/* eslint-disable */

export const AllTypesProps: Record<string,any> = {
	Query:{
		getAddress:{
			by:"AddressUniqueWhere",
			filter:"AddressWhere"
		},
		listAddress:{
			filter:"AddressWhere",
			orderBy:"AddressOrderBy"
		},
		paginateAddress:{
			filter:"AddressWhere",
			orderBy:"AddressOrderBy"
		},
		validateCreateAddress:{
			data:"AddressCreateInput"
		},
		validateUpdateAddress:{
			by:"AddressUniqueWhere",
			data:"AddressUpdateInput"
		},
		getCountry:{
			by:"CountryUniqueWhere",
			filter:"CountryWhere"
		},
		listCountry:{
			filter:"CountryWhere",
			orderBy:"CountryOrderBy"
		},
		paginateCountry:{
			filter:"CountryWhere",
			orderBy:"CountryOrderBy"
		},
		validateCreateCountry:{
			data:"CountryCreateInput"
		},
		validateUpdateCountry:{
			by:"CountryUniqueWhere",
			data:"CountryUpdateInput"
		},
		getChannel:{
			by:"ChannelUniqueWhere",
			filter:"ChannelWhere"
		},
		listChannel:{
			filter:"ChannelWhere",
			orderBy:"ChannelOrderBy"
		},
		paginateChannel:{
			filter:"ChannelWhere",
			orderBy:"ChannelOrderBy"
		},
		validateCreateChannel:{
			data:"ChannelCreateInput"
		},
		validateUpdateChannel:{
			by:"ChannelUniqueWhere",
			data:"ChannelUpdateInput"
		},
		getChannelPayment:{
			by:"ChannelPaymentUniqueWhere",
			filter:"ChannelPaymentWhere"
		},
		listChannelPayment:{
			filter:"ChannelPaymentWhere",
			orderBy:"ChannelPaymentOrderBy"
		},
		paginateChannelPayment:{
			filter:"ChannelPaymentWhere",
			orderBy:"ChannelPaymentOrderBy"
		},
		validateCreateChannelPayment:{
			data:"ChannelPaymentCreateInput"
		},
		validateUpdateChannelPayment:{
			by:"ChannelPaymentUniqueWhere",
			data:"ChannelPaymentUpdateInput"
		},
		getChannelDelivery:{
			by:"ChannelDeliveryUniqueWhere",
			filter:"ChannelDeliveryWhere"
		},
		listChannelDelivery:{
			filter:"ChannelDeliveryWhere",
			orderBy:"ChannelDeliveryOrderBy"
		},
		paginateChannelDelivery:{
			filter:"ChannelDeliveryWhere",
			orderBy:"ChannelDeliveryOrderBy"
		},
		validateCreateChannelDelivery:{
			data:"ChannelDeliveryCreateInput"
		},
		validateUpdateChannelDelivery:{
			by:"ChannelDeliveryUniqueWhere",
			data:"ChannelDeliveryUpdateInput"
		},
		getCustomer:{
			by:"CustomerUniqueWhere",
			filter:"CustomerWhere"
		},
		listCustomer:{
			filter:"CustomerWhere",
			orderBy:"CustomerOrderBy"
		},
		paginateCustomer:{
			filter:"CustomerWhere",
			orderBy:"CustomerOrderBy"
		},
		validateCreateCustomer:{
			data:"CustomerCreateInput"
		},
		validateUpdateCustomer:{
			by:"CustomerUniqueWhere",
			data:"CustomerUpdateInput"
		},
		getCustomerCredit:{
			by:"CustomerCreditUniqueWhere",
			filter:"CustomerCreditWhere"
		},
		listCustomerCredit:{
			filter:"CustomerCreditWhere",
			orderBy:"CustomerCreditOrderBy"
		},
		paginateCustomerCredit:{
			filter:"CustomerCreditWhere",
			orderBy:"CustomerCreditOrderBy"
		},
		validateCreateCustomerCredit:{
			data:"CustomerCreditCreateInput"
		},
		validateUpdateCustomerCredit:{
			by:"CustomerCreditUniqueWhere",
			data:"CustomerCreditUpdateInput"
		},
		getCustomerGroup:{
			by:"CustomerGroupUniqueWhere",
			filter:"CustomerGroupWhere"
		},
		listCustomerGroup:{
			filter:"CustomerGroupWhere",
			orderBy:"CustomerGroupOrderBy"
		},
		paginateCustomerGroup:{
			filter:"CustomerGroupWhere",
			orderBy:"CustomerGroupOrderBy"
		},
		validateCreateCustomerGroup:{
			data:"CustomerGroupCreateInput"
		},
		validateUpdateCustomerGroup:{
			by:"CustomerGroupUniqueWhere",
			data:"CustomerGroupUpdateInput"
		},
		getCustomerPaymentMethod:{
			by:"CustomerPaymentMethodUniqueWhere",
			filter:"CustomerPaymentMethodWhere"
		},
		listCustomerPaymentMethod:{
			filter:"CustomerPaymentMethodWhere",
			orderBy:"CustomerPaymentMethodOrderBy"
		},
		paginateCustomerPaymentMethod:{
			filter:"CustomerPaymentMethodWhere",
			orderBy:"CustomerPaymentMethodOrderBy"
		},
		validateCreateCustomerPaymentMethod:{
			data:"CustomerPaymentMethodCreateInput"
		},
		validateUpdateCustomerPaymentMethod:{
			by:"CustomerPaymentMethodUniqueWhere",
			data:"CustomerPaymentMethodUpdateInput"
		},
		getDeliveryMethod:{
			by:"DeliveryMethodUniqueWhere",
			filter:"DeliveryMethodWhere"
		},
		listDeliveryMethod:{
			filter:"DeliveryMethodWhere",
			orderBy:"DeliveryMethodOrderBy"
		},
		paginateDeliveryMethod:{
			filter:"DeliveryMethodWhere",
			orderBy:"DeliveryMethodOrderBy"
		},
		validateCreateDeliveryMethod:{
			data:"DeliveryMethodCreateInput"
		},
		validateUpdateDeliveryMethod:{
			by:"DeliveryMethodUniqueWhere",
			data:"DeliveryMethodUpdateInput"
		},
		getOrder:{
			by:"OrderUniqueWhere",
			filter:"OrderWhere"
		},
		listOrder:{
			filter:"OrderWhere",
			orderBy:"OrderOrderBy"
		},
		paginateOrder:{
			filter:"OrderWhere",
			orderBy:"OrderOrderBy"
		},
		validateCreateOrder:{
			data:"OrderCreateInput"
		},
		validateUpdateOrder:{
			by:"OrderUniqueWhere",
			data:"OrderUpdateInput"
		},
		getOrderDiscount:{
			by:"OrderDiscountUniqueWhere",
			filter:"OrderDiscountWhere"
		},
		listOrderDiscount:{
			filter:"OrderDiscountWhere",
			orderBy:"OrderDiscountOrderBy"
		},
		paginateOrderDiscount:{
			filter:"OrderDiscountWhere",
			orderBy:"OrderDiscountOrderBy"
		},
		validateCreateOrderDiscount:{
			data:"OrderDiscountCreateInput"
		},
		validateUpdateOrderDiscount:{
			by:"OrderDiscountUniqueWhere",
			data:"OrderDiscountUpdateInput"
		},
		getOrderPayment:{
			by:"OrderPaymentUniqueWhere",
			filter:"OrderPaymentWhere"
		},
		listOrderPayment:{
			filter:"OrderPaymentWhere",
			orderBy:"OrderPaymentOrderBy"
		},
		paginateOrderPayment:{
			filter:"OrderPaymentWhere",
			orderBy:"OrderPaymentOrderBy"
		},
		validateCreateOrderPayment:{
			data:"OrderPaymentCreateInput"
		},
		validateUpdateOrderPayment:{
			by:"OrderPaymentUniqueWhere",
			data:"OrderPaymentUpdateInput"
		},
		getOrderDelivery:{
			by:"OrderDeliveryUniqueWhere",
			filter:"OrderDeliveryWhere"
		},
		listOrderDelivery:{
			filter:"OrderDeliveryWhere",
			orderBy:"OrderDeliveryOrderBy"
		},
		paginateOrderDelivery:{
			filter:"OrderDeliveryWhere",
			orderBy:"OrderDeliveryOrderBy"
		},
		validateCreateOrderDelivery:{
			data:"OrderDeliveryCreateInput"
		},
		validateUpdateOrderDelivery:{
			by:"OrderDeliveryUniqueWhere",
			data:"OrderDeliveryUpdateInput"
		},
		getOrderItem:{
			by:"OrderItemUniqueWhere",
			filter:"OrderItemWhere"
		},
		listOrderItem:{
			filter:"OrderItemWhere",
			orderBy:"OrderItemOrderBy"
		},
		paginateOrderItem:{
			filter:"OrderItemWhere",
			orderBy:"OrderItemOrderBy"
		},
		validateCreateOrderItem:{
			data:"OrderItemCreateInput"
		},
		validateUpdateOrderItem:{
			by:"OrderItemUniqueWhere",
			data:"OrderItemUpdateInput"
		},
		getPaymentMethod:{
			by:"PaymentMethodUniqueWhere",
			filter:"PaymentMethodWhere"
		},
		listPaymentMethod:{
			filter:"PaymentMethodWhere",
			orderBy:"PaymentMethodOrderBy"
		},
		paginatePaymentMethod:{
			filter:"PaymentMethodWhere",
			orderBy:"PaymentMethodOrderBy"
		},
		validateCreatePaymentMethod:{
			data:"PaymentMethodCreateInput"
		},
		validateUpdatePaymentMethod:{
			by:"PaymentMethodUniqueWhere",
			data:"PaymentMethodUpdateInput"
		},
		getVatRate:{
			by:"VatRateUniqueWhere",
			filter:"VatRateWhere"
		},
		listVatRate:{
			filter:"VatRateWhere",
			orderBy:"VatRateOrderBy"
		},
		paginateVatRate:{
			filter:"VatRateWhere",
			orderBy:"VatRateOrderBy"
		},
		validateCreateVatRate:{
			data:"VatRateCreateInput"
		},
		validateUpdateVatRate:{
			by:"VatRateUniqueWhere",
			data:"VatRateUpdateInput"
		},
		getProduct:{
			by:"ProductUniqueWhere",
			filter:"ProductWhere"
		},
		listProduct:{
			filter:"ProductWhere",
			orderBy:"ProductOrderBy"
		},
		paginateProduct:{
			filter:"ProductWhere",
			orderBy:"ProductOrderBy"
		},
		validateCreateProduct:{
			data:"ProductCreateInput"
		},
		validateUpdateProduct:{
			by:"ProductUniqueWhere",
			data:"ProductUpdateInput"
		},
		getProductStock:{
			by:"ProductStockUniqueWhere",
			filter:"ProductStockWhere"
		},
		listProductStock:{
			filter:"ProductStockWhere",
			orderBy:"ProductStockOrderBy"
		},
		paginateProductStock:{
			filter:"ProductStockWhere",
			orderBy:"ProductStockOrderBy"
		},
		validateCreateProductStock:{
			data:"ProductStockCreateInput"
		},
		validateUpdateProductStock:{
			by:"ProductStockUniqueWhere",
			data:"ProductStockUpdateInput"
		},
		getProductPacking:{
			by:"ProductPackingUniqueWhere",
			filter:"ProductPackingWhere"
		},
		listProductPacking:{
			filter:"ProductPackingWhere",
			orderBy:"ProductPackingOrderBy"
		},
		paginateProductPacking:{
			filter:"ProductPackingWhere",
			orderBy:"ProductPackingOrderBy"
		},
		validateCreateProductPacking:{
			data:"ProductPackingCreateInput"
		},
		validateUpdateProductPacking:{
			by:"ProductPackingUniqueWhere",
			data:"ProductPackingUpdateInput"
		},
		getProductGroupPrice:{
			by:"ProductGroupPriceUniqueWhere",
			filter:"ProductGroupPriceWhere"
		},
		listProductGroupPrice:{
			filter:"ProductGroupPriceWhere",
			orderBy:"ProductGroupPriceOrderBy"
		},
		paginateProductGroupPrice:{
			filter:"ProductGroupPriceWhere",
			orderBy:"ProductGroupPriceOrderBy"
		},
		validateCreateProductGroupPrice:{
			data:"ProductGroupPriceCreateInput"
		},
		validateUpdateProductGroupPrice:{
			by:"ProductGroupPriceUniqueWhere",
			data:"ProductGroupPriceUpdateInput"
		},
		getProductRecipe:{
			by:"ProductRecipeUniqueWhere",
			filter:"ProductRecipeWhere"
		},
		listProductRecipe:{
			filter:"ProductRecipeWhere",
			orderBy:"ProductRecipeOrderBy"
		},
		paginateProductRecipe:{
			filter:"ProductRecipeWhere",
			orderBy:"ProductRecipeOrderBy"
		},
		validateCreateProductRecipe:{
			data:"ProductRecipeCreateInput"
		},
		validateUpdateProductRecipe:{
			by:"ProductRecipeUniqueWhere",
			data:"ProductRecipeUpdateInput"
		},
		getProductCategory:{
			by:"ProductCategoryUniqueWhere",
			filter:"ProductCategoryWhere"
		},
		listProductCategory:{
			filter:"ProductCategoryWhere",
			orderBy:"ProductCategoryOrderBy"
		},
		paginateProductCategory:{
			filter:"ProductCategoryWhere",
			orderBy:"ProductCategoryOrderBy"
		},
		validateCreateProductCategory:{
			data:"ProductCategoryCreateInput"
		},
		validateUpdateProductCategory:{
			by:"ProductCategoryUniqueWhere",
			data:"ProductCategoryUpdateInput"
		},
		getStore:{
			by:"StoreUniqueWhere",
			filter:"StoreWhere"
		},
		listStore:{
			filter:"StoreWhere",
			orderBy:"StoreOrderBy"
		},
		paginateStore:{
			filter:"StoreWhere",
			orderBy:"StoreOrderBy"
		},
		validateCreateStore:{
			data:"StoreCreateInput"
		},
		validateUpdateStore:{
			by:"StoreUniqueWhere",
			data:"StoreUpdateInput"
		},
		getTag:{
			by:"TagUniqueWhere",
			filter:"TagWhere"
		},
		listTag:{
			filter:"TagWhere",
			orderBy:"TagOrderBy"
		},
		paginateTag:{
			filter:"TagWhere",
			orderBy:"TagOrderBy"
		},
		validateCreateTag:{
			data:"TagCreateInput"
		},
		validateUpdateTag:{
			by:"TagUniqueWhere",
			data:"TagUpdateInput"
		},
		getCustomerPermissions:{
			by:"CustomerPermissionsUniqueWhere",
			filter:"CustomerPermissionsWhere"
		},
		listCustomerPermissions:{
			filter:"CustomerPermissionsWhere",
			orderBy:"CustomerPermissionsOrderBy"
		},
		paginateCustomerPermissions:{
			filter:"CustomerPermissionsWhere",
			orderBy:"CustomerPermissionsOrderBy"
		},
		getImage:{
			by:"ImageUniqueWhere",
			filter:"ImageWhere"
		},
		listImage:{
			filter:"ImageWhere",
			orderBy:"ImageOrderBy"
		},
		paginateImage:{
			filter:"ImageWhere",
			orderBy:"ImageOrderBy"
		},
		validateCreateImage:{
			data:"ImageCreateInput"
		},
		validateUpdateImage:{
			by:"ImageUniqueWhere",
			data:"ImageUpdateInput"
		},
		getBusinessCategory:{
			by:"BusinessCategoryUniqueWhere",
			filter:"BusinessCategoryWhere"
		},
		listBusinessCategory:{
			filter:"BusinessCategoryWhere",
			orderBy:"BusinessCategoryOrderBy"
		},
		paginateBusinessCategory:{
			filter:"BusinessCategoryWhere",
			orderBy:"BusinessCategoryOrderBy"
		},
		validateCreateBusinessCategory:{
			data:"BusinessCategoryCreateInput"
		},
		validateUpdateBusinessCategory:{
			by:"BusinessCategoryUniqueWhere",
			data:"BusinessCategoryUpdateInput"
		},
		getProductList:{
			by:"ProductListUniqueWhere",
			filter:"ProductListWhere"
		},
		listProductList:{
			filter:"ProductListWhere",
			orderBy:"ProductListOrderBy"
		},
		paginateProductList:{
			filter:"ProductListWhere",
			orderBy:"ProductListOrderBy"
		},
		validateCreateProductList:{
			data:"ProductListCreateInput"
		},
		validateUpdateProductList:{
			by:"ProductListUniqueWhere",
			data:"ProductListUpdateInput"
		},
		getProductListItem:{
			by:"ProductListItemUniqueWhere",
			filter:"ProductListItemWhere"
		},
		listProductListItem:{
			filter:"ProductListItemWhere",
			orderBy:"ProductListItemOrderBy"
		},
		paginateProductListItem:{
			filter:"ProductListItemWhere",
			orderBy:"ProductListItemOrderBy"
		},
		validateCreateProductListItem:{
			data:"ProductListItemCreateInput"
		},
		validateUpdateProductListItem:{
			by:"ProductListItemUniqueWhere",
			data:"ProductListItemUpdateInput"
		},
		getProductCategoryList:{
			by:"ProductCategoryListUniqueWhere",
			filter:"ProductCategoryListWhere"
		},
		listProductCategoryList:{
			filter:"ProductCategoryListWhere",
			orderBy:"ProductCategoryListOrderBy"
		},
		paginateProductCategoryList:{
			filter:"ProductCategoryListWhere",
			orderBy:"ProductCategoryListOrderBy"
		},
		validateCreateProductCategoryList:{
			data:"ProductCategoryListCreateInput"
		},
		validateUpdateProductCategoryList:{
			by:"ProductCategoryListUniqueWhere",
			data:"ProductCategoryListUpdateInput"
		},
		getProductCategoryListItem:{
			by:"ProductCategoryListItemUniqueWhere",
			filter:"ProductCategoryListItemWhere"
		},
		listProductCategoryListItem:{
			filter:"ProductCategoryListItemWhere",
			orderBy:"ProductCategoryListItemOrderBy"
		},
		paginateProductCategoryListItem:{
			filter:"ProductCategoryListItemWhere",
			orderBy:"ProductCategoryListItemOrderBy"
		},
		validateCreateProductCategoryListItem:{
			data:"ProductCategoryListItemCreateInput"
		},
		validateUpdateProductCategoryListItem:{
			by:"ProductCategoryListItemUniqueWhere",
			data:"ProductCategoryListItemUpdateInput"
		},
		getBusinessCategoryLocale:{
			by:"BusinessCategoryLocaleUniqueWhere",
			filter:"BusinessCategoryLocaleWhere"
		},
		listBusinessCategoryLocale:{
			filter:"BusinessCategoryLocaleWhere",
			orderBy:"BusinessCategoryLocaleOrderBy"
		},
		paginateBusinessCategoryLocale:{
			filter:"BusinessCategoryLocaleWhere",
			orderBy:"BusinessCategoryLocaleOrderBy"
		},
		validateCreateBusinessCategoryLocale:{
			data:"BusinessCategoryLocaleCreateInput"
		},
		validateUpdateBusinessCategoryLocale:{
			by:"BusinessCategoryLocaleUniqueWhere",
			data:"BusinessCategoryLocaleUpdateInput"
		},
		getLocale:{
			by:"LocaleUniqueWhere",
			filter:"LocaleWhere"
		},
		listLocale:{
			filter:"LocaleWhere",
			orderBy:"LocaleOrderBy"
		},
		paginateLocale:{
			filter:"LocaleWhere",
			orderBy:"LocaleOrderBy"
		},
		validateCreateLocale:{
			data:"LocaleCreateInput"
		},
		validateUpdateLocale:{
			by:"LocaleUniqueWhere",
			data:"LocaleUpdateInput"
		},
		getProductCategoryListLocale:{
			by:"ProductCategoryListLocaleUniqueWhere",
			filter:"ProductCategoryListLocaleWhere"
		},
		listProductCategoryListLocale:{
			filter:"ProductCategoryListLocaleWhere",
			orderBy:"ProductCategoryListLocaleOrderBy"
		},
		paginateProductCategoryListLocale:{
			filter:"ProductCategoryListLocaleWhere",
			orderBy:"ProductCategoryListLocaleOrderBy"
		},
		validateCreateProductCategoryListLocale:{
			data:"ProductCategoryListLocaleCreateInput"
		},
		validateUpdateProductCategoryListLocale:{
			by:"ProductCategoryListLocaleUniqueWhere",
			data:"ProductCategoryListLocaleUpdateInput"
		},
		getCustomerName:{
			by:"CustomerNameUniqueWhere",
			filter:"CustomerNameWhere"
		},
		listCustomerName:{
			filter:"CustomerNameWhere",
			orderBy:"CustomerNameOrderBy"
		},
		paginateCustomerName:{
			filter:"CustomerNameWhere",
			orderBy:"CustomerNameOrderBy"
		},
		validateCreateCustomerName:{
			data:"CustomerNameCreateInput"
		},
		validateUpdateCustomerName:{
			by:"CustomerNameUniqueWhere",
			data:"CustomerNameUpdateInput"
		},
		getCustomerAlias:{
			by:"CustomerAliasUniqueWhere",
			filter:"CustomerAliasWhere"
		},
		listCustomerAlias:{
			filter:"CustomerAliasWhere",
			orderBy:"CustomerAliasOrderBy"
		},
		paginateCustomerAlias:{
			filter:"CustomerAliasWhere",
			orderBy:"CustomerAliasOrderBy"
		},
		validateCreateCustomerAlias:{
			data:"CustomerAliasCreateInput"
		},
		validateUpdateCustomerAlias:{
			by:"CustomerAliasUniqueWhere",
			data:"CustomerAliasUpdateInput"
		},
		getProductIngredientItem:{
			by:"ProductIngredientItemUniqueWhere",
			filter:"ProductIngredientItemWhere"
		},
		listProductIngredientItem:{
			filter:"ProductIngredientItemWhere",
			orderBy:"ProductIngredientItemOrderBy"
		},
		paginateProductIngredientItem:{
			filter:"ProductIngredientItemWhere",
			orderBy:"ProductIngredientItemOrderBy"
		},
		validateCreateProductIngredientItem:{
			data:"ProductIngredientItemCreateInput"
		},
		validateUpdateProductIngredientItem:{
			by:"ProductIngredientItemUniqueWhere",
			data:"ProductIngredientItemUpdateInput"
		},
		getProductIngredientItemQuantity:{
			by:"ProductIngredientItemQuantityUniqueWhere",
			filter:"ProductIngredientItemQuantityWhere"
		},
		listProductIngredientItemQuantity:{
			filter:"ProductIngredientItemQuantityWhere",
			orderBy:"ProductIngredientItemQuantityOrderBy"
		},
		paginateProductIngredientItemQuantity:{
			filter:"ProductIngredientItemQuantityWhere",
			orderBy:"ProductIngredientItemQuantityOrderBy"
		},
		validateCreateProductIngredientItemQuantity:{
			data:"ProductIngredientItemQuantityCreateInput"
		},
		validateUpdateProductIngredientItemQuantity:{
			by:"ProductIngredientItemQuantityUniqueWhere",
			data:"ProductIngredientItemQuantityUpdateInput"
		},
		getProductIngredientItemQuantityUnit:{
			by:"ProductIngredientItemQuantityUnitUniqueWhere",
			filter:"ProductIngredientItemQuantityUnitWhere"
		},
		listProductIngredientItemQuantityUnit:{
			filter:"ProductIngredientItemQuantityUnitWhere",
			orderBy:"ProductIngredientItemQuantityUnitOrderBy"
		},
		paginateProductIngredientItemQuantityUnit:{
			filter:"ProductIngredientItemQuantityUnitWhere",
			orderBy:"ProductIngredientItemQuantityUnitOrderBy"
		},
		validateCreateProductIngredientItemQuantityUnit:{
			data:"ProductIngredientItemQuantityUnitCreateInput"
		},
		validateUpdateProductIngredientItemQuantityUnit:{
			by:"ProductIngredientItemQuantityUnitUniqueWhere",
			data:"ProductIngredientItemQuantityUnitUpdateInput"
		},
		getProductIngredient:{
			by:"ProductIngredientUniqueWhere",
			filter:"ProductIngredientWhere"
		},
		listProductIngredient:{
			filter:"ProductIngredientWhere",
			orderBy:"ProductIngredientOrderBy"
		},
		paginateProductIngredient:{
			filter:"ProductIngredientWhere",
			orderBy:"ProductIngredientOrderBy"
		},
		validateCreateProductIngredient:{
			data:"ProductIngredientCreateInput"
		},
		validateUpdateProductIngredient:{
			by:"ProductIngredientUniqueWhere",
			data:"ProductIngredientUpdateInput"
		},
		getCustomerIngredientRating:{
			by:"CustomerIngredientRatingUniqueWhere",
			filter:"CustomerIngredientRatingWhere"
		},
		listCustomerIngredientRating:{
			filter:"CustomerIngredientRatingWhere",
			orderBy:"CustomerIngredientRatingOrderBy"
		},
		paginateCustomerIngredientRating:{
			filter:"CustomerIngredientRatingWhere",
			orderBy:"CustomerIngredientRatingOrderBy"
		},
		validateCreateCustomerIngredientRating:{
			data:"CustomerIngredientRatingCreateInput"
		},
		validateUpdateCustomerIngredientRating:{
			by:"CustomerIngredientRatingUniqueWhere",
			data:"CustomerIngredientRatingUpdateInput"
		},
		getProductIngredientRating:{
			by:"ProductIngredientRatingUniqueWhere",
			filter:"ProductIngredientRatingWhere"
		},
		listProductIngredientRating:{
			filter:"ProductIngredientRatingWhere",
			orderBy:"ProductIngredientRatingOrderBy"
		},
		paginateProductIngredientRating:{
			filter:"ProductIngredientRatingWhere",
			orderBy:"ProductIngredientRatingOrderBy"
		},
		validateCreateProductIngredientRating:{
			data:"ProductIngredientRatingCreateInput"
		},
		validateUpdateProductIngredientRating:{
			by:"ProductIngredientRatingUniqueWhere",
			data:"ProductIngredientRatingUpdateInput"
		},
		getProductIngredientLocale:{
			by:"ProductIngredientLocaleUniqueWhere",
			filter:"ProductIngredientLocaleWhere"
		},
		listProductIngredientLocale:{
			filter:"ProductIngredientLocaleWhere",
			orderBy:"ProductIngredientLocaleOrderBy"
		},
		paginateProductIngredientLocale:{
			filter:"ProductIngredientLocaleWhere",
			orderBy:"ProductIngredientLocaleOrderBy"
		},
		validateCreateProductIngredientLocale:{
			data:"ProductIngredientLocaleCreateInput"
		},
		validateUpdateProductIngredientLocale:{
			by:"ProductIngredientLocaleUniqueWhere",
			data:"ProductIngredientLocaleUpdateInput"
		},
		getOrderRecurrence:{
			by:"OrderRecurrenceUniqueWhere",
			filter:"OrderRecurrenceWhere"
		},
		listOrderRecurrence:{
			filter:"OrderRecurrenceWhere",
			orderBy:"OrderRecurrenceOrderBy"
		},
		paginateOrderRecurrence:{
			filter:"OrderRecurrenceWhere",
			orderBy:"OrderRecurrenceOrderBy"
		},
		validateCreateOrderRecurrence:{
			data:"OrderRecurrenceCreateInput"
		},
		validateUpdateOrderRecurrence:{
			by:"OrderRecurrenceUniqueWhere",
			data:"OrderRecurrenceUpdateInput"
		},
		getOrderRecurrenceLocale:{
			by:"OrderRecurrenceLocaleUniqueWhere",
			filter:"OrderRecurrenceLocaleWhere"
		},
		listOrderRecurrenceLocale:{
			filter:"OrderRecurrenceLocaleWhere",
			orderBy:"OrderRecurrenceLocaleOrderBy"
		},
		paginateOrderRecurrenceLocale:{
			filter:"OrderRecurrenceLocaleWhere",
			orderBy:"OrderRecurrenceLocaleOrderBy"
		},
		validateCreateOrderRecurrenceLocale:{
			data:"OrderRecurrenceLocaleCreateInput"
		},
		validateUpdateOrderRecurrenceLocale:{
			by:"OrderRecurrenceLocaleUniqueWhere",
			data:"OrderRecurrenceLocaleUpdateInput"
		},
		getBusinessCustomer:{
			by:"BusinessCustomerUniqueWhere",
			filter:"BusinessCustomerWhere"
		},
		listBusinessCustomer:{
			filter:"BusinessCustomerWhere",
			orderBy:"BusinessCustomerOrderBy"
		},
		paginateBusinessCustomer:{
			filter:"BusinessCustomerWhere",
			orderBy:"BusinessCustomerOrderBy"
		},
		validateCreateBusinessCustomer:{
			data:"BusinessCustomerCreateInput"
		},
		validateUpdateBusinessCustomer:{
			by:"BusinessCustomerUniqueWhere",
			data:"BusinessCustomerUpdateInput"
		},
		getPointOfSale:{
			by:"PointOfSaleUniqueWhere",
			filter:"PointOfSaleWhere"
		},
		listPointOfSale:{
			filter:"PointOfSaleWhere",
			orderBy:"PointOfSaleOrderBy"
		},
		paginatePointOfSale:{
			filter:"PointOfSaleWhere",
			orderBy:"PointOfSaleOrderBy"
		},
		validateCreatePointOfSale:{
			data:"PointOfSaleCreateInput"
		},
		validateUpdatePointOfSale:{
			by:"PointOfSaleUniqueWhere",
			data:"PointOfSaleUpdateInput"
		},
		getStaff:{
			by:"StaffUniqueWhere",
			filter:"StaffWhere"
		},
		listStaff:{
			filter:"StaffWhere",
			orderBy:"StaffOrderBy"
		},
		paginateStaff:{
			filter:"StaffWhere",
			orderBy:"StaffOrderBy"
		},
		validateCreateStaff:{
			data:"StaffCreateInput"
		},
		validateUpdateStaff:{
			by:"StaffUniqueWhere",
			data:"StaffUpdateInput"
		},
		getPointOfSalePermissions:{
			by:"PointOfSalePermissionsUniqueWhere",
			filter:"PointOfSalePermissionsWhere"
		},
		listPointOfSalePermissions:{
			filter:"PointOfSalePermissionsWhere",
			orderBy:"PointOfSalePermissionsOrderBy"
		},
		paginatePointOfSalePermissions:{
			filter:"PointOfSalePermissionsWhere",
			orderBy:"PointOfSalePermissionsOrderBy"
		},
		getBlog:{
			by:"BlogUniqueWhere",
			filter:"BlogWhere"
		},
		listBlog:{
			filter:"BlogWhere",
			orderBy:"BlogOrderBy"
		},
		paginateBlog:{
			filter:"BlogWhere",
			orderBy:"BlogOrderBy"
		},
		validateCreateBlog:{
			data:"BlogCreateInput"
		},
		validateUpdateBlog:{
			by:"BlogUniqueWhere",
			data:"BlogUpdateInput"
		},
		getBlogLocale:{
			by:"BlogLocaleUniqueWhere",
			filter:"BlogLocaleWhere"
		},
		listBlogLocale:{
			filter:"BlogLocaleWhere",
			orderBy:"BlogLocaleOrderBy"
		},
		paginateBlogLocale:{
			filter:"BlogLocaleWhere",
			orderBy:"BlogLocaleOrderBy"
		},
		validateCreateBlogLocale:{
			data:"BlogLocaleCreateInput"
		},
		validateUpdateBlogLocale:{
			by:"BlogLocaleUniqueWhere",
			data:"BlogLocaleUpdateInput"
		},
		getBlogPost:{
			by:"BlogPostUniqueWhere",
			filter:"BlogPostWhere"
		},
		listBlogPost:{
			filter:"BlogPostWhere",
			orderBy:"BlogPostOrderBy"
		},
		paginateBlogPost:{
			filter:"BlogPostWhere",
			orderBy:"BlogPostOrderBy"
		},
		validateCreateBlogPost:{
			data:"BlogPostCreateInput"
		},
		validateUpdateBlogPost:{
			by:"BlogPostUniqueWhere",
			data:"BlogPostUpdateInput"
		},
		getBlogPostLocale:{
			by:"BlogPostLocaleUniqueWhere",
			filter:"BlogPostLocaleWhere"
		},
		listBlogPostLocale:{
			filter:"BlogPostLocaleWhere",
			orderBy:"BlogPostLocaleOrderBy"
		},
		paginateBlogPostLocale:{
			filter:"BlogPostLocaleWhere",
			orderBy:"BlogPostLocaleOrderBy"
		},
		validateCreateBlogPostLocale:{
			data:"BlogPostLocaleCreateInput"
		},
		validateUpdateBlogPostLocale:{
			by:"BlogPostLocaleUniqueWhere",
			data:"BlogPostLocaleUpdateInput"
		},
		getColorPallete:{
			by:"ColorPalleteUniqueWhere",
			filter:"ColorPalleteWhere"
		},
		listColorPallete:{
			filter:"ColorPalleteWhere",
			orderBy:"ColorPalleteOrderBy"
		},
		paginateColorPallete:{
			filter:"ColorPalleteWhere",
			orderBy:"ColorPalleteOrderBy"
		},
		validateCreateColorPallete:{
			data:"ColorPalleteCreateInput"
		},
		validateUpdateColorPallete:{
			by:"ColorPalleteUniqueWhere",
			data:"ColorPalleteUpdateInput"
		},
		getContent:{
			by:"ContentUniqueWhere",
			filter:"ContentWhere"
		},
		listContent:{
			filter:"ContentWhere",
			orderBy:"ContentOrderBy"
		},
		paginateContent:{
			filter:"ContentWhere",
			orderBy:"ContentOrderBy"
		},
		validateCreateContent:{
			data:"ContentCreateInput"
		},
		validateUpdateContent:{
			by:"ContentUniqueWhere",
			data:"ContentUpdateInput"
		},
		getContentBlock:{
			by:"ContentBlockUniqueWhere",
			filter:"ContentBlockWhere"
		},
		listContentBlock:{
			filter:"ContentBlockWhere",
			orderBy:"ContentBlockOrderBy"
		},
		paginateContentBlock:{
			filter:"ContentBlockWhere",
			orderBy:"ContentBlockOrderBy"
		},
		validateCreateContentBlock:{
			data:"ContentBlockCreateInput"
		},
		validateUpdateContentBlock:{
			by:"ContentBlockUniqueWhere",
			data:"ContentBlockUpdateInput"
		},
		getContentReference:{
			by:"ContentReferenceUniqueWhere",
			filter:"ContentReferenceWhere"
		},
		listContentReference:{
			filter:"ContentReferenceWhere",
			orderBy:"ContentReferenceOrderBy"
		},
		paginateContentReference:{
			filter:"ContentReferenceWhere",
			orderBy:"ContentReferenceOrderBy"
		},
		validateCreateContentReference:{
			data:"ContentReferenceCreateInput"
		},
		validateUpdateContentReference:{
			by:"ContentReferenceUniqueWhere",
			data:"ContentReferenceUpdateInput"
		},
		getBlogPostList:{
			by:"BlogPostListUniqueWhere",
			filter:"BlogPostListWhere"
		},
		listBlogPostList:{
			filter:"BlogPostListWhere",
			orderBy:"BlogPostListOrderBy"
		},
		paginateBlogPostList:{
			filter:"BlogPostListWhere",
			orderBy:"BlogPostListOrderBy"
		},
		validateCreateBlogPostList:{
			data:"BlogPostListCreateInput"
		},
		validateUpdateBlogPostList:{
			by:"BlogPostListUniqueWhere",
			data:"BlogPostListUpdateInput"
		},
		getBlogPostListItem:{
			by:"BlogPostListItemUniqueWhere",
			filter:"BlogPostListItemWhere"
		},
		listBlogPostListItem:{
			filter:"BlogPostListItemWhere",
			orderBy:"BlogPostListItemOrderBy"
		},
		paginateBlogPostListItem:{
			filter:"BlogPostListItemWhere",
			orderBy:"BlogPostListItemOrderBy"
		},
		validateCreateBlogPostListItem:{
			data:"BlogPostListItemCreateInput"
		},
		validateUpdateBlogPostListItem:{
			by:"BlogPostListItemUniqueWhere",
			data:"BlogPostListItemUpdateInput"
		},
		getLinkList:{
			by:"LinkListUniqueWhere",
			filter:"LinkListWhere"
		},
		listLinkList:{
			filter:"LinkListWhere",
			orderBy:"LinkListOrderBy"
		},
		paginateLinkList:{
			filter:"LinkListWhere",
			orderBy:"LinkListOrderBy"
		},
		validateCreateLinkList:{
			data:"LinkListCreateInput"
		},
		validateUpdateLinkList:{
			by:"LinkListUniqueWhere",
			data:"LinkListUpdateInput"
		},
		getLinkListItem:{
			by:"LinkListItemUniqueWhere",
			filter:"LinkListItemWhere"
		},
		listLinkListItem:{
			filter:"LinkListItemWhere",
			orderBy:"LinkListItemOrderBy"
		},
		paginateLinkListItem:{
			filter:"LinkListItemWhere",
			orderBy:"LinkListItemOrderBy"
		},
		validateCreateLinkListItem:{
			data:"LinkListItemCreateInput"
		},
		validateUpdateLinkListItem:{
			by:"LinkListItemUniqueWhere",
			data:"LinkListItemUpdateInput"
		},
		getCover:{
			by:"CoverUniqueWhere",
			filter:"CoverWhere"
		},
		listCover:{
			filter:"CoverWhere",
			orderBy:"CoverOrderBy"
		},
		paginateCover:{
			filter:"CoverWhere",
			orderBy:"CoverOrderBy"
		},
		validateCreateCover:{
			data:"CoverCreateInput"
		},
		validateUpdateCover:{
			by:"CoverUniqueWhere",
			data:"CoverUpdateInput"
		},
		getLink:{
			by:"LinkUniqueWhere",
			filter:"LinkWhere"
		},
		listLink:{
			filter:"LinkWhere",
			orderBy:"LinkOrderBy"
		},
		paginateLink:{
			filter:"LinkWhere",
			orderBy:"LinkOrderBy"
		},
		validateCreateLink:{
			data:"LinkCreateInput"
		},
		validateUpdateLink:{
			by:"LinkUniqueWhere",
			data:"LinkUpdateInput"
		},
		getLinkable:{
			by:"LinkableUniqueWhere",
			filter:"LinkableWhere"
		},
		listLinkable:{
			filter:"LinkableWhere",
			orderBy:"LinkableOrderBy"
		},
		paginateLinkable:{
			filter:"LinkableWhere",
			orderBy:"LinkableOrderBy"
		},
		validateCreateLinkable:{
			data:"LinkableCreateInput"
		},
		validateUpdateLinkable:{
			by:"LinkableUniqueWhere",
			data:"LinkableUpdateInput"
		},
		getMedium:{
			by:"MediumUniqueWhere",
			filter:"MediumWhere"
		},
		listMedium:{
			filter:"MediumWhere",
			orderBy:"MediumOrderBy"
		},
		paginateMedium:{
			filter:"MediumWhere",
			orderBy:"MediumOrderBy"
		},
		validateCreateMedium:{
			data:"MediumCreateInput"
		},
		validateUpdateMedium:{
			by:"MediumUniqueWhere",
			data:"MediumUpdateInput"
		},
		getVideo:{
			by:"VideoUniqueWhere",
			filter:"VideoWhere"
		},
		listVideo:{
			filter:"VideoWhere",
			orderBy:"VideoOrderBy"
		},
		paginateVideo:{
			filter:"VideoWhere",
			orderBy:"VideoOrderBy"
		},
		validateCreateVideo:{
			data:"VideoCreateInput"
		},
		validateUpdateVideo:{
			by:"VideoUniqueWhere",
			data:"VideoUpdateInput"
		},
		getSeo:{
			by:"SeoUniqueWhere",
			filter:"SeoWhere"
		},
		listSeo:{
			filter:"SeoWhere",
			orderBy:"SeoOrderBy"
		},
		paginateSeo:{
			filter:"SeoWhere",
			orderBy:"SeoOrderBy"
		},
		validateCreateSeo:{
			data:"SeoCreateInput"
		},
		validateUpdateSeo:{
			by:"SeoUniqueWhere",
			data:"SeoUpdateInput"
		},
		getProtectedImage:{
			by:"ProtectedImageUniqueWhere",
			filter:"ProtectedImageWhere"
		},
		listProtectedImage:{
			filter:"ProtectedImageWhere",
			orderBy:"ProtectedImageOrderBy"
		},
		paginateProtectedImage:{
			filter:"ProtectedImageWhere",
			orderBy:"ProtectedImageOrderBy"
		},
		validateCreateProtectedImage:{
			data:"ProtectedImageCreateInput"
		},
		validateUpdateProtectedImage:{
			by:"ProtectedImageUniqueWhere",
			data:"ProtectedImageUpdateInput"
		},
		getTranslationDomain:{
			by:"TranslationDomainUniqueWhere",
			filter:"TranslationDomainWhere"
		},
		listTranslationDomain:{
			filter:"TranslationDomainWhere",
			orderBy:"TranslationDomainOrderBy"
		},
		paginateTranslationDomain:{
			filter:"TranslationDomainWhere",
			orderBy:"TranslationDomainOrderBy"
		},
		validateCreateTranslationDomain:{
			data:"TranslationDomainCreateInput"
		},
		validateUpdateTranslationDomain:{
			by:"TranslationDomainUniqueWhere",
			data:"TranslationDomainUpdateInput"
		},
		getTranslationCatalogue:{
			by:"TranslationCatalogueUniqueWhere",
			filter:"TranslationCatalogueWhere"
		},
		listTranslationCatalogue:{
			filter:"TranslationCatalogueWhere",
			orderBy:"TranslationCatalogueOrderBy"
		},
		paginateTranslationCatalogue:{
			filter:"TranslationCatalogueWhere",
			orderBy:"TranslationCatalogueOrderBy"
		},
		validateCreateTranslationCatalogue:{
			data:"TranslationCatalogueCreateInput"
		},
		validateUpdateTranslationCatalogue:{
			by:"TranslationCatalogueUniqueWhere",
			data:"TranslationCatalogueUpdateInput"
		},
		getTranslationKey:{
			by:"TranslationKeyUniqueWhere",
			filter:"TranslationKeyWhere"
		},
		listTranslationKey:{
			filter:"TranslationKeyWhere",
			orderBy:"TranslationKeyOrderBy"
		},
		paginateTranslationKey:{
			filter:"TranslationKeyWhere",
			orderBy:"TranslationKeyOrderBy"
		},
		validateCreateTranslationKey:{
			data:"TranslationKeyCreateInput"
		},
		validateUpdateTranslationKey:{
			by:"TranslationKeyUniqueWhere",
			data:"TranslationKeyUpdateInput"
		},
		getTranslationValue:{
			by:"TranslationValueUniqueWhere",
			filter:"TranslationValueWhere"
		},
		listTranslationValue:{
			filter:"TranslationValueWhere",
			orderBy:"TranslationValueOrderBy"
		},
		paginateTranslationValue:{
			filter:"TranslationValueWhere",
			orderBy:"TranslationValueOrderBy"
		},
		validateCreateTranslationValue:{
			data:"TranslationValueCreateInput"
		},
		validateUpdateTranslationValue:{
			by:"TranslationValueUniqueWhere",
			data:"TranslationValueUpdateInput"
		},
		getTranslationCataloguesIdentifier:{
			by:"TranslationCataloguesIdentifierUniqueWhere",
			filter:"TranslationCataloguesIdentifierWhere"
		},
		listTranslationCataloguesIdentifier:{
			filter:"TranslationCataloguesIdentifierWhere",
			orderBy:"TranslationCataloguesIdentifierOrderBy"
		},
		paginateTranslationCataloguesIdentifier:{
			filter:"TranslationCataloguesIdentifierWhere",
			orderBy:"TranslationCataloguesIdentifierOrderBy"
		},
		validateCreateTranslationCataloguesIdentifier:{
			data:"TranslationCataloguesIdentifierCreateInput"
		},
		validateUpdateTranslationCataloguesIdentifier:{
			by:"TranslationCataloguesIdentifierUniqueWhere",
			data:"TranslationCataloguesIdentifierUpdateInput"
		},
		getSocialsAndApps:{
			by:"SocialsAndAppsUniqueWhere",
			filter:"SocialsAndAppsWhere"
		},
		listSocialsAndApps:{
			filter:"SocialsAndAppsWhere",
			orderBy:"SocialsAndAppsOrderBy"
		},
		paginateSocialsAndApps:{
			filter:"SocialsAndAppsWhere",
			orderBy:"SocialsAndAppsOrderBy"
		},
		validateCreateSocialsAndApps:{
			data:"SocialsAndAppsCreateInput"
		},
		validateUpdateSocialsAndApps:{
			by:"SocialsAndAppsUniqueWhere",
			data:"SocialsAndAppsUpdateInput"
		},
		getProductGrid:{
			by:"ProductGridUniqueWhere",
			filter:"ProductGridWhere"
		},
		listProductGrid:{
			filter:"ProductGridWhere",
			orderBy:"ProductGridOrderBy"
		},
		paginateProductGrid:{
			filter:"ProductGridWhere",
			orderBy:"ProductGridOrderBy"
		},
		validateCreateProductGrid:{
			data:"ProductGridCreateInput"
		},
		validateUpdateProductGrid:{
			by:"ProductGridUniqueWhere",
			data:"ProductGridUpdateInput"
		},
		getProductGridItem:{
			by:"ProductGridItemUniqueWhere",
			filter:"ProductGridItemWhere"
		},
		listProductGridItem:{
			filter:"ProductGridItemWhere",
			orderBy:"ProductGridItemOrderBy"
		},
		paginateProductGridItem:{
			filter:"ProductGridItemWhere",
			orderBy:"ProductGridItemOrderBy"
		},
		validateCreateProductGridItem:{
			data:"ProductGridItemCreateInput"
		},
		validateUpdateProductGridItem:{
			by:"ProductGridItemUniqueWhere",
			data:"ProductGridItemUpdateInput"
		},
		getGallery:{
			by:"GalleryUniqueWhere",
			filter:"GalleryWhere"
		},
		listGallery:{
			filter:"GalleryWhere",
			orderBy:"GalleryOrderBy"
		},
		paginateGallery:{
			filter:"GalleryWhere",
			orderBy:"GalleryOrderBy"
		},
		validateCreateGallery:{
			data:"GalleryCreateInput"
		},
		validateUpdateGallery:{
			by:"GalleryUniqueWhere",
			data:"GalleryUpdateInput"
		},
		getGalleryItem:{
			by:"GalleryItemUniqueWhere",
			filter:"GalleryItemWhere"
		},
		listGalleryItem:{
			filter:"GalleryItemWhere",
			orderBy:"GalleryItemOrderBy"
		},
		paginateGalleryItem:{
			filter:"GalleryItemWhere",
			orderBy:"GalleryItemOrderBy"
		},
		validateCreateGalleryItem:{
			data:"GalleryItemCreateInput"
		},
		validateUpdateGalleryItem:{
			by:"GalleryItemUniqueWhere",
			data:"GalleryItemUpdateInput"
		},
		getHero:{
			by:"HeroUniqueWhere",
			filter:"HeroWhere"
		},
		listHero:{
			filter:"HeroWhere",
			orderBy:"HeroOrderBy"
		},
		paginateHero:{
			filter:"HeroWhere",
			orderBy:"HeroOrderBy"
		},
		validateCreateHero:{
			data:"HeroCreateInput"
		},
		validateUpdateHero:{
			by:"HeroUniqueWhere",
			data:"HeroUpdateInput"
		},
		getSiteMenu:{
			by:"SiteMenuUniqueWhere",
			filter:"SiteMenuWhere"
		},
		listSiteMenu:{
			filter:"SiteMenuWhere",
			orderBy:"SiteMenuOrderBy"
		},
		paginateSiteMenu:{
			filter:"SiteMenuWhere",
			orderBy:"SiteMenuOrderBy"
		},
		validateCreateSiteMenu:{
			data:"SiteMenuCreateInput"
		},
		validateUpdateSiteMenu:{
			by:"SiteMenuUniqueWhere",
			data:"SiteMenuUpdateInput"
		},
		getMenuLocale:{
			by:"MenuLocaleUniqueWhere",
			filter:"MenuLocaleWhere"
		},
		listMenuLocale:{
			filter:"MenuLocaleWhere",
			orderBy:"MenuLocaleOrderBy"
		},
		paginateMenuLocale:{
			filter:"MenuLocaleWhere",
			orderBy:"MenuLocaleOrderBy"
		},
		validateCreateMenuLocale:{
			data:"MenuLocaleCreateInput"
		},
		validateUpdateMenuLocale:{
			by:"MenuLocaleUniqueWhere",
			data:"MenuLocaleUpdateInput"
		},
		getMenuItem:{
			by:"MenuItemUniqueWhere",
			filter:"MenuItemWhere"
		},
		listMenuItem:{
			filter:"MenuItemWhere",
			orderBy:"MenuItemOrderBy"
		},
		paginateMenuItem:{
			filter:"MenuItemWhere",
			orderBy:"MenuItemOrderBy"
		},
		validateCreateMenuItem:{
			data:"MenuItemCreateInput"
		},
		validateUpdateMenuItem:{
			by:"MenuItemUniqueWhere",
			data:"MenuItemUpdateInput"
		},
		getPage:{
			by:"PageUniqueWhere",
			filter:"PageWhere"
		},
		listPage:{
			filter:"PageWhere",
			orderBy:"PageOrderBy"
		},
		paginatePage:{
			filter:"PageWhere",
			orderBy:"PageOrderBy"
		},
		validateCreatePage:{
			data:"PageCreateInput"
		},
		validateUpdatePage:{
			by:"PageUniqueWhere",
			data:"PageUpdateInput"
		},
		getPageLocale:{
			by:"PageLocaleUniqueWhere",
			filter:"PageLocaleWhere"
		},
		listPageLocale:{
			filter:"PageLocaleWhere",
			orderBy:"PageLocaleOrderBy"
		},
		paginatePageLocale:{
			filter:"PageLocaleWhere",
			orderBy:"PageLocaleOrderBy"
		},
		validateCreatePageLocale:{
			data:"PageLocaleCreateInput"
		},
		validateUpdatePageLocale:{
			by:"PageLocaleUniqueWhere",
			data:"PageLocaleUpdateInput"
		},
		getWikiPage:{
			by:"WikiPageUniqueWhere",
			filter:"WikiPageWhere"
		},
		listWikiPage:{
			filter:"WikiPageWhere",
			orderBy:"WikiPageOrderBy"
		},
		paginateWikiPage:{
			filter:"WikiPageWhere",
			orderBy:"WikiPageOrderBy"
		},
		validateCreateWikiPage:{
			data:"WikiPageCreateInput"
		},
		validateUpdateWikiPage:{
			by:"WikiPageUniqueWhere",
			data:"WikiPageUpdateInput"
		},
		getMenuSubitem:{
			by:"MenuSubitemUniqueWhere",
			filter:"MenuSubitemWhere"
		},
		listMenuSubitem:{
			filter:"MenuSubitemWhere",
			orderBy:"MenuSubitemOrderBy"
		},
		paginateMenuSubitem:{
			filter:"MenuSubitemWhere",
			orderBy:"MenuSubitemOrderBy"
		},
		validateCreateMenuSubitem:{
			data:"MenuSubitemCreateInput"
		},
		validateUpdateMenuSubitem:{
			by:"MenuSubitemUniqueWhere",
			data:"MenuSubitemUpdateInput"
		},
		getMenuLinkList:{
			by:"MenuLinkListUniqueWhere",
			filter:"MenuLinkListWhere"
		},
		listMenuLinkList:{
			filter:"MenuLinkListWhere",
			orderBy:"MenuLinkListOrderBy"
		},
		paginateMenuLinkList:{
			filter:"MenuLinkListWhere",
			orderBy:"MenuLinkListOrderBy"
		},
		validateCreateMenuLinkList:{
			data:"MenuLinkListCreateInput"
		},
		validateUpdateMenuLinkList:{
			by:"MenuLinkListUniqueWhere",
			data:"MenuLinkListUpdateInput"
		},
		getMenuLinkItem:{
			by:"MenuLinkItemUniqueWhere",
			filter:"MenuLinkItemWhere"
		},
		listMenuLinkItem:{
			filter:"MenuLinkItemWhere",
			orderBy:"MenuLinkItemOrderBy"
		},
		paginateMenuLinkItem:{
			filter:"MenuLinkItemWhere",
			orderBy:"MenuLinkItemOrderBy"
		},
		validateCreateMenuLinkItem:{
			data:"MenuLinkItemCreateInput"
		},
		validateUpdateMenuLinkItem:{
			by:"MenuLinkItemUniqueWhere",
			data:"MenuLinkItemUpdateInput"
		},
		getMenuProducts:{
			by:"MenuProductsUniqueWhere",
			filter:"MenuProductsWhere"
		},
		listMenuProducts:{
			filter:"MenuProductsWhere",
			orderBy:"MenuProductsOrderBy"
		},
		paginateMenuProducts:{
			filter:"MenuProductsWhere",
			orderBy:"MenuProductsOrderBy"
		},
		validateCreateMenuProducts:{
			data:"MenuProductsCreateInput"
		},
		validateUpdateMenuProducts:{
			by:"MenuProductsUniqueWhere",
			data:"MenuProductsUpdateInput"
		},
		getMenuDelivery:{
			by:"MenuDeliveryUniqueWhere",
			filter:"MenuDeliveryWhere"
		},
		listMenuDelivery:{
			filter:"MenuDeliveryWhere",
			orderBy:"MenuDeliveryOrderBy"
		},
		paginateMenuDelivery:{
			filter:"MenuDeliveryWhere",
			orderBy:"MenuDeliveryOrderBy"
		},
		validateCreateMenuDelivery:{
			data:"MenuDeliveryCreateInput"
		},
		validateUpdateMenuDelivery:{
			by:"MenuDeliveryUniqueWhere",
			data:"MenuDeliveryUpdateInput"
		},
		getMenuContact:{
			by:"MenuContactUniqueWhere",
			filter:"MenuContactWhere"
		},
		listMenuContact:{
			filter:"MenuContactWhere",
			orderBy:"MenuContactOrderBy"
		},
		paginateMenuContact:{
			filter:"MenuContactWhere",
			orderBy:"MenuContactOrderBy"
		},
		validateCreateMenuContact:{
			data:"MenuContactCreateInput"
		},
		validateUpdateMenuContact:{
			by:"MenuContactUniqueWhere",
			data:"MenuContactUpdateInput"
		},
		getDeadlineTemplate:{
			by:"DeadlineTemplateUniqueWhere",
			filter:"DeadlineTemplateWhere"
		},
		listDeadlineTemplate:{
			filter:"DeadlineTemplateWhere",
			orderBy:"DeadlineTemplateOrderBy"
		},
		paginateDeadlineTemplate:{
			filter:"DeadlineTemplateWhere",
			orderBy:"DeadlineTemplateOrderBy"
		},
		validateCreateDeadlineTemplate:{
			data:"DeadlineTemplateCreateInput"
		},
		validateUpdateDeadlineTemplate:{
			by:"DeadlineTemplateUniqueWhere",
			data:"DeadlineTemplateUpdateInput"
		},
		getEmployeeQueue:{
			by:"EmployeeQueueUniqueWhere",
			filter:"EmployeeQueueWhere"
		},
		listEmployeeQueue:{
			filter:"EmployeeQueueWhere",
			orderBy:"EmployeeQueueOrderBy"
		},
		paginateEmployeeQueue:{
			filter:"EmployeeQueueWhere",
			orderBy:"EmployeeQueueOrderBy"
		},
		validateCreateEmployeeQueue:{
			data:"EmployeeQueueCreateInput"
		},
		validateUpdateEmployeeQueue:{
			by:"EmployeeQueueUniqueWhere",
			data:"EmployeeQueueUpdateInput"
		},
		getTimetableDay:{
			by:"TimetableDayUniqueWhere",
			filter:"TimetableDayWhere"
		},
		listTimetableDay:{
			filter:"TimetableDayWhere",
			orderBy:"TimetableDayOrderBy"
		},
		paginateTimetableDay:{
			filter:"TimetableDayWhere",
			orderBy:"TimetableDayOrderBy"
		},
		validateCreateTimetableDay:{
			data:"TimetableDayCreateInput"
		},
		validateUpdateTimetableDay:{
			by:"TimetableDayUniqueWhere",
			data:"TimetableDayUpdateInput"
		},
		getTimetableEmployeeRole:{
			by:"TimetableEmployeeRoleUniqueWhere",
			filter:"TimetableEmployeeRoleWhere"
		},
		listTimetableEmployeeRole:{
			filter:"TimetableEmployeeRoleWhere",
			orderBy:"TimetableEmployeeRoleOrderBy"
		},
		paginateTimetableEmployeeRole:{
			filter:"TimetableEmployeeRoleWhere",
			orderBy:"TimetableEmployeeRoleOrderBy"
		},
		validateCreateTimetableEmployeeRole:{
			data:"TimetableEmployeeRoleCreateInput"
		},
		validateUpdateTimetableEmployeeRole:{
			by:"TimetableEmployeeRoleUniqueWhere",
			data:"TimetableEmployeeRoleUpdateInput"
		},
		getTimetableShift:{
			by:"TimetableShiftUniqueWhere",
			filter:"TimetableShiftWhere"
		},
		listTimetableShift:{
			filter:"TimetableShiftWhere",
			orderBy:"TimetableShiftOrderBy"
		},
		paginateTimetableShift:{
			filter:"TimetableShiftWhere",
			orderBy:"TimetableShiftOrderBy"
		},
		validateCreateTimetableShift:{
			data:"TimetableShiftCreateInput"
		},
		validateUpdateTimetableShift:{
			by:"TimetableShiftUniqueWhere",
			data:"TimetableShiftUpdateInput"
		},
		getTimetableShiftGroup:{
			by:"TimetableShiftGroupUniqueWhere",
			filter:"TimetableShiftGroupWhere"
		},
		listTimetableShiftGroup:{
			filter:"TimetableShiftGroupWhere",
			orderBy:"TimetableShiftGroupOrderBy"
		},
		paginateTimetableShiftGroup:{
			filter:"TimetableShiftGroupWhere",
			orderBy:"TimetableShiftGroupOrderBy"
		},
		validateCreateTimetableShiftGroup:{
			data:"TimetableShiftGroupCreateInput"
		},
		validateUpdateTimetableShiftGroup:{
			by:"TimetableShiftGroupUniqueWhere",
			data:"TimetableShiftGroupUpdateInput"
		},
		getTimetableShiftPosition:{
			by:"TimetableShiftPositionUniqueWhere",
			filter:"TimetableShiftPositionWhere"
		},
		listTimetableShiftPosition:{
			filter:"TimetableShiftPositionWhere",
			orderBy:"TimetableShiftPositionOrderBy"
		},
		paginateTimetableShiftPosition:{
			filter:"TimetableShiftPositionWhere",
			orderBy:"TimetableShiftPositionOrderBy"
		},
		validateCreateTimetableShiftPosition:{
			data:"TimetableShiftPositionCreateInput"
		},
		validateUpdateTimetableShiftPosition:{
			by:"TimetableShiftPositionUniqueWhere",
			data:"TimetableShiftPositionUpdateInput"
		},
		getTimetableTemplate:{
			by:"TimetableTemplateUniqueWhere",
			filter:"TimetableTemplateWhere"
		},
		listTimetableTemplate:{
			filter:"TimetableTemplateWhere",
			orderBy:"TimetableTemplateOrderBy"
		},
		paginateTimetableTemplate:{
			filter:"TimetableTemplateWhere",
			orderBy:"TimetableTemplateOrderBy"
		},
		validateCreateTimetableTemplate:{
			data:"TimetableTemplateCreateInput"
		},
		validateUpdateTimetableTemplate:{
			by:"TimetableTemplateUniqueWhere",
			data:"TimetableTemplateUpdateInput"
		},
		getCart:{
			by:"CartUniqueWhere",
			filter:"CartWhere"
		},
		listCart:{
			filter:"CartWhere",
			orderBy:"CartOrderBy"
		},
		paginateCart:{
			filter:"CartWhere",
			orderBy:"CartOrderBy"
		},
		validateCreateCart:{
			data:"CartCreateInput"
		},
		validateUpdateCart:{
			by:"CartUniqueWhere",
			data:"CartUpdateInput"
		},
		getCartItem:{
			by:"CartItemUniqueWhere",
			filter:"CartItemWhere"
		},
		listCartItem:{
			filter:"CartItemWhere",
			orderBy:"CartItemOrderBy"
		},
		paginateCartItem:{
			filter:"CartItemWhere",
			orderBy:"CartItemOrderBy"
		},
		validateCreateCartItem:{
			data:"CartItemCreateInput"
		},
		validateUpdateCartItem:{
			by:"CartItemUniqueWhere",
			data:"CartItemUpdateInput"
		},
		getEmployeeQueueItem:{
			by:"EmployeeQueueItemUniqueWhere",
			filter:"EmployeeQueueItemWhere"
		},
		listEmployeeQueueItem:{
			filter:"EmployeeQueueItemWhere",
			orderBy:"EmployeeQueueItemOrderBy"
		},
		paginateEmployeeQueueItem:{
			filter:"EmployeeQueueItemWhere",
			orderBy:"EmployeeQueueItemOrderBy"
		},
		validateCreateEmployeeQueueItem:{
			data:"EmployeeQueueItemCreateInput"
		},
		validateUpdateEmployeeQueueItem:{
			by:"EmployeeQueueItemUniqueWhere",
			data:"EmployeeQueueItemUpdateInput"
		},
		getApplication:{
			by:"ApplicationUniqueWhere",
			filter:"ApplicationWhere"
		},
		listApplication:{
			filter:"ApplicationWhere",
			orderBy:"ApplicationOrderBy"
		},
		paginateApplication:{
			filter:"ApplicationWhere",
			orderBy:"ApplicationOrderBy"
		},
		validateCreateApplication:{
			data:"ApplicationCreateInput"
		},
		validateUpdateApplication:{
			by:"ApplicationUniqueWhere",
			data:"ApplicationUpdateInput"
		},
		getApplicationShortcutList:{
			by:"ApplicationShortcutListUniqueWhere",
			filter:"ApplicationShortcutListWhere"
		},
		listApplicationShortcutList:{
			filter:"ApplicationShortcutListWhere",
			orderBy:"ApplicationShortcutListOrderBy"
		},
		paginateApplicationShortcutList:{
			filter:"ApplicationShortcutListWhere",
			orderBy:"ApplicationShortcutListOrderBy"
		},
		validateCreateApplicationShortcutList:{
			data:"ApplicationShortcutListCreateInput"
		},
		validateUpdateApplicationShortcutList:{
			by:"ApplicationShortcutListUniqueWhere",
			data:"ApplicationShortcutListUpdateInput"
		},
		getApplicationShortcutListItem:{
			by:"ApplicationShortcutListItemUniqueWhere",
			filter:"ApplicationShortcutListItemWhere"
		},
		listApplicationShortcutListItem:{
			filter:"ApplicationShortcutListItemWhere",
			orderBy:"ApplicationShortcutListItemOrderBy"
		},
		paginateApplicationShortcutListItem:{
			filter:"ApplicationShortcutListItemWhere",
			orderBy:"ApplicationShortcutListItemOrderBy"
		},
		validateCreateApplicationShortcutListItem:{
			data:"ApplicationShortcutListItemCreateInput"
		},
		validateUpdateApplicationShortcutListItem:{
			by:"ApplicationShortcutListItemUniqueWhere",
			data:"ApplicationShortcutListItemUpdateInput"
		},
		getProductBanner:{
			by:"ProductBannerUniqueWhere",
			filter:"ProductBannerWhere"
		},
		listProductBanner:{
			filter:"ProductBannerWhere",
			orderBy:"ProductBannerOrderBy"
		},
		paginateProductBanner:{
			filter:"ProductBannerWhere",
			orderBy:"ProductBannerOrderBy"
		},
		validateCreateProductBanner:{
			data:"ProductBannerCreateInput"
		},
		validateUpdateProductBanner:{
			by:"ProductBannerUniqueWhere",
			data:"ProductBannerUpdateInput"
		},
		getProductBannerItem:{
			by:"ProductBannerItemUniqueWhere",
			filter:"ProductBannerItemWhere"
		},
		listProductBannerItem:{
			filter:"ProductBannerItemWhere",
			orderBy:"ProductBannerItemOrderBy"
		},
		paginateProductBannerItem:{
			filter:"ProductBannerItemWhere",
			orderBy:"ProductBannerItemOrderBy"
		},
		validateCreateProductBannerItem:{
			data:"ProductBannerItemCreateInput"
		},
		validateUpdateProductBannerItem:{
			by:"ProductBannerItemUniqueWhere",
			data:"ProductBannerItemUpdateInput"
		},
		getProductBannerList:{
			by:"ProductBannerListUniqueWhere",
			filter:"ProductBannerListWhere"
		},
		listProductBannerList:{
			filter:"ProductBannerListWhere",
			orderBy:"ProductBannerListOrderBy"
		},
		paginateProductBannerList:{
			filter:"ProductBannerListWhere",
			orderBy:"ProductBannerListOrderBy"
		},
		validateCreateProductBannerList:{
			data:"ProductBannerListCreateInput"
		},
		validateUpdateProductBannerList:{
			by:"ProductBannerListUniqueWhere",
			data:"ProductBannerListUpdateInput"
		},
		getBartender:{
			by:"BartenderUniqueWhere",
			filter:"BartenderWhere"
		},
		listBartender:{
			filter:"BartenderWhere",
			orderBy:"BartenderOrderBy"
		},
		paginateBartender:{
			filter:"BartenderWhere",
			orderBy:"BartenderOrderBy"
		},
		validateCreateBartender:{
			data:"BartenderCreateInput"
		},
		validateUpdateBartender:{
			by:"BartenderUniqueWhere",
			data:"BartenderUpdateInput"
		},
		getBusinessToBusinessManager:{
			by:"BusinessToBusinessManagerUniqueWhere",
			filter:"BusinessToBusinessManagerWhere"
		},
		listBusinessToBusinessManager:{
			filter:"BusinessToBusinessManagerWhere",
			orderBy:"BusinessToBusinessManagerOrderBy"
		},
		paginateBusinessToBusinessManager:{
			filter:"BusinessToBusinessManagerWhere",
			orderBy:"BusinessToBusinessManagerOrderBy"
		},
		validateCreateBusinessToBusinessManager:{
			data:"BusinessToBusinessManagerCreateInput"
		},
		validateUpdateBusinessToBusinessManager:{
			by:"BusinessToBusinessManagerUniqueWhere",
			data:"BusinessToBusinessManagerUpdateInput"
		},
		getCleaner:{
			by:"CleanerUniqueWhere",
			filter:"CleanerWhere"
		},
		listCleaner:{
			filter:"CleanerWhere",
			orderBy:"CleanerOrderBy"
		},
		paginateCleaner:{
			filter:"CleanerWhere",
			orderBy:"CleanerOrderBy"
		},
		validateCreateCleaner:{
			data:"CleanerCreateInput"
		},
		validateUpdateCleaner:{
			by:"CleanerUniqueWhere",
			data:"CleanerUpdateInput"
		},
		getCourier:{
			by:"CourierUniqueWhere",
			filter:"CourierWhere"
		},
		listCourier:{
			filter:"CourierWhere",
			orderBy:"CourierOrderBy"
		},
		paginateCourier:{
			filter:"CourierWhere",
			orderBy:"CourierOrderBy"
		},
		validateCreateCourier:{
			data:"CourierCreateInput"
		},
		validateUpdateCourier:{
			by:"CourierUniqueWhere",
			data:"CourierUpdateInput"
		},
		getShiftsManager:{
			by:"ShiftsManagerUniqueWhere",
			filter:"ShiftsManagerWhere"
		},
		listShiftsManager:{
			filter:"ShiftsManagerWhere",
			orderBy:"ShiftsManagerOrderBy"
		},
		paginateShiftsManager:{
			filter:"ShiftsManagerWhere",
			orderBy:"ShiftsManagerOrderBy"
		},
		validateCreateShiftsManager:{
			data:"ShiftsManagerCreateInput"
		},
		validateUpdateShiftsManager:{
			by:"ShiftsManagerUniqueWhere",
			data:"ShiftsManagerUpdateInput"
		},
		getUser:{
			by:"UserUniqueWhere",
			filter:"UserWhere"
		},
		listUser:{
			filter:"UserWhere",
			orderBy:"UserOrderBy"
		},
		paginateUser:{
			filter:"UserWhere",
			orderBy:"UserOrderBy"
		},
		validateCreateUser:{
			data:"UserCreateInput"
		},
		validateUpdateUser:{
			by:"UserUniqueWhere",
			data:"UserUpdateInput"
		},
		getShiftsProfile:{
			by:"ShiftsProfileUniqueWhere",
			filter:"ShiftsProfileWhere"
		},
		listShiftsProfile:{
			filter:"ShiftsProfileWhere",
			orderBy:"ShiftsProfileOrderBy"
		},
		paginateShiftsProfile:{
			filter:"ShiftsProfileWhere",
			orderBy:"ShiftsProfileOrderBy"
		},
		validateCreateShiftsProfile:{
			data:"ShiftsProfileCreateInput"
		},
		validateUpdateShiftsProfile:{
			by:"ShiftsProfileUniqueWhere",
			data:"ShiftsProfileUpdateInput"
		},
		getProductIngredientCategory:{
			by:"ProductIngredientCategoryUniqueWhere",
			filter:"ProductIngredientCategoryWhere"
		},
		listProductIngredientCategory:{
			filter:"ProductIngredientCategoryWhere",
			orderBy:"ProductIngredientCategoryOrderBy"
		},
		paginateProductIngredientCategory:{
			filter:"ProductIngredientCategoryWhere",
			orderBy:"ProductIngredientCategoryOrderBy"
		},
		validateCreateProductIngredientCategory:{
			data:"ProductIngredientCategoryCreateInput"
		},
		validateUpdateProductIngredientCategory:{
			by:"ProductIngredientCategoryUniqueWhere",
			data:"ProductIngredientCategoryUpdateInput"
		},
		getProductIngredientCategoryLocale:{
			by:"ProductIngredientCategoryLocaleUniqueWhere",
			filter:"ProductIngredientCategoryLocaleWhere"
		},
		listProductIngredientCategoryLocale:{
			filter:"ProductIngredientCategoryLocaleWhere",
			orderBy:"ProductIngredientCategoryLocaleOrderBy"
		},
		paginateProductIngredientCategoryLocale:{
			filter:"ProductIngredientCategoryLocaleWhere",
			orderBy:"ProductIngredientCategoryLocaleOrderBy"
		},
		validateCreateProductIngredientCategoryLocale:{
			data:"ProductIngredientCategoryLocaleCreateInput"
		},
		validateUpdateProductIngredientCategoryLocale:{
			by:"ProductIngredientCategoryLocaleUniqueWhere",
			data:"ProductIngredientCategoryLocaleUpdateInput"
		},
		getStocksManager:{
			by:"StocksManagerUniqueWhere",
			filter:"StocksManagerWhere"
		},
		listStocksManager:{
			filter:"StocksManagerWhere",
			orderBy:"StocksManagerOrderBy"
		},
		paginateStocksManager:{
			filter:"StocksManagerWhere",
			orderBy:"StocksManagerOrderBy"
		},
		validateCreateStocksManager:{
			data:"StocksManagerCreateInput"
		},
		validateUpdateStocksManager:{
			by:"StocksManagerUniqueWhere",
			data:"StocksManagerUpdateInput"
		},
		getDeliveryRoute:{
			by:"DeliveryRouteUniqueWhere",
			filter:"DeliveryRouteWhere"
		},
		listDeliveryRoute:{
			filter:"DeliveryRouteWhere",
			orderBy:"DeliveryRouteOrderBy"
		},
		paginateDeliveryRoute:{
			filter:"DeliveryRouteWhere",
			orderBy:"DeliveryRouteOrderBy"
		},
		validateCreateDeliveryRoute:{
			data:"DeliveryRouteCreateInput"
		},
		validateUpdateDeliveryRoute:{
			by:"DeliveryRouteUniqueWhere",
			data:"DeliveryRouteUpdateInput"
		},
		getDeliveryWaypoint:{
			by:"DeliveryWaypointUniqueWhere",
			filter:"DeliveryWaypointWhere"
		},
		listDeliveryWaypoint:{
			filter:"DeliveryWaypointWhere",
			orderBy:"DeliveryWaypointOrderBy"
		},
		paginateDeliveryWaypoint:{
			filter:"DeliveryWaypointWhere",
			orderBy:"DeliveryWaypointOrderBy"
		},
		validateCreateDeliveryWaypoint:{
			data:"DeliveryWaypointCreateInput"
		},
		validateUpdateDeliveryWaypoint:{
			by:"DeliveryWaypointUniqueWhere",
			data:"DeliveryWaypointUpdateInput"
		},
		getAllergen:{
			by:"AllergenUniqueWhere",
			filter:"AllergenWhere"
		},
		listAllergen:{
			filter:"AllergenWhere",
			orderBy:"AllergenOrderBy"
		},
		paginateAllergen:{
			filter:"AllergenWhere",
			orderBy:"AllergenOrderBy"
		},
		validateCreateAllergen:{
			data:"AllergenCreateInput"
		},
		validateUpdateAllergen:{
			by:"AllergenUniqueWhere",
			data:"AllergenUpdateInput"
		},
		getAllergenLocale:{
			by:"AllergenLocaleUniqueWhere",
			filter:"AllergenLocaleWhere"
		},
		listAllergenLocale:{
			filter:"AllergenLocaleWhere",
			orderBy:"AllergenLocaleOrderBy"
		},
		paginateAllergenLocale:{
			filter:"AllergenLocaleWhere",
			orderBy:"AllergenLocaleOrderBy"
		},
		validateCreateAllergenLocale:{
			data:"AllergenLocaleCreateInput"
		},
		validateUpdateAllergenLocale:{
			by:"AllergenLocaleUniqueWhere",
			data:"AllergenLocaleUpdateInput"
		},
		getGps:{
			by:"GpsUniqueWhere",
			filter:"GpsWhere"
		},
		listGps:{
			filter:"GpsWhere",
			orderBy:"GpsOrderBy"
		},
		paginateGps:{
			filter:"GpsWhere",
			orderBy:"GpsOrderBy"
		},
		validateCreateGps:{
			data:"GpsCreateInput"
		},
		validateUpdateGps:{
			by:"GpsUniqueWhere",
			data:"GpsUpdateInput"
		},
		getProductCategoryTree:{
			by:"ProductCategoryTreeUniqueWhere",
			filter:"ProductCategoryTreeWhere"
		},
		listProductCategoryTree:{
			filter:"ProductCategoryTreeWhere",
			orderBy:"ProductCategoryTreeOrderBy"
		},
		paginateProductCategoryTree:{
			filter:"ProductCategoryTreeWhere",
			orderBy:"ProductCategoryTreeOrderBy"
		},
		getInheritedProductCategoryTag:{
			by:"InheritedProductCategoryTagUniqueWhere",
			filter:"InheritedProductCategoryTagWhere"
		},
		listInheritedProductCategoryTag:{
			filter:"InheritedProductCategoryTagWhere",
			orderBy:"InheritedProductCategoryTagOrderBy"
		},
		paginateInheritedProductCategoryTag:{
			filter:"InheritedProductCategoryTagWhere",
			orderBy:"InheritedProductCategoryTagOrderBy"
		},
		getNestedProductCategoryProduct:{
			by:"NestedProductCategoryProductUniqueWhere",
			filter:"NestedProductCategoryProductWhere"
		},
		listNestedProductCategoryProduct:{
			filter:"NestedProductCategoryProductWhere",
			orderBy:"NestedProductCategoryProductOrderBy"
		},
		paginateNestedProductCategoryProduct:{
			filter:"NestedProductCategoryProductWhere",
			orderBy:"NestedProductCategoryProductOrderBy"
		},
		getWeekHours:{
			by:"WeekHoursUniqueWhere",
			filter:"WeekHoursWhere"
		},
		listWeekHours:{
			filter:"WeekHoursWhere",
			orderBy:"WeekHoursOrderBy"
		},
		paginateWeekHours:{
			filter:"WeekHoursWhere",
			orderBy:"WeekHoursOrderBy"
		},
		validateCreateWeekHours:{
			data:"WeekHoursCreateInput"
		},
		validateUpdateWeekHours:{
			by:"WeekHoursUniqueWhere",
			data:"WeekHoursUpdateInput"
		},
		getPreparedIngredientQuantity:{
			by:"PreparedIngredientQuantityUniqueWhere",
			filter:"PreparedIngredientQuantityWhere"
		},
		listPreparedIngredientQuantity:{
			filter:"PreparedIngredientQuantityWhere",
			orderBy:"PreparedIngredientQuantityOrderBy"
		},
		paginatePreparedIngredientQuantity:{
			filter:"PreparedIngredientQuantityWhere",
			orderBy:"PreparedIngredientQuantityOrderBy"
		},
		validateCreatePreparedIngredientQuantity:{
			data:"PreparedIngredientQuantityCreateInput"
		},
		validateUpdatePreparedIngredientQuantity:{
			by:"PreparedIngredientQuantityUniqueWhere",
			data:"PreparedIngredientQuantityUpdateInput"
		},
		getPreparedRecipeQuantity:{
			by:"PreparedRecipeQuantityUniqueWhere",
			filter:"PreparedRecipeQuantityWhere"
		},
		listPreparedRecipeQuantity:{
			filter:"PreparedRecipeQuantityWhere",
			orderBy:"PreparedRecipeQuantityOrderBy"
		},
		paginatePreparedRecipeQuantity:{
			filter:"PreparedRecipeQuantityWhere",
			orderBy:"PreparedRecipeQuantityOrderBy"
		},
		validateCreatePreparedRecipeQuantity:{
			data:"PreparedRecipeQuantityCreateInput"
		},
		validateUpdatePreparedRecipeQuantity:{
			by:"PreparedRecipeQuantityUniqueWhere",
			data:"PreparedRecipeQuantityUpdateInput"
		},
		getInternalOrder:{
			by:"InternalOrderUniqueWhere",
			filter:"InternalOrderWhere"
		},
		listInternalOrder:{
			filter:"InternalOrderWhere",
			orderBy:"InternalOrderOrderBy"
		},
		paginateInternalOrder:{
			filter:"InternalOrderWhere",
			orderBy:"InternalOrderOrderBy"
		},
		validateCreateInternalOrder:{
			data:"InternalOrderCreateInput"
		},
		validateUpdateInternalOrder:{
			by:"InternalOrderUniqueWhere",
			data:"InternalOrderUpdateInput"
		},
		getInternalOrderItem:{
			by:"InternalOrderItemUniqueWhere",
			filter:"InternalOrderItemWhere"
		},
		listInternalOrderItem:{
			filter:"InternalOrderItemWhere",
			orderBy:"InternalOrderItemOrderBy"
		},
		paginateInternalOrderItem:{
			filter:"InternalOrderItemWhere",
			orderBy:"InternalOrderItemOrderBy"
		},
		validateCreateInternalOrderItem:{
			data:"InternalOrderItemCreateInput"
		},
		validateUpdateInternalOrderItem:{
			by:"InternalOrderItemUniqueWhere",
			data:"InternalOrderItemUpdateInput"
		},
		getPreparedPackingQuantity:{
			by:"PreparedPackingQuantityUniqueWhere",
			filter:"PreparedPackingQuantityWhere"
		},
		listPreparedPackingQuantity:{
			filter:"PreparedPackingQuantityWhere",
			orderBy:"PreparedPackingQuantityOrderBy"
		},
		paginatePreparedPackingQuantity:{
			filter:"PreparedPackingQuantityWhere",
			orderBy:"PreparedPackingQuantityOrderBy"
		},
		validateCreatePreparedPackingQuantity:{
			data:"PreparedPackingQuantityCreateInput"
		},
		validateUpdatePreparedPackingQuantity:{
			by:"PreparedPackingQuantityUniqueWhere",
			data:"PreparedPackingQuantityUpdateInput"
		},
		getCourierManager:{
			by:"CourierManagerUniqueWhere",
			filter:"CourierManagerWhere"
		},
		listCourierManager:{
			filter:"CourierManagerWhere",
			orderBy:"CourierManagerOrderBy"
		},
		paginateCourierManager:{
			filter:"CourierManagerWhere",
			orderBy:"CourierManagerOrderBy"
		},
		validateCreateCourierManager:{
			data:"CourierManagerCreateInput"
		},
		validateUpdateCourierManager:{
			by:"CourierManagerUniqueWhere",
			data:"CourierManagerUpdateInput"
		},
		getDeliveryZone:{
			by:"DeliveryZoneUniqueWhere",
			filter:"DeliveryZoneWhere"
		},
		listDeliveryZone:{
			filter:"DeliveryZoneWhere",
			orderBy:"DeliveryZoneOrderBy"
		},
		paginateDeliveryZone:{
			filter:"DeliveryZoneWhere",
			orderBy:"DeliveryZoneOrderBy"
		},
		validateCreateDeliveryZone:{
			data:"DeliveryZoneCreateInput"
		},
		validateUpdateDeliveryZone:{
			by:"DeliveryZoneUniqueWhere",
			data:"DeliveryZoneUpdateInput"
		},
		getAddressMetadata:{
			by:"AddressMetadataUniqueWhere",
			filter:"AddressMetadataWhere"
		},
		listAddressMetadata:{
			filter:"AddressMetadataWhere",
			orderBy:"AddressMetadataOrderBy"
		},
		paginateAddressMetadata:{
			filter:"AddressMetadataWhere",
			orderBy:"AddressMetadataOrderBy"
		},
		getDeliveryTimelinePreset:{
			by:"DeliveryTimelinePresetUniqueWhere",
			filter:"DeliveryTimelinePresetWhere"
		},
		listDeliveryTimelinePreset:{
			filter:"DeliveryTimelinePresetWhere",
			orderBy:"DeliveryTimelinePresetOrderBy"
		},
		paginateDeliveryTimelinePreset:{
			filter:"DeliveryTimelinePresetWhere",
			orderBy:"DeliveryTimelinePresetOrderBy"
		},
		validateCreateDeliveryTimelinePreset:{
			data:"DeliveryTimelinePresetCreateInput"
		},
		validateUpdateDeliveryTimelinePreset:{
			by:"DeliveryTimelinePresetUniqueWhere",
			data:"DeliveryTimelinePresetUpdateInput"
		},
		getOrderDeliveryTimeline:{
			by:"OrderDeliveryTimelineUniqueWhere",
			filter:"OrderDeliveryTimelineWhere"
		},
		listOrderDeliveryTimeline:{
			filter:"OrderDeliveryTimelineWhere",
			orderBy:"OrderDeliveryTimelineOrderBy"
		},
		paginateOrderDeliveryTimeline:{
			filter:"OrderDeliveryTimelineWhere",
			orderBy:"OrderDeliveryTimelineOrderBy"
		},
		validateCreateOrderDeliveryTimeline:{
			data:"OrderDeliveryTimelineCreateInput"
		},
		validateUpdateOrderDeliveryTimeline:{
			by:"OrderDeliveryTimelineUniqueWhere",
			data:"OrderDeliveryTimelineUpdateInput"
		},
		getOrderEvent:{
			by:"OrderEventUniqueWhere",
			filter:"OrderEventWhere"
		},
		listOrderEvent:{
			filter:"OrderEventWhere",
			orderBy:"OrderEventOrderBy"
		},
		paginateOrderEvent:{
			filter:"OrderEventWhere",
			orderBy:"OrderEventOrderBy"
		},
		validateCreateOrderEvent:{
			data:"OrderEventCreateInput"
		},
		validateUpdateOrderEvent:{
			by:"OrderEventUniqueWhere",
			data:"OrderEventUpdateInput"
		},
		getLiftagoRide:{
			by:"LiftagoRideUniqueWhere",
			filter:"LiftagoRideWhere"
		},
		listLiftagoRide:{
			filter:"LiftagoRideWhere",
			orderBy:"LiftagoRideOrderBy"
		},
		paginateLiftagoRide:{
			filter:"LiftagoRideWhere",
			orderBy:"LiftagoRideOrderBy"
		},
		validateCreateLiftagoRide:{
			data:"LiftagoRideCreateInput"
		},
		validateUpdateLiftagoRide:{
			by:"LiftagoRideUniqueWhere",
			data:"LiftagoRideUpdateInput"
		},
		getInvoice:{
			by:"InvoiceUniqueWhere",
			filter:"InvoiceWhere"
		},
		listInvoice:{
			filter:"InvoiceWhere",
			orderBy:"InvoiceOrderBy"
		},
		paginateInvoice:{
			filter:"InvoiceWhere",
			orderBy:"InvoiceOrderBy"
		},
		validateCreateInvoice:{
			data:"InvoiceCreateInput"
		},
		validateUpdateInvoice:{
			by:"InvoiceUniqueWhere",
			data:"InvoiceUpdateInput"
		},
		getInvoicingPlan:{
			by:"InvoicingPlanUniqueWhere",
			filter:"InvoicingPlanWhere"
		},
		listInvoicingPlan:{
			filter:"InvoicingPlanWhere",
			orderBy:"InvoicingPlanOrderBy"
		},
		paginateInvoicingPlan:{
			filter:"InvoicingPlanWhere",
			orderBy:"InvoicingPlanOrderBy"
		},
		validateCreateInvoicingPlan:{
			data:"InvoicingPlanCreateInput"
		},
		validateUpdateInvoicingPlan:{
			by:"InvoicingPlanUniqueWhere",
			data:"InvoicingPlanUpdateInput"
		},
		getProductPackingLocale:{
			by:"ProductPackingLocaleUniqueWhere",
			filter:"ProductPackingLocaleWhere"
		},
		listProductPackingLocale:{
			filter:"ProductPackingLocaleWhere",
			orderBy:"ProductPackingLocaleOrderBy"
		},
		paginateProductPackingLocale:{
			filter:"ProductPackingLocaleWhere",
			orderBy:"ProductPackingLocaleOrderBy"
		},
		validateCreateProductPackingLocale:{
			data:"ProductPackingLocaleCreateInput"
		},
		validateUpdateProductPackingLocale:{
			by:"ProductPackingLocaleUniqueWhere",
			data:"ProductPackingLocaleUpdateInput"
		},
		getProductLocale:{
			by:"ProductLocaleUniqueWhere",
			filter:"ProductLocaleWhere"
		},
		listProductLocale:{
			filter:"ProductLocaleWhere",
			orderBy:"ProductLocaleOrderBy"
		},
		paginateProductLocale:{
			filter:"ProductLocaleWhere",
			orderBy:"ProductLocaleOrderBy"
		},
		validateCreateProductLocale:{
			data:"ProductLocaleCreateInput"
		},
		validateUpdateProductLocale:{
			by:"ProductLocaleUniqueWhere",
			data:"ProductLocaleUpdateInput"
		},
		getProductRecipeLocale:{
			by:"ProductRecipeLocaleUniqueWhere",
			filter:"ProductRecipeLocaleWhere"
		},
		listProductRecipeLocale:{
			filter:"ProductRecipeLocaleWhere",
			orderBy:"ProductRecipeLocaleOrderBy"
		},
		paginateProductRecipeLocale:{
			filter:"ProductRecipeLocaleWhere",
			orderBy:"ProductRecipeLocaleOrderBy"
		},
		validateCreateProductRecipeLocale:{
			data:"ProductRecipeLocaleCreateInput"
		},
		validateUpdateProductRecipeLocale:{
			by:"ProductRecipeLocaleUniqueWhere",
			data:"ProductRecipeLocaleUpdateInput"
		},
		getUserDevice:{
			by:"UserDeviceUniqueWhere",
			filter:"UserDeviceWhere"
		},
		listUserDevice:{
			filter:"UserDeviceWhere",
			orderBy:"UserDeviceOrderBy"
		},
		paginateUserDevice:{
			filter:"UserDeviceWhere",
			orderBy:"UserDeviceOrderBy"
		},
		validateCreateUserDevice:{
			data:"UserDeviceCreateInput"
		},
		validateUpdateUserDevice:{
			by:"UserDeviceUniqueWhere",
			data:"UserDeviceUpdateInput"
		},
		getProtectedAction:{
			by:"ProtectedActionUniqueWhere",
			filter:"ProtectedActionWhere"
		},
		listProtectedAction:{
			filter:"ProtectedActionWhere",
			orderBy:"ProtectedActionOrderBy"
		},
		paginateProtectedAction:{
			filter:"ProtectedActionWhere",
			orderBy:"ProtectedActionOrderBy"
		},
		validateCreateProtectedAction:{
			data:"ProtectedActionCreateInput"
		},
		validateUpdateProtectedAction:{
			by:"ProtectedActionUniqueWhere",
			data:"ProtectedActionUpdateInput"
		},
		getPicker:{
			by:"PickerUniqueWhere",
			filter:"PickerWhere"
		},
		listPicker:{
			filter:"PickerWhere",
			orderBy:"PickerOrderBy"
		},
		paginatePicker:{
			filter:"PickerWhere",
			orderBy:"PickerOrderBy"
		},
		validateCreatePicker:{
			data:"PickerCreateInput"
		},
		validateUpdatePicker:{
			by:"PickerUniqueWhere",
			data:"PickerUpdateInput"
		},
		getTenantPerson:{
			by:"TenantPersonUniqueWhere",
			filter:"TenantPersonWhere"
		},
		listTenantPerson:{
			filter:"TenantPersonWhere",
			orderBy:"TenantPersonOrderBy"
		},
		paginateTenantPerson:{
			filter:"TenantPersonWhere",
			orderBy:"TenantPersonOrderBy"
		},
		getTimetableTemplateStaffOptions:{
			by:"TimetableTemplateStaffOptionsUniqueWhere",
			filter:"TimetableTemplateStaffOptionsWhere"
		},
		listTimetableTemplateStaffOptions:{
			filter:"TimetableTemplateStaffOptionsWhere",
			orderBy:"TimetableTemplateStaffOptionsOrderBy"
		},
		paginateTimetableTemplateStaffOptions:{
			filter:"TimetableTemplateStaffOptionsWhere",
			orderBy:"TimetableTemplateStaffOptionsOrderBy"
		},
		validateCreateTimetableTemplateStaffOptions:{
			data:"TimetableTemplateStaffOptionsCreateInput"
		},
		validateUpdateTimetableTemplateStaffOptions:{
			by:"TimetableTemplateStaffOptionsUniqueWhere",
			data:"TimetableTemplateStaffOptionsUpdateInput"
		},
		getShoppingList:{
			by:"ShoppingListUniqueWhere",
			filter:"ShoppingListWhere"
		},
		listShoppingList:{
			filter:"ShoppingListWhere",
			orderBy:"ShoppingListOrderBy"
		},
		paginateShoppingList:{
			filter:"ShoppingListWhere",
			orderBy:"ShoppingListOrderBy"
		},
		validateCreateShoppingList:{
			data:"ShoppingListCreateInput"
		},
		validateUpdateShoppingList:{
			by:"ShoppingListUniqueWhere",
			data:"ShoppingListUpdateInput"
		},
		getSuppliesPurchase:{
			by:"SuppliesPurchaseUniqueWhere",
			filter:"SuppliesPurchaseWhere"
		},
		listSuppliesPurchase:{
			filter:"SuppliesPurchaseWhere",
			orderBy:"SuppliesPurchaseOrderBy"
		},
		paginateSuppliesPurchase:{
			filter:"SuppliesPurchaseWhere",
			orderBy:"SuppliesPurchaseOrderBy"
		},
		validateCreateSuppliesPurchase:{
			data:"SuppliesPurchaseCreateInput"
		},
		validateUpdateSuppliesPurchase:{
			by:"SuppliesPurchaseUniqueWhere",
			data:"SuppliesPurchaseUpdateInput"
		},
		getInvoicingPreset:{
			by:"InvoicingPresetUniqueWhere",
			filter:"InvoicingPresetWhere"
		},
		listInvoicingPreset:{
			filter:"InvoicingPresetWhere",
			orderBy:"InvoicingPresetOrderBy"
		},
		paginateInvoicingPreset:{
			filter:"InvoicingPresetWhere",
			orderBy:"InvoicingPresetOrderBy"
		},
		validateCreateInvoicingPreset:{
			data:"InvoicingPresetCreateInput"
		},
		validateUpdateInvoicingPreset:{
			by:"InvoicingPresetUniqueWhere",
			data:"InvoicingPresetUpdateInput"
		},
		getLogRecord:{
			by:"LogRecordUniqueWhere",
			filter:"LogRecordWhere"
		},
		listLogRecord:{
			filter:"LogRecordWhere",
			orderBy:"LogRecordOrderBy"
		},
		paginateLogRecord:{
			filter:"LogRecordWhere",
			orderBy:"LogRecordOrderBy"
		},
		validateCreateLogRecord:{
			data:"LogRecordCreateInput"
		},
		validateUpdateLogRecord:{
			by:"LogRecordUniqueWhere",
			data:"LogRecordUpdateInput"
		},
		getBillingSubject:{
			by:"BillingSubjectUniqueWhere",
			filter:"BillingSubjectWhere"
		},
		listBillingSubject:{
			filter:"BillingSubjectWhere",
			orderBy:"BillingSubjectOrderBy"
		},
		paginateBillingSubject:{
			filter:"BillingSubjectWhere",
			orderBy:"BillingSubjectOrderBy"
		},
		validateCreateBillingSubject:{
			data:"BillingSubjectCreateInput"
		},
		validateUpdateBillingSubject:{
			by:"BillingSubjectUniqueWhere",
			data:"BillingSubjectUpdateInput"
		},
		getProductCustomerPrice:{
			by:"ProductCustomerPriceUniqueWhere",
			filter:"ProductCustomerPriceWhere"
		},
		listProductCustomerPrice:{
			filter:"ProductCustomerPriceWhere",
			orderBy:"ProductCustomerPriceOrderBy"
		},
		paginateProductCustomerPrice:{
			filter:"ProductCustomerPriceWhere",
			orderBy:"ProductCustomerPriceOrderBy"
		},
		getCartPriceLine:{
			by:"CartPriceLineUniqueWhere",
			filter:"CartPriceLineWhere"
		},
		listCartPriceLine:{
			filter:"CartPriceLineWhere",
			orderBy:"CartPriceLineOrderBy"
		},
		paginateCartPriceLine:{
			filter:"CartPriceLineWhere",
			orderBy:"CartPriceLineOrderBy"
		},
		getShoppingListItem:{
			by:"ShoppingListItemUniqueWhere",
			filter:"ShoppingListItemWhere"
		},
		listShoppingListItem:{
			filter:"ShoppingListItemWhere",
			orderBy:"ShoppingListItemOrderBy"
		},
		paginateShoppingListItem:{
			filter:"ShoppingListItemWhere",
			orderBy:"ShoppingListItemOrderBy"
		},
		validateCreateShoppingListItem:{
			data:"ShoppingListItemCreateInput"
		},
		validateUpdateShoppingListItem:{
			by:"ShoppingListItemUniqueWhere",
			data:"ShoppingListItemUpdateInput"
		},
		getSuppliesPurchaseItem:{
			by:"SuppliesPurchaseItemUniqueWhere",
			filter:"SuppliesPurchaseItemWhere"
		},
		listSuppliesPurchaseItem:{
			filter:"SuppliesPurchaseItemWhere",
			orderBy:"SuppliesPurchaseItemOrderBy"
		},
		paginateSuppliesPurchaseItem:{
			filter:"SuppliesPurchaseItemWhere",
			orderBy:"SuppliesPurchaseItemOrderBy"
		},
		validateCreateSuppliesPurchaseItem:{
			data:"SuppliesPurchaseItemCreateInput"
		},
		validateUpdateSuppliesPurchaseItem:{
			by:"SuppliesPurchaseItemUniqueWhere",
			data:"SuppliesPurchaseItemUpdateInput"
		},
		getCustomerCreditTransaction:{
			by:"CustomerCreditTransactionUniqueWhere",
			filter:"CustomerCreditTransactionWhere"
		},
		listCustomerCreditTransaction:{
			filter:"CustomerCreditTransactionWhere",
			orderBy:"CustomerCreditTransactionOrderBy"
		},
		paginateCustomerCreditTransaction:{
			filter:"CustomerCreditTransactionWhere",
			orderBy:"CustomerCreditTransactionOrderBy"
		},
		validateCreateCustomerCreditTransaction:{
			data:"CustomerCreditTransactionCreateInput"
		},
		validateUpdateCustomerCreditTransaction:{
			by:"CustomerCreditTransactionUniqueWhere",
			data:"CustomerCreditTransactionUpdateInput"
		},
		getVirtualProduct:{
			by:"VirtualProductUniqueWhere",
			filter:"VirtualProductWhere"
		},
		listVirtualProduct:{
			filter:"VirtualProductWhere",
			orderBy:"VirtualProductOrderBy"
		},
		paginateVirtualProduct:{
			filter:"VirtualProductWhere",
			orderBy:"VirtualProductOrderBy"
		},
		validateCreateVirtualProduct:{
			data:"VirtualProductCreateInput"
		},
		validateUpdateVirtualProduct:{
			by:"VirtualProductUniqueWhere",
			data:"VirtualProductUpdateInput"
		},
		getVirtualProductEffect:{
			by:"VirtualProductEffectUniqueWhere",
			filter:"VirtualProductEffectWhere"
		},
		listVirtualProductEffect:{
			filter:"VirtualProductEffectWhere",
			orderBy:"VirtualProductEffectOrderBy"
		},
		paginateVirtualProductEffect:{
			filter:"VirtualProductEffectWhere",
			orderBy:"VirtualProductEffectOrderBy"
		},
		validateCreateVirtualProductEffect:{
			data:"VirtualProductEffectCreateInput"
		},
		validateUpdateVirtualProductEffect:{
			by:"VirtualProductEffectUniqueWhere",
			data:"VirtualProductEffectUpdateInput"
		},
		getOrderPriceLine:{
			by:"OrderPriceLineUniqueWhere",
			filter:"OrderPriceLineWhere"
		},
		listOrderPriceLine:{
			filter:"OrderPriceLineWhere",
			orderBy:"OrderPriceLineOrderBy"
		},
		paginateOrderPriceLine:{
			filter:"OrderPriceLineWhere",
			orderBy:"OrderPriceLineOrderBy"
		},
		getProductMetadata:{
			by:"ProductMetadataUniqueWhere",
			filter:"ProductMetadataWhere"
		},
		listProductMetadata:{
			filter:"ProductMetadataWhere",
			orderBy:"ProductMetadataOrderBy"
		},
		paginateProductMetadata:{
			filter:"ProductMetadataWhere",
			orderBy:"ProductMetadataOrderBy"
		},
		getEmploymentInformation:{
			by:"EmploymentInformationUniqueWhere",
			filter:"EmploymentInformationWhere"
		},
		listEmploymentInformation:{
			filter:"EmploymentInformationWhere",
			orderBy:"EmploymentInformationOrderBy"
		},
		paginateEmploymentInformation:{
			filter:"EmploymentInformationWhere",
			orderBy:"EmploymentInformationOrderBy"
		},
		validateCreateEmploymentInformation:{
			data:"EmploymentInformationCreateInput"
		},
		validateUpdateEmploymentInformation:{
			by:"EmploymentInformationUniqueWhere",
			data:"EmploymentInformationUpdateInput"
		},
		getRemunerationProfile:{
			by:"RemunerationProfileUniqueWhere",
			filter:"RemunerationProfileWhere"
		},
		listRemunerationProfile:{
			filter:"RemunerationProfileWhere",
			orderBy:"RemunerationProfileOrderBy"
		},
		paginateRemunerationProfile:{
			filter:"RemunerationProfileWhere",
			orderBy:"RemunerationProfileOrderBy"
		},
		validateCreateRemunerationProfile:{
			data:"RemunerationProfileCreateInput"
		},
		validateUpdateRemunerationProfile:{
			by:"RemunerationProfileUniqueWhere",
			data:"RemunerationProfileUpdateInput"
		},
		getWorkMonth:{
			by:"WorkMonthUniqueWhere",
			filter:"WorkMonthWhere"
		},
		listWorkMonth:{
			filter:"WorkMonthWhere",
			orderBy:"WorkMonthOrderBy"
		},
		paginateWorkMonth:{
			filter:"WorkMonthWhere",
			orderBy:"WorkMonthOrderBy"
		},
		validateCreateWorkMonth:{
			data:"WorkMonthCreateInput"
		},
		validateUpdateWorkMonth:{
			by:"WorkMonthUniqueWhere",
			data:"WorkMonthUpdateInput"
		},
		getSalaryOptions:{
			by:"SalaryOptionsUniqueWhere",
			filter:"SalaryOptionsWhere"
		},
		listSalaryOptions:{
			filter:"SalaryOptionsWhere",
			orderBy:"SalaryOptionsOrderBy"
		},
		paginateSalaryOptions:{
			filter:"SalaryOptionsWhere",
			orderBy:"SalaryOptionsOrderBy"
		},
		validateCreateSalaryOptions:{
			data:"SalaryOptionsCreateInput"
		},
		validateUpdateSalaryOptions:{
			by:"SalaryOptionsUniqueWhere",
			data:"SalaryOptionsUpdateInput"
		},
		getTimetableShiftSwapInfo:{
			by:"TimetableShiftSwapInfoUniqueWhere",
			filter:"TimetableShiftSwapInfoWhere"
		},
		listTimetableShiftSwapInfo:{
			filter:"TimetableShiftSwapInfoWhere",
			orderBy:"TimetableShiftSwapInfoOrderBy"
		},
		paginateTimetableShiftSwapInfo:{
			filter:"TimetableShiftSwapInfoWhere",
			orderBy:"TimetableShiftSwapInfoOrderBy"
		},
		validateCreateTimetableShiftSwapInfo:{
			data:"TimetableShiftSwapInfoCreateInput"
		},
		validateUpdateTimetableShiftSwapInfo:{
			by:"TimetableShiftSwapInfoUniqueWhere",
			data:"TimetableShiftSwapInfoUpdateInput"
		},
		getProductGridCategory:{
			by:"ProductGridCategoryUniqueWhere",
			filter:"ProductGridCategoryWhere"
		},
		listProductGridCategory:{
			filter:"ProductGridCategoryWhere",
			orderBy:"ProductGridCategoryOrderBy"
		},
		paginateProductGridCategory:{
			filter:"ProductGridCategoryWhere",
			orderBy:"ProductGridCategoryOrderBy"
		},
		validateCreateProductGridCategory:{
			data:"ProductGridCategoryCreateInput"
		},
		validateUpdateProductGridCategory:{
			by:"ProductGridCategoryUniqueWhere",
			data:"ProductGridCategoryUpdateInput"
		},
		getCashier:{
			by:"CashierUniqueWhere",
			filter:"CashierWhere"
		},
		listCashier:{
			filter:"CashierWhere",
			orderBy:"CashierOrderBy"
		},
		paginateCashier:{
			filter:"CashierWhere",
			orderBy:"CashierOrderBy"
		},
		validateCreateCashier:{
			data:"CashierCreateInput"
		},
		validateUpdateCashier:{
			by:"CashierUniqueWhere",
			data:"CashierUpdateInput"
		},
		getPointOfSaleCategory:{
			by:"PointOfSaleCategoryUniqueWhere",
			filter:"PointOfSaleCategoryWhere"
		},
		listPointOfSaleCategory:{
			filter:"PointOfSaleCategoryWhere",
			orderBy:"PointOfSaleCategoryOrderBy"
		},
		paginatePointOfSaleCategory:{
			filter:"PointOfSaleCategoryWhere",
			orderBy:"PointOfSaleCategoryOrderBy"
		},
		validateCreatePointOfSaleCategory:{
			data:"PointOfSaleCategoryCreateInput"
		},
		validateUpdatePointOfSaleCategory:{
			by:"PointOfSaleCategoryUniqueWhere",
			data:"PointOfSaleCategoryUpdateInput"
		},
		getPointOfSaleCategoryLocale:{
			by:"PointOfSaleCategoryLocaleUniqueWhere",
			filter:"PointOfSaleCategoryLocaleWhere"
		},
		listPointOfSaleCategoryLocale:{
			filter:"PointOfSaleCategoryLocaleWhere",
			orderBy:"PointOfSaleCategoryLocaleOrderBy"
		},
		paginatePointOfSaleCategoryLocale:{
			filter:"PointOfSaleCategoryLocaleWhere",
			orderBy:"PointOfSaleCategoryLocaleOrderBy"
		},
		validateCreatePointOfSaleCategoryLocale:{
			data:"PointOfSaleCategoryLocaleCreateInput"
		},
		validateUpdatePointOfSaleCategoryLocale:{
			by:"PointOfSaleCategoryLocaleUniqueWhere",
			data:"PointOfSaleCategoryLocaleUpdateInput"
		},
		getPointOfSaleCategoryProduct:{
			by:"PointOfSaleCategoryProductUniqueWhere",
			filter:"PointOfSaleCategoryProductWhere"
		},
		listPointOfSaleCategoryProduct:{
			filter:"PointOfSaleCategoryProductWhere",
			orderBy:"PointOfSaleCategoryProductOrderBy"
		},
		paginatePointOfSaleCategoryProduct:{
			filter:"PointOfSaleCategoryProductWhere",
			orderBy:"PointOfSaleCategoryProductOrderBy"
		},
		validateCreatePointOfSaleCategoryProduct:{
			data:"PointOfSaleCategoryProductCreateInput"
		},
		validateUpdatePointOfSaleCategoryProduct:{
			by:"PointOfSaleCategoryProductUniqueWhere",
			data:"PointOfSaleCategoryProductUpdateInput"
		},
		getPointOfSaleCategoryProductLocale:{
			by:"PointOfSaleCategoryProductLocaleUniqueWhere",
			filter:"PointOfSaleCategoryProductLocaleWhere"
		},
		listPointOfSaleCategoryProductLocale:{
			filter:"PointOfSaleCategoryProductLocaleWhere",
			orderBy:"PointOfSaleCategoryProductLocaleOrderBy"
		},
		paginatePointOfSaleCategoryProductLocale:{
			filter:"PointOfSaleCategoryProductLocaleWhere",
			orderBy:"PointOfSaleCategoryProductLocaleOrderBy"
		},
		validateCreatePointOfSaleCategoryProductLocale:{
			data:"PointOfSaleCategoryProductLocaleCreateInput"
		},
		validateUpdatePointOfSaleCategoryProductLocale:{
			by:"PointOfSaleCategoryProductLocaleUniqueWhere",
			data:"PointOfSaleCategoryProductLocaleUpdateInput"
		},
		getCustomerTab:{
			by:"CustomerTabUniqueWhere",
			filter:"CustomerTabWhere"
		},
		listCustomerTab:{
			filter:"CustomerTabWhere",
			orderBy:"CustomerTabOrderBy"
		},
		paginateCustomerTab:{
			filter:"CustomerTabWhere",
			orderBy:"CustomerTabOrderBy"
		},
		validateCreateCustomerTab:{
			data:"CustomerTabCreateInput"
		},
		validateUpdateCustomerTab:{
			by:"CustomerTabUniqueWhere",
			data:"CustomerTabUpdateInput"
		},
		getCustomerTabItem:{
			by:"CustomerTabItemUniqueWhere",
			filter:"CustomerTabItemWhere"
		},
		listCustomerTabItem:{
			filter:"CustomerTabItemWhere",
			orderBy:"CustomerTabItemOrderBy"
		},
		paginateCustomerTabItem:{
			filter:"CustomerTabItemWhere",
			orderBy:"CustomerTabItemOrderBy"
		},
		validateCreateCustomerTabItem:{
			data:"CustomerTabItemCreateInput"
		},
		validateUpdateCustomerTabItem:{
			by:"CustomerTabItemUniqueWhere",
			data:"CustomerTabItemUpdateInput"
		},
		getAnonymousSession:{
			by:"AnonymousSessionUniqueWhere",
			filter:"AnonymousSessionWhere"
		},
		listAnonymousSession:{
			filter:"AnonymousSessionWhere",
			orderBy:"AnonymousSessionOrderBy"
		},
		paginateAnonymousSession:{
			filter:"AnonymousSessionWhere",
			orderBy:"AnonymousSessionOrderBy"
		},
		validateCreateAnonymousSession:{
			data:"AnonymousSessionCreateInput"
		},
		validateUpdateAnonymousSession:{
			by:"AnonymousSessionUniqueWhere",
			data:"AnonymousSessionUpdateInput"
		},
		getVoucher:{
			by:"VoucherUniqueWhere",
			filter:"VoucherWhere"
		},
		listVoucher:{
			filter:"VoucherWhere",
			orderBy:"VoucherOrderBy"
		},
		paginateVoucher:{
			filter:"VoucherWhere",
			orderBy:"VoucherOrderBy"
		},
		validateCreateVoucher:{
			data:"VoucherCreateInput"
		},
		validateUpdateVoucher:{
			by:"VoucherUniqueWhere",
			data:"VoucherUpdateInput"
		},
		getVoucherRedemption:{
			by:"VoucherRedemptionUniqueWhere",
			filter:"VoucherRedemptionWhere"
		},
		listVoucherRedemption:{
			filter:"VoucherRedemptionWhere",
			orderBy:"VoucherRedemptionOrderBy"
		},
		paginateVoucherRedemption:{
			filter:"VoucherRedemptionWhere",
			orderBy:"VoucherRedemptionOrderBy"
		},
		validateCreateVoucherRedemption:{
			data:"VoucherRedemptionCreateInput"
		},
		validateUpdateVoucherRedemption:{
			by:"VoucherRedemptionUniqueWhere",
			data:"VoucherRedemptionUpdateInput"
		},
		getUnassignedShiftInfo:{
			by:"UnassignedShiftInfoUniqueWhere",
			filter:"UnassignedShiftInfoWhere"
		},
		listUnassignedShiftInfo:{
			filter:"UnassignedShiftInfoWhere",
			orderBy:"UnassignedShiftInfoOrderBy"
		},
		paginateUnassignedShiftInfo:{
			filter:"UnassignedShiftInfoWhere",
			orderBy:"UnassignedShiftInfoOrderBy"
		},
		validateCreateUnassignedShiftInfo:{
			data:"UnassignedShiftInfoCreateInput"
		},
		validateUpdateUnassignedShiftInfo:{
			by:"UnassignedShiftInfoUniqueWhere",
			data:"UnassignedShiftInfoUpdateInput"
		},
		getFreshingContainer:{
			by:"FreshingContainerUniqueWhere",
			filter:"FreshingContainerWhere"
		},
		listFreshingContainer:{
			filter:"FreshingContainerWhere",
			orderBy:"FreshingContainerOrderBy"
		},
		paginateFreshingContainer:{
			filter:"FreshingContainerWhere",
			orderBy:"FreshingContainerOrderBy"
		},
		validateCreateFreshingContainer:{
			data:"FreshingContainerCreateInput"
		},
		validateUpdateFreshingContainer:{
			by:"FreshingContainerUniqueWhere",
			data:"FreshingContainerUpdateInput"
		},
		getTextItem:{
			by:"TextItemUniqueWhere",
			filter:"TextItemWhere"
		},
		listTextItem:{
			filter:"TextItemWhere",
			orderBy:"TextItemOrderBy"
		},
		paginateTextItem:{
			filter:"TextItemWhere",
			orderBy:"TextItemOrderBy"
		},
		validateCreateTextItem:{
			data:"TextItemCreateInput"
		},
		validateUpdateTextItem:{
			by:"TextItemUniqueWhere",
			data:"TextItemUpdateInput"
		},
		getTextList:{
			by:"TextListUniqueWhere",
			filter:"TextListWhere"
		},
		listTextList:{
			filter:"TextListWhere",
			orderBy:"TextListOrderBy"
		},
		paginateTextList:{
			filter:"TextListWhere",
			orderBy:"TextListOrderBy"
		},
		validateCreateTextList:{
			data:"TextListCreateInput"
		},
		validateUpdateTextList:{
			by:"TextListUniqueWhere",
			data:"TextListUpdateInput"
		},
		getEmployeeQueueItemMetadata:{
			by:"EmployeeQueueItemMetadataUniqueWhere",
			filter:"EmployeeQueueItemMetadataWhere"
		},
		listEmployeeQueueItemMetadata:{
			filter:"EmployeeQueueItemMetadataWhere",
			orderBy:"EmployeeQueueItemMetadataOrderBy"
		},
		paginateEmployeeQueueItemMetadata:{
			filter:"EmployeeQueueItemMetadataWhere",
			orderBy:"EmployeeQueueItemMetadataOrderBy"
		},
		getDeliveryRegions:{
			by:"DeliveryRegionsUniqueWhere",
			filter:"DeliveryRegionsWhere"
		},
		listDeliveryRegions:{
			filter:"DeliveryRegionsWhere",
			orderBy:"DeliveryRegionsOrderBy"
		},
		paginateDeliveryRegions:{
			filter:"DeliveryRegionsWhere",
			orderBy:"DeliveryRegionsOrderBy"
		},
		validateCreateDeliveryRegions:{
			data:"DeliveryRegionsCreateInput"
		},
		validateUpdateDeliveryRegions:{
			by:"DeliveryRegionsUniqueWhere",
			data:"DeliveryRegionsUpdateInput"
		},
		getDeliveryRegionsItem:{
			by:"DeliveryRegionsItemUniqueWhere",
			filter:"DeliveryRegionsItemWhere"
		},
		listDeliveryRegionsItem:{
			filter:"DeliveryRegionsItemWhere",
			orderBy:"DeliveryRegionsItemOrderBy"
		},
		paginateDeliveryRegionsItem:{
			filter:"DeliveryRegionsItemWhere",
			orderBy:"DeliveryRegionsItemOrderBy"
		},
		validateCreateDeliveryRegionsItem:{
			data:"DeliveryRegionsItemCreateInput"
		},
		validateUpdateDeliveryRegionsItem:{
			by:"DeliveryRegionsItemUniqueWhere",
			data:"DeliveryRegionsItemUpdateInput"
		},
		getImageList:{
			by:"ImageListUniqueWhere",
			filter:"ImageListWhere"
		},
		listImageList:{
			filter:"ImageListWhere",
			orderBy:"ImageListOrderBy"
		},
		paginateImageList:{
			filter:"ImageListWhere",
			orderBy:"ImageListOrderBy"
		},
		validateCreateImageList:{
			data:"ImageListCreateInput"
		},
		validateUpdateImageList:{
			by:"ImageListUniqueWhere",
			data:"ImageListUpdateInput"
		},
		getImageListItem:{
			by:"ImageListItemUniqueWhere",
			filter:"ImageListItemWhere"
		},
		listImageListItem:{
			filter:"ImageListItemWhere",
			orderBy:"ImageListItemOrderBy"
		},
		paginateImageListItem:{
			filter:"ImageListItemWhere",
			orderBy:"ImageListItemOrderBy"
		},
		validateCreateImageListItem:{
			data:"ImageListItemCreateInput"
		},
		validateUpdateImageListItem:{
			by:"ImageListItemUniqueWhere",
			data:"ImageListItemUpdateInput"
		},
		getProductSalesDay:{
			by:"ProductSalesDayUniqueWhere",
			filter:"ProductSalesDayWhere"
		},
		listProductSalesDay:{
			filter:"ProductSalesDayWhere",
			orderBy:"ProductSalesDayOrderBy"
		},
		paginateProductSalesDay:{
			filter:"ProductSalesDayWhere",
			orderBy:"ProductSalesDayOrderBy"
		},
		getProductSalesMonth:{
			by:"ProductSalesMonthUniqueWhere",
			filter:"ProductSalesMonthWhere"
		},
		listProductSalesMonth:{
			filter:"ProductSalesMonthWhere",
			orderBy:"ProductSalesMonthOrderBy"
		},
		paginateProductSalesMonth:{
			filter:"ProductSalesMonthWhere",
			orderBy:"ProductSalesMonthOrderBy"
		},
		getProductSalesWeek:{
			by:"ProductSalesWeekUniqueWhere",
			filter:"ProductSalesWeekWhere"
		},
		listProductSalesWeek:{
			filter:"ProductSalesWeekWhere",
			orderBy:"ProductSalesWeekOrderBy"
		},
		paginateProductSalesWeek:{
			filter:"ProductSalesWeekWhere",
			orderBy:"ProductSalesWeekOrderBy"
		},
		getTimetablesEmployeePrivileges:{
			by:"TimetablesEmployeePrivilegesUniqueWhere",
			filter:"TimetablesEmployeePrivilegesWhere"
		},
		listTimetablesEmployeePrivileges:{
			filter:"TimetablesEmployeePrivilegesWhere",
			orderBy:"TimetablesEmployeePrivilegesOrderBy"
		},
		paginateTimetablesEmployeePrivileges:{
			filter:"TimetablesEmployeePrivilegesWhere",
			orderBy:"TimetablesEmployeePrivilegesOrderBy"
		},
		validateCreateTimetablesEmployeePrivileges:{
			data:"TimetablesEmployeePrivilegesCreateInput"
		},
		validateUpdateTimetablesEmployeePrivileges:{
			by:"TimetablesEmployeePrivilegesUniqueWhere",
			data:"TimetablesEmployeePrivilegesUpdateInput"
		},
		getTimetableDayNote:{
			by:"TimetableDayNoteUniqueWhere",
			filter:"TimetableDayNoteWhere"
		},
		listTimetableDayNote:{
			filter:"TimetableDayNoteWhere",
			orderBy:"TimetableDayNoteOrderBy"
		},
		paginateTimetableDayNote:{
			filter:"TimetableDayNoteWhere",
			orderBy:"TimetableDayNoteOrderBy"
		},
		validateCreateTimetableDayNote:{
			data:"TimetableDayNoteCreateInput"
		},
		validateUpdateTimetableDayNote:{
			by:"TimetableDayNoteUniqueWhere",
			data:"TimetableDayNoteUpdateInput"
		},
		getDeliveryMethodLocale:{
			by:"DeliveryMethodLocaleUniqueWhere",
			filter:"DeliveryMethodLocaleWhere"
		},
		listDeliveryMethodLocale:{
			filter:"DeliveryMethodLocaleWhere",
			orderBy:"DeliveryMethodLocaleOrderBy"
		},
		paginateDeliveryMethodLocale:{
			filter:"DeliveryMethodLocaleWhere",
			orderBy:"DeliveryMethodLocaleOrderBy"
		},
		validateCreateDeliveryMethodLocale:{
			data:"DeliveryMethodLocaleCreateInput"
		},
		validateUpdateDeliveryMethodLocale:{
			by:"DeliveryMethodLocaleUniqueWhere",
			data:"DeliveryMethodLocaleUpdateInput"
		},
		getIngredientSupplier:{
			by:"IngredientSupplierUniqueWhere",
			filter:"IngredientSupplierWhere"
		},
		listIngredientSupplier:{
			filter:"IngredientSupplierWhere",
			orderBy:"IngredientSupplierOrderBy"
		},
		paginateIngredientSupplier:{
			filter:"IngredientSupplierWhere",
			orderBy:"IngredientSupplierOrderBy"
		},
		validateCreateIngredientSupplier:{
			data:"IngredientSupplierCreateInput"
		},
		validateUpdateIngredientSupplier:{
			by:"IngredientSupplierUniqueWhere",
			data:"IngredientSupplierUpdateInput"
		},
		getIngredientSupplierItem:{
			by:"IngredientSupplierItemUniqueWhere",
			filter:"IngredientSupplierItemWhere"
		},
		listIngredientSupplierItem:{
			filter:"IngredientSupplierItemWhere",
			orderBy:"IngredientSupplierItemOrderBy"
		},
		paginateIngredientSupplierItem:{
			filter:"IngredientSupplierItemWhere",
			orderBy:"IngredientSupplierItemOrderBy"
		},
		validateCreateIngredientSupplierItem:{
			data:"IngredientSupplierItemCreateInput"
		},
		validateUpdateIngredientSupplierItem:{
			by:"IngredientSupplierItemUniqueWhere",
			data:"IngredientSupplierItemUpdateInput"
		},
		getIngredientSupplierList:{
			by:"IngredientSupplierListUniqueWhere",
			filter:"IngredientSupplierListWhere"
		},
		listIngredientSupplierList:{
			filter:"IngredientSupplierListWhere",
			orderBy:"IngredientSupplierListOrderBy"
		},
		paginateIngredientSupplierList:{
			filter:"IngredientSupplierListWhere",
			orderBy:"IngredientSupplierListOrderBy"
		},
		validateCreateIngredientSupplierList:{
			data:"IngredientSupplierListCreateInput"
		},
		validateUpdateIngredientSupplierList:{
			by:"IngredientSupplierListUniqueWhere",
			data:"IngredientSupplierListUpdateInput"
		},
		getIngredientSupplierLocale:{
			by:"IngredientSupplierLocaleUniqueWhere",
			filter:"IngredientSupplierLocaleWhere"
		},
		listIngredientSupplierLocale:{
			filter:"IngredientSupplierLocaleWhere",
			orderBy:"IngredientSupplierLocaleOrderBy"
		},
		paginateIngredientSupplierLocale:{
			filter:"IngredientSupplierLocaleWhere",
			orderBy:"IngredientSupplierLocaleOrderBy"
		},
		validateCreateIngredientSupplierLocale:{
			data:"IngredientSupplierLocaleCreateInput"
		},
		validateUpdateIngredientSupplierLocale:{
			by:"IngredientSupplierLocaleUniqueWhere",
			data:"IngredientSupplierLocaleUpdateInput"
		},
		getRedirect:{
			by:"RedirectUniqueWhere",
			filter:"RedirectWhere"
		},
		listRedirect:{
			filter:"RedirectWhere",
			orderBy:"RedirectOrderBy"
		},
		paginateRedirect:{
			filter:"RedirectWhere",
			orderBy:"RedirectOrderBy"
		},
		validateCreateRedirect:{
			data:"RedirectCreateInput"
		},
		validateUpdateRedirect:{
			by:"RedirectUniqueWhere",
			data:"RedirectUpdateInput"
		},
		getNutritionFacts:{
			by:"NutritionFactsUniqueWhere",
			filter:"NutritionFactsWhere"
		},
		listNutritionFacts:{
			filter:"NutritionFactsWhere",
			orderBy:"NutritionFactsOrderBy"
		},
		paginateNutritionFacts:{
			filter:"NutritionFactsWhere",
			orderBy:"NutritionFactsOrderBy"
		},
		validateCreateNutritionFacts:{
			data:"NutritionFactsCreateInput"
		},
		validateUpdateNutritionFacts:{
			by:"NutritionFactsUniqueWhere",
			data:"NutritionFactsUpdateInput"
		},
		getVenue:{
			by:"VenueUniqueWhere",
			filter:"VenueWhere"
		},
		listVenue:{
			filter:"VenueWhere",
			orderBy:"VenueOrderBy"
		},
		paginateVenue:{
			filter:"VenueWhere",
			orderBy:"VenueOrderBy"
		},
		validateCreateVenue:{
			data:"VenueCreateInput"
		},
		validateUpdateVenue:{
			by:"VenueUniqueWhere",
			data:"VenueUpdateInput"
		},
		getWorkspace:{
			by:"WorkspaceUniqueWhere",
			filter:"WorkspaceWhere"
		},
		listWorkspace:{
			filter:"WorkspaceWhere",
			orderBy:"WorkspaceOrderBy"
		},
		paginateWorkspace:{
			filter:"WorkspaceWhere",
			orderBy:"WorkspaceOrderBy"
		},
		validateCreateWorkspace:{
			data:"WorkspaceCreateInput"
		},
		validateUpdateWorkspace:{
			by:"WorkspaceUniqueWhere",
			data:"WorkspaceUpdateInput"
		},
		getInternalBuyer:{
			by:"InternalBuyerUniqueWhere",
			filter:"InternalBuyerWhere"
		},
		listInternalBuyer:{
			filter:"InternalBuyerWhere",
			orderBy:"InternalBuyerOrderBy"
		},
		paginateInternalBuyer:{
			filter:"InternalBuyerWhere",
			orderBy:"InternalBuyerOrderBy"
		},
		validateCreateInternalBuyer:{
			data:"InternalBuyerCreateInput"
		},
		validateUpdateInternalBuyer:{
			by:"InternalBuyerUniqueWhere",
			data:"InternalBuyerUpdateInput"
		},
		getCartSummary:{
			by:"CartSummaryUniqueWhere",
			filter:"CartSummaryWhere"
		},
		listCartSummary:{
			filter:"CartSummaryWhere",
			orderBy:"CartSummaryOrderBy"
		},
		paginateCartSummary:{
			filter:"CartSummaryWhere",
			orderBy:"CartSummaryOrderBy"
		},
		getOrderSummary:{
			by:"OrderSummaryUniqueWhere",
			filter:"OrderSummaryWhere"
		},
		listOrderSummary:{
			filter:"OrderSummaryWhere",
			orderBy:"OrderSummaryOrderBy"
		},
		paginateOrderSummary:{
			filter:"OrderSummaryWhere",
			orderBy:"OrderSummaryOrderBy"
		},
		getCustomerSpending:{
			by:"CustomerSpendingUniqueWhere",
			filter:"CustomerSpendingWhere"
		},
		listCustomerSpending:{
			filter:"CustomerSpendingWhere",
			orderBy:"CustomerSpendingOrderBy"
		},
		paginateCustomerSpending:{
			filter:"CustomerSpendingWhere",
			orderBy:"CustomerSpendingOrderBy"
		},
		getOrderPaymentMetadata:{
			by:"OrderPaymentMetadataUniqueWhere",
			filter:"OrderPaymentMetadataWhere"
		},
		listOrderPaymentMetadata:{
			filter:"OrderPaymentMetadataWhere",
			orderBy:"OrderPaymentMetadataOrderBy"
		},
		paginateOrderPaymentMetadata:{
			filter:"OrderPaymentMetadataWhere",
			orderBy:"OrderPaymentMetadataOrderBy"
		},
		getUserMetadata:{
			by:"UserMetadataUniqueWhere",
			filter:"UserMetadataWhere"
		},
		listUserMetadata:{
			filter:"UserMetadataWhere",
			orderBy:"UserMetadataOrderBy"
		},
		paginateUserMetadata:{
			filter:"UserMetadataWhere",
			orderBy:"UserMetadataOrderBy"
		},
		getCustomerTabMetadata:{
			by:"CustomerTabMetadataUniqueWhere",
			filter:"CustomerTabMetadataWhere"
		},
		listCustomerTabMetadata:{
			filter:"CustomerTabMetadataWhere",
			orderBy:"CustomerTabMetadataOrderBy"
		},
		paginateCustomerTabMetadata:{
			filter:"CustomerTabMetadataWhere",
			orderBy:"CustomerTabMetadataOrderBy"
		},
		getVenueEmployeeRole:{
			by:"VenueEmployeeRoleUniqueWhere",
			filter:"VenueEmployeeRoleWhere"
		},
		listVenueEmployeeRole:{
			filter:"VenueEmployeeRoleWhere",
			orderBy:"VenueEmployeeRoleOrderBy"
		},
		paginateVenueEmployeeRole:{
			filter:"VenueEmployeeRoleWhere",
			orderBy:"VenueEmployeeRoleOrderBy"
		},
		validateCreateVenueEmployeeRole:{
			data:"VenueEmployeeRoleCreateInput"
		},
		validateUpdateVenueEmployeeRole:{
			by:"VenueEmployeeRoleUniqueWhere",
			data:"VenueEmployeeRoleUpdateInput"
		},
		getIdentificationAttempt:{
			by:"IdentificationAttemptUniqueWhere",
			filter:"IdentificationAttemptWhere"
		},
		listIdentificationAttempt:{
			filter:"IdentificationAttemptWhere",
			orderBy:"IdentificationAttemptOrderBy"
		},
		paginateIdentificationAttempt:{
			filter:"IdentificationAttemptWhere",
			orderBy:"IdentificationAttemptOrderBy"
		},
		validateCreateIdentificationAttempt:{
			data:"IdentificationAttemptCreateInput"
		},
		validateUpdateIdentificationAttempt:{
			by:"IdentificationAttemptUniqueWhere",
			data:"IdentificationAttemptUpdateInput"
		},
		getIdentificationCode:{
			by:"IdentificationCodeUniqueWhere",
			filter:"IdentificationCodeWhere"
		},
		listIdentificationCode:{
			filter:"IdentificationCodeWhere",
			orderBy:"IdentificationCodeOrderBy"
		},
		paginateIdentificationCode:{
			filter:"IdentificationCodeWhere",
			orderBy:"IdentificationCodeOrderBy"
		},
		validateCreateIdentificationCode:{
			data:"IdentificationCodeCreateInput"
		},
		validateUpdateIdentificationCode:{
			by:"IdentificationCodeUniqueWhere",
			data:"IdentificationCodeUpdateInput"
		},
		getIdentificationCodeLocale:{
			by:"IdentificationCodeLocaleUniqueWhere",
			filter:"IdentificationCodeLocaleWhere"
		},
		listIdentificationCodeLocale:{
			filter:"IdentificationCodeLocaleWhere",
			orderBy:"IdentificationCodeLocaleOrderBy"
		},
		paginateIdentificationCodeLocale:{
			filter:"IdentificationCodeLocaleWhere",
			orderBy:"IdentificationCodeLocaleOrderBy"
		},
		validateCreateIdentificationCodeLocale:{
			data:"IdentificationCodeLocaleCreateInput"
		},
		validateUpdateIdentificationCodeLocale:{
			by:"IdentificationCodeLocaleUniqueWhere",
			data:"IdentificationCodeLocaleUpdateInput"
		},
		getPipeline:{
			by:"PipelineUniqueWhere",
			filter:"PipelineWhere"
		},
		listPipeline:{
			filter:"PipelineWhere",
			orderBy:"PipelineOrderBy"
		},
		paginatePipeline:{
			filter:"PipelineWhere",
			orderBy:"PipelineOrderBy"
		},
		validateCreatePipeline:{
			data:"PipelineCreateInput"
		},
		validateUpdatePipeline:{
			by:"PipelineUniqueWhere",
			data:"PipelineUpdateInput"
		},
		getPipelineLead:{
			by:"PipelineLeadUniqueWhere",
			filter:"PipelineLeadWhere"
		},
		listPipelineLead:{
			filter:"PipelineLeadWhere",
			orderBy:"PipelineLeadOrderBy"
		},
		paginatePipelineLead:{
			filter:"PipelineLeadWhere",
			orderBy:"PipelineLeadOrderBy"
		},
		validateCreatePipelineLead:{
			data:"PipelineLeadCreateInput"
		},
		validateUpdatePipelineLead:{
			by:"PipelineLeadUniqueWhere",
			data:"PipelineLeadUpdateInput"
		},
		getPipelineStage:{
			by:"PipelineStageUniqueWhere",
			filter:"PipelineStageWhere"
		},
		listPipelineStage:{
			filter:"PipelineStageWhere",
			orderBy:"PipelineStageOrderBy"
		},
		paginatePipelineStage:{
			filter:"PipelineStageWhere",
			orderBy:"PipelineStageOrderBy"
		},
		validateCreatePipelineStage:{
			data:"PipelineStageCreateInput"
		},
		validateUpdatePipelineStage:{
			by:"PipelineStageUniqueWhere",
			data:"PipelineStageUpdateInput"
		},
		getPipelineStageItem:{
			by:"PipelineStageItemUniqueWhere",
			filter:"PipelineStageItemWhere"
		},
		listPipelineStageItem:{
			filter:"PipelineStageItemWhere",
			orderBy:"PipelineStageItemOrderBy"
		},
		paginatePipelineStageItem:{
			filter:"PipelineStageItemWhere",
			orderBy:"PipelineStageItemOrderBy"
		},
		validateCreatePipelineStageItem:{
			data:"PipelineStageItemCreateInput"
		},
		validateUpdatePipelineStageItem:{
			by:"PipelineStageItemUniqueWhere",
			data:"PipelineStageItemUpdateInput"
		},
		getPipelineStageLocale:{
			by:"PipelineStageLocaleUniqueWhere",
			filter:"PipelineStageLocaleWhere"
		},
		listPipelineStageLocale:{
			filter:"PipelineStageLocaleWhere",
			orderBy:"PipelineStageLocaleOrderBy"
		},
		paginatePipelineStageLocale:{
			filter:"PipelineStageLocaleWhere",
			orderBy:"PipelineStageLocaleOrderBy"
		},
		validateCreatePipelineStageLocale:{
			data:"PipelineStageLocaleCreateInput"
		},
		validateUpdatePipelineStageLocale:{
			by:"PipelineStageLocaleUniqueWhere",
			data:"PipelineStageLocaleUpdateInput"
		},
		getSalesManager:{
			by:"SalesManagerUniqueWhere",
			filter:"SalesManagerWhere"
		},
		listSalesManager:{
			filter:"SalesManagerWhere",
			orderBy:"SalesManagerOrderBy"
		},
		paginateSalesManager:{
			filter:"SalesManagerWhere",
			orderBy:"SalesManagerOrderBy"
		},
		validateCreateSalesManager:{
			data:"SalesManagerCreateInput"
		},
		validateUpdateSalesManager:{
			by:"SalesManagerUniqueWhere",
			data:"SalesManagerUpdateInput"
		},
		getCashierManager:{
			by:"CashierManagerUniqueWhere",
			filter:"CashierManagerWhere"
		},
		listCashierManager:{
			filter:"CashierManagerWhere",
			orderBy:"CashierManagerOrderBy"
		},
		paginateCashierManager:{
			filter:"CashierManagerWhere",
			orderBy:"CashierManagerOrderBy"
		},
		validateCreateCashierManager:{
			data:"CashierManagerCreateInput"
		},
		validateUpdateCashierManager:{
			by:"CashierManagerUniqueWhere",
			data:"CashierManagerUpdateInput"
		},
		getUserRoles:{
			by:"UserRolesUniqueWhere",
			filter:"UserRolesWhere"
		},
		listUserRoles:{
			filter:"UserRolesWhere",
			orderBy:"UserRolesOrderBy"
		},
		paginateUserRoles:{
			filter:"UserRolesWhere",
			orderBy:"UserRolesOrderBy"
		},
		getPointOfSaleApplicationDevice:{
			by:"PointOfSaleApplicationDeviceUniqueWhere",
			filter:"PointOfSaleApplicationDeviceWhere"
		},
		listPointOfSaleApplicationDevice:{
			filter:"PointOfSaleApplicationDeviceWhere",
			orderBy:"PointOfSaleApplicationDeviceOrderBy"
		},
		paginatePointOfSaleApplicationDevice:{
			filter:"PointOfSaleApplicationDeviceWhere",
			orderBy:"PointOfSaleApplicationDeviceOrderBy"
		},
		validateCreatePointOfSaleApplicationDevice:{
			data:"PointOfSaleApplicationDeviceCreateInput"
		},
		validateUpdatePointOfSaleApplicationDevice:{
			by:"PointOfSaleApplicationDeviceUniqueWhere",
			data:"PointOfSaleApplicationDeviceUpdateInput"
		},
		getPointOfSaleTerminal:{
			by:"PointOfSaleTerminalUniqueWhere",
			filter:"PointOfSaleTerminalWhere"
		},
		listPointOfSaleTerminal:{
			filter:"PointOfSaleTerminalWhere",
			orderBy:"PointOfSaleTerminalOrderBy"
		},
		paginatePointOfSaleTerminal:{
			filter:"PointOfSaleTerminalWhere",
			orderBy:"PointOfSaleTerminalOrderBy"
		},
		validateCreatePointOfSaleTerminal:{
			data:"PointOfSaleTerminalCreateInput"
		},
		validateUpdatePointOfSaleTerminal:{
			by:"PointOfSaleTerminalUniqueWhere",
			data:"PointOfSaleTerminalUpdateInput"
		},
		getPipelineStageSentiment:{
			by:"PipelineStageSentimentUniqueWhere",
			filter:"PipelineStageSentimentWhere"
		},
		listPipelineStageSentiment:{
			filter:"PipelineStageSentimentWhere",
			orderBy:"PipelineStageSentimentOrderBy"
		},
		paginatePipelineStageSentiment:{
			filter:"PipelineStageSentimentWhere",
			orderBy:"PipelineStageSentimentOrderBy"
		},
		validateCreatePipelineStageSentiment:{
			data:"PipelineStageSentimentCreateInput"
		},
		validateUpdatePipelineStageSentiment:{
			by:"PipelineStageSentimentUniqueWhere",
			data:"PipelineStageSentimentUpdateInput"
		},
		getDeviceIdentifier:{
			by:"DeviceIdentifierUniqueWhere",
			filter:"DeviceIdentifierWhere"
		},
		listDeviceIdentifier:{
			filter:"DeviceIdentifierWhere",
			orderBy:"DeviceIdentifierOrderBy"
		},
		paginateDeviceIdentifier:{
			filter:"DeviceIdentifierWhere",
			orderBy:"DeviceIdentifierOrderBy"
		},
		validateCreateDeviceIdentifier:{
			data:"DeviceIdentifierCreateInput"
		},
		validateUpdateDeviceIdentifier:{
			by:"DeviceIdentifierUniqueWhere",
			data:"DeviceIdentifierUpdateInput"
		},
		getDeviceIdentifierMetadata:{
			by:"DeviceIdentifierMetadataUniqueWhere",
			filter:"DeviceIdentifierMetadataWhere"
		},
		listDeviceIdentifierMetadata:{
			filter:"DeviceIdentifierMetadataWhere",
			orderBy:"DeviceIdentifierMetadataOrderBy"
		},
		paginateDeviceIdentifierMetadata:{
			filter:"DeviceIdentifierMetadataWhere",
			orderBy:"DeviceIdentifierMetadataOrderBy"
		},
		getPointOfSalePrinter:{
			by:"PointOfSalePrinterUniqueWhere",
			filter:"PointOfSalePrinterWhere"
		},
		listPointOfSalePrinter:{
			filter:"PointOfSalePrinterWhere",
			orderBy:"PointOfSalePrinterOrderBy"
		},
		paginatePointOfSalePrinter:{
			filter:"PointOfSalePrinterWhere",
			orderBy:"PointOfSalePrinterOrderBy"
		},
		validateCreatePointOfSalePrinter:{
			data:"PointOfSalePrinterCreateInput"
		},
		validateUpdatePointOfSalePrinter:{
			by:"PointOfSalePrinterUniqueWhere",
			data:"PointOfSalePrinterUpdateInput"
		},
		getGratuity:{
			by:"GratuityUniqueWhere",
			filter:"GratuityWhere"
		},
		listGratuity:{
			filter:"GratuityWhere",
			orderBy:"GratuityOrderBy"
		},
		paginateGratuity:{
			filter:"GratuityWhere",
			orderBy:"GratuityOrderBy"
		},
		validateCreateGratuity:{
			data:"GratuityCreateInput"
		},
		validateUpdateGratuity:{
			by:"GratuityUniqueWhere",
			data:"GratuityUpdateInput"
		},
		getFulfillmentNote:{
			by:"FulfillmentNoteUniqueWhere",
			filter:"FulfillmentNoteWhere"
		},
		listFulfillmentNote:{
			filter:"FulfillmentNoteWhere",
			orderBy:"FulfillmentNoteOrderBy"
		},
		paginateFulfillmentNote:{
			filter:"FulfillmentNoteWhere",
			orderBy:"FulfillmentNoteOrderBy"
		},
		validateCreateFulfillmentNote:{
			data:"FulfillmentNoteCreateInput"
		},
		validateUpdateFulfillmentNote:{
			by:"FulfillmentNoteUniqueWhere",
			data:"FulfillmentNoteUpdateInput"
		},
		getCustomerMetadata:{
			by:"CustomerMetadataUniqueWhere",
			filter:"CustomerMetadataWhere"
		},
		listCustomerMetadata:{
			filter:"CustomerMetadataWhere",
			orderBy:"CustomerMetadataOrderBy"
		},
		paginateCustomerMetadata:{
			filter:"CustomerMetadataWhere",
			orderBy:"CustomerMetadataOrderBy"
		},
		getLeadForm:{
			by:"LeadFormUniqueWhere",
			filter:"LeadFormWhere"
		},
		listLeadForm:{
			filter:"LeadFormWhere",
			orderBy:"LeadFormOrderBy"
		},
		paginateLeadForm:{
			filter:"LeadFormWhere",
			orderBy:"LeadFormOrderBy"
		},
		validateCreateLeadForm:{
			data:"LeadFormCreateInput"
		},
		validateUpdateLeadForm:{
			by:"LeadFormUniqueWhere",
			data:"LeadFormUpdateInput"
		},
		getSubscriptionBox:{
			by:"SubscriptionBoxUniqueWhere",
			filter:"SubscriptionBoxWhere"
		},
		listSubscriptionBox:{
			filter:"SubscriptionBoxWhere",
			orderBy:"SubscriptionBoxOrderBy"
		},
		paginateSubscriptionBox:{
			filter:"SubscriptionBoxWhere",
			orderBy:"SubscriptionBoxOrderBy"
		},
		validateCreateSubscriptionBox:{
			data:"SubscriptionBoxCreateInput"
		},
		validateUpdateSubscriptionBox:{
			by:"SubscriptionBoxUniqueWhere",
			data:"SubscriptionBoxUpdateInput"
		},
		getSubscriptionBoxLocale:{
			by:"SubscriptionBoxLocaleUniqueWhere",
			filter:"SubscriptionBoxLocaleWhere"
		},
		listSubscriptionBoxLocale:{
			filter:"SubscriptionBoxLocaleWhere",
			orderBy:"SubscriptionBoxLocaleOrderBy"
		},
		paginateSubscriptionBoxLocale:{
			filter:"SubscriptionBoxLocaleWhere",
			orderBy:"SubscriptionBoxLocaleOrderBy"
		},
		validateCreateSubscriptionBoxLocale:{
			data:"SubscriptionBoxLocaleCreateInput"
		},
		validateUpdateSubscriptionBoxLocale:{
			by:"SubscriptionBoxLocaleUniqueWhere",
			data:"SubscriptionBoxLocaleUpdateInput"
		},
		getTimetableDayMetadata:{
			by:"TimetableDayMetadataUniqueWhere",
			filter:"TimetableDayMetadataWhere"
		},
		listTimetableDayMetadata:{
			filter:"TimetableDayMetadataWhere",
			orderBy:"TimetableDayMetadataOrderBy"
		},
		paginateTimetableDayMetadata:{
			filter:"TimetableDayMetadataWhere",
			orderBy:"TimetableDayMetadataOrderBy"
		},
		getBusinessService:{
			by:"BusinessServiceUniqueWhere",
			filter:"BusinessServiceWhere"
		},
		listBusinessService:{
			filter:"BusinessServiceWhere",
			orderBy:"BusinessServiceOrderBy"
		},
		paginateBusinessService:{
			filter:"BusinessServiceWhere",
			orderBy:"BusinessServiceOrderBy"
		},
		validateCreateBusinessService:{
			data:"BusinessServiceCreateInput"
		},
		validateUpdateBusinessService:{
			by:"BusinessServiceUniqueWhere",
			data:"BusinessServiceUpdateInput"
		},
		getBusinessServiceEvent:{
			by:"BusinessServiceEventUniqueWhere",
			filter:"BusinessServiceEventWhere"
		},
		listBusinessServiceEvent:{
			filter:"BusinessServiceEventWhere",
			orderBy:"BusinessServiceEventOrderBy"
		},
		paginateBusinessServiceEvent:{
			filter:"BusinessServiceEventWhere",
			orderBy:"BusinessServiceEventOrderBy"
		},
		validateCreateBusinessServiceEvent:{
			data:"BusinessServiceEventCreateInput"
		},
		validateUpdateBusinessServiceEvent:{
			by:"BusinessServiceEventUniqueWhere",
			data:"BusinessServiceEventUpdateInput"
		},
		getBusinessServiceLocale:{
			by:"BusinessServiceLocaleUniqueWhere",
			filter:"BusinessServiceLocaleWhere"
		},
		listBusinessServiceLocale:{
			filter:"BusinessServiceLocaleWhere",
			orderBy:"BusinessServiceLocaleOrderBy"
		},
		paginateBusinessServiceLocale:{
			filter:"BusinessServiceLocaleWhere",
			orderBy:"BusinessServiceLocaleOrderBy"
		},
		validateCreateBusinessServiceLocale:{
			data:"BusinessServiceLocaleCreateInput"
		},
		validateUpdateBusinessServiceLocale:{
			by:"BusinessServiceLocaleUniqueWhere",
			data:"BusinessServiceLocaleUpdateInput"
		},
		getGridTileItem:{
			by:"GridTileItemUniqueWhere",
			filter:"GridTileItemWhere"
		},
		listGridTileItem:{
			filter:"GridTileItemWhere",
			orderBy:"GridTileItemOrderBy"
		},
		paginateGridTileItem:{
			filter:"GridTileItemWhere",
			orderBy:"GridTileItemOrderBy"
		},
		validateCreateGridTileItem:{
			data:"GridTileItemCreateInput"
		},
		validateUpdateGridTileItem:{
			by:"GridTileItemUniqueWhere",
			data:"GridTileItemUpdateInput"
		},
		getGridTiles:{
			by:"GridTilesUniqueWhere",
			filter:"GridTilesWhere"
		},
		listGridTiles:{
			filter:"GridTilesWhere",
			orderBy:"GridTilesOrderBy"
		},
		paginateGridTiles:{
			filter:"GridTilesWhere",
			orderBy:"GridTilesOrderBy"
		},
		validateCreateGridTiles:{
			data:"GridTilesCreateInput"
		},
		validateUpdateGridTiles:{
			by:"GridTilesUniqueWhere",
			data:"GridTilesUpdateInput"
		},
		getArea:{
			by:"AreaUniqueWhere",
			filter:"AreaWhere"
		},
		listArea:{
			filter:"AreaWhere",
			orderBy:"AreaOrderBy"
		},
		paginateArea:{
			filter:"AreaWhere",
			orderBy:"AreaOrderBy"
		},
		validateCreateArea:{
			data:"AreaCreateInput"
		},
		validateUpdateArea:{
			by:"AreaUniqueWhere",
			data:"AreaUpdateInput"
		},
		getPosition:{
			by:"PositionUniqueWhere",
			filter:"PositionWhere"
		},
		listPosition:{
			filter:"PositionWhere",
			orderBy:"PositionOrderBy"
		},
		paginatePosition:{
			filter:"PositionWhere",
			orderBy:"PositionOrderBy"
		},
		validateCreatePosition:{
			data:"PositionCreateInput"
		},
		validateUpdatePosition:{
			by:"PositionUniqueWhere",
			data:"PositionUpdateInput"
		},
		getStatsEnabledWidgetType:{
			by:"StatsEnabledWidgetTypeUniqueWhere",
			filter:"StatsEnabledWidgetTypeWhere"
		},
		listStatsEnabledWidgetType:{
			filter:"StatsEnabledWidgetTypeWhere",
			orderBy:"StatsEnabledWidgetTypeOrderBy"
		},
		paginateStatsEnabledWidgetType:{
			filter:"StatsEnabledWidgetTypeWhere",
			orderBy:"StatsEnabledWidgetTypeOrderBy"
		},
		validateCreateStatsEnabledWidgetType:{
			data:"StatsEnabledWidgetTypeCreateInput"
		},
		validateUpdateStatsEnabledWidgetType:{
			by:"StatsEnabledWidgetTypeUniqueWhere",
			data:"StatsEnabledWidgetTypeUpdateInput"
		},
		getStatsWidget:{
			by:"StatsWidgetUniqueWhere",
			filter:"StatsWidgetWhere"
		},
		listStatsWidget:{
			filter:"StatsWidgetWhere",
			orderBy:"StatsWidgetOrderBy"
		},
		paginateStatsWidget:{
			filter:"StatsWidgetWhere",
			orderBy:"StatsWidgetOrderBy"
		},
		validateCreateStatsWidget:{
			data:"StatsWidgetCreateInput"
		},
		validateUpdateStatsWidget:{
			by:"StatsWidgetUniqueWhere",
			data:"StatsWidgetUpdateInput"
		},
		getStatsWidgetsLayout:{
			by:"StatsWidgetsLayoutUniqueWhere",
			filter:"StatsWidgetsLayoutWhere"
		},
		listStatsWidgetsLayout:{
			filter:"StatsWidgetsLayoutWhere",
			orderBy:"StatsWidgetsLayoutOrderBy"
		},
		paginateStatsWidgetsLayout:{
			filter:"StatsWidgetsLayoutWhere",
			orderBy:"StatsWidgetsLayoutOrderBy"
		},
		validateCreateStatsWidgetsLayout:{
			data:"StatsWidgetsLayoutCreateInput"
		},
		validateUpdateStatsWidgetsLayout:{
			by:"StatsWidgetsLayoutUniqueWhere",
			data:"StatsWidgetsLayoutUpdateInput"
		},
		getSeat:{
			by:"SeatUniqueWhere",
			filter:"SeatWhere"
		},
		listSeat:{
			filter:"SeatWhere",
			orderBy:"SeatOrderBy"
		},
		paginateSeat:{
			filter:"SeatWhere",
			orderBy:"SeatOrderBy"
		},
		validateCreateSeat:{
			data:"SeatCreateInput"
		},
		validateUpdateSeat:{
			by:"SeatUniqueWhere",
			data:"SeatUpdateInput"
		},
		getTable:{
			by:"TableUniqueWhere",
			filter:"TableWhere"
		},
		listTable:{
			filter:"TableWhere",
			orderBy:"TableOrderBy"
		},
		paginateTable:{
			filter:"TableWhere",
			orderBy:"TableOrderBy"
		},
		validateCreateTable:{
			data:"TableCreateInput"
		},
		validateUpdateTable:{
			by:"TableUniqueWhere",
			data:"TableUpdateInput"
		},
		getStatsPage:{
			by:"StatsPageUniqueWhere",
			filter:"StatsPageWhere"
		},
		listStatsPage:{
			filter:"StatsPageWhere",
			orderBy:"StatsPageOrderBy"
		},
		paginateStatsPage:{
			filter:"StatsPageWhere",
			orderBy:"StatsPageOrderBy"
		},
		validateCreateStatsPage:{
			data:"StatsPageCreateInput"
		},
		validateUpdateStatsPage:{
			by:"StatsPageUniqueWhere",
			data:"StatsPageUpdateInput"
		},
		getUnassignReason:{
			by:"UnassignReasonUniqueWhere",
			filter:"UnassignReasonWhere"
		},
		listUnassignReason:{
			filter:"UnassignReasonWhere",
			orderBy:"UnassignReasonOrderBy"
		},
		paginateUnassignReason:{
			filter:"UnassignReasonWhere",
			orderBy:"UnassignReasonOrderBy"
		},
		validateCreateUnassignReason:{
			data:"UnassignReasonCreateInput"
		},
		validateUpdateUnassignReason:{
			by:"UnassignReasonUniqueWhere",
			data:"UnassignReasonUpdateInput"
		},
		getDoubleshotCoffeeEquipment:{
			by:"DoubleshotCoffeeEquipmentUniqueWhere",
			filter:"DoubleshotCoffeeEquipmentWhere"
		},
		listDoubleshotCoffeeEquipment:{
			filter:"DoubleshotCoffeeEquipmentWhere",
			orderBy:"DoubleshotCoffeeEquipmentOrderBy"
		},
		paginateDoubleshotCoffeeEquipment:{
			filter:"DoubleshotCoffeeEquipmentWhere",
			orderBy:"DoubleshotCoffeeEquipmentOrderBy"
		},
		validateCreateDoubleshotCoffeeEquipment:{
			data:"DoubleshotCoffeeEquipmentCreateInput"
		},
		validateUpdateDoubleshotCoffeeEquipment:{
			by:"DoubleshotCoffeeEquipmentUniqueWhere",
			data:"DoubleshotCoffeeEquipmentUpdateInput"
		},
		getExpense:{
			by:"ExpenseUniqueWhere",
			filter:"ExpenseWhere"
		},
		listExpense:{
			filter:"ExpenseWhere",
			orderBy:"ExpenseOrderBy"
		},
		paginateExpense:{
			filter:"ExpenseWhere",
			orderBy:"ExpenseOrderBy"
		},
		validateCreateExpense:{
			data:"ExpenseCreateInput"
		},
		validateUpdateExpense:{
			by:"ExpenseUniqueWhere",
			data:"ExpenseUpdateInput"
		},
		getExpenseCategory:{
			by:"ExpenseCategoryUniqueWhere",
			filter:"ExpenseCategoryWhere"
		},
		listExpenseCategory:{
			filter:"ExpenseCategoryWhere",
			orderBy:"ExpenseCategoryOrderBy"
		},
		paginateExpenseCategory:{
			filter:"ExpenseCategoryWhere",
			orderBy:"ExpenseCategoryOrderBy"
		},
		validateCreateExpenseCategory:{
			data:"ExpenseCategoryCreateInput"
		},
		validateUpdateExpenseCategory:{
			by:"ExpenseCategoryUniqueWhere",
			data:"ExpenseCategoryUpdateInput"
		},
		getExpenseChange:{
			by:"ExpenseChangeUniqueWhere",
			filter:"ExpenseChangeWhere"
		},
		listExpenseChange:{
			filter:"ExpenseChangeWhere",
			orderBy:"ExpenseChangeOrderBy"
		},
		paginateExpenseChange:{
			filter:"ExpenseChangeWhere",
			orderBy:"ExpenseChangeOrderBy"
		},
		validateCreateExpenseChange:{
			data:"ExpenseChangeCreateInput"
		},
		validateUpdateExpenseChange:{
			by:"ExpenseChangeUniqueWhere",
			data:"ExpenseChangeUpdateInput"
		},
		getExpenseDocument:{
			by:"ExpenseDocumentUniqueWhere",
			filter:"ExpenseDocumentWhere"
		},
		listExpenseDocument:{
			filter:"ExpenseDocumentWhere",
			orderBy:"ExpenseDocumentOrderBy"
		},
		paginateExpenseDocument:{
			filter:"ExpenseDocumentWhere",
			orderBy:"ExpenseDocumentOrderBy"
		},
		validateCreateExpenseDocument:{
			data:"ExpenseDocumentCreateInput"
		},
		validateUpdateExpenseDocument:{
			by:"ExpenseDocumentUniqueWhere",
			data:"ExpenseDocumentUpdateInput"
		},
		getRevenuePrediction:{
			by:"RevenuePredictionUniqueWhere",
			filter:"RevenuePredictionWhere"
		},
		listRevenuePrediction:{
			filter:"RevenuePredictionWhere",
			orderBy:"RevenuePredictionOrderBy"
		},
		paginateRevenuePrediction:{
			filter:"RevenuePredictionWhere",
			orderBy:"RevenuePredictionOrderBy"
		},
		validateCreateRevenuePrediction:{
			data:"RevenuePredictionCreateInput"
		},
		validateUpdateRevenuePrediction:{
			by:"RevenuePredictionUniqueWhere",
			data:"RevenuePredictionUpdateInput"
		},
		getRevenuePredictionChange:{
			by:"RevenuePredictionChangeUniqueWhere",
			filter:"RevenuePredictionChangeWhere"
		},
		listRevenuePredictionChange:{
			filter:"RevenuePredictionChangeWhere",
			orderBy:"RevenuePredictionChangeOrderBy"
		},
		paginateRevenuePredictionChange:{
			filter:"RevenuePredictionChangeWhere",
			orderBy:"RevenuePredictionChangeOrderBy"
		},
		validateCreateRevenuePredictionChange:{
			data:"RevenuePredictionChangeCreateInput"
		},
		validateUpdateRevenuePredictionChange:{
			by:"RevenuePredictionChangeUniqueWhere",
			data:"RevenuePredictionChangeUpdateInput"
		},
		getFile:{
			by:"FileUniqueWhere",
			filter:"FileWhere"
		},
		listFile:{
			filter:"FileWhere",
			orderBy:"FileOrderBy"
		},
		paginateFile:{
			filter:"FileWhere",
			orderBy:"FileOrderBy"
		},
		validateCreateFile:{
			data:"FileCreateInput"
		},
		validateUpdateFile:{
			by:"FileUniqueWhere",
			data:"FileUpdateInput"
		},
		getExpenseTerm:{
			by:"ExpenseTermUniqueWhere",
			filter:"ExpenseTermWhere"
		},
		listExpenseTerm:{
			filter:"ExpenseTermWhere",
			orderBy:"ExpenseTermOrderBy"
		},
		paginateExpenseTerm:{
			filter:"ExpenseTermWhere",
			orderBy:"ExpenseTermOrderBy"
		},
		getLine:{
			by:"LineUniqueWhere",
			filter:"LineWhere"
		},
		listLine:{
			filter:"LineWhere",
			orderBy:"LineOrderBy"
		},
		paginateLine:{
			filter:"LineWhere",
			orderBy:"LineOrderBy"
		},
		validateCreateLine:{
			data:"LineCreateInput"
		},
		validateUpdateLine:{
			by:"LineUniqueWhere",
			data:"LineUpdateInput"
		},
		getFinancesBalanceItem:{
			by:"FinancesBalanceItemUniqueWhere",
			filter:"FinancesBalanceItemWhere"
		},
		listFinancesBalanceItem:{
			filter:"FinancesBalanceItemWhere",
			orderBy:"FinancesBalanceItemOrderBy"
		},
		paginateFinancesBalanceItem:{
			filter:"FinancesBalanceItemWhere",
			orderBy:"FinancesBalanceItemOrderBy"
		},
		validateCreateFinancesBalanceItem:{
			data:"FinancesBalanceItemCreateInput"
		},
		validateUpdateFinancesBalanceItem:{
			by:"FinancesBalanceItemUniqueWhere",
			data:"FinancesBalanceItemUpdateInput"
		},
		getRevenuePredictionTerm:{
			by:"RevenuePredictionTermUniqueWhere",
			filter:"RevenuePredictionTermWhere"
		},
		listRevenuePredictionTerm:{
			filter:"RevenuePredictionTermWhere",
			orderBy:"RevenuePredictionTermOrderBy"
		},
		paginateRevenuePredictionTerm:{
			filter:"RevenuePredictionTermWhere",
			orderBy:"RevenuePredictionTermOrderBy"
		},
		getOrderPaymentStatsByDay:{
			by:"OrderPaymentStatsByDayUniqueWhere",
			filter:"OrderPaymentStatsByDayWhere"
		},
		listOrderPaymentStatsByDay:{
			filter:"OrderPaymentStatsByDayWhere",
			orderBy:"OrderPaymentStatsByDayOrderBy"
		},
		paginateOrderPaymentStatsByDay:{
			filter:"OrderPaymentStatsByDayWhere",
			orderBy:"OrderPaymentStatsByDayOrderBy"
		},
		getWoltDriveDelivery:{
			by:"WoltDriveDeliveryUniqueWhere",
			filter:"WoltDriveDeliveryWhere"
		},
		listWoltDriveDelivery:{
			filter:"WoltDriveDeliveryWhere",
			orderBy:"WoltDriveDeliveryOrderBy"
		},
		paginateWoltDriveDelivery:{
			filter:"WoltDriveDeliveryWhere",
			orderBy:"WoltDriveDeliveryOrderBy"
		},
		validateCreateWoltDriveDelivery:{
			data:"WoltDriveDeliveryCreateInput"
		},
		validateUpdateWoltDriveDelivery:{
			by:"WoltDriveDeliveryUniqueWhere",
			data:"WoltDriveDeliveryUpdateInput"
		}
	},
	Address:{
		customer:{
			filter:"CustomerWhere"
		},
		country:{
			filter:"CountryWhere"
		},
		deliveryZone:{
			filter:"DeliveryZoneWhere"
		},
		meta:{
			filter:"AddressMetadataWhere"
		},
		gps:{
			filter:"GpsWhere"
		},
		invoices:{
			filter:"InvoiceWhere",
			orderBy:"InvoiceOrderBy"
		},
		billingAddressOfOrders:{
			filter:"OrderWhere",
			orderBy:"OrderOrderBy"
		},
		deliveryAddressOfOrderDeliveries:{
			filter:"OrderDeliveryWhere",
			orderBy:"OrderDeliveryOrderBy"
		},
		defaultDeliveryAddressOfCustomer:{
			filter:"CustomerWhere"
		},
		invoicesByPublicKey:{
			by:"AddressInvoicesByPublicKeyUniqueWhere",
			filter:"InvoiceWhere"
		},
		invoicesByFakturoidId:{
			by:"AddressInvoicesByFakturoidIdUniqueWhere",
			filter:"InvoiceWhere"
		},
		invoicesByOrderPayments:{
			by:"AddressInvoicesByOrderPaymentsUniqueWhere",
			filter:"InvoiceWhere"
		},
		billingAddressOfOrdersBySeq:{
			by:"AddressBillingAddressOfOrdersBySeqUniqueWhere",
			filter:"OrderWhere"
		},
		billingAddressOfOrdersByDoubleshotLegacyId:{
			by:"AddressBillingAddressOfOrdersByDoubleshotLegacyIdUniqueWhere",
			filter:"OrderWhere"
		},
		billingAddressOfOrdersByDoubleShotLegacyNumber:{
			by:"AddressBillingAddressOfOrdersByDoubleShotLegacyNumberUniqueWhere",
			filter:"OrderWhere"
		},
		billingAddressOfOrdersByDiscounts:{
			by:"AddressBillingAddressOfOrdersByDiscountsUniqueWhere",
			filter:"OrderWhere"
		},
		billingAddressOfOrdersByDelivery:{
			by:"AddressBillingAddressOfOrdersByDeliveryUniqueWhere",
			filter:"OrderWhere"
		},
		billingAddressOfOrdersByItems:{
			by:"AddressBillingAddressOfOrdersByItemsUniqueWhere",
			filter:"OrderWhere"
		},
		billingAddressOfOrdersByCart:{
			by:"AddressBillingAddressOfOrdersByCartUniqueWhere",
			filter:"OrderWhere"
		},
		billingAddressOfOrdersByEvents:{
			by:"AddressBillingAddressOfOrdersByEventsUniqueWhere",
			filter:"OrderWhere"
		},
		billingAddressOfOrdersByPriceLines:{
			by:"AddressBillingAddressOfOrdersByPriceLinesUniqueWhere",
			filter:"OrderWhere"
		},
		billingAddressOfOrdersByPayments:{
			by:"AddressBillingAddressOfOrdersByPaymentsUniqueWhere",
			filter:"OrderWhere"
		},
		billingAddressOfOrdersBySummary:{
			by:"AddressBillingAddressOfOrdersBySummaryUniqueWhere",
			filter:"OrderWhere"
		},
		billingAddressOfOrdersByGratuity:{
			by:"AddressBillingAddressOfOrdersByGratuityUniqueWhere",
			filter:"OrderWhere"
		},
		deliveryAddressOfOrderDeliveriesByTrackingCode:{
			by:"AddressDeliveryAddressOfOrderDeliveriesByTrackingCodeUniqueWhere",
			filter:"OrderDeliveryWhere"
		},
		deliveryAddressOfOrderDeliveriesByOrder:{
			by:"AddressDeliveryAddressOfOrderDeliveriesByOrderUniqueWhere",
			filter:"OrderDeliveryWhere"
		},
		deliveryAddressOfOrderDeliveriesByDeliveryWaypoint:{
			by:"AddressDeliveryAddressOfOrderDeliveriesByDeliveryWaypointUniqueWhere",
			filter:"OrderDeliveryWhere"
		},
		deliveryAddressOfOrderDeliveriesByEvents:{
			by:"AddressDeliveryAddressOfOrderDeliveriesByEventsUniqueWhere",
			filter:"OrderDeliveryWhere"
		},
		deliveryAddressOfOrderDeliveriesByLiftagoRide:{
			by:"AddressDeliveryAddressOfOrderDeliveriesByLiftagoRideUniqueWhere",
			filter:"OrderDeliveryWhere"
		},
		deliveryAddressOfOrderDeliveriesByWoltDriveDelivery:{
			by:"AddressDeliveryAddressOfOrderDeliveriesByWoltDriveDeliveryUniqueWhere",
			filter:"OrderDeliveryWhere"
		},
		paginateInvoices:{
			filter:"InvoiceWhere",
			orderBy:"InvoiceOrderBy"
		},
		paginateBillingAddressOfOrders:{
			filter:"OrderWhere",
			orderBy:"OrderOrderBy"
		},
		paginateDeliveryAddressOfOrderDeliveries:{
			filter:"OrderDeliveryWhere",
			orderBy:"OrderDeliveryOrderBy"
		}
	},
	UUID: "String",
	Customer:{
		addresses:{
			filter:"AddressWhere",
			orderBy:"AddressOrderBy"
		},
		defaultBillingAddress:{
			filter:"AddressWhere"
		},
		defaultPaymentMethod:{
			filter:"CustomerPaymentMethodWhere"
		},
		tags:{
			filter:"TagWhere",
			orderBy:"TagOrderBy"
		},
		credits:{
			filter:"CustomerCreditWhere",
			orderBy:"CustomerCreditOrderBy"
		},
		paymentMethods:{
			filter:"CustomerPaymentMethodWhere",
			orderBy:"CustomerPaymentMethodOrderBy"
		},
		orders:{
			filter:"OrderWhere",
			orderBy:"OrderOrderBy"
		},
		permissions:{
			filter:"CustomerPermissionsWhere"
		},
		group:{
			filter:"CustomerGroupWhere"
		},
		photo:{
			filter:"ImageWhere"
		},
		name:{
			filter:"CustomerNameWhere"
		},
		ingredientRatings:{
			filter:"CustomerIngredientRatingWhere",
			orderBy:"CustomerIngredientRatingOrderBy"
		},
		business:{
			filter:"BusinessCustomerWhere"
		},
		ownerOfBusinesses:{
			filter:"BusinessCustomerWhere",
			orderBy:"BusinessCustomerOrderBy"
		},
		memberOfBusinesses:{
			filter:"BusinessCustomerWhere",
			orderBy:"BusinessCustomerOrderBy"
		},
		carts:{
			filter:"CartWhere",
			orderBy:"CartOrderBy"
		},
		shortcutList:{
			filter:"ApplicationShortcutListWhere"
		},
		user:{
			filter:"UserWhere"
		},
		channels:{
			filter:"ChannelWhere",
			orderBy:"ChannelOrderBy"
		},
		invoices:{
			filter:"InvoiceWhere",
			orderBy:"InvoiceOrderBy"
		},
		invoicingPlan:{
			filter:"InvoicingPlanWhere"
		},
		billingSubjects:{
			filter:"BillingSubjectWhere",
			orderBy:"BillingSubjectOrderBy"
		},
		offeredProducts:{
			filter:"ProductCustomerPriceWhere",
			orderBy:"ProductCustomerPriceOrderBy"
		},
		defaultDeliveryAddress:{
			filter:"AddressWhere"
		},
		defaultBillingSubject:{
			filter:"BillingSubjectWhere"
		},
		anonymousSession:{
			filter:"AnonymousSessionWhere"
		},
		boughtVouchers:{
			filter:"VoucherWhere",
			orderBy:"VoucherOrderBy"
		},
		ownsVouchers:{
			filter:"VoucherWhere",
			orderBy:"VoucherOrderBy"
		},
		redeemedVouchers:{
			filter:"VoucherRedemptionWhere",
			orderBy:"VoucherRedemptionOrderBy"
		},
		spending:{
			filter:"CustomerSpendingWhere"
		},
		customerTabs:{
			filter:"CustomerTabWhere",
			orderBy:"CustomerTabOrderBy"
		},
		lead:{
			filter:"PipelineLeadWhere",
			orderBy:"PipelineLeadOrderBy"
		},
		meta:{
			filter:"CustomerMetadataWhere"
		},
		addressesByMeta:{
			by:"CustomerAddressesByMetaUniqueWhere",
			filter:"AddressWhere"
		},
		addressesByGps:{
			by:"CustomerAddressesByGpsUniqueWhere",
			filter:"AddressWhere"
		},
		addressesByInvoices:{
			by:"CustomerAddressesByInvoicesUniqueWhere",
			filter:"AddressWhere"
		},
		addressesByBillingAddressOfOrders:{
			by:"CustomerAddressesByBillingAddressOfOrdersUniqueWhere",
			filter:"AddressWhere"
		},
		addressesByDeliveryAddressOfOrderDeliveries:{
			by:"CustomerAddressesByDeliveryAddressOfOrderDeliveriesUniqueWhere",
			filter:"AddressWhere"
		},
		addressesByDefaultDeliveryAddressOfCustomer:{
			by:"CustomerAddressesByDefaultDeliveryAddressOfCustomerUniqueWhere",
			filter:"AddressWhere"
		},
		creditsByTransactions:{
			by:"CustomerCreditsByTransactionsUniqueWhere",
			filter:"CustomerCreditWhere"
		},
		creditsByVoucherRedemption:{
			by:"CustomerCreditsByVoucherRedemptionUniqueWhere",
			filter:"CustomerCreditWhere"
		},
		ordersBySeq:{
			by:"CustomerOrdersBySeqUniqueWhere",
			filter:"OrderWhere"
		},
		ordersByDoubleshotLegacyId:{
			by:"CustomerOrdersByDoubleshotLegacyIdUniqueWhere",
			filter:"OrderWhere"
		},
		ordersByDoubleShotLegacyNumber:{
			by:"CustomerOrdersByDoubleShotLegacyNumberUniqueWhere",
			filter:"OrderWhere"
		},
		ordersByDiscounts:{
			by:"CustomerOrdersByDiscountsUniqueWhere",
			filter:"OrderWhere"
		},
		ordersByDelivery:{
			by:"CustomerOrdersByDeliveryUniqueWhere",
			filter:"OrderWhere"
		},
		ordersByItems:{
			by:"CustomerOrdersByItemsUniqueWhere",
			filter:"OrderWhere"
		},
		ordersByCart:{
			by:"CustomerOrdersByCartUniqueWhere",
			filter:"OrderWhere"
		},
		ordersByEvents:{
			by:"CustomerOrdersByEventsUniqueWhere",
			filter:"OrderWhere"
		},
		ordersByPriceLines:{
			by:"CustomerOrdersByPriceLinesUniqueWhere",
			filter:"OrderWhere"
		},
		ordersByPayments:{
			by:"CustomerOrdersByPaymentsUniqueWhere",
			filter:"OrderWhere"
		},
		ordersBySummary:{
			by:"CustomerOrdersBySummaryUniqueWhere",
			filter:"OrderWhere"
		},
		ordersByGratuity:{
			by:"CustomerOrdersByGratuityUniqueWhere",
			filter:"OrderWhere"
		},
		ingredientRatingsByIngredient:{
			by:"CustomerIngredientRatingsByIngredientUniqueWhere",
			filter:"CustomerIngredientRatingWhere"
		},
		cartsByItems:{
			by:"CustomerCartsByItemsUniqueWhere",
			filter:"CartWhere"
		},
		cartsByOrder:{
			by:"CustomerCartsByOrderUniqueWhere",
			filter:"CartWhere"
		},
		cartsByPriceLines:{
			by:"CustomerCartsByPriceLinesUniqueWhere",
			filter:"CartWhere"
		},
		cartsBySummary:{
			by:"CustomerCartsBySummaryUniqueWhere",
			filter:"CartWhere"
		},
		invoicesByPublicKey:{
			by:"CustomerInvoicesByPublicKeyUniqueWhere",
			filter:"InvoiceWhere"
		},
		invoicesByFakturoidId:{
			by:"CustomerInvoicesByFakturoidIdUniqueWhere",
			filter:"InvoiceWhere"
		},
		invoicesByOrderPayments:{
			by:"CustomerInvoicesByOrderPaymentsUniqueWhere",
			filter:"InvoiceWhere"
		},
		billingSubjectsByInvoices:{
			by:"CustomerBillingSubjectsByInvoicesUniqueWhere",
			filter:"BillingSubjectWhere"
		},
		billingSubjectsByDefaultBillingSubjectOfCustomer:{
			by:"CustomerBillingSubjectsByDefaultBillingSubjectOfCustomerUniqueWhere",
			filter:"BillingSubjectWhere"
		},
		billingSubjectsByOrders:{
			by:"CustomerBillingSubjectsByOrdersUniqueWhere",
			filter:"BillingSubjectWhere"
		},
		offeredProductsByProduct:{
			by:"CustomerOfferedProductsByProductUniqueWhere",
			filter:"ProductCustomerPriceWhere"
		},
		boughtVouchersByCode:{
			by:"CustomerBoughtVouchersByCodeUniqueWhere",
			filter:"VoucherWhere"
		},
		boughtVouchersByRedemption:{
			by:"CustomerBoughtVouchersByRedemptionUniqueWhere",
			filter:"VoucherWhere"
		},
		ownsVouchersByCode:{
			by:"CustomerOwnsVouchersByCodeUniqueWhere",
			filter:"VoucherWhere"
		},
		ownsVouchersByRedemption:{
			by:"CustomerOwnsVouchersByRedemptionUniqueWhere",
			filter:"VoucherWhere"
		},
		redeemedVouchersByCustomerCredit:{
			by:"CustomerRedeemedVouchersByCustomerCreditUniqueWhere",
			filter:"VoucherRedemptionWhere"
		},
		redeemedVouchersByOrderDiscount:{
			by:"CustomerRedeemedVouchersByOrderDiscountUniqueWhere",
			filter:"VoucherRedemptionWhere"
		},
		redeemedVouchersByVoucher:{
			by:"CustomerRedeemedVouchersByVoucherUniqueWhere",
			filter:"VoucherRedemptionWhere"
		},
		customerTabsByItems:{
			by:"CustomerCustomerTabsByItemsUniqueWhere",
			filter:"CustomerTabWhere"
		},
		customerTabsByMeta:{
			by:"CustomerCustomerTabsByMetaUniqueWhere",
			filter:"CustomerTabWhere"
		},
		leadByStageItem:{
			by:"CustomerLeadByStageItemUniqueWhere",
			filter:"PipelineLeadWhere"
		},
		paginateAddresses:{
			filter:"AddressWhere",
			orderBy:"AddressOrderBy"
		},
		paginateTags:{
			filter:"TagWhere",
			orderBy:"TagOrderBy"
		},
		paginateCredits:{
			filter:"CustomerCreditWhere",
			orderBy:"CustomerCreditOrderBy"
		},
		paginatePaymentMethods:{
			filter:"CustomerPaymentMethodWhere",
			orderBy:"CustomerPaymentMethodOrderBy"
		},
		paginateOrders:{
			filter:"OrderWhere",
			orderBy:"OrderOrderBy"
		},
		paginateIngredientRatings:{
			filter:"CustomerIngredientRatingWhere",
			orderBy:"CustomerIngredientRatingOrderBy"
		},
		paginateOwnerOfBusinesses:{
			filter:"BusinessCustomerWhere",
			orderBy:"BusinessCustomerOrderBy"
		},
		paginateMemberOfBusinesses:{
			filter:"BusinessCustomerWhere",
			orderBy:"BusinessCustomerOrderBy"
		},
		paginateCarts:{
			filter:"CartWhere",
			orderBy:"CartOrderBy"
		},
		paginateChannels:{
			filter:"ChannelWhere",
			orderBy:"ChannelOrderBy"
		},
		paginateInvoices:{
			filter:"InvoiceWhere",
			orderBy:"InvoiceOrderBy"
		},
		paginateBillingSubjects:{
			filter:"BillingSubjectWhere",
			orderBy:"BillingSubjectOrderBy"
		},
		paginateOfferedProducts:{
			filter:"ProductCustomerPriceWhere",
			orderBy:"ProductCustomerPriceOrderBy"
		},
		paginateBoughtVouchers:{
			filter:"VoucherWhere",
			orderBy:"VoucherOrderBy"
		},
		paginateOwnsVouchers:{
			filter:"VoucherWhere",
			orderBy:"VoucherOrderBy"
		},
		paginateRedeemedVouchers:{
			filter:"VoucherRedemptionWhere",
			orderBy:"VoucherRedemptionOrderBy"
		},
		paginateCustomerTabs:{
			filter:"CustomerTabWhere",
			orderBy:"CustomerTabOrderBy"
		},
		paginateLead:{
			filter:"PipelineLeadWhere",
			orderBy:"PipelineLeadOrderBy"
		}
	},
	AddressWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		firstName:"StringCondition",
		lastName:"StringCondition",
		addressLine2:"StringCondition",
		email:"StringCondition",
		phone:"StringCondition",
		companyName:"StringCondition",
		companyIdentifier:"StringCondition",
		vatIdentifier:"StringCondition",
		externalIdentifier:"StringCondition",
		hidden:"BooleanCondition",
		customer:"CustomerWhere",
		internalNote:"StringCondition",
		country:"CountryWhere",
		deletedAt:"DateTimeCondition",
		note:"StringCondition",
		googlePlaceId:"StringCondition",
		raw:"StringCondition",
		formatted:"StringCondition",
		geocodeGeneratedAt:"DateTimeCondition",
		geocodeResponse:"StringCondition",
		deliveryZone:"DeliveryZoneWhere",
		meta:"AddressMetadataWhere",
		gps:"GpsWhere",
		geocodeValid:"BooleanCondition",
		fullName:"StringCondition",
		fakturoidSubjectId:"StringCondition",
		invoices:"InvoiceWhere",
		addressLine1:"StringCondition",
		city:"StringCondition",
		postalCode:"StringCondition",
		createdAt:"DateTimeCondition",
		billingAddressOfOrders:"OrderWhere",
		deliveryAddressOfOrderDeliveries:"OrderDeliveryWhere",
		defaultDeliveryAddressOfCustomer:"CustomerWhere",
		and:"AddressWhere",
		or:"AddressWhere",
		not:"AddressWhere"
	},
	UUIDCondition:{
		and:"UUIDCondition",
		or:"UUIDCondition",
		not:"UUIDCondition",
		eq:"UUID",
		notEq:"UUID",
		in:"UUID",
		notIn:"UUID",
		lt:"UUID",
		lte:"UUID",
		gt:"UUID",
		gte:"UUID"
	},
	StringCondition:{
		and:"StringCondition",
		or:"StringCondition",
		not:"StringCondition"
	},
	BooleanCondition:{
		and:"BooleanCondition",
		or:"BooleanCondition",
		not:"BooleanCondition"
	},
	CustomerWhere:{
		id:"UUIDCondition",
		addresses:"AddressWhere",
		defaultBillingAddress:"AddressWhere",
		defaultPaymentMethod:"CustomerPaymentMethodWhere",
		tags:"TagWhere",
		credits:"CustomerCreditWhere",
		paymentMethods:"CustomerPaymentMethodWhere",
		orders:"OrderWhere",
		permissions:"CustomerPermissionsWhere",
		group:"CustomerGroupWhere",
		photo:"ImageWhere",
		phone:"StringCondition",
		name:"CustomerNameWhere",
		internalNote:"StringCondition",
		welcomeMessage:"StringCondition",
		familiarity:"CustomerFamiliarityCondition",
		ingredientRatings:"CustomerIngredientRatingWhere",
		business:"BusinessCustomerWhere",
		ownerOfBusinesses:"BusinessCustomerWhere",
		memberOfBusinesses:"BusinessCustomerWhere",
		carts:"CartWhere",
		shortcutList:"ApplicationShortcutListWhere",
		user:"UserWhere",
		channels:"ChannelWhere",
		disabledAt:"DateTimeCondition",
		invoices:"InvoiceWhere",
		invoicingPlan:"InvoicingPlanWhere",
		email:"StringCondition",
		createdAt:"DateTimeCondition",
		billingSubjects:"BillingSubjectWhere",
		offeredProducts:"ProductCustomerPriceWhere",
		defaultDeliveryAddress:"AddressWhere",
		defaultBillingSubject:"BillingSubjectWhere",
		prefersPackingsWithoutCardboard:"BooleanCondition",
		anonymousSession:"AnonymousSessionWhere",
		boughtVouchers:"VoucherWhere",
		ownsVouchers:"VoucherWhere",
		redeemedVouchers:"VoucherRedemptionWhere",
		spending:"CustomerSpendingWhere",
		customerTabs:"CustomerTabWhere",
		lead:"PipelineLeadWhere",
		doubleshotLegacyId:"StringCondition",
		meta:"CustomerMetadataWhere",
		doubleshotLastUpdatedAt:"DateTimeCondition",
		and:"CustomerWhere",
		or:"CustomerWhere",
		not:"CustomerWhere"
	},
	CustomerPaymentMethodWhere:{
		id:"UUIDCondition",
		caption:"StringCondition",
		data:"JsonCondition",
		customer:"CustomerWhere",
		paymentMethod:"PaymentMethodWhere",
		and:"CustomerPaymentMethodWhere",
		or:"CustomerPaymentMethodWhere",
		not:"CustomerPaymentMethodWhere"
	},
	JsonCondition:{
		and:"JsonCondition",
		or:"JsonCondition",
		not:"JsonCondition"
	},
	PaymentMethodWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		code:"StringCondition",
		enabled:"BooleanCondition",
		deliveryMethods:"DeliveryMethodWhere",
		description:"StringCondition",
		internalNote:"StringCondition",
		blockingDispatch:"BooleanCondition",
		type:"PaymentMethodTypeCondition",
		channels:"ChannelPaymentWhere",
		reduceGratuityByPercentage:"IntCondition",
		and:"PaymentMethodWhere",
		or:"PaymentMethodWhere",
		not:"PaymentMethodWhere"
	},
	DeliveryMethodWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		code:"StringCondition",
		enabled:"BooleanCondition",
		paymentMethods:"PaymentMethodWhere",
		description:"StringCondition",
		internalNote:"StringCondition",
		requireDeliveryAddress:"BooleanCondition",
		suitableForDeliveryZones:"DeliveryZoneWhere",
		channels:"ChannelDeliveryWhere",
		courierHandlers:"CourierWhere",
		enableDeliveryTracking:"BooleanCondition",
		locales:"DeliveryMethodLocaleWhere",
		timelinePreset:"DeliveryTimelinePresetWhere",
		woltDriveVenueId:"StringCondition",
		and:"DeliveryMethodWhere",
		or:"DeliveryMethodWhere",
		not:"DeliveryMethodWhere"
	},
	DeliveryZoneWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		code:"StringCondition",
		description:"StringCondition",
		internalNote:"StringCondition",
		type:"DeliveryZoneTypeCondition",
		addresses:"AddressWhere",
		suitableDeliveryMethods:"DeliveryMethodWhere",
		deliveryZonesOfTags:"TagWhere",
		deliveryZonesOfProducts:"ProductWhere",
		addressesMetadata:"AddressMetadataWhere",
		and:"DeliveryZoneWhere",
		or:"DeliveryZoneWhere",
		not:"DeliveryZoneWhere"
	},
	DeliveryZoneTypeCondition:{
		and:"DeliveryZoneTypeCondition",
		or:"DeliveryZoneTypeCondition",
		not:"DeliveryZoneTypeCondition",
		eq:"DeliveryZoneType",
		notEq:"DeliveryZoneType",
		in:"DeliveryZoneType",
		notIn:"DeliveryZoneType",
		lt:"DeliveryZoneType",
		lte:"DeliveryZoneType",
		gt:"DeliveryZoneType",
		gte:"DeliveryZoneType"
	},
	DeliveryZoneType: true,
	TagWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		code:"StringCondition",
		customers:"CustomerWhere",
		products:"ProductWhere",
		categories:"ProductCategoryWhere",
		description:"StringCondition",
		internalNote:"StringCondition",
		addTagsOnRegistration:"ChannelWhere",
		nestedCategories:"InheritedProductCategoryTagWhere",
		deliveryZones:"DeliveryZoneWhere",
		publicInChannels:"ChannelWhere",
		allowChannelPayments:"ChannelPaymentWhere",
		fulfillmentNotes:"FulfillmentNoteWhere",
		and:"TagWhere",
		or:"TagWhere",
		not:"TagWhere"
	},
	ProductWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		code:"StringCondition",
		priceCents:"IntCondition",
		notDiscountable:"BooleanCondition",
		packing:"ProductPackingWhere",
		recipe:"ProductRecipeWhere",
		tags:"TagWhere",
		categories:"ProductCategoryWhere",
		vatRate:"VatRateWhere",
		stocks:"ProductStockWhere",
		groupPrices:"ProductGroupPriceWhere",
		image:"ImageWhere",
		description:"StringCondition",
		internalNote:"StringCondition",
		cartItems:"CartItemWhere",
		availability:"ProductAvailabilityCondition",
		order:"FloatCondition",
		manager:"StocksManagerWhere",
		orderItems:"OrderItemWhere",
		maximumQuantityPerOrder:"IntCondition",
		inheritedCategories:"NestedProductCategoryProductWhere",
		deliveryZones:"DeliveryZoneWhere",
		locales:"ProductLocaleWhere",
		archivedAt:"DateTimeCondition",
		customerPrices:"ProductCustomerPriceWhere",
		virtualProduct:"VirtualProductWhere",
		meta:"ProductMetadataWhere",
		page:"PageWhere",
		salesDays:"ProductSalesDayWhere",
		salesWeeks:"ProductSalesWeekWhere",
		salesMonths:"ProductSalesMonthWhere",
		fulfillmentNotes:"FulfillmentNoteWhere",
		hasSubscription:"BooleanCondition",
		pointOfSaleTileColor:"StringCondition",
		and:"ProductWhere",
		or:"ProductWhere",
		not:"ProductWhere"
	},
	IntCondition:{
		and:"IntCondition",
		or:"IntCondition",
		not:"IntCondition"
	},
	ProductPackingWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		image:"ImageWhere",
		description:"StringCondition",
		internalNote:"StringCondition",
		volumeMl:"IntCondition",
		icon:"ImageWhere",
		shortName:"StringCondition",
		locales:"ProductPackingLocaleWhere",
		preparedPackingQuantities:"PreparedPackingQuantityWhere",
		isPackedInCardboard:"BooleanCondition",
		and:"ProductPackingWhere",
		or:"ProductPackingWhere",
		not:"ProductPackingWhere"
	},
	ImageWhere:{
		id:"UUIDCondition",
		url:"StringCondition",
		width:"IntCondition",
		height:"IntCondition",
		size:"IntCondition",
		type:"StringCondition",
		alt:"StringCondition",
		and:"ImageWhere",
		or:"ImageWhere",
		not:"ImageWhere"
	},
	ProductPackingLocaleWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		shortName:"StringCondition",
		description:"StringCondition",
		root:"ProductPackingWhere",
		locale:"LocaleWhere",
		and:"ProductPackingLocaleWhere",
		or:"ProductPackingLocaleWhere",
		not:"ProductPackingLocaleWhere"
	},
	LocaleWhere:{
		id:"UUIDCondition",
		businessCategories:"BusinessCategoryLocaleWhere",
		productCategoryLists:"ProductCategoryListLocaleWhere",
		productIngredients:"ProductIngredientLocaleWhere",
		orderRecurrences:"OrderRecurrenceLocaleWhere",
		blogs:"BlogLocaleWhere",
		blogPosts:"BlogPostLocaleWhere",
		identifier:"TranslationCataloguesIdentifierWhere",
		menus:"MenuLocaleWhere",
		pages:"PageLocaleWhere",
		productIngredientCategories:"ProductIngredientCategoryLocaleWhere",
		allergens:"AllergenLocaleWhere",
		productPackings:"ProductPackingLocaleWhere",
		products:"ProductLocaleWhere",
		productRecipes:"ProductRecipeLocaleWhere",
		pointOfSaleCategories:"PointOfSaleCategoryLocaleWhere",
		pointOfSaleCategoryProducts:"PointOfSaleCategoryProductLocaleWhere",
		deliveryMethods:"DeliveryMethodLocaleWhere",
		ingredientSuppliers:"IngredientSupplierLocaleWhere",
		identificationCodes:"IdentificationCodeLocaleWhere",
		pipelineStages:"PipelineStageLocaleWhere",
		subscriptionBoxes:"SubscriptionBoxLocaleWhere",
		businessServices:"BusinessServiceLocaleWhere",
		and:"LocaleWhere",
		or:"LocaleWhere",
		not:"LocaleWhere"
	},
	BusinessCategoryLocaleWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		root:"BusinessCategoryWhere",
		locale:"LocaleWhere",
		title:"StringCondition",
		and:"BusinessCategoryLocaleWhere",
		or:"BusinessCategoryLocaleWhere",
		not:"BusinessCategoryLocaleWhere"
	},
	BusinessCategoryWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		visibleToNewCustomers:"BooleanCondition",
		locales:"BusinessCategoryLocaleWhere",
		internalName:"StringCondition",
		businessCustomers:"BusinessCustomerWhere",
		recurrences:"OrderRecurrenceWhere",
		specificProducts:"ProductListWhere",
		seasonalProductCategories:"ProductCategoryListWhere",
		specificProductsProductCategories:"ProductCategoryListWhere",
		slug:"StringCondition",
		and:"BusinessCategoryWhere",
		or:"BusinessCategoryWhere",
		not:"BusinessCategoryWhere"
	},
	BusinessCustomerWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		customer:"CustomerWhere",
		owners:"CustomerWhere",
		members:"CustomerWhere",
		category:"BusinessCategoryWhere",
		accountManager:"BusinessToBusinessManagerWhere",
		logo:"ImageWhere",
		note:"StringCondition",
		businessServiceEvents:"BusinessServiceEventWhere",
		doubleshotCoffeeEquipment:"DoubleshotCoffeeEquipmentWhere",
		and:"BusinessCustomerWhere",
		or:"BusinessCustomerWhere",
		not:"BusinessCustomerWhere"
	},
	BusinessToBusinessManagerWhere:{
		id:"UUIDCondition",
		staff:"StaffWhere",
		managedBusinesses:"BusinessCustomerWhere",
		createdAt:"DateTimeCondition",
		and:"BusinessToBusinessManagerWhere",
		or:"BusinessToBusinessManagerWhere",
		not:"BusinessToBusinessManagerWhere"
	},
	StaffWhere:{
		id:"UUIDCondition",
		bartender:"BartenderWhere",
		courier:"CourierWhere",
		cleaner:"CleanerWhere",
		shiftsManager:"ShiftsManagerWhere",
		businessToBusinessManager:"BusinessToBusinessManagerWhere",
		user:"UserWhere",
		shiftsProfile:"ShiftsProfileWhere",
		stocksManager:"StocksManagerWhere",
		photo:"ImageWhere",
		courierManager:"CourierManagerWhere",
		picker:"PickerWhere",
		createdAt:"DateTimeCondition",
		remunerationProfile:"RemunerationProfileWhere",
		cashier:"CashierWhere",
		venues:"VenueWhere",
		internalBuyer:"InternalBuyerWhere",
		salesManager:"SalesManagerWhere",
		cashierManager:"CashierManagerWhere",
		and:"StaffWhere",
		or:"StaffWhere",
		not:"StaffWhere"
	},
	BartenderWhere:{
		id:"UUIDCondition",
		staff:"StaffWhere",
		createdAt:"DateTimeCondition",
		and:"BartenderWhere",
		or:"BartenderWhere",
		not:"BartenderWhere"
	},
	DateTimeCondition:{
		and:"DateTimeCondition",
		or:"DateTimeCondition",
		not:"DateTimeCondition",
		eq:"DateTime",
		notEq:"DateTime",
		in:"DateTime",
		notIn:"DateTime",
		lt:"DateTime",
		lte:"DateTime",
		gt:"DateTime",
		gte:"DateTime"
	},
	DateTime: "String",
	CourierWhere:{
		id:"UUIDCondition",
		staff:"StaffWhere",
		routes:"DeliveryRouteWhere",
		createdAt:"DateTimeCondition",
		deliveryMethods:"DeliveryMethodWhere",
		showInPicker:"BooleanCondition",
		and:"CourierWhere",
		or:"CourierWhere",
		not:"CourierWhere"
	},
	DeliveryRouteWhere:{
		id:"UUIDCondition",
		courier:"CourierWhere",
		createdAt:"DateTimeCondition",
		waypoints:"DeliveryWaypointWhere",
		dispatchAt:"StringCondition",
		and:"DeliveryRouteWhere",
		or:"DeliveryRouteWhere",
		not:"DeliveryRouteWhere"
	},
	DeliveryWaypointWhere:{
		id:"UUIDCondition",
		estimatedArrival:"DateTimeCondition",
		note:"StringCondition",
		route:"DeliveryRouteWhere",
		sortingOrder:"IntCondition",
		delivery:"OrderDeliveryWhere",
		estimatedDistance:"IntCondition",
		estimatedDuration:"IntCondition",
		originDeparture:"DateTimeCondition",
		originAddress:"StringCondition",
		transitMode:"StringCondition",
		and:"DeliveryWaypointWhere",
		or:"DeliveryWaypointWhere",
		not:"DeliveryWaypointWhere"
	},
	OrderDeliveryWhere:{
		id:"UUIDCondition",
		priceCents:"IntCondition",
		deliveredAt:"DateTimeCondition",
		method:"DeliveryMethodWhere",
		vatRate:"VatRateWhere",
		order:"OrderWhere",
		expectedAt:"DateTimeCondition",
		state:"OrderDeliveryStateCondition",
		loadingDurationHours:"IntCondition",
		dispatchAt:"DateTimeCondition",
		duration:"StringCondition",
		window:"StringCondition",
		expectedEndAt:"DateTimeCondition",
		processingAt:"DateTimeCondition",
		deliveringAt:"DateTimeCondition",
		failedAt:"DateTimeCondition",
		internalNote:"StringCondition",
		deliveryWaypoint:"DeliveryWaypointWhere",
		events:"OrderEventWhere",
		prepareAt:"DateTimeCondition",
		liftagoRide:"LiftagoRideWhere",
		pickedAt:"DateTimeCondition",
		address:"AddressWhere",
		trackingCode:"StringCondition",
		woltDriveDelivery:"WoltDriveDeliveryWhere",
		and:"OrderDeliveryWhere",
		or:"OrderDeliveryWhere",
		not:"OrderDeliveryWhere"
	},
	VatRateWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		ratePermille:"IntCondition",
		description:"StringCondition",
		internalNote:"StringCondition",
		channelDeliveries:"ChannelDeliveryWhere",
		channelPayments:"ChannelPaymentWhere",
		preset:"VatRatePresetCondition",
		and:"VatRateWhere",
		or:"VatRateWhere",
		not:"VatRateWhere"
	},
	ChannelDeliveryWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		priceCents:"IntCondition",
		channel:"ChannelWhere",
		method:"DeliveryMethodWhere",
		vatRate:"VatRateWhere",
		defaultVisible:"BooleanCondition",
		and:"ChannelDeliveryWhere",
		or:"ChannelDeliveryWhere",
		not:"ChannelDeliveryWhere"
	},
	ChannelWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		disabled:"BooleanCondition",
		payments:"ChannelPaymentWhere",
		deliveries:"ChannelDeliveryWhere",
		pointOfSales:"PointOfSaleWhere",
		carts:"CartWhere",
		customers:"CustomerWhere",
		code:"ChannelCodeCondition",
		addTagsOnRegistration:"TagWhere",
		publicTags:"TagWhere",
		venue:"VenueWhere",
		and:"ChannelWhere",
		or:"ChannelWhere",
		not:"ChannelWhere"
	},
	ChannelPaymentWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		channel:"ChannelWhere",
		method:"PaymentMethodWhere",
		vatRate:"VatRateWhere",
		requireBillingAddress:"BooleanCondition",
		provideReceipt:"BooleanCondition",
		requireBillingSubject:"BooleanCondition",
		allowOnlyForTags:"TagWhere",
		and:"ChannelPaymentWhere",
		or:"ChannelPaymentWhere",
		not:"ChannelPaymentWhere"
	},
	PointOfSaleWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		code:"StringCondition",
		channels:"ChannelWhere",
		permissions:"PointOfSalePermissionsWhere",
		tenantPersonId:"UUIDCondition",
		and:"PointOfSaleWhere",
		or:"PointOfSaleWhere",
		not:"PointOfSaleWhere"
	},
	PointOfSalePermissionsWhere:{
		id:"UUIDCondition",
		canPlaceOrder:"BooleanCondition",
		pointOfSale:"PointOfSaleWhere",
		and:"PointOfSalePermissionsWhere",
		or:"PointOfSalePermissionsWhere",
		not:"PointOfSalePermissionsWhere"
	},
	CartWhere:{
		id:"UUIDCondition",
		confirmedAt:"DateTimeCondition",
		deletedAt:"DateTimeCondition",
		note:"StringCondition",
		items:"CartItemWhere",
		handle:"StringCondition",
		state:"CartStateCondition",
		createdAt:"DateTimeCondition",
		channel:"ChannelWhere",
		order:"OrderWhere",
		customer:"CustomerWhere",
		deliveryAddress:"AddressWhere",
		billingAddress:"AddressWhere",
		deliveryOption:"StringCondition",
		paymentOption:"StringCondition",
		delivery:"ChannelDeliveryWhere",
		payment:"ChannelPaymentWhere",
		billingSubject:"BillingSubjectWhere",
		priceLines:"CartPriceLineWhere",
		summary:"CartSummaryWhere",
		and:"CartWhere",
		or:"CartWhere",
		not:"CartWhere"
	},
	CartItemWhere:{
		id:"UUIDCondition",
		quantity:"IntCondition",
		cart:"CartWhere",
		product:"ProductWhere",
		createdAt:"DateTimeCondition",
		updatedAt:"DateTimeCondition",
		fulfillmentNote:"StringCondition",
		fulfillmentNotes:"FulfillmentNoteWhere",
		and:"CartItemWhere",
		or:"CartItemWhere",
		not:"CartItemWhere"
	},
	FulfillmentNoteWhere:{
		id:"UUIDCondition",
		note:"StringCondition",
		products:"ProductWhere",
		tags:"TagWhere",
		venues:"VenueWhere",
		cartItems:"CartItemWhere",
		orderItems:"OrderItemWhere",
		orders:"OrderWhere",
		highlight:"BooleanCondition",
		createdAt:"DateTimeCondition",
		emoji:"StringCondition",
		and:"FulfillmentNoteWhere",
		or:"FulfillmentNoteWhere",
		not:"FulfillmentNoteWhere"
	},
	VenueWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		deadlineTemplate:"DeadlineTemplateWhere",
		timetableDays:"TimetableDayWhere",
		timetableTemplates:"TimetableTemplateWhere",
		staffMembers:"StaffWhere",
		employeeRoles:"VenueEmployeeRoleWhere",
		pointOfSaleApplicationDevices:"PointOfSaleApplicationDeviceWhere",
		pointOfSaleTerminals:"PointOfSaleTerminalWhere",
		pointOfSalePrinters:"PointOfSalePrinterWhere",
		orders:"OrderWhere",
		fulfillmentNotes:"FulfillmentNoteWhere",
		areas:"AreaWhere",
		enabledUnassignReasons:"UnassignReasonWhere",
		categories:"PointOfSaleCategoryWhere",
		channels:"ChannelWhere",
		address:"StringCondition",
		pointOfSalePngBase64ReceiptLogo:"StringCondition",
		pointOfSaleInitialView:"PointOfSaleInitialViewCondition",
		pointOfSalePreferPrintReceipt:"BooleanCondition",
		and:"VenueWhere",
		or:"VenueWhere",
		not:"VenueWhere"
	},
	DeadlineTemplateWhere:{
		id:"UUIDCondition",
		startDate:"DateCondition",
		period:"IntCondition",
		cutoff:"IntCondition",
		closed:"BooleanCondition",
		venue:"VenueWhere",
		and:"DeadlineTemplateWhere",
		or:"DeadlineTemplateWhere",
		not:"DeadlineTemplateWhere"
	},
	DateCondition:{
		and:"DateCondition",
		or:"DateCondition",
		not:"DateCondition",
		eq:"Date",
		notEq:"Date",
		in:"Date",
		notIn:"Date",
		lt:"Date",
		lte:"Date",
		gt:"Date",
		gte:"Date"
	},
	Date: "String",
	TimetableDayWhere:{
		id:"UUIDCondition",
		date:"DateCondition",
		type:"TimetableDayTypeCondition",
		shiftGroups:"TimetableShiftGroupWhere",
		tipsCents:"IntCondition",
		notes:"TimetableDayNoteWhere",
		venue:"VenueWhere",
		meta:"TimetableDayMetadataWhere",
		and:"TimetableDayWhere",
		or:"TimetableDayWhere",
		not:"TimetableDayWhere"
	},
	TimetableDayTypeCondition:{
		and:"TimetableDayTypeCondition",
		or:"TimetableDayTypeCondition",
		not:"TimetableDayTypeCondition",
		eq:"TimetableDayType",
		notEq:"TimetableDayType",
		in:"TimetableDayType",
		notIn:"TimetableDayType",
		lt:"TimetableDayType",
		lte:"TimetableDayType",
		gt:"TimetableDayType",
		gte:"TimetableDayType"
	},
	TimetableDayType: true,
	TimetableShiftGroupWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		shifts:"TimetableShiftWhere",
		day:"TimetableDayWhere",
		type:"TimetableEmployeeRoleWhere",
		position:"TimetableShiftPositionWhere",
		queue:"EmployeeQueueWhere",
		generatedByTemplate:"TimetableTemplateWhere",
		and:"TimetableShiftGroupWhere",
		or:"TimetableShiftGroupWhere",
		not:"TimetableShiftGroupWhere"
	},
	TimetableShiftWhere:{
		id:"UUIDCondition",
		locked:"BooleanCondition",
		order:"IntCondition",
		assigned:"DateCondition",
		group:"TimetableShiftGroupWhere",
		shiftsProfile:"ShiftsProfileWhere",
		queueItem:"EmployeeQueueItemWhere",
		swapInfo:"TimetableShiftSwapInfoWhere",
		isOvertime:"BooleanCondition",
		and:"TimetableShiftWhere",
		or:"TimetableShiftWhere",
		not:"TimetableShiftWhere"
	},
	ShiftsProfileWhere:{
		id:"UUIDCondition",
		queueItems:"EmployeeQueueItemWhere",
		staff:"StaffWhere",
		roles:"TimetableEmployeeRoleWhere",
		shifts:"TimetableShiftWhere",
		allowSelfUnassigning:"BooleanCondition",
		and:"ShiftsProfileWhere",
		or:"ShiftsProfileWhere",
		not:"ShiftsProfileWhere"
	},
	EmployeeQueueItemWhere:{
		id:"UUIDCondition",
		start:"StringCondition",
		end:"StringCondition",
		queue:"EmployeeQueueWhere",
		shiftsProfile:"ShiftsProfileWhere",
		shift:"TimetableShiftWhere",
		unassignInfo:"UnassignedShiftInfoWhere",
		meta:"EmployeeQueueItemMetadataWhere",
		and:"EmployeeQueueItemWhere",
		or:"EmployeeQueueItemWhere",
		not:"EmployeeQueueItemWhere"
	},
	EmployeeQueueWhere:{
		id:"UUIDCondition",
		shiftGroup:"TimetableShiftGroupWhere",
		items:"EmployeeQueueItemWhere",
		contemberBugFix:"BooleanCondition",
		and:"EmployeeQueueWhere",
		or:"EmployeeQueueWhere",
		not:"EmployeeQueueWhere"
	},
	UnassignedShiftInfoWhere:{
		id:"UUIDCondition",
		hoursMissed:"IntCondition",
		queueItem:"EmployeeQueueItemWhere",
		legacyReason:"UnassignedInfoReasonCondition",
		reason:"UnassignReasonWhere",
		and:"UnassignedShiftInfoWhere",
		or:"UnassignedShiftInfoWhere",
		not:"UnassignedShiftInfoWhere"
	},
	UnassignedInfoReasonCondition:{
		and:"UnassignedInfoReasonCondition",
		or:"UnassignedInfoReasonCondition",
		not:"UnassignedInfoReasonCondition",
		eq:"UnassignedInfoReason",
		notEq:"UnassignedInfoReason",
		in:"UnassignedInfoReason",
		notIn:"UnassignedInfoReason",
		lt:"UnassignedInfoReason",
		lte:"UnassignedInfoReason",
		gt:"UnassignedInfoReason",
		gte:"UnassignedInfoReason"
	},
	UnassignedInfoReason: true,
	UnassignReasonWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		name:"StringCondition",
		venues:"VenueWhere",
		and:"UnassignReasonWhere",
		or:"UnassignReasonWhere",
		not:"UnassignReasonWhere"
	},
	EmployeeQueueItemMetadataWhere:{
		id:"UUIDCondition",
		totalMinutes:"IntCondition",
		queueItem:"EmployeeQueueItemWhere",
		includeInTipsCalculation:"BooleanCondition",
		and:"EmployeeQueueItemMetadataWhere",
		or:"EmployeeQueueItemMetadataWhere",
		not:"EmployeeQueueItemMetadataWhere"
	},
	TimetableEmployeeRoleWhere:{
		id:"UUIDCondition",
		shiftGroups:"TimetableShiftGroupWhere",
		shiftsProfiles:"ShiftsProfileWhere",
		shiftsManagers:"ShiftsManagerWhere",
		name:"StringCondition",
		timetableTemplates:"TimetableTemplateWhere",
		color:"StringCondition",
		and:"TimetableEmployeeRoleWhere",
		or:"TimetableEmployeeRoleWhere",
		not:"TimetableEmployeeRoleWhere"
	},
	ShiftsManagerWhere:{
		id:"UUIDCondition",
		staff:"StaffWhere",
		managedRoles:"TimetableEmployeeRoleWhere",
		createdAt:"DateTimeCondition",
		and:"ShiftsManagerWhere",
		or:"ShiftsManagerWhere",
		not:"ShiftsManagerWhere"
	},
	TimetableTemplateWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		startDate:"DateCondition",
		period:"IntCondition",
		slots:"IntCondition",
		position:"TimetableShiftPositionWhere",
		staffOptions:"TimetableTemplateStaffOptionsWhere",
		internalName:"StringCondition",
		venue:"VenueWhere",
		employeeRole:"TimetableEmployeeRoleWhere",
		workdaysOnly:"BooleanCondition",
		monday:"BooleanCondition",
		tuesday:"BooleanCondition",
		wednesday:"BooleanCondition",
		thursday:"BooleanCondition",
		friday:"BooleanCondition",
		saturday:"BooleanCondition",
		sunday:"BooleanCondition",
		type:"TemplateTypeCondition",
		and:"TimetableTemplateWhere",
		or:"TimetableTemplateWhere",
		not:"TimetableTemplateWhere"
	},
	TimetableShiftPositionWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		start:"StringCondition",
		end:"StringCondition",
		shiftGroups:"TimetableShiftGroupWhere",
		timetableTemplates:"TimetableTemplateWhere",
		isDynamic:"BooleanCondition",
		and:"TimetableShiftPositionWhere",
		or:"TimetableShiftPositionWhere",
		not:"TimetableShiftPositionWhere"
	},
	TimetableTemplateStaffOptionsWhere:{
		id:"UUIDCondition",
		startTime:"StringCondition",
		endTime:"StringCondition",
		timetableTemplate:"TimetableTemplateWhere",
		autoAssignedEmployee:"ShiftsProfileWhere",
		and:"TimetableTemplateStaffOptionsWhere",
		or:"TimetableTemplateStaffOptionsWhere",
		not:"TimetableTemplateStaffOptionsWhere"
	},
	TemplateTypeCondition:{
		and:"TemplateTypeCondition",
		or:"TemplateTypeCondition",
		not:"TemplateTypeCondition",
		eq:"TemplateType",
		notEq:"TemplateType",
		in:"TemplateType",
		notIn:"TemplateType",
		lt:"TemplateType",
		lte:"TemplateType",
		gt:"TemplateType",
		gte:"TemplateType"
	},
	TemplateType: true,
	TimetableShiftSwapInfoWhere:{
		id:"UUIDCondition",
		assigned:"DateCondition",
		requested:"BooleanCondition",
		confirmed:"BooleanCondition",
		swappedShiftsProfile:"ShiftsProfileWhere",
		shift:"TimetableShiftWhere",
		and:"TimetableShiftSwapInfoWhere",
		or:"TimetableShiftSwapInfoWhere",
		not:"TimetableShiftSwapInfoWhere"
	},
	TimetableDayNoteWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		note:"StringCondition",
		day:"TimetableDayWhere",
		role:"TimetableEmployeeRoleWhere",
		and:"TimetableDayNoteWhere",
		or:"TimetableDayNoteWhere",
		not:"TimetableDayNoteWhere"
	},
	TimetableDayMetadataWhere:{
		id:"UUIDCondition",
		numberOfWorkers:"IntCondition",
		tipsTotalCents:"IntCondition",
		totalMinutes:"IntCondition",
		tipsCentsPerMinute:"FloatCondition",
		day:"TimetableDayWhere",
		and:"TimetableDayMetadataWhere",
		or:"TimetableDayMetadataWhere",
		not:"TimetableDayMetadataWhere"
	},
	FloatCondition:{
		and:"FloatCondition",
		or:"FloatCondition",
		not:"FloatCondition"
	},
	VenueEmployeeRoleWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		employeePrivileges:"TimetablesEmployeePrivilegesWhere",
		venue:"VenueWhere",
		role:"TimetableEmployeeRoleWhere",
		getsTipsShare:"BooleanCondition",
		notesEnabled:"BooleanCondition",
		and:"VenueEmployeeRoleWhere",
		or:"VenueEmployeeRoleWhere",
		not:"VenueEmployeeRoleWhere"
	},
	TimetablesEmployeePrivilegesWhere:{
		id:"UUIDCondition",
		venueEmployeeRole:"VenueEmployeeRoleWhere",
		read:"BooleanCondition",
		unassign:"BooleanCondition",
		assign:"BooleanCondition",
		and:"TimetablesEmployeePrivilegesWhere",
		or:"TimetablesEmployeePrivilegesWhere",
		not:"TimetablesEmployeePrivilegesWhere"
	},
	PointOfSaleApplicationDeviceWhere:{
		id:"UUIDCondition",
		internalName:"StringCondition",
		note:"StringCondition",
		venue:"VenueWhere",
		identificationCode:"IdentificationCodeWhere",
		identifier:"DeviceIdentifierWhere",
		terminal:"PointOfSaleTerminalWhere",
		receiptPrinter:"PointOfSalePrinterWhere",
		ticketPrinters:"PointOfSalePrinterWhere",
		and:"PointOfSaleApplicationDeviceWhere",
		or:"PointOfSaleApplicationDeviceWhere",
		not:"PointOfSaleApplicationDeviceWhere"
	},
	IdentificationCodeWhere:{
		id:"UUIDCondition",
		code:"StringCondition",
		createdAt:"DateTimeCondition",
		attempts:"IdentificationAttemptWhere",
		locales:"IdentificationCodeLocaleWhere",
		internalName:"StringCondition",
		applicationDevices:"PointOfSaleApplicationDeviceWhere",
		and:"IdentificationCodeWhere",
		or:"IdentificationCodeWhere",
		not:"IdentificationCodeWhere"
	},
	IdentificationAttemptWhere:{
		id:"UUIDCondition",
		createdAt:"DateTimeCondition",
		code:"IdentificationCodeWhere",
		user:"UserWhere",
		and:"IdentificationAttemptWhere",
		or:"IdentificationAttemptWhere",
		not:"IdentificationAttemptWhere"
	},
	UserWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		internalNote:"StringCondition",
		staff:"StaffWhere",
		customer:"CustomerWhere",
		tenantPersonId:"UUIDCondition",
		disabledAt:"DateTimeCondition",
		devices:"UserDeviceWhere",
		verifiedAt:"DateTimeCondition",
		email:"StringCondition",
		createdAt:"DateTimeCondition",
		deletionRequestedAt:"DateTimeCondition",
		deletionExpectedAt:"DateTimeCondition",
		deletedAt:"DateTimeCondition",
		meta:"UserMetadataWhere",
		identificationAttempts:"IdentificationAttemptWhere",
		roles:"UserRolesWhere",
		and:"UserWhere",
		or:"UserWhere",
		not:"UserWhere"
	},
	UserDeviceWhere:{
		id:"UUIDCondition",
		createdAt:"DateTimeCondition",
		lastActiveAt:"DateTimeCondition",
		platform:"StringCondition",
		deviceId:"StringCondition",
		notificationsEnabled:"BooleanCondition",
		user:"UserWhere",
		appVersion:"StringCondition",
		osVersion:"StringCondition",
		apiVersion:"StringCondition",
		anonymousSession:"AnonymousSessionWhere",
		and:"UserDeviceWhere",
		or:"UserDeviceWhere",
		not:"UserDeviceWhere"
	},
	AnonymousSessionWhere:{
		id:"UUIDCondition",
		createdAt:"DateTimeCondition",
		lastActiveAt:"DateTimeCondition",
		anonymousSessionKey:"StringCondition",
		email:"StringCondition",
		name:"StringCondition",
		internalNote:"StringCondition",
		customer:"CustomerWhere",
		devices:"UserDeviceWhere",
		and:"AnonymousSessionWhere",
		or:"AnonymousSessionWhere",
		not:"AnonymousSessionWhere"
	},
	UserMetadataWhere:{
		id:"UUIDCondition",
		userProfileUrl:"StringCondition",
		tenantEmail:"StringCondition",
		tenantPersonId:"UUIDCondition",
		tenantIdentityId:"UUIDCondition",
		globalRoles:"JsonCondition",
		projectRoles:"JsonCondition",
		projectRolesString:"StringCondition",
		externalIdentifiers:"JsonCondition",
		externalIdentifiersString:"StringCondition",
		idpSlugs:"JsonCondition",
		idpSlugsString:"StringCondition",
		user:"UserWhere",
		and:"UserMetadataWhere",
		or:"UserMetadataWhere",
		not:"UserMetadataWhere"
	},
	UserRolesWhere:{
		id:"UUIDCondition",
		isCustomer:"BooleanCondition",
		isStaff:"BooleanCondition",
		isBartender:"BooleanCondition",
		isCashier:"BooleanCondition",
		isCourier:"BooleanCondition",
		isCleaner:"BooleanCondition",
		isShiftsManager:"BooleanCondition",
		isInternalBuyer:"BooleanCondition",
		isStocksManager:"BooleanCondition",
		isCourierManager:"BooleanCondition",
		isCashierManager:"BooleanCondition",
		isBusinessToBusinessManager:"BooleanCondition",
		isPicker:"BooleanCondition",
		user:"UserWhere",
		and:"UserRolesWhere",
		or:"UserRolesWhere",
		not:"UserRolesWhere"
	},
	IdentificationCodeLocaleWhere:{
		id:"UUIDCondition",
		successMessage:"StringCondition",
		root:"IdentificationCodeWhere",
		locale:"LocaleWhere",
		and:"IdentificationCodeLocaleWhere",
		or:"IdentificationCodeLocaleWhere",
		not:"IdentificationCodeLocaleWhere"
	},
	DeviceIdentifierWhere:{
		id:"UUIDCondition",
		internalName:"StringCondition",
		device:"PointOfSaleApplicationDeviceWhere",
		updatedAt:"DateTimeCondition",
		platform:"StringCondition",
		resolution:"StringCondition",
		devicePixelRatio:"FloatCondition",
		updatedByUser:"UserWhere",
		identifier:"StringCondition",
		meta:"DeviceIdentifierMetadataWhere",
		applicationVersionIdentifier:"StringCondition",
		lastPointOfSaleSynchronizationErrorRawDetails:"StringCondition",
		and:"DeviceIdentifierWhere",
		or:"DeviceIdentifierWhere",
		not:"DeviceIdentifierWhere"
	},
	DeviceIdentifierMetadataWhere:{
		id:"UUIDCondition",
		prettyIdentifier:"StringCondition",
		deviceIdentifier:"DeviceIdentifierWhere",
		and:"DeviceIdentifierMetadataWhere",
		or:"DeviceIdentifierMetadataWhere",
		not:"DeviceIdentifierMetadataWhere"
	},
	PointOfSaleTerminalWhere:{
		id:"UUIDCondition",
		internalName:"StringCondition",
		note:"StringCondition",
		venue:"VenueWhere",
		applicationDevices:"PointOfSaleApplicationDeviceWhere",
		ipAddress:"StringCondition",
		port:"IntCondition",
		type:"PointOfSaleTerminalTypeCondition",
		and:"PointOfSaleTerminalWhere",
		or:"PointOfSaleTerminalWhere",
		not:"PointOfSaleTerminalWhere"
	},
	PointOfSaleTerminalTypeCondition:{
		and:"PointOfSaleTerminalTypeCondition",
		or:"PointOfSaleTerminalTypeCondition",
		not:"PointOfSaleTerminalTypeCondition",
		eq:"PointOfSaleTerminalType",
		notEq:"PointOfSaleTerminalType",
		in:"PointOfSaleTerminalType",
		notIn:"PointOfSaleTerminalType",
		lt:"PointOfSaleTerminalType",
		lte:"PointOfSaleTerminalType",
		gt:"PointOfSaleTerminalType",
		gte:"PointOfSaleTerminalType"
	},
	PointOfSaleTerminalType: true,
	PointOfSalePrinterWhere:{
		id:"UUIDCondition",
		internalName:"StringCondition",
		note:"StringCondition",
		ipAddress:"StringCondition",
		applicationDevicesReceipt:"PointOfSaleApplicationDeviceWhere",
		applicationDevicesTicket:"PointOfSaleApplicationDeviceWhere",
		venue:"VenueWhere",
		ticketCategories:"PointOfSaleCategoryWhere",
		and:"PointOfSalePrinterWhere",
		or:"PointOfSalePrinterWhere",
		not:"PointOfSalePrinterWhere"
	},
	PointOfSaleCategoryWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		slug:"StringCondition",
		locales:"PointOfSaleCategoryLocaleWhere",
		products:"PointOfSaleCategoryProductWhere",
		category:"ProductCategoryWhere",
		venue:"VenueWhere",
		ticketPrinters:"PointOfSalePrinterWhere",
		and:"PointOfSaleCategoryWhere",
		or:"PointOfSaleCategoryWhere",
		not:"PointOfSaleCategoryWhere"
	},
	PointOfSaleCategoryLocaleWhere:{
		id:"UUIDCondition",
		title:"StringCondition",
		root:"PointOfSaleCategoryWhere",
		locale:"LocaleWhere",
		and:"PointOfSaleCategoryLocaleWhere",
		or:"PointOfSaleCategoryLocaleWhere",
		not:"PointOfSaleCategoryLocaleWhere"
	},
	PointOfSaleCategoryProductWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		category:"PointOfSaleCategoryWhere",
		product:"ProductWhere",
		locales:"PointOfSaleCategoryProductLocaleWhere",
		and:"PointOfSaleCategoryProductWhere",
		or:"PointOfSaleCategoryProductWhere",
		not:"PointOfSaleCategoryProductWhere"
	},
	PointOfSaleCategoryProductLocaleWhere:{
		id:"UUIDCondition",
		title:"StringCondition",
		root:"PointOfSaleCategoryProductWhere",
		locale:"LocaleWhere",
		and:"PointOfSaleCategoryProductLocaleWhere",
		or:"PointOfSaleCategoryProductLocaleWhere",
		not:"PointOfSaleCategoryProductLocaleWhere"
	},
	ProductCategoryWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		code:"StringCondition",
		products:"ProductWhere",
		tags:"TagWhere",
		parent:"ProductCategoryWhere",
		children:"ProductCategoryWhere",
		description:"StringCondition",
		internalNote:"StringCondition",
		color:"StringCondition",
		image:"ImageWhere",
		order:"FloatCondition",
		descendants:"ProductCategoryTreeWhere",
		ancestors:"ProductCategoryTreeWhere",
		inheritedTags:"InheritedProductCategoryTagWhere",
		nestedProducts:"NestedProductCategoryProductWhere",
		and:"ProductCategoryWhere",
		or:"ProductCategoryWhere",
		not:"ProductCategoryWhere"
	},
	ProductCategoryTreeWhere:{
		id:"UUIDCondition",
		depth:"IntCondition",
		ancestor:"ProductCategoryWhere",
		descendant:"ProductCategoryWhere",
		and:"ProductCategoryTreeWhere",
		or:"ProductCategoryTreeWhere",
		not:"ProductCategoryTreeWhere"
	},
	InheritedProductCategoryTagWhere:{
		id:"UUIDCondition",
		depth:"IntCondition",
		productCategory:"ProductCategoryWhere",
		tag:"TagWhere",
		and:"InheritedProductCategoryTagWhere",
		or:"InheritedProductCategoryTagWhere",
		not:"InheritedProductCategoryTagWhere"
	},
	NestedProductCategoryProductWhere:{
		id:"UUIDCondition",
		depth:"IntCondition",
		product:"ProductWhere",
		productCategory:"ProductCategoryWhere",
		and:"NestedProductCategoryProductWhere",
		or:"NestedProductCategoryProductWhere",
		not:"NestedProductCategoryProductWhere"
	},
	OrderWhere:{
		id:"UUIDCondition",
		state:"OrderStateCondition",
		fulfilledAt:"DateTimeCondition",
		canceledAt:"DateTimeCondition",
		note:"StringCondition",
		customer:"CustomerWhere",
		channel:"ChannelWhere",
		discounts:"OrderDiscountWhere",
		delivery:"OrderDeliveryWhere",
		items:"OrderItemWhere",
		internalNote:"StringCondition",
		cart:"CartWhere",
		events:"OrderEventWhere",
		createdAt:"DateTimeCondition",
		billingAddress:"AddressWhere",
		priceLines:"OrderPriceLineWhere",
		payments:"OrderPaymentWhere",
		seq:"IntCondition",
		billingSubject:"BillingSubjectWhere",
		summary:"OrderSummaryWhere",
		doubleshotLegacyId:"StringCondition",
		gratuity:"GratuityWhere",
		venue:"VenueWhere",
		fulfillmentNote:"StringCondition",
		fulfillmentNotes:"FulfillmentNoteWhere",
		doubleshotTotalWeightGrams:"IntCondition",
		doubleShotLegacyNumber:"StringCondition",
		doubleshotLastUpdatedAt:"DateTimeCondition",
		doubleshotAdminUrl:"StringCondition",
		and:"OrderWhere",
		or:"OrderWhere",
		not:"OrderWhere"
	},
	OrderStateCondition:{
		and:"OrderStateCondition",
		or:"OrderStateCondition",
		not:"OrderStateCondition",
		eq:"OrderState",
		notEq:"OrderState",
		in:"OrderState",
		notIn:"OrderState",
		lt:"OrderState",
		lte:"OrderState",
		gt:"OrderState",
		gte:"OrderState"
	},
	OrderState: true,
	OrderDiscountWhere:{
		id:"UUIDCondition",
		discountCents:"IntCondition",
		vatRate:"VatRateWhere",
		order:"OrderWhere",
		description:"StringCondition",
		type:"OrderDiscountTypeCondition",
		customerCreditTransactions:"CustomerCreditTransactionWhere",
		voucherRedemption:"VoucherRedemptionWhere",
		and:"OrderDiscountWhere",
		or:"OrderDiscountWhere",
		not:"OrderDiscountWhere"
	},
	OrderDiscountTypeCondition:{
		and:"OrderDiscountTypeCondition",
		or:"OrderDiscountTypeCondition",
		not:"OrderDiscountTypeCondition",
		eq:"OrderDiscountType",
		notEq:"OrderDiscountType",
		in:"OrderDiscountType",
		notIn:"OrderDiscountType",
		lt:"OrderDiscountType",
		lte:"OrderDiscountType",
		gt:"OrderDiscountType",
		gte:"OrderDiscountType"
	},
	OrderDiscountType: true,
	CustomerCreditTransactionWhere:{
		id:"UUIDCondition",
		createdAt:"DateTimeCondition",
		amountCents:"IntCondition",
		customerCredit:"CustomerCreditWhere",
		orderDiscount:"OrderDiscountWhere",
		virtualProductEffect:"VirtualProductEffectWhere",
		and:"CustomerCreditTransactionWhere",
		or:"CustomerCreditTransactionWhere",
		not:"CustomerCreditTransactionWhere"
	},
	CustomerCreditWhere:{
		id:"UUIDCondition",
		initialCreditCents:"IntCondition",
		remainingCreditsCents:"IntCondition",
		expiresAt:"DateTimeCondition",
		reason:"StringCondition",
		customer:"CustomerWhere",
		vatRate:"VatRateWhere",
		createdAt:"DateTimeCondition",
		transactions:"CustomerCreditTransactionWhere",
		voucherRedemption:"VoucherRedemptionWhere",
		invoiceUrl:"StringCondition",
		and:"CustomerCreditWhere",
		or:"CustomerCreditWhere",
		not:"CustomerCreditWhere"
	},
	VoucherRedemptionWhere:{
		id:"UUIDCondition",
		createdAt:"DateTimeCondition",
		note:"StringCondition",
		manualRedemptionNote:"StringCondition",
		customerCredit:"CustomerCreditWhere",
		orderDiscount:"OrderDiscountWhere",
		voucher:"VoucherWhere",
		customer:"CustomerWhere",
		and:"VoucherRedemptionWhere",
		or:"VoucherRedemptionWhere",
		not:"VoucherRedemptionWhere"
	},
	VoucherWhere:{
		id:"UUIDCondition",
		createdAt:"DateTimeCondition",
		activatedAt:"DateTimeCondition",
		expiresAt:"DateTimeCondition",
		internalNote:"StringCondition",
		note:"StringCondition",
		code:"StringCondition",
		type:"VoucherTypeCondition",
		creditCents:"IntCondition",
		buyer:"CustomerWhere",
		owner:"CustomerWhere",
		vatRate:"VatRateWhere",
		virtualProductEffect:"VirtualProductEffectWhere",
		redemption:"VoucherRedemptionWhere",
		and:"VoucherWhere",
		or:"VoucherWhere",
		not:"VoucherWhere"
	},
	VoucherTypeCondition:{
		and:"VoucherTypeCondition",
		or:"VoucherTypeCondition",
		not:"VoucherTypeCondition",
		eq:"VoucherType",
		notEq:"VoucherType",
		in:"VoucherType",
		notIn:"VoucherType",
		lt:"VoucherType",
		lte:"VoucherType",
		gt:"VoucherType",
		gte:"VoucherType"
	},
	VoucherType: true,
	VirtualProductEffectWhere:{
		id:"UUIDCondition",
		createdAt:"DateTimeCondition",
		succeededAt:"DateTimeCondition",
		orderItem:"OrderItemWhere",
		failedAt:"DateTimeCondition",
		revertedAt:"DateTimeCondition",
		resultCustomerCreditTransaction:"CustomerCreditTransactionWhere",
		resultVouchers:"VoucherWhere",
		and:"VirtualProductEffectWhere",
		or:"VirtualProductEffectWhere",
		not:"VirtualProductEffectWhere"
	},
	OrderItemWhere:{
		id:"UUIDCondition",
		unitPriceCents:"IntCondition",
		quantity:"IntCondition",
		vatRate:"VatRateWhere",
		order:"OrderWhere",
		virtualProductEffects:"VirtualProductEffectWhere",
		pickedAt:"DateTimeCondition",
		note:"StringCondition",
		fulfillmentNotes:"FulfillmentNoteWhere",
		product:"ProductWhere",
		and:"OrderItemWhere",
		or:"OrderItemWhere",
		not:"OrderItemWhere"
	},
	OrderEventWhere:{
		id:"UUIDCondition",
		type:"StringCondition",
		data:"StringCondition",
		createdAt:"DateTimeCondition",
		order:"OrderWhere",
		payment:"OrderPaymentWhere",
		delivery:"OrderDeliveryWhere",
		and:"OrderEventWhere",
		or:"OrderEventWhere",
		not:"OrderEventWhere"
	},
	OrderPaymentWhere:{
		id:"UUIDCondition",
		data:"JsonCondition",
		paymentCents:"IntCondition",
		method:"PaymentMethodWhere",
		failedAt:"DateTimeCondition",
		state:"OrderPaymentStateCondition",
		approvedAt:"DateTimeCondition",
		events:"OrderEventWhere",
		order:"OrderWhere",
		invoice:"InvoiceWhere",
		walletType:"StringCondition",
		createdAt:"DateTimeCondition",
		publicReceiptUrl:"StringCondition",
		priceCents:"IntCondition",
		vatRate:"VatRateWhere",
		meta:"OrderPaymentMetadataWhere",
		otherCurrencyPriceCents:"StringCondition",
		and:"OrderPaymentWhere",
		or:"OrderPaymentWhere",
		not:"OrderPaymentWhere"
	},
	OrderPaymentStateCondition:{
		and:"OrderPaymentStateCondition",
		or:"OrderPaymentStateCondition",
		not:"OrderPaymentStateCondition",
		eq:"OrderPaymentState",
		notEq:"OrderPaymentState",
		in:"OrderPaymentState",
		notIn:"OrderPaymentState",
		lt:"OrderPaymentState",
		lte:"OrderPaymentState",
		gt:"OrderPaymentState",
		gte:"OrderPaymentState"
	},
	OrderPaymentState: true,
	InvoiceWhere:{
		id:"UUIDCondition",
		createdAt:"DateTimeCondition",
		publicKey:"StringCondition",
		fakturoidId:"StringCondition",
		fakturoidData:"StringCondition",
		legacyUrl:"StringCondition",
		customer:"CustomerWhere",
		orderPayments:"OrderPaymentWhere",
		address:"AddressWhere",
		publicUrl:"StringCondition",
		billingSubject:"BillingSubjectWhere",
		and:"InvoiceWhere",
		or:"InvoiceWhere",
		not:"InvoiceWhere"
	},
	BillingSubjectWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		fullName:"StringCondition",
		addressLine1:"StringCondition",
		addressLine2:"StringCondition",
		city:"StringCondition",
		postalCode:"StringCondition",
		email:"StringCondition",
		phone:"StringCondition",
		companyName:"StringCondition",
		companyIdentifier:"StringCondition",
		vatIdentifier:"StringCondition",
		externalIdentifier:"StringCondition",
		hidden:"BooleanCondition",
		createdAt:"DateTimeCondition",
		deletedAt:"DateTimeCondition",
		note:"StringCondition",
		internalNote:"StringCondition",
		fakturoidSubjectId:"StringCondition",
		country:"CountryWhere",
		customer:"CustomerWhere",
		invoices:"InvoiceWhere",
		defaultBillingSubjectOfCustomer:"CustomerWhere",
		orders:"OrderWhere",
		and:"BillingSubjectWhere",
		or:"BillingSubjectWhere",
		not:"BillingSubjectWhere"
	},
	CountryWhere:{
		id:"UUIDCondition",
		code:"StringCondition",
		order:"IntCondition",
		and:"CountryWhere",
		or:"CountryWhere",
		not:"CountryWhere"
	},
	OrderPaymentMetadataWhere:{
		id:"UUIDCondition",
		paymentUrl:"StringCondition",
		orderPayment:"OrderPaymentWhere",
		and:"OrderPaymentMetadataWhere",
		or:"OrderPaymentMetadataWhere",
		not:"OrderPaymentMetadataWhere"
	},
	OrderPriceLineWhere:{
		id:"UUIDCondition",
		unitPriceCents:"IntCondition",
		quantity:"IntCondition",
		type:"OrderPriceLineTypeCondition",
		orderItem:"OrderItemWhere",
		orderDiscount:"OrderDiscountWhere",
		orderPayment:"OrderPaymentWhere",
		orderDelivery:"OrderDeliveryWhere",
		vatRatePermille:"IntCondition",
		vatRate:"VatRateWhere",
		order:"OrderWhere",
		and:"OrderPriceLineWhere",
		or:"OrderPriceLineWhere",
		not:"OrderPriceLineWhere"
	},
	OrderPriceLineTypeCondition:{
		and:"OrderPriceLineTypeCondition",
		or:"OrderPriceLineTypeCondition",
		not:"OrderPriceLineTypeCondition",
		eq:"OrderPriceLineType",
		notEq:"OrderPriceLineType",
		in:"OrderPriceLineType",
		notIn:"OrderPriceLineType",
		lt:"OrderPriceLineType",
		lte:"OrderPriceLineType",
		gt:"OrderPriceLineType",
		gte:"OrderPriceLineType"
	},
	OrderPriceLineType: true,
	OrderSummaryWhere:{
		id:"UUIDCondition",
		totalPriceCents:"IntCondition",
		discountPriceCents:"IntCondition",
		undiscountedPriceCents:"IntCondition",
		itemsQuantity:"IntCondition",
		orderUrl:"StringCondition",
		orderNumber:"StringCondition",
		order:"OrderWhere",
		and:"OrderSummaryWhere",
		or:"OrderSummaryWhere",
		not:"OrderSummaryWhere"
	},
	GratuityWhere:{
		id:"UUIDCondition",
		amountCents:"IntCondition",
		order:"OrderWhere",
		and:"GratuityWhere",
		or:"GratuityWhere",
		not:"GratuityWhere"
	},
	AreaWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		name:"StringCondition",
		venue:"VenueWhere",
		tables:"TableWhere",
		lines:"LineWhere",
		and:"AreaWhere",
		or:"AreaWhere",
		not:"AreaWhere"
	},
	TableWhere:{
		id:"UUIDCondition",
		shape:"TableShapeCondition",
		width:"IntCondition",
		height:"IntCondition",
		positionX:"IntCondition",
		positionY:"IntCondition",
		name:"StringCondition",
		color:"StringCondition",
		customerTabs:"CustomerTabWhere",
		area:"AreaWhere",
		seats:"SeatWhere",
		and:"TableWhere",
		or:"TableWhere",
		not:"TableWhere"
	},
	TableShapeCondition:{
		and:"TableShapeCondition",
		or:"TableShapeCondition",
		not:"TableShapeCondition",
		eq:"TableShape",
		notEq:"TableShape",
		in:"TableShape",
		notIn:"TableShape",
		lt:"TableShape",
		lte:"TableShape",
		gt:"TableShape",
		gte:"TableShape"
	},
	TableShape: true,
	CustomerTabWhere:{
		id:"UUIDCondition",
		createdAt:"DateTimeCondition",
		color:"StringCondition",
		items:"CustomerTabItemWhere",
		name:"StringCondition",
		meta:"CustomerTabMetadataWhere",
		customer:"CustomerWhere",
		table:"TableWhere",
		seat:"SeatWhere",
		and:"CustomerTabWhere",
		or:"CustomerTabWhere",
		not:"CustomerTabWhere"
	},
	CustomerTabItemWhere:{
		id:"UUIDCondition",
		addedAt:"DateTimeCondition",
		tab:"CustomerTabWhere",
		product:"ProductWhere",
		paidAt:"DateTimeCondition",
		and:"CustomerTabItemWhere",
		or:"CustomerTabItemWhere",
		not:"CustomerTabItemWhere"
	},
	CustomerTabMetadataWhere:{
		id:"UUIDCondition",
		totalPriceCents:"IntCondition",
		totalSpentCents:"IntCondition",
		unpaidCents:"IntCondition",
		customerTab:"CustomerTabWhere",
		and:"CustomerTabMetadataWhere",
		or:"CustomerTabMetadataWhere",
		not:"CustomerTabMetadataWhere"
	},
	SeatWhere:{
		id:"UUIDCondition",
		positionX:"IntCondition",
		positionY:"IntCondition",
		name:"StringCondition",
		color:"StringCondition",
		customerTabs:"CustomerTabWhere",
		table:"TableWhere",
		and:"SeatWhere",
		or:"SeatWhere",
		not:"SeatWhere"
	},
	LineWhere:{
		id:"UUIDCondition",
		positionStartX:"IntCondition",
		positionStartY:"IntCondition",
		positionEndX:"IntCondition",
		positionEndY:"IntCondition",
		area:"AreaWhere",
		and:"LineWhere",
		or:"LineWhere",
		not:"LineWhere"
	},
	PointOfSaleInitialViewCondition:{
		and:"PointOfSaleInitialViewCondition",
		or:"PointOfSaleInitialViewCondition",
		not:"PointOfSaleInitialViewCondition",
		eq:"PointOfSaleInitialView",
		notEq:"PointOfSaleInitialView",
		in:"PointOfSaleInitialView",
		notIn:"PointOfSaleInitialView",
		lt:"PointOfSaleInitialView",
		lte:"PointOfSaleInitialView",
		gt:"PointOfSaleInitialView",
		gte:"PointOfSaleInitialView"
	},
	PointOfSaleInitialView: true,
	CartStateCondition:{
		and:"CartStateCondition",
		or:"CartStateCondition",
		not:"CartStateCondition",
		eq:"CartState",
		notEq:"CartState",
		in:"CartState",
		notIn:"CartState",
		lt:"CartState",
		lte:"CartState",
		gt:"CartState",
		gte:"CartState"
	},
	CartState: true,
	CartPriceLineWhere:{
		id:"UUIDCondition",
		type:"CartPriceLineTypeCondition",
		item:"CartItemWhere",
		product:"ProductWhere",
		unitPriceCents:"IntCondition",
		priceCents:"IntCondition",
		quantity:"IntCondition",
		vatRatePermille:"IntCondition",
		vatRate:"VatRateWhere",
		cart:"CartWhere",
		and:"CartPriceLineWhere",
		or:"CartPriceLineWhere",
		not:"CartPriceLineWhere"
	},
	CartPriceLineTypeCondition:{
		and:"CartPriceLineTypeCondition",
		or:"CartPriceLineTypeCondition",
		not:"CartPriceLineTypeCondition",
		eq:"CartPriceLineType",
		notEq:"CartPriceLineType",
		in:"CartPriceLineType",
		notIn:"CartPriceLineType",
		lt:"CartPriceLineType",
		lte:"CartPriceLineType",
		gt:"CartPriceLineType",
		gte:"CartPriceLineType"
	},
	CartPriceLineType: true,
	CartSummaryWhere:{
		id:"UUIDCondition",
		itemsPriceCents:"IntCondition",
		deliveryPriceCents:"IntCondition",
		totalPriceCents:"IntCondition",
		itemsCount:"IntCondition",
		itemsQuantity:"IntCondition",
		checkoutUrl:"StringCondition",
		cart:"CartWhere",
		and:"CartSummaryWhere",
		or:"CartSummaryWhere",
		not:"CartSummaryWhere"
	},
	ChannelCodeCondition:{
		and:"ChannelCodeCondition",
		or:"ChannelCodeCondition",
		not:"ChannelCodeCondition",
		eq:"ChannelCode",
		notEq:"ChannelCode",
		in:"ChannelCode",
		notIn:"ChannelCode",
		lt:"ChannelCode",
		lte:"ChannelCode",
		gt:"ChannelCode",
		gte:"ChannelCode"
	},
	ChannelCode: true,
	VatRatePresetCondition:{
		and:"VatRatePresetCondition",
		or:"VatRatePresetCondition",
		not:"VatRatePresetCondition",
		eq:"VatRatePreset",
		notEq:"VatRatePreset",
		in:"VatRatePreset",
		notIn:"VatRatePreset",
		lt:"VatRatePreset",
		lte:"VatRatePreset",
		gt:"VatRatePreset",
		gte:"VatRatePreset"
	},
	VatRatePreset: true,
	OrderDeliveryStateCondition:{
		and:"OrderDeliveryStateCondition",
		or:"OrderDeliveryStateCondition",
		not:"OrderDeliveryStateCondition",
		eq:"OrderDeliveryState",
		notEq:"OrderDeliveryState",
		in:"OrderDeliveryState",
		notIn:"OrderDeliveryState",
		lt:"OrderDeliveryState",
		lte:"OrderDeliveryState",
		gt:"OrderDeliveryState",
		gte:"OrderDeliveryState"
	},
	OrderDeliveryState: true,
	LiftagoRideWhere:{
		id:"UUIDCondition",
		liftagoId:"StringCondition",
		data:"StringCondition",
		updatedAt:"DateTimeCondition",
		delivery:"OrderDeliveryWhere",
		and:"LiftagoRideWhere",
		or:"LiftagoRideWhere",
		not:"LiftagoRideWhere"
	},
	WoltDriveDeliveryWhere:{
		id:"UUIDCondition",
		state:"WoltDriveDeliveryStateCondition",
		shipmentPromiseId:"StringCondition",
		deliveryPrice:"IntCondition",
		deliveryPriceCurrency:"StringCondition",
		shipmentPromiseResponse:"StringCondition",
		deliveryOrderId:"StringCondition",
		trackingUrl:"StringCondition",
		deliverOrderResponse:"StringCondition",
		delivery:"OrderDeliveryWhere",
		and:"WoltDriveDeliveryWhere",
		or:"WoltDriveDeliveryWhere",
		not:"WoltDriveDeliveryWhere"
	},
	WoltDriveDeliveryStateCondition:{
		and:"WoltDriveDeliveryStateCondition",
		or:"WoltDriveDeliveryStateCondition",
		not:"WoltDriveDeliveryStateCondition",
		eq:"WoltDriveDeliveryState",
		notEq:"WoltDriveDeliveryState",
		in:"WoltDriveDeliveryState",
		notIn:"WoltDriveDeliveryState",
		lt:"WoltDriveDeliveryState",
		lte:"WoltDriveDeliveryState",
		gt:"WoltDriveDeliveryState",
		gte:"WoltDriveDeliveryState"
	},
	WoltDriveDeliveryState: true,
	CleanerWhere:{
		id:"UUIDCondition",
		staff:"StaffWhere",
		canReachTopShelf:"BooleanCondition",
		createdAt:"DateTimeCondition",
		and:"CleanerWhere",
		or:"CleanerWhere",
		not:"CleanerWhere"
	},
	StocksManagerWhere:{
		id:"UUIDCondition",
		staff:"StaffWhere",
		managedProducts:"ProductWhere",
		createdAt:"DateTimeCondition",
		and:"StocksManagerWhere",
		or:"StocksManagerWhere",
		not:"StocksManagerWhere"
	},
	CourierManagerWhere:{
		id:"UUIDCondition",
		staff:"StaffWhere",
		createdAt:"DateTimeCondition",
		and:"CourierManagerWhere",
		or:"CourierManagerWhere",
		not:"CourierManagerWhere"
	},
	PickerWhere:{
		id:"UUIDCondition",
		staff:"StaffWhere",
		createdAt:"DateTimeCondition",
		and:"PickerWhere",
		or:"PickerWhere",
		not:"PickerWhere"
	},
	RemunerationProfileWhere:{
		id:"UUIDCondition",
		employmentInformation:"EmploymentInformationWhere",
		workMonths:"WorkMonthWhere",
		staff:"StaffWhere",
		and:"RemunerationProfileWhere",
		or:"RemunerationProfileWhere",
		not:"RemunerationProfileWhere"
	},
	EmploymentInformationWhere:{
		id:"UUIDCondition",
		hourlyRate:"IntCondition",
		remunerationProfiles:"RemunerationProfileWhere",
		monthlySalary:"IntCondition",
		type:"EmploymentTypeCondition",
		name:"StringCondition",
		and:"EmploymentInformationWhere",
		or:"EmploymentInformationWhere",
		not:"EmploymentInformationWhere"
	},
	EmploymentTypeCondition:{
		and:"EmploymentTypeCondition",
		or:"EmploymentTypeCondition",
		not:"EmploymentTypeCondition",
		eq:"EmploymentType",
		notEq:"EmploymentType",
		in:"EmploymentType",
		notIn:"EmploymentType",
		lt:"EmploymentType",
		lte:"EmploymentType",
		gt:"EmploymentType",
		gte:"EmploymentType"
	},
	EmploymentType: true,
	WorkMonthWhere:{
		id:"UUIDCondition",
		year:"IntCondition",
		month:"IntCondition",
		hoursWorked:"FloatCondition",
		billableHours:"FloatCondition",
		remunerationProfile:"RemunerationProfileWhere",
		and:"WorkMonthWhere",
		or:"WorkMonthWhere",
		not:"WorkMonthWhere"
	},
	CashierWhere:{
		id:"UUIDCondition",
		createdAt:"DateTimeCondition",
		staff:"StaffWhere",
		and:"CashierWhere",
		or:"CashierWhere",
		not:"CashierWhere"
	},
	InternalBuyerWhere:{
		id:"UUIDCondition",
		createdAt:"DateTimeCondition",
		staff:"StaffWhere",
		and:"InternalBuyerWhere",
		or:"InternalBuyerWhere",
		not:"InternalBuyerWhere"
	},
	SalesManagerWhere:{
		id:"UUIDCondition",
		staff:"StaffWhere",
		createdAt:"DateTimeCondition",
		countries:"CountryWhere",
		and:"SalesManagerWhere",
		or:"SalesManagerWhere",
		not:"SalesManagerWhere"
	},
	CashierManagerWhere:{
		id:"UUIDCondition",
		createdAt:"DateTimeCondition",
		staff:"StaffWhere",
		and:"CashierManagerWhere",
		or:"CashierManagerWhere",
		not:"CashierManagerWhere"
	},
	BusinessServiceEventWhere:{
		id:"UUIDCondition",
		createdAt:"DateTimeCondition",
		fulfilledAt:"DateTimeCondition",
		businessCustomer:"BusinessCustomerWhere",
		businessService:"BusinessServiceWhere",
		filledNumberOfPeople:"IntCondition",
		filledInvoiced:"BooleanCondition",
		filledEquipment:"StringCondition",
		filledMillTamDem:"BooleanCondition",
		filledSOEspresso:"BooleanCondition",
		filledFilterCoffeeInMenu:"BooleanCondition",
		filledWaterMeterStatus:"StringCondition",
		filledServiceAction:"StringCondition",
		filledInvoiceIdentifier:"StringCondition",
		filledNote:"StringCondition",
		filledContact:"StringCondition",
		filledPhone:"BooleanCondition",
		filledEmail:"BooleanCondition",
		filledGrindingStonesCondition:"StringCondition",
		createdBy:"StaffWhere",
		filledSupervisor:"StaffWhere",
		and:"BusinessServiceEventWhere",
		or:"BusinessServiceEventWhere",
		not:"BusinessServiceEventWhere"
	},
	BusinessServiceWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		requireNote:"IntCondition",
		locales:"BusinessServiceLocaleWhere",
		requireNumberOfPeople:"IntCondition",
		requireInvoiced:"IntCondition",
		requireEquipment:"IntCondition",
		requireMillTamDem:"IntCondition",
		requireSOEspresso:"IntCondition",
		requireFilterCoffeeInMenu:"IntCondition",
		requireWaterMeterStatus:"IntCondition",
		requireServiceAction:"IntCondition",
		optionsEquipment:"StringCondition",
		optionsServiceAction:"StringCondition",
		requireInvoiceIdentifier:"IntCondition",
		requireSupervisor:"IntCondition",
		requireContact:"IntCondition",
		requirePhone:"IntCondition",
		requireEmail:"IntCondition",
		requireGrindingStonesCondition:"IntCondition",
		and:"BusinessServiceWhere",
		or:"BusinessServiceWhere",
		not:"BusinessServiceWhere"
	},
	BusinessServiceLocaleWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		labelNote:"StringCondition",
		root:"BusinessServiceWhere",
		locale:"LocaleWhere",
		labelNumberOfPeople:"StringCondition",
		labelInvoiced:"StringCondition",
		labelEquipment:"StringCondition",
		labelMillTamDem:"StringCondition",
		labelSOEspresso:"StringCondition",
		labelFilterCoffeeInMenu:"StringCondition",
		labelWaterMeterStatus:"StringCondition",
		labelServiceAction:"StringCondition",
		labelInvoiceIdentifier:"StringCondition",
		labelSupervisor:"StringCondition",
		labelContact:"StringCondition",
		labelPhone:"StringCondition",
		labelEmail:"StringCondition",
		labelGrindingStonesCondition:"StringCondition",
		and:"BusinessServiceLocaleWhere",
		or:"BusinessServiceLocaleWhere",
		not:"BusinessServiceLocaleWhere"
	},
	DoubleshotCoffeeEquipmentWhere:{
		id:"UUIDCondition",
		espressoMachine:"StringCondition",
		espressoGrinder:"StringCondition",
		batchBrew:"StringCondition",
		batchGrinder:"StringCondition",
		waterFilter:"StringCondition",
		mechanicalFilter:"StringCondition",
		and:"DoubleshotCoffeeEquipmentWhere",
		or:"DoubleshotCoffeeEquipmentWhere",
		not:"DoubleshotCoffeeEquipmentWhere"
	},
	OrderRecurrenceWhere:{
		id:"UUIDCondition",
		internalName:"StringCondition",
		locales:"OrderRecurrenceLocaleWhere",
		order:"IntCondition",
		businessCategory:"BusinessCategoryWhere",
		and:"OrderRecurrenceWhere",
		or:"OrderRecurrenceWhere",
		not:"OrderRecurrenceWhere"
	},
	OrderRecurrenceLocaleWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		root:"OrderRecurrenceWhere",
		locale:"LocaleWhere",
		and:"OrderRecurrenceLocaleWhere",
		or:"OrderRecurrenceLocaleWhere",
		not:"OrderRecurrenceLocaleWhere"
	},
	ProductListWhere:{
		id:"UUIDCondition",
		items:"ProductListItemWhere",
		businessCategory:"BusinessCategoryWhere",
		and:"ProductListWhere",
		or:"ProductListWhere",
		not:"ProductListWhere"
	},
	ProductListItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		list:"ProductListWhere",
		product:"ProductWhere",
		defaultQuantityForOrder:"IntCondition",
		and:"ProductListItemWhere",
		or:"ProductListItemWhere",
		not:"ProductListItemWhere"
	},
	ProductCategoryListWhere:{
		id:"UUIDCondition",
		items:"ProductCategoryListItemWhere",
		locales:"ProductCategoryListLocaleWhere",
		seasonalProductCategoriesOfBusinessCategory:"BusinessCategoryWhere",
		specificProductsProductCategoriesOfBusinessCategory:"BusinessCategoryWhere",
		and:"ProductCategoryListWhere",
		or:"ProductCategoryListWhere",
		not:"ProductCategoryListWhere"
	},
	ProductCategoryListItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		list:"ProductCategoryListWhere",
		productCategory:"ProductCategoryWhere",
		showRecipeImages:"BooleanCondition",
		showPackingImages:"BooleanCondition",
		showAllAvailableProducts:"BooleanCondition",
		and:"ProductCategoryListItemWhere",
		or:"ProductCategoryListItemWhere",
		not:"ProductCategoryListItemWhere"
	},
	ProductCategoryListLocaleWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		root:"ProductCategoryListWhere",
		locale:"LocaleWhere",
		and:"ProductCategoryListLocaleWhere",
		or:"ProductCategoryListLocaleWhere",
		not:"ProductCategoryListLocaleWhere"
	},
	ProductIngredientLocaleWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		root:"ProductIngredientWhere",
		locale:"LocaleWhere",
		and:"ProductIngredientLocaleWhere",
		or:"ProductIngredientLocaleWhere",
		not:"ProductIngredientLocaleWhere"
	},
	ProductIngredientWhere:{
		id:"UUIDCondition",
		internalNote:"StringCondition",
		locales:"ProductIngredientLocaleWhere",
		internalName:"StringCondition",
		categories:"ProductIngredientCategoryWhere",
		allergens:"AllergenWhere",
		needsPrepping:"BooleanCondition",
		allowCustomerRating:"BooleanCondition",
		customerRatings:"CustomerIngredientRatingWhere",
		preferredQuantityUnit:"ProductIngredientItemQuantityUnitWhere",
		freshingContainer:"FreshingContainerWhere",
		image:"ImageWhere",
		suppliers:"IngredientSupplierListWhere",
		incrementQuantityNumber:"FloatCondition",
		and:"ProductIngredientWhere",
		or:"ProductIngredientWhere",
		not:"ProductIngredientWhere"
	},
	ProductIngredientCategoryWhere:{
		id:"UUIDCondition",
		internalName:"StringCondition",
		internalNote:"StringCondition",
		ingredients:"ProductIngredientWhere",
		locales:"ProductIngredientCategoryLocaleWhere",
		order:"IntCondition",
		and:"ProductIngredientCategoryWhere",
		or:"ProductIngredientCategoryWhere",
		not:"ProductIngredientCategoryWhere"
	},
	ProductIngredientCategoryLocaleWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		root:"ProductIngredientCategoryWhere",
		locale:"LocaleWhere",
		and:"ProductIngredientCategoryLocaleWhere",
		or:"ProductIngredientCategoryLocaleWhere",
		not:"ProductIngredientCategoryLocaleWhere"
	},
	AllergenWhere:{
		id:"UUIDCondition",
		internalName:"StringCondition",
		locales:"AllergenLocaleWhere",
		ingredients:"ProductIngredientWhere",
		code:"IntCondition",
		and:"AllergenWhere",
		or:"AllergenWhere",
		not:"AllergenWhere"
	},
	AllergenLocaleWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		root:"AllergenWhere",
		locale:"LocaleWhere",
		and:"AllergenLocaleWhere",
		or:"AllergenLocaleWhere",
		not:"AllergenLocaleWhere"
	},
	CustomerIngredientRatingWhere:{
		id:"UUIDCondition",
		customer:"CustomerWhere",
		rating:"ProductIngredientRatingWhere",
		ingredient:"ProductIngredientWhere",
		and:"CustomerIngredientRatingWhere",
		or:"CustomerIngredientRatingWhere",
		not:"CustomerIngredientRatingWhere"
	},
	ProductIngredientRatingWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		name:"StringCondition",
		icon:"ImageWhere",
		and:"ProductIngredientRatingWhere",
		or:"ProductIngredientRatingWhere",
		not:"ProductIngredientRatingWhere"
	},
	ProductIngredientItemQuantityUnitWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		and:"ProductIngredientItemQuantityUnitWhere",
		or:"ProductIngredientItemQuantityUnitWhere",
		not:"ProductIngredientItemQuantityUnitWhere"
	},
	FreshingContainerWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		volumeMl:"IntCondition",
		workspace:"WorkspaceWhere",
		and:"FreshingContainerWhere",
		or:"FreshingContainerWhere",
		not:"FreshingContainerWhere"
	},
	WorkspaceWhere:{
		id:"UUIDCondition",
		unique:"OneCondition",
		orderDeadlineTime:"StringCondition",
		ordersLoadingDurationHours:"IntCondition",
		freshingContainerVolumeMl:"IntCondition",
		freshingPrepareOrderByOffsetMinutes:"IntCondition",
		checkoutUrlTemplate:"StringCondition",
		orderUrlTemplate:"StringCondition",
		paymentUrlTemplate:"StringCondition",
		customerProfileUrlTemplate:"StringCondition",
		userProfileUrlTemplate:"StringCondition",
		messengerUrl:"StringCondition",
		messengerIosUrl:"StringCondition",
		messengerAndroidUrl:"StringCondition",
		freshingContainers:"FreshingContainerWhere",
		openingHours:"WeekHoursWhere",
		workingHours:"WeekHoursWhere",
		defaultFreshingContainer:"FreshingContainerWhere",
		creditsProduct:"VirtualProductWhere",
		discountVatRate:"VatRateWhere",
		name:"StringCondition",
		businessAddress:"StringCondition",
		and:"WorkspaceWhere",
		or:"WorkspaceWhere",
		not:"WorkspaceWhere"
	},
	OneCondition:{
		and:"OneCondition",
		or:"OneCondition",
		not:"OneCondition",
		eq:"One",
		notEq:"One",
		in:"One",
		notIn:"One",
		lt:"One",
		lte:"One",
		gt:"One",
		gte:"One"
	},
	One: true,
	WeekHoursWhere:{
		id:"UUIDCondition",
		mon:"StringCondition",
		tue:"StringCondition",
		wed:"StringCondition",
		thu:"StringCondition",
		fri:"StringCondition",
		sat:"StringCondition",
		sun:"StringCondition",
		and:"WeekHoursWhere",
		or:"WeekHoursWhere",
		not:"WeekHoursWhere"
	},
	VirtualProductWhere:{
		id:"UUIDCondition",
		type:"VirtualProductTypeCondition",
		product:"ProductWhere",
		voucherCreditCents:"IntCondition",
		physicalRepresentation:"VirtualProductPhysicalRepresentationTypeCondition",
		recipientEmail:"BooleanCondition",
		and:"VirtualProductWhere",
		or:"VirtualProductWhere",
		not:"VirtualProductWhere"
	},
	VirtualProductTypeCondition:{
		and:"VirtualProductTypeCondition",
		or:"VirtualProductTypeCondition",
		not:"VirtualProductTypeCondition",
		eq:"VirtualProductType",
		notEq:"VirtualProductType",
		in:"VirtualProductType",
		notIn:"VirtualProductType",
		lt:"VirtualProductType",
		lte:"VirtualProductType",
		gt:"VirtualProductType",
		gte:"VirtualProductType"
	},
	VirtualProductType: true,
	VirtualProductPhysicalRepresentationTypeCondition:{
		and:"VirtualProductPhysicalRepresentationTypeCondition",
		or:"VirtualProductPhysicalRepresentationTypeCondition",
		not:"VirtualProductPhysicalRepresentationTypeCondition",
		eq:"VirtualProductPhysicalRepresentationType",
		notEq:"VirtualProductPhysicalRepresentationType",
		in:"VirtualProductPhysicalRepresentationType",
		notIn:"VirtualProductPhysicalRepresentationType",
		lt:"VirtualProductPhysicalRepresentationType",
		lte:"VirtualProductPhysicalRepresentationType",
		gt:"VirtualProductPhysicalRepresentationType",
		gte:"VirtualProductPhysicalRepresentationType"
	},
	VirtualProductPhysicalRepresentationType: true,
	IngredientSupplierListWhere:{
		id:"UUIDCondition",
		items:"IngredientSupplierItemWhere",
		and:"IngredientSupplierListWhere",
		or:"IngredientSupplierListWhere",
		not:"IngredientSupplierListWhere"
	},
	IngredientSupplierItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		list:"IngredientSupplierListWhere",
		supplier:"IngredientSupplierWhere",
		and:"IngredientSupplierItemWhere",
		or:"IngredientSupplierItemWhere",
		not:"IngredientSupplierItemWhere"
	},
	IngredientSupplierWhere:{
		id:"UUIDCondition",
		internalName:"StringCondition",
		internalNote:"StringCondition",
		locales:"IngredientSupplierLocaleWhere",
		and:"IngredientSupplierWhere",
		or:"IngredientSupplierWhere",
		not:"IngredientSupplierWhere"
	},
	IngredientSupplierLocaleWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		root:"IngredientSupplierWhere",
		locale:"LocaleWhere",
		and:"IngredientSupplierLocaleWhere",
		or:"IngredientSupplierLocaleWhere",
		not:"IngredientSupplierLocaleWhere"
	},
	BlogLocaleWhere:{
		id:"UUIDCondition",
		pageName:"StringCondition",
		title:"StringCondition",
		lead:"StringCondition",
		root:"BlogWhere",
		locale:"LocaleWhere",
		and:"BlogLocaleWhere",
		or:"BlogLocaleWhere",
		not:"BlogLocaleWhere"
	},
	BlogWhere:{
		id:"UUIDCondition",
		unique:"OneCondition",
		locales:"BlogLocaleWhere",
		and:"BlogWhere",
		or:"BlogWhere",
		not:"BlogWhere"
	},
	BlogPostLocaleWhere:{
		id:"UUIDCondition",
		title:"StringCondition",
		availableForWeb:"BooleanCondition",
		availableForMobile:"BooleanCondition",
		root:"BlogPostWhere",
		locale:"LocaleWhere",
		cover:"CoverWhere",
		content:"ContentWhere",
		link:"LinkableWhere",
		seo:"SeoWhere",
		products:"ProductWhere",
		and:"BlogPostLocaleWhere",
		or:"BlogPostLocaleWhere",
		not:"BlogPostLocaleWhere"
	},
	BlogPostWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		locales:"BlogPostLocaleWhere",
		and:"BlogPostWhere",
		or:"BlogPostWhere",
		not:"BlogPostWhere"
	},
	CoverWhere:{
		id:"UUIDCondition",
		primaryTitle:"StringCondition",
		secondaryTitle:"StringCondition",
		medium:"MediumWhere",
		buttonColors:"ColorPalleteWhere",
		and:"CoverWhere",
		or:"CoverWhere",
		not:"CoverWhere"
	},
	MediumWhere:{
		id:"UUIDCondition",
		type:"MediumTypeCondition",
		colorTheme:"ColorThemeCondition",
		image:"ImageWhere",
		video:"VideoWhere",
		and:"MediumWhere",
		or:"MediumWhere",
		not:"MediumWhere"
	},
	MediumTypeCondition:{
		and:"MediumTypeCondition",
		or:"MediumTypeCondition",
		not:"MediumTypeCondition",
		eq:"MediumType",
		notEq:"MediumType",
		in:"MediumType",
		notIn:"MediumType",
		lt:"MediumType",
		lte:"MediumType",
		gt:"MediumType",
		gte:"MediumType"
	},
	MediumType: true,
	ColorThemeCondition:{
		and:"ColorThemeCondition",
		or:"ColorThemeCondition",
		not:"ColorThemeCondition",
		eq:"ColorTheme",
		notEq:"ColorTheme",
		in:"ColorTheme",
		notIn:"ColorTheme",
		lt:"ColorTheme",
		lte:"ColorTheme",
		gt:"ColorTheme",
		gte:"ColorTheme"
	},
	ColorTheme: true,
	VideoWhere:{
		id:"UUIDCondition",
		src:"StringCondition",
		width:"IntCondition",
		height:"IntCondition",
		size:"IntCondition",
		type:"StringCondition",
		duration:"FloatCondition",
		poster:"ImageWhere",
		and:"VideoWhere",
		or:"VideoWhere",
		not:"VideoWhere"
	},
	ColorPalleteWhere:{
		id:"UUIDCondition",
		background:"StringCondition",
		text:"StringCondition",
		and:"ColorPalleteWhere",
		or:"ColorPalleteWhere",
		not:"ColorPalleteWhere"
	},
	ContentWhere:{
		id:"UUIDCondition",
		blocks:"ContentBlockWhere",
		and:"ContentWhere",
		or:"ContentWhere",
		not:"ContentWhere"
	},
	ContentBlockWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		json:"StringCondition",
		content:"ContentWhere",
		references:"ContentReferenceWhere",
		and:"ContentBlockWhere",
		or:"ContentBlockWhere",
		not:"ContentBlockWhere"
	},
	ContentReferenceWhere:{
		id:"UUIDCondition",
		type:"ContentReferenceTypeCondition",
		primaryText:"StringCondition",
		secondaryText:"StringCondition",
		jsonContent:"StringCondition",
		block:"ContentBlockWhere",
		colorPallete:"ColorPalleteWhere",
		medium:"MediumWhere",
		link:"LinkWhere",
		blogPosts:"BlogPostListWhere",
		links:"LinkListWhere",
		products:"ProductListWhere",
		contentSize:"ContentSizeCondition",
		misc:"StringCondition",
		hero:"HeroWhere",
		gallery:"GalleryWhere",
		socialsAndApps:"SocialsAndAppsWhere",
		productGrid:"ProductGridWhere",
		productBanners:"ProductBannerListWhere",
		deliveryRegions:"DeliveryRegionsWhere",
		textList:"TextListWhere",
		gridTiles:"GridTilesWhere",
		and:"ContentReferenceWhere",
		or:"ContentReferenceWhere",
		not:"ContentReferenceWhere"
	},
	ContentReferenceTypeCondition:{
		and:"ContentReferenceTypeCondition",
		or:"ContentReferenceTypeCondition",
		not:"ContentReferenceTypeCondition",
		eq:"ContentReferenceType",
		notEq:"ContentReferenceType",
		in:"ContentReferenceType",
		notIn:"ContentReferenceType",
		lt:"ContentReferenceType",
		lte:"ContentReferenceType",
		gt:"ContentReferenceType",
		gte:"ContentReferenceType"
	},
	ContentReferenceType: true,
	LinkWhere:{
		id:"UUIDCondition",
		type:"LinkTypeCondition",
		title:"StringCondition",
		externalLink:"StringCondition",
		internalLink:"LinkableWhere",
		and:"LinkWhere",
		or:"LinkWhere",
		not:"LinkWhere"
	},
	LinkTypeCondition:{
		and:"LinkTypeCondition",
		or:"LinkTypeCondition",
		not:"LinkTypeCondition",
		eq:"LinkType",
		notEq:"LinkType",
		in:"LinkType",
		notIn:"LinkType",
		lt:"LinkType",
		lte:"LinkType",
		gt:"LinkType",
		gte:"LinkType"
	},
	LinkType: true,
	LinkableWhere:{
		id:"UUIDCondition",
		url:"StringCondition",
		blogPost:"BlogPostLocaleWhere",
		page:"PageLocaleWhere",
		wikiPage:"WikiPageWhere",
		redirect:"RedirectWhere",
		and:"LinkableWhere",
		or:"LinkableWhere",
		not:"LinkableWhere"
	},
	PageLocaleWhere:{
		id:"UUIDCondition",
		title:"StringCondition",
		link:"LinkableWhere",
		root:"PageWhere",
		locale:"LocaleWhere",
		seo:"SeoWhere",
		content:"ContentWhere",
		cover:"CoverWhere",
		theme:"PageThemeCondition",
		and:"PageLocaleWhere",
		or:"PageLocaleWhere",
		not:"PageLocaleWhere"
	},
	PageWhere:{
		id:"UUIDCondition",
		locales:"PageLocaleWhere",
		and:"PageWhere",
		or:"PageWhere",
		not:"PageWhere"
	},
	SeoWhere:{
		id:"UUIDCondition",
		title:"StringCondition",
		description:"StringCondition",
		ogTitle:"StringCondition",
		ogDescription:"StringCondition",
		ogImage:"ImageWhere",
		and:"SeoWhere",
		or:"SeoWhere",
		not:"SeoWhere"
	},
	PageThemeCondition:{
		and:"PageThemeCondition",
		or:"PageThemeCondition",
		not:"PageThemeCondition",
		eq:"PageTheme",
		notEq:"PageTheme",
		in:"PageTheme",
		notIn:"PageTheme",
		lt:"PageTheme",
		lte:"PageTheme",
		gt:"PageTheme",
		gte:"PageTheme"
	},
	PageTheme: true,
	WikiPageWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		title:"StringCondition",
		emoji:"StringCondition",
		link:"LinkableWhere",
		parent:"WikiPageWhere",
		children:"WikiPageWhere",
		content:"ContentWhere",
		and:"WikiPageWhere",
		or:"WikiPageWhere",
		not:"WikiPageWhere"
	},
	RedirectWhere:{
		id:"UUIDCondition",
		link:"LinkableWhere",
		target:"LinkWhere",
		and:"RedirectWhere",
		or:"RedirectWhere",
		not:"RedirectWhere"
	},
	BlogPostListWhere:{
		id:"UUIDCondition",
		items:"BlogPostListItemWhere",
		and:"BlogPostListWhere",
		or:"BlogPostListWhere",
		not:"BlogPostListWhere"
	},
	BlogPostListItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		caption:"StringCondition",
		list:"BlogPostListWhere",
		blogPost:"BlogPostLocaleWhere",
		and:"BlogPostListItemWhere",
		or:"BlogPostListItemWhere",
		not:"BlogPostListItemWhere"
	},
	LinkListWhere:{
		id:"UUIDCondition",
		items:"LinkListItemWhere",
		and:"LinkListWhere",
		or:"LinkListWhere",
		not:"LinkListWhere"
	},
	LinkListItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		isPrimary:"BooleanCondition",
		list:"LinkListWhere",
		link:"LinkWhere",
		and:"LinkListItemWhere",
		or:"LinkListItemWhere",
		not:"LinkListItemWhere"
	},
	ContentSizeCondition:{
		and:"ContentSizeCondition",
		or:"ContentSizeCondition",
		not:"ContentSizeCondition",
		eq:"ContentSize",
		notEq:"ContentSize",
		in:"ContentSize",
		notIn:"ContentSize",
		lt:"ContentSize",
		lte:"ContentSize",
		gt:"ContentSize",
		gte:"ContentSize"
	},
	ContentSize: true,
	HeroWhere:{
		id:"UUIDCondition",
		showLogo:"BooleanCondition",
		middleContent:"StringCondition",
		medium:"MediumWhere",
		and:"HeroWhere",
		or:"HeroWhere",
		not:"HeroWhere"
	},
	GalleryWhere:{
		id:"UUIDCondition",
		items:"GalleryItemWhere",
		and:"GalleryWhere",
		or:"GalleryWhere",
		not:"GalleryWhere"
	},
	GalleryItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		caption:"StringCondition",
		list:"GalleryWhere",
		medium:"MediumWhere",
		and:"GalleryItemWhere",
		or:"GalleryItemWhere",
		not:"GalleryItemWhere"
	},
	SocialsAndAppsWhere:{
		id:"UUIDCondition",
		instagram:"BooleanCondition",
		appStore:"BooleanCondition",
		googlePlay:"BooleanCondition",
		and:"SocialsAndAppsWhere",
		or:"SocialsAndAppsWhere",
		not:"SocialsAndAppsWhere"
	},
	ProductGridWhere:{
		id:"UUIDCondition",
		isCarousel:"BooleanCondition",
		categories:"ProductGridCategoryWhere",
		type:"ProductGridTypeCondition",
		and:"ProductGridWhere",
		or:"ProductGridWhere",
		not:"ProductGridWhere"
	},
	ProductGridCategoryWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		title:"StringCondition",
		root:"ProductGridWhere",
		items:"ProductGridItemWhere",
		images:"ImageListWhere",
		and:"ProductGridCategoryWhere",
		or:"ProductGridCategoryWhere",
		not:"ProductGridCategoryWhere"
	},
	ProductGridItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		title:"StringCondition",
		lead:"StringCondition",
		product:"ProductWhere",
		medium:"MediumWhere",
		link:"LinkWhere",
		category:"ProductGridCategoryWhere",
		description:"StringCondition",
		and:"ProductGridItemWhere",
		or:"ProductGridItemWhere",
		not:"ProductGridItemWhere"
	},
	ImageListWhere:{
		id:"UUIDCondition",
		items:"ImageListItemWhere",
		and:"ImageListWhere",
		or:"ImageListWhere",
		not:"ImageListWhere"
	},
	ImageListItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		list:"ImageListWhere",
		image:"ImageWhere",
		and:"ImageListItemWhere",
		or:"ImageListItemWhere",
		not:"ImageListItemWhere"
	},
	ProductGridTypeCondition:{
		and:"ProductGridTypeCondition",
		or:"ProductGridTypeCondition",
		not:"ProductGridTypeCondition",
		eq:"ProductGridType",
		notEq:"ProductGridType",
		in:"ProductGridType",
		notIn:"ProductGridType",
		lt:"ProductGridType",
		lte:"ProductGridType",
		gt:"ProductGridType",
		gte:"ProductGridType"
	},
	ProductGridType: true,
	ProductBannerListWhere:{
		id:"UUIDCondition",
		items:"ProductBannerItemWhere",
		and:"ProductBannerListWhere",
		or:"ProductBannerListWhere",
		not:"ProductBannerListWhere"
	},
	ProductBannerItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		list:"ProductBannerListWhere",
		banner:"ProductBannerWhere",
		size:"ProductBannerItemSizeCondition",
		and:"ProductBannerItemWhere",
		or:"ProductBannerItemWhere",
		not:"ProductBannerItemWhere"
	},
	ProductBannerWhere:{
		id:"UUIDCondition",
		beforeTitle:"StringCondition",
		title:"StringCondition",
		label:"StringCondition",
		button:"LinkWhere",
		backgroundImage:"ImageWhere",
		productImage:"ImageWhere",
		product:"ProductWhere",
		and:"ProductBannerWhere",
		or:"ProductBannerWhere",
		not:"ProductBannerWhere"
	},
	ProductBannerItemSizeCondition:{
		and:"ProductBannerItemSizeCondition",
		or:"ProductBannerItemSizeCondition",
		not:"ProductBannerItemSizeCondition",
		eq:"ProductBannerItemSize",
		notEq:"ProductBannerItemSize",
		in:"ProductBannerItemSize",
		notIn:"ProductBannerItemSize",
		lt:"ProductBannerItemSize",
		lte:"ProductBannerItemSize",
		gt:"ProductBannerItemSize",
		gte:"ProductBannerItemSize"
	},
	ProductBannerItemSize: true,
	DeliveryRegionsWhere:{
		id:"UUIDCondition",
		items:"DeliveryRegionsItemWhere",
		and:"DeliveryRegionsWhere",
		or:"DeliveryRegionsWhere",
		not:"DeliveryRegionsWhere"
	},
	DeliveryRegionsItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		title:"StringCondition",
		offerLabel:"StringCondition",
		list:"DeliveryRegionsWhere",
		image:"ImageWhere",
		textList:"TextListWhere",
		gallery:"ImageListWhere",
		and:"DeliveryRegionsItemWhere",
		or:"DeliveryRegionsItemWhere",
		not:"DeliveryRegionsItemWhere"
	},
	TextListWhere:{
		id:"UUIDCondition",
		items:"TextItemWhere",
		and:"TextListWhere",
		or:"TextListWhere",
		not:"TextListWhere"
	},
	TextItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		text:"StringCondition",
		list:"TextListWhere",
		title:"StringCondition",
		and:"TextItemWhere",
		or:"TextItemWhere",
		not:"TextItemWhere"
	},
	GridTilesWhere:{
		id:"UUIDCondition",
		items:"GridTileItemWhere",
		and:"GridTilesWhere",
		or:"GridTilesWhere",
		not:"GridTilesWhere"
	},
	GridTileItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		text:"StringCondition",
		list:"GridTilesWhere",
		medium:"MediumWhere",
		link:"LinkWhere",
		and:"GridTileItemWhere",
		or:"GridTileItemWhere",
		not:"GridTileItemWhere"
	},
	TranslationCataloguesIdentifierWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		code:"StringCondition",
		catalogue:"TranslationCatalogueWhere",
		and:"TranslationCataloguesIdentifierWhere",
		or:"TranslationCataloguesIdentifierWhere",
		not:"TranslationCataloguesIdentifierWhere"
	},
	TranslationCatalogueWhere:{
		id:"UUIDCondition",
		domain:"TranslationDomainWhere",
		fallback:"TranslationCatalogueWhere",
		values:"TranslationValueWhere",
		identifier:"TranslationCataloguesIdentifierWhere",
		and:"TranslationCatalogueWhere",
		or:"TranslationCatalogueWhere",
		not:"TranslationCatalogueWhere"
	},
	TranslationDomainWhere:{
		id:"UUIDCondition",
		identifier:"StringCondition",
		name:"StringCondition",
		catalogues:"TranslationCatalogueWhere",
		keys:"TranslationKeyWhere",
		and:"TranslationDomainWhere",
		or:"TranslationDomainWhere",
		not:"TranslationDomainWhere"
	},
	TranslationKeyWhere:{
		id:"UUIDCondition",
		identifier:"StringCondition",
		contentType:"TranslationContentTypeCondition",
		note:"StringCondition",
		domain:"TranslationDomainWhere",
		values:"TranslationValueWhere",
		and:"TranslationKeyWhere",
		or:"TranslationKeyWhere",
		not:"TranslationKeyWhere"
	},
	TranslationContentTypeCondition:{
		and:"TranslationContentTypeCondition",
		or:"TranslationContentTypeCondition",
		not:"TranslationContentTypeCondition",
		eq:"TranslationContentType",
		notEq:"TranslationContentType",
		in:"TranslationContentType",
		notIn:"TranslationContentType",
		lt:"TranslationContentType",
		lte:"TranslationContentType",
		gt:"TranslationContentType",
		gte:"TranslationContentType"
	},
	TranslationContentType: true,
	TranslationValueWhere:{
		id:"UUIDCondition",
		value:"StringCondition",
		catalogue:"TranslationCatalogueWhere",
		key:"TranslationKeyWhere",
		and:"TranslationValueWhere",
		or:"TranslationValueWhere",
		not:"TranslationValueWhere"
	},
	MenuLocaleWhere:{
		id:"UUIDCondition",
		root:"SiteMenuWhere",
		locale:"LocaleWhere",
		items:"MenuItemWhere",
		secondaryItems:"LinkListWhere",
		eshopLink:"LinkWhere",
		and:"MenuLocaleWhere",
		or:"MenuLocaleWhere",
		not:"MenuLocaleWhere"
	},
	SiteMenuWhere:{
		id:"UUIDCondition",
		unique:"OneCondition",
		locales:"MenuLocaleWhere",
		and:"SiteMenuWhere",
		or:"SiteMenuWhere",
		not:"SiteMenuWhere"
	},
	MenuItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		menu:"MenuLocaleWhere",
		link:"LinkWhere",
		subitems:"MenuSubitemWhere",
		and:"MenuItemWhere",
		or:"MenuItemWhere",
		not:"MenuItemWhere"
	},
	MenuSubitemWhere:{
		id:"UUIDCondition",
		type:"MenuSubitemTypeCondition",
		title:"StringCondition",
		item:"MenuItemWhere",
		links:"MenuLinkListWhere",
		products:"MenuProductsWhere",
		delivery:"MenuDeliveryWhere",
		contact:"MenuContactWhere",
		order:"IntCondition",
		and:"MenuSubitemWhere",
		or:"MenuSubitemWhere",
		not:"MenuSubitemWhere"
	},
	MenuSubitemTypeCondition:{
		and:"MenuSubitemTypeCondition",
		or:"MenuSubitemTypeCondition",
		not:"MenuSubitemTypeCondition",
		eq:"MenuSubitemType",
		notEq:"MenuSubitemType",
		in:"MenuSubitemType",
		notIn:"MenuSubitemType",
		lt:"MenuSubitemType",
		lte:"MenuSubitemType",
		gt:"MenuSubitemType",
		gte:"MenuSubitemType"
	},
	MenuSubitemType: true,
	MenuLinkListWhere:{
		id:"UUIDCondition",
		items:"MenuLinkItemWhere",
		and:"MenuLinkListWhere",
		or:"MenuLinkListWhere",
		not:"MenuLinkListWhere"
	},
	MenuLinkItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		list:"MenuLinkListWhere",
		link:"LinkWhere",
		image:"ImageWhere",
		description:"StringCondition",
		and:"MenuLinkItemWhere",
		or:"MenuLinkItemWhere",
		not:"MenuLinkItemWhere"
	},
	MenuProductsWhere:{
		id:"UUIDCondition",
		links:"MenuLinkListWhere",
		buttons:"LinkListWhere",
		and:"MenuProductsWhere",
		or:"MenuProductsWhere",
		not:"MenuProductsWhere"
	},
	MenuDeliveryWhere:{
		id:"UUIDCondition",
		deliveryRegions:"DeliveryRegionsWhere",
		text:"StringCondition",
		socialsAndApps:"SocialsAndAppsWhere",
		and:"MenuDeliveryWhere",
		or:"MenuDeliveryWhere",
		not:"MenuDeliveryWhere"
	},
	MenuContactWhere:{
		id:"UUIDCondition",
		text:"StringCondition",
		image:"ImageWhere",
		and:"MenuContactWhere",
		or:"MenuContactWhere",
		not:"MenuContactWhere"
	},
	ProductLocaleWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		description:"StringCondition",
		root:"ProductWhere",
		locale:"LocaleWhere",
		featureList:"TextListWhere",
		printableName:"StringCondition",
		firstSticker:"StringCondition",
		secondSticker:"StringCondition",
		and:"ProductLocaleWhere",
		or:"ProductLocaleWhere",
		not:"ProductLocaleWhere"
	},
	ProductRecipeLocaleWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		root:"ProductRecipeWhere",
		locale:"LocaleWhere",
		description:"StringCondition",
		and:"ProductRecipeLocaleWhere",
		or:"ProductRecipeLocaleWhere",
		not:"ProductRecipeLocaleWhere"
	},
	ProductRecipeWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		products:"ProductWhere",
		internalNote:"StringCondition",
		color:"StringCondition",
		image:"ImageWhere",
		icon:"ImageWhere",
		ingredients:"ProductIngredientItemWhere",
		needsPrepping:"BooleanCondition",
		locales:"ProductRecipeLocaleWhere",
		gutTuning:"FloatCondition",
		freshingContainer:"FreshingContainerWhere",
		description:"StringCondition",
		nutritionFacts:"NutritionFactsWhere",
		and:"ProductRecipeWhere",
		or:"ProductRecipeWhere",
		not:"ProductRecipeWhere"
	},
	ProductIngredientItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		internalOrder:"IntCondition",
		recipe:"ProductRecipeWhere",
		ingredient:"ProductIngredientWhere",
		quantity:"ProductIngredientItemQuantityWhere",
		and:"ProductIngredientItemWhere",
		or:"ProductIngredientItemWhere",
		not:"ProductIngredientItemWhere"
	},
	ProductIngredientItemQuantityWhere:{
		id:"UUIDCondition",
		unit:"ProductIngredientItemQuantityUnitWhere",
		value:"FloatCondition",
		and:"ProductIngredientItemQuantityWhere",
		or:"ProductIngredientItemQuantityWhere",
		not:"ProductIngredientItemQuantityWhere"
	},
	NutritionFactsWhere:{
		id:"UUIDCondition",
		energyKiloJoule:"FloatCondition",
		energyKiloCalorie:"FloatCondition",
		fatsGrams:"FloatCondition",
		fatsOfWhichSaturatedGrams:"FloatCondition",
		carbohydrateGrams:"FloatCondition",
		carbohydrateOfWhichSugarsGrams:"FloatCondition",
		proteinGrams:"FloatCondition",
		fibreGrams:"FloatCondition",
		saltGrams:"FloatCondition",
		and:"NutritionFactsWhere",
		or:"NutritionFactsWhere",
		not:"NutritionFactsWhere"
	},
	DeliveryMethodLocaleWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		description:"StringCondition",
		trackingCodeUrlTemplate:"StringCondition",
		processingTitle:"StringCondition",
		processingText:"StringCondition",
		processingIconUrl:"StringCondition",
		dispatchedTitle:"StringCondition",
		dispatchedText:"StringCondition",
		dispatchedIconUrl:"StringCondition",
		fulfilledTitle:"StringCondition",
		fulfilledText:"StringCondition",
		fulfilledIconUrl:"StringCondition",
		locale:"LocaleWhere",
		root:"DeliveryMethodWhere",
		and:"DeliveryMethodLocaleWhere",
		or:"DeliveryMethodLocaleWhere",
		not:"DeliveryMethodLocaleWhere"
	},
	PipelineStageLocaleWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		root:"PipelineStageWhere",
		locale:"LocaleWhere",
		and:"PipelineStageLocaleWhere",
		or:"PipelineStageLocaleWhere",
		not:"PipelineStageLocaleWhere"
	},
	PipelineStageWhere:{
		id:"UUIDCondition",
		items:"PipelineStageItemWhere",
		pipeline:"PipelineWhere",
		order:"IntCondition",
		locales:"PipelineStageLocaleWhere",
		sentiment:"PipelineStageSentimentWhere",
		type:"PipelineStageTypeCondition",
		forms:"LeadFormWhere",
		showItemsWeight:"BooleanCondition",
		showItemsPrice:"BooleanCondition",
		and:"PipelineStageWhere",
		or:"PipelineStageWhere",
		not:"PipelineStageWhere"
	},
	PipelineStageItemWhere:{
		id:"UUIDCondition",
		list:"PipelineStageWhere",
		lead:"PipelineLeadWhere",
		order:"IntCondition",
		and:"PipelineStageItemWhere",
		or:"PipelineStageItemWhere",
		not:"PipelineStageItemWhere"
	},
	PipelineLeadWhere:{
		id:"UUIDCondition",
		createdAt:"DateTimeCondition",
		stageItem:"PipelineStageItemWhere",
		contactPerson:"StringCondition",
		customer:"CustomerWhere",
		cafeType:"StringCondition",
		offerType:"StringCondition",
		ownMachine:"BooleanCondition",
		customerCity:"StringCondition",
		companyId:"StringCondition",
		customerName:"StringCondition",
		email:"StringCondition",
		phone:"StringCondition",
		form:"LeadFormWhere",
		meta:"StringCondition",
		multiroasterType:"StringCondition",
		and:"PipelineLeadWhere",
		or:"PipelineLeadWhere",
		not:"PipelineLeadWhere"
	},
	LeadFormWhere:{
		id:"UUIDCondition",
		code:"StringCondition",
		stage:"PipelineStageWhere",
		leads:"PipelineLeadWhere",
		and:"LeadFormWhere",
		or:"LeadFormWhere",
		not:"LeadFormWhere"
	},
	PipelineWhere:{
		id:"UUIDCondition",
		unique:"OneCondition",
		stages:"PipelineStageWhere",
		and:"PipelineWhere",
		or:"PipelineWhere",
		not:"PipelineWhere"
	},
	PipelineStageSentimentWhere:{
		id:"UUIDCondition",
		internalName:"StringCondition",
		backgroundColor:"StringCondition",
		textColor:"StringCondition",
		and:"PipelineStageSentimentWhere",
		or:"PipelineStageSentimentWhere",
		not:"PipelineStageSentimentWhere"
	},
	PipelineStageTypeCondition:{
		and:"PipelineStageTypeCondition",
		or:"PipelineStageTypeCondition",
		not:"PipelineStageTypeCondition",
		eq:"PipelineStageType",
		notEq:"PipelineStageType",
		in:"PipelineStageType",
		notIn:"PipelineStageType",
		lt:"PipelineStageType",
		lte:"PipelineStageType",
		gt:"PipelineStageType",
		gte:"PipelineStageType"
	},
	PipelineStageType: true,
	SubscriptionBoxLocaleWhere:{
		id:"UUIDCondition",
		title:"StringCondition",
		stickerText:"StringCondition",
		descriptionText:"StringCondition",
		root:"SubscriptionBoxWhere",
		locale:"LocaleWhere",
		secondaryTitle:"StringCondition",
		texts:"TextListWhere",
		secondaryTexts:"TextListWhere",
		and:"SubscriptionBoxLocaleWhere",
		or:"SubscriptionBoxLocaleWhere",
		not:"SubscriptionBoxLocaleWhere"
	},
	SubscriptionBoxWhere:{
		id:"UUIDCondition",
		locales:"SubscriptionBoxLocaleWhere",
		unique:"OneCondition",
		and:"SubscriptionBoxWhere",
		or:"SubscriptionBoxWhere",
		not:"SubscriptionBoxWhere"
	},
	PreparedPackingQuantityWhere:{
		id:"UUIDCondition",
		date:"DateCondition",
		quantity:"FloatCondition",
		recipe:"ProductRecipeWhere",
		packing:"ProductPackingWhere",
		packedInCardboard:"BooleanCondition",
		and:"PreparedPackingQuantityWhere",
		or:"PreparedPackingQuantityWhere",
		not:"PreparedPackingQuantityWhere"
	},
	ProductStockWhere:{
		id:"UUIDCondition",
		quantity:"IntCondition",
		product:"ProductWhere",
		store:"StoreWhere",
		and:"ProductStockWhere",
		or:"ProductStockWhere",
		not:"ProductStockWhere"
	},
	StoreWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		code:"StringCondition",
		description:"StringCondition",
		internalNote:"StringCondition",
		and:"StoreWhere",
		or:"StoreWhere",
		not:"StoreWhere"
	},
	ProductGroupPriceWhere:{
		id:"UUIDCondition",
		priceCents:"IntCondition",
		group:"CustomerGroupWhere",
		product:"ProductWhere",
		and:"ProductGroupPriceWhere",
		or:"ProductGroupPriceWhere",
		not:"ProductGroupPriceWhere"
	},
	CustomerGroupWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		productPrices:"ProductGroupPriceWhere",
		customers:"CustomerWhere",
		discountPermille:"IntCondition",
		code:"StringCondition",
		doubleshotLegacyId:"StringCondition",
		and:"CustomerGroupWhere",
		or:"CustomerGroupWhere",
		not:"CustomerGroupWhere"
	},
	ProductAvailabilityCondition:{
		and:"ProductAvailabilityCondition",
		or:"ProductAvailabilityCondition",
		not:"ProductAvailabilityCondition",
		eq:"ProductAvailability",
		notEq:"ProductAvailability",
		in:"ProductAvailability",
		notIn:"ProductAvailability",
		lt:"ProductAvailability",
		lte:"ProductAvailability",
		gt:"ProductAvailability",
		gte:"ProductAvailability"
	},
	ProductAvailability: true,
	ProductCustomerPriceWhere:{
		id:"UUIDCondition",
		groupDiscountPermille:"IntCondition",
		groupPriceCents:"IntCondition",
		fullPriceCents:"IntCondition",
		discountedPriceCents:"IntCondition",
		priceCents:"IntCondition",
		offered:"BooleanCondition",
		notDiscountable:"BooleanCondition",
		customer:"CustomerWhere",
		product:"ProductWhere",
		and:"ProductCustomerPriceWhere",
		or:"ProductCustomerPriceWhere",
		not:"ProductCustomerPriceWhere"
	},
	ProductMetadataWhere:{
		id:"UUIDCondition",
		archived:"BooleanCondition",
		available:"BooleanCondition",
		availableQuantity:"IntCondition",
		product:"ProductWhere",
		and:"ProductMetadataWhere",
		or:"ProductMetadataWhere",
		not:"ProductMetadataWhere"
	},
	ProductSalesDayWhere:{
		id:"UUIDCondition",
		productName:"StringCondition",
		orderDate:"DateCondition",
		priceCentsSum:"IntCondition",
		sum:"IntCondition",
		product:"ProductWhere",
		and:"ProductSalesDayWhere",
		or:"ProductSalesDayWhere",
		not:"ProductSalesDayWhere"
	},
	ProductSalesWeekWhere:{
		id:"UUIDCondition",
		productName:"StringCondition",
		orderDate:"DateCondition",
		priceCentsSum:"IntCondition",
		sum:"IntCondition",
		product:"ProductWhere",
		and:"ProductSalesWeekWhere",
		or:"ProductSalesWeekWhere",
		not:"ProductSalesWeekWhere"
	},
	ProductSalesMonthWhere:{
		id:"UUIDCondition",
		productName:"StringCondition",
		orderDate:"DateCondition",
		priceCentsSum:"IntCondition",
		sum:"IntCondition",
		product:"ProductWhere",
		and:"ProductSalesMonthWhere",
		or:"ProductSalesMonthWhere",
		not:"ProductSalesMonthWhere"
	},
	AddressMetadataWhere:{
		id:"UUIDCondition",
		deliveryZoneType:"DeliveryZoneTypeCondition",
		address:"AddressWhere",
		deliveryZone:"DeliveryZoneWhere",
		and:"AddressMetadataWhere",
		or:"AddressMetadataWhere",
		not:"AddressMetadataWhere"
	},
	DeliveryTimelinePresetWhere:{
		id:"UUIDCondition",
		type:"DeliveryTimelineTypeCondition",
		duration:"StringCondition",
		window:"StringCondition",
		deliveryMethod:"DeliveryMethodWhere",
		and:"DeliveryTimelinePresetWhere",
		or:"DeliveryTimelinePresetWhere",
		not:"DeliveryTimelinePresetWhere"
	},
	DeliveryTimelineTypeCondition:{
		and:"DeliveryTimelineTypeCondition",
		or:"DeliveryTimelineTypeCondition",
		not:"DeliveryTimelineTypeCondition",
		eq:"DeliveryTimelineType",
		notEq:"DeliveryTimelineType",
		in:"DeliveryTimelineType",
		notIn:"DeliveryTimelineType",
		lt:"DeliveryTimelineType",
		lte:"DeliveryTimelineType",
		gt:"DeliveryTimelineType",
		gte:"DeliveryTimelineType"
	},
	DeliveryTimelineType: true,
	PaymentMethodTypeCondition:{
		and:"PaymentMethodTypeCondition",
		or:"PaymentMethodTypeCondition",
		not:"PaymentMethodTypeCondition",
		eq:"PaymentMethodType",
		notEq:"PaymentMethodType",
		in:"PaymentMethodType",
		notIn:"PaymentMethodType",
		lt:"PaymentMethodType",
		lte:"PaymentMethodType",
		gt:"PaymentMethodType",
		gte:"PaymentMethodType"
	},
	PaymentMethodType: true,
	CustomerPermissionsWhere:{
		id:"UUIDCondition",
		canPlaceOrder:"BooleanCondition",
		customer:"CustomerWhere",
		and:"CustomerPermissionsWhere",
		or:"CustomerPermissionsWhere",
		not:"CustomerPermissionsWhere"
	},
	CustomerNameWhere:{
		id:"UUIDCondition",
		nominative:"StringCondition",
		vocative:"StringCondition",
		customer:"CustomerWhere",
		aliases:"CustomerAliasWhere",
		and:"CustomerNameWhere",
		or:"CustomerNameWhere",
		not:"CustomerNameWhere"
	},
	CustomerAliasWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		order:"IntCondition",
		and:"CustomerAliasWhere",
		or:"CustomerAliasWhere",
		not:"CustomerAliasWhere"
	},
	CustomerFamiliarityCondition:{
		and:"CustomerFamiliarityCondition",
		or:"CustomerFamiliarityCondition",
		not:"CustomerFamiliarityCondition",
		eq:"CustomerFamiliarity",
		notEq:"CustomerFamiliarity",
		in:"CustomerFamiliarity",
		notIn:"CustomerFamiliarity",
		lt:"CustomerFamiliarity",
		lte:"CustomerFamiliarity",
		gt:"CustomerFamiliarity",
		gte:"CustomerFamiliarity"
	},
	CustomerFamiliarity: true,
	ApplicationShortcutListWhere:{
		id:"UUIDCondition",
		items:"ApplicationShortcutListItemWhere",
		customer:"CustomerWhere",
		and:"ApplicationShortcutListWhere",
		or:"ApplicationShortcutListWhere",
		not:"ApplicationShortcutListWhere"
	},
	ApplicationShortcutListItemWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		application:"ApplicationWhere",
		list:"ApplicationShortcutListWhere",
		and:"ApplicationShortcutListItemWhere",
		or:"ApplicationShortcutListItemWhere",
		not:"ApplicationShortcutListItemWhere"
	},
	ApplicationWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		handle:"StringCondition",
		url:"StringCondition",
		color:"StringCondition",
		icon:"ImageWhere",
		name:"StringCondition",
		short:"StringCondition",
		and:"ApplicationWhere",
		or:"ApplicationWhere",
		not:"ApplicationWhere"
	},
	InvoicingPlanWhere:{
		id:"UUIDCondition",
		customer:"CustomerWhere",
		preset:"InvoicingPresetWhere",
		and:"InvoicingPlanWhere",
		or:"InvoicingPlanWhere",
		not:"InvoicingPlanWhere"
	},
	InvoicingPresetWhere:{
		id:"UUIDCondition",
		type:"InvoicingPresetTypeCondition",
		startsAt:"DateTimeCondition",
		endsAt:"DateTimeCondition",
		intervalOfDays:"IntCondition",
		invoicingPlan:"InvoicingPlanWhere",
		and:"InvoicingPresetWhere",
		or:"InvoicingPresetWhere",
		not:"InvoicingPresetWhere"
	},
	InvoicingPresetTypeCondition:{
		and:"InvoicingPresetTypeCondition",
		or:"InvoicingPresetTypeCondition",
		not:"InvoicingPresetTypeCondition",
		eq:"InvoicingPresetType",
		notEq:"InvoicingPresetType",
		in:"InvoicingPresetType",
		notIn:"InvoicingPresetType",
		lt:"InvoicingPresetType",
		lte:"InvoicingPresetType",
		gt:"InvoicingPresetType",
		gte:"InvoicingPresetType"
	},
	InvoicingPresetType: true,
	CustomerSpendingWhere:{
		id:"UUIDCondition",
		totalCents:"IntCondition",
		customer:"CustomerWhere",
		and:"CustomerSpendingWhere",
		or:"CustomerSpendingWhere",
		not:"CustomerSpendingWhere"
	},
	CustomerMetadataWhere:{
		id:"UUIDCondition",
		isBusiness:"BooleanCondition",
		name:"StringCondition",
		fallbackName:"StringCondition",
		remainingCreditsCents:"IntCondition",
		ordersTotalCents:"IntCondition",
		customerProfileUrl:"StringCondition",
		customer:"CustomerWhere",
		and:"CustomerMetadataWhere",
		or:"CustomerMetadataWhere",
		not:"CustomerMetadataWhere"
	},
	GpsWhere:{
		id:"UUIDCondition",
		latitude:"FloatCondition",
		longitude:"FloatCondition",
		address:"AddressWhere",
		and:"GpsWhere",
		or:"GpsWhere",
		not:"GpsWhere"
	},
	AddressOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		firstName:"OrderDirection",
		lastName:"OrderDirection",
		addressLine2:"OrderDirection",
		email:"OrderDirection",
		phone:"OrderDirection",
		companyName:"OrderDirection",
		companyIdentifier:"OrderDirection",
		vatIdentifier:"OrderDirection",
		externalIdentifier:"OrderDirection",
		hidden:"OrderDirection",
		customer:"CustomerOrderBy",
		internalNote:"OrderDirection",
		country:"CountryOrderBy",
		deletedAt:"OrderDirection",
		note:"OrderDirection",
		googlePlaceId:"OrderDirection",
		raw:"OrderDirection",
		formatted:"OrderDirection",
		geocodeGeneratedAt:"OrderDirection",
		geocodeResponse:"OrderDirection",
		deliveryZone:"DeliveryZoneOrderBy",
		meta:"AddressMetadataOrderBy",
		gps:"GpsOrderBy",
		geocodeValid:"OrderDirection",
		fullName:"OrderDirection",
		fakturoidSubjectId:"OrderDirection",
		addressLine1:"OrderDirection",
		city:"OrderDirection",
		postalCode:"OrderDirection",
		createdAt:"OrderDirection",
		defaultDeliveryAddressOfCustomer:"CustomerOrderBy"
	},
	OrderDirection: true,
	CustomerOrderBy:{
		id:"OrderDirection",
		defaultBillingAddress:"AddressOrderBy",
		defaultPaymentMethod:"CustomerPaymentMethodOrderBy",
		permissions:"CustomerPermissionsOrderBy",
		group:"CustomerGroupOrderBy",
		photo:"ImageOrderBy",
		phone:"OrderDirection",
		name:"CustomerNameOrderBy",
		internalNote:"OrderDirection",
		welcomeMessage:"OrderDirection",
		familiarity:"OrderDirection",
		business:"BusinessCustomerOrderBy",
		shortcutList:"ApplicationShortcutListOrderBy",
		user:"UserOrderBy",
		disabledAt:"OrderDirection",
		invoicingPlan:"InvoicingPlanOrderBy",
		email:"OrderDirection",
		createdAt:"OrderDirection",
		defaultDeliveryAddress:"AddressOrderBy",
		defaultBillingSubject:"BillingSubjectOrderBy",
		prefersPackingsWithoutCardboard:"OrderDirection",
		anonymousSession:"AnonymousSessionOrderBy",
		spending:"CustomerSpendingOrderBy",
		doubleshotLegacyId:"OrderDirection",
		meta:"CustomerMetadataOrderBy",
		doubleshotLastUpdatedAt:"OrderDirection"
	},
	CustomerPaymentMethodOrderBy:{
		id:"OrderDirection",
		caption:"OrderDirection",
		data:"OrderDirection",
		customer:"CustomerOrderBy",
		paymentMethod:"PaymentMethodOrderBy"
	},
	PaymentMethodOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		code:"OrderDirection",
		enabled:"OrderDirection",
		description:"OrderDirection",
		internalNote:"OrderDirection",
		blockingDispatch:"OrderDirection",
		type:"OrderDirection",
		reduceGratuityByPercentage:"OrderDirection"
	},
	CustomerPermissionsOrderBy:{
		id:"OrderDirection",
		canPlaceOrder:"OrderDirection",
		customer:"CustomerOrderBy"
	},
	CustomerGroupOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		discountPermille:"OrderDirection",
		code:"OrderDirection",
		doubleshotLegacyId:"OrderDirection"
	},
	ImageOrderBy:{
		id:"OrderDirection",
		url:"OrderDirection",
		width:"OrderDirection",
		height:"OrderDirection",
		size:"OrderDirection",
		type:"OrderDirection",
		alt:"OrderDirection"
	},
	CustomerNameOrderBy:{
		id:"OrderDirection",
		nominative:"OrderDirection",
		vocative:"OrderDirection",
		customer:"CustomerOrderBy"
	},
	BusinessCustomerOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		customer:"CustomerOrderBy",
		category:"BusinessCategoryOrderBy",
		accountManager:"BusinessToBusinessManagerOrderBy",
		logo:"ImageOrderBy",
		note:"OrderDirection",
		doubleshotCoffeeEquipment:"DoubleshotCoffeeEquipmentOrderBy"
	},
	BusinessCategoryOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		visibleToNewCustomers:"OrderDirection",
		internalName:"OrderDirection",
		specificProducts:"ProductListOrderBy",
		seasonalProductCategories:"ProductCategoryListOrderBy",
		specificProductsProductCategories:"ProductCategoryListOrderBy",
		slug:"OrderDirection"
	},
	ProductListOrderBy:{
		id:"OrderDirection",
		businessCategory:"BusinessCategoryOrderBy"
	},
	ProductCategoryListOrderBy:{
		id:"OrderDirection",
		seasonalProductCategoriesOfBusinessCategory:"BusinessCategoryOrderBy",
		specificProductsProductCategoriesOfBusinessCategory:"BusinessCategoryOrderBy"
	},
	BusinessToBusinessManagerOrderBy:{
		id:"OrderDirection",
		staff:"StaffOrderBy",
		createdAt:"OrderDirection"
	},
	StaffOrderBy:{
		id:"OrderDirection",
		bartender:"BartenderOrderBy",
		courier:"CourierOrderBy",
		cleaner:"CleanerOrderBy",
		shiftsManager:"ShiftsManagerOrderBy",
		businessToBusinessManager:"BusinessToBusinessManagerOrderBy",
		user:"UserOrderBy",
		shiftsProfile:"ShiftsProfileOrderBy",
		stocksManager:"StocksManagerOrderBy",
		photo:"ImageOrderBy",
		courierManager:"CourierManagerOrderBy",
		picker:"PickerOrderBy",
		createdAt:"OrderDirection",
		remunerationProfile:"RemunerationProfileOrderBy",
		cashier:"CashierOrderBy",
		internalBuyer:"InternalBuyerOrderBy",
		salesManager:"SalesManagerOrderBy",
		cashierManager:"CashierManagerOrderBy"
	},
	BartenderOrderBy:{
		id:"OrderDirection",
		staff:"StaffOrderBy",
		createdAt:"OrderDirection"
	},
	CourierOrderBy:{
		id:"OrderDirection",
		staff:"StaffOrderBy",
		createdAt:"OrderDirection",
		showInPicker:"OrderDirection"
	},
	CleanerOrderBy:{
		id:"OrderDirection",
		staff:"StaffOrderBy",
		canReachTopShelf:"OrderDirection",
		createdAt:"OrderDirection"
	},
	ShiftsManagerOrderBy:{
		id:"OrderDirection",
		staff:"StaffOrderBy",
		createdAt:"OrderDirection"
	},
	UserOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		internalNote:"OrderDirection",
		staff:"StaffOrderBy",
		customer:"CustomerOrderBy",
		tenantPersonId:"OrderDirection",
		disabledAt:"OrderDirection",
		verifiedAt:"OrderDirection",
		email:"OrderDirection",
		createdAt:"OrderDirection",
		deletionRequestedAt:"OrderDirection",
		deletionExpectedAt:"OrderDirection",
		deletedAt:"OrderDirection",
		meta:"UserMetadataOrderBy",
		roles:"UserRolesOrderBy"
	},
	UserMetadataOrderBy:{
		id:"OrderDirection",
		userProfileUrl:"OrderDirection",
		tenantEmail:"OrderDirection",
		tenantPersonId:"OrderDirection",
		tenantIdentityId:"OrderDirection",
		globalRoles:"OrderDirection",
		projectRoles:"OrderDirection",
		projectRolesString:"OrderDirection",
		externalIdentifiers:"OrderDirection",
		externalIdentifiersString:"OrderDirection",
		idpSlugs:"OrderDirection",
		idpSlugsString:"OrderDirection",
		user:"UserOrderBy"
	},
	UserRolesOrderBy:{
		id:"OrderDirection",
		isCustomer:"OrderDirection",
		isStaff:"OrderDirection",
		isBartender:"OrderDirection",
		isCashier:"OrderDirection",
		isCourier:"OrderDirection",
		isCleaner:"OrderDirection",
		isShiftsManager:"OrderDirection",
		isInternalBuyer:"OrderDirection",
		isStocksManager:"OrderDirection",
		isCourierManager:"OrderDirection",
		isCashierManager:"OrderDirection",
		isBusinessToBusinessManager:"OrderDirection",
		isPicker:"OrderDirection",
		user:"UserOrderBy"
	},
	ShiftsProfileOrderBy:{
		id:"OrderDirection",
		staff:"StaffOrderBy",
		allowSelfUnassigning:"OrderDirection"
	},
	StocksManagerOrderBy:{
		id:"OrderDirection",
		staff:"StaffOrderBy",
		createdAt:"OrderDirection"
	},
	CourierManagerOrderBy:{
		id:"OrderDirection",
		staff:"StaffOrderBy",
		createdAt:"OrderDirection"
	},
	PickerOrderBy:{
		id:"OrderDirection",
		staff:"StaffOrderBy",
		createdAt:"OrderDirection"
	},
	RemunerationProfileOrderBy:{
		id:"OrderDirection",
		workMonths:"WorkMonthOrderBy",
		staff:"StaffOrderBy"
	},
	WorkMonthOrderBy:{
		id:"OrderDirection",
		year:"OrderDirection",
		month:"OrderDirection",
		hoursWorked:"OrderDirection",
		billableHours:"OrderDirection"
	},
	CashierOrderBy:{
		id:"OrderDirection",
		createdAt:"OrderDirection",
		staff:"StaffOrderBy"
	},
	InternalBuyerOrderBy:{
		id:"OrderDirection",
		createdAt:"OrderDirection",
		staff:"StaffOrderBy"
	},
	SalesManagerOrderBy:{
		id:"OrderDirection",
		staff:"StaffOrderBy",
		createdAt:"OrderDirection"
	},
	CashierManagerOrderBy:{
		id:"OrderDirection",
		createdAt:"OrderDirection",
		staff:"StaffOrderBy"
	},
	DoubleshotCoffeeEquipmentOrderBy:{
		id:"OrderDirection",
		espressoMachine:"OrderDirection",
		espressoGrinder:"OrderDirection",
		batchBrew:"OrderDirection",
		batchGrinder:"OrderDirection",
		waterFilter:"OrderDirection",
		mechanicalFilter:"OrderDirection"
	},
	ApplicationShortcutListOrderBy:{
		id:"OrderDirection",
		customer:"CustomerOrderBy"
	},
	InvoicingPlanOrderBy:{
		id:"OrderDirection",
		customer:"CustomerOrderBy",
		preset:"InvoicingPresetOrderBy"
	},
	InvoicingPresetOrderBy:{
		id:"OrderDirection",
		type:"OrderDirection",
		startsAt:"OrderDirection",
		endsAt:"OrderDirection",
		intervalOfDays:"OrderDirection",
		invoicingPlan:"InvoicingPlanOrderBy"
	},
	BillingSubjectOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		fullName:"OrderDirection",
		addressLine1:"OrderDirection",
		addressLine2:"OrderDirection",
		city:"OrderDirection",
		postalCode:"OrderDirection",
		email:"OrderDirection",
		phone:"OrderDirection",
		companyName:"OrderDirection",
		companyIdentifier:"OrderDirection",
		vatIdentifier:"OrderDirection",
		externalIdentifier:"OrderDirection",
		hidden:"OrderDirection",
		createdAt:"OrderDirection",
		deletedAt:"OrderDirection",
		note:"OrderDirection",
		internalNote:"OrderDirection",
		fakturoidSubjectId:"OrderDirection",
		country:"CountryOrderBy",
		customer:"CustomerOrderBy",
		defaultBillingSubjectOfCustomer:"CustomerOrderBy"
	},
	CountryOrderBy:{
		id:"OrderDirection",
		code:"OrderDirection",
		order:"OrderDirection"
	},
	AnonymousSessionOrderBy:{
		id:"OrderDirection",
		createdAt:"OrderDirection",
		lastActiveAt:"OrderDirection",
		anonymousSessionKey:"OrderDirection",
		email:"OrderDirection",
		name:"OrderDirection",
		internalNote:"OrderDirection",
		customer:"CustomerOrderBy"
	},
	CustomerSpendingOrderBy:{
		id:"OrderDirection",
		totalCents:"OrderDirection",
		customer:"CustomerOrderBy"
	},
	CustomerMetadataOrderBy:{
		id:"OrderDirection",
		isBusiness:"OrderDirection",
		name:"OrderDirection",
		fallbackName:"OrderDirection",
		remainingCreditsCents:"OrderDirection",
		ordersTotalCents:"OrderDirection",
		customerProfileUrl:"OrderDirection",
		customer:"CustomerOrderBy"
	},
	DeliveryZoneOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		code:"OrderDirection",
		description:"OrderDirection",
		internalNote:"OrderDirection",
		type:"OrderDirection"
	},
	AddressMetadataOrderBy:{
		id:"OrderDirection",
		deliveryZoneType:"OrderDirection",
		address:"AddressOrderBy",
		deliveryZone:"DeliveryZoneOrderBy"
	},
	GpsOrderBy:{
		id:"OrderDirection",
		latitude:"OrderDirection",
		longitude:"OrderDirection",
		address:"AddressOrderBy"
	},
	CustomerPaymentMethod:{
		customer:{
			filter:"CustomerWhere"
		},
		paymentMethod:{
			filter:"PaymentMethodWhere"
		}
	},
	Json: "String",
	PaymentMethod:{
		deliveryMethods:{
			filter:"DeliveryMethodWhere",
			orderBy:"DeliveryMethodOrderBy"
		},
		channels:{
			filter:"ChannelPaymentWhere",
			orderBy:"ChannelPaymentOrderBy"
		},
		paginateDeliveryMethods:{
			filter:"DeliveryMethodWhere",
			orderBy:"DeliveryMethodOrderBy"
		},
		paginateChannels:{
			filter:"ChannelPaymentWhere",
			orderBy:"ChannelPaymentOrderBy"
		}
	},
	DeliveryMethod:{
		paymentMethods:{
			filter:"PaymentMethodWhere",
			orderBy:"PaymentMethodOrderBy"
		},
		suitableForDeliveryZones:{
			filter:"DeliveryZoneWhere",
			orderBy:"DeliveryZoneOrderBy"
		},
		channels:{
			filter:"ChannelDeliveryWhere",
			orderBy:"ChannelDeliveryOrderBy"
		},
		courierHandlers:{
			filter:"CourierWhere",
			orderBy:"CourierOrderBy"
		},
		locales:{
			filter:"DeliveryMethodLocaleWhere",
			orderBy:"DeliveryMethodLocaleOrderBy"
		},
		timelinePreset:{
			filter:"DeliveryTimelinePresetWhere"
		},
		localesByLocale:{
			by:"DeliveryMethodLocalesByLocaleUniqueWhere",
			filter:"DeliveryMethodLocaleWhere"
		},
		paginatePaymentMethods:{
			filter:"PaymentMethodWhere",
			orderBy:"PaymentMethodOrderBy"
		},
		paginateSuitableForDeliveryZones:{
			filter:"DeliveryZoneWhere",
			orderBy:"DeliveryZoneOrderBy"
		},
		paginateChannels:{
			filter:"ChannelDeliveryWhere",
			orderBy:"ChannelDeliveryOrderBy"
		},
		paginateCourierHandlers:{
			filter:"CourierWhere",
			orderBy:"CourierOrderBy"
		},
		paginateLocales:{
			filter:"DeliveryMethodLocaleWhere",
			orderBy:"DeliveryMethodLocaleOrderBy"
		}
	},
	DeliveryZone:{
		addresses:{
			filter:"AddressWhere",
			orderBy:"AddressOrderBy"
		},
		suitableDeliveryMethods:{
			filter:"DeliveryMethodWhere",
			orderBy:"DeliveryMethodOrderBy"
		},
		deliveryZonesOfTags:{
			filter:"TagWhere",
			orderBy:"TagOrderBy"
		},
		deliveryZonesOfProducts:{
			filter:"ProductWhere",
			orderBy:"ProductOrderBy"
		},
		addressesMetadata:{
			filter:"AddressMetadataWhere",
			orderBy:"AddressMetadataOrderBy"
		},
		addressesByMeta:{
			by:"DeliveryZoneAddressesByMetaUniqueWhere",
			filter:"AddressWhere"
		},
		addressesByGps:{
			by:"DeliveryZoneAddressesByGpsUniqueWhere",
			filter:"AddressWhere"
		},
		addressesByInvoices:{
			by:"DeliveryZoneAddressesByInvoicesUniqueWhere",
			filter:"AddressWhere"
		},
		addressesByBillingAddressOfOrders:{
			by:"DeliveryZoneAddressesByBillingAddressOfOrdersUniqueWhere",
			filter:"AddressWhere"
		},
		addressesByDeliveryAddressOfOrderDeliveries:{
			by:"DeliveryZoneAddressesByDeliveryAddressOfOrderDeliveriesUniqueWhere",
			filter:"AddressWhere"
		},
		addressesByDefaultDeliveryAddressOfCustomer:{
			by:"DeliveryZoneAddressesByDefaultDeliveryAddressOfCustomerUniqueWhere",
			filter:"AddressWhere"
		},
		addressesMetadataByAddress:{
			by:"DeliveryZoneAddressesMetadataByAddressUniqueWhere",
			filter:"AddressMetadataWhere"
		},
		paginateAddresses:{
			filter:"AddressWhere",
			orderBy:"AddressOrderBy"
		},
		paginateSuitableDeliveryMethods:{
			filter:"DeliveryMethodWhere",
			orderBy:"DeliveryMethodOrderBy"
		},
		paginateDeliveryZonesOfTags:{
			filter:"TagWhere",
			orderBy:"TagOrderBy"
		},
		paginateDeliveryZonesOfProducts:{
			filter:"ProductWhere",
			orderBy:"ProductOrderBy"
		},
		paginateAddressesMetadata:{
			filter:"AddressMetadataWhere",
			orderBy:"AddressMetadataOrderBy"
		}
	},
	DeliveryMethodOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		code:"OrderDirection",
		enabled:"OrderDirection",
		description:"OrderDirection",
		internalNote:"OrderDirection",
		requireDeliveryAddress:"OrderDirection",
		enableDeliveryTracking:"OrderDirection",
		timelinePreset:"DeliveryTimelinePresetOrderBy",
		woltDriveVenueId:"OrderDirection"
	},
	DeliveryTimelinePresetOrderBy:{
		id:"OrderDirection",
		type:"OrderDirection",
		duration:"OrderDirection",
		window:"OrderDirection",
		deliveryMethod:"DeliveryMethodOrderBy"
	},
	Tag:{
		customers:{
			filter:"CustomerWhere",
			orderBy:"CustomerOrderBy"
		},
		products:{
			filter:"ProductWhere",
			orderBy:"ProductOrderBy"
		},
		categories:{
			filter:"ProductCategoryWhere",
			orderBy:"ProductCategoryOrderBy"
		},
		addTagsOnRegistration:{
			filter:"ChannelWhere",
			orderBy:"ChannelOrderBy"
		},
		nestedCategories:{
			filter:"InheritedProductCategoryTagWhere",
			orderBy:"InheritedProductCategoryTagOrderBy"
		},
		deliveryZones:{
			filter:"DeliveryZoneWhere",
			orderBy:"DeliveryZoneOrderBy"
		},
		publicInChannels:{
			filter:"ChannelWhere",
			orderBy:"ChannelOrderBy"
		},
		allowChannelPayments:{
			filter:"ChannelPaymentWhere",
			orderBy:"ChannelPaymentOrderBy"
		},
		fulfillmentNotes:{
			filter:"FulfillmentNoteWhere",
			orderBy:"FulfillmentNoteOrderBy"
		},
		paginateCustomers:{
			filter:"CustomerWhere",
			orderBy:"CustomerOrderBy"
		},
		paginateProducts:{
			filter:"ProductWhere",
			orderBy:"ProductOrderBy"
		},
		paginateCategories:{
			filter:"ProductCategoryWhere",
			orderBy:"ProductCategoryOrderBy"
		},
		paginateAddTagsOnRegistration:{
			filter:"ChannelWhere",
			orderBy:"ChannelOrderBy"
		},
		paginateNestedCategories:{
			filter:"InheritedProductCategoryTagWhere",
			orderBy:"InheritedProductCategoryTagOrderBy"
		},
		paginateDeliveryZones:{
			filter:"DeliveryZoneWhere",
			orderBy:"DeliveryZoneOrderBy"
		},
		paginatePublicInChannels:{
			filter:"ChannelWhere",
			orderBy:"ChannelOrderBy"
		},
		paginateAllowChannelPayments:{
			filter:"ChannelPaymentWhere",
			orderBy:"ChannelPaymentOrderBy"
		},
		paginateFulfillmentNotes:{
			filter:"FulfillmentNoteWhere",
			orderBy:"FulfillmentNoteOrderBy"
		}
	},
	Product:{
		packing:{
			filter:"ProductPackingWhere"
		},
		recipe:{
			filter:"ProductRecipeWhere"
		},
		tags:{
			filter:"TagWhere",
			orderBy:"TagOrderBy"
		},
		categories:{
			filter:"ProductCategoryWhere",
			orderBy:"ProductCategoryOrderBy"
		},
		vatRate:{
			filter:"VatRateWhere"
		},
		stocks:{
			filter:"ProductStockWhere",
			orderBy:"ProductStockOrderBy"
		},
		groupPrices:{
			filter:"ProductGroupPriceWhere",
			orderBy:"ProductGroupPriceOrderBy"
		},
		image:{
			filter:"ImageWhere"
		},
		cartItems:{
			filter:"CartItemWhere",
			orderBy:"CartItemOrderBy"
		},
		manager:{
			filter:"StocksManagerWhere"
		},
		orderItems:{
			filter:"OrderItemWhere",
			orderBy:"OrderItemOrderBy"
		},
		inheritedCategories:{
			filter:"NestedProductCategoryProductWhere",
			orderBy:"NestedProductCategoryProductOrderBy"
		},
		deliveryZones:{
			filter:"DeliveryZoneWhere",
			orderBy:"DeliveryZoneOrderBy"
		},
		locales:{
			filter:"ProductLocaleWhere",
			orderBy:"ProductLocaleOrderBy"
		},
		customerPrices:{
			filter:"ProductCustomerPriceWhere",
			orderBy:"ProductCustomerPriceOrderBy"
		},
		virtualProduct:{
			filter:"VirtualProductWhere"
		},
		meta:{
			filter:"ProductMetadataWhere"
		},
		page:{
			filter:"PageWhere"
		},
		salesDays:{
			filter:"ProductSalesDayWhere",
			orderBy:"ProductSalesDayOrderBy"
		},
		salesWeeks:{
			filter:"ProductSalesWeekWhere",
			orderBy:"ProductSalesWeekOrderBy"
		},
		salesMonths:{
			filter:"ProductSalesMonthWhere",
			orderBy:"ProductSalesMonthOrderBy"
		},
		fulfillmentNotes:{
			filter:"FulfillmentNoteWhere",
			orderBy:"FulfillmentNoteOrderBy"
		},
		stocksByStore:{
			by:"ProductStocksByStoreUniqueWhere",
			filter:"ProductStockWhere"
		},
		groupPricesByGroup:{
			by:"ProductGroupPricesByGroupUniqueWhere",
			filter:"ProductGroupPriceWhere"
		},
		cartItemsByCart:{
			by:"ProductCartItemsByCartUniqueWhere",
			filter:"CartItemWhere"
		},
		orderItemsByVirtualProductEffects:{
			by:"ProductOrderItemsByVirtualProductEffectsUniqueWhere",
			filter:"OrderItemWhere"
		},
		localesByLocale:{
			by:"ProductLocalesByLocaleUniqueWhere",
			filter:"ProductLocaleWhere"
		},
		localesByFeatureList:{
			by:"ProductLocalesByFeatureListUniqueWhere",
			filter:"ProductLocaleWhere"
		},
		customerPricesByCustomer:{
			by:"ProductCustomerPricesByCustomerUniqueWhere",
			filter:"ProductCustomerPriceWhere"
		},
		paginateTags:{
			filter:"TagWhere",
			orderBy:"TagOrderBy"
		},
		paginateCategories:{
			filter:"ProductCategoryWhere",
			orderBy:"ProductCategoryOrderBy"
		},
		paginateStocks:{
			filter:"ProductStockWhere",
			orderBy:"ProductStockOrderBy"
		},
		paginateGroupPrices:{
			filter:"ProductGroupPriceWhere",
			orderBy:"ProductGroupPriceOrderBy"
		},
		paginateCartItems:{
			filter:"CartItemWhere",
			orderBy:"CartItemOrderBy"
		},
		paginateOrderItems:{
			filter:"OrderItemWhere",
			orderBy:"OrderItemOrderBy"
		},
		paginateInheritedCategories:{
			filter:"NestedProductCategoryProductWhere",
			orderBy:"NestedProductCategoryProductOrderBy"
		},
		paginateDeliveryZones:{
			filter:"DeliveryZoneWhere",
			orderBy:"DeliveryZoneOrderBy"
		},
		paginateLocales:{
			filter:"ProductLocaleWhere",
			orderBy:"ProductLocaleOrderBy"
		},
		paginateCustomerPrices:{
			filter:"ProductCustomerPriceWhere",
			orderBy:"ProductCustomerPriceOrderBy"
		},
		paginateSalesDays:{
			filter:"ProductSalesDayWhere",
			orderBy:"ProductSalesDayOrderBy"
		},
		paginateSalesWeeks:{
			filter:"ProductSalesWeekWhere",
			orderBy:"ProductSalesWeekOrderBy"
		},
		paginateSalesMonths:{
			filter:"ProductSalesMonthWhere",
			orderBy:"ProductSalesMonthOrderBy"
		},
		paginateFulfillmentNotes:{
			filter:"FulfillmentNoteWhere",
			orderBy:"FulfillmentNoteOrderBy"
		}
	},
	ProductPacking:{
		image:{
			filter:"ImageWhere"
		},
		icon:{
			filter:"ImageWhere"
		},
		locales:{
			filter:"ProductPackingLocaleWhere",
			orderBy:"ProductPackingLocaleOrderBy"
		},
		preparedPackingQuantities:{
			filter:"PreparedPackingQuantityWhere",
			orderBy:"PreparedPackingQuantityOrderBy"
		},
		localesByLocale:{
			by:"ProductPackingLocalesByLocaleUniqueWhere",
			filter:"ProductPackingLocaleWhere"
		},
		paginateLocales:{
			filter:"ProductPackingLocaleWhere",
			orderBy:"ProductPackingLocaleOrderBy"
		},
		paginatePreparedPackingQuantities:{
			filter:"PreparedPackingQuantityWhere",
			orderBy:"PreparedPackingQuantityOrderBy"
		}
	},
	ProductPackingLocale:{
		root:{
			filter:"ProductPackingWhere"
		},
		locale:{
			filter:"LocaleWhere"
		}
	},
	Locale:{
		businessCategories:{
			filter:"BusinessCategoryLocaleWhere",
			orderBy:"BusinessCategoryLocaleOrderBy"
		},
		productCategoryLists:{
			filter:"ProductCategoryListLocaleWhere",
			orderBy:"ProductCategoryListLocaleOrderBy"
		},
		productIngredients:{
			filter:"ProductIngredientLocaleWhere",
			orderBy:"ProductIngredientLocaleOrderBy"
		},
		orderRecurrences:{
			filter:"OrderRecurrenceLocaleWhere",
			orderBy:"OrderRecurrenceLocaleOrderBy"
		},
		blogs:{
			filter:"BlogLocaleWhere",
			orderBy:"BlogLocaleOrderBy"
		},
		blogPosts:{
			filter:"BlogPostLocaleWhere",
			orderBy:"BlogPostLocaleOrderBy"
		},
		identifier:{
			filter:"TranslationCataloguesIdentifierWhere"
		},
		menus:{
			filter:"MenuLocaleWhere",
			orderBy:"MenuLocaleOrderBy"
		},
		pages:{
			filter:"PageLocaleWhere",
			orderBy:"PageLocaleOrderBy"
		},
		productIngredientCategories:{
			filter:"ProductIngredientCategoryLocaleWhere",
			orderBy:"ProductIngredientCategoryLocaleOrderBy"
		},
		allergens:{
			filter:"AllergenLocaleWhere",
			orderBy:"AllergenLocaleOrderBy"
		},
		productPackings:{
			filter:"ProductPackingLocaleWhere",
			orderBy:"ProductPackingLocaleOrderBy"
		},
		products:{
			filter:"ProductLocaleWhere",
			orderBy:"ProductLocaleOrderBy"
		},
		productRecipes:{
			filter:"ProductRecipeLocaleWhere",
			orderBy:"ProductRecipeLocaleOrderBy"
		},
		pointOfSaleCategories:{
			filter:"PointOfSaleCategoryLocaleWhere",
			orderBy:"PointOfSaleCategoryLocaleOrderBy"
		},
		pointOfSaleCategoryProducts:{
			filter:"PointOfSaleCategoryProductLocaleWhere",
			orderBy:"PointOfSaleCategoryProductLocaleOrderBy"
		},
		deliveryMethods:{
			filter:"DeliveryMethodLocaleWhere",
			orderBy:"DeliveryMethodLocaleOrderBy"
		},
		ingredientSuppliers:{
			filter:"IngredientSupplierLocaleWhere",
			orderBy:"IngredientSupplierLocaleOrderBy"
		},
		identificationCodes:{
			filter:"IdentificationCodeLocaleWhere",
			orderBy:"IdentificationCodeLocaleOrderBy"
		},
		pipelineStages:{
			filter:"PipelineStageLocaleWhere",
			orderBy:"PipelineStageLocaleOrderBy"
		},
		subscriptionBoxes:{
			filter:"SubscriptionBoxLocaleWhere",
			orderBy:"SubscriptionBoxLocaleOrderBy"
		},
		businessServices:{
			filter:"BusinessServiceLocaleWhere",
			orderBy:"BusinessServiceLocaleOrderBy"
		},
		businessCategoriesByRoot:{
			by:"LocaleBusinessCategoriesByRootUniqueWhere",
			filter:"BusinessCategoryLocaleWhere"
		},
		productCategoryListsByRoot:{
			by:"LocaleProductCategoryListsByRootUniqueWhere",
			filter:"ProductCategoryListLocaleWhere"
		},
		productIngredientsByRoot:{
			by:"LocaleProductIngredientsByRootUniqueWhere",
			filter:"ProductIngredientLocaleWhere"
		},
		orderRecurrencesByRoot:{
			by:"LocaleOrderRecurrencesByRootUniqueWhere",
			filter:"OrderRecurrenceLocaleWhere"
		},
		blogsByRoot:{
			by:"LocaleBlogsByRootUniqueWhere",
			filter:"BlogLocaleWhere"
		},
		blogPostsByRoot:{
			by:"LocaleBlogPostsByRootUniqueWhere",
			filter:"BlogPostLocaleWhere"
		},
		blogPostsByCover:{
			by:"LocaleBlogPostsByCoverUniqueWhere",
			filter:"BlogPostLocaleWhere"
		},
		blogPostsByContent:{
			by:"LocaleBlogPostsByContentUniqueWhere",
			filter:"BlogPostLocaleWhere"
		},
		blogPostsByLink:{
			by:"LocaleBlogPostsByLinkUniqueWhere",
			filter:"BlogPostLocaleWhere"
		},
		blogPostsBySeo:{
			by:"LocaleBlogPostsBySeoUniqueWhere",
			filter:"BlogPostLocaleWhere"
		},
		menusByRoot:{
			by:"LocaleMenusByRootUniqueWhere",
			filter:"MenuLocaleWhere"
		},
		menusByItems:{
			by:"LocaleMenusByItemsUniqueWhere",
			filter:"MenuLocaleWhere"
		},
		menusBySecondaryItems:{
			by:"LocaleMenusBySecondaryItemsUniqueWhere",
			filter:"MenuLocaleWhere"
		},
		pagesByRoot:{
			by:"LocalePagesByRootUniqueWhere",
			filter:"PageLocaleWhere"
		},
		pagesByLink:{
			by:"LocalePagesByLinkUniqueWhere",
			filter:"PageLocaleWhere"
		},
		pagesBySeo:{
			by:"LocalePagesBySeoUniqueWhere",
			filter:"PageLocaleWhere"
		},
		pagesByContent:{
			by:"LocalePagesByContentUniqueWhere",
			filter:"PageLocaleWhere"
		},
		pagesByCover:{
			by:"LocalePagesByCoverUniqueWhere",
			filter:"PageLocaleWhere"
		},
		productIngredientCategoriesByRoot:{
			by:"LocaleProductIngredientCategoriesByRootUniqueWhere",
			filter:"ProductIngredientCategoryLocaleWhere"
		},
		allergensByRoot:{
			by:"LocaleAllergensByRootUniqueWhere",
			filter:"AllergenLocaleWhere"
		},
		productPackingsByRoot:{
			by:"LocaleProductPackingsByRootUniqueWhere",
			filter:"ProductPackingLocaleWhere"
		},
		productsByRoot:{
			by:"LocaleProductsByRootUniqueWhere",
			filter:"ProductLocaleWhere"
		},
		productsByFeatureList:{
			by:"LocaleProductsByFeatureListUniqueWhere",
			filter:"ProductLocaleWhere"
		},
		productRecipesByRoot:{
			by:"LocaleProductRecipesByRootUniqueWhere",
			filter:"ProductRecipeLocaleWhere"
		},
		pointOfSaleCategoriesByRoot:{
			by:"LocalePointOfSaleCategoriesByRootUniqueWhere",
			filter:"PointOfSaleCategoryLocaleWhere"
		},
		pointOfSaleCategoryProductsByRoot:{
			by:"LocalePointOfSaleCategoryProductsByRootUniqueWhere",
			filter:"PointOfSaleCategoryProductLocaleWhere"
		},
		deliveryMethodsByRoot:{
			by:"LocaleDeliveryMethodsByRootUniqueWhere",
			filter:"DeliveryMethodLocaleWhere"
		},
		ingredientSuppliersByRoot:{
			by:"LocaleIngredientSuppliersByRootUniqueWhere",
			filter:"IngredientSupplierLocaleWhere"
		},
		identificationCodesByRoot:{
			by:"LocaleIdentificationCodesByRootUniqueWhere",
			filter:"IdentificationCodeLocaleWhere"
		},
		pipelineStagesByRoot:{
			by:"LocalePipelineStagesByRootUniqueWhere",
			filter:"PipelineStageLocaleWhere"
		},
		subscriptionBoxesByRoot:{
			by:"LocaleSubscriptionBoxesByRootUniqueWhere",
			filter:"SubscriptionBoxLocaleWhere"
		},
		subscriptionBoxesByTexts:{
			by:"LocaleSubscriptionBoxesByTextsUniqueWhere",
			filter:"SubscriptionBoxLocaleWhere"
		},
		subscriptionBoxesBySecondaryTexts:{
			by:"LocaleSubscriptionBoxesBySecondaryTextsUniqueWhere",
			filter:"SubscriptionBoxLocaleWhere"
		},
		businessServicesByRoot:{
			by:"LocaleBusinessServicesByRootUniqueWhere",
			filter:"BusinessServiceLocaleWhere"
		},
		paginateBusinessCategories:{
			filter:"BusinessCategoryLocaleWhere",
			orderBy:"BusinessCategoryLocaleOrderBy"
		},
		paginateProductCategoryLists:{
			filter:"ProductCategoryListLocaleWhere",
			orderBy:"ProductCategoryListLocaleOrderBy"
		},
		paginateProductIngredients:{
			filter:"ProductIngredientLocaleWhere",
			orderBy:"ProductIngredientLocaleOrderBy"
		},
		paginateOrderRecurrences:{
			filter:"OrderRecurrenceLocaleWhere",
			orderBy:"OrderRecurrenceLocaleOrderBy"
		},
		paginateBlogs:{
			filter:"BlogLocaleWhere",
			orderBy:"BlogLocaleOrderBy"
		},
		paginateBlogPosts:{
			filter:"BlogPostLocaleWhere",
			orderBy:"BlogPostLocaleOrderBy"
		},
		paginateMenus:{
			filter:"MenuLocaleWhere",
			orderBy:"MenuLocaleOrderBy"
		},
		paginatePages:{
			filter:"PageLocaleWhere",
			orderBy:"PageLocaleOrderBy"
		},
		paginateProductIngredientCategories:{
			filter:"ProductIngredientCategoryLocaleWhere",
			orderBy:"ProductIngredientCategoryLocaleOrderBy"
		},
		paginateAllergens:{
			filter:"AllergenLocaleWhere",
			orderBy:"AllergenLocaleOrderBy"
		},
		paginateProductPackings:{
			filter:"ProductPackingLocaleWhere",
			orderBy:"ProductPackingLocaleOrderBy"
		},
		paginateProducts:{
			filter:"ProductLocaleWhere",
			orderBy:"ProductLocaleOrderBy"
		},
		paginateProductRecipes:{
			filter:"ProductRecipeLocaleWhere",
			orderBy:"ProductRecipeLocaleOrderBy"
		},
		paginatePointOfSaleCategories:{
			filter:"PointOfSaleCategoryLocaleWhere",
			orderBy:"PointOfSaleCategoryLocaleOrderBy"
		},
		paginatePointOfSaleCategoryProducts:{
			filter:"PointOfSaleCategoryProductLocaleWhere",
			orderBy:"PointOfSaleCategoryProductLocaleOrderBy"
		},
		paginateDeliveryMethods:{
			filter:"DeliveryMethodLocaleWhere",
			orderBy:"DeliveryMethodLocaleOrderBy"
		},
		paginateIngredientSuppliers:{
			filter:"IngredientSupplierLocaleWhere",
			orderBy:"IngredientSupplierLocaleOrderBy"
		},
		paginateIdentificationCodes:{
			filter:"IdentificationCodeLocaleWhere",
			orderBy:"IdentificationCodeLocaleOrderBy"
		},
		paginatePipelineStages:{
			filter:"PipelineStageLocaleWhere",
			orderBy:"PipelineStageLocaleOrderBy"
		},
		paginateSubscriptionBoxes:{
			filter:"SubscriptionBoxLocaleWhere",
			orderBy:"SubscriptionBoxLocaleOrderBy"
		},
		paginateBusinessServices:{
			filter:"BusinessServiceLocaleWhere",
			orderBy:"BusinessServiceLocaleOrderBy"
		}
	},
	BusinessCategoryLocale:{
		root:{
			filter:"BusinessCategoryWhere"
		},
		locale:{
			filter:"LocaleWhere"
		}
	},
	BusinessCategory:{
		locales:{
			filter:"BusinessCategoryLocaleWhere",
			orderBy:"BusinessCategoryLocaleOrderBy"
		},
		businessCustomers:{
			filter:"BusinessCustomerWhere",
			orderBy:"BusinessCustomerOrderBy"
		},
		recurrences:{
			filter:"OrderRecurrenceWhere",
			orderBy:"OrderRecurrenceOrderBy"
		},
		specificProducts:{
			filter:"ProductListWhere"
		},
		seasonalProductCategories:{
			filter:"ProductCategoryListWhere"
		},
		specificProductsProductCategories:{
			filter:"ProductCategoryListWhere"
		},
		localesByLocale:{
			by:"BusinessCategoryLocalesByLocaleUniqueWhere",
			filter:"BusinessCategoryLocaleWhere"
		},
		businessCustomersByCustomer:{
			by:"BusinessCategoryBusinessCustomersByCustomerUniqueWhere",
			filter:"BusinessCustomerWhere"
		},
		businessCustomersByBusinessServiceEvents:{
			by:"BusinessCategoryBusinessCustomersByBusinessServiceEventsUniqueWhere",
			filter:"BusinessCustomerWhere"
		},
		businessCustomersByDoubleshotCoffeeEquipment:{
			by:"BusinessCategoryBusinessCustomersByDoubleshotCoffeeEquipmentUniqueWhere",
			filter:"BusinessCustomerWhere"
		},
		paginateLocales:{
			filter:"BusinessCategoryLocaleWhere",
			orderBy:"BusinessCategoryLocaleOrderBy"
		},
		paginateBusinessCustomers:{
			filter:"BusinessCustomerWhere",
			orderBy:"BusinessCustomerOrderBy"
		},
		paginateRecurrences:{
			filter:"OrderRecurrenceWhere",
			orderBy:"OrderRecurrenceOrderBy"
		}
	},
	BusinessCategoryLocaleOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		root:"BusinessCategoryOrderBy",
		locale:"LocaleOrderBy",
		title:"OrderDirection"
	},
	LocaleOrderBy:{
		id:"OrderDirection",
		identifier:"TranslationCataloguesIdentifierOrderBy"
	},
	TranslationCataloguesIdentifierOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		code:"OrderDirection"
	},
	BusinessCustomer:{
		customer:{
			filter:"CustomerWhere"
		},
		owners:{
			filter:"CustomerWhere",
			orderBy:"CustomerOrderBy"
		},
		members:{
			filter:"CustomerWhere",
			orderBy:"CustomerOrderBy"
		},
		category:{
			filter:"BusinessCategoryWhere"
		},
		accountManager:{
			filter:"BusinessToBusinessManagerWhere"
		},
		logo:{
			filter:"ImageWhere"
		},
		businessServiceEvents:{
			filter:"BusinessServiceEventWhere",
			orderBy:"BusinessServiceEventOrderBy"
		},
		doubleshotCoffeeEquipment:{
			filter:"DoubleshotCoffeeEquipmentWhere"
		},
		paginateOwners:{
			filter:"CustomerWhere",
			orderBy:"CustomerOrderBy"
		},
		paginateMembers:{
			filter:"CustomerWhere",
			orderBy:"CustomerOrderBy"
		},
		paginateBusinessServiceEvents:{
			filter:"BusinessServiceEventWhere",
			orderBy:"BusinessServiceEventOrderBy"
		}
	},
	BusinessToBusinessManager:{
		staff:{
			filter:"StaffWhere"
		},
		managedBusinesses:{
			filter:"BusinessCustomerWhere",
			orderBy:"BusinessCustomerOrderBy"
		},
		managedBusinessesByCustomer:{
			by:"BusinessToBusinessManagerManagedBusinessesByCustomerUniqueWhere",
			filter:"BusinessCustomerWhere"
		},
		managedBusinessesByBusinessServiceEvents:{
			by:"BusinessToBusinessManagerManagedBusinessesByBusinessServiceEventsUniqueWhere",
			filter:"BusinessCustomerWhere"
		},
		managedBusinessesByDoubleshotCoffeeEquipment:{
			by:"BusinessToBusinessManagerManagedBusinessesByDoubleshotCoffeeEquipmentUniqueWhere",
			filter:"BusinessCustomerWhere"
		},
		paginateManagedBusinesses:{
			filter:"BusinessCustomerWhere",
			orderBy:"BusinessCustomerOrderBy"
		}
	},
	Staff:{
		bartender:{
			filter:"BartenderWhere"
		},
		courier:{
			filter:"CourierWhere"
		},
		cleaner:{
			filter:"CleanerWhere"
		},
		shiftsManager:{
			filter:"ShiftsManagerWhere"
		},
		businessToBusinessManager:{
			filter:"BusinessToBusinessManagerWhere"
		},
		user:{
			filter:"UserWhere"
		},
		shiftsProfile:{
			filter:"ShiftsProfileWhere"
		},
		stocksManager:{
			filter:"StocksManagerWhere"
		},
		photo:{
			filter:"ImageWhere"
		},
		courierManager:{
			filter:"CourierManagerWhere"
		},
		picker:{
			filter:"PickerWhere"
		},
		remunerationProfile:{
			filter:"RemunerationProfileWhere"
		},
		cashier:{
			filter:"CashierWhere"
		},
		venues:{
			filter:"VenueWhere",
			orderBy:"VenueOrderBy"
		},
		internalBuyer:{
			filter:"InternalBuyerWhere"
		},
		salesManager:{
			filter:"SalesManagerWhere"
		},
		cashierManager:{
			filter:"CashierManagerWhere"
		},
		paginateVenues:{
			filter:"VenueWhere",
			orderBy:"VenueOrderBy"
		}
	},
	Bartender:{
		staff:{
			filter:"StaffWhere"
		}
	},
	Courier:{
		staff:{
			filter:"StaffWhere"
		},
		routes:{
			filter:"DeliveryRouteWhere",
			orderBy:"DeliveryRouteOrderBy"
		},
		deliveryMethods:{
			filter:"DeliveryMethodWhere",
			orderBy:"DeliveryMethodOrderBy"
		},
		routesByWaypoints:{
			by:"CourierRoutesByWaypointsUniqueWhere",
			filter:"DeliveryRouteWhere"
		},
		paginateRoutes:{
			filter:"DeliveryRouteWhere",
			orderBy:"DeliveryRouteOrderBy"
		},
		paginateDeliveryMethods:{
			filter:"DeliveryMethodWhere",
			orderBy:"DeliveryMethodOrderBy"
		}
	},
	DeliveryRoute:{
		courier:{
			filter:"CourierWhere"
		},
		waypoints:{
			filter:"DeliveryWaypointWhere",
			orderBy:"DeliveryWaypointOrderBy"
		},
		waypointsByDelivery:{
			by:"DeliveryRouteWaypointsByDeliveryUniqueWhere",
			filter:"DeliveryWaypointWhere"
		},
		paginateWaypoints:{
			filter:"DeliveryWaypointWhere",
			orderBy:"DeliveryWaypointOrderBy"
		}
	},
	DeliveryWaypoint:{
		route:{
			filter:"DeliveryRouteWhere"
		},
		delivery:{
			filter:"OrderDeliveryWhere"
		}
	},
	OrderDelivery:{
		method:{
			filter:"DeliveryMethodWhere"
		},
		vatRate:{
			filter:"VatRateWhere"
		},
		order:{
			filter:"OrderWhere"
		},
		deliveryWaypoint:{
			filter:"DeliveryWaypointWhere"
		},
		events:{
			filter:"OrderEventWhere",
			orderBy:"OrderEventOrderBy"
		},
		liftagoRide:{
			filter:"LiftagoRideWhere"
		},
		address:{
			filter:"AddressWhere"
		},
		woltDriveDelivery:{
			filter:"WoltDriveDeliveryWhere"
		},
		paginateEvents:{
			filter:"OrderEventWhere",
			orderBy:"OrderEventOrderBy"
		}
	},
	VatRate:{
		channelDeliveries:{
			filter:"ChannelDeliveryWhere",
			orderBy:"ChannelDeliveryOrderBy"
		},
		channelPayments:{
			filter:"ChannelPaymentWhere",
			orderBy:"ChannelPaymentOrderBy"
		},
		paginateChannelDeliveries:{
			filter:"ChannelDeliveryWhere",
			orderBy:"ChannelDeliveryOrderBy"
		},
		paginateChannelPayments:{
			filter:"ChannelPaymentWhere",
			orderBy:"ChannelPaymentOrderBy"
		}
	},
	ChannelDelivery:{
		channel:{
			filter:"ChannelWhere"
		},
		method:{
			filter:"DeliveryMethodWhere"
		},
		vatRate:{
			filter:"VatRateWhere"
		}
	},
	Channel:{
		payments:{
			filter:"ChannelPaymentWhere",
			orderBy:"ChannelPaymentOrderBy"
		},
		deliveries:{
			filter:"ChannelDeliveryWhere",
			orderBy:"ChannelDeliveryOrderBy"
		},
		pointOfSales:{
			filter:"PointOfSaleWhere",
			orderBy:"PointOfSaleOrderBy"
		},
		carts:{
			filter:"CartWhere",
			orderBy:"CartOrderBy"
		},
		customers:{
			filter:"CustomerWhere",
			orderBy:"CustomerOrderBy"
		},
		addTagsOnRegistration:{
			filter:"TagWhere",
			orderBy:"TagOrderBy"
		},
		publicTags:{
			filter:"TagWhere",
			orderBy:"TagOrderBy"
		},
		venue:{
			filter:"VenueWhere"
		},
		cartsByItems:{
			by:"ChannelCartsByItemsUniqueWhere",
			filter:"CartWhere"
		},
		cartsByOrder:{
			by:"ChannelCartsByOrderUniqueWhere",
			filter:"CartWhere"
		},
		cartsByPriceLines:{
			by:"ChannelCartsByPriceLinesUniqueWhere",
			filter:"CartWhere"
		},
		cartsBySummary:{
			by:"ChannelCartsBySummaryUniqueWhere",
			filter:"CartWhere"
		},
		paginatePayments:{
			filter:"ChannelPaymentWhere",
			orderBy:"ChannelPaymentOrderBy"
		},
		paginateDeliveries:{
			filter:"ChannelDeliveryWhere",
			orderBy:"ChannelDeliveryOrderBy"
		},
		paginatePointOfSales:{
			filter:"PointOfSaleWhere",
			orderBy:"PointOfSaleOrderBy"
		},
		paginateCarts:{
			filter:"CartWhere",
			orderBy:"CartOrderBy"
		},
		paginateCustomers:{
			filter:"CustomerWhere",
			orderBy:"CustomerOrderBy"
		},
		paginateAddTagsOnRegistration:{
			filter:"TagWhere",
			orderBy:"TagOrderBy"
		},
		paginatePublicTags:{
			filter:"TagWhere",
			orderBy:"TagOrderBy"
		}
	},
	ChannelPayment:{
		channel:{
			filter:"ChannelWhere"
		},
		method:{
			filter:"PaymentMethodWhere"
		},
		vatRate:{
			filter:"VatRateWhere"
		},
		allowOnlyForTags:{
			filter:"TagWhere",
			orderBy:"TagOrderBy"
		},
		paginateAllowOnlyForTags:{
			filter:"TagWhere",
			orderBy:"TagOrderBy"
		}
	},
	TagOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		code:"OrderDirection",
		description:"OrderDirection",
		internalNote:"OrderDirection"
	},
	ChannelPaymentOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		channel:"ChannelOrderBy",
		method:"PaymentMethodOrderBy",
		vatRate:"VatRateOrderBy",
		requireBillingAddress:"OrderDirection",
		provideReceipt:"OrderDirection",
		requireBillingSubject:"OrderDirection"
	},
	ChannelOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		disabled:"OrderDirection",
		code:"OrderDirection",
		venue:"VenueOrderBy"
	},
	VenueOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		deadlineTemplate:"DeadlineTemplateOrderBy",
		address:"OrderDirection",
		pointOfSalePngBase64ReceiptLogo:"OrderDirection",
		pointOfSaleInitialView:"OrderDirection",
		pointOfSalePreferPrintReceipt:"OrderDirection"
	},
	DeadlineTemplateOrderBy:{
		id:"OrderDirection",
		startDate:"OrderDirection",
		period:"OrderDirection",
		cutoff:"OrderDirection",
		closed:"OrderDirection",
		venue:"VenueOrderBy"
	},
	VatRateOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		ratePermille:"OrderDirection",
		description:"OrderDirection",
		internalNote:"OrderDirection",
		preset:"OrderDirection"
	},
	ChannelDeliveryOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		priceCents:"OrderDirection",
		channel:"ChannelOrderBy",
		method:"DeliveryMethodOrderBy",
		vatRate:"VatRateOrderBy",
		defaultVisible:"OrderDirection"
	},
	PointOfSale:{
		channels:{
			filter:"ChannelWhere",
			orderBy:"ChannelOrderBy"
		},
		permissions:{
			filter:"PointOfSalePermissionsWhere"
		},
		paginateChannels:{
			filter:"ChannelWhere",
			orderBy:"ChannelOrderBy"
		}
	},
	PointOfSalePermissions:{
		pointOfSale:{
			filter:"PointOfSaleWhere"
		}
	},
	PointOfSaleOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		code:"OrderDirection",
		permissions:"PointOfSalePermissionsOrderBy",
		tenantPersonId:"OrderDirection"
	},
	PointOfSalePermissionsOrderBy:{
		id:"OrderDirection",
		canPlaceOrder:"OrderDirection",
		pointOfSale:"PointOfSaleOrderBy"
	},
	Cart:{
		items:{
			filter:"CartItemWhere",
			orderBy:"CartItemOrderBy"
		},
		channel:{
			filter:"ChannelWhere"
		},
		order:{
			filter:"OrderWhere"
		},
		customer:{
			filter:"CustomerWhere"
		},
		deliveryAddress:{
			filter:"AddressWhere"
		},
		billingAddress:{
			filter:"AddressWhere"
		},
		delivery:{
			filter:"ChannelDeliveryWhere"
		},
		payment:{
			filter:"ChannelPaymentWhere"
		},
		billingSubject:{
			filter:"BillingSubjectWhere"
		},
		priceLines:{
			filter:"CartPriceLineWhere",
			orderBy:"CartPriceLineOrderBy"
		},
		summary:{
			filter:"CartSummaryWhere"
		},
		itemsByProduct:{
			by:"CartItemsByProductUniqueWhere",
			filter:"CartItemWhere"
		},
		paginateItems:{
			filter:"CartItemWhere",
			orderBy:"CartItemOrderBy"
		},
		paginatePriceLines:{
			filter:"CartPriceLineWhere",
			orderBy:"CartPriceLineOrderBy"
		}
	},
	CartItem:{
		cart:{
			filter:"CartWhere"
		},
		product:{
			filter:"ProductWhere"
		},
		fulfillmentNotes:{
			filter:"FulfillmentNoteWhere",
			orderBy:"FulfillmentNoteOrderBy"
		},
		paginateFulfillmentNotes:{
			filter:"FulfillmentNoteWhere",
			orderBy:"FulfillmentNoteOrderBy"
		}
	},
	FulfillmentNote:{
		products:{
			filter:"ProductWhere",
			orderBy:"ProductOrderBy"
		},
		tags:{
			filter:"TagWhere",
			orderBy:"TagOrderBy"
		},
		venues:{
			filter:"VenueWhere",
			orderBy:"VenueOrderBy"
		},
		cartItems:{
			filter:"CartItemWhere",
			orderBy:"CartItemOrderBy"
		},
		orderItems:{
			filter:"OrderItemWhere",
			orderBy:"OrderItemOrderBy"
		},
		orders:{
			filter:"OrderWhere",
			orderBy:"OrderOrderBy"
		},
		paginateProducts:{
			filter:"ProductWhere",
			orderBy:"ProductOrderBy"
		},
		paginateTags:{
			filter:"TagWhere",
			orderBy:"TagOrderBy"
		},
		paginateVenues:{
			filter:"VenueWhere",
			orderBy:"VenueOrderBy"
		},
		paginateCartItems:{
			filter:"CartItemWhere",
			orderBy:"CartItemOrderBy"
		},
		paginateOrderItems:{
			filter:"OrderItemWhere",
			orderBy:"OrderItemOrderBy"
		},
		paginateOrders:{
			filter:"OrderWhere",
			orderBy:"OrderOrderBy"
		}
	},
	ProductOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		code:"OrderDirection",
		priceCents:"OrderDirection",
		notDiscountable:"OrderDirection",
		packing:"ProductPackingOrderBy",
		recipe:"ProductRecipeOrderBy",
		vatRate:"VatRateOrderBy",
		image:"ImageOrderBy",
		description:"OrderDirection",
		internalNote:"OrderDirection",
		availability:"OrderDirection",
		order:"OrderDirection",
		manager:"StocksManagerOrderBy",
		maximumQuantityPerOrder:"OrderDirection",
		archivedAt:"OrderDirection",
		virtualProduct:"VirtualProductOrderBy",
		meta:"ProductMetadataOrderBy",
		page:"PageOrderBy",
		hasSubscription:"OrderDirection",
		pointOfSaleTileColor:"OrderDirection"
	},
	ProductPackingOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		image:"ImageOrderBy",
		description:"OrderDirection",
		internalNote:"OrderDirection",
		volumeMl:"OrderDirection",
		icon:"ImageOrderBy",
		shortName:"OrderDirection",
		isPackedInCardboard:"OrderDirection"
	},
	ProductRecipeOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		internalNote:"OrderDirection",
		color:"OrderDirection",
		image:"ImageOrderBy",
		icon:"ImageOrderBy",
		needsPrepping:"OrderDirection",
		gutTuning:"OrderDirection",
		freshingContainer:"FreshingContainerOrderBy",
		description:"OrderDirection",
		nutritionFacts:"NutritionFactsOrderBy"
	},
	FreshingContainerOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		volumeMl:"OrderDirection",
		workspace:"WorkspaceOrderBy"
	},
	WorkspaceOrderBy:{
		id:"OrderDirection",
		unique:"OrderDirection",
		orderDeadlineTime:"OrderDirection",
		ordersLoadingDurationHours:"OrderDirection",
		freshingContainerVolumeMl:"OrderDirection",
		freshingPrepareOrderByOffsetMinutes:"OrderDirection",
		checkoutUrlTemplate:"OrderDirection",
		orderUrlTemplate:"OrderDirection",
		paymentUrlTemplate:"OrderDirection",
		customerProfileUrlTemplate:"OrderDirection",
		userProfileUrlTemplate:"OrderDirection",
		messengerUrl:"OrderDirection",
		messengerIosUrl:"OrderDirection",
		messengerAndroidUrl:"OrderDirection",
		openingHours:"WeekHoursOrderBy",
		workingHours:"WeekHoursOrderBy",
		defaultFreshingContainer:"FreshingContainerOrderBy",
		creditsProduct:"VirtualProductOrderBy",
		discountVatRate:"VatRateOrderBy",
		name:"OrderDirection",
		businessAddress:"OrderDirection"
	},
	WeekHoursOrderBy:{
		id:"OrderDirection",
		mon:"OrderDirection",
		tue:"OrderDirection",
		wed:"OrderDirection",
		thu:"OrderDirection",
		fri:"OrderDirection",
		sat:"OrderDirection",
		sun:"OrderDirection"
	},
	VirtualProductOrderBy:{
		id:"OrderDirection",
		type:"OrderDirection",
		product:"ProductOrderBy",
		voucherCreditCents:"OrderDirection",
		physicalRepresentation:"OrderDirection",
		recipientEmail:"OrderDirection"
	},
	NutritionFactsOrderBy:{
		id:"OrderDirection",
		energyKiloJoule:"OrderDirection",
		energyKiloCalorie:"OrderDirection",
		fatsGrams:"OrderDirection",
		fatsOfWhichSaturatedGrams:"OrderDirection",
		carbohydrateGrams:"OrderDirection",
		carbohydrateOfWhichSugarsGrams:"OrderDirection",
		proteinGrams:"OrderDirection",
		fibreGrams:"OrderDirection",
		saltGrams:"OrderDirection"
	},
	ProductMetadataOrderBy:{
		id:"OrderDirection",
		archived:"OrderDirection",
		available:"OrderDirection",
		availableQuantity:"OrderDirection",
		product:"ProductOrderBy"
	},
	PageOrderBy:{
		id:"OrderDirection"
	},
	Venue:{
		deadlineTemplate:{
			filter:"DeadlineTemplateWhere"
		},
		timetableDays:{
			filter:"TimetableDayWhere",
			orderBy:"TimetableDayOrderBy"
		},
		timetableTemplates:{
			filter:"TimetableTemplateWhere",
			orderBy:"TimetableTemplateOrderBy"
		},
		staffMembers:{
			filter:"StaffWhere",
			orderBy:"StaffOrderBy"
		},
		employeeRoles:{
			filter:"VenueEmployeeRoleWhere",
			orderBy:"VenueEmployeeRoleOrderBy"
		},
		pointOfSaleApplicationDevices:{
			filter:"PointOfSaleApplicationDeviceWhere",
			orderBy:"PointOfSaleApplicationDeviceOrderBy"
		},
		pointOfSaleTerminals:{
			filter:"PointOfSaleTerminalWhere",
			orderBy:"PointOfSaleTerminalOrderBy"
		},
		pointOfSalePrinters:{
			filter:"PointOfSalePrinterWhere",
			orderBy:"PointOfSalePrinterOrderBy"
		},
		orders:{
			filter:"OrderWhere",
			orderBy:"OrderOrderBy"
		},
		fulfillmentNotes:{
			filter:"FulfillmentNoteWhere",
			orderBy:"FulfillmentNoteOrderBy"
		},
		areas:{
			filter:"AreaWhere",
			orderBy:"AreaOrderBy"
		},
		enabledUnassignReasons:{
			filter:"UnassignReasonWhere",
			orderBy:"UnassignReasonOrderBy"
		},
		categories:{
			filter:"PointOfSaleCategoryWhere",
			orderBy:"PointOfSaleCategoryOrderBy"
		},
		channels:{
			filter:"ChannelWhere",
			orderBy:"ChannelOrderBy"
		},
		timetableDaysByDate:{
			by:"VenueTimetableDaysByDateUniqueWhere",
			filter:"TimetableDayWhere"
		},
		timetableDaysByShiftGroups:{
			by:"VenueTimetableDaysByShiftGroupsUniqueWhere",
			filter:"TimetableDayWhere"
		},
		timetableDaysByNotes:{
			by:"VenueTimetableDaysByNotesUniqueWhere",
			filter:"TimetableDayWhere"
		},
		timetableDaysByMeta:{
			by:"VenueTimetableDaysByMetaUniqueWhere",
			filter:"TimetableDayWhere"
		},
		timetableTemplatesByStaffOptions:{
			by:"VenueTimetableTemplatesByStaffOptionsUniqueWhere",
			filter:"TimetableTemplateWhere"
		},
		employeeRolesByRole:{
			by:"VenueEmployeeRolesByRoleUniqueWhere",
			filter:"VenueEmployeeRoleWhere"
		},
		employeeRolesByEmployeePrivileges:{
			by:"VenueEmployeeRolesByEmployeePrivilegesUniqueWhere",
			filter:"VenueEmployeeRoleWhere"
		},
		pointOfSaleApplicationDevicesByIdentifier:{
			by:"VenuePointOfSaleApplicationDevicesByIdentifierUniqueWhere",
			filter:"PointOfSaleApplicationDeviceWhere"
		},
		pointOfSaleTerminalsByApplicationDevices:{
			by:"VenuePointOfSaleTerminalsByApplicationDevicesUniqueWhere",
			filter:"PointOfSaleTerminalWhere"
		},
		pointOfSalePrintersByApplicationDevicesReceipt:{
			by:"VenuePointOfSalePrintersByApplicationDevicesReceiptUniqueWhere",
			filter:"PointOfSalePrinterWhere"
		},
		ordersBySeq:{
			by:"VenueOrdersBySeqUniqueWhere",
			filter:"OrderWhere"
		},
		ordersByDoubleshotLegacyId:{
			by:"VenueOrdersByDoubleshotLegacyIdUniqueWhere",
			filter:"OrderWhere"
		},
		ordersByDoubleShotLegacyNumber:{
			by:"VenueOrdersByDoubleShotLegacyNumberUniqueWhere",
			filter:"OrderWhere"
		},
		ordersByDiscounts:{
			by:"VenueOrdersByDiscountsUniqueWhere",
			filter:"OrderWhere"
		},
		ordersByDelivery:{
			by:"VenueOrdersByDeliveryUniqueWhere",
			filter:"OrderWhere"
		},
		ordersByItems:{
			by:"VenueOrdersByItemsUniqueWhere",
			filter:"OrderWhere"
		},
		ordersByCart:{
			by:"VenueOrdersByCartUniqueWhere",
			filter:"OrderWhere"
		},
		ordersByEvents:{
			by:"VenueOrdersByEventsUniqueWhere",
			filter:"OrderWhere"
		},
		ordersByPriceLines:{
			by:"VenueOrdersByPriceLinesUniqueWhere",
			filter:"OrderWhere"
		},
		ordersByPayments:{
			by:"VenueOrdersByPaymentsUniqueWhere",
			filter:"OrderWhere"
		},
		ordersBySummary:{
			by:"VenueOrdersBySummaryUniqueWhere",
			filter:"OrderWhere"
		},
		ordersByGratuity:{
			by:"VenueOrdersByGratuityUniqueWhere",
			filter:"OrderWhere"
		},
		areasByTables:{
			by:"VenueAreasByTablesUniqueWhere",
			filter:"AreaWhere"
		},
		areasByLines:{
			by:"VenueAreasByLinesUniqueWhere",
			filter:"AreaWhere"
		},
		categoriesBySlug:{
			by:"VenueCategoriesBySlugUniqueWhere",
			filter:"PointOfSaleCategoryWhere"
		},
		categoriesByLocales:{
			by:"VenueCategoriesByLocalesUniqueWhere",
			filter:"PointOfSaleCategoryWhere"
		},
		categoriesByProducts:{
			by:"VenueCategoriesByProductsUniqueWhere",
			filter:"PointOfSaleCategoryWhere"
		},
		channelsByCode:{
			by:"VenueChannelsByCodeUniqueWhere",
			filter:"ChannelWhere"
		},
		channelsByPayments:{
			by:"VenueChannelsByPaymentsUniqueWhere",
			filter:"ChannelWhere"
		},
		channelsByDeliveries:{
			by:"VenueChannelsByDeliveriesUniqueWhere",
			filter:"ChannelWhere"
		},
		channelsByCarts:{
			by:"VenueChannelsByCartsUniqueWhere",
			filter:"ChannelWhere"
		},
		paginateTimetableDays:{
			filter:"TimetableDayWhere",
			orderBy:"TimetableDayOrderBy"
		},
		paginateTimetableTemplates:{
			filter:"TimetableTemplateWhere",
			orderBy:"TimetableTemplateOrderBy"
		},
		paginateStaffMembers:{
			filter:"StaffWhere",
			orderBy:"StaffOrderBy"
		},
		paginateEmployeeRoles:{
			filter:"VenueEmployeeRoleWhere",
			orderBy:"VenueEmployeeRoleOrderBy"
		},
		paginatePointOfSaleApplicationDevices:{
			filter:"PointOfSaleApplicationDeviceWhere",
			orderBy:"PointOfSaleApplicationDeviceOrderBy"
		},
		paginatePointOfSaleTerminals:{
			filter:"PointOfSaleTerminalWhere",
			orderBy:"PointOfSaleTerminalOrderBy"
		},
		paginatePointOfSalePrinters:{
			filter:"PointOfSalePrinterWhere",
			orderBy:"PointOfSalePrinterOrderBy"
		},
		paginateOrders:{
			filter:"OrderWhere",
			orderBy:"OrderOrderBy"
		},
		paginateFulfillmentNotes:{
			filter:"FulfillmentNoteWhere",
			orderBy:"FulfillmentNoteOrderBy"
		},
		paginateAreas:{
			filter:"AreaWhere",
			orderBy:"AreaOrderBy"
		},
		paginateEnabledUnassignReasons:{
			filter:"UnassignReasonWhere",
			orderBy:"UnassignReasonOrderBy"
		},
		paginateCategories:{
			filter:"PointOfSaleCategoryWhere",
			orderBy:"PointOfSaleCategoryOrderBy"
		},
		paginateChannels:{
			filter:"ChannelWhere",
			orderBy:"ChannelOrderBy"
		}
	},
	DeadlineTemplate:{
		venue:{
			filter:"VenueWhere"
		}
	},
	TimetableDay:{
		shiftGroups:{
			filter:"TimetableShiftGroupWhere",
			orderBy:"TimetableShiftGroupOrderBy"
		},
		notes:{
			filter:"TimetableDayNoteWhere",
			orderBy:"TimetableDayNoteOrderBy"
		},
		venue:{
			filter:"VenueWhere"
		},
		meta:{
			filter:"TimetableDayMetadataWhere"
		},
		shiftGroupsByShifts:{
			by:"TimetableDayShiftGroupsByShiftsUniqueWhere",
			filter:"TimetableShiftGroupWhere"
		},
		shiftGroupsByQueue:{
			by:"TimetableDayShiftGroupsByQueueUniqueWhere",
			filter:"TimetableShiftGroupWhere"
		},
		paginateShiftGroups:{
			filter:"TimetableShiftGroupWhere",
			orderBy:"TimetableShiftGroupOrderBy"
		},
		paginateNotes:{
			filter:"TimetableDayNoteWhere",
			orderBy:"TimetableDayNoteOrderBy"
		}
	},
	TimetableShiftGroup:{
		shifts:{
			filter:"TimetableShiftWhere",
			orderBy:"TimetableShiftOrderBy"
		},
		day:{
			filter:"TimetableDayWhere"
		},
		type:{
			filter:"TimetableEmployeeRoleWhere"
		},
		position:{
			filter:"TimetableShiftPositionWhere"
		},
		queue:{
			filter:"EmployeeQueueWhere"
		},
		generatedByTemplate:{
			filter:"TimetableTemplateWhere"
		},
		shiftsByQueueItem:{
			by:"TimetableShiftGroupShiftsByQueueItemUniqueWhere",
			filter:"TimetableShiftWhere"
		},
		shiftsBySwapInfo:{
			by:"TimetableShiftGroupShiftsBySwapInfoUniqueWhere",
			filter:"TimetableShiftWhere"
		},
		paginateShifts:{
			filter:"TimetableShiftWhere",
			orderBy:"TimetableShiftOrderBy"
		}
	},
	TimetableShift:{
		group:{
			filter:"TimetableShiftGroupWhere"
		},
		shiftsProfile:{
			filter:"ShiftsProfileWhere"
		},
		queueItem:{
			filter:"EmployeeQueueItemWhere"
		},
		swapInfo:{
			filter:"TimetableShiftSwapInfoWhere"
		}
	},
	ShiftsProfile:{
		queueItems:{
			filter:"EmployeeQueueItemWhere",
			orderBy:"EmployeeQueueItemOrderBy"
		},
		staff:{
			filter:"StaffWhere"
		},
		roles:{
			filter:"TimetableEmployeeRoleWhere",
			orderBy:"TimetableEmployeeRoleOrderBy"
		},
		shifts:{
			filter:"TimetableShiftWhere",
			orderBy:"TimetableShiftOrderBy"
		},
		queueItemsByQueue:{
			by:"ShiftsProfileQueueItemsByQueueUniqueWhere",
			filter:"EmployeeQueueItemWhere"
		},
		queueItemsByShift:{
			by:"ShiftsProfileQueueItemsByShiftUniqueWhere",
			filter:"EmployeeQueueItemWhere"
		},
		queueItemsByUnassignInfo:{
			by:"ShiftsProfileQueueItemsByUnassignInfoUniqueWhere",
			filter:"EmployeeQueueItemWhere"
		},
		queueItemsByMeta:{
			by:"ShiftsProfileQueueItemsByMetaUniqueWhere",
			filter:"EmployeeQueueItemWhere"
		},
		shiftsByQueueItem:{
			by:"ShiftsProfileShiftsByQueueItemUniqueWhere",
			filter:"TimetableShiftWhere"
		},
		shiftsBySwapInfo:{
			by:"ShiftsProfileShiftsBySwapInfoUniqueWhere",
			filter:"TimetableShiftWhere"
		},
		paginateQueueItems:{
			filter:"EmployeeQueueItemWhere",
			orderBy:"EmployeeQueueItemOrderBy"
		},
		paginateRoles:{
			filter:"TimetableEmployeeRoleWhere",
			orderBy:"TimetableEmployeeRoleOrderBy"
		},
		paginateShifts:{
			filter:"TimetableShiftWhere",
			orderBy:"TimetableShiftOrderBy"
		}
	},
	EmployeeQueueItem:{
		queue:{
			filter:"EmployeeQueueWhere"
		},
		shiftsProfile:{
			filter:"ShiftsProfileWhere"
		},
		shift:{
			filter:"TimetableShiftWhere"
		},
		unassignInfo:{
			filter:"UnassignedShiftInfoWhere"
		},
		meta:{
			filter:"EmployeeQueueItemMetadataWhere"
		}
	},
	EmployeeQueue:{
		shiftGroup:{
			filter:"TimetableShiftGroupWhere"
		},
		items:{
			filter:"EmployeeQueueItemWhere",
			orderBy:"EmployeeQueueItemOrderBy"
		},
		itemsByShiftsProfile:{
			by:"EmployeeQueueItemsByShiftsProfileUniqueWhere",
			filter:"EmployeeQueueItemWhere"
		},
		itemsByShift:{
			by:"EmployeeQueueItemsByShiftUniqueWhere",
			filter:"EmployeeQueueItemWhere"
		},
		itemsByUnassignInfo:{
			by:"EmployeeQueueItemsByUnassignInfoUniqueWhere",
			filter:"EmployeeQueueItemWhere"
		},
		itemsByMeta:{
			by:"EmployeeQueueItemsByMetaUniqueWhere",
			filter:"EmployeeQueueItemWhere"
		},
		paginateItems:{
			filter:"EmployeeQueueItemWhere",
			orderBy:"EmployeeQueueItemOrderBy"
		}
	},
	EmployeeQueueItemOrderBy:{
		id:"OrderDirection",
		start:"OrderDirection",
		end:"OrderDirection",
		queue:"EmployeeQueueOrderBy",
		shiftsProfile:"ShiftsProfileOrderBy",
		shift:"TimetableShiftOrderBy",
		unassignInfo:"UnassignedShiftInfoOrderBy",
		meta:"EmployeeQueueItemMetadataOrderBy"
	},
	EmployeeQueueOrderBy:{
		id:"OrderDirection",
		shiftGroup:"TimetableShiftGroupOrderBy",
		contemberBugFix:"OrderDirection"
	},
	TimetableShiftGroupOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		day:"TimetableDayOrderBy",
		type:"TimetableEmployeeRoleOrderBy",
		position:"TimetableShiftPositionOrderBy",
		queue:"EmployeeQueueOrderBy",
		generatedByTemplate:"TimetableTemplateOrderBy"
	},
	TimetableDayOrderBy:{
		id:"OrderDirection",
		date:"OrderDirection",
		type:"OrderDirection",
		tipsCents:"OrderDirection",
		venue:"VenueOrderBy",
		meta:"TimetableDayMetadataOrderBy"
	},
	TimetableDayMetadataOrderBy:{
		id:"OrderDirection",
		numberOfWorkers:"OrderDirection",
		tipsTotalCents:"OrderDirection",
		totalMinutes:"OrderDirection",
		tipsCentsPerMinute:"OrderDirection",
		day:"TimetableDayOrderBy"
	},
	TimetableEmployeeRoleOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		color:"OrderDirection"
	},
	TimetableShiftPositionOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		start:"OrderDirection",
		end:"OrderDirection",
		isDynamic:"OrderDirection"
	},
	TimetableTemplateOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		startDate:"OrderDirection",
		period:"OrderDirection",
		slots:"OrderDirection",
		position:"TimetableShiftPositionOrderBy",
		internalName:"OrderDirection",
		venue:"VenueOrderBy",
		employeeRole:"TimetableEmployeeRoleOrderBy",
		workdaysOnly:"OrderDirection",
		monday:"OrderDirection",
		tuesday:"OrderDirection",
		wednesday:"OrderDirection",
		thursday:"OrderDirection",
		friday:"OrderDirection",
		saturday:"OrderDirection",
		sunday:"OrderDirection",
		type:"OrderDirection"
	},
	TimetableShiftOrderBy:{
		id:"OrderDirection",
		locked:"OrderDirection",
		order:"OrderDirection",
		assigned:"OrderDirection",
		group:"TimetableShiftGroupOrderBy",
		shiftsProfile:"ShiftsProfileOrderBy",
		queueItem:"EmployeeQueueItemOrderBy",
		swapInfo:"TimetableShiftSwapInfoOrderBy",
		isOvertime:"OrderDirection"
	},
	TimetableShiftSwapInfoOrderBy:{
		id:"OrderDirection",
		assigned:"OrderDirection",
		requested:"OrderDirection",
		confirmed:"OrderDirection",
		swappedShiftsProfile:"ShiftsProfileOrderBy",
		shift:"TimetableShiftOrderBy"
	},
	UnassignedShiftInfoOrderBy:{
		id:"OrderDirection",
		hoursMissed:"OrderDirection",
		queueItem:"EmployeeQueueItemOrderBy",
		legacyReason:"OrderDirection",
		reason:"UnassignReasonOrderBy"
	},
	UnassignReasonOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		name:"OrderDirection"
	},
	EmployeeQueueItemMetadataOrderBy:{
		id:"OrderDirection",
		totalMinutes:"OrderDirection",
		queueItem:"EmployeeQueueItemOrderBy",
		includeInTipsCalculation:"OrderDirection"
	},
	EmployeeQueueItemsByShiftsProfileUniqueWhere:{
		shiftsProfile:"ShiftsProfileUniqueWhere"
	},
	ShiftsProfileUniqueWhere:{
		id:"UUID",
		queueItems:"EmployeeQueueItemUniqueWhere",
		staff:"StaffUniqueWhere",
		shifts:"TimetableShiftUniqueWhere"
	},
	EmployeeQueueItemUniqueWhere:{
		id:"UUID",
		shiftsProfile:"ShiftsProfileUniqueWhere",
		queue:"EmployeeQueueUniqueWhere",
		shift:"TimetableShiftUniqueWhere",
		unassignInfo:"UnassignedShiftInfoUniqueWhere",
		meta:"EmployeeQueueItemMetadataUniqueWhere"
	},
	EmployeeQueueUniqueWhere:{
		id:"UUID",
		shiftGroup:"TimetableShiftGroupUniqueWhere",
		items:"EmployeeQueueItemUniqueWhere"
	},
	TimetableShiftGroupUniqueWhere:{
		id:"UUID",
		shifts:"TimetableShiftUniqueWhere",
		queue:"EmployeeQueueUniqueWhere"
	},
	TimetableShiftUniqueWhere:{
		id:"UUID",
		queueItem:"EmployeeQueueItemUniqueWhere",
		swapInfo:"TimetableShiftSwapInfoUniqueWhere"
	},
	TimetableShiftSwapInfoUniqueWhere:{
		id:"UUID",
		swappedShiftsProfile:"ShiftsProfileUniqueWhere",
		shift:"TimetableShiftUniqueWhere"
	},
	UnassignedShiftInfoUniqueWhere:{
		id:"UUID",
		queueItem:"EmployeeQueueItemUniqueWhere"
	},
	EmployeeQueueItemMetadataUniqueWhere:{
		id:"UUID",
		queueItem:"EmployeeQueueItemUniqueWhere"
	},
	StaffUniqueWhere:{
		id:"UUID",
		bartender:"BartenderUniqueWhere",
		courier:"CourierUniqueWhere",
		cleaner:"CleanerUniqueWhere",
		shiftsManager:"ShiftsManagerUniqueWhere",
		businessToBusinessManager:"BusinessToBusinessManagerUniqueWhere",
		user:"UserUniqueWhere",
		shiftsProfile:"ShiftsProfileUniqueWhere",
		stocksManager:"StocksManagerUniqueWhere",
		courierManager:"CourierManagerUniqueWhere",
		picker:"PickerUniqueWhere",
		remunerationProfile:"RemunerationProfileUniqueWhere",
		cashier:"CashierUniqueWhere",
		internalBuyer:"InternalBuyerUniqueWhere",
		salesManager:"SalesManagerUniqueWhere",
		cashierManager:"CashierManagerUniqueWhere"
	},
	BartenderUniqueWhere:{
		id:"UUID",
		staff:"StaffUniqueWhere"
	},
	CourierUniqueWhere:{
		id:"UUID",
		staff:"StaffUniqueWhere",
		routes:"DeliveryRouteUniqueWhere"
	},
	DeliveryRouteUniqueWhere:{
		id:"UUID",
		waypoints:"DeliveryWaypointUniqueWhere"
	},
	DeliveryWaypointUniqueWhere:{
		id:"UUID",
		delivery:"OrderDeliveryUniqueWhere"
	},
	OrderDeliveryUniqueWhere:{
		id:"UUID",
		order:"OrderUniqueWhere",
		deliveryWaypoint:"DeliveryWaypointUniqueWhere",
		events:"OrderEventUniqueWhere",
		liftagoRide:"LiftagoRideUniqueWhere",
		woltDriveDelivery:"WoltDriveDeliveryUniqueWhere"
	},
	OrderUniqueWhere:{
		id:"UUID",
		discounts:"OrderDiscountUniqueWhere",
		delivery:"OrderDeliveryUniqueWhere",
		items:"OrderItemUniqueWhere",
		cart:"CartUniqueWhere",
		events:"OrderEventUniqueWhere",
		priceLines:"OrderPriceLineUniqueWhere",
		payments:"OrderPaymentUniqueWhere",
		summary:"OrderSummaryUniqueWhere",
		gratuity:"GratuityUniqueWhere"
	},
	OrderDiscountUniqueWhere:{
		id:"UUID",
		customerCreditTransactions:"CustomerCreditTransactionUniqueWhere",
		voucherRedemption:"VoucherRedemptionUniqueWhere"
	},
	CustomerCreditTransactionUniqueWhere:{
		id:"UUID",
		virtualProductEffect:"VirtualProductEffectUniqueWhere"
	},
	VirtualProductEffectUniqueWhere:{
		id:"UUID",
		resultCustomerCreditTransaction:"CustomerCreditTransactionUniqueWhere",
		resultVouchers:"VoucherUniqueWhere"
	},
	VoucherUniqueWhere:{
		id:"UUID",
		redemption:"VoucherRedemptionUniqueWhere"
	},
	VoucherRedemptionUniqueWhere:{
		id:"UUID",
		customerCredit:"CustomerCreditUniqueWhere",
		orderDiscount:"OrderDiscountUniqueWhere",
		voucher:"VoucherUniqueWhere"
	},
	CustomerCreditUniqueWhere:{
		id:"UUID",
		transactions:"CustomerCreditTransactionUniqueWhere",
		voucherRedemption:"VoucherRedemptionUniqueWhere"
	},
	OrderItemUniqueWhere:{
		id:"UUID",
		virtualProductEffects:"VirtualProductEffectUniqueWhere"
	},
	CartUniqueWhere:{
		id:"UUID",
		items:"CartItemUniqueWhere",
		order:"OrderUniqueWhere",
		priceLines:"CartPriceLineUniqueWhere",
		summary:"CartSummaryUniqueWhere"
	},
	CartItemUniqueWhere:{
		id:"UUID",
		cart:"CartUniqueWhere",
		product:"ProductUniqueWhere"
	},
	ProductUniqueWhere:{
		id:"UUID",
		stocks:"ProductStockUniqueWhere",
		groupPrices:"ProductGroupPriceUniqueWhere",
		cartItems:"CartItemUniqueWhere",
		orderItems:"OrderItemUniqueWhere",
		inheritedCategories:"NestedProductCategoryProductUniqueWhere",
		locales:"ProductLocaleUniqueWhere",
		customerPrices:"ProductCustomerPriceUniqueWhere",
		virtualProduct:"VirtualProductUniqueWhere",
		meta:"ProductMetadataUniqueWhere",
		page:"PageUniqueWhere",
		salesDays:"ProductSalesDayUniqueWhere",
		salesWeeks:"ProductSalesWeekUniqueWhere",
		salesMonths:"ProductSalesMonthUniqueWhere"
	},
	ProductStockUniqueWhere:{
		id:"UUID",
		product:"ProductUniqueWhere",
		store:"StoreUniqueWhere"
	},
	StoreUniqueWhere:{
		id:"UUID"
	},
	ProductGroupPriceUniqueWhere:{
		id:"UUID",
		group:"CustomerGroupUniqueWhere",
		product:"ProductUniqueWhere"
	},
	CustomerGroupUniqueWhere:{
		id:"UUID",
		productPrices:"ProductGroupPriceUniqueWhere",
		customers:"CustomerUniqueWhere"
	},
	CustomerUniqueWhere:{
		id:"UUID",
		addresses:"AddressUniqueWhere",
		defaultBillingAddress:"AddressUniqueWhere",
		defaultPaymentMethod:"CustomerPaymentMethodUniqueWhere",
		credits:"CustomerCreditUniqueWhere",
		paymentMethods:"CustomerPaymentMethodUniqueWhere",
		orders:"OrderUniqueWhere",
		permissions:"CustomerPermissionsUniqueWhere",
		name:"CustomerNameUniqueWhere",
		ingredientRatings:"CustomerIngredientRatingUniqueWhere",
		business:"BusinessCustomerUniqueWhere",
		carts:"CartUniqueWhere",
		shortcutList:"ApplicationShortcutListUniqueWhere",
		user:"UserUniqueWhere",
		invoices:"InvoiceUniqueWhere",
		invoicingPlan:"InvoicingPlanUniqueWhere",
		billingSubjects:"BillingSubjectUniqueWhere",
		offeredProducts:"ProductCustomerPriceUniqueWhere",
		defaultDeliveryAddress:"AddressUniqueWhere",
		defaultBillingSubject:"BillingSubjectUniqueWhere",
		anonymousSession:"AnonymousSessionUniqueWhere",
		boughtVouchers:"VoucherUniqueWhere",
		ownsVouchers:"VoucherUniqueWhere",
		redeemedVouchers:"VoucherRedemptionUniqueWhere",
		spending:"CustomerSpendingUniqueWhere",
		customerTabs:"CustomerTabUniqueWhere",
		lead:"PipelineLeadUniqueWhere",
		meta:"CustomerMetadataUniqueWhere"
	},
	AddressUniqueWhere:{
		id:"UUID",
		meta:"AddressMetadataUniqueWhere",
		gps:"GpsUniqueWhere",
		invoices:"InvoiceUniqueWhere",
		billingAddressOfOrders:"OrderUniqueWhere",
		deliveryAddressOfOrderDeliveries:"OrderDeliveryUniqueWhere",
		defaultDeliveryAddressOfCustomer:"CustomerUniqueWhere"
	},
	AddressMetadataUniqueWhere:{
		id:"UUID",
		address:"AddressUniqueWhere"
	},
	GpsUniqueWhere:{
		id:"UUID",
		address:"AddressUniqueWhere"
	},
	InvoiceUniqueWhere:{
		id:"UUID",
		orderPayments:"OrderPaymentUniqueWhere"
	},
	OrderPaymentUniqueWhere:{
		id:"UUID",
		events:"OrderEventUniqueWhere",
		meta:"OrderPaymentMetadataUniqueWhere"
	},
	OrderEventUniqueWhere:{
		id:"UUID"
	},
	OrderPaymentMetadataUniqueWhere:{
		id:"UUID",
		orderPayment:"OrderPaymentUniqueWhere"
	},
	CustomerPaymentMethodUniqueWhere:{
		id:"UUID"
	},
	CustomerPermissionsUniqueWhere:{
		id:"UUID",
		customer:"CustomerUniqueWhere"
	},
	CustomerNameUniqueWhere:{
		id:"UUID",
		customer:"CustomerUniqueWhere"
	},
	CustomerIngredientRatingUniqueWhere:{
		id:"UUID",
		customer:"CustomerUniqueWhere",
		ingredient:"ProductIngredientUniqueWhere"
	},
	ProductIngredientUniqueWhere:{
		id:"UUID",
		locales:"ProductIngredientLocaleUniqueWhere",
		customerRatings:"CustomerIngredientRatingUniqueWhere",
		suppliers:"IngredientSupplierListUniqueWhere"
	},
	ProductIngredientLocaleUniqueWhere:{
		id:"UUID",
		root:"ProductIngredientUniqueWhere",
		locale:"LocaleUniqueWhere"
	},
	LocaleUniqueWhere:{
		id:"UUID",
		businessCategories:"BusinessCategoryLocaleUniqueWhere",
		productCategoryLists:"ProductCategoryListLocaleUniqueWhere",
		productIngredients:"ProductIngredientLocaleUniqueWhere",
		orderRecurrences:"OrderRecurrenceLocaleUniqueWhere",
		blogs:"BlogLocaleUniqueWhere",
		blogPosts:"BlogPostLocaleUniqueWhere",
		identifier:"TranslationCataloguesIdentifierUniqueWhere",
		menus:"MenuLocaleUniqueWhere",
		pages:"PageLocaleUniqueWhere",
		productIngredientCategories:"ProductIngredientCategoryLocaleUniqueWhere",
		allergens:"AllergenLocaleUniqueWhere",
		productPackings:"ProductPackingLocaleUniqueWhere",
		products:"ProductLocaleUniqueWhere",
		productRecipes:"ProductRecipeLocaleUniqueWhere",
		pointOfSaleCategories:"PointOfSaleCategoryLocaleUniqueWhere",
		pointOfSaleCategoryProducts:"PointOfSaleCategoryProductLocaleUniqueWhere",
		deliveryMethods:"DeliveryMethodLocaleUniqueWhere",
		ingredientSuppliers:"IngredientSupplierLocaleUniqueWhere",
		identificationCodes:"IdentificationCodeLocaleUniqueWhere",
		pipelineStages:"PipelineStageLocaleUniqueWhere",
		subscriptionBoxes:"SubscriptionBoxLocaleUniqueWhere",
		businessServices:"BusinessServiceLocaleUniqueWhere"
	},
	BusinessCategoryLocaleUniqueWhere:{
		id:"UUID",
		root:"BusinessCategoryUniqueWhere",
		locale:"LocaleUniqueWhere"
	},
	BusinessCategoryUniqueWhere:{
		id:"UUID",
		locales:"BusinessCategoryLocaleUniqueWhere",
		businessCustomers:"BusinessCustomerUniqueWhere",
		specificProducts:"ProductListUniqueWhere",
		seasonalProductCategories:"ProductCategoryListUniqueWhere",
		specificProductsProductCategories:"ProductCategoryListUniqueWhere"
	},
	BusinessCustomerUniqueWhere:{
		id:"UUID",
		customer:"CustomerUniqueWhere",
		businessServiceEvents:"BusinessServiceEventUniqueWhere",
		doubleshotCoffeeEquipment:"DoubleshotCoffeeEquipmentUniqueWhere"
	},
	BusinessServiceEventUniqueWhere:{
		id:"UUID"
	},
	DoubleshotCoffeeEquipmentUniqueWhere:{
		id:"UUID"
	},
	ProductListUniqueWhere:{
		id:"UUID",
		items:"ProductListItemUniqueWhere",
		businessCategory:"BusinessCategoryUniqueWhere"
	},
	ProductListItemUniqueWhere:{
		id:"UUID"
	},
	ProductCategoryListUniqueWhere:{
		id:"UUID",
		items:"ProductCategoryListItemUniqueWhere",
		locales:"ProductCategoryListLocaleUniqueWhere",
		seasonalProductCategoriesOfBusinessCategory:"BusinessCategoryUniqueWhere",
		specificProductsProductCategoriesOfBusinessCategory:"BusinessCategoryUniqueWhere"
	},
	ProductCategoryListItemUniqueWhere:{
		id:"UUID"
	},
	ProductCategoryListLocaleUniqueWhere:{
		id:"UUID",
		root:"ProductCategoryListUniqueWhere",
		locale:"LocaleUniqueWhere"
	},
	OrderRecurrenceLocaleUniqueWhere:{
		id:"UUID",
		root:"OrderRecurrenceUniqueWhere",
		locale:"LocaleUniqueWhere"
	},
	OrderRecurrenceUniqueWhere:{
		id:"UUID",
		locales:"OrderRecurrenceLocaleUniqueWhere"
	},
	BlogLocaleUniqueWhere:{
		id:"UUID",
		root:"BlogUniqueWhere",
		locale:"LocaleUniqueWhere"
	},
	BlogUniqueWhere:{
		id:"UUID",
		unique:"One",
		locales:"BlogLocaleUniqueWhere"
	},
	BlogPostLocaleUniqueWhere:{
		id:"UUID",
		root:"BlogPostUniqueWhere",
		locale:"LocaleUniqueWhere",
		cover:"CoverUniqueWhere",
		content:"ContentUniqueWhere",
		link:"LinkableUniqueWhere",
		seo:"SeoUniqueWhere"
	},
	BlogPostUniqueWhere:{
		id:"UUID",
		locales:"BlogPostLocaleUniqueWhere"
	},
	CoverUniqueWhere:{
		id:"UUID"
	},
	ContentUniqueWhere:{
		id:"UUID",
		blocks:"ContentBlockUniqueWhere"
	},
	ContentBlockUniqueWhere:{
		id:"UUID",
		references:"ContentReferenceUniqueWhere"
	},
	ContentReferenceUniqueWhere:{
		id:"UUID",
		products:"ProductListUniqueWhere",
		productBanners:"ProductBannerListUniqueWhere",
		deliveryRegions:"DeliveryRegionsUniqueWhere"
	},
	ProductBannerListUniqueWhere:{
		id:"UUID",
		items:"ProductBannerItemUniqueWhere"
	},
	ProductBannerItemUniqueWhere:{
		id:"UUID"
	},
	DeliveryRegionsUniqueWhere:{
		id:"UUID",
		items:"DeliveryRegionsItemUniqueWhere"
	},
	DeliveryRegionsItemUniqueWhere:{
		id:"UUID",
		image:"ImageUniqueWhere",
		textList:"TextListUniqueWhere",
		gallery:"ImageListUniqueWhere"
	},
	ImageUniqueWhere:{
		id:"UUID"
	},
	TextListUniqueWhere:{
		id:"UUID",
		items:"TextItemUniqueWhere"
	},
	TextItemUniqueWhere:{
		id:"UUID"
	},
	ImageListUniqueWhere:{
		id:"UUID",
		items:"ImageListItemUniqueWhere"
	},
	ImageListItemUniqueWhere:{
		id:"UUID",
		image:"ImageUniqueWhere"
	},
	LinkableUniqueWhere:{
		id:"UUID",
		blogPost:"BlogPostLocaleUniqueWhere",
		page:"PageLocaleUniqueWhere",
		wikiPage:"WikiPageUniqueWhere",
		redirect:"RedirectUniqueWhere"
	},
	PageLocaleUniqueWhere:{
		id:"UUID",
		root:"PageUniqueWhere",
		locale:"LocaleUniqueWhere",
		link:"LinkableUniqueWhere",
		seo:"SeoUniqueWhere",
		content:"ContentUniqueWhere",
		cover:"CoverUniqueWhere"
	},
	PageUniqueWhere:{
		id:"UUID",
		locales:"PageLocaleUniqueWhere"
	},
	SeoUniqueWhere:{
		id:"UUID",
		ogImage:"ImageUniqueWhere"
	},
	WikiPageUniqueWhere:{
		id:"UUID",
		link:"LinkableUniqueWhere",
		children:"WikiPageUniqueWhere",
		content:"ContentUniqueWhere"
	},
	RedirectUniqueWhere:{
		id:"UUID",
		link:"LinkableUniqueWhere"
	},
	TranslationCataloguesIdentifierUniqueWhere:{
		id:"UUID",
		catalogue:"TranslationCatalogueUniqueWhere"
	},
	TranslationCatalogueUniqueWhere:{
		id:"UUID",
		domain:"TranslationDomainUniqueWhere",
		identifier:"TranslationCataloguesIdentifierUniqueWhere",
		values:"TranslationValueUniqueWhere"
	},
	TranslationDomainUniqueWhere:{
		id:"UUID",
		catalogues:"TranslationCatalogueUniqueWhere",
		keys:"TranslationKeyUniqueWhere"
	},
	TranslationKeyUniqueWhere:{
		id:"UUID",
		domain:"TranslationDomainUniqueWhere",
		values:"TranslationValueUniqueWhere"
	},
	TranslationValueUniqueWhere:{
		id:"UUID",
		catalogue:"TranslationCatalogueUniqueWhere",
		key:"TranslationKeyUniqueWhere"
	},
	MenuLocaleUniqueWhere:{
		id:"UUID",
		root:"SiteMenuUniqueWhere",
		locale:"LocaleUniqueWhere",
		items:"MenuItemUniqueWhere",
		secondaryItems:"LinkListUniqueWhere"
	},
	SiteMenuUniqueWhere:{
		id:"UUID",
		unique:"One",
		locales:"MenuLocaleUniqueWhere"
	},
	MenuItemUniqueWhere:{
		id:"UUID",
		subitems:"MenuSubitemUniqueWhere"
	},
	MenuSubitemUniqueWhere:{
		id:"UUID"
	},
	LinkListUniqueWhere:{
		id:"UUID",
		items:"LinkListItemUniqueWhere"
	},
	LinkListItemUniqueWhere:{
		id:"UUID"
	},
	ProductIngredientCategoryLocaleUniqueWhere:{
		id:"UUID",
		root:"ProductIngredientCategoryUniqueWhere",
		locale:"LocaleUniqueWhere"
	},
	ProductIngredientCategoryUniqueWhere:{
		id:"UUID",
		locales:"ProductIngredientCategoryLocaleUniqueWhere"
	},
	AllergenLocaleUniqueWhere:{
		id:"UUID",
		root:"AllergenUniqueWhere",
		locale:"LocaleUniqueWhere"
	},
	AllergenUniqueWhere:{
		id:"UUID",
		locales:"AllergenLocaleUniqueWhere"
	},
	ProductPackingLocaleUniqueWhere:{
		id:"UUID",
		root:"ProductPackingUniqueWhere",
		locale:"LocaleUniqueWhere"
	},
	ProductPackingUniqueWhere:{
		id:"UUID",
		locales:"ProductPackingLocaleUniqueWhere",
		preparedPackingQuantities:"PreparedPackingQuantityUniqueWhere"
	},
	PreparedPackingQuantityUniqueWhere:{
		id:"UUID",
		date:"Date",
		recipe:"ProductRecipeUniqueWhere",
		packing:"ProductPackingUniqueWhere"
	},
	ProductRecipeUniqueWhere:{
		id:"UUID",
		products:"ProductUniqueWhere",
		ingredients:"ProductIngredientItemUniqueWhere",
		locales:"ProductRecipeLocaleUniqueWhere",
		nutritionFacts:"NutritionFactsUniqueWhere"
	},
	ProductIngredientItemUniqueWhere:{
		id:"UUID",
		quantity:"ProductIngredientItemQuantityUniqueWhere"
	},
	ProductIngredientItemQuantityUniqueWhere:{
		id:"UUID"
	},
	ProductRecipeLocaleUniqueWhere:{
		id:"UUID",
		root:"ProductRecipeUniqueWhere",
		locale:"LocaleUniqueWhere"
	},
	NutritionFactsUniqueWhere:{
		id:"UUID"
	},
	ProductLocaleUniqueWhere:{
		id:"UUID",
		root:"ProductUniqueWhere",
		locale:"LocaleUniqueWhere",
		featureList:"TextListUniqueWhere"
	},
	PointOfSaleCategoryLocaleUniqueWhere:{
		id:"UUID",
		root:"PointOfSaleCategoryUniqueWhere",
		locale:"LocaleUniqueWhere"
	},
	PointOfSaleCategoryUniqueWhere:{
		id:"UUID",
		locales:"PointOfSaleCategoryLocaleUniqueWhere",
		products:"PointOfSaleCategoryProductUniqueWhere"
	},
	PointOfSaleCategoryProductUniqueWhere:{
		id:"UUID",
		locales:"PointOfSaleCategoryProductLocaleUniqueWhere"
	},
	PointOfSaleCategoryProductLocaleUniqueWhere:{
		id:"UUID",
		root:"PointOfSaleCategoryProductUniqueWhere",
		locale:"LocaleUniqueWhere"
	},
	DeliveryMethodLocaleUniqueWhere:{
		id:"UUID",
		locale:"LocaleUniqueWhere",
		root:"DeliveryMethodUniqueWhere"
	},
	DeliveryMethodUniqueWhere:{
		id:"UUID",
		channels:"ChannelDeliveryUniqueWhere",
		locales:"DeliveryMethodLocaleUniqueWhere",
		timelinePreset:"DeliveryTimelinePresetUniqueWhere"
	},
	ChannelDeliveryUniqueWhere:{
		id:"UUID"
	},
	DeliveryTimelinePresetUniqueWhere:{
		id:"UUID",
		deliveryMethod:"DeliveryMethodUniqueWhere"
	},
	IngredientSupplierLocaleUniqueWhere:{
		id:"UUID",
		root:"IngredientSupplierUniqueWhere",
		locale:"LocaleUniqueWhere"
	},
	IngredientSupplierUniqueWhere:{
		id:"UUID",
		locales:"IngredientSupplierLocaleUniqueWhere"
	},
	IdentificationCodeLocaleUniqueWhere:{
		id:"UUID",
		root:"IdentificationCodeUniqueWhere",
		locale:"LocaleUniqueWhere"
	},
	IdentificationCodeUniqueWhere:{
		id:"UUID",
		attempts:"IdentificationAttemptUniqueWhere",
		locales:"IdentificationCodeLocaleUniqueWhere",
		applicationDevices:"PointOfSaleApplicationDeviceUniqueWhere"
	},
	IdentificationAttemptUniqueWhere:{
		id:"UUID"
	},
	PointOfSaleApplicationDeviceUniqueWhere:{
		id:"UUID",
		identifier:"DeviceIdentifierUniqueWhere"
	},
	DeviceIdentifierUniqueWhere:{
		id:"UUID",
		device:"PointOfSaleApplicationDeviceUniqueWhere",
		meta:"DeviceIdentifierMetadataUniqueWhere"
	},
	DeviceIdentifierMetadataUniqueWhere:{
		id:"UUID",
		deviceIdentifier:"DeviceIdentifierUniqueWhere"
	},
	PipelineStageLocaleUniqueWhere:{
		id:"UUID",
		root:"PipelineStageUniqueWhere",
		locale:"LocaleUniqueWhere"
	},
	PipelineStageUniqueWhere:{
		id:"UUID",
		items:"PipelineStageItemUniqueWhere",
		locales:"PipelineStageLocaleUniqueWhere",
		forms:"LeadFormUniqueWhere"
	},
	PipelineStageItemUniqueWhere:{
		id:"UUID",
		lead:"PipelineLeadUniqueWhere"
	},
	PipelineLeadUniqueWhere:{
		id:"UUID",
		stageItem:"PipelineStageItemUniqueWhere"
	},
	LeadFormUniqueWhere:{
		id:"UUID",
		leads:"PipelineLeadUniqueWhere"
	},
	SubscriptionBoxLocaleUniqueWhere:{
		id:"UUID",
		root:"SubscriptionBoxUniqueWhere",
		locale:"LocaleUniqueWhere",
		texts:"TextListUniqueWhere",
		secondaryTexts:"TextListUniqueWhere"
	},
	SubscriptionBoxUniqueWhere:{
		id:"UUID",
		unique:"One",
		locales:"SubscriptionBoxLocaleUniqueWhere"
	},
	BusinessServiceLocaleUniqueWhere:{
		id:"UUID",
		root:"BusinessServiceUniqueWhere",
		locale:"LocaleUniqueWhere"
	},
	BusinessServiceUniqueWhere:{
		id:"UUID",
		locales:"BusinessServiceLocaleUniqueWhere"
	},
	IngredientSupplierListUniqueWhere:{
		id:"UUID",
		items:"IngredientSupplierItemUniqueWhere"
	},
	IngredientSupplierItemUniqueWhere:{
		id:"UUID"
	},
	ApplicationShortcutListUniqueWhere:{
		id:"UUID",
		items:"ApplicationShortcutListItemUniqueWhere",
		customer:"CustomerUniqueWhere"
	},
	ApplicationShortcutListItemUniqueWhere:{
		id:"UUID"
	},
	UserUniqueWhere:{
		id:"UUID",
		tenantPersonId:"UUID",
		staff:"StaffUniqueWhere",
		customer:"CustomerUniqueWhere",
		devices:"UserDeviceUniqueWhere",
		meta:"UserMetadataUniqueWhere",
		identificationAttempts:"IdentificationAttemptUniqueWhere",
		roles:"UserRolesUniqueWhere"
	},
	UserDeviceUniqueWhere:{
		id:"UUID"
	},
	UserMetadataUniqueWhere:{
		id:"UUID",
		tenantPersonId:"UUID",
		tenantIdentityId:"UUID",
		user:"UserUniqueWhere"
	},
	UserRolesUniqueWhere:{
		id:"UUID",
		user:"UserUniqueWhere"
	},
	InvoicingPlanUniqueWhere:{
		id:"UUID",
		customer:"CustomerUniqueWhere",
		preset:"InvoicingPresetUniqueWhere"
	},
	InvoicingPresetUniqueWhere:{
		id:"UUID",
		invoicingPlan:"InvoicingPlanUniqueWhere"
	},
	BillingSubjectUniqueWhere:{
		id:"UUID",
		invoices:"InvoiceUniqueWhere",
		defaultBillingSubjectOfCustomer:"CustomerUniqueWhere",
		orders:"OrderUniqueWhere"
	},
	ProductCustomerPriceUniqueWhere:{
		id:"UUID",
		product:"ProductUniqueWhere",
		customer:"CustomerUniqueWhere"
	},
	AnonymousSessionUniqueWhere:{
		id:"UUID",
		customer:"CustomerUniqueWhere",
		devices:"UserDeviceUniqueWhere"
	},
	CustomerSpendingUniqueWhere:{
		id:"UUID",
		customer:"CustomerUniqueWhere"
	},
	CustomerTabUniqueWhere:{
		id:"UUID",
		items:"CustomerTabItemUniqueWhere",
		meta:"CustomerTabMetadataUniqueWhere"
	},
	CustomerTabItemUniqueWhere:{
		id:"UUID"
	},
	CustomerTabMetadataUniqueWhere:{
		id:"UUID",
		customerTab:"CustomerTabUniqueWhere"
	},
	CustomerMetadataUniqueWhere:{
		id:"UUID",
		customer:"CustomerUniqueWhere"
	},
	NestedProductCategoryProductUniqueWhere:{
		id:"UUID"
	},
	VirtualProductUniqueWhere:{
		id:"UUID",
		product:"ProductUniqueWhere"
	},
	ProductMetadataUniqueWhere:{
		id:"UUID",
		product:"ProductUniqueWhere"
	},
	ProductSalesDayUniqueWhere:{
		id:"UUID"
	},
	ProductSalesWeekUniqueWhere:{
		id:"UUID"
	},
	ProductSalesMonthUniqueWhere:{
		id:"UUID"
	},
	CartPriceLineUniqueWhere:{
		id:"UUID"
	},
	CartSummaryUniqueWhere:{
		id:"UUID",
		cart:"CartUniqueWhere"
	},
	OrderPriceLineUniqueWhere:{
		id:"UUID",
		orderItem:"OrderItemUniqueWhere",
		orderDiscount:"OrderDiscountUniqueWhere",
		orderPayment:"OrderPaymentUniqueWhere",
		orderDelivery:"OrderDeliveryUniqueWhere"
	},
	OrderSummaryUniqueWhere:{
		id:"UUID",
		order:"OrderUniqueWhere"
	},
	GratuityUniqueWhere:{
		id:"UUID",
		order:"OrderUniqueWhere"
	},
	LiftagoRideUniqueWhere:{
		id:"UUID",
		delivery:"OrderDeliveryUniqueWhere"
	},
	WoltDriveDeliveryUniqueWhere:{
		id:"UUID",
		delivery:"OrderDeliveryUniqueWhere"
	},
	CleanerUniqueWhere:{
		id:"UUID",
		staff:"StaffUniqueWhere"
	},
	ShiftsManagerUniqueWhere:{
		id:"UUID",
		staff:"StaffUniqueWhere"
	},
	BusinessToBusinessManagerUniqueWhere:{
		id:"UUID",
		staff:"StaffUniqueWhere",
		managedBusinesses:"BusinessCustomerUniqueWhere"
	},
	StocksManagerUniqueWhere:{
		id:"UUID",
		staff:"StaffUniqueWhere",
		managedProducts:"ProductUniqueWhere"
	},
	CourierManagerUniqueWhere:{
		id:"UUID",
		staff:"StaffUniqueWhere"
	},
	PickerUniqueWhere:{
		id:"UUID",
		staff:"StaffUniqueWhere"
	},
	RemunerationProfileUniqueWhere:{
		id:"UUID",
		employmentInformation:"EmploymentInformationUniqueWhere",
		staff:"StaffUniqueWhere"
	},
	EmploymentInformationUniqueWhere:{
		id:"UUID"
	},
	CashierUniqueWhere:{
		id:"UUID",
		staff:"StaffUniqueWhere"
	},
	InternalBuyerUniqueWhere:{
		id:"UUID",
		staff:"StaffUniqueWhere"
	},
	SalesManagerUniqueWhere:{
		id:"UUID",
		staff:"StaffUniqueWhere"
	},
	CashierManagerUniqueWhere:{
		id:"UUID",
		staff:"StaffUniqueWhere"
	},
	EmployeeQueueItemsByShiftUniqueWhere:{
		shift:"TimetableShiftUniqueWhere"
	},
	EmployeeQueueItemsByUnassignInfoUniqueWhere:{
		unassignInfo:"UnassignedShiftInfoUniqueWhere"
	},
	EmployeeQueueItemsByMetaUniqueWhere:{
		meta:"EmployeeQueueItemMetadataUniqueWhere"
	},
	UnassignedShiftInfo:{
		queueItem:{
			filter:"EmployeeQueueItemWhere"
		},
		reason:{
			filter:"UnassignReasonWhere"
		}
	},
	UnassignReason:{
		venues:{
			filter:"VenueWhere",
			orderBy:"VenueOrderBy"
		},
		paginateVenues:{
			filter:"VenueWhere",
			orderBy:"VenueOrderBy"
		}
	},
	EmployeeQueueItemMetadata:{
		queueItem:{
			filter:"EmployeeQueueItemWhere"
		}
	},
	TimetableEmployeeRole:{
		shiftGroups:{
			filter:"TimetableShiftGroupWhere",
			orderBy:"TimetableShiftGroupOrderBy"
		},
		shiftsProfiles:{
			filter:"ShiftsProfileWhere",
			orderBy:"ShiftsProfileOrderBy"
		},
		shiftsManagers:{
			filter:"ShiftsManagerWhere",
			orderBy:"ShiftsManagerOrderBy"
		},
		timetableTemplates:{
			filter:"TimetableTemplateWhere",
			orderBy:"TimetableTemplateOrderBy"
		},
		shiftGroupsByShifts:{
			by:"TimetableEmployeeRoleShiftGroupsByShiftsUniqueWhere",
			filter:"TimetableShiftGroupWhere"
		},
		shiftGroupsByQueue:{
			by:"TimetableEmployeeRoleShiftGroupsByQueueUniqueWhere",
			filter:"TimetableShiftGroupWhere"
		},
		timetableTemplatesByStaffOptions:{
			by:"TimetableEmployeeRoleTimetableTemplatesByStaffOptionsUniqueWhere",
			filter:"TimetableTemplateWhere"
		},
		paginateShiftGroups:{
			filter:"TimetableShiftGroupWhere",
			orderBy:"TimetableShiftGroupOrderBy"
		},
		paginateShiftsProfiles:{
			filter:"ShiftsProfileWhere",
			orderBy:"ShiftsProfileOrderBy"
		},
		paginateShiftsManagers:{
			filter:"ShiftsManagerWhere",
			orderBy:"ShiftsManagerOrderBy"
		},
		paginateTimetableTemplates:{
			filter:"TimetableTemplateWhere",
			orderBy:"TimetableTemplateOrderBy"
		}
	},
	ShiftsManager:{
		staff:{
			filter:"StaffWhere"
		},
		managedRoles:{
			filter:"TimetableEmployeeRoleWhere",
			orderBy:"TimetableEmployeeRoleOrderBy"
		},
		paginateManagedRoles:{
			filter:"TimetableEmployeeRoleWhere",
			orderBy:"TimetableEmployeeRoleOrderBy"
		}
	},
	TimetableTemplate:{
		position:{
			filter:"TimetableShiftPositionWhere"
		},
		staffOptions:{
			filter:"TimetableTemplateStaffOptionsWhere",
			orderBy:"TimetableTemplateStaffOptionsOrderBy"
		},
		venue:{
			filter:"VenueWhere"
		},
		employeeRole:{
			filter:"TimetableEmployeeRoleWhere"
		},
		paginateStaffOptions:{
			filter:"TimetableTemplateStaffOptionsWhere",
			orderBy:"TimetableTemplateStaffOptionsOrderBy"
		}
	},
	TimetableShiftPosition:{
		shiftGroups:{
			filter:"TimetableShiftGroupWhere",
			orderBy:"TimetableShiftGroupOrderBy"
		},
		timetableTemplates:{
			filter:"TimetableTemplateWhere",
			orderBy:"TimetableTemplateOrderBy"
		},
		shiftGroupsByShifts:{
			by:"TimetableShiftPositionShiftGroupsByShiftsUniqueWhere",
			filter:"TimetableShiftGroupWhere"
		},
		shiftGroupsByQueue:{
			by:"TimetableShiftPositionShiftGroupsByQueueUniqueWhere",
			filter:"TimetableShiftGroupWhere"
		},
		timetableTemplatesByStaffOptions:{
			by:"TimetableShiftPositionTimetableTemplatesByStaffOptionsUniqueWhere",
			filter:"TimetableTemplateWhere"
		},
		paginateShiftGroups:{
			filter:"TimetableShiftGroupWhere",
			orderBy:"TimetableShiftGroupOrderBy"
		},
		paginateTimetableTemplates:{
			filter:"TimetableTemplateWhere",
			orderBy:"TimetableTemplateOrderBy"
		}
	},
	TimetableShiftPositionShiftGroupsByShiftsUniqueWhere:{
		shifts:"TimetableShiftUniqueWhere"
	},
	TimetableShiftPositionShiftGroupsByQueueUniqueWhere:{
		queue:"EmployeeQueueUniqueWhere"
	},
	TimetableShiftPositionTimetableTemplatesByStaffOptionsUniqueWhere:{
		staffOptions:"TimetableTemplateStaffOptionsUniqueWhere"
	},
	TimetableTemplateStaffOptionsUniqueWhere:{
		id:"UUID"
	},
	TimetableTemplateStaffOptions:{
		timetableTemplate:{
			filter:"TimetableTemplateWhere"
		},
		autoAssignedEmployee:{
			filter:"ShiftsProfileWhere"
		}
	},
	TimetableTemplateStaffOptionsOrderBy:{
		id:"OrderDirection",
		startTime:"OrderDirection",
		endTime:"OrderDirection",
		timetableTemplate:"TimetableTemplateOrderBy",
		autoAssignedEmployee:"ShiftsProfileOrderBy"
	},
	TimetableEmployeeRoleShiftGroupsByShiftsUniqueWhere:{
		shifts:"TimetableShiftUniqueWhere"
	},
	TimetableEmployeeRoleShiftGroupsByQueueUniqueWhere:{
		queue:"EmployeeQueueUniqueWhere"
	},
	TimetableEmployeeRoleTimetableTemplatesByStaffOptionsUniqueWhere:{
		staffOptions:"TimetableTemplateStaffOptionsUniqueWhere"
	},
	ShiftsProfileQueueItemsByQueueUniqueWhere:{
		queue:"EmployeeQueueUniqueWhere"
	},
	ShiftsProfileQueueItemsByShiftUniqueWhere:{
		shift:"TimetableShiftUniqueWhere"
	},
	ShiftsProfileQueueItemsByUnassignInfoUniqueWhere:{
		unassignInfo:"UnassignedShiftInfoUniqueWhere"
	},
	ShiftsProfileQueueItemsByMetaUniqueWhere:{
		meta:"EmployeeQueueItemMetadataUniqueWhere"
	},
	ShiftsProfileShiftsByQueueItemUniqueWhere:{
		queueItem:"EmployeeQueueItemUniqueWhere"
	},
	ShiftsProfileShiftsBySwapInfoUniqueWhere:{
		swapInfo:"TimetableShiftSwapInfoUniqueWhere"
	},
	TimetableShiftSwapInfo:{
		swappedShiftsProfile:{
			filter:"ShiftsProfileWhere"
		},
		shift:{
			filter:"TimetableShiftWhere"
		}
	},
	TimetableShiftGroupShiftsByQueueItemUniqueWhere:{
		queueItem:"EmployeeQueueItemUniqueWhere"
	},
	TimetableShiftGroupShiftsBySwapInfoUniqueWhere:{
		swapInfo:"TimetableShiftSwapInfoUniqueWhere"
	},
	TimetableDayNote:{
		day:{
			filter:"TimetableDayWhere"
		},
		role:{
			filter:"TimetableEmployeeRoleWhere"
		}
	},
	TimetableDayNoteOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		note:"OrderDirection",
		day:"TimetableDayOrderBy",
		role:"TimetableEmployeeRoleOrderBy"
	},
	TimetableDayMetadata:{
		day:{
			filter:"TimetableDayWhere"
		}
	},
	TimetableDayShiftGroupsByShiftsUniqueWhere:{
		shifts:"TimetableShiftUniqueWhere"
	},
	TimetableDayShiftGroupsByQueueUniqueWhere:{
		queue:"EmployeeQueueUniqueWhere"
	},
	VenueEmployeeRole:{
		employeePrivileges:{
			filter:"TimetablesEmployeePrivilegesWhere"
		},
		venue:{
			filter:"VenueWhere"
		},
		role:{
			filter:"TimetableEmployeeRoleWhere"
		}
	},
	TimetablesEmployeePrivileges:{
		venueEmployeeRole:{
			filter:"VenueEmployeeRoleWhere"
		}
	},
	VenueEmployeeRoleOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		employeePrivileges:"TimetablesEmployeePrivilegesOrderBy",
		venue:"VenueOrderBy",
		role:"TimetableEmployeeRoleOrderBy",
		getsTipsShare:"OrderDirection",
		notesEnabled:"OrderDirection"
	},
	TimetablesEmployeePrivilegesOrderBy:{
		id:"OrderDirection",
		venueEmployeeRole:"VenueEmployeeRoleOrderBy",
		read:"OrderDirection",
		unassign:"OrderDirection",
		assign:"OrderDirection"
	},
	PointOfSaleApplicationDevice:{
		venue:{
			filter:"VenueWhere"
		},
		identificationCode:{
			filter:"IdentificationCodeWhere"
		},
		identifier:{
			filter:"DeviceIdentifierWhere"
		},
		terminal:{
			filter:"PointOfSaleTerminalWhere"
		},
		receiptPrinter:{
			filter:"PointOfSalePrinterWhere"
		},
		ticketPrinters:{
			filter:"PointOfSalePrinterWhere",
			orderBy:"PointOfSalePrinterOrderBy"
		},
		paginateTicketPrinters:{
			filter:"PointOfSalePrinterWhere",
			orderBy:"PointOfSalePrinterOrderBy"
		}
	},
	IdentificationCode:{
		attempts:{
			filter:"IdentificationAttemptWhere",
			orderBy:"IdentificationAttemptOrderBy"
		},
		locales:{
			filter:"IdentificationCodeLocaleWhere",
			orderBy:"IdentificationCodeLocaleOrderBy"
		},
		applicationDevices:{
			filter:"PointOfSaleApplicationDeviceWhere",
			orderBy:"PointOfSaleApplicationDeviceOrderBy"
		},
		localesByLocale:{
			by:"IdentificationCodeLocalesByLocaleUniqueWhere",
			filter:"IdentificationCodeLocaleWhere"
		},
		applicationDevicesByIdentifier:{
			by:"IdentificationCodeApplicationDevicesByIdentifierUniqueWhere",
			filter:"PointOfSaleApplicationDeviceWhere"
		},
		paginateAttempts:{
			filter:"IdentificationAttemptWhere",
			orderBy:"IdentificationAttemptOrderBy"
		},
		paginateLocales:{
			filter:"IdentificationCodeLocaleWhere",
			orderBy:"IdentificationCodeLocaleOrderBy"
		},
		paginateApplicationDevices:{
			filter:"PointOfSaleApplicationDeviceWhere",
			orderBy:"PointOfSaleApplicationDeviceOrderBy"
		}
	},
	IdentificationAttempt:{
		code:{
			filter:"IdentificationCodeWhere"
		},
		user:{
			filter:"UserWhere"
		}
	},
	User:{
		staff:{
			filter:"StaffWhere"
		},
		customer:{
			filter:"CustomerWhere"
		},
		devices:{
			filter:"UserDeviceWhere",
			orderBy:"UserDeviceOrderBy"
		},
		meta:{
			filter:"UserMetadataWhere"
		},
		identificationAttempts:{
			filter:"IdentificationAttemptWhere",
			orderBy:"IdentificationAttemptOrderBy"
		},
		roles:{
			filter:"UserRolesWhere"
		},
		devicesByDeviceId:{
			by:"UserDevicesByDeviceIdUniqueWhere",
			filter:"UserDeviceWhere"
		},
		paginateDevices:{
			filter:"UserDeviceWhere",
			orderBy:"UserDeviceOrderBy"
		},
		paginateIdentificationAttempts:{
			filter:"IdentificationAttemptWhere",
			orderBy:"IdentificationAttemptOrderBy"
		}
	},
	UserDevice:{
		user:{
			filter:"UserWhere"
		},
		anonymousSession:{
			filter:"AnonymousSessionWhere"
		}
	},
	AnonymousSession:{
		customer:{
			filter:"CustomerWhere"
		},
		devices:{
			filter:"UserDeviceWhere",
			orderBy:"UserDeviceOrderBy"
		},
		devicesByDeviceId:{
			by:"AnonymousSessionDevicesByDeviceIdUniqueWhere",
			filter:"UserDeviceWhere"
		},
		paginateDevices:{
			filter:"UserDeviceWhere",
			orderBy:"UserDeviceOrderBy"
		}
	},
	UserDeviceOrderBy:{
		id:"OrderDirection",
		createdAt:"OrderDirection",
		lastActiveAt:"OrderDirection",
		platform:"OrderDirection",
		deviceId:"OrderDirection",
		notificationsEnabled:"OrderDirection",
		user:"UserOrderBy",
		appVersion:"OrderDirection",
		osVersion:"OrderDirection",
		apiVersion:"OrderDirection",
		anonymousSession:"AnonymousSessionOrderBy"
	},
	AnonymousSessionDevicesByDeviceIdUniqueWhere:{

	},
	UserMetadata:{
		user:{
			filter:"UserWhere"
		}
	},
	IdentificationAttemptOrderBy:{
		id:"OrderDirection",
		createdAt:"OrderDirection",
		code:"IdentificationCodeOrderBy",
		user:"UserOrderBy"
	},
	IdentificationCodeOrderBy:{
		id:"OrderDirection",
		code:"OrderDirection",
		createdAt:"OrderDirection",
		internalName:"OrderDirection"
	},
	UserRoles:{
		user:{
			filter:"UserWhere"
		}
	},
	UserDevicesByDeviceIdUniqueWhere:{

	},
	IdentificationCodeLocale:{
		root:{
			filter:"IdentificationCodeWhere"
		},
		locale:{
			filter:"LocaleWhere"
		}
	},
	IdentificationCodeLocaleOrderBy:{
		id:"OrderDirection",
		successMessage:"OrderDirection",
		root:"IdentificationCodeOrderBy",
		locale:"LocaleOrderBy"
	},
	PointOfSaleApplicationDeviceOrderBy:{
		id:"OrderDirection",
		internalName:"OrderDirection",
		note:"OrderDirection",
		venue:"VenueOrderBy",
		identificationCode:"IdentificationCodeOrderBy",
		identifier:"DeviceIdentifierOrderBy",
		terminal:"PointOfSaleTerminalOrderBy",
		receiptPrinter:"PointOfSalePrinterOrderBy"
	},
	DeviceIdentifierOrderBy:{
		id:"OrderDirection",
		internalName:"OrderDirection",
		device:"PointOfSaleApplicationDeviceOrderBy",
		updatedAt:"OrderDirection",
		platform:"OrderDirection",
		resolution:"OrderDirection",
		devicePixelRatio:"OrderDirection",
		updatedByUser:"UserOrderBy",
		identifier:"OrderDirection",
		meta:"DeviceIdentifierMetadataOrderBy",
		applicationVersionIdentifier:"OrderDirection",
		lastPointOfSaleSynchronizationErrorRawDetails:"OrderDirection"
	},
	DeviceIdentifierMetadataOrderBy:{
		id:"OrderDirection",
		prettyIdentifier:"OrderDirection",
		deviceIdentifier:"DeviceIdentifierOrderBy"
	},
	PointOfSaleTerminalOrderBy:{
		id:"OrderDirection",
		internalName:"OrderDirection",
		note:"OrderDirection",
		venue:"VenueOrderBy",
		ipAddress:"OrderDirection",
		port:"OrderDirection",
		type:"OrderDirection"
	},
	PointOfSalePrinterOrderBy:{
		id:"OrderDirection",
		internalName:"OrderDirection",
		note:"OrderDirection",
		ipAddress:"OrderDirection",
		venue:"VenueOrderBy"
	},
	IdentificationCodeLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	IdentificationCodeApplicationDevicesByIdentifierUniqueWhere:{
		identifier:"DeviceIdentifierUniqueWhere"
	},
	DeviceIdentifier:{
		device:{
			filter:"PointOfSaleApplicationDeviceWhere"
		},
		updatedByUser:{
			filter:"UserWhere"
		},
		meta:{
			filter:"DeviceIdentifierMetadataWhere"
		}
	},
	DeviceIdentifierMetadata:{
		deviceIdentifier:{
			filter:"DeviceIdentifierWhere"
		}
	},
	PointOfSaleTerminal:{
		venue:{
			filter:"VenueWhere"
		},
		applicationDevices:{
			filter:"PointOfSaleApplicationDeviceWhere",
			orderBy:"PointOfSaleApplicationDeviceOrderBy"
		},
		applicationDevicesByIdentifier:{
			by:"PointOfSaleTerminalApplicationDevicesByIdentifierUniqueWhere",
			filter:"PointOfSaleApplicationDeviceWhere"
		},
		paginateApplicationDevices:{
			filter:"PointOfSaleApplicationDeviceWhere",
			orderBy:"PointOfSaleApplicationDeviceOrderBy"
		}
	},
	PointOfSaleTerminalApplicationDevicesByIdentifierUniqueWhere:{
		identifier:"DeviceIdentifierUniqueWhere"
	},
	PointOfSalePrinter:{
		applicationDevicesReceipt:{
			filter:"PointOfSaleApplicationDeviceWhere",
			orderBy:"PointOfSaleApplicationDeviceOrderBy"
		},
		applicationDevicesTicket:{
			filter:"PointOfSaleApplicationDeviceWhere",
			orderBy:"PointOfSaleApplicationDeviceOrderBy"
		},
		venue:{
			filter:"VenueWhere"
		},
		ticketCategories:{
			filter:"PointOfSaleCategoryWhere",
			orderBy:"PointOfSaleCategoryOrderBy"
		},
		applicationDevicesReceiptByIdentifier:{
			by:"PointOfSalePrinterApplicationDevicesReceiptByIdentifierUniqueWhere",
			filter:"PointOfSaleApplicationDeviceWhere"
		},
		paginateApplicationDevicesReceipt:{
			filter:"PointOfSaleApplicationDeviceWhere",
			orderBy:"PointOfSaleApplicationDeviceOrderBy"
		},
		paginateApplicationDevicesTicket:{
			filter:"PointOfSaleApplicationDeviceWhere",
			orderBy:"PointOfSaleApplicationDeviceOrderBy"
		},
		paginateTicketCategories:{
			filter:"PointOfSaleCategoryWhere",
			orderBy:"PointOfSaleCategoryOrderBy"
		}
	},
	PointOfSaleCategory:{
		locales:{
			filter:"PointOfSaleCategoryLocaleWhere",
			orderBy:"PointOfSaleCategoryLocaleOrderBy"
		},
		products:{
			filter:"PointOfSaleCategoryProductWhere",
			orderBy:"PointOfSaleCategoryProductOrderBy"
		},
		category:{
			filter:"ProductCategoryWhere"
		},
		venue:{
			filter:"VenueWhere"
		},
		ticketPrinters:{
			filter:"PointOfSalePrinterWhere",
			orderBy:"PointOfSalePrinterOrderBy"
		},
		localesByLocale:{
			by:"PointOfSaleCategoryLocalesByLocaleUniqueWhere",
			filter:"PointOfSaleCategoryLocaleWhere"
		},
		productsByLocales:{
			by:"PointOfSaleCategoryProductsByLocalesUniqueWhere",
			filter:"PointOfSaleCategoryProductWhere"
		},
		paginateLocales:{
			filter:"PointOfSaleCategoryLocaleWhere",
			orderBy:"PointOfSaleCategoryLocaleOrderBy"
		},
		paginateProducts:{
			filter:"PointOfSaleCategoryProductWhere",
			orderBy:"PointOfSaleCategoryProductOrderBy"
		},
		paginateTicketPrinters:{
			filter:"PointOfSalePrinterWhere",
			orderBy:"PointOfSalePrinterOrderBy"
		}
	},
	PointOfSaleCategoryLocale:{
		root:{
			filter:"PointOfSaleCategoryWhere"
		},
		locale:{
			filter:"LocaleWhere"
		}
	},
	PointOfSaleCategoryLocaleOrderBy:{
		id:"OrderDirection",
		title:"OrderDirection",
		root:"PointOfSaleCategoryOrderBy",
		locale:"LocaleOrderBy"
	},
	PointOfSaleCategoryOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		slug:"OrderDirection",
		category:"ProductCategoryOrderBy",
		venue:"VenueOrderBy"
	},
	ProductCategoryOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		code:"OrderDirection",
		parent:"ProductCategoryOrderBy",
		description:"OrderDirection",
		internalNote:"OrderDirection",
		color:"OrderDirection",
		image:"ImageOrderBy",
		order:"OrderDirection"
	},
	PointOfSaleCategoryProduct:{
		category:{
			filter:"PointOfSaleCategoryWhere"
		},
		product:{
			filter:"ProductWhere"
		},
		locales:{
			filter:"PointOfSaleCategoryProductLocaleWhere",
			orderBy:"PointOfSaleCategoryProductLocaleOrderBy"
		},
		localesByLocale:{
			by:"PointOfSaleCategoryProductLocalesByLocaleUniqueWhere",
			filter:"PointOfSaleCategoryProductLocaleWhere"
		},
		paginateLocales:{
			filter:"PointOfSaleCategoryProductLocaleWhere",
			orderBy:"PointOfSaleCategoryProductLocaleOrderBy"
		}
	},
	PointOfSaleCategoryProductLocale:{
		root:{
			filter:"PointOfSaleCategoryProductWhere"
		},
		locale:{
			filter:"LocaleWhere"
		}
	},
	PointOfSaleCategoryProductLocaleOrderBy:{
		id:"OrderDirection",
		title:"OrderDirection",
		root:"PointOfSaleCategoryProductOrderBy",
		locale:"LocaleOrderBy"
	},
	PointOfSaleCategoryProductOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		category:"PointOfSaleCategoryOrderBy",
		product:"ProductOrderBy"
	},
	PointOfSaleCategoryProductLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	ProductCategory:{
		products:{
			filter:"ProductWhere",
			orderBy:"ProductOrderBy"
		},
		tags:{
			filter:"TagWhere",
			orderBy:"TagOrderBy"
		},
		parent:{
			filter:"ProductCategoryWhere"
		},
		children:{
			filter:"ProductCategoryWhere",
			orderBy:"ProductCategoryOrderBy"
		},
		image:{
			filter:"ImageWhere"
		},
		descendants:{
			filter:"ProductCategoryTreeWhere",
			orderBy:"ProductCategoryTreeOrderBy"
		},
		ancestors:{
			filter:"ProductCategoryTreeWhere",
			orderBy:"ProductCategoryTreeOrderBy"
		},
		inheritedTags:{
			filter:"InheritedProductCategoryTagWhere",
			orderBy:"InheritedProductCategoryTagOrderBy"
		},
		nestedProducts:{
			filter:"NestedProductCategoryProductWhere",
			orderBy:"NestedProductCategoryProductOrderBy"
		},
		childrenByCode:{
			by:"ProductCategoryChildrenByCodeUniqueWhere",
			filter:"ProductCategoryWhere"
		},
		childrenByChildren:{
			by:"ProductCategoryChildrenByChildrenUniqueWhere",
			filter:"ProductCategoryWhere"
		},
		childrenByDescendants:{
			by:"ProductCategoryChildrenByDescendantsUniqueWhere",
			filter:"ProductCategoryWhere"
		},
		childrenByAncestors:{
			by:"ProductCategoryChildrenByAncestorsUniqueWhere",
			filter:"ProductCategoryWhere"
		},
		childrenByInheritedTags:{
			by:"ProductCategoryChildrenByInheritedTagsUniqueWhere",
			filter:"ProductCategoryWhere"
		},
		childrenByNestedProducts:{
			by:"ProductCategoryChildrenByNestedProductsUniqueWhere",
			filter:"ProductCategoryWhere"
		},
		paginateProducts:{
			filter:"ProductWhere",
			orderBy:"ProductOrderBy"
		},
		paginateTags:{
			filter:"TagWhere",
			orderBy:"TagOrderBy"
		},
		paginateChildren:{
			filter:"ProductCategoryWhere",
			orderBy:"ProductCategoryOrderBy"
		},
		paginateDescendants:{
			filter:"ProductCategoryTreeWhere",
			orderBy:"ProductCategoryTreeOrderBy"
		},
		paginateAncestors:{
			filter:"ProductCategoryTreeWhere",
			orderBy:"ProductCategoryTreeOrderBy"
		},
		paginateInheritedTags:{
			filter:"InheritedProductCategoryTagWhere",
			orderBy:"InheritedProductCategoryTagOrderBy"
		},
		paginateNestedProducts:{
			filter:"NestedProductCategoryProductWhere",
			orderBy:"NestedProductCategoryProductOrderBy"
		}
	},
	ProductCategoryTree:{
		ancestor:{
			filter:"ProductCategoryWhere"
		},
		descendant:{
			filter:"ProductCategoryWhere"
		}
	},
	ProductCategoryTreeOrderBy:{
		id:"OrderDirection",
		depth:"OrderDirection",
		ancestor:"ProductCategoryOrderBy",
		descendant:"ProductCategoryOrderBy"
	},
	InheritedProductCategoryTag:{
		productCategory:{
			filter:"ProductCategoryWhere"
		},
		tag:{
			filter:"TagWhere"
		}
	},
	InheritedProductCategoryTagOrderBy:{
		id:"OrderDirection",
		depth:"OrderDirection",
		productCategory:"ProductCategoryOrderBy",
		tag:"TagOrderBy"
	},
	NestedProductCategoryProduct:{
		product:{
			filter:"ProductWhere"
		},
		productCategory:{
			filter:"ProductCategoryWhere"
		}
	},
	NestedProductCategoryProductOrderBy:{
		id:"OrderDirection",
		depth:"OrderDirection",
		product:"ProductOrderBy",
		productCategory:"ProductCategoryOrderBy"
	},
	ProductCategoryChildrenByCodeUniqueWhere:{

	},
	ProductCategoryChildrenByChildrenUniqueWhere:{
		children:"ProductCategoryUniqueWhere"
	},
	ProductCategoryUniqueWhere:{
		id:"UUID",
		children:"ProductCategoryUniqueWhere",
		descendants:"ProductCategoryTreeUniqueWhere",
		ancestors:"ProductCategoryTreeUniqueWhere",
		inheritedTags:"InheritedProductCategoryTagUniqueWhere",
		nestedProducts:"NestedProductCategoryProductUniqueWhere"
	},
	ProductCategoryTreeUniqueWhere:{
		id:"UUID"
	},
	InheritedProductCategoryTagUniqueWhere:{
		id:"UUID"
	},
	ProductCategoryChildrenByDescendantsUniqueWhere:{
		descendants:"ProductCategoryTreeUniqueWhere"
	},
	ProductCategoryChildrenByAncestorsUniqueWhere:{
		ancestors:"ProductCategoryTreeUniqueWhere"
	},
	ProductCategoryChildrenByInheritedTagsUniqueWhere:{
		inheritedTags:"InheritedProductCategoryTagUniqueWhere"
	},
	ProductCategoryChildrenByNestedProductsUniqueWhere:{
		nestedProducts:"NestedProductCategoryProductUniqueWhere"
	},
	PointOfSaleCategoryLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	PointOfSaleCategoryProductsByLocalesUniqueWhere:{
		locales:"PointOfSaleCategoryProductLocaleUniqueWhere"
	},
	PointOfSalePrinterApplicationDevicesReceiptByIdentifierUniqueWhere:{
		identifier:"DeviceIdentifierUniqueWhere"
	},
	Order:{
		customer:{
			filter:"CustomerWhere"
		},
		channel:{
			filter:"ChannelWhere"
		},
		discounts:{
			filter:"OrderDiscountWhere",
			orderBy:"OrderDiscountOrderBy"
		},
		delivery:{
			filter:"OrderDeliveryWhere"
		},
		items:{
			filter:"OrderItemWhere",
			orderBy:"OrderItemOrderBy"
		},
		cart:{
			filter:"CartWhere"
		},
		events:{
			filter:"OrderEventWhere",
			orderBy:"OrderEventOrderBy"
		},
		billingAddress:{
			filter:"AddressWhere"
		},
		priceLines:{
			filter:"OrderPriceLineWhere",
			orderBy:"OrderPriceLineOrderBy"
		},
		payments:{
			filter:"OrderPaymentWhere",
			orderBy:"OrderPaymentOrderBy"
		},
		billingSubject:{
			filter:"BillingSubjectWhere"
		},
		summary:{
			filter:"OrderSummaryWhere"
		},
		gratuity:{
			filter:"GratuityWhere"
		},
		venue:{
			filter:"VenueWhere"
		},
		fulfillmentNotes:{
			filter:"FulfillmentNoteWhere",
			orderBy:"FulfillmentNoteOrderBy"
		},
		discountsByCustomerCreditTransactions:{
			by:"OrderDiscountsByCustomerCreditTransactionsUniqueWhere",
			filter:"OrderDiscountWhere"
		},
		discountsByVoucherRedemption:{
			by:"OrderDiscountsByVoucherRedemptionUniqueWhere",
			filter:"OrderDiscountWhere"
		},
		itemsByVirtualProductEffects:{
			by:"OrderItemsByVirtualProductEffectsUniqueWhere",
			filter:"OrderItemWhere"
		},
		priceLinesByOrderItem:{
			by:"OrderPriceLinesByOrderItemUniqueWhere",
			filter:"OrderPriceLineWhere"
		},
		priceLinesByOrderDiscount:{
			by:"OrderPriceLinesByOrderDiscountUniqueWhere",
			filter:"OrderPriceLineWhere"
		},
		priceLinesByOrderPayment:{
			by:"OrderPriceLinesByOrderPaymentUniqueWhere",
			filter:"OrderPriceLineWhere"
		},
		priceLinesByOrderDelivery:{
			by:"OrderPriceLinesByOrderDeliveryUniqueWhere",
			filter:"OrderPriceLineWhere"
		},
		paymentsByEvents:{
			by:"OrderPaymentsByEventsUniqueWhere",
			filter:"OrderPaymentWhere"
		},
		paymentsByMeta:{
			by:"OrderPaymentsByMetaUniqueWhere",
			filter:"OrderPaymentWhere"
		},
		paginateDiscounts:{
			filter:"OrderDiscountWhere",
			orderBy:"OrderDiscountOrderBy"
		},
		paginateItems:{
			filter:"OrderItemWhere",
			orderBy:"OrderItemOrderBy"
		},
		paginateEvents:{
			filter:"OrderEventWhere",
			orderBy:"OrderEventOrderBy"
		},
		paginatePriceLines:{
			filter:"OrderPriceLineWhere",
			orderBy:"OrderPriceLineOrderBy"
		},
		paginatePayments:{
			filter:"OrderPaymentWhere",
			orderBy:"OrderPaymentOrderBy"
		},
		paginateFulfillmentNotes:{
			filter:"FulfillmentNoteWhere",
			orderBy:"FulfillmentNoteOrderBy"
		}
	},
	OrderDiscount:{
		vatRate:{
			filter:"VatRateWhere"
		},
		order:{
			filter:"OrderWhere"
		},
		customerCreditTransactions:{
			filter:"CustomerCreditTransactionWhere",
			orderBy:"CustomerCreditTransactionOrderBy"
		},
		voucherRedemption:{
			filter:"VoucherRedemptionWhere"
		},
		customerCreditTransactionsByVirtualProductEffect:{
			by:"OrderDiscountCustomerCreditTransactionsByVirtualProductEffectUniqueWhere",
			filter:"CustomerCreditTransactionWhere"
		},
		paginateCustomerCreditTransactions:{
			filter:"CustomerCreditTransactionWhere",
			orderBy:"CustomerCreditTransactionOrderBy"
		}
	},
	CustomerCreditTransaction:{
		customerCredit:{
			filter:"CustomerCreditWhere"
		},
		orderDiscount:{
			filter:"OrderDiscountWhere"
		},
		virtualProductEffect:{
			filter:"VirtualProductEffectWhere"
		}
	},
	CustomerCredit:{
		customer:{
			filter:"CustomerWhere"
		},
		vatRate:{
			filter:"VatRateWhere"
		},
		transactions:{
			filter:"CustomerCreditTransactionWhere",
			orderBy:"CustomerCreditTransactionOrderBy"
		},
		voucherRedemption:{
			filter:"VoucherRedemptionWhere"
		},
		transactionsByVirtualProductEffect:{
			by:"CustomerCreditTransactionsByVirtualProductEffectUniqueWhere",
			filter:"CustomerCreditTransactionWhere"
		},
		paginateTransactions:{
			filter:"CustomerCreditTransactionWhere",
			orderBy:"CustomerCreditTransactionOrderBy"
		}
	},
	CustomerCreditTransactionOrderBy:{
		id:"OrderDirection",
		createdAt:"OrderDirection",
		amountCents:"OrderDirection",
		customerCredit:"CustomerCreditOrderBy",
		orderDiscount:"OrderDiscountOrderBy",
		virtualProductEffect:"VirtualProductEffectOrderBy"
	},
	CustomerCreditOrderBy:{
		id:"OrderDirection",
		initialCreditCents:"OrderDirection",
		remainingCreditsCents:"OrderDirection",
		expiresAt:"OrderDirection",
		reason:"OrderDirection",
		customer:"CustomerOrderBy",
		vatRate:"VatRateOrderBy",
		createdAt:"OrderDirection",
		voucherRedemption:"VoucherRedemptionOrderBy",
		invoiceUrl:"OrderDirection"
	},
	VoucherRedemptionOrderBy:{
		id:"OrderDirection",
		createdAt:"OrderDirection",
		note:"OrderDirection",
		manualRedemptionNote:"OrderDirection",
		customerCredit:"CustomerCreditOrderBy",
		orderDiscount:"OrderDiscountOrderBy",
		voucher:"VoucherOrderBy",
		customer:"CustomerOrderBy"
	},
	OrderDiscountOrderBy:{
		id:"OrderDirection",
		discountCents:"OrderDirection",
		vatRate:"VatRateOrderBy",
		order:"OrderOrderBy",
		description:"OrderDirection",
		type:"OrderDirection",
		voucherRedemption:"VoucherRedemptionOrderBy"
	},
	OrderOrderBy:{
		id:"OrderDirection",
		state:"OrderDirection",
		fulfilledAt:"OrderDirection",
		canceledAt:"OrderDirection",
		note:"OrderDirection",
		customer:"CustomerOrderBy",
		channel:"ChannelOrderBy",
		delivery:"OrderDeliveryOrderBy",
		internalNote:"OrderDirection",
		cart:"CartOrderBy",
		createdAt:"OrderDirection",
		billingAddress:"AddressOrderBy",
		seq:"OrderDirection",
		billingSubject:"BillingSubjectOrderBy",
		summary:"OrderSummaryOrderBy",
		doubleshotLegacyId:"OrderDirection",
		gratuity:"GratuityOrderBy",
		venue:"VenueOrderBy",
		fulfillmentNote:"OrderDirection",
		doubleshotTotalWeightGrams:"OrderDirection",
		doubleShotLegacyNumber:"OrderDirection",
		doubleshotLastUpdatedAt:"OrderDirection",
		doubleshotAdminUrl:"OrderDirection"
	},
	OrderDeliveryOrderBy:{
		id:"OrderDirection",
		priceCents:"OrderDirection",
		deliveredAt:"OrderDirection",
		method:"DeliveryMethodOrderBy",
		vatRate:"VatRateOrderBy",
		order:"OrderOrderBy",
		expectedAt:"OrderDirection",
		state:"OrderDirection",
		loadingDurationHours:"OrderDirection",
		dispatchAt:"OrderDirection",
		duration:"OrderDirection",
		window:"OrderDirection",
		expectedEndAt:"OrderDirection",
		processingAt:"OrderDirection",
		deliveringAt:"OrderDirection",
		failedAt:"OrderDirection",
		internalNote:"OrderDirection",
		deliveryWaypoint:"DeliveryWaypointOrderBy",
		prepareAt:"OrderDirection",
		liftagoRide:"LiftagoRideOrderBy",
		pickedAt:"OrderDirection",
		address:"AddressOrderBy",
		trackingCode:"OrderDirection",
		woltDriveDelivery:"WoltDriveDeliveryOrderBy"
	},
	DeliveryWaypointOrderBy:{
		id:"OrderDirection",
		estimatedArrival:"OrderDirection",
		note:"OrderDirection",
		route:"DeliveryRouteOrderBy",
		sortingOrder:"OrderDirection",
		delivery:"OrderDeliveryOrderBy",
		estimatedDistance:"OrderDirection",
		estimatedDuration:"OrderDirection",
		originDeparture:"OrderDirection",
		originAddress:"OrderDirection",
		transitMode:"OrderDirection"
	},
	DeliveryRouteOrderBy:{
		id:"OrderDirection",
		courier:"CourierOrderBy",
		createdAt:"OrderDirection",
		dispatchAt:"OrderDirection"
	},
	LiftagoRideOrderBy:{
		id:"OrderDirection",
		liftagoId:"OrderDirection",
		data:"OrderDirection",
		updatedAt:"OrderDirection",
		delivery:"OrderDeliveryOrderBy"
	},
	WoltDriveDeliveryOrderBy:{
		id:"OrderDirection",
		state:"OrderDirection",
		shipmentPromiseId:"OrderDirection",
		deliveryPrice:"OrderDirection",
		deliveryPriceCurrency:"OrderDirection",
		shipmentPromiseResponse:"OrderDirection",
		deliveryOrderId:"OrderDirection",
		trackingUrl:"OrderDirection",
		deliverOrderResponse:"OrderDirection",
		delivery:"OrderDeliveryOrderBy"
	},
	CartOrderBy:{
		id:"OrderDirection",
		confirmedAt:"OrderDirection",
		deletedAt:"OrderDirection",
		note:"OrderDirection",
		handle:"OrderDirection",
		state:"OrderDirection",
		createdAt:"OrderDirection",
		channel:"ChannelOrderBy",
		order:"OrderOrderBy",
		customer:"CustomerOrderBy",
		deliveryAddress:"AddressOrderBy",
		billingAddress:"AddressOrderBy",
		deliveryOption:"OrderDirection",
		paymentOption:"OrderDirection",
		delivery:"ChannelDeliveryOrderBy",
		payment:"ChannelPaymentOrderBy",
		billingSubject:"BillingSubjectOrderBy",
		summary:"CartSummaryOrderBy"
	},
	CartSummaryOrderBy:{
		id:"OrderDirection",
		itemsPriceCents:"OrderDirection",
		deliveryPriceCents:"OrderDirection",
		totalPriceCents:"OrderDirection",
		itemsCount:"OrderDirection",
		itemsQuantity:"OrderDirection",
		checkoutUrl:"OrderDirection",
		cart:"CartOrderBy"
	},
	OrderSummaryOrderBy:{
		id:"OrderDirection",
		totalPriceCents:"OrderDirection",
		discountPriceCents:"OrderDirection",
		undiscountedPriceCents:"OrderDirection",
		itemsQuantity:"OrderDirection",
		orderUrl:"OrderDirection",
		orderNumber:"OrderDirection",
		order:"OrderOrderBy"
	},
	GratuityOrderBy:{
		id:"OrderDirection",
		amountCents:"OrderDirection",
		order:"OrderOrderBy"
	},
	VoucherOrderBy:{
		id:"OrderDirection",
		createdAt:"OrderDirection",
		activatedAt:"OrderDirection",
		expiresAt:"OrderDirection",
		internalNote:"OrderDirection",
		note:"OrderDirection",
		code:"OrderDirection",
		type:"OrderDirection",
		creditCents:"OrderDirection",
		buyer:"CustomerOrderBy",
		owner:"CustomerOrderBy",
		vatRate:"VatRateOrderBy",
		virtualProductEffect:"VirtualProductEffectOrderBy",
		redemption:"VoucherRedemptionOrderBy"
	},
	VirtualProductEffectOrderBy:{
		id:"OrderDirection",
		createdAt:"OrderDirection",
		succeededAt:"OrderDirection",
		orderItem:"OrderItemOrderBy",
		failedAt:"OrderDirection",
		revertedAt:"OrderDirection",
		resultCustomerCreditTransaction:"CustomerCreditTransactionOrderBy"
	},
	OrderItemOrderBy:{
		id:"OrderDirection",
		unitPriceCents:"OrderDirection",
		quantity:"OrderDirection",
		vatRate:"VatRateOrderBy",
		order:"OrderOrderBy",
		pickedAt:"OrderDirection",
		note:"OrderDirection",
		product:"ProductOrderBy"
	},
	VoucherRedemption:{
		customerCredit:{
			filter:"CustomerCreditWhere"
		},
		orderDiscount:{
			filter:"OrderDiscountWhere"
		},
		voucher:{
			filter:"VoucherWhere"
		},
		customer:{
			filter:"CustomerWhere"
		}
	},
	Voucher:{
		buyer:{
			filter:"CustomerWhere"
		},
		owner:{
			filter:"CustomerWhere"
		},
		vatRate:{
			filter:"VatRateWhere"
		},
		virtualProductEffect:{
			filter:"VirtualProductEffectWhere"
		},
		redemption:{
			filter:"VoucherRedemptionWhere"
		}
	},
	VirtualProductEffect:{
		orderItem:{
			filter:"OrderItemWhere"
		},
		resultCustomerCreditTransaction:{
			filter:"CustomerCreditTransactionWhere"
		},
		resultVouchers:{
			filter:"VoucherWhere",
			orderBy:"VoucherOrderBy"
		},
		resultVouchersByCode:{
			by:"VirtualProductEffectResultVouchersByCodeUniqueWhere",
			filter:"VoucherWhere"
		},
		resultVouchersByRedemption:{
			by:"VirtualProductEffectResultVouchersByRedemptionUniqueWhere",
			filter:"VoucherWhere"
		},
		paginateResultVouchers:{
			filter:"VoucherWhere",
			orderBy:"VoucherOrderBy"
		}
	},
	OrderItem:{
		vatRate:{
			filter:"VatRateWhere"
		},
		order:{
			filter:"OrderWhere"
		},
		virtualProductEffects:{
			filter:"VirtualProductEffectWhere",
			orderBy:"VirtualProductEffectOrderBy"
		},
		fulfillmentNotes:{
			filter:"FulfillmentNoteWhere",
			orderBy:"FulfillmentNoteOrderBy"
		},
		product:{
			filter:"ProductWhere"
		},
		virtualProductEffectsByResultCustomerCreditTransaction:{
			by:"OrderItemVirtualProductEffectsByResultCustomerCreditTransactionUniqueWhere",
			filter:"VirtualProductEffectWhere"
		},
		virtualProductEffectsByResultVouchers:{
			by:"OrderItemVirtualProductEffectsByResultVouchersUniqueWhere",
			filter:"VirtualProductEffectWhere"
		},
		paginateVirtualProductEffects:{
			filter:"VirtualProductEffectWhere",
			orderBy:"VirtualProductEffectOrderBy"
		},
		paginateFulfillmentNotes:{
			filter:"FulfillmentNoteWhere",
			orderBy:"FulfillmentNoteOrderBy"
		}
	},
	FulfillmentNoteOrderBy:{
		id:"OrderDirection",
		note:"OrderDirection",
		highlight:"OrderDirection",
		createdAt:"OrderDirection",
		emoji:"OrderDirection"
	},
	OrderItemVirtualProductEffectsByResultCustomerCreditTransactionUniqueWhere:{
		resultCustomerCreditTransaction:"CustomerCreditTransactionUniqueWhere"
	},
	OrderItemVirtualProductEffectsByResultVouchersUniqueWhere:{
		resultVouchers:"VoucherUniqueWhere"
	},
	VirtualProductEffectResultVouchersByCodeUniqueWhere:{

	},
	VirtualProductEffectResultVouchersByRedemptionUniqueWhere:{
		redemption:"VoucherRedemptionUniqueWhere"
	},
	CustomerCreditTransactionsByVirtualProductEffectUniqueWhere:{
		virtualProductEffect:"VirtualProductEffectUniqueWhere"
	},
	OrderDiscountCustomerCreditTransactionsByVirtualProductEffectUniqueWhere:{
		virtualProductEffect:"VirtualProductEffectUniqueWhere"
	},
	OrderEvent:{
		order:{
			filter:"OrderWhere"
		},
		payment:{
			filter:"OrderPaymentWhere"
		},
		delivery:{
			filter:"OrderDeliveryWhere"
		}
	},
	OrderPayment:{
		method:{
			filter:"PaymentMethodWhere"
		},
		events:{
			filter:"OrderEventWhere",
			orderBy:"OrderEventOrderBy"
		},
		order:{
			filter:"OrderWhere"
		},
		invoice:{
			filter:"InvoiceWhere"
		},
		vatRate:{
			filter:"VatRateWhere"
		},
		meta:{
			filter:"OrderPaymentMetadataWhere"
		},
		paginateEvents:{
			filter:"OrderEventWhere",
			orderBy:"OrderEventOrderBy"
		}
	},
	OrderEventOrderBy:{
		id:"OrderDirection",
		type:"OrderDirection",
		data:"OrderDirection",
		createdAt:"OrderDirection",
		order:"OrderOrderBy",
		payment:"OrderPaymentOrderBy",
		delivery:"OrderDeliveryOrderBy"
	},
	OrderPaymentOrderBy:{
		id:"OrderDirection",
		data:"OrderDirection",
		paymentCents:"OrderDirection",
		method:"PaymentMethodOrderBy",
		failedAt:"OrderDirection",
		state:"OrderDirection",
		approvedAt:"OrderDirection",
		order:"OrderOrderBy",
		invoice:"InvoiceOrderBy",
		walletType:"OrderDirection",
		createdAt:"OrderDirection",
		publicReceiptUrl:"OrderDirection",
		priceCents:"OrderDirection",
		vatRate:"VatRateOrderBy",
		meta:"OrderPaymentMetadataOrderBy",
		otherCurrencyPriceCents:"OrderDirection"
	},
	InvoiceOrderBy:{
		id:"OrderDirection",
		createdAt:"OrderDirection",
		publicKey:"OrderDirection",
		fakturoidId:"OrderDirection",
		fakturoidData:"OrderDirection",
		legacyUrl:"OrderDirection",
		customer:"CustomerOrderBy",
		address:"AddressOrderBy",
		publicUrl:"OrderDirection",
		billingSubject:"BillingSubjectOrderBy"
	},
	OrderPaymentMetadataOrderBy:{
		id:"OrderDirection",
		paymentUrl:"OrderDirection",
		orderPayment:"OrderPaymentOrderBy"
	},
	Invoice:{
		customer:{
			filter:"CustomerWhere"
		},
		orderPayments:{
			filter:"OrderPaymentWhere",
			orderBy:"OrderPaymentOrderBy"
		},
		address:{
			filter:"AddressWhere"
		},
		billingSubject:{
			filter:"BillingSubjectWhere"
		},
		orderPaymentsByEvents:{
			by:"InvoiceOrderPaymentsByEventsUniqueWhere",
			filter:"OrderPaymentWhere"
		},
		orderPaymentsByMeta:{
			by:"InvoiceOrderPaymentsByMetaUniqueWhere",
			filter:"OrderPaymentWhere"
		},
		paginateOrderPayments:{
			filter:"OrderPaymentWhere",
			orderBy:"OrderPaymentOrderBy"
		}
	},
	BillingSubject:{
		country:{
			filter:"CountryWhere"
		},
		customer:{
			filter:"CustomerWhere"
		},
		invoices:{
			filter:"InvoiceWhere",
			orderBy:"InvoiceOrderBy"
		},
		defaultBillingSubjectOfCustomer:{
			filter:"CustomerWhere"
		},
		orders:{
			filter:"OrderWhere",
			orderBy:"OrderOrderBy"
		},
		invoicesByPublicKey:{
			by:"BillingSubjectInvoicesByPublicKeyUniqueWhere",
			filter:"InvoiceWhere"
		},
		invoicesByFakturoidId:{
			by:"BillingSubjectInvoicesByFakturoidIdUniqueWhere",
			filter:"InvoiceWhere"
		},
		invoicesByOrderPayments:{
			by:"BillingSubjectInvoicesByOrderPaymentsUniqueWhere",
			filter:"InvoiceWhere"
		},
		ordersBySeq:{
			by:"BillingSubjectOrdersBySeqUniqueWhere",
			filter:"OrderWhere"
		},
		ordersByDoubleshotLegacyId:{
			by:"BillingSubjectOrdersByDoubleshotLegacyIdUniqueWhere",
			filter:"OrderWhere"
		},
		ordersByDoubleShotLegacyNumber:{
			by:"BillingSubjectOrdersByDoubleShotLegacyNumberUniqueWhere",
			filter:"OrderWhere"
		},
		ordersByDiscounts:{
			by:"BillingSubjectOrdersByDiscountsUniqueWhere",
			filter:"OrderWhere"
		},
		ordersByDelivery:{
			by:"BillingSubjectOrdersByDeliveryUniqueWhere",
			filter:"OrderWhere"
		},
		ordersByItems:{
			by:"BillingSubjectOrdersByItemsUniqueWhere",
			filter:"OrderWhere"
		},
		ordersByCart:{
			by:"BillingSubjectOrdersByCartUniqueWhere",
			filter:"OrderWhere"
		},
		ordersByEvents:{
			by:"BillingSubjectOrdersByEventsUniqueWhere",
			filter:"OrderWhere"
		},
		ordersByPriceLines:{
			by:"BillingSubjectOrdersByPriceLinesUniqueWhere",
			filter:"OrderWhere"
		},
		ordersByPayments:{
			by:"BillingSubjectOrdersByPaymentsUniqueWhere",
			filter:"OrderWhere"
		},
		ordersBySummary:{
			by:"BillingSubjectOrdersBySummaryUniqueWhere",
			filter:"OrderWhere"
		},
		ordersByGratuity:{
			by:"BillingSubjectOrdersByGratuityUniqueWhere",
			filter:"OrderWhere"
		},
		paginateInvoices:{
			filter:"InvoiceWhere",
			orderBy:"InvoiceOrderBy"
		},
		paginateOrders:{
			filter:"OrderWhere",
			orderBy:"OrderOrderBy"
		}
	},
	BillingSubjectInvoicesByPublicKeyUniqueWhere:{

	},
	BillingSubjectInvoicesByFakturoidIdUniqueWhere:{

	},
	BillingSubjectInvoicesByOrderPaymentsUniqueWhere:{
		orderPayments:"OrderPaymentUniqueWhere"
	},
	BillingSubjectOrdersBySeqUniqueWhere:{

	},
	BillingSubjectOrdersByDoubleshotLegacyIdUniqueWhere:{

	},
	BillingSubjectOrdersByDoubleShotLegacyNumberUniqueWhere:{

	},
	BillingSubjectOrdersByDiscountsUniqueWhere:{
		discounts:"OrderDiscountUniqueWhere"
	},
	BillingSubjectOrdersByDeliveryUniqueWhere:{
		delivery:"OrderDeliveryUniqueWhere"
	},
	BillingSubjectOrdersByItemsUniqueWhere:{
		items:"OrderItemUniqueWhere"
	},
	BillingSubjectOrdersByCartUniqueWhere:{
		cart:"CartUniqueWhere"
	},
	BillingSubjectOrdersByEventsUniqueWhere:{
		events:"OrderEventUniqueWhere"
	},
	BillingSubjectOrdersByPriceLinesUniqueWhere:{
		priceLines:"OrderPriceLineUniqueWhere"
	},
	BillingSubjectOrdersByPaymentsUniqueWhere:{
		payments:"OrderPaymentUniqueWhere"
	},
	BillingSubjectOrdersBySummaryUniqueWhere:{
		summary:"OrderSummaryUniqueWhere"
	},
	BillingSubjectOrdersByGratuityUniqueWhere:{
		gratuity:"GratuityUniqueWhere"
	},
	InvoiceOrderPaymentsByEventsUniqueWhere:{
		events:"OrderEventUniqueWhere"
	},
	InvoiceOrderPaymentsByMetaUniqueWhere:{
		meta:"OrderPaymentMetadataUniqueWhere"
	},
	OrderPaymentMetadata:{
		orderPayment:{
			filter:"OrderPaymentWhere"
		}
	},
	OrderPriceLine:{
		orderItem:{
			filter:"OrderItemWhere"
		},
		orderDiscount:{
			filter:"OrderDiscountWhere"
		},
		orderPayment:{
			filter:"OrderPaymentWhere"
		},
		orderDelivery:{
			filter:"OrderDeliveryWhere"
		},
		vatRate:{
			filter:"VatRateWhere"
		},
		order:{
			filter:"OrderWhere"
		}
	},
	OrderPriceLineOrderBy:{
		id:"OrderDirection",
		unitPriceCents:"OrderDirection",
		quantity:"OrderDirection",
		type:"OrderDirection",
		orderItem:"OrderItemOrderBy",
		orderDiscount:"OrderDiscountOrderBy",
		orderPayment:"OrderPaymentOrderBy",
		orderDelivery:"OrderDeliveryOrderBy",
		vatRatePermille:"OrderDirection",
		vatRate:"VatRateOrderBy",
		order:"OrderOrderBy"
	},
	OrderSummary:{
		order:{
			filter:"OrderWhere"
		}
	},
	Gratuity:{
		order:{
			filter:"OrderWhere"
		}
	},
	OrderDiscountsByCustomerCreditTransactionsUniqueWhere:{
		customerCreditTransactions:"CustomerCreditTransactionUniqueWhere"
	},
	OrderDiscountsByVoucherRedemptionUniqueWhere:{
		voucherRedemption:"VoucherRedemptionUniqueWhere"
	},
	OrderItemsByVirtualProductEffectsUniqueWhere:{
		virtualProductEffects:"VirtualProductEffectUniqueWhere"
	},
	OrderPriceLinesByOrderItemUniqueWhere:{
		orderItem:"OrderItemUniqueWhere"
	},
	OrderPriceLinesByOrderDiscountUniqueWhere:{
		orderDiscount:"OrderDiscountUniqueWhere"
	},
	OrderPriceLinesByOrderPaymentUniqueWhere:{
		orderPayment:"OrderPaymentUniqueWhere"
	},
	OrderPriceLinesByOrderDeliveryUniqueWhere:{
		orderDelivery:"OrderDeliveryUniqueWhere"
	},
	OrderPaymentsByEventsUniqueWhere:{
		events:"OrderEventUniqueWhere"
	},
	OrderPaymentsByMetaUniqueWhere:{
		meta:"OrderPaymentMetadataUniqueWhere"
	},
	Area:{
		venue:{
			filter:"VenueWhere"
		},
		tables:{
			filter:"TableWhere",
			orderBy:"TableOrderBy"
		},
		lines:{
			filter:"LineWhere",
			orderBy:"LineOrderBy"
		},
		tablesByCustomerTabs:{
			by:"AreaTablesByCustomerTabsUniqueWhere",
			filter:"TableWhere"
		},
		tablesBySeats:{
			by:"AreaTablesBySeatsUniqueWhere",
			filter:"TableWhere"
		},
		paginateTables:{
			filter:"TableWhere",
			orderBy:"TableOrderBy"
		},
		paginateLines:{
			filter:"LineWhere",
			orderBy:"LineOrderBy"
		}
	},
	Table:{
		customerTabs:{
			filter:"CustomerTabWhere",
			orderBy:"CustomerTabOrderBy"
		},
		area:{
			filter:"AreaWhere"
		},
		seats:{
			filter:"SeatWhere",
			orderBy:"SeatOrderBy"
		},
		customerTabsByItems:{
			by:"TableCustomerTabsByItemsUniqueWhere",
			filter:"CustomerTabWhere"
		},
		customerTabsByMeta:{
			by:"TableCustomerTabsByMetaUniqueWhere",
			filter:"CustomerTabWhere"
		},
		seatsByCustomerTabs:{
			by:"TableSeatsByCustomerTabsUniqueWhere",
			filter:"SeatWhere"
		},
		paginateCustomerTabs:{
			filter:"CustomerTabWhere",
			orderBy:"CustomerTabOrderBy"
		},
		paginateSeats:{
			filter:"SeatWhere",
			orderBy:"SeatOrderBy"
		}
	},
	CustomerTab:{
		items:{
			filter:"CustomerTabItemWhere",
			orderBy:"CustomerTabItemOrderBy"
		},
		meta:{
			filter:"CustomerTabMetadataWhere"
		},
		customer:{
			filter:"CustomerWhere"
		},
		table:{
			filter:"TableWhere"
		},
		seat:{
			filter:"SeatWhere"
		},
		paginateItems:{
			filter:"CustomerTabItemWhere",
			orderBy:"CustomerTabItemOrderBy"
		}
	},
	CustomerTabItem:{
		tab:{
			filter:"CustomerTabWhere"
		},
		product:{
			filter:"ProductWhere"
		}
	},
	CustomerTabItemOrderBy:{
		id:"OrderDirection",
		addedAt:"OrderDirection",
		tab:"CustomerTabOrderBy",
		product:"ProductOrderBy",
		paidAt:"OrderDirection"
	},
	CustomerTabOrderBy:{
		id:"OrderDirection",
		createdAt:"OrderDirection",
		color:"OrderDirection",
		name:"OrderDirection",
		meta:"CustomerTabMetadataOrderBy",
		customer:"CustomerOrderBy",
		table:"TableOrderBy",
		seat:"SeatOrderBy"
	},
	CustomerTabMetadataOrderBy:{
		id:"OrderDirection",
		totalPriceCents:"OrderDirection",
		totalSpentCents:"OrderDirection",
		unpaidCents:"OrderDirection",
		customerTab:"CustomerTabOrderBy"
	},
	TableOrderBy:{
		id:"OrderDirection",
		shape:"OrderDirection",
		width:"OrderDirection",
		height:"OrderDirection",
		positionX:"OrderDirection",
		positionY:"OrderDirection",
		name:"OrderDirection",
		color:"OrderDirection",
		area:"AreaOrderBy"
	},
	AreaOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		name:"OrderDirection",
		venue:"VenueOrderBy"
	},
	SeatOrderBy:{
		id:"OrderDirection",
		positionX:"OrderDirection",
		positionY:"OrderDirection",
		name:"OrderDirection",
		color:"OrderDirection",
		table:"TableOrderBy"
	},
	CustomerTabMetadata:{
		customerTab:{
			filter:"CustomerTabWhere"
		}
	},
	Seat:{
		customerTabs:{
			filter:"CustomerTabWhere",
			orderBy:"CustomerTabOrderBy"
		},
		table:{
			filter:"TableWhere"
		},
		customerTabsByItems:{
			by:"SeatCustomerTabsByItemsUniqueWhere",
			filter:"CustomerTabWhere"
		},
		customerTabsByMeta:{
			by:"SeatCustomerTabsByMetaUniqueWhere",
			filter:"CustomerTabWhere"
		},
		paginateCustomerTabs:{
			filter:"CustomerTabWhere",
			orderBy:"CustomerTabOrderBy"
		}
	},
	SeatCustomerTabsByItemsUniqueWhere:{
		items:"CustomerTabItemUniqueWhere"
	},
	SeatCustomerTabsByMetaUniqueWhere:{
		meta:"CustomerTabMetadataUniqueWhere"
	},
	TableCustomerTabsByItemsUniqueWhere:{
		items:"CustomerTabItemUniqueWhere"
	},
	TableCustomerTabsByMetaUniqueWhere:{
		meta:"CustomerTabMetadataUniqueWhere"
	},
	TableSeatsByCustomerTabsUniqueWhere:{
		customerTabs:"CustomerTabUniqueWhere"
	},
	Line:{
		area:{
			filter:"AreaWhere"
		}
	},
	LineOrderBy:{
		id:"OrderDirection",
		positionStartX:"OrderDirection",
		positionStartY:"OrderDirection",
		positionEndX:"OrderDirection",
		positionEndY:"OrderDirection",
		area:"AreaOrderBy"
	},
	AreaTablesByCustomerTabsUniqueWhere:{
		customerTabs:"CustomerTabUniqueWhere"
	},
	AreaTablesBySeatsUniqueWhere:{
		seats:"SeatUniqueWhere"
	},
	SeatUniqueWhere:{
		id:"UUID",
		customerTabs:"CustomerTabUniqueWhere"
	},
	VenueTimetableDaysByDateUniqueWhere:{
		date:"Date"
	},
	VenueTimetableDaysByShiftGroupsUniqueWhere:{
		shiftGroups:"TimetableShiftGroupUniqueWhere"
	},
	VenueTimetableDaysByNotesUniqueWhere:{
		notes:"TimetableDayNoteUniqueWhere"
	},
	TimetableDayNoteUniqueWhere:{
		id:"UUID"
	},
	VenueTimetableDaysByMetaUniqueWhere:{
		meta:"TimetableDayMetadataUniqueWhere"
	},
	TimetableDayMetadataUniqueWhere:{
		id:"UUID",
		day:"TimetableDayUniqueWhere"
	},
	TimetableDayUniqueWhere:{
		id:"UUID",
		venue:"VenueUniqueWhere",
		date:"Date",
		shiftGroups:"TimetableShiftGroupUniqueWhere",
		notes:"TimetableDayNoteUniqueWhere",
		meta:"TimetableDayMetadataUniqueWhere"
	},
	VenueUniqueWhere:{
		id:"UUID",
		deadlineTemplate:"DeadlineTemplateUniqueWhere",
		timetableDays:"TimetableDayUniqueWhere",
		timetableTemplates:"TimetableTemplateUniqueWhere",
		employeeRoles:"VenueEmployeeRoleUniqueWhere",
		pointOfSaleApplicationDevices:"PointOfSaleApplicationDeviceUniqueWhere",
		pointOfSaleTerminals:"PointOfSaleTerminalUniqueWhere",
		pointOfSalePrinters:"PointOfSalePrinterUniqueWhere",
		orders:"OrderUniqueWhere",
		areas:"AreaUniqueWhere",
		categories:"PointOfSaleCategoryUniqueWhere",
		channels:"ChannelUniqueWhere"
	},
	DeadlineTemplateUniqueWhere:{
		id:"UUID",
		venue:"VenueUniqueWhere"
	},
	TimetableTemplateUniqueWhere:{
		id:"UUID",
		staffOptions:"TimetableTemplateStaffOptionsUniqueWhere"
	},
	VenueEmployeeRoleUniqueWhere:{
		id:"UUID",
		venue:"VenueUniqueWhere",
		role:"TimetableEmployeeRoleUniqueWhere",
		employeePrivileges:"TimetablesEmployeePrivilegesUniqueWhere"
	},
	TimetableEmployeeRoleUniqueWhere:{
		id:"UUID",
		shiftGroups:"TimetableShiftGroupUniqueWhere",
		timetableTemplates:"TimetableTemplateUniqueWhere"
	},
	TimetablesEmployeePrivilegesUniqueWhere:{
		id:"UUID",
		venueEmployeeRole:"VenueEmployeeRoleUniqueWhere"
	},
	PointOfSaleTerminalUniqueWhere:{
		id:"UUID",
		applicationDevices:"PointOfSaleApplicationDeviceUniqueWhere"
	},
	PointOfSalePrinterUniqueWhere:{
		id:"UUID",
		applicationDevicesReceipt:"PointOfSaleApplicationDeviceUniqueWhere"
	},
	AreaUniqueWhere:{
		id:"UUID",
		tables:"TableUniqueWhere",
		lines:"LineUniqueWhere"
	},
	TableUniqueWhere:{
		id:"UUID",
		customerTabs:"CustomerTabUniqueWhere",
		seats:"SeatUniqueWhere"
	},
	LineUniqueWhere:{
		id:"UUID"
	},
	ChannelUniqueWhere:{
		id:"UUID",
		code:"ChannelCode",
		payments:"ChannelPaymentUniqueWhere",
		deliveries:"ChannelDeliveryUniqueWhere",
		carts:"CartUniqueWhere"
	},
	ChannelPaymentUniqueWhere:{
		id:"UUID"
	},
	VenueTimetableTemplatesByStaffOptionsUniqueWhere:{
		staffOptions:"TimetableTemplateStaffOptionsUniqueWhere"
	},
	VenueEmployeeRolesByRoleUniqueWhere:{
		role:"TimetableEmployeeRoleUniqueWhere"
	},
	VenueEmployeeRolesByEmployeePrivilegesUniqueWhere:{
		employeePrivileges:"TimetablesEmployeePrivilegesUniqueWhere"
	},
	VenuePointOfSaleApplicationDevicesByIdentifierUniqueWhere:{
		identifier:"DeviceIdentifierUniqueWhere"
	},
	VenuePointOfSaleTerminalsByApplicationDevicesUniqueWhere:{
		applicationDevices:"PointOfSaleApplicationDeviceUniqueWhere"
	},
	VenuePointOfSalePrintersByApplicationDevicesReceiptUniqueWhere:{
		applicationDevicesReceipt:"PointOfSaleApplicationDeviceUniqueWhere"
	},
	VenueOrdersBySeqUniqueWhere:{

	},
	VenueOrdersByDoubleshotLegacyIdUniqueWhere:{

	},
	VenueOrdersByDoubleShotLegacyNumberUniqueWhere:{

	},
	VenueOrdersByDiscountsUniqueWhere:{
		discounts:"OrderDiscountUniqueWhere"
	},
	VenueOrdersByDeliveryUniqueWhere:{
		delivery:"OrderDeliveryUniqueWhere"
	},
	VenueOrdersByItemsUniqueWhere:{
		items:"OrderItemUniqueWhere"
	},
	VenueOrdersByCartUniqueWhere:{
		cart:"CartUniqueWhere"
	},
	VenueOrdersByEventsUniqueWhere:{
		events:"OrderEventUniqueWhere"
	},
	VenueOrdersByPriceLinesUniqueWhere:{
		priceLines:"OrderPriceLineUniqueWhere"
	},
	VenueOrdersByPaymentsUniqueWhere:{
		payments:"OrderPaymentUniqueWhere"
	},
	VenueOrdersBySummaryUniqueWhere:{
		summary:"OrderSummaryUniqueWhere"
	},
	VenueOrdersByGratuityUniqueWhere:{
		gratuity:"GratuityUniqueWhere"
	},
	VenueAreasByTablesUniqueWhere:{
		tables:"TableUniqueWhere"
	},
	VenueAreasByLinesUniqueWhere:{
		lines:"LineUniqueWhere"
	},
	VenueCategoriesBySlugUniqueWhere:{

	},
	VenueCategoriesByLocalesUniqueWhere:{
		locales:"PointOfSaleCategoryLocaleUniqueWhere"
	},
	VenueCategoriesByProductsUniqueWhere:{
		products:"PointOfSaleCategoryProductUniqueWhere"
	},
	VenueChannelsByCodeUniqueWhere:{
		code:"ChannelCode"
	},
	VenueChannelsByPaymentsUniqueWhere:{
		payments:"ChannelPaymentUniqueWhere"
	},
	VenueChannelsByDeliveriesUniqueWhere:{
		deliveries:"ChannelDeliveryUniqueWhere"
	},
	VenueChannelsByCartsUniqueWhere:{
		carts:"CartUniqueWhere"
	},
	CartItemOrderBy:{
		id:"OrderDirection",
		quantity:"OrderDirection",
		cart:"CartOrderBy",
		product:"ProductOrderBy",
		createdAt:"OrderDirection",
		updatedAt:"OrderDirection",
		fulfillmentNote:"OrderDirection"
	},
	CartPriceLine:{
		item:{
			filter:"CartItemWhere"
		},
		product:{
			filter:"ProductWhere"
		},
		vatRate:{
			filter:"VatRateWhere"
		},
		cart:{
			filter:"CartWhere"
		}
	},
	CartPriceLineOrderBy:{
		id:"OrderDirection",
		type:"OrderDirection",
		item:"CartItemOrderBy",
		product:"ProductOrderBy",
		unitPriceCents:"OrderDirection",
		priceCents:"OrderDirection",
		quantity:"OrderDirection",
		vatRatePermille:"OrderDirection",
		vatRate:"VatRateOrderBy",
		cart:"CartOrderBy"
	},
	CartSummary:{
		cart:{
			filter:"CartWhere"
		}
	},
	CartItemsByProductUniqueWhere:{
		product:"ProductUniqueWhere"
	},
	ChannelCartsByItemsUniqueWhere:{
		items:"CartItemUniqueWhere"
	},
	ChannelCartsByOrderUniqueWhere:{
		order:"OrderUniqueWhere"
	},
	ChannelCartsByPriceLinesUniqueWhere:{
		priceLines:"CartPriceLineUniqueWhere"
	},
	ChannelCartsBySummaryUniqueWhere:{
		summary:"CartSummaryUniqueWhere"
	},
	LiftagoRide:{
		delivery:{
			filter:"OrderDeliveryWhere"
		}
	},
	WoltDriveDelivery:{
		delivery:{
			filter:"OrderDeliveryWhere"
		}
	},
	DeliveryRouteWaypointsByDeliveryUniqueWhere:{
		delivery:"OrderDeliveryUniqueWhere"
	},
	CourierRoutesByWaypointsUniqueWhere:{
		waypoints:"DeliveryWaypointUniqueWhere"
	},
	Cleaner:{
		staff:{
			filter:"StaffWhere"
		}
	},
	StocksManager:{
		staff:{
			filter:"StaffWhere"
		},
		managedProducts:{
			filter:"ProductWhere",
			orderBy:"ProductOrderBy"
		},
		managedProductsByCode:{
			by:"StocksManagerManagedProductsByCodeUniqueWhere",
			filter:"ProductWhere"
		},
		managedProductsByStocks:{
			by:"StocksManagerManagedProductsByStocksUniqueWhere",
			filter:"ProductWhere"
		},
		managedProductsByGroupPrices:{
			by:"StocksManagerManagedProductsByGroupPricesUniqueWhere",
			filter:"ProductWhere"
		},
		managedProductsByCartItems:{
			by:"StocksManagerManagedProductsByCartItemsUniqueWhere",
			filter:"ProductWhere"
		},
		managedProductsByOrderItems:{
			by:"StocksManagerManagedProductsByOrderItemsUniqueWhere",
			filter:"ProductWhere"
		},
		managedProductsByInheritedCategories:{
			by:"StocksManagerManagedProductsByInheritedCategoriesUniqueWhere",
			filter:"ProductWhere"
		},
		managedProductsByLocales:{
			by:"StocksManagerManagedProductsByLocalesUniqueWhere",
			filter:"ProductWhere"
		},
		managedProductsByCustomerPrices:{
			by:"StocksManagerManagedProductsByCustomerPricesUniqueWhere",
			filter:"ProductWhere"
		},
		managedProductsByVirtualProduct:{
			by:"StocksManagerManagedProductsByVirtualProductUniqueWhere",
			filter:"ProductWhere"
		},
		managedProductsByMeta:{
			by:"StocksManagerManagedProductsByMetaUniqueWhere",
			filter:"ProductWhere"
		},
		managedProductsByPage:{
			by:"StocksManagerManagedProductsByPageUniqueWhere",
			filter:"ProductWhere"
		},
		managedProductsBySalesDays:{
			by:"StocksManagerManagedProductsBySalesDaysUniqueWhere",
			filter:"ProductWhere"
		},
		managedProductsBySalesWeeks:{
			by:"StocksManagerManagedProductsBySalesWeeksUniqueWhere",
			filter:"ProductWhere"
		},
		managedProductsBySalesMonths:{
			by:"StocksManagerManagedProductsBySalesMonthsUniqueWhere",
			filter:"ProductWhere"
		},
		paginateManagedProducts:{
			filter:"ProductWhere",
			orderBy:"ProductOrderBy"
		}
	},
	StocksManagerManagedProductsByCodeUniqueWhere:{

	},
	StocksManagerManagedProductsByStocksUniqueWhere:{
		stocks:"ProductStockUniqueWhere"
	},
	StocksManagerManagedProductsByGroupPricesUniqueWhere:{
		groupPrices:"ProductGroupPriceUniqueWhere"
	},
	StocksManagerManagedProductsByCartItemsUniqueWhere:{
		cartItems:"CartItemUniqueWhere"
	},
	StocksManagerManagedProductsByOrderItemsUniqueWhere:{
		orderItems:"OrderItemUniqueWhere"
	},
	StocksManagerManagedProductsByInheritedCategoriesUniqueWhere:{
		inheritedCategories:"NestedProductCategoryProductUniqueWhere"
	},
	StocksManagerManagedProductsByLocalesUniqueWhere:{
		locales:"ProductLocaleUniqueWhere"
	},
	StocksManagerManagedProductsByCustomerPricesUniqueWhere:{
		customerPrices:"ProductCustomerPriceUniqueWhere"
	},
	StocksManagerManagedProductsByVirtualProductUniqueWhere:{
		virtualProduct:"VirtualProductUniqueWhere"
	},
	StocksManagerManagedProductsByMetaUniqueWhere:{
		meta:"ProductMetadataUniqueWhere"
	},
	StocksManagerManagedProductsByPageUniqueWhere:{
		page:"PageUniqueWhere"
	},
	StocksManagerManagedProductsBySalesDaysUniqueWhere:{
		salesDays:"ProductSalesDayUniqueWhere"
	},
	StocksManagerManagedProductsBySalesWeeksUniqueWhere:{
		salesWeeks:"ProductSalesWeekUniqueWhere"
	},
	StocksManagerManagedProductsBySalesMonthsUniqueWhere:{
		salesMonths:"ProductSalesMonthUniqueWhere"
	},
	CourierManager:{
		staff:{
			filter:"StaffWhere"
		}
	},
	Picker:{
		staff:{
			filter:"StaffWhere"
		}
	},
	RemunerationProfile:{
		employmentInformation:{
			filter:"EmploymentInformationWhere",
			orderBy:"EmploymentInformationOrderBy"
		},
		workMonths:{
			filter:"WorkMonthWhere"
		},
		staff:{
			filter:"StaffWhere"
		},
		paginateEmploymentInformation:{
			filter:"EmploymentInformationWhere",
			orderBy:"EmploymentInformationOrderBy"
		}
	},
	EmploymentInformation:{
		remunerationProfiles:{
			filter:"RemunerationProfileWhere"
		}
	},
	EmploymentInformationOrderBy:{
		id:"OrderDirection",
		hourlyRate:"OrderDirection",
		remunerationProfiles:"RemunerationProfileOrderBy",
		monthlySalary:"OrderDirection",
		type:"OrderDirection",
		name:"OrderDirection"
	},
	WorkMonth:{
		remunerationProfile:{
			filter:"RemunerationProfileWhere",
			orderBy:"RemunerationProfileOrderBy"
		},
		remunerationProfileByEmploymentInformation:{
			by:"WorkMonthRemunerationProfileByEmploymentInformationUniqueWhere",
			filter:"RemunerationProfileWhere"
		},
		remunerationProfileByStaff:{
			by:"WorkMonthRemunerationProfileByStaffUniqueWhere",
			filter:"RemunerationProfileWhere"
		},
		paginateRemunerationProfile:{
			filter:"RemunerationProfileWhere",
			orderBy:"RemunerationProfileOrderBy"
		}
	},
	WorkMonthRemunerationProfileByEmploymentInformationUniqueWhere:{
		employmentInformation:"EmploymentInformationUniqueWhere"
	},
	WorkMonthRemunerationProfileByStaffUniqueWhere:{
		staff:"StaffUniqueWhere"
	},
	Cashier:{
		staff:{
			filter:"StaffWhere"
		}
	},
	InternalBuyer:{
		staff:{
			filter:"StaffWhere"
		}
	},
	SalesManager:{
		staff:{
			filter:"StaffWhere"
		},
		countries:{
			filter:"CountryWhere",
			orderBy:"CountryOrderBy"
		},
		paginateCountries:{
			filter:"CountryWhere",
			orderBy:"CountryOrderBy"
		}
	},
	CashierManager:{
		staff:{
			filter:"StaffWhere"
		}
	},
	BusinessToBusinessManagerManagedBusinessesByCustomerUniqueWhere:{
		customer:"CustomerUniqueWhere"
	},
	BusinessToBusinessManagerManagedBusinessesByBusinessServiceEventsUniqueWhere:{
		businessServiceEvents:"BusinessServiceEventUniqueWhere"
	},
	BusinessToBusinessManagerManagedBusinessesByDoubleshotCoffeeEquipmentUniqueWhere:{
		doubleshotCoffeeEquipment:"DoubleshotCoffeeEquipmentUniqueWhere"
	},
	BusinessServiceEvent:{
		businessCustomer:{
			filter:"BusinessCustomerWhere"
		},
		businessService:{
			filter:"BusinessServiceWhere"
		},
		createdBy:{
			filter:"StaffWhere"
		},
		filledSupervisor:{
			filter:"StaffWhere"
		}
	},
	BusinessService:{
		locales:{
			filter:"BusinessServiceLocaleWhere",
			orderBy:"BusinessServiceLocaleOrderBy"
		},
		localesByLocale:{
			by:"BusinessServiceLocalesByLocaleUniqueWhere",
			filter:"BusinessServiceLocaleWhere"
		},
		paginateLocales:{
			filter:"BusinessServiceLocaleWhere",
			orderBy:"BusinessServiceLocaleOrderBy"
		}
	},
	BusinessServiceLocale:{
		root:{
			filter:"BusinessServiceWhere"
		},
		locale:{
			filter:"LocaleWhere"
		}
	},
	BusinessServiceLocaleOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		labelNote:"OrderDirection",
		root:"BusinessServiceOrderBy",
		locale:"LocaleOrderBy",
		labelNumberOfPeople:"OrderDirection",
		labelInvoiced:"OrderDirection",
		labelEquipment:"OrderDirection",
		labelMillTamDem:"OrderDirection",
		labelSOEspresso:"OrderDirection",
		labelFilterCoffeeInMenu:"OrderDirection",
		labelWaterMeterStatus:"OrderDirection",
		labelServiceAction:"OrderDirection",
		labelInvoiceIdentifier:"OrderDirection",
		labelSupervisor:"OrderDirection",
		labelContact:"OrderDirection",
		labelPhone:"OrderDirection",
		labelEmail:"OrderDirection",
		labelGrindingStonesCondition:"OrderDirection"
	},
	BusinessServiceOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		requireNote:"OrderDirection",
		requireNumberOfPeople:"OrderDirection",
		requireInvoiced:"OrderDirection",
		requireEquipment:"OrderDirection",
		requireMillTamDem:"OrderDirection",
		requireSOEspresso:"OrderDirection",
		requireFilterCoffeeInMenu:"OrderDirection",
		requireWaterMeterStatus:"OrderDirection",
		requireServiceAction:"OrderDirection",
		optionsEquipment:"OrderDirection",
		optionsServiceAction:"OrderDirection",
		requireInvoiceIdentifier:"OrderDirection",
		requireSupervisor:"OrderDirection",
		requireContact:"OrderDirection",
		requirePhone:"OrderDirection",
		requireEmail:"OrderDirection",
		requireGrindingStonesCondition:"OrderDirection"
	},
	BusinessServiceLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	BusinessServiceEventOrderBy:{
		id:"OrderDirection",
		createdAt:"OrderDirection",
		fulfilledAt:"OrderDirection",
		businessCustomer:"BusinessCustomerOrderBy",
		businessService:"BusinessServiceOrderBy",
		filledNumberOfPeople:"OrderDirection",
		filledInvoiced:"OrderDirection",
		filledEquipment:"OrderDirection",
		filledMillTamDem:"OrderDirection",
		filledSOEspresso:"OrderDirection",
		filledFilterCoffeeInMenu:"OrderDirection",
		filledWaterMeterStatus:"OrderDirection",
		filledServiceAction:"OrderDirection",
		filledInvoiceIdentifier:"OrderDirection",
		filledNote:"OrderDirection",
		filledContact:"OrderDirection",
		filledPhone:"OrderDirection",
		filledEmail:"OrderDirection",
		filledGrindingStonesCondition:"OrderDirection",
		createdBy:"StaffOrderBy",
		filledSupervisor:"StaffOrderBy"
	},
	OrderRecurrence:{
		locales:{
			filter:"OrderRecurrenceLocaleWhere",
			orderBy:"OrderRecurrenceLocaleOrderBy"
		},
		businessCategory:{
			filter:"BusinessCategoryWhere",
			orderBy:"BusinessCategoryOrderBy"
		},
		localesByLocale:{
			by:"OrderRecurrenceLocalesByLocaleUniqueWhere",
			filter:"OrderRecurrenceLocaleWhere"
		},
		paginateLocales:{
			filter:"OrderRecurrenceLocaleWhere",
			orderBy:"OrderRecurrenceLocaleOrderBy"
		},
		paginateBusinessCategory:{
			filter:"BusinessCategoryWhere",
			orderBy:"BusinessCategoryOrderBy"
		}
	},
	OrderRecurrenceLocale:{
		root:{
			filter:"OrderRecurrenceWhere"
		},
		locale:{
			filter:"LocaleWhere"
		}
	},
	OrderRecurrenceLocaleOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		root:"OrderRecurrenceOrderBy",
		locale:"LocaleOrderBy"
	},
	OrderRecurrenceOrderBy:{
		id:"OrderDirection",
		internalName:"OrderDirection",
		order:"OrderDirection"
	},
	OrderRecurrenceLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	ProductList:{
		items:{
			filter:"ProductListItemWhere",
			orderBy:"ProductListItemOrderBy"
		},
		businessCategory:{
			filter:"BusinessCategoryWhere"
		},
		paginateItems:{
			filter:"ProductListItemWhere",
			orderBy:"ProductListItemOrderBy"
		}
	},
	ProductListItem:{
		list:{
			filter:"ProductListWhere"
		},
		product:{
			filter:"ProductWhere"
		}
	},
	ProductListItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		list:"ProductListOrderBy",
		product:"ProductOrderBy",
		defaultQuantityForOrder:"OrderDirection"
	},
	ProductCategoryList:{
		items:{
			filter:"ProductCategoryListItemWhere",
			orderBy:"ProductCategoryListItemOrderBy"
		},
		locales:{
			filter:"ProductCategoryListLocaleWhere",
			orderBy:"ProductCategoryListLocaleOrderBy"
		},
		seasonalProductCategoriesOfBusinessCategory:{
			filter:"BusinessCategoryWhere"
		},
		specificProductsProductCategoriesOfBusinessCategory:{
			filter:"BusinessCategoryWhere"
		},
		localesByLocale:{
			by:"ProductCategoryListLocalesByLocaleUniqueWhere",
			filter:"ProductCategoryListLocaleWhere"
		},
		paginateItems:{
			filter:"ProductCategoryListItemWhere",
			orderBy:"ProductCategoryListItemOrderBy"
		},
		paginateLocales:{
			filter:"ProductCategoryListLocaleWhere",
			orderBy:"ProductCategoryListLocaleOrderBy"
		}
	},
	ProductCategoryListItem:{
		list:{
			filter:"ProductCategoryListWhere"
		},
		productCategory:{
			filter:"ProductCategoryWhere"
		}
	},
	ProductCategoryListItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		list:"ProductCategoryListOrderBy",
		productCategory:"ProductCategoryOrderBy",
		showRecipeImages:"OrderDirection",
		showPackingImages:"OrderDirection",
		showAllAvailableProducts:"OrderDirection"
	},
	ProductCategoryListLocale:{
		root:{
			filter:"ProductCategoryListWhere"
		},
		locale:{
			filter:"LocaleWhere"
		}
	},
	ProductCategoryListLocaleOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		root:"ProductCategoryListOrderBy",
		locale:"LocaleOrderBy"
	},
	ProductCategoryListLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	BusinessCategoryLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	BusinessCategoryBusinessCustomersByCustomerUniqueWhere:{
		customer:"CustomerUniqueWhere"
	},
	BusinessCategoryBusinessCustomersByBusinessServiceEventsUniqueWhere:{
		businessServiceEvents:"BusinessServiceEventUniqueWhere"
	},
	BusinessCategoryBusinessCustomersByDoubleshotCoffeeEquipmentUniqueWhere:{
		doubleshotCoffeeEquipment:"DoubleshotCoffeeEquipmentUniqueWhere"
	},
	ProductIngredientLocale:{
		root:{
			filter:"ProductIngredientWhere"
		},
		locale:{
			filter:"LocaleWhere"
		}
	},
	ProductIngredient:{
		locales:{
			filter:"ProductIngredientLocaleWhere",
			orderBy:"ProductIngredientLocaleOrderBy"
		},
		categories:{
			filter:"ProductIngredientCategoryWhere",
			orderBy:"ProductIngredientCategoryOrderBy"
		},
		allergens:{
			filter:"AllergenWhere",
			orderBy:"AllergenOrderBy"
		},
		customerRatings:{
			filter:"CustomerIngredientRatingWhere",
			orderBy:"CustomerIngredientRatingOrderBy"
		},
		preferredQuantityUnit:{
			filter:"ProductIngredientItemQuantityUnitWhere"
		},
		freshingContainer:{
			filter:"FreshingContainerWhere"
		},
		image:{
			filter:"ImageWhere"
		},
		suppliers:{
			filter:"IngredientSupplierListWhere"
		},
		localesByLocale:{
			by:"ProductIngredientLocalesByLocaleUniqueWhere",
			filter:"ProductIngredientLocaleWhere"
		},
		customerRatingsByCustomer:{
			by:"ProductIngredientCustomerRatingsByCustomerUniqueWhere",
			filter:"CustomerIngredientRatingWhere"
		},
		paginateLocales:{
			filter:"ProductIngredientLocaleWhere",
			orderBy:"ProductIngredientLocaleOrderBy"
		},
		paginateCategories:{
			filter:"ProductIngredientCategoryWhere",
			orderBy:"ProductIngredientCategoryOrderBy"
		},
		paginateAllergens:{
			filter:"AllergenWhere",
			orderBy:"AllergenOrderBy"
		},
		paginateCustomerRatings:{
			filter:"CustomerIngredientRatingWhere",
			orderBy:"CustomerIngredientRatingOrderBy"
		}
	},
	ProductIngredientLocaleOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		root:"ProductIngredientOrderBy",
		locale:"LocaleOrderBy"
	},
	ProductIngredientOrderBy:{
		id:"OrderDirection",
		internalNote:"OrderDirection",
		internalName:"OrderDirection",
		needsPrepping:"OrderDirection",
		allowCustomerRating:"OrderDirection",
		preferredQuantityUnit:"ProductIngredientItemQuantityUnitOrderBy",
		freshingContainer:"FreshingContainerOrderBy",
		image:"ImageOrderBy",
		suppliers:"IngredientSupplierListOrderBy",
		incrementQuantityNumber:"OrderDirection"
	},
	ProductIngredientItemQuantityUnitOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection"
	},
	IngredientSupplierListOrderBy:{
		id:"OrderDirection"
	},
	ProductIngredientCategory:{
		ingredients:{
			filter:"ProductIngredientWhere",
			orderBy:"ProductIngredientOrderBy"
		},
		locales:{
			filter:"ProductIngredientCategoryLocaleWhere",
			orderBy:"ProductIngredientCategoryLocaleOrderBy"
		},
		localesByLocale:{
			by:"ProductIngredientCategoryLocalesByLocaleUniqueWhere",
			filter:"ProductIngredientCategoryLocaleWhere"
		},
		paginateIngredients:{
			filter:"ProductIngredientWhere",
			orderBy:"ProductIngredientOrderBy"
		},
		paginateLocales:{
			filter:"ProductIngredientCategoryLocaleWhere",
			orderBy:"ProductIngredientCategoryLocaleOrderBy"
		}
	},
	ProductIngredientCategoryLocale:{
		root:{
			filter:"ProductIngredientCategoryWhere"
		},
		locale:{
			filter:"LocaleWhere"
		}
	},
	ProductIngredientCategoryLocaleOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		root:"ProductIngredientCategoryOrderBy",
		locale:"LocaleOrderBy"
	},
	ProductIngredientCategoryOrderBy:{
		id:"OrderDirection",
		internalName:"OrderDirection",
		internalNote:"OrderDirection",
		order:"OrderDirection"
	},
	ProductIngredientCategoryLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	Allergen:{
		locales:{
			filter:"AllergenLocaleWhere",
			orderBy:"AllergenLocaleOrderBy"
		},
		ingredients:{
			filter:"ProductIngredientWhere",
			orderBy:"ProductIngredientOrderBy"
		},
		localesByLocale:{
			by:"AllergenLocalesByLocaleUniqueWhere",
			filter:"AllergenLocaleWhere"
		},
		paginateLocales:{
			filter:"AllergenLocaleWhere",
			orderBy:"AllergenLocaleOrderBy"
		},
		paginateIngredients:{
			filter:"ProductIngredientWhere",
			orderBy:"ProductIngredientOrderBy"
		}
	},
	AllergenLocale:{
		root:{
			filter:"AllergenWhere"
		},
		locale:{
			filter:"LocaleWhere"
		}
	},
	AllergenLocaleOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		root:"AllergenOrderBy",
		locale:"LocaleOrderBy"
	},
	AllergenOrderBy:{
		id:"OrderDirection",
		internalName:"OrderDirection",
		code:"OrderDirection"
	},
	AllergenLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	CustomerIngredientRating:{
		customer:{
			filter:"CustomerWhere"
		},
		rating:{
			filter:"ProductIngredientRatingWhere"
		},
		ingredient:{
			filter:"ProductIngredientWhere"
		}
	},
	ProductIngredientRating:{
		icon:{
			filter:"ImageWhere"
		}
	},
	CustomerIngredientRatingOrderBy:{
		id:"OrderDirection",
		customer:"CustomerOrderBy",
		rating:"ProductIngredientRatingOrderBy",
		ingredient:"ProductIngredientOrderBy"
	},
	ProductIngredientRatingOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		name:"OrderDirection",
		icon:"ImageOrderBy"
	},
	FreshingContainer:{
		workspace:{
			filter:"WorkspaceWhere"
		}
	},
	Workspace:{
		freshingContainers:{
			filter:"FreshingContainerWhere",
			orderBy:"FreshingContainerOrderBy"
		},
		openingHours:{
			filter:"WeekHoursWhere"
		},
		workingHours:{
			filter:"WeekHoursWhere"
		},
		defaultFreshingContainer:{
			filter:"FreshingContainerWhere"
		},
		creditsProduct:{
			filter:"VirtualProductWhere"
		},
		discountVatRate:{
			filter:"VatRateWhere"
		},
		paginateFreshingContainers:{
			filter:"FreshingContainerWhere",
			orderBy:"FreshingContainerOrderBy"
		}
	},
	VirtualProduct:{
		product:{
			filter:"ProductWhere"
		}
	},
	IngredientSupplierList:{
		items:{
			filter:"IngredientSupplierItemWhere",
			orderBy:"IngredientSupplierItemOrderBy"
		},
		paginateItems:{
			filter:"IngredientSupplierItemWhere",
			orderBy:"IngredientSupplierItemOrderBy"
		}
	},
	IngredientSupplierItem:{
		list:{
			filter:"IngredientSupplierListWhere"
		},
		supplier:{
			filter:"IngredientSupplierWhere"
		}
	},
	IngredientSupplier:{
		locales:{
			filter:"IngredientSupplierLocaleWhere",
			orderBy:"IngredientSupplierLocaleOrderBy"
		},
		localesByLocale:{
			by:"IngredientSupplierLocalesByLocaleUniqueWhere",
			filter:"IngredientSupplierLocaleWhere"
		},
		paginateLocales:{
			filter:"IngredientSupplierLocaleWhere",
			orderBy:"IngredientSupplierLocaleOrderBy"
		}
	},
	IngredientSupplierLocale:{
		root:{
			filter:"IngredientSupplierWhere"
		},
		locale:{
			filter:"LocaleWhere"
		}
	},
	IngredientSupplierLocaleOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		root:"IngredientSupplierOrderBy",
		locale:"LocaleOrderBy"
	},
	IngredientSupplierOrderBy:{
		id:"OrderDirection",
		internalName:"OrderDirection",
		internalNote:"OrderDirection"
	},
	IngredientSupplierLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	IngredientSupplierItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		list:"IngredientSupplierListOrderBy",
		supplier:"IngredientSupplierOrderBy"
	},
	ProductIngredientLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	ProductIngredientCustomerRatingsByCustomerUniqueWhere:{
		customer:"CustomerUniqueWhere"
	},
	BlogLocale:{
		root:{
			filter:"BlogWhere"
		},
		locale:{
			filter:"LocaleWhere"
		}
	},
	Blog:{
		locales:{
			filter:"BlogLocaleWhere",
			orderBy:"BlogLocaleOrderBy"
		},
		localesByLocale:{
			by:"BlogLocalesByLocaleUniqueWhere",
			filter:"BlogLocaleWhere"
		},
		paginateLocales:{
			filter:"BlogLocaleWhere",
			orderBy:"BlogLocaleOrderBy"
		}
	},
	BlogLocaleOrderBy:{
		id:"OrderDirection",
		pageName:"OrderDirection",
		title:"OrderDirection",
		lead:"OrderDirection",
		root:"BlogOrderBy",
		locale:"LocaleOrderBy"
	},
	BlogOrderBy:{
		id:"OrderDirection",
		unique:"OrderDirection"
	},
	BlogLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	BlogPostLocale:{
		root:{
			filter:"BlogPostWhere"
		},
		locale:{
			filter:"LocaleWhere"
		},
		cover:{
			filter:"CoverWhere"
		},
		content:{
			filter:"ContentWhere"
		},
		link:{
			filter:"LinkableWhere"
		},
		seo:{
			filter:"SeoWhere"
		},
		products:{
			filter:"ProductWhere",
			orderBy:"ProductOrderBy"
		},
		paginateProducts:{
			filter:"ProductWhere",
			orderBy:"ProductOrderBy"
		}
	},
	BlogPost:{
		locales:{
			filter:"BlogPostLocaleWhere",
			orderBy:"BlogPostLocaleOrderBy"
		},
		localesByLocale:{
			by:"BlogPostLocalesByLocaleUniqueWhere",
			filter:"BlogPostLocaleWhere"
		},
		localesByCover:{
			by:"BlogPostLocalesByCoverUniqueWhere",
			filter:"BlogPostLocaleWhere"
		},
		localesByContent:{
			by:"BlogPostLocalesByContentUniqueWhere",
			filter:"BlogPostLocaleWhere"
		},
		localesByLink:{
			by:"BlogPostLocalesByLinkUniqueWhere",
			filter:"BlogPostLocaleWhere"
		},
		localesBySeo:{
			by:"BlogPostLocalesBySeoUniqueWhere",
			filter:"BlogPostLocaleWhere"
		},
		paginateLocales:{
			filter:"BlogPostLocaleWhere",
			orderBy:"BlogPostLocaleOrderBy"
		}
	},
	BlogPostLocaleOrderBy:{
		id:"OrderDirection",
		title:"OrderDirection",
		availableForWeb:"OrderDirection",
		availableForMobile:"OrderDirection",
		root:"BlogPostOrderBy",
		locale:"LocaleOrderBy",
		cover:"CoverOrderBy",
		content:"ContentOrderBy",
		link:"LinkableOrderBy",
		seo:"SeoOrderBy"
	},
	BlogPostOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection"
	},
	CoverOrderBy:{
		id:"OrderDirection",
		primaryTitle:"OrderDirection",
		secondaryTitle:"OrderDirection",
		medium:"MediumOrderBy",
		buttonColors:"ColorPalleteOrderBy"
	},
	MediumOrderBy:{
		id:"OrderDirection",
		type:"OrderDirection",
		colorTheme:"OrderDirection",
		image:"ImageOrderBy",
		video:"VideoOrderBy"
	},
	VideoOrderBy:{
		id:"OrderDirection",
		src:"OrderDirection",
		width:"OrderDirection",
		height:"OrderDirection",
		size:"OrderDirection",
		type:"OrderDirection",
		duration:"OrderDirection",
		poster:"ImageOrderBy"
	},
	ColorPalleteOrderBy:{
		id:"OrderDirection",
		background:"OrderDirection",
		text:"OrderDirection"
	},
	ContentOrderBy:{
		id:"OrderDirection"
	},
	LinkableOrderBy:{
		id:"OrderDirection",
		url:"OrderDirection",
		blogPost:"BlogPostLocaleOrderBy",
		page:"PageLocaleOrderBy",
		wikiPage:"WikiPageOrderBy",
		redirect:"RedirectOrderBy"
	},
	PageLocaleOrderBy:{
		id:"OrderDirection",
		title:"OrderDirection",
		link:"LinkableOrderBy",
		root:"PageOrderBy",
		locale:"LocaleOrderBy",
		seo:"SeoOrderBy",
		content:"ContentOrderBy",
		cover:"CoverOrderBy",
		theme:"OrderDirection"
	},
	SeoOrderBy:{
		id:"OrderDirection",
		title:"OrderDirection",
		description:"OrderDirection",
		ogTitle:"OrderDirection",
		ogDescription:"OrderDirection",
		ogImage:"ImageOrderBy"
	},
	WikiPageOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		title:"OrderDirection",
		emoji:"OrderDirection",
		link:"LinkableOrderBy",
		parent:"WikiPageOrderBy",
		content:"ContentOrderBy"
	},
	RedirectOrderBy:{
		id:"OrderDirection",
		link:"LinkableOrderBy",
		target:"LinkOrderBy"
	},
	LinkOrderBy:{
		id:"OrderDirection",
		type:"OrderDirection",
		title:"OrderDirection",
		externalLink:"OrderDirection",
		internalLink:"LinkableOrderBy"
	},
	BlogPostLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	BlogPostLocalesByCoverUniqueWhere:{
		cover:"CoverUniqueWhere"
	},
	BlogPostLocalesByContentUniqueWhere:{
		content:"ContentUniqueWhere"
	},
	BlogPostLocalesByLinkUniqueWhere:{
		link:"LinkableUniqueWhere"
	},
	BlogPostLocalesBySeoUniqueWhere:{
		seo:"SeoUniqueWhere"
	},
	Cover:{
		medium:{
			filter:"MediumWhere"
		},
		buttonColors:{
			filter:"ColorPalleteWhere"
		}
	},
	Medium:{
		image:{
			filter:"ImageWhere"
		},
		video:{
			filter:"VideoWhere"
		}
	},
	Video:{
		poster:{
			filter:"ImageWhere"
		}
	},
	Content:{
		blocks:{
			filter:"ContentBlockWhere",
			orderBy:"ContentBlockOrderBy"
		},
		blocksByReferences:{
			by:"ContentBlocksByReferencesUniqueWhere",
			filter:"ContentBlockWhere"
		},
		paginateBlocks:{
			filter:"ContentBlockWhere",
			orderBy:"ContentBlockOrderBy"
		}
	},
	ContentBlock:{
		content:{
			filter:"ContentWhere"
		},
		references:{
			filter:"ContentReferenceWhere",
			orderBy:"ContentReferenceOrderBy"
		},
		referencesByProducts:{
			by:"ContentBlockReferencesByProductsUniqueWhere",
			filter:"ContentReferenceWhere"
		},
		referencesByProductBanners:{
			by:"ContentBlockReferencesByProductBannersUniqueWhere",
			filter:"ContentReferenceWhere"
		},
		referencesByDeliveryRegions:{
			by:"ContentBlockReferencesByDeliveryRegionsUniqueWhere",
			filter:"ContentReferenceWhere"
		},
		paginateReferences:{
			filter:"ContentReferenceWhere",
			orderBy:"ContentReferenceOrderBy"
		}
	},
	ContentReference:{
		block:{
			filter:"ContentBlockWhere"
		},
		colorPallete:{
			filter:"ColorPalleteWhere"
		},
		medium:{
			filter:"MediumWhere"
		},
		link:{
			filter:"LinkWhere"
		},
		blogPosts:{
			filter:"BlogPostListWhere"
		},
		links:{
			filter:"LinkListWhere"
		},
		products:{
			filter:"ProductListWhere"
		},
		hero:{
			filter:"HeroWhere"
		},
		gallery:{
			filter:"GalleryWhere"
		},
		socialsAndApps:{
			filter:"SocialsAndAppsWhere"
		},
		productGrid:{
			filter:"ProductGridWhere"
		},
		productBanners:{
			filter:"ProductBannerListWhere"
		},
		deliveryRegions:{
			filter:"DeliveryRegionsWhere"
		},
		textList:{
			filter:"TextListWhere"
		},
		gridTiles:{
			filter:"GridTilesWhere"
		}
	},
	Link:{
		internalLink:{
			filter:"LinkableWhere"
		}
	},
	Linkable:{
		blogPost:{
			filter:"BlogPostLocaleWhere"
		},
		page:{
			filter:"PageLocaleWhere"
		},
		wikiPage:{
			filter:"WikiPageWhere"
		},
		redirect:{
			filter:"RedirectWhere"
		}
	},
	PageLocale:{
		link:{
			filter:"LinkableWhere"
		},
		root:{
			filter:"PageWhere"
		},
		locale:{
			filter:"LocaleWhere"
		},
		seo:{
			filter:"SeoWhere"
		},
		content:{
			filter:"ContentWhere"
		},
		cover:{
			filter:"CoverWhere"
		}
	},
	Page:{
		locales:{
			filter:"PageLocaleWhere",
			orderBy:"PageLocaleOrderBy"
		},
		localesByLocale:{
			by:"PageLocalesByLocaleUniqueWhere",
			filter:"PageLocaleWhere"
		},
		localesByLink:{
			by:"PageLocalesByLinkUniqueWhere",
			filter:"PageLocaleWhere"
		},
		localesBySeo:{
			by:"PageLocalesBySeoUniqueWhere",
			filter:"PageLocaleWhere"
		},
		localesByContent:{
			by:"PageLocalesByContentUniqueWhere",
			filter:"PageLocaleWhere"
		},
		localesByCover:{
			by:"PageLocalesByCoverUniqueWhere",
			filter:"PageLocaleWhere"
		},
		paginateLocales:{
			filter:"PageLocaleWhere",
			orderBy:"PageLocaleOrderBy"
		}
	},
	PageLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	PageLocalesByLinkUniqueWhere:{
		link:"LinkableUniqueWhere"
	},
	PageLocalesBySeoUniqueWhere:{
		seo:"SeoUniqueWhere"
	},
	PageLocalesByContentUniqueWhere:{
		content:"ContentUniqueWhere"
	},
	PageLocalesByCoverUniqueWhere:{
		cover:"CoverUniqueWhere"
	},
	Seo:{
		ogImage:{
			filter:"ImageWhere"
		}
	},
	WikiPage:{
		link:{
			filter:"LinkableWhere"
		},
		parent:{
			filter:"WikiPageWhere"
		},
		children:{
			filter:"WikiPageWhere",
			orderBy:"WikiPageOrderBy"
		},
		content:{
			filter:"ContentWhere"
		},
		childrenByLink:{
			by:"WikiPageChildrenByLinkUniqueWhere",
			filter:"WikiPageWhere"
		},
		childrenByChildren:{
			by:"WikiPageChildrenByChildrenUniqueWhere",
			filter:"WikiPageWhere"
		},
		childrenByContent:{
			by:"WikiPageChildrenByContentUniqueWhere",
			filter:"WikiPageWhere"
		},
		paginateChildren:{
			filter:"WikiPageWhere",
			orderBy:"WikiPageOrderBy"
		}
	},
	WikiPageChildrenByLinkUniqueWhere:{
		link:"LinkableUniqueWhere"
	},
	WikiPageChildrenByChildrenUniqueWhere:{
		children:"WikiPageUniqueWhere"
	},
	WikiPageChildrenByContentUniqueWhere:{
		content:"ContentUniqueWhere"
	},
	Redirect:{
		link:{
			filter:"LinkableWhere"
		},
		target:{
			filter:"LinkWhere"
		}
	},
	BlogPostList:{
		items:{
			filter:"BlogPostListItemWhere",
			orderBy:"BlogPostListItemOrderBy"
		},
		paginateItems:{
			filter:"BlogPostListItemWhere",
			orderBy:"BlogPostListItemOrderBy"
		}
	},
	BlogPostListItem:{
		list:{
			filter:"BlogPostListWhere"
		},
		blogPost:{
			filter:"BlogPostLocaleWhere"
		}
	},
	BlogPostListItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		caption:"OrderDirection",
		list:"BlogPostListOrderBy",
		blogPost:"BlogPostLocaleOrderBy"
	},
	BlogPostListOrderBy:{
		id:"OrderDirection"
	},
	LinkList:{
		items:{
			filter:"LinkListItemWhere",
			orderBy:"LinkListItemOrderBy"
		},
		paginateItems:{
			filter:"LinkListItemWhere",
			orderBy:"LinkListItemOrderBy"
		}
	},
	LinkListItem:{
		list:{
			filter:"LinkListWhere"
		},
		link:{
			filter:"LinkWhere"
		}
	},
	LinkListItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		isPrimary:"OrderDirection",
		list:"LinkListOrderBy",
		link:"LinkOrderBy"
	},
	LinkListOrderBy:{
		id:"OrderDirection"
	},
	Hero:{
		medium:{
			filter:"MediumWhere"
		}
	},
	Gallery:{
		items:{
			filter:"GalleryItemWhere",
			orderBy:"GalleryItemOrderBy"
		},
		paginateItems:{
			filter:"GalleryItemWhere",
			orderBy:"GalleryItemOrderBy"
		}
	},
	GalleryItem:{
		list:{
			filter:"GalleryWhere"
		},
		medium:{
			filter:"MediumWhere"
		}
	},
	GalleryItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		caption:"OrderDirection",
		list:"GalleryOrderBy",
		medium:"MediumOrderBy"
	},
	GalleryOrderBy:{
		id:"OrderDirection"
	},
	ProductGrid:{
		categories:{
			filter:"ProductGridCategoryWhere",
			orderBy:"ProductGridCategoryOrderBy"
		},
		categoriesByItems:{
			by:"ProductGridCategoriesByItemsUniqueWhere",
			filter:"ProductGridCategoryWhere"
		},
		categoriesByImages:{
			by:"ProductGridCategoriesByImagesUniqueWhere",
			filter:"ProductGridCategoryWhere"
		},
		paginateCategories:{
			filter:"ProductGridCategoryWhere",
			orderBy:"ProductGridCategoryOrderBy"
		}
	},
	ProductGridCategory:{
		root:{
			filter:"ProductGridWhere"
		},
		items:{
			filter:"ProductGridItemWhere",
			orderBy:"ProductGridItemOrderBy"
		},
		images:{
			filter:"ImageListWhere"
		},
		paginateItems:{
			filter:"ProductGridItemWhere",
			orderBy:"ProductGridItemOrderBy"
		}
	},
	ProductGridItem:{
		product:{
			filter:"ProductWhere"
		},
		medium:{
			filter:"MediumWhere"
		},
		link:{
			filter:"LinkWhere"
		},
		category:{
			filter:"ProductGridCategoryWhere"
		}
	},
	ProductGridItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		title:"OrderDirection",
		lead:"OrderDirection",
		product:"ProductOrderBy",
		medium:"MediumOrderBy",
		link:"LinkOrderBy",
		category:"ProductGridCategoryOrderBy",
		description:"OrderDirection"
	},
	ProductGridCategoryOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		title:"OrderDirection",
		root:"ProductGridOrderBy",
		images:"ImageListOrderBy"
	},
	ProductGridOrderBy:{
		id:"OrderDirection",
		isCarousel:"OrderDirection",
		type:"OrderDirection"
	},
	ImageListOrderBy:{
		id:"OrderDirection"
	},
	ImageList:{
		items:{
			filter:"ImageListItemWhere",
			orderBy:"ImageListItemOrderBy"
		},
		itemsByImage:{
			by:"ImageListItemsByImageUniqueWhere",
			filter:"ImageListItemWhere"
		},
		paginateItems:{
			filter:"ImageListItemWhere",
			orderBy:"ImageListItemOrderBy"
		}
	},
	ImageListItem:{
		list:{
			filter:"ImageListWhere"
		},
		image:{
			filter:"ImageWhere"
		}
	},
	ImageListItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		list:"ImageListOrderBy",
		image:"ImageOrderBy"
	},
	ImageListItemsByImageUniqueWhere:{
		image:"ImageUniqueWhere"
	},
	ProductGridCategoriesByItemsUniqueWhere:{
		items:"ProductGridItemUniqueWhere"
	},
	ProductGridItemUniqueWhere:{
		id:"UUID"
	},
	ProductGridCategoriesByImagesUniqueWhere:{
		images:"ImageListUniqueWhere"
	},
	ProductBannerList:{
		items:{
			filter:"ProductBannerItemWhere",
			orderBy:"ProductBannerItemOrderBy"
		},
		paginateItems:{
			filter:"ProductBannerItemWhere",
			orderBy:"ProductBannerItemOrderBy"
		}
	},
	ProductBannerItem:{
		list:{
			filter:"ProductBannerListWhere"
		},
		banner:{
			filter:"ProductBannerWhere"
		}
	},
	ProductBanner:{
		button:{
			filter:"LinkWhere"
		},
		backgroundImage:{
			filter:"ImageWhere"
		},
		productImage:{
			filter:"ImageWhere"
		},
		product:{
			filter:"ProductWhere"
		}
	},
	ProductBannerItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		list:"ProductBannerListOrderBy",
		banner:"ProductBannerOrderBy",
		size:"OrderDirection"
	},
	ProductBannerListOrderBy:{
		id:"OrderDirection"
	},
	ProductBannerOrderBy:{
		id:"OrderDirection",
		beforeTitle:"OrderDirection",
		title:"OrderDirection",
		label:"OrderDirection",
		button:"LinkOrderBy",
		backgroundImage:"ImageOrderBy",
		productImage:"ImageOrderBy",
		product:"ProductOrderBy"
	},
	DeliveryRegions:{
		items:{
			filter:"DeliveryRegionsItemWhere",
			orderBy:"DeliveryRegionsItemOrderBy"
		},
		itemsByImage:{
			by:"DeliveryRegionsItemsByImageUniqueWhere",
			filter:"DeliveryRegionsItemWhere"
		},
		itemsByTextList:{
			by:"DeliveryRegionsItemsByTextListUniqueWhere",
			filter:"DeliveryRegionsItemWhere"
		},
		itemsByGallery:{
			by:"DeliveryRegionsItemsByGalleryUniqueWhere",
			filter:"DeliveryRegionsItemWhere"
		},
		paginateItems:{
			filter:"DeliveryRegionsItemWhere",
			orderBy:"DeliveryRegionsItemOrderBy"
		}
	},
	DeliveryRegionsItem:{
		list:{
			filter:"DeliveryRegionsWhere"
		},
		image:{
			filter:"ImageWhere"
		},
		textList:{
			filter:"TextListWhere"
		},
		gallery:{
			filter:"ImageListWhere"
		}
	},
	TextList:{
		items:{
			filter:"TextItemWhere",
			orderBy:"TextItemOrderBy"
		},
		paginateItems:{
			filter:"TextItemWhere",
			orderBy:"TextItemOrderBy"
		}
	},
	TextItem:{
		list:{
			filter:"TextListWhere"
		}
	},
	TextItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		text:"OrderDirection",
		list:"TextListOrderBy",
		title:"OrderDirection"
	},
	TextListOrderBy:{
		id:"OrderDirection"
	},
	DeliveryRegionsItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		title:"OrderDirection",
		offerLabel:"OrderDirection",
		list:"DeliveryRegionsOrderBy",
		image:"ImageOrderBy",
		textList:"TextListOrderBy",
		gallery:"ImageListOrderBy"
	},
	DeliveryRegionsOrderBy:{
		id:"OrderDirection"
	},
	DeliveryRegionsItemsByImageUniqueWhere:{
		image:"ImageUniqueWhere"
	},
	DeliveryRegionsItemsByTextListUniqueWhere:{
		textList:"TextListUniqueWhere"
	},
	DeliveryRegionsItemsByGalleryUniqueWhere:{
		gallery:"ImageListUniqueWhere"
	},
	GridTiles:{
		items:{
			filter:"GridTileItemWhere",
			orderBy:"GridTileItemOrderBy"
		},
		itemsByLink:{
			by:"GridTilesItemsByLinkUniqueWhere",
			filter:"GridTileItemWhere"
		},
		paginateItems:{
			filter:"GridTileItemWhere",
			orderBy:"GridTileItemOrderBy"
		}
	},
	GridTileItem:{
		list:{
			filter:"GridTilesWhere"
		},
		medium:{
			filter:"MediumWhere"
		},
		link:{
			filter:"LinkWhere"
		}
	},
	GridTileItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		text:"OrderDirection",
		list:"GridTilesOrderBy",
		medium:"MediumOrderBy",
		link:"LinkOrderBy"
	},
	GridTilesOrderBy:{
		id:"OrderDirection"
	},
	GridTilesItemsByLinkUniqueWhere:{
		link:"LinkUniqueWhere"
	},
	LinkUniqueWhere:{
		id:"UUID"
	},
	ContentReferenceOrderBy:{
		id:"OrderDirection",
		type:"OrderDirection",
		primaryText:"OrderDirection",
		secondaryText:"OrderDirection",
		jsonContent:"OrderDirection",
		block:"ContentBlockOrderBy",
		colorPallete:"ColorPalleteOrderBy",
		medium:"MediumOrderBy",
		link:"LinkOrderBy",
		blogPosts:"BlogPostListOrderBy",
		links:"LinkListOrderBy",
		products:"ProductListOrderBy",
		contentSize:"OrderDirection",
		misc:"OrderDirection",
		hero:"HeroOrderBy",
		gallery:"GalleryOrderBy",
		socialsAndApps:"SocialsAndAppsOrderBy",
		productGrid:"ProductGridOrderBy",
		productBanners:"ProductBannerListOrderBy",
		deliveryRegions:"DeliveryRegionsOrderBy",
		textList:"TextListOrderBy",
		gridTiles:"GridTilesOrderBy"
	},
	ContentBlockOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		json:"OrderDirection",
		content:"ContentOrderBy"
	},
	HeroOrderBy:{
		id:"OrderDirection",
		showLogo:"OrderDirection",
		middleContent:"OrderDirection",
		medium:"MediumOrderBy"
	},
	SocialsAndAppsOrderBy:{
		id:"OrderDirection",
		instagram:"OrderDirection",
		appStore:"OrderDirection",
		googlePlay:"OrderDirection"
	},
	ContentBlockReferencesByProductsUniqueWhere:{
		products:"ProductListUniqueWhere"
	},
	ContentBlockReferencesByProductBannersUniqueWhere:{
		productBanners:"ProductBannerListUniqueWhere"
	},
	ContentBlockReferencesByDeliveryRegionsUniqueWhere:{
		deliveryRegions:"DeliveryRegionsUniqueWhere"
	},
	ContentBlocksByReferencesUniqueWhere:{
		references:"ContentReferenceUniqueWhere"
	},
	TranslationCataloguesIdentifier:{
		catalogue:{
			filter:"TranslationCatalogueWhere",
			orderBy:"TranslationCatalogueOrderBy"
		},
		catalogueByDomain:{
			by:"TranslationCataloguesIdentifierCatalogueByDomainUniqueWhere",
			filter:"TranslationCatalogueWhere"
		},
		catalogueByValues:{
			by:"TranslationCataloguesIdentifierCatalogueByValuesUniqueWhere",
			filter:"TranslationCatalogueWhere"
		},
		paginateCatalogue:{
			filter:"TranslationCatalogueWhere",
			orderBy:"TranslationCatalogueOrderBy"
		}
	},
	TranslationCatalogue:{
		domain:{
			filter:"TranslationDomainWhere"
		},
		fallback:{
			filter:"TranslationCatalogueWhere"
		},
		values:{
			filter:"TranslationValueWhere",
			orderBy:"TranslationValueOrderBy"
		},
		identifier:{
			filter:"TranslationCataloguesIdentifierWhere"
		},
		valuesByKey:{
			by:"TranslationCatalogueValuesByKeyUniqueWhere",
			filter:"TranslationValueWhere"
		},
		paginateValues:{
			filter:"TranslationValueWhere",
			orderBy:"TranslationValueOrderBy"
		}
	},
	TranslationDomain:{
		catalogues:{
			filter:"TranslationCatalogueWhere",
			orderBy:"TranslationCatalogueOrderBy"
		},
		keys:{
			filter:"TranslationKeyWhere",
			orderBy:"TranslationKeyOrderBy"
		},
		cataloguesByIdentifier:{
			by:"TranslationDomainCataloguesByIdentifierUniqueWhere",
			filter:"TranslationCatalogueWhere"
		},
		cataloguesByValues:{
			by:"TranslationDomainCataloguesByValuesUniqueWhere",
			filter:"TranslationCatalogueWhere"
		},
		keysByIdentifier:{
			by:"TranslationDomainKeysByIdentifierUniqueWhere",
			filter:"TranslationKeyWhere"
		},
		keysByValues:{
			by:"TranslationDomainKeysByValuesUniqueWhere",
			filter:"TranslationKeyWhere"
		},
		paginateCatalogues:{
			filter:"TranslationCatalogueWhere",
			orderBy:"TranslationCatalogueOrderBy"
		},
		paginateKeys:{
			filter:"TranslationKeyWhere",
			orderBy:"TranslationKeyOrderBy"
		}
	},
	TranslationCatalogueOrderBy:{
		id:"OrderDirection",
		domain:"TranslationDomainOrderBy",
		fallback:"TranslationCatalogueOrderBy",
		identifier:"TranslationCataloguesIdentifierOrderBy"
	},
	TranslationDomainOrderBy:{
		id:"OrderDirection",
		identifier:"OrderDirection",
		name:"OrderDirection"
	},
	TranslationKey:{
		domain:{
			filter:"TranslationDomainWhere"
		},
		values:{
			filter:"TranslationValueWhere",
			orderBy:"TranslationValueOrderBy"
		},
		valuesByCatalogue:{
			by:"TranslationKeyValuesByCatalogueUniqueWhere",
			filter:"TranslationValueWhere"
		},
		paginateValues:{
			filter:"TranslationValueWhere",
			orderBy:"TranslationValueOrderBy"
		}
	},
	TranslationValue:{
		catalogue:{
			filter:"TranslationCatalogueWhere"
		},
		key:{
			filter:"TranslationKeyWhere"
		}
	},
	TranslationValueOrderBy:{
		id:"OrderDirection",
		value:"OrderDirection",
		catalogue:"TranslationCatalogueOrderBy",
		key:"TranslationKeyOrderBy"
	},
	TranslationKeyOrderBy:{
		id:"OrderDirection",
		identifier:"OrderDirection",
		contentType:"OrderDirection",
		note:"OrderDirection",
		domain:"TranslationDomainOrderBy"
	},
	TranslationKeyValuesByCatalogueUniqueWhere:{
		catalogue:"TranslationCatalogueUniqueWhere"
	},
	TranslationDomainCataloguesByIdentifierUniqueWhere:{
		identifier:"TranslationCataloguesIdentifierUniqueWhere"
	},
	TranslationDomainCataloguesByValuesUniqueWhere:{
		values:"TranslationValueUniqueWhere"
	},
	TranslationDomainKeysByIdentifierUniqueWhere:{

	},
	TranslationDomainKeysByValuesUniqueWhere:{
		values:"TranslationValueUniqueWhere"
	},
	TranslationCatalogueValuesByKeyUniqueWhere:{
		key:"TranslationKeyUniqueWhere"
	},
	TranslationCataloguesIdentifierCatalogueByDomainUniqueWhere:{
		domain:"TranslationDomainUniqueWhere"
	},
	TranslationCataloguesIdentifierCatalogueByValuesUniqueWhere:{
		values:"TranslationValueUniqueWhere"
	},
	MenuLocale:{
		root:{
			filter:"SiteMenuWhere"
		},
		locale:{
			filter:"LocaleWhere"
		},
		items:{
			filter:"MenuItemWhere",
			orderBy:"MenuItemOrderBy"
		},
		secondaryItems:{
			filter:"LinkListWhere"
		},
		eshopLink:{
			filter:"LinkWhere"
		},
		itemsBySubitems:{
			by:"MenuLocaleItemsBySubitemsUniqueWhere",
			filter:"MenuItemWhere"
		},
		paginateItems:{
			filter:"MenuItemWhere",
			orderBy:"MenuItemOrderBy"
		}
	},
	SiteMenu:{
		locales:{
			filter:"MenuLocaleWhere",
			orderBy:"MenuLocaleOrderBy"
		},
		localesByLocale:{
			by:"SiteMenuLocalesByLocaleUniqueWhere",
			filter:"MenuLocaleWhere"
		},
		localesByItems:{
			by:"SiteMenuLocalesByItemsUniqueWhere",
			filter:"MenuLocaleWhere"
		},
		localesBySecondaryItems:{
			by:"SiteMenuLocalesBySecondaryItemsUniqueWhere",
			filter:"MenuLocaleWhere"
		},
		paginateLocales:{
			filter:"MenuLocaleWhere",
			orderBy:"MenuLocaleOrderBy"
		}
	},
	MenuLocaleOrderBy:{
		id:"OrderDirection",
		root:"SiteMenuOrderBy",
		locale:"LocaleOrderBy",
		secondaryItems:"LinkListOrderBy",
		eshopLink:"LinkOrderBy"
	},
	SiteMenuOrderBy:{
		id:"OrderDirection",
		unique:"OrderDirection"
	},
	SiteMenuLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	SiteMenuLocalesByItemsUniqueWhere:{
		items:"MenuItemUniqueWhere"
	},
	SiteMenuLocalesBySecondaryItemsUniqueWhere:{
		secondaryItems:"LinkListUniqueWhere"
	},
	MenuItem:{
		menu:{
			filter:"MenuLocaleWhere"
		},
		link:{
			filter:"LinkWhere"
		},
		subitems:{
			filter:"MenuSubitemWhere",
			orderBy:"MenuSubitemOrderBy"
		},
		paginateSubitems:{
			filter:"MenuSubitemWhere",
			orderBy:"MenuSubitemOrderBy"
		}
	},
	MenuSubitem:{
		item:{
			filter:"MenuItemWhere"
		},
		links:{
			filter:"MenuLinkListWhere"
		},
		products:{
			filter:"MenuProductsWhere"
		},
		delivery:{
			filter:"MenuDeliveryWhere"
		},
		contact:{
			filter:"MenuContactWhere"
		}
	},
	MenuLinkList:{
		items:{
			filter:"MenuLinkItemWhere",
			orderBy:"MenuLinkItemOrderBy"
		},
		paginateItems:{
			filter:"MenuLinkItemWhere",
			orderBy:"MenuLinkItemOrderBy"
		}
	},
	MenuLinkItem:{
		list:{
			filter:"MenuLinkListWhere"
		},
		link:{
			filter:"LinkWhere"
		},
		image:{
			filter:"ImageWhere"
		}
	},
	MenuLinkItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		list:"MenuLinkListOrderBy",
		link:"LinkOrderBy",
		image:"ImageOrderBy",
		description:"OrderDirection"
	},
	MenuLinkListOrderBy:{
		id:"OrderDirection"
	},
	MenuProducts:{
		links:{
			filter:"MenuLinkListWhere"
		},
		buttons:{
			filter:"LinkListWhere"
		}
	},
	MenuDelivery:{
		deliveryRegions:{
			filter:"DeliveryRegionsWhere"
		},
		socialsAndApps:{
			filter:"SocialsAndAppsWhere"
		}
	},
	MenuContact:{
		image:{
			filter:"ImageWhere"
		}
	},
	MenuSubitemOrderBy:{
		id:"OrderDirection",
		type:"OrderDirection",
		title:"OrderDirection",
		item:"MenuItemOrderBy",
		links:"MenuLinkListOrderBy",
		products:"MenuProductsOrderBy",
		delivery:"MenuDeliveryOrderBy",
		contact:"MenuContactOrderBy",
		order:"OrderDirection"
	},
	MenuItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		menu:"MenuLocaleOrderBy",
		link:"LinkOrderBy"
	},
	MenuProductsOrderBy:{
		id:"OrderDirection",
		links:"MenuLinkListOrderBy",
		buttons:"LinkListOrderBy"
	},
	MenuDeliveryOrderBy:{
		id:"OrderDirection",
		deliveryRegions:"DeliveryRegionsOrderBy",
		text:"OrderDirection",
		socialsAndApps:"SocialsAndAppsOrderBy"
	},
	MenuContactOrderBy:{
		id:"OrderDirection",
		text:"OrderDirection",
		image:"ImageOrderBy"
	},
	MenuLocaleItemsBySubitemsUniqueWhere:{
		subitems:"MenuSubitemUniqueWhere"
	},
	ProductPackingLocaleOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		shortName:"OrderDirection",
		description:"OrderDirection",
		root:"ProductPackingOrderBy",
		locale:"LocaleOrderBy"
	},
	ProductLocale:{
		root:{
			filter:"ProductWhere"
		},
		locale:{
			filter:"LocaleWhere"
		},
		featureList:{
			filter:"TextListWhere"
		}
	},
	ProductLocaleOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		description:"OrderDirection",
		root:"ProductOrderBy",
		locale:"LocaleOrderBy",
		featureList:"TextListOrderBy",
		printableName:"OrderDirection",
		firstSticker:"OrderDirection",
		secondSticker:"OrderDirection"
	},
	ProductRecipeLocale:{
		root:{
			filter:"ProductRecipeWhere"
		},
		locale:{
			filter:"LocaleWhere"
		}
	},
	ProductRecipe:{
		products:{
			filter:"ProductWhere",
			orderBy:"ProductOrderBy"
		},
		image:{
			filter:"ImageWhere"
		},
		icon:{
			filter:"ImageWhere"
		},
		ingredients:{
			filter:"ProductIngredientItemWhere",
			orderBy:"ProductIngredientItemOrderBy"
		},
		locales:{
			filter:"ProductRecipeLocaleWhere",
			orderBy:"ProductRecipeLocaleOrderBy"
		},
		freshingContainer:{
			filter:"FreshingContainerWhere"
		},
		nutritionFacts:{
			filter:"NutritionFactsWhere"
		},
		productsByCode:{
			by:"ProductRecipeProductsByCodeUniqueWhere",
			filter:"ProductWhere"
		},
		productsByStocks:{
			by:"ProductRecipeProductsByStocksUniqueWhere",
			filter:"ProductWhere"
		},
		productsByGroupPrices:{
			by:"ProductRecipeProductsByGroupPricesUniqueWhere",
			filter:"ProductWhere"
		},
		productsByCartItems:{
			by:"ProductRecipeProductsByCartItemsUniqueWhere",
			filter:"ProductWhere"
		},
		productsByOrderItems:{
			by:"ProductRecipeProductsByOrderItemsUniqueWhere",
			filter:"ProductWhere"
		},
		productsByInheritedCategories:{
			by:"ProductRecipeProductsByInheritedCategoriesUniqueWhere",
			filter:"ProductWhere"
		},
		productsByLocales:{
			by:"ProductRecipeProductsByLocalesUniqueWhere",
			filter:"ProductWhere"
		},
		productsByCustomerPrices:{
			by:"ProductRecipeProductsByCustomerPricesUniqueWhere",
			filter:"ProductWhere"
		},
		productsByVirtualProduct:{
			by:"ProductRecipeProductsByVirtualProductUniqueWhere",
			filter:"ProductWhere"
		},
		productsByMeta:{
			by:"ProductRecipeProductsByMetaUniqueWhere",
			filter:"ProductWhere"
		},
		productsByPage:{
			by:"ProductRecipeProductsByPageUniqueWhere",
			filter:"ProductWhere"
		},
		productsBySalesDays:{
			by:"ProductRecipeProductsBySalesDaysUniqueWhere",
			filter:"ProductWhere"
		},
		productsBySalesWeeks:{
			by:"ProductRecipeProductsBySalesWeeksUniqueWhere",
			filter:"ProductWhere"
		},
		productsBySalesMonths:{
			by:"ProductRecipeProductsBySalesMonthsUniqueWhere",
			filter:"ProductWhere"
		},
		ingredientsByQuantity:{
			by:"ProductRecipeIngredientsByQuantityUniqueWhere",
			filter:"ProductIngredientItemWhere"
		},
		localesByLocale:{
			by:"ProductRecipeLocalesByLocaleUniqueWhere",
			filter:"ProductRecipeLocaleWhere"
		},
		paginateProducts:{
			filter:"ProductWhere",
			orderBy:"ProductOrderBy"
		},
		paginateIngredients:{
			filter:"ProductIngredientItemWhere",
			orderBy:"ProductIngredientItemOrderBy"
		},
		paginateLocales:{
			filter:"ProductRecipeLocaleWhere",
			orderBy:"ProductRecipeLocaleOrderBy"
		}
	},
	ProductIngredientItem:{
		recipe:{
			filter:"ProductRecipeWhere"
		},
		ingredient:{
			filter:"ProductIngredientWhere"
		},
		quantity:{
			filter:"ProductIngredientItemQuantityWhere"
		}
	},
	ProductIngredientItemQuantity:{
		unit:{
			filter:"ProductIngredientItemQuantityUnitWhere"
		}
	},
	ProductIngredientItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		internalOrder:"OrderDirection",
		recipe:"ProductRecipeOrderBy",
		ingredient:"ProductIngredientOrderBy",
		quantity:"ProductIngredientItemQuantityOrderBy"
	},
	ProductIngredientItemQuantityOrderBy:{
		id:"OrderDirection",
		unit:"ProductIngredientItemQuantityUnitOrderBy",
		value:"OrderDirection"
	},
	ProductRecipeLocaleOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		root:"ProductRecipeOrderBy",
		locale:"LocaleOrderBy",
		description:"OrderDirection"
	},
	ProductRecipeProductsByCodeUniqueWhere:{

	},
	ProductRecipeProductsByStocksUniqueWhere:{
		stocks:"ProductStockUniqueWhere"
	},
	ProductRecipeProductsByGroupPricesUniqueWhere:{
		groupPrices:"ProductGroupPriceUniqueWhere"
	},
	ProductRecipeProductsByCartItemsUniqueWhere:{
		cartItems:"CartItemUniqueWhere"
	},
	ProductRecipeProductsByOrderItemsUniqueWhere:{
		orderItems:"OrderItemUniqueWhere"
	},
	ProductRecipeProductsByInheritedCategoriesUniqueWhere:{
		inheritedCategories:"NestedProductCategoryProductUniqueWhere"
	},
	ProductRecipeProductsByLocalesUniqueWhere:{
		locales:"ProductLocaleUniqueWhere"
	},
	ProductRecipeProductsByCustomerPricesUniqueWhere:{
		customerPrices:"ProductCustomerPriceUniqueWhere"
	},
	ProductRecipeProductsByVirtualProductUniqueWhere:{
		virtualProduct:"VirtualProductUniqueWhere"
	},
	ProductRecipeProductsByMetaUniqueWhere:{
		meta:"ProductMetadataUniqueWhere"
	},
	ProductRecipeProductsByPageUniqueWhere:{
		page:"PageUniqueWhere"
	},
	ProductRecipeProductsBySalesDaysUniqueWhere:{
		salesDays:"ProductSalesDayUniqueWhere"
	},
	ProductRecipeProductsBySalesWeeksUniqueWhere:{
		salesWeeks:"ProductSalesWeekUniqueWhere"
	},
	ProductRecipeProductsBySalesMonthsUniqueWhere:{
		salesMonths:"ProductSalesMonthUniqueWhere"
	},
	ProductRecipeIngredientsByQuantityUniqueWhere:{
		quantity:"ProductIngredientItemQuantityUniqueWhere"
	},
	ProductRecipeLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	DeliveryMethodLocale:{
		locale:{
			filter:"LocaleWhere"
		},
		root:{
			filter:"DeliveryMethodWhere"
		}
	},
	DeliveryMethodLocaleOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		description:"OrderDirection",
		trackingCodeUrlTemplate:"OrderDirection",
		processingTitle:"OrderDirection",
		processingText:"OrderDirection",
		processingIconUrl:"OrderDirection",
		dispatchedTitle:"OrderDirection",
		dispatchedText:"OrderDirection",
		dispatchedIconUrl:"OrderDirection",
		fulfilledTitle:"OrderDirection",
		fulfilledText:"OrderDirection",
		fulfilledIconUrl:"OrderDirection",
		locale:"LocaleOrderBy",
		root:"DeliveryMethodOrderBy"
	},
	PipelineStageLocale:{
		root:{
			filter:"PipelineStageWhere"
		},
		locale:{
			filter:"LocaleWhere"
		}
	},
	PipelineStage:{
		items:{
			filter:"PipelineStageItemWhere",
			orderBy:"PipelineStageItemOrderBy"
		},
		pipeline:{
			filter:"PipelineWhere"
		},
		locales:{
			filter:"PipelineStageLocaleWhere",
			orderBy:"PipelineStageLocaleOrderBy"
		},
		sentiment:{
			filter:"PipelineStageSentimentWhere"
		},
		forms:{
			filter:"LeadFormWhere",
			orderBy:"LeadFormOrderBy"
		},
		itemsByLead:{
			by:"PipelineStageItemsByLeadUniqueWhere",
			filter:"PipelineStageItemWhere"
		},
		localesByLocale:{
			by:"PipelineStageLocalesByLocaleUniqueWhere",
			filter:"PipelineStageLocaleWhere"
		},
		formsByCode:{
			by:"PipelineStageFormsByCodeUniqueWhere",
			filter:"LeadFormWhere"
		},
		formsByLeads:{
			by:"PipelineStageFormsByLeadsUniqueWhere",
			filter:"LeadFormWhere"
		},
		paginateItems:{
			filter:"PipelineStageItemWhere",
			orderBy:"PipelineStageItemOrderBy"
		},
		paginateLocales:{
			filter:"PipelineStageLocaleWhere",
			orderBy:"PipelineStageLocaleOrderBy"
		},
		paginateForms:{
			filter:"LeadFormWhere",
			orderBy:"LeadFormOrderBy"
		}
	},
	PipelineStageItem:{
		list:{
			filter:"PipelineStageWhere"
		},
		lead:{
			filter:"PipelineLeadWhere"
		}
	},
	PipelineLead:{
		stageItem:{
			filter:"PipelineStageItemWhere"
		},
		customer:{
			filter:"CustomerWhere"
		},
		form:{
			filter:"LeadFormWhere"
		}
	},
	LeadForm:{
		stage:{
			filter:"PipelineStageWhere"
		},
		leads:{
			filter:"PipelineLeadWhere",
			orderBy:"PipelineLeadOrderBy"
		},
		leadsByStageItem:{
			by:"LeadFormLeadsByStageItemUniqueWhere",
			filter:"PipelineLeadWhere"
		},
		paginateLeads:{
			filter:"PipelineLeadWhere",
			orderBy:"PipelineLeadOrderBy"
		}
	},
	PipelineLeadOrderBy:{
		id:"OrderDirection",
		createdAt:"OrderDirection",
		stageItem:"PipelineStageItemOrderBy",
		contactPerson:"OrderDirection",
		customer:"CustomerOrderBy",
		cafeType:"OrderDirection",
		offerType:"OrderDirection",
		ownMachine:"OrderDirection",
		customerCity:"OrderDirection",
		companyId:"OrderDirection",
		customerName:"OrderDirection",
		email:"OrderDirection",
		phone:"OrderDirection",
		form:"LeadFormOrderBy",
		meta:"OrderDirection",
		multiroasterType:"OrderDirection"
	},
	PipelineStageItemOrderBy:{
		id:"OrderDirection",
		list:"PipelineStageOrderBy",
		lead:"PipelineLeadOrderBy",
		order:"OrderDirection"
	},
	PipelineStageOrderBy:{
		id:"OrderDirection",
		pipeline:"PipelineOrderBy",
		order:"OrderDirection",
		sentiment:"PipelineStageSentimentOrderBy",
		type:"OrderDirection",
		showItemsWeight:"OrderDirection",
		showItemsPrice:"OrderDirection"
	},
	PipelineOrderBy:{
		id:"OrderDirection",
		unique:"OrderDirection"
	},
	PipelineStageSentimentOrderBy:{
		id:"OrderDirection",
		internalName:"OrderDirection",
		backgroundColor:"OrderDirection",
		textColor:"OrderDirection"
	},
	LeadFormOrderBy:{
		id:"OrderDirection",
		code:"OrderDirection",
		stage:"PipelineStageOrderBy"
	},
	LeadFormLeadsByStageItemUniqueWhere:{
		stageItem:"PipelineStageItemUniqueWhere"
	},
	Pipeline:{
		stages:{
			filter:"PipelineStageWhere",
			orderBy:"PipelineStageOrderBy"
		},
		stagesByItems:{
			by:"PipelineStagesByItemsUniqueWhere",
			filter:"PipelineStageWhere"
		},
		stagesByLocales:{
			by:"PipelineStagesByLocalesUniqueWhere",
			filter:"PipelineStageWhere"
		},
		stagesByForms:{
			by:"PipelineStagesByFormsUniqueWhere",
			filter:"PipelineStageWhere"
		},
		paginateStages:{
			filter:"PipelineStageWhere",
			orderBy:"PipelineStageOrderBy"
		}
	},
	PipelineStagesByItemsUniqueWhere:{
		items:"PipelineStageItemUniqueWhere"
	},
	PipelineStagesByLocalesUniqueWhere:{
		locales:"PipelineStageLocaleUniqueWhere"
	},
	PipelineStagesByFormsUniqueWhere:{
		forms:"LeadFormUniqueWhere"
	},
	PipelineStageLocaleOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		root:"PipelineStageOrderBy",
		locale:"LocaleOrderBy"
	},
	PipelineStageItemsByLeadUniqueWhere:{
		lead:"PipelineLeadUniqueWhere"
	},
	PipelineStageLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	PipelineStageFormsByCodeUniqueWhere:{

	},
	PipelineStageFormsByLeadsUniqueWhere:{
		leads:"PipelineLeadUniqueWhere"
	},
	SubscriptionBoxLocale:{
		root:{
			filter:"SubscriptionBoxWhere"
		},
		locale:{
			filter:"LocaleWhere"
		},
		texts:{
			filter:"TextListWhere"
		},
		secondaryTexts:{
			filter:"TextListWhere"
		}
	},
	SubscriptionBox:{
		locales:{
			filter:"SubscriptionBoxLocaleWhere",
			orderBy:"SubscriptionBoxLocaleOrderBy"
		},
		localesByLocale:{
			by:"SubscriptionBoxLocalesByLocaleUniqueWhere",
			filter:"SubscriptionBoxLocaleWhere"
		},
		localesByTexts:{
			by:"SubscriptionBoxLocalesByTextsUniqueWhere",
			filter:"SubscriptionBoxLocaleWhere"
		},
		localesBySecondaryTexts:{
			by:"SubscriptionBoxLocalesBySecondaryTextsUniqueWhere",
			filter:"SubscriptionBoxLocaleWhere"
		},
		paginateLocales:{
			filter:"SubscriptionBoxLocaleWhere",
			orderBy:"SubscriptionBoxLocaleOrderBy"
		}
	},
	SubscriptionBoxLocaleOrderBy:{
		id:"OrderDirection",
		title:"OrderDirection",
		stickerText:"OrderDirection",
		descriptionText:"OrderDirection",
		root:"SubscriptionBoxOrderBy",
		locale:"LocaleOrderBy",
		secondaryTitle:"OrderDirection",
		texts:"TextListOrderBy",
		secondaryTexts:"TextListOrderBy"
	},
	SubscriptionBoxOrderBy:{
		id:"OrderDirection",
		unique:"OrderDirection"
	},
	SubscriptionBoxLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	SubscriptionBoxLocalesByTextsUniqueWhere:{
		texts:"TextListUniqueWhere"
	},
	SubscriptionBoxLocalesBySecondaryTextsUniqueWhere:{
		secondaryTexts:"TextListUniqueWhere"
	},
	LocaleBusinessCategoriesByRootUniqueWhere:{
		root:"BusinessCategoryUniqueWhere"
	},
	LocaleProductCategoryListsByRootUniqueWhere:{
		root:"ProductCategoryListUniqueWhere"
	},
	LocaleProductIngredientsByRootUniqueWhere:{
		root:"ProductIngredientUniqueWhere"
	},
	LocaleOrderRecurrencesByRootUniqueWhere:{
		root:"OrderRecurrenceUniqueWhere"
	},
	LocaleBlogsByRootUniqueWhere:{
		root:"BlogUniqueWhere"
	},
	LocaleBlogPostsByRootUniqueWhere:{
		root:"BlogPostUniqueWhere"
	},
	LocaleBlogPostsByCoverUniqueWhere:{
		cover:"CoverUniqueWhere"
	},
	LocaleBlogPostsByContentUniqueWhere:{
		content:"ContentUniqueWhere"
	},
	LocaleBlogPostsByLinkUniqueWhere:{
		link:"LinkableUniqueWhere"
	},
	LocaleBlogPostsBySeoUniqueWhere:{
		seo:"SeoUniqueWhere"
	},
	LocaleMenusByRootUniqueWhere:{
		root:"SiteMenuUniqueWhere"
	},
	LocaleMenusByItemsUniqueWhere:{
		items:"MenuItemUniqueWhere"
	},
	LocaleMenusBySecondaryItemsUniqueWhere:{
		secondaryItems:"LinkListUniqueWhere"
	},
	LocalePagesByRootUniqueWhere:{
		root:"PageUniqueWhere"
	},
	LocalePagesByLinkUniqueWhere:{
		link:"LinkableUniqueWhere"
	},
	LocalePagesBySeoUniqueWhere:{
		seo:"SeoUniqueWhere"
	},
	LocalePagesByContentUniqueWhere:{
		content:"ContentUniqueWhere"
	},
	LocalePagesByCoverUniqueWhere:{
		cover:"CoverUniqueWhere"
	},
	LocaleProductIngredientCategoriesByRootUniqueWhere:{
		root:"ProductIngredientCategoryUniqueWhere"
	},
	LocaleAllergensByRootUniqueWhere:{
		root:"AllergenUniqueWhere"
	},
	LocaleProductPackingsByRootUniqueWhere:{
		root:"ProductPackingUniqueWhere"
	},
	LocaleProductsByRootUniqueWhere:{
		root:"ProductUniqueWhere"
	},
	LocaleProductsByFeatureListUniqueWhere:{
		featureList:"TextListUniqueWhere"
	},
	LocaleProductRecipesByRootUniqueWhere:{
		root:"ProductRecipeUniqueWhere"
	},
	LocalePointOfSaleCategoriesByRootUniqueWhere:{
		root:"PointOfSaleCategoryUniqueWhere"
	},
	LocalePointOfSaleCategoryProductsByRootUniqueWhere:{
		root:"PointOfSaleCategoryProductUniqueWhere"
	},
	LocaleDeliveryMethodsByRootUniqueWhere:{
		root:"DeliveryMethodUniqueWhere"
	},
	LocaleIngredientSuppliersByRootUniqueWhere:{
		root:"IngredientSupplierUniqueWhere"
	},
	LocaleIdentificationCodesByRootUniqueWhere:{
		root:"IdentificationCodeUniqueWhere"
	},
	LocalePipelineStagesByRootUniqueWhere:{
		root:"PipelineStageUniqueWhere"
	},
	LocaleSubscriptionBoxesByRootUniqueWhere:{
		root:"SubscriptionBoxUniqueWhere"
	},
	LocaleSubscriptionBoxesByTextsUniqueWhere:{
		texts:"TextListUniqueWhere"
	},
	LocaleSubscriptionBoxesBySecondaryTextsUniqueWhere:{
		secondaryTexts:"TextListUniqueWhere"
	},
	LocaleBusinessServicesByRootUniqueWhere:{
		root:"BusinessServiceUniqueWhere"
	},
	PreparedPackingQuantity:{
		recipe:{
			filter:"ProductRecipeWhere"
		},
		packing:{
			filter:"ProductPackingWhere"
		}
	},
	PreparedPackingQuantityOrderBy:{
		id:"OrderDirection",
		date:"OrderDirection",
		quantity:"OrderDirection",
		recipe:"ProductRecipeOrderBy",
		packing:"ProductPackingOrderBy",
		packedInCardboard:"OrderDirection"
	},
	ProductPackingLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	ProductStock:{
		product:{
			filter:"ProductWhere"
		},
		store:{
			filter:"StoreWhere"
		}
	},
	ProductStockOrderBy:{
		id:"OrderDirection",
		quantity:"OrderDirection",
		product:"ProductOrderBy",
		store:"StoreOrderBy"
	},
	StoreOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		code:"OrderDirection",
		description:"OrderDirection",
		internalNote:"OrderDirection"
	},
	ProductGroupPrice:{
		group:{
			filter:"CustomerGroupWhere"
		},
		product:{
			filter:"ProductWhere"
		}
	},
	CustomerGroup:{
		productPrices:{
			filter:"ProductGroupPriceWhere",
			orderBy:"ProductGroupPriceOrderBy"
		},
		customers:{
			filter:"CustomerWhere",
			orderBy:"CustomerOrderBy"
		},
		productPricesByProduct:{
			by:"CustomerGroupProductPricesByProductUniqueWhere",
			filter:"ProductGroupPriceWhere"
		},
		customersByDoubleshotLegacyId:{
			by:"CustomerGroupCustomersByDoubleshotLegacyIdUniqueWhere",
			filter:"CustomerWhere"
		},
		customersByAddresses:{
			by:"CustomerGroupCustomersByAddressesUniqueWhere",
			filter:"CustomerWhere"
		},
		customersByDefaultBillingAddress:{
			by:"CustomerGroupCustomersByDefaultBillingAddressUniqueWhere",
			filter:"CustomerWhere"
		},
		customersByDefaultPaymentMethod:{
			by:"CustomerGroupCustomersByDefaultPaymentMethodUniqueWhere",
			filter:"CustomerWhere"
		},
		customersByCredits:{
			by:"CustomerGroupCustomersByCreditsUniqueWhere",
			filter:"CustomerWhere"
		},
		customersByPaymentMethods:{
			by:"CustomerGroupCustomersByPaymentMethodsUniqueWhere",
			filter:"CustomerWhere"
		},
		customersByOrders:{
			by:"CustomerGroupCustomersByOrdersUniqueWhere",
			filter:"CustomerWhere"
		},
		customersByPermissions:{
			by:"CustomerGroupCustomersByPermissionsUniqueWhere",
			filter:"CustomerWhere"
		},
		customersByName:{
			by:"CustomerGroupCustomersByNameUniqueWhere",
			filter:"CustomerWhere"
		},
		customersByIngredientRatings:{
			by:"CustomerGroupCustomersByIngredientRatingsUniqueWhere",
			filter:"CustomerWhere"
		},
		customersByBusiness:{
			by:"CustomerGroupCustomersByBusinessUniqueWhere",
			filter:"CustomerWhere"
		},
		customersByCarts:{
			by:"CustomerGroupCustomersByCartsUniqueWhere",
			filter:"CustomerWhere"
		},
		customersByShortcutList:{
			by:"CustomerGroupCustomersByShortcutListUniqueWhere",
			filter:"CustomerWhere"
		},
		customersByUser:{
			by:"CustomerGroupCustomersByUserUniqueWhere",
			filter:"CustomerWhere"
		},
		customersByInvoices:{
			by:"CustomerGroupCustomersByInvoicesUniqueWhere",
			filter:"CustomerWhere"
		},
		customersByInvoicingPlan:{
			by:"CustomerGroupCustomersByInvoicingPlanUniqueWhere",
			filter:"CustomerWhere"
		},
		customersByBillingSubjects:{
			by:"CustomerGroupCustomersByBillingSubjectsUniqueWhere",
			filter:"CustomerWhere"
		},
		customersByOfferedProducts:{
			by:"CustomerGroupCustomersByOfferedProductsUniqueWhere",
			filter:"CustomerWhere"
		},
		customersByDefaultDeliveryAddress:{
			by:"CustomerGroupCustomersByDefaultDeliveryAddressUniqueWhere",
			filter:"CustomerWhere"
		},
		customersByDefaultBillingSubject:{
			by:"CustomerGroupCustomersByDefaultBillingSubjectUniqueWhere",
			filter:"CustomerWhere"
		},
		customersByAnonymousSession:{
			by:"CustomerGroupCustomersByAnonymousSessionUniqueWhere",
			filter:"CustomerWhere"
		},
		customersByBoughtVouchers:{
			by:"CustomerGroupCustomersByBoughtVouchersUniqueWhere",
			filter:"CustomerWhere"
		},
		customersByOwnsVouchers:{
			by:"CustomerGroupCustomersByOwnsVouchersUniqueWhere",
			filter:"CustomerWhere"
		},
		customersByRedeemedVouchers:{
			by:"CustomerGroupCustomersByRedeemedVouchersUniqueWhere",
			filter:"CustomerWhere"
		},
		customersBySpending:{
			by:"CustomerGroupCustomersBySpendingUniqueWhere",
			filter:"CustomerWhere"
		},
		customersByCustomerTabs:{
			by:"CustomerGroupCustomersByCustomerTabsUniqueWhere",
			filter:"CustomerWhere"
		},
		customersByLead:{
			by:"CustomerGroupCustomersByLeadUniqueWhere",
			filter:"CustomerWhere"
		},
		customersByMeta:{
			by:"CustomerGroupCustomersByMetaUniqueWhere",
			filter:"CustomerWhere"
		},
		paginateProductPrices:{
			filter:"ProductGroupPriceWhere",
			orderBy:"ProductGroupPriceOrderBy"
		},
		paginateCustomers:{
			filter:"CustomerWhere",
			orderBy:"CustomerOrderBy"
		}
	},
	ProductGroupPriceOrderBy:{
		id:"OrderDirection",
		priceCents:"OrderDirection",
		group:"CustomerGroupOrderBy",
		product:"ProductOrderBy"
	},
	CustomerGroupProductPricesByProductUniqueWhere:{
		product:"ProductUniqueWhere"
	},
	CustomerGroupCustomersByDoubleshotLegacyIdUniqueWhere:{

	},
	CustomerGroupCustomersByAddressesUniqueWhere:{
		addresses:"AddressUniqueWhere"
	},
	CustomerGroupCustomersByDefaultBillingAddressUniqueWhere:{
		defaultBillingAddress:"AddressUniqueWhere"
	},
	CustomerGroupCustomersByDefaultPaymentMethodUniqueWhere:{
		defaultPaymentMethod:"CustomerPaymentMethodUniqueWhere"
	},
	CustomerGroupCustomersByCreditsUniqueWhere:{
		credits:"CustomerCreditUniqueWhere"
	},
	CustomerGroupCustomersByPaymentMethodsUniqueWhere:{
		paymentMethods:"CustomerPaymentMethodUniqueWhere"
	},
	CustomerGroupCustomersByOrdersUniqueWhere:{
		orders:"OrderUniqueWhere"
	},
	CustomerGroupCustomersByPermissionsUniqueWhere:{
		permissions:"CustomerPermissionsUniqueWhere"
	},
	CustomerGroupCustomersByNameUniqueWhere:{
		name:"CustomerNameUniqueWhere"
	},
	CustomerGroupCustomersByIngredientRatingsUniqueWhere:{
		ingredientRatings:"CustomerIngredientRatingUniqueWhere"
	},
	CustomerGroupCustomersByBusinessUniqueWhere:{
		business:"BusinessCustomerUniqueWhere"
	},
	CustomerGroupCustomersByCartsUniqueWhere:{
		carts:"CartUniqueWhere"
	},
	CustomerGroupCustomersByShortcutListUniqueWhere:{
		shortcutList:"ApplicationShortcutListUniqueWhere"
	},
	CustomerGroupCustomersByUserUniqueWhere:{
		user:"UserUniqueWhere"
	},
	CustomerGroupCustomersByInvoicesUniqueWhere:{
		invoices:"InvoiceUniqueWhere"
	},
	CustomerGroupCustomersByInvoicingPlanUniqueWhere:{
		invoicingPlan:"InvoicingPlanUniqueWhere"
	},
	CustomerGroupCustomersByBillingSubjectsUniqueWhere:{
		billingSubjects:"BillingSubjectUniqueWhere"
	},
	CustomerGroupCustomersByOfferedProductsUniqueWhere:{
		offeredProducts:"ProductCustomerPriceUniqueWhere"
	},
	CustomerGroupCustomersByDefaultDeliveryAddressUniqueWhere:{
		defaultDeliveryAddress:"AddressUniqueWhere"
	},
	CustomerGroupCustomersByDefaultBillingSubjectUniqueWhere:{
		defaultBillingSubject:"BillingSubjectUniqueWhere"
	},
	CustomerGroupCustomersByAnonymousSessionUniqueWhere:{
		anonymousSession:"AnonymousSessionUniqueWhere"
	},
	CustomerGroupCustomersByBoughtVouchersUniqueWhere:{
		boughtVouchers:"VoucherUniqueWhere"
	},
	CustomerGroupCustomersByOwnsVouchersUniqueWhere:{
		ownsVouchers:"VoucherUniqueWhere"
	},
	CustomerGroupCustomersByRedeemedVouchersUniqueWhere:{
		redeemedVouchers:"VoucherRedemptionUniqueWhere"
	},
	CustomerGroupCustomersBySpendingUniqueWhere:{
		spending:"CustomerSpendingUniqueWhere"
	},
	CustomerGroupCustomersByCustomerTabsUniqueWhere:{
		customerTabs:"CustomerTabUniqueWhere"
	},
	CustomerGroupCustomersByLeadUniqueWhere:{
		lead:"PipelineLeadUniqueWhere"
	},
	CustomerGroupCustomersByMetaUniqueWhere:{
		meta:"CustomerMetadataUniqueWhere"
	},
	ProductCustomerPrice:{
		customer:{
			filter:"CustomerWhere"
		},
		product:{
			filter:"ProductWhere"
		}
	},
	ProductCustomerPriceOrderBy:{
		id:"OrderDirection",
		groupDiscountPermille:"OrderDirection",
		groupPriceCents:"OrderDirection",
		fullPriceCents:"OrderDirection",
		discountedPriceCents:"OrderDirection",
		priceCents:"OrderDirection",
		offered:"OrderDirection",
		notDiscountable:"OrderDirection",
		customer:"CustomerOrderBy",
		product:"ProductOrderBy"
	},
	ProductMetadata:{
		product:{
			filter:"ProductWhere"
		}
	},
	ProductSalesDay:{
		product:{
			filter:"ProductWhere"
		}
	},
	ProductSalesDayOrderBy:{
		id:"OrderDirection",
		productName:"OrderDirection",
		orderDate:"OrderDirection",
		priceCentsSum:"OrderDirection",
		sum:"OrderDirection",
		product:"ProductOrderBy"
	},
	ProductSalesWeek:{
		product:{
			filter:"ProductWhere"
		}
	},
	ProductSalesWeekOrderBy:{
		id:"OrderDirection",
		productName:"OrderDirection",
		orderDate:"OrderDirection",
		priceCentsSum:"OrderDirection",
		sum:"OrderDirection",
		product:"ProductOrderBy"
	},
	ProductSalesMonth:{
		product:{
			filter:"ProductWhere"
		}
	},
	ProductSalesMonthOrderBy:{
		id:"OrderDirection",
		productName:"OrderDirection",
		orderDate:"OrderDirection",
		priceCentsSum:"OrderDirection",
		sum:"OrderDirection",
		product:"ProductOrderBy"
	},
	ProductStocksByStoreUniqueWhere:{
		store:"StoreUniqueWhere"
	},
	ProductGroupPricesByGroupUniqueWhere:{
		group:"CustomerGroupUniqueWhere"
	},
	ProductCartItemsByCartUniqueWhere:{
		cart:"CartUniqueWhere"
	},
	ProductOrderItemsByVirtualProductEffectsUniqueWhere:{
		virtualProductEffects:"VirtualProductEffectUniqueWhere"
	},
	ProductLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	ProductLocalesByFeatureListUniqueWhere:{
		featureList:"TextListUniqueWhere"
	},
	ProductCustomerPricesByCustomerUniqueWhere:{
		customer:"CustomerUniqueWhere"
	},
	AddressMetadata:{
		address:{
			filter:"AddressWhere"
		},
		deliveryZone:{
			filter:"DeliveryZoneWhere"
		}
	},
	DeliveryZoneAddressesByMetaUniqueWhere:{
		meta:"AddressMetadataUniqueWhere"
	},
	DeliveryZoneAddressesByGpsUniqueWhere:{
		gps:"GpsUniqueWhere"
	},
	DeliveryZoneAddressesByInvoicesUniqueWhere:{
		invoices:"InvoiceUniqueWhere"
	},
	DeliveryZoneAddressesByBillingAddressOfOrdersUniqueWhere:{
		billingAddressOfOrders:"OrderUniqueWhere"
	},
	DeliveryZoneAddressesByDeliveryAddressOfOrderDeliveriesUniqueWhere:{
		deliveryAddressOfOrderDeliveries:"OrderDeliveryUniqueWhere"
	},
	DeliveryZoneAddressesByDefaultDeliveryAddressOfCustomerUniqueWhere:{
		defaultDeliveryAddressOfCustomer:"CustomerUniqueWhere"
	},
	DeliveryZoneAddressesMetadataByAddressUniqueWhere:{
		address:"AddressUniqueWhere"
	},
	DeliveryTimelinePreset:{
		deliveryMethod:{
			filter:"DeliveryMethodWhere"
		}
	},
	DeliveryMethodLocalesByLocaleUniqueWhere:{
		locale:"LocaleUniqueWhere"
	},
	CustomerPermissions:{
		customer:{
			filter:"CustomerWhere"
		}
	},
	CustomerName:{
		customer:{
			filter:"CustomerWhere"
		},
		aliases:{
			filter:"CustomerAliasWhere",
			orderBy:"CustomerAliasOrderBy"
		},
		paginateAliases:{
			filter:"CustomerAliasWhere",
			orderBy:"CustomerAliasOrderBy"
		}
	},
	CustomerAliasOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		order:"OrderDirection"
	},
	ApplicationShortcutList:{
		items:{
			filter:"ApplicationShortcutListItemWhere",
			orderBy:"ApplicationShortcutListItemOrderBy"
		},
		customer:{
			filter:"CustomerWhere"
		},
		paginateItems:{
			filter:"ApplicationShortcutListItemWhere",
			orderBy:"ApplicationShortcutListItemOrderBy"
		}
	},
	ApplicationShortcutListItem:{
		application:{
			filter:"ApplicationWhere"
		},
		list:{
			filter:"ApplicationShortcutListWhere"
		}
	},
	Application:{
		icon:{
			filter:"ImageWhere"
		}
	},
	ApplicationShortcutListItemOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		application:"ApplicationOrderBy",
		list:"ApplicationShortcutListOrderBy"
	},
	ApplicationOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		handle:"OrderDirection",
		url:"OrderDirection",
		color:"OrderDirection",
		icon:"ImageOrderBy",
		name:"OrderDirection",
		short:"OrderDirection"
	},
	InvoicingPlan:{
		customer:{
			filter:"CustomerWhere"
		},
		preset:{
			filter:"InvoicingPresetWhere"
		}
	},
	InvoicingPreset:{
		invoicingPlan:{
			filter:"InvoicingPlanWhere"
		}
	},
	CustomerSpending:{
		customer:{
			filter:"CustomerWhere"
		}
	},
	CustomerMetadata:{
		customer:{
			filter:"CustomerWhere"
		}
	},
	CustomerAddressesByMetaUniqueWhere:{
		meta:"AddressMetadataUniqueWhere"
	},
	CustomerAddressesByGpsUniqueWhere:{
		gps:"GpsUniqueWhere"
	},
	CustomerAddressesByInvoicesUniqueWhere:{
		invoices:"InvoiceUniqueWhere"
	},
	CustomerAddressesByBillingAddressOfOrdersUniqueWhere:{
		billingAddressOfOrders:"OrderUniqueWhere"
	},
	CustomerAddressesByDeliveryAddressOfOrderDeliveriesUniqueWhere:{
		deliveryAddressOfOrderDeliveries:"OrderDeliveryUniqueWhere"
	},
	CustomerAddressesByDefaultDeliveryAddressOfCustomerUniqueWhere:{
		defaultDeliveryAddressOfCustomer:"CustomerUniqueWhere"
	},
	CustomerCreditsByTransactionsUniqueWhere:{
		transactions:"CustomerCreditTransactionUniqueWhere"
	},
	CustomerCreditsByVoucherRedemptionUniqueWhere:{
		voucherRedemption:"VoucherRedemptionUniqueWhere"
	},
	CustomerOrdersBySeqUniqueWhere:{

	},
	CustomerOrdersByDoubleshotLegacyIdUniqueWhere:{

	},
	CustomerOrdersByDoubleShotLegacyNumberUniqueWhere:{

	},
	CustomerOrdersByDiscountsUniqueWhere:{
		discounts:"OrderDiscountUniqueWhere"
	},
	CustomerOrdersByDeliveryUniqueWhere:{
		delivery:"OrderDeliveryUniqueWhere"
	},
	CustomerOrdersByItemsUniqueWhere:{
		items:"OrderItemUniqueWhere"
	},
	CustomerOrdersByCartUniqueWhere:{
		cart:"CartUniqueWhere"
	},
	CustomerOrdersByEventsUniqueWhere:{
		events:"OrderEventUniqueWhere"
	},
	CustomerOrdersByPriceLinesUniqueWhere:{
		priceLines:"OrderPriceLineUniqueWhere"
	},
	CustomerOrdersByPaymentsUniqueWhere:{
		payments:"OrderPaymentUniqueWhere"
	},
	CustomerOrdersBySummaryUniqueWhere:{
		summary:"OrderSummaryUniqueWhere"
	},
	CustomerOrdersByGratuityUniqueWhere:{
		gratuity:"GratuityUniqueWhere"
	},
	CustomerIngredientRatingsByIngredientUniqueWhere:{
		ingredient:"ProductIngredientUniqueWhere"
	},
	CustomerCartsByItemsUniqueWhere:{
		items:"CartItemUniqueWhere"
	},
	CustomerCartsByOrderUniqueWhere:{
		order:"OrderUniqueWhere"
	},
	CustomerCartsByPriceLinesUniqueWhere:{
		priceLines:"CartPriceLineUniqueWhere"
	},
	CustomerCartsBySummaryUniqueWhere:{
		summary:"CartSummaryUniqueWhere"
	},
	CustomerInvoicesByPublicKeyUniqueWhere:{

	},
	CustomerInvoicesByFakturoidIdUniqueWhere:{

	},
	CustomerInvoicesByOrderPaymentsUniqueWhere:{
		orderPayments:"OrderPaymentUniqueWhere"
	},
	CustomerBillingSubjectsByInvoicesUniqueWhere:{
		invoices:"InvoiceUniqueWhere"
	},
	CustomerBillingSubjectsByDefaultBillingSubjectOfCustomerUniqueWhere:{
		defaultBillingSubjectOfCustomer:"CustomerUniqueWhere"
	},
	CustomerBillingSubjectsByOrdersUniqueWhere:{
		orders:"OrderUniqueWhere"
	},
	CustomerOfferedProductsByProductUniqueWhere:{
		product:"ProductUniqueWhere"
	},
	CustomerBoughtVouchersByCodeUniqueWhere:{

	},
	CustomerBoughtVouchersByRedemptionUniqueWhere:{
		redemption:"VoucherRedemptionUniqueWhere"
	},
	CustomerOwnsVouchersByCodeUniqueWhere:{

	},
	CustomerOwnsVouchersByRedemptionUniqueWhere:{
		redemption:"VoucherRedemptionUniqueWhere"
	},
	CustomerRedeemedVouchersByCustomerCreditUniqueWhere:{
		customerCredit:"CustomerCreditUniqueWhere"
	},
	CustomerRedeemedVouchersByOrderDiscountUniqueWhere:{
		orderDiscount:"OrderDiscountUniqueWhere"
	},
	CustomerRedeemedVouchersByVoucherUniqueWhere:{
		voucher:"VoucherUniqueWhere"
	},
	CustomerCustomerTabsByItemsUniqueWhere:{
		items:"CustomerTabItemUniqueWhere"
	},
	CustomerCustomerTabsByMetaUniqueWhere:{
		meta:"CustomerTabMetadataUniqueWhere"
	},
	CustomerLeadByStageItemUniqueWhere:{
		stageItem:"PipelineStageItemUniqueWhere"
	},
	Gps:{
		address:{
			filter:"AddressWhere"
		}
	},
	AddressInvoicesByPublicKeyUniqueWhere:{

	},
	AddressInvoicesByFakturoidIdUniqueWhere:{

	},
	AddressInvoicesByOrderPaymentsUniqueWhere:{
		orderPayments:"OrderPaymentUniqueWhere"
	},
	AddressBillingAddressOfOrdersBySeqUniqueWhere:{

	},
	AddressBillingAddressOfOrdersByDoubleshotLegacyIdUniqueWhere:{

	},
	AddressBillingAddressOfOrdersByDoubleShotLegacyNumberUniqueWhere:{

	},
	AddressBillingAddressOfOrdersByDiscountsUniqueWhere:{
		discounts:"OrderDiscountUniqueWhere"
	},
	AddressBillingAddressOfOrdersByDeliveryUniqueWhere:{
		delivery:"OrderDeliveryUniqueWhere"
	},
	AddressBillingAddressOfOrdersByItemsUniqueWhere:{
		items:"OrderItemUniqueWhere"
	},
	AddressBillingAddressOfOrdersByCartUniqueWhere:{
		cart:"CartUniqueWhere"
	},
	AddressBillingAddressOfOrdersByEventsUniqueWhere:{
		events:"OrderEventUniqueWhere"
	},
	AddressBillingAddressOfOrdersByPriceLinesUniqueWhere:{
		priceLines:"OrderPriceLineUniqueWhere"
	},
	AddressBillingAddressOfOrdersByPaymentsUniqueWhere:{
		payments:"OrderPaymentUniqueWhere"
	},
	AddressBillingAddressOfOrdersBySummaryUniqueWhere:{
		summary:"OrderSummaryUniqueWhere"
	},
	AddressBillingAddressOfOrdersByGratuityUniqueWhere:{
		gratuity:"GratuityUniqueWhere"
	},
	AddressDeliveryAddressOfOrderDeliveriesByTrackingCodeUniqueWhere:{

	},
	AddressDeliveryAddressOfOrderDeliveriesByOrderUniqueWhere:{
		order:"OrderUniqueWhere"
	},
	AddressDeliveryAddressOfOrderDeliveriesByDeliveryWaypointUniqueWhere:{
		deliveryWaypoint:"DeliveryWaypointUniqueWhere"
	},
	AddressDeliveryAddressOfOrderDeliveriesByEventsUniqueWhere:{
		events:"OrderEventUniqueWhere"
	},
	AddressDeliveryAddressOfOrderDeliveriesByLiftagoRideUniqueWhere:{
		liftagoRide:"LiftagoRideUniqueWhere"
	},
	AddressDeliveryAddressOfOrderDeliveriesByWoltDriveDeliveryUniqueWhere:{
		woltDriveDelivery:"WoltDriveDeliveryUniqueWhere"
	},
	AddressCreateInput:{
		id:"UUID",
		customer:"AddressCreateCustomerEntityRelationInput",
		country:"AddressCreateCountryEntityRelationInput",
		deletedAt:"DateTime",
		geocodeGeneratedAt:"DateTime",
		deliveryZone:"AddressCreateDeliveryZoneEntityRelationInput",
		meta:"AddressCreateMetaEntityRelationInput",
		gps:"AddressCreateGpsEntityRelationInput",
		invoices:"AddressCreateInvoicesEntityRelationInput",
		createdAt:"DateTime",
		billingAddressOfOrders:"AddressCreateBillingAddressOfOrdersEntityRelationInput",
		deliveryAddressOfOrderDeliveries:"AddressCreateDeliveryAddressOfOrderDeliveriesEntityRelationInput",
		defaultDeliveryAddressOfCustomer:"AddressCreateDefaultDeliveryAddressOfCustomerEntityRelationInput"
	},
	AddressCreateCustomerEntityRelationInput:{
		connect:"CustomerUniqueWhere",
		create:"CustomerWithoutAddressesCreateInput"
	},
	CustomerWithoutAddressesCreateInput:{
		id:"UUID",
		defaultBillingAddress:"CustomerCreateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerCreateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerCreateTagsEntityRelationInput",
		credits:"CustomerCreateCreditsEntityRelationInput",
		paymentMethods:"CustomerCreatePaymentMethodsEntityRelationInput",
		orders:"CustomerCreateOrdersEntityRelationInput",
		permissions:"CustomerCreatePermissionsEntityRelationInput",
		group:"CustomerCreateGroupEntityRelationInput",
		photo:"CustomerCreatePhotoEntityRelationInput",
		name:"CustomerCreateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerCreateIngredientRatingsEntityRelationInput",
		business:"CustomerCreateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerCreateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerCreateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerCreateCartsEntityRelationInput",
		shortcutList:"CustomerCreateShortcutListEntityRelationInput",
		user:"CustomerCreateUserEntityRelationInput",
		channels:"CustomerCreateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerCreateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerCreateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerCreateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerCreateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerCreateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerCreateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerCreateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerCreateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerCreateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerCreateRedeemedVouchersEntityRelationInput",
		spending:"CustomerCreateSpendingEntityRelationInput",
		customerTabs:"CustomerCreateCustomerTabsEntityRelationInput",
		lead:"CustomerCreateLeadEntityRelationInput",
		meta:"CustomerCreateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerCreateDefaultBillingAddressEntityRelationInput:{
		connect:"AddressUniqueWhere",
		create:"AddressCreateInput"
	},
	CustomerCreateDefaultPaymentMethodEntityRelationInput:{
		connect:"CustomerPaymentMethodUniqueWhere",
		create:"CustomerPaymentMethodCreateInput"
	},
	CustomerPaymentMethodCreateInput:{
		id:"UUID",
		data:"Json",
		customer:"CustomerPaymentMethodCreateCustomerEntityRelationInput",
		paymentMethod:"CustomerPaymentMethodCreatePaymentMethodEntityRelationInput"
	},
	CustomerPaymentMethodCreateCustomerEntityRelationInput:{
		connect:"CustomerUniqueWhere",
		create:"CustomerWithoutPaymentMethodsCreateInput"
	},
	CustomerWithoutPaymentMethodsCreateInput:{
		id:"UUID",
		addresses:"CustomerCreateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerCreateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerCreateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerCreateTagsEntityRelationInput",
		credits:"CustomerCreateCreditsEntityRelationInput",
		orders:"CustomerCreateOrdersEntityRelationInput",
		permissions:"CustomerCreatePermissionsEntityRelationInput",
		group:"CustomerCreateGroupEntityRelationInput",
		photo:"CustomerCreatePhotoEntityRelationInput",
		name:"CustomerCreateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerCreateIngredientRatingsEntityRelationInput",
		business:"CustomerCreateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerCreateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerCreateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerCreateCartsEntityRelationInput",
		shortcutList:"CustomerCreateShortcutListEntityRelationInput",
		user:"CustomerCreateUserEntityRelationInput",
		channels:"CustomerCreateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerCreateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerCreateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerCreateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerCreateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerCreateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerCreateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerCreateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerCreateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerCreateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerCreateRedeemedVouchersEntityRelationInput",
		spending:"CustomerCreateSpendingEntityRelationInput",
		customerTabs:"CustomerCreateCustomerTabsEntityRelationInput",
		lead:"CustomerCreateLeadEntityRelationInput",
		meta:"CustomerCreateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerCreateAddressesEntityRelationInput:{
		connect:"AddressUniqueWhere",
		create:"AddressWithoutCustomerCreateInput"
	},
	AddressWithoutCustomerCreateInput:{
		id:"UUID",
		country:"AddressCreateCountryEntityRelationInput",
		deletedAt:"DateTime",
		geocodeGeneratedAt:"DateTime",
		deliveryZone:"AddressCreateDeliveryZoneEntityRelationInput",
		meta:"AddressCreateMetaEntityRelationInput",
		gps:"AddressCreateGpsEntityRelationInput",
		invoices:"AddressCreateInvoicesEntityRelationInput",
		createdAt:"DateTime",
		billingAddressOfOrders:"AddressCreateBillingAddressOfOrdersEntityRelationInput",
		deliveryAddressOfOrderDeliveries:"AddressCreateDeliveryAddressOfOrderDeliveriesEntityRelationInput",
		defaultDeliveryAddressOfCustomer:"AddressCreateDefaultDeliveryAddressOfCustomerEntityRelationInput"
	},
	AddressCreateCountryEntityRelationInput:{
		connect:"CountryUniqueWhere",
		create:"CountryCreateInput"
	},
	CountryUniqueWhere:{
		id:"UUID"
	},
	CountryCreateInput:{
		id:"UUID"
	},
	AddressCreateDeliveryZoneEntityRelationInput:{
		connect:"DeliveryZoneUniqueWhere",
		create:"DeliveryZoneWithoutAddressesCreateInput"
	},
	DeliveryZoneUniqueWhere:{
		id:"UUID",
		addresses:"AddressUniqueWhere",
		addressesMetadata:"AddressMetadataUniqueWhere"
	},
	DeliveryZoneWithoutAddressesCreateInput:{
		id:"UUID",
		type:"DeliveryZoneType",
		suitableDeliveryMethods:"DeliveryZoneCreateSuitableDeliveryMethodsEntityRelationInput",
		deliveryZonesOfTags:"DeliveryZoneCreateDeliveryZonesOfTagsEntityRelationInput",
		deliveryZonesOfProducts:"DeliveryZoneCreateDeliveryZonesOfProductsEntityRelationInput",
		addressesMetadata:"DeliveryZoneCreateAddressesMetadataEntityRelationInput"
	},
	DeliveryZoneCreateSuitableDeliveryMethodsEntityRelationInput:{
		connect:"DeliveryMethodUniqueWhere",
		create:"DeliveryMethodWithoutSuitableForDeliveryZonesCreateInput"
	},
	DeliveryMethodWithoutSuitableForDeliveryZonesCreateInput:{
		id:"UUID",
		paymentMethods:"DeliveryMethodCreatePaymentMethodsEntityRelationInput",
		channels:"DeliveryMethodCreateChannelsEntityRelationInput",
		courierHandlers:"DeliveryMethodCreateCourierHandlersEntityRelationInput",
		locales:"DeliveryMethodCreateLocalesEntityRelationInput",
		timelinePreset:"DeliveryMethodCreateTimelinePresetEntityRelationInput"
	},
	DeliveryMethodCreatePaymentMethodsEntityRelationInput:{
		connect:"PaymentMethodUniqueWhere",
		create:"PaymentMethodWithoutDeliveryMethodsCreateInput"
	},
	PaymentMethodUniqueWhere:{
		id:"UUID",
		channels:"ChannelPaymentUniqueWhere"
	},
	PaymentMethodWithoutDeliveryMethodsCreateInput:{
		id:"UUID",
		type:"PaymentMethodType",
		channels:"PaymentMethodCreateChannelsEntityRelationInput"
	},
	PaymentMethodCreateChannelsEntityRelationInput:{
		connect:"ChannelPaymentUniqueWhere",
		create:"ChannelPaymentWithoutMethodCreateInput"
	},
	ChannelPaymentWithoutMethodCreateInput:{
		id:"UUID",
		channel:"ChannelPaymentCreateChannelEntityRelationInput",
		vatRate:"ChannelPaymentCreateVatRateEntityRelationInput",
		allowOnlyForTags:"ChannelPaymentCreateAllowOnlyForTagsEntityRelationInput"
	},
	ChannelPaymentCreateChannelEntityRelationInput:{
		connect:"ChannelUniqueWhere",
		create:"ChannelWithoutPaymentsCreateInput"
	},
	ChannelWithoutPaymentsCreateInput:{
		id:"UUID",
		deliveries:"ChannelCreateDeliveriesEntityRelationInput",
		pointOfSales:"ChannelCreatePointOfSalesEntityRelationInput",
		carts:"ChannelCreateCartsEntityRelationInput",
		customers:"ChannelCreateCustomersEntityRelationInput",
		code:"ChannelCode",
		addTagsOnRegistration:"ChannelCreateAddTagsOnRegistrationEntityRelationInput",
		publicTags:"ChannelCreatePublicTagsEntityRelationInput",
		venue:"ChannelCreateVenueEntityRelationInput"
	},
	ChannelCreateDeliveriesEntityRelationInput:{
		connect:"ChannelDeliveryUniqueWhere",
		create:"ChannelDeliveryWithoutChannelCreateInput"
	},
	ChannelDeliveryWithoutChannelCreateInput:{
		id:"UUID",
		method:"ChannelDeliveryCreateMethodEntityRelationInput",
		vatRate:"ChannelDeliveryCreateVatRateEntityRelationInput"
	},
	ChannelDeliveryCreateMethodEntityRelationInput:{
		connect:"DeliveryMethodUniqueWhere",
		create:"DeliveryMethodWithoutChannelsCreateInput"
	},
	DeliveryMethodWithoutChannelsCreateInput:{
		id:"UUID",
		paymentMethods:"DeliveryMethodCreatePaymentMethodsEntityRelationInput",
		suitableForDeliveryZones:"DeliveryMethodCreateSuitableForDeliveryZonesEntityRelationInput",
		courierHandlers:"DeliveryMethodCreateCourierHandlersEntityRelationInput",
		locales:"DeliveryMethodCreateLocalesEntityRelationInput",
		timelinePreset:"DeliveryMethodCreateTimelinePresetEntityRelationInput"
	},
	DeliveryMethodCreateSuitableForDeliveryZonesEntityRelationInput:{
		connect:"DeliveryZoneUniqueWhere",
		create:"DeliveryZoneWithoutSuitableDeliveryMethodsCreateInput"
	},
	DeliveryZoneWithoutSuitableDeliveryMethodsCreateInput:{
		id:"UUID",
		type:"DeliveryZoneType",
		addresses:"DeliveryZoneCreateAddressesEntityRelationInput",
		deliveryZonesOfTags:"DeliveryZoneCreateDeliveryZonesOfTagsEntityRelationInput",
		deliveryZonesOfProducts:"DeliveryZoneCreateDeliveryZonesOfProductsEntityRelationInput",
		addressesMetadata:"DeliveryZoneCreateAddressesMetadataEntityRelationInput"
	},
	DeliveryZoneCreateAddressesEntityRelationInput:{
		connect:"AddressUniqueWhere",
		create:"AddressWithoutDeliveryZoneCreateInput"
	},
	AddressWithoutDeliveryZoneCreateInput:{
		id:"UUID",
		customer:"AddressCreateCustomerEntityRelationInput",
		country:"AddressCreateCountryEntityRelationInput",
		deletedAt:"DateTime",
		geocodeGeneratedAt:"DateTime",
		meta:"AddressCreateMetaEntityRelationInput",
		gps:"AddressCreateGpsEntityRelationInput",
		invoices:"AddressCreateInvoicesEntityRelationInput",
		createdAt:"DateTime",
		billingAddressOfOrders:"AddressCreateBillingAddressOfOrdersEntityRelationInput",
		deliveryAddressOfOrderDeliveries:"AddressCreateDeliveryAddressOfOrderDeliveriesEntityRelationInput",
		defaultDeliveryAddressOfCustomer:"AddressCreateDefaultDeliveryAddressOfCustomerEntityRelationInput"
	},
	AddressCreateMetaEntityRelationInput:{
		connect:"AddressMetadataUniqueWhere"
	},
	AddressCreateGpsEntityRelationInput:{
		connect:"GpsUniqueWhere",
		create:"GpsWithoutAddressCreateInput"
	},
	GpsWithoutAddressCreateInput:{
		id:"UUID"
	},
	AddressCreateInvoicesEntityRelationInput:{
		connect:"InvoiceUniqueWhere",
		create:"InvoiceWithoutAddressCreateInput"
	},
	InvoiceWithoutAddressCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		customer:"InvoiceCreateCustomerEntityRelationInput",
		orderPayments:"InvoiceCreateOrderPaymentsEntityRelationInput",
		billingSubject:"InvoiceCreateBillingSubjectEntityRelationInput"
	},
	InvoiceCreateCustomerEntityRelationInput:{
		connect:"CustomerUniqueWhere",
		create:"CustomerWithoutInvoicesCreateInput"
	},
	CustomerWithoutInvoicesCreateInput:{
		id:"UUID",
		addresses:"CustomerCreateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerCreateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerCreateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerCreateTagsEntityRelationInput",
		credits:"CustomerCreateCreditsEntityRelationInput",
		paymentMethods:"CustomerCreatePaymentMethodsEntityRelationInput",
		orders:"CustomerCreateOrdersEntityRelationInput",
		permissions:"CustomerCreatePermissionsEntityRelationInput",
		group:"CustomerCreateGroupEntityRelationInput",
		photo:"CustomerCreatePhotoEntityRelationInput",
		name:"CustomerCreateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerCreateIngredientRatingsEntityRelationInput",
		business:"CustomerCreateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerCreateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerCreateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerCreateCartsEntityRelationInput",
		shortcutList:"CustomerCreateShortcutListEntityRelationInput",
		user:"CustomerCreateUserEntityRelationInput",
		channels:"CustomerCreateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoicingPlan:"CustomerCreateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerCreateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerCreateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerCreateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerCreateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerCreateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerCreateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerCreateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerCreateRedeemedVouchersEntityRelationInput",
		spending:"CustomerCreateSpendingEntityRelationInput",
		customerTabs:"CustomerCreateCustomerTabsEntityRelationInput",
		lead:"CustomerCreateLeadEntityRelationInput",
		meta:"CustomerCreateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerCreateTagsEntityRelationInput:{
		connect:"TagUniqueWhere",
		create:"TagWithoutCustomersCreateInput"
	},
	TagUniqueWhere:{
		id:"UUID",
		nestedCategories:"InheritedProductCategoryTagUniqueWhere"
	},
	TagWithoutCustomersCreateInput:{
		id:"UUID",
		products:"TagCreateProductsEntityRelationInput",
		categories:"TagCreateCategoriesEntityRelationInput",
		addTagsOnRegistration:"TagCreateAddTagsOnRegistrationEntityRelationInput",
		nestedCategories:"TagCreateNestedCategoriesEntityRelationInput",
		deliveryZones:"TagCreateDeliveryZonesEntityRelationInput",
		publicInChannels:"TagCreatePublicInChannelsEntityRelationInput",
		allowChannelPayments:"TagCreateAllowChannelPaymentsEntityRelationInput",
		fulfillmentNotes:"TagCreateFulfillmentNotesEntityRelationInput"
	},
	TagCreateProductsEntityRelationInput:{
		connect:"ProductUniqueWhere",
		create:"ProductWithoutTagsCreateInput"
	},
	ProductWithoutTagsCreateInput:{
		id:"UUID",
		packing:"ProductCreatePackingEntityRelationInput",
		recipe:"ProductCreateRecipeEntityRelationInput",
		categories:"ProductCreateCategoriesEntityRelationInput",
		vatRate:"ProductCreateVatRateEntityRelationInput",
		stocks:"ProductCreateStocksEntityRelationInput",
		groupPrices:"ProductCreateGroupPricesEntityRelationInput",
		image:"ProductCreateImageEntityRelationInput",
		cartItems:"ProductCreateCartItemsEntityRelationInput",
		availability:"ProductAvailability",
		manager:"ProductCreateManagerEntityRelationInput",
		orderItems:"ProductCreateOrderItemsEntityRelationInput",
		inheritedCategories:"ProductCreateInheritedCategoriesEntityRelationInput",
		deliveryZones:"ProductCreateDeliveryZonesEntityRelationInput",
		locales:"ProductCreateLocalesEntityRelationInput",
		archivedAt:"DateTime",
		customerPrices:"ProductCreateCustomerPricesEntityRelationInput",
		virtualProduct:"ProductCreateVirtualProductEntityRelationInput",
		meta:"ProductCreateMetaEntityRelationInput",
		page:"ProductCreatePageEntityRelationInput",
		salesDays:"ProductCreateSalesDaysEntityRelationInput",
		salesWeeks:"ProductCreateSalesWeeksEntityRelationInput",
		salesMonths:"ProductCreateSalesMonthsEntityRelationInput",
		fulfillmentNotes:"ProductCreateFulfillmentNotesEntityRelationInput"
	},
	ProductCreatePackingEntityRelationInput:{
		connect:"ProductPackingUniqueWhere",
		create:"ProductPackingCreateInput"
	},
	ProductPackingCreateInput:{
		id:"UUID",
		image:"ProductPackingCreateImageEntityRelationInput",
		icon:"ProductPackingCreateIconEntityRelationInput",
		locales:"ProductPackingCreateLocalesEntityRelationInput",
		preparedPackingQuantities:"ProductPackingCreatePreparedPackingQuantitiesEntityRelationInput"
	},
	ProductPackingCreateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	ImageCreateInput:{
		id:"UUID"
	},
	ProductPackingCreateIconEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	ProductPackingCreateLocalesEntityRelationInput:{
		connect:"ProductPackingLocaleUniqueWhere",
		create:"ProductPackingLocaleWithoutRootCreateInput"
	},
	ProductPackingLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"ProductPackingLocaleCreateLocaleEntityRelationInput"
	},
	ProductPackingLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutProductPackingsCreateInput"
	},
	LocaleWithoutProductPackingsCreateInput:{
		id:"UUID",
		businessCategories:"LocaleCreateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleCreateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleCreateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleCreateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleCreateBlogsEntityRelationInput",
		blogPosts:"LocaleCreateBlogPostsEntityRelationInput",
		identifier:"LocaleCreateIdentifierEntityRelationInput",
		menus:"LocaleCreateMenusEntityRelationInput",
		pages:"LocaleCreatePagesEntityRelationInput",
		productIngredientCategories:"LocaleCreateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleCreateAllergensEntityRelationInput",
		products:"LocaleCreateProductsEntityRelationInput",
		productRecipes:"LocaleCreateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleCreatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleCreatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleCreateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleCreateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleCreateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleCreatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleCreateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleCreateBusinessServicesEntityRelationInput"
	},
	LocaleCreateBusinessCategoriesEntityRelationInput:{
		connect:"BusinessCategoryLocaleUniqueWhere",
		create:"BusinessCategoryLocaleWithoutLocaleCreateInput"
	},
	BusinessCategoryLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"BusinessCategoryLocaleCreateRootEntityRelationInput"
	},
	BusinessCategoryLocaleCreateRootEntityRelationInput:{
		connect:"BusinessCategoryUniqueWhere",
		create:"BusinessCategoryWithoutLocalesCreateInput"
	},
	BusinessCategoryWithoutLocalesCreateInput:{
		id:"UUID",
		businessCustomers:"BusinessCategoryCreateBusinessCustomersEntityRelationInput",
		recurrences:"BusinessCategoryCreateRecurrencesEntityRelationInput",
		specificProducts:"BusinessCategoryCreateSpecificProductsEntityRelationInput",
		seasonalProductCategories:"BusinessCategoryCreateSeasonalProductCategoriesEntityRelationInput",
		specificProductsProductCategories:"BusinessCategoryCreateSpecificProductsProductCategoriesEntityRelationInput"
	},
	BusinessCategoryCreateBusinessCustomersEntityRelationInput:{
		connect:"BusinessCustomerUniqueWhere",
		create:"BusinessCustomerWithoutCategoryCreateInput"
	},
	BusinessCustomerWithoutCategoryCreateInput:{
		id:"UUID",
		customer:"BusinessCustomerCreateCustomerEntityRelationInput",
		owners:"BusinessCustomerCreateOwnersEntityRelationInput",
		members:"BusinessCustomerCreateMembersEntityRelationInput",
		accountManager:"BusinessCustomerCreateAccountManagerEntityRelationInput",
		logo:"BusinessCustomerCreateLogoEntityRelationInput",
		businessServiceEvents:"BusinessCustomerCreateBusinessServiceEventsEntityRelationInput",
		doubleshotCoffeeEquipment:"BusinessCustomerCreateDoubleshotCoffeeEquipmentEntityRelationInput"
	},
	BusinessCustomerCreateCustomerEntityRelationInput:{
		connect:"CustomerUniqueWhere",
		create:"CustomerWithoutBusinessCreateInput"
	},
	CustomerWithoutBusinessCreateInput:{
		id:"UUID",
		addresses:"CustomerCreateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerCreateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerCreateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerCreateTagsEntityRelationInput",
		credits:"CustomerCreateCreditsEntityRelationInput",
		paymentMethods:"CustomerCreatePaymentMethodsEntityRelationInput",
		orders:"CustomerCreateOrdersEntityRelationInput",
		permissions:"CustomerCreatePermissionsEntityRelationInput",
		group:"CustomerCreateGroupEntityRelationInput",
		photo:"CustomerCreatePhotoEntityRelationInput",
		name:"CustomerCreateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerCreateIngredientRatingsEntityRelationInput",
		ownerOfBusinesses:"CustomerCreateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerCreateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerCreateCartsEntityRelationInput",
		shortcutList:"CustomerCreateShortcutListEntityRelationInput",
		user:"CustomerCreateUserEntityRelationInput",
		channels:"CustomerCreateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerCreateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerCreateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerCreateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerCreateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerCreateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerCreateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerCreateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerCreateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerCreateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerCreateRedeemedVouchersEntityRelationInput",
		spending:"CustomerCreateSpendingEntityRelationInput",
		customerTabs:"CustomerCreateCustomerTabsEntityRelationInput",
		lead:"CustomerCreateLeadEntityRelationInput",
		meta:"CustomerCreateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerCreateCreditsEntityRelationInput:{
		connect:"CustomerCreditUniqueWhere",
		create:"CustomerCreditWithoutCustomerCreateInput"
	},
	CustomerCreditWithoutCustomerCreateInput:{
		id:"UUID",
		expiresAt:"DateTime",
		vatRate:"CustomerCreditCreateVatRateEntityRelationInput",
		createdAt:"DateTime",
		transactions:"CustomerCreditCreateTransactionsEntityRelationInput",
		voucherRedemption:"CustomerCreditCreateVoucherRedemptionEntityRelationInput"
	},
	CustomerCreditCreateVatRateEntityRelationInput:{
		connect:"VatRateUniqueWhere",
		create:"VatRateCreateInput"
	},
	VatRateUniqueWhere:{
		id:"UUID",
		preset:"VatRatePreset",
		channelDeliveries:"ChannelDeliveryUniqueWhere",
		channelPayments:"ChannelPaymentUniqueWhere"
	},
	VatRateCreateInput:{
		id:"UUID",
		channelDeliveries:"VatRateCreateChannelDeliveriesEntityRelationInput",
		channelPayments:"VatRateCreateChannelPaymentsEntityRelationInput",
		preset:"VatRatePreset"
	},
	VatRateCreateChannelDeliveriesEntityRelationInput:{
		connect:"ChannelDeliveryUniqueWhere",
		create:"ChannelDeliveryWithoutVatRateCreateInput"
	},
	ChannelDeliveryWithoutVatRateCreateInput:{
		id:"UUID",
		channel:"ChannelDeliveryCreateChannelEntityRelationInput",
		method:"ChannelDeliveryCreateMethodEntityRelationInput"
	},
	ChannelDeliveryCreateChannelEntityRelationInput:{
		connect:"ChannelUniqueWhere",
		create:"ChannelWithoutDeliveriesCreateInput"
	},
	ChannelWithoutDeliveriesCreateInput:{
		id:"UUID",
		payments:"ChannelCreatePaymentsEntityRelationInput",
		pointOfSales:"ChannelCreatePointOfSalesEntityRelationInput",
		carts:"ChannelCreateCartsEntityRelationInput",
		customers:"ChannelCreateCustomersEntityRelationInput",
		code:"ChannelCode",
		addTagsOnRegistration:"ChannelCreateAddTagsOnRegistrationEntityRelationInput",
		publicTags:"ChannelCreatePublicTagsEntityRelationInput",
		venue:"ChannelCreateVenueEntityRelationInput"
	},
	ChannelCreatePaymentsEntityRelationInput:{
		connect:"ChannelPaymentUniqueWhere",
		create:"ChannelPaymentWithoutChannelCreateInput"
	},
	ChannelPaymentWithoutChannelCreateInput:{
		id:"UUID",
		method:"ChannelPaymentCreateMethodEntityRelationInput",
		vatRate:"ChannelPaymentCreateVatRateEntityRelationInput",
		allowOnlyForTags:"ChannelPaymentCreateAllowOnlyForTagsEntityRelationInput"
	},
	ChannelPaymentCreateMethodEntityRelationInput:{
		connect:"PaymentMethodUniqueWhere",
		create:"PaymentMethodWithoutChannelsCreateInput"
	},
	PaymentMethodWithoutChannelsCreateInput:{
		id:"UUID",
		deliveryMethods:"PaymentMethodCreateDeliveryMethodsEntityRelationInput",
		type:"PaymentMethodType"
	},
	PaymentMethodCreateDeliveryMethodsEntityRelationInput:{
		connect:"DeliveryMethodUniqueWhere",
		create:"DeliveryMethodWithoutPaymentMethodsCreateInput"
	},
	DeliveryMethodWithoutPaymentMethodsCreateInput:{
		id:"UUID",
		suitableForDeliveryZones:"DeliveryMethodCreateSuitableForDeliveryZonesEntityRelationInput",
		channels:"DeliveryMethodCreateChannelsEntityRelationInput",
		courierHandlers:"DeliveryMethodCreateCourierHandlersEntityRelationInput",
		locales:"DeliveryMethodCreateLocalesEntityRelationInput",
		timelinePreset:"DeliveryMethodCreateTimelinePresetEntityRelationInput"
	},
	DeliveryMethodCreateChannelsEntityRelationInput:{
		connect:"ChannelDeliveryUniqueWhere",
		create:"ChannelDeliveryWithoutMethodCreateInput"
	},
	ChannelDeliveryWithoutMethodCreateInput:{
		id:"UUID",
		channel:"ChannelDeliveryCreateChannelEntityRelationInput",
		vatRate:"ChannelDeliveryCreateVatRateEntityRelationInput"
	},
	ChannelDeliveryCreateVatRateEntityRelationInput:{
		connect:"VatRateUniqueWhere",
		create:"VatRateWithoutChannelDeliveriesCreateInput"
	},
	VatRateWithoutChannelDeliveriesCreateInput:{
		id:"UUID",
		channelPayments:"VatRateCreateChannelPaymentsEntityRelationInput",
		preset:"VatRatePreset"
	},
	VatRateCreateChannelPaymentsEntityRelationInput:{
		connect:"ChannelPaymentUniqueWhere",
		create:"ChannelPaymentWithoutVatRateCreateInput"
	},
	ChannelPaymentWithoutVatRateCreateInput:{
		id:"UUID",
		channel:"ChannelPaymentCreateChannelEntityRelationInput",
		method:"ChannelPaymentCreateMethodEntityRelationInput",
		allowOnlyForTags:"ChannelPaymentCreateAllowOnlyForTagsEntityRelationInput"
	},
	ChannelPaymentCreateAllowOnlyForTagsEntityRelationInput:{
		connect:"TagUniqueWhere",
		create:"TagWithoutAllowChannelPaymentsCreateInput"
	},
	TagWithoutAllowChannelPaymentsCreateInput:{
		id:"UUID",
		customers:"TagCreateCustomersEntityRelationInput",
		products:"TagCreateProductsEntityRelationInput",
		categories:"TagCreateCategoriesEntityRelationInput",
		addTagsOnRegistration:"TagCreateAddTagsOnRegistrationEntityRelationInput",
		nestedCategories:"TagCreateNestedCategoriesEntityRelationInput",
		deliveryZones:"TagCreateDeliveryZonesEntityRelationInput",
		publicInChannels:"TagCreatePublicInChannelsEntityRelationInput",
		fulfillmentNotes:"TagCreateFulfillmentNotesEntityRelationInput"
	},
	TagCreateCustomersEntityRelationInput:{
		connect:"CustomerUniqueWhere",
		create:"CustomerWithoutTagsCreateInput"
	},
	CustomerWithoutTagsCreateInput:{
		id:"UUID",
		addresses:"CustomerCreateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerCreateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerCreateDefaultPaymentMethodEntityRelationInput",
		credits:"CustomerCreateCreditsEntityRelationInput",
		paymentMethods:"CustomerCreatePaymentMethodsEntityRelationInput",
		orders:"CustomerCreateOrdersEntityRelationInput",
		permissions:"CustomerCreatePermissionsEntityRelationInput",
		group:"CustomerCreateGroupEntityRelationInput",
		photo:"CustomerCreatePhotoEntityRelationInput",
		name:"CustomerCreateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerCreateIngredientRatingsEntityRelationInput",
		business:"CustomerCreateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerCreateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerCreateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerCreateCartsEntityRelationInput",
		shortcutList:"CustomerCreateShortcutListEntityRelationInput",
		user:"CustomerCreateUserEntityRelationInput",
		channels:"CustomerCreateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerCreateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerCreateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerCreateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerCreateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerCreateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerCreateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerCreateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerCreateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerCreateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerCreateRedeemedVouchersEntityRelationInput",
		spending:"CustomerCreateSpendingEntityRelationInput",
		customerTabs:"CustomerCreateCustomerTabsEntityRelationInput",
		lead:"CustomerCreateLeadEntityRelationInput",
		meta:"CustomerCreateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerCreatePaymentMethodsEntityRelationInput:{
		connect:"CustomerPaymentMethodUniqueWhere",
		create:"CustomerPaymentMethodWithoutCustomerCreateInput"
	},
	CustomerPaymentMethodWithoutCustomerCreateInput:{
		id:"UUID",
		data:"Json",
		paymentMethod:"CustomerPaymentMethodCreatePaymentMethodEntityRelationInput"
	},
	CustomerPaymentMethodCreatePaymentMethodEntityRelationInput:{
		connect:"PaymentMethodUniqueWhere",
		create:"PaymentMethodCreateInput"
	},
	PaymentMethodCreateInput:{
		id:"UUID",
		deliveryMethods:"PaymentMethodCreateDeliveryMethodsEntityRelationInput",
		type:"PaymentMethodType",
		channels:"PaymentMethodCreateChannelsEntityRelationInput"
	},
	CustomerCreateOrdersEntityRelationInput:{
		connect:"OrderUniqueWhere",
		create:"OrderWithoutCustomerCreateInput"
	},
	OrderWithoutCustomerCreateInput:{
		id:"UUID",
		state:"OrderState",
		fulfilledAt:"DateTime",
		canceledAt:"DateTime",
		channel:"OrderCreateChannelEntityRelationInput",
		discounts:"OrderCreateDiscountsEntityRelationInput",
		delivery:"OrderCreateDeliveryEntityRelationInput",
		items:"OrderCreateItemsEntityRelationInput",
		cart:"OrderCreateCartEntityRelationInput",
		events:"OrderCreateEventsEntityRelationInput",
		createdAt:"DateTime",
		billingAddress:"OrderCreateBillingAddressEntityRelationInput",
		priceLines:"OrderCreatePriceLinesEntityRelationInput",
		payments:"OrderCreatePaymentsEntityRelationInput",
		billingSubject:"OrderCreateBillingSubjectEntityRelationInput",
		summary:"OrderCreateSummaryEntityRelationInput",
		gratuity:"OrderCreateGratuityEntityRelationInput",
		venue:"OrderCreateVenueEntityRelationInput",
		fulfillmentNotes:"OrderCreateFulfillmentNotesEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	OrderCreateChannelEntityRelationInput:{
		connect:"ChannelUniqueWhere",
		create:"ChannelCreateInput"
	},
	ChannelCreateInput:{
		id:"UUID",
		payments:"ChannelCreatePaymentsEntityRelationInput",
		deliveries:"ChannelCreateDeliveriesEntityRelationInput",
		pointOfSales:"ChannelCreatePointOfSalesEntityRelationInput",
		carts:"ChannelCreateCartsEntityRelationInput",
		customers:"ChannelCreateCustomersEntityRelationInput",
		code:"ChannelCode",
		addTagsOnRegistration:"ChannelCreateAddTagsOnRegistrationEntityRelationInput",
		publicTags:"ChannelCreatePublicTagsEntityRelationInput",
		venue:"ChannelCreateVenueEntityRelationInput"
	},
	ChannelCreatePointOfSalesEntityRelationInput:{
		connect:"PointOfSaleUniqueWhere",
		create:"PointOfSaleWithoutChannelsCreateInput"
	},
	PointOfSaleUniqueWhere:{
		id:"UUID",
		tenantPersonId:"UUID",
		permissions:"PointOfSalePermissionsUniqueWhere"
	},
	PointOfSalePermissionsUniqueWhere:{
		id:"UUID",
		pointOfSale:"PointOfSaleUniqueWhere"
	},
	PointOfSaleWithoutChannelsCreateInput:{
		id:"UUID",
		permissions:"PointOfSaleCreatePermissionsEntityRelationInput",
		tenantPersonId:"UUID"
	},
	PointOfSaleCreatePermissionsEntityRelationInput:{
		connect:"PointOfSalePermissionsUniqueWhere"
	},
	ChannelCreateCartsEntityRelationInput:{
		connect:"CartUniqueWhere",
		create:"CartWithoutChannelCreateInput"
	},
	CartWithoutChannelCreateInput:{
		id:"UUID",
		confirmedAt:"DateTime",
		deletedAt:"DateTime",
		items:"CartCreateItemsEntityRelationInput",
		state:"CartState",
		createdAt:"DateTime",
		order:"CartCreateOrderEntityRelationInput",
		customer:"CartCreateCustomerEntityRelationInput",
		deliveryAddress:"CartCreateDeliveryAddressEntityRelationInput",
		billingAddress:"CartCreateBillingAddressEntityRelationInput",
		delivery:"CartCreateDeliveryEntityRelationInput",
		payment:"CartCreatePaymentEntityRelationInput",
		billingSubject:"CartCreateBillingSubjectEntityRelationInput",
		priceLines:"CartCreatePriceLinesEntityRelationInput",
		summary:"CartCreateSummaryEntityRelationInput"
	},
	CartCreateItemsEntityRelationInput:{
		connect:"CartItemUniqueWhere",
		create:"CartItemWithoutCartCreateInput"
	},
	CartItemWithoutCartCreateInput:{
		id:"UUID",
		product:"CartItemCreateProductEntityRelationInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		fulfillmentNotes:"CartItemCreateFulfillmentNotesEntityRelationInput"
	},
	CartItemCreateProductEntityRelationInput:{
		connect:"ProductUniqueWhere",
		create:"ProductWithoutCartItemsCreateInput"
	},
	ProductWithoutCartItemsCreateInput:{
		id:"UUID",
		packing:"ProductCreatePackingEntityRelationInput",
		recipe:"ProductCreateRecipeEntityRelationInput",
		tags:"ProductCreateTagsEntityRelationInput",
		categories:"ProductCreateCategoriesEntityRelationInput",
		vatRate:"ProductCreateVatRateEntityRelationInput",
		stocks:"ProductCreateStocksEntityRelationInput",
		groupPrices:"ProductCreateGroupPricesEntityRelationInput",
		image:"ProductCreateImageEntityRelationInput",
		availability:"ProductAvailability",
		manager:"ProductCreateManagerEntityRelationInput",
		orderItems:"ProductCreateOrderItemsEntityRelationInput",
		inheritedCategories:"ProductCreateInheritedCategoriesEntityRelationInput",
		deliveryZones:"ProductCreateDeliveryZonesEntityRelationInput",
		locales:"ProductCreateLocalesEntityRelationInput",
		archivedAt:"DateTime",
		customerPrices:"ProductCreateCustomerPricesEntityRelationInput",
		virtualProduct:"ProductCreateVirtualProductEntityRelationInput",
		meta:"ProductCreateMetaEntityRelationInput",
		page:"ProductCreatePageEntityRelationInput",
		salesDays:"ProductCreateSalesDaysEntityRelationInput",
		salesWeeks:"ProductCreateSalesWeeksEntityRelationInput",
		salesMonths:"ProductCreateSalesMonthsEntityRelationInput",
		fulfillmentNotes:"ProductCreateFulfillmentNotesEntityRelationInput"
	},
	ProductCreateRecipeEntityRelationInput:{
		connect:"ProductRecipeUniqueWhere",
		create:"ProductRecipeWithoutProductsCreateInput"
	},
	ProductRecipeWithoutProductsCreateInput:{
		id:"UUID",
		image:"ProductRecipeCreateImageEntityRelationInput",
		icon:"ProductRecipeCreateIconEntityRelationInput",
		ingredients:"ProductRecipeCreateIngredientsEntityRelationInput",
		locales:"ProductRecipeCreateLocalesEntityRelationInput",
		freshingContainer:"ProductRecipeCreateFreshingContainerEntityRelationInput",
		nutritionFacts:"ProductRecipeCreateNutritionFactsEntityRelationInput"
	},
	ProductRecipeCreateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	ProductRecipeCreateIconEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	ProductRecipeCreateIngredientsEntityRelationInput:{
		connect:"ProductIngredientItemUniqueWhere",
		create:"ProductIngredientItemWithoutRecipeCreateInput"
	},
	ProductIngredientItemWithoutRecipeCreateInput:{
		id:"UUID",
		ingredient:"ProductIngredientItemCreateIngredientEntityRelationInput",
		quantity:"ProductIngredientItemCreateQuantityEntityRelationInput"
	},
	ProductIngredientItemCreateIngredientEntityRelationInput:{
		connect:"ProductIngredientUniqueWhere",
		create:"ProductIngredientCreateInput"
	},
	ProductIngredientCreateInput:{
		id:"UUID",
		locales:"ProductIngredientCreateLocalesEntityRelationInput",
		categories:"ProductIngredientCreateCategoriesEntityRelationInput",
		allergens:"ProductIngredientCreateAllergensEntityRelationInput",
		customerRatings:"ProductIngredientCreateCustomerRatingsEntityRelationInput",
		preferredQuantityUnit:"ProductIngredientCreatePreferredQuantityUnitEntityRelationInput",
		freshingContainer:"ProductIngredientCreateFreshingContainerEntityRelationInput",
		image:"ProductIngredientCreateImageEntityRelationInput",
		suppliers:"ProductIngredientCreateSuppliersEntityRelationInput"
	},
	ProductIngredientCreateLocalesEntityRelationInput:{
		connect:"ProductIngredientLocaleUniqueWhere",
		create:"ProductIngredientLocaleWithoutRootCreateInput"
	},
	ProductIngredientLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"ProductIngredientLocaleCreateLocaleEntityRelationInput"
	},
	ProductIngredientLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutProductIngredientsCreateInput"
	},
	LocaleWithoutProductIngredientsCreateInput:{
		id:"UUID",
		businessCategories:"LocaleCreateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleCreateProductCategoryListsEntityRelationInput",
		orderRecurrences:"LocaleCreateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleCreateBlogsEntityRelationInput",
		blogPosts:"LocaleCreateBlogPostsEntityRelationInput",
		identifier:"LocaleCreateIdentifierEntityRelationInput",
		menus:"LocaleCreateMenusEntityRelationInput",
		pages:"LocaleCreatePagesEntityRelationInput",
		productIngredientCategories:"LocaleCreateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleCreateAllergensEntityRelationInput",
		productPackings:"LocaleCreateProductPackingsEntityRelationInput",
		products:"LocaleCreateProductsEntityRelationInput",
		productRecipes:"LocaleCreateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleCreatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleCreatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleCreateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleCreateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleCreateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleCreatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleCreateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleCreateBusinessServicesEntityRelationInput"
	},
	LocaleCreateProductCategoryListsEntityRelationInput:{
		connect:"ProductCategoryListLocaleUniqueWhere",
		create:"ProductCategoryListLocaleWithoutLocaleCreateInput"
	},
	ProductCategoryListLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"ProductCategoryListLocaleCreateRootEntityRelationInput"
	},
	ProductCategoryListLocaleCreateRootEntityRelationInput:{
		connect:"ProductCategoryListUniqueWhere",
		create:"ProductCategoryListWithoutLocalesCreateInput"
	},
	ProductCategoryListWithoutLocalesCreateInput:{
		id:"UUID",
		items:"ProductCategoryListCreateItemsEntityRelationInput",
		seasonalProductCategoriesOfBusinessCategory:"ProductCategoryListCreateSeasonalProductCategoriesOfBusinessCategoryEntityRelationInput",
		specificProductsProductCategoriesOfBusinessCategory:"ProductCategoryListCreateSpecificProductsProductCategoriesOfBusinessCategoryEntityRelationInput"
	},
	ProductCategoryListCreateItemsEntityRelationInput:{
		connect:"ProductCategoryListItemUniqueWhere",
		create:"ProductCategoryListItemWithoutListCreateInput"
	},
	ProductCategoryListItemWithoutListCreateInput:{
		id:"UUID",
		productCategory:"ProductCategoryListItemCreateProductCategoryEntityRelationInput"
	},
	ProductCategoryListItemCreateProductCategoryEntityRelationInput:{
		connect:"ProductCategoryUniqueWhere",
		create:"ProductCategoryCreateInput"
	},
	ProductCategoryCreateInput:{
		id:"UUID",
		products:"ProductCategoryCreateProductsEntityRelationInput",
		tags:"ProductCategoryCreateTagsEntityRelationInput",
		parent:"ProductCategoryCreateParentEntityRelationInput",
		children:"ProductCategoryCreateChildrenEntityRelationInput",
		image:"ProductCategoryCreateImageEntityRelationInput",
		descendants:"ProductCategoryCreateDescendantsEntityRelationInput",
		ancestors:"ProductCategoryCreateAncestorsEntityRelationInput",
		inheritedTags:"ProductCategoryCreateInheritedTagsEntityRelationInput",
		nestedProducts:"ProductCategoryCreateNestedProductsEntityRelationInput"
	},
	ProductCategoryCreateProductsEntityRelationInput:{
		connect:"ProductUniqueWhere",
		create:"ProductWithoutCategoriesCreateInput"
	},
	ProductWithoutCategoriesCreateInput:{
		id:"UUID",
		packing:"ProductCreatePackingEntityRelationInput",
		recipe:"ProductCreateRecipeEntityRelationInput",
		tags:"ProductCreateTagsEntityRelationInput",
		vatRate:"ProductCreateVatRateEntityRelationInput",
		stocks:"ProductCreateStocksEntityRelationInput",
		groupPrices:"ProductCreateGroupPricesEntityRelationInput",
		image:"ProductCreateImageEntityRelationInput",
		cartItems:"ProductCreateCartItemsEntityRelationInput",
		availability:"ProductAvailability",
		manager:"ProductCreateManagerEntityRelationInput",
		orderItems:"ProductCreateOrderItemsEntityRelationInput",
		inheritedCategories:"ProductCreateInheritedCategoriesEntityRelationInput",
		deliveryZones:"ProductCreateDeliveryZonesEntityRelationInput",
		locales:"ProductCreateLocalesEntityRelationInput",
		archivedAt:"DateTime",
		customerPrices:"ProductCreateCustomerPricesEntityRelationInput",
		virtualProduct:"ProductCreateVirtualProductEntityRelationInput",
		meta:"ProductCreateMetaEntityRelationInput",
		page:"ProductCreatePageEntityRelationInput",
		salesDays:"ProductCreateSalesDaysEntityRelationInput",
		salesWeeks:"ProductCreateSalesWeeksEntityRelationInput",
		salesMonths:"ProductCreateSalesMonthsEntityRelationInput",
		fulfillmentNotes:"ProductCreateFulfillmentNotesEntityRelationInput"
	},
	ProductCreateTagsEntityRelationInput:{
		connect:"TagUniqueWhere",
		create:"TagWithoutProductsCreateInput"
	},
	TagWithoutProductsCreateInput:{
		id:"UUID",
		customers:"TagCreateCustomersEntityRelationInput",
		categories:"TagCreateCategoriesEntityRelationInput",
		addTagsOnRegistration:"TagCreateAddTagsOnRegistrationEntityRelationInput",
		nestedCategories:"TagCreateNestedCategoriesEntityRelationInput",
		deliveryZones:"TagCreateDeliveryZonesEntityRelationInput",
		publicInChannels:"TagCreatePublicInChannelsEntityRelationInput",
		allowChannelPayments:"TagCreateAllowChannelPaymentsEntityRelationInput",
		fulfillmentNotes:"TagCreateFulfillmentNotesEntityRelationInput"
	},
	TagCreateCategoriesEntityRelationInput:{
		connect:"ProductCategoryUniqueWhere",
		create:"ProductCategoryWithoutTagsCreateInput"
	},
	ProductCategoryWithoutTagsCreateInput:{
		id:"UUID",
		products:"ProductCategoryCreateProductsEntityRelationInput",
		parent:"ProductCategoryCreateParentEntityRelationInput",
		children:"ProductCategoryCreateChildrenEntityRelationInput",
		image:"ProductCategoryCreateImageEntityRelationInput",
		descendants:"ProductCategoryCreateDescendantsEntityRelationInput",
		ancestors:"ProductCategoryCreateAncestorsEntityRelationInput",
		inheritedTags:"ProductCategoryCreateInheritedTagsEntityRelationInput",
		nestedProducts:"ProductCategoryCreateNestedProductsEntityRelationInput"
	},
	ProductCategoryCreateParentEntityRelationInput:{
		connect:"ProductCategoryUniqueWhere",
		create:"ProductCategoryWithoutChildrenCreateInput"
	},
	ProductCategoryWithoutChildrenCreateInput:{
		id:"UUID",
		products:"ProductCategoryCreateProductsEntityRelationInput",
		tags:"ProductCategoryCreateTagsEntityRelationInput",
		parent:"ProductCategoryCreateParentEntityRelationInput",
		image:"ProductCategoryCreateImageEntityRelationInput",
		descendants:"ProductCategoryCreateDescendantsEntityRelationInput",
		ancestors:"ProductCategoryCreateAncestorsEntityRelationInput",
		inheritedTags:"ProductCategoryCreateInheritedTagsEntityRelationInput",
		nestedProducts:"ProductCategoryCreateNestedProductsEntityRelationInput"
	},
	ProductCategoryCreateTagsEntityRelationInput:{
		connect:"TagUniqueWhere",
		create:"TagWithoutCategoriesCreateInput"
	},
	TagWithoutCategoriesCreateInput:{
		id:"UUID",
		customers:"TagCreateCustomersEntityRelationInput",
		products:"TagCreateProductsEntityRelationInput",
		addTagsOnRegistration:"TagCreateAddTagsOnRegistrationEntityRelationInput",
		nestedCategories:"TagCreateNestedCategoriesEntityRelationInput",
		deliveryZones:"TagCreateDeliveryZonesEntityRelationInput",
		publicInChannels:"TagCreatePublicInChannelsEntityRelationInput",
		allowChannelPayments:"TagCreateAllowChannelPaymentsEntityRelationInput",
		fulfillmentNotes:"TagCreateFulfillmentNotesEntityRelationInput"
	},
	TagCreateAddTagsOnRegistrationEntityRelationInput:{
		connect:"ChannelUniqueWhere",
		create:"ChannelWithoutAddTagsOnRegistrationCreateInput"
	},
	ChannelWithoutAddTagsOnRegistrationCreateInput:{
		id:"UUID",
		payments:"ChannelCreatePaymentsEntityRelationInput",
		deliveries:"ChannelCreateDeliveriesEntityRelationInput",
		pointOfSales:"ChannelCreatePointOfSalesEntityRelationInput",
		carts:"ChannelCreateCartsEntityRelationInput",
		customers:"ChannelCreateCustomersEntityRelationInput",
		code:"ChannelCode",
		publicTags:"ChannelCreatePublicTagsEntityRelationInput",
		venue:"ChannelCreateVenueEntityRelationInput"
	},
	ChannelCreateCustomersEntityRelationInput:{
		connect:"CustomerUniqueWhere",
		create:"CustomerWithoutChannelsCreateInput"
	},
	CustomerWithoutChannelsCreateInput:{
		id:"UUID",
		addresses:"CustomerCreateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerCreateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerCreateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerCreateTagsEntityRelationInput",
		credits:"CustomerCreateCreditsEntityRelationInput",
		paymentMethods:"CustomerCreatePaymentMethodsEntityRelationInput",
		orders:"CustomerCreateOrdersEntityRelationInput",
		permissions:"CustomerCreatePermissionsEntityRelationInput",
		group:"CustomerCreateGroupEntityRelationInput",
		photo:"CustomerCreatePhotoEntityRelationInput",
		name:"CustomerCreateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerCreateIngredientRatingsEntityRelationInput",
		business:"CustomerCreateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerCreateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerCreateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerCreateCartsEntityRelationInput",
		shortcutList:"CustomerCreateShortcutListEntityRelationInput",
		user:"CustomerCreateUserEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerCreateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerCreateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerCreateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerCreateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerCreateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerCreateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerCreateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerCreateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerCreateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerCreateRedeemedVouchersEntityRelationInput",
		spending:"CustomerCreateSpendingEntityRelationInput",
		customerTabs:"CustomerCreateCustomerTabsEntityRelationInput",
		lead:"CustomerCreateLeadEntityRelationInput",
		meta:"CustomerCreateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerCreatePermissionsEntityRelationInput:{
		connect:"CustomerPermissionsUniqueWhere"
	},
	CustomerCreateGroupEntityRelationInput:{
		connect:"CustomerGroupUniqueWhere",
		create:"CustomerGroupWithoutCustomersCreateInput"
	},
	CustomerGroupWithoutCustomersCreateInput:{
		id:"UUID",
		productPrices:"CustomerGroupCreateProductPricesEntityRelationInput"
	},
	CustomerGroupCreateProductPricesEntityRelationInput:{
		connect:"ProductGroupPriceUniqueWhere",
		create:"ProductGroupPriceWithoutGroupCreateInput"
	},
	ProductGroupPriceWithoutGroupCreateInput:{
		id:"UUID",
		product:"ProductGroupPriceCreateProductEntityRelationInput"
	},
	ProductGroupPriceCreateProductEntityRelationInput:{
		connect:"ProductUniqueWhere",
		create:"ProductWithoutGroupPricesCreateInput"
	},
	ProductWithoutGroupPricesCreateInput:{
		id:"UUID",
		packing:"ProductCreatePackingEntityRelationInput",
		recipe:"ProductCreateRecipeEntityRelationInput",
		tags:"ProductCreateTagsEntityRelationInput",
		categories:"ProductCreateCategoriesEntityRelationInput",
		vatRate:"ProductCreateVatRateEntityRelationInput",
		stocks:"ProductCreateStocksEntityRelationInput",
		image:"ProductCreateImageEntityRelationInput",
		cartItems:"ProductCreateCartItemsEntityRelationInput",
		availability:"ProductAvailability",
		manager:"ProductCreateManagerEntityRelationInput",
		orderItems:"ProductCreateOrderItemsEntityRelationInput",
		inheritedCategories:"ProductCreateInheritedCategoriesEntityRelationInput",
		deliveryZones:"ProductCreateDeliveryZonesEntityRelationInput",
		locales:"ProductCreateLocalesEntityRelationInput",
		archivedAt:"DateTime",
		customerPrices:"ProductCreateCustomerPricesEntityRelationInput",
		virtualProduct:"ProductCreateVirtualProductEntityRelationInput",
		meta:"ProductCreateMetaEntityRelationInput",
		page:"ProductCreatePageEntityRelationInput",
		salesDays:"ProductCreateSalesDaysEntityRelationInput",
		salesWeeks:"ProductCreateSalesWeeksEntityRelationInput",
		salesMonths:"ProductCreateSalesMonthsEntityRelationInput",
		fulfillmentNotes:"ProductCreateFulfillmentNotesEntityRelationInput"
	},
	ProductCreateCategoriesEntityRelationInput:{
		connect:"ProductCategoryUniqueWhere",
		create:"ProductCategoryWithoutProductsCreateInput"
	},
	ProductCategoryWithoutProductsCreateInput:{
		id:"UUID",
		tags:"ProductCategoryCreateTagsEntityRelationInput",
		parent:"ProductCategoryCreateParentEntityRelationInput",
		children:"ProductCategoryCreateChildrenEntityRelationInput",
		image:"ProductCategoryCreateImageEntityRelationInput",
		descendants:"ProductCategoryCreateDescendantsEntityRelationInput",
		ancestors:"ProductCategoryCreateAncestorsEntityRelationInput",
		inheritedTags:"ProductCategoryCreateInheritedTagsEntityRelationInput",
		nestedProducts:"ProductCategoryCreateNestedProductsEntityRelationInput"
	},
	ProductCategoryCreateChildrenEntityRelationInput:{
		connect:"ProductCategoryUniqueWhere",
		create:"ProductCategoryWithoutParentCreateInput"
	},
	ProductCategoryWithoutParentCreateInput:{
		id:"UUID",
		products:"ProductCategoryCreateProductsEntityRelationInput",
		tags:"ProductCategoryCreateTagsEntityRelationInput",
		children:"ProductCategoryCreateChildrenEntityRelationInput",
		image:"ProductCategoryCreateImageEntityRelationInput",
		descendants:"ProductCategoryCreateDescendantsEntityRelationInput",
		ancestors:"ProductCategoryCreateAncestorsEntityRelationInput",
		inheritedTags:"ProductCategoryCreateInheritedTagsEntityRelationInput",
		nestedProducts:"ProductCategoryCreateNestedProductsEntityRelationInput"
	},
	ProductCategoryCreateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	ProductCategoryCreateDescendantsEntityRelationInput:{
		connect:"ProductCategoryTreeUniqueWhere"
	},
	ProductCategoryCreateAncestorsEntityRelationInput:{
		connect:"ProductCategoryTreeUniqueWhere"
	},
	ProductCategoryCreateInheritedTagsEntityRelationInput:{
		connect:"InheritedProductCategoryTagUniqueWhere"
	},
	ProductCategoryCreateNestedProductsEntityRelationInput:{
		connect:"NestedProductCategoryProductUniqueWhere"
	},
	ProductCreateVatRateEntityRelationInput:{
		connect:"VatRateUniqueWhere",
		create:"VatRateCreateInput"
	},
	ProductCreateStocksEntityRelationInput:{
		connect:"ProductStockUniqueWhere",
		create:"ProductStockWithoutProductCreateInput"
	},
	ProductStockWithoutProductCreateInput:{
		id:"UUID",
		store:"ProductStockCreateStoreEntityRelationInput"
	},
	ProductStockCreateStoreEntityRelationInput:{
		connect:"StoreUniqueWhere",
		create:"StoreCreateInput"
	},
	StoreCreateInput:{
		id:"UUID"
	},
	ProductCreateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	ProductCreateCartItemsEntityRelationInput:{
		connect:"CartItemUniqueWhere",
		create:"CartItemWithoutProductCreateInput"
	},
	CartItemWithoutProductCreateInput:{
		id:"UUID",
		cart:"CartItemCreateCartEntityRelationInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		fulfillmentNotes:"CartItemCreateFulfillmentNotesEntityRelationInput"
	},
	CartItemCreateCartEntityRelationInput:{
		connect:"CartUniqueWhere",
		create:"CartWithoutItemsCreateInput"
	},
	CartWithoutItemsCreateInput:{
		id:"UUID",
		confirmedAt:"DateTime",
		deletedAt:"DateTime",
		state:"CartState",
		createdAt:"DateTime",
		channel:"CartCreateChannelEntityRelationInput",
		order:"CartCreateOrderEntityRelationInput",
		customer:"CartCreateCustomerEntityRelationInput",
		deliveryAddress:"CartCreateDeliveryAddressEntityRelationInput",
		billingAddress:"CartCreateBillingAddressEntityRelationInput",
		delivery:"CartCreateDeliveryEntityRelationInput",
		payment:"CartCreatePaymentEntityRelationInput",
		billingSubject:"CartCreateBillingSubjectEntityRelationInput",
		priceLines:"CartCreatePriceLinesEntityRelationInput",
		summary:"CartCreateSummaryEntityRelationInput"
	},
	CartCreateChannelEntityRelationInput:{
		connect:"ChannelUniqueWhere",
		create:"ChannelWithoutCartsCreateInput"
	},
	ChannelWithoutCartsCreateInput:{
		id:"UUID",
		payments:"ChannelCreatePaymentsEntityRelationInput",
		deliveries:"ChannelCreateDeliveriesEntityRelationInput",
		pointOfSales:"ChannelCreatePointOfSalesEntityRelationInput",
		customers:"ChannelCreateCustomersEntityRelationInput",
		code:"ChannelCode",
		addTagsOnRegistration:"ChannelCreateAddTagsOnRegistrationEntityRelationInput",
		publicTags:"ChannelCreatePublicTagsEntityRelationInput",
		venue:"ChannelCreateVenueEntityRelationInput"
	},
	ChannelCreateAddTagsOnRegistrationEntityRelationInput:{
		connect:"TagUniqueWhere",
		create:"TagWithoutAddTagsOnRegistrationCreateInput"
	},
	TagWithoutAddTagsOnRegistrationCreateInput:{
		id:"UUID",
		customers:"TagCreateCustomersEntityRelationInput",
		products:"TagCreateProductsEntityRelationInput",
		categories:"TagCreateCategoriesEntityRelationInput",
		nestedCategories:"TagCreateNestedCategoriesEntityRelationInput",
		deliveryZones:"TagCreateDeliveryZonesEntityRelationInput",
		publicInChannels:"TagCreatePublicInChannelsEntityRelationInput",
		allowChannelPayments:"TagCreateAllowChannelPaymentsEntityRelationInput",
		fulfillmentNotes:"TagCreateFulfillmentNotesEntityRelationInput"
	},
	TagCreateNestedCategoriesEntityRelationInput:{
		connect:"InheritedProductCategoryTagUniqueWhere"
	},
	TagCreateDeliveryZonesEntityRelationInput:{
		connect:"DeliveryZoneUniqueWhere",
		create:"DeliveryZoneWithoutDeliveryZonesOfTagsCreateInput"
	},
	DeliveryZoneWithoutDeliveryZonesOfTagsCreateInput:{
		id:"UUID",
		type:"DeliveryZoneType",
		addresses:"DeliveryZoneCreateAddressesEntityRelationInput",
		suitableDeliveryMethods:"DeliveryZoneCreateSuitableDeliveryMethodsEntityRelationInput",
		deliveryZonesOfProducts:"DeliveryZoneCreateDeliveryZonesOfProductsEntityRelationInput",
		addressesMetadata:"DeliveryZoneCreateAddressesMetadataEntityRelationInput"
	},
	DeliveryZoneCreateDeliveryZonesOfProductsEntityRelationInput:{
		connect:"ProductUniqueWhere",
		create:"ProductWithoutDeliveryZonesCreateInput"
	},
	ProductWithoutDeliveryZonesCreateInput:{
		id:"UUID",
		packing:"ProductCreatePackingEntityRelationInput",
		recipe:"ProductCreateRecipeEntityRelationInput",
		tags:"ProductCreateTagsEntityRelationInput",
		categories:"ProductCreateCategoriesEntityRelationInput",
		vatRate:"ProductCreateVatRateEntityRelationInput",
		stocks:"ProductCreateStocksEntityRelationInput",
		groupPrices:"ProductCreateGroupPricesEntityRelationInput",
		image:"ProductCreateImageEntityRelationInput",
		cartItems:"ProductCreateCartItemsEntityRelationInput",
		availability:"ProductAvailability",
		manager:"ProductCreateManagerEntityRelationInput",
		orderItems:"ProductCreateOrderItemsEntityRelationInput",
		inheritedCategories:"ProductCreateInheritedCategoriesEntityRelationInput",
		locales:"ProductCreateLocalesEntityRelationInput",
		archivedAt:"DateTime",
		customerPrices:"ProductCreateCustomerPricesEntityRelationInput",
		virtualProduct:"ProductCreateVirtualProductEntityRelationInput",
		meta:"ProductCreateMetaEntityRelationInput",
		page:"ProductCreatePageEntityRelationInput",
		salesDays:"ProductCreateSalesDaysEntityRelationInput",
		salesWeeks:"ProductCreateSalesWeeksEntityRelationInput",
		salesMonths:"ProductCreateSalesMonthsEntityRelationInput",
		fulfillmentNotes:"ProductCreateFulfillmentNotesEntityRelationInput"
	},
	ProductCreateGroupPricesEntityRelationInput:{
		connect:"ProductGroupPriceUniqueWhere",
		create:"ProductGroupPriceWithoutProductCreateInput"
	},
	ProductGroupPriceWithoutProductCreateInput:{
		id:"UUID",
		group:"ProductGroupPriceCreateGroupEntityRelationInput"
	},
	ProductGroupPriceCreateGroupEntityRelationInput:{
		connect:"CustomerGroupUniqueWhere",
		create:"CustomerGroupWithoutProductPricesCreateInput"
	},
	CustomerGroupWithoutProductPricesCreateInput:{
		id:"UUID",
		customers:"CustomerGroupCreateCustomersEntityRelationInput"
	},
	CustomerGroupCreateCustomersEntityRelationInput:{
		connect:"CustomerUniqueWhere",
		create:"CustomerWithoutGroupCreateInput"
	},
	CustomerWithoutGroupCreateInput:{
		id:"UUID",
		addresses:"CustomerCreateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerCreateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerCreateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerCreateTagsEntityRelationInput",
		credits:"CustomerCreateCreditsEntityRelationInput",
		paymentMethods:"CustomerCreatePaymentMethodsEntityRelationInput",
		orders:"CustomerCreateOrdersEntityRelationInput",
		permissions:"CustomerCreatePermissionsEntityRelationInput",
		photo:"CustomerCreatePhotoEntityRelationInput",
		name:"CustomerCreateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerCreateIngredientRatingsEntityRelationInput",
		business:"CustomerCreateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerCreateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerCreateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerCreateCartsEntityRelationInput",
		shortcutList:"CustomerCreateShortcutListEntityRelationInput",
		user:"CustomerCreateUserEntityRelationInput",
		channels:"CustomerCreateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerCreateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerCreateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerCreateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerCreateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerCreateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerCreateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerCreateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerCreateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerCreateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerCreateRedeemedVouchersEntityRelationInput",
		spending:"CustomerCreateSpendingEntityRelationInput",
		customerTabs:"CustomerCreateCustomerTabsEntityRelationInput",
		lead:"CustomerCreateLeadEntityRelationInput",
		meta:"CustomerCreateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerCreatePhotoEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	CustomerCreateNameEntityRelationInput:{
		connect:"CustomerNameUniqueWhere",
		create:"CustomerNameWithoutCustomerCreateInput"
	},
	CustomerNameWithoutCustomerCreateInput:{
		id:"UUID",
		aliases:"CustomerNameCreateAliasesEntityRelationInput"
	},
	CustomerNameCreateAliasesEntityRelationInput:{
		connect:"CustomerAliasUniqueWhere",
		create:"CustomerAliasCreateInput"
	},
	CustomerAliasUniqueWhere:{
		id:"UUID"
	},
	CustomerAliasCreateInput:{
		id:"UUID"
	},
	CustomerCreateIngredientRatingsEntityRelationInput:{
		connect:"CustomerIngredientRatingUniqueWhere",
		create:"CustomerIngredientRatingWithoutCustomerCreateInput"
	},
	CustomerIngredientRatingWithoutCustomerCreateInput:{
		id:"UUID",
		rating:"CustomerIngredientRatingCreateRatingEntityRelationInput",
		ingredient:"CustomerIngredientRatingCreateIngredientEntityRelationInput"
	},
	CustomerIngredientRatingCreateRatingEntityRelationInput:{
		connect:"ProductIngredientRatingUniqueWhere",
		create:"ProductIngredientRatingCreateInput"
	},
	ProductIngredientRatingUniqueWhere:{
		id:"UUID"
	},
	ProductIngredientRatingCreateInput:{
		id:"UUID",
		icon:"ProductIngredientRatingCreateIconEntityRelationInput"
	},
	ProductIngredientRatingCreateIconEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	CustomerIngredientRatingCreateIngredientEntityRelationInput:{
		connect:"ProductIngredientUniqueWhere",
		create:"ProductIngredientWithoutCustomerRatingsCreateInput"
	},
	ProductIngredientWithoutCustomerRatingsCreateInput:{
		id:"UUID",
		locales:"ProductIngredientCreateLocalesEntityRelationInput",
		categories:"ProductIngredientCreateCategoriesEntityRelationInput",
		allergens:"ProductIngredientCreateAllergensEntityRelationInput",
		preferredQuantityUnit:"ProductIngredientCreatePreferredQuantityUnitEntityRelationInput",
		freshingContainer:"ProductIngredientCreateFreshingContainerEntityRelationInput",
		image:"ProductIngredientCreateImageEntityRelationInput",
		suppliers:"ProductIngredientCreateSuppliersEntityRelationInput"
	},
	ProductIngredientCreateCategoriesEntityRelationInput:{
		connect:"ProductIngredientCategoryUniqueWhere",
		create:"ProductIngredientCategoryWithoutIngredientsCreateInput"
	},
	ProductIngredientCategoryWithoutIngredientsCreateInput:{
		id:"UUID",
		locales:"ProductIngredientCategoryCreateLocalesEntityRelationInput"
	},
	ProductIngredientCategoryCreateLocalesEntityRelationInput:{
		connect:"ProductIngredientCategoryLocaleUniqueWhere",
		create:"ProductIngredientCategoryLocaleWithoutRootCreateInput"
	},
	ProductIngredientCategoryLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"ProductIngredientCategoryLocaleCreateLocaleEntityRelationInput"
	},
	ProductIngredientCategoryLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutProductIngredientCategoriesCreateInput"
	},
	LocaleWithoutProductIngredientCategoriesCreateInput:{
		id:"UUID",
		businessCategories:"LocaleCreateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleCreateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleCreateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleCreateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleCreateBlogsEntityRelationInput",
		blogPosts:"LocaleCreateBlogPostsEntityRelationInput",
		identifier:"LocaleCreateIdentifierEntityRelationInput",
		menus:"LocaleCreateMenusEntityRelationInput",
		pages:"LocaleCreatePagesEntityRelationInput",
		allergens:"LocaleCreateAllergensEntityRelationInput",
		productPackings:"LocaleCreateProductPackingsEntityRelationInput",
		products:"LocaleCreateProductsEntityRelationInput",
		productRecipes:"LocaleCreateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleCreatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleCreatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleCreateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleCreateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleCreateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleCreatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleCreateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleCreateBusinessServicesEntityRelationInput"
	},
	LocaleCreateProductIngredientsEntityRelationInput:{
		connect:"ProductIngredientLocaleUniqueWhere",
		create:"ProductIngredientLocaleWithoutLocaleCreateInput"
	},
	ProductIngredientLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"ProductIngredientLocaleCreateRootEntityRelationInput"
	},
	ProductIngredientLocaleCreateRootEntityRelationInput:{
		connect:"ProductIngredientUniqueWhere",
		create:"ProductIngredientWithoutLocalesCreateInput"
	},
	ProductIngredientWithoutLocalesCreateInput:{
		id:"UUID",
		categories:"ProductIngredientCreateCategoriesEntityRelationInput",
		allergens:"ProductIngredientCreateAllergensEntityRelationInput",
		customerRatings:"ProductIngredientCreateCustomerRatingsEntityRelationInput",
		preferredQuantityUnit:"ProductIngredientCreatePreferredQuantityUnitEntityRelationInput",
		freshingContainer:"ProductIngredientCreateFreshingContainerEntityRelationInput",
		image:"ProductIngredientCreateImageEntityRelationInput",
		suppliers:"ProductIngredientCreateSuppliersEntityRelationInput"
	},
	ProductIngredientCreateAllergensEntityRelationInput:{
		connect:"AllergenUniqueWhere",
		create:"AllergenWithoutIngredientsCreateInput"
	},
	AllergenWithoutIngredientsCreateInput:{
		id:"UUID",
		locales:"AllergenCreateLocalesEntityRelationInput"
	},
	AllergenCreateLocalesEntityRelationInput:{
		connect:"AllergenLocaleUniqueWhere",
		create:"AllergenLocaleWithoutRootCreateInput"
	},
	AllergenLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"AllergenLocaleCreateLocaleEntityRelationInput"
	},
	AllergenLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutAllergensCreateInput"
	},
	LocaleWithoutAllergensCreateInput:{
		id:"UUID",
		businessCategories:"LocaleCreateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleCreateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleCreateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleCreateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleCreateBlogsEntityRelationInput",
		blogPosts:"LocaleCreateBlogPostsEntityRelationInput",
		identifier:"LocaleCreateIdentifierEntityRelationInput",
		menus:"LocaleCreateMenusEntityRelationInput",
		pages:"LocaleCreatePagesEntityRelationInput",
		productIngredientCategories:"LocaleCreateProductIngredientCategoriesEntityRelationInput",
		productPackings:"LocaleCreateProductPackingsEntityRelationInput",
		products:"LocaleCreateProductsEntityRelationInput",
		productRecipes:"LocaleCreateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleCreatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleCreatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleCreateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleCreateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleCreateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleCreatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleCreateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleCreateBusinessServicesEntityRelationInput"
	},
	LocaleCreateOrderRecurrencesEntityRelationInput:{
		connect:"OrderRecurrenceLocaleUniqueWhere",
		create:"OrderRecurrenceLocaleWithoutLocaleCreateInput"
	},
	OrderRecurrenceLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"OrderRecurrenceLocaleCreateRootEntityRelationInput"
	},
	OrderRecurrenceLocaleCreateRootEntityRelationInput:{
		connect:"OrderRecurrenceUniqueWhere",
		create:"OrderRecurrenceWithoutLocalesCreateInput"
	},
	OrderRecurrenceWithoutLocalesCreateInput:{
		id:"UUID",
		businessCategory:"OrderRecurrenceCreateBusinessCategoryEntityRelationInput"
	},
	OrderRecurrenceCreateBusinessCategoryEntityRelationInput:{
		connect:"BusinessCategoryUniqueWhere",
		create:"BusinessCategoryWithoutRecurrencesCreateInput"
	},
	BusinessCategoryWithoutRecurrencesCreateInput:{
		id:"UUID",
		locales:"BusinessCategoryCreateLocalesEntityRelationInput",
		businessCustomers:"BusinessCategoryCreateBusinessCustomersEntityRelationInput",
		specificProducts:"BusinessCategoryCreateSpecificProductsEntityRelationInput",
		seasonalProductCategories:"BusinessCategoryCreateSeasonalProductCategoriesEntityRelationInput",
		specificProductsProductCategories:"BusinessCategoryCreateSpecificProductsProductCategoriesEntityRelationInput"
	},
	BusinessCategoryCreateLocalesEntityRelationInput:{
		connect:"BusinessCategoryLocaleUniqueWhere",
		create:"BusinessCategoryLocaleWithoutRootCreateInput"
	},
	BusinessCategoryLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"BusinessCategoryLocaleCreateLocaleEntityRelationInput"
	},
	BusinessCategoryLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutBusinessCategoriesCreateInput"
	},
	LocaleWithoutBusinessCategoriesCreateInput:{
		id:"UUID",
		productCategoryLists:"LocaleCreateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleCreateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleCreateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleCreateBlogsEntityRelationInput",
		blogPosts:"LocaleCreateBlogPostsEntityRelationInput",
		identifier:"LocaleCreateIdentifierEntityRelationInput",
		menus:"LocaleCreateMenusEntityRelationInput",
		pages:"LocaleCreatePagesEntityRelationInput",
		productIngredientCategories:"LocaleCreateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleCreateAllergensEntityRelationInput",
		productPackings:"LocaleCreateProductPackingsEntityRelationInput",
		products:"LocaleCreateProductsEntityRelationInput",
		productRecipes:"LocaleCreateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleCreatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleCreatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleCreateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleCreateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleCreateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleCreatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleCreateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleCreateBusinessServicesEntityRelationInput"
	},
	LocaleCreateBlogsEntityRelationInput:{
		connect:"BlogLocaleUniqueWhere",
		create:"BlogLocaleWithoutLocaleCreateInput"
	},
	BlogLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"BlogLocaleCreateRootEntityRelationInput"
	},
	BlogLocaleCreateRootEntityRelationInput:{
		connect:"BlogUniqueWhere",
		create:"BlogWithoutLocalesCreateInput"
	},
	BlogWithoutLocalesCreateInput:{
		id:"UUID",
		unique:"One"
	},
	LocaleCreateBlogPostsEntityRelationInput:{
		connect:"BlogPostLocaleUniqueWhere",
		create:"BlogPostLocaleWithoutLocaleCreateInput"
	},
	BlogPostLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"BlogPostLocaleCreateRootEntityRelationInput",
		cover:"BlogPostLocaleCreateCoverEntityRelationInput",
		content:"BlogPostLocaleCreateContentEntityRelationInput",
		link:"BlogPostLocaleCreateLinkEntityRelationInput",
		seo:"BlogPostLocaleCreateSeoEntityRelationInput",
		products:"BlogPostLocaleCreateProductsEntityRelationInput"
	},
	BlogPostLocaleCreateRootEntityRelationInput:{
		connect:"BlogPostUniqueWhere",
		create:"BlogPostWithoutLocalesCreateInput"
	},
	BlogPostWithoutLocalesCreateInput:{
		id:"UUID"
	},
	BlogPostLocaleCreateCoverEntityRelationInput:{
		connect:"CoverUniqueWhere",
		create:"CoverCreateInput"
	},
	CoverCreateInput:{
		id:"UUID",
		medium:"CoverCreateMediumEntityRelationInput",
		buttonColors:"CoverCreateButtonColorsEntityRelationInput"
	},
	CoverCreateMediumEntityRelationInput:{
		connect:"MediumUniqueWhere",
		create:"MediumCreateInput"
	},
	MediumUniqueWhere:{
		id:"UUID"
	},
	MediumCreateInput:{
		id:"UUID",
		type:"MediumType",
		colorTheme:"ColorTheme",
		image:"MediumCreateImageEntityRelationInput",
		video:"MediumCreateVideoEntityRelationInput"
	},
	MediumCreateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	MediumCreateVideoEntityRelationInput:{
		connect:"VideoUniqueWhere",
		create:"VideoCreateInput"
	},
	VideoUniqueWhere:{
		id:"UUID"
	},
	VideoCreateInput:{
		id:"UUID",
		poster:"VideoCreatePosterEntityRelationInput"
	},
	VideoCreatePosterEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	CoverCreateButtonColorsEntityRelationInput:{
		connect:"ColorPalleteUniqueWhere",
		create:"ColorPalleteCreateInput"
	},
	ColorPalleteUniqueWhere:{
		id:"UUID"
	},
	ColorPalleteCreateInput:{
		id:"UUID"
	},
	BlogPostLocaleCreateContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput"
	},
	ContentCreateInput:{
		id:"UUID",
		blocks:"ContentCreateBlocksEntityRelationInput"
	},
	ContentCreateBlocksEntityRelationInput:{
		connect:"ContentBlockUniqueWhere",
		create:"ContentBlockWithoutContentCreateInput"
	},
	ContentBlockWithoutContentCreateInput:{
		id:"UUID",
		references:"ContentBlockCreateReferencesEntityRelationInput"
	},
	ContentBlockCreateReferencesEntityRelationInput:{
		connect:"ContentReferenceUniqueWhere",
		create:"ContentReferenceWithoutBlockCreateInput"
	},
	ContentReferenceWithoutBlockCreateInput:{
		id:"UUID",
		type:"ContentReferenceType",
		colorPallete:"ContentReferenceCreateColorPalleteEntityRelationInput",
		medium:"ContentReferenceCreateMediumEntityRelationInput",
		link:"ContentReferenceCreateLinkEntityRelationInput",
		blogPosts:"ContentReferenceCreateBlogPostsEntityRelationInput",
		links:"ContentReferenceCreateLinksEntityRelationInput",
		products:"ContentReferenceCreateProductsEntityRelationInput",
		contentSize:"ContentSize",
		hero:"ContentReferenceCreateHeroEntityRelationInput",
		gallery:"ContentReferenceCreateGalleryEntityRelationInput",
		socialsAndApps:"ContentReferenceCreateSocialsAndAppsEntityRelationInput",
		productGrid:"ContentReferenceCreateProductGridEntityRelationInput",
		productBanners:"ContentReferenceCreateProductBannersEntityRelationInput",
		deliveryRegions:"ContentReferenceCreateDeliveryRegionsEntityRelationInput",
		textList:"ContentReferenceCreateTextListEntityRelationInput",
		gridTiles:"ContentReferenceCreateGridTilesEntityRelationInput"
	},
	ContentReferenceCreateColorPalleteEntityRelationInput:{
		connect:"ColorPalleteUniqueWhere",
		create:"ColorPalleteCreateInput"
	},
	ContentReferenceCreateMediumEntityRelationInput:{
		connect:"MediumUniqueWhere",
		create:"MediumCreateInput"
	},
	ContentReferenceCreateLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput"
	},
	LinkCreateInput:{
		id:"UUID",
		type:"LinkType",
		internalLink:"LinkCreateInternalLinkEntityRelationInput"
	},
	LinkCreateInternalLinkEntityRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableCreateInput"
	},
	LinkableCreateInput:{
		id:"UUID",
		blogPost:"LinkableCreateBlogPostEntityRelationInput",
		page:"LinkableCreatePageEntityRelationInput",
		wikiPage:"LinkableCreateWikiPageEntityRelationInput",
		redirect:"LinkableCreateRedirectEntityRelationInput"
	},
	LinkableCreateBlogPostEntityRelationInput:{
		connect:"BlogPostLocaleUniqueWhere",
		create:"BlogPostLocaleWithoutLinkCreateInput"
	},
	BlogPostLocaleWithoutLinkCreateInput:{
		id:"UUID",
		root:"BlogPostLocaleCreateRootEntityRelationInput",
		locale:"BlogPostLocaleCreateLocaleEntityRelationInput",
		cover:"BlogPostLocaleCreateCoverEntityRelationInput",
		content:"BlogPostLocaleCreateContentEntityRelationInput",
		seo:"BlogPostLocaleCreateSeoEntityRelationInput",
		products:"BlogPostLocaleCreateProductsEntityRelationInput"
	},
	BlogPostLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutBlogPostsCreateInput"
	},
	LocaleWithoutBlogPostsCreateInput:{
		id:"UUID",
		businessCategories:"LocaleCreateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleCreateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleCreateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleCreateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleCreateBlogsEntityRelationInput",
		identifier:"LocaleCreateIdentifierEntityRelationInput",
		menus:"LocaleCreateMenusEntityRelationInput",
		pages:"LocaleCreatePagesEntityRelationInput",
		productIngredientCategories:"LocaleCreateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleCreateAllergensEntityRelationInput",
		productPackings:"LocaleCreateProductPackingsEntityRelationInput",
		products:"LocaleCreateProductsEntityRelationInput",
		productRecipes:"LocaleCreateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleCreatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleCreatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleCreateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleCreateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleCreateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleCreatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleCreateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleCreateBusinessServicesEntityRelationInput"
	},
	LocaleCreateIdentifierEntityRelationInput:{
		connect:"TranslationCataloguesIdentifierUniqueWhere",
		create:"TranslationCataloguesIdentifierCreateInput"
	},
	TranslationCataloguesIdentifierCreateInput:{
		id:"UUID",
		catalogue:"TranslationCataloguesIdentifierCreateCatalogueEntityRelationInput"
	},
	TranslationCataloguesIdentifierCreateCatalogueEntityRelationInput:{
		connect:"TranslationCatalogueUniqueWhere",
		create:"TranslationCatalogueWithoutIdentifierCreateInput"
	},
	TranslationCatalogueWithoutIdentifierCreateInput:{
		id:"UUID",
		domain:"TranslationCatalogueCreateDomainEntityRelationInput",
		fallback:"TranslationCatalogueCreateFallbackEntityRelationInput",
		values:"TranslationCatalogueCreateValuesEntityRelationInput"
	},
	TranslationCatalogueCreateDomainEntityRelationInput:{
		connect:"TranslationDomainUniqueWhere",
		create:"TranslationDomainWithoutCataloguesCreateInput"
	},
	TranslationDomainWithoutCataloguesCreateInput:{
		id:"UUID",
		keys:"TranslationDomainCreateKeysEntityRelationInput"
	},
	TranslationDomainCreateKeysEntityRelationInput:{
		connect:"TranslationKeyUniqueWhere",
		create:"TranslationKeyWithoutDomainCreateInput"
	},
	TranslationKeyWithoutDomainCreateInput:{
		id:"UUID",
		contentType:"TranslationContentType",
		values:"TranslationKeyCreateValuesEntityRelationInput"
	},
	TranslationKeyCreateValuesEntityRelationInput:{
		connect:"TranslationValueUniqueWhere",
		create:"TranslationValueWithoutKeyCreateInput"
	},
	TranslationValueWithoutKeyCreateInput:{
		id:"UUID",
		catalogue:"TranslationValueCreateCatalogueEntityRelationInput"
	},
	TranslationValueCreateCatalogueEntityRelationInput:{
		connect:"TranslationCatalogueUniqueWhere",
		create:"TranslationCatalogueWithoutValuesCreateInput"
	},
	TranslationCatalogueWithoutValuesCreateInput:{
		id:"UUID",
		domain:"TranslationCatalogueCreateDomainEntityRelationInput",
		fallback:"TranslationCatalogueCreateFallbackEntityRelationInput",
		identifier:"TranslationCatalogueCreateIdentifierEntityRelationInput"
	},
	TranslationCatalogueCreateFallbackEntityRelationInput:{
		connect:"TranslationCatalogueUniqueWhere",
		create:"TranslationCatalogueCreateInput"
	},
	TranslationCatalogueCreateInput:{
		id:"UUID",
		domain:"TranslationCatalogueCreateDomainEntityRelationInput",
		fallback:"TranslationCatalogueCreateFallbackEntityRelationInput",
		values:"TranslationCatalogueCreateValuesEntityRelationInput",
		identifier:"TranslationCatalogueCreateIdentifierEntityRelationInput"
	},
	TranslationCatalogueCreateValuesEntityRelationInput:{
		connect:"TranslationValueUniqueWhere",
		create:"TranslationValueWithoutCatalogueCreateInput"
	},
	TranslationValueWithoutCatalogueCreateInput:{
		id:"UUID",
		key:"TranslationValueCreateKeyEntityRelationInput"
	},
	TranslationValueCreateKeyEntityRelationInput:{
		connect:"TranslationKeyUniqueWhere",
		create:"TranslationKeyWithoutValuesCreateInput"
	},
	TranslationKeyWithoutValuesCreateInput:{
		id:"UUID",
		contentType:"TranslationContentType",
		domain:"TranslationKeyCreateDomainEntityRelationInput"
	},
	TranslationKeyCreateDomainEntityRelationInput:{
		connect:"TranslationDomainUniqueWhere",
		create:"TranslationDomainWithoutKeysCreateInput"
	},
	TranslationDomainWithoutKeysCreateInput:{
		id:"UUID",
		catalogues:"TranslationDomainCreateCataloguesEntityRelationInput"
	},
	TranslationDomainCreateCataloguesEntityRelationInput:{
		connect:"TranslationCatalogueUniqueWhere",
		create:"TranslationCatalogueWithoutDomainCreateInput"
	},
	TranslationCatalogueWithoutDomainCreateInput:{
		id:"UUID",
		fallback:"TranslationCatalogueCreateFallbackEntityRelationInput",
		values:"TranslationCatalogueCreateValuesEntityRelationInput",
		identifier:"TranslationCatalogueCreateIdentifierEntityRelationInput"
	},
	TranslationCatalogueCreateIdentifierEntityRelationInput:{
		connect:"TranslationCataloguesIdentifierUniqueWhere",
		create:"TranslationCataloguesIdentifierWithoutCatalogueCreateInput"
	},
	TranslationCataloguesIdentifierWithoutCatalogueCreateInput:{
		id:"UUID"
	},
	LocaleCreateMenusEntityRelationInput:{
		connect:"MenuLocaleUniqueWhere",
		create:"MenuLocaleWithoutLocaleCreateInput"
	},
	MenuLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"MenuLocaleCreateRootEntityRelationInput",
		items:"MenuLocaleCreateItemsEntityRelationInput",
		secondaryItems:"MenuLocaleCreateSecondaryItemsEntityRelationInput",
		eshopLink:"MenuLocaleCreateEshopLinkEntityRelationInput"
	},
	MenuLocaleCreateRootEntityRelationInput:{
		connect:"SiteMenuUniqueWhere",
		create:"SiteMenuWithoutLocalesCreateInput"
	},
	SiteMenuWithoutLocalesCreateInput:{
		id:"UUID",
		unique:"One"
	},
	MenuLocaleCreateItemsEntityRelationInput:{
		connect:"MenuItemUniqueWhere",
		create:"MenuItemWithoutMenuCreateInput"
	},
	MenuItemWithoutMenuCreateInput:{
		id:"UUID",
		link:"MenuItemCreateLinkEntityRelationInput",
		subitems:"MenuItemCreateSubitemsEntityRelationInput"
	},
	MenuItemCreateLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput"
	},
	MenuItemCreateSubitemsEntityRelationInput:{
		connect:"MenuSubitemUniqueWhere",
		create:"MenuSubitemWithoutItemCreateInput"
	},
	MenuSubitemWithoutItemCreateInput:{
		id:"UUID",
		type:"MenuSubitemType",
		links:"MenuSubitemCreateLinksEntityRelationInput",
		products:"MenuSubitemCreateProductsEntityRelationInput",
		delivery:"MenuSubitemCreateDeliveryEntityRelationInput",
		contact:"MenuSubitemCreateContactEntityRelationInput"
	},
	MenuSubitemCreateLinksEntityRelationInput:{
		connect:"MenuLinkListUniqueWhere",
		create:"MenuLinkListCreateInput"
	},
	MenuLinkListUniqueWhere:{
		id:"UUID",
		items:"MenuLinkItemUniqueWhere"
	},
	MenuLinkItemUniqueWhere:{
		id:"UUID"
	},
	MenuLinkListCreateInput:{
		id:"UUID",
		items:"MenuLinkListCreateItemsEntityRelationInput"
	},
	MenuLinkListCreateItemsEntityRelationInput:{
		connect:"MenuLinkItemUniqueWhere",
		create:"MenuLinkItemWithoutListCreateInput"
	},
	MenuLinkItemWithoutListCreateInput:{
		id:"UUID",
		link:"MenuLinkItemCreateLinkEntityRelationInput",
		image:"MenuLinkItemCreateImageEntityRelationInput"
	},
	MenuLinkItemCreateLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput"
	},
	MenuLinkItemCreateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	MenuSubitemCreateProductsEntityRelationInput:{
		connect:"MenuProductsUniqueWhere",
		create:"MenuProductsCreateInput"
	},
	MenuProductsUniqueWhere:{
		id:"UUID",
		buttons:"LinkListUniqueWhere"
	},
	MenuProductsCreateInput:{
		id:"UUID",
		links:"MenuProductsCreateLinksEntityRelationInput",
		buttons:"MenuProductsCreateButtonsEntityRelationInput"
	},
	MenuProductsCreateLinksEntityRelationInput:{
		connect:"MenuLinkListUniqueWhere",
		create:"MenuLinkListCreateInput"
	},
	MenuProductsCreateButtonsEntityRelationInput:{
		connect:"LinkListUniqueWhere",
		create:"LinkListCreateInput"
	},
	LinkListCreateInput:{
		id:"UUID",
		items:"LinkListCreateItemsEntityRelationInput"
	},
	LinkListCreateItemsEntityRelationInput:{
		connect:"LinkListItemUniqueWhere",
		create:"LinkListItemWithoutListCreateInput"
	},
	LinkListItemWithoutListCreateInput:{
		id:"UUID",
		link:"LinkListItemCreateLinkEntityRelationInput"
	},
	LinkListItemCreateLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput"
	},
	MenuSubitemCreateDeliveryEntityRelationInput:{
		connect:"MenuDeliveryUniqueWhere",
		create:"MenuDeliveryCreateInput"
	},
	MenuDeliveryUniqueWhere:{
		id:"UUID",
		deliveryRegions:"DeliveryRegionsUniqueWhere"
	},
	MenuDeliveryCreateInput:{
		id:"UUID",
		deliveryRegions:"MenuDeliveryCreateDeliveryRegionsEntityRelationInput",
		socialsAndApps:"MenuDeliveryCreateSocialsAndAppsEntityRelationInput"
	},
	MenuDeliveryCreateDeliveryRegionsEntityRelationInput:{
		connect:"DeliveryRegionsUniqueWhere",
		create:"DeliveryRegionsCreateInput"
	},
	DeliveryRegionsCreateInput:{
		id:"UUID",
		items:"DeliveryRegionsCreateItemsEntityRelationInput"
	},
	DeliveryRegionsCreateItemsEntityRelationInput:{
		connect:"DeliveryRegionsItemUniqueWhere",
		create:"DeliveryRegionsItemWithoutListCreateInput"
	},
	DeliveryRegionsItemWithoutListCreateInput:{
		id:"UUID",
		image:"DeliveryRegionsItemCreateImageEntityRelationInput",
		textList:"DeliveryRegionsItemCreateTextListEntityRelationInput",
		gallery:"DeliveryRegionsItemCreateGalleryEntityRelationInput"
	},
	DeliveryRegionsItemCreateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	DeliveryRegionsItemCreateTextListEntityRelationInput:{
		connect:"TextListUniqueWhere",
		create:"TextListCreateInput"
	},
	TextListCreateInput:{
		id:"UUID",
		items:"TextListCreateItemsEntityRelationInput"
	},
	TextListCreateItemsEntityRelationInput:{
		connect:"TextItemUniqueWhere",
		create:"TextItemWithoutListCreateInput"
	},
	TextItemWithoutListCreateInput:{
		id:"UUID"
	},
	DeliveryRegionsItemCreateGalleryEntityRelationInput:{
		connect:"ImageListUniqueWhere",
		create:"ImageListCreateInput"
	},
	ImageListCreateInput:{
		id:"UUID",
		items:"ImageListCreateItemsEntityRelationInput"
	},
	ImageListCreateItemsEntityRelationInput:{
		connect:"ImageListItemUniqueWhere",
		create:"ImageListItemWithoutListCreateInput"
	},
	ImageListItemWithoutListCreateInput:{
		id:"UUID",
		image:"ImageListItemCreateImageEntityRelationInput"
	},
	ImageListItemCreateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	MenuDeliveryCreateSocialsAndAppsEntityRelationInput:{
		connect:"SocialsAndAppsUniqueWhere",
		create:"SocialsAndAppsCreateInput"
	},
	SocialsAndAppsUniqueWhere:{
		id:"UUID"
	},
	SocialsAndAppsCreateInput:{
		id:"UUID"
	},
	MenuSubitemCreateContactEntityRelationInput:{
		connect:"MenuContactUniqueWhere",
		create:"MenuContactCreateInput"
	},
	MenuContactUniqueWhere:{
		id:"UUID"
	},
	MenuContactCreateInput:{
		id:"UUID",
		image:"MenuContactCreateImageEntityRelationInput"
	},
	MenuContactCreateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	MenuLocaleCreateSecondaryItemsEntityRelationInput:{
		connect:"LinkListUniqueWhere",
		create:"LinkListCreateInput"
	},
	MenuLocaleCreateEshopLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput"
	},
	LocaleCreatePagesEntityRelationInput:{
		connect:"PageLocaleUniqueWhere",
		create:"PageLocaleWithoutLocaleCreateInput"
	},
	PageLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		link:"PageLocaleCreateLinkEntityRelationInput",
		root:"PageLocaleCreateRootEntityRelationInput",
		seo:"PageLocaleCreateSeoEntityRelationInput",
		content:"PageLocaleCreateContentEntityRelationInput",
		cover:"PageLocaleCreateCoverEntityRelationInput",
		theme:"PageTheme"
	},
	PageLocaleCreateLinkEntityRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutPageCreateInput"
	},
	LinkableWithoutPageCreateInput:{
		id:"UUID",
		blogPost:"LinkableCreateBlogPostEntityRelationInput",
		wikiPage:"LinkableCreateWikiPageEntityRelationInput",
		redirect:"LinkableCreateRedirectEntityRelationInput"
	},
	LinkableCreateWikiPageEntityRelationInput:{
		connect:"WikiPageUniqueWhere",
		create:"WikiPageWithoutLinkCreateInput"
	},
	WikiPageWithoutLinkCreateInput:{
		id:"UUID",
		parent:"WikiPageCreateParentEntityRelationInput",
		children:"WikiPageCreateChildrenEntityRelationInput",
		content:"WikiPageCreateContentEntityRelationInput"
	},
	WikiPageCreateParentEntityRelationInput:{
		connect:"WikiPageUniqueWhere",
		create:"WikiPageWithoutChildrenCreateInput"
	},
	WikiPageWithoutChildrenCreateInput:{
		id:"UUID",
		link:"WikiPageCreateLinkEntityRelationInput",
		parent:"WikiPageCreateParentEntityRelationInput",
		content:"WikiPageCreateContentEntityRelationInput"
	},
	WikiPageCreateLinkEntityRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutWikiPageCreateInput"
	},
	LinkableWithoutWikiPageCreateInput:{
		id:"UUID",
		blogPost:"LinkableCreateBlogPostEntityRelationInput",
		page:"LinkableCreatePageEntityRelationInput",
		redirect:"LinkableCreateRedirectEntityRelationInput"
	},
	LinkableCreatePageEntityRelationInput:{
		connect:"PageLocaleUniqueWhere",
		create:"PageLocaleWithoutLinkCreateInput"
	},
	PageLocaleWithoutLinkCreateInput:{
		id:"UUID",
		root:"PageLocaleCreateRootEntityRelationInput",
		locale:"PageLocaleCreateLocaleEntityRelationInput",
		seo:"PageLocaleCreateSeoEntityRelationInput",
		content:"PageLocaleCreateContentEntityRelationInput",
		cover:"PageLocaleCreateCoverEntityRelationInput",
		theme:"PageTheme"
	},
	PageLocaleCreateRootEntityRelationInput:{
		connect:"PageUniqueWhere",
		create:"PageWithoutLocalesCreateInput"
	},
	PageWithoutLocalesCreateInput:{
		id:"UUID"
	},
	PageLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutPagesCreateInput"
	},
	LocaleWithoutPagesCreateInput:{
		id:"UUID",
		businessCategories:"LocaleCreateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleCreateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleCreateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleCreateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleCreateBlogsEntityRelationInput",
		blogPosts:"LocaleCreateBlogPostsEntityRelationInput",
		identifier:"LocaleCreateIdentifierEntityRelationInput",
		menus:"LocaleCreateMenusEntityRelationInput",
		productIngredientCategories:"LocaleCreateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleCreateAllergensEntityRelationInput",
		productPackings:"LocaleCreateProductPackingsEntityRelationInput",
		products:"LocaleCreateProductsEntityRelationInput",
		productRecipes:"LocaleCreateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleCreatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleCreatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleCreateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleCreateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleCreateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleCreatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleCreateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleCreateBusinessServicesEntityRelationInput"
	},
	LocaleCreateProductIngredientCategoriesEntityRelationInput:{
		connect:"ProductIngredientCategoryLocaleUniqueWhere",
		create:"ProductIngredientCategoryLocaleWithoutLocaleCreateInput"
	},
	ProductIngredientCategoryLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"ProductIngredientCategoryLocaleCreateRootEntityRelationInput"
	},
	ProductIngredientCategoryLocaleCreateRootEntityRelationInput:{
		connect:"ProductIngredientCategoryUniqueWhere",
		create:"ProductIngredientCategoryWithoutLocalesCreateInput"
	},
	ProductIngredientCategoryWithoutLocalesCreateInput:{
		id:"UUID",
		ingredients:"ProductIngredientCategoryCreateIngredientsEntityRelationInput"
	},
	ProductIngredientCategoryCreateIngredientsEntityRelationInput:{
		connect:"ProductIngredientUniqueWhere",
		create:"ProductIngredientWithoutCategoriesCreateInput"
	},
	ProductIngredientWithoutCategoriesCreateInput:{
		id:"UUID",
		locales:"ProductIngredientCreateLocalesEntityRelationInput",
		allergens:"ProductIngredientCreateAllergensEntityRelationInput",
		customerRatings:"ProductIngredientCreateCustomerRatingsEntityRelationInput",
		preferredQuantityUnit:"ProductIngredientCreatePreferredQuantityUnitEntityRelationInput",
		freshingContainer:"ProductIngredientCreateFreshingContainerEntityRelationInput",
		image:"ProductIngredientCreateImageEntityRelationInput",
		suppliers:"ProductIngredientCreateSuppliersEntityRelationInput"
	},
	ProductIngredientCreateCustomerRatingsEntityRelationInput:{
		connect:"CustomerIngredientRatingUniqueWhere",
		create:"CustomerIngredientRatingWithoutIngredientCreateInput"
	},
	CustomerIngredientRatingWithoutIngredientCreateInput:{
		id:"UUID",
		customer:"CustomerIngredientRatingCreateCustomerEntityRelationInput",
		rating:"CustomerIngredientRatingCreateRatingEntityRelationInput"
	},
	CustomerIngredientRatingCreateCustomerEntityRelationInput:{
		connect:"CustomerUniqueWhere",
		create:"CustomerWithoutIngredientRatingsCreateInput"
	},
	CustomerWithoutIngredientRatingsCreateInput:{
		id:"UUID",
		addresses:"CustomerCreateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerCreateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerCreateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerCreateTagsEntityRelationInput",
		credits:"CustomerCreateCreditsEntityRelationInput",
		paymentMethods:"CustomerCreatePaymentMethodsEntityRelationInput",
		orders:"CustomerCreateOrdersEntityRelationInput",
		permissions:"CustomerCreatePermissionsEntityRelationInput",
		group:"CustomerCreateGroupEntityRelationInput",
		photo:"CustomerCreatePhotoEntityRelationInput",
		name:"CustomerCreateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		business:"CustomerCreateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerCreateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerCreateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerCreateCartsEntityRelationInput",
		shortcutList:"CustomerCreateShortcutListEntityRelationInput",
		user:"CustomerCreateUserEntityRelationInput",
		channels:"CustomerCreateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerCreateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerCreateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerCreateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerCreateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerCreateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerCreateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerCreateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerCreateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerCreateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerCreateRedeemedVouchersEntityRelationInput",
		spending:"CustomerCreateSpendingEntityRelationInput",
		customerTabs:"CustomerCreateCustomerTabsEntityRelationInput",
		lead:"CustomerCreateLeadEntityRelationInput",
		meta:"CustomerCreateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerCreateBusinessEntityRelationInput:{
		connect:"BusinessCustomerUniqueWhere",
		create:"BusinessCustomerWithoutCustomerCreateInput"
	},
	BusinessCustomerWithoutCustomerCreateInput:{
		id:"UUID",
		owners:"BusinessCustomerCreateOwnersEntityRelationInput",
		members:"BusinessCustomerCreateMembersEntityRelationInput",
		category:"BusinessCustomerCreateCategoryEntityRelationInput",
		accountManager:"BusinessCustomerCreateAccountManagerEntityRelationInput",
		logo:"BusinessCustomerCreateLogoEntityRelationInput",
		businessServiceEvents:"BusinessCustomerCreateBusinessServiceEventsEntityRelationInput",
		doubleshotCoffeeEquipment:"BusinessCustomerCreateDoubleshotCoffeeEquipmentEntityRelationInput"
	},
	BusinessCustomerCreateOwnersEntityRelationInput:{
		connect:"CustomerUniqueWhere",
		create:"CustomerWithoutOwnerOfBusinessesCreateInput"
	},
	CustomerWithoutOwnerOfBusinessesCreateInput:{
		id:"UUID",
		addresses:"CustomerCreateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerCreateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerCreateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerCreateTagsEntityRelationInput",
		credits:"CustomerCreateCreditsEntityRelationInput",
		paymentMethods:"CustomerCreatePaymentMethodsEntityRelationInput",
		orders:"CustomerCreateOrdersEntityRelationInput",
		permissions:"CustomerCreatePermissionsEntityRelationInput",
		group:"CustomerCreateGroupEntityRelationInput",
		photo:"CustomerCreatePhotoEntityRelationInput",
		name:"CustomerCreateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerCreateIngredientRatingsEntityRelationInput",
		business:"CustomerCreateBusinessEntityRelationInput",
		memberOfBusinesses:"CustomerCreateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerCreateCartsEntityRelationInput",
		shortcutList:"CustomerCreateShortcutListEntityRelationInput",
		user:"CustomerCreateUserEntityRelationInput",
		channels:"CustomerCreateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerCreateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerCreateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerCreateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerCreateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerCreateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerCreateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerCreateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerCreateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerCreateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerCreateRedeemedVouchersEntityRelationInput",
		spending:"CustomerCreateSpendingEntityRelationInput",
		customerTabs:"CustomerCreateCustomerTabsEntityRelationInput",
		lead:"CustomerCreateLeadEntityRelationInput",
		meta:"CustomerCreateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerCreateMemberOfBusinessesEntityRelationInput:{
		connect:"BusinessCustomerUniqueWhere",
		create:"BusinessCustomerWithoutMembersCreateInput"
	},
	BusinessCustomerWithoutMembersCreateInput:{
		id:"UUID",
		customer:"BusinessCustomerCreateCustomerEntityRelationInput",
		owners:"BusinessCustomerCreateOwnersEntityRelationInput",
		category:"BusinessCustomerCreateCategoryEntityRelationInput",
		accountManager:"BusinessCustomerCreateAccountManagerEntityRelationInput",
		logo:"BusinessCustomerCreateLogoEntityRelationInput",
		businessServiceEvents:"BusinessCustomerCreateBusinessServiceEventsEntityRelationInput",
		doubleshotCoffeeEquipment:"BusinessCustomerCreateDoubleshotCoffeeEquipmentEntityRelationInput"
	},
	BusinessCustomerCreateCategoryEntityRelationInput:{
		connect:"BusinessCategoryUniqueWhere",
		create:"BusinessCategoryWithoutBusinessCustomersCreateInput"
	},
	BusinessCategoryWithoutBusinessCustomersCreateInput:{
		id:"UUID",
		locales:"BusinessCategoryCreateLocalesEntityRelationInput",
		recurrences:"BusinessCategoryCreateRecurrencesEntityRelationInput",
		specificProducts:"BusinessCategoryCreateSpecificProductsEntityRelationInput",
		seasonalProductCategories:"BusinessCategoryCreateSeasonalProductCategoriesEntityRelationInput",
		specificProductsProductCategories:"BusinessCategoryCreateSpecificProductsProductCategoriesEntityRelationInput"
	},
	BusinessCategoryCreateRecurrencesEntityRelationInput:{
		connect:"OrderRecurrenceUniqueWhere",
		create:"OrderRecurrenceWithoutBusinessCategoryCreateInput"
	},
	OrderRecurrenceWithoutBusinessCategoryCreateInput:{
		id:"UUID",
		locales:"OrderRecurrenceCreateLocalesEntityRelationInput"
	},
	OrderRecurrenceCreateLocalesEntityRelationInput:{
		connect:"OrderRecurrenceLocaleUniqueWhere",
		create:"OrderRecurrenceLocaleWithoutRootCreateInput"
	},
	OrderRecurrenceLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"OrderRecurrenceLocaleCreateLocaleEntityRelationInput"
	},
	OrderRecurrenceLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutOrderRecurrencesCreateInput"
	},
	LocaleWithoutOrderRecurrencesCreateInput:{
		id:"UUID",
		businessCategories:"LocaleCreateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleCreateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleCreateProductIngredientsEntityRelationInput",
		blogs:"LocaleCreateBlogsEntityRelationInput",
		blogPosts:"LocaleCreateBlogPostsEntityRelationInput",
		identifier:"LocaleCreateIdentifierEntityRelationInput",
		menus:"LocaleCreateMenusEntityRelationInput",
		pages:"LocaleCreatePagesEntityRelationInput",
		productIngredientCategories:"LocaleCreateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleCreateAllergensEntityRelationInput",
		productPackings:"LocaleCreateProductPackingsEntityRelationInput",
		products:"LocaleCreateProductsEntityRelationInput",
		productRecipes:"LocaleCreateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleCreatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleCreatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleCreateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleCreateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleCreateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleCreatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleCreateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleCreateBusinessServicesEntityRelationInput"
	},
	LocaleCreateAllergensEntityRelationInput:{
		connect:"AllergenLocaleUniqueWhere",
		create:"AllergenLocaleWithoutLocaleCreateInput"
	},
	AllergenLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"AllergenLocaleCreateRootEntityRelationInput"
	},
	AllergenLocaleCreateRootEntityRelationInput:{
		connect:"AllergenUniqueWhere",
		create:"AllergenWithoutLocalesCreateInput"
	},
	AllergenWithoutLocalesCreateInput:{
		id:"UUID",
		ingredients:"AllergenCreateIngredientsEntityRelationInput"
	},
	AllergenCreateIngredientsEntityRelationInput:{
		connect:"ProductIngredientUniqueWhere",
		create:"ProductIngredientWithoutAllergensCreateInput"
	},
	ProductIngredientWithoutAllergensCreateInput:{
		id:"UUID",
		locales:"ProductIngredientCreateLocalesEntityRelationInput",
		categories:"ProductIngredientCreateCategoriesEntityRelationInput",
		customerRatings:"ProductIngredientCreateCustomerRatingsEntityRelationInput",
		preferredQuantityUnit:"ProductIngredientCreatePreferredQuantityUnitEntityRelationInput",
		freshingContainer:"ProductIngredientCreateFreshingContainerEntityRelationInput",
		image:"ProductIngredientCreateImageEntityRelationInput",
		suppliers:"ProductIngredientCreateSuppliersEntityRelationInput"
	},
	ProductIngredientCreatePreferredQuantityUnitEntityRelationInput:{
		connect:"ProductIngredientItemQuantityUnitUniqueWhere",
		create:"ProductIngredientItemQuantityUnitCreateInput"
	},
	ProductIngredientItemQuantityUnitUniqueWhere:{
		id:"UUID"
	},
	ProductIngredientItemQuantityUnitCreateInput:{
		id:"UUID"
	},
	ProductIngredientCreateFreshingContainerEntityRelationInput:{
		connect:"FreshingContainerUniqueWhere",
		create:"FreshingContainerCreateInput"
	},
	FreshingContainerUniqueWhere:{
		id:"UUID"
	},
	FreshingContainerCreateInput:{
		id:"UUID",
		workspace:"FreshingContainerCreateWorkspaceEntityRelationInput"
	},
	FreshingContainerCreateWorkspaceEntityRelationInput:{
		connect:"WorkspaceUniqueWhere",
		create:"WorkspaceWithoutFreshingContainersCreateInput"
	},
	WorkspaceUniqueWhere:{
		id:"UUID",
		unique:"One",
		freshingContainers:"FreshingContainerUniqueWhere",
		openingHours:"WeekHoursUniqueWhere",
		workingHours:"WeekHoursUniqueWhere",
		creditsProduct:"VirtualProductUniqueWhere",
		discountVatRate:"VatRateUniqueWhere"
	},
	WeekHoursUniqueWhere:{
		id:"UUID"
	},
	WorkspaceWithoutFreshingContainersCreateInput:{
		id:"UUID",
		unique:"One",
		openingHours:"WorkspaceCreateOpeningHoursEntityRelationInput",
		workingHours:"WorkspaceCreateWorkingHoursEntityRelationInput",
		defaultFreshingContainer:"WorkspaceCreateDefaultFreshingContainerEntityRelationInput",
		creditsProduct:"WorkspaceCreateCreditsProductEntityRelationInput",
		discountVatRate:"WorkspaceCreateDiscountVatRateEntityRelationInput"
	},
	WorkspaceCreateOpeningHoursEntityRelationInput:{
		connect:"WeekHoursUniqueWhere",
		create:"WeekHoursCreateInput"
	},
	WeekHoursCreateInput:{
		id:"UUID"
	},
	WorkspaceCreateWorkingHoursEntityRelationInput:{
		connect:"WeekHoursUniqueWhere",
		create:"WeekHoursCreateInput"
	},
	WorkspaceCreateDefaultFreshingContainerEntityRelationInput:{
		connect:"FreshingContainerUniqueWhere",
		create:"FreshingContainerCreateInput"
	},
	WorkspaceCreateCreditsProductEntityRelationInput:{
		connect:"VirtualProductUniqueWhere",
		create:"VirtualProductCreateInput"
	},
	VirtualProductCreateInput:{
		id:"UUID",
		type:"VirtualProductType",
		product:"VirtualProductCreateProductEntityRelationInput",
		physicalRepresentation:"VirtualProductPhysicalRepresentationType"
	},
	VirtualProductCreateProductEntityRelationInput:{
		connect:"ProductUniqueWhere",
		create:"ProductWithoutVirtualProductCreateInput"
	},
	ProductWithoutVirtualProductCreateInput:{
		id:"UUID",
		packing:"ProductCreatePackingEntityRelationInput",
		recipe:"ProductCreateRecipeEntityRelationInput",
		tags:"ProductCreateTagsEntityRelationInput",
		categories:"ProductCreateCategoriesEntityRelationInput",
		vatRate:"ProductCreateVatRateEntityRelationInput",
		stocks:"ProductCreateStocksEntityRelationInput",
		groupPrices:"ProductCreateGroupPricesEntityRelationInput",
		image:"ProductCreateImageEntityRelationInput",
		cartItems:"ProductCreateCartItemsEntityRelationInput",
		availability:"ProductAvailability",
		manager:"ProductCreateManagerEntityRelationInput",
		orderItems:"ProductCreateOrderItemsEntityRelationInput",
		inheritedCategories:"ProductCreateInheritedCategoriesEntityRelationInput",
		deliveryZones:"ProductCreateDeliveryZonesEntityRelationInput",
		locales:"ProductCreateLocalesEntityRelationInput",
		archivedAt:"DateTime",
		customerPrices:"ProductCreateCustomerPricesEntityRelationInput",
		meta:"ProductCreateMetaEntityRelationInput",
		page:"ProductCreatePageEntityRelationInput",
		salesDays:"ProductCreateSalesDaysEntityRelationInput",
		salesWeeks:"ProductCreateSalesWeeksEntityRelationInput",
		salesMonths:"ProductCreateSalesMonthsEntityRelationInput",
		fulfillmentNotes:"ProductCreateFulfillmentNotesEntityRelationInput"
	},
	ProductCreateManagerEntityRelationInput:{
		connect:"StocksManagerUniqueWhere",
		create:"StocksManagerWithoutManagedProductsCreateInput"
	},
	StocksManagerWithoutManagedProductsCreateInput:{
		id:"UUID",
		staff:"StocksManagerCreateStaffEntityRelationInput",
		createdAt:"DateTime"
	},
	StocksManagerCreateStaffEntityRelationInput:{
		connect:"StaffUniqueWhere",
		create:"StaffWithoutStocksManagerCreateInput"
	},
	StaffWithoutStocksManagerCreateInput:{
		id:"UUID",
		bartender:"StaffCreateBartenderEntityRelationInput",
		courier:"StaffCreateCourierEntityRelationInput",
		cleaner:"StaffCreateCleanerEntityRelationInput",
		shiftsManager:"StaffCreateShiftsManagerEntityRelationInput",
		businessToBusinessManager:"StaffCreateBusinessToBusinessManagerEntityRelationInput",
		user:"StaffCreateUserEntityRelationInput",
		shiftsProfile:"StaffCreateShiftsProfileEntityRelationInput",
		photo:"StaffCreatePhotoEntityRelationInput",
		courierManager:"StaffCreateCourierManagerEntityRelationInput",
		picker:"StaffCreatePickerEntityRelationInput",
		createdAt:"DateTime",
		remunerationProfile:"StaffCreateRemunerationProfileEntityRelationInput",
		cashier:"StaffCreateCashierEntityRelationInput",
		venues:"StaffCreateVenuesEntityRelationInput",
		internalBuyer:"StaffCreateInternalBuyerEntityRelationInput",
		salesManager:"StaffCreateSalesManagerEntityRelationInput",
		cashierManager:"StaffCreateCashierManagerEntityRelationInput"
	},
	StaffCreateBartenderEntityRelationInput:{
		connect:"BartenderUniqueWhere",
		create:"BartenderWithoutStaffCreateInput"
	},
	BartenderWithoutStaffCreateInput:{
		id:"UUID",
		createdAt:"DateTime"
	},
	StaffCreateCourierEntityRelationInput:{
		connect:"CourierUniqueWhere",
		create:"CourierWithoutStaffCreateInput"
	},
	CourierWithoutStaffCreateInput:{
		id:"UUID",
		routes:"CourierCreateRoutesEntityRelationInput",
		createdAt:"DateTime",
		deliveryMethods:"CourierCreateDeliveryMethodsEntityRelationInput"
	},
	CourierCreateRoutesEntityRelationInput:{
		connect:"DeliveryRouteUniqueWhere",
		create:"DeliveryRouteWithoutCourierCreateInput"
	},
	DeliveryRouteWithoutCourierCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		waypoints:"DeliveryRouteCreateWaypointsEntityRelationInput"
	},
	DeliveryRouteCreateWaypointsEntityRelationInput:{
		connect:"DeliveryWaypointUniqueWhere",
		create:"DeliveryWaypointWithoutRouteCreateInput"
	},
	DeliveryWaypointWithoutRouteCreateInput:{
		id:"UUID",
		estimatedArrival:"DateTime",
		delivery:"DeliveryWaypointCreateDeliveryEntityRelationInput",
		originDeparture:"DateTime"
	},
	DeliveryWaypointCreateDeliveryEntityRelationInput:{
		connect:"OrderDeliveryUniqueWhere",
		create:"OrderDeliveryWithoutDeliveryWaypointCreateInput"
	},
	OrderDeliveryWithoutDeliveryWaypointCreateInput:{
		id:"UUID",
		deliveredAt:"DateTime",
		method:"OrderDeliveryCreateMethodEntityRelationInput",
		vatRate:"OrderDeliveryCreateVatRateEntityRelationInput",
		order:"OrderDeliveryCreateOrderEntityRelationInput",
		expectedAt:"DateTime",
		state:"OrderDeliveryState",
		dispatchAt:"DateTime",
		expectedEndAt:"DateTime",
		processingAt:"DateTime",
		deliveringAt:"DateTime",
		failedAt:"DateTime",
		events:"OrderDeliveryCreateEventsEntityRelationInput",
		prepareAt:"DateTime",
		liftagoRide:"OrderDeliveryCreateLiftagoRideEntityRelationInput",
		pickedAt:"DateTime",
		address:"OrderDeliveryCreateAddressEntityRelationInput",
		woltDriveDelivery:"OrderDeliveryCreateWoltDriveDeliveryEntityRelationInput"
	},
	OrderDeliveryCreateMethodEntityRelationInput:{
		connect:"DeliveryMethodUniqueWhere",
		create:"DeliveryMethodCreateInput"
	},
	DeliveryMethodCreateInput:{
		id:"UUID",
		paymentMethods:"DeliveryMethodCreatePaymentMethodsEntityRelationInput",
		suitableForDeliveryZones:"DeliveryMethodCreateSuitableForDeliveryZonesEntityRelationInput",
		channels:"DeliveryMethodCreateChannelsEntityRelationInput",
		courierHandlers:"DeliveryMethodCreateCourierHandlersEntityRelationInput",
		locales:"DeliveryMethodCreateLocalesEntityRelationInput",
		timelinePreset:"DeliveryMethodCreateTimelinePresetEntityRelationInput"
	},
	DeliveryMethodCreateCourierHandlersEntityRelationInput:{
		connect:"CourierUniqueWhere",
		create:"CourierWithoutDeliveryMethodsCreateInput"
	},
	CourierWithoutDeliveryMethodsCreateInput:{
		id:"UUID",
		staff:"CourierCreateStaffEntityRelationInput",
		routes:"CourierCreateRoutesEntityRelationInput",
		createdAt:"DateTime"
	},
	CourierCreateStaffEntityRelationInput:{
		connect:"StaffUniqueWhere",
		create:"StaffWithoutCourierCreateInput"
	},
	StaffWithoutCourierCreateInput:{
		id:"UUID",
		bartender:"StaffCreateBartenderEntityRelationInput",
		cleaner:"StaffCreateCleanerEntityRelationInput",
		shiftsManager:"StaffCreateShiftsManagerEntityRelationInput",
		businessToBusinessManager:"StaffCreateBusinessToBusinessManagerEntityRelationInput",
		user:"StaffCreateUserEntityRelationInput",
		shiftsProfile:"StaffCreateShiftsProfileEntityRelationInput",
		stocksManager:"StaffCreateStocksManagerEntityRelationInput",
		photo:"StaffCreatePhotoEntityRelationInput",
		courierManager:"StaffCreateCourierManagerEntityRelationInput",
		picker:"StaffCreatePickerEntityRelationInput",
		createdAt:"DateTime",
		remunerationProfile:"StaffCreateRemunerationProfileEntityRelationInput",
		cashier:"StaffCreateCashierEntityRelationInput",
		venues:"StaffCreateVenuesEntityRelationInput",
		internalBuyer:"StaffCreateInternalBuyerEntityRelationInput",
		salesManager:"StaffCreateSalesManagerEntityRelationInput",
		cashierManager:"StaffCreateCashierManagerEntityRelationInput"
	},
	StaffCreateCleanerEntityRelationInput:{
		connect:"CleanerUniqueWhere",
		create:"CleanerWithoutStaffCreateInput"
	},
	CleanerWithoutStaffCreateInput:{
		id:"UUID",
		createdAt:"DateTime"
	},
	StaffCreateShiftsManagerEntityRelationInput:{
		connect:"ShiftsManagerUniqueWhere",
		create:"ShiftsManagerWithoutStaffCreateInput"
	},
	ShiftsManagerWithoutStaffCreateInput:{
		id:"UUID",
		managedRoles:"ShiftsManagerCreateManagedRolesEntityRelationInput",
		createdAt:"DateTime"
	},
	ShiftsManagerCreateManagedRolesEntityRelationInput:{
		connect:"TimetableEmployeeRoleUniqueWhere",
		create:"TimetableEmployeeRoleWithoutShiftsManagersCreateInput"
	},
	TimetableEmployeeRoleWithoutShiftsManagersCreateInput:{
		id:"UUID",
		shiftGroups:"TimetableEmployeeRoleCreateShiftGroupsEntityRelationInput",
		shiftsProfiles:"TimetableEmployeeRoleCreateShiftsProfilesEntityRelationInput",
		timetableTemplates:"TimetableEmployeeRoleCreateTimetableTemplatesEntityRelationInput"
	},
	TimetableEmployeeRoleCreateShiftGroupsEntityRelationInput:{
		connect:"TimetableShiftGroupUniqueWhere",
		create:"TimetableShiftGroupWithoutTypeCreateInput"
	},
	TimetableShiftGroupWithoutTypeCreateInput:{
		id:"UUID",
		shifts:"TimetableShiftGroupCreateShiftsEntityRelationInput",
		day:"TimetableShiftGroupCreateDayEntityRelationInput",
		position:"TimetableShiftGroupCreatePositionEntityRelationInput",
		queue:"TimetableShiftGroupCreateQueueEntityRelationInput",
		generatedByTemplate:"TimetableShiftGroupCreateGeneratedByTemplateEntityRelationInput"
	},
	TimetableShiftGroupCreateShiftsEntityRelationInput:{
		connect:"TimetableShiftUniqueWhere",
		create:"TimetableShiftWithoutGroupCreateInput"
	},
	TimetableShiftWithoutGroupCreateInput:{
		id:"UUID",
		assigned:"Date",
		shiftsProfile:"TimetableShiftCreateShiftsProfileEntityRelationInput",
		queueItem:"TimetableShiftCreateQueueItemEntityRelationInput",
		swapInfo:"TimetableShiftCreateSwapInfoEntityRelationInput"
	},
	TimetableShiftCreateShiftsProfileEntityRelationInput:{
		connect:"ShiftsProfileUniqueWhere",
		create:"ShiftsProfileWithoutShiftsCreateInput"
	},
	ShiftsProfileWithoutShiftsCreateInput:{
		id:"UUID",
		queueItems:"ShiftsProfileCreateQueueItemsEntityRelationInput",
		staff:"ShiftsProfileCreateStaffEntityRelationInput",
		roles:"ShiftsProfileCreateRolesEntityRelationInput"
	},
	ShiftsProfileCreateQueueItemsEntityRelationInput:{
		connect:"EmployeeQueueItemUniqueWhere",
		create:"EmployeeQueueItemWithoutShiftsProfileCreateInput"
	},
	EmployeeQueueItemWithoutShiftsProfileCreateInput:{
		id:"UUID",
		queue:"EmployeeQueueItemCreateQueueEntityRelationInput",
		shift:"EmployeeQueueItemCreateShiftEntityRelationInput",
		unassignInfo:"EmployeeQueueItemCreateUnassignInfoEntityRelationInput",
		meta:"EmployeeQueueItemCreateMetaEntityRelationInput"
	},
	EmployeeQueueItemCreateQueueEntityRelationInput:{
		connect:"EmployeeQueueUniqueWhere",
		create:"EmployeeQueueWithoutItemsCreateInput"
	},
	EmployeeQueueWithoutItemsCreateInput:{
		id:"UUID",
		shiftGroup:"EmployeeQueueCreateShiftGroupEntityRelationInput"
	},
	EmployeeQueueCreateShiftGroupEntityRelationInput:{
		connect:"TimetableShiftGroupUniqueWhere",
		create:"TimetableShiftGroupWithoutQueueCreateInput"
	},
	TimetableShiftGroupWithoutQueueCreateInput:{
		id:"UUID",
		shifts:"TimetableShiftGroupCreateShiftsEntityRelationInput",
		day:"TimetableShiftGroupCreateDayEntityRelationInput",
		type:"TimetableShiftGroupCreateTypeEntityRelationInput",
		position:"TimetableShiftGroupCreatePositionEntityRelationInput",
		generatedByTemplate:"TimetableShiftGroupCreateGeneratedByTemplateEntityRelationInput"
	},
	TimetableShiftGroupCreateDayEntityRelationInput:{
		connect:"TimetableDayUniqueWhere",
		create:"TimetableDayWithoutShiftGroupsCreateInput"
	},
	TimetableDayWithoutShiftGroupsCreateInput:{
		id:"UUID",
		date:"Date",
		type:"TimetableDayType",
		notes:"TimetableDayCreateNotesEntityRelationInput",
		venue:"TimetableDayCreateVenueEntityRelationInput",
		meta:"TimetableDayCreateMetaEntityRelationInput"
	},
	TimetableDayCreateNotesEntityRelationInput:{
		connect:"TimetableDayNoteUniqueWhere",
		create:"TimetableDayNoteWithoutDayCreateInput"
	},
	TimetableDayNoteWithoutDayCreateInput:{
		id:"UUID",
		role:"TimetableDayNoteCreateRoleEntityRelationInput"
	},
	TimetableDayNoteCreateRoleEntityRelationInput:{
		connect:"TimetableEmployeeRoleUniqueWhere",
		create:"TimetableEmployeeRoleCreateInput"
	},
	TimetableEmployeeRoleCreateInput:{
		id:"UUID",
		shiftGroups:"TimetableEmployeeRoleCreateShiftGroupsEntityRelationInput",
		shiftsProfiles:"TimetableEmployeeRoleCreateShiftsProfilesEntityRelationInput",
		shiftsManagers:"TimetableEmployeeRoleCreateShiftsManagersEntityRelationInput",
		timetableTemplates:"TimetableEmployeeRoleCreateTimetableTemplatesEntityRelationInput"
	},
	TimetableEmployeeRoleCreateShiftsProfilesEntityRelationInput:{
		connect:"ShiftsProfileUniqueWhere",
		create:"ShiftsProfileWithoutRolesCreateInput"
	},
	ShiftsProfileWithoutRolesCreateInput:{
		id:"UUID",
		queueItems:"ShiftsProfileCreateQueueItemsEntityRelationInput",
		staff:"ShiftsProfileCreateStaffEntityRelationInput",
		shifts:"ShiftsProfileCreateShiftsEntityRelationInput"
	},
	ShiftsProfileCreateStaffEntityRelationInput:{
		connect:"StaffUniqueWhere",
		create:"StaffWithoutShiftsProfileCreateInput"
	},
	StaffWithoutShiftsProfileCreateInput:{
		id:"UUID",
		bartender:"StaffCreateBartenderEntityRelationInput",
		courier:"StaffCreateCourierEntityRelationInput",
		cleaner:"StaffCreateCleanerEntityRelationInput",
		shiftsManager:"StaffCreateShiftsManagerEntityRelationInput",
		businessToBusinessManager:"StaffCreateBusinessToBusinessManagerEntityRelationInput",
		user:"StaffCreateUserEntityRelationInput",
		stocksManager:"StaffCreateStocksManagerEntityRelationInput",
		photo:"StaffCreatePhotoEntityRelationInput",
		courierManager:"StaffCreateCourierManagerEntityRelationInput",
		picker:"StaffCreatePickerEntityRelationInput",
		createdAt:"DateTime",
		remunerationProfile:"StaffCreateRemunerationProfileEntityRelationInput",
		cashier:"StaffCreateCashierEntityRelationInput",
		venues:"StaffCreateVenuesEntityRelationInput",
		internalBuyer:"StaffCreateInternalBuyerEntityRelationInput",
		salesManager:"StaffCreateSalesManagerEntityRelationInput",
		cashierManager:"StaffCreateCashierManagerEntityRelationInput"
	},
	StaffCreateBusinessToBusinessManagerEntityRelationInput:{
		connect:"BusinessToBusinessManagerUniqueWhere",
		create:"BusinessToBusinessManagerWithoutStaffCreateInput"
	},
	BusinessToBusinessManagerWithoutStaffCreateInput:{
		id:"UUID",
		managedBusinesses:"BusinessToBusinessManagerCreateManagedBusinessesEntityRelationInput",
		createdAt:"DateTime"
	},
	BusinessToBusinessManagerCreateManagedBusinessesEntityRelationInput:{
		connect:"BusinessCustomerUniqueWhere",
		create:"BusinessCustomerWithoutAccountManagerCreateInput"
	},
	BusinessCustomerWithoutAccountManagerCreateInput:{
		id:"UUID",
		customer:"BusinessCustomerCreateCustomerEntityRelationInput",
		owners:"BusinessCustomerCreateOwnersEntityRelationInput",
		members:"BusinessCustomerCreateMembersEntityRelationInput",
		category:"BusinessCustomerCreateCategoryEntityRelationInput",
		logo:"BusinessCustomerCreateLogoEntityRelationInput",
		businessServiceEvents:"BusinessCustomerCreateBusinessServiceEventsEntityRelationInput",
		doubleshotCoffeeEquipment:"BusinessCustomerCreateDoubleshotCoffeeEquipmentEntityRelationInput"
	},
	BusinessCustomerCreateMembersEntityRelationInput:{
		connect:"CustomerUniqueWhere",
		create:"CustomerWithoutMemberOfBusinessesCreateInput"
	},
	CustomerWithoutMemberOfBusinessesCreateInput:{
		id:"UUID",
		addresses:"CustomerCreateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerCreateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerCreateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerCreateTagsEntityRelationInput",
		credits:"CustomerCreateCreditsEntityRelationInput",
		paymentMethods:"CustomerCreatePaymentMethodsEntityRelationInput",
		orders:"CustomerCreateOrdersEntityRelationInput",
		permissions:"CustomerCreatePermissionsEntityRelationInput",
		group:"CustomerCreateGroupEntityRelationInput",
		photo:"CustomerCreatePhotoEntityRelationInput",
		name:"CustomerCreateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerCreateIngredientRatingsEntityRelationInput",
		business:"CustomerCreateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerCreateOwnerOfBusinessesEntityRelationInput",
		carts:"CustomerCreateCartsEntityRelationInput",
		shortcutList:"CustomerCreateShortcutListEntityRelationInput",
		user:"CustomerCreateUserEntityRelationInput",
		channels:"CustomerCreateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerCreateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerCreateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerCreateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerCreateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerCreateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerCreateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerCreateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerCreateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerCreateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerCreateRedeemedVouchersEntityRelationInput",
		spending:"CustomerCreateSpendingEntityRelationInput",
		customerTabs:"CustomerCreateCustomerTabsEntityRelationInput",
		lead:"CustomerCreateLeadEntityRelationInput",
		meta:"CustomerCreateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerCreateOwnerOfBusinessesEntityRelationInput:{
		connect:"BusinessCustomerUniqueWhere",
		create:"BusinessCustomerWithoutOwnersCreateInput"
	},
	BusinessCustomerWithoutOwnersCreateInput:{
		id:"UUID",
		customer:"BusinessCustomerCreateCustomerEntityRelationInput",
		members:"BusinessCustomerCreateMembersEntityRelationInput",
		category:"BusinessCustomerCreateCategoryEntityRelationInput",
		accountManager:"BusinessCustomerCreateAccountManagerEntityRelationInput",
		logo:"BusinessCustomerCreateLogoEntityRelationInput",
		businessServiceEvents:"BusinessCustomerCreateBusinessServiceEventsEntityRelationInput",
		doubleshotCoffeeEquipment:"BusinessCustomerCreateDoubleshotCoffeeEquipmentEntityRelationInput"
	},
	BusinessCustomerCreateAccountManagerEntityRelationInput:{
		connect:"BusinessToBusinessManagerUniqueWhere",
		create:"BusinessToBusinessManagerWithoutManagedBusinessesCreateInput"
	},
	BusinessToBusinessManagerWithoutManagedBusinessesCreateInput:{
		id:"UUID",
		staff:"BusinessToBusinessManagerCreateStaffEntityRelationInput",
		createdAt:"DateTime"
	},
	BusinessToBusinessManagerCreateStaffEntityRelationInput:{
		connect:"StaffUniqueWhere",
		create:"StaffWithoutBusinessToBusinessManagerCreateInput"
	},
	StaffWithoutBusinessToBusinessManagerCreateInput:{
		id:"UUID",
		bartender:"StaffCreateBartenderEntityRelationInput",
		courier:"StaffCreateCourierEntityRelationInput",
		cleaner:"StaffCreateCleanerEntityRelationInput",
		shiftsManager:"StaffCreateShiftsManagerEntityRelationInput",
		user:"StaffCreateUserEntityRelationInput",
		shiftsProfile:"StaffCreateShiftsProfileEntityRelationInput",
		stocksManager:"StaffCreateStocksManagerEntityRelationInput",
		photo:"StaffCreatePhotoEntityRelationInput",
		courierManager:"StaffCreateCourierManagerEntityRelationInput",
		picker:"StaffCreatePickerEntityRelationInput",
		createdAt:"DateTime",
		remunerationProfile:"StaffCreateRemunerationProfileEntityRelationInput",
		cashier:"StaffCreateCashierEntityRelationInput",
		venues:"StaffCreateVenuesEntityRelationInput",
		internalBuyer:"StaffCreateInternalBuyerEntityRelationInput",
		salesManager:"StaffCreateSalesManagerEntityRelationInput",
		cashierManager:"StaffCreateCashierManagerEntityRelationInput"
	},
	StaffCreateUserEntityRelationInput:{
		connect:"UserUniqueWhere",
		create:"UserWithoutStaffCreateInput"
	},
	UserWithoutStaffCreateInput:{
		id:"UUID",
		customer:"UserCreateCustomerEntityRelationInput",
		tenantPersonId:"UUID",
		disabledAt:"DateTime",
		devices:"UserCreateDevicesEntityRelationInput",
		verifiedAt:"DateTime",
		createdAt:"DateTime",
		deletionRequestedAt:"DateTime",
		deletionExpectedAt:"DateTime",
		deletedAt:"DateTime",
		meta:"UserCreateMetaEntityRelationInput",
		identificationAttempts:"UserCreateIdentificationAttemptsEntityRelationInput",
		roles:"UserCreateRolesEntityRelationInput"
	},
	UserCreateCustomerEntityRelationInput:{
		connect:"CustomerUniqueWhere",
		create:"CustomerWithoutUserCreateInput"
	},
	CustomerWithoutUserCreateInput:{
		id:"UUID",
		addresses:"CustomerCreateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerCreateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerCreateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerCreateTagsEntityRelationInput",
		credits:"CustomerCreateCreditsEntityRelationInput",
		paymentMethods:"CustomerCreatePaymentMethodsEntityRelationInput",
		orders:"CustomerCreateOrdersEntityRelationInput",
		permissions:"CustomerCreatePermissionsEntityRelationInput",
		group:"CustomerCreateGroupEntityRelationInput",
		photo:"CustomerCreatePhotoEntityRelationInput",
		name:"CustomerCreateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerCreateIngredientRatingsEntityRelationInput",
		business:"CustomerCreateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerCreateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerCreateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerCreateCartsEntityRelationInput",
		shortcutList:"CustomerCreateShortcutListEntityRelationInput",
		channels:"CustomerCreateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerCreateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerCreateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerCreateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerCreateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerCreateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerCreateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerCreateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerCreateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerCreateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerCreateRedeemedVouchersEntityRelationInput",
		spending:"CustomerCreateSpendingEntityRelationInput",
		customerTabs:"CustomerCreateCustomerTabsEntityRelationInput",
		lead:"CustomerCreateLeadEntityRelationInput",
		meta:"CustomerCreateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerCreateCartsEntityRelationInput:{
		connect:"CartUniqueWhere",
		create:"CartWithoutCustomerCreateInput"
	},
	CartWithoutCustomerCreateInput:{
		id:"UUID",
		confirmedAt:"DateTime",
		deletedAt:"DateTime",
		items:"CartCreateItemsEntityRelationInput",
		state:"CartState",
		createdAt:"DateTime",
		channel:"CartCreateChannelEntityRelationInput",
		order:"CartCreateOrderEntityRelationInput",
		deliveryAddress:"CartCreateDeliveryAddressEntityRelationInput",
		billingAddress:"CartCreateBillingAddressEntityRelationInput",
		delivery:"CartCreateDeliveryEntityRelationInput",
		payment:"CartCreatePaymentEntityRelationInput",
		billingSubject:"CartCreateBillingSubjectEntityRelationInput",
		priceLines:"CartCreatePriceLinesEntityRelationInput",
		summary:"CartCreateSummaryEntityRelationInput"
	},
	CartCreateOrderEntityRelationInput:{
		connect:"OrderUniqueWhere",
		create:"OrderWithoutCartCreateInput"
	},
	OrderWithoutCartCreateInput:{
		id:"UUID",
		state:"OrderState",
		fulfilledAt:"DateTime",
		canceledAt:"DateTime",
		customer:"OrderCreateCustomerEntityRelationInput",
		channel:"OrderCreateChannelEntityRelationInput",
		discounts:"OrderCreateDiscountsEntityRelationInput",
		delivery:"OrderCreateDeliveryEntityRelationInput",
		items:"OrderCreateItemsEntityRelationInput",
		events:"OrderCreateEventsEntityRelationInput",
		createdAt:"DateTime",
		billingAddress:"OrderCreateBillingAddressEntityRelationInput",
		priceLines:"OrderCreatePriceLinesEntityRelationInput",
		payments:"OrderCreatePaymentsEntityRelationInput",
		billingSubject:"OrderCreateBillingSubjectEntityRelationInput",
		summary:"OrderCreateSummaryEntityRelationInput",
		gratuity:"OrderCreateGratuityEntityRelationInput",
		venue:"OrderCreateVenueEntityRelationInput",
		fulfillmentNotes:"OrderCreateFulfillmentNotesEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	OrderCreateCustomerEntityRelationInput:{
		connect:"CustomerUniqueWhere",
		create:"CustomerWithoutOrdersCreateInput"
	},
	CustomerWithoutOrdersCreateInput:{
		id:"UUID",
		addresses:"CustomerCreateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerCreateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerCreateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerCreateTagsEntityRelationInput",
		credits:"CustomerCreateCreditsEntityRelationInput",
		paymentMethods:"CustomerCreatePaymentMethodsEntityRelationInput",
		permissions:"CustomerCreatePermissionsEntityRelationInput",
		group:"CustomerCreateGroupEntityRelationInput",
		photo:"CustomerCreatePhotoEntityRelationInput",
		name:"CustomerCreateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerCreateIngredientRatingsEntityRelationInput",
		business:"CustomerCreateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerCreateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerCreateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerCreateCartsEntityRelationInput",
		shortcutList:"CustomerCreateShortcutListEntityRelationInput",
		user:"CustomerCreateUserEntityRelationInput",
		channels:"CustomerCreateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerCreateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerCreateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerCreateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerCreateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerCreateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerCreateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerCreateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerCreateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerCreateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerCreateRedeemedVouchersEntityRelationInput",
		spending:"CustomerCreateSpendingEntityRelationInput",
		customerTabs:"CustomerCreateCustomerTabsEntityRelationInput",
		lead:"CustomerCreateLeadEntityRelationInput",
		meta:"CustomerCreateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerCreateShortcutListEntityRelationInput:{
		connect:"ApplicationShortcutListUniqueWhere",
		create:"ApplicationShortcutListWithoutCustomerCreateInput"
	},
	ApplicationShortcutListWithoutCustomerCreateInput:{
		id:"UUID",
		items:"ApplicationShortcutListCreateItemsEntityRelationInput"
	},
	ApplicationShortcutListCreateItemsEntityRelationInput:{
		connect:"ApplicationShortcutListItemUniqueWhere",
		create:"ApplicationShortcutListItemWithoutListCreateInput"
	},
	ApplicationShortcutListItemWithoutListCreateInput:{
		id:"UUID",
		application:"ApplicationShortcutListItemCreateApplicationEntityRelationInput"
	},
	ApplicationShortcutListItemCreateApplicationEntityRelationInput:{
		connect:"ApplicationUniqueWhere",
		create:"ApplicationCreateInput"
	},
	ApplicationUniqueWhere:{
		id:"UUID",
		icon:"ImageUniqueWhere"
	},
	ApplicationCreateInput:{
		id:"UUID",
		icon:"ApplicationCreateIconEntityRelationInput"
	},
	ApplicationCreateIconEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	CustomerCreateUserEntityRelationInput:{
		connect:"UserUniqueWhere",
		create:"UserWithoutCustomerCreateInput"
	},
	UserWithoutCustomerCreateInput:{
		id:"UUID",
		staff:"UserCreateStaffEntityRelationInput",
		tenantPersonId:"UUID",
		disabledAt:"DateTime",
		devices:"UserCreateDevicesEntityRelationInput",
		verifiedAt:"DateTime",
		createdAt:"DateTime",
		deletionRequestedAt:"DateTime",
		deletionExpectedAt:"DateTime",
		deletedAt:"DateTime",
		meta:"UserCreateMetaEntityRelationInput",
		identificationAttempts:"UserCreateIdentificationAttemptsEntityRelationInput",
		roles:"UserCreateRolesEntityRelationInput"
	},
	UserCreateStaffEntityRelationInput:{
		connect:"StaffUniqueWhere",
		create:"StaffWithoutUserCreateInput"
	},
	StaffWithoutUserCreateInput:{
		id:"UUID",
		bartender:"StaffCreateBartenderEntityRelationInput",
		courier:"StaffCreateCourierEntityRelationInput",
		cleaner:"StaffCreateCleanerEntityRelationInput",
		shiftsManager:"StaffCreateShiftsManagerEntityRelationInput",
		businessToBusinessManager:"StaffCreateBusinessToBusinessManagerEntityRelationInput",
		shiftsProfile:"StaffCreateShiftsProfileEntityRelationInput",
		stocksManager:"StaffCreateStocksManagerEntityRelationInput",
		photo:"StaffCreatePhotoEntityRelationInput",
		courierManager:"StaffCreateCourierManagerEntityRelationInput",
		picker:"StaffCreatePickerEntityRelationInput",
		createdAt:"DateTime",
		remunerationProfile:"StaffCreateRemunerationProfileEntityRelationInput",
		cashier:"StaffCreateCashierEntityRelationInput",
		venues:"StaffCreateVenuesEntityRelationInput",
		internalBuyer:"StaffCreateInternalBuyerEntityRelationInput",
		salesManager:"StaffCreateSalesManagerEntityRelationInput",
		cashierManager:"StaffCreateCashierManagerEntityRelationInput"
	},
	StaffCreateShiftsProfileEntityRelationInput:{
		connect:"ShiftsProfileUniqueWhere",
		create:"ShiftsProfileWithoutStaffCreateInput"
	},
	ShiftsProfileWithoutStaffCreateInput:{
		id:"UUID",
		queueItems:"ShiftsProfileCreateQueueItemsEntityRelationInput",
		roles:"ShiftsProfileCreateRolesEntityRelationInput",
		shifts:"ShiftsProfileCreateShiftsEntityRelationInput"
	},
	ShiftsProfileCreateRolesEntityRelationInput:{
		connect:"TimetableEmployeeRoleUniqueWhere",
		create:"TimetableEmployeeRoleWithoutShiftsProfilesCreateInput"
	},
	TimetableEmployeeRoleWithoutShiftsProfilesCreateInput:{
		id:"UUID",
		shiftGroups:"TimetableEmployeeRoleCreateShiftGroupsEntityRelationInput",
		shiftsManagers:"TimetableEmployeeRoleCreateShiftsManagersEntityRelationInput",
		timetableTemplates:"TimetableEmployeeRoleCreateTimetableTemplatesEntityRelationInput"
	},
	TimetableEmployeeRoleCreateShiftsManagersEntityRelationInput:{
		connect:"ShiftsManagerUniqueWhere",
		create:"ShiftsManagerWithoutManagedRolesCreateInput"
	},
	ShiftsManagerWithoutManagedRolesCreateInput:{
		id:"UUID",
		staff:"ShiftsManagerCreateStaffEntityRelationInput",
		createdAt:"DateTime"
	},
	ShiftsManagerCreateStaffEntityRelationInput:{
		connect:"StaffUniqueWhere",
		create:"StaffWithoutShiftsManagerCreateInput"
	},
	StaffWithoutShiftsManagerCreateInput:{
		id:"UUID",
		bartender:"StaffCreateBartenderEntityRelationInput",
		courier:"StaffCreateCourierEntityRelationInput",
		cleaner:"StaffCreateCleanerEntityRelationInput",
		businessToBusinessManager:"StaffCreateBusinessToBusinessManagerEntityRelationInput",
		user:"StaffCreateUserEntityRelationInput",
		shiftsProfile:"StaffCreateShiftsProfileEntityRelationInput",
		stocksManager:"StaffCreateStocksManagerEntityRelationInput",
		photo:"StaffCreatePhotoEntityRelationInput",
		courierManager:"StaffCreateCourierManagerEntityRelationInput",
		picker:"StaffCreatePickerEntityRelationInput",
		createdAt:"DateTime",
		remunerationProfile:"StaffCreateRemunerationProfileEntityRelationInput",
		cashier:"StaffCreateCashierEntityRelationInput",
		venues:"StaffCreateVenuesEntityRelationInput",
		internalBuyer:"StaffCreateInternalBuyerEntityRelationInput",
		salesManager:"StaffCreateSalesManagerEntityRelationInput",
		cashierManager:"StaffCreateCashierManagerEntityRelationInput"
	},
	StaffCreateStocksManagerEntityRelationInput:{
		connect:"StocksManagerUniqueWhere",
		create:"StocksManagerWithoutStaffCreateInput"
	},
	StocksManagerWithoutStaffCreateInput:{
		id:"UUID",
		managedProducts:"StocksManagerCreateManagedProductsEntityRelationInput",
		createdAt:"DateTime"
	},
	StocksManagerCreateManagedProductsEntityRelationInput:{
		connect:"ProductUniqueWhere",
		create:"ProductWithoutManagerCreateInput"
	},
	ProductWithoutManagerCreateInput:{
		id:"UUID",
		packing:"ProductCreatePackingEntityRelationInput",
		recipe:"ProductCreateRecipeEntityRelationInput",
		tags:"ProductCreateTagsEntityRelationInput",
		categories:"ProductCreateCategoriesEntityRelationInput",
		vatRate:"ProductCreateVatRateEntityRelationInput",
		stocks:"ProductCreateStocksEntityRelationInput",
		groupPrices:"ProductCreateGroupPricesEntityRelationInput",
		image:"ProductCreateImageEntityRelationInput",
		cartItems:"ProductCreateCartItemsEntityRelationInput",
		availability:"ProductAvailability",
		orderItems:"ProductCreateOrderItemsEntityRelationInput",
		inheritedCategories:"ProductCreateInheritedCategoriesEntityRelationInput",
		deliveryZones:"ProductCreateDeliveryZonesEntityRelationInput",
		locales:"ProductCreateLocalesEntityRelationInput",
		archivedAt:"DateTime",
		customerPrices:"ProductCreateCustomerPricesEntityRelationInput",
		virtualProduct:"ProductCreateVirtualProductEntityRelationInput",
		meta:"ProductCreateMetaEntityRelationInput",
		page:"ProductCreatePageEntityRelationInput",
		salesDays:"ProductCreateSalesDaysEntityRelationInput",
		salesWeeks:"ProductCreateSalesWeeksEntityRelationInput",
		salesMonths:"ProductCreateSalesMonthsEntityRelationInput",
		fulfillmentNotes:"ProductCreateFulfillmentNotesEntityRelationInput"
	},
	ProductCreateOrderItemsEntityRelationInput:{
		connect:"OrderItemUniqueWhere",
		create:"OrderItemWithoutProductCreateInput"
	},
	OrderItemWithoutProductCreateInput:{
		id:"UUID",
		vatRate:"OrderItemCreateVatRateEntityRelationInput",
		order:"OrderItemCreateOrderEntityRelationInput",
		virtualProductEffects:"OrderItemCreateVirtualProductEffectsEntityRelationInput",
		pickedAt:"DateTime",
		fulfillmentNotes:"OrderItemCreateFulfillmentNotesEntityRelationInput"
	},
	OrderItemCreateVatRateEntityRelationInput:{
		connect:"VatRateUniqueWhere",
		create:"VatRateCreateInput"
	},
	OrderItemCreateOrderEntityRelationInput:{
		connect:"OrderUniqueWhere",
		create:"OrderWithoutItemsCreateInput"
	},
	OrderWithoutItemsCreateInput:{
		id:"UUID",
		state:"OrderState",
		fulfilledAt:"DateTime",
		canceledAt:"DateTime",
		customer:"OrderCreateCustomerEntityRelationInput",
		channel:"OrderCreateChannelEntityRelationInput",
		discounts:"OrderCreateDiscountsEntityRelationInput",
		delivery:"OrderCreateDeliveryEntityRelationInput",
		cart:"OrderCreateCartEntityRelationInput",
		events:"OrderCreateEventsEntityRelationInput",
		createdAt:"DateTime",
		billingAddress:"OrderCreateBillingAddressEntityRelationInput",
		priceLines:"OrderCreatePriceLinesEntityRelationInput",
		payments:"OrderCreatePaymentsEntityRelationInput",
		billingSubject:"OrderCreateBillingSubjectEntityRelationInput",
		summary:"OrderCreateSummaryEntityRelationInput",
		gratuity:"OrderCreateGratuityEntityRelationInput",
		venue:"OrderCreateVenueEntityRelationInput",
		fulfillmentNotes:"OrderCreateFulfillmentNotesEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	OrderCreateDiscountsEntityRelationInput:{
		connect:"OrderDiscountUniqueWhere",
		create:"OrderDiscountWithoutOrderCreateInput"
	},
	OrderDiscountWithoutOrderCreateInput:{
		id:"UUID",
		vatRate:"OrderDiscountCreateVatRateEntityRelationInput",
		type:"OrderDiscountType",
		customerCreditTransactions:"OrderDiscountCreateCustomerCreditTransactionsEntityRelationInput",
		voucherRedemption:"OrderDiscountCreateVoucherRedemptionEntityRelationInput"
	},
	OrderDiscountCreateVatRateEntityRelationInput:{
		connect:"VatRateUniqueWhere",
		create:"VatRateCreateInput"
	},
	OrderDiscountCreateCustomerCreditTransactionsEntityRelationInput:{
		connect:"CustomerCreditTransactionUniqueWhere",
		create:"CustomerCreditTransactionWithoutOrderDiscountCreateInput"
	},
	CustomerCreditTransactionWithoutOrderDiscountCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		customerCredit:"CustomerCreditTransactionCreateCustomerCreditEntityRelationInput",
		virtualProductEffect:"CustomerCreditTransactionCreateVirtualProductEffectEntityRelationInput"
	},
	CustomerCreditTransactionCreateCustomerCreditEntityRelationInput:{
		connect:"CustomerCreditUniqueWhere",
		create:"CustomerCreditWithoutTransactionsCreateInput"
	},
	CustomerCreditWithoutTransactionsCreateInput:{
		id:"UUID",
		expiresAt:"DateTime",
		customer:"CustomerCreditCreateCustomerEntityRelationInput",
		vatRate:"CustomerCreditCreateVatRateEntityRelationInput",
		createdAt:"DateTime",
		voucherRedemption:"CustomerCreditCreateVoucherRedemptionEntityRelationInput"
	},
	CustomerCreditCreateCustomerEntityRelationInput:{
		connect:"CustomerUniqueWhere",
		create:"CustomerWithoutCreditsCreateInput"
	},
	CustomerWithoutCreditsCreateInput:{
		id:"UUID",
		addresses:"CustomerCreateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerCreateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerCreateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerCreateTagsEntityRelationInput",
		paymentMethods:"CustomerCreatePaymentMethodsEntityRelationInput",
		orders:"CustomerCreateOrdersEntityRelationInput",
		permissions:"CustomerCreatePermissionsEntityRelationInput",
		group:"CustomerCreateGroupEntityRelationInput",
		photo:"CustomerCreatePhotoEntityRelationInput",
		name:"CustomerCreateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerCreateIngredientRatingsEntityRelationInput",
		business:"CustomerCreateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerCreateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerCreateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerCreateCartsEntityRelationInput",
		shortcutList:"CustomerCreateShortcutListEntityRelationInput",
		user:"CustomerCreateUserEntityRelationInput",
		channels:"CustomerCreateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerCreateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerCreateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerCreateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerCreateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerCreateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerCreateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerCreateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerCreateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerCreateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerCreateRedeemedVouchersEntityRelationInput",
		spending:"CustomerCreateSpendingEntityRelationInput",
		customerTabs:"CustomerCreateCustomerTabsEntityRelationInput",
		lead:"CustomerCreateLeadEntityRelationInput",
		meta:"CustomerCreateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerCreateChannelsEntityRelationInput:{
		connect:"ChannelUniqueWhere",
		create:"ChannelWithoutCustomersCreateInput"
	},
	ChannelWithoutCustomersCreateInput:{
		id:"UUID",
		payments:"ChannelCreatePaymentsEntityRelationInput",
		deliveries:"ChannelCreateDeliveriesEntityRelationInput",
		pointOfSales:"ChannelCreatePointOfSalesEntityRelationInput",
		carts:"ChannelCreateCartsEntityRelationInput",
		code:"ChannelCode",
		addTagsOnRegistration:"ChannelCreateAddTagsOnRegistrationEntityRelationInput",
		publicTags:"ChannelCreatePublicTagsEntityRelationInput",
		venue:"ChannelCreateVenueEntityRelationInput"
	},
	ChannelCreatePublicTagsEntityRelationInput:{
		connect:"TagUniqueWhere",
		create:"TagWithoutPublicInChannelsCreateInput"
	},
	TagWithoutPublicInChannelsCreateInput:{
		id:"UUID",
		customers:"TagCreateCustomersEntityRelationInput",
		products:"TagCreateProductsEntityRelationInput",
		categories:"TagCreateCategoriesEntityRelationInput",
		addTagsOnRegistration:"TagCreateAddTagsOnRegistrationEntityRelationInput",
		nestedCategories:"TagCreateNestedCategoriesEntityRelationInput",
		deliveryZones:"TagCreateDeliveryZonesEntityRelationInput",
		allowChannelPayments:"TagCreateAllowChannelPaymentsEntityRelationInput",
		fulfillmentNotes:"TagCreateFulfillmentNotesEntityRelationInput"
	},
	TagCreateAllowChannelPaymentsEntityRelationInput:{
		connect:"ChannelPaymentUniqueWhere",
		create:"ChannelPaymentWithoutAllowOnlyForTagsCreateInput"
	},
	ChannelPaymentWithoutAllowOnlyForTagsCreateInput:{
		id:"UUID",
		channel:"ChannelPaymentCreateChannelEntityRelationInput",
		method:"ChannelPaymentCreateMethodEntityRelationInput",
		vatRate:"ChannelPaymentCreateVatRateEntityRelationInput"
	},
	ChannelPaymentCreateVatRateEntityRelationInput:{
		connect:"VatRateUniqueWhere",
		create:"VatRateWithoutChannelPaymentsCreateInput"
	},
	VatRateWithoutChannelPaymentsCreateInput:{
		id:"UUID",
		channelDeliveries:"VatRateCreateChannelDeliveriesEntityRelationInput",
		preset:"VatRatePreset"
	},
	TagCreateFulfillmentNotesEntityRelationInput:{
		connect:"FulfillmentNoteUniqueWhere",
		create:"FulfillmentNoteWithoutTagsCreateInput"
	},
	FulfillmentNoteUniqueWhere:{
		id:"UUID"
	},
	FulfillmentNoteWithoutTagsCreateInput:{
		id:"UUID",
		products:"FulfillmentNoteCreateProductsEntityRelationInput",
		venues:"FulfillmentNoteCreateVenuesEntityRelationInput",
		cartItems:"FulfillmentNoteCreateCartItemsEntityRelationInput",
		orderItems:"FulfillmentNoteCreateOrderItemsEntityRelationInput",
		orders:"FulfillmentNoteCreateOrdersEntityRelationInput",
		createdAt:"DateTime"
	},
	FulfillmentNoteCreateProductsEntityRelationInput:{
		connect:"ProductUniqueWhere",
		create:"ProductWithoutFulfillmentNotesCreateInput"
	},
	ProductWithoutFulfillmentNotesCreateInput:{
		id:"UUID",
		packing:"ProductCreatePackingEntityRelationInput",
		recipe:"ProductCreateRecipeEntityRelationInput",
		tags:"ProductCreateTagsEntityRelationInput",
		categories:"ProductCreateCategoriesEntityRelationInput",
		vatRate:"ProductCreateVatRateEntityRelationInput",
		stocks:"ProductCreateStocksEntityRelationInput",
		groupPrices:"ProductCreateGroupPricesEntityRelationInput",
		image:"ProductCreateImageEntityRelationInput",
		cartItems:"ProductCreateCartItemsEntityRelationInput",
		availability:"ProductAvailability",
		manager:"ProductCreateManagerEntityRelationInput",
		orderItems:"ProductCreateOrderItemsEntityRelationInput",
		inheritedCategories:"ProductCreateInheritedCategoriesEntityRelationInput",
		deliveryZones:"ProductCreateDeliveryZonesEntityRelationInput",
		locales:"ProductCreateLocalesEntityRelationInput",
		archivedAt:"DateTime",
		customerPrices:"ProductCreateCustomerPricesEntityRelationInput",
		virtualProduct:"ProductCreateVirtualProductEntityRelationInput",
		meta:"ProductCreateMetaEntityRelationInput",
		page:"ProductCreatePageEntityRelationInput",
		salesDays:"ProductCreateSalesDaysEntityRelationInput",
		salesWeeks:"ProductCreateSalesWeeksEntityRelationInput",
		salesMonths:"ProductCreateSalesMonthsEntityRelationInput"
	},
	ProductCreateInheritedCategoriesEntityRelationInput:{
		connect:"NestedProductCategoryProductUniqueWhere"
	},
	ProductCreateDeliveryZonesEntityRelationInput:{
		connect:"DeliveryZoneUniqueWhere",
		create:"DeliveryZoneWithoutDeliveryZonesOfProductsCreateInput"
	},
	DeliveryZoneWithoutDeliveryZonesOfProductsCreateInput:{
		id:"UUID",
		type:"DeliveryZoneType",
		addresses:"DeliveryZoneCreateAddressesEntityRelationInput",
		suitableDeliveryMethods:"DeliveryZoneCreateSuitableDeliveryMethodsEntityRelationInput",
		deliveryZonesOfTags:"DeliveryZoneCreateDeliveryZonesOfTagsEntityRelationInput",
		addressesMetadata:"DeliveryZoneCreateAddressesMetadataEntityRelationInput"
	},
	DeliveryZoneCreateDeliveryZonesOfTagsEntityRelationInput:{
		connect:"TagUniqueWhere",
		create:"TagWithoutDeliveryZonesCreateInput"
	},
	TagWithoutDeliveryZonesCreateInput:{
		id:"UUID",
		customers:"TagCreateCustomersEntityRelationInput",
		products:"TagCreateProductsEntityRelationInput",
		categories:"TagCreateCategoriesEntityRelationInput",
		addTagsOnRegistration:"TagCreateAddTagsOnRegistrationEntityRelationInput",
		nestedCategories:"TagCreateNestedCategoriesEntityRelationInput",
		publicInChannels:"TagCreatePublicInChannelsEntityRelationInput",
		allowChannelPayments:"TagCreateAllowChannelPaymentsEntityRelationInput",
		fulfillmentNotes:"TagCreateFulfillmentNotesEntityRelationInput"
	},
	TagCreatePublicInChannelsEntityRelationInput:{
		connect:"ChannelUniqueWhere",
		create:"ChannelWithoutPublicTagsCreateInput"
	},
	ChannelWithoutPublicTagsCreateInput:{
		id:"UUID",
		payments:"ChannelCreatePaymentsEntityRelationInput",
		deliveries:"ChannelCreateDeliveriesEntityRelationInput",
		pointOfSales:"ChannelCreatePointOfSalesEntityRelationInput",
		carts:"ChannelCreateCartsEntityRelationInput",
		customers:"ChannelCreateCustomersEntityRelationInput",
		code:"ChannelCode",
		addTagsOnRegistration:"ChannelCreateAddTagsOnRegistrationEntityRelationInput",
		venue:"ChannelCreateVenueEntityRelationInput"
	},
	ChannelCreateVenueEntityRelationInput:{
		connect:"VenueUniqueWhere",
		create:"VenueWithoutChannelsCreateInput"
	},
	VenueWithoutChannelsCreateInput:{
		id:"UUID",
		deadlineTemplate:"VenueCreateDeadlineTemplateEntityRelationInput",
		timetableDays:"VenueCreateTimetableDaysEntityRelationInput",
		timetableTemplates:"VenueCreateTimetableTemplatesEntityRelationInput",
		staffMembers:"VenueCreateStaffMembersEntityRelationInput",
		employeeRoles:"VenueCreateEmployeeRolesEntityRelationInput",
		pointOfSaleApplicationDevices:"VenueCreatePointOfSaleApplicationDevicesEntityRelationInput",
		pointOfSaleTerminals:"VenueCreatePointOfSaleTerminalsEntityRelationInput",
		pointOfSalePrinters:"VenueCreatePointOfSalePrintersEntityRelationInput",
		orders:"VenueCreateOrdersEntityRelationInput",
		fulfillmentNotes:"VenueCreateFulfillmentNotesEntityRelationInput",
		areas:"VenueCreateAreasEntityRelationInput",
		enabledUnassignReasons:"VenueCreateEnabledUnassignReasonsEntityRelationInput",
		categories:"VenueCreateCategoriesEntityRelationInput",
		pointOfSaleInitialView:"PointOfSaleInitialView"
	},
	VenueCreateDeadlineTemplateEntityRelationInput:{
		connect:"DeadlineTemplateUniqueWhere",
		create:"DeadlineTemplateWithoutVenueCreateInput"
	},
	DeadlineTemplateWithoutVenueCreateInput:{
		id:"UUID",
		startDate:"Date"
	},
	VenueCreateTimetableDaysEntityRelationInput:{
		connect:"TimetableDayUniqueWhere",
		create:"TimetableDayWithoutVenueCreateInput"
	},
	TimetableDayWithoutVenueCreateInput:{
		id:"UUID",
		date:"Date",
		type:"TimetableDayType",
		shiftGroups:"TimetableDayCreateShiftGroupsEntityRelationInput",
		notes:"TimetableDayCreateNotesEntityRelationInput",
		meta:"TimetableDayCreateMetaEntityRelationInput"
	},
	TimetableDayCreateShiftGroupsEntityRelationInput:{
		connect:"TimetableShiftGroupUniqueWhere",
		create:"TimetableShiftGroupWithoutDayCreateInput"
	},
	TimetableShiftGroupWithoutDayCreateInput:{
		id:"UUID",
		shifts:"TimetableShiftGroupCreateShiftsEntityRelationInput",
		type:"TimetableShiftGroupCreateTypeEntityRelationInput",
		position:"TimetableShiftGroupCreatePositionEntityRelationInput",
		queue:"TimetableShiftGroupCreateQueueEntityRelationInput",
		generatedByTemplate:"TimetableShiftGroupCreateGeneratedByTemplateEntityRelationInput"
	},
	TimetableShiftGroupCreateTypeEntityRelationInput:{
		connect:"TimetableEmployeeRoleUniqueWhere",
		create:"TimetableEmployeeRoleWithoutShiftGroupsCreateInput"
	},
	TimetableEmployeeRoleWithoutShiftGroupsCreateInput:{
		id:"UUID",
		shiftsProfiles:"TimetableEmployeeRoleCreateShiftsProfilesEntityRelationInput",
		shiftsManagers:"TimetableEmployeeRoleCreateShiftsManagersEntityRelationInput",
		timetableTemplates:"TimetableEmployeeRoleCreateTimetableTemplatesEntityRelationInput"
	},
	TimetableEmployeeRoleCreateTimetableTemplatesEntityRelationInput:{
		connect:"TimetableTemplateUniqueWhere",
		create:"TimetableTemplateWithoutEmployeeRoleCreateInput"
	},
	TimetableTemplateWithoutEmployeeRoleCreateInput:{
		id:"UUID",
		startDate:"Date",
		position:"TimetableTemplateCreatePositionEntityRelationInput",
		staffOptions:"TimetableTemplateCreateStaffOptionsEntityRelationInput",
		venue:"TimetableTemplateCreateVenueEntityRelationInput",
		type:"TemplateType"
	},
	TimetableTemplateCreatePositionEntityRelationInput:{
		connect:"TimetableShiftPositionUniqueWhere",
		create:"TimetableShiftPositionWithoutTimetableTemplatesCreateInput"
	},
	TimetableShiftPositionUniqueWhere:{
		id:"UUID",
		shiftGroups:"TimetableShiftGroupUniqueWhere",
		timetableTemplates:"TimetableTemplateUniqueWhere"
	},
	TimetableShiftPositionWithoutTimetableTemplatesCreateInput:{
		id:"UUID",
		shiftGroups:"TimetableShiftPositionCreateShiftGroupsEntityRelationInput"
	},
	TimetableShiftPositionCreateShiftGroupsEntityRelationInput:{
		connect:"TimetableShiftGroupUniqueWhere",
		create:"TimetableShiftGroupWithoutPositionCreateInput"
	},
	TimetableShiftGroupWithoutPositionCreateInput:{
		id:"UUID",
		shifts:"TimetableShiftGroupCreateShiftsEntityRelationInput",
		day:"TimetableShiftGroupCreateDayEntityRelationInput",
		type:"TimetableShiftGroupCreateTypeEntityRelationInput",
		queue:"TimetableShiftGroupCreateQueueEntityRelationInput",
		generatedByTemplate:"TimetableShiftGroupCreateGeneratedByTemplateEntityRelationInput"
	},
	TimetableShiftGroupCreateQueueEntityRelationInput:{
		connect:"EmployeeQueueUniqueWhere",
		create:"EmployeeQueueWithoutShiftGroupCreateInput"
	},
	EmployeeQueueWithoutShiftGroupCreateInput:{
		id:"UUID",
		items:"EmployeeQueueCreateItemsEntityRelationInput"
	},
	EmployeeQueueCreateItemsEntityRelationInput:{
		connect:"EmployeeQueueItemUniqueWhere",
		create:"EmployeeQueueItemWithoutQueueCreateInput"
	},
	EmployeeQueueItemWithoutQueueCreateInput:{
		id:"UUID",
		shiftsProfile:"EmployeeQueueItemCreateShiftsProfileEntityRelationInput",
		shift:"EmployeeQueueItemCreateShiftEntityRelationInput",
		unassignInfo:"EmployeeQueueItemCreateUnassignInfoEntityRelationInput",
		meta:"EmployeeQueueItemCreateMetaEntityRelationInput"
	},
	EmployeeQueueItemCreateShiftsProfileEntityRelationInput:{
		connect:"ShiftsProfileUniqueWhere",
		create:"ShiftsProfileWithoutQueueItemsCreateInput"
	},
	ShiftsProfileWithoutQueueItemsCreateInput:{
		id:"UUID",
		staff:"ShiftsProfileCreateStaffEntityRelationInput",
		roles:"ShiftsProfileCreateRolesEntityRelationInput",
		shifts:"ShiftsProfileCreateShiftsEntityRelationInput"
	},
	ShiftsProfileCreateShiftsEntityRelationInput:{
		connect:"TimetableShiftUniqueWhere",
		create:"TimetableShiftWithoutShiftsProfileCreateInput"
	},
	TimetableShiftWithoutShiftsProfileCreateInput:{
		id:"UUID",
		assigned:"Date",
		group:"TimetableShiftCreateGroupEntityRelationInput",
		queueItem:"TimetableShiftCreateQueueItemEntityRelationInput",
		swapInfo:"TimetableShiftCreateSwapInfoEntityRelationInput"
	},
	TimetableShiftCreateGroupEntityRelationInput:{
		connect:"TimetableShiftGroupUniqueWhere",
		create:"TimetableShiftGroupWithoutShiftsCreateInput"
	},
	TimetableShiftGroupWithoutShiftsCreateInput:{
		id:"UUID",
		day:"TimetableShiftGroupCreateDayEntityRelationInput",
		type:"TimetableShiftGroupCreateTypeEntityRelationInput",
		position:"TimetableShiftGroupCreatePositionEntityRelationInput",
		queue:"TimetableShiftGroupCreateQueueEntityRelationInput",
		generatedByTemplate:"TimetableShiftGroupCreateGeneratedByTemplateEntityRelationInput"
	},
	TimetableShiftGroupCreatePositionEntityRelationInput:{
		connect:"TimetableShiftPositionUniqueWhere",
		create:"TimetableShiftPositionWithoutShiftGroupsCreateInput"
	},
	TimetableShiftPositionWithoutShiftGroupsCreateInput:{
		id:"UUID",
		timetableTemplates:"TimetableShiftPositionCreateTimetableTemplatesEntityRelationInput"
	},
	TimetableShiftPositionCreateTimetableTemplatesEntityRelationInput:{
		connect:"TimetableTemplateUniqueWhere",
		create:"TimetableTemplateWithoutPositionCreateInput"
	},
	TimetableTemplateWithoutPositionCreateInput:{
		id:"UUID",
		startDate:"Date",
		staffOptions:"TimetableTemplateCreateStaffOptionsEntityRelationInput",
		venue:"TimetableTemplateCreateVenueEntityRelationInput",
		employeeRole:"TimetableTemplateCreateEmployeeRoleEntityRelationInput",
		type:"TemplateType"
	},
	TimetableTemplateCreateStaffOptionsEntityRelationInput:{
		connect:"TimetableTemplateStaffOptionsUniqueWhere",
		create:"TimetableTemplateStaffOptionsWithoutTimetableTemplateCreateInput"
	},
	TimetableTemplateStaffOptionsWithoutTimetableTemplateCreateInput:{
		id:"UUID",
		autoAssignedEmployee:"TimetableTemplateStaffOptionsCreateAutoAssignedEmployeeEntityRelationInput"
	},
	TimetableTemplateStaffOptionsCreateAutoAssignedEmployeeEntityRelationInput:{
		connect:"ShiftsProfileUniqueWhere",
		create:"ShiftsProfileCreateInput"
	},
	ShiftsProfileCreateInput:{
		id:"UUID",
		queueItems:"ShiftsProfileCreateQueueItemsEntityRelationInput",
		staff:"ShiftsProfileCreateStaffEntityRelationInput",
		roles:"ShiftsProfileCreateRolesEntityRelationInput",
		shifts:"ShiftsProfileCreateShiftsEntityRelationInput"
	},
	TimetableTemplateCreateVenueEntityRelationInput:{
		connect:"VenueUniqueWhere",
		create:"VenueWithoutTimetableTemplatesCreateInput"
	},
	VenueWithoutTimetableTemplatesCreateInput:{
		id:"UUID",
		deadlineTemplate:"VenueCreateDeadlineTemplateEntityRelationInput",
		timetableDays:"VenueCreateTimetableDaysEntityRelationInput",
		staffMembers:"VenueCreateStaffMembersEntityRelationInput",
		employeeRoles:"VenueCreateEmployeeRolesEntityRelationInput",
		pointOfSaleApplicationDevices:"VenueCreatePointOfSaleApplicationDevicesEntityRelationInput",
		pointOfSaleTerminals:"VenueCreatePointOfSaleTerminalsEntityRelationInput",
		pointOfSalePrinters:"VenueCreatePointOfSalePrintersEntityRelationInput",
		orders:"VenueCreateOrdersEntityRelationInput",
		fulfillmentNotes:"VenueCreateFulfillmentNotesEntityRelationInput",
		areas:"VenueCreateAreasEntityRelationInput",
		enabledUnassignReasons:"VenueCreateEnabledUnassignReasonsEntityRelationInput",
		categories:"VenueCreateCategoriesEntityRelationInput",
		channels:"VenueCreateChannelsEntityRelationInput",
		pointOfSaleInitialView:"PointOfSaleInitialView"
	},
	VenueCreateStaffMembersEntityRelationInput:{
		connect:"StaffUniqueWhere",
		create:"StaffWithoutVenuesCreateInput"
	},
	StaffWithoutVenuesCreateInput:{
		id:"UUID",
		bartender:"StaffCreateBartenderEntityRelationInput",
		courier:"StaffCreateCourierEntityRelationInput",
		cleaner:"StaffCreateCleanerEntityRelationInput",
		shiftsManager:"StaffCreateShiftsManagerEntityRelationInput",
		businessToBusinessManager:"StaffCreateBusinessToBusinessManagerEntityRelationInput",
		user:"StaffCreateUserEntityRelationInput",
		shiftsProfile:"StaffCreateShiftsProfileEntityRelationInput",
		stocksManager:"StaffCreateStocksManagerEntityRelationInput",
		photo:"StaffCreatePhotoEntityRelationInput",
		courierManager:"StaffCreateCourierManagerEntityRelationInput",
		picker:"StaffCreatePickerEntityRelationInput",
		createdAt:"DateTime",
		remunerationProfile:"StaffCreateRemunerationProfileEntityRelationInput",
		cashier:"StaffCreateCashierEntityRelationInput",
		internalBuyer:"StaffCreateInternalBuyerEntityRelationInput",
		salesManager:"StaffCreateSalesManagerEntityRelationInput",
		cashierManager:"StaffCreateCashierManagerEntityRelationInput"
	},
	StaffCreatePhotoEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	StaffCreateCourierManagerEntityRelationInput:{
		connect:"CourierManagerUniqueWhere",
		create:"CourierManagerWithoutStaffCreateInput"
	},
	CourierManagerWithoutStaffCreateInput:{
		id:"UUID",
		createdAt:"DateTime"
	},
	StaffCreatePickerEntityRelationInput:{
		connect:"PickerUniqueWhere",
		create:"PickerWithoutStaffCreateInput"
	},
	PickerWithoutStaffCreateInput:{
		id:"UUID",
		createdAt:"DateTime"
	},
	StaffCreateRemunerationProfileEntityRelationInput:{
		connect:"RemunerationProfileUniqueWhere",
		create:"RemunerationProfileWithoutStaffCreateInput"
	},
	RemunerationProfileWithoutStaffCreateInput:{
		id:"UUID",
		employmentInformation:"RemunerationProfileCreateEmploymentInformationEntityRelationInput",
		workMonths:"RemunerationProfileCreateWorkMonthsEntityRelationInput"
	},
	RemunerationProfileCreateEmploymentInformationEntityRelationInput:{
		connect:"EmploymentInformationUniqueWhere",
		create:"EmploymentInformationWithoutRemunerationProfilesCreateInput"
	},
	EmploymentInformationWithoutRemunerationProfilesCreateInput:{
		id:"UUID",
		type:"EmploymentType"
	},
	RemunerationProfileCreateWorkMonthsEntityRelationInput:{
		connect:"WorkMonthUniqueWhere",
		create:"WorkMonthWithoutRemunerationProfileCreateInput"
	},
	WorkMonthUniqueWhere:{
		id:"UUID",
		remunerationProfile:"RemunerationProfileUniqueWhere"
	},
	WorkMonthWithoutRemunerationProfileCreateInput:{
		id:"UUID"
	},
	StaffCreateCashierEntityRelationInput:{
		connect:"CashierUniqueWhere",
		create:"CashierWithoutStaffCreateInput"
	},
	CashierWithoutStaffCreateInput:{
		id:"UUID",
		createdAt:"DateTime"
	},
	StaffCreateInternalBuyerEntityRelationInput:{
		connect:"InternalBuyerUniqueWhere",
		create:"InternalBuyerWithoutStaffCreateInput"
	},
	InternalBuyerWithoutStaffCreateInput:{
		id:"UUID",
		createdAt:"DateTime"
	},
	StaffCreateSalesManagerEntityRelationInput:{
		connect:"SalesManagerUniqueWhere",
		create:"SalesManagerWithoutStaffCreateInput"
	},
	SalesManagerWithoutStaffCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		countries:"SalesManagerCreateCountriesEntityRelationInput"
	},
	SalesManagerCreateCountriesEntityRelationInput:{
		connect:"CountryUniqueWhere",
		create:"CountryCreateInput"
	},
	StaffCreateCashierManagerEntityRelationInput:{
		connect:"CashierManagerUniqueWhere",
		create:"CashierManagerWithoutStaffCreateInput"
	},
	CashierManagerWithoutStaffCreateInput:{
		id:"UUID",
		createdAt:"DateTime"
	},
	VenueCreateEmployeeRolesEntityRelationInput:{
		connect:"VenueEmployeeRoleUniqueWhere",
		create:"VenueEmployeeRoleWithoutVenueCreateInput"
	},
	VenueEmployeeRoleWithoutVenueCreateInput:{
		id:"UUID",
		employeePrivileges:"VenueEmployeeRoleCreateEmployeePrivilegesEntityRelationInput",
		role:"VenueEmployeeRoleCreateRoleEntityRelationInput"
	},
	VenueEmployeeRoleCreateEmployeePrivilegesEntityRelationInput:{
		connect:"TimetablesEmployeePrivilegesUniqueWhere",
		create:"TimetablesEmployeePrivilegesWithoutVenueEmployeeRoleCreateInput"
	},
	TimetablesEmployeePrivilegesWithoutVenueEmployeeRoleCreateInput:{
		id:"UUID"
	},
	VenueEmployeeRoleCreateRoleEntityRelationInput:{
		connect:"TimetableEmployeeRoleUniqueWhere",
		create:"TimetableEmployeeRoleCreateInput"
	},
	VenueCreatePointOfSaleApplicationDevicesEntityRelationInput:{
		connect:"PointOfSaleApplicationDeviceUniqueWhere",
		create:"PointOfSaleApplicationDeviceWithoutVenueCreateInput"
	},
	PointOfSaleApplicationDeviceWithoutVenueCreateInput:{
		id:"UUID",
		identificationCode:"PointOfSaleApplicationDeviceCreateIdentificationCodeEntityRelationInput",
		identifier:"PointOfSaleApplicationDeviceCreateIdentifierEntityRelationInput",
		terminal:"PointOfSaleApplicationDeviceCreateTerminalEntityRelationInput",
		receiptPrinter:"PointOfSaleApplicationDeviceCreateReceiptPrinterEntityRelationInput",
		ticketPrinters:"PointOfSaleApplicationDeviceCreateTicketPrintersEntityRelationInput"
	},
	PointOfSaleApplicationDeviceCreateIdentificationCodeEntityRelationInput:{
		connect:"IdentificationCodeUniqueWhere",
		create:"IdentificationCodeWithoutApplicationDevicesCreateInput"
	},
	IdentificationCodeWithoutApplicationDevicesCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		attempts:"IdentificationCodeCreateAttemptsEntityRelationInput",
		locales:"IdentificationCodeCreateLocalesEntityRelationInput"
	},
	IdentificationCodeCreateAttemptsEntityRelationInput:{
		connect:"IdentificationAttemptUniqueWhere",
		create:"IdentificationAttemptWithoutCodeCreateInput"
	},
	IdentificationAttemptWithoutCodeCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		user:"IdentificationAttemptCreateUserEntityRelationInput"
	},
	IdentificationAttemptCreateUserEntityRelationInput:{
		connect:"UserUniqueWhere",
		create:"UserWithoutIdentificationAttemptsCreateInput"
	},
	UserWithoutIdentificationAttemptsCreateInput:{
		id:"UUID",
		staff:"UserCreateStaffEntityRelationInput",
		customer:"UserCreateCustomerEntityRelationInput",
		tenantPersonId:"UUID",
		disabledAt:"DateTime",
		devices:"UserCreateDevicesEntityRelationInput",
		verifiedAt:"DateTime",
		createdAt:"DateTime",
		deletionRequestedAt:"DateTime",
		deletionExpectedAt:"DateTime",
		deletedAt:"DateTime",
		meta:"UserCreateMetaEntityRelationInput",
		roles:"UserCreateRolesEntityRelationInput"
	},
	UserCreateDevicesEntityRelationInput:{
		connect:"UserDeviceUniqueWhere",
		create:"UserDeviceWithoutUserCreateInput"
	},
	UserDeviceWithoutUserCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		lastActiveAt:"DateTime",
		anonymousSession:"UserDeviceCreateAnonymousSessionEntityRelationInput"
	},
	UserDeviceCreateAnonymousSessionEntityRelationInput:{
		connect:"AnonymousSessionUniqueWhere",
		create:"AnonymousSessionWithoutDevicesCreateInput"
	},
	AnonymousSessionWithoutDevicesCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		lastActiveAt:"DateTime",
		customer:"AnonymousSessionCreateCustomerEntityRelationInput"
	},
	AnonymousSessionCreateCustomerEntityRelationInput:{
		connect:"CustomerUniqueWhere",
		create:"CustomerWithoutAnonymousSessionCreateInput"
	},
	CustomerWithoutAnonymousSessionCreateInput:{
		id:"UUID",
		addresses:"CustomerCreateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerCreateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerCreateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerCreateTagsEntityRelationInput",
		credits:"CustomerCreateCreditsEntityRelationInput",
		paymentMethods:"CustomerCreatePaymentMethodsEntityRelationInput",
		orders:"CustomerCreateOrdersEntityRelationInput",
		permissions:"CustomerCreatePermissionsEntityRelationInput",
		group:"CustomerCreateGroupEntityRelationInput",
		photo:"CustomerCreatePhotoEntityRelationInput",
		name:"CustomerCreateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerCreateIngredientRatingsEntityRelationInput",
		business:"CustomerCreateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerCreateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerCreateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerCreateCartsEntityRelationInput",
		shortcutList:"CustomerCreateShortcutListEntityRelationInput",
		user:"CustomerCreateUserEntityRelationInput",
		channels:"CustomerCreateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerCreateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerCreateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerCreateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerCreateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerCreateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerCreateDefaultBillingSubjectEntityRelationInput",
		boughtVouchers:"CustomerCreateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerCreateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerCreateRedeemedVouchersEntityRelationInput",
		spending:"CustomerCreateSpendingEntityRelationInput",
		customerTabs:"CustomerCreateCustomerTabsEntityRelationInput",
		lead:"CustomerCreateLeadEntityRelationInput",
		meta:"CustomerCreateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerCreateInvoicesEntityRelationInput:{
		connect:"InvoiceUniqueWhere",
		create:"InvoiceWithoutCustomerCreateInput"
	},
	InvoiceWithoutCustomerCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		orderPayments:"InvoiceCreateOrderPaymentsEntityRelationInput",
		address:"InvoiceCreateAddressEntityRelationInput",
		billingSubject:"InvoiceCreateBillingSubjectEntityRelationInput"
	},
	InvoiceCreateOrderPaymentsEntityRelationInput:{
		connect:"OrderPaymentUniqueWhere",
		create:"OrderPaymentWithoutInvoiceCreateInput"
	},
	OrderPaymentWithoutInvoiceCreateInput:{
		id:"UUID",
		data:"Json",
		method:"OrderPaymentCreateMethodEntityRelationInput",
		failedAt:"DateTime",
		state:"OrderPaymentState",
		approvedAt:"DateTime",
		events:"OrderPaymentCreateEventsEntityRelationInput",
		order:"OrderPaymentCreateOrderEntityRelationInput",
		createdAt:"DateTime",
		vatRate:"OrderPaymentCreateVatRateEntityRelationInput",
		meta:"OrderPaymentCreateMetaEntityRelationInput"
	},
	OrderPaymentCreateMethodEntityRelationInput:{
		connect:"PaymentMethodUniqueWhere",
		create:"PaymentMethodCreateInput"
	},
	OrderPaymentCreateEventsEntityRelationInput:{
		connect:"OrderEventUniqueWhere",
		create:"OrderEventWithoutPaymentCreateInput"
	},
	OrderEventWithoutPaymentCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		order:"OrderEventCreateOrderEntityRelationInput",
		delivery:"OrderEventCreateDeliveryEntityRelationInput"
	},
	OrderEventCreateOrderEntityRelationInput:{
		connect:"OrderUniqueWhere",
		create:"OrderWithoutEventsCreateInput"
	},
	OrderWithoutEventsCreateInput:{
		id:"UUID",
		state:"OrderState",
		fulfilledAt:"DateTime",
		canceledAt:"DateTime",
		customer:"OrderCreateCustomerEntityRelationInput",
		channel:"OrderCreateChannelEntityRelationInput",
		discounts:"OrderCreateDiscountsEntityRelationInput",
		delivery:"OrderCreateDeliveryEntityRelationInput",
		items:"OrderCreateItemsEntityRelationInput",
		cart:"OrderCreateCartEntityRelationInput",
		createdAt:"DateTime",
		billingAddress:"OrderCreateBillingAddressEntityRelationInput",
		priceLines:"OrderCreatePriceLinesEntityRelationInput",
		payments:"OrderCreatePaymentsEntityRelationInput",
		billingSubject:"OrderCreateBillingSubjectEntityRelationInput",
		summary:"OrderCreateSummaryEntityRelationInput",
		gratuity:"OrderCreateGratuityEntityRelationInput",
		venue:"OrderCreateVenueEntityRelationInput",
		fulfillmentNotes:"OrderCreateFulfillmentNotesEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	OrderCreateDeliveryEntityRelationInput:{
		connect:"OrderDeliveryUniqueWhere",
		create:"OrderDeliveryWithoutOrderCreateInput"
	},
	OrderDeliveryWithoutOrderCreateInput:{
		id:"UUID",
		deliveredAt:"DateTime",
		method:"OrderDeliveryCreateMethodEntityRelationInput",
		vatRate:"OrderDeliveryCreateVatRateEntityRelationInput",
		expectedAt:"DateTime",
		state:"OrderDeliveryState",
		dispatchAt:"DateTime",
		expectedEndAt:"DateTime",
		processingAt:"DateTime",
		deliveringAt:"DateTime",
		failedAt:"DateTime",
		deliveryWaypoint:"OrderDeliveryCreateDeliveryWaypointEntityRelationInput",
		events:"OrderDeliveryCreateEventsEntityRelationInput",
		prepareAt:"DateTime",
		liftagoRide:"OrderDeliveryCreateLiftagoRideEntityRelationInput",
		pickedAt:"DateTime",
		address:"OrderDeliveryCreateAddressEntityRelationInput",
		woltDriveDelivery:"OrderDeliveryCreateWoltDriveDeliveryEntityRelationInput"
	},
	OrderDeliveryCreateVatRateEntityRelationInput:{
		connect:"VatRateUniqueWhere",
		create:"VatRateCreateInput"
	},
	OrderDeliveryCreateDeliveryWaypointEntityRelationInput:{
		connect:"DeliveryWaypointUniqueWhere",
		create:"DeliveryWaypointWithoutDeliveryCreateInput"
	},
	DeliveryWaypointWithoutDeliveryCreateInput:{
		id:"UUID",
		estimatedArrival:"DateTime",
		route:"DeliveryWaypointCreateRouteEntityRelationInput",
		originDeparture:"DateTime"
	},
	DeliveryWaypointCreateRouteEntityRelationInput:{
		connect:"DeliveryRouteUniqueWhere",
		create:"DeliveryRouteWithoutWaypointsCreateInput"
	},
	DeliveryRouteWithoutWaypointsCreateInput:{
		id:"UUID",
		courier:"DeliveryRouteCreateCourierEntityRelationInput",
		createdAt:"DateTime"
	},
	DeliveryRouteCreateCourierEntityRelationInput:{
		connect:"CourierUniqueWhere",
		create:"CourierWithoutRoutesCreateInput"
	},
	CourierWithoutRoutesCreateInput:{
		id:"UUID",
		staff:"CourierCreateStaffEntityRelationInput",
		createdAt:"DateTime",
		deliveryMethods:"CourierCreateDeliveryMethodsEntityRelationInput"
	},
	CourierCreateDeliveryMethodsEntityRelationInput:{
		connect:"DeliveryMethodUniqueWhere",
		create:"DeliveryMethodWithoutCourierHandlersCreateInput"
	},
	DeliveryMethodWithoutCourierHandlersCreateInput:{
		id:"UUID",
		paymentMethods:"DeliveryMethodCreatePaymentMethodsEntityRelationInput",
		suitableForDeliveryZones:"DeliveryMethodCreateSuitableForDeliveryZonesEntityRelationInput",
		channels:"DeliveryMethodCreateChannelsEntityRelationInput",
		locales:"DeliveryMethodCreateLocalesEntityRelationInput",
		timelinePreset:"DeliveryMethodCreateTimelinePresetEntityRelationInput"
	},
	DeliveryMethodCreateLocalesEntityRelationInput:{
		connect:"DeliveryMethodLocaleUniqueWhere",
		create:"DeliveryMethodLocaleWithoutRootCreateInput"
	},
	DeliveryMethodLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"DeliveryMethodLocaleCreateLocaleEntityRelationInput"
	},
	DeliveryMethodLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutDeliveryMethodsCreateInput"
	},
	LocaleWithoutDeliveryMethodsCreateInput:{
		id:"UUID",
		businessCategories:"LocaleCreateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleCreateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleCreateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleCreateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleCreateBlogsEntityRelationInput",
		blogPosts:"LocaleCreateBlogPostsEntityRelationInput",
		identifier:"LocaleCreateIdentifierEntityRelationInput",
		menus:"LocaleCreateMenusEntityRelationInput",
		pages:"LocaleCreatePagesEntityRelationInput",
		productIngredientCategories:"LocaleCreateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleCreateAllergensEntityRelationInput",
		productPackings:"LocaleCreateProductPackingsEntityRelationInput",
		products:"LocaleCreateProductsEntityRelationInput",
		productRecipes:"LocaleCreateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleCreatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleCreatePointOfSaleCategoryProductsEntityRelationInput",
		ingredientSuppliers:"LocaleCreateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleCreateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleCreatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleCreateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleCreateBusinessServicesEntityRelationInput"
	},
	LocaleCreateProductPackingsEntityRelationInput:{
		connect:"ProductPackingLocaleUniqueWhere",
		create:"ProductPackingLocaleWithoutLocaleCreateInput"
	},
	ProductPackingLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"ProductPackingLocaleCreateRootEntityRelationInput"
	},
	ProductPackingLocaleCreateRootEntityRelationInput:{
		connect:"ProductPackingUniqueWhere",
		create:"ProductPackingWithoutLocalesCreateInput"
	},
	ProductPackingWithoutLocalesCreateInput:{
		id:"UUID",
		image:"ProductPackingCreateImageEntityRelationInput",
		icon:"ProductPackingCreateIconEntityRelationInput",
		preparedPackingQuantities:"ProductPackingCreatePreparedPackingQuantitiesEntityRelationInput"
	},
	ProductPackingCreatePreparedPackingQuantitiesEntityRelationInput:{
		connect:"PreparedPackingQuantityUniqueWhere",
		create:"PreparedPackingQuantityWithoutPackingCreateInput"
	},
	PreparedPackingQuantityWithoutPackingCreateInput:{
		id:"UUID",
		date:"Date",
		recipe:"PreparedPackingQuantityCreateRecipeEntityRelationInput"
	},
	PreparedPackingQuantityCreateRecipeEntityRelationInput:{
		connect:"ProductRecipeUniqueWhere",
		create:"ProductRecipeCreateInput"
	},
	ProductRecipeCreateInput:{
		id:"UUID",
		products:"ProductRecipeCreateProductsEntityRelationInput",
		image:"ProductRecipeCreateImageEntityRelationInput",
		icon:"ProductRecipeCreateIconEntityRelationInput",
		ingredients:"ProductRecipeCreateIngredientsEntityRelationInput",
		locales:"ProductRecipeCreateLocalesEntityRelationInput",
		freshingContainer:"ProductRecipeCreateFreshingContainerEntityRelationInput",
		nutritionFacts:"ProductRecipeCreateNutritionFactsEntityRelationInput"
	},
	ProductRecipeCreateProductsEntityRelationInput:{
		connect:"ProductUniqueWhere",
		create:"ProductWithoutRecipeCreateInput"
	},
	ProductWithoutRecipeCreateInput:{
		id:"UUID",
		packing:"ProductCreatePackingEntityRelationInput",
		tags:"ProductCreateTagsEntityRelationInput",
		categories:"ProductCreateCategoriesEntityRelationInput",
		vatRate:"ProductCreateVatRateEntityRelationInput",
		stocks:"ProductCreateStocksEntityRelationInput",
		groupPrices:"ProductCreateGroupPricesEntityRelationInput",
		image:"ProductCreateImageEntityRelationInput",
		cartItems:"ProductCreateCartItemsEntityRelationInput",
		availability:"ProductAvailability",
		manager:"ProductCreateManagerEntityRelationInput",
		orderItems:"ProductCreateOrderItemsEntityRelationInput",
		inheritedCategories:"ProductCreateInheritedCategoriesEntityRelationInput",
		deliveryZones:"ProductCreateDeliveryZonesEntityRelationInput",
		locales:"ProductCreateLocalesEntityRelationInput",
		archivedAt:"DateTime",
		customerPrices:"ProductCreateCustomerPricesEntityRelationInput",
		virtualProduct:"ProductCreateVirtualProductEntityRelationInput",
		meta:"ProductCreateMetaEntityRelationInput",
		page:"ProductCreatePageEntityRelationInput",
		salesDays:"ProductCreateSalesDaysEntityRelationInput",
		salesWeeks:"ProductCreateSalesWeeksEntityRelationInput",
		salesMonths:"ProductCreateSalesMonthsEntityRelationInput",
		fulfillmentNotes:"ProductCreateFulfillmentNotesEntityRelationInput"
	},
	ProductCreateLocalesEntityRelationInput:{
		connect:"ProductLocaleUniqueWhere",
		create:"ProductLocaleWithoutRootCreateInput"
	},
	ProductLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"ProductLocaleCreateLocaleEntityRelationInput",
		featureList:"ProductLocaleCreateFeatureListEntityRelationInput"
	},
	ProductLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutProductsCreateInput"
	},
	LocaleWithoutProductsCreateInput:{
		id:"UUID",
		businessCategories:"LocaleCreateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleCreateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleCreateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleCreateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleCreateBlogsEntityRelationInput",
		blogPosts:"LocaleCreateBlogPostsEntityRelationInput",
		identifier:"LocaleCreateIdentifierEntityRelationInput",
		menus:"LocaleCreateMenusEntityRelationInput",
		pages:"LocaleCreatePagesEntityRelationInput",
		productIngredientCategories:"LocaleCreateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleCreateAllergensEntityRelationInput",
		productPackings:"LocaleCreateProductPackingsEntityRelationInput",
		productRecipes:"LocaleCreateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleCreatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleCreatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleCreateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleCreateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleCreateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleCreatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleCreateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleCreateBusinessServicesEntityRelationInput"
	},
	LocaleCreateProductRecipesEntityRelationInput:{
		connect:"ProductRecipeLocaleUniqueWhere",
		create:"ProductRecipeLocaleWithoutLocaleCreateInput"
	},
	ProductRecipeLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"ProductRecipeLocaleCreateRootEntityRelationInput"
	},
	ProductRecipeLocaleCreateRootEntityRelationInput:{
		connect:"ProductRecipeUniqueWhere",
		create:"ProductRecipeWithoutLocalesCreateInput"
	},
	ProductRecipeWithoutLocalesCreateInput:{
		id:"UUID",
		products:"ProductRecipeCreateProductsEntityRelationInput",
		image:"ProductRecipeCreateImageEntityRelationInput",
		icon:"ProductRecipeCreateIconEntityRelationInput",
		ingredients:"ProductRecipeCreateIngredientsEntityRelationInput",
		freshingContainer:"ProductRecipeCreateFreshingContainerEntityRelationInput",
		nutritionFacts:"ProductRecipeCreateNutritionFactsEntityRelationInput"
	},
	ProductRecipeCreateFreshingContainerEntityRelationInput:{
		connect:"FreshingContainerUniqueWhere",
		create:"FreshingContainerCreateInput"
	},
	ProductRecipeCreateNutritionFactsEntityRelationInput:{
		connect:"NutritionFactsUniqueWhere",
		create:"NutritionFactsCreateInput"
	},
	NutritionFactsCreateInput:{
		id:"UUID"
	},
	LocaleCreatePointOfSaleCategoriesEntityRelationInput:{
		connect:"PointOfSaleCategoryLocaleUniqueWhere",
		create:"PointOfSaleCategoryLocaleWithoutLocaleCreateInput"
	},
	PointOfSaleCategoryLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"PointOfSaleCategoryLocaleCreateRootEntityRelationInput"
	},
	PointOfSaleCategoryLocaleCreateRootEntityRelationInput:{
		connect:"PointOfSaleCategoryUniqueWhere",
		create:"PointOfSaleCategoryWithoutLocalesCreateInput"
	},
	PointOfSaleCategoryWithoutLocalesCreateInput:{
		id:"UUID",
		products:"PointOfSaleCategoryCreateProductsEntityRelationInput",
		category:"PointOfSaleCategoryCreateCategoryEntityRelationInput",
		venue:"PointOfSaleCategoryCreateVenueEntityRelationInput",
		ticketPrinters:"PointOfSaleCategoryCreateTicketPrintersEntityRelationInput"
	},
	PointOfSaleCategoryCreateProductsEntityRelationInput:{
		connect:"PointOfSaleCategoryProductUniqueWhere",
		create:"PointOfSaleCategoryProductWithoutCategoryCreateInput"
	},
	PointOfSaleCategoryProductWithoutCategoryCreateInput:{
		id:"UUID",
		product:"PointOfSaleCategoryProductCreateProductEntityRelationInput",
		locales:"PointOfSaleCategoryProductCreateLocalesEntityRelationInput"
	},
	PointOfSaleCategoryProductCreateProductEntityRelationInput:{
		connect:"ProductUniqueWhere",
		create:"ProductCreateInput"
	},
	ProductCreateInput:{
		id:"UUID",
		packing:"ProductCreatePackingEntityRelationInput",
		recipe:"ProductCreateRecipeEntityRelationInput",
		tags:"ProductCreateTagsEntityRelationInput",
		categories:"ProductCreateCategoriesEntityRelationInput",
		vatRate:"ProductCreateVatRateEntityRelationInput",
		stocks:"ProductCreateStocksEntityRelationInput",
		groupPrices:"ProductCreateGroupPricesEntityRelationInput",
		image:"ProductCreateImageEntityRelationInput",
		cartItems:"ProductCreateCartItemsEntityRelationInput",
		availability:"ProductAvailability",
		manager:"ProductCreateManagerEntityRelationInput",
		orderItems:"ProductCreateOrderItemsEntityRelationInput",
		inheritedCategories:"ProductCreateInheritedCategoriesEntityRelationInput",
		deliveryZones:"ProductCreateDeliveryZonesEntityRelationInput",
		locales:"ProductCreateLocalesEntityRelationInput",
		archivedAt:"DateTime",
		customerPrices:"ProductCreateCustomerPricesEntityRelationInput",
		virtualProduct:"ProductCreateVirtualProductEntityRelationInput",
		meta:"ProductCreateMetaEntityRelationInput",
		page:"ProductCreatePageEntityRelationInput",
		salesDays:"ProductCreateSalesDaysEntityRelationInput",
		salesWeeks:"ProductCreateSalesWeeksEntityRelationInput",
		salesMonths:"ProductCreateSalesMonthsEntityRelationInput",
		fulfillmentNotes:"ProductCreateFulfillmentNotesEntityRelationInput"
	},
	ProductCreateCustomerPricesEntityRelationInput:{
		connect:"ProductCustomerPriceUniqueWhere"
	},
	ProductCreateVirtualProductEntityRelationInput:{
		connect:"VirtualProductUniqueWhere",
		create:"VirtualProductWithoutProductCreateInput"
	},
	VirtualProductWithoutProductCreateInput:{
		id:"UUID",
		type:"VirtualProductType",
		physicalRepresentation:"VirtualProductPhysicalRepresentationType"
	},
	ProductCreateMetaEntityRelationInput:{
		connect:"ProductMetadataUniqueWhere"
	},
	ProductCreatePageEntityRelationInput:{
		connect:"PageUniqueWhere",
		create:"PageCreateInput"
	},
	PageCreateInput:{
		id:"UUID",
		locales:"PageCreateLocalesEntityRelationInput"
	},
	PageCreateLocalesEntityRelationInput:{
		connect:"PageLocaleUniqueWhere",
		create:"PageLocaleWithoutRootCreateInput"
	},
	PageLocaleWithoutRootCreateInput:{
		id:"UUID",
		link:"PageLocaleCreateLinkEntityRelationInput",
		locale:"PageLocaleCreateLocaleEntityRelationInput",
		seo:"PageLocaleCreateSeoEntityRelationInput",
		content:"PageLocaleCreateContentEntityRelationInput",
		cover:"PageLocaleCreateCoverEntityRelationInput",
		theme:"PageTheme"
	},
	PageLocaleCreateSeoEntityRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput"
	},
	SeoCreateInput:{
		id:"UUID",
		ogImage:"SeoCreateOgImageEntityRelationInput"
	},
	SeoCreateOgImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	PageLocaleCreateContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput"
	},
	PageLocaleCreateCoverEntityRelationInput:{
		connect:"CoverUniqueWhere",
		create:"CoverCreateInput"
	},
	ProductCreateSalesDaysEntityRelationInput:{
		connect:"ProductSalesDayUniqueWhere"
	},
	ProductCreateSalesWeeksEntityRelationInput:{
		connect:"ProductSalesWeekUniqueWhere"
	},
	ProductCreateSalesMonthsEntityRelationInput:{
		connect:"ProductSalesMonthUniqueWhere"
	},
	ProductCreateFulfillmentNotesEntityRelationInput:{
		connect:"FulfillmentNoteUniqueWhere",
		create:"FulfillmentNoteWithoutProductsCreateInput"
	},
	FulfillmentNoteWithoutProductsCreateInput:{
		id:"UUID",
		tags:"FulfillmentNoteCreateTagsEntityRelationInput",
		venues:"FulfillmentNoteCreateVenuesEntityRelationInput",
		cartItems:"FulfillmentNoteCreateCartItemsEntityRelationInput",
		orderItems:"FulfillmentNoteCreateOrderItemsEntityRelationInput",
		orders:"FulfillmentNoteCreateOrdersEntityRelationInput",
		createdAt:"DateTime"
	},
	FulfillmentNoteCreateTagsEntityRelationInput:{
		connect:"TagUniqueWhere",
		create:"TagWithoutFulfillmentNotesCreateInput"
	},
	TagWithoutFulfillmentNotesCreateInput:{
		id:"UUID",
		customers:"TagCreateCustomersEntityRelationInput",
		products:"TagCreateProductsEntityRelationInput",
		categories:"TagCreateCategoriesEntityRelationInput",
		addTagsOnRegistration:"TagCreateAddTagsOnRegistrationEntityRelationInput",
		nestedCategories:"TagCreateNestedCategoriesEntityRelationInput",
		deliveryZones:"TagCreateDeliveryZonesEntityRelationInput",
		publicInChannels:"TagCreatePublicInChannelsEntityRelationInput",
		allowChannelPayments:"TagCreateAllowChannelPaymentsEntityRelationInput"
	},
	FulfillmentNoteCreateVenuesEntityRelationInput:{
		connect:"VenueUniqueWhere",
		create:"VenueWithoutFulfillmentNotesCreateInput"
	},
	VenueWithoutFulfillmentNotesCreateInput:{
		id:"UUID",
		deadlineTemplate:"VenueCreateDeadlineTemplateEntityRelationInput",
		timetableDays:"VenueCreateTimetableDaysEntityRelationInput",
		timetableTemplates:"VenueCreateTimetableTemplatesEntityRelationInput",
		staffMembers:"VenueCreateStaffMembersEntityRelationInput",
		employeeRoles:"VenueCreateEmployeeRolesEntityRelationInput",
		pointOfSaleApplicationDevices:"VenueCreatePointOfSaleApplicationDevicesEntityRelationInput",
		pointOfSaleTerminals:"VenueCreatePointOfSaleTerminalsEntityRelationInput",
		pointOfSalePrinters:"VenueCreatePointOfSalePrintersEntityRelationInput",
		orders:"VenueCreateOrdersEntityRelationInput",
		areas:"VenueCreateAreasEntityRelationInput",
		enabledUnassignReasons:"VenueCreateEnabledUnassignReasonsEntityRelationInput",
		categories:"VenueCreateCategoriesEntityRelationInput",
		channels:"VenueCreateChannelsEntityRelationInput",
		pointOfSaleInitialView:"PointOfSaleInitialView"
	},
	VenueCreateTimetableTemplatesEntityRelationInput:{
		connect:"TimetableTemplateUniqueWhere",
		create:"TimetableTemplateWithoutVenueCreateInput"
	},
	TimetableTemplateWithoutVenueCreateInput:{
		id:"UUID",
		startDate:"Date",
		position:"TimetableTemplateCreatePositionEntityRelationInput",
		staffOptions:"TimetableTemplateCreateStaffOptionsEntityRelationInput",
		employeeRole:"TimetableTemplateCreateEmployeeRoleEntityRelationInput",
		type:"TemplateType"
	},
	TimetableTemplateCreateEmployeeRoleEntityRelationInput:{
		connect:"TimetableEmployeeRoleUniqueWhere",
		create:"TimetableEmployeeRoleWithoutTimetableTemplatesCreateInput"
	},
	TimetableEmployeeRoleWithoutTimetableTemplatesCreateInput:{
		id:"UUID",
		shiftGroups:"TimetableEmployeeRoleCreateShiftGroupsEntityRelationInput",
		shiftsProfiles:"TimetableEmployeeRoleCreateShiftsProfilesEntityRelationInput",
		shiftsManagers:"TimetableEmployeeRoleCreateShiftsManagersEntityRelationInput"
	},
	VenueCreatePointOfSaleTerminalsEntityRelationInput:{
		connect:"PointOfSaleTerminalUniqueWhere",
		create:"PointOfSaleTerminalWithoutVenueCreateInput"
	},
	PointOfSaleTerminalWithoutVenueCreateInput:{
		id:"UUID",
		applicationDevices:"PointOfSaleTerminalCreateApplicationDevicesEntityRelationInput",
		type:"PointOfSaleTerminalType"
	},
	PointOfSaleTerminalCreateApplicationDevicesEntityRelationInput:{
		connect:"PointOfSaleApplicationDeviceUniqueWhere",
		create:"PointOfSaleApplicationDeviceWithoutTerminalCreateInput"
	},
	PointOfSaleApplicationDeviceWithoutTerminalCreateInput:{
		id:"UUID",
		venue:"PointOfSaleApplicationDeviceCreateVenueEntityRelationInput",
		identificationCode:"PointOfSaleApplicationDeviceCreateIdentificationCodeEntityRelationInput",
		identifier:"PointOfSaleApplicationDeviceCreateIdentifierEntityRelationInput",
		receiptPrinter:"PointOfSaleApplicationDeviceCreateReceiptPrinterEntityRelationInput",
		ticketPrinters:"PointOfSaleApplicationDeviceCreateTicketPrintersEntityRelationInput"
	},
	PointOfSaleApplicationDeviceCreateVenueEntityRelationInput:{
		connect:"VenueUniqueWhere",
		create:"VenueWithoutPointOfSaleApplicationDevicesCreateInput"
	},
	VenueWithoutPointOfSaleApplicationDevicesCreateInput:{
		id:"UUID",
		deadlineTemplate:"VenueCreateDeadlineTemplateEntityRelationInput",
		timetableDays:"VenueCreateTimetableDaysEntityRelationInput",
		timetableTemplates:"VenueCreateTimetableTemplatesEntityRelationInput",
		staffMembers:"VenueCreateStaffMembersEntityRelationInput",
		employeeRoles:"VenueCreateEmployeeRolesEntityRelationInput",
		pointOfSaleTerminals:"VenueCreatePointOfSaleTerminalsEntityRelationInput",
		pointOfSalePrinters:"VenueCreatePointOfSalePrintersEntityRelationInput",
		orders:"VenueCreateOrdersEntityRelationInput",
		fulfillmentNotes:"VenueCreateFulfillmentNotesEntityRelationInput",
		areas:"VenueCreateAreasEntityRelationInput",
		enabledUnassignReasons:"VenueCreateEnabledUnassignReasonsEntityRelationInput",
		categories:"VenueCreateCategoriesEntityRelationInput",
		channels:"VenueCreateChannelsEntityRelationInput",
		pointOfSaleInitialView:"PointOfSaleInitialView"
	},
	VenueCreatePointOfSalePrintersEntityRelationInput:{
		connect:"PointOfSalePrinterUniqueWhere",
		create:"PointOfSalePrinterWithoutVenueCreateInput"
	},
	PointOfSalePrinterWithoutVenueCreateInput:{
		id:"UUID",
		applicationDevicesReceipt:"PointOfSalePrinterCreateApplicationDevicesReceiptEntityRelationInput",
		applicationDevicesTicket:"PointOfSalePrinterCreateApplicationDevicesTicketEntityRelationInput",
		ticketCategories:"PointOfSalePrinterCreateTicketCategoriesEntityRelationInput"
	},
	PointOfSalePrinterCreateApplicationDevicesReceiptEntityRelationInput:{
		connect:"PointOfSaleApplicationDeviceUniqueWhere",
		create:"PointOfSaleApplicationDeviceWithoutReceiptPrinterCreateInput"
	},
	PointOfSaleApplicationDeviceWithoutReceiptPrinterCreateInput:{
		id:"UUID",
		venue:"PointOfSaleApplicationDeviceCreateVenueEntityRelationInput",
		identificationCode:"PointOfSaleApplicationDeviceCreateIdentificationCodeEntityRelationInput",
		identifier:"PointOfSaleApplicationDeviceCreateIdentifierEntityRelationInput",
		terminal:"PointOfSaleApplicationDeviceCreateTerminalEntityRelationInput",
		ticketPrinters:"PointOfSaleApplicationDeviceCreateTicketPrintersEntityRelationInput"
	},
	PointOfSaleApplicationDeviceCreateIdentifierEntityRelationInput:{
		connect:"DeviceIdentifierUniqueWhere",
		create:"DeviceIdentifierWithoutDeviceCreateInput"
	},
	DeviceIdentifierWithoutDeviceCreateInput:{
		id:"UUID",
		updatedAt:"DateTime",
		updatedByUser:"DeviceIdentifierCreateUpdatedByUserEntityRelationInput"
	},
	DeviceIdentifierCreateUpdatedByUserEntityRelationInput:{
		connect:"UserUniqueWhere",
		create:"UserCreateInput"
	},
	UserCreateInput:{
		id:"UUID",
		staff:"UserCreateStaffEntityRelationInput",
		customer:"UserCreateCustomerEntityRelationInput",
		tenantPersonId:"UUID",
		disabledAt:"DateTime",
		devices:"UserCreateDevicesEntityRelationInput",
		verifiedAt:"DateTime",
		createdAt:"DateTime",
		deletionRequestedAt:"DateTime",
		deletionExpectedAt:"DateTime",
		deletedAt:"DateTime",
		meta:"UserCreateMetaEntityRelationInput",
		identificationAttempts:"UserCreateIdentificationAttemptsEntityRelationInput",
		roles:"UserCreateRolesEntityRelationInput"
	},
	UserCreateMetaEntityRelationInput:{
		connect:"UserMetadataUniqueWhere"
	},
	UserCreateIdentificationAttemptsEntityRelationInput:{
		connect:"IdentificationAttemptUniqueWhere",
		create:"IdentificationAttemptWithoutUserCreateInput"
	},
	IdentificationAttemptWithoutUserCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		code:"IdentificationAttemptCreateCodeEntityRelationInput"
	},
	IdentificationAttemptCreateCodeEntityRelationInput:{
		connect:"IdentificationCodeUniqueWhere",
		create:"IdentificationCodeWithoutAttemptsCreateInput"
	},
	IdentificationCodeWithoutAttemptsCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		locales:"IdentificationCodeCreateLocalesEntityRelationInput",
		applicationDevices:"IdentificationCodeCreateApplicationDevicesEntityRelationInput"
	},
	IdentificationCodeCreateLocalesEntityRelationInput:{
		connect:"IdentificationCodeLocaleUniqueWhere",
		create:"IdentificationCodeLocaleWithoutRootCreateInput"
	},
	IdentificationCodeLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"IdentificationCodeLocaleCreateLocaleEntityRelationInput"
	},
	IdentificationCodeLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutIdentificationCodesCreateInput"
	},
	LocaleWithoutIdentificationCodesCreateInput:{
		id:"UUID",
		businessCategories:"LocaleCreateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleCreateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleCreateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleCreateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleCreateBlogsEntityRelationInput",
		blogPosts:"LocaleCreateBlogPostsEntityRelationInput",
		identifier:"LocaleCreateIdentifierEntityRelationInput",
		menus:"LocaleCreateMenusEntityRelationInput",
		pages:"LocaleCreatePagesEntityRelationInput",
		productIngredientCategories:"LocaleCreateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleCreateAllergensEntityRelationInput",
		productPackings:"LocaleCreateProductPackingsEntityRelationInput",
		products:"LocaleCreateProductsEntityRelationInput",
		productRecipes:"LocaleCreateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleCreatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleCreatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleCreateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleCreateIngredientSuppliersEntityRelationInput",
		pipelineStages:"LocaleCreatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleCreateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleCreateBusinessServicesEntityRelationInput"
	},
	LocaleCreateProductsEntityRelationInput:{
		connect:"ProductLocaleUniqueWhere",
		create:"ProductLocaleWithoutLocaleCreateInput"
	},
	ProductLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"ProductLocaleCreateRootEntityRelationInput",
		featureList:"ProductLocaleCreateFeatureListEntityRelationInput"
	},
	ProductLocaleCreateRootEntityRelationInput:{
		connect:"ProductUniqueWhere",
		create:"ProductWithoutLocalesCreateInput"
	},
	ProductWithoutLocalesCreateInput:{
		id:"UUID",
		packing:"ProductCreatePackingEntityRelationInput",
		recipe:"ProductCreateRecipeEntityRelationInput",
		tags:"ProductCreateTagsEntityRelationInput",
		categories:"ProductCreateCategoriesEntityRelationInput",
		vatRate:"ProductCreateVatRateEntityRelationInput",
		stocks:"ProductCreateStocksEntityRelationInput",
		groupPrices:"ProductCreateGroupPricesEntityRelationInput",
		image:"ProductCreateImageEntityRelationInput",
		cartItems:"ProductCreateCartItemsEntityRelationInput",
		availability:"ProductAvailability",
		manager:"ProductCreateManagerEntityRelationInput",
		orderItems:"ProductCreateOrderItemsEntityRelationInput",
		inheritedCategories:"ProductCreateInheritedCategoriesEntityRelationInput",
		deliveryZones:"ProductCreateDeliveryZonesEntityRelationInput",
		archivedAt:"DateTime",
		customerPrices:"ProductCreateCustomerPricesEntityRelationInput",
		virtualProduct:"ProductCreateVirtualProductEntityRelationInput",
		meta:"ProductCreateMetaEntityRelationInput",
		page:"ProductCreatePageEntityRelationInput",
		salesDays:"ProductCreateSalesDaysEntityRelationInput",
		salesWeeks:"ProductCreateSalesWeeksEntityRelationInput",
		salesMonths:"ProductCreateSalesMonthsEntityRelationInput",
		fulfillmentNotes:"ProductCreateFulfillmentNotesEntityRelationInput"
	},
	ProductLocaleCreateFeatureListEntityRelationInput:{
		connect:"TextListUniqueWhere",
		create:"TextListCreateInput"
	},
	LocaleCreatePointOfSaleCategoryProductsEntityRelationInput:{
		connect:"PointOfSaleCategoryProductLocaleUniqueWhere",
		create:"PointOfSaleCategoryProductLocaleWithoutLocaleCreateInput"
	},
	PointOfSaleCategoryProductLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"PointOfSaleCategoryProductLocaleCreateRootEntityRelationInput"
	},
	PointOfSaleCategoryProductLocaleCreateRootEntityRelationInput:{
		connect:"PointOfSaleCategoryProductUniqueWhere",
		create:"PointOfSaleCategoryProductWithoutLocalesCreateInput"
	},
	PointOfSaleCategoryProductWithoutLocalesCreateInput:{
		id:"UUID",
		category:"PointOfSaleCategoryProductCreateCategoryEntityRelationInput",
		product:"PointOfSaleCategoryProductCreateProductEntityRelationInput"
	},
	PointOfSaleCategoryProductCreateCategoryEntityRelationInput:{
		connect:"PointOfSaleCategoryUniqueWhere",
		create:"PointOfSaleCategoryWithoutProductsCreateInput"
	},
	PointOfSaleCategoryWithoutProductsCreateInput:{
		id:"UUID",
		locales:"PointOfSaleCategoryCreateLocalesEntityRelationInput",
		category:"PointOfSaleCategoryCreateCategoryEntityRelationInput",
		venue:"PointOfSaleCategoryCreateVenueEntityRelationInput",
		ticketPrinters:"PointOfSaleCategoryCreateTicketPrintersEntityRelationInput"
	},
	PointOfSaleCategoryCreateLocalesEntityRelationInput:{
		connect:"PointOfSaleCategoryLocaleUniqueWhere",
		create:"PointOfSaleCategoryLocaleWithoutRootCreateInput"
	},
	PointOfSaleCategoryLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"PointOfSaleCategoryLocaleCreateLocaleEntityRelationInput"
	},
	PointOfSaleCategoryLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutPointOfSaleCategoriesCreateInput"
	},
	LocaleWithoutPointOfSaleCategoriesCreateInput:{
		id:"UUID",
		businessCategories:"LocaleCreateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleCreateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleCreateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleCreateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleCreateBlogsEntityRelationInput",
		blogPosts:"LocaleCreateBlogPostsEntityRelationInput",
		identifier:"LocaleCreateIdentifierEntityRelationInput",
		menus:"LocaleCreateMenusEntityRelationInput",
		pages:"LocaleCreatePagesEntityRelationInput",
		productIngredientCategories:"LocaleCreateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleCreateAllergensEntityRelationInput",
		productPackings:"LocaleCreateProductPackingsEntityRelationInput",
		products:"LocaleCreateProductsEntityRelationInput",
		productRecipes:"LocaleCreateProductRecipesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleCreatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleCreateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleCreateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleCreateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleCreatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleCreateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleCreateBusinessServicesEntityRelationInput"
	},
	LocaleCreateDeliveryMethodsEntityRelationInput:{
		connect:"DeliveryMethodLocaleUniqueWhere",
		create:"DeliveryMethodLocaleWithoutLocaleCreateInput"
	},
	DeliveryMethodLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"DeliveryMethodLocaleCreateRootEntityRelationInput"
	},
	DeliveryMethodLocaleCreateRootEntityRelationInput:{
		connect:"DeliveryMethodUniqueWhere",
		create:"DeliveryMethodWithoutLocalesCreateInput"
	},
	DeliveryMethodWithoutLocalesCreateInput:{
		id:"UUID",
		paymentMethods:"DeliveryMethodCreatePaymentMethodsEntityRelationInput",
		suitableForDeliveryZones:"DeliveryMethodCreateSuitableForDeliveryZonesEntityRelationInput",
		channels:"DeliveryMethodCreateChannelsEntityRelationInput",
		courierHandlers:"DeliveryMethodCreateCourierHandlersEntityRelationInput",
		timelinePreset:"DeliveryMethodCreateTimelinePresetEntityRelationInput"
	},
	DeliveryMethodCreateTimelinePresetEntityRelationInput:{
		connect:"DeliveryTimelinePresetUniqueWhere",
		create:"DeliveryTimelinePresetWithoutDeliveryMethodCreateInput"
	},
	DeliveryTimelinePresetWithoutDeliveryMethodCreateInput:{
		id:"UUID",
		type:"DeliveryTimelineType"
	},
	LocaleCreateIngredientSuppliersEntityRelationInput:{
		connect:"IngredientSupplierLocaleUniqueWhere",
		create:"IngredientSupplierLocaleWithoutLocaleCreateInput"
	},
	IngredientSupplierLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"IngredientSupplierLocaleCreateRootEntityRelationInput"
	},
	IngredientSupplierLocaleCreateRootEntityRelationInput:{
		connect:"IngredientSupplierUniqueWhere",
		create:"IngredientSupplierWithoutLocalesCreateInput"
	},
	IngredientSupplierWithoutLocalesCreateInput:{
		id:"UUID"
	},
	LocaleCreateIdentificationCodesEntityRelationInput:{
		connect:"IdentificationCodeLocaleUniqueWhere",
		create:"IdentificationCodeLocaleWithoutLocaleCreateInput"
	},
	IdentificationCodeLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"IdentificationCodeLocaleCreateRootEntityRelationInput"
	},
	IdentificationCodeLocaleCreateRootEntityRelationInput:{
		connect:"IdentificationCodeUniqueWhere",
		create:"IdentificationCodeWithoutLocalesCreateInput"
	},
	IdentificationCodeWithoutLocalesCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		attempts:"IdentificationCodeCreateAttemptsEntityRelationInput",
		applicationDevices:"IdentificationCodeCreateApplicationDevicesEntityRelationInput"
	},
	IdentificationCodeCreateApplicationDevicesEntityRelationInput:{
		connect:"PointOfSaleApplicationDeviceUniqueWhere",
		create:"PointOfSaleApplicationDeviceWithoutIdentificationCodeCreateInput"
	},
	PointOfSaleApplicationDeviceWithoutIdentificationCodeCreateInput:{
		id:"UUID",
		venue:"PointOfSaleApplicationDeviceCreateVenueEntityRelationInput",
		identifier:"PointOfSaleApplicationDeviceCreateIdentifierEntityRelationInput",
		terminal:"PointOfSaleApplicationDeviceCreateTerminalEntityRelationInput",
		receiptPrinter:"PointOfSaleApplicationDeviceCreateReceiptPrinterEntityRelationInput",
		ticketPrinters:"PointOfSaleApplicationDeviceCreateTicketPrintersEntityRelationInput"
	},
	PointOfSaleApplicationDeviceCreateTerminalEntityRelationInput:{
		connect:"PointOfSaleTerminalUniqueWhere",
		create:"PointOfSaleTerminalWithoutApplicationDevicesCreateInput"
	},
	PointOfSaleTerminalWithoutApplicationDevicesCreateInput:{
		id:"UUID",
		venue:"PointOfSaleTerminalCreateVenueEntityRelationInput",
		type:"PointOfSaleTerminalType"
	},
	PointOfSaleTerminalCreateVenueEntityRelationInput:{
		connect:"VenueUniqueWhere",
		create:"VenueWithoutPointOfSaleTerminalsCreateInput"
	},
	VenueWithoutPointOfSaleTerminalsCreateInput:{
		id:"UUID",
		deadlineTemplate:"VenueCreateDeadlineTemplateEntityRelationInput",
		timetableDays:"VenueCreateTimetableDaysEntityRelationInput",
		timetableTemplates:"VenueCreateTimetableTemplatesEntityRelationInput",
		staffMembers:"VenueCreateStaffMembersEntityRelationInput",
		employeeRoles:"VenueCreateEmployeeRolesEntityRelationInput",
		pointOfSaleApplicationDevices:"VenueCreatePointOfSaleApplicationDevicesEntityRelationInput",
		pointOfSalePrinters:"VenueCreatePointOfSalePrintersEntityRelationInput",
		orders:"VenueCreateOrdersEntityRelationInput",
		fulfillmentNotes:"VenueCreateFulfillmentNotesEntityRelationInput",
		areas:"VenueCreateAreasEntityRelationInput",
		enabledUnassignReasons:"VenueCreateEnabledUnassignReasonsEntityRelationInput",
		categories:"VenueCreateCategoriesEntityRelationInput",
		channels:"VenueCreateChannelsEntityRelationInput",
		pointOfSaleInitialView:"PointOfSaleInitialView"
	},
	VenueCreateOrdersEntityRelationInput:{
		connect:"OrderUniqueWhere",
		create:"OrderWithoutVenueCreateInput"
	},
	OrderWithoutVenueCreateInput:{
		id:"UUID",
		state:"OrderState",
		fulfilledAt:"DateTime",
		canceledAt:"DateTime",
		customer:"OrderCreateCustomerEntityRelationInput",
		channel:"OrderCreateChannelEntityRelationInput",
		discounts:"OrderCreateDiscountsEntityRelationInput",
		delivery:"OrderCreateDeliveryEntityRelationInput",
		items:"OrderCreateItemsEntityRelationInput",
		cart:"OrderCreateCartEntityRelationInput",
		events:"OrderCreateEventsEntityRelationInput",
		createdAt:"DateTime",
		billingAddress:"OrderCreateBillingAddressEntityRelationInput",
		priceLines:"OrderCreatePriceLinesEntityRelationInput",
		payments:"OrderCreatePaymentsEntityRelationInput",
		billingSubject:"OrderCreateBillingSubjectEntityRelationInput",
		summary:"OrderCreateSummaryEntityRelationInput",
		gratuity:"OrderCreateGratuityEntityRelationInput",
		fulfillmentNotes:"OrderCreateFulfillmentNotesEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	OrderCreateItemsEntityRelationInput:{
		connect:"OrderItemUniqueWhere",
		create:"OrderItemWithoutOrderCreateInput"
	},
	OrderItemWithoutOrderCreateInput:{
		id:"UUID",
		vatRate:"OrderItemCreateVatRateEntityRelationInput",
		virtualProductEffects:"OrderItemCreateVirtualProductEffectsEntityRelationInput",
		pickedAt:"DateTime",
		fulfillmentNotes:"OrderItemCreateFulfillmentNotesEntityRelationInput",
		product:"OrderItemCreateProductEntityRelationInput"
	},
	OrderItemCreateVirtualProductEffectsEntityRelationInput:{
		connect:"VirtualProductEffectUniqueWhere",
		create:"VirtualProductEffectWithoutOrderItemCreateInput"
	},
	VirtualProductEffectWithoutOrderItemCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		succeededAt:"DateTime",
		failedAt:"DateTime",
		revertedAt:"DateTime",
		resultCustomerCreditTransaction:"VirtualProductEffectCreateResultCustomerCreditTransactionEntityRelationInput",
		resultVouchers:"VirtualProductEffectCreateResultVouchersEntityRelationInput"
	},
	VirtualProductEffectCreateResultCustomerCreditTransactionEntityRelationInput:{
		connect:"CustomerCreditTransactionUniqueWhere",
		create:"CustomerCreditTransactionWithoutVirtualProductEffectCreateInput"
	},
	CustomerCreditTransactionWithoutVirtualProductEffectCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		customerCredit:"CustomerCreditTransactionCreateCustomerCreditEntityRelationInput",
		orderDiscount:"CustomerCreditTransactionCreateOrderDiscountEntityRelationInput"
	},
	CustomerCreditTransactionCreateOrderDiscountEntityRelationInput:{
		connect:"OrderDiscountUniqueWhere",
		create:"OrderDiscountWithoutCustomerCreditTransactionsCreateInput"
	},
	OrderDiscountWithoutCustomerCreditTransactionsCreateInput:{
		id:"UUID",
		vatRate:"OrderDiscountCreateVatRateEntityRelationInput",
		order:"OrderDiscountCreateOrderEntityRelationInput",
		type:"OrderDiscountType",
		voucherRedemption:"OrderDiscountCreateVoucherRedemptionEntityRelationInput"
	},
	OrderDiscountCreateOrderEntityRelationInput:{
		connect:"OrderUniqueWhere",
		create:"OrderWithoutDiscountsCreateInput"
	},
	OrderWithoutDiscountsCreateInput:{
		id:"UUID",
		state:"OrderState",
		fulfilledAt:"DateTime",
		canceledAt:"DateTime",
		customer:"OrderCreateCustomerEntityRelationInput",
		channel:"OrderCreateChannelEntityRelationInput",
		delivery:"OrderCreateDeliveryEntityRelationInput",
		items:"OrderCreateItemsEntityRelationInput",
		cart:"OrderCreateCartEntityRelationInput",
		events:"OrderCreateEventsEntityRelationInput",
		createdAt:"DateTime",
		billingAddress:"OrderCreateBillingAddressEntityRelationInput",
		priceLines:"OrderCreatePriceLinesEntityRelationInput",
		payments:"OrderCreatePaymentsEntityRelationInput",
		billingSubject:"OrderCreateBillingSubjectEntityRelationInput",
		summary:"OrderCreateSummaryEntityRelationInput",
		gratuity:"OrderCreateGratuityEntityRelationInput",
		venue:"OrderCreateVenueEntityRelationInput",
		fulfillmentNotes:"OrderCreateFulfillmentNotesEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	OrderCreateCartEntityRelationInput:{
		connect:"CartUniqueWhere",
		create:"CartWithoutOrderCreateInput"
	},
	CartWithoutOrderCreateInput:{
		id:"UUID",
		confirmedAt:"DateTime",
		deletedAt:"DateTime",
		items:"CartCreateItemsEntityRelationInput",
		state:"CartState",
		createdAt:"DateTime",
		channel:"CartCreateChannelEntityRelationInput",
		customer:"CartCreateCustomerEntityRelationInput",
		deliveryAddress:"CartCreateDeliveryAddressEntityRelationInput",
		billingAddress:"CartCreateBillingAddressEntityRelationInput",
		delivery:"CartCreateDeliveryEntityRelationInput",
		payment:"CartCreatePaymentEntityRelationInput",
		billingSubject:"CartCreateBillingSubjectEntityRelationInput",
		priceLines:"CartCreatePriceLinesEntityRelationInput",
		summary:"CartCreateSummaryEntityRelationInput"
	},
	CartCreateCustomerEntityRelationInput:{
		connect:"CustomerUniqueWhere",
		create:"CustomerWithoutCartsCreateInput"
	},
	CustomerWithoutCartsCreateInput:{
		id:"UUID",
		addresses:"CustomerCreateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerCreateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerCreateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerCreateTagsEntityRelationInput",
		credits:"CustomerCreateCreditsEntityRelationInput",
		paymentMethods:"CustomerCreatePaymentMethodsEntityRelationInput",
		orders:"CustomerCreateOrdersEntityRelationInput",
		permissions:"CustomerCreatePermissionsEntityRelationInput",
		group:"CustomerCreateGroupEntityRelationInput",
		photo:"CustomerCreatePhotoEntityRelationInput",
		name:"CustomerCreateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerCreateIngredientRatingsEntityRelationInput",
		business:"CustomerCreateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerCreateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerCreateMemberOfBusinessesEntityRelationInput",
		shortcutList:"CustomerCreateShortcutListEntityRelationInput",
		user:"CustomerCreateUserEntityRelationInput",
		channels:"CustomerCreateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerCreateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerCreateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerCreateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerCreateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerCreateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerCreateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerCreateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerCreateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerCreateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerCreateRedeemedVouchersEntityRelationInput",
		spending:"CustomerCreateSpendingEntityRelationInput",
		customerTabs:"CustomerCreateCustomerTabsEntityRelationInput",
		lead:"CustomerCreateLeadEntityRelationInput",
		meta:"CustomerCreateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerCreateInvoicingPlanEntityRelationInput:{
		connect:"InvoicingPlanUniqueWhere",
		create:"InvoicingPlanWithoutCustomerCreateInput"
	},
	InvoicingPlanWithoutCustomerCreateInput:{
		id:"UUID",
		preset:"InvoicingPlanCreatePresetEntityRelationInput"
	},
	InvoicingPlanCreatePresetEntityRelationInput:{
		connect:"InvoicingPresetUniqueWhere",
		create:"InvoicingPresetWithoutInvoicingPlanCreateInput"
	},
	InvoicingPresetWithoutInvoicingPlanCreateInput:{
		id:"UUID",
		type:"InvoicingPresetType",
		startsAt:"DateTime",
		endsAt:"DateTime"
	},
	CustomerCreateBillingSubjectsEntityRelationInput:{
		connect:"BillingSubjectUniqueWhere",
		create:"BillingSubjectWithoutCustomerCreateInput"
	},
	BillingSubjectWithoutCustomerCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		deletedAt:"DateTime",
		country:"BillingSubjectCreateCountryEntityRelationInput",
		invoices:"BillingSubjectCreateInvoicesEntityRelationInput",
		defaultBillingSubjectOfCustomer:"BillingSubjectCreateDefaultBillingSubjectOfCustomerEntityRelationInput",
		orders:"BillingSubjectCreateOrdersEntityRelationInput"
	},
	BillingSubjectCreateCountryEntityRelationInput:{
		connect:"CountryUniqueWhere",
		create:"CountryCreateInput"
	},
	BillingSubjectCreateInvoicesEntityRelationInput:{
		connect:"InvoiceUniqueWhere",
		create:"InvoiceWithoutBillingSubjectCreateInput"
	},
	InvoiceWithoutBillingSubjectCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		customer:"InvoiceCreateCustomerEntityRelationInput",
		orderPayments:"InvoiceCreateOrderPaymentsEntityRelationInput",
		address:"InvoiceCreateAddressEntityRelationInput"
	},
	InvoiceCreateAddressEntityRelationInput:{
		connect:"AddressUniqueWhere",
		create:"AddressWithoutInvoicesCreateInput"
	},
	AddressWithoutInvoicesCreateInput:{
		id:"UUID",
		customer:"AddressCreateCustomerEntityRelationInput",
		country:"AddressCreateCountryEntityRelationInput",
		deletedAt:"DateTime",
		geocodeGeneratedAt:"DateTime",
		deliveryZone:"AddressCreateDeliveryZoneEntityRelationInput",
		meta:"AddressCreateMetaEntityRelationInput",
		gps:"AddressCreateGpsEntityRelationInput",
		createdAt:"DateTime",
		billingAddressOfOrders:"AddressCreateBillingAddressOfOrdersEntityRelationInput",
		deliveryAddressOfOrderDeliveries:"AddressCreateDeliveryAddressOfOrderDeliveriesEntityRelationInput",
		defaultDeliveryAddressOfCustomer:"AddressCreateDefaultDeliveryAddressOfCustomerEntityRelationInput"
	},
	AddressCreateBillingAddressOfOrdersEntityRelationInput:{
		connect:"OrderUniqueWhere",
		create:"OrderWithoutBillingAddressCreateInput"
	},
	OrderWithoutBillingAddressCreateInput:{
		id:"UUID",
		state:"OrderState",
		fulfilledAt:"DateTime",
		canceledAt:"DateTime",
		customer:"OrderCreateCustomerEntityRelationInput",
		channel:"OrderCreateChannelEntityRelationInput",
		discounts:"OrderCreateDiscountsEntityRelationInput",
		delivery:"OrderCreateDeliveryEntityRelationInput",
		items:"OrderCreateItemsEntityRelationInput",
		cart:"OrderCreateCartEntityRelationInput",
		events:"OrderCreateEventsEntityRelationInput",
		createdAt:"DateTime",
		priceLines:"OrderCreatePriceLinesEntityRelationInput",
		payments:"OrderCreatePaymentsEntityRelationInput",
		billingSubject:"OrderCreateBillingSubjectEntityRelationInput",
		summary:"OrderCreateSummaryEntityRelationInput",
		gratuity:"OrderCreateGratuityEntityRelationInput",
		venue:"OrderCreateVenueEntityRelationInput",
		fulfillmentNotes:"OrderCreateFulfillmentNotesEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	OrderCreateEventsEntityRelationInput:{
		connect:"OrderEventUniqueWhere",
		create:"OrderEventWithoutOrderCreateInput"
	},
	OrderEventWithoutOrderCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		payment:"OrderEventCreatePaymentEntityRelationInput",
		delivery:"OrderEventCreateDeliveryEntityRelationInput"
	},
	OrderEventCreatePaymentEntityRelationInput:{
		connect:"OrderPaymentUniqueWhere",
		create:"OrderPaymentWithoutEventsCreateInput"
	},
	OrderPaymentWithoutEventsCreateInput:{
		id:"UUID",
		data:"Json",
		method:"OrderPaymentCreateMethodEntityRelationInput",
		failedAt:"DateTime",
		state:"OrderPaymentState",
		approvedAt:"DateTime",
		order:"OrderPaymentCreateOrderEntityRelationInput",
		invoice:"OrderPaymentCreateInvoiceEntityRelationInput",
		createdAt:"DateTime",
		vatRate:"OrderPaymentCreateVatRateEntityRelationInput",
		meta:"OrderPaymentCreateMetaEntityRelationInput"
	},
	OrderPaymentCreateOrderEntityRelationInput:{
		connect:"OrderUniqueWhere",
		create:"OrderWithoutPaymentsCreateInput"
	},
	OrderWithoutPaymentsCreateInput:{
		id:"UUID",
		state:"OrderState",
		fulfilledAt:"DateTime",
		canceledAt:"DateTime",
		customer:"OrderCreateCustomerEntityRelationInput",
		channel:"OrderCreateChannelEntityRelationInput",
		discounts:"OrderCreateDiscountsEntityRelationInput",
		delivery:"OrderCreateDeliveryEntityRelationInput",
		items:"OrderCreateItemsEntityRelationInput",
		cart:"OrderCreateCartEntityRelationInput",
		events:"OrderCreateEventsEntityRelationInput",
		createdAt:"DateTime",
		billingAddress:"OrderCreateBillingAddressEntityRelationInput",
		priceLines:"OrderCreatePriceLinesEntityRelationInput",
		billingSubject:"OrderCreateBillingSubjectEntityRelationInput",
		summary:"OrderCreateSummaryEntityRelationInput",
		gratuity:"OrderCreateGratuityEntityRelationInput",
		venue:"OrderCreateVenueEntityRelationInput",
		fulfillmentNotes:"OrderCreateFulfillmentNotesEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	OrderCreateBillingAddressEntityRelationInput:{
		connect:"AddressUniqueWhere",
		create:"AddressWithoutBillingAddressOfOrdersCreateInput"
	},
	AddressWithoutBillingAddressOfOrdersCreateInput:{
		id:"UUID",
		customer:"AddressCreateCustomerEntityRelationInput",
		country:"AddressCreateCountryEntityRelationInput",
		deletedAt:"DateTime",
		geocodeGeneratedAt:"DateTime",
		deliveryZone:"AddressCreateDeliveryZoneEntityRelationInput",
		meta:"AddressCreateMetaEntityRelationInput",
		gps:"AddressCreateGpsEntityRelationInput",
		invoices:"AddressCreateInvoicesEntityRelationInput",
		createdAt:"DateTime",
		deliveryAddressOfOrderDeliveries:"AddressCreateDeliveryAddressOfOrderDeliveriesEntityRelationInput",
		defaultDeliveryAddressOfCustomer:"AddressCreateDefaultDeliveryAddressOfCustomerEntityRelationInput"
	},
	AddressCreateDeliveryAddressOfOrderDeliveriesEntityRelationInput:{
		connect:"OrderDeliveryUniqueWhere",
		create:"OrderDeliveryWithoutAddressCreateInput"
	},
	OrderDeliveryWithoutAddressCreateInput:{
		id:"UUID",
		deliveredAt:"DateTime",
		method:"OrderDeliveryCreateMethodEntityRelationInput",
		vatRate:"OrderDeliveryCreateVatRateEntityRelationInput",
		order:"OrderDeliveryCreateOrderEntityRelationInput",
		expectedAt:"DateTime",
		state:"OrderDeliveryState",
		dispatchAt:"DateTime",
		expectedEndAt:"DateTime",
		processingAt:"DateTime",
		deliveringAt:"DateTime",
		failedAt:"DateTime",
		deliveryWaypoint:"OrderDeliveryCreateDeliveryWaypointEntityRelationInput",
		events:"OrderDeliveryCreateEventsEntityRelationInput",
		prepareAt:"DateTime",
		liftagoRide:"OrderDeliveryCreateLiftagoRideEntityRelationInput",
		pickedAt:"DateTime",
		woltDriveDelivery:"OrderDeliveryCreateWoltDriveDeliveryEntityRelationInput"
	},
	OrderDeliveryCreateOrderEntityRelationInput:{
		connect:"OrderUniqueWhere",
		create:"OrderWithoutDeliveryCreateInput"
	},
	OrderWithoutDeliveryCreateInput:{
		id:"UUID",
		state:"OrderState",
		fulfilledAt:"DateTime",
		canceledAt:"DateTime",
		customer:"OrderCreateCustomerEntityRelationInput",
		channel:"OrderCreateChannelEntityRelationInput",
		discounts:"OrderCreateDiscountsEntityRelationInput",
		items:"OrderCreateItemsEntityRelationInput",
		cart:"OrderCreateCartEntityRelationInput",
		events:"OrderCreateEventsEntityRelationInput",
		createdAt:"DateTime",
		billingAddress:"OrderCreateBillingAddressEntityRelationInput",
		priceLines:"OrderCreatePriceLinesEntityRelationInput",
		payments:"OrderCreatePaymentsEntityRelationInput",
		billingSubject:"OrderCreateBillingSubjectEntityRelationInput",
		summary:"OrderCreateSummaryEntityRelationInput",
		gratuity:"OrderCreateGratuityEntityRelationInput",
		venue:"OrderCreateVenueEntityRelationInput",
		fulfillmentNotes:"OrderCreateFulfillmentNotesEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	OrderCreatePriceLinesEntityRelationInput:{
		connect:"OrderPriceLineUniqueWhere"
	},
	OrderCreatePaymentsEntityRelationInput:{
		connect:"OrderPaymentUniqueWhere",
		create:"OrderPaymentWithoutOrderCreateInput"
	},
	OrderPaymentWithoutOrderCreateInput:{
		id:"UUID",
		data:"Json",
		method:"OrderPaymentCreateMethodEntityRelationInput",
		failedAt:"DateTime",
		state:"OrderPaymentState",
		approvedAt:"DateTime",
		events:"OrderPaymentCreateEventsEntityRelationInput",
		invoice:"OrderPaymentCreateInvoiceEntityRelationInput",
		createdAt:"DateTime",
		vatRate:"OrderPaymentCreateVatRateEntityRelationInput",
		meta:"OrderPaymentCreateMetaEntityRelationInput"
	},
	OrderPaymentCreateInvoiceEntityRelationInput:{
		connect:"InvoiceUniqueWhere",
		create:"InvoiceWithoutOrderPaymentsCreateInput"
	},
	InvoiceWithoutOrderPaymentsCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		customer:"InvoiceCreateCustomerEntityRelationInput",
		address:"InvoiceCreateAddressEntityRelationInput",
		billingSubject:"InvoiceCreateBillingSubjectEntityRelationInput"
	},
	InvoiceCreateBillingSubjectEntityRelationInput:{
		connect:"BillingSubjectUniqueWhere",
		create:"BillingSubjectWithoutInvoicesCreateInput"
	},
	BillingSubjectWithoutInvoicesCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		deletedAt:"DateTime",
		country:"BillingSubjectCreateCountryEntityRelationInput",
		customer:"BillingSubjectCreateCustomerEntityRelationInput",
		defaultBillingSubjectOfCustomer:"BillingSubjectCreateDefaultBillingSubjectOfCustomerEntityRelationInput",
		orders:"BillingSubjectCreateOrdersEntityRelationInput"
	},
	BillingSubjectCreateCustomerEntityRelationInput:{
		connect:"CustomerUniqueWhere",
		create:"CustomerWithoutBillingSubjectsCreateInput"
	},
	CustomerWithoutBillingSubjectsCreateInput:{
		id:"UUID",
		addresses:"CustomerCreateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerCreateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerCreateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerCreateTagsEntityRelationInput",
		credits:"CustomerCreateCreditsEntityRelationInput",
		paymentMethods:"CustomerCreatePaymentMethodsEntityRelationInput",
		orders:"CustomerCreateOrdersEntityRelationInput",
		permissions:"CustomerCreatePermissionsEntityRelationInput",
		group:"CustomerCreateGroupEntityRelationInput",
		photo:"CustomerCreatePhotoEntityRelationInput",
		name:"CustomerCreateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerCreateIngredientRatingsEntityRelationInput",
		business:"CustomerCreateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerCreateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerCreateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerCreateCartsEntityRelationInput",
		shortcutList:"CustomerCreateShortcutListEntityRelationInput",
		user:"CustomerCreateUserEntityRelationInput",
		channels:"CustomerCreateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerCreateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerCreateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		offeredProducts:"CustomerCreateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerCreateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerCreateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerCreateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerCreateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerCreateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerCreateRedeemedVouchersEntityRelationInput",
		spending:"CustomerCreateSpendingEntityRelationInput",
		customerTabs:"CustomerCreateCustomerTabsEntityRelationInput",
		lead:"CustomerCreateLeadEntityRelationInput",
		meta:"CustomerCreateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerCreateOfferedProductsEntityRelationInput:{
		connect:"ProductCustomerPriceUniqueWhere"
	},
	CustomerCreateDefaultDeliveryAddressEntityRelationInput:{
		connect:"AddressUniqueWhere",
		create:"AddressWithoutDefaultDeliveryAddressOfCustomerCreateInput"
	},
	AddressWithoutDefaultDeliveryAddressOfCustomerCreateInput:{
		id:"UUID",
		customer:"AddressCreateCustomerEntityRelationInput",
		country:"AddressCreateCountryEntityRelationInput",
		deletedAt:"DateTime",
		geocodeGeneratedAt:"DateTime",
		deliveryZone:"AddressCreateDeliveryZoneEntityRelationInput",
		meta:"AddressCreateMetaEntityRelationInput",
		gps:"AddressCreateGpsEntityRelationInput",
		invoices:"AddressCreateInvoicesEntityRelationInput",
		createdAt:"DateTime",
		billingAddressOfOrders:"AddressCreateBillingAddressOfOrdersEntityRelationInput",
		deliveryAddressOfOrderDeliveries:"AddressCreateDeliveryAddressOfOrderDeliveriesEntityRelationInput"
	},
	CustomerCreateDefaultBillingSubjectEntityRelationInput:{
		connect:"BillingSubjectUniqueWhere",
		create:"BillingSubjectWithoutDefaultBillingSubjectOfCustomerCreateInput"
	},
	BillingSubjectWithoutDefaultBillingSubjectOfCustomerCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		deletedAt:"DateTime",
		country:"BillingSubjectCreateCountryEntityRelationInput",
		customer:"BillingSubjectCreateCustomerEntityRelationInput",
		invoices:"BillingSubjectCreateInvoicesEntityRelationInput",
		orders:"BillingSubjectCreateOrdersEntityRelationInput"
	},
	BillingSubjectCreateOrdersEntityRelationInput:{
		connect:"OrderUniqueWhere",
		create:"OrderWithoutBillingSubjectCreateInput"
	},
	OrderWithoutBillingSubjectCreateInput:{
		id:"UUID",
		state:"OrderState",
		fulfilledAt:"DateTime",
		canceledAt:"DateTime",
		customer:"OrderCreateCustomerEntityRelationInput",
		channel:"OrderCreateChannelEntityRelationInput",
		discounts:"OrderCreateDiscountsEntityRelationInput",
		delivery:"OrderCreateDeliveryEntityRelationInput",
		items:"OrderCreateItemsEntityRelationInput",
		cart:"OrderCreateCartEntityRelationInput",
		events:"OrderCreateEventsEntityRelationInput",
		createdAt:"DateTime",
		billingAddress:"OrderCreateBillingAddressEntityRelationInput",
		priceLines:"OrderCreatePriceLinesEntityRelationInput",
		payments:"OrderCreatePaymentsEntityRelationInput",
		summary:"OrderCreateSummaryEntityRelationInput",
		gratuity:"OrderCreateGratuityEntityRelationInput",
		venue:"OrderCreateVenueEntityRelationInput",
		fulfillmentNotes:"OrderCreateFulfillmentNotesEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	OrderCreateSummaryEntityRelationInput:{
		connect:"OrderSummaryUniqueWhere"
	},
	OrderCreateGratuityEntityRelationInput:{
		connect:"GratuityUniqueWhere",
		create:"GratuityWithoutOrderCreateInput"
	},
	GratuityWithoutOrderCreateInput:{
		id:"UUID"
	},
	OrderCreateVenueEntityRelationInput:{
		connect:"VenueUniqueWhere",
		create:"VenueWithoutOrdersCreateInput"
	},
	VenueWithoutOrdersCreateInput:{
		id:"UUID",
		deadlineTemplate:"VenueCreateDeadlineTemplateEntityRelationInput",
		timetableDays:"VenueCreateTimetableDaysEntityRelationInput",
		timetableTemplates:"VenueCreateTimetableTemplatesEntityRelationInput",
		staffMembers:"VenueCreateStaffMembersEntityRelationInput",
		employeeRoles:"VenueCreateEmployeeRolesEntityRelationInput",
		pointOfSaleApplicationDevices:"VenueCreatePointOfSaleApplicationDevicesEntityRelationInput",
		pointOfSaleTerminals:"VenueCreatePointOfSaleTerminalsEntityRelationInput",
		pointOfSalePrinters:"VenueCreatePointOfSalePrintersEntityRelationInput",
		fulfillmentNotes:"VenueCreateFulfillmentNotesEntityRelationInput",
		areas:"VenueCreateAreasEntityRelationInput",
		enabledUnassignReasons:"VenueCreateEnabledUnassignReasonsEntityRelationInput",
		categories:"VenueCreateCategoriesEntityRelationInput",
		channels:"VenueCreateChannelsEntityRelationInput",
		pointOfSaleInitialView:"PointOfSaleInitialView"
	},
	VenueCreateFulfillmentNotesEntityRelationInput:{
		connect:"FulfillmentNoteUniqueWhere",
		create:"FulfillmentNoteWithoutVenuesCreateInput"
	},
	FulfillmentNoteWithoutVenuesCreateInput:{
		id:"UUID",
		products:"FulfillmentNoteCreateProductsEntityRelationInput",
		tags:"FulfillmentNoteCreateTagsEntityRelationInput",
		cartItems:"FulfillmentNoteCreateCartItemsEntityRelationInput",
		orderItems:"FulfillmentNoteCreateOrderItemsEntityRelationInput",
		orders:"FulfillmentNoteCreateOrdersEntityRelationInput",
		createdAt:"DateTime"
	},
	FulfillmentNoteCreateCartItemsEntityRelationInput:{
		connect:"CartItemUniqueWhere",
		create:"CartItemWithoutFulfillmentNotesCreateInput"
	},
	CartItemWithoutFulfillmentNotesCreateInput:{
		id:"UUID",
		cart:"CartItemCreateCartEntityRelationInput",
		product:"CartItemCreateProductEntityRelationInput",
		createdAt:"DateTime",
		updatedAt:"DateTime"
	},
	FulfillmentNoteCreateOrderItemsEntityRelationInput:{
		connect:"OrderItemUniqueWhere",
		create:"OrderItemWithoutFulfillmentNotesCreateInput"
	},
	OrderItemWithoutFulfillmentNotesCreateInput:{
		id:"UUID",
		vatRate:"OrderItemCreateVatRateEntityRelationInput",
		order:"OrderItemCreateOrderEntityRelationInput",
		virtualProductEffects:"OrderItemCreateVirtualProductEffectsEntityRelationInput",
		pickedAt:"DateTime",
		product:"OrderItemCreateProductEntityRelationInput"
	},
	OrderItemCreateProductEntityRelationInput:{
		connect:"ProductUniqueWhere",
		create:"ProductWithoutOrderItemsCreateInput"
	},
	ProductWithoutOrderItemsCreateInput:{
		id:"UUID",
		packing:"ProductCreatePackingEntityRelationInput",
		recipe:"ProductCreateRecipeEntityRelationInput",
		tags:"ProductCreateTagsEntityRelationInput",
		categories:"ProductCreateCategoriesEntityRelationInput",
		vatRate:"ProductCreateVatRateEntityRelationInput",
		stocks:"ProductCreateStocksEntityRelationInput",
		groupPrices:"ProductCreateGroupPricesEntityRelationInput",
		image:"ProductCreateImageEntityRelationInput",
		cartItems:"ProductCreateCartItemsEntityRelationInput",
		availability:"ProductAvailability",
		manager:"ProductCreateManagerEntityRelationInput",
		inheritedCategories:"ProductCreateInheritedCategoriesEntityRelationInput",
		deliveryZones:"ProductCreateDeliveryZonesEntityRelationInput",
		locales:"ProductCreateLocalesEntityRelationInput",
		archivedAt:"DateTime",
		customerPrices:"ProductCreateCustomerPricesEntityRelationInput",
		virtualProduct:"ProductCreateVirtualProductEntityRelationInput",
		meta:"ProductCreateMetaEntityRelationInput",
		page:"ProductCreatePageEntityRelationInput",
		salesDays:"ProductCreateSalesDaysEntityRelationInput",
		salesWeeks:"ProductCreateSalesWeeksEntityRelationInput",
		salesMonths:"ProductCreateSalesMonthsEntityRelationInput",
		fulfillmentNotes:"ProductCreateFulfillmentNotesEntityRelationInput"
	},
	FulfillmentNoteCreateOrdersEntityRelationInput:{
		connect:"OrderUniqueWhere",
		create:"OrderWithoutFulfillmentNotesCreateInput"
	},
	OrderWithoutFulfillmentNotesCreateInput:{
		id:"UUID",
		state:"OrderState",
		fulfilledAt:"DateTime",
		canceledAt:"DateTime",
		customer:"OrderCreateCustomerEntityRelationInput",
		channel:"OrderCreateChannelEntityRelationInput",
		discounts:"OrderCreateDiscountsEntityRelationInput",
		delivery:"OrderCreateDeliveryEntityRelationInput",
		items:"OrderCreateItemsEntityRelationInput",
		cart:"OrderCreateCartEntityRelationInput",
		events:"OrderCreateEventsEntityRelationInput",
		createdAt:"DateTime",
		billingAddress:"OrderCreateBillingAddressEntityRelationInput",
		priceLines:"OrderCreatePriceLinesEntityRelationInput",
		payments:"OrderCreatePaymentsEntityRelationInput",
		billingSubject:"OrderCreateBillingSubjectEntityRelationInput",
		summary:"OrderCreateSummaryEntityRelationInput",
		gratuity:"OrderCreateGratuityEntityRelationInput",
		venue:"OrderCreateVenueEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	OrderCreateBillingSubjectEntityRelationInput:{
		connect:"BillingSubjectUniqueWhere",
		create:"BillingSubjectWithoutOrdersCreateInput"
	},
	BillingSubjectWithoutOrdersCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		deletedAt:"DateTime",
		country:"BillingSubjectCreateCountryEntityRelationInput",
		customer:"BillingSubjectCreateCustomerEntityRelationInput",
		invoices:"BillingSubjectCreateInvoicesEntityRelationInput",
		defaultBillingSubjectOfCustomer:"BillingSubjectCreateDefaultBillingSubjectOfCustomerEntityRelationInput"
	},
	BillingSubjectCreateDefaultBillingSubjectOfCustomerEntityRelationInput:{
		connect:"CustomerUniqueWhere",
		create:"CustomerWithoutDefaultBillingSubjectCreateInput"
	},
	CustomerWithoutDefaultBillingSubjectCreateInput:{
		id:"UUID",
		addresses:"CustomerCreateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerCreateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerCreateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerCreateTagsEntityRelationInput",
		credits:"CustomerCreateCreditsEntityRelationInput",
		paymentMethods:"CustomerCreatePaymentMethodsEntityRelationInput",
		orders:"CustomerCreateOrdersEntityRelationInput",
		permissions:"CustomerCreatePermissionsEntityRelationInput",
		group:"CustomerCreateGroupEntityRelationInput",
		photo:"CustomerCreatePhotoEntityRelationInput",
		name:"CustomerCreateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerCreateIngredientRatingsEntityRelationInput",
		business:"CustomerCreateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerCreateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerCreateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerCreateCartsEntityRelationInput",
		shortcutList:"CustomerCreateShortcutListEntityRelationInput",
		user:"CustomerCreateUserEntityRelationInput",
		channels:"CustomerCreateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerCreateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerCreateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerCreateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerCreateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerCreateDefaultDeliveryAddressEntityRelationInput",
		anonymousSession:"CustomerCreateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerCreateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerCreateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerCreateRedeemedVouchersEntityRelationInput",
		spending:"CustomerCreateSpendingEntityRelationInput",
		customerTabs:"CustomerCreateCustomerTabsEntityRelationInput",
		lead:"CustomerCreateLeadEntityRelationInput",
		meta:"CustomerCreateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerCreateAnonymousSessionEntityRelationInput:{
		connect:"AnonymousSessionUniqueWhere",
		create:"AnonymousSessionWithoutCustomerCreateInput"
	},
	AnonymousSessionWithoutCustomerCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		lastActiveAt:"DateTime",
		devices:"AnonymousSessionCreateDevicesEntityRelationInput"
	},
	AnonymousSessionCreateDevicesEntityRelationInput:{
		connect:"UserDeviceUniqueWhere",
		create:"UserDeviceWithoutAnonymousSessionCreateInput"
	},
	UserDeviceWithoutAnonymousSessionCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		lastActiveAt:"DateTime",
		user:"UserDeviceCreateUserEntityRelationInput"
	},
	UserDeviceCreateUserEntityRelationInput:{
		connect:"UserUniqueWhere",
		create:"UserWithoutDevicesCreateInput"
	},
	UserWithoutDevicesCreateInput:{
		id:"UUID",
		staff:"UserCreateStaffEntityRelationInput",
		customer:"UserCreateCustomerEntityRelationInput",
		tenantPersonId:"UUID",
		disabledAt:"DateTime",
		verifiedAt:"DateTime",
		createdAt:"DateTime",
		deletionRequestedAt:"DateTime",
		deletionExpectedAt:"DateTime",
		deletedAt:"DateTime",
		meta:"UserCreateMetaEntityRelationInput",
		identificationAttempts:"UserCreateIdentificationAttemptsEntityRelationInput",
		roles:"UserCreateRolesEntityRelationInput"
	},
	UserCreateRolesEntityRelationInput:{
		connect:"UserRolesUniqueWhere"
	},
	CustomerCreateBoughtVouchersEntityRelationInput:{
		connect:"VoucherUniqueWhere",
		create:"VoucherWithoutBuyerCreateInput"
	},
	VoucherWithoutBuyerCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		activatedAt:"DateTime",
		expiresAt:"DateTime",
		type:"VoucherType",
		owner:"VoucherCreateOwnerEntityRelationInput",
		vatRate:"VoucherCreateVatRateEntityRelationInput",
		virtualProductEffect:"VoucherCreateVirtualProductEffectEntityRelationInput",
		redemption:"VoucherCreateRedemptionEntityRelationInput"
	},
	VoucherCreateOwnerEntityRelationInput:{
		connect:"CustomerUniqueWhere",
		create:"CustomerWithoutOwnsVouchersCreateInput"
	},
	CustomerWithoutOwnsVouchersCreateInput:{
		id:"UUID",
		addresses:"CustomerCreateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerCreateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerCreateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerCreateTagsEntityRelationInput",
		credits:"CustomerCreateCreditsEntityRelationInput",
		paymentMethods:"CustomerCreatePaymentMethodsEntityRelationInput",
		orders:"CustomerCreateOrdersEntityRelationInput",
		permissions:"CustomerCreatePermissionsEntityRelationInput",
		group:"CustomerCreateGroupEntityRelationInput",
		photo:"CustomerCreatePhotoEntityRelationInput",
		name:"CustomerCreateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerCreateIngredientRatingsEntityRelationInput",
		business:"CustomerCreateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerCreateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerCreateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerCreateCartsEntityRelationInput",
		shortcutList:"CustomerCreateShortcutListEntityRelationInput",
		user:"CustomerCreateUserEntityRelationInput",
		channels:"CustomerCreateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerCreateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerCreateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerCreateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerCreateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerCreateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerCreateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerCreateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerCreateBoughtVouchersEntityRelationInput",
		redeemedVouchers:"CustomerCreateRedeemedVouchersEntityRelationInput",
		spending:"CustomerCreateSpendingEntityRelationInput",
		customerTabs:"CustomerCreateCustomerTabsEntityRelationInput",
		lead:"CustomerCreateLeadEntityRelationInput",
		meta:"CustomerCreateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerCreateRedeemedVouchersEntityRelationInput:{
		connect:"VoucherRedemptionUniqueWhere",
		create:"VoucherRedemptionWithoutCustomerCreateInput"
	},
	VoucherRedemptionWithoutCustomerCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		customerCredit:"VoucherRedemptionCreateCustomerCreditEntityRelationInput",
		orderDiscount:"VoucherRedemptionCreateOrderDiscountEntityRelationInput",
		voucher:"VoucherRedemptionCreateVoucherEntityRelationInput"
	},
	VoucherRedemptionCreateCustomerCreditEntityRelationInput:{
		connect:"CustomerCreditUniqueWhere",
		create:"CustomerCreditWithoutVoucherRedemptionCreateInput"
	},
	CustomerCreditWithoutVoucherRedemptionCreateInput:{
		id:"UUID",
		expiresAt:"DateTime",
		customer:"CustomerCreditCreateCustomerEntityRelationInput",
		vatRate:"CustomerCreditCreateVatRateEntityRelationInput",
		createdAt:"DateTime",
		transactions:"CustomerCreditCreateTransactionsEntityRelationInput"
	},
	CustomerCreditCreateTransactionsEntityRelationInput:{
		connect:"CustomerCreditTransactionUniqueWhere",
		create:"CustomerCreditTransactionWithoutCustomerCreditCreateInput"
	},
	CustomerCreditTransactionWithoutCustomerCreditCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		orderDiscount:"CustomerCreditTransactionCreateOrderDiscountEntityRelationInput",
		virtualProductEffect:"CustomerCreditTransactionCreateVirtualProductEffectEntityRelationInput"
	},
	CustomerCreditTransactionCreateVirtualProductEffectEntityRelationInput:{
		connect:"VirtualProductEffectUniqueWhere",
		create:"VirtualProductEffectWithoutResultCustomerCreditTransactionCreateInput"
	},
	VirtualProductEffectWithoutResultCustomerCreditTransactionCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		succeededAt:"DateTime",
		orderItem:"VirtualProductEffectCreateOrderItemEntityRelationInput",
		failedAt:"DateTime",
		revertedAt:"DateTime",
		resultVouchers:"VirtualProductEffectCreateResultVouchersEntityRelationInput"
	},
	VirtualProductEffectCreateOrderItemEntityRelationInput:{
		connect:"OrderItemUniqueWhere",
		create:"OrderItemWithoutVirtualProductEffectsCreateInput"
	},
	OrderItemWithoutVirtualProductEffectsCreateInput:{
		id:"UUID",
		vatRate:"OrderItemCreateVatRateEntityRelationInput",
		order:"OrderItemCreateOrderEntityRelationInput",
		pickedAt:"DateTime",
		fulfillmentNotes:"OrderItemCreateFulfillmentNotesEntityRelationInput",
		product:"OrderItemCreateProductEntityRelationInput"
	},
	OrderItemCreateFulfillmentNotesEntityRelationInput:{
		connect:"FulfillmentNoteUniqueWhere",
		create:"FulfillmentNoteWithoutOrderItemsCreateInput"
	},
	FulfillmentNoteWithoutOrderItemsCreateInput:{
		id:"UUID",
		products:"FulfillmentNoteCreateProductsEntityRelationInput",
		tags:"FulfillmentNoteCreateTagsEntityRelationInput",
		venues:"FulfillmentNoteCreateVenuesEntityRelationInput",
		cartItems:"FulfillmentNoteCreateCartItemsEntityRelationInput",
		orders:"FulfillmentNoteCreateOrdersEntityRelationInput",
		createdAt:"DateTime"
	},
	VirtualProductEffectCreateResultVouchersEntityRelationInput:{
		connect:"VoucherUniqueWhere",
		create:"VoucherWithoutVirtualProductEffectCreateInput"
	},
	VoucherWithoutVirtualProductEffectCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		activatedAt:"DateTime",
		expiresAt:"DateTime",
		type:"VoucherType",
		buyer:"VoucherCreateBuyerEntityRelationInput",
		owner:"VoucherCreateOwnerEntityRelationInput",
		vatRate:"VoucherCreateVatRateEntityRelationInput",
		redemption:"VoucherCreateRedemptionEntityRelationInput"
	},
	VoucherCreateBuyerEntityRelationInput:{
		connect:"CustomerUniqueWhere",
		create:"CustomerWithoutBoughtVouchersCreateInput"
	},
	CustomerWithoutBoughtVouchersCreateInput:{
		id:"UUID",
		addresses:"CustomerCreateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerCreateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerCreateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerCreateTagsEntityRelationInput",
		credits:"CustomerCreateCreditsEntityRelationInput",
		paymentMethods:"CustomerCreatePaymentMethodsEntityRelationInput",
		orders:"CustomerCreateOrdersEntityRelationInput",
		permissions:"CustomerCreatePermissionsEntityRelationInput",
		group:"CustomerCreateGroupEntityRelationInput",
		photo:"CustomerCreatePhotoEntityRelationInput",
		name:"CustomerCreateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerCreateIngredientRatingsEntityRelationInput",
		business:"CustomerCreateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerCreateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerCreateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerCreateCartsEntityRelationInput",
		shortcutList:"CustomerCreateShortcutListEntityRelationInput",
		user:"CustomerCreateUserEntityRelationInput",
		channels:"CustomerCreateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerCreateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerCreateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerCreateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerCreateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerCreateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerCreateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerCreateAnonymousSessionEntityRelationInput",
		ownsVouchers:"CustomerCreateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerCreateRedeemedVouchersEntityRelationInput",
		spending:"CustomerCreateSpendingEntityRelationInput",
		customerTabs:"CustomerCreateCustomerTabsEntityRelationInput",
		lead:"CustomerCreateLeadEntityRelationInput",
		meta:"CustomerCreateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerCreateOwnsVouchersEntityRelationInput:{
		connect:"VoucherUniqueWhere",
		create:"VoucherWithoutOwnerCreateInput"
	},
	VoucherWithoutOwnerCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		activatedAt:"DateTime",
		expiresAt:"DateTime",
		type:"VoucherType",
		buyer:"VoucherCreateBuyerEntityRelationInput",
		vatRate:"VoucherCreateVatRateEntityRelationInput",
		virtualProductEffect:"VoucherCreateVirtualProductEffectEntityRelationInput",
		redemption:"VoucherCreateRedemptionEntityRelationInput"
	},
	VoucherCreateVatRateEntityRelationInput:{
		connect:"VatRateUniqueWhere",
		create:"VatRateCreateInput"
	},
	VoucherCreateVirtualProductEffectEntityRelationInput:{
		connect:"VirtualProductEffectUniqueWhere",
		create:"VirtualProductEffectWithoutResultVouchersCreateInput"
	},
	VirtualProductEffectWithoutResultVouchersCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		succeededAt:"DateTime",
		orderItem:"VirtualProductEffectCreateOrderItemEntityRelationInput",
		failedAt:"DateTime",
		revertedAt:"DateTime",
		resultCustomerCreditTransaction:"VirtualProductEffectCreateResultCustomerCreditTransactionEntityRelationInput"
	},
	VoucherCreateRedemptionEntityRelationInput:{
		connect:"VoucherRedemptionUniqueWhere",
		create:"VoucherRedemptionWithoutVoucherCreateInput"
	},
	VoucherRedemptionWithoutVoucherCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		customerCredit:"VoucherRedemptionCreateCustomerCreditEntityRelationInput",
		orderDiscount:"VoucherRedemptionCreateOrderDiscountEntityRelationInput",
		customer:"VoucherRedemptionCreateCustomerEntityRelationInput"
	},
	VoucherRedemptionCreateOrderDiscountEntityRelationInput:{
		connect:"OrderDiscountUniqueWhere",
		create:"OrderDiscountWithoutVoucherRedemptionCreateInput"
	},
	OrderDiscountWithoutVoucherRedemptionCreateInput:{
		id:"UUID",
		vatRate:"OrderDiscountCreateVatRateEntityRelationInput",
		order:"OrderDiscountCreateOrderEntityRelationInput",
		type:"OrderDiscountType",
		customerCreditTransactions:"OrderDiscountCreateCustomerCreditTransactionsEntityRelationInput"
	},
	VoucherRedemptionCreateCustomerEntityRelationInput:{
		connect:"CustomerUniqueWhere",
		create:"CustomerWithoutRedeemedVouchersCreateInput"
	},
	CustomerWithoutRedeemedVouchersCreateInput:{
		id:"UUID",
		addresses:"CustomerCreateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerCreateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerCreateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerCreateTagsEntityRelationInput",
		credits:"CustomerCreateCreditsEntityRelationInput",
		paymentMethods:"CustomerCreatePaymentMethodsEntityRelationInput",
		orders:"CustomerCreateOrdersEntityRelationInput",
		permissions:"CustomerCreatePermissionsEntityRelationInput",
		group:"CustomerCreateGroupEntityRelationInput",
		photo:"CustomerCreatePhotoEntityRelationInput",
		name:"CustomerCreateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerCreateIngredientRatingsEntityRelationInput",
		business:"CustomerCreateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerCreateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerCreateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerCreateCartsEntityRelationInput",
		shortcutList:"CustomerCreateShortcutListEntityRelationInput",
		user:"CustomerCreateUserEntityRelationInput",
		channels:"CustomerCreateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerCreateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerCreateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerCreateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerCreateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerCreateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerCreateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerCreateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerCreateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerCreateOwnsVouchersEntityRelationInput",
		spending:"CustomerCreateSpendingEntityRelationInput",
		customerTabs:"CustomerCreateCustomerTabsEntityRelationInput",
		lead:"CustomerCreateLeadEntityRelationInput",
		meta:"CustomerCreateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerCreateSpendingEntityRelationInput:{
		connect:"CustomerSpendingUniqueWhere"
	},
	CustomerCreateCustomerTabsEntityRelationInput:{
		connect:"CustomerTabUniqueWhere",
		create:"CustomerTabWithoutCustomerCreateInput"
	},
	CustomerTabWithoutCustomerCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		items:"CustomerTabCreateItemsEntityRelationInput",
		meta:"CustomerTabCreateMetaEntityRelationInput",
		table:"CustomerTabCreateTableEntityRelationInput",
		seat:"CustomerTabCreateSeatEntityRelationInput"
	},
	CustomerTabCreateItemsEntityRelationInput:{
		connect:"CustomerTabItemUniqueWhere",
		create:"CustomerTabItemWithoutTabCreateInput"
	},
	CustomerTabItemWithoutTabCreateInput:{
		id:"UUID",
		addedAt:"DateTime",
		product:"CustomerTabItemCreateProductEntityRelationInput",
		paidAt:"DateTime"
	},
	CustomerTabItemCreateProductEntityRelationInput:{
		connect:"ProductUniqueWhere",
		create:"ProductCreateInput"
	},
	CustomerTabCreateMetaEntityRelationInput:{
		connect:"CustomerTabMetadataUniqueWhere"
	},
	CustomerTabCreateTableEntityRelationInput:{
		connect:"TableUniqueWhere",
		create:"TableWithoutCustomerTabsCreateInput"
	},
	TableWithoutCustomerTabsCreateInput:{
		id:"UUID",
		shape:"TableShape",
		area:"TableCreateAreaEntityRelationInput",
		seats:"TableCreateSeatsEntityRelationInput"
	},
	TableCreateAreaEntityRelationInput:{
		connect:"AreaUniqueWhere",
		create:"AreaWithoutTablesCreateInput"
	},
	AreaWithoutTablesCreateInput:{
		id:"UUID",
		venue:"AreaCreateVenueEntityRelationInput",
		lines:"AreaCreateLinesEntityRelationInput"
	},
	AreaCreateVenueEntityRelationInput:{
		connect:"VenueUniqueWhere",
		create:"VenueWithoutAreasCreateInput"
	},
	VenueWithoutAreasCreateInput:{
		id:"UUID",
		deadlineTemplate:"VenueCreateDeadlineTemplateEntityRelationInput",
		timetableDays:"VenueCreateTimetableDaysEntityRelationInput",
		timetableTemplates:"VenueCreateTimetableTemplatesEntityRelationInput",
		staffMembers:"VenueCreateStaffMembersEntityRelationInput",
		employeeRoles:"VenueCreateEmployeeRolesEntityRelationInput",
		pointOfSaleApplicationDevices:"VenueCreatePointOfSaleApplicationDevicesEntityRelationInput",
		pointOfSaleTerminals:"VenueCreatePointOfSaleTerminalsEntityRelationInput",
		pointOfSalePrinters:"VenueCreatePointOfSalePrintersEntityRelationInput",
		orders:"VenueCreateOrdersEntityRelationInput",
		fulfillmentNotes:"VenueCreateFulfillmentNotesEntityRelationInput",
		enabledUnassignReasons:"VenueCreateEnabledUnassignReasonsEntityRelationInput",
		categories:"VenueCreateCategoriesEntityRelationInput",
		channels:"VenueCreateChannelsEntityRelationInput",
		pointOfSaleInitialView:"PointOfSaleInitialView"
	},
	VenueCreateEnabledUnassignReasonsEntityRelationInput:{
		connect:"UnassignReasonUniqueWhere",
		create:"UnassignReasonWithoutVenuesCreateInput"
	},
	UnassignReasonUniqueWhere:{
		id:"UUID"
	},
	UnassignReasonWithoutVenuesCreateInput:{
		id:"UUID"
	},
	VenueCreateCategoriesEntityRelationInput:{
		connect:"PointOfSaleCategoryUniqueWhere",
		create:"PointOfSaleCategoryWithoutVenueCreateInput"
	},
	PointOfSaleCategoryWithoutVenueCreateInput:{
		id:"UUID",
		locales:"PointOfSaleCategoryCreateLocalesEntityRelationInput",
		products:"PointOfSaleCategoryCreateProductsEntityRelationInput",
		category:"PointOfSaleCategoryCreateCategoryEntityRelationInput",
		ticketPrinters:"PointOfSaleCategoryCreateTicketPrintersEntityRelationInput"
	},
	PointOfSaleCategoryCreateCategoryEntityRelationInput:{
		connect:"ProductCategoryUniqueWhere",
		create:"ProductCategoryCreateInput"
	},
	PointOfSaleCategoryCreateTicketPrintersEntityRelationInput:{
		connect:"PointOfSalePrinterUniqueWhere",
		create:"PointOfSalePrinterWithoutTicketCategoriesCreateInput"
	},
	PointOfSalePrinterWithoutTicketCategoriesCreateInput:{
		id:"UUID",
		applicationDevicesReceipt:"PointOfSalePrinterCreateApplicationDevicesReceiptEntityRelationInput",
		applicationDevicesTicket:"PointOfSalePrinterCreateApplicationDevicesTicketEntityRelationInput",
		venue:"PointOfSalePrinterCreateVenueEntityRelationInput"
	},
	PointOfSalePrinterCreateApplicationDevicesTicketEntityRelationInput:{
		connect:"PointOfSaleApplicationDeviceUniqueWhere",
		create:"PointOfSaleApplicationDeviceWithoutTicketPrintersCreateInput"
	},
	PointOfSaleApplicationDeviceWithoutTicketPrintersCreateInput:{
		id:"UUID",
		venue:"PointOfSaleApplicationDeviceCreateVenueEntityRelationInput",
		identificationCode:"PointOfSaleApplicationDeviceCreateIdentificationCodeEntityRelationInput",
		identifier:"PointOfSaleApplicationDeviceCreateIdentifierEntityRelationInput",
		terminal:"PointOfSaleApplicationDeviceCreateTerminalEntityRelationInput",
		receiptPrinter:"PointOfSaleApplicationDeviceCreateReceiptPrinterEntityRelationInput"
	},
	PointOfSaleApplicationDeviceCreateReceiptPrinterEntityRelationInput:{
		connect:"PointOfSalePrinterUniqueWhere",
		create:"PointOfSalePrinterWithoutApplicationDevicesReceiptCreateInput"
	},
	PointOfSalePrinterWithoutApplicationDevicesReceiptCreateInput:{
		id:"UUID",
		applicationDevicesTicket:"PointOfSalePrinterCreateApplicationDevicesTicketEntityRelationInput",
		venue:"PointOfSalePrinterCreateVenueEntityRelationInput",
		ticketCategories:"PointOfSalePrinterCreateTicketCategoriesEntityRelationInput"
	},
	PointOfSalePrinterCreateVenueEntityRelationInput:{
		connect:"VenueUniqueWhere",
		create:"VenueWithoutPointOfSalePrintersCreateInput"
	},
	VenueWithoutPointOfSalePrintersCreateInput:{
		id:"UUID",
		deadlineTemplate:"VenueCreateDeadlineTemplateEntityRelationInput",
		timetableDays:"VenueCreateTimetableDaysEntityRelationInput",
		timetableTemplates:"VenueCreateTimetableTemplatesEntityRelationInput",
		staffMembers:"VenueCreateStaffMembersEntityRelationInput",
		employeeRoles:"VenueCreateEmployeeRolesEntityRelationInput",
		pointOfSaleApplicationDevices:"VenueCreatePointOfSaleApplicationDevicesEntityRelationInput",
		pointOfSaleTerminals:"VenueCreatePointOfSaleTerminalsEntityRelationInput",
		orders:"VenueCreateOrdersEntityRelationInput",
		fulfillmentNotes:"VenueCreateFulfillmentNotesEntityRelationInput",
		areas:"VenueCreateAreasEntityRelationInput",
		enabledUnassignReasons:"VenueCreateEnabledUnassignReasonsEntityRelationInput",
		categories:"VenueCreateCategoriesEntityRelationInput",
		channels:"VenueCreateChannelsEntityRelationInput",
		pointOfSaleInitialView:"PointOfSaleInitialView"
	},
	VenueCreateAreasEntityRelationInput:{
		connect:"AreaUniqueWhere",
		create:"AreaWithoutVenueCreateInput"
	},
	AreaWithoutVenueCreateInput:{
		id:"UUID",
		tables:"AreaCreateTablesEntityRelationInput",
		lines:"AreaCreateLinesEntityRelationInput"
	},
	AreaCreateTablesEntityRelationInput:{
		connect:"TableUniqueWhere",
		create:"TableWithoutAreaCreateInput"
	},
	TableWithoutAreaCreateInput:{
		id:"UUID",
		shape:"TableShape",
		customerTabs:"TableCreateCustomerTabsEntityRelationInput",
		seats:"TableCreateSeatsEntityRelationInput"
	},
	TableCreateCustomerTabsEntityRelationInput:{
		connect:"CustomerTabUniqueWhere",
		create:"CustomerTabWithoutTableCreateInput"
	},
	CustomerTabWithoutTableCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		items:"CustomerTabCreateItemsEntityRelationInput",
		meta:"CustomerTabCreateMetaEntityRelationInput",
		customer:"CustomerTabCreateCustomerEntityRelationInput",
		seat:"CustomerTabCreateSeatEntityRelationInput"
	},
	CustomerTabCreateCustomerEntityRelationInput:{
		connect:"CustomerUniqueWhere",
		create:"CustomerWithoutCustomerTabsCreateInput"
	},
	CustomerWithoutCustomerTabsCreateInput:{
		id:"UUID",
		addresses:"CustomerCreateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerCreateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerCreateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerCreateTagsEntityRelationInput",
		credits:"CustomerCreateCreditsEntityRelationInput",
		paymentMethods:"CustomerCreatePaymentMethodsEntityRelationInput",
		orders:"CustomerCreateOrdersEntityRelationInput",
		permissions:"CustomerCreatePermissionsEntityRelationInput",
		group:"CustomerCreateGroupEntityRelationInput",
		photo:"CustomerCreatePhotoEntityRelationInput",
		name:"CustomerCreateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerCreateIngredientRatingsEntityRelationInput",
		business:"CustomerCreateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerCreateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerCreateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerCreateCartsEntityRelationInput",
		shortcutList:"CustomerCreateShortcutListEntityRelationInput",
		user:"CustomerCreateUserEntityRelationInput",
		channels:"CustomerCreateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerCreateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerCreateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerCreateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerCreateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerCreateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerCreateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerCreateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerCreateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerCreateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerCreateRedeemedVouchersEntityRelationInput",
		spending:"CustomerCreateSpendingEntityRelationInput",
		lead:"CustomerCreateLeadEntityRelationInput",
		meta:"CustomerCreateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerCreateLeadEntityRelationInput:{
		connect:"PipelineLeadUniqueWhere",
		create:"PipelineLeadWithoutCustomerCreateInput"
	},
	PipelineLeadWithoutCustomerCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		stageItem:"PipelineLeadCreateStageItemEntityRelationInput",
		form:"PipelineLeadCreateFormEntityRelationInput"
	},
	PipelineLeadCreateStageItemEntityRelationInput:{
		connect:"PipelineStageItemUniqueWhere",
		create:"PipelineStageItemWithoutLeadCreateInput"
	},
	PipelineStageItemWithoutLeadCreateInput:{
		id:"UUID",
		list:"PipelineStageItemCreateListEntityRelationInput"
	},
	PipelineStageItemCreateListEntityRelationInput:{
		connect:"PipelineStageUniqueWhere",
		create:"PipelineStageWithoutItemsCreateInput"
	},
	PipelineStageWithoutItemsCreateInput:{
		id:"UUID",
		pipeline:"PipelineStageCreatePipelineEntityRelationInput",
		locales:"PipelineStageCreateLocalesEntityRelationInput",
		sentiment:"PipelineStageCreateSentimentEntityRelationInput",
		type:"PipelineStageType",
		forms:"PipelineStageCreateFormsEntityRelationInput"
	},
	PipelineStageCreatePipelineEntityRelationInput:{
		connect:"PipelineUniqueWhere",
		create:"PipelineWithoutStagesCreateInput"
	},
	PipelineUniqueWhere:{
		id:"UUID",
		unique:"One",
		stages:"PipelineStageUniqueWhere"
	},
	PipelineWithoutStagesCreateInput:{
		id:"UUID",
		unique:"One"
	},
	PipelineStageCreateLocalesEntityRelationInput:{
		connect:"PipelineStageLocaleUniqueWhere",
		create:"PipelineStageLocaleWithoutRootCreateInput"
	},
	PipelineStageLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"PipelineStageLocaleCreateLocaleEntityRelationInput"
	},
	PipelineStageLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutPipelineStagesCreateInput"
	},
	LocaleWithoutPipelineStagesCreateInput:{
		id:"UUID",
		businessCategories:"LocaleCreateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleCreateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleCreateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleCreateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleCreateBlogsEntityRelationInput",
		blogPosts:"LocaleCreateBlogPostsEntityRelationInput",
		identifier:"LocaleCreateIdentifierEntityRelationInput",
		menus:"LocaleCreateMenusEntityRelationInput",
		pages:"LocaleCreatePagesEntityRelationInput",
		productIngredientCategories:"LocaleCreateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleCreateAllergensEntityRelationInput",
		productPackings:"LocaleCreateProductPackingsEntityRelationInput",
		products:"LocaleCreateProductsEntityRelationInput",
		productRecipes:"LocaleCreateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleCreatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleCreatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleCreateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleCreateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleCreateIdentificationCodesEntityRelationInput",
		subscriptionBoxes:"LocaleCreateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleCreateBusinessServicesEntityRelationInput"
	},
	LocaleCreateSubscriptionBoxesEntityRelationInput:{
		connect:"SubscriptionBoxLocaleUniqueWhere",
		create:"SubscriptionBoxLocaleWithoutLocaleCreateInput"
	},
	SubscriptionBoxLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"SubscriptionBoxLocaleCreateRootEntityRelationInput",
		texts:"SubscriptionBoxLocaleCreateTextsEntityRelationInput",
		secondaryTexts:"SubscriptionBoxLocaleCreateSecondaryTextsEntityRelationInput"
	},
	SubscriptionBoxLocaleCreateRootEntityRelationInput:{
		connect:"SubscriptionBoxUniqueWhere",
		create:"SubscriptionBoxWithoutLocalesCreateInput"
	},
	SubscriptionBoxWithoutLocalesCreateInput:{
		id:"UUID",
		unique:"One"
	},
	SubscriptionBoxLocaleCreateTextsEntityRelationInput:{
		connect:"TextListUniqueWhere",
		create:"TextListCreateInput"
	},
	SubscriptionBoxLocaleCreateSecondaryTextsEntityRelationInput:{
		connect:"TextListUniqueWhere",
		create:"TextListCreateInput"
	},
	LocaleCreateBusinessServicesEntityRelationInput:{
		connect:"BusinessServiceLocaleUniqueWhere",
		create:"BusinessServiceLocaleWithoutLocaleCreateInput"
	},
	BusinessServiceLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"BusinessServiceLocaleCreateRootEntityRelationInput"
	},
	BusinessServiceLocaleCreateRootEntityRelationInput:{
		connect:"BusinessServiceUniqueWhere",
		create:"BusinessServiceWithoutLocalesCreateInput"
	},
	BusinessServiceWithoutLocalesCreateInput:{
		id:"UUID"
	},
	PipelineStageCreateSentimentEntityRelationInput:{
		connect:"PipelineStageSentimentUniqueWhere",
		create:"PipelineStageSentimentCreateInput"
	},
	PipelineStageSentimentUniqueWhere:{
		id:"UUID"
	},
	PipelineStageSentimentCreateInput:{
		id:"UUID"
	},
	PipelineStageCreateFormsEntityRelationInput:{
		connect:"LeadFormUniqueWhere",
		create:"LeadFormWithoutStageCreateInput"
	},
	LeadFormWithoutStageCreateInput:{
		id:"UUID",
		leads:"LeadFormCreateLeadsEntityRelationInput"
	},
	LeadFormCreateLeadsEntityRelationInput:{
		connect:"PipelineLeadUniqueWhere",
		create:"PipelineLeadWithoutFormCreateInput"
	},
	PipelineLeadWithoutFormCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		stageItem:"PipelineLeadCreateStageItemEntityRelationInput",
		customer:"PipelineLeadCreateCustomerEntityRelationInput"
	},
	PipelineLeadCreateCustomerEntityRelationInput:{
		connect:"CustomerUniqueWhere",
		create:"CustomerWithoutLeadCreateInput"
	},
	CustomerWithoutLeadCreateInput:{
		id:"UUID",
		addresses:"CustomerCreateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerCreateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerCreateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerCreateTagsEntityRelationInput",
		credits:"CustomerCreateCreditsEntityRelationInput",
		paymentMethods:"CustomerCreatePaymentMethodsEntityRelationInput",
		orders:"CustomerCreateOrdersEntityRelationInput",
		permissions:"CustomerCreatePermissionsEntityRelationInput",
		group:"CustomerCreateGroupEntityRelationInput",
		photo:"CustomerCreatePhotoEntityRelationInput",
		name:"CustomerCreateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerCreateIngredientRatingsEntityRelationInput",
		business:"CustomerCreateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerCreateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerCreateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerCreateCartsEntityRelationInput",
		shortcutList:"CustomerCreateShortcutListEntityRelationInput",
		user:"CustomerCreateUserEntityRelationInput",
		channels:"CustomerCreateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerCreateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerCreateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerCreateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerCreateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerCreateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerCreateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerCreateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerCreateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerCreateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerCreateRedeemedVouchersEntityRelationInput",
		spending:"CustomerCreateSpendingEntityRelationInput",
		customerTabs:"CustomerCreateCustomerTabsEntityRelationInput",
		meta:"CustomerCreateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerCreateMetaEntityRelationInput:{
		connect:"CustomerMetadataUniqueWhere"
	},
	PipelineLeadCreateFormEntityRelationInput:{
		connect:"LeadFormUniqueWhere",
		create:"LeadFormWithoutLeadsCreateInput"
	},
	LeadFormWithoutLeadsCreateInput:{
		id:"UUID",
		stage:"LeadFormCreateStageEntityRelationInput"
	},
	LeadFormCreateStageEntityRelationInput:{
		connect:"PipelineStageUniqueWhere",
		create:"PipelineStageWithoutFormsCreateInput"
	},
	PipelineStageWithoutFormsCreateInput:{
		id:"UUID",
		items:"PipelineStageCreateItemsEntityRelationInput",
		pipeline:"PipelineStageCreatePipelineEntityRelationInput",
		locales:"PipelineStageCreateLocalesEntityRelationInput",
		sentiment:"PipelineStageCreateSentimentEntityRelationInput",
		type:"PipelineStageType"
	},
	PipelineStageCreateItemsEntityRelationInput:{
		connect:"PipelineStageItemUniqueWhere",
		create:"PipelineStageItemWithoutListCreateInput"
	},
	PipelineStageItemWithoutListCreateInput:{
		id:"UUID",
		lead:"PipelineStageItemCreateLeadEntityRelationInput"
	},
	PipelineStageItemCreateLeadEntityRelationInput:{
		connect:"PipelineLeadUniqueWhere",
		create:"PipelineLeadWithoutStageItemCreateInput"
	},
	PipelineLeadWithoutStageItemCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		customer:"PipelineLeadCreateCustomerEntityRelationInput",
		form:"PipelineLeadCreateFormEntityRelationInput"
	},
	CustomerTabCreateSeatEntityRelationInput:{
		connect:"SeatUniqueWhere",
		create:"SeatWithoutCustomerTabsCreateInput"
	},
	SeatWithoutCustomerTabsCreateInput:{
		id:"UUID",
		table:"SeatCreateTableEntityRelationInput"
	},
	SeatCreateTableEntityRelationInput:{
		connect:"TableUniqueWhere",
		create:"TableWithoutSeatsCreateInput"
	},
	TableWithoutSeatsCreateInput:{
		id:"UUID",
		shape:"TableShape",
		customerTabs:"TableCreateCustomerTabsEntityRelationInput",
		area:"TableCreateAreaEntityRelationInput"
	},
	TableCreateSeatsEntityRelationInput:{
		connect:"SeatUniqueWhere",
		create:"SeatWithoutTableCreateInput"
	},
	SeatWithoutTableCreateInput:{
		id:"UUID",
		customerTabs:"SeatCreateCustomerTabsEntityRelationInput"
	},
	SeatCreateCustomerTabsEntityRelationInput:{
		connect:"CustomerTabUniqueWhere",
		create:"CustomerTabWithoutSeatCreateInput"
	},
	CustomerTabWithoutSeatCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		items:"CustomerTabCreateItemsEntityRelationInput",
		meta:"CustomerTabCreateMetaEntityRelationInput",
		customer:"CustomerTabCreateCustomerEntityRelationInput",
		table:"CustomerTabCreateTableEntityRelationInput"
	},
	AreaCreateLinesEntityRelationInput:{
		connect:"LineUniqueWhere",
		create:"LineWithoutAreaCreateInput"
	},
	LineWithoutAreaCreateInput:{
		id:"UUID"
	},
	VenueCreateChannelsEntityRelationInput:{
		connect:"ChannelUniqueWhere",
		create:"ChannelWithoutVenueCreateInput"
	},
	ChannelWithoutVenueCreateInput:{
		id:"UUID",
		payments:"ChannelCreatePaymentsEntityRelationInput",
		deliveries:"ChannelCreateDeliveriesEntityRelationInput",
		pointOfSales:"ChannelCreatePointOfSalesEntityRelationInput",
		carts:"ChannelCreateCartsEntityRelationInput",
		customers:"ChannelCreateCustomersEntityRelationInput",
		code:"ChannelCode",
		addTagsOnRegistration:"ChannelCreateAddTagsOnRegistrationEntityRelationInput",
		publicTags:"ChannelCreatePublicTagsEntityRelationInput"
	},
	PointOfSalePrinterCreateTicketCategoriesEntityRelationInput:{
		connect:"PointOfSaleCategoryUniqueWhere",
		create:"PointOfSaleCategoryWithoutTicketPrintersCreateInput"
	},
	PointOfSaleCategoryWithoutTicketPrintersCreateInput:{
		id:"UUID",
		locales:"PointOfSaleCategoryCreateLocalesEntityRelationInput",
		products:"PointOfSaleCategoryCreateProductsEntityRelationInput",
		category:"PointOfSaleCategoryCreateCategoryEntityRelationInput",
		venue:"PointOfSaleCategoryCreateVenueEntityRelationInput"
	},
	PointOfSaleCategoryCreateVenueEntityRelationInput:{
		connect:"VenueUniqueWhere",
		create:"VenueWithoutCategoriesCreateInput"
	},
	VenueWithoutCategoriesCreateInput:{
		id:"UUID",
		deadlineTemplate:"VenueCreateDeadlineTemplateEntityRelationInput",
		timetableDays:"VenueCreateTimetableDaysEntityRelationInput",
		timetableTemplates:"VenueCreateTimetableTemplatesEntityRelationInput",
		staffMembers:"VenueCreateStaffMembersEntityRelationInput",
		employeeRoles:"VenueCreateEmployeeRolesEntityRelationInput",
		pointOfSaleApplicationDevices:"VenueCreatePointOfSaleApplicationDevicesEntityRelationInput",
		pointOfSaleTerminals:"VenueCreatePointOfSaleTerminalsEntityRelationInput",
		pointOfSalePrinters:"VenueCreatePointOfSalePrintersEntityRelationInput",
		orders:"VenueCreateOrdersEntityRelationInput",
		fulfillmentNotes:"VenueCreateFulfillmentNotesEntityRelationInput",
		areas:"VenueCreateAreasEntityRelationInput",
		enabledUnassignReasons:"VenueCreateEnabledUnassignReasonsEntityRelationInput",
		channels:"VenueCreateChannelsEntityRelationInput",
		pointOfSaleInitialView:"PointOfSaleInitialView"
	},
	VoucherRedemptionCreateVoucherEntityRelationInput:{
		connect:"VoucherUniqueWhere",
		create:"VoucherWithoutRedemptionCreateInput"
	},
	VoucherWithoutRedemptionCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		activatedAt:"DateTime",
		expiresAt:"DateTime",
		type:"VoucherType",
		buyer:"VoucherCreateBuyerEntityRelationInput",
		owner:"VoucherCreateOwnerEntityRelationInput",
		vatRate:"VoucherCreateVatRateEntityRelationInput",
		virtualProductEffect:"VoucherCreateVirtualProductEffectEntityRelationInput"
	},
	OrderCreateFulfillmentNotesEntityRelationInput:{
		connect:"FulfillmentNoteUniqueWhere",
		create:"FulfillmentNoteWithoutOrdersCreateInput"
	},
	FulfillmentNoteWithoutOrdersCreateInput:{
		id:"UUID",
		products:"FulfillmentNoteCreateProductsEntityRelationInput",
		tags:"FulfillmentNoteCreateTagsEntityRelationInput",
		venues:"FulfillmentNoteCreateVenuesEntityRelationInput",
		cartItems:"FulfillmentNoteCreateCartItemsEntityRelationInput",
		orderItems:"FulfillmentNoteCreateOrderItemsEntityRelationInput",
		createdAt:"DateTime"
	},
	OrderPaymentCreateVatRateEntityRelationInput:{
		connect:"VatRateUniqueWhere",
		create:"VatRateCreateInput"
	},
	OrderPaymentCreateMetaEntityRelationInput:{
		connect:"OrderPaymentMetadataUniqueWhere"
	},
	OrderDeliveryCreateEventsEntityRelationInput:{
		connect:"OrderEventUniqueWhere",
		create:"OrderEventWithoutDeliveryCreateInput"
	},
	OrderEventWithoutDeliveryCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		order:"OrderEventCreateOrderEntityRelationInput",
		payment:"OrderEventCreatePaymentEntityRelationInput"
	},
	OrderDeliveryCreateLiftagoRideEntityRelationInput:{
		connect:"LiftagoRideUniqueWhere",
		create:"LiftagoRideWithoutDeliveryCreateInput"
	},
	LiftagoRideWithoutDeliveryCreateInput:{
		id:"UUID",
		updatedAt:"DateTime"
	},
	OrderDeliveryCreateWoltDriveDeliveryEntityRelationInput:{
		connect:"WoltDriveDeliveryUniqueWhere",
		create:"WoltDriveDeliveryWithoutDeliveryCreateInput"
	},
	WoltDriveDeliveryWithoutDeliveryCreateInput:{
		id:"UUID",
		state:"WoltDriveDeliveryState"
	},
	AddressCreateDefaultDeliveryAddressOfCustomerEntityRelationInput:{
		connect:"CustomerUniqueWhere",
		create:"CustomerWithoutDefaultDeliveryAddressCreateInput"
	},
	CustomerWithoutDefaultDeliveryAddressCreateInput:{
		id:"UUID",
		addresses:"CustomerCreateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerCreateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerCreateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerCreateTagsEntityRelationInput",
		credits:"CustomerCreateCreditsEntityRelationInput",
		paymentMethods:"CustomerCreatePaymentMethodsEntityRelationInput",
		orders:"CustomerCreateOrdersEntityRelationInput",
		permissions:"CustomerCreatePermissionsEntityRelationInput",
		group:"CustomerCreateGroupEntityRelationInput",
		photo:"CustomerCreatePhotoEntityRelationInput",
		name:"CustomerCreateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerCreateIngredientRatingsEntityRelationInput",
		business:"CustomerCreateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerCreateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerCreateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerCreateCartsEntityRelationInput",
		shortcutList:"CustomerCreateShortcutListEntityRelationInput",
		user:"CustomerCreateUserEntityRelationInput",
		channels:"CustomerCreateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerCreateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerCreateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerCreateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerCreateOfferedProductsEntityRelationInput",
		defaultBillingSubject:"CustomerCreateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerCreateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerCreateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerCreateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerCreateRedeemedVouchersEntityRelationInput",
		spending:"CustomerCreateSpendingEntityRelationInput",
		customerTabs:"CustomerCreateCustomerTabsEntityRelationInput",
		lead:"CustomerCreateLeadEntityRelationInput",
		meta:"CustomerCreateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	OrderEventCreateDeliveryEntityRelationInput:{
		connect:"OrderDeliveryUniqueWhere",
		create:"OrderDeliveryWithoutEventsCreateInput"
	},
	OrderDeliveryWithoutEventsCreateInput:{
		id:"UUID",
		deliveredAt:"DateTime",
		method:"OrderDeliveryCreateMethodEntityRelationInput",
		vatRate:"OrderDeliveryCreateVatRateEntityRelationInput",
		order:"OrderDeliveryCreateOrderEntityRelationInput",
		expectedAt:"DateTime",
		state:"OrderDeliveryState",
		dispatchAt:"DateTime",
		expectedEndAt:"DateTime",
		processingAt:"DateTime",
		deliveringAt:"DateTime",
		failedAt:"DateTime",
		deliveryWaypoint:"OrderDeliveryCreateDeliveryWaypointEntityRelationInput",
		prepareAt:"DateTime",
		liftagoRide:"OrderDeliveryCreateLiftagoRideEntityRelationInput",
		pickedAt:"DateTime",
		address:"OrderDeliveryCreateAddressEntityRelationInput",
		woltDriveDelivery:"OrderDeliveryCreateWoltDriveDeliveryEntityRelationInput"
	},
	OrderDeliveryCreateAddressEntityRelationInput:{
		connect:"AddressUniqueWhere",
		create:"AddressWithoutDeliveryAddressOfOrderDeliveriesCreateInput"
	},
	AddressWithoutDeliveryAddressOfOrderDeliveriesCreateInput:{
		id:"UUID",
		customer:"AddressCreateCustomerEntityRelationInput",
		country:"AddressCreateCountryEntityRelationInput",
		deletedAt:"DateTime",
		geocodeGeneratedAt:"DateTime",
		deliveryZone:"AddressCreateDeliveryZoneEntityRelationInput",
		meta:"AddressCreateMetaEntityRelationInput",
		gps:"AddressCreateGpsEntityRelationInput",
		invoices:"AddressCreateInvoicesEntityRelationInput",
		createdAt:"DateTime",
		billingAddressOfOrders:"AddressCreateBillingAddressOfOrdersEntityRelationInput",
		defaultDeliveryAddressOfCustomer:"AddressCreateDefaultDeliveryAddressOfCustomerEntityRelationInput"
	},
	CartCreateDeliveryAddressEntityRelationInput:{
		connect:"AddressUniqueWhere",
		create:"AddressCreateInput"
	},
	CartCreateBillingAddressEntityRelationInput:{
		connect:"AddressUniqueWhere",
		create:"AddressCreateInput"
	},
	CartCreateDeliveryEntityRelationInput:{
		connect:"ChannelDeliveryUniqueWhere",
		create:"ChannelDeliveryCreateInput"
	},
	ChannelDeliveryCreateInput:{
		id:"UUID",
		channel:"ChannelDeliveryCreateChannelEntityRelationInput",
		method:"ChannelDeliveryCreateMethodEntityRelationInput",
		vatRate:"ChannelDeliveryCreateVatRateEntityRelationInput"
	},
	CartCreatePaymentEntityRelationInput:{
		connect:"ChannelPaymentUniqueWhere",
		create:"ChannelPaymentCreateInput"
	},
	ChannelPaymentCreateInput:{
		id:"UUID",
		channel:"ChannelPaymentCreateChannelEntityRelationInput",
		method:"ChannelPaymentCreateMethodEntityRelationInput",
		vatRate:"ChannelPaymentCreateVatRateEntityRelationInput",
		allowOnlyForTags:"ChannelPaymentCreateAllowOnlyForTagsEntityRelationInput"
	},
	CartCreateBillingSubjectEntityRelationInput:{
		connect:"BillingSubjectUniqueWhere",
		create:"BillingSubjectCreateInput"
	},
	BillingSubjectCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		deletedAt:"DateTime",
		country:"BillingSubjectCreateCountryEntityRelationInput",
		customer:"BillingSubjectCreateCustomerEntityRelationInput",
		invoices:"BillingSubjectCreateInvoicesEntityRelationInput",
		defaultBillingSubjectOfCustomer:"BillingSubjectCreateDefaultBillingSubjectOfCustomerEntityRelationInput",
		orders:"BillingSubjectCreateOrdersEntityRelationInput"
	},
	CartCreatePriceLinesEntityRelationInput:{
		connect:"CartPriceLineUniqueWhere"
	},
	CartCreateSummaryEntityRelationInput:{
		connect:"CartSummaryUniqueWhere"
	},
	OrderDiscountCreateVoucherRedemptionEntityRelationInput:{
		connect:"VoucherRedemptionUniqueWhere",
		create:"VoucherRedemptionWithoutOrderDiscountCreateInput"
	},
	VoucherRedemptionWithoutOrderDiscountCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		customerCredit:"VoucherRedemptionCreateCustomerCreditEntityRelationInput",
		voucher:"VoucherRedemptionCreateVoucherEntityRelationInput",
		customer:"VoucherRedemptionCreateCustomerEntityRelationInput"
	},
	PointOfSaleApplicationDeviceCreateTicketPrintersEntityRelationInput:{
		connect:"PointOfSalePrinterUniqueWhere",
		create:"PointOfSalePrinterWithoutApplicationDevicesTicketCreateInput"
	},
	PointOfSalePrinterWithoutApplicationDevicesTicketCreateInput:{
		id:"UUID",
		applicationDevicesReceipt:"PointOfSalePrinterCreateApplicationDevicesReceiptEntityRelationInput",
		venue:"PointOfSalePrinterCreateVenueEntityRelationInput",
		ticketCategories:"PointOfSalePrinterCreateTicketCategoriesEntityRelationInput"
	},
	LocaleCreatePipelineStagesEntityRelationInput:{
		connect:"PipelineStageLocaleUniqueWhere",
		create:"PipelineStageLocaleWithoutLocaleCreateInput"
	},
	PipelineStageLocaleWithoutLocaleCreateInput:{
		id:"UUID",
		root:"PipelineStageLocaleCreateRootEntityRelationInput"
	},
	PipelineStageLocaleCreateRootEntityRelationInput:{
		connect:"PipelineStageUniqueWhere",
		create:"PipelineStageWithoutLocalesCreateInput"
	},
	PipelineStageWithoutLocalesCreateInput:{
		id:"UUID",
		items:"PipelineStageCreateItemsEntityRelationInput",
		pipeline:"PipelineStageCreatePipelineEntityRelationInput",
		sentiment:"PipelineStageCreateSentimentEntityRelationInput",
		type:"PipelineStageType",
		forms:"PipelineStageCreateFormsEntityRelationInput"
	},
	PointOfSaleCategoryProductCreateLocalesEntityRelationInput:{
		connect:"PointOfSaleCategoryProductLocaleUniqueWhere",
		create:"PointOfSaleCategoryProductLocaleWithoutRootCreateInput"
	},
	PointOfSaleCategoryProductLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"PointOfSaleCategoryProductLocaleCreateLocaleEntityRelationInput"
	},
	PointOfSaleCategoryProductLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutPointOfSaleCategoryProductsCreateInput"
	},
	LocaleWithoutPointOfSaleCategoryProductsCreateInput:{
		id:"UUID",
		businessCategories:"LocaleCreateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleCreateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleCreateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleCreateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleCreateBlogsEntityRelationInput",
		blogPosts:"LocaleCreateBlogPostsEntityRelationInput",
		identifier:"LocaleCreateIdentifierEntityRelationInput",
		menus:"LocaleCreateMenusEntityRelationInput",
		pages:"LocaleCreatePagesEntityRelationInput",
		productIngredientCategories:"LocaleCreateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleCreateAllergensEntityRelationInput",
		productPackings:"LocaleCreateProductPackingsEntityRelationInput",
		products:"LocaleCreateProductsEntityRelationInput",
		productRecipes:"LocaleCreateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleCreatePointOfSaleCategoriesEntityRelationInput",
		deliveryMethods:"LocaleCreateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleCreateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleCreateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleCreatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleCreateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleCreateBusinessServicesEntityRelationInput"
	},
	ProductRecipeCreateLocalesEntityRelationInput:{
		connect:"ProductRecipeLocaleUniqueWhere",
		create:"ProductRecipeLocaleWithoutRootCreateInput"
	},
	ProductRecipeLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"ProductRecipeLocaleCreateLocaleEntityRelationInput"
	},
	ProductRecipeLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutProductRecipesCreateInput"
	},
	LocaleWithoutProductRecipesCreateInput:{
		id:"UUID",
		businessCategories:"LocaleCreateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleCreateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleCreateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleCreateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleCreateBlogsEntityRelationInput",
		blogPosts:"LocaleCreateBlogPostsEntityRelationInput",
		identifier:"LocaleCreateIdentifierEntityRelationInput",
		menus:"LocaleCreateMenusEntityRelationInput",
		pages:"LocaleCreatePagesEntityRelationInput",
		productIngredientCategories:"LocaleCreateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleCreateAllergensEntityRelationInput",
		productPackings:"LocaleCreateProductPackingsEntityRelationInput",
		products:"LocaleCreateProductsEntityRelationInput",
		pointOfSaleCategories:"LocaleCreatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleCreatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleCreateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleCreateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleCreateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleCreatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleCreateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleCreateBusinessServicesEntityRelationInput"
	},
	TimetableShiftGroupCreateGeneratedByTemplateEntityRelationInput:{
		connect:"TimetableTemplateUniqueWhere",
		create:"TimetableTemplateCreateInput"
	},
	TimetableTemplateCreateInput:{
		id:"UUID",
		startDate:"Date",
		position:"TimetableTemplateCreatePositionEntityRelationInput",
		staffOptions:"TimetableTemplateCreateStaffOptionsEntityRelationInput",
		venue:"TimetableTemplateCreateVenueEntityRelationInput",
		employeeRole:"TimetableTemplateCreateEmployeeRoleEntityRelationInput",
		type:"TemplateType"
	},
	TimetableShiftCreateQueueItemEntityRelationInput:{
		connect:"EmployeeQueueItemUniqueWhere",
		create:"EmployeeQueueItemWithoutShiftCreateInput"
	},
	EmployeeQueueItemWithoutShiftCreateInput:{
		id:"UUID",
		queue:"EmployeeQueueItemCreateQueueEntityRelationInput",
		shiftsProfile:"EmployeeQueueItemCreateShiftsProfileEntityRelationInput",
		unassignInfo:"EmployeeQueueItemCreateUnassignInfoEntityRelationInput",
		meta:"EmployeeQueueItemCreateMetaEntityRelationInput"
	},
	EmployeeQueueItemCreateUnassignInfoEntityRelationInput:{
		connect:"UnassignedShiftInfoUniqueWhere",
		create:"UnassignedShiftInfoWithoutQueueItemCreateInput"
	},
	UnassignedShiftInfoWithoutQueueItemCreateInput:{
		id:"UUID",
		legacyReason:"UnassignedInfoReason",
		reason:"UnassignedShiftInfoCreateReasonEntityRelationInput"
	},
	UnassignedShiftInfoCreateReasonEntityRelationInput:{
		connect:"UnassignReasonUniqueWhere",
		create:"UnassignReasonCreateInput"
	},
	UnassignReasonCreateInput:{
		id:"UUID",
		venues:"UnassignReasonCreateVenuesEntityRelationInput"
	},
	UnassignReasonCreateVenuesEntityRelationInput:{
		connect:"VenueUniqueWhere",
		create:"VenueWithoutEnabledUnassignReasonsCreateInput"
	},
	VenueWithoutEnabledUnassignReasonsCreateInput:{
		id:"UUID",
		deadlineTemplate:"VenueCreateDeadlineTemplateEntityRelationInput",
		timetableDays:"VenueCreateTimetableDaysEntityRelationInput",
		timetableTemplates:"VenueCreateTimetableTemplatesEntityRelationInput",
		staffMembers:"VenueCreateStaffMembersEntityRelationInput",
		employeeRoles:"VenueCreateEmployeeRolesEntityRelationInput",
		pointOfSaleApplicationDevices:"VenueCreatePointOfSaleApplicationDevicesEntityRelationInput",
		pointOfSaleTerminals:"VenueCreatePointOfSaleTerminalsEntityRelationInput",
		pointOfSalePrinters:"VenueCreatePointOfSalePrintersEntityRelationInput",
		orders:"VenueCreateOrdersEntityRelationInput",
		fulfillmentNotes:"VenueCreateFulfillmentNotesEntityRelationInput",
		areas:"VenueCreateAreasEntityRelationInput",
		categories:"VenueCreateCategoriesEntityRelationInput",
		channels:"VenueCreateChannelsEntityRelationInput",
		pointOfSaleInitialView:"PointOfSaleInitialView"
	},
	EmployeeQueueItemCreateMetaEntityRelationInput:{
		connect:"EmployeeQueueItemMetadataUniqueWhere"
	},
	TimetableShiftCreateSwapInfoEntityRelationInput:{
		connect:"TimetableShiftSwapInfoUniqueWhere",
		create:"TimetableShiftSwapInfoWithoutShiftCreateInput"
	},
	TimetableShiftSwapInfoWithoutShiftCreateInput:{
		id:"UUID",
		assigned:"Date",
		swappedShiftsProfile:"TimetableShiftSwapInfoCreateSwappedShiftsProfileEntityRelationInput"
	},
	TimetableShiftSwapInfoCreateSwappedShiftsProfileEntityRelationInput:{
		connect:"ShiftsProfileUniqueWhere",
		create:"ShiftsProfileCreateInput"
	},
	EmployeeQueueItemCreateShiftEntityRelationInput:{
		connect:"TimetableShiftUniqueWhere",
		create:"TimetableShiftWithoutQueueItemCreateInput"
	},
	TimetableShiftWithoutQueueItemCreateInput:{
		id:"UUID",
		assigned:"Date",
		group:"TimetableShiftCreateGroupEntityRelationInput",
		shiftsProfile:"TimetableShiftCreateShiftsProfileEntityRelationInput",
		swapInfo:"TimetableShiftCreateSwapInfoEntityRelationInput"
	},
	TimetableDayCreateMetaEntityRelationInput:{
		connect:"TimetableDayMetadataUniqueWhere"
	},
	DeliveryZoneCreateAddressesMetadataEntityRelationInput:{
		connect:"AddressMetadataUniqueWhere"
	},
	CustomerCreditCreateVoucherRedemptionEntityRelationInput:{
		connect:"VoucherRedemptionUniqueWhere",
		create:"VoucherRedemptionWithoutCustomerCreditCreateInput"
	},
	VoucherRedemptionWithoutCustomerCreditCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		orderDiscount:"VoucherRedemptionCreateOrderDiscountEntityRelationInput",
		voucher:"VoucherRedemptionCreateVoucherEntityRelationInput",
		customer:"VoucherRedemptionCreateCustomerEntityRelationInput"
	},
	StaffCreateVenuesEntityRelationInput:{
		connect:"VenueUniqueWhere",
		create:"VenueWithoutStaffMembersCreateInput"
	},
	VenueWithoutStaffMembersCreateInput:{
		id:"UUID",
		deadlineTemplate:"VenueCreateDeadlineTemplateEntityRelationInput",
		timetableDays:"VenueCreateTimetableDaysEntityRelationInput",
		timetableTemplates:"VenueCreateTimetableTemplatesEntityRelationInput",
		employeeRoles:"VenueCreateEmployeeRolesEntityRelationInput",
		pointOfSaleApplicationDevices:"VenueCreatePointOfSaleApplicationDevicesEntityRelationInput",
		pointOfSaleTerminals:"VenueCreatePointOfSaleTerminalsEntityRelationInput",
		pointOfSalePrinters:"VenueCreatePointOfSalePrintersEntityRelationInput",
		orders:"VenueCreateOrdersEntityRelationInput",
		fulfillmentNotes:"VenueCreateFulfillmentNotesEntityRelationInput",
		areas:"VenueCreateAreasEntityRelationInput",
		enabledUnassignReasons:"VenueCreateEnabledUnassignReasonsEntityRelationInput",
		categories:"VenueCreateCategoriesEntityRelationInput",
		channels:"VenueCreateChannelsEntityRelationInput",
		pointOfSaleInitialView:"PointOfSaleInitialView"
	},
	BusinessCustomerCreateLogoEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	BusinessCustomerCreateBusinessServiceEventsEntityRelationInput:{
		connect:"BusinessServiceEventUniqueWhere",
		create:"BusinessServiceEventWithoutBusinessCustomerCreateInput"
	},
	BusinessServiceEventWithoutBusinessCustomerCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		fulfilledAt:"DateTime",
		businessService:"BusinessServiceEventCreateBusinessServiceEntityRelationInput",
		createdBy:"BusinessServiceEventCreateCreatedByEntityRelationInput",
		filledSupervisor:"BusinessServiceEventCreateFilledSupervisorEntityRelationInput"
	},
	BusinessServiceEventCreateBusinessServiceEntityRelationInput:{
		connect:"BusinessServiceUniqueWhere",
		create:"BusinessServiceCreateInput"
	},
	BusinessServiceCreateInput:{
		id:"UUID",
		locales:"BusinessServiceCreateLocalesEntityRelationInput"
	},
	BusinessServiceCreateLocalesEntityRelationInput:{
		connect:"BusinessServiceLocaleUniqueWhere",
		create:"BusinessServiceLocaleWithoutRootCreateInput"
	},
	BusinessServiceLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"BusinessServiceLocaleCreateLocaleEntityRelationInput"
	},
	BusinessServiceLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutBusinessServicesCreateInput"
	},
	LocaleWithoutBusinessServicesCreateInput:{
		id:"UUID",
		businessCategories:"LocaleCreateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleCreateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleCreateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleCreateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleCreateBlogsEntityRelationInput",
		blogPosts:"LocaleCreateBlogPostsEntityRelationInput",
		identifier:"LocaleCreateIdentifierEntityRelationInput",
		menus:"LocaleCreateMenusEntityRelationInput",
		pages:"LocaleCreatePagesEntityRelationInput",
		productIngredientCategories:"LocaleCreateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleCreateAllergensEntityRelationInput",
		productPackings:"LocaleCreateProductPackingsEntityRelationInput",
		products:"LocaleCreateProductsEntityRelationInput",
		productRecipes:"LocaleCreateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleCreatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleCreatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleCreateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleCreateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleCreateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleCreatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleCreateSubscriptionBoxesEntityRelationInput"
	},
	BusinessServiceEventCreateCreatedByEntityRelationInput:{
		connect:"StaffUniqueWhere",
		create:"StaffCreateInput"
	},
	StaffCreateInput:{
		id:"UUID",
		bartender:"StaffCreateBartenderEntityRelationInput",
		courier:"StaffCreateCourierEntityRelationInput",
		cleaner:"StaffCreateCleanerEntityRelationInput",
		shiftsManager:"StaffCreateShiftsManagerEntityRelationInput",
		businessToBusinessManager:"StaffCreateBusinessToBusinessManagerEntityRelationInput",
		user:"StaffCreateUserEntityRelationInput",
		shiftsProfile:"StaffCreateShiftsProfileEntityRelationInput",
		stocksManager:"StaffCreateStocksManagerEntityRelationInput",
		photo:"StaffCreatePhotoEntityRelationInput",
		courierManager:"StaffCreateCourierManagerEntityRelationInput",
		picker:"StaffCreatePickerEntityRelationInput",
		createdAt:"DateTime",
		remunerationProfile:"StaffCreateRemunerationProfileEntityRelationInput",
		cashier:"StaffCreateCashierEntityRelationInput",
		venues:"StaffCreateVenuesEntityRelationInput",
		internalBuyer:"StaffCreateInternalBuyerEntityRelationInput",
		salesManager:"StaffCreateSalesManagerEntityRelationInput",
		cashierManager:"StaffCreateCashierManagerEntityRelationInput"
	},
	BusinessServiceEventCreateFilledSupervisorEntityRelationInput:{
		connect:"StaffUniqueWhere",
		create:"StaffCreateInput"
	},
	BusinessCustomerCreateDoubleshotCoffeeEquipmentEntityRelationInput:{
		connect:"DoubleshotCoffeeEquipmentUniqueWhere",
		create:"DoubleshotCoffeeEquipmentCreateInput"
	},
	DoubleshotCoffeeEquipmentCreateInput:{
		id:"UUID"
	},
	TimetableDayCreateVenueEntityRelationInput:{
		connect:"VenueUniqueWhere",
		create:"VenueWithoutTimetableDaysCreateInput"
	},
	VenueWithoutTimetableDaysCreateInput:{
		id:"UUID",
		deadlineTemplate:"VenueCreateDeadlineTemplateEntityRelationInput",
		timetableTemplates:"VenueCreateTimetableTemplatesEntityRelationInput",
		staffMembers:"VenueCreateStaffMembersEntityRelationInput",
		employeeRoles:"VenueCreateEmployeeRolesEntityRelationInput",
		pointOfSaleApplicationDevices:"VenueCreatePointOfSaleApplicationDevicesEntityRelationInput",
		pointOfSaleTerminals:"VenueCreatePointOfSaleTerminalsEntityRelationInput",
		pointOfSalePrinters:"VenueCreatePointOfSalePrintersEntityRelationInput",
		orders:"VenueCreateOrdersEntityRelationInput",
		fulfillmentNotes:"VenueCreateFulfillmentNotesEntityRelationInput",
		areas:"VenueCreateAreasEntityRelationInput",
		enabledUnassignReasons:"VenueCreateEnabledUnassignReasonsEntityRelationInput",
		categories:"VenueCreateCategoriesEntityRelationInput",
		channels:"VenueCreateChannelsEntityRelationInput",
		pointOfSaleInitialView:"PointOfSaleInitialView"
	},
	WorkspaceCreateDiscountVatRateEntityRelationInput:{
		connect:"VatRateUniqueWhere",
		create:"VatRateCreateInput"
	},
	ProductIngredientCreateImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	ProductIngredientCreateSuppliersEntityRelationInput:{
		connect:"IngredientSupplierListUniqueWhere",
		create:"IngredientSupplierListCreateInput"
	},
	IngredientSupplierListCreateInput:{
		id:"UUID",
		items:"IngredientSupplierListCreateItemsEntityRelationInput"
	},
	IngredientSupplierListCreateItemsEntityRelationInput:{
		connect:"IngredientSupplierItemUniqueWhere",
		create:"IngredientSupplierItemWithoutListCreateInput"
	},
	IngredientSupplierItemWithoutListCreateInput:{
		id:"UUID",
		supplier:"IngredientSupplierItemCreateSupplierEntityRelationInput"
	},
	IngredientSupplierItemCreateSupplierEntityRelationInput:{
		connect:"IngredientSupplierUniqueWhere",
		create:"IngredientSupplierCreateInput"
	},
	IngredientSupplierCreateInput:{
		id:"UUID",
		locales:"IngredientSupplierCreateLocalesEntityRelationInput"
	},
	IngredientSupplierCreateLocalesEntityRelationInput:{
		connect:"IngredientSupplierLocaleUniqueWhere",
		create:"IngredientSupplierLocaleWithoutRootCreateInput"
	},
	IngredientSupplierLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"IngredientSupplierLocaleCreateLocaleEntityRelationInput"
	},
	IngredientSupplierLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutIngredientSuppliersCreateInput"
	},
	LocaleWithoutIngredientSuppliersCreateInput:{
		id:"UUID",
		businessCategories:"LocaleCreateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleCreateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleCreateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleCreateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleCreateBlogsEntityRelationInput",
		blogPosts:"LocaleCreateBlogPostsEntityRelationInput",
		identifier:"LocaleCreateIdentifierEntityRelationInput",
		menus:"LocaleCreateMenusEntityRelationInput",
		pages:"LocaleCreatePagesEntityRelationInput",
		productIngredientCategories:"LocaleCreateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleCreateAllergensEntityRelationInput",
		productPackings:"LocaleCreateProductPackingsEntityRelationInput",
		products:"LocaleCreateProductsEntityRelationInput",
		productRecipes:"LocaleCreateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleCreatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleCreatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleCreateDeliveryMethodsEntityRelationInput",
		identificationCodes:"LocaleCreateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleCreatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleCreateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleCreateBusinessServicesEntityRelationInput"
	},
	BusinessCategoryCreateSpecificProductsEntityRelationInput:{
		connect:"ProductListUniqueWhere",
		create:"ProductListWithoutBusinessCategoryCreateInput"
	},
	ProductListWithoutBusinessCategoryCreateInput:{
		id:"UUID",
		items:"ProductListCreateItemsEntityRelationInput"
	},
	ProductListCreateItemsEntityRelationInput:{
		connect:"ProductListItemUniqueWhere",
		create:"ProductListItemWithoutListCreateInput"
	},
	ProductListItemWithoutListCreateInput:{
		id:"UUID",
		product:"ProductListItemCreateProductEntityRelationInput"
	},
	ProductListItemCreateProductEntityRelationInput:{
		connect:"ProductUniqueWhere",
		create:"ProductCreateInput"
	},
	BusinessCategoryCreateSeasonalProductCategoriesEntityRelationInput:{
		connect:"ProductCategoryListUniqueWhere",
		create:"ProductCategoryListWithoutSeasonalProductCategoriesOfBusinessCategoryCreateInput"
	},
	ProductCategoryListWithoutSeasonalProductCategoriesOfBusinessCategoryCreateInput:{
		id:"UUID",
		items:"ProductCategoryListCreateItemsEntityRelationInput",
		locales:"ProductCategoryListCreateLocalesEntityRelationInput",
		specificProductsProductCategoriesOfBusinessCategory:"ProductCategoryListCreateSpecificProductsProductCategoriesOfBusinessCategoryEntityRelationInput"
	},
	ProductCategoryListCreateLocalesEntityRelationInput:{
		connect:"ProductCategoryListLocaleUniqueWhere",
		create:"ProductCategoryListLocaleWithoutRootCreateInput"
	},
	ProductCategoryListLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"ProductCategoryListLocaleCreateLocaleEntityRelationInput"
	},
	ProductCategoryListLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutProductCategoryListsCreateInput"
	},
	LocaleWithoutProductCategoryListsCreateInput:{
		id:"UUID",
		businessCategories:"LocaleCreateBusinessCategoriesEntityRelationInput",
		productIngredients:"LocaleCreateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleCreateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleCreateBlogsEntityRelationInput",
		blogPosts:"LocaleCreateBlogPostsEntityRelationInput",
		identifier:"LocaleCreateIdentifierEntityRelationInput",
		menus:"LocaleCreateMenusEntityRelationInput",
		pages:"LocaleCreatePagesEntityRelationInput",
		productIngredientCategories:"LocaleCreateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleCreateAllergensEntityRelationInput",
		productPackings:"LocaleCreateProductPackingsEntityRelationInput",
		products:"LocaleCreateProductsEntityRelationInput",
		productRecipes:"LocaleCreateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleCreatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleCreatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleCreateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleCreateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleCreateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleCreatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleCreateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleCreateBusinessServicesEntityRelationInput"
	},
	ProductCategoryListCreateSpecificProductsProductCategoriesOfBusinessCategoryEntityRelationInput:{
		connect:"BusinessCategoryUniqueWhere",
		create:"BusinessCategoryWithoutSpecificProductsProductCategoriesCreateInput"
	},
	BusinessCategoryWithoutSpecificProductsProductCategoriesCreateInput:{
		id:"UUID",
		locales:"BusinessCategoryCreateLocalesEntityRelationInput",
		businessCustomers:"BusinessCategoryCreateBusinessCustomersEntityRelationInput",
		recurrences:"BusinessCategoryCreateRecurrencesEntityRelationInput",
		specificProducts:"BusinessCategoryCreateSpecificProductsEntityRelationInput",
		seasonalProductCategories:"BusinessCategoryCreateSeasonalProductCategoriesEntityRelationInput"
	},
	BusinessCategoryCreateSpecificProductsProductCategoriesEntityRelationInput:{
		connect:"ProductCategoryListUniqueWhere",
		create:"ProductCategoryListWithoutSpecificProductsProductCategoriesOfBusinessCategoryCreateInput"
	},
	ProductCategoryListWithoutSpecificProductsProductCategoriesOfBusinessCategoryCreateInput:{
		id:"UUID",
		items:"ProductCategoryListCreateItemsEntityRelationInput",
		locales:"ProductCategoryListCreateLocalesEntityRelationInput",
		seasonalProductCategoriesOfBusinessCategory:"ProductCategoryListCreateSeasonalProductCategoriesOfBusinessCategoryEntityRelationInput"
	},
	ProductCategoryListCreateSeasonalProductCategoriesOfBusinessCategoryEntityRelationInput:{
		connect:"BusinessCategoryUniqueWhere",
		create:"BusinessCategoryWithoutSeasonalProductCategoriesCreateInput"
	},
	BusinessCategoryWithoutSeasonalProductCategoriesCreateInput:{
		id:"UUID",
		locales:"BusinessCategoryCreateLocalesEntityRelationInput",
		businessCustomers:"BusinessCategoryCreateBusinessCustomersEntityRelationInput",
		recurrences:"BusinessCategoryCreateRecurrencesEntityRelationInput",
		specificProducts:"BusinessCategoryCreateSpecificProductsEntityRelationInput",
		specificProductsProductCategories:"BusinessCategoryCreateSpecificProductsProductCategoriesEntityRelationInput"
	},
	LinkableCreateRedirectEntityRelationInput:{
		connect:"RedirectUniqueWhere",
		create:"RedirectWithoutLinkCreateInput"
	},
	RedirectWithoutLinkCreateInput:{
		id:"UUID",
		target:"RedirectCreateTargetEntityRelationInput"
	},
	RedirectCreateTargetEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput"
	},
	WikiPageCreateContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentCreateInput"
	},
	WikiPageCreateChildrenEntityRelationInput:{
		connect:"WikiPageUniqueWhere",
		create:"WikiPageWithoutParentCreateInput"
	},
	WikiPageWithoutParentCreateInput:{
		id:"UUID",
		link:"WikiPageCreateLinkEntityRelationInput",
		children:"WikiPageCreateChildrenEntityRelationInput",
		content:"WikiPageCreateContentEntityRelationInput"
	},
	BlogPostLocaleCreateSeoEntityRelationInput:{
		connect:"SeoUniqueWhere",
		create:"SeoCreateInput"
	},
	BlogPostLocaleCreateProductsEntityRelationInput:{
		connect:"ProductUniqueWhere",
		create:"ProductCreateInput"
	},
	ContentReferenceCreateBlogPostsEntityRelationInput:{
		connect:"BlogPostListUniqueWhere",
		create:"BlogPostListCreateInput"
	},
	BlogPostListUniqueWhere:{
		id:"UUID",
		items:"BlogPostListItemUniqueWhere"
	},
	BlogPostListItemUniqueWhere:{
		id:"UUID"
	},
	BlogPostListCreateInput:{
		id:"UUID",
		items:"BlogPostListCreateItemsEntityRelationInput"
	},
	BlogPostListCreateItemsEntityRelationInput:{
		connect:"BlogPostListItemUniqueWhere",
		create:"BlogPostListItemWithoutListCreateInput"
	},
	BlogPostListItemWithoutListCreateInput:{
		id:"UUID",
		blogPost:"BlogPostListItemCreateBlogPostEntityRelationInput"
	},
	BlogPostListItemCreateBlogPostEntityRelationInput:{
		connect:"BlogPostLocaleUniqueWhere",
		create:"BlogPostLocaleCreateInput"
	},
	BlogPostLocaleCreateInput:{
		id:"UUID",
		root:"BlogPostLocaleCreateRootEntityRelationInput",
		locale:"BlogPostLocaleCreateLocaleEntityRelationInput",
		cover:"BlogPostLocaleCreateCoverEntityRelationInput",
		content:"BlogPostLocaleCreateContentEntityRelationInput",
		link:"BlogPostLocaleCreateLinkEntityRelationInput",
		seo:"BlogPostLocaleCreateSeoEntityRelationInput",
		products:"BlogPostLocaleCreateProductsEntityRelationInput"
	},
	BlogPostLocaleCreateLinkEntityRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutBlogPostCreateInput"
	},
	LinkableWithoutBlogPostCreateInput:{
		id:"UUID",
		page:"LinkableCreatePageEntityRelationInput",
		wikiPage:"LinkableCreateWikiPageEntityRelationInput",
		redirect:"LinkableCreateRedirectEntityRelationInput"
	},
	ContentReferenceCreateLinksEntityRelationInput:{
		connect:"LinkListUniqueWhere",
		create:"LinkListCreateInput"
	},
	ContentReferenceCreateProductsEntityRelationInput:{
		connect:"ProductListUniqueWhere",
		create:"ProductListCreateInput"
	},
	ProductListCreateInput:{
		id:"UUID",
		items:"ProductListCreateItemsEntityRelationInput",
		businessCategory:"ProductListCreateBusinessCategoryEntityRelationInput"
	},
	ProductListCreateBusinessCategoryEntityRelationInput:{
		connect:"BusinessCategoryUniqueWhere",
		create:"BusinessCategoryWithoutSpecificProductsCreateInput"
	},
	BusinessCategoryWithoutSpecificProductsCreateInput:{
		id:"UUID",
		locales:"BusinessCategoryCreateLocalesEntityRelationInput",
		businessCustomers:"BusinessCategoryCreateBusinessCustomersEntityRelationInput",
		recurrences:"BusinessCategoryCreateRecurrencesEntityRelationInput",
		seasonalProductCategories:"BusinessCategoryCreateSeasonalProductCategoriesEntityRelationInput",
		specificProductsProductCategories:"BusinessCategoryCreateSpecificProductsProductCategoriesEntityRelationInput"
	},
	ContentReferenceCreateHeroEntityRelationInput:{
		connect:"HeroUniqueWhere",
		create:"HeroCreateInput"
	},
	HeroUniqueWhere:{
		id:"UUID"
	},
	HeroCreateInput:{
		id:"UUID",
		medium:"HeroCreateMediumEntityRelationInput"
	},
	HeroCreateMediumEntityRelationInput:{
		connect:"MediumUniqueWhere",
		create:"MediumCreateInput"
	},
	ContentReferenceCreateGalleryEntityRelationInput:{
		connect:"GalleryUniqueWhere",
		create:"GalleryCreateInput"
	},
	GalleryUniqueWhere:{
		id:"UUID",
		items:"GalleryItemUniqueWhere"
	},
	GalleryItemUniqueWhere:{
		id:"UUID"
	},
	GalleryCreateInput:{
		id:"UUID",
		items:"GalleryCreateItemsEntityRelationInput"
	},
	GalleryCreateItemsEntityRelationInput:{
		connect:"GalleryItemUniqueWhere",
		create:"GalleryItemWithoutListCreateInput"
	},
	GalleryItemWithoutListCreateInput:{
		id:"UUID",
		medium:"GalleryItemCreateMediumEntityRelationInput"
	},
	GalleryItemCreateMediumEntityRelationInput:{
		connect:"MediumUniqueWhere",
		create:"MediumCreateInput"
	},
	ContentReferenceCreateSocialsAndAppsEntityRelationInput:{
		connect:"SocialsAndAppsUniqueWhere",
		create:"SocialsAndAppsCreateInput"
	},
	ContentReferenceCreateProductGridEntityRelationInput:{
		connect:"ProductGridUniqueWhere",
		create:"ProductGridCreateInput"
	},
	ProductGridUniqueWhere:{
		id:"UUID",
		categories:"ProductGridCategoryUniqueWhere"
	},
	ProductGridCategoryUniqueWhere:{
		id:"UUID",
		items:"ProductGridItemUniqueWhere",
		images:"ImageListUniqueWhere"
	},
	ProductGridCreateInput:{
		id:"UUID",
		categories:"ProductGridCreateCategoriesEntityRelationInput",
		type:"ProductGridType"
	},
	ProductGridCreateCategoriesEntityRelationInput:{
		connect:"ProductGridCategoryUniqueWhere",
		create:"ProductGridCategoryWithoutRootCreateInput"
	},
	ProductGridCategoryWithoutRootCreateInput:{
		id:"UUID",
		items:"ProductGridCategoryCreateItemsEntityRelationInput",
		images:"ProductGridCategoryCreateImagesEntityRelationInput"
	},
	ProductGridCategoryCreateItemsEntityRelationInput:{
		connect:"ProductGridItemUniqueWhere",
		create:"ProductGridItemWithoutCategoryCreateInput"
	},
	ProductGridItemWithoutCategoryCreateInput:{
		id:"UUID",
		product:"ProductGridItemCreateProductEntityRelationInput",
		medium:"ProductGridItemCreateMediumEntityRelationInput",
		link:"ProductGridItemCreateLinkEntityRelationInput"
	},
	ProductGridItemCreateProductEntityRelationInput:{
		connect:"ProductUniqueWhere",
		create:"ProductCreateInput"
	},
	ProductGridItemCreateMediumEntityRelationInput:{
		connect:"MediumUniqueWhere",
		create:"MediumCreateInput"
	},
	ProductGridItemCreateLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput"
	},
	ProductGridCategoryCreateImagesEntityRelationInput:{
		connect:"ImageListUniqueWhere",
		create:"ImageListCreateInput"
	},
	ContentReferenceCreateProductBannersEntityRelationInput:{
		connect:"ProductBannerListUniqueWhere",
		create:"ProductBannerListCreateInput"
	},
	ProductBannerListCreateInput:{
		id:"UUID",
		items:"ProductBannerListCreateItemsEntityRelationInput"
	},
	ProductBannerListCreateItemsEntityRelationInput:{
		connect:"ProductBannerItemUniqueWhere",
		create:"ProductBannerItemWithoutListCreateInput"
	},
	ProductBannerItemWithoutListCreateInput:{
		id:"UUID",
		banner:"ProductBannerItemCreateBannerEntityRelationInput",
		size:"ProductBannerItemSize"
	},
	ProductBannerItemCreateBannerEntityRelationInput:{
		connect:"ProductBannerUniqueWhere",
		create:"ProductBannerCreateInput"
	},
	ProductBannerUniqueWhere:{
		id:"UUID",
		button:"LinkUniqueWhere"
	},
	ProductBannerCreateInput:{
		id:"UUID",
		button:"ProductBannerCreateButtonEntityRelationInput",
		backgroundImage:"ProductBannerCreateBackgroundImageEntityRelationInput",
		productImage:"ProductBannerCreateProductImageEntityRelationInput",
		product:"ProductBannerCreateProductEntityRelationInput"
	},
	ProductBannerCreateButtonEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput"
	},
	ProductBannerCreateBackgroundImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	ProductBannerCreateProductImageEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	ProductBannerCreateProductEntityRelationInput:{
		connect:"ProductUniqueWhere",
		create:"ProductCreateInput"
	},
	ContentReferenceCreateDeliveryRegionsEntityRelationInput:{
		connect:"DeliveryRegionsUniqueWhere",
		create:"DeliveryRegionsCreateInput"
	},
	ContentReferenceCreateTextListEntityRelationInput:{
		connect:"TextListUniqueWhere",
		create:"TextListCreateInput"
	},
	ContentReferenceCreateGridTilesEntityRelationInput:{
		connect:"GridTilesUniqueWhere",
		create:"GridTilesCreateInput"
	},
	GridTilesUniqueWhere:{
		id:"UUID",
		items:"GridTileItemUniqueWhere"
	},
	GridTileItemUniqueWhere:{
		id:"UUID",
		link:"LinkUniqueWhere"
	},
	GridTilesCreateInput:{
		id:"UUID",
		items:"GridTilesCreateItemsEntityRelationInput"
	},
	GridTilesCreateItemsEntityRelationInput:{
		connect:"GridTileItemUniqueWhere",
		create:"GridTileItemWithoutListCreateInput"
	},
	GridTileItemWithoutListCreateInput:{
		id:"UUID",
		medium:"GridTileItemCreateMediumEntityRelationInput",
		link:"GridTileItemCreateLinkEntityRelationInput"
	},
	GridTileItemCreateMediumEntityRelationInput:{
		connect:"MediumUniqueWhere",
		create:"MediumCreateInput"
	},
	GridTileItemCreateLinkEntityRelationInput:{
		connect:"LinkUniqueWhere",
		create:"LinkCreateInput"
	},
	CartItemCreateFulfillmentNotesEntityRelationInput:{
		connect:"FulfillmentNoteUniqueWhere",
		create:"FulfillmentNoteWithoutCartItemsCreateInput"
	},
	FulfillmentNoteWithoutCartItemsCreateInput:{
		id:"UUID",
		products:"FulfillmentNoteCreateProductsEntityRelationInput",
		tags:"FulfillmentNoteCreateTagsEntityRelationInput",
		venues:"FulfillmentNoteCreateVenuesEntityRelationInput",
		orderItems:"FulfillmentNoteCreateOrderItemsEntityRelationInput",
		orders:"FulfillmentNoteCreateOrdersEntityRelationInput",
		createdAt:"DateTime"
	},
	ProductIngredientItemCreateQuantityEntityRelationInput:{
		connect:"ProductIngredientItemQuantityUniqueWhere",
		create:"ProductIngredientItemQuantityCreateInput"
	},
	ProductIngredientItemQuantityCreateInput:{
		id:"UUID",
		unit:"ProductIngredientItemQuantityCreateUnitEntityRelationInput"
	},
	ProductIngredientItemQuantityCreateUnitEntityRelationInput:{
		connect:"ProductIngredientItemQuantityUnitUniqueWhere",
		create:"ProductIngredientItemQuantityUnitCreateInput"
	},
	AddressUpdateInput:{
		customer:"AddressUpdateCustomerEntityRelationInput",
		country:"AddressUpdateCountryEntityRelationInput",
		deletedAt:"DateTime",
		geocodeGeneratedAt:"DateTime",
		deliveryZone:"AddressUpdateDeliveryZoneEntityRelationInput",
		meta:"AddressUpdateMetaEntityRelationInput",
		gps:"AddressUpdateGpsEntityRelationInput",
		invoices:"AddressUpdateInvoicesEntityRelationInput",
		createdAt:"DateTime",
		billingAddressOfOrders:"AddressUpdateBillingAddressOfOrdersEntityRelationInput",
		deliveryAddressOfOrderDeliveries:"AddressUpdateDeliveryAddressOfOrderDeliveriesEntityRelationInput",
		defaultDeliveryAddressOfCustomer:"AddressUpdateDefaultDeliveryAddressOfCustomerEntityRelationInput"
	},
	AddressUpdateCustomerEntityRelationInput:{
		create:"CustomerWithoutAddressesCreateInput",
		update:"CustomerWithoutAddressesUpdateInput",
		upsert:"AddressUpsertCustomerRelationInput",
		connect:"CustomerUniqueWhere"
	},
	CustomerWithoutAddressesUpdateInput:{
		defaultBillingAddress:"CustomerUpdateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerUpdateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerUpdateTagsEntityRelationInput",
		credits:"CustomerUpdateCreditsEntityRelationInput",
		paymentMethods:"CustomerUpdatePaymentMethodsEntityRelationInput",
		orders:"CustomerUpdateOrdersEntityRelationInput",
		permissions:"CustomerUpdatePermissionsEntityRelationInput",
		group:"CustomerUpdateGroupEntityRelationInput",
		photo:"CustomerUpdatePhotoEntityRelationInput",
		name:"CustomerUpdateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerUpdateIngredientRatingsEntityRelationInput",
		business:"CustomerUpdateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerUpdateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerUpdateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerUpdateCartsEntityRelationInput",
		shortcutList:"CustomerUpdateShortcutListEntityRelationInput",
		user:"CustomerUpdateUserEntityRelationInput",
		channels:"CustomerUpdateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerUpdateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerUpdateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerUpdateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerUpdateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerUpdateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerUpdateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerUpdateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerUpdateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerUpdateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerUpdateRedeemedVouchersEntityRelationInput",
		spending:"CustomerUpdateSpendingEntityRelationInput",
		customerTabs:"CustomerUpdateCustomerTabsEntityRelationInput",
		lead:"CustomerUpdateLeadEntityRelationInput",
		meta:"CustomerUpdateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerUpdateDefaultBillingAddressEntityRelationInput:{
		create:"AddressCreateInput",
		update:"AddressUpdateInput",
		upsert:"CustomerUpsertDefaultBillingAddressRelationInput",
		connect:"AddressUniqueWhere"
	},
	CustomerUpsertDefaultBillingAddressRelationInput:{
		update:"AddressUpdateInput",
		create:"AddressCreateInput"
	},
	CustomerUpdateDefaultPaymentMethodEntityRelationInput:{
		create:"CustomerPaymentMethodCreateInput",
		update:"CustomerPaymentMethodUpdateInput",
		upsert:"CustomerUpsertDefaultPaymentMethodRelationInput",
		connect:"CustomerPaymentMethodUniqueWhere"
	},
	CustomerPaymentMethodUpdateInput:{
		data:"Json",
		customer:"CustomerPaymentMethodUpdateCustomerEntityRelationInput",
		paymentMethod:"CustomerPaymentMethodUpdatePaymentMethodEntityRelationInput"
	},
	CustomerPaymentMethodUpdateCustomerEntityRelationInput:{
		create:"CustomerWithoutPaymentMethodsCreateInput",
		update:"CustomerWithoutPaymentMethodsUpdateInput",
		upsert:"CustomerPaymentMethodUpsertCustomerRelationInput",
		connect:"CustomerUniqueWhere"
	},
	CustomerWithoutPaymentMethodsUpdateInput:{
		addresses:"CustomerUpdateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerUpdateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerUpdateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerUpdateTagsEntityRelationInput",
		credits:"CustomerUpdateCreditsEntityRelationInput",
		orders:"CustomerUpdateOrdersEntityRelationInput",
		permissions:"CustomerUpdatePermissionsEntityRelationInput",
		group:"CustomerUpdateGroupEntityRelationInput",
		photo:"CustomerUpdatePhotoEntityRelationInput",
		name:"CustomerUpdateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerUpdateIngredientRatingsEntityRelationInput",
		business:"CustomerUpdateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerUpdateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerUpdateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerUpdateCartsEntityRelationInput",
		shortcutList:"CustomerUpdateShortcutListEntityRelationInput",
		user:"CustomerUpdateUserEntityRelationInput",
		channels:"CustomerUpdateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerUpdateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerUpdateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerUpdateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerUpdateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerUpdateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerUpdateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerUpdateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerUpdateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerUpdateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerUpdateRedeemedVouchersEntityRelationInput",
		spending:"CustomerUpdateSpendingEntityRelationInput",
		customerTabs:"CustomerUpdateCustomerTabsEntityRelationInput",
		lead:"CustomerUpdateLeadEntityRelationInput",
		meta:"CustomerUpdateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerUpdateAddressesEntityRelationInput:{
		create:"AddressWithoutCustomerCreateInput",
		update:"CustomerUpdateAddressesRelationInput",
		upsert:"CustomerUpsertAddressesRelationInput",
		connect:"AddressUniqueWhere",
		disconnect:"AddressUniqueWhere",
		delete:"AddressUniqueWhere"
	},
	CustomerUpdateAddressesRelationInput:{
		by:"AddressUniqueWhere",
		data:"AddressWithoutCustomerUpdateInput"
	},
	AddressWithoutCustomerUpdateInput:{
		country:"AddressUpdateCountryEntityRelationInput",
		deletedAt:"DateTime",
		geocodeGeneratedAt:"DateTime",
		deliveryZone:"AddressUpdateDeliveryZoneEntityRelationInput",
		meta:"AddressUpdateMetaEntityRelationInput",
		gps:"AddressUpdateGpsEntityRelationInput",
		invoices:"AddressUpdateInvoicesEntityRelationInput",
		createdAt:"DateTime",
		billingAddressOfOrders:"AddressUpdateBillingAddressOfOrdersEntityRelationInput",
		deliveryAddressOfOrderDeliveries:"AddressUpdateDeliveryAddressOfOrderDeliveriesEntityRelationInput",
		defaultDeliveryAddressOfCustomer:"AddressUpdateDefaultDeliveryAddressOfCustomerEntityRelationInput"
	},
	AddressUpdateCountryEntityRelationInput:{
		create:"CountryCreateInput",
		update:"CountryUpdateInput",
		upsert:"AddressUpsertCountryRelationInput",
		connect:"CountryUniqueWhere"
	},
	CountryUpdateInput:{

	},
	AddressUpsertCountryRelationInput:{
		update:"CountryUpdateInput",
		create:"CountryCreateInput"
	},
	AddressUpdateDeliveryZoneEntityRelationInput:{
		create:"DeliveryZoneWithoutAddressesCreateInput",
		update:"DeliveryZoneWithoutAddressesUpdateInput",
		upsert:"AddressUpsertDeliveryZoneRelationInput",
		connect:"DeliveryZoneUniqueWhere"
	},
	DeliveryZoneWithoutAddressesUpdateInput:{
		type:"DeliveryZoneType",
		suitableDeliveryMethods:"DeliveryZoneUpdateSuitableDeliveryMethodsEntityRelationInput",
		deliveryZonesOfTags:"DeliveryZoneUpdateDeliveryZonesOfTagsEntityRelationInput",
		deliveryZonesOfProducts:"DeliveryZoneUpdateDeliveryZonesOfProductsEntityRelationInput",
		addressesMetadata:"DeliveryZoneUpdateAddressesMetadataEntityRelationInput"
	},
	DeliveryZoneUpdateSuitableDeliveryMethodsEntityRelationInput:{
		create:"DeliveryMethodWithoutSuitableForDeliveryZonesCreateInput",
		update:"DeliveryZoneUpdateSuitableDeliveryMethodsRelationInput",
		upsert:"DeliveryZoneUpsertSuitableDeliveryMethodsRelationInput",
		connect:"DeliveryMethodUniqueWhere",
		disconnect:"DeliveryMethodUniqueWhere",
		delete:"DeliveryMethodUniqueWhere"
	},
	DeliveryZoneUpdateSuitableDeliveryMethodsRelationInput:{
		by:"DeliveryMethodUniqueWhere",
		data:"DeliveryMethodWithoutSuitableForDeliveryZonesUpdateInput"
	},
	DeliveryMethodWithoutSuitableForDeliveryZonesUpdateInput:{
		paymentMethods:"DeliveryMethodUpdatePaymentMethodsEntityRelationInput",
		channels:"DeliveryMethodUpdateChannelsEntityRelationInput",
		courierHandlers:"DeliveryMethodUpdateCourierHandlersEntityRelationInput",
		locales:"DeliveryMethodUpdateLocalesEntityRelationInput",
		timelinePreset:"DeliveryMethodUpdateTimelinePresetEntityRelationInput"
	},
	DeliveryMethodUpdatePaymentMethodsEntityRelationInput:{
		create:"PaymentMethodWithoutDeliveryMethodsCreateInput",
		update:"DeliveryMethodUpdatePaymentMethodsRelationInput",
		upsert:"DeliveryMethodUpsertPaymentMethodsRelationInput",
		connect:"PaymentMethodUniqueWhere",
		disconnect:"PaymentMethodUniqueWhere",
		delete:"PaymentMethodUniqueWhere"
	},
	DeliveryMethodUpdatePaymentMethodsRelationInput:{
		by:"PaymentMethodUniqueWhere",
		data:"PaymentMethodWithoutDeliveryMethodsUpdateInput"
	},
	PaymentMethodWithoutDeliveryMethodsUpdateInput:{
		type:"PaymentMethodType",
		channels:"PaymentMethodUpdateChannelsEntityRelationInput"
	},
	PaymentMethodUpdateChannelsEntityRelationInput:{
		create:"ChannelPaymentWithoutMethodCreateInput",
		update:"PaymentMethodUpdateChannelsRelationInput",
		upsert:"PaymentMethodUpsertChannelsRelationInput",
		connect:"ChannelPaymentUniqueWhere",
		disconnect:"ChannelPaymentUniqueWhere",
		delete:"ChannelPaymentUniqueWhere"
	},
	PaymentMethodUpdateChannelsRelationInput:{
		by:"ChannelPaymentUniqueWhere",
		data:"ChannelPaymentWithoutMethodUpdateInput"
	},
	ChannelPaymentWithoutMethodUpdateInput:{
		channel:"ChannelPaymentUpdateChannelEntityRelationInput",
		vatRate:"ChannelPaymentUpdateVatRateEntityRelationInput",
		allowOnlyForTags:"ChannelPaymentUpdateAllowOnlyForTagsEntityRelationInput"
	},
	ChannelPaymentUpdateChannelEntityRelationInput:{
		create:"ChannelWithoutPaymentsCreateInput",
		update:"ChannelWithoutPaymentsUpdateInput",
		upsert:"ChannelPaymentUpsertChannelRelationInput",
		connect:"ChannelUniqueWhere"
	},
	ChannelWithoutPaymentsUpdateInput:{
		deliveries:"ChannelUpdateDeliveriesEntityRelationInput",
		pointOfSales:"ChannelUpdatePointOfSalesEntityRelationInput",
		carts:"ChannelUpdateCartsEntityRelationInput",
		customers:"ChannelUpdateCustomersEntityRelationInput",
		code:"ChannelCode",
		addTagsOnRegistration:"ChannelUpdateAddTagsOnRegistrationEntityRelationInput",
		publicTags:"ChannelUpdatePublicTagsEntityRelationInput",
		venue:"ChannelUpdateVenueEntityRelationInput"
	},
	ChannelUpdateDeliveriesEntityRelationInput:{
		create:"ChannelDeliveryWithoutChannelCreateInput",
		update:"ChannelUpdateDeliveriesRelationInput",
		upsert:"ChannelUpsertDeliveriesRelationInput",
		connect:"ChannelDeliveryUniqueWhere",
		disconnect:"ChannelDeliveryUniqueWhere",
		delete:"ChannelDeliveryUniqueWhere"
	},
	ChannelUpdateDeliveriesRelationInput:{
		by:"ChannelDeliveryUniqueWhere",
		data:"ChannelDeliveryWithoutChannelUpdateInput"
	},
	ChannelDeliveryWithoutChannelUpdateInput:{
		method:"ChannelDeliveryUpdateMethodEntityRelationInput",
		vatRate:"ChannelDeliveryUpdateVatRateEntityRelationInput"
	},
	ChannelDeliveryUpdateMethodEntityRelationInput:{
		create:"DeliveryMethodWithoutChannelsCreateInput",
		update:"DeliveryMethodWithoutChannelsUpdateInput",
		upsert:"ChannelDeliveryUpsertMethodRelationInput",
		connect:"DeliveryMethodUniqueWhere"
	},
	DeliveryMethodWithoutChannelsUpdateInput:{
		paymentMethods:"DeliveryMethodUpdatePaymentMethodsEntityRelationInput",
		suitableForDeliveryZones:"DeliveryMethodUpdateSuitableForDeliveryZonesEntityRelationInput",
		courierHandlers:"DeliveryMethodUpdateCourierHandlersEntityRelationInput",
		locales:"DeliveryMethodUpdateLocalesEntityRelationInput",
		timelinePreset:"DeliveryMethodUpdateTimelinePresetEntityRelationInput"
	},
	DeliveryMethodUpdateSuitableForDeliveryZonesEntityRelationInput:{
		create:"DeliveryZoneWithoutSuitableDeliveryMethodsCreateInput",
		update:"DeliveryMethodUpdateSuitableForDeliveryZonesRelationInput",
		upsert:"DeliveryMethodUpsertSuitableForDeliveryZonesRelationInput",
		connect:"DeliveryZoneUniqueWhere",
		disconnect:"DeliveryZoneUniqueWhere",
		delete:"DeliveryZoneUniqueWhere"
	},
	DeliveryMethodUpdateSuitableForDeliveryZonesRelationInput:{
		by:"DeliveryZoneUniqueWhere",
		data:"DeliveryZoneWithoutSuitableDeliveryMethodsUpdateInput"
	},
	DeliveryZoneWithoutSuitableDeliveryMethodsUpdateInput:{
		type:"DeliveryZoneType",
		addresses:"DeliveryZoneUpdateAddressesEntityRelationInput",
		deliveryZonesOfTags:"DeliveryZoneUpdateDeliveryZonesOfTagsEntityRelationInput",
		deliveryZonesOfProducts:"DeliveryZoneUpdateDeliveryZonesOfProductsEntityRelationInput",
		addressesMetadata:"DeliveryZoneUpdateAddressesMetadataEntityRelationInput"
	},
	DeliveryZoneUpdateAddressesEntityRelationInput:{
		create:"AddressWithoutDeliveryZoneCreateInput",
		update:"DeliveryZoneUpdateAddressesRelationInput",
		upsert:"DeliveryZoneUpsertAddressesRelationInput",
		connect:"AddressUniqueWhere",
		disconnect:"AddressUniqueWhere",
		delete:"AddressUniqueWhere"
	},
	DeliveryZoneUpdateAddressesRelationInput:{
		by:"AddressUniqueWhere",
		data:"AddressWithoutDeliveryZoneUpdateInput"
	},
	AddressWithoutDeliveryZoneUpdateInput:{
		customer:"AddressUpdateCustomerEntityRelationInput",
		country:"AddressUpdateCountryEntityRelationInput",
		deletedAt:"DateTime",
		geocodeGeneratedAt:"DateTime",
		meta:"AddressUpdateMetaEntityRelationInput",
		gps:"AddressUpdateGpsEntityRelationInput",
		invoices:"AddressUpdateInvoicesEntityRelationInput",
		createdAt:"DateTime",
		billingAddressOfOrders:"AddressUpdateBillingAddressOfOrdersEntityRelationInput",
		deliveryAddressOfOrderDeliveries:"AddressUpdateDeliveryAddressOfOrderDeliveriesEntityRelationInput",
		defaultDeliveryAddressOfCustomer:"AddressUpdateDefaultDeliveryAddressOfCustomerEntityRelationInput"
	},
	AddressUpdateMetaEntityRelationInput:{
		connect:"AddressMetadataUniqueWhere"
	},
	AddressUpdateGpsEntityRelationInput:{
		create:"GpsWithoutAddressCreateInput",
		update:"GpsWithoutAddressUpdateInput",
		upsert:"AddressUpsertGpsRelationInput",
		connect:"GpsUniqueWhere"
	},
	GpsWithoutAddressUpdateInput:{

	},
	AddressUpsertGpsRelationInput:{
		update:"GpsWithoutAddressUpdateInput",
		create:"GpsWithoutAddressCreateInput"
	},
	AddressUpdateInvoicesEntityRelationInput:{
		create:"InvoiceWithoutAddressCreateInput",
		update:"AddressUpdateInvoicesRelationInput",
		upsert:"AddressUpsertInvoicesRelationInput",
		connect:"InvoiceUniqueWhere",
		disconnect:"InvoiceUniqueWhere",
		delete:"InvoiceUniqueWhere"
	},
	AddressUpdateInvoicesRelationInput:{
		by:"InvoiceUniqueWhere",
		data:"InvoiceWithoutAddressUpdateInput"
	},
	InvoiceWithoutAddressUpdateInput:{
		createdAt:"DateTime",
		customer:"InvoiceUpdateCustomerEntityRelationInput",
		orderPayments:"InvoiceUpdateOrderPaymentsEntityRelationInput",
		billingSubject:"InvoiceUpdateBillingSubjectEntityRelationInput"
	},
	InvoiceUpdateCustomerEntityRelationInput:{
		create:"CustomerWithoutInvoicesCreateInput",
		update:"CustomerWithoutInvoicesUpdateInput",
		upsert:"InvoiceUpsertCustomerRelationInput",
		connect:"CustomerUniqueWhere"
	},
	CustomerWithoutInvoicesUpdateInput:{
		addresses:"CustomerUpdateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerUpdateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerUpdateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerUpdateTagsEntityRelationInput",
		credits:"CustomerUpdateCreditsEntityRelationInput",
		paymentMethods:"CustomerUpdatePaymentMethodsEntityRelationInput",
		orders:"CustomerUpdateOrdersEntityRelationInput",
		permissions:"CustomerUpdatePermissionsEntityRelationInput",
		group:"CustomerUpdateGroupEntityRelationInput",
		photo:"CustomerUpdatePhotoEntityRelationInput",
		name:"CustomerUpdateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerUpdateIngredientRatingsEntityRelationInput",
		business:"CustomerUpdateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerUpdateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerUpdateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerUpdateCartsEntityRelationInput",
		shortcutList:"CustomerUpdateShortcutListEntityRelationInput",
		user:"CustomerUpdateUserEntityRelationInput",
		channels:"CustomerUpdateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoicingPlan:"CustomerUpdateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerUpdateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerUpdateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerUpdateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerUpdateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerUpdateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerUpdateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerUpdateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerUpdateRedeemedVouchersEntityRelationInput",
		spending:"CustomerUpdateSpendingEntityRelationInput",
		customerTabs:"CustomerUpdateCustomerTabsEntityRelationInput",
		lead:"CustomerUpdateLeadEntityRelationInput",
		meta:"CustomerUpdateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerUpdateTagsEntityRelationInput:{
		create:"TagWithoutCustomersCreateInput",
		update:"CustomerUpdateTagsRelationInput",
		upsert:"CustomerUpsertTagsRelationInput",
		connect:"TagUniqueWhere",
		disconnect:"TagUniqueWhere",
		delete:"TagUniqueWhere"
	},
	CustomerUpdateTagsRelationInput:{
		by:"TagUniqueWhere",
		data:"TagWithoutCustomersUpdateInput"
	},
	TagWithoutCustomersUpdateInput:{
		products:"TagUpdateProductsEntityRelationInput",
		categories:"TagUpdateCategoriesEntityRelationInput",
		addTagsOnRegistration:"TagUpdateAddTagsOnRegistrationEntityRelationInput",
		nestedCategories:"TagUpdateNestedCategoriesEntityRelationInput",
		deliveryZones:"TagUpdateDeliveryZonesEntityRelationInput",
		publicInChannels:"TagUpdatePublicInChannelsEntityRelationInput",
		allowChannelPayments:"TagUpdateAllowChannelPaymentsEntityRelationInput",
		fulfillmentNotes:"TagUpdateFulfillmentNotesEntityRelationInput"
	},
	TagUpdateProductsEntityRelationInput:{
		create:"ProductWithoutTagsCreateInput",
		update:"TagUpdateProductsRelationInput",
		upsert:"TagUpsertProductsRelationInput",
		connect:"ProductUniqueWhere",
		disconnect:"ProductUniqueWhere",
		delete:"ProductUniqueWhere"
	},
	TagUpdateProductsRelationInput:{
		by:"ProductUniqueWhere",
		data:"ProductWithoutTagsUpdateInput"
	},
	ProductWithoutTagsUpdateInput:{
		packing:"ProductUpdatePackingEntityRelationInput",
		recipe:"ProductUpdateRecipeEntityRelationInput",
		categories:"ProductUpdateCategoriesEntityRelationInput",
		vatRate:"ProductUpdateVatRateEntityRelationInput",
		stocks:"ProductUpdateStocksEntityRelationInput",
		groupPrices:"ProductUpdateGroupPricesEntityRelationInput",
		image:"ProductUpdateImageEntityRelationInput",
		cartItems:"ProductUpdateCartItemsEntityRelationInput",
		availability:"ProductAvailability",
		manager:"ProductUpdateManagerEntityRelationInput",
		orderItems:"ProductUpdateOrderItemsEntityRelationInput",
		inheritedCategories:"ProductUpdateInheritedCategoriesEntityRelationInput",
		deliveryZones:"ProductUpdateDeliveryZonesEntityRelationInput",
		locales:"ProductUpdateLocalesEntityRelationInput",
		archivedAt:"DateTime",
		customerPrices:"ProductUpdateCustomerPricesEntityRelationInput",
		virtualProduct:"ProductUpdateVirtualProductEntityRelationInput",
		meta:"ProductUpdateMetaEntityRelationInput",
		page:"ProductUpdatePageEntityRelationInput",
		salesDays:"ProductUpdateSalesDaysEntityRelationInput",
		salesWeeks:"ProductUpdateSalesWeeksEntityRelationInput",
		salesMonths:"ProductUpdateSalesMonthsEntityRelationInput",
		fulfillmentNotes:"ProductUpdateFulfillmentNotesEntityRelationInput"
	},
	ProductUpdatePackingEntityRelationInput:{
		create:"ProductPackingCreateInput",
		update:"ProductPackingUpdateInput",
		upsert:"ProductUpsertPackingRelationInput",
		connect:"ProductPackingUniqueWhere"
	},
	ProductPackingUpdateInput:{
		image:"ProductPackingUpdateImageEntityRelationInput",
		icon:"ProductPackingUpdateIconEntityRelationInput",
		locales:"ProductPackingUpdateLocalesEntityRelationInput",
		preparedPackingQuantities:"ProductPackingUpdatePreparedPackingQuantitiesEntityRelationInput"
	},
	ProductPackingUpdateImageEntityRelationInput:{
		create:"ImageCreateInput",
		update:"ImageUpdateInput",
		upsert:"ProductPackingUpsertImageRelationInput",
		connect:"ImageUniqueWhere"
	},
	ImageUpdateInput:{

	},
	ProductPackingUpsertImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	ProductPackingUpdateIconEntityRelationInput:{
		create:"ImageCreateInput",
		update:"ImageUpdateInput",
		upsert:"ProductPackingUpsertIconRelationInput",
		connect:"ImageUniqueWhere"
	},
	ProductPackingUpsertIconRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	ProductPackingUpdateLocalesEntityRelationInput:{
		create:"ProductPackingLocaleWithoutRootCreateInput",
		update:"ProductPackingUpdateLocalesRelationInput",
		upsert:"ProductPackingUpsertLocalesRelationInput",
		connect:"ProductPackingLocaleUniqueWhere",
		disconnect:"ProductPackingLocaleUniqueWhere",
		delete:"ProductPackingLocaleUniqueWhere"
	},
	ProductPackingUpdateLocalesRelationInput:{
		by:"ProductPackingLocaleUniqueWhere",
		data:"ProductPackingLocaleWithoutRootUpdateInput"
	},
	ProductPackingLocaleWithoutRootUpdateInput:{
		locale:"ProductPackingLocaleUpdateLocaleEntityRelationInput"
	},
	ProductPackingLocaleUpdateLocaleEntityRelationInput:{
		create:"LocaleWithoutProductPackingsCreateInput",
		update:"LocaleWithoutProductPackingsUpdateInput",
		upsert:"ProductPackingLocaleUpsertLocaleRelationInput",
		connect:"LocaleUniqueWhere"
	},
	LocaleWithoutProductPackingsUpdateInput:{
		businessCategories:"LocaleUpdateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleUpdateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleUpdateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleUpdateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleUpdateBlogsEntityRelationInput",
		blogPosts:"LocaleUpdateBlogPostsEntityRelationInput",
		identifier:"LocaleUpdateIdentifierEntityRelationInput",
		menus:"LocaleUpdateMenusEntityRelationInput",
		pages:"LocaleUpdatePagesEntityRelationInput",
		productIngredientCategories:"LocaleUpdateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleUpdateAllergensEntityRelationInput",
		products:"LocaleUpdateProductsEntityRelationInput",
		productRecipes:"LocaleUpdateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleUpdatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleUpdateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleUpdateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleUpdateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleUpdatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleUpdateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleUpdateBusinessServicesEntityRelationInput"
	},
	LocaleUpdateBusinessCategoriesEntityRelationInput:{
		create:"BusinessCategoryLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateBusinessCategoriesRelationInput",
		upsert:"LocaleUpsertBusinessCategoriesRelationInput",
		connect:"BusinessCategoryLocaleUniqueWhere",
		disconnect:"BusinessCategoryLocaleUniqueWhere",
		delete:"BusinessCategoryLocaleUniqueWhere"
	},
	LocaleUpdateBusinessCategoriesRelationInput:{
		by:"BusinessCategoryLocaleUniqueWhere",
		data:"BusinessCategoryLocaleWithoutLocaleUpdateInput"
	},
	BusinessCategoryLocaleWithoutLocaleUpdateInput:{
		root:"BusinessCategoryLocaleUpdateRootEntityRelationInput"
	},
	BusinessCategoryLocaleUpdateRootEntityRelationInput:{
		create:"BusinessCategoryWithoutLocalesCreateInput",
		update:"BusinessCategoryWithoutLocalesUpdateInput",
		upsert:"BusinessCategoryLocaleUpsertRootRelationInput",
		connect:"BusinessCategoryUniqueWhere"
	},
	BusinessCategoryWithoutLocalesUpdateInput:{
		businessCustomers:"BusinessCategoryUpdateBusinessCustomersEntityRelationInput",
		recurrences:"BusinessCategoryUpdateRecurrencesEntityRelationInput",
		specificProducts:"BusinessCategoryUpdateSpecificProductsEntityRelationInput",
		seasonalProductCategories:"BusinessCategoryUpdateSeasonalProductCategoriesEntityRelationInput",
		specificProductsProductCategories:"BusinessCategoryUpdateSpecificProductsProductCategoriesEntityRelationInput"
	},
	BusinessCategoryUpdateBusinessCustomersEntityRelationInput:{
		create:"BusinessCustomerWithoutCategoryCreateInput",
		update:"BusinessCategoryUpdateBusinessCustomersRelationInput",
		upsert:"BusinessCategoryUpsertBusinessCustomersRelationInput",
		connect:"BusinessCustomerUniqueWhere",
		disconnect:"BusinessCustomerUniqueWhere",
		delete:"BusinessCustomerUniqueWhere"
	},
	BusinessCategoryUpdateBusinessCustomersRelationInput:{
		by:"BusinessCustomerUniqueWhere",
		data:"BusinessCustomerWithoutCategoryUpdateInput"
	},
	BusinessCustomerWithoutCategoryUpdateInput:{
		customer:"BusinessCustomerUpdateCustomerEntityRelationInput",
		owners:"BusinessCustomerUpdateOwnersEntityRelationInput",
		members:"BusinessCustomerUpdateMembersEntityRelationInput",
		accountManager:"BusinessCustomerUpdateAccountManagerEntityRelationInput",
		logo:"BusinessCustomerUpdateLogoEntityRelationInput",
		businessServiceEvents:"BusinessCustomerUpdateBusinessServiceEventsEntityRelationInput",
		doubleshotCoffeeEquipment:"BusinessCustomerUpdateDoubleshotCoffeeEquipmentEntityRelationInput"
	},
	BusinessCustomerUpdateCustomerEntityRelationInput:{
		create:"CustomerWithoutBusinessCreateInput",
		update:"CustomerWithoutBusinessUpdateInput",
		upsert:"BusinessCustomerUpsertCustomerRelationInput",
		connect:"CustomerUniqueWhere"
	},
	CustomerWithoutBusinessUpdateInput:{
		addresses:"CustomerUpdateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerUpdateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerUpdateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerUpdateTagsEntityRelationInput",
		credits:"CustomerUpdateCreditsEntityRelationInput",
		paymentMethods:"CustomerUpdatePaymentMethodsEntityRelationInput",
		orders:"CustomerUpdateOrdersEntityRelationInput",
		permissions:"CustomerUpdatePermissionsEntityRelationInput",
		group:"CustomerUpdateGroupEntityRelationInput",
		photo:"CustomerUpdatePhotoEntityRelationInput",
		name:"CustomerUpdateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerUpdateIngredientRatingsEntityRelationInput",
		ownerOfBusinesses:"CustomerUpdateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerUpdateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerUpdateCartsEntityRelationInput",
		shortcutList:"CustomerUpdateShortcutListEntityRelationInput",
		user:"CustomerUpdateUserEntityRelationInput",
		channels:"CustomerUpdateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerUpdateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerUpdateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerUpdateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerUpdateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerUpdateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerUpdateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerUpdateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerUpdateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerUpdateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerUpdateRedeemedVouchersEntityRelationInput",
		spending:"CustomerUpdateSpendingEntityRelationInput",
		customerTabs:"CustomerUpdateCustomerTabsEntityRelationInput",
		lead:"CustomerUpdateLeadEntityRelationInput",
		meta:"CustomerUpdateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerUpdateCreditsEntityRelationInput:{
		create:"CustomerCreditWithoutCustomerCreateInput",
		update:"CustomerUpdateCreditsRelationInput",
		upsert:"CustomerUpsertCreditsRelationInput",
		connect:"CustomerCreditUniqueWhere",
		disconnect:"CustomerCreditUniqueWhere",
		delete:"CustomerCreditUniqueWhere"
	},
	CustomerUpdateCreditsRelationInput:{
		by:"CustomerCreditUniqueWhere",
		data:"CustomerCreditWithoutCustomerUpdateInput"
	},
	CustomerCreditWithoutCustomerUpdateInput:{
		expiresAt:"DateTime",
		vatRate:"CustomerCreditUpdateVatRateEntityRelationInput",
		createdAt:"DateTime",
		transactions:"CustomerCreditUpdateTransactionsEntityRelationInput",
		voucherRedemption:"CustomerCreditUpdateVoucherRedemptionEntityRelationInput"
	},
	CustomerCreditUpdateVatRateEntityRelationInput:{
		create:"VatRateCreateInput",
		update:"VatRateUpdateInput",
		upsert:"CustomerCreditUpsertVatRateRelationInput",
		connect:"VatRateUniqueWhere"
	},
	VatRateUpdateInput:{
		channelDeliveries:"VatRateUpdateChannelDeliveriesEntityRelationInput",
		channelPayments:"VatRateUpdateChannelPaymentsEntityRelationInput",
		preset:"VatRatePreset"
	},
	VatRateUpdateChannelDeliveriesEntityRelationInput:{
		create:"ChannelDeliveryWithoutVatRateCreateInput",
		update:"VatRateUpdateChannelDeliveriesRelationInput",
		upsert:"VatRateUpsertChannelDeliveriesRelationInput",
		connect:"ChannelDeliveryUniqueWhere",
		disconnect:"ChannelDeliveryUniqueWhere",
		delete:"ChannelDeliveryUniqueWhere"
	},
	VatRateUpdateChannelDeliveriesRelationInput:{
		by:"ChannelDeliveryUniqueWhere",
		data:"ChannelDeliveryWithoutVatRateUpdateInput"
	},
	ChannelDeliveryWithoutVatRateUpdateInput:{
		channel:"ChannelDeliveryUpdateChannelEntityRelationInput",
		method:"ChannelDeliveryUpdateMethodEntityRelationInput"
	},
	ChannelDeliveryUpdateChannelEntityRelationInput:{
		create:"ChannelWithoutDeliveriesCreateInput",
		update:"ChannelWithoutDeliveriesUpdateInput",
		upsert:"ChannelDeliveryUpsertChannelRelationInput",
		connect:"ChannelUniqueWhere"
	},
	ChannelWithoutDeliveriesUpdateInput:{
		payments:"ChannelUpdatePaymentsEntityRelationInput",
		pointOfSales:"ChannelUpdatePointOfSalesEntityRelationInput",
		carts:"ChannelUpdateCartsEntityRelationInput",
		customers:"ChannelUpdateCustomersEntityRelationInput",
		code:"ChannelCode",
		addTagsOnRegistration:"ChannelUpdateAddTagsOnRegistrationEntityRelationInput",
		publicTags:"ChannelUpdatePublicTagsEntityRelationInput",
		venue:"ChannelUpdateVenueEntityRelationInput"
	},
	ChannelUpdatePaymentsEntityRelationInput:{
		create:"ChannelPaymentWithoutChannelCreateInput",
		update:"ChannelUpdatePaymentsRelationInput",
		upsert:"ChannelUpsertPaymentsRelationInput",
		connect:"ChannelPaymentUniqueWhere",
		disconnect:"ChannelPaymentUniqueWhere",
		delete:"ChannelPaymentUniqueWhere"
	},
	ChannelUpdatePaymentsRelationInput:{
		by:"ChannelPaymentUniqueWhere",
		data:"ChannelPaymentWithoutChannelUpdateInput"
	},
	ChannelPaymentWithoutChannelUpdateInput:{
		method:"ChannelPaymentUpdateMethodEntityRelationInput",
		vatRate:"ChannelPaymentUpdateVatRateEntityRelationInput",
		allowOnlyForTags:"ChannelPaymentUpdateAllowOnlyForTagsEntityRelationInput"
	},
	ChannelPaymentUpdateMethodEntityRelationInput:{
		create:"PaymentMethodWithoutChannelsCreateInput",
		update:"PaymentMethodWithoutChannelsUpdateInput",
		upsert:"ChannelPaymentUpsertMethodRelationInput",
		connect:"PaymentMethodUniqueWhere"
	},
	PaymentMethodWithoutChannelsUpdateInput:{
		deliveryMethods:"PaymentMethodUpdateDeliveryMethodsEntityRelationInput",
		type:"PaymentMethodType"
	},
	PaymentMethodUpdateDeliveryMethodsEntityRelationInput:{
		create:"DeliveryMethodWithoutPaymentMethodsCreateInput",
		update:"PaymentMethodUpdateDeliveryMethodsRelationInput",
		upsert:"PaymentMethodUpsertDeliveryMethodsRelationInput",
		connect:"DeliveryMethodUniqueWhere",
		disconnect:"DeliveryMethodUniqueWhere",
		delete:"DeliveryMethodUniqueWhere"
	},
	PaymentMethodUpdateDeliveryMethodsRelationInput:{
		by:"DeliveryMethodUniqueWhere",
		data:"DeliveryMethodWithoutPaymentMethodsUpdateInput"
	},
	DeliveryMethodWithoutPaymentMethodsUpdateInput:{
		suitableForDeliveryZones:"DeliveryMethodUpdateSuitableForDeliveryZonesEntityRelationInput",
		channels:"DeliveryMethodUpdateChannelsEntityRelationInput",
		courierHandlers:"DeliveryMethodUpdateCourierHandlersEntityRelationInput",
		locales:"DeliveryMethodUpdateLocalesEntityRelationInput",
		timelinePreset:"DeliveryMethodUpdateTimelinePresetEntityRelationInput"
	},
	DeliveryMethodUpdateChannelsEntityRelationInput:{
		create:"ChannelDeliveryWithoutMethodCreateInput",
		update:"DeliveryMethodUpdateChannelsRelationInput",
		upsert:"DeliveryMethodUpsertChannelsRelationInput",
		connect:"ChannelDeliveryUniqueWhere",
		disconnect:"ChannelDeliveryUniqueWhere",
		delete:"ChannelDeliveryUniqueWhere"
	},
	DeliveryMethodUpdateChannelsRelationInput:{
		by:"ChannelDeliveryUniqueWhere",
		data:"ChannelDeliveryWithoutMethodUpdateInput"
	},
	ChannelDeliveryWithoutMethodUpdateInput:{
		channel:"ChannelDeliveryUpdateChannelEntityRelationInput",
		vatRate:"ChannelDeliveryUpdateVatRateEntityRelationInput"
	},
	ChannelDeliveryUpdateVatRateEntityRelationInput:{
		create:"VatRateWithoutChannelDeliveriesCreateInput",
		update:"VatRateWithoutChannelDeliveriesUpdateInput",
		upsert:"ChannelDeliveryUpsertVatRateRelationInput",
		connect:"VatRateUniqueWhere"
	},
	VatRateWithoutChannelDeliveriesUpdateInput:{
		channelPayments:"VatRateUpdateChannelPaymentsEntityRelationInput",
		preset:"VatRatePreset"
	},
	VatRateUpdateChannelPaymentsEntityRelationInput:{
		create:"ChannelPaymentWithoutVatRateCreateInput",
		update:"VatRateUpdateChannelPaymentsRelationInput",
		upsert:"VatRateUpsertChannelPaymentsRelationInput",
		connect:"ChannelPaymentUniqueWhere",
		disconnect:"ChannelPaymentUniqueWhere",
		delete:"ChannelPaymentUniqueWhere"
	},
	VatRateUpdateChannelPaymentsRelationInput:{
		by:"ChannelPaymentUniqueWhere",
		data:"ChannelPaymentWithoutVatRateUpdateInput"
	},
	ChannelPaymentWithoutVatRateUpdateInput:{
		channel:"ChannelPaymentUpdateChannelEntityRelationInput",
		method:"ChannelPaymentUpdateMethodEntityRelationInput",
		allowOnlyForTags:"ChannelPaymentUpdateAllowOnlyForTagsEntityRelationInput"
	},
	ChannelPaymentUpdateAllowOnlyForTagsEntityRelationInput:{
		create:"TagWithoutAllowChannelPaymentsCreateInput",
		update:"ChannelPaymentUpdateAllowOnlyForTagsRelationInput",
		upsert:"ChannelPaymentUpsertAllowOnlyForTagsRelationInput",
		connect:"TagUniqueWhere",
		disconnect:"TagUniqueWhere",
		delete:"TagUniqueWhere"
	},
	ChannelPaymentUpdateAllowOnlyForTagsRelationInput:{
		by:"TagUniqueWhere",
		data:"TagWithoutAllowChannelPaymentsUpdateInput"
	},
	TagWithoutAllowChannelPaymentsUpdateInput:{
		customers:"TagUpdateCustomersEntityRelationInput",
		products:"TagUpdateProductsEntityRelationInput",
		categories:"TagUpdateCategoriesEntityRelationInput",
		addTagsOnRegistration:"TagUpdateAddTagsOnRegistrationEntityRelationInput",
		nestedCategories:"TagUpdateNestedCategoriesEntityRelationInput",
		deliveryZones:"TagUpdateDeliveryZonesEntityRelationInput",
		publicInChannels:"TagUpdatePublicInChannelsEntityRelationInput",
		fulfillmentNotes:"TagUpdateFulfillmentNotesEntityRelationInput"
	},
	TagUpdateCustomersEntityRelationInput:{
		create:"CustomerWithoutTagsCreateInput",
		update:"TagUpdateCustomersRelationInput",
		upsert:"TagUpsertCustomersRelationInput",
		connect:"CustomerUniqueWhere",
		disconnect:"CustomerUniqueWhere",
		delete:"CustomerUniqueWhere"
	},
	TagUpdateCustomersRelationInput:{
		by:"CustomerUniqueWhere",
		data:"CustomerWithoutTagsUpdateInput"
	},
	CustomerWithoutTagsUpdateInput:{
		addresses:"CustomerUpdateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerUpdateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerUpdateDefaultPaymentMethodEntityRelationInput",
		credits:"CustomerUpdateCreditsEntityRelationInput",
		paymentMethods:"CustomerUpdatePaymentMethodsEntityRelationInput",
		orders:"CustomerUpdateOrdersEntityRelationInput",
		permissions:"CustomerUpdatePermissionsEntityRelationInput",
		group:"CustomerUpdateGroupEntityRelationInput",
		photo:"CustomerUpdatePhotoEntityRelationInput",
		name:"CustomerUpdateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerUpdateIngredientRatingsEntityRelationInput",
		business:"CustomerUpdateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerUpdateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerUpdateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerUpdateCartsEntityRelationInput",
		shortcutList:"CustomerUpdateShortcutListEntityRelationInput",
		user:"CustomerUpdateUserEntityRelationInput",
		channels:"CustomerUpdateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerUpdateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerUpdateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerUpdateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerUpdateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerUpdateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerUpdateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerUpdateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerUpdateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerUpdateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerUpdateRedeemedVouchersEntityRelationInput",
		spending:"CustomerUpdateSpendingEntityRelationInput",
		customerTabs:"CustomerUpdateCustomerTabsEntityRelationInput",
		lead:"CustomerUpdateLeadEntityRelationInput",
		meta:"CustomerUpdateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerUpdatePaymentMethodsEntityRelationInput:{
		create:"CustomerPaymentMethodWithoutCustomerCreateInput",
		update:"CustomerUpdatePaymentMethodsRelationInput",
		upsert:"CustomerUpsertPaymentMethodsRelationInput",
		connect:"CustomerPaymentMethodUniqueWhere",
		disconnect:"CustomerPaymentMethodUniqueWhere",
		delete:"CustomerPaymentMethodUniqueWhere"
	},
	CustomerUpdatePaymentMethodsRelationInput:{
		by:"CustomerPaymentMethodUniqueWhere",
		data:"CustomerPaymentMethodWithoutCustomerUpdateInput"
	},
	CustomerPaymentMethodWithoutCustomerUpdateInput:{
		data:"Json",
		paymentMethod:"CustomerPaymentMethodUpdatePaymentMethodEntityRelationInput"
	},
	CustomerPaymentMethodUpdatePaymentMethodEntityRelationInput:{
		create:"PaymentMethodCreateInput",
		update:"PaymentMethodUpdateInput",
		upsert:"CustomerPaymentMethodUpsertPaymentMethodRelationInput",
		connect:"PaymentMethodUniqueWhere"
	},
	PaymentMethodUpdateInput:{
		deliveryMethods:"PaymentMethodUpdateDeliveryMethodsEntityRelationInput",
		type:"PaymentMethodType",
		channels:"PaymentMethodUpdateChannelsEntityRelationInput"
	},
	CustomerPaymentMethodUpsertPaymentMethodRelationInput:{
		update:"PaymentMethodUpdateInput",
		create:"PaymentMethodCreateInput"
	},
	CustomerUpsertPaymentMethodsRelationInput:{
		by:"CustomerPaymentMethodUniqueWhere",
		update:"CustomerPaymentMethodWithoutCustomerUpdateInput",
		create:"CustomerPaymentMethodWithoutCustomerCreateInput"
	},
	CustomerUpdateOrdersEntityRelationInput:{
		create:"OrderWithoutCustomerCreateInput",
		update:"CustomerUpdateOrdersRelationInput",
		upsert:"CustomerUpsertOrdersRelationInput",
		connect:"OrderUniqueWhere",
		disconnect:"OrderUniqueWhere",
		delete:"OrderUniqueWhere"
	},
	CustomerUpdateOrdersRelationInput:{
		by:"OrderUniqueWhere",
		data:"OrderWithoutCustomerUpdateInput"
	},
	OrderWithoutCustomerUpdateInput:{
		state:"OrderState",
		fulfilledAt:"DateTime",
		canceledAt:"DateTime",
		channel:"OrderUpdateChannelEntityRelationInput",
		discounts:"OrderUpdateDiscountsEntityRelationInput",
		delivery:"OrderUpdateDeliveryEntityRelationInput",
		items:"OrderUpdateItemsEntityRelationInput",
		cart:"OrderUpdateCartEntityRelationInput",
		events:"OrderUpdateEventsEntityRelationInput",
		createdAt:"DateTime",
		billingAddress:"OrderUpdateBillingAddressEntityRelationInput",
		priceLines:"OrderUpdatePriceLinesEntityRelationInput",
		payments:"OrderUpdatePaymentsEntityRelationInput",
		billingSubject:"OrderUpdateBillingSubjectEntityRelationInput",
		summary:"OrderUpdateSummaryEntityRelationInput",
		gratuity:"OrderUpdateGratuityEntityRelationInput",
		venue:"OrderUpdateVenueEntityRelationInput",
		fulfillmentNotes:"OrderUpdateFulfillmentNotesEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	OrderUpdateChannelEntityRelationInput:{
		create:"ChannelCreateInput",
		update:"ChannelUpdateInput",
		upsert:"OrderUpsertChannelRelationInput",
		connect:"ChannelUniqueWhere"
	},
	ChannelUpdateInput:{
		payments:"ChannelUpdatePaymentsEntityRelationInput",
		deliveries:"ChannelUpdateDeliveriesEntityRelationInput",
		pointOfSales:"ChannelUpdatePointOfSalesEntityRelationInput",
		carts:"ChannelUpdateCartsEntityRelationInput",
		customers:"ChannelUpdateCustomersEntityRelationInput",
		code:"ChannelCode",
		addTagsOnRegistration:"ChannelUpdateAddTagsOnRegistrationEntityRelationInput",
		publicTags:"ChannelUpdatePublicTagsEntityRelationInput",
		venue:"ChannelUpdateVenueEntityRelationInput"
	},
	ChannelUpdatePointOfSalesEntityRelationInput:{
		create:"PointOfSaleWithoutChannelsCreateInput",
		update:"ChannelUpdatePointOfSalesRelationInput",
		upsert:"ChannelUpsertPointOfSalesRelationInput",
		connect:"PointOfSaleUniqueWhere",
		disconnect:"PointOfSaleUniqueWhere",
		delete:"PointOfSaleUniqueWhere"
	},
	ChannelUpdatePointOfSalesRelationInput:{
		by:"PointOfSaleUniqueWhere",
		data:"PointOfSaleWithoutChannelsUpdateInput"
	},
	PointOfSaleWithoutChannelsUpdateInput:{
		permissions:"PointOfSaleUpdatePermissionsEntityRelationInput",
		tenantPersonId:"UUID"
	},
	PointOfSaleUpdatePermissionsEntityRelationInput:{
		connect:"PointOfSalePermissionsUniqueWhere"
	},
	ChannelUpsertPointOfSalesRelationInput:{
		by:"PointOfSaleUniqueWhere",
		update:"PointOfSaleWithoutChannelsUpdateInput",
		create:"PointOfSaleWithoutChannelsCreateInput"
	},
	ChannelUpdateCartsEntityRelationInput:{
		create:"CartWithoutChannelCreateInput",
		update:"ChannelUpdateCartsRelationInput",
		upsert:"ChannelUpsertCartsRelationInput",
		connect:"CartUniqueWhere",
		disconnect:"CartUniqueWhere",
		delete:"CartUniqueWhere"
	},
	ChannelUpdateCartsRelationInput:{
		by:"CartUniqueWhere",
		data:"CartWithoutChannelUpdateInput"
	},
	CartWithoutChannelUpdateInput:{
		confirmedAt:"DateTime",
		deletedAt:"DateTime",
		items:"CartUpdateItemsEntityRelationInput",
		state:"CartState",
		createdAt:"DateTime",
		order:"CartUpdateOrderEntityRelationInput",
		customer:"CartUpdateCustomerEntityRelationInput",
		deliveryAddress:"CartUpdateDeliveryAddressEntityRelationInput",
		billingAddress:"CartUpdateBillingAddressEntityRelationInput",
		delivery:"CartUpdateDeliveryEntityRelationInput",
		payment:"CartUpdatePaymentEntityRelationInput",
		billingSubject:"CartUpdateBillingSubjectEntityRelationInput",
		priceLines:"CartUpdatePriceLinesEntityRelationInput",
		summary:"CartUpdateSummaryEntityRelationInput"
	},
	CartUpdateItemsEntityRelationInput:{
		create:"CartItemWithoutCartCreateInput",
		update:"CartUpdateItemsRelationInput",
		upsert:"CartUpsertItemsRelationInput",
		connect:"CartItemUniqueWhere",
		disconnect:"CartItemUniqueWhere",
		delete:"CartItemUniqueWhere"
	},
	CartUpdateItemsRelationInput:{
		by:"CartItemUniqueWhere",
		data:"CartItemWithoutCartUpdateInput"
	},
	CartItemWithoutCartUpdateInput:{
		product:"CartItemUpdateProductEntityRelationInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		fulfillmentNotes:"CartItemUpdateFulfillmentNotesEntityRelationInput"
	},
	CartItemUpdateProductEntityRelationInput:{
		create:"ProductWithoutCartItemsCreateInput",
		update:"ProductWithoutCartItemsUpdateInput",
		upsert:"CartItemUpsertProductRelationInput",
		connect:"ProductUniqueWhere"
	},
	ProductWithoutCartItemsUpdateInput:{
		packing:"ProductUpdatePackingEntityRelationInput",
		recipe:"ProductUpdateRecipeEntityRelationInput",
		tags:"ProductUpdateTagsEntityRelationInput",
		categories:"ProductUpdateCategoriesEntityRelationInput",
		vatRate:"ProductUpdateVatRateEntityRelationInput",
		stocks:"ProductUpdateStocksEntityRelationInput",
		groupPrices:"ProductUpdateGroupPricesEntityRelationInput",
		image:"ProductUpdateImageEntityRelationInput",
		availability:"ProductAvailability",
		manager:"ProductUpdateManagerEntityRelationInput",
		orderItems:"ProductUpdateOrderItemsEntityRelationInput",
		inheritedCategories:"ProductUpdateInheritedCategoriesEntityRelationInput",
		deliveryZones:"ProductUpdateDeliveryZonesEntityRelationInput",
		locales:"ProductUpdateLocalesEntityRelationInput",
		archivedAt:"DateTime",
		customerPrices:"ProductUpdateCustomerPricesEntityRelationInput",
		virtualProduct:"ProductUpdateVirtualProductEntityRelationInput",
		meta:"ProductUpdateMetaEntityRelationInput",
		page:"ProductUpdatePageEntityRelationInput",
		salesDays:"ProductUpdateSalesDaysEntityRelationInput",
		salesWeeks:"ProductUpdateSalesWeeksEntityRelationInput",
		salesMonths:"ProductUpdateSalesMonthsEntityRelationInput",
		fulfillmentNotes:"ProductUpdateFulfillmentNotesEntityRelationInput"
	},
	ProductUpdateRecipeEntityRelationInput:{
		create:"ProductRecipeWithoutProductsCreateInput",
		update:"ProductRecipeWithoutProductsUpdateInput",
		upsert:"ProductUpsertRecipeRelationInput",
		connect:"ProductRecipeUniqueWhere"
	},
	ProductRecipeWithoutProductsUpdateInput:{
		image:"ProductRecipeUpdateImageEntityRelationInput",
		icon:"ProductRecipeUpdateIconEntityRelationInput",
		ingredients:"ProductRecipeUpdateIngredientsEntityRelationInput",
		locales:"ProductRecipeUpdateLocalesEntityRelationInput",
		freshingContainer:"ProductRecipeUpdateFreshingContainerEntityRelationInput",
		nutritionFacts:"ProductRecipeUpdateNutritionFactsEntityRelationInput"
	},
	ProductRecipeUpdateImageEntityRelationInput:{
		create:"ImageCreateInput",
		update:"ImageUpdateInput",
		upsert:"ProductRecipeUpsertImageRelationInput",
		connect:"ImageUniqueWhere"
	},
	ProductRecipeUpsertImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	ProductRecipeUpdateIconEntityRelationInput:{
		create:"ImageCreateInput",
		update:"ImageUpdateInput",
		upsert:"ProductRecipeUpsertIconRelationInput",
		connect:"ImageUniqueWhere"
	},
	ProductRecipeUpsertIconRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	ProductRecipeUpdateIngredientsEntityRelationInput:{
		create:"ProductIngredientItemWithoutRecipeCreateInput",
		update:"ProductRecipeUpdateIngredientsRelationInput",
		upsert:"ProductRecipeUpsertIngredientsRelationInput",
		connect:"ProductIngredientItemUniqueWhere",
		disconnect:"ProductIngredientItemUniqueWhere",
		delete:"ProductIngredientItemUniqueWhere"
	},
	ProductRecipeUpdateIngredientsRelationInput:{
		by:"ProductIngredientItemUniqueWhere",
		data:"ProductIngredientItemWithoutRecipeUpdateInput"
	},
	ProductIngredientItemWithoutRecipeUpdateInput:{
		ingredient:"ProductIngredientItemUpdateIngredientEntityRelationInput",
		quantity:"ProductIngredientItemUpdateQuantityEntityRelationInput"
	},
	ProductIngredientItemUpdateIngredientEntityRelationInput:{
		create:"ProductIngredientCreateInput",
		update:"ProductIngredientUpdateInput",
		upsert:"ProductIngredientItemUpsertIngredientRelationInput",
		connect:"ProductIngredientUniqueWhere"
	},
	ProductIngredientUpdateInput:{
		locales:"ProductIngredientUpdateLocalesEntityRelationInput",
		categories:"ProductIngredientUpdateCategoriesEntityRelationInput",
		allergens:"ProductIngredientUpdateAllergensEntityRelationInput",
		customerRatings:"ProductIngredientUpdateCustomerRatingsEntityRelationInput",
		preferredQuantityUnit:"ProductIngredientUpdatePreferredQuantityUnitEntityRelationInput",
		freshingContainer:"ProductIngredientUpdateFreshingContainerEntityRelationInput",
		image:"ProductIngredientUpdateImageEntityRelationInput",
		suppliers:"ProductIngredientUpdateSuppliersEntityRelationInput"
	},
	ProductIngredientUpdateLocalesEntityRelationInput:{
		create:"ProductIngredientLocaleWithoutRootCreateInput",
		update:"ProductIngredientUpdateLocalesRelationInput",
		upsert:"ProductIngredientUpsertLocalesRelationInput",
		connect:"ProductIngredientLocaleUniqueWhere",
		disconnect:"ProductIngredientLocaleUniqueWhere",
		delete:"ProductIngredientLocaleUniqueWhere"
	},
	ProductIngredientUpdateLocalesRelationInput:{
		by:"ProductIngredientLocaleUniqueWhere",
		data:"ProductIngredientLocaleWithoutRootUpdateInput"
	},
	ProductIngredientLocaleWithoutRootUpdateInput:{
		locale:"ProductIngredientLocaleUpdateLocaleEntityRelationInput"
	},
	ProductIngredientLocaleUpdateLocaleEntityRelationInput:{
		create:"LocaleWithoutProductIngredientsCreateInput",
		update:"LocaleWithoutProductIngredientsUpdateInput",
		upsert:"ProductIngredientLocaleUpsertLocaleRelationInput",
		connect:"LocaleUniqueWhere"
	},
	LocaleWithoutProductIngredientsUpdateInput:{
		businessCategories:"LocaleUpdateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleUpdateProductCategoryListsEntityRelationInput",
		orderRecurrences:"LocaleUpdateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleUpdateBlogsEntityRelationInput",
		blogPosts:"LocaleUpdateBlogPostsEntityRelationInput",
		identifier:"LocaleUpdateIdentifierEntityRelationInput",
		menus:"LocaleUpdateMenusEntityRelationInput",
		pages:"LocaleUpdatePagesEntityRelationInput",
		productIngredientCategories:"LocaleUpdateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleUpdateAllergensEntityRelationInput",
		productPackings:"LocaleUpdateProductPackingsEntityRelationInput",
		products:"LocaleUpdateProductsEntityRelationInput",
		productRecipes:"LocaleUpdateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleUpdatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleUpdateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleUpdateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleUpdateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleUpdatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleUpdateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleUpdateBusinessServicesEntityRelationInput"
	},
	LocaleUpdateProductCategoryListsEntityRelationInput:{
		create:"ProductCategoryListLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateProductCategoryListsRelationInput",
		upsert:"LocaleUpsertProductCategoryListsRelationInput",
		connect:"ProductCategoryListLocaleUniqueWhere",
		disconnect:"ProductCategoryListLocaleUniqueWhere",
		delete:"ProductCategoryListLocaleUniqueWhere"
	},
	LocaleUpdateProductCategoryListsRelationInput:{
		by:"ProductCategoryListLocaleUniqueWhere",
		data:"ProductCategoryListLocaleWithoutLocaleUpdateInput"
	},
	ProductCategoryListLocaleWithoutLocaleUpdateInput:{
		root:"ProductCategoryListLocaleUpdateRootEntityRelationInput"
	},
	ProductCategoryListLocaleUpdateRootEntityRelationInput:{
		create:"ProductCategoryListWithoutLocalesCreateInput",
		update:"ProductCategoryListWithoutLocalesUpdateInput",
		upsert:"ProductCategoryListLocaleUpsertRootRelationInput",
		connect:"ProductCategoryListUniqueWhere"
	},
	ProductCategoryListWithoutLocalesUpdateInput:{
		items:"ProductCategoryListUpdateItemsEntityRelationInput",
		seasonalProductCategoriesOfBusinessCategory:"ProductCategoryListUpdateSeasonalProductCategoriesOfBusinessCategoryEntityRelationInput",
		specificProductsProductCategoriesOfBusinessCategory:"ProductCategoryListUpdateSpecificProductsProductCategoriesOfBusinessCategoryEntityRelationInput"
	},
	ProductCategoryListUpdateItemsEntityRelationInput:{
		create:"ProductCategoryListItemWithoutListCreateInput",
		update:"ProductCategoryListUpdateItemsRelationInput",
		upsert:"ProductCategoryListUpsertItemsRelationInput",
		connect:"ProductCategoryListItemUniqueWhere",
		disconnect:"ProductCategoryListItemUniqueWhere",
		delete:"ProductCategoryListItemUniqueWhere"
	},
	ProductCategoryListUpdateItemsRelationInput:{
		by:"ProductCategoryListItemUniqueWhere",
		data:"ProductCategoryListItemWithoutListUpdateInput"
	},
	ProductCategoryListItemWithoutListUpdateInput:{
		productCategory:"ProductCategoryListItemUpdateProductCategoryEntityRelationInput"
	},
	ProductCategoryListItemUpdateProductCategoryEntityRelationInput:{
		create:"ProductCategoryCreateInput",
		update:"ProductCategoryUpdateInput",
		upsert:"ProductCategoryListItemUpsertProductCategoryRelationInput",
		connect:"ProductCategoryUniqueWhere"
	},
	ProductCategoryUpdateInput:{
		products:"ProductCategoryUpdateProductsEntityRelationInput",
		tags:"ProductCategoryUpdateTagsEntityRelationInput",
		parent:"ProductCategoryUpdateParentEntityRelationInput",
		children:"ProductCategoryUpdateChildrenEntityRelationInput",
		image:"ProductCategoryUpdateImageEntityRelationInput",
		descendants:"ProductCategoryUpdateDescendantsEntityRelationInput",
		ancestors:"ProductCategoryUpdateAncestorsEntityRelationInput",
		inheritedTags:"ProductCategoryUpdateInheritedTagsEntityRelationInput",
		nestedProducts:"ProductCategoryUpdateNestedProductsEntityRelationInput"
	},
	ProductCategoryUpdateProductsEntityRelationInput:{
		create:"ProductWithoutCategoriesCreateInput",
		update:"ProductCategoryUpdateProductsRelationInput",
		upsert:"ProductCategoryUpsertProductsRelationInput",
		connect:"ProductUniqueWhere",
		disconnect:"ProductUniqueWhere",
		delete:"ProductUniqueWhere"
	},
	ProductCategoryUpdateProductsRelationInput:{
		by:"ProductUniqueWhere",
		data:"ProductWithoutCategoriesUpdateInput"
	},
	ProductWithoutCategoriesUpdateInput:{
		packing:"ProductUpdatePackingEntityRelationInput",
		recipe:"ProductUpdateRecipeEntityRelationInput",
		tags:"ProductUpdateTagsEntityRelationInput",
		vatRate:"ProductUpdateVatRateEntityRelationInput",
		stocks:"ProductUpdateStocksEntityRelationInput",
		groupPrices:"ProductUpdateGroupPricesEntityRelationInput",
		image:"ProductUpdateImageEntityRelationInput",
		cartItems:"ProductUpdateCartItemsEntityRelationInput",
		availability:"ProductAvailability",
		manager:"ProductUpdateManagerEntityRelationInput",
		orderItems:"ProductUpdateOrderItemsEntityRelationInput",
		inheritedCategories:"ProductUpdateInheritedCategoriesEntityRelationInput",
		deliveryZones:"ProductUpdateDeliveryZonesEntityRelationInput",
		locales:"ProductUpdateLocalesEntityRelationInput",
		archivedAt:"DateTime",
		customerPrices:"ProductUpdateCustomerPricesEntityRelationInput",
		virtualProduct:"ProductUpdateVirtualProductEntityRelationInput",
		meta:"ProductUpdateMetaEntityRelationInput",
		page:"ProductUpdatePageEntityRelationInput",
		salesDays:"ProductUpdateSalesDaysEntityRelationInput",
		salesWeeks:"ProductUpdateSalesWeeksEntityRelationInput",
		salesMonths:"ProductUpdateSalesMonthsEntityRelationInput",
		fulfillmentNotes:"ProductUpdateFulfillmentNotesEntityRelationInput"
	},
	ProductUpdateTagsEntityRelationInput:{
		create:"TagWithoutProductsCreateInput",
		update:"ProductUpdateTagsRelationInput",
		upsert:"ProductUpsertTagsRelationInput",
		connect:"TagUniqueWhere",
		disconnect:"TagUniqueWhere",
		delete:"TagUniqueWhere"
	},
	ProductUpdateTagsRelationInput:{
		by:"TagUniqueWhere",
		data:"TagWithoutProductsUpdateInput"
	},
	TagWithoutProductsUpdateInput:{
		customers:"TagUpdateCustomersEntityRelationInput",
		categories:"TagUpdateCategoriesEntityRelationInput",
		addTagsOnRegistration:"TagUpdateAddTagsOnRegistrationEntityRelationInput",
		nestedCategories:"TagUpdateNestedCategoriesEntityRelationInput",
		deliveryZones:"TagUpdateDeliveryZonesEntityRelationInput",
		publicInChannels:"TagUpdatePublicInChannelsEntityRelationInput",
		allowChannelPayments:"TagUpdateAllowChannelPaymentsEntityRelationInput",
		fulfillmentNotes:"TagUpdateFulfillmentNotesEntityRelationInput"
	},
	TagUpdateCategoriesEntityRelationInput:{
		create:"ProductCategoryWithoutTagsCreateInput",
		update:"TagUpdateCategoriesRelationInput",
		upsert:"TagUpsertCategoriesRelationInput",
		connect:"ProductCategoryUniqueWhere",
		disconnect:"ProductCategoryUniqueWhere",
		delete:"ProductCategoryUniqueWhere"
	},
	TagUpdateCategoriesRelationInput:{
		by:"ProductCategoryUniqueWhere",
		data:"ProductCategoryWithoutTagsUpdateInput"
	},
	ProductCategoryWithoutTagsUpdateInput:{
		products:"ProductCategoryUpdateProductsEntityRelationInput",
		parent:"ProductCategoryUpdateParentEntityRelationInput",
		children:"ProductCategoryUpdateChildrenEntityRelationInput",
		image:"ProductCategoryUpdateImageEntityRelationInput",
		descendants:"ProductCategoryUpdateDescendantsEntityRelationInput",
		ancestors:"ProductCategoryUpdateAncestorsEntityRelationInput",
		inheritedTags:"ProductCategoryUpdateInheritedTagsEntityRelationInput",
		nestedProducts:"ProductCategoryUpdateNestedProductsEntityRelationInput"
	},
	ProductCategoryUpdateParentEntityRelationInput:{
		create:"ProductCategoryWithoutChildrenCreateInput",
		update:"ProductCategoryWithoutChildrenUpdateInput",
		upsert:"ProductCategoryUpsertParentRelationInput",
		connect:"ProductCategoryUniqueWhere"
	},
	ProductCategoryWithoutChildrenUpdateInput:{
		products:"ProductCategoryUpdateProductsEntityRelationInput",
		tags:"ProductCategoryUpdateTagsEntityRelationInput",
		parent:"ProductCategoryUpdateParentEntityRelationInput",
		image:"ProductCategoryUpdateImageEntityRelationInput",
		descendants:"ProductCategoryUpdateDescendantsEntityRelationInput",
		ancestors:"ProductCategoryUpdateAncestorsEntityRelationInput",
		inheritedTags:"ProductCategoryUpdateInheritedTagsEntityRelationInput",
		nestedProducts:"ProductCategoryUpdateNestedProductsEntityRelationInput"
	},
	ProductCategoryUpdateTagsEntityRelationInput:{
		create:"TagWithoutCategoriesCreateInput",
		update:"ProductCategoryUpdateTagsRelationInput",
		upsert:"ProductCategoryUpsertTagsRelationInput",
		connect:"TagUniqueWhere",
		disconnect:"TagUniqueWhere",
		delete:"TagUniqueWhere"
	},
	ProductCategoryUpdateTagsRelationInput:{
		by:"TagUniqueWhere",
		data:"TagWithoutCategoriesUpdateInput"
	},
	TagWithoutCategoriesUpdateInput:{
		customers:"TagUpdateCustomersEntityRelationInput",
		products:"TagUpdateProductsEntityRelationInput",
		addTagsOnRegistration:"TagUpdateAddTagsOnRegistrationEntityRelationInput",
		nestedCategories:"TagUpdateNestedCategoriesEntityRelationInput",
		deliveryZones:"TagUpdateDeliveryZonesEntityRelationInput",
		publicInChannels:"TagUpdatePublicInChannelsEntityRelationInput",
		allowChannelPayments:"TagUpdateAllowChannelPaymentsEntityRelationInput",
		fulfillmentNotes:"TagUpdateFulfillmentNotesEntityRelationInput"
	},
	TagUpdateAddTagsOnRegistrationEntityRelationInput:{
		create:"ChannelWithoutAddTagsOnRegistrationCreateInput",
		update:"TagUpdateAddTagsOnRegistrationRelationInput",
		upsert:"TagUpsertAddTagsOnRegistrationRelationInput",
		connect:"ChannelUniqueWhere",
		disconnect:"ChannelUniqueWhere",
		delete:"ChannelUniqueWhere"
	},
	TagUpdateAddTagsOnRegistrationRelationInput:{
		by:"ChannelUniqueWhere",
		data:"ChannelWithoutAddTagsOnRegistrationUpdateInput"
	},
	ChannelWithoutAddTagsOnRegistrationUpdateInput:{
		payments:"ChannelUpdatePaymentsEntityRelationInput",
		deliveries:"ChannelUpdateDeliveriesEntityRelationInput",
		pointOfSales:"ChannelUpdatePointOfSalesEntityRelationInput",
		carts:"ChannelUpdateCartsEntityRelationInput",
		customers:"ChannelUpdateCustomersEntityRelationInput",
		code:"ChannelCode",
		publicTags:"ChannelUpdatePublicTagsEntityRelationInput",
		venue:"ChannelUpdateVenueEntityRelationInput"
	},
	ChannelUpdateCustomersEntityRelationInput:{
		create:"CustomerWithoutChannelsCreateInput",
		update:"ChannelUpdateCustomersRelationInput",
		upsert:"ChannelUpsertCustomersRelationInput",
		connect:"CustomerUniqueWhere",
		disconnect:"CustomerUniqueWhere",
		delete:"CustomerUniqueWhere"
	},
	ChannelUpdateCustomersRelationInput:{
		by:"CustomerUniqueWhere",
		data:"CustomerWithoutChannelsUpdateInput"
	},
	CustomerWithoutChannelsUpdateInput:{
		addresses:"CustomerUpdateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerUpdateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerUpdateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerUpdateTagsEntityRelationInput",
		credits:"CustomerUpdateCreditsEntityRelationInput",
		paymentMethods:"CustomerUpdatePaymentMethodsEntityRelationInput",
		orders:"CustomerUpdateOrdersEntityRelationInput",
		permissions:"CustomerUpdatePermissionsEntityRelationInput",
		group:"CustomerUpdateGroupEntityRelationInput",
		photo:"CustomerUpdatePhotoEntityRelationInput",
		name:"CustomerUpdateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerUpdateIngredientRatingsEntityRelationInput",
		business:"CustomerUpdateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerUpdateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerUpdateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerUpdateCartsEntityRelationInput",
		shortcutList:"CustomerUpdateShortcutListEntityRelationInput",
		user:"CustomerUpdateUserEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerUpdateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerUpdateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerUpdateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerUpdateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerUpdateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerUpdateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerUpdateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerUpdateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerUpdateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerUpdateRedeemedVouchersEntityRelationInput",
		spending:"CustomerUpdateSpendingEntityRelationInput",
		customerTabs:"CustomerUpdateCustomerTabsEntityRelationInput",
		lead:"CustomerUpdateLeadEntityRelationInput",
		meta:"CustomerUpdateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerUpdatePermissionsEntityRelationInput:{
		connect:"CustomerPermissionsUniqueWhere"
	},
	CustomerUpdateGroupEntityRelationInput:{
		create:"CustomerGroupWithoutCustomersCreateInput",
		update:"CustomerGroupWithoutCustomersUpdateInput",
		upsert:"CustomerUpsertGroupRelationInput",
		connect:"CustomerGroupUniqueWhere"
	},
	CustomerGroupWithoutCustomersUpdateInput:{
		productPrices:"CustomerGroupUpdateProductPricesEntityRelationInput"
	},
	CustomerGroupUpdateProductPricesEntityRelationInput:{
		create:"ProductGroupPriceWithoutGroupCreateInput",
		update:"CustomerGroupUpdateProductPricesRelationInput",
		upsert:"CustomerGroupUpsertProductPricesRelationInput",
		connect:"ProductGroupPriceUniqueWhere",
		disconnect:"ProductGroupPriceUniqueWhere",
		delete:"ProductGroupPriceUniqueWhere"
	},
	CustomerGroupUpdateProductPricesRelationInput:{
		by:"ProductGroupPriceUniqueWhere",
		data:"ProductGroupPriceWithoutGroupUpdateInput"
	},
	ProductGroupPriceWithoutGroupUpdateInput:{
		product:"ProductGroupPriceUpdateProductEntityRelationInput"
	},
	ProductGroupPriceUpdateProductEntityRelationInput:{
		create:"ProductWithoutGroupPricesCreateInput",
		update:"ProductWithoutGroupPricesUpdateInput",
		upsert:"ProductGroupPriceUpsertProductRelationInput",
		connect:"ProductUniqueWhere"
	},
	ProductWithoutGroupPricesUpdateInput:{
		packing:"ProductUpdatePackingEntityRelationInput",
		recipe:"ProductUpdateRecipeEntityRelationInput",
		tags:"ProductUpdateTagsEntityRelationInput",
		categories:"ProductUpdateCategoriesEntityRelationInput",
		vatRate:"ProductUpdateVatRateEntityRelationInput",
		stocks:"ProductUpdateStocksEntityRelationInput",
		image:"ProductUpdateImageEntityRelationInput",
		cartItems:"ProductUpdateCartItemsEntityRelationInput",
		availability:"ProductAvailability",
		manager:"ProductUpdateManagerEntityRelationInput",
		orderItems:"ProductUpdateOrderItemsEntityRelationInput",
		inheritedCategories:"ProductUpdateInheritedCategoriesEntityRelationInput",
		deliveryZones:"ProductUpdateDeliveryZonesEntityRelationInput",
		locales:"ProductUpdateLocalesEntityRelationInput",
		archivedAt:"DateTime",
		customerPrices:"ProductUpdateCustomerPricesEntityRelationInput",
		virtualProduct:"ProductUpdateVirtualProductEntityRelationInput",
		meta:"ProductUpdateMetaEntityRelationInput",
		page:"ProductUpdatePageEntityRelationInput",
		salesDays:"ProductUpdateSalesDaysEntityRelationInput",
		salesWeeks:"ProductUpdateSalesWeeksEntityRelationInput",
		salesMonths:"ProductUpdateSalesMonthsEntityRelationInput",
		fulfillmentNotes:"ProductUpdateFulfillmentNotesEntityRelationInput"
	},
	ProductUpdateCategoriesEntityRelationInput:{
		create:"ProductCategoryWithoutProductsCreateInput",
		update:"ProductUpdateCategoriesRelationInput",
		upsert:"ProductUpsertCategoriesRelationInput",
		connect:"ProductCategoryUniqueWhere",
		disconnect:"ProductCategoryUniqueWhere",
		delete:"ProductCategoryUniqueWhere"
	},
	ProductUpdateCategoriesRelationInput:{
		by:"ProductCategoryUniqueWhere",
		data:"ProductCategoryWithoutProductsUpdateInput"
	},
	ProductCategoryWithoutProductsUpdateInput:{
		tags:"ProductCategoryUpdateTagsEntityRelationInput",
		parent:"ProductCategoryUpdateParentEntityRelationInput",
		children:"ProductCategoryUpdateChildrenEntityRelationInput",
		image:"ProductCategoryUpdateImageEntityRelationInput",
		descendants:"ProductCategoryUpdateDescendantsEntityRelationInput",
		ancestors:"ProductCategoryUpdateAncestorsEntityRelationInput",
		inheritedTags:"ProductCategoryUpdateInheritedTagsEntityRelationInput",
		nestedProducts:"ProductCategoryUpdateNestedProductsEntityRelationInput"
	},
	ProductCategoryUpdateChildrenEntityRelationInput:{
		create:"ProductCategoryWithoutParentCreateInput",
		update:"ProductCategoryUpdateChildrenRelationInput",
		upsert:"ProductCategoryUpsertChildrenRelationInput",
		connect:"ProductCategoryUniqueWhere",
		disconnect:"ProductCategoryUniqueWhere",
		delete:"ProductCategoryUniqueWhere"
	},
	ProductCategoryUpdateChildrenRelationInput:{
		by:"ProductCategoryUniqueWhere",
		data:"ProductCategoryWithoutParentUpdateInput"
	},
	ProductCategoryWithoutParentUpdateInput:{
		products:"ProductCategoryUpdateProductsEntityRelationInput",
		tags:"ProductCategoryUpdateTagsEntityRelationInput",
		children:"ProductCategoryUpdateChildrenEntityRelationInput",
		image:"ProductCategoryUpdateImageEntityRelationInput",
		descendants:"ProductCategoryUpdateDescendantsEntityRelationInput",
		ancestors:"ProductCategoryUpdateAncestorsEntityRelationInput",
		inheritedTags:"ProductCategoryUpdateInheritedTagsEntityRelationInput",
		nestedProducts:"ProductCategoryUpdateNestedProductsEntityRelationInput"
	},
	ProductCategoryUpdateImageEntityRelationInput:{
		create:"ImageCreateInput",
		update:"ImageUpdateInput",
		upsert:"ProductCategoryUpsertImageRelationInput",
		connect:"ImageUniqueWhere"
	},
	ProductCategoryUpsertImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	ProductCategoryUpdateDescendantsEntityRelationInput:{
		connect:"ProductCategoryTreeUniqueWhere",
		disconnect:"ProductCategoryTreeUniqueWhere",
		delete:"ProductCategoryTreeUniqueWhere"
	},
	ProductCategoryUpdateAncestorsEntityRelationInput:{
		connect:"ProductCategoryTreeUniqueWhere",
		disconnect:"ProductCategoryTreeUniqueWhere",
		delete:"ProductCategoryTreeUniqueWhere"
	},
	ProductCategoryUpdateInheritedTagsEntityRelationInput:{
		connect:"InheritedProductCategoryTagUniqueWhere",
		disconnect:"InheritedProductCategoryTagUniqueWhere",
		delete:"InheritedProductCategoryTagUniqueWhere"
	},
	ProductCategoryUpdateNestedProductsEntityRelationInput:{
		connect:"NestedProductCategoryProductUniqueWhere",
		disconnect:"NestedProductCategoryProductUniqueWhere",
		delete:"NestedProductCategoryProductUniqueWhere"
	},
	ProductCategoryUpsertChildrenRelationInput:{
		by:"ProductCategoryUniqueWhere",
		update:"ProductCategoryWithoutParentUpdateInput",
		create:"ProductCategoryWithoutParentCreateInput"
	},
	ProductUpsertCategoriesRelationInput:{
		by:"ProductCategoryUniqueWhere",
		update:"ProductCategoryWithoutProductsUpdateInput",
		create:"ProductCategoryWithoutProductsCreateInput"
	},
	ProductUpdateVatRateEntityRelationInput:{
		create:"VatRateCreateInput",
		update:"VatRateUpdateInput",
		upsert:"ProductUpsertVatRateRelationInput",
		connect:"VatRateUniqueWhere"
	},
	ProductUpsertVatRateRelationInput:{
		update:"VatRateUpdateInput",
		create:"VatRateCreateInput"
	},
	ProductUpdateStocksEntityRelationInput:{
		create:"ProductStockWithoutProductCreateInput",
		update:"ProductUpdateStocksRelationInput",
		upsert:"ProductUpsertStocksRelationInput",
		connect:"ProductStockUniqueWhere",
		disconnect:"ProductStockUniqueWhere",
		delete:"ProductStockUniqueWhere"
	},
	ProductUpdateStocksRelationInput:{
		by:"ProductStockUniqueWhere",
		data:"ProductStockWithoutProductUpdateInput"
	},
	ProductStockWithoutProductUpdateInput:{
		store:"ProductStockUpdateStoreEntityRelationInput"
	},
	ProductStockUpdateStoreEntityRelationInput:{
		create:"StoreCreateInput",
		update:"StoreUpdateInput",
		upsert:"ProductStockUpsertStoreRelationInput",
		connect:"StoreUniqueWhere"
	},
	StoreUpdateInput:{

	},
	ProductStockUpsertStoreRelationInput:{
		update:"StoreUpdateInput",
		create:"StoreCreateInput"
	},
	ProductUpsertStocksRelationInput:{
		by:"ProductStockUniqueWhere",
		update:"ProductStockWithoutProductUpdateInput",
		create:"ProductStockWithoutProductCreateInput"
	},
	ProductUpdateImageEntityRelationInput:{
		create:"ImageCreateInput",
		update:"ImageUpdateInput",
		upsert:"ProductUpsertImageRelationInput",
		connect:"ImageUniqueWhere"
	},
	ProductUpsertImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	ProductUpdateCartItemsEntityRelationInput:{
		create:"CartItemWithoutProductCreateInput",
		update:"ProductUpdateCartItemsRelationInput",
		upsert:"ProductUpsertCartItemsRelationInput",
		connect:"CartItemUniqueWhere",
		disconnect:"CartItemUniqueWhere",
		delete:"CartItemUniqueWhere"
	},
	ProductUpdateCartItemsRelationInput:{
		by:"CartItemUniqueWhere",
		data:"CartItemWithoutProductUpdateInput"
	},
	CartItemWithoutProductUpdateInput:{
		cart:"CartItemUpdateCartEntityRelationInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		fulfillmentNotes:"CartItemUpdateFulfillmentNotesEntityRelationInput"
	},
	CartItemUpdateCartEntityRelationInput:{
		create:"CartWithoutItemsCreateInput",
		update:"CartWithoutItemsUpdateInput",
		upsert:"CartItemUpsertCartRelationInput",
		connect:"CartUniqueWhere"
	},
	CartWithoutItemsUpdateInput:{
		confirmedAt:"DateTime",
		deletedAt:"DateTime",
		state:"CartState",
		createdAt:"DateTime",
		channel:"CartUpdateChannelEntityRelationInput",
		order:"CartUpdateOrderEntityRelationInput",
		customer:"CartUpdateCustomerEntityRelationInput",
		deliveryAddress:"CartUpdateDeliveryAddressEntityRelationInput",
		billingAddress:"CartUpdateBillingAddressEntityRelationInput",
		delivery:"CartUpdateDeliveryEntityRelationInput",
		payment:"CartUpdatePaymentEntityRelationInput",
		billingSubject:"CartUpdateBillingSubjectEntityRelationInput",
		priceLines:"CartUpdatePriceLinesEntityRelationInput",
		summary:"CartUpdateSummaryEntityRelationInput"
	},
	CartUpdateChannelEntityRelationInput:{
		create:"ChannelWithoutCartsCreateInput",
		update:"ChannelWithoutCartsUpdateInput",
		upsert:"CartUpsertChannelRelationInput",
		connect:"ChannelUniqueWhere"
	},
	ChannelWithoutCartsUpdateInput:{
		payments:"ChannelUpdatePaymentsEntityRelationInput",
		deliveries:"ChannelUpdateDeliveriesEntityRelationInput",
		pointOfSales:"ChannelUpdatePointOfSalesEntityRelationInput",
		customers:"ChannelUpdateCustomersEntityRelationInput",
		code:"ChannelCode",
		addTagsOnRegistration:"ChannelUpdateAddTagsOnRegistrationEntityRelationInput",
		publicTags:"ChannelUpdatePublicTagsEntityRelationInput",
		venue:"ChannelUpdateVenueEntityRelationInput"
	},
	ChannelUpdateAddTagsOnRegistrationEntityRelationInput:{
		create:"TagWithoutAddTagsOnRegistrationCreateInput",
		update:"ChannelUpdateAddTagsOnRegistrationRelationInput",
		upsert:"ChannelUpsertAddTagsOnRegistrationRelationInput",
		connect:"TagUniqueWhere",
		disconnect:"TagUniqueWhere",
		delete:"TagUniqueWhere"
	},
	ChannelUpdateAddTagsOnRegistrationRelationInput:{
		by:"TagUniqueWhere",
		data:"TagWithoutAddTagsOnRegistrationUpdateInput"
	},
	TagWithoutAddTagsOnRegistrationUpdateInput:{
		customers:"TagUpdateCustomersEntityRelationInput",
		products:"TagUpdateProductsEntityRelationInput",
		categories:"TagUpdateCategoriesEntityRelationInput",
		nestedCategories:"TagUpdateNestedCategoriesEntityRelationInput",
		deliveryZones:"TagUpdateDeliveryZonesEntityRelationInput",
		publicInChannels:"TagUpdatePublicInChannelsEntityRelationInput",
		allowChannelPayments:"TagUpdateAllowChannelPaymentsEntityRelationInput",
		fulfillmentNotes:"TagUpdateFulfillmentNotesEntityRelationInput"
	},
	TagUpdateNestedCategoriesEntityRelationInput:{
		connect:"InheritedProductCategoryTagUniqueWhere",
		disconnect:"InheritedProductCategoryTagUniqueWhere",
		delete:"InheritedProductCategoryTagUniqueWhere"
	},
	TagUpdateDeliveryZonesEntityRelationInput:{
		create:"DeliveryZoneWithoutDeliveryZonesOfTagsCreateInput",
		update:"TagUpdateDeliveryZonesRelationInput",
		upsert:"TagUpsertDeliveryZonesRelationInput",
		connect:"DeliveryZoneUniqueWhere",
		disconnect:"DeliveryZoneUniqueWhere",
		delete:"DeliveryZoneUniqueWhere"
	},
	TagUpdateDeliveryZonesRelationInput:{
		by:"DeliveryZoneUniqueWhere",
		data:"DeliveryZoneWithoutDeliveryZonesOfTagsUpdateInput"
	},
	DeliveryZoneWithoutDeliveryZonesOfTagsUpdateInput:{
		type:"DeliveryZoneType",
		addresses:"DeliveryZoneUpdateAddressesEntityRelationInput",
		suitableDeliveryMethods:"DeliveryZoneUpdateSuitableDeliveryMethodsEntityRelationInput",
		deliveryZonesOfProducts:"DeliveryZoneUpdateDeliveryZonesOfProductsEntityRelationInput",
		addressesMetadata:"DeliveryZoneUpdateAddressesMetadataEntityRelationInput"
	},
	DeliveryZoneUpdateDeliveryZonesOfProductsEntityRelationInput:{
		create:"ProductWithoutDeliveryZonesCreateInput",
		update:"DeliveryZoneUpdateDeliveryZonesOfProductsRelationInput",
		upsert:"DeliveryZoneUpsertDeliveryZonesOfProductsRelationInput",
		connect:"ProductUniqueWhere",
		disconnect:"ProductUniqueWhere",
		delete:"ProductUniqueWhere"
	},
	DeliveryZoneUpdateDeliveryZonesOfProductsRelationInput:{
		by:"ProductUniqueWhere",
		data:"ProductWithoutDeliveryZonesUpdateInput"
	},
	ProductWithoutDeliveryZonesUpdateInput:{
		packing:"ProductUpdatePackingEntityRelationInput",
		recipe:"ProductUpdateRecipeEntityRelationInput",
		tags:"ProductUpdateTagsEntityRelationInput",
		categories:"ProductUpdateCategoriesEntityRelationInput",
		vatRate:"ProductUpdateVatRateEntityRelationInput",
		stocks:"ProductUpdateStocksEntityRelationInput",
		groupPrices:"ProductUpdateGroupPricesEntityRelationInput",
		image:"ProductUpdateImageEntityRelationInput",
		cartItems:"ProductUpdateCartItemsEntityRelationInput",
		availability:"ProductAvailability",
		manager:"ProductUpdateManagerEntityRelationInput",
		orderItems:"ProductUpdateOrderItemsEntityRelationInput",
		inheritedCategories:"ProductUpdateInheritedCategoriesEntityRelationInput",
		locales:"ProductUpdateLocalesEntityRelationInput",
		archivedAt:"DateTime",
		customerPrices:"ProductUpdateCustomerPricesEntityRelationInput",
		virtualProduct:"ProductUpdateVirtualProductEntityRelationInput",
		meta:"ProductUpdateMetaEntityRelationInput",
		page:"ProductUpdatePageEntityRelationInput",
		salesDays:"ProductUpdateSalesDaysEntityRelationInput",
		salesWeeks:"ProductUpdateSalesWeeksEntityRelationInput",
		salesMonths:"ProductUpdateSalesMonthsEntityRelationInput",
		fulfillmentNotes:"ProductUpdateFulfillmentNotesEntityRelationInput"
	},
	ProductUpdateGroupPricesEntityRelationInput:{
		create:"ProductGroupPriceWithoutProductCreateInput",
		update:"ProductUpdateGroupPricesRelationInput",
		upsert:"ProductUpsertGroupPricesRelationInput",
		connect:"ProductGroupPriceUniqueWhere",
		disconnect:"ProductGroupPriceUniqueWhere",
		delete:"ProductGroupPriceUniqueWhere"
	},
	ProductUpdateGroupPricesRelationInput:{
		by:"ProductGroupPriceUniqueWhere",
		data:"ProductGroupPriceWithoutProductUpdateInput"
	},
	ProductGroupPriceWithoutProductUpdateInput:{
		group:"ProductGroupPriceUpdateGroupEntityRelationInput"
	},
	ProductGroupPriceUpdateGroupEntityRelationInput:{
		create:"CustomerGroupWithoutProductPricesCreateInput",
		update:"CustomerGroupWithoutProductPricesUpdateInput",
		upsert:"ProductGroupPriceUpsertGroupRelationInput",
		connect:"CustomerGroupUniqueWhere"
	},
	CustomerGroupWithoutProductPricesUpdateInput:{
		customers:"CustomerGroupUpdateCustomersEntityRelationInput"
	},
	CustomerGroupUpdateCustomersEntityRelationInput:{
		create:"CustomerWithoutGroupCreateInput",
		update:"CustomerGroupUpdateCustomersRelationInput",
		upsert:"CustomerGroupUpsertCustomersRelationInput",
		connect:"CustomerUniqueWhere",
		disconnect:"CustomerUniqueWhere",
		delete:"CustomerUniqueWhere"
	},
	CustomerGroupUpdateCustomersRelationInput:{
		by:"CustomerUniqueWhere",
		data:"CustomerWithoutGroupUpdateInput"
	},
	CustomerWithoutGroupUpdateInput:{
		addresses:"CustomerUpdateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerUpdateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerUpdateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerUpdateTagsEntityRelationInput",
		credits:"CustomerUpdateCreditsEntityRelationInput",
		paymentMethods:"CustomerUpdatePaymentMethodsEntityRelationInput",
		orders:"CustomerUpdateOrdersEntityRelationInput",
		permissions:"CustomerUpdatePermissionsEntityRelationInput",
		photo:"CustomerUpdatePhotoEntityRelationInput",
		name:"CustomerUpdateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerUpdateIngredientRatingsEntityRelationInput",
		business:"CustomerUpdateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerUpdateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerUpdateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerUpdateCartsEntityRelationInput",
		shortcutList:"CustomerUpdateShortcutListEntityRelationInput",
		user:"CustomerUpdateUserEntityRelationInput",
		channels:"CustomerUpdateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerUpdateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerUpdateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerUpdateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerUpdateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerUpdateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerUpdateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerUpdateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerUpdateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerUpdateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerUpdateRedeemedVouchersEntityRelationInput",
		spending:"CustomerUpdateSpendingEntityRelationInput",
		customerTabs:"CustomerUpdateCustomerTabsEntityRelationInput",
		lead:"CustomerUpdateLeadEntityRelationInput",
		meta:"CustomerUpdateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerUpdatePhotoEntityRelationInput:{
		create:"ImageCreateInput",
		update:"ImageUpdateInput",
		upsert:"CustomerUpsertPhotoRelationInput",
		connect:"ImageUniqueWhere"
	},
	CustomerUpsertPhotoRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	CustomerUpdateNameEntityRelationInput:{
		create:"CustomerNameWithoutCustomerCreateInput",
		update:"CustomerNameWithoutCustomerUpdateInput",
		upsert:"CustomerUpsertNameRelationInput",
		connect:"CustomerNameUniqueWhere"
	},
	CustomerNameWithoutCustomerUpdateInput:{
		aliases:"CustomerNameUpdateAliasesEntityRelationInput"
	},
	CustomerNameUpdateAliasesEntityRelationInput:{
		create:"CustomerAliasCreateInput",
		update:"CustomerNameUpdateAliasesRelationInput",
		upsert:"CustomerNameUpsertAliasesRelationInput",
		connect:"CustomerAliasUniqueWhere",
		disconnect:"CustomerAliasUniqueWhere",
		delete:"CustomerAliasUniqueWhere"
	},
	CustomerNameUpdateAliasesRelationInput:{
		by:"CustomerAliasUniqueWhere",
		data:"CustomerAliasUpdateInput"
	},
	CustomerAliasUpdateInput:{

	},
	CustomerNameUpsertAliasesRelationInput:{
		by:"CustomerAliasUniqueWhere",
		update:"CustomerAliasUpdateInput",
		create:"CustomerAliasCreateInput"
	},
	CustomerUpsertNameRelationInput:{
		update:"CustomerNameWithoutCustomerUpdateInput",
		create:"CustomerNameWithoutCustomerCreateInput"
	},
	CustomerUpdateIngredientRatingsEntityRelationInput:{
		create:"CustomerIngredientRatingWithoutCustomerCreateInput",
		update:"CustomerUpdateIngredientRatingsRelationInput",
		upsert:"CustomerUpsertIngredientRatingsRelationInput",
		connect:"CustomerIngredientRatingUniqueWhere",
		disconnect:"CustomerIngredientRatingUniqueWhere",
		delete:"CustomerIngredientRatingUniqueWhere"
	},
	CustomerUpdateIngredientRatingsRelationInput:{
		by:"CustomerIngredientRatingUniqueWhere",
		data:"CustomerIngredientRatingWithoutCustomerUpdateInput"
	},
	CustomerIngredientRatingWithoutCustomerUpdateInput:{
		rating:"CustomerIngredientRatingUpdateRatingEntityRelationInput",
		ingredient:"CustomerIngredientRatingUpdateIngredientEntityRelationInput"
	},
	CustomerIngredientRatingUpdateRatingEntityRelationInput:{
		create:"ProductIngredientRatingCreateInput",
		update:"ProductIngredientRatingUpdateInput",
		upsert:"CustomerIngredientRatingUpsertRatingRelationInput",
		connect:"ProductIngredientRatingUniqueWhere"
	},
	ProductIngredientRatingUpdateInput:{
		icon:"ProductIngredientRatingUpdateIconEntityRelationInput"
	},
	ProductIngredientRatingUpdateIconEntityRelationInput:{
		create:"ImageCreateInput",
		update:"ImageUpdateInput",
		upsert:"ProductIngredientRatingUpsertIconRelationInput",
		connect:"ImageUniqueWhere"
	},
	ProductIngredientRatingUpsertIconRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	CustomerIngredientRatingUpsertRatingRelationInput:{
		update:"ProductIngredientRatingUpdateInput",
		create:"ProductIngredientRatingCreateInput"
	},
	CustomerIngredientRatingUpdateIngredientEntityRelationInput:{
		create:"ProductIngredientWithoutCustomerRatingsCreateInput",
		update:"ProductIngredientWithoutCustomerRatingsUpdateInput",
		upsert:"CustomerIngredientRatingUpsertIngredientRelationInput",
		connect:"ProductIngredientUniqueWhere"
	},
	ProductIngredientWithoutCustomerRatingsUpdateInput:{
		locales:"ProductIngredientUpdateLocalesEntityRelationInput",
		categories:"ProductIngredientUpdateCategoriesEntityRelationInput",
		allergens:"ProductIngredientUpdateAllergensEntityRelationInput",
		preferredQuantityUnit:"ProductIngredientUpdatePreferredQuantityUnitEntityRelationInput",
		freshingContainer:"ProductIngredientUpdateFreshingContainerEntityRelationInput",
		image:"ProductIngredientUpdateImageEntityRelationInput",
		suppliers:"ProductIngredientUpdateSuppliersEntityRelationInput"
	},
	ProductIngredientUpdateCategoriesEntityRelationInput:{
		create:"ProductIngredientCategoryWithoutIngredientsCreateInput",
		update:"ProductIngredientUpdateCategoriesRelationInput",
		upsert:"ProductIngredientUpsertCategoriesRelationInput",
		connect:"ProductIngredientCategoryUniqueWhere",
		disconnect:"ProductIngredientCategoryUniqueWhere",
		delete:"ProductIngredientCategoryUniqueWhere"
	},
	ProductIngredientUpdateCategoriesRelationInput:{
		by:"ProductIngredientCategoryUniqueWhere",
		data:"ProductIngredientCategoryWithoutIngredientsUpdateInput"
	},
	ProductIngredientCategoryWithoutIngredientsUpdateInput:{
		locales:"ProductIngredientCategoryUpdateLocalesEntityRelationInput"
	},
	ProductIngredientCategoryUpdateLocalesEntityRelationInput:{
		create:"ProductIngredientCategoryLocaleWithoutRootCreateInput",
		update:"ProductIngredientCategoryUpdateLocalesRelationInput",
		upsert:"ProductIngredientCategoryUpsertLocalesRelationInput",
		connect:"ProductIngredientCategoryLocaleUniqueWhere",
		disconnect:"ProductIngredientCategoryLocaleUniqueWhere",
		delete:"ProductIngredientCategoryLocaleUniqueWhere"
	},
	ProductIngredientCategoryUpdateLocalesRelationInput:{
		by:"ProductIngredientCategoryLocaleUniqueWhere",
		data:"ProductIngredientCategoryLocaleWithoutRootUpdateInput"
	},
	ProductIngredientCategoryLocaleWithoutRootUpdateInput:{
		locale:"ProductIngredientCategoryLocaleUpdateLocaleEntityRelationInput"
	},
	ProductIngredientCategoryLocaleUpdateLocaleEntityRelationInput:{
		create:"LocaleWithoutProductIngredientCategoriesCreateInput",
		update:"LocaleWithoutProductIngredientCategoriesUpdateInput",
		upsert:"ProductIngredientCategoryLocaleUpsertLocaleRelationInput",
		connect:"LocaleUniqueWhere"
	},
	LocaleWithoutProductIngredientCategoriesUpdateInput:{
		businessCategories:"LocaleUpdateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleUpdateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleUpdateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleUpdateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleUpdateBlogsEntityRelationInput",
		blogPosts:"LocaleUpdateBlogPostsEntityRelationInput",
		identifier:"LocaleUpdateIdentifierEntityRelationInput",
		menus:"LocaleUpdateMenusEntityRelationInput",
		pages:"LocaleUpdatePagesEntityRelationInput",
		allergens:"LocaleUpdateAllergensEntityRelationInput",
		productPackings:"LocaleUpdateProductPackingsEntityRelationInput",
		products:"LocaleUpdateProductsEntityRelationInput",
		productRecipes:"LocaleUpdateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleUpdatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleUpdateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleUpdateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleUpdateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleUpdatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleUpdateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleUpdateBusinessServicesEntityRelationInput"
	},
	LocaleUpdateProductIngredientsEntityRelationInput:{
		create:"ProductIngredientLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateProductIngredientsRelationInput",
		upsert:"LocaleUpsertProductIngredientsRelationInput",
		connect:"ProductIngredientLocaleUniqueWhere",
		disconnect:"ProductIngredientLocaleUniqueWhere",
		delete:"ProductIngredientLocaleUniqueWhere"
	},
	LocaleUpdateProductIngredientsRelationInput:{
		by:"ProductIngredientLocaleUniqueWhere",
		data:"ProductIngredientLocaleWithoutLocaleUpdateInput"
	},
	ProductIngredientLocaleWithoutLocaleUpdateInput:{
		root:"ProductIngredientLocaleUpdateRootEntityRelationInput"
	},
	ProductIngredientLocaleUpdateRootEntityRelationInput:{
		create:"ProductIngredientWithoutLocalesCreateInput",
		update:"ProductIngredientWithoutLocalesUpdateInput",
		upsert:"ProductIngredientLocaleUpsertRootRelationInput",
		connect:"ProductIngredientUniqueWhere"
	},
	ProductIngredientWithoutLocalesUpdateInput:{
		categories:"ProductIngredientUpdateCategoriesEntityRelationInput",
		allergens:"ProductIngredientUpdateAllergensEntityRelationInput",
		customerRatings:"ProductIngredientUpdateCustomerRatingsEntityRelationInput",
		preferredQuantityUnit:"ProductIngredientUpdatePreferredQuantityUnitEntityRelationInput",
		freshingContainer:"ProductIngredientUpdateFreshingContainerEntityRelationInput",
		image:"ProductIngredientUpdateImageEntityRelationInput",
		suppliers:"ProductIngredientUpdateSuppliersEntityRelationInput"
	},
	ProductIngredientUpdateAllergensEntityRelationInput:{
		create:"AllergenWithoutIngredientsCreateInput",
		update:"ProductIngredientUpdateAllergensRelationInput",
		upsert:"ProductIngredientUpsertAllergensRelationInput",
		connect:"AllergenUniqueWhere",
		disconnect:"AllergenUniqueWhere",
		delete:"AllergenUniqueWhere"
	},
	ProductIngredientUpdateAllergensRelationInput:{
		by:"AllergenUniqueWhere",
		data:"AllergenWithoutIngredientsUpdateInput"
	},
	AllergenWithoutIngredientsUpdateInput:{
		locales:"AllergenUpdateLocalesEntityRelationInput"
	},
	AllergenUpdateLocalesEntityRelationInput:{
		create:"AllergenLocaleWithoutRootCreateInput",
		update:"AllergenUpdateLocalesRelationInput",
		upsert:"AllergenUpsertLocalesRelationInput",
		connect:"AllergenLocaleUniqueWhere",
		disconnect:"AllergenLocaleUniqueWhere",
		delete:"AllergenLocaleUniqueWhere"
	},
	AllergenUpdateLocalesRelationInput:{
		by:"AllergenLocaleUniqueWhere",
		data:"AllergenLocaleWithoutRootUpdateInput"
	},
	AllergenLocaleWithoutRootUpdateInput:{
		locale:"AllergenLocaleUpdateLocaleEntityRelationInput"
	},
	AllergenLocaleUpdateLocaleEntityRelationInput:{
		create:"LocaleWithoutAllergensCreateInput",
		update:"LocaleWithoutAllergensUpdateInput",
		upsert:"AllergenLocaleUpsertLocaleRelationInput",
		connect:"LocaleUniqueWhere"
	},
	LocaleWithoutAllergensUpdateInput:{
		businessCategories:"LocaleUpdateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleUpdateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleUpdateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleUpdateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleUpdateBlogsEntityRelationInput",
		blogPosts:"LocaleUpdateBlogPostsEntityRelationInput",
		identifier:"LocaleUpdateIdentifierEntityRelationInput",
		menus:"LocaleUpdateMenusEntityRelationInput",
		pages:"LocaleUpdatePagesEntityRelationInput",
		productIngredientCategories:"LocaleUpdateProductIngredientCategoriesEntityRelationInput",
		productPackings:"LocaleUpdateProductPackingsEntityRelationInput",
		products:"LocaleUpdateProductsEntityRelationInput",
		productRecipes:"LocaleUpdateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleUpdatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleUpdateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleUpdateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleUpdateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleUpdatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleUpdateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleUpdateBusinessServicesEntityRelationInput"
	},
	LocaleUpdateOrderRecurrencesEntityRelationInput:{
		create:"OrderRecurrenceLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateOrderRecurrencesRelationInput",
		upsert:"LocaleUpsertOrderRecurrencesRelationInput",
		connect:"OrderRecurrenceLocaleUniqueWhere",
		disconnect:"OrderRecurrenceLocaleUniqueWhere",
		delete:"OrderRecurrenceLocaleUniqueWhere"
	},
	LocaleUpdateOrderRecurrencesRelationInput:{
		by:"OrderRecurrenceLocaleUniqueWhere",
		data:"OrderRecurrenceLocaleWithoutLocaleUpdateInput"
	},
	OrderRecurrenceLocaleWithoutLocaleUpdateInput:{
		root:"OrderRecurrenceLocaleUpdateRootEntityRelationInput"
	},
	OrderRecurrenceLocaleUpdateRootEntityRelationInput:{
		create:"OrderRecurrenceWithoutLocalesCreateInput",
		update:"OrderRecurrenceWithoutLocalesUpdateInput",
		upsert:"OrderRecurrenceLocaleUpsertRootRelationInput",
		connect:"OrderRecurrenceUniqueWhere"
	},
	OrderRecurrenceWithoutLocalesUpdateInput:{
		businessCategory:"OrderRecurrenceUpdateBusinessCategoryEntityRelationInput"
	},
	OrderRecurrenceUpdateBusinessCategoryEntityRelationInput:{
		create:"BusinessCategoryWithoutRecurrencesCreateInput",
		update:"OrderRecurrenceUpdateBusinessCategoryRelationInput",
		upsert:"OrderRecurrenceUpsertBusinessCategoryRelationInput",
		connect:"BusinessCategoryUniqueWhere",
		disconnect:"BusinessCategoryUniqueWhere",
		delete:"BusinessCategoryUniqueWhere"
	},
	OrderRecurrenceUpdateBusinessCategoryRelationInput:{
		by:"BusinessCategoryUniqueWhere",
		data:"BusinessCategoryWithoutRecurrencesUpdateInput"
	},
	BusinessCategoryWithoutRecurrencesUpdateInput:{
		locales:"BusinessCategoryUpdateLocalesEntityRelationInput",
		businessCustomers:"BusinessCategoryUpdateBusinessCustomersEntityRelationInput",
		specificProducts:"BusinessCategoryUpdateSpecificProductsEntityRelationInput",
		seasonalProductCategories:"BusinessCategoryUpdateSeasonalProductCategoriesEntityRelationInput",
		specificProductsProductCategories:"BusinessCategoryUpdateSpecificProductsProductCategoriesEntityRelationInput"
	},
	BusinessCategoryUpdateLocalesEntityRelationInput:{
		create:"BusinessCategoryLocaleWithoutRootCreateInput",
		update:"BusinessCategoryUpdateLocalesRelationInput",
		upsert:"BusinessCategoryUpsertLocalesRelationInput",
		connect:"BusinessCategoryLocaleUniqueWhere",
		disconnect:"BusinessCategoryLocaleUniqueWhere",
		delete:"BusinessCategoryLocaleUniqueWhere"
	},
	BusinessCategoryUpdateLocalesRelationInput:{
		by:"BusinessCategoryLocaleUniqueWhere",
		data:"BusinessCategoryLocaleWithoutRootUpdateInput"
	},
	BusinessCategoryLocaleWithoutRootUpdateInput:{
		locale:"BusinessCategoryLocaleUpdateLocaleEntityRelationInput"
	},
	BusinessCategoryLocaleUpdateLocaleEntityRelationInput:{
		create:"LocaleWithoutBusinessCategoriesCreateInput",
		update:"LocaleWithoutBusinessCategoriesUpdateInput",
		upsert:"BusinessCategoryLocaleUpsertLocaleRelationInput",
		connect:"LocaleUniqueWhere"
	},
	LocaleWithoutBusinessCategoriesUpdateInput:{
		productCategoryLists:"LocaleUpdateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleUpdateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleUpdateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleUpdateBlogsEntityRelationInput",
		blogPosts:"LocaleUpdateBlogPostsEntityRelationInput",
		identifier:"LocaleUpdateIdentifierEntityRelationInput",
		menus:"LocaleUpdateMenusEntityRelationInput",
		pages:"LocaleUpdatePagesEntityRelationInput",
		productIngredientCategories:"LocaleUpdateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleUpdateAllergensEntityRelationInput",
		productPackings:"LocaleUpdateProductPackingsEntityRelationInput",
		products:"LocaleUpdateProductsEntityRelationInput",
		productRecipes:"LocaleUpdateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleUpdatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleUpdateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleUpdateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleUpdateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleUpdatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleUpdateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleUpdateBusinessServicesEntityRelationInput"
	},
	LocaleUpdateBlogsEntityRelationInput:{
		create:"BlogLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateBlogsRelationInput",
		upsert:"LocaleUpsertBlogsRelationInput",
		connect:"BlogLocaleUniqueWhere",
		disconnect:"BlogLocaleUniqueWhere",
		delete:"BlogLocaleUniqueWhere"
	},
	LocaleUpdateBlogsRelationInput:{
		by:"BlogLocaleUniqueWhere",
		data:"BlogLocaleWithoutLocaleUpdateInput"
	},
	BlogLocaleWithoutLocaleUpdateInput:{
		root:"BlogLocaleUpdateRootEntityRelationInput"
	},
	BlogLocaleUpdateRootEntityRelationInput:{
		create:"BlogWithoutLocalesCreateInput",
		update:"BlogWithoutLocalesUpdateInput",
		upsert:"BlogLocaleUpsertRootRelationInput",
		connect:"BlogUniqueWhere"
	},
	BlogWithoutLocalesUpdateInput:{
		unique:"One"
	},
	BlogLocaleUpsertRootRelationInput:{
		update:"BlogWithoutLocalesUpdateInput",
		create:"BlogWithoutLocalesCreateInput"
	},
	LocaleUpsertBlogsRelationInput:{
		by:"BlogLocaleUniqueWhere",
		update:"BlogLocaleWithoutLocaleUpdateInput",
		create:"BlogLocaleWithoutLocaleCreateInput"
	},
	LocaleUpdateBlogPostsEntityRelationInput:{
		create:"BlogPostLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateBlogPostsRelationInput",
		upsert:"LocaleUpsertBlogPostsRelationInput",
		connect:"BlogPostLocaleUniqueWhere",
		disconnect:"BlogPostLocaleUniqueWhere",
		delete:"BlogPostLocaleUniqueWhere"
	},
	LocaleUpdateBlogPostsRelationInput:{
		by:"BlogPostLocaleUniqueWhere",
		data:"BlogPostLocaleWithoutLocaleUpdateInput"
	},
	BlogPostLocaleWithoutLocaleUpdateInput:{
		root:"BlogPostLocaleUpdateRootEntityRelationInput",
		cover:"BlogPostLocaleUpdateCoverEntityRelationInput",
		content:"BlogPostLocaleUpdateContentEntityRelationInput",
		link:"BlogPostLocaleUpdateLinkEntityRelationInput",
		seo:"BlogPostLocaleUpdateSeoEntityRelationInput",
		products:"BlogPostLocaleUpdateProductsEntityRelationInput"
	},
	BlogPostLocaleUpdateRootEntityRelationInput:{
		create:"BlogPostWithoutLocalesCreateInput",
		update:"BlogPostWithoutLocalesUpdateInput",
		upsert:"BlogPostLocaleUpsertRootRelationInput",
		connect:"BlogPostUniqueWhere"
	},
	BlogPostWithoutLocalesUpdateInput:{

	},
	BlogPostLocaleUpsertRootRelationInput:{
		update:"BlogPostWithoutLocalesUpdateInput",
		create:"BlogPostWithoutLocalesCreateInput"
	},
	BlogPostLocaleUpdateCoverEntityRelationInput:{
		create:"CoverCreateInput",
		update:"CoverUpdateInput",
		upsert:"BlogPostLocaleUpsertCoverRelationInput",
		connect:"CoverUniqueWhere"
	},
	CoverUpdateInput:{
		medium:"CoverUpdateMediumEntityRelationInput",
		buttonColors:"CoverUpdateButtonColorsEntityRelationInput"
	},
	CoverUpdateMediumEntityRelationInput:{
		create:"MediumCreateInput",
		update:"MediumUpdateInput",
		upsert:"CoverUpsertMediumRelationInput",
		connect:"MediumUniqueWhere"
	},
	MediumUpdateInput:{
		type:"MediumType",
		colorTheme:"ColorTheme",
		image:"MediumUpdateImageEntityRelationInput",
		video:"MediumUpdateVideoEntityRelationInput"
	},
	MediumUpdateImageEntityRelationInput:{
		create:"ImageCreateInput",
		update:"ImageUpdateInput",
		upsert:"MediumUpsertImageRelationInput",
		connect:"ImageUniqueWhere"
	},
	MediumUpsertImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	MediumUpdateVideoEntityRelationInput:{
		create:"VideoCreateInput",
		update:"VideoUpdateInput",
		upsert:"MediumUpsertVideoRelationInput",
		connect:"VideoUniqueWhere"
	},
	VideoUpdateInput:{
		poster:"VideoUpdatePosterEntityRelationInput"
	},
	VideoUpdatePosterEntityRelationInput:{
		create:"ImageCreateInput",
		update:"ImageUpdateInput",
		upsert:"VideoUpsertPosterRelationInput",
		connect:"ImageUniqueWhere"
	},
	VideoUpsertPosterRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	MediumUpsertVideoRelationInput:{
		update:"VideoUpdateInput",
		create:"VideoCreateInput"
	},
	CoverUpsertMediumRelationInput:{
		update:"MediumUpdateInput",
		create:"MediumCreateInput"
	},
	CoverUpdateButtonColorsEntityRelationInput:{
		create:"ColorPalleteCreateInput",
		update:"ColorPalleteUpdateInput",
		upsert:"CoverUpsertButtonColorsRelationInput",
		connect:"ColorPalleteUniqueWhere"
	},
	ColorPalleteUpdateInput:{

	},
	CoverUpsertButtonColorsRelationInput:{
		update:"ColorPalleteUpdateInput",
		create:"ColorPalleteCreateInput"
	},
	BlogPostLocaleUpsertCoverRelationInput:{
		update:"CoverUpdateInput",
		create:"CoverCreateInput"
	},
	BlogPostLocaleUpdateContentEntityRelationInput:{
		create:"ContentCreateInput",
		update:"ContentUpdateInput",
		upsert:"BlogPostLocaleUpsertContentRelationInput",
		connect:"ContentUniqueWhere"
	},
	ContentUpdateInput:{
		blocks:"ContentUpdateBlocksEntityRelationInput"
	},
	ContentUpdateBlocksEntityRelationInput:{
		create:"ContentBlockWithoutContentCreateInput",
		update:"ContentUpdateBlocksRelationInput",
		upsert:"ContentUpsertBlocksRelationInput",
		connect:"ContentBlockUniqueWhere",
		disconnect:"ContentBlockUniqueWhere",
		delete:"ContentBlockUniqueWhere"
	},
	ContentUpdateBlocksRelationInput:{
		by:"ContentBlockUniqueWhere",
		data:"ContentBlockWithoutContentUpdateInput"
	},
	ContentBlockWithoutContentUpdateInput:{
		references:"ContentBlockUpdateReferencesEntityRelationInput"
	},
	ContentBlockUpdateReferencesEntityRelationInput:{
		create:"ContentReferenceWithoutBlockCreateInput",
		update:"ContentBlockUpdateReferencesRelationInput",
		upsert:"ContentBlockUpsertReferencesRelationInput",
		connect:"ContentReferenceUniqueWhere",
		disconnect:"ContentReferenceUniqueWhere",
		delete:"ContentReferenceUniqueWhere"
	},
	ContentBlockUpdateReferencesRelationInput:{
		by:"ContentReferenceUniqueWhere",
		data:"ContentReferenceWithoutBlockUpdateInput"
	},
	ContentReferenceWithoutBlockUpdateInput:{
		type:"ContentReferenceType",
		colorPallete:"ContentReferenceUpdateColorPalleteEntityRelationInput",
		medium:"ContentReferenceUpdateMediumEntityRelationInput",
		link:"ContentReferenceUpdateLinkEntityRelationInput",
		blogPosts:"ContentReferenceUpdateBlogPostsEntityRelationInput",
		links:"ContentReferenceUpdateLinksEntityRelationInput",
		products:"ContentReferenceUpdateProductsEntityRelationInput",
		contentSize:"ContentSize",
		hero:"ContentReferenceUpdateHeroEntityRelationInput",
		gallery:"ContentReferenceUpdateGalleryEntityRelationInput",
		socialsAndApps:"ContentReferenceUpdateSocialsAndAppsEntityRelationInput",
		productGrid:"ContentReferenceUpdateProductGridEntityRelationInput",
		productBanners:"ContentReferenceUpdateProductBannersEntityRelationInput",
		deliveryRegions:"ContentReferenceUpdateDeliveryRegionsEntityRelationInput",
		textList:"ContentReferenceUpdateTextListEntityRelationInput",
		gridTiles:"ContentReferenceUpdateGridTilesEntityRelationInput"
	},
	ContentReferenceUpdateColorPalleteEntityRelationInput:{
		create:"ColorPalleteCreateInput",
		update:"ColorPalleteUpdateInput",
		upsert:"ContentReferenceUpsertColorPalleteRelationInput",
		connect:"ColorPalleteUniqueWhere"
	},
	ContentReferenceUpsertColorPalleteRelationInput:{
		update:"ColorPalleteUpdateInput",
		create:"ColorPalleteCreateInput"
	},
	ContentReferenceUpdateMediumEntityRelationInput:{
		create:"MediumCreateInput",
		update:"MediumUpdateInput",
		upsert:"ContentReferenceUpsertMediumRelationInput",
		connect:"MediumUniqueWhere"
	},
	ContentReferenceUpsertMediumRelationInput:{
		update:"MediumUpdateInput",
		create:"MediumCreateInput"
	},
	ContentReferenceUpdateLinkEntityRelationInput:{
		create:"LinkCreateInput",
		update:"LinkUpdateInput",
		upsert:"ContentReferenceUpsertLinkRelationInput",
		connect:"LinkUniqueWhere"
	},
	LinkUpdateInput:{
		type:"LinkType",
		internalLink:"LinkUpdateInternalLinkEntityRelationInput"
	},
	LinkUpdateInternalLinkEntityRelationInput:{
		create:"LinkableCreateInput",
		update:"LinkableUpdateInput",
		upsert:"LinkUpsertInternalLinkRelationInput",
		connect:"LinkableUniqueWhere"
	},
	LinkableUpdateInput:{
		blogPost:"LinkableUpdateBlogPostEntityRelationInput",
		page:"LinkableUpdatePageEntityRelationInput",
		wikiPage:"LinkableUpdateWikiPageEntityRelationInput",
		redirect:"LinkableUpdateRedirectEntityRelationInput"
	},
	LinkableUpdateBlogPostEntityRelationInput:{
		create:"BlogPostLocaleWithoutLinkCreateInput",
		update:"BlogPostLocaleWithoutLinkUpdateInput",
		upsert:"LinkableUpsertBlogPostRelationInput",
		connect:"BlogPostLocaleUniqueWhere"
	},
	BlogPostLocaleWithoutLinkUpdateInput:{
		root:"BlogPostLocaleUpdateRootEntityRelationInput",
		locale:"BlogPostLocaleUpdateLocaleEntityRelationInput",
		cover:"BlogPostLocaleUpdateCoverEntityRelationInput",
		content:"BlogPostLocaleUpdateContentEntityRelationInput",
		seo:"BlogPostLocaleUpdateSeoEntityRelationInput",
		products:"BlogPostLocaleUpdateProductsEntityRelationInput"
	},
	BlogPostLocaleUpdateLocaleEntityRelationInput:{
		create:"LocaleWithoutBlogPostsCreateInput",
		update:"LocaleWithoutBlogPostsUpdateInput",
		upsert:"BlogPostLocaleUpsertLocaleRelationInput",
		connect:"LocaleUniqueWhere"
	},
	LocaleWithoutBlogPostsUpdateInput:{
		businessCategories:"LocaleUpdateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleUpdateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleUpdateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleUpdateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleUpdateBlogsEntityRelationInput",
		identifier:"LocaleUpdateIdentifierEntityRelationInput",
		menus:"LocaleUpdateMenusEntityRelationInput",
		pages:"LocaleUpdatePagesEntityRelationInput",
		productIngredientCategories:"LocaleUpdateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleUpdateAllergensEntityRelationInput",
		productPackings:"LocaleUpdateProductPackingsEntityRelationInput",
		products:"LocaleUpdateProductsEntityRelationInput",
		productRecipes:"LocaleUpdateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleUpdatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleUpdateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleUpdateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleUpdateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleUpdatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleUpdateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleUpdateBusinessServicesEntityRelationInput"
	},
	LocaleUpdateIdentifierEntityRelationInput:{
		create:"TranslationCataloguesIdentifierCreateInput",
		update:"TranslationCataloguesIdentifierUpdateInput",
		upsert:"LocaleUpsertIdentifierRelationInput",
		connect:"TranslationCataloguesIdentifierUniqueWhere"
	},
	TranslationCataloguesIdentifierUpdateInput:{
		catalogue:"TranslationCataloguesIdentifierUpdateCatalogueEntityRelationInput"
	},
	TranslationCataloguesIdentifierUpdateCatalogueEntityRelationInput:{
		create:"TranslationCatalogueWithoutIdentifierCreateInput",
		update:"TranslationCataloguesIdentifierUpdateCatalogueRelationInput",
		upsert:"TranslationCataloguesIdentifierUpsertCatalogueRelationInput",
		connect:"TranslationCatalogueUniqueWhere",
		disconnect:"TranslationCatalogueUniqueWhere",
		delete:"TranslationCatalogueUniqueWhere"
	},
	TranslationCataloguesIdentifierUpdateCatalogueRelationInput:{
		by:"TranslationCatalogueUniqueWhere",
		data:"TranslationCatalogueWithoutIdentifierUpdateInput"
	},
	TranslationCatalogueWithoutIdentifierUpdateInput:{
		domain:"TranslationCatalogueUpdateDomainEntityRelationInput",
		fallback:"TranslationCatalogueUpdateFallbackEntityRelationInput",
		values:"TranslationCatalogueUpdateValuesEntityRelationInput"
	},
	TranslationCatalogueUpdateDomainEntityRelationInput:{
		create:"TranslationDomainWithoutCataloguesCreateInput",
		update:"TranslationDomainWithoutCataloguesUpdateInput",
		upsert:"TranslationCatalogueUpsertDomainRelationInput",
		connect:"TranslationDomainUniqueWhere"
	},
	TranslationDomainWithoutCataloguesUpdateInput:{
		keys:"TranslationDomainUpdateKeysEntityRelationInput"
	},
	TranslationDomainUpdateKeysEntityRelationInput:{
		create:"TranslationKeyWithoutDomainCreateInput",
		update:"TranslationDomainUpdateKeysRelationInput",
		upsert:"TranslationDomainUpsertKeysRelationInput",
		connect:"TranslationKeyUniqueWhere",
		disconnect:"TranslationKeyUniqueWhere",
		delete:"TranslationKeyUniqueWhere"
	},
	TranslationDomainUpdateKeysRelationInput:{
		by:"TranslationKeyUniqueWhere",
		data:"TranslationKeyWithoutDomainUpdateInput"
	},
	TranslationKeyWithoutDomainUpdateInput:{
		contentType:"TranslationContentType",
		values:"TranslationKeyUpdateValuesEntityRelationInput"
	},
	TranslationKeyUpdateValuesEntityRelationInput:{
		create:"TranslationValueWithoutKeyCreateInput",
		update:"TranslationKeyUpdateValuesRelationInput",
		upsert:"TranslationKeyUpsertValuesRelationInput",
		connect:"TranslationValueUniqueWhere",
		disconnect:"TranslationValueUniqueWhere",
		delete:"TranslationValueUniqueWhere"
	},
	TranslationKeyUpdateValuesRelationInput:{
		by:"TranslationValueUniqueWhere",
		data:"TranslationValueWithoutKeyUpdateInput"
	},
	TranslationValueWithoutKeyUpdateInput:{
		catalogue:"TranslationValueUpdateCatalogueEntityRelationInput"
	},
	TranslationValueUpdateCatalogueEntityRelationInput:{
		create:"TranslationCatalogueWithoutValuesCreateInput",
		update:"TranslationCatalogueWithoutValuesUpdateInput",
		upsert:"TranslationValueUpsertCatalogueRelationInput",
		connect:"TranslationCatalogueUniqueWhere"
	},
	TranslationCatalogueWithoutValuesUpdateInput:{
		domain:"TranslationCatalogueUpdateDomainEntityRelationInput",
		fallback:"TranslationCatalogueUpdateFallbackEntityRelationInput",
		identifier:"TranslationCatalogueUpdateIdentifierEntityRelationInput"
	},
	TranslationCatalogueUpdateFallbackEntityRelationInput:{
		create:"TranslationCatalogueCreateInput",
		update:"TranslationCatalogueUpdateInput",
		upsert:"TranslationCatalogueUpsertFallbackRelationInput",
		connect:"TranslationCatalogueUniqueWhere"
	},
	TranslationCatalogueUpdateInput:{
		domain:"TranslationCatalogueUpdateDomainEntityRelationInput",
		fallback:"TranslationCatalogueUpdateFallbackEntityRelationInput",
		values:"TranslationCatalogueUpdateValuesEntityRelationInput",
		identifier:"TranslationCatalogueUpdateIdentifierEntityRelationInput"
	},
	TranslationCatalogueUpdateValuesEntityRelationInput:{
		create:"TranslationValueWithoutCatalogueCreateInput",
		update:"TranslationCatalogueUpdateValuesRelationInput",
		upsert:"TranslationCatalogueUpsertValuesRelationInput",
		connect:"TranslationValueUniqueWhere",
		disconnect:"TranslationValueUniqueWhere",
		delete:"TranslationValueUniqueWhere"
	},
	TranslationCatalogueUpdateValuesRelationInput:{
		by:"TranslationValueUniqueWhere",
		data:"TranslationValueWithoutCatalogueUpdateInput"
	},
	TranslationValueWithoutCatalogueUpdateInput:{
		key:"TranslationValueUpdateKeyEntityRelationInput"
	},
	TranslationValueUpdateKeyEntityRelationInput:{
		create:"TranslationKeyWithoutValuesCreateInput",
		update:"TranslationKeyWithoutValuesUpdateInput",
		upsert:"TranslationValueUpsertKeyRelationInput",
		connect:"TranslationKeyUniqueWhere"
	},
	TranslationKeyWithoutValuesUpdateInput:{
		contentType:"TranslationContentType",
		domain:"TranslationKeyUpdateDomainEntityRelationInput"
	},
	TranslationKeyUpdateDomainEntityRelationInput:{
		create:"TranslationDomainWithoutKeysCreateInput",
		update:"TranslationDomainWithoutKeysUpdateInput",
		upsert:"TranslationKeyUpsertDomainRelationInput",
		connect:"TranslationDomainUniqueWhere"
	},
	TranslationDomainWithoutKeysUpdateInput:{
		catalogues:"TranslationDomainUpdateCataloguesEntityRelationInput"
	},
	TranslationDomainUpdateCataloguesEntityRelationInput:{
		create:"TranslationCatalogueWithoutDomainCreateInput",
		update:"TranslationDomainUpdateCataloguesRelationInput",
		upsert:"TranslationDomainUpsertCataloguesRelationInput",
		connect:"TranslationCatalogueUniqueWhere",
		disconnect:"TranslationCatalogueUniqueWhere",
		delete:"TranslationCatalogueUniqueWhere"
	},
	TranslationDomainUpdateCataloguesRelationInput:{
		by:"TranslationCatalogueUniqueWhere",
		data:"TranslationCatalogueWithoutDomainUpdateInput"
	},
	TranslationCatalogueWithoutDomainUpdateInput:{
		fallback:"TranslationCatalogueUpdateFallbackEntityRelationInput",
		values:"TranslationCatalogueUpdateValuesEntityRelationInput",
		identifier:"TranslationCatalogueUpdateIdentifierEntityRelationInput"
	},
	TranslationCatalogueUpdateIdentifierEntityRelationInput:{
		create:"TranslationCataloguesIdentifierWithoutCatalogueCreateInput",
		update:"TranslationCataloguesIdentifierWithoutCatalogueUpdateInput",
		upsert:"TranslationCatalogueUpsertIdentifierRelationInput",
		connect:"TranslationCataloguesIdentifierUniqueWhere"
	},
	TranslationCataloguesIdentifierWithoutCatalogueUpdateInput:{

	},
	TranslationCatalogueUpsertIdentifierRelationInput:{
		update:"TranslationCataloguesIdentifierWithoutCatalogueUpdateInput",
		create:"TranslationCataloguesIdentifierWithoutCatalogueCreateInput"
	},
	TranslationDomainUpsertCataloguesRelationInput:{
		by:"TranslationCatalogueUniqueWhere",
		update:"TranslationCatalogueWithoutDomainUpdateInput",
		create:"TranslationCatalogueWithoutDomainCreateInput"
	},
	TranslationKeyUpsertDomainRelationInput:{
		update:"TranslationDomainWithoutKeysUpdateInput",
		create:"TranslationDomainWithoutKeysCreateInput"
	},
	TranslationValueUpsertKeyRelationInput:{
		update:"TranslationKeyWithoutValuesUpdateInput",
		create:"TranslationKeyWithoutValuesCreateInput"
	},
	TranslationCatalogueUpsertValuesRelationInput:{
		by:"TranslationValueUniqueWhere",
		update:"TranslationValueWithoutCatalogueUpdateInput",
		create:"TranslationValueWithoutCatalogueCreateInput"
	},
	TranslationCatalogueUpsertFallbackRelationInput:{
		update:"TranslationCatalogueUpdateInput",
		create:"TranslationCatalogueCreateInput"
	},
	TranslationValueUpsertCatalogueRelationInput:{
		update:"TranslationCatalogueWithoutValuesUpdateInput",
		create:"TranslationCatalogueWithoutValuesCreateInput"
	},
	TranslationKeyUpsertValuesRelationInput:{
		by:"TranslationValueUniqueWhere",
		update:"TranslationValueWithoutKeyUpdateInput",
		create:"TranslationValueWithoutKeyCreateInput"
	},
	TranslationDomainUpsertKeysRelationInput:{
		by:"TranslationKeyUniqueWhere",
		update:"TranslationKeyWithoutDomainUpdateInput",
		create:"TranslationKeyWithoutDomainCreateInput"
	},
	TranslationCatalogueUpsertDomainRelationInput:{
		update:"TranslationDomainWithoutCataloguesUpdateInput",
		create:"TranslationDomainWithoutCataloguesCreateInput"
	},
	TranslationCataloguesIdentifierUpsertCatalogueRelationInput:{
		by:"TranslationCatalogueUniqueWhere",
		update:"TranslationCatalogueWithoutIdentifierUpdateInput",
		create:"TranslationCatalogueWithoutIdentifierCreateInput"
	},
	LocaleUpsertIdentifierRelationInput:{
		update:"TranslationCataloguesIdentifierUpdateInput",
		create:"TranslationCataloguesIdentifierCreateInput"
	},
	LocaleUpdateMenusEntityRelationInput:{
		create:"MenuLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateMenusRelationInput",
		upsert:"LocaleUpsertMenusRelationInput",
		connect:"MenuLocaleUniqueWhere",
		disconnect:"MenuLocaleUniqueWhere",
		delete:"MenuLocaleUniqueWhere"
	},
	LocaleUpdateMenusRelationInput:{
		by:"MenuLocaleUniqueWhere",
		data:"MenuLocaleWithoutLocaleUpdateInput"
	},
	MenuLocaleWithoutLocaleUpdateInput:{
		root:"MenuLocaleUpdateRootEntityRelationInput",
		items:"MenuLocaleUpdateItemsEntityRelationInput",
		secondaryItems:"MenuLocaleUpdateSecondaryItemsEntityRelationInput",
		eshopLink:"MenuLocaleUpdateEshopLinkEntityRelationInput"
	},
	MenuLocaleUpdateRootEntityRelationInput:{
		create:"SiteMenuWithoutLocalesCreateInput",
		update:"SiteMenuWithoutLocalesUpdateInput",
		upsert:"MenuLocaleUpsertRootRelationInput",
		connect:"SiteMenuUniqueWhere"
	},
	SiteMenuWithoutLocalesUpdateInput:{
		unique:"One"
	},
	MenuLocaleUpsertRootRelationInput:{
		update:"SiteMenuWithoutLocalesUpdateInput",
		create:"SiteMenuWithoutLocalesCreateInput"
	},
	MenuLocaleUpdateItemsEntityRelationInput:{
		create:"MenuItemWithoutMenuCreateInput",
		update:"MenuLocaleUpdateItemsRelationInput",
		upsert:"MenuLocaleUpsertItemsRelationInput",
		connect:"MenuItemUniqueWhere",
		disconnect:"MenuItemUniqueWhere",
		delete:"MenuItemUniqueWhere"
	},
	MenuLocaleUpdateItemsRelationInput:{
		by:"MenuItemUniqueWhere",
		data:"MenuItemWithoutMenuUpdateInput"
	},
	MenuItemWithoutMenuUpdateInput:{
		link:"MenuItemUpdateLinkEntityRelationInput",
		subitems:"MenuItemUpdateSubitemsEntityRelationInput"
	},
	MenuItemUpdateLinkEntityRelationInput:{
		create:"LinkCreateInput",
		update:"LinkUpdateInput",
		upsert:"MenuItemUpsertLinkRelationInput",
		connect:"LinkUniqueWhere"
	},
	MenuItemUpsertLinkRelationInput:{
		update:"LinkUpdateInput",
		create:"LinkCreateInput"
	},
	MenuItemUpdateSubitemsEntityRelationInput:{
		create:"MenuSubitemWithoutItemCreateInput",
		update:"MenuItemUpdateSubitemsRelationInput",
		upsert:"MenuItemUpsertSubitemsRelationInput",
		connect:"MenuSubitemUniqueWhere",
		disconnect:"MenuSubitemUniqueWhere",
		delete:"MenuSubitemUniqueWhere"
	},
	MenuItemUpdateSubitemsRelationInput:{
		by:"MenuSubitemUniqueWhere",
		data:"MenuSubitemWithoutItemUpdateInput"
	},
	MenuSubitemWithoutItemUpdateInput:{
		type:"MenuSubitemType",
		links:"MenuSubitemUpdateLinksEntityRelationInput",
		products:"MenuSubitemUpdateProductsEntityRelationInput",
		delivery:"MenuSubitemUpdateDeliveryEntityRelationInput",
		contact:"MenuSubitemUpdateContactEntityRelationInput"
	},
	MenuSubitemUpdateLinksEntityRelationInput:{
		create:"MenuLinkListCreateInput",
		update:"MenuLinkListUpdateInput",
		upsert:"MenuSubitemUpsertLinksRelationInput",
		connect:"MenuLinkListUniqueWhere"
	},
	MenuLinkListUpdateInput:{
		items:"MenuLinkListUpdateItemsEntityRelationInput"
	},
	MenuLinkListUpdateItemsEntityRelationInput:{
		create:"MenuLinkItemWithoutListCreateInput",
		update:"MenuLinkListUpdateItemsRelationInput",
		upsert:"MenuLinkListUpsertItemsRelationInput",
		connect:"MenuLinkItemUniqueWhere",
		disconnect:"MenuLinkItemUniqueWhere",
		delete:"MenuLinkItemUniqueWhere"
	},
	MenuLinkListUpdateItemsRelationInput:{
		by:"MenuLinkItemUniqueWhere",
		data:"MenuLinkItemWithoutListUpdateInput"
	},
	MenuLinkItemWithoutListUpdateInput:{
		link:"MenuLinkItemUpdateLinkEntityRelationInput",
		image:"MenuLinkItemUpdateImageEntityRelationInput"
	},
	MenuLinkItemUpdateLinkEntityRelationInput:{
		create:"LinkCreateInput",
		update:"LinkUpdateInput",
		upsert:"MenuLinkItemUpsertLinkRelationInput",
		connect:"LinkUniqueWhere"
	},
	MenuLinkItemUpsertLinkRelationInput:{
		update:"LinkUpdateInput",
		create:"LinkCreateInput"
	},
	MenuLinkItemUpdateImageEntityRelationInput:{
		create:"ImageCreateInput",
		update:"ImageUpdateInput",
		upsert:"MenuLinkItemUpsertImageRelationInput",
		connect:"ImageUniqueWhere"
	},
	MenuLinkItemUpsertImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	MenuLinkListUpsertItemsRelationInput:{
		by:"MenuLinkItemUniqueWhere",
		update:"MenuLinkItemWithoutListUpdateInput",
		create:"MenuLinkItemWithoutListCreateInput"
	},
	MenuSubitemUpsertLinksRelationInput:{
		update:"MenuLinkListUpdateInput",
		create:"MenuLinkListCreateInput"
	},
	MenuSubitemUpdateProductsEntityRelationInput:{
		create:"MenuProductsCreateInput",
		update:"MenuProductsUpdateInput",
		upsert:"MenuSubitemUpsertProductsRelationInput",
		connect:"MenuProductsUniqueWhere"
	},
	MenuProductsUpdateInput:{
		links:"MenuProductsUpdateLinksEntityRelationInput",
		buttons:"MenuProductsUpdateButtonsEntityRelationInput"
	},
	MenuProductsUpdateLinksEntityRelationInput:{
		create:"MenuLinkListCreateInput",
		update:"MenuLinkListUpdateInput",
		upsert:"MenuProductsUpsertLinksRelationInput",
		connect:"MenuLinkListUniqueWhere"
	},
	MenuProductsUpsertLinksRelationInput:{
		update:"MenuLinkListUpdateInput",
		create:"MenuLinkListCreateInput"
	},
	MenuProductsUpdateButtonsEntityRelationInput:{
		create:"LinkListCreateInput",
		update:"LinkListUpdateInput",
		upsert:"MenuProductsUpsertButtonsRelationInput",
		connect:"LinkListUniqueWhere"
	},
	LinkListUpdateInput:{
		items:"LinkListUpdateItemsEntityRelationInput"
	},
	LinkListUpdateItemsEntityRelationInput:{
		create:"LinkListItemWithoutListCreateInput",
		update:"LinkListUpdateItemsRelationInput",
		upsert:"LinkListUpsertItemsRelationInput",
		connect:"LinkListItemUniqueWhere",
		disconnect:"LinkListItemUniqueWhere",
		delete:"LinkListItemUniqueWhere"
	},
	LinkListUpdateItemsRelationInput:{
		by:"LinkListItemUniqueWhere",
		data:"LinkListItemWithoutListUpdateInput"
	},
	LinkListItemWithoutListUpdateInput:{
		link:"LinkListItemUpdateLinkEntityRelationInput"
	},
	LinkListItemUpdateLinkEntityRelationInput:{
		create:"LinkCreateInput",
		update:"LinkUpdateInput",
		upsert:"LinkListItemUpsertLinkRelationInput",
		connect:"LinkUniqueWhere"
	},
	LinkListItemUpsertLinkRelationInput:{
		update:"LinkUpdateInput",
		create:"LinkCreateInput"
	},
	LinkListUpsertItemsRelationInput:{
		by:"LinkListItemUniqueWhere",
		update:"LinkListItemWithoutListUpdateInput",
		create:"LinkListItemWithoutListCreateInput"
	},
	MenuProductsUpsertButtonsRelationInput:{
		update:"LinkListUpdateInput",
		create:"LinkListCreateInput"
	},
	MenuSubitemUpsertProductsRelationInput:{
		update:"MenuProductsUpdateInput",
		create:"MenuProductsCreateInput"
	},
	MenuSubitemUpdateDeliveryEntityRelationInput:{
		create:"MenuDeliveryCreateInput",
		update:"MenuDeliveryUpdateInput",
		upsert:"MenuSubitemUpsertDeliveryRelationInput",
		connect:"MenuDeliveryUniqueWhere"
	},
	MenuDeliveryUpdateInput:{
		deliveryRegions:"MenuDeliveryUpdateDeliveryRegionsEntityRelationInput",
		socialsAndApps:"MenuDeliveryUpdateSocialsAndAppsEntityRelationInput"
	},
	MenuDeliveryUpdateDeliveryRegionsEntityRelationInput:{
		create:"DeliveryRegionsCreateInput",
		update:"DeliveryRegionsUpdateInput",
		upsert:"MenuDeliveryUpsertDeliveryRegionsRelationInput",
		connect:"DeliveryRegionsUniqueWhere"
	},
	DeliveryRegionsUpdateInput:{
		items:"DeliveryRegionsUpdateItemsEntityRelationInput"
	},
	DeliveryRegionsUpdateItemsEntityRelationInput:{
		create:"DeliveryRegionsItemWithoutListCreateInput",
		update:"DeliveryRegionsUpdateItemsRelationInput",
		upsert:"DeliveryRegionsUpsertItemsRelationInput",
		connect:"DeliveryRegionsItemUniqueWhere",
		disconnect:"DeliveryRegionsItemUniqueWhere",
		delete:"DeliveryRegionsItemUniqueWhere"
	},
	DeliveryRegionsUpdateItemsRelationInput:{
		by:"DeliveryRegionsItemUniqueWhere",
		data:"DeliveryRegionsItemWithoutListUpdateInput"
	},
	DeliveryRegionsItemWithoutListUpdateInput:{
		image:"DeliveryRegionsItemUpdateImageEntityRelationInput",
		textList:"DeliveryRegionsItemUpdateTextListEntityRelationInput",
		gallery:"DeliveryRegionsItemUpdateGalleryEntityRelationInput"
	},
	DeliveryRegionsItemUpdateImageEntityRelationInput:{
		create:"ImageCreateInput",
		update:"ImageUpdateInput",
		upsert:"DeliveryRegionsItemUpsertImageRelationInput",
		connect:"ImageUniqueWhere"
	},
	DeliveryRegionsItemUpsertImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	DeliveryRegionsItemUpdateTextListEntityRelationInput:{
		create:"TextListCreateInput",
		update:"TextListUpdateInput",
		upsert:"DeliveryRegionsItemUpsertTextListRelationInput",
		connect:"TextListUniqueWhere"
	},
	TextListUpdateInput:{
		items:"TextListUpdateItemsEntityRelationInput"
	},
	TextListUpdateItemsEntityRelationInput:{
		create:"TextItemWithoutListCreateInput",
		update:"TextListUpdateItemsRelationInput",
		upsert:"TextListUpsertItemsRelationInput",
		connect:"TextItemUniqueWhere",
		disconnect:"TextItemUniqueWhere",
		delete:"TextItemUniqueWhere"
	},
	TextListUpdateItemsRelationInput:{
		by:"TextItemUniqueWhere",
		data:"TextItemWithoutListUpdateInput"
	},
	TextItemWithoutListUpdateInput:{

	},
	TextListUpsertItemsRelationInput:{
		by:"TextItemUniqueWhere",
		update:"TextItemWithoutListUpdateInput",
		create:"TextItemWithoutListCreateInput"
	},
	DeliveryRegionsItemUpsertTextListRelationInput:{
		update:"TextListUpdateInput",
		create:"TextListCreateInput"
	},
	DeliveryRegionsItemUpdateGalleryEntityRelationInput:{
		create:"ImageListCreateInput",
		update:"ImageListUpdateInput",
		upsert:"DeliveryRegionsItemUpsertGalleryRelationInput",
		connect:"ImageListUniqueWhere"
	},
	ImageListUpdateInput:{
		items:"ImageListUpdateItemsEntityRelationInput"
	},
	ImageListUpdateItemsEntityRelationInput:{
		create:"ImageListItemWithoutListCreateInput",
		update:"ImageListUpdateItemsRelationInput",
		upsert:"ImageListUpsertItemsRelationInput",
		connect:"ImageListItemUniqueWhere",
		disconnect:"ImageListItemUniqueWhere",
		delete:"ImageListItemUniqueWhere"
	},
	ImageListUpdateItemsRelationInput:{
		by:"ImageListItemUniqueWhere",
		data:"ImageListItemWithoutListUpdateInput"
	},
	ImageListItemWithoutListUpdateInput:{
		image:"ImageListItemUpdateImageEntityRelationInput"
	},
	ImageListItemUpdateImageEntityRelationInput:{
		create:"ImageCreateInput",
		update:"ImageUpdateInput",
		upsert:"ImageListItemUpsertImageRelationInput",
		connect:"ImageUniqueWhere"
	},
	ImageListItemUpsertImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	ImageListUpsertItemsRelationInput:{
		by:"ImageListItemUniqueWhere",
		update:"ImageListItemWithoutListUpdateInput",
		create:"ImageListItemWithoutListCreateInput"
	},
	DeliveryRegionsItemUpsertGalleryRelationInput:{
		update:"ImageListUpdateInput",
		create:"ImageListCreateInput"
	},
	DeliveryRegionsUpsertItemsRelationInput:{
		by:"DeliveryRegionsItemUniqueWhere",
		update:"DeliveryRegionsItemWithoutListUpdateInput",
		create:"DeliveryRegionsItemWithoutListCreateInput"
	},
	MenuDeliveryUpsertDeliveryRegionsRelationInput:{
		update:"DeliveryRegionsUpdateInput",
		create:"DeliveryRegionsCreateInput"
	},
	MenuDeliveryUpdateSocialsAndAppsEntityRelationInput:{
		create:"SocialsAndAppsCreateInput",
		update:"SocialsAndAppsUpdateInput",
		upsert:"MenuDeliveryUpsertSocialsAndAppsRelationInput",
		connect:"SocialsAndAppsUniqueWhere"
	},
	SocialsAndAppsUpdateInput:{

	},
	MenuDeliveryUpsertSocialsAndAppsRelationInput:{
		update:"SocialsAndAppsUpdateInput",
		create:"SocialsAndAppsCreateInput"
	},
	MenuSubitemUpsertDeliveryRelationInput:{
		update:"MenuDeliveryUpdateInput",
		create:"MenuDeliveryCreateInput"
	},
	MenuSubitemUpdateContactEntityRelationInput:{
		create:"MenuContactCreateInput",
		update:"MenuContactUpdateInput",
		upsert:"MenuSubitemUpsertContactRelationInput",
		connect:"MenuContactUniqueWhere"
	},
	MenuContactUpdateInput:{
		image:"MenuContactUpdateImageEntityRelationInput"
	},
	MenuContactUpdateImageEntityRelationInput:{
		create:"ImageCreateInput",
		update:"ImageUpdateInput",
		upsert:"MenuContactUpsertImageRelationInput",
		connect:"ImageUniqueWhere"
	},
	MenuContactUpsertImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	MenuSubitemUpsertContactRelationInput:{
		update:"MenuContactUpdateInput",
		create:"MenuContactCreateInput"
	},
	MenuItemUpsertSubitemsRelationInput:{
		by:"MenuSubitemUniqueWhere",
		update:"MenuSubitemWithoutItemUpdateInput",
		create:"MenuSubitemWithoutItemCreateInput"
	},
	MenuLocaleUpsertItemsRelationInput:{
		by:"MenuItemUniqueWhere",
		update:"MenuItemWithoutMenuUpdateInput",
		create:"MenuItemWithoutMenuCreateInput"
	},
	MenuLocaleUpdateSecondaryItemsEntityRelationInput:{
		create:"LinkListCreateInput",
		update:"LinkListUpdateInput",
		upsert:"MenuLocaleUpsertSecondaryItemsRelationInput",
		connect:"LinkListUniqueWhere"
	},
	MenuLocaleUpsertSecondaryItemsRelationInput:{
		update:"LinkListUpdateInput",
		create:"LinkListCreateInput"
	},
	MenuLocaleUpdateEshopLinkEntityRelationInput:{
		create:"LinkCreateInput",
		update:"LinkUpdateInput",
		upsert:"MenuLocaleUpsertEshopLinkRelationInput",
		connect:"LinkUniqueWhere"
	},
	MenuLocaleUpsertEshopLinkRelationInput:{
		update:"LinkUpdateInput",
		create:"LinkCreateInput"
	},
	LocaleUpsertMenusRelationInput:{
		by:"MenuLocaleUniqueWhere",
		update:"MenuLocaleWithoutLocaleUpdateInput",
		create:"MenuLocaleWithoutLocaleCreateInput"
	},
	LocaleUpdatePagesEntityRelationInput:{
		create:"PageLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdatePagesRelationInput",
		upsert:"LocaleUpsertPagesRelationInput",
		connect:"PageLocaleUniqueWhere",
		disconnect:"PageLocaleUniqueWhere",
		delete:"PageLocaleUniqueWhere"
	},
	LocaleUpdatePagesRelationInput:{
		by:"PageLocaleUniqueWhere",
		data:"PageLocaleWithoutLocaleUpdateInput"
	},
	PageLocaleWithoutLocaleUpdateInput:{
		link:"PageLocaleUpdateLinkEntityRelationInput",
		root:"PageLocaleUpdateRootEntityRelationInput",
		seo:"PageLocaleUpdateSeoEntityRelationInput",
		content:"PageLocaleUpdateContentEntityRelationInput",
		cover:"PageLocaleUpdateCoverEntityRelationInput",
		theme:"PageTheme"
	},
	PageLocaleUpdateLinkEntityRelationInput:{
		create:"LinkableWithoutPageCreateInput",
		update:"LinkableWithoutPageUpdateInput",
		upsert:"PageLocaleUpsertLinkRelationInput",
		connect:"LinkableUniqueWhere"
	},
	LinkableWithoutPageUpdateInput:{
		blogPost:"LinkableUpdateBlogPostEntityRelationInput",
		wikiPage:"LinkableUpdateWikiPageEntityRelationInput",
		redirect:"LinkableUpdateRedirectEntityRelationInput"
	},
	LinkableUpdateWikiPageEntityRelationInput:{
		create:"WikiPageWithoutLinkCreateInput",
		update:"WikiPageWithoutLinkUpdateInput",
		upsert:"LinkableUpsertWikiPageRelationInput",
		connect:"WikiPageUniqueWhere"
	},
	WikiPageWithoutLinkUpdateInput:{
		parent:"WikiPageUpdateParentEntityRelationInput",
		children:"WikiPageUpdateChildrenEntityRelationInput",
		content:"WikiPageUpdateContentEntityRelationInput"
	},
	WikiPageUpdateParentEntityRelationInput:{
		create:"WikiPageWithoutChildrenCreateInput",
		update:"WikiPageWithoutChildrenUpdateInput",
		upsert:"WikiPageUpsertParentRelationInput",
		connect:"WikiPageUniqueWhere"
	},
	WikiPageWithoutChildrenUpdateInput:{
		link:"WikiPageUpdateLinkEntityRelationInput",
		parent:"WikiPageUpdateParentEntityRelationInput",
		content:"WikiPageUpdateContentEntityRelationInput"
	},
	WikiPageUpdateLinkEntityRelationInput:{
		create:"LinkableWithoutWikiPageCreateInput",
		update:"LinkableWithoutWikiPageUpdateInput",
		upsert:"WikiPageUpsertLinkRelationInput",
		connect:"LinkableUniqueWhere"
	},
	LinkableWithoutWikiPageUpdateInput:{
		blogPost:"LinkableUpdateBlogPostEntityRelationInput",
		page:"LinkableUpdatePageEntityRelationInput",
		redirect:"LinkableUpdateRedirectEntityRelationInput"
	},
	LinkableUpdatePageEntityRelationInput:{
		create:"PageLocaleWithoutLinkCreateInput",
		update:"PageLocaleWithoutLinkUpdateInput",
		upsert:"LinkableUpsertPageRelationInput",
		connect:"PageLocaleUniqueWhere"
	},
	PageLocaleWithoutLinkUpdateInput:{
		root:"PageLocaleUpdateRootEntityRelationInput",
		locale:"PageLocaleUpdateLocaleEntityRelationInput",
		seo:"PageLocaleUpdateSeoEntityRelationInput",
		content:"PageLocaleUpdateContentEntityRelationInput",
		cover:"PageLocaleUpdateCoverEntityRelationInput",
		theme:"PageTheme"
	},
	PageLocaleUpdateRootEntityRelationInput:{
		create:"PageWithoutLocalesCreateInput",
		update:"PageWithoutLocalesUpdateInput",
		upsert:"PageLocaleUpsertRootRelationInput",
		connect:"PageUniqueWhere"
	},
	PageWithoutLocalesUpdateInput:{

	},
	PageLocaleUpsertRootRelationInput:{
		update:"PageWithoutLocalesUpdateInput",
		create:"PageWithoutLocalesCreateInput"
	},
	PageLocaleUpdateLocaleEntityRelationInput:{
		create:"LocaleWithoutPagesCreateInput",
		update:"LocaleWithoutPagesUpdateInput",
		upsert:"PageLocaleUpsertLocaleRelationInput",
		connect:"LocaleUniqueWhere"
	},
	LocaleWithoutPagesUpdateInput:{
		businessCategories:"LocaleUpdateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleUpdateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleUpdateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleUpdateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleUpdateBlogsEntityRelationInput",
		blogPosts:"LocaleUpdateBlogPostsEntityRelationInput",
		identifier:"LocaleUpdateIdentifierEntityRelationInput",
		menus:"LocaleUpdateMenusEntityRelationInput",
		productIngredientCategories:"LocaleUpdateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleUpdateAllergensEntityRelationInput",
		productPackings:"LocaleUpdateProductPackingsEntityRelationInput",
		products:"LocaleUpdateProductsEntityRelationInput",
		productRecipes:"LocaleUpdateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleUpdatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleUpdateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleUpdateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleUpdateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleUpdatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleUpdateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleUpdateBusinessServicesEntityRelationInput"
	},
	LocaleUpdateProductIngredientCategoriesEntityRelationInput:{
		create:"ProductIngredientCategoryLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateProductIngredientCategoriesRelationInput",
		upsert:"LocaleUpsertProductIngredientCategoriesRelationInput",
		connect:"ProductIngredientCategoryLocaleUniqueWhere",
		disconnect:"ProductIngredientCategoryLocaleUniqueWhere",
		delete:"ProductIngredientCategoryLocaleUniqueWhere"
	},
	LocaleUpdateProductIngredientCategoriesRelationInput:{
		by:"ProductIngredientCategoryLocaleUniqueWhere",
		data:"ProductIngredientCategoryLocaleWithoutLocaleUpdateInput"
	},
	ProductIngredientCategoryLocaleWithoutLocaleUpdateInput:{
		root:"ProductIngredientCategoryLocaleUpdateRootEntityRelationInput"
	},
	ProductIngredientCategoryLocaleUpdateRootEntityRelationInput:{
		create:"ProductIngredientCategoryWithoutLocalesCreateInput",
		update:"ProductIngredientCategoryWithoutLocalesUpdateInput",
		upsert:"ProductIngredientCategoryLocaleUpsertRootRelationInput",
		connect:"ProductIngredientCategoryUniqueWhere"
	},
	ProductIngredientCategoryWithoutLocalesUpdateInput:{
		ingredients:"ProductIngredientCategoryUpdateIngredientsEntityRelationInput"
	},
	ProductIngredientCategoryUpdateIngredientsEntityRelationInput:{
		create:"ProductIngredientWithoutCategoriesCreateInput",
		update:"ProductIngredientCategoryUpdateIngredientsRelationInput",
		upsert:"ProductIngredientCategoryUpsertIngredientsRelationInput",
		connect:"ProductIngredientUniqueWhere",
		disconnect:"ProductIngredientUniqueWhere",
		delete:"ProductIngredientUniqueWhere"
	},
	ProductIngredientCategoryUpdateIngredientsRelationInput:{
		by:"ProductIngredientUniqueWhere",
		data:"ProductIngredientWithoutCategoriesUpdateInput"
	},
	ProductIngredientWithoutCategoriesUpdateInput:{
		locales:"ProductIngredientUpdateLocalesEntityRelationInput",
		allergens:"ProductIngredientUpdateAllergensEntityRelationInput",
		customerRatings:"ProductIngredientUpdateCustomerRatingsEntityRelationInput",
		preferredQuantityUnit:"ProductIngredientUpdatePreferredQuantityUnitEntityRelationInput",
		freshingContainer:"ProductIngredientUpdateFreshingContainerEntityRelationInput",
		image:"ProductIngredientUpdateImageEntityRelationInput",
		suppliers:"ProductIngredientUpdateSuppliersEntityRelationInput"
	},
	ProductIngredientUpdateCustomerRatingsEntityRelationInput:{
		create:"CustomerIngredientRatingWithoutIngredientCreateInput",
		update:"ProductIngredientUpdateCustomerRatingsRelationInput",
		upsert:"ProductIngredientUpsertCustomerRatingsRelationInput",
		connect:"CustomerIngredientRatingUniqueWhere",
		disconnect:"CustomerIngredientRatingUniqueWhere",
		delete:"CustomerIngredientRatingUniqueWhere"
	},
	ProductIngredientUpdateCustomerRatingsRelationInput:{
		by:"CustomerIngredientRatingUniqueWhere",
		data:"CustomerIngredientRatingWithoutIngredientUpdateInput"
	},
	CustomerIngredientRatingWithoutIngredientUpdateInput:{
		customer:"CustomerIngredientRatingUpdateCustomerEntityRelationInput",
		rating:"CustomerIngredientRatingUpdateRatingEntityRelationInput"
	},
	CustomerIngredientRatingUpdateCustomerEntityRelationInput:{
		create:"CustomerWithoutIngredientRatingsCreateInput",
		update:"CustomerWithoutIngredientRatingsUpdateInput",
		upsert:"CustomerIngredientRatingUpsertCustomerRelationInput",
		connect:"CustomerUniqueWhere"
	},
	CustomerWithoutIngredientRatingsUpdateInput:{
		addresses:"CustomerUpdateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerUpdateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerUpdateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerUpdateTagsEntityRelationInput",
		credits:"CustomerUpdateCreditsEntityRelationInput",
		paymentMethods:"CustomerUpdatePaymentMethodsEntityRelationInput",
		orders:"CustomerUpdateOrdersEntityRelationInput",
		permissions:"CustomerUpdatePermissionsEntityRelationInput",
		group:"CustomerUpdateGroupEntityRelationInput",
		photo:"CustomerUpdatePhotoEntityRelationInput",
		name:"CustomerUpdateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		business:"CustomerUpdateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerUpdateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerUpdateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerUpdateCartsEntityRelationInput",
		shortcutList:"CustomerUpdateShortcutListEntityRelationInput",
		user:"CustomerUpdateUserEntityRelationInput",
		channels:"CustomerUpdateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerUpdateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerUpdateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerUpdateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerUpdateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerUpdateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerUpdateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerUpdateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerUpdateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerUpdateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerUpdateRedeemedVouchersEntityRelationInput",
		spending:"CustomerUpdateSpendingEntityRelationInput",
		customerTabs:"CustomerUpdateCustomerTabsEntityRelationInput",
		lead:"CustomerUpdateLeadEntityRelationInput",
		meta:"CustomerUpdateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerUpdateBusinessEntityRelationInput:{
		create:"BusinessCustomerWithoutCustomerCreateInput",
		update:"BusinessCustomerWithoutCustomerUpdateInput",
		upsert:"CustomerUpsertBusinessRelationInput",
		connect:"BusinessCustomerUniqueWhere"
	},
	BusinessCustomerWithoutCustomerUpdateInput:{
		owners:"BusinessCustomerUpdateOwnersEntityRelationInput",
		members:"BusinessCustomerUpdateMembersEntityRelationInput",
		category:"BusinessCustomerUpdateCategoryEntityRelationInput",
		accountManager:"BusinessCustomerUpdateAccountManagerEntityRelationInput",
		logo:"BusinessCustomerUpdateLogoEntityRelationInput",
		businessServiceEvents:"BusinessCustomerUpdateBusinessServiceEventsEntityRelationInput",
		doubleshotCoffeeEquipment:"BusinessCustomerUpdateDoubleshotCoffeeEquipmentEntityRelationInput"
	},
	BusinessCustomerUpdateOwnersEntityRelationInput:{
		create:"CustomerWithoutOwnerOfBusinessesCreateInput",
		update:"BusinessCustomerUpdateOwnersRelationInput",
		upsert:"BusinessCustomerUpsertOwnersRelationInput",
		connect:"CustomerUniqueWhere",
		disconnect:"CustomerUniqueWhere",
		delete:"CustomerUniqueWhere"
	},
	BusinessCustomerUpdateOwnersRelationInput:{
		by:"CustomerUniqueWhere",
		data:"CustomerWithoutOwnerOfBusinessesUpdateInput"
	},
	CustomerWithoutOwnerOfBusinessesUpdateInput:{
		addresses:"CustomerUpdateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerUpdateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerUpdateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerUpdateTagsEntityRelationInput",
		credits:"CustomerUpdateCreditsEntityRelationInput",
		paymentMethods:"CustomerUpdatePaymentMethodsEntityRelationInput",
		orders:"CustomerUpdateOrdersEntityRelationInput",
		permissions:"CustomerUpdatePermissionsEntityRelationInput",
		group:"CustomerUpdateGroupEntityRelationInput",
		photo:"CustomerUpdatePhotoEntityRelationInput",
		name:"CustomerUpdateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerUpdateIngredientRatingsEntityRelationInput",
		business:"CustomerUpdateBusinessEntityRelationInput",
		memberOfBusinesses:"CustomerUpdateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerUpdateCartsEntityRelationInput",
		shortcutList:"CustomerUpdateShortcutListEntityRelationInput",
		user:"CustomerUpdateUserEntityRelationInput",
		channels:"CustomerUpdateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerUpdateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerUpdateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerUpdateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerUpdateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerUpdateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerUpdateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerUpdateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerUpdateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerUpdateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerUpdateRedeemedVouchersEntityRelationInput",
		spending:"CustomerUpdateSpendingEntityRelationInput",
		customerTabs:"CustomerUpdateCustomerTabsEntityRelationInput",
		lead:"CustomerUpdateLeadEntityRelationInput",
		meta:"CustomerUpdateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerUpdateMemberOfBusinessesEntityRelationInput:{
		create:"BusinessCustomerWithoutMembersCreateInput",
		update:"CustomerUpdateMemberOfBusinessesRelationInput",
		upsert:"CustomerUpsertMemberOfBusinessesRelationInput",
		connect:"BusinessCustomerUniqueWhere",
		disconnect:"BusinessCustomerUniqueWhere",
		delete:"BusinessCustomerUniqueWhere"
	},
	CustomerUpdateMemberOfBusinessesRelationInput:{
		by:"BusinessCustomerUniqueWhere",
		data:"BusinessCustomerWithoutMembersUpdateInput"
	},
	BusinessCustomerWithoutMembersUpdateInput:{
		customer:"BusinessCustomerUpdateCustomerEntityRelationInput",
		owners:"BusinessCustomerUpdateOwnersEntityRelationInput",
		category:"BusinessCustomerUpdateCategoryEntityRelationInput",
		accountManager:"BusinessCustomerUpdateAccountManagerEntityRelationInput",
		logo:"BusinessCustomerUpdateLogoEntityRelationInput",
		businessServiceEvents:"BusinessCustomerUpdateBusinessServiceEventsEntityRelationInput",
		doubleshotCoffeeEquipment:"BusinessCustomerUpdateDoubleshotCoffeeEquipmentEntityRelationInput"
	},
	BusinessCustomerUpdateCategoryEntityRelationInput:{
		create:"BusinessCategoryWithoutBusinessCustomersCreateInput",
		update:"BusinessCategoryWithoutBusinessCustomersUpdateInput",
		upsert:"BusinessCustomerUpsertCategoryRelationInput",
		connect:"BusinessCategoryUniqueWhere"
	},
	BusinessCategoryWithoutBusinessCustomersUpdateInput:{
		locales:"BusinessCategoryUpdateLocalesEntityRelationInput",
		recurrences:"BusinessCategoryUpdateRecurrencesEntityRelationInput",
		specificProducts:"BusinessCategoryUpdateSpecificProductsEntityRelationInput",
		seasonalProductCategories:"BusinessCategoryUpdateSeasonalProductCategoriesEntityRelationInput",
		specificProductsProductCategories:"BusinessCategoryUpdateSpecificProductsProductCategoriesEntityRelationInput"
	},
	BusinessCategoryUpdateRecurrencesEntityRelationInput:{
		create:"OrderRecurrenceWithoutBusinessCategoryCreateInput",
		update:"BusinessCategoryUpdateRecurrencesRelationInput",
		upsert:"BusinessCategoryUpsertRecurrencesRelationInput",
		connect:"OrderRecurrenceUniqueWhere",
		disconnect:"OrderRecurrenceUniqueWhere",
		delete:"OrderRecurrenceUniqueWhere"
	},
	BusinessCategoryUpdateRecurrencesRelationInput:{
		by:"OrderRecurrenceUniqueWhere",
		data:"OrderRecurrenceWithoutBusinessCategoryUpdateInput"
	},
	OrderRecurrenceWithoutBusinessCategoryUpdateInput:{
		locales:"OrderRecurrenceUpdateLocalesEntityRelationInput"
	},
	OrderRecurrenceUpdateLocalesEntityRelationInput:{
		create:"OrderRecurrenceLocaleWithoutRootCreateInput",
		update:"OrderRecurrenceUpdateLocalesRelationInput",
		upsert:"OrderRecurrenceUpsertLocalesRelationInput",
		connect:"OrderRecurrenceLocaleUniqueWhere",
		disconnect:"OrderRecurrenceLocaleUniqueWhere",
		delete:"OrderRecurrenceLocaleUniqueWhere"
	},
	OrderRecurrenceUpdateLocalesRelationInput:{
		by:"OrderRecurrenceLocaleUniqueWhere",
		data:"OrderRecurrenceLocaleWithoutRootUpdateInput"
	},
	OrderRecurrenceLocaleWithoutRootUpdateInput:{
		locale:"OrderRecurrenceLocaleUpdateLocaleEntityRelationInput"
	},
	OrderRecurrenceLocaleUpdateLocaleEntityRelationInput:{
		create:"LocaleWithoutOrderRecurrencesCreateInput",
		update:"LocaleWithoutOrderRecurrencesUpdateInput",
		upsert:"OrderRecurrenceLocaleUpsertLocaleRelationInput",
		connect:"LocaleUniqueWhere"
	},
	LocaleWithoutOrderRecurrencesUpdateInput:{
		businessCategories:"LocaleUpdateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleUpdateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleUpdateProductIngredientsEntityRelationInput",
		blogs:"LocaleUpdateBlogsEntityRelationInput",
		blogPosts:"LocaleUpdateBlogPostsEntityRelationInput",
		identifier:"LocaleUpdateIdentifierEntityRelationInput",
		menus:"LocaleUpdateMenusEntityRelationInput",
		pages:"LocaleUpdatePagesEntityRelationInput",
		productIngredientCategories:"LocaleUpdateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleUpdateAllergensEntityRelationInput",
		productPackings:"LocaleUpdateProductPackingsEntityRelationInput",
		products:"LocaleUpdateProductsEntityRelationInput",
		productRecipes:"LocaleUpdateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleUpdatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleUpdateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleUpdateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleUpdateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleUpdatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleUpdateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleUpdateBusinessServicesEntityRelationInput"
	},
	LocaleUpdateAllergensEntityRelationInput:{
		create:"AllergenLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateAllergensRelationInput",
		upsert:"LocaleUpsertAllergensRelationInput",
		connect:"AllergenLocaleUniqueWhere",
		disconnect:"AllergenLocaleUniqueWhere",
		delete:"AllergenLocaleUniqueWhere"
	},
	LocaleUpdateAllergensRelationInput:{
		by:"AllergenLocaleUniqueWhere",
		data:"AllergenLocaleWithoutLocaleUpdateInput"
	},
	AllergenLocaleWithoutLocaleUpdateInput:{
		root:"AllergenLocaleUpdateRootEntityRelationInput"
	},
	AllergenLocaleUpdateRootEntityRelationInput:{
		create:"AllergenWithoutLocalesCreateInput",
		update:"AllergenWithoutLocalesUpdateInput",
		upsert:"AllergenLocaleUpsertRootRelationInput",
		connect:"AllergenUniqueWhere"
	},
	AllergenWithoutLocalesUpdateInput:{
		ingredients:"AllergenUpdateIngredientsEntityRelationInput"
	},
	AllergenUpdateIngredientsEntityRelationInput:{
		create:"ProductIngredientWithoutAllergensCreateInput",
		update:"AllergenUpdateIngredientsRelationInput",
		upsert:"AllergenUpsertIngredientsRelationInput",
		connect:"ProductIngredientUniqueWhere",
		disconnect:"ProductIngredientUniqueWhere",
		delete:"ProductIngredientUniqueWhere"
	},
	AllergenUpdateIngredientsRelationInput:{
		by:"ProductIngredientUniqueWhere",
		data:"ProductIngredientWithoutAllergensUpdateInput"
	},
	ProductIngredientWithoutAllergensUpdateInput:{
		locales:"ProductIngredientUpdateLocalesEntityRelationInput",
		categories:"ProductIngredientUpdateCategoriesEntityRelationInput",
		customerRatings:"ProductIngredientUpdateCustomerRatingsEntityRelationInput",
		preferredQuantityUnit:"ProductIngredientUpdatePreferredQuantityUnitEntityRelationInput",
		freshingContainer:"ProductIngredientUpdateFreshingContainerEntityRelationInput",
		image:"ProductIngredientUpdateImageEntityRelationInput",
		suppliers:"ProductIngredientUpdateSuppliersEntityRelationInput"
	},
	ProductIngredientUpdatePreferredQuantityUnitEntityRelationInput:{
		create:"ProductIngredientItemQuantityUnitCreateInput",
		update:"ProductIngredientItemQuantityUnitUpdateInput",
		upsert:"ProductIngredientUpsertPreferredQuantityUnitRelationInput",
		connect:"ProductIngredientItemQuantityUnitUniqueWhere"
	},
	ProductIngredientItemQuantityUnitUpdateInput:{

	},
	ProductIngredientUpsertPreferredQuantityUnitRelationInput:{
		update:"ProductIngredientItemQuantityUnitUpdateInput",
		create:"ProductIngredientItemQuantityUnitCreateInput"
	},
	ProductIngredientUpdateFreshingContainerEntityRelationInput:{
		create:"FreshingContainerCreateInput",
		update:"FreshingContainerUpdateInput",
		upsert:"ProductIngredientUpsertFreshingContainerRelationInput",
		connect:"FreshingContainerUniqueWhere"
	},
	FreshingContainerUpdateInput:{
		workspace:"FreshingContainerUpdateWorkspaceEntityRelationInput"
	},
	FreshingContainerUpdateWorkspaceEntityRelationInput:{
		create:"WorkspaceWithoutFreshingContainersCreateInput",
		update:"WorkspaceWithoutFreshingContainersUpdateInput",
		upsert:"FreshingContainerUpsertWorkspaceRelationInput",
		connect:"WorkspaceUniqueWhere"
	},
	WorkspaceWithoutFreshingContainersUpdateInput:{
		unique:"One",
		openingHours:"WorkspaceUpdateOpeningHoursEntityRelationInput",
		workingHours:"WorkspaceUpdateWorkingHoursEntityRelationInput",
		defaultFreshingContainer:"WorkspaceUpdateDefaultFreshingContainerEntityRelationInput",
		creditsProduct:"WorkspaceUpdateCreditsProductEntityRelationInput",
		discountVatRate:"WorkspaceUpdateDiscountVatRateEntityRelationInput"
	},
	WorkspaceUpdateOpeningHoursEntityRelationInput:{
		create:"WeekHoursCreateInput",
		update:"WeekHoursUpdateInput",
		upsert:"WorkspaceUpsertOpeningHoursRelationInput",
		connect:"WeekHoursUniqueWhere"
	},
	WeekHoursUpdateInput:{

	},
	WorkspaceUpsertOpeningHoursRelationInput:{
		update:"WeekHoursUpdateInput",
		create:"WeekHoursCreateInput"
	},
	WorkspaceUpdateWorkingHoursEntityRelationInput:{
		create:"WeekHoursCreateInput",
		update:"WeekHoursUpdateInput",
		upsert:"WorkspaceUpsertWorkingHoursRelationInput",
		connect:"WeekHoursUniqueWhere"
	},
	WorkspaceUpsertWorkingHoursRelationInput:{
		update:"WeekHoursUpdateInput",
		create:"WeekHoursCreateInput"
	},
	WorkspaceUpdateDefaultFreshingContainerEntityRelationInput:{
		create:"FreshingContainerCreateInput",
		update:"FreshingContainerUpdateInput",
		upsert:"WorkspaceUpsertDefaultFreshingContainerRelationInput",
		connect:"FreshingContainerUniqueWhere"
	},
	WorkspaceUpsertDefaultFreshingContainerRelationInput:{
		update:"FreshingContainerUpdateInput",
		create:"FreshingContainerCreateInput"
	},
	WorkspaceUpdateCreditsProductEntityRelationInput:{
		create:"VirtualProductCreateInput",
		update:"VirtualProductUpdateInput",
		upsert:"WorkspaceUpsertCreditsProductRelationInput",
		connect:"VirtualProductUniqueWhere"
	},
	VirtualProductUpdateInput:{
		type:"VirtualProductType",
		product:"VirtualProductUpdateProductEntityRelationInput",
		physicalRepresentation:"VirtualProductPhysicalRepresentationType"
	},
	VirtualProductUpdateProductEntityRelationInput:{
		create:"ProductWithoutVirtualProductCreateInput",
		update:"ProductWithoutVirtualProductUpdateInput",
		upsert:"VirtualProductUpsertProductRelationInput",
		connect:"ProductUniqueWhere"
	},
	ProductWithoutVirtualProductUpdateInput:{
		packing:"ProductUpdatePackingEntityRelationInput",
		recipe:"ProductUpdateRecipeEntityRelationInput",
		tags:"ProductUpdateTagsEntityRelationInput",
		categories:"ProductUpdateCategoriesEntityRelationInput",
		vatRate:"ProductUpdateVatRateEntityRelationInput",
		stocks:"ProductUpdateStocksEntityRelationInput",
		groupPrices:"ProductUpdateGroupPricesEntityRelationInput",
		image:"ProductUpdateImageEntityRelationInput",
		cartItems:"ProductUpdateCartItemsEntityRelationInput",
		availability:"ProductAvailability",
		manager:"ProductUpdateManagerEntityRelationInput",
		orderItems:"ProductUpdateOrderItemsEntityRelationInput",
		inheritedCategories:"ProductUpdateInheritedCategoriesEntityRelationInput",
		deliveryZones:"ProductUpdateDeliveryZonesEntityRelationInput",
		locales:"ProductUpdateLocalesEntityRelationInput",
		archivedAt:"DateTime",
		customerPrices:"ProductUpdateCustomerPricesEntityRelationInput",
		meta:"ProductUpdateMetaEntityRelationInput",
		page:"ProductUpdatePageEntityRelationInput",
		salesDays:"ProductUpdateSalesDaysEntityRelationInput",
		salesWeeks:"ProductUpdateSalesWeeksEntityRelationInput",
		salesMonths:"ProductUpdateSalesMonthsEntityRelationInput",
		fulfillmentNotes:"ProductUpdateFulfillmentNotesEntityRelationInput"
	},
	ProductUpdateManagerEntityRelationInput:{
		create:"StocksManagerWithoutManagedProductsCreateInput",
		update:"StocksManagerWithoutManagedProductsUpdateInput",
		upsert:"ProductUpsertManagerRelationInput",
		connect:"StocksManagerUniqueWhere"
	},
	StocksManagerWithoutManagedProductsUpdateInput:{
		staff:"StocksManagerUpdateStaffEntityRelationInput",
		createdAt:"DateTime"
	},
	StocksManagerUpdateStaffEntityRelationInput:{
		create:"StaffWithoutStocksManagerCreateInput",
		update:"StaffWithoutStocksManagerUpdateInput",
		upsert:"StocksManagerUpsertStaffRelationInput",
		connect:"StaffUniqueWhere"
	},
	StaffWithoutStocksManagerUpdateInput:{
		bartender:"StaffUpdateBartenderEntityRelationInput",
		courier:"StaffUpdateCourierEntityRelationInput",
		cleaner:"StaffUpdateCleanerEntityRelationInput",
		shiftsManager:"StaffUpdateShiftsManagerEntityRelationInput",
		businessToBusinessManager:"StaffUpdateBusinessToBusinessManagerEntityRelationInput",
		user:"StaffUpdateUserEntityRelationInput",
		shiftsProfile:"StaffUpdateShiftsProfileEntityRelationInput",
		photo:"StaffUpdatePhotoEntityRelationInput",
		courierManager:"StaffUpdateCourierManagerEntityRelationInput",
		picker:"StaffUpdatePickerEntityRelationInput",
		createdAt:"DateTime",
		remunerationProfile:"StaffUpdateRemunerationProfileEntityRelationInput",
		cashier:"StaffUpdateCashierEntityRelationInput",
		venues:"StaffUpdateVenuesEntityRelationInput",
		internalBuyer:"StaffUpdateInternalBuyerEntityRelationInput",
		salesManager:"StaffUpdateSalesManagerEntityRelationInput",
		cashierManager:"StaffUpdateCashierManagerEntityRelationInput"
	},
	StaffUpdateBartenderEntityRelationInput:{
		create:"BartenderWithoutStaffCreateInput",
		update:"BartenderWithoutStaffUpdateInput",
		upsert:"StaffUpsertBartenderRelationInput",
		connect:"BartenderUniqueWhere"
	},
	BartenderWithoutStaffUpdateInput:{
		createdAt:"DateTime"
	},
	StaffUpsertBartenderRelationInput:{
		update:"BartenderWithoutStaffUpdateInput",
		create:"BartenderWithoutStaffCreateInput"
	},
	StaffUpdateCourierEntityRelationInput:{
		create:"CourierWithoutStaffCreateInput",
		update:"CourierWithoutStaffUpdateInput",
		upsert:"StaffUpsertCourierRelationInput",
		connect:"CourierUniqueWhere"
	},
	CourierWithoutStaffUpdateInput:{
		routes:"CourierUpdateRoutesEntityRelationInput",
		createdAt:"DateTime",
		deliveryMethods:"CourierUpdateDeliveryMethodsEntityRelationInput"
	},
	CourierUpdateRoutesEntityRelationInput:{
		create:"DeliveryRouteWithoutCourierCreateInput",
		update:"CourierUpdateRoutesRelationInput",
		upsert:"CourierUpsertRoutesRelationInput",
		connect:"DeliveryRouteUniqueWhere",
		disconnect:"DeliveryRouteUniqueWhere",
		delete:"DeliveryRouteUniqueWhere"
	},
	CourierUpdateRoutesRelationInput:{
		by:"DeliveryRouteUniqueWhere",
		data:"DeliveryRouteWithoutCourierUpdateInput"
	},
	DeliveryRouteWithoutCourierUpdateInput:{
		createdAt:"DateTime",
		waypoints:"DeliveryRouteUpdateWaypointsEntityRelationInput"
	},
	DeliveryRouteUpdateWaypointsEntityRelationInput:{
		create:"DeliveryWaypointWithoutRouteCreateInput",
		update:"DeliveryRouteUpdateWaypointsRelationInput",
		upsert:"DeliveryRouteUpsertWaypointsRelationInput",
		connect:"DeliveryWaypointUniqueWhere",
		disconnect:"DeliveryWaypointUniqueWhere",
		delete:"DeliveryWaypointUniqueWhere"
	},
	DeliveryRouteUpdateWaypointsRelationInput:{
		by:"DeliveryWaypointUniqueWhere",
		data:"DeliveryWaypointWithoutRouteUpdateInput"
	},
	DeliveryWaypointWithoutRouteUpdateInput:{
		estimatedArrival:"DateTime",
		delivery:"DeliveryWaypointUpdateDeliveryEntityRelationInput",
		originDeparture:"DateTime"
	},
	DeliveryWaypointUpdateDeliveryEntityRelationInput:{
		create:"OrderDeliveryWithoutDeliveryWaypointCreateInput",
		update:"OrderDeliveryWithoutDeliveryWaypointUpdateInput",
		upsert:"DeliveryWaypointUpsertDeliveryRelationInput",
		connect:"OrderDeliveryUniqueWhere"
	},
	OrderDeliveryWithoutDeliveryWaypointUpdateInput:{
		deliveredAt:"DateTime",
		method:"OrderDeliveryUpdateMethodEntityRelationInput",
		vatRate:"OrderDeliveryUpdateVatRateEntityRelationInput",
		order:"OrderDeliveryUpdateOrderEntityRelationInput",
		expectedAt:"DateTime",
		state:"OrderDeliveryState",
		dispatchAt:"DateTime",
		expectedEndAt:"DateTime",
		processingAt:"DateTime",
		deliveringAt:"DateTime",
		failedAt:"DateTime",
		events:"OrderDeliveryUpdateEventsEntityRelationInput",
		prepareAt:"DateTime",
		liftagoRide:"OrderDeliveryUpdateLiftagoRideEntityRelationInput",
		pickedAt:"DateTime",
		address:"OrderDeliveryUpdateAddressEntityRelationInput",
		woltDriveDelivery:"OrderDeliveryUpdateWoltDriveDeliveryEntityRelationInput"
	},
	OrderDeliveryUpdateMethodEntityRelationInput:{
		create:"DeliveryMethodCreateInput",
		update:"DeliveryMethodUpdateInput",
		upsert:"OrderDeliveryUpsertMethodRelationInput",
		connect:"DeliveryMethodUniqueWhere"
	},
	DeliveryMethodUpdateInput:{
		paymentMethods:"DeliveryMethodUpdatePaymentMethodsEntityRelationInput",
		suitableForDeliveryZones:"DeliveryMethodUpdateSuitableForDeliveryZonesEntityRelationInput",
		channels:"DeliveryMethodUpdateChannelsEntityRelationInput",
		courierHandlers:"DeliveryMethodUpdateCourierHandlersEntityRelationInput",
		locales:"DeliveryMethodUpdateLocalesEntityRelationInput",
		timelinePreset:"DeliveryMethodUpdateTimelinePresetEntityRelationInput"
	},
	DeliveryMethodUpdateCourierHandlersEntityRelationInput:{
		create:"CourierWithoutDeliveryMethodsCreateInput",
		update:"DeliveryMethodUpdateCourierHandlersRelationInput",
		upsert:"DeliveryMethodUpsertCourierHandlersRelationInput",
		connect:"CourierUniqueWhere",
		disconnect:"CourierUniqueWhere",
		delete:"CourierUniqueWhere"
	},
	DeliveryMethodUpdateCourierHandlersRelationInput:{
		by:"CourierUniqueWhere",
		data:"CourierWithoutDeliveryMethodsUpdateInput"
	},
	CourierWithoutDeliveryMethodsUpdateInput:{
		staff:"CourierUpdateStaffEntityRelationInput",
		routes:"CourierUpdateRoutesEntityRelationInput",
		createdAt:"DateTime"
	},
	CourierUpdateStaffEntityRelationInput:{
		create:"StaffWithoutCourierCreateInput",
		update:"StaffWithoutCourierUpdateInput",
		upsert:"CourierUpsertStaffRelationInput",
		connect:"StaffUniqueWhere"
	},
	StaffWithoutCourierUpdateInput:{
		bartender:"StaffUpdateBartenderEntityRelationInput",
		cleaner:"StaffUpdateCleanerEntityRelationInput",
		shiftsManager:"StaffUpdateShiftsManagerEntityRelationInput",
		businessToBusinessManager:"StaffUpdateBusinessToBusinessManagerEntityRelationInput",
		user:"StaffUpdateUserEntityRelationInput",
		shiftsProfile:"StaffUpdateShiftsProfileEntityRelationInput",
		stocksManager:"StaffUpdateStocksManagerEntityRelationInput",
		photo:"StaffUpdatePhotoEntityRelationInput",
		courierManager:"StaffUpdateCourierManagerEntityRelationInput",
		picker:"StaffUpdatePickerEntityRelationInput",
		createdAt:"DateTime",
		remunerationProfile:"StaffUpdateRemunerationProfileEntityRelationInput",
		cashier:"StaffUpdateCashierEntityRelationInput",
		venues:"StaffUpdateVenuesEntityRelationInput",
		internalBuyer:"StaffUpdateInternalBuyerEntityRelationInput",
		salesManager:"StaffUpdateSalesManagerEntityRelationInput",
		cashierManager:"StaffUpdateCashierManagerEntityRelationInput"
	},
	StaffUpdateCleanerEntityRelationInput:{
		create:"CleanerWithoutStaffCreateInput",
		update:"CleanerWithoutStaffUpdateInput",
		upsert:"StaffUpsertCleanerRelationInput",
		connect:"CleanerUniqueWhere"
	},
	CleanerWithoutStaffUpdateInput:{
		createdAt:"DateTime"
	},
	StaffUpsertCleanerRelationInput:{
		update:"CleanerWithoutStaffUpdateInput",
		create:"CleanerWithoutStaffCreateInput"
	},
	StaffUpdateShiftsManagerEntityRelationInput:{
		create:"ShiftsManagerWithoutStaffCreateInput",
		update:"ShiftsManagerWithoutStaffUpdateInput",
		upsert:"StaffUpsertShiftsManagerRelationInput",
		connect:"ShiftsManagerUniqueWhere"
	},
	ShiftsManagerWithoutStaffUpdateInput:{
		managedRoles:"ShiftsManagerUpdateManagedRolesEntityRelationInput",
		createdAt:"DateTime"
	},
	ShiftsManagerUpdateManagedRolesEntityRelationInput:{
		create:"TimetableEmployeeRoleWithoutShiftsManagersCreateInput",
		update:"ShiftsManagerUpdateManagedRolesRelationInput",
		upsert:"ShiftsManagerUpsertManagedRolesRelationInput",
		connect:"TimetableEmployeeRoleUniqueWhere",
		disconnect:"TimetableEmployeeRoleUniqueWhere",
		delete:"TimetableEmployeeRoleUniqueWhere"
	},
	ShiftsManagerUpdateManagedRolesRelationInput:{
		by:"TimetableEmployeeRoleUniqueWhere",
		data:"TimetableEmployeeRoleWithoutShiftsManagersUpdateInput"
	},
	TimetableEmployeeRoleWithoutShiftsManagersUpdateInput:{
		shiftGroups:"TimetableEmployeeRoleUpdateShiftGroupsEntityRelationInput",
		shiftsProfiles:"TimetableEmployeeRoleUpdateShiftsProfilesEntityRelationInput",
		timetableTemplates:"TimetableEmployeeRoleUpdateTimetableTemplatesEntityRelationInput"
	},
	TimetableEmployeeRoleUpdateShiftGroupsEntityRelationInput:{
		create:"TimetableShiftGroupWithoutTypeCreateInput",
		update:"TimetableEmployeeRoleUpdateShiftGroupsRelationInput",
		upsert:"TimetableEmployeeRoleUpsertShiftGroupsRelationInput",
		connect:"TimetableShiftGroupUniqueWhere",
		disconnect:"TimetableShiftGroupUniqueWhere",
		delete:"TimetableShiftGroupUniqueWhere"
	},
	TimetableEmployeeRoleUpdateShiftGroupsRelationInput:{
		by:"TimetableShiftGroupUniqueWhere",
		data:"TimetableShiftGroupWithoutTypeUpdateInput"
	},
	TimetableShiftGroupWithoutTypeUpdateInput:{
		shifts:"TimetableShiftGroupUpdateShiftsEntityRelationInput",
		day:"TimetableShiftGroupUpdateDayEntityRelationInput",
		position:"TimetableShiftGroupUpdatePositionEntityRelationInput",
		queue:"TimetableShiftGroupUpdateQueueEntityRelationInput",
		generatedByTemplate:"TimetableShiftGroupUpdateGeneratedByTemplateEntityRelationInput"
	},
	TimetableShiftGroupUpdateShiftsEntityRelationInput:{
		create:"TimetableShiftWithoutGroupCreateInput",
		update:"TimetableShiftGroupUpdateShiftsRelationInput",
		upsert:"TimetableShiftGroupUpsertShiftsRelationInput",
		connect:"TimetableShiftUniqueWhere",
		disconnect:"TimetableShiftUniqueWhere",
		delete:"TimetableShiftUniqueWhere"
	},
	TimetableShiftGroupUpdateShiftsRelationInput:{
		by:"TimetableShiftUniqueWhere",
		data:"TimetableShiftWithoutGroupUpdateInput"
	},
	TimetableShiftWithoutGroupUpdateInput:{
		assigned:"Date",
		shiftsProfile:"TimetableShiftUpdateShiftsProfileEntityRelationInput",
		queueItem:"TimetableShiftUpdateQueueItemEntityRelationInput",
		swapInfo:"TimetableShiftUpdateSwapInfoEntityRelationInput"
	},
	TimetableShiftUpdateShiftsProfileEntityRelationInput:{
		create:"ShiftsProfileWithoutShiftsCreateInput",
		update:"ShiftsProfileWithoutShiftsUpdateInput",
		upsert:"TimetableShiftUpsertShiftsProfileRelationInput",
		connect:"ShiftsProfileUniqueWhere"
	},
	ShiftsProfileWithoutShiftsUpdateInput:{
		queueItems:"ShiftsProfileUpdateQueueItemsEntityRelationInput",
		staff:"ShiftsProfileUpdateStaffEntityRelationInput",
		roles:"ShiftsProfileUpdateRolesEntityRelationInput"
	},
	ShiftsProfileUpdateQueueItemsEntityRelationInput:{
		create:"EmployeeQueueItemWithoutShiftsProfileCreateInput",
		update:"ShiftsProfileUpdateQueueItemsRelationInput",
		upsert:"ShiftsProfileUpsertQueueItemsRelationInput",
		connect:"EmployeeQueueItemUniqueWhere",
		disconnect:"EmployeeQueueItemUniqueWhere",
		delete:"EmployeeQueueItemUniqueWhere"
	},
	ShiftsProfileUpdateQueueItemsRelationInput:{
		by:"EmployeeQueueItemUniqueWhere",
		data:"EmployeeQueueItemWithoutShiftsProfileUpdateInput"
	},
	EmployeeQueueItemWithoutShiftsProfileUpdateInput:{
		queue:"EmployeeQueueItemUpdateQueueEntityRelationInput",
		shift:"EmployeeQueueItemUpdateShiftEntityRelationInput",
		unassignInfo:"EmployeeQueueItemUpdateUnassignInfoEntityRelationInput",
		meta:"EmployeeQueueItemUpdateMetaEntityRelationInput"
	},
	EmployeeQueueItemUpdateQueueEntityRelationInput:{
		create:"EmployeeQueueWithoutItemsCreateInput",
		update:"EmployeeQueueWithoutItemsUpdateInput",
		upsert:"EmployeeQueueItemUpsertQueueRelationInput",
		connect:"EmployeeQueueUniqueWhere"
	},
	EmployeeQueueWithoutItemsUpdateInput:{
		shiftGroup:"EmployeeQueueUpdateShiftGroupEntityRelationInput"
	},
	EmployeeQueueUpdateShiftGroupEntityRelationInput:{
		create:"TimetableShiftGroupWithoutQueueCreateInput",
		update:"TimetableShiftGroupWithoutQueueUpdateInput",
		upsert:"EmployeeQueueUpsertShiftGroupRelationInput",
		connect:"TimetableShiftGroupUniqueWhere"
	},
	TimetableShiftGroupWithoutQueueUpdateInput:{
		shifts:"TimetableShiftGroupUpdateShiftsEntityRelationInput",
		day:"TimetableShiftGroupUpdateDayEntityRelationInput",
		type:"TimetableShiftGroupUpdateTypeEntityRelationInput",
		position:"TimetableShiftGroupUpdatePositionEntityRelationInput",
		generatedByTemplate:"TimetableShiftGroupUpdateGeneratedByTemplateEntityRelationInput"
	},
	TimetableShiftGroupUpdateDayEntityRelationInput:{
		create:"TimetableDayWithoutShiftGroupsCreateInput",
		update:"TimetableDayWithoutShiftGroupsUpdateInput",
		upsert:"TimetableShiftGroupUpsertDayRelationInput",
		connect:"TimetableDayUniqueWhere"
	},
	TimetableDayWithoutShiftGroupsUpdateInput:{
		date:"Date",
		type:"TimetableDayType",
		notes:"TimetableDayUpdateNotesEntityRelationInput",
		venue:"TimetableDayUpdateVenueEntityRelationInput",
		meta:"TimetableDayUpdateMetaEntityRelationInput"
	},
	TimetableDayUpdateNotesEntityRelationInput:{
		create:"TimetableDayNoteWithoutDayCreateInput",
		update:"TimetableDayUpdateNotesRelationInput",
		upsert:"TimetableDayUpsertNotesRelationInput",
		connect:"TimetableDayNoteUniqueWhere",
		disconnect:"TimetableDayNoteUniqueWhere",
		delete:"TimetableDayNoteUniqueWhere"
	},
	TimetableDayUpdateNotesRelationInput:{
		by:"TimetableDayNoteUniqueWhere",
		data:"TimetableDayNoteWithoutDayUpdateInput"
	},
	TimetableDayNoteWithoutDayUpdateInput:{
		role:"TimetableDayNoteUpdateRoleEntityRelationInput"
	},
	TimetableDayNoteUpdateRoleEntityRelationInput:{
		create:"TimetableEmployeeRoleCreateInput",
		update:"TimetableEmployeeRoleUpdateInput",
		upsert:"TimetableDayNoteUpsertRoleRelationInput",
		connect:"TimetableEmployeeRoleUniqueWhere"
	},
	TimetableEmployeeRoleUpdateInput:{
		shiftGroups:"TimetableEmployeeRoleUpdateShiftGroupsEntityRelationInput",
		shiftsProfiles:"TimetableEmployeeRoleUpdateShiftsProfilesEntityRelationInput",
		shiftsManagers:"TimetableEmployeeRoleUpdateShiftsManagersEntityRelationInput",
		timetableTemplates:"TimetableEmployeeRoleUpdateTimetableTemplatesEntityRelationInput"
	},
	TimetableEmployeeRoleUpdateShiftsProfilesEntityRelationInput:{
		create:"ShiftsProfileWithoutRolesCreateInput",
		update:"TimetableEmployeeRoleUpdateShiftsProfilesRelationInput",
		upsert:"TimetableEmployeeRoleUpsertShiftsProfilesRelationInput",
		connect:"ShiftsProfileUniqueWhere",
		disconnect:"ShiftsProfileUniqueWhere",
		delete:"ShiftsProfileUniqueWhere"
	},
	TimetableEmployeeRoleUpdateShiftsProfilesRelationInput:{
		by:"ShiftsProfileUniqueWhere",
		data:"ShiftsProfileWithoutRolesUpdateInput"
	},
	ShiftsProfileWithoutRolesUpdateInput:{
		queueItems:"ShiftsProfileUpdateQueueItemsEntityRelationInput",
		staff:"ShiftsProfileUpdateStaffEntityRelationInput",
		shifts:"ShiftsProfileUpdateShiftsEntityRelationInput"
	},
	ShiftsProfileUpdateStaffEntityRelationInput:{
		create:"StaffWithoutShiftsProfileCreateInput",
		update:"StaffWithoutShiftsProfileUpdateInput",
		upsert:"ShiftsProfileUpsertStaffRelationInput",
		connect:"StaffUniqueWhere"
	},
	StaffWithoutShiftsProfileUpdateInput:{
		bartender:"StaffUpdateBartenderEntityRelationInput",
		courier:"StaffUpdateCourierEntityRelationInput",
		cleaner:"StaffUpdateCleanerEntityRelationInput",
		shiftsManager:"StaffUpdateShiftsManagerEntityRelationInput",
		businessToBusinessManager:"StaffUpdateBusinessToBusinessManagerEntityRelationInput",
		user:"StaffUpdateUserEntityRelationInput",
		stocksManager:"StaffUpdateStocksManagerEntityRelationInput",
		photo:"StaffUpdatePhotoEntityRelationInput",
		courierManager:"StaffUpdateCourierManagerEntityRelationInput",
		picker:"StaffUpdatePickerEntityRelationInput",
		createdAt:"DateTime",
		remunerationProfile:"StaffUpdateRemunerationProfileEntityRelationInput",
		cashier:"StaffUpdateCashierEntityRelationInput",
		venues:"StaffUpdateVenuesEntityRelationInput",
		internalBuyer:"StaffUpdateInternalBuyerEntityRelationInput",
		salesManager:"StaffUpdateSalesManagerEntityRelationInput",
		cashierManager:"StaffUpdateCashierManagerEntityRelationInput"
	},
	StaffUpdateBusinessToBusinessManagerEntityRelationInput:{
		create:"BusinessToBusinessManagerWithoutStaffCreateInput",
		update:"BusinessToBusinessManagerWithoutStaffUpdateInput",
		upsert:"StaffUpsertBusinessToBusinessManagerRelationInput",
		connect:"BusinessToBusinessManagerUniqueWhere"
	},
	BusinessToBusinessManagerWithoutStaffUpdateInput:{
		managedBusinesses:"BusinessToBusinessManagerUpdateManagedBusinessesEntityRelationInput",
		createdAt:"DateTime"
	},
	BusinessToBusinessManagerUpdateManagedBusinessesEntityRelationInput:{
		create:"BusinessCustomerWithoutAccountManagerCreateInput",
		update:"BusinessToBusinessManagerUpdateManagedBusinessesRelationInput",
		upsert:"BusinessToBusinessManagerUpsertManagedBusinessesRelationInput",
		connect:"BusinessCustomerUniqueWhere",
		disconnect:"BusinessCustomerUniqueWhere",
		delete:"BusinessCustomerUniqueWhere"
	},
	BusinessToBusinessManagerUpdateManagedBusinessesRelationInput:{
		by:"BusinessCustomerUniqueWhere",
		data:"BusinessCustomerWithoutAccountManagerUpdateInput"
	},
	BusinessCustomerWithoutAccountManagerUpdateInput:{
		customer:"BusinessCustomerUpdateCustomerEntityRelationInput",
		owners:"BusinessCustomerUpdateOwnersEntityRelationInput",
		members:"BusinessCustomerUpdateMembersEntityRelationInput",
		category:"BusinessCustomerUpdateCategoryEntityRelationInput",
		logo:"BusinessCustomerUpdateLogoEntityRelationInput",
		businessServiceEvents:"BusinessCustomerUpdateBusinessServiceEventsEntityRelationInput",
		doubleshotCoffeeEquipment:"BusinessCustomerUpdateDoubleshotCoffeeEquipmentEntityRelationInput"
	},
	BusinessCustomerUpdateMembersEntityRelationInput:{
		create:"CustomerWithoutMemberOfBusinessesCreateInput",
		update:"BusinessCustomerUpdateMembersRelationInput",
		upsert:"BusinessCustomerUpsertMembersRelationInput",
		connect:"CustomerUniqueWhere",
		disconnect:"CustomerUniqueWhere",
		delete:"CustomerUniqueWhere"
	},
	BusinessCustomerUpdateMembersRelationInput:{
		by:"CustomerUniqueWhere",
		data:"CustomerWithoutMemberOfBusinessesUpdateInput"
	},
	CustomerWithoutMemberOfBusinessesUpdateInput:{
		addresses:"CustomerUpdateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerUpdateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerUpdateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerUpdateTagsEntityRelationInput",
		credits:"CustomerUpdateCreditsEntityRelationInput",
		paymentMethods:"CustomerUpdatePaymentMethodsEntityRelationInput",
		orders:"CustomerUpdateOrdersEntityRelationInput",
		permissions:"CustomerUpdatePermissionsEntityRelationInput",
		group:"CustomerUpdateGroupEntityRelationInput",
		photo:"CustomerUpdatePhotoEntityRelationInput",
		name:"CustomerUpdateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerUpdateIngredientRatingsEntityRelationInput",
		business:"CustomerUpdateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerUpdateOwnerOfBusinessesEntityRelationInput",
		carts:"CustomerUpdateCartsEntityRelationInput",
		shortcutList:"CustomerUpdateShortcutListEntityRelationInput",
		user:"CustomerUpdateUserEntityRelationInput",
		channels:"CustomerUpdateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerUpdateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerUpdateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerUpdateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerUpdateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerUpdateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerUpdateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerUpdateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerUpdateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerUpdateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerUpdateRedeemedVouchersEntityRelationInput",
		spending:"CustomerUpdateSpendingEntityRelationInput",
		customerTabs:"CustomerUpdateCustomerTabsEntityRelationInput",
		lead:"CustomerUpdateLeadEntityRelationInput",
		meta:"CustomerUpdateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerUpdateOwnerOfBusinessesEntityRelationInput:{
		create:"BusinessCustomerWithoutOwnersCreateInput",
		update:"CustomerUpdateOwnerOfBusinessesRelationInput",
		upsert:"CustomerUpsertOwnerOfBusinessesRelationInput",
		connect:"BusinessCustomerUniqueWhere",
		disconnect:"BusinessCustomerUniqueWhere",
		delete:"BusinessCustomerUniqueWhere"
	},
	CustomerUpdateOwnerOfBusinessesRelationInput:{
		by:"BusinessCustomerUniqueWhere",
		data:"BusinessCustomerWithoutOwnersUpdateInput"
	},
	BusinessCustomerWithoutOwnersUpdateInput:{
		customer:"BusinessCustomerUpdateCustomerEntityRelationInput",
		members:"BusinessCustomerUpdateMembersEntityRelationInput",
		category:"BusinessCustomerUpdateCategoryEntityRelationInput",
		accountManager:"BusinessCustomerUpdateAccountManagerEntityRelationInput",
		logo:"BusinessCustomerUpdateLogoEntityRelationInput",
		businessServiceEvents:"BusinessCustomerUpdateBusinessServiceEventsEntityRelationInput",
		doubleshotCoffeeEquipment:"BusinessCustomerUpdateDoubleshotCoffeeEquipmentEntityRelationInput"
	},
	BusinessCustomerUpdateAccountManagerEntityRelationInput:{
		create:"BusinessToBusinessManagerWithoutManagedBusinessesCreateInput",
		update:"BusinessToBusinessManagerWithoutManagedBusinessesUpdateInput",
		upsert:"BusinessCustomerUpsertAccountManagerRelationInput",
		connect:"BusinessToBusinessManagerUniqueWhere"
	},
	BusinessToBusinessManagerWithoutManagedBusinessesUpdateInput:{
		staff:"BusinessToBusinessManagerUpdateStaffEntityRelationInput",
		createdAt:"DateTime"
	},
	BusinessToBusinessManagerUpdateStaffEntityRelationInput:{
		create:"StaffWithoutBusinessToBusinessManagerCreateInput",
		update:"StaffWithoutBusinessToBusinessManagerUpdateInput",
		upsert:"BusinessToBusinessManagerUpsertStaffRelationInput",
		connect:"StaffUniqueWhere"
	},
	StaffWithoutBusinessToBusinessManagerUpdateInput:{
		bartender:"StaffUpdateBartenderEntityRelationInput",
		courier:"StaffUpdateCourierEntityRelationInput",
		cleaner:"StaffUpdateCleanerEntityRelationInput",
		shiftsManager:"StaffUpdateShiftsManagerEntityRelationInput",
		user:"StaffUpdateUserEntityRelationInput",
		shiftsProfile:"StaffUpdateShiftsProfileEntityRelationInput",
		stocksManager:"StaffUpdateStocksManagerEntityRelationInput",
		photo:"StaffUpdatePhotoEntityRelationInput",
		courierManager:"StaffUpdateCourierManagerEntityRelationInput",
		picker:"StaffUpdatePickerEntityRelationInput",
		createdAt:"DateTime",
		remunerationProfile:"StaffUpdateRemunerationProfileEntityRelationInput",
		cashier:"StaffUpdateCashierEntityRelationInput",
		venues:"StaffUpdateVenuesEntityRelationInput",
		internalBuyer:"StaffUpdateInternalBuyerEntityRelationInput",
		salesManager:"StaffUpdateSalesManagerEntityRelationInput",
		cashierManager:"StaffUpdateCashierManagerEntityRelationInput"
	},
	StaffUpdateUserEntityRelationInput:{
		create:"UserWithoutStaffCreateInput",
		update:"UserWithoutStaffUpdateInput",
		upsert:"StaffUpsertUserRelationInput",
		connect:"UserUniqueWhere"
	},
	UserWithoutStaffUpdateInput:{
		customer:"UserUpdateCustomerEntityRelationInput",
		tenantPersonId:"UUID",
		disabledAt:"DateTime",
		devices:"UserUpdateDevicesEntityRelationInput",
		verifiedAt:"DateTime",
		createdAt:"DateTime",
		deletionRequestedAt:"DateTime",
		deletionExpectedAt:"DateTime",
		deletedAt:"DateTime",
		meta:"UserUpdateMetaEntityRelationInput",
		identificationAttempts:"UserUpdateIdentificationAttemptsEntityRelationInput",
		roles:"UserUpdateRolesEntityRelationInput"
	},
	UserUpdateCustomerEntityRelationInput:{
		create:"CustomerWithoutUserCreateInput",
		update:"CustomerWithoutUserUpdateInput",
		upsert:"UserUpsertCustomerRelationInput",
		connect:"CustomerUniqueWhere"
	},
	CustomerWithoutUserUpdateInput:{
		addresses:"CustomerUpdateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerUpdateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerUpdateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerUpdateTagsEntityRelationInput",
		credits:"CustomerUpdateCreditsEntityRelationInput",
		paymentMethods:"CustomerUpdatePaymentMethodsEntityRelationInput",
		orders:"CustomerUpdateOrdersEntityRelationInput",
		permissions:"CustomerUpdatePermissionsEntityRelationInput",
		group:"CustomerUpdateGroupEntityRelationInput",
		photo:"CustomerUpdatePhotoEntityRelationInput",
		name:"CustomerUpdateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerUpdateIngredientRatingsEntityRelationInput",
		business:"CustomerUpdateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerUpdateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerUpdateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerUpdateCartsEntityRelationInput",
		shortcutList:"CustomerUpdateShortcutListEntityRelationInput",
		channels:"CustomerUpdateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerUpdateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerUpdateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerUpdateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerUpdateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerUpdateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerUpdateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerUpdateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerUpdateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerUpdateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerUpdateRedeemedVouchersEntityRelationInput",
		spending:"CustomerUpdateSpendingEntityRelationInput",
		customerTabs:"CustomerUpdateCustomerTabsEntityRelationInput",
		lead:"CustomerUpdateLeadEntityRelationInput",
		meta:"CustomerUpdateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerUpdateCartsEntityRelationInput:{
		create:"CartWithoutCustomerCreateInput",
		update:"CustomerUpdateCartsRelationInput",
		upsert:"CustomerUpsertCartsRelationInput",
		connect:"CartUniqueWhere",
		disconnect:"CartUniqueWhere",
		delete:"CartUniqueWhere"
	},
	CustomerUpdateCartsRelationInput:{
		by:"CartUniqueWhere",
		data:"CartWithoutCustomerUpdateInput"
	},
	CartWithoutCustomerUpdateInput:{
		confirmedAt:"DateTime",
		deletedAt:"DateTime",
		items:"CartUpdateItemsEntityRelationInput",
		state:"CartState",
		createdAt:"DateTime",
		channel:"CartUpdateChannelEntityRelationInput",
		order:"CartUpdateOrderEntityRelationInput",
		deliveryAddress:"CartUpdateDeliveryAddressEntityRelationInput",
		billingAddress:"CartUpdateBillingAddressEntityRelationInput",
		delivery:"CartUpdateDeliveryEntityRelationInput",
		payment:"CartUpdatePaymentEntityRelationInput",
		billingSubject:"CartUpdateBillingSubjectEntityRelationInput",
		priceLines:"CartUpdatePriceLinesEntityRelationInput",
		summary:"CartUpdateSummaryEntityRelationInput"
	},
	CartUpdateOrderEntityRelationInput:{
		create:"OrderWithoutCartCreateInput",
		update:"OrderWithoutCartUpdateInput",
		upsert:"CartUpsertOrderRelationInput",
		connect:"OrderUniqueWhere"
	},
	OrderWithoutCartUpdateInput:{
		state:"OrderState",
		fulfilledAt:"DateTime",
		canceledAt:"DateTime",
		customer:"OrderUpdateCustomerEntityRelationInput",
		channel:"OrderUpdateChannelEntityRelationInput",
		discounts:"OrderUpdateDiscountsEntityRelationInput",
		delivery:"OrderUpdateDeliveryEntityRelationInput",
		items:"OrderUpdateItemsEntityRelationInput",
		events:"OrderUpdateEventsEntityRelationInput",
		createdAt:"DateTime",
		billingAddress:"OrderUpdateBillingAddressEntityRelationInput",
		priceLines:"OrderUpdatePriceLinesEntityRelationInput",
		payments:"OrderUpdatePaymentsEntityRelationInput",
		billingSubject:"OrderUpdateBillingSubjectEntityRelationInput",
		summary:"OrderUpdateSummaryEntityRelationInput",
		gratuity:"OrderUpdateGratuityEntityRelationInput",
		venue:"OrderUpdateVenueEntityRelationInput",
		fulfillmentNotes:"OrderUpdateFulfillmentNotesEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	OrderUpdateCustomerEntityRelationInput:{
		create:"CustomerWithoutOrdersCreateInput",
		update:"CustomerWithoutOrdersUpdateInput",
		upsert:"OrderUpsertCustomerRelationInput",
		connect:"CustomerUniqueWhere"
	},
	CustomerWithoutOrdersUpdateInput:{
		addresses:"CustomerUpdateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerUpdateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerUpdateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerUpdateTagsEntityRelationInput",
		credits:"CustomerUpdateCreditsEntityRelationInput",
		paymentMethods:"CustomerUpdatePaymentMethodsEntityRelationInput",
		permissions:"CustomerUpdatePermissionsEntityRelationInput",
		group:"CustomerUpdateGroupEntityRelationInput",
		photo:"CustomerUpdatePhotoEntityRelationInput",
		name:"CustomerUpdateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerUpdateIngredientRatingsEntityRelationInput",
		business:"CustomerUpdateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerUpdateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerUpdateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerUpdateCartsEntityRelationInput",
		shortcutList:"CustomerUpdateShortcutListEntityRelationInput",
		user:"CustomerUpdateUserEntityRelationInput",
		channels:"CustomerUpdateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerUpdateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerUpdateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerUpdateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerUpdateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerUpdateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerUpdateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerUpdateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerUpdateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerUpdateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerUpdateRedeemedVouchersEntityRelationInput",
		spending:"CustomerUpdateSpendingEntityRelationInput",
		customerTabs:"CustomerUpdateCustomerTabsEntityRelationInput",
		lead:"CustomerUpdateLeadEntityRelationInput",
		meta:"CustomerUpdateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerUpdateShortcutListEntityRelationInput:{
		create:"ApplicationShortcutListWithoutCustomerCreateInput",
		update:"ApplicationShortcutListWithoutCustomerUpdateInput",
		upsert:"CustomerUpsertShortcutListRelationInput",
		connect:"ApplicationShortcutListUniqueWhere"
	},
	ApplicationShortcutListWithoutCustomerUpdateInput:{
		items:"ApplicationShortcutListUpdateItemsEntityRelationInput"
	},
	ApplicationShortcutListUpdateItemsEntityRelationInput:{
		create:"ApplicationShortcutListItemWithoutListCreateInput",
		update:"ApplicationShortcutListUpdateItemsRelationInput",
		upsert:"ApplicationShortcutListUpsertItemsRelationInput",
		connect:"ApplicationShortcutListItemUniqueWhere",
		disconnect:"ApplicationShortcutListItemUniqueWhere",
		delete:"ApplicationShortcutListItemUniqueWhere"
	},
	ApplicationShortcutListUpdateItemsRelationInput:{
		by:"ApplicationShortcutListItemUniqueWhere",
		data:"ApplicationShortcutListItemWithoutListUpdateInput"
	},
	ApplicationShortcutListItemWithoutListUpdateInput:{
		application:"ApplicationShortcutListItemUpdateApplicationEntityRelationInput"
	},
	ApplicationShortcutListItemUpdateApplicationEntityRelationInput:{
		create:"ApplicationCreateInput",
		update:"ApplicationUpdateInput",
		upsert:"ApplicationShortcutListItemUpsertApplicationRelationInput",
		connect:"ApplicationUniqueWhere"
	},
	ApplicationUpdateInput:{
		icon:"ApplicationUpdateIconEntityRelationInput"
	},
	ApplicationUpdateIconEntityRelationInput:{
		create:"ImageCreateInput",
		update:"ImageUpdateInput",
		upsert:"ApplicationUpsertIconRelationInput",
		connect:"ImageUniqueWhere"
	},
	ApplicationUpsertIconRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	ApplicationShortcutListItemUpsertApplicationRelationInput:{
		update:"ApplicationUpdateInput",
		create:"ApplicationCreateInput"
	},
	ApplicationShortcutListUpsertItemsRelationInput:{
		by:"ApplicationShortcutListItemUniqueWhere",
		update:"ApplicationShortcutListItemWithoutListUpdateInput",
		create:"ApplicationShortcutListItemWithoutListCreateInput"
	},
	CustomerUpsertShortcutListRelationInput:{
		update:"ApplicationShortcutListWithoutCustomerUpdateInput",
		create:"ApplicationShortcutListWithoutCustomerCreateInput"
	},
	CustomerUpdateUserEntityRelationInput:{
		create:"UserWithoutCustomerCreateInput",
		update:"UserWithoutCustomerUpdateInput",
		upsert:"CustomerUpsertUserRelationInput",
		connect:"UserUniqueWhere"
	},
	UserWithoutCustomerUpdateInput:{
		staff:"UserUpdateStaffEntityRelationInput",
		tenantPersonId:"UUID",
		disabledAt:"DateTime",
		devices:"UserUpdateDevicesEntityRelationInput",
		verifiedAt:"DateTime",
		createdAt:"DateTime",
		deletionRequestedAt:"DateTime",
		deletionExpectedAt:"DateTime",
		deletedAt:"DateTime",
		meta:"UserUpdateMetaEntityRelationInput",
		identificationAttempts:"UserUpdateIdentificationAttemptsEntityRelationInput",
		roles:"UserUpdateRolesEntityRelationInput"
	},
	UserUpdateStaffEntityRelationInput:{
		create:"StaffWithoutUserCreateInput",
		update:"StaffWithoutUserUpdateInput",
		upsert:"UserUpsertStaffRelationInput",
		connect:"StaffUniqueWhere"
	},
	StaffWithoutUserUpdateInput:{
		bartender:"StaffUpdateBartenderEntityRelationInput",
		courier:"StaffUpdateCourierEntityRelationInput",
		cleaner:"StaffUpdateCleanerEntityRelationInput",
		shiftsManager:"StaffUpdateShiftsManagerEntityRelationInput",
		businessToBusinessManager:"StaffUpdateBusinessToBusinessManagerEntityRelationInput",
		shiftsProfile:"StaffUpdateShiftsProfileEntityRelationInput",
		stocksManager:"StaffUpdateStocksManagerEntityRelationInput",
		photo:"StaffUpdatePhotoEntityRelationInput",
		courierManager:"StaffUpdateCourierManagerEntityRelationInput",
		picker:"StaffUpdatePickerEntityRelationInput",
		createdAt:"DateTime",
		remunerationProfile:"StaffUpdateRemunerationProfileEntityRelationInput",
		cashier:"StaffUpdateCashierEntityRelationInput",
		venues:"StaffUpdateVenuesEntityRelationInput",
		internalBuyer:"StaffUpdateInternalBuyerEntityRelationInput",
		salesManager:"StaffUpdateSalesManagerEntityRelationInput",
		cashierManager:"StaffUpdateCashierManagerEntityRelationInput"
	},
	StaffUpdateShiftsProfileEntityRelationInput:{
		create:"ShiftsProfileWithoutStaffCreateInput",
		update:"ShiftsProfileWithoutStaffUpdateInput",
		upsert:"StaffUpsertShiftsProfileRelationInput",
		connect:"ShiftsProfileUniqueWhere"
	},
	ShiftsProfileWithoutStaffUpdateInput:{
		queueItems:"ShiftsProfileUpdateQueueItemsEntityRelationInput",
		roles:"ShiftsProfileUpdateRolesEntityRelationInput",
		shifts:"ShiftsProfileUpdateShiftsEntityRelationInput"
	},
	ShiftsProfileUpdateRolesEntityRelationInput:{
		create:"TimetableEmployeeRoleWithoutShiftsProfilesCreateInput",
		update:"ShiftsProfileUpdateRolesRelationInput",
		upsert:"ShiftsProfileUpsertRolesRelationInput",
		connect:"TimetableEmployeeRoleUniqueWhere",
		disconnect:"TimetableEmployeeRoleUniqueWhere",
		delete:"TimetableEmployeeRoleUniqueWhere"
	},
	ShiftsProfileUpdateRolesRelationInput:{
		by:"TimetableEmployeeRoleUniqueWhere",
		data:"TimetableEmployeeRoleWithoutShiftsProfilesUpdateInput"
	},
	TimetableEmployeeRoleWithoutShiftsProfilesUpdateInput:{
		shiftGroups:"TimetableEmployeeRoleUpdateShiftGroupsEntityRelationInput",
		shiftsManagers:"TimetableEmployeeRoleUpdateShiftsManagersEntityRelationInput",
		timetableTemplates:"TimetableEmployeeRoleUpdateTimetableTemplatesEntityRelationInput"
	},
	TimetableEmployeeRoleUpdateShiftsManagersEntityRelationInput:{
		create:"ShiftsManagerWithoutManagedRolesCreateInput",
		update:"TimetableEmployeeRoleUpdateShiftsManagersRelationInput",
		upsert:"TimetableEmployeeRoleUpsertShiftsManagersRelationInput",
		connect:"ShiftsManagerUniqueWhere",
		disconnect:"ShiftsManagerUniqueWhere",
		delete:"ShiftsManagerUniqueWhere"
	},
	TimetableEmployeeRoleUpdateShiftsManagersRelationInput:{
		by:"ShiftsManagerUniqueWhere",
		data:"ShiftsManagerWithoutManagedRolesUpdateInput"
	},
	ShiftsManagerWithoutManagedRolesUpdateInput:{
		staff:"ShiftsManagerUpdateStaffEntityRelationInput",
		createdAt:"DateTime"
	},
	ShiftsManagerUpdateStaffEntityRelationInput:{
		create:"StaffWithoutShiftsManagerCreateInput",
		update:"StaffWithoutShiftsManagerUpdateInput",
		upsert:"ShiftsManagerUpsertStaffRelationInput",
		connect:"StaffUniqueWhere"
	},
	StaffWithoutShiftsManagerUpdateInput:{
		bartender:"StaffUpdateBartenderEntityRelationInput",
		courier:"StaffUpdateCourierEntityRelationInput",
		cleaner:"StaffUpdateCleanerEntityRelationInput",
		businessToBusinessManager:"StaffUpdateBusinessToBusinessManagerEntityRelationInput",
		user:"StaffUpdateUserEntityRelationInput",
		shiftsProfile:"StaffUpdateShiftsProfileEntityRelationInput",
		stocksManager:"StaffUpdateStocksManagerEntityRelationInput",
		photo:"StaffUpdatePhotoEntityRelationInput",
		courierManager:"StaffUpdateCourierManagerEntityRelationInput",
		picker:"StaffUpdatePickerEntityRelationInput",
		createdAt:"DateTime",
		remunerationProfile:"StaffUpdateRemunerationProfileEntityRelationInput",
		cashier:"StaffUpdateCashierEntityRelationInput",
		venues:"StaffUpdateVenuesEntityRelationInput",
		internalBuyer:"StaffUpdateInternalBuyerEntityRelationInput",
		salesManager:"StaffUpdateSalesManagerEntityRelationInput",
		cashierManager:"StaffUpdateCashierManagerEntityRelationInput"
	},
	StaffUpdateStocksManagerEntityRelationInput:{
		create:"StocksManagerWithoutStaffCreateInput",
		update:"StocksManagerWithoutStaffUpdateInput",
		upsert:"StaffUpsertStocksManagerRelationInput",
		connect:"StocksManagerUniqueWhere"
	},
	StocksManagerWithoutStaffUpdateInput:{
		managedProducts:"StocksManagerUpdateManagedProductsEntityRelationInput",
		createdAt:"DateTime"
	},
	StocksManagerUpdateManagedProductsEntityRelationInput:{
		create:"ProductWithoutManagerCreateInput",
		update:"StocksManagerUpdateManagedProductsRelationInput",
		upsert:"StocksManagerUpsertManagedProductsRelationInput",
		connect:"ProductUniqueWhere",
		disconnect:"ProductUniqueWhere",
		delete:"ProductUniqueWhere"
	},
	StocksManagerUpdateManagedProductsRelationInput:{
		by:"ProductUniqueWhere",
		data:"ProductWithoutManagerUpdateInput"
	},
	ProductWithoutManagerUpdateInput:{
		packing:"ProductUpdatePackingEntityRelationInput",
		recipe:"ProductUpdateRecipeEntityRelationInput",
		tags:"ProductUpdateTagsEntityRelationInput",
		categories:"ProductUpdateCategoriesEntityRelationInput",
		vatRate:"ProductUpdateVatRateEntityRelationInput",
		stocks:"ProductUpdateStocksEntityRelationInput",
		groupPrices:"ProductUpdateGroupPricesEntityRelationInput",
		image:"ProductUpdateImageEntityRelationInput",
		cartItems:"ProductUpdateCartItemsEntityRelationInput",
		availability:"ProductAvailability",
		orderItems:"ProductUpdateOrderItemsEntityRelationInput",
		inheritedCategories:"ProductUpdateInheritedCategoriesEntityRelationInput",
		deliveryZones:"ProductUpdateDeliveryZonesEntityRelationInput",
		locales:"ProductUpdateLocalesEntityRelationInput",
		archivedAt:"DateTime",
		customerPrices:"ProductUpdateCustomerPricesEntityRelationInput",
		virtualProduct:"ProductUpdateVirtualProductEntityRelationInput",
		meta:"ProductUpdateMetaEntityRelationInput",
		page:"ProductUpdatePageEntityRelationInput",
		salesDays:"ProductUpdateSalesDaysEntityRelationInput",
		salesWeeks:"ProductUpdateSalesWeeksEntityRelationInput",
		salesMonths:"ProductUpdateSalesMonthsEntityRelationInput",
		fulfillmentNotes:"ProductUpdateFulfillmentNotesEntityRelationInput"
	},
	ProductUpdateOrderItemsEntityRelationInput:{
		create:"OrderItemWithoutProductCreateInput",
		update:"ProductUpdateOrderItemsRelationInput",
		upsert:"ProductUpsertOrderItemsRelationInput",
		connect:"OrderItemUniqueWhere",
		disconnect:"OrderItemUniqueWhere",
		delete:"OrderItemUniqueWhere"
	},
	ProductUpdateOrderItemsRelationInput:{
		by:"OrderItemUniqueWhere",
		data:"OrderItemWithoutProductUpdateInput"
	},
	OrderItemWithoutProductUpdateInput:{
		vatRate:"OrderItemUpdateVatRateEntityRelationInput",
		order:"OrderItemUpdateOrderEntityRelationInput",
		virtualProductEffects:"OrderItemUpdateVirtualProductEffectsEntityRelationInput",
		pickedAt:"DateTime",
		fulfillmentNotes:"OrderItemUpdateFulfillmentNotesEntityRelationInput"
	},
	OrderItemUpdateVatRateEntityRelationInput:{
		create:"VatRateCreateInput",
		update:"VatRateUpdateInput",
		upsert:"OrderItemUpsertVatRateRelationInput",
		connect:"VatRateUniqueWhere"
	},
	OrderItemUpsertVatRateRelationInput:{
		update:"VatRateUpdateInput",
		create:"VatRateCreateInput"
	},
	OrderItemUpdateOrderEntityRelationInput:{
		create:"OrderWithoutItemsCreateInput",
		update:"OrderWithoutItemsUpdateInput",
		upsert:"OrderItemUpsertOrderRelationInput",
		connect:"OrderUniqueWhere"
	},
	OrderWithoutItemsUpdateInput:{
		state:"OrderState",
		fulfilledAt:"DateTime",
		canceledAt:"DateTime",
		customer:"OrderUpdateCustomerEntityRelationInput",
		channel:"OrderUpdateChannelEntityRelationInput",
		discounts:"OrderUpdateDiscountsEntityRelationInput",
		delivery:"OrderUpdateDeliveryEntityRelationInput",
		cart:"OrderUpdateCartEntityRelationInput",
		events:"OrderUpdateEventsEntityRelationInput",
		createdAt:"DateTime",
		billingAddress:"OrderUpdateBillingAddressEntityRelationInput",
		priceLines:"OrderUpdatePriceLinesEntityRelationInput",
		payments:"OrderUpdatePaymentsEntityRelationInput",
		billingSubject:"OrderUpdateBillingSubjectEntityRelationInput",
		summary:"OrderUpdateSummaryEntityRelationInput",
		gratuity:"OrderUpdateGratuityEntityRelationInput",
		venue:"OrderUpdateVenueEntityRelationInput",
		fulfillmentNotes:"OrderUpdateFulfillmentNotesEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	OrderUpdateDiscountsEntityRelationInput:{
		create:"OrderDiscountWithoutOrderCreateInput",
		update:"OrderUpdateDiscountsRelationInput",
		upsert:"OrderUpsertDiscountsRelationInput",
		connect:"OrderDiscountUniqueWhere",
		disconnect:"OrderDiscountUniqueWhere",
		delete:"OrderDiscountUniqueWhere"
	},
	OrderUpdateDiscountsRelationInput:{
		by:"OrderDiscountUniqueWhere",
		data:"OrderDiscountWithoutOrderUpdateInput"
	},
	OrderDiscountWithoutOrderUpdateInput:{
		vatRate:"OrderDiscountUpdateVatRateEntityRelationInput",
		type:"OrderDiscountType",
		customerCreditTransactions:"OrderDiscountUpdateCustomerCreditTransactionsEntityRelationInput",
		voucherRedemption:"OrderDiscountUpdateVoucherRedemptionEntityRelationInput"
	},
	OrderDiscountUpdateVatRateEntityRelationInput:{
		create:"VatRateCreateInput",
		update:"VatRateUpdateInput",
		upsert:"OrderDiscountUpsertVatRateRelationInput",
		connect:"VatRateUniqueWhere"
	},
	OrderDiscountUpsertVatRateRelationInput:{
		update:"VatRateUpdateInput",
		create:"VatRateCreateInput"
	},
	OrderDiscountUpdateCustomerCreditTransactionsEntityRelationInput:{
		create:"CustomerCreditTransactionWithoutOrderDiscountCreateInput",
		update:"OrderDiscountUpdateCustomerCreditTransactionsRelationInput",
		upsert:"OrderDiscountUpsertCustomerCreditTransactionsRelationInput",
		connect:"CustomerCreditTransactionUniqueWhere",
		disconnect:"CustomerCreditTransactionUniqueWhere",
		delete:"CustomerCreditTransactionUniqueWhere"
	},
	OrderDiscountUpdateCustomerCreditTransactionsRelationInput:{
		by:"CustomerCreditTransactionUniqueWhere",
		data:"CustomerCreditTransactionWithoutOrderDiscountUpdateInput"
	},
	CustomerCreditTransactionWithoutOrderDiscountUpdateInput:{
		createdAt:"DateTime",
		customerCredit:"CustomerCreditTransactionUpdateCustomerCreditEntityRelationInput",
		virtualProductEffect:"CustomerCreditTransactionUpdateVirtualProductEffectEntityRelationInput"
	},
	CustomerCreditTransactionUpdateCustomerCreditEntityRelationInput:{
		create:"CustomerCreditWithoutTransactionsCreateInput",
		update:"CustomerCreditWithoutTransactionsUpdateInput",
		upsert:"CustomerCreditTransactionUpsertCustomerCreditRelationInput",
		connect:"CustomerCreditUniqueWhere"
	},
	CustomerCreditWithoutTransactionsUpdateInput:{
		expiresAt:"DateTime",
		customer:"CustomerCreditUpdateCustomerEntityRelationInput",
		vatRate:"CustomerCreditUpdateVatRateEntityRelationInput",
		createdAt:"DateTime",
		voucherRedemption:"CustomerCreditUpdateVoucherRedemptionEntityRelationInput"
	},
	CustomerCreditUpdateCustomerEntityRelationInput:{
		create:"CustomerWithoutCreditsCreateInput",
		update:"CustomerWithoutCreditsUpdateInput",
		upsert:"CustomerCreditUpsertCustomerRelationInput",
		connect:"CustomerUniqueWhere"
	},
	CustomerWithoutCreditsUpdateInput:{
		addresses:"CustomerUpdateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerUpdateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerUpdateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerUpdateTagsEntityRelationInput",
		paymentMethods:"CustomerUpdatePaymentMethodsEntityRelationInput",
		orders:"CustomerUpdateOrdersEntityRelationInput",
		permissions:"CustomerUpdatePermissionsEntityRelationInput",
		group:"CustomerUpdateGroupEntityRelationInput",
		photo:"CustomerUpdatePhotoEntityRelationInput",
		name:"CustomerUpdateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerUpdateIngredientRatingsEntityRelationInput",
		business:"CustomerUpdateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerUpdateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerUpdateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerUpdateCartsEntityRelationInput",
		shortcutList:"CustomerUpdateShortcutListEntityRelationInput",
		user:"CustomerUpdateUserEntityRelationInput",
		channels:"CustomerUpdateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerUpdateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerUpdateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerUpdateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerUpdateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerUpdateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerUpdateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerUpdateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerUpdateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerUpdateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerUpdateRedeemedVouchersEntityRelationInput",
		spending:"CustomerUpdateSpendingEntityRelationInput",
		customerTabs:"CustomerUpdateCustomerTabsEntityRelationInput",
		lead:"CustomerUpdateLeadEntityRelationInput",
		meta:"CustomerUpdateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerUpdateChannelsEntityRelationInput:{
		create:"ChannelWithoutCustomersCreateInput",
		update:"CustomerUpdateChannelsRelationInput",
		upsert:"CustomerUpsertChannelsRelationInput",
		connect:"ChannelUniqueWhere",
		disconnect:"ChannelUniqueWhere",
		delete:"ChannelUniqueWhere"
	},
	CustomerUpdateChannelsRelationInput:{
		by:"ChannelUniqueWhere",
		data:"ChannelWithoutCustomersUpdateInput"
	},
	ChannelWithoutCustomersUpdateInput:{
		payments:"ChannelUpdatePaymentsEntityRelationInput",
		deliveries:"ChannelUpdateDeliveriesEntityRelationInput",
		pointOfSales:"ChannelUpdatePointOfSalesEntityRelationInput",
		carts:"ChannelUpdateCartsEntityRelationInput",
		code:"ChannelCode",
		addTagsOnRegistration:"ChannelUpdateAddTagsOnRegistrationEntityRelationInput",
		publicTags:"ChannelUpdatePublicTagsEntityRelationInput",
		venue:"ChannelUpdateVenueEntityRelationInput"
	},
	ChannelUpdatePublicTagsEntityRelationInput:{
		create:"TagWithoutPublicInChannelsCreateInput",
		update:"ChannelUpdatePublicTagsRelationInput",
		upsert:"ChannelUpsertPublicTagsRelationInput",
		connect:"TagUniqueWhere",
		disconnect:"TagUniqueWhere",
		delete:"TagUniqueWhere"
	},
	ChannelUpdatePublicTagsRelationInput:{
		by:"TagUniqueWhere",
		data:"TagWithoutPublicInChannelsUpdateInput"
	},
	TagWithoutPublicInChannelsUpdateInput:{
		customers:"TagUpdateCustomersEntityRelationInput",
		products:"TagUpdateProductsEntityRelationInput",
		categories:"TagUpdateCategoriesEntityRelationInput",
		addTagsOnRegistration:"TagUpdateAddTagsOnRegistrationEntityRelationInput",
		nestedCategories:"TagUpdateNestedCategoriesEntityRelationInput",
		deliveryZones:"TagUpdateDeliveryZonesEntityRelationInput",
		allowChannelPayments:"TagUpdateAllowChannelPaymentsEntityRelationInput",
		fulfillmentNotes:"TagUpdateFulfillmentNotesEntityRelationInput"
	},
	TagUpdateAllowChannelPaymentsEntityRelationInput:{
		create:"ChannelPaymentWithoutAllowOnlyForTagsCreateInput",
		update:"TagUpdateAllowChannelPaymentsRelationInput",
		upsert:"TagUpsertAllowChannelPaymentsRelationInput",
		connect:"ChannelPaymentUniqueWhere",
		disconnect:"ChannelPaymentUniqueWhere",
		delete:"ChannelPaymentUniqueWhere"
	},
	TagUpdateAllowChannelPaymentsRelationInput:{
		by:"ChannelPaymentUniqueWhere",
		data:"ChannelPaymentWithoutAllowOnlyForTagsUpdateInput"
	},
	ChannelPaymentWithoutAllowOnlyForTagsUpdateInput:{
		channel:"ChannelPaymentUpdateChannelEntityRelationInput",
		method:"ChannelPaymentUpdateMethodEntityRelationInput",
		vatRate:"ChannelPaymentUpdateVatRateEntityRelationInput"
	},
	ChannelPaymentUpdateVatRateEntityRelationInput:{
		create:"VatRateWithoutChannelPaymentsCreateInput",
		update:"VatRateWithoutChannelPaymentsUpdateInput",
		upsert:"ChannelPaymentUpsertVatRateRelationInput",
		connect:"VatRateUniqueWhere"
	},
	VatRateWithoutChannelPaymentsUpdateInput:{
		channelDeliveries:"VatRateUpdateChannelDeliveriesEntityRelationInput",
		preset:"VatRatePreset"
	},
	ChannelPaymentUpsertVatRateRelationInput:{
		update:"VatRateWithoutChannelPaymentsUpdateInput",
		create:"VatRateWithoutChannelPaymentsCreateInput"
	},
	TagUpsertAllowChannelPaymentsRelationInput:{
		by:"ChannelPaymentUniqueWhere",
		update:"ChannelPaymentWithoutAllowOnlyForTagsUpdateInput",
		create:"ChannelPaymentWithoutAllowOnlyForTagsCreateInput"
	},
	TagUpdateFulfillmentNotesEntityRelationInput:{
		create:"FulfillmentNoteWithoutTagsCreateInput",
		update:"TagUpdateFulfillmentNotesRelationInput",
		upsert:"TagUpsertFulfillmentNotesRelationInput",
		connect:"FulfillmentNoteUniqueWhere",
		disconnect:"FulfillmentNoteUniqueWhere",
		delete:"FulfillmentNoteUniqueWhere"
	},
	TagUpdateFulfillmentNotesRelationInput:{
		by:"FulfillmentNoteUniqueWhere",
		data:"FulfillmentNoteWithoutTagsUpdateInput"
	},
	FulfillmentNoteWithoutTagsUpdateInput:{
		products:"FulfillmentNoteUpdateProductsEntityRelationInput",
		venues:"FulfillmentNoteUpdateVenuesEntityRelationInput",
		cartItems:"FulfillmentNoteUpdateCartItemsEntityRelationInput",
		orderItems:"FulfillmentNoteUpdateOrderItemsEntityRelationInput",
		orders:"FulfillmentNoteUpdateOrdersEntityRelationInput",
		createdAt:"DateTime"
	},
	FulfillmentNoteUpdateProductsEntityRelationInput:{
		create:"ProductWithoutFulfillmentNotesCreateInput",
		update:"FulfillmentNoteUpdateProductsRelationInput",
		upsert:"FulfillmentNoteUpsertProductsRelationInput",
		connect:"ProductUniqueWhere",
		disconnect:"ProductUniqueWhere",
		delete:"ProductUniqueWhere"
	},
	FulfillmentNoteUpdateProductsRelationInput:{
		by:"ProductUniqueWhere",
		data:"ProductWithoutFulfillmentNotesUpdateInput"
	},
	ProductWithoutFulfillmentNotesUpdateInput:{
		packing:"ProductUpdatePackingEntityRelationInput",
		recipe:"ProductUpdateRecipeEntityRelationInput",
		tags:"ProductUpdateTagsEntityRelationInput",
		categories:"ProductUpdateCategoriesEntityRelationInput",
		vatRate:"ProductUpdateVatRateEntityRelationInput",
		stocks:"ProductUpdateStocksEntityRelationInput",
		groupPrices:"ProductUpdateGroupPricesEntityRelationInput",
		image:"ProductUpdateImageEntityRelationInput",
		cartItems:"ProductUpdateCartItemsEntityRelationInput",
		availability:"ProductAvailability",
		manager:"ProductUpdateManagerEntityRelationInput",
		orderItems:"ProductUpdateOrderItemsEntityRelationInput",
		inheritedCategories:"ProductUpdateInheritedCategoriesEntityRelationInput",
		deliveryZones:"ProductUpdateDeliveryZonesEntityRelationInput",
		locales:"ProductUpdateLocalesEntityRelationInput",
		archivedAt:"DateTime",
		customerPrices:"ProductUpdateCustomerPricesEntityRelationInput",
		virtualProduct:"ProductUpdateVirtualProductEntityRelationInput",
		meta:"ProductUpdateMetaEntityRelationInput",
		page:"ProductUpdatePageEntityRelationInput",
		salesDays:"ProductUpdateSalesDaysEntityRelationInput",
		salesWeeks:"ProductUpdateSalesWeeksEntityRelationInput",
		salesMonths:"ProductUpdateSalesMonthsEntityRelationInput"
	},
	ProductUpdateInheritedCategoriesEntityRelationInput:{
		connect:"NestedProductCategoryProductUniqueWhere",
		disconnect:"NestedProductCategoryProductUniqueWhere",
		delete:"NestedProductCategoryProductUniqueWhere"
	},
	ProductUpdateDeliveryZonesEntityRelationInput:{
		create:"DeliveryZoneWithoutDeliveryZonesOfProductsCreateInput",
		update:"ProductUpdateDeliveryZonesRelationInput",
		upsert:"ProductUpsertDeliveryZonesRelationInput",
		connect:"DeliveryZoneUniqueWhere",
		disconnect:"DeliveryZoneUniqueWhere",
		delete:"DeliveryZoneUniqueWhere"
	},
	ProductUpdateDeliveryZonesRelationInput:{
		by:"DeliveryZoneUniqueWhere",
		data:"DeliveryZoneWithoutDeliveryZonesOfProductsUpdateInput"
	},
	DeliveryZoneWithoutDeliveryZonesOfProductsUpdateInput:{
		type:"DeliveryZoneType",
		addresses:"DeliveryZoneUpdateAddressesEntityRelationInput",
		suitableDeliveryMethods:"DeliveryZoneUpdateSuitableDeliveryMethodsEntityRelationInput",
		deliveryZonesOfTags:"DeliveryZoneUpdateDeliveryZonesOfTagsEntityRelationInput",
		addressesMetadata:"DeliveryZoneUpdateAddressesMetadataEntityRelationInput"
	},
	DeliveryZoneUpdateDeliveryZonesOfTagsEntityRelationInput:{
		create:"TagWithoutDeliveryZonesCreateInput",
		update:"DeliveryZoneUpdateDeliveryZonesOfTagsRelationInput",
		upsert:"DeliveryZoneUpsertDeliveryZonesOfTagsRelationInput",
		connect:"TagUniqueWhere",
		disconnect:"TagUniqueWhere",
		delete:"TagUniqueWhere"
	},
	DeliveryZoneUpdateDeliveryZonesOfTagsRelationInput:{
		by:"TagUniqueWhere",
		data:"TagWithoutDeliveryZonesUpdateInput"
	},
	TagWithoutDeliveryZonesUpdateInput:{
		customers:"TagUpdateCustomersEntityRelationInput",
		products:"TagUpdateProductsEntityRelationInput",
		categories:"TagUpdateCategoriesEntityRelationInput",
		addTagsOnRegistration:"TagUpdateAddTagsOnRegistrationEntityRelationInput",
		nestedCategories:"TagUpdateNestedCategoriesEntityRelationInput",
		publicInChannels:"TagUpdatePublicInChannelsEntityRelationInput",
		allowChannelPayments:"TagUpdateAllowChannelPaymentsEntityRelationInput",
		fulfillmentNotes:"TagUpdateFulfillmentNotesEntityRelationInput"
	},
	TagUpdatePublicInChannelsEntityRelationInput:{
		create:"ChannelWithoutPublicTagsCreateInput",
		update:"TagUpdatePublicInChannelsRelationInput",
		upsert:"TagUpsertPublicInChannelsRelationInput",
		connect:"ChannelUniqueWhere",
		disconnect:"ChannelUniqueWhere",
		delete:"ChannelUniqueWhere"
	},
	TagUpdatePublicInChannelsRelationInput:{
		by:"ChannelUniqueWhere",
		data:"ChannelWithoutPublicTagsUpdateInput"
	},
	ChannelWithoutPublicTagsUpdateInput:{
		payments:"ChannelUpdatePaymentsEntityRelationInput",
		deliveries:"ChannelUpdateDeliveriesEntityRelationInput",
		pointOfSales:"ChannelUpdatePointOfSalesEntityRelationInput",
		carts:"ChannelUpdateCartsEntityRelationInput",
		customers:"ChannelUpdateCustomersEntityRelationInput",
		code:"ChannelCode",
		addTagsOnRegistration:"ChannelUpdateAddTagsOnRegistrationEntityRelationInput",
		venue:"ChannelUpdateVenueEntityRelationInput"
	},
	ChannelUpdateVenueEntityRelationInput:{
		create:"VenueWithoutChannelsCreateInput",
		update:"VenueWithoutChannelsUpdateInput",
		upsert:"ChannelUpsertVenueRelationInput",
		connect:"VenueUniqueWhere"
	},
	VenueWithoutChannelsUpdateInput:{
		deadlineTemplate:"VenueUpdateDeadlineTemplateEntityRelationInput",
		timetableDays:"VenueUpdateTimetableDaysEntityRelationInput",
		timetableTemplates:"VenueUpdateTimetableTemplatesEntityRelationInput",
		staffMembers:"VenueUpdateStaffMembersEntityRelationInput",
		employeeRoles:"VenueUpdateEmployeeRolesEntityRelationInput",
		pointOfSaleApplicationDevices:"VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput",
		pointOfSaleTerminals:"VenueUpdatePointOfSaleTerminalsEntityRelationInput",
		pointOfSalePrinters:"VenueUpdatePointOfSalePrintersEntityRelationInput",
		orders:"VenueUpdateOrdersEntityRelationInput",
		fulfillmentNotes:"VenueUpdateFulfillmentNotesEntityRelationInput",
		areas:"VenueUpdateAreasEntityRelationInput",
		enabledUnassignReasons:"VenueUpdateEnabledUnassignReasonsEntityRelationInput",
		categories:"VenueUpdateCategoriesEntityRelationInput",
		pointOfSaleInitialView:"PointOfSaleInitialView"
	},
	VenueUpdateDeadlineTemplateEntityRelationInput:{
		create:"DeadlineTemplateWithoutVenueCreateInput",
		update:"DeadlineTemplateWithoutVenueUpdateInput",
		upsert:"VenueUpsertDeadlineTemplateRelationInput",
		connect:"DeadlineTemplateUniqueWhere"
	},
	DeadlineTemplateWithoutVenueUpdateInput:{
		startDate:"Date"
	},
	VenueUpsertDeadlineTemplateRelationInput:{
		update:"DeadlineTemplateWithoutVenueUpdateInput",
		create:"DeadlineTemplateWithoutVenueCreateInput"
	},
	VenueUpdateTimetableDaysEntityRelationInput:{
		create:"TimetableDayWithoutVenueCreateInput",
		update:"VenueUpdateTimetableDaysRelationInput",
		upsert:"VenueUpsertTimetableDaysRelationInput",
		connect:"TimetableDayUniqueWhere",
		disconnect:"TimetableDayUniqueWhere",
		delete:"TimetableDayUniqueWhere"
	},
	VenueUpdateTimetableDaysRelationInput:{
		by:"TimetableDayUniqueWhere",
		data:"TimetableDayWithoutVenueUpdateInput"
	},
	TimetableDayWithoutVenueUpdateInput:{
		date:"Date",
		type:"TimetableDayType",
		shiftGroups:"TimetableDayUpdateShiftGroupsEntityRelationInput",
		notes:"TimetableDayUpdateNotesEntityRelationInput",
		meta:"TimetableDayUpdateMetaEntityRelationInput"
	},
	TimetableDayUpdateShiftGroupsEntityRelationInput:{
		create:"TimetableShiftGroupWithoutDayCreateInput",
		update:"TimetableDayUpdateShiftGroupsRelationInput",
		upsert:"TimetableDayUpsertShiftGroupsRelationInput",
		connect:"TimetableShiftGroupUniqueWhere",
		disconnect:"TimetableShiftGroupUniqueWhere",
		delete:"TimetableShiftGroupUniqueWhere"
	},
	TimetableDayUpdateShiftGroupsRelationInput:{
		by:"TimetableShiftGroupUniqueWhere",
		data:"TimetableShiftGroupWithoutDayUpdateInput"
	},
	TimetableShiftGroupWithoutDayUpdateInput:{
		shifts:"TimetableShiftGroupUpdateShiftsEntityRelationInput",
		type:"TimetableShiftGroupUpdateTypeEntityRelationInput",
		position:"TimetableShiftGroupUpdatePositionEntityRelationInput",
		queue:"TimetableShiftGroupUpdateQueueEntityRelationInput",
		generatedByTemplate:"TimetableShiftGroupUpdateGeneratedByTemplateEntityRelationInput"
	},
	TimetableShiftGroupUpdateTypeEntityRelationInput:{
		create:"TimetableEmployeeRoleWithoutShiftGroupsCreateInput",
		update:"TimetableEmployeeRoleWithoutShiftGroupsUpdateInput",
		upsert:"TimetableShiftGroupUpsertTypeRelationInput",
		connect:"TimetableEmployeeRoleUniqueWhere"
	},
	TimetableEmployeeRoleWithoutShiftGroupsUpdateInput:{
		shiftsProfiles:"TimetableEmployeeRoleUpdateShiftsProfilesEntityRelationInput",
		shiftsManagers:"TimetableEmployeeRoleUpdateShiftsManagersEntityRelationInput",
		timetableTemplates:"TimetableEmployeeRoleUpdateTimetableTemplatesEntityRelationInput"
	},
	TimetableEmployeeRoleUpdateTimetableTemplatesEntityRelationInput:{
		create:"TimetableTemplateWithoutEmployeeRoleCreateInput",
		update:"TimetableEmployeeRoleUpdateTimetableTemplatesRelationInput",
		upsert:"TimetableEmployeeRoleUpsertTimetableTemplatesRelationInput",
		connect:"TimetableTemplateUniqueWhere",
		disconnect:"TimetableTemplateUniqueWhere",
		delete:"TimetableTemplateUniqueWhere"
	},
	TimetableEmployeeRoleUpdateTimetableTemplatesRelationInput:{
		by:"TimetableTemplateUniqueWhere",
		data:"TimetableTemplateWithoutEmployeeRoleUpdateInput"
	},
	TimetableTemplateWithoutEmployeeRoleUpdateInput:{
		startDate:"Date",
		position:"TimetableTemplateUpdatePositionEntityRelationInput",
		staffOptions:"TimetableTemplateUpdateStaffOptionsEntityRelationInput",
		venue:"TimetableTemplateUpdateVenueEntityRelationInput",
		type:"TemplateType"
	},
	TimetableTemplateUpdatePositionEntityRelationInput:{
		create:"TimetableShiftPositionWithoutTimetableTemplatesCreateInput",
		update:"TimetableShiftPositionWithoutTimetableTemplatesUpdateInput",
		upsert:"TimetableTemplateUpsertPositionRelationInput",
		connect:"TimetableShiftPositionUniqueWhere"
	},
	TimetableShiftPositionWithoutTimetableTemplatesUpdateInput:{
		shiftGroups:"TimetableShiftPositionUpdateShiftGroupsEntityRelationInput"
	},
	TimetableShiftPositionUpdateShiftGroupsEntityRelationInput:{
		create:"TimetableShiftGroupWithoutPositionCreateInput",
		update:"TimetableShiftPositionUpdateShiftGroupsRelationInput",
		upsert:"TimetableShiftPositionUpsertShiftGroupsRelationInput",
		connect:"TimetableShiftGroupUniqueWhere",
		disconnect:"TimetableShiftGroupUniqueWhere",
		delete:"TimetableShiftGroupUniqueWhere"
	},
	TimetableShiftPositionUpdateShiftGroupsRelationInput:{
		by:"TimetableShiftGroupUniqueWhere",
		data:"TimetableShiftGroupWithoutPositionUpdateInput"
	},
	TimetableShiftGroupWithoutPositionUpdateInput:{
		shifts:"TimetableShiftGroupUpdateShiftsEntityRelationInput",
		day:"TimetableShiftGroupUpdateDayEntityRelationInput",
		type:"TimetableShiftGroupUpdateTypeEntityRelationInput",
		queue:"TimetableShiftGroupUpdateQueueEntityRelationInput",
		generatedByTemplate:"TimetableShiftGroupUpdateGeneratedByTemplateEntityRelationInput"
	},
	TimetableShiftGroupUpdateQueueEntityRelationInput:{
		create:"EmployeeQueueWithoutShiftGroupCreateInput",
		update:"EmployeeQueueWithoutShiftGroupUpdateInput",
		upsert:"TimetableShiftGroupUpsertQueueRelationInput",
		connect:"EmployeeQueueUniqueWhere"
	},
	EmployeeQueueWithoutShiftGroupUpdateInput:{
		items:"EmployeeQueueUpdateItemsEntityRelationInput"
	},
	EmployeeQueueUpdateItemsEntityRelationInput:{
		create:"EmployeeQueueItemWithoutQueueCreateInput",
		update:"EmployeeQueueUpdateItemsRelationInput",
		upsert:"EmployeeQueueUpsertItemsRelationInput",
		connect:"EmployeeQueueItemUniqueWhere",
		disconnect:"EmployeeQueueItemUniqueWhere",
		delete:"EmployeeQueueItemUniqueWhere"
	},
	EmployeeQueueUpdateItemsRelationInput:{
		by:"EmployeeQueueItemUniqueWhere",
		data:"EmployeeQueueItemWithoutQueueUpdateInput"
	},
	EmployeeQueueItemWithoutQueueUpdateInput:{
		shiftsProfile:"EmployeeQueueItemUpdateShiftsProfileEntityRelationInput",
		shift:"EmployeeQueueItemUpdateShiftEntityRelationInput",
		unassignInfo:"EmployeeQueueItemUpdateUnassignInfoEntityRelationInput",
		meta:"EmployeeQueueItemUpdateMetaEntityRelationInput"
	},
	EmployeeQueueItemUpdateShiftsProfileEntityRelationInput:{
		create:"ShiftsProfileWithoutQueueItemsCreateInput",
		update:"ShiftsProfileWithoutQueueItemsUpdateInput",
		upsert:"EmployeeQueueItemUpsertShiftsProfileRelationInput",
		connect:"ShiftsProfileUniqueWhere"
	},
	ShiftsProfileWithoutQueueItemsUpdateInput:{
		staff:"ShiftsProfileUpdateStaffEntityRelationInput",
		roles:"ShiftsProfileUpdateRolesEntityRelationInput",
		shifts:"ShiftsProfileUpdateShiftsEntityRelationInput"
	},
	ShiftsProfileUpdateShiftsEntityRelationInput:{
		create:"TimetableShiftWithoutShiftsProfileCreateInput",
		update:"ShiftsProfileUpdateShiftsRelationInput",
		upsert:"ShiftsProfileUpsertShiftsRelationInput",
		connect:"TimetableShiftUniqueWhere",
		disconnect:"TimetableShiftUniqueWhere",
		delete:"TimetableShiftUniqueWhere"
	},
	ShiftsProfileUpdateShiftsRelationInput:{
		by:"TimetableShiftUniqueWhere",
		data:"TimetableShiftWithoutShiftsProfileUpdateInput"
	},
	TimetableShiftWithoutShiftsProfileUpdateInput:{
		assigned:"Date",
		group:"TimetableShiftUpdateGroupEntityRelationInput",
		queueItem:"TimetableShiftUpdateQueueItemEntityRelationInput",
		swapInfo:"TimetableShiftUpdateSwapInfoEntityRelationInput"
	},
	TimetableShiftUpdateGroupEntityRelationInput:{
		create:"TimetableShiftGroupWithoutShiftsCreateInput",
		update:"TimetableShiftGroupWithoutShiftsUpdateInput",
		upsert:"TimetableShiftUpsertGroupRelationInput",
		connect:"TimetableShiftGroupUniqueWhere"
	},
	TimetableShiftGroupWithoutShiftsUpdateInput:{
		day:"TimetableShiftGroupUpdateDayEntityRelationInput",
		type:"TimetableShiftGroupUpdateTypeEntityRelationInput",
		position:"TimetableShiftGroupUpdatePositionEntityRelationInput",
		queue:"TimetableShiftGroupUpdateQueueEntityRelationInput",
		generatedByTemplate:"TimetableShiftGroupUpdateGeneratedByTemplateEntityRelationInput"
	},
	TimetableShiftGroupUpdatePositionEntityRelationInput:{
		create:"TimetableShiftPositionWithoutShiftGroupsCreateInput",
		update:"TimetableShiftPositionWithoutShiftGroupsUpdateInput",
		upsert:"TimetableShiftGroupUpsertPositionRelationInput",
		connect:"TimetableShiftPositionUniqueWhere"
	},
	TimetableShiftPositionWithoutShiftGroupsUpdateInput:{
		timetableTemplates:"TimetableShiftPositionUpdateTimetableTemplatesEntityRelationInput"
	},
	TimetableShiftPositionUpdateTimetableTemplatesEntityRelationInput:{
		create:"TimetableTemplateWithoutPositionCreateInput",
		update:"TimetableShiftPositionUpdateTimetableTemplatesRelationInput",
		upsert:"TimetableShiftPositionUpsertTimetableTemplatesRelationInput",
		connect:"TimetableTemplateUniqueWhere",
		disconnect:"TimetableTemplateUniqueWhere",
		delete:"TimetableTemplateUniqueWhere"
	},
	TimetableShiftPositionUpdateTimetableTemplatesRelationInput:{
		by:"TimetableTemplateUniqueWhere",
		data:"TimetableTemplateWithoutPositionUpdateInput"
	},
	TimetableTemplateWithoutPositionUpdateInput:{
		startDate:"Date",
		staffOptions:"TimetableTemplateUpdateStaffOptionsEntityRelationInput",
		venue:"TimetableTemplateUpdateVenueEntityRelationInput",
		employeeRole:"TimetableTemplateUpdateEmployeeRoleEntityRelationInput",
		type:"TemplateType"
	},
	TimetableTemplateUpdateStaffOptionsEntityRelationInput:{
		create:"TimetableTemplateStaffOptionsWithoutTimetableTemplateCreateInput",
		update:"TimetableTemplateUpdateStaffOptionsRelationInput",
		upsert:"TimetableTemplateUpsertStaffOptionsRelationInput",
		connect:"TimetableTemplateStaffOptionsUniqueWhere",
		disconnect:"TimetableTemplateStaffOptionsUniqueWhere",
		delete:"TimetableTemplateStaffOptionsUniqueWhere"
	},
	TimetableTemplateUpdateStaffOptionsRelationInput:{
		by:"TimetableTemplateStaffOptionsUniqueWhere",
		data:"TimetableTemplateStaffOptionsWithoutTimetableTemplateUpdateInput"
	},
	TimetableTemplateStaffOptionsWithoutTimetableTemplateUpdateInput:{
		autoAssignedEmployee:"TimetableTemplateStaffOptionsUpdateAutoAssignedEmployeeEntityRelationInput"
	},
	TimetableTemplateStaffOptionsUpdateAutoAssignedEmployeeEntityRelationInput:{
		create:"ShiftsProfileCreateInput",
		update:"ShiftsProfileUpdateInput",
		upsert:"TimetableTemplateStaffOptionsUpsertAutoAssignedEmployeeRelationInput",
		connect:"ShiftsProfileUniqueWhere"
	},
	ShiftsProfileUpdateInput:{
		queueItems:"ShiftsProfileUpdateQueueItemsEntityRelationInput",
		staff:"ShiftsProfileUpdateStaffEntityRelationInput",
		roles:"ShiftsProfileUpdateRolesEntityRelationInput",
		shifts:"ShiftsProfileUpdateShiftsEntityRelationInput"
	},
	TimetableTemplateStaffOptionsUpsertAutoAssignedEmployeeRelationInput:{
		update:"ShiftsProfileUpdateInput",
		create:"ShiftsProfileCreateInput"
	},
	TimetableTemplateUpsertStaffOptionsRelationInput:{
		by:"TimetableTemplateStaffOptionsUniqueWhere",
		update:"TimetableTemplateStaffOptionsWithoutTimetableTemplateUpdateInput",
		create:"TimetableTemplateStaffOptionsWithoutTimetableTemplateCreateInput"
	},
	TimetableTemplateUpdateVenueEntityRelationInput:{
		create:"VenueWithoutTimetableTemplatesCreateInput",
		update:"VenueWithoutTimetableTemplatesUpdateInput",
		upsert:"TimetableTemplateUpsertVenueRelationInput",
		connect:"VenueUniqueWhere"
	},
	VenueWithoutTimetableTemplatesUpdateInput:{
		deadlineTemplate:"VenueUpdateDeadlineTemplateEntityRelationInput",
		timetableDays:"VenueUpdateTimetableDaysEntityRelationInput",
		staffMembers:"VenueUpdateStaffMembersEntityRelationInput",
		employeeRoles:"VenueUpdateEmployeeRolesEntityRelationInput",
		pointOfSaleApplicationDevices:"VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput",
		pointOfSaleTerminals:"VenueUpdatePointOfSaleTerminalsEntityRelationInput",
		pointOfSalePrinters:"VenueUpdatePointOfSalePrintersEntityRelationInput",
		orders:"VenueUpdateOrdersEntityRelationInput",
		fulfillmentNotes:"VenueUpdateFulfillmentNotesEntityRelationInput",
		areas:"VenueUpdateAreasEntityRelationInput",
		enabledUnassignReasons:"VenueUpdateEnabledUnassignReasonsEntityRelationInput",
		categories:"VenueUpdateCategoriesEntityRelationInput",
		channels:"VenueUpdateChannelsEntityRelationInput",
		pointOfSaleInitialView:"PointOfSaleInitialView"
	},
	VenueUpdateStaffMembersEntityRelationInput:{
		create:"StaffWithoutVenuesCreateInput",
		update:"VenueUpdateStaffMembersRelationInput",
		upsert:"VenueUpsertStaffMembersRelationInput",
		connect:"StaffUniqueWhere",
		disconnect:"StaffUniqueWhere",
		delete:"StaffUniqueWhere"
	},
	VenueUpdateStaffMembersRelationInput:{
		by:"StaffUniqueWhere",
		data:"StaffWithoutVenuesUpdateInput"
	},
	StaffWithoutVenuesUpdateInput:{
		bartender:"StaffUpdateBartenderEntityRelationInput",
		courier:"StaffUpdateCourierEntityRelationInput",
		cleaner:"StaffUpdateCleanerEntityRelationInput",
		shiftsManager:"StaffUpdateShiftsManagerEntityRelationInput",
		businessToBusinessManager:"StaffUpdateBusinessToBusinessManagerEntityRelationInput",
		user:"StaffUpdateUserEntityRelationInput",
		shiftsProfile:"StaffUpdateShiftsProfileEntityRelationInput",
		stocksManager:"StaffUpdateStocksManagerEntityRelationInput",
		photo:"StaffUpdatePhotoEntityRelationInput",
		courierManager:"StaffUpdateCourierManagerEntityRelationInput",
		picker:"StaffUpdatePickerEntityRelationInput",
		createdAt:"DateTime",
		remunerationProfile:"StaffUpdateRemunerationProfileEntityRelationInput",
		cashier:"StaffUpdateCashierEntityRelationInput",
		internalBuyer:"StaffUpdateInternalBuyerEntityRelationInput",
		salesManager:"StaffUpdateSalesManagerEntityRelationInput",
		cashierManager:"StaffUpdateCashierManagerEntityRelationInput"
	},
	StaffUpdatePhotoEntityRelationInput:{
		create:"ImageCreateInput",
		update:"ImageUpdateInput",
		upsert:"StaffUpsertPhotoRelationInput",
		connect:"ImageUniqueWhere"
	},
	StaffUpsertPhotoRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	StaffUpdateCourierManagerEntityRelationInput:{
		create:"CourierManagerWithoutStaffCreateInput",
		update:"CourierManagerWithoutStaffUpdateInput",
		upsert:"StaffUpsertCourierManagerRelationInput",
		connect:"CourierManagerUniqueWhere"
	},
	CourierManagerWithoutStaffUpdateInput:{
		createdAt:"DateTime"
	},
	StaffUpsertCourierManagerRelationInput:{
		update:"CourierManagerWithoutStaffUpdateInput",
		create:"CourierManagerWithoutStaffCreateInput"
	},
	StaffUpdatePickerEntityRelationInput:{
		create:"PickerWithoutStaffCreateInput",
		update:"PickerWithoutStaffUpdateInput",
		upsert:"StaffUpsertPickerRelationInput",
		connect:"PickerUniqueWhere"
	},
	PickerWithoutStaffUpdateInput:{
		createdAt:"DateTime"
	},
	StaffUpsertPickerRelationInput:{
		update:"PickerWithoutStaffUpdateInput",
		create:"PickerWithoutStaffCreateInput"
	},
	StaffUpdateRemunerationProfileEntityRelationInput:{
		create:"RemunerationProfileWithoutStaffCreateInput",
		update:"RemunerationProfileWithoutStaffUpdateInput",
		upsert:"StaffUpsertRemunerationProfileRelationInput",
		connect:"RemunerationProfileUniqueWhere"
	},
	RemunerationProfileWithoutStaffUpdateInput:{
		employmentInformation:"RemunerationProfileUpdateEmploymentInformationEntityRelationInput",
		workMonths:"RemunerationProfileUpdateWorkMonthsEntityRelationInput"
	},
	RemunerationProfileUpdateEmploymentInformationEntityRelationInput:{
		create:"EmploymentInformationWithoutRemunerationProfilesCreateInput",
		update:"RemunerationProfileUpdateEmploymentInformationRelationInput",
		upsert:"RemunerationProfileUpsertEmploymentInformationRelationInput",
		connect:"EmploymentInformationUniqueWhere",
		disconnect:"EmploymentInformationUniqueWhere",
		delete:"EmploymentInformationUniqueWhere"
	},
	RemunerationProfileUpdateEmploymentInformationRelationInput:{
		by:"EmploymentInformationUniqueWhere",
		data:"EmploymentInformationWithoutRemunerationProfilesUpdateInput"
	},
	EmploymentInformationWithoutRemunerationProfilesUpdateInput:{
		type:"EmploymentType"
	},
	RemunerationProfileUpsertEmploymentInformationRelationInput:{
		by:"EmploymentInformationUniqueWhere",
		update:"EmploymentInformationWithoutRemunerationProfilesUpdateInput",
		create:"EmploymentInformationWithoutRemunerationProfilesCreateInput"
	},
	RemunerationProfileUpdateWorkMonthsEntityRelationInput:{
		create:"WorkMonthWithoutRemunerationProfileCreateInput",
		update:"WorkMonthWithoutRemunerationProfileUpdateInput",
		upsert:"RemunerationProfileUpsertWorkMonthsRelationInput",
		connect:"WorkMonthUniqueWhere"
	},
	WorkMonthWithoutRemunerationProfileUpdateInput:{

	},
	RemunerationProfileUpsertWorkMonthsRelationInput:{
		update:"WorkMonthWithoutRemunerationProfileUpdateInput",
		create:"WorkMonthWithoutRemunerationProfileCreateInput"
	},
	StaffUpsertRemunerationProfileRelationInput:{
		update:"RemunerationProfileWithoutStaffUpdateInput",
		create:"RemunerationProfileWithoutStaffCreateInput"
	},
	StaffUpdateCashierEntityRelationInput:{
		create:"CashierWithoutStaffCreateInput",
		update:"CashierWithoutStaffUpdateInput",
		upsert:"StaffUpsertCashierRelationInput",
		connect:"CashierUniqueWhere"
	},
	CashierWithoutStaffUpdateInput:{
		createdAt:"DateTime"
	},
	StaffUpsertCashierRelationInput:{
		update:"CashierWithoutStaffUpdateInput",
		create:"CashierWithoutStaffCreateInput"
	},
	StaffUpdateInternalBuyerEntityRelationInput:{
		create:"InternalBuyerWithoutStaffCreateInput",
		update:"InternalBuyerWithoutStaffUpdateInput",
		upsert:"StaffUpsertInternalBuyerRelationInput",
		connect:"InternalBuyerUniqueWhere"
	},
	InternalBuyerWithoutStaffUpdateInput:{
		createdAt:"DateTime"
	},
	StaffUpsertInternalBuyerRelationInput:{
		update:"InternalBuyerWithoutStaffUpdateInput",
		create:"InternalBuyerWithoutStaffCreateInput"
	},
	StaffUpdateSalesManagerEntityRelationInput:{
		create:"SalesManagerWithoutStaffCreateInput",
		update:"SalesManagerWithoutStaffUpdateInput",
		upsert:"StaffUpsertSalesManagerRelationInput",
		connect:"SalesManagerUniqueWhere"
	},
	SalesManagerWithoutStaffUpdateInput:{
		createdAt:"DateTime",
		countries:"SalesManagerUpdateCountriesEntityRelationInput"
	},
	SalesManagerUpdateCountriesEntityRelationInput:{
		create:"CountryCreateInput",
		update:"SalesManagerUpdateCountriesRelationInput",
		upsert:"SalesManagerUpsertCountriesRelationInput",
		connect:"CountryUniqueWhere",
		disconnect:"CountryUniqueWhere",
		delete:"CountryUniqueWhere"
	},
	SalesManagerUpdateCountriesRelationInput:{
		by:"CountryUniqueWhere",
		data:"CountryUpdateInput"
	},
	SalesManagerUpsertCountriesRelationInput:{
		by:"CountryUniqueWhere",
		update:"CountryUpdateInput",
		create:"CountryCreateInput"
	},
	StaffUpsertSalesManagerRelationInput:{
		update:"SalesManagerWithoutStaffUpdateInput",
		create:"SalesManagerWithoutStaffCreateInput"
	},
	StaffUpdateCashierManagerEntityRelationInput:{
		create:"CashierManagerWithoutStaffCreateInput",
		update:"CashierManagerWithoutStaffUpdateInput",
		upsert:"StaffUpsertCashierManagerRelationInput",
		connect:"CashierManagerUniqueWhere"
	},
	CashierManagerWithoutStaffUpdateInput:{
		createdAt:"DateTime"
	},
	StaffUpsertCashierManagerRelationInput:{
		update:"CashierManagerWithoutStaffUpdateInput",
		create:"CashierManagerWithoutStaffCreateInput"
	},
	VenueUpsertStaffMembersRelationInput:{
		by:"StaffUniqueWhere",
		update:"StaffWithoutVenuesUpdateInput",
		create:"StaffWithoutVenuesCreateInput"
	},
	VenueUpdateEmployeeRolesEntityRelationInput:{
		create:"VenueEmployeeRoleWithoutVenueCreateInput",
		update:"VenueUpdateEmployeeRolesRelationInput",
		upsert:"VenueUpsertEmployeeRolesRelationInput",
		connect:"VenueEmployeeRoleUniqueWhere",
		disconnect:"VenueEmployeeRoleUniqueWhere",
		delete:"VenueEmployeeRoleUniqueWhere"
	},
	VenueUpdateEmployeeRolesRelationInput:{
		by:"VenueEmployeeRoleUniqueWhere",
		data:"VenueEmployeeRoleWithoutVenueUpdateInput"
	},
	VenueEmployeeRoleWithoutVenueUpdateInput:{
		employeePrivileges:"VenueEmployeeRoleUpdateEmployeePrivilegesEntityRelationInput",
		role:"VenueEmployeeRoleUpdateRoleEntityRelationInput"
	},
	VenueEmployeeRoleUpdateEmployeePrivilegesEntityRelationInput:{
		create:"TimetablesEmployeePrivilegesWithoutVenueEmployeeRoleCreateInput",
		update:"TimetablesEmployeePrivilegesWithoutVenueEmployeeRoleUpdateInput",
		upsert:"VenueEmployeeRoleUpsertEmployeePrivilegesRelationInput",
		connect:"TimetablesEmployeePrivilegesUniqueWhere"
	},
	TimetablesEmployeePrivilegesWithoutVenueEmployeeRoleUpdateInput:{

	},
	VenueEmployeeRoleUpsertEmployeePrivilegesRelationInput:{
		update:"TimetablesEmployeePrivilegesWithoutVenueEmployeeRoleUpdateInput",
		create:"TimetablesEmployeePrivilegesWithoutVenueEmployeeRoleCreateInput"
	},
	VenueEmployeeRoleUpdateRoleEntityRelationInput:{
		create:"TimetableEmployeeRoleCreateInput",
		update:"TimetableEmployeeRoleUpdateInput",
		upsert:"VenueEmployeeRoleUpsertRoleRelationInput",
		connect:"TimetableEmployeeRoleUniqueWhere"
	},
	VenueEmployeeRoleUpsertRoleRelationInput:{
		update:"TimetableEmployeeRoleUpdateInput",
		create:"TimetableEmployeeRoleCreateInput"
	},
	VenueUpsertEmployeeRolesRelationInput:{
		by:"VenueEmployeeRoleUniqueWhere",
		update:"VenueEmployeeRoleWithoutVenueUpdateInput",
		create:"VenueEmployeeRoleWithoutVenueCreateInput"
	},
	VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput:{
		create:"PointOfSaleApplicationDeviceWithoutVenueCreateInput",
		update:"VenueUpdatePointOfSaleApplicationDevicesRelationInput",
		upsert:"VenueUpsertPointOfSaleApplicationDevicesRelationInput",
		connect:"PointOfSaleApplicationDeviceUniqueWhere",
		disconnect:"PointOfSaleApplicationDeviceUniqueWhere",
		delete:"PointOfSaleApplicationDeviceUniqueWhere"
	},
	VenueUpdatePointOfSaleApplicationDevicesRelationInput:{
		by:"PointOfSaleApplicationDeviceUniqueWhere",
		data:"PointOfSaleApplicationDeviceWithoutVenueUpdateInput"
	},
	PointOfSaleApplicationDeviceWithoutVenueUpdateInput:{
		identificationCode:"PointOfSaleApplicationDeviceUpdateIdentificationCodeEntityRelationInput",
		identifier:"PointOfSaleApplicationDeviceUpdateIdentifierEntityRelationInput",
		terminal:"PointOfSaleApplicationDeviceUpdateTerminalEntityRelationInput",
		receiptPrinter:"PointOfSaleApplicationDeviceUpdateReceiptPrinterEntityRelationInput",
		ticketPrinters:"PointOfSaleApplicationDeviceUpdateTicketPrintersEntityRelationInput"
	},
	PointOfSaleApplicationDeviceUpdateIdentificationCodeEntityRelationInput:{
		create:"IdentificationCodeWithoutApplicationDevicesCreateInput",
		update:"IdentificationCodeWithoutApplicationDevicesUpdateInput",
		upsert:"PointOfSaleApplicationDeviceUpsertIdentificationCodeRelationInput",
		connect:"IdentificationCodeUniqueWhere"
	},
	IdentificationCodeWithoutApplicationDevicesUpdateInput:{
		createdAt:"DateTime",
		attempts:"IdentificationCodeUpdateAttemptsEntityRelationInput",
		locales:"IdentificationCodeUpdateLocalesEntityRelationInput"
	},
	IdentificationCodeUpdateAttemptsEntityRelationInput:{
		create:"IdentificationAttemptWithoutCodeCreateInput",
		update:"IdentificationCodeUpdateAttemptsRelationInput",
		upsert:"IdentificationCodeUpsertAttemptsRelationInput",
		connect:"IdentificationAttemptUniqueWhere",
		disconnect:"IdentificationAttemptUniqueWhere",
		delete:"IdentificationAttemptUniqueWhere"
	},
	IdentificationCodeUpdateAttemptsRelationInput:{
		by:"IdentificationAttemptUniqueWhere",
		data:"IdentificationAttemptWithoutCodeUpdateInput"
	},
	IdentificationAttemptWithoutCodeUpdateInput:{
		createdAt:"DateTime",
		user:"IdentificationAttemptUpdateUserEntityRelationInput"
	},
	IdentificationAttemptUpdateUserEntityRelationInput:{
		create:"UserWithoutIdentificationAttemptsCreateInput",
		update:"UserWithoutIdentificationAttemptsUpdateInput",
		upsert:"IdentificationAttemptUpsertUserRelationInput",
		connect:"UserUniqueWhere"
	},
	UserWithoutIdentificationAttemptsUpdateInput:{
		staff:"UserUpdateStaffEntityRelationInput",
		customer:"UserUpdateCustomerEntityRelationInput",
		tenantPersonId:"UUID",
		disabledAt:"DateTime",
		devices:"UserUpdateDevicesEntityRelationInput",
		verifiedAt:"DateTime",
		createdAt:"DateTime",
		deletionRequestedAt:"DateTime",
		deletionExpectedAt:"DateTime",
		deletedAt:"DateTime",
		meta:"UserUpdateMetaEntityRelationInput",
		roles:"UserUpdateRolesEntityRelationInput"
	},
	UserUpdateDevicesEntityRelationInput:{
		create:"UserDeviceWithoutUserCreateInput",
		update:"UserUpdateDevicesRelationInput",
		upsert:"UserUpsertDevicesRelationInput",
		connect:"UserDeviceUniqueWhere",
		disconnect:"UserDeviceUniqueWhere",
		delete:"UserDeviceUniqueWhere"
	},
	UserUpdateDevicesRelationInput:{
		by:"UserDeviceUniqueWhere",
		data:"UserDeviceWithoutUserUpdateInput"
	},
	UserDeviceWithoutUserUpdateInput:{
		createdAt:"DateTime",
		lastActiveAt:"DateTime",
		anonymousSession:"UserDeviceUpdateAnonymousSessionEntityRelationInput"
	},
	UserDeviceUpdateAnonymousSessionEntityRelationInput:{
		create:"AnonymousSessionWithoutDevicesCreateInput",
		update:"AnonymousSessionWithoutDevicesUpdateInput",
		upsert:"UserDeviceUpsertAnonymousSessionRelationInput",
		connect:"AnonymousSessionUniqueWhere"
	},
	AnonymousSessionWithoutDevicesUpdateInput:{
		createdAt:"DateTime",
		lastActiveAt:"DateTime",
		customer:"AnonymousSessionUpdateCustomerEntityRelationInput"
	},
	AnonymousSessionUpdateCustomerEntityRelationInput:{
		create:"CustomerWithoutAnonymousSessionCreateInput",
		update:"CustomerWithoutAnonymousSessionUpdateInput",
		upsert:"AnonymousSessionUpsertCustomerRelationInput",
		connect:"CustomerUniqueWhere"
	},
	CustomerWithoutAnonymousSessionUpdateInput:{
		addresses:"CustomerUpdateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerUpdateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerUpdateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerUpdateTagsEntityRelationInput",
		credits:"CustomerUpdateCreditsEntityRelationInput",
		paymentMethods:"CustomerUpdatePaymentMethodsEntityRelationInput",
		orders:"CustomerUpdateOrdersEntityRelationInput",
		permissions:"CustomerUpdatePermissionsEntityRelationInput",
		group:"CustomerUpdateGroupEntityRelationInput",
		photo:"CustomerUpdatePhotoEntityRelationInput",
		name:"CustomerUpdateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerUpdateIngredientRatingsEntityRelationInput",
		business:"CustomerUpdateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerUpdateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerUpdateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerUpdateCartsEntityRelationInput",
		shortcutList:"CustomerUpdateShortcutListEntityRelationInput",
		user:"CustomerUpdateUserEntityRelationInput",
		channels:"CustomerUpdateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerUpdateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerUpdateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerUpdateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerUpdateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerUpdateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerUpdateDefaultBillingSubjectEntityRelationInput",
		boughtVouchers:"CustomerUpdateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerUpdateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerUpdateRedeemedVouchersEntityRelationInput",
		spending:"CustomerUpdateSpendingEntityRelationInput",
		customerTabs:"CustomerUpdateCustomerTabsEntityRelationInput",
		lead:"CustomerUpdateLeadEntityRelationInput",
		meta:"CustomerUpdateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerUpdateInvoicesEntityRelationInput:{
		create:"InvoiceWithoutCustomerCreateInput",
		update:"CustomerUpdateInvoicesRelationInput",
		upsert:"CustomerUpsertInvoicesRelationInput",
		connect:"InvoiceUniqueWhere",
		disconnect:"InvoiceUniqueWhere",
		delete:"InvoiceUniqueWhere"
	},
	CustomerUpdateInvoicesRelationInput:{
		by:"InvoiceUniqueWhere",
		data:"InvoiceWithoutCustomerUpdateInput"
	},
	InvoiceWithoutCustomerUpdateInput:{
		createdAt:"DateTime",
		orderPayments:"InvoiceUpdateOrderPaymentsEntityRelationInput",
		address:"InvoiceUpdateAddressEntityRelationInput",
		billingSubject:"InvoiceUpdateBillingSubjectEntityRelationInput"
	},
	InvoiceUpdateOrderPaymentsEntityRelationInput:{
		create:"OrderPaymentWithoutInvoiceCreateInput",
		update:"InvoiceUpdateOrderPaymentsRelationInput",
		upsert:"InvoiceUpsertOrderPaymentsRelationInput",
		connect:"OrderPaymentUniqueWhere",
		disconnect:"OrderPaymentUniqueWhere",
		delete:"OrderPaymentUniqueWhere"
	},
	InvoiceUpdateOrderPaymentsRelationInput:{
		by:"OrderPaymentUniqueWhere",
		data:"OrderPaymentWithoutInvoiceUpdateInput"
	},
	OrderPaymentWithoutInvoiceUpdateInput:{
		data:"Json",
		method:"OrderPaymentUpdateMethodEntityRelationInput",
		failedAt:"DateTime",
		state:"OrderPaymentState",
		approvedAt:"DateTime",
		events:"OrderPaymentUpdateEventsEntityRelationInput",
		order:"OrderPaymentUpdateOrderEntityRelationInput",
		createdAt:"DateTime",
		vatRate:"OrderPaymentUpdateVatRateEntityRelationInput",
		meta:"OrderPaymentUpdateMetaEntityRelationInput"
	},
	OrderPaymentUpdateMethodEntityRelationInput:{
		create:"PaymentMethodCreateInput",
		update:"PaymentMethodUpdateInput",
		upsert:"OrderPaymentUpsertMethodRelationInput",
		connect:"PaymentMethodUniqueWhere"
	},
	OrderPaymentUpsertMethodRelationInput:{
		update:"PaymentMethodUpdateInput",
		create:"PaymentMethodCreateInput"
	},
	OrderPaymentUpdateEventsEntityRelationInput:{
		create:"OrderEventWithoutPaymentCreateInput",
		update:"OrderPaymentUpdateEventsRelationInput",
		upsert:"OrderPaymentUpsertEventsRelationInput",
		connect:"OrderEventUniqueWhere",
		disconnect:"OrderEventUniqueWhere",
		delete:"OrderEventUniqueWhere"
	},
	OrderPaymentUpdateEventsRelationInput:{
		by:"OrderEventUniqueWhere",
		data:"OrderEventWithoutPaymentUpdateInput"
	},
	OrderEventWithoutPaymentUpdateInput:{
		createdAt:"DateTime",
		order:"OrderEventUpdateOrderEntityRelationInput",
		delivery:"OrderEventUpdateDeliveryEntityRelationInput"
	},
	OrderEventUpdateOrderEntityRelationInput:{
		create:"OrderWithoutEventsCreateInput",
		update:"OrderWithoutEventsUpdateInput",
		upsert:"OrderEventUpsertOrderRelationInput",
		connect:"OrderUniqueWhere"
	},
	OrderWithoutEventsUpdateInput:{
		state:"OrderState",
		fulfilledAt:"DateTime",
		canceledAt:"DateTime",
		customer:"OrderUpdateCustomerEntityRelationInput",
		channel:"OrderUpdateChannelEntityRelationInput",
		discounts:"OrderUpdateDiscountsEntityRelationInput",
		delivery:"OrderUpdateDeliveryEntityRelationInput",
		items:"OrderUpdateItemsEntityRelationInput",
		cart:"OrderUpdateCartEntityRelationInput",
		createdAt:"DateTime",
		billingAddress:"OrderUpdateBillingAddressEntityRelationInput",
		priceLines:"OrderUpdatePriceLinesEntityRelationInput",
		payments:"OrderUpdatePaymentsEntityRelationInput",
		billingSubject:"OrderUpdateBillingSubjectEntityRelationInput",
		summary:"OrderUpdateSummaryEntityRelationInput",
		gratuity:"OrderUpdateGratuityEntityRelationInput",
		venue:"OrderUpdateVenueEntityRelationInput",
		fulfillmentNotes:"OrderUpdateFulfillmentNotesEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	OrderUpdateDeliveryEntityRelationInput:{
		create:"OrderDeliveryWithoutOrderCreateInput",
		update:"OrderDeliveryWithoutOrderUpdateInput",
		upsert:"OrderUpsertDeliveryRelationInput",
		connect:"OrderDeliveryUniqueWhere"
	},
	OrderDeliveryWithoutOrderUpdateInput:{
		deliveredAt:"DateTime",
		method:"OrderDeliveryUpdateMethodEntityRelationInput",
		vatRate:"OrderDeliveryUpdateVatRateEntityRelationInput",
		expectedAt:"DateTime",
		state:"OrderDeliveryState",
		dispatchAt:"DateTime",
		expectedEndAt:"DateTime",
		processingAt:"DateTime",
		deliveringAt:"DateTime",
		failedAt:"DateTime",
		deliveryWaypoint:"OrderDeliveryUpdateDeliveryWaypointEntityRelationInput",
		events:"OrderDeliveryUpdateEventsEntityRelationInput",
		prepareAt:"DateTime",
		liftagoRide:"OrderDeliveryUpdateLiftagoRideEntityRelationInput",
		pickedAt:"DateTime",
		address:"OrderDeliveryUpdateAddressEntityRelationInput",
		woltDriveDelivery:"OrderDeliveryUpdateWoltDriveDeliveryEntityRelationInput"
	},
	OrderDeliveryUpdateVatRateEntityRelationInput:{
		create:"VatRateCreateInput",
		update:"VatRateUpdateInput",
		upsert:"OrderDeliveryUpsertVatRateRelationInput",
		connect:"VatRateUniqueWhere"
	},
	OrderDeliveryUpsertVatRateRelationInput:{
		update:"VatRateUpdateInput",
		create:"VatRateCreateInput"
	},
	OrderDeliveryUpdateDeliveryWaypointEntityRelationInput:{
		create:"DeliveryWaypointWithoutDeliveryCreateInput",
		update:"DeliveryWaypointWithoutDeliveryUpdateInput",
		upsert:"OrderDeliveryUpsertDeliveryWaypointRelationInput",
		connect:"DeliveryWaypointUniqueWhere"
	},
	DeliveryWaypointWithoutDeliveryUpdateInput:{
		estimatedArrival:"DateTime",
		route:"DeliveryWaypointUpdateRouteEntityRelationInput",
		originDeparture:"DateTime"
	},
	DeliveryWaypointUpdateRouteEntityRelationInput:{
		create:"DeliveryRouteWithoutWaypointsCreateInput",
		update:"DeliveryRouteWithoutWaypointsUpdateInput",
		upsert:"DeliveryWaypointUpsertRouteRelationInput",
		connect:"DeliveryRouteUniqueWhere"
	},
	DeliveryRouteWithoutWaypointsUpdateInput:{
		courier:"DeliveryRouteUpdateCourierEntityRelationInput",
		createdAt:"DateTime"
	},
	DeliveryRouteUpdateCourierEntityRelationInput:{
		create:"CourierWithoutRoutesCreateInput",
		update:"CourierWithoutRoutesUpdateInput",
		upsert:"DeliveryRouteUpsertCourierRelationInput",
		connect:"CourierUniqueWhere"
	},
	CourierWithoutRoutesUpdateInput:{
		staff:"CourierUpdateStaffEntityRelationInput",
		createdAt:"DateTime",
		deliveryMethods:"CourierUpdateDeliveryMethodsEntityRelationInput"
	},
	CourierUpdateDeliveryMethodsEntityRelationInput:{
		create:"DeliveryMethodWithoutCourierHandlersCreateInput",
		update:"CourierUpdateDeliveryMethodsRelationInput",
		upsert:"CourierUpsertDeliveryMethodsRelationInput",
		connect:"DeliveryMethodUniqueWhere",
		disconnect:"DeliveryMethodUniqueWhere",
		delete:"DeliveryMethodUniqueWhere"
	},
	CourierUpdateDeliveryMethodsRelationInput:{
		by:"DeliveryMethodUniqueWhere",
		data:"DeliveryMethodWithoutCourierHandlersUpdateInput"
	},
	DeliveryMethodWithoutCourierHandlersUpdateInput:{
		paymentMethods:"DeliveryMethodUpdatePaymentMethodsEntityRelationInput",
		suitableForDeliveryZones:"DeliveryMethodUpdateSuitableForDeliveryZonesEntityRelationInput",
		channels:"DeliveryMethodUpdateChannelsEntityRelationInput",
		locales:"DeliveryMethodUpdateLocalesEntityRelationInput",
		timelinePreset:"DeliveryMethodUpdateTimelinePresetEntityRelationInput"
	},
	DeliveryMethodUpdateLocalesEntityRelationInput:{
		create:"DeliveryMethodLocaleWithoutRootCreateInput",
		update:"DeliveryMethodUpdateLocalesRelationInput",
		upsert:"DeliveryMethodUpsertLocalesRelationInput",
		connect:"DeliveryMethodLocaleUniqueWhere",
		disconnect:"DeliveryMethodLocaleUniqueWhere",
		delete:"DeliveryMethodLocaleUniqueWhere"
	},
	DeliveryMethodUpdateLocalesRelationInput:{
		by:"DeliveryMethodLocaleUniqueWhere",
		data:"DeliveryMethodLocaleWithoutRootUpdateInput"
	},
	DeliveryMethodLocaleWithoutRootUpdateInput:{
		locale:"DeliveryMethodLocaleUpdateLocaleEntityRelationInput"
	},
	DeliveryMethodLocaleUpdateLocaleEntityRelationInput:{
		create:"LocaleWithoutDeliveryMethodsCreateInput",
		update:"LocaleWithoutDeliveryMethodsUpdateInput",
		upsert:"DeliveryMethodLocaleUpsertLocaleRelationInput",
		connect:"LocaleUniqueWhere"
	},
	LocaleWithoutDeliveryMethodsUpdateInput:{
		businessCategories:"LocaleUpdateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleUpdateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleUpdateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleUpdateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleUpdateBlogsEntityRelationInput",
		blogPosts:"LocaleUpdateBlogPostsEntityRelationInput",
		identifier:"LocaleUpdateIdentifierEntityRelationInput",
		menus:"LocaleUpdateMenusEntityRelationInput",
		pages:"LocaleUpdatePagesEntityRelationInput",
		productIngredientCategories:"LocaleUpdateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleUpdateAllergensEntityRelationInput",
		productPackings:"LocaleUpdateProductPackingsEntityRelationInput",
		products:"LocaleUpdateProductsEntityRelationInput",
		productRecipes:"LocaleUpdateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleUpdatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput",
		ingredientSuppliers:"LocaleUpdateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleUpdateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleUpdatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleUpdateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleUpdateBusinessServicesEntityRelationInput"
	},
	LocaleUpdateProductPackingsEntityRelationInput:{
		create:"ProductPackingLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateProductPackingsRelationInput",
		upsert:"LocaleUpsertProductPackingsRelationInput",
		connect:"ProductPackingLocaleUniqueWhere",
		disconnect:"ProductPackingLocaleUniqueWhere",
		delete:"ProductPackingLocaleUniqueWhere"
	},
	LocaleUpdateProductPackingsRelationInput:{
		by:"ProductPackingLocaleUniqueWhere",
		data:"ProductPackingLocaleWithoutLocaleUpdateInput"
	},
	ProductPackingLocaleWithoutLocaleUpdateInput:{
		root:"ProductPackingLocaleUpdateRootEntityRelationInput"
	},
	ProductPackingLocaleUpdateRootEntityRelationInput:{
		create:"ProductPackingWithoutLocalesCreateInput",
		update:"ProductPackingWithoutLocalesUpdateInput",
		upsert:"ProductPackingLocaleUpsertRootRelationInput",
		connect:"ProductPackingUniqueWhere"
	},
	ProductPackingWithoutLocalesUpdateInput:{
		image:"ProductPackingUpdateImageEntityRelationInput",
		icon:"ProductPackingUpdateIconEntityRelationInput",
		preparedPackingQuantities:"ProductPackingUpdatePreparedPackingQuantitiesEntityRelationInput"
	},
	ProductPackingUpdatePreparedPackingQuantitiesEntityRelationInput:{
		create:"PreparedPackingQuantityWithoutPackingCreateInput",
		update:"ProductPackingUpdatePreparedPackingQuantitiesRelationInput",
		upsert:"ProductPackingUpsertPreparedPackingQuantitiesRelationInput",
		connect:"PreparedPackingQuantityUniqueWhere",
		disconnect:"PreparedPackingQuantityUniqueWhere",
		delete:"PreparedPackingQuantityUniqueWhere"
	},
	ProductPackingUpdatePreparedPackingQuantitiesRelationInput:{
		by:"PreparedPackingQuantityUniqueWhere",
		data:"PreparedPackingQuantityWithoutPackingUpdateInput"
	},
	PreparedPackingQuantityWithoutPackingUpdateInput:{
		date:"Date",
		recipe:"PreparedPackingQuantityUpdateRecipeEntityRelationInput"
	},
	PreparedPackingQuantityUpdateRecipeEntityRelationInput:{
		create:"ProductRecipeCreateInput",
		update:"ProductRecipeUpdateInput",
		upsert:"PreparedPackingQuantityUpsertRecipeRelationInput",
		connect:"ProductRecipeUniqueWhere"
	},
	ProductRecipeUpdateInput:{
		products:"ProductRecipeUpdateProductsEntityRelationInput",
		image:"ProductRecipeUpdateImageEntityRelationInput",
		icon:"ProductRecipeUpdateIconEntityRelationInput",
		ingredients:"ProductRecipeUpdateIngredientsEntityRelationInput",
		locales:"ProductRecipeUpdateLocalesEntityRelationInput",
		freshingContainer:"ProductRecipeUpdateFreshingContainerEntityRelationInput",
		nutritionFacts:"ProductRecipeUpdateNutritionFactsEntityRelationInput"
	},
	ProductRecipeUpdateProductsEntityRelationInput:{
		create:"ProductWithoutRecipeCreateInput",
		update:"ProductRecipeUpdateProductsRelationInput",
		upsert:"ProductRecipeUpsertProductsRelationInput",
		connect:"ProductUniqueWhere",
		disconnect:"ProductUniqueWhere",
		delete:"ProductUniqueWhere"
	},
	ProductRecipeUpdateProductsRelationInput:{
		by:"ProductUniqueWhere",
		data:"ProductWithoutRecipeUpdateInput"
	},
	ProductWithoutRecipeUpdateInput:{
		packing:"ProductUpdatePackingEntityRelationInput",
		tags:"ProductUpdateTagsEntityRelationInput",
		categories:"ProductUpdateCategoriesEntityRelationInput",
		vatRate:"ProductUpdateVatRateEntityRelationInput",
		stocks:"ProductUpdateStocksEntityRelationInput",
		groupPrices:"ProductUpdateGroupPricesEntityRelationInput",
		image:"ProductUpdateImageEntityRelationInput",
		cartItems:"ProductUpdateCartItemsEntityRelationInput",
		availability:"ProductAvailability",
		manager:"ProductUpdateManagerEntityRelationInput",
		orderItems:"ProductUpdateOrderItemsEntityRelationInput",
		inheritedCategories:"ProductUpdateInheritedCategoriesEntityRelationInput",
		deliveryZones:"ProductUpdateDeliveryZonesEntityRelationInput",
		locales:"ProductUpdateLocalesEntityRelationInput",
		archivedAt:"DateTime",
		customerPrices:"ProductUpdateCustomerPricesEntityRelationInput",
		virtualProduct:"ProductUpdateVirtualProductEntityRelationInput",
		meta:"ProductUpdateMetaEntityRelationInput",
		page:"ProductUpdatePageEntityRelationInput",
		salesDays:"ProductUpdateSalesDaysEntityRelationInput",
		salesWeeks:"ProductUpdateSalesWeeksEntityRelationInput",
		salesMonths:"ProductUpdateSalesMonthsEntityRelationInput",
		fulfillmentNotes:"ProductUpdateFulfillmentNotesEntityRelationInput"
	},
	ProductUpdateLocalesEntityRelationInput:{
		create:"ProductLocaleWithoutRootCreateInput",
		update:"ProductUpdateLocalesRelationInput",
		upsert:"ProductUpsertLocalesRelationInput",
		connect:"ProductLocaleUniqueWhere",
		disconnect:"ProductLocaleUniqueWhere",
		delete:"ProductLocaleUniqueWhere"
	},
	ProductUpdateLocalesRelationInput:{
		by:"ProductLocaleUniqueWhere",
		data:"ProductLocaleWithoutRootUpdateInput"
	},
	ProductLocaleWithoutRootUpdateInput:{
		locale:"ProductLocaleUpdateLocaleEntityRelationInput",
		featureList:"ProductLocaleUpdateFeatureListEntityRelationInput"
	},
	ProductLocaleUpdateLocaleEntityRelationInput:{
		create:"LocaleWithoutProductsCreateInput",
		update:"LocaleWithoutProductsUpdateInput",
		upsert:"ProductLocaleUpsertLocaleRelationInput",
		connect:"LocaleUniqueWhere"
	},
	LocaleWithoutProductsUpdateInput:{
		businessCategories:"LocaleUpdateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleUpdateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleUpdateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleUpdateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleUpdateBlogsEntityRelationInput",
		blogPosts:"LocaleUpdateBlogPostsEntityRelationInput",
		identifier:"LocaleUpdateIdentifierEntityRelationInput",
		menus:"LocaleUpdateMenusEntityRelationInput",
		pages:"LocaleUpdatePagesEntityRelationInput",
		productIngredientCategories:"LocaleUpdateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleUpdateAllergensEntityRelationInput",
		productPackings:"LocaleUpdateProductPackingsEntityRelationInput",
		productRecipes:"LocaleUpdateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleUpdatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleUpdateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleUpdateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleUpdateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleUpdatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleUpdateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleUpdateBusinessServicesEntityRelationInput"
	},
	LocaleUpdateProductRecipesEntityRelationInput:{
		create:"ProductRecipeLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateProductRecipesRelationInput",
		upsert:"LocaleUpsertProductRecipesRelationInput",
		connect:"ProductRecipeLocaleUniqueWhere",
		disconnect:"ProductRecipeLocaleUniqueWhere",
		delete:"ProductRecipeLocaleUniqueWhere"
	},
	LocaleUpdateProductRecipesRelationInput:{
		by:"ProductRecipeLocaleUniqueWhere",
		data:"ProductRecipeLocaleWithoutLocaleUpdateInput"
	},
	ProductRecipeLocaleWithoutLocaleUpdateInput:{
		root:"ProductRecipeLocaleUpdateRootEntityRelationInput"
	},
	ProductRecipeLocaleUpdateRootEntityRelationInput:{
		create:"ProductRecipeWithoutLocalesCreateInput",
		update:"ProductRecipeWithoutLocalesUpdateInput",
		upsert:"ProductRecipeLocaleUpsertRootRelationInput",
		connect:"ProductRecipeUniqueWhere"
	},
	ProductRecipeWithoutLocalesUpdateInput:{
		products:"ProductRecipeUpdateProductsEntityRelationInput",
		image:"ProductRecipeUpdateImageEntityRelationInput",
		icon:"ProductRecipeUpdateIconEntityRelationInput",
		ingredients:"ProductRecipeUpdateIngredientsEntityRelationInput",
		freshingContainer:"ProductRecipeUpdateFreshingContainerEntityRelationInput",
		nutritionFacts:"ProductRecipeUpdateNutritionFactsEntityRelationInput"
	},
	ProductRecipeUpdateFreshingContainerEntityRelationInput:{
		create:"FreshingContainerCreateInput",
		update:"FreshingContainerUpdateInput",
		upsert:"ProductRecipeUpsertFreshingContainerRelationInput",
		connect:"FreshingContainerUniqueWhere"
	},
	ProductRecipeUpsertFreshingContainerRelationInput:{
		update:"FreshingContainerUpdateInput",
		create:"FreshingContainerCreateInput"
	},
	ProductRecipeUpdateNutritionFactsEntityRelationInput:{
		create:"NutritionFactsCreateInput",
		update:"NutritionFactsUpdateInput",
		upsert:"ProductRecipeUpsertNutritionFactsRelationInput",
		connect:"NutritionFactsUniqueWhere"
	},
	NutritionFactsUpdateInput:{

	},
	ProductRecipeUpsertNutritionFactsRelationInput:{
		update:"NutritionFactsUpdateInput",
		create:"NutritionFactsCreateInput"
	},
	ProductRecipeLocaleUpsertRootRelationInput:{
		update:"ProductRecipeWithoutLocalesUpdateInput",
		create:"ProductRecipeWithoutLocalesCreateInput"
	},
	LocaleUpsertProductRecipesRelationInput:{
		by:"ProductRecipeLocaleUniqueWhere",
		update:"ProductRecipeLocaleWithoutLocaleUpdateInput",
		create:"ProductRecipeLocaleWithoutLocaleCreateInput"
	},
	LocaleUpdatePointOfSaleCategoriesEntityRelationInput:{
		create:"PointOfSaleCategoryLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdatePointOfSaleCategoriesRelationInput",
		upsert:"LocaleUpsertPointOfSaleCategoriesRelationInput",
		connect:"PointOfSaleCategoryLocaleUniqueWhere",
		disconnect:"PointOfSaleCategoryLocaleUniqueWhere",
		delete:"PointOfSaleCategoryLocaleUniqueWhere"
	},
	LocaleUpdatePointOfSaleCategoriesRelationInput:{
		by:"PointOfSaleCategoryLocaleUniqueWhere",
		data:"PointOfSaleCategoryLocaleWithoutLocaleUpdateInput"
	},
	PointOfSaleCategoryLocaleWithoutLocaleUpdateInput:{
		root:"PointOfSaleCategoryLocaleUpdateRootEntityRelationInput"
	},
	PointOfSaleCategoryLocaleUpdateRootEntityRelationInput:{
		create:"PointOfSaleCategoryWithoutLocalesCreateInput",
		update:"PointOfSaleCategoryWithoutLocalesUpdateInput",
		upsert:"PointOfSaleCategoryLocaleUpsertRootRelationInput",
		connect:"PointOfSaleCategoryUniqueWhere"
	},
	PointOfSaleCategoryWithoutLocalesUpdateInput:{
		products:"PointOfSaleCategoryUpdateProductsEntityRelationInput",
		category:"PointOfSaleCategoryUpdateCategoryEntityRelationInput",
		venue:"PointOfSaleCategoryUpdateVenueEntityRelationInput",
		ticketPrinters:"PointOfSaleCategoryUpdateTicketPrintersEntityRelationInput"
	},
	PointOfSaleCategoryUpdateProductsEntityRelationInput:{
		create:"PointOfSaleCategoryProductWithoutCategoryCreateInput",
		update:"PointOfSaleCategoryUpdateProductsRelationInput",
		upsert:"PointOfSaleCategoryUpsertProductsRelationInput",
		connect:"PointOfSaleCategoryProductUniqueWhere",
		disconnect:"PointOfSaleCategoryProductUniqueWhere",
		delete:"PointOfSaleCategoryProductUniqueWhere"
	},
	PointOfSaleCategoryUpdateProductsRelationInput:{
		by:"PointOfSaleCategoryProductUniqueWhere",
		data:"PointOfSaleCategoryProductWithoutCategoryUpdateInput"
	},
	PointOfSaleCategoryProductWithoutCategoryUpdateInput:{
		product:"PointOfSaleCategoryProductUpdateProductEntityRelationInput",
		locales:"PointOfSaleCategoryProductUpdateLocalesEntityRelationInput"
	},
	PointOfSaleCategoryProductUpdateProductEntityRelationInput:{
		create:"ProductCreateInput",
		update:"ProductUpdateInput",
		upsert:"PointOfSaleCategoryProductUpsertProductRelationInput",
		connect:"ProductUniqueWhere"
	},
	ProductUpdateInput:{
		packing:"ProductUpdatePackingEntityRelationInput",
		recipe:"ProductUpdateRecipeEntityRelationInput",
		tags:"ProductUpdateTagsEntityRelationInput",
		categories:"ProductUpdateCategoriesEntityRelationInput",
		vatRate:"ProductUpdateVatRateEntityRelationInput",
		stocks:"ProductUpdateStocksEntityRelationInput",
		groupPrices:"ProductUpdateGroupPricesEntityRelationInput",
		image:"ProductUpdateImageEntityRelationInput",
		cartItems:"ProductUpdateCartItemsEntityRelationInput",
		availability:"ProductAvailability",
		manager:"ProductUpdateManagerEntityRelationInput",
		orderItems:"ProductUpdateOrderItemsEntityRelationInput",
		inheritedCategories:"ProductUpdateInheritedCategoriesEntityRelationInput",
		deliveryZones:"ProductUpdateDeliveryZonesEntityRelationInput",
		locales:"ProductUpdateLocalesEntityRelationInput",
		archivedAt:"DateTime",
		customerPrices:"ProductUpdateCustomerPricesEntityRelationInput",
		virtualProduct:"ProductUpdateVirtualProductEntityRelationInput",
		meta:"ProductUpdateMetaEntityRelationInput",
		page:"ProductUpdatePageEntityRelationInput",
		salesDays:"ProductUpdateSalesDaysEntityRelationInput",
		salesWeeks:"ProductUpdateSalesWeeksEntityRelationInput",
		salesMonths:"ProductUpdateSalesMonthsEntityRelationInput",
		fulfillmentNotes:"ProductUpdateFulfillmentNotesEntityRelationInput"
	},
	ProductUpdateCustomerPricesEntityRelationInput:{
		connect:"ProductCustomerPriceUniqueWhere",
		disconnect:"ProductCustomerPriceUniqueWhere",
		delete:"ProductCustomerPriceUniqueWhere"
	},
	ProductUpdateVirtualProductEntityRelationInput:{
		create:"VirtualProductWithoutProductCreateInput",
		update:"VirtualProductWithoutProductUpdateInput",
		upsert:"ProductUpsertVirtualProductRelationInput",
		connect:"VirtualProductUniqueWhere"
	},
	VirtualProductWithoutProductUpdateInput:{
		type:"VirtualProductType",
		physicalRepresentation:"VirtualProductPhysicalRepresentationType"
	},
	ProductUpsertVirtualProductRelationInput:{
		update:"VirtualProductWithoutProductUpdateInput",
		create:"VirtualProductWithoutProductCreateInput"
	},
	ProductUpdateMetaEntityRelationInput:{
		connect:"ProductMetadataUniqueWhere"
	},
	ProductUpdatePageEntityRelationInput:{
		create:"PageCreateInput",
		update:"PageUpdateInput",
		upsert:"ProductUpsertPageRelationInput",
		connect:"PageUniqueWhere"
	},
	PageUpdateInput:{
		locales:"PageUpdateLocalesEntityRelationInput"
	},
	PageUpdateLocalesEntityRelationInput:{
		create:"PageLocaleWithoutRootCreateInput",
		update:"PageUpdateLocalesRelationInput",
		upsert:"PageUpsertLocalesRelationInput",
		connect:"PageLocaleUniqueWhere",
		disconnect:"PageLocaleUniqueWhere",
		delete:"PageLocaleUniqueWhere"
	},
	PageUpdateLocalesRelationInput:{
		by:"PageLocaleUniqueWhere",
		data:"PageLocaleWithoutRootUpdateInput"
	},
	PageLocaleWithoutRootUpdateInput:{
		link:"PageLocaleUpdateLinkEntityRelationInput",
		locale:"PageLocaleUpdateLocaleEntityRelationInput",
		seo:"PageLocaleUpdateSeoEntityRelationInput",
		content:"PageLocaleUpdateContentEntityRelationInput",
		cover:"PageLocaleUpdateCoverEntityRelationInput",
		theme:"PageTheme"
	},
	PageLocaleUpdateSeoEntityRelationInput:{
		create:"SeoCreateInput",
		update:"SeoUpdateInput",
		upsert:"PageLocaleUpsertSeoRelationInput",
		connect:"SeoUniqueWhere"
	},
	SeoUpdateInput:{
		ogImage:"SeoUpdateOgImageEntityRelationInput"
	},
	SeoUpdateOgImageEntityRelationInput:{
		create:"ImageCreateInput",
		update:"ImageUpdateInput",
		upsert:"SeoUpsertOgImageRelationInput",
		connect:"ImageUniqueWhere"
	},
	SeoUpsertOgImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	PageLocaleUpsertSeoRelationInput:{
		update:"SeoUpdateInput",
		create:"SeoCreateInput"
	},
	PageLocaleUpdateContentEntityRelationInput:{
		create:"ContentCreateInput",
		update:"ContentUpdateInput",
		upsert:"PageLocaleUpsertContentRelationInput",
		connect:"ContentUniqueWhere"
	},
	PageLocaleUpsertContentRelationInput:{
		update:"ContentUpdateInput",
		create:"ContentCreateInput"
	},
	PageLocaleUpdateCoverEntityRelationInput:{
		create:"CoverCreateInput",
		update:"CoverUpdateInput",
		upsert:"PageLocaleUpsertCoverRelationInput",
		connect:"CoverUniqueWhere"
	},
	PageLocaleUpsertCoverRelationInput:{
		update:"CoverUpdateInput",
		create:"CoverCreateInput"
	},
	PageUpsertLocalesRelationInput:{
		by:"PageLocaleUniqueWhere",
		update:"PageLocaleWithoutRootUpdateInput",
		create:"PageLocaleWithoutRootCreateInput"
	},
	ProductUpsertPageRelationInput:{
		update:"PageUpdateInput",
		create:"PageCreateInput"
	},
	ProductUpdateSalesDaysEntityRelationInput:{
		connect:"ProductSalesDayUniqueWhere",
		disconnect:"ProductSalesDayUniqueWhere",
		delete:"ProductSalesDayUniqueWhere"
	},
	ProductUpdateSalesWeeksEntityRelationInput:{
		connect:"ProductSalesWeekUniqueWhere",
		disconnect:"ProductSalesWeekUniqueWhere",
		delete:"ProductSalesWeekUniqueWhere"
	},
	ProductUpdateSalesMonthsEntityRelationInput:{
		connect:"ProductSalesMonthUniqueWhere",
		disconnect:"ProductSalesMonthUniqueWhere",
		delete:"ProductSalesMonthUniqueWhere"
	},
	ProductUpdateFulfillmentNotesEntityRelationInput:{
		create:"FulfillmentNoteWithoutProductsCreateInput",
		update:"ProductUpdateFulfillmentNotesRelationInput",
		upsert:"ProductUpsertFulfillmentNotesRelationInput",
		connect:"FulfillmentNoteUniqueWhere",
		disconnect:"FulfillmentNoteUniqueWhere",
		delete:"FulfillmentNoteUniqueWhere"
	},
	ProductUpdateFulfillmentNotesRelationInput:{
		by:"FulfillmentNoteUniqueWhere",
		data:"FulfillmentNoteWithoutProductsUpdateInput"
	},
	FulfillmentNoteWithoutProductsUpdateInput:{
		tags:"FulfillmentNoteUpdateTagsEntityRelationInput",
		venues:"FulfillmentNoteUpdateVenuesEntityRelationInput",
		cartItems:"FulfillmentNoteUpdateCartItemsEntityRelationInput",
		orderItems:"FulfillmentNoteUpdateOrderItemsEntityRelationInput",
		orders:"FulfillmentNoteUpdateOrdersEntityRelationInput",
		createdAt:"DateTime"
	},
	FulfillmentNoteUpdateTagsEntityRelationInput:{
		create:"TagWithoutFulfillmentNotesCreateInput",
		update:"FulfillmentNoteUpdateTagsRelationInput",
		upsert:"FulfillmentNoteUpsertTagsRelationInput",
		connect:"TagUniqueWhere",
		disconnect:"TagUniqueWhere",
		delete:"TagUniqueWhere"
	},
	FulfillmentNoteUpdateTagsRelationInput:{
		by:"TagUniqueWhere",
		data:"TagWithoutFulfillmentNotesUpdateInput"
	},
	TagWithoutFulfillmentNotesUpdateInput:{
		customers:"TagUpdateCustomersEntityRelationInput",
		products:"TagUpdateProductsEntityRelationInput",
		categories:"TagUpdateCategoriesEntityRelationInput",
		addTagsOnRegistration:"TagUpdateAddTagsOnRegistrationEntityRelationInput",
		nestedCategories:"TagUpdateNestedCategoriesEntityRelationInput",
		deliveryZones:"TagUpdateDeliveryZonesEntityRelationInput",
		publicInChannels:"TagUpdatePublicInChannelsEntityRelationInput",
		allowChannelPayments:"TagUpdateAllowChannelPaymentsEntityRelationInput"
	},
	FulfillmentNoteUpsertTagsRelationInput:{
		by:"TagUniqueWhere",
		update:"TagWithoutFulfillmentNotesUpdateInput",
		create:"TagWithoutFulfillmentNotesCreateInput"
	},
	FulfillmentNoteUpdateVenuesEntityRelationInput:{
		create:"VenueWithoutFulfillmentNotesCreateInput",
		update:"FulfillmentNoteUpdateVenuesRelationInput",
		upsert:"FulfillmentNoteUpsertVenuesRelationInput",
		connect:"VenueUniqueWhere",
		disconnect:"VenueUniqueWhere",
		delete:"VenueUniqueWhere"
	},
	FulfillmentNoteUpdateVenuesRelationInput:{
		by:"VenueUniqueWhere",
		data:"VenueWithoutFulfillmentNotesUpdateInput"
	},
	VenueWithoutFulfillmentNotesUpdateInput:{
		deadlineTemplate:"VenueUpdateDeadlineTemplateEntityRelationInput",
		timetableDays:"VenueUpdateTimetableDaysEntityRelationInput",
		timetableTemplates:"VenueUpdateTimetableTemplatesEntityRelationInput",
		staffMembers:"VenueUpdateStaffMembersEntityRelationInput",
		employeeRoles:"VenueUpdateEmployeeRolesEntityRelationInput",
		pointOfSaleApplicationDevices:"VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput",
		pointOfSaleTerminals:"VenueUpdatePointOfSaleTerminalsEntityRelationInput",
		pointOfSalePrinters:"VenueUpdatePointOfSalePrintersEntityRelationInput",
		orders:"VenueUpdateOrdersEntityRelationInput",
		areas:"VenueUpdateAreasEntityRelationInput",
		enabledUnassignReasons:"VenueUpdateEnabledUnassignReasonsEntityRelationInput",
		categories:"VenueUpdateCategoriesEntityRelationInput",
		channels:"VenueUpdateChannelsEntityRelationInput",
		pointOfSaleInitialView:"PointOfSaleInitialView"
	},
	VenueUpdateTimetableTemplatesEntityRelationInput:{
		create:"TimetableTemplateWithoutVenueCreateInput",
		update:"VenueUpdateTimetableTemplatesRelationInput",
		upsert:"VenueUpsertTimetableTemplatesRelationInput",
		connect:"TimetableTemplateUniqueWhere",
		disconnect:"TimetableTemplateUniqueWhere",
		delete:"TimetableTemplateUniqueWhere"
	},
	VenueUpdateTimetableTemplatesRelationInput:{
		by:"TimetableTemplateUniqueWhere",
		data:"TimetableTemplateWithoutVenueUpdateInput"
	},
	TimetableTemplateWithoutVenueUpdateInput:{
		startDate:"Date",
		position:"TimetableTemplateUpdatePositionEntityRelationInput",
		staffOptions:"TimetableTemplateUpdateStaffOptionsEntityRelationInput",
		employeeRole:"TimetableTemplateUpdateEmployeeRoleEntityRelationInput",
		type:"TemplateType"
	},
	TimetableTemplateUpdateEmployeeRoleEntityRelationInput:{
		create:"TimetableEmployeeRoleWithoutTimetableTemplatesCreateInput",
		update:"TimetableEmployeeRoleWithoutTimetableTemplatesUpdateInput",
		upsert:"TimetableTemplateUpsertEmployeeRoleRelationInput",
		connect:"TimetableEmployeeRoleUniqueWhere"
	},
	TimetableEmployeeRoleWithoutTimetableTemplatesUpdateInput:{
		shiftGroups:"TimetableEmployeeRoleUpdateShiftGroupsEntityRelationInput",
		shiftsProfiles:"TimetableEmployeeRoleUpdateShiftsProfilesEntityRelationInput",
		shiftsManagers:"TimetableEmployeeRoleUpdateShiftsManagersEntityRelationInput"
	},
	TimetableTemplateUpsertEmployeeRoleRelationInput:{
		update:"TimetableEmployeeRoleWithoutTimetableTemplatesUpdateInput",
		create:"TimetableEmployeeRoleWithoutTimetableTemplatesCreateInput"
	},
	VenueUpsertTimetableTemplatesRelationInput:{
		by:"TimetableTemplateUniqueWhere",
		update:"TimetableTemplateWithoutVenueUpdateInput",
		create:"TimetableTemplateWithoutVenueCreateInput"
	},
	VenueUpdatePointOfSaleTerminalsEntityRelationInput:{
		create:"PointOfSaleTerminalWithoutVenueCreateInput",
		update:"VenueUpdatePointOfSaleTerminalsRelationInput",
		upsert:"VenueUpsertPointOfSaleTerminalsRelationInput",
		connect:"PointOfSaleTerminalUniqueWhere",
		disconnect:"PointOfSaleTerminalUniqueWhere",
		delete:"PointOfSaleTerminalUniqueWhere"
	},
	VenueUpdatePointOfSaleTerminalsRelationInput:{
		by:"PointOfSaleTerminalUniqueWhere",
		data:"PointOfSaleTerminalWithoutVenueUpdateInput"
	},
	PointOfSaleTerminalWithoutVenueUpdateInput:{
		applicationDevices:"PointOfSaleTerminalUpdateApplicationDevicesEntityRelationInput",
		type:"PointOfSaleTerminalType"
	},
	PointOfSaleTerminalUpdateApplicationDevicesEntityRelationInput:{
		create:"PointOfSaleApplicationDeviceWithoutTerminalCreateInput",
		update:"PointOfSaleTerminalUpdateApplicationDevicesRelationInput",
		upsert:"PointOfSaleTerminalUpsertApplicationDevicesRelationInput",
		connect:"PointOfSaleApplicationDeviceUniqueWhere",
		disconnect:"PointOfSaleApplicationDeviceUniqueWhere",
		delete:"PointOfSaleApplicationDeviceUniqueWhere"
	},
	PointOfSaleTerminalUpdateApplicationDevicesRelationInput:{
		by:"PointOfSaleApplicationDeviceUniqueWhere",
		data:"PointOfSaleApplicationDeviceWithoutTerminalUpdateInput"
	},
	PointOfSaleApplicationDeviceWithoutTerminalUpdateInput:{
		venue:"PointOfSaleApplicationDeviceUpdateVenueEntityRelationInput",
		identificationCode:"PointOfSaleApplicationDeviceUpdateIdentificationCodeEntityRelationInput",
		identifier:"PointOfSaleApplicationDeviceUpdateIdentifierEntityRelationInput",
		receiptPrinter:"PointOfSaleApplicationDeviceUpdateReceiptPrinterEntityRelationInput",
		ticketPrinters:"PointOfSaleApplicationDeviceUpdateTicketPrintersEntityRelationInput"
	},
	PointOfSaleApplicationDeviceUpdateVenueEntityRelationInput:{
		create:"VenueWithoutPointOfSaleApplicationDevicesCreateInput",
		update:"VenueWithoutPointOfSaleApplicationDevicesUpdateInput",
		upsert:"PointOfSaleApplicationDeviceUpsertVenueRelationInput",
		connect:"VenueUniqueWhere"
	},
	VenueWithoutPointOfSaleApplicationDevicesUpdateInput:{
		deadlineTemplate:"VenueUpdateDeadlineTemplateEntityRelationInput",
		timetableDays:"VenueUpdateTimetableDaysEntityRelationInput",
		timetableTemplates:"VenueUpdateTimetableTemplatesEntityRelationInput",
		staffMembers:"VenueUpdateStaffMembersEntityRelationInput",
		employeeRoles:"VenueUpdateEmployeeRolesEntityRelationInput",
		pointOfSaleTerminals:"VenueUpdatePointOfSaleTerminalsEntityRelationInput",
		pointOfSalePrinters:"VenueUpdatePointOfSalePrintersEntityRelationInput",
		orders:"VenueUpdateOrdersEntityRelationInput",
		fulfillmentNotes:"VenueUpdateFulfillmentNotesEntityRelationInput",
		areas:"VenueUpdateAreasEntityRelationInput",
		enabledUnassignReasons:"VenueUpdateEnabledUnassignReasonsEntityRelationInput",
		categories:"VenueUpdateCategoriesEntityRelationInput",
		channels:"VenueUpdateChannelsEntityRelationInput",
		pointOfSaleInitialView:"PointOfSaleInitialView"
	},
	VenueUpdatePointOfSalePrintersEntityRelationInput:{
		create:"PointOfSalePrinterWithoutVenueCreateInput",
		update:"VenueUpdatePointOfSalePrintersRelationInput",
		upsert:"VenueUpsertPointOfSalePrintersRelationInput",
		connect:"PointOfSalePrinterUniqueWhere",
		disconnect:"PointOfSalePrinterUniqueWhere",
		delete:"PointOfSalePrinterUniqueWhere"
	},
	VenueUpdatePointOfSalePrintersRelationInput:{
		by:"PointOfSalePrinterUniqueWhere",
		data:"PointOfSalePrinterWithoutVenueUpdateInput"
	},
	PointOfSalePrinterWithoutVenueUpdateInput:{
		applicationDevicesReceipt:"PointOfSalePrinterUpdateApplicationDevicesReceiptEntityRelationInput",
		applicationDevicesTicket:"PointOfSalePrinterUpdateApplicationDevicesTicketEntityRelationInput",
		ticketCategories:"PointOfSalePrinterUpdateTicketCategoriesEntityRelationInput"
	},
	PointOfSalePrinterUpdateApplicationDevicesReceiptEntityRelationInput:{
		create:"PointOfSaleApplicationDeviceWithoutReceiptPrinterCreateInput",
		update:"PointOfSalePrinterUpdateApplicationDevicesReceiptRelationInput",
		upsert:"PointOfSalePrinterUpsertApplicationDevicesReceiptRelationInput",
		connect:"PointOfSaleApplicationDeviceUniqueWhere",
		disconnect:"PointOfSaleApplicationDeviceUniqueWhere",
		delete:"PointOfSaleApplicationDeviceUniqueWhere"
	},
	PointOfSalePrinterUpdateApplicationDevicesReceiptRelationInput:{
		by:"PointOfSaleApplicationDeviceUniqueWhere",
		data:"PointOfSaleApplicationDeviceWithoutReceiptPrinterUpdateInput"
	},
	PointOfSaleApplicationDeviceWithoutReceiptPrinterUpdateInput:{
		venue:"PointOfSaleApplicationDeviceUpdateVenueEntityRelationInput",
		identificationCode:"PointOfSaleApplicationDeviceUpdateIdentificationCodeEntityRelationInput",
		identifier:"PointOfSaleApplicationDeviceUpdateIdentifierEntityRelationInput",
		terminal:"PointOfSaleApplicationDeviceUpdateTerminalEntityRelationInput",
		ticketPrinters:"PointOfSaleApplicationDeviceUpdateTicketPrintersEntityRelationInput"
	},
	PointOfSaleApplicationDeviceUpdateIdentifierEntityRelationInput:{
		create:"DeviceIdentifierWithoutDeviceCreateInput",
		update:"DeviceIdentifierWithoutDeviceUpdateInput",
		upsert:"PointOfSaleApplicationDeviceUpsertIdentifierRelationInput",
		connect:"DeviceIdentifierUniqueWhere"
	},
	DeviceIdentifierWithoutDeviceUpdateInput:{
		updatedAt:"DateTime",
		updatedByUser:"DeviceIdentifierUpdateUpdatedByUserEntityRelationInput"
	},
	DeviceIdentifierUpdateUpdatedByUserEntityRelationInput:{
		create:"UserCreateInput",
		update:"UserUpdateInput",
		upsert:"DeviceIdentifierUpsertUpdatedByUserRelationInput",
		connect:"UserUniqueWhere"
	},
	UserUpdateInput:{
		staff:"UserUpdateStaffEntityRelationInput",
		customer:"UserUpdateCustomerEntityRelationInput",
		tenantPersonId:"UUID",
		disabledAt:"DateTime",
		devices:"UserUpdateDevicesEntityRelationInput",
		verifiedAt:"DateTime",
		createdAt:"DateTime",
		deletionRequestedAt:"DateTime",
		deletionExpectedAt:"DateTime",
		deletedAt:"DateTime",
		meta:"UserUpdateMetaEntityRelationInput",
		identificationAttempts:"UserUpdateIdentificationAttemptsEntityRelationInput",
		roles:"UserUpdateRolesEntityRelationInput"
	},
	UserUpdateMetaEntityRelationInput:{
		connect:"UserMetadataUniqueWhere"
	},
	UserUpdateIdentificationAttemptsEntityRelationInput:{
		create:"IdentificationAttemptWithoutUserCreateInput",
		update:"UserUpdateIdentificationAttemptsRelationInput",
		upsert:"UserUpsertIdentificationAttemptsRelationInput",
		connect:"IdentificationAttemptUniqueWhere",
		disconnect:"IdentificationAttemptUniqueWhere",
		delete:"IdentificationAttemptUniqueWhere"
	},
	UserUpdateIdentificationAttemptsRelationInput:{
		by:"IdentificationAttemptUniqueWhere",
		data:"IdentificationAttemptWithoutUserUpdateInput"
	},
	IdentificationAttemptWithoutUserUpdateInput:{
		createdAt:"DateTime",
		code:"IdentificationAttemptUpdateCodeEntityRelationInput"
	},
	IdentificationAttemptUpdateCodeEntityRelationInput:{
		create:"IdentificationCodeWithoutAttemptsCreateInput",
		update:"IdentificationCodeWithoutAttemptsUpdateInput",
		upsert:"IdentificationAttemptUpsertCodeRelationInput",
		connect:"IdentificationCodeUniqueWhere"
	},
	IdentificationCodeWithoutAttemptsUpdateInput:{
		createdAt:"DateTime",
		locales:"IdentificationCodeUpdateLocalesEntityRelationInput",
		applicationDevices:"IdentificationCodeUpdateApplicationDevicesEntityRelationInput"
	},
	IdentificationCodeUpdateLocalesEntityRelationInput:{
		create:"IdentificationCodeLocaleWithoutRootCreateInput",
		update:"IdentificationCodeUpdateLocalesRelationInput",
		upsert:"IdentificationCodeUpsertLocalesRelationInput",
		connect:"IdentificationCodeLocaleUniqueWhere",
		disconnect:"IdentificationCodeLocaleUniqueWhere",
		delete:"IdentificationCodeLocaleUniqueWhere"
	},
	IdentificationCodeUpdateLocalesRelationInput:{
		by:"IdentificationCodeLocaleUniqueWhere",
		data:"IdentificationCodeLocaleWithoutRootUpdateInput"
	},
	IdentificationCodeLocaleWithoutRootUpdateInput:{
		locale:"IdentificationCodeLocaleUpdateLocaleEntityRelationInput"
	},
	IdentificationCodeLocaleUpdateLocaleEntityRelationInput:{
		create:"LocaleWithoutIdentificationCodesCreateInput",
		update:"LocaleWithoutIdentificationCodesUpdateInput",
		upsert:"IdentificationCodeLocaleUpsertLocaleRelationInput",
		connect:"LocaleUniqueWhere"
	},
	LocaleWithoutIdentificationCodesUpdateInput:{
		businessCategories:"LocaleUpdateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleUpdateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleUpdateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleUpdateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleUpdateBlogsEntityRelationInput",
		blogPosts:"LocaleUpdateBlogPostsEntityRelationInput",
		identifier:"LocaleUpdateIdentifierEntityRelationInput",
		menus:"LocaleUpdateMenusEntityRelationInput",
		pages:"LocaleUpdatePagesEntityRelationInput",
		productIngredientCategories:"LocaleUpdateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleUpdateAllergensEntityRelationInput",
		productPackings:"LocaleUpdateProductPackingsEntityRelationInput",
		products:"LocaleUpdateProductsEntityRelationInput",
		productRecipes:"LocaleUpdateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleUpdatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleUpdateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleUpdateIngredientSuppliersEntityRelationInput",
		pipelineStages:"LocaleUpdatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleUpdateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleUpdateBusinessServicesEntityRelationInput"
	},
	LocaleUpdateProductsEntityRelationInput:{
		create:"ProductLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateProductsRelationInput",
		upsert:"LocaleUpsertProductsRelationInput",
		connect:"ProductLocaleUniqueWhere",
		disconnect:"ProductLocaleUniqueWhere",
		delete:"ProductLocaleUniqueWhere"
	},
	LocaleUpdateProductsRelationInput:{
		by:"ProductLocaleUniqueWhere",
		data:"ProductLocaleWithoutLocaleUpdateInput"
	},
	ProductLocaleWithoutLocaleUpdateInput:{
		root:"ProductLocaleUpdateRootEntityRelationInput",
		featureList:"ProductLocaleUpdateFeatureListEntityRelationInput"
	},
	ProductLocaleUpdateRootEntityRelationInput:{
		create:"ProductWithoutLocalesCreateInput",
		update:"ProductWithoutLocalesUpdateInput",
		upsert:"ProductLocaleUpsertRootRelationInput",
		connect:"ProductUniqueWhere"
	},
	ProductWithoutLocalesUpdateInput:{
		packing:"ProductUpdatePackingEntityRelationInput",
		recipe:"ProductUpdateRecipeEntityRelationInput",
		tags:"ProductUpdateTagsEntityRelationInput",
		categories:"ProductUpdateCategoriesEntityRelationInput",
		vatRate:"ProductUpdateVatRateEntityRelationInput",
		stocks:"ProductUpdateStocksEntityRelationInput",
		groupPrices:"ProductUpdateGroupPricesEntityRelationInput",
		image:"ProductUpdateImageEntityRelationInput",
		cartItems:"ProductUpdateCartItemsEntityRelationInput",
		availability:"ProductAvailability",
		manager:"ProductUpdateManagerEntityRelationInput",
		orderItems:"ProductUpdateOrderItemsEntityRelationInput",
		inheritedCategories:"ProductUpdateInheritedCategoriesEntityRelationInput",
		deliveryZones:"ProductUpdateDeliveryZonesEntityRelationInput",
		archivedAt:"DateTime",
		customerPrices:"ProductUpdateCustomerPricesEntityRelationInput",
		virtualProduct:"ProductUpdateVirtualProductEntityRelationInput",
		meta:"ProductUpdateMetaEntityRelationInput",
		page:"ProductUpdatePageEntityRelationInput",
		salesDays:"ProductUpdateSalesDaysEntityRelationInput",
		salesWeeks:"ProductUpdateSalesWeeksEntityRelationInput",
		salesMonths:"ProductUpdateSalesMonthsEntityRelationInput",
		fulfillmentNotes:"ProductUpdateFulfillmentNotesEntityRelationInput"
	},
	ProductLocaleUpsertRootRelationInput:{
		update:"ProductWithoutLocalesUpdateInput",
		create:"ProductWithoutLocalesCreateInput"
	},
	ProductLocaleUpdateFeatureListEntityRelationInput:{
		create:"TextListCreateInput",
		update:"TextListUpdateInput",
		upsert:"ProductLocaleUpsertFeatureListRelationInput",
		connect:"TextListUniqueWhere"
	},
	ProductLocaleUpsertFeatureListRelationInput:{
		update:"TextListUpdateInput",
		create:"TextListCreateInput"
	},
	LocaleUpsertProductsRelationInput:{
		by:"ProductLocaleUniqueWhere",
		update:"ProductLocaleWithoutLocaleUpdateInput",
		create:"ProductLocaleWithoutLocaleCreateInput"
	},
	LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput:{
		create:"PointOfSaleCategoryProductLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdatePointOfSaleCategoryProductsRelationInput",
		upsert:"LocaleUpsertPointOfSaleCategoryProductsRelationInput",
		connect:"PointOfSaleCategoryProductLocaleUniqueWhere",
		disconnect:"PointOfSaleCategoryProductLocaleUniqueWhere",
		delete:"PointOfSaleCategoryProductLocaleUniqueWhere"
	},
	LocaleUpdatePointOfSaleCategoryProductsRelationInput:{
		by:"PointOfSaleCategoryProductLocaleUniqueWhere",
		data:"PointOfSaleCategoryProductLocaleWithoutLocaleUpdateInput"
	},
	PointOfSaleCategoryProductLocaleWithoutLocaleUpdateInput:{
		root:"PointOfSaleCategoryProductLocaleUpdateRootEntityRelationInput"
	},
	PointOfSaleCategoryProductLocaleUpdateRootEntityRelationInput:{
		create:"PointOfSaleCategoryProductWithoutLocalesCreateInput",
		update:"PointOfSaleCategoryProductWithoutLocalesUpdateInput",
		upsert:"PointOfSaleCategoryProductLocaleUpsertRootRelationInput",
		connect:"PointOfSaleCategoryProductUniqueWhere"
	},
	PointOfSaleCategoryProductWithoutLocalesUpdateInput:{
		category:"PointOfSaleCategoryProductUpdateCategoryEntityRelationInput",
		product:"PointOfSaleCategoryProductUpdateProductEntityRelationInput"
	},
	PointOfSaleCategoryProductUpdateCategoryEntityRelationInput:{
		create:"PointOfSaleCategoryWithoutProductsCreateInput",
		update:"PointOfSaleCategoryWithoutProductsUpdateInput",
		upsert:"PointOfSaleCategoryProductUpsertCategoryRelationInput",
		connect:"PointOfSaleCategoryUniqueWhere"
	},
	PointOfSaleCategoryWithoutProductsUpdateInput:{
		locales:"PointOfSaleCategoryUpdateLocalesEntityRelationInput",
		category:"PointOfSaleCategoryUpdateCategoryEntityRelationInput",
		venue:"PointOfSaleCategoryUpdateVenueEntityRelationInput",
		ticketPrinters:"PointOfSaleCategoryUpdateTicketPrintersEntityRelationInput"
	},
	PointOfSaleCategoryUpdateLocalesEntityRelationInput:{
		create:"PointOfSaleCategoryLocaleWithoutRootCreateInput",
		update:"PointOfSaleCategoryUpdateLocalesRelationInput",
		upsert:"PointOfSaleCategoryUpsertLocalesRelationInput",
		connect:"PointOfSaleCategoryLocaleUniqueWhere",
		disconnect:"PointOfSaleCategoryLocaleUniqueWhere",
		delete:"PointOfSaleCategoryLocaleUniqueWhere"
	},
	PointOfSaleCategoryUpdateLocalesRelationInput:{
		by:"PointOfSaleCategoryLocaleUniqueWhere",
		data:"PointOfSaleCategoryLocaleWithoutRootUpdateInput"
	},
	PointOfSaleCategoryLocaleWithoutRootUpdateInput:{
		locale:"PointOfSaleCategoryLocaleUpdateLocaleEntityRelationInput"
	},
	PointOfSaleCategoryLocaleUpdateLocaleEntityRelationInput:{
		create:"LocaleWithoutPointOfSaleCategoriesCreateInput",
		update:"LocaleWithoutPointOfSaleCategoriesUpdateInput",
		upsert:"PointOfSaleCategoryLocaleUpsertLocaleRelationInput",
		connect:"LocaleUniqueWhere"
	},
	LocaleWithoutPointOfSaleCategoriesUpdateInput:{
		businessCategories:"LocaleUpdateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleUpdateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleUpdateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleUpdateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleUpdateBlogsEntityRelationInput",
		blogPosts:"LocaleUpdateBlogPostsEntityRelationInput",
		identifier:"LocaleUpdateIdentifierEntityRelationInput",
		menus:"LocaleUpdateMenusEntityRelationInput",
		pages:"LocaleUpdatePagesEntityRelationInput",
		productIngredientCategories:"LocaleUpdateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleUpdateAllergensEntityRelationInput",
		productPackings:"LocaleUpdateProductPackingsEntityRelationInput",
		products:"LocaleUpdateProductsEntityRelationInput",
		productRecipes:"LocaleUpdateProductRecipesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleUpdateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleUpdateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleUpdateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleUpdatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleUpdateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleUpdateBusinessServicesEntityRelationInput"
	},
	LocaleUpdateDeliveryMethodsEntityRelationInput:{
		create:"DeliveryMethodLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateDeliveryMethodsRelationInput",
		upsert:"LocaleUpsertDeliveryMethodsRelationInput",
		connect:"DeliveryMethodLocaleUniqueWhere",
		disconnect:"DeliveryMethodLocaleUniqueWhere",
		delete:"DeliveryMethodLocaleUniqueWhere"
	},
	LocaleUpdateDeliveryMethodsRelationInput:{
		by:"DeliveryMethodLocaleUniqueWhere",
		data:"DeliveryMethodLocaleWithoutLocaleUpdateInput"
	},
	DeliveryMethodLocaleWithoutLocaleUpdateInput:{
		root:"DeliveryMethodLocaleUpdateRootEntityRelationInput"
	},
	DeliveryMethodLocaleUpdateRootEntityRelationInput:{
		create:"DeliveryMethodWithoutLocalesCreateInput",
		update:"DeliveryMethodWithoutLocalesUpdateInput",
		upsert:"DeliveryMethodLocaleUpsertRootRelationInput",
		connect:"DeliveryMethodUniqueWhere"
	},
	DeliveryMethodWithoutLocalesUpdateInput:{
		paymentMethods:"DeliveryMethodUpdatePaymentMethodsEntityRelationInput",
		suitableForDeliveryZones:"DeliveryMethodUpdateSuitableForDeliveryZonesEntityRelationInput",
		channels:"DeliveryMethodUpdateChannelsEntityRelationInput",
		courierHandlers:"DeliveryMethodUpdateCourierHandlersEntityRelationInput",
		timelinePreset:"DeliveryMethodUpdateTimelinePresetEntityRelationInput"
	},
	DeliveryMethodUpdateTimelinePresetEntityRelationInput:{
		create:"DeliveryTimelinePresetWithoutDeliveryMethodCreateInput",
		update:"DeliveryTimelinePresetWithoutDeliveryMethodUpdateInput",
		upsert:"DeliveryMethodUpsertTimelinePresetRelationInput",
		connect:"DeliveryTimelinePresetUniqueWhere"
	},
	DeliveryTimelinePresetWithoutDeliveryMethodUpdateInput:{
		type:"DeliveryTimelineType"
	},
	DeliveryMethodUpsertTimelinePresetRelationInput:{
		update:"DeliveryTimelinePresetWithoutDeliveryMethodUpdateInput",
		create:"DeliveryTimelinePresetWithoutDeliveryMethodCreateInput"
	},
	DeliveryMethodLocaleUpsertRootRelationInput:{
		update:"DeliveryMethodWithoutLocalesUpdateInput",
		create:"DeliveryMethodWithoutLocalesCreateInput"
	},
	LocaleUpsertDeliveryMethodsRelationInput:{
		by:"DeliveryMethodLocaleUniqueWhere",
		update:"DeliveryMethodLocaleWithoutLocaleUpdateInput",
		create:"DeliveryMethodLocaleWithoutLocaleCreateInput"
	},
	LocaleUpdateIngredientSuppliersEntityRelationInput:{
		create:"IngredientSupplierLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateIngredientSuppliersRelationInput",
		upsert:"LocaleUpsertIngredientSuppliersRelationInput",
		connect:"IngredientSupplierLocaleUniqueWhere",
		disconnect:"IngredientSupplierLocaleUniqueWhere",
		delete:"IngredientSupplierLocaleUniqueWhere"
	},
	LocaleUpdateIngredientSuppliersRelationInput:{
		by:"IngredientSupplierLocaleUniqueWhere",
		data:"IngredientSupplierLocaleWithoutLocaleUpdateInput"
	},
	IngredientSupplierLocaleWithoutLocaleUpdateInput:{
		root:"IngredientSupplierLocaleUpdateRootEntityRelationInput"
	},
	IngredientSupplierLocaleUpdateRootEntityRelationInput:{
		create:"IngredientSupplierWithoutLocalesCreateInput",
		update:"IngredientSupplierWithoutLocalesUpdateInput",
		upsert:"IngredientSupplierLocaleUpsertRootRelationInput",
		connect:"IngredientSupplierUniqueWhere"
	},
	IngredientSupplierWithoutLocalesUpdateInput:{

	},
	IngredientSupplierLocaleUpsertRootRelationInput:{
		update:"IngredientSupplierWithoutLocalesUpdateInput",
		create:"IngredientSupplierWithoutLocalesCreateInput"
	},
	LocaleUpsertIngredientSuppliersRelationInput:{
		by:"IngredientSupplierLocaleUniqueWhere",
		update:"IngredientSupplierLocaleWithoutLocaleUpdateInput",
		create:"IngredientSupplierLocaleWithoutLocaleCreateInput"
	},
	LocaleUpdateIdentificationCodesEntityRelationInput:{
		create:"IdentificationCodeLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateIdentificationCodesRelationInput",
		upsert:"LocaleUpsertIdentificationCodesRelationInput",
		connect:"IdentificationCodeLocaleUniqueWhere",
		disconnect:"IdentificationCodeLocaleUniqueWhere",
		delete:"IdentificationCodeLocaleUniqueWhere"
	},
	LocaleUpdateIdentificationCodesRelationInput:{
		by:"IdentificationCodeLocaleUniqueWhere",
		data:"IdentificationCodeLocaleWithoutLocaleUpdateInput"
	},
	IdentificationCodeLocaleWithoutLocaleUpdateInput:{
		root:"IdentificationCodeLocaleUpdateRootEntityRelationInput"
	},
	IdentificationCodeLocaleUpdateRootEntityRelationInput:{
		create:"IdentificationCodeWithoutLocalesCreateInput",
		update:"IdentificationCodeWithoutLocalesUpdateInput",
		upsert:"IdentificationCodeLocaleUpsertRootRelationInput",
		connect:"IdentificationCodeUniqueWhere"
	},
	IdentificationCodeWithoutLocalesUpdateInput:{
		createdAt:"DateTime",
		attempts:"IdentificationCodeUpdateAttemptsEntityRelationInput",
		applicationDevices:"IdentificationCodeUpdateApplicationDevicesEntityRelationInput"
	},
	IdentificationCodeUpdateApplicationDevicesEntityRelationInput:{
		create:"PointOfSaleApplicationDeviceWithoutIdentificationCodeCreateInput",
		update:"IdentificationCodeUpdateApplicationDevicesRelationInput",
		upsert:"IdentificationCodeUpsertApplicationDevicesRelationInput",
		connect:"PointOfSaleApplicationDeviceUniqueWhere",
		disconnect:"PointOfSaleApplicationDeviceUniqueWhere",
		delete:"PointOfSaleApplicationDeviceUniqueWhere"
	},
	IdentificationCodeUpdateApplicationDevicesRelationInput:{
		by:"PointOfSaleApplicationDeviceUniqueWhere",
		data:"PointOfSaleApplicationDeviceWithoutIdentificationCodeUpdateInput"
	},
	PointOfSaleApplicationDeviceWithoutIdentificationCodeUpdateInput:{
		venue:"PointOfSaleApplicationDeviceUpdateVenueEntityRelationInput",
		identifier:"PointOfSaleApplicationDeviceUpdateIdentifierEntityRelationInput",
		terminal:"PointOfSaleApplicationDeviceUpdateTerminalEntityRelationInput",
		receiptPrinter:"PointOfSaleApplicationDeviceUpdateReceiptPrinterEntityRelationInput",
		ticketPrinters:"PointOfSaleApplicationDeviceUpdateTicketPrintersEntityRelationInput"
	},
	PointOfSaleApplicationDeviceUpdateTerminalEntityRelationInput:{
		create:"PointOfSaleTerminalWithoutApplicationDevicesCreateInput",
		update:"PointOfSaleTerminalWithoutApplicationDevicesUpdateInput",
		upsert:"PointOfSaleApplicationDeviceUpsertTerminalRelationInput",
		connect:"PointOfSaleTerminalUniqueWhere"
	},
	PointOfSaleTerminalWithoutApplicationDevicesUpdateInput:{
		venue:"PointOfSaleTerminalUpdateVenueEntityRelationInput",
		type:"PointOfSaleTerminalType"
	},
	PointOfSaleTerminalUpdateVenueEntityRelationInput:{
		create:"VenueWithoutPointOfSaleTerminalsCreateInput",
		update:"VenueWithoutPointOfSaleTerminalsUpdateInput",
		upsert:"PointOfSaleTerminalUpsertVenueRelationInput",
		connect:"VenueUniqueWhere"
	},
	VenueWithoutPointOfSaleTerminalsUpdateInput:{
		deadlineTemplate:"VenueUpdateDeadlineTemplateEntityRelationInput",
		timetableDays:"VenueUpdateTimetableDaysEntityRelationInput",
		timetableTemplates:"VenueUpdateTimetableTemplatesEntityRelationInput",
		staffMembers:"VenueUpdateStaffMembersEntityRelationInput",
		employeeRoles:"VenueUpdateEmployeeRolesEntityRelationInput",
		pointOfSaleApplicationDevices:"VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput",
		pointOfSalePrinters:"VenueUpdatePointOfSalePrintersEntityRelationInput",
		orders:"VenueUpdateOrdersEntityRelationInput",
		fulfillmentNotes:"VenueUpdateFulfillmentNotesEntityRelationInput",
		areas:"VenueUpdateAreasEntityRelationInput",
		enabledUnassignReasons:"VenueUpdateEnabledUnassignReasonsEntityRelationInput",
		categories:"VenueUpdateCategoriesEntityRelationInput",
		channels:"VenueUpdateChannelsEntityRelationInput",
		pointOfSaleInitialView:"PointOfSaleInitialView"
	},
	VenueUpdateOrdersEntityRelationInput:{
		create:"OrderWithoutVenueCreateInput",
		update:"VenueUpdateOrdersRelationInput",
		upsert:"VenueUpsertOrdersRelationInput",
		connect:"OrderUniqueWhere",
		disconnect:"OrderUniqueWhere",
		delete:"OrderUniqueWhere"
	},
	VenueUpdateOrdersRelationInput:{
		by:"OrderUniqueWhere",
		data:"OrderWithoutVenueUpdateInput"
	},
	OrderWithoutVenueUpdateInput:{
		state:"OrderState",
		fulfilledAt:"DateTime",
		canceledAt:"DateTime",
		customer:"OrderUpdateCustomerEntityRelationInput",
		channel:"OrderUpdateChannelEntityRelationInput",
		discounts:"OrderUpdateDiscountsEntityRelationInput",
		delivery:"OrderUpdateDeliveryEntityRelationInput",
		items:"OrderUpdateItemsEntityRelationInput",
		cart:"OrderUpdateCartEntityRelationInput",
		events:"OrderUpdateEventsEntityRelationInput",
		createdAt:"DateTime",
		billingAddress:"OrderUpdateBillingAddressEntityRelationInput",
		priceLines:"OrderUpdatePriceLinesEntityRelationInput",
		payments:"OrderUpdatePaymentsEntityRelationInput",
		billingSubject:"OrderUpdateBillingSubjectEntityRelationInput",
		summary:"OrderUpdateSummaryEntityRelationInput",
		gratuity:"OrderUpdateGratuityEntityRelationInput",
		fulfillmentNotes:"OrderUpdateFulfillmentNotesEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	OrderUpdateItemsEntityRelationInput:{
		create:"OrderItemWithoutOrderCreateInput",
		update:"OrderUpdateItemsRelationInput",
		upsert:"OrderUpsertItemsRelationInput",
		connect:"OrderItemUniqueWhere",
		disconnect:"OrderItemUniqueWhere",
		delete:"OrderItemUniqueWhere"
	},
	OrderUpdateItemsRelationInput:{
		by:"OrderItemUniqueWhere",
		data:"OrderItemWithoutOrderUpdateInput"
	},
	OrderItemWithoutOrderUpdateInput:{
		vatRate:"OrderItemUpdateVatRateEntityRelationInput",
		virtualProductEffects:"OrderItemUpdateVirtualProductEffectsEntityRelationInput",
		pickedAt:"DateTime",
		fulfillmentNotes:"OrderItemUpdateFulfillmentNotesEntityRelationInput",
		product:"OrderItemUpdateProductEntityRelationInput"
	},
	OrderItemUpdateVirtualProductEffectsEntityRelationInput:{
		create:"VirtualProductEffectWithoutOrderItemCreateInput",
		update:"OrderItemUpdateVirtualProductEffectsRelationInput",
		upsert:"OrderItemUpsertVirtualProductEffectsRelationInput",
		connect:"VirtualProductEffectUniqueWhere",
		disconnect:"VirtualProductEffectUniqueWhere",
		delete:"VirtualProductEffectUniqueWhere"
	},
	OrderItemUpdateVirtualProductEffectsRelationInput:{
		by:"VirtualProductEffectUniqueWhere",
		data:"VirtualProductEffectWithoutOrderItemUpdateInput"
	},
	VirtualProductEffectWithoutOrderItemUpdateInput:{
		createdAt:"DateTime",
		succeededAt:"DateTime",
		failedAt:"DateTime",
		revertedAt:"DateTime",
		resultCustomerCreditTransaction:"VirtualProductEffectUpdateResultCustomerCreditTransactionEntityRelationInput",
		resultVouchers:"VirtualProductEffectUpdateResultVouchersEntityRelationInput"
	},
	VirtualProductEffectUpdateResultCustomerCreditTransactionEntityRelationInput:{
		create:"CustomerCreditTransactionWithoutVirtualProductEffectCreateInput",
		update:"CustomerCreditTransactionWithoutVirtualProductEffectUpdateInput",
		upsert:"VirtualProductEffectUpsertResultCustomerCreditTransactionRelationInput",
		connect:"CustomerCreditTransactionUniqueWhere"
	},
	CustomerCreditTransactionWithoutVirtualProductEffectUpdateInput:{
		createdAt:"DateTime",
		customerCredit:"CustomerCreditTransactionUpdateCustomerCreditEntityRelationInput",
		orderDiscount:"CustomerCreditTransactionUpdateOrderDiscountEntityRelationInput"
	},
	CustomerCreditTransactionUpdateOrderDiscountEntityRelationInput:{
		create:"OrderDiscountWithoutCustomerCreditTransactionsCreateInput",
		update:"OrderDiscountWithoutCustomerCreditTransactionsUpdateInput",
		upsert:"CustomerCreditTransactionUpsertOrderDiscountRelationInput",
		connect:"OrderDiscountUniqueWhere"
	},
	OrderDiscountWithoutCustomerCreditTransactionsUpdateInput:{
		vatRate:"OrderDiscountUpdateVatRateEntityRelationInput",
		order:"OrderDiscountUpdateOrderEntityRelationInput",
		type:"OrderDiscountType",
		voucherRedemption:"OrderDiscountUpdateVoucherRedemptionEntityRelationInput"
	},
	OrderDiscountUpdateOrderEntityRelationInput:{
		create:"OrderWithoutDiscountsCreateInput",
		update:"OrderWithoutDiscountsUpdateInput",
		upsert:"OrderDiscountUpsertOrderRelationInput",
		connect:"OrderUniqueWhere"
	},
	OrderWithoutDiscountsUpdateInput:{
		state:"OrderState",
		fulfilledAt:"DateTime",
		canceledAt:"DateTime",
		customer:"OrderUpdateCustomerEntityRelationInput",
		channel:"OrderUpdateChannelEntityRelationInput",
		delivery:"OrderUpdateDeliveryEntityRelationInput",
		items:"OrderUpdateItemsEntityRelationInput",
		cart:"OrderUpdateCartEntityRelationInput",
		events:"OrderUpdateEventsEntityRelationInput",
		createdAt:"DateTime",
		billingAddress:"OrderUpdateBillingAddressEntityRelationInput",
		priceLines:"OrderUpdatePriceLinesEntityRelationInput",
		payments:"OrderUpdatePaymentsEntityRelationInput",
		billingSubject:"OrderUpdateBillingSubjectEntityRelationInput",
		summary:"OrderUpdateSummaryEntityRelationInput",
		gratuity:"OrderUpdateGratuityEntityRelationInput",
		venue:"OrderUpdateVenueEntityRelationInput",
		fulfillmentNotes:"OrderUpdateFulfillmentNotesEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	OrderUpdateCartEntityRelationInput:{
		create:"CartWithoutOrderCreateInput",
		update:"CartWithoutOrderUpdateInput",
		upsert:"OrderUpsertCartRelationInput",
		connect:"CartUniqueWhere"
	},
	CartWithoutOrderUpdateInput:{
		confirmedAt:"DateTime",
		deletedAt:"DateTime",
		items:"CartUpdateItemsEntityRelationInput",
		state:"CartState",
		createdAt:"DateTime",
		channel:"CartUpdateChannelEntityRelationInput",
		customer:"CartUpdateCustomerEntityRelationInput",
		deliveryAddress:"CartUpdateDeliveryAddressEntityRelationInput",
		billingAddress:"CartUpdateBillingAddressEntityRelationInput",
		delivery:"CartUpdateDeliveryEntityRelationInput",
		payment:"CartUpdatePaymentEntityRelationInput",
		billingSubject:"CartUpdateBillingSubjectEntityRelationInput",
		priceLines:"CartUpdatePriceLinesEntityRelationInput",
		summary:"CartUpdateSummaryEntityRelationInput"
	},
	CartUpdateCustomerEntityRelationInput:{
		create:"CustomerWithoutCartsCreateInput",
		update:"CustomerWithoutCartsUpdateInput",
		upsert:"CartUpsertCustomerRelationInput",
		connect:"CustomerUniqueWhere"
	},
	CustomerWithoutCartsUpdateInput:{
		addresses:"CustomerUpdateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerUpdateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerUpdateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerUpdateTagsEntityRelationInput",
		credits:"CustomerUpdateCreditsEntityRelationInput",
		paymentMethods:"CustomerUpdatePaymentMethodsEntityRelationInput",
		orders:"CustomerUpdateOrdersEntityRelationInput",
		permissions:"CustomerUpdatePermissionsEntityRelationInput",
		group:"CustomerUpdateGroupEntityRelationInput",
		photo:"CustomerUpdatePhotoEntityRelationInput",
		name:"CustomerUpdateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerUpdateIngredientRatingsEntityRelationInput",
		business:"CustomerUpdateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerUpdateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerUpdateMemberOfBusinessesEntityRelationInput",
		shortcutList:"CustomerUpdateShortcutListEntityRelationInput",
		user:"CustomerUpdateUserEntityRelationInput",
		channels:"CustomerUpdateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerUpdateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerUpdateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerUpdateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerUpdateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerUpdateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerUpdateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerUpdateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerUpdateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerUpdateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerUpdateRedeemedVouchersEntityRelationInput",
		spending:"CustomerUpdateSpendingEntityRelationInput",
		customerTabs:"CustomerUpdateCustomerTabsEntityRelationInput",
		lead:"CustomerUpdateLeadEntityRelationInput",
		meta:"CustomerUpdateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerUpdateInvoicingPlanEntityRelationInput:{
		create:"InvoicingPlanWithoutCustomerCreateInput",
		update:"InvoicingPlanWithoutCustomerUpdateInput",
		upsert:"CustomerUpsertInvoicingPlanRelationInput",
		connect:"InvoicingPlanUniqueWhere"
	},
	InvoicingPlanWithoutCustomerUpdateInput:{
		preset:"InvoicingPlanUpdatePresetEntityRelationInput"
	},
	InvoicingPlanUpdatePresetEntityRelationInput:{
		create:"InvoicingPresetWithoutInvoicingPlanCreateInput",
		update:"InvoicingPresetWithoutInvoicingPlanUpdateInput",
		upsert:"InvoicingPlanUpsertPresetRelationInput",
		connect:"InvoicingPresetUniqueWhere"
	},
	InvoicingPresetWithoutInvoicingPlanUpdateInput:{
		type:"InvoicingPresetType",
		startsAt:"DateTime",
		endsAt:"DateTime"
	},
	InvoicingPlanUpsertPresetRelationInput:{
		update:"InvoicingPresetWithoutInvoicingPlanUpdateInput",
		create:"InvoicingPresetWithoutInvoicingPlanCreateInput"
	},
	CustomerUpsertInvoicingPlanRelationInput:{
		update:"InvoicingPlanWithoutCustomerUpdateInput",
		create:"InvoicingPlanWithoutCustomerCreateInput"
	},
	CustomerUpdateBillingSubjectsEntityRelationInput:{
		create:"BillingSubjectWithoutCustomerCreateInput",
		update:"CustomerUpdateBillingSubjectsRelationInput",
		upsert:"CustomerUpsertBillingSubjectsRelationInput",
		connect:"BillingSubjectUniqueWhere",
		disconnect:"BillingSubjectUniqueWhere",
		delete:"BillingSubjectUniqueWhere"
	},
	CustomerUpdateBillingSubjectsRelationInput:{
		by:"BillingSubjectUniqueWhere",
		data:"BillingSubjectWithoutCustomerUpdateInput"
	},
	BillingSubjectWithoutCustomerUpdateInput:{
		createdAt:"DateTime",
		deletedAt:"DateTime",
		country:"BillingSubjectUpdateCountryEntityRelationInput",
		invoices:"BillingSubjectUpdateInvoicesEntityRelationInput",
		defaultBillingSubjectOfCustomer:"BillingSubjectUpdateDefaultBillingSubjectOfCustomerEntityRelationInput",
		orders:"BillingSubjectUpdateOrdersEntityRelationInput"
	},
	BillingSubjectUpdateCountryEntityRelationInput:{
		create:"CountryCreateInput",
		update:"CountryUpdateInput",
		upsert:"BillingSubjectUpsertCountryRelationInput",
		connect:"CountryUniqueWhere"
	},
	BillingSubjectUpsertCountryRelationInput:{
		update:"CountryUpdateInput",
		create:"CountryCreateInput"
	},
	BillingSubjectUpdateInvoicesEntityRelationInput:{
		create:"InvoiceWithoutBillingSubjectCreateInput",
		update:"BillingSubjectUpdateInvoicesRelationInput",
		upsert:"BillingSubjectUpsertInvoicesRelationInput",
		connect:"InvoiceUniqueWhere",
		disconnect:"InvoiceUniqueWhere",
		delete:"InvoiceUniqueWhere"
	},
	BillingSubjectUpdateInvoicesRelationInput:{
		by:"InvoiceUniqueWhere",
		data:"InvoiceWithoutBillingSubjectUpdateInput"
	},
	InvoiceWithoutBillingSubjectUpdateInput:{
		createdAt:"DateTime",
		customer:"InvoiceUpdateCustomerEntityRelationInput",
		orderPayments:"InvoiceUpdateOrderPaymentsEntityRelationInput",
		address:"InvoiceUpdateAddressEntityRelationInput"
	},
	InvoiceUpdateAddressEntityRelationInput:{
		create:"AddressWithoutInvoicesCreateInput",
		update:"AddressWithoutInvoicesUpdateInput",
		upsert:"InvoiceUpsertAddressRelationInput",
		connect:"AddressUniqueWhere"
	},
	AddressWithoutInvoicesUpdateInput:{
		customer:"AddressUpdateCustomerEntityRelationInput",
		country:"AddressUpdateCountryEntityRelationInput",
		deletedAt:"DateTime",
		geocodeGeneratedAt:"DateTime",
		deliveryZone:"AddressUpdateDeliveryZoneEntityRelationInput",
		meta:"AddressUpdateMetaEntityRelationInput",
		gps:"AddressUpdateGpsEntityRelationInput",
		createdAt:"DateTime",
		billingAddressOfOrders:"AddressUpdateBillingAddressOfOrdersEntityRelationInput",
		deliveryAddressOfOrderDeliveries:"AddressUpdateDeliveryAddressOfOrderDeliveriesEntityRelationInput",
		defaultDeliveryAddressOfCustomer:"AddressUpdateDefaultDeliveryAddressOfCustomerEntityRelationInput"
	},
	AddressUpdateBillingAddressOfOrdersEntityRelationInput:{
		create:"OrderWithoutBillingAddressCreateInput",
		update:"AddressUpdateBillingAddressOfOrdersRelationInput",
		upsert:"AddressUpsertBillingAddressOfOrdersRelationInput",
		connect:"OrderUniqueWhere",
		disconnect:"OrderUniqueWhere",
		delete:"OrderUniqueWhere"
	},
	AddressUpdateBillingAddressOfOrdersRelationInput:{
		by:"OrderUniqueWhere",
		data:"OrderWithoutBillingAddressUpdateInput"
	},
	OrderWithoutBillingAddressUpdateInput:{
		state:"OrderState",
		fulfilledAt:"DateTime",
		canceledAt:"DateTime",
		customer:"OrderUpdateCustomerEntityRelationInput",
		channel:"OrderUpdateChannelEntityRelationInput",
		discounts:"OrderUpdateDiscountsEntityRelationInput",
		delivery:"OrderUpdateDeliveryEntityRelationInput",
		items:"OrderUpdateItemsEntityRelationInput",
		cart:"OrderUpdateCartEntityRelationInput",
		events:"OrderUpdateEventsEntityRelationInput",
		createdAt:"DateTime",
		priceLines:"OrderUpdatePriceLinesEntityRelationInput",
		payments:"OrderUpdatePaymentsEntityRelationInput",
		billingSubject:"OrderUpdateBillingSubjectEntityRelationInput",
		summary:"OrderUpdateSummaryEntityRelationInput",
		gratuity:"OrderUpdateGratuityEntityRelationInput",
		venue:"OrderUpdateVenueEntityRelationInput",
		fulfillmentNotes:"OrderUpdateFulfillmentNotesEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	OrderUpdateEventsEntityRelationInput:{
		create:"OrderEventWithoutOrderCreateInput",
		update:"OrderUpdateEventsRelationInput",
		upsert:"OrderUpsertEventsRelationInput",
		connect:"OrderEventUniqueWhere",
		disconnect:"OrderEventUniqueWhere",
		delete:"OrderEventUniqueWhere"
	},
	OrderUpdateEventsRelationInput:{
		by:"OrderEventUniqueWhere",
		data:"OrderEventWithoutOrderUpdateInput"
	},
	OrderEventWithoutOrderUpdateInput:{
		createdAt:"DateTime",
		payment:"OrderEventUpdatePaymentEntityRelationInput",
		delivery:"OrderEventUpdateDeliveryEntityRelationInput"
	},
	OrderEventUpdatePaymentEntityRelationInput:{
		create:"OrderPaymentWithoutEventsCreateInput",
		update:"OrderPaymentWithoutEventsUpdateInput",
		upsert:"OrderEventUpsertPaymentRelationInput",
		connect:"OrderPaymentUniqueWhere"
	},
	OrderPaymentWithoutEventsUpdateInput:{
		data:"Json",
		method:"OrderPaymentUpdateMethodEntityRelationInput",
		failedAt:"DateTime",
		state:"OrderPaymentState",
		approvedAt:"DateTime",
		order:"OrderPaymentUpdateOrderEntityRelationInput",
		invoice:"OrderPaymentUpdateInvoiceEntityRelationInput",
		createdAt:"DateTime",
		vatRate:"OrderPaymentUpdateVatRateEntityRelationInput",
		meta:"OrderPaymentUpdateMetaEntityRelationInput"
	},
	OrderPaymentUpdateOrderEntityRelationInput:{
		create:"OrderWithoutPaymentsCreateInput",
		update:"OrderWithoutPaymentsUpdateInput",
		upsert:"OrderPaymentUpsertOrderRelationInput",
		connect:"OrderUniqueWhere"
	},
	OrderWithoutPaymentsUpdateInput:{
		state:"OrderState",
		fulfilledAt:"DateTime",
		canceledAt:"DateTime",
		customer:"OrderUpdateCustomerEntityRelationInput",
		channel:"OrderUpdateChannelEntityRelationInput",
		discounts:"OrderUpdateDiscountsEntityRelationInput",
		delivery:"OrderUpdateDeliveryEntityRelationInput",
		items:"OrderUpdateItemsEntityRelationInput",
		cart:"OrderUpdateCartEntityRelationInput",
		events:"OrderUpdateEventsEntityRelationInput",
		createdAt:"DateTime",
		billingAddress:"OrderUpdateBillingAddressEntityRelationInput",
		priceLines:"OrderUpdatePriceLinesEntityRelationInput",
		billingSubject:"OrderUpdateBillingSubjectEntityRelationInput",
		summary:"OrderUpdateSummaryEntityRelationInput",
		gratuity:"OrderUpdateGratuityEntityRelationInput",
		venue:"OrderUpdateVenueEntityRelationInput",
		fulfillmentNotes:"OrderUpdateFulfillmentNotesEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	OrderUpdateBillingAddressEntityRelationInput:{
		create:"AddressWithoutBillingAddressOfOrdersCreateInput",
		update:"AddressWithoutBillingAddressOfOrdersUpdateInput",
		upsert:"OrderUpsertBillingAddressRelationInput",
		connect:"AddressUniqueWhere"
	},
	AddressWithoutBillingAddressOfOrdersUpdateInput:{
		customer:"AddressUpdateCustomerEntityRelationInput",
		country:"AddressUpdateCountryEntityRelationInput",
		deletedAt:"DateTime",
		geocodeGeneratedAt:"DateTime",
		deliveryZone:"AddressUpdateDeliveryZoneEntityRelationInput",
		meta:"AddressUpdateMetaEntityRelationInput",
		gps:"AddressUpdateGpsEntityRelationInput",
		invoices:"AddressUpdateInvoicesEntityRelationInput",
		createdAt:"DateTime",
		deliveryAddressOfOrderDeliveries:"AddressUpdateDeliveryAddressOfOrderDeliveriesEntityRelationInput",
		defaultDeliveryAddressOfCustomer:"AddressUpdateDefaultDeliveryAddressOfCustomerEntityRelationInput"
	},
	AddressUpdateDeliveryAddressOfOrderDeliveriesEntityRelationInput:{
		create:"OrderDeliveryWithoutAddressCreateInput",
		update:"AddressUpdateDeliveryAddressOfOrderDeliveriesRelationInput",
		upsert:"AddressUpsertDeliveryAddressOfOrderDeliveriesRelationInput",
		connect:"OrderDeliveryUniqueWhere",
		disconnect:"OrderDeliveryUniqueWhere",
		delete:"OrderDeliveryUniqueWhere"
	},
	AddressUpdateDeliveryAddressOfOrderDeliveriesRelationInput:{
		by:"OrderDeliveryUniqueWhere",
		data:"OrderDeliveryWithoutAddressUpdateInput"
	},
	OrderDeliveryWithoutAddressUpdateInput:{
		deliveredAt:"DateTime",
		method:"OrderDeliveryUpdateMethodEntityRelationInput",
		vatRate:"OrderDeliveryUpdateVatRateEntityRelationInput",
		order:"OrderDeliveryUpdateOrderEntityRelationInput",
		expectedAt:"DateTime",
		state:"OrderDeliveryState",
		dispatchAt:"DateTime",
		expectedEndAt:"DateTime",
		processingAt:"DateTime",
		deliveringAt:"DateTime",
		failedAt:"DateTime",
		deliveryWaypoint:"OrderDeliveryUpdateDeliveryWaypointEntityRelationInput",
		events:"OrderDeliveryUpdateEventsEntityRelationInput",
		prepareAt:"DateTime",
		liftagoRide:"OrderDeliveryUpdateLiftagoRideEntityRelationInput",
		pickedAt:"DateTime",
		woltDriveDelivery:"OrderDeliveryUpdateWoltDriveDeliveryEntityRelationInput"
	},
	OrderDeliveryUpdateOrderEntityRelationInput:{
		create:"OrderWithoutDeliveryCreateInput",
		update:"OrderWithoutDeliveryUpdateInput",
		upsert:"OrderDeliveryUpsertOrderRelationInput",
		connect:"OrderUniqueWhere"
	},
	OrderWithoutDeliveryUpdateInput:{
		state:"OrderState",
		fulfilledAt:"DateTime",
		canceledAt:"DateTime",
		customer:"OrderUpdateCustomerEntityRelationInput",
		channel:"OrderUpdateChannelEntityRelationInput",
		discounts:"OrderUpdateDiscountsEntityRelationInput",
		items:"OrderUpdateItemsEntityRelationInput",
		cart:"OrderUpdateCartEntityRelationInput",
		events:"OrderUpdateEventsEntityRelationInput",
		createdAt:"DateTime",
		billingAddress:"OrderUpdateBillingAddressEntityRelationInput",
		priceLines:"OrderUpdatePriceLinesEntityRelationInput",
		payments:"OrderUpdatePaymentsEntityRelationInput",
		billingSubject:"OrderUpdateBillingSubjectEntityRelationInput",
		summary:"OrderUpdateSummaryEntityRelationInput",
		gratuity:"OrderUpdateGratuityEntityRelationInput",
		venue:"OrderUpdateVenueEntityRelationInput",
		fulfillmentNotes:"OrderUpdateFulfillmentNotesEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	OrderUpdatePriceLinesEntityRelationInput:{
		connect:"OrderPriceLineUniqueWhere",
		disconnect:"OrderPriceLineUniqueWhere",
		delete:"OrderPriceLineUniqueWhere"
	},
	OrderUpdatePaymentsEntityRelationInput:{
		create:"OrderPaymentWithoutOrderCreateInput",
		update:"OrderUpdatePaymentsRelationInput",
		upsert:"OrderUpsertPaymentsRelationInput",
		connect:"OrderPaymentUniqueWhere",
		disconnect:"OrderPaymentUniqueWhere",
		delete:"OrderPaymentUniqueWhere"
	},
	OrderUpdatePaymentsRelationInput:{
		by:"OrderPaymentUniqueWhere",
		data:"OrderPaymentWithoutOrderUpdateInput"
	},
	OrderPaymentWithoutOrderUpdateInput:{
		data:"Json",
		method:"OrderPaymentUpdateMethodEntityRelationInput",
		failedAt:"DateTime",
		state:"OrderPaymentState",
		approvedAt:"DateTime",
		events:"OrderPaymentUpdateEventsEntityRelationInput",
		invoice:"OrderPaymentUpdateInvoiceEntityRelationInput",
		createdAt:"DateTime",
		vatRate:"OrderPaymentUpdateVatRateEntityRelationInput",
		meta:"OrderPaymentUpdateMetaEntityRelationInput"
	},
	OrderPaymentUpdateInvoiceEntityRelationInput:{
		create:"InvoiceWithoutOrderPaymentsCreateInput",
		update:"InvoiceWithoutOrderPaymentsUpdateInput",
		upsert:"OrderPaymentUpsertInvoiceRelationInput",
		connect:"InvoiceUniqueWhere"
	},
	InvoiceWithoutOrderPaymentsUpdateInput:{
		createdAt:"DateTime",
		customer:"InvoiceUpdateCustomerEntityRelationInput",
		address:"InvoiceUpdateAddressEntityRelationInput",
		billingSubject:"InvoiceUpdateBillingSubjectEntityRelationInput"
	},
	InvoiceUpdateBillingSubjectEntityRelationInput:{
		create:"BillingSubjectWithoutInvoicesCreateInput",
		update:"BillingSubjectWithoutInvoicesUpdateInput",
		upsert:"InvoiceUpsertBillingSubjectRelationInput",
		connect:"BillingSubjectUniqueWhere"
	},
	BillingSubjectWithoutInvoicesUpdateInput:{
		createdAt:"DateTime",
		deletedAt:"DateTime",
		country:"BillingSubjectUpdateCountryEntityRelationInput",
		customer:"BillingSubjectUpdateCustomerEntityRelationInput",
		defaultBillingSubjectOfCustomer:"BillingSubjectUpdateDefaultBillingSubjectOfCustomerEntityRelationInput",
		orders:"BillingSubjectUpdateOrdersEntityRelationInput"
	},
	BillingSubjectUpdateCustomerEntityRelationInput:{
		create:"CustomerWithoutBillingSubjectsCreateInput",
		update:"CustomerWithoutBillingSubjectsUpdateInput",
		upsert:"BillingSubjectUpsertCustomerRelationInput",
		connect:"CustomerUniqueWhere"
	},
	CustomerWithoutBillingSubjectsUpdateInput:{
		addresses:"CustomerUpdateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerUpdateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerUpdateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerUpdateTagsEntityRelationInput",
		credits:"CustomerUpdateCreditsEntityRelationInput",
		paymentMethods:"CustomerUpdatePaymentMethodsEntityRelationInput",
		orders:"CustomerUpdateOrdersEntityRelationInput",
		permissions:"CustomerUpdatePermissionsEntityRelationInput",
		group:"CustomerUpdateGroupEntityRelationInput",
		photo:"CustomerUpdatePhotoEntityRelationInput",
		name:"CustomerUpdateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerUpdateIngredientRatingsEntityRelationInput",
		business:"CustomerUpdateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerUpdateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerUpdateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerUpdateCartsEntityRelationInput",
		shortcutList:"CustomerUpdateShortcutListEntityRelationInput",
		user:"CustomerUpdateUserEntityRelationInput",
		channels:"CustomerUpdateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerUpdateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerUpdateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		offeredProducts:"CustomerUpdateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerUpdateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerUpdateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerUpdateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerUpdateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerUpdateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerUpdateRedeemedVouchersEntityRelationInput",
		spending:"CustomerUpdateSpendingEntityRelationInput",
		customerTabs:"CustomerUpdateCustomerTabsEntityRelationInput",
		lead:"CustomerUpdateLeadEntityRelationInput",
		meta:"CustomerUpdateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerUpdateOfferedProductsEntityRelationInput:{
		connect:"ProductCustomerPriceUniqueWhere",
		disconnect:"ProductCustomerPriceUniqueWhere",
		delete:"ProductCustomerPriceUniqueWhere"
	},
	CustomerUpdateDefaultDeliveryAddressEntityRelationInput:{
		create:"AddressWithoutDefaultDeliveryAddressOfCustomerCreateInput",
		update:"AddressWithoutDefaultDeliveryAddressOfCustomerUpdateInput",
		upsert:"CustomerUpsertDefaultDeliveryAddressRelationInput",
		connect:"AddressUniqueWhere"
	},
	AddressWithoutDefaultDeliveryAddressOfCustomerUpdateInput:{
		customer:"AddressUpdateCustomerEntityRelationInput",
		country:"AddressUpdateCountryEntityRelationInput",
		deletedAt:"DateTime",
		geocodeGeneratedAt:"DateTime",
		deliveryZone:"AddressUpdateDeliveryZoneEntityRelationInput",
		meta:"AddressUpdateMetaEntityRelationInput",
		gps:"AddressUpdateGpsEntityRelationInput",
		invoices:"AddressUpdateInvoicesEntityRelationInput",
		createdAt:"DateTime",
		billingAddressOfOrders:"AddressUpdateBillingAddressOfOrdersEntityRelationInput",
		deliveryAddressOfOrderDeliveries:"AddressUpdateDeliveryAddressOfOrderDeliveriesEntityRelationInput"
	},
	CustomerUpsertDefaultDeliveryAddressRelationInput:{
		update:"AddressWithoutDefaultDeliveryAddressOfCustomerUpdateInput",
		create:"AddressWithoutDefaultDeliveryAddressOfCustomerCreateInput"
	},
	CustomerUpdateDefaultBillingSubjectEntityRelationInput:{
		create:"BillingSubjectWithoutDefaultBillingSubjectOfCustomerCreateInput",
		update:"BillingSubjectWithoutDefaultBillingSubjectOfCustomerUpdateInput",
		upsert:"CustomerUpsertDefaultBillingSubjectRelationInput",
		connect:"BillingSubjectUniqueWhere"
	},
	BillingSubjectWithoutDefaultBillingSubjectOfCustomerUpdateInput:{
		createdAt:"DateTime",
		deletedAt:"DateTime",
		country:"BillingSubjectUpdateCountryEntityRelationInput",
		customer:"BillingSubjectUpdateCustomerEntityRelationInput",
		invoices:"BillingSubjectUpdateInvoicesEntityRelationInput",
		orders:"BillingSubjectUpdateOrdersEntityRelationInput"
	},
	BillingSubjectUpdateOrdersEntityRelationInput:{
		create:"OrderWithoutBillingSubjectCreateInput",
		update:"BillingSubjectUpdateOrdersRelationInput",
		upsert:"BillingSubjectUpsertOrdersRelationInput",
		connect:"OrderUniqueWhere",
		disconnect:"OrderUniqueWhere",
		delete:"OrderUniqueWhere"
	},
	BillingSubjectUpdateOrdersRelationInput:{
		by:"OrderUniqueWhere",
		data:"OrderWithoutBillingSubjectUpdateInput"
	},
	OrderWithoutBillingSubjectUpdateInput:{
		state:"OrderState",
		fulfilledAt:"DateTime",
		canceledAt:"DateTime",
		customer:"OrderUpdateCustomerEntityRelationInput",
		channel:"OrderUpdateChannelEntityRelationInput",
		discounts:"OrderUpdateDiscountsEntityRelationInput",
		delivery:"OrderUpdateDeliveryEntityRelationInput",
		items:"OrderUpdateItemsEntityRelationInput",
		cart:"OrderUpdateCartEntityRelationInput",
		events:"OrderUpdateEventsEntityRelationInput",
		createdAt:"DateTime",
		billingAddress:"OrderUpdateBillingAddressEntityRelationInput",
		priceLines:"OrderUpdatePriceLinesEntityRelationInput",
		payments:"OrderUpdatePaymentsEntityRelationInput",
		summary:"OrderUpdateSummaryEntityRelationInput",
		gratuity:"OrderUpdateGratuityEntityRelationInput",
		venue:"OrderUpdateVenueEntityRelationInput",
		fulfillmentNotes:"OrderUpdateFulfillmentNotesEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	OrderUpdateSummaryEntityRelationInput:{
		connect:"OrderSummaryUniqueWhere"
	},
	OrderUpdateGratuityEntityRelationInput:{
		create:"GratuityWithoutOrderCreateInput",
		update:"GratuityWithoutOrderUpdateInput",
		upsert:"OrderUpsertGratuityRelationInput",
		connect:"GratuityUniqueWhere"
	},
	GratuityWithoutOrderUpdateInput:{

	},
	OrderUpsertGratuityRelationInput:{
		update:"GratuityWithoutOrderUpdateInput",
		create:"GratuityWithoutOrderCreateInput"
	},
	OrderUpdateVenueEntityRelationInput:{
		create:"VenueWithoutOrdersCreateInput",
		update:"VenueWithoutOrdersUpdateInput",
		upsert:"OrderUpsertVenueRelationInput",
		connect:"VenueUniqueWhere"
	},
	VenueWithoutOrdersUpdateInput:{
		deadlineTemplate:"VenueUpdateDeadlineTemplateEntityRelationInput",
		timetableDays:"VenueUpdateTimetableDaysEntityRelationInput",
		timetableTemplates:"VenueUpdateTimetableTemplatesEntityRelationInput",
		staffMembers:"VenueUpdateStaffMembersEntityRelationInput",
		employeeRoles:"VenueUpdateEmployeeRolesEntityRelationInput",
		pointOfSaleApplicationDevices:"VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput",
		pointOfSaleTerminals:"VenueUpdatePointOfSaleTerminalsEntityRelationInput",
		pointOfSalePrinters:"VenueUpdatePointOfSalePrintersEntityRelationInput",
		fulfillmentNotes:"VenueUpdateFulfillmentNotesEntityRelationInput",
		areas:"VenueUpdateAreasEntityRelationInput",
		enabledUnassignReasons:"VenueUpdateEnabledUnassignReasonsEntityRelationInput",
		categories:"VenueUpdateCategoriesEntityRelationInput",
		channels:"VenueUpdateChannelsEntityRelationInput",
		pointOfSaleInitialView:"PointOfSaleInitialView"
	},
	VenueUpdateFulfillmentNotesEntityRelationInput:{
		create:"FulfillmentNoteWithoutVenuesCreateInput",
		update:"VenueUpdateFulfillmentNotesRelationInput",
		upsert:"VenueUpsertFulfillmentNotesRelationInput",
		connect:"FulfillmentNoteUniqueWhere",
		disconnect:"FulfillmentNoteUniqueWhere",
		delete:"FulfillmentNoteUniqueWhere"
	},
	VenueUpdateFulfillmentNotesRelationInput:{
		by:"FulfillmentNoteUniqueWhere",
		data:"FulfillmentNoteWithoutVenuesUpdateInput"
	},
	FulfillmentNoteWithoutVenuesUpdateInput:{
		products:"FulfillmentNoteUpdateProductsEntityRelationInput",
		tags:"FulfillmentNoteUpdateTagsEntityRelationInput",
		cartItems:"FulfillmentNoteUpdateCartItemsEntityRelationInput",
		orderItems:"FulfillmentNoteUpdateOrderItemsEntityRelationInput",
		orders:"FulfillmentNoteUpdateOrdersEntityRelationInput",
		createdAt:"DateTime"
	},
	FulfillmentNoteUpdateCartItemsEntityRelationInput:{
		create:"CartItemWithoutFulfillmentNotesCreateInput",
		update:"FulfillmentNoteUpdateCartItemsRelationInput",
		upsert:"FulfillmentNoteUpsertCartItemsRelationInput",
		connect:"CartItemUniqueWhere",
		disconnect:"CartItemUniqueWhere",
		delete:"CartItemUniqueWhere"
	},
	FulfillmentNoteUpdateCartItemsRelationInput:{
		by:"CartItemUniqueWhere",
		data:"CartItemWithoutFulfillmentNotesUpdateInput"
	},
	CartItemWithoutFulfillmentNotesUpdateInput:{
		cart:"CartItemUpdateCartEntityRelationInput",
		product:"CartItemUpdateProductEntityRelationInput",
		createdAt:"DateTime",
		updatedAt:"DateTime"
	},
	FulfillmentNoteUpsertCartItemsRelationInput:{
		by:"CartItemUniqueWhere",
		update:"CartItemWithoutFulfillmentNotesUpdateInput",
		create:"CartItemWithoutFulfillmentNotesCreateInput"
	},
	FulfillmentNoteUpdateOrderItemsEntityRelationInput:{
		create:"OrderItemWithoutFulfillmentNotesCreateInput",
		update:"FulfillmentNoteUpdateOrderItemsRelationInput",
		upsert:"FulfillmentNoteUpsertOrderItemsRelationInput",
		connect:"OrderItemUniqueWhere",
		disconnect:"OrderItemUniqueWhere",
		delete:"OrderItemUniqueWhere"
	},
	FulfillmentNoteUpdateOrderItemsRelationInput:{
		by:"OrderItemUniqueWhere",
		data:"OrderItemWithoutFulfillmentNotesUpdateInput"
	},
	OrderItemWithoutFulfillmentNotesUpdateInput:{
		vatRate:"OrderItemUpdateVatRateEntityRelationInput",
		order:"OrderItemUpdateOrderEntityRelationInput",
		virtualProductEffects:"OrderItemUpdateVirtualProductEffectsEntityRelationInput",
		pickedAt:"DateTime",
		product:"OrderItemUpdateProductEntityRelationInput"
	},
	OrderItemUpdateProductEntityRelationInput:{
		create:"ProductWithoutOrderItemsCreateInput",
		update:"ProductWithoutOrderItemsUpdateInput",
		upsert:"OrderItemUpsertProductRelationInput",
		connect:"ProductUniqueWhere"
	},
	ProductWithoutOrderItemsUpdateInput:{
		packing:"ProductUpdatePackingEntityRelationInput",
		recipe:"ProductUpdateRecipeEntityRelationInput",
		tags:"ProductUpdateTagsEntityRelationInput",
		categories:"ProductUpdateCategoriesEntityRelationInput",
		vatRate:"ProductUpdateVatRateEntityRelationInput",
		stocks:"ProductUpdateStocksEntityRelationInput",
		groupPrices:"ProductUpdateGroupPricesEntityRelationInput",
		image:"ProductUpdateImageEntityRelationInput",
		cartItems:"ProductUpdateCartItemsEntityRelationInput",
		availability:"ProductAvailability",
		manager:"ProductUpdateManagerEntityRelationInput",
		inheritedCategories:"ProductUpdateInheritedCategoriesEntityRelationInput",
		deliveryZones:"ProductUpdateDeliveryZonesEntityRelationInput",
		locales:"ProductUpdateLocalesEntityRelationInput",
		archivedAt:"DateTime",
		customerPrices:"ProductUpdateCustomerPricesEntityRelationInput",
		virtualProduct:"ProductUpdateVirtualProductEntityRelationInput",
		meta:"ProductUpdateMetaEntityRelationInput",
		page:"ProductUpdatePageEntityRelationInput",
		salesDays:"ProductUpdateSalesDaysEntityRelationInput",
		salesWeeks:"ProductUpdateSalesWeeksEntityRelationInput",
		salesMonths:"ProductUpdateSalesMonthsEntityRelationInput",
		fulfillmentNotes:"ProductUpdateFulfillmentNotesEntityRelationInput"
	},
	OrderItemUpsertProductRelationInput:{
		update:"ProductWithoutOrderItemsUpdateInput",
		create:"ProductWithoutOrderItemsCreateInput"
	},
	FulfillmentNoteUpsertOrderItemsRelationInput:{
		by:"OrderItemUniqueWhere",
		update:"OrderItemWithoutFulfillmentNotesUpdateInput",
		create:"OrderItemWithoutFulfillmentNotesCreateInput"
	},
	FulfillmentNoteUpdateOrdersEntityRelationInput:{
		create:"OrderWithoutFulfillmentNotesCreateInput",
		update:"FulfillmentNoteUpdateOrdersRelationInput",
		upsert:"FulfillmentNoteUpsertOrdersRelationInput",
		connect:"OrderUniqueWhere",
		disconnect:"OrderUniqueWhere",
		delete:"OrderUniqueWhere"
	},
	FulfillmentNoteUpdateOrdersRelationInput:{
		by:"OrderUniqueWhere",
		data:"OrderWithoutFulfillmentNotesUpdateInput"
	},
	OrderWithoutFulfillmentNotesUpdateInput:{
		state:"OrderState",
		fulfilledAt:"DateTime",
		canceledAt:"DateTime",
		customer:"OrderUpdateCustomerEntityRelationInput",
		channel:"OrderUpdateChannelEntityRelationInput",
		discounts:"OrderUpdateDiscountsEntityRelationInput",
		delivery:"OrderUpdateDeliveryEntityRelationInput",
		items:"OrderUpdateItemsEntityRelationInput",
		cart:"OrderUpdateCartEntityRelationInput",
		events:"OrderUpdateEventsEntityRelationInput",
		createdAt:"DateTime",
		billingAddress:"OrderUpdateBillingAddressEntityRelationInput",
		priceLines:"OrderUpdatePriceLinesEntityRelationInput",
		payments:"OrderUpdatePaymentsEntityRelationInput",
		billingSubject:"OrderUpdateBillingSubjectEntityRelationInput",
		summary:"OrderUpdateSummaryEntityRelationInput",
		gratuity:"OrderUpdateGratuityEntityRelationInput",
		venue:"OrderUpdateVenueEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	OrderUpdateBillingSubjectEntityRelationInput:{
		create:"BillingSubjectWithoutOrdersCreateInput",
		update:"BillingSubjectWithoutOrdersUpdateInput",
		upsert:"OrderUpsertBillingSubjectRelationInput",
		connect:"BillingSubjectUniqueWhere"
	},
	BillingSubjectWithoutOrdersUpdateInput:{
		createdAt:"DateTime",
		deletedAt:"DateTime",
		country:"BillingSubjectUpdateCountryEntityRelationInput",
		customer:"BillingSubjectUpdateCustomerEntityRelationInput",
		invoices:"BillingSubjectUpdateInvoicesEntityRelationInput",
		defaultBillingSubjectOfCustomer:"BillingSubjectUpdateDefaultBillingSubjectOfCustomerEntityRelationInput"
	},
	BillingSubjectUpdateDefaultBillingSubjectOfCustomerEntityRelationInput:{
		create:"CustomerWithoutDefaultBillingSubjectCreateInput",
		update:"CustomerWithoutDefaultBillingSubjectUpdateInput",
		upsert:"BillingSubjectUpsertDefaultBillingSubjectOfCustomerRelationInput",
		connect:"CustomerUniqueWhere"
	},
	CustomerWithoutDefaultBillingSubjectUpdateInput:{
		addresses:"CustomerUpdateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerUpdateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerUpdateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerUpdateTagsEntityRelationInput",
		credits:"CustomerUpdateCreditsEntityRelationInput",
		paymentMethods:"CustomerUpdatePaymentMethodsEntityRelationInput",
		orders:"CustomerUpdateOrdersEntityRelationInput",
		permissions:"CustomerUpdatePermissionsEntityRelationInput",
		group:"CustomerUpdateGroupEntityRelationInput",
		photo:"CustomerUpdatePhotoEntityRelationInput",
		name:"CustomerUpdateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerUpdateIngredientRatingsEntityRelationInput",
		business:"CustomerUpdateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerUpdateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerUpdateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerUpdateCartsEntityRelationInput",
		shortcutList:"CustomerUpdateShortcutListEntityRelationInput",
		user:"CustomerUpdateUserEntityRelationInput",
		channels:"CustomerUpdateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerUpdateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerUpdateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerUpdateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerUpdateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerUpdateDefaultDeliveryAddressEntityRelationInput",
		anonymousSession:"CustomerUpdateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerUpdateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerUpdateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerUpdateRedeemedVouchersEntityRelationInput",
		spending:"CustomerUpdateSpendingEntityRelationInput",
		customerTabs:"CustomerUpdateCustomerTabsEntityRelationInput",
		lead:"CustomerUpdateLeadEntityRelationInput",
		meta:"CustomerUpdateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerUpdateAnonymousSessionEntityRelationInput:{
		create:"AnonymousSessionWithoutCustomerCreateInput",
		update:"AnonymousSessionWithoutCustomerUpdateInput",
		upsert:"CustomerUpsertAnonymousSessionRelationInput",
		connect:"AnonymousSessionUniqueWhere"
	},
	AnonymousSessionWithoutCustomerUpdateInput:{
		createdAt:"DateTime",
		lastActiveAt:"DateTime",
		devices:"AnonymousSessionUpdateDevicesEntityRelationInput"
	},
	AnonymousSessionUpdateDevicesEntityRelationInput:{
		create:"UserDeviceWithoutAnonymousSessionCreateInput",
		update:"AnonymousSessionUpdateDevicesRelationInput",
		upsert:"AnonymousSessionUpsertDevicesRelationInput",
		connect:"UserDeviceUniqueWhere",
		disconnect:"UserDeviceUniqueWhere",
		delete:"UserDeviceUniqueWhere"
	},
	AnonymousSessionUpdateDevicesRelationInput:{
		by:"UserDeviceUniqueWhere",
		data:"UserDeviceWithoutAnonymousSessionUpdateInput"
	},
	UserDeviceWithoutAnonymousSessionUpdateInput:{
		createdAt:"DateTime",
		lastActiveAt:"DateTime",
		user:"UserDeviceUpdateUserEntityRelationInput"
	},
	UserDeviceUpdateUserEntityRelationInput:{
		create:"UserWithoutDevicesCreateInput",
		update:"UserWithoutDevicesUpdateInput",
		upsert:"UserDeviceUpsertUserRelationInput",
		connect:"UserUniqueWhere"
	},
	UserWithoutDevicesUpdateInput:{
		staff:"UserUpdateStaffEntityRelationInput",
		customer:"UserUpdateCustomerEntityRelationInput",
		tenantPersonId:"UUID",
		disabledAt:"DateTime",
		verifiedAt:"DateTime",
		createdAt:"DateTime",
		deletionRequestedAt:"DateTime",
		deletionExpectedAt:"DateTime",
		deletedAt:"DateTime",
		meta:"UserUpdateMetaEntityRelationInput",
		identificationAttempts:"UserUpdateIdentificationAttemptsEntityRelationInput",
		roles:"UserUpdateRolesEntityRelationInput"
	},
	UserUpdateRolesEntityRelationInput:{
		connect:"UserRolesUniqueWhere"
	},
	UserDeviceUpsertUserRelationInput:{
		update:"UserWithoutDevicesUpdateInput",
		create:"UserWithoutDevicesCreateInput"
	},
	AnonymousSessionUpsertDevicesRelationInput:{
		by:"UserDeviceUniqueWhere",
		update:"UserDeviceWithoutAnonymousSessionUpdateInput",
		create:"UserDeviceWithoutAnonymousSessionCreateInput"
	},
	CustomerUpsertAnonymousSessionRelationInput:{
		update:"AnonymousSessionWithoutCustomerUpdateInput",
		create:"AnonymousSessionWithoutCustomerCreateInput"
	},
	CustomerUpdateBoughtVouchersEntityRelationInput:{
		create:"VoucherWithoutBuyerCreateInput",
		update:"CustomerUpdateBoughtVouchersRelationInput",
		upsert:"CustomerUpsertBoughtVouchersRelationInput",
		connect:"VoucherUniqueWhere",
		disconnect:"VoucherUniqueWhere",
		delete:"VoucherUniqueWhere"
	},
	CustomerUpdateBoughtVouchersRelationInput:{
		by:"VoucherUniqueWhere",
		data:"VoucherWithoutBuyerUpdateInput"
	},
	VoucherWithoutBuyerUpdateInput:{
		createdAt:"DateTime",
		activatedAt:"DateTime",
		expiresAt:"DateTime",
		type:"VoucherType",
		owner:"VoucherUpdateOwnerEntityRelationInput",
		vatRate:"VoucherUpdateVatRateEntityRelationInput",
		virtualProductEffect:"VoucherUpdateVirtualProductEffectEntityRelationInput",
		redemption:"VoucherUpdateRedemptionEntityRelationInput"
	},
	VoucherUpdateOwnerEntityRelationInput:{
		create:"CustomerWithoutOwnsVouchersCreateInput",
		update:"CustomerWithoutOwnsVouchersUpdateInput",
		upsert:"VoucherUpsertOwnerRelationInput",
		connect:"CustomerUniqueWhere"
	},
	CustomerWithoutOwnsVouchersUpdateInput:{
		addresses:"CustomerUpdateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerUpdateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerUpdateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerUpdateTagsEntityRelationInput",
		credits:"CustomerUpdateCreditsEntityRelationInput",
		paymentMethods:"CustomerUpdatePaymentMethodsEntityRelationInput",
		orders:"CustomerUpdateOrdersEntityRelationInput",
		permissions:"CustomerUpdatePermissionsEntityRelationInput",
		group:"CustomerUpdateGroupEntityRelationInput",
		photo:"CustomerUpdatePhotoEntityRelationInput",
		name:"CustomerUpdateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerUpdateIngredientRatingsEntityRelationInput",
		business:"CustomerUpdateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerUpdateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerUpdateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerUpdateCartsEntityRelationInput",
		shortcutList:"CustomerUpdateShortcutListEntityRelationInput",
		user:"CustomerUpdateUserEntityRelationInput",
		channels:"CustomerUpdateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerUpdateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerUpdateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerUpdateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerUpdateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerUpdateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerUpdateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerUpdateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerUpdateBoughtVouchersEntityRelationInput",
		redeemedVouchers:"CustomerUpdateRedeemedVouchersEntityRelationInput",
		spending:"CustomerUpdateSpendingEntityRelationInput",
		customerTabs:"CustomerUpdateCustomerTabsEntityRelationInput",
		lead:"CustomerUpdateLeadEntityRelationInput",
		meta:"CustomerUpdateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerUpdateRedeemedVouchersEntityRelationInput:{
		create:"VoucherRedemptionWithoutCustomerCreateInput",
		update:"CustomerUpdateRedeemedVouchersRelationInput",
		upsert:"CustomerUpsertRedeemedVouchersRelationInput",
		connect:"VoucherRedemptionUniqueWhere",
		disconnect:"VoucherRedemptionUniqueWhere",
		delete:"VoucherRedemptionUniqueWhere"
	},
	CustomerUpdateRedeemedVouchersRelationInput:{
		by:"VoucherRedemptionUniqueWhere",
		data:"VoucherRedemptionWithoutCustomerUpdateInput"
	},
	VoucherRedemptionWithoutCustomerUpdateInput:{
		createdAt:"DateTime",
		customerCredit:"VoucherRedemptionUpdateCustomerCreditEntityRelationInput",
		orderDiscount:"VoucherRedemptionUpdateOrderDiscountEntityRelationInput",
		voucher:"VoucherRedemptionUpdateVoucherEntityRelationInput"
	},
	VoucherRedemptionUpdateCustomerCreditEntityRelationInput:{
		create:"CustomerCreditWithoutVoucherRedemptionCreateInput",
		update:"CustomerCreditWithoutVoucherRedemptionUpdateInput",
		upsert:"VoucherRedemptionUpsertCustomerCreditRelationInput",
		connect:"CustomerCreditUniqueWhere"
	},
	CustomerCreditWithoutVoucherRedemptionUpdateInput:{
		expiresAt:"DateTime",
		customer:"CustomerCreditUpdateCustomerEntityRelationInput",
		vatRate:"CustomerCreditUpdateVatRateEntityRelationInput",
		createdAt:"DateTime",
		transactions:"CustomerCreditUpdateTransactionsEntityRelationInput"
	},
	CustomerCreditUpdateTransactionsEntityRelationInput:{
		create:"CustomerCreditTransactionWithoutCustomerCreditCreateInput",
		update:"CustomerCreditUpdateTransactionsRelationInput",
		upsert:"CustomerCreditUpsertTransactionsRelationInput",
		connect:"CustomerCreditTransactionUniqueWhere",
		disconnect:"CustomerCreditTransactionUniqueWhere",
		delete:"CustomerCreditTransactionUniqueWhere"
	},
	CustomerCreditUpdateTransactionsRelationInput:{
		by:"CustomerCreditTransactionUniqueWhere",
		data:"CustomerCreditTransactionWithoutCustomerCreditUpdateInput"
	},
	CustomerCreditTransactionWithoutCustomerCreditUpdateInput:{
		createdAt:"DateTime",
		orderDiscount:"CustomerCreditTransactionUpdateOrderDiscountEntityRelationInput",
		virtualProductEffect:"CustomerCreditTransactionUpdateVirtualProductEffectEntityRelationInput"
	},
	CustomerCreditTransactionUpdateVirtualProductEffectEntityRelationInput:{
		create:"VirtualProductEffectWithoutResultCustomerCreditTransactionCreateInput",
		update:"VirtualProductEffectWithoutResultCustomerCreditTransactionUpdateInput",
		upsert:"CustomerCreditTransactionUpsertVirtualProductEffectRelationInput",
		connect:"VirtualProductEffectUniqueWhere"
	},
	VirtualProductEffectWithoutResultCustomerCreditTransactionUpdateInput:{
		createdAt:"DateTime",
		succeededAt:"DateTime",
		orderItem:"VirtualProductEffectUpdateOrderItemEntityRelationInput",
		failedAt:"DateTime",
		revertedAt:"DateTime",
		resultVouchers:"VirtualProductEffectUpdateResultVouchersEntityRelationInput"
	},
	VirtualProductEffectUpdateOrderItemEntityRelationInput:{
		create:"OrderItemWithoutVirtualProductEffectsCreateInput",
		update:"OrderItemWithoutVirtualProductEffectsUpdateInput",
		upsert:"VirtualProductEffectUpsertOrderItemRelationInput",
		connect:"OrderItemUniqueWhere"
	},
	OrderItemWithoutVirtualProductEffectsUpdateInput:{
		vatRate:"OrderItemUpdateVatRateEntityRelationInput",
		order:"OrderItemUpdateOrderEntityRelationInput",
		pickedAt:"DateTime",
		fulfillmentNotes:"OrderItemUpdateFulfillmentNotesEntityRelationInput",
		product:"OrderItemUpdateProductEntityRelationInput"
	},
	OrderItemUpdateFulfillmentNotesEntityRelationInput:{
		create:"FulfillmentNoteWithoutOrderItemsCreateInput",
		update:"OrderItemUpdateFulfillmentNotesRelationInput",
		upsert:"OrderItemUpsertFulfillmentNotesRelationInput",
		connect:"FulfillmentNoteUniqueWhere",
		disconnect:"FulfillmentNoteUniqueWhere",
		delete:"FulfillmentNoteUniqueWhere"
	},
	OrderItemUpdateFulfillmentNotesRelationInput:{
		by:"FulfillmentNoteUniqueWhere",
		data:"FulfillmentNoteWithoutOrderItemsUpdateInput"
	},
	FulfillmentNoteWithoutOrderItemsUpdateInput:{
		products:"FulfillmentNoteUpdateProductsEntityRelationInput",
		tags:"FulfillmentNoteUpdateTagsEntityRelationInput",
		venues:"FulfillmentNoteUpdateVenuesEntityRelationInput",
		cartItems:"FulfillmentNoteUpdateCartItemsEntityRelationInput",
		orders:"FulfillmentNoteUpdateOrdersEntityRelationInput",
		createdAt:"DateTime"
	},
	OrderItemUpsertFulfillmentNotesRelationInput:{
		by:"FulfillmentNoteUniqueWhere",
		update:"FulfillmentNoteWithoutOrderItemsUpdateInput",
		create:"FulfillmentNoteWithoutOrderItemsCreateInput"
	},
	VirtualProductEffectUpsertOrderItemRelationInput:{
		update:"OrderItemWithoutVirtualProductEffectsUpdateInput",
		create:"OrderItemWithoutVirtualProductEffectsCreateInput"
	},
	VirtualProductEffectUpdateResultVouchersEntityRelationInput:{
		create:"VoucherWithoutVirtualProductEffectCreateInput",
		update:"VirtualProductEffectUpdateResultVouchersRelationInput",
		upsert:"VirtualProductEffectUpsertResultVouchersRelationInput",
		connect:"VoucherUniqueWhere",
		disconnect:"VoucherUniqueWhere",
		delete:"VoucherUniqueWhere"
	},
	VirtualProductEffectUpdateResultVouchersRelationInput:{
		by:"VoucherUniqueWhere",
		data:"VoucherWithoutVirtualProductEffectUpdateInput"
	},
	VoucherWithoutVirtualProductEffectUpdateInput:{
		createdAt:"DateTime",
		activatedAt:"DateTime",
		expiresAt:"DateTime",
		type:"VoucherType",
		buyer:"VoucherUpdateBuyerEntityRelationInput",
		owner:"VoucherUpdateOwnerEntityRelationInput",
		vatRate:"VoucherUpdateVatRateEntityRelationInput",
		redemption:"VoucherUpdateRedemptionEntityRelationInput"
	},
	VoucherUpdateBuyerEntityRelationInput:{
		create:"CustomerWithoutBoughtVouchersCreateInput",
		update:"CustomerWithoutBoughtVouchersUpdateInput",
		upsert:"VoucherUpsertBuyerRelationInput",
		connect:"CustomerUniqueWhere"
	},
	CustomerWithoutBoughtVouchersUpdateInput:{
		addresses:"CustomerUpdateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerUpdateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerUpdateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerUpdateTagsEntityRelationInput",
		credits:"CustomerUpdateCreditsEntityRelationInput",
		paymentMethods:"CustomerUpdatePaymentMethodsEntityRelationInput",
		orders:"CustomerUpdateOrdersEntityRelationInput",
		permissions:"CustomerUpdatePermissionsEntityRelationInput",
		group:"CustomerUpdateGroupEntityRelationInput",
		photo:"CustomerUpdatePhotoEntityRelationInput",
		name:"CustomerUpdateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerUpdateIngredientRatingsEntityRelationInput",
		business:"CustomerUpdateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerUpdateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerUpdateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerUpdateCartsEntityRelationInput",
		shortcutList:"CustomerUpdateShortcutListEntityRelationInput",
		user:"CustomerUpdateUserEntityRelationInput",
		channels:"CustomerUpdateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerUpdateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerUpdateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerUpdateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerUpdateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerUpdateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerUpdateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerUpdateAnonymousSessionEntityRelationInput",
		ownsVouchers:"CustomerUpdateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerUpdateRedeemedVouchersEntityRelationInput",
		spending:"CustomerUpdateSpendingEntityRelationInput",
		customerTabs:"CustomerUpdateCustomerTabsEntityRelationInput",
		lead:"CustomerUpdateLeadEntityRelationInput",
		meta:"CustomerUpdateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerUpdateOwnsVouchersEntityRelationInput:{
		create:"VoucherWithoutOwnerCreateInput",
		update:"CustomerUpdateOwnsVouchersRelationInput",
		upsert:"CustomerUpsertOwnsVouchersRelationInput",
		connect:"VoucherUniqueWhere",
		disconnect:"VoucherUniqueWhere",
		delete:"VoucherUniqueWhere"
	},
	CustomerUpdateOwnsVouchersRelationInput:{
		by:"VoucherUniqueWhere",
		data:"VoucherWithoutOwnerUpdateInput"
	},
	VoucherWithoutOwnerUpdateInput:{
		createdAt:"DateTime",
		activatedAt:"DateTime",
		expiresAt:"DateTime",
		type:"VoucherType",
		buyer:"VoucherUpdateBuyerEntityRelationInput",
		vatRate:"VoucherUpdateVatRateEntityRelationInput",
		virtualProductEffect:"VoucherUpdateVirtualProductEffectEntityRelationInput",
		redemption:"VoucherUpdateRedemptionEntityRelationInput"
	},
	VoucherUpdateVatRateEntityRelationInput:{
		create:"VatRateCreateInput",
		update:"VatRateUpdateInput",
		upsert:"VoucherUpsertVatRateRelationInput",
		connect:"VatRateUniqueWhere"
	},
	VoucherUpsertVatRateRelationInput:{
		update:"VatRateUpdateInput",
		create:"VatRateCreateInput"
	},
	VoucherUpdateVirtualProductEffectEntityRelationInput:{
		create:"VirtualProductEffectWithoutResultVouchersCreateInput",
		update:"VirtualProductEffectWithoutResultVouchersUpdateInput",
		upsert:"VoucherUpsertVirtualProductEffectRelationInput",
		connect:"VirtualProductEffectUniqueWhere"
	},
	VirtualProductEffectWithoutResultVouchersUpdateInput:{
		createdAt:"DateTime",
		succeededAt:"DateTime",
		orderItem:"VirtualProductEffectUpdateOrderItemEntityRelationInput",
		failedAt:"DateTime",
		revertedAt:"DateTime",
		resultCustomerCreditTransaction:"VirtualProductEffectUpdateResultCustomerCreditTransactionEntityRelationInput"
	},
	VoucherUpsertVirtualProductEffectRelationInput:{
		update:"VirtualProductEffectWithoutResultVouchersUpdateInput",
		create:"VirtualProductEffectWithoutResultVouchersCreateInput"
	},
	VoucherUpdateRedemptionEntityRelationInput:{
		create:"VoucherRedemptionWithoutVoucherCreateInput",
		update:"VoucherRedemptionWithoutVoucherUpdateInput",
		upsert:"VoucherUpsertRedemptionRelationInput",
		connect:"VoucherRedemptionUniqueWhere"
	},
	VoucherRedemptionWithoutVoucherUpdateInput:{
		createdAt:"DateTime",
		customerCredit:"VoucherRedemptionUpdateCustomerCreditEntityRelationInput",
		orderDiscount:"VoucherRedemptionUpdateOrderDiscountEntityRelationInput",
		customer:"VoucherRedemptionUpdateCustomerEntityRelationInput"
	},
	VoucherRedemptionUpdateOrderDiscountEntityRelationInput:{
		create:"OrderDiscountWithoutVoucherRedemptionCreateInput",
		update:"OrderDiscountWithoutVoucherRedemptionUpdateInput",
		upsert:"VoucherRedemptionUpsertOrderDiscountRelationInput",
		connect:"OrderDiscountUniqueWhere"
	},
	OrderDiscountWithoutVoucherRedemptionUpdateInput:{
		vatRate:"OrderDiscountUpdateVatRateEntityRelationInput",
		order:"OrderDiscountUpdateOrderEntityRelationInput",
		type:"OrderDiscountType",
		customerCreditTransactions:"OrderDiscountUpdateCustomerCreditTransactionsEntityRelationInput"
	},
	VoucherRedemptionUpsertOrderDiscountRelationInput:{
		update:"OrderDiscountWithoutVoucherRedemptionUpdateInput",
		create:"OrderDiscountWithoutVoucherRedemptionCreateInput"
	},
	VoucherRedemptionUpdateCustomerEntityRelationInput:{
		create:"CustomerWithoutRedeemedVouchersCreateInput",
		update:"CustomerWithoutRedeemedVouchersUpdateInput",
		upsert:"VoucherRedemptionUpsertCustomerRelationInput",
		connect:"CustomerUniqueWhere"
	},
	CustomerWithoutRedeemedVouchersUpdateInput:{
		addresses:"CustomerUpdateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerUpdateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerUpdateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerUpdateTagsEntityRelationInput",
		credits:"CustomerUpdateCreditsEntityRelationInput",
		paymentMethods:"CustomerUpdatePaymentMethodsEntityRelationInput",
		orders:"CustomerUpdateOrdersEntityRelationInput",
		permissions:"CustomerUpdatePermissionsEntityRelationInput",
		group:"CustomerUpdateGroupEntityRelationInput",
		photo:"CustomerUpdatePhotoEntityRelationInput",
		name:"CustomerUpdateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerUpdateIngredientRatingsEntityRelationInput",
		business:"CustomerUpdateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerUpdateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerUpdateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerUpdateCartsEntityRelationInput",
		shortcutList:"CustomerUpdateShortcutListEntityRelationInput",
		user:"CustomerUpdateUserEntityRelationInput",
		channels:"CustomerUpdateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerUpdateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerUpdateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerUpdateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerUpdateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerUpdateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerUpdateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerUpdateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerUpdateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerUpdateOwnsVouchersEntityRelationInput",
		spending:"CustomerUpdateSpendingEntityRelationInput",
		customerTabs:"CustomerUpdateCustomerTabsEntityRelationInput",
		lead:"CustomerUpdateLeadEntityRelationInput",
		meta:"CustomerUpdateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerUpdateSpendingEntityRelationInput:{
		connect:"CustomerSpendingUniqueWhere"
	},
	CustomerUpdateCustomerTabsEntityRelationInput:{
		create:"CustomerTabWithoutCustomerCreateInput",
		update:"CustomerUpdateCustomerTabsRelationInput",
		upsert:"CustomerUpsertCustomerTabsRelationInput",
		connect:"CustomerTabUniqueWhere",
		disconnect:"CustomerTabUniqueWhere",
		delete:"CustomerTabUniqueWhere"
	},
	CustomerUpdateCustomerTabsRelationInput:{
		by:"CustomerTabUniqueWhere",
		data:"CustomerTabWithoutCustomerUpdateInput"
	},
	CustomerTabWithoutCustomerUpdateInput:{
		createdAt:"DateTime",
		items:"CustomerTabUpdateItemsEntityRelationInput",
		meta:"CustomerTabUpdateMetaEntityRelationInput",
		table:"CustomerTabUpdateTableEntityRelationInput",
		seat:"CustomerTabUpdateSeatEntityRelationInput"
	},
	CustomerTabUpdateItemsEntityRelationInput:{
		create:"CustomerTabItemWithoutTabCreateInput",
		update:"CustomerTabUpdateItemsRelationInput",
		upsert:"CustomerTabUpsertItemsRelationInput",
		connect:"CustomerTabItemUniqueWhere",
		disconnect:"CustomerTabItemUniqueWhere",
		delete:"CustomerTabItemUniqueWhere"
	},
	CustomerTabUpdateItemsRelationInput:{
		by:"CustomerTabItemUniqueWhere",
		data:"CustomerTabItemWithoutTabUpdateInput"
	},
	CustomerTabItemWithoutTabUpdateInput:{
		addedAt:"DateTime",
		product:"CustomerTabItemUpdateProductEntityRelationInput",
		paidAt:"DateTime"
	},
	CustomerTabItemUpdateProductEntityRelationInput:{
		create:"ProductCreateInput",
		update:"ProductUpdateInput",
		upsert:"CustomerTabItemUpsertProductRelationInput",
		connect:"ProductUniqueWhere"
	},
	CustomerTabItemUpsertProductRelationInput:{
		update:"ProductUpdateInput",
		create:"ProductCreateInput"
	},
	CustomerTabUpsertItemsRelationInput:{
		by:"CustomerTabItemUniqueWhere",
		update:"CustomerTabItemWithoutTabUpdateInput",
		create:"CustomerTabItemWithoutTabCreateInput"
	},
	CustomerTabUpdateMetaEntityRelationInput:{
		connect:"CustomerTabMetadataUniqueWhere"
	},
	CustomerTabUpdateTableEntityRelationInput:{
		create:"TableWithoutCustomerTabsCreateInput",
		update:"TableWithoutCustomerTabsUpdateInput",
		upsert:"CustomerTabUpsertTableRelationInput",
		connect:"TableUniqueWhere"
	},
	TableWithoutCustomerTabsUpdateInput:{
		shape:"TableShape",
		area:"TableUpdateAreaEntityRelationInput",
		seats:"TableUpdateSeatsEntityRelationInput"
	},
	TableUpdateAreaEntityRelationInput:{
		create:"AreaWithoutTablesCreateInput",
		update:"AreaWithoutTablesUpdateInput",
		upsert:"TableUpsertAreaRelationInput",
		connect:"AreaUniqueWhere"
	},
	AreaWithoutTablesUpdateInput:{
		venue:"AreaUpdateVenueEntityRelationInput",
		lines:"AreaUpdateLinesEntityRelationInput"
	},
	AreaUpdateVenueEntityRelationInput:{
		create:"VenueWithoutAreasCreateInput",
		update:"VenueWithoutAreasUpdateInput",
		upsert:"AreaUpsertVenueRelationInput",
		connect:"VenueUniqueWhere"
	},
	VenueWithoutAreasUpdateInput:{
		deadlineTemplate:"VenueUpdateDeadlineTemplateEntityRelationInput",
		timetableDays:"VenueUpdateTimetableDaysEntityRelationInput",
		timetableTemplates:"VenueUpdateTimetableTemplatesEntityRelationInput",
		staffMembers:"VenueUpdateStaffMembersEntityRelationInput",
		employeeRoles:"VenueUpdateEmployeeRolesEntityRelationInput",
		pointOfSaleApplicationDevices:"VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput",
		pointOfSaleTerminals:"VenueUpdatePointOfSaleTerminalsEntityRelationInput",
		pointOfSalePrinters:"VenueUpdatePointOfSalePrintersEntityRelationInput",
		orders:"VenueUpdateOrdersEntityRelationInput",
		fulfillmentNotes:"VenueUpdateFulfillmentNotesEntityRelationInput",
		enabledUnassignReasons:"VenueUpdateEnabledUnassignReasonsEntityRelationInput",
		categories:"VenueUpdateCategoriesEntityRelationInput",
		channels:"VenueUpdateChannelsEntityRelationInput",
		pointOfSaleInitialView:"PointOfSaleInitialView"
	},
	VenueUpdateEnabledUnassignReasonsEntityRelationInput:{
		create:"UnassignReasonWithoutVenuesCreateInput",
		update:"VenueUpdateEnabledUnassignReasonsRelationInput",
		upsert:"VenueUpsertEnabledUnassignReasonsRelationInput",
		connect:"UnassignReasonUniqueWhere",
		disconnect:"UnassignReasonUniqueWhere",
		delete:"UnassignReasonUniqueWhere"
	},
	VenueUpdateEnabledUnassignReasonsRelationInput:{
		by:"UnassignReasonUniqueWhere",
		data:"UnassignReasonWithoutVenuesUpdateInput"
	},
	UnassignReasonWithoutVenuesUpdateInput:{

	},
	VenueUpsertEnabledUnassignReasonsRelationInput:{
		by:"UnassignReasonUniqueWhere",
		update:"UnassignReasonWithoutVenuesUpdateInput",
		create:"UnassignReasonWithoutVenuesCreateInput"
	},
	VenueUpdateCategoriesEntityRelationInput:{
		create:"PointOfSaleCategoryWithoutVenueCreateInput",
		update:"VenueUpdateCategoriesRelationInput",
		upsert:"VenueUpsertCategoriesRelationInput",
		connect:"PointOfSaleCategoryUniqueWhere",
		disconnect:"PointOfSaleCategoryUniqueWhere",
		delete:"PointOfSaleCategoryUniqueWhere"
	},
	VenueUpdateCategoriesRelationInput:{
		by:"PointOfSaleCategoryUniqueWhere",
		data:"PointOfSaleCategoryWithoutVenueUpdateInput"
	},
	PointOfSaleCategoryWithoutVenueUpdateInput:{
		locales:"PointOfSaleCategoryUpdateLocalesEntityRelationInput",
		products:"PointOfSaleCategoryUpdateProductsEntityRelationInput",
		category:"PointOfSaleCategoryUpdateCategoryEntityRelationInput",
		ticketPrinters:"PointOfSaleCategoryUpdateTicketPrintersEntityRelationInput"
	},
	PointOfSaleCategoryUpdateCategoryEntityRelationInput:{
		create:"ProductCategoryCreateInput",
		update:"ProductCategoryUpdateInput",
		upsert:"PointOfSaleCategoryUpsertCategoryRelationInput",
		connect:"ProductCategoryUniqueWhere"
	},
	PointOfSaleCategoryUpsertCategoryRelationInput:{
		update:"ProductCategoryUpdateInput",
		create:"ProductCategoryCreateInput"
	},
	PointOfSaleCategoryUpdateTicketPrintersEntityRelationInput:{
		create:"PointOfSalePrinterWithoutTicketCategoriesCreateInput",
		update:"PointOfSaleCategoryUpdateTicketPrintersRelationInput",
		upsert:"PointOfSaleCategoryUpsertTicketPrintersRelationInput",
		connect:"PointOfSalePrinterUniqueWhere",
		disconnect:"PointOfSalePrinterUniqueWhere",
		delete:"PointOfSalePrinterUniqueWhere"
	},
	PointOfSaleCategoryUpdateTicketPrintersRelationInput:{
		by:"PointOfSalePrinterUniqueWhere",
		data:"PointOfSalePrinterWithoutTicketCategoriesUpdateInput"
	},
	PointOfSalePrinterWithoutTicketCategoriesUpdateInput:{
		applicationDevicesReceipt:"PointOfSalePrinterUpdateApplicationDevicesReceiptEntityRelationInput",
		applicationDevicesTicket:"PointOfSalePrinterUpdateApplicationDevicesTicketEntityRelationInput",
		venue:"PointOfSalePrinterUpdateVenueEntityRelationInput"
	},
	PointOfSalePrinterUpdateApplicationDevicesTicketEntityRelationInput:{
		create:"PointOfSaleApplicationDeviceWithoutTicketPrintersCreateInput",
		update:"PointOfSalePrinterUpdateApplicationDevicesTicketRelationInput",
		upsert:"PointOfSalePrinterUpsertApplicationDevicesTicketRelationInput",
		connect:"PointOfSaleApplicationDeviceUniqueWhere",
		disconnect:"PointOfSaleApplicationDeviceUniqueWhere",
		delete:"PointOfSaleApplicationDeviceUniqueWhere"
	},
	PointOfSalePrinterUpdateApplicationDevicesTicketRelationInput:{
		by:"PointOfSaleApplicationDeviceUniqueWhere",
		data:"PointOfSaleApplicationDeviceWithoutTicketPrintersUpdateInput"
	},
	PointOfSaleApplicationDeviceWithoutTicketPrintersUpdateInput:{
		venue:"PointOfSaleApplicationDeviceUpdateVenueEntityRelationInput",
		identificationCode:"PointOfSaleApplicationDeviceUpdateIdentificationCodeEntityRelationInput",
		identifier:"PointOfSaleApplicationDeviceUpdateIdentifierEntityRelationInput",
		terminal:"PointOfSaleApplicationDeviceUpdateTerminalEntityRelationInput",
		receiptPrinter:"PointOfSaleApplicationDeviceUpdateReceiptPrinterEntityRelationInput"
	},
	PointOfSaleApplicationDeviceUpdateReceiptPrinterEntityRelationInput:{
		create:"PointOfSalePrinterWithoutApplicationDevicesReceiptCreateInput",
		update:"PointOfSalePrinterWithoutApplicationDevicesReceiptUpdateInput",
		upsert:"PointOfSaleApplicationDeviceUpsertReceiptPrinterRelationInput",
		connect:"PointOfSalePrinterUniqueWhere"
	},
	PointOfSalePrinterWithoutApplicationDevicesReceiptUpdateInput:{
		applicationDevicesTicket:"PointOfSalePrinterUpdateApplicationDevicesTicketEntityRelationInput",
		venue:"PointOfSalePrinterUpdateVenueEntityRelationInput",
		ticketCategories:"PointOfSalePrinterUpdateTicketCategoriesEntityRelationInput"
	},
	PointOfSalePrinterUpdateVenueEntityRelationInput:{
		create:"VenueWithoutPointOfSalePrintersCreateInput",
		update:"VenueWithoutPointOfSalePrintersUpdateInput",
		upsert:"PointOfSalePrinterUpsertVenueRelationInput",
		connect:"VenueUniqueWhere"
	},
	VenueWithoutPointOfSalePrintersUpdateInput:{
		deadlineTemplate:"VenueUpdateDeadlineTemplateEntityRelationInput",
		timetableDays:"VenueUpdateTimetableDaysEntityRelationInput",
		timetableTemplates:"VenueUpdateTimetableTemplatesEntityRelationInput",
		staffMembers:"VenueUpdateStaffMembersEntityRelationInput",
		employeeRoles:"VenueUpdateEmployeeRolesEntityRelationInput",
		pointOfSaleApplicationDevices:"VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput",
		pointOfSaleTerminals:"VenueUpdatePointOfSaleTerminalsEntityRelationInput",
		orders:"VenueUpdateOrdersEntityRelationInput",
		fulfillmentNotes:"VenueUpdateFulfillmentNotesEntityRelationInput",
		areas:"VenueUpdateAreasEntityRelationInput",
		enabledUnassignReasons:"VenueUpdateEnabledUnassignReasonsEntityRelationInput",
		categories:"VenueUpdateCategoriesEntityRelationInput",
		channels:"VenueUpdateChannelsEntityRelationInput",
		pointOfSaleInitialView:"PointOfSaleInitialView"
	},
	VenueUpdateAreasEntityRelationInput:{
		create:"AreaWithoutVenueCreateInput",
		update:"VenueUpdateAreasRelationInput",
		upsert:"VenueUpsertAreasRelationInput",
		connect:"AreaUniqueWhere",
		disconnect:"AreaUniqueWhere",
		delete:"AreaUniqueWhere"
	},
	VenueUpdateAreasRelationInput:{
		by:"AreaUniqueWhere",
		data:"AreaWithoutVenueUpdateInput"
	},
	AreaWithoutVenueUpdateInput:{
		tables:"AreaUpdateTablesEntityRelationInput",
		lines:"AreaUpdateLinesEntityRelationInput"
	},
	AreaUpdateTablesEntityRelationInput:{
		create:"TableWithoutAreaCreateInput",
		update:"AreaUpdateTablesRelationInput",
		upsert:"AreaUpsertTablesRelationInput",
		connect:"TableUniqueWhere",
		disconnect:"TableUniqueWhere",
		delete:"TableUniqueWhere"
	},
	AreaUpdateTablesRelationInput:{
		by:"TableUniqueWhere",
		data:"TableWithoutAreaUpdateInput"
	},
	TableWithoutAreaUpdateInput:{
		shape:"TableShape",
		customerTabs:"TableUpdateCustomerTabsEntityRelationInput",
		seats:"TableUpdateSeatsEntityRelationInput"
	},
	TableUpdateCustomerTabsEntityRelationInput:{
		create:"CustomerTabWithoutTableCreateInput",
		update:"TableUpdateCustomerTabsRelationInput",
		upsert:"TableUpsertCustomerTabsRelationInput",
		connect:"CustomerTabUniqueWhere",
		disconnect:"CustomerTabUniqueWhere",
		delete:"CustomerTabUniqueWhere"
	},
	TableUpdateCustomerTabsRelationInput:{
		by:"CustomerTabUniqueWhere",
		data:"CustomerTabWithoutTableUpdateInput"
	},
	CustomerTabWithoutTableUpdateInput:{
		createdAt:"DateTime",
		items:"CustomerTabUpdateItemsEntityRelationInput",
		meta:"CustomerTabUpdateMetaEntityRelationInput",
		customer:"CustomerTabUpdateCustomerEntityRelationInput",
		seat:"CustomerTabUpdateSeatEntityRelationInput"
	},
	CustomerTabUpdateCustomerEntityRelationInput:{
		create:"CustomerWithoutCustomerTabsCreateInput",
		update:"CustomerWithoutCustomerTabsUpdateInput",
		upsert:"CustomerTabUpsertCustomerRelationInput",
		connect:"CustomerUniqueWhere"
	},
	CustomerWithoutCustomerTabsUpdateInput:{
		addresses:"CustomerUpdateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerUpdateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerUpdateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerUpdateTagsEntityRelationInput",
		credits:"CustomerUpdateCreditsEntityRelationInput",
		paymentMethods:"CustomerUpdatePaymentMethodsEntityRelationInput",
		orders:"CustomerUpdateOrdersEntityRelationInput",
		permissions:"CustomerUpdatePermissionsEntityRelationInput",
		group:"CustomerUpdateGroupEntityRelationInput",
		photo:"CustomerUpdatePhotoEntityRelationInput",
		name:"CustomerUpdateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerUpdateIngredientRatingsEntityRelationInput",
		business:"CustomerUpdateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerUpdateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerUpdateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerUpdateCartsEntityRelationInput",
		shortcutList:"CustomerUpdateShortcutListEntityRelationInput",
		user:"CustomerUpdateUserEntityRelationInput",
		channels:"CustomerUpdateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerUpdateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerUpdateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerUpdateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerUpdateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerUpdateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerUpdateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerUpdateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerUpdateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerUpdateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerUpdateRedeemedVouchersEntityRelationInput",
		spending:"CustomerUpdateSpendingEntityRelationInput",
		lead:"CustomerUpdateLeadEntityRelationInput",
		meta:"CustomerUpdateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerUpdateLeadEntityRelationInput:{
		create:"PipelineLeadWithoutCustomerCreateInput",
		update:"CustomerUpdateLeadRelationInput",
		upsert:"CustomerUpsertLeadRelationInput",
		connect:"PipelineLeadUniqueWhere",
		disconnect:"PipelineLeadUniqueWhere",
		delete:"PipelineLeadUniqueWhere"
	},
	CustomerUpdateLeadRelationInput:{
		by:"PipelineLeadUniqueWhere",
		data:"PipelineLeadWithoutCustomerUpdateInput"
	},
	PipelineLeadWithoutCustomerUpdateInput:{
		createdAt:"DateTime",
		stageItem:"PipelineLeadUpdateStageItemEntityRelationInput",
		form:"PipelineLeadUpdateFormEntityRelationInput"
	},
	PipelineLeadUpdateStageItemEntityRelationInput:{
		create:"PipelineStageItemWithoutLeadCreateInput",
		update:"PipelineStageItemWithoutLeadUpdateInput",
		upsert:"PipelineLeadUpsertStageItemRelationInput",
		connect:"PipelineStageItemUniqueWhere"
	},
	PipelineStageItemWithoutLeadUpdateInput:{
		list:"PipelineStageItemUpdateListEntityRelationInput"
	},
	PipelineStageItemUpdateListEntityRelationInput:{
		create:"PipelineStageWithoutItemsCreateInput",
		update:"PipelineStageWithoutItemsUpdateInput",
		upsert:"PipelineStageItemUpsertListRelationInput",
		connect:"PipelineStageUniqueWhere"
	},
	PipelineStageWithoutItemsUpdateInput:{
		pipeline:"PipelineStageUpdatePipelineEntityRelationInput",
		locales:"PipelineStageUpdateLocalesEntityRelationInput",
		sentiment:"PipelineStageUpdateSentimentEntityRelationInput",
		type:"PipelineStageType",
		forms:"PipelineStageUpdateFormsEntityRelationInput"
	},
	PipelineStageUpdatePipelineEntityRelationInput:{
		create:"PipelineWithoutStagesCreateInput",
		update:"PipelineWithoutStagesUpdateInput",
		upsert:"PipelineStageUpsertPipelineRelationInput",
		connect:"PipelineUniqueWhere"
	},
	PipelineWithoutStagesUpdateInput:{
		unique:"One"
	},
	PipelineStageUpsertPipelineRelationInput:{
		update:"PipelineWithoutStagesUpdateInput",
		create:"PipelineWithoutStagesCreateInput"
	},
	PipelineStageUpdateLocalesEntityRelationInput:{
		create:"PipelineStageLocaleWithoutRootCreateInput",
		update:"PipelineStageUpdateLocalesRelationInput",
		upsert:"PipelineStageUpsertLocalesRelationInput",
		connect:"PipelineStageLocaleUniqueWhere",
		disconnect:"PipelineStageLocaleUniqueWhere",
		delete:"PipelineStageLocaleUniqueWhere"
	},
	PipelineStageUpdateLocalesRelationInput:{
		by:"PipelineStageLocaleUniqueWhere",
		data:"PipelineStageLocaleWithoutRootUpdateInput"
	},
	PipelineStageLocaleWithoutRootUpdateInput:{
		locale:"PipelineStageLocaleUpdateLocaleEntityRelationInput"
	},
	PipelineStageLocaleUpdateLocaleEntityRelationInput:{
		create:"LocaleWithoutPipelineStagesCreateInput",
		update:"LocaleWithoutPipelineStagesUpdateInput",
		upsert:"PipelineStageLocaleUpsertLocaleRelationInput",
		connect:"LocaleUniqueWhere"
	},
	LocaleWithoutPipelineStagesUpdateInput:{
		businessCategories:"LocaleUpdateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleUpdateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleUpdateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleUpdateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleUpdateBlogsEntityRelationInput",
		blogPosts:"LocaleUpdateBlogPostsEntityRelationInput",
		identifier:"LocaleUpdateIdentifierEntityRelationInput",
		menus:"LocaleUpdateMenusEntityRelationInput",
		pages:"LocaleUpdatePagesEntityRelationInput",
		productIngredientCategories:"LocaleUpdateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleUpdateAllergensEntityRelationInput",
		productPackings:"LocaleUpdateProductPackingsEntityRelationInput",
		products:"LocaleUpdateProductsEntityRelationInput",
		productRecipes:"LocaleUpdateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleUpdatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleUpdateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleUpdateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleUpdateIdentificationCodesEntityRelationInput",
		subscriptionBoxes:"LocaleUpdateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleUpdateBusinessServicesEntityRelationInput"
	},
	LocaleUpdateSubscriptionBoxesEntityRelationInput:{
		create:"SubscriptionBoxLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateSubscriptionBoxesRelationInput",
		upsert:"LocaleUpsertSubscriptionBoxesRelationInput",
		connect:"SubscriptionBoxLocaleUniqueWhere",
		disconnect:"SubscriptionBoxLocaleUniqueWhere",
		delete:"SubscriptionBoxLocaleUniqueWhere"
	},
	LocaleUpdateSubscriptionBoxesRelationInput:{
		by:"SubscriptionBoxLocaleUniqueWhere",
		data:"SubscriptionBoxLocaleWithoutLocaleUpdateInput"
	},
	SubscriptionBoxLocaleWithoutLocaleUpdateInput:{
		root:"SubscriptionBoxLocaleUpdateRootEntityRelationInput",
		texts:"SubscriptionBoxLocaleUpdateTextsEntityRelationInput",
		secondaryTexts:"SubscriptionBoxLocaleUpdateSecondaryTextsEntityRelationInput"
	},
	SubscriptionBoxLocaleUpdateRootEntityRelationInput:{
		create:"SubscriptionBoxWithoutLocalesCreateInput",
		update:"SubscriptionBoxWithoutLocalesUpdateInput",
		upsert:"SubscriptionBoxLocaleUpsertRootRelationInput",
		connect:"SubscriptionBoxUniqueWhere"
	},
	SubscriptionBoxWithoutLocalesUpdateInput:{
		unique:"One"
	},
	SubscriptionBoxLocaleUpsertRootRelationInput:{
		update:"SubscriptionBoxWithoutLocalesUpdateInput",
		create:"SubscriptionBoxWithoutLocalesCreateInput"
	},
	SubscriptionBoxLocaleUpdateTextsEntityRelationInput:{
		create:"TextListCreateInput",
		update:"TextListUpdateInput",
		upsert:"SubscriptionBoxLocaleUpsertTextsRelationInput",
		connect:"TextListUniqueWhere"
	},
	SubscriptionBoxLocaleUpsertTextsRelationInput:{
		update:"TextListUpdateInput",
		create:"TextListCreateInput"
	},
	SubscriptionBoxLocaleUpdateSecondaryTextsEntityRelationInput:{
		create:"TextListCreateInput",
		update:"TextListUpdateInput",
		upsert:"SubscriptionBoxLocaleUpsertSecondaryTextsRelationInput",
		connect:"TextListUniqueWhere"
	},
	SubscriptionBoxLocaleUpsertSecondaryTextsRelationInput:{
		update:"TextListUpdateInput",
		create:"TextListCreateInput"
	},
	LocaleUpsertSubscriptionBoxesRelationInput:{
		by:"SubscriptionBoxLocaleUniqueWhere",
		update:"SubscriptionBoxLocaleWithoutLocaleUpdateInput",
		create:"SubscriptionBoxLocaleWithoutLocaleCreateInput"
	},
	LocaleUpdateBusinessServicesEntityRelationInput:{
		create:"BusinessServiceLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdateBusinessServicesRelationInput",
		upsert:"LocaleUpsertBusinessServicesRelationInput",
		connect:"BusinessServiceLocaleUniqueWhere",
		disconnect:"BusinessServiceLocaleUniqueWhere",
		delete:"BusinessServiceLocaleUniqueWhere"
	},
	LocaleUpdateBusinessServicesRelationInput:{
		by:"BusinessServiceLocaleUniqueWhere",
		data:"BusinessServiceLocaleWithoutLocaleUpdateInput"
	},
	BusinessServiceLocaleWithoutLocaleUpdateInput:{
		root:"BusinessServiceLocaleUpdateRootEntityRelationInput"
	},
	BusinessServiceLocaleUpdateRootEntityRelationInput:{
		create:"BusinessServiceWithoutLocalesCreateInput",
		update:"BusinessServiceWithoutLocalesUpdateInput",
		upsert:"BusinessServiceLocaleUpsertRootRelationInput",
		connect:"BusinessServiceUniqueWhere"
	},
	BusinessServiceWithoutLocalesUpdateInput:{

	},
	BusinessServiceLocaleUpsertRootRelationInput:{
		update:"BusinessServiceWithoutLocalesUpdateInput",
		create:"BusinessServiceWithoutLocalesCreateInput"
	},
	LocaleUpsertBusinessServicesRelationInput:{
		by:"BusinessServiceLocaleUniqueWhere",
		update:"BusinessServiceLocaleWithoutLocaleUpdateInput",
		create:"BusinessServiceLocaleWithoutLocaleCreateInput"
	},
	PipelineStageLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutPipelineStagesUpdateInput",
		create:"LocaleWithoutPipelineStagesCreateInput"
	},
	PipelineStageUpsertLocalesRelationInput:{
		by:"PipelineStageLocaleUniqueWhere",
		update:"PipelineStageLocaleWithoutRootUpdateInput",
		create:"PipelineStageLocaleWithoutRootCreateInput"
	},
	PipelineStageUpdateSentimentEntityRelationInput:{
		create:"PipelineStageSentimentCreateInput",
		update:"PipelineStageSentimentUpdateInput",
		upsert:"PipelineStageUpsertSentimentRelationInput",
		connect:"PipelineStageSentimentUniqueWhere"
	},
	PipelineStageSentimentUpdateInput:{

	},
	PipelineStageUpsertSentimentRelationInput:{
		update:"PipelineStageSentimentUpdateInput",
		create:"PipelineStageSentimentCreateInput"
	},
	PipelineStageUpdateFormsEntityRelationInput:{
		create:"LeadFormWithoutStageCreateInput",
		update:"PipelineStageUpdateFormsRelationInput",
		upsert:"PipelineStageUpsertFormsRelationInput",
		connect:"LeadFormUniqueWhere",
		disconnect:"LeadFormUniqueWhere",
		delete:"LeadFormUniqueWhere"
	},
	PipelineStageUpdateFormsRelationInput:{
		by:"LeadFormUniqueWhere",
		data:"LeadFormWithoutStageUpdateInput"
	},
	LeadFormWithoutStageUpdateInput:{
		leads:"LeadFormUpdateLeadsEntityRelationInput"
	},
	LeadFormUpdateLeadsEntityRelationInput:{
		create:"PipelineLeadWithoutFormCreateInput",
		update:"LeadFormUpdateLeadsRelationInput",
		upsert:"LeadFormUpsertLeadsRelationInput",
		connect:"PipelineLeadUniqueWhere",
		disconnect:"PipelineLeadUniqueWhere",
		delete:"PipelineLeadUniqueWhere"
	},
	LeadFormUpdateLeadsRelationInput:{
		by:"PipelineLeadUniqueWhere",
		data:"PipelineLeadWithoutFormUpdateInput"
	},
	PipelineLeadWithoutFormUpdateInput:{
		createdAt:"DateTime",
		stageItem:"PipelineLeadUpdateStageItemEntityRelationInput",
		customer:"PipelineLeadUpdateCustomerEntityRelationInput"
	},
	PipelineLeadUpdateCustomerEntityRelationInput:{
		create:"CustomerWithoutLeadCreateInput",
		update:"CustomerWithoutLeadUpdateInput",
		upsert:"PipelineLeadUpsertCustomerRelationInput",
		connect:"CustomerUniqueWhere"
	},
	CustomerWithoutLeadUpdateInput:{
		addresses:"CustomerUpdateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerUpdateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerUpdateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerUpdateTagsEntityRelationInput",
		credits:"CustomerUpdateCreditsEntityRelationInput",
		paymentMethods:"CustomerUpdatePaymentMethodsEntityRelationInput",
		orders:"CustomerUpdateOrdersEntityRelationInput",
		permissions:"CustomerUpdatePermissionsEntityRelationInput",
		group:"CustomerUpdateGroupEntityRelationInput",
		photo:"CustomerUpdatePhotoEntityRelationInput",
		name:"CustomerUpdateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerUpdateIngredientRatingsEntityRelationInput",
		business:"CustomerUpdateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerUpdateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerUpdateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerUpdateCartsEntityRelationInput",
		shortcutList:"CustomerUpdateShortcutListEntityRelationInput",
		user:"CustomerUpdateUserEntityRelationInput",
		channels:"CustomerUpdateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerUpdateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerUpdateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerUpdateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerUpdateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerUpdateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerUpdateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerUpdateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerUpdateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerUpdateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerUpdateRedeemedVouchersEntityRelationInput",
		spending:"CustomerUpdateSpendingEntityRelationInput",
		customerTabs:"CustomerUpdateCustomerTabsEntityRelationInput",
		meta:"CustomerUpdateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerUpdateMetaEntityRelationInput:{
		connect:"CustomerMetadataUniqueWhere"
	},
	PipelineLeadUpsertCustomerRelationInput:{
		update:"CustomerWithoutLeadUpdateInput",
		create:"CustomerWithoutLeadCreateInput"
	},
	LeadFormUpsertLeadsRelationInput:{
		by:"PipelineLeadUniqueWhere",
		update:"PipelineLeadWithoutFormUpdateInput",
		create:"PipelineLeadWithoutFormCreateInput"
	},
	PipelineStageUpsertFormsRelationInput:{
		by:"LeadFormUniqueWhere",
		update:"LeadFormWithoutStageUpdateInput",
		create:"LeadFormWithoutStageCreateInput"
	},
	PipelineStageItemUpsertListRelationInput:{
		update:"PipelineStageWithoutItemsUpdateInput",
		create:"PipelineStageWithoutItemsCreateInput"
	},
	PipelineLeadUpsertStageItemRelationInput:{
		update:"PipelineStageItemWithoutLeadUpdateInput",
		create:"PipelineStageItemWithoutLeadCreateInput"
	},
	PipelineLeadUpdateFormEntityRelationInput:{
		create:"LeadFormWithoutLeadsCreateInput",
		update:"LeadFormWithoutLeadsUpdateInput",
		upsert:"PipelineLeadUpsertFormRelationInput",
		connect:"LeadFormUniqueWhere"
	},
	LeadFormWithoutLeadsUpdateInput:{
		stage:"LeadFormUpdateStageEntityRelationInput"
	},
	LeadFormUpdateStageEntityRelationInput:{
		create:"PipelineStageWithoutFormsCreateInput",
		update:"PipelineStageWithoutFormsUpdateInput",
		upsert:"LeadFormUpsertStageRelationInput",
		connect:"PipelineStageUniqueWhere"
	},
	PipelineStageWithoutFormsUpdateInput:{
		items:"PipelineStageUpdateItemsEntityRelationInput",
		pipeline:"PipelineStageUpdatePipelineEntityRelationInput",
		locales:"PipelineStageUpdateLocalesEntityRelationInput",
		sentiment:"PipelineStageUpdateSentimentEntityRelationInput",
		type:"PipelineStageType"
	},
	PipelineStageUpdateItemsEntityRelationInput:{
		create:"PipelineStageItemWithoutListCreateInput",
		update:"PipelineStageUpdateItemsRelationInput",
		upsert:"PipelineStageUpsertItemsRelationInput",
		connect:"PipelineStageItemUniqueWhere",
		disconnect:"PipelineStageItemUniqueWhere",
		delete:"PipelineStageItemUniqueWhere"
	},
	PipelineStageUpdateItemsRelationInput:{
		by:"PipelineStageItemUniqueWhere",
		data:"PipelineStageItemWithoutListUpdateInput"
	},
	PipelineStageItemWithoutListUpdateInput:{
		lead:"PipelineStageItemUpdateLeadEntityRelationInput"
	},
	PipelineStageItemUpdateLeadEntityRelationInput:{
		create:"PipelineLeadWithoutStageItemCreateInput",
		update:"PipelineLeadWithoutStageItemUpdateInput",
		upsert:"PipelineStageItemUpsertLeadRelationInput",
		connect:"PipelineLeadUniqueWhere"
	},
	PipelineLeadWithoutStageItemUpdateInput:{
		createdAt:"DateTime",
		customer:"PipelineLeadUpdateCustomerEntityRelationInput",
		form:"PipelineLeadUpdateFormEntityRelationInput"
	},
	PipelineStageItemUpsertLeadRelationInput:{
		update:"PipelineLeadWithoutStageItemUpdateInput",
		create:"PipelineLeadWithoutStageItemCreateInput"
	},
	PipelineStageUpsertItemsRelationInput:{
		by:"PipelineStageItemUniqueWhere",
		update:"PipelineStageItemWithoutListUpdateInput",
		create:"PipelineStageItemWithoutListCreateInput"
	},
	LeadFormUpsertStageRelationInput:{
		update:"PipelineStageWithoutFormsUpdateInput",
		create:"PipelineStageWithoutFormsCreateInput"
	},
	PipelineLeadUpsertFormRelationInput:{
		update:"LeadFormWithoutLeadsUpdateInput",
		create:"LeadFormWithoutLeadsCreateInput"
	},
	CustomerUpsertLeadRelationInput:{
		by:"PipelineLeadUniqueWhere",
		update:"PipelineLeadWithoutCustomerUpdateInput",
		create:"PipelineLeadWithoutCustomerCreateInput"
	},
	CustomerTabUpsertCustomerRelationInput:{
		update:"CustomerWithoutCustomerTabsUpdateInput",
		create:"CustomerWithoutCustomerTabsCreateInput"
	},
	CustomerTabUpdateSeatEntityRelationInput:{
		create:"SeatWithoutCustomerTabsCreateInput",
		update:"SeatWithoutCustomerTabsUpdateInput",
		upsert:"CustomerTabUpsertSeatRelationInput",
		connect:"SeatUniqueWhere"
	},
	SeatWithoutCustomerTabsUpdateInput:{
		table:"SeatUpdateTableEntityRelationInput"
	},
	SeatUpdateTableEntityRelationInput:{
		create:"TableWithoutSeatsCreateInput",
		update:"TableWithoutSeatsUpdateInput",
		upsert:"SeatUpsertTableRelationInput",
		connect:"TableUniqueWhere"
	},
	TableWithoutSeatsUpdateInput:{
		shape:"TableShape",
		customerTabs:"TableUpdateCustomerTabsEntityRelationInput",
		area:"TableUpdateAreaEntityRelationInput"
	},
	SeatUpsertTableRelationInput:{
		update:"TableWithoutSeatsUpdateInput",
		create:"TableWithoutSeatsCreateInput"
	},
	CustomerTabUpsertSeatRelationInput:{
		update:"SeatWithoutCustomerTabsUpdateInput",
		create:"SeatWithoutCustomerTabsCreateInput"
	},
	TableUpsertCustomerTabsRelationInput:{
		by:"CustomerTabUniqueWhere",
		update:"CustomerTabWithoutTableUpdateInput",
		create:"CustomerTabWithoutTableCreateInput"
	},
	TableUpdateSeatsEntityRelationInput:{
		create:"SeatWithoutTableCreateInput",
		update:"TableUpdateSeatsRelationInput",
		upsert:"TableUpsertSeatsRelationInput",
		connect:"SeatUniqueWhere",
		disconnect:"SeatUniqueWhere",
		delete:"SeatUniqueWhere"
	},
	TableUpdateSeatsRelationInput:{
		by:"SeatUniqueWhere",
		data:"SeatWithoutTableUpdateInput"
	},
	SeatWithoutTableUpdateInput:{
		customerTabs:"SeatUpdateCustomerTabsEntityRelationInput"
	},
	SeatUpdateCustomerTabsEntityRelationInput:{
		create:"CustomerTabWithoutSeatCreateInput",
		update:"SeatUpdateCustomerTabsRelationInput",
		upsert:"SeatUpsertCustomerTabsRelationInput",
		connect:"CustomerTabUniqueWhere",
		disconnect:"CustomerTabUniqueWhere",
		delete:"CustomerTabUniqueWhere"
	},
	SeatUpdateCustomerTabsRelationInput:{
		by:"CustomerTabUniqueWhere",
		data:"CustomerTabWithoutSeatUpdateInput"
	},
	CustomerTabWithoutSeatUpdateInput:{
		createdAt:"DateTime",
		items:"CustomerTabUpdateItemsEntityRelationInput",
		meta:"CustomerTabUpdateMetaEntityRelationInput",
		customer:"CustomerTabUpdateCustomerEntityRelationInput",
		table:"CustomerTabUpdateTableEntityRelationInput"
	},
	SeatUpsertCustomerTabsRelationInput:{
		by:"CustomerTabUniqueWhere",
		update:"CustomerTabWithoutSeatUpdateInput",
		create:"CustomerTabWithoutSeatCreateInput"
	},
	TableUpsertSeatsRelationInput:{
		by:"SeatUniqueWhere",
		update:"SeatWithoutTableUpdateInput",
		create:"SeatWithoutTableCreateInput"
	},
	AreaUpsertTablesRelationInput:{
		by:"TableUniqueWhere",
		update:"TableWithoutAreaUpdateInput",
		create:"TableWithoutAreaCreateInput"
	},
	AreaUpdateLinesEntityRelationInput:{
		create:"LineWithoutAreaCreateInput",
		update:"AreaUpdateLinesRelationInput",
		upsert:"AreaUpsertLinesRelationInput",
		connect:"LineUniqueWhere",
		disconnect:"LineUniqueWhere",
		delete:"LineUniqueWhere"
	},
	AreaUpdateLinesRelationInput:{
		by:"LineUniqueWhere",
		data:"LineWithoutAreaUpdateInput"
	},
	LineWithoutAreaUpdateInput:{

	},
	AreaUpsertLinesRelationInput:{
		by:"LineUniqueWhere",
		update:"LineWithoutAreaUpdateInput",
		create:"LineWithoutAreaCreateInput"
	},
	VenueUpsertAreasRelationInput:{
		by:"AreaUniqueWhere",
		update:"AreaWithoutVenueUpdateInput",
		create:"AreaWithoutVenueCreateInput"
	},
	VenueUpdateChannelsEntityRelationInput:{
		create:"ChannelWithoutVenueCreateInput",
		update:"VenueUpdateChannelsRelationInput",
		upsert:"VenueUpsertChannelsRelationInput",
		connect:"ChannelUniqueWhere",
		disconnect:"ChannelUniqueWhere",
		delete:"ChannelUniqueWhere"
	},
	VenueUpdateChannelsRelationInput:{
		by:"ChannelUniqueWhere",
		data:"ChannelWithoutVenueUpdateInput"
	},
	ChannelWithoutVenueUpdateInput:{
		payments:"ChannelUpdatePaymentsEntityRelationInput",
		deliveries:"ChannelUpdateDeliveriesEntityRelationInput",
		pointOfSales:"ChannelUpdatePointOfSalesEntityRelationInput",
		carts:"ChannelUpdateCartsEntityRelationInput",
		customers:"ChannelUpdateCustomersEntityRelationInput",
		code:"ChannelCode",
		addTagsOnRegistration:"ChannelUpdateAddTagsOnRegistrationEntityRelationInput",
		publicTags:"ChannelUpdatePublicTagsEntityRelationInput"
	},
	VenueUpsertChannelsRelationInput:{
		by:"ChannelUniqueWhere",
		update:"ChannelWithoutVenueUpdateInput",
		create:"ChannelWithoutVenueCreateInput"
	},
	PointOfSalePrinterUpsertVenueRelationInput:{
		update:"VenueWithoutPointOfSalePrintersUpdateInput",
		create:"VenueWithoutPointOfSalePrintersCreateInput"
	},
	PointOfSalePrinterUpdateTicketCategoriesEntityRelationInput:{
		create:"PointOfSaleCategoryWithoutTicketPrintersCreateInput",
		update:"PointOfSalePrinterUpdateTicketCategoriesRelationInput",
		upsert:"PointOfSalePrinterUpsertTicketCategoriesRelationInput",
		connect:"PointOfSaleCategoryUniqueWhere",
		disconnect:"PointOfSaleCategoryUniqueWhere",
		delete:"PointOfSaleCategoryUniqueWhere"
	},
	PointOfSalePrinterUpdateTicketCategoriesRelationInput:{
		by:"PointOfSaleCategoryUniqueWhere",
		data:"PointOfSaleCategoryWithoutTicketPrintersUpdateInput"
	},
	PointOfSaleCategoryWithoutTicketPrintersUpdateInput:{
		locales:"PointOfSaleCategoryUpdateLocalesEntityRelationInput",
		products:"PointOfSaleCategoryUpdateProductsEntityRelationInput",
		category:"PointOfSaleCategoryUpdateCategoryEntityRelationInput",
		venue:"PointOfSaleCategoryUpdateVenueEntityRelationInput"
	},
	PointOfSaleCategoryUpdateVenueEntityRelationInput:{
		create:"VenueWithoutCategoriesCreateInput",
		update:"VenueWithoutCategoriesUpdateInput",
		upsert:"PointOfSaleCategoryUpsertVenueRelationInput",
		connect:"VenueUniqueWhere"
	},
	VenueWithoutCategoriesUpdateInput:{
		deadlineTemplate:"VenueUpdateDeadlineTemplateEntityRelationInput",
		timetableDays:"VenueUpdateTimetableDaysEntityRelationInput",
		timetableTemplates:"VenueUpdateTimetableTemplatesEntityRelationInput",
		staffMembers:"VenueUpdateStaffMembersEntityRelationInput",
		employeeRoles:"VenueUpdateEmployeeRolesEntityRelationInput",
		pointOfSaleApplicationDevices:"VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput",
		pointOfSaleTerminals:"VenueUpdatePointOfSaleTerminalsEntityRelationInput",
		pointOfSalePrinters:"VenueUpdatePointOfSalePrintersEntityRelationInput",
		orders:"VenueUpdateOrdersEntityRelationInput",
		fulfillmentNotes:"VenueUpdateFulfillmentNotesEntityRelationInput",
		areas:"VenueUpdateAreasEntityRelationInput",
		enabledUnassignReasons:"VenueUpdateEnabledUnassignReasonsEntityRelationInput",
		channels:"VenueUpdateChannelsEntityRelationInput",
		pointOfSaleInitialView:"PointOfSaleInitialView"
	},
	PointOfSaleCategoryUpsertVenueRelationInput:{
		update:"VenueWithoutCategoriesUpdateInput",
		create:"VenueWithoutCategoriesCreateInput"
	},
	PointOfSalePrinterUpsertTicketCategoriesRelationInput:{
		by:"PointOfSaleCategoryUniqueWhere",
		update:"PointOfSaleCategoryWithoutTicketPrintersUpdateInput",
		create:"PointOfSaleCategoryWithoutTicketPrintersCreateInput"
	},
	PointOfSaleApplicationDeviceUpsertReceiptPrinterRelationInput:{
		update:"PointOfSalePrinterWithoutApplicationDevicesReceiptUpdateInput",
		create:"PointOfSalePrinterWithoutApplicationDevicesReceiptCreateInput"
	},
	PointOfSalePrinterUpsertApplicationDevicesTicketRelationInput:{
		by:"PointOfSaleApplicationDeviceUniqueWhere",
		update:"PointOfSaleApplicationDeviceWithoutTicketPrintersUpdateInput",
		create:"PointOfSaleApplicationDeviceWithoutTicketPrintersCreateInput"
	},
	PointOfSaleCategoryUpsertTicketPrintersRelationInput:{
		by:"PointOfSalePrinterUniqueWhere",
		update:"PointOfSalePrinterWithoutTicketCategoriesUpdateInput",
		create:"PointOfSalePrinterWithoutTicketCategoriesCreateInput"
	},
	VenueUpsertCategoriesRelationInput:{
		by:"PointOfSaleCategoryUniqueWhere",
		update:"PointOfSaleCategoryWithoutVenueUpdateInput",
		create:"PointOfSaleCategoryWithoutVenueCreateInput"
	},
	AreaUpsertVenueRelationInput:{
		update:"VenueWithoutAreasUpdateInput",
		create:"VenueWithoutAreasCreateInput"
	},
	TableUpsertAreaRelationInput:{
		update:"AreaWithoutTablesUpdateInput",
		create:"AreaWithoutTablesCreateInput"
	},
	CustomerTabUpsertTableRelationInput:{
		update:"TableWithoutCustomerTabsUpdateInput",
		create:"TableWithoutCustomerTabsCreateInput"
	},
	CustomerUpsertCustomerTabsRelationInput:{
		by:"CustomerTabUniqueWhere",
		update:"CustomerTabWithoutCustomerUpdateInput",
		create:"CustomerTabWithoutCustomerCreateInput"
	},
	VoucherRedemptionUpsertCustomerRelationInput:{
		update:"CustomerWithoutRedeemedVouchersUpdateInput",
		create:"CustomerWithoutRedeemedVouchersCreateInput"
	},
	VoucherUpsertRedemptionRelationInput:{
		update:"VoucherRedemptionWithoutVoucherUpdateInput",
		create:"VoucherRedemptionWithoutVoucherCreateInput"
	},
	CustomerUpsertOwnsVouchersRelationInput:{
		by:"VoucherUniqueWhere",
		update:"VoucherWithoutOwnerUpdateInput",
		create:"VoucherWithoutOwnerCreateInput"
	},
	VoucherUpsertBuyerRelationInput:{
		update:"CustomerWithoutBoughtVouchersUpdateInput",
		create:"CustomerWithoutBoughtVouchersCreateInput"
	},
	VirtualProductEffectUpsertResultVouchersRelationInput:{
		by:"VoucherUniqueWhere",
		update:"VoucherWithoutVirtualProductEffectUpdateInput",
		create:"VoucherWithoutVirtualProductEffectCreateInput"
	},
	CustomerCreditTransactionUpsertVirtualProductEffectRelationInput:{
		update:"VirtualProductEffectWithoutResultCustomerCreditTransactionUpdateInput",
		create:"VirtualProductEffectWithoutResultCustomerCreditTransactionCreateInput"
	},
	CustomerCreditUpsertTransactionsRelationInput:{
		by:"CustomerCreditTransactionUniqueWhere",
		update:"CustomerCreditTransactionWithoutCustomerCreditUpdateInput",
		create:"CustomerCreditTransactionWithoutCustomerCreditCreateInput"
	},
	VoucherRedemptionUpsertCustomerCreditRelationInput:{
		update:"CustomerCreditWithoutVoucherRedemptionUpdateInput",
		create:"CustomerCreditWithoutVoucherRedemptionCreateInput"
	},
	VoucherRedemptionUpdateVoucherEntityRelationInput:{
		create:"VoucherWithoutRedemptionCreateInput",
		update:"VoucherWithoutRedemptionUpdateInput",
		upsert:"VoucherRedemptionUpsertVoucherRelationInput",
		connect:"VoucherUniqueWhere"
	},
	VoucherWithoutRedemptionUpdateInput:{
		createdAt:"DateTime",
		activatedAt:"DateTime",
		expiresAt:"DateTime",
		type:"VoucherType",
		buyer:"VoucherUpdateBuyerEntityRelationInput",
		owner:"VoucherUpdateOwnerEntityRelationInput",
		vatRate:"VoucherUpdateVatRateEntityRelationInput",
		virtualProductEffect:"VoucherUpdateVirtualProductEffectEntityRelationInput"
	},
	VoucherRedemptionUpsertVoucherRelationInput:{
		update:"VoucherWithoutRedemptionUpdateInput",
		create:"VoucherWithoutRedemptionCreateInput"
	},
	CustomerUpsertRedeemedVouchersRelationInput:{
		by:"VoucherRedemptionUniqueWhere",
		update:"VoucherRedemptionWithoutCustomerUpdateInput",
		create:"VoucherRedemptionWithoutCustomerCreateInput"
	},
	VoucherUpsertOwnerRelationInput:{
		update:"CustomerWithoutOwnsVouchersUpdateInput",
		create:"CustomerWithoutOwnsVouchersCreateInput"
	},
	CustomerUpsertBoughtVouchersRelationInput:{
		by:"VoucherUniqueWhere",
		update:"VoucherWithoutBuyerUpdateInput",
		create:"VoucherWithoutBuyerCreateInput"
	},
	BillingSubjectUpsertDefaultBillingSubjectOfCustomerRelationInput:{
		update:"CustomerWithoutDefaultBillingSubjectUpdateInput",
		create:"CustomerWithoutDefaultBillingSubjectCreateInput"
	},
	OrderUpsertBillingSubjectRelationInput:{
		update:"BillingSubjectWithoutOrdersUpdateInput",
		create:"BillingSubjectWithoutOrdersCreateInput"
	},
	FulfillmentNoteUpsertOrdersRelationInput:{
		by:"OrderUniqueWhere",
		update:"OrderWithoutFulfillmentNotesUpdateInput",
		create:"OrderWithoutFulfillmentNotesCreateInput"
	},
	VenueUpsertFulfillmentNotesRelationInput:{
		by:"FulfillmentNoteUniqueWhere",
		update:"FulfillmentNoteWithoutVenuesUpdateInput",
		create:"FulfillmentNoteWithoutVenuesCreateInput"
	},
	OrderUpsertVenueRelationInput:{
		update:"VenueWithoutOrdersUpdateInput",
		create:"VenueWithoutOrdersCreateInput"
	},
	OrderUpdateFulfillmentNotesEntityRelationInput:{
		create:"FulfillmentNoteWithoutOrdersCreateInput",
		update:"OrderUpdateFulfillmentNotesRelationInput",
		upsert:"OrderUpsertFulfillmentNotesRelationInput",
		connect:"FulfillmentNoteUniqueWhere",
		disconnect:"FulfillmentNoteUniqueWhere",
		delete:"FulfillmentNoteUniqueWhere"
	},
	OrderUpdateFulfillmentNotesRelationInput:{
		by:"FulfillmentNoteUniqueWhere",
		data:"FulfillmentNoteWithoutOrdersUpdateInput"
	},
	FulfillmentNoteWithoutOrdersUpdateInput:{
		products:"FulfillmentNoteUpdateProductsEntityRelationInput",
		tags:"FulfillmentNoteUpdateTagsEntityRelationInput",
		venues:"FulfillmentNoteUpdateVenuesEntityRelationInput",
		cartItems:"FulfillmentNoteUpdateCartItemsEntityRelationInput",
		orderItems:"FulfillmentNoteUpdateOrderItemsEntityRelationInput",
		createdAt:"DateTime"
	},
	OrderUpsertFulfillmentNotesRelationInput:{
		by:"FulfillmentNoteUniqueWhere",
		update:"FulfillmentNoteWithoutOrdersUpdateInput",
		create:"FulfillmentNoteWithoutOrdersCreateInput"
	},
	BillingSubjectUpsertOrdersRelationInput:{
		by:"OrderUniqueWhere",
		update:"OrderWithoutBillingSubjectUpdateInput",
		create:"OrderWithoutBillingSubjectCreateInput"
	},
	CustomerUpsertDefaultBillingSubjectRelationInput:{
		update:"BillingSubjectWithoutDefaultBillingSubjectOfCustomerUpdateInput",
		create:"BillingSubjectWithoutDefaultBillingSubjectOfCustomerCreateInput"
	},
	BillingSubjectUpsertCustomerRelationInput:{
		update:"CustomerWithoutBillingSubjectsUpdateInput",
		create:"CustomerWithoutBillingSubjectsCreateInput"
	},
	InvoiceUpsertBillingSubjectRelationInput:{
		update:"BillingSubjectWithoutInvoicesUpdateInput",
		create:"BillingSubjectWithoutInvoicesCreateInput"
	},
	OrderPaymentUpsertInvoiceRelationInput:{
		update:"InvoiceWithoutOrderPaymentsUpdateInput",
		create:"InvoiceWithoutOrderPaymentsCreateInput"
	},
	OrderPaymentUpdateVatRateEntityRelationInput:{
		create:"VatRateCreateInput",
		update:"VatRateUpdateInput",
		upsert:"OrderPaymentUpsertVatRateRelationInput",
		connect:"VatRateUniqueWhere"
	},
	OrderPaymentUpsertVatRateRelationInput:{
		update:"VatRateUpdateInput",
		create:"VatRateCreateInput"
	},
	OrderPaymentUpdateMetaEntityRelationInput:{
		connect:"OrderPaymentMetadataUniqueWhere"
	},
	OrderUpsertPaymentsRelationInput:{
		by:"OrderPaymentUniqueWhere",
		update:"OrderPaymentWithoutOrderUpdateInput",
		create:"OrderPaymentWithoutOrderCreateInput"
	},
	OrderDeliveryUpsertOrderRelationInput:{
		update:"OrderWithoutDeliveryUpdateInput",
		create:"OrderWithoutDeliveryCreateInput"
	},
	OrderDeliveryUpdateEventsEntityRelationInput:{
		create:"OrderEventWithoutDeliveryCreateInput",
		update:"OrderDeliveryUpdateEventsRelationInput",
		upsert:"OrderDeliveryUpsertEventsRelationInput",
		connect:"OrderEventUniqueWhere",
		disconnect:"OrderEventUniqueWhere",
		delete:"OrderEventUniqueWhere"
	},
	OrderDeliveryUpdateEventsRelationInput:{
		by:"OrderEventUniqueWhere",
		data:"OrderEventWithoutDeliveryUpdateInput"
	},
	OrderEventWithoutDeliveryUpdateInput:{
		createdAt:"DateTime",
		order:"OrderEventUpdateOrderEntityRelationInput",
		payment:"OrderEventUpdatePaymentEntityRelationInput"
	},
	OrderDeliveryUpsertEventsRelationInput:{
		by:"OrderEventUniqueWhere",
		update:"OrderEventWithoutDeliveryUpdateInput",
		create:"OrderEventWithoutDeliveryCreateInput"
	},
	OrderDeliveryUpdateLiftagoRideEntityRelationInput:{
		create:"LiftagoRideWithoutDeliveryCreateInput",
		update:"LiftagoRideWithoutDeliveryUpdateInput",
		upsert:"OrderDeliveryUpsertLiftagoRideRelationInput",
		connect:"LiftagoRideUniqueWhere"
	},
	LiftagoRideWithoutDeliveryUpdateInput:{
		updatedAt:"DateTime"
	},
	OrderDeliveryUpsertLiftagoRideRelationInput:{
		update:"LiftagoRideWithoutDeliveryUpdateInput",
		create:"LiftagoRideWithoutDeliveryCreateInput"
	},
	OrderDeliveryUpdateWoltDriveDeliveryEntityRelationInput:{
		create:"WoltDriveDeliveryWithoutDeliveryCreateInput",
		update:"WoltDriveDeliveryWithoutDeliveryUpdateInput",
		upsert:"OrderDeliveryUpsertWoltDriveDeliveryRelationInput",
		connect:"WoltDriveDeliveryUniqueWhere"
	},
	WoltDriveDeliveryWithoutDeliveryUpdateInput:{
		state:"WoltDriveDeliveryState"
	},
	OrderDeliveryUpsertWoltDriveDeliveryRelationInput:{
		update:"WoltDriveDeliveryWithoutDeliveryUpdateInput",
		create:"WoltDriveDeliveryWithoutDeliveryCreateInput"
	},
	AddressUpsertDeliveryAddressOfOrderDeliveriesRelationInput:{
		by:"OrderDeliveryUniqueWhere",
		update:"OrderDeliveryWithoutAddressUpdateInput",
		create:"OrderDeliveryWithoutAddressCreateInput"
	},
	AddressUpdateDefaultDeliveryAddressOfCustomerEntityRelationInput:{
		create:"CustomerWithoutDefaultDeliveryAddressCreateInput",
		update:"CustomerWithoutDefaultDeliveryAddressUpdateInput",
		upsert:"AddressUpsertDefaultDeliveryAddressOfCustomerRelationInput",
		connect:"CustomerUniqueWhere"
	},
	CustomerWithoutDefaultDeliveryAddressUpdateInput:{
		addresses:"CustomerUpdateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerUpdateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerUpdateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerUpdateTagsEntityRelationInput",
		credits:"CustomerUpdateCreditsEntityRelationInput",
		paymentMethods:"CustomerUpdatePaymentMethodsEntityRelationInput",
		orders:"CustomerUpdateOrdersEntityRelationInput",
		permissions:"CustomerUpdatePermissionsEntityRelationInput",
		group:"CustomerUpdateGroupEntityRelationInput",
		photo:"CustomerUpdatePhotoEntityRelationInput",
		name:"CustomerUpdateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerUpdateIngredientRatingsEntityRelationInput",
		business:"CustomerUpdateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerUpdateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerUpdateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerUpdateCartsEntityRelationInput",
		shortcutList:"CustomerUpdateShortcutListEntityRelationInput",
		user:"CustomerUpdateUserEntityRelationInput",
		channels:"CustomerUpdateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerUpdateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerUpdateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerUpdateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerUpdateOfferedProductsEntityRelationInput",
		defaultBillingSubject:"CustomerUpdateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerUpdateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerUpdateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerUpdateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerUpdateRedeemedVouchersEntityRelationInput",
		spending:"CustomerUpdateSpendingEntityRelationInput",
		customerTabs:"CustomerUpdateCustomerTabsEntityRelationInput",
		lead:"CustomerUpdateLeadEntityRelationInput",
		meta:"CustomerUpdateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	AddressUpsertDefaultDeliveryAddressOfCustomerRelationInput:{
		update:"CustomerWithoutDefaultDeliveryAddressUpdateInput",
		create:"CustomerWithoutDefaultDeliveryAddressCreateInput"
	},
	OrderUpsertBillingAddressRelationInput:{
		update:"AddressWithoutBillingAddressOfOrdersUpdateInput",
		create:"AddressWithoutBillingAddressOfOrdersCreateInput"
	},
	OrderPaymentUpsertOrderRelationInput:{
		update:"OrderWithoutPaymentsUpdateInput",
		create:"OrderWithoutPaymentsCreateInput"
	},
	OrderEventUpsertPaymentRelationInput:{
		update:"OrderPaymentWithoutEventsUpdateInput",
		create:"OrderPaymentWithoutEventsCreateInput"
	},
	OrderEventUpdateDeliveryEntityRelationInput:{
		create:"OrderDeliveryWithoutEventsCreateInput",
		update:"OrderDeliveryWithoutEventsUpdateInput",
		upsert:"OrderEventUpsertDeliveryRelationInput",
		connect:"OrderDeliveryUniqueWhere"
	},
	OrderDeliveryWithoutEventsUpdateInput:{
		deliveredAt:"DateTime",
		method:"OrderDeliveryUpdateMethodEntityRelationInput",
		vatRate:"OrderDeliveryUpdateVatRateEntityRelationInput",
		order:"OrderDeliveryUpdateOrderEntityRelationInput",
		expectedAt:"DateTime",
		state:"OrderDeliveryState",
		dispatchAt:"DateTime",
		expectedEndAt:"DateTime",
		processingAt:"DateTime",
		deliveringAt:"DateTime",
		failedAt:"DateTime",
		deliveryWaypoint:"OrderDeliveryUpdateDeliveryWaypointEntityRelationInput",
		prepareAt:"DateTime",
		liftagoRide:"OrderDeliveryUpdateLiftagoRideEntityRelationInput",
		pickedAt:"DateTime",
		address:"OrderDeliveryUpdateAddressEntityRelationInput",
		woltDriveDelivery:"OrderDeliveryUpdateWoltDriveDeliveryEntityRelationInput"
	},
	OrderDeliveryUpdateAddressEntityRelationInput:{
		create:"AddressWithoutDeliveryAddressOfOrderDeliveriesCreateInput",
		update:"AddressWithoutDeliveryAddressOfOrderDeliveriesUpdateInput",
		upsert:"OrderDeliveryUpsertAddressRelationInput",
		connect:"AddressUniqueWhere"
	},
	AddressWithoutDeliveryAddressOfOrderDeliveriesUpdateInput:{
		customer:"AddressUpdateCustomerEntityRelationInput",
		country:"AddressUpdateCountryEntityRelationInput",
		deletedAt:"DateTime",
		geocodeGeneratedAt:"DateTime",
		deliveryZone:"AddressUpdateDeliveryZoneEntityRelationInput",
		meta:"AddressUpdateMetaEntityRelationInput",
		gps:"AddressUpdateGpsEntityRelationInput",
		invoices:"AddressUpdateInvoicesEntityRelationInput",
		createdAt:"DateTime",
		billingAddressOfOrders:"AddressUpdateBillingAddressOfOrdersEntityRelationInput",
		defaultDeliveryAddressOfCustomer:"AddressUpdateDefaultDeliveryAddressOfCustomerEntityRelationInput"
	},
	OrderDeliveryUpsertAddressRelationInput:{
		update:"AddressWithoutDeliveryAddressOfOrderDeliveriesUpdateInput",
		create:"AddressWithoutDeliveryAddressOfOrderDeliveriesCreateInput"
	},
	OrderEventUpsertDeliveryRelationInput:{
		update:"OrderDeliveryWithoutEventsUpdateInput",
		create:"OrderDeliveryWithoutEventsCreateInput"
	},
	OrderUpsertEventsRelationInput:{
		by:"OrderEventUniqueWhere",
		update:"OrderEventWithoutOrderUpdateInput",
		create:"OrderEventWithoutOrderCreateInput"
	},
	AddressUpsertBillingAddressOfOrdersRelationInput:{
		by:"OrderUniqueWhere",
		update:"OrderWithoutBillingAddressUpdateInput",
		create:"OrderWithoutBillingAddressCreateInput"
	},
	InvoiceUpsertAddressRelationInput:{
		update:"AddressWithoutInvoicesUpdateInput",
		create:"AddressWithoutInvoicesCreateInput"
	},
	BillingSubjectUpsertInvoicesRelationInput:{
		by:"InvoiceUniqueWhere",
		update:"InvoiceWithoutBillingSubjectUpdateInput",
		create:"InvoiceWithoutBillingSubjectCreateInput"
	},
	CustomerUpsertBillingSubjectsRelationInput:{
		by:"BillingSubjectUniqueWhere",
		update:"BillingSubjectWithoutCustomerUpdateInput",
		create:"BillingSubjectWithoutCustomerCreateInput"
	},
	CartUpsertCustomerRelationInput:{
		update:"CustomerWithoutCartsUpdateInput",
		create:"CustomerWithoutCartsCreateInput"
	},
	CartUpdateDeliveryAddressEntityRelationInput:{
		create:"AddressCreateInput",
		update:"AddressUpdateInput",
		upsert:"CartUpsertDeliveryAddressRelationInput",
		connect:"AddressUniqueWhere"
	},
	CartUpsertDeliveryAddressRelationInput:{
		update:"AddressUpdateInput",
		create:"AddressCreateInput"
	},
	CartUpdateBillingAddressEntityRelationInput:{
		create:"AddressCreateInput",
		update:"AddressUpdateInput",
		upsert:"CartUpsertBillingAddressRelationInput",
		connect:"AddressUniqueWhere"
	},
	CartUpsertBillingAddressRelationInput:{
		update:"AddressUpdateInput",
		create:"AddressCreateInput"
	},
	CartUpdateDeliveryEntityRelationInput:{
		create:"ChannelDeliveryCreateInput",
		update:"ChannelDeliveryUpdateInput",
		upsert:"CartUpsertDeliveryRelationInput",
		connect:"ChannelDeliveryUniqueWhere"
	},
	ChannelDeliveryUpdateInput:{
		channel:"ChannelDeliveryUpdateChannelEntityRelationInput",
		method:"ChannelDeliveryUpdateMethodEntityRelationInput",
		vatRate:"ChannelDeliveryUpdateVatRateEntityRelationInput"
	},
	CartUpsertDeliveryRelationInput:{
		update:"ChannelDeliveryUpdateInput",
		create:"ChannelDeliveryCreateInput"
	},
	CartUpdatePaymentEntityRelationInput:{
		create:"ChannelPaymentCreateInput",
		update:"ChannelPaymentUpdateInput",
		upsert:"CartUpsertPaymentRelationInput",
		connect:"ChannelPaymentUniqueWhere"
	},
	ChannelPaymentUpdateInput:{
		channel:"ChannelPaymentUpdateChannelEntityRelationInput",
		method:"ChannelPaymentUpdateMethodEntityRelationInput",
		vatRate:"ChannelPaymentUpdateVatRateEntityRelationInput",
		allowOnlyForTags:"ChannelPaymentUpdateAllowOnlyForTagsEntityRelationInput"
	},
	CartUpsertPaymentRelationInput:{
		update:"ChannelPaymentUpdateInput",
		create:"ChannelPaymentCreateInput"
	},
	CartUpdateBillingSubjectEntityRelationInput:{
		create:"BillingSubjectCreateInput",
		update:"BillingSubjectUpdateInput",
		upsert:"CartUpsertBillingSubjectRelationInput",
		connect:"BillingSubjectUniqueWhere"
	},
	BillingSubjectUpdateInput:{
		createdAt:"DateTime",
		deletedAt:"DateTime",
		country:"BillingSubjectUpdateCountryEntityRelationInput",
		customer:"BillingSubjectUpdateCustomerEntityRelationInput",
		invoices:"BillingSubjectUpdateInvoicesEntityRelationInput",
		defaultBillingSubjectOfCustomer:"BillingSubjectUpdateDefaultBillingSubjectOfCustomerEntityRelationInput",
		orders:"BillingSubjectUpdateOrdersEntityRelationInput"
	},
	CartUpsertBillingSubjectRelationInput:{
		update:"BillingSubjectUpdateInput",
		create:"BillingSubjectCreateInput"
	},
	CartUpdatePriceLinesEntityRelationInput:{
		connect:"CartPriceLineUniqueWhere",
		disconnect:"CartPriceLineUniqueWhere",
		delete:"CartPriceLineUniqueWhere"
	},
	CartUpdateSummaryEntityRelationInput:{
		connect:"CartSummaryUniqueWhere"
	},
	OrderUpsertCartRelationInput:{
		update:"CartWithoutOrderUpdateInput",
		create:"CartWithoutOrderCreateInput"
	},
	OrderDiscountUpsertOrderRelationInput:{
		update:"OrderWithoutDiscountsUpdateInput",
		create:"OrderWithoutDiscountsCreateInput"
	},
	OrderDiscountUpdateVoucherRedemptionEntityRelationInput:{
		create:"VoucherRedemptionWithoutOrderDiscountCreateInput",
		update:"VoucherRedemptionWithoutOrderDiscountUpdateInput",
		upsert:"OrderDiscountUpsertVoucherRedemptionRelationInput",
		connect:"VoucherRedemptionUniqueWhere"
	},
	VoucherRedemptionWithoutOrderDiscountUpdateInput:{
		createdAt:"DateTime",
		customerCredit:"VoucherRedemptionUpdateCustomerCreditEntityRelationInput",
		voucher:"VoucherRedemptionUpdateVoucherEntityRelationInput",
		customer:"VoucherRedemptionUpdateCustomerEntityRelationInput"
	},
	OrderDiscountUpsertVoucherRedemptionRelationInput:{
		update:"VoucherRedemptionWithoutOrderDiscountUpdateInput",
		create:"VoucherRedemptionWithoutOrderDiscountCreateInput"
	},
	CustomerCreditTransactionUpsertOrderDiscountRelationInput:{
		update:"OrderDiscountWithoutCustomerCreditTransactionsUpdateInput",
		create:"OrderDiscountWithoutCustomerCreditTransactionsCreateInput"
	},
	VirtualProductEffectUpsertResultCustomerCreditTransactionRelationInput:{
		update:"CustomerCreditTransactionWithoutVirtualProductEffectUpdateInput",
		create:"CustomerCreditTransactionWithoutVirtualProductEffectCreateInput"
	},
	OrderItemUpsertVirtualProductEffectsRelationInput:{
		by:"VirtualProductEffectUniqueWhere",
		update:"VirtualProductEffectWithoutOrderItemUpdateInput",
		create:"VirtualProductEffectWithoutOrderItemCreateInput"
	},
	OrderUpsertItemsRelationInput:{
		by:"OrderItemUniqueWhere",
		update:"OrderItemWithoutOrderUpdateInput",
		create:"OrderItemWithoutOrderCreateInput"
	},
	VenueUpsertOrdersRelationInput:{
		by:"OrderUniqueWhere",
		update:"OrderWithoutVenueUpdateInput",
		create:"OrderWithoutVenueCreateInput"
	},
	PointOfSaleTerminalUpsertVenueRelationInput:{
		update:"VenueWithoutPointOfSaleTerminalsUpdateInput",
		create:"VenueWithoutPointOfSaleTerminalsCreateInput"
	},
	PointOfSaleApplicationDeviceUpsertTerminalRelationInput:{
		update:"PointOfSaleTerminalWithoutApplicationDevicesUpdateInput",
		create:"PointOfSaleTerminalWithoutApplicationDevicesCreateInput"
	},
	PointOfSaleApplicationDeviceUpdateTicketPrintersEntityRelationInput:{
		create:"PointOfSalePrinterWithoutApplicationDevicesTicketCreateInput",
		update:"PointOfSaleApplicationDeviceUpdateTicketPrintersRelationInput",
		upsert:"PointOfSaleApplicationDeviceUpsertTicketPrintersRelationInput",
		connect:"PointOfSalePrinterUniqueWhere",
		disconnect:"PointOfSalePrinterUniqueWhere",
		delete:"PointOfSalePrinterUniqueWhere"
	},
	PointOfSaleApplicationDeviceUpdateTicketPrintersRelationInput:{
		by:"PointOfSalePrinterUniqueWhere",
		data:"PointOfSalePrinterWithoutApplicationDevicesTicketUpdateInput"
	},
	PointOfSalePrinterWithoutApplicationDevicesTicketUpdateInput:{
		applicationDevicesReceipt:"PointOfSalePrinterUpdateApplicationDevicesReceiptEntityRelationInput",
		venue:"PointOfSalePrinterUpdateVenueEntityRelationInput",
		ticketCategories:"PointOfSalePrinterUpdateTicketCategoriesEntityRelationInput"
	},
	PointOfSaleApplicationDeviceUpsertTicketPrintersRelationInput:{
		by:"PointOfSalePrinterUniqueWhere",
		update:"PointOfSalePrinterWithoutApplicationDevicesTicketUpdateInput",
		create:"PointOfSalePrinterWithoutApplicationDevicesTicketCreateInput"
	},
	IdentificationCodeUpsertApplicationDevicesRelationInput:{
		by:"PointOfSaleApplicationDeviceUniqueWhere",
		update:"PointOfSaleApplicationDeviceWithoutIdentificationCodeUpdateInput",
		create:"PointOfSaleApplicationDeviceWithoutIdentificationCodeCreateInput"
	},
	IdentificationCodeLocaleUpsertRootRelationInput:{
		update:"IdentificationCodeWithoutLocalesUpdateInput",
		create:"IdentificationCodeWithoutLocalesCreateInput"
	},
	LocaleUpsertIdentificationCodesRelationInput:{
		by:"IdentificationCodeLocaleUniqueWhere",
		update:"IdentificationCodeLocaleWithoutLocaleUpdateInput",
		create:"IdentificationCodeLocaleWithoutLocaleCreateInput"
	},
	LocaleUpdatePipelineStagesEntityRelationInput:{
		create:"PipelineStageLocaleWithoutLocaleCreateInput",
		update:"LocaleUpdatePipelineStagesRelationInput",
		upsert:"LocaleUpsertPipelineStagesRelationInput",
		connect:"PipelineStageLocaleUniqueWhere",
		disconnect:"PipelineStageLocaleUniqueWhere",
		delete:"PipelineStageLocaleUniqueWhere"
	},
	LocaleUpdatePipelineStagesRelationInput:{
		by:"PipelineStageLocaleUniqueWhere",
		data:"PipelineStageLocaleWithoutLocaleUpdateInput"
	},
	PipelineStageLocaleWithoutLocaleUpdateInput:{
		root:"PipelineStageLocaleUpdateRootEntityRelationInput"
	},
	PipelineStageLocaleUpdateRootEntityRelationInput:{
		create:"PipelineStageWithoutLocalesCreateInput",
		update:"PipelineStageWithoutLocalesUpdateInput",
		upsert:"PipelineStageLocaleUpsertRootRelationInput",
		connect:"PipelineStageUniqueWhere"
	},
	PipelineStageWithoutLocalesUpdateInput:{
		items:"PipelineStageUpdateItemsEntityRelationInput",
		pipeline:"PipelineStageUpdatePipelineEntityRelationInput",
		sentiment:"PipelineStageUpdateSentimentEntityRelationInput",
		type:"PipelineStageType",
		forms:"PipelineStageUpdateFormsEntityRelationInput"
	},
	PipelineStageLocaleUpsertRootRelationInput:{
		update:"PipelineStageWithoutLocalesUpdateInput",
		create:"PipelineStageWithoutLocalesCreateInput"
	},
	LocaleUpsertPipelineStagesRelationInput:{
		by:"PipelineStageLocaleUniqueWhere",
		update:"PipelineStageLocaleWithoutLocaleUpdateInput",
		create:"PipelineStageLocaleWithoutLocaleCreateInput"
	},
	PointOfSaleCategoryLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutPointOfSaleCategoriesUpdateInput",
		create:"LocaleWithoutPointOfSaleCategoriesCreateInput"
	},
	PointOfSaleCategoryUpsertLocalesRelationInput:{
		by:"PointOfSaleCategoryLocaleUniqueWhere",
		update:"PointOfSaleCategoryLocaleWithoutRootUpdateInput",
		create:"PointOfSaleCategoryLocaleWithoutRootCreateInput"
	},
	PointOfSaleCategoryProductUpsertCategoryRelationInput:{
		update:"PointOfSaleCategoryWithoutProductsUpdateInput",
		create:"PointOfSaleCategoryWithoutProductsCreateInput"
	},
	PointOfSaleCategoryProductLocaleUpsertRootRelationInput:{
		update:"PointOfSaleCategoryProductWithoutLocalesUpdateInput",
		create:"PointOfSaleCategoryProductWithoutLocalesCreateInput"
	},
	LocaleUpsertPointOfSaleCategoryProductsRelationInput:{
		by:"PointOfSaleCategoryProductLocaleUniqueWhere",
		update:"PointOfSaleCategoryProductLocaleWithoutLocaleUpdateInput",
		create:"PointOfSaleCategoryProductLocaleWithoutLocaleCreateInput"
	},
	IdentificationCodeLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutIdentificationCodesUpdateInput",
		create:"LocaleWithoutIdentificationCodesCreateInput"
	},
	IdentificationCodeUpsertLocalesRelationInput:{
		by:"IdentificationCodeLocaleUniqueWhere",
		update:"IdentificationCodeLocaleWithoutRootUpdateInput",
		create:"IdentificationCodeLocaleWithoutRootCreateInput"
	},
	IdentificationAttemptUpsertCodeRelationInput:{
		update:"IdentificationCodeWithoutAttemptsUpdateInput",
		create:"IdentificationCodeWithoutAttemptsCreateInput"
	},
	UserUpsertIdentificationAttemptsRelationInput:{
		by:"IdentificationAttemptUniqueWhere",
		update:"IdentificationAttemptWithoutUserUpdateInput",
		create:"IdentificationAttemptWithoutUserCreateInput"
	},
	DeviceIdentifierUpsertUpdatedByUserRelationInput:{
		update:"UserUpdateInput",
		create:"UserCreateInput"
	},
	PointOfSaleApplicationDeviceUpsertIdentifierRelationInput:{
		update:"DeviceIdentifierWithoutDeviceUpdateInput",
		create:"DeviceIdentifierWithoutDeviceCreateInput"
	},
	PointOfSalePrinterUpsertApplicationDevicesReceiptRelationInput:{
		by:"PointOfSaleApplicationDeviceUniqueWhere",
		update:"PointOfSaleApplicationDeviceWithoutReceiptPrinterUpdateInput",
		create:"PointOfSaleApplicationDeviceWithoutReceiptPrinterCreateInput"
	},
	VenueUpsertPointOfSalePrintersRelationInput:{
		by:"PointOfSalePrinterUniqueWhere",
		update:"PointOfSalePrinterWithoutVenueUpdateInput",
		create:"PointOfSalePrinterWithoutVenueCreateInput"
	},
	PointOfSaleApplicationDeviceUpsertVenueRelationInput:{
		update:"VenueWithoutPointOfSaleApplicationDevicesUpdateInput",
		create:"VenueWithoutPointOfSaleApplicationDevicesCreateInput"
	},
	PointOfSaleTerminalUpsertApplicationDevicesRelationInput:{
		by:"PointOfSaleApplicationDeviceUniqueWhere",
		update:"PointOfSaleApplicationDeviceWithoutTerminalUpdateInput",
		create:"PointOfSaleApplicationDeviceWithoutTerminalCreateInput"
	},
	VenueUpsertPointOfSaleTerminalsRelationInput:{
		by:"PointOfSaleTerminalUniqueWhere",
		update:"PointOfSaleTerminalWithoutVenueUpdateInput",
		create:"PointOfSaleTerminalWithoutVenueCreateInput"
	},
	FulfillmentNoteUpsertVenuesRelationInput:{
		by:"VenueUniqueWhere",
		update:"VenueWithoutFulfillmentNotesUpdateInput",
		create:"VenueWithoutFulfillmentNotesCreateInput"
	},
	ProductUpsertFulfillmentNotesRelationInput:{
		by:"FulfillmentNoteUniqueWhere",
		update:"FulfillmentNoteWithoutProductsUpdateInput",
		create:"FulfillmentNoteWithoutProductsCreateInput"
	},
	PointOfSaleCategoryProductUpsertProductRelationInput:{
		update:"ProductUpdateInput",
		create:"ProductCreateInput"
	},
	PointOfSaleCategoryProductUpdateLocalesEntityRelationInput:{
		create:"PointOfSaleCategoryProductLocaleWithoutRootCreateInput",
		update:"PointOfSaleCategoryProductUpdateLocalesRelationInput",
		upsert:"PointOfSaleCategoryProductUpsertLocalesRelationInput",
		connect:"PointOfSaleCategoryProductLocaleUniqueWhere",
		disconnect:"PointOfSaleCategoryProductLocaleUniqueWhere",
		delete:"PointOfSaleCategoryProductLocaleUniqueWhere"
	},
	PointOfSaleCategoryProductUpdateLocalesRelationInput:{
		by:"PointOfSaleCategoryProductLocaleUniqueWhere",
		data:"PointOfSaleCategoryProductLocaleWithoutRootUpdateInput"
	},
	PointOfSaleCategoryProductLocaleWithoutRootUpdateInput:{
		locale:"PointOfSaleCategoryProductLocaleUpdateLocaleEntityRelationInput"
	},
	PointOfSaleCategoryProductLocaleUpdateLocaleEntityRelationInput:{
		create:"LocaleWithoutPointOfSaleCategoryProductsCreateInput",
		update:"LocaleWithoutPointOfSaleCategoryProductsUpdateInput",
		upsert:"PointOfSaleCategoryProductLocaleUpsertLocaleRelationInput",
		connect:"LocaleUniqueWhere"
	},
	LocaleWithoutPointOfSaleCategoryProductsUpdateInput:{
		businessCategories:"LocaleUpdateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleUpdateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleUpdateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleUpdateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleUpdateBlogsEntityRelationInput",
		blogPosts:"LocaleUpdateBlogPostsEntityRelationInput",
		identifier:"LocaleUpdateIdentifierEntityRelationInput",
		menus:"LocaleUpdateMenusEntityRelationInput",
		pages:"LocaleUpdatePagesEntityRelationInput",
		productIngredientCategories:"LocaleUpdateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleUpdateAllergensEntityRelationInput",
		productPackings:"LocaleUpdateProductPackingsEntityRelationInput",
		products:"LocaleUpdateProductsEntityRelationInput",
		productRecipes:"LocaleUpdateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleUpdatePointOfSaleCategoriesEntityRelationInput",
		deliveryMethods:"LocaleUpdateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleUpdateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleUpdateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleUpdatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleUpdateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleUpdateBusinessServicesEntityRelationInput"
	},
	PointOfSaleCategoryProductLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutPointOfSaleCategoryProductsUpdateInput",
		create:"LocaleWithoutPointOfSaleCategoryProductsCreateInput"
	},
	PointOfSaleCategoryProductUpsertLocalesRelationInput:{
		by:"PointOfSaleCategoryProductLocaleUniqueWhere",
		update:"PointOfSaleCategoryProductLocaleWithoutRootUpdateInput",
		create:"PointOfSaleCategoryProductLocaleWithoutRootCreateInput"
	},
	PointOfSaleCategoryUpsertProductsRelationInput:{
		by:"PointOfSaleCategoryProductUniqueWhere",
		update:"PointOfSaleCategoryProductWithoutCategoryUpdateInput",
		create:"PointOfSaleCategoryProductWithoutCategoryCreateInput"
	},
	PointOfSaleCategoryLocaleUpsertRootRelationInput:{
		update:"PointOfSaleCategoryWithoutLocalesUpdateInput",
		create:"PointOfSaleCategoryWithoutLocalesCreateInput"
	},
	LocaleUpsertPointOfSaleCategoriesRelationInput:{
		by:"PointOfSaleCategoryLocaleUniqueWhere",
		update:"PointOfSaleCategoryLocaleWithoutLocaleUpdateInput",
		create:"PointOfSaleCategoryLocaleWithoutLocaleCreateInput"
	},
	ProductLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutProductsUpdateInput",
		create:"LocaleWithoutProductsCreateInput"
	},
	ProductUpsertLocalesRelationInput:{
		by:"ProductLocaleUniqueWhere",
		update:"ProductLocaleWithoutRootUpdateInput",
		create:"ProductLocaleWithoutRootCreateInput"
	},
	ProductRecipeUpsertProductsRelationInput:{
		by:"ProductUniqueWhere",
		update:"ProductWithoutRecipeUpdateInput",
		create:"ProductWithoutRecipeCreateInput"
	},
	ProductRecipeUpdateLocalesEntityRelationInput:{
		create:"ProductRecipeLocaleWithoutRootCreateInput",
		update:"ProductRecipeUpdateLocalesRelationInput",
		upsert:"ProductRecipeUpsertLocalesRelationInput",
		connect:"ProductRecipeLocaleUniqueWhere",
		disconnect:"ProductRecipeLocaleUniqueWhere",
		delete:"ProductRecipeLocaleUniqueWhere"
	},
	ProductRecipeUpdateLocalesRelationInput:{
		by:"ProductRecipeLocaleUniqueWhere",
		data:"ProductRecipeLocaleWithoutRootUpdateInput"
	},
	ProductRecipeLocaleWithoutRootUpdateInput:{
		locale:"ProductRecipeLocaleUpdateLocaleEntityRelationInput"
	},
	ProductRecipeLocaleUpdateLocaleEntityRelationInput:{
		create:"LocaleWithoutProductRecipesCreateInput",
		update:"LocaleWithoutProductRecipesUpdateInput",
		upsert:"ProductRecipeLocaleUpsertLocaleRelationInput",
		connect:"LocaleUniqueWhere"
	},
	LocaleWithoutProductRecipesUpdateInput:{
		businessCategories:"LocaleUpdateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleUpdateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleUpdateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleUpdateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleUpdateBlogsEntityRelationInput",
		blogPosts:"LocaleUpdateBlogPostsEntityRelationInput",
		identifier:"LocaleUpdateIdentifierEntityRelationInput",
		menus:"LocaleUpdateMenusEntityRelationInput",
		pages:"LocaleUpdatePagesEntityRelationInput",
		productIngredientCategories:"LocaleUpdateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleUpdateAllergensEntityRelationInput",
		productPackings:"LocaleUpdateProductPackingsEntityRelationInput",
		products:"LocaleUpdateProductsEntityRelationInput",
		pointOfSaleCategories:"LocaleUpdatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleUpdateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleUpdateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleUpdateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleUpdatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleUpdateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleUpdateBusinessServicesEntityRelationInput"
	},
	ProductRecipeLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutProductRecipesUpdateInput",
		create:"LocaleWithoutProductRecipesCreateInput"
	},
	ProductRecipeUpsertLocalesRelationInput:{
		by:"ProductRecipeLocaleUniqueWhere",
		update:"ProductRecipeLocaleWithoutRootUpdateInput",
		create:"ProductRecipeLocaleWithoutRootCreateInput"
	},
	PreparedPackingQuantityUpsertRecipeRelationInput:{
		update:"ProductRecipeUpdateInput",
		create:"ProductRecipeCreateInput"
	},
	ProductPackingUpsertPreparedPackingQuantitiesRelationInput:{
		by:"PreparedPackingQuantityUniqueWhere",
		update:"PreparedPackingQuantityWithoutPackingUpdateInput",
		create:"PreparedPackingQuantityWithoutPackingCreateInput"
	},
	ProductPackingLocaleUpsertRootRelationInput:{
		update:"ProductPackingWithoutLocalesUpdateInput",
		create:"ProductPackingWithoutLocalesCreateInput"
	},
	LocaleUpsertProductPackingsRelationInput:{
		by:"ProductPackingLocaleUniqueWhere",
		update:"ProductPackingLocaleWithoutLocaleUpdateInput",
		create:"ProductPackingLocaleWithoutLocaleCreateInput"
	},
	DeliveryMethodLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutDeliveryMethodsUpdateInput",
		create:"LocaleWithoutDeliveryMethodsCreateInput"
	},
	DeliveryMethodUpsertLocalesRelationInput:{
		by:"DeliveryMethodLocaleUniqueWhere",
		update:"DeliveryMethodLocaleWithoutRootUpdateInput",
		create:"DeliveryMethodLocaleWithoutRootCreateInput"
	},
	CourierUpsertDeliveryMethodsRelationInput:{
		by:"DeliveryMethodUniqueWhere",
		update:"DeliveryMethodWithoutCourierHandlersUpdateInput",
		create:"DeliveryMethodWithoutCourierHandlersCreateInput"
	},
	DeliveryRouteUpsertCourierRelationInput:{
		update:"CourierWithoutRoutesUpdateInput",
		create:"CourierWithoutRoutesCreateInput"
	},
	DeliveryWaypointUpsertRouteRelationInput:{
		update:"DeliveryRouteWithoutWaypointsUpdateInput",
		create:"DeliveryRouteWithoutWaypointsCreateInput"
	},
	OrderDeliveryUpsertDeliveryWaypointRelationInput:{
		update:"DeliveryWaypointWithoutDeliveryUpdateInput",
		create:"DeliveryWaypointWithoutDeliveryCreateInput"
	},
	OrderUpsertDeliveryRelationInput:{
		update:"OrderDeliveryWithoutOrderUpdateInput",
		create:"OrderDeliveryWithoutOrderCreateInput"
	},
	OrderEventUpsertOrderRelationInput:{
		update:"OrderWithoutEventsUpdateInput",
		create:"OrderWithoutEventsCreateInput"
	},
	OrderPaymentUpsertEventsRelationInput:{
		by:"OrderEventUniqueWhere",
		update:"OrderEventWithoutPaymentUpdateInput",
		create:"OrderEventWithoutPaymentCreateInput"
	},
	InvoiceUpsertOrderPaymentsRelationInput:{
		by:"OrderPaymentUniqueWhere",
		update:"OrderPaymentWithoutInvoiceUpdateInput",
		create:"OrderPaymentWithoutInvoiceCreateInput"
	},
	CustomerUpsertInvoicesRelationInput:{
		by:"InvoiceUniqueWhere",
		update:"InvoiceWithoutCustomerUpdateInput",
		create:"InvoiceWithoutCustomerCreateInput"
	},
	AnonymousSessionUpsertCustomerRelationInput:{
		update:"CustomerWithoutAnonymousSessionUpdateInput",
		create:"CustomerWithoutAnonymousSessionCreateInput"
	},
	UserDeviceUpsertAnonymousSessionRelationInput:{
		update:"AnonymousSessionWithoutDevicesUpdateInput",
		create:"AnonymousSessionWithoutDevicesCreateInput"
	},
	UserUpsertDevicesRelationInput:{
		by:"UserDeviceUniqueWhere",
		update:"UserDeviceWithoutUserUpdateInput",
		create:"UserDeviceWithoutUserCreateInput"
	},
	IdentificationAttemptUpsertUserRelationInput:{
		update:"UserWithoutIdentificationAttemptsUpdateInput",
		create:"UserWithoutIdentificationAttemptsCreateInput"
	},
	IdentificationCodeUpsertAttemptsRelationInput:{
		by:"IdentificationAttemptUniqueWhere",
		update:"IdentificationAttemptWithoutCodeUpdateInput",
		create:"IdentificationAttemptWithoutCodeCreateInput"
	},
	PointOfSaleApplicationDeviceUpsertIdentificationCodeRelationInput:{
		update:"IdentificationCodeWithoutApplicationDevicesUpdateInput",
		create:"IdentificationCodeWithoutApplicationDevicesCreateInput"
	},
	VenueUpsertPointOfSaleApplicationDevicesRelationInput:{
		by:"PointOfSaleApplicationDeviceUniqueWhere",
		update:"PointOfSaleApplicationDeviceWithoutVenueUpdateInput",
		create:"PointOfSaleApplicationDeviceWithoutVenueCreateInput"
	},
	TimetableTemplateUpsertVenueRelationInput:{
		update:"VenueWithoutTimetableTemplatesUpdateInput",
		create:"VenueWithoutTimetableTemplatesCreateInput"
	},
	TimetableShiftPositionUpsertTimetableTemplatesRelationInput:{
		by:"TimetableTemplateUniqueWhere",
		update:"TimetableTemplateWithoutPositionUpdateInput",
		create:"TimetableTemplateWithoutPositionCreateInput"
	},
	TimetableShiftGroupUpsertPositionRelationInput:{
		update:"TimetableShiftPositionWithoutShiftGroupsUpdateInput",
		create:"TimetableShiftPositionWithoutShiftGroupsCreateInput"
	},
	TimetableShiftGroupUpdateGeneratedByTemplateEntityRelationInput:{
		create:"TimetableTemplateCreateInput",
		update:"TimetableTemplateUpdateInput",
		upsert:"TimetableShiftGroupUpsertGeneratedByTemplateRelationInput",
		connect:"TimetableTemplateUniqueWhere"
	},
	TimetableTemplateUpdateInput:{
		startDate:"Date",
		position:"TimetableTemplateUpdatePositionEntityRelationInput",
		staffOptions:"TimetableTemplateUpdateStaffOptionsEntityRelationInput",
		venue:"TimetableTemplateUpdateVenueEntityRelationInput",
		employeeRole:"TimetableTemplateUpdateEmployeeRoleEntityRelationInput",
		type:"TemplateType"
	},
	TimetableShiftGroupUpsertGeneratedByTemplateRelationInput:{
		update:"TimetableTemplateUpdateInput",
		create:"TimetableTemplateCreateInput"
	},
	TimetableShiftUpsertGroupRelationInput:{
		update:"TimetableShiftGroupWithoutShiftsUpdateInput",
		create:"TimetableShiftGroupWithoutShiftsCreateInput"
	},
	TimetableShiftUpdateQueueItemEntityRelationInput:{
		create:"EmployeeQueueItemWithoutShiftCreateInput",
		update:"EmployeeQueueItemWithoutShiftUpdateInput",
		upsert:"TimetableShiftUpsertQueueItemRelationInput",
		connect:"EmployeeQueueItemUniqueWhere"
	},
	EmployeeQueueItemWithoutShiftUpdateInput:{
		queue:"EmployeeQueueItemUpdateQueueEntityRelationInput",
		shiftsProfile:"EmployeeQueueItemUpdateShiftsProfileEntityRelationInput",
		unassignInfo:"EmployeeQueueItemUpdateUnassignInfoEntityRelationInput",
		meta:"EmployeeQueueItemUpdateMetaEntityRelationInput"
	},
	EmployeeQueueItemUpdateUnassignInfoEntityRelationInput:{
		create:"UnassignedShiftInfoWithoutQueueItemCreateInput",
		update:"UnassignedShiftInfoWithoutQueueItemUpdateInput",
		upsert:"EmployeeQueueItemUpsertUnassignInfoRelationInput",
		connect:"UnassignedShiftInfoUniqueWhere"
	},
	UnassignedShiftInfoWithoutQueueItemUpdateInput:{
		legacyReason:"UnassignedInfoReason",
		reason:"UnassignedShiftInfoUpdateReasonEntityRelationInput"
	},
	UnassignedShiftInfoUpdateReasonEntityRelationInput:{
		create:"UnassignReasonCreateInput",
		update:"UnassignReasonUpdateInput",
		upsert:"UnassignedShiftInfoUpsertReasonRelationInput",
		connect:"UnassignReasonUniqueWhere"
	},
	UnassignReasonUpdateInput:{
		venues:"UnassignReasonUpdateVenuesEntityRelationInput"
	},
	UnassignReasonUpdateVenuesEntityRelationInput:{
		create:"VenueWithoutEnabledUnassignReasonsCreateInput",
		update:"UnassignReasonUpdateVenuesRelationInput",
		upsert:"UnassignReasonUpsertVenuesRelationInput",
		connect:"VenueUniqueWhere",
		disconnect:"VenueUniqueWhere",
		delete:"VenueUniqueWhere"
	},
	UnassignReasonUpdateVenuesRelationInput:{
		by:"VenueUniqueWhere",
		data:"VenueWithoutEnabledUnassignReasonsUpdateInput"
	},
	VenueWithoutEnabledUnassignReasonsUpdateInput:{
		deadlineTemplate:"VenueUpdateDeadlineTemplateEntityRelationInput",
		timetableDays:"VenueUpdateTimetableDaysEntityRelationInput",
		timetableTemplates:"VenueUpdateTimetableTemplatesEntityRelationInput",
		staffMembers:"VenueUpdateStaffMembersEntityRelationInput",
		employeeRoles:"VenueUpdateEmployeeRolesEntityRelationInput",
		pointOfSaleApplicationDevices:"VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput",
		pointOfSaleTerminals:"VenueUpdatePointOfSaleTerminalsEntityRelationInput",
		pointOfSalePrinters:"VenueUpdatePointOfSalePrintersEntityRelationInput",
		orders:"VenueUpdateOrdersEntityRelationInput",
		fulfillmentNotes:"VenueUpdateFulfillmentNotesEntityRelationInput",
		areas:"VenueUpdateAreasEntityRelationInput",
		categories:"VenueUpdateCategoriesEntityRelationInput",
		channels:"VenueUpdateChannelsEntityRelationInput",
		pointOfSaleInitialView:"PointOfSaleInitialView"
	},
	UnassignReasonUpsertVenuesRelationInput:{
		by:"VenueUniqueWhere",
		update:"VenueWithoutEnabledUnassignReasonsUpdateInput",
		create:"VenueWithoutEnabledUnassignReasonsCreateInput"
	},
	UnassignedShiftInfoUpsertReasonRelationInput:{
		update:"UnassignReasonUpdateInput",
		create:"UnassignReasonCreateInput"
	},
	EmployeeQueueItemUpsertUnassignInfoRelationInput:{
		update:"UnassignedShiftInfoWithoutQueueItemUpdateInput",
		create:"UnassignedShiftInfoWithoutQueueItemCreateInput"
	},
	EmployeeQueueItemUpdateMetaEntityRelationInput:{
		connect:"EmployeeQueueItemMetadataUniqueWhere"
	},
	TimetableShiftUpsertQueueItemRelationInput:{
		update:"EmployeeQueueItemWithoutShiftUpdateInput",
		create:"EmployeeQueueItemWithoutShiftCreateInput"
	},
	TimetableShiftUpdateSwapInfoEntityRelationInput:{
		create:"TimetableShiftSwapInfoWithoutShiftCreateInput",
		update:"TimetableShiftSwapInfoWithoutShiftUpdateInput",
		upsert:"TimetableShiftUpsertSwapInfoRelationInput",
		connect:"TimetableShiftSwapInfoUniqueWhere"
	},
	TimetableShiftSwapInfoWithoutShiftUpdateInput:{
		assigned:"Date",
		swappedShiftsProfile:"TimetableShiftSwapInfoUpdateSwappedShiftsProfileEntityRelationInput"
	},
	TimetableShiftSwapInfoUpdateSwappedShiftsProfileEntityRelationInput:{
		create:"ShiftsProfileCreateInput",
		update:"ShiftsProfileUpdateInput",
		upsert:"TimetableShiftSwapInfoUpsertSwappedShiftsProfileRelationInput",
		connect:"ShiftsProfileUniqueWhere"
	},
	TimetableShiftSwapInfoUpsertSwappedShiftsProfileRelationInput:{
		update:"ShiftsProfileUpdateInput",
		create:"ShiftsProfileCreateInput"
	},
	TimetableShiftUpsertSwapInfoRelationInput:{
		update:"TimetableShiftSwapInfoWithoutShiftUpdateInput",
		create:"TimetableShiftSwapInfoWithoutShiftCreateInput"
	},
	ShiftsProfileUpsertShiftsRelationInput:{
		by:"TimetableShiftUniqueWhere",
		update:"TimetableShiftWithoutShiftsProfileUpdateInput",
		create:"TimetableShiftWithoutShiftsProfileCreateInput"
	},
	EmployeeQueueItemUpsertShiftsProfileRelationInput:{
		update:"ShiftsProfileWithoutQueueItemsUpdateInput",
		create:"ShiftsProfileWithoutQueueItemsCreateInput"
	},
	EmployeeQueueItemUpdateShiftEntityRelationInput:{
		create:"TimetableShiftWithoutQueueItemCreateInput",
		update:"TimetableShiftWithoutQueueItemUpdateInput",
		upsert:"EmployeeQueueItemUpsertShiftRelationInput",
		connect:"TimetableShiftUniqueWhere"
	},
	TimetableShiftWithoutQueueItemUpdateInput:{
		assigned:"Date",
		group:"TimetableShiftUpdateGroupEntityRelationInput",
		shiftsProfile:"TimetableShiftUpdateShiftsProfileEntityRelationInput",
		swapInfo:"TimetableShiftUpdateSwapInfoEntityRelationInput"
	},
	EmployeeQueueItemUpsertShiftRelationInput:{
		update:"TimetableShiftWithoutQueueItemUpdateInput",
		create:"TimetableShiftWithoutQueueItemCreateInput"
	},
	EmployeeQueueUpsertItemsRelationInput:{
		by:"EmployeeQueueItemUniqueWhere",
		update:"EmployeeQueueItemWithoutQueueUpdateInput",
		create:"EmployeeQueueItemWithoutQueueCreateInput"
	},
	TimetableShiftGroupUpsertQueueRelationInput:{
		update:"EmployeeQueueWithoutShiftGroupUpdateInput",
		create:"EmployeeQueueWithoutShiftGroupCreateInput"
	},
	TimetableShiftPositionUpsertShiftGroupsRelationInput:{
		by:"TimetableShiftGroupUniqueWhere",
		update:"TimetableShiftGroupWithoutPositionUpdateInput",
		create:"TimetableShiftGroupWithoutPositionCreateInput"
	},
	TimetableTemplateUpsertPositionRelationInput:{
		update:"TimetableShiftPositionWithoutTimetableTemplatesUpdateInput",
		create:"TimetableShiftPositionWithoutTimetableTemplatesCreateInput"
	},
	TimetableEmployeeRoleUpsertTimetableTemplatesRelationInput:{
		by:"TimetableTemplateUniqueWhere",
		update:"TimetableTemplateWithoutEmployeeRoleUpdateInput",
		create:"TimetableTemplateWithoutEmployeeRoleCreateInput"
	},
	TimetableShiftGroupUpsertTypeRelationInput:{
		update:"TimetableEmployeeRoleWithoutShiftGroupsUpdateInput",
		create:"TimetableEmployeeRoleWithoutShiftGroupsCreateInput"
	},
	TimetableDayUpsertShiftGroupsRelationInput:{
		by:"TimetableShiftGroupUniqueWhere",
		update:"TimetableShiftGroupWithoutDayUpdateInput",
		create:"TimetableShiftGroupWithoutDayCreateInput"
	},
	TimetableDayUpdateMetaEntityRelationInput:{
		connect:"TimetableDayMetadataUniqueWhere"
	},
	VenueUpsertTimetableDaysRelationInput:{
		by:"TimetableDayUniqueWhere",
		update:"TimetableDayWithoutVenueUpdateInput",
		create:"TimetableDayWithoutVenueCreateInput"
	},
	ChannelUpsertVenueRelationInput:{
		update:"VenueWithoutChannelsUpdateInput",
		create:"VenueWithoutChannelsCreateInput"
	},
	TagUpsertPublicInChannelsRelationInput:{
		by:"ChannelUniqueWhere",
		update:"ChannelWithoutPublicTagsUpdateInput",
		create:"ChannelWithoutPublicTagsCreateInput"
	},
	DeliveryZoneUpsertDeliveryZonesOfTagsRelationInput:{
		by:"TagUniqueWhere",
		update:"TagWithoutDeliveryZonesUpdateInput",
		create:"TagWithoutDeliveryZonesCreateInput"
	},
	DeliveryZoneUpdateAddressesMetadataEntityRelationInput:{
		connect:"AddressMetadataUniqueWhere",
		disconnect:"AddressMetadataUniqueWhere",
		delete:"AddressMetadataUniqueWhere"
	},
	ProductUpsertDeliveryZonesRelationInput:{
		by:"DeliveryZoneUniqueWhere",
		update:"DeliveryZoneWithoutDeliveryZonesOfProductsUpdateInput",
		create:"DeliveryZoneWithoutDeliveryZonesOfProductsCreateInput"
	},
	FulfillmentNoteUpsertProductsRelationInput:{
		by:"ProductUniqueWhere",
		update:"ProductWithoutFulfillmentNotesUpdateInput",
		create:"ProductWithoutFulfillmentNotesCreateInput"
	},
	TagUpsertFulfillmentNotesRelationInput:{
		by:"FulfillmentNoteUniqueWhere",
		update:"FulfillmentNoteWithoutTagsUpdateInput",
		create:"FulfillmentNoteWithoutTagsCreateInput"
	},
	ChannelUpsertPublicTagsRelationInput:{
		by:"TagUniqueWhere",
		update:"TagWithoutPublicInChannelsUpdateInput",
		create:"TagWithoutPublicInChannelsCreateInput"
	},
	CustomerUpsertChannelsRelationInput:{
		by:"ChannelUniqueWhere",
		update:"ChannelWithoutCustomersUpdateInput",
		create:"ChannelWithoutCustomersCreateInput"
	},
	CustomerCreditUpsertCustomerRelationInput:{
		update:"CustomerWithoutCreditsUpdateInput",
		create:"CustomerWithoutCreditsCreateInput"
	},
	CustomerCreditUpdateVoucherRedemptionEntityRelationInput:{
		create:"VoucherRedemptionWithoutCustomerCreditCreateInput",
		update:"VoucherRedemptionWithoutCustomerCreditUpdateInput",
		upsert:"CustomerCreditUpsertVoucherRedemptionRelationInput",
		connect:"VoucherRedemptionUniqueWhere"
	},
	VoucherRedemptionWithoutCustomerCreditUpdateInput:{
		createdAt:"DateTime",
		orderDiscount:"VoucherRedemptionUpdateOrderDiscountEntityRelationInput",
		voucher:"VoucherRedemptionUpdateVoucherEntityRelationInput",
		customer:"VoucherRedemptionUpdateCustomerEntityRelationInput"
	},
	CustomerCreditUpsertVoucherRedemptionRelationInput:{
		update:"VoucherRedemptionWithoutCustomerCreditUpdateInput",
		create:"VoucherRedemptionWithoutCustomerCreditCreateInput"
	},
	CustomerCreditTransactionUpsertCustomerCreditRelationInput:{
		update:"CustomerCreditWithoutTransactionsUpdateInput",
		create:"CustomerCreditWithoutTransactionsCreateInput"
	},
	OrderDiscountUpsertCustomerCreditTransactionsRelationInput:{
		by:"CustomerCreditTransactionUniqueWhere",
		update:"CustomerCreditTransactionWithoutOrderDiscountUpdateInput",
		create:"CustomerCreditTransactionWithoutOrderDiscountCreateInput"
	},
	OrderUpsertDiscountsRelationInput:{
		by:"OrderDiscountUniqueWhere",
		update:"OrderDiscountWithoutOrderUpdateInput",
		create:"OrderDiscountWithoutOrderCreateInput"
	},
	OrderItemUpsertOrderRelationInput:{
		update:"OrderWithoutItemsUpdateInput",
		create:"OrderWithoutItemsCreateInput"
	},
	ProductUpsertOrderItemsRelationInput:{
		by:"OrderItemUniqueWhere",
		update:"OrderItemWithoutProductUpdateInput",
		create:"OrderItemWithoutProductCreateInput"
	},
	StocksManagerUpsertManagedProductsRelationInput:{
		by:"ProductUniqueWhere",
		update:"ProductWithoutManagerUpdateInput",
		create:"ProductWithoutManagerCreateInput"
	},
	StaffUpsertStocksManagerRelationInput:{
		update:"StocksManagerWithoutStaffUpdateInput",
		create:"StocksManagerWithoutStaffCreateInput"
	},
	StaffUpdateVenuesEntityRelationInput:{
		create:"VenueWithoutStaffMembersCreateInput",
		update:"StaffUpdateVenuesRelationInput",
		upsert:"StaffUpsertVenuesRelationInput",
		connect:"VenueUniqueWhere",
		disconnect:"VenueUniqueWhere",
		delete:"VenueUniqueWhere"
	},
	StaffUpdateVenuesRelationInput:{
		by:"VenueUniqueWhere",
		data:"VenueWithoutStaffMembersUpdateInput"
	},
	VenueWithoutStaffMembersUpdateInput:{
		deadlineTemplate:"VenueUpdateDeadlineTemplateEntityRelationInput",
		timetableDays:"VenueUpdateTimetableDaysEntityRelationInput",
		timetableTemplates:"VenueUpdateTimetableTemplatesEntityRelationInput",
		employeeRoles:"VenueUpdateEmployeeRolesEntityRelationInput",
		pointOfSaleApplicationDevices:"VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput",
		pointOfSaleTerminals:"VenueUpdatePointOfSaleTerminalsEntityRelationInput",
		pointOfSalePrinters:"VenueUpdatePointOfSalePrintersEntityRelationInput",
		orders:"VenueUpdateOrdersEntityRelationInput",
		fulfillmentNotes:"VenueUpdateFulfillmentNotesEntityRelationInput",
		areas:"VenueUpdateAreasEntityRelationInput",
		enabledUnassignReasons:"VenueUpdateEnabledUnassignReasonsEntityRelationInput",
		categories:"VenueUpdateCategoriesEntityRelationInput",
		channels:"VenueUpdateChannelsEntityRelationInput",
		pointOfSaleInitialView:"PointOfSaleInitialView"
	},
	StaffUpsertVenuesRelationInput:{
		by:"VenueUniqueWhere",
		update:"VenueWithoutStaffMembersUpdateInput",
		create:"VenueWithoutStaffMembersCreateInput"
	},
	ShiftsManagerUpsertStaffRelationInput:{
		update:"StaffWithoutShiftsManagerUpdateInput",
		create:"StaffWithoutShiftsManagerCreateInput"
	},
	TimetableEmployeeRoleUpsertShiftsManagersRelationInput:{
		by:"ShiftsManagerUniqueWhere",
		update:"ShiftsManagerWithoutManagedRolesUpdateInput",
		create:"ShiftsManagerWithoutManagedRolesCreateInput"
	},
	ShiftsProfileUpsertRolesRelationInput:{
		by:"TimetableEmployeeRoleUniqueWhere",
		update:"TimetableEmployeeRoleWithoutShiftsProfilesUpdateInput",
		create:"TimetableEmployeeRoleWithoutShiftsProfilesCreateInput"
	},
	StaffUpsertShiftsProfileRelationInput:{
		update:"ShiftsProfileWithoutStaffUpdateInput",
		create:"ShiftsProfileWithoutStaffCreateInput"
	},
	UserUpsertStaffRelationInput:{
		update:"StaffWithoutUserUpdateInput",
		create:"StaffWithoutUserCreateInput"
	},
	CustomerUpsertUserRelationInput:{
		update:"UserWithoutCustomerUpdateInput",
		create:"UserWithoutCustomerCreateInput"
	},
	OrderUpsertCustomerRelationInput:{
		update:"CustomerWithoutOrdersUpdateInput",
		create:"CustomerWithoutOrdersCreateInput"
	},
	CartUpsertOrderRelationInput:{
		update:"OrderWithoutCartUpdateInput",
		create:"OrderWithoutCartCreateInput"
	},
	CustomerUpsertCartsRelationInput:{
		by:"CartUniqueWhere",
		update:"CartWithoutCustomerUpdateInput",
		create:"CartWithoutCustomerCreateInput"
	},
	UserUpsertCustomerRelationInput:{
		update:"CustomerWithoutUserUpdateInput",
		create:"CustomerWithoutUserCreateInput"
	},
	StaffUpsertUserRelationInput:{
		update:"UserWithoutStaffUpdateInput",
		create:"UserWithoutStaffCreateInput"
	},
	BusinessToBusinessManagerUpsertStaffRelationInput:{
		update:"StaffWithoutBusinessToBusinessManagerUpdateInput",
		create:"StaffWithoutBusinessToBusinessManagerCreateInput"
	},
	BusinessCustomerUpsertAccountManagerRelationInput:{
		update:"BusinessToBusinessManagerWithoutManagedBusinessesUpdateInput",
		create:"BusinessToBusinessManagerWithoutManagedBusinessesCreateInput"
	},
	BusinessCustomerUpdateLogoEntityRelationInput:{
		create:"ImageCreateInput",
		update:"ImageUpdateInput",
		upsert:"BusinessCustomerUpsertLogoRelationInput",
		connect:"ImageUniqueWhere"
	},
	BusinessCustomerUpsertLogoRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	BusinessCustomerUpdateBusinessServiceEventsEntityRelationInput:{
		create:"BusinessServiceEventWithoutBusinessCustomerCreateInput",
		update:"BusinessCustomerUpdateBusinessServiceEventsRelationInput",
		upsert:"BusinessCustomerUpsertBusinessServiceEventsRelationInput",
		connect:"BusinessServiceEventUniqueWhere",
		disconnect:"BusinessServiceEventUniqueWhere",
		delete:"BusinessServiceEventUniqueWhere"
	},
	BusinessCustomerUpdateBusinessServiceEventsRelationInput:{
		by:"BusinessServiceEventUniqueWhere",
		data:"BusinessServiceEventWithoutBusinessCustomerUpdateInput"
	},
	BusinessServiceEventWithoutBusinessCustomerUpdateInput:{
		createdAt:"DateTime",
		fulfilledAt:"DateTime",
		businessService:"BusinessServiceEventUpdateBusinessServiceEntityRelationInput",
		createdBy:"BusinessServiceEventUpdateCreatedByEntityRelationInput",
		filledSupervisor:"BusinessServiceEventUpdateFilledSupervisorEntityRelationInput"
	},
	BusinessServiceEventUpdateBusinessServiceEntityRelationInput:{
		create:"BusinessServiceCreateInput",
		update:"BusinessServiceUpdateInput",
		upsert:"BusinessServiceEventUpsertBusinessServiceRelationInput",
		connect:"BusinessServiceUniqueWhere"
	},
	BusinessServiceUpdateInput:{
		locales:"BusinessServiceUpdateLocalesEntityRelationInput"
	},
	BusinessServiceUpdateLocalesEntityRelationInput:{
		create:"BusinessServiceLocaleWithoutRootCreateInput",
		update:"BusinessServiceUpdateLocalesRelationInput",
		upsert:"BusinessServiceUpsertLocalesRelationInput",
		connect:"BusinessServiceLocaleUniqueWhere",
		disconnect:"BusinessServiceLocaleUniqueWhere",
		delete:"BusinessServiceLocaleUniqueWhere"
	},
	BusinessServiceUpdateLocalesRelationInput:{
		by:"BusinessServiceLocaleUniqueWhere",
		data:"BusinessServiceLocaleWithoutRootUpdateInput"
	},
	BusinessServiceLocaleWithoutRootUpdateInput:{
		locale:"BusinessServiceLocaleUpdateLocaleEntityRelationInput"
	},
	BusinessServiceLocaleUpdateLocaleEntityRelationInput:{
		create:"LocaleWithoutBusinessServicesCreateInput",
		update:"LocaleWithoutBusinessServicesUpdateInput",
		upsert:"BusinessServiceLocaleUpsertLocaleRelationInput",
		connect:"LocaleUniqueWhere"
	},
	LocaleWithoutBusinessServicesUpdateInput:{
		businessCategories:"LocaleUpdateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleUpdateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleUpdateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleUpdateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleUpdateBlogsEntityRelationInput",
		blogPosts:"LocaleUpdateBlogPostsEntityRelationInput",
		identifier:"LocaleUpdateIdentifierEntityRelationInput",
		menus:"LocaleUpdateMenusEntityRelationInput",
		pages:"LocaleUpdatePagesEntityRelationInput",
		productIngredientCategories:"LocaleUpdateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleUpdateAllergensEntityRelationInput",
		productPackings:"LocaleUpdateProductPackingsEntityRelationInput",
		products:"LocaleUpdateProductsEntityRelationInput",
		productRecipes:"LocaleUpdateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleUpdatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleUpdateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleUpdateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleUpdateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleUpdatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleUpdateSubscriptionBoxesEntityRelationInput"
	},
	BusinessServiceLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutBusinessServicesUpdateInput",
		create:"LocaleWithoutBusinessServicesCreateInput"
	},
	BusinessServiceUpsertLocalesRelationInput:{
		by:"BusinessServiceLocaleUniqueWhere",
		update:"BusinessServiceLocaleWithoutRootUpdateInput",
		create:"BusinessServiceLocaleWithoutRootCreateInput"
	},
	BusinessServiceEventUpsertBusinessServiceRelationInput:{
		update:"BusinessServiceUpdateInput",
		create:"BusinessServiceCreateInput"
	},
	BusinessServiceEventUpdateCreatedByEntityRelationInput:{
		create:"StaffCreateInput",
		update:"StaffUpdateInput",
		upsert:"BusinessServiceEventUpsertCreatedByRelationInput",
		connect:"StaffUniqueWhere"
	},
	StaffUpdateInput:{
		bartender:"StaffUpdateBartenderEntityRelationInput",
		courier:"StaffUpdateCourierEntityRelationInput",
		cleaner:"StaffUpdateCleanerEntityRelationInput",
		shiftsManager:"StaffUpdateShiftsManagerEntityRelationInput",
		businessToBusinessManager:"StaffUpdateBusinessToBusinessManagerEntityRelationInput",
		user:"StaffUpdateUserEntityRelationInput",
		shiftsProfile:"StaffUpdateShiftsProfileEntityRelationInput",
		stocksManager:"StaffUpdateStocksManagerEntityRelationInput",
		photo:"StaffUpdatePhotoEntityRelationInput",
		courierManager:"StaffUpdateCourierManagerEntityRelationInput",
		picker:"StaffUpdatePickerEntityRelationInput",
		createdAt:"DateTime",
		remunerationProfile:"StaffUpdateRemunerationProfileEntityRelationInput",
		cashier:"StaffUpdateCashierEntityRelationInput",
		venues:"StaffUpdateVenuesEntityRelationInput",
		internalBuyer:"StaffUpdateInternalBuyerEntityRelationInput",
		salesManager:"StaffUpdateSalesManagerEntityRelationInput",
		cashierManager:"StaffUpdateCashierManagerEntityRelationInput"
	},
	BusinessServiceEventUpsertCreatedByRelationInput:{
		update:"StaffUpdateInput",
		create:"StaffCreateInput"
	},
	BusinessServiceEventUpdateFilledSupervisorEntityRelationInput:{
		create:"StaffCreateInput",
		update:"StaffUpdateInput",
		upsert:"BusinessServiceEventUpsertFilledSupervisorRelationInput",
		connect:"StaffUniqueWhere"
	},
	BusinessServiceEventUpsertFilledSupervisorRelationInput:{
		update:"StaffUpdateInput",
		create:"StaffCreateInput"
	},
	BusinessCustomerUpsertBusinessServiceEventsRelationInput:{
		by:"BusinessServiceEventUniqueWhere",
		update:"BusinessServiceEventWithoutBusinessCustomerUpdateInput",
		create:"BusinessServiceEventWithoutBusinessCustomerCreateInput"
	},
	BusinessCustomerUpdateDoubleshotCoffeeEquipmentEntityRelationInput:{
		create:"DoubleshotCoffeeEquipmentCreateInput",
		update:"DoubleshotCoffeeEquipmentUpdateInput",
		upsert:"BusinessCustomerUpsertDoubleshotCoffeeEquipmentRelationInput",
		connect:"DoubleshotCoffeeEquipmentUniqueWhere"
	},
	DoubleshotCoffeeEquipmentUpdateInput:{

	},
	BusinessCustomerUpsertDoubleshotCoffeeEquipmentRelationInput:{
		update:"DoubleshotCoffeeEquipmentUpdateInput",
		create:"DoubleshotCoffeeEquipmentCreateInput"
	},
	CustomerUpsertOwnerOfBusinessesRelationInput:{
		by:"BusinessCustomerUniqueWhere",
		update:"BusinessCustomerWithoutOwnersUpdateInput",
		create:"BusinessCustomerWithoutOwnersCreateInput"
	},
	BusinessCustomerUpsertMembersRelationInput:{
		by:"CustomerUniqueWhere",
		update:"CustomerWithoutMemberOfBusinessesUpdateInput",
		create:"CustomerWithoutMemberOfBusinessesCreateInput"
	},
	BusinessToBusinessManagerUpsertManagedBusinessesRelationInput:{
		by:"BusinessCustomerUniqueWhere",
		update:"BusinessCustomerWithoutAccountManagerUpdateInput",
		create:"BusinessCustomerWithoutAccountManagerCreateInput"
	},
	StaffUpsertBusinessToBusinessManagerRelationInput:{
		update:"BusinessToBusinessManagerWithoutStaffUpdateInput",
		create:"BusinessToBusinessManagerWithoutStaffCreateInput"
	},
	ShiftsProfileUpsertStaffRelationInput:{
		update:"StaffWithoutShiftsProfileUpdateInput",
		create:"StaffWithoutShiftsProfileCreateInput"
	},
	TimetableEmployeeRoleUpsertShiftsProfilesRelationInput:{
		by:"ShiftsProfileUniqueWhere",
		update:"ShiftsProfileWithoutRolesUpdateInput",
		create:"ShiftsProfileWithoutRolesCreateInput"
	},
	TimetableDayNoteUpsertRoleRelationInput:{
		update:"TimetableEmployeeRoleUpdateInput",
		create:"TimetableEmployeeRoleCreateInput"
	},
	TimetableDayUpsertNotesRelationInput:{
		by:"TimetableDayNoteUniqueWhere",
		update:"TimetableDayNoteWithoutDayUpdateInput",
		create:"TimetableDayNoteWithoutDayCreateInput"
	},
	TimetableDayUpdateVenueEntityRelationInput:{
		create:"VenueWithoutTimetableDaysCreateInput",
		update:"VenueWithoutTimetableDaysUpdateInput",
		upsert:"TimetableDayUpsertVenueRelationInput",
		connect:"VenueUniqueWhere"
	},
	VenueWithoutTimetableDaysUpdateInput:{
		deadlineTemplate:"VenueUpdateDeadlineTemplateEntityRelationInput",
		timetableTemplates:"VenueUpdateTimetableTemplatesEntityRelationInput",
		staffMembers:"VenueUpdateStaffMembersEntityRelationInput",
		employeeRoles:"VenueUpdateEmployeeRolesEntityRelationInput",
		pointOfSaleApplicationDevices:"VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput",
		pointOfSaleTerminals:"VenueUpdatePointOfSaleTerminalsEntityRelationInput",
		pointOfSalePrinters:"VenueUpdatePointOfSalePrintersEntityRelationInput",
		orders:"VenueUpdateOrdersEntityRelationInput",
		fulfillmentNotes:"VenueUpdateFulfillmentNotesEntityRelationInput",
		areas:"VenueUpdateAreasEntityRelationInput",
		enabledUnassignReasons:"VenueUpdateEnabledUnassignReasonsEntityRelationInput",
		categories:"VenueUpdateCategoriesEntityRelationInput",
		channels:"VenueUpdateChannelsEntityRelationInput",
		pointOfSaleInitialView:"PointOfSaleInitialView"
	},
	TimetableDayUpsertVenueRelationInput:{
		update:"VenueWithoutTimetableDaysUpdateInput",
		create:"VenueWithoutTimetableDaysCreateInput"
	},
	TimetableShiftGroupUpsertDayRelationInput:{
		update:"TimetableDayWithoutShiftGroupsUpdateInput",
		create:"TimetableDayWithoutShiftGroupsCreateInput"
	},
	EmployeeQueueUpsertShiftGroupRelationInput:{
		update:"TimetableShiftGroupWithoutQueueUpdateInput",
		create:"TimetableShiftGroupWithoutQueueCreateInput"
	},
	EmployeeQueueItemUpsertQueueRelationInput:{
		update:"EmployeeQueueWithoutItemsUpdateInput",
		create:"EmployeeQueueWithoutItemsCreateInput"
	},
	ShiftsProfileUpsertQueueItemsRelationInput:{
		by:"EmployeeQueueItemUniqueWhere",
		update:"EmployeeQueueItemWithoutShiftsProfileUpdateInput",
		create:"EmployeeQueueItemWithoutShiftsProfileCreateInput"
	},
	TimetableShiftUpsertShiftsProfileRelationInput:{
		update:"ShiftsProfileWithoutShiftsUpdateInput",
		create:"ShiftsProfileWithoutShiftsCreateInput"
	},
	TimetableShiftGroupUpsertShiftsRelationInput:{
		by:"TimetableShiftUniqueWhere",
		update:"TimetableShiftWithoutGroupUpdateInput",
		create:"TimetableShiftWithoutGroupCreateInput"
	},
	TimetableEmployeeRoleUpsertShiftGroupsRelationInput:{
		by:"TimetableShiftGroupUniqueWhere",
		update:"TimetableShiftGroupWithoutTypeUpdateInput",
		create:"TimetableShiftGroupWithoutTypeCreateInput"
	},
	ShiftsManagerUpsertManagedRolesRelationInput:{
		by:"TimetableEmployeeRoleUniqueWhere",
		update:"TimetableEmployeeRoleWithoutShiftsManagersUpdateInput",
		create:"TimetableEmployeeRoleWithoutShiftsManagersCreateInput"
	},
	StaffUpsertShiftsManagerRelationInput:{
		update:"ShiftsManagerWithoutStaffUpdateInput",
		create:"ShiftsManagerWithoutStaffCreateInput"
	},
	CourierUpsertStaffRelationInput:{
		update:"StaffWithoutCourierUpdateInput",
		create:"StaffWithoutCourierCreateInput"
	},
	DeliveryMethodUpsertCourierHandlersRelationInput:{
		by:"CourierUniqueWhere",
		update:"CourierWithoutDeliveryMethodsUpdateInput",
		create:"CourierWithoutDeliveryMethodsCreateInput"
	},
	OrderDeliveryUpsertMethodRelationInput:{
		update:"DeliveryMethodUpdateInput",
		create:"DeliveryMethodCreateInput"
	},
	DeliveryWaypointUpsertDeliveryRelationInput:{
		update:"OrderDeliveryWithoutDeliveryWaypointUpdateInput",
		create:"OrderDeliveryWithoutDeliveryWaypointCreateInput"
	},
	DeliveryRouteUpsertWaypointsRelationInput:{
		by:"DeliveryWaypointUniqueWhere",
		update:"DeliveryWaypointWithoutRouteUpdateInput",
		create:"DeliveryWaypointWithoutRouteCreateInput"
	},
	CourierUpsertRoutesRelationInput:{
		by:"DeliveryRouteUniqueWhere",
		update:"DeliveryRouteWithoutCourierUpdateInput",
		create:"DeliveryRouteWithoutCourierCreateInput"
	},
	StaffUpsertCourierRelationInput:{
		update:"CourierWithoutStaffUpdateInput",
		create:"CourierWithoutStaffCreateInput"
	},
	StocksManagerUpsertStaffRelationInput:{
		update:"StaffWithoutStocksManagerUpdateInput",
		create:"StaffWithoutStocksManagerCreateInput"
	},
	ProductUpsertManagerRelationInput:{
		update:"StocksManagerWithoutManagedProductsUpdateInput",
		create:"StocksManagerWithoutManagedProductsCreateInput"
	},
	VirtualProductUpsertProductRelationInput:{
		update:"ProductWithoutVirtualProductUpdateInput",
		create:"ProductWithoutVirtualProductCreateInput"
	},
	WorkspaceUpsertCreditsProductRelationInput:{
		update:"VirtualProductUpdateInput",
		create:"VirtualProductCreateInput"
	},
	WorkspaceUpdateDiscountVatRateEntityRelationInput:{
		create:"VatRateCreateInput",
		update:"VatRateUpdateInput",
		upsert:"WorkspaceUpsertDiscountVatRateRelationInput",
		connect:"VatRateUniqueWhere"
	},
	WorkspaceUpsertDiscountVatRateRelationInput:{
		update:"VatRateUpdateInput",
		create:"VatRateCreateInput"
	},
	FreshingContainerUpsertWorkspaceRelationInput:{
		update:"WorkspaceWithoutFreshingContainersUpdateInput",
		create:"WorkspaceWithoutFreshingContainersCreateInput"
	},
	ProductIngredientUpsertFreshingContainerRelationInput:{
		update:"FreshingContainerUpdateInput",
		create:"FreshingContainerCreateInput"
	},
	ProductIngredientUpdateImageEntityRelationInput:{
		create:"ImageCreateInput",
		update:"ImageUpdateInput",
		upsert:"ProductIngredientUpsertImageRelationInput",
		connect:"ImageUniqueWhere"
	},
	ProductIngredientUpsertImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	ProductIngredientUpdateSuppliersEntityRelationInput:{
		create:"IngredientSupplierListCreateInput",
		update:"IngredientSupplierListUpdateInput",
		upsert:"ProductIngredientUpsertSuppliersRelationInput",
		connect:"IngredientSupplierListUniqueWhere"
	},
	IngredientSupplierListUpdateInput:{
		items:"IngredientSupplierListUpdateItemsEntityRelationInput"
	},
	IngredientSupplierListUpdateItemsEntityRelationInput:{
		create:"IngredientSupplierItemWithoutListCreateInput",
		update:"IngredientSupplierListUpdateItemsRelationInput",
		upsert:"IngredientSupplierListUpsertItemsRelationInput",
		connect:"IngredientSupplierItemUniqueWhere",
		disconnect:"IngredientSupplierItemUniqueWhere",
		delete:"IngredientSupplierItemUniqueWhere"
	},
	IngredientSupplierListUpdateItemsRelationInput:{
		by:"IngredientSupplierItemUniqueWhere",
		data:"IngredientSupplierItemWithoutListUpdateInput"
	},
	IngredientSupplierItemWithoutListUpdateInput:{
		supplier:"IngredientSupplierItemUpdateSupplierEntityRelationInput"
	},
	IngredientSupplierItemUpdateSupplierEntityRelationInput:{
		create:"IngredientSupplierCreateInput",
		update:"IngredientSupplierUpdateInput",
		upsert:"IngredientSupplierItemUpsertSupplierRelationInput",
		connect:"IngredientSupplierUniqueWhere"
	},
	IngredientSupplierUpdateInput:{
		locales:"IngredientSupplierUpdateLocalesEntityRelationInput"
	},
	IngredientSupplierUpdateLocalesEntityRelationInput:{
		create:"IngredientSupplierLocaleWithoutRootCreateInput",
		update:"IngredientSupplierUpdateLocalesRelationInput",
		upsert:"IngredientSupplierUpsertLocalesRelationInput",
		connect:"IngredientSupplierLocaleUniqueWhere",
		disconnect:"IngredientSupplierLocaleUniqueWhere",
		delete:"IngredientSupplierLocaleUniqueWhere"
	},
	IngredientSupplierUpdateLocalesRelationInput:{
		by:"IngredientSupplierLocaleUniqueWhere",
		data:"IngredientSupplierLocaleWithoutRootUpdateInput"
	},
	IngredientSupplierLocaleWithoutRootUpdateInput:{
		locale:"IngredientSupplierLocaleUpdateLocaleEntityRelationInput"
	},
	IngredientSupplierLocaleUpdateLocaleEntityRelationInput:{
		create:"LocaleWithoutIngredientSuppliersCreateInput",
		update:"LocaleWithoutIngredientSuppliersUpdateInput",
		upsert:"IngredientSupplierLocaleUpsertLocaleRelationInput",
		connect:"LocaleUniqueWhere"
	},
	LocaleWithoutIngredientSuppliersUpdateInput:{
		businessCategories:"LocaleUpdateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleUpdateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleUpdateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleUpdateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleUpdateBlogsEntityRelationInput",
		blogPosts:"LocaleUpdateBlogPostsEntityRelationInput",
		identifier:"LocaleUpdateIdentifierEntityRelationInput",
		menus:"LocaleUpdateMenusEntityRelationInput",
		pages:"LocaleUpdatePagesEntityRelationInput",
		productIngredientCategories:"LocaleUpdateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleUpdateAllergensEntityRelationInput",
		productPackings:"LocaleUpdateProductPackingsEntityRelationInput",
		products:"LocaleUpdateProductsEntityRelationInput",
		productRecipes:"LocaleUpdateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleUpdatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleUpdateDeliveryMethodsEntityRelationInput",
		identificationCodes:"LocaleUpdateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleUpdatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleUpdateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleUpdateBusinessServicesEntityRelationInput"
	},
	IngredientSupplierLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutIngredientSuppliersUpdateInput",
		create:"LocaleWithoutIngredientSuppliersCreateInput"
	},
	IngredientSupplierUpsertLocalesRelationInput:{
		by:"IngredientSupplierLocaleUniqueWhere",
		update:"IngredientSupplierLocaleWithoutRootUpdateInput",
		create:"IngredientSupplierLocaleWithoutRootCreateInput"
	},
	IngredientSupplierItemUpsertSupplierRelationInput:{
		update:"IngredientSupplierUpdateInput",
		create:"IngredientSupplierCreateInput"
	},
	IngredientSupplierListUpsertItemsRelationInput:{
		by:"IngredientSupplierItemUniqueWhere",
		update:"IngredientSupplierItemWithoutListUpdateInput",
		create:"IngredientSupplierItemWithoutListCreateInput"
	},
	ProductIngredientUpsertSuppliersRelationInput:{
		update:"IngredientSupplierListUpdateInput",
		create:"IngredientSupplierListCreateInput"
	},
	AllergenUpsertIngredientsRelationInput:{
		by:"ProductIngredientUniqueWhere",
		update:"ProductIngredientWithoutAllergensUpdateInput",
		create:"ProductIngredientWithoutAllergensCreateInput"
	},
	AllergenLocaleUpsertRootRelationInput:{
		update:"AllergenWithoutLocalesUpdateInput",
		create:"AllergenWithoutLocalesCreateInput"
	},
	LocaleUpsertAllergensRelationInput:{
		by:"AllergenLocaleUniqueWhere",
		update:"AllergenLocaleWithoutLocaleUpdateInput",
		create:"AllergenLocaleWithoutLocaleCreateInput"
	},
	OrderRecurrenceLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutOrderRecurrencesUpdateInput",
		create:"LocaleWithoutOrderRecurrencesCreateInput"
	},
	OrderRecurrenceUpsertLocalesRelationInput:{
		by:"OrderRecurrenceLocaleUniqueWhere",
		update:"OrderRecurrenceLocaleWithoutRootUpdateInput",
		create:"OrderRecurrenceLocaleWithoutRootCreateInput"
	},
	BusinessCategoryUpsertRecurrencesRelationInput:{
		by:"OrderRecurrenceUniqueWhere",
		update:"OrderRecurrenceWithoutBusinessCategoryUpdateInput",
		create:"OrderRecurrenceWithoutBusinessCategoryCreateInput"
	},
	BusinessCategoryUpdateSpecificProductsEntityRelationInput:{
		create:"ProductListWithoutBusinessCategoryCreateInput",
		update:"ProductListWithoutBusinessCategoryUpdateInput",
		upsert:"BusinessCategoryUpsertSpecificProductsRelationInput",
		connect:"ProductListUniqueWhere"
	},
	ProductListWithoutBusinessCategoryUpdateInput:{
		items:"ProductListUpdateItemsEntityRelationInput"
	},
	ProductListUpdateItemsEntityRelationInput:{
		create:"ProductListItemWithoutListCreateInput",
		update:"ProductListUpdateItemsRelationInput",
		upsert:"ProductListUpsertItemsRelationInput",
		connect:"ProductListItemUniqueWhere",
		disconnect:"ProductListItemUniqueWhere",
		delete:"ProductListItemUniqueWhere"
	},
	ProductListUpdateItemsRelationInput:{
		by:"ProductListItemUniqueWhere",
		data:"ProductListItemWithoutListUpdateInput"
	},
	ProductListItemWithoutListUpdateInput:{
		product:"ProductListItemUpdateProductEntityRelationInput"
	},
	ProductListItemUpdateProductEntityRelationInput:{
		create:"ProductCreateInput",
		update:"ProductUpdateInput",
		upsert:"ProductListItemUpsertProductRelationInput",
		connect:"ProductUniqueWhere"
	},
	ProductListItemUpsertProductRelationInput:{
		update:"ProductUpdateInput",
		create:"ProductCreateInput"
	},
	ProductListUpsertItemsRelationInput:{
		by:"ProductListItemUniqueWhere",
		update:"ProductListItemWithoutListUpdateInput",
		create:"ProductListItemWithoutListCreateInput"
	},
	BusinessCategoryUpsertSpecificProductsRelationInput:{
		update:"ProductListWithoutBusinessCategoryUpdateInput",
		create:"ProductListWithoutBusinessCategoryCreateInput"
	},
	BusinessCategoryUpdateSeasonalProductCategoriesEntityRelationInput:{
		create:"ProductCategoryListWithoutSeasonalProductCategoriesOfBusinessCategoryCreateInput",
		update:"ProductCategoryListWithoutSeasonalProductCategoriesOfBusinessCategoryUpdateInput",
		upsert:"BusinessCategoryUpsertSeasonalProductCategoriesRelationInput",
		connect:"ProductCategoryListUniqueWhere"
	},
	ProductCategoryListWithoutSeasonalProductCategoriesOfBusinessCategoryUpdateInput:{
		items:"ProductCategoryListUpdateItemsEntityRelationInput",
		locales:"ProductCategoryListUpdateLocalesEntityRelationInput",
		specificProductsProductCategoriesOfBusinessCategory:"ProductCategoryListUpdateSpecificProductsProductCategoriesOfBusinessCategoryEntityRelationInput"
	},
	ProductCategoryListUpdateLocalesEntityRelationInput:{
		create:"ProductCategoryListLocaleWithoutRootCreateInput",
		update:"ProductCategoryListUpdateLocalesRelationInput",
		upsert:"ProductCategoryListUpsertLocalesRelationInput",
		connect:"ProductCategoryListLocaleUniqueWhere",
		disconnect:"ProductCategoryListLocaleUniqueWhere",
		delete:"ProductCategoryListLocaleUniqueWhere"
	},
	ProductCategoryListUpdateLocalesRelationInput:{
		by:"ProductCategoryListLocaleUniqueWhere",
		data:"ProductCategoryListLocaleWithoutRootUpdateInput"
	},
	ProductCategoryListLocaleWithoutRootUpdateInput:{
		locale:"ProductCategoryListLocaleUpdateLocaleEntityRelationInput"
	},
	ProductCategoryListLocaleUpdateLocaleEntityRelationInput:{
		create:"LocaleWithoutProductCategoryListsCreateInput",
		update:"LocaleWithoutProductCategoryListsUpdateInput",
		upsert:"ProductCategoryListLocaleUpsertLocaleRelationInput",
		connect:"LocaleUniqueWhere"
	},
	LocaleWithoutProductCategoryListsUpdateInput:{
		businessCategories:"LocaleUpdateBusinessCategoriesEntityRelationInput",
		productIngredients:"LocaleUpdateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleUpdateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleUpdateBlogsEntityRelationInput",
		blogPosts:"LocaleUpdateBlogPostsEntityRelationInput",
		identifier:"LocaleUpdateIdentifierEntityRelationInput",
		menus:"LocaleUpdateMenusEntityRelationInput",
		pages:"LocaleUpdatePagesEntityRelationInput",
		productIngredientCategories:"LocaleUpdateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleUpdateAllergensEntityRelationInput",
		productPackings:"LocaleUpdateProductPackingsEntityRelationInput",
		products:"LocaleUpdateProductsEntityRelationInput",
		productRecipes:"LocaleUpdateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleUpdatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleUpdateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleUpdateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleUpdateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleUpdatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleUpdateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleUpdateBusinessServicesEntityRelationInput"
	},
	ProductCategoryListLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutProductCategoryListsUpdateInput",
		create:"LocaleWithoutProductCategoryListsCreateInput"
	},
	ProductCategoryListUpsertLocalesRelationInput:{
		by:"ProductCategoryListLocaleUniqueWhere",
		update:"ProductCategoryListLocaleWithoutRootUpdateInput",
		create:"ProductCategoryListLocaleWithoutRootCreateInput"
	},
	ProductCategoryListUpdateSpecificProductsProductCategoriesOfBusinessCategoryEntityRelationInput:{
		create:"BusinessCategoryWithoutSpecificProductsProductCategoriesCreateInput",
		update:"BusinessCategoryWithoutSpecificProductsProductCategoriesUpdateInput",
		upsert:"ProductCategoryListUpsertSpecificProductsProductCategoriesOfBusinessCategoryRelationInput",
		connect:"BusinessCategoryUniqueWhere"
	},
	BusinessCategoryWithoutSpecificProductsProductCategoriesUpdateInput:{
		locales:"BusinessCategoryUpdateLocalesEntityRelationInput",
		businessCustomers:"BusinessCategoryUpdateBusinessCustomersEntityRelationInput",
		recurrences:"BusinessCategoryUpdateRecurrencesEntityRelationInput",
		specificProducts:"BusinessCategoryUpdateSpecificProductsEntityRelationInput",
		seasonalProductCategories:"BusinessCategoryUpdateSeasonalProductCategoriesEntityRelationInput"
	},
	ProductCategoryListUpsertSpecificProductsProductCategoriesOfBusinessCategoryRelationInput:{
		update:"BusinessCategoryWithoutSpecificProductsProductCategoriesUpdateInput",
		create:"BusinessCategoryWithoutSpecificProductsProductCategoriesCreateInput"
	},
	BusinessCategoryUpsertSeasonalProductCategoriesRelationInput:{
		update:"ProductCategoryListWithoutSeasonalProductCategoriesOfBusinessCategoryUpdateInput",
		create:"ProductCategoryListWithoutSeasonalProductCategoriesOfBusinessCategoryCreateInput"
	},
	BusinessCategoryUpdateSpecificProductsProductCategoriesEntityRelationInput:{
		create:"ProductCategoryListWithoutSpecificProductsProductCategoriesOfBusinessCategoryCreateInput",
		update:"ProductCategoryListWithoutSpecificProductsProductCategoriesOfBusinessCategoryUpdateInput",
		upsert:"BusinessCategoryUpsertSpecificProductsProductCategoriesRelationInput",
		connect:"ProductCategoryListUniqueWhere"
	},
	ProductCategoryListWithoutSpecificProductsProductCategoriesOfBusinessCategoryUpdateInput:{
		items:"ProductCategoryListUpdateItemsEntityRelationInput",
		locales:"ProductCategoryListUpdateLocalesEntityRelationInput",
		seasonalProductCategoriesOfBusinessCategory:"ProductCategoryListUpdateSeasonalProductCategoriesOfBusinessCategoryEntityRelationInput"
	},
	ProductCategoryListUpdateSeasonalProductCategoriesOfBusinessCategoryEntityRelationInput:{
		create:"BusinessCategoryWithoutSeasonalProductCategoriesCreateInput",
		update:"BusinessCategoryWithoutSeasonalProductCategoriesUpdateInput",
		upsert:"ProductCategoryListUpsertSeasonalProductCategoriesOfBusinessCategoryRelationInput",
		connect:"BusinessCategoryUniqueWhere"
	},
	BusinessCategoryWithoutSeasonalProductCategoriesUpdateInput:{
		locales:"BusinessCategoryUpdateLocalesEntityRelationInput",
		businessCustomers:"BusinessCategoryUpdateBusinessCustomersEntityRelationInput",
		recurrences:"BusinessCategoryUpdateRecurrencesEntityRelationInput",
		specificProducts:"BusinessCategoryUpdateSpecificProductsEntityRelationInput",
		specificProductsProductCategories:"BusinessCategoryUpdateSpecificProductsProductCategoriesEntityRelationInput"
	},
	ProductCategoryListUpsertSeasonalProductCategoriesOfBusinessCategoryRelationInput:{
		update:"BusinessCategoryWithoutSeasonalProductCategoriesUpdateInput",
		create:"BusinessCategoryWithoutSeasonalProductCategoriesCreateInput"
	},
	BusinessCategoryUpsertSpecificProductsProductCategoriesRelationInput:{
		update:"ProductCategoryListWithoutSpecificProductsProductCategoriesOfBusinessCategoryUpdateInput",
		create:"ProductCategoryListWithoutSpecificProductsProductCategoriesOfBusinessCategoryCreateInput"
	},
	BusinessCustomerUpsertCategoryRelationInput:{
		update:"BusinessCategoryWithoutBusinessCustomersUpdateInput",
		create:"BusinessCategoryWithoutBusinessCustomersCreateInput"
	},
	CustomerUpsertMemberOfBusinessesRelationInput:{
		by:"BusinessCustomerUniqueWhere",
		update:"BusinessCustomerWithoutMembersUpdateInput",
		create:"BusinessCustomerWithoutMembersCreateInput"
	},
	BusinessCustomerUpsertOwnersRelationInput:{
		by:"CustomerUniqueWhere",
		update:"CustomerWithoutOwnerOfBusinessesUpdateInput",
		create:"CustomerWithoutOwnerOfBusinessesCreateInput"
	},
	CustomerUpsertBusinessRelationInput:{
		update:"BusinessCustomerWithoutCustomerUpdateInput",
		create:"BusinessCustomerWithoutCustomerCreateInput"
	},
	CustomerIngredientRatingUpsertCustomerRelationInput:{
		update:"CustomerWithoutIngredientRatingsUpdateInput",
		create:"CustomerWithoutIngredientRatingsCreateInput"
	},
	ProductIngredientUpsertCustomerRatingsRelationInput:{
		by:"CustomerIngredientRatingUniqueWhere",
		update:"CustomerIngredientRatingWithoutIngredientUpdateInput",
		create:"CustomerIngredientRatingWithoutIngredientCreateInput"
	},
	ProductIngredientCategoryUpsertIngredientsRelationInput:{
		by:"ProductIngredientUniqueWhere",
		update:"ProductIngredientWithoutCategoriesUpdateInput",
		create:"ProductIngredientWithoutCategoriesCreateInput"
	},
	ProductIngredientCategoryLocaleUpsertRootRelationInput:{
		update:"ProductIngredientCategoryWithoutLocalesUpdateInput",
		create:"ProductIngredientCategoryWithoutLocalesCreateInput"
	},
	LocaleUpsertProductIngredientCategoriesRelationInput:{
		by:"ProductIngredientCategoryLocaleUniqueWhere",
		update:"ProductIngredientCategoryLocaleWithoutLocaleUpdateInput",
		create:"ProductIngredientCategoryLocaleWithoutLocaleCreateInput"
	},
	PageLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutPagesUpdateInput",
		create:"LocaleWithoutPagesCreateInput"
	},
	LinkableUpsertPageRelationInput:{
		update:"PageLocaleWithoutLinkUpdateInput",
		create:"PageLocaleWithoutLinkCreateInput"
	},
	LinkableUpdateRedirectEntityRelationInput:{
		create:"RedirectWithoutLinkCreateInput",
		update:"RedirectWithoutLinkUpdateInput",
		upsert:"LinkableUpsertRedirectRelationInput",
		connect:"RedirectUniqueWhere"
	},
	RedirectWithoutLinkUpdateInput:{
		target:"RedirectUpdateTargetEntityRelationInput"
	},
	RedirectUpdateTargetEntityRelationInput:{
		create:"LinkCreateInput",
		update:"LinkUpdateInput",
		upsert:"RedirectUpsertTargetRelationInput",
		connect:"LinkUniqueWhere"
	},
	RedirectUpsertTargetRelationInput:{
		update:"LinkUpdateInput",
		create:"LinkCreateInput"
	},
	LinkableUpsertRedirectRelationInput:{
		update:"RedirectWithoutLinkUpdateInput",
		create:"RedirectWithoutLinkCreateInput"
	},
	WikiPageUpsertLinkRelationInput:{
		update:"LinkableWithoutWikiPageUpdateInput",
		create:"LinkableWithoutWikiPageCreateInput"
	},
	WikiPageUpdateContentEntityRelationInput:{
		create:"ContentCreateInput",
		update:"ContentUpdateInput",
		upsert:"WikiPageUpsertContentRelationInput",
		connect:"ContentUniqueWhere"
	},
	WikiPageUpsertContentRelationInput:{
		update:"ContentUpdateInput",
		create:"ContentCreateInput"
	},
	WikiPageUpsertParentRelationInput:{
		update:"WikiPageWithoutChildrenUpdateInput",
		create:"WikiPageWithoutChildrenCreateInput"
	},
	WikiPageUpdateChildrenEntityRelationInput:{
		create:"WikiPageWithoutParentCreateInput",
		update:"WikiPageUpdateChildrenRelationInput",
		upsert:"WikiPageUpsertChildrenRelationInput",
		connect:"WikiPageUniqueWhere",
		disconnect:"WikiPageUniqueWhere",
		delete:"WikiPageUniqueWhere"
	},
	WikiPageUpdateChildrenRelationInput:{
		by:"WikiPageUniqueWhere",
		data:"WikiPageWithoutParentUpdateInput"
	},
	WikiPageWithoutParentUpdateInput:{
		link:"WikiPageUpdateLinkEntityRelationInput",
		children:"WikiPageUpdateChildrenEntityRelationInput",
		content:"WikiPageUpdateContentEntityRelationInput"
	},
	WikiPageUpsertChildrenRelationInput:{
		by:"WikiPageUniqueWhere",
		update:"WikiPageWithoutParentUpdateInput",
		create:"WikiPageWithoutParentCreateInput"
	},
	LinkableUpsertWikiPageRelationInput:{
		update:"WikiPageWithoutLinkUpdateInput",
		create:"WikiPageWithoutLinkCreateInput"
	},
	PageLocaleUpsertLinkRelationInput:{
		update:"LinkableWithoutPageUpdateInput",
		create:"LinkableWithoutPageCreateInput"
	},
	LocaleUpsertPagesRelationInput:{
		by:"PageLocaleUniqueWhere",
		update:"PageLocaleWithoutLocaleUpdateInput",
		create:"PageLocaleWithoutLocaleCreateInput"
	},
	BlogPostLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutBlogPostsUpdateInput",
		create:"LocaleWithoutBlogPostsCreateInput"
	},
	BlogPostLocaleUpdateSeoEntityRelationInput:{
		create:"SeoCreateInput",
		update:"SeoUpdateInput",
		upsert:"BlogPostLocaleUpsertSeoRelationInput",
		connect:"SeoUniqueWhere"
	},
	BlogPostLocaleUpsertSeoRelationInput:{
		update:"SeoUpdateInput",
		create:"SeoCreateInput"
	},
	BlogPostLocaleUpdateProductsEntityRelationInput:{
		create:"ProductCreateInput",
		update:"BlogPostLocaleUpdateProductsRelationInput",
		upsert:"BlogPostLocaleUpsertProductsRelationInput",
		connect:"ProductUniqueWhere",
		disconnect:"ProductUniqueWhere",
		delete:"ProductUniqueWhere"
	},
	BlogPostLocaleUpdateProductsRelationInput:{
		by:"ProductUniqueWhere",
		data:"ProductUpdateInput"
	},
	BlogPostLocaleUpsertProductsRelationInput:{
		by:"ProductUniqueWhere",
		update:"ProductUpdateInput",
		create:"ProductCreateInput"
	},
	LinkableUpsertBlogPostRelationInput:{
		update:"BlogPostLocaleWithoutLinkUpdateInput",
		create:"BlogPostLocaleWithoutLinkCreateInput"
	},
	LinkUpsertInternalLinkRelationInput:{
		update:"LinkableUpdateInput",
		create:"LinkableCreateInput"
	},
	ContentReferenceUpsertLinkRelationInput:{
		update:"LinkUpdateInput",
		create:"LinkCreateInput"
	},
	ContentReferenceUpdateBlogPostsEntityRelationInput:{
		create:"BlogPostListCreateInput",
		update:"BlogPostListUpdateInput",
		upsert:"ContentReferenceUpsertBlogPostsRelationInput",
		connect:"BlogPostListUniqueWhere"
	},
	BlogPostListUpdateInput:{
		items:"BlogPostListUpdateItemsEntityRelationInput"
	},
	BlogPostListUpdateItemsEntityRelationInput:{
		create:"BlogPostListItemWithoutListCreateInput",
		update:"BlogPostListUpdateItemsRelationInput",
		upsert:"BlogPostListUpsertItemsRelationInput",
		connect:"BlogPostListItemUniqueWhere",
		disconnect:"BlogPostListItemUniqueWhere",
		delete:"BlogPostListItemUniqueWhere"
	},
	BlogPostListUpdateItemsRelationInput:{
		by:"BlogPostListItemUniqueWhere",
		data:"BlogPostListItemWithoutListUpdateInput"
	},
	BlogPostListItemWithoutListUpdateInput:{
		blogPost:"BlogPostListItemUpdateBlogPostEntityRelationInput"
	},
	BlogPostListItemUpdateBlogPostEntityRelationInput:{
		create:"BlogPostLocaleCreateInput",
		update:"BlogPostLocaleUpdateInput",
		upsert:"BlogPostListItemUpsertBlogPostRelationInput",
		connect:"BlogPostLocaleUniqueWhere"
	},
	BlogPostLocaleUpdateInput:{
		root:"BlogPostLocaleUpdateRootEntityRelationInput",
		locale:"BlogPostLocaleUpdateLocaleEntityRelationInput",
		cover:"BlogPostLocaleUpdateCoverEntityRelationInput",
		content:"BlogPostLocaleUpdateContentEntityRelationInput",
		link:"BlogPostLocaleUpdateLinkEntityRelationInput",
		seo:"BlogPostLocaleUpdateSeoEntityRelationInput",
		products:"BlogPostLocaleUpdateProductsEntityRelationInput"
	},
	BlogPostLocaleUpdateLinkEntityRelationInput:{
		create:"LinkableWithoutBlogPostCreateInput",
		update:"LinkableWithoutBlogPostUpdateInput",
		upsert:"BlogPostLocaleUpsertLinkRelationInput",
		connect:"LinkableUniqueWhere"
	},
	LinkableWithoutBlogPostUpdateInput:{
		page:"LinkableUpdatePageEntityRelationInput",
		wikiPage:"LinkableUpdateWikiPageEntityRelationInput",
		redirect:"LinkableUpdateRedirectEntityRelationInput"
	},
	BlogPostLocaleUpsertLinkRelationInput:{
		update:"LinkableWithoutBlogPostUpdateInput",
		create:"LinkableWithoutBlogPostCreateInput"
	},
	BlogPostListItemUpsertBlogPostRelationInput:{
		update:"BlogPostLocaleUpdateInput",
		create:"BlogPostLocaleCreateInput"
	},
	BlogPostListUpsertItemsRelationInput:{
		by:"BlogPostListItemUniqueWhere",
		update:"BlogPostListItemWithoutListUpdateInput",
		create:"BlogPostListItemWithoutListCreateInput"
	},
	ContentReferenceUpsertBlogPostsRelationInput:{
		update:"BlogPostListUpdateInput",
		create:"BlogPostListCreateInput"
	},
	ContentReferenceUpdateLinksEntityRelationInput:{
		create:"LinkListCreateInput",
		update:"LinkListUpdateInput",
		upsert:"ContentReferenceUpsertLinksRelationInput",
		connect:"LinkListUniqueWhere"
	},
	ContentReferenceUpsertLinksRelationInput:{
		update:"LinkListUpdateInput",
		create:"LinkListCreateInput"
	},
	ContentReferenceUpdateProductsEntityRelationInput:{
		create:"ProductListCreateInput",
		update:"ProductListUpdateInput",
		upsert:"ContentReferenceUpsertProductsRelationInput",
		connect:"ProductListUniqueWhere"
	},
	ProductListUpdateInput:{
		items:"ProductListUpdateItemsEntityRelationInput",
		businessCategory:"ProductListUpdateBusinessCategoryEntityRelationInput"
	},
	ProductListUpdateBusinessCategoryEntityRelationInput:{
		create:"BusinessCategoryWithoutSpecificProductsCreateInput",
		update:"BusinessCategoryWithoutSpecificProductsUpdateInput",
		upsert:"ProductListUpsertBusinessCategoryRelationInput",
		connect:"BusinessCategoryUniqueWhere"
	},
	BusinessCategoryWithoutSpecificProductsUpdateInput:{
		locales:"BusinessCategoryUpdateLocalesEntityRelationInput",
		businessCustomers:"BusinessCategoryUpdateBusinessCustomersEntityRelationInput",
		recurrences:"BusinessCategoryUpdateRecurrencesEntityRelationInput",
		seasonalProductCategories:"BusinessCategoryUpdateSeasonalProductCategoriesEntityRelationInput",
		specificProductsProductCategories:"BusinessCategoryUpdateSpecificProductsProductCategoriesEntityRelationInput"
	},
	ProductListUpsertBusinessCategoryRelationInput:{
		update:"BusinessCategoryWithoutSpecificProductsUpdateInput",
		create:"BusinessCategoryWithoutSpecificProductsCreateInput"
	},
	ContentReferenceUpsertProductsRelationInput:{
		update:"ProductListUpdateInput",
		create:"ProductListCreateInput"
	},
	ContentReferenceUpdateHeroEntityRelationInput:{
		create:"HeroCreateInput",
		update:"HeroUpdateInput",
		upsert:"ContentReferenceUpsertHeroRelationInput",
		connect:"HeroUniqueWhere"
	},
	HeroUpdateInput:{
		medium:"HeroUpdateMediumEntityRelationInput"
	},
	HeroUpdateMediumEntityRelationInput:{
		create:"MediumCreateInput",
		update:"MediumUpdateInput",
		upsert:"HeroUpsertMediumRelationInput",
		connect:"MediumUniqueWhere"
	},
	HeroUpsertMediumRelationInput:{
		update:"MediumUpdateInput",
		create:"MediumCreateInput"
	},
	ContentReferenceUpsertHeroRelationInput:{
		update:"HeroUpdateInput",
		create:"HeroCreateInput"
	},
	ContentReferenceUpdateGalleryEntityRelationInput:{
		create:"GalleryCreateInput",
		update:"GalleryUpdateInput",
		upsert:"ContentReferenceUpsertGalleryRelationInput",
		connect:"GalleryUniqueWhere"
	},
	GalleryUpdateInput:{
		items:"GalleryUpdateItemsEntityRelationInput"
	},
	GalleryUpdateItemsEntityRelationInput:{
		create:"GalleryItemWithoutListCreateInput",
		update:"GalleryUpdateItemsRelationInput",
		upsert:"GalleryUpsertItemsRelationInput",
		connect:"GalleryItemUniqueWhere",
		disconnect:"GalleryItemUniqueWhere",
		delete:"GalleryItemUniqueWhere"
	},
	GalleryUpdateItemsRelationInput:{
		by:"GalleryItemUniqueWhere",
		data:"GalleryItemWithoutListUpdateInput"
	},
	GalleryItemWithoutListUpdateInput:{
		medium:"GalleryItemUpdateMediumEntityRelationInput"
	},
	GalleryItemUpdateMediumEntityRelationInput:{
		create:"MediumCreateInput",
		update:"MediumUpdateInput",
		upsert:"GalleryItemUpsertMediumRelationInput",
		connect:"MediumUniqueWhere"
	},
	GalleryItemUpsertMediumRelationInput:{
		update:"MediumUpdateInput",
		create:"MediumCreateInput"
	},
	GalleryUpsertItemsRelationInput:{
		by:"GalleryItemUniqueWhere",
		update:"GalleryItemWithoutListUpdateInput",
		create:"GalleryItemWithoutListCreateInput"
	},
	ContentReferenceUpsertGalleryRelationInput:{
		update:"GalleryUpdateInput",
		create:"GalleryCreateInput"
	},
	ContentReferenceUpdateSocialsAndAppsEntityRelationInput:{
		create:"SocialsAndAppsCreateInput",
		update:"SocialsAndAppsUpdateInput",
		upsert:"ContentReferenceUpsertSocialsAndAppsRelationInput",
		connect:"SocialsAndAppsUniqueWhere"
	},
	ContentReferenceUpsertSocialsAndAppsRelationInput:{
		update:"SocialsAndAppsUpdateInput",
		create:"SocialsAndAppsCreateInput"
	},
	ContentReferenceUpdateProductGridEntityRelationInput:{
		create:"ProductGridCreateInput",
		update:"ProductGridUpdateInput",
		upsert:"ContentReferenceUpsertProductGridRelationInput",
		connect:"ProductGridUniqueWhere"
	},
	ProductGridUpdateInput:{
		categories:"ProductGridUpdateCategoriesEntityRelationInput",
		type:"ProductGridType"
	},
	ProductGridUpdateCategoriesEntityRelationInput:{
		create:"ProductGridCategoryWithoutRootCreateInput",
		update:"ProductGridUpdateCategoriesRelationInput",
		upsert:"ProductGridUpsertCategoriesRelationInput",
		connect:"ProductGridCategoryUniqueWhere",
		disconnect:"ProductGridCategoryUniqueWhere",
		delete:"ProductGridCategoryUniqueWhere"
	},
	ProductGridUpdateCategoriesRelationInput:{
		by:"ProductGridCategoryUniqueWhere",
		data:"ProductGridCategoryWithoutRootUpdateInput"
	},
	ProductGridCategoryWithoutRootUpdateInput:{
		items:"ProductGridCategoryUpdateItemsEntityRelationInput",
		images:"ProductGridCategoryUpdateImagesEntityRelationInput"
	},
	ProductGridCategoryUpdateItemsEntityRelationInput:{
		create:"ProductGridItemWithoutCategoryCreateInput",
		update:"ProductGridCategoryUpdateItemsRelationInput",
		upsert:"ProductGridCategoryUpsertItemsRelationInput",
		connect:"ProductGridItemUniqueWhere",
		disconnect:"ProductGridItemUniqueWhere",
		delete:"ProductGridItemUniqueWhere"
	},
	ProductGridCategoryUpdateItemsRelationInput:{
		by:"ProductGridItemUniqueWhere",
		data:"ProductGridItemWithoutCategoryUpdateInput"
	},
	ProductGridItemWithoutCategoryUpdateInput:{
		product:"ProductGridItemUpdateProductEntityRelationInput",
		medium:"ProductGridItemUpdateMediumEntityRelationInput",
		link:"ProductGridItemUpdateLinkEntityRelationInput"
	},
	ProductGridItemUpdateProductEntityRelationInput:{
		create:"ProductCreateInput",
		update:"ProductUpdateInput",
		upsert:"ProductGridItemUpsertProductRelationInput",
		connect:"ProductUniqueWhere"
	},
	ProductGridItemUpsertProductRelationInput:{
		update:"ProductUpdateInput",
		create:"ProductCreateInput"
	},
	ProductGridItemUpdateMediumEntityRelationInput:{
		create:"MediumCreateInput",
		update:"MediumUpdateInput",
		upsert:"ProductGridItemUpsertMediumRelationInput",
		connect:"MediumUniqueWhere"
	},
	ProductGridItemUpsertMediumRelationInput:{
		update:"MediumUpdateInput",
		create:"MediumCreateInput"
	},
	ProductGridItemUpdateLinkEntityRelationInput:{
		create:"LinkCreateInput",
		update:"LinkUpdateInput",
		upsert:"ProductGridItemUpsertLinkRelationInput",
		connect:"LinkUniqueWhere"
	},
	ProductGridItemUpsertLinkRelationInput:{
		update:"LinkUpdateInput",
		create:"LinkCreateInput"
	},
	ProductGridCategoryUpsertItemsRelationInput:{
		by:"ProductGridItemUniqueWhere",
		update:"ProductGridItemWithoutCategoryUpdateInput",
		create:"ProductGridItemWithoutCategoryCreateInput"
	},
	ProductGridCategoryUpdateImagesEntityRelationInput:{
		create:"ImageListCreateInput",
		update:"ImageListUpdateInput",
		upsert:"ProductGridCategoryUpsertImagesRelationInput",
		connect:"ImageListUniqueWhere"
	},
	ProductGridCategoryUpsertImagesRelationInput:{
		update:"ImageListUpdateInput",
		create:"ImageListCreateInput"
	},
	ProductGridUpsertCategoriesRelationInput:{
		by:"ProductGridCategoryUniqueWhere",
		update:"ProductGridCategoryWithoutRootUpdateInput",
		create:"ProductGridCategoryWithoutRootCreateInput"
	},
	ContentReferenceUpsertProductGridRelationInput:{
		update:"ProductGridUpdateInput",
		create:"ProductGridCreateInput"
	},
	ContentReferenceUpdateProductBannersEntityRelationInput:{
		create:"ProductBannerListCreateInput",
		update:"ProductBannerListUpdateInput",
		upsert:"ContentReferenceUpsertProductBannersRelationInput",
		connect:"ProductBannerListUniqueWhere"
	},
	ProductBannerListUpdateInput:{
		items:"ProductBannerListUpdateItemsEntityRelationInput"
	},
	ProductBannerListUpdateItemsEntityRelationInput:{
		create:"ProductBannerItemWithoutListCreateInput",
		update:"ProductBannerListUpdateItemsRelationInput",
		upsert:"ProductBannerListUpsertItemsRelationInput",
		connect:"ProductBannerItemUniqueWhere",
		disconnect:"ProductBannerItemUniqueWhere",
		delete:"ProductBannerItemUniqueWhere"
	},
	ProductBannerListUpdateItemsRelationInput:{
		by:"ProductBannerItemUniqueWhere",
		data:"ProductBannerItemWithoutListUpdateInput"
	},
	ProductBannerItemWithoutListUpdateInput:{
		banner:"ProductBannerItemUpdateBannerEntityRelationInput",
		size:"ProductBannerItemSize"
	},
	ProductBannerItemUpdateBannerEntityRelationInput:{
		create:"ProductBannerCreateInput",
		update:"ProductBannerUpdateInput",
		upsert:"ProductBannerItemUpsertBannerRelationInput",
		connect:"ProductBannerUniqueWhere"
	},
	ProductBannerUpdateInput:{
		button:"ProductBannerUpdateButtonEntityRelationInput",
		backgroundImage:"ProductBannerUpdateBackgroundImageEntityRelationInput",
		productImage:"ProductBannerUpdateProductImageEntityRelationInput",
		product:"ProductBannerUpdateProductEntityRelationInput"
	},
	ProductBannerUpdateButtonEntityRelationInput:{
		create:"LinkCreateInput",
		update:"LinkUpdateInput",
		upsert:"ProductBannerUpsertButtonRelationInput",
		connect:"LinkUniqueWhere"
	},
	ProductBannerUpsertButtonRelationInput:{
		update:"LinkUpdateInput",
		create:"LinkCreateInput"
	},
	ProductBannerUpdateBackgroundImageEntityRelationInput:{
		create:"ImageCreateInput",
		update:"ImageUpdateInput",
		upsert:"ProductBannerUpsertBackgroundImageRelationInput",
		connect:"ImageUniqueWhere"
	},
	ProductBannerUpsertBackgroundImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	ProductBannerUpdateProductImageEntityRelationInput:{
		create:"ImageCreateInput",
		update:"ImageUpdateInput",
		upsert:"ProductBannerUpsertProductImageRelationInput",
		connect:"ImageUniqueWhere"
	},
	ProductBannerUpsertProductImageRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	ProductBannerUpdateProductEntityRelationInput:{
		create:"ProductCreateInput",
		update:"ProductUpdateInput",
		upsert:"ProductBannerUpsertProductRelationInput",
		connect:"ProductUniqueWhere"
	},
	ProductBannerUpsertProductRelationInput:{
		update:"ProductUpdateInput",
		create:"ProductCreateInput"
	},
	ProductBannerItemUpsertBannerRelationInput:{
		update:"ProductBannerUpdateInput",
		create:"ProductBannerCreateInput"
	},
	ProductBannerListUpsertItemsRelationInput:{
		by:"ProductBannerItemUniqueWhere",
		update:"ProductBannerItemWithoutListUpdateInput",
		create:"ProductBannerItemWithoutListCreateInput"
	},
	ContentReferenceUpsertProductBannersRelationInput:{
		update:"ProductBannerListUpdateInput",
		create:"ProductBannerListCreateInput"
	},
	ContentReferenceUpdateDeliveryRegionsEntityRelationInput:{
		create:"DeliveryRegionsCreateInput",
		update:"DeliveryRegionsUpdateInput",
		upsert:"ContentReferenceUpsertDeliveryRegionsRelationInput",
		connect:"DeliveryRegionsUniqueWhere"
	},
	ContentReferenceUpsertDeliveryRegionsRelationInput:{
		update:"DeliveryRegionsUpdateInput",
		create:"DeliveryRegionsCreateInput"
	},
	ContentReferenceUpdateTextListEntityRelationInput:{
		create:"TextListCreateInput",
		update:"TextListUpdateInput",
		upsert:"ContentReferenceUpsertTextListRelationInput",
		connect:"TextListUniqueWhere"
	},
	ContentReferenceUpsertTextListRelationInput:{
		update:"TextListUpdateInput",
		create:"TextListCreateInput"
	},
	ContentReferenceUpdateGridTilesEntityRelationInput:{
		create:"GridTilesCreateInput",
		update:"GridTilesUpdateInput",
		upsert:"ContentReferenceUpsertGridTilesRelationInput",
		connect:"GridTilesUniqueWhere"
	},
	GridTilesUpdateInput:{
		items:"GridTilesUpdateItemsEntityRelationInput"
	},
	GridTilesUpdateItemsEntityRelationInput:{
		create:"GridTileItemWithoutListCreateInput",
		update:"GridTilesUpdateItemsRelationInput",
		upsert:"GridTilesUpsertItemsRelationInput",
		connect:"GridTileItemUniqueWhere",
		disconnect:"GridTileItemUniqueWhere",
		delete:"GridTileItemUniqueWhere"
	},
	GridTilesUpdateItemsRelationInput:{
		by:"GridTileItemUniqueWhere",
		data:"GridTileItemWithoutListUpdateInput"
	},
	GridTileItemWithoutListUpdateInput:{
		medium:"GridTileItemUpdateMediumEntityRelationInput",
		link:"GridTileItemUpdateLinkEntityRelationInput"
	},
	GridTileItemUpdateMediumEntityRelationInput:{
		create:"MediumCreateInput",
		update:"MediumUpdateInput",
		upsert:"GridTileItemUpsertMediumRelationInput",
		connect:"MediumUniqueWhere"
	},
	GridTileItemUpsertMediumRelationInput:{
		update:"MediumUpdateInput",
		create:"MediumCreateInput"
	},
	GridTileItemUpdateLinkEntityRelationInput:{
		create:"LinkCreateInput",
		update:"LinkUpdateInput",
		upsert:"GridTileItemUpsertLinkRelationInput",
		connect:"LinkUniqueWhere"
	},
	GridTileItemUpsertLinkRelationInput:{
		update:"LinkUpdateInput",
		create:"LinkCreateInput"
	},
	GridTilesUpsertItemsRelationInput:{
		by:"GridTileItemUniqueWhere",
		update:"GridTileItemWithoutListUpdateInput",
		create:"GridTileItemWithoutListCreateInput"
	},
	ContentReferenceUpsertGridTilesRelationInput:{
		update:"GridTilesUpdateInput",
		create:"GridTilesCreateInput"
	},
	ContentBlockUpsertReferencesRelationInput:{
		by:"ContentReferenceUniqueWhere",
		update:"ContentReferenceWithoutBlockUpdateInput",
		create:"ContentReferenceWithoutBlockCreateInput"
	},
	ContentUpsertBlocksRelationInput:{
		by:"ContentBlockUniqueWhere",
		update:"ContentBlockWithoutContentUpdateInput",
		create:"ContentBlockWithoutContentCreateInput"
	},
	BlogPostLocaleUpsertContentRelationInput:{
		update:"ContentUpdateInput",
		create:"ContentCreateInput"
	},
	LocaleUpsertBlogPostsRelationInput:{
		by:"BlogPostLocaleUniqueWhere",
		update:"BlogPostLocaleWithoutLocaleUpdateInput",
		create:"BlogPostLocaleWithoutLocaleCreateInput"
	},
	BusinessCategoryLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutBusinessCategoriesUpdateInput",
		create:"LocaleWithoutBusinessCategoriesCreateInput"
	},
	BusinessCategoryUpsertLocalesRelationInput:{
		by:"BusinessCategoryLocaleUniqueWhere",
		update:"BusinessCategoryLocaleWithoutRootUpdateInput",
		create:"BusinessCategoryLocaleWithoutRootCreateInput"
	},
	OrderRecurrenceUpsertBusinessCategoryRelationInput:{
		by:"BusinessCategoryUniqueWhere",
		update:"BusinessCategoryWithoutRecurrencesUpdateInput",
		create:"BusinessCategoryWithoutRecurrencesCreateInput"
	},
	OrderRecurrenceLocaleUpsertRootRelationInput:{
		update:"OrderRecurrenceWithoutLocalesUpdateInput",
		create:"OrderRecurrenceWithoutLocalesCreateInput"
	},
	LocaleUpsertOrderRecurrencesRelationInput:{
		by:"OrderRecurrenceLocaleUniqueWhere",
		update:"OrderRecurrenceLocaleWithoutLocaleUpdateInput",
		create:"OrderRecurrenceLocaleWithoutLocaleCreateInput"
	},
	AllergenLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutAllergensUpdateInput",
		create:"LocaleWithoutAllergensCreateInput"
	},
	AllergenUpsertLocalesRelationInput:{
		by:"AllergenLocaleUniqueWhere",
		update:"AllergenLocaleWithoutRootUpdateInput",
		create:"AllergenLocaleWithoutRootCreateInput"
	},
	ProductIngredientUpsertAllergensRelationInput:{
		by:"AllergenUniqueWhere",
		update:"AllergenWithoutIngredientsUpdateInput",
		create:"AllergenWithoutIngredientsCreateInput"
	},
	ProductIngredientLocaleUpsertRootRelationInput:{
		update:"ProductIngredientWithoutLocalesUpdateInput",
		create:"ProductIngredientWithoutLocalesCreateInput"
	},
	LocaleUpsertProductIngredientsRelationInput:{
		by:"ProductIngredientLocaleUniqueWhere",
		update:"ProductIngredientLocaleWithoutLocaleUpdateInput",
		create:"ProductIngredientLocaleWithoutLocaleCreateInput"
	},
	ProductIngredientCategoryLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutProductIngredientCategoriesUpdateInput",
		create:"LocaleWithoutProductIngredientCategoriesCreateInput"
	},
	ProductIngredientCategoryUpsertLocalesRelationInput:{
		by:"ProductIngredientCategoryLocaleUniqueWhere",
		update:"ProductIngredientCategoryLocaleWithoutRootUpdateInput",
		create:"ProductIngredientCategoryLocaleWithoutRootCreateInput"
	},
	ProductIngredientUpsertCategoriesRelationInput:{
		by:"ProductIngredientCategoryUniqueWhere",
		update:"ProductIngredientCategoryWithoutIngredientsUpdateInput",
		create:"ProductIngredientCategoryWithoutIngredientsCreateInput"
	},
	CustomerIngredientRatingUpsertIngredientRelationInput:{
		update:"ProductIngredientWithoutCustomerRatingsUpdateInput",
		create:"ProductIngredientWithoutCustomerRatingsCreateInput"
	},
	CustomerUpsertIngredientRatingsRelationInput:{
		by:"CustomerIngredientRatingUniqueWhere",
		update:"CustomerIngredientRatingWithoutCustomerUpdateInput",
		create:"CustomerIngredientRatingWithoutCustomerCreateInput"
	},
	CustomerGroupUpsertCustomersRelationInput:{
		by:"CustomerUniqueWhere",
		update:"CustomerWithoutGroupUpdateInput",
		create:"CustomerWithoutGroupCreateInput"
	},
	ProductGroupPriceUpsertGroupRelationInput:{
		update:"CustomerGroupWithoutProductPricesUpdateInput",
		create:"CustomerGroupWithoutProductPricesCreateInput"
	},
	ProductUpsertGroupPricesRelationInput:{
		by:"ProductGroupPriceUniqueWhere",
		update:"ProductGroupPriceWithoutProductUpdateInput",
		create:"ProductGroupPriceWithoutProductCreateInput"
	},
	DeliveryZoneUpsertDeliveryZonesOfProductsRelationInput:{
		by:"ProductUniqueWhere",
		update:"ProductWithoutDeliveryZonesUpdateInput",
		create:"ProductWithoutDeliveryZonesCreateInput"
	},
	TagUpsertDeliveryZonesRelationInput:{
		by:"DeliveryZoneUniqueWhere",
		update:"DeliveryZoneWithoutDeliveryZonesOfTagsUpdateInput",
		create:"DeliveryZoneWithoutDeliveryZonesOfTagsCreateInput"
	},
	ChannelUpsertAddTagsOnRegistrationRelationInput:{
		by:"TagUniqueWhere",
		update:"TagWithoutAddTagsOnRegistrationUpdateInput",
		create:"TagWithoutAddTagsOnRegistrationCreateInput"
	},
	CartUpsertChannelRelationInput:{
		update:"ChannelWithoutCartsUpdateInput",
		create:"ChannelWithoutCartsCreateInput"
	},
	CartItemUpsertCartRelationInput:{
		update:"CartWithoutItemsUpdateInput",
		create:"CartWithoutItemsCreateInput"
	},
	CartItemUpdateFulfillmentNotesEntityRelationInput:{
		create:"FulfillmentNoteWithoutCartItemsCreateInput",
		update:"CartItemUpdateFulfillmentNotesRelationInput",
		upsert:"CartItemUpsertFulfillmentNotesRelationInput",
		connect:"FulfillmentNoteUniqueWhere",
		disconnect:"FulfillmentNoteUniqueWhere",
		delete:"FulfillmentNoteUniqueWhere"
	},
	CartItemUpdateFulfillmentNotesRelationInput:{
		by:"FulfillmentNoteUniqueWhere",
		data:"FulfillmentNoteWithoutCartItemsUpdateInput"
	},
	FulfillmentNoteWithoutCartItemsUpdateInput:{
		products:"FulfillmentNoteUpdateProductsEntityRelationInput",
		tags:"FulfillmentNoteUpdateTagsEntityRelationInput",
		venues:"FulfillmentNoteUpdateVenuesEntityRelationInput",
		orderItems:"FulfillmentNoteUpdateOrderItemsEntityRelationInput",
		orders:"FulfillmentNoteUpdateOrdersEntityRelationInput",
		createdAt:"DateTime"
	},
	CartItemUpsertFulfillmentNotesRelationInput:{
		by:"FulfillmentNoteUniqueWhere",
		update:"FulfillmentNoteWithoutCartItemsUpdateInput",
		create:"FulfillmentNoteWithoutCartItemsCreateInput"
	},
	ProductUpsertCartItemsRelationInput:{
		by:"CartItemUniqueWhere",
		update:"CartItemWithoutProductUpdateInput",
		create:"CartItemWithoutProductCreateInput"
	},
	ProductGroupPriceUpsertProductRelationInput:{
		update:"ProductWithoutGroupPricesUpdateInput",
		create:"ProductWithoutGroupPricesCreateInput"
	},
	CustomerGroupUpsertProductPricesRelationInput:{
		by:"ProductGroupPriceUniqueWhere",
		update:"ProductGroupPriceWithoutGroupUpdateInput",
		create:"ProductGroupPriceWithoutGroupCreateInput"
	},
	CustomerUpsertGroupRelationInput:{
		update:"CustomerGroupWithoutCustomersUpdateInput",
		create:"CustomerGroupWithoutCustomersCreateInput"
	},
	ChannelUpsertCustomersRelationInput:{
		by:"CustomerUniqueWhere",
		update:"CustomerWithoutChannelsUpdateInput",
		create:"CustomerWithoutChannelsCreateInput"
	},
	TagUpsertAddTagsOnRegistrationRelationInput:{
		by:"ChannelUniqueWhere",
		update:"ChannelWithoutAddTagsOnRegistrationUpdateInput",
		create:"ChannelWithoutAddTagsOnRegistrationCreateInput"
	},
	ProductCategoryUpsertTagsRelationInput:{
		by:"TagUniqueWhere",
		update:"TagWithoutCategoriesUpdateInput",
		create:"TagWithoutCategoriesCreateInput"
	},
	ProductCategoryUpsertParentRelationInput:{
		update:"ProductCategoryWithoutChildrenUpdateInput",
		create:"ProductCategoryWithoutChildrenCreateInput"
	},
	TagUpsertCategoriesRelationInput:{
		by:"ProductCategoryUniqueWhere",
		update:"ProductCategoryWithoutTagsUpdateInput",
		create:"ProductCategoryWithoutTagsCreateInput"
	},
	ProductUpsertTagsRelationInput:{
		by:"TagUniqueWhere",
		update:"TagWithoutProductsUpdateInput",
		create:"TagWithoutProductsCreateInput"
	},
	ProductCategoryUpsertProductsRelationInput:{
		by:"ProductUniqueWhere",
		update:"ProductWithoutCategoriesUpdateInput",
		create:"ProductWithoutCategoriesCreateInput"
	},
	ProductCategoryListItemUpsertProductCategoryRelationInput:{
		update:"ProductCategoryUpdateInput",
		create:"ProductCategoryCreateInput"
	},
	ProductCategoryListUpsertItemsRelationInput:{
		by:"ProductCategoryListItemUniqueWhere",
		update:"ProductCategoryListItemWithoutListUpdateInput",
		create:"ProductCategoryListItemWithoutListCreateInput"
	},
	ProductCategoryListLocaleUpsertRootRelationInput:{
		update:"ProductCategoryListWithoutLocalesUpdateInput",
		create:"ProductCategoryListWithoutLocalesCreateInput"
	},
	LocaleUpsertProductCategoryListsRelationInput:{
		by:"ProductCategoryListLocaleUniqueWhere",
		update:"ProductCategoryListLocaleWithoutLocaleUpdateInput",
		create:"ProductCategoryListLocaleWithoutLocaleCreateInput"
	},
	ProductIngredientLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutProductIngredientsUpdateInput",
		create:"LocaleWithoutProductIngredientsCreateInput"
	},
	ProductIngredientUpsertLocalesRelationInput:{
		by:"ProductIngredientLocaleUniqueWhere",
		update:"ProductIngredientLocaleWithoutRootUpdateInput",
		create:"ProductIngredientLocaleWithoutRootCreateInput"
	},
	ProductIngredientItemUpsertIngredientRelationInput:{
		update:"ProductIngredientUpdateInput",
		create:"ProductIngredientCreateInput"
	},
	ProductIngredientItemUpdateQuantityEntityRelationInput:{
		create:"ProductIngredientItemQuantityCreateInput",
		update:"ProductIngredientItemQuantityUpdateInput",
		upsert:"ProductIngredientItemUpsertQuantityRelationInput",
		connect:"ProductIngredientItemQuantityUniqueWhere"
	},
	ProductIngredientItemQuantityUpdateInput:{
		unit:"ProductIngredientItemQuantityUpdateUnitEntityRelationInput"
	},
	ProductIngredientItemQuantityUpdateUnitEntityRelationInput:{
		create:"ProductIngredientItemQuantityUnitCreateInput",
		update:"ProductIngredientItemQuantityUnitUpdateInput",
		upsert:"ProductIngredientItemQuantityUpsertUnitRelationInput",
		connect:"ProductIngredientItemQuantityUnitUniqueWhere"
	},
	ProductIngredientItemQuantityUpsertUnitRelationInput:{
		update:"ProductIngredientItemQuantityUnitUpdateInput",
		create:"ProductIngredientItemQuantityUnitCreateInput"
	},
	ProductIngredientItemUpsertQuantityRelationInput:{
		update:"ProductIngredientItemQuantityUpdateInput",
		create:"ProductIngredientItemQuantityCreateInput"
	},
	ProductRecipeUpsertIngredientsRelationInput:{
		by:"ProductIngredientItemUniqueWhere",
		update:"ProductIngredientItemWithoutRecipeUpdateInput",
		create:"ProductIngredientItemWithoutRecipeCreateInput"
	},
	ProductUpsertRecipeRelationInput:{
		update:"ProductRecipeWithoutProductsUpdateInput",
		create:"ProductRecipeWithoutProductsCreateInput"
	},
	CartItemUpsertProductRelationInput:{
		update:"ProductWithoutCartItemsUpdateInput",
		create:"ProductWithoutCartItemsCreateInput"
	},
	CartUpsertItemsRelationInput:{
		by:"CartItemUniqueWhere",
		update:"CartItemWithoutCartUpdateInput",
		create:"CartItemWithoutCartCreateInput"
	},
	ChannelUpsertCartsRelationInput:{
		by:"CartUniqueWhere",
		update:"CartWithoutChannelUpdateInput",
		create:"CartWithoutChannelCreateInput"
	},
	OrderUpsertChannelRelationInput:{
		update:"ChannelUpdateInput",
		create:"ChannelCreateInput"
	},
	CustomerUpsertOrdersRelationInput:{
		by:"OrderUniqueWhere",
		update:"OrderWithoutCustomerUpdateInput",
		create:"OrderWithoutCustomerCreateInput"
	},
	TagUpsertCustomersRelationInput:{
		by:"CustomerUniqueWhere",
		update:"CustomerWithoutTagsUpdateInput",
		create:"CustomerWithoutTagsCreateInput"
	},
	ChannelPaymentUpsertAllowOnlyForTagsRelationInput:{
		by:"TagUniqueWhere",
		update:"TagWithoutAllowChannelPaymentsUpdateInput",
		create:"TagWithoutAllowChannelPaymentsCreateInput"
	},
	VatRateUpsertChannelPaymentsRelationInput:{
		by:"ChannelPaymentUniqueWhere",
		update:"ChannelPaymentWithoutVatRateUpdateInput",
		create:"ChannelPaymentWithoutVatRateCreateInput"
	},
	ChannelDeliveryUpsertVatRateRelationInput:{
		update:"VatRateWithoutChannelDeliveriesUpdateInput",
		create:"VatRateWithoutChannelDeliveriesCreateInput"
	},
	DeliveryMethodUpsertChannelsRelationInput:{
		by:"ChannelDeliveryUniqueWhere",
		update:"ChannelDeliveryWithoutMethodUpdateInput",
		create:"ChannelDeliveryWithoutMethodCreateInput"
	},
	PaymentMethodUpsertDeliveryMethodsRelationInput:{
		by:"DeliveryMethodUniqueWhere",
		update:"DeliveryMethodWithoutPaymentMethodsUpdateInput",
		create:"DeliveryMethodWithoutPaymentMethodsCreateInput"
	},
	ChannelPaymentUpsertMethodRelationInput:{
		update:"PaymentMethodWithoutChannelsUpdateInput",
		create:"PaymentMethodWithoutChannelsCreateInput"
	},
	ChannelUpsertPaymentsRelationInput:{
		by:"ChannelPaymentUniqueWhere",
		update:"ChannelPaymentWithoutChannelUpdateInput",
		create:"ChannelPaymentWithoutChannelCreateInput"
	},
	ChannelDeliveryUpsertChannelRelationInput:{
		update:"ChannelWithoutDeliveriesUpdateInput",
		create:"ChannelWithoutDeliveriesCreateInput"
	},
	VatRateUpsertChannelDeliveriesRelationInput:{
		by:"ChannelDeliveryUniqueWhere",
		update:"ChannelDeliveryWithoutVatRateUpdateInput",
		create:"ChannelDeliveryWithoutVatRateCreateInput"
	},
	CustomerCreditUpsertVatRateRelationInput:{
		update:"VatRateUpdateInput",
		create:"VatRateCreateInput"
	},
	CustomerUpsertCreditsRelationInput:{
		by:"CustomerCreditUniqueWhere",
		update:"CustomerCreditWithoutCustomerUpdateInput",
		create:"CustomerCreditWithoutCustomerCreateInput"
	},
	BusinessCustomerUpsertCustomerRelationInput:{
		update:"CustomerWithoutBusinessUpdateInput",
		create:"CustomerWithoutBusinessCreateInput"
	},
	BusinessCategoryUpsertBusinessCustomersRelationInput:{
		by:"BusinessCustomerUniqueWhere",
		update:"BusinessCustomerWithoutCategoryUpdateInput",
		create:"BusinessCustomerWithoutCategoryCreateInput"
	},
	BusinessCategoryLocaleUpsertRootRelationInput:{
		update:"BusinessCategoryWithoutLocalesUpdateInput",
		create:"BusinessCategoryWithoutLocalesCreateInput"
	},
	LocaleUpsertBusinessCategoriesRelationInput:{
		by:"BusinessCategoryLocaleUniqueWhere",
		update:"BusinessCategoryLocaleWithoutLocaleUpdateInput",
		create:"BusinessCategoryLocaleWithoutLocaleCreateInput"
	},
	ProductPackingLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutProductPackingsUpdateInput",
		create:"LocaleWithoutProductPackingsCreateInput"
	},
	ProductPackingUpsertLocalesRelationInput:{
		by:"ProductPackingLocaleUniqueWhere",
		update:"ProductPackingLocaleWithoutRootUpdateInput",
		create:"ProductPackingLocaleWithoutRootCreateInput"
	},
	ProductUpsertPackingRelationInput:{
		update:"ProductPackingUpdateInput",
		create:"ProductPackingCreateInput"
	},
	TagUpsertProductsRelationInput:{
		by:"ProductUniqueWhere",
		update:"ProductWithoutTagsUpdateInput",
		create:"ProductWithoutTagsCreateInput"
	},
	CustomerUpsertTagsRelationInput:{
		by:"TagUniqueWhere",
		update:"TagWithoutCustomersUpdateInput",
		create:"TagWithoutCustomersCreateInput"
	},
	InvoiceUpsertCustomerRelationInput:{
		update:"CustomerWithoutInvoicesUpdateInput",
		create:"CustomerWithoutInvoicesCreateInput"
	},
	AddressUpsertInvoicesRelationInput:{
		by:"InvoiceUniqueWhere",
		update:"InvoiceWithoutAddressUpdateInput",
		create:"InvoiceWithoutAddressCreateInput"
	},
	DeliveryZoneUpsertAddressesRelationInput:{
		by:"AddressUniqueWhere",
		update:"AddressWithoutDeliveryZoneUpdateInput",
		create:"AddressWithoutDeliveryZoneCreateInput"
	},
	DeliveryMethodUpsertSuitableForDeliveryZonesRelationInput:{
		by:"DeliveryZoneUniqueWhere",
		update:"DeliveryZoneWithoutSuitableDeliveryMethodsUpdateInput",
		create:"DeliveryZoneWithoutSuitableDeliveryMethodsCreateInput"
	},
	ChannelDeliveryUpsertMethodRelationInput:{
		update:"DeliveryMethodWithoutChannelsUpdateInput",
		create:"DeliveryMethodWithoutChannelsCreateInput"
	},
	ChannelUpsertDeliveriesRelationInput:{
		by:"ChannelDeliveryUniqueWhere",
		update:"ChannelDeliveryWithoutChannelUpdateInput",
		create:"ChannelDeliveryWithoutChannelCreateInput"
	},
	ChannelPaymentUpsertChannelRelationInput:{
		update:"ChannelWithoutPaymentsUpdateInput",
		create:"ChannelWithoutPaymentsCreateInput"
	},
	PaymentMethodUpsertChannelsRelationInput:{
		by:"ChannelPaymentUniqueWhere",
		update:"ChannelPaymentWithoutMethodUpdateInput",
		create:"ChannelPaymentWithoutMethodCreateInput"
	},
	DeliveryMethodUpsertPaymentMethodsRelationInput:{
		by:"PaymentMethodUniqueWhere",
		update:"PaymentMethodWithoutDeliveryMethodsUpdateInput",
		create:"PaymentMethodWithoutDeliveryMethodsCreateInput"
	},
	DeliveryZoneUpsertSuitableDeliveryMethodsRelationInput:{
		by:"DeliveryMethodUniqueWhere",
		update:"DeliveryMethodWithoutSuitableForDeliveryZonesUpdateInput",
		create:"DeliveryMethodWithoutSuitableForDeliveryZonesCreateInput"
	},
	AddressUpsertDeliveryZoneRelationInput:{
		update:"DeliveryZoneWithoutAddressesUpdateInput",
		create:"DeliveryZoneWithoutAddressesCreateInput"
	},
	CustomerUpsertAddressesRelationInput:{
		by:"AddressUniqueWhere",
		update:"AddressWithoutCustomerUpdateInput",
		create:"AddressWithoutCustomerCreateInput"
	},
	CustomerPaymentMethodUpsertCustomerRelationInput:{
		update:"CustomerWithoutPaymentMethodsUpdateInput",
		create:"CustomerWithoutPaymentMethodsCreateInput"
	},
	CustomerUpsertDefaultPaymentMethodRelationInput:{
		update:"CustomerPaymentMethodUpdateInput",
		create:"CustomerPaymentMethodCreateInput"
	},
	AddressUpsertCustomerRelationInput:{
		update:"CustomerWithoutAddressesUpdateInput",
		create:"CustomerWithoutAddressesCreateInput"
	},
	CustomerCreateInput:{
		id:"UUID",
		addresses:"CustomerCreateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerCreateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerCreateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerCreateTagsEntityRelationInput",
		credits:"CustomerCreateCreditsEntityRelationInput",
		paymentMethods:"CustomerCreatePaymentMethodsEntityRelationInput",
		orders:"CustomerCreateOrdersEntityRelationInput",
		permissions:"CustomerCreatePermissionsEntityRelationInput",
		group:"CustomerCreateGroupEntityRelationInput",
		photo:"CustomerCreatePhotoEntityRelationInput",
		name:"CustomerCreateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerCreateIngredientRatingsEntityRelationInput",
		business:"CustomerCreateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerCreateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerCreateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerCreateCartsEntityRelationInput",
		shortcutList:"CustomerCreateShortcutListEntityRelationInput",
		user:"CustomerCreateUserEntityRelationInput",
		channels:"CustomerCreateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerCreateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerCreateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerCreateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerCreateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerCreateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerCreateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerCreateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerCreateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerCreateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerCreateRedeemedVouchersEntityRelationInput",
		spending:"CustomerCreateSpendingEntityRelationInput",
		customerTabs:"CustomerCreateCustomerTabsEntityRelationInput",
		lead:"CustomerCreateLeadEntityRelationInput",
		meta:"CustomerCreateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerUpdateInput:{
		addresses:"CustomerUpdateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerUpdateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerUpdateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerUpdateTagsEntityRelationInput",
		credits:"CustomerUpdateCreditsEntityRelationInput",
		paymentMethods:"CustomerUpdatePaymentMethodsEntityRelationInput",
		orders:"CustomerUpdateOrdersEntityRelationInput",
		permissions:"CustomerUpdatePermissionsEntityRelationInput",
		group:"CustomerUpdateGroupEntityRelationInput",
		photo:"CustomerUpdatePhotoEntityRelationInput",
		name:"CustomerUpdateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerUpdateIngredientRatingsEntityRelationInput",
		business:"CustomerUpdateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerUpdateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerUpdateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerUpdateCartsEntityRelationInput",
		shortcutList:"CustomerUpdateShortcutListEntityRelationInput",
		user:"CustomerUpdateUserEntityRelationInput",
		channels:"CustomerUpdateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerUpdateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerUpdateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerUpdateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerUpdateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerUpdateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerUpdateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerUpdateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerUpdateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerUpdateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerUpdateRedeemedVouchersEntityRelationInput",
		spending:"CustomerUpdateSpendingEntityRelationInput",
		customerTabs:"CustomerUpdateCustomerTabsEntityRelationInput",
		lead:"CustomerUpdateLeadEntityRelationInput",
		meta:"CustomerUpdateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerCreditCreateInput:{
		id:"UUID",
		expiresAt:"DateTime",
		customer:"CustomerCreditCreateCustomerEntityRelationInput",
		vatRate:"CustomerCreditCreateVatRateEntityRelationInput",
		createdAt:"DateTime",
		transactions:"CustomerCreditCreateTransactionsEntityRelationInput",
		voucherRedemption:"CustomerCreditCreateVoucherRedemptionEntityRelationInput"
	},
	CustomerCreditUpdateInput:{
		expiresAt:"DateTime",
		customer:"CustomerCreditUpdateCustomerEntityRelationInput",
		vatRate:"CustomerCreditUpdateVatRateEntityRelationInput",
		createdAt:"DateTime",
		transactions:"CustomerCreditUpdateTransactionsEntityRelationInput",
		voucherRedemption:"CustomerCreditUpdateVoucherRedemptionEntityRelationInput"
	},
	CustomerGroupCreateInput:{
		id:"UUID",
		productPrices:"CustomerGroupCreateProductPricesEntityRelationInput",
		customers:"CustomerGroupCreateCustomersEntityRelationInput"
	},
	CustomerGroupUpdateInput:{
		productPrices:"CustomerGroupUpdateProductPricesEntityRelationInput",
		customers:"CustomerGroupUpdateCustomersEntityRelationInput"
	},
	OrderCreateInput:{
		id:"UUID",
		state:"OrderState",
		fulfilledAt:"DateTime",
		canceledAt:"DateTime",
		customer:"OrderCreateCustomerEntityRelationInput",
		channel:"OrderCreateChannelEntityRelationInput",
		discounts:"OrderCreateDiscountsEntityRelationInput",
		delivery:"OrderCreateDeliveryEntityRelationInput",
		items:"OrderCreateItemsEntityRelationInput",
		cart:"OrderCreateCartEntityRelationInput",
		events:"OrderCreateEventsEntityRelationInput",
		createdAt:"DateTime",
		billingAddress:"OrderCreateBillingAddressEntityRelationInput",
		priceLines:"OrderCreatePriceLinesEntityRelationInput",
		payments:"OrderCreatePaymentsEntityRelationInput",
		billingSubject:"OrderCreateBillingSubjectEntityRelationInput",
		summary:"OrderCreateSummaryEntityRelationInput",
		gratuity:"OrderCreateGratuityEntityRelationInput",
		venue:"OrderCreateVenueEntityRelationInput",
		fulfillmentNotes:"OrderCreateFulfillmentNotesEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	OrderUpdateInput:{
		state:"OrderState",
		fulfilledAt:"DateTime",
		canceledAt:"DateTime",
		customer:"OrderUpdateCustomerEntityRelationInput",
		channel:"OrderUpdateChannelEntityRelationInput",
		discounts:"OrderUpdateDiscountsEntityRelationInput",
		delivery:"OrderUpdateDeliveryEntityRelationInput",
		items:"OrderUpdateItemsEntityRelationInput",
		cart:"OrderUpdateCartEntityRelationInput",
		events:"OrderUpdateEventsEntityRelationInput",
		createdAt:"DateTime",
		billingAddress:"OrderUpdateBillingAddressEntityRelationInput",
		priceLines:"OrderUpdatePriceLinesEntityRelationInput",
		payments:"OrderUpdatePaymentsEntityRelationInput",
		billingSubject:"OrderUpdateBillingSubjectEntityRelationInput",
		summary:"OrderUpdateSummaryEntityRelationInput",
		gratuity:"OrderUpdateGratuityEntityRelationInput",
		venue:"OrderUpdateVenueEntityRelationInput",
		fulfillmentNotes:"OrderUpdateFulfillmentNotesEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	OrderDiscountCreateInput:{
		id:"UUID",
		vatRate:"OrderDiscountCreateVatRateEntityRelationInput",
		order:"OrderDiscountCreateOrderEntityRelationInput",
		type:"OrderDiscountType",
		customerCreditTransactions:"OrderDiscountCreateCustomerCreditTransactionsEntityRelationInput",
		voucherRedemption:"OrderDiscountCreateVoucherRedemptionEntityRelationInput"
	},
	OrderDiscountUpdateInput:{
		vatRate:"OrderDiscountUpdateVatRateEntityRelationInput",
		order:"OrderDiscountUpdateOrderEntityRelationInput",
		type:"OrderDiscountType",
		customerCreditTransactions:"OrderDiscountUpdateCustomerCreditTransactionsEntityRelationInput",
		voucherRedemption:"OrderDiscountUpdateVoucherRedemptionEntityRelationInput"
	},
	OrderPaymentCreateInput:{
		id:"UUID",
		data:"Json",
		method:"OrderPaymentCreateMethodEntityRelationInput",
		failedAt:"DateTime",
		state:"OrderPaymentState",
		approvedAt:"DateTime",
		events:"OrderPaymentCreateEventsEntityRelationInput",
		order:"OrderPaymentCreateOrderEntityRelationInput",
		invoice:"OrderPaymentCreateInvoiceEntityRelationInput",
		createdAt:"DateTime",
		vatRate:"OrderPaymentCreateVatRateEntityRelationInput",
		meta:"OrderPaymentCreateMetaEntityRelationInput"
	},
	OrderPaymentUpdateInput:{
		data:"Json",
		method:"OrderPaymentUpdateMethodEntityRelationInput",
		failedAt:"DateTime",
		state:"OrderPaymentState",
		approvedAt:"DateTime",
		events:"OrderPaymentUpdateEventsEntityRelationInput",
		order:"OrderPaymentUpdateOrderEntityRelationInput",
		invoice:"OrderPaymentUpdateInvoiceEntityRelationInput",
		createdAt:"DateTime",
		vatRate:"OrderPaymentUpdateVatRateEntityRelationInput",
		meta:"OrderPaymentUpdateMetaEntityRelationInput"
	},
	OrderDeliveryCreateInput:{
		id:"UUID",
		deliveredAt:"DateTime",
		method:"OrderDeliveryCreateMethodEntityRelationInput",
		vatRate:"OrderDeliveryCreateVatRateEntityRelationInput",
		order:"OrderDeliveryCreateOrderEntityRelationInput",
		expectedAt:"DateTime",
		state:"OrderDeliveryState",
		dispatchAt:"DateTime",
		expectedEndAt:"DateTime",
		processingAt:"DateTime",
		deliveringAt:"DateTime",
		failedAt:"DateTime",
		deliveryWaypoint:"OrderDeliveryCreateDeliveryWaypointEntityRelationInput",
		events:"OrderDeliveryCreateEventsEntityRelationInput",
		prepareAt:"DateTime",
		liftagoRide:"OrderDeliveryCreateLiftagoRideEntityRelationInput",
		pickedAt:"DateTime",
		address:"OrderDeliveryCreateAddressEntityRelationInput",
		woltDriveDelivery:"OrderDeliveryCreateWoltDriveDeliveryEntityRelationInput"
	},
	OrderDeliveryUpdateInput:{
		deliveredAt:"DateTime",
		method:"OrderDeliveryUpdateMethodEntityRelationInput",
		vatRate:"OrderDeliveryUpdateVatRateEntityRelationInput",
		order:"OrderDeliveryUpdateOrderEntityRelationInput",
		expectedAt:"DateTime",
		state:"OrderDeliveryState",
		dispatchAt:"DateTime",
		expectedEndAt:"DateTime",
		processingAt:"DateTime",
		deliveringAt:"DateTime",
		failedAt:"DateTime",
		deliveryWaypoint:"OrderDeliveryUpdateDeliveryWaypointEntityRelationInput",
		events:"OrderDeliveryUpdateEventsEntityRelationInput",
		prepareAt:"DateTime",
		liftagoRide:"OrderDeliveryUpdateLiftagoRideEntityRelationInput",
		pickedAt:"DateTime",
		address:"OrderDeliveryUpdateAddressEntityRelationInput",
		woltDriveDelivery:"OrderDeliveryUpdateWoltDriveDeliveryEntityRelationInput"
	},
	OrderItemCreateInput:{
		id:"UUID",
		vatRate:"OrderItemCreateVatRateEntityRelationInput",
		order:"OrderItemCreateOrderEntityRelationInput",
		virtualProductEffects:"OrderItemCreateVirtualProductEffectsEntityRelationInput",
		pickedAt:"DateTime",
		fulfillmentNotes:"OrderItemCreateFulfillmentNotesEntityRelationInput",
		product:"OrderItemCreateProductEntityRelationInput"
	},
	OrderItemUpdateInput:{
		vatRate:"OrderItemUpdateVatRateEntityRelationInput",
		order:"OrderItemUpdateOrderEntityRelationInput",
		virtualProductEffects:"OrderItemUpdateVirtualProductEffectsEntityRelationInput",
		pickedAt:"DateTime",
		fulfillmentNotes:"OrderItemUpdateFulfillmentNotesEntityRelationInput",
		product:"OrderItemUpdateProductEntityRelationInput"
	},
	ProductStockCreateInput:{
		id:"UUID",
		product:"ProductStockCreateProductEntityRelationInput",
		store:"ProductStockCreateStoreEntityRelationInput"
	},
	ProductStockCreateProductEntityRelationInput:{
		connect:"ProductUniqueWhere",
		create:"ProductWithoutStocksCreateInput"
	},
	ProductWithoutStocksCreateInput:{
		id:"UUID",
		packing:"ProductCreatePackingEntityRelationInput",
		recipe:"ProductCreateRecipeEntityRelationInput",
		tags:"ProductCreateTagsEntityRelationInput",
		categories:"ProductCreateCategoriesEntityRelationInput",
		vatRate:"ProductCreateVatRateEntityRelationInput",
		groupPrices:"ProductCreateGroupPricesEntityRelationInput",
		image:"ProductCreateImageEntityRelationInput",
		cartItems:"ProductCreateCartItemsEntityRelationInput",
		availability:"ProductAvailability",
		manager:"ProductCreateManagerEntityRelationInput",
		orderItems:"ProductCreateOrderItemsEntityRelationInput",
		inheritedCategories:"ProductCreateInheritedCategoriesEntityRelationInput",
		deliveryZones:"ProductCreateDeliveryZonesEntityRelationInput",
		locales:"ProductCreateLocalesEntityRelationInput",
		archivedAt:"DateTime",
		customerPrices:"ProductCreateCustomerPricesEntityRelationInput",
		virtualProduct:"ProductCreateVirtualProductEntityRelationInput",
		meta:"ProductCreateMetaEntityRelationInput",
		page:"ProductCreatePageEntityRelationInput",
		salesDays:"ProductCreateSalesDaysEntityRelationInput",
		salesWeeks:"ProductCreateSalesWeeksEntityRelationInput",
		salesMonths:"ProductCreateSalesMonthsEntityRelationInput",
		fulfillmentNotes:"ProductCreateFulfillmentNotesEntityRelationInput"
	},
	ProductStockUpdateInput:{
		product:"ProductStockUpdateProductEntityRelationInput",
		store:"ProductStockUpdateStoreEntityRelationInput"
	},
	ProductStockUpdateProductEntityRelationInput:{
		create:"ProductWithoutStocksCreateInput",
		update:"ProductWithoutStocksUpdateInput",
		upsert:"ProductStockUpsertProductRelationInput",
		connect:"ProductUniqueWhere"
	},
	ProductWithoutStocksUpdateInput:{
		packing:"ProductUpdatePackingEntityRelationInput",
		recipe:"ProductUpdateRecipeEntityRelationInput",
		tags:"ProductUpdateTagsEntityRelationInput",
		categories:"ProductUpdateCategoriesEntityRelationInput",
		vatRate:"ProductUpdateVatRateEntityRelationInput",
		groupPrices:"ProductUpdateGroupPricesEntityRelationInput",
		image:"ProductUpdateImageEntityRelationInput",
		cartItems:"ProductUpdateCartItemsEntityRelationInput",
		availability:"ProductAvailability",
		manager:"ProductUpdateManagerEntityRelationInput",
		orderItems:"ProductUpdateOrderItemsEntityRelationInput",
		inheritedCategories:"ProductUpdateInheritedCategoriesEntityRelationInput",
		deliveryZones:"ProductUpdateDeliveryZonesEntityRelationInput",
		locales:"ProductUpdateLocalesEntityRelationInput",
		archivedAt:"DateTime",
		customerPrices:"ProductUpdateCustomerPricesEntityRelationInput",
		virtualProduct:"ProductUpdateVirtualProductEntityRelationInput",
		meta:"ProductUpdateMetaEntityRelationInput",
		page:"ProductUpdatePageEntityRelationInput",
		salesDays:"ProductUpdateSalesDaysEntityRelationInput",
		salesWeeks:"ProductUpdateSalesWeeksEntityRelationInput",
		salesMonths:"ProductUpdateSalesMonthsEntityRelationInput",
		fulfillmentNotes:"ProductUpdateFulfillmentNotesEntityRelationInput"
	},
	ProductStockUpsertProductRelationInput:{
		update:"ProductWithoutStocksUpdateInput",
		create:"ProductWithoutStocksCreateInput"
	},
	ProductGroupPriceCreateInput:{
		id:"UUID",
		group:"ProductGroupPriceCreateGroupEntityRelationInput",
		product:"ProductGroupPriceCreateProductEntityRelationInput"
	},
	ProductGroupPriceUpdateInput:{
		group:"ProductGroupPriceUpdateGroupEntityRelationInput",
		product:"ProductGroupPriceUpdateProductEntityRelationInput"
	},
	TagCreateInput:{
		id:"UUID",
		customers:"TagCreateCustomersEntityRelationInput",
		products:"TagCreateProductsEntityRelationInput",
		categories:"TagCreateCategoriesEntityRelationInput",
		addTagsOnRegistration:"TagCreateAddTagsOnRegistrationEntityRelationInput",
		nestedCategories:"TagCreateNestedCategoriesEntityRelationInput",
		deliveryZones:"TagCreateDeliveryZonesEntityRelationInput",
		publicInChannels:"TagCreatePublicInChannelsEntityRelationInput",
		allowChannelPayments:"TagCreateAllowChannelPaymentsEntityRelationInput",
		fulfillmentNotes:"TagCreateFulfillmentNotesEntityRelationInput"
	},
	TagUpdateInput:{
		customers:"TagUpdateCustomersEntityRelationInput",
		products:"TagUpdateProductsEntityRelationInput",
		categories:"TagUpdateCategoriesEntityRelationInput",
		addTagsOnRegistration:"TagUpdateAddTagsOnRegistrationEntityRelationInput",
		nestedCategories:"TagUpdateNestedCategoriesEntityRelationInput",
		deliveryZones:"TagUpdateDeliveryZonesEntityRelationInput",
		publicInChannels:"TagUpdatePublicInChannelsEntityRelationInput",
		allowChannelPayments:"TagUpdateAllowChannelPaymentsEntityRelationInput",
		fulfillmentNotes:"TagUpdateFulfillmentNotesEntityRelationInput"
	},
	BusinessCategoryCreateInput:{
		id:"UUID",
		locales:"BusinessCategoryCreateLocalesEntityRelationInput",
		businessCustomers:"BusinessCategoryCreateBusinessCustomersEntityRelationInput",
		recurrences:"BusinessCategoryCreateRecurrencesEntityRelationInput",
		specificProducts:"BusinessCategoryCreateSpecificProductsEntityRelationInput",
		seasonalProductCategories:"BusinessCategoryCreateSeasonalProductCategoriesEntityRelationInput",
		specificProductsProductCategories:"BusinessCategoryCreateSpecificProductsProductCategoriesEntityRelationInput"
	},
	BusinessCategoryUpdateInput:{
		locales:"BusinessCategoryUpdateLocalesEntityRelationInput",
		businessCustomers:"BusinessCategoryUpdateBusinessCustomersEntityRelationInput",
		recurrences:"BusinessCategoryUpdateRecurrencesEntityRelationInput",
		specificProducts:"BusinessCategoryUpdateSpecificProductsEntityRelationInput",
		seasonalProductCategories:"BusinessCategoryUpdateSeasonalProductCategoriesEntityRelationInput",
		specificProductsProductCategories:"BusinessCategoryUpdateSpecificProductsProductCategoriesEntityRelationInput"
	},
	ProductListItemCreateInput:{
		id:"UUID",
		list:"ProductListItemCreateListEntityRelationInput",
		product:"ProductListItemCreateProductEntityRelationInput"
	},
	ProductListItemCreateListEntityRelationInput:{
		connect:"ProductListUniqueWhere",
		create:"ProductListWithoutItemsCreateInput"
	},
	ProductListWithoutItemsCreateInput:{
		id:"UUID",
		businessCategory:"ProductListCreateBusinessCategoryEntityRelationInput"
	},
	ProductListItemUpdateInput:{
		list:"ProductListItemUpdateListEntityRelationInput",
		product:"ProductListItemUpdateProductEntityRelationInput"
	},
	ProductListItemUpdateListEntityRelationInput:{
		create:"ProductListWithoutItemsCreateInput",
		update:"ProductListWithoutItemsUpdateInput",
		upsert:"ProductListItemUpsertListRelationInput",
		connect:"ProductListUniqueWhere"
	},
	ProductListWithoutItemsUpdateInput:{
		businessCategory:"ProductListUpdateBusinessCategoryEntityRelationInput"
	},
	ProductListItemUpsertListRelationInput:{
		update:"ProductListWithoutItemsUpdateInput",
		create:"ProductListWithoutItemsCreateInput"
	},
	ProductCategoryListCreateInput:{
		id:"UUID",
		items:"ProductCategoryListCreateItemsEntityRelationInput",
		locales:"ProductCategoryListCreateLocalesEntityRelationInput",
		seasonalProductCategoriesOfBusinessCategory:"ProductCategoryListCreateSeasonalProductCategoriesOfBusinessCategoryEntityRelationInput",
		specificProductsProductCategoriesOfBusinessCategory:"ProductCategoryListCreateSpecificProductsProductCategoriesOfBusinessCategoryEntityRelationInput"
	},
	ProductCategoryListUpdateInput:{
		items:"ProductCategoryListUpdateItemsEntityRelationInput",
		locales:"ProductCategoryListUpdateLocalesEntityRelationInput",
		seasonalProductCategoriesOfBusinessCategory:"ProductCategoryListUpdateSeasonalProductCategoriesOfBusinessCategoryEntityRelationInput",
		specificProductsProductCategoriesOfBusinessCategory:"ProductCategoryListUpdateSpecificProductsProductCategoriesOfBusinessCategoryEntityRelationInput"
	},
	ProductCategoryListItemCreateInput:{
		id:"UUID",
		list:"ProductCategoryListItemCreateListEntityRelationInput",
		productCategory:"ProductCategoryListItemCreateProductCategoryEntityRelationInput"
	},
	ProductCategoryListItemCreateListEntityRelationInput:{
		connect:"ProductCategoryListUniqueWhere",
		create:"ProductCategoryListWithoutItemsCreateInput"
	},
	ProductCategoryListWithoutItemsCreateInput:{
		id:"UUID",
		locales:"ProductCategoryListCreateLocalesEntityRelationInput",
		seasonalProductCategoriesOfBusinessCategory:"ProductCategoryListCreateSeasonalProductCategoriesOfBusinessCategoryEntityRelationInput",
		specificProductsProductCategoriesOfBusinessCategory:"ProductCategoryListCreateSpecificProductsProductCategoriesOfBusinessCategoryEntityRelationInput"
	},
	ProductCategoryListItemUpdateInput:{
		list:"ProductCategoryListItemUpdateListEntityRelationInput",
		productCategory:"ProductCategoryListItemUpdateProductCategoryEntityRelationInput"
	},
	ProductCategoryListItemUpdateListEntityRelationInput:{
		create:"ProductCategoryListWithoutItemsCreateInput",
		update:"ProductCategoryListWithoutItemsUpdateInput",
		upsert:"ProductCategoryListItemUpsertListRelationInput",
		connect:"ProductCategoryListUniqueWhere"
	},
	ProductCategoryListWithoutItemsUpdateInput:{
		locales:"ProductCategoryListUpdateLocalesEntityRelationInput",
		seasonalProductCategoriesOfBusinessCategory:"ProductCategoryListUpdateSeasonalProductCategoriesOfBusinessCategoryEntityRelationInput",
		specificProductsProductCategoriesOfBusinessCategory:"ProductCategoryListUpdateSpecificProductsProductCategoriesOfBusinessCategoryEntityRelationInput"
	},
	ProductCategoryListItemUpsertListRelationInput:{
		update:"ProductCategoryListWithoutItemsUpdateInput",
		create:"ProductCategoryListWithoutItemsCreateInput"
	},
	BusinessCategoryLocaleCreateInput:{
		id:"UUID",
		root:"BusinessCategoryLocaleCreateRootEntityRelationInput",
		locale:"BusinessCategoryLocaleCreateLocaleEntityRelationInput"
	},
	BusinessCategoryLocaleUpdateInput:{
		root:"BusinessCategoryLocaleUpdateRootEntityRelationInput",
		locale:"BusinessCategoryLocaleUpdateLocaleEntityRelationInput"
	},
	LocaleCreateInput:{
		id:"UUID",
		businessCategories:"LocaleCreateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleCreateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleCreateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleCreateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleCreateBlogsEntityRelationInput",
		blogPosts:"LocaleCreateBlogPostsEntityRelationInput",
		identifier:"LocaleCreateIdentifierEntityRelationInput",
		menus:"LocaleCreateMenusEntityRelationInput",
		pages:"LocaleCreatePagesEntityRelationInput",
		productIngredientCategories:"LocaleCreateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleCreateAllergensEntityRelationInput",
		productPackings:"LocaleCreateProductPackingsEntityRelationInput",
		products:"LocaleCreateProductsEntityRelationInput",
		productRecipes:"LocaleCreateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleCreatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleCreatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleCreateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleCreateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleCreateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleCreatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleCreateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleCreateBusinessServicesEntityRelationInput"
	},
	LocaleUpdateInput:{
		businessCategories:"LocaleUpdateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleUpdateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleUpdateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleUpdateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleUpdateBlogsEntityRelationInput",
		blogPosts:"LocaleUpdateBlogPostsEntityRelationInput",
		identifier:"LocaleUpdateIdentifierEntityRelationInput",
		menus:"LocaleUpdateMenusEntityRelationInput",
		pages:"LocaleUpdatePagesEntityRelationInput",
		productIngredientCategories:"LocaleUpdateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleUpdateAllergensEntityRelationInput",
		productPackings:"LocaleUpdateProductPackingsEntityRelationInput",
		products:"LocaleUpdateProductsEntityRelationInput",
		productRecipes:"LocaleUpdateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleUpdatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleUpdateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleUpdateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleUpdateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleUpdatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleUpdateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleUpdateBusinessServicesEntityRelationInput"
	},
	ProductCategoryListLocaleCreateInput:{
		id:"UUID",
		root:"ProductCategoryListLocaleCreateRootEntityRelationInput",
		locale:"ProductCategoryListLocaleCreateLocaleEntityRelationInput"
	},
	ProductCategoryListLocaleUpdateInput:{
		root:"ProductCategoryListLocaleUpdateRootEntityRelationInput",
		locale:"ProductCategoryListLocaleUpdateLocaleEntityRelationInput"
	},
	CustomerNameCreateInput:{
		id:"UUID",
		customer:"CustomerNameCreateCustomerEntityRelationInput",
		aliases:"CustomerNameCreateAliasesEntityRelationInput"
	},
	CustomerNameCreateCustomerEntityRelationInput:{
		connect:"CustomerUniqueWhere",
		create:"CustomerWithoutNameCreateInput"
	},
	CustomerWithoutNameCreateInput:{
		id:"UUID",
		addresses:"CustomerCreateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerCreateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerCreateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerCreateTagsEntityRelationInput",
		credits:"CustomerCreateCreditsEntityRelationInput",
		paymentMethods:"CustomerCreatePaymentMethodsEntityRelationInput",
		orders:"CustomerCreateOrdersEntityRelationInput",
		permissions:"CustomerCreatePermissionsEntityRelationInput",
		group:"CustomerCreateGroupEntityRelationInput",
		photo:"CustomerCreatePhotoEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerCreateIngredientRatingsEntityRelationInput",
		business:"CustomerCreateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerCreateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerCreateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerCreateCartsEntityRelationInput",
		shortcutList:"CustomerCreateShortcutListEntityRelationInput",
		user:"CustomerCreateUserEntityRelationInput",
		channels:"CustomerCreateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerCreateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerCreateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerCreateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerCreateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerCreateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerCreateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerCreateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerCreateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerCreateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerCreateRedeemedVouchersEntityRelationInput",
		spending:"CustomerCreateSpendingEntityRelationInput",
		customerTabs:"CustomerCreateCustomerTabsEntityRelationInput",
		lead:"CustomerCreateLeadEntityRelationInput",
		meta:"CustomerCreateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerNameUpdateInput:{
		customer:"CustomerNameUpdateCustomerEntityRelationInput",
		aliases:"CustomerNameUpdateAliasesEntityRelationInput"
	},
	CustomerNameUpdateCustomerEntityRelationInput:{
		create:"CustomerWithoutNameCreateInput",
		update:"CustomerWithoutNameUpdateInput",
		upsert:"CustomerNameUpsertCustomerRelationInput",
		connect:"CustomerUniqueWhere"
	},
	CustomerWithoutNameUpdateInput:{
		addresses:"CustomerUpdateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerUpdateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerUpdateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerUpdateTagsEntityRelationInput",
		credits:"CustomerUpdateCreditsEntityRelationInput",
		paymentMethods:"CustomerUpdatePaymentMethodsEntityRelationInput",
		orders:"CustomerUpdateOrdersEntityRelationInput",
		permissions:"CustomerUpdatePermissionsEntityRelationInput",
		group:"CustomerUpdateGroupEntityRelationInput",
		photo:"CustomerUpdatePhotoEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerUpdateIngredientRatingsEntityRelationInput",
		business:"CustomerUpdateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerUpdateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerUpdateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerUpdateCartsEntityRelationInput",
		shortcutList:"CustomerUpdateShortcutListEntityRelationInput",
		user:"CustomerUpdateUserEntityRelationInput",
		channels:"CustomerUpdateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerUpdateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerUpdateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerUpdateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerUpdateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerUpdateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerUpdateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerUpdateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerUpdateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerUpdateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerUpdateRedeemedVouchersEntityRelationInput",
		spending:"CustomerUpdateSpendingEntityRelationInput",
		customerTabs:"CustomerUpdateCustomerTabsEntityRelationInput",
		lead:"CustomerUpdateLeadEntityRelationInput",
		meta:"CustomerUpdateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	CustomerNameUpsertCustomerRelationInput:{
		update:"CustomerWithoutNameUpdateInput",
		create:"CustomerWithoutNameCreateInput"
	},
	ProductIngredientItemCreateInput:{
		id:"UUID",
		recipe:"ProductIngredientItemCreateRecipeEntityRelationInput",
		ingredient:"ProductIngredientItemCreateIngredientEntityRelationInput",
		quantity:"ProductIngredientItemCreateQuantityEntityRelationInput"
	},
	ProductIngredientItemCreateRecipeEntityRelationInput:{
		connect:"ProductRecipeUniqueWhere",
		create:"ProductRecipeWithoutIngredientsCreateInput"
	},
	ProductRecipeWithoutIngredientsCreateInput:{
		id:"UUID",
		products:"ProductRecipeCreateProductsEntityRelationInput",
		image:"ProductRecipeCreateImageEntityRelationInput",
		icon:"ProductRecipeCreateIconEntityRelationInput",
		locales:"ProductRecipeCreateLocalesEntityRelationInput",
		freshingContainer:"ProductRecipeCreateFreshingContainerEntityRelationInput",
		nutritionFacts:"ProductRecipeCreateNutritionFactsEntityRelationInput"
	},
	ProductIngredientItemUpdateInput:{
		recipe:"ProductIngredientItemUpdateRecipeEntityRelationInput",
		ingredient:"ProductIngredientItemUpdateIngredientEntityRelationInput",
		quantity:"ProductIngredientItemUpdateQuantityEntityRelationInput"
	},
	ProductIngredientItemUpdateRecipeEntityRelationInput:{
		create:"ProductRecipeWithoutIngredientsCreateInput",
		update:"ProductRecipeWithoutIngredientsUpdateInput",
		upsert:"ProductIngredientItemUpsertRecipeRelationInput",
		connect:"ProductRecipeUniqueWhere"
	},
	ProductRecipeWithoutIngredientsUpdateInput:{
		products:"ProductRecipeUpdateProductsEntityRelationInput",
		image:"ProductRecipeUpdateImageEntityRelationInput",
		icon:"ProductRecipeUpdateIconEntityRelationInput",
		locales:"ProductRecipeUpdateLocalesEntityRelationInput",
		freshingContainer:"ProductRecipeUpdateFreshingContainerEntityRelationInput",
		nutritionFacts:"ProductRecipeUpdateNutritionFactsEntityRelationInput"
	},
	ProductIngredientItemUpsertRecipeRelationInput:{
		update:"ProductRecipeWithoutIngredientsUpdateInput",
		create:"ProductRecipeWithoutIngredientsCreateInput"
	},
	CustomerIngredientRatingCreateInput:{
		id:"UUID",
		customer:"CustomerIngredientRatingCreateCustomerEntityRelationInput",
		rating:"CustomerIngredientRatingCreateRatingEntityRelationInput",
		ingredient:"CustomerIngredientRatingCreateIngredientEntityRelationInput"
	},
	CustomerIngredientRatingUpdateInput:{
		customer:"CustomerIngredientRatingUpdateCustomerEntityRelationInput",
		rating:"CustomerIngredientRatingUpdateRatingEntityRelationInput",
		ingredient:"CustomerIngredientRatingUpdateIngredientEntityRelationInput"
	},
	ProductIngredientLocaleCreateInput:{
		id:"UUID",
		root:"ProductIngredientLocaleCreateRootEntityRelationInput",
		locale:"ProductIngredientLocaleCreateLocaleEntityRelationInput"
	},
	ProductIngredientLocaleUpdateInput:{
		root:"ProductIngredientLocaleUpdateRootEntityRelationInput",
		locale:"ProductIngredientLocaleUpdateLocaleEntityRelationInput"
	},
	OrderRecurrenceCreateInput:{
		id:"UUID",
		locales:"OrderRecurrenceCreateLocalesEntityRelationInput",
		businessCategory:"OrderRecurrenceCreateBusinessCategoryEntityRelationInput"
	},
	OrderRecurrenceUpdateInput:{
		locales:"OrderRecurrenceUpdateLocalesEntityRelationInput",
		businessCategory:"OrderRecurrenceUpdateBusinessCategoryEntityRelationInput"
	},
	OrderRecurrenceLocaleCreateInput:{
		id:"UUID",
		root:"OrderRecurrenceLocaleCreateRootEntityRelationInput",
		locale:"OrderRecurrenceLocaleCreateLocaleEntityRelationInput"
	},
	OrderRecurrenceLocaleUpdateInput:{
		root:"OrderRecurrenceLocaleUpdateRootEntityRelationInput",
		locale:"OrderRecurrenceLocaleUpdateLocaleEntityRelationInput"
	},
	BusinessCustomerCreateInput:{
		id:"UUID",
		customer:"BusinessCustomerCreateCustomerEntityRelationInput",
		owners:"BusinessCustomerCreateOwnersEntityRelationInput",
		members:"BusinessCustomerCreateMembersEntityRelationInput",
		category:"BusinessCustomerCreateCategoryEntityRelationInput",
		accountManager:"BusinessCustomerCreateAccountManagerEntityRelationInput",
		logo:"BusinessCustomerCreateLogoEntityRelationInput",
		businessServiceEvents:"BusinessCustomerCreateBusinessServiceEventsEntityRelationInput",
		doubleshotCoffeeEquipment:"BusinessCustomerCreateDoubleshotCoffeeEquipmentEntityRelationInput"
	},
	BusinessCustomerUpdateInput:{
		customer:"BusinessCustomerUpdateCustomerEntityRelationInput",
		owners:"BusinessCustomerUpdateOwnersEntityRelationInput",
		members:"BusinessCustomerUpdateMembersEntityRelationInput",
		category:"BusinessCustomerUpdateCategoryEntityRelationInput",
		accountManager:"BusinessCustomerUpdateAccountManagerEntityRelationInput",
		logo:"BusinessCustomerUpdateLogoEntityRelationInput",
		businessServiceEvents:"BusinessCustomerUpdateBusinessServiceEventsEntityRelationInput",
		doubleshotCoffeeEquipment:"BusinessCustomerUpdateDoubleshotCoffeeEquipmentEntityRelationInput"
	},
	PointOfSaleCreateInput:{
		id:"UUID",
		channels:"PointOfSaleCreateChannelsEntityRelationInput",
		permissions:"PointOfSaleCreatePermissionsEntityRelationInput",
		tenantPersonId:"UUID"
	},
	PointOfSaleCreateChannelsEntityRelationInput:{
		connect:"ChannelUniqueWhere",
		create:"ChannelWithoutPointOfSalesCreateInput"
	},
	ChannelWithoutPointOfSalesCreateInput:{
		id:"UUID",
		payments:"ChannelCreatePaymentsEntityRelationInput",
		deliveries:"ChannelCreateDeliveriesEntityRelationInput",
		carts:"ChannelCreateCartsEntityRelationInput",
		customers:"ChannelCreateCustomersEntityRelationInput",
		code:"ChannelCode",
		addTagsOnRegistration:"ChannelCreateAddTagsOnRegistrationEntityRelationInput",
		publicTags:"ChannelCreatePublicTagsEntityRelationInput",
		venue:"ChannelCreateVenueEntityRelationInput"
	},
	PointOfSaleUpdateInput:{
		channels:"PointOfSaleUpdateChannelsEntityRelationInput",
		permissions:"PointOfSaleUpdatePermissionsEntityRelationInput",
		tenantPersonId:"UUID"
	},
	PointOfSaleUpdateChannelsEntityRelationInput:{
		create:"ChannelWithoutPointOfSalesCreateInput",
		update:"PointOfSaleUpdateChannelsRelationInput",
		upsert:"PointOfSaleUpsertChannelsRelationInput",
		connect:"ChannelUniqueWhere",
		disconnect:"ChannelUniqueWhere",
		delete:"ChannelUniqueWhere"
	},
	PointOfSaleUpdateChannelsRelationInput:{
		by:"ChannelUniqueWhere",
		data:"ChannelWithoutPointOfSalesUpdateInput"
	},
	ChannelWithoutPointOfSalesUpdateInput:{
		payments:"ChannelUpdatePaymentsEntityRelationInput",
		deliveries:"ChannelUpdateDeliveriesEntityRelationInput",
		carts:"ChannelUpdateCartsEntityRelationInput",
		customers:"ChannelUpdateCustomersEntityRelationInput",
		code:"ChannelCode",
		addTagsOnRegistration:"ChannelUpdateAddTagsOnRegistrationEntityRelationInput",
		publicTags:"ChannelUpdatePublicTagsEntityRelationInput",
		venue:"ChannelUpdateVenueEntityRelationInput"
	},
	PointOfSaleUpsertChannelsRelationInput:{
		by:"ChannelUniqueWhere",
		update:"ChannelWithoutPointOfSalesUpdateInput",
		create:"ChannelWithoutPointOfSalesCreateInput"
	},
	BlogCreateInput:{
		id:"UUID",
		unique:"One",
		locales:"BlogCreateLocalesEntityRelationInput"
	},
	BlogCreateLocalesEntityRelationInput:{
		connect:"BlogLocaleUniqueWhere",
		create:"BlogLocaleWithoutRootCreateInput"
	},
	BlogLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"BlogLocaleCreateLocaleEntityRelationInput"
	},
	BlogLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutBlogsCreateInput"
	},
	LocaleWithoutBlogsCreateInput:{
		id:"UUID",
		businessCategories:"LocaleCreateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleCreateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleCreateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleCreateOrderRecurrencesEntityRelationInput",
		blogPosts:"LocaleCreateBlogPostsEntityRelationInput",
		identifier:"LocaleCreateIdentifierEntityRelationInput",
		menus:"LocaleCreateMenusEntityRelationInput",
		pages:"LocaleCreatePagesEntityRelationInput",
		productIngredientCategories:"LocaleCreateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleCreateAllergensEntityRelationInput",
		productPackings:"LocaleCreateProductPackingsEntityRelationInput",
		products:"LocaleCreateProductsEntityRelationInput",
		productRecipes:"LocaleCreateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleCreatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleCreatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleCreateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleCreateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleCreateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleCreatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleCreateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleCreateBusinessServicesEntityRelationInput"
	},
	BlogUpdateInput:{
		unique:"One",
		locales:"BlogUpdateLocalesEntityRelationInput"
	},
	BlogUpdateLocalesEntityRelationInput:{
		create:"BlogLocaleWithoutRootCreateInput",
		update:"BlogUpdateLocalesRelationInput",
		upsert:"BlogUpsertLocalesRelationInput",
		connect:"BlogLocaleUniqueWhere",
		disconnect:"BlogLocaleUniqueWhere",
		delete:"BlogLocaleUniqueWhere"
	},
	BlogUpdateLocalesRelationInput:{
		by:"BlogLocaleUniqueWhere",
		data:"BlogLocaleWithoutRootUpdateInput"
	},
	BlogLocaleWithoutRootUpdateInput:{
		locale:"BlogLocaleUpdateLocaleEntityRelationInput"
	},
	BlogLocaleUpdateLocaleEntityRelationInput:{
		create:"LocaleWithoutBlogsCreateInput",
		update:"LocaleWithoutBlogsUpdateInput",
		upsert:"BlogLocaleUpsertLocaleRelationInput",
		connect:"LocaleUniqueWhere"
	},
	LocaleWithoutBlogsUpdateInput:{
		businessCategories:"LocaleUpdateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleUpdateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleUpdateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleUpdateOrderRecurrencesEntityRelationInput",
		blogPosts:"LocaleUpdateBlogPostsEntityRelationInput",
		identifier:"LocaleUpdateIdentifierEntityRelationInput",
		menus:"LocaleUpdateMenusEntityRelationInput",
		pages:"LocaleUpdatePagesEntityRelationInput",
		productIngredientCategories:"LocaleUpdateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleUpdateAllergensEntityRelationInput",
		productPackings:"LocaleUpdateProductPackingsEntityRelationInput",
		products:"LocaleUpdateProductsEntityRelationInput",
		productRecipes:"LocaleUpdateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleUpdatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleUpdateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleUpdateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleUpdateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleUpdatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleUpdateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleUpdateBusinessServicesEntityRelationInput"
	},
	BlogLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutBlogsUpdateInput",
		create:"LocaleWithoutBlogsCreateInput"
	},
	BlogUpsertLocalesRelationInput:{
		by:"BlogLocaleUniqueWhere",
		update:"BlogLocaleWithoutRootUpdateInput",
		create:"BlogLocaleWithoutRootCreateInput"
	},
	BlogLocaleCreateInput:{
		id:"UUID",
		root:"BlogLocaleCreateRootEntityRelationInput",
		locale:"BlogLocaleCreateLocaleEntityRelationInput"
	},
	BlogLocaleUpdateInput:{
		root:"BlogLocaleUpdateRootEntityRelationInput",
		locale:"BlogLocaleUpdateLocaleEntityRelationInput"
	},
	BlogPostCreateInput:{
		id:"UUID",
		locales:"BlogPostCreateLocalesEntityRelationInput"
	},
	BlogPostCreateLocalesEntityRelationInput:{
		connect:"BlogPostLocaleUniqueWhere",
		create:"BlogPostLocaleWithoutRootCreateInput"
	},
	BlogPostLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"BlogPostLocaleCreateLocaleEntityRelationInput",
		cover:"BlogPostLocaleCreateCoverEntityRelationInput",
		content:"BlogPostLocaleCreateContentEntityRelationInput",
		link:"BlogPostLocaleCreateLinkEntityRelationInput",
		seo:"BlogPostLocaleCreateSeoEntityRelationInput",
		products:"BlogPostLocaleCreateProductsEntityRelationInput"
	},
	BlogPostUpdateInput:{
		locales:"BlogPostUpdateLocalesEntityRelationInput"
	},
	BlogPostUpdateLocalesEntityRelationInput:{
		create:"BlogPostLocaleWithoutRootCreateInput",
		update:"BlogPostUpdateLocalesRelationInput",
		upsert:"BlogPostUpsertLocalesRelationInput",
		connect:"BlogPostLocaleUniqueWhere",
		disconnect:"BlogPostLocaleUniqueWhere",
		delete:"BlogPostLocaleUniqueWhere"
	},
	BlogPostUpdateLocalesRelationInput:{
		by:"BlogPostLocaleUniqueWhere",
		data:"BlogPostLocaleWithoutRootUpdateInput"
	},
	BlogPostLocaleWithoutRootUpdateInput:{
		locale:"BlogPostLocaleUpdateLocaleEntityRelationInput",
		cover:"BlogPostLocaleUpdateCoverEntityRelationInput",
		content:"BlogPostLocaleUpdateContentEntityRelationInput",
		link:"BlogPostLocaleUpdateLinkEntityRelationInput",
		seo:"BlogPostLocaleUpdateSeoEntityRelationInput",
		products:"BlogPostLocaleUpdateProductsEntityRelationInput"
	},
	BlogPostUpsertLocalesRelationInput:{
		by:"BlogPostLocaleUniqueWhere",
		update:"BlogPostLocaleWithoutRootUpdateInput",
		create:"BlogPostLocaleWithoutRootCreateInput"
	},
	ContentBlockCreateInput:{
		id:"UUID",
		content:"ContentBlockCreateContentEntityRelationInput",
		references:"ContentBlockCreateReferencesEntityRelationInput"
	},
	ContentBlockCreateContentEntityRelationInput:{
		connect:"ContentUniqueWhere",
		create:"ContentWithoutBlocksCreateInput"
	},
	ContentWithoutBlocksCreateInput:{
		id:"UUID"
	},
	ContentBlockUpdateInput:{
		content:"ContentBlockUpdateContentEntityRelationInput",
		references:"ContentBlockUpdateReferencesEntityRelationInput"
	},
	ContentBlockUpdateContentEntityRelationInput:{
		create:"ContentWithoutBlocksCreateInput",
		update:"ContentWithoutBlocksUpdateInput",
		upsert:"ContentBlockUpsertContentRelationInput",
		connect:"ContentUniqueWhere"
	},
	ContentWithoutBlocksUpdateInput:{

	},
	ContentBlockUpsertContentRelationInput:{
		update:"ContentWithoutBlocksUpdateInput",
		create:"ContentWithoutBlocksCreateInput"
	},
	ContentReferenceCreateInput:{
		id:"UUID",
		type:"ContentReferenceType",
		block:"ContentReferenceCreateBlockEntityRelationInput",
		colorPallete:"ContentReferenceCreateColorPalleteEntityRelationInput",
		medium:"ContentReferenceCreateMediumEntityRelationInput",
		link:"ContentReferenceCreateLinkEntityRelationInput",
		blogPosts:"ContentReferenceCreateBlogPostsEntityRelationInput",
		links:"ContentReferenceCreateLinksEntityRelationInput",
		products:"ContentReferenceCreateProductsEntityRelationInput",
		contentSize:"ContentSize",
		hero:"ContentReferenceCreateHeroEntityRelationInput",
		gallery:"ContentReferenceCreateGalleryEntityRelationInput",
		socialsAndApps:"ContentReferenceCreateSocialsAndAppsEntityRelationInput",
		productGrid:"ContentReferenceCreateProductGridEntityRelationInput",
		productBanners:"ContentReferenceCreateProductBannersEntityRelationInput",
		deliveryRegions:"ContentReferenceCreateDeliveryRegionsEntityRelationInput",
		textList:"ContentReferenceCreateTextListEntityRelationInput",
		gridTiles:"ContentReferenceCreateGridTilesEntityRelationInput"
	},
	ContentReferenceCreateBlockEntityRelationInput:{
		connect:"ContentBlockUniqueWhere",
		create:"ContentBlockWithoutReferencesCreateInput"
	},
	ContentBlockWithoutReferencesCreateInput:{
		id:"UUID",
		content:"ContentBlockCreateContentEntityRelationInput"
	},
	ContentReferenceUpdateInput:{
		type:"ContentReferenceType",
		block:"ContentReferenceUpdateBlockEntityRelationInput",
		colorPallete:"ContentReferenceUpdateColorPalleteEntityRelationInput",
		medium:"ContentReferenceUpdateMediumEntityRelationInput",
		link:"ContentReferenceUpdateLinkEntityRelationInput",
		blogPosts:"ContentReferenceUpdateBlogPostsEntityRelationInput",
		links:"ContentReferenceUpdateLinksEntityRelationInput",
		products:"ContentReferenceUpdateProductsEntityRelationInput",
		contentSize:"ContentSize",
		hero:"ContentReferenceUpdateHeroEntityRelationInput",
		gallery:"ContentReferenceUpdateGalleryEntityRelationInput",
		socialsAndApps:"ContentReferenceUpdateSocialsAndAppsEntityRelationInput",
		productGrid:"ContentReferenceUpdateProductGridEntityRelationInput",
		productBanners:"ContentReferenceUpdateProductBannersEntityRelationInput",
		deliveryRegions:"ContentReferenceUpdateDeliveryRegionsEntityRelationInput",
		textList:"ContentReferenceUpdateTextListEntityRelationInput",
		gridTiles:"ContentReferenceUpdateGridTilesEntityRelationInput"
	},
	ContentReferenceUpdateBlockEntityRelationInput:{
		create:"ContentBlockWithoutReferencesCreateInput",
		update:"ContentBlockWithoutReferencesUpdateInput",
		upsert:"ContentReferenceUpsertBlockRelationInput",
		connect:"ContentBlockUniqueWhere"
	},
	ContentBlockWithoutReferencesUpdateInput:{
		content:"ContentBlockUpdateContentEntityRelationInput"
	},
	ContentReferenceUpsertBlockRelationInput:{
		update:"ContentBlockWithoutReferencesUpdateInput",
		create:"ContentBlockWithoutReferencesCreateInput"
	},
	BlogPostListItemCreateInput:{
		id:"UUID",
		list:"BlogPostListItemCreateListEntityRelationInput",
		blogPost:"BlogPostListItemCreateBlogPostEntityRelationInput"
	},
	BlogPostListItemCreateListEntityRelationInput:{
		connect:"BlogPostListUniqueWhere",
		create:"BlogPostListWithoutItemsCreateInput"
	},
	BlogPostListWithoutItemsCreateInput:{
		id:"UUID"
	},
	BlogPostListItemUpdateInput:{
		list:"BlogPostListItemUpdateListEntityRelationInput",
		blogPost:"BlogPostListItemUpdateBlogPostEntityRelationInput"
	},
	BlogPostListItemUpdateListEntityRelationInput:{
		create:"BlogPostListWithoutItemsCreateInput",
		update:"BlogPostListWithoutItemsUpdateInput",
		upsert:"BlogPostListItemUpsertListRelationInput",
		connect:"BlogPostListUniqueWhere"
	},
	BlogPostListWithoutItemsUpdateInput:{

	},
	BlogPostListItemUpsertListRelationInput:{
		update:"BlogPostListWithoutItemsUpdateInput",
		create:"BlogPostListWithoutItemsCreateInput"
	},
	LinkListItemCreateInput:{
		id:"UUID",
		list:"LinkListItemCreateListEntityRelationInput",
		link:"LinkListItemCreateLinkEntityRelationInput"
	},
	LinkListItemCreateListEntityRelationInput:{
		connect:"LinkListUniqueWhere",
		create:"LinkListWithoutItemsCreateInput"
	},
	LinkListWithoutItemsCreateInput:{
		id:"UUID"
	},
	LinkListItemUpdateInput:{
		list:"LinkListItemUpdateListEntityRelationInput",
		link:"LinkListItemUpdateLinkEntityRelationInput"
	},
	LinkListItemUpdateListEntityRelationInput:{
		create:"LinkListWithoutItemsCreateInput",
		update:"LinkListWithoutItemsUpdateInput",
		upsert:"LinkListItemUpsertListRelationInput",
		connect:"LinkListUniqueWhere"
	},
	LinkListWithoutItemsUpdateInput:{

	},
	LinkListItemUpsertListRelationInput:{
		update:"LinkListWithoutItemsUpdateInput",
		create:"LinkListWithoutItemsCreateInput"
	},
	ProtectedImageUniqueWhere:{
		id:"UUID"
	},
	ProtectedImageWhere:{
		id:"UUIDCondition",
		url:"StringCondition",
		width:"IntCondition",
		height:"IntCondition",
		size:"IntCondition",
		type:"StringCondition",
		alt:"StringCondition",
		and:"ProtectedImageWhere",
		or:"ProtectedImageWhere",
		not:"ProtectedImageWhere"
	},
	ProtectedImageOrderBy:{
		id:"OrderDirection",
		url:"OrderDirection",
		width:"OrderDirection",
		height:"OrderDirection",
		size:"OrderDirection",
		type:"OrderDirection",
		alt:"OrderDirection"
	},
	ProtectedImageCreateInput:{
		id:"UUID"
	},
	ProtectedImageUpdateInput:{

	},
	TranslationDomainCreateInput:{
		id:"UUID",
		catalogues:"TranslationDomainCreateCataloguesEntityRelationInput",
		keys:"TranslationDomainCreateKeysEntityRelationInput"
	},
	TranslationDomainUpdateInput:{
		catalogues:"TranslationDomainUpdateCataloguesEntityRelationInput",
		keys:"TranslationDomainUpdateKeysEntityRelationInput"
	},
	TranslationKeyCreateInput:{
		id:"UUID",
		contentType:"TranslationContentType",
		domain:"TranslationKeyCreateDomainEntityRelationInput",
		values:"TranslationKeyCreateValuesEntityRelationInput"
	},
	TranslationKeyUpdateInput:{
		contentType:"TranslationContentType",
		domain:"TranslationKeyUpdateDomainEntityRelationInput",
		values:"TranslationKeyUpdateValuesEntityRelationInput"
	},
	TranslationValueCreateInput:{
		id:"UUID",
		catalogue:"TranslationValueCreateCatalogueEntityRelationInput",
		key:"TranslationValueCreateKeyEntityRelationInput"
	},
	TranslationValueUpdateInput:{
		catalogue:"TranslationValueUpdateCatalogueEntityRelationInput",
		key:"TranslationValueUpdateKeyEntityRelationInput"
	},
	ProductGridItemCreateInput:{
		id:"UUID",
		product:"ProductGridItemCreateProductEntityRelationInput",
		medium:"ProductGridItemCreateMediumEntityRelationInput",
		link:"ProductGridItemCreateLinkEntityRelationInput",
		category:"ProductGridItemCreateCategoryEntityRelationInput"
	},
	ProductGridItemCreateCategoryEntityRelationInput:{
		connect:"ProductGridCategoryUniqueWhere",
		create:"ProductGridCategoryWithoutItemsCreateInput"
	},
	ProductGridCategoryWithoutItemsCreateInput:{
		id:"UUID",
		root:"ProductGridCategoryCreateRootEntityRelationInput",
		images:"ProductGridCategoryCreateImagesEntityRelationInput"
	},
	ProductGridCategoryCreateRootEntityRelationInput:{
		connect:"ProductGridUniqueWhere",
		create:"ProductGridWithoutCategoriesCreateInput"
	},
	ProductGridWithoutCategoriesCreateInput:{
		id:"UUID",
		type:"ProductGridType"
	},
	ProductGridItemUpdateInput:{
		product:"ProductGridItemUpdateProductEntityRelationInput",
		medium:"ProductGridItemUpdateMediumEntityRelationInput",
		link:"ProductGridItemUpdateLinkEntityRelationInput",
		category:"ProductGridItemUpdateCategoryEntityRelationInput"
	},
	ProductGridItemUpdateCategoryEntityRelationInput:{
		create:"ProductGridCategoryWithoutItemsCreateInput",
		update:"ProductGridCategoryWithoutItemsUpdateInput",
		upsert:"ProductGridItemUpsertCategoryRelationInput",
		connect:"ProductGridCategoryUniqueWhere"
	},
	ProductGridCategoryWithoutItemsUpdateInput:{
		root:"ProductGridCategoryUpdateRootEntityRelationInput",
		images:"ProductGridCategoryUpdateImagesEntityRelationInput"
	},
	ProductGridCategoryUpdateRootEntityRelationInput:{
		create:"ProductGridWithoutCategoriesCreateInput",
		update:"ProductGridWithoutCategoriesUpdateInput",
		upsert:"ProductGridCategoryUpsertRootRelationInput",
		connect:"ProductGridUniqueWhere"
	},
	ProductGridWithoutCategoriesUpdateInput:{
		type:"ProductGridType"
	},
	ProductGridCategoryUpsertRootRelationInput:{
		update:"ProductGridWithoutCategoriesUpdateInput",
		create:"ProductGridWithoutCategoriesCreateInput"
	},
	ProductGridItemUpsertCategoryRelationInput:{
		update:"ProductGridCategoryWithoutItemsUpdateInput",
		create:"ProductGridCategoryWithoutItemsCreateInput"
	},
	GalleryItemCreateInput:{
		id:"UUID",
		list:"GalleryItemCreateListEntityRelationInput",
		medium:"GalleryItemCreateMediumEntityRelationInput"
	},
	GalleryItemCreateListEntityRelationInput:{
		connect:"GalleryUniqueWhere",
		create:"GalleryWithoutItemsCreateInput"
	},
	GalleryWithoutItemsCreateInput:{
		id:"UUID"
	},
	GalleryItemUpdateInput:{
		list:"GalleryItemUpdateListEntityRelationInput",
		medium:"GalleryItemUpdateMediumEntityRelationInput"
	},
	GalleryItemUpdateListEntityRelationInput:{
		create:"GalleryWithoutItemsCreateInput",
		update:"GalleryWithoutItemsUpdateInput",
		upsert:"GalleryItemUpsertListRelationInput",
		connect:"GalleryUniqueWhere"
	},
	GalleryWithoutItemsUpdateInput:{

	},
	GalleryItemUpsertListRelationInput:{
		update:"GalleryWithoutItemsUpdateInput",
		create:"GalleryWithoutItemsCreateInput"
	},
	SiteMenuCreateInput:{
		id:"UUID",
		unique:"One",
		locales:"SiteMenuCreateLocalesEntityRelationInput"
	},
	SiteMenuCreateLocalesEntityRelationInput:{
		connect:"MenuLocaleUniqueWhere",
		create:"MenuLocaleWithoutRootCreateInput"
	},
	MenuLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"MenuLocaleCreateLocaleEntityRelationInput",
		items:"MenuLocaleCreateItemsEntityRelationInput",
		secondaryItems:"MenuLocaleCreateSecondaryItemsEntityRelationInput",
		eshopLink:"MenuLocaleCreateEshopLinkEntityRelationInput"
	},
	MenuLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutMenusCreateInput"
	},
	LocaleWithoutMenusCreateInput:{
		id:"UUID",
		businessCategories:"LocaleCreateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleCreateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleCreateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleCreateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleCreateBlogsEntityRelationInput",
		blogPosts:"LocaleCreateBlogPostsEntityRelationInput",
		identifier:"LocaleCreateIdentifierEntityRelationInput",
		pages:"LocaleCreatePagesEntityRelationInput",
		productIngredientCategories:"LocaleCreateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleCreateAllergensEntityRelationInput",
		productPackings:"LocaleCreateProductPackingsEntityRelationInput",
		products:"LocaleCreateProductsEntityRelationInput",
		productRecipes:"LocaleCreateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleCreatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleCreatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleCreateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleCreateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleCreateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleCreatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleCreateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleCreateBusinessServicesEntityRelationInput"
	},
	SiteMenuUpdateInput:{
		unique:"One",
		locales:"SiteMenuUpdateLocalesEntityRelationInput"
	},
	SiteMenuUpdateLocalesEntityRelationInput:{
		create:"MenuLocaleWithoutRootCreateInput",
		update:"SiteMenuUpdateLocalesRelationInput",
		upsert:"SiteMenuUpsertLocalesRelationInput",
		connect:"MenuLocaleUniqueWhere",
		disconnect:"MenuLocaleUniqueWhere",
		delete:"MenuLocaleUniqueWhere"
	},
	SiteMenuUpdateLocalesRelationInput:{
		by:"MenuLocaleUniqueWhere",
		data:"MenuLocaleWithoutRootUpdateInput"
	},
	MenuLocaleWithoutRootUpdateInput:{
		locale:"MenuLocaleUpdateLocaleEntityRelationInput",
		items:"MenuLocaleUpdateItemsEntityRelationInput",
		secondaryItems:"MenuLocaleUpdateSecondaryItemsEntityRelationInput",
		eshopLink:"MenuLocaleUpdateEshopLinkEntityRelationInput"
	},
	MenuLocaleUpdateLocaleEntityRelationInput:{
		create:"LocaleWithoutMenusCreateInput",
		update:"LocaleWithoutMenusUpdateInput",
		upsert:"MenuLocaleUpsertLocaleRelationInput",
		connect:"LocaleUniqueWhere"
	},
	LocaleWithoutMenusUpdateInput:{
		businessCategories:"LocaleUpdateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleUpdateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleUpdateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleUpdateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleUpdateBlogsEntityRelationInput",
		blogPosts:"LocaleUpdateBlogPostsEntityRelationInput",
		identifier:"LocaleUpdateIdentifierEntityRelationInput",
		pages:"LocaleUpdatePagesEntityRelationInput",
		productIngredientCategories:"LocaleUpdateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleUpdateAllergensEntityRelationInput",
		productPackings:"LocaleUpdateProductPackingsEntityRelationInput",
		products:"LocaleUpdateProductsEntityRelationInput",
		productRecipes:"LocaleUpdateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleUpdatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleUpdateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleUpdateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleUpdateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleUpdatePipelineStagesEntityRelationInput",
		subscriptionBoxes:"LocaleUpdateSubscriptionBoxesEntityRelationInput",
		businessServices:"LocaleUpdateBusinessServicesEntityRelationInput"
	},
	MenuLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutMenusUpdateInput",
		create:"LocaleWithoutMenusCreateInput"
	},
	SiteMenuUpsertLocalesRelationInput:{
		by:"MenuLocaleUniqueWhere",
		update:"MenuLocaleWithoutRootUpdateInput",
		create:"MenuLocaleWithoutRootCreateInput"
	},
	MenuLocaleCreateInput:{
		id:"UUID",
		root:"MenuLocaleCreateRootEntityRelationInput",
		locale:"MenuLocaleCreateLocaleEntityRelationInput",
		items:"MenuLocaleCreateItemsEntityRelationInput",
		secondaryItems:"MenuLocaleCreateSecondaryItemsEntityRelationInput",
		eshopLink:"MenuLocaleCreateEshopLinkEntityRelationInput"
	},
	MenuLocaleUpdateInput:{
		root:"MenuLocaleUpdateRootEntityRelationInput",
		locale:"MenuLocaleUpdateLocaleEntityRelationInput",
		items:"MenuLocaleUpdateItemsEntityRelationInput",
		secondaryItems:"MenuLocaleUpdateSecondaryItemsEntityRelationInput",
		eshopLink:"MenuLocaleUpdateEshopLinkEntityRelationInput"
	},
	MenuItemCreateInput:{
		id:"UUID",
		menu:"MenuItemCreateMenuEntityRelationInput",
		link:"MenuItemCreateLinkEntityRelationInput",
		subitems:"MenuItemCreateSubitemsEntityRelationInput"
	},
	MenuItemCreateMenuEntityRelationInput:{
		connect:"MenuLocaleUniqueWhere",
		create:"MenuLocaleWithoutItemsCreateInput"
	},
	MenuLocaleWithoutItemsCreateInput:{
		id:"UUID",
		root:"MenuLocaleCreateRootEntityRelationInput",
		locale:"MenuLocaleCreateLocaleEntityRelationInput",
		secondaryItems:"MenuLocaleCreateSecondaryItemsEntityRelationInput",
		eshopLink:"MenuLocaleCreateEshopLinkEntityRelationInput"
	},
	MenuItemUpdateInput:{
		menu:"MenuItemUpdateMenuEntityRelationInput",
		link:"MenuItemUpdateLinkEntityRelationInput",
		subitems:"MenuItemUpdateSubitemsEntityRelationInput"
	},
	MenuItemUpdateMenuEntityRelationInput:{
		create:"MenuLocaleWithoutItemsCreateInput",
		update:"MenuLocaleWithoutItemsUpdateInput",
		upsert:"MenuItemUpsertMenuRelationInput",
		connect:"MenuLocaleUniqueWhere"
	},
	MenuLocaleWithoutItemsUpdateInput:{
		root:"MenuLocaleUpdateRootEntityRelationInput",
		locale:"MenuLocaleUpdateLocaleEntityRelationInput",
		secondaryItems:"MenuLocaleUpdateSecondaryItemsEntityRelationInput",
		eshopLink:"MenuLocaleUpdateEshopLinkEntityRelationInput"
	},
	MenuItemUpsertMenuRelationInput:{
		update:"MenuLocaleWithoutItemsUpdateInput",
		create:"MenuLocaleWithoutItemsCreateInput"
	},
	PageLocaleCreateInput:{
		id:"UUID",
		link:"PageLocaleCreateLinkEntityRelationInput",
		root:"PageLocaleCreateRootEntityRelationInput",
		locale:"PageLocaleCreateLocaleEntityRelationInput",
		seo:"PageLocaleCreateSeoEntityRelationInput",
		content:"PageLocaleCreateContentEntityRelationInput",
		cover:"PageLocaleCreateCoverEntityRelationInput",
		theme:"PageTheme"
	},
	PageLocaleUpdateInput:{
		link:"PageLocaleUpdateLinkEntityRelationInput",
		root:"PageLocaleUpdateRootEntityRelationInput",
		locale:"PageLocaleUpdateLocaleEntityRelationInput",
		seo:"PageLocaleUpdateSeoEntityRelationInput",
		content:"PageLocaleUpdateContentEntityRelationInput",
		cover:"PageLocaleUpdateCoverEntityRelationInput",
		theme:"PageTheme"
	},
	WikiPageCreateInput:{
		id:"UUID",
		link:"WikiPageCreateLinkEntityRelationInput",
		parent:"WikiPageCreateParentEntityRelationInput",
		children:"WikiPageCreateChildrenEntityRelationInput",
		content:"WikiPageCreateContentEntityRelationInput"
	},
	WikiPageUpdateInput:{
		link:"WikiPageUpdateLinkEntityRelationInput",
		parent:"WikiPageUpdateParentEntityRelationInput",
		children:"WikiPageUpdateChildrenEntityRelationInput",
		content:"WikiPageUpdateContentEntityRelationInput"
	},
	MenuSubitemCreateInput:{
		id:"UUID",
		type:"MenuSubitemType",
		item:"MenuSubitemCreateItemEntityRelationInput",
		links:"MenuSubitemCreateLinksEntityRelationInput",
		products:"MenuSubitemCreateProductsEntityRelationInput",
		delivery:"MenuSubitemCreateDeliveryEntityRelationInput",
		contact:"MenuSubitemCreateContactEntityRelationInput"
	},
	MenuSubitemCreateItemEntityRelationInput:{
		connect:"MenuItemUniqueWhere",
		create:"MenuItemWithoutSubitemsCreateInput"
	},
	MenuItemWithoutSubitemsCreateInput:{
		id:"UUID",
		menu:"MenuItemCreateMenuEntityRelationInput",
		link:"MenuItemCreateLinkEntityRelationInput"
	},
	MenuSubitemUpdateInput:{
		type:"MenuSubitemType",
		item:"MenuSubitemUpdateItemEntityRelationInput",
		links:"MenuSubitemUpdateLinksEntityRelationInput",
		products:"MenuSubitemUpdateProductsEntityRelationInput",
		delivery:"MenuSubitemUpdateDeliveryEntityRelationInput",
		contact:"MenuSubitemUpdateContactEntityRelationInput"
	},
	MenuSubitemUpdateItemEntityRelationInput:{
		create:"MenuItemWithoutSubitemsCreateInput",
		update:"MenuItemWithoutSubitemsUpdateInput",
		upsert:"MenuSubitemUpsertItemRelationInput",
		connect:"MenuItemUniqueWhere"
	},
	MenuItemWithoutSubitemsUpdateInput:{
		menu:"MenuItemUpdateMenuEntityRelationInput",
		link:"MenuItemUpdateLinkEntityRelationInput"
	},
	MenuSubitemUpsertItemRelationInput:{
		update:"MenuItemWithoutSubitemsUpdateInput",
		create:"MenuItemWithoutSubitemsCreateInput"
	},
	MenuLinkItemCreateInput:{
		id:"UUID",
		list:"MenuLinkItemCreateListEntityRelationInput",
		link:"MenuLinkItemCreateLinkEntityRelationInput",
		image:"MenuLinkItemCreateImageEntityRelationInput"
	},
	MenuLinkItemCreateListEntityRelationInput:{
		connect:"MenuLinkListUniqueWhere",
		create:"MenuLinkListWithoutItemsCreateInput"
	},
	MenuLinkListWithoutItemsCreateInput:{
		id:"UUID"
	},
	MenuLinkItemUpdateInput:{
		list:"MenuLinkItemUpdateListEntityRelationInput",
		link:"MenuLinkItemUpdateLinkEntityRelationInput",
		image:"MenuLinkItemUpdateImageEntityRelationInput"
	},
	MenuLinkItemUpdateListEntityRelationInput:{
		create:"MenuLinkListWithoutItemsCreateInput",
		update:"MenuLinkListWithoutItemsUpdateInput",
		upsert:"MenuLinkItemUpsertListRelationInput",
		connect:"MenuLinkListUniqueWhere"
	},
	MenuLinkListWithoutItemsUpdateInput:{

	},
	MenuLinkItemUpsertListRelationInput:{
		update:"MenuLinkListWithoutItemsUpdateInput",
		create:"MenuLinkListWithoutItemsCreateInput"
	},
	DeadlineTemplateCreateInput:{
		id:"UUID",
		startDate:"Date",
		venue:"DeadlineTemplateCreateVenueEntityRelationInput"
	},
	DeadlineTemplateCreateVenueEntityRelationInput:{
		connect:"VenueUniqueWhere",
		create:"VenueWithoutDeadlineTemplateCreateInput"
	},
	VenueWithoutDeadlineTemplateCreateInput:{
		id:"UUID",
		timetableDays:"VenueCreateTimetableDaysEntityRelationInput",
		timetableTemplates:"VenueCreateTimetableTemplatesEntityRelationInput",
		staffMembers:"VenueCreateStaffMembersEntityRelationInput",
		employeeRoles:"VenueCreateEmployeeRolesEntityRelationInput",
		pointOfSaleApplicationDevices:"VenueCreatePointOfSaleApplicationDevicesEntityRelationInput",
		pointOfSaleTerminals:"VenueCreatePointOfSaleTerminalsEntityRelationInput",
		pointOfSalePrinters:"VenueCreatePointOfSalePrintersEntityRelationInput",
		orders:"VenueCreateOrdersEntityRelationInput",
		fulfillmentNotes:"VenueCreateFulfillmentNotesEntityRelationInput",
		areas:"VenueCreateAreasEntityRelationInput",
		enabledUnassignReasons:"VenueCreateEnabledUnassignReasonsEntityRelationInput",
		categories:"VenueCreateCategoriesEntityRelationInput",
		channels:"VenueCreateChannelsEntityRelationInput",
		pointOfSaleInitialView:"PointOfSaleInitialView"
	},
	DeadlineTemplateUpdateInput:{
		startDate:"Date",
		venue:"DeadlineTemplateUpdateVenueEntityRelationInput"
	},
	DeadlineTemplateUpdateVenueEntityRelationInput:{
		create:"VenueWithoutDeadlineTemplateCreateInput",
		update:"VenueWithoutDeadlineTemplateUpdateInput",
		upsert:"DeadlineTemplateUpsertVenueRelationInput",
		connect:"VenueUniqueWhere"
	},
	VenueWithoutDeadlineTemplateUpdateInput:{
		timetableDays:"VenueUpdateTimetableDaysEntityRelationInput",
		timetableTemplates:"VenueUpdateTimetableTemplatesEntityRelationInput",
		staffMembers:"VenueUpdateStaffMembersEntityRelationInput",
		employeeRoles:"VenueUpdateEmployeeRolesEntityRelationInput",
		pointOfSaleApplicationDevices:"VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput",
		pointOfSaleTerminals:"VenueUpdatePointOfSaleTerminalsEntityRelationInput",
		pointOfSalePrinters:"VenueUpdatePointOfSalePrintersEntityRelationInput",
		orders:"VenueUpdateOrdersEntityRelationInput",
		fulfillmentNotes:"VenueUpdateFulfillmentNotesEntityRelationInput",
		areas:"VenueUpdateAreasEntityRelationInput",
		enabledUnassignReasons:"VenueUpdateEnabledUnassignReasonsEntityRelationInput",
		categories:"VenueUpdateCategoriesEntityRelationInput",
		channels:"VenueUpdateChannelsEntityRelationInput",
		pointOfSaleInitialView:"PointOfSaleInitialView"
	},
	DeadlineTemplateUpsertVenueRelationInput:{
		update:"VenueWithoutDeadlineTemplateUpdateInput",
		create:"VenueWithoutDeadlineTemplateCreateInput"
	},
	EmployeeQueueCreateInput:{
		id:"UUID",
		shiftGroup:"EmployeeQueueCreateShiftGroupEntityRelationInput",
		items:"EmployeeQueueCreateItemsEntityRelationInput"
	},
	EmployeeQueueUpdateInput:{
		shiftGroup:"EmployeeQueueUpdateShiftGroupEntityRelationInput",
		items:"EmployeeQueueUpdateItemsEntityRelationInput"
	},
	TimetableDayCreateInput:{
		id:"UUID",
		date:"Date",
		type:"TimetableDayType",
		shiftGroups:"TimetableDayCreateShiftGroupsEntityRelationInput",
		notes:"TimetableDayCreateNotesEntityRelationInput",
		venue:"TimetableDayCreateVenueEntityRelationInput",
		meta:"TimetableDayCreateMetaEntityRelationInput"
	},
	TimetableDayUpdateInput:{
		date:"Date",
		type:"TimetableDayType",
		shiftGroups:"TimetableDayUpdateShiftGroupsEntityRelationInput",
		notes:"TimetableDayUpdateNotesEntityRelationInput",
		venue:"TimetableDayUpdateVenueEntityRelationInput",
		meta:"TimetableDayUpdateMetaEntityRelationInput"
	},
	TimetableShiftCreateInput:{
		id:"UUID",
		assigned:"Date",
		group:"TimetableShiftCreateGroupEntityRelationInput",
		shiftsProfile:"TimetableShiftCreateShiftsProfileEntityRelationInput",
		queueItem:"TimetableShiftCreateQueueItemEntityRelationInput",
		swapInfo:"TimetableShiftCreateSwapInfoEntityRelationInput"
	},
	TimetableShiftUpdateInput:{
		assigned:"Date",
		group:"TimetableShiftUpdateGroupEntityRelationInput",
		shiftsProfile:"TimetableShiftUpdateShiftsProfileEntityRelationInput",
		queueItem:"TimetableShiftUpdateQueueItemEntityRelationInput",
		swapInfo:"TimetableShiftUpdateSwapInfoEntityRelationInput"
	},
	TimetableShiftGroupCreateInput:{
		id:"UUID",
		shifts:"TimetableShiftGroupCreateShiftsEntityRelationInput",
		day:"TimetableShiftGroupCreateDayEntityRelationInput",
		type:"TimetableShiftGroupCreateTypeEntityRelationInput",
		position:"TimetableShiftGroupCreatePositionEntityRelationInput",
		queue:"TimetableShiftGroupCreateQueueEntityRelationInput",
		generatedByTemplate:"TimetableShiftGroupCreateGeneratedByTemplateEntityRelationInput"
	},
	TimetableShiftGroupUpdateInput:{
		shifts:"TimetableShiftGroupUpdateShiftsEntityRelationInput",
		day:"TimetableShiftGroupUpdateDayEntityRelationInput",
		type:"TimetableShiftGroupUpdateTypeEntityRelationInput",
		position:"TimetableShiftGroupUpdatePositionEntityRelationInput",
		queue:"TimetableShiftGroupUpdateQueueEntityRelationInput",
		generatedByTemplate:"TimetableShiftGroupUpdateGeneratedByTemplateEntityRelationInput"
	},
	TimetableShiftPositionCreateInput:{
		id:"UUID",
		shiftGroups:"TimetableShiftPositionCreateShiftGroupsEntityRelationInput",
		timetableTemplates:"TimetableShiftPositionCreateTimetableTemplatesEntityRelationInput"
	},
	TimetableShiftPositionUpdateInput:{
		shiftGroups:"TimetableShiftPositionUpdateShiftGroupsEntityRelationInput",
		timetableTemplates:"TimetableShiftPositionUpdateTimetableTemplatesEntityRelationInput"
	},
	CartCreateInput:{
		id:"UUID",
		confirmedAt:"DateTime",
		deletedAt:"DateTime",
		items:"CartCreateItemsEntityRelationInput",
		state:"CartState",
		createdAt:"DateTime",
		channel:"CartCreateChannelEntityRelationInput",
		order:"CartCreateOrderEntityRelationInput",
		customer:"CartCreateCustomerEntityRelationInput",
		deliveryAddress:"CartCreateDeliveryAddressEntityRelationInput",
		billingAddress:"CartCreateBillingAddressEntityRelationInput",
		delivery:"CartCreateDeliveryEntityRelationInput",
		payment:"CartCreatePaymentEntityRelationInput",
		billingSubject:"CartCreateBillingSubjectEntityRelationInput",
		priceLines:"CartCreatePriceLinesEntityRelationInput",
		summary:"CartCreateSummaryEntityRelationInput"
	},
	CartUpdateInput:{
		confirmedAt:"DateTime",
		deletedAt:"DateTime",
		items:"CartUpdateItemsEntityRelationInput",
		state:"CartState",
		createdAt:"DateTime",
		channel:"CartUpdateChannelEntityRelationInput",
		order:"CartUpdateOrderEntityRelationInput",
		customer:"CartUpdateCustomerEntityRelationInput",
		deliveryAddress:"CartUpdateDeliveryAddressEntityRelationInput",
		billingAddress:"CartUpdateBillingAddressEntityRelationInput",
		delivery:"CartUpdateDeliveryEntityRelationInput",
		payment:"CartUpdatePaymentEntityRelationInput",
		billingSubject:"CartUpdateBillingSubjectEntityRelationInput",
		priceLines:"CartUpdatePriceLinesEntityRelationInput",
		summary:"CartUpdateSummaryEntityRelationInput"
	},
	CartItemCreateInput:{
		id:"UUID",
		cart:"CartItemCreateCartEntityRelationInput",
		product:"CartItemCreateProductEntityRelationInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		fulfillmentNotes:"CartItemCreateFulfillmentNotesEntityRelationInput"
	},
	CartItemUpdateInput:{
		cart:"CartItemUpdateCartEntityRelationInput",
		product:"CartItemUpdateProductEntityRelationInput",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		fulfillmentNotes:"CartItemUpdateFulfillmentNotesEntityRelationInput"
	},
	EmployeeQueueItemCreateInput:{
		id:"UUID",
		queue:"EmployeeQueueItemCreateQueueEntityRelationInput",
		shiftsProfile:"EmployeeQueueItemCreateShiftsProfileEntityRelationInput",
		shift:"EmployeeQueueItemCreateShiftEntityRelationInput",
		unassignInfo:"EmployeeQueueItemCreateUnassignInfoEntityRelationInput",
		meta:"EmployeeQueueItemCreateMetaEntityRelationInput"
	},
	EmployeeQueueItemUpdateInput:{
		queue:"EmployeeQueueItemUpdateQueueEntityRelationInput",
		shiftsProfile:"EmployeeQueueItemUpdateShiftsProfileEntityRelationInput",
		shift:"EmployeeQueueItemUpdateShiftEntityRelationInput",
		unassignInfo:"EmployeeQueueItemUpdateUnassignInfoEntityRelationInput",
		meta:"EmployeeQueueItemUpdateMetaEntityRelationInput"
	},
	ApplicationShortcutListCreateInput:{
		id:"UUID",
		items:"ApplicationShortcutListCreateItemsEntityRelationInput",
		customer:"ApplicationShortcutListCreateCustomerEntityRelationInput"
	},
	ApplicationShortcutListCreateCustomerEntityRelationInput:{
		connect:"CustomerUniqueWhere",
		create:"CustomerWithoutShortcutListCreateInput"
	},
	CustomerWithoutShortcutListCreateInput:{
		id:"UUID",
		addresses:"CustomerCreateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerCreateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerCreateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerCreateTagsEntityRelationInput",
		credits:"CustomerCreateCreditsEntityRelationInput",
		paymentMethods:"CustomerCreatePaymentMethodsEntityRelationInput",
		orders:"CustomerCreateOrdersEntityRelationInput",
		permissions:"CustomerCreatePermissionsEntityRelationInput",
		group:"CustomerCreateGroupEntityRelationInput",
		photo:"CustomerCreatePhotoEntityRelationInput",
		name:"CustomerCreateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerCreateIngredientRatingsEntityRelationInput",
		business:"CustomerCreateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerCreateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerCreateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerCreateCartsEntityRelationInput",
		user:"CustomerCreateUserEntityRelationInput",
		channels:"CustomerCreateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerCreateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerCreateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerCreateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerCreateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerCreateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerCreateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerCreateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerCreateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerCreateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerCreateRedeemedVouchersEntityRelationInput",
		spending:"CustomerCreateSpendingEntityRelationInput",
		customerTabs:"CustomerCreateCustomerTabsEntityRelationInput",
		lead:"CustomerCreateLeadEntityRelationInput",
		meta:"CustomerCreateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	ApplicationShortcutListUpdateInput:{
		items:"ApplicationShortcutListUpdateItemsEntityRelationInput",
		customer:"ApplicationShortcutListUpdateCustomerEntityRelationInput"
	},
	ApplicationShortcutListUpdateCustomerEntityRelationInput:{
		create:"CustomerWithoutShortcutListCreateInput",
		update:"CustomerWithoutShortcutListUpdateInput",
		upsert:"ApplicationShortcutListUpsertCustomerRelationInput",
		connect:"CustomerUniqueWhere"
	},
	CustomerWithoutShortcutListUpdateInput:{
		addresses:"CustomerUpdateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerUpdateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerUpdateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerUpdateTagsEntityRelationInput",
		credits:"CustomerUpdateCreditsEntityRelationInput",
		paymentMethods:"CustomerUpdatePaymentMethodsEntityRelationInput",
		orders:"CustomerUpdateOrdersEntityRelationInput",
		permissions:"CustomerUpdatePermissionsEntityRelationInput",
		group:"CustomerUpdateGroupEntityRelationInput",
		photo:"CustomerUpdatePhotoEntityRelationInput",
		name:"CustomerUpdateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerUpdateIngredientRatingsEntityRelationInput",
		business:"CustomerUpdateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerUpdateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerUpdateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerUpdateCartsEntityRelationInput",
		user:"CustomerUpdateUserEntityRelationInput",
		channels:"CustomerUpdateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerUpdateInvoicesEntityRelationInput",
		invoicingPlan:"CustomerUpdateInvoicingPlanEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerUpdateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerUpdateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerUpdateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerUpdateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerUpdateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerUpdateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerUpdateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerUpdateRedeemedVouchersEntityRelationInput",
		spending:"CustomerUpdateSpendingEntityRelationInput",
		customerTabs:"CustomerUpdateCustomerTabsEntityRelationInput",
		lead:"CustomerUpdateLeadEntityRelationInput",
		meta:"CustomerUpdateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	ApplicationShortcutListUpsertCustomerRelationInput:{
		update:"CustomerWithoutShortcutListUpdateInput",
		create:"CustomerWithoutShortcutListCreateInput"
	},
	ApplicationShortcutListItemCreateInput:{
		id:"UUID",
		application:"ApplicationShortcutListItemCreateApplicationEntityRelationInput",
		list:"ApplicationShortcutListItemCreateListEntityRelationInput"
	},
	ApplicationShortcutListItemCreateListEntityRelationInput:{
		connect:"ApplicationShortcutListUniqueWhere",
		create:"ApplicationShortcutListWithoutItemsCreateInput"
	},
	ApplicationShortcutListWithoutItemsCreateInput:{
		id:"UUID",
		customer:"ApplicationShortcutListCreateCustomerEntityRelationInput"
	},
	ApplicationShortcutListItemUpdateInput:{
		application:"ApplicationShortcutListItemUpdateApplicationEntityRelationInput",
		list:"ApplicationShortcutListItemUpdateListEntityRelationInput"
	},
	ApplicationShortcutListItemUpdateListEntityRelationInput:{
		create:"ApplicationShortcutListWithoutItemsCreateInput",
		update:"ApplicationShortcutListWithoutItemsUpdateInput",
		upsert:"ApplicationShortcutListItemUpsertListRelationInput",
		connect:"ApplicationShortcutListUniqueWhere"
	},
	ApplicationShortcutListWithoutItemsUpdateInput:{
		customer:"ApplicationShortcutListUpdateCustomerEntityRelationInput"
	},
	ApplicationShortcutListItemUpsertListRelationInput:{
		update:"ApplicationShortcutListWithoutItemsUpdateInput",
		create:"ApplicationShortcutListWithoutItemsCreateInput"
	},
	ProductBannerItemCreateInput:{
		id:"UUID",
		list:"ProductBannerItemCreateListEntityRelationInput",
		banner:"ProductBannerItemCreateBannerEntityRelationInput",
		size:"ProductBannerItemSize"
	},
	ProductBannerItemCreateListEntityRelationInput:{
		connect:"ProductBannerListUniqueWhere",
		create:"ProductBannerListWithoutItemsCreateInput"
	},
	ProductBannerListWithoutItemsCreateInput:{
		id:"UUID"
	},
	ProductBannerItemUpdateInput:{
		list:"ProductBannerItemUpdateListEntityRelationInput",
		banner:"ProductBannerItemUpdateBannerEntityRelationInput",
		size:"ProductBannerItemSize"
	},
	ProductBannerItemUpdateListEntityRelationInput:{
		create:"ProductBannerListWithoutItemsCreateInput",
		update:"ProductBannerListWithoutItemsUpdateInput",
		upsert:"ProductBannerItemUpsertListRelationInput",
		connect:"ProductBannerListUniqueWhere"
	},
	ProductBannerListWithoutItemsUpdateInput:{

	},
	ProductBannerItemUpsertListRelationInput:{
		update:"ProductBannerListWithoutItemsUpdateInput",
		create:"ProductBannerListWithoutItemsCreateInput"
	},
	BartenderCreateInput:{
		id:"UUID",
		staff:"BartenderCreateStaffEntityRelationInput",
		createdAt:"DateTime"
	},
	BartenderCreateStaffEntityRelationInput:{
		connect:"StaffUniqueWhere",
		create:"StaffWithoutBartenderCreateInput"
	},
	StaffWithoutBartenderCreateInput:{
		id:"UUID",
		courier:"StaffCreateCourierEntityRelationInput",
		cleaner:"StaffCreateCleanerEntityRelationInput",
		shiftsManager:"StaffCreateShiftsManagerEntityRelationInput",
		businessToBusinessManager:"StaffCreateBusinessToBusinessManagerEntityRelationInput",
		user:"StaffCreateUserEntityRelationInput",
		shiftsProfile:"StaffCreateShiftsProfileEntityRelationInput",
		stocksManager:"StaffCreateStocksManagerEntityRelationInput",
		photo:"StaffCreatePhotoEntityRelationInput",
		courierManager:"StaffCreateCourierManagerEntityRelationInput",
		picker:"StaffCreatePickerEntityRelationInput",
		createdAt:"DateTime",
		remunerationProfile:"StaffCreateRemunerationProfileEntityRelationInput",
		cashier:"StaffCreateCashierEntityRelationInput",
		venues:"StaffCreateVenuesEntityRelationInput",
		internalBuyer:"StaffCreateInternalBuyerEntityRelationInput",
		salesManager:"StaffCreateSalesManagerEntityRelationInput",
		cashierManager:"StaffCreateCashierManagerEntityRelationInput"
	},
	BartenderUpdateInput:{
		staff:"BartenderUpdateStaffEntityRelationInput",
		createdAt:"DateTime"
	},
	BartenderUpdateStaffEntityRelationInput:{
		create:"StaffWithoutBartenderCreateInput",
		update:"StaffWithoutBartenderUpdateInput",
		upsert:"BartenderUpsertStaffRelationInput",
		connect:"StaffUniqueWhere"
	},
	StaffWithoutBartenderUpdateInput:{
		courier:"StaffUpdateCourierEntityRelationInput",
		cleaner:"StaffUpdateCleanerEntityRelationInput",
		shiftsManager:"StaffUpdateShiftsManagerEntityRelationInput",
		businessToBusinessManager:"StaffUpdateBusinessToBusinessManagerEntityRelationInput",
		user:"StaffUpdateUserEntityRelationInput",
		shiftsProfile:"StaffUpdateShiftsProfileEntityRelationInput",
		stocksManager:"StaffUpdateStocksManagerEntityRelationInput",
		photo:"StaffUpdatePhotoEntityRelationInput",
		courierManager:"StaffUpdateCourierManagerEntityRelationInput",
		picker:"StaffUpdatePickerEntityRelationInput",
		createdAt:"DateTime",
		remunerationProfile:"StaffUpdateRemunerationProfileEntityRelationInput",
		cashier:"StaffUpdateCashierEntityRelationInput",
		venues:"StaffUpdateVenuesEntityRelationInput",
		internalBuyer:"StaffUpdateInternalBuyerEntityRelationInput",
		salesManager:"StaffUpdateSalesManagerEntityRelationInput",
		cashierManager:"StaffUpdateCashierManagerEntityRelationInput"
	},
	BartenderUpsertStaffRelationInput:{
		update:"StaffWithoutBartenderUpdateInput",
		create:"StaffWithoutBartenderCreateInput"
	},
	BusinessToBusinessManagerCreateInput:{
		id:"UUID",
		staff:"BusinessToBusinessManagerCreateStaffEntityRelationInput",
		managedBusinesses:"BusinessToBusinessManagerCreateManagedBusinessesEntityRelationInput",
		createdAt:"DateTime"
	},
	BusinessToBusinessManagerUpdateInput:{
		staff:"BusinessToBusinessManagerUpdateStaffEntityRelationInput",
		managedBusinesses:"BusinessToBusinessManagerUpdateManagedBusinessesEntityRelationInput",
		createdAt:"DateTime"
	},
	CleanerCreateInput:{
		id:"UUID",
		staff:"CleanerCreateStaffEntityRelationInput",
		createdAt:"DateTime"
	},
	CleanerCreateStaffEntityRelationInput:{
		connect:"StaffUniqueWhere",
		create:"StaffWithoutCleanerCreateInput"
	},
	StaffWithoutCleanerCreateInput:{
		id:"UUID",
		bartender:"StaffCreateBartenderEntityRelationInput",
		courier:"StaffCreateCourierEntityRelationInput",
		shiftsManager:"StaffCreateShiftsManagerEntityRelationInput",
		businessToBusinessManager:"StaffCreateBusinessToBusinessManagerEntityRelationInput",
		user:"StaffCreateUserEntityRelationInput",
		shiftsProfile:"StaffCreateShiftsProfileEntityRelationInput",
		stocksManager:"StaffCreateStocksManagerEntityRelationInput",
		photo:"StaffCreatePhotoEntityRelationInput",
		courierManager:"StaffCreateCourierManagerEntityRelationInput",
		picker:"StaffCreatePickerEntityRelationInput",
		createdAt:"DateTime",
		remunerationProfile:"StaffCreateRemunerationProfileEntityRelationInput",
		cashier:"StaffCreateCashierEntityRelationInput",
		venues:"StaffCreateVenuesEntityRelationInput",
		internalBuyer:"StaffCreateInternalBuyerEntityRelationInput",
		salesManager:"StaffCreateSalesManagerEntityRelationInput",
		cashierManager:"StaffCreateCashierManagerEntityRelationInput"
	},
	CleanerUpdateInput:{
		staff:"CleanerUpdateStaffEntityRelationInput",
		createdAt:"DateTime"
	},
	CleanerUpdateStaffEntityRelationInput:{
		create:"StaffWithoutCleanerCreateInput",
		update:"StaffWithoutCleanerUpdateInput",
		upsert:"CleanerUpsertStaffRelationInput",
		connect:"StaffUniqueWhere"
	},
	StaffWithoutCleanerUpdateInput:{
		bartender:"StaffUpdateBartenderEntityRelationInput",
		courier:"StaffUpdateCourierEntityRelationInput",
		shiftsManager:"StaffUpdateShiftsManagerEntityRelationInput",
		businessToBusinessManager:"StaffUpdateBusinessToBusinessManagerEntityRelationInput",
		user:"StaffUpdateUserEntityRelationInput",
		shiftsProfile:"StaffUpdateShiftsProfileEntityRelationInput",
		stocksManager:"StaffUpdateStocksManagerEntityRelationInput",
		photo:"StaffUpdatePhotoEntityRelationInput",
		courierManager:"StaffUpdateCourierManagerEntityRelationInput",
		picker:"StaffUpdatePickerEntityRelationInput",
		createdAt:"DateTime",
		remunerationProfile:"StaffUpdateRemunerationProfileEntityRelationInput",
		cashier:"StaffUpdateCashierEntityRelationInput",
		venues:"StaffUpdateVenuesEntityRelationInput",
		internalBuyer:"StaffUpdateInternalBuyerEntityRelationInput",
		salesManager:"StaffUpdateSalesManagerEntityRelationInput",
		cashierManager:"StaffUpdateCashierManagerEntityRelationInput"
	},
	CleanerUpsertStaffRelationInput:{
		update:"StaffWithoutCleanerUpdateInput",
		create:"StaffWithoutCleanerCreateInput"
	},
	CourierCreateInput:{
		id:"UUID",
		staff:"CourierCreateStaffEntityRelationInput",
		routes:"CourierCreateRoutesEntityRelationInput",
		createdAt:"DateTime",
		deliveryMethods:"CourierCreateDeliveryMethodsEntityRelationInput"
	},
	CourierUpdateInput:{
		staff:"CourierUpdateStaffEntityRelationInput",
		routes:"CourierUpdateRoutesEntityRelationInput",
		createdAt:"DateTime",
		deliveryMethods:"CourierUpdateDeliveryMethodsEntityRelationInput"
	},
	ShiftsManagerCreateInput:{
		id:"UUID",
		staff:"ShiftsManagerCreateStaffEntityRelationInput",
		managedRoles:"ShiftsManagerCreateManagedRolesEntityRelationInput",
		createdAt:"DateTime"
	},
	ShiftsManagerUpdateInput:{
		staff:"ShiftsManagerUpdateStaffEntityRelationInput",
		managedRoles:"ShiftsManagerUpdateManagedRolesEntityRelationInput",
		createdAt:"DateTime"
	},
	ProductIngredientCategoryCreateInput:{
		id:"UUID",
		ingredients:"ProductIngredientCategoryCreateIngredientsEntityRelationInput",
		locales:"ProductIngredientCategoryCreateLocalesEntityRelationInput"
	},
	ProductIngredientCategoryUpdateInput:{
		ingredients:"ProductIngredientCategoryUpdateIngredientsEntityRelationInput",
		locales:"ProductIngredientCategoryUpdateLocalesEntityRelationInput"
	},
	ProductIngredientCategoryLocaleCreateInput:{
		id:"UUID",
		root:"ProductIngredientCategoryLocaleCreateRootEntityRelationInput",
		locale:"ProductIngredientCategoryLocaleCreateLocaleEntityRelationInput"
	},
	ProductIngredientCategoryLocaleUpdateInput:{
		root:"ProductIngredientCategoryLocaleUpdateRootEntityRelationInput",
		locale:"ProductIngredientCategoryLocaleUpdateLocaleEntityRelationInput"
	},
	StocksManagerCreateInput:{
		id:"UUID",
		staff:"StocksManagerCreateStaffEntityRelationInput",
		managedProducts:"StocksManagerCreateManagedProductsEntityRelationInput",
		createdAt:"DateTime"
	},
	StocksManagerUpdateInput:{
		staff:"StocksManagerUpdateStaffEntityRelationInput",
		managedProducts:"StocksManagerUpdateManagedProductsEntityRelationInput",
		createdAt:"DateTime"
	},
	DeliveryRouteCreateInput:{
		id:"UUID",
		courier:"DeliveryRouteCreateCourierEntityRelationInput",
		createdAt:"DateTime",
		waypoints:"DeliveryRouteCreateWaypointsEntityRelationInput"
	},
	DeliveryRouteUpdateInput:{
		courier:"DeliveryRouteUpdateCourierEntityRelationInput",
		createdAt:"DateTime",
		waypoints:"DeliveryRouteUpdateWaypointsEntityRelationInput"
	},
	DeliveryWaypointCreateInput:{
		id:"UUID",
		estimatedArrival:"DateTime",
		route:"DeliveryWaypointCreateRouteEntityRelationInput",
		delivery:"DeliveryWaypointCreateDeliveryEntityRelationInput",
		originDeparture:"DateTime"
	},
	DeliveryWaypointUpdateInput:{
		estimatedArrival:"DateTime",
		route:"DeliveryWaypointUpdateRouteEntityRelationInput",
		delivery:"DeliveryWaypointUpdateDeliveryEntityRelationInput",
		originDeparture:"DateTime"
	},
	AllergenCreateInput:{
		id:"UUID",
		locales:"AllergenCreateLocalesEntityRelationInput",
		ingredients:"AllergenCreateIngredientsEntityRelationInput"
	},
	AllergenUpdateInput:{
		locales:"AllergenUpdateLocalesEntityRelationInput",
		ingredients:"AllergenUpdateIngredientsEntityRelationInput"
	},
	AllergenLocaleCreateInput:{
		id:"UUID",
		root:"AllergenLocaleCreateRootEntityRelationInput",
		locale:"AllergenLocaleCreateLocaleEntityRelationInput"
	},
	AllergenLocaleUpdateInput:{
		root:"AllergenLocaleUpdateRootEntityRelationInput",
		locale:"AllergenLocaleUpdateLocaleEntityRelationInput"
	},
	GpsCreateInput:{
		id:"UUID",
		address:"GpsCreateAddressEntityRelationInput"
	},
	GpsCreateAddressEntityRelationInput:{
		connect:"AddressUniqueWhere",
		create:"AddressWithoutGpsCreateInput"
	},
	AddressWithoutGpsCreateInput:{
		id:"UUID",
		customer:"AddressCreateCustomerEntityRelationInput",
		country:"AddressCreateCountryEntityRelationInput",
		deletedAt:"DateTime",
		geocodeGeneratedAt:"DateTime",
		deliveryZone:"AddressCreateDeliveryZoneEntityRelationInput",
		meta:"AddressCreateMetaEntityRelationInput",
		invoices:"AddressCreateInvoicesEntityRelationInput",
		createdAt:"DateTime",
		billingAddressOfOrders:"AddressCreateBillingAddressOfOrdersEntityRelationInput",
		deliveryAddressOfOrderDeliveries:"AddressCreateDeliveryAddressOfOrderDeliveriesEntityRelationInput",
		defaultDeliveryAddressOfCustomer:"AddressCreateDefaultDeliveryAddressOfCustomerEntityRelationInput"
	},
	GpsUpdateInput:{
		address:"GpsUpdateAddressEntityRelationInput"
	},
	GpsUpdateAddressEntityRelationInput:{
		create:"AddressWithoutGpsCreateInput",
		update:"AddressWithoutGpsUpdateInput",
		upsert:"GpsUpsertAddressRelationInput",
		connect:"AddressUniqueWhere"
	},
	AddressWithoutGpsUpdateInput:{
		customer:"AddressUpdateCustomerEntityRelationInput",
		country:"AddressUpdateCountryEntityRelationInput",
		deletedAt:"DateTime",
		geocodeGeneratedAt:"DateTime",
		deliveryZone:"AddressUpdateDeliveryZoneEntityRelationInput",
		meta:"AddressUpdateMetaEntityRelationInput",
		invoices:"AddressUpdateInvoicesEntityRelationInput",
		createdAt:"DateTime",
		billingAddressOfOrders:"AddressUpdateBillingAddressOfOrdersEntityRelationInput",
		deliveryAddressOfOrderDeliveries:"AddressUpdateDeliveryAddressOfOrderDeliveriesEntityRelationInput",
		defaultDeliveryAddressOfCustomer:"AddressUpdateDefaultDeliveryAddressOfCustomerEntityRelationInput"
	},
	GpsUpsertAddressRelationInput:{
		update:"AddressWithoutGpsUpdateInput",
		create:"AddressWithoutGpsCreateInput"
	},
	PreparedIngredientQuantity:{
		ingredient:{
			filter:"ProductIngredientWhere"
		},
		unit:{
			filter:"ProductIngredientItemQuantityUnitWhere"
		}
	},
	PreparedIngredientQuantityUniqueWhere:{
		id:"UUID",
		date:"Date",
		ingredient:"ProductIngredientUniqueWhere",
		unit:"ProductIngredientItemQuantityUnitUniqueWhere"
	},
	PreparedIngredientQuantityWhere:{
		id:"UUIDCondition",
		date:"DateCondition",
		quantity:"FloatCondition",
		usedQuantity:"FloatCondition",
		ingredient:"ProductIngredientWhere",
		unit:"ProductIngredientItemQuantityUnitWhere",
		and:"PreparedIngredientQuantityWhere",
		or:"PreparedIngredientQuantityWhere",
		not:"PreparedIngredientQuantityWhere"
	},
	PreparedIngredientQuantityOrderBy:{
		id:"OrderDirection",
		date:"OrderDirection",
		quantity:"OrderDirection",
		usedQuantity:"OrderDirection",
		ingredient:"ProductIngredientOrderBy",
		unit:"ProductIngredientItemQuantityUnitOrderBy"
	},
	PreparedIngredientQuantityCreateInput:{
		id:"UUID",
		date:"Date",
		ingredient:"PreparedIngredientQuantityCreateIngredientEntityRelationInput",
		unit:"PreparedIngredientQuantityCreateUnitEntityRelationInput"
	},
	PreparedIngredientQuantityCreateIngredientEntityRelationInput:{
		connect:"ProductIngredientUniqueWhere",
		create:"ProductIngredientCreateInput"
	},
	PreparedIngredientQuantityCreateUnitEntityRelationInput:{
		connect:"ProductIngredientItemQuantityUnitUniqueWhere",
		create:"ProductIngredientItemQuantityUnitCreateInput"
	},
	PreparedIngredientQuantityUpdateInput:{
		date:"Date",
		ingredient:"PreparedIngredientQuantityUpdateIngredientEntityRelationInput",
		unit:"PreparedIngredientQuantityUpdateUnitEntityRelationInput"
	},
	PreparedIngredientQuantityUpdateIngredientEntityRelationInput:{
		create:"ProductIngredientCreateInput",
		update:"ProductIngredientUpdateInput",
		upsert:"PreparedIngredientQuantityUpsertIngredientRelationInput",
		connect:"ProductIngredientUniqueWhere"
	},
	PreparedIngredientQuantityUpsertIngredientRelationInput:{
		update:"ProductIngredientUpdateInput",
		create:"ProductIngredientCreateInput"
	},
	PreparedIngredientQuantityUpdateUnitEntityRelationInput:{
		create:"ProductIngredientItemQuantityUnitCreateInput",
		update:"ProductIngredientItemQuantityUnitUpdateInput",
		upsert:"PreparedIngredientQuantityUpsertUnitRelationInput",
		connect:"ProductIngredientItemQuantityUnitUniqueWhere"
	},
	PreparedIngredientQuantityUpsertUnitRelationInput:{
		update:"ProductIngredientItemQuantityUnitUpdateInput",
		create:"ProductIngredientItemQuantityUnitCreateInput"
	},
	PreparedRecipeQuantity:{
		recipe:{
			filter:"ProductRecipeWhere"
		}
	},
	PreparedRecipeQuantityUniqueWhere:{
		id:"UUID",
		date:"Date",
		recipe:"ProductRecipeUniqueWhere"
	},
	PreparedRecipeQuantityWhere:{
		id:"UUIDCondition",
		date:"DateCondition",
		quantity:"FloatCondition",
		recipe:"ProductRecipeWhere",
		usedQuantity:"FloatCondition",
		and:"PreparedRecipeQuantityWhere",
		or:"PreparedRecipeQuantityWhere",
		not:"PreparedRecipeQuantityWhere"
	},
	PreparedRecipeQuantityOrderBy:{
		id:"OrderDirection",
		date:"OrderDirection",
		quantity:"OrderDirection",
		recipe:"ProductRecipeOrderBy",
		usedQuantity:"OrderDirection"
	},
	PreparedRecipeQuantityCreateInput:{
		id:"UUID",
		date:"Date",
		recipe:"PreparedRecipeQuantityCreateRecipeEntityRelationInput"
	},
	PreparedRecipeQuantityCreateRecipeEntityRelationInput:{
		connect:"ProductRecipeUniqueWhere",
		create:"ProductRecipeCreateInput"
	},
	PreparedRecipeQuantityUpdateInput:{
		date:"Date",
		recipe:"PreparedRecipeQuantityUpdateRecipeEntityRelationInput"
	},
	PreparedRecipeQuantityUpdateRecipeEntityRelationInput:{
		create:"ProductRecipeCreateInput",
		update:"ProductRecipeUpdateInput",
		upsert:"PreparedRecipeQuantityUpsertRecipeRelationInput",
		connect:"ProductRecipeUniqueWhere"
	},
	PreparedRecipeQuantityUpsertRecipeRelationInput:{
		update:"ProductRecipeUpdateInput",
		create:"ProductRecipeCreateInput"
	},
	InternalOrder:{
		items:{
			filter:"InternalOrderItemWhere",
			orderBy:"InternalOrderItemOrderBy"
		},
		paginateItems:{
			filter:"InternalOrderItemWhere",
			orderBy:"InternalOrderItemOrderBy"
		}
	},
	InternalOrderState: true,
	InternalOrderItem:{
		internalOrder:{
			filter:"InternalOrderWhere"
		},
		product:{
			filter:"ProductWhere"
		}
	},
	InternalOrderWhere:{
		id:"UUIDCondition",
		state:"InternalOrderStateCondition",
		fulfilledAt:"DateTimeCondition",
		canceledAt:"DateTimeCondition",
		targetPlace:"StringCondition",
		note:"StringCondition",
		internalNote:"StringCondition",
		items:"InternalOrderItemWhere",
		createdAt:"DateTimeCondition",
		and:"InternalOrderWhere",
		or:"InternalOrderWhere",
		not:"InternalOrderWhere"
	},
	InternalOrderStateCondition:{
		and:"InternalOrderStateCondition",
		or:"InternalOrderStateCondition",
		not:"InternalOrderStateCondition",
		eq:"InternalOrderState",
		notEq:"InternalOrderState",
		in:"InternalOrderState",
		notIn:"InternalOrderState",
		lt:"InternalOrderState",
		lte:"InternalOrderState",
		gt:"InternalOrderState",
		gte:"InternalOrderState"
	},
	InternalOrderItemWhere:{
		id:"UUIDCondition",
		quantity:"IntCondition",
		internalOrder:"InternalOrderWhere",
		product:"ProductWhere",
		and:"InternalOrderItemWhere",
		or:"InternalOrderItemWhere",
		not:"InternalOrderItemWhere"
	},
	InternalOrderItemOrderBy:{
		id:"OrderDirection",
		quantity:"OrderDirection",
		internalOrder:"InternalOrderOrderBy",
		product:"ProductOrderBy"
	},
	InternalOrderOrderBy:{
		id:"OrderDirection",
		state:"OrderDirection",
		fulfilledAt:"OrderDirection",
		canceledAt:"OrderDirection",
		targetPlace:"OrderDirection",
		note:"OrderDirection",
		internalNote:"OrderDirection",
		createdAt:"OrderDirection"
	},
	InternalOrderUniqueWhere:{
		id:"UUID",
		items:"InternalOrderItemUniqueWhere"
	},
	InternalOrderItemUniqueWhere:{
		id:"UUID"
	},
	InternalOrderCreateInput:{
		id:"UUID",
		state:"InternalOrderState",
		fulfilledAt:"DateTime",
		canceledAt:"DateTime",
		items:"InternalOrderCreateItemsEntityRelationInput",
		createdAt:"DateTime"
	},
	InternalOrderCreateItemsEntityRelationInput:{
		connect:"InternalOrderItemUniqueWhere",
		create:"InternalOrderItemWithoutInternalOrderCreateInput"
	},
	InternalOrderItemWithoutInternalOrderCreateInput:{
		id:"UUID",
		product:"InternalOrderItemCreateProductEntityRelationInput"
	},
	InternalOrderItemCreateProductEntityRelationInput:{
		connect:"ProductUniqueWhere",
		create:"ProductCreateInput"
	},
	InternalOrderUpdateInput:{
		state:"InternalOrderState",
		fulfilledAt:"DateTime",
		canceledAt:"DateTime",
		items:"InternalOrderUpdateItemsEntityRelationInput",
		createdAt:"DateTime"
	},
	InternalOrderUpdateItemsEntityRelationInput:{
		create:"InternalOrderItemWithoutInternalOrderCreateInput",
		update:"InternalOrderUpdateItemsRelationInput",
		upsert:"InternalOrderUpsertItemsRelationInput",
		connect:"InternalOrderItemUniqueWhere",
		disconnect:"InternalOrderItemUniqueWhere",
		delete:"InternalOrderItemUniqueWhere"
	},
	InternalOrderUpdateItemsRelationInput:{
		by:"InternalOrderItemUniqueWhere",
		data:"InternalOrderItemWithoutInternalOrderUpdateInput"
	},
	InternalOrderItemWithoutInternalOrderUpdateInput:{
		product:"InternalOrderItemUpdateProductEntityRelationInput"
	},
	InternalOrderItemUpdateProductEntityRelationInput:{
		create:"ProductCreateInput",
		update:"ProductUpdateInput",
		upsert:"InternalOrderItemUpsertProductRelationInput",
		connect:"ProductUniqueWhere"
	},
	InternalOrderItemUpsertProductRelationInput:{
		update:"ProductUpdateInput",
		create:"ProductCreateInput"
	},
	InternalOrderUpsertItemsRelationInput:{
		by:"InternalOrderItemUniqueWhere",
		update:"InternalOrderItemWithoutInternalOrderUpdateInput",
		create:"InternalOrderItemWithoutInternalOrderCreateInput"
	},
	InternalOrderItemCreateInput:{
		id:"UUID",
		internalOrder:"InternalOrderItemCreateInternalOrderEntityRelationInput",
		product:"InternalOrderItemCreateProductEntityRelationInput"
	},
	InternalOrderItemCreateInternalOrderEntityRelationInput:{
		connect:"InternalOrderUniqueWhere",
		create:"InternalOrderWithoutItemsCreateInput"
	},
	InternalOrderWithoutItemsCreateInput:{
		id:"UUID",
		state:"InternalOrderState",
		fulfilledAt:"DateTime",
		canceledAt:"DateTime",
		createdAt:"DateTime"
	},
	InternalOrderItemUpdateInput:{
		internalOrder:"InternalOrderItemUpdateInternalOrderEntityRelationInput",
		product:"InternalOrderItemUpdateProductEntityRelationInput"
	},
	InternalOrderItemUpdateInternalOrderEntityRelationInput:{
		create:"InternalOrderWithoutItemsCreateInput",
		update:"InternalOrderWithoutItemsUpdateInput",
		upsert:"InternalOrderItemUpsertInternalOrderRelationInput",
		connect:"InternalOrderUniqueWhere"
	},
	InternalOrderWithoutItemsUpdateInput:{
		state:"InternalOrderState",
		fulfilledAt:"DateTime",
		canceledAt:"DateTime",
		createdAt:"DateTime"
	},
	InternalOrderItemUpsertInternalOrderRelationInput:{
		update:"InternalOrderWithoutItemsUpdateInput",
		create:"InternalOrderWithoutItemsCreateInput"
	},
	PreparedPackingQuantityCreateInput:{
		id:"UUID",
		date:"Date",
		recipe:"PreparedPackingQuantityCreateRecipeEntityRelationInput",
		packing:"PreparedPackingQuantityCreatePackingEntityRelationInput"
	},
	PreparedPackingQuantityCreatePackingEntityRelationInput:{
		connect:"ProductPackingUniqueWhere",
		create:"ProductPackingWithoutPreparedPackingQuantitiesCreateInput"
	},
	ProductPackingWithoutPreparedPackingQuantitiesCreateInput:{
		id:"UUID",
		image:"ProductPackingCreateImageEntityRelationInput",
		icon:"ProductPackingCreateIconEntityRelationInput",
		locales:"ProductPackingCreateLocalesEntityRelationInput"
	},
	PreparedPackingQuantityUpdateInput:{
		date:"Date",
		recipe:"PreparedPackingQuantityUpdateRecipeEntityRelationInput",
		packing:"PreparedPackingQuantityUpdatePackingEntityRelationInput"
	},
	PreparedPackingQuantityUpdatePackingEntityRelationInput:{
		create:"ProductPackingWithoutPreparedPackingQuantitiesCreateInput",
		update:"ProductPackingWithoutPreparedPackingQuantitiesUpdateInput",
		upsert:"PreparedPackingQuantityUpsertPackingRelationInput",
		connect:"ProductPackingUniqueWhere"
	},
	ProductPackingWithoutPreparedPackingQuantitiesUpdateInput:{
		image:"ProductPackingUpdateImageEntityRelationInput",
		icon:"ProductPackingUpdateIconEntityRelationInput",
		locales:"ProductPackingUpdateLocalesEntityRelationInput"
	},
	PreparedPackingQuantityUpsertPackingRelationInput:{
		update:"ProductPackingWithoutPreparedPackingQuantitiesUpdateInput",
		create:"ProductPackingWithoutPreparedPackingQuantitiesCreateInput"
	},
	CourierManagerCreateInput:{
		id:"UUID",
		staff:"CourierManagerCreateStaffEntityRelationInput",
		createdAt:"DateTime"
	},
	CourierManagerCreateStaffEntityRelationInput:{
		connect:"StaffUniqueWhere",
		create:"StaffWithoutCourierManagerCreateInput"
	},
	StaffWithoutCourierManagerCreateInput:{
		id:"UUID",
		bartender:"StaffCreateBartenderEntityRelationInput",
		courier:"StaffCreateCourierEntityRelationInput",
		cleaner:"StaffCreateCleanerEntityRelationInput",
		shiftsManager:"StaffCreateShiftsManagerEntityRelationInput",
		businessToBusinessManager:"StaffCreateBusinessToBusinessManagerEntityRelationInput",
		user:"StaffCreateUserEntityRelationInput",
		shiftsProfile:"StaffCreateShiftsProfileEntityRelationInput",
		stocksManager:"StaffCreateStocksManagerEntityRelationInput",
		photo:"StaffCreatePhotoEntityRelationInput",
		picker:"StaffCreatePickerEntityRelationInput",
		createdAt:"DateTime",
		remunerationProfile:"StaffCreateRemunerationProfileEntityRelationInput",
		cashier:"StaffCreateCashierEntityRelationInput",
		venues:"StaffCreateVenuesEntityRelationInput",
		internalBuyer:"StaffCreateInternalBuyerEntityRelationInput",
		salesManager:"StaffCreateSalesManagerEntityRelationInput",
		cashierManager:"StaffCreateCashierManagerEntityRelationInput"
	},
	CourierManagerUpdateInput:{
		staff:"CourierManagerUpdateStaffEntityRelationInput",
		createdAt:"DateTime"
	},
	CourierManagerUpdateStaffEntityRelationInput:{
		create:"StaffWithoutCourierManagerCreateInput",
		update:"StaffWithoutCourierManagerUpdateInput",
		upsert:"CourierManagerUpsertStaffRelationInput",
		connect:"StaffUniqueWhere"
	},
	StaffWithoutCourierManagerUpdateInput:{
		bartender:"StaffUpdateBartenderEntityRelationInput",
		courier:"StaffUpdateCourierEntityRelationInput",
		cleaner:"StaffUpdateCleanerEntityRelationInput",
		shiftsManager:"StaffUpdateShiftsManagerEntityRelationInput",
		businessToBusinessManager:"StaffUpdateBusinessToBusinessManagerEntityRelationInput",
		user:"StaffUpdateUserEntityRelationInput",
		shiftsProfile:"StaffUpdateShiftsProfileEntityRelationInput",
		stocksManager:"StaffUpdateStocksManagerEntityRelationInput",
		photo:"StaffUpdatePhotoEntityRelationInput",
		picker:"StaffUpdatePickerEntityRelationInput",
		createdAt:"DateTime",
		remunerationProfile:"StaffUpdateRemunerationProfileEntityRelationInput",
		cashier:"StaffUpdateCashierEntityRelationInput",
		venues:"StaffUpdateVenuesEntityRelationInput",
		internalBuyer:"StaffUpdateInternalBuyerEntityRelationInput",
		salesManager:"StaffUpdateSalesManagerEntityRelationInput",
		cashierManager:"StaffUpdateCashierManagerEntityRelationInput"
	},
	CourierManagerUpsertStaffRelationInput:{
		update:"StaffWithoutCourierManagerUpdateInput",
		create:"StaffWithoutCourierManagerCreateInput"
	},
	DeliveryZoneCreateInput:{
		id:"UUID",
		type:"DeliveryZoneType",
		addresses:"DeliveryZoneCreateAddressesEntityRelationInput",
		suitableDeliveryMethods:"DeliveryZoneCreateSuitableDeliveryMethodsEntityRelationInput",
		deliveryZonesOfTags:"DeliveryZoneCreateDeliveryZonesOfTagsEntityRelationInput",
		deliveryZonesOfProducts:"DeliveryZoneCreateDeliveryZonesOfProductsEntityRelationInput",
		addressesMetadata:"DeliveryZoneCreateAddressesMetadataEntityRelationInput"
	},
	DeliveryZoneUpdateInput:{
		type:"DeliveryZoneType",
		addresses:"DeliveryZoneUpdateAddressesEntityRelationInput",
		suitableDeliveryMethods:"DeliveryZoneUpdateSuitableDeliveryMethodsEntityRelationInput",
		deliveryZonesOfTags:"DeliveryZoneUpdateDeliveryZonesOfTagsEntityRelationInput",
		deliveryZonesOfProducts:"DeliveryZoneUpdateDeliveryZonesOfProductsEntityRelationInput",
		addressesMetadata:"DeliveryZoneUpdateAddressesMetadataEntityRelationInput"
	},
	DeliveryTimelinePresetCreateInput:{
		id:"UUID",
		type:"DeliveryTimelineType",
		deliveryMethod:"DeliveryTimelinePresetCreateDeliveryMethodEntityRelationInput"
	},
	DeliveryTimelinePresetCreateDeliveryMethodEntityRelationInput:{
		connect:"DeliveryMethodUniqueWhere",
		create:"DeliveryMethodWithoutTimelinePresetCreateInput"
	},
	DeliveryMethodWithoutTimelinePresetCreateInput:{
		id:"UUID",
		paymentMethods:"DeliveryMethodCreatePaymentMethodsEntityRelationInput",
		suitableForDeliveryZones:"DeliveryMethodCreateSuitableForDeliveryZonesEntityRelationInput",
		channels:"DeliveryMethodCreateChannelsEntityRelationInput",
		courierHandlers:"DeliveryMethodCreateCourierHandlersEntityRelationInput",
		locales:"DeliveryMethodCreateLocalesEntityRelationInput"
	},
	DeliveryTimelinePresetUpdateInput:{
		type:"DeliveryTimelineType",
		deliveryMethod:"DeliveryTimelinePresetUpdateDeliveryMethodEntityRelationInput"
	},
	DeliveryTimelinePresetUpdateDeliveryMethodEntityRelationInput:{
		create:"DeliveryMethodWithoutTimelinePresetCreateInput",
		update:"DeliveryMethodWithoutTimelinePresetUpdateInput",
		upsert:"DeliveryTimelinePresetUpsertDeliveryMethodRelationInput",
		connect:"DeliveryMethodUniqueWhere"
	},
	DeliveryMethodWithoutTimelinePresetUpdateInput:{
		paymentMethods:"DeliveryMethodUpdatePaymentMethodsEntityRelationInput",
		suitableForDeliveryZones:"DeliveryMethodUpdateSuitableForDeliveryZonesEntityRelationInput",
		channels:"DeliveryMethodUpdateChannelsEntityRelationInput",
		courierHandlers:"DeliveryMethodUpdateCourierHandlersEntityRelationInput",
		locales:"DeliveryMethodUpdateLocalesEntityRelationInput"
	},
	DeliveryTimelinePresetUpsertDeliveryMethodRelationInput:{
		update:"DeliveryMethodWithoutTimelinePresetUpdateInput",
		create:"DeliveryMethodWithoutTimelinePresetCreateInput"
	},
	OrderDeliveryTimelineUniqueWhere:{
		id:"UUID"
	},
	OrderDeliveryTimelineWhere:{
		id:"UUIDCondition",
		type:"DeliveryTimelineTypeCondition",
		prepareAt:"DateTimeCondition",
		loadingHours:"IntCondition",
		dispatchAt:"DateTimeCondition",
		duration:"StringCondition",
		window:"StringCondition",
		expectedEndAt:"DateTimeCondition",
		expectedAt:"DateTimeCondition",
		and:"OrderDeliveryTimelineWhere",
		or:"OrderDeliveryTimelineWhere",
		not:"OrderDeliveryTimelineWhere"
	},
	OrderDeliveryTimelineOrderBy:{
		id:"OrderDirection",
		type:"OrderDirection",
		prepareAt:"OrderDirection",
		loadingHours:"OrderDirection",
		dispatchAt:"OrderDirection",
		duration:"OrderDirection",
		window:"OrderDirection",
		expectedEndAt:"OrderDirection",
		expectedAt:"OrderDirection"
	},
	OrderDeliveryTimelineCreateInput:{
		id:"UUID",
		type:"DeliveryTimelineType",
		prepareAt:"DateTime",
		dispatchAt:"DateTime",
		expectedEndAt:"DateTime",
		expectedAt:"DateTime"
	},
	OrderDeliveryTimelineUpdateInput:{
		type:"DeliveryTimelineType",
		prepareAt:"DateTime",
		dispatchAt:"DateTime",
		expectedEndAt:"DateTime",
		expectedAt:"DateTime"
	},
	OrderEventCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		order:"OrderEventCreateOrderEntityRelationInput",
		payment:"OrderEventCreatePaymentEntityRelationInput",
		delivery:"OrderEventCreateDeliveryEntityRelationInput"
	},
	OrderEventUpdateInput:{
		createdAt:"DateTime",
		order:"OrderEventUpdateOrderEntityRelationInput",
		payment:"OrderEventUpdatePaymentEntityRelationInput",
		delivery:"OrderEventUpdateDeliveryEntityRelationInput"
	},
	LiftagoRideCreateInput:{
		id:"UUID",
		updatedAt:"DateTime",
		delivery:"LiftagoRideCreateDeliveryEntityRelationInput"
	},
	LiftagoRideCreateDeliveryEntityRelationInput:{
		connect:"OrderDeliveryUniqueWhere",
		create:"OrderDeliveryWithoutLiftagoRideCreateInput"
	},
	OrderDeliveryWithoutLiftagoRideCreateInput:{
		id:"UUID",
		deliveredAt:"DateTime",
		method:"OrderDeliveryCreateMethodEntityRelationInput",
		vatRate:"OrderDeliveryCreateVatRateEntityRelationInput",
		order:"OrderDeliveryCreateOrderEntityRelationInput",
		expectedAt:"DateTime",
		state:"OrderDeliveryState",
		dispatchAt:"DateTime",
		expectedEndAt:"DateTime",
		processingAt:"DateTime",
		deliveringAt:"DateTime",
		failedAt:"DateTime",
		deliveryWaypoint:"OrderDeliveryCreateDeliveryWaypointEntityRelationInput",
		events:"OrderDeliveryCreateEventsEntityRelationInput",
		prepareAt:"DateTime",
		pickedAt:"DateTime",
		address:"OrderDeliveryCreateAddressEntityRelationInput",
		woltDriveDelivery:"OrderDeliveryCreateWoltDriveDeliveryEntityRelationInput"
	},
	LiftagoRideUpdateInput:{
		updatedAt:"DateTime",
		delivery:"LiftagoRideUpdateDeliveryEntityRelationInput"
	},
	LiftagoRideUpdateDeliveryEntityRelationInput:{
		create:"OrderDeliveryWithoutLiftagoRideCreateInput",
		update:"OrderDeliveryWithoutLiftagoRideUpdateInput",
		upsert:"LiftagoRideUpsertDeliveryRelationInput",
		connect:"OrderDeliveryUniqueWhere"
	},
	OrderDeliveryWithoutLiftagoRideUpdateInput:{
		deliveredAt:"DateTime",
		method:"OrderDeliveryUpdateMethodEntityRelationInput",
		vatRate:"OrderDeliveryUpdateVatRateEntityRelationInput",
		order:"OrderDeliveryUpdateOrderEntityRelationInput",
		expectedAt:"DateTime",
		state:"OrderDeliveryState",
		dispatchAt:"DateTime",
		expectedEndAt:"DateTime",
		processingAt:"DateTime",
		deliveringAt:"DateTime",
		failedAt:"DateTime",
		deliveryWaypoint:"OrderDeliveryUpdateDeliveryWaypointEntityRelationInput",
		events:"OrderDeliveryUpdateEventsEntityRelationInput",
		prepareAt:"DateTime",
		pickedAt:"DateTime",
		address:"OrderDeliveryUpdateAddressEntityRelationInput",
		woltDriveDelivery:"OrderDeliveryUpdateWoltDriveDeliveryEntityRelationInput"
	},
	LiftagoRideUpsertDeliveryRelationInput:{
		update:"OrderDeliveryWithoutLiftagoRideUpdateInput",
		create:"OrderDeliveryWithoutLiftagoRideCreateInput"
	},
	InvoiceCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		customer:"InvoiceCreateCustomerEntityRelationInput",
		orderPayments:"InvoiceCreateOrderPaymentsEntityRelationInput",
		address:"InvoiceCreateAddressEntityRelationInput",
		billingSubject:"InvoiceCreateBillingSubjectEntityRelationInput"
	},
	InvoiceUpdateInput:{
		createdAt:"DateTime",
		customer:"InvoiceUpdateCustomerEntityRelationInput",
		orderPayments:"InvoiceUpdateOrderPaymentsEntityRelationInput",
		address:"InvoiceUpdateAddressEntityRelationInput",
		billingSubject:"InvoiceUpdateBillingSubjectEntityRelationInput"
	},
	InvoicingPlanCreateInput:{
		id:"UUID",
		customer:"InvoicingPlanCreateCustomerEntityRelationInput",
		preset:"InvoicingPlanCreatePresetEntityRelationInput"
	},
	InvoicingPlanCreateCustomerEntityRelationInput:{
		connect:"CustomerUniqueWhere",
		create:"CustomerWithoutInvoicingPlanCreateInput"
	},
	CustomerWithoutInvoicingPlanCreateInput:{
		id:"UUID",
		addresses:"CustomerCreateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerCreateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerCreateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerCreateTagsEntityRelationInput",
		credits:"CustomerCreateCreditsEntityRelationInput",
		paymentMethods:"CustomerCreatePaymentMethodsEntityRelationInput",
		orders:"CustomerCreateOrdersEntityRelationInput",
		permissions:"CustomerCreatePermissionsEntityRelationInput",
		group:"CustomerCreateGroupEntityRelationInput",
		photo:"CustomerCreatePhotoEntityRelationInput",
		name:"CustomerCreateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerCreateIngredientRatingsEntityRelationInput",
		business:"CustomerCreateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerCreateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerCreateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerCreateCartsEntityRelationInput",
		shortcutList:"CustomerCreateShortcutListEntityRelationInput",
		user:"CustomerCreateUserEntityRelationInput",
		channels:"CustomerCreateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerCreateInvoicesEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerCreateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerCreateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerCreateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerCreateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerCreateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerCreateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerCreateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerCreateRedeemedVouchersEntityRelationInput",
		spending:"CustomerCreateSpendingEntityRelationInput",
		customerTabs:"CustomerCreateCustomerTabsEntityRelationInput",
		lead:"CustomerCreateLeadEntityRelationInput",
		meta:"CustomerCreateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	InvoicingPlanUpdateInput:{
		customer:"InvoicingPlanUpdateCustomerEntityRelationInput",
		preset:"InvoicingPlanUpdatePresetEntityRelationInput"
	},
	InvoicingPlanUpdateCustomerEntityRelationInput:{
		create:"CustomerWithoutInvoicingPlanCreateInput",
		update:"CustomerWithoutInvoicingPlanUpdateInput",
		upsert:"InvoicingPlanUpsertCustomerRelationInput",
		connect:"CustomerUniqueWhere"
	},
	CustomerWithoutInvoicingPlanUpdateInput:{
		addresses:"CustomerUpdateAddressesEntityRelationInput",
		defaultBillingAddress:"CustomerUpdateDefaultBillingAddressEntityRelationInput",
		defaultPaymentMethod:"CustomerUpdateDefaultPaymentMethodEntityRelationInput",
		tags:"CustomerUpdateTagsEntityRelationInput",
		credits:"CustomerUpdateCreditsEntityRelationInput",
		paymentMethods:"CustomerUpdatePaymentMethodsEntityRelationInput",
		orders:"CustomerUpdateOrdersEntityRelationInput",
		permissions:"CustomerUpdatePermissionsEntityRelationInput",
		group:"CustomerUpdateGroupEntityRelationInput",
		photo:"CustomerUpdatePhotoEntityRelationInput",
		name:"CustomerUpdateNameEntityRelationInput",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerUpdateIngredientRatingsEntityRelationInput",
		business:"CustomerUpdateBusinessEntityRelationInput",
		ownerOfBusinesses:"CustomerUpdateOwnerOfBusinessesEntityRelationInput",
		memberOfBusinesses:"CustomerUpdateMemberOfBusinessesEntityRelationInput",
		carts:"CustomerUpdateCartsEntityRelationInput",
		shortcutList:"CustomerUpdateShortcutListEntityRelationInput",
		user:"CustomerUpdateUserEntityRelationInput",
		channels:"CustomerUpdateChannelsEntityRelationInput",
		disabledAt:"DateTime",
		invoices:"CustomerUpdateInvoicesEntityRelationInput",
		createdAt:"DateTime",
		billingSubjects:"CustomerUpdateBillingSubjectsEntityRelationInput",
		offeredProducts:"CustomerUpdateOfferedProductsEntityRelationInput",
		defaultDeliveryAddress:"CustomerUpdateDefaultDeliveryAddressEntityRelationInput",
		defaultBillingSubject:"CustomerUpdateDefaultBillingSubjectEntityRelationInput",
		anonymousSession:"CustomerUpdateAnonymousSessionEntityRelationInput",
		boughtVouchers:"CustomerUpdateBoughtVouchersEntityRelationInput",
		ownsVouchers:"CustomerUpdateOwnsVouchersEntityRelationInput",
		redeemedVouchers:"CustomerUpdateRedeemedVouchersEntityRelationInput",
		spending:"CustomerUpdateSpendingEntityRelationInput",
		customerTabs:"CustomerUpdateCustomerTabsEntityRelationInput",
		lead:"CustomerUpdateLeadEntityRelationInput",
		meta:"CustomerUpdateMetaEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	InvoicingPlanUpsertCustomerRelationInput:{
		update:"CustomerWithoutInvoicingPlanUpdateInput",
		create:"CustomerWithoutInvoicingPlanCreateInput"
	},
	ProductPackingLocaleCreateInput:{
		id:"UUID",
		root:"ProductPackingLocaleCreateRootEntityRelationInput",
		locale:"ProductPackingLocaleCreateLocaleEntityRelationInput"
	},
	ProductPackingLocaleUpdateInput:{
		root:"ProductPackingLocaleUpdateRootEntityRelationInput",
		locale:"ProductPackingLocaleUpdateLocaleEntityRelationInput"
	},
	ProductLocaleCreateInput:{
		id:"UUID",
		root:"ProductLocaleCreateRootEntityRelationInput",
		locale:"ProductLocaleCreateLocaleEntityRelationInput",
		featureList:"ProductLocaleCreateFeatureListEntityRelationInput"
	},
	ProductLocaleUpdateInput:{
		root:"ProductLocaleUpdateRootEntityRelationInput",
		locale:"ProductLocaleUpdateLocaleEntityRelationInput",
		featureList:"ProductLocaleUpdateFeatureListEntityRelationInput"
	},
	ProductRecipeLocaleCreateInput:{
		id:"UUID",
		root:"ProductRecipeLocaleCreateRootEntityRelationInput",
		locale:"ProductRecipeLocaleCreateLocaleEntityRelationInput"
	},
	ProductRecipeLocaleUpdateInput:{
		root:"ProductRecipeLocaleUpdateRootEntityRelationInput",
		locale:"ProductRecipeLocaleUpdateLocaleEntityRelationInput"
	},
	UserDeviceCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		lastActiveAt:"DateTime",
		user:"UserDeviceCreateUserEntityRelationInput",
		anonymousSession:"UserDeviceCreateAnonymousSessionEntityRelationInput"
	},
	UserDeviceUpdateInput:{
		createdAt:"DateTime",
		lastActiveAt:"DateTime",
		user:"UserDeviceUpdateUserEntityRelationInput",
		anonymousSession:"UserDeviceUpdateAnonymousSessionEntityRelationInput"
	},
	ProtectedActionType: true,
	ProtectedActionUniqueWhere:{
		id:"UUID"
	},
	ProtectedActionWhere:{
		id:"UUIDCondition",
		type:"ProtectedActionTypeCondition",
		data:"JsonCondition",
		publicKey:"StringCondition",
		secretKeyHash:"StringCondition",
		confirmKeyHash:"StringCondition",
		url:"StringCondition",
		createdAt:"DateTimeCondition",
		expiresAt:"DateTimeCondition",
		usedAt:"DateTimeCondition",
		service:"StringCondition",
		and:"ProtectedActionWhere",
		or:"ProtectedActionWhere",
		not:"ProtectedActionWhere"
	},
	ProtectedActionTypeCondition:{
		and:"ProtectedActionTypeCondition",
		or:"ProtectedActionTypeCondition",
		not:"ProtectedActionTypeCondition",
		eq:"ProtectedActionType",
		notEq:"ProtectedActionType",
		in:"ProtectedActionType",
		notIn:"ProtectedActionType",
		lt:"ProtectedActionType",
		lte:"ProtectedActionType",
		gt:"ProtectedActionType",
		gte:"ProtectedActionType"
	},
	ProtectedActionOrderBy:{
		id:"OrderDirection",
		type:"OrderDirection",
		data:"OrderDirection",
		publicKey:"OrderDirection",
		secretKeyHash:"OrderDirection",
		confirmKeyHash:"OrderDirection",
		url:"OrderDirection",
		createdAt:"OrderDirection",
		expiresAt:"OrderDirection",
		usedAt:"OrderDirection",
		service:"OrderDirection"
	},
	ProtectedActionCreateInput:{
		id:"UUID",
		type:"ProtectedActionType",
		data:"Json",
		createdAt:"DateTime",
		expiresAt:"DateTime",
		usedAt:"DateTime"
	},
	ProtectedActionUpdateInput:{
		type:"ProtectedActionType",
		data:"Json",
		createdAt:"DateTime",
		expiresAt:"DateTime",
		usedAt:"DateTime"
	},
	PickerCreateInput:{
		id:"UUID",
		staff:"PickerCreateStaffEntityRelationInput",
		createdAt:"DateTime"
	},
	PickerCreateStaffEntityRelationInput:{
		connect:"StaffUniqueWhere",
		create:"StaffWithoutPickerCreateInput"
	},
	StaffWithoutPickerCreateInput:{
		id:"UUID",
		bartender:"StaffCreateBartenderEntityRelationInput",
		courier:"StaffCreateCourierEntityRelationInput",
		cleaner:"StaffCreateCleanerEntityRelationInput",
		shiftsManager:"StaffCreateShiftsManagerEntityRelationInput",
		businessToBusinessManager:"StaffCreateBusinessToBusinessManagerEntityRelationInput",
		user:"StaffCreateUserEntityRelationInput",
		shiftsProfile:"StaffCreateShiftsProfileEntityRelationInput",
		stocksManager:"StaffCreateStocksManagerEntityRelationInput",
		photo:"StaffCreatePhotoEntityRelationInput",
		courierManager:"StaffCreateCourierManagerEntityRelationInput",
		createdAt:"DateTime",
		remunerationProfile:"StaffCreateRemunerationProfileEntityRelationInput",
		cashier:"StaffCreateCashierEntityRelationInput",
		venues:"StaffCreateVenuesEntityRelationInput",
		internalBuyer:"StaffCreateInternalBuyerEntityRelationInput",
		salesManager:"StaffCreateSalesManagerEntityRelationInput",
		cashierManager:"StaffCreateCashierManagerEntityRelationInput"
	},
	PickerUpdateInput:{
		staff:"PickerUpdateStaffEntityRelationInput",
		createdAt:"DateTime"
	},
	PickerUpdateStaffEntityRelationInput:{
		create:"StaffWithoutPickerCreateInput",
		update:"StaffWithoutPickerUpdateInput",
		upsert:"PickerUpsertStaffRelationInput",
		connect:"StaffUniqueWhere"
	},
	StaffWithoutPickerUpdateInput:{
		bartender:"StaffUpdateBartenderEntityRelationInput",
		courier:"StaffUpdateCourierEntityRelationInput",
		cleaner:"StaffUpdateCleanerEntityRelationInput",
		shiftsManager:"StaffUpdateShiftsManagerEntityRelationInput",
		businessToBusinessManager:"StaffUpdateBusinessToBusinessManagerEntityRelationInput",
		user:"StaffUpdateUserEntityRelationInput",
		shiftsProfile:"StaffUpdateShiftsProfileEntityRelationInput",
		stocksManager:"StaffUpdateStocksManagerEntityRelationInput",
		photo:"StaffUpdatePhotoEntityRelationInput",
		courierManager:"StaffUpdateCourierManagerEntityRelationInput",
		createdAt:"DateTime",
		remunerationProfile:"StaffUpdateRemunerationProfileEntityRelationInput",
		cashier:"StaffUpdateCashierEntityRelationInput",
		venues:"StaffUpdateVenuesEntityRelationInput",
		internalBuyer:"StaffUpdateInternalBuyerEntityRelationInput",
		salesManager:"StaffUpdateSalesManagerEntityRelationInput",
		cashierManager:"StaffUpdateCashierManagerEntityRelationInput"
	},
	PickerUpsertStaffRelationInput:{
		update:"StaffWithoutPickerUpdateInput",
		create:"StaffWithoutPickerCreateInput"
	},
	TenantPersonUniqueWhere:{
		id:"UUID"
	},
	TenantPersonWhere:{
		id:"UUIDCondition",
		email:"StringCondition",
		externalIdentifier:"StringCondition",
		personId:"UUIDCondition",
		identityId:"UUIDCondition",
		globalRoles:"JsonCondition",
		projectRoles:"JsonCondition",
		projectRolesString:"StringCondition",
		externalIdentifiers:"JsonCondition",
		externalIdentifiersString:"StringCondition",
		and:"TenantPersonWhere",
		or:"TenantPersonWhere",
		not:"TenantPersonWhere"
	},
	TenantPersonOrderBy:{
		id:"OrderDirection",
		email:"OrderDirection",
		externalIdentifier:"OrderDirection",
		personId:"OrderDirection",
		identityId:"OrderDirection",
		globalRoles:"OrderDirection",
		projectRoles:"OrderDirection",
		projectRolesString:"OrderDirection",
		externalIdentifiers:"OrderDirection",
		externalIdentifiersString:"OrderDirection"
	},
	TimetableTemplateStaffOptionsCreateInput:{
		id:"UUID",
		timetableTemplate:"TimetableTemplateStaffOptionsCreateTimetableTemplateEntityRelationInput",
		autoAssignedEmployee:"TimetableTemplateStaffOptionsCreateAutoAssignedEmployeeEntityRelationInput"
	},
	TimetableTemplateStaffOptionsCreateTimetableTemplateEntityRelationInput:{
		connect:"TimetableTemplateUniqueWhere",
		create:"TimetableTemplateWithoutStaffOptionsCreateInput"
	},
	TimetableTemplateWithoutStaffOptionsCreateInput:{
		id:"UUID",
		startDate:"Date",
		position:"TimetableTemplateCreatePositionEntityRelationInput",
		venue:"TimetableTemplateCreateVenueEntityRelationInput",
		employeeRole:"TimetableTemplateCreateEmployeeRoleEntityRelationInput",
		type:"TemplateType"
	},
	TimetableTemplateStaffOptionsUpdateInput:{
		timetableTemplate:"TimetableTemplateStaffOptionsUpdateTimetableTemplateEntityRelationInput",
		autoAssignedEmployee:"TimetableTemplateStaffOptionsUpdateAutoAssignedEmployeeEntityRelationInput"
	},
	TimetableTemplateStaffOptionsUpdateTimetableTemplateEntityRelationInput:{
		create:"TimetableTemplateWithoutStaffOptionsCreateInput",
		update:"TimetableTemplateWithoutStaffOptionsUpdateInput",
		upsert:"TimetableTemplateStaffOptionsUpsertTimetableTemplateRelationInput",
		connect:"TimetableTemplateUniqueWhere"
	},
	TimetableTemplateWithoutStaffOptionsUpdateInput:{
		startDate:"Date",
		position:"TimetableTemplateUpdatePositionEntityRelationInput",
		venue:"TimetableTemplateUpdateVenueEntityRelationInput",
		employeeRole:"TimetableTemplateUpdateEmployeeRoleEntityRelationInput",
		type:"TemplateType"
	},
	TimetableTemplateStaffOptionsUpsertTimetableTemplateRelationInput:{
		update:"TimetableTemplateWithoutStaffOptionsUpdateInput",
		create:"TimetableTemplateWithoutStaffOptionsCreateInput"
	},
	ShoppingList:{
		items:{
			filter:"ShoppingListItemWhere",
			orderBy:"ShoppingListItemOrderBy"
		},
		supplier:{
			filter:"IngredientSupplierWhere"
		},
		paginateItems:{
			filter:"ShoppingListItemWhere",
			orderBy:"ShoppingListItemOrderBy"
		}
	},
	ShoppingListItem:{
		list:{
			filter:"ShoppingListWhere"
		},
		ingredient:{
			filter:"ProductIngredientWhere"
		},
		preferredUnit:{
			filter:"ProductIngredientItemQuantityUnitWhere"
		}
	},
	ShoppingListWhere:{
		id:"UUIDCondition",
		createdAt:"DateTimeCondition",
		items:"ShoppingListItemWhere",
		supplier:"IngredientSupplierWhere",
		and:"ShoppingListWhere",
		or:"ShoppingListWhere",
		not:"ShoppingListWhere"
	},
	ShoppingListItemWhere:{
		id:"UUIDCondition",
		amount:"IntCondition",
		list:"ShoppingListWhere",
		ingredient:"ProductIngredientWhere",
		preferredUnit:"ProductIngredientItemQuantityUnitWhere",
		wasPurcahsed:"BooleanCondition",
		wasTransferred:"BooleanCondition",
		and:"ShoppingListItemWhere",
		or:"ShoppingListItemWhere",
		not:"ShoppingListItemWhere"
	},
	ShoppingListItemOrderBy:{
		id:"OrderDirection",
		amount:"OrderDirection",
		list:"ShoppingListOrderBy",
		ingredient:"ProductIngredientOrderBy",
		preferredUnit:"ProductIngredientItemQuantityUnitOrderBy",
		wasPurcahsed:"OrderDirection",
		wasTransferred:"OrderDirection"
	},
	ShoppingListOrderBy:{
		id:"OrderDirection",
		createdAt:"OrderDirection",
		supplier:"IngredientSupplierOrderBy"
	},
	ShoppingListUniqueWhere:{
		id:"UUID",
		createdAt:"DateTime",
		supplier:"IngredientSupplierUniqueWhere",
		items:"ShoppingListItemUniqueWhere"
	},
	ShoppingListItemUniqueWhere:{
		id:"UUID"
	},
	ShoppingListCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		items:"ShoppingListCreateItemsEntityRelationInput",
		supplier:"ShoppingListCreateSupplierEntityRelationInput"
	},
	ShoppingListCreateItemsEntityRelationInput:{
		connect:"ShoppingListItemUniqueWhere",
		create:"ShoppingListItemWithoutListCreateInput"
	},
	ShoppingListItemWithoutListCreateInput:{
		id:"UUID",
		ingredient:"ShoppingListItemCreateIngredientEntityRelationInput",
		preferredUnit:"ShoppingListItemCreatePreferredUnitEntityRelationInput"
	},
	ShoppingListItemCreateIngredientEntityRelationInput:{
		connect:"ProductIngredientUniqueWhere",
		create:"ProductIngredientCreateInput"
	},
	ShoppingListItemCreatePreferredUnitEntityRelationInput:{
		connect:"ProductIngredientItemQuantityUnitUniqueWhere",
		create:"ProductIngredientItemQuantityUnitCreateInput"
	},
	ShoppingListCreateSupplierEntityRelationInput:{
		connect:"IngredientSupplierUniqueWhere",
		create:"IngredientSupplierCreateInput"
	},
	ShoppingListUpdateInput:{
		createdAt:"DateTime",
		items:"ShoppingListUpdateItemsEntityRelationInput",
		supplier:"ShoppingListUpdateSupplierEntityRelationInput"
	},
	ShoppingListUpdateItemsEntityRelationInput:{
		create:"ShoppingListItemWithoutListCreateInput",
		update:"ShoppingListUpdateItemsRelationInput",
		upsert:"ShoppingListUpsertItemsRelationInput",
		connect:"ShoppingListItemUniqueWhere",
		disconnect:"ShoppingListItemUniqueWhere",
		delete:"ShoppingListItemUniqueWhere"
	},
	ShoppingListUpdateItemsRelationInput:{
		by:"ShoppingListItemUniqueWhere",
		data:"ShoppingListItemWithoutListUpdateInput"
	},
	ShoppingListItemWithoutListUpdateInput:{
		ingredient:"ShoppingListItemUpdateIngredientEntityRelationInput",
		preferredUnit:"ShoppingListItemUpdatePreferredUnitEntityRelationInput"
	},
	ShoppingListItemUpdateIngredientEntityRelationInput:{
		create:"ProductIngredientCreateInput",
		update:"ProductIngredientUpdateInput",
		upsert:"ShoppingListItemUpsertIngredientRelationInput",
		connect:"ProductIngredientUniqueWhere"
	},
	ShoppingListItemUpsertIngredientRelationInput:{
		update:"ProductIngredientUpdateInput",
		create:"ProductIngredientCreateInput"
	},
	ShoppingListItemUpdatePreferredUnitEntityRelationInput:{
		create:"ProductIngredientItemQuantityUnitCreateInput",
		update:"ProductIngredientItemQuantityUnitUpdateInput",
		upsert:"ShoppingListItemUpsertPreferredUnitRelationInput",
		connect:"ProductIngredientItemQuantityUnitUniqueWhere"
	},
	ShoppingListItemUpsertPreferredUnitRelationInput:{
		update:"ProductIngredientItemQuantityUnitUpdateInput",
		create:"ProductIngredientItemQuantityUnitCreateInput"
	},
	ShoppingListUpsertItemsRelationInput:{
		by:"ShoppingListItemUniqueWhere",
		update:"ShoppingListItemWithoutListUpdateInput",
		create:"ShoppingListItemWithoutListCreateInput"
	},
	ShoppingListUpdateSupplierEntityRelationInput:{
		create:"IngredientSupplierCreateInput",
		update:"IngredientSupplierUpdateInput",
		upsert:"ShoppingListUpsertSupplierRelationInput",
		connect:"IngredientSupplierUniqueWhere"
	},
	ShoppingListUpsertSupplierRelationInput:{
		update:"IngredientSupplierUpdateInput",
		create:"IngredientSupplierCreateInput"
	},
	SuppliesPurchase:{
		items:{
			filter:"SuppliesPurchaseItemWhere",
			orderBy:"SuppliesPurchaseItemOrderBy"
		},
		supplier:{
			filter:"IngredientSupplierWhere"
		},
		paginateItems:{
			filter:"SuppliesPurchaseItemWhere",
			orderBy:"SuppliesPurchaseItemOrderBy"
		}
	},
	SuppliesPurchaseItem:{
		list:{
			filter:"SuppliesPurchaseWhere"
		},
		ingredient:{
			filter:"ProductIngredientWhere"
		},
		preferredUnit:{
			filter:"ProductIngredientItemQuantityUnitWhere"
		},
		purchasedBy:{
			filter:"StaffWhere"
		}
	},
	SuppliesPurchaseWhere:{
		id:"UUIDCondition",
		createdAt:"DateTimeCondition",
		items:"SuppliesPurchaseItemWhere",
		supplier:"IngredientSupplierWhere",
		requestedDeliveryDate:"DateCondition",
		and:"SuppliesPurchaseWhere",
		or:"SuppliesPurchaseWhere",
		not:"SuppliesPurchaseWhere"
	},
	SuppliesPurchaseItemWhere:{
		id:"UUIDCondition",
		amount:"IntCondition",
		list:"SuppliesPurchaseWhere",
		ingredient:"ProductIngredientWhere",
		pricePaidCents:"IntCondition",
		preferredUnit:"ProductIngredientItemQuantityUnitWhere",
		deletedAt:"DateTimeCondition",
		purchasedAt:"DateTimeCondition",
		purchasedBy:"StaffWhere",
		and:"SuppliesPurchaseItemWhere",
		or:"SuppliesPurchaseItemWhere",
		not:"SuppliesPurchaseItemWhere"
	},
	SuppliesPurchaseItemOrderBy:{
		id:"OrderDirection",
		amount:"OrderDirection",
		list:"SuppliesPurchaseOrderBy",
		ingredient:"ProductIngredientOrderBy",
		pricePaidCents:"OrderDirection",
		preferredUnit:"ProductIngredientItemQuantityUnitOrderBy",
		deletedAt:"OrderDirection",
		purchasedAt:"OrderDirection",
		purchasedBy:"StaffOrderBy"
	},
	SuppliesPurchaseOrderBy:{
		id:"OrderDirection",
		createdAt:"OrderDirection",
		supplier:"IngredientSupplierOrderBy",
		requestedDeliveryDate:"OrderDirection"
	},
	SuppliesPurchaseUniqueWhere:{
		id:"UUID",
		createdAt:"DateTime",
		supplier:"IngredientSupplierUniqueWhere",
		items:"SuppliesPurchaseItemUniqueWhere"
	},
	SuppliesPurchaseItemUniqueWhere:{
		id:"UUID"
	},
	SuppliesPurchaseCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		items:"SuppliesPurchaseCreateItemsEntityRelationInput",
		supplier:"SuppliesPurchaseCreateSupplierEntityRelationInput",
		requestedDeliveryDate:"Date"
	},
	SuppliesPurchaseCreateItemsEntityRelationInput:{
		connect:"SuppliesPurchaseItemUniqueWhere",
		create:"SuppliesPurchaseItemWithoutListCreateInput"
	},
	SuppliesPurchaseItemWithoutListCreateInput:{
		id:"UUID",
		ingredient:"SuppliesPurchaseItemCreateIngredientEntityRelationInput",
		preferredUnit:"SuppliesPurchaseItemCreatePreferredUnitEntityRelationInput",
		deletedAt:"DateTime",
		purchasedAt:"DateTime",
		purchasedBy:"SuppliesPurchaseItemCreatePurchasedByEntityRelationInput"
	},
	SuppliesPurchaseItemCreateIngredientEntityRelationInput:{
		connect:"ProductIngredientUniqueWhere",
		create:"ProductIngredientCreateInput"
	},
	SuppliesPurchaseItemCreatePreferredUnitEntityRelationInput:{
		connect:"ProductIngredientItemQuantityUnitUniqueWhere",
		create:"ProductIngredientItemQuantityUnitCreateInput"
	},
	SuppliesPurchaseItemCreatePurchasedByEntityRelationInput:{
		connect:"StaffUniqueWhere",
		create:"StaffCreateInput"
	},
	SuppliesPurchaseCreateSupplierEntityRelationInput:{
		connect:"IngredientSupplierUniqueWhere",
		create:"IngredientSupplierCreateInput"
	},
	SuppliesPurchaseUpdateInput:{
		createdAt:"DateTime",
		items:"SuppliesPurchaseUpdateItemsEntityRelationInput",
		supplier:"SuppliesPurchaseUpdateSupplierEntityRelationInput",
		requestedDeliveryDate:"Date"
	},
	SuppliesPurchaseUpdateItemsEntityRelationInput:{
		create:"SuppliesPurchaseItemWithoutListCreateInput",
		update:"SuppliesPurchaseUpdateItemsRelationInput",
		upsert:"SuppliesPurchaseUpsertItemsRelationInput",
		connect:"SuppliesPurchaseItemUniqueWhere",
		disconnect:"SuppliesPurchaseItemUniqueWhere",
		delete:"SuppliesPurchaseItemUniqueWhere"
	},
	SuppliesPurchaseUpdateItemsRelationInput:{
		by:"SuppliesPurchaseItemUniqueWhere",
		data:"SuppliesPurchaseItemWithoutListUpdateInput"
	},
	SuppliesPurchaseItemWithoutListUpdateInput:{
		ingredient:"SuppliesPurchaseItemUpdateIngredientEntityRelationInput",
		preferredUnit:"SuppliesPurchaseItemUpdatePreferredUnitEntityRelationInput",
		deletedAt:"DateTime",
		purchasedAt:"DateTime",
		purchasedBy:"SuppliesPurchaseItemUpdatePurchasedByEntityRelationInput"
	},
	SuppliesPurchaseItemUpdateIngredientEntityRelationInput:{
		create:"ProductIngredientCreateInput",
		update:"ProductIngredientUpdateInput",
		upsert:"SuppliesPurchaseItemUpsertIngredientRelationInput",
		connect:"ProductIngredientUniqueWhere"
	},
	SuppliesPurchaseItemUpsertIngredientRelationInput:{
		update:"ProductIngredientUpdateInput",
		create:"ProductIngredientCreateInput"
	},
	SuppliesPurchaseItemUpdatePreferredUnitEntityRelationInput:{
		create:"ProductIngredientItemQuantityUnitCreateInput",
		update:"ProductIngredientItemQuantityUnitUpdateInput",
		upsert:"SuppliesPurchaseItemUpsertPreferredUnitRelationInput",
		connect:"ProductIngredientItemQuantityUnitUniqueWhere"
	},
	SuppliesPurchaseItemUpsertPreferredUnitRelationInput:{
		update:"ProductIngredientItemQuantityUnitUpdateInput",
		create:"ProductIngredientItemQuantityUnitCreateInput"
	},
	SuppliesPurchaseItemUpdatePurchasedByEntityRelationInput:{
		create:"StaffCreateInput",
		update:"StaffUpdateInput",
		upsert:"SuppliesPurchaseItemUpsertPurchasedByRelationInput",
		connect:"StaffUniqueWhere"
	},
	SuppliesPurchaseItemUpsertPurchasedByRelationInput:{
		update:"StaffUpdateInput",
		create:"StaffCreateInput"
	},
	SuppliesPurchaseUpsertItemsRelationInput:{
		by:"SuppliesPurchaseItemUniqueWhere",
		update:"SuppliesPurchaseItemWithoutListUpdateInput",
		create:"SuppliesPurchaseItemWithoutListCreateInput"
	},
	SuppliesPurchaseUpdateSupplierEntityRelationInput:{
		create:"IngredientSupplierCreateInput",
		update:"IngredientSupplierUpdateInput",
		upsert:"SuppliesPurchaseUpsertSupplierRelationInput",
		connect:"IngredientSupplierUniqueWhere"
	},
	SuppliesPurchaseUpsertSupplierRelationInput:{
		update:"IngredientSupplierUpdateInput",
		create:"IngredientSupplierCreateInput"
	},
	InvoicingPresetCreateInput:{
		id:"UUID",
		type:"InvoicingPresetType",
		startsAt:"DateTime",
		endsAt:"DateTime",
		invoicingPlan:"InvoicingPresetCreateInvoicingPlanEntityRelationInput"
	},
	InvoicingPresetCreateInvoicingPlanEntityRelationInput:{
		connect:"InvoicingPlanUniqueWhere",
		create:"InvoicingPlanWithoutPresetCreateInput"
	},
	InvoicingPlanWithoutPresetCreateInput:{
		id:"UUID",
		customer:"InvoicingPlanCreateCustomerEntityRelationInput"
	},
	InvoicingPresetUpdateInput:{
		type:"InvoicingPresetType",
		startsAt:"DateTime",
		endsAt:"DateTime",
		invoicingPlan:"InvoicingPresetUpdateInvoicingPlanEntityRelationInput"
	},
	InvoicingPresetUpdateInvoicingPlanEntityRelationInput:{
		create:"InvoicingPlanWithoutPresetCreateInput",
		update:"InvoicingPlanWithoutPresetUpdateInput",
		upsert:"InvoicingPresetUpsertInvoicingPlanRelationInput",
		connect:"InvoicingPlanUniqueWhere"
	},
	InvoicingPlanWithoutPresetUpdateInput:{
		customer:"InvoicingPlanUpdateCustomerEntityRelationInput"
	},
	InvoicingPresetUpsertInvoicingPlanRelationInput:{
		update:"InvoicingPlanWithoutPresetUpdateInput",
		create:"InvoicingPlanWithoutPresetCreateInput"
	},
	LogRecord:{
		resolvedBy:{
			filter:"UserWhere"
		}
	},
	LogRecordUniqueWhere:{
		id:"UUID"
	},
	LogRecordWhere:{
		id:"UUIDCondition",
		level:"IntCondition",
		type:"StringCondition",
		message:"StringCondition",
		data:"JsonCondition",
		createdAt:"DateTimeCondition",
		shouldBeResolved:"BooleanCondition",
		resolvedAt:"DateTimeCondition",
		resolvedBy:"UserWhere",
		and:"LogRecordWhere",
		or:"LogRecordWhere",
		not:"LogRecordWhere"
	},
	LogRecordOrderBy:{
		id:"OrderDirection",
		level:"OrderDirection",
		type:"OrderDirection",
		message:"OrderDirection",
		data:"OrderDirection",
		createdAt:"OrderDirection",
		shouldBeResolved:"OrderDirection",
		resolvedAt:"OrderDirection",
		resolvedBy:"UserOrderBy"
	},
	LogRecordCreateInput:{
		id:"UUID",
		data:"Json",
		createdAt:"DateTime",
		resolvedAt:"DateTime",
		resolvedBy:"LogRecordCreateResolvedByEntityRelationInput"
	},
	LogRecordCreateResolvedByEntityRelationInput:{
		connect:"UserUniqueWhere",
		create:"UserCreateInput"
	},
	LogRecordUpdateInput:{
		data:"Json",
		createdAt:"DateTime",
		resolvedAt:"DateTime",
		resolvedBy:"LogRecordUpdateResolvedByEntityRelationInput"
	},
	LogRecordUpdateResolvedByEntityRelationInput:{
		create:"UserCreateInput",
		update:"UserUpdateInput",
		upsert:"LogRecordUpsertResolvedByRelationInput",
		connect:"UserUniqueWhere"
	},
	LogRecordUpsertResolvedByRelationInput:{
		update:"UserUpdateInput",
		create:"UserCreateInput"
	},
	ShoppingListItemCreateInput:{
		id:"UUID",
		list:"ShoppingListItemCreateListEntityRelationInput",
		ingredient:"ShoppingListItemCreateIngredientEntityRelationInput",
		preferredUnit:"ShoppingListItemCreatePreferredUnitEntityRelationInput"
	},
	ShoppingListItemCreateListEntityRelationInput:{
		connect:"ShoppingListUniqueWhere",
		create:"ShoppingListWithoutItemsCreateInput"
	},
	ShoppingListWithoutItemsCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		supplier:"ShoppingListCreateSupplierEntityRelationInput"
	},
	ShoppingListItemUpdateInput:{
		list:"ShoppingListItemUpdateListEntityRelationInput",
		ingredient:"ShoppingListItemUpdateIngredientEntityRelationInput",
		preferredUnit:"ShoppingListItemUpdatePreferredUnitEntityRelationInput"
	},
	ShoppingListItemUpdateListEntityRelationInput:{
		create:"ShoppingListWithoutItemsCreateInput",
		update:"ShoppingListWithoutItemsUpdateInput",
		upsert:"ShoppingListItemUpsertListRelationInput",
		connect:"ShoppingListUniqueWhere"
	},
	ShoppingListWithoutItemsUpdateInput:{
		createdAt:"DateTime",
		supplier:"ShoppingListUpdateSupplierEntityRelationInput"
	},
	ShoppingListItemUpsertListRelationInput:{
		update:"ShoppingListWithoutItemsUpdateInput",
		create:"ShoppingListWithoutItemsCreateInput"
	},
	SuppliesPurchaseItemCreateInput:{
		id:"UUID",
		list:"SuppliesPurchaseItemCreateListEntityRelationInput",
		ingredient:"SuppliesPurchaseItemCreateIngredientEntityRelationInput",
		preferredUnit:"SuppliesPurchaseItemCreatePreferredUnitEntityRelationInput",
		deletedAt:"DateTime",
		purchasedAt:"DateTime",
		purchasedBy:"SuppliesPurchaseItemCreatePurchasedByEntityRelationInput"
	},
	SuppliesPurchaseItemCreateListEntityRelationInput:{
		connect:"SuppliesPurchaseUniqueWhere",
		create:"SuppliesPurchaseWithoutItemsCreateInput"
	},
	SuppliesPurchaseWithoutItemsCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		supplier:"SuppliesPurchaseCreateSupplierEntityRelationInput",
		requestedDeliveryDate:"Date"
	},
	SuppliesPurchaseItemUpdateInput:{
		list:"SuppliesPurchaseItemUpdateListEntityRelationInput",
		ingredient:"SuppliesPurchaseItemUpdateIngredientEntityRelationInput",
		preferredUnit:"SuppliesPurchaseItemUpdatePreferredUnitEntityRelationInput",
		deletedAt:"DateTime",
		purchasedAt:"DateTime",
		purchasedBy:"SuppliesPurchaseItemUpdatePurchasedByEntityRelationInput"
	},
	SuppliesPurchaseItemUpdateListEntityRelationInput:{
		create:"SuppliesPurchaseWithoutItemsCreateInput",
		update:"SuppliesPurchaseWithoutItemsUpdateInput",
		upsert:"SuppliesPurchaseItemUpsertListRelationInput",
		connect:"SuppliesPurchaseUniqueWhere"
	},
	SuppliesPurchaseWithoutItemsUpdateInput:{
		createdAt:"DateTime",
		supplier:"SuppliesPurchaseUpdateSupplierEntityRelationInput",
		requestedDeliveryDate:"Date"
	},
	SuppliesPurchaseItemUpsertListRelationInput:{
		update:"SuppliesPurchaseWithoutItemsUpdateInput",
		create:"SuppliesPurchaseWithoutItemsCreateInput"
	},
	CustomerCreditTransactionCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		customerCredit:"CustomerCreditTransactionCreateCustomerCreditEntityRelationInput",
		orderDiscount:"CustomerCreditTransactionCreateOrderDiscountEntityRelationInput",
		virtualProductEffect:"CustomerCreditTransactionCreateVirtualProductEffectEntityRelationInput"
	},
	CustomerCreditTransactionUpdateInput:{
		createdAt:"DateTime",
		customerCredit:"CustomerCreditTransactionUpdateCustomerCreditEntityRelationInput",
		orderDiscount:"CustomerCreditTransactionUpdateOrderDiscountEntityRelationInput",
		virtualProductEffect:"CustomerCreditTransactionUpdateVirtualProductEffectEntityRelationInput"
	},
	VirtualProductEffectCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		succeededAt:"DateTime",
		orderItem:"VirtualProductEffectCreateOrderItemEntityRelationInput",
		failedAt:"DateTime",
		revertedAt:"DateTime",
		resultCustomerCreditTransaction:"VirtualProductEffectCreateResultCustomerCreditTransactionEntityRelationInput",
		resultVouchers:"VirtualProductEffectCreateResultVouchersEntityRelationInput"
	},
	VirtualProductEffectUpdateInput:{
		createdAt:"DateTime",
		succeededAt:"DateTime",
		orderItem:"VirtualProductEffectUpdateOrderItemEntityRelationInput",
		failedAt:"DateTime",
		revertedAt:"DateTime",
		resultCustomerCreditTransaction:"VirtualProductEffectUpdateResultCustomerCreditTransactionEntityRelationInput",
		resultVouchers:"VirtualProductEffectUpdateResultVouchersEntityRelationInput"
	},
	EmploymentInformationCreateInput:{
		id:"UUID",
		remunerationProfiles:"EmploymentInformationCreateRemunerationProfilesEntityRelationInput",
		type:"EmploymentType"
	},
	EmploymentInformationCreateRemunerationProfilesEntityRelationInput:{
		connect:"RemunerationProfileUniqueWhere",
		create:"RemunerationProfileWithoutEmploymentInformationCreateInput"
	},
	RemunerationProfileWithoutEmploymentInformationCreateInput:{
		id:"UUID",
		workMonths:"RemunerationProfileCreateWorkMonthsEntityRelationInput",
		staff:"RemunerationProfileCreateStaffEntityRelationInput"
	},
	RemunerationProfileCreateStaffEntityRelationInput:{
		connect:"StaffUniqueWhere",
		create:"StaffWithoutRemunerationProfileCreateInput"
	},
	StaffWithoutRemunerationProfileCreateInput:{
		id:"UUID",
		bartender:"StaffCreateBartenderEntityRelationInput",
		courier:"StaffCreateCourierEntityRelationInput",
		cleaner:"StaffCreateCleanerEntityRelationInput",
		shiftsManager:"StaffCreateShiftsManagerEntityRelationInput",
		businessToBusinessManager:"StaffCreateBusinessToBusinessManagerEntityRelationInput",
		user:"StaffCreateUserEntityRelationInput",
		shiftsProfile:"StaffCreateShiftsProfileEntityRelationInput",
		stocksManager:"StaffCreateStocksManagerEntityRelationInput",
		photo:"StaffCreatePhotoEntityRelationInput",
		courierManager:"StaffCreateCourierManagerEntityRelationInput",
		picker:"StaffCreatePickerEntityRelationInput",
		createdAt:"DateTime",
		cashier:"StaffCreateCashierEntityRelationInput",
		venues:"StaffCreateVenuesEntityRelationInput",
		internalBuyer:"StaffCreateInternalBuyerEntityRelationInput",
		salesManager:"StaffCreateSalesManagerEntityRelationInput",
		cashierManager:"StaffCreateCashierManagerEntityRelationInput"
	},
	EmploymentInformationUpdateInput:{
		remunerationProfiles:"EmploymentInformationUpdateRemunerationProfilesEntityRelationInput",
		type:"EmploymentType"
	},
	EmploymentInformationUpdateRemunerationProfilesEntityRelationInput:{
		create:"RemunerationProfileWithoutEmploymentInformationCreateInput",
		update:"RemunerationProfileWithoutEmploymentInformationUpdateInput",
		upsert:"EmploymentInformationUpsertRemunerationProfilesRelationInput",
		connect:"RemunerationProfileUniqueWhere"
	},
	RemunerationProfileWithoutEmploymentInformationUpdateInput:{
		workMonths:"RemunerationProfileUpdateWorkMonthsEntityRelationInput",
		staff:"RemunerationProfileUpdateStaffEntityRelationInput"
	},
	RemunerationProfileUpdateStaffEntityRelationInput:{
		create:"StaffWithoutRemunerationProfileCreateInput",
		update:"StaffWithoutRemunerationProfileUpdateInput",
		upsert:"RemunerationProfileUpsertStaffRelationInput",
		connect:"StaffUniqueWhere"
	},
	StaffWithoutRemunerationProfileUpdateInput:{
		bartender:"StaffUpdateBartenderEntityRelationInput",
		courier:"StaffUpdateCourierEntityRelationInput",
		cleaner:"StaffUpdateCleanerEntityRelationInput",
		shiftsManager:"StaffUpdateShiftsManagerEntityRelationInput",
		businessToBusinessManager:"StaffUpdateBusinessToBusinessManagerEntityRelationInput",
		user:"StaffUpdateUserEntityRelationInput",
		shiftsProfile:"StaffUpdateShiftsProfileEntityRelationInput",
		stocksManager:"StaffUpdateStocksManagerEntityRelationInput",
		photo:"StaffUpdatePhotoEntityRelationInput",
		courierManager:"StaffUpdateCourierManagerEntityRelationInput",
		picker:"StaffUpdatePickerEntityRelationInput",
		createdAt:"DateTime",
		cashier:"StaffUpdateCashierEntityRelationInput",
		venues:"StaffUpdateVenuesEntityRelationInput",
		internalBuyer:"StaffUpdateInternalBuyerEntityRelationInput",
		salesManager:"StaffUpdateSalesManagerEntityRelationInput",
		cashierManager:"StaffUpdateCashierManagerEntityRelationInput"
	},
	RemunerationProfileUpsertStaffRelationInput:{
		update:"StaffWithoutRemunerationProfileUpdateInput",
		create:"StaffWithoutRemunerationProfileCreateInput"
	},
	EmploymentInformationUpsertRemunerationProfilesRelationInput:{
		update:"RemunerationProfileWithoutEmploymentInformationUpdateInput",
		create:"RemunerationProfileWithoutEmploymentInformationCreateInput"
	},
	RemunerationProfileCreateInput:{
		id:"UUID",
		employmentInformation:"RemunerationProfileCreateEmploymentInformationEntityRelationInput",
		workMonths:"RemunerationProfileCreateWorkMonthsEntityRelationInput",
		staff:"RemunerationProfileCreateStaffEntityRelationInput"
	},
	RemunerationProfileUpdateInput:{
		employmentInformation:"RemunerationProfileUpdateEmploymentInformationEntityRelationInput",
		workMonths:"RemunerationProfileUpdateWorkMonthsEntityRelationInput",
		staff:"RemunerationProfileUpdateStaffEntityRelationInput"
	},
	WorkMonthCreateInput:{
		id:"UUID",
		remunerationProfile:"WorkMonthCreateRemunerationProfileEntityRelationInput"
	},
	WorkMonthCreateRemunerationProfileEntityRelationInput:{
		connect:"RemunerationProfileUniqueWhere",
		create:"RemunerationProfileWithoutWorkMonthsCreateInput"
	},
	RemunerationProfileWithoutWorkMonthsCreateInput:{
		id:"UUID",
		employmentInformation:"RemunerationProfileCreateEmploymentInformationEntityRelationInput",
		staff:"RemunerationProfileCreateStaffEntityRelationInput"
	},
	WorkMonthUpdateInput:{
		remunerationProfile:"WorkMonthUpdateRemunerationProfileEntityRelationInput"
	},
	WorkMonthUpdateRemunerationProfileEntityRelationInput:{
		create:"RemunerationProfileWithoutWorkMonthsCreateInput",
		update:"WorkMonthUpdateRemunerationProfileRelationInput",
		upsert:"WorkMonthUpsertRemunerationProfileRelationInput",
		connect:"RemunerationProfileUniqueWhere",
		disconnect:"RemunerationProfileUniqueWhere",
		delete:"RemunerationProfileUniqueWhere"
	},
	WorkMonthUpdateRemunerationProfileRelationInput:{
		by:"RemunerationProfileUniqueWhere",
		data:"RemunerationProfileWithoutWorkMonthsUpdateInput"
	},
	RemunerationProfileWithoutWorkMonthsUpdateInput:{
		employmentInformation:"RemunerationProfileUpdateEmploymentInformationEntityRelationInput",
		staff:"RemunerationProfileUpdateStaffEntityRelationInput"
	},
	WorkMonthUpsertRemunerationProfileRelationInput:{
		by:"RemunerationProfileUniqueWhere",
		update:"RemunerationProfileWithoutWorkMonthsUpdateInput",
		create:"RemunerationProfileWithoutWorkMonthsCreateInput"
	},
	SalaryOptionsUniqueWhere:{
		id:"UUID",
		unique:"One"
	},
	SalaryOptionsWhere:{
		id:"UUIDCondition",
		overtimeMultiplier:"FloatCondition",
		publicHolidayMultiplier:"FloatCondition",
		weekendMultiplier:"FloatCondition",
		unique:"OneCondition",
		partTimeMonthlySalaryLimit:"IntCondition",
		and:"SalaryOptionsWhere",
		or:"SalaryOptionsWhere",
		not:"SalaryOptionsWhere"
	},
	SalaryOptionsOrderBy:{
		id:"OrderDirection",
		overtimeMultiplier:"OrderDirection",
		publicHolidayMultiplier:"OrderDirection",
		weekendMultiplier:"OrderDirection",
		unique:"OrderDirection",
		partTimeMonthlySalaryLimit:"OrderDirection"
	},
	SalaryOptionsCreateInput:{
		id:"UUID",
		unique:"One"
	},
	SalaryOptionsUpdateInput:{
		unique:"One"
	},
	TimetableShiftSwapInfoCreateInput:{
		id:"UUID",
		assigned:"Date",
		swappedShiftsProfile:"TimetableShiftSwapInfoCreateSwappedShiftsProfileEntityRelationInput",
		shift:"TimetableShiftSwapInfoCreateShiftEntityRelationInput"
	},
	TimetableShiftSwapInfoCreateShiftEntityRelationInput:{
		connect:"TimetableShiftUniqueWhere",
		create:"TimetableShiftWithoutSwapInfoCreateInput"
	},
	TimetableShiftWithoutSwapInfoCreateInput:{
		id:"UUID",
		assigned:"Date",
		group:"TimetableShiftCreateGroupEntityRelationInput",
		shiftsProfile:"TimetableShiftCreateShiftsProfileEntityRelationInput",
		queueItem:"TimetableShiftCreateQueueItemEntityRelationInput"
	},
	TimetableShiftSwapInfoUpdateInput:{
		assigned:"Date",
		swappedShiftsProfile:"TimetableShiftSwapInfoUpdateSwappedShiftsProfileEntityRelationInput",
		shift:"TimetableShiftSwapInfoUpdateShiftEntityRelationInput"
	},
	TimetableShiftSwapInfoUpdateShiftEntityRelationInput:{
		create:"TimetableShiftWithoutSwapInfoCreateInput",
		update:"TimetableShiftWithoutSwapInfoUpdateInput",
		upsert:"TimetableShiftSwapInfoUpsertShiftRelationInput",
		connect:"TimetableShiftUniqueWhere"
	},
	TimetableShiftWithoutSwapInfoUpdateInput:{
		assigned:"Date",
		group:"TimetableShiftUpdateGroupEntityRelationInput",
		shiftsProfile:"TimetableShiftUpdateShiftsProfileEntityRelationInput",
		queueItem:"TimetableShiftUpdateQueueItemEntityRelationInput"
	},
	TimetableShiftSwapInfoUpsertShiftRelationInput:{
		update:"TimetableShiftWithoutSwapInfoUpdateInput",
		create:"TimetableShiftWithoutSwapInfoCreateInput"
	},
	ProductGridCategoryCreateInput:{
		id:"UUID",
		root:"ProductGridCategoryCreateRootEntityRelationInput",
		items:"ProductGridCategoryCreateItemsEntityRelationInput",
		images:"ProductGridCategoryCreateImagesEntityRelationInput"
	},
	ProductGridCategoryUpdateInput:{
		root:"ProductGridCategoryUpdateRootEntityRelationInput",
		items:"ProductGridCategoryUpdateItemsEntityRelationInput",
		images:"ProductGridCategoryUpdateImagesEntityRelationInput"
	},
	CashierCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		staff:"CashierCreateStaffEntityRelationInput"
	},
	CashierCreateStaffEntityRelationInput:{
		connect:"StaffUniqueWhere",
		create:"StaffWithoutCashierCreateInput"
	},
	StaffWithoutCashierCreateInput:{
		id:"UUID",
		bartender:"StaffCreateBartenderEntityRelationInput",
		courier:"StaffCreateCourierEntityRelationInput",
		cleaner:"StaffCreateCleanerEntityRelationInput",
		shiftsManager:"StaffCreateShiftsManagerEntityRelationInput",
		businessToBusinessManager:"StaffCreateBusinessToBusinessManagerEntityRelationInput",
		user:"StaffCreateUserEntityRelationInput",
		shiftsProfile:"StaffCreateShiftsProfileEntityRelationInput",
		stocksManager:"StaffCreateStocksManagerEntityRelationInput",
		photo:"StaffCreatePhotoEntityRelationInput",
		courierManager:"StaffCreateCourierManagerEntityRelationInput",
		picker:"StaffCreatePickerEntityRelationInput",
		createdAt:"DateTime",
		remunerationProfile:"StaffCreateRemunerationProfileEntityRelationInput",
		venues:"StaffCreateVenuesEntityRelationInput",
		internalBuyer:"StaffCreateInternalBuyerEntityRelationInput",
		salesManager:"StaffCreateSalesManagerEntityRelationInput",
		cashierManager:"StaffCreateCashierManagerEntityRelationInput"
	},
	CashierUpdateInput:{
		createdAt:"DateTime",
		staff:"CashierUpdateStaffEntityRelationInput"
	},
	CashierUpdateStaffEntityRelationInput:{
		create:"StaffWithoutCashierCreateInput",
		update:"StaffWithoutCashierUpdateInput",
		upsert:"CashierUpsertStaffRelationInput",
		connect:"StaffUniqueWhere"
	},
	StaffWithoutCashierUpdateInput:{
		bartender:"StaffUpdateBartenderEntityRelationInput",
		courier:"StaffUpdateCourierEntityRelationInput",
		cleaner:"StaffUpdateCleanerEntityRelationInput",
		shiftsManager:"StaffUpdateShiftsManagerEntityRelationInput",
		businessToBusinessManager:"StaffUpdateBusinessToBusinessManagerEntityRelationInput",
		user:"StaffUpdateUserEntityRelationInput",
		shiftsProfile:"StaffUpdateShiftsProfileEntityRelationInput",
		stocksManager:"StaffUpdateStocksManagerEntityRelationInput",
		photo:"StaffUpdatePhotoEntityRelationInput",
		courierManager:"StaffUpdateCourierManagerEntityRelationInput",
		picker:"StaffUpdatePickerEntityRelationInput",
		createdAt:"DateTime",
		remunerationProfile:"StaffUpdateRemunerationProfileEntityRelationInput",
		venues:"StaffUpdateVenuesEntityRelationInput",
		internalBuyer:"StaffUpdateInternalBuyerEntityRelationInput",
		salesManager:"StaffUpdateSalesManagerEntityRelationInput",
		cashierManager:"StaffUpdateCashierManagerEntityRelationInput"
	},
	CashierUpsertStaffRelationInput:{
		update:"StaffWithoutCashierUpdateInput",
		create:"StaffWithoutCashierCreateInput"
	},
	PointOfSaleCategoryCreateInput:{
		id:"UUID",
		locales:"PointOfSaleCategoryCreateLocalesEntityRelationInput",
		products:"PointOfSaleCategoryCreateProductsEntityRelationInput",
		category:"PointOfSaleCategoryCreateCategoryEntityRelationInput",
		venue:"PointOfSaleCategoryCreateVenueEntityRelationInput",
		ticketPrinters:"PointOfSaleCategoryCreateTicketPrintersEntityRelationInput"
	},
	PointOfSaleCategoryUpdateInput:{
		locales:"PointOfSaleCategoryUpdateLocalesEntityRelationInput",
		products:"PointOfSaleCategoryUpdateProductsEntityRelationInput",
		category:"PointOfSaleCategoryUpdateCategoryEntityRelationInput",
		venue:"PointOfSaleCategoryUpdateVenueEntityRelationInput",
		ticketPrinters:"PointOfSaleCategoryUpdateTicketPrintersEntityRelationInput"
	},
	PointOfSaleCategoryLocaleCreateInput:{
		id:"UUID",
		root:"PointOfSaleCategoryLocaleCreateRootEntityRelationInput",
		locale:"PointOfSaleCategoryLocaleCreateLocaleEntityRelationInput"
	},
	PointOfSaleCategoryLocaleUpdateInput:{
		root:"PointOfSaleCategoryLocaleUpdateRootEntityRelationInput",
		locale:"PointOfSaleCategoryLocaleUpdateLocaleEntityRelationInput"
	},
	PointOfSaleCategoryProductCreateInput:{
		id:"UUID",
		category:"PointOfSaleCategoryProductCreateCategoryEntityRelationInput",
		product:"PointOfSaleCategoryProductCreateProductEntityRelationInput",
		locales:"PointOfSaleCategoryProductCreateLocalesEntityRelationInput"
	},
	PointOfSaleCategoryProductUpdateInput:{
		category:"PointOfSaleCategoryProductUpdateCategoryEntityRelationInput",
		product:"PointOfSaleCategoryProductUpdateProductEntityRelationInput",
		locales:"PointOfSaleCategoryProductUpdateLocalesEntityRelationInput"
	},
	PointOfSaleCategoryProductLocaleCreateInput:{
		id:"UUID",
		root:"PointOfSaleCategoryProductLocaleCreateRootEntityRelationInput",
		locale:"PointOfSaleCategoryProductLocaleCreateLocaleEntityRelationInput"
	},
	PointOfSaleCategoryProductLocaleUpdateInput:{
		root:"PointOfSaleCategoryProductLocaleUpdateRootEntityRelationInput",
		locale:"PointOfSaleCategoryProductLocaleUpdateLocaleEntityRelationInput"
	},
	CustomerTabCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		items:"CustomerTabCreateItemsEntityRelationInput",
		meta:"CustomerTabCreateMetaEntityRelationInput",
		customer:"CustomerTabCreateCustomerEntityRelationInput",
		table:"CustomerTabCreateTableEntityRelationInput",
		seat:"CustomerTabCreateSeatEntityRelationInput"
	},
	CustomerTabUpdateInput:{
		createdAt:"DateTime",
		items:"CustomerTabUpdateItemsEntityRelationInput",
		meta:"CustomerTabUpdateMetaEntityRelationInput",
		customer:"CustomerTabUpdateCustomerEntityRelationInput",
		table:"CustomerTabUpdateTableEntityRelationInput",
		seat:"CustomerTabUpdateSeatEntityRelationInput"
	},
	CustomerTabItemCreateInput:{
		id:"UUID",
		addedAt:"DateTime",
		tab:"CustomerTabItemCreateTabEntityRelationInput",
		product:"CustomerTabItemCreateProductEntityRelationInput",
		paidAt:"DateTime"
	},
	CustomerTabItemCreateTabEntityRelationInput:{
		connect:"CustomerTabUniqueWhere",
		create:"CustomerTabWithoutItemsCreateInput"
	},
	CustomerTabWithoutItemsCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		meta:"CustomerTabCreateMetaEntityRelationInput",
		customer:"CustomerTabCreateCustomerEntityRelationInput",
		table:"CustomerTabCreateTableEntityRelationInput",
		seat:"CustomerTabCreateSeatEntityRelationInput"
	},
	CustomerTabItemUpdateInput:{
		addedAt:"DateTime",
		tab:"CustomerTabItemUpdateTabEntityRelationInput",
		product:"CustomerTabItemUpdateProductEntityRelationInput",
		paidAt:"DateTime"
	},
	CustomerTabItemUpdateTabEntityRelationInput:{
		create:"CustomerTabWithoutItemsCreateInput",
		update:"CustomerTabWithoutItemsUpdateInput",
		upsert:"CustomerTabItemUpsertTabRelationInput",
		connect:"CustomerTabUniqueWhere"
	},
	CustomerTabWithoutItemsUpdateInput:{
		createdAt:"DateTime",
		meta:"CustomerTabUpdateMetaEntityRelationInput",
		customer:"CustomerTabUpdateCustomerEntityRelationInput",
		table:"CustomerTabUpdateTableEntityRelationInput",
		seat:"CustomerTabUpdateSeatEntityRelationInput"
	},
	CustomerTabItemUpsertTabRelationInput:{
		update:"CustomerTabWithoutItemsUpdateInput",
		create:"CustomerTabWithoutItemsCreateInput"
	},
	AnonymousSessionCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		lastActiveAt:"DateTime",
		customer:"AnonymousSessionCreateCustomerEntityRelationInput",
		devices:"AnonymousSessionCreateDevicesEntityRelationInput"
	},
	AnonymousSessionUpdateInput:{
		createdAt:"DateTime",
		lastActiveAt:"DateTime",
		customer:"AnonymousSessionUpdateCustomerEntityRelationInput",
		devices:"AnonymousSessionUpdateDevicesEntityRelationInput"
	},
	VoucherCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		activatedAt:"DateTime",
		expiresAt:"DateTime",
		type:"VoucherType",
		buyer:"VoucherCreateBuyerEntityRelationInput",
		owner:"VoucherCreateOwnerEntityRelationInput",
		vatRate:"VoucherCreateVatRateEntityRelationInput",
		virtualProductEffect:"VoucherCreateVirtualProductEffectEntityRelationInput",
		redemption:"VoucherCreateRedemptionEntityRelationInput"
	},
	VoucherUpdateInput:{
		createdAt:"DateTime",
		activatedAt:"DateTime",
		expiresAt:"DateTime",
		type:"VoucherType",
		buyer:"VoucherUpdateBuyerEntityRelationInput",
		owner:"VoucherUpdateOwnerEntityRelationInput",
		vatRate:"VoucherUpdateVatRateEntityRelationInput",
		virtualProductEffect:"VoucherUpdateVirtualProductEffectEntityRelationInput",
		redemption:"VoucherUpdateRedemptionEntityRelationInput"
	},
	VoucherRedemptionCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		customerCredit:"VoucherRedemptionCreateCustomerCreditEntityRelationInput",
		orderDiscount:"VoucherRedemptionCreateOrderDiscountEntityRelationInput",
		voucher:"VoucherRedemptionCreateVoucherEntityRelationInput",
		customer:"VoucherRedemptionCreateCustomerEntityRelationInput"
	},
	VoucherRedemptionUpdateInput:{
		createdAt:"DateTime",
		customerCredit:"VoucherRedemptionUpdateCustomerCreditEntityRelationInput",
		orderDiscount:"VoucherRedemptionUpdateOrderDiscountEntityRelationInput",
		voucher:"VoucherRedemptionUpdateVoucherEntityRelationInput",
		customer:"VoucherRedemptionUpdateCustomerEntityRelationInput"
	},
	UnassignedShiftInfoCreateInput:{
		id:"UUID",
		queueItem:"UnassignedShiftInfoCreateQueueItemEntityRelationInput",
		legacyReason:"UnassignedInfoReason",
		reason:"UnassignedShiftInfoCreateReasonEntityRelationInput"
	},
	UnassignedShiftInfoCreateQueueItemEntityRelationInput:{
		connect:"EmployeeQueueItemUniqueWhere",
		create:"EmployeeQueueItemWithoutUnassignInfoCreateInput"
	},
	EmployeeQueueItemWithoutUnassignInfoCreateInput:{
		id:"UUID",
		queue:"EmployeeQueueItemCreateQueueEntityRelationInput",
		shiftsProfile:"EmployeeQueueItemCreateShiftsProfileEntityRelationInput",
		shift:"EmployeeQueueItemCreateShiftEntityRelationInput",
		meta:"EmployeeQueueItemCreateMetaEntityRelationInput"
	},
	UnassignedShiftInfoUpdateInput:{
		queueItem:"UnassignedShiftInfoUpdateQueueItemEntityRelationInput",
		legacyReason:"UnassignedInfoReason",
		reason:"UnassignedShiftInfoUpdateReasonEntityRelationInput"
	},
	UnassignedShiftInfoUpdateQueueItemEntityRelationInput:{
		create:"EmployeeQueueItemWithoutUnassignInfoCreateInput",
		update:"EmployeeQueueItemWithoutUnassignInfoUpdateInput",
		upsert:"UnassignedShiftInfoUpsertQueueItemRelationInput",
		connect:"EmployeeQueueItemUniqueWhere"
	},
	EmployeeQueueItemWithoutUnassignInfoUpdateInput:{
		queue:"EmployeeQueueItemUpdateQueueEntityRelationInput",
		shiftsProfile:"EmployeeQueueItemUpdateShiftsProfileEntityRelationInput",
		shift:"EmployeeQueueItemUpdateShiftEntityRelationInput",
		meta:"EmployeeQueueItemUpdateMetaEntityRelationInput"
	},
	UnassignedShiftInfoUpsertQueueItemRelationInput:{
		update:"EmployeeQueueItemWithoutUnassignInfoUpdateInput",
		create:"EmployeeQueueItemWithoutUnassignInfoCreateInput"
	},
	TextItemCreateInput:{
		id:"UUID",
		list:"TextItemCreateListEntityRelationInput"
	},
	TextItemCreateListEntityRelationInput:{
		connect:"TextListUniqueWhere",
		create:"TextListWithoutItemsCreateInput"
	},
	TextListWithoutItemsCreateInput:{
		id:"UUID"
	},
	TextItemUpdateInput:{
		list:"TextItemUpdateListEntityRelationInput"
	},
	TextItemUpdateListEntityRelationInput:{
		create:"TextListWithoutItemsCreateInput",
		update:"TextListWithoutItemsUpdateInput",
		upsert:"TextItemUpsertListRelationInput",
		connect:"TextListUniqueWhere"
	},
	TextListWithoutItemsUpdateInput:{

	},
	TextItemUpsertListRelationInput:{
		update:"TextListWithoutItemsUpdateInput",
		create:"TextListWithoutItemsCreateInput"
	},
	DeliveryRegionsItemCreateInput:{
		id:"UUID",
		list:"DeliveryRegionsItemCreateListEntityRelationInput",
		image:"DeliveryRegionsItemCreateImageEntityRelationInput",
		textList:"DeliveryRegionsItemCreateTextListEntityRelationInput",
		gallery:"DeliveryRegionsItemCreateGalleryEntityRelationInput"
	},
	DeliveryRegionsItemCreateListEntityRelationInput:{
		connect:"DeliveryRegionsUniqueWhere",
		create:"DeliveryRegionsWithoutItemsCreateInput"
	},
	DeliveryRegionsWithoutItemsCreateInput:{
		id:"UUID"
	},
	DeliveryRegionsItemUpdateInput:{
		list:"DeliveryRegionsItemUpdateListEntityRelationInput",
		image:"DeliveryRegionsItemUpdateImageEntityRelationInput",
		textList:"DeliveryRegionsItemUpdateTextListEntityRelationInput",
		gallery:"DeliveryRegionsItemUpdateGalleryEntityRelationInput"
	},
	DeliveryRegionsItemUpdateListEntityRelationInput:{
		create:"DeliveryRegionsWithoutItemsCreateInput",
		update:"DeliveryRegionsWithoutItemsUpdateInput",
		upsert:"DeliveryRegionsItemUpsertListRelationInput",
		connect:"DeliveryRegionsUniqueWhere"
	},
	DeliveryRegionsWithoutItemsUpdateInput:{

	},
	DeliveryRegionsItemUpsertListRelationInput:{
		update:"DeliveryRegionsWithoutItemsUpdateInput",
		create:"DeliveryRegionsWithoutItemsCreateInput"
	},
	ImageListItemCreateInput:{
		id:"UUID",
		list:"ImageListItemCreateListEntityRelationInput",
		image:"ImageListItemCreateImageEntityRelationInput"
	},
	ImageListItemCreateListEntityRelationInput:{
		connect:"ImageListUniqueWhere",
		create:"ImageListWithoutItemsCreateInput"
	},
	ImageListWithoutItemsCreateInput:{
		id:"UUID"
	},
	ImageListItemUpdateInput:{
		list:"ImageListItemUpdateListEntityRelationInput",
		image:"ImageListItemUpdateImageEntityRelationInput"
	},
	ImageListItemUpdateListEntityRelationInput:{
		create:"ImageListWithoutItemsCreateInput",
		update:"ImageListWithoutItemsUpdateInput",
		upsert:"ImageListItemUpsertListRelationInput",
		connect:"ImageListUniqueWhere"
	},
	ImageListWithoutItemsUpdateInput:{

	},
	ImageListItemUpsertListRelationInput:{
		update:"ImageListWithoutItemsUpdateInput",
		create:"ImageListWithoutItemsCreateInput"
	},
	TimetablesEmployeePrivilegesCreateInput:{
		id:"UUID",
		venueEmployeeRole:"TimetablesEmployeePrivilegesCreateVenueEmployeeRoleEntityRelationInput"
	},
	TimetablesEmployeePrivilegesCreateVenueEmployeeRoleEntityRelationInput:{
		connect:"VenueEmployeeRoleUniqueWhere",
		create:"VenueEmployeeRoleWithoutEmployeePrivilegesCreateInput"
	},
	VenueEmployeeRoleWithoutEmployeePrivilegesCreateInput:{
		id:"UUID",
		venue:"VenueEmployeeRoleCreateVenueEntityRelationInput",
		role:"VenueEmployeeRoleCreateRoleEntityRelationInput"
	},
	VenueEmployeeRoleCreateVenueEntityRelationInput:{
		connect:"VenueUniqueWhere",
		create:"VenueWithoutEmployeeRolesCreateInput"
	},
	VenueWithoutEmployeeRolesCreateInput:{
		id:"UUID",
		deadlineTemplate:"VenueCreateDeadlineTemplateEntityRelationInput",
		timetableDays:"VenueCreateTimetableDaysEntityRelationInput",
		timetableTemplates:"VenueCreateTimetableTemplatesEntityRelationInput",
		staffMembers:"VenueCreateStaffMembersEntityRelationInput",
		pointOfSaleApplicationDevices:"VenueCreatePointOfSaleApplicationDevicesEntityRelationInput",
		pointOfSaleTerminals:"VenueCreatePointOfSaleTerminalsEntityRelationInput",
		pointOfSalePrinters:"VenueCreatePointOfSalePrintersEntityRelationInput",
		orders:"VenueCreateOrdersEntityRelationInput",
		fulfillmentNotes:"VenueCreateFulfillmentNotesEntityRelationInput",
		areas:"VenueCreateAreasEntityRelationInput",
		enabledUnassignReasons:"VenueCreateEnabledUnassignReasonsEntityRelationInput",
		categories:"VenueCreateCategoriesEntityRelationInput",
		channels:"VenueCreateChannelsEntityRelationInput",
		pointOfSaleInitialView:"PointOfSaleInitialView"
	},
	TimetablesEmployeePrivilegesUpdateInput:{
		venueEmployeeRole:"TimetablesEmployeePrivilegesUpdateVenueEmployeeRoleEntityRelationInput"
	},
	TimetablesEmployeePrivilegesUpdateVenueEmployeeRoleEntityRelationInput:{
		create:"VenueEmployeeRoleWithoutEmployeePrivilegesCreateInput",
		update:"VenueEmployeeRoleWithoutEmployeePrivilegesUpdateInput",
		upsert:"TimetablesEmployeePrivilegesUpsertVenueEmployeeRoleRelationInput",
		connect:"VenueEmployeeRoleUniqueWhere"
	},
	VenueEmployeeRoleWithoutEmployeePrivilegesUpdateInput:{
		venue:"VenueEmployeeRoleUpdateVenueEntityRelationInput",
		role:"VenueEmployeeRoleUpdateRoleEntityRelationInput"
	},
	VenueEmployeeRoleUpdateVenueEntityRelationInput:{
		create:"VenueWithoutEmployeeRolesCreateInput",
		update:"VenueWithoutEmployeeRolesUpdateInput",
		upsert:"VenueEmployeeRoleUpsertVenueRelationInput",
		connect:"VenueUniqueWhere"
	},
	VenueWithoutEmployeeRolesUpdateInput:{
		deadlineTemplate:"VenueUpdateDeadlineTemplateEntityRelationInput",
		timetableDays:"VenueUpdateTimetableDaysEntityRelationInput",
		timetableTemplates:"VenueUpdateTimetableTemplatesEntityRelationInput",
		staffMembers:"VenueUpdateStaffMembersEntityRelationInput",
		pointOfSaleApplicationDevices:"VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput",
		pointOfSaleTerminals:"VenueUpdatePointOfSaleTerminalsEntityRelationInput",
		pointOfSalePrinters:"VenueUpdatePointOfSalePrintersEntityRelationInput",
		orders:"VenueUpdateOrdersEntityRelationInput",
		fulfillmentNotes:"VenueUpdateFulfillmentNotesEntityRelationInput",
		areas:"VenueUpdateAreasEntityRelationInput",
		enabledUnassignReasons:"VenueUpdateEnabledUnassignReasonsEntityRelationInput",
		categories:"VenueUpdateCategoriesEntityRelationInput",
		channels:"VenueUpdateChannelsEntityRelationInput",
		pointOfSaleInitialView:"PointOfSaleInitialView"
	},
	VenueEmployeeRoleUpsertVenueRelationInput:{
		update:"VenueWithoutEmployeeRolesUpdateInput",
		create:"VenueWithoutEmployeeRolesCreateInput"
	},
	TimetablesEmployeePrivilegesUpsertVenueEmployeeRoleRelationInput:{
		update:"VenueEmployeeRoleWithoutEmployeePrivilegesUpdateInput",
		create:"VenueEmployeeRoleWithoutEmployeePrivilegesCreateInput"
	},
	TimetableDayNoteCreateInput:{
		id:"UUID",
		day:"TimetableDayNoteCreateDayEntityRelationInput",
		role:"TimetableDayNoteCreateRoleEntityRelationInput"
	},
	TimetableDayNoteCreateDayEntityRelationInput:{
		connect:"TimetableDayUniqueWhere",
		create:"TimetableDayWithoutNotesCreateInput"
	},
	TimetableDayWithoutNotesCreateInput:{
		id:"UUID",
		date:"Date",
		type:"TimetableDayType",
		shiftGroups:"TimetableDayCreateShiftGroupsEntityRelationInput",
		venue:"TimetableDayCreateVenueEntityRelationInput",
		meta:"TimetableDayCreateMetaEntityRelationInput"
	},
	TimetableDayNoteUpdateInput:{
		day:"TimetableDayNoteUpdateDayEntityRelationInput",
		role:"TimetableDayNoteUpdateRoleEntityRelationInput"
	},
	TimetableDayNoteUpdateDayEntityRelationInput:{
		create:"TimetableDayWithoutNotesCreateInput",
		update:"TimetableDayWithoutNotesUpdateInput",
		upsert:"TimetableDayNoteUpsertDayRelationInput",
		connect:"TimetableDayUniqueWhere"
	},
	TimetableDayWithoutNotesUpdateInput:{
		date:"Date",
		type:"TimetableDayType",
		shiftGroups:"TimetableDayUpdateShiftGroupsEntityRelationInput",
		venue:"TimetableDayUpdateVenueEntityRelationInput",
		meta:"TimetableDayUpdateMetaEntityRelationInput"
	},
	TimetableDayNoteUpsertDayRelationInput:{
		update:"TimetableDayWithoutNotesUpdateInput",
		create:"TimetableDayWithoutNotesCreateInput"
	},
	DeliveryMethodLocaleCreateInput:{
		id:"UUID",
		locale:"DeliveryMethodLocaleCreateLocaleEntityRelationInput",
		root:"DeliveryMethodLocaleCreateRootEntityRelationInput"
	},
	DeliveryMethodLocaleUpdateInput:{
		locale:"DeliveryMethodLocaleUpdateLocaleEntityRelationInput",
		root:"DeliveryMethodLocaleUpdateRootEntityRelationInput"
	},
	IngredientSupplierItemCreateInput:{
		id:"UUID",
		list:"IngredientSupplierItemCreateListEntityRelationInput",
		supplier:"IngredientSupplierItemCreateSupplierEntityRelationInput"
	},
	IngredientSupplierItemCreateListEntityRelationInput:{
		connect:"IngredientSupplierListUniqueWhere",
		create:"IngredientSupplierListWithoutItemsCreateInput"
	},
	IngredientSupplierListWithoutItemsCreateInput:{
		id:"UUID"
	},
	IngredientSupplierItemUpdateInput:{
		list:"IngredientSupplierItemUpdateListEntityRelationInput",
		supplier:"IngredientSupplierItemUpdateSupplierEntityRelationInput"
	},
	IngredientSupplierItemUpdateListEntityRelationInput:{
		create:"IngredientSupplierListWithoutItemsCreateInput",
		update:"IngredientSupplierListWithoutItemsUpdateInput",
		upsert:"IngredientSupplierItemUpsertListRelationInput",
		connect:"IngredientSupplierListUniqueWhere"
	},
	IngredientSupplierListWithoutItemsUpdateInput:{

	},
	IngredientSupplierItemUpsertListRelationInput:{
		update:"IngredientSupplierListWithoutItemsUpdateInput",
		create:"IngredientSupplierListWithoutItemsCreateInput"
	},
	IngredientSupplierLocaleCreateInput:{
		id:"UUID",
		root:"IngredientSupplierLocaleCreateRootEntityRelationInput",
		locale:"IngredientSupplierLocaleCreateLocaleEntityRelationInput"
	},
	IngredientSupplierLocaleUpdateInput:{
		root:"IngredientSupplierLocaleUpdateRootEntityRelationInput",
		locale:"IngredientSupplierLocaleUpdateLocaleEntityRelationInput"
	},
	RedirectCreateInput:{
		id:"UUID",
		link:"RedirectCreateLinkEntityRelationInput",
		target:"RedirectCreateTargetEntityRelationInput"
	},
	RedirectCreateLinkEntityRelationInput:{
		connect:"LinkableUniqueWhere",
		create:"LinkableWithoutRedirectCreateInput"
	},
	LinkableWithoutRedirectCreateInput:{
		id:"UUID",
		blogPost:"LinkableCreateBlogPostEntityRelationInput",
		page:"LinkableCreatePageEntityRelationInput",
		wikiPage:"LinkableCreateWikiPageEntityRelationInput"
	},
	RedirectUpdateInput:{
		link:"RedirectUpdateLinkEntityRelationInput",
		target:"RedirectUpdateTargetEntityRelationInput"
	},
	RedirectUpdateLinkEntityRelationInput:{
		create:"LinkableWithoutRedirectCreateInput",
		update:"LinkableWithoutRedirectUpdateInput",
		upsert:"RedirectUpsertLinkRelationInput",
		connect:"LinkableUniqueWhere"
	},
	LinkableWithoutRedirectUpdateInput:{
		blogPost:"LinkableUpdateBlogPostEntityRelationInput",
		page:"LinkableUpdatePageEntityRelationInput",
		wikiPage:"LinkableUpdateWikiPageEntityRelationInput"
	},
	RedirectUpsertLinkRelationInput:{
		update:"LinkableWithoutRedirectUpdateInput",
		create:"LinkableWithoutRedirectCreateInput"
	},
	VenueCreateInput:{
		id:"UUID",
		deadlineTemplate:"VenueCreateDeadlineTemplateEntityRelationInput",
		timetableDays:"VenueCreateTimetableDaysEntityRelationInput",
		timetableTemplates:"VenueCreateTimetableTemplatesEntityRelationInput",
		staffMembers:"VenueCreateStaffMembersEntityRelationInput",
		employeeRoles:"VenueCreateEmployeeRolesEntityRelationInput",
		pointOfSaleApplicationDevices:"VenueCreatePointOfSaleApplicationDevicesEntityRelationInput",
		pointOfSaleTerminals:"VenueCreatePointOfSaleTerminalsEntityRelationInput",
		pointOfSalePrinters:"VenueCreatePointOfSalePrintersEntityRelationInput",
		orders:"VenueCreateOrdersEntityRelationInput",
		fulfillmentNotes:"VenueCreateFulfillmentNotesEntityRelationInput",
		areas:"VenueCreateAreasEntityRelationInput",
		enabledUnassignReasons:"VenueCreateEnabledUnassignReasonsEntityRelationInput",
		categories:"VenueCreateCategoriesEntityRelationInput",
		channels:"VenueCreateChannelsEntityRelationInput",
		pointOfSaleInitialView:"PointOfSaleInitialView"
	},
	VenueUpdateInput:{
		deadlineTemplate:"VenueUpdateDeadlineTemplateEntityRelationInput",
		timetableDays:"VenueUpdateTimetableDaysEntityRelationInput",
		timetableTemplates:"VenueUpdateTimetableTemplatesEntityRelationInput",
		staffMembers:"VenueUpdateStaffMembersEntityRelationInput",
		employeeRoles:"VenueUpdateEmployeeRolesEntityRelationInput",
		pointOfSaleApplicationDevices:"VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput",
		pointOfSaleTerminals:"VenueUpdatePointOfSaleTerminalsEntityRelationInput",
		pointOfSalePrinters:"VenueUpdatePointOfSalePrintersEntityRelationInput",
		orders:"VenueUpdateOrdersEntityRelationInput",
		fulfillmentNotes:"VenueUpdateFulfillmentNotesEntityRelationInput",
		areas:"VenueUpdateAreasEntityRelationInput",
		enabledUnassignReasons:"VenueUpdateEnabledUnassignReasonsEntityRelationInput",
		categories:"VenueUpdateCategoriesEntityRelationInput",
		channels:"VenueUpdateChannelsEntityRelationInput",
		pointOfSaleInitialView:"PointOfSaleInitialView"
	},
	WorkspaceCreateInput:{
		id:"UUID",
		unique:"One",
		freshingContainers:"WorkspaceCreateFreshingContainersEntityRelationInput",
		openingHours:"WorkspaceCreateOpeningHoursEntityRelationInput",
		workingHours:"WorkspaceCreateWorkingHoursEntityRelationInput",
		defaultFreshingContainer:"WorkspaceCreateDefaultFreshingContainerEntityRelationInput",
		creditsProduct:"WorkspaceCreateCreditsProductEntityRelationInput",
		discountVatRate:"WorkspaceCreateDiscountVatRateEntityRelationInput"
	},
	WorkspaceCreateFreshingContainersEntityRelationInput:{
		connect:"FreshingContainerUniqueWhere",
		create:"FreshingContainerWithoutWorkspaceCreateInput"
	},
	FreshingContainerWithoutWorkspaceCreateInput:{
		id:"UUID"
	},
	WorkspaceUpdateInput:{
		unique:"One",
		freshingContainers:"WorkspaceUpdateFreshingContainersEntityRelationInput",
		openingHours:"WorkspaceUpdateOpeningHoursEntityRelationInput",
		workingHours:"WorkspaceUpdateWorkingHoursEntityRelationInput",
		defaultFreshingContainer:"WorkspaceUpdateDefaultFreshingContainerEntityRelationInput",
		creditsProduct:"WorkspaceUpdateCreditsProductEntityRelationInput",
		discountVatRate:"WorkspaceUpdateDiscountVatRateEntityRelationInput"
	},
	WorkspaceUpdateFreshingContainersEntityRelationInput:{
		create:"FreshingContainerWithoutWorkspaceCreateInput",
		update:"WorkspaceUpdateFreshingContainersRelationInput",
		upsert:"WorkspaceUpsertFreshingContainersRelationInput",
		connect:"FreshingContainerUniqueWhere",
		disconnect:"FreshingContainerUniqueWhere",
		delete:"FreshingContainerUniqueWhere"
	},
	WorkspaceUpdateFreshingContainersRelationInput:{
		by:"FreshingContainerUniqueWhere",
		data:"FreshingContainerWithoutWorkspaceUpdateInput"
	},
	FreshingContainerWithoutWorkspaceUpdateInput:{

	},
	WorkspaceUpsertFreshingContainersRelationInput:{
		by:"FreshingContainerUniqueWhere",
		update:"FreshingContainerWithoutWorkspaceUpdateInput",
		create:"FreshingContainerWithoutWorkspaceCreateInput"
	},
	InternalBuyerCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		staff:"InternalBuyerCreateStaffEntityRelationInput"
	},
	InternalBuyerCreateStaffEntityRelationInput:{
		connect:"StaffUniqueWhere",
		create:"StaffWithoutInternalBuyerCreateInput"
	},
	StaffWithoutInternalBuyerCreateInput:{
		id:"UUID",
		bartender:"StaffCreateBartenderEntityRelationInput",
		courier:"StaffCreateCourierEntityRelationInput",
		cleaner:"StaffCreateCleanerEntityRelationInput",
		shiftsManager:"StaffCreateShiftsManagerEntityRelationInput",
		businessToBusinessManager:"StaffCreateBusinessToBusinessManagerEntityRelationInput",
		user:"StaffCreateUserEntityRelationInput",
		shiftsProfile:"StaffCreateShiftsProfileEntityRelationInput",
		stocksManager:"StaffCreateStocksManagerEntityRelationInput",
		photo:"StaffCreatePhotoEntityRelationInput",
		courierManager:"StaffCreateCourierManagerEntityRelationInput",
		picker:"StaffCreatePickerEntityRelationInput",
		createdAt:"DateTime",
		remunerationProfile:"StaffCreateRemunerationProfileEntityRelationInput",
		cashier:"StaffCreateCashierEntityRelationInput",
		venues:"StaffCreateVenuesEntityRelationInput",
		salesManager:"StaffCreateSalesManagerEntityRelationInput",
		cashierManager:"StaffCreateCashierManagerEntityRelationInput"
	},
	InternalBuyerUpdateInput:{
		createdAt:"DateTime",
		staff:"InternalBuyerUpdateStaffEntityRelationInput"
	},
	InternalBuyerUpdateStaffEntityRelationInput:{
		create:"StaffWithoutInternalBuyerCreateInput",
		update:"StaffWithoutInternalBuyerUpdateInput",
		upsert:"InternalBuyerUpsertStaffRelationInput",
		connect:"StaffUniqueWhere"
	},
	StaffWithoutInternalBuyerUpdateInput:{
		bartender:"StaffUpdateBartenderEntityRelationInput",
		courier:"StaffUpdateCourierEntityRelationInput",
		cleaner:"StaffUpdateCleanerEntityRelationInput",
		shiftsManager:"StaffUpdateShiftsManagerEntityRelationInput",
		businessToBusinessManager:"StaffUpdateBusinessToBusinessManagerEntityRelationInput",
		user:"StaffUpdateUserEntityRelationInput",
		shiftsProfile:"StaffUpdateShiftsProfileEntityRelationInput",
		stocksManager:"StaffUpdateStocksManagerEntityRelationInput",
		photo:"StaffUpdatePhotoEntityRelationInput",
		courierManager:"StaffUpdateCourierManagerEntityRelationInput",
		picker:"StaffUpdatePickerEntityRelationInput",
		createdAt:"DateTime",
		remunerationProfile:"StaffUpdateRemunerationProfileEntityRelationInput",
		cashier:"StaffUpdateCashierEntityRelationInput",
		venues:"StaffUpdateVenuesEntityRelationInput",
		salesManager:"StaffUpdateSalesManagerEntityRelationInput",
		cashierManager:"StaffUpdateCashierManagerEntityRelationInput"
	},
	InternalBuyerUpsertStaffRelationInput:{
		update:"StaffWithoutInternalBuyerUpdateInput",
		create:"StaffWithoutInternalBuyerCreateInput"
	},
	VenueEmployeeRoleCreateInput:{
		id:"UUID",
		employeePrivileges:"VenueEmployeeRoleCreateEmployeePrivilegesEntityRelationInput",
		venue:"VenueEmployeeRoleCreateVenueEntityRelationInput",
		role:"VenueEmployeeRoleCreateRoleEntityRelationInput"
	},
	VenueEmployeeRoleUpdateInput:{
		employeePrivileges:"VenueEmployeeRoleUpdateEmployeePrivilegesEntityRelationInput",
		venue:"VenueEmployeeRoleUpdateVenueEntityRelationInput",
		role:"VenueEmployeeRoleUpdateRoleEntityRelationInput"
	},
	IdentificationAttemptCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		code:"IdentificationAttemptCreateCodeEntityRelationInput",
		user:"IdentificationAttemptCreateUserEntityRelationInput"
	},
	IdentificationAttemptUpdateInput:{
		createdAt:"DateTime",
		code:"IdentificationAttemptUpdateCodeEntityRelationInput",
		user:"IdentificationAttemptUpdateUserEntityRelationInput"
	},
	IdentificationCodeCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		attempts:"IdentificationCodeCreateAttemptsEntityRelationInput",
		locales:"IdentificationCodeCreateLocalesEntityRelationInput",
		applicationDevices:"IdentificationCodeCreateApplicationDevicesEntityRelationInput"
	},
	IdentificationCodeUpdateInput:{
		createdAt:"DateTime",
		attempts:"IdentificationCodeUpdateAttemptsEntityRelationInput",
		locales:"IdentificationCodeUpdateLocalesEntityRelationInput",
		applicationDevices:"IdentificationCodeUpdateApplicationDevicesEntityRelationInput"
	},
	IdentificationCodeLocaleCreateInput:{
		id:"UUID",
		root:"IdentificationCodeLocaleCreateRootEntityRelationInput",
		locale:"IdentificationCodeLocaleCreateLocaleEntityRelationInput"
	},
	IdentificationCodeLocaleUpdateInput:{
		root:"IdentificationCodeLocaleUpdateRootEntityRelationInput",
		locale:"IdentificationCodeLocaleUpdateLocaleEntityRelationInput"
	},
	PipelineCreateInput:{
		id:"UUID",
		unique:"One",
		stages:"PipelineCreateStagesEntityRelationInput"
	},
	PipelineCreateStagesEntityRelationInput:{
		connect:"PipelineStageUniqueWhere",
		create:"PipelineStageWithoutPipelineCreateInput"
	},
	PipelineStageWithoutPipelineCreateInput:{
		id:"UUID",
		items:"PipelineStageCreateItemsEntityRelationInput",
		locales:"PipelineStageCreateLocalesEntityRelationInput",
		sentiment:"PipelineStageCreateSentimentEntityRelationInput",
		type:"PipelineStageType",
		forms:"PipelineStageCreateFormsEntityRelationInput"
	},
	PipelineUpdateInput:{
		unique:"One",
		stages:"PipelineUpdateStagesEntityRelationInput"
	},
	PipelineUpdateStagesEntityRelationInput:{
		create:"PipelineStageWithoutPipelineCreateInput",
		update:"PipelineUpdateStagesRelationInput",
		upsert:"PipelineUpsertStagesRelationInput",
		connect:"PipelineStageUniqueWhere",
		disconnect:"PipelineStageUniqueWhere",
		delete:"PipelineStageUniqueWhere"
	},
	PipelineUpdateStagesRelationInput:{
		by:"PipelineStageUniqueWhere",
		data:"PipelineStageWithoutPipelineUpdateInput"
	},
	PipelineStageWithoutPipelineUpdateInput:{
		items:"PipelineStageUpdateItemsEntityRelationInput",
		locales:"PipelineStageUpdateLocalesEntityRelationInput",
		sentiment:"PipelineStageUpdateSentimentEntityRelationInput",
		type:"PipelineStageType",
		forms:"PipelineStageUpdateFormsEntityRelationInput"
	},
	PipelineUpsertStagesRelationInput:{
		by:"PipelineStageUniqueWhere",
		update:"PipelineStageWithoutPipelineUpdateInput",
		create:"PipelineStageWithoutPipelineCreateInput"
	},
	PipelineLeadCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		stageItem:"PipelineLeadCreateStageItemEntityRelationInput",
		customer:"PipelineLeadCreateCustomerEntityRelationInput",
		form:"PipelineLeadCreateFormEntityRelationInput"
	},
	PipelineLeadUpdateInput:{
		createdAt:"DateTime",
		stageItem:"PipelineLeadUpdateStageItemEntityRelationInput",
		customer:"PipelineLeadUpdateCustomerEntityRelationInput",
		form:"PipelineLeadUpdateFormEntityRelationInput"
	},
	PipelineStageCreateInput:{
		id:"UUID",
		items:"PipelineStageCreateItemsEntityRelationInput",
		pipeline:"PipelineStageCreatePipelineEntityRelationInput",
		locales:"PipelineStageCreateLocalesEntityRelationInput",
		sentiment:"PipelineStageCreateSentimentEntityRelationInput",
		type:"PipelineStageType",
		forms:"PipelineStageCreateFormsEntityRelationInput"
	},
	PipelineStageUpdateInput:{
		items:"PipelineStageUpdateItemsEntityRelationInput",
		pipeline:"PipelineStageUpdatePipelineEntityRelationInput",
		locales:"PipelineStageUpdateLocalesEntityRelationInput",
		sentiment:"PipelineStageUpdateSentimentEntityRelationInput",
		type:"PipelineStageType",
		forms:"PipelineStageUpdateFormsEntityRelationInput"
	},
	PipelineStageItemCreateInput:{
		id:"UUID",
		list:"PipelineStageItemCreateListEntityRelationInput",
		lead:"PipelineStageItemCreateLeadEntityRelationInput"
	},
	PipelineStageItemUpdateInput:{
		list:"PipelineStageItemUpdateListEntityRelationInput",
		lead:"PipelineStageItemUpdateLeadEntityRelationInput"
	},
	PipelineStageLocaleCreateInput:{
		id:"UUID",
		root:"PipelineStageLocaleCreateRootEntityRelationInput",
		locale:"PipelineStageLocaleCreateLocaleEntityRelationInput"
	},
	PipelineStageLocaleUpdateInput:{
		root:"PipelineStageLocaleUpdateRootEntityRelationInput",
		locale:"PipelineStageLocaleUpdateLocaleEntityRelationInput"
	},
	SalesManagerCreateInput:{
		id:"UUID",
		staff:"SalesManagerCreateStaffEntityRelationInput",
		createdAt:"DateTime",
		countries:"SalesManagerCreateCountriesEntityRelationInput"
	},
	SalesManagerCreateStaffEntityRelationInput:{
		connect:"StaffUniqueWhere",
		create:"StaffWithoutSalesManagerCreateInput"
	},
	StaffWithoutSalesManagerCreateInput:{
		id:"UUID",
		bartender:"StaffCreateBartenderEntityRelationInput",
		courier:"StaffCreateCourierEntityRelationInput",
		cleaner:"StaffCreateCleanerEntityRelationInput",
		shiftsManager:"StaffCreateShiftsManagerEntityRelationInput",
		businessToBusinessManager:"StaffCreateBusinessToBusinessManagerEntityRelationInput",
		user:"StaffCreateUserEntityRelationInput",
		shiftsProfile:"StaffCreateShiftsProfileEntityRelationInput",
		stocksManager:"StaffCreateStocksManagerEntityRelationInput",
		photo:"StaffCreatePhotoEntityRelationInput",
		courierManager:"StaffCreateCourierManagerEntityRelationInput",
		picker:"StaffCreatePickerEntityRelationInput",
		createdAt:"DateTime",
		remunerationProfile:"StaffCreateRemunerationProfileEntityRelationInput",
		cashier:"StaffCreateCashierEntityRelationInput",
		venues:"StaffCreateVenuesEntityRelationInput",
		internalBuyer:"StaffCreateInternalBuyerEntityRelationInput",
		cashierManager:"StaffCreateCashierManagerEntityRelationInput"
	},
	SalesManagerUpdateInput:{
		staff:"SalesManagerUpdateStaffEntityRelationInput",
		createdAt:"DateTime",
		countries:"SalesManagerUpdateCountriesEntityRelationInput"
	},
	SalesManagerUpdateStaffEntityRelationInput:{
		create:"StaffWithoutSalesManagerCreateInput",
		update:"StaffWithoutSalesManagerUpdateInput",
		upsert:"SalesManagerUpsertStaffRelationInput",
		connect:"StaffUniqueWhere"
	},
	StaffWithoutSalesManagerUpdateInput:{
		bartender:"StaffUpdateBartenderEntityRelationInput",
		courier:"StaffUpdateCourierEntityRelationInput",
		cleaner:"StaffUpdateCleanerEntityRelationInput",
		shiftsManager:"StaffUpdateShiftsManagerEntityRelationInput",
		businessToBusinessManager:"StaffUpdateBusinessToBusinessManagerEntityRelationInput",
		user:"StaffUpdateUserEntityRelationInput",
		shiftsProfile:"StaffUpdateShiftsProfileEntityRelationInput",
		stocksManager:"StaffUpdateStocksManagerEntityRelationInput",
		photo:"StaffUpdatePhotoEntityRelationInput",
		courierManager:"StaffUpdateCourierManagerEntityRelationInput",
		picker:"StaffUpdatePickerEntityRelationInput",
		createdAt:"DateTime",
		remunerationProfile:"StaffUpdateRemunerationProfileEntityRelationInput",
		cashier:"StaffUpdateCashierEntityRelationInput",
		venues:"StaffUpdateVenuesEntityRelationInput",
		internalBuyer:"StaffUpdateInternalBuyerEntityRelationInput",
		cashierManager:"StaffUpdateCashierManagerEntityRelationInput"
	},
	SalesManagerUpsertStaffRelationInput:{
		update:"StaffWithoutSalesManagerUpdateInput",
		create:"StaffWithoutSalesManagerCreateInput"
	},
	CashierManagerCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		staff:"CashierManagerCreateStaffEntityRelationInput"
	},
	CashierManagerCreateStaffEntityRelationInput:{
		connect:"StaffUniqueWhere",
		create:"StaffWithoutCashierManagerCreateInput"
	},
	StaffWithoutCashierManagerCreateInput:{
		id:"UUID",
		bartender:"StaffCreateBartenderEntityRelationInput",
		courier:"StaffCreateCourierEntityRelationInput",
		cleaner:"StaffCreateCleanerEntityRelationInput",
		shiftsManager:"StaffCreateShiftsManagerEntityRelationInput",
		businessToBusinessManager:"StaffCreateBusinessToBusinessManagerEntityRelationInput",
		user:"StaffCreateUserEntityRelationInput",
		shiftsProfile:"StaffCreateShiftsProfileEntityRelationInput",
		stocksManager:"StaffCreateStocksManagerEntityRelationInput",
		photo:"StaffCreatePhotoEntityRelationInput",
		courierManager:"StaffCreateCourierManagerEntityRelationInput",
		picker:"StaffCreatePickerEntityRelationInput",
		createdAt:"DateTime",
		remunerationProfile:"StaffCreateRemunerationProfileEntityRelationInput",
		cashier:"StaffCreateCashierEntityRelationInput",
		venues:"StaffCreateVenuesEntityRelationInput",
		internalBuyer:"StaffCreateInternalBuyerEntityRelationInput",
		salesManager:"StaffCreateSalesManagerEntityRelationInput"
	},
	CashierManagerUpdateInput:{
		createdAt:"DateTime",
		staff:"CashierManagerUpdateStaffEntityRelationInput"
	},
	CashierManagerUpdateStaffEntityRelationInput:{
		create:"StaffWithoutCashierManagerCreateInput",
		update:"StaffWithoutCashierManagerUpdateInput",
		upsert:"CashierManagerUpsertStaffRelationInput",
		connect:"StaffUniqueWhere"
	},
	StaffWithoutCashierManagerUpdateInput:{
		bartender:"StaffUpdateBartenderEntityRelationInput",
		courier:"StaffUpdateCourierEntityRelationInput",
		cleaner:"StaffUpdateCleanerEntityRelationInput",
		shiftsManager:"StaffUpdateShiftsManagerEntityRelationInput",
		businessToBusinessManager:"StaffUpdateBusinessToBusinessManagerEntityRelationInput",
		user:"StaffUpdateUserEntityRelationInput",
		shiftsProfile:"StaffUpdateShiftsProfileEntityRelationInput",
		stocksManager:"StaffUpdateStocksManagerEntityRelationInput",
		photo:"StaffUpdatePhotoEntityRelationInput",
		courierManager:"StaffUpdateCourierManagerEntityRelationInput",
		picker:"StaffUpdatePickerEntityRelationInput",
		createdAt:"DateTime",
		remunerationProfile:"StaffUpdateRemunerationProfileEntityRelationInput",
		cashier:"StaffUpdateCashierEntityRelationInput",
		venues:"StaffUpdateVenuesEntityRelationInput",
		internalBuyer:"StaffUpdateInternalBuyerEntityRelationInput",
		salesManager:"StaffUpdateSalesManagerEntityRelationInput"
	},
	CashierManagerUpsertStaffRelationInput:{
		update:"StaffWithoutCashierManagerUpdateInput",
		create:"StaffWithoutCashierManagerCreateInput"
	},
	PointOfSaleApplicationDeviceCreateInput:{
		id:"UUID",
		venue:"PointOfSaleApplicationDeviceCreateVenueEntityRelationInput",
		identificationCode:"PointOfSaleApplicationDeviceCreateIdentificationCodeEntityRelationInput",
		identifier:"PointOfSaleApplicationDeviceCreateIdentifierEntityRelationInput",
		terminal:"PointOfSaleApplicationDeviceCreateTerminalEntityRelationInput",
		receiptPrinter:"PointOfSaleApplicationDeviceCreateReceiptPrinterEntityRelationInput",
		ticketPrinters:"PointOfSaleApplicationDeviceCreateTicketPrintersEntityRelationInput"
	},
	PointOfSaleApplicationDeviceUpdateInput:{
		venue:"PointOfSaleApplicationDeviceUpdateVenueEntityRelationInput",
		identificationCode:"PointOfSaleApplicationDeviceUpdateIdentificationCodeEntityRelationInput",
		identifier:"PointOfSaleApplicationDeviceUpdateIdentifierEntityRelationInput",
		terminal:"PointOfSaleApplicationDeviceUpdateTerminalEntityRelationInput",
		receiptPrinter:"PointOfSaleApplicationDeviceUpdateReceiptPrinterEntityRelationInput",
		ticketPrinters:"PointOfSaleApplicationDeviceUpdateTicketPrintersEntityRelationInput"
	},
	PointOfSaleTerminalCreateInput:{
		id:"UUID",
		venue:"PointOfSaleTerminalCreateVenueEntityRelationInput",
		applicationDevices:"PointOfSaleTerminalCreateApplicationDevicesEntityRelationInput",
		type:"PointOfSaleTerminalType"
	},
	PointOfSaleTerminalUpdateInput:{
		venue:"PointOfSaleTerminalUpdateVenueEntityRelationInput",
		applicationDevices:"PointOfSaleTerminalUpdateApplicationDevicesEntityRelationInput",
		type:"PointOfSaleTerminalType"
	},
	DeviceIdentifierCreateInput:{
		id:"UUID",
		device:"DeviceIdentifierCreateDeviceEntityRelationInput",
		updatedAt:"DateTime",
		updatedByUser:"DeviceIdentifierCreateUpdatedByUserEntityRelationInput"
	},
	DeviceIdentifierCreateDeviceEntityRelationInput:{
		connect:"PointOfSaleApplicationDeviceUniqueWhere",
		create:"PointOfSaleApplicationDeviceWithoutIdentifierCreateInput"
	},
	PointOfSaleApplicationDeviceWithoutIdentifierCreateInput:{
		id:"UUID",
		venue:"PointOfSaleApplicationDeviceCreateVenueEntityRelationInput",
		identificationCode:"PointOfSaleApplicationDeviceCreateIdentificationCodeEntityRelationInput",
		terminal:"PointOfSaleApplicationDeviceCreateTerminalEntityRelationInput",
		receiptPrinter:"PointOfSaleApplicationDeviceCreateReceiptPrinterEntityRelationInput",
		ticketPrinters:"PointOfSaleApplicationDeviceCreateTicketPrintersEntityRelationInput"
	},
	DeviceIdentifierUpdateInput:{
		device:"DeviceIdentifierUpdateDeviceEntityRelationInput",
		updatedAt:"DateTime",
		updatedByUser:"DeviceIdentifierUpdateUpdatedByUserEntityRelationInput"
	},
	DeviceIdentifierUpdateDeviceEntityRelationInput:{
		create:"PointOfSaleApplicationDeviceWithoutIdentifierCreateInput",
		update:"PointOfSaleApplicationDeviceWithoutIdentifierUpdateInput",
		upsert:"DeviceIdentifierUpsertDeviceRelationInput",
		connect:"PointOfSaleApplicationDeviceUniqueWhere"
	},
	PointOfSaleApplicationDeviceWithoutIdentifierUpdateInput:{
		venue:"PointOfSaleApplicationDeviceUpdateVenueEntityRelationInput",
		identificationCode:"PointOfSaleApplicationDeviceUpdateIdentificationCodeEntityRelationInput",
		terminal:"PointOfSaleApplicationDeviceUpdateTerminalEntityRelationInput",
		receiptPrinter:"PointOfSaleApplicationDeviceUpdateReceiptPrinterEntityRelationInput",
		ticketPrinters:"PointOfSaleApplicationDeviceUpdateTicketPrintersEntityRelationInput"
	},
	DeviceIdentifierUpsertDeviceRelationInput:{
		update:"PointOfSaleApplicationDeviceWithoutIdentifierUpdateInput",
		create:"PointOfSaleApplicationDeviceWithoutIdentifierCreateInput"
	},
	PointOfSalePrinterCreateInput:{
		id:"UUID",
		applicationDevicesReceipt:"PointOfSalePrinterCreateApplicationDevicesReceiptEntityRelationInput",
		applicationDevicesTicket:"PointOfSalePrinterCreateApplicationDevicesTicketEntityRelationInput",
		venue:"PointOfSalePrinterCreateVenueEntityRelationInput",
		ticketCategories:"PointOfSalePrinterCreateTicketCategoriesEntityRelationInput"
	},
	PointOfSalePrinterUpdateInput:{
		applicationDevicesReceipt:"PointOfSalePrinterUpdateApplicationDevicesReceiptEntityRelationInput",
		applicationDevicesTicket:"PointOfSalePrinterUpdateApplicationDevicesTicketEntityRelationInput",
		venue:"PointOfSalePrinterUpdateVenueEntityRelationInput",
		ticketCategories:"PointOfSalePrinterUpdateTicketCategoriesEntityRelationInput"
	},
	GratuityCreateInput:{
		id:"UUID",
		order:"GratuityCreateOrderEntityRelationInput"
	},
	GratuityCreateOrderEntityRelationInput:{
		connect:"OrderUniqueWhere",
		create:"OrderWithoutGratuityCreateInput"
	},
	OrderWithoutGratuityCreateInput:{
		id:"UUID",
		state:"OrderState",
		fulfilledAt:"DateTime",
		canceledAt:"DateTime",
		customer:"OrderCreateCustomerEntityRelationInput",
		channel:"OrderCreateChannelEntityRelationInput",
		discounts:"OrderCreateDiscountsEntityRelationInput",
		delivery:"OrderCreateDeliveryEntityRelationInput",
		items:"OrderCreateItemsEntityRelationInput",
		cart:"OrderCreateCartEntityRelationInput",
		events:"OrderCreateEventsEntityRelationInput",
		createdAt:"DateTime",
		billingAddress:"OrderCreateBillingAddressEntityRelationInput",
		priceLines:"OrderCreatePriceLinesEntityRelationInput",
		payments:"OrderCreatePaymentsEntityRelationInput",
		billingSubject:"OrderCreateBillingSubjectEntityRelationInput",
		summary:"OrderCreateSummaryEntityRelationInput",
		venue:"OrderCreateVenueEntityRelationInput",
		fulfillmentNotes:"OrderCreateFulfillmentNotesEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	GratuityUpdateInput:{
		order:"GratuityUpdateOrderEntityRelationInput"
	},
	GratuityUpdateOrderEntityRelationInput:{
		create:"OrderWithoutGratuityCreateInput",
		update:"OrderWithoutGratuityUpdateInput",
		upsert:"GratuityUpsertOrderRelationInput",
		connect:"OrderUniqueWhere"
	},
	OrderWithoutGratuityUpdateInput:{
		state:"OrderState",
		fulfilledAt:"DateTime",
		canceledAt:"DateTime",
		customer:"OrderUpdateCustomerEntityRelationInput",
		channel:"OrderUpdateChannelEntityRelationInput",
		discounts:"OrderUpdateDiscountsEntityRelationInput",
		delivery:"OrderUpdateDeliveryEntityRelationInput",
		items:"OrderUpdateItemsEntityRelationInput",
		cart:"OrderUpdateCartEntityRelationInput",
		events:"OrderUpdateEventsEntityRelationInput",
		createdAt:"DateTime",
		billingAddress:"OrderUpdateBillingAddressEntityRelationInput",
		priceLines:"OrderUpdatePriceLinesEntityRelationInput",
		payments:"OrderUpdatePaymentsEntityRelationInput",
		billingSubject:"OrderUpdateBillingSubjectEntityRelationInput",
		summary:"OrderUpdateSummaryEntityRelationInput",
		venue:"OrderUpdateVenueEntityRelationInput",
		fulfillmentNotes:"OrderUpdateFulfillmentNotesEntityRelationInput",
		doubleshotLastUpdatedAt:"DateTime"
	},
	GratuityUpsertOrderRelationInput:{
		update:"OrderWithoutGratuityUpdateInput",
		create:"OrderWithoutGratuityCreateInput"
	},
	FulfillmentNoteCreateInput:{
		id:"UUID",
		products:"FulfillmentNoteCreateProductsEntityRelationInput",
		tags:"FulfillmentNoteCreateTagsEntityRelationInput",
		venues:"FulfillmentNoteCreateVenuesEntityRelationInput",
		cartItems:"FulfillmentNoteCreateCartItemsEntityRelationInput",
		orderItems:"FulfillmentNoteCreateOrderItemsEntityRelationInput",
		orders:"FulfillmentNoteCreateOrdersEntityRelationInput",
		createdAt:"DateTime"
	},
	FulfillmentNoteUpdateInput:{
		products:"FulfillmentNoteUpdateProductsEntityRelationInput",
		tags:"FulfillmentNoteUpdateTagsEntityRelationInput",
		venues:"FulfillmentNoteUpdateVenuesEntityRelationInput",
		cartItems:"FulfillmentNoteUpdateCartItemsEntityRelationInput",
		orderItems:"FulfillmentNoteUpdateOrderItemsEntityRelationInput",
		orders:"FulfillmentNoteUpdateOrdersEntityRelationInput",
		createdAt:"DateTime"
	},
	LeadFormCreateInput:{
		id:"UUID",
		stage:"LeadFormCreateStageEntityRelationInput",
		leads:"LeadFormCreateLeadsEntityRelationInput"
	},
	LeadFormUpdateInput:{
		stage:"LeadFormUpdateStageEntityRelationInput",
		leads:"LeadFormUpdateLeadsEntityRelationInput"
	},
	SubscriptionBoxCreateInput:{
		id:"UUID",
		locales:"SubscriptionBoxCreateLocalesEntityRelationInput",
		unique:"One"
	},
	SubscriptionBoxCreateLocalesEntityRelationInput:{
		connect:"SubscriptionBoxLocaleUniqueWhere",
		create:"SubscriptionBoxLocaleWithoutRootCreateInput"
	},
	SubscriptionBoxLocaleWithoutRootCreateInput:{
		id:"UUID",
		locale:"SubscriptionBoxLocaleCreateLocaleEntityRelationInput",
		texts:"SubscriptionBoxLocaleCreateTextsEntityRelationInput",
		secondaryTexts:"SubscriptionBoxLocaleCreateSecondaryTextsEntityRelationInput"
	},
	SubscriptionBoxLocaleCreateLocaleEntityRelationInput:{
		connect:"LocaleUniqueWhere",
		create:"LocaleWithoutSubscriptionBoxesCreateInput"
	},
	LocaleWithoutSubscriptionBoxesCreateInput:{
		id:"UUID",
		businessCategories:"LocaleCreateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleCreateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleCreateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleCreateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleCreateBlogsEntityRelationInput",
		blogPosts:"LocaleCreateBlogPostsEntityRelationInput",
		identifier:"LocaleCreateIdentifierEntityRelationInput",
		menus:"LocaleCreateMenusEntityRelationInput",
		pages:"LocaleCreatePagesEntityRelationInput",
		productIngredientCategories:"LocaleCreateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleCreateAllergensEntityRelationInput",
		productPackings:"LocaleCreateProductPackingsEntityRelationInput",
		products:"LocaleCreateProductsEntityRelationInput",
		productRecipes:"LocaleCreateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleCreatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleCreatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleCreateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleCreateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleCreateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleCreatePipelineStagesEntityRelationInput",
		businessServices:"LocaleCreateBusinessServicesEntityRelationInput"
	},
	SubscriptionBoxUpdateInput:{
		locales:"SubscriptionBoxUpdateLocalesEntityRelationInput",
		unique:"One"
	},
	SubscriptionBoxUpdateLocalesEntityRelationInput:{
		create:"SubscriptionBoxLocaleWithoutRootCreateInput",
		update:"SubscriptionBoxUpdateLocalesRelationInput",
		upsert:"SubscriptionBoxUpsertLocalesRelationInput",
		connect:"SubscriptionBoxLocaleUniqueWhere",
		disconnect:"SubscriptionBoxLocaleUniqueWhere",
		delete:"SubscriptionBoxLocaleUniqueWhere"
	},
	SubscriptionBoxUpdateLocalesRelationInput:{
		by:"SubscriptionBoxLocaleUniqueWhere",
		data:"SubscriptionBoxLocaleWithoutRootUpdateInput"
	},
	SubscriptionBoxLocaleWithoutRootUpdateInput:{
		locale:"SubscriptionBoxLocaleUpdateLocaleEntityRelationInput",
		texts:"SubscriptionBoxLocaleUpdateTextsEntityRelationInput",
		secondaryTexts:"SubscriptionBoxLocaleUpdateSecondaryTextsEntityRelationInput"
	},
	SubscriptionBoxLocaleUpdateLocaleEntityRelationInput:{
		create:"LocaleWithoutSubscriptionBoxesCreateInput",
		update:"LocaleWithoutSubscriptionBoxesUpdateInput",
		upsert:"SubscriptionBoxLocaleUpsertLocaleRelationInput",
		connect:"LocaleUniqueWhere"
	},
	LocaleWithoutSubscriptionBoxesUpdateInput:{
		businessCategories:"LocaleUpdateBusinessCategoriesEntityRelationInput",
		productCategoryLists:"LocaleUpdateProductCategoryListsEntityRelationInput",
		productIngredients:"LocaleUpdateProductIngredientsEntityRelationInput",
		orderRecurrences:"LocaleUpdateOrderRecurrencesEntityRelationInput",
		blogs:"LocaleUpdateBlogsEntityRelationInput",
		blogPosts:"LocaleUpdateBlogPostsEntityRelationInput",
		identifier:"LocaleUpdateIdentifierEntityRelationInput",
		menus:"LocaleUpdateMenusEntityRelationInput",
		pages:"LocaleUpdatePagesEntityRelationInput",
		productIngredientCategories:"LocaleUpdateProductIngredientCategoriesEntityRelationInput",
		allergens:"LocaleUpdateAllergensEntityRelationInput",
		productPackings:"LocaleUpdateProductPackingsEntityRelationInput",
		products:"LocaleUpdateProductsEntityRelationInput",
		productRecipes:"LocaleUpdateProductRecipesEntityRelationInput",
		pointOfSaleCategories:"LocaleUpdatePointOfSaleCategoriesEntityRelationInput",
		pointOfSaleCategoryProducts:"LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput",
		deliveryMethods:"LocaleUpdateDeliveryMethodsEntityRelationInput",
		ingredientSuppliers:"LocaleUpdateIngredientSuppliersEntityRelationInput",
		identificationCodes:"LocaleUpdateIdentificationCodesEntityRelationInput",
		pipelineStages:"LocaleUpdatePipelineStagesEntityRelationInput",
		businessServices:"LocaleUpdateBusinessServicesEntityRelationInput"
	},
	SubscriptionBoxLocaleUpsertLocaleRelationInput:{
		update:"LocaleWithoutSubscriptionBoxesUpdateInput",
		create:"LocaleWithoutSubscriptionBoxesCreateInput"
	},
	SubscriptionBoxUpsertLocalesRelationInput:{
		by:"SubscriptionBoxLocaleUniqueWhere",
		update:"SubscriptionBoxLocaleWithoutRootUpdateInput",
		create:"SubscriptionBoxLocaleWithoutRootCreateInput"
	},
	SubscriptionBoxLocaleCreateInput:{
		id:"UUID",
		root:"SubscriptionBoxLocaleCreateRootEntityRelationInput",
		locale:"SubscriptionBoxLocaleCreateLocaleEntityRelationInput",
		texts:"SubscriptionBoxLocaleCreateTextsEntityRelationInput",
		secondaryTexts:"SubscriptionBoxLocaleCreateSecondaryTextsEntityRelationInput"
	},
	SubscriptionBoxLocaleUpdateInput:{
		root:"SubscriptionBoxLocaleUpdateRootEntityRelationInput",
		locale:"SubscriptionBoxLocaleUpdateLocaleEntityRelationInput",
		texts:"SubscriptionBoxLocaleUpdateTextsEntityRelationInput",
		secondaryTexts:"SubscriptionBoxLocaleUpdateSecondaryTextsEntityRelationInput"
	},
	BusinessServiceEventCreateInput:{
		id:"UUID",
		createdAt:"DateTime",
		fulfilledAt:"DateTime",
		businessCustomer:"BusinessServiceEventCreateBusinessCustomerEntityRelationInput",
		businessService:"BusinessServiceEventCreateBusinessServiceEntityRelationInput",
		createdBy:"BusinessServiceEventCreateCreatedByEntityRelationInput",
		filledSupervisor:"BusinessServiceEventCreateFilledSupervisorEntityRelationInput"
	},
	BusinessServiceEventCreateBusinessCustomerEntityRelationInput:{
		connect:"BusinessCustomerUniqueWhere",
		create:"BusinessCustomerWithoutBusinessServiceEventsCreateInput"
	},
	BusinessCustomerWithoutBusinessServiceEventsCreateInput:{
		id:"UUID",
		customer:"BusinessCustomerCreateCustomerEntityRelationInput",
		owners:"BusinessCustomerCreateOwnersEntityRelationInput",
		members:"BusinessCustomerCreateMembersEntityRelationInput",
		category:"BusinessCustomerCreateCategoryEntityRelationInput",
		accountManager:"BusinessCustomerCreateAccountManagerEntityRelationInput",
		logo:"BusinessCustomerCreateLogoEntityRelationInput",
		doubleshotCoffeeEquipment:"BusinessCustomerCreateDoubleshotCoffeeEquipmentEntityRelationInput"
	},
	BusinessServiceEventUpdateInput:{
		createdAt:"DateTime",
		fulfilledAt:"DateTime",
		businessCustomer:"BusinessServiceEventUpdateBusinessCustomerEntityRelationInput",
		businessService:"BusinessServiceEventUpdateBusinessServiceEntityRelationInput",
		createdBy:"BusinessServiceEventUpdateCreatedByEntityRelationInput",
		filledSupervisor:"BusinessServiceEventUpdateFilledSupervisorEntityRelationInput"
	},
	BusinessServiceEventUpdateBusinessCustomerEntityRelationInput:{
		create:"BusinessCustomerWithoutBusinessServiceEventsCreateInput",
		update:"BusinessCustomerWithoutBusinessServiceEventsUpdateInput",
		upsert:"BusinessServiceEventUpsertBusinessCustomerRelationInput",
		connect:"BusinessCustomerUniqueWhere"
	},
	BusinessCustomerWithoutBusinessServiceEventsUpdateInput:{
		customer:"BusinessCustomerUpdateCustomerEntityRelationInput",
		owners:"BusinessCustomerUpdateOwnersEntityRelationInput",
		members:"BusinessCustomerUpdateMembersEntityRelationInput",
		category:"BusinessCustomerUpdateCategoryEntityRelationInput",
		accountManager:"BusinessCustomerUpdateAccountManagerEntityRelationInput",
		logo:"BusinessCustomerUpdateLogoEntityRelationInput",
		doubleshotCoffeeEquipment:"BusinessCustomerUpdateDoubleshotCoffeeEquipmentEntityRelationInput"
	},
	BusinessServiceEventUpsertBusinessCustomerRelationInput:{
		update:"BusinessCustomerWithoutBusinessServiceEventsUpdateInput",
		create:"BusinessCustomerWithoutBusinessServiceEventsCreateInput"
	},
	BusinessServiceLocaleCreateInput:{
		id:"UUID",
		root:"BusinessServiceLocaleCreateRootEntityRelationInput",
		locale:"BusinessServiceLocaleCreateLocaleEntityRelationInput"
	},
	BusinessServiceLocaleUpdateInput:{
		root:"BusinessServiceLocaleUpdateRootEntityRelationInput",
		locale:"BusinessServiceLocaleUpdateLocaleEntityRelationInput"
	},
	GridTileItemCreateInput:{
		id:"UUID",
		list:"GridTileItemCreateListEntityRelationInput",
		medium:"GridTileItemCreateMediumEntityRelationInput",
		link:"GridTileItemCreateLinkEntityRelationInput"
	},
	GridTileItemCreateListEntityRelationInput:{
		connect:"GridTilesUniqueWhere",
		create:"GridTilesWithoutItemsCreateInput"
	},
	GridTilesWithoutItemsCreateInput:{
		id:"UUID"
	},
	GridTileItemUpdateInput:{
		list:"GridTileItemUpdateListEntityRelationInput",
		medium:"GridTileItemUpdateMediumEntityRelationInput",
		link:"GridTileItemUpdateLinkEntityRelationInput"
	},
	GridTileItemUpdateListEntityRelationInput:{
		create:"GridTilesWithoutItemsCreateInput",
		update:"GridTilesWithoutItemsUpdateInput",
		upsert:"GridTileItemUpsertListRelationInput",
		connect:"GridTilesUniqueWhere"
	},
	GridTilesWithoutItemsUpdateInput:{

	},
	GridTileItemUpsertListRelationInput:{
		update:"GridTilesWithoutItemsUpdateInput",
		create:"GridTilesWithoutItemsCreateInput"
	},
	AreaCreateInput:{
		id:"UUID",
		venue:"AreaCreateVenueEntityRelationInput",
		tables:"AreaCreateTablesEntityRelationInput",
		lines:"AreaCreateLinesEntityRelationInput"
	},
	AreaUpdateInput:{
		venue:"AreaUpdateVenueEntityRelationInput",
		tables:"AreaUpdateTablesEntityRelationInput",
		lines:"AreaUpdateLinesEntityRelationInput"
	},
	PositionUniqueWhere:{
		id:"UUID"
	},
	PositionWhere:{
		id:"UUIDCondition",
		x:"IntCondition",
		y:"IntCondition",
		and:"PositionWhere",
		or:"PositionWhere",
		not:"PositionWhere"
	},
	PositionOrderBy:{
		id:"OrderDirection",
		x:"OrderDirection",
		y:"OrderDirection"
	},
	PositionCreateInput:{
		id:"UUID"
	},
	PositionUpdateInput:{

	},
	StatsEnabledWidgetType:{
		layout:{
			filter:"StatsWidgetsLayoutWhere"
		}
	},
	StatsEnabledWidgetTypeType: true,
	StatsWidgetsLayout:{
		enabledWidgetTypes:{
			filter:"StatsEnabledWidgetTypeWhere",
			orderBy:"StatsEnabledWidgetTypeOrderBy"
		},
		items:{
			filter:"StatsWidgetWhere",
			orderBy:"StatsWidgetOrderBy"
		},
		enabledWidgetTypesByType:{
			by:"StatsWidgetsLayoutEnabledWidgetTypesByTypeUniqueWhere",
			filter:"StatsEnabledWidgetTypeWhere"
		},
		paginateEnabledWidgetTypes:{
			filter:"StatsEnabledWidgetTypeWhere",
			orderBy:"StatsEnabledWidgetTypeOrderBy"
		},
		paginateItems:{
			filter:"StatsWidgetWhere",
			orderBy:"StatsWidgetOrderBy"
		}
	},
	StatsEnabledWidgetTypeWhere:{
		id:"UUIDCondition",
		type:"StatsEnabledWidgetTypeTypeCondition",
		layout:"StatsWidgetsLayoutWhere",
		and:"StatsEnabledWidgetTypeWhere",
		or:"StatsEnabledWidgetTypeWhere",
		not:"StatsEnabledWidgetTypeWhere"
	},
	StatsEnabledWidgetTypeTypeCondition:{
		and:"StatsEnabledWidgetTypeTypeCondition",
		or:"StatsEnabledWidgetTypeTypeCondition",
		not:"StatsEnabledWidgetTypeTypeCondition",
		eq:"StatsEnabledWidgetTypeType",
		notEq:"StatsEnabledWidgetTypeType",
		in:"StatsEnabledWidgetTypeType",
		notIn:"StatsEnabledWidgetTypeType",
		lt:"StatsEnabledWidgetTypeType",
		lte:"StatsEnabledWidgetTypeType",
		gt:"StatsEnabledWidgetTypeType",
		gte:"StatsEnabledWidgetTypeType"
	},
	StatsWidgetsLayoutWhere:{
		id:"UUIDCondition",
		enabledWidgetTypes:"StatsEnabledWidgetTypeWhere",
		items:"StatsWidgetWhere",
		and:"StatsWidgetsLayoutWhere",
		or:"StatsWidgetsLayoutWhere",
		not:"StatsWidgetsLayoutWhere"
	},
	StatsWidgetWhere:{
		id:"UUIDCondition",
		order:"IntCondition",
		size:"IntCondition",
		type:"StatsEnabledWidgetTypeTypeCondition",
		link:"StringCondition",
		title:"StringCondition",
		timeFrame:"StatsWidgetTimeFrameCondition",
		layout:"StatsWidgetsLayoutWhere",
		icon:"ImageWhere",
		channels:"ChannelWhere",
		productCategory:"ProductCategoryWhere",
		paymentMethods:"PaymentMethodWhere",
		hoursFrom:"StringCondition",
		hoursTo:"StringCondition",
		and:"StatsWidgetWhere",
		or:"StatsWidgetWhere",
		not:"StatsWidgetWhere"
	},
	StatsWidgetTimeFrameCondition:{
		and:"StatsWidgetTimeFrameCondition",
		or:"StatsWidgetTimeFrameCondition",
		not:"StatsWidgetTimeFrameCondition",
		eq:"StatsWidgetTimeFrame",
		notEq:"StatsWidgetTimeFrame",
		in:"StatsWidgetTimeFrame",
		notIn:"StatsWidgetTimeFrame",
		lt:"StatsWidgetTimeFrame",
		lte:"StatsWidgetTimeFrame",
		gt:"StatsWidgetTimeFrame",
		gte:"StatsWidgetTimeFrame"
	},
	StatsWidgetTimeFrame: true,
	StatsEnabledWidgetTypeOrderBy:{
		id:"OrderDirection",
		type:"OrderDirection",
		layout:"StatsWidgetsLayoutOrderBy"
	},
	StatsWidgetsLayoutOrderBy:{
		id:"OrderDirection"
	},
	StatsWidget:{
		layout:{
			filter:"StatsWidgetsLayoutWhere"
		},
		icon:{
			filter:"ImageWhere"
		},
		channels:{
			filter:"ChannelWhere",
			orderBy:"ChannelOrderBy"
		},
		productCategory:{
			filter:"ProductCategoryWhere"
		},
		paymentMethods:{
			filter:"PaymentMethodWhere",
			orderBy:"PaymentMethodOrderBy"
		},
		paginateChannels:{
			filter:"ChannelWhere",
			orderBy:"ChannelOrderBy"
		},
		paginatePaymentMethods:{
			filter:"PaymentMethodWhere",
			orderBy:"PaymentMethodOrderBy"
		}
	},
	StatsWidgetOrderBy:{
		id:"OrderDirection",
		order:"OrderDirection",
		size:"OrderDirection",
		type:"OrderDirection",
		link:"OrderDirection",
		title:"OrderDirection",
		timeFrame:"OrderDirection",
		layout:"StatsWidgetsLayoutOrderBy",
		icon:"ImageOrderBy",
		productCategory:"ProductCategoryOrderBy",
		hoursFrom:"OrderDirection",
		hoursTo:"OrderDirection"
	},
	StatsWidgetsLayoutEnabledWidgetTypesByTypeUniqueWhere:{
		type:"StatsEnabledWidgetTypeType"
	},
	StatsEnabledWidgetTypeUniqueWhere:{
		id:"UUID",
		layout:"StatsWidgetsLayoutUniqueWhere",
		type:"StatsEnabledWidgetTypeType"
	},
	StatsWidgetsLayoutUniqueWhere:{
		id:"UUID",
		enabledWidgetTypes:"StatsEnabledWidgetTypeUniqueWhere",
		items:"StatsWidgetUniqueWhere"
	},
	StatsWidgetUniqueWhere:{
		id:"UUID"
	},
	StatsEnabledWidgetTypeCreateInput:{
		id:"UUID",
		type:"StatsEnabledWidgetTypeType",
		layout:"StatsEnabledWidgetTypeCreateLayoutEntityRelationInput"
	},
	StatsEnabledWidgetTypeCreateLayoutEntityRelationInput:{
		connect:"StatsWidgetsLayoutUniqueWhere",
		create:"StatsWidgetsLayoutWithoutEnabledWidgetTypesCreateInput"
	},
	StatsWidgetsLayoutWithoutEnabledWidgetTypesCreateInput:{
		id:"UUID",
		items:"StatsWidgetsLayoutCreateItemsEntityRelationInput"
	},
	StatsWidgetsLayoutCreateItemsEntityRelationInput:{
		connect:"StatsWidgetUniqueWhere",
		create:"StatsWidgetWithoutLayoutCreateInput"
	},
	StatsWidgetWithoutLayoutCreateInput:{
		id:"UUID",
		type:"StatsEnabledWidgetTypeType",
		timeFrame:"StatsWidgetTimeFrame",
		icon:"StatsWidgetCreateIconEntityRelationInput",
		channels:"StatsWidgetCreateChannelsEntityRelationInput",
		productCategory:"StatsWidgetCreateProductCategoryEntityRelationInput",
		paymentMethods:"StatsWidgetCreatePaymentMethodsEntityRelationInput"
	},
	StatsWidgetCreateIconEntityRelationInput:{
		connect:"ImageUniqueWhere",
		create:"ImageCreateInput"
	},
	StatsWidgetCreateChannelsEntityRelationInput:{
		connect:"ChannelUniqueWhere",
		create:"ChannelCreateInput"
	},
	StatsWidgetCreateProductCategoryEntityRelationInput:{
		connect:"ProductCategoryUniqueWhere",
		create:"ProductCategoryCreateInput"
	},
	StatsWidgetCreatePaymentMethodsEntityRelationInput:{
		connect:"PaymentMethodUniqueWhere",
		create:"PaymentMethodCreateInput"
	},
	StatsEnabledWidgetTypeUpdateInput:{
		type:"StatsEnabledWidgetTypeType",
		layout:"StatsEnabledWidgetTypeUpdateLayoutEntityRelationInput"
	},
	StatsEnabledWidgetTypeUpdateLayoutEntityRelationInput:{
		create:"StatsWidgetsLayoutWithoutEnabledWidgetTypesCreateInput",
		update:"StatsWidgetsLayoutWithoutEnabledWidgetTypesUpdateInput",
		upsert:"StatsEnabledWidgetTypeUpsertLayoutRelationInput",
		connect:"StatsWidgetsLayoutUniqueWhere"
	},
	StatsWidgetsLayoutWithoutEnabledWidgetTypesUpdateInput:{
		items:"StatsWidgetsLayoutUpdateItemsEntityRelationInput"
	},
	StatsWidgetsLayoutUpdateItemsEntityRelationInput:{
		create:"StatsWidgetWithoutLayoutCreateInput",
		update:"StatsWidgetsLayoutUpdateItemsRelationInput",
		upsert:"StatsWidgetsLayoutUpsertItemsRelationInput",
		connect:"StatsWidgetUniqueWhere",
		disconnect:"StatsWidgetUniqueWhere",
		delete:"StatsWidgetUniqueWhere"
	},
	StatsWidgetsLayoutUpdateItemsRelationInput:{
		by:"StatsWidgetUniqueWhere",
		data:"StatsWidgetWithoutLayoutUpdateInput"
	},
	StatsWidgetWithoutLayoutUpdateInput:{
		type:"StatsEnabledWidgetTypeType",
		timeFrame:"StatsWidgetTimeFrame",
		icon:"StatsWidgetUpdateIconEntityRelationInput",
		channels:"StatsWidgetUpdateChannelsEntityRelationInput",
		productCategory:"StatsWidgetUpdateProductCategoryEntityRelationInput",
		paymentMethods:"StatsWidgetUpdatePaymentMethodsEntityRelationInput"
	},
	StatsWidgetUpdateIconEntityRelationInput:{
		create:"ImageCreateInput",
		update:"ImageUpdateInput",
		upsert:"StatsWidgetUpsertIconRelationInput",
		connect:"ImageUniqueWhere"
	},
	StatsWidgetUpsertIconRelationInput:{
		update:"ImageUpdateInput",
		create:"ImageCreateInput"
	},
	StatsWidgetUpdateChannelsEntityRelationInput:{
		create:"ChannelCreateInput",
		update:"StatsWidgetUpdateChannelsRelationInput",
		upsert:"StatsWidgetUpsertChannelsRelationInput",
		connect:"ChannelUniqueWhere",
		disconnect:"ChannelUniqueWhere",
		delete:"ChannelUniqueWhere"
	},
	StatsWidgetUpdateChannelsRelationInput:{
		by:"ChannelUniqueWhere",
		data:"ChannelUpdateInput"
	},
	StatsWidgetUpsertChannelsRelationInput:{
		by:"ChannelUniqueWhere",
		update:"ChannelUpdateInput",
		create:"ChannelCreateInput"
	},
	StatsWidgetUpdateProductCategoryEntityRelationInput:{
		create:"ProductCategoryCreateInput",
		update:"ProductCategoryUpdateInput",
		upsert:"StatsWidgetUpsertProductCategoryRelationInput",
		connect:"ProductCategoryUniqueWhere"
	},
	StatsWidgetUpsertProductCategoryRelationInput:{
		update:"ProductCategoryUpdateInput",
		create:"ProductCategoryCreateInput"
	},
	StatsWidgetUpdatePaymentMethodsEntityRelationInput:{
		create:"PaymentMethodCreateInput",
		update:"StatsWidgetUpdatePaymentMethodsRelationInput",
		upsert:"StatsWidgetUpsertPaymentMethodsRelationInput",
		connect:"PaymentMethodUniqueWhere",
		disconnect:"PaymentMethodUniqueWhere",
		delete:"PaymentMethodUniqueWhere"
	},
	StatsWidgetUpdatePaymentMethodsRelationInput:{
		by:"PaymentMethodUniqueWhere",
		data:"PaymentMethodUpdateInput"
	},
	StatsWidgetUpsertPaymentMethodsRelationInput:{
		by:"PaymentMethodUniqueWhere",
		update:"PaymentMethodUpdateInput",
		create:"PaymentMethodCreateInput"
	},
	StatsWidgetsLayoutUpsertItemsRelationInput:{
		by:"StatsWidgetUniqueWhere",
		update:"StatsWidgetWithoutLayoutUpdateInput",
		create:"StatsWidgetWithoutLayoutCreateInput"
	},
	StatsEnabledWidgetTypeUpsertLayoutRelationInput:{
		update:"StatsWidgetsLayoutWithoutEnabledWidgetTypesUpdateInput",
		create:"StatsWidgetsLayoutWithoutEnabledWidgetTypesCreateInput"
	},
	StatsWidgetCreateInput:{
		id:"UUID",
		type:"StatsEnabledWidgetTypeType",
		timeFrame:"StatsWidgetTimeFrame",
		layout:"StatsWidgetCreateLayoutEntityRelationInput",
		icon:"StatsWidgetCreateIconEntityRelationInput",
		channels:"StatsWidgetCreateChannelsEntityRelationInput",
		productCategory:"StatsWidgetCreateProductCategoryEntityRelationInput",
		paymentMethods:"StatsWidgetCreatePaymentMethodsEntityRelationInput"
	},
	StatsWidgetCreateLayoutEntityRelationInput:{
		connect:"StatsWidgetsLayoutUniqueWhere",
		create:"StatsWidgetsLayoutWithoutItemsCreateInput"
	},
	StatsWidgetsLayoutWithoutItemsCreateInput:{
		id:"UUID",
		enabledWidgetTypes:"StatsWidgetsLayoutCreateEnabledWidgetTypesEntityRelationInput"
	},
	StatsWidgetsLayoutCreateEnabledWidgetTypesEntityRelationInput:{
		connect:"StatsEnabledWidgetTypeUniqueWhere",
		create:"StatsEnabledWidgetTypeWithoutLayoutCreateInput"
	},
	StatsEnabledWidgetTypeWithoutLayoutCreateInput:{
		id:"UUID",
		type:"StatsEnabledWidgetTypeType"
	},
	StatsWidgetUpdateInput:{
		type:"StatsEnabledWidgetTypeType",
		timeFrame:"StatsWidgetTimeFrame",
		layout:"StatsWidgetUpdateLayoutEntityRelationInput",
		icon:"StatsWidgetUpdateIconEntityRelationInput",
		channels:"StatsWidgetUpdateChannelsEntityRelationInput",
		productCategory:"StatsWidgetUpdateProductCategoryEntityRelationInput",
		paymentMethods:"StatsWidgetUpdatePaymentMethodsEntityRelationInput"
	},
	StatsWidgetUpdateLayoutEntityRelationInput:{
		create:"StatsWidgetsLayoutWithoutItemsCreateInput",
		update:"StatsWidgetsLayoutWithoutItemsUpdateInput",
		upsert:"StatsWidgetUpsertLayoutRelationInput",
		connect:"StatsWidgetsLayoutUniqueWhere"
	},
	StatsWidgetsLayoutWithoutItemsUpdateInput:{
		enabledWidgetTypes:"StatsWidgetsLayoutUpdateEnabledWidgetTypesEntityRelationInput"
	},
	StatsWidgetsLayoutUpdateEnabledWidgetTypesEntityRelationInput:{
		create:"StatsEnabledWidgetTypeWithoutLayoutCreateInput",
		update:"StatsWidgetsLayoutUpdateEnabledWidgetTypesRelationInput",
		upsert:"StatsWidgetsLayoutUpsertEnabledWidgetTypesRelationInput",
		connect:"StatsEnabledWidgetTypeUniqueWhere",
		disconnect:"StatsEnabledWidgetTypeUniqueWhere",
		delete:"StatsEnabledWidgetTypeUniqueWhere"
	},
	StatsWidgetsLayoutUpdateEnabledWidgetTypesRelationInput:{
		by:"StatsEnabledWidgetTypeUniqueWhere",
		data:"StatsEnabledWidgetTypeWithoutLayoutUpdateInput"
	},
	StatsEnabledWidgetTypeWithoutLayoutUpdateInput:{
		type:"StatsEnabledWidgetTypeType"
	},
	StatsWidgetsLayoutUpsertEnabledWidgetTypesRelationInput:{
		by:"StatsEnabledWidgetTypeUniqueWhere",
		update:"StatsEnabledWidgetTypeWithoutLayoutUpdateInput",
		create:"StatsEnabledWidgetTypeWithoutLayoutCreateInput"
	},
	StatsWidgetUpsertLayoutRelationInput:{
		update:"StatsWidgetsLayoutWithoutItemsUpdateInput",
		create:"StatsWidgetsLayoutWithoutItemsCreateInput"
	},
	StatsWidgetsLayoutCreateInput:{
		id:"UUID",
		enabledWidgetTypes:"StatsWidgetsLayoutCreateEnabledWidgetTypesEntityRelationInput",
		items:"StatsWidgetsLayoutCreateItemsEntityRelationInput"
	},
	StatsWidgetsLayoutUpdateInput:{
		enabledWidgetTypes:"StatsWidgetsLayoutUpdateEnabledWidgetTypesEntityRelationInput",
		items:"StatsWidgetsLayoutUpdateItemsEntityRelationInput"
	},
	SeatCreateInput:{
		id:"UUID",
		customerTabs:"SeatCreateCustomerTabsEntityRelationInput",
		table:"SeatCreateTableEntityRelationInput"
	},
	SeatUpdateInput:{
		customerTabs:"SeatUpdateCustomerTabsEntityRelationInput",
		table:"SeatUpdateTableEntityRelationInput"
	},
	TableCreateInput:{
		id:"UUID",
		shape:"TableShape",
		customerTabs:"TableCreateCustomerTabsEntityRelationInput",
		area:"TableCreateAreaEntityRelationInput",
		seats:"TableCreateSeatsEntityRelationInput"
	},
	TableUpdateInput:{
		shape:"TableShape",
		customerTabs:"TableUpdateCustomerTabsEntityRelationInput",
		area:"TableUpdateAreaEntityRelationInput",
		seats:"TableUpdateSeatsEntityRelationInput"
	},
	StatsPage:{
		widgets:{
			filter:"StatsWidgetsLayoutWhere"
		}
	},
	StatsPageType: true,
	StatsPageUniqueWhere:{
		id:"UUID",
		type:"StatsPageType",
		widgets:"StatsWidgetsLayoutUniqueWhere"
	},
	StatsPageWhere:{
		id:"UUIDCondition",
		type:"StatsPageTypeCondition",
		enabled:"BooleanCondition",
		widgets:"StatsWidgetsLayoutWhere",
		and:"StatsPageWhere",
		or:"StatsPageWhere",
		not:"StatsPageWhere"
	},
	StatsPageTypeCondition:{
		and:"StatsPageTypeCondition",
		or:"StatsPageTypeCondition",
		not:"StatsPageTypeCondition",
		eq:"StatsPageType",
		notEq:"StatsPageType",
		in:"StatsPageType",
		notIn:"StatsPageType",
		lt:"StatsPageType",
		lte:"StatsPageType",
		gt:"StatsPageType",
		gte:"StatsPageType"
	},
	StatsPageOrderBy:{
		id:"OrderDirection",
		type:"OrderDirection",
		enabled:"OrderDirection",
		widgets:"StatsWidgetsLayoutOrderBy"
	},
	StatsPageCreateInput:{
		id:"UUID",
		type:"StatsPageType",
		widgets:"StatsPageCreateWidgetsEntityRelationInput"
	},
	StatsPageCreateWidgetsEntityRelationInput:{
		connect:"StatsWidgetsLayoutUniqueWhere",
		create:"StatsWidgetsLayoutCreateInput"
	},
	StatsPageUpdateInput:{
		type:"StatsPageType",
		widgets:"StatsPageUpdateWidgetsEntityRelationInput"
	},
	StatsPageUpdateWidgetsEntityRelationInput:{
		create:"StatsWidgetsLayoutCreateInput",
		update:"StatsWidgetsLayoutUpdateInput",
		upsert:"StatsPageUpsertWidgetsRelationInput",
		connect:"StatsWidgetsLayoutUniqueWhere"
	},
	StatsPageUpsertWidgetsRelationInput:{
		update:"StatsWidgetsLayoutUpdateInput",
		create:"StatsWidgetsLayoutCreateInput"
	},
	Expense:{
		category:{
			filter:"ExpenseCategoryWhere"
		},
		supplier:{
			filter:"IngredientSupplierWhere"
		},
		changes:{
			filter:"ExpenseChangeWhere",
			orderBy:"ExpenseChangeOrderBy"
		},
		documents:{
			filter:"ExpenseDocumentWhere",
			orderBy:"ExpenseDocumentOrderBy"
		},
		terms:{
			filter:"ExpenseTermWhere",
			orderBy:"ExpenseTermOrderBy"
		},
		venue:{
			filter:"VenueWhere"
		},
		changesByDate:{
			by:"ExpenseChangesByDateUniqueWhere",
			filter:"ExpenseChangeWhere"
		},
		documentsByFile:{
			by:"ExpenseDocumentsByFileUniqueWhere",
			filter:"ExpenseDocumentWhere"
		},
		paginateChanges:{
			filter:"ExpenseChangeWhere",
			orderBy:"ExpenseChangeOrderBy"
		},
		paginateDocuments:{
			filter:"ExpenseDocumentWhere",
			orderBy:"ExpenseDocumentOrderBy"
		},
		paginateTerms:{
			filter:"ExpenseTermWhere",
			orderBy:"ExpenseTermOrderBy"
		}
	},
	ExpenseType: true,
	ExpenseCategory:{
		items:{
			filter:"ExpenseWhere",
			orderBy:"ExpenseOrderBy"
		},
		itemsByChanges:{
			by:"ExpenseCategoryItemsByChangesUniqueWhere",
			filter:"ExpenseWhere"
		},
		itemsByDocuments:{
			by:"ExpenseCategoryItemsByDocumentsUniqueWhere",
			filter:"ExpenseWhere"
		},
		itemsByTerms:{
			by:"ExpenseCategoryItemsByTermsUniqueWhere",
			filter:"ExpenseWhere"
		},
		paginateItems:{
			filter:"ExpenseWhere",
			orderBy:"ExpenseOrderBy"
		}
	},
	ExpenseWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		type:"ExpenseTypeCondition",
		category:"ExpenseCategoryWhere",
		supplier:"IngredientSupplierWhere",
		changes:"ExpenseChangeWhere",
		documents:"ExpenseDocumentWhere",
		terms:"ExpenseTermWhere",
		venue:"VenueWhere",
		paidByCash:"BooleanCondition",
		and:"ExpenseWhere",
		or:"ExpenseWhere",
		not:"ExpenseWhere"
	},
	ExpenseTypeCondition:{
		and:"ExpenseTypeCondition",
		or:"ExpenseTypeCondition",
		not:"ExpenseTypeCondition",
		eq:"ExpenseType",
		notEq:"ExpenseType",
		in:"ExpenseType",
		notIn:"ExpenseType",
		lt:"ExpenseType",
		lte:"ExpenseType",
		gt:"ExpenseType",
		gte:"ExpenseType"
	},
	ExpenseCategoryWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		items:"ExpenseWhere",
		order:"IntCondition",
		and:"ExpenseCategoryWhere",
		or:"ExpenseCategoryWhere",
		not:"ExpenseCategoryWhere"
	},
	ExpenseChangeWhere:{
		id:"UUIDCondition",
		date:"DateCondition",
		amountCents:"IntCondition",
		expense:"ExpenseWhere",
		and:"ExpenseChangeWhere",
		or:"ExpenseChangeWhere",
		not:"ExpenseChangeWhere"
	},
	ExpenseDocumentWhere:{
		id:"UUIDCondition",
		expense:"ExpenseWhere",
		amountCents:"IntCondition",
		file:"FileWhere",
		date:"DateCondition",
		termDate:"DateCondition",
		and:"ExpenseDocumentWhere",
		or:"ExpenseDocumentWhere",
		not:"ExpenseDocumentWhere"
	},
	FileWhere:{
		id:"UUIDCondition",
		url:"StringCondition",
		size:"IntCondition",
		type:"StringCondition",
		name:"StringCondition",
		and:"FileWhere",
		or:"FileWhere",
		not:"FileWhere"
	},
	ExpenseTermWhere:{
		id:"StringCondition",
		date:"DateCondition",
		amountCents:"IntCondition",
		expense:"ExpenseWhere",
		and:"ExpenseTermWhere",
		or:"ExpenseTermWhere",
		not:"ExpenseTermWhere"
	},
	ExpenseOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		type:"OrderDirection",
		category:"ExpenseCategoryOrderBy",
		supplier:"IngredientSupplierOrderBy",
		venue:"VenueOrderBy",
		paidByCash:"OrderDirection"
	},
	ExpenseCategoryOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		order:"OrderDirection"
	},
	ExpenseCategoryItemsByChangesUniqueWhere:{
		changes:"ExpenseChangeUniqueWhere"
	},
	ExpenseChangeUniqueWhere:{
		id:"UUID",
		expense:"ExpenseUniqueWhere",
		date:"Date"
	},
	ExpenseUniqueWhere:{
		id:"UUID",
		changes:"ExpenseChangeUniqueWhere",
		documents:"ExpenseDocumentUniqueWhere",
		terms:"ExpenseTermUniqueWhere"
	},
	ExpenseDocumentUniqueWhere:{
		id:"UUID",
		file:"FileUniqueWhere"
	},
	FileUniqueWhere:{
		id:"UUID"
	},
	ExpenseTermUniqueWhere:{

	},
	ExpenseCategoryItemsByDocumentsUniqueWhere:{
		documents:"ExpenseDocumentUniqueWhere"
	},
	ExpenseCategoryItemsByTermsUniqueWhere:{
		terms:"ExpenseTermUniqueWhere"
	},
	ExpenseChange:{
		expense:{
			filter:"ExpenseWhere"
		}
	},
	ExpenseChangeOrderBy:{
		id:"OrderDirection",
		date:"OrderDirection",
		amountCents:"OrderDirection",
		expense:"ExpenseOrderBy"
	},
	ExpenseDocument:{
		expense:{
			filter:"ExpenseWhere"
		},
		file:{
			filter:"FileWhere"
		}
	},
	ExpenseDocumentOrderBy:{
		id:"OrderDirection",
		expense:"ExpenseOrderBy",
		amountCents:"OrderDirection",
		file:"FileOrderBy",
		date:"OrderDirection",
		termDate:"OrderDirection"
	},
	FileOrderBy:{
		id:"OrderDirection",
		url:"OrderDirection",
		size:"OrderDirection",
		type:"OrderDirection",
		name:"OrderDirection"
	},
	ExpenseTerm:{
		expense:{
			filter:"ExpenseWhere"
		}
	},
	ExpenseTermOrderBy:{
		id:"OrderDirection",
		date:"OrderDirection",
		amountCents:"OrderDirection",
		expense:"ExpenseOrderBy"
	},
	ExpenseChangesByDateUniqueWhere:{
		date:"Date"
	},
	ExpenseDocumentsByFileUniqueWhere:{
		file:"FileUniqueWhere"
	},
	ExpenseCreateInput:{
		id:"UUID",
		type:"ExpenseType",
		category:"ExpenseCreateCategoryEntityRelationInput",
		supplier:"ExpenseCreateSupplierEntityRelationInput",
		changes:"ExpenseCreateChangesEntityRelationInput",
		documents:"ExpenseCreateDocumentsEntityRelationInput",
		terms:"ExpenseCreateTermsEntityRelationInput",
		venue:"ExpenseCreateVenueEntityRelationInput"
	},
	ExpenseCreateCategoryEntityRelationInput:{
		connect:"ExpenseCategoryUniqueWhere",
		create:"ExpenseCategoryWithoutItemsCreateInput"
	},
	ExpenseCategoryUniqueWhere:{
		id:"UUID",
		items:"ExpenseUniqueWhere"
	},
	ExpenseCategoryWithoutItemsCreateInput:{
		id:"UUID"
	},
	ExpenseCreateSupplierEntityRelationInput:{
		connect:"IngredientSupplierUniqueWhere",
		create:"IngredientSupplierCreateInput"
	},
	ExpenseCreateChangesEntityRelationInput:{
		connect:"ExpenseChangeUniqueWhere",
		create:"ExpenseChangeWithoutExpenseCreateInput"
	},
	ExpenseChangeWithoutExpenseCreateInput:{
		id:"UUID",
		date:"Date"
	},
	ExpenseCreateDocumentsEntityRelationInput:{
		connect:"ExpenseDocumentUniqueWhere",
		create:"ExpenseDocumentWithoutExpenseCreateInput"
	},
	ExpenseDocumentWithoutExpenseCreateInput:{
		id:"UUID",
		file:"ExpenseDocumentCreateFileEntityRelationInput",
		date:"Date",
		termDate:"Date"
	},
	ExpenseDocumentCreateFileEntityRelationInput:{
		connect:"FileUniqueWhere",
		create:"FileCreateInput"
	},
	FileCreateInput:{
		id:"UUID"
	},
	ExpenseCreateTermsEntityRelationInput:{
		connect:"ExpenseTermUniqueWhere"
	},
	ExpenseCreateVenueEntityRelationInput:{
		connect:"VenueUniqueWhere",
		create:"VenueCreateInput"
	},
	ExpenseUpdateInput:{
		type:"ExpenseType",
		category:"ExpenseUpdateCategoryEntityRelationInput",
		supplier:"ExpenseUpdateSupplierEntityRelationInput",
		changes:"ExpenseUpdateChangesEntityRelationInput",
		documents:"ExpenseUpdateDocumentsEntityRelationInput",
		terms:"ExpenseUpdateTermsEntityRelationInput",
		venue:"ExpenseUpdateVenueEntityRelationInput"
	},
	ExpenseUpdateCategoryEntityRelationInput:{
		create:"ExpenseCategoryWithoutItemsCreateInput",
		update:"ExpenseCategoryWithoutItemsUpdateInput",
		upsert:"ExpenseUpsertCategoryRelationInput",
		connect:"ExpenseCategoryUniqueWhere"
	},
	ExpenseCategoryWithoutItemsUpdateInput:{

	},
	ExpenseUpsertCategoryRelationInput:{
		update:"ExpenseCategoryWithoutItemsUpdateInput",
		create:"ExpenseCategoryWithoutItemsCreateInput"
	},
	ExpenseUpdateSupplierEntityRelationInput:{
		create:"IngredientSupplierCreateInput",
		update:"IngredientSupplierUpdateInput",
		upsert:"ExpenseUpsertSupplierRelationInput",
		connect:"IngredientSupplierUniqueWhere"
	},
	ExpenseUpsertSupplierRelationInput:{
		update:"IngredientSupplierUpdateInput",
		create:"IngredientSupplierCreateInput"
	},
	ExpenseUpdateChangesEntityRelationInput:{
		create:"ExpenseChangeWithoutExpenseCreateInput",
		update:"ExpenseUpdateChangesRelationInput",
		upsert:"ExpenseUpsertChangesRelationInput",
		connect:"ExpenseChangeUniqueWhere",
		disconnect:"ExpenseChangeUniqueWhere",
		delete:"ExpenseChangeUniqueWhere"
	},
	ExpenseUpdateChangesRelationInput:{
		by:"ExpenseChangeUniqueWhere",
		data:"ExpenseChangeWithoutExpenseUpdateInput"
	},
	ExpenseChangeWithoutExpenseUpdateInput:{
		date:"Date"
	},
	ExpenseUpsertChangesRelationInput:{
		by:"ExpenseChangeUniqueWhere",
		update:"ExpenseChangeWithoutExpenseUpdateInput",
		create:"ExpenseChangeWithoutExpenseCreateInput"
	},
	ExpenseUpdateDocumentsEntityRelationInput:{
		create:"ExpenseDocumentWithoutExpenseCreateInput",
		update:"ExpenseUpdateDocumentsRelationInput",
		upsert:"ExpenseUpsertDocumentsRelationInput",
		connect:"ExpenseDocumentUniqueWhere",
		disconnect:"ExpenseDocumentUniqueWhere",
		delete:"ExpenseDocumentUniqueWhere"
	},
	ExpenseUpdateDocumentsRelationInput:{
		by:"ExpenseDocumentUniqueWhere",
		data:"ExpenseDocumentWithoutExpenseUpdateInput"
	},
	ExpenseDocumentWithoutExpenseUpdateInput:{
		file:"ExpenseDocumentUpdateFileEntityRelationInput",
		date:"Date",
		termDate:"Date"
	},
	ExpenseDocumentUpdateFileEntityRelationInput:{
		create:"FileCreateInput",
		update:"FileUpdateInput",
		upsert:"ExpenseDocumentUpsertFileRelationInput",
		connect:"FileUniqueWhere"
	},
	FileUpdateInput:{

	},
	ExpenseDocumentUpsertFileRelationInput:{
		update:"FileUpdateInput",
		create:"FileCreateInput"
	},
	ExpenseUpsertDocumentsRelationInput:{
		by:"ExpenseDocumentUniqueWhere",
		update:"ExpenseDocumentWithoutExpenseUpdateInput",
		create:"ExpenseDocumentWithoutExpenseCreateInput"
	},
	ExpenseUpdateTermsEntityRelationInput:{
		connect:"ExpenseTermUniqueWhere",
		disconnect:"ExpenseTermUniqueWhere",
		delete:"ExpenseTermUniqueWhere"
	},
	ExpenseUpdateVenueEntityRelationInput:{
		create:"VenueCreateInput",
		update:"VenueUpdateInput",
		upsert:"ExpenseUpsertVenueRelationInput",
		connect:"VenueUniqueWhere"
	},
	ExpenseUpsertVenueRelationInput:{
		update:"VenueUpdateInput",
		create:"VenueCreateInput"
	},
	ExpenseCategoryCreateInput:{
		id:"UUID",
		items:"ExpenseCategoryCreateItemsEntityRelationInput"
	},
	ExpenseCategoryCreateItemsEntityRelationInput:{
		connect:"ExpenseUniqueWhere",
		create:"ExpenseWithoutCategoryCreateInput"
	},
	ExpenseWithoutCategoryCreateInput:{
		id:"UUID",
		type:"ExpenseType",
		supplier:"ExpenseCreateSupplierEntityRelationInput",
		changes:"ExpenseCreateChangesEntityRelationInput",
		documents:"ExpenseCreateDocumentsEntityRelationInput",
		terms:"ExpenseCreateTermsEntityRelationInput",
		venue:"ExpenseCreateVenueEntityRelationInput"
	},
	ExpenseCategoryUpdateInput:{
		items:"ExpenseCategoryUpdateItemsEntityRelationInput"
	},
	ExpenseCategoryUpdateItemsEntityRelationInput:{
		create:"ExpenseWithoutCategoryCreateInput",
		update:"ExpenseCategoryUpdateItemsRelationInput",
		upsert:"ExpenseCategoryUpsertItemsRelationInput",
		connect:"ExpenseUniqueWhere",
		disconnect:"ExpenseUniqueWhere",
		delete:"ExpenseUniqueWhere"
	},
	ExpenseCategoryUpdateItemsRelationInput:{
		by:"ExpenseUniqueWhere",
		data:"ExpenseWithoutCategoryUpdateInput"
	},
	ExpenseWithoutCategoryUpdateInput:{
		type:"ExpenseType",
		supplier:"ExpenseUpdateSupplierEntityRelationInput",
		changes:"ExpenseUpdateChangesEntityRelationInput",
		documents:"ExpenseUpdateDocumentsEntityRelationInput",
		terms:"ExpenseUpdateTermsEntityRelationInput",
		venue:"ExpenseUpdateVenueEntityRelationInput"
	},
	ExpenseCategoryUpsertItemsRelationInput:{
		by:"ExpenseUniqueWhere",
		update:"ExpenseWithoutCategoryUpdateInput",
		create:"ExpenseWithoutCategoryCreateInput"
	},
	ExpenseChangeCreateInput:{
		id:"UUID",
		date:"Date",
		expense:"ExpenseChangeCreateExpenseEntityRelationInput"
	},
	ExpenseChangeCreateExpenseEntityRelationInput:{
		connect:"ExpenseUniqueWhere",
		create:"ExpenseWithoutChangesCreateInput"
	},
	ExpenseWithoutChangesCreateInput:{
		id:"UUID",
		type:"ExpenseType",
		category:"ExpenseCreateCategoryEntityRelationInput",
		supplier:"ExpenseCreateSupplierEntityRelationInput",
		documents:"ExpenseCreateDocumentsEntityRelationInput",
		terms:"ExpenseCreateTermsEntityRelationInput",
		venue:"ExpenseCreateVenueEntityRelationInput"
	},
	ExpenseChangeUpdateInput:{
		date:"Date",
		expense:"ExpenseChangeUpdateExpenseEntityRelationInput"
	},
	ExpenseChangeUpdateExpenseEntityRelationInput:{
		create:"ExpenseWithoutChangesCreateInput",
		update:"ExpenseWithoutChangesUpdateInput",
		upsert:"ExpenseChangeUpsertExpenseRelationInput",
		connect:"ExpenseUniqueWhere"
	},
	ExpenseWithoutChangesUpdateInput:{
		type:"ExpenseType",
		category:"ExpenseUpdateCategoryEntityRelationInput",
		supplier:"ExpenseUpdateSupplierEntityRelationInput",
		documents:"ExpenseUpdateDocumentsEntityRelationInput",
		terms:"ExpenseUpdateTermsEntityRelationInput",
		venue:"ExpenseUpdateVenueEntityRelationInput"
	},
	ExpenseChangeUpsertExpenseRelationInput:{
		update:"ExpenseWithoutChangesUpdateInput",
		create:"ExpenseWithoutChangesCreateInput"
	},
	ExpenseDocumentCreateInput:{
		id:"UUID",
		expense:"ExpenseDocumentCreateExpenseEntityRelationInput",
		file:"ExpenseDocumentCreateFileEntityRelationInput",
		date:"Date",
		termDate:"Date"
	},
	ExpenseDocumentCreateExpenseEntityRelationInput:{
		connect:"ExpenseUniqueWhere",
		create:"ExpenseWithoutDocumentsCreateInput"
	},
	ExpenseWithoutDocumentsCreateInput:{
		id:"UUID",
		type:"ExpenseType",
		category:"ExpenseCreateCategoryEntityRelationInput",
		supplier:"ExpenseCreateSupplierEntityRelationInput",
		changes:"ExpenseCreateChangesEntityRelationInput",
		terms:"ExpenseCreateTermsEntityRelationInput",
		venue:"ExpenseCreateVenueEntityRelationInput"
	},
	ExpenseDocumentUpdateInput:{
		expense:"ExpenseDocumentUpdateExpenseEntityRelationInput",
		file:"ExpenseDocumentUpdateFileEntityRelationInput",
		date:"Date",
		termDate:"Date"
	},
	ExpenseDocumentUpdateExpenseEntityRelationInput:{
		create:"ExpenseWithoutDocumentsCreateInput",
		update:"ExpenseWithoutDocumentsUpdateInput",
		upsert:"ExpenseDocumentUpsertExpenseRelationInput",
		connect:"ExpenseUniqueWhere"
	},
	ExpenseWithoutDocumentsUpdateInput:{
		type:"ExpenseType",
		category:"ExpenseUpdateCategoryEntityRelationInput",
		supplier:"ExpenseUpdateSupplierEntityRelationInput",
		changes:"ExpenseUpdateChangesEntityRelationInput",
		terms:"ExpenseUpdateTermsEntityRelationInput",
		venue:"ExpenseUpdateVenueEntityRelationInput"
	},
	ExpenseDocumentUpsertExpenseRelationInput:{
		update:"ExpenseWithoutDocumentsUpdateInput",
		create:"ExpenseWithoutDocumentsCreateInput"
	},
	RevenuePrediction:{
		channel:{
			filter:"ChannelWhere"
		},
		changes:{
			filter:"RevenuePredictionChangeWhere",
			orderBy:"RevenuePredictionChangeOrderBy"
		},
		terms:{
			filter:"RevenuePredictionTermWhere",
			orderBy:"RevenuePredictionTermOrderBy"
		},
		paymentMethod:{
			filter:"PaymentMethodWhere"
		},
		changesByDate:{
			by:"RevenuePredictionChangesByDateUniqueWhere",
			filter:"RevenuePredictionChangeWhere"
		},
		paginateChanges:{
			filter:"RevenuePredictionChangeWhere",
			orderBy:"RevenuePredictionChangeOrderBy"
		},
		paginateTerms:{
			filter:"RevenuePredictionTermWhere",
			orderBy:"RevenuePredictionTermOrderBy"
		}
	},
	RevenuePredictionType: true,
	RevenuePredictionChange:{
		prediction:{
			filter:"RevenuePredictionWhere"
		}
	},
	RevenuePredictionWhere:{
		id:"UUIDCondition",
		name:"StringCondition",
		type:"RevenuePredictionTypeCondition",
		channel:"ChannelWhere",
		changes:"RevenuePredictionChangeWhere",
		alwaysIncludeInTotalRevenue:"BooleanCondition",
		recurrencePeriod:"RecurrencePeriodCondition",
		monday:"BooleanCondition",
		tuesday:"BooleanCondition",
		wednesday:"BooleanCondition",
		thursday:"BooleanCondition",
		friday:"BooleanCondition",
		saturday:"BooleanCondition",
		sunday:"BooleanCondition",
		terms:"RevenuePredictionTermWhere",
		paymentMethod:"PaymentMethodWhere",
		and:"RevenuePredictionWhere",
		or:"RevenuePredictionWhere",
		not:"RevenuePredictionWhere"
	},
	RevenuePredictionTypeCondition:{
		and:"RevenuePredictionTypeCondition",
		or:"RevenuePredictionTypeCondition",
		not:"RevenuePredictionTypeCondition",
		eq:"RevenuePredictionType",
		notEq:"RevenuePredictionType",
		in:"RevenuePredictionType",
		notIn:"RevenuePredictionType",
		lt:"RevenuePredictionType",
		lte:"RevenuePredictionType",
		gt:"RevenuePredictionType",
		gte:"RevenuePredictionType"
	},
	RevenuePredictionChangeWhere:{
		id:"UUIDCondition",
		date:"DateCondition",
		amountCents:"IntCondition",
		prediction:"RevenuePredictionWhere",
		and:"RevenuePredictionChangeWhere",
		or:"RevenuePredictionChangeWhere",
		not:"RevenuePredictionChangeWhere"
	},
	RecurrencePeriodCondition:{
		and:"RecurrencePeriodCondition",
		or:"RecurrencePeriodCondition",
		not:"RecurrencePeriodCondition",
		eq:"RecurrencePeriod",
		notEq:"RecurrencePeriod",
		in:"RecurrencePeriod",
		notIn:"RecurrencePeriod",
		lt:"RecurrencePeriod",
		lte:"RecurrencePeriod",
		gt:"RecurrencePeriod",
		gte:"RecurrencePeriod"
	},
	RecurrencePeriod: true,
	RevenuePredictionTermWhere:{
		id:"StringCondition",
		date:"DateCondition",
		amountCents:"IntCondition",
		prediction:"RevenuePredictionWhere",
		and:"RevenuePredictionTermWhere",
		or:"RevenuePredictionTermWhere",
		not:"RevenuePredictionTermWhere"
	},
	RevenuePredictionChangeOrderBy:{
		id:"OrderDirection",
		date:"OrderDirection",
		amountCents:"OrderDirection",
		prediction:"RevenuePredictionOrderBy"
	},
	RevenuePredictionOrderBy:{
		id:"OrderDirection",
		name:"OrderDirection",
		type:"OrderDirection",
		channel:"ChannelOrderBy",
		alwaysIncludeInTotalRevenue:"OrderDirection",
		recurrencePeriod:"OrderDirection",
		monday:"OrderDirection",
		tuesday:"OrderDirection",
		wednesday:"OrderDirection",
		thursday:"OrderDirection",
		friday:"OrderDirection",
		saturday:"OrderDirection",
		sunday:"OrderDirection",
		paymentMethod:"PaymentMethodOrderBy"
	},
	RevenuePredictionTerm:{
		prediction:{
			filter:"RevenuePredictionWhere"
		}
	},
	RevenuePredictionTermOrderBy:{
		id:"OrderDirection",
		date:"OrderDirection",
		amountCents:"OrderDirection",
		prediction:"RevenuePredictionOrderBy"
	},
	RevenuePredictionChangesByDateUniqueWhere:{
		date:"Date"
	},
	RevenuePredictionUniqueWhere:{
		id:"UUID",
		changes:"RevenuePredictionChangeUniqueWhere",
		terms:"RevenuePredictionTermUniqueWhere"
	},
	RevenuePredictionChangeUniqueWhere:{
		id:"UUID",
		prediction:"RevenuePredictionUniqueWhere",
		date:"Date"
	},
	RevenuePredictionTermUniqueWhere:{

	},
	RevenuePredictionCreateInput:{
		id:"UUID",
		type:"RevenuePredictionType",
		channel:"RevenuePredictionCreateChannelEntityRelationInput",
		changes:"RevenuePredictionCreateChangesEntityRelationInput",
		recurrencePeriod:"RecurrencePeriod",
		terms:"RevenuePredictionCreateTermsEntityRelationInput",
		paymentMethod:"RevenuePredictionCreatePaymentMethodEntityRelationInput"
	},
	RevenuePredictionCreateChannelEntityRelationInput:{
		connect:"ChannelUniqueWhere",
		create:"ChannelCreateInput"
	},
	RevenuePredictionCreateChangesEntityRelationInput:{
		connect:"RevenuePredictionChangeUniqueWhere",
		create:"RevenuePredictionChangeWithoutPredictionCreateInput"
	},
	RevenuePredictionChangeWithoutPredictionCreateInput:{
		id:"UUID",
		date:"Date"
	},
	RevenuePredictionCreateTermsEntityRelationInput:{
		connect:"RevenuePredictionTermUniqueWhere"
	},
	RevenuePredictionCreatePaymentMethodEntityRelationInput:{
		connect:"PaymentMethodUniqueWhere",
		create:"PaymentMethodCreateInput"
	},
	RevenuePredictionUpdateInput:{
		type:"RevenuePredictionType",
		channel:"RevenuePredictionUpdateChannelEntityRelationInput",
		changes:"RevenuePredictionUpdateChangesEntityRelationInput",
		recurrencePeriod:"RecurrencePeriod",
		terms:"RevenuePredictionUpdateTermsEntityRelationInput",
		paymentMethod:"RevenuePredictionUpdatePaymentMethodEntityRelationInput"
	},
	RevenuePredictionUpdateChannelEntityRelationInput:{
		create:"ChannelCreateInput",
		update:"ChannelUpdateInput",
		upsert:"RevenuePredictionUpsertChannelRelationInput",
		connect:"ChannelUniqueWhere"
	},
	RevenuePredictionUpsertChannelRelationInput:{
		update:"ChannelUpdateInput",
		create:"ChannelCreateInput"
	},
	RevenuePredictionUpdateChangesEntityRelationInput:{
		create:"RevenuePredictionChangeWithoutPredictionCreateInput",
		update:"RevenuePredictionUpdateChangesRelationInput",
		upsert:"RevenuePredictionUpsertChangesRelationInput",
		connect:"RevenuePredictionChangeUniqueWhere",
		disconnect:"RevenuePredictionChangeUniqueWhere",
		delete:"RevenuePredictionChangeUniqueWhere"
	},
	RevenuePredictionUpdateChangesRelationInput:{
		by:"RevenuePredictionChangeUniqueWhere",
		data:"RevenuePredictionChangeWithoutPredictionUpdateInput"
	},
	RevenuePredictionChangeWithoutPredictionUpdateInput:{
		date:"Date"
	},
	RevenuePredictionUpsertChangesRelationInput:{
		by:"RevenuePredictionChangeUniqueWhere",
		update:"RevenuePredictionChangeWithoutPredictionUpdateInput",
		create:"RevenuePredictionChangeWithoutPredictionCreateInput"
	},
	RevenuePredictionUpdateTermsEntityRelationInput:{
		connect:"RevenuePredictionTermUniqueWhere",
		disconnect:"RevenuePredictionTermUniqueWhere",
		delete:"RevenuePredictionTermUniqueWhere"
	},
	RevenuePredictionUpdatePaymentMethodEntityRelationInput:{
		create:"PaymentMethodCreateInput",
		update:"PaymentMethodUpdateInput",
		upsert:"RevenuePredictionUpsertPaymentMethodRelationInput",
		connect:"PaymentMethodUniqueWhere"
	},
	RevenuePredictionUpsertPaymentMethodRelationInput:{
		update:"PaymentMethodUpdateInput",
		create:"PaymentMethodCreateInput"
	},
	RevenuePredictionChangeCreateInput:{
		id:"UUID",
		date:"Date",
		prediction:"RevenuePredictionChangeCreatePredictionEntityRelationInput"
	},
	RevenuePredictionChangeCreatePredictionEntityRelationInput:{
		connect:"RevenuePredictionUniqueWhere",
		create:"RevenuePredictionWithoutChangesCreateInput"
	},
	RevenuePredictionWithoutChangesCreateInput:{
		id:"UUID",
		type:"RevenuePredictionType",
		channel:"RevenuePredictionCreateChannelEntityRelationInput",
		recurrencePeriod:"RecurrencePeriod",
		terms:"RevenuePredictionCreateTermsEntityRelationInput",
		paymentMethod:"RevenuePredictionCreatePaymentMethodEntityRelationInput"
	},
	RevenuePredictionChangeUpdateInput:{
		date:"Date",
		prediction:"RevenuePredictionChangeUpdatePredictionEntityRelationInput"
	},
	RevenuePredictionChangeUpdatePredictionEntityRelationInput:{
		create:"RevenuePredictionWithoutChangesCreateInput",
		update:"RevenuePredictionWithoutChangesUpdateInput",
		upsert:"RevenuePredictionChangeUpsertPredictionRelationInput",
		connect:"RevenuePredictionUniqueWhere"
	},
	RevenuePredictionWithoutChangesUpdateInput:{
		type:"RevenuePredictionType",
		channel:"RevenuePredictionUpdateChannelEntityRelationInput",
		recurrencePeriod:"RecurrencePeriod",
		terms:"RevenuePredictionUpdateTermsEntityRelationInput",
		paymentMethod:"RevenuePredictionUpdatePaymentMethodEntityRelationInput"
	},
	RevenuePredictionChangeUpsertPredictionRelationInput:{
		update:"RevenuePredictionWithoutChangesUpdateInput",
		create:"RevenuePredictionWithoutChangesCreateInput"
	},
	LineCreateInput:{
		id:"UUID",
		area:"LineCreateAreaEntityRelationInput"
	},
	LineCreateAreaEntityRelationInput:{
		connect:"AreaUniqueWhere",
		create:"AreaWithoutLinesCreateInput"
	},
	AreaWithoutLinesCreateInput:{
		id:"UUID",
		venue:"AreaCreateVenueEntityRelationInput",
		tables:"AreaCreateTablesEntityRelationInput"
	},
	LineUpdateInput:{
		area:"LineUpdateAreaEntityRelationInput"
	},
	LineUpdateAreaEntityRelationInput:{
		create:"AreaWithoutLinesCreateInput",
		update:"AreaWithoutLinesUpdateInput",
		upsert:"LineUpsertAreaRelationInput",
		connect:"AreaUniqueWhere"
	},
	AreaWithoutLinesUpdateInput:{
		venue:"AreaUpdateVenueEntityRelationInput",
		tables:"AreaUpdateTablesEntityRelationInput"
	},
	LineUpsertAreaRelationInput:{
		update:"AreaWithoutLinesUpdateInput",
		create:"AreaWithoutLinesCreateInput"
	},
	FinancesBalanceItem:{
		venue:{
			filter:"VenueWhere"
		}
	},
	FinancesBalanceItemUniqueWhere:{
		id:"UUID"
	},
	FinancesBalanceItemWhere:{
		id:"UUIDCondition",
		amountCents:"IntCondition",
		date:"DateCondition",
		venue:"VenueWhere",
		paidByCash:"BooleanCondition",
		and:"FinancesBalanceItemWhere",
		or:"FinancesBalanceItemWhere",
		not:"FinancesBalanceItemWhere"
	},
	FinancesBalanceItemOrderBy:{
		id:"OrderDirection",
		amountCents:"OrderDirection",
		date:"OrderDirection",
		venue:"VenueOrderBy",
		paidByCash:"OrderDirection"
	},
	FinancesBalanceItemCreateInput:{
		id:"UUID",
		date:"Date",
		venue:"FinancesBalanceItemCreateVenueEntityRelationInput"
	},
	FinancesBalanceItemCreateVenueEntityRelationInput:{
		connect:"VenueUniqueWhere",
		create:"VenueCreateInput"
	},
	FinancesBalanceItemUpdateInput:{
		date:"Date",
		venue:"FinancesBalanceItemUpdateVenueEntityRelationInput"
	},
	FinancesBalanceItemUpdateVenueEntityRelationInput:{
		create:"VenueCreateInput",
		update:"VenueUpdateInput",
		upsert:"FinancesBalanceItemUpsertVenueRelationInput",
		connect:"VenueUniqueWhere"
	},
	FinancesBalanceItemUpsertVenueRelationInput:{
		update:"VenueUpdateInput",
		create:"VenueCreateInput"
	},
	OrderPaymentStatsByDay:{
		channel:{
			filter:"ChannelWhere"
		},
		paymentMethod:{
			filter:"PaymentMethodWhere"
		}
	},
	OrderPaymentStatsByDayUniqueWhere:{

	},
	OrderPaymentStatsByDayWhere:{
		id:"StringCondition",
		day:"DateCondition",
		totalGratuityCents:"IntCondition",
		reducedGratuityCents:"IntCondition",
		channel:"ChannelWhere",
		paymentMethod:"PaymentMethodWhere",
		and:"OrderPaymentStatsByDayWhere",
		or:"OrderPaymentStatsByDayWhere",
		not:"OrderPaymentStatsByDayWhere"
	},
	OrderPaymentStatsByDayOrderBy:{
		id:"OrderDirection",
		day:"OrderDirection",
		totalGratuityCents:"OrderDirection",
		reducedGratuityCents:"OrderDirection",
		channel:"ChannelOrderBy",
		paymentMethod:"PaymentMethodOrderBy"
	},
	WoltDriveDeliveryCreateInput:{
		id:"UUID",
		state:"WoltDriveDeliveryState",
		delivery:"WoltDriveDeliveryCreateDeliveryEntityRelationInput"
	},
	WoltDriveDeliveryCreateDeliveryEntityRelationInput:{
		connect:"OrderDeliveryUniqueWhere",
		create:"OrderDeliveryWithoutWoltDriveDeliveryCreateInput"
	},
	OrderDeliveryWithoutWoltDriveDeliveryCreateInput:{
		id:"UUID",
		deliveredAt:"DateTime",
		method:"OrderDeliveryCreateMethodEntityRelationInput",
		vatRate:"OrderDeliveryCreateVatRateEntityRelationInput",
		order:"OrderDeliveryCreateOrderEntityRelationInput",
		expectedAt:"DateTime",
		state:"OrderDeliveryState",
		dispatchAt:"DateTime",
		expectedEndAt:"DateTime",
		processingAt:"DateTime",
		deliveringAt:"DateTime",
		failedAt:"DateTime",
		deliveryWaypoint:"OrderDeliveryCreateDeliveryWaypointEntityRelationInput",
		events:"OrderDeliveryCreateEventsEntityRelationInput",
		prepareAt:"DateTime",
		liftagoRide:"OrderDeliveryCreateLiftagoRideEntityRelationInput",
		pickedAt:"DateTime",
		address:"OrderDeliveryCreateAddressEntityRelationInput"
	},
	WoltDriveDeliveryUpdateInput:{
		state:"WoltDriveDeliveryState",
		delivery:"WoltDriveDeliveryUpdateDeliveryEntityRelationInput"
	},
	WoltDriveDeliveryUpdateDeliveryEntityRelationInput:{
		create:"OrderDeliveryWithoutWoltDriveDeliveryCreateInput",
		update:"OrderDeliveryWithoutWoltDriveDeliveryUpdateInput",
		upsert:"WoltDriveDeliveryUpsertDeliveryRelationInput",
		connect:"OrderDeliveryUniqueWhere"
	},
	OrderDeliveryWithoutWoltDriveDeliveryUpdateInput:{
		deliveredAt:"DateTime",
		method:"OrderDeliveryUpdateMethodEntityRelationInput",
		vatRate:"OrderDeliveryUpdateVatRateEntityRelationInput",
		order:"OrderDeliveryUpdateOrderEntityRelationInput",
		expectedAt:"DateTime",
		state:"OrderDeliveryState",
		dispatchAt:"DateTime",
		expectedEndAt:"DateTime",
		processingAt:"DateTime",
		deliveringAt:"DateTime",
		failedAt:"DateTime",
		deliveryWaypoint:"OrderDeliveryUpdateDeliveryWaypointEntityRelationInput",
		events:"OrderDeliveryUpdateEventsEntityRelationInput",
		prepareAt:"DateTime",
		liftagoRide:"OrderDeliveryUpdateLiftagoRideEntityRelationInput",
		pickedAt:"DateTime",
		address:"OrderDeliveryUpdateAddressEntityRelationInput"
	},
	WoltDriveDeliveryUpsertDeliveryRelationInput:{
		update:"OrderDeliveryWithoutWoltDriveDeliveryUpdateInput",
		create:"OrderDeliveryWithoutWoltDriveDeliveryCreateInput"
	},
	QueryTransaction:{
		getAddress:{
			by:"AddressUniqueWhere",
			filter:"AddressWhere"
		},
		listAddress:{
			filter:"AddressWhere",
			orderBy:"AddressOrderBy"
		},
		paginateAddress:{
			filter:"AddressWhere",
			orderBy:"AddressOrderBy"
		},
		validateCreateAddress:{
			data:"AddressCreateInput"
		},
		validateUpdateAddress:{
			by:"AddressUniqueWhere",
			data:"AddressUpdateInput"
		},
		getCountry:{
			by:"CountryUniqueWhere",
			filter:"CountryWhere"
		},
		listCountry:{
			filter:"CountryWhere",
			orderBy:"CountryOrderBy"
		},
		paginateCountry:{
			filter:"CountryWhere",
			orderBy:"CountryOrderBy"
		},
		validateCreateCountry:{
			data:"CountryCreateInput"
		},
		validateUpdateCountry:{
			by:"CountryUniqueWhere",
			data:"CountryUpdateInput"
		},
		getChannel:{
			by:"ChannelUniqueWhere",
			filter:"ChannelWhere"
		},
		listChannel:{
			filter:"ChannelWhere",
			orderBy:"ChannelOrderBy"
		},
		paginateChannel:{
			filter:"ChannelWhere",
			orderBy:"ChannelOrderBy"
		},
		validateCreateChannel:{
			data:"ChannelCreateInput"
		},
		validateUpdateChannel:{
			by:"ChannelUniqueWhere",
			data:"ChannelUpdateInput"
		},
		getChannelPayment:{
			by:"ChannelPaymentUniqueWhere",
			filter:"ChannelPaymentWhere"
		},
		listChannelPayment:{
			filter:"ChannelPaymentWhere",
			orderBy:"ChannelPaymentOrderBy"
		},
		paginateChannelPayment:{
			filter:"ChannelPaymentWhere",
			orderBy:"ChannelPaymentOrderBy"
		},
		validateCreateChannelPayment:{
			data:"ChannelPaymentCreateInput"
		},
		validateUpdateChannelPayment:{
			by:"ChannelPaymentUniqueWhere",
			data:"ChannelPaymentUpdateInput"
		},
		getChannelDelivery:{
			by:"ChannelDeliveryUniqueWhere",
			filter:"ChannelDeliveryWhere"
		},
		listChannelDelivery:{
			filter:"ChannelDeliveryWhere",
			orderBy:"ChannelDeliveryOrderBy"
		},
		paginateChannelDelivery:{
			filter:"ChannelDeliveryWhere",
			orderBy:"ChannelDeliveryOrderBy"
		},
		validateCreateChannelDelivery:{
			data:"ChannelDeliveryCreateInput"
		},
		validateUpdateChannelDelivery:{
			by:"ChannelDeliveryUniqueWhere",
			data:"ChannelDeliveryUpdateInput"
		},
		getCustomer:{
			by:"CustomerUniqueWhere",
			filter:"CustomerWhere"
		},
		listCustomer:{
			filter:"CustomerWhere",
			orderBy:"CustomerOrderBy"
		},
		paginateCustomer:{
			filter:"CustomerWhere",
			orderBy:"CustomerOrderBy"
		},
		validateCreateCustomer:{
			data:"CustomerCreateInput"
		},
		validateUpdateCustomer:{
			by:"CustomerUniqueWhere",
			data:"CustomerUpdateInput"
		},
		getCustomerCredit:{
			by:"CustomerCreditUniqueWhere",
			filter:"CustomerCreditWhere"
		},
		listCustomerCredit:{
			filter:"CustomerCreditWhere",
			orderBy:"CustomerCreditOrderBy"
		},
		paginateCustomerCredit:{
			filter:"CustomerCreditWhere",
			orderBy:"CustomerCreditOrderBy"
		},
		validateCreateCustomerCredit:{
			data:"CustomerCreditCreateInput"
		},
		validateUpdateCustomerCredit:{
			by:"CustomerCreditUniqueWhere",
			data:"CustomerCreditUpdateInput"
		},
		getCustomerGroup:{
			by:"CustomerGroupUniqueWhere",
			filter:"CustomerGroupWhere"
		},
		listCustomerGroup:{
			filter:"CustomerGroupWhere",
			orderBy:"CustomerGroupOrderBy"
		},
		paginateCustomerGroup:{
			filter:"CustomerGroupWhere",
			orderBy:"CustomerGroupOrderBy"
		},
		validateCreateCustomerGroup:{
			data:"CustomerGroupCreateInput"
		},
		validateUpdateCustomerGroup:{
			by:"CustomerGroupUniqueWhere",
			data:"CustomerGroupUpdateInput"
		},
		getCustomerPaymentMethod:{
			by:"CustomerPaymentMethodUniqueWhere",
			filter:"CustomerPaymentMethodWhere"
		},
		listCustomerPaymentMethod:{
			filter:"CustomerPaymentMethodWhere",
			orderBy:"CustomerPaymentMethodOrderBy"
		},
		paginateCustomerPaymentMethod:{
			filter:"CustomerPaymentMethodWhere",
			orderBy:"CustomerPaymentMethodOrderBy"
		},
		validateCreateCustomerPaymentMethod:{
			data:"CustomerPaymentMethodCreateInput"
		},
		validateUpdateCustomerPaymentMethod:{
			by:"CustomerPaymentMethodUniqueWhere",
			data:"CustomerPaymentMethodUpdateInput"
		},
		getDeliveryMethod:{
			by:"DeliveryMethodUniqueWhere",
			filter:"DeliveryMethodWhere"
		},
		listDeliveryMethod:{
			filter:"DeliveryMethodWhere",
			orderBy:"DeliveryMethodOrderBy"
		},
		paginateDeliveryMethod:{
			filter:"DeliveryMethodWhere",
			orderBy:"DeliveryMethodOrderBy"
		},
		validateCreateDeliveryMethod:{
			data:"DeliveryMethodCreateInput"
		},
		validateUpdateDeliveryMethod:{
			by:"DeliveryMethodUniqueWhere",
			data:"DeliveryMethodUpdateInput"
		},
		getOrder:{
			by:"OrderUniqueWhere",
			filter:"OrderWhere"
		},
		listOrder:{
			filter:"OrderWhere",
			orderBy:"OrderOrderBy"
		},
		paginateOrder:{
			filter:"OrderWhere",
			orderBy:"OrderOrderBy"
		},
		validateCreateOrder:{
			data:"OrderCreateInput"
		},
		validateUpdateOrder:{
			by:"OrderUniqueWhere",
			data:"OrderUpdateInput"
		},
		getOrderDiscount:{
			by:"OrderDiscountUniqueWhere",
			filter:"OrderDiscountWhere"
		},
		listOrderDiscount:{
			filter:"OrderDiscountWhere",
			orderBy:"OrderDiscountOrderBy"
		},
		paginateOrderDiscount:{
			filter:"OrderDiscountWhere",
			orderBy:"OrderDiscountOrderBy"
		},
		validateCreateOrderDiscount:{
			data:"OrderDiscountCreateInput"
		},
		validateUpdateOrderDiscount:{
			by:"OrderDiscountUniqueWhere",
			data:"OrderDiscountUpdateInput"
		},
		getOrderPayment:{
			by:"OrderPaymentUniqueWhere",
			filter:"OrderPaymentWhere"
		},
		listOrderPayment:{
			filter:"OrderPaymentWhere",
			orderBy:"OrderPaymentOrderBy"
		},
		paginateOrderPayment:{
			filter:"OrderPaymentWhere",
			orderBy:"OrderPaymentOrderBy"
		},
		validateCreateOrderPayment:{
			data:"OrderPaymentCreateInput"
		},
		validateUpdateOrderPayment:{
			by:"OrderPaymentUniqueWhere",
			data:"OrderPaymentUpdateInput"
		},
		getOrderDelivery:{
			by:"OrderDeliveryUniqueWhere",
			filter:"OrderDeliveryWhere"
		},
		listOrderDelivery:{
			filter:"OrderDeliveryWhere",
			orderBy:"OrderDeliveryOrderBy"
		},
		paginateOrderDelivery:{
			filter:"OrderDeliveryWhere",
			orderBy:"OrderDeliveryOrderBy"
		},
		validateCreateOrderDelivery:{
			data:"OrderDeliveryCreateInput"
		},
		validateUpdateOrderDelivery:{
			by:"OrderDeliveryUniqueWhere",
			data:"OrderDeliveryUpdateInput"
		},
		getOrderItem:{
			by:"OrderItemUniqueWhere",
			filter:"OrderItemWhere"
		},
		listOrderItem:{
			filter:"OrderItemWhere",
			orderBy:"OrderItemOrderBy"
		},
		paginateOrderItem:{
			filter:"OrderItemWhere",
			orderBy:"OrderItemOrderBy"
		},
		validateCreateOrderItem:{
			data:"OrderItemCreateInput"
		},
		validateUpdateOrderItem:{
			by:"OrderItemUniqueWhere",
			data:"OrderItemUpdateInput"
		},
		getPaymentMethod:{
			by:"PaymentMethodUniqueWhere",
			filter:"PaymentMethodWhere"
		},
		listPaymentMethod:{
			filter:"PaymentMethodWhere",
			orderBy:"PaymentMethodOrderBy"
		},
		paginatePaymentMethod:{
			filter:"PaymentMethodWhere",
			orderBy:"PaymentMethodOrderBy"
		},
		validateCreatePaymentMethod:{
			data:"PaymentMethodCreateInput"
		},
		validateUpdatePaymentMethod:{
			by:"PaymentMethodUniqueWhere",
			data:"PaymentMethodUpdateInput"
		},
		getVatRate:{
			by:"VatRateUniqueWhere",
			filter:"VatRateWhere"
		},
		listVatRate:{
			filter:"VatRateWhere",
			orderBy:"VatRateOrderBy"
		},
		paginateVatRate:{
			filter:"VatRateWhere",
			orderBy:"VatRateOrderBy"
		},
		validateCreateVatRate:{
			data:"VatRateCreateInput"
		},
		validateUpdateVatRate:{
			by:"VatRateUniqueWhere",
			data:"VatRateUpdateInput"
		},
		getProduct:{
			by:"ProductUniqueWhere",
			filter:"ProductWhere"
		},
		listProduct:{
			filter:"ProductWhere",
			orderBy:"ProductOrderBy"
		},
		paginateProduct:{
			filter:"ProductWhere",
			orderBy:"ProductOrderBy"
		},
		validateCreateProduct:{
			data:"ProductCreateInput"
		},
		validateUpdateProduct:{
			by:"ProductUniqueWhere",
			data:"ProductUpdateInput"
		},
		getProductStock:{
			by:"ProductStockUniqueWhere",
			filter:"ProductStockWhere"
		},
		listProductStock:{
			filter:"ProductStockWhere",
			orderBy:"ProductStockOrderBy"
		},
		paginateProductStock:{
			filter:"ProductStockWhere",
			orderBy:"ProductStockOrderBy"
		},
		validateCreateProductStock:{
			data:"ProductStockCreateInput"
		},
		validateUpdateProductStock:{
			by:"ProductStockUniqueWhere",
			data:"ProductStockUpdateInput"
		},
		getProductPacking:{
			by:"ProductPackingUniqueWhere",
			filter:"ProductPackingWhere"
		},
		listProductPacking:{
			filter:"ProductPackingWhere",
			orderBy:"ProductPackingOrderBy"
		},
		paginateProductPacking:{
			filter:"ProductPackingWhere",
			orderBy:"ProductPackingOrderBy"
		},
		validateCreateProductPacking:{
			data:"ProductPackingCreateInput"
		},
		validateUpdateProductPacking:{
			by:"ProductPackingUniqueWhere",
			data:"ProductPackingUpdateInput"
		},
		getProductGroupPrice:{
			by:"ProductGroupPriceUniqueWhere",
			filter:"ProductGroupPriceWhere"
		},
		listProductGroupPrice:{
			filter:"ProductGroupPriceWhere",
			orderBy:"ProductGroupPriceOrderBy"
		},
		paginateProductGroupPrice:{
			filter:"ProductGroupPriceWhere",
			orderBy:"ProductGroupPriceOrderBy"
		},
		validateCreateProductGroupPrice:{
			data:"ProductGroupPriceCreateInput"
		},
		validateUpdateProductGroupPrice:{
			by:"ProductGroupPriceUniqueWhere",
			data:"ProductGroupPriceUpdateInput"
		},
		getProductRecipe:{
			by:"ProductRecipeUniqueWhere",
			filter:"ProductRecipeWhere"
		},
		listProductRecipe:{
			filter:"ProductRecipeWhere",
			orderBy:"ProductRecipeOrderBy"
		},
		paginateProductRecipe:{
			filter:"ProductRecipeWhere",
			orderBy:"ProductRecipeOrderBy"
		},
		validateCreateProductRecipe:{
			data:"ProductRecipeCreateInput"
		},
		validateUpdateProductRecipe:{
			by:"ProductRecipeUniqueWhere",
			data:"ProductRecipeUpdateInput"
		},
		getProductCategory:{
			by:"ProductCategoryUniqueWhere",
			filter:"ProductCategoryWhere"
		},
		listProductCategory:{
			filter:"ProductCategoryWhere",
			orderBy:"ProductCategoryOrderBy"
		},
		paginateProductCategory:{
			filter:"ProductCategoryWhere",
			orderBy:"ProductCategoryOrderBy"
		},
		validateCreateProductCategory:{
			data:"ProductCategoryCreateInput"
		},
		validateUpdateProductCategory:{
			by:"ProductCategoryUniqueWhere",
			data:"ProductCategoryUpdateInput"
		},
		getStore:{
			by:"StoreUniqueWhere",
			filter:"StoreWhere"
		},
		listStore:{
			filter:"StoreWhere",
			orderBy:"StoreOrderBy"
		},
		paginateStore:{
			filter:"StoreWhere",
			orderBy:"StoreOrderBy"
		},
		validateCreateStore:{
			data:"StoreCreateInput"
		},
		validateUpdateStore:{
			by:"StoreUniqueWhere",
			data:"StoreUpdateInput"
		},
		getTag:{
			by:"TagUniqueWhere",
			filter:"TagWhere"
		},
		listTag:{
			filter:"TagWhere",
			orderBy:"TagOrderBy"
		},
		paginateTag:{
			filter:"TagWhere",
			orderBy:"TagOrderBy"
		},
		validateCreateTag:{
			data:"TagCreateInput"
		},
		validateUpdateTag:{
			by:"TagUniqueWhere",
			data:"TagUpdateInput"
		},
		getCustomerPermissions:{
			by:"CustomerPermissionsUniqueWhere",
			filter:"CustomerPermissionsWhere"
		},
		listCustomerPermissions:{
			filter:"CustomerPermissionsWhere",
			orderBy:"CustomerPermissionsOrderBy"
		},
		paginateCustomerPermissions:{
			filter:"CustomerPermissionsWhere",
			orderBy:"CustomerPermissionsOrderBy"
		},
		getImage:{
			by:"ImageUniqueWhere",
			filter:"ImageWhere"
		},
		listImage:{
			filter:"ImageWhere",
			orderBy:"ImageOrderBy"
		},
		paginateImage:{
			filter:"ImageWhere",
			orderBy:"ImageOrderBy"
		},
		validateCreateImage:{
			data:"ImageCreateInput"
		},
		validateUpdateImage:{
			by:"ImageUniqueWhere",
			data:"ImageUpdateInput"
		},
		getBusinessCategory:{
			by:"BusinessCategoryUniqueWhere",
			filter:"BusinessCategoryWhere"
		},
		listBusinessCategory:{
			filter:"BusinessCategoryWhere",
			orderBy:"BusinessCategoryOrderBy"
		},
		paginateBusinessCategory:{
			filter:"BusinessCategoryWhere",
			orderBy:"BusinessCategoryOrderBy"
		},
		validateCreateBusinessCategory:{
			data:"BusinessCategoryCreateInput"
		},
		validateUpdateBusinessCategory:{
			by:"BusinessCategoryUniqueWhere",
			data:"BusinessCategoryUpdateInput"
		},
		getProductList:{
			by:"ProductListUniqueWhere",
			filter:"ProductListWhere"
		},
		listProductList:{
			filter:"ProductListWhere",
			orderBy:"ProductListOrderBy"
		},
		paginateProductList:{
			filter:"ProductListWhere",
			orderBy:"ProductListOrderBy"
		},
		validateCreateProductList:{
			data:"ProductListCreateInput"
		},
		validateUpdateProductList:{
			by:"ProductListUniqueWhere",
			data:"ProductListUpdateInput"
		},
		getProductListItem:{
			by:"ProductListItemUniqueWhere",
			filter:"ProductListItemWhere"
		},
		listProductListItem:{
			filter:"ProductListItemWhere",
			orderBy:"ProductListItemOrderBy"
		},
		paginateProductListItem:{
			filter:"ProductListItemWhere",
			orderBy:"ProductListItemOrderBy"
		},
		validateCreateProductListItem:{
			data:"ProductListItemCreateInput"
		},
		validateUpdateProductListItem:{
			by:"ProductListItemUniqueWhere",
			data:"ProductListItemUpdateInput"
		},
		getProductCategoryList:{
			by:"ProductCategoryListUniqueWhere",
			filter:"ProductCategoryListWhere"
		},
		listProductCategoryList:{
			filter:"ProductCategoryListWhere",
			orderBy:"ProductCategoryListOrderBy"
		},
		paginateProductCategoryList:{
			filter:"ProductCategoryListWhere",
			orderBy:"ProductCategoryListOrderBy"
		},
		validateCreateProductCategoryList:{
			data:"ProductCategoryListCreateInput"
		},
		validateUpdateProductCategoryList:{
			by:"ProductCategoryListUniqueWhere",
			data:"ProductCategoryListUpdateInput"
		},
		getProductCategoryListItem:{
			by:"ProductCategoryListItemUniqueWhere",
			filter:"ProductCategoryListItemWhere"
		},
		listProductCategoryListItem:{
			filter:"ProductCategoryListItemWhere",
			orderBy:"ProductCategoryListItemOrderBy"
		},
		paginateProductCategoryListItem:{
			filter:"ProductCategoryListItemWhere",
			orderBy:"ProductCategoryListItemOrderBy"
		},
		validateCreateProductCategoryListItem:{
			data:"ProductCategoryListItemCreateInput"
		},
		validateUpdateProductCategoryListItem:{
			by:"ProductCategoryListItemUniqueWhere",
			data:"ProductCategoryListItemUpdateInput"
		},
		getBusinessCategoryLocale:{
			by:"BusinessCategoryLocaleUniqueWhere",
			filter:"BusinessCategoryLocaleWhere"
		},
		listBusinessCategoryLocale:{
			filter:"BusinessCategoryLocaleWhere",
			orderBy:"BusinessCategoryLocaleOrderBy"
		},
		paginateBusinessCategoryLocale:{
			filter:"BusinessCategoryLocaleWhere",
			orderBy:"BusinessCategoryLocaleOrderBy"
		},
		validateCreateBusinessCategoryLocale:{
			data:"BusinessCategoryLocaleCreateInput"
		},
		validateUpdateBusinessCategoryLocale:{
			by:"BusinessCategoryLocaleUniqueWhere",
			data:"BusinessCategoryLocaleUpdateInput"
		},
		getLocale:{
			by:"LocaleUniqueWhere",
			filter:"LocaleWhere"
		},
		listLocale:{
			filter:"LocaleWhere",
			orderBy:"LocaleOrderBy"
		},
		paginateLocale:{
			filter:"LocaleWhere",
			orderBy:"LocaleOrderBy"
		},
		validateCreateLocale:{
			data:"LocaleCreateInput"
		},
		validateUpdateLocale:{
			by:"LocaleUniqueWhere",
			data:"LocaleUpdateInput"
		},
		getProductCategoryListLocale:{
			by:"ProductCategoryListLocaleUniqueWhere",
			filter:"ProductCategoryListLocaleWhere"
		},
		listProductCategoryListLocale:{
			filter:"ProductCategoryListLocaleWhere",
			orderBy:"ProductCategoryListLocaleOrderBy"
		},
		paginateProductCategoryListLocale:{
			filter:"ProductCategoryListLocaleWhere",
			orderBy:"ProductCategoryListLocaleOrderBy"
		},
		validateCreateProductCategoryListLocale:{
			data:"ProductCategoryListLocaleCreateInput"
		},
		validateUpdateProductCategoryListLocale:{
			by:"ProductCategoryListLocaleUniqueWhere",
			data:"ProductCategoryListLocaleUpdateInput"
		},
		getCustomerName:{
			by:"CustomerNameUniqueWhere",
			filter:"CustomerNameWhere"
		},
		listCustomerName:{
			filter:"CustomerNameWhere",
			orderBy:"CustomerNameOrderBy"
		},
		paginateCustomerName:{
			filter:"CustomerNameWhere",
			orderBy:"CustomerNameOrderBy"
		},
		validateCreateCustomerName:{
			data:"CustomerNameCreateInput"
		},
		validateUpdateCustomerName:{
			by:"CustomerNameUniqueWhere",
			data:"CustomerNameUpdateInput"
		},
		getCustomerAlias:{
			by:"CustomerAliasUniqueWhere",
			filter:"CustomerAliasWhere"
		},
		listCustomerAlias:{
			filter:"CustomerAliasWhere",
			orderBy:"CustomerAliasOrderBy"
		},
		paginateCustomerAlias:{
			filter:"CustomerAliasWhere",
			orderBy:"CustomerAliasOrderBy"
		},
		validateCreateCustomerAlias:{
			data:"CustomerAliasCreateInput"
		},
		validateUpdateCustomerAlias:{
			by:"CustomerAliasUniqueWhere",
			data:"CustomerAliasUpdateInput"
		},
		getProductIngredientItem:{
			by:"ProductIngredientItemUniqueWhere",
			filter:"ProductIngredientItemWhere"
		},
		listProductIngredientItem:{
			filter:"ProductIngredientItemWhere",
			orderBy:"ProductIngredientItemOrderBy"
		},
		paginateProductIngredientItem:{
			filter:"ProductIngredientItemWhere",
			orderBy:"ProductIngredientItemOrderBy"
		},
		validateCreateProductIngredientItem:{
			data:"ProductIngredientItemCreateInput"
		},
		validateUpdateProductIngredientItem:{
			by:"ProductIngredientItemUniqueWhere",
			data:"ProductIngredientItemUpdateInput"
		},
		getProductIngredientItemQuantity:{
			by:"ProductIngredientItemQuantityUniqueWhere",
			filter:"ProductIngredientItemQuantityWhere"
		},
		listProductIngredientItemQuantity:{
			filter:"ProductIngredientItemQuantityWhere",
			orderBy:"ProductIngredientItemQuantityOrderBy"
		},
		paginateProductIngredientItemQuantity:{
			filter:"ProductIngredientItemQuantityWhere",
			orderBy:"ProductIngredientItemQuantityOrderBy"
		},
		validateCreateProductIngredientItemQuantity:{
			data:"ProductIngredientItemQuantityCreateInput"
		},
		validateUpdateProductIngredientItemQuantity:{
			by:"ProductIngredientItemQuantityUniqueWhere",
			data:"ProductIngredientItemQuantityUpdateInput"
		},
		getProductIngredientItemQuantityUnit:{
			by:"ProductIngredientItemQuantityUnitUniqueWhere",
			filter:"ProductIngredientItemQuantityUnitWhere"
		},
		listProductIngredientItemQuantityUnit:{
			filter:"ProductIngredientItemQuantityUnitWhere",
			orderBy:"ProductIngredientItemQuantityUnitOrderBy"
		},
		paginateProductIngredientItemQuantityUnit:{
			filter:"ProductIngredientItemQuantityUnitWhere",
			orderBy:"ProductIngredientItemQuantityUnitOrderBy"
		},
		validateCreateProductIngredientItemQuantityUnit:{
			data:"ProductIngredientItemQuantityUnitCreateInput"
		},
		validateUpdateProductIngredientItemQuantityUnit:{
			by:"ProductIngredientItemQuantityUnitUniqueWhere",
			data:"ProductIngredientItemQuantityUnitUpdateInput"
		},
		getProductIngredient:{
			by:"ProductIngredientUniqueWhere",
			filter:"ProductIngredientWhere"
		},
		listProductIngredient:{
			filter:"ProductIngredientWhere",
			orderBy:"ProductIngredientOrderBy"
		},
		paginateProductIngredient:{
			filter:"ProductIngredientWhere",
			orderBy:"ProductIngredientOrderBy"
		},
		validateCreateProductIngredient:{
			data:"ProductIngredientCreateInput"
		},
		validateUpdateProductIngredient:{
			by:"ProductIngredientUniqueWhere",
			data:"ProductIngredientUpdateInput"
		},
		getCustomerIngredientRating:{
			by:"CustomerIngredientRatingUniqueWhere",
			filter:"CustomerIngredientRatingWhere"
		},
		listCustomerIngredientRating:{
			filter:"CustomerIngredientRatingWhere",
			orderBy:"CustomerIngredientRatingOrderBy"
		},
		paginateCustomerIngredientRating:{
			filter:"CustomerIngredientRatingWhere",
			orderBy:"CustomerIngredientRatingOrderBy"
		},
		validateCreateCustomerIngredientRating:{
			data:"CustomerIngredientRatingCreateInput"
		},
		validateUpdateCustomerIngredientRating:{
			by:"CustomerIngredientRatingUniqueWhere",
			data:"CustomerIngredientRatingUpdateInput"
		},
		getProductIngredientRating:{
			by:"ProductIngredientRatingUniqueWhere",
			filter:"ProductIngredientRatingWhere"
		},
		listProductIngredientRating:{
			filter:"ProductIngredientRatingWhere",
			orderBy:"ProductIngredientRatingOrderBy"
		},
		paginateProductIngredientRating:{
			filter:"ProductIngredientRatingWhere",
			orderBy:"ProductIngredientRatingOrderBy"
		},
		validateCreateProductIngredientRating:{
			data:"ProductIngredientRatingCreateInput"
		},
		validateUpdateProductIngredientRating:{
			by:"ProductIngredientRatingUniqueWhere",
			data:"ProductIngredientRatingUpdateInput"
		},
		getProductIngredientLocale:{
			by:"ProductIngredientLocaleUniqueWhere",
			filter:"ProductIngredientLocaleWhere"
		},
		listProductIngredientLocale:{
			filter:"ProductIngredientLocaleWhere",
			orderBy:"ProductIngredientLocaleOrderBy"
		},
		paginateProductIngredientLocale:{
			filter:"ProductIngredientLocaleWhere",
			orderBy:"ProductIngredientLocaleOrderBy"
		},
		validateCreateProductIngredientLocale:{
			data:"ProductIngredientLocaleCreateInput"
		},
		validateUpdateProductIngredientLocale:{
			by:"ProductIngredientLocaleUniqueWhere",
			data:"ProductIngredientLocaleUpdateInput"
		},
		getOrderRecurrence:{
			by:"OrderRecurrenceUniqueWhere",
			filter:"OrderRecurrenceWhere"
		},
		listOrderRecurrence:{
			filter:"OrderRecurrenceWhere",
			orderBy:"OrderRecurrenceOrderBy"
		},
		paginateOrderRecurrence:{
			filter:"OrderRecurrenceWhere",
			orderBy:"OrderRecurrenceOrderBy"
		},
		validateCreateOrderRecurrence:{
			data:"OrderRecurrenceCreateInput"
		},
		validateUpdateOrderRecurrence:{
			by:"OrderRecurrenceUniqueWhere",
			data:"OrderRecurrenceUpdateInput"
		},
		getOrderRecurrenceLocale:{
			by:"OrderRecurrenceLocaleUniqueWhere",
			filter:"OrderRecurrenceLocaleWhere"
		},
		listOrderRecurrenceLocale:{
			filter:"OrderRecurrenceLocaleWhere",
			orderBy:"OrderRecurrenceLocaleOrderBy"
		},
		paginateOrderRecurrenceLocale:{
			filter:"OrderRecurrenceLocaleWhere",
			orderBy:"OrderRecurrenceLocaleOrderBy"
		},
		validateCreateOrderRecurrenceLocale:{
			data:"OrderRecurrenceLocaleCreateInput"
		},
		validateUpdateOrderRecurrenceLocale:{
			by:"OrderRecurrenceLocaleUniqueWhere",
			data:"OrderRecurrenceLocaleUpdateInput"
		},
		getBusinessCustomer:{
			by:"BusinessCustomerUniqueWhere",
			filter:"BusinessCustomerWhere"
		},
		listBusinessCustomer:{
			filter:"BusinessCustomerWhere",
			orderBy:"BusinessCustomerOrderBy"
		},
		paginateBusinessCustomer:{
			filter:"BusinessCustomerWhere",
			orderBy:"BusinessCustomerOrderBy"
		},
		validateCreateBusinessCustomer:{
			data:"BusinessCustomerCreateInput"
		},
		validateUpdateBusinessCustomer:{
			by:"BusinessCustomerUniqueWhere",
			data:"BusinessCustomerUpdateInput"
		},
		getPointOfSale:{
			by:"PointOfSaleUniqueWhere",
			filter:"PointOfSaleWhere"
		},
		listPointOfSale:{
			filter:"PointOfSaleWhere",
			orderBy:"PointOfSaleOrderBy"
		},
		paginatePointOfSale:{
			filter:"PointOfSaleWhere",
			orderBy:"PointOfSaleOrderBy"
		},
		validateCreatePointOfSale:{
			data:"PointOfSaleCreateInput"
		},
		validateUpdatePointOfSale:{
			by:"PointOfSaleUniqueWhere",
			data:"PointOfSaleUpdateInput"
		},
		getStaff:{
			by:"StaffUniqueWhere",
			filter:"StaffWhere"
		},
		listStaff:{
			filter:"StaffWhere",
			orderBy:"StaffOrderBy"
		},
		paginateStaff:{
			filter:"StaffWhere",
			orderBy:"StaffOrderBy"
		},
		validateCreateStaff:{
			data:"StaffCreateInput"
		},
		validateUpdateStaff:{
			by:"StaffUniqueWhere",
			data:"StaffUpdateInput"
		},
		getPointOfSalePermissions:{
			by:"PointOfSalePermissionsUniqueWhere",
			filter:"PointOfSalePermissionsWhere"
		},
		listPointOfSalePermissions:{
			filter:"PointOfSalePermissionsWhere",
			orderBy:"PointOfSalePermissionsOrderBy"
		},
		paginatePointOfSalePermissions:{
			filter:"PointOfSalePermissionsWhere",
			orderBy:"PointOfSalePermissionsOrderBy"
		},
		getBlog:{
			by:"BlogUniqueWhere",
			filter:"BlogWhere"
		},
		listBlog:{
			filter:"BlogWhere",
			orderBy:"BlogOrderBy"
		},
		paginateBlog:{
			filter:"BlogWhere",
			orderBy:"BlogOrderBy"
		},
		validateCreateBlog:{
			data:"BlogCreateInput"
		},
		validateUpdateBlog:{
			by:"BlogUniqueWhere",
			data:"BlogUpdateInput"
		},
		getBlogLocale:{
			by:"BlogLocaleUniqueWhere",
			filter:"BlogLocaleWhere"
		},
		listBlogLocale:{
			filter:"BlogLocaleWhere",
			orderBy:"BlogLocaleOrderBy"
		},
		paginateBlogLocale:{
			filter:"BlogLocaleWhere",
			orderBy:"BlogLocaleOrderBy"
		},
		validateCreateBlogLocale:{
			data:"BlogLocaleCreateInput"
		},
		validateUpdateBlogLocale:{
			by:"BlogLocaleUniqueWhere",
			data:"BlogLocaleUpdateInput"
		},
		getBlogPost:{
			by:"BlogPostUniqueWhere",
			filter:"BlogPostWhere"
		},
		listBlogPost:{
			filter:"BlogPostWhere",
			orderBy:"BlogPostOrderBy"
		},
		paginateBlogPost:{
			filter:"BlogPostWhere",
			orderBy:"BlogPostOrderBy"
		},
		validateCreateBlogPost:{
			data:"BlogPostCreateInput"
		},
		validateUpdateBlogPost:{
			by:"BlogPostUniqueWhere",
			data:"BlogPostUpdateInput"
		},
		getBlogPostLocale:{
			by:"BlogPostLocaleUniqueWhere",
			filter:"BlogPostLocaleWhere"
		},
		listBlogPostLocale:{
			filter:"BlogPostLocaleWhere",
			orderBy:"BlogPostLocaleOrderBy"
		},
		paginateBlogPostLocale:{
			filter:"BlogPostLocaleWhere",
			orderBy:"BlogPostLocaleOrderBy"
		},
		validateCreateBlogPostLocale:{
			data:"BlogPostLocaleCreateInput"
		},
		validateUpdateBlogPostLocale:{
			by:"BlogPostLocaleUniqueWhere",
			data:"BlogPostLocaleUpdateInput"
		},
		getColorPallete:{
			by:"ColorPalleteUniqueWhere",
			filter:"ColorPalleteWhere"
		},
		listColorPallete:{
			filter:"ColorPalleteWhere",
			orderBy:"ColorPalleteOrderBy"
		},
		paginateColorPallete:{
			filter:"ColorPalleteWhere",
			orderBy:"ColorPalleteOrderBy"
		},
		validateCreateColorPallete:{
			data:"ColorPalleteCreateInput"
		},
		validateUpdateColorPallete:{
			by:"ColorPalleteUniqueWhere",
			data:"ColorPalleteUpdateInput"
		},
		getContent:{
			by:"ContentUniqueWhere",
			filter:"ContentWhere"
		},
		listContent:{
			filter:"ContentWhere",
			orderBy:"ContentOrderBy"
		},
		paginateContent:{
			filter:"ContentWhere",
			orderBy:"ContentOrderBy"
		},
		validateCreateContent:{
			data:"ContentCreateInput"
		},
		validateUpdateContent:{
			by:"ContentUniqueWhere",
			data:"ContentUpdateInput"
		},
		getContentBlock:{
			by:"ContentBlockUniqueWhere",
			filter:"ContentBlockWhere"
		},
		listContentBlock:{
			filter:"ContentBlockWhere",
			orderBy:"ContentBlockOrderBy"
		},
		paginateContentBlock:{
			filter:"ContentBlockWhere",
			orderBy:"ContentBlockOrderBy"
		},
		validateCreateContentBlock:{
			data:"ContentBlockCreateInput"
		},
		validateUpdateContentBlock:{
			by:"ContentBlockUniqueWhere",
			data:"ContentBlockUpdateInput"
		},
		getContentReference:{
			by:"ContentReferenceUniqueWhere",
			filter:"ContentReferenceWhere"
		},
		listContentReference:{
			filter:"ContentReferenceWhere",
			orderBy:"ContentReferenceOrderBy"
		},
		paginateContentReference:{
			filter:"ContentReferenceWhere",
			orderBy:"ContentReferenceOrderBy"
		},
		validateCreateContentReference:{
			data:"ContentReferenceCreateInput"
		},
		validateUpdateContentReference:{
			by:"ContentReferenceUniqueWhere",
			data:"ContentReferenceUpdateInput"
		},
		getBlogPostList:{
			by:"BlogPostListUniqueWhere",
			filter:"BlogPostListWhere"
		},
		listBlogPostList:{
			filter:"BlogPostListWhere",
			orderBy:"BlogPostListOrderBy"
		},
		paginateBlogPostList:{
			filter:"BlogPostListWhere",
			orderBy:"BlogPostListOrderBy"
		},
		validateCreateBlogPostList:{
			data:"BlogPostListCreateInput"
		},
		validateUpdateBlogPostList:{
			by:"BlogPostListUniqueWhere",
			data:"BlogPostListUpdateInput"
		},
		getBlogPostListItem:{
			by:"BlogPostListItemUniqueWhere",
			filter:"BlogPostListItemWhere"
		},
		listBlogPostListItem:{
			filter:"BlogPostListItemWhere",
			orderBy:"BlogPostListItemOrderBy"
		},
		paginateBlogPostListItem:{
			filter:"BlogPostListItemWhere",
			orderBy:"BlogPostListItemOrderBy"
		},
		validateCreateBlogPostListItem:{
			data:"BlogPostListItemCreateInput"
		},
		validateUpdateBlogPostListItem:{
			by:"BlogPostListItemUniqueWhere",
			data:"BlogPostListItemUpdateInput"
		},
		getLinkList:{
			by:"LinkListUniqueWhere",
			filter:"LinkListWhere"
		},
		listLinkList:{
			filter:"LinkListWhere",
			orderBy:"LinkListOrderBy"
		},
		paginateLinkList:{
			filter:"LinkListWhere",
			orderBy:"LinkListOrderBy"
		},
		validateCreateLinkList:{
			data:"LinkListCreateInput"
		},
		validateUpdateLinkList:{
			by:"LinkListUniqueWhere",
			data:"LinkListUpdateInput"
		},
		getLinkListItem:{
			by:"LinkListItemUniqueWhere",
			filter:"LinkListItemWhere"
		},
		listLinkListItem:{
			filter:"LinkListItemWhere",
			orderBy:"LinkListItemOrderBy"
		},
		paginateLinkListItem:{
			filter:"LinkListItemWhere",
			orderBy:"LinkListItemOrderBy"
		},
		validateCreateLinkListItem:{
			data:"LinkListItemCreateInput"
		},
		validateUpdateLinkListItem:{
			by:"LinkListItemUniqueWhere",
			data:"LinkListItemUpdateInput"
		},
		getCover:{
			by:"CoverUniqueWhere",
			filter:"CoverWhere"
		},
		listCover:{
			filter:"CoverWhere",
			orderBy:"CoverOrderBy"
		},
		paginateCover:{
			filter:"CoverWhere",
			orderBy:"CoverOrderBy"
		},
		validateCreateCover:{
			data:"CoverCreateInput"
		},
		validateUpdateCover:{
			by:"CoverUniqueWhere",
			data:"CoverUpdateInput"
		},
		getLink:{
			by:"LinkUniqueWhere",
			filter:"LinkWhere"
		},
		listLink:{
			filter:"LinkWhere",
			orderBy:"LinkOrderBy"
		},
		paginateLink:{
			filter:"LinkWhere",
			orderBy:"LinkOrderBy"
		},
		validateCreateLink:{
			data:"LinkCreateInput"
		},
		validateUpdateLink:{
			by:"LinkUniqueWhere",
			data:"LinkUpdateInput"
		},
		getLinkable:{
			by:"LinkableUniqueWhere",
			filter:"LinkableWhere"
		},
		listLinkable:{
			filter:"LinkableWhere",
			orderBy:"LinkableOrderBy"
		},
		paginateLinkable:{
			filter:"LinkableWhere",
			orderBy:"LinkableOrderBy"
		},
		validateCreateLinkable:{
			data:"LinkableCreateInput"
		},
		validateUpdateLinkable:{
			by:"LinkableUniqueWhere",
			data:"LinkableUpdateInput"
		},
		getMedium:{
			by:"MediumUniqueWhere",
			filter:"MediumWhere"
		},
		listMedium:{
			filter:"MediumWhere",
			orderBy:"MediumOrderBy"
		},
		paginateMedium:{
			filter:"MediumWhere",
			orderBy:"MediumOrderBy"
		},
		validateCreateMedium:{
			data:"MediumCreateInput"
		},
		validateUpdateMedium:{
			by:"MediumUniqueWhere",
			data:"MediumUpdateInput"
		},
		getVideo:{
			by:"VideoUniqueWhere",
			filter:"VideoWhere"
		},
		listVideo:{
			filter:"VideoWhere",
			orderBy:"VideoOrderBy"
		},
		paginateVideo:{
			filter:"VideoWhere",
			orderBy:"VideoOrderBy"
		},
		validateCreateVideo:{
			data:"VideoCreateInput"
		},
		validateUpdateVideo:{
			by:"VideoUniqueWhere",
			data:"VideoUpdateInput"
		},
		getSeo:{
			by:"SeoUniqueWhere",
			filter:"SeoWhere"
		},
		listSeo:{
			filter:"SeoWhere",
			orderBy:"SeoOrderBy"
		},
		paginateSeo:{
			filter:"SeoWhere",
			orderBy:"SeoOrderBy"
		},
		validateCreateSeo:{
			data:"SeoCreateInput"
		},
		validateUpdateSeo:{
			by:"SeoUniqueWhere",
			data:"SeoUpdateInput"
		},
		getProtectedImage:{
			by:"ProtectedImageUniqueWhere",
			filter:"ProtectedImageWhere"
		},
		listProtectedImage:{
			filter:"ProtectedImageWhere",
			orderBy:"ProtectedImageOrderBy"
		},
		paginateProtectedImage:{
			filter:"ProtectedImageWhere",
			orderBy:"ProtectedImageOrderBy"
		},
		validateCreateProtectedImage:{
			data:"ProtectedImageCreateInput"
		},
		validateUpdateProtectedImage:{
			by:"ProtectedImageUniqueWhere",
			data:"ProtectedImageUpdateInput"
		},
		getTranslationDomain:{
			by:"TranslationDomainUniqueWhere",
			filter:"TranslationDomainWhere"
		},
		listTranslationDomain:{
			filter:"TranslationDomainWhere",
			orderBy:"TranslationDomainOrderBy"
		},
		paginateTranslationDomain:{
			filter:"TranslationDomainWhere",
			orderBy:"TranslationDomainOrderBy"
		},
		validateCreateTranslationDomain:{
			data:"TranslationDomainCreateInput"
		},
		validateUpdateTranslationDomain:{
			by:"TranslationDomainUniqueWhere",
			data:"TranslationDomainUpdateInput"
		},
		getTranslationCatalogue:{
			by:"TranslationCatalogueUniqueWhere",
			filter:"TranslationCatalogueWhere"
		},
		listTranslationCatalogue:{
			filter:"TranslationCatalogueWhere",
			orderBy:"TranslationCatalogueOrderBy"
		},
		paginateTranslationCatalogue:{
			filter:"TranslationCatalogueWhere",
			orderBy:"TranslationCatalogueOrderBy"
		},
		validateCreateTranslationCatalogue:{
			data:"TranslationCatalogueCreateInput"
		},
		validateUpdateTranslationCatalogue:{
			by:"TranslationCatalogueUniqueWhere",
			data:"TranslationCatalogueUpdateInput"
		},
		getTranslationKey:{
			by:"TranslationKeyUniqueWhere",
			filter:"TranslationKeyWhere"
		},
		listTranslationKey:{
			filter:"TranslationKeyWhere",
			orderBy:"TranslationKeyOrderBy"
		},
		paginateTranslationKey:{
			filter:"TranslationKeyWhere",
			orderBy:"TranslationKeyOrderBy"
		},
		validateCreateTranslationKey:{
			data:"TranslationKeyCreateInput"
		},
		validateUpdateTranslationKey:{
			by:"TranslationKeyUniqueWhere",
			data:"TranslationKeyUpdateInput"
		},
		getTranslationValue:{
			by:"TranslationValueUniqueWhere",
			filter:"TranslationValueWhere"
		},
		listTranslationValue:{
			filter:"TranslationValueWhere",
			orderBy:"TranslationValueOrderBy"
		},
		paginateTranslationValue:{
			filter:"TranslationValueWhere",
			orderBy:"TranslationValueOrderBy"
		},
		validateCreateTranslationValue:{
			data:"TranslationValueCreateInput"
		},
		validateUpdateTranslationValue:{
			by:"TranslationValueUniqueWhere",
			data:"TranslationValueUpdateInput"
		},
		getTranslationCataloguesIdentifier:{
			by:"TranslationCataloguesIdentifierUniqueWhere",
			filter:"TranslationCataloguesIdentifierWhere"
		},
		listTranslationCataloguesIdentifier:{
			filter:"TranslationCataloguesIdentifierWhere",
			orderBy:"TranslationCataloguesIdentifierOrderBy"
		},
		paginateTranslationCataloguesIdentifier:{
			filter:"TranslationCataloguesIdentifierWhere",
			orderBy:"TranslationCataloguesIdentifierOrderBy"
		},
		validateCreateTranslationCataloguesIdentifier:{
			data:"TranslationCataloguesIdentifierCreateInput"
		},
		validateUpdateTranslationCataloguesIdentifier:{
			by:"TranslationCataloguesIdentifierUniqueWhere",
			data:"TranslationCataloguesIdentifierUpdateInput"
		},
		getSocialsAndApps:{
			by:"SocialsAndAppsUniqueWhere",
			filter:"SocialsAndAppsWhere"
		},
		listSocialsAndApps:{
			filter:"SocialsAndAppsWhere",
			orderBy:"SocialsAndAppsOrderBy"
		},
		paginateSocialsAndApps:{
			filter:"SocialsAndAppsWhere",
			orderBy:"SocialsAndAppsOrderBy"
		},
		validateCreateSocialsAndApps:{
			data:"SocialsAndAppsCreateInput"
		},
		validateUpdateSocialsAndApps:{
			by:"SocialsAndAppsUniqueWhere",
			data:"SocialsAndAppsUpdateInput"
		},
		getProductGrid:{
			by:"ProductGridUniqueWhere",
			filter:"ProductGridWhere"
		},
		listProductGrid:{
			filter:"ProductGridWhere",
			orderBy:"ProductGridOrderBy"
		},
		paginateProductGrid:{
			filter:"ProductGridWhere",
			orderBy:"ProductGridOrderBy"
		},
		validateCreateProductGrid:{
			data:"ProductGridCreateInput"
		},
		validateUpdateProductGrid:{
			by:"ProductGridUniqueWhere",
			data:"ProductGridUpdateInput"
		},
		getProductGridItem:{
			by:"ProductGridItemUniqueWhere",
			filter:"ProductGridItemWhere"
		},
		listProductGridItem:{
			filter:"ProductGridItemWhere",
			orderBy:"ProductGridItemOrderBy"
		},
		paginateProductGridItem:{
			filter:"ProductGridItemWhere",
			orderBy:"ProductGridItemOrderBy"
		},
		validateCreateProductGridItem:{
			data:"ProductGridItemCreateInput"
		},
		validateUpdateProductGridItem:{
			by:"ProductGridItemUniqueWhere",
			data:"ProductGridItemUpdateInput"
		},
		getGallery:{
			by:"GalleryUniqueWhere",
			filter:"GalleryWhere"
		},
		listGallery:{
			filter:"GalleryWhere",
			orderBy:"GalleryOrderBy"
		},
		paginateGallery:{
			filter:"GalleryWhere",
			orderBy:"GalleryOrderBy"
		},
		validateCreateGallery:{
			data:"GalleryCreateInput"
		},
		validateUpdateGallery:{
			by:"GalleryUniqueWhere",
			data:"GalleryUpdateInput"
		},
		getGalleryItem:{
			by:"GalleryItemUniqueWhere",
			filter:"GalleryItemWhere"
		},
		listGalleryItem:{
			filter:"GalleryItemWhere",
			orderBy:"GalleryItemOrderBy"
		},
		paginateGalleryItem:{
			filter:"GalleryItemWhere",
			orderBy:"GalleryItemOrderBy"
		},
		validateCreateGalleryItem:{
			data:"GalleryItemCreateInput"
		},
		validateUpdateGalleryItem:{
			by:"GalleryItemUniqueWhere",
			data:"GalleryItemUpdateInput"
		},
		getHero:{
			by:"HeroUniqueWhere",
			filter:"HeroWhere"
		},
		listHero:{
			filter:"HeroWhere",
			orderBy:"HeroOrderBy"
		},
		paginateHero:{
			filter:"HeroWhere",
			orderBy:"HeroOrderBy"
		},
		validateCreateHero:{
			data:"HeroCreateInput"
		},
		validateUpdateHero:{
			by:"HeroUniqueWhere",
			data:"HeroUpdateInput"
		},
		getSiteMenu:{
			by:"SiteMenuUniqueWhere",
			filter:"SiteMenuWhere"
		},
		listSiteMenu:{
			filter:"SiteMenuWhere",
			orderBy:"SiteMenuOrderBy"
		},
		paginateSiteMenu:{
			filter:"SiteMenuWhere",
			orderBy:"SiteMenuOrderBy"
		},
		validateCreateSiteMenu:{
			data:"SiteMenuCreateInput"
		},
		validateUpdateSiteMenu:{
			by:"SiteMenuUniqueWhere",
			data:"SiteMenuUpdateInput"
		},
		getMenuLocale:{
			by:"MenuLocaleUniqueWhere",
			filter:"MenuLocaleWhere"
		},
		listMenuLocale:{
			filter:"MenuLocaleWhere",
			orderBy:"MenuLocaleOrderBy"
		},
		paginateMenuLocale:{
			filter:"MenuLocaleWhere",
			orderBy:"MenuLocaleOrderBy"
		},
		validateCreateMenuLocale:{
			data:"MenuLocaleCreateInput"
		},
		validateUpdateMenuLocale:{
			by:"MenuLocaleUniqueWhere",
			data:"MenuLocaleUpdateInput"
		},
		getMenuItem:{
			by:"MenuItemUniqueWhere",
			filter:"MenuItemWhere"
		},
		listMenuItem:{
			filter:"MenuItemWhere",
			orderBy:"MenuItemOrderBy"
		},
		paginateMenuItem:{
			filter:"MenuItemWhere",
			orderBy:"MenuItemOrderBy"
		},
		validateCreateMenuItem:{
			data:"MenuItemCreateInput"
		},
		validateUpdateMenuItem:{
			by:"MenuItemUniqueWhere",
			data:"MenuItemUpdateInput"
		},
		getPage:{
			by:"PageUniqueWhere",
			filter:"PageWhere"
		},
		listPage:{
			filter:"PageWhere",
			orderBy:"PageOrderBy"
		},
		paginatePage:{
			filter:"PageWhere",
			orderBy:"PageOrderBy"
		},
		validateCreatePage:{
			data:"PageCreateInput"
		},
		validateUpdatePage:{
			by:"PageUniqueWhere",
			data:"PageUpdateInput"
		},
		getPageLocale:{
			by:"PageLocaleUniqueWhere",
			filter:"PageLocaleWhere"
		},
		listPageLocale:{
			filter:"PageLocaleWhere",
			orderBy:"PageLocaleOrderBy"
		},
		paginatePageLocale:{
			filter:"PageLocaleWhere",
			orderBy:"PageLocaleOrderBy"
		},
		validateCreatePageLocale:{
			data:"PageLocaleCreateInput"
		},
		validateUpdatePageLocale:{
			by:"PageLocaleUniqueWhere",
			data:"PageLocaleUpdateInput"
		},
		getWikiPage:{
			by:"WikiPageUniqueWhere",
			filter:"WikiPageWhere"
		},
		listWikiPage:{
			filter:"WikiPageWhere",
			orderBy:"WikiPageOrderBy"
		},
		paginateWikiPage:{
			filter:"WikiPageWhere",
			orderBy:"WikiPageOrderBy"
		},
		validateCreateWikiPage:{
			data:"WikiPageCreateInput"
		},
		validateUpdateWikiPage:{
			by:"WikiPageUniqueWhere",
			data:"WikiPageUpdateInput"
		},
		getMenuSubitem:{
			by:"MenuSubitemUniqueWhere",
			filter:"MenuSubitemWhere"
		},
		listMenuSubitem:{
			filter:"MenuSubitemWhere",
			orderBy:"MenuSubitemOrderBy"
		},
		paginateMenuSubitem:{
			filter:"MenuSubitemWhere",
			orderBy:"MenuSubitemOrderBy"
		},
		validateCreateMenuSubitem:{
			data:"MenuSubitemCreateInput"
		},
		validateUpdateMenuSubitem:{
			by:"MenuSubitemUniqueWhere",
			data:"MenuSubitemUpdateInput"
		},
		getMenuLinkList:{
			by:"MenuLinkListUniqueWhere",
			filter:"MenuLinkListWhere"
		},
		listMenuLinkList:{
			filter:"MenuLinkListWhere",
			orderBy:"MenuLinkListOrderBy"
		},
		paginateMenuLinkList:{
			filter:"MenuLinkListWhere",
			orderBy:"MenuLinkListOrderBy"
		},
		validateCreateMenuLinkList:{
			data:"MenuLinkListCreateInput"
		},
		validateUpdateMenuLinkList:{
			by:"MenuLinkListUniqueWhere",
			data:"MenuLinkListUpdateInput"
		},
		getMenuLinkItem:{
			by:"MenuLinkItemUniqueWhere",
			filter:"MenuLinkItemWhere"
		},
		listMenuLinkItem:{
			filter:"MenuLinkItemWhere",
			orderBy:"MenuLinkItemOrderBy"
		},
		paginateMenuLinkItem:{
			filter:"MenuLinkItemWhere",
			orderBy:"MenuLinkItemOrderBy"
		},
		validateCreateMenuLinkItem:{
			data:"MenuLinkItemCreateInput"
		},
		validateUpdateMenuLinkItem:{
			by:"MenuLinkItemUniqueWhere",
			data:"MenuLinkItemUpdateInput"
		},
		getMenuProducts:{
			by:"MenuProductsUniqueWhere",
			filter:"MenuProductsWhere"
		},
		listMenuProducts:{
			filter:"MenuProductsWhere",
			orderBy:"MenuProductsOrderBy"
		},
		paginateMenuProducts:{
			filter:"MenuProductsWhere",
			orderBy:"MenuProductsOrderBy"
		},
		validateCreateMenuProducts:{
			data:"MenuProductsCreateInput"
		},
		validateUpdateMenuProducts:{
			by:"MenuProductsUniqueWhere",
			data:"MenuProductsUpdateInput"
		},
		getMenuDelivery:{
			by:"MenuDeliveryUniqueWhere",
			filter:"MenuDeliveryWhere"
		},
		listMenuDelivery:{
			filter:"MenuDeliveryWhere",
			orderBy:"MenuDeliveryOrderBy"
		},
		paginateMenuDelivery:{
			filter:"MenuDeliveryWhere",
			orderBy:"MenuDeliveryOrderBy"
		},
		validateCreateMenuDelivery:{
			data:"MenuDeliveryCreateInput"
		},
		validateUpdateMenuDelivery:{
			by:"MenuDeliveryUniqueWhere",
			data:"MenuDeliveryUpdateInput"
		},
		getMenuContact:{
			by:"MenuContactUniqueWhere",
			filter:"MenuContactWhere"
		},
		listMenuContact:{
			filter:"MenuContactWhere",
			orderBy:"MenuContactOrderBy"
		},
		paginateMenuContact:{
			filter:"MenuContactWhere",
			orderBy:"MenuContactOrderBy"
		},
		validateCreateMenuContact:{
			data:"MenuContactCreateInput"
		},
		validateUpdateMenuContact:{
			by:"MenuContactUniqueWhere",
			data:"MenuContactUpdateInput"
		},
		getDeadlineTemplate:{
			by:"DeadlineTemplateUniqueWhere",
			filter:"DeadlineTemplateWhere"
		},
		listDeadlineTemplate:{
			filter:"DeadlineTemplateWhere",
			orderBy:"DeadlineTemplateOrderBy"
		},
		paginateDeadlineTemplate:{
			filter:"DeadlineTemplateWhere",
			orderBy:"DeadlineTemplateOrderBy"
		},
		validateCreateDeadlineTemplate:{
			data:"DeadlineTemplateCreateInput"
		},
		validateUpdateDeadlineTemplate:{
			by:"DeadlineTemplateUniqueWhere",
			data:"DeadlineTemplateUpdateInput"
		},
		getEmployeeQueue:{
			by:"EmployeeQueueUniqueWhere",
			filter:"EmployeeQueueWhere"
		},
		listEmployeeQueue:{
			filter:"EmployeeQueueWhere",
			orderBy:"EmployeeQueueOrderBy"
		},
		paginateEmployeeQueue:{
			filter:"EmployeeQueueWhere",
			orderBy:"EmployeeQueueOrderBy"
		},
		validateCreateEmployeeQueue:{
			data:"EmployeeQueueCreateInput"
		},
		validateUpdateEmployeeQueue:{
			by:"EmployeeQueueUniqueWhere",
			data:"EmployeeQueueUpdateInput"
		},
		getTimetableDay:{
			by:"TimetableDayUniqueWhere",
			filter:"TimetableDayWhere"
		},
		listTimetableDay:{
			filter:"TimetableDayWhere",
			orderBy:"TimetableDayOrderBy"
		},
		paginateTimetableDay:{
			filter:"TimetableDayWhere",
			orderBy:"TimetableDayOrderBy"
		},
		validateCreateTimetableDay:{
			data:"TimetableDayCreateInput"
		},
		validateUpdateTimetableDay:{
			by:"TimetableDayUniqueWhere",
			data:"TimetableDayUpdateInput"
		},
		getTimetableEmployeeRole:{
			by:"TimetableEmployeeRoleUniqueWhere",
			filter:"TimetableEmployeeRoleWhere"
		},
		listTimetableEmployeeRole:{
			filter:"TimetableEmployeeRoleWhere",
			orderBy:"TimetableEmployeeRoleOrderBy"
		},
		paginateTimetableEmployeeRole:{
			filter:"TimetableEmployeeRoleWhere",
			orderBy:"TimetableEmployeeRoleOrderBy"
		},
		validateCreateTimetableEmployeeRole:{
			data:"TimetableEmployeeRoleCreateInput"
		},
		validateUpdateTimetableEmployeeRole:{
			by:"TimetableEmployeeRoleUniqueWhere",
			data:"TimetableEmployeeRoleUpdateInput"
		},
		getTimetableShift:{
			by:"TimetableShiftUniqueWhere",
			filter:"TimetableShiftWhere"
		},
		listTimetableShift:{
			filter:"TimetableShiftWhere",
			orderBy:"TimetableShiftOrderBy"
		},
		paginateTimetableShift:{
			filter:"TimetableShiftWhere",
			orderBy:"TimetableShiftOrderBy"
		},
		validateCreateTimetableShift:{
			data:"TimetableShiftCreateInput"
		},
		validateUpdateTimetableShift:{
			by:"TimetableShiftUniqueWhere",
			data:"TimetableShiftUpdateInput"
		},
		getTimetableShiftGroup:{
			by:"TimetableShiftGroupUniqueWhere",
			filter:"TimetableShiftGroupWhere"
		},
		listTimetableShiftGroup:{
			filter:"TimetableShiftGroupWhere",
			orderBy:"TimetableShiftGroupOrderBy"
		},
		paginateTimetableShiftGroup:{
			filter:"TimetableShiftGroupWhere",
			orderBy:"TimetableShiftGroupOrderBy"
		},
		validateCreateTimetableShiftGroup:{
			data:"TimetableShiftGroupCreateInput"
		},
		validateUpdateTimetableShiftGroup:{
			by:"TimetableShiftGroupUniqueWhere",
			data:"TimetableShiftGroupUpdateInput"
		},
		getTimetableShiftPosition:{
			by:"TimetableShiftPositionUniqueWhere",
			filter:"TimetableShiftPositionWhere"
		},
		listTimetableShiftPosition:{
			filter:"TimetableShiftPositionWhere",
			orderBy:"TimetableShiftPositionOrderBy"
		},
		paginateTimetableShiftPosition:{
			filter:"TimetableShiftPositionWhere",
			orderBy:"TimetableShiftPositionOrderBy"
		},
		validateCreateTimetableShiftPosition:{
			data:"TimetableShiftPositionCreateInput"
		},
		validateUpdateTimetableShiftPosition:{
			by:"TimetableShiftPositionUniqueWhere",
			data:"TimetableShiftPositionUpdateInput"
		},
		getTimetableTemplate:{
			by:"TimetableTemplateUniqueWhere",
			filter:"TimetableTemplateWhere"
		},
		listTimetableTemplate:{
			filter:"TimetableTemplateWhere",
			orderBy:"TimetableTemplateOrderBy"
		},
		paginateTimetableTemplate:{
			filter:"TimetableTemplateWhere",
			orderBy:"TimetableTemplateOrderBy"
		},
		validateCreateTimetableTemplate:{
			data:"TimetableTemplateCreateInput"
		},
		validateUpdateTimetableTemplate:{
			by:"TimetableTemplateUniqueWhere",
			data:"TimetableTemplateUpdateInput"
		},
		getCart:{
			by:"CartUniqueWhere",
			filter:"CartWhere"
		},
		listCart:{
			filter:"CartWhere",
			orderBy:"CartOrderBy"
		},
		paginateCart:{
			filter:"CartWhere",
			orderBy:"CartOrderBy"
		},
		validateCreateCart:{
			data:"CartCreateInput"
		},
		validateUpdateCart:{
			by:"CartUniqueWhere",
			data:"CartUpdateInput"
		},
		getCartItem:{
			by:"CartItemUniqueWhere",
			filter:"CartItemWhere"
		},
		listCartItem:{
			filter:"CartItemWhere",
			orderBy:"CartItemOrderBy"
		},
		paginateCartItem:{
			filter:"CartItemWhere",
			orderBy:"CartItemOrderBy"
		},
		validateCreateCartItem:{
			data:"CartItemCreateInput"
		},
		validateUpdateCartItem:{
			by:"CartItemUniqueWhere",
			data:"CartItemUpdateInput"
		},
		getEmployeeQueueItem:{
			by:"EmployeeQueueItemUniqueWhere",
			filter:"EmployeeQueueItemWhere"
		},
		listEmployeeQueueItem:{
			filter:"EmployeeQueueItemWhere",
			orderBy:"EmployeeQueueItemOrderBy"
		},
		paginateEmployeeQueueItem:{
			filter:"EmployeeQueueItemWhere",
			orderBy:"EmployeeQueueItemOrderBy"
		},
		validateCreateEmployeeQueueItem:{
			data:"EmployeeQueueItemCreateInput"
		},
		validateUpdateEmployeeQueueItem:{
			by:"EmployeeQueueItemUniqueWhere",
			data:"EmployeeQueueItemUpdateInput"
		},
		getApplication:{
			by:"ApplicationUniqueWhere",
			filter:"ApplicationWhere"
		},
		listApplication:{
			filter:"ApplicationWhere",
			orderBy:"ApplicationOrderBy"
		},
		paginateApplication:{
			filter:"ApplicationWhere",
			orderBy:"ApplicationOrderBy"
		},
		validateCreateApplication:{
			data:"ApplicationCreateInput"
		},
		validateUpdateApplication:{
			by:"ApplicationUniqueWhere",
			data:"ApplicationUpdateInput"
		},
		getApplicationShortcutList:{
			by:"ApplicationShortcutListUniqueWhere",
			filter:"ApplicationShortcutListWhere"
		},
		listApplicationShortcutList:{
			filter:"ApplicationShortcutListWhere",
			orderBy:"ApplicationShortcutListOrderBy"
		},
		paginateApplicationShortcutList:{
			filter:"ApplicationShortcutListWhere",
			orderBy:"ApplicationShortcutListOrderBy"
		},
		validateCreateApplicationShortcutList:{
			data:"ApplicationShortcutListCreateInput"
		},
		validateUpdateApplicationShortcutList:{
			by:"ApplicationShortcutListUniqueWhere",
			data:"ApplicationShortcutListUpdateInput"
		},
		getApplicationShortcutListItem:{
			by:"ApplicationShortcutListItemUniqueWhere",
			filter:"ApplicationShortcutListItemWhere"
		},
		listApplicationShortcutListItem:{
			filter:"ApplicationShortcutListItemWhere",
			orderBy:"ApplicationShortcutListItemOrderBy"
		},
		paginateApplicationShortcutListItem:{
			filter:"ApplicationShortcutListItemWhere",
			orderBy:"ApplicationShortcutListItemOrderBy"
		},
		validateCreateApplicationShortcutListItem:{
			data:"ApplicationShortcutListItemCreateInput"
		},
		validateUpdateApplicationShortcutListItem:{
			by:"ApplicationShortcutListItemUniqueWhere",
			data:"ApplicationShortcutListItemUpdateInput"
		},
		getProductBanner:{
			by:"ProductBannerUniqueWhere",
			filter:"ProductBannerWhere"
		},
		listProductBanner:{
			filter:"ProductBannerWhere",
			orderBy:"ProductBannerOrderBy"
		},
		paginateProductBanner:{
			filter:"ProductBannerWhere",
			orderBy:"ProductBannerOrderBy"
		},
		validateCreateProductBanner:{
			data:"ProductBannerCreateInput"
		},
		validateUpdateProductBanner:{
			by:"ProductBannerUniqueWhere",
			data:"ProductBannerUpdateInput"
		},
		getProductBannerItem:{
			by:"ProductBannerItemUniqueWhere",
			filter:"ProductBannerItemWhere"
		},
		listProductBannerItem:{
			filter:"ProductBannerItemWhere",
			orderBy:"ProductBannerItemOrderBy"
		},
		paginateProductBannerItem:{
			filter:"ProductBannerItemWhere",
			orderBy:"ProductBannerItemOrderBy"
		},
		validateCreateProductBannerItem:{
			data:"ProductBannerItemCreateInput"
		},
		validateUpdateProductBannerItem:{
			by:"ProductBannerItemUniqueWhere",
			data:"ProductBannerItemUpdateInput"
		},
		getProductBannerList:{
			by:"ProductBannerListUniqueWhere",
			filter:"ProductBannerListWhere"
		},
		listProductBannerList:{
			filter:"ProductBannerListWhere",
			orderBy:"ProductBannerListOrderBy"
		},
		paginateProductBannerList:{
			filter:"ProductBannerListWhere",
			orderBy:"ProductBannerListOrderBy"
		},
		validateCreateProductBannerList:{
			data:"ProductBannerListCreateInput"
		},
		validateUpdateProductBannerList:{
			by:"ProductBannerListUniqueWhere",
			data:"ProductBannerListUpdateInput"
		},
		getBartender:{
			by:"BartenderUniqueWhere",
			filter:"BartenderWhere"
		},
		listBartender:{
			filter:"BartenderWhere",
			orderBy:"BartenderOrderBy"
		},
		paginateBartender:{
			filter:"BartenderWhere",
			orderBy:"BartenderOrderBy"
		},
		validateCreateBartender:{
			data:"BartenderCreateInput"
		},
		validateUpdateBartender:{
			by:"BartenderUniqueWhere",
			data:"BartenderUpdateInput"
		},
		getBusinessToBusinessManager:{
			by:"BusinessToBusinessManagerUniqueWhere",
			filter:"BusinessToBusinessManagerWhere"
		},
		listBusinessToBusinessManager:{
			filter:"BusinessToBusinessManagerWhere",
			orderBy:"BusinessToBusinessManagerOrderBy"
		},
		paginateBusinessToBusinessManager:{
			filter:"BusinessToBusinessManagerWhere",
			orderBy:"BusinessToBusinessManagerOrderBy"
		},
		validateCreateBusinessToBusinessManager:{
			data:"BusinessToBusinessManagerCreateInput"
		},
		validateUpdateBusinessToBusinessManager:{
			by:"BusinessToBusinessManagerUniqueWhere",
			data:"BusinessToBusinessManagerUpdateInput"
		},
		getCleaner:{
			by:"CleanerUniqueWhere",
			filter:"CleanerWhere"
		},
		listCleaner:{
			filter:"CleanerWhere",
			orderBy:"CleanerOrderBy"
		},
		paginateCleaner:{
			filter:"CleanerWhere",
			orderBy:"CleanerOrderBy"
		},
		validateCreateCleaner:{
			data:"CleanerCreateInput"
		},
		validateUpdateCleaner:{
			by:"CleanerUniqueWhere",
			data:"CleanerUpdateInput"
		},
		getCourier:{
			by:"CourierUniqueWhere",
			filter:"CourierWhere"
		},
		listCourier:{
			filter:"CourierWhere",
			orderBy:"CourierOrderBy"
		},
		paginateCourier:{
			filter:"CourierWhere",
			orderBy:"CourierOrderBy"
		},
		validateCreateCourier:{
			data:"CourierCreateInput"
		},
		validateUpdateCourier:{
			by:"CourierUniqueWhere",
			data:"CourierUpdateInput"
		},
		getShiftsManager:{
			by:"ShiftsManagerUniqueWhere",
			filter:"ShiftsManagerWhere"
		},
		listShiftsManager:{
			filter:"ShiftsManagerWhere",
			orderBy:"ShiftsManagerOrderBy"
		},
		paginateShiftsManager:{
			filter:"ShiftsManagerWhere",
			orderBy:"ShiftsManagerOrderBy"
		},
		validateCreateShiftsManager:{
			data:"ShiftsManagerCreateInput"
		},
		validateUpdateShiftsManager:{
			by:"ShiftsManagerUniqueWhere",
			data:"ShiftsManagerUpdateInput"
		},
		getUser:{
			by:"UserUniqueWhere",
			filter:"UserWhere"
		},
		listUser:{
			filter:"UserWhere",
			orderBy:"UserOrderBy"
		},
		paginateUser:{
			filter:"UserWhere",
			orderBy:"UserOrderBy"
		},
		validateCreateUser:{
			data:"UserCreateInput"
		},
		validateUpdateUser:{
			by:"UserUniqueWhere",
			data:"UserUpdateInput"
		},
		getShiftsProfile:{
			by:"ShiftsProfileUniqueWhere",
			filter:"ShiftsProfileWhere"
		},
		listShiftsProfile:{
			filter:"ShiftsProfileWhere",
			orderBy:"ShiftsProfileOrderBy"
		},
		paginateShiftsProfile:{
			filter:"ShiftsProfileWhere",
			orderBy:"ShiftsProfileOrderBy"
		},
		validateCreateShiftsProfile:{
			data:"ShiftsProfileCreateInput"
		},
		validateUpdateShiftsProfile:{
			by:"ShiftsProfileUniqueWhere",
			data:"ShiftsProfileUpdateInput"
		},
		getProductIngredientCategory:{
			by:"ProductIngredientCategoryUniqueWhere",
			filter:"ProductIngredientCategoryWhere"
		},
		listProductIngredientCategory:{
			filter:"ProductIngredientCategoryWhere",
			orderBy:"ProductIngredientCategoryOrderBy"
		},
		paginateProductIngredientCategory:{
			filter:"ProductIngredientCategoryWhere",
			orderBy:"ProductIngredientCategoryOrderBy"
		},
		validateCreateProductIngredientCategory:{
			data:"ProductIngredientCategoryCreateInput"
		},
		validateUpdateProductIngredientCategory:{
			by:"ProductIngredientCategoryUniqueWhere",
			data:"ProductIngredientCategoryUpdateInput"
		},
		getProductIngredientCategoryLocale:{
			by:"ProductIngredientCategoryLocaleUniqueWhere",
			filter:"ProductIngredientCategoryLocaleWhere"
		},
		listProductIngredientCategoryLocale:{
			filter:"ProductIngredientCategoryLocaleWhere",
			orderBy:"ProductIngredientCategoryLocaleOrderBy"
		},
		paginateProductIngredientCategoryLocale:{
			filter:"ProductIngredientCategoryLocaleWhere",
			orderBy:"ProductIngredientCategoryLocaleOrderBy"
		},
		validateCreateProductIngredientCategoryLocale:{
			data:"ProductIngredientCategoryLocaleCreateInput"
		},
		validateUpdateProductIngredientCategoryLocale:{
			by:"ProductIngredientCategoryLocaleUniqueWhere",
			data:"ProductIngredientCategoryLocaleUpdateInput"
		},
		getStocksManager:{
			by:"StocksManagerUniqueWhere",
			filter:"StocksManagerWhere"
		},
		listStocksManager:{
			filter:"StocksManagerWhere",
			orderBy:"StocksManagerOrderBy"
		},
		paginateStocksManager:{
			filter:"StocksManagerWhere",
			orderBy:"StocksManagerOrderBy"
		},
		validateCreateStocksManager:{
			data:"StocksManagerCreateInput"
		},
		validateUpdateStocksManager:{
			by:"StocksManagerUniqueWhere",
			data:"StocksManagerUpdateInput"
		},
		getDeliveryRoute:{
			by:"DeliveryRouteUniqueWhere",
			filter:"DeliveryRouteWhere"
		},
		listDeliveryRoute:{
			filter:"DeliveryRouteWhere",
			orderBy:"DeliveryRouteOrderBy"
		},
		paginateDeliveryRoute:{
			filter:"DeliveryRouteWhere",
			orderBy:"DeliveryRouteOrderBy"
		},
		validateCreateDeliveryRoute:{
			data:"DeliveryRouteCreateInput"
		},
		validateUpdateDeliveryRoute:{
			by:"DeliveryRouteUniqueWhere",
			data:"DeliveryRouteUpdateInput"
		},
		getDeliveryWaypoint:{
			by:"DeliveryWaypointUniqueWhere",
			filter:"DeliveryWaypointWhere"
		},
		listDeliveryWaypoint:{
			filter:"DeliveryWaypointWhere",
			orderBy:"DeliveryWaypointOrderBy"
		},
		paginateDeliveryWaypoint:{
			filter:"DeliveryWaypointWhere",
			orderBy:"DeliveryWaypointOrderBy"
		},
		validateCreateDeliveryWaypoint:{
			data:"DeliveryWaypointCreateInput"
		},
		validateUpdateDeliveryWaypoint:{
			by:"DeliveryWaypointUniqueWhere",
			data:"DeliveryWaypointUpdateInput"
		},
		getAllergen:{
			by:"AllergenUniqueWhere",
			filter:"AllergenWhere"
		},
		listAllergen:{
			filter:"AllergenWhere",
			orderBy:"AllergenOrderBy"
		},
		paginateAllergen:{
			filter:"AllergenWhere",
			orderBy:"AllergenOrderBy"
		},
		validateCreateAllergen:{
			data:"AllergenCreateInput"
		},
		validateUpdateAllergen:{
			by:"AllergenUniqueWhere",
			data:"AllergenUpdateInput"
		},
		getAllergenLocale:{
			by:"AllergenLocaleUniqueWhere",
			filter:"AllergenLocaleWhere"
		},
		listAllergenLocale:{
			filter:"AllergenLocaleWhere",
			orderBy:"AllergenLocaleOrderBy"
		},
		paginateAllergenLocale:{
			filter:"AllergenLocaleWhere",
			orderBy:"AllergenLocaleOrderBy"
		},
		validateCreateAllergenLocale:{
			data:"AllergenLocaleCreateInput"
		},
		validateUpdateAllergenLocale:{
			by:"AllergenLocaleUniqueWhere",
			data:"AllergenLocaleUpdateInput"
		},
		getGps:{
			by:"GpsUniqueWhere",
			filter:"GpsWhere"
		},
		listGps:{
			filter:"GpsWhere",
			orderBy:"GpsOrderBy"
		},
		paginateGps:{
			filter:"GpsWhere",
			orderBy:"GpsOrderBy"
		},
		validateCreateGps:{
			data:"GpsCreateInput"
		},
		validateUpdateGps:{
			by:"GpsUniqueWhere",
			data:"GpsUpdateInput"
		},
		getProductCategoryTree:{
			by:"ProductCategoryTreeUniqueWhere",
			filter:"ProductCategoryTreeWhere"
		},
		listProductCategoryTree:{
			filter:"ProductCategoryTreeWhere",
			orderBy:"ProductCategoryTreeOrderBy"
		},
		paginateProductCategoryTree:{
			filter:"ProductCategoryTreeWhere",
			orderBy:"ProductCategoryTreeOrderBy"
		},
		getInheritedProductCategoryTag:{
			by:"InheritedProductCategoryTagUniqueWhere",
			filter:"InheritedProductCategoryTagWhere"
		},
		listInheritedProductCategoryTag:{
			filter:"InheritedProductCategoryTagWhere",
			orderBy:"InheritedProductCategoryTagOrderBy"
		},
		paginateInheritedProductCategoryTag:{
			filter:"InheritedProductCategoryTagWhere",
			orderBy:"InheritedProductCategoryTagOrderBy"
		},
		getNestedProductCategoryProduct:{
			by:"NestedProductCategoryProductUniqueWhere",
			filter:"NestedProductCategoryProductWhere"
		},
		listNestedProductCategoryProduct:{
			filter:"NestedProductCategoryProductWhere",
			orderBy:"NestedProductCategoryProductOrderBy"
		},
		paginateNestedProductCategoryProduct:{
			filter:"NestedProductCategoryProductWhere",
			orderBy:"NestedProductCategoryProductOrderBy"
		},
		getWeekHours:{
			by:"WeekHoursUniqueWhere",
			filter:"WeekHoursWhere"
		},
		listWeekHours:{
			filter:"WeekHoursWhere",
			orderBy:"WeekHoursOrderBy"
		},
		paginateWeekHours:{
			filter:"WeekHoursWhere",
			orderBy:"WeekHoursOrderBy"
		},
		validateCreateWeekHours:{
			data:"WeekHoursCreateInput"
		},
		validateUpdateWeekHours:{
			by:"WeekHoursUniqueWhere",
			data:"WeekHoursUpdateInput"
		},
		getPreparedIngredientQuantity:{
			by:"PreparedIngredientQuantityUniqueWhere",
			filter:"PreparedIngredientQuantityWhere"
		},
		listPreparedIngredientQuantity:{
			filter:"PreparedIngredientQuantityWhere",
			orderBy:"PreparedIngredientQuantityOrderBy"
		},
		paginatePreparedIngredientQuantity:{
			filter:"PreparedIngredientQuantityWhere",
			orderBy:"PreparedIngredientQuantityOrderBy"
		},
		validateCreatePreparedIngredientQuantity:{
			data:"PreparedIngredientQuantityCreateInput"
		},
		validateUpdatePreparedIngredientQuantity:{
			by:"PreparedIngredientQuantityUniqueWhere",
			data:"PreparedIngredientQuantityUpdateInput"
		},
		getPreparedRecipeQuantity:{
			by:"PreparedRecipeQuantityUniqueWhere",
			filter:"PreparedRecipeQuantityWhere"
		},
		listPreparedRecipeQuantity:{
			filter:"PreparedRecipeQuantityWhere",
			orderBy:"PreparedRecipeQuantityOrderBy"
		},
		paginatePreparedRecipeQuantity:{
			filter:"PreparedRecipeQuantityWhere",
			orderBy:"PreparedRecipeQuantityOrderBy"
		},
		validateCreatePreparedRecipeQuantity:{
			data:"PreparedRecipeQuantityCreateInput"
		},
		validateUpdatePreparedRecipeQuantity:{
			by:"PreparedRecipeQuantityUniqueWhere",
			data:"PreparedRecipeQuantityUpdateInput"
		},
		getInternalOrder:{
			by:"InternalOrderUniqueWhere",
			filter:"InternalOrderWhere"
		},
		listInternalOrder:{
			filter:"InternalOrderWhere",
			orderBy:"InternalOrderOrderBy"
		},
		paginateInternalOrder:{
			filter:"InternalOrderWhere",
			orderBy:"InternalOrderOrderBy"
		},
		validateCreateInternalOrder:{
			data:"InternalOrderCreateInput"
		},
		validateUpdateInternalOrder:{
			by:"InternalOrderUniqueWhere",
			data:"InternalOrderUpdateInput"
		},
		getInternalOrderItem:{
			by:"InternalOrderItemUniqueWhere",
			filter:"InternalOrderItemWhere"
		},
		listInternalOrderItem:{
			filter:"InternalOrderItemWhere",
			orderBy:"InternalOrderItemOrderBy"
		},
		paginateInternalOrderItem:{
			filter:"InternalOrderItemWhere",
			orderBy:"InternalOrderItemOrderBy"
		},
		validateCreateInternalOrderItem:{
			data:"InternalOrderItemCreateInput"
		},
		validateUpdateInternalOrderItem:{
			by:"InternalOrderItemUniqueWhere",
			data:"InternalOrderItemUpdateInput"
		},
		getPreparedPackingQuantity:{
			by:"PreparedPackingQuantityUniqueWhere",
			filter:"PreparedPackingQuantityWhere"
		},
		listPreparedPackingQuantity:{
			filter:"PreparedPackingQuantityWhere",
			orderBy:"PreparedPackingQuantityOrderBy"
		},
		paginatePreparedPackingQuantity:{
			filter:"PreparedPackingQuantityWhere",
			orderBy:"PreparedPackingQuantityOrderBy"
		},
		validateCreatePreparedPackingQuantity:{
			data:"PreparedPackingQuantityCreateInput"
		},
		validateUpdatePreparedPackingQuantity:{
			by:"PreparedPackingQuantityUniqueWhere",
			data:"PreparedPackingQuantityUpdateInput"
		},
		getCourierManager:{
			by:"CourierManagerUniqueWhere",
			filter:"CourierManagerWhere"
		},
		listCourierManager:{
			filter:"CourierManagerWhere",
			orderBy:"CourierManagerOrderBy"
		},
		paginateCourierManager:{
			filter:"CourierManagerWhere",
			orderBy:"CourierManagerOrderBy"
		},
		validateCreateCourierManager:{
			data:"CourierManagerCreateInput"
		},
		validateUpdateCourierManager:{
			by:"CourierManagerUniqueWhere",
			data:"CourierManagerUpdateInput"
		},
		getDeliveryZone:{
			by:"DeliveryZoneUniqueWhere",
			filter:"DeliveryZoneWhere"
		},
		listDeliveryZone:{
			filter:"DeliveryZoneWhere",
			orderBy:"DeliveryZoneOrderBy"
		},
		paginateDeliveryZone:{
			filter:"DeliveryZoneWhere",
			orderBy:"DeliveryZoneOrderBy"
		},
		validateCreateDeliveryZone:{
			data:"DeliveryZoneCreateInput"
		},
		validateUpdateDeliveryZone:{
			by:"DeliveryZoneUniqueWhere",
			data:"DeliveryZoneUpdateInput"
		},
		getAddressMetadata:{
			by:"AddressMetadataUniqueWhere",
			filter:"AddressMetadataWhere"
		},
		listAddressMetadata:{
			filter:"AddressMetadataWhere",
			orderBy:"AddressMetadataOrderBy"
		},
		paginateAddressMetadata:{
			filter:"AddressMetadataWhere",
			orderBy:"AddressMetadataOrderBy"
		},
		getDeliveryTimelinePreset:{
			by:"DeliveryTimelinePresetUniqueWhere",
			filter:"DeliveryTimelinePresetWhere"
		},
		listDeliveryTimelinePreset:{
			filter:"DeliveryTimelinePresetWhere",
			orderBy:"DeliveryTimelinePresetOrderBy"
		},
		paginateDeliveryTimelinePreset:{
			filter:"DeliveryTimelinePresetWhere",
			orderBy:"DeliveryTimelinePresetOrderBy"
		},
		validateCreateDeliveryTimelinePreset:{
			data:"DeliveryTimelinePresetCreateInput"
		},
		validateUpdateDeliveryTimelinePreset:{
			by:"DeliveryTimelinePresetUniqueWhere",
			data:"DeliveryTimelinePresetUpdateInput"
		},
		getOrderDeliveryTimeline:{
			by:"OrderDeliveryTimelineUniqueWhere",
			filter:"OrderDeliveryTimelineWhere"
		},
		listOrderDeliveryTimeline:{
			filter:"OrderDeliveryTimelineWhere",
			orderBy:"OrderDeliveryTimelineOrderBy"
		},
		paginateOrderDeliveryTimeline:{
			filter:"OrderDeliveryTimelineWhere",
			orderBy:"OrderDeliveryTimelineOrderBy"
		},
		validateCreateOrderDeliveryTimeline:{
			data:"OrderDeliveryTimelineCreateInput"
		},
		validateUpdateOrderDeliveryTimeline:{
			by:"OrderDeliveryTimelineUniqueWhere",
			data:"OrderDeliveryTimelineUpdateInput"
		},
		getOrderEvent:{
			by:"OrderEventUniqueWhere",
			filter:"OrderEventWhere"
		},
		listOrderEvent:{
			filter:"OrderEventWhere",
			orderBy:"OrderEventOrderBy"
		},
		paginateOrderEvent:{
			filter:"OrderEventWhere",
			orderBy:"OrderEventOrderBy"
		},
		validateCreateOrderEvent:{
			data:"OrderEventCreateInput"
		},
		validateUpdateOrderEvent:{
			by:"OrderEventUniqueWhere",
			data:"OrderEventUpdateInput"
		},
		getLiftagoRide:{
			by:"LiftagoRideUniqueWhere",
			filter:"LiftagoRideWhere"
		},
		listLiftagoRide:{
			filter:"LiftagoRideWhere",
			orderBy:"LiftagoRideOrderBy"
		},
		paginateLiftagoRide:{
			filter:"LiftagoRideWhere",
			orderBy:"LiftagoRideOrderBy"
		},
		validateCreateLiftagoRide:{
			data:"LiftagoRideCreateInput"
		},
		validateUpdateLiftagoRide:{
			by:"LiftagoRideUniqueWhere",
			data:"LiftagoRideUpdateInput"
		},
		getInvoice:{
			by:"InvoiceUniqueWhere",
			filter:"InvoiceWhere"
		},
		listInvoice:{
			filter:"InvoiceWhere",
			orderBy:"InvoiceOrderBy"
		},
		paginateInvoice:{
			filter:"InvoiceWhere",
			orderBy:"InvoiceOrderBy"
		},
		validateCreateInvoice:{
			data:"InvoiceCreateInput"
		},
		validateUpdateInvoice:{
			by:"InvoiceUniqueWhere",
			data:"InvoiceUpdateInput"
		},
		getInvoicingPlan:{
			by:"InvoicingPlanUniqueWhere",
			filter:"InvoicingPlanWhere"
		},
		listInvoicingPlan:{
			filter:"InvoicingPlanWhere",
			orderBy:"InvoicingPlanOrderBy"
		},
		paginateInvoicingPlan:{
			filter:"InvoicingPlanWhere",
			orderBy:"InvoicingPlanOrderBy"
		},
		validateCreateInvoicingPlan:{
			data:"InvoicingPlanCreateInput"
		},
		validateUpdateInvoicingPlan:{
			by:"InvoicingPlanUniqueWhere",
			data:"InvoicingPlanUpdateInput"
		},
		getProductPackingLocale:{
			by:"ProductPackingLocaleUniqueWhere",
			filter:"ProductPackingLocaleWhere"
		},
		listProductPackingLocale:{
			filter:"ProductPackingLocaleWhere",
			orderBy:"ProductPackingLocaleOrderBy"
		},
		paginateProductPackingLocale:{
			filter:"ProductPackingLocaleWhere",
			orderBy:"ProductPackingLocaleOrderBy"
		},
		validateCreateProductPackingLocale:{
			data:"ProductPackingLocaleCreateInput"
		},
		validateUpdateProductPackingLocale:{
			by:"ProductPackingLocaleUniqueWhere",
			data:"ProductPackingLocaleUpdateInput"
		},
		getProductLocale:{
			by:"ProductLocaleUniqueWhere",
			filter:"ProductLocaleWhere"
		},
		listProductLocale:{
			filter:"ProductLocaleWhere",
			orderBy:"ProductLocaleOrderBy"
		},
		paginateProductLocale:{
			filter:"ProductLocaleWhere",
			orderBy:"ProductLocaleOrderBy"
		},
		validateCreateProductLocale:{
			data:"ProductLocaleCreateInput"
		},
		validateUpdateProductLocale:{
			by:"ProductLocaleUniqueWhere",
			data:"ProductLocaleUpdateInput"
		},
		getProductRecipeLocale:{
			by:"ProductRecipeLocaleUniqueWhere",
			filter:"ProductRecipeLocaleWhere"
		},
		listProductRecipeLocale:{
			filter:"ProductRecipeLocaleWhere",
			orderBy:"ProductRecipeLocaleOrderBy"
		},
		paginateProductRecipeLocale:{
			filter:"ProductRecipeLocaleWhere",
			orderBy:"ProductRecipeLocaleOrderBy"
		},
		validateCreateProductRecipeLocale:{
			data:"ProductRecipeLocaleCreateInput"
		},
		validateUpdateProductRecipeLocale:{
			by:"ProductRecipeLocaleUniqueWhere",
			data:"ProductRecipeLocaleUpdateInput"
		},
		getUserDevice:{
			by:"UserDeviceUniqueWhere",
			filter:"UserDeviceWhere"
		},
		listUserDevice:{
			filter:"UserDeviceWhere",
			orderBy:"UserDeviceOrderBy"
		},
		paginateUserDevice:{
			filter:"UserDeviceWhere",
			orderBy:"UserDeviceOrderBy"
		},
		validateCreateUserDevice:{
			data:"UserDeviceCreateInput"
		},
		validateUpdateUserDevice:{
			by:"UserDeviceUniqueWhere",
			data:"UserDeviceUpdateInput"
		},
		getProtectedAction:{
			by:"ProtectedActionUniqueWhere",
			filter:"ProtectedActionWhere"
		},
		listProtectedAction:{
			filter:"ProtectedActionWhere",
			orderBy:"ProtectedActionOrderBy"
		},
		paginateProtectedAction:{
			filter:"ProtectedActionWhere",
			orderBy:"ProtectedActionOrderBy"
		},
		validateCreateProtectedAction:{
			data:"ProtectedActionCreateInput"
		},
		validateUpdateProtectedAction:{
			by:"ProtectedActionUniqueWhere",
			data:"ProtectedActionUpdateInput"
		},
		getPicker:{
			by:"PickerUniqueWhere",
			filter:"PickerWhere"
		},
		listPicker:{
			filter:"PickerWhere",
			orderBy:"PickerOrderBy"
		},
		paginatePicker:{
			filter:"PickerWhere",
			orderBy:"PickerOrderBy"
		},
		validateCreatePicker:{
			data:"PickerCreateInput"
		},
		validateUpdatePicker:{
			by:"PickerUniqueWhere",
			data:"PickerUpdateInput"
		},
		getTenantPerson:{
			by:"TenantPersonUniqueWhere",
			filter:"TenantPersonWhere"
		},
		listTenantPerson:{
			filter:"TenantPersonWhere",
			orderBy:"TenantPersonOrderBy"
		},
		paginateTenantPerson:{
			filter:"TenantPersonWhere",
			orderBy:"TenantPersonOrderBy"
		},
		getTimetableTemplateStaffOptions:{
			by:"TimetableTemplateStaffOptionsUniqueWhere",
			filter:"TimetableTemplateStaffOptionsWhere"
		},
		listTimetableTemplateStaffOptions:{
			filter:"TimetableTemplateStaffOptionsWhere",
			orderBy:"TimetableTemplateStaffOptionsOrderBy"
		},
		paginateTimetableTemplateStaffOptions:{
			filter:"TimetableTemplateStaffOptionsWhere",
			orderBy:"TimetableTemplateStaffOptionsOrderBy"
		},
		validateCreateTimetableTemplateStaffOptions:{
			data:"TimetableTemplateStaffOptionsCreateInput"
		},
		validateUpdateTimetableTemplateStaffOptions:{
			by:"TimetableTemplateStaffOptionsUniqueWhere",
			data:"TimetableTemplateStaffOptionsUpdateInput"
		},
		getShoppingList:{
			by:"ShoppingListUniqueWhere",
			filter:"ShoppingListWhere"
		},
		listShoppingList:{
			filter:"ShoppingListWhere",
			orderBy:"ShoppingListOrderBy"
		},
		paginateShoppingList:{
			filter:"ShoppingListWhere",
			orderBy:"ShoppingListOrderBy"
		},
		validateCreateShoppingList:{
			data:"ShoppingListCreateInput"
		},
		validateUpdateShoppingList:{
			by:"ShoppingListUniqueWhere",
			data:"ShoppingListUpdateInput"
		},
		getSuppliesPurchase:{
			by:"SuppliesPurchaseUniqueWhere",
			filter:"SuppliesPurchaseWhere"
		},
		listSuppliesPurchase:{
			filter:"SuppliesPurchaseWhere",
			orderBy:"SuppliesPurchaseOrderBy"
		},
		paginateSuppliesPurchase:{
			filter:"SuppliesPurchaseWhere",
			orderBy:"SuppliesPurchaseOrderBy"
		},
		validateCreateSuppliesPurchase:{
			data:"SuppliesPurchaseCreateInput"
		},
		validateUpdateSuppliesPurchase:{
			by:"SuppliesPurchaseUniqueWhere",
			data:"SuppliesPurchaseUpdateInput"
		},
		getInvoicingPreset:{
			by:"InvoicingPresetUniqueWhere",
			filter:"InvoicingPresetWhere"
		},
		listInvoicingPreset:{
			filter:"InvoicingPresetWhere",
			orderBy:"InvoicingPresetOrderBy"
		},
		paginateInvoicingPreset:{
			filter:"InvoicingPresetWhere",
			orderBy:"InvoicingPresetOrderBy"
		},
		validateCreateInvoicingPreset:{
			data:"InvoicingPresetCreateInput"
		},
		validateUpdateInvoicingPreset:{
			by:"InvoicingPresetUniqueWhere",
			data:"InvoicingPresetUpdateInput"
		},
		getLogRecord:{
			by:"LogRecordUniqueWhere",
			filter:"LogRecordWhere"
		},
		listLogRecord:{
			filter:"LogRecordWhere",
			orderBy:"LogRecordOrderBy"
		},
		paginateLogRecord:{
			filter:"LogRecordWhere",
			orderBy:"LogRecordOrderBy"
		},
		validateCreateLogRecord:{
			data:"LogRecordCreateInput"
		},
		validateUpdateLogRecord:{
			by:"LogRecordUniqueWhere",
			data:"LogRecordUpdateInput"
		},
		getBillingSubject:{
			by:"BillingSubjectUniqueWhere",
			filter:"BillingSubjectWhere"
		},
		listBillingSubject:{
			filter:"BillingSubjectWhere",
			orderBy:"BillingSubjectOrderBy"
		},
		paginateBillingSubject:{
			filter:"BillingSubjectWhere",
			orderBy:"BillingSubjectOrderBy"
		},
		validateCreateBillingSubject:{
			data:"BillingSubjectCreateInput"
		},
		validateUpdateBillingSubject:{
			by:"BillingSubjectUniqueWhere",
			data:"BillingSubjectUpdateInput"
		},
		getProductCustomerPrice:{
			by:"ProductCustomerPriceUniqueWhere",
			filter:"ProductCustomerPriceWhere"
		},
		listProductCustomerPrice:{
			filter:"ProductCustomerPriceWhere",
			orderBy:"ProductCustomerPriceOrderBy"
		},
		paginateProductCustomerPrice:{
			filter:"ProductCustomerPriceWhere",
			orderBy:"ProductCustomerPriceOrderBy"
		},
		getCartPriceLine:{
			by:"CartPriceLineUniqueWhere",
			filter:"CartPriceLineWhere"
		},
		listCartPriceLine:{
			filter:"CartPriceLineWhere",
			orderBy:"CartPriceLineOrderBy"
		},
		paginateCartPriceLine:{
			filter:"CartPriceLineWhere",
			orderBy:"CartPriceLineOrderBy"
		},
		getShoppingListItem:{
			by:"ShoppingListItemUniqueWhere",
			filter:"ShoppingListItemWhere"
		},
		listShoppingListItem:{
			filter:"ShoppingListItemWhere",
			orderBy:"ShoppingListItemOrderBy"
		},
		paginateShoppingListItem:{
			filter:"ShoppingListItemWhere",
			orderBy:"ShoppingListItemOrderBy"
		},
		validateCreateShoppingListItem:{
			data:"ShoppingListItemCreateInput"
		},
		validateUpdateShoppingListItem:{
			by:"ShoppingListItemUniqueWhere",
			data:"ShoppingListItemUpdateInput"
		},
		getSuppliesPurchaseItem:{
			by:"SuppliesPurchaseItemUniqueWhere",
			filter:"SuppliesPurchaseItemWhere"
		},
		listSuppliesPurchaseItem:{
			filter:"SuppliesPurchaseItemWhere",
			orderBy:"SuppliesPurchaseItemOrderBy"
		},
		paginateSuppliesPurchaseItem:{
			filter:"SuppliesPurchaseItemWhere",
			orderBy:"SuppliesPurchaseItemOrderBy"
		},
		validateCreateSuppliesPurchaseItem:{
			data:"SuppliesPurchaseItemCreateInput"
		},
		validateUpdateSuppliesPurchaseItem:{
			by:"SuppliesPurchaseItemUniqueWhere",
			data:"SuppliesPurchaseItemUpdateInput"
		},
		getCustomerCreditTransaction:{
			by:"CustomerCreditTransactionUniqueWhere",
			filter:"CustomerCreditTransactionWhere"
		},
		listCustomerCreditTransaction:{
			filter:"CustomerCreditTransactionWhere",
			orderBy:"CustomerCreditTransactionOrderBy"
		},
		paginateCustomerCreditTransaction:{
			filter:"CustomerCreditTransactionWhere",
			orderBy:"CustomerCreditTransactionOrderBy"
		},
		validateCreateCustomerCreditTransaction:{
			data:"CustomerCreditTransactionCreateInput"
		},
		validateUpdateCustomerCreditTransaction:{
			by:"CustomerCreditTransactionUniqueWhere",
			data:"CustomerCreditTransactionUpdateInput"
		},
		getVirtualProduct:{
			by:"VirtualProductUniqueWhere",
			filter:"VirtualProductWhere"
		},
		listVirtualProduct:{
			filter:"VirtualProductWhere",
			orderBy:"VirtualProductOrderBy"
		},
		paginateVirtualProduct:{
			filter:"VirtualProductWhere",
			orderBy:"VirtualProductOrderBy"
		},
		validateCreateVirtualProduct:{
			data:"VirtualProductCreateInput"
		},
		validateUpdateVirtualProduct:{
			by:"VirtualProductUniqueWhere",
			data:"VirtualProductUpdateInput"
		},
		getVirtualProductEffect:{
			by:"VirtualProductEffectUniqueWhere",
			filter:"VirtualProductEffectWhere"
		},
		listVirtualProductEffect:{
			filter:"VirtualProductEffectWhere",
			orderBy:"VirtualProductEffectOrderBy"
		},
		paginateVirtualProductEffect:{
			filter:"VirtualProductEffectWhere",
			orderBy:"VirtualProductEffectOrderBy"
		},
		validateCreateVirtualProductEffect:{
			data:"VirtualProductEffectCreateInput"
		},
		validateUpdateVirtualProductEffect:{
			by:"VirtualProductEffectUniqueWhere",
			data:"VirtualProductEffectUpdateInput"
		},
		getOrderPriceLine:{
			by:"OrderPriceLineUniqueWhere",
			filter:"OrderPriceLineWhere"
		},
		listOrderPriceLine:{
			filter:"OrderPriceLineWhere",
			orderBy:"OrderPriceLineOrderBy"
		},
		paginateOrderPriceLine:{
			filter:"OrderPriceLineWhere",
			orderBy:"OrderPriceLineOrderBy"
		},
		getProductMetadata:{
			by:"ProductMetadataUniqueWhere",
			filter:"ProductMetadataWhere"
		},
		listProductMetadata:{
			filter:"ProductMetadataWhere",
			orderBy:"ProductMetadataOrderBy"
		},
		paginateProductMetadata:{
			filter:"ProductMetadataWhere",
			orderBy:"ProductMetadataOrderBy"
		},
		getEmploymentInformation:{
			by:"EmploymentInformationUniqueWhere",
			filter:"EmploymentInformationWhere"
		},
		listEmploymentInformation:{
			filter:"EmploymentInformationWhere",
			orderBy:"EmploymentInformationOrderBy"
		},
		paginateEmploymentInformation:{
			filter:"EmploymentInformationWhere",
			orderBy:"EmploymentInformationOrderBy"
		},
		validateCreateEmploymentInformation:{
			data:"EmploymentInformationCreateInput"
		},
		validateUpdateEmploymentInformation:{
			by:"EmploymentInformationUniqueWhere",
			data:"EmploymentInformationUpdateInput"
		},
		getRemunerationProfile:{
			by:"RemunerationProfileUniqueWhere",
			filter:"RemunerationProfileWhere"
		},
		listRemunerationProfile:{
			filter:"RemunerationProfileWhere",
			orderBy:"RemunerationProfileOrderBy"
		},
		paginateRemunerationProfile:{
			filter:"RemunerationProfileWhere",
			orderBy:"RemunerationProfileOrderBy"
		},
		validateCreateRemunerationProfile:{
			data:"RemunerationProfileCreateInput"
		},
		validateUpdateRemunerationProfile:{
			by:"RemunerationProfileUniqueWhere",
			data:"RemunerationProfileUpdateInput"
		},
		getWorkMonth:{
			by:"WorkMonthUniqueWhere",
			filter:"WorkMonthWhere"
		},
		listWorkMonth:{
			filter:"WorkMonthWhere",
			orderBy:"WorkMonthOrderBy"
		},
		paginateWorkMonth:{
			filter:"WorkMonthWhere",
			orderBy:"WorkMonthOrderBy"
		},
		validateCreateWorkMonth:{
			data:"WorkMonthCreateInput"
		},
		validateUpdateWorkMonth:{
			by:"WorkMonthUniqueWhere",
			data:"WorkMonthUpdateInput"
		},
		getSalaryOptions:{
			by:"SalaryOptionsUniqueWhere",
			filter:"SalaryOptionsWhere"
		},
		listSalaryOptions:{
			filter:"SalaryOptionsWhere",
			orderBy:"SalaryOptionsOrderBy"
		},
		paginateSalaryOptions:{
			filter:"SalaryOptionsWhere",
			orderBy:"SalaryOptionsOrderBy"
		},
		validateCreateSalaryOptions:{
			data:"SalaryOptionsCreateInput"
		},
		validateUpdateSalaryOptions:{
			by:"SalaryOptionsUniqueWhere",
			data:"SalaryOptionsUpdateInput"
		},
		getTimetableShiftSwapInfo:{
			by:"TimetableShiftSwapInfoUniqueWhere",
			filter:"TimetableShiftSwapInfoWhere"
		},
		listTimetableShiftSwapInfo:{
			filter:"TimetableShiftSwapInfoWhere",
			orderBy:"TimetableShiftSwapInfoOrderBy"
		},
		paginateTimetableShiftSwapInfo:{
			filter:"TimetableShiftSwapInfoWhere",
			orderBy:"TimetableShiftSwapInfoOrderBy"
		},
		validateCreateTimetableShiftSwapInfo:{
			data:"TimetableShiftSwapInfoCreateInput"
		},
		validateUpdateTimetableShiftSwapInfo:{
			by:"TimetableShiftSwapInfoUniqueWhere",
			data:"TimetableShiftSwapInfoUpdateInput"
		},
		getProductGridCategory:{
			by:"ProductGridCategoryUniqueWhere",
			filter:"ProductGridCategoryWhere"
		},
		listProductGridCategory:{
			filter:"ProductGridCategoryWhere",
			orderBy:"ProductGridCategoryOrderBy"
		},
		paginateProductGridCategory:{
			filter:"ProductGridCategoryWhere",
			orderBy:"ProductGridCategoryOrderBy"
		},
		validateCreateProductGridCategory:{
			data:"ProductGridCategoryCreateInput"
		},
		validateUpdateProductGridCategory:{
			by:"ProductGridCategoryUniqueWhere",
			data:"ProductGridCategoryUpdateInput"
		},
		getCashier:{
			by:"CashierUniqueWhere",
			filter:"CashierWhere"
		},
		listCashier:{
			filter:"CashierWhere",
			orderBy:"CashierOrderBy"
		},
		paginateCashier:{
			filter:"CashierWhere",
			orderBy:"CashierOrderBy"
		},
		validateCreateCashier:{
			data:"CashierCreateInput"
		},
		validateUpdateCashier:{
			by:"CashierUniqueWhere",
			data:"CashierUpdateInput"
		},
		getPointOfSaleCategory:{
			by:"PointOfSaleCategoryUniqueWhere",
			filter:"PointOfSaleCategoryWhere"
		},
		listPointOfSaleCategory:{
			filter:"PointOfSaleCategoryWhere",
			orderBy:"PointOfSaleCategoryOrderBy"
		},
		paginatePointOfSaleCategory:{
			filter:"PointOfSaleCategoryWhere",
			orderBy:"PointOfSaleCategoryOrderBy"
		},
		validateCreatePointOfSaleCategory:{
			data:"PointOfSaleCategoryCreateInput"
		},
		validateUpdatePointOfSaleCategory:{
			by:"PointOfSaleCategoryUniqueWhere",
			data:"PointOfSaleCategoryUpdateInput"
		},
		getPointOfSaleCategoryLocale:{
			by:"PointOfSaleCategoryLocaleUniqueWhere",
			filter:"PointOfSaleCategoryLocaleWhere"
		},
		listPointOfSaleCategoryLocale:{
			filter:"PointOfSaleCategoryLocaleWhere",
			orderBy:"PointOfSaleCategoryLocaleOrderBy"
		},
		paginatePointOfSaleCategoryLocale:{
			filter:"PointOfSaleCategoryLocaleWhere",
			orderBy:"PointOfSaleCategoryLocaleOrderBy"
		},
		validateCreatePointOfSaleCategoryLocale:{
			data:"PointOfSaleCategoryLocaleCreateInput"
		},
		validateUpdatePointOfSaleCategoryLocale:{
			by:"PointOfSaleCategoryLocaleUniqueWhere",
			data:"PointOfSaleCategoryLocaleUpdateInput"
		},
		getPointOfSaleCategoryProduct:{
			by:"PointOfSaleCategoryProductUniqueWhere",
			filter:"PointOfSaleCategoryProductWhere"
		},
		listPointOfSaleCategoryProduct:{
			filter:"PointOfSaleCategoryProductWhere",
			orderBy:"PointOfSaleCategoryProductOrderBy"
		},
		paginatePointOfSaleCategoryProduct:{
			filter:"PointOfSaleCategoryProductWhere",
			orderBy:"PointOfSaleCategoryProductOrderBy"
		},
		validateCreatePointOfSaleCategoryProduct:{
			data:"PointOfSaleCategoryProductCreateInput"
		},
		validateUpdatePointOfSaleCategoryProduct:{
			by:"PointOfSaleCategoryProductUniqueWhere",
			data:"PointOfSaleCategoryProductUpdateInput"
		},
		getPointOfSaleCategoryProductLocale:{
			by:"PointOfSaleCategoryProductLocaleUniqueWhere",
			filter:"PointOfSaleCategoryProductLocaleWhere"
		},
		listPointOfSaleCategoryProductLocale:{
			filter:"PointOfSaleCategoryProductLocaleWhere",
			orderBy:"PointOfSaleCategoryProductLocaleOrderBy"
		},
		paginatePointOfSaleCategoryProductLocale:{
			filter:"PointOfSaleCategoryProductLocaleWhere",
			orderBy:"PointOfSaleCategoryProductLocaleOrderBy"
		},
		validateCreatePointOfSaleCategoryProductLocale:{
			data:"PointOfSaleCategoryProductLocaleCreateInput"
		},
		validateUpdatePointOfSaleCategoryProductLocale:{
			by:"PointOfSaleCategoryProductLocaleUniqueWhere",
			data:"PointOfSaleCategoryProductLocaleUpdateInput"
		},
		getCustomerTab:{
			by:"CustomerTabUniqueWhere",
			filter:"CustomerTabWhere"
		},
		listCustomerTab:{
			filter:"CustomerTabWhere",
			orderBy:"CustomerTabOrderBy"
		},
		paginateCustomerTab:{
			filter:"CustomerTabWhere",
			orderBy:"CustomerTabOrderBy"
		},
		validateCreateCustomerTab:{
			data:"CustomerTabCreateInput"
		},
		validateUpdateCustomerTab:{
			by:"CustomerTabUniqueWhere",
			data:"CustomerTabUpdateInput"
		},
		getCustomerTabItem:{
			by:"CustomerTabItemUniqueWhere",
			filter:"CustomerTabItemWhere"
		},
		listCustomerTabItem:{
			filter:"CustomerTabItemWhere",
			orderBy:"CustomerTabItemOrderBy"
		},
		paginateCustomerTabItem:{
			filter:"CustomerTabItemWhere",
			orderBy:"CustomerTabItemOrderBy"
		},
		validateCreateCustomerTabItem:{
			data:"CustomerTabItemCreateInput"
		},
		validateUpdateCustomerTabItem:{
			by:"CustomerTabItemUniqueWhere",
			data:"CustomerTabItemUpdateInput"
		},
		getAnonymousSession:{
			by:"AnonymousSessionUniqueWhere",
			filter:"AnonymousSessionWhere"
		},
		listAnonymousSession:{
			filter:"AnonymousSessionWhere",
			orderBy:"AnonymousSessionOrderBy"
		},
		paginateAnonymousSession:{
			filter:"AnonymousSessionWhere",
			orderBy:"AnonymousSessionOrderBy"
		},
		validateCreateAnonymousSession:{
			data:"AnonymousSessionCreateInput"
		},
		validateUpdateAnonymousSession:{
			by:"AnonymousSessionUniqueWhere",
			data:"AnonymousSessionUpdateInput"
		},
		getVoucher:{
			by:"VoucherUniqueWhere",
			filter:"VoucherWhere"
		},
		listVoucher:{
			filter:"VoucherWhere",
			orderBy:"VoucherOrderBy"
		},
		paginateVoucher:{
			filter:"VoucherWhere",
			orderBy:"VoucherOrderBy"
		},
		validateCreateVoucher:{
			data:"VoucherCreateInput"
		},
		validateUpdateVoucher:{
			by:"VoucherUniqueWhere",
			data:"VoucherUpdateInput"
		},
		getVoucherRedemption:{
			by:"VoucherRedemptionUniqueWhere",
			filter:"VoucherRedemptionWhere"
		},
		listVoucherRedemption:{
			filter:"VoucherRedemptionWhere",
			orderBy:"VoucherRedemptionOrderBy"
		},
		paginateVoucherRedemption:{
			filter:"VoucherRedemptionWhere",
			orderBy:"VoucherRedemptionOrderBy"
		},
		validateCreateVoucherRedemption:{
			data:"VoucherRedemptionCreateInput"
		},
		validateUpdateVoucherRedemption:{
			by:"VoucherRedemptionUniqueWhere",
			data:"VoucherRedemptionUpdateInput"
		},
		getUnassignedShiftInfo:{
			by:"UnassignedShiftInfoUniqueWhere",
			filter:"UnassignedShiftInfoWhere"
		},
		listUnassignedShiftInfo:{
			filter:"UnassignedShiftInfoWhere",
			orderBy:"UnassignedShiftInfoOrderBy"
		},
		paginateUnassignedShiftInfo:{
			filter:"UnassignedShiftInfoWhere",
			orderBy:"UnassignedShiftInfoOrderBy"
		},
		validateCreateUnassignedShiftInfo:{
			data:"UnassignedShiftInfoCreateInput"
		},
		validateUpdateUnassignedShiftInfo:{
			by:"UnassignedShiftInfoUniqueWhere",
			data:"UnassignedShiftInfoUpdateInput"
		},
		getFreshingContainer:{
			by:"FreshingContainerUniqueWhere",
			filter:"FreshingContainerWhere"
		},
		listFreshingContainer:{
			filter:"FreshingContainerWhere",
			orderBy:"FreshingContainerOrderBy"
		},
		paginateFreshingContainer:{
			filter:"FreshingContainerWhere",
			orderBy:"FreshingContainerOrderBy"
		},
		validateCreateFreshingContainer:{
			data:"FreshingContainerCreateInput"
		},
		validateUpdateFreshingContainer:{
			by:"FreshingContainerUniqueWhere",
			data:"FreshingContainerUpdateInput"
		},
		getTextItem:{
			by:"TextItemUniqueWhere",
			filter:"TextItemWhere"
		},
		listTextItem:{
			filter:"TextItemWhere",
			orderBy:"TextItemOrderBy"
		},
		paginateTextItem:{
			filter:"TextItemWhere",
			orderBy:"TextItemOrderBy"
		},
		validateCreateTextItem:{
			data:"TextItemCreateInput"
		},
		validateUpdateTextItem:{
			by:"TextItemUniqueWhere",
			data:"TextItemUpdateInput"
		},
		getTextList:{
			by:"TextListUniqueWhere",
			filter:"TextListWhere"
		},
		listTextList:{
			filter:"TextListWhere",
			orderBy:"TextListOrderBy"
		},
		paginateTextList:{
			filter:"TextListWhere",
			orderBy:"TextListOrderBy"
		},
		validateCreateTextList:{
			data:"TextListCreateInput"
		},
		validateUpdateTextList:{
			by:"TextListUniqueWhere",
			data:"TextListUpdateInput"
		},
		getEmployeeQueueItemMetadata:{
			by:"EmployeeQueueItemMetadataUniqueWhere",
			filter:"EmployeeQueueItemMetadataWhere"
		},
		listEmployeeQueueItemMetadata:{
			filter:"EmployeeQueueItemMetadataWhere",
			orderBy:"EmployeeQueueItemMetadataOrderBy"
		},
		paginateEmployeeQueueItemMetadata:{
			filter:"EmployeeQueueItemMetadataWhere",
			orderBy:"EmployeeQueueItemMetadataOrderBy"
		},
		getDeliveryRegions:{
			by:"DeliveryRegionsUniqueWhere",
			filter:"DeliveryRegionsWhere"
		},
		listDeliveryRegions:{
			filter:"DeliveryRegionsWhere",
			orderBy:"DeliveryRegionsOrderBy"
		},
		paginateDeliveryRegions:{
			filter:"DeliveryRegionsWhere",
			orderBy:"DeliveryRegionsOrderBy"
		},
		validateCreateDeliveryRegions:{
			data:"DeliveryRegionsCreateInput"
		},
		validateUpdateDeliveryRegions:{
			by:"DeliveryRegionsUniqueWhere",
			data:"DeliveryRegionsUpdateInput"
		},
		getDeliveryRegionsItem:{
			by:"DeliveryRegionsItemUniqueWhere",
			filter:"DeliveryRegionsItemWhere"
		},
		listDeliveryRegionsItem:{
			filter:"DeliveryRegionsItemWhere",
			orderBy:"DeliveryRegionsItemOrderBy"
		},
		paginateDeliveryRegionsItem:{
			filter:"DeliveryRegionsItemWhere",
			orderBy:"DeliveryRegionsItemOrderBy"
		},
		validateCreateDeliveryRegionsItem:{
			data:"DeliveryRegionsItemCreateInput"
		},
		validateUpdateDeliveryRegionsItem:{
			by:"DeliveryRegionsItemUniqueWhere",
			data:"DeliveryRegionsItemUpdateInput"
		},
		getImageList:{
			by:"ImageListUniqueWhere",
			filter:"ImageListWhere"
		},
		listImageList:{
			filter:"ImageListWhere",
			orderBy:"ImageListOrderBy"
		},
		paginateImageList:{
			filter:"ImageListWhere",
			orderBy:"ImageListOrderBy"
		},
		validateCreateImageList:{
			data:"ImageListCreateInput"
		},
		validateUpdateImageList:{
			by:"ImageListUniqueWhere",
			data:"ImageListUpdateInput"
		},
		getImageListItem:{
			by:"ImageListItemUniqueWhere",
			filter:"ImageListItemWhere"
		},
		listImageListItem:{
			filter:"ImageListItemWhere",
			orderBy:"ImageListItemOrderBy"
		},
		paginateImageListItem:{
			filter:"ImageListItemWhere",
			orderBy:"ImageListItemOrderBy"
		},
		validateCreateImageListItem:{
			data:"ImageListItemCreateInput"
		},
		validateUpdateImageListItem:{
			by:"ImageListItemUniqueWhere",
			data:"ImageListItemUpdateInput"
		},
		getProductSalesDay:{
			by:"ProductSalesDayUniqueWhere",
			filter:"ProductSalesDayWhere"
		},
		listProductSalesDay:{
			filter:"ProductSalesDayWhere",
			orderBy:"ProductSalesDayOrderBy"
		},
		paginateProductSalesDay:{
			filter:"ProductSalesDayWhere",
			orderBy:"ProductSalesDayOrderBy"
		},
		getProductSalesMonth:{
			by:"ProductSalesMonthUniqueWhere",
			filter:"ProductSalesMonthWhere"
		},
		listProductSalesMonth:{
			filter:"ProductSalesMonthWhere",
			orderBy:"ProductSalesMonthOrderBy"
		},
		paginateProductSalesMonth:{
			filter:"ProductSalesMonthWhere",
			orderBy:"ProductSalesMonthOrderBy"
		},
		getProductSalesWeek:{
			by:"ProductSalesWeekUniqueWhere",
			filter:"ProductSalesWeekWhere"
		},
		listProductSalesWeek:{
			filter:"ProductSalesWeekWhere",
			orderBy:"ProductSalesWeekOrderBy"
		},
		paginateProductSalesWeek:{
			filter:"ProductSalesWeekWhere",
			orderBy:"ProductSalesWeekOrderBy"
		},
		getTimetablesEmployeePrivileges:{
			by:"TimetablesEmployeePrivilegesUniqueWhere",
			filter:"TimetablesEmployeePrivilegesWhere"
		},
		listTimetablesEmployeePrivileges:{
			filter:"TimetablesEmployeePrivilegesWhere",
			orderBy:"TimetablesEmployeePrivilegesOrderBy"
		},
		paginateTimetablesEmployeePrivileges:{
			filter:"TimetablesEmployeePrivilegesWhere",
			orderBy:"TimetablesEmployeePrivilegesOrderBy"
		},
		validateCreateTimetablesEmployeePrivileges:{
			data:"TimetablesEmployeePrivilegesCreateInput"
		},
		validateUpdateTimetablesEmployeePrivileges:{
			by:"TimetablesEmployeePrivilegesUniqueWhere",
			data:"TimetablesEmployeePrivilegesUpdateInput"
		},
		getTimetableDayNote:{
			by:"TimetableDayNoteUniqueWhere",
			filter:"TimetableDayNoteWhere"
		},
		listTimetableDayNote:{
			filter:"TimetableDayNoteWhere",
			orderBy:"TimetableDayNoteOrderBy"
		},
		paginateTimetableDayNote:{
			filter:"TimetableDayNoteWhere",
			orderBy:"TimetableDayNoteOrderBy"
		},
		validateCreateTimetableDayNote:{
			data:"TimetableDayNoteCreateInput"
		},
		validateUpdateTimetableDayNote:{
			by:"TimetableDayNoteUniqueWhere",
			data:"TimetableDayNoteUpdateInput"
		},
		getDeliveryMethodLocale:{
			by:"DeliveryMethodLocaleUniqueWhere",
			filter:"DeliveryMethodLocaleWhere"
		},
		listDeliveryMethodLocale:{
			filter:"DeliveryMethodLocaleWhere",
			orderBy:"DeliveryMethodLocaleOrderBy"
		},
		paginateDeliveryMethodLocale:{
			filter:"DeliveryMethodLocaleWhere",
			orderBy:"DeliveryMethodLocaleOrderBy"
		},
		validateCreateDeliveryMethodLocale:{
			data:"DeliveryMethodLocaleCreateInput"
		},
		validateUpdateDeliveryMethodLocale:{
			by:"DeliveryMethodLocaleUniqueWhere",
			data:"DeliveryMethodLocaleUpdateInput"
		},
		getIngredientSupplier:{
			by:"IngredientSupplierUniqueWhere",
			filter:"IngredientSupplierWhere"
		},
		listIngredientSupplier:{
			filter:"IngredientSupplierWhere",
			orderBy:"IngredientSupplierOrderBy"
		},
		paginateIngredientSupplier:{
			filter:"IngredientSupplierWhere",
			orderBy:"IngredientSupplierOrderBy"
		},
		validateCreateIngredientSupplier:{
			data:"IngredientSupplierCreateInput"
		},
		validateUpdateIngredientSupplier:{
			by:"IngredientSupplierUniqueWhere",
			data:"IngredientSupplierUpdateInput"
		},
		getIngredientSupplierItem:{
			by:"IngredientSupplierItemUniqueWhere",
			filter:"IngredientSupplierItemWhere"
		},
		listIngredientSupplierItem:{
			filter:"IngredientSupplierItemWhere",
			orderBy:"IngredientSupplierItemOrderBy"
		},
		paginateIngredientSupplierItem:{
			filter:"IngredientSupplierItemWhere",
			orderBy:"IngredientSupplierItemOrderBy"
		},
		validateCreateIngredientSupplierItem:{
			data:"IngredientSupplierItemCreateInput"
		},
		validateUpdateIngredientSupplierItem:{
			by:"IngredientSupplierItemUniqueWhere",
			data:"IngredientSupplierItemUpdateInput"
		},
		getIngredientSupplierList:{
			by:"IngredientSupplierListUniqueWhere",
			filter:"IngredientSupplierListWhere"
		},
		listIngredientSupplierList:{
			filter:"IngredientSupplierListWhere",
			orderBy:"IngredientSupplierListOrderBy"
		},
		paginateIngredientSupplierList:{
			filter:"IngredientSupplierListWhere",
			orderBy:"IngredientSupplierListOrderBy"
		},
		validateCreateIngredientSupplierList:{
			data:"IngredientSupplierListCreateInput"
		},
		validateUpdateIngredientSupplierList:{
			by:"IngredientSupplierListUniqueWhere",
			data:"IngredientSupplierListUpdateInput"
		},
		getIngredientSupplierLocale:{
			by:"IngredientSupplierLocaleUniqueWhere",
			filter:"IngredientSupplierLocaleWhere"
		},
		listIngredientSupplierLocale:{
			filter:"IngredientSupplierLocaleWhere",
			orderBy:"IngredientSupplierLocaleOrderBy"
		},
		paginateIngredientSupplierLocale:{
			filter:"IngredientSupplierLocaleWhere",
			orderBy:"IngredientSupplierLocaleOrderBy"
		},
		validateCreateIngredientSupplierLocale:{
			data:"IngredientSupplierLocaleCreateInput"
		},
		validateUpdateIngredientSupplierLocale:{
			by:"IngredientSupplierLocaleUniqueWhere",
			data:"IngredientSupplierLocaleUpdateInput"
		},
		getRedirect:{
			by:"RedirectUniqueWhere",
			filter:"RedirectWhere"
		},
		listRedirect:{
			filter:"RedirectWhere",
			orderBy:"RedirectOrderBy"
		},
		paginateRedirect:{
			filter:"RedirectWhere",
			orderBy:"RedirectOrderBy"
		},
		validateCreateRedirect:{
			data:"RedirectCreateInput"
		},
		validateUpdateRedirect:{
			by:"RedirectUniqueWhere",
			data:"RedirectUpdateInput"
		},
		getNutritionFacts:{
			by:"NutritionFactsUniqueWhere",
			filter:"NutritionFactsWhere"
		},
		listNutritionFacts:{
			filter:"NutritionFactsWhere",
			orderBy:"NutritionFactsOrderBy"
		},
		paginateNutritionFacts:{
			filter:"NutritionFactsWhere",
			orderBy:"NutritionFactsOrderBy"
		},
		validateCreateNutritionFacts:{
			data:"NutritionFactsCreateInput"
		},
		validateUpdateNutritionFacts:{
			by:"NutritionFactsUniqueWhere",
			data:"NutritionFactsUpdateInput"
		},
		getVenue:{
			by:"VenueUniqueWhere",
			filter:"VenueWhere"
		},
		listVenue:{
			filter:"VenueWhere",
			orderBy:"VenueOrderBy"
		},
		paginateVenue:{
			filter:"VenueWhere",
			orderBy:"VenueOrderBy"
		},
		validateCreateVenue:{
			data:"VenueCreateInput"
		},
		validateUpdateVenue:{
			by:"VenueUniqueWhere",
			data:"VenueUpdateInput"
		},
		getWorkspace:{
			by:"WorkspaceUniqueWhere",
			filter:"WorkspaceWhere"
		},
		listWorkspace:{
			filter:"WorkspaceWhere",
			orderBy:"WorkspaceOrderBy"
		},
		paginateWorkspace:{
			filter:"WorkspaceWhere",
			orderBy:"WorkspaceOrderBy"
		},
		validateCreateWorkspace:{
			data:"WorkspaceCreateInput"
		},
		validateUpdateWorkspace:{
			by:"WorkspaceUniqueWhere",
			data:"WorkspaceUpdateInput"
		},
		getInternalBuyer:{
			by:"InternalBuyerUniqueWhere",
			filter:"InternalBuyerWhere"
		},
		listInternalBuyer:{
			filter:"InternalBuyerWhere",
			orderBy:"InternalBuyerOrderBy"
		},
		paginateInternalBuyer:{
			filter:"InternalBuyerWhere",
			orderBy:"InternalBuyerOrderBy"
		},
		validateCreateInternalBuyer:{
			data:"InternalBuyerCreateInput"
		},
		validateUpdateInternalBuyer:{
			by:"InternalBuyerUniqueWhere",
			data:"InternalBuyerUpdateInput"
		},
		getCartSummary:{
			by:"CartSummaryUniqueWhere",
			filter:"CartSummaryWhere"
		},
		listCartSummary:{
			filter:"CartSummaryWhere",
			orderBy:"CartSummaryOrderBy"
		},
		paginateCartSummary:{
			filter:"CartSummaryWhere",
			orderBy:"CartSummaryOrderBy"
		},
		getOrderSummary:{
			by:"OrderSummaryUniqueWhere",
			filter:"OrderSummaryWhere"
		},
		listOrderSummary:{
			filter:"OrderSummaryWhere",
			orderBy:"OrderSummaryOrderBy"
		},
		paginateOrderSummary:{
			filter:"OrderSummaryWhere",
			orderBy:"OrderSummaryOrderBy"
		},
		getCustomerSpending:{
			by:"CustomerSpendingUniqueWhere",
			filter:"CustomerSpendingWhere"
		},
		listCustomerSpending:{
			filter:"CustomerSpendingWhere",
			orderBy:"CustomerSpendingOrderBy"
		},
		paginateCustomerSpending:{
			filter:"CustomerSpendingWhere",
			orderBy:"CustomerSpendingOrderBy"
		},
		getOrderPaymentMetadata:{
			by:"OrderPaymentMetadataUniqueWhere",
			filter:"OrderPaymentMetadataWhere"
		},
		listOrderPaymentMetadata:{
			filter:"OrderPaymentMetadataWhere",
			orderBy:"OrderPaymentMetadataOrderBy"
		},
		paginateOrderPaymentMetadata:{
			filter:"OrderPaymentMetadataWhere",
			orderBy:"OrderPaymentMetadataOrderBy"
		},
		getUserMetadata:{
			by:"UserMetadataUniqueWhere",
			filter:"UserMetadataWhere"
		},
		listUserMetadata:{
			filter:"UserMetadataWhere",
			orderBy:"UserMetadataOrderBy"
		},
		paginateUserMetadata:{
			filter:"UserMetadataWhere",
			orderBy:"UserMetadataOrderBy"
		},
		getCustomerTabMetadata:{
			by:"CustomerTabMetadataUniqueWhere",
			filter:"CustomerTabMetadataWhere"
		},
		listCustomerTabMetadata:{
			filter:"CustomerTabMetadataWhere",
			orderBy:"CustomerTabMetadataOrderBy"
		},
		paginateCustomerTabMetadata:{
			filter:"CustomerTabMetadataWhere",
			orderBy:"CustomerTabMetadataOrderBy"
		},
		getVenueEmployeeRole:{
			by:"VenueEmployeeRoleUniqueWhere",
			filter:"VenueEmployeeRoleWhere"
		},
		listVenueEmployeeRole:{
			filter:"VenueEmployeeRoleWhere",
			orderBy:"VenueEmployeeRoleOrderBy"
		},
		paginateVenueEmployeeRole:{
			filter:"VenueEmployeeRoleWhere",
			orderBy:"VenueEmployeeRoleOrderBy"
		},
		validateCreateVenueEmployeeRole:{
			data:"VenueEmployeeRoleCreateInput"
		},
		validateUpdateVenueEmployeeRole:{
			by:"VenueEmployeeRoleUniqueWhere",
			data:"VenueEmployeeRoleUpdateInput"
		},
		getIdentificationAttempt:{
			by:"IdentificationAttemptUniqueWhere",
			filter:"IdentificationAttemptWhere"
		},
		listIdentificationAttempt:{
			filter:"IdentificationAttemptWhere",
			orderBy:"IdentificationAttemptOrderBy"
		},
		paginateIdentificationAttempt:{
			filter:"IdentificationAttemptWhere",
			orderBy:"IdentificationAttemptOrderBy"
		},
		validateCreateIdentificationAttempt:{
			data:"IdentificationAttemptCreateInput"
		},
		validateUpdateIdentificationAttempt:{
			by:"IdentificationAttemptUniqueWhere",
			data:"IdentificationAttemptUpdateInput"
		},
		getIdentificationCode:{
			by:"IdentificationCodeUniqueWhere",
			filter:"IdentificationCodeWhere"
		},
		listIdentificationCode:{
			filter:"IdentificationCodeWhere",
			orderBy:"IdentificationCodeOrderBy"
		},
		paginateIdentificationCode:{
			filter:"IdentificationCodeWhere",
			orderBy:"IdentificationCodeOrderBy"
		},
		validateCreateIdentificationCode:{
			data:"IdentificationCodeCreateInput"
		},
		validateUpdateIdentificationCode:{
			by:"IdentificationCodeUniqueWhere",
			data:"IdentificationCodeUpdateInput"
		},
		getIdentificationCodeLocale:{
			by:"IdentificationCodeLocaleUniqueWhere",
			filter:"IdentificationCodeLocaleWhere"
		},
		listIdentificationCodeLocale:{
			filter:"IdentificationCodeLocaleWhere",
			orderBy:"IdentificationCodeLocaleOrderBy"
		},
		paginateIdentificationCodeLocale:{
			filter:"IdentificationCodeLocaleWhere",
			orderBy:"IdentificationCodeLocaleOrderBy"
		},
		validateCreateIdentificationCodeLocale:{
			data:"IdentificationCodeLocaleCreateInput"
		},
		validateUpdateIdentificationCodeLocale:{
			by:"IdentificationCodeLocaleUniqueWhere",
			data:"IdentificationCodeLocaleUpdateInput"
		},
		getPipeline:{
			by:"PipelineUniqueWhere",
			filter:"PipelineWhere"
		},
		listPipeline:{
			filter:"PipelineWhere",
			orderBy:"PipelineOrderBy"
		},
		paginatePipeline:{
			filter:"PipelineWhere",
			orderBy:"PipelineOrderBy"
		},
		validateCreatePipeline:{
			data:"PipelineCreateInput"
		},
		validateUpdatePipeline:{
			by:"PipelineUniqueWhere",
			data:"PipelineUpdateInput"
		},
		getPipelineLead:{
			by:"PipelineLeadUniqueWhere",
			filter:"PipelineLeadWhere"
		},
		listPipelineLead:{
			filter:"PipelineLeadWhere",
			orderBy:"PipelineLeadOrderBy"
		},
		paginatePipelineLead:{
			filter:"PipelineLeadWhere",
			orderBy:"PipelineLeadOrderBy"
		},
		validateCreatePipelineLead:{
			data:"PipelineLeadCreateInput"
		},
		validateUpdatePipelineLead:{
			by:"PipelineLeadUniqueWhere",
			data:"PipelineLeadUpdateInput"
		},
		getPipelineStage:{
			by:"PipelineStageUniqueWhere",
			filter:"PipelineStageWhere"
		},
		listPipelineStage:{
			filter:"PipelineStageWhere",
			orderBy:"PipelineStageOrderBy"
		},
		paginatePipelineStage:{
			filter:"PipelineStageWhere",
			orderBy:"PipelineStageOrderBy"
		},
		validateCreatePipelineStage:{
			data:"PipelineStageCreateInput"
		},
		validateUpdatePipelineStage:{
			by:"PipelineStageUniqueWhere",
			data:"PipelineStageUpdateInput"
		},
		getPipelineStageItem:{
			by:"PipelineStageItemUniqueWhere",
			filter:"PipelineStageItemWhere"
		},
		listPipelineStageItem:{
			filter:"PipelineStageItemWhere",
			orderBy:"PipelineStageItemOrderBy"
		},
		paginatePipelineStageItem:{
			filter:"PipelineStageItemWhere",
			orderBy:"PipelineStageItemOrderBy"
		},
		validateCreatePipelineStageItem:{
			data:"PipelineStageItemCreateInput"
		},
		validateUpdatePipelineStageItem:{
			by:"PipelineStageItemUniqueWhere",
			data:"PipelineStageItemUpdateInput"
		},
		getPipelineStageLocale:{
			by:"PipelineStageLocaleUniqueWhere",
			filter:"PipelineStageLocaleWhere"
		},
		listPipelineStageLocale:{
			filter:"PipelineStageLocaleWhere",
			orderBy:"PipelineStageLocaleOrderBy"
		},
		paginatePipelineStageLocale:{
			filter:"PipelineStageLocaleWhere",
			orderBy:"PipelineStageLocaleOrderBy"
		},
		validateCreatePipelineStageLocale:{
			data:"PipelineStageLocaleCreateInput"
		},
		validateUpdatePipelineStageLocale:{
			by:"PipelineStageLocaleUniqueWhere",
			data:"PipelineStageLocaleUpdateInput"
		},
		getSalesManager:{
			by:"SalesManagerUniqueWhere",
			filter:"SalesManagerWhere"
		},
		listSalesManager:{
			filter:"SalesManagerWhere",
			orderBy:"SalesManagerOrderBy"
		},
		paginateSalesManager:{
			filter:"SalesManagerWhere",
			orderBy:"SalesManagerOrderBy"
		},
		validateCreateSalesManager:{
			data:"SalesManagerCreateInput"
		},
		validateUpdateSalesManager:{
			by:"SalesManagerUniqueWhere",
			data:"SalesManagerUpdateInput"
		},
		getCashierManager:{
			by:"CashierManagerUniqueWhere",
			filter:"CashierManagerWhere"
		},
		listCashierManager:{
			filter:"CashierManagerWhere",
			orderBy:"CashierManagerOrderBy"
		},
		paginateCashierManager:{
			filter:"CashierManagerWhere",
			orderBy:"CashierManagerOrderBy"
		},
		validateCreateCashierManager:{
			data:"CashierManagerCreateInput"
		},
		validateUpdateCashierManager:{
			by:"CashierManagerUniqueWhere",
			data:"CashierManagerUpdateInput"
		},
		getUserRoles:{
			by:"UserRolesUniqueWhere",
			filter:"UserRolesWhere"
		},
		listUserRoles:{
			filter:"UserRolesWhere",
			orderBy:"UserRolesOrderBy"
		},
		paginateUserRoles:{
			filter:"UserRolesWhere",
			orderBy:"UserRolesOrderBy"
		},
		getPointOfSaleApplicationDevice:{
			by:"PointOfSaleApplicationDeviceUniqueWhere",
			filter:"PointOfSaleApplicationDeviceWhere"
		},
		listPointOfSaleApplicationDevice:{
			filter:"PointOfSaleApplicationDeviceWhere",
			orderBy:"PointOfSaleApplicationDeviceOrderBy"
		},
		paginatePointOfSaleApplicationDevice:{
			filter:"PointOfSaleApplicationDeviceWhere",
			orderBy:"PointOfSaleApplicationDeviceOrderBy"
		},
		validateCreatePointOfSaleApplicationDevice:{
			data:"PointOfSaleApplicationDeviceCreateInput"
		},
		validateUpdatePointOfSaleApplicationDevice:{
			by:"PointOfSaleApplicationDeviceUniqueWhere",
			data:"PointOfSaleApplicationDeviceUpdateInput"
		},
		getPointOfSaleTerminal:{
			by:"PointOfSaleTerminalUniqueWhere",
			filter:"PointOfSaleTerminalWhere"
		},
		listPointOfSaleTerminal:{
			filter:"PointOfSaleTerminalWhere",
			orderBy:"PointOfSaleTerminalOrderBy"
		},
		paginatePointOfSaleTerminal:{
			filter:"PointOfSaleTerminalWhere",
			orderBy:"PointOfSaleTerminalOrderBy"
		},
		validateCreatePointOfSaleTerminal:{
			data:"PointOfSaleTerminalCreateInput"
		},
		validateUpdatePointOfSaleTerminal:{
			by:"PointOfSaleTerminalUniqueWhere",
			data:"PointOfSaleTerminalUpdateInput"
		},
		getPipelineStageSentiment:{
			by:"PipelineStageSentimentUniqueWhere",
			filter:"PipelineStageSentimentWhere"
		},
		listPipelineStageSentiment:{
			filter:"PipelineStageSentimentWhere",
			orderBy:"PipelineStageSentimentOrderBy"
		},
		paginatePipelineStageSentiment:{
			filter:"PipelineStageSentimentWhere",
			orderBy:"PipelineStageSentimentOrderBy"
		},
		validateCreatePipelineStageSentiment:{
			data:"PipelineStageSentimentCreateInput"
		},
		validateUpdatePipelineStageSentiment:{
			by:"PipelineStageSentimentUniqueWhere",
			data:"PipelineStageSentimentUpdateInput"
		},
		getDeviceIdentifier:{
			by:"DeviceIdentifierUniqueWhere",
			filter:"DeviceIdentifierWhere"
		},
		listDeviceIdentifier:{
			filter:"DeviceIdentifierWhere",
			orderBy:"DeviceIdentifierOrderBy"
		},
		paginateDeviceIdentifier:{
			filter:"DeviceIdentifierWhere",
			orderBy:"DeviceIdentifierOrderBy"
		},
		validateCreateDeviceIdentifier:{
			data:"DeviceIdentifierCreateInput"
		},
		validateUpdateDeviceIdentifier:{
			by:"DeviceIdentifierUniqueWhere",
			data:"DeviceIdentifierUpdateInput"
		},
		getDeviceIdentifierMetadata:{
			by:"DeviceIdentifierMetadataUniqueWhere",
			filter:"DeviceIdentifierMetadataWhere"
		},
		listDeviceIdentifierMetadata:{
			filter:"DeviceIdentifierMetadataWhere",
			orderBy:"DeviceIdentifierMetadataOrderBy"
		},
		paginateDeviceIdentifierMetadata:{
			filter:"DeviceIdentifierMetadataWhere",
			orderBy:"DeviceIdentifierMetadataOrderBy"
		},
		getPointOfSalePrinter:{
			by:"PointOfSalePrinterUniqueWhere",
			filter:"PointOfSalePrinterWhere"
		},
		listPointOfSalePrinter:{
			filter:"PointOfSalePrinterWhere",
			orderBy:"PointOfSalePrinterOrderBy"
		},
		paginatePointOfSalePrinter:{
			filter:"PointOfSalePrinterWhere",
			orderBy:"PointOfSalePrinterOrderBy"
		},
		validateCreatePointOfSalePrinter:{
			data:"PointOfSalePrinterCreateInput"
		},
		validateUpdatePointOfSalePrinter:{
			by:"PointOfSalePrinterUniqueWhere",
			data:"PointOfSalePrinterUpdateInput"
		},
		getGratuity:{
			by:"GratuityUniqueWhere",
			filter:"GratuityWhere"
		},
		listGratuity:{
			filter:"GratuityWhere",
			orderBy:"GratuityOrderBy"
		},
		paginateGratuity:{
			filter:"GratuityWhere",
			orderBy:"GratuityOrderBy"
		},
		validateCreateGratuity:{
			data:"GratuityCreateInput"
		},
		validateUpdateGratuity:{
			by:"GratuityUniqueWhere",
			data:"GratuityUpdateInput"
		},
		getFulfillmentNote:{
			by:"FulfillmentNoteUniqueWhere",
			filter:"FulfillmentNoteWhere"
		},
		listFulfillmentNote:{
			filter:"FulfillmentNoteWhere",
			orderBy:"FulfillmentNoteOrderBy"
		},
		paginateFulfillmentNote:{
			filter:"FulfillmentNoteWhere",
			orderBy:"FulfillmentNoteOrderBy"
		},
		validateCreateFulfillmentNote:{
			data:"FulfillmentNoteCreateInput"
		},
		validateUpdateFulfillmentNote:{
			by:"FulfillmentNoteUniqueWhere",
			data:"FulfillmentNoteUpdateInput"
		},
		getCustomerMetadata:{
			by:"CustomerMetadataUniqueWhere",
			filter:"CustomerMetadataWhere"
		},
		listCustomerMetadata:{
			filter:"CustomerMetadataWhere",
			orderBy:"CustomerMetadataOrderBy"
		},
		paginateCustomerMetadata:{
			filter:"CustomerMetadataWhere",
			orderBy:"CustomerMetadataOrderBy"
		},
		getLeadForm:{
			by:"LeadFormUniqueWhere",
			filter:"LeadFormWhere"
		},
		listLeadForm:{
			filter:"LeadFormWhere",
			orderBy:"LeadFormOrderBy"
		},
		paginateLeadForm:{
			filter:"LeadFormWhere",
			orderBy:"LeadFormOrderBy"
		},
		validateCreateLeadForm:{
			data:"LeadFormCreateInput"
		},
		validateUpdateLeadForm:{
			by:"LeadFormUniqueWhere",
			data:"LeadFormUpdateInput"
		},
		getSubscriptionBox:{
			by:"SubscriptionBoxUniqueWhere",
			filter:"SubscriptionBoxWhere"
		},
		listSubscriptionBox:{
			filter:"SubscriptionBoxWhere",
			orderBy:"SubscriptionBoxOrderBy"
		},
		paginateSubscriptionBox:{
			filter:"SubscriptionBoxWhere",
			orderBy:"SubscriptionBoxOrderBy"
		},
		validateCreateSubscriptionBox:{
			data:"SubscriptionBoxCreateInput"
		},
		validateUpdateSubscriptionBox:{
			by:"SubscriptionBoxUniqueWhere",
			data:"SubscriptionBoxUpdateInput"
		},
		getSubscriptionBoxLocale:{
			by:"SubscriptionBoxLocaleUniqueWhere",
			filter:"SubscriptionBoxLocaleWhere"
		},
		listSubscriptionBoxLocale:{
			filter:"SubscriptionBoxLocaleWhere",
			orderBy:"SubscriptionBoxLocaleOrderBy"
		},
		paginateSubscriptionBoxLocale:{
			filter:"SubscriptionBoxLocaleWhere",
			orderBy:"SubscriptionBoxLocaleOrderBy"
		},
		validateCreateSubscriptionBoxLocale:{
			data:"SubscriptionBoxLocaleCreateInput"
		},
		validateUpdateSubscriptionBoxLocale:{
			by:"SubscriptionBoxLocaleUniqueWhere",
			data:"SubscriptionBoxLocaleUpdateInput"
		},
		getTimetableDayMetadata:{
			by:"TimetableDayMetadataUniqueWhere",
			filter:"TimetableDayMetadataWhere"
		},
		listTimetableDayMetadata:{
			filter:"TimetableDayMetadataWhere",
			orderBy:"TimetableDayMetadataOrderBy"
		},
		paginateTimetableDayMetadata:{
			filter:"TimetableDayMetadataWhere",
			orderBy:"TimetableDayMetadataOrderBy"
		},
		getBusinessService:{
			by:"BusinessServiceUniqueWhere",
			filter:"BusinessServiceWhere"
		},
		listBusinessService:{
			filter:"BusinessServiceWhere",
			orderBy:"BusinessServiceOrderBy"
		},
		paginateBusinessService:{
			filter:"BusinessServiceWhere",
			orderBy:"BusinessServiceOrderBy"
		},
		validateCreateBusinessService:{
			data:"BusinessServiceCreateInput"
		},
		validateUpdateBusinessService:{
			by:"BusinessServiceUniqueWhere",
			data:"BusinessServiceUpdateInput"
		},
		getBusinessServiceEvent:{
			by:"BusinessServiceEventUniqueWhere",
			filter:"BusinessServiceEventWhere"
		},
		listBusinessServiceEvent:{
			filter:"BusinessServiceEventWhere",
			orderBy:"BusinessServiceEventOrderBy"
		},
		paginateBusinessServiceEvent:{
			filter:"BusinessServiceEventWhere",
			orderBy:"BusinessServiceEventOrderBy"
		},
		validateCreateBusinessServiceEvent:{
			data:"BusinessServiceEventCreateInput"
		},
		validateUpdateBusinessServiceEvent:{
			by:"BusinessServiceEventUniqueWhere",
			data:"BusinessServiceEventUpdateInput"
		},
		getBusinessServiceLocale:{
			by:"BusinessServiceLocaleUniqueWhere",
			filter:"BusinessServiceLocaleWhere"
		},
		listBusinessServiceLocale:{
			filter:"BusinessServiceLocaleWhere",
			orderBy:"BusinessServiceLocaleOrderBy"
		},
		paginateBusinessServiceLocale:{
			filter:"BusinessServiceLocaleWhere",
			orderBy:"BusinessServiceLocaleOrderBy"
		},
		validateCreateBusinessServiceLocale:{
			data:"BusinessServiceLocaleCreateInput"
		},
		validateUpdateBusinessServiceLocale:{
			by:"BusinessServiceLocaleUniqueWhere",
			data:"BusinessServiceLocaleUpdateInput"
		},
		getGridTileItem:{
			by:"GridTileItemUniqueWhere",
			filter:"GridTileItemWhere"
		},
		listGridTileItem:{
			filter:"GridTileItemWhere",
			orderBy:"GridTileItemOrderBy"
		},
		paginateGridTileItem:{
			filter:"GridTileItemWhere",
			orderBy:"GridTileItemOrderBy"
		},
		validateCreateGridTileItem:{
			data:"GridTileItemCreateInput"
		},
		validateUpdateGridTileItem:{
			by:"GridTileItemUniqueWhere",
			data:"GridTileItemUpdateInput"
		},
		getGridTiles:{
			by:"GridTilesUniqueWhere",
			filter:"GridTilesWhere"
		},
		listGridTiles:{
			filter:"GridTilesWhere",
			orderBy:"GridTilesOrderBy"
		},
		paginateGridTiles:{
			filter:"GridTilesWhere",
			orderBy:"GridTilesOrderBy"
		},
		validateCreateGridTiles:{
			data:"GridTilesCreateInput"
		},
		validateUpdateGridTiles:{
			by:"GridTilesUniqueWhere",
			data:"GridTilesUpdateInput"
		},
		getArea:{
			by:"AreaUniqueWhere",
			filter:"AreaWhere"
		},
		listArea:{
			filter:"AreaWhere",
			orderBy:"AreaOrderBy"
		},
		paginateArea:{
			filter:"AreaWhere",
			orderBy:"AreaOrderBy"
		},
		validateCreateArea:{
			data:"AreaCreateInput"
		},
		validateUpdateArea:{
			by:"AreaUniqueWhere",
			data:"AreaUpdateInput"
		},
		getPosition:{
			by:"PositionUniqueWhere",
			filter:"PositionWhere"
		},
		listPosition:{
			filter:"PositionWhere",
			orderBy:"PositionOrderBy"
		},
		paginatePosition:{
			filter:"PositionWhere",
			orderBy:"PositionOrderBy"
		},
		validateCreatePosition:{
			data:"PositionCreateInput"
		},
		validateUpdatePosition:{
			by:"PositionUniqueWhere",
			data:"PositionUpdateInput"
		},
		getStatsEnabledWidgetType:{
			by:"StatsEnabledWidgetTypeUniqueWhere",
			filter:"StatsEnabledWidgetTypeWhere"
		},
		listStatsEnabledWidgetType:{
			filter:"StatsEnabledWidgetTypeWhere",
			orderBy:"StatsEnabledWidgetTypeOrderBy"
		},
		paginateStatsEnabledWidgetType:{
			filter:"StatsEnabledWidgetTypeWhere",
			orderBy:"StatsEnabledWidgetTypeOrderBy"
		},
		validateCreateStatsEnabledWidgetType:{
			data:"StatsEnabledWidgetTypeCreateInput"
		},
		validateUpdateStatsEnabledWidgetType:{
			by:"StatsEnabledWidgetTypeUniqueWhere",
			data:"StatsEnabledWidgetTypeUpdateInput"
		},
		getStatsWidget:{
			by:"StatsWidgetUniqueWhere",
			filter:"StatsWidgetWhere"
		},
		listStatsWidget:{
			filter:"StatsWidgetWhere",
			orderBy:"StatsWidgetOrderBy"
		},
		paginateStatsWidget:{
			filter:"StatsWidgetWhere",
			orderBy:"StatsWidgetOrderBy"
		},
		validateCreateStatsWidget:{
			data:"StatsWidgetCreateInput"
		},
		validateUpdateStatsWidget:{
			by:"StatsWidgetUniqueWhere",
			data:"StatsWidgetUpdateInput"
		},
		getStatsWidgetsLayout:{
			by:"StatsWidgetsLayoutUniqueWhere",
			filter:"StatsWidgetsLayoutWhere"
		},
		listStatsWidgetsLayout:{
			filter:"StatsWidgetsLayoutWhere",
			orderBy:"StatsWidgetsLayoutOrderBy"
		},
		paginateStatsWidgetsLayout:{
			filter:"StatsWidgetsLayoutWhere",
			orderBy:"StatsWidgetsLayoutOrderBy"
		},
		validateCreateStatsWidgetsLayout:{
			data:"StatsWidgetsLayoutCreateInput"
		},
		validateUpdateStatsWidgetsLayout:{
			by:"StatsWidgetsLayoutUniqueWhere",
			data:"StatsWidgetsLayoutUpdateInput"
		},
		getSeat:{
			by:"SeatUniqueWhere",
			filter:"SeatWhere"
		},
		listSeat:{
			filter:"SeatWhere",
			orderBy:"SeatOrderBy"
		},
		paginateSeat:{
			filter:"SeatWhere",
			orderBy:"SeatOrderBy"
		},
		validateCreateSeat:{
			data:"SeatCreateInput"
		},
		validateUpdateSeat:{
			by:"SeatUniqueWhere",
			data:"SeatUpdateInput"
		},
		getTable:{
			by:"TableUniqueWhere",
			filter:"TableWhere"
		},
		listTable:{
			filter:"TableWhere",
			orderBy:"TableOrderBy"
		},
		paginateTable:{
			filter:"TableWhere",
			orderBy:"TableOrderBy"
		},
		validateCreateTable:{
			data:"TableCreateInput"
		},
		validateUpdateTable:{
			by:"TableUniqueWhere",
			data:"TableUpdateInput"
		},
		getStatsPage:{
			by:"StatsPageUniqueWhere",
			filter:"StatsPageWhere"
		},
		listStatsPage:{
			filter:"StatsPageWhere",
			orderBy:"StatsPageOrderBy"
		},
		paginateStatsPage:{
			filter:"StatsPageWhere",
			orderBy:"StatsPageOrderBy"
		},
		validateCreateStatsPage:{
			data:"StatsPageCreateInput"
		},
		validateUpdateStatsPage:{
			by:"StatsPageUniqueWhere",
			data:"StatsPageUpdateInput"
		},
		getUnassignReason:{
			by:"UnassignReasonUniqueWhere",
			filter:"UnassignReasonWhere"
		},
		listUnassignReason:{
			filter:"UnassignReasonWhere",
			orderBy:"UnassignReasonOrderBy"
		},
		paginateUnassignReason:{
			filter:"UnassignReasonWhere",
			orderBy:"UnassignReasonOrderBy"
		},
		validateCreateUnassignReason:{
			data:"UnassignReasonCreateInput"
		},
		validateUpdateUnassignReason:{
			by:"UnassignReasonUniqueWhere",
			data:"UnassignReasonUpdateInput"
		},
		getDoubleshotCoffeeEquipment:{
			by:"DoubleshotCoffeeEquipmentUniqueWhere",
			filter:"DoubleshotCoffeeEquipmentWhere"
		},
		listDoubleshotCoffeeEquipment:{
			filter:"DoubleshotCoffeeEquipmentWhere",
			orderBy:"DoubleshotCoffeeEquipmentOrderBy"
		},
		paginateDoubleshotCoffeeEquipment:{
			filter:"DoubleshotCoffeeEquipmentWhere",
			orderBy:"DoubleshotCoffeeEquipmentOrderBy"
		},
		validateCreateDoubleshotCoffeeEquipment:{
			data:"DoubleshotCoffeeEquipmentCreateInput"
		},
		validateUpdateDoubleshotCoffeeEquipment:{
			by:"DoubleshotCoffeeEquipmentUniqueWhere",
			data:"DoubleshotCoffeeEquipmentUpdateInput"
		},
		getExpense:{
			by:"ExpenseUniqueWhere",
			filter:"ExpenseWhere"
		},
		listExpense:{
			filter:"ExpenseWhere",
			orderBy:"ExpenseOrderBy"
		},
		paginateExpense:{
			filter:"ExpenseWhere",
			orderBy:"ExpenseOrderBy"
		},
		validateCreateExpense:{
			data:"ExpenseCreateInput"
		},
		validateUpdateExpense:{
			by:"ExpenseUniqueWhere",
			data:"ExpenseUpdateInput"
		},
		getExpenseCategory:{
			by:"ExpenseCategoryUniqueWhere",
			filter:"ExpenseCategoryWhere"
		},
		listExpenseCategory:{
			filter:"ExpenseCategoryWhere",
			orderBy:"ExpenseCategoryOrderBy"
		},
		paginateExpenseCategory:{
			filter:"ExpenseCategoryWhere",
			orderBy:"ExpenseCategoryOrderBy"
		},
		validateCreateExpenseCategory:{
			data:"ExpenseCategoryCreateInput"
		},
		validateUpdateExpenseCategory:{
			by:"ExpenseCategoryUniqueWhere",
			data:"ExpenseCategoryUpdateInput"
		},
		getExpenseChange:{
			by:"ExpenseChangeUniqueWhere",
			filter:"ExpenseChangeWhere"
		},
		listExpenseChange:{
			filter:"ExpenseChangeWhere",
			orderBy:"ExpenseChangeOrderBy"
		},
		paginateExpenseChange:{
			filter:"ExpenseChangeWhere",
			orderBy:"ExpenseChangeOrderBy"
		},
		validateCreateExpenseChange:{
			data:"ExpenseChangeCreateInput"
		},
		validateUpdateExpenseChange:{
			by:"ExpenseChangeUniqueWhere",
			data:"ExpenseChangeUpdateInput"
		},
		getExpenseDocument:{
			by:"ExpenseDocumentUniqueWhere",
			filter:"ExpenseDocumentWhere"
		},
		listExpenseDocument:{
			filter:"ExpenseDocumentWhere",
			orderBy:"ExpenseDocumentOrderBy"
		},
		paginateExpenseDocument:{
			filter:"ExpenseDocumentWhere",
			orderBy:"ExpenseDocumentOrderBy"
		},
		validateCreateExpenseDocument:{
			data:"ExpenseDocumentCreateInput"
		},
		validateUpdateExpenseDocument:{
			by:"ExpenseDocumentUniqueWhere",
			data:"ExpenseDocumentUpdateInput"
		},
		getRevenuePrediction:{
			by:"RevenuePredictionUniqueWhere",
			filter:"RevenuePredictionWhere"
		},
		listRevenuePrediction:{
			filter:"RevenuePredictionWhere",
			orderBy:"RevenuePredictionOrderBy"
		},
		paginateRevenuePrediction:{
			filter:"RevenuePredictionWhere",
			orderBy:"RevenuePredictionOrderBy"
		},
		validateCreateRevenuePrediction:{
			data:"RevenuePredictionCreateInput"
		},
		validateUpdateRevenuePrediction:{
			by:"RevenuePredictionUniqueWhere",
			data:"RevenuePredictionUpdateInput"
		},
		getRevenuePredictionChange:{
			by:"RevenuePredictionChangeUniqueWhere",
			filter:"RevenuePredictionChangeWhere"
		},
		listRevenuePredictionChange:{
			filter:"RevenuePredictionChangeWhere",
			orderBy:"RevenuePredictionChangeOrderBy"
		},
		paginateRevenuePredictionChange:{
			filter:"RevenuePredictionChangeWhere",
			orderBy:"RevenuePredictionChangeOrderBy"
		},
		validateCreateRevenuePredictionChange:{
			data:"RevenuePredictionChangeCreateInput"
		},
		validateUpdateRevenuePredictionChange:{
			by:"RevenuePredictionChangeUniqueWhere",
			data:"RevenuePredictionChangeUpdateInput"
		},
		getFile:{
			by:"FileUniqueWhere",
			filter:"FileWhere"
		},
		listFile:{
			filter:"FileWhere",
			orderBy:"FileOrderBy"
		},
		paginateFile:{
			filter:"FileWhere",
			orderBy:"FileOrderBy"
		},
		validateCreateFile:{
			data:"FileCreateInput"
		},
		validateUpdateFile:{
			by:"FileUniqueWhere",
			data:"FileUpdateInput"
		},
		getExpenseTerm:{
			by:"ExpenseTermUniqueWhere",
			filter:"ExpenseTermWhere"
		},
		listExpenseTerm:{
			filter:"ExpenseTermWhere",
			orderBy:"ExpenseTermOrderBy"
		},
		paginateExpenseTerm:{
			filter:"ExpenseTermWhere",
			orderBy:"ExpenseTermOrderBy"
		},
		getLine:{
			by:"LineUniqueWhere",
			filter:"LineWhere"
		},
		listLine:{
			filter:"LineWhere",
			orderBy:"LineOrderBy"
		},
		paginateLine:{
			filter:"LineWhere",
			orderBy:"LineOrderBy"
		},
		validateCreateLine:{
			data:"LineCreateInput"
		},
		validateUpdateLine:{
			by:"LineUniqueWhere",
			data:"LineUpdateInput"
		},
		getFinancesBalanceItem:{
			by:"FinancesBalanceItemUniqueWhere",
			filter:"FinancesBalanceItemWhere"
		},
		listFinancesBalanceItem:{
			filter:"FinancesBalanceItemWhere",
			orderBy:"FinancesBalanceItemOrderBy"
		},
		paginateFinancesBalanceItem:{
			filter:"FinancesBalanceItemWhere",
			orderBy:"FinancesBalanceItemOrderBy"
		},
		validateCreateFinancesBalanceItem:{
			data:"FinancesBalanceItemCreateInput"
		},
		validateUpdateFinancesBalanceItem:{
			by:"FinancesBalanceItemUniqueWhere",
			data:"FinancesBalanceItemUpdateInput"
		},
		getRevenuePredictionTerm:{
			by:"RevenuePredictionTermUniqueWhere",
			filter:"RevenuePredictionTermWhere"
		},
		listRevenuePredictionTerm:{
			filter:"RevenuePredictionTermWhere",
			orderBy:"RevenuePredictionTermOrderBy"
		},
		paginateRevenuePredictionTerm:{
			filter:"RevenuePredictionTermWhere",
			orderBy:"RevenuePredictionTermOrderBy"
		},
		getOrderPaymentStatsByDay:{
			by:"OrderPaymentStatsByDayUniqueWhere",
			filter:"OrderPaymentStatsByDayWhere"
		},
		listOrderPaymentStatsByDay:{
			filter:"OrderPaymentStatsByDayWhere",
			orderBy:"OrderPaymentStatsByDayOrderBy"
		},
		paginateOrderPaymentStatsByDay:{
			filter:"OrderPaymentStatsByDayWhere",
			orderBy:"OrderPaymentStatsByDayOrderBy"
		},
		getWoltDriveDelivery:{
			by:"WoltDriveDeliveryUniqueWhere",
			filter:"WoltDriveDeliveryWhere"
		},
		listWoltDriveDelivery:{
			filter:"WoltDriveDeliveryWhere",
			orderBy:"WoltDriveDeliveryOrderBy"
		},
		paginateWoltDriveDelivery:{
			filter:"WoltDriveDeliveryWhere",
			orderBy:"WoltDriveDeliveryOrderBy"
		},
		validateCreateWoltDriveDelivery:{
			data:"WoltDriveDeliveryCreateInput"
		},
		validateUpdateWoltDriveDelivery:{
			by:"WoltDriveDeliveryUniqueWhere",
			data:"WoltDriveDeliveryUpdateInput"
		}
	},
	Mutation:{
		createAddress:{
			data:"AddressCreateInput"
		},
		deleteAddress:{
			by:"AddressUniqueWhere",
			filter:"AddressWhere"
		},
		updateAddress:{
			by:"AddressUniqueWhere",
			filter:"AddressWhere",
			data:"AddressUpdateInput"
		},
		upsertAddress:{
			by:"AddressUniqueWhere",
			filter:"AddressWhere",
			update:"AddressUpdateInput",
			create:"AddressCreateInput"
		},
		createCountry:{
			data:"CountryCreateInput"
		},
		deleteCountry:{
			by:"CountryUniqueWhere",
			filter:"CountryWhere"
		},
		updateCountry:{
			by:"CountryUniqueWhere",
			filter:"CountryWhere",
			data:"CountryUpdateInput"
		},
		upsertCountry:{
			by:"CountryUniqueWhere",
			filter:"CountryWhere",
			update:"CountryUpdateInput",
			create:"CountryCreateInput"
		},
		createChannel:{
			data:"ChannelCreateInput"
		},
		deleteChannel:{
			by:"ChannelUniqueWhere",
			filter:"ChannelWhere"
		},
		updateChannel:{
			by:"ChannelUniqueWhere",
			filter:"ChannelWhere",
			data:"ChannelUpdateInput"
		},
		upsertChannel:{
			by:"ChannelUniqueWhere",
			filter:"ChannelWhere",
			update:"ChannelUpdateInput",
			create:"ChannelCreateInput"
		},
		createChannelPayment:{
			data:"ChannelPaymentCreateInput"
		},
		deleteChannelPayment:{
			by:"ChannelPaymentUniqueWhere",
			filter:"ChannelPaymentWhere"
		},
		updateChannelPayment:{
			by:"ChannelPaymentUniqueWhere",
			filter:"ChannelPaymentWhere",
			data:"ChannelPaymentUpdateInput"
		},
		upsertChannelPayment:{
			by:"ChannelPaymentUniqueWhere",
			filter:"ChannelPaymentWhere",
			update:"ChannelPaymentUpdateInput",
			create:"ChannelPaymentCreateInput"
		},
		createChannelDelivery:{
			data:"ChannelDeliveryCreateInput"
		},
		deleteChannelDelivery:{
			by:"ChannelDeliveryUniqueWhere",
			filter:"ChannelDeliveryWhere"
		},
		updateChannelDelivery:{
			by:"ChannelDeliveryUniqueWhere",
			filter:"ChannelDeliveryWhere",
			data:"ChannelDeliveryUpdateInput"
		},
		upsertChannelDelivery:{
			by:"ChannelDeliveryUniqueWhere",
			filter:"ChannelDeliveryWhere",
			update:"ChannelDeliveryUpdateInput",
			create:"ChannelDeliveryCreateInput"
		},
		createCustomer:{
			data:"CustomerCreateInput"
		},
		deleteCustomer:{
			by:"CustomerUniqueWhere",
			filter:"CustomerWhere"
		},
		updateCustomer:{
			by:"CustomerUniqueWhere",
			filter:"CustomerWhere",
			data:"CustomerUpdateInput"
		},
		upsertCustomer:{
			by:"CustomerUniqueWhere",
			filter:"CustomerWhere",
			update:"CustomerUpdateInput",
			create:"CustomerCreateInput"
		},
		createCustomerCredit:{
			data:"CustomerCreditCreateInput"
		},
		deleteCustomerCredit:{
			by:"CustomerCreditUniqueWhere",
			filter:"CustomerCreditWhere"
		},
		updateCustomerCredit:{
			by:"CustomerCreditUniqueWhere",
			filter:"CustomerCreditWhere",
			data:"CustomerCreditUpdateInput"
		},
		upsertCustomerCredit:{
			by:"CustomerCreditUniqueWhere",
			filter:"CustomerCreditWhere",
			update:"CustomerCreditUpdateInput",
			create:"CustomerCreditCreateInput"
		},
		createCustomerGroup:{
			data:"CustomerGroupCreateInput"
		},
		deleteCustomerGroup:{
			by:"CustomerGroupUniqueWhere",
			filter:"CustomerGroupWhere"
		},
		updateCustomerGroup:{
			by:"CustomerGroupUniqueWhere",
			filter:"CustomerGroupWhere",
			data:"CustomerGroupUpdateInput"
		},
		upsertCustomerGroup:{
			by:"CustomerGroupUniqueWhere",
			filter:"CustomerGroupWhere",
			update:"CustomerGroupUpdateInput",
			create:"CustomerGroupCreateInput"
		},
		createCustomerPaymentMethod:{
			data:"CustomerPaymentMethodCreateInput"
		},
		deleteCustomerPaymentMethod:{
			by:"CustomerPaymentMethodUniqueWhere",
			filter:"CustomerPaymentMethodWhere"
		},
		updateCustomerPaymentMethod:{
			by:"CustomerPaymentMethodUniqueWhere",
			filter:"CustomerPaymentMethodWhere",
			data:"CustomerPaymentMethodUpdateInput"
		},
		upsertCustomerPaymentMethod:{
			by:"CustomerPaymentMethodUniqueWhere",
			filter:"CustomerPaymentMethodWhere",
			update:"CustomerPaymentMethodUpdateInput",
			create:"CustomerPaymentMethodCreateInput"
		},
		createDeliveryMethod:{
			data:"DeliveryMethodCreateInput"
		},
		deleteDeliveryMethod:{
			by:"DeliveryMethodUniqueWhere",
			filter:"DeliveryMethodWhere"
		},
		updateDeliveryMethod:{
			by:"DeliveryMethodUniqueWhere",
			filter:"DeliveryMethodWhere",
			data:"DeliveryMethodUpdateInput"
		},
		upsertDeliveryMethod:{
			by:"DeliveryMethodUniqueWhere",
			filter:"DeliveryMethodWhere",
			update:"DeliveryMethodUpdateInput",
			create:"DeliveryMethodCreateInput"
		},
		createOrder:{
			data:"OrderCreateInput"
		},
		deleteOrder:{
			by:"OrderUniqueWhere",
			filter:"OrderWhere"
		},
		updateOrder:{
			by:"OrderUniqueWhere",
			filter:"OrderWhere",
			data:"OrderUpdateInput"
		},
		upsertOrder:{
			by:"OrderUniqueWhere",
			filter:"OrderWhere",
			update:"OrderUpdateInput",
			create:"OrderCreateInput"
		},
		createOrderDiscount:{
			data:"OrderDiscountCreateInput"
		},
		deleteOrderDiscount:{
			by:"OrderDiscountUniqueWhere",
			filter:"OrderDiscountWhere"
		},
		updateOrderDiscount:{
			by:"OrderDiscountUniqueWhere",
			filter:"OrderDiscountWhere",
			data:"OrderDiscountUpdateInput"
		},
		upsertOrderDiscount:{
			by:"OrderDiscountUniqueWhere",
			filter:"OrderDiscountWhere",
			update:"OrderDiscountUpdateInput",
			create:"OrderDiscountCreateInput"
		},
		createOrderPayment:{
			data:"OrderPaymentCreateInput"
		},
		deleteOrderPayment:{
			by:"OrderPaymentUniqueWhere",
			filter:"OrderPaymentWhere"
		},
		updateOrderPayment:{
			by:"OrderPaymentUniqueWhere",
			filter:"OrderPaymentWhere",
			data:"OrderPaymentUpdateInput"
		},
		upsertOrderPayment:{
			by:"OrderPaymentUniqueWhere",
			filter:"OrderPaymentWhere",
			update:"OrderPaymentUpdateInput",
			create:"OrderPaymentCreateInput"
		},
		createOrderDelivery:{
			data:"OrderDeliveryCreateInput"
		},
		deleteOrderDelivery:{
			by:"OrderDeliveryUniqueWhere",
			filter:"OrderDeliveryWhere"
		},
		updateOrderDelivery:{
			by:"OrderDeliveryUniqueWhere",
			filter:"OrderDeliveryWhere",
			data:"OrderDeliveryUpdateInput"
		},
		upsertOrderDelivery:{
			by:"OrderDeliveryUniqueWhere",
			filter:"OrderDeliveryWhere",
			update:"OrderDeliveryUpdateInput",
			create:"OrderDeliveryCreateInput"
		},
		createOrderItem:{
			data:"OrderItemCreateInput"
		},
		deleteOrderItem:{
			by:"OrderItemUniqueWhere",
			filter:"OrderItemWhere"
		},
		updateOrderItem:{
			by:"OrderItemUniqueWhere",
			filter:"OrderItemWhere",
			data:"OrderItemUpdateInput"
		},
		upsertOrderItem:{
			by:"OrderItemUniqueWhere",
			filter:"OrderItemWhere",
			update:"OrderItemUpdateInput",
			create:"OrderItemCreateInput"
		},
		createPaymentMethod:{
			data:"PaymentMethodCreateInput"
		},
		deletePaymentMethod:{
			by:"PaymentMethodUniqueWhere",
			filter:"PaymentMethodWhere"
		},
		updatePaymentMethod:{
			by:"PaymentMethodUniqueWhere",
			filter:"PaymentMethodWhere",
			data:"PaymentMethodUpdateInput"
		},
		upsertPaymentMethod:{
			by:"PaymentMethodUniqueWhere",
			filter:"PaymentMethodWhere",
			update:"PaymentMethodUpdateInput",
			create:"PaymentMethodCreateInput"
		},
		createVatRate:{
			data:"VatRateCreateInput"
		},
		deleteVatRate:{
			by:"VatRateUniqueWhere",
			filter:"VatRateWhere"
		},
		updateVatRate:{
			by:"VatRateUniqueWhere",
			filter:"VatRateWhere",
			data:"VatRateUpdateInput"
		},
		upsertVatRate:{
			by:"VatRateUniqueWhere",
			filter:"VatRateWhere",
			update:"VatRateUpdateInput",
			create:"VatRateCreateInput"
		},
		createProduct:{
			data:"ProductCreateInput"
		},
		deleteProduct:{
			by:"ProductUniqueWhere",
			filter:"ProductWhere"
		},
		updateProduct:{
			by:"ProductUniqueWhere",
			filter:"ProductWhere",
			data:"ProductUpdateInput"
		},
		upsertProduct:{
			by:"ProductUniqueWhere",
			filter:"ProductWhere",
			update:"ProductUpdateInput",
			create:"ProductCreateInput"
		},
		createProductStock:{
			data:"ProductStockCreateInput"
		},
		deleteProductStock:{
			by:"ProductStockUniqueWhere",
			filter:"ProductStockWhere"
		},
		updateProductStock:{
			by:"ProductStockUniqueWhere",
			filter:"ProductStockWhere",
			data:"ProductStockUpdateInput"
		},
		upsertProductStock:{
			by:"ProductStockUniqueWhere",
			filter:"ProductStockWhere",
			update:"ProductStockUpdateInput",
			create:"ProductStockCreateInput"
		},
		createProductPacking:{
			data:"ProductPackingCreateInput"
		},
		deleteProductPacking:{
			by:"ProductPackingUniqueWhere",
			filter:"ProductPackingWhere"
		},
		updateProductPacking:{
			by:"ProductPackingUniqueWhere",
			filter:"ProductPackingWhere",
			data:"ProductPackingUpdateInput"
		},
		upsertProductPacking:{
			by:"ProductPackingUniqueWhere",
			filter:"ProductPackingWhere",
			update:"ProductPackingUpdateInput",
			create:"ProductPackingCreateInput"
		},
		createProductGroupPrice:{
			data:"ProductGroupPriceCreateInput"
		},
		deleteProductGroupPrice:{
			by:"ProductGroupPriceUniqueWhere",
			filter:"ProductGroupPriceWhere"
		},
		updateProductGroupPrice:{
			by:"ProductGroupPriceUniqueWhere",
			filter:"ProductGroupPriceWhere",
			data:"ProductGroupPriceUpdateInput"
		},
		upsertProductGroupPrice:{
			by:"ProductGroupPriceUniqueWhere",
			filter:"ProductGroupPriceWhere",
			update:"ProductGroupPriceUpdateInput",
			create:"ProductGroupPriceCreateInput"
		},
		createProductRecipe:{
			data:"ProductRecipeCreateInput"
		},
		deleteProductRecipe:{
			by:"ProductRecipeUniqueWhere",
			filter:"ProductRecipeWhere"
		},
		updateProductRecipe:{
			by:"ProductRecipeUniqueWhere",
			filter:"ProductRecipeWhere",
			data:"ProductRecipeUpdateInput"
		},
		upsertProductRecipe:{
			by:"ProductRecipeUniqueWhere",
			filter:"ProductRecipeWhere",
			update:"ProductRecipeUpdateInput",
			create:"ProductRecipeCreateInput"
		},
		createProductCategory:{
			data:"ProductCategoryCreateInput"
		},
		deleteProductCategory:{
			by:"ProductCategoryUniqueWhere",
			filter:"ProductCategoryWhere"
		},
		updateProductCategory:{
			by:"ProductCategoryUniqueWhere",
			filter:"ProductCategoryWhere",
			data:"ProductCategoryUpdateInput"
		},
		upsertProductCategory:{
			by:"ProductCategoryUniqueWhere",
			filter:"ProductCategoryWhere",
			update:"ProductCategoryUpdateInput",
			create:"ProductCategoryCreateInput"
		},
		createStore:{
			data:"StoreCreateInput"
		},
		deleteStore:{
			by:"StoreUniqueWhere",
			filter:"StoreWhere"
		},
		updateStore:{
			by:"StoreUniqueWhere",
			filter:"StoreWhere",
			data:"StoreUpdateInput"
		},
		upsertStore:{
			by:"StoreUniqueWhere",
			filter:"StoreWhere",
			update:"StoreUpdateInput",
			create:"StoreCreateInput"
		},
		createTag:{
			data:"TagCreateInput"
		},
		deleteTag:{
			by:"TagUniqueWhere",
			filter:"TagWhere"
		},
		updateTag:{
			by:"TagUniqueWhere",
			filter:"TagWhere",
			data:"TagUpdateInput"
		},
		upsertTag:{
			by:"TagUniqueWhere",
			filter:"TagWhere",
			update:"TagUpdateInput",
			create:"TagCreateInput"
		},
		createImage:{
			data:"ImageCreateInput"
		},
		deleteImage:{
			by:"ImageUniqueWhere",
			filter:"ImageWhere"
		},
		updateImage:{
			by:"ImageUniqueWhere",
			filter:"ImageWhere",
			data:"ImageUpdateInput"
		},
		upsertImage:{
			by:"ImageUniqueWhere",
			filter:"ImageWhere",
			update:"ImageUpdateInput",
			create:"ImageCreateInput"
		},
		createBusinessCategory:{
			data:"BusinessCategoryCreateInput"
		},
		deleteBusinessCategory:{
			by:"BusinessCategoryUniqueWhere",
			filter:"BusinessCategoryWhere"
		},
		updateBusinessCategory:{
			by:"BusinessCategoryUniqueWhere",
			filter:"BusinessCategoryWhere",
			data:"BusinessCategoryUpdateInput"
		},
		upsertBusinessCategory:{
			by:"BusinessCategoryUniqueWhere",
			filter:"BusinessCategoryWhere",
			update:"BusinessCategoryUpdateInput",
			create:"BusinessCategoryCreateInput"
		},
		createProductList:{
			data:"ProductListCreateInput"
		},
		deleteProductList:{
			by:"ProductListUniqueWhere",
			filter:"ProductListWhere"
		},
		updateProductList:{
			by:"ProductListUniqueWhere",
			filter:"ProductListWhere",
			data:"ProductListUpdateInput"
		},
		upsertProductList:{
			by:"ProductListUniqueWhere",
			filter:"ProductListWhere",
			update:"ProductListUpdateInput",
			create:"ProductListCreateInput"
		},
		createProductListItem:{
			data:"ProductListItemCreateInput"
		},
		deleteProductListItem:{
			by:"ProductListItemUniqueWhere",
			filter:"ProductListItemWhere"
		},
		updateProductListItem:{
			by:"ProductListItemUniqueWhere",
			filter:"ProductListItemWhere",
			data:"ProductListItemUpdateInput"
		},
		upsertProductListItem:{
			by:"ProductListItemUniqueWhere",
			filter:"ProductListItemWhere",
			update:"ProductListItemUpdateInput",
			create:"ProductListItemCreateInput"
		},
		createProductCategoryList:{
			data:"ProductCategoryListCreateInput"
		},
		deleteProductCategoryList:{
			by:"ProductCategoryListUniqueWhere",
			filter:"ProductCategoryListWhere"
		},
		updateProductCategoryList:{
			by:"ProductCategoryListUniqueWhere",
			filter:"ProductCategoryListWhere",
			data:"ProductCategoryListUpdateInput"
		},
		upsertProductCategoryList:{
			by:"ProductCategoryListUniqueWhere",
			filter:"ProductCategoryListWhere",
			update:"ProductCategoryListUpdateInput",
			create:"ProductCategoryListCreateInput"
		},
		createProductCategoryListItem:{
			data:"ProductCategoryListItemCreateInput"
		},
		deleteProductCategoryListItem:{
			by:"ProductCategoryListItemUniqueWhere",
			filter:"ProductCategoryListItemWhere"
		},
		updateProductCategoryListItem:{
			by:"ProductCategoryListItemUniqueWhere",
			filter:"ProductCategoryListItemWhere",
			data:"ProductCategoryListItemUpdateInput"
		},
		upsertProductCategoryListItem:{
			by:"ProductCategoryListItemUniqueWhere",
			filter:"ProductCategoryListItemWhere",
			update:"ProductCategoryListItemUpdateInput",
			create:"ProductCategoryListItemCreateInput"
		},
		createBusinessCategoryLocale:{
			data:"BusinessCategoryLocaleCreateInput"
		},
		deleteBusinessCategoryLocale:{
			by:"BusinessCategoryLocaleUniqueWhere",
			filter:"BusinessCategoryLocaleWhere"
		},
		updateBusinessCategoryLocale:{
			by:"BusinessCategoryLocaleUniqueWhere",
			filter:"BusinessCategoryLocaleWhere",
			data:"BusinessCategoryLocaleUpdateInput"
		},
		upsertBusinessCategoryLocale:{
			by:"BusinessCategoryLocaleUniqueWhere",
			filter:"BusinessCategoryLocaleWhere",
			update:"BusinessCategoryLocaleUpdateInput",
			create:"BusinessCategoryLocaleCreateInput"
		},
		createLocale:{
			data:"LocaleCreateInput"
		},
		deleteLocale:{
			by:"LocaleUniqueWhere",
			filter:"LocaleWhere"
		},
		updateLocale:{
			by:"LocaleUniqueWhere",
			filter:"LocaleWhere",
			data:"LocaleUpdateInput"
		},
		upsertLocale:{
			by:"LocaleUniqueWhere",
			filter:"LocaleWhere",
			update:"LocaleUpdateInput",
			create:"LocaleCreateInput"
		},
		createProductCategoryListLocale:{
			data:"ProductCategoryListLocaleCreateInput"
		},
		deleteProductCategoryListLocale:{
			by:"ProductCategoryListLocaleUniqueWhere",
			filter:"ProductCategoryListLocaleWhere"
		},
		updateProductCategoryListLocale:{
			by:"ProductCategoryListLocaleUniqueWhere",
			filter:"ProductCategoryListLocaleWhere",
			data:"ProductCategoryListLocaleUpdateInput"
		},
		upsertProductCategoryListLocale:{
			by:"ProductCategoryListLocaleUniqueWhere",
			filter:"ProductCategoryListLocaleWhere",
			update:"ProductCategoryListLocaleUpdateInput",
			create:"ProductCategoryListLocaleCreateInput"
		},
		createCustomerName:{
			data:"CustomerNameCreateInput"
		},
		deleteCustomerName:{
			by:"CustomerNameUniqueWhere",
			filter:"CustomerNameWhere"
		},
		updateCustomerName:{
			by:"CustomerNameUniqueWhere",
			filter:"CustomerNameWhere",
			data:"CustomerNameUpdateInput"
		},
		upsertCustomerName:{
			by:"CustomerNameUniqueWhere",
			filter:"CustomerNameWhere",
			update:"CustomerNameUpdateInput",
			create:"CustomerNameCreateInput"
		},
		createCustomerAlias:{
			data:"CustomerAliasCreateInput"
		},
		deleteCustomerAlias:{
			by:"CustomerAliasUniqueWhere",
			filter:"CustomerAliasWhere"
		},
		updateCustomerAlias:{
			by:"CustomerAliasUniqueWhere",
			filter:"CustomerAliasWhere",
			data:"CustomerAliasUpdateInput"
		},
		upsertCustomerAlias:{
			by:"CustomerAliasUniqueWhere",
			filter:"CustomerAliasWhere",
			update:"CustomerAliasUpdateInput",
			create:"CustomerAliasCreateInput"
		},
		createProductIngredientItem:{
			data:"ProductIngredientItemCreateInput"
		},
		deleteProductIngredientItem:{
			by:"ProductIngredientItemUniqueWhere",
			filter:"ProductIngredientItemWhere"
		},
		updateProductIngredientItem:{
			by:"ProductIngredientItemUniqueWhere",
			filter:"ProductIngredientItemWhere",
			data:"ProductIngredientItemUpdateInput"
		},
		upsertProductIngredientItem:{
			by:"ProductIngredientItemUniqueWhere",
			filter:"ProductIngredientItemWhere",
			update:"ProductIngredientItemUpdateInput",
			create:"ProductIngredientItemCreateInput"
		},
		createProductIngredientItemQuantity:{
			data:"ProductIngredientItemQuantityCreateInput"
		},
		deleteProductIngredientItemQuantity:{
			by:"ProductIngredientItemQuantityUniqueWhere",
			filter:"ProductIngredientItemQuantityWhere"
		},
		updateProductIngredientItemQuantity:{
			by:"ProductIngredientItemQuantityUniqueWhere",
			filter:"ProductIngredientItemQuantityWhere",
			data:"ProductIngredientItemQuantityUpdateInput"
		},
		upsertProductIngredientItemQuantity:{
			by:"ProductIngredientItemQuantityUniqueWhere",
			filter:"ProductIngredientItemQuantityWhere",
			update:"ProductIngredientItemQuantityUpdateInput",
			create:"ProductIngredientItemQuantityCreateInput"
		},
		createProductIngredientItemQuantityUnit:{
			data:"ProductIngredientItemQuantityUnitCreateInput"
		},
		deleteProductIngredientItemQuantityUnit:{
			by:"ProductIngredientItemQuantityUnitUniqueWhere",
			filter:"ProductIngredientItemQuantityUnitWhere"
		},
		updateProductIngredientItemQuantityUnit:{
			by:"ProductIngredientItemQuantityUnitUniqueWhere",
			filter:"ProductIngredientItemQuantityUnitWhere",
			data:"ProductIngredientItemQuantityUnitUpdateInput"
		},
		upsertProductIngredientItemQuantityUnit:{
			by:"ProductIngredientItemQuantityUnitUniqueWhere",
			filter:"ProductIngredientItemQuantityUnitWhere",
			update:"ProductIngredientItemQuantityUnitUpdateInput",
			create:"ProductIngredientItemQuantityUnitCreateInput"
		},
		createProductIngredient:{
			data:"ProductIngredientCreateInput"
		},
		deleteProductIngredient:{
			by:"ProductIngredientUniqueWhere",
			filter:"ProductIngredientWhere"
		},
		updateProductIngredient:{
			by:"ProductIngredientUniqueWhere",
			filter:"ProductIngredientWhere",
			data:"ProductIngredientUpdateInput"
		},
		upsertProductIngredient:{
			by:"ProductIngredientUniqueWhere",
			filter:"ProductIngredientWhere",
			update:"ProductIngredientUpdateInput",
			create:"ProductIngredientCreateInput"
		},
		createCustomerIngredientRating:{
			data:"CustomerIngredientRatingCreateInput"
		},
		deleteCustomerIngredientRating:{
			by:"CustomerIngredientRatingUniqueWhere",
			filter:"CustomerIngredientRatingWhere"
		},
		updateCustomerIngredientRating:{
			by:"CustomerIngredientRatingUniqueWhere",
			filter:"CustomerIngredientRatingWhere",
			data:"CustomerIngredientRatingUpdateInput"
		},
		upsertCustomerIngredientRating:{
			by:"CustomerIngredientRatingUniqueWhere",
			filter:"CustomerIngredientRatingWhere",
			update:"CustomerIngredientRatingUpdateInput",
			create:"CustomerIngredientRatingCreateInput"
		},
		createProductIngredientRating:{
			data:"ProductIngredientRatingCreateInput"
		},
		deleteProductIngredientRating:{
			by:"ProductIngredientRatingUniqueWhere",
			filter:"ProductIngredientRatingWhere"
		},
		updateProductIngredientRating:{
			by:"ProductIngredientRatingUniqueWhere",
			filter:"ProductIngredientRatingWhere",
			data:"ProductIngredientRatingUpdateInput"
		},
		upsertProductIngredientRating:{
			by:"ProductIngredientRatingUniqueWhere",
			filter:"ProductIngredientRatingWhere",
			update:"ProductIngredientRatingUpdateInput",
			create:"ProductIngredientRatingCreateInput"
		},
		createProductIngredientLocale:{
			data:"ProductIngredientLocaleCreateInput"
		},
		deleteProductIngredientLocale:{
			by:"ProductIngredientLocaleUniqueWhere",
			filter:"ProductIngredientLocaleWhere"
		},
		updateProductIngredientLocale:{
			by:"ProductIngredientLocaleUniqueWhere",
			filter:"ProductIngredientLocaleWhere",
			data:"ProductIngredientLocaleUpdateInput"
		},
		upsertProductIngredientLocale:{
			by:"ProductIngredientLocaleUniqueWhere",
			filter:"ProductIngredientLocaleWhere",
			update:"ProductIngredientLocaleUpdateInput",
			create:"ProductIngredientLocaleCreateInput"
		},
		createOrderRecurrence:{
			data:"OrderRecurrenceCreateInput"
		},
		deleteOrderRecurrence:{
			by:"OrderRecurrenceUniqueWhere",
			filter:"OrderRecurrenceWhere"
		},
		updateOrderRecurrence:{
			by:"OrderRecurrenceUniqueWhere",
			filter:"OrderRecurrenceWhere",
			data:"OrderRecurrenceUpdateInput"
		},
		upsertOrderRecurrence:{
			by:"OrderRecurrenceUniqueWhere",
			filter:"OrderRecurrenceWhere",
			update:"OrderRecurrenceUpdateInput",
			create:"OrderRecurrenceCreateInput"
		},
		createOrderRecurrenceLocale:{
			data:"OrderRecurrenceLocaleCreateInput"
		},
		deleteOrderRecurrenceLocale:{
			by:"OrderRecurrenceLocaleUniqueWhere",
			filter:"OrderRecurrenceLocaleWhere"
		},
		updateOrderRecurrenceLocale:{
			by:"OrderRecurrenceLocaleUniqueWhere",
			filter:"OrderRecurrenceLocaleWhere",
			data:"OrderRecurrenceLocaleUpdateInput"
		},
		upsertOrderRecurrenceLocale:{
			by:"OrderRecurrenceLocaleUniqueWhere",
			filter:"OrderRecurrenceLocaleWhere",
			update:"OrderRecurrenceLocaleUpdateInput",
			create:"OrderRecurrenceLocaleCreateInput"
		},
		createBusinessCustomer:{
			data:"BusinessCustomerCreateInput"
		},
		deleteBusinessCustomer:{
			by:"BusinessCustomerUniqueWhere",
			filter:"BusinessCustomerWhere"
		},
		updateBusinessCustomer:{
			by:"BusinessCustomerUniqueWhere",
			filter:"BusinessCustomerWhere",
			data:"BusinessCustomerUpdateInput"
		},
		upsertBusinessCustomer:{
			by:"BusinessCustomerUniqueWhere",
			filter:"BusinessCustomerWhere",
			update:"BusinessCustomerUpdateInput",
			create:"BusinessCustomerCreateInput"
		},
		createPointOfSale:{
			data:"PointOfSaleCreateInput"
		},
		deletePointOfSale:{
			by:"PointOfSaleUniqueWhere",
			filter:"PointOfSaleWhere"
		},
		updatePointOfSale:{
			by:"PointOfSaleUniqueWhere",
			filter:"PointOfSaleWhere",
			data:"PointOfSaleUpdateInput"
		},
		upsertPointOfSale:{
			by:"PointOfSaleUniqueWhere",
			filter:"PointOfSaleWhere",
			update:"PointOfSaleUpdateInput",
			create:"PointOfSaleCreateInput"
		},
		createStaff:{
			data:"StaffCreateInput"
		},
		deleteStaff:{
			by:"StaffUniqueWhere",
			filter:"StaffWhere"
		},
		updateStaff:{
			by:"StaffUniqueWhere",
			filter:"StaffWhere",
			data:"StaffUpdateInput"
		},
		upsertStaff:{
			by:"StaffUniqueWhere",
			filter:"StaffWhere",
			update:"StaffUpdateInput",
			create:"StaffCreateInput"
		},
		createBlog:{
			data:"BlogCreateInput"
		},
		deleteBlog:{
			by:"BlogUniqueWhere",
			filter:"BlogWhere"
		},
		updateBlog:{
			by:"BlogUniqueWhere",
			filter:"BlogWhere",
			data:"BlogUpdateInput"
		},
		upsertBlog:{
			by:"BlogUniqueWhere",
			filter:"BlogWhere",
			update:"BlogUpdateInput",
			create:"BlogCreateInput"
		},
		createBlogLocale:{
			data:"BlogLocaleCreateInput"
		},
		deleteBlogLocale:{
			by:"BlogLocaleUniqueWhere",
			filter:"BlogLocaleWhere"
		},
		updateBlogLocale:{
			by:"BlogLocaleUniqueWhere",
			filter:"BlogLocaleWhere",
			data:"BlogLocaleUpdateInput"
		},
		upsertBlogLocale:{
			by:"BlogLocaleUniqueWhere",
			filter:"BlogLocaleWhere",
			update:"BlogLocaleUpdateInput",
			create:"BlogLocaleCreateInput"
		},
		createBlogPost:{
			data:"BlogPostCreateInput"
		},
		deleteBlogPost:{
			by:"BlogPostUniqueWhere",
			filter:"BlogPostWhere"
		},
		updateBlogPost:{
			by:"BlogPostUniqueWhere",
			filter:"BlogPostWhere",
			data:"BlogPostUpdateInput"
		},
		upsertBlogPost:{
			by:"BlogPostUniqueWhere",
			filter:"BlogPostWhere",
			update:"BlogPostUpdateInput",
			create:"BlogPostCreateInput"
		},
		createBlogPostLocale:{
			data:"BlogPostLocaleCreateInput"
		},
		deleteBlogPostLocale:{
			by:"BlogPostLocaleUniqueWhere",
			filter:"BlogPostLocaleWhere"
		},
		updateBlogPostLocale:{
			by:"BlogPostLocaleUniqueWhere",
			filter:"BlogPostLocaleWhere",
			data:"BlogPostLocaleUpdateInput"
		},
		upsertBlogPostLocale:{
			by:"BlogPostLocaleUniqueWhere",
			filter:"BlogPostLocaleWhere",
			update:"BlogPostLocaleUpdateInput",
			create:"BlogPostLocaleCreateInput"
		},
		createColorPallete:{
			data:"ColorPalleteCreateInput"
		},
		deleteColorPallete:{
			by:"ColorPalleteUniqueWhere",
			filter:"ColorPalleteWhere"
		},
		updateColorPallete:{
			by:"ColorPalleteUniqueWhere",
			filter:"ColorPalleteWhere",
			data:"ColorPalleteUpdateInput"
		},
		upsertColorPallete:{
			by:"ColorPalleteUniqueWhere",
			filter:"ColorPalleteWhere",
			update:"ColorPalleteUpdateInput",
			create:"ColorPalleteCreateInput"
		},
		createContent:{
			data:"ContentCreateInput"
		},
		deleteContent:{
			by:"ContentUniqueWhere",
			filter:"ContentWhere"
		},
		updateContent:{
			by:"ContentUniqueWhere",
			filter:"ContentWhere",
			data:"ContentUpdateInput"
		},
		upsertContent:{
			by:"ContentUniqueWhere",
			filter:"ContentWhere",
			update:"ContentUpdateInput",
			create:"ContentCreateInput"
		},
		createContentBlock:{
			data:"ContentBlockCreateInput"
		},
		deleteContentBlock:{
			by:"ContentBlockUniqueWhere",
			filter:"ContentBlockWhere"
		},
		updateContentBlock:{
			by:"ContentBlockUniqueWhere",
			filter:"ContentBlockWhere",
			data:"ContentBlockUpdateInput"
		},
		upsertContentBlock:{
			by:"ContentBlockUniqueWhere",
			filter:"ContentBlockWhere",
			update:"ContentBlockUpdateInput",
			create:"ContentBlockCreateInput"
		},
		createContentReference:{
			data:"ContentReferenceCreateInput"
		},
		deleteContentReference:{
			by:"ContentReferenceUniqueWhere",
			filter:"ContentReferenceWhere"
		},
		updateContentReference:{
			by:"ContentReferenceUniqueWhere",
			filter:"ContentReferenceWhere",
			data:"ContentReferenceUpdateInput"
		},
		upsertContentReference:{
			by:"ContentReferenceUniqueWhere",
			filter:"ContentReferenceWhere",
			update:"ContentReferenceUpdateInput",
			create:"ContentReferenceCreateInput"
		},
		createBlogPostList:{
			data:"BlogPostListCreateInput"
		},
		deleteBlogPostList:{
			by:"BlogPostListUniqueWhere",
			filter:"BlogPostListWhere"
		},
		updateBlogPostList:{
			by:"BlogPostListUniqueWhere",
			filter:"BlogPostListWhere",
			data:"BlogPostListUpdateInput"
		},
		upsertBlogPostList:{
			by:"BlogPostListUniqueWhere",
			filter:"BlogPostListWhere",
			update:"BlogPostListUpdateInput",
			create:"BlogPostListCreateInput"
		},
		createBlogPostListItem:{
			data:"BlogPostListItemCreateInput"
		},
		deleteBlogPostListItem:{
			by:"BlogPostListItemUniqueWhere",
			filter:"BlogPostListItemWhere"
		},
		updateBlogPostListItem:{
			by:"BlogPostListItemUniqueWhere",
			filter:"BlogPostListItemWhere",
			data:"BlogPostListItemUpdateInput"
		},
		upsertBlogPostListItem:{
			by:"BlogPostListItemUniqueWhere",
			filter:"BlogPostListItemWhere",
			update:"BlogPostListItemUpdateInput",
			create:"BlogPostListItemCreateInput"
		},
		createLinkList:{
			data:"LinkListCreateInput"
		},
		deleteLinkList:{
			by:"LinkListUniqueWhere",
			filter:"LinkListWhere"
		},
		updateLinkList:{
			by:"LinkListUniqueWhere",
			filter:"LinkListWhere",
			data:"LinkListUpdateInput"
		},
		upsertLinkList:{
			by:"LinkListUniqueWhere",
			filter:"LinkListWhere",
			update:"LinkListUpdateInput",
			create:"LinkListCreateInput"
		},
		createLinkListItem:{
			data:"LinkListItemCreateInput"
		},
		deleteLinkListItem:{
			by:"LinkListItemUniqueWhere",
			filter:"LinkListItemWhere"
		},
		updateLinkListItem:{
			by:"LinkListItemUniqueWhere",
			filter:"LinkListItemWhere",
			data:"LinkListItemUpdateInput"
		},
		upsertLinkListItem:{
			by:"LinkListItemUniqueWhere",
			filter:"LinkListItemWhere",
			update:"LinkListItemUpdateInput",
			create:"LinkListItemCreateInput"
		},
		createCover:{
			data:"CoverCreateInput"
		},
		deleteCover:{
			by:"CoverUniqueWhere",
			filter:"CoverWhere"
		},
		updateCover:{
			by:"CoverUniqueWhere",
			filter:"CoverWhere",
			data:"CoverUpdateInput"
		},
		upsertCover:{
			by:"CoverUniqueWhere",
			filter:"CoverWhere",
			update:"CoverUpdateInput",
			create:"CoverCreateInput"
		},
		createLink:{
			data:"LinkCreateInput"
		},
		deleteLink:{
			by:"LinkUniqueWhere",
			filter:"LinkWhere"
		},
		updateLink:{
			by:"LinkUniqueWhere",
			filter:"LinkWhere",
			data:"LinkUpdateInput"
		},
		upsertLink:{
			by:"LinkUniqueWhere",
			filter:"LinkWhere",
			update:"LinkUpdateInput",
			create:"LinkCreateInput"
		},
		createLinkable:{
			data:"LinkableCreateInput"
		},
		deleteLinkable:{
			by:"LinkableUniqueWhere",
			filter:"LinkableWhere"
		},
		updateLinkable:{
			by:"LinkableUniqueWhere",
			filter:"LinkableWhere",
			data:"LinkableUpdateInput"
		},
		upsertLinkable:{
			by:"LinkableUniqueWhere",
			filter:"LinkableWhere",
			update:"LinkableUpdateInput",
			create:"LinkableCreateInput"
		},
		createMedium:{
			data:"MediumCreateInput"
		},
		deleteMedium:{
			by:"MediumUniqueWhere",
			filter:"MediumWhere"
		},
		updateMedium:{
			by:"MediumUniqueWhere",
			filter:"MediumWhere",
			data:"MediumUpdateInput"
		},
		upsertMedium:{
			by:"MediumUniqueWhere",
			filter:"MediumWhere",
			update:"MediumUpdateInput",
			create:"MediumCreateInput"
		},
		createVideo:{
			data:"VideoCreateInput"
		},
		deleteVideo:{
			by:"VideoUniqueWhere",
			filter:"VideoWhere"
		},
		updateVideo:{
			by:"VideoUniqueWhere",
			filter:"VideoWhere",
			data:"VideoUpdateInput"
		},
		upsertVideo:{
			by:"VideoUniqueWhere",
			filter:"VideoWhere",
			update:"VideoUpdateInput",
			create:"VideoCreateInput"
		},
		createSeo:{
			data:"SeoCreateInput"
		},
		deleteSeo:{
			by:"SeoUniqueWhere",
			filter:"SeoWhere"
		},
		updateSeo:{
			by:"SeoUniqueWhere",
			filter:"SeoWhere",
			data:"SeoUpdateInput"
		},
		upsertSeo:{
			by:"SeoUniqueWhere",
			filter:"SeoWhere",
			update:"SeoUpdateInput",
			create:"SeoCreateInput"
		},
		createProtectedImage:{
			data:"ProtectedImageCreateInput"
		},
		deleteProtectedImage:{
			by:"ProtectedImageUniqueWhere",
			filter:"ProtectedImageWhere"
		},
		updateProtectedImage:{
			by:"ProtectedImageUniqueWhere",
			filter:"ProtectedImageWhere",
			data:"ProtectedImageUpdateInput"
		},
		upsertProtectedImage:{
			by:"ProtectedImageUniqueWhere",
			filter:"ProtectedImageWhere",
			update:"ProtectedImageUpdateInput",
			create:"ProtectedImageCreateInput"
		},
		createTranslationDomain:{
			data:"TranslationDomainCreateInput"
		},
		deleteTranslationDomain:{
			by:"TranslationDomainUniqueWhere",
			filter:"TranslationDomainWhere"
		},
		updateTranslationDomain:{
			by:"TranslationDomainUniqueWhere",
			filter:"TranslationDomainWhere",
			data:"TranslationDomainUpdateInput"
		},
		upsertTranslationDomain:{
			by:"TranslationDomainUniqueWhere",
			filter:"TranslationDomainWhere",
			update:"TranslationDomainUpdateInput",
			create:"TranslationDomainCreateInput"
		},
		createTranslationCatalogue:{
			data:"TranslationCatalogueCreateInput"
		},
		deleteTranslationCatalogue:{
			by:"TranslationCatalogueUniqueWhere",
			filter:"TranslationCatalogueWhere"
		},
		updateTranslationCatalogue:{
			by:"TranslationCatalogueUniqueWhere",
			filter:"TranslationCatalogueWhere",
			data:"TranslationCatalogueUpdateInput"
		},
		upsertTranslationCatalogue:{
			by:"TranslationCatalogueUniqueWhere",
			filter:"TranslationCatalogueWhere",
			update:"TranslationCatalogueUpdateInput",
			create:"TranslationCatalogueCreateInput"
		},
		createTranslationKey:{
			data:"TranslationKeyCreateInput"
		},
		deleteTranslationKey:{
			by:"TranslationKeyUniqueWhere",
			filter:"TranslationKeyWhere"
		},
		updateTranslationKey:{
			by:"TranslationKeyUniqueWhere",
			filter:"TranslationKeyWhere",
			data:"TranslationKeyUpdateInput"
		},
		upsertTranslationKey:{
			by:"TranslationKeyUniqueWhere",
			filter:"TranslationKeyWhere",
			update:"TranslationKeyUpdateInput",
			create:"TranslationKeyCreateInput"
		},
		createTranslationValue:{
			data:"TranslationValueCreateInput"
		},
		deleteTranslationValue:{
			by:"TranslationValueUniqueWhere",
			filter:"TranslationValueWhere"
		},
		updateTranslationValue:{
			by:"TranslationValueUniqueWhere",
			filter:"TranslationValueWhere",
			data:"TranslationValueUpdateInput"
		},
		upsertTranslationValue:{
			by:"TranslationValueUniqueWhere",
			filter:"TranslationValueWhere",
			update:"TranslationValueUpdateInput",
			create:"TranslationValueCreateInput"
		},
		createTranslationCataloguesIdentifier:{
			data:"TranslationCataloguesIdentifierCreateInput"
		},
		deleteTranslationCataloguesIdentifier:{
			by:"TranslationCataloguesIdentifierUniqueWhere",
			filter:"TranslationCataloguesIdentifierWhere"
		},
		updateTranslationCataloguesIdentifier:{
			by:"TranslationCataloguesIdentifierUniqueWhere",
			filter:"TranslationCataloguesIdentifierWhere",
			data:"TranslationCataloguesIdentifierUpdateInput"
		},
		upsertTranslationCataloguesIdentifier:{
			by:"TranslationCataloguesIdentifierUniqueWhere",
			filter:"TranslationCataloguesIdentifierWhere",
			update:"TranslationCataloguesIdentifierUpdateInput",
			create:"TranslationCataloguesIdentifierCreateInput"
		},
		createSocialsAndApps:{
			data:"SocialsAndAppsCreateInput"
		},
		deleteSocialsAndApps:{
			by:"SocialsAndAppsUniqueWhere",
			filter:"SocialsAndAppsWhere"
		},
		updateSocialsAndApps:{
			by:"SocialsAndAppsUniqueWhere",
			filter:"SocialsAndAppsWhere",
			data:"SocialsAndAppsUpdateInput"
		},
		upsertSocialsAndApps:{
			by:"SocialsAndAppsUniqueWhere",
			filter:"SocialsAndAppsWhere",
			update:"SocialsAndAppsUpdateInput",
			create:"SocialsAndAppsCreateInput"
		},
		createProductGrid:{
			data:"ProductGridCreateInput"
		},
		deleteProductGrid:{
			by:"ProductGridUniqueWhere",
			filter:"ProductGridWhere"
		},
		updateProductGrid:{
			by:"ProductGridUniqueWhere",
			filter:"ProductGridWhere",
			data:"ProductGridUpdateInput"
		},
		upsertProductGrid:{
			by:"ProductGridUniqueWhere",
			filter:"ProductGridWhere",
			update:"ProductGridUpdateInput",
			create:"ProductGridCreateInput"
		},
		createProductGridItem:{
			data:"ProductGridItemCreateInput"
		},
		deleteProductGridItem:{
			by:"ProductGridItemUniqueWhere",
			filter:"ProductGridItemWhere"
		},
		updateProductGridItem:{
			by:"ProductGridItemUniqueWhere",
			filter:"ProductGridItemWhere",
			data:"ProductGridItemUpdateInput"
		},
		upsertProductGridItem:{
			by:"ProductGridItemUniqueWhere",
			filter:"ProductGridItemWhere",
			update:"ProductGridItemUpdateInput",
			create:"ProductGridItemCreateInput"
		},
		createGallery:{
			data:"GalleryCreateInput"
		},
		deleteGallery:{
			by:"GalleryUniqueWhere",
			filter:"GalleryWhere"
		},
		updateGallery:{
			by:"GalleryUniqueWhere",
			filter:"GalleryWhere",
			data:"GalleryUpdateInput"
		},
		upsertGallery:{
			by:"GalleryUniqueWhere",
			filter:"GalleryWhere",
			update:"GalleryUpdateInput",
			create:"GalleryCreateInput"
		},
		createGalleryItem:{
			data:"GalleryItemCreateInput"
		},
		deleteGalleryItem:{
			by:"GalleryItemUniqueWhere",
			filter:"GalleryItemWhere"
		},
		updateGalleryItem:{
			by:"GalleryItemUniqueWhere",
			filter:"GalleryItemWhere",
			data:"GalleryItemUpdateInput"
		},
		upsertGalleryItem:{
			by:"GalleryItemUniqueWhere",
			filter:"GalleryItemWhere",
			update:"GalleryItemUpdateInput",
			create:"GalleryItemCreateInput"
		},
		createHero:{
			data:"HeroCreateInput"
		},
		deleteHero:{
			by:"HeroUniqueWhere",
			filter:"HeroWhere"
		},
		updateHero:{
			by:"HeroUniqueWhere",
			filter:"HeroWhere",
			data:"HeroUpdateInput"
		},
		upsertHero:{
			by:"HeroUniqueWhere",
			filter:"HeroWhere",
			update:"HeroUpdateInput",
			create:"HeroCreateInput"
		},
		createSiteMenu:{
			data:"SiteMenuCreateInput"
		},
		deleteSiteMenu:{
			by:"SiteMenuUniqueWhere",
			filter:"SiteMenuWhere"
		},
		updateSiteMenu:{
			by:"SiteMenuUniqueWhere",
			filter:"SiteMenuWhere",
			data:"SiteMenuUpdateInput"
		},
		upsertSiteMenu:{
			by:"SiteMenuUniqueWhere",
			filter:"SiteMenuWhere",
			update:"SiteMenuUpdateInput",
			create:"SiteMenuCreateInput"
		},
		createMenuLocale:{
			data:"MenuLocaleCreateInput"
		},
		deleteMenuLocale:{
			by:"MenuLocaleUniqueWhere",
			filter:"MenuLocaleWhere"
		},
		updateMenuLocale:{
			by:"MenuLocaleUniqueWhere",
			filter:"MenuLocaleWhere",
			data:"MenuLocaleUpdateInput"
		},
		upsertMenuLocale:{
			by:"MenuLocaleUniqueWhere",
			filter:"MenuLocaleWhere",
			update:"MenuLocaleUpdateInput",
			create:"MenuLocaleCreateInput"
		},
		createMenuItem:{
			data:"MenuItemCreateInput"
		},
		deleteMenuItem:{
			by:"MenuItemUniqueWhere",
			filter:"MenuItemWhere"
		},
		updateMenuItem:{
			by:"MenuItemUniqueWhere",
			filter:"MenuItemWhere",
			data:"MenuItemUpdateInput"
		},
		upsertMenuItem:{
			by:"MenuItemUniqueWhere",
			filter:"MenuItemWhere",
			update:"MenuItemUpdateInput",
			create:"MenuItemCreateInput"
		},
		createPage:{
			data:"PageCreateInput"
		},
		deletePage:{
			by:"PageUniqueWhere",
			filter:"PageWhere"
		},
		updatePage:{
			by:"PageUniqueWhere",
			filter:"PageWhere",
			data:"PageUpdateInput"
		},
		upsertPage:{
			by:"PageUniqueWhere",
			filter:"PageWhere",
			update:"PageUpdateInput",
			create:"PageCreateInput"
		},
		createPageLocale:{
			data:"PageLocaleCreateInput"
		},
		deletePageLocale:{
			by:"PageLocaleUniqueWhere",
			filter:"PageLocaleWhere"
		},
		updatePageLocale:{
			by:"PageLocaleUniqueWhere",
			filter:"PageLocaleWhere",
			data:"PageLocaleUpdateInput"
		},
		upsertPageLocale:{
			by:"PageLocaleUniqueWhere",
			filter:"PageLocaleWhere",
			update:"PageLocaleUpdateInput",
			create:"PageLocaleCreateInput"
		},
		createWikiPage:{
			data:"WikiPageCreateInput"
		},
		deleteWikiPage:{
			by:"WikiPageUniqueWhere",
			filter:"WikiPageWhere"
		},
		updateWikiPage:{
			by:"WikiPageUniqueWhere",
			filter:"WikiPageWhere",
			data:"WikiPageUpdateInput"
		},
		upsertWikiPage:{
			by:"WikiPageUniqueWhere",
			filter:"WikiPageWhere",
			update:"WikiPageUpdateInput",
			create:"WikiPageCreateInput"
		},
		createMenuSubitem:{
			data:"MenuSubitemCreateInput"
		},
		deleteMenuSubitem:{
			by:"MenuSubitemUniqueWhere",
			filter:"MenuSubitemWhere"
		},
		updateMenuSubitem:{
			by:"MenuSubitemUniqueWhere",
			filter:"MenuSubitemWhere",
			data:"MenuSubitemUpdateInput"
		},
		upsertMenuSubitem:{
			by:"MenuSubitemUniqueWhere",
			filter:"MenuSubitemWhere",
			update:"MenuSubitemUpdateInput",
			create:"MenuSubitemCreateInput"
		},
		createMenuLinkList:{
			data:"MenuLinkListCreateInput"
		},
		deleteMenuLinkList:{
			by:"MenuLinkListUniqueWhere",
			filter:"MenuLinkListWhere"
		},
		updateMenuLinkList:{
			by:"MenuLinkListUniqueWhere",
			filter:"MenuLinkListWhere",
			data:"MenuLinkListUpdateInput"
		},
		upsertMenuLinkList:{
			by:"MenuLinkListUniqueWhere",
			filter:"MenuLinkListWhere",
			update:"MenuLinkListUpdateInput",
			create:"MenuLinkListCreateInput"
		},
		createMenuLinkItem:{
			data:"MenuLinkItemCreateInput"
		},
		deleteMenuLinkItem:{
			by:"MenuLinkItemUniqueWhere",
			filter:"MenuLinkItemWhere"
		},
		updateMenuLinkItem:{
			by:"MenuLinkItemUniqueWhere",
			filter:"MenuLinkItemWhere",
			data:"MenuLinkItemUpdateInput"
		},
		upsertMenuLinkItem:{
			by:"MenuLinkItemUniqueWhere",
			filter:"MenuLinkItemWhere",
			update:"MenuLinkItemUpdateInput",
			create:"MenuLinkItemCreateInput"
		},
		createMenuProducts:{
			data:"MenuProductsCreateInput"
		},
		deleteMenuProducts:{
			by:"MenuProductsUniqueWhere",
			filter:"MenuProductsWhere"
		},
		updateMenuProducts:{
			by:"MenuProductsUniqueWhere",
			filter:"MenuProductsWhere",
			data:"MenuProductsUpdateInput"
		},
		upsertMenuProducts:{
			by:"MenuProductsUniqueWhere",
			filter:"MenuProductsWhere",
			update:"MenuProductsUpdateInput",
			create:"MenuProductsCreateInput"
		},
		createMenuDelivery:{
			data:"MenuDeliveryCreateInput"
		},
		deleteMenuDelivery:{
			by:"MenuDeliveryUniqueWhere",
			filter:"MenuDeliveryWhere"
		},
		updateMenuDelivery:{
			by:"MenuDeliveryUniqueWhere",
			filter:"MenuDeliveryWhere",
			data:"MenuDeliveryUpdateInput"
		},
		upsertMenuDelivery:{
			by:"MenuDeliveryUniqueWhere",
			filter:"MenuDeliveryWhere",
			update:"MenuDeliveryUpdateInput",
			create:"MenuDeliveryCreateInput"
		},
		createMenuContact:{
			data:"MenuContactCreateInput"
		},
		deleteMenuContact:{
			by:"MenuContactUniqueWhere",
			filter:"MenuContactWhere"
		},
		updateMenuContact:{
			by:"MenuContactUniqueWhere",
			filter:"MenuContactWhere",
			data:"MenuContactUpdateInput"
		},
		upsertMenuContact:{
			by:"MenuContactUniqueWhere",
			filter:"MenuContactWhere",
			update:"MenuContactUpdateInput",
			create:"MenuContactCreateInput"
		},
		createDeadlineTemplate:{
			data:"DeadlineTemplateCreateInput"
		},
		deleteDeadlineTemplate:{
			by:"DeadlineTemplateUniqueWhere",
			filter:"DeadlineTemplateWhere"
		},
		updateDeadlineTemplate:{
			by:"DeadlineTemplateUniqueWhere",
			filter:"DeadlineTemplateWhere",
			data:"DeadlineTemplateUpdateInput"
		},
		upsertDeadlineTemplate:{
			by:"DeadlineTemplateUniqueWhere",
			filter:"DeadlineTemplateWhere",
			update:"DeadlineTemplateUpdateInput",
			create:"DeadlineTemplateCreateInput"
		},
		createEmployeeQueue:{
			data:"EmployeeQueueCreateInput"
		},
		deleteEmployeeQueue:{
			by:"EmployeeQueueUniqueWhere",
			filter:"EmployeeQueueWhere"
		},
		updateEmployeeQueue:{
			by:"EmployeeQueueUniqueWhere",
			filter:"EmployeeQueueWhere",
			data:"EmployeeQueueUpdateInput"
		},
		upsertEmployeeQueue:{
			by:"EmployeeQueueUniqueWhere",
			filter:"EmployeeQueueWhere",
			update:"EmployeeQueueUpdateInput",
			create:"EmployeeQueueCreateInput"
		},
		createTimetableDay:{
			data:"TimetableDayCreateInput"
		},
		deleteTimetableDay:{
			by:"TimetableDayUniqueWhere",
			filter:"TimetableDayWhere"
		},
		updateTimetableDay:{
			by:"TimetableDayUniqueWhere",
			filter:"TimetableDayWhere",
			data:"TimetableDayUpdateInput"
		},
		upsertTimetableDay:{
			by:"TimetableDayUniqueWhere",
			filter:"TimetableDayWhere",
			update:"TimetableDayUpdateInput",
			create:"TimetableDayCreateInput"
		},
		createTimetableEmployeeRole:{
			data:"TimetableEmployeeRoleCreateInput"
		},
		deleteTimetableEmployeeRole:{
			by:"TimetableEmployeeRoleUniqueWhere",
			filter:"TimetableEmployeeRoleWhere"
		},
		updateTimetableEmployeeRole:{
			by:"TimetableEmployeeRoleUniqueWhere",
			filter:"TimetableEmployeeRoleWhere",
			data:"TimetableEmployeeRoleUpdateInput"
		},
		upsertTimetableEmployeeRole:{
			by:"TimetableEmployeeRoleUniqueWhere",
			filter:"TimetableEmployeeRoleWhere",
			update:"TimetableEmployeeRoleUpdateInput",
			create:"TimetableEmployeeRoleCreateInput"
		},
		createTimetableShift:{
			data:"TimetableShiftCreateInput"
		},
		deleteTimetableShift:{
			by:"TimetableShiftUniqueWhere",
			filter:"TimetableShiftWhere"
		},
		updateTimetableShift:{
			by:"TimetableShiftUniqueWhere",
			filter:"TimetableShiftWhere",
			data:"TimetableShiftUpdateInput"
		},
		upsertTimetableShift:{
			by:"TimetableShiftUniqueWhere",
			filter:"TimetableShiftWhere",
			update:"TimetableShiftUpdateInput",
			create:"TimetableShiftCreateInput"
		},
		createTimetableShiftGroup:{
			data:"TimetableShiftGroupCreateInput"
		},
		deleteTimetableShiftGroup:{
			by:"TimetableShiftGroupUniqueWhere",
			filter:"TimetableShiftGroupWhere"
		},
		updateTimetableShiftGroup:{
			by:"TimetableShiftGroupUniqueWhere",
			filter:"TimetableShiftGroupWhere",
			data:"TimetableShiftGroupUpdateInput"
		},
		upsertTimetableShiftGroup:{
			by:"TimetableShiftGroupUniqueWhere",
			filter:"TimetableShiftGroupWhere",
			update:"TimetableShiftGroupUpdateInput",
			create:"TimetableShiftGroupCreateInput"
		},
		createTimetableShiftPosition:{
			data:"TimetableShiftPositionCreateInput"
		},
		deleteTimetableShiftPosition:{
			by:"TimetableShiftPositionUniqueWhere",
			filter:"TimetableShiftPositionWhere"
		},
		updateTimetableShiftPosition:{
			by:"TimetableShiftPositionUniqueWhere",
			filter:"TimetableShiftPositionWhere",
			data:"TimetableShiftPositionUpdateInput"
		},
		upsertTimetableShiftPosition:{
			by:"TimetableShiftPositionUniqueWhere",
			filter:"TimetableShiftPositionWhere",
			update:"TimetableShiftPositionUpdateInput",
			create:"TimetableShiftPositionCreateInput"
		},
		createTimetableTemplate:{
			data:"TimetableTemplateCreateInput"
		},
		deleteTimetableTemplate:{
			by:"TimetableTemplateUniqueWhere",
			filter:"TimetableTemplateWhere"
		},
		updateTimetableTemplate:{
			by:"TimetableTemplateUniqueWhere",
			filter:"TimetableTemplateWhere",
			data:"TimetableTemplateUpdateInput"
		},
		upsertTimetableTemplate:{
			by:"TimetableTemplateUniqueWhere",
			filter:"TimetableTemplateWhere",
			update:"TimetableTemplateUpdateInput",
			create:"TimetableTemplateCreateInput"
		},
		createCart:{
			data:"CartCreateInput"
		},
		deleteCart:{
			by:"CartUniqueWhere",
			filter:"CartWhere"
		},
		updateCart:{
			by:"CartUniqueWhere",
			filter:"CartWhere",
			data:"CartUpdateInput"
		},
		upsertCart:{
			by:"CartUniqueWhere",
			filter:"CartWhere",
			update:"CartUpdateInput",
			create:"CartCreateInput"
		},
		createCartItem:{
			data:"CartItemCreateInput"
		},
		deleteCartItem:{
			by:"CartItemUniqueWhere",
			filter:"CartItemWhere"
		},
		updateCartItem:{
			by:"CartItemUniqueWhere",
			filter:"CartItemWhere",
			data:"CartItemUpdateInput"
		},
		upsertCartItem:{
			by:"CartItemUniqueWhere",
			filter:"CartItemWhere",
			update:"CartItemUpdateInput",
			create:"CartItemCreateInput"
		},
		createEmployeeQueueItem:{
			data:"EmployeeQueueItemCreateInput"
		},
		deleteEmployeeQueueItem:{
			by:"EmployeeQueueItemUniqueWhere",
			filter:"EmployeeQueueItemWhere"
		},
		updateEmployeeQueueItem:{
			by:"EmployeeQueueItemUniqueWhere",
			filter:"EmployeeQueueItemWhere",
			data:"EmployeeQueueItemUpdateInput"
		},
		upsertEmployeeQueueItem:{
			by:"EmployeeQueueItemUniqueWhere",
			filter:"EmployeeQueueItemWhere",
			update:"EmployeeQueueItemUpdateInput",
			create:"EmployeeQueueItemCreateInput"
		},
		createApplication:{
			data:"ApplicationCreateInput"
		},
		deleteApplication:{
			by:"ApplicationUniqueWhere",
			filter:"ApplicationWhere"
		},
		updateApplication:{
			by:"ApplicationUniqueWhere",
			filter:"ApplicationWhere",
			data:"ApplicationUpdateInput"
		},
		upsertApplication:{
			by:"ApplicationUniqueWhere",
			filter:"ApplicationWhere",
			update:"ApplicationUpdateInput",
			create:"ApplicationCreateInput"
		},
		createApplicationShortcutList:{
			data:"ApplicationShortcutListCreateInput"
		},
		deleteApplicationShortcutList:{
			by:"ApplicationShortcutListUniqueWhere",
			filter:"ApplicationShortcutListWhere"
		},
		updateApplicationShortcutList:{
			by:"ApplicationShortcutListUniqueWhere",
			filter:"ApplicationShortcutListWhere",
			data:"ApplicationShortcutListUpdateInput"
		},
		upsertApplicationShortcutList:{
			by:"ApplicationShortcutListUniqueWhere",
			filter:"ApplicationShortcutListWhere",
			update:"ApplicationShortcutListUpdateInput",
			create:"ApplicationShortcutListCreateInput"
		},
		createApplicationShortcutListItem:{
			data:"ApplicationShortcutListItemCreateInput"
		},
		deleteApplicationShortcutListItem:{
			by:"ApplicationShortcutListItemUniqueWhere",
			filter:"ApplicationShortcutListItemWhere"
		},
		updateApplicationShortcutListItem:{
			by:"ApplicationShortcutListItemUniqueWhere",
			filter:"ApplicationShortcutListItemWhere",
			data:"ApplicationShortcutListItemUpdateInput"
		},
		upsertApplicationShortcutListItem:{
			by:"ApplicationShortcutListItemUniqueWhere",
			filter:"ApplicationShortcutListItemWhere",
			update:"ApplicationShortcutListItemUpdateInput",
			create:"ApplicationShortcutListItemCreateInput"
		},
		createProductBanner:{
			data:"ProductBannerCreateInput"
		},
		deleteProductBanner:{
			by:"ProductBannerUniqueWhere",
			filter:"ProductBannerWhere"
		},
		updateProductBanner:{
			by:"ProductBannerUniqueWhere",
			filter:"ProductBannerWhere",
			data:"ProductBannerUpdateInput"
		},
		upsertProductBanner:{
			by:"ProductBannerUniqueWhere",
			filter:"ProductBannerWhere",
			update:"ProductBannerUpdateInput",
			create:"ProductBannerCreateInput"
		},
		createProductBannerItem:{
			data:"ProductBannerItemCreateInput"
		},
		deleteProductBannerItem:{
			by:"ProductBannerItemUniqueWhere",
			filter:"ProductBannerItemWhere"
		},
		updateProductBannerItem:{
			by:"ProductBannerItemUniqueWhere",
			filter:"ProductBannerItemWhere",
			data:"ProductBannerItemUpdateInput"
		},
		upsertProductBannerItem:{
			by:"ProductBannerItemUniqueWhere",
			filter:"ProductBannerItemWhere",
			update:"ProductBannerItemUpdateInput",
			create:"ProductBannerItemCreateInput"
		},
		createProductBannerList:{
			data:"ProductBannerListCreateInput"
		},
		deleteProductBannerList:{
			by:"ProductBannerListUniqueWhere",
			filter:"ProductBannerListWhere"
		},
		updateProductBannerList:{
			by:"ProductBannerListUniqueWhere",
			filter:"ProductBannerListWhere",
			data:"ProductBannerListUpdateInput"
		},
		upsertProductBannerList:{
			by:"ProductBannerListUniqueWhere",
			filter:"ProductBannerListWhere",
			update:"ProductBannerListUpdateInput",
			create:"ProductBannerListCreateInput"
		},
		createBartender:{
			data:"BartenderCreateInput"
		},
		deleteBartender:{
			by:"BartenderUniqueWhere",
			filter:"BartenderWhere"
		},
		updateBartender:{
			by:"BartenderUniqueWhere",
			filter:"BartenderWhere",
			data:"BartenderUpdateInput"
		},
		upsertBartender:{
			by:"BartenderUniqueWhere",
			filter:"BartenderWhere",
			update:"BartenderUpdateInput",
			create:"BartenderCreateInput"
		},
		createBusinessToBusinessManager:{
			data:"BusinessToBusinessManagerCreateInput"
		},
		deleteBusinessToBusinessManager:{
			by:"BusinessToBusinessManagerUniqueWhere",
			filter:"BusinessToBusinessManagerWhere"
		},
		updateBusinessToBusinessManager:{
			by:"BusinessToBusinessManagerUniqueWhere",
			filter:"BusinessToBusinessManagerWhere",
			data:"BusinessToBusinessManagerUpdateInput"
		},
		upsertBusinessToBusinessManager:{
			by:"BusinessToBusinessManagerUniqueWhere",
			filter:"BusinessToBusinessManagerWhere",
			update:"BusinessToBusinessManagerUpdateInput",
			create:"BusinessToBusinessManagerCreateInput"
		},
		createCleaner:{
			data:"CleanerCreateInput"
		},
		deleteCleaner:{
			by:"CleanerUniqueWhere",
			filter:"CleanerWhere"
		},
		updateCleaner:{
			by:"CleanerUniqueWhere",
			filter:"CleanerWhere",
			data:"CleanerUpdateInput"
		},
		upsertCleaner:{
			by:"CleanerUniqueWhere",
			filter:"CleanerWhere",
			update:"CleanerUpdateInput",
			create:"CleanerCreateInput"
		},
		createCourier:{
			data:"CourierCreateInput"
		},
		deleteCourier:{
			by:"CourierUniqueWhere",
			filter:"CourierWhere"
		},
		updateCourier:{
			by:"CourierUniqueWhere",
			filter:"CourierWhere",
			data:"CourierUpdateInput"
		},
		upsertCourier:{
			by:"CourierUniqueWhere",
			filter:"CourierWhere",
			update:"CourierUpdateInput",
			create:"CourierCreateInput"
		},
		createShiftsManager:{
			data:"ShiftsManagerCreateInput"
		},
		deleteShiftsManager:{
			by:"ShiftsManagerUniqueWhere",
			filter:"ShiftsManagerWhere"
		},
		updateShiftsManager:{
			by:"ShiftsManagerUniqueWhere",
			filter:"ShiftsManagerWhere",
			data:"ShiftsManagerUpdateInput"
		},
		upsertShiftsManager:{
			by:"ShiftsManagerUniqueWhere",
			filter:"ShiftsManagerWhere",
			update:"ShiftsManagerUpdateInput",
			create:"ShiftsManagerCreateInput"
		},
		createUser:{
			data:"UserCreateInput"
		},
		deleteUser:{
			by:"UserUniqueWhere",
			filter:"UserWhere"
		},
		updateUser:{
			by:"UserUniqueWhere",
			filter:"UserWhere",
			data:"UserUpdateInput"
		},
		upsertUser:{
			by:"UserUniqueWhere",
			filter:"UserWhere",
			update:"UserUpdateInput",
			create:"UserCreateInput"
		},
		createShiftsProfile:{
			data:"ShiftsProfileCreateInput"
		},
		deleteShiftsProfile:{
			by:"ShiftsProfileUniqueWhere",
			filter:"ShiftsProfileWhere"
		},
		updateShiftsProfile:{
			by:"ShiftsProfileUniqueWhere",
			filter:"ShiftsProfileWhere",
			data:"ShiftsProfileUpdateInput"
		},
		upsertShiftsProfile:{
			by:"ShiftsProfileUniqueWhere",
			filter:"ShiftsProfileWhere",
			update:"ShiftsProfileUpdateInput",
			create:"ShiftsProfileCreateInput"
		},
		createProductIngredientCategory:{
			data:"ProductIngredientCategoryCreateInput"
		},
		deleteProductIngredientCategory:{
			by:"ProductIngredientCategoryUniqueWhere",
			filter:"ProductIngredientCategoryWhere"
		},
		updateProductIngredientCategory:{
			by:"ProductIngredientCategoryUniqueWhere",
			filter:"ProductIngredientCategoryWhere",
			data:"ProductIngredientCategoryUpdateInput"
		},
		upsertProductIngredientCategory:{
			by:"ProductIngredientCategoryUniqueWhere",
			filter:"ProductIngredientCategoryWhere",
			update:"ProductIngredientCategoryUpdateInput",
			create:"ProductIngredientCategoryCreateInput"
		},
		createProductIngredientCategoryLocale:{
			data:"ProductIngredientCategoryLocaleCreateInput"
		},
		deleteProductIngredientCategoryLocale:{
			by:"ProductIngredientCategoryLocaleUniqueWhere",
			filter:"ProductIngredientCategoryLocaleWhere"
		},
		updateProductIngredientCategoryLocale:{
			by:"ProductIngredientCategoryLocaleUniqueWhere",
			filter:"ProductIngredientCategoryLocaleWhere",
			data:"ProductIngredientCategoryLocaleUpdateInput"
		},
		upsertProductIngredientCategoryLocale:{
			by:"ProductIngredientCategoryLocaleUniqueWhere",
			filter:"ProductIngredientCategoryLocaleWhere",
			update:"ProductIngredientCategoryLocaleUpdateInput",
			create:"ProductIngredientCategoryLocaleCreateInput"
		},
		createStocksManager:{
			data:"StocksManagerCreateInput"
		},
		deleteStocksManager:{
			by:"StocksManagerUniqueWhere",
			filter:"StocksManagerWhere"
		},
		updateStocksManager:{
			by:"StocksManagerUniqueWhere",
			filter:"StocksManagerWhere",
			data:"StocksManagerUpdateInput"
		},
		upsertStocksManager:{
			by:"StocksManagerUniqueWhere",
			filter:"StocksManagerWhere",
			update:"StocksManagerUpdateInput",
			create:"StocksManagerCreateInput"
		},
		createDeliveryRoute:{
			data:"DeliveryRouteCreateInput"
		},
		deleteDeliveryRoute:{
			by:"DeliveryRouteUniqueWhere",
			filter:"DeliveryRouteWhere"
		},
		updateDeliveryRoute:{
			by:"DeliveryRouteUniqueWhere",
			filter:"DeliveryRouteWhere",
			data:"DeliveryRouteUpdateInput"
		},
		upsertDeliveryRoute:{
			by:"DeliveryRouteUniqueWhere",
			filter:"DeliveryRouteWhere",
			update:"DeliveryRouteUpdateInput",
			create:"DeliveryRouteCreateInput"
		},
		createDeliveryWaypoint:{
			data:"DeliveryWaypointCreateInput"
		},
		deleteDeliveryWaypoint:{
			by:"DeliveryWaypointUniqueWhere",
			filter:"DeliveryWaypointWhere"
		},
		updateDeliveryWaypoint:{
			by:"DeliveryWaypointUniqueWhere",
			filter:"DeliveryWaypointWhere",
			data:"DeliveryWaypointUpdateInput"
		},
		upsertDeliveryWaypoint:{
			by:"DeliveryWaypointUniqueWhere",
			filter:"DeliveryWaypointWhere",
			update:"DeliveryWaypointUpdateInput",
			create:"DeliveryWaypointCreateInput"
		},
		createAllergen:{
			data:"AllergenCreateInput"
		},
		deleteAllergen:{
			by:"AllergenUniqueWhere",
			filter:"AllergenWhere"
		},
		updateAllergen:{
			by:"AllergenUniqueWhere",
			filter:"AllergenWhere",
			data:"AllergenUpdateInput"
		},
		upsertAllergen:{
			by:"AllergenUniqueWhere",
			filter:"AllergenWhere",
			update:"AllergenUpdateInput",
			create:"AllergenCreateInput"
		},
		createAllergenLocale:{
			data:"AllergenLocaleCreateInput"
		},
		deleteAllergenLocale:{
			by:"AllergenLocaleUniqueWhere",
			filter:"AllergenLocaleWhere"
		},
		updateAllergenLocale:{
			by:"AllergenLocaleUniqueWhere",
			filter:"AllergenLocaleWhere",
			data:"AllergenLocaleUpdateInput"
		},
		upsertAllergenLocale:{
			by:"AllergenLocaleUniqueWhere",
			filter:"AllergenLocaleWhere",
			update:"AllergenLocaleUpdateInput",
			create:"AllergenLocaleCreateInput"
		},
		createGps:{
			data:"GpsCreateInput"
		},
		deleteGps:{
			by:"GpsUniqueWhere",
			filter:"GpsWhere"
		},
		updateGps:{
			by:"GpsUniqueWhere",
			filter:"GpsWhere",
			data:"GpsUpdateInput"
		},
		upsertGps:{
			by:"GpsUniqueWhere",
			filter:"GpsWhere",
			update:"GpsUpdateInput",
			create:"GpsCreateInput"
		},
		createWeekHours:{
			data:"WeekHoursCreateInput"
		},
		deleteWeekHours:{
			by:"WeekHoursUniqueWhere",
			filter:"WeekHoursWhere"
		},
		updateWeekHours:{
			by:"WeekHoursUniqueWhere",
			filter:"WeekHoursWhere",
			data:"WeekHoursUpdateInput"
		},
		upsertWeekHours:{
			by:"WeekHoursUniqueWhere",
			filter:"WeekHoursWhere",
			update:"WeekHoursUpdateInput",
			create:"WeekHoursCreateInput"
		},
		createPreparedIngredientQuantity:{
			data:"PreparedIngredientQuantityCreateInput"
		},
		deletePreparedIngredientQuantity:{
			by:"PreparedIngredientQuantityUniqueWhere",
			filter:"PreparedIngredientQuantityWhere"
		},
		updatePreparedIngredientQuantity:{
			by:"PreparedIngredientQuantityUniqueWhere",
			filter:"PreparedIngredientQuantityWhere",
			data:"PreparedIngredientQuantityUpdateInput"
		},
		upsertPreparedIngredientQuantity:{
			by:"PreparedIngredientQuantityUniqueWhere",
			filter:"PreparedIngredientQuantityWhere",
			update:"PreparedIngredientQuantityUpdateInput",
			create:"PreparedIngredientQuantityCreateInput"
		},
		createPreparedRecipeQuantity:{
			data:"PreparedRecipeQuantityCreateInput"
		},
		deletePreparedRecipeQuantity:{
			by:"PreparedRecipeQuantityUniqueWhere",
			filter:"PreparedRecipeQuantityWhere"
		},
		updatePreparedRecipeQuantity:{
			by:"PreparedRecipeQuantityUniqueWhere",
			filter:"PreparedRecipeQuantityWhere",
			data:"PreparedRecipeQuantityUpdateInput"
		},
		upsertPreparedRecipeQuantity:{
			by:"PreparedRecipeQuantityUniqueWhere",
			filter:"PreparedRecipeQuantityWhere",
			update:"PreparedRecipeQuantityUpdateInput",
			create:"PreparedRecipeQuantityCreateInput"
		},
		createInternalOrder:{
			data:"InternalOrderCreateInput"
		},
		deleteInternalOrder:{
			by:"InternalOrderUniqueWhere",
			filter:"InternalOrderWhere"
		},
		updateInternalOrder:{
			by:"InternalOrderUniqueWhere",
			filter:"InternalOrderWhere",
			data:"InternalOrderUpdateInput"
		},
		upsertInternalOrder:{
			by:"InternalOrderUniqueWhere",
			filter:"InternalOrderWhere",
			update:"InternalOrderUpdateInput",
			create:"InternalOrderCreateInput"
		},
		createInternalOrderItem:{
			data:"InternalOrderItemCreateInput"
		},
		deleteInternalOrderItem:{
			by:"InternalOrderItemUniqueWhere",
			filter:"InternalOrderItemWhere"
		},
		updateInternalOrderItem:{
			by:"InternalOrderItemUniqueWhere",
			filter:"InternalOrderItemWhere",
			data:"InternalOrderItemUpdateInput"
		},
		upsertInternalOrderItem:{
			by:"InternalOrderItemUniqueWhere",
			filter:"InternalOrderItemWhere",
			update:"InternalOrderItemUpdateInput",
			create:"InternalOrderItemCreateInput"
		},
		createPreparedPackingQuantity:{
			data:"PreparedPackingQuantityCreateInput"
		},
		deletePreparedPackingQuantity:{
			by:"PreparedPackingQuantityUniqueWhere",
			filter:"PreparedPackingQuantityWhere"
		},
		updatePreparedPackingQuantity:{
			by:"PreparedPackingQuantityUniqueWhere",
			filter:"PreparedPackingQuantityWhere",
			data:"PreparedPackingQuantityUpdateInput"
		},
		upsertPreparedPackingQuantity:{
			by:"PreparedPackingQuantityUniqueWhere",
			filter:"PreparedPackingQuantityWhere",
			update:"PreparedPackingQuantityUpdateInput",
			create:"PreparedPackingQuantityCreateInput"
		},
		createCourierManager:{
			data:"CourierManagerCreateInput"
		},
		deleteCourierManager:{
			by:"CourierManagerUniqueWhere",
			filter:"CourierManagerWhere"
		},
		updateCourierManager:{
			by:"CourierManagerUniqueWhere",
			filter:"CourierManagerWhere",
			data:"CourierManagerUpdateInput"
		},
		upsertCourierManager:{
			by:"CourierManagerUniqueWhere",
			filter:"CourierManagerWhere",
			update:"CourierManagerUpdateInput",
			create:"CourierManagerCreateInput"
		},
		createDeliveryZone:{
			data:"DeliveryZoneCreateInput"
		},
		deleteDeliveryZone:{
			by:"DeliveryZoneUniqueWhere",
			filter:"DeliveryZoneWhere"
		},
		updateDeliveryZone:{
			by:"DeliveryZoneUniqueWhere",
			filter:"DeliveryZoneWhere",
			data:"DeliveryZoneUpdateInput"
		},
		upsertDeliveryZone:{
			by:"DeliveryZoneUniqueWhere",
			filter:"DeliveryZoneWhere",
			update:"DeliveryZoneUpdateInput",
			create:"DeliveryZoneCreateInput"
		},
		createDeliveryTimelinePreset:{
			data:"DeliveryTimelinePresetCreateInput"
		},
		deleteDeliveryTimelinePreset:{
			by:"DeliveryTimelinePresetUniqueWhere",
			filter:"DeliveryTimelinePresetWhere"
		},
		updateDeliveryTimelinePreset:{
			by:"DeliveryTimelinePresetUniqueWhere",
			filter:"DeliveryTimelinePresetWhere",
			data:"DeliveryTimelinePresetUpdateInput"
		},
		upsertDeliveryTimelinePreset:{
			by:"DeliveryTimelinePresetUniqueWhere",
			filter:"DeliveryTimelinePresetWhere",
			update:"DeliveryTimelinePresetUpdateInput",
			create:"DeliveryTimelinePresetCreateInput"
		},
		createOrderDeliveryTimeline:{
			data:"OrderDeliveryTimelineCreateInput"
		},
		deleteOrderDeliveryTimeline:{
			by:"OrderDeliveryTimelineUniqueWhere",
			filter:"OrderDeliveryTimelineWhere"
		},
		updateOrderDeliveryTimeline:{
			by:"OrderDeliveryTimelineUniqueWhere",
			filter:"OrderDeliveryTimelineWhere",
			data:"OrderDeliveryTimelineUpdateInput"
		},
		upsertOrderDeliveryTimeline:{
			by:"OrderDeliveryTimelineUniqueWhere",
			filter:"OrderDeliveryTimelineWhere",
			update:"OrderDeliveryTimelineUpdateInput",
			create:"OrderDeliveryTimelineCreateInput"
		},
		createOrderEvent:{
			data:"OrderEventCreateInput"
		},
		deleteOrderEvent:{
			by:"OrderEventUniqueWhere",
			filter:"OrderEventWhere"
		},
		updateOrderEvent:{
			by:"OrderEventUniqueWhere",
			filter:"OrderEventWhere",
			data:"OrderEventUpdateInput"
		},
		upsertOrderEvent:{
			by:"OrderEventUniqueWhere",
			filter:"OrderEventWhere",
			update:"OrderEventUpdateInput",
			create:"OrderEventCreateInput"
		},
		createLiftagoRide:{
			data:"LiftagoRideCreateInput"
		},
		deleteLiftagoRide:{
			by:"LiftagoRideUniqueWhere",
			filter:"LiftagoRideWhere"
		},
		updateLiftagoRide:{
			by:"LiftagoRideUniqueWhere",
			filter:"LiftagoRideWhere",
			data:"LiftagoRideUpdateInput"
		},
		upsertLiftagoRide:{
			by:"LiftagoRideUniqueWhere",
			filter:"LiftagoRideWhere",
			update:"LiftagoRideUpdateInput",
			create:"LiftagoRideCreateInput"
		},
		createInvoice:{
			data:"InvoiceCreateInput"
		},
		deleteInvoice:{
			by:"InvoiceUniqueWhere",
			filter:"InvoiceWhere"
		},
		updateInvoice:{
			by:"InvoiceUniqueWhere",
			filter:"InvoiceWhere",
			data:"InvoiceUpdateInput"
		},
		upsertInvoice:{
			by:"InvoiceUniqueWhere",
			filter:"InvoiceWhere",
			update:"InvoiceUpdateInput",
			create:"InvoiceCreateInput"
		},
		createInvoicingPlan:{
			data:"InvoicingPlanCreateInput"
		},
		deleteInvoicingPlan:{
			by:"InvoicingPlanUniqueWhere",
			filter:"InvoicingPlanWhere"
		},
		updateInvoicingPlan:{
			by:"InvoicingPlanUniqueWhere",
			filter:"InvoicingPlanWhere",
			data:"InvoicingPlanUpdateInput"
		},
		upsertInvoicingPlan:{
			by:"InvoicingPlanUniqueWhere",
			filter:"InvoicingPlanWhere",
			update:"InvoicingPlanUpdateInput",
			create:"InvoicingPlanCreateInput"
		},
		createProductPackingLocale:{
			data:"ProductPackingLocaleCreateInput"
		},
		deleteProductPackingLocale:{
			by:"ProductPackingLocaleUniqueWhere",
			filter:"ProductPackingLocaleWhere"
		},
		updateProductPackingLocale:{
			by:"ProductPackingLocaleUniqueWhere",
			filter:"ProductPackingLocaleWhere",
			data:"ProductPackingLocaleUpdateInput"
		},
		upsertProductPackingLocale:{
			by:"ProductPackingLocaleUniqueWhere",
			filter:"ProductPackingLocaleWhere",
			update:"ProductPackingLocaleUpdateInput",
			create:"ProductPackingLocaleCreateInput"
		},
		createProductLocale:{
			data:"ProductLocaleCreateInput"
		},
		deleteProductLocale:{
			by:"ProductLocaleUniqueWhere",
			filter:"ProductLocaleWhere"
		},
		updateProductLocale:{
			by:"ProductLocaleUniqueWhere",
			filter:"ProductLocaleWhere",
			data:"ProductLocaleUpdateInput"
		},
		upsertProductLocale:{
			by:"ProductLocaleUniqueWhere",
			filter:"ProductLocaleWhere",
			update:"ProductLocaleUpdateInput",
			create:"ProductLocaleCreateInput"
		},
		createProductRecipeLocale:{
			data:"ProductRecipeLocaleCreateInput"
		},
		deleteProductRecipeLocale:{
			by:"ProductRecipeLocaleUniqueWhere",
			filter:"ProductRecipeLocaleWhere"
		},
		updateProductRecipeLocale:{
			by:"ProductRecipeLocaleUniqueWhere",
			filter:"ProductRecipeLocaleWhere",
			data:"ProductRecipeLocaleUpdateInput"
		},
		upsertProductRecipeLocale:{
			by:"ProductRecipeLocaleUniqueWhere",
			filter:"ProductRecipeLocaleWhere",
			update:"ProductRecipeLocaleUpdateInput",
			create:"ProductRecipeLocaleCreateInput"
		},
		createUserDevice:{
			data:"UserDeviceCreateInput"
		},
		deleteUserDevice:{
			by:"UserDeviceUniqueWhere",
			filter:"UserDeviceWhere"
		},
		updateUserDevice:{
			by:"UserDeviceUniqueWhere",
			filter:"UserDeviceWhere",
			data:"UserDeviceUpdateInput"
		},
		upsertUserDevice:{
			by:"UserDeviceUniqueWhere",
			filter:"UserDeviceWhere",
			update:"UserDeviceUpdateInput",
			create:"UserDeviceCreateInput"
		},
		createProtectedAction:{
			data:"ProtectedActionCreateInput"
		},
		deleteProtectedAction:{
			by:"ProtectedActionUniqueWhere",
			filter:"ProtectedActionWhere"
		},
		updateProtectedAction:{
			by:"ProtectedActionUniqueWhere",
			filter:"ProtectedActionWhere",
			data:"ProtectedActionUpdateInput"
		},
		upsertProtectedAction:{
			by:"ProtectedActionUniqueWhere",
			filter:"ProtectedActionWhere",
			update:"ProtectedActionUpdateInput",
			create:"ProtectedActionCreateInput"
		},
		createPicker:{
			data:"PickerCreateInput"
		},
		deletePicker:{
			by:"PickerUniqueWhere",
			filter:"PickerWhere"
		},
		updatePicker:{
			by:"PickerUniqueWhere",
			filter:"PickerWhere",
			data:"PickerUpdateInput"
		},
		upsertPicker:{
			by:"PickerUniqueWhere",
			filter:"PickerWhere",
			update:"PickerUpdateInput",
			create:"PickerCreateInput"
		},
		createTimetableTemplateStaffOptions:{
			data:"TimetableTemplateStaffOptionsCreateInput"
		},
		deleteTimetableTemplateStaffOptions:{
			by:"TimetableTemplateStaffOptionsUniqueWhere",
			filter:"TimetableTemplateStaffOptionsWhere"
		},
		updateTimetableTemplateStaffOptions:{
			by:"TimetableTemplateStaffOptionsUniqueWhere",
			filter:"TimetableTemplateStaffOptionsWhere",
			data:"TimetableTemplateStaffOptionsUpdateInput"
		},
		upsertTimetableTemplateStaffOptions:{
			by:"TimetableTemplateStaffOptionsUniqueWhere",
			filter:"TimetableTemplateStaffOptionsWhere",
			update:"TimetableTemplateStaffOptionsUpdateInput",
			create:"TimetableTemplateStaffOptionsCreateInput"
		},
		createShoppingList:{
			data:"ShoppingListCreateInput"
		},
		deleteShoppingList:{
			by:"ShoppingListUniqueWhere",
			filter:"ShoppingListWhere"
		},
		updateShoppingList:{
			by:"ShoppingListUniqueWhere",
			filter:"ShoppingListWhere",
			data:"ShoppingListUpdateInput"
		},
		upsertShoppingList:{
			by:"ShoppingListUniqueWhere",
			filter:"ShoppingListWhere",
			update:"ShoppingListUpdateInput",
			create:"ShoppingListCreateInput"
		},
		createSuppliesPurchase:{
			data:"SuppliesPurchaseCreateInput"
		},
		deleteSuppliesPurchase:{
			by:"SuppliesPurchaseUniqueWhere",
			filter:"SuppliesPurchaseWhere"
		},
		updateSuppliesPurchase:{
			by:"SuppliesPurchaseUniqueWhere",
			filter:"SuppliesPurchaseWhere",
			data:"SuppliesPurchaseUpdateInput"
		},
		upsertSuppliesPurchase:{
			by:"SuppliesPurchaseUniqueWhere",
			filter:"SuppliesPurchaseWhere",
			update:"SuppliesPurchaseUpdateInput",
			create:"SuppliesPurchaseCreateInput"
		},
		createInvoicingPreset:{
			data:"InvoicingPresetCreateInput"
		},
		deleteInvoicingPreset:{
			by:"InvoicingPresetUniqueWhere",
			filter:"InvoicingPresetWhere"
		},
		updateInvoicingPreset:{
			by:"InvoicingPresetUniqueWhere",
			filter:"InvoicingPresetWhere",
			data:"InvoicingPresetUpdateInput"
		},
		upsertInvoicingPreset:{
			by:"InvoicingPresetUniqueWhere",
			filter:"InvoicingPresetWhere",
			update:"InvoicingPresetUpdateInput",
			create:"InvoicingPresetCreateInput"
		},
		createLogRecord:{
			data:"LogRecordCreateInput"
		},
		deleteLogRecord:{
			by:"LogRecordUniqueWhere",
			filter:"LogRecordWhere"
		},
		updateLogRecord:{
			by:"LogRecordUniqueWhere",
			filter:"LogRecordWhere",
			data:"LogRecordUpdateInput"
		},
		upsertLogRecord:{
			by:"LogRecordUniqueWhere",
			filter:"LogRecordWhere",
			update:"LogRecordUpdateInput",
			create:"LogRecordCreateInput"
		},
		createBillingSubject:{
			data:"BillingSubjectCreateInput"
		},
		deleteBillingSubject:{
			by:"BillingSubjectUniqueWhere",
			filter:"BillingSubjectWhere"
		},
		updateBillingSubject:{
			by:"BillingSubjectUniqueWhere",
			filter:"BillingSubjectWhere",
			data:"BillingSubjectUpdateInput"
		},
		upsertBillingSubject:{
			by:"BillingSubjectUniqueWhere",
			filter:"BillingSubjectWhere",
			update:"BillingSubjectUpdateInput",
			create:"BillingSubjectCreateInput"
		},
		createShoppingListItem:{
			data:"ShoppingListItemCreateInput"
		},
		deleteShoppingListItem:{
			by:"ShoppingListItemUniqueWhere",
			filter:"ShoppingListItemWhere"
		},
		updateShoppingListItem:{
			by:"ShoppingListItemUniqueWhere",
			filter:"ShoppingListItemWhere",
			data:"ShoppingListItemUpdateInput"
		},
		upsertShoppingListItem:{
			by:"ShoppingListItemUniqueWhere",
			filter:"ShoppingListItemWhere",
			update:"ShoppingListItemUpdateInput",
			create:"ShoppingListItemCreateInput"
		},
		createSuppliesPurchaseItem:{
			data:"SuppliesPurchaseItemCreateInput"
		},
		deleteSuppliesPurchaseItem:{
			by:"SuppliesPurchaseItemUniqueWhere",
			filter:"SuppliesPurchaseItemWhere"
		},
		updateSuppliesPurchaseItem:{
			by:"SuppliesPurchaseItemUniqueWhere",
			filter:"SuppliesPurchaseItemWhere",
			data:"SuppliesPurchaseItemUpdateInput"
		},
		upsertSuppliesPurchaseItem:{
			by:"SuppliesPurchaseItemUniqueWhere",
			filter:"SuppliesPurchaseItemWhere",
			update:"SuppliesPurchaseItemUpdateInput",
			create:"SuppliesPurchaseItemCreateInput"
		},
		createCustomerCreditTransaction:{
			data:"CustomerCreditTransactionCreateInput"
		},
		deleteCustomerCreditTransaction:{
			by:"CustomerCreditTransactionUniqueWhere",
			filter:"CustomerCreditTransactionWhere"
		},
		updateCustomerCreditTransaction:{
			by:"CustomerCreditTransactionUniqueWhere",
			filter:"CustomerCreditTransactionWhere",
			data:"CustomerCreditTransactionUpdateInput"
		},
		upsertCustomerCreditTransaction:{
			by:"CustomerCreditTransactionUniqueWhere",
			filter:"CustomerCreditTransactionWhere",
			update:"CustomerCreditTransactionUpdateInput",
			create:"CustomerCreditTransactionCreateInput"
		},
		createVirtualProduct:{
			data:"VirtualProductCreateInput"
		},
		deleteVirtualProduct:{
			by:"VirtualProductUniqueWhere",
			filter:"VirtualProductWhere"
		},
		updateVirtualProduct:{
			by:"VirtualProductUniqueWhere",
			filter:"VirtualProductWhere",
			data:"VirtualProductUpdateInput"
		},
		upsertVirtualProduct:{
			by:"VirtualProductUniqueWhere",
			filter:"VirtualProductWhere",
			update:"VirtualProductUpdateInput",
			create:"VirtualProductCreateInput"
		},
		createVirtualProductEffect:{
			data:"VirtualProductEffectCreateInput"
		},
		deleteVirtualProductEffect:{
			by:"VirtualProductEffectUniqueWhere",
			filter:"VirtualProductEffectWhere"
		},
		updateVirtualProductEffect:{
			by:"VirtualProductEffectUniqueWhere",
			filter:"VirtualProductEffectWhere",
			data:"VirtualProductEffectUpdateInput"
		},
		upsertVirtualProductEffect:{
			by:"VirtualProductEffectUniqueWhere",
			filter:"VirtualProductEffectWhere",
			update:"VirtualProductEffectUpdateInput",
			create:"VirtualProductEffectCreateInput"
		},
		createEmploymentInformation:{
			data:"EmploymentInformationCreateInput"
		},
		deleteEmploymentInformation:{
			by:"EmploymentInformationUniqueWhere",
			filter:"EmploymentInformationWhere"
		},
		updateEmploymentInformation:{
			by:"EmploymentInformationUniqueWhere",
			filter:"EmploymentInformationWhere",
			data:"EmploymentInformationUpdateInput"
		},
		upsertEmploymentInformation:{
			by:"EmploymentInformationUniqueWhere",
			filter:"EmploymentInformationWhere",
			update:"EmploymentInformationUpdateInput",
			create:"EmploymentInformationCreateInput"
		},
		createRemunerationProfile:{
			data:"RemunerationProfileCreateInput"
		},
		deleteRemunerationProfile:{
			by:"RemunerationProfileUniqueWhere",
			filter:"RemunerationProfileWhere"
		},
		updateRemunerationProfile:{
			by:"RemunerationProfileUniqueWhere",
			filter:"RemunerationProfileWhere",
			data:"RemunerationProfileUpdateInput"
		},
		upsertRemunerationProfile:{
			by:"RemunerationProfileUniqueWhere",
			filter:"RemunerationProfileWhere",
			update:"RemunerationProfileUpdateInput",
			create:"RemunerationProfileCreateInput"
		},
		createWorkMonth:{
			data:"WorkMonthCreateInput"
		},
		deleteWorkMonth:{
			by:"WorkMonthUniqueWhere",
			filter:"WorkMonthWhere"
		},
		updateWorkMonth:{
			by:"WorkMonthUniqueWhere",
			filter:"WorkMonthWhere",
			data:"WorkMonthUpdateInput"
		},
		upsertWorkMonth:{
			by:"WorkMonthUniqueWhere",
			filter:"WorkMonthWhere",
			update:"WorkMonthUpdateInput",
			create:"WorkMonthCreateInput"
		},
		createSalaryOptions:{
			data:"SalaryOptionsCreateInput"
		},
		deleteSalaryOptions:{
			by:"SalaryOptionsUniqueWhere",
			filter:"SalaryOptionsWhere"
		},
		updateSalaryOptions:{
			by:"SalaryOptionsUniqueWhere",
			filter:"SalaryOptionsWhere",
			data:"SalaryOptionsUpdateInput"
		},
		upsertSalaryOptions:{
			by:"SalaryOptionsUniqueWhere",
			filter:"SalaryOptionsWhere",
			update:"SalaryOptionsUpdateInput",
			create:"SalaryOptionsCreateInput"
		},
		createTimetableShiftSwapInfo:{
			data:"TimetableShiftSwapInfoCreateInput"
		},
		deleteTimetableShiftSwapInfo:{
			by:"TimetableShiftSwapInfoUniqueWhere",
			filter:"TimetableShiftSwapInfoWhere"
		},
		updateTimetableShiftSwapInfo:{
			by:"TimetableShiftSwapInfoUniqueWhere",
			filter:"TimetableShiftSwapInfoWhere",
			data:"TimetableShiftSwapInfoUpdateInput"
		},
		upsertTimetableShiftSwapInfo:{
			by:"TimetableShiftSwapInfoUniqueWhere",
			filter:"TimetableShiftSwapInfoWhere",
			update:"TimetableShiftSwapInfoUpdateInput",
			create:"TimetableShiftSwapInfoCreateInput"
		},
		createProductGridCategory:{
			data:"ProductGridCategoryCreateInput"
		},
		deleteProductGridCategory:{
			by:"ProductGridCategoryUniqueWhere",
			filter:"ProductGridCategoryWhere"
		},
		updateProductGridCategory:{
			by:"ProductGridCategoryUniqueWhere",
			filter:"ProductGridCategoryWhere",
			data:"ProductGridCategoryUpdateInput"
		},
		upsertProductGridCategory:{
			by:"ProductGridCategoryUniqueWhere",
			filter:"ProductGridCategoryWhere",
			update:"ProductGridCategoryUpdateInput",
			create:"ProductGridCategoryCreateInput"
		},
		createCashier:{
			data:"CashierCreateInput"
		},
		deleteCashier:{
			by:"CashierUniqueWhere",
			filter:"CashierWhere"
		},
		updateCashier:{
			by:"CashierUniqueWhere",
			filter:"CashierWhere",
			data:"CashierUpdateInput"
		},
		upsertCashier:{
			by:"CashierUniqueWhere",
			filter:"CashierWhere",
			update:"CashierUpdateInput",
			create:"CashierCreateInput"
		},
		createPointOfSaleCategory:{
			data:"PointOfSaleCategoryCreateInput"
		},
		deletePointOfSaleCategory:{
			by:"PointOfSaleCategoryUniqueWhere",
			filter:"PointOfSaleCategoryWhere"
		},
		updatePointOfSaleCategory:{
			by:"PointOfSaleCategoryUniqueWhere",
			filter:"PointOfSaleCategoryWhere",
			data:"PointOfSaleCategoryUpdateInput"
		},
		upsertPointOfSaleCategory:{
			by:"PointOfSaleCategoryUniqueWhere",
			filter:"PointOfSaleCategoryWhere",
			update:"PointOfSaleCategoryUpdateInput",
			create:"PointOfSaleCategoryCreateInput"
		},
		createPointOfSaleCategoryLocale:{
			data:"PointOfSaleCategoryLocaleCreateInput"
		},
		deletePointOfSaleCategoryLocale:{
			by:"PointOfSaleCategoryLocaleUniqueWhere",
			filter:"PointOfSaleCategoryLocaleWhere"
		},
		updatePointOfSaleCategoryLocale:{
			by:"PointOfSaleCategoryLocaleUniqueWhere",
			filter:"PointOfSaleCategoryLocaleWhere",
			data:"PointOfSaleCategoryLocaleUpdateInput"
		},
		upsertPointOfSaleCategoryLocale:{
			by:"PointOfSaleCategoryLocaleUniqueWhere",
			filter:"PointOfSaleCategoryLocaleWhere",
			update:"PointOfSaleCategoryLocaleUpdateInput",
			create:"PointOfSaleCategoryLocaleCreateInput"
		},
		createPointOfSaleCategoryProduct:{
			data:"PointOfSaleCategoryProductCreateInput"
		},
		deletePointOfSaleCategoryProduct:{
			by:"PointOfSaleCategoryProductUniqueWhere",
			filter:"PointOfSaleCategoryProductWhere"
		},
		updatePointOfSaleCategoryProduct:{
			by:"PointOfSaleCategoryProductUniqueWhere",
			filter:"PointOfSaleCategoryProductWhere",
			data:"PointOfSaleCategoryProductUpdateInput"
		},
		upsertPointOfSaleCategoryProduct:{
			by:"PointOfSaleCategoryProductUniqueWhere",
			filter:"PointOfSaleCategoryProductWhere",
			update:"PointOfSaleCategoryProductUpdateInput",
			create:"PointOfSaleCategoryProductCreateInput"
		},
		createPointOfSaleCategoryProductLocale:{
			data:"PointOfSaleCategoryProductLocaleCreateInput"
		},
		deletePointOfSaleCategoryProductLocale:{
			by:"PointOfSaleCategoryProductLocaleUniqueWhere",
			filter:"PointOfSaleCategoryProductLocaleWhere"
		},
		updatePointOfSaleCategoryProductLocale:{
			by:"PointOfSaleCategoryProductLocaleUniqueWhere",
			filter:"PointOfSaleCategoryProductLocaleWhere",
			data:"PointOfSaleCategoryProductLocaleUpdateInput"
		},
		upsertPointOfSaleCategoryProductLocale:{
			by:"PointOfSaleCategoryProductLocaleUniqueWhere",
			filter:"PointOfSaleCategoryProductLocaleWhere",
			update:"PointOfSaleCategoryProductLocaleUpdateInput",
			create:"PointOfSaleCategoryProductLocaleCreateInput"
		},
		createCustomerTab:{
			data:"CustomerTabCreateInput"
		},
		deleteCustomerTab:{
			by:"CustomerTabUniqueWhere",
			filter:"CustomerTabWhere"
		},
		updateCustomerTab:{
			by:"CustomerTabUniqueWhere",
			filter:"CustomerTabWhere",
			data:"CustomerTabUpdateInput"
		},
		upsertCustomerTab:{
			by:"CustomerTabUniqueWhere",
			filter:"CustomerTabWhere",
			update:"CustomerTabUpdateInput",
			create:"CustomerTabCreateInput"
		},
		createCustomerTabItem:{
			data:"CustomerTabItemCreateInput"
		},
		deleteCustomerTabItem:{
			by:"CustomerTabItemUniqueWhere",
			filter:"CustomerTabItemWhere"
		},
		updateCustomerTabItem:{
			by:"CustomerTabItemUniqueWhere",
			filter:"CustomerTabItemWhere",
			data:"CustomerTabItemUpdateInput"
		},
		upsertCustomerTabItem:{
			by:"CustomerTabItemUniqueWhere",
			filter:"CustomerTabItemWhere",
			update:"CustomerTabItemUpdateInput",
			create:"CustomerTabItemCreateInput"
		},
		createAnonymousSession:{
			data:"AnonymousSessionCreateInput"
		},
		deleteAnonymousSession:{
			by:"AnonymousSessionUniqueWhere",
			filter:"AnonymousSessionWhere"
		},
		updateAnonymousSession:{
			by:"AnonymousSessionUniqueWhere",
			filter:"AnonymousSessionWhere",
			data:"AnonymousSessionUpdateInput"
		},
		upsertAnonymousSession:{
			by:"AnonymousSessionUniqueWhere",
			filter:"AnonymousSessionWhere",
			update:"AnonymousSessionUpdateInput",
			create:"AnonymousSessionCreateInput"
		},
		createVoucher:{
			data:"VoucherCreateInput"
		},
		deleteVoucher:{
			by:"VoucherUniqueWhere",
			filter:"VoucherWhere"
		},
		updateVoucher:{
			by:"VoucherUniqueWhere",
			filter:"VoucherWhere",
			data:"VoucherUpdateInput"
		},
		upsertVoucher:{
			by:"VoucherUniqueWhere",
			filter:"VoucherWhere",
			update:"VoucherUpdateInput",
			create:"VoucherCreateInput"
		},
		createVoucherRedemption:{
			data:"VoucherRedemptionCreateInput"
		},
		deleteVoucherRedemption:{
			by:"VoucherRedemptionUniqueWhere",
			filter:"VoucherRedemptionWhere"
		},
		updateVoucherRedemption:{
			by:"VoucherRedemptionUniqueWhere",
			filter:"VoucherRedemptionWhere",
			data:"VoucherRedemptionUpdateInput"
		},
		upsertVoucherRedemption:{
			by:"VoucherRedemptionUniqueWhere",
			filter:"VoucherRedemptionWhere",
			update:"VoucherRedemptionUpdateInput",
			create:"VoucherRedemptionCreateInput"
		},
		createUnassignedShiftInfo:{
			data:"UnassignedShiftInfoCreateInput"
		},
		deleteUnassignedShiftInfo:{
			by:"UnassignedShiftInfoUniqueWhere",
			filter:"UnassignedShiftInfoWhere"
		},
		updateUnassignedShiftInfo:{
			by:"UnassignedShiftInfoUniqueWhere",
			filter:"UnassignedShiftInfoWhere",
			data:"UnassignedShiftInfoUpdateInput"
		},
		upsertUnassignedShiftInfo:{
			by:"UnassignedShiftInfoUniqueWhere",
			filter:"UnassignedShiftInfoWhere",
			update:"UnassignedShiftInfoUpdateInput",
			create:"UnassignedShiftInfoCreateInput"
		},
		createFreshingContainer:{
			data:"FreshingContainerCreateInput"
		},
		deleteFreshingContainer:{
			by:"FreshingContainerUniqueWhere",
			filter:"FreshingContainerWhere"
		},
		updateFreshingContainer:{
			by:"FreshingContainerUniqueWhere",
			filter:"FreshingContainerWhere",
			data:"FreshingContainerUpdateInput"
		},
		upsertFreshingContainer:{
			by:"FreshingContainerUniqueWhere",
			filter:"FreshingContainerWhere",
			update:"FreshingContainerUpdateInput",
			create:"FreshingContainerCreateInput"
		},
		createTextItem:{
			data:"TextItemCreateInput"
		},
		deleteTextItem:{
			by:"TextItemUniqueWhere",
			filter:"TextItemWhere"
		},
		updateTextItem:{
			by:"TextItemUniqueWhere",
			filter:"TextItemWhere",
			data:"TextItemUpdateInput"
		},
		upsertTextItem:{
			by:"TextItemUniqueWhere",
			filter:"TextItemWhere",
			update:"TextItemUpdateInput",
			create:"TextItemCreateInput"
		},
		createTextList:{
			data:"TextListCreateInput"
		},
		deleteTextList:{
			by:"TextListUniqueWhere",
			filter:"TextListWhere"
		},
		updateTextList:{
			by:"TextListUniqueWhere",
			filter:"TextListWhere",
			data:"TextListUpdateInput"
		},
		upsertTextList:{
			by:"TextListUniqueWhere",
			filter:"TextListWhere",
			update:"TextListUpdateInput",
			create:"TextListCreateInput"
		},
		createDeliveryRegions:{
			data:"DeliveryRegionsCreateInput"
		},
		deleteDeliveryRegions:{
			by:"DeliveryRegionsUniqueWhere",
			filter:"DeliveryRegionsWhere"
		},
		updateDeliveryRegions:{
			by:"DeliveryRegionsUniqueWhere",
			filter:"DeliveryRegionsWhere",
			data:"DeliveryRegionsUpdateInput"
		},
		upsertDeliveryRegions:{
			by:"DeliveryRegionsUniqueWhere",
			filter:"DeliveryRegionsWhere",
			update:"DeliveryRegionsUpdateInput",
			create:"DeliveryRegionsCreateInput"
		},
		createDeliveryRegionsItem:{
			data:"DeliveryRegionsItemCreateInput"
		},
		deleteDeliveryRegionsItem:{
			by:"DeliveryRegionsItemUniqueWhere",
			filter:"DeliveryRegionsItemWhere"
		},
		updateDeliveryRegionsItem:{
			by:"DeliveryRegionsItemUniqueWhere",
			filter:"DeliveryRegionsItemWhere",
			data:"DeliveryRegionsItemUpdateInput"
		},
		upsertDeliveryRegionsItem:{
			by:"DeliveryRegionsItemUniqueWhere",
			filter:"DeliveryRegionsItemWhere",
			update:"DeliveryRegionsItemUpdateInput",
			create:"DeliveryRegionsItemCreateInput"
		},
		createImageList:{
			data:"ImageListCreateInput"
		},
		deleteImageList:{
			by:"ImageListUniqueWhere",
			filter:"ImageListWhere"
		},
		updateImageList:{
			by:"ImageListUniqueWhere",
			filter:"ImageListWhere",
			data:"ImageListUpdateInput"
		},
		upsertImageList:{
			by:"ImageListUniqueWhere",
			filter:"ImageListWhere",
			update:"ImageListUpdateInput",
			create:"ImageListCreateInput"
		},
		createImageListItem:{
			data:"ImageListItemCreateInput"
		},
		deleteImageListItem:{
			by:"ImageListItemUniqueWhere",
			filter:"ImageListItemWhere"
		},
		updateImageListItem:{
			by:"ImageListItemUniqueWhere",
			filter:"ImageListItemWhere",
			data:"ImageListItemUpdateInput"
		},
		upsertImageListItem:{
			by:"ImageListItemUniqueWhere",
			filter:"ImageListItemWhere",
			update:"ImageListItemUpdateInput",
			create:"ImageListItemCreateInput"
		},
		createTimetablesEmployeePrivileges:{
			data:"TimetablesEmployeePrivilegesCreateInput"
		},
		deleteTimetablesEmployeePrivileges:{
			by:"TimetablesEmployeePrivilegesUniqueWhere",
			filter:"TimetablesEmployeePrivilegesWhere"
		},
		updateTimetablesEmployeePrivileges:{
			by:"TimetablesEmployeePrivilegesUniqueWhere",
			filter:"TimetablesEmployeePrivilegesWhere",
			data:"TimetablesEmployeePrivilegesUpdateInput"
		},
		upsertTimetablesEmployeePrivileges:{
			by:"TimetablesEmployeePrivilegesUniqueWhere",
			filter:"TimetablesEmployeePrivilegesWhere",
			update:"TimetablesEmployeePrivilegesUpdateInput",
			create:"TimetablesEmployeePrivilegesCreateInput"
		},
		createTimetableDayNote:{
			data:"TimetableDayNoteCreateInput"
		},
		deleteTimetableDayNote:{
			by:"TimetableDayNoteUniqueWhere",
			filter:"TimetableDayNoteWhere"
		},
		updateTimetableDayNote:{
			by:"TimetableDayNoteUniqueWhere",
			filter:"TimetableDayNoteWhere",
			data:"TimetableDayNoteUpdateInput"
		},
		upsertTimetableDayNote:{
			by:"TimetableDayNoteUniqueWhere",
			filter:"TimetableDayNoteWhere",
			update:"TimetableDayNoteUpdateInput",
			create:"TimetableDayNoteCreateInput"
		},
		createDeliveryMethodLocale:{
			data:"DeliveryMethodLocaleCreateInput"
		},
		deleteDeliveryMethodLocale:{
			by:"DeliveryMethodLocaleUniqueWhere",
			filter:"DeliveryMethodLocaleWhere"
		},
		updateDeliveryMethodLocale:{
			by:"DeliveryMethodLocaleUniqueWhere",
			filter:"DeliveryMethodLocaleWhere",
			data:"DeliveryMethodLocaleUpdateInput"
		},
		upsertDeliveryMethodLocale:{
			by:"DeliveryMethodLocaleUniqueWhere",
			filter:"DeliveryMethodLocaleWhere",
			update:"DeliveryMethodLocaleUpdateInput",
			create:"DeliveryMethodLocaleCreateInput"
		},
		createIngredientSupplier:{
			data:"IngredientSupplierCreateInput"
		},
		deleteIngredientSupplier:{
			by:"IngredientSupplierUniqueWhere",
			filter:"IngredientSupplierWhere"
		},
		updateIngredientSupplier:{
			by:"IngredientSupplierUniqueWhere",
			filter:"IngredientSupplierWhere",
			data:"IngredientSupplierUpdateInput"
		},
		upsertIngredientSupplier:{
			by:"IngredientSupplierUniqueWhere",
			filter:"IngredientSupplierWhere",
			update:"IngredientSupplierUpdateInput",
			create:"IngredientSupplierCreateInput"
		},
		createIngredientSupplierItem:{
			data:"IngredientSupplierItemCreateInput"
		},
		deleteIngredientSupplierItem:{
			by:"IngredientSupplierItemUniqueWhere",
			filter:"IngredientSupplierItemWhere"
		},
		updateIngredientSupplierItem:{
			by:"IngredientSupplierItemUniqueWhere",
			filter:"IngredientSupplierItemWhere",
			data:"IngredientSupplierItemUpdateInput"
		},
		upsertIngredientSupplierItem:{
			by:"IngredientSupplierItemUniqueWhere",
			filter:"IngredientSupplierItemWhere",
			update:"IngredientSupplierItemUpdateInput",
			create:"IngredientSupplierItemCreateInput"
		},
		createIngredientSupplierList:{
			data:"IngredientSupplierListCreateInput"
		},
		deleteIngredientSupplierList:{
			by:"IngredientSupplierListUniqueWhere",
			filter:"IngredientSupplierListWhere"
		},
		updateIngredientSupplierList:{
			by:"IngredientSupplierListUniqueWhere",
			filter:"IngredientSupplierListWhere",
			data:"IngredientSupplierListUpdateInput"
		},
		upsertIngredientSupplierList:{
			by:"IngredientSupplierListUniqueWhere",
			filter:"IngredientSupplierListWhere",
			update:"IngredientSupplierListUpdateInput",
			create:"IngredientSupplierListCreateInput"
		},
		createIngredientSupplierLocale:{
			data:"IngredientSupplierLocaleCreateInput"
		},
		deleteIngredientSupplierLocale:{
			by:"IngredientSupplierLocaleUniqueWhere",
			filter:"IngredientSupplierLocaleWhere"
		},
		updateIngredientSupplierLocale:{
			by:"IngredientSupplierLocaleUniqueWhere",
			filter:"IngredientSupplierLocaleWhere",
			data:"IngredientSupplierLocaleUpdateInput"
		},
		upsertIngredientSupplierLocale:{
			by:"IngredientSupplierLocaleUniqueWhere",
			filter:"IngredientSupplierLocaleWhere",
			update:"IngredientSupplierLocaleUpdateInput",
			create:"IngredientSupplierLocaleCreateInput"
		},
		createRedirect:{
			data:"RedirectCreateInput"
		},
		deleteRedirect:{
			by:"RedirectUniqueWhere",
			filter:"RedirectWhere"
		},
		updateRedirect:{
			by:"RedirectUniqueWhere",
			filter:"RedirectWhere",
			data:"RedirectUpdateInput"
		},
		upsertRedirect:{
			by:"RedirectUniqueWhere",
			filter:"RedirectWhere",
			update:"RedirectUpdateInput",
			create:"RedirectCreateInput"
		},
		createNutritionFacts:{
			data:"NutritionFactsCreateInput"
		},
		deleteNutritionFacts:{
			by:"NutritionFactsUniqueWhere",
			filter:"NutritionFactsWhere"
		},
		updateNutritionFacts:{
			by:"NutritionFactsUniqueWhere",
			filter:"NutritionFactsWhere",
			data:"NutritionFactsUpdateInput"
		},
		upsertNutritionFacts:{
			by:"NutritionFactsUniqueWhere",
			filter:"NutritionFactsWhere",
			update:"NutritionFactsUpdateInput",
			create:"NutritionFactsCreateInput"
		},
		createVenue:{
			data:"VenueCreateInput"
		},
		deleteVenue:{
			by:"VenueUniqueWhere",
			filter:"VenueWhere"
		},
		updateVenue:{
			by:"VenueUniqueWhere",
			filter:"VenueWhere",
			data:"VenueUpdateInput"
		},
		upsertVenue:{
			by:"VenueUniqueWhere",
			filter:"VenueWhere",
			update:"VenueUpdateInput",
			create:"VenueCreateInput"
		},
		createWorkspace:{
			data:"WorkspaceCreateInput"
		},
		deleteWorkspace:{
			by:"WorkspaceUniqueWhere",
			filter:"WorkspaceWhere"
		},
		updateWorkspace:{
			by:"WorkspaceUniqueWhere",
			filter:"WorkspaceWhere",
			data:"WorkspaceUpdateInput"
		},
		upsertWorkspace:{
			by:"WorkspaceUniqueWhere",
			filter:"WorkspaceWhere",
			update:"WorkspaceUpdateInput",
			create:"WorkspaceCreateInput"
		},
		createInternalBuyer:{
			data:"InternalBuyerCreateInput"
		},
		deleteInternalBuyer:{
			by:"InternalBuyerUniqueWhere",
			filter:"InternalBuyerWhere"
		},
		updateInternalBuyer:{
			by:"InternalBuyerUniqueWhere",
			filter:"InternalBuyerWhere",
			data:"InternalBuyerUpdateInput"
		},
		upsertInternalBuyer:{
			by:"InternalBuyerUniqueWhere",
			filter:"InternalBuyerWhere",
			update:"InternalBuyerUpdateInput",
			create:"InternalBuyerCreateInput"
		},
		createVenueEmployeeRole:{
			data:"VenueEmployeeRoleCreateInput"
		},
		deleteVenueEmployeeRole:{
			by:"VenueEmployeeRoleUniqueWhere",
			filter:"VenueEmployeeRoleWhere"
		},
		updateVenueEmployeeRole:{
			by:"VenueEmployeeRoleUniqueWhere",
			filter:"VenueEmployeeRoleWhere",
			data:"VenueEmployeeRoleUpdateInput"
		},
		upsertVenueEmployeeRole:{
			by:"VenueEmployeeRoleUniqueWhere",
			filter:"VenueEmployeeRoleWhere",
			update:"VenueEmployeeRoleUpdateInput",
			create:"VenueEmployeeRoleCreateInput"
		},
		createIdentificationAttempt:{
			data:"IdentificationAttemptCreateInput"
		},
		deleteIdentificationAttempt:{
			by:"IdentificationAttemptUniqueWhere",
			filter:"IdentificationAttemptWhere"
		},
		updateIdentificationAttempt:{
			by:"IdentificationAttemptUniqueWhere",
			filter:"IdentificationAttemptWhere",
			data:"IdentificationAttemptUpdateInput"
		},
		upsertIdentificationAttempt:{
			by:"IdentificationAttemptUniqueWhere",
			filter:"IdentificationAttemptWhere",
			update:"IdentificationAttemptUpdateInput",
			create:"IdentificationAttemptCreateInput"
		},
		createIdentificationCode:{
			data:"IdentificationCodeCreateInput"
		},
		deleteIdentificationCode:{
			by:"IdentificationCodeUniqueWhere",
			filter:"IdentificationCodeWhere"
		},
		updateIdentificationCode:{
			by:"IdentificationCodeUniqueWhere",
			filter:"IdentificationCodeWhere",
			data:"IdentificationCodeUpdateInput"
		},
		upsertIdentificationCode:{
			by:"IdentificationCodeUniqueWhere",
			filter:"IdentificationCodeWhere",
			update:"IdentificationCodeUpdateInput",
			create:"IdentificationCodeCreateInput"
		},
		createIdentificationCodeLocale:{
			data:"IdentificationCodeLocaleCreateInput"
		},
		deleteIdentificationCodeLocale:{
			by:"IdentificationCodeLocaleUniqueWhere",
			filter:"IdentificationCodeLocaleWhere"
		},
		updateIdentificationCodeLocale:{
			by:"IdentificationCodeLocaleUniqueWhere",
			filter:"IdentificationCodeLocaleWhere",
			data:"IdentificationCodeLocaleUpdateInput"
		},
		upsertIdentificationCodeLocale:{
			by:"IdentificationCodeLocaleUniqueWhere",
			filter:"IdentificationCodeLocaleWhere",
			update:"IdentificationCodeLocaleUpdateInput",
			create:"IdentificationCodeLocaleCreateInput"
		},
		createPipeline:{
			data:"PipelineCreateInput"
		},
		deletePipeline:{
			by:"PipelineUniqueWhere",
			filter:"PipelineWhere"
		},
		updatePipeline:{
			by:"PipelineUniqueWhere",
			filter:"PipelineWhere",
			data:"PipelineUpdateInput"
		},
		upsertPipeline:{
			by:"PipelineUniqueWhere",
			filter:"PipelineWhere",
			update:"PipelineUpdateInput",
			create:"PipelineCreateInput"
		},
		createPipelineLead:{
			data:"PipelineLeadCreateInput"
		},
		deletePipelineLead:{
			by:"PipelineLeadUniqueWhere",
			filter:"PipelineLeadWhere"
		},
		updatePipelineLead:{
			by:"PipelineLeadUniqueWhere",
			filter:"PipelineLeadWhere",
			data:"PipelineLeadUpdateInput"
		},
		upsertPipelineLead:{
			by:"PipelineLeadUniqueWhere",
			filter:"PipelineLeadWhere",
			update:"PipelineLeadUpdateInput",
			create:"PipelineLeadCreateInput"
		},
		createPipelineStage:{
			data:"PipelineStageCreateInput"
		},
		deletePipelineStage:{
			by:"PipelineStageUniqueWhere",
			filter:"PipelineStageWhere"
		},
		updatePipelineStage:{
			by:"PipelineStageUniqueWhere",
			filter:"PipelineStageWhere",
			data:"PipelineStageUpdateInput"
		},
		upsertPipelineStage:{
			by:"PipelineStageUniqueWhere",
			filter:"PipelineStageWhere",
			update:"PipelineStageUpdateInput",
			create:"PipelineStageCreateInput"
		},
		createPipelineStageItem:{
			data:"PipelineStageItemCreateInput"
		},
		deletePipelineStageItem:{
			by:"PipelineStageItemUniqueWhere",
			filter:"PipelineStageItemWhere"
		},
		updatePipelineStageItem:{
			by:"PipelineStageItemUniqueWhere",
			filter:"PipelineStageItemWhere",
			data:"PipelineStageItemUpdateInput"
		},
		upsertPipelineStageItem:{
			by:"PipelineStageItemUniqueWhere",
			filter:"PipelineStageItemWhere",
			update:"PipelineStageItemUpdateInput",
			create:"PipelineStageItemCreateInput"
		},
		createPipelineStageLocale:{
			data:"PipelineStageLocaleCreateInput"
		},
		deletePipelineStageLocale:{
			by:"PipelineStageLocaleUniqueWhere",
			filter:"PipelineStageLocaleWhere"
		},
		updatePipelineStageLocale:{
			by:"PipelineStageLocaleUniqueWhere",
			filter:"PipelineStageLocaleWhere",
			data:"PipelineStageLocaleUpdateInput"
		},
		upsertPipelineStageLocale:{
			by:"PipelineStageLocaleUniqueWhere",
			filter:"PipelineStageLocaleWhere",
			update:"PipelineStageLocaleUpdateInput",
			create:"PipelineStageLocaleCreateInput"
		},
		createSalesManager:{
			data:"SalesManagerCreateInput"
		},
		deleteSalesManager:{
			by:"SalesManagerUniqueWhere",
			filter:"SalesManagerWhere"
		},
		updateSalesManager:{
			by:"SalesManagerUniqueWhere",
			filter:"SalesManagerWhere",
			data:"SalesManagerUpdateInput"
		},
		upsertSalesManager:{
			by:"SalesManagerUniqueWhere",
			filter:"SalesManagerWhere",
			update:"SalesManagerUpdateInput",
			create:"SalesManagerCreateInput"
		},
		createCashierManager:{
			data:"CashierManagerCreateInput"
		},
		deleteCashierManager:{
			by:"CashierManagerUniqueWhere",
			filter:"CashierManagerWhere"
		},
		updateCashierManager:{
			by:"CashierManagerUniqueWhere",
			filter:"CashierManagerWhere",
			data:"CashierManagerUpdateInput"
		},
		upsertCashierManager:{
			by:"CashierManagerUniqueWhere",
			filter:"CashierManagerWhere",
			update:"CashierManagerUpdateInput",
			create:"CashierManagerCreateInput"
		},
		createPointOfSaleApplicationDevice:{
			data:"PointOfSaleApplicationDeviceCreateInput"
		},
		deletePointOfSaleApplicationDevice:{
			by:"PointOfSaleApplicationDeviceUniqueWhere",
			filter:"PointOfSaleApplicationDeviceWhere"
		},
		updatePointOfSaleApplicationDevice:{
			by:"PointOfSaleApplicationDeviceUniqueWhere",
			filter:"PointOfSaleApplicationDeviceWhere",
			data:"PointOfSaleApplicationDeviceUpdateInput"
		},
		upsertPointOfSaleApplicationDevice:{
			by:"PointOfSaleApplicationDeviceUniqueWhere",
			filter:"PointOfSaleApplicationDeviceWhere",
			update:"PointOfSaleApplicationDeviceUpdateInput",
			create:"PointOfSaleApplicationDeviceCreateInput"
		},
		createPointOfSaleTerminal:{
			data:"PointOfSaleTerminalCreateInput"
		},
		deletePointOfSaleTerminal:{
			by:"PointOfSaleTerminalUniqueWhere",
			filter:"PointOfSaleTerminalWhere"
		},
		updatePointOfSaleTerminal:{
			by:"PointOfSaleTerminalUniqueWhere",
			filter:"PointOfSaleTerminalWhere",
			data:"PointOfSaleTerminalUpdateInput"
		},
		upsertPointOfSaleTerminal:{
			by:"PointOfSaleTerminalUniqueWhere",
			filter:"PointOfSaleTerminalWhere",
			update:"PointOfSaleTerminalUpdateInput",
			create:"PointOfSaleTerminalCreateInput"
		},
		createPipelineStageSentiment:{
			data:"PipelineStageSentimentCreateInput"
		},
		deletePipelineStageSentiment:{
			by:"PipelineStageSentimentUniqueWhere",
			filter:"PipelineStageSentimentWhere"
		},
		updatePipelineStageSentiment:{
			by:"PipelineStageSentimentUniqueWhere",
			filter:"PipelineStageSentimentWhere",
			data:"PipelineStageSentimentUpdateInput"
		},
		upsertPipelineStageSentiment:{
			by:"PipelineStageSentimentUniqueWhere",
			filter:"PipelineStageSentimentWhere",
			update:"PipelineStageSentimentUpdateInput",
			create:"PipelineStageSentimentCreateInput"
		},
		createDeviceIdentifier:{
			data:"DeviceIdentifierCreateInput"
		},
		deleteDeviceIdentifier:{
			by:"DeviceIdentifierUniqueWhere",
			filter:"DeviceIdentifierWhere"
		},
		updateDeviceIdentifier:{
			by:"DeviceIdentifierUniqueWhere",
			filter:"DeviceIdentifierWhere",
			data:"DeviceIdentifierUpdateInput"
		},
		upsertDeviceIdentifier:{
			by:"DeviceIdentifierUniqueWhere",
			filter:"DeviceIdentifierWhere",
			update:"DeviceIdentifierUpdateInput",
			create:"DeviceIdentifierCreateInput"
		},
		createPointOfSalePrinter:{
			data:"PointOfSalePrinterCreateInput"
		},
		deletePointOfSalePrinter:{
			by:"PointOfSalePrinterUniqueWhere",
			filter:"PointOfSalePrinterWhere"
		},
		updatePointOfSalePrinter:{
			by:"PointOfSalePrinterUniqueWhere",
			filter:"PointOfSalePrinterWhere",
			data:"PointOfSalePrinterUpdateInput"
		},
		upsertPointOfSalePrinter:{
			by:"PointOfSalePrinterUniqueWhere",
			filter:"PointOfSalePrinterWhere",
			update:"PointOfSalePrinterUpdateInput",
			create:"PointOfSalePrinterCreateInput"
		},
		createGratuity:{
			data:"GratuityCreateInput"
		},
		deleteGratuity:{
			by:"GratuityUniqueWhere",
			filter:"GratuityWhere"
		},
		updateGratuity:{
			by:"GratuityUniqueWhere",
			filter:"GratuityWhere",
			data:"GratuityUpdateInput"
		},
		upsertGratuity:{
			by:"GratuityUniqueWhere",
			filter:"GratuityWhere",
			update:"GratuityUpdateInput",
			create:"GratuityCreateInput"
		},
		createFulfillmentNote:{
			data:"FulfillmentNoteCreateInput"
		},
		deleteFulfillmentNote:{
			by:"FulfillmentNoteUniqueWhere",
			filter:"FulfillmentNoteWhere"
		},
		updateFulfillmentNote:{
			by:"FulfillmentNoteUniqueWhere",
			filter:"FulfillmentNoteWhere",
			data:"FulfillmentNoteUpdateInput"
		},
		upsertFulfillmentNote:{
			by:"FulfillmentNoteUniqueWhere",
			filter:"FulfillmentNoteWhere",
			update:"FulfillmentNoteUpdateInput",
			create:"FulfillmentNoteCreateInput"
		},
		createLeadForm:{
			data:"LeadFormCreateInput"
		},
		deleteLeadForm:{
			by:"LeadFormUniqueWhere",
			filter:"LeadFormWhere"
		},
		updateLeadForm:{
			by:"LeadFormUniqueWhere",
			filter:"LeadFormWhere",
			data:"LeadFormUpdateInput"
		},
		upsertLeadForm:{
			by:"LeadFormUniqueWhere",
			filter:"LeadFormWhere",
			update:"LeadFormUpdateInput",
			create:"LeadFormCreateInput"
		},
		createSubscriptionBox:{
			data:"SubscriptionBoxCreateInput"
		},
		deleteSubscriptionBox:{
			by:"SubscriptionBoxUniqueWhere",
			filter:"SubscriptionBoxWhere"
		},
		updateSubscriptionBox:{
			by:"SubscriptionBoxUniqueWhere",
			filter:"SubscriptionBoxWhere",
			data:"SubscriptionBoxUpdateInput"
		},
		upsertSubscriptionBox:{
			by:"SubscriptionBoxUniqueWhere",
			filter:"SubscriptionBoxWhere",
			update:"SubscriptionBoxUpdateInput",
			create:"SubscriptionBoxCreateInput"
		},
		createSubscriptionBoxLocale:{
			data:"SubscriptionBoxLocaleCreateInput"
		},
		deleteSubscriptionBoxLocale:{
			by:"SubscriptionBoxLocaleUniqueWhere",
			filter:"SubscriptionBoxLocaleWhere"
		},
		updateSubscriptionBoxLocale:{
			by:"SubscriptionBoxLocaleUniqueWhere",
			filter:"SubscriptionBoxLocaleWhere",
			data:"SubscriptionBoxLocaleUpdateInput"
		},
		upsertSubscriptionBoxLocale:{
			by:"SubscriptionBoxLocaleUniqueWhere",
			filter:"SubscriptionBoxLocaleWhere",
			update:"SubscriptionBoxLocaleUpdateInput",
			create:"SubscriptionBoxLocaleCreateInput"
		},
		createBusinessService:{
			data:"BusinessServiceCreateInput"
		},
		deleteBusinessService:{
			by:"BusinessServiceUniqueWhere",
			filter:"BusinessServiceWhere"
		},
		updateBusinessService:{
			by:"BusinessServiceUniqueWhere",
			filter:"BusinessServiceWhere",
			data:"BusinessServiceUpdateInput"
		},
		upsertBusinessService:{
			by:"BusinessServiceUniqueWhere",
			filter:"BusinessServiceWhere",
			update:"BusinessServiceUpdateInput",
			create:"BusinessServiceCreateInput"
		},
		createBusinessServiceEvent:{
			data:"BusinessServiceEventCreateInput"
		},
		deleteBusinessServiceEvent:{
			by:"BusinessServiceEventUniqueWhere",
			filter:"BusinessServiceEventWhere"
		},
		updateBusinessServiceEvent:{
			by:"BusinessServiceEventUniqueWhere",
			filter:"BusinessServiceEventWhere",
			data:"BusinessServiceEventUpdateInput"
		},
		upsertBusinessServiceEvent:{
			by:"BusinessServiceEventUniqueWhere",
			filter:"BusinessServiceEventWhere",
			update:"BusinessServiceEventUpdateInput",
			create:"BusinessServiceEventCreateInput"
		},
		createBusinessServiceLocale:{
			data:"BusinessServiceLocaleCreateInput"
		},
		deleteBusinessServiceLocale:{
			by:"BusinessServiceLocaleUniqueWhere",
			filter:"BusinessServiceLocaleWhere"
		},
		updateBusinessServiceLocale:{
			by:"BusinessServiceLocaleUniqueWhere",
			filter:"BusinessServiceLocaleWhere",
			data:"BusinessServiceLocaleUpdateInput"
		},
		upsertBusinessServiceLocale:{
			by:"BusinessServiceLocaleUniqueWhere",
			filter:"BusinessServiceLocaleWhere",
			update:"BusinessServiceLocaleUpdateInput",
			create:"BusinessServiceLocaleCreateInput"
		},
		createGridTileItem:{
			data:"GridTileItemCreateInput"
		},
		deleteGridTileItem:{
			by:"GridTileItemUniqueWhere",
			filter:"GridTileItemWhere"
		},
		updateGridTileItem:{
			by:"GridTileItemUniqueWhere",
			filter:"GridTileItemWhere",
			data:"GridTileItemUpdateInput"
		},
		upsertGridTileItem:{
			by:"GridTileItemUniqueWhere",
			filter:"GridTileItemWhere",
			update:"GridTileItemUpdateInput",
			create:"GridTileItemCreateInput"
		},
		createGridTiles:{
			data:"GridTilesCreateInput"
		},
		deleteGridTiles:{
			by:"GridTilesUniqueWhere",
			filter:"GridTilesWhere"
		},
		updateGridTiles:{
			by:"GridTilesUniqueWhere",
			filter:"GridTilesWhere",
			data:"GridTilesUpdateInput"
		},
		upsertGridTiles:{
			by:"GridTilesUniqueWhere",
			filter:"GridTilesWhere",
			update:"GridTilesUpdateInput",
			create:"GridTilesCreateInput"
		},
		createArea:{
			data:"AreaCreateInput"
		},
		deleteArea:{
			by:"AreaUniqueWhere",
			filter:"AreaWhere"
		},
		updateArea:{
			by:"AreaUniqueWhere",
			filter:"AreaWhere",
			data:"AreaUpdateInput"
		},
		upsertArea:{
			by:"AreaUniqueWhere",
			filter:"AreaWhere",
			update:"AreaUpdateInput",
			create:"AreaCreateInput"
		},
		createPosition:{
			data:"PositionCreateInput"
		},
		deletePosition:{
			by:"PositionUniqueWhere",
			filter:"PositionWhere"
		},
		updatePosition:{
			by:"PositionUniqueWhere",
			filter:"PositionWhere",
			data:"PositionUpdateInput"
		},
		upsertPosition:{
			by:"PositionUniqueWhere",
			filter:"PositionWhere",
			update:"PositionUpdateInput",
			create:"PositionCreateInput"
		},
		createStatsEnabledWidgetType:{
			data:"StatsEnabledWidgetTypeCreateInput"
		},
		deleteStatsEnabledWidgetType:{
			by:"StatsEnabledWidgetTypeUniqueWhere",
			filter:"StatsEnabledWidgetTypeWhere"
		},
		updateStatsEnabledWidgetType:{
			by:"StatsEnabledWidgetTypeUniqueWhere",
			filter:"StatsEnabledWidgetTypeWhere",
			data:"StatsEnabledWidgetTypeUpdateInput"
		},
		upsertStatsEnabledWidgetType:{
			by:"StatsEnabledWidgetTypeUniqueWhere",
			filter:"StatsEnabledWidgetTypeWhere",
			update:"StatsEnabledWidgetTypeUpdateInput",
			create:"StatsEnabledWidgetTypeCreateInput"
		},
		createStatsWidget:{
			data:"StatsWidgetCreateInput"
		},
		deleteStatsWidget:{
			by:"StatsWidgetUniqueWhere",
			filter:"StatsWidgetWhere"
		},
		updateStatsWidget:{
			by:"StatsWidgetUniqueWhere",
			filter:"StatsWidgetWhere",
			data:"StatsWidgetUpdateInput"
		},
		upsertStatsWidget:{
			by:"StatsWidgetUniqueWhere",
			filter:"StatsWidgetWhere",
			update:"StatsWidgetUpdateInput",
			create:"StatsWidgetCreateInput"
		},
		createStatsWidgetsLayout:{
			data:"StatsWidgetsLayoutCreateInput"
		},
		deleteStatsWidgetsLayout:{
			by:"StatsWidgetsLayoutUniqueWhere",
			filter:"StatsWidgetsLayoutWhere"
		},
		updateStatsWidgetsLayout:{
			by:"StatsWidgetsLayoutUniqueWhere",
			filter:"StatsWidgetsLayoutWhere",
			data:"StatsWidgetsLayoutUpdateInput"
		},
		upsertStatsWidgetsLayout:{
			by:"StatsWidgetsLayoutUniqueWhere",
			filter:"StatsWidgetsLayoutWhere",
			update:"StatsWidgetsLayoutUpdateInput",
			create:"StatsWidgetsLayoutCreateInput"
		},
		createSeat:{
			data:"SeatCreateInput"
		},
		deleteSeat:{
			by:"SeatUniqueWhere",
			filter:"SeatWhere"
		},
		updateSeat:{
			by:"SeatUniqueWhere",
			filter:"SeatWhere",
			data:"SeatUpdateInput"
		},
		upsertSeat:{
			by:"SeatUniqueWhere",
			filter:"SeatWhere",
			update:"SeatUpdateInput",
			create:"SeatCreateInput"
		},
		createTable:{
			data:"TableCreateInput"
		},
		deleteTable:{
			by:"TableUniqueWhere",
			filter:"TableWhere"
		},
		updateTable:{
			by:"TableUniqueWhere",
			filter:"TableWhere",
			data:"TableUpdateInput"
		},
		upsertTable:{
			by:"TableUniqueWhere",
			filter:"TableWhere",
			update:"TableUpdateInput",
			create:"TableCreateInput"
		},
		createStatsPage:{
			data:"StatsPageCreateInput"
		},
		deleteStatsPage:{
			by:"StatsPageUniqueWhere",
			filter:"StatsPageWhere"
		},
		updateStatsPage:{
			by:"StatsPageUniqueWhere",
			filter:"StatsPageWhere",
			data:"StatsPageUpdateInput"
		},
		upsertStatsPage:{
			by:"StatsPageUniqueWhere",
			filter:"StatsPageWhere",
			update:"StatsPageUpdateInput",
			create:"StatsPageCreateInput"
		},
		createUnassignReason:{
			data:"UnassignReasonCreateInput"
		},
		deleteUnassignReason:{
			by:"UnassignReasonUniqueWhere",
			filter:"UnassignReasonWhere"
		},
		updateUnassignReason:{
			by:"UnassignReasonUniqueWhere",
			filter:"UnassignReasonWhere",
			data:"UnassignReasonUpdateInput"
		},
		upsertUnassignReason:{
			by:"UnassignReasonUniqueWhere",
			filter:"UnassignReasonWhere",
			update:"UnassignReasonUpdateInput",
			create:"UnassignReasonCreateInput"
		},
		createDoubleshotCoffeeEquipment:{
			data:"DoubleshotCoffeeEquipmentCreateInput"
		},
		deleteDoubleshotCoffeeEquipment:{
			by:"DoubleshotCoffeeEquipmentUniqueWhere",
			filter:"DoubleshotCoffeeEquipmentWhere"
		},
		updateDoubleshotCoffeeEquipment:{
			by:"DoubleshotCoffeeEquipmentUniqueWhere",
			filter:"DoubleshotCoffeeEquipmentWhere",
			data:"DoubleshotCoffeeEquipmentUpdateInput"
		},
		upsertDoubleshotCoffeeEquipment:{
			by:"DoubleshotCoffeeEquipmentUniqueWhere",
			filter:"DoubleshotCoffeeEquipmentWhere",
			update:"DoubleshotCoffeeEquipmentUpdateInput",
			create:"DoubleshotCoffeeEquipmentCreateInput"
		},
		createExpense:{
			data:"ExpenseCreateInput"
		},
		deleteExpense:{
			by:"ExpenseUniqueWhere",
			filter:"ExpenseWhere"
		},
		updateExpense:{
			by:"ExpenseUniqueWhere",
			filter:"ExpenseWhere",
			data:"ExpenseUpdateInput"
		},
		upsertExpense:{
			by:"ExpenseUniqueWhere",
			filter:"ExpenseWhere",
			update:"ExpenseUpdateInput",
			create:"ExpenseCreateInput"
		},
		createExpenseCategory:{
			data:"ExpenseCategoryCreateInput"
		},
		deleteExpenseCategory:{
			by:"ExpenseCategoryUniqueWhere",
			filter:"ExpenseCategoryWhere"
		},
		updateExpenseCategory:{
			by:"ExpenseCategoryUniqueWhere",
			filter:"ExpenseCategoryWhere",
			data:"ExpenseCategoryUpdateInput"
		},
		upsertExpenseCategory:{
			by:"ExpenseCategoryUniqueWhere",
			filter:"ExpenseCategoryWhere",
			update:"ExpenseCategoryUpdateInput",
			create:"ExpenseCategoryCreateInput"
		},
		createExpenseChange:{
			data:"ExpenseChangeCreateInput"
		},
		deleteExpenseChange:{
			by:"ExpenseChangeUniqueWhere",
			filter:"ExpenseChangeWhere"
		},
		updateExpenseChange:{
			by:"ExpenseChangeUniqueWhere",
			filter:"ExpenseChangeWhere",
			data:"ExpenseChangeUpdateInput"
		},
		upsertExpenseChange:{
			by:"ExpenseChangeUniqueWhere",
			filter:"ExpenseChangeWhere",
			update:"ExpenseChangeUpdateInput",
			create:"ExpenseChangeCreateInput"
		},
		createExpenseDocument:{
			data:"ExpenseDocumentCreateInput"
		},
		deleteExpenseDocument:{
			by:"ExpenseDocumentUniqueWhere",
			filter:"ExpenseDocumentWhere"
		},
		updateExpenseDocument:{
			by:"ExpenseDocumentUniqueWhere",
			filter:"ExpenseDocumentWhere",
			data:"ExpenseDocumentUpdateInput"
		},
		upsertExpenseDocument:{
			by:"ExpenseDocumentUniqueWhere",
			filter:"ExpenseDocumentWhere",
			update:"ExpenseDocumentUpdateInput",
			create:"ExpenseDocumentCreateInput"
		},
		createRevenuePrediction:{
			data:"RevenuePredictionCreateInput"
		},
		deleteRevenuePrediction:{
			by:"RevenuePredictionUniqueWhere",
			filter:"RevenuePredictionWhere"
		},
		updateRevenuePrediction:{
			by:"RevenuePredictionUniqueWhere",
			filter:"RevenuePredictionWhere",
			data:"RevenuePredictionUpdateInput"
		},
		upsertRevenuePrediction:{
			by:"RevenuePredictionUniqueWhere",
			filter:"RevenuePredictionWhere",
			update:"RevenuePredictionUpdateInput",
			create:"RevenuePredictionCreateInput"
		},
		createRevenuePredictionChange:{
			data:"RevenuePredictionChangeCreateInput"
		},
		deleteRevenuePredictionChange:{
			by:"RevenuePredictionChangeUniqueWhere",
			filter:"RevenuePredictionChangeWhere"
		},
		updateRevenuePredictionChange:{
			by:"RevenuePredictionChangeUniqueWhere",
			filter:"RevenuePredictionChangeWhere",
			data:"RevenuePredictionChangeUpdateInput"
		},
		upsertRevenuePredictionChange:{
			by:"RevenuePredictionChangeUniqueWhere",
			filter:"RevenuePredictionChangeWhere",
			update:"RevenuePredictionChangeUpdateInput",
			create:"RevenuePredictionChangeCreateInput"
		},
		createFile:{
			data:"FileCreateInput"
		},
		deleteFile:{
			by:"FileUniqueWhere",
			filter:"FileWhere"
		},
		updateFile:{
			by:"FileUniqueWhere",
			filter:"FileWhere",
			data:"FileUpdateInput"
		},
		upsertFile:{
			by:"FileUniqueWhere",
			filter:"FileWhere",
			update:"FileUpdateInput",
			create:"FileCreateInput"
		},
		createLine:{
			data:"LineCreateInput"
		},
		deleteLine:{
			by:"LineUniqueWhere",
			filter:"LineWhere"
		},
		updateLine:{
			by:"LineUniqueWhere",
			filter:"LineWhere",
			data:"LineUpdateInput"
		},
		upsertLine:{
			by:"LineUniqueWhere",
			filter:"LineWhere",
			update:"LineUpdateInput",
			create:"LineCreateInput"
		},
		createFinancesBalanceItem:{
			data:"FinancesBalanceItemCreateInput"
		},
		deleteFinancesBalanceItem:{
			by:"FinancesBalanceItemUniqueWhere",
			filter:"FinancesBalanceItemWhere"
		},
		updateFinancesBalanceItem:{
			by:"FinancesBalanceItemUniqueWhere",
			filter:"FinancesBalanceItemWhere",
			data:"FinancesBalanceItemUpdateInput"
		},
		upsertFinancesBalanceItem:{
			by:"FinancesBalanceItemUniqueWhere",
			filter:"FinancesBalanceItemWhere",
			update:"FinancesBalanceItemUpdateInput",
			create:"FinancesBalanceItemCreateInput"
		},
		createWoltDriveDelivery:{
			data:"WoltDriveDeliveryCreateInput"
		},
		deleteWoltDriveDelivery:{
			by:"WoltDriveDeliveryUniqueWhere",
			filter:"WoltDriveDeliveryWhere"
		},
		updateWoltDriveDelivery:{
			by:"WoltDriveDeliveryUniqueWhere",
			filter:"WoltDriveDeliveryWhere",
			data:"WoltDriveDeliveryUpdateInput"
		},
		upsertWoltDriveDelivery:{
			by:"WoltDriveDeliveryUniqueWhere",
			filter:"WoltDriveDeliveryWhere",
			update:"WoltDriveDeliveryUpdateInput",
			create:"WoltDriveDeliveryCreateInput"
		},
		transaction:{
			options:"MutationTransactionOptions"
		},
		generateUploadUrl:{

		},
		generateReadUrl:{

		}
	},
	_MutationErrorType: true,
	MutationTransaction:{
		createAddress:{
			data:"AddressCreateInput"
		},
		deleteAddress:{
			by:"AddressUniqueWhere",
			filter:"AddressWhere"
		},
		updateAddress:{
			by:"AddressUniqueWhere",
			filter:"AddressWhere",
			data:"AddressUpdateInput"
		},
		upsertAddress:{
			by:"AddressUniqueWhere",
			filter:"AddressWhere",
			update:"AddressUpdateInput",
			create:"AddressCreateInput"
		},
		createCountry:{
			data:"CountryCreateInput"
		},
		deleteCountry:{
			by:"CountryUniqueWhere",
			filter:"CountryWhere"
		},
		updateCountry:{
			by:"CountryUniqueWhere",
			filter:"CountryWhere",
			data:"CountryUpdateInput"
		},
		upsertCountry:{
			by:"CountryUniqueWhere",
			filter:"CountryWhere",
			update:"CountryUpdateInput",
			create:"CountryCreateInput"
		},
		createChannel:{
			data:"ChannelCreateInput"
		},
		deleteChannel:{
			by:"ChannelUniqueWhere",
			filter:"ChannelWhere"
		},
		updateChannel:{
			by:"ChannelUniqueWhere",
			filter:"ChannelWhere",
			data:"ChannelUpdateInput"
		},
		upsertChannel:{
			by:"ChannelUniqueWhere",
			filter:"ChannelWhere",
			update:"ChannelUpdateInput",
			create:"ChannelCreateInput"
		},
		createChannelPayment:{
			data:"ChannelPaymentCreateInput"
		},
		deleteChannelPayment:{
			by:"ChannelPaymentUniqueWhere",
			filter:"ChannelPaymentWhere"
		},
		updateChannelPayment:{
			by:"ChannelPaymentUniqueWhere",
			filter:"ChannelPaymentWhere",
			data:"ChannelPaymentUpdateInput"
		},
		upsertChannelPayment:{
			by:"ChannelPaymentUniqueWhere",
			filter:"ChannelPaymentWhere",
			update:"ChannelPaymentUpdateInput",
			create:"ChannelPaymentCreateInput"
		},
		createChannelDelivery:{
			data:"ChannelDeliveryCreateInput"
		},
		deleteChannelDelivery:{
			by:"ChannelDeliveryUniqueWhere",
			filter:"ChannelDeliveryWhere"
		},
		updateChannelDelivery:{
			by:"ChannelDeliveryUniqueWhere",
			filter:"ChannelDeliveryWhere",
			data:"ChannelDeliveryUpdateInput"
		},
		upsertChannelDelivery:{
			by:"ChannelDeliveryUniqueWhere",
			filter:"ChannelDeliveryWhere",
			update:"ChannelDeliveryUpdateInput",
			create:"ChannelDeliveryCreateInput"
		},
		createCustomer:{
			data:"CustomerCreateInput"
		},
		deleteCustomer:{
			by:"CustomerUniqueWhere",
			filter:"CustomerWhere"
		},
		updateCustomer:{
			by:"CustomerUniqueWhere",
			filter:"CustomerWhere",
			data:"CustomerUpdateInput"
		},
		upsertCustomer:{
			by:"CustomerUniqueWhere",
			filter:"CustomerWhere",
			update:"CustomerUpdateInput",
			create:"CustomerCreateInput"
		},
		createCustomerCredit:{
			data:"CustomerCreditCreateInput"
		},
		deleteCustomerCredit:{
			by:"CustomerCreditUniqueWhere",
			filter:"CustomerCreditWhere"
		},
		updateCustomerCredit:{
			by:"CustomerCreditUniqueWhere",
			filter:"CustomerCreditWhere",
			data:"CustomerCreditUpdateInput"
		},
		upsertCustomerCredit:{
			by:"CustomerCreditUniqueWhere",
			filter:"CustomerCreditWhere",
			update:"CustomerCreditUpdateInput",
			create:"CustomerCreditCreateInput"
		},
		createCustomerGroup:{
			data:"CustomerGroupCreateInput"
		},
		deleteCustomerGroup:{
			by:"CustomerGroupUniqueWhere",
			filter:"CustomerGroupWhere"
		},
		updateCustomerGroup:{
			by:"CustomerGroupUniqueWhere",
			filter:"CustomerGroupWhere",
			data:"CustomerGroupUpdateInput"
		},
		upsertCustomerGroup:{
			by:"CustomerGroupUniqueWhere",
			filter:"CustomerGroupWhere",
			update:"CustomerGroupUpdateInput",
			create:"CustomerGroupCreateInput"
		},
		createCustomerPaymentMethod:{
			data:"CustomerPaymentMethodCreateInput"
		},
		deleteCustomerPaymentMethod:{
			by:"CustomerPaymentMethodUniqueWhere",
			filter:"CustomerPaymentMethodWhere"
		},
		updateCustomerPaymentMethod:{
			by:"CustomerPaymentMethodUniqueWhere",
			filter:"CustomerPaymentMethodWhere",
			data:"CustomerPaymentMethodUpdateInput"
		},
		upsertCustomerPaymentMethod:{
			by:"CustomerPaymentMethodUniqueWhere",
			filter:"CustomerPaymentMethodWhere",
			update:"CustomerPaymentMethodUpdateInput",
			create:"CustomerPaymentMethodCreateInput"
		},
		createDeliveryMethod:{
			data:"DeliveryMethodCreateInput"
		},
		deleteDeliveryMethod:{
			by:"DeliveryMethodUniqueWhere",
			filter:"DeliveryMethodWhere"
		},
		updateDeliveryMethod:{
			by:"DeliveryMethodUniqueWhere",
			filter:"DeliveryMethodWhere",
			data:"DeliveryMethodUpdateInput"
		},
		upsertDeliveryMethod:{
			by:"DeliveryMethodUniqueWhere",
			filter:"DeliveryMethodWhere",
			update:"DeliveryMethodUpdateInput",
			create:"DeliveryMethodCreateInput"
		},
		createOrder:{
			data:"OrderCreateInput"
		},
		deleteOrder:{
			by:"OrderUniqueWhere",
			filter:"OrderWhere"
		},
		updateOrder:{
			by:"OrderUniqueWhere",
			filter:"OrderWhere",
			data:"OrderUpdateInput"
		},
		upsertOrder:{
			by:"OrderUniqueWhere",
			filter:"OrderWhere",
			update:"OrderUpdateInput",
			create:"OrderCreateInput"
		},
		createOrderDiscount:{
			data:"OrderDiscountCreateInput"
		},
		deleteOrderDiscount:{
			by:"OrderDiscountUniqueWhere",
			filter:"OrderDiscountWhere"
		},
		updateOrderDiscount:{
			by:"OrderDiscountUniqueWhere",
			filter:"OrderDiscountWhere",
			data:"OrderDiscountUpdateInput"
		},
		upsertOrderDiscount:{
			by:"OrderDiscountUniqueWhere",
			filter:"OrderDiscountWhere",
			update:"OrderDiscountUpdateInput",
			create:"OrderDiscountCreateInput"
		},
		createOrderPayment:{
			data:"OrderPaymentCreateInput"
		},
		deleteOrderPayment:{
			by:"OrderPaymentUniqueWhere",
			filter:"OrderPaymentWhere"
		},
		updateOrderPayment:{
			by:"OrderPaymentUniqueWhere",
			filter:"OrderPaymentWhere",
			data:"OrderPaymentUpdateInput"
		},
		upsertOrderPayment:{
			by:"OrderPaymentUniqueWhere",
			filter:"OrderPaymentWhere",
			update:"OrderPaymentUpdateInput",
			create:"OrderPaymentCreateInput"
		},
		createOrderDelivery:{
			data:"OrderDeliveryCreateInput"
		},
		deleteOrderDelivery:{
			by:"OrderDeliveryUniqueWhere",
			filter:"OrderDeliveryWhere"
		},
		updateOrderDelivery:{
			by:"OrderDeliveryUniqueWhere",
			filter:"OrderDeliveryWhere",
			data:"OrderDeliveryUpdateInput"
		},
		upsertOrderDelivery:{
			by:"OrderDeliveryUniqueWhere",
			filter:"OrderDeliveryWhere",
			update:"OrderDeliveryUpdateInput",
			create:"OrderDeliveryCreateInput"
		},
		createOrderItem:{
			data:"OrderItemCreateInput"
		},
		deleteOrderItem:{
			by:"OrderItemUniqueWhere",
			filter:"OrderItemWhere"
		},
		updateOrderItem:{
			by:"OrderItemUniqueWhere",
			filter:"OrderItemWhere",
			data:"OrderItemUpdateInput"
		},
		upsertOrderItem:{
			by:"OrderItemUniqueWhere",
			filter:"OrderItemWhere",
			update:"OrderItemUpdateInput",
			create:"OrderItemCreateInput"
		},
		createPaymentMethod:{
			data:"PaymentMethodCreateInput"
		},
		deletePaymentMethod:{
			by:"PaymentMethodUniqueWhere",
			filter:"PaymentMethodWhere"
		},
		updatePaymentMethod:{
			by:"PaymentMethodUniqueWhere",
			filter:"PaymentMethodWhere",
			data:"PaymentMethodUpdateInput"
		},
		upsertPaymentMethod:{
			by:"PaymentMethodUniqueWhere",
			filter:"PaymentMethodWhere",
			update:"PaymentMethodUpdateInput",
			create:"PaymentMethodCreateInput"
		},
		createVatRate:{
			data:"VatRateCreateInput"
		},
		deleteVatRate:{
			by:"VatRateUniqueWhere",
			filter:"VatRateWhere"
		},
		updateVatRate:{
			by:"VatRateUniqueWhere",
			filter:"VatRateWhere",
			data:"VatRateUpdateInput"
		},
		upsertVatRate:{
			by:"VatRateUniqueWhere",
			filter:"VatRateWhere",
			update:"VatRateUpdateInput",
			create:"VatRateCreateInput"
		},
		createProduct:{
			data:"ProductCreateInput"
		},
		deleteProduct:{
			by:"ProductUniqueWhere",
			filter:"ProductWhere"
		},
		updateProduct:{
			by:"ProductUniqueWhere",
			filter:"ProductWhere",
			data:"ProductUpdateInput"
		},
		upsertProduct:{
			by:"ProductUniqueWhere",
			filter:"ProductWhere",
			update:"ProductUpdateInput",
			create:"ProductCreateInput"
		},
		createProductStock:{
			data:"ProductStockCreateInput"
		},
		deleteProductStock:{
			by:"ProductStockUniqueWhere",
			filter:"ProductStockWhere"
		},
		updateProductStock:{
			by:"ProductStockUniqueWhere",
			filter:"ProductStockWhere",
			data:"ProductStockUpdateInput"
		},
		upsertProductStock:{
			by:"ProductStockUniqueWhere",
			filter:"ProductStockWhere",
			update:"ProductStockUpdateInput",
			create:"ProductStockCreateInput"
		},
		createProductPacking:{
			data:"ProductPackingCreateInput"
		},
		deleteProductPacking:{
			by:"ProductPackingUniqueWhere",
			filter:"ProductPackingWhere"
		},
		updateProductPacking:{
			by:"ProductPackingUniqueWhere",
			filter:"ProductPackingWhere",
			data:"ProductPackingUpdateInput"
		},
		upsertProductPacking:{
			by:"ProductPackingUniqueWhere",
			filter:"ProductPackingWhere",
			update:"ProductPackingUpdateInput",
			create:"ProductPackingCreateInput"
		},
		createProductGroupPrice:{
			data:"ProductGroupPriceCreateInput"
		},
		deleteProductGroupPrice:{
			by:"ProductGroupPriceUniqueWhere",
			filter:"ProductGroupPriceWhere"
		},
		updateProductGroupPrice:{
			by:"ProductGroupPriceUniqueWhere",
			filter:"ProductGroupPriceWhere",
			data:"ProductGroupPriceUpdateInput"
		},
		upsertProductGroupPrice:{
			by:"ProductGroupPriceUniqueWhere",
			filter:"ProductGroupPriceWhere",
			update:"ProductGroupPriceUpdateInput",
			create:"ProductGroupPriceCreateInput"
		},
		createProductRecipe:{
			data:"ProductRecipeCreateInput"
		},
		deleteProductRecipe:{
			by:"ProductRecipeUniqueWhere",
			filter:"ProductRecipeWhere"
		},
		updateProductRecipe:{
			by:"ProductRecipeUniqueWhere",
			filter:"ProductRecipeWhere",
			data:"ProductRecipeUpdateInput"
		},
		upsertProductRecipe:{
			by:"ProductRecipeUniqueWhere",
			filter:"ProductRecipeWhere",
			update:"ProductRecipeUpdateInput",
			create:"ProductRecipeCreateInput"
		},
		createProductCategory:{
			data:"ProductCategoryCreateInput"
		},
		deleteProductCategory:{
			by:"ProductCategoryUniqueWhere",
			filter:"ProductCategoryWhere"
		},
		updateProductCategory:{
			by:"ProductCategoryUniqueWhere",
			filter:"ProductCategoryWhere",
			data:"ProductCategoryUpdateInput"
		},
		upsertProductCategory:{
			by:"ProductCategoryUniqueWhere",
			filter:"ProductCategoryWhere",
			update:"ProductCategoryUpdateInput",
			create:"ProductCategoryCreateInput"
		},
		createStore:{
			data:"StoreCreateInput"
		},
		deleteStore:{
			by:"StoreUniqueWhere",
			filter:"StoreWhere"
		},
		updateStore:{
			by:"StoreUniqueWhere",
			filter:"StoreWhere",
			data:"StoreUpdateInput"
		},
		upsertStore:{
			by:"StoreUniqueWhere",
			filter:"StoreWhere",
			update:"StoreUpdateInput",
			create:"StoreCreateInput"
		},
		createTag:{
			data:"TagCreateInput"
		},
		deleteTag:{
			by:"TagUniqueWhere",
			filter:"TagWhere"
		},
		updateTag:{
			by:"TagUniqueWhere",
			filter:"TagWhere",
			data:"TagUpdateInput"
		},
		upsertTag:{
			by:"TagUniqueWhere",
			filter:"TagWhere",
			update:"TagUpdateInput",
			create:"TagCreateInput"
		},
		createImage:{
			data:"ImageCreateInput"
		},
		deleteImage:{
			by:"ImageUniqueWhere",
			filter:"ImageWhere"
		},
		updateImage:{
			by:"ImageUniqueWhere",
			filter:"ImageWhere",
			data:"ImageUpdateInput"
		},
		upsertImage:{
			by:"ImageUniqueWhere",
			filter:"ImageWhere",
			update:"ImageUpdateInput",
			create:"ImageCreateInput"
		},
		createBusinessCategory:{
			data:"BusinessCategoryCreateInput"
		},
		deleteBusinessCategory:{
			by:"BusinessCategoryUniqueWhere",
			filter:"BusinessCategoryWhere"
		},
		updateBusinessCategory:{
			by:"BusinessCategoryUniqueWhere",
			filter:"BusinessCategoryWhere",
			data:"BusinessCategoryUpdateInput"
		},
		upsertBusinessCategory:{
			by:"BusinessCategoryUniqueWhere",
			filter:"BusinessCategoryWhere",
			update:"BusinessCategoryUpdateInput",
			create:"BusinessCategoryCreateInput"
		},
		createProductList:{
			data:"ProductListCreateInput"
		},
		deleteProductList:{
			by:"ProductListUniqueWhere",
			filter:"ProductListWhere"
		},
		updateProductList:{
			by:"ProductListUniqueWhere",
			filter:"ProductListWhere",
			data:"ProductListUpdateInput"
		},
		upsertProductList:{
			by:"ProductListUniqueWhere",
			filter:"ProductListWhere",
			update:"ProductListUpdateInput",
			create:"ProductListCreateInput"
		},
		createProductListItem:{
			data:"ProductListItemCreateInput"
		},
		deleteProductListItem:{
			by:"ProductListItemUniqueWhere",
			filter:"ProductListItemWhere"
		},
		updateProductListItem:{
			by:"ProductListItemUniqueWhere",
			filter:"ProductListItemWhere",
			data:"ProductListItemUpdateInput"
		},
		upsertProductListItem:{
			by:"ProductListItemUniqueWhere",
			filter:"ProductListItemWhere",
			update:"ProductListItemUpdateInput",
			create:"ProductListItemCreateInput"
		},
		createProductCategoryList:{
			data:"ProductCategoryListCreateInput"
		},
		deleteProductCategoryList:{
			by:"ProductCategoryListUniqueWhere",
			filter:"ProductCategoryListWhere"
		},
		updateProductCategoryList:{
			by:"ProductCategoryListUniqueWhere",
			filter:"ProductCategoryListWhere",
			data:"ProductCategoryListUpdateInput"
		},
		upsertProductCategoryList:{
			by:"ProductCategoryListUniqueWhere",
			filter:"ProductCategoryListWhere",
			update:"ProductCategoryListUpdateInput",
			create:"ProductCategoryListCreateInput"
		},
		createProductCategoryListItem:{
			data:"ProductCategoryListItemCreateInput"
		},
		deleteProductCategoryListItem:{
			by:"ProductCategoryListItemUniqueWhere",
			filter:"ProductCategoryListItemWhere"
		},
		updateProductCategoryListItem:{
			by:"ProductCategoryListItemUniqueWhere",
			filter:"ProductCategoryListItemWhere",
			data:"ProductCategoryListItemUpdateInput"
		},
		upsertProductCategoryListItem:{
			by:"ProductCategoryListItemUniqueWhere",
			filter:"ProductCategoryListItemWhere",
			update:"ProductCategoryListItemUpdateInput",
			create:"ProductCategoryListItemCreateInput"
		},
		createBusinessCategoryLocale:{
			data:"BusinessCategoryLocaleCreateInput"
		},
		deleteBusinessCategoryLocale:{
			by:"BusinessCategoryLocaleUniqueWhere",
			filter:"BusinessCategoryLocaleWhere"
		},
		updateBusinessCategoryLocale:{
			by:"BusinessCategoryLocaleUniqueWhere",
			filter:"BusinessCategoryLocaleWhere",
			data:"BusinessCategoryLocaleUpdateInput"
		},
		upsertBusinessCategoryLocale:{
			by:"BusinessCategoryLocaleUniqueWhere",
			filter:"BusinessCategoryLocaleWhere",
			update:"BusinessCategoryLocaleUpdateInput",
			create:"BusinessCategoryLocaleCreateInput"
		},
		createLocale:{
			data:"LocaleCreateInput"
		},
		deleteLocale:{
			by:"LocaleUniqueWhere",
			filter:"LocaleWhere"
		},
		updateLocale:{
			by:"LocaleUniqueWhere",
			filter:"LocaleWhere",
			data:"LocaleUpdateInput"
		},
		upsertLocale:{
			by:"LocaleUniqueWhere",
			filter:"LocaleWhere",
			update:"LocaleUpdateInput",
			create:"LocaleCreateInput"
		},
		createProductCategoryListLocale:{
			data:"ProductCategoryListLocaleCreateInput"
		},
		deleteProductCategoryListLocale:{
			by:"ProductCategoryListLocaleUniqueWhere",
			filter:"ProductCategoryListLocaleWhere"
		},
		updateProductCategoryListLocale:{
			by:"ProductCategoryListLocaleUniqueWhere",
			filter:"ProductCategoryListLocaleWhere",
			data:"ProductCategoryListLocaleUpdateInput"
		},
		upsertProductCategoryListLocale:{
			by:"ProductCategoryListLocaleUniqueWhere",
			filter:"ProductCategoryListLocaleWhere",
			update:"ProductCategoryListLocaleUpdateInput",
			create:"ProductCategoryListLocaleCreateInput"
		},
		createCustomerName:{
			data:"CustomerNameCreateInput"
		},
		deleteCustomerName:{
			by:"CustomerNameUniqueWhere",
			filter:"CustomerNameWhere"
		},
		updateCustomerName:{
			by:"CustomerNameUniqueWhere",
			filter:"CustomerNameWhere",
			data:"CustomerNameUpdateInput"
		},
		upsertCustomerName:{
			by:"CustomerNameUniqueWhere",
			filter:"CustomerNameWhere",
			update:"CustomerNameUpdateInput",
			create:"CustomerNameCreateInput"
		},
		createCustomerAlias:{
			data:"CustomerAliasCreateInput"
		},
		deleteCustomerAlias:{
			by:"CustomerAliasUniqueWhere",
			filter:"CustomerAliasWhere"
		},
		updateCustomerAlias:{
			by:"CustomerAliasUniqueWhere",
			filter:"CustomerAliasWhere",
			data:"CustomerAliasUpdateInput"
		},
		upsertCustomerAlias:{
			by:"CustomerAliasUniqueWhere",
			filter:"CustomerAliasWhere",
			update:"CustomerAliasUpdateInput",
			create:"CustomerAliasCreateInput"
		},
		createProductIngredientItem:{
			data:"ProductIngredientItemCreateInput"
		},
		deleteProductIngredientItem:{
			by:"ProductIngredientItemUniqueWhere",
			filter:"ProductIngredientItemWhere"
		},
		updateProductIngredientItem:{
			by:"ProductIngredientItemUniqueWhere",
			filter:"ProductIngredientItemWhere",
			data:"ProductIngredientItemUpdateInput"
		},
		upsertProductIngredientItem:{
			by:"ProductIngredientItemUniqueWhere",
			filter:"ProductIngredientItemWhere",
			update:"ProductIngredientItemUpdateInput",
			create:"ProductIngredientItemCreateInput"
		},
		createProductIngredientItemQuantity:{
			data:"ProductIngredientItemQuantityCreateInput"
		},
		deleteProductIngredientItemQuantity:{
			by:"ProductIngredientItemQuantityUniqueWhere",
			filter:"ProductIngredientItemQuantityWhere"
		},
		updateProductIngredientItemQuantity:{
			by:"ProductIngredientItemQuantityUniqueWhere",
			filter:"ProductIngredientItemQuantityWhere",
			data:"ProductIngredientItemQuantityUpdateInput"
		},
		upsertProductIngredientItemQuantity:{
			by:"ProductIngredientItemQuantityUniqueWhere",
			filter:"ProductIngredientItemQuantityWhere",
			update:"ProductIngredientItemQuantityUpdateInput",
			create:"ProductIngredientItemQuantityCreateInput"
		},
		createProductIngredientItemQuantityUnit:{
			data:"ProductIngredientItemQuantityUnitCreateInput"
		},
		deleteProductIngredientItemQuantityUnit:{
			by:"ProductIngredientItemQuantityUnitUniqueWhere",
			filter:"ProductIngredientItemQuantityUnitWhere"
		},
		updateProductIngredientItemQuantityUnit:{
			by:"ProductIngredientItemQuantityUnitUniqueWhere",
			filter:"ProductIngredientItemQuantityUnitWhere",
			data:"ProductIngredientItemQuantityUnitUpdateInput"
		},
		upsertProductIngredientItemQuantityUnit:{
			by:"ProductIngredientItemQuantityUnitUniqueWhere",
			filter:"ProductIngredientItemQuantityUnitWhere",
			update:"ProductIngredientItemQuantityUnitUpdateInput",
			create:"ProductIngredientItemQuantityUnitCreateInput"
		},
		createProductIngredient:{
			data:"ProductIngredientCreateInput"
		},
		deleteProductIngredient:{
			by:"ProductIngredientUniqueWhere",
			filter:"ProductIngredientWhere"
		},
		updateProductIngredient:{
			by:"ProductIngredientUniqueWhere",
			filter:"ProductIngredientWhere",
			data:"ProductIngredientUpdateInput"
		},
		upsertProductIngredient:{
			by:"ProductIngredientUniqueWhere",
			filter:"ProductIngredientWhere",
			update:"ProductIngredientUpdateInput",
			create:"ProductIngredientCreateInput"
		},
		createCustomerIngredientRating:{
			data:"CustomerIngredientRatingCreateInput"
		},
		deleteCustomerIngredientRating:{
			by:"CustomerIngredientRatingUniqueWhere",
			filter:"CustomerIngredientRatingWhere"
		},
		updateCustomerIngredientRating:{
			by:"CustomerIngredientRatingUniqueWhere",
			filter:"CustomerIngredientRatingWhere",
			data:"CustomerIngredientRatingUpdateInput"
		},
		upsertCustomerIngredientRating:{
			by:"CustomerIngredientRatingUniqueWhere",
			filter:"CustomerIngredientRatingWhere",
			update:"CustomerIngredientRatingUpdateInput",
			create:"CustomerIngredientRatingCreateInput"
		},
		createProductIngredientRating:{
			data:"ProductIngredientRatingCreateInput"
		},
		deleteProductIngredientRating:{
			by:"ProductIngredientRatingUniqueWhere",
			filter:"ProductIngredientRatingWhere"
		},
		updateProductIngredientRating:{
			by:"ProductIngredientRatingUniqueWhere",
			filter:"ProductIngredientRatingWhere",
			data:"ProductIngredientRatingUpdateInput"
		},
		upsertProductIngredientRating:{
			by:"ProductIngredientRatingUniqueWhere",
			filter:"ProductIngredientRatingWhere",
			update:"ProductIngredientRatingUpdateInput",
			create:"ProductIngredientRatingCreateInput"
		},
		createProductIngredientLocale:{
			data:"ProductIngredientLocaleCreateInput"
		},
		deleteProductIngredientLocale:{
			by:"ProductIngredientLocaleUniqueWhere",
			filter:"ProductIngredientLocaleWhere"
		},
		updateProductIngredientLocale:{
			by:"ProductIngredientLocaleUniqueWhere",
			filter:"ProductIngredientLocaleWhere",
			data:"ProductIngredientLocaleUpdateInput"
		},
		upsertProductIngredientLocale:{
			by:"ProductIngredientLocaleUniqueWhere",
			filter:"ProductIngredientLocaleWhere",
			update:"ProductIngredientLocaleUpdateInput",
			create:"ProductIngredientLocaleCreateInput"
		},
		createOrderRecurrence:{
			data:"OrderRecurrenceCreateInput"
		},
		deleteOrderRecurrence:{
			by:"OrderRecurrenceUniqueWhere",
			filter:"OrderRecurrenceWhere"
		},
		updateOrderRecurrence:{
			by:"OrderRecurrenceUniqueWhere",
			filter:"OrderRecurrenceWhere",
			data:"OrderRecurrenceUpdateInput"
		},
		upsertOrderRecurrence:{
			by:"OrderRecurrenceUniqueWhere",
			filter:"OrderRecurrenceWhere",
			update:"OrderRecurrenceUpdateInput",
			create:"OrderRecurrenceCreateInput"
		},
		createOrderRecurrenceLocale:{
			data:"OrderRecurrenceLocaleCreateInput"
		},
		deleteOrderRecurrenceLocale:{
			by:"OrderRecurrenceLocaleUniqueWhere",
			filter:"OrderRecurrenceLocaleWhere"
		},
		updateOrderRecurrenceLocale:{
			by:"OrderRecurrenceLocaleUniqueWhere",
			filter:"OrderRecurrenceLocaleWhere",
			data:"OrderRecurrenceLocaleUpdateInput"
		},
		upsertOrderRecurrenceLocale:{
			by:"OrderRecurrenceLocaleUniqueWhere",
			filter:"OrderRecurrenceLocaleWhere",
			update:"OrderRecurrenceLocaleUpdateInput",
			create:"OrderRecurrenceLocaleCreateInput"
		},
		createBusinessCustomer:{
			data:"BusinessCustomerCreateInput"
		},
		deleteBusinessCustomer:{
			by:"BusinessCustomerUniqueWhere",
			filter:"BusinessCustomerWhere"
		},
		updateBusinessCustomer:{
			by:"BusinessCustomerUniqueWhere",
			filter:"BusinessCustomerWhere",
			data:"BusinessCustomerUpdateInput"
		},
		upsertBusinessCustomer:{
			by:"BusinessCustomerUniqueWhere",
			filter:"BusinessCustomerWhere",
			update:"BusinessCustomerUpdateInput",
			create:"BusinessCustomerCreateInput"
		},
		createPointOfSale:{
			data:"PointOfSaleCreateInput"
		},
		deletePointOfSale:{
			by:"PointOfSaleUniqueWhere",
			filter:"PointOfSaleWhere"
		},
		updatePointOfSale:{
			by:"PointOfSaleUniqueWhere",
			filter:"PointOfSaleWhere",
			data:"PointOfSaleUpdateInput"
		},
		upsertPointOfSale:{
			by:"PointOfSaleUniqueWhere",
			filter:"PointOfSaleWhere",
			update:"PointOfSaleUpdateInput",
			create:"PointOfSaleCreateInput"
		},
		createStaff:{
			data:"StaffCreateInput"
		},
		deleteStaff:{
			by:"StaffUniqueWhere",
			filter:"StaffWhere"
		},
		updateStaff:{
			by:"StaffUniqueWhere",
			filter:"StaffWhere",
			data:"StaffUpdateInput"
		},
		upsertStaff:{
			by:"StaffUniqueWhere",
			filter:"StaffWhere",
			update:"StaffUpdateInput",
			create:"StaffCreateInput"
		},
		createBlog:{
			data:"BlogCreateInput"
		},
		deleteBlog:{
			by:"BlogUniqueWhere",
			filter:"BlogWhere"
		},
		updateBlog:{
			by:"BlogUniqueWhere",
			filter:"BlogWhere",
			data:"BlogUpdateInput"
		},
		upsertBlog:{
			by:"BlogUniqueWhere",
			filter:"BlogWhere",
			update:"BlogUpdateInput",
			create:"BlogCreateInput"
		},
		createBlogLocale:{
			data:"BlogLocaleCreateInput"
		},
		deleteBlogLocale:{
			by:"BlogLocaleUniqueWhere",
			filter:"BlogLocaleWhere"
		},
		updateBlogLocale:{
			by:"BlogLocaleUniqueWhere",
			filter:"BlogLocaleWhere",
			data:"BlogLocaleUpdateInput"
		},
		upsertBlogLocale:{
			by:"BlogLocaleUniqueWhere",
			filter:"BlogLocaleWhere",
			update:"BlogLocaleUpdateInput",
			create:"BlogLocaleCreateInput"
		},
		createBlogPost:{
			data:"BlogPostCreateInput"
		},
		deleteBlogPost:{
			by:"BlogPostUniqueWhere",
			filter:"BlogPostWhere"
		},
		updateBlogPost:{
			by:"BlogPostUniqueWhere",
			filter:"BlogPostWhere",
			data:"BlogPostUpdateInput"
		},
		upsertBlogPost:{
			by:"BlogPostUniqueWhere",
			filter:"BlogPostWhere",
			update:"BlogPostUpdateInput",
			create:"BlogPostCreateInput"
		},
		createBlogPostLocale:{
			data:"BlogPostLocaleCreateInput"
		},
		deleteBlogPostLocale:{
			by:"BlogPostLocaleUniqueWhere",
			filter:"BlogPostLocaleWhere"
		},
		updateBlogPostLocale:{
			by:"BlogPostLocaleUniqueWhere",
			filter:"BlogPostLocaleWhere",
			data:"BlogPostLocaleUpdateInput"
		},
		upsertBlogPostLocale:{
			by:"BlogPostLocaleUniqueWhere",
			filter:"BlogPostLocaleWhere",
			update:"BlogPostLocaleUpdateInput",
			create:"BlogPostLocaleCreateInput"
		},
		createColorPallete:{
			data:"ColorPalleteCreateInput"
		},
		deleteColorPallete:{
			by:"ColorPalleteUniqueWhere",
			filter:"ColorPalleteWhere"
		},
		updateColorPallete:{
			by:"ColorPalleteUniqueWhere",
			filter:"ColorPalleteWhere",
			data:"ColorPalleteUpdateInput"
		},
		upsertColorPallete:{
			by:"ColorPalleteUniqueWhere",
			filter:"ColorPalleteWhere",
			update:"ColorPalleteUpdateInput",
			create:"ColorPalleteCreateInput"
		},
		createContent:{
			data:"ContentCreateInput"
		},
		deleteContent:{
			by:"ContentUniqueWhere",
			filter:"ContentWhere"
		},
		updateContent:{
			by:"ContentUniqueWhere",
			filter:"ContentWhere",
			data:"ContentUpdateInput"
		},
		upsertContent:{
			by:"ContentUniqueWhere",
			filter:"ContentWhere",
			update:"ContentUpdateInput",
			create:"ContentCreateInput"
		},
		createContentBlock:{
			data:"ContentBlockCreateInput"
		},
		deleteContentBlock:{
			by:"ContentBlockUniqueWhere",
			filter:"ContentBlockWhere"
		},
		updateContentBlock:{
			by:"ContentBlockUniqueWhere",
			filter:"ContentBlockWhere",
			data:"ContentBlockUpdateInput"
		},
		upsertContentBlock:{
			by:"ContentBlockUniqueWhere",
			filter:"ContentBlockWhere",
			update:"ContentBlockUpdateInput",
			create:"ContentBlockCreateInput"
		},
		createContentReference:{
			data:"ContentReferenceCreateInput"
		},
		deleteContentReference:{
			by:"ContentReferenceUniqueWhere",
			filter:"ContentReferenceWhere"
		},
		updateContentReference:{
			by:"ContentReferenceUniqueWhere",
			filter:"ContentReferenceWhere",
			data:"ContentReferenceUpdateInput"
		},
		upsertContentReference:{
			by:"ContentReferenceUniqueWhere",
			filter:"ContentReferenceWhere",
			update:"ContentReferenceUpdateInput",
			create:"ContentReferenceCreateInput"
		},
		createBlogPostList:{
			data:"BlogPostListCreateInput"
		},
		deleteBlogPostList:{
			by:"BlogPostListUniqueWhere",
			filter:"BlogPostListWhere"
		},
		updateBlogPostList:{
			by:"BlogPostListUniqueWhere",
			filter:"BlogPostListWhere",
			data:"BlogPostListUpdateInput"
		},
		upsertBlogPostList:{
			by:"BlogPostListUniqueWhere",
			filter:"BlogPostListWhere",
			update:"BlogPostListUpdateInput",
			create:"BlogPostListCreateInput"
		},
		createBlogPostListItem:{
			data:"BlogPostListItemCreateInput"
		},
		deleteBlogPostListItem:{
			by:"BlogPostListItemUniqueWhere",
			filter:"BlogPostListItemWhere"
		},
		updateBlogPostListItem:{
			by:"BlogPostListItemUniqueWhere",
			filter:"BlogPostListItemWhere",
			data:"BlogPostListItemUpdateInput"
		},
		upsertBlogPostListItem:{
			by:"BlogPostListItemUniqueWhere",
			filter:"BlogPostListItemWhere",
			update:"BlogPostListItemUpdateInput",
			create:"BlogPostListItemCreateInput"
		},
		createLinkList:{
			data:"LinkListCreateInput"
		},
		deleteLinkList:{
			by:"LinkListUniqueWhere",
			filter:"LinkListWhere"
		},
		updateLinkList:{
			by:"LinkListUniqueWhere",
			filter:"LinkListWhere",
			data:"LinkListUpdateInput"
		},
		upsertLinkList:{
			by:"LinkListUniqueWhere",
			filter:"LinkListWhere",
			update:"LinkListUpdateInput",
			create:"LinkListCreateInput"
		},
		createLinkListItem:{
			data:"LinkListItemCreateInput"
		},
		deleteLinkListItem:{
			by:"LinkListItemUniqueWhere",
			filter:"LinkListItemWhere"
		},
		updateLinkListItem:{
			by:"LinkListItemUniqueWhere",
			filter:"LinkListItemWhere",
			data:"LinkListItemUpdateInput"
		},
		upsertLinkListItem:{
			by:"LinkListItemUniqueWhere",
			filter:"LinkListItemWhere",
			update:"LinkListItemUpdateInput",
			create:"LinkListItemCreateInput"
		},
		createCover:{
			data:"CoverCreateInput"
		},
		deleteCover:{
			by:"CoverUniqueWhere",
			filter:"CoverWhere"
		},
		updateCover:{
			by:"CoverUniqueWhere",
			filter:"CoverWhere",
			data:"CoverUpdateInput"
		},
		upsertCover:{
			by:"CoverUniqueWhere",
			filter:"CoverWhere",
			update:"CoverUpdateInput",
			create:"CoverCreateInput"
		},
		createLink:{
			data:"LinkCreateInput"
		},
		deleteLink:{
			by:"LinkUniqueWhere",
			filter:"LinkWhere"
		},
		updateLink:{
			by:"LinkUniqueWhere",
			filter:"LinkWhere",
			data:"LinkUpdateInput"
		},
		upsertLink:{
			by:"LinkUniqueWhere",
			filter:"LinkWhere",
			update:"LinkUpdateInput",
			create:"LinkCreateInput"
		},
		createLinkable:{
			data:"LinkableCreateInput"
		},
		deleteLinkable:{
			by:"LinkableUniqueWhere",
			filter:"LinkableWhere"
		},
		updateLinkable:{
			by:"LinkableUniqueWhere",
			filter:"LinkableWhere",
			data:"LinkableUpdateInput"
		},
		upsertLinkable:{
			by:"LinkableUniqueWhere",
			filter:"LinkableWhere",
			update:"LinkableUpdateInput",
			create:"LinkableCreateInput"
		},
		createMedium:{
			data:"MediumCreateInput"
		},
		deleteMedium:{
			by:"MediumUniqueWhere",
			filter:"MediumWhere"
		},
		updateMedium:{
			by:"MediumUniqueWhere",
			filter:"MediumWhere",
			data:"MediumUpdateInput"
		},
		upsertMedium:{
			by:"MediumUniqueWhere",
			filter:"MediumWhere",
			update:"MediumUpdateInput",
			create:"MediumCreateInput"
		},
		createVideo:{
			data:"VideoCreateInput"
		},
		deleteVideo:{
			by:"VideoUniqueWhere",
			filter:"VideoWhere"
		},
		updateVideo:{
			by:"VideoUniqueWhere",
			filter:"VideoWhere",
			data:"VideoUpdateInput"
		},
		upsertVideo:{
			by:"VideoUniqueWhere",
			filter:"VideoWhere",
			update:"VideoUpdateInput",
			create:"VideoCreateInput"
		},
		createSeo:{
			data:"SeoCreateInput"
		},
		deleteSeo:{
			by:"SeoUniqueWhere",
			filter:"SeoWhere"
		},
		updateSeo:{
			by:"SeoUniqueWhere",
			filter:"SeoWhere",
			data:"SeoUpdateInput"
		},
		upsertSeo:{
			by:"SeoUniqueWhere",
			filter:"SeoWhere",
			update:"SeoUpdateInput",
			create:"SeoCreateInput"
		},
		createProtectedImage:{
			data:"ProtectedImageCreateInput"
		},
		deleteProtectedImage:{
			by:"ProtectedImageUniqueWhere",
			filter:"ProtectedImageWhere"
		},
		updateProtectedImage:{
			by:"ProtectedImageUniqueWhere",
			filter:"ProtectedImageWhere",
			data:"ProtectedImageUpdateInput"
		},
		upsertProtectedImage:{
			by:"ProtectedImageUniqueWhere",
			filter:"ProtectedImageWhere",
			update:"ProtectedImageUpdateInput",
			create:"ProtectedImageCreateInput"
		},
		createTranslationDomain:{
			data:"TranslationDomainCreateInput"
		},
		deleteTranslationDomain:{
			by:"TranslationDomainUniqueWhere",
			filter:"TranslationDomainWhere"
		},
		updateTranslationDomain:{
			by:"TranslationDomainUniqueWhere",
			filter:"TranslationDomainWhere",
			data:"TranslationDomainUpdateInput"
		},
		upsertTranslationDomain:{
			by:"TranslationDomainUniqueWhere",
			filter:"TranslationDomainWhere",
			update:"TranslationDomainUpdateInput",
			create:"TranslationDomainCreateInput"
		},
		createTranslationCatalogue:{
			data:"TranslationCatalogueCreateInput"
		},
		deleteTranslationCatalogue:{
			by:"TranslationCatalogueUniqueWhere",
			filter:"TranslationCatalogueWhere"
		},
		updateTranslationCatalogue:{
			by:"TranslationCatalogueUniqueWhere",
			filter:"TranslationCatalogueWhere",
			data:"TranslationCatalogueUpdateInput"
		},
		upsertTranslationCatalogue:{
			by:"TranslationCatalogueUniqueWhere",
			filter:"TranslationCatalogueWhere",
			update:"TranslationCatalogueUpdateInput",
			create:"TranslationCatalogueCreateInput"
		},
		createTranslationKey:{
			data:"TranslationKeyCreateInput"
		},
		deleteTranslationKey:{
			by:"TranslationKeyUniqueWhere",
			filter:"TranslationKeyWhere"
		},
		updateTranslationKey:{
			by:"TranslationKeyUniqueWhere",
			filter:"TranslationKeyWhere",
			data:"TranslationKeyUpdateInput"
		},
		upsertTranslationKey:{
			by:"TranslationKeyUniqueWhere",
			filter:"TranslationKeyWhere",
			update:"TranslationKeyUpdateInput",
			create:"TranslationKeyCreateInput"
		},
		createTranslationValue:{
			data:"TranslationValueCreateInput"
		},
		deleteTranslationValue:{
			by:"TranslationValueUniqueWhere",
			filter:"TranslationValueWhere"
		},
		updateTranslationValue:{
			by:"TranslationValueUniqueWhere",
			filter:"TranslationValueWhere",
			data:"TranslationValueUpdateInput"
		},
		upsertTranslationValue:{
			by:"TranslationValueUniqueWhere",
			filter:"TranslationValueWhere",
			update:"TranslationValueUpdateInput",
			create:"TranslationValueCreateInput"
		},
		createTranslationCataloguesIdentifier:{
			data:"TranslationCataloguesIdentifierCreateInput"
		},
		deleteTranslationCataloguesIdentifier:{
			by:"TranslationCataloguesIdentifierUniqueWhere",
			filter:"TranslationCataloguesIdentifierWhere"
		},
		updateTranslationCataloguesIdentifier:{
			by:"TranslationCataloguesIdentifierUniqueWhere",
			filter:"TranslationCataloguesIdentifierWhere",
			data:"TranslationCataloguesIdentifierUpdateInput"
		},
		upsertTranslationCataloguesIdentifier:{
			by:"TranslationCataloguesIdentifierUniqueWhere",
			filter:"TranslationCataloguesIdentifierWhere",
			update:"TranslationCataloguesIdentifierUpdateInput",
			create:"TranslationCataloguesIdentifierCreateInput"
		},
		createSocialsAndApps:{
			data:"SocialsAndAppsCreateInput"
		},
		deleteSocialsAndApps:{
			by:"SocialsAndAppsUniqueWhere",
			filter:"SocialsAndAppsWhere"
		},
		updateSocialsAndApps:{
			by:"SocialsAndAppsUniqueWhere",
			filter:"SocialsAndAppsWhere",
			data:"SocialsAndAppsUpdateInput"
		},
		upsertSocialsAndApps:{
			by:"SocialsAndAppsUniqueWhere",
			filter:"SocialsAndAppsWhere",
			update:"SocialsAndAppsUpdateInput",
			create:"SocialsAndAppsCreateInput"
		},
		createProductGrid:{
			data:"ProductGridCreateInput"
		},
		deleteProductGrid:{
			by:"ProductGridUniqueWhere",
			filter:"ProductGridWhere"
		},
		updateProductGrid:{
			by:"ProductGridUniqueWhere",
			filter:"ProductGridWhere",
			data:"ProductGridUpdateInput"
		},
		upsertProductGrid:{
			by:"ProductGridUniqueWhere",
			filter:"ProductGridWhere",
			update:"ProductGridUpdateInput",
			create:"ProductGridCreateInput"
		},
		createProductGridItem:{
			data:"ProductGridItemCreateInput"
		},
		deleteProductGridItem:{
			by:"ProductGridItemUniqueWhere",
			filter:"ProductGridItemWhere"
		},
		updateProductGridItem:{
			by:"ProductGridItemUniqueWhere",
			filter:"ProductGridItemWhere",
			data:"ProductGridItemUpdateInput"
		},
		upsertProductGridItem:{
			by:"ProductGridItemUniqueWhere",
			filter:"ProductGridItemWhere",
			update:"ProductGridItemUpdateInput",
			create:"ProductGridItemCreateInput"
		},
		createGallery:{
			data:"GalleryCreateInput"
		},
		deleteGallery:{
			by:"GalleryUniqueWhere",
			filter:"GalleryWhere"
		},
		updateGallery:{
			by:"GalleryUniqueWhere",
			filter:"GalleryWhere",
			data:"GalleryUpdateInput"
		},
		upsertGallery:{
			by:"GalleryUniqueWhere",
			filter:"GalleryWhere",
			update:"GalleryUpdateInput",
			create:"GalleryCreateInput"
		},
		createGalleryItem:{
			data:"GalleryItemCreateInput"
		},
		deleteGalleryItem:{
			by:"GalleryItemUniqueWhere",
			filter:"GalleryItemWhere"
		},
		updateGalleryItem:{
			by:"GalleryItemUniqueWhere",
			filter:"GalleryItemWhere",
			data:"GalleryItemUpdateInput"
		},
		upsertGalleryItem:{
			by:"GalleryItemUniqueWhere",
			filter:"GalleryItemWhere",
			update:"GalleryItemUpdateInput",
			create:"GalleryItemCreateInput"
		},
		createHero:{
			data:"HeroCreateInput"
		},
		deleteHero:{
			by:"HeroUniqueWhere",
			filter:"HeroWhere"
		},
		updateHero:{
			by:"HeroUniqueWhere",
			filter:"HeroWhere",
			data:"HeroUpdateInput"
		},
		upsertHero:{
			by:"HeroUniqueWhere",
			filter:"HeroWhere",
			update:"HeroUpdateInput",
			create:"HeroCreateInput"
		},
		createSiteMenu:{
			data:"SiteMenuCreateInput"
		},
		deleteSiteMenu:{
			by:"SiteMenuUniqueWhere",
			filter:"SiteMenuWhere"
		},
		updateSiteMenu:{
			by:"SiteMenuUniqueWhere",
			filter:"SiteMenuWhere",
			data:"SiteMenuUpdateInput"
		},
		upsertSiteMenu:{
			by:"SiteMenuUniqueWhere",
			filter:"SiteMenuWhere",
			update:"SiteMenuUpdateInput",
			create:"SiteMenuCreateInput"
		},
		createMenuLocale:{
			data:"MenuLocaleCreateInput"
		},
		deleteMenuLocale:{
			by:"MenuLocaleUniqueWhere",
			filter:"MenuLocaleWhere"
		},
		updateMenuLocale:{
			by:"MenuLocaleUniqueWhere",
			filter:"MenuLocaleWhere",
			data:"MenuLocaleUpdateInput"
		},
		upsertMenuLocale:{
			by:"MenuLocaleUniqueWhere",
			filter:"MenuLocaleWhere",
			update:"MenuLocaleUpdateInput",
			create:"MenuLocaleCreateInput"
		},
		createMenuItem:{
			data:"MenuItemCreateInput"
		},
		deleteMenuItem:{
			by:"MenuItemUniqueWhere",
			filter:"MenuItemWhere"
		},
		updateMenuItem:{
			by:"MenuItemUniqueWhere",
			filter:"MenuItemWhere",
			data:"MenuItemUpdateInput"
		},
		upsertMenuItem:{
			by:"MenuItemUniqueWhere",
			filter:"MenuItemWhere",
			update:"MenuItemUpdateInput",
			create:"MenuItemCreateInput"
		},
		createPage:{
			data:"PageCreateInput"
		},
		deletePage:{
			by:"PageUniqueWhere",
			filter:"PageWhere"
		},
		updatePage:{
			by:"PageUniqueWhere",
			filter:"PageWhere",
			data:"PageUpdateInput"
		},
		upsertPage:{
			by:"PageUniqueWhere",
			filter:"PageWhere",
			update:"PageUpdateInput",
			create:"PageCreateInput"
		},
		createPageLocale:{
			data:"PageLocaleCreateInput"
		},
		deletePageLocale:{
			by:"PageLocaleUniqueWhere",
			filter:"PageLocaleWhere"
		},
		updatePageLocale:{
			by:"PageLocaleUniqueWhere",
			filter:"PageLocaleWhere",
			data:"PageLocaleUpdateInput"
		},
		upsertPageLocale:{
			by:"PageLocaleUniqueWhere",
			filter:"PageLocaleWhere",
			update:"PageLocaleUpdateInput",
			create:"PageLocaleCreateInput"
		},
		createWikiPage:{
			data:"WikiPageCreateInput"
		},
		deleteWikiPage:{
			by:"WikiPageUniqueWhere",
			filter:"WikiPageWhere"
		},
		updateWikiPage:{
			by:"WikiPageUniqueWhere",
			filter:"WikiPageWhere",
			data:"WikiPageUpdateInput"
		},
		upsertWikiPage:{
			by:"WikiPageUniqueWhere",
			filter:"WikiPageWhere",
			update:"WikiPageUpdateInput",
			create:"WikiPageCreateInput"
		},
		createMenuSubitem:{
			data:"MenuSubitemCreateInput"
		},
		deleteMenuSubitem:{
			by:"MenuSubitemUniqueWhere",
			filter:"MenuSubitemWhere"
		},
		updateMenuSubitem:{
			by:"MenuSubitemUniqueWhere",
			filter:"MenuSubitemWhere",
			data:"MenuSubitemUpdateInput"
		},
		upsertMenuSubitem:{
			by:"MenuSubitemUniqueWhere",
			filter:"MenuSubitemWhere",
			update:"MenuSubitemUpdateInput",
			create:"MenuSubitemCreateInput"
		},
		createMenuLinkList:{
			data:"MenuLinkListCreateInput"
		},
		deleteMenuLinkList:{
			by:"MenuLinkListUniqueWhere",
			filter:"MenuLinkListWhere"
		},
		updateMenuLinkList:{
			by:"MenuLinkListUniqueWhere",
			filter:"MenuLinkListWhere",
			data:"MenuLinkListUpdateInput"
		},
		upsertMenuLinkList:{
			by:"MenuLinkListUniqueWhere",
			filter:"MenuLinkListWhere",
			update:"MenuLinkListUpdateInput",
			create:"MenuLinkListCreateInput"
		},
		createMenuLinkItem:{
			data:"MenuLinkItemCreateInput"
		},
		deleteMenuLinkItem:{
			by:"MenuLinkItemUniqueWhere",
			filter:"MenuLinkItemWhere"
		},
		updateMenuLinkItem:{
			by:"MenuLinkItemUniqueWhere",
			filter:"MenuLinkItemWhere",
			data:"MenuLinkItemUpdateInput"
		},
		upsertMenuLinkItem:{
			by:"MenuLinkItemUniqueWhere",
			filter:"MenuLinkItemWhere",
			update:"MenuLinkItemUpdateInput",
			create:"MenuLinkItemCreateInput"
		},
		createMenuProducts:{
			data:"MenuProductsCreateInput"
		},
		deleteMenuProducts:{
			by:"MenuProductsUniqueWhere",
			filter:"MenuProductsWhere"
		},
		updateMenuProducts:{
			by:"MenuProductsUniqueWhere",
			filter:"MenuProductsWhere",
			data:"MenuProductsUpdateInput"
		},
		upsertMenuProducts:{
			by:"MenuProductsUniqueWhere",
			filter:"MenuProductsWhere",
			update:"MenuProductsUpdateInput",
			create:"MenuProductsCreateInput"
		},
		createMenuDelivery:{
			data:"MenuDeliveryCreateInput"
		},
		deleteMenuDelivery:{
			by:"MenuDeliveryUniqueWhere",
			filter:"MenuDeliveryWhere"
		},
		updateMenuDelivery:{
			by:"MenuDeliveryUniqueWhere",
			filter:"MenuDeliveryWhere",
			data:"MenuDeliveryUpdateInput"
		},
		upsertMenuDelivery:{
			by:"MenuDeliveryUniqueWhere",
			filter:"MenuDeliveryWhere",
			update:"MenuDeliveryUpdateInput",
			create:"MenuDeliveryCreateInput"
		},
		createMenuContact:{
			data:"MenuContactCreateInput"
		},
		deleteMenuContact:{
			by:"MenuContactUniqueWhere",
			filter:"MenuContactWhere"
		},
		updateMenuContact:{
			by:"MenuContactUniqueWhere",
			filter:"MenuContactWhere",
			data:"MenuContactUpdateInput"
		},
		upsertMenuContact:{
			by:"MenuContactUniqueWhere",
			filter:"MenuContactWhere",
			update:"MenuContactUpdateInput",
			create:"MenuContactCreateInput"
		},
		createDeadlineTemplate:{
			data:"DeadlineTemplateCreateInput"
		},
		deleteDeadlineTemplate:{
			by:"DeadlineTemplateUniqueWhere",
			filter:"DeadlineTemplateWhere"
		},
		updateDeadlineTemplate:{
			by:"DeadlineTemplateUniqueWhere",
			filter:"DeadlineTemplateWhere",
			data:"DeadlineTemplateUpdateInput"
		},
		upsertDeadlineTemplate:{
			by:"DeadlineTemplateUniqueWhere",
			filter:"DeadlineTemplateWhere",
			update:"DeadlineTemplateUpdateInput",
			create:"DeadlineTemplateCreateInput"
		},
		createEmployeeQueue:{
			data:"EmployeeQueueCreateInput"
		},
		deleteEmployeeQueue:{
			by:"EmployeeQueueUniqueWhere",
			filter:"EmployeeQueueWhere"
		},
		updateEmployeeQueue:{
			by:"EmployeeQueueUniqueWhere",
			filter:"EmployeeQueueWhere",
			data:"EmployeeQueueUpdateInput"
		},
		upsertEmployeeQueue:{
			by:"EmployeeQueueUniqueWhere",
			filter:"EmployeeQueueWhere",
			update:"EmployeeQueueUpdateInput",
			create:"EmployeeQueueCreateInput"
		},
		createTimetableDay:{
			data:"TimetableDayCreateInput"
		},
		deleteTimetableDay:{
			by:"TimetableDayUniqueWhere",
			filter:"TimetableDayWhere"
		},
		updateTimetableDay:{
			by:"TimetableDayUniqueWhere",
			filter:"TimetableDayWhere",
			data:"TimetableDayUpdateInput"
		},
		upsertTimetableDay:{
			by:"TimetableDayUniqueWhere",
			filter:"TimetableDayWhere",
			update:"TimetableDayUpdateInput",
			create:"TimetableDayCreateInput"
		},
		createTimetableEmployeeRole:{
			data:"TimetableEmployeeRoleCreateInput"
		},
		deleteTimetableEmployeeRole:{
			by:"TimetableEmployeeRoleUniqueWhere",
			filter:"TimetableEmployeeRoleWhere"
		},
		updateTimetableEmployeeRole:{
			by:"TimetableEmployeeRoleUniqueWhere",
			filter:"TimetableEmployeeRoleWhere",
			data:"TimetableEmployeeRoleUpdateInput"
		},
		upsertTimetableEmployeeRole:{
			by:"TimetableEmployeeRoleUniqueWhere",
			filter:"TimetableEmployeeRoleWhere",
			update:"TimetableEmployeeRoleUpdateInput",
			create:"TimetableEmployeeRoleCreateInput"
		},
		createTimetableShift:{
			data:"TimetableShiftCreateInput"
		},
		deleteTimetableShift:{
			by:"TimetableShiftUniqueWhere",
			filter:"TimetableShiftWhere"
		},
		updateTimetableShift:{
			by:"TimetableShiftUniqueWhere",
			filter:"TimetableShiftWhere",
			data:"TimetableShiftUpdateInput"
		},
		upsertTimetableShift:{
			by:"TimetableShiftUniqueWhere",
			filter:"TimetableShiftWhere",
			update:"TimetableShiftUpdateInput",
			create:"TimetableShiftCreateInput"
		},
		createTimetableShiftGroup:{
			data:"TimetableShiftGroupCreateInput"
		},
		deleteTimetableShiftGroup:{
			by:"TimetableShiftGroupUniqueWhere",
			filter:"TimetableShiftGroupWhere"
		},
		updateTimetableShiftGroup:{
			by:"TimetableShiftGroupUniqueWhere",
			filter:"TimetableShiftGroupWhere",
			data:"TimetableShiftGroupUpdateInput"
		},
		upsertTimetableShiftGroup:{
			by:"TimetableShiftGroupUniqueWhere",
			filter:"TimetableShiftGroupWhere",
			update:"TimetableShiftGroupUpdateInput",
			create:"TimetableShiftGroupCreateInput"
		},
		createTimetableShiftPosition:{
			data:"TimetableShiftPositionCreateInput"
		},
		deleteTimetableShiftPosition:{
			by:"TimetableShiftPositionUniqueWhere",
			filter:"TimetableShiftPositionWhere"
		},
		updateTimetableShiftPosition:{
			by:"TimetableShiftPositionUniqueWhere",
			filter:"TimetableShiftPositionWhere",
			data:"TimetableShiftPositionUpdateInput"
		},
		upsertTimetableShiftPosition:{
			by:"TimetableShiftPositionUniqueWhere",
			filter:"TimetableShiftPositionWhere",
			update:"TimetableShiftPositionUpdateInput",
			create:"TimetableShiftPositionCreateInput"
		},
		createTimetableTemplate:{
			data:"TimetableTemplateCreateInput"
		},
		deleteTimetableTemplate:{
			by:"TimetableTemplateUniqueWhere",
			filter:"TimetableTemplateWhere"
		},
		updateTimetableTemplate:{
			by:"TimetableTemplateUniqueWhere",
			filter:"TimetableTemplateWhere",
			data:"TimetableTemplateUpdateInput"
		},
		upsertTimetableTemplate:{
			by:"TimetableTemplateUniqueWhere",
			filter:"TimetableTemplateWhere",
			update:"TimetableTemplateUpdateInput",
			create:"TimetableTemplateCreateInput"
		},
		createCart:{
			data:"CartCreateInput"
		},
		deleteCart:{
			by:"CartUniqueWhere",
			filter:"CartWhere"
		},
		updateCart:{
			by:"CartUniqueWhere",
			filter:"CartWhere",
			data:"CartUpdateInput"
		},
		upsertCart:{
			by:"CartUniqueWhere",
			filter:"CartWhere",
			update:"CartUpdateInput",
			create:"CartCreateInput"
		},
		createCartItem:{
			data:"CartItemCreateInput"
		},
		deleteCartItem:{
			by:"CartItemUniqueWhere",
			filter:"CartItemWhere"
		},
		updateCartItem:{
			by:"CartItemUniqueWhere",
			filter:"CartItemWhere",
			data:"CartItemUpdateInput"
		},
		upsertCartItem:{
			by:"CartItemUniqueWhere",
			filter:"CartItemWhere",
			update:"CartItemUpdateInput",
			create:"CartItemCreateInput"
		},
		createEmployeeQueueItem:{
			data:"EmployeeQueueItemCreateInput"
		},
		deleteEmployeeQueueItem:{
			by:"EmployeeQueueItemUniqueWhere",
			filter:"EmployeeQueueItemWhere"
		},
		updateEmployeeQueueItem:{
			by:"EmployeeQueueItemUniqueWhere",
			filter:"EmployeeQueueItemWhere",
			data:"EmployeeQueueItemUpdateInput"
		},
		upsertEmployeeQueueItem:{
			by:"EmployeeQueueItemUniqueWhere",
			filter:"EmployeeQueueItemWhere",
			update:"EmployeeQueueItemUpdateInput",
			create:"EmployeeQueueItemCreateInput"
		},
		createApplication:{
			data:"ApplicationCreateInput"
		},
		deleteApplication:{
			by:"ApplicationUniqueWhere",
			filter:"ApplicationWhere"
		},
		updateApplication:{
			by:"ApplicationUniqueWhere",
			filter:"ApplicationWhere",
			data:"ApplicationUpdateInput"
		},
		upsertApplication:{
			by:"ApplicationUniqueWhere",
			filter:"ApplicationWhere",
			update:"ApplicationUpdateInput",
			create:"ApplicationCreateInput"
		},
		createApplicationShortcutList:{
			data:"ApplicationShortcutListCreateInput"
		},
		deleteApplicationShortcutList:{
			by:"ApplicationShortcutListUniqueWhere",
			filter:"ApplicationShortcutListWhere"
		},
		updateApplicationShortcutList:{
			by:"ApplicationShortcutListUniqueWhere",
			filter:"ApplicationShortcutListWhere",
			data:"ApplicationShortcutListUpdateInput"
		},
		upsertApplicationShortcutList:{
			by:"ApplicationShortcutListUniqueWhere",
			filter:"ApplicationShortcutListWhere",
			update:"ApplicationShortcutListUpdateInput",
			create:"ApplicationShortcutListCreateInput"
		},
		createApplicationShortcutListItem:{
			data:"ApplicationShortcutListItemCreateInput"
		},
		deleteApplicationShortcutListItem:{
			by:"ApplicationShortcutListItemUniqueWhere",
			filter:"ApplicationShortcutListItemWhere"
		},
		updateApplicationShortcutListItem:{
			by:"ApplicationShortcutListItemUniqueWhere",
			filter:"ApplicationShortcutListItemWhere",
			data:"ApplicationShortcutListItemUpdateInput"
		},
		upsertApplicationShortcutListItem:{
			by:"ApplicationShortcutListItemUniqueWhere",
			filter:"ApplicationShortcutListItemWhere",
			update:"ApplicationShortcutListItemUpdateInput",
			create:"ApplicationShortcutListItemCreateInput"
		},
		createProductBanner:{
			data:"ProductBannerCreateInput"
		},
		deleteProductBanner:{
			by:"ProductBannerUniqueWhere",
			filter:"ProductBannerWhere"
		},
		updateProductBanner:{
			by:"ProductBannerUniqueWhere",
			filter:"ProductBannerWhere",
			data:"ProductBannerUpdateInput"
		},
		upsertProductBanner:{
			by:"ProductBannerUniqueWhere",
			filter:"ProductBannerWhere",
			update:"ProductBannerUpdateInput",
			create:"ProductBannerCreateInput"
		},
		createProductBannerItem:{
			data:"ProductBannerItemCreateInput"
		},
		deleteProductBannerItem:{
			by:"ProductBannerItemUniqueWhere",
			filter:"ProductBannerItemWhere"
		},
		updateProductBannerItem:{
			by:"ProductBannerItemUniqueWhere",
			filter:"ProductBannerItemWhere",
			data:"ProductBannerItemUpdateInput"
		},
		upsertProductBannerItem:{
			by:"ProductBannerItemUniqueWhere",
			filter:"ProductBannerItemWhere",
			update:"ProductBannerItemUpdateInput",
			create:"ProductBannerItemCreateInput"
		},
		createProductBannerList:{
			data:"ProductBannerListCreateInput"
		},
		deleteProductBannerList:{
			by:"ProductBannerListUniqueWhere",
			filter:"ProductBannerListWhere"
		},
		updateProductBannerList:{
			by:"ProductBannerListUniqueWhere",
			filter:"ProductBannerListWhere",
			data:"ProductBannerListUpdateInput"
		},
		upsertProductBannerList:{
			by:"ProductBannerListUniqueWhere",
			filter:"ProductBannerListWhere",
			update:"ProductBannerListUpdateInput",
			create:"ProductBannerListCreateInput"
		},
		createBartender:{
			data:"BartenderCreateInput"
		},
		deleteBartender:{
			by:"BartenderUniqueWhere",
			filter:"BartenderWhere"
		},
		updateBartender:{
			by:"BartenderUniqueWhere",
			filter:"BartenderWhere",
			data:"BartenderUpdateInput"
		},
		upsertBartender:{
			by:"BartenderUniqueWhere",
			filter:"BartenderWhere",
			update:"BartenderUpdateInput",
			create:"BartenderCreateInput"
		},
		createBusinessToBusinessManager:{
			data:"BusinessToBusinessManagerCreateInput"
		},
		deleteBusinessToBusinessManager:{
			by:"BusinessToBusinessManagerUniqueWhere",
			filter:"BusinessToBusinessManagerWhere"
		},
		updateBusinessToBusinessManager:{
			by:"BusinessToBusinessManagerUniqueWhere",
			filter:"BusinessToBusinessManagerWhere",
			data:"BusinessToBusinessManagerUpdateInput"
		},
		upsertBusinessToBusinessManager:{
			by:"BusinessToBusinessManagerUniqueWhere",
			filter:"BusinessToBusinessManagerWhere",
			update:"BusinessToBusinessManagerUpdateInput",
			create:"BusinessToBusinessManagerCreateInput"
		},
		createCleaner:{
			data:"CleanerCreateInput"
		},
		deleteCleaner:{
			by:"CleanerUniqueWhere",
			filter:"CleanerWhere"
		},
		updateCleaner:{
			by:"CleanerUniqueWhere",
			filter:"CleanerWhere",
			data:"CleanerUpdateInput"
		},
		upsertCleaner:{
			by:"CleanerUniqueWhere",
			filter:"CleanerWhere",
			update:"CleanerUpdateInput",
			create:"CleanerCreateInput"
		},
		createCourier:{
			data:"CourierCreateInput"
		},
		deleteCourier:{
			by:"CourierUniqueWhere",
			filter:"CourierWhere"
		},
		updateCourier:{
			by:"CourierUniqueWhere",
			filter:"CourierWhere",
			data:"CourierUpdateInput"
		},
		upsertCourier:{
			by:"CourierUniqueWhere",
			filter:"CourierWhere",
			update:"CourierUpdateInput",
			create:"CourierCreateInput"
		},
		createShiftsManager:{
			data:"ShiftsManagerCreateInput"
		},
		deleteShiftsManager:{
			by:"ShiftsManagerUniqueWhere",
			filter:"ShiftsManagerWhere"
		},
		updateShiftsManager:{
			by:"ShiftsManagerUniqueWhere",
			filter:"ShiftsManagerWhere",
			data:"ShiftsManagerUpdateInput"
		},
		upsertShiftsManager:{
			by:"ShiftsManagerUniqueWhere",
			filter:"ShiftsManagerWhere",
			update:"ShiftsManagerUpdateInput",
			create:"ShiftsManagerCreateInput"
		},
		createUser:{
			data:"UserCreateInput"
		},
		deleteUser:{
			by:"UserUniqueWhere",
			filter:"UserWhere"
		},
		updateUser:{
			by:"UserUniqueWhere",
			filter:"UserWhere",
			data:"UserUpdateInput"
		},
		upsertUser:{
			by:"UserUniqueWhere",
			filter:"UserWhere",
			update:"UserUpdateInput",
			create:"UserCreateInput"
		},
		createShiftsProfile:{
			data:"ShiftsProfileCreateInput"
		},
		deleteShiftsProfile:{
			by:"ShiftsProfileUniqueWhere",
			filter:"ShiftsProfileWhere"
		},
		updateShiftsProfile:{
			by:"ShiftsProfileUniqueWhere",
			filter:"ShiftsProfileWhere",
			data:"ShiftsProfileUpdateInput"
		},
		upsertShiftsProfile:{
			by:"ShiftsProfileUniqueWhere",
			filter:"ShiftsProfileWhere",
			update:"ShiftsProfileUpdateInput",
			create:"ShiftsProfileCreateInput"
		},
		createProductIngredientCategory:{
			data:"ProductIngredientCategoryCreateInput"
		},
		deleteProductIngredientCategory:{
			by:"ProductIngredientCategoryUniqueWhere",
			filter:"ProductIngredientCategoryWhere"
		},
		updateProductIngredientCategory:{
			by:"ProductIngredientCategoryUniqueWhere",
			filter:"ProductIngredientCategoryWhere",
			data:"ProductIngredientCategoryUpdateInput"
		},
		upsertProductIngredientCategory:{
			by:"ProductIngredientCategoryUniqueWhere",
			filter:"ProductIngredientCategoryWhere",
			update:"ProductIngredientCategoryUpdateInput",
			create:"ProductIngredientCategoryCreateInput"
		},
		createProductIngredientCategoryLocale:{
			data:"ProductIngredientCategoryLocaleCreateInput"
		},
		deleteProductIngredientCategoryLocale:{
			by:"ProductIngredientCategoryLocaleUniqueWhere",
			filter:"ProductIngredientCategoryLocaleWhere"
		},
		updateProductIngredientCategoryLocale:{
			by:"ProductIngredientCategoryLocaleUniqueWhere",
			filter:"ProductIngredientCategoryLocaleWhere",
			data:"ProductIngredientCategoryLocaleUpdateInput"
		},
		upsertProductIngredientCategoryLocale:{
			by:"ProductIngredientCategoryLocaleUniqueWhere",
			filter:"ProductIngredientCategoryLocaleWhere",
			update:"ProductIngredientCategoryLocaleUpdateInput",
			create:"ProductIngredientCategoryLocaleCreateInput"
		},
		createStocksManager:{
			data:"StocksManagerCreateInput"
		},
		deleteStocksManager:{
			by:"StocksManagerUniqueWhere",
			filter:"StocksManagerWhere"
		},
		updateStocksManager:{
			by:"StocksManagerUniqueWhere",
			filter:"StocksManagerWhere",
			data:"StocksManagerUpdateInput"
		},
		upsertStocksManager:{
			by:"StocksManagerUniqueWhere",
			filter:"StocksManagerWhere",
			update:"StocksManagerUpdateInput",
			create:"StocksManagerCreateInput"
		},
		createDeliveryRoute:{
			data:"DeliveryRouteCreateInput"
		},
		deleteDeliveryRoute:{
			by:"DeliveryRouteUniqueWhere",
			filter:"DeliveryRouteWhere"
		},
		updateDeliveryRoute:{
			by:"DeliveryRouteUniqueWhere",
			filter:"DeliveryRouteWhere",
			data:"DeliveryRouteUpdateInput"
		},
		upsertDeliveryRoute:{
			by:"DeliveryRouteUniqueWhere",
			filter:"DeliveryRouteWhere",
			update:"DeliveryRouteUpdateInput",
			create:"DeliveryRouteCreateInput"
		},
		createDeliveryWaypoint:{
			data:"DeliveryWaypointCreateInput"
		},
		deleteDeliveryWaypoint:{
			by:"DeliveryWaypointUniqueWhere",
			filter:"DeliveryWaypointWhere"
		},
		updateDeliveryWaypoint:{
			by:"DeliveryWaypointUniqueWhere",
			filter:"DeliveryWaypointWhere",
			data:"DeliveryWaypointUpdateInput"
		},
		upsertDeliveryWaypoint:{
			by:"DeliveryWaypointUniqueWhere",
			filter:"DeliveryWaypointWhere",
			update:"DeliveryWaypointUpdateInput",
			create:"DeliveryWaypointCreateInput"
		},
		createAllergen:{
			data:"AllergenCreateInput"
		},
		deleteAllergen:{
			by:"AllergenUniqueWhere",
			filter:"AllergenWhere"
		},
		updateAllergen:{
			by:"AllergenUniqueWhere",
			filter:"AllergenWhere",
			data:"AllergenUpdateInput"
		},
		upsertAllergen:{
			by:"AllergenUniqueWhere",
			filter:"AllergenWhere",
			update:"AllergenUpdateInput",
			create:"AllergenCreateInput"
		},
		createAllergenLocale:{
			data:"AllergenLocaleCreateInput"
		},
		deleteAllergenLocale:{
			by:"AllergenLocaleUniqueWhere",
			filter:"AllergenLocaleWhere"
		},
		updateAllergenLocale:{
			by:"AllergenLocaleUniqueWhere",
			filter:"AllergenLocaleWhere",
			data:"AllergenLocaleUpdateInput"
		},
		upsertAllergenLocale:{
			by:"AllergenLocaleUniqueWhere",
			filter:"AllergenLocaleWhere",
			update:"AllergenLocaleUpdateInput",
			create:"AllergenLocaleCreateInput"
		},
		createGps:{
			data:"GpsCreateInput"
		},
		deleteGps:{
			by:"GpsUniqueWhere",
			filter:"GpsWhere"
		},
		updateGps:{
			by:"GpsUniqueWhere",
			filter:"GpsWhere",
			data:"GpsUpdateInput"
		},
		upsertGps:{
			by:"GpsUniqueWhere",
			filter:"GpsWhere",
			update:"GpsUpdateInput",
			create:"GpsCreateInput"
		},
		createWeekHours:{
			data:"WeekHoursCreateInput"
		},
		deleteWeekHours:{
			by:"WeekHoursUniqueWhere",
			filter:"WeekHoursWhere"
		},
		updateWeekHours:{
			by:"WeekHoursUniqueWhere",
			filter:"WeekHoursWhere",
			data:"WeekHoursUpdateInput"
		},
		upsertWeekHours:{
			by:"WeekHoursUniqueWhere",
			filter:"WeekHoursWhere",
			update:"WeekHoursUpdateInput",
			create:"WeekHoursCreateInput"
		},
		createPreparedIngredientQuantity:{
			data:"PreparedIngredientQuantityCreateInput"
		},
		deletePreparedIngredientQuantity:{
			by:"PreparedIngredientQuantityUniqueWhere",
			filter:"PreparedIngredientQuantityWhere"
		},
		updatePreparedIngredientQuantity:{
			by:"PreparedIngredientQuantityUniqueWhere",
			filter:"PreparedIngredientQuantityWhere",
			data:"PreparedIngredientQuantityUpdateInput"
		},
		upsertPreparedIngredientQuantity:{
			by:"PreparedIngredientQuantityUniqueWhere",
			filter:"PreparedIngredientQuantityWhere",
			update:"PreparedIngredientQuantityUpdateInput",
			create:"PreparedIngredientQuantityCreateInput"
		},
		createPreparedRecipeQuantity:{
			data:"PreparedRecipeQuantityCreateInput"
		},
		deletePreparedRecipeQuantity:{
			by:"PreparedRecipeQuantityUniqueWhere",
			filter:"PreparedRecipeQuantityWhere"
		},
		updatePreparedRecipeQuantity:{
			by:"PreparedRecipeQuantityUniqueWhere",
			filter:"PreparedRecipeQuantityWhere",
			data:"PreparedRecipeQuantityUpdateInput"
		},
		upsertPreparedRecipeQuantity:{
			by:"PreparedRecipeQuantityUniqueWhere",
			filter:"PreparedRecipeQuantityWhere",
			update:"PreparedRecipeQuantityUpdateInput",
			create:"PreparedRecipeQuantityCreateInput"
		},
		createInternalOrder:{
			data:"InternalOrderCreateInput"
		},
		deleteInternalOrder:{
			by:"InternalOrderUniqueWhere",
			filter:"InternalOrderWhere"
		},
		updateInternalOrder:{
			by:"InternalOrderUniqueWhere",
			filter:"InternalOrderWhere",
			data:"InternalOrderUpdateInput"
		},
		upsertInternalOrder:{
			by:"InternalOrderUniqueWhere",
			filter:"InternalOrderWhere",
			update:"InternalOrderUpdateInput",
			create:"InternalOrderCreateInput"
		},
		createInternalOrderItem:{
			data:"InternalOrderItemCreateInput"
		},
		deleteInternalOrderItem:{
			by:"InternalOrderItemUniqueWhere",
			filter:"InternalOrderItemWhere"
		},
		updateInternalOrderItem:{
			by:"InternalOrderItemUniqueWhere",
			filter:"InternalOrderItemWhere",
			data:"InternalOrderItemUpdateInput"
		},
		upsertInternalOrderItem:{
			by:"InternalOrderItemUniqueWhere",
			filter:"InternalOrderItemWhere",
			update:"InternalOrderItemUpdateInput",
			create:"InternalOrderItemCreateInput"
		},
		createPreparedPackingQuantity:{
			data:"PreparedPackingQuantityCreateInput"
		},
		deletePreparedPackingQuantity:{
			by:"PreparedPackingQuantityUniqueWhere",
			filter:"PreparedPackingQuantityWhere"
		},
		updatePreparedPackingQuantity:{
			by:"PreparedPackingQuantityUniqueWhere",
			filter:"PreparedPackingQuantityWhere",
			data:"PreparedPackingQuantityUpdateInput"
		},
		upsertPreparedPackingQuantity:{
			by:"PreparedPackingQuantityUniqueWhere",
			filter:"PreparedPackingQuantityWhere",
			update:"PreparedPackingQuantityUpdateInput",
			create:"PreparedPackingQuantityCreateInput"
		},
		createCourierManager:{
			data:"CourierManagerCreateInput"
		},
		deleteCourierManager:{
			by:"CourierManagerUniqueWhere",
			filter:"CourierManagerWhere"
		},
		updateCourierManager:{
			by:"CourierManagerUniqueWhere",
			filter:"CourierManagerWhere",
			data:"CourierManagerUpdateInput"
		},
		upsertCourierManager:{
			by:"CourierManagerUniqueWhere",
			filter:"CourierManagerWhere",
			update:"CourierManagerUpdateInput",
			create:"CourierManagerCreateInput"
		},
		createDeliveryZone:{
			data:"DeliveryZoneCreateInput"
		},
		deleteDeliveryZone:{
			by:"DeliveryZoneUniqueWhere",
			filter:"DeliveryZoneWhere"
		},
		updateDeliveryZone:{
			by:"DeliveryZoneUniqueWhere",
			filter:"DeliveryZoneWhere",
			data:"DeliveryZoneUpdateInput"
		},
		upsertDeliveryZone:{
			by:"DeliveryZoneUniqueWhere",
			filter:"DeliveryZoneWhere",
			update:"DeliveryZoneUpdateInput",
			create:"DeliveryZoneCreateInput"
		},
		createDeliveryTimelinePreset:{
			data:"DeliveryTimelinePresetCreateInput"
		},
		deleteDeliveryTimelinePreset:{
			by:"DeliveryTimelinePresetUniqueWhere",
			filter:"DeliveryTimelinePresetWhere"
		},
		updateDeliveryTimelinePreset:{
			by:"DeliveryTimelinePresetUniqueWhere",
			filter:"DeliveryTimelinePresetWhere",
			data:"DeliveryTimelinePresetUpdateInput"
		},
		upsertDeliveryTimelinePreset:{
			by:"DeliveryTimelinePresetUniqueWhere",
			filter:"DeliveryTimelinePresetWhere",
			update:"DeliveryTimelinePresetUpdateInput",
			create:"DeliveryTimelinePresetCreateInput"
		},
		createOrderDeliveryTimeline:{
			data:"OrderDeliveryTimelineCreateInput"
		},
		deleteOrderDeliveryTimeline:{
			by:"OrderDeliveryTimelineUniqueWhere",
			filter:"OrderDeliveryTimelineWhere"
		},
		updateOrderDeliveryTimeline:{
			by:"OrderDeliveryTimelineUniqueWhere",
			filter:"OrderDeliveryTimelineWhere",
			data:"OrderDeliveryTimelineUpdateInput"
		},
		upsertOrderDeliveryTimeline:{
			by:"OrderDeliveryTimelineUniqueWhere",
			filter:"OrderDeliveryTimelineWhere",
			update:"OrderDeliveryTimelineUpdateInput",
			create:"OrderDeliveryTimelineCreateInput"
		},
		createOrderEvent:{
			data:"OrderEventCreateInput"
		},
		deleteOrderEvent:{
			by:"OrderEventUniqueWhere",
			filter:"OrderEventWhere"
		},
		updateOrderEvent:{
			by:"OrderEventUniqueWhere",
			filter:"OrderEventWhere",
			data:"OrderEventUpdateInput"
		},
		upsertOrderEvent:{
			by:"OrderEventUniqueWhere",
			filter:"OrderEventWhere",
			update:"OrderEventUpdateInput",
			create:"OrderEventCreateInput"
		},
		createLiftagoRide:{
			data:"LiftagoRideCreateInput"
		},
		deleteLiftagoRide:{
			by:"LiftagoRideUniqueWhere",
			filter:"LiftagoRideWhere"
		},
		updateLiftagoRide:{
			by:"LiftagoRideUniqueWhere",
			filter:"LiftagoRideWhere",
			data:"LiftagoRideUpdateInput"
		},
		upsertLiftagoRide:{
			by:"LiftagoRideUniqueWhere",
			filter:"LiftagoRideWhere",
			update:"LiftagoRideUpdateInput",
			create:"LiftagoRideCreateInput"
		},
		createInvoice:{
			data:"InvoiceCreateInput"
		},
		deleteInvoice:{
			by:"InvoiceUniqueWhere",
			filter:"InvoiceWhere"
		},
		updateInvoice:{
			by:"InvoiceUniqueWhere",
			filter:"InvoiceWhere",
			data:"InvoiceUpdateInput"
		},
		upsertInvoice:{
			by:"InvoiceUniqueWhere",
			filter:"InvoiceWhere",
			update:"InvoiceUpdateInput",
			create:"InvoiceCreateInput"
		},
		createInvoicingPlan:{
			data:"InvoicingPlanCreateInput"
		},
		deleteInvoicingPlan:{
			by:"InvoicingPlanUniqueWhere",
			filter:"InvoicingPlanWhere"
		},
		updateInvoicingPlan:{
			by:"InvoicingPlanUniqueWhere",
			filter:"InvoicingPlanWhere",
			data:"InvoicingPlanUpdateInput"
		},
		upsertInvoicingPlan:{
			by:"InvoicingPlanUniqueWhere",
			filter:"InvoicingPlanWhere",
			update:"InvoicingPlanUpdateInput",
			create:"InvoicingPlanCreateInput"
		},
		createProductPackingLocale:{
			data:"ProductPackingLocaleCreateInput"
		},
		deleteProductPackingLocale:{
			by:"ProductPackingLocaleUniqueWhere",
			filter:"ProductPackingLocaleWhere"
		},
		updateProductPackingLocale:{
			by:"ProductPackingLocaleUniqueWhere",
			filter:"ProductPackingLocaleWhere",
			data:"ProductPackingLocaleUpdateInput"
		},
		upsertProductPackingLocale:{
			by:"ProductPackingLocaleUniqueWhere",
			filter:"ProductPackingLocaleWhere",
			update:"ProductPackingLocaleUpdateInput",
			create:"ProductPackingLocaleCreateInput"
		},
		createProductLocale:{
			data:"ProductLocaleCreateInput"
		},
		deleteProductLocale:{
			by:"ProductLocaleUniqueWhere",
			filter:"ProductLocaleWhere"
		},
		updateProductLocale:{
			by:"ProductLocaleUniqueWhere",
			filter:"ProductLocaleWhere",
			data:"ProductLocaleUpdateInput"
		},
		upsertProductLocale:{
			by:"ProductLocaleUniqueWhere",
			filter:"ProductLocaleWhere",
			update:"ProductLocaleUpdateInput",
			create:"ProductLocaleCreateInput"
		},
		createProductRecipeLocale:{
			data:"ProductRecipeLocaleCreateInput"
		},
		deleteProductRecipeLocale:{
			by:"ProductRecipeLocaleUniqueWhere",
			filter:"ProductRecipeLocaleWhere"
		},
		updateProductRecipeLocale:{
			by:"ProductRecipeLocaleUniqueWhere",
			filter:"ProductRecipeLocaleWhere",
			data:"ProductRecipeLocaleUpdateInput"
		},
		upsertProductRecipeLocale:{
			by:"ProductRecipeLocaleUniqueWhere",
			filter:"ProductRecipeLocaleWhere",
			update:"ProductRecipeLocaleUpdateInput",
			create:"ProductRecipeLocaleCreateInput"
		},
		createUserDevice:{
			data:"UserDeviceCreateInput"
		},
		deleteUserDevice:{
			by:"UserDeviceUniqueWhere",
			filter:"UserDeviceWhere"
		},
		updateUserDevice:{
			by:"UserDeviceUniqueWhere",
			filter:"UserDeviceWhere",
			data:"UserDeviceUpdateInput"
		},
		upsertUserDevice:{
			by:"UserDeviceUniqueWhere",
			filter:"UserDeviceWhere",
			update:"UserDeviceUpdateInput",
			create:"UserDeviceCreateInput"
		},
		createProtectedAction:{
			data:"ProtectedActionCreateInput"
		},
		deleteProtectedAction:{
			by:"ProtectedActionUniqueWhere",
			filter:"ProtectedActionWhere"
		},
		updateProtectedAction:{
			by:"ProtectedActionUniqueWhere",
			filter:"ProtectedActionWhere",
			data:"ProtectedActionUpdateInput"
		},
		upsertProtectedAction:{
			by:"ProtectedActionUniqueWhere",
			filter:"ProtectedActionWhere",
			update:"ProtectedActionUpdateInput",
			create:"ProtectedActionCreateInput"
		},
		createPicker:{
			data:"PickerCreateInput"
		},
		deletePicker:{
			by:"PickerUniqueWhere",
			filter:"PickerWhere"
		},
		updatePicker:{
			by:"PickerUniqueWhere",
			filter:"PickerWhere",
			data:"PickerUpdateInput"
		},
		upsertPicker:{
			by:"PickerUniqueWhere",
			filter:"PickerWhere",
			update:"PickerUpdateInput",
			create:"PickerCreateInput"
		},
		createTimetableTemplateStaffOptions:{
			data:"TimetableTemplateStaffOptionsCreateInput"
		},
		deleteTimetableTemplateStaffOptions:{
			by:"TimetableTemplateStaffOptionsUniqueWhere",
			filter:"TimetableTemplateStaffOptionsWhere"
		},
		updateTimetableTemplateStaffOptions:{
			by:"TimetableTemplateStaffOptionsUniqueWhere",
			filter:"TimetableTemplateStaffOptionsWhere",
			data:"TimetableTemplateStaffOptionsUpdateInput"
		},
		upsertTimetableTemplateStaffOptions:{
			by:"TimetableTemplateStaffOptionsUniqueWhere",
			filter:"TimetableTemplateStaffOptionsWhere",
			update:"TimetableTemplateStaffOptionsUpdateInput",
			create:"TimetableTemplateStaffOptionsCreateInput"
		},
		createShoppingList:{
			data:"ShoppingListCreateInput"
		},
		deleteShoppingList:{
			by:"ShoppingListUniqueWhere",
			filter:"ShoppingListWhere"
		},
		updateShoppingList:{
			by:"ShoppingListUniqueWhere",
			filter:"ShoppingListWhere",
			data:"ShoppingListUpdateInput"
		},
		upsertShoppingList:{
			by:"ShoppingListUniqueWhere",
			filter:"ShoppingListWhere",
			update:"ShoppingListUpdateInput",
			create:"ShoppingListCreateInput"
		},
		createSuppliesPurchase:{
			data:"SuppliesPurchaseCreateInput"
		},
		deleteSuppliesPurchase:{
			by:"SuppliesPurchaseUniqueWhere",
			filter:"SuppliesPurchaseWhere"
		},
		updateSuppliesPurchase:{
			by:"SuppliesPurchaseUniqueWhere",
			filter:"SuppliesPurchaseWhere",
			data:"SuppliesPurchaseUpdateInput"
		},
		upsertSuppliesPurchase:{
			by:"SuppliesPurchaseUniqueWhere",
			filter:"SuppliesPurchaseWhere",
			update:"SuppliesPurchaseUpdateInput",
			create:"SuppliesPurchaseCreateInput"
		},
		createInvoicingPreset:{
			data:"InvoicingPresetCreateInput"
		},
		deleteInvoicingPreset:{
			by:"InvoicingPresetUniqueWhere",
			filter:"InvoicingPresetWhere"
		},
		updateInvoicingPreset:{
			by:"InvoicingPresetUniqueWhere",
			filter:"InvoicingPresetWhere",
			data:"InvoicingPresetUpdateInput"
		},
		upsertInvoicingPreset:{
			by:"InvoicingPresetUniqueWhere",
			filter:"InvoicingPresetWhere",
			update:"InvoicingPresetUpdateInput",
			create:"InvoicingPresetCreateInput"
		},
		createLogRecord:{
			data:"LogRecordCreateInput"
		},
		deleteLogRecord:{
			by:"LogRecordUniqueWhere",
			filter:"LogRecordWhere"
		},
		updateLogRecord:{
			by:"LogRecordUniqueWhere",
			filter:"LogRecordWhere",
			data:"LogRecordUpdateInput"
		},
		upsertLogRecord:{
			by:"LogRecordUniqueWhere",
			filter:"LogRecordWhere",
			update:"LogRecordUpdateInput",
			create:"LogRecordCreateInput"
		},
		createBillingSubject:{
			data:"BillingSubjectCreateInput"
		},
		deleteBillingSubject:{
			by:"BillingSubjectUniqueWhere",
			filter:"BillingSubjectWhere"
		},
		updateBillingSubject:{
			by:"BillingSubjectUniqueWhere",
			filter:"BillingSubjectWhere",
			data:"BillingSubjectUpdateInput"
		},
		upsertBillingSubject:{
			by:"BillingSubjectUniqueWhere",
			filter:"BillingSubjectWhere",
			update:"BillingSubjectUpdateInput",
			create:"BillingSubjectCreateInput"
		},
		createShoppingListItem:{
			data:"ShoppingListItemCreateInput"
		},
		deleteShoppingListItem:{
			by:"ShoppingListItemUniqueWhere",
			filter:"ShoppingListItemWhere"
		},
		updateShoppingListItem:{
			by:"ShoppingListItemUniqueWhere",
			filter:"ShoppingListItemWhere",
			data:"ShoppingListItemUpdateInput"
		},
		upsertShoppingListItem:{
			by:"ShoppingListItemUniqueWhere",
			filter:"ShoppingListItemWhere",
			update:"ShoppingListItemUpdateInput",
			create:"ShoppingListItemCreateInput"
		},
		createSuppliesPurchaseItem:{
			data:"SuppliesPurchaseItemCreateInput"
		},
		deleteSuppliesPurchaseItem:{
			by:"SuppliesPurchaseItemUniqueWhere",
			filter:"SuppliesPurchaseItemWhere"
		},
		updateSuppliesPurchaseItem:{
			by:"SuppliesPurchaseItemUniqueWhere",
			filter:"SuppliesPurchaseItemWhere",
			data:"SuppliesPurchaseItemUpdateInput"
		},
		upsertSuppliesPurchaseItem:{
			by:"SuppliesPurchaseItemUniqueWhere",
			filter:"SuppliesPurchaseItemWhere",
			update:"SuppliesPurchaseItemUpdateInput",
			create:"SuppliesPurchaseItemCreateInput"
		},
		createCustomerCreditTransaction:{
			data:"CustomerCreditTransactionCreateInput"
		},
		deleteCustomerCreditTransaction:{
			by:"CustomerCreditTransactionUniqueWhere",
			filter:"CustomerCreditTransactionWhere"
		},
		updateCustomerCreditTransaction:{
			by:"CustomerCreditTransactionUniqueWhere",
			filter:"CustomerCreditTransactionWhere",
			data:"CustomerCreditTransactionUpdateInput"
		},
		upsertCustomerCreditTransaction:{
			by:"CustomerCreditTransactionUniqueWhere",
			filter:"CustomerCreditTransactionWhere",
			update:"CustomerCreditTransactionUpdateInput",
			create:"CustomerCreditTransactionCreateInput"
		},
		createVirtualProduct:{
			data:"VirtualProductCreateInput"
		},
		deleteVirtualProduct:{
			by:"VirtualProductUniqueWhere",
			filter:"VirtualProductWhere"
		},
		updateVirtualProduct:{
			by:"VirtualProductUniqueWhere",
			filter:"VirtualProductWhere",
			data:"VirtualProductUpdateInput"
		},
		upsertVirtualProduct:{
			by:"VirtualProductUniqueWhere",
			filter:"VirtualProductWhere",
			update:"VirtualProductUpdateInput",
			create:"VirtualProductCreateInput"
		},
		createVirtualProductEffect:{
			data:"VirtualProductEffectCreateInput"
		},
		deleteVirtualProductEffect:{
			by:"VirtualProductEffectUniqueWhere",
			filter:"VirtualProductEffectWhere"
		},
		updateVirtualProductEffect:{
			by:"VirtualProductEffectUniqueWhere",
			filter:"VirtualProductEffectWhere",
			data:"VirtualProductEffectUpdateInput"
		},
		upsertVirtualProductEffect:{
			by:"VirtualProductEffectUniqueWhere",
			filter:"VirtualProductEffectWhere",
			update:"VirtualProductEffectUpdateInput",
			create:"VirtualProductEffectCreateInput"
		},
		createEmploymentInformation:{
			data:"EmploymentInformationCreateInput"
		},
		deleteEmploymentInformation:{
			by:"EmploymentInformationUniqueWhere",
			filter:"EmploymentInformationWhere"
		},
		updateEmploymentInformation:{
			by:"EmploymentInformationUniqueWhere",
			filter:"EmploymentInformationWhere",
			data:"EmploymentInformationUpdateInput"
		},
		upsertEmploymentInformation:{
			by:"EmploymentInformationUniqueWhere",
			filter:"EmploymentInformationWhere",
			update:"EmploymentInformationUpdateInput",
			create:"EmploymentInformationCreateInput"
		},
		createRemunerationProfile:{
			data:"RemunerationProfileCreateInput"
		},
		deleteRemunerationProfile:{
			by:"RemunerationProfileUniqueWhere",
			filter:"RemunerationProfileWhere"
		},
		updateRemunerationProfile:{
			by:"RemunerationProfileUniqueWhere",
			filter:"RemunerationProfileWhere",
			data:"RemunerationProfileUpdateInput"
		},
		upsertRemunerationProfile:{
			by:"RemunerationProfileUniqueWhere",
			filter:"RemunerationProfileWhere",
			update:"RemunerationProfileUpdateInput",
			create:"RemunerationProfileCreateInput"
		},
		createWorkMonth:{
			data:"WorkMonthCreateInput"
		},
		deleteWorkMonth:{
			by:"WorkMonthUniqueWhere",
			filter:"WorkMonthWhere"
		},
		updateWorkMonth:{
			by:"WorkMonthUniqueWhere",
			filter:"WorkMonthWhere",
			data:"WorkMonthUpdateInput"
		},
		upsertWorkMonth:{
			by:"WorkMonthUniqueWhere",
			filter:"WorkMonthWhere",
			update:"WorkMonthUpdateInput",
			create:"WorkMonthCreateInput"
		},
		createSalaryOptions:{
			data:"SalaryOptionsCreateInput"
		},
		deleteSalaryOptions:{
			by:"SalaryOptionsUniqueWhere",
			filter:"SalaryOptionsWhere"
		},
		updateSalaryOptions:{
			by:"SalaryOptionsUniqueWhere",
			filter:"SalaryOptionsWhere",
			data:"SalaryOptionsUpdateInput"
		},
		upsertSalaryOptions:{
			by:"SalaryOptionsUniqueWhere",
			filter:"SalaryOptionsWhere",
			update:"SalaryOptionsUpdateInput",
			create:"SalaryOptionsCreateInput"
		},
		createTimetableShiftSwapInfo:{
			data:"TimetableShiftSwapInfoCreateInput"
		},
		deleteTimetableShiftSwapInfo:{
			by:"TimetableShiftSwapInfoUniqueWhere",
			filter:"TimetableShiftSwapInfoWhere"
		},
		updateTimetableShiftSwapInfo:{
			by:"TimetableShiftSwapInfoUniqueWhere",
			filter:"TimetableShiftSwapInfoWhere",
			data:"TimetableShiftSwapInfoUpdateInput"
		},
		upsertTimetableShiftSwapInfo:{
			by:"TimetableShiftSwapInfoUniqueWhere",
			filter:"TimetableShiftSwapInfoWhere",
			update:"TimetableShiftSwapInfoUpdateInput",
			create:"TimetableShiftSwapInfoCreateInput"
		},
		createProductGridCategory:{
			data:"ProductGridCategoryCreateInput"
		},
		deleteProductGridCategory:{
			by:"ProductGridCategoryUniqueWhere",
			filter:"ProductGridCategoryWhere"
		},
		updateProductGridCategory:{
			by:"ProductGridCategoryUniqueWhere",
			filter:"ProductGridCategoryWhere",
			data:"ProductGridCategoryUpdateInput"
		},
		upsertProductGridCategory:{
			by:"ProductGridCategoryUniqueWhere",
			filter:"ProductGridCategoryWhere",
			update:"ProductGridCategoryUpdateInput",
			create:"ProductGridCategoryCreateInput"
		},
		createCashier:{
			data:"CashierCreateInput"
		},
		deleteCashier:{
			by:"CashierUniqueWhere",
			filter:"CashierWhere"
		},
		updateCashier:{
			by:"CashierUniqueWhere",
			filter:"CashierWhere",
			data:"CashierUpdateInput"
		},
		upsertCashier:{
			by:"CashierUniqueWhere",
			filter:"CashierWhere",
			update:"CashierUpdateInput",
			create:"CashierCreateInput"
		},
		createPointOfSaleCategory:{
			data:"PointOfSaleCategoryCreateInput"
		},
		deletePointOfSaleCategory:{
			by:"PointOfSaleCategoryUniqueWhere",
			filter:"PointOfSaleCategoryWhere"
		},
		updatePointOfSaleCategory:{
			by:"PointOfSaleCategoryUniqueWhere",
			filter:"PointOfSaleCategoryWhere",
			data:"PointOfSaleCategoryUpdateInput"
		},
		upsertPointOfSaleCategory:{
			by:"PointOfSaleCategoryUniqueWhere",
			filter:"PointOfSaleCategoryWhere",
			update:"PointOfSaleCategoryUpdateInput",
			create:"PointOfSaleCategoryCreateInput"
		},
		createPointOfSaleCategoryLocale:{
			data:"PointOfSaleCategoryLocaleCreateInput"
		},
		deletePointOfSaleCategoryLocale:{
			by:"PointOfSaleCategoryLocaleUniqueWhere",
			filter:"PointOfSaleCategoryLocaleWhere"
		},
		updatePointOfSaleCategoryLocale:{
			by:"PointOfSaleCategoryLocaleUniqueWhere",
			filter:"PointOfSaleCategoryLocaleWhere",
			data:"PointOfSaleCategoryLocaleUpdateInput"
		},
		upsertPointOfSaleCategoryLocale:{
			by:"PointOfSaleCategoryLocaleUniqueWhere",
			filter:"PointOfSaleCategoryLocaleWhere",
			update:"PointOfSaleCategoryLocaleUpdateInput",
			create:"PointOfSaleCategoryLocaleCreateInput"
		},
		createPointOfSaleCategoryProduct:{
			data:"PointOfSaleCategoryProductCreateInput"
		},
		deletePointOfSaleCategoryProduct:{
			by:"PointOfSaleCategoryProductUniqueWhere",
			filter:"PointOfSaleCategoryProductWhere"
		},
		updatePointOfSaleCategoryProduct:{
			by:"PointOfSaleCategoryProductUniqueWhere",
			filter:"PointOfSaleCategoryProductWhere",
			data:"PointOfSaleCategoryProductUpdateInput"
		},
		upsertPointOfSaleCategoryProduct:{
			by:"PointOfSaleCategoryProductUniqueWhere",
			filter:"PointOfSaleCategoryProductWhere",
			update:"PointOfSaleCategoryProductUpdateInput",
			create:"PointOfSaleCategoryProductCreateInput"
		},
		createPointOfSaleCategoryProductLocale:{
			data:"PointOfSaleCategoryProductLocaleCreateInput"
		},
		deletePointOfSaleCategoryProductLocale:{
			by:"PointOfSaleCategoryProductLocaleUniqueWhere",
			filter:"PointOfSaleCategoryProductLocaleWhere"
		},
		updatePointOfSaleCategoryProductLocale:{
			by:"PointOfSaleCategoryProductLocaleUniqueWhere",
			filter:"PointOfSaleCategoryProductLocaleWhere",
			data:"PointOfSaleCategoryProductLocaleUpdateInput"
		},
		upsertPointOfSaleCategoryProductLocale:{
			by:"PointOfSaleCategoryProductLocaleUniqueWhere",
			filter:"PointOfSaleCategoryProductLocaleWhere",
			update:"PointOfSaleCategoryProductLocaleUpdateInput",
			create:"PointOfSaleCategoryProductLocaleCreateInput"
		},
		createCustomerTab:{
			data:"CustomerTabCreateInput"
		},
		deleteCustomerTab:{
			by:"CustomerTabUniqueWhere",
			filter:"CustomerTabWhere"
		},
		updateCustomerTab:{
			by:"CustomerTabUniqueWhere",
			filter:"CustomerTabWhere",
			data:"CustomerTabUpdateInput"
		},
		upsertCustomerTab:{
			by:"CustomerTabUniqueWhere",
			filter:"CustomerTabWhere",
			update:"CustomerTabUpdateInput",
			create:"CustomerTabCreateInput"
		},
		createCustomerTabItem:{
			data:"CustomerTabItemCreateInput"
		},
		deleteCustomerTabItem:{
			by:"CustomerTabItemUniqueWhere",
			filter:"CustomerTabItemWhere"
		},
		updateCustomerTabItem:{
			by:"CustomerTabItemUniqueWhere",
			filter:"CustomerTabItemWhere",
			data:"CustomerTabItemUpdateInput"
		},
		upsertCustomerTabItem:{
			by:"CustomerTabItemUniqueWhere",
			filter:"CustomerTabItemWhere",
			update:"CustomerTabItemUpdateInput",
			create:"CustomerTabItemCreateInput"
		},
		createAnonymousSession:{
			data:"AnonymousSessionCreateInput"
		},
		deleteAnonymousSession:{
			by:"AnonymousSessionUniqueWhere",
			filter:"AnonymousSessionWhere"
		},
		updateAnonymousSession:{
			by:"AnonymousSessionUniqueWhere",
			filter:"AnonymousSessionWhere",
			data:"AnonymousSessionUpdateInput"
		},
		upsertAnonymousSession:{
			by:"AnonymousSessionUniqueWhere",
			filter:"AnonymousSessionWhere",
			update:"AnonymousSessionUpdateInput",
			create:"AnonymousSessionCreateInput"
		},
		createVoucher:{
			data:"VoucherCreateInput"
		},
		deleteVoucher:{
			by:"VoucherUniqueWhere",
			filter:"VoucherWhere"
		},
		updateVoucher:{
			by:"VoucherUniqueWhere",
			filter:"VoucherWhere",
			data:"VoucherUpdateInput"
		},
		upsertVoucher:{
			by:"VoucherUniqueWhere",
			filter:"VoucherWhere",
			update:"VoucherUpdateInput",
			create:"VoucherCreateInput"
		},
		createVoucherRedemption:{
			data:"VoucherRedemptionCreateInput"
		},
		deleteVoucherRedemption:{
			by:"VoucherRedemptionUniqueWhere",
			filter:"VoucherRedemptionWhere"
		},
		updateVoucherRedemption:{
			by:"VoucherRedemptionUniqueWhere",
			filter:"VoucherRedemptionWhere",
			data:"VoucherRedemptionUpdateInput"
		},
		upsertVoucherRedemption:{
			by:"VoucherRedemptionUniqueWhere",
			filter:"VoucherRedemptionWhere",
			update:"VoucherRedemptionUpdateInput",
			create:"VoucherRedemptionCreateInput"
		},
		createUnassignedShiftInfo:{
			data:"UnassignedShiftInfoCreateInput"
		},
		deleteUnassignedShiftInfo:{
			by:"UnassignedShiftInfoUniqueWhere",
			filter:"UnassignedShiftInfoWhere"
		},
		updateUnassignedShiftInfo:{
			by:"UnassignedShiftInfoUniqueWhere",
			filter:"UnassignedShiftInfoWhere",
			data:"UnassignedShiftInfoUpdateInput"
		},
		upsertUnassignedShiftInfo:{
			by:"UnassignedShiftInfoUniqueWhere",
			filter:"UnassignedShiftInfoWhere",
			update:"UnassignedShiftInfoUpdateInput",
			create:"UnassignedShiftInfoCreateInput"
		},
		createFreshingContainer:{
			data:"FreshingContainerCreateInput"
		},
		deleteFreshingContainer:{
			by:"FreshingContainerUniqueWhere",
			filter:"FreshingContainerWhere"
		},
		updateFreshingContainer:{
			by:"FreshingContainerUniqueWhere",
			filter:"FreshingContainerWhere",
			data:"FreshingContainerUpdateInput"
		},
		upsertFreshingContainer:{
			by:"FreshingContainerUniqueWhere",
			filter:"FreshingContainerWhere",
			update:"FreshingContainerUpdateInput",
			create:"FreshingContainerCreateInput"
		},
		createTextItem:{
			data:"TextItemCreateInput"
		},
		deleteTextItem:{
			by:"TextItemUniqueWhere",
			filter:"TextItemWhere"
		},
		updateTextItem:{
			by:"TextItemUniqueWhere",
			filter:"TextItemWhere",
			data:"TextItemUpdateInput"
		},
		upsertTextItem:{
			by:"TextItemUniqueWhere",
			filter:"TextItemWhere",
			update:"TextItemUpdateInput",
			create:"TextItemCreateInput"
		},
		createTextList:{
			data:"TextListCreateInput"
		},
		deleteTextList:{
			by:"TextListUniqueWhere",
			filter:"TextListWhere"
		},
		updateTextList:{
			by:"TextListUniqueWhere",
			filter:"TextListWhere",
			data:"TextListUpdateInput"
		},
		upsertTextList:{
			by:"TextListUniqueWhere",
			filter:"TextListWhere",
			update:"TextListUpdateInput",
			create:"TextListCreateInput"
		},
		createDeliveryRegions:{
			data:"DeliveryRegionsCreateInput"
		},
		deleteDeliveryRegions:{
			by:"DeliveryRegionsUniqueWhere",
			filter:"DeliveryRegionsWhere"
		},
		updateDeliveryRegions:{
			by:"DeliveryRegionsUniqueWhere",
			filter:"DeliveryRegionsWhere",
			data:"DeliveryRegionsUpdateInput"
		},
		upsertDeliveryRegions:{
			by:"DeliveryRegionsUniqueWhere",
			filter:"DeliveryRegionsWhere",
			update:"DeliveryRegionsUpdateInput",
			create:"DeliveryRegionsCreateInput"
		},
		createDeliveryRegionsItem:{
			data:"DeliveryRegionsItemCreateInput"
		},
		deleteDeliveryRegionsItem:{
			by:"DeliveryRegionsItemUniqueWhere",
			filter:"DeliveryRegionsItemWhere"
		},
		updateDeliveryRegionsItem:{
			by:"DeliveryRegionsItemUniqueWhere",
			filter:"DeliveryRegionsItemWhere",
			data:"DeliveryRegionsItemUpdateInput"
		},
		upsertDeliveryRegionsItem:{
			by:"DeliveryRegionsItemUniqueWhere",
			filter:"DeliveryRegionsItemWhere",
			update:"DeliveryRegionsItemUpdateInput",
			create:"DeliveryRegionsItemCreateInput"
		},
		createImageList:{
			data:"ImageListCreateInput"
		},
		deleteImageList:{
			by:"ImageListUniqueWhere",
			filter:"ImageListWhere"
		},
		updateImageList:{
			by:"ImageListUniqueWhere",
			filter:"ImageListWhere",
			data:"ImageListUpdateInput"
		},
		upsertImageList:{
			by:"ImageListUniqueWhere",
			filter:"ImageListWhere",
			update:"ImageListUpdateInput",
			create:"ImageListCreateInput"
		},
		createImageListItem:{
			data:"ImageListItemCreateInput"
		},
		deleteImageListItem:{
			by:"ImageListItemUniqueWhere",
			filter:"ImageListItemWhere"
		},
		updateImageListItem:{
			by:"ImageListItemUniqueWhere",
			filter:"ImageListItemWhere",
			data:"ImageListItemUpdateInput"
		},
		upsertImageListItem:{
			by:"ImageListItemUniqueWhere",
			filter:"ImageListItemWhere",
			update:"ImageListItemUpdateInput",
			create:"ImageListItemCreateInput"
		},
		createTimetablesEmployeePrivileges:{
			data:"TimetablesEmployeePrivilegesCreateInput"
		},
		deleteTimetablesEmployeePrivileges:{
			by:"TimetablesEmployeePrivilegesUniqueWhere",
			filter:"TimetablesEmployeePrivilegesWhere"
		},
		updateTimetablesEmployeePrivileges:{
			by:"TimetablesEmployeePrivilegesUniqueWhere",
			filter:"TimetablesEmployeePrivilegesWhere",
			data:"TimetablesEmployeePrivilegesUpdateInput"
		},
		upsertTimetablesEmployeePrivileges:{
			by:"TimetablesEmployeePrivilegesUniqueWhere",
			filter:"TimetablesEmployeePrivilegesWhere",
			update:"TimetablesEmployeePrivilegesUpdateInput",
			create:"TimetablesEmployeePrivilegesCreateInput"
		},
		createTimetableDayNote:{
			data:"TimetableDayNoteCreateInput"
		},
		deleteTimetableDayNote:{
			by:"TimetableDayNoteUniqueWhere",
			filter:"TimetableDayNoteWhere"
		},
		updateTimetableDayNote:{
			by:"TimetableDayNoteUniqueWhere",
			filter:"TimetableDayNoteWhere",
			data:"TimetableDayNoteUpdateInput"
		},
		upsertTimetableDayNote:{
			by:"TimetableDayNoteUniqueWhere",
			filter:"TimetableDayNoteWhere",
			update:"TimetableDayNoteUpdateInput",
			create:"TimetableDayNoteCreateInput"
		},
		createDeliveryMethodLocale:{
			data:"DeliveryMethodLocaleCreateInput"
		},
		deleteDeliveryMethodLocale:{
			by:"DeliveryMethodLocaleUniqueWhere",
			filter:"DeliveryMethodLocaleWhere"
		},
		updateDeliveryMethodLocale:{
			by:"DeliveryMethodLocaleUniqueWhere",
			filter:"DeliveryMethodLocaleWhere",
			data:"DeliveryMethodLocaleUpdateInput"
		},
		upsertDeliveryMethodLocale:{
			by:"DeliveryMethodLocaleUniqueWhere",
			filter:"DeliveryMethodLocaleWhere",
			update:"DeliveryMethodLocaleUpdateInput",
			create:"DeliveryMethodLocaleCreateInput"
		},
		createIngredientSupplier:{
			data:"IngredientSupplierCreateInput"
		},
		deleteIngredientSupplier:{
			by:"IngredientSupplierUniqueWhere",
			filter:"IngredientSupplierWhere"
		},
		updateIngredientSupplier:{
			by:"IngredientSupplierUniqueWhere",
			filter:"IngredientSupplierWhere",
			data:"IngredientSupplierUpdateInput"
		},
		upsertIngredientSupplier:{
			by:"IngredientSupplierUniqueWhere",
			filter:"IngredientSupplierWhere",
			update:"IngredientSupplierUpdateInput",
			create:"IngredientSupplierCreateInput"
		},
		createIngredientSupplierItem:{
			data:"IngredientSupplierItemCreateInput"
		},
		deleteIngredientSupplierItem:{
			by:"IngredientSupplierItemUniqueWhere",
			filter:"IngredientSupplierItemWhere"
		},
		updateIngredientSupplierItem:{
			by:"IngredientSupplierItemUniqueWhere",
			filter:"IngredientSupplierItemWhere",
			data:"IngredientSupplierItemUpdateInput"
		},
		upsertIngredientSupplierItem:{
			by:"IngredientSupplierItemUniqueWhere",
			filter:"IngredientSupplierItemWhere",
			update:"IngredientSupplierItemUpdateInput",
			create:"IngredientSupplierItemCreateInput"
		},
		createIngredientSupplierList:{
			data:"IngredientSupplierListCreateInput"
		},
		deleteIngredientSupplierList:{
			by:"IngredientSupplierListUniqueWhere",
			filter:"IngredientSupplierListWhere"
		},
		updateIngredientSupplierList:{
			by:"IngredientSupplierListUniqueWhere",
			filter:"IngredientSupplierListWhere",
			data:"IngredientSupplierListUpdateInput"
		},
		upsertIngredientSupplierList:{
			by:"IngredientSupplierListUniqueWhere",
			filter:"IngredientSupplierListWhere",
			update:"IngredientSupplierListUpdateInput",
			create:"IngredientSupplierListCreateInput"
		},
		createIngredientSupplierLocale:{
			data:"IngredientSupplierLocaleCreateInput"
		},
		deleteIngredientSupplierLocale:{
			by:"IngredientSupplierLocaleUniqueWhere",
			filter:"IngredientSupplierLocaleWhere"
		},
		updateIngredientSupplierLocale:{
			by:"IngredientSupplierLocaleUniqueWhere",
			filter:"IngredientSupplierLocaleWhere",
			data:"IngredientSupplierLocaleUpdateInput"
		},
		upsertIngredientSupplierLocale:{
			by:"IngredientSupplierLocaleUniqueWhere",
			filter:"IngredientSupplierLocaleWhere",
			update:"IngredientSupplierLocaleUpdateInput",
			create:"IngredientSupplierLocaleCreateInput"
		},
		createRedirect:{
			data:"RedirectCreateInput"
		},
		deleteRedirect:{
			by:"RedirectUniqueWhere",
			filter:"RedirectWhere"
		},
		updateRedirect:{
			by:"RedirectUniqueWhere",
			filter:"RedirectWhere",
			data:"RedirectUpdateInput"
		},
		upsertRedirect:{
			by:"RedirectUniqueWhere",
			filter:"RedirectWhere",
			update:"RedirectUpdateInput",
			create:"RedirectCreateInput"
		},
		createNutritionFacts:{
			data:"NutritionFactsCreateInput"
		},
		deleteNutritionFacts:{
			by:"NutritionFactsUniqueWhere",
			filter:"NutritionFactsWhere"
		},
		updateNutritionFacts:{
			by:"NutritionFactsUniqueWhere",
			filter:"NutritionFactsWhere",
			data:"NutritionFactsUpdateInput"
		},
		upsertNutritionFacts:{
			by:"NutritionFactsUniqueWhere",
			filter:"NutritionFactsWhere",
			update:"NutritionFactsUpdateInput",
			create:"NutritionFactsCreateInput"
		},
		createVenue:{
			data:"VenueCreateInput"
		},
		deleteVenue:{
			by:"VenueUniqueWhere",
			filter:"VenueWhere"
		},
		updateVenue:{
			by:"VenueUniqueWhere",
			filter:"VenueWhere",
			data:"VenueUpdateInput"
		},
		upsertVenue:{
			by:"VenueUniqueWhere",
			filter:"VenueWhere",
			update:"VenueUpdateInput",
			create:"VenueCreateInput"
		},
		createWorkspace:{
			data:"WorkspaceCreateInput"
		},
		deleteWorkspace:{
			by:"WorkspaceUniqueWhere",
			filter:"WorkspaceWhere"
		},
		updateWorkspace:{
			by:"WorkspaceUniqueWhere",
			filter:"WorkspaceWhere",
			data:"WorkspaceUpdateInput"
		},
		upsertWorkspace:{
			by:"WorkspaceUniqueWhere",
			filter:"WorkspaceWhere",
			update:"WorkspaceUpdateInput",
			create:"WorkspaceCreateInput"
		},
		createInternalBuyer:{
			data:"InternalBuyerCreateInput"
		},
		deleteInternalBuyer:{
			by:"InternalBuyerUniqueWhere",
			filter:"InternalBuyerWhere"
		},
		updateInternalBuyer:{
			by:"InternalBuyerUniqueWhere",
			filter:"InternalBuyerWhere",
			data:"InternalBuyerUpdateInput"
		},
		upsertInternalBuyer:{
			by:"InternalBuyerUniqueWhere",
			filter:"InternalBuyerWhere",
			update:"InternalBuyerUpdateInput",
			create:"InternalBuyerCreateInput"
		},
		createVenueEmployeeRole:{
			data:"VenueEmployeeRoleCreateInput"
		},
		deleteVenueEmployeeRole:{
			by:"VenueEmployeeRoleUniqueWhere",
			filter:"VenueEmployeeRoleWhere"
		},
		updateVenueEmployeeRole:{
			by:"VenueEmployeeRoleUniqueWhere",
			filter:"VenueEmployeeRoleWhere",
			data:"VenueEmployeeRoleUpdateInput"
		},
		upsertVenueEmployeeRole:{
			by:"VenueEmployeeRoleUniqueWhere",
			filter:"VenueEmployeeRoleWhere",
			update:"VenueEmployeeRoleUpdateInput",
			create:"VenueEmployeeRoleCreateInput"
		},
		createIdentificationAttempt:{
			data:"IdentificationAttemptCreateInput"
		},
		deleteIdentificationAttempt:{
			by:"IdentificationAttemptUniqueWhere",
			filter:"IdentificationAttemptWhere"
		},
		updateIdentificationAttempt:{
			by:"IdentificationAttemptUniqueWhere",
			filter:"IdentificationAttemptWhere",
			data:"IdentificationAttemptUpdateInput"
		},
		upsertIdentificationAttempt:{
			by:"IdentificationAttemptUniqueWhere",
			filter:"IdentificationAttemptWhere",
			update:"IdentificationAttemptUpdateInput",
			create:"IdentificationAttemptCreateInput"
		},
		createIdentificationCode:{
			data:"IdentificationCodeCreateInput"
		},
		deleteIdentificationCode:{
			by:"IdentificationCodeUniqueWhere",
			filter:"IdentificationCodeWhere"
		},
		updateIdentificationCode:{
			by:"IdentificationCodeUniqueWhere",
			filter:"IdentificationCodeWhere",
			data:"IdentificationCodeUpdateInput"
		},
		upsertIdentificationCode:{
			by:"IdentificationCodeUniqueWhere",
			filter:"IdentificationCodeWhere",
			update:"IdentificationCodeUpdateInput",
			create:"IdentificationCodeCreateInput"
		},
		createIdentificationCodeLocale:{
			data:"IdentificationCodeLocaleCreateInput"
		},
		deleteIdentificationCodeLocale:{
			by:"IdentificationCodeLocaleUniqueWhere",
			filter:"IdentificationCodeLocaleWhere"
		},
		updateIdentificationCodeLocale:{
			by:"IdentificationCodeLocaleUniqueWhere",
			filter:"IdentificationCodeLocaleWhere",
			data:"IdentificationCodeLocaleUpdateInput"
		},
		upsertIdentificationCodeLocale:{
			by:"IdentificationCodeLocaleUniqueWhere",
			filter:"IdentificationCodeLocaleWhere",
			update:"IdentificationCodeLocaleUpdateInput",
			create:"IdentificationCodeLocaleCreateInput"
		},
		createPipeline:{
			data:"PipelineCreateInput"
		},
		deletePipeline:{
			by:"PipelineUniqueWhere",
			filter:"PipelineWhere"
		},
		updatePipeline:{
			by:"PipelineUniqueWhere",
			filter:"PipelineWhere",
			data:"PipelineUpdateInput"
		},
		upsertPipeline:{
			by:"PipelineUniqueWhere",
			filter:"PipelineWhere",
			update:"PipelineUpdateInput",
			create:"PipelineCreateInput"
		},
		createPipelineLead:{
			data:"PipelineLeadCreateInput"
		},
		deletePipelineLead:{
			by:"PipelineLeadUniqueWhere",
			filter:"PipelineLeadWhere"
		},
		updatePipelineLead:{
			by:"PipelineLeadUniqueWhere",
			filter:"PipelineLeadWhere",
			data:"PipelineLeadUpdateInput"
		},
		upsertPipelineLead:{
			by:"PipelineLeadUniqueWhere",
			filter:"PipelineLeadWhere",
			update:"PipelineLeadUpdateInput",
			create:"PipelineLeadCreateInput"
		},
		createPipelineStage:{
			data:"PipelineStageCreateInput"
		},
		deletePipelineStage:{
			by:"PipelineStageUniqueWhere",
			filter:"PipelineStageWhere"
		},
		updatePipelineStage:{
			by:"PipelineStageUniqueWhere",
			filter:"PipelineStageWhere",
			data:"PipelineStageUpdateInput"
		},
		upsertPipelineStage:{
			by:"PipelineStageUniqueWhere",
			filter:"PipelineStageWhere",
			update:"PipelineStageUpdateInput",
			create:"PipelineStageCreateInput"
		},
		createPipelineStageItem:{
			data:"PipelineStageItemCreateInput"
		},
		deletePipelineStageItem:{
			by:"PipelineStageItemUniqueWhere",
			filter:"PipelineStageItemWhere"
		},
		updatePipelineStageItem:{
			by:"PipelineStageItemUniqueWhere",
			filter:"PipelineStageItemWhere",
			data:"PipelineStageItemUpdateInput"
		},
		upsertPipelineStageItem:{
			by:"PipelineStageItemUniqueWhere",
			filter:"PipelineStageItemWhere",
			update:"PipelineStageItemUpdateInput",
			create:"PipelineStageItemCreateInput"
		},
		createPipelineStageLocale:{
			data:"PipelineStageLocaleCreateInput"
		},
		deletePipelineStageLocale:{
			by:"PipelineStageLocaleUniqueWhere",
			filter:"PipelineStageLocaleWhere"
		},
		updatePipelineStageLocale:{
			by:"PipelineStageLocaleUniqueWhere",
			filter:"PipelineStageLocaleWhere",
			data:"PipelineStageLocaleUpdateInput"
		},
		upsertPipelineStageLocale:{
			by:"PipelineStageLocaleUniqueWhere",
			filter:"PipelineStageLocaleWhere",
			update:"PipelineStageLocaleUpdateInput",
			create:"PipelineStageLocaleCreateInput"
		},
		createSalesManager:{
			data:"SalesManagerCreateInput"
		},
		deleteSalesManager:{
			by:"SalesManagerUniqueWhere",
			filter:"SalesManagerWhere"
		},
		updateSalesManager:{
			by:"SalesManagerUniqueWhere",
			filter:"SalesManagerWhere",
			data:"SalesManagerUpdateInput"
		},
		upsertSalesManager:{
			by:"SalesManagerUniqueWhere",
			filter:"SalesManagerWhere",
			update:"SalesManagerUpdateInput",
			create:"SalesManagerCreateInput"
		},
		createCashierManager:{
			data:"CashierManagerCreateInput"
		},
		deleteCashierManager:{
			by:"CashierManagerUniqueWhere",
			filter:"CashierManagerWhere"
		},
		updateCashierManager:{
			by:"CashierManagerUniqueWhere",
			filter:"CashierManagerWhere",
			data:"CashierManagerUpdateInput"
		},
		upsertCashierManager:{
			by:"CashierManagerUniqueWhere",
			filter:"CashierManagerWhere",
			update:"CashierManagerUpdateInput",
			create:"CashierManagerCreateInput"
		},
		createPointOfSaleApplicationDevice:{
			data:"PointOfSaleApplicationDeviceCreateInput"
		},
		deletePointOfSaleApplicationDevice:{
			by:"PointOfSaleApplicationDeviceUniqueWhere",
			filter:"PointOfSaleApplicationDeviceWhere"
		},
		updatePointOfSaleApplicationDevice:{
			by:"PointOfSaleApplicationDeviceUniqueWhere",
			filter:"PointOfSaleApplicationDeviceWhere",
			data:"PointOfSaleApplicationDeviceUpdateInput"
		},
		upsertPointOfSaleApplicationDevice:{
			by:"PointOfSaleApplicationDeviceUniqueWhere",
			filter:"PointOfSaleApplicationDeviceWhere",
			update:"PointOfSaleApplicationDeviceUpdateInput",
			create:"PointOfSaleApplicationDeviceCreateInput"
		},
		createPointOfSaleTerminal:{
			data:"PointOfSaleTerminalCreateInput"
		},
		deletePointOfSaleTerminal:{
			by:"PointOfSaleTerminalUniqueWhere",
			filter:"PointOfSaleTerminalWhere"
		},
		updatePointOfSaleTerminal:{
			by:"PointOfSaleTerminalUniqueWhere",
			filter:"PointOfSaleTerminalWhere",
			data:"PointOfSaleTerminalUpdateInput"
		},
		upsertPointOfSaleTerminal:{
			by:"PointOfSaleTerminalUniqueWhere",
			filter:"PointOfSaleTerminalWhere",
			update:"PointOfSaleTerminalUpdateInput",
			create:"PointOfSaleTerminalCreateInput"
		},
		createPipelineStageSentiment:{
			data:"PipelineStageSentimentCreateInput"
		},
		deletePipelineStageSentiment:{
			by:"PipelineStageSentimentUniqueWhere",
			filter:"PipelineStageSentimentWhere"
		},
		updatePipelineStageSentiment:{
			by:"PipelineStageSentimentUniqueWhere",
			filter:"PipelineStageSentimentWhere",
			data:"PipelineStageSentimentUpdateInput"
		},
		upsertPipelineStageSentiment:{
			by:"PipelineStageSentimentUniqueWhere",
			filter:"PipelineStageSentimentWhere",
			update:"PipelineStageSentimentUpdateInput",
			create:"PipelineStageSentimentCreateInput"
		},
		createDeviceIdentifier:{
			data:"DeviceIdentifierCreateInput"
		},
		deleteDeviceIdentifier:{
			by:"DeviceIdentifierUniqueWhere",
			filter:"DeviceIdentifierWhere"
		},
		updateDeviceIdentifier:{
			by:"DeviceIdentifierUniqueWhere",
			filter:"DeviceIdentifierWhere",
			data:"DeviceIdentifierUpdateInput"
		},
		upsertDeviceIdentifier:{
			by:"DeviceIdentifierUniqueWhere",
			filter:"DeviceIdentifierWhere",
			update:"DeviceIdentifierUpdateInput",
			create:"DeviceIdentifierCreateInput"
		},
		createPointOfSalePrinter:{
			data:"PointOfSalePrinterCreateInput"
		},
		deletePointOfSalePrinter:{
			by:"PointOfSalePrinterUniqueWhere",
			filter:"PointOfSalePrinterWhere"
		},
		updatePointOfSalePrinter:{
			by:"PointOfSalePrinterUniqueWhere",
			filter:"PointOfSalePrinterWhere",
			data:"PointOfSalePrinterUpdateInput"
		},
		upsertPointOfSalePrinter:{
			by:"PointOfSalePrinterUniqueWhere",
			filter:"PointOfSalePrinterWhere",
			update:"PointOfSalePrinterUpdateInput",
			create:"PointOfSalePrinterCreateInput"
		},
		createGratuity:{
			data:"GratuityCreateInput"
		},
		deleteGratuity:{
			by:"GratuityUniqueWhere",
			filter:"GratuityWhere"
		},
		updateGratuity:{
			by:"GratuityUniqueWhere",
			filter:"GratuityWhere",
			data:"GratuityUpdateInput"
		},
		upsertGratuity:{
			by:"GratuityUniqueWhere",
			filter:"GratuityWhere",
			update:"GratuityUpdateInput",
			create:"GratuityCreateInput"
		},
		createFulfillmentNote:{
			data:"FulfillmentNoteCreateInput"
		},
		deleteFulfillmentNote:{
			by:"FulfillmentNoteUniqueWhere",
			filter:"FulfillmentNoteWhere"
		},
		updateFulfillmentNote:{
			by:"FulfillmentNoteUniqueWhere",
			filter:"FulfillmentNoteWhere",
			data:"FulfillmentNoteUpdateInput"
		},
		upsertFulfillmentNote:{
			by:"FulfillmentNoteUniqueWhere",
			filter:"FulfillmentNoteWhere",
			update:"FulfillmentNoteUpdateInput",
			create:"FulfillmentNoteCreateInput"
		},
		createLeadForm:{
			data:"LeadFormCreateInput"
		},
		deleteLeadForm:{
			by:"LeadFormUniqueWhere",
			filter:"LeadFormWhere"
		},
		updateLeadForm:{
			by:"LeadFormUniqueWhere",
			filter:"LeadFormWhere",
			data:"LeadFormUpdateInput"
		},
		upsertLeadForm:{
			by:"LeadFormUniqueWhere",
			filter:"LeadFormWhere",
			update:"LeadFormUpdateInput",
			create:"LeadFormCreateInput"
		},
		createSubscriptionBox:{
			data:"SubscriptionBoxCreateInput"
		},
		deleteSubscriptionBox:{
			by:"SubscriptionBoxUniqueWhere",
			filter:"SubscriptionBoxWhere"
		},
		updateSubscriptionBox:{
			by:"SubscriptionBoxUniqueWhere",
			filter:"SubscriptionBoxWhere",
			data:"SubscriptionBoxUpdateInput"
		},
		upsertSubscriptionBox:{
			by:"SubscriptionBoxUniqueWhere",
			filter:"SubscriptionBoxWhere",
			update:"SubscriptionBoxUpdateInput",
			create:"SubscriptionBoxCreateInput"
		},
		createSubscriptionBoxLocale:{
			data:"SubscriptionBoxLocaleCreateInput"
		},
		deleteSubscriptionBoxLocale:{
			by:"SubscriptionBoxLocaleUniqueWhere",
			filter:"SubscriptionBoxLocaleWhere"
		},
		updateSubscriptionBoxLocale:{
			by:"SubscriptionBoxLocaleUniqueWhere",
			filter:"SubscriptionBoxLocaleWhere",
			data:"SubscriptionBoxLocaleUpdateInput"
		},
		upsertSubscriptionBoxLocale:{
			by:"SubscriptionBoxLocaleUniqueWhere",
			filter:"SubscriptionBoxLocaleWhere",
			update:"SubscriptionBoxLocaleUpdateInput",
			create:"SubscriptionBoxLocaleCreateInput"
		},
		createBusinessService:{
			data:"BusinessServiceCreateInput"
		},
		deleteBusinessService:{
			by:"BusinessServiceUniqueWhere",
			filter:"BusinessServiceWhere"
		},
		updateBusinessService:{
			by:"BusinessServiceUniqueWhere",
			filter:"BusinessServiceWhere",
			data:"BusinessServiceUpdateInput"
		},
		upsertBusinessService:{
			by:"BusinessServiceUniqueWhere",
			filter:"BusinessServiceWhere",
			update:"BusinessServiceUpdateInput",
			create:"BusinessServiceCreateInput"
		},
		createBusinessServiceEvent:{
			data:"BusinessServiceEventCreateInput"
		},
		deleteBusinessServiceEvent:{
			by:"BusinessServiceEventUniqueWhere",
			filter:"BusinessServiceEventWhere"
		},
		updateBusinessServiceEvent:{
			by:"BusinessServiceEventUniqueWhere",
			filter:"BusinessServiceEventWhere",
			data:"BusinessServiceEventUpdateInput"
		},
		upsertBusinessServiceEvent:{
			by:"BusinessServiceEventUniqueWhere",
			filter:"BusinessServiceEventWhere",
			update:"BusinessServiceEventUpdateInput",
			create:"BusinessServiceEventCreateInput"
		},
		createBusinessServiceLocale:{
			data:"BusinessServiceLocaleCreateInput"
		},
		deleteBusinessServiceLocale:{
			by:"BusinessServiceLocaleUniqueWhere",
			filter:"BusinessServiceLocaleWhere"
		},
		updateBusinessServiceLocale:{
			by:"BusinessServiceLocaleUniqueWhere",
			filter:"BusinessServiceLocaleWhere",
			data:"BusinessServiceLocaleUpdateInput"
		},
		upsertBusinessServiceLocale:{
			by:"BusinessServiceLocaleUniqueWhere",
			filter:"BusinessServiceLocaleWhere",
			update:"BusinessServiceLocaleUpdateInput",
			create:"BusinessServiceLocaleCreateInput"
		},
		createGridTileItem:{
			data:"GridTileItemCreateInput"
		},
		deleteGridTileItem:{
			by:"GridTileItemUniqueWhere",
			filter:"GridTileItemWhere"
		},
		updateGridTileItem:{
			by:"GridTileItemUniqueWhere",
			filter:"GridTileItemWhere",
			data:"GridTileItemUpdateInput"
		},
		upsertGridTileItem:{
			by:"GridTileItemUniqueWhere",
			filter:"GridTileItemWhere",
			update:"GridTileItemUpdateInput",
			create:"GridTileItemCreateInput"
		},
		createGridTiles:{
			data:"GridTilesCreateInput"
		},
		deleteGridTiles:{
			by:"GridTilesUniqueWhere",
			filter:"GridTilesWhere"
		},
		updateGridTiles:{
			by:"GridTilesUniqueWhere",
			filter:"GridTilesWhere",
			data:"GridTilesUpdateInput"
		},
		upsertGridTiles:{
			by:"GridTilesUniqueWhere",
			filter:"GridTilesWhere",
			update:"GridTilesUpdateInput",
			create:"GridTilesCreateInput"
		},
		createArea:{
			data:"AreaCreateInput"
		},
		deleteArea:{
			by:"AreaUniqueWhere",
			filter:"AreaWhere"
		},
		updateArea:{
			by:"AreaUniqueWhere",
			filter:"AreaWhere",
			data:"AreaUpdateInput"
		},
		upsertArea:{
			by:"AreaUniqueWhere",
			filter:"AreaWhere",
			update:"AreaUpdateInput",
			create:"AreaCreateInput"
		},
		createPosition:{
			data:"PositionCreateInput"
		},
		deletePosition:{
			by:"PositionUniqueWhere",
			filter:"PositionWhere"
		},
		updatePosition:{
			by:"PositionUniqueWhere",
			filter:"PositionWhere",
			data:"PositionUpdateInput"
		},
		upsertPosition:{
			by:"PositionUniqueWhere",
			filter:"PositionWhere",
			update:"PositionUpdateInput",
			create:"PositionCreateInput"
		},
		createStatsEnabledWidgetType:{
			data:"StatsEnabledWidgetTypeCreateInput"
		},
		deleteStatsEnabledWidgetType:{
			by:"StatsEnabledWidgetTypeUniqueWhere",
			filter:"StatsEnabledWidgetTypeWhere"
		},
		updateStatsEnabledWidgetType:{
			by:"StatsEnabledWidgetTypeUniqueWhere",
			filter:"StatsEnabledWidgetTypeWhere",
			data:"StatsEnabledWidgetTypeUpdateInput"
		},
		upsertStatsEnabledWidgetType:{
			by:"StatsEnabledWidgetTypeUniqueWhere",
			filter:"StatsEnabledWidgetTypeWhere",
			update:"StatsEnabledWidgetTypeUpdateInput",
			create:"StatsEnabledWidgetTypeCreateInput"
		},
		createStatsWidget:{
			data:"StatsWidgetCreateInput"
		},
		deleteStatsWidget:{
			by:"StatsWidgetUniqueWhere",
			filter:"StatsWidgetWhere"
		},
		updateStatsWidget:{
			by:"StatsWidgetUniqueWhere",
			filter:"StatsWidgetWhere",
			data:"StatsWidgetUpdateInput"
		},
		upsertStatsWidget:{
			by:"StatsWidgetUniqueWhere",
			filter:"StatsWidgetWhere",
			update:"StatsWidgetUpdateInput",
			create:"StatsWidgetCreateInput"
		},
		createStatsWidgetsLayout:{
			data:"StatsWidgetsLayoutCreateInput"
		},
		deleteStatsWidgetsLayout:{
			by:"StatsWidgetsLayoutUniqueWhere",
			filter:"StatsWidgetsLayoutWhere"
		},
		updateStatsWidgetsLayout:{
			by:"StatsWidgetsLayoutUniqueWhere",
			filter:"StatsWidgetsLayoutWhere",
			data:"StatsWidgetsLayoutUpdateInput"
		},
		upsertStatsWidgetsLayout:{
			by:"StatsWidgetsLayoutUniqueWhere",
			filter:"StatsWidgetsLayoutWhere",
			update:"StatsWidgetsLayoutUpdateInput",
			create:"StatsWidgetsLayoutCreateInput"
		},
		createSeat:{
			data:"SeatCreateInput"
		},
		deleteSeat:{
			by:"SeatUniqueWhere",
			filter:"SeatWhere"
		},
		updateSeat:{
			by:"SeatUniqueWhere",
			filter:"SeatWhere",
			data:"SeatUpdateInput"
		},
		upsertSeat:{
			by:"SeatUniqueWhere",
			filter:"SeatWhere",
			update:"SeatUpdateInput",
			create:"SeatCreateInput"
		},
		createTable:{
			data:"TableCreateInput"
		},
		deleteTable:{
			by:"TableUniqueWhere",
			filter:"TableWhere"
		},
		updateTable:{
			by:"TableUniqueWhere",
			filter:"TableWhere",
			data:"TableUpdateInput"
		},
		upsertTable:{
			by:"TableUniqueWhere",
			filter:"TableWhere",
			update:"TableUpdateInput",
			create:"TableCreateInput"
		},
		createStatsPage:{
			data:"StatsPageCreateInput"
		},
		deleteStatsPage:{
			by:"StatsPageUniqueWhere",
			filter:"StatsPageWhere"
		},
		updateStatsPage:{
			by:"StatsPageUniqueWhere",
			filter:"StatsPageWhere",
			data:"StatsPageUpdateInput"
		},
		upsertStatsPage:{
			by:"StatsPageUniqueWhere",
			filter:"StatsPageWhere",
			update:"StatsPageUpdateInput",
			create:"StatsPageCreateInput"
		},
		createUnassignReason:{
			data:"UnassignReasonCreateInput"
		},
		deleteUnassignReason:{
			by:"UnassignReasonUniqueWhere",
			filter:"UnassignReasonWhere"
		},
		updateUnassignReason:{
			by:"UnassignReasonUniqueWhere",
			filter:"UnassignReasonWhere",
			data:"UnassignReasonUpdateInput"
		},
		upsertUnassignReason:{
			by:"UnassignReasonUniqueWhere",
			filter:"UnassignReasonWhere",
			update:"UnassignReasonUpdateInput",
			create:"UnassignReasonCreateInput"
		},
		createDoubleshotCoffeeEquipment:{
			data:"DoubleshotCoffeeEquipmentCreateInput"
		},
		deleteDoubleshotCoffeeEquipment:{
			by:"DoubleshotCoffeeEquipmentUniqueWhere",
			filter:"DoubleshotCoffeeEquipmentWhere"
		},
		updateDoubleshotCoffeeEquipment:{
			by:"DoubleshotCoffeeEquipmentUniqueWhere",
			filter:"DoubleshotCoffeeEquipmentWhere",
			data:"DoubleshotCoffeeEquipmentUpdateInput"
		},
		upsertDoubleshotCoffeeEquipment:{
			by:"DoubleshotCoffeeEquipmentUniqueWhere",
			filter:"DoubleshotCoffeeEquipmentWhere",
			update:"DoubleshotCoffeeEquipmentUpdateInput",
			create:"DoubleshotCoffeeEquipmentCreateInput"
		},
		createExpense:{
			data:"ExpenseCreateInput"
		},
		deleteExpense:{
			by:"ExpenseUniqueWhere",
			filter:"ExpenseWhere"
		},
		updateExpense:{
			by:"ExpenseUniqueWhere",
			filter:"ExpenseWhere",
			data:"ExpenseUpdateInput"
		},
		upsertExpense:{
			by:"ExpenseUniqueWhere",
			filter:"ExpenseWhere",
			update:"ExpenseUpdateInput",
			create:"ExpenseCreateInput"
		},
		createExpenseCategory:{
			data:"ExpenseCategoryCreateInput"
		},
		deleteExpenseCategory:{
			by:"ExpenseCategoryUniqueWhere",
			filter:"ExpenseCategoryWhere"
		},
		updateExpenseCategory:{
			by:"ExpenseCategoryUniqueWhere",
			filter:"ExpenseCategoryWhere",
			data:"ExpenseCategoryUpdateInput"
		},
		upsertExpenseCategory:{
			by:"ExpenseCategoryUniqueWhere",
			filter:"ExpenseCategoryWhere",
			update:"ExpenseCategoryUpdateInput",
			create:"ExpenseCategoryCreateInput"
		},
		createExpenseChange:{
			data:"ExpenseChangeCreateInput"
		},
		deleteExpenseChange:{
			by:"ExpenseChangeUniqueWhere",
			filter:"ExpenseChangeWhere"
		},
		updateExpenseChange:{
			by:"ExpenseChangeUniqueWhere",
			filter:"ExpenseChangeWhere",
			data:"ExpenseChangeUpdateInput"
		},
		upsertExpenseChange:{
			by:"ExpenseChangeUniqueWhere",
			filter:"ExpenseChangeWhere",
			update:"ExpenseChangeUpdateInput",
			create:"ExpenseChangeCreateInput"
		},
		createExpenseDocument:{
			data:"ExpenseDocumentCreateInput"
		},
		deleteExpenseDocument:{
			by:"ExpenseDocumentUniqueWhere",
			filter:"ExpenseDocumentWhere"
		},
		updateExpenseDocument:{
			by:"ExpenseDocumentUniqueWhere",
			filter:"ExpenseDocumentWhere",
			data:"ExpenseDocumentUpdateInput"
		},
		upsertExpenseDocument:{
			by:"ExpenseDocumentUniqueWhere",
			filter:"ExpenseDocumentWhere",
			update:"ExpenseDocumentUpdateInput",
			create:"ExpenseDocumentCreateInput"
		},
		createRevenuePrediction:{
			data:"RevenuePredictionCreateInput"
		},
		deleteRevenuePrediction:{
			by:"RevenuePredictionUniqueWhere",
			filter:"RevenuePredictionWhere"
		},
		updateRevenuePrediction:{
			by:"RevenuePredictionUniqueWhere",
			filter:"RevenuePredictionWhere",
			data:"RevenuePredictionUpdateInput"
		},
		upsertRevenuePrediction:{
			by:"RevenuePredictionUniqueWhere",
			filter:"RevenuePredictionWhere",
			update:"RevenuePredictionUpdateInput",
			create:"RevenuePredictionCreateInput"
		},
		createRevenuePredictionChange:{
			data:"RevenuePredictionChangeCreateInput"
		},
		deleteRevenuePredictionChange:{
			by:"RevenuePredictionChangeUniqueWhere",
			filter:"RevenuePredictionChangeWhere"
		},
		updateRevenuePredictionChange:{
			by:"RevenuePredictionChangeUniqueWhere",
			filter:"RevenuePredictionChangeWhere",
			data:"RevenuePredictionChangeUpdateInput"
		},
		upsertRevenuePredictionChange:{
			by:"RevenuePredictionChangeUniqueWhere",
			filter:"RevenuePredictionChangeWhere",
			update:"RevenuePredictionChangeUpdateInput",
			create:"RevenuePredictionChangeCreateInput"
		},
		createFile:{
			data:"FileCreateInput"
		},
		deleteFile:{
			by:"FileUniqueWhere",
			filter:"FileWhere"
		},
		updateFile:{
			by:"FileUniqueWhere",
			filter:"FileWhere",
			data:"FileUpdateInput"
		},
		upsertFile:{
			by:"FileUniqueWhere",
			filter:"FileWhere",
			update:"FileUpdateInput",
			create:"FileCreateInput"
		},
		createLine:{
			data:"LineCreateInput"
		},
		deleteLine:{
			by:"LineUniqueWhere",
			filter:"LineWhere"
		},
		updateLine:{
			by:"LineUniqueWhere",
			filter:"LineWhere",
			data:"LineUpdateInput"
		},
		upsertLine:{
			by:"LineUniqueWhere",
			filter:"LineWhere",
			update:"LineUpdateInput",
			create:"LineCreateInput"
		},
		createFinancesBalanceItem:{
			data:"FinancesBalanceItemCreateInput"
		},
		deleteFinancesBalanceItem:{
			by:"FinancesBalanceItemUniqueWhere",
			filter:"FinancesBalanceItemWhere"
		},
		updateFinancesBalanceItem:{
			by:"FinancesBalanceItemUniqueWhere",
			filter:"FinancesBalanceItemWhere",
			data:"FinancesBalanceItemUpdateInput"
		},
		upsertFinancesBalanceItem:{
			by:"FinancesBalanceItemUniqueWhere",
			filter:"FinancesBalanceItemWhere",
			update:"FinancesBalanceItemUpdateInput",
			create:"FinancesBalanceItemCreateInput"
		},
		createWoltDriveDelivery:{
			data:"WoltDriveDeliveryCreateInput"
		},
		deleteWoltDriveDelivery:{
			by:"WoltDriveDeliveryUniqueWhere",
			filter:"WoltDriveDeliveryWhere"
		},
		updateWoltDriveDelivery:{
			by:"WoltDriveDeliveryUniqueWhere",
			filter:"WoltDriveDeliveryWhere",
			data:"WoltDriveDeliveryUpdateInput"
		},
		upsertWoltDriveDelivery:{
			by:"WoltDriveDeliveryUniqueWhere",
			filter:"WoltDriveDeliveryWhere",
			update:"WoltDriveDeliveryUpdateInput",
			create:"WoltDriveDeliveryCreateInput"
		}
	},
	MutationTransactionOptions:{

	},
	_OnDeleteBehaviour: true,
	_RelationSide: true,
	_OrderByDirection: true
}

export const ReturnTypes: Record<string,any> = {
	Query:{
		getAddress:"Address",
		listAddress:"Address",
		paginateAddress:"AddressConnection",
		validateCreateAddress:"_ValidationResult",
		validateUpdateAddress:"_ValidationResult",
		getCountry:"Country",
		listCountry:"Country",
		paginateCountry:"CountryConnection",
		validateCreateCountry:"_ValidationResult",
		validateUpdateCountry:"_ValidationResult",
		getChannel:"Channel",
		listChannel:"Channel",
		paginateChannel:"ChannelConnection",
		validateCreateChannel:"_ValidationResult",
		validateUpdateChannel:"_ValidationResult",
		getChannelPayment:"ChannelPayment",
		listChannelPayment:"ChannelPayment",
		paginateChannelPayment:"ChannelPaymentConnection",
		validateCreateChannelPayment:"_ValidationResult",
		validateUpdateChannelPayment:"_ValidationResult",
		getChannelDelivery:"ChannelDelivery",
		listChannelDelivery:"ChannelDelivery",
		paginateChannelDelivery:"ChannelDeliveryConnection",
		validateCreateChannelDelivery:"_ValidationResult",
		validateUpdateChannelDelivery:"_ValidationResult",
		getCustomer:"Customer",
		listCustomer:"Customer",
		paginateCustomer:"CustomerConnection",
		validateCreateCustomer:"_ValidationResult",
		validateUpdateCustomer:"_ValidationResult",
		getCustomerCredit:"CustomerCredit",
		listCustomerCredit:"CustomerCredit",
		paginateCustomerCredit:"CustomerCreditConnection",
		validateCreateCustomerCredit:"_ValidationResult",
		validateUpdateCustomerCredit:"_ValidationResult",
		getCustomerGroup:"CustomerGroup",
		listCustomerGroup:"CustomerGroup",
		paginateCustomerGroup:"CustomerGroupConnection",
		validateCreateCustomerGroup:"_ValidationResult",
		validateUpdateCustomerGroup:"_ValidationResult",
		getCustomerPaymentMethod:"CustomerPaymentMethod",
		listCustomerPaymentMethod:"CustomerPaymentMethod",
		paginateCustomerPaymentMethod:"CustomerPaymentMethodConnection",
		validateCreateCustomerPaymentMethod:"_ValidationResult",
		validateUpdateCustomerPaymentMethod:"_ValidationResult",
		getDeliveryMethod:"DeliveryMethod",
		listDeliveryMethod:"DeliveryMethod",
		paginateDeliveryMethod:"DeliveryMethodConnection",
		validateCreateDeliveryMethod:"_ValidationResult",
		validateUpdateDeliveryMethod:"_ValidationResult",
		getOrder:"Order",
		listOrder:"Order",
		paginateOrder:"OrderConnection",
		validateCreateOrder:"_ValidationResult",
		validateUpdateOrder:"_ValidationResult",
		getOrderDiscount:"OrderDiscount",
		listOrderDiscount:"OrderDiscount",
		paginateOrderDiscount:"OrderDiscountConnection",
		validateCreateOrderDiscount:"_ValidationResult",
		validateUpdateOrderDiscount:"_ValidationResult",
		getOrderPayment:"OrderPayment",
		listOrderPayment:"OrderPayment",
		paginateOrderPayment:"OrderPaymentConnection",
		validateCreateOrderPayment:"_ValidationResult",
		validateUpdateOrderPayment:"_ValidationResult",
		getOrderDelivery:"OrderDelivery",
		listOrderDelivery:"OrderDelivery",
		paginateOrderDelivery:"OrderDeliveryConnection",
		validateCreateOrderDelivery:"_ValidationResult",
		validateUpdateOrderDelivery:"_ValidationResult",
		getOrderItem:"OrderItem",
		listOrderItem:"OrderItem",
		paginateOrderItem:"OrderItemConnection",
		validateCreateOrderItem:"_ValidationResult",
		validateUpdateOrderItem:"_ValidationResult",
		getPaymentMethod:"PaymentMethod",
		listPaymentMethod:"PaymentMethod",
		paginatePaymentMethod:"PaymentMethodConnection",
		validateCreatePaymentMethod:"_ValidationResult",
		validateUpdatePaymentMethod:"_ValidationResult",
		getVatRate:"VatRate",
		listVatRate:"VatRate",
		paginateVatRate:"VatRateConnection",
		validateCreateVatRate:"_ValidationResult",
		validateUpdateVatRate:"_ValidationResult",
		getProduct:"Product",
		listProduct:"Product",
		paginateProduct:"ProductConnection",
		validateCreateProduct:"_ValidationResult",
		validateUpdateProduct:"_ValidationResult",
		getProductStock:"ProductStock",
		listProductStock:"ProductStock",
		paginateProductStock:"ProductStockConnection",
		validateCreateProductStock:"_ValidationResult",
		validateUpdateProductStock:"_ValidationResult",
		getProductPacking:"ProductPacking",
		listProductPacking:"ProductPacking",
		paginateProductPacking:"ProductPackingConnection",
		validateCreateProductPacking:"_ValidationResult",
		validateUpdateProductPacking:"_ValidationResult",
		getProductGroupPrice:"ProductGroupPrice",
		listProductGroupPrice:"ProductGroupPrice",
		paginateProductGroupPrice:"ProductGroupPriceConnection",
		validateCreateProductGroupPrice:"_ValidationResult",
		validateUpdateProductGroupPrice:"_ValidationResult",
		getProductRecipe:"ProductRecipe",
		listProductRecipe:"ProductRecipe",
		paginateProductRecipe:"ProductRecipeConnection",
		validateCreateProductRecipe:"_ValidationResult",
		validateUpdateProductRecipe:"_ValidationResult",
		getProductCategory:"ProductCategory",
		listProductCategory:"ProductCategory",
		paginateProductCategory:"ProductCategoryConnection",
		validateCreateProductCategory:"_ValidationResult",
		validateUpdateProductCategory:"_ValidationResult",
		getStore:"Store",
		listStore:"Store",
		paginateStore:"StoreConnection",
		validateCreateStore:"_ValidationResult",
		validateUpdateStore:"_ValidationResult",
		getTag:"Tag",
		listTag:"Tag",
		paginateTag:"TagConnection",
		validateCreateTag:"_ValidationResult",
		validateUpdateTag:"_ValidationResult",
		getCustomerPermissions:"CustomerPermissions",
		listCustomerPermissions:"CustomerPermissions",
		paginateCustomerPermissions:"CustomerPermissionsConnection",
		getImage:"Image",
		listImage:"Image",
		paginateImage:"ImageConnection",
		validateCreateImage:"_ValidationResult",
		validateUpdateImage:"_ValidationResult",
		getBusinessCategory:"BusinessCategory",
		listBusinessCategory:"BusinessCategory",
		paginateBusinessCategory:"BusinessCategoryConnection",
		validateCreateBusinessCategory:"_ValidationResult",
		validateUpdateBusinessCategory:"_ValidationResult",
		getProductList:"ProductList",
		listProductList:"ProductList",
		paginateProductList:"ProductListConnection",
		validateCreateProductList:"_ValidationResult",
		validateUpdateProductList:"_ValidationResult",
		getProductListItem:"ProductListItem",
		listProductListItem:"ProductListItem",
		paginateProductListItem:"ProductListItemConnection",
		validateCreateProductListItem:"_ValidationResult",
		validateUpdateProductListItem:"_ValidationResult",
		getProductCategoryList:"ProductCategoryList",
		listProductCategoryList:"ProductCategoryList",
		paginateProductCategoryList:"ProductCategoryListConnection",
		validateCreateProductCategoryList:"_ValidationResult",
		validateUpdateProductCategoryList:"_ValidationResult",
		getProductCategoryListItem:"ProductCategoryListItem",
		listProductCategoryListItem:"ProductCategoryListItem",
		paginateProductCategoryListItem:"ProductCategoryListItemConnection",
		validateCreateProductCategoryListItem:"_ValidationResult",
		validateUpdateProductCategoryListItem:"_ValidationResult",
		getBusinessCategoryLocale:"BusinessCategoryLocale",
		listBusinessCategoryLocale:"BusinessCategoryLocale",
		paginateBusinessCategoryLocale:"BusinessCategoryLocaleConnection",
		validateCreateBusinessCategoryLocale:"_ValidationResult",
		validateUpdateBusinessCategoryLocale:"_ValidationResult",
		getLocale:"Locale",
		listLocale:"Locale",
		paginateLocale:"LocaleConnection",
		validateCreateLocale:"_ValidationResult",
		validateUpdateLocale:"_ValidationResult",
		getProductCategoryListLocale:"ProductCategoryListLocale",
		listProductCategoryListLocale:"ProductCategoryListLocale",
		paginateProductCategoryListLocale:"ProductCategoryListLocaleConnection",
		validateCreateProductCategoryListLocale:"_ValidationResult",
		validateUpdateProductCategoryListLocale:"_ValidationResult",
		getCustomerName:"CustomerName",
		listCustomerName:"CustomerName",
		paginateCustomerName:"CustomerNameConnection",
		validateCreateCustomerName:"_ValidationResult",
		validateUpdateCustomerName:"_ValidationResult",
		getCustomerAlias:"CustomerAlias",
		listCustomerAlias:"CustomerAlias",
		paginateCustomerAlias:"CustomerAliasConnection",
		validateCreateCustomerAlias:"_ValidationResult",
		validateUpdateCustomerAlias:"_ValidationResult",
		getProductIngredientItem:"ProductIngredientItem",
		listProductIngredientItem:"ProductIngredientItem",
		paginateProductIngredientItem:"ProductIngredientItemConnection",
		validateCreateProductIngredientItem:"_ValidationResult",
		validateUpdateProductIngredientItem:"_ValidationResult",
		getProductIngredientItemQuantity:"ProductIngredientItemQuantity",
		listProductIngredientItemQuantity:"ProductIngredientItemQuantity",
		paginateProductIngredientItemQuantity:"ProductIngredientItemQuantityConnection",
		validateCreateProductIngredientItemQuantity:"_ValidationResult",
		validateUpdateProductIngredientItemQuantity:"_ValidationResult",
		getProductIngredientItemQuantityUnit:"ProductIngredientItemQuantityUnit",
		listProductIngredientItemQuantityUnit:"ProductIngredientItemQuantityUnit",
		paginateProductIngredientItemQuantityUnit:"ProductIngredientItemQuantityUnitConnection",
		validateCreateProductIngredientItemQuantityUnit:"_ValidationResult",
		validateUpdateProductIngredientItemQuantityUnit:"_ValidationResult",
		getProductIngredient:"ProductIngredient",
		listProductIngredient:"ProductIngredient",
		paginateProductIngredient:"ProductIngredientConnection",
		validateCreateProductIngredient:"_ValidationResult",
		validateUpdateProductIngredient:"_ValidationResult",
		getCustomerIngredientRating:"CustomerIngredientRating",
		listCustomerIngredientRating:"CustomerIngredientRating",
		paginateCustomerIngredientRating:"CustomerIngredientRatingConnection",
		validateCreateCustomerIngredientRating:"_ValidationResult",
		validateUpdateCustomerIngredientRating:"_ValidationResult",
		getProductIngredientRating:"ProductIngredientRating",
		listProductIngredientRating:"ProductIngredientRating",
		paginateProductIngredientRating:"ProductIngredientRatingConnection",
		validateCreateProductIngredientRating:"_ValidationResult",
		validateUpdateProductIngredientRating:"_ValidationResult",
		getProductIngredientLocale:"ProductIngredientLocale",
		listProductIngredientLocale:"ProductIngredientLocale",
		paginateProductIngredientLocale:"ProductIngredientLocaleConnection",
		validateCreateProductIngredientLocale:"_ValidationResult",
		validateUpdateProductIngredientLocale:"_ValidationResult",
		getOrderRecurrence:"OrderRecurrence",
		listOrderRecurrence:"OrderRecurrence",
		paginateOrderRecurrence:"OrderRecurrenceConnection",
		validateCreateOrderRecurrence:"_ValidationResult",
		validateUpdateOrderRecurrence:"_ValidationResult",
		getOrderRecurrenceLocale:"OrderRecurrenceLocale",
		listOrderRecurrenceLocale:"OrderRecurrenceLocale",
		paginateOrderRecurrenceLocale:"OrderRecurrenceLocaleConnection",
		validateCreateOrderRecurrenceLocale:"_ValidationResult",
		validateUpdateOrderRecurrenceLocale:"_ValidationResult",
		getBusinessCustomer:"BusinessCustomer",
		listBusinessCustomer:"BusinessCustomer",
		paginateBusinessCustomer:"BusinessCustomerConnection",
		validateCreateBusinessCustomer:"_ValidationResult",
		validateUpdateBusinessCustomer:"_ValidationResult",
		getPointOfSale:"PointOfSale",
		listPointOfSale:"PointOfSale",
		paginatePointOfSale:"PointOfSaleConnection",
		validateCreatePointOfSale:"_ValidationResult",
		validateUpdatePointOfSale:"_ValidationResult",
		getStaff:"Staff",
		listStaff:"Staff",
		paginateStaff:"StaffConnection",
		validateCreateStaff:"_ValidationResult",
		validateUpdateStaff:"_ValidationResult",
		getPointOfSalePermissions:"PointOfSalePermissions",
		listPointOfSalePermissions:"PointOfSalePermissions",
		paginatePointOfSalePermissions:"PointOfSalePermissionsConnection",
		getBlog:"Blog",
		listBlog:"Blog",
		paginateBlog:"BlogConnection",
		validateCreateBlog:"_ValidationResult",
		validateUpdateBlog:"_ValidationResult",
		getBlogLocale:"BlogLocale",
		listBlogLocale:"BlogLocale",
		paginateBlogLocale:"BlogLocaleConnection",
		validateCreateBlogLocale:"_ValidationResult",
		validateUpdateBlogLocale:"_ValidationResult",
		getBlogPost:"BlogPost",
		listBlogPost:"BlogPost",
		paginateBlogPost:"BlogPostConnection",
		validateCreateBlogPost:"_ValidationResult",
		validateUpdateBlogPost:"_ValidationResult",
		getBlogPostLocale:"BlogPostLocale",
		listBlogPostLocale:"BlogPostLocale",
		paginateBlogPostLocale:"BlogPostLocaleConnection",
		validateCreateBlogPostLocale:"_ValidationResult",
		validateUpdateBlogPostLocale:"_ValidationResult",
		getColorPallete:"ColorPallete",
		listColorPallete:"ColorPallete",
		paginateColorPallete:"ColorPalleteConnection",
		validateCreateColorPallete:"_ValidationResult",
		validateUpdateColorPallete:"_ValidationResult",
		getContent:"Content",
		listContent:"Content",
		paginateContent:"ContentConnection",
		validateCreateContent:"_ValidationResult",
		validateUpdateContent:"_ValidationResult",
		getContentBlock:"ContentBlock",
		listContentBlock:"ContentBlock",
		paginateContentBlock:"ContentBlockConnection",
		validateCreateContentBlock:"_ValidationResult",
		validateUpdateContentBlock:"_ValidationResult",
		getContentReference:"ContentReference",
		listContentReference:"ContentReference",
		paginateContentReference:"ContentReferenceConnection",
		validateCreateContentReference:"_ValidationResult",
		validateUpdateContentReference:"_ValidationResult",
		getBlogPostList:"BlogPostList",
		listBlogPostList:"BlogPostList",
		paginateBlogPostList:"BlogPostListConnection",
		validateCreateBlogPostList:"_ValidationResult",
		validateUpdateBlogPostList:"_ValidationResult",
		getBlogPostListItem:"BlogPostListItem",
		listBlogPostListItem:"BlogPostListItem",
		paginateBlogPostListItem:"BlogPostListItemConnection",
		validateCreateBlogPostListItem:"_ValidationResult",
		validateUpdateBlogPostListItem:"_ValidationResult",
		getLinkList:"LinkList",
		listLinkList:"LinkList",
		paginateLinkList:"LinkListConnection",
		validateCreateLinkList:"_ValidationResult",
		validateUpdateLinkList:"_ValidationResult",
		getLinkListItem:"LinkListItem",
		listLinkListItem:"LinkListItem",
		paginateLinkListItem:"LinkListItemConnection",
		validateCreateLinkListItem:"_ValidationResult",
		validateUpdateLinkListItem:"_ValidationResult",
		getCover:"Cover",
		listCover:"Cover",
		paginateCover:"CoverConnection",
		validateCreateCover:"_ValidationResult",
		validateUpdateCover:"_ValidationResult",
		getLink:"Link",
		listLink:"Link",
		paginateLink:"LinkConnection",
		validateCreateLink:"_ValidationResult",
		validateUpdateLink:"_ValidationResult",
		getLinkable:"Linkable",
		listLinkable:"Linkable",
		paginateLinkable:"LinkableConnection",
		validateCreateLinkable:"_ValidationResult",
		validateUpdateLinkable:"_ValidationResult",
		getMedium:"Medium",
		listMedium:"Medium",
		paginateMedium:"MediumConnection",
		validateCreateMedium:"_ValidationResult",
		validateUpdateMedium:"_ValidationResult",
		getVideo:"Video",
		listVideo:"Video",
		paginateVideo:"VideoConnection",
		validateCreateVideo:"_ValidationResult",
		validateUpdateVideo:"_ValidationResult",
		getSeo:"Seo",
		listSeo:"Seo",
		paginateSeo:"SeoConnection",
		validateCreateSeo:"_ValidationResult",
		validateUpdateSeo:"_ValidationResult",
		getProtectedImage:"ProtectedImage",
		listProtectedImage:"ProtectedImage",
		paginateProtectedImage:"ProtectedImageConnection",
		validateCreateProtectedImage:"_ValidationResult",
		validateUpdateProtectedImage:"_ValidationResult",
		getTranslationDomain:"TranslationDomain",
		listTranslationDomain:"TranslationDomain",
		paginateTranslationDomain:"TranslationDomainConnection",
		validateCreateTranslationDomain:"_ValidationResult",
		validateUpdateTranslationDomain:"_ValidationResult",
		getTranslationCatalogue:"TranslationCatalogue",
		listTranslationCatalogue:"TranslationCatalogue",
		paginateTranslationCatalogue:"TranslationCatalogueConnection",
		validateCreateTranslationCatalogue:"_ValidationResult",
		validateUpdateTranslationCatalogue:"_ValidationResult",
		getTranslationKey:"TranslationKey",
		listTranslationKey:"TranslationKey",
		paginateTranslationKey:"TranslationKeyConnection",
		validateCreateTranslationKey:"_ValidationResult",
		validateUpdateTranslationKey:"_ValidationResult",
		getTranslationValue:"TranslationValue",
		listTranslationValue:"TranslationValue",
		paginateTranslationValue:"TranslationValueConnection",
		validateCreateTranslationValue:"_ValidationResult",
		validateUpdateTranslationValue:"_ValidationResult",
		getTranslationCataloguesIdentifier:"TranslationCataloguesIdentifier",
		listTranslationCataloguesIdentifier:"TranslationCataloguesIdentifier",
		paginateTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierConnection",
		validateCreateTranslationCataloguesIdentifier:"_ValidationResult",
		validateUpdateTranslationCataloguesIdentifier:"_ValidationResult",
		getSocialsAndApps:"SocialsAndApps",
		listSocialsAndApps:"SocialsAndApps",
		paginateSocialsAndApps:"SocialsAndAppsConnection",
		validateCreateSocialsAndApps:"_ValidationResult",
		validateUpdateSocialsAndApps:"_ValidationResult",
		getProductGrid:"ProductGrid",
		listProductGrid:"ProductGrid",
		paginateProductGrid:"ProductGridConnection",
		validateCreateProductGrid:"_ValidationResult",
		validateUpdateProductGrid:"_ValidationResult",
		getProductGridItem:"ProductGridItem",
		listProductGridItem:"ProductGridItem",
		paginateProductGridItem:"ProductGridItemConnection",
		validateCreateProductGridItem:"_ValidationResult",
		validateUpdateProductGridItem:"_ValidationResult",
		getGallery:"Gallery",
		listGallery:"Gallery",
		paginateGallery:"GalleryConnection",
		validateCreateGallery:"_ValidationResult",
		validateUpdateGallery:"_ValidationResult",
		getGalleryItem:"GalleryItem",
		listGalleryItem:"GalleryItem",
		paginateGalleryItem:"GalleryItemConnection",
		validateCreateGalleryItem:"_ValidationResult",
		validateUpdateGalleryItem:"_ValidationResult",
		getHero:"Hero",
		listHero:"Hero",
		paginateHero:"HeroConnection",
		validateCreateHero:"_ValidationResult",
		validateUpdateHero:"_ValidationResult",
		getSiteMenu:"SiteMenu",
		listSiteMenu:"SiteMenu",
		paginateSiteMenu:"SiteMenuConnection",
		validateCreateSiteMenu:"_ValidationResult",
		validateUpdateSiteMenu:"_ValidationResult",
		getMenuLocale:"MenuLocale",
		listMenuLocale:"MenuLocale",
		paginateMenuLocale:"MenuLocaleConnection",
		validateCreateMenuLocale:"_ValidationResult",
		validateUpdateMenuLocale:"_ValidationResult",
		getMenuItem:"MenuItem",
		listMenuItem:"MenuItem",
		paginateMenuItem:"MenuItemConnection",
		validateCreateMenuItem:"_ValidationResult",
		validateUpdateMenuItem:"_ValidationResult",
		getPage:"Page",
		listPage:"Page",
		paginatePage:"PageConnection",
		validateCreatePage:"_ValidationResult",
		validateUpdatePage:"_ValidationResult",
		getPageLocale:"PageLocale",
		listPageLocale:"PageLocale",
		paginatePageLocale:"PageLocaleConnection",
		validateCreatePageLocale:"_ValidationResult",
		validateUpdatePageLocale:"_ValidationResult",
		getWikiPage:"WikiPage",
		listWikiPage:"WikiPage",
		paginateWikiPage:"WikiPageConnection",
		validateCreateWikiPage:"_ValidationResult",
		validateUpdateWikiPage:"_ValidationResult",
		getMenuSubitem:"MenuSubitem",
		listMenuSubitem:"MenuSubitem",
		paginateMenuSubitem:"MenuSubitemConnection",
		validateCreateMenuSubitem:"_ValidationResult",
		validateUpdateMenuSubitem:"_ValidationResult",
		getMenuLinkList:"MenuLinkList",
		listMenuLinkList:"MenuLinkList",
		paginateMenuLinkList:"MenuLinkListConnection",
		validateCreateMenuLinkList:"_ValidationResult",
		validateUpdateMenuLinkList:"_ValidationResult",
		getMenuLinkItem:"MenuLinkItem",
		listMenuLinkItem:"MenuLinkItem",
		paginateMenuLinkItem:"MenuLinkItemConnection",
		validateCreateMenuLinkItem:"_ValidationResult",
		validateUpdateMenuLinkItem:"_ValidationResult",
		getMenuProducts:"MenuProducts",
		listMenuProducts:"MenuProducts",
		paginateMenuProducts:"MenuProductsConnection",
		validateCreateMenuProducts:"_ValidationResult",
		validateUpdateMenuProducts:"_ValidationResult",
		getMenuDelivery:"MenuDelivery",
		listMenuDelivery:"MenuDelivery",
		paginateMenuDelivery:"MenuDeliveryConnection",
		validateCreateMenuDelivery:"_ValidationResult",
		validateUpdateMenuDelivery:"_ValidationResult",
		getMenuContact:"MenuContact",
		listMenuContact:"MenuContact",
		paginateMenuContact:"MenuContactConnection",
		validateCreateMenuContact:"_ValidationResult",
		validateUpdateMenuContact:"_ValidationResult",
		getDeadlineTemplate:"DeadlineTemplate",
		listDeadlineTemplate:"DeadlineTemplate",
		paginateDeadlineTemplate:"DeadlineTemplateConnection",
		validateCreateDeadlineTemplate:"_ValidationResult",
		validateUpdateDeadlineTemplate:"_ValidationResult",
		getEmployeeQueue:"EmployeeQueue",
		listEmployeeQueue:"EmployeeQueue",
		paginateEmployeeQueue:"EmployeeQueueConnection",
		validateCreateEmployeeQueue:"_ValidationResult",
		validateUpdateEmployeeQueue:"_ValidationResult",
		getTimetableDay:"TimetableDay",
		listTimetableDay:"TimetableDay",
		paginateTimetableDay:"TimetableDayConnection",
		validateCreateTimetableDay:"_ValidationResult",
		validateUpdateTimetableDay:"_ValidationResult",
		getTimetableEmployeeRole:"TimetableEmployeeRole",
		listTimetableEmployeeRole:"TimetableEmployeeRole",
		paginateTimetableEmployeeRole:"TimetableEmployeeRoleConnection",
		validateCreateTimetableEmployeeRole:"_ValidationResult",
		validateUpdateTimetableEmployeeRole:"_ValidationResult",
		getTimetableShift:"TimetableShift",
		listTimetableShift:"TimetableShift",
		paginateTimetableShift:"TimetableShiftConnection",
		validateCreateTimetableShift:"_ValidationResult",
		validateUpdateTimetableShift:"_ValidationResult",
		getTimetableShiftGroup:"TimetableShiftGroup",
		listTimetableShiftGroup:"TimetableShiftGroup",
		paginateTimetableShiftGroup:"TimetableShiftGroupConnection",
		validateCreateTimetableShiftGroup:"_ValidationResult",
		validateUpdateTimetableShiftGroup:"_ValidationResult",
		getTimetableShiftPosition:"TimetableShiftPosition",
		listTimetableShiftPosition:"TimetableShiftPosition",
		paginateTimetableShiftPosition:"TimetableShiftPositionConnection",
		validateCreateTimetableShiftPosition:"_ValidationResult",
		validateUpdateTimetableShiftPosition:"_ValidationResult",
		getTimetableTemplate:"TimetableTemplate",
		listTimetableTemplate:"TimetableTemplate",
		paginateTimetableTemplate:"TimetableTemplateConnection",
		validateCreateTimetableTemplate:"_ValidationResult",
		validateUpdateTimetableTemplate:"_ValidationResult",
		getCart:"Cart",
		listCart:"Cart",
		paginateCart:"CartConnection",
		validateCreateCart:"_ValidationResult",
		validateUpdateCart:"_ValidationResult",
		getCartItem:"CartItem",
		listCartItem:"CartItem",
		paginateCartItem:"CartItemConnection",
		validateCreateCartItem:"_ValidationResult",
		validateUpdateCartItem:"_ValidationResult",
		getEmployeeQueueItem:"EmployeeQueueItem",
		listEmployeeQueueItem:"EmployeeQueueItem",
		paginateEmployeeQueueItem:"EmployeeQueueItemConnection",
		validateCreateEmployeeQueueItem:"_ValidationResult",
		validateUpdateEmployeeQueueItem:"_ValidationResult",
		getApplication:"Application",
		listApplication:"Application",
		paginateApplication:"ApplicationConnection",
		validateCreateApplication:"_ValidationResult",
		validateUpdateApplication:"_ValidationResult",
		getApplicationShortcutList:"ApplicationShortcutList",
		listApplicationShortcutList:"ApplicationShortcutList",
		paginateApplicationShortcutList:"ApplicationShortcutListConnection",
		validateCreateApplicationShortcutList:"_ValidationResult",
		validateUpdateApplicationShortcutList:"_ValidationResult",
		getApplicationShortcutListItem:"ApplicationShortcutListItem",
		listApplicationShortcutListItem:"ApplicationShortcutListItem",
		paginateApplicationShortcutListItem:"ApplicationShortcutListItemConnection",
		validateCreateApplicationShortcutListItem:"_ValidationResult",
		validateUpdateApplicationShortcutListItem:"_ValidationResult",
		getProductBanner:"ProductBanner",
		listProductBanner:"ProductBanner",
		paginateProductBanner:"ProductBannerConnection",
		validateCreateProductBanner:"_ValidationResult",
		validateUpdateProductBanner:"_ValidationResult",
		getProductBannerItem:"ProductBannerItem",
		listProductBannerItem:"ProductBannerItem",
		paginateProductBannerItem:"ProductBannerItemConnection",
		validateCreateProductBannerItem:"_ValidationResult",
		validateUpdateProductBannerItem:"_ValidationResult",
		getProductBannerList:"ProductBannerList",
		listProductBannerList:"ProductBannerList",
		paginateProductBannerList:"ProductBannerListConnection",
		validateCreateProductBannerList:"_ValidationResult",
		validateUpdateProductBannerList:"_ValidationResult",
		getBartender:"Bartender",
		listBartender:"Bartender",
		paginateBartender:"BartenderConnection",
		validateCreateBartender:"_ValidationResult",
		validateUpdateBartender:"_ValidationResult",
		getBusinessToBusinessManager:"BusinessToBusinessManager",
		listBusinessToBusinessManager:"BusinessToBusinessManager",
		paginateBusinessToBusinessManager:"BusinessToBusinessManagerConnection",
		validateCreateBusinessToBusinessManager:"_ValidationResult",
		validateUpdateBusinessToBusinessManager:"_ValidationResult",
		getCleaner:"Cleaner",
		listCleaner:"Cleaner",
		paginateCleaner:"CleanerConnection",
		validateCreateCleaner:"_ValidationResult",
		validateUpdateCleaner:"_ValidationResult",
		getCourier:"Courier",
		listCourier:"Courier",
		paginateCourier:"CourierConnection",
		validateCreateCourier:"_ValidationResult",
		validateUpdateCourier:"_ValidationResult",
		getShiftsManager:"ShiftsManager",
		listShiftsManager:"ShiftsManager",
		paginateShiftsManager:"ShiftsManagerConnection",
		validateCreateShiftsManager:"_ValidationResult",
		validateUpdateShiftsManager:"_ValidationResult",
		getUser:"User",
		listUser:"User",
		paginateUser:"UserConnection",
		validateCreateUser:"_ValidationResult",
		validateUpdateUser:"_ValidationResult",
		getShiftsProfile:"ShiftsProfile",
		listShiftsProfile:"ShiftsProfile",
		paginateShiftsProfile:"ShiftsProfileConnection",
		validateCreateShiftsProfile:"_ValidationResult",
		validateUpdateShiftsProfile:"_ValidationResult",
		getProductIngredientCategory:"ProductIngredientCategory",
		listProductIngredientCategory:"ProductIngredientCategory",
		paginateProductIngredientCategory:"ProductIngredientCategoryConnection",
		validateCreateProductIngredientCategory:"_ValidationResult",
		validateUpdateProductIngredientCategory:"_ValidationResult",
		getProductIngredientCategoryLocale:"ProductIngredientCategoryLocale",
		listProductIngredientCategoryLocale:"ProductIngredientCategoryLocale",
		paginateProductIngredientCategoryLocale:"ProductIngredientCategoryLocaleConnection",
		validateCreateProductIngredientCategoryLocale:"_ValidationResult",
		validateUpdateProductIngredientCategoryLocale:"_ValidationResult",
		getStocksManager:"StocksManager",
		listStocksManager:"StocksManager",
		paginateStocksManager:"StocksManagerConnection",
		validateCreateStocksManager:"_ValidationResult",
		validateUpdateStocksManager:"_ValidationResult",
		getDeliveryRoute:"DeliveryRoute",
		listDeliveryRoute:"DeliveryRoute",
		paginateDeliveryRoute:"DeliveryRouteConnection",
		validateCreateDeliveryRoute:"_ValidationResult",
		validateUpdateDeliveryRoute:"_ValidationResult",
		getDeliveryWaypoint:"DeliveryWaypoint",
		listDeliveryWaypoint:"DeliveryWaypoint",
		paginateDeliveryWaypoint:"DeliveryWaypointConnection",
		validateCreateDeliveryWaypoint:"_ValidationResult",
		validateUpdateDeliveryWaypoint:"_ValidationResult",
		getAllergen:"Allergen",
		listAllergen:"Allergen",
		paginateAllergen:"AllergenConnection",
		validateCreateAllergen:"_ValidationResult",
		validateUpdateAllergen:"_ValidationResult",
		getAllergenLocale:"AllergenLocale",
		listAllergenLocale:"AllergenLocale",
		paginateAllergenLocale:"AllergenLocaleConnection",
		validateCreateAllergenLocale:"_ValidationResult",
		validateUpdateAllergenLocale:"_ValidationResult",
		getGps:"Gps",
		listGps:"Gps",
		paginateGps:"GpsConnection",
		validateCreateGps:"_ValidationResult",
		validateUpdateGps:"_ValidationResult",
		getProductCategoryTree:"ProductCategoryTree",
		listProductCategoryTree:"ProductCategoryTree",
		paginateProductCategoryTree:"ProductCategoryTreeConnection",
		getInheritedProductCategoryTag:"InheritedProductCategoryTag",
		listInheritedProductCategoryTag:"InheritedProductCategoryTag",
		paginateInheritedProductCategoryTag:"InheritedProductCategoryTagConnection",
		getNestedProductCategoryProduct:"NestedProductCategoryProduct",
		listNestedProductCategoryProduct:"NestedProductCategoryProduct",
		paginateNestedProductCategoryProduct:"NestedProductCategoryProductConnection",
		getWeekHours:"WeekHours",
		listWeekHours:"WeekHours",
		paginateWeekHours:"WeekHoursConnection",
		validateCreateWeekHours:"_ValidationResult",
		validateUpdateWeekHours:"_ValidationResult",
		getPreparedIngredientQuantity:"PreparedIngredientQuantity",
		listPreparedIngredientQuantity:"PreparedIngredientQuantity",
		paginatePreparedIngredientQuantity:"PreparedIngredientQuantityConnection",
		validateCreatePreparedIngredientQuantity:"_ValidationResult",
		validateUpdatePreparedIngredientQuantity:"_ValidationResult",
		getPreparedRecipeQuantity:"PreparedRecipeQuantity",
		listPreparedRecipeQuantity:"PreparedRecipeQuantity",
		paginatePreparedRecipeQuantity:"PreparedRecipeQuantityConnection",
		validateCreatePreparedRecipeQuantity:"_ValidationResult",
		validateUpdatePreparedRecipeQuantity:"_ValidationResult",
		getInternalOrder:"InternalOrder",
		listInternalOrder:"InternalOrder",
		paginateInternalOrder:"InternalOrderConnection",
		validateCreateInternalOrder:"_ValidationResult",
		validateUpdateInternalOrder:"_ValidationResult",
		getInternalOrderItem:"InternalOrderItem",
		listInternalOrderItem:"InternalOrderItem",
		paginateInternalOrderItem:"InternalOrderItemConnection",
		validateCreateInternalOrderItem:"_ValidationResult",
		validateUpdateInternalOrderItem:"_ValidationResult",
		getPreparedPackingQuantity:"PreparedPackingQuantity",
		listPreparedPackingQuantity:"PreparedPackingQuantity",
		paginatePreparedPackingQuantity:"PreparedPackingQuantityConnection",
		validateCreatePreparedPackingQuantity:"_ValidationResult",
		validateUpdatePreparedPackingQuantity:"_ValidationResult",
		getCourierManager:"CourierManager",
		listCourierManager:"CourierManager",
		paginateCourierManager:"CourierManagerConnection",
		validateCreateCourierManager:"_ValidationResult",
		validateUpdateCourierManager:"_ValidationResult",
		getDeliveryZone:"DeliveryZone",
		listDeliveryZone:"DeliveryZone",
		paginateDeliveryZone:"DeliveryZoneConnection",
		validateCreateDeliveryZone:"_ValidationResult",
		validateUpdateDeliveryZone:"_ValidationResult",
		getAddressMetadata:"AddressMetadata",
		listAddressMetadata:"AddressMetadata",
		paginateAddressMetadata:"AddressMetadataConnection",
		getDeliveryTimelinePreset:"DeliveryTimelinePreset",
		listDeliveryTimelinePreset:"DeliveryTimelinePreset",
		paginateDeliveryTimelinePreset:"DeliveryTimelinePresetConnection",
		validateCreateDeliveryTimelinePreset:"_ValidationResult",
		validateUpdateDeliveryTimelinePreset:"_ValidationResult",
		getOrderDeliveryTimeline:"OrderDeliveryTimeline",
		listOrderDeliveryTimeline:"OrderDeliveryTimeline",
		paginateOrderDeliveryTimeline:"OrderDeliveryTimelineConnection",
		validateCreateOrderDeliveryTimeline:"_ValidationResult",
		validateUpdateOrderDeliveryTimeline:"_ValidationResult",
		getOrderEvent:"OrderEvent",
		listOrderEvent:"OrderEvent",
		paginateOrderEvent:"OrderEventConnection",
		validateCreateOrderEvent:"_ValidationResult",
		validateUpdateOrderEvent:"_ValidationResult",
		getLiftagoRide:"LiftagoRide",
		listLiftagoRide:"LiftagoRide",
		paginateLiftagoRide:"LiftagoRideConnection",
		validateCreateLiftagoRide:"_ValidationResult",
		validateUpdateLiftagoRide:"_ValidationResult",
		getInvoice:"Invoice",
		listInvoice:"Invoice",
		paginateInvoice:"InvoiceConnection",
		validateCreateInvoice:"_ValidationResult",
		validateUpdateInvoice:"_ValidationResult",
		getInvoicingPlan:"InvoicingPlan",
		listInvoicingPlan:"InvoicingPlan",
		paginateInvoicingPlan:"InvoicingPlanConnection",
		validateCreateInvoicingPlan:"_ValidationResult",
		validateUpdateInvoicingPlan:"_ValidationResult",
		getProductPackingLocale:"ProductPackingLocale",
		listProductPackingLocale:"ProductPackingLocale",
		paginateProductPackingLocale:"ProductPackingLocaleConnection",
		validateCreateProductPackingLocale:"_ValidationResult",
		validateUpdateProductPackingLocale:"_ValidationResult",
		getProductLocale:"ProductLocale",
		listProductLocale:"ProductLocale",
		paginateProductLocale:"ProductLocaleConnection",
		validateCreateProductLocale:"_ValidationResult",
		validateUpdateProductLocale:"_ValidationResult",
		getProductRecipeLocale:"ProductRecipeLocale",
		listProductRecipeLocale:"ProductRecipeLocale",
		paginateProductRecipeLocale:"ProductRecipeLocaleConnection",
		validateCreateProductRecipeLocale:"_ValidationResult",
		validateUpdateProductRecipeLocale:"_ValidationResult",
		getUserDevice:"UserDevice",
		listUserDevice:"UserDevice",
		paginateUserDevice:"UserDeviceConnection",
		validateCreateUserDevice:"_ValidationResult",
		validateUpdateUserDevice:"_ValidationResult",
		getProtectedAction:"ProtectedAction",
		listProtectedAction:"ProtectedAction",
		paginateProtectedAction:"ProtectedActionConnection",
		validateCreateProtectedAction:"_ValidationResult",
		validateUpdateProtectedAction:"_ValidationResult",
		getPicker:"Picker",
		listPicker:"Picker",
		paginatePicker:"PickerConnection",
		validateCreatePicker:"_ValidationResult",
		validateUpdatePicker:"_ValidationResult",
		getTenantPerson:"TenantPerson",
		listTenantPerson:"TenantPerson",
		paginateTenantPerson:"TenantPersonConnection",
		getTimetableTemplateStaffOptions:"TimetableTemplateStaffOptions",
		listTimetableTemplateStaffOptions:"TimetableTemplateStaffOptions",
		paginateTimetableTemplateStaffOptions:"TimetableTemplateStaffOptionsConnection",
		validateCreateTimetableTemplateStaffOptions:"_ValidationResult",
		validateUpdateTimetableTemplateStaffOptions:"_ValidationResult",
		getShoppingList:"ShoppingList",
		listShoppingList:"ShoppingList",
		paginateShoppingList:"ShoppingListConnection",
		validateCreateShoppingList:"_ValidationResult",
		validateUpdateShoppingList:"_ValidationResult",
		getSuppliesPurchase:"SuppliesPurchase",
		listSuppliesPurchase:"SuppliesPurchase",
		paginateSuppliesPurchase:"SuppliesPurchaseConnection",
		validateCreateSuppliesPurchase:"_ValidationResult",
		validateUpdateSuppliesPurchase:"_ValidationResult",
		getInvoicingPreset:"InvoicingPreset",
		listInvoicingPreset:"InvoicingPreset",
		paginateInvoicingPreset:"InvoicingPresetConnection",
		validateCreateInvoicingPreset:"_ValidationResult",
		validateUpdateInvoicingPreset:"_ValidationResult",
		getLogRecord:"LogRecord",
		listLogRecord:"LogRecord",
		paginateLogRecord:"LogRecordConnection",
		validateCreateLogRecord:"_ValidationResult",
		validateUpdateLogRecord:"_ValidationResult",
		getBillingSubject:"BillingSubject",
		listBillingSubject:"BillingSubject",
		paginateBillingSubject:"BillingSubjectConnection",
		validateCreateBillingSubject:"_ValidationResult",
		validateUpdateBillingSubject:"_ValidationResult",
		getProductCustomerPrice:"ProductCustomerPrice",
		listProductCustomerPrice:"ProductCustomerPrice",
		paginateProductCustomerPrice:"ProductCustomerPriceConnection",
		getCartPriceLine:"CartPriceLine",
		listCartPriceLine:"CartPriceLine",
		paginateCartPriceLine:"CartPriceLineConnection",
		getShoppingListItem:"ShoppingListItem",
		listShoppingListItem:"ShoppingListItem",
		paginateShoppingListItem:"ShoppingListItemConnection",
		validateCreateShoppingListItem:"_ValidationResult",
		validateUpdateShoppingListItem:"_ValidationResult",
		getSuppliesPurchaseItem:"SuppliesPurchaseItem",
		listSuppliesPurchaseItem:"SuppliesPurchaseItem",
		paginateSuppliesPurchaseItem:"SuppliesPurchaseItemConnection",
		validateCreateSuppliesPurchaseItem:"_ValidationResult",
		validateUpdateSuppliesPurchaseItem:"_ValidationResult",
		getCustomerCreditTransaction:"CustomerCreditTransaction",
		listCustomerCreditTransaction:"CustomerCreditTransaction",
		paginateCustomerCreditTransaction:"CustomerCreditTransactionConnection",
		validateCreateCustomerCreditTransaction:"_ValidationResult",
		validateUpdateCustomerCreditTransaction:"_ValidationResult",
		getVirtualProduct:"VirtualProduct",
		listVirtualProduct:"VirtualProduct",
		paginateVirtualProduct:"VirtualProductConnection",
		validateCreateVirtualProduct:"_ValidationResult",
		validateUpdateVirtualProduct:"_ValidationResult",
		getVirtualProductEffect:"VirtualProductEffect",
		listVirtualProductEffect:"VirtualProductEffect",
		paginateVirtualProductEffect:"VirtualProductEffectConnection",
		validateCreateVirtualProductEffect:"_ValidationResult",
		validateUpdateVirtualProductEffect:"_ValidationResult",
		getOrderPriceLine:"OrderPriceLine",
		listOrderPriceLine:"OrderPriceLine",
		paginateOrderPriceLine:"OrderPriceLineConnection",
		getProductMetadata:"ProductMetadata",
		listProductMetadata:"ProductMetadata",
		paginateProductMetadata:"ProductMetadataConnection",
		getEmploymentInformation:"EmploymentInformation",
		listEmploymentInformation:"EmploymentInformation",
		paginateEmploymentInformation:"EmploymentInformationConnection",
		validateCreateEmploymentInformation:"_ValidationResult",
		validateUpdateEmploymentInformation:"_ValidationResult",
		getRemunerationProfile:"RemunerationProfile",
		listRemunerationProfile:"RemunerationProfile",
		paginateRemunerationProfile:"RemunerationProfileConnection",
		validateCreateRemunerationProfile:"_ValidationResult",
		validateUpdateRemunerationProfile:"_ValidationResult",
		getWorkMonth:"WorkMonth",
		listWorkMonth:"WorkMonth",
		paginateWorkMonth:"WorkMonthConnection",
		validateCreateWorkMonth:"_ValidationResult",
		validateUpdateWorkMonth:"_ValidationResult",
		getSalaryOptions:"SalaryOptions",
		listSalaryOptions:"SalaryOptions",
		paginateSalaryOptions:"SalaryOptionsConnection",
		validateCreateSalaryOptions:"_ValidationResult",
		validateUpdateSalaryOptions:"_ValidationResult",
		getTimetableShiftSwapInfo:"TimetableShiftSwapInfo",
		listTimetableShiftSwapInfo:"TimetableShiftSwapInfo",
		paginateTimetableShiftSwapInfo:"TimetableShiftSwapInfoConnection",
		validateCreateTimetableShiftSwapInfo:"_ValidationResult",
		validateUpdateTimetableShiftSwapInfo:"_ValidationResult",
		getProductGridCategory:"ProductGridCategory",
		listProductGridCategory:"ProductGridCategory",
		paginateProductGridCategory:"ProductGridCategoryConnection",
		validateCreateProductGridCategory:"_ValidationResult",
		validateUpdateProductGridCategory:"_ValidationResult",
		getCashier:"Cashier",
		listCashier:"Cashier",
		paginateCashier:"CashierConnection",
		validateCreateCashier:"_ValidationResult",
		validateUpdateCashier:"_ValidationResult",
		getPointOfSaleCategory:"PointOfSaleCategory",
		listPointOfSaleCategory:"PointOfSaleCategory",
		paginatePointOfSaleCategory:"PointOfSaleCategoryConnection",
		validateCreatePointOfSaleCategory:"_ValidationResult",
		validateUpdatePointOfSaleCategory:"_ValidationResult",
		getPointOfSaleCategoryLocale:"PointOfSaleCategoryLocale",
		listPointOfSaleCategoryLocale:"PointOfSaleCategoryLocale",
		paginatePointOfSaleCategoryLocale:"PointOfSaleCategoryLocaleConnection",
		validateCreatePointOfSaleCategoryLocale:"_ValidationResult",
		validateUpdatePointOfSaleCategoryLocale:"_ValidationResult",
		getPointOfSaleCategoryProduct:"PointOfSaleCategoryProduct",
		listPointOfSaleCategoryProduct:"PointOfSaleCategoryProduct",
		paginatePointOfSaleCategoryProduct:"PointOfSaleCategoryProductConnection",
		validateCreatePointOfSaleCategoryProduct:"_ValidationResult",
		validateUpdatePointOfSaleCategoryProduct:"_ValidationResult",
		getPointOfSaleCategoryProductLocale:"PointOfSaleCategoryProductLocale",
		listPointOfSaleCategoryProductLocale:"PointOfSaleCategoryProductLocale",
		paginatePointOfSaleCategoryProductLocale:"PointOfSaleCategoryProductLocaleConnection",
		validateCreatePointOfSaleCategoryProductLocale:"_ValidationResult",
		validateUpdatePointOfSaleCategoryProductLocale:"_ValidationResult",
		getCustomerTab:"CustomerTab",
		listCustomerTab:"CustomerTab",
		paginateCustomerTab:"CustomerTabConnection",
		validateCreateCustomerTab:"_ValidationResult",
		validateUpdateCustomerTab:"_ValidationResult",
		getCustomerTabItem:"CustomerTabItem",
		listCustomerTabItem:"CustomerTabItem",
		paginateCustomerTabItem:"CustomerTabItemConnection",
		validateCreateCustomerTabItem:"_ValidationResult",
		validateUpdateCustomerTabItem:"_ValidationResult",
		getAnonymousSession:"AnonymousSession",
		listAnonymousSession:"AnonymousSession",
		paginateAnonymousSession:"AnonymousSessionConnection",
		validateCreateAnonymousSession:"_ValidationResult",
		validateUpdateAnonymousSession:"_ValidationResult",
		getVoucher:"Voucher",
		listVoucher:"Voucher",
		paginateVoucher:"VoucherConnection",
		validateCreateVoucher:"_ValidationResult",
		validateUpdateVoucher:"_ValidationResult",
		getVoucherRedemption:"VoucherRedemption",
		listVoucherRedemption:"VoucherRedemption",
		paginateVoucherRedemption:"VoucherRedemptionConnection",
		validateCreateVoucherRedemption:"_ValidationResult",
		validateUpdateVoucherRedemption:"_ValidationResult",
		getUnassignedShiftInfo:"UnassignedShiftInfo",
		listUnassignedShiftInfo:"UnassignedShiftInfo",
		paginateUnassignedShiftInfo:"UnassignedShiftInfoConnection",
		validateCreateUnassignedShiftInfo:"_ValidationResult",
		validateUpdateUnassignedShiftInfo:"_ValidationResult",
		getFreshingContainer:"FreshingContainer",
		listFreshingContainer:"FreshingContainer",
		paginateFreshingContainer:"FreshingContainerConnection",
		validateCreateFreshingContainer:"_ValidationResult",
		validateUpdateFreshingContainer:"_ValidationResult",
		getTextItem:"TextItem",
		listTextItem:"TextItem",
		paginateTextItem:"TextItemConnection",
		validateCreateTextItem:"_ValidationResult",
		validateUpdateTextItem:"_ValidationResult",
		getTextList:"TextList",
		listTextList:"TextList",
		paginateTextList:"TextListConnection",
		validateCreateTextList:"_ValidationResult",
		validateUpdateTextList:"_ValidationResult",
		getEmployeeQueueItemMetadata:"EmployeeQueueItemMetadata",
		listEmployeeQueueItemMetadata:"EmployeeQueueItemMetadata",
		paginateEmployeeQueueItemMetadata:"EmployeeQueueItemMetadataConnection",
		getDeliveryRegions:"DeliveryRegions",
		listDeliveryRegions:"DeliveryRegions",
		paginateDeliveryRegions:"DeliveryRegionsConnection",
		validateCreateDeliveryRegions:"_ValidationResult",
		validateUpdateDeliveryRegions:"_ValidationResult",
		getDeliveryRegionsItem:"DeliveryRegionsItem",
		listDeliveryRegionsItem:"DeliveryRegionsItem",
		paginateDeliveryRegionsItem:"DeliveryRegionsItemConnection",
		validateCreateDeliveryRegionsItem:"_ValidationResult",
		validateUpdateDeliveryRegionsItem:"_ValidationResult",
		getImageList:"ImageList",
		listImageList:"ImageList",
		paginateImageList:"ImageListConnection",
		validateCreateImageList:"_ValidationResult",
		validateUpdateImageList:"_ValidationResult",
		getImageListItem:"ImageListItem",
		listImageListItem:"ImageListItem",
		paginateImageListItem:"ImageListItemConnection",
		validateCreateImageListItem:"_ValidationResult",
		validateUpdateImageListItem:"_ValidationResult",
		getProductSalesDay:"ProductSalesDay",
		listProductSalesDay:"ProductSalesDay",
		paginateProductSalesDay:"ProductSalesDayConnection",
		getProductSalesMonth:"ProductSalesMonth",
		listProductSalesMonth:"ProductSalesMonth",
		paginateProductSalesMonth:"ProductSalesMonthConnection",
		getProductSalesWeek:"ProductSalesWeek",
		listProductSalesWeek:"ProductSalesWeek",
		paginateProductSalesWeek:"ProductSalesWeekConnection",
		getTimetablesEmployeePrivileges:"TimetablesEmployeePrivileges",
		listTimetablesEmployeePrivileges:"TimetablesEmployeePrivileges",
		paginateTimetablesEmployeePrivileges:"TimetablesEmployeePrivilegesConnection",
		validateCreateTimetablesEmployeePrivileges:"_ValidationResult",
		validateUpdateTimetablesEmployeePrivileges:"_ValidationResult",
		getTimetableDayNote:"TimetableDayNote",
		listTimetableDayNote:"TimetableDayNote",
		paginateTimetableDayNote:"TimetableDayNoteConnection",
		validateCreateTimetableDayNote:"_ValidationResult",
		validateUpdateTimetableDayNote:"_ValidationResult",
		getDeliveryMethodLocale:"DeliveryMethodLocale",
		listDeliveryMethodLocale:"DeliveryMethodLocale",
		paginateDeliveryMethodLocale:"DeliveryMethodLocaleConnection",
		validateCreateDeliveryMethodLocale:"_ValidationResult",
		validateUpdateDeliveryMethodLocale:"_ValidationResult",
		getIngredientSupplier:"IngredientSupplier",
		listIngredientSupplier:"IngredientSupplier",
		paginateIngredientSupplier:"IngredientSupplierConnection",
		validateCreateIngredientSupplier:"_ValidationResult",
		validateUpdateIngredientSupplier:"_ValidationResult",
		getIngredientSupplierItem:"IngredientSupplierItem",
		listIngredientSupplierItem:"IngredientSupplierItem",
		paginateIngredientSupplierItem:"IngredientSupplierItemConnection",
		validateCreateIngredientSupplierItem:"_ValidationResult",
		validateUpdateIngredientSupplierItem:"_ValidationResult",
		getIngredientSupplierList:"IngredientSupplierList",
		listIngredientSupplierList:"IngredientSupplierList",
		paginateIngredientSupplierList:"IngredientSupplierListConnection",
		validateCreateIngredientSupplierList:"_ValidationResult",
		validateUpdateIngredientSupplierList:"_ValidationResult",
		getIngredientSupplierLocale:"IngredientSupplierLocale",
		listIngredientSupplierLocale:"IngredientSupplierLocale",
		paginateIngredientSupplierLocale:"IngredientSupplierLocaleConnection",
		validateCreateIngredientSupplierLocale:"_ValidationResult",
		validateUpdateIngredientSupplierLocale:"_ValidationResult",
		getRedirect:"Redirect",
		listRedirect:"Redirect",
		paginateRedirect:"RedirectConnection",
		validateCreateRedirect:"_ValidationResult",
		validateUpdateRedirect:"_ValidationResult",
		getNutritionFacts:"NutritionFacts",
		listNutritionFacts:"NutritionFacts",
		paginateNutritionFacts:"NutritionFactsConnection",
		validateCreateNutritionFacts:"_ValidationResult",
		validateUpdateNutritionFacts:"_ValidationResult",
		getVenue:"Venue",
		listVenue:"Venue",
		paginateVenue:"VenueConnection",
		validateCreateVenue:"_ValidationResult",
		validateUpdateVenue:"_ValidationResult",
		getWorkspace:"Workspace",
		listWorkspace:"Workspace",
		paginateWorkspace:"WorkspaceConnection",
		validateCreateWorkspace:"_ValidationResult",
		validateUpdateWorkspace:"_ValidationResult",
		getInternalBuyer:"InternalBuyer",
		listInternalBuyer:"InternalBuyer",
		paginateInternalBuyer:"InternalBuyerConnection",
		validateCreateInternalBuyer:"_ValidationResult",
		validateUpdateInternalBuyer:"_ValidationResult",
		getCartSummary:"CartSummary",
		listCartSummary:"CartSummary",
		paginateCartSummary:"CartSummaryConnection",
		getOrderSummary:"OrderSummary",
		listOrderSummary:"OrderSummary",
		paginateOrderSummary:"OrderSummaryConnection",
		getCustomerSpending:"CustomerSpending",
		listCustomerSpending:"CustomerSpending",
		paginateCustomerSpending:"CustomerSpendingConnection",
		getOrderPaymentMetadata:"OrderPaymentMetadata",
		listOrderPaymentMetadata:"OrderPaymentMetadata",
		paginateOrderPaymentMetadata:"OrderPaymentMetadataConnection",
		getUserMetadata:"UserMetadata",
		listUserMetadata:"UserMetadata",
		paginateUserMetadata:"UserMetadataConnection",
		getCustomerTabMetadata:"CustomerTabMetadata",
		listCustomerTabMetadata:"CustomerTabMetadata",
		paginateCustomerTabMetadata:"CustomerTabMetadataConnection",
		getVenueEmployeeRole:"VenueEmployeeRole",
		listVenueEmployeeRole:"VenueEmployeeRole",
		paginateVenueEmployeeRole:"VenueEmployeeRoleConnection",
		validateCreateVenueEmployeeRole:"_ValidationResult",
		validateUpdateVenueEmployeeRole:"_ValidationResult",
		getIdentificationAttempt:"IdentificationAttempt",
		listIdentificationAttempt:"IdentificationAttempt",
		paginateIdentificationAttempt:"IdentificationAttemptConnection",
		validateCreateIdentificationAttempt:"_ValidationResult",
		validateUpdateIdentificationAttempt:"_ValidationResult",
		getIdentificationCode:"IdentificationCode",
		listIdentificationCode:"IdentificationCode",
		paginateIdentificationCode:"IdentificationCodeConnection",
		validateCreateIdentificationCode:"_ValidationResult",
		validateUpdateIdentificationCode:"_ValidationResult",
		getIdentificationCodeLocale:"IdentificationCodeLocale",
		listIdentificationCodeLocale:"IdentificationCodeLocale",
		paginateIdentificationCodeLocale:"IdentificationCodeLocaleConnection",
		validateCreateIdentificationCodeLocale:"_ValidationResult",
		validateUpdateIdentificationCodeLocale:"_ValidationResult",
		getPipeline:"Pipeline",
		listPipeline:"Pipeline",
		paginatePipeline:"PipelineConnection",
		validateCreatePipeline:"_ValidationResult",
		validateUpdatePipeline:"_ValidationResult",
		getPipelineLead:"PipelineLead",
		listPipelineLead:"PipelineLead",
		paginatePipelineLead:"PipelineLeadConnection",
		validateCreatePipelineLead:"_ValidationResult",
		validateUpdatePipelineLead:"_ValidationResult",
		getPipelineStage:"PipelineStage",
		listPipelineStage:"PipelineStage",
		paginatePipelineStage:"PipelineStageConnection",
		validateCreatePipelineStage:"_ValidationResult",
		validateUpdatePipelineStage:"_ValidationResult",
		getPipelineStageItem:"PipelineStageItem",
		listPipelineStageItem:"PipelineStageItem",
		paginatePipelineStageItem:"PipelineStageItemConnection",
		validateCreatePipelineStageItem:"_ValidationResult",
		validateUpdatePipelineStageItem:"_ValidationResult",
		getPipelineStageLocale:"PipelineStageLocale",
		listPipelineStageLocale:"PipelineStageLocale",
		paginatePipelineStageLocale:"PipelineStageLocaleConnection",
		validateCreatePipelineStageLocale:"_ValidationResult",
		validateUpdatePipelineStageLocale:"_ValidationResult",
		getSalesManager:"SalesManager",
		listSalesManager:"SalesManager",
		paginateSalesManager:"SalesManagerConnection",
		validateCreateSalesManager:"_ValidationResult",
		validateUpdateSalesManager:"_ValidationResult",
		getCashierManager:"CashierManager",
		listCashierManager:"CashierManager",
		paginateCashierManager:"CashierManagerConnection",
		validateCreateCashierManager:"_ValidationResult",
		validateUpdateCashierManager:"_ValidationResult",
		getUserRoles:"UserRoles",
		listUserRoles:"UserRoles",
		paginateUserRoles:"UserRolesConnection",
		getPointOfSaleApplicationDevice:"PointOfSaleApplicationDevice",
		listPointOfSaleApplicationDevice:"PointOfSaleApplicationDevice",
		paginatePointOfSaleApplicationDevice:"PointOfSaleApplicationDeviceConnection",
		validateCreatePointOfSaleApplicationDevice:"_ValidationResult",
		validateUpdatePointOfSaleApplicationDevice:"_ValidationResult",
		getPointOfSaleTerminal:"PointOfSaleTerminal",
		listPointOfSaleTerminal:"PointOfSaleTerminal",
		paginatePointOfSaleTerminal:"PointOfSaleTerminalConnection",
		validateCreatePointOfSaleTerminal:"_ValidationResult",
		validateUpdatePointOfSaleTerminal:"_ValidationResult",
		getPipelineStageSentiment:"PipelineStageSentiment",
		listPipelineStageSentiment:"PipelineStageSentiment",
		paginatePipelineStageSentiment:"PipelineStageSentimentConnection",
		validateCreatePipelineStageSentiment:"_ValidationResult",
		validateUpdatePipelineStageSentiment:"_ValidationResult",
		getDeviceIdentifier:"DeviceIdentifier",
		listDeviceIdentifier:"DeviceIdentifier",
		paginateDeviceIdentifier:"DeviceIdentifierConnection",
		validateCreateDeviceIdentifier:"_ValidationResult",
		validateUpdateDeviceIdentifier:"_ValidationResult",
		getDeviceIdentifierMetadata:"DeviceIdentifierMetadata",
		listDeviceIdentifierMetadata:"DeviceIdentifierMetadata",
		paginateDeviceIdentifierMetadata:"DeviceIdentifierMetadataConnection",
		getPointOfSalePrinter:"PointOfSalePrinter",
		listPointOfSalePrinter:"PointOfSalePrinter",
		paginatePointOfSalePrinter:"PointOfSalePrinterConnection",
		validateCreatePointOfSalePrinter:"_ValidationResult",
		validateUpdatePointOfSalePrinter:"_ValidationResult",
		getGratuity:"Gratuity",
		listGratuity:"Gratuity",
		paginateGratuity:"GratuityConnection",
		validateCreateGratuity:"_ValidationResult",
		validateUpdateGratuity:"_ValidationResult",
		getFulfillmentNote:"FulfillmentNote",
		listFulfillmentNote:"FulfillmentNote",
		paginateFulfillmentNote:"FulfillmentNoteConnection",
		validateCreateFulfillmentNote:"_ValidationResult",
		validateUpdateFulfillmentNote:"_ValidationResult",
		getCustomerMetadata:"CustomerMetadata",
		listCustomerMetadata:"CustomerMetadata",
		paginateCustomerMetadata:"CustomerMetadataConnection",
		getLeadForm:"LeadForm",
		listLeadForm:"LeadForm",
		paginateLeadForm:"LeadFormConnection",
		validateCreateLeadForm:"_ValidationResult",
		validateUpdateLeadForm:"_ValidationResult",
		getSubscriptionBox:"SubscriptionBox",
		listSubscriptionBox:"SubscriptionBox",
		paginateSubscriptionBox:"SubscriptionBoxConnection",
		validateCreateSubscriptionBox:"_ValidationResult",
		validateUpdateSubscriptionBox:"_ValidationResult",
		getSubscriptionBoxLocale:"SubscriptionBoxLocale",
		listSubscriptionBoxLocale:"SubscriptionBoxLocale",
		paginateSubscriptionBoxLocale:"SubscriptionBoxLocaleConnection",
		validateCreateSubscriptionBoxLocale:"_ValidationResult",
		validateUpdateSubscriptionBoxLocale:"_ValidationResult",
		getTimetableDayMetadata:"TimetableDayMetadata",
		listTimetableDayMetadata:"TimetableDayMetadata",
		paginateTimetableDayMetadata:"TimetableDayMetadataConnection",
		getBusinessService:"BusinessService",
		listBusinessService:"BusinessService",
		paginateBusinessService:"BusinessServiceConnection",
		validateCreateBusinessService:"_ValidationResult",
		validateUpdateBusinessService:"_ValidationResult",
		getBusinessServiceEvent:"BusinessServiceEvent",
		listBusinessServiceEvent:"BusinessServiceEvent",
		paginateBusinessServiceEvent:"BusinessServiceEventConnection",
		validateCreateBusinessServiceEvent:"_ValidationResult",
		validateUpdateBusinessServiceEvent:"_ValidationResult",
		getBusinessServiceLocale:"BusinessServiceLocale",
		listBusinessServiceLocale:"BusinessServiceLocale",
		paginateBusinessServiceLocale:"BusinessServiceLocaleConnection",
		validateCreateBusinessServiceLocale:"_ValidationResult",
		validateUpdateBusinessServiceLocale:"_ValidationResult",
		getGridTileItem:"GridTileItem",
		listGridTileItem:"GridTileItem",
		paginateGridTileItem:"GridTileItemConnection",
		validateCreateGridTileItem:"_ValidationResult",
		validateUpdateGridTileItem:"_ValidationResult",
		getGridTiles:"GridTiles",
		listGridTiles:"GridTiles",
		paginateGridTiles:"GridTilesConnection",
		validateCreateGridTiles:"_ValidationResult",
		validateUpdateGridTiles:"_ValidationResult",
		getArea:"Area",
		listArea:"Area",
		paginateArea:"AreaConnection",
		validateCreateArea:"_ValidationResult",
		validateUpdateArea:"_ValidationResult",
		getPosition:"Position",
		listPosition:"Position",
		paginatePosition:"PositionConnection",
		validateCreatePosition:"_ValidationResult",
		validateUpdatePosition:"_ValidationResult",
		getStatsEnabledWidgetType:"StatsEnabledWidgetType",
		listStatsEnabledWidgetType:"StatsEnabledWidgetType",
		paginateStatsEnabledWidgetType:"StatsEnabledWidgetTypeConnection",
		validateCreateStatsEnabledWidgetType:"_ValidationResult",
		validateUpdateStatsEnabledWidgetType:"_ValidationResult",
		getStatsWidget:"StatsWidget",
		listStatsWidget:"StatsWidget",
		paginateStatsWidget:"StatsWidgetConnection",
		validateCreateStatsWidget:"_ValidationResult",
		validateUpdateStatsWidget:"_ValidationResult",
		getStatsWidgetsLayout:"StatsWidgetsLayout",
		listStatsWidgetsLayout:"StatsWidgetsLayout",
		paginateStatsWidgetsLayout:"StatsWidgetsLayoutConnection",
		validateCreateStatsWidgetsLayout:"_ValidationResult",
		validateUpdateStatsWidgetsLayout:"_ValidationResult",
		getSeat:"Seat",
		listSeat:"Seat",
		paginateSeat:"SeatConnection",
		validateCreateSeat:"_ValidationResult",
		validateUpdateSeat:"_ValidationResult",
		getTable:"Table",
		listTable:"Table",
		paginateTable:"TableConnection",
		validateCreateTable:"_ValidationResult",
		validateUpdateTable:"_ValidationResult",
		getStatsPage:"StatsPage",
		listStatsPage:"StatsPage",
		paginateStatsPage:"StatsPageConnection",
		validateCreateStatsPage:"_ValidationResult",
		validateUpdateStatsPage:"_ValidationResult",
		getUnassignReason:"UnassignReason",
		listUnassignReason:"UnassignReason",
		paginateUnassignReason:"UnassignReasonConnection",
		validateCreateUnassignReason:"_ValidationResult",
		validateUpdateUnassignReason:"_ValidationResult",
		getDoubleshotCoffeeEquipment:"DoubleshotCoffeeEquipment",
		listDoubleshotCoffeeEquipment:"DoubleshotCoffeeEquipment",
		paginateDoubleshotCoffeeEquipment:"DoubleshotCoffeeEquipmentConnection",
		validateCreateDoubleshotCoffeeEquipment:"_ValidationResult",
		validateUpdateDoubleshotCoffeeEquipment:"_ValidationResult",
		getExpense:"Expense",
		listExpense:"Expense",
		paginateExpense:"ExpenseConnection",
		validateCreateExpense:"_ValidationResult",
		validateUpdateExpense:"_ValidationResult",
		getExpenseCategory:"ExpenseCategory",
		listExpenseCategory:"ExpenseCategory",
		paginateExpenseCategory:"ExpenseCategoryConnection",
		validateCreateExpenseCategory:"_ValidationResult",
		validateUpdateExpenseCategory:"_ValidationResult",
		getExpenseChange:"ExpenseChange",
		listExpenseChange:"ExpenseChange",
		paginateExpenseChange:"ExpenseChangeConnection",
		validateCreateExpenseChange:"_ValidationResult",
		validateUpdateExpenseChange:"_ValidationResult",
		getExpenseDocument:"ExpenseDocument",
		listExpenseDocument:"ExpenseDocument",
		paginateExpenseDocument:"ExpenseDocumentConnection",
		validateCreateExpenseDocument:"_ValidationResult",
		validateUpdateExpenseDocument:"_ValidationResult",
		getRevenuePrediction:"RevenuePrediction",
		listRevenuePrediction:"RevenuePrediction",
		paginateRevenuePrediction:"RevenuePredictionConnection",
		validateCreateRevenuePrediction:"_ValidationResult",
		validateUpdateRevenuePrediction:"_ValidationResult",
		getRevenuePredictionChange:"RevenuePredictionChange",
		listRevenuePredictionChange:"RevenuePredictionChange",
		paginateRevenuePredictionChange:"RevenuePredictionChangeConnection",
		validateCreateRevenuePredictionChange:"_ValidationResult",
		validateUpdateRevenuePredictionChange:"_ValidationResult",
		getFile:"File",
		listFile:"File",
		paginateFile:"FileConnection",
		validateCreateFile:"_ValidationResult",
		validateUpdateFile:"_ValidationResult",
		getExpenseTerm:"ExpenseTerm",
		listExpenseTerm:"ExpenseTerm",
		paginateExpenseTerm:"ExpenseTermConnection",
		getLine:"Line",
		listLine:"Line",
		paginateLine:"LineConnection",
		validateCreateLine:"_ValidationResult",
		validateUpdateLine:"_ValidationResult",
		getFinancesBalanceItem:"FinancesBalanceItem",
		listFinancesBalanceItem:"FinancesBalanceItem",
		paginateFinancesBalanceItem:"FinancesBalanceItemConnection",
		validateCreateFinancesBalanceItem:"_ValidationResult",
		validateUpdateFinancesBalanceItem:"_ValidationResult",
		getRevenuePredictionTerm:"RevenuePredictionTerm",
		listRevenuePredictionTerm:"RevenuePredictionTerm",
		paginateRevenuePredictionTerm:"RevenuePredictionTermConnection",
		getOrderPaymentStatsByDay:"OrderPaymentStatsByDay",
		listOrderPaymentStatsByDay:"OrderPaymentStatsByDay",
		paginateOrderPaymentStatsByDay:"OrderPaymentStatsByDayConnection",
		getWoltDriveDelivery:"WoltDriveDelivery",
		listWoltDriveDelivery:"WoltDriveDelivery",
		paginateWoltDriveDelivery:"WoltDriveDeliveryConnection",
		validateCreateWoltDriveDelivery:"_ValidationResult",
		validateUpdateWoltDriveDelivery:"_ValidationResult",
		transaction:"QueryTransaction",
		_info:"Info",
		schema:"_Schema",
		s3DummyQuery:"String"
	},
	Address:{
		_meta:"AddressMeta",
		id:"UUID",
		name:"String",
		firstName:"String",
		lastName:"String",
		addressLine2:"String",
		email:"String",
		phone:"String",
		companyName:"String",
		companyIdentifier:"String",
		vatIdentifier:"String",
		externalIdentifier:"String",
		hidden:"Boolean",
		customer:"Customer",
		internalNote:"String",
		country:"Country",
		deletedAt:"DateTime",
		note:"String",
		googlePlaceId:"String",
		raw:"String",
		formatted:"String",
		geocodeGeneratedAt:"DateTime",
		geocodeResponse:"String",
		deliveryZone:"DeliveryZone",
		meta:"AddressMetadata",
		gps:"Gps",
		geocodeValid:"Boolean",
		fullName:"String",
		fakturoidSubjectId:"String",
		invoices:"Invoice",
		addressLine1:"String",
		city:"String",
		postalCode:"String",
		createdAt:"DateTime",
		billingAddressOfOrders:"Order",
		deliveryAddressOfOrderDeliveries:"OrderDelivery",
		defaultDeliveryAddressOfCustomer:"Customer",
		invoicesByPublicKey:"Invoice",
		invoicesByFakturoidId:"Invoice",
		invoicesByOrderPayments:"Invoice",
		billingAddressOfOrdersBySeq:"Order",
		billingAddressOfOrdersByDoubleshotLegacyId:"Order",
		billingAddressOfOrdersByDoubleShotLegacyNumber:"Order",
		billingAddressOfOrdersByDiscounts:"Order",
		billingAddressOfOrdersByDelivery:"Order",
		billingAddressOfOrdersByItems:"Order",
		billingAddressOfOrdersByCart:"Order",
		billingAddressOfOrdersByEvents:"Order",
		billingAddressOfOrdersByPriceLines:"Order",
		billingAddressOfOrdersByPayments:"Order",
		billingAddressOfOrdersBySummary:"Order",
		billingAddressOfOrdersByGratuity:"Order",
		deliveryAddressOfOrderDeliveriesByTrackingCode:"OrderDelivery",
		deliveryAddressOfOrderDeliveriesByOrder:"OrderDelivery",
		deliveryAddressOfOrderDeliveriesByDeliveryWaypoint:"OrderDelivery",
		deliveryAddressOfOrderDeliveriesByEvents:"OrderDelivery",
		deliveryAddressOfOrderDeliveriesByLiftagoRide:"OrderDelivery",
		deliveryAddressOfOrderDeliveriesByWoltDriveDelivery:"OrderDelivery",
		paginateInvoices:"InvoiceConnection",
		paginateBillingAddressOfOrders:"OrderConnection",
		paginateDeliveryAddressOfOrderDeliveries:"OrderDeliveryConnection"
	},
	AddressMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		firstName:"FieldMeta",
		lastName:"FieldMeta",
		addressLine2:"FieldMeta",
		email:"FieldMeta",
		phone:"FieldMeta",
		companyName:"FieldMeta",
		companyIdentifier:"FieldMeta",
		vatIdentifier:"FieldMeta",
		externalIdentifier:"FieldMeta",
		hidden:"FieldMeta",
		customer:"FieldMeta",
		internalNote:"FieldMeta",
		country:"FieldMeta",
		deletedAt:"FieldMeta",
		note:"FieldMeta",
		googlePlaceId:"FieldMeta",
		raw:"FieldMeta",
		formatted:"FieldMeta",
		geocodeGeneratedAt:"FieldMeta",
		geocodeResponse:"FieldMeta",
		deliveryZone:"FieldMeta",
		meta:"FieldMeta",
		gps:"FieldMeta",
		geocodeValid:"FieldMeta",
		fullName:"FieldMeta",
		fakturoidSubjectId:"FieldMeta",
		invoices:"FieldMeta",
		addressLine1:"FieldMeta",
		city:"FieldMeta",
		postalCode:"FieldMeta",
		createdAt:"FieldMeta",
		billingAddressOfOrders:"FieldMeta",
		deliveryAddressOfOrderDeliveries:"FieldMeta",
		defaultDeliveryAddressOfCustomer:"FieldMeta"
	},
	FieldMeta:{
		readable:"Boolean",
		updatable:"Boolean"
	},
	Customer:{
		_meta:"CustomerMeta",
		id:"UUID",
		addresses:"Address",
		defaultBillingAddress:"Address",
		defaultPaymentMethod:"CustomerPaymentMethod",
		tags:"Tag",
		credits:"CustomerCredit",
		paymentMethods:"CustomerPaymentMethod",
		orders:"Order",
		permissions:"CustomerPermissions",
		group:"CustomerGroup",
		photo:"Image",
		phone:"String",
		name:"CustomerName",
		internalNote:"String",
		welcomeMessage:"String",
		familiarity:"CustomerFamiliarity",
		ingredientRatings:"CustomerIngredientRating",
		business:"BusinessCustomer",
		ownerOfBusinesses:"BusinessCustomer",
		memberOfBusinesses:"BusinessCustomer",
		carts:"Cart",
		shortcutList:"ApplicationShortcutList",
		user:"User",
		channels:"Channel",
		disabledAt:"DateTime",
		invoices:"Invoice",
		invoicingPlan:"InvoicingPlan",
		email:"String",
		createdAt:"DateTime",
		billingSubjects:"BillingSubject",
		offeredProducts:"ProductCustomerPrice",
		defaultDeliveryAddress:"Address",
		defaultBillingSubject:"BillingSubject",
		prefersPackingsWithoutCardboard:"Boolean",
		anonymousSession:"AnonymousSession",
		boughtVouchers:"Voucher",
		ownsVouchers:"Voucher",
		redeemedVouchers:"VoucherRedemption",
		spending:"CustomerSpending",
		customerTabs:"CustomerTab",
		lead:"PipelineLead",
		doubleshotLegacyId:"String",
		meta:"CustomerMetadata",
		doubleshotLastUpdatedAt:"DateTime",
		addressesByMeta:"Address",
		addressesByGps:"Address",
		addressesByInvoices:"Address",
		addressesByBillingAddressOfOrders:"Address",
		addressesByDeliveryAddressOfOrderDeliveries:"Address",
		addressesByDefaultDeliveryAddressOfCustomer:"Address",
		creditsByTransactions:"CustomerCredit",
		creditsByVoucherRedemption:"CustomerCredit",
		ordersBySeq:"Order",
		ordersByDoubleshotLegacyId:"Order",
		ordersByDoubleShotLegacyNumber:"Order",
		ordersByDiscounts:"Order",
		ordersByDelivery:"Order",
		ordersByItems:"Order",
		ordersByCart:"Order",
		ordersByEvents:"Order",
		ordersByPriceLines:"Order",
		ordersByPayments:"Order",
		ordersBySummary:"Order",
		ordersByGratuity:"Order",
		ingredientRatingsByIngredient:"CustomerIngredientRating",
		cartsByItems:"Cart",
		cartsByOrder:"Cart",
		cartsByPriceLines:"Cart",
		cartsBySummary:"Cart",
		invoicesByPublicKey:"Invoice",
		invoicesByFakturoidId:"Invoice",
		invoicesByOrderPayments:"Invoice",
		billingSubjectsByInvoices:"BillingSubject",
		billingSubjectsByDefaultBillingSubjectOfCustomer:"BillingSubject",
		billingSubjectsByOrders:"BillingSubject",
		offeredProductsByProduct:"ProductCustomerPrice",
		boughtVouchersByCode:"Voucher",
		boughtVouchersByRedemption:"Voucher",
		ownsVouchersByCode:"Voucher",
		ownsVouchersByRedemption:"Voucher",
		redeemedVouchersByCustomerCredit:"VoucherRedemption",
		redeemedVouchersByOrderDiscount:"VoucherRedemption",
		redeemedVouchersByVoucher:"VoucherRedemption",
		customerTabsByItems:"CustomerTab",
		customerTabsByMeta:"CustomerTab",
		leadByStageItem:"PipelineLead",
		paginateAddresses:"AddressConnection",
		paginateTags:"TagConnection",
		paginateCredits:"CustomerCreditConnection",
		paginatePaymentMethods:"CustomerPaymentMethodConnection",
		paginateOrders:"OrderConnection",
		paginateIngredientRatings:"CustomerIngredientRatingConnection",
		paginateOwnerOfBusinesses:"BusinessCustomerConnection",
		paginateMemberOfBusinesses:"BusinessCustomerConnection",
		paginateCarts:"CartConnection",
		paginateChannels:"ChannelConnection",
		paginateInvoices:"InvoiceConnection",
		paginateBillingSubjects:"BillingSubjectConnection",
		paginateOfferedProducts:"ProductCustomerPriceConnection",
		paginateBoughtVouchers:"VoucherConnection",
		paginateOwnsVouchers:"VoucherConnection",
		paginateRedeemedVouchers:"VoucherRedemptionConnection",
		paginateCustomerTabs:"CustomerTabConnection",
		paginateLead:"PipelineLeadConnection"
	},
	CustomerMeta:{
		id:"FieldMeta",
		addresses:"FieldMeta",
		defaultBillingAddress:"FieldMeta",
		defaultPaymentMethod:"FieldMeta",
		tags:"FieldMeta",
		credits:"FieldMeta",
		paymentMethods:"FieldMeta",
		orders:"FieldMeta",
		permissions:"FieldMeta",
		group:"FieldMeta",
		photo:"FieldMeta",
		phone:"FieldMeta",
		name:"FieldMeta",
		internalNote:"FieldMeta",
		welcomeMessage:"FieldMeta",
		familiarity:"FieldMeta",
		ingredientRatings:"FieldMeta",
		business:"FieldMeta",
		ownerOfBusinesses:"FieldMeta",
		memberOfBusinesses:"FieldMeta",
		carts:"FieldMeta",
		shortcutList:"FieldMeta",
		user:"FieldMeta",
		channels:"FieldMeta",
		disabledAt:"FieldMeta",
		invoices:"FieldMeta",
		invoicingPlan:"FieldMeta",
		email:"FieldMeta",
		createdAt:"FieldMeta",
		billingSubjects:"FieldMeta",
		offeredProducts:"FieldMeta",
		defaultDeliveryAddress:"FieldMeta",
		defaultBillingSubject:"FieldMeta",
		prefersPackingsWithoutCardboard:"FieldMeta",
		anonymousSession:"FieldMeta",
		boughtVouchers:"FieldMeta",
		ownsVouchers:"FieldMeta",
		redeemedVouchers:"FieldMeta",
		spending:"FieldMeta",
		customerTabs:"FieldMeta",
		lead:"FieldMeta",
		doubleshotLegacyId:"FieldMeta",
		meta:"FieldMeta",
		doubleshotLastUpdatedAt:"FieldMeta"
	},
	CustomerPaymentMethod:{
		_meta:"CustomerPaymentMethodMeta",
		id:"UUID",
		caption:"String",
		data:"Json",
		customer:"Customer",
		paymentMethod:"PaymentMethod"
	},
	CustomerPaymentMethodMeta:{
		id:"FieldMeta",
		caption:"FieldMeta",
		data:"FieldMeta",
		customer:"FieldMeta",
		paymentMethod:"FieldMeta"
	},
	PaymentMethod:{
		_meta:"PaymentMethodMeta",
		id:"UUID",
		name:"String",
		code:"String",
		enabled:"Boolean",
		deliveryMethods:"DeliveryMethod",
		description:"String",
		internalNote:"String",
		blockingDispatch:"Boolean",
		type:"PaymentMethodType",
		channels:"ChannelPayment",
		reduceGratuityByPercentage:"Int",
		paginateDeliveryMethods:"DeliveryMethodConnection",
		paginateChannels:"ChannelPaymentConnection"
	},
	PaymentMethodMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		code:"FieldMeta",
		enabled:"FieldMeta",
		deliveryMethods:"FieldMeta",
		description:"FieldMeta",
		internalNote:"FieldMeta",
		blockingDispatch:"FieldMeta",
		type:"FieldMeta",
		channels:"FieldMeta",
		reduceGratuityByPercentage:"FieldMeta"
	},
	DeliveryMethod:{
		_meta:"DeliveryMethodMeta",
		id:"UUID",
		name:"String",
		code:"String",
		enabled:"Boolean",
		paymentMethods:"PaymentMethod",
		description:"String",
		internalNote:"String",
		requireDeliveryAddress:"Boolean",
		suitableForDeliveryZones:"DeliveryZone",
		channels:"ChannelDelivery",
		courierHandlers:"Courier",
		enableDeliveryTracking:"Boolean",
		locales:"DeliveryMethodLocale",
		timelinePreset:"DeliveryTimelinePreset",
		woltDriveVenueId:"String",
		localesByLocale:"DeliveryMethodLocale",
		paginatePaymentMethods:"PaymentMethodConnection",
		paginateSuitableForDeliveryZones:"DeliveryZoneConnection",
		paginateChannels:"ChannelDeliveryConnection",
		paginateCourierHandlers:"CourierConnection",
		paginateLocales:"DeliveryMethodLocaleConnection"
	},
	DeliveryMethodMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		code:"FieldMeta",
		enabled:"FieldMeta",
		paymentMethods:"FieldMeta",
		description:"FieldMeta",
		internalNote:"FieldMeta",
		requireDeliveryAddress:"FieldMeta",
		suitableForDeliveryZones:"FieldMeta",
		channels:"FieldMeta",
		courierHandlers:"FieldMeta",
		enableDeliveryTracking:"FieldMeta",
		locales:"FieldMeta",
		timelinePreset:"FieldMeta",
		woltDriveVenueId:"FieldMeta"
	},
	DeliveryZone:{
		_meta:"DeliveryZoneMeta",
		id:"UUID",
		name:"String",
		code:"String",
		description:"String",
		internalNote:"String",
		type:"DeliveryZoneType",
		addresses:"Address",
		suitableDeliveryMethods:"DeliveryMethod",
		deliveryZonesOfTags:"Tag",
		deliveryZonesOfProducts:"Product",
		addressesMetadata:"AddressMetadata",
		addressesByMeta:"Address",
		addressesByGps:"Address",
		addressesByInvoices:"Address",
		addressesByBillingAddressOfOrders:"Address",
		addressesByDeliveryAddressOfOrderDeliveries:"Address",
		addressesByDefaultDeliveryAddressOfCustomer:"Address",
		addressesMetadataByAddress:"AddressMetadata",
		paginateAddresses:"AddressConnection",
		paginateSuitableDeliveryMethods:"DeliveryMethodConnection",
		paginateDeliveryZonesOfTags:"TagConnection",
		paginateDeliveryZonesOfProducts:"ProductConnection",
		paginateAddressesMetadata:"AddressMetadataConnection"
	},
	DeliveryZoneMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		code:"FieldMeta",
		description:"FieldMeta",
		internalNote:"FieldMeta",
		type:"FieldMeta",
		addresses:"FieldMeta",
		suitableDeliveryMethods:"FieldMeta",
		deliveryZonesOfTags:"FieldMeta",
		deliveryZonesOfProducts:"FieldMeta",
		addressesMetadata:"FieldMeta"
	},
	Tag:{
		_meta:"TagMeta",
		id:"UUID",
		name:"String",
		code:"String",
		customers:"Customer",
		products:"Product",
		categories:"ProductCategory",
		description:"String",
		internalNote:"String",
		addTagsOnRegistration:"Channel",
		nestedCategories:"InheritedProductCategoryTag",
		deliveryZones:"DeliveryZone",
		publicInChannels:"Channel",
		allowChannelPayments:"ChannelPayment",
		fulfillmentNotes:"FulfillmentNote",
		paginateCustomers:"CustomerConnection",
		paginateProducts:"ProductConnection",
		paginateCategories:"ProductCategoryConnection",
		paginateAddTagsOnRegistration:"ChannelConnection",
		paginateNestedCategories:"InheritedProductCategoryTagConnection",
		paginateDeliveryZones:"DeliveryZoneConnection",
		paginatePublicInChannels:"ChannelConnection",
		paginateAllowChannelPayments:"ChannelPaymentConnection",
		paginateFulfillmentNotes:"FulfillmentNoteConnection"
	},
	TagMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		code:"FieldMeta",
		customers:"FieldMeta",
		products:"FieldMeta",
		categories:"FieldMeta",
		description:"FieldMeta",
		internalNote:"FieldMeta",
		addTagsOnRegistration:"FieldMeta",
		nestedCategories:"FieldMeta",
		deliveryZones:"FieldMeta",
		publicInChannels:"FieldMeta",
		allowChannelPayments:"FieldMeta",
		fulfillmentNotes:"FieldMeta"
	},
	Product:{
		_meta:"ProductMeta",
		id:"UUID",
		name:"String",
		code:"String",
		priceCents:"Int",
		notDiscountable:"Boolean",
		packing:"ProductPacking",
		recipe:"ProductRecipe",
		tags:"Tag",
		categories:"ProductCategory",
		vatRate:"VatRate",
		stocks:"ProductStock",
		groupPrices:"ProductGroupPrice",
		image:"Image",
		description:"String",
		internalNote:"String",
		cartItems:"CartItem",
		availability:"ProductAvailability",
		order:"Float",
		manager:"StocksManager",
		orderItems:"OrderItem",
		maximumQuantityPerOrder:"Int",
		inheritedCategories:"NestedProductCategoryProduct",
		deliveryZones:"DeliveryZone",
		locales:"ProductLocale",
		archivedAt:"DateTime",
		customerPrices:"ProductCustomerPrice",
		virtualProduct:"VirtualProduct",
		meta:"ProductMetadata",
		page:"Page",
		salesDays:"ProductSalesDay",
		salesWeeks:"ProductSalesWeek",
		salesMonths:"ProductSalesMonth",
		fulfillmentNotes:"FulfillmentNote",
		hasSubscription:"Boolean",
		pointOfSaleTileColor:"String",
		stocksByStore:"ProductStock",
		groupPricesByGroup:"ProductGroupPrice",
		cartItemsByCart:"CartItem",
		orderItemsByVirtualProductEffects:"OrderItem",
		localesByLocale:"ProductLocale",
		localesByFeatureList:"ProductLocale",
		customerPricesByCustomer:"ProductCustomerPrice",
		paginateTags:"TagConnection",
		paginateCategories:"ProductCategoryConnection",
		paginateStocks:"ProductStockConnection",
		paginateGroupPrices:"ProductGroupPriceConnection",
		paginateCartItems:"CartItemConnection",
		paginateOrderItems:"OrderItemConnection",
		paginateInheritedCategories:"NestedProductCategoryProductConnection",
		paginateDeliveryZones:"DeliveryZoneConnection",
		paginateLocales:"ProductLocaleConnection",
		paginateCustomerPrices:"ProductCustomerPriceConnection",
		paginateSalesDays:"ProductSalesDayConnection",
		paginateSalesWeeks:"ProductSalesWeekConnection",
		paginateSalesMonths:"ProductSalesMonthConnection",
		paginateFulfillmentNotes:"FulfillmentNoteConnection"
	},
	ProductMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		code:"FieldMeta",
		priceCents:"FieldMeta",
		notDiscountable:"FieldMeta",
		packing:"FieldMeta",
		recipe:"FieldMeta",
		tags:"FieldMeta",
		categories:"FieldMeta",
		vatRate:"FieldMeta",
		stocks:"FieldMeta",
		groupPrices:"FieldMeta",
		image:"FieldMeta",
		description:"FieldMeta",
		internalNote:"FieldMeta",
		cartItems:"FieldMeta",
		availability:"FieldMeta",
		order:"FieldMeta",
		manager:"FieldMeta",
		orderItems:"FieldMeta",
		maximumQuantityPerOrder:"FieldMeta",
		inheritedCategories:"FieldMeta",
		deliveryZones:"FieldMeta",
		locales:"FieldMeta",
		archivedAt:"FieldMeta",
		customerPrices:"FieldMeta",
		virtualProduct:"FieldMeta",
		meta:"FieldMeta",
		page:"FieldMeta",
		salesDays:"FieldMeta",
		salesWeeks:"FieldMeta",
		salesMonths:"FieldMeta",
		fulfillmentNotes:"FieldMeta",
		hasSubscription:"FieldMeta",
		pointOfSaleTileColor:"FieldMeta"
	},
	ProductPacking:{
		_meta:"ProductPackingMeta",
		id:"UUID",
		name:"String",
		image:"Image",
		description:"String",
		internalNote:"String",
		volumeMl:"Int",
		icon:"Image",
		shortName:"String",
		locales:"ProductPackingLocale",
		preparedPackingQuantities:"PreparedPackingQuantity",
		isPackedInCardboard:"Boolean",
		localesByLocale:"ProductPackingLocale",
		paginateLocales:"ProductPackingLocaleConnection",
		paginatePreparedPackingQuantities:"PreparedPackingQuantityConnection"
	},
	ProductPackingMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		image:"FieldMeta",
		description:"FieldMeta",
		internalNote:"FieldMeta",
		volumeMl:"FieldMeta",
		icon:"FieldMeta",
		shortName:"FieldMeta",
		locales:"FieldMeta",
		preparedPackingQuantities:"FieldMeta",
		isPackedInCardboard:"FieldMeta"
	},
	Image:{
		_meta:"ImageMeta",
		id:"UUID",
		url:"String",
		width:"Int",
		height:"Int",
		size:"Int",
		type:"String",
		alt:"String"
	},
	ImageMeta:{
		id:"FieldMeta",
		url:"FieldMeta",
		width:"FieldMeta",
		height:"FieldMeta",
		size:"FieldMeta",
		type:"FieldMeta",
		alt:"FieldMeta"
	},
	ProductPackingLocale:{
		_meta:"ProductPackingLocaleMeta",
		id:"UUID",
		name:"String",
		shortName:"String",
		description:"String",
		root:"ProductPacking",
		locale:"Locale"
	},
	ProductPackingLocaleMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		shortName:"FieldMeta",
		description:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta"
	},
	Locale:{
		_meta:"LocaleMeta",
		id:"UUID",
		businessCategories:"BusinessCategoryLocale",
		productCategoryLists:"ProductCategoryListLocale",
		productIngredients:"ProductIngredientLocale",
		orderRecurrences:"OrderRecurrenceLocale",
		blogs:"BlogLocale",
		blogPosts:"BlogPostLocale",
		identifier:"TranslationCataloguesIdentifier",
		menus:"MenuLocale",
		pages:"PageLocale",
		productIngredientCategories:"ProductIngredientCategoryLocale",
		allergens:"AllergenLocale",
		productPackings:"ProductPackingLocale",
		products:"ProductLocale",
		productRecipes:"ProductRecipeLocale",
		pointOfSaleCategories:"PointOfSaleCategoryLocale",
		pointOfSaleCategoryProducts:"PointOfSaleCategoryProductLocale",
		deliveryMethods:"DeliveryMethodLocale",
		ingredientSuppliers:"IngredientSupplierLocale",
		identificationCodes:"IdentificationCodeLocale",
		pipelineStages:"PipelineStageLocale",
		subscriptionBoxes:"SubscriptionBoxLocale",
		businessServices:"BusinessServiceLocale",
		businessCategoriesByRoot:"BusinessCategoryLocale",
		productCategoryListsByRoot:"ProductCategoryListLocale",
		productIngredientsByRoot:"ProductIngredientLocale",
		orderRecurrencesByRoot:"OrderRecurrenceLocale",
		blogsByRoot:"BlogLocale",
		blogPostsByRoot:"BlogPostLocale",
		blogPostsByCover:"BlogPostLocale",
		blogPostsByContent:"BlogPostLocale",
		blogPostsByLink:"BlogPostLocale",
		blogPostsBySeo:"BlogPostLocale",
		menusByRoot:"MenuLocale",
		menusByItems:"MenuLocale",
		menusBySecondaryItems:"MenuLocale",
		pagesByRoot:"PageLocale",
		pagesByLink:"PageLocale",
		pagesBySeo:"PageLocale",
		pagesByContent:"PageLocale",
		pagesByCover:"PageLocale",
		productIngredientCategoriesByRoot:"ProductIngredientCategoryLocale",
		allergensByRoot:"AllergenLocale",
		productPackingsByRoot:"ProductPackingLocale",
		productsByRoot:"ProductLocale",
		productsByFeatureList:"ProductLocale",
		productRecipesByRoot:"ProductRecipeLocale",
		pointOfSaleCategoriesByRoot:"PointOfSaleCategoryLocale",
		pointOfSaleCategoryProductsByRoot:"PointOfSaleCategoryProductLocale",
		deliveryMethodsByRoot:"DeliveryMethodLocale",
		ingredientSuppliersByRoot:"IngredientSupplierLocale",
		identificationCodesByRoot:"IdentificationCodeLocale",
		pipelineStagesByRoot:"PipelineStageLocale",
		subscriptionBoxesByRoot:"SubscriptionBoxLocale",
		subscriptionBoxesByTexts:"SubscriptionBoxLocale",
		subscriptionBoxesBySecondaryTexts:"SubscriptionBoxLocale",
		businessServicesByRoot:"BusinessServiceLocale",
		paginateBusinessCategories:"BusinessCategoryLocaleConnection",
		paginateProductCategoryLists:"ProductCategoryListLocaleConnection",
		paginateProductIngredients:"ProductIngredientLocaleConnection",
		paginateOrderRecurrences:"OrderRecurrenceLocaleConnection",
		paginateBlogs:"BlogLocaleConnection",
		paginateBlogPosts:"BlogPostLocaleConnection",
		paginateMenus:"MenuLocaleConnection",
		paginatePages:"PageLocaleConnection",
		paginateProductIngredientCategories:"ProductIngredientCategoryLocaleConnection",
		paginateAllergens:"AllergenLocaleConnection",
		paginateProductPackings:"ProductPackingLocaleConnection",
		paginateProducts:"ProductLocaleConnection",
		paginateProductRecipes:"ProductRecipeLocaleConnection",
		paginatePointOfSaleCategories:"PointOfSaleCategoryLocaleConnection",
		paginatePointOfSaleCategoryProducts:"PointOfSaleCategoryProductLocaleConnection",
		paginateDeliveryMethods:"DeliveryMethodLocaleConnection",
		paginateIngredientSuppliers:"IngredientSupplierLocaleConnection",
		paginateIdentificationCodes:"IdentificationCodeLocaleConnection",
		paginatePipelineStages:"PipelineStageLocaleConnection",
		paginateSubscriptionBoxes:"SubscriptionBoxLocaleConnection",
		paginateBusinessServices:"BusinessServiceLocaleConnection"
	},
	LocaleMeta:{
		id:"FieldMeta",
		businessCategories:"FieldMeta",
		productCategoryLists:"FieldMeta",
		productIngredients:"FieldMeta",
		orderRecurrences:"FieldMeta",
		blogs:"FieldMeta",
		blogPosts:"FieldMeta",
		identifier:"FieldMeta",
		menus:"FieldMeta",
		pages:"FieldMeta",
		productIngredientCategories:"FieldMeta",
		allergens:"FieldMeta",
		productPackings:"FieldMeta",
		products:"FieldMeta",
		productRecipes:"FieldMeta",
		pointOfSaleCategories:"FieldMeta",
		pointOfSaleCategoryProducts:"FieldMeta",
		deliveryMethods:"FieldMeta",
		ingredientSuppliers:"FieldMeta",
		identificationCodes:"FieldMeta",
		pipelineStages:"FieldMeta",
		subscriptionBoxes:"FieldMeta",
		businessServices:"FieldMeta"
	},
	BusinessCategoryLocale:{
		_meta:"BusinessCategoryLocaleMeta",
		id:"UUID",
		name:"String",
		root:"BusinessCategory",
		locale:"Locale",
		title:"String"
	},
	BusinessCategoryLocaleMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		title:"FieldMeta"
	},
	BusinessCategory:{
		_meta:"BusinessCategoryMeta",
		id:"UUID",
		order:"Int",
		visibleToNewCustomers:"Boolean",
		locales:"BusinessCategoryLocale",
		internalName:"String",
		businessCustomers:"BusinessCustomer",
		recurrences:"OrderRecurrence",
		specificProducts:"ProductList",
		seasonalProductCategories:"ProductCategoryList",
		specificProductsProductCategories:"ProductCategoryList",
		slug:"String",
		localesByLocale:"BusinessCategoryLocale",
		businessCustomersByCustomer:"BusinessCustomer",
		businessCustomersByBusinessServiceEvents:"BusinessCustomer",
		businessCustomersByDoubleshotCoffeeEquipment:"BusinessCustomer",
		paginateLocales:"BusinessCategoryLocaleConnection",
		paginateBusinessCustomers:"BusinessCustomerConnection",
		paginateRecurrences:"OrderRecurrenceConnection"
	},
	BusinessCategoryMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		visibleToNewCustomers:"FieldMeta",
		locales:"FieldMeta",
		internalName:"FieldMeta",
		businessCustomers:"FieldMeta",
		recurrences:"FieldMeta",
		specificProducts:"FieldMeta",
		seasonalProductCategories:"FieldMeta",
		specificProductsProductCategories:"FieldMeta",
		slug:"FieldMeta"
	},
	BusinessCustomer:{
		_meta:"BusinessCustomerMeta",
		id:"UUID",
		name:"String",
		customer:"Customer",
		owners:"Customer",
		members:"Customer",
		category:"BusinessCategory",
		accountManager:"BusinessToBusinessManager",
		logo:"Image",
		note:"String",
		businessServiceEvents:"BusinessServiceEvent",
		doubleshotCoffeeEquipment:"DoubleshotCoffeeEquipment",
		paginateOwners:"CustomerConnection",
		paginateMembers:"CustomerConnection",
		paginateBusinessServiceEvents:"BusinessServiceEventConnection"
	},
	BusinessCustomerMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		customer:"FieldMeta",
		owners:"FieldMeta",
		members:"FieldMeta",
		category:"FieldMeta",
		accountManager:"FieldMeta",
		logo:"FieldMeta",
		note:"FieldMeta",
		businessServiceEvents:"FieldMeta",
		doubleshotCoffeeEquipment:"FieldMeta"
	},
	BusinessToBusinessManager:{
		_meta:"BusinessToBusinessManagerMeta",
		id:"UUID",
		staff:"Staff",
		managedBusinesses:"BusinessCustomer",
		createdAt:"DateTime",
		managedBusinessesByCustomer:"BusinessCustomer",
		managedBusinessesByBusinessServiceEvents:"BusinessCustomer",
		managedBusinessesByDoubleshotCoffeeEquipment:"BusinessCustomer",
		paginateManagedBusinesses:"BusinessCustomerConnection"
	},
	BusinessToBusinessManagerMeta:{
		id:"FieldMeta",
		staff:"FieldMeta",
		managedBusinesses:"FieldMeta",
		createdAt:"FieldMeta"
	},
	Staff:{
		_meta:"StaffMeta",
		id:"UUID",
		bartender:"Bartender",
		courier:"Courier",
		cleaner:"Cleaner",
		shiftsManager:"ShiftsManager",
		businessToBusinessManager:"BusinessToBusinessManager",
		user:"User",
		shiftsProfile:"ShiftsProfile",
		stocksManager:"StocksManager",
		photo:"Image",
		courierManager:"CourierManager",
		picker:"Picker",
		createdAt:"DateTime",
		remunerationProfile:"RemunerationProfile",
		cashier:"Cashier",
		venues:"Venue",
		internalBuyer:"InternalBuyer",
		salesManager:"SalesManager",
		cashierManager:"CashierManager",
		paginateVenues:"VenueConnection"
	},
	StaffMeta:{
		id:"FieldMeta",
		bartender:"FieldMeta",
		courier:"FieldMeta",
		cleaner:"FieldMeta",
		shiftsManager:"FieldMeta",
		businessToBusinessManager:"FieldMeta",
		user:"FieldMeta",
		shiftsProfile:"FieldMeta",
		stocksManager:"FieldMeta",
		photo:"FieldMeta",
		courierManager:"FieldMeta",
		picker:"FieldMeta",
		createdAt:"FieldMeta",
		remunerationProfile:"FieldMeta",
		cashier:"FieldMeta",
		venues:"FieldMeta",
		internalBuyer:"FieldMeta",
		salesManager:"FieldMeta",
		cashierManager:"FieldMeta"
	},
	Bartender:{
		_meta:"BartenderMeta",
		id:"UUID",
		staff:"Staff",
		createdAt:"DateTime"
	},
	BartenderMeta:{
		id:"FieldMeta",
		staff:"FieldMeta",
		createdAt:"FieldMeta"
	},
	Courier:{
		_meta:"CourierMeta",
		id:"UUID",
		staff:"Staff",
		routes:"DeliveryRoute",
		createdAt:"DateTime",
		deliveryMethods:"DeliveryMethod",
		showInPicker:"Boolean",
		routesByWaypoints:"DeliveryRoute",
		paginateRoutes:"DeliveryRouteConnection",
		paginateDeliveryMethods:"DeliveryMethodConnection"
	},
	CourierMeta:{
		id:"FieldMeta",
		staff:"FieldMeta",
		routes:"FieldMeta",
		createdAt:"FieldMeta",
		deliveryMethods:"FieldMeta",
		showInPicker:"FieldMeta"
	},
	DeliveryRoute:{
		_meta:"DeliveryRouteMeta",
		id:"UUID",
		courier:"Courier",
		createdAt:"DateTime",
		waypoints:"DeliveryWaypoint",
		dispatchAt:"String",
		waypointsByDelivery:"DeliveryWaypoint",
		paginateWaypoints:"DeliveryWaypointConnection"
	},
	DeliveryRouteMeta:{
		id:"FieldMeta",
		courier:"FieldMeta",
		createdAt:"FieldMeta",
		waypoints:"FieldMeta",
		dispatchAt:"FieldMeta"
	},
	DeliveryWaypoint:{
		_meta:"DeliveryWaypointMeta",
		id:"UUID",
		estimatedArrival:"DateTime",
		note:"String",
		route:"DeliveryRoute",
		sortingOrder:"Int",
		delivery:"OrderDelivery",
		estimatedDistance:"Int",
		estimatedDuration:"Int",
		originDeparture:"DateTime",
		originAddress:"String",
		transitMode:"String"
	},
	DeliveryWaypointMeta:{
		id:"FieldMeta",
		estimatedArrival:"FieldMeta",
		note:"FieldMeta",
		route:"FieldMeta",
		sortingOrder:"FieldMeta",
		delivery:"FieldMeta",
		estimatedDistance:"FieldMeta",
		estimatedDuration:"FieldMeta",
		originDeparture:"FieldMeta",
		originAddress:"FieldMeta",
		transitMode:"FieldMeta"
	},
	OrderDelivery:{
		_meta:"OrderDeliveryMeta",
		id:"UUID",
		priceCents:"Int",
		deliveredAt:"DateTime",
		method:"DeliveryMethod",
		vatRate:"VatRate",
		order:"Order",
		expectedAt:"DateTime",
		state:"OrderDeliveryState",
		loadingDurationHours:"Int",
		dispatchAt:"DateTime",
		duration:"String",
		window:"String",
		expectedEndAt:"DateTime",
		processingAt:"DateTime",
		deliveringAt:"DateTime",
		failedAt:"DateTime",
		internalNote:"String",
		deliveryWaypoint:"DeliveryWaypoint",
		events:"OrderEvent",
		prepareAt:"DateTime",
		liftagoRide:"LiftagoRide",
		pickedAt:"DateTime",
		address:"Address",
		trackingCode:"String",
		woltDriveDelivery:"WoltDriveDelivery",
		paginateEvents:"OrderEventConnection"
	},
	OrderDeliveryMeta:{
		id:"FieldMeta",
		priceCents:"FieldMeta",
		deliveredAt:"FieldMeta",
		method:"FieldMeta",
		vatRate:"FieldMeta",
		order:"FieldMeta",
		expectedAt:"FieldMeta",
		state:"FieldMeta",
		loadingDurationHours:"FieldMeta",
		dispatchAt:"FieldMeta",
		duration:"FieldMeta",
		window:"FieldMeta",
		expectedEndAt:"FieldMeta",
		processingAt:"FieldMeta",
		deliveringAt:"FieldMeta",
		failedAt:"FieldMeta",
		internalNote:"FieldMeta",
		deliveryWaypoint:"FieldMeta",
		events:"FieldMeta",
		prepareAt:"FieldMeta",
		liftagoRide:"FieldMeta",
		pickedAt:"FieldMeta",
		address:"FieldMeta",
		trackingCode:"FieldMeta",
		woltDriveDelivery:"FieldMeta"
	},
	VatRate:{
		_meta:"VatRateMeta",
		id:"UUID",
		name:"String",
		ratePermille:"Int",
		description:"String",
		internalNote:"String",
		channelDeliveries:"ChannelDelivery",
		channelPayments:"ChannelPayment",
		preset:"VatRatePreset",
		paginateChannelDeliveries:"ChannelDeliveryConnection",
		paginateChannelPayments:"ChannelPaymentConnection"
	},
	VatRateMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		ratePermille:"FieldMeta",
		description:"FieldMeta",
		internalNote:"FieldMeta",
		channelDeliveries:"FieldMeta",
		channelPayments:"FieldMeta",
		preset:"FieldMeta"
	},
	ChannelDelivery:{
		_meta:"ChannelDeliveryMeta",
		id:"UUID",
		order:"Int",
		priceCents:"Int",
		channel:"Channel",
		method:"DeliveryMethod",
		vatRate:"VatRate",
		defaultVisible:"Boolean"
	},
	ChannelDeliveryMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		priceCents:"FieldMeta",
		channel:"FieldMeta",
		method:"FieldMeta",
		vatRate:"FieldMeta",
		defaultVisible:"FieldMeta"
	},
	Channel:{
		_meta:"ChannelMeta",
		id:"UUID",
		name:"String",
		disabled:"Boolean",
		payments:"ChannelPayment",
		deliveries:"ChannelDelivery",
		pointOfSales:"PointOfSale",
		carts:"Cart",
		customers:"Customer",
		code:"ChannelCode",
		addTagsOnRegistration:"Tag",
		publicTags:"Tag",
		venue:"Venue",
		cartsByItems:"Cart",
		cartsByOrder:"Cart",
		cartsByPriceLines:"Cart",
		cartsBySummary:"Cart",
		paginatePayments:"ChannelPaymentConnection",
		paginateDeliveries:"ChannelDeliveryConnection",
		paginatePointOfSales:"PointOfSaleConnection",
		paginateCarts:"CartConnection",
		paginateCustomers:"CustomerConnection",
		paginateAddTagsOnRegistration:"TagConnection",
		paginatePublicTags:"TagConnection"
	},
	ChannelMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		disabled:"FieldMeta",
		payments:"FieldMeta",
		deliveries:"FieldMeta",
		pointOfSales:"FieldMeta",
		carts:"FieldMeta",
		customers:"FieldMeta",
		code:"FieldMeta",
		addTagsOnRegistration:"FieldMeta",
		publicTags:"FieldMeta",
		venue:"FieldMeta"
	},
	ChannelPayment:{
		_meta:"ChannelPaymentMeta",
		id:"UUID",
		order:"Int",
		channel:"Channel",
		method:"PaymentMethod",
		vatRate:"VatRate",
		requireBillingAddress:"Boolean",
		provideReceipt:"Boolean",
		requireBillingSubject:"Boolean",
		allowOnlyForTags:"Tag",
		paginateAllowOnlyForTags:"TagConnection"
	},
	ChannelPaymentMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		channel:"FieldMeta",
		method:"FieldMeta",
		vatRate:"FieldMeta",
		requireBillingAddress:"FieldMeta",
		provideReceipt:"FieldMeta",
		requireBillingSubject:"FieldMeta",
		allowOnlyForTags:"FieldMeta"
	},
	TagConnection:{
		pageInfo:"PageInfo",
		edges:"TagEdge"
	},
	PageInfo:{
		totalCount:"Int"
	},
	TagEdge:{
		node:"Tag"
	},
	PointOfSale:{
		_meta:"PointOfSaleMeta",
		id:"UUID",
		name:"String",
		code:"String",
		channels:"Channel",
		permissions:"PointOfSalePermissions",
		tenantPersonId:"UUID",
		paginateChannels:"ChannelConnection"
	},
	PointOfSaleMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		code:"FieldMeta",
		channels:"FieldMeta",
		permissions:"FieldMeta",
		tenantPersonId:"FieldMeta"
	},
	PointOfSalePermissions:{
		_meta:"PointOfSalePermissionsMeta",
		id:"UUID",
		canPlaceOrder:"Boolean",
		pointOfSale:"PointOfSale"
	},
	PointOfSalePermissionsMeta:{
		id:"FieldMeta",
		canPlaceOrder:"FieldMeta",
		pointOfSale:"FieldMeta"
	},
	ChannelConnection:{
		pageInfo:"PageInfo",
		edges:"ChannelEdge"
	},
	ChannelEdge:{
		node:"Channel"
	},
	Cart:{
		_meta:"CartMeta",
		id:"UUID",
		confirmedAt:"DateTime",
		deletedAt:"DateTime",
		note:"String",
		items:"CartItem",
		handle:"String",
		state:"CartState",
		createdAt:"DateTime",
		channel:"Channel",
		order:"Order",
		customer:"Customer",
		deliveryAddress:"Address",
		billingAddress:"Address",
		deliveryOption:"String",
		paymentOption:"String",
		delivery:"ChannelDelivery",
		payment:"ChannelPayment",
		billingSubject:"BillingSubject",
		priceLines:"CartPriceLine",
		summary:"CartSummary",
		itemsByProduct:"CartItem",
		paginateItems:"CartItemConnection",
		paginatePriceLines:"CartPriceLineConnection"
	},
	CartMeta:{
		id:"FieldMeta",
		confirmedAt:"FieldMeta",
		deletedAt:"FieldMeta",
		note:"FieldMeta",
		items:"FieldMeta",
		handle:"FieldMeta",
		state:"FieldMeta",
		createdAt:"FieldMeta",
		channel:"FieldMeta",
		order:"FieldMeta",
		customer:"FieldMeta",
		deliveryAddress:"FieldMeta",
		billingAddress:"FieldMeta",
		deliveryOption:"FieldMeta",
		paymentOption:"FieldMeta",
		delivery:"FieldMeta",
		payment:"FieldMeta",
		billingSubject:"FieldMeta",
		priceLines:"FieldMeta",
		summary:"FieldMeta"
	},
	CartItem:{
		_meta:"CartItemMeta",
		id:"UUID",
		quantity:"Int",
		cart:"Cart",
		product:"Product",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		fulfillmentNote:"String",
		fulfillmentNotes:"FulfillmentNote",
		paginateFulfillmentNotes:"FulfillmentNoteConnection"
	},
	CartItemMeta:{
		id:"FieldMeta",
		quantity:"FieldMeta",
		cart:"FieldMeta",
		product:"FieldMeta",
		createdAt:"FieldMeta",
		updatedAt:"FieldMeta",
		fulfillmentNote:"FieldMeta",
		fulfillmentNotes:"FieldMeta"
	},
	FulfillmentNote:{
		_meta:"FulfillmentNoteMeta",
		id:"UUID",
		note:"String",
		products:"Product",
		tags:"Tag",
		venues:"Venue",
		cartItems:"CartItem",
		orderItems:"OrderItem",
		orders:"Order",
		highlight:"Boolean",
		createdAt:"DateTime",
		emoji:"String",
		paginateProducts:"ProductConnection",
		paginateTags:"TagConnection",
		paginateVenues:"VenueConnection",
		paginateCartItems:"CartItemConnection",
		paginateOrderItems:"OrderItemConnection",
		paginateOrders:"OrderConnection"
	},
	FulfillmentNoteMeta:{
		id:"FieldMeta",
		note:"FieldMeta",
		products:"FieldMeta",
		tags:"FieldMeta",
		venues:"FieldMeta",
		cartItems:"FieldMeta",
		orderItems:"FieldMeta",
		orders:"FieldMeta",
		highlight:"FieldMeta",
		createdAt:"FieldMeta",
		emoji:"FieldMeta"
	},
	Venue:{
		_meta:"VenueMeta",
		id:"UUID",
		name:"String",
		deadlineTemplate:"DeadlineTemplate",
		timetableDays:"TimetableDay",
		timetableTemplates:"TimetableTemplate",
		staffMembers:"Staff",
		employeeRoles:"VenueEmployeeRole",
		pointOfSaleApplicationDevices:"PointOfSaleApplicationDevice",
		pointOfSaleTerminals:"PointOfSaleTerminal",
		pointOfSalePrinters:"PointOfSalePrinter",
		orders:"Order",
		fulfillmentNotes:"FulfillmentNote",
		areas:"Area",
		enabledUnassignReasons:"UnassignReason",
		categories:"PointOfSaleCategory",
		channels:"Channel",
		address:"String",
		pointOfSalePngBase64ReceiptLogo:"String",
		pointOfSaleInitialView:"PointOfSaleInitialView",
		pointOfSalePreferPrintReceipt:"Boolean",
		timetableDaysByDate:"TimetableDay",
		timetableDaysByShiftGroups:"TimetableDay",
		timetableDaysByNotes:"TimetableDay",
		timetableDaysByMeta:"TimetableDay",
		timetableTemplatesByStaffOptions:"TimetableTemplate",
		employeeRolesByRole:"VenueEmployeeRole",
		employeeRolesByEmployeePrivileges:"VenueEmployeeRole",
		pointOfSaleApplicationDevicesByIdentifier:"PointOfSaleApplicationDevice",
		pointOfSaleTerminalsByApplicationDevices:"PointOfSaleTerminal",
		pointOfSalePrintersByApplicationDevicesReceipt:"PointOfSalePrinter",
		ordersBySeq:"Order",
		ordersByDoubleshotLegacyId:"Order",
		ordersByDoubleShotLegacyNumber:"Order",
		ordersByDiscounts:"Order",
		ordersByDelivery:"Order",
		ordersByItems:"Order",
		ordersByCart:"Order",
		ordersByEvents:"Order",
		ordersByPriceLines:"Order",
		ordersByPayments:"Order",
		ordersBySummary:"Order",
		ordersByGratuity:"Order",
		areasByTables:"Area",
		areasByLines:"Area",
		categoriesBySlug:"PointOfSaleCategory",
		categoriesByLocales:"PointOfSaleCategory",
		categoriesByProducts:"PointOfSaleCategory",
		channelsByCode:"Channel",
		channelsByPayments:"Channel",
		channelsByDeliveries:"Channel",
		channelsByCarts:"Channel",
		paginateTimetableDays:"TimetableDayConnection",
		paginateTimetableTemplates:"TimetableTemplateConnection",
		paginateStaffMembers:"StaffConnection",
		paginateEmployeeRoles:"VenueEmployeeRoleConnection",
		paginatePointOfSaleApplicationDevices:"PointOfSaleApplicationDeviceConnection",
		paginatePointOfSaleTerminals:"PointOfSaleTerminalConnection",
		paginatePointOfSalePrinters:"PointOfSalePrinterConnection",
		paginateOrders:"OrderConnection",
		paginateFulfillmentNotes:"FulfillmentNoteConnection",
		paginateAreas:"AreaConnection",
		paginateEnabledUnassignReasons:"UnassignReasonConnection",
		paginateCategories:"PointOfSaleCategoryConnection",
		paginateChannels:"ChannelConnection"
	},
	VenueMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		deadlineTemplate:"FieldMeta",
		timetableDays:"FieldMeta",
		timetableTemplates:"FieldMeta",
		staffMembers:"FieldMeta",
		employeeRoles:"FieldMeta",
		pointOfSaleApplicationDevices:"FieldMeta",
		pointOfSaleTerminals:"FieldMeta",
		pointOfSalePrinters:"FieldMeta",
		orders:"FieldMeta",
		fulfillmentNotes:"FieldMeta",
		areas:"FieldMeta",
		enabledUnassignReasons:"FieldMeta",
		categories:"FieldMeta",
		channels:"FieldMeta",
		address:"FieldMeta",
		pointOfSalePngBase64ReceiptLogo:"FieldMeta",
		pointOfSaleInitialView:"FieldMeta",
		pointOfSalePreferPrintReceipt:"FieldMeta"
	},
	DeadlineTemplate:{
		_meta:"DeadlineTemplateMeta",
		id:"UUID",
		startDate:"Date",
		period:"Int",
		cutoff:"Int",
		closed:"Boolean",
		venue:"Venue"
	},
	DeadlineTemplateMeta:{
		id:"FieldMeta",
		startDate:"FieldMeta",
		period:"FieldMeta",
		cutoff:"FieldMeta",
		closed:"FieldMeta",
		venue:"FieldMeta"
	},
	TimetableDay:{
		_meta:"TimetableDayMeta",
		id:"UUID",
		date:"Date",
		type:"TimetableDayType",
		shiftGroups:"TimetableShiftGroup",
		tipsCents:"Int",
		notes:"TimetableDayNote",
		venue:"Venue",
		meta:"TimetableDayMetadata",
		shiftGroupsByShifts:"TimetableShiftGroup",
		shiftGroupsByQueue:"TimetableShiftGroup",
		paginateShiftGroups:"TimetableShiftGroupConnection",
		paginateNotes:"TimetableDayNoteConnection"
	},
	TimetableDayMeta:{
		id:"FieldMeta",
		date:"FieldMeta",
		type:"FieldMeta",
		shiftGroups:"FieldMeta",
		tipsCents:"FieldMeta",
		notes:"FieldMeta",
		venue:"FieldMeta",
		meta:"FieldMeta"
	},
	TimetableShiftGroup:{
		_meta:"TimetableShiftGroupMeta",
		id:"UUID",
		order:"Int",
		shifts:"TimetableShift",
		day:"TimetableDay",
		type:"TimetableEmployeeRole",
		position:"TimetableShiftPosition",
		queue:"EmployeeQueue",
		generatedByTemplate:"TimetableTemplate",
		shiftsByQueueItem:"TimetableShift",
		shiftsBySwapInfo:"TimetableShift",
		paginateShifts:"TimetableShiftConnection"
	},
	TimetableShiftGroupMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		shifts:"FieldMeta",
		day:"FieldMeta",
		type:"FieldMeta",
		position:"FieldMeta",
		queue:"FieldMeta",
		generatedByTemplate:"FieldMeta"
	},
	TimetableShift:{
		_meta:"TimetableShiftMeta",
		id:"UUID",
		locked:"Boolean",
		order:"Int",
		assigned:"Date",
		group:"TimetableShiftGroup",
		shiftsProfile:"ShiftsProfile",
		queueItem:"EmployeeQueueItem",
		swapInfo:"TimetableShiftSwapInfo",
		isOvertime:"Boolean"
	},
	TimetableShiftMeta:{
		id:"FieldMeta",
		locked:"FieldMeta",
		order:"FieldMeta",
		assigned:"FieldMeta",
		group:"FieldMeta",
		shiftsProfile:"FieldMeta",
		queueItem:"FieldMeta",
		swapInfo:"FieldMeta",
		isOvertime:"FieldMeta"
	},
	ShiftsProfile:{
		_meta:"ShiftsProfileMeta",
		id:"UUID",
		queueItems:"EmployeeQueueItem",
		staff:"Staff",
		roles:"TimetableEmployeeRole",
		shifts:"TimetableShift",
		allowSelfUnassigning:"Boolean",
		queueItemsByQueue:"EmployeeQueueItem",
		queueItemsByShift:"EmployeeQueueItem",
		queueItemsByUnassignInfo:"EmployeeQueueItem",
		queueItemsByMeta:"EmployeeQueueItem",
		shiftsByQueueItem:"TimetableShift",
		shiftsBySwapInfo:"TimetableShift",
		paginateQueueItems:"EmployeeQueueItemConnection",
		paginateRoles:"TimetableEmployeeRoleConnection",
		paginateShifts:"TimetableShiftConnection"
	},
	ShiftsProfileMeta:{
		id:"FieldMeta",
		queueItems:"FieldMeta",
		staff:"FieldMeta",
		roles:"FieldMeta",
		shifts:"FieldMeta",
		allowSelfUnassigning:"FieldMeta"
	},
	EmployeeQueueItem:{
		_meta:"EmployeeQueueItemMeta",
		id:"UUID",
		start:"String",
		end:"String",
		queue:"EmployeeQueue",
		shiftsProfile:"ShiftsProfile",
		shift:"TimetableShift",
		unassignInfo:"UnassignedShiftInfo",
		meta:"EmployeeQueueItemMetadata"
	},
	EmployeeQueueItemMeta:{
		id:"FieldMeta",
		start:"FieldMeta",
		end:"FieldMeta",
		queue:"FieldMeta",
		shiftsProfile:"FieldMeta",
		shift:"FieldMeta",
		unassignInfo:"FieldMeta",
		meta:"FieldMeta"
	},
	EmployeeQueue:{
		_meta:"EmployeeQueueMeta",
		id:"UUID",
		shiftGroup:"TimetableShiftGroup",
		items:"EmployeeQueueItem",
		contemberBugFix:"Boolean",
		itemsByShiftsProfile:"EmployeeQueueItem",
		itemsByShift:"EmployeeQueueItem",
		itemsByUnassignInfo:"EmployeeQueueItem",
		itemsByMeta:"EmployeeQueueItem",
		paginateItems:"EmployeeQueueItemConnection"
	},
	EmployeeQueueMeta:{
		id:"FieldMeta",
		shiftGroup:"FieldMeta",
		items:"FieldMeta",
		contemberBugFix:"FieldMeta"
	},
	EmployeeQueueItemConnection:{
		pageInfo:"PageInfo",
		edges:"EmployeeQueueItemEdge"
	},
	EmployeeQueueItemEdge:{
		node:"EmployeeQueueItem"
	},
	UnassignedShiftInfo:{
		_meta:"UnassignedShiftInfoMeta",
		id:"UUID",
		hoursMissed:"Int",
		queueItem:"EmployeeQueueItem",
		legacyReason:"UnassignedInfoReason",
		reason:"UnassignReason"
	},
	UnassignedShiftInfoMeta:{
		id:"FieldMeta",
		hoursMissed:"FieldMeta",
		queueItem:"FieldMeta",
		legacyReason:"FieldMeta",
		reason:"FieldMeta"
	},
	UnassignReason:{
		_meta:"UnassignReasonMeta",
		id:"UUID",
		order:"Int",
		name:"String",
		venues:"Venue",
		paginateVenues:"VenueConnection"
	},
	UnassignReasonMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		name:"FieldMeta",
		venues:"FieldMeta"
	},
	VenueConnection:{
		pageInfo:"PageInfo",
		edges:"VenueEdge"
	},
	VenueEdge:{
		node:"Venue"
	},
	EmployeeQueueItemMetadata:{
		_meta:"EmployeeQueueItemMetadataMeta",
		id:"UUID",
		totalMinutes:"Int",
		queueItem:"EmployeeQueueItem",
		includeInTipsCalculation:"Boolean"
	},
	EmployeeQueueItemMetadataMeta:{
		id:"FieldMeta",
		totalMinutes:"FieldMeta",
		queueItem:"FieldMeta",
		includeInTipsCalculation:"FieldMeta"
	},
	TimetableEmployeeRole:{
		_meta:"TimetableEmployeeRoleMeta",
		id:"UUID",
		shiftGroups:"TimetableShiftGroup",
		shiftsProfiles:"ShiftsProfile",
		shiftsManagers:"ShiftsManager",
		name:"String",
		timetableTemplates:"TimetableTemplate",
		color:"String",
		shiftGroupsByShifts:"TimetableShiftGroup",
		shiftGroupsByQueue:"TimetableShiftGroup",
		timetableTemplatesByStaffOptions:"TimetableTemplate",
		paginateShiftGroups:"TimetableShiftGroupConnection",
		paginateShiftsProfiles:"ShiftsProfileConnection",
		paginateShiftsManagers:"ShiftsManagerConnection",
		paginateTimetableTemplates:"TimetableTemplateConnection"
	},
	TimetableEmployeeRoleMeta:{
		id:"FieldMeta",
		shiftGroups:"FieldMeta",
		shiftsProfiles:"FieldMeta",
		shiftsManagers:"FieldMeta",
		name:"FieldMeta",
		timetableTemplates:"FieldMeta",
		color:"FieldMeta"
	},
	ShiftsManager:{
		_meta:"ShiftsManagerMeta",
		id:"UUID",
		staff:"Staff",
		managedRoles:"TimetableEmployeeRole",
		createdAt:"DateTime",
		paginateManagedRoles:"TimetableEmployeeRoleConnection"
	},
	ShiftsManagerMeta:{
		id:"FieldMeta",
		staff:"FieldMeta",
		managedRoles:"FieldMeta",
		createdAt:"FieldMeta"
	},
	TimetableEmployeeRoleConnection:{
		pageInfo:"PageInfo",
		edges:"TimetableEmployeeRoleEdge"
	},
	TimetableEmployeeRoleEdge:{
		node:"TimetableEmployeeRole"
	},
	TimetableTemplate:{
		_meta:"TimetableTemplateMeta",
		id:"UUID",
		order:"Int",
		startDate:"Date",
		period:"Int",
		slots:"Int",
		position:"TimetableShiftPosition",
		staffOptions:"TimetableTemplateStaffOptions",
		internalName:"String",
		venue:"Venue",
		employeeRole:"TimetableEmployeeRole",
		workdaysOnly:"Boolean",
		monday:"Boolean",
		tuesday:"Boolean",
		wednesday:"Boolean",
		thursday:"Boolean",
		friday:"Boolean",
		saturday:"Boolean",
		sunday:"Boolean",
		type:"TemplateType",
		paginateStaffOptions:"TimetableTemplateStaffOptionsConnection"
	},
	TimetableTemplateMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		startDate:"FieldMeta",
		period:"FieldMeta",
		slots:"FieldMeta",
		position:"FieldMeta",
		staffOptions:"FieldMeta",
		internalName:"FieldMeta",
		venue:"FieldMeta",
		employeeRole:"FieldMeta",
		workdaysOnly:"FieldMeta",
		monday:"FieldMeta",
		tuesday:"FieldMeta",
		wednesday:"FieldMeta",
		thursday:"FieldMeta",
		friday:"FieldMeta",
		saturday:"FieldMeta",
		sunday:"FieldMeta",
		type:"FieldMeta"
	},
	TimetableShiftPosition:{
		_meta:"TimetableShiftPositionMeta",
		id:"UUID",
		name:"String",
		start:"String",
		end:"String",
		shiftGroups:"TimetableShiftGroup",
		timetableTemplates:"TimetableTemplate",
		isDynamic:"Boolean",
		shiftGroupsByShifts:"TimetableShiftGroup",
		shiftGroupsByQueue:"TimetableShiftGroup",
		timetableTemplatesByStaffOptions:"TimetableTemplate",
		paginateShiftGroups:"TimetableShiftGroupConnection",
		paginateTimetableTemplates:"TimetableTemplateConnection"
	},
	TimetableShiftPositionMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		start:"FieldMeta",
		end:"FieldMeta",
		shiftGroups:"FieldMeta",
		timetableTemplates:"FieldMeta",
		isDynamic:"FieldMeta"
	},
	TimetableShiftGroupConnection:{
		pageInfo:"PageInfo",
		edges:"TimetableShiftGroupEdge"
	},
	TimetableShiftGroupEdge:{
		node:"TimetableShiftGroup"
	},
	TimetableTemplateConnection:{
		pageInfo:"PageInfo",
		edges:"TimetableTemplateEdge"
	},
	TimetableTemplateEdge:{
		node:"TimetableTemplate"
	},
	TimetableTemplateStaffOptions:{
		_meta:"TimetableTemplateStaffOptionsMeta",
		id:"UUID",
		startTime:"String",
		endTime:"String",
		timetableTemplate:"TimetableTemplate",
		autoAssignedEmployee:"ShiftsProfile"
	},
	TimetableTemplateStaffOptionsMeta:{
		id:"FieldMeta",
		startTime:"FieldMeta",
		endTime:"FieldMeta",
		timetableTemplate:"FieldMeta",
		autoAssignedEmployee:"FieldMeta"
	},
	TimetableTemplateStaffOptionsConnection:{
		pageInfo:"PageInfo",
		edges:"TimetableTemplateStaffOptionsEdge"
	},
	TimetableTemplateStaffOptionsEdge:{
		node:"TimetableTemplateStaffOptions"
	},
	ShiftsProfileConnection:{
		pageInfo:"PageInfo",
		edges:"ShiftsProfileEdge"
	},
	ShiftsProfileEdge:{
		node:"ShiftsProfile"
	},
	ShiftsManagerConnection:{
		pageInfo:"PageInfo",
		edges:"ShiftsManagerEdge"
	},
	ShiftsManagerEdge:{
		node:"ShiftsManager"
	},
	TimetableShiftConnection:{
		pageInfo:"PageInfo",
		edges:"TimetableShiftEdge"
	},
	TimetableShiftEdge:{
		node:"TimetableShift"
	},
	TimetableShiftSwapInfo:{
		_meta:"TimetableShiftSwapInfoMeta",
		id:"UUID",
		assigned:"Date",
		requested:"Boolean",
		confirmed:"Boolean",
		swappedShiftsProfile:"ShiftsProfile",
		shift:"TimetableShift"
	},
	TimetableShiftSwapInfoMeta:{
		id:"FieldMeta",
		assigned:"FieldMeta",
		requested:"FieldMeta",
		confirmed:"FieldMeta",
		swappedShiftsProfile:"FieldMeta",
		shift:"FieldMeta"
	},
	TimetableDayNote:{
		_meta:"TimetableDayNoteMeta",
		id:"UUID",
		order:"Int",
		note:"String",
		day:"TimetableDay",
		role:"TimetableEmployeeRole"
	},
	TimetableDayNoteMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		note:"FieldMeta",
		day:"FieldMeta",
		role:"FieldMeta"
	},
	TimetableDayMetadata:{
		_meta:"TimetableDayMetadataMeta",
		id:"UUID",
		numberOfWorkers:"Int",
		tipsTotalCents:"Int",
		totalMinutes:"Int",
		tipsCentsPerMinute:"Float",
		day:"TimetableDay"
	},
	TimetableDayMetadataMeta:{
		id:"FieldMeta",
		numberOfWorkers:"FieldMeta",
		tipsTotalCents:"FieldMeta",
		totalMinutes:"FieldMeta",
		tipsCentsPerMinute:"FieldMeta",
		day:"FieldMeta"
	},
	TimetableDayNoteConnection:{
		pageInfo:"PageInfo",
		edges:"TimetableDayNoteEdge"
	},
	TimetableDayNoteEdge:{
		node:"TimetableDayNote"
	},
	VenueEmployeeRole:{
		_meta:"VenueEmployeeRoleMeta",
		id:"UUID",
		order:"Int",
		employeePrivileges:"TimetablesEmployeePrivileges",
		venue:"Venue",
		role:"TimetableEmployeeRole",
		getsTipsShare:"Boolean",
		notesEnabled:"Boolean"
	},
	VenueEmployeeRoleMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		employeePrivileges:"FieldMeta",
		venue:"FieldMeta",
		role:"FieldMeta",
		getsTipsShare:"FieldMeta",
		notesEnabled:"FieldMeta"
	},
	TimetablesEmployeePrivileges:{
		_meta:"TimetablesEmployeePrivilegesMeta",
		id:"UUID",
		venueEmployeeRole:"VenueEmployeeRole",
		read:"Boolean",
		unassign:"Boolean",
		assign:"Boolean"
	},
	TimetablesEmployeePrivilegesMeta:{
		id:"FieldMeta",
		venueEmployeeRole:"FieldMeta",
		read:"FieldMeta",
		unassign:"FieldMeta",
		assign:"FieldMeta"
	},
	PointOfSaleApplicationDevice:{
		_meta:"PointOfSaleApplicationDeviceMeta",
		id:"UUID",
		internalName:"String",
		note:"String",
		venue:"Venue",
		identificationCode:"IdentificationCode",
		identifier:"DeviceIdentifier",
		terminal:"PointOfSaleTerminal",
		receiptPrinter:"PointOfSalePrinter",
		ticketPrinters:"PointOfSalePrinter",
		paginateTicketPrinters:"PointOfSalePrinterConnection"
	},
	PointOfSaleApplicationDeviceMeta:{
		id:"FieldMeta",
		internalName:"FieldMeta",
		note:"FieldMeta",
		venue:"FieldMeta",
		identificationCode:"FieldMeta",
		identifier:"FieldMeta",
		terminal:"FieldMeta",
		receiptPrinter:"FieldMeta",
		ticketPrinters:"FieldMeta"
	},
	IdentificationCode:{
		_meta:"IdentificationCodeMeta",
		id:"UUID",
		code:"String",
		createdAt:"DateTime",
		attempts:"IdentificationAttempt",
		locales:"IdentificationCodeLocale",
		internalName:"String",
		applicationDevices:"PointOfSaleApplicationDevice",
		localesByLocale:"IdentificationCodeLocale",
		applicationDevicesByIdentifier:"PointOfSaleApplicationDevice",
		paginateAttempts:"IdentificationAttemptConnection",
		paginateLocales:"IdentificationCodeLocaleConnection",
		paginateApplicationDevices:"PointOfSaleApplicationDeviceConnection"
	},
	IdentificationCodeMeta:{
		id:"FieldMeta",
		code:"FieldMeta",
		createdAt:"FieldMeta",
		attempts:"FieldMeta",
		locales:"FieldMeta",
		internalName:"FieldMeta",
		applicationDevices:"FieldMeta"
	},
	IdentificationAttempt:{
		_meta:"IdentificationAttemptMeta",
		id:"UUID",
		createdAt:"DateTime",
		code:"IdentificationCode",
		user:"User"
	},
	IdentificationAttemptMeta:{
		id:"FieldMeta",
		createdAt:"FieldMeta",
		code:"FieldMeta",
		user:"FieldMeta"
	},
	User:{
		_meta:"UserMeta",
		id:"UUID",
		name:"String",
		internalNote:"String",
		staff:"Staff",
		customer:"Customer",
		tenantPersonId:"UUID",
		disabledAt:"DateTime",
		devices:"UserDevice",
		verifiedAt:"DateTime",
		email:"String",
		createdAt:"DateTime",
		deletionRequestedAt:"DateTime",
		deletionExpectedAt:"DateTime",
		deletedAt:"DateTime",
		meta:"UserMetadata",
		identificationAttempts:"IdentificationAttempt",
		roles:"UserRoles",
		devicesByDeviceId:"UserDevice",
		paginateDevices:"UserDeviceConnection",
		paginateIdentificationAttempts:"IdentificationAttemptConnection"
	},
	UserMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		internalNote:"FieldMeta",
		staff:"FieldMeta",
		customer:"FieldMeta",
		tenantPersonId:"FieldMeta",
		disabledAt:"FieldMeta",
		devices:"FieldMeta",
		verifiedAt:"FieldMeta",
		email:"FieldMeta",
		createdAt:"FieldMeta",
		deletionRequestedAt:"FieldMeta",
		deletionExpectedAt:"FieldMeta",
		deletedAt:"FieldMeta",
		meta:"FieldMeta",
		identificationAttempts:"FieldMeta",
		roles:"FieldMeta"
	},
	UserDevice:{
		_meta:"UserDeviceMeta",
		id:"UUID",
		createdAt:"DateTime",
		lastActiveAt:"DateTime",
		platform:"String",
		deviceId:"String",
		notificationsEnabled:"Boolean",
		user:"User",
		appVersion:"String",
		osVersion:"String",
		apiVersion:"String",
		anonymousSession:"AnonymousSession"
	},
	UserDeviceMeta:{
		id:"FieldMeta",
		createdAt:"FieldMeta",
		lastActiveAt:"FieldMeta",
		platform:"FieldMeta",
		deviceId:"FieldMeta",
		notificationsEnabled:"FieldMeta",
		user:"FieldMeta",
		appVersion:"FieldMeta",
		osVersion:"FieldMeta",
		apiVersion:"FieldMeta",
		anonymousSession:"FieldMeta"
	},
	AnonymousSession:{
		_meta:"AnonymousSessionMeta",
		id:"UUID",
		createdAt:"DateTime",
		lastActiveAt:"DateTime",
		anonymousSessionKey:"String",
		email:"String",
		name:"String",
		internalNote:"String",
		customer:"Customer",
		devices:"UserDevice",
		devicesByDeviceId:"UserDevice",
		paginateDevices:"UserDeviceConnection"
	},
	AnonymousSessionMeta:{
		id:"FieldMeta",
		createdAt:"FieldMeta",
		lastActiveAt:"FieldMeta",
		anonymousSessionKey:"FieldMeta",
		email:"FieldMeta",
		name:"FieldMeta",
		internalNote:"FieldMeta",
		customer:"FieldMeta",
		devices:"FieldMeta"
	},
	UserDeviceConnection:{
		pageInfo:"PageInfo",
		edges:"UserDeviceEdge"
	},
	UserDeviceEdge:{
		node:"UserDevice"
	},
	UserMetadata:{
		_meta:"UserMetadataMeta",
		id:"UUID",
		userProfileUrl:"String",
		tenantEmail:"String",
		tenantPersonId:"UUID",
		tenantIdentityId:"UUID",
		globalRoles:"Json",
		projectRoles:"Json",
		projectRolesString:"String",
		externalIdentifiers:"Json",
		externalIdentifiersString:"String",
		idpSlugs:"Json",
		idpSlugsString:"String",
		user:"User"
	},
	UserMetadataMeta:{
		id:"FieldMeta",
		userProfileUrl:"FieldMeta",
		tenantEmail:"FieldMeta",
		tenantPersonId:"FieldMeta",
		tenantIdentityId:"FieldMeta",
		globalRoles:"FieldMeta",
		projectRoles:"FieldMeta",
		projectRolesString:"FieldMeta",
		externalIdentifiers:"FieldMeta",
		externalIdentifiersString:"FieldMeta",
		idpSlugs:"FieldMeta",
		idpSlugsString:"FieldMeta",
		user:"FieldMeta"
	},
	UserRoles:{
		_meta:"UserRolesMeta",
		id:"UUID",
		isCustomer:"Boolean",
		isStaff:"Boolean",
		isBartender:"Boolean",
		isCashier:"Boolean",
		isCourier:"Boolean",
		isCleaner:"Boolean",
		isShiftsManager:"Boolean",
		isInternalBuyer:"Boolean",
		isStocksManager:"Boolean",
		isCourierManager:"Boolean",
		isCashierManager:"Boolean",
		isBusinessToBusinessManager:"Boolean",
		isPicker:"Boolean",
		user:"User"
	},
	UserRolesMeta:{
		id:"FieldMeta",
		isCustomer:"FieldMeta",
		isStaff:"FieldMeta",
		isBartender:"FieldMeta",
		isCashier:"FieldMeta",
		isCourier:"FieldMeta",
		isCleaner:"FieldMeta",
		isShiftsManager:"FieldMeta",
		isInternalBuyer:"FieldMeta",
		isStocksManager:"FieldMeta",
		isCourierManager:"FieldMeta",
		isCashierManager:"FieldMeta",
		isBusinessToBusinessManager:"FieldMeta",
		isPicker:"FieldMeta",
		user:"FieldMeta"
	},
	IdentificationAttemptConnection:{
		pageInfo:"PageInfo",
		edges:"IdentificationAttemptEdge"
	},
	IdentificationAttemptEdge:{
		node:"IdentificationAttempt"
	},
	IdentificationCodeLocale:{
		_meta:"IdentificationCodeLocaleMeta",
		id:"UUID",
		successMessage:"String",
		root:"IdentificationCode",
		locale:"Locale"
	},
	IdentificationCodeLocaleMeta:{
		id:"FieldMeta",
		successMessage:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta"
	},
	IdentificationCodeLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"IdentificationCodeLocaleEdge"
	},
	IdentificationCodeLocaleEdge:{
		node:"IdentificationCodeLocale"
	},
	PointOfSaleApplicationDeviceConnection:{
		pageInfo:"PageInfo",
		edges:"PointOfSaleApplicationDeviceEdge"
	},
	PointOfSaleApplicationDeviceEdge:{
		node:"PointOfSaleApplicationDevice"
	},
	DeviceIdentifier:{
		_meta:"DeviceIdentifierMeta",
		id:"UUID",
		internalName:"String",
		device:"PointOfSaleApplicationDevice",
		updatedAt:"DateTime",
		platform:"String",
		resolution:"String",
		devicePixelRatio:"Float",
		updatedByUser:"User",
		identifier:"String",
		meta:"DeviceIdentifierMetadata",
		applicationVersionIdentifier:"String",
		lastPointOfSaleSynchronizationErrorRawDetails:"String"
	},
	DeviceIdentifierMeta:{
		id:"FieldMeta",
		internalName:"FieldMeta",
		device:"FieldMeta",
		updatedAt:"FieldMeta",
		platform:"FieldMeta",
		resolution:"FieldMeta",
		devicePixelRatio:"FieldMeta",
		updatedByUser:"FieldMeta",
		identifier:"FieldMeta",
		meta:"FieldMeta",
		applicationVersionIdentifier:"FieldMeta",
		lastPointOfSaleSynchronizationErrorRawDetails:"FieldMeta"
	},
	DeviceIdentifierMetadata:{
		_meta:"DeviceIdentifierMetadataMeta",
		id:"UUID",
		prettyIdentifier:"String",
		deviceIdentifier:"DeviceIdentifier"
	},
	DeviceIdentifierMetadataMeta:{
		id:"FieldMeta",
		prettyIdentifier:"FieldMeta",
		deviceIdentifier:"FieldMeta"
	},
	PointOfSaleTerminal:{
		_meta:"PointOfSaleTerminalMeta",
		id:"UUID",
		internalName:"String",
		note:"String",
		venue:"Venue",
		applicationDevices:"PointOfSaleApplicationDevice",
		ipAddress:"String",
		port:"Int",
		type:"PointOfSaleTerminalType",
		applicationDevicesByIdentifier:"PointOfSaleApplicationDevice",
		paginateApplicationDevices:"PointOfSaleApplicationDeviceConnection"
	},
	PointOfSaleTerminalMeta:{
		id:"FieldMeta",
		internalName:"FieldMeta",
		note:"FieldMeta",
		venue:"FieldMeta",
		applicationDevices:"FieldMeta",
		ipAddress:"FieldMeta",
		port:"FieldMeta",
		type:"FieldMeta"
	},
	PointOfSalePrinter:{
		_meta:"PointOfSalePrinterMeta",
		id:"UUID",
		internalName:"String",
		note:"String",
		ipAddress:"String",
		applicationDevicesReceipt:"PointOfSaleApplicationDevice",
		applicationDevicesTicket:"PointOfSaleApplicationDevice",
		venue:"Venue",
		ticketCategories:"PointOfSaleCategory",
		applicationDevicesReceiptByIdentifier:"PointOfSaleApplicationDevice",
		paginateApplicationDevicesReceipt:"PointOfSaleApplicationDeviceConnection",
		paginateApplicationDevicesTicket:"PointOfSaleApplicationDeviceConnection",
		paginateTicketCategories:"PointOfSaleCategoryConnection"
	},
	PointOfSalePrinterMeta:{
		id:"FieldMeta",
		internalName:"FieldMeta",
		note:"FieldMeta",
		ipAddress:"FieldMeta",
		applicationDevicesReceipt:"FieldMeta",
		applicationDevicesTicket:"FieldMeta",
		venue:"FieldMeta",
		ticketCategories:"FieldMeta"
	},
	PointOfSaleCategory:{
		_meta:"PointOfSaleCategoryMeta",
		id:"UUID",
		order:"Int",
		slug:"String",
		locales:"PointOfSaleCategoryLocale",
		products:"PointOfSaleCategoryProduct",
		category:"ProductCategory",
		venue:"Venue",
		ticketPrinters:"PointOfSalePrinter",
		localesByLocale:"PointOfSaleCategoryLocale",
		productsByLocales:"PointOfSaleCategoryProduct",
		paginateLocales:"PointOfSaleCategoryLocaleConnection",
		paginateProducts:"PointOfSaleCategoryProductConnection",
		paginateTicketPrinters:"PointOfSalePrinterConnection"
	},
	PointOfSaleCategoryMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		slug:"FieldMeta",
		locales:"FieldMeta",
		products:"FieldMeta",
		category:"FieldMeta",
		venue:"FieldMeta",
		ticketPrinters:"FieldMeta"
	},
	PointOfSaleCategoryLocale:{
		_meta:"PointOfSaleCategoryLocaleMeta",
		id:"UUID",
		title:"String",
		root:"PointOfSaleCategory",
		locale:"Locale"
	},
	PointOfSaleCategoryLocaleMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta"
	},
	PointOfSaleCategoryProduct:{
		_meta:"PointOfSaleCategoryProductMeta",
		id:"UUID",
		order:"Int",
		category:"PointOfSaleCategory",
		product:"Product",
		locales:"PointOfSaleCategoryProductLocale",
		localesByLocale:"PointOfSaleCategoryProductLocale",
		paginateLocales:"PointOfSaleCategoryProductLocaleConnection"
	},
	PointOfSaleCategoryProductMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		category:"FieldMeta",
		product:"FieldMeta",
		locales:"FieldMeta"
	},
	PointOfSaleCategoryProductLocale:{
		_meta:"PointOfSaleCategoryProductLocaleMeta",
		id:"UUID",
		title:"String",
		root:"PointOfSaleCategoryProduct",
		locale:"Locale"
	},
	PointOfSaleCategoryProductLocaleMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta"
	},
	PointOfSaleCategoryProductLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"PointOfSaleCategoryProductLocaleEdge"
	},
	PointOfSaleCategoryProductLocaleEdge:{
		node:"PointOfSaleCategoryProductLocale"
	},
	ProductCategory:{
		_meta:"ProductCategoryMeta",
		id:"UUID",
		name:"String",
		code:"String",
		products:"Product",
		tags:"Tag",
		parent:"ProductCategory",
		children:"ProductCategory",
		description:"String",
		internalNote:"String",
		color:"String",
		image:"Image",
		order:"Float",
		descendants:"ProductCategoryTree",
		ancestors:"ProductCategoryTree",
		inheritedTags:"InheritedProductCategoryTag",
		nestedProducts:"NestedProductCategoryProduct",
		childrenByCode:"ProductCategory",
		childrenByChildren:"ProductCategory",
		childrenByDescendants:"ProductCategory",
		childrenByAncestors:"ProductCategory",
		childrenByInheritedTags:"ProductCategory",
		childrenByNestedProducts:"ProductCategory",
		paginateProducts:"ProductConnection",
		paginateTags:"TagConnection",
		paginateChildren:"ProductCategoryConnection",
		paginateDescendants:"ProductCategoryTreeConnection",
		paginateAncestors:"ProductCategoryTreeConnection",
		paginateInheritedTags:"InheritedProductCategoryTagConnection",
		paginateNestedProducts:"NestedProductCategoryProductConnection"
	},
	ProductCategoryMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		code:"FieldMeta",
		products:"FieldMeta",
		tags:"FieldMeta",
		parent:"FieldMeta",
		children:"FieldMeta",
		description:"FieldMeta",
		internalNote:"FieldMeta",
		color:"FieldMeta",
		image:"FieldMeta",
		order:"FieldMeta",
		descendants:"FieldMeta",
		ancestors:"FieldMeta",
		inheritedTags:"FieldMeta",
		nestedProducts:"FieldMeta"
	},
	ProductCategoryTree:{
		_meta:"ProductCategoryTreeMeta",
		id:"UUID",
		depth:"Int",
		ancestor:"ProductCategory",
		descendant:"ProductCategory"
	},
	ProductCategoryTreeMeta:{
		id:"FieldMeta",
		depth:"FieldMeta",
		ancestor:"FieldMeta",
		descendant:"FieldMeta"
	},
	InheritedProductCategoryTag:{
		_meta:"InheritedProductCategoryTagMeta",
		id:"UUID",
		depth:"Int",
		productCategory:"ProductCategory",
		tag:"Tag"
	},
	InheritedProductCategoryTagMeta:{
		id:"FieldMeta",
		depth:"FieldMeta",
		productCategory:"FieldMeta",
		tag:"FieldMeta"
	},
	NestedProductCategoryProduct:{
		_meta:"NestedProductCategoryProductMeta",
		id:"UUID",
		depth:"Int",
		product:"Product",
		productCategory:"ProductCategory"
	},
	NestedProductCategoryProductMeta:{
		id:"FieldMeta",
		depth:"FieldMeta",
		product:"FieldMeta",
		productCategory:"FieldMeta"
	},
	ProductConnection:{
		pageInfo:"PageInfo",
		edges:"ProductEdge"
	},
	ProductEdge:{
		node:"Product"
	},
	ProductCategoryConnection:{
		pageInfo:"PageInfo",
		edges:"ProductCategoryEdge"
	},
	ProductCategoryEdge:{
		node:"ProductCategory"
	},
	ProductCategoryTreeConnection:{
		pageInfo:"PageInfo",
		edges:"ProductCategoryTreeEdge"
	},
	ProductCategoryTreeEdge:{
		node:"ProductCategoryTree"
	},
	InheritedProductCategoryTagConnection:{
		pageInfo:"PageInfo",
		edges:"InheritedProductCategoryTagEdge"
	},
	InheritedProductCategoryTagEdge:{
		node:"InheritedProductCategoryTag"
	},
	NestedProductCategoryProductConnection:{
		pageInfo:"PageInfo",
		edges:"NestedProductCategoryProductEdge"
	},
	NestedProductCategoryProductEdge:{
		node:"NestedProductCategoryProduct"
	},
	PointOfSaleCategoryLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"PointOfSaleCategoryLocaleEdge"
	},
	PointOfSaleCategoryLocaleEdge:{
		node:"PointOfSaleCategoryLocale"
	},
	PointOfSaleCategoryProductConnection:{
		pageInfo:"PageInfo",
		edges:"PointOfSaleCategoryProductEdge"
	},
	PointOfSaleCategoryProductEdge:{
		node:"PointOfSaleCategoryProduct"
	},
	PointOfSalePrinterConnection:{
		pageInfo:"PageInfo",
		edges:"PointOfSalePrinterEdge"
	},
	PointOfSalePrinterEdge:{
		node:"PointOfSalePrinter"
	},
	PointOfSaleCategoryConnection:{
		pageInfo:"PageInfo",
		edges:"PointOfSaleCategoryEdge"
	},
	PointOfSaleCategoryEdge:{
		node:"PointOfSaleCategory"
	},
	Order:{
		_meta:"OrderMeta",
		id:"UUID",
		state:"OrderState",
		fulfilledAt:"DateTime",
		canceledAt:"DateTime",
		note:"String",
		customer:"Customer",
		channel:"Channel",
		discounts:"OrderDiscount",
		delivery:"OrderDelivery",
		items:"OrderItem",
		internalNote:"String",
		cart:"Cart",
		events:"OrderEvent",
		createdAt:"DateTime",
		billingAddress:"Address",
		priceLines:"OrderPriceLine",
		payments:"OrderPayment",
		seq:"Int",
		billingSubject:"BillingSubject",
		summary:"OrderSummary",
		doubleshotLegacyId:"String",
		gratuity:"Gratuity",
		venue:"Venue",
		fulfillmentNote:"String",
		fulfillmentNotes:"FulfillmentNote",
		doubleshotTotalWeightGrams:"Int",
		doubleShotLegacyNumber:"String",
		doubleshotLastUpdatedAt:"DateTime",
		doubleshotAdminUrl:"String",
		discountsByCustomerCreditTransactions:"OrderDiscount",
		discountsByVoucherRedemption:"OrderDiscount",
		itemsByVirtualProductEffects:"OrderItem",
		priceLinesByOrderItem:"OrderPriceLine",
		priceLinesByOrderDiscount:"OrderPriceLine",
		priceLinesByOrderPayment:"OrderPriceLine",
		priceLinesByOrderDelivery:"OrderPriceLine",
		paymentsByEvents:"OrderPayment",
		paymentsByMeta:"OrderPayment",
		paginateDiscounts:"OrderDiscountConnection",
		paginateItems:"OrderItemConnection",
		paginateEvents:"OrderEventConnection",
		paginatePriceLines:"OrderPriceLineConnection",
		paginatePayments:"OrderPaymentConnection",
		paginateFulfillmentNotes:"FulfillmentNoteConnection"
	},
	OrderMeta:{
		id:"FieldMeta",
		state:"FieldMeta",
		fulfilledAt:"FieldMeta",
		canceledAt:"FieldMeta",
		note:"FieldMeta",
		customer:"FieldMeta",
		channel:"FieldMeta",
		discounts:"FieldMeta",
		delivery:"FieldMeta",
		items:"FieldMeta",
		internalNote:"FieldMeta",
		cart:"FieldMeta",
		events:"FieldMeta",
		createdAt:"FieldMeta",
		billingAddress:"FieldMeta",
		priceLines:"FieldMeta",
		payments:"FieldMeta",
		seq:"FieldMeta",
		billingSubject:"FieldMeta",
		summary:"FieldMeta",
		doubleshotLegacyId:"FieldMeta",
		gratuity:"FieldMeta",
		venue:"FieldMeta",
		fulfillmentNote:"FieldMeta",
		fulfillmentNotes:"FieldMeta",
		doubleshotTotalWeightGrams:"FieldMeta",
		doubleShotLegacyNumber:"FieldMeta",
		doubleshotLastUpdatedAt:"FieldMeta",
		doubleshotAdminUrl:"FieldMeta"
	},
	OrderDiscount:{
		_meta:"OrderDiscountMeta",
		id:"UUID",
		discountCents:"Int",
		vatRate:"VatRate",
		order:"Order",
		description:"String",
		type:"OrderDiscountType",
		customerCreditTransactions:"CustomerCreditTransaction",
		voucherRedemption:"VoucherRedemption",
		customerCreditTransactionsByVirtualProductEffect:"CustomerCreditTransaction",
		paginateCustomerCreditTransactions:"CustomerCreditTransactionConnection"
	},
	OrderDiscountMeta:{
		id:"FieldMeta",
		discountCents:"FieldMeta",
		vatRate:"FieldMeta",
		order:"FieldMeta",
		description:"FieldMeta",
		type:"FieldMeta",
		customerCreditTransactions:"FieldMeta",
		voucherRedemption:"FieldMeta"
	},
	CustomerCreditTransaction:{
		_meta:"CustomerCreditTransactionMeta",
		id:"UUID",
		createdAt:"DateTime",
		amountCents:"Int",
		customerCredit:"CustomerCredit",
		orderDiscount:"OrderDiscount",
		virtualProductEffect:"VirtualProductEffect"
	},
	CustomerCreditTransactionMeta:{
		id:"FieldMeta",
		createdAt:"FieldMeta",
		amountCents:"FieldMeta",
		customerCredit:"FieldMeta",
		orderDiscount:"FieldMeta",
		virtualProductEffect:"FieldMeta"
	},
	CustomerCredit:{
		_meta:"CustomerCreditMeta",
		id:"UUID",
		initialCreditCents:"Int",
		remainingCreditsCents:"Int",
		expiresAt:"DateTime",
		reason:"String",
		customer:"Customer",
		vatRate:"VatRate",
		createdAt:"DateTime",
		transactions:"CustomerCreditTransaction",
		voucherRedemption:"VoucherRedemption",
		invoiceUrl:"String",
		transactionsByVirtualProductEffect:"CustomerCreditTransaction",
		paginateTransactions:"CustomerCreditTransactionConnection"
	},
	CustomerCreditMeta:{
		id:"FieldMeta",
		initialCreditCents:"FieldMeta",
		remainingCreditsCents:"FieldMeta",
		expiresAt:"FieldMeta",
		reason:"FieldMeta",
		customer:"FieldMeta",
		vatRate:"FieldMeta",
		createdAt:"FieldMeta",
		transactions:"FieldMeta",
		voucherRedemption:"FieldMeta",
		invoiceUrl:"FieldMeta"
	},
	VoucherRedemption:{
		_meta:"VoucherRedemptionMeta",
		id:"UUID",
		createdAt:"DateTime",
		note:"String",
		manualRedemptionNote:"String",
		customerCredit:"CustomerCredit",
		orderDiscount:"OrderDiscount",
		voucher:"Voucher",
		customer:"Customer"
	},
	VoucherRedemptionMeta:{
		id:"FieldMeta",
		createdAt:"FieldMeta",
		note:"FieldMeta",
		manualRedemptionNote:"FieldMeta",
		customerCredit:"FieldMeta",
		orderDiscount:"FieldMeta",
		voucher:"FieldMeta",
		customer:"FieldMeta"
	},
	Voucher:{
		_meta:"VoucherMeta",
		id:"UUID",
		createdAt:"DateTime",
		activatedAt:"DateTime",
		expiresAt:"DateTime",
		internalNote:"String",
		note:"String",
		code:"String",
		type:"VoucherType",
		creditCents:"Int",
		buyer:"Customer",
		owner:"Customer",
		vatRate:"VatRate",
		virtualProductEffect:"VirtualProductEffect",
		redemption:"VoucherRedemption"
	},
	VoucherMeta:{
		id:"FieldMeta",
		createdAt:"FieldMeta",
		activatedAt:"FieldMeta",
		expiresAt:"FieldMeta",
		internalNote:"FieldMeta",
		note:"FieldMeta",
		code:"FieldMeta",
		type:"FieldMeta",
		creditCents:"FieldMeta",
		buyer:"FieldMeta",
		owner:"FieldMeta",
		vatRate:"FieldMeta",
		virtualProductEffect:"FieldMeta",
		redemption:"FieldMeta"
	},
	VirtualProductEffect:{
		_meta:"VirtualProductEffectMeta",
		id:"UUID",
		createdAt:"DateTime",
		succeededAt:"DateTime",
		orderItem:"OrderItem",
		failedAt:"DateTime",
		revertedAt:"DateTime",
		resultCustomerCreditTransaction:"CustomerCreditTransaction",
		resultVouchers:"Voucher",
		resultVouchersByCode:"Voucher",
		resultVouchersByRedemption:"Voucher",
		paginateResultVouchers:"VoucherConnection"
	},
	VirtualProductEffectMeta:{
		id:"FieldMeta",
		createdAt:"FieldMeta",
		succeededAt:"FieldMeta",
		orderItem:"FieldMeta",
		failedAt:"FieldMeta",
		revertedAt:"FieldMeta",
		resultCustomerCreditTransaction:"FieldMeta",
		resultVouchers:"FieldMeta"
	},
	OrderItem:{
		_meta:"OrderItemMeta",
		id:"UUID",
		unitPriceCents:"Int",
		quantity:"Int",
		vatRate:"VatRate",
		order:"Order",
		virtualProductEffects:"VirtualProductEffect",
		pickedAt:"DateTime",
		note:"String",
		fulfillmentNotes:"FulfillmentNote",
		product:"Product",
		virtualProductEffectsByResultCustomerCreditTransaction:"VirtualProductEffect",
		virtualProductEffectsByResultVouchers:"VirtualProductEffect",
		paginateVirtualProductEffects:"VirtualProductEffectConnection",
		paginateFulfillmentNotes:"FulfillmentNoteConnection"
	},
	OrderItemMeta:{
		id:"FieldMeta",
		unitPriceCents:"FieldMeta",
		quantity:"FieldMeta",
		vatRate:"FieldMeta",
		order:"FieldMeta",
		virtualProductEffects:"FieldMeta",
		pickedAt:"FieldMeta",
		note:"FieldMeta",
		fulfillmentNotes:"FieldMeta",
		product:"FieldMeta"
	},
	VirtualProductEffectConnection:{
		pageInfo:"PageInfo",
		edges:"VirtualProductEffectEdge"
	},
	VirtualProductEffectEdge:{
		node:"VirtualProductEffect"
	},
	FulfillmentNoteConnection:{
		pageInfo:"PageInfo",
		edges:"FulfillmentNoteEdge"
	},
	FulfillmentNoteEdge:{
		node:"FulfillmentNote"
	},
	VoucherConnection:{
		pageInfo:"PageInfo",
		edges:"VoucherEdge"
	},
	VoucherEdge:{
		node:"Voucher"
	},
	CustomerCreditTransactionConnection:{
		pageInfo:"PageInfo",
		edges:"CustomerCreditTransactionEdge"
	},
	CustomerCreditTransactionEdge:{
		node:"CustomerCreditTransaction"
	},
	OrderEvent:{
		_meta:"OrderEventMeta",
		id:"UUID",
		type:"String",
		data:"String",
		createdAt:"DateTime",
		order:"Order",
		payment:"OrderPayment",
		delivery:"OrderDelivery"
	},
	OrderEventMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		data:"FieldMeta",
		createdAt:"FieldMeta",
		order:"FieldMeta",
		payment:"FieldMeta",
		delivery:"FieldMeta"
	},
	OrderPayment:{
		_meta:"OrderPaymentMeta",
		id:"UUID",
		data:"Json",
		paymentCents:"Int",
		method:"PaymentMethod",
		failedAt:"DateTime",
		state:"OrderPaymentState",
		approvedAt:"DateTime",
		events:"OrderEvent",
		order:"Order",
		invoice:"Invoice",
		walletType:"String",
		createdAt:"DateTime",
		publicReceiptUrl:"String",
		priceCents:"Int",
		vatRate:"VatRate",
		meta:"OrderPaymentMetadata",
		otherCurrencyPriceCents:"String",
		paginateEvents:"OrderEventConnection"
	},
	OrderPaymentMeta:{
		id:"FieldMeta",
		data:"FieldMeta",
		paymentCents:"FieldMeta",
		method:"FieldMeta",
		failedAt:"FieldMeta",
		state:"FieldMeta",
		approvedAt:"FieldMeta",
		events:"FieldMeta",
		order:"FieldMeta",
		invoice:"FieldMeta",
		walletType:"FieldMeta",
		createdAt:"FieldMeta",
		publicReceiptUrl:"FieldMeta",
		priceCents:"FieldMeta",
		vatRate:"FieldMeta",
		meta:"FieldMeta",
		otherCurrencyPriceCents:"FieldMeta"
	},
	Invoice:{
		_meta:"InvoiceMeta",
		id:"UUID",
		createdAt:"DateTime",
		publicKey:"String",
		fakturoidId:"String",
		fakturoidData:"String",
		legacyUrl:"String",
		customer:"Customer",
		orderPayments:"OrderPayment",
		address:"Address",
		publicUrl:"String",
		billingSubject:"BillingSubject",
		orderPaymentsByEvents:"OrderPayment",
		orderPaymentsByMeta:"OrderPayment",
		paginateOrderPayments:"OrderPaymentConnection"
	},
	InvoiceMeta:{
		id:"FieldMeta",
		createdAt:"FieldMeta",
		publicKey:"FieldMeta",
		fakturoidId:"FieldMeta",
		fakturoidData:"FieldMeta",
		legacyUrl:"FieldMeta",
		customer:"FieldMeta",
		orderPayments:"FieldMeta",
		address:"FieldMeta",
		publicUrl:"FieldMeta",
		billingSubject:"FieldMeta"
	},
	BillingSubject:{
		_meta:"BillingSubjectMeta",
		id:"UUID",
		name:"String",
		fullName:"String",
		addressLine1:"String",
		addressLine2:"String",
		city:"String",
		postalCode:"String",
		email:"String",
		phone:"String",
		companyName:"String",
		companyIdentifier:"String",
		vatIdentifier:"String",
		externalIdentifier:"String",
		hidden:"Boolean",
		createdAt:"DateTime",
		deletedAt:"DateTime",
		note:"String",
		internalNote:"String",
		fakturoidSubjectId:"String",
		country:"Country",
		customer:"Customer",
		invoices:"Invoice",
		defaultBillingSubjectOfCustomer:"Customer",
		orders:"Order",
		invoicesByPublicKey:"Invoice",
		invoicesByFakturoidId:"Invoice",
		invoicesByOrderPayments:"Invoice",
		ordersBySeq:"Order",
		ordersByDoubleshotLegacyId:"Order",
		ordersByDoubleShotLegacyNumber:"Order",
		ordersByDiscounts:"Order",
		ordersByDelivery:"Order",
		ordersByItems:"Order",
		ordersByCart:"Order",
		ordersByEvents:"Order",
		ordersByPriceLines:"Order",
		ordersByPayments:"Order",
		ordersBySummary:"Order",
		ordersByGratuity:"Order",
		paginateInvoices:"InvoiceConnection",
		paginateOrders:"OrderConnection"
	},
	BillingSubjectMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		fullName:"FieldMeta",
		addressLine1:"FieldMeta",
		addressLine2:"FieldMeta",
		city:"FieldMeta",
		postalCode:"FieldMeta",
		email:"FieldMeta",
		phone:"FieldMeta",
		companyName:"FieldMeta",
		companyIdentifier:"FieldMeta",
		vatIdentifier:"FieldMeta",
		externalIdentifier:"FieldMeta",
		hidden:"FieldMeta",
		createdAt:"FieldMeta",
		deletedAt:"FieldMeta",
		note:"FieldMeta",
		internalNote:"FieldMeta",
		fakturoidSubjectId:"FieldMeta",
		country:"FieldMeta",
		customer:"FieldMeta",
		invoices:"FieldMeta",
		defaultBillingSubjectOfCustomer:"FieldMeta",
		orders:"FieldMeta"
	},
	Country:{
		_meta:"CountryMeta",
		id:"UUID",
		code:"String",
		order:"Int"
	},
	CountryMeta:{
		id:"FieldMeta",
		code:"FieldMeta",
		order:"FieldMeta"
	},
	InvoiceConnection:{
		pageInfo:"PageInfo",
		edges:"InvoiceEdge"
	},
	InvoiceEdge:{
		node:"Invoice"
	},
	OrderConnection:{
		pageInfo:"PageInfo",
		edges:"OrderEdge"
	},
	OrderEdge:{
		node:"Order"
	},
	OrderPaymentConnection:{
		pageInfo:"PageInfo",
		edges:"OrderPaymentEdge"
	},
	OrderPaymentEdge:{
		node:"OrderPayment"
	},
	OrderPaymentMetadata:{
		_meta:"OrderPaymentMetadataMeta",
		id:"UUID",
		paymentUrl:"String",
		orderPayment:"OrderPayment"
	},
	OrderPaymentMetadataMeta:{
		id:"FieldMeta",
		paymentUrl:"FieldMeta",
		orderPayment:"FieldMeta"
	},
	OrderEventConnection:{
		pageInfo:"PageInfo",
		edges:"OrderEventEdge"
	},
	OrderEventEdge:{
		node:"OrderEvent"
	},
	OrderPriceLine:{
		_meta:"OrderPriceLineMeta",
		id:"UUID",
		unitPriceCents:"Int",
		quantity:"Int",
		type:"OrderPriceLineType",
		orderItem:"OrderItem",
		orderDiscount:"OrderDiscount",
		orderPayment:"OrderPayment",
		orderDelivery:"OrderDelivery",
		vatRatePermille:"Int",
		vatRate:"VatRate",
		order:"Order"
	},
	OrderPriceLineMeta:{
		id:"FieldMeta",
		unitPriceCents:"FieldMeta",
		quantity:"FieldMeta",
		type:"FieldMeta",
		orderItem:"FieldMeta",
		orderDiscount:"FieldMeta",
		orderPayment:"FieldMeta",
		orderDelivery:"FieldMeta",
		vatRatePermille:"FieldMeta",
		vatRate:"FieldMeta",
		order:"FieldMeta"
	},
	OrderSummary:{
		_meta:"OrderSummaryMeta",
		id:"UUID",
		totalPriceCents:"Int",
		discountPriceCents:"Int",
		undiscountedPriceCents:"Int",
		itemsQuantity:"Int",
		orderUrl:"String",
		orderNumber:"String",
		order:"Order"
	},
	OrderSummaryMeta:{
		id:"FieldMeta",
		totalPriceCents:"FieldMeta",
		discountPriceCents:"FieldMeta",
		undiscountedPriceCents:"FieldMeta",
		itemsQuantity:"FieldMeta",
		orderUrl:"FieldMeta",
		orderNumber:"FieldMeta",
		order:"FieldMeta"
	},
	Gratuity:{
		_meta:"GratuityMeta",
		id:"UUID",
		amountCents:"Int",
		order:"Order"
	},
	GratuityMeta:{
		id:"FieldMeta",
		amountCents:"FieldMeta",
		order:"FieldMeta"
	},
	OrderDiscountConnection:{
		pageInfo:"PageInfo",
		edges:"OrderDiscountEdge"
	},
	OrderDiscountEdge:{
		node:"OrderDiscount"
	},
	OrderItemConnection:{
		pageInfo:"PageInfo",
		edges:"OrderItemEdge"
	},
	OrderItemEdge:{
		node:"OrderItem"
	},
	OrderPriceLineConnection:{
		pageInfo:"PageInfo",
		edges:"OrderPriceLineEdge"
	},
	OrderPriceLineEdge:{
		node:"OrderPriceLine"
	},
	Area:{
		_meta:"AreaMeta",
		id:"UUID",
		order:"Int",
		name:"String",
		venue:"Venue",
		tables:"Table",
		lines:"Line",
		tablesByCustomerTabs:"Table",
		tablesBySeats:"Table",
		paginateTables:"TableConnection",
		paginateLines:"LineConnection"
	},
	AreaMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		name:"FieldMeta",
		venue:"FieldMeta",
		tables:"FieldMeta",
		lines:"FieldMeta"
	},
	Table:{
		_meta:"TableMeta",
		id:"UUID",
		shape:"TableShape",
		width:"Int",
		height:"Int",
		positionX:"Int",
		positionY:"Int",
		name:"String",
		color:"String",
		customerTabs:"CustomerTab",
		area:"Area",
		seats:"Seat",
		customerTabsByItems:"CustomerTab",
		customerTabsByMeta:"CustomerTab",
		seatsByCustomerTabs:"Seat",
		paginateCustomerTabs:"CustomerTabConnection",
		paginateSeats:"SeatConnection"
	},
	TableMeta:{
		id:"FieldMeta",
		shape:"FieldMeta",
		width:"FieldMeta",
		height:"FieldMeta",
		positionX:"FieldMeta",
		positionY:"FieldMeta",
		name:"FieldMeta",
		color:"FieldMeta",
		customerTabs:"FieldMeta",
		area:"FieldMeta",
		seats:"FieldMeta"
	},
	CustomerTab:{
		_meta:"CustomerTabMeta",
		id:"UUID",
		createdAt:"DateTime",
		color:"String",
		items:"CustomerTabItem",
		name:"String",
		meta:"CustomerTabMetadata",
		customer:"Customer",
		table:"Table",
		seat:"Seat",
		paginateItems:"CustomerTabItemConnection"
	},
	CustomerTabMeta:{
		id:"FieldMeta",
		createdAt:"FieldMeta",
		color:"FieldMeta",
		items:"FieldMeta",
		name:"FieldMeta",
		meta:"FieldMeta",
		customer:"FieldMeta",
		table:"FieldMeta",
		seat:"FieldMeta"
	},
	CustomerTabItem:{
		_meta:"CustomerTabItemMeta",
		id:"UUID",
		addedAt:"DateTime",
		tab:"CustomerTab",
		product:"Product",
		paidAt:"DateTime"
	},
	CustomerTabItemMeta:{
		id:"FieldMeta",
		addedAt:"FieldMeta",
		tab:"FieldMeta",
		product:"FieldMeta",
		paidAt:"FieldMeta"
	},
	CustomerTabMetadata:{
		_meta:"CustomerTabMetadataMeta",
		id:"UUID",
		totalPriceCents:"Int",
		totalSpentCents:"Int",
		unpaidCents:"Int",
		customerTab:"CustomerTab"
	},
	CustomerTabMetadataMeta:{
		id:"FieldMeta",
		totalPriceCents:"FieldMeta",
		totalSpentCents:"FieldMeta",
		unpaidCents:"FieldMeta",
		customerTab:"FieldMeta"
	},
	Seat:{
		_meta:"SeatMeta",
		id:"UUID",
		positionX:"Int",
		positionY:"Int",
		name:"String",
		color:"String",
		customerTabs:"CustomerTab",
		table:"Table",
		customerTabsByItems:"CustomerTab",
		customerTabsByMeta:"CustomerTab",
		paginateCustomerTabs:"CustomerTabConnection"
	},
	SeatMeta:{
		id:"FieldMeta",
		positionX:"FieldMeta",
		positionY:"FieldMeta",
		name:"FieldMeta",
		color:"FieldMeta",
		customerTabs:"FieldMeta",
		table:"FieldMeta"
	},
	CustomerTabConnection:{
		pageInfo:"PageInfo",
		edges:"CustomerTabEdge"
	},
	CustomerTabEdge:{
		node:"CustomerTab"
	},
	CustomerTabItemConnection:{
		pageInfo:"PageInfo",
		edges:"CustomerTabItemEdge"
	},
	CustomerTabItemEdge:{
		node:"CustomerTabItem"
	},
	SeatConnection:{
		pageInfo:"PageInfo",
		edges:"SeatEdge"
	},
	SeatEdge:{
		node:"Seat"
	},
	Line:{
		_meta:"LineMeta",
		id:"UUID",
		positionStartX:"Int",
		positionStartY:"Int",
		positionEndX:"Int",
		positionEndY:"Int",
		area:"Area"
	},
	LineMeta:{
		id:"FieldMeta",
		positionStartX:"FieldMeta",
		positionStartY:"FieldMeta",
		positionEndX:"FieldMeta",
		positionEndY:"FieldMeta",
		area:"FieldMeta"
	},
	TableConnection:{
		pageInfo:"PageInfo",
		edges:"TableEdge"
	},
	TableEdge:{
		node:"Table"
	},
	LineConnection:{
		pageInfo:"PageInfo",
		edges:"LineEdge"
	},
	LineEdge:{
		node:"Line"
	},
	TimetableDayConnection:{
		pageInfo:"PageInfo",
		edges:"TimetableDayEdge"
	},
	TimetableDayEdge:{
		node:"TimetableDay"
	},
	StaffConnection:{
		pageInfo:"PageInfo",
		edges:"StaffEdge"
	},
	StaffEdge:{
		node:"Staff"
	},
	VenueEmployeeRoleConnection:{
		pageInfo:"PageInfo",
		edges:"VenueEmployeeRoleEdge"
	},
	VenueEmployeeRoleEdge:{
		node:"VenueEmployeeRole"
	},
	PointOfSaleTerminalConnection:{
		pageInfo:"PageInfo",
		edges:"PointOfSaleTerminalEdge"
	},
	PointOfSaleTerminalEdge:{
		node:"PointOfSaleTerminal"
	},
	AreaConnection:{
		pageInfo:"PageInfo",
		edges:"AreaEdge"
	},
	AreaEdge:{
		node:"Area"
	},
	UnassignReasonConnection:{
		pageInfo:"PageInfo",
		edges:"UnassignReasonEdge"
	},
	UnassignReasonEdge:{
		node:"UnassignReason"
	},
	CartItemConnection:{
		pageInfo:"PageInfo",
		edges:"CartItemEdge"
	},
	CartItemEdge:{
		node:"CartItem"
	},
	CartPriceLine:{
		_meta:"CartPriceLineMeta",
		id:"UUID",
		type:"CartPriceLineType",
		item:"CartItem",
		product:"Product",
		unitPriceCents:"Int",
		priceCents:"Int",
		quantity:"Int",
		vatRatePermille:"Int",
		vatRate:"VatRate",
		cart:"Cart"
	},
	CartPriceLineMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		item:"FieldMeta",
		product:"FieldMeta",
		unitPriceCents:"FieldMeta",
		priceCents:"FieldMeta",
		quantity:"FieldMeta",
		vatRatePermille:"FieldMeta",
		vatRate:"FieldMeta",
		cart:"FieldMeta"
	},
	CartSummary:{
		_meta:"CartSummaryMeta",
		id:"UUID",
		itemsPriceCents:"Int",
		deliveryPriceCents:"Int",
		totalPriceCents:"Int",
		itemsCount:"Int",
		itemsQuantity:"Int",
		checkoutUrl:"String",
		cart:"Cart"
	},
	CartSummaryMeta:{
		id:"FieldMeta",
		itemsPriceCents:"FieldMeta",
		deliveryPriceCents:"FieldMeta",
		totalPriceCents:"FieldMeta",
		itemsCount:"FieldMeta",
		itemsQuantity:"FieldMeta",
		checkoutUrl:"FieldMeta",
		cart:"FieldMeta"
	},
	CartPriceLineConnection:{
		pageInfo:"PageInfo",
		edges:"CartPriceLineEdge"
	},
	CartPriceLineEdge:{
		node:"CartPriceLine"
	},
	ChannelPaymentConnection:{
		pageInfo:"PageInfo",
		edges:"ChannelPaymentEdge"
	},
	ChannelPaymentEdge:{
		node:"ChannelPayment"
	},
	ChannelDeliveryConnection:{
		pageInfo:"PageInfo",
		edges:"ChannelDeliveryEdge"
	},
	ChannelDeliveryEdge:{
		node:"ChannelDelivery"
	},
	PointOfSaleConnection:{
		pageInfo:"PageInfo",
		edges:"PointOfSaleEdge"
	},
	PointOfSaleEdge:{
		node:"PointOfSale"
	},
	CartConnection:{
		pageInfo:"PageInfo",
		edges:"CartEdge"
	},
	CartEdge:{
		node:"Cart"
	},
	CustomerConnection:{
		pageInfo:"PageInfo",
		edges:"CustomerEdge"
	},
	CustomerEdge:{
		node:"Customer"
	},
	LiftagoRide:{
		_meta:"LiftagoRideMeta",
		id:"UUID",
		liftagoId:"String",
		data:"String",
		updatedAt:"DateTime",
		delivery:"OrderDelivery"
	},
	LiftagoRideMeta:{
		id:"FieldMeta",
		liftagoId:"FieldMeta",
		data:"FieldMeta",
		updatedAt:"FieldMeta",
		delivery:"FieldMeta"
	},
	WoltDriveDelivery:{
		_meta:"WoltDriveDeliveryMeta",
		id:"UUID",
		state:"WoltDriveDeliveryState",
		shipmentPromiseId:"String",
		deliveryPrice:"Int",
		deliveryPriceCurrency:"String",
		shipmentPromiseResponse:"String",
		deliveryOrderId:"String",
		trackingUrl:"String",
		deliverOrderResponse:"String",
		delivery:"OrderDelivery"
	},
	WoltDriveDeliveryMeta:{
		id:"FieldMeta",
		state:"FieldMeta",
		shipmentPromiseId:"FieldMeta",
		deliveryPrice:"FieldMeta",
		deliveryPriceCurrency:"FieldMeta",
		shipmentPromiseResponse:"FieldMeta",
		deliveryOrderId:"FieldMeta",
		trackingUrl:"FieldMeta",
		deliverOrderResponse:"FieldMeta",
		delivery:"FieldMeta"
	},
	DeliveryWaypointConnection:{
		pageInfo:"PageInfo",
		edges:"DeliveryWaypointEdge"
	},
	DeliveryWaypointEdge:{
		node:"DeliveryWaypoint"
	},
	DeliveryRouteConnection:{
		pageInfo:"PageInfo",
		edges:"DeliveryRouteEdge"
	},
	DeliveryRouteEdge:{
		node:"DeliveryRoute"
	},
	DeliveryMethodConnection:{
		pageInfo:"PageInfo",
		edges:"DeliveryMethodEdge"
	},
	DeliveryMethodEdge:{
		node:"DeliveryMethod"
	},
	Cleaner:{
		_meta:"CleanerMeta",
		id:"UUID",
		staff:"Staff",
		canReachTopShelf:"Boolean",
		createdAt:"DateTime"
	},
	CleanerMeta:{
		id:"FieldMeta",
		staff:"FieldMeta",
		canReachTopShelf:"FieldMeta",
		createdAt:"FieldMeta"
	},
	StocksManager:{
		_meta:"StocksManagerMeta",
		id:"UUID",
		staff:"Staff",
		managedProducts:"Product",
		createdAt:"DateTime",
		managedProductsByCode:"Product",
		managedProductsByStocks:"Product",
		managedProductsByGroupPrices:"Product",
		managedProductsByCartItems:"Product",
		managedProductsByOrderItems:"Product",
		managedProductsByInheritedCategories:"Product",
		managedProductsByLocales:"Product",
		managedProductsByCustomerPrices:"Product",
		managedProductsByVirtualProduct:"Product",
		managedProductsByMeta:"Product",
		managedProductsByPage:"Product",
		managedProductsBySalesDays:"Product",
		managedProductsBySalesWeeks:"Product",
		managedProductsBySalesMonths:"Product",
		paginateManagedProducts:"ProductConnection"
	},
	StocksManagerMeta:{
		id:"FieldMeta",
		staff:"FieldMeta",
		managedProducts:"FieldMeta",
		createdAt:"FieldMeta"
	},
	CourierManager:{
		_meta:"CourierManagerMeta",
		id:"UUID",
		staff:"Staff",
		createdAt:"DateTime"
	},
	CourierManagerMeta:{
		id:"FieldMeta",
		staff:"FieldMeta",
		createdAt:"FieldMeta"
	},
	Picker:{
		_meta:"PickerMeta",
		id:"UUID",
		staff:"Staff",
		createdAt:"DateTime"
	},
	PickerMeta:{
		id:"FieldMeta",
		staff:"FieldMeta",
		createdAt:"FieldMeta"
	},
	RemunerationProfile:{
		_meta:"RemunerationProfileMeta",
		id:"UUID",
		employmentInformation:"EmploymentInformation",
		workMonths:"WorkMonth",
		staff:"Staff",
		paginateEmploymentInformation:"EmploymentInformationConnection"
	},
	RemunerationProfileMeta:{
		id:"FieldMeta",
		employmentInformation:"FieldMeta",
		workMonths:"FieldMeta",
		staff:"FieldMeta"
	},
	EmploymentInformation:{
		_meta:"EmploymentInformationMeta",
		id:"UUID",
		hourlyRate:"Int",
		remunerationProfiles:"RemunerationProfile",
		monthlySalary:"Int",
		type:"EmploymentType",
		name:"String"
	},
	EmploymentInformationMeta:{
		id:"FieldMeta",
		hourlyRate:"FieldMeta",
		remunerationProfiles:"FieldMeta",
		monthlySalary:"FieldMeta",
		type:"FieldMeta",
		name:"FieldMeta"
	},
	WorkMonth:{
		_meta:"WorkMonthMeta",
		id:"UUID",
		year:"Int",
		month:"Int",
		hoursWorked:"Float",
		billableHours:"Float",
		remunerationProfile:"RemunerationProfile",
		remunerationProfileByEmploymentInformation:"RemunerationProfile",
		remunerationProfileByStaff:"RemunerationProfile",
		paginateRemunerationProfile:"RemunerationProfileConnection"
	},
	WorkMonthMeta:{
		id:"FieldMeta",
		year:"FieldMeta",
		month:"FieldMeta",
		hoursWorked:"FieldMeta",
		billableHours:"FieldMeta",
		remunerationProfile:"FieldMeta"
	},
	RemunerationProfileConnection:{
		pageInfo:"PageInfo",
		edges:"RemunerationProfileEdge"
	},
	RemunerationProfileEdge:{
		node:"RemunerationProfile"
	},
	EmploymentInformationConnection:{
		pageInfo:"PageInfo",
		edges:"EmploymentInformationEdge"
	},
	EmploymentInformationEdge:{
		node:"EmploymentInformation"
	},
	Cashier:{
		_meta:"CashierMeta",
		id:"UUID",
		createdAt:"DateTime",
		staff:"Staff"
	},
	CashierMeta:{
		id:"FieldMeta",
		createdAt:"FieldMeta",
		staff:"FieldMeta"
	},
	InternalBuyer:{
		_meta:"InternalBuyerMeta",
		id:"UUID",
		createdAt:"DateTime",
		staff:"Staff"
	},
	InternalBuyerMeta:{
		id:"FieldMeta",
		createdAt:"FieldMeta",
		staff:"FieldMeta"
	},
	SalesManager:{
		_meta:"SalesManagerMeta",
		id:"UUID",
		staff:"Staff",
		createdAt:"DateTime",
		countries:"Country",
		paginateCountries:"CountryConnection"
	},
	SalesManagerMeta:{
		id:"FieldMeta",
		staff:"FieldMeta",
		createdAt:"FieldMeta",
		countries:"FieldMeta"
	},
	CountryConnection:{
		pageInfo:"PageInfo",
		edges:"CountryEdge"
	},
	CountryEdge:{
		node:"Country"
	},
	CashierManager:{
		_meta:"CashierManagerMeta",
		id:"UUID",
		createdAt:"DateTime",
		staff:"Staff"
	},
	CashierManagerMeta:{
		id:"FieldMeta",
		createdAt:"FieldMeta",
		staff:"FieldMeta"
	},
	BusinessCustomerConnection:{
		pageInfo:"PageInfo",
		edges:"BusinessCustomerEdge"
	},
	BusinessCustomerEdge:{
		node:"BusinessCustomer"
	},
	BusinessServiceEvent:{
		_meta:"BusinessServiceEventMeta",
		id:"UUID",
		createdAt:"DateTime",
		fulfilledAt:"DateTime",
		businessCustomer:"BusinessCustomer",
		businessService:"BusinessService",
		filledNumberOfPeople:"Int",
		filledInvoiced:"Boolean",
		filledEquipment:"String",
		filledMillTamDem:"Boolean",
		filledSOEspresso:"Boolean",
		filledFilterCoffeeInMenu:"Boolean",
		filledWaterMeterStatus:"String",
		filledServiceAction:"String",
		filledInvoiceIdentifier:"String",
		filledNote:"String",
		filledContact:"String",
		filledPhone:"Boolean",
		filledEmail:"Boolean",
		filledGrindingStonesCondition:"String",
		createdBy:"Staff",
		filledSupervisor:"Staff"
	},
	BusinessServiceEventMeta:{
		id:"FieldMeta",
		createdAt:"FieldMeta",
		fulfilledAt:"FieldMeta",
		businessCustomer:"FieldMeta",
		businessService:"FieldMeta",
		filledNumberOfPeople:"FieldMeta",
		filledInvoiced:"FieldMeta",
		filledEquipment:"FieldMeta",
		filledMillTamDem:"FieldMeta",
		filledSOEspresso:"FieldMeta",
		filledFilterCoffeeInMenu:"FieldMeta",
		filledWaterMeterStatus:"FieldMeta",
		filledServiceAction:"FieldMeta",
		filledInvoiceIdentifier:"FieldMeta",
		filledNote:"FieldMeta",
		filledContact:"FieldMeta",
		filledPhone:"FieldMeta",
		filledEmail:"FieldMeta",
		filledGrindingStonesCondition:"FieldMeta",
		createdBy:"FieldMeta",
		filledSupervisor:"FieldMeta"
	},
	BusinessService:{
		_meta:"BusinessServiceMeta",
		id:"UUID",
		order:"Int",
		requireNote:"Int",
		locales:"BusinessServiceLocale",
		requireNumberOfPeople:"Int",
		requireInvoiced:"Int",
		requireEquipment:"Int",
		requireMillTamDem:"Int",
		requireSOEspresso:"Int",
		requireFilterCoffeeInMenu:"Int",
		requireWaterMeterStatus:"Int",
		requireServiceAction:"Int",
		optionsEquipment:"String",
		optionsServiceAction:"String",
		requireInvoiceIdentifier:"Int",
		requireSupervisor:"Int",
		requireContact:"Int",
		requirePhone:"Int",
		requireEmail:"Int",
		requireGrindingStonesCondition:"Int",
		localesByLocale:"BusinessServiceLocale",
		paginateLocales:"BusinessServiceLocaleConnection"
	},
	BusinessServiceMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		requireNote:"FieldMeta",
		locales:"FieldMeta",
		requireNumberOfPeople:"FieldMeta",
		requireInvoiced:"FieldMeta",
		requireEquipment:"FieldMeta",
		requireMillTamDem:"FieldMeta",
		requireSOEspresso:"FieldMeta",
		requireFilterCoffeeInMenu:"FieldMeta",
		requireWaterMeterStatus:"FieldMeta",
		requireServiceAction:"FieldMeta",
		optionsEquipment:"FieldMeta",
		optionsServiceAction:"FieldMeta",
		requireInvoiceIdentifier:"FieldMeta",
		requireSupervisor:"FieldMeta",
		requireContact:"FieldMeta",
		requirePhone:"FieldMeta",
		requireEmail:"FieldMeta",
		requireGrindingStonesCondition:"FieldMeta"
	},
	BusinessServiceLocale:{
		_meta:"BusinessServiceLocaleMeta",
		id:"UUID",
		name:"String",
		labelNote:"String",
		root:"BusinessService",
		locale:"Locale",
		labelNumberOfPeople:"String",
		labelInvoiced:"String",
		labelEquipment:"String",
		labelMillTamDem:"String",
		labelSOEspresso:"String",
		labelFilterCoffeeInMenu:"String",
		labelWaterMeterStatus:"String",
		labelServiceAction:"String",
		labelInvoiceIdentifier:"String",
		labelSupervisor:"String",
		labelContact:"String",
		labelPhone:"String",
		labelEmail:"String",
		labelGrindingStonesCondition:"String"
	},
	BusinessServiceLocaleMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		labelNote:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		labelNumberOfPeople:"FieldMeta",
		labelInvoiced:"FieldMeta",
		labelEquipment:"FieldMeta",
		labelMillTamDem:"FieldMeta",
		labelSOEspresso:"FieldMeta",
		labelFilterCoffeeInMenu:"FieldMeta",
		labelWaterMeterStatus:"FieldMeta",
		labelServiceAction:"FieldMeta",
		labelInvoiceIdentifier:"FieldMeta",
		labelSupervisor:"FieldMeta",
		labelContact:"FieldMeta",
		labelPhone:"FieldMeta",
		labelEmail:"FieldMeta",
		labelGrindingStonesCondition:"FieldMeta"
	},
	BusinessServiceLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"BusinessServiceLocaleEdge"
	},
	BusinessServiceLocaleEdge:{
		node:"BusinessServiceLocale"
	},
	DoubleshotCoffeeEquipment:{
		_meta:"DoubleshotCoffeeEquipmentMeta",
		id:"UUID",
		espressoMachine:"String",
		espressoGrinder:"String",
		batchBrew:"String",
		batchGrinder:"String",
		waterFilter:"String",
		mechanicalFilter:"String"
	},
	DoubleshotCoffeeEquipmentMeta:{
		id:"FieldMeta",
		espressoMachine:"FieldMeta",
		espressoGrinder:"FieldMeta",
		batchBrew:"FieldMeta",
		batchGrinder:"FieldMeta",
		waterFilter:"FieldMeta",
		mechanicalFilter:"FieldMeta"
	},
	BusinessServiceEventConnection:{
		pageInfo:"PageInfo",
		edges:"BusinessServiceEventEdge"
	},
	BusinessServiceEventEdge:{
		node:"BusinessServiceEvent"
	},
	OrderRecurrence:{
		_meta:"OrderRecurrenceMeta",
		id:"UUID",
		internalName:"String",
		locales:"OrderRecurrenceLocale",
		order:"Int",
		businessCategory:"BusinessCategory",
		localesByLocale:"OrderRecurrenceLocale",
		paginateLocales:"OrderRecurrenceLocaleConnection",
		paginateBusinessCategory:"BusinessCategoryConnection"
	},
	OrderRecurrenceMeta:{
		id:"FieldMeta",
		internalName:"FieldMeta",
		locales:"FieldMeta",
		order:"FieldMeta",
		businessCategory:"FieldMeta"
	},
	OrderRecurrenceLocale:{
		_meta:"OrderRecurrenceLocaleMeta",
		id:"UUID",
		name:"String",
		root:"OrderRecurrence",
		locale:"Locale"
	},
	OrderRecurrenceLocaleMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta"
	},
	OrderRecurrenceLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"OrderRecurrenceLocaleEdge"
	},
	OrderRecurrenceLocaleEdge:{
		node:"OrderRecurrenceLocale"
	},
	BusinessCategoryConnection:{
		pageInfo:"PageInfo",
		edges:"BusinessCategoryEdge"
	},
	BusinessCategoryEdge:{
		node:"BusinessCategory"
	},
	ProductList:{
		_meta:"ProductListMeta",
		id:"UUID",
		items:"ProductListItem",
		businessCategory:"BusinessCategory",
		paginateItems:"ProductListItemConnection"
	},
	ProductListMeta:{
		id:"FieldMeta",
		items:"FieldMeta",
		businessCategory:"FieldMeta"
	},
	ProductListItem:{
		_meta:"ProductListItemMeta",
		id:"UUID",
		order:"Int",
		list:"ProductList",
		product:"Product",
		defaultQuantityForOrder:"Int"
	},
	ProductListItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		product:"FieldMeta",
		defaultQuantityForOrder:"FieldMeta"
	},
	ProductListItemConnection:{
		pageInfo:"PageInfo",
		edges:"ProductListItemEdge"
	},
	ProductListItemEdge:{
		node:"ProductListItem"
	},
	ProductCategoryList:{
		_meta:"ProductCategoryListMeta",
		id:"UUID",
		items:"ProductCategoryListItem",
		locales:"ProductCategoryListLocale",
		seasonalProductCategoriesOfBusinessCategory:"BusinessCategory",
		specificProductsProductCategoriesOfBusinessCategory:"BusinessCategory",
		localesByLocale:"ProductCategoryListLocale",
		paginateItems:"ProductCategoryListItemConnection",
		paginateLocales:"ProductCategoryListLocaleConnection"
	},
	ProductCategoryListMeta:{
		id:"FieldMeta",
		items:"FieldMeta",
		locales:"FieldMeta",
		seasonalProductCategoriesOfBusinessCategory:"FieldMeta",
		specificProductsProductCategoriesOfBusinessCategory:"FieldMeta"
	},
	ProductCategoryListItem:{
		_meta:"ProductCategoryListItemMeta",
		id:"UUID",
		order:"Int",
		list:"ProductCategoryList",
		productCategory:"ProductCategory",
		showRecipeImages:"Boolean",
		showPackingImages:"Boolean",
		showAllAvailableProducts:"Boolean"
	},
	ProductCategoryListItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		productCategory:"FieldMeta",
		showRecipeImages:"FieldMeta",
		showPackingImages:"FieldMeta",
		showAllAvailableProducts:"FieldMeta"
	},
	ProductCategoryListLocale:{
		_meta:"ProductCategoryListLocaleMeta",
		id:"UUID",
		name:"String",
		root:"ProductCategoryList",
		locale:"Locale"
	},
	ProductCategoryListLocaleMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta"
	},
	ProductCategoryListItemConnection:{
		pageInfo:"PageInfo",
		edges:"ProductCategoryListItemEdge"
	},
	ProductCategoryListItemEdge:{
		node:"ProductCategoryListItem"
	},
	ProductCategoryListLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"ProductCategoryListLocaleEdge"
	},
	ProductCategoryListLocaleEdge:{
		node:"ProductCategoryListLocale"
	},
	BusinessCategoryLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"BusinessCategoryLocaleEdge"
	},
	BusinessCategoryLocaleEdge:{
		node:"BusinessCategoryLocale"
	},
	OrderRecurrenceConnection:{
		pageInfo:"PageInfo",
		edges:"OrderRecurrenceEdge"
	},
	OrderRecurrenceEdge:{
		node:"OrderRecurrence"
	},
	ProductIngredientLocale:{
		_meta:"ProductIngredientLocaleMeta",
		id:"UUID",
		name:"String",
		root:"ProductIngredient",
		locale:"Locale"
	},
	ProductIngredientLocaleMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta"
	},
	ProductIngredient:{
		_meta:"ProductIngredientMeta",
		id:"UUID",
		internalNote:"String",
		locales:"ProductIngredientLocale",
		internalName:"String",
		categories:"ProductIngredientCategory",
		allergens:"Allergen",
		needsPrepping:"Boolean",
		allowCustomerRating:"Boolean",
		customerRatings:"CustomerIngredientRating",
		preferredQuantityUnit:"ProductIngredientItemQuantityUnit",
		freshingContainer:"FreshingContainer",
		image:"Image",
		suppliers:"IngredientSupplierList",
		incrementQuantityNumber:"Float",
		localesByLocale:"ProductIngredientLocale",
		customerRatingsByCustomer:"CustomerIngredientRating",
		paginateLocales:"ProductIngredientLocaleConnection",
		paginateCategories:"ProductIngredientCategoryConnection",
		paginateAllergens:"AllergenConnection",
		paginateCustomerRatings:"CustomerIngredientRatingConnection"
	},
	ProductIngredientMeta:{
		id:"FieldMeta",
		internalNote:"FieldMeta",
		locales:"FieldMeta",
		internalName:"FieldMeta",
		categories:"FieldMeta",
		allergens:"FieldMeta",
		needsPrepping:"FieldMeta",
		allowCustomerRating:"FieldMeta",
		customerRatings:"FieldMeta",
		preferredQuantityUnit:"FieldMeta",
		freshingContainer:"FieldMeta",
		image:"FieldMeta",
		suppliers:"FieldMeta",
		incrementQuantityNumber:"FieldMeta"
	},
	ProductIngredientCategory:{
		_meta:"ProductIngredientCategoryMeta",
		id:"UUID",
		internalName:"String",
		internalNote:"String",
		ingredients:"ProductIngredient",
		locales:"ProductIngredientCategoryLocale",
		order:"Int",
		localesByLocale:"ProductIngredientCategoryLocale",
		paginateIngredients:"ProductIngredientConnection",
		paginateLocales:"ProductIngredientCategoryLocaleConnection"
	},
	ProductIngredientCategoryMeta:{
		id:"FieldMeta",
		internalName:"FieldMeta",
		internalNote:"FieldMeta",
		ingredients:"FieldMeta",
		locales:"FieldMeta",
		order:"FieldMeta"
	},
	ProductIngredientCategoryLocale:{
		_meta:"ProductIngredientCategoryLocaleMeta",
		id:"UUID",
		name:"String",
		root:"ProductIngredientCategory",
		locale:"Locale"
	},
	ProductIngredientCategoryLocaleMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta"
	},
	ProductIngredientConnection:{
		pageInfo:"PageInfo",
		edges:"ProductIngredientEdge"
	},
	ProductIngredientEdge:{
		node:"ProductIngredient"
	},
	ProductIngredientCategoryLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"ProductIngredientCategoryLocaleEdge"
	},
	ProductIngredientCategoryLocaleEdge:{
		node:"ProductIngredientCategoryLocale"
	},
	Allergen:{
		_meta:"AllergenMeta",
		id:"UUID",
		internalName:"String",
		locales:"AllergenLocale",
		ingredients:"ProductIngredient",
		code:"Int",
		localesByLocale:"AllergenLocale",
		paginateLocales:"AllergenLocaleConnection",
		paginateIngredients:"ProductIngredientConnection"
	},
	AllergenMeta:{
		id:"FieldMeta",
		internalName:"FieldMeta",
		locales:"FieldMeta",
		ingredients:"FieldMeta",
		code:"FieldMeta"
	},
	AllergenLocale:{
		_meta:"AllergenLocaleMeta",
		id:"UUID",
		name:"String",
		root:"Allergen",
		locale:"Locale"
	},
	AllergenLocaleMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta"
	},
	AllergenLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"AllergenLocaleEdge"
	},
	AllergenLocaleEdge:{
		node:"AllergenLocale"
	},
	CustomerIngredientRating:{
		_meta:"CustomerIngredientRatingMeta",
		id:"UUID",
		customer:"Customer",
		rating:"ProductIngredientRating",
		ingredient:"ProductIngredient"
	},
	CustomerIngredientRatingMeta:{
		id:"FieldMeta",
		customer:"FieldMeta",
		rating:"FieldMeta",
		ingredient:"FieldMeta"
	},
	ProductIngredientRating:{
		_meta:"ProductIngredientRatingMeta",
		id:"UUID",
		order:"Int",
		name:"String",
		icon:"Image"
	},
	ProductIngredientRatingMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		name:"FieldMeta",
		icon:"FieldMeta"
	},
	ProductIngredientItemQuantityUnit:{
		_meta:"ProductIngredientItemQuantityUnitMeta",
		id:"UUID",
		name:"String"
	},
	ProductIngredientItemQuantityUnitMeta:{
		id:"FieldMeta",
		name:"FieldMeta"
	},
	FreshingContainer:{
		_meta:"FreshingContainerMeta",
		id:"UUID",
		order:"Int",
		volumeMl:"Int",
		workspace:"Workspace"
	},
	FreshingContainerMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		volumeMl:"FieldMeta",
		workspace:"FieldMeta"
	},
	Workspace:{
		_meta:"WorkspaceMeta",
		id:"UUID",
		unique:"One",
		orderDeadlineTime:"String",
		ordersLoadingDurationHours:"Int",
		freshingContainerVolumeMl:"Int",
		freshingPrepareOrderByOffsetMinutes:"Int",
		checkoutUrlTemplate:"String",
		orderUrlTemplate:"String",
		paymentUrlTemplate:"String",
		customerProfileUrlTemplate:"String",
		userProfileUrlTemplate:"String",
		messengerUrl:"String",
		messengerIosUrl:"String",
		messengerAndroidUrl:"String",
		freshingContainers:"FreshingContainer",
		openingHours:"WeekHours",
		workingHours:"WeekHours",
		defaultFreshingContainer:"FreshingContainer",
		creditsProduct:"VirtualProduct",
		discountVatRate:"VatRate",
		name:"String",
		businessAddress:"String",
		paginateFreshingContainers:"FreshingContainerConnection"
	},
	WorkspaceMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		orderDeadlineTime:"FieldMeta",
		ordersLoadingDurationHours:"FieldMeta",
		freshingContainerVolumeMl:"FieldMeta",
		freshingPrepareOrderByOffsetMinutes:"FieldMeta",
		checkoutUrlTemplate:"FieldMeta",
		orderUrlTemplate:"FieldMeta",
		paymentUrlTemplate:"FieldMeta",
		customerProfileUrlTemplate:"FieldMeta",
		userProfileUrlTemplate:"FieldMeta",
		messengerUrl:"FieldMeta",
		messengerIosUrl:"FieldMeta",
		messengerAndroidUrl:"FieldMeta",
		freshingContainers:"FieldMeta",
		openingHours:"FieldMeta",
		workingHours:"FieldMeta",
		defaultFreshingContainer:"FieldMeta",
		creditsProduct:"FieldMeta",
		discountVatRate:"FieldMeta",
		name:"FieldMeta",
		businessAddress:"FieldMeta"
	},
	WeekHours:{
		_meta:"WeekHoursMeta",
		id:"UUID",
		mon:"String",
		tue:"String",
		wed:"String",
		thu:"String",
		fri:"String",
		sat:"String",
		sun:"String"
	},
	WeekHoursMeta:{
		id:"FieldMeta",
		mon:"FieldMeta",
		tue:"FieldMeta",
		wed:"FieldMeta",
		thu:"FieldMeta",
		fri:"FieldMeta",
		sat:"FieldMeta",
		sun:"FieldMeta"
	},
	VirtualProduct:{
		_meta:"VirtualProductMeta",
		id:"UUID",
		type:"VirtualProductType",
		product:"Product",
		voucherCreditCents:"Int",
		physicalRepresentation:"VirtualProductPhysicalRepresentationType",
		recipientEmail:"Boolean"
	},
	VirtualProductMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		product:"FieldMeta",
		voucherCreditCents:"FieldMeta",
		physicalRepresentation:"FieldMeta",
		recipientEmail:"FieldMeta"
	},
	FreshingContainerConnection:{
		pageInfo:"PageInfo",
		edges:"FreshingContainerEdge"
	},
	FreshingContainerEdge:{
		node:"FreshingContainer"
	},
	IngredientSupplierList:{
		_meta:"IngredientSupplierListMeta",
		id:"UUID",
		items:"IngredientSupplierItem",
		paginateItems:"IngredientSupplierItemConnection"
	},
	IngredientSupplierListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	IngredientSupplierItem:{
		_meta:"IngredientSupplierItemMeta",
		id:"UUID",
		order:"Int",
		list:"IngredientSupplierList",
		supplier:"IngredientSupplier"
	},
	IngredientSupplierItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		supplier:"FieldMeta"
	},
	IngredientSupplier:{
		_meta:"IngredientSupplierMeta",
		id:"UUID",
		internalName:"String",
		internalNote:"String",
		locales:"IngredientSupplierLocale",
		localesByLocale:"IngredientSupplierLocale",
		paginateLocales:"IngredientSupplierLocaleConnection"
	},
	IngredientSupplierMeta:{
		id:"FieldMeta",
		internalName:"FieldMeta",
		internalNote:"FieldMeta",
		locales:"FieldMeta"
	},
	IngredientSupplierLocale:{
		_meta:"IngredientSupplierLocaleMeta",
		id:"UUID",
		name:"String",
		root:"IngredientSupplier",
		locale:"Locale"
	},
	IngredientSupplierLocaleMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta"
	},
	IngredientSupplierLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"IngredientSupplierLocaleEdge"
	},
	IngredientSupplierLocaleEdge:{
		node:"IngredientSupplierLocale"
	},
	IngredientSupplierItemConnection:{
		pageInfo:"PageInfo",
		edges:"IngredientSupplierItemEdge"
	},
	IngredientSupplierItemEdge:{
		node:"IngredientSupplierItem"
	},
	ProductIngredientLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"ProductIngredientLocaleEdge"
	},
	ProductIngredientLocaleEdge:{
		node:"ProductIngredientLocale"
	},
	ProductIngredientCategoryConnection:{
		pageInfo:"PageInfo",
		edges:"ProductIngredientCategoryEdge"
	},
	ProductIngredientCategoryEdge:{
		node:"ProductIngredientCategory"
	},
	AllergenConnection:{
		pageInfo:"PageInfo",
		edges:"AllergenEdge"
	},
	AllergenEdge:{
		node:"Allergen"
	},
	CustomerIngredientRatingConnection:{
		pageInfo:"PageInfo",
		edges:"CustomerIngredientRatingEdge"
	},
	CustomerIngredientRatingEdge:{
		node:"CustomerIngredientRating"
	},
	BlogLocale:{
		_meta:"BlogLocaleMeta",
		id:"UUID",
		pageName:"String",
		title:"String",
		lead:"String",
		root:"Blog",
		locale:"Locale"
	},
	BlogLocaleMeta:{
		id:"FieldMeta",
		pageName:"FieldMeta",
		title:"FieldMeta",
		lead:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta"
	},
	Blog:{
		_meta:"BlogMeta",
		id:"UUID",
		unique:"One",
		locales:"BlogLocale",
		localesByLocale:"BlogLocale",
		paginateLocales:"BlogLocaleConnection"
	},
	BlogMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		locales:"FieldMeta"
	},
	BlogLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"BlogLocaleEdge"
	},
	BlogLocaleEdge:{
		node:"BlogLocale"
	},
	BlogPostLocale:{
		_meta:"BlogPostLocaleMeta",
		id:"UUID",
		title:"String",
		availableForWeb:"Boolean",
		availableForMobile:"Boolean",
		root:"BlogPost",
		locale:"Locale",
		cover:"Cover",
		content:"Content",
		link:"Linkable",
		seo:"Seo",
		products:"Product",
		paginateProducts:"ProductConnection"
	},
	BlogPostLocaleMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		availableForWeb:"FieldMeta",
		availableForMobile:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		cover:"FieldMeta",
		content:"FieldMeta",
		link:"FieldMeta",
		seo:"FieldMeta",
		products:"FieldMeta"
	},
	BlogPost:{
		_meta:"BlogPostMeta",
		id:"UUID",
		order:"Int",
		locales:"BlogPostLocale",
		localesByLocale:"BlogPostLocale",
		localesByCover:"BlogPostLocale",
		localesByContent:"BlogPostLocale",
		localesByLink:"BlogPostLocale",
		localesBySeo:"BlogPostLocale",
		paginateLocales:"BlogPostLocaleConnection"
	},
	BlogPostMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		locales:"FieldMeta"
	},
	BlogPostLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"BlogPostLocaleEdge"
	},
	BlogPostLocaleEdge:{
		node:"BlogPostLocale"
	},
	Cover:{
		_meta:"CoverMeta",
		id:"UUID",
		primaryTitle:"String",
		secondaryTitle:"String",
		medium:"Medium",
		buttonColors:"ColorPallete"
	},
	CoverMeta:{
		id:"FieldMeta",
		primaryTitle:"FieldMeta",
		secondaryTitle:"FieldMeta",
		medium:"FieldMeta",
		buttonColors:"FieldMeta"
	},
	Medium:{
		_meta:"MediumMeta",
		id:"UUID",
		type:"MediumType",
		colorTheme:"ColorTheme",
		image:"Image",
		video:"Video"
	},
	MediumMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		colorTheme:"FieldMeta",
		image:"FieldMeta",
		video:"FieldMeta"
	},
	Video:{
		_meta:"VideoMeta",
		id:"UUID",
		src:"String",
		width:"Int",
		height:"Int",
		size:"Int",
		type:"String",
		duration:"Float",
		poster:"Image"
	},
	VideoMeta:{
		id:"FieldMeta",
		src:"FieldMeta",
		width:"FieldMeta",
		height:"FieldMeta",
		size:"FieldMeta",
		type:"FieldMeta",
		duration:"FieldMeta",
		poster:"FieldMeta"
	},
	ColorPallete:{
		_meta:"ColorPalleteMeta",
		id:"UUID",
		background:"String",
		text:"String"
	},
	ColorPalleteMeta:{
		id:"FieldMeta",
		background:"FieldMeta",
		text:"FieldMeta"
	},
	Content:{
		_meta:"ContentMeta",
		id:"UUID",
		blocks:"ContentBlock",
		blocksByReferences:"ContentBlock",
		paginateBlocks:"ContentBlockConnection"
	},
	ContentMeta:{
		id:"FieldMeta",
		blocks:"FieldMeta"
	},
	ContentBlock:{
		_meta:"ContentBlockMeta",
		id:"UUID",
		order:"Int",
		json:"String",
		content:"Content",
		references:"ContentReference",
		referencesByProducts:"ContentReference",
		referencesByProductBanners:"ContentReference",
		referencesByDeliveryRegions:"ContentReference",
		paginateReferences:"ContentReferenceConnection"
	},
	ContentBlockMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		json:"FieldMeta",
		content:"FieldMeta",
		references:"FieldMeta"
	},
	ContentReference:{
		_meta:"ContentReferenceMeta",
		id:"UUID",
		type:"ContentReferenceType",
		primaryText:"String",
		secondaryText:"String",
		jsonContent:"String",
		block:"ContentBlock",
		colorPallete:"ColorPallete",
		medium:"Medium",
		link:"Link",
		blogPosts:"BlogPostList",
		links:"LinkList",
		products:"ProductList",
		contentSize:"ContentSize",
		misc:"String",
		hero:"Hero",
		gallery:"Gallery",
		socialsAndApps:"SocialsAndApps",
		productGrid:"ProductGrid",
		productBanners:"ProductBannerList",
		deliveryRegions:"DeliveryRegions",
		textList:"TextList",
		gridTiles:"GridTiles"
	},
	ContentReferenceMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		primaryText:"FieldMeta",
		secondaryText:"FieldMeta",
		jsonContent:"FieldMeta",
		block:"FieldMeta",
		colorPallete:"FieldMeta",
		medium:"FieldMeta",
		link:"FieldMeta",
		blogPosts:"FieldMeta",
		links:"FieldMeta",
		products:"FieldMeta",
		contentSize:"FieldMeta",
		misc:"FieldMeta",
		hero:"FieldMeta",
		gallery:"FieldMeta",
		socialsAndApps:"FieldMeta",
		productGrid:"FieldMeta",
		productBanners:"FieldMeta",
		deliveryRegions:"FieldMeta",
		textList:"FieldMeta",
		gridTiles:"FieldMeta"
	},
	Link:{
		_meta:"LinkMeta",
		id:"UUID",
		type:"LinkType",
		title:"String",
		externalLink:"String",
		internalLink:"Linkable"
	},
	LinkMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		title:"FieldMeta",
		externalLink:"FieldMeta",
		internalLink:"FieldMeta"
	},
	Linkable:{
		_meta:"LinkableMeta",
		id:"UUID",
		url:"String",
		blogPost:"BlogPostLocale",
		page:"PageLocale",
		wikiPage:"WikiPage",
		redirect:"Redirect"
	},
	LinkableMeta:{
		id:"FieldMeta",
		url:"FieldMeta",
		blogPost:"FieldMeta",
		page:"FieldMeta",
		wikiPage:"FieldMeta",
		redirect:"FieldMeta"
	},
	PageLocale:{
		_meta:"PageLocaleMeta",
		id:"UUID",
		title:"String",
		link:"Linkable",
		root:"Page",
		locale:"Locale",
		seo:"Seo",
		content:"Content",
		cover:"Cover",
		theme:"PageTheme"
	},
	PageLocaleMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		link:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		seo:"FieldMeta",
		content:"FieldMeta",
		cover:"FieldMeta",
		theme:"FieldMeta"
	},
	Page:{
		_meta:"PageMeta",
		id:"UUID",
		locales:"PageLocale",
		localesByLocale:"PageLocale",
		localesByLink:"PageLocale",
		localesBySeo:"PageLocale",
		localesByContent:"PageLocale",
		localesByCover:"PageLocale",
		paginateLocales:"PageLocaleConnection"
	},
	PageMeta:{
		id:"FieldMeta",
		locales:"FieldMeta"
	},
	PageLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"PageLocaleEdge"
	},
	PageLocaleEdge:{
		node:"PageLocale"
	},
	Seo:{
		_meta:"SeoMeta",
		id:"UUID",
		title:"String",
		description:"String",
		ogTitle:"String",
		ogDescription:"String",
		ogImage:"Image"
	},
	SeoMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		description:"FieldMeta",
		ogTitle:"FieldMeta",
		ogDescription:"FieldMeta",
		ogImage:"FieldMeta"
	},
	WikiPage:{
		_meta:"WikiPageMeta",
		id:"UUID",
		order:"Int",
		title:"String",
		emoji:"String",
		link:"Linkable",
		parent:"WikiPage",
		children:"WikiPage",
		content:"Content",
		childrenByLink:"WikiPage",
		childrenByChildren:"WikiPage",
		childrenByContent:"WikiPage",
		paginateChildren:"WikiPageConnection"
	},
	WikiPageMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		title:"FieldMeta",
		emoji:"FieldMeta",
		link:"FieldMeta",
		parent:"FieldMeta",
		children:"FieldMeta",
		content:"FieldMeta"
	},
	WikiPageConnection:{
		pageInfo:"PageInfo",
		edges:"WikiPageEdge"
	},
	WikiPageEdge:{
		node:"WikiPage"
	},
	Redirect:{
		_meta:"RedirectMeta",
		id:"UUID",
		link:"Linkable",
		target:"Link"
	},
	RedirectMeta:{
		id:"FieldMeta",
		link:"FieldMeta",
		target:"FieldMeta"
	},
	BlogPostList:{
		_meta:"BlogPostListMeta",
		id:"UUID",
		items:"BlogPostListItem",
		paginateItems:"BlogPostListItemConnection"
	},
	BlogPostListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	BlogPostListItem:{
		_meta:"BlogPostListItemMeta",
		id:"UUID",
		order:"Int",
		caption:"String",
		list:"BlogPostList",
		blogPost:"BlogPostLocale"
	},
	BlogPostListItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		caption:"FieldMeta",
		list:"FieldMeta",
		blogPost:"FieldMeta"
	},
	BlogPostListItemConnection:{
		pageInfo:"PageInfo",
		edges:"BlogPostListItemEdge"
	},
	BlogPostListItemEdge:{
		node:"BlogPostListItem"
	},
	LinkList:{
		_meta:"LinkListMeta",
		id:"UUID",
		items:"LinkListItem",
		paginateItems:"LinkListItemConnection"
	},
	LinkListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	LinkListItem:{
		_meta:"LinkListItemMeta",
		id:"UUID",
		order:"Int",
		isPrimary:"Boolean",
		list:"LinkList",
		link:"Link"
	},
	LinkListItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		isPrimary:"FieldMeta",
		list:"FieldMeta",
		link:"FieldMeta"
	},
	LinkListItemConnection:{
		pageInfo:"PageInfo",
		edges:"LinkListItemEdge"
	},
	LinkListItemEdge:{
		node:"LinkListItem"
	},
	Hero:{
		_meta:"HeroMeta",
		id:"UUID",
		showLogo:"Boolean",
		middleContent:"String",
		medium:"Medium"
	},
	HeroMeta:{
		id:"FieldMeta",
		showLogo:"FieldMeta",
		middleContent:"FieldMeta",
		medium:"FieldMeta"
	},
	Gallery:{
		_meta:"GalleryMeta",
		id:"UUID",
		items:"GalleryItem",
		paginateItems:"GalleryItemConnection"
	},
	GalleryMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	GalleryItem:{
		_meta:"GalleryItemMeta",
		id:"UUID",
		order:"Int",
		caption:"String",
		list:"Gallery",
		medium:"Medium"
	},
	GalleryItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		caption:"FieldMeta",
		list:"FieldMeta",
		medium:"FieldMeta"
	},
	GalleryItemConnection:{
		pageInfo:"PageInfo",
		edges:"GalleryItemEdge"
	},
	GalleryItemEdge:{
		node:"GalleryItem"
	},
	SocialsAndApps:{
		_meta:"SocialsAndAppsMeta",
		id:"UUID",
		instagram:"Boolean",
		appStore:"Boolean",
		googlePlay:"Boolean"
	},
	SocialsAndAppsMeta:{
		id:"FieldMeta",
		instagram:"FieldMeta",
		appStore:"FieldMeta",
		googlePlay:"FieldMeta"
	},
	ProductGrid:{
		_meta:"ProductGridMeta",
		id:"UUID",
		isCarousel:"Boolean",
		categories:"ProductGridCategory",
		type:"ProductGridType",
		categoriesByItems:"ProductGridCategory",
		categoriesByImages:"ProductGridCategory",
		paginateCategories:"ProductGridCategoryConnection"
	},
	ProductGridMeta:{
		id:"FieldMeta",
		isCarousel:"FieldMeta",
		categories:"FieldMeta",
		type:"FieldMeta"
	},
	ProductGridCategory:{
		_meta:"ProductGridCategoryMeta",
		id:"UUID",
		order:"Int",
		title:"String",
		root:"ProductGrid",
		items:"ProductGridItem",
		images:"ImageList",
		paginateItems:"ProductGridItemConnection"
	},
	ProductGridCategoryMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		title:"FieldMeta",
		root:"FieldMeta",
		items:"FieldMeta",
		images:"FieldMeta"
	},
	ProductGridItem:{
		_meta:"ProductGridItemMeta",
		id:"UUID",
		order:"Int",
		title:"String",
		lead:"String",
		product:"Product",
		medium:"Medium",
		link:"Link",
		category:"ProductGridCategory",
		description:"String"
	},
	ProductGridItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		title:"FieldMeta",
		lead:"FieldMeta",
		product:"FieldMeta",
		medium:"FieldMeta",
		link:"FieldMeta",
		category:"FieldMeta",
		description:"FieldMeta"
	},
	ImageList:{
		_meta:"ImageListMeta",
		id:"UUID",
		items:"ImageListItem",
		itemsByImage:"ImageListItem",
		paginateItems:"ImageListItemConnection"
	},
	ImageListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	ImageListItem:{
		_meta:"ImageListItemMeta",
		id:"UUID",
		order:"Int",
		list:"ImageList",
		image:"Image"
	},
	ImageListItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		image:"FieldMeta"
	},
	ImageListItemConnection:{
		pageInfo:"PageInfo",
		edges:"ImageListItemEdge"
	},
	ImageListItemEdge:{
		node:"ImageListItem"
	},
	ProductGridItemConnection:{
		pageInfo:"PageInfo",
		edges:"ProductGridItemEdge"
	},
	ProductGridItemEdge:{
		node:"ProductGridItem"
	},
	ProductGridCategoryConnection:{
		pageInfo:"PageInfo",
		edges:"ProductGridCategoryEdge"
	},
	ProductGridCategoryEdge:{
		node:"ProductGridCategory"
	},
	ProductBannerList:{
		_meta:"ProductBannerListMeta",
		id:"UUID",
		items:"ProductBannerItem",
		paginateItems:"ProductBannerItemConnection"
	},
	ProductBannerListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	ProductBannerItem:{
		_meta:"ProductBannerItemMeta",
		id:"UUID",
		order:"Int",
		list:"ProductBannerList",
		banner:"ProductBanner",
		size:"ProductBannerItemSize"
	},
	ProductBannerItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		banner:"FieldMeta",
		size:"FieldMeta"
	},
	ProductBanner:{
		_meta:"ProductBannerMeta",
		id:"UUID",
		beforeTitle:"String",
		title:"String",
		label:"String",
		button:"Link",
		backgroundImage:"Image",
		productImage:"Image",
		product:"Product"
	},
	ProductBannerMeta:{
		id:"FieldMeta",
		beforeTitle:"FieldMeta",
		title:"FieldMeta",
		label:"FieldMeta",
		button:"FieldMeta",
		backgroundImage:"FieldMeta",
		productImage:"FieldMeta",
		product:"FieldMeta"
	},
	ProductBannerItemConnection:{
		pageInfo:"PageInfo",
		edges:"ProductBannerItemEdge"
	},
	ProductBannerItemEdge:{
		node:"ProductBannerItem"
	},
	DeliveryRegions:{
		_meta:"DeliveryRegionsMeta",
		id:"UUID",
		items:"DeliveryRegionsItem",
		itemsByImage:"DeliveryRegionsItem",
		itemsByTextList:"DeliveryRegionsItem",
		itemsByGallery:"DeliveryRegionsItem",
		paginateItems:"DeliveryRegionsItemConnection"
	},
	DeliveryRegionsMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	DeliveryRegionsItem:{
		_meta:"DeliveryRegionsItemMeta",
		id:"UUID",
		order:"Int",
		title:"String",
		offerLabel:"String",
		list:"DeliveryRegions",
		image:"Image",
		textList:"TextList",
		gallery:"ImageList"
	},
	DeliveryRegionsItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		title:"FieldMeta",
		offerLabel:"FieldMeta",
		list:"FieldMeta",
		image:"FieldMeta",
		textList:"FieldMeta",
		gallery:"FieldMeta"
	},
	TextList:{
		_meta:"TextListMeta",
		id:"UUID",
		items:"TextItem",
		paginateItems:"TextItemConnection"
	},
	TextListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	TextItem:{
		_meta:"TextItemMeta",
		id:"UUID",
		order:"Int",
		text:"String",
		list:"TextList",
		title:"String"
	},
	TextItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		text:"FieldMeta",
		list:"FieldMeta",
		title:"FieldMeta"
	},
	TextItemConnection:{
		pageInfo:"PageInfo",
		edges:"TextItemEdge"
	},
	TextItemEdge:{
		node:"TextItem"
	},
	DeliveryRegionsItemConnection:{
		pageInfo:"PageInfo",
		edges:"DeliveryRegionsItemEdge"
	},
	DeliveryRegionsItemEdge:{
		node:"DeliveryRegionsItem"
	},
	GridTiles:{
		_meta:"GridTilesMeta",
		id:"UUID",
		items:"GridTileItem",
		itemsByLink:"GridTileItem",
		paginateItems:"GridTileItemConnection"
	},
	GridTilesMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	GridTileItem:{
		_meta:"GridTileItemMeta",
		id:"UUID",
		order:"Int",
		text:"String",
		list:"GridTiles",
		medium:"Medium",
		link:"Link"
	},
	GridTileItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		text:"FieldMeta",
		list:"FieldMeta",
		medium:"FieldMeta",
		link:"FieldMeta"
	},
	GridTileItemConnection:{
		pageInfo:"PageInfo",
		edges:"GridTileItemEdge"
	},
	GridTileItemEdge:{
		node:"GridTileItem"
	},
	ContentReferenceConnection:{
		pageInfo:"PageInfo",
		edges:"ContentReferenceEdge"
	},
	ContentReferenceEdge:{
		node:"ContentReference"
	},
	ContentBlockConnection:{
		pageInfo:"PageInfo",
		edges:"ContentBlockEdge"
	},
	ContentBlockEdge:{
		node:"ContentBlock"
	},
	TranslationCataloguesIdentifier:{
		_meta:"TranslationCataloguesIdentifierMeta",
		id:"UUID",
		name:"String",
		code:"String",
		catalogue:"TranslationCatalogue",
		catalogueByDomain:"TranslationCatalogue",
		catalogueByValues:"TranslationCatalogue",
		paginateCatalogue:"TranslationCatalogueConnection"
	},
	TranslationCataloguesIdentifierMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		code:"FieldMeta",
		catalogue:"FieldMeta"
	},
	TranslationCatalogue:{
		_meta:"TranslationCatalogueMeta",
		id:"UUID",
		domain:"TranslationDomain",
		fallback:"TranslationCatalogue",
		values:"TranslationValue",
		identifier:"TranslationCataloguesIdentifier",
		valuesByKey:"TranslationValue",
		paginateValues:"TranslationValueConnection"
	},
	TranslationCatalogueMeta:{
		id:"FieldMeta",
		domain:"FieldMeta",
		fallback:"FieldMeta",
		values:"FieldMeta",
		identifier:"FieldMeta"
	},
	TranslationDomain:{
		_meta:"TranslationDomainMeta",
		id:"UUID",
		identifier:"String",
		name:"String",
		catalogues:"TranslationCatalogue",
		keys:"TranslationKey",
		cataloguesByIdentifier:"TranslationCatalogue",
		cataloguesByValues:"TranslationCatalogue",
		keysByIdentifier:"TranslationKey",
		keysByValues:"TranslationKey",
		paginateCatalogues:"TranslationCatalogueConnection",
		paginateKeys:"TranslationKeyConnection"
	},
	TranslationDomainMeta:{
		id:"FieldMeta",
		identifier:"FieldMeta",
		name:"FieldMeta",
		catalogues:"FieldMeta",
		keys:"FieldMeta"
	},
	TranslationKey:{
		_meta:"TranslationKeyMeta",
		id:"UUID",
		identifier:"String",
		contentType:"TranslationContentType",
		note:"String",
		domain:"TranslationDomain",
		values:"TranslationValue",
		valuesByCatalogue:"TranslationValue",
		paginateValues:"TranslationValueConnection"
	},
	TranslationKeyMeta:{
		id:"FieldMeta",
		identifier:"FieldMeta",
		contentType:"FieldMeta",
		note:"FieldMeta",
		domain:"FieldMeta",
		values:"FieldMeta"
	},
	TranslationValue:{
		_meta:"TranslationValueMeta",
		id:"UUID",
		value:"String",
		catalogue:"TranslationCatalogue",
		key:"TranslationKey"
	},
	TranslationValueMeta:{
		id:"FieldMeta",
		value:"FieldMeta",
		catalogue:"FieldMeta",
		key:"FieldMeta"
	},
	TranslationValueConnection:{
		pageInfo:"PageInfo",
		edges:"TranslationValueEdge"
	},
	TranslationValueEdge:{
		node:"TranslationValue"
	},
	TranslationCatalogueConnection:{
		pageInfo:"PageInfo",
		edges:"TranslationCatalogueEdge"
	},
	TranslationCatalogueEdge:{
		node:"TranslationCatalogue"
	},
	TranslationKeyConnection:{
		pageInfo:"PageInfo",
		edges:"TranslationKeyEdge"
	},
	TranslationKeyEdge:{
		node:"TranslationKey"
	},
	MenuLocale:{
		_meta:"MenuLocaleMeta",
		id:"UUID",
		root:"SiteMenu",
		locale:"Locale",
		items:"MenuItem",
		secondaryItems:"LinkList",
		eshopLink:"Link",
		itemsBySubitems:"MenuItem",
		paginateItems:"MenuItemConnection"
	},
	MenuLocaleMeta:{
		id:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		items:"FieldMeta",
		secondaryItems:"FieldMeta",
		eshopLink:"FieldMeta"
	},
	SiteMenu:{
		_meta:"SiteMenuMeta",
		id:"UUID",
		unique:"One",
		locales:"MenuLocale",
		localesByLocale:"MenuLocale",
		localesByItems:"MenuLocale",
		localesBySecondaryItems:"MenuLocale",
		paginateLocales:"MenuLocaleConnection"
	},
	SiteMenuMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		locales:"FieldMeta"
	},
	MenuLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"MenuLocaleEdge"
	},
	MenuLocaleEdge:{
		node:"MenuLocale"
	},
	MenuItem:{
		_meta:"MenuItemMeta",
		id:"UUID",
		order:"Int",
		menu:"MenuLocale",
		link:"Link",
		subitems:"MenuSubitem",
		paginateSubitems:"MenuSubitemConnection"
	},
	MenuItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		menu:"FieldMeta",
		link:"FieldMeta",
		subitems:"FieldMeta"
	},
	MenuSubitem:{
		_meta:"MenuSubitemMeta",
		id:"UUID",
		type:"MenuSubitemType",
		title:"String",
		item:"MenuItem",
		links:"MenuLinkList",
		products:"MenuProducts",
		delivery:"MenuDelivery",
		contact:"MenuContact",
		order:"Int"
	},
	MenuSubitemMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		title:"FieldMeta",
		item:"FieldMeta",
		links:"FieldMeta",
		products:"FieldMeta",
		delivery:"FieldMeta",
		contact:"FieldMeta",
		order:"FieldMeta"
	},
	MenuLinkList:{
		_meta:"MenuLinkListMeta",
		id:"UUID",
		items:"MenuLinkItem",
		paginateItems:"MenuLinkItemConnection"
	},
	MenuLinkListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	MenuLinkItem:{
		_meta:"MenuLinkItemMeta",
		id:"UUID",
		order:"Int",
		list:"MenuLinkList",
		link:"Link",
		image:"Image",
		description:"String"
	},
	MenuLinkItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		link:"FieldMeta",
		image:"FieldMeta",
		description:"FieldMeta"
	},
	MenuLinkItemConnection:{
		pageInfo:"PageInfo",
		edges:"MenuLinkItemEdge"
	},
	MenuLinkItemEdge:{
		node:"MenuLinkItem"
	},
	MenuProducts:{
		_meta:"MenuProductsMeta",
		id:"UUID",
		links:"MenuLinkList",
		buttons:"LinkList"
	},
	MenuProductsMeta:{
		id:"FieldMeta",
		links:"FieldMeta",
		buttons:"FieldMeta"
	},
	MenuDelivery:{
		_meta:"MenuDeliveryMeta",
		id:"UUID",
		deliveryRegions:"DeliveryRegions",
		text:"String",
		socialsAndApps:"SocialsAndApps"
	},
	MenuDeliveryMeta:{
		id:"FieldMeta",
		deliveryRegions:"FieldMeta",
		text:"FieldMeta",
		socialsAndApps:"FieldMeta"
	},
	MenuContact:{
		_meta:"MenuContactMeta",
		id:"UUID",
		text:"String",
		image:"Image"
	},
	MenuContactMeta:{
		id:"FieldMeta",
		text:"FieldMeta",
		image:"FieldMeta"
	},
	MenuSubitemConnection:{
		pageInfo:"PageInfo",
		edges:"MenuSubitemEdge"
	},
	MenuSubitemEdge:{
		node:"MenuSubitem"
	},
	MenuItemConnection:{
		pageInfo:"PageInfo",
		edges:"MenuItemEdge"
	},
	MenuItemEdge:{
		node:"MenuItem"
	},
	ProductLocale:{
		_meta:"ProductLocaleMeta",
		id:"UUID",
		name:"String",
		description:"String",
		root:"Product",
		locale:"Locale",
		featureList:"TextList",
		printableName:"String",
		firstSticker:"String",
		secondSticker:"String"
	},
	ProductLocaleMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		description:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		featureList:"FieldMeta",
		printableName:"FieldMeta",
		firstSticker:"FieldMeta",
		secondSticker:"FieldMeta"
	},
	ProductRecipeLocale:{
		_meta:"ProductRecipeLocaleMeta",
		id:"UUID",
		name:"String",
		root:"ProductRecipe",
		locale:"Locale",
		description:"String"
	},
	ProductRecipeLocaleMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		description:"FieldMeta"
	},
	ProductRecipe:{
		_meta:"ProductRecipeMeta",
		id:"UUID",
		name:"String",
		products:"Product",
		internalNote:"String",
		color:"String",
		image:"Image",
		icon:"Image",
		ingredients:"ProductIngredientItem",
		needsPrepping:"Boolean",
		locales:"ProductRecipeLocale",
		gutTuning:"Float",
		freshingContainer:"FreshingContainer",
		description:"String",
		nutritionFacts:"NutritionFacts",
		productsByCode:"Product",
		productsByStocks:"Product",
		productsByGroupPrices:"Product",
		productsByCartItems:"Product",
		productsByOrderItems:"Product",
		productsByInheritedCategories:"Product",
		productsByLocales:"Product",
		productsByCustomerPrices:"Product",
		productsByVirtualProduct:"Product",
		productsByMeta:"Product",
		productsByPage:"Product",
		productsBySalesDays:"Product",
		productsBySalesWeeks:"Product",
		productsBySalesMonths:"Product",
		ingredientsByQuantity:"ProductIngredientItem",
		localesByLocale:"ProductRecipeLocale",
		paginateProducts:"ProductConnection",
		paginateIngredients:"ProductIngredientItemConnection",
		paginateLocales:"ProductRecipeLocaleConnection"
	},
	ProductRecipeMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		products:"FieldMeta",
		internalNote:"FieldMeta",
		color:"FieldMeta",
		image:"FieldMeta",
		icon:"FieldMeta",
		ingredients:"FieldMeta",
		needsPrepping:"FieldMeta",
		locales:"FieldMeta",
		gutTuning:"FieldMeta",
		freshingContainer:"FieldMeta",
		description:"FieldMeta",
		nutritionFacts:"FieldMeta"
	},
	ProductIngredientItem:{
		_meta:"ProductIngredientItemMeta",
		id:"UUID",
		order:"Int",
		internalOrder:"Int",
		recipe:"ProductRecipe",
		ingredient:"ProductIngredient",
		quantity:"ProductIngredientItemQuantity"
	},
	ProductIngredientItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		internalOrder:"FieldMeta",
		recipe:"FieldMeta",
		ingredient:"FieldMeta",
		quantity:"FieldMeta"
	},
	ProductIngredientItemQuantity:{
		_meta:"ProductIngredientItemQuantityMeta",
		id:"UUID",
		unit:"ProductIngredientItemQuantityUnit",
		value:"Float"
	},
	ProductIngredientItemQuantityMeta:{
		id:"FieldMeta",
		unit:"FieldMeta",
		value:"FieldMeta"
	},
	NutritionFacts:{
		_meta:"NutritionFactsMeta",
		id:"UUID",
		energyKiloJoule:"Float",
		energyKiloCalorie:"Float",
		fatsGrams:"Float",
		fatsOfWhichSaturatedGrams:"Float",
		carbohydrateGrams:"Float",
		carbohydrateOfWhichSugarsGrams:"Float",
		proteinGrams:"Float",
		fibreGrams:"Float",
		saltGrams:"Float"
	},
	NutritionFactsMeta:{
		id:"FieldMeta",
		energyKiloJoule:"FieldMeta",
		energyKiloCalorie:"FieldMeta",
		fatsGrams:"FieldMeta",
		fatsOfWhichSaturatedGrams:"FieldMeta",
		carbohydrateGrams:"FieldMeta",
		carbohydrateOfWhichSugarsGrams:"FieldMeta",
		proteinGrams:"FieldMeta",
		fibreGrams:"FieldMeta",
		saltGrams:"FieldMeta"
	},
	ProductIngredientItemConnection:{
		pageInfo:"PageInfo",
		edges:"ProductIngredientItemEdge"
	},
	ProductIngredientItemEdge:{
		node:"ProductIngredientItem"
	},
	ProductRecipeLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"ProductRecipeLocaleEdge"
	},
	ProductRecipeLocaleEdge:{
		node:"ProductRecipeLocale"
	},
	DeliveryMethodLocale:{
		_meta:"DeliveryMethodLocaleMeta",
		id:"UUID",
		name:"String",
		description:"String",
		trackingCodeUrlTemplate:"String",
		processingTitle:"String",
		processingText:"String",
		processingIconUrl:"String",
		dispatchedTitle:"String",
		dispatchedText:"String",
		dispatchedIconUrl:"String",
		fulfilledTitle:"String",
		fulfilledText:"String",
		fulfilledIconUrl:"String",
		locale:"Locale",
		root:"DeliveryMethod"
	},
	DeliveryMethodLocaleMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		description:"FieldMeta",
		trackingCodeUrlTemplate:"FieldMeta",
		processingTitle:"FieldMeta",
		processingText:"FieldMeta",
		processingIconUrl:"FieldMeta",
		dispatchedTitle:"FieldMeta",
		dispatchedText:"FieldMeta",
		dispatchedIconUrl:"FieldMeta",
		fulfilledTitle:"FieldMeta",
		fulfilledText:"FieldMeta",
		fulfilledIconUrl:"FieldMeta",
		locale:"FieldMeta",
		root:"FieldMeta"
	},
	PipelineStageLocale:{
		_meta:"PipelineStageLocaleMeta",
		id:"UUID",
		name:"String",
		root:"PipelineStage",
		locale:"Locale"
	},
	PipelineStageLocaleMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta"
	},
	PipelineStage:{
		_meta:"PipelineStageMeta",
		id:"UUID",
		items:"PipelineStageItem",
		pipeline:"Pipeline",
		order:"Int",
		locales:"PipelineStageLocale",
		sentiment:"PipelineStageSentiment",
		type:"PipelineStageType",
		forms:"LeadForm",
		showItemsWeight:"Boolean",
		showItemsPrice:"Boolean",
		itemsByLead:"PipelineStageItem",
		localesByLocale:"PipelineStageLocale",
		formsByCode:"LeadForm",
		formsByLeads:"LeadForm",
		paginateItems:"PipelineStageItemConnection",
		paginateLocales:"PipelineStageLocaleConnection",
		paginateForms:"LeadFormConnection"
	},
	PipelineStageMeta:{
		id:"FieldMeta",
		items:"FieldMeta",
		pipeline:"FieldMeta",
		order:"FieldMeta",
		locales:"FieldMeta",
		sentiment:"FieldMeta",
		type:"FieldMeta",
		forms:"FieldMeta",
		showItemsWeight:"FieldMeta",
		showItemsPrice:"FieldMeta"
	},
	PipelineStageItem:{
		_meta:"PipelineStageItemMeta",
		id:"UUID",
		list:"PipelineStage",
		lead:"PipelineLead",
		order:"Int"
	},
	PipelineStageItemMeta:{
		id:"FieldMeta",
		list:"FieldMeta",
		lead:"FieldMeta",
		order:"FieldMeta"
	},
	PipelineLead:{
		_meta:"PipelineLeadMeta",
		id:"UUID",
		createdAt:"DateTime",
		stageItem:"PipelineStageItem",
		contactPerson:"String",
		customer:"Customer",
		cafeType:"String",
		offerType:"String",
		ownMachine:"Boolean",
		customerCity:"String",
		companyId:"String",
		customerName:"String",
		email:"String",
		phone:"String",
		form:"LeadForm",
		meta:"String",
		multiroasterType:"String"
	},
	PipelineLeadMeta:{
		id:"FieldMeta",
		createdAt:"FieldMeta",
		stageItem:"FieldMeta",
		contactPerson:"FieldMeta",
		customer:"FieldMeta",
		cafeType:"FieldMeta",
		offerType:"FieldMeta",
		ownMachine:"FieldMeta",
		customerCity:"FieldMeta",
		companyId:"FieldMeta",
		customerName:"FieldMeta",
		email:"FieldMeta",
		phone:"FieldMeta",
		form:"FieldMeta",
		meta:"FieldMeta",
		multiroasterType:"FieldMeta"
	},
	LeadForm:{
		_meta:"LeadFormMeta",
		id:"UUID",
		code:"String",
		stage:"PipelineStage",
		leads:"PipelineLead",
		leadsByStageItem:"PipelineLead",
		paginateLeads:"PipelineLeadConnection"
	},
	LeadFormMeta:{
		id:"FieldMeta",
		code:"FieldMeta",
		stage:"FieldMeta",
		leads:"FieldMeta"
	},
	PipelineLeadConnection:{
		pageInfo:"PageInfo",
		edges:"PipelineLeadEdge"
	},
	PipelineLeadEdge:{
		node:"PipelineLead"
	},
	Pipeline:{
		_meta:"PipelineMeta",
		id:"UUID",
		unique:"One",
		stages:"PipelineStage",
		stagesByItems:"PipelineStage",
		stagesByLocales:"PipelineStage",
		stagesByForms:"PipelineStage",
		paginateStages:"PipelineStageConnection"
	},
	PipelineMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		stages:"FieldMeta"
	},
	PipelineStageConnection:{
		pageInfo:"PageInfo",
		edges:"PipelineStageEdge"
	},
	PipelineStageEdge:{
		node:"PipelineStage"
	},
	PipelineStageSentiment:{
		_meta:"PipelineStageSentimentMeta",
		id:"UUID",
		internalName:"String",
		backgroundColor:"String",
		textColor:"String"
	},
	PipelineStageSentimentMeta:{
		id:"FieldMeta",
		internalName:"FieldMeta",
		backgroundColor:"FieldMeta",
		textColor:"FieldMeta"
	},
	PipelineStageItemConnection:{
		pageInfo:"PageInfo",
		edges:"PipelineStageItemEdge"
	},
	PipelineStageItemEdge:{
		node:"PipelineStageItem"
	},
	PipelineStageLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"PipelineStageLocaleEdge"
	},
	PipelineStageLocaleEdge:{
		node:"PipelineStageLocale"
	},
	LeadFormConnection:{
		pageInfo:"PageInfo",
		edges:"LeadFormEdge"
	},
	LeadFormEdge:{
		node:"LeadForm"
	},
	SubscriptionBoxLocale:{
		_meta:"SubscriptionBoxLocaleMeta",
		id:"UUID",
		title:"String",
		stickerText:"String",
		descriptionText:"String",
		root:"SubscriptionBox",
		locale:"Locale",
		secondaryTitle:"String",
		texts:"TextList",
		secondaryTexts:"TextList"
	},
	SubscriptionBoxLocaleMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		stickerText:"FieldMeta",
		descriptionText:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		secondaryTitle:"FieldMeta",
		texts:"FieldMeta",
		secondaryTexts:"FieldMeta"
	},
	SubscriptionBox:{
		_meta:"SubscriptionBoxMeta",
		id:"UUID",
		locales:"SubscriptionBoxLocale",
		unique:"One",
		localesByLocale:"SubscriptionBoxLocale",
		localesByTexts:"SubscriptionBoxLocale",
		localesBySecondaryTexts:"SubscriptionBoxLocale",
		paginateLocales:"SubscriptionBoxLocaleConnection"
	},
	SubscriptionBoxMeta:{
		id:"FieldMeta",
		locales:"FieldMeta",
		unique:"FieldMeta"
	},
	SubscriptionBoxLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"SubscriptionBoxLocaleEdge"
	},
	SubscriptionBoxLocaleEdge:{
		node:"SubscriptionBoxLocale"
	},
	ProductPackingLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"ProductPackingLocaleEdge"
	},
	ProductPackingLocaleEdge:{
		node:"ProductPackingLocale"
	},
	ProductLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"ProductLocaleEdge"
	},
	ProductLocaleEdge:{
		node:"ProductLocale"
	},
	DeliveryMethodLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"DeliveryMethodLocaleEdge"
	},
	DeliveryMethodLocaleEdge:{
		node:"DeliveryMethodLocale"
	},
	PreparedPackingQuantity:{
		_meta:"PreparedPackingQuantityMeta",
		id:"UUID",
		date:"Date",
		quantity:"Float",
		recipe:"ProductRecipe",
		packing:"ProductPacking",
		packedInCardboard:"Boolean"
	},
	PreparedPackingQuantityMeta:{
		id:"FieldMeta",
		date:"FieldMeta",
		quantity:"FieldMeta",
		recipe:"FieldMeta",
		packing:"FieldMeta",
		packedInCardboard:"FieldMeta"
	},
	PreparedPackingQuantityConnection:{
		pageInfo:"PageInfo",
		edges:"PreparedPackingQuantityEdge"
	},
	PreparedPackingQuantityEdge:{
		node:"PreparedPackingQuantity"
	},
	ProductStock:{
		_meta:"ProductStockMeta",
		id:"UUID",
		quantity:"Int",
		product:"Product",
		store:"Store"
	},
	ProductStockMeta:{
		id:"FieldMeta",
		quantity:"FieldMeta",
		product:"FieldMeta",
		store:"FieldMeta"
	},
	Store:{
		_meta:"StoreMeta",
		id:"UUID",
		name:"String",
		code:"String",
		description:"String",
		internalNote:"String"
	},
	StoreMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		code:"FieldMeta",
		description:"FieldMeta",
		internalNote:"FieldMeta"
	},
	ProductGroupPrice:{
		_meta:"ProductGroupPriceMeta",
		id:"UUID",
		priceCents:"Int",
		group:"CustomerGroup",
		product:"Product"
	},
	ProductGroupPriceMeta:{
		id:"FieldMeta",
		priceCents:"FieldMeta",
		group:"FieldMeta",
		product:"FieldMeta"
	},
	CustomerGroup:{
		_meta:"CustomerGroupMeta",
		id:"UUID",
		name:"String",
		productPrices:"ProductGroupPrice",
		customers:"Customer",
		discountPermille:"Int",
		code:"String",
		doubleshotLegacyId:"String",
		productPricesByProduct:"ProductGroupPrice",
		customersByDoubleshotLegacyId:"Customer",
		customersByAddresses:"Customer",
		customersByDefaultBillingAddress:"Customer",
		customersByDefaultPaymentMethod:"Customer",
		customersByCredits:"Customer",
		customersByPaymentMethods:"Customer",
		customersByOrders:"Customer",
		customersByPermissions:"Customer",
		customersByName:"Customer",
		customersByIngredientRatings:"Customer",
		customersByBusiness:"Customer",
		customersByCarts:"Customer",
		customersByShortcutList:"Customer",
		customersByUser:"Customer",
		customersByInvoices:"Customer",
		customersByInvoicingPlan:"Customer",
		customersByBillingSubjects:"Customer",
		customersByOfferedProducts:"Customer",
		customersByDefaultDeliveryAddress:"Customer",
		customersByDefaultBillingSubject:"Customer",
		customersByAnonymousSession:"Customer",
		customersByBoughtVouchers:"Customer",
		customersByOwnsVouchers:"Customer",
		customersByRedeemedVouchers:"Customer",
		customersBySpending:"Customer",
		customersByCustomerTabs:"Customer",
		customersByLead:"Customer",
		customersByMeta:"Customer",
		paginateProductPrices:"ProductGroupPriceConnection",
		paginateCustomers:"CustomerConnection"
	},
	CustomerGroupMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		productPrices:"FieldMeta",
		customers:"FieldMeta",
		discountPermille:"FieldMeta",
		code:"FieldMeta",
		doubleshotLegacyId:"FieldMeta"
	},
	ProductGroupPriceConnection:{
		pageInfo:"PageInfo",
		edges:"ProductGroupPriceEdge"
	},
	ProductGroupPriceEdge:{
		node:"ProductGroupPrice"
	},
	ProductCustomerPrice:{
		_meta:"ProductCustomerPriceMeta",
		id:"UUID",
		groupDiscountPermille:"Int",
		groupPriceCents:"Int",
		fullPriceCents:"Int",
		discountedPriceCents:"Int",
		priceCents:"Int",
		offered:"Boolean",
		notDiscountable:"Boolean",
		customer:"Customer",
		product:"Product"
	},
	ProductCustomerPriceMeta:{
		id:"FieldMeta",
		groupDiscountPermille:"FieldMeta",
		groupPriceCents:"FieldMeta",
		fullPriceCents:"FieldMeta",
		discountedPriceCents:"FieldMeta",
		priceCents:"FieldMeta",
		offered:"FieldMeta",
		notDiscountable:"FieldMeta",
		customer:"FieldMeta",
		product:"FieldMeta"
	},
	ProductMetadata:{
		_meta:"ProductMetadataMeta",
		id:"UUID",
		archived:"Boolean",
		available:"Boolean",
		availableQuantity:"Int",
		product:"Product"
	},
	ProductMetadataMeta:{
		id:"FieldMeta",
		archived:"FieldMeta",
		available:"FieldMeta",
		availableQuantity:"FieldMeta",
		product:"FieldMeta"
	},
	ProductSalesDay:{
		_meta:"ProductSalesDayMeta",
		id:"UUID",
		productName:"String",
		orderDate:"Date",
		priceCentsSum:"Int",
		sum:"Int",
		product:"Product"
	},
	ProductSalesDayMeta:{
		id:"FieldMeta",
		productName:"FieldMeta",
		orderDate:"FieldMeta",
		priceCentsSum:"FieldMeta",
		sum:"FieldMeta",
		product:"FieldMeta"
	},
	ProductSalesWeek:{
		_meta:"ProductSalesWeekMeta",
		id:"UUID",
		productName:"String",
		orderDate:"Date",
		priceCentsSum:"Int",
		sum:"Int",
		product:"Product"
	},
	ProductSalesWeekMeta:{
		id:"FieldMeta",
		productName:"FieldMeta",
		orderDate:"FieldMeta",
		priceCentsSum:"FieldMeta",
		sum:"FieldMeta",
		product:"FieldMeta"
	},
	ProductSalesMonth:{
		_meta:"ProductSalesMonthMeta",
		id:"UUID",
		productName:"String",
		orderDate:"Date",
		priceCentsSum:"Int",
		sum:"Int",
		product:"Product"
	},
	ProductSalesMonthMeta:{
		id:"FieldMeta",
		productName:"FieldMeta",
		orderDate:"FieldMeta",
		priceCentsSum:"FieldMeta",
		sum:"FieldMeta",
		product:"FieldMeta"
	},
	ProductStockConnection:{
		pageInfo:"PageInfo",
		edges:"ProductStockEdge"
	},
	ProductStockEdge:{
		node:"ProductStock"
	},
	DeliveryZoneConnection:{
		pageInfo:"PageInfo",
		edges:"DeliveryZoneEdge"
	},
	DeliveryZoneEdge:{
		node:"DeliveryZone"
	},
	ProductCustomerPriceConnection:{
		pageInfo:"PageInfo",
		edges:"ProductCustomerPriceEdge"
	},
	ProductCustomerPriceEdge:{
		node:"ProductCustomerPrice"
	},
	ProductSalesDayConnection:{
		pageInfo:"PageInfo",
		edges:"ProductSalesDayEdge"
	},
	ProductSalesDayEdge:{
		node:"ProductSalesDay"
	},
	ProductSalesWeekConnection:{
		pageInfo:"PageInfo",
		edges:"ProductSalesWeekEdge"
	},
	ProductSalesWeekEdge:{
		node:"ProductSalesWeek"
	},
	ProductSalesMonthConnection:{
		pageInfo:"PageInfo",
		edges:"ProductSalesMonthEdge"
	},
	ProductSalesMonthEdge:{
		node:"ProductSalesMonth"
	},
	AddressMetadata:{
		_meta:"AddressMetadataMeta",
		id:"UUID",
		deliveryZoneType:"DeliveryZoneType",
		address:"Address",
		deliveryZone:"DeliveryZone"
	},
	AddressMetadataMeta:{
		id:"FieldMeta",
		deliveryZoneType:"FieldMeta",
		address:"FieldMeta",
		deliveryZone:"FieldMeta"
	},
	AddressConnection:{
		pageInfo:"PageInfo",
		edges:"AddressEdge"
	},
	AddressEdge:{
		node:"Address"
	},
	AddressMetadataConnection:{
		pageInfo:"PageInfo",
		edges:"AddressMetadataEdge"
	},
	AddressMetadataEdge:{
		node:"AddressMetadata"
	},
	DeliveryTimelinePreset:{
		_meta:"DeliveryTimelinePresetMeta",
		id:"UUID",
		type:"DeliveryTimelineType",
		duration:"String",
		window:"String",
		deliveryMethod:"DeliveryMethod"
	},
	DeliveryTimelinePresetMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		duration:"FieldMeta",
		window:"FieldMeta",
		deliveryMethod:"FieldMeta"
	},
	PaymentMethodConnection:{
		pageInfo:"PageInfo",
		edges:"PaymentMethodEdge"
	},
	PaymentMethodEdge:{
		node:"PaymentMethod"
	},
	CourierConnection:{
		pageInfo:"PageInfo",
		edges:"CourierEdge"
	},
	CourierEdge:{
		node:"Courier"
	},
	CustomerPermissions:{
		_meta:"CustomerPermissionsMeta",
		id:"UUID",
		canPlaceOrder:"Boolean",
		customer:"Customer"
	},
	CustomerPermissionsMeta:{
		id:"FieldMeta",
		canPlaceOrder:"FieldMeta",
		customer:"FieldMeta"
	},
	CustomerName:{
		_meta:"CustomerNameMeta",
		id:"UUID",
		nominative:"String",
		vocative:"String",
		customer:"Customer",
		aliases:"CustomerAlias",
		paginateAliases:"CustomerAliasConnection"
	},
	CustomerNameMeta:{
		id:"FieldMeta",
		nominative:"FieldMeta",
		vocative:"FieldMeta",
		customer:"FieldMeta",
		aliases:"FieldMeta"
	},
	CustomerAlias:{
		_meta:"CustomerAliasMeta",
		id:"UUID",
		name:"String",
		order:"Int"
	},
	CustomerAliasMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		order:"FieldMeta"
	},
	CustomerAliasConnection:{
		pageInfo:"PageInfo",
		edges:"CustomerAliasEdge"
	},
	CustomerAliasEdge:{
		node:"CustomerAlias"
	},
	ApplicationShortcutList:{
		_meta:"ApplicationShortcutListMeta",
		id:"UUID",
		items:"ApplicationShortcutListItem",
		customer:"Customer",
		paginateItems:"ApplicationShortcutListItemConnection"
	},
	ApplicationShortcutListMeta:{
		id:"FieldMeta",
		items:"FieldMeta",
		customer:"FieldMeta"
	},
	ApplicationShortcutListItem:{
		_meta:"ApplicationShortcutListItemMeta",
		id:"UUID",
		order:"Int",
		application:"Application",
		list:"ApplicationShortcutList"
	},
	ApplicationShortcutListItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		application:"FieldMeta",
		list:"FieldMeta"
	},
	Application:{
		_meta:"ApplicationMeta",
		id:"UUID",
		order:"Int",
		handle:"String",
		url:"String",
		color:"String",
		icon:"Image",
		name:"String",
		short:"String"
	},
	ApplicationMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		handle:"FieldMeta",
		url:"FieldMeta",
		color:"FieldMeta",
		icon:"FieldMeta",
		name:"FieldMeta",
		short:"FieldMeta"
	},
	ApplicationShortcutListItemConnection:{
		pageInfo:"PageInfo",
		edges:"ApplicationShortcutListItemEdge"
	},
	ApplicationShortcutListItemEdge:{
		node:"ApplicationShortcutListItem"
	},
	InvoicingPlan:{
		_meta:"InvoicingPlanMeta",
		id:"UUID",
		customer:"Customer",
		preset:"InvoicingPreset"
	},
	InvoicingPlanMeta:{
		id:"FieldMeta",
		customer:"FieldMeta",
		preset:"FieldMeta"
	},
	InvoicingPreset:{
		_meta:"InvoicingPresetMeta",
		id:"UUID",
		type:"InvoicingPresetType",
		startsAt:"DateTime",
		endsAt:"DateTime",
		intervalOfDays:"Int",
		invoicingPlan:"InvoicingPlan"
	},
	InvoicingPresetMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		startsAt:"FieldMeta",
		endsAt:"FieldMeta",
		intervalOfDays:"FieldMeta",
		invoicingPlan:"FieldMeta"
	},
	CustomerSpending:{
		_meta:"CustomerSpendingMeta",
		id:"UUID",
		totalCents:"Int",
		customer:"Customer"
	},
	CustomerSpendingMeta:{
		id:"FieldMeta",
		totalCents:"FieldMeta",
		customer:"FieldMeta"
	},
	CustomerMetadata:{
		_meta:"CustomerMetadataMeta",
		id:"UUID",
		isBusiness:"Boolean",
		name:"String",
		fallbackName:"String",
		remainingCreditsCents:"Int",
		ordersTotalCents:"Int",
		customerProfileUrl:"String",
		customer:"Customer"
	},
	CustomerMetadataMeta:{
		id:"FieldMeta",
		isBusiness:"FieldMeta",
		name:"FieldMeta",
		fallbackName:"FieldMeta",
		remainingCreditsCents:"FieldMeta",
		ordersTotalCents:"FieldMeta",
		customerProfileUrl:"FieldMeta",
		customer:"FieldMeta"
	},
	CustomerCreditConnection:{
		pageInfo:"PageInfo",
		edges:"CustomerCreditEdge"
	},
	CustomerCreditEdge:{
		node:"CustomerCredit"
	},
	CustomerPaymentMethodConnection:{
		pageInfo:"PageInfo",
		edges:"CustomerPaymentMethodEdge"
	},
	CustomerPaymentMethodEdge:{
		node:"CustomerPaymentMethod"
	},
	BillingSubjectConnection:{
		pageInfo:"PageInfo",
		edges:"BillingSubjectEdge"
	},
	BillingSubjectEdge:{
		node:"BillingSubject"
	},
	VoucherRedemptionConnection:{
		pageInfo:"PageInfo",
		edges:"VoucherRedemptionEdge"
	},
	VoucherRedemptionEdge:{
		node:"VoucherRedemption"
	},
	Gps:{
		_meta:"GpsMeta",
		id:"UUID",
		latitude:"Float",
		longitude:"Float",
		address:"Address"
	},
	GpsMeta:{
		id:"FieldMeta",
		latitude:"FieldMeta",
		longitude:"FieldMeta",
		address:"FieldMeta"
	},
	OrderDeliveryConnection:{
		pageInfo:"PageInfo",
		edges:"OrderDeliveryEdge"
	},
	OrderDeliveryEdge:{
		node:"OrderDelivery"
	},
	_ValidationResult:{
		valid:"Boolean",
		errors:"_ValidationError"
	},
	_ValidationError:{
		path:"_PathFragment",
		message:"_ValidationMessage"
	},
	_PathFragment:{
		"...on _FieldPathFragment":"_FieldPathFragment",
		"...on _IndexPathFragment":"_IndexPathFragment"
	},
	_FieldPathFragment:{
		field:"String"
	},
	_IndexPathFragment:{
		index:"Int",
		alias:"String"
	},
	_ValidationMessage:{
		text:"String"
	},
	CustomerGroupConnection:{
		pageInfo:"PageInfo",
		edges:"CustomerGroupEdge"
	},
	CustomerGroupEdge:{
		node:"CustomerGroup"
	},
	VatRateConnection:{
		pageInfo:"PageInfo",
		edges:"VatRateEdge"
	},
	VatRateEdge:{
		node:"VatRate"
	},
	ProductPackingConnection:{
		pageInfo:"PageInfo",
		edges:"ProductPackingEdge"
	},
	ProductPackingEdge:{
		node:"ProductPacking"
	},
	ProductRecipeConnection:{
		pageInfo:"PageInfo",
		edges:"ProductRecipeEdge"
	},
	ProductRecipeEdge:{
		node:"ProductRecipe"
	},
	StoreConnection:{
		pageInfo:"PageInfo",
		edges:"StoreEdge"
	},
	StoreEdge:{
		node:"Store"
	},
	CustomerPermissionsConnection:{
		pageInfo:"PageInfo",
		edges:"CustomerPermissionsEdge"
	},
	CustomerPermissionsEdge:{
		node:"CustomerPermissions"
	},
	ImageConnection:{
		pageInfo:"PageInfo",
		edges:"ImageEdge"
	},
	ImageEdge:{
		node:"Image"
	},
	ProductListConnection:{
		pageInfo:"PageInfo",
		edges:"ProductListEdge"
	},
	ProductListEdge:{
		node:"ProductList"
	},
	ProductCategoryListConnection:{
		pageInfo:"PageInfo",
		edges:"ProductCategoryListEdge"
	},
	ProductCategoryListEdge:{
		node:"ProductCategoryList"
	},
	LocaleConnection:{
		pageInfo:"PageInfo",
		edges:"LocaleEdge"
	},
	LocaleEdge:{
		node:"Locale"
	},
	CustomerNameConnection:{
		pageInfo:"PageInfo",
		edges:"CustomerNameEdge"
	},
	CustomerNameEdge:{
		node:"CustomerName"
	},
	ProductIngredientItemQuantityConnection:{
		pageInfo:"PageInfo",
		edges:"ProductIngredientItemQuantityEdge"
	},
	ProductIngredientItemQuantityEdge:{
		node:"ProductIngredientItemQuantity"
	},
	ProductIngredientItemQuantityUnitConnection:{
		pageInfo:"PageInfo",
		edges:"ProductIngredientItemQuantityUnitEdge"
	},
	ProductIngredientItemQuantityUnitEdge:{
		node:"ProductIngredientItemQuantityUnit"
	},
	ProductIngredientRatingConnection:{
		pageInfo:"PageInfo",
		edges:"ProductIngredientRatingEdge"
	},
	ProductIngredientRatingEdge:{
		node:"ProductIngredientRating"
	},
	PointOfSalePermissionsConnection:{
		pageInfo:"PageInfo",
		edges:"PointOfSalePermissionsEdge"
	},
	PointOfSalePermissionsEdge:{
		node:"PointOfSalePermissions"
	},
	BlogConnection:{
		pageInfo:"PageInfo",
		edges:"BlogEdge"
	},
	BlogEdge:{
		node:"Blog"
	},
	BlogPostConnection:{
		pageInfo:"PageInfo",
		edges:"BlogPostEdge"
	},
	BlogPostEdge:{
		node:"BlogPost"
	},
	ColorPalleteConnection:{
		pageInfo:"PageInfo",
		edges:"ColorPalleteEdge"
	},
	ColorPalleteEdge:{
		node:"ColorPallete"
	},
	ContentConnection:{
		pageInfo:"PageInfo",
		edges:"ContentEdge"
	},
	ContentEdge:{
		node:"Content"
	},
	BlogPostListConnection:{
		pageInfo:"PageInfo",
		edges:"BlogPostListEdge"
	},
	BlogPostListEdge:{
		node:"BlogPostList"
	},
	LinkListConnection:{
		pageInfo:"PageInfo",
		edges:"LinkListEdge"
	},
	LinkListEdge:{
		node:"LinkList"
	},
	CoverConnection:{
		pageInfo:"PageInfo",
		edges:"CoverEdge"
	},
	CoverEdge:{
		node:"Cover"
	},
	LinkConnection:{
		pageInfo:"PageInfo",
		edges:"LinkEdge"
	},
	LinkEdge:{
		node:"Link"
	},
	LinkableConnection:{
		pageInfo:"PageInfo",
		edges:"LinkableEdge"
	},
	LinkableEdge:{
		node:"Linkable"
	},
	MediumConnection:{
		pageInfo:"PageInfo",
		edges:"MediumEdge"
	},
	MediumEdge:{
		node:"Medium"
	},
	VideoConnection:{
		pageInfo:"PageInfo",
		edges:"VideoEdge"
	},
	VideoEdge:{
		node:"Video"
	},
	SeoConnection:{
		pageInfo:"PageInfo",
		edges:"SeoEdge"
	},
	SeoEdge:{
		node:"Seo"
	},
	ProtectedImage:{
		_meta:"ProtectedImageMeta",
		id:"UUID",
		url:"String",
		width:"Int",
		height:"Int",
		size:"Int",
		type:"String",
		alt:"String"
	},
	ProtectedImageMeta:{
		id:"FieldMeta",
		url:"FieldMeta",
		width:"FieldMeta",
		height:"FieldMeta",
		size:"FieldMeta",
		type:"FieldMeta",
		alt:"FieldMeta"
	},
	ProtectedImageConnection:{
		pageInfo:"PageInfo",
		edges:"ProtectedImageEdge"
	},
	ProtectedImageEdge:{
		node:"ProtectedImage"
	},
	TranslationDomainConnection:{
		pageInfo:"PageInfo",
		edges:"TranslationDomainEdge"
	},
	TranslationDomainEdge:{
		node:"TranslationDomain"
	},
	TranslationCataloguesIdentifierConnection:{
		pageInfo:"PageInfo",
		edges:"TranslationCataloguesIdentifierEdge"
	},
	TranslationCataloguesIdentifierEdge:{
		node:"TranslationCataloguesIdentifier"
	},
	SocialsAndAppsConnection:{
		pageInfo:"PageInfo",
		edges:"SocialsAndAppsEdge"
	},
	SocialsAndAppsEdge:{
		node:"SocialsAndApps"
	},
	ProductGridConnection:{
		pageInfo:"PageInfo",
		edges:"ProductGridEdge"
	},
	ProductGridEdge:{
		node:"ProductGrid"
	},
	GalleryConnection:{
		pageInfo:"PageInfo",
		edges:"GalleryEdge"
	},
	GalleryEdge:{
		node:"Gallery"
	},
	HeroConnection:{
		pageInfo:"PageInfo",
		edges:"HeroEdge"
	},
	HeroEdge:{
		node:"Hero"
	},
	SiteMenuConnection:{
		pageInfo:"PageInfo",
		edges:"SiteMenuEdge"
	},
	SiteMenuEdge:{
		node:"SiteMenu"
	},
	PageConnection:{
		pageInfo:"PageInfo",
		edges:"PageEdge"
	},
	PageEdge:{
		node:"Page"
	},
	MenuLinkListConnection:{
		pageInfo:"PageInfo",
		edges:"MenuLinkListEdge"
	},
	MenuLinkListEdge:{
		node:"MenuLinkList"
	},
	MenuProductsConnection:{
		pageInfo:"PageInfo",
		edges:"MenuProductsEdge"
	},
	MenuProductsEdge:{
		node:"MenuProducts"
	},
	MenuDeliveryConnection:{
		pageInfo:"PageInfo",
		edges:"MenuDeliveryEdge"
	},
	MenuDeliveryEdge:{
		node:"MenuDelivery"
	},
	MenuContactConnection:{
		pageInfo:"PageInfo",
		edges:"MenuContactEdge"
	},
	MenuContactEdge:{
		node:"MenuContact"
	},
	DeadlineTemplateConnection:{
		pageInfo:"PageInfo",
		edges:"DeadlineTemplateEdge"
	},
	DeadlineTemplateEdge:{
		node:"DeadlineTemplate"
	},
	EmployeeQueueConnection:{
		pageInfo:"PageInfo",
		edges:"EmployeeQueueEdge"
	},
	EmployeeQueueEdge:{
		node:"EmployeeQueue"
	},
	TimetableShiftPositionConnection:{
		pageInfo:"PageInfo",
		edges:"TimetableShiftPositionEdge"
	},
	TimetableShiftPositionEdge:{
		node:"TimetableShiftPosition"
	},
	ApplicationConnection:{
		pageInfo:"PageInfo",
		edges:"ApplicationEdge"
	},
	ApplicationEdge:{
		node:"Application"
	},
	ApplicationShortcutListConnection:{
		pageInfo:"PageInfo",
		edges:"ApplicationShortcutListEdge"
	},
	ApplicationShortcutListEdge:{
		node:"ApplicationShortcutList"
	},
	ProductBannerConnection:{
		pageInfo:"PageInfo",
		edges:"ProductBannerEdge"
	},
	ProductBannerEdge:{
		node:"ProductBanner"
	},
	ProductBannerListConnection:{
		pageInfo:"PageInfo",
		edges:"ProductBannerListEdge"
	},
	ProductBannerListEdge:{
		node:"ProductBannerList"
	},
	BartenderConnection:{
		pageInfo:"PageInfo",
		edges:"BartenderEdge"
	},
	BartenderEdge:{
		node:"Bartender"
	},
	BusinessToBusinessManagerConnection:{
		pageInfo:"PageInfo",
		edges:"BusinessToBusinessManagerEdge"
	},
	BusinessToBusinessManagerEdge:{
		node:"BusinessToBusinessManager"
	},
	CleanerConnection:{
		pageInfo:"PageInfo",
		edges:"CleanerEdge"
	},
	CleanerEdge:{
		node:"Cleaner"
	},
	UserConnection:{
		pageInfo:"PageInfo",
		edges:"UserEdge"
	},
	UserEdge:{
		node:"User"
	},
	StocksManagerConnection:{
		pageInfo:"PageInfo",
		edges:"StocksManagerEdge"
	},
	StocksManagerEdge:{
		node:"StocksManager"
	},
	GpsConnection:{
		pageInfo:"PageInfo",
		edges:"GpsEdge"
	},
	GpsEdge:{
		node:"Gps"
	},
	WeekHoursConnection:{
		pageInfo:"PageInfo",
		edges:"WeekHoursEdge"
	},
	WeekHoursEdge:{
		node:"WeekHours"
	},
	PreparedIngredientQuantity:{
		_meta:"PreparedIngredientQuantityMeta",
		id:"UUID",
		date:"Date",
		quantity:"Float",
		usedQuantity:"Float",
		ingredient:"ProductIngredient",
		unit:"ProductIngredientItemQuantityUnit"
	},
	PreparedIngredientQuantityMeta:{
		id:"FieldMeta",
		date:"FieldMeta",
		quantity:"FieldMeta",
		usedQuantity:"FieldMeta",
		ingredient:"FieldMeta",
		unit:"FieldMeta"
	},
	PreparedIngredientQuantityConnection:{
		pageInfo:"PageInfo",
		edges:"PreparedIngredientQuantityEdge"
	},
	PreparedIngredientQuantityEdge:{
		node:"PreparedIngredientQuantity"
	},
	PreparedRecipeQuantity:{
		_meta:"PreparedRecipeQuantityMeta",
		id:"UUID",
		date:"Date",
		quantity:"Float",
		recipe:"ProductRecipe",
		usedQuantity:"Float"
	},
	PreparedRecipeQuantityMeta:{
		id:"FieldMeta",
		date:"FieldMeta",
		quantity:"FieldMeta",
		recipe:"FieldMeta",
		usedQuantity:"FieldMeta"
	},
	PreparedRecipeQuantityConnection:{
		pageInfo:"PageInfo",
		edges:"PreparedRecipeQuantityEdge"
	},
	PreparedRecipeQuantityEdge:{
		node:"PreparedRecipeQuantity"
	},
	InternalOrder:{
		_meta:"InternalOrderMeta",
		id:"UUID",
		state:"InternalOrderState",
		fulfilledAt:"DateTime",
		canceledAt:"DateTime",
		targetPlace:"String",
		note:"String",
		internalNote:"String",
		items:"InternalOrderItem",
		createdAt:"DateTime",
		paginateItems:"InternalOrderItemConnection"
	},
	InternalOrderMeta:{
		id:"FieldMeta",
		state:"FieldMeta",
		fulfilledAt:"FieldMeta",
		canceledAt:"FieldMeta",
		targetPlace:"FieldMeta",
		note:"FieldMeta",
		internalNote:"FieldMeta",
		items:"FieldMeta",
		createdAt:"FieldMeta"
	},
	InternalOrderItem:{
		_meta:"InternalOrderItemMeta",
		id:"UUID",
		quantity:"Int",
		internalOrder:"InternalOrder",
		product:"Product"
	},
	InternalOrderItemMeta:{
		id:"FieldMeta",
		quantity:"FieldMeta",
		internalOrder:"FieldMeta",
		product:"FieldMeta"
	},
	InternalOrderItemConnection:{
		pageInfo:"PageInfo",
		edges:"InternalOrderItemEdge"
	},
	InternalOrderItemEdge:{
		node:"InternalOrderItem"
	},
	InternalOrderConnection:{
		pageInfo:"PageInfo",
		edges:"InternalOrderEdge"
	},
	InternalOrderEdge:{
		node:"InternalOrder"
	},
	CourierManagerConnection:{
		pageInfo:"PageInfo",
		edges:"CourierManagerEdge"
	},
	CourierManagerEdge:{
		node:"CourierManager"
	},
	DeliveryTimelinePresetConnection:{
		pageInfo:"PageInfo",
		edges:"DeliveryTimelinePresetEdge"
	},
	DeliveryTimelinePresetEdge:{
		node:"DeliveryTimelinePreset"
	},
	OrderDeliveryTimeline:{
		_meta:"OrderDeliveryTimelineMeta",
		id:"UUID",
		type:"DeliveryTimelineType",
		prepareAt:"DateTime",
		loadingHours:"Int",
		dispatchAt:"DateTime",
		duration:"String",
		window:"String",
		expectedEndAt:"DateTime",
		expectedAt:"DateTime"
	},
	OrderDeliveryTimelineMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		prepareAt:"FieldMeta",
		loadingHours:"FieldMeta",
		dispatchAt:"FieldMeta",
		duration:"FieldMeta",
		window:"FieldMeta",
		expectedEndAt:"FieldMeta",
		expectedAt:"FieldMeta"
	},
	OrderDeliveryTimelineConnection:{
		pageInfo:"PageInfo",
		edges:"OrderDeliveryTimelineEdge"
	},
	OrderDeliveryTimelineEdge:{
		node:"OrderDeliveryTimeline"
	},
	LiftagoRideConnection:{
		pageInfo:"PageInfo",
		edges:"LiftagoRideEdge"
	},
	LiftagoRideEdge:{
		node:"LiftagoRide"
	},
	InvoicingPlanConnection:{
		pageInfo:"PageInfo",
		edges:"InvoicingPlanEdge"
	},
	InvoicingPlanEdge:{
		node:"InvoicingPlan"
	},
	ProtectedAction:{
		_meta:"ProtectedActionMeta",
		id:"UUID",
		type:"ProtectedActionType",
		data:"Json",
		publicKey:"String",
		secretKeyHash:"String",
		confirmKeyHash:"String",
		url:"String",
		createdAt:"DateTime",
		expiresAt:"DateTime",
		usedAt:"DateTime",
		service:"String"
	},
	ProtectedActionMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		data:"FieldMeta",
		publicKey:"FieldMeta",
		secretKeyHash:"FieldMeta",
		confirmKeyHash:"FieldMeta",
		url:"FieldMeta",
		createdAt:"FieldMeta",
		expiresAt:"FieldMeta",
		usedAt:"FieldMeta",
		service:"FieldMeta"
	},
	ProtectedActionConnection:{
		pageInfo:"PageInfo",
		edges:"ProtectedActionEdge"
	},
	ProtectedActionEdge:{
		node:"ProtectedAction"
	},
	PickerConnection:{
		pageInfo:"PageInfo",
		edges:"PickerEdge"
	},
	PickerEdge:{
		node:"Picker"
	},
	TenantPerson:{
		_meta:"TenantPersonMeta",
		id:"UUID",
		email:"String",
		externalIdentifier:"String",
		personId:"UUID",
		identityId:"UUID",
		globalRoles:"Json",
		projectRoles:"Json",
		projectRolesString:"String",
		externalIdentifiers:"Json",
		externalIdentifiersString:"String"
	},
	TenantPersonMeta:{
		id:"FieldMeta",
		email:"FieldMeta",
		externalIdentifier:"FieldMeta",
		personId:"FieldMeta",
		identityId:"FieldMeta",
		globalRoles:"FieldMeta",
		projectRoles:"FieldMeta",
		projectRolesString:"FieldMeta",
		externalIdentifiers:"FieldMeta",
		externalIdentifiersString:"FieldMeta"
	},
	TenantPersonConnection:{
		pageInfo:"PageInfo",
		edges:"TenantPersonEdge"
	},
	TenantPersonEdge:{
		node:"TenantPerson"
	},
	ShoppingList:{
		_meta:"ShoppingListMeta",
		id:"UUID",
		createdAt:"DateTime",
		items:"ShoppingListItem",
		supplier:"IngredientSupplier",
		paginateItems:"ShoppingListItemConnection"
	},
	ShoppingListMeta:{
		id:"FieldMeta",
		createdAt:"FieldMeta",
		items:"FieldMeta",
		supplier:"FieldMeta"
	},
	ShoppingListItem:{
		_meta:"ShoppingListItemMeta",
		id:"UUID",
		amount:"Int",
		list:"ShoppingList",
		ingredient:"ProductIngredient",
		preferredUnit:"ProductIngredientItemQuantityUnit",
		wasPurcahsed:"Boolean",
		wasTransferred:"Boolean"
	},
	ShoppingListItemMeta:{
		id:"FieldMeta",
		amount:"FieldMeta",
		list:"FieldMeta",
		ingredient:"FieldMeta",
		preferredUnit:"FieldMeta",
		wasPurcahsed:"FieldMeta",
		wasTransferred:"FieldMeta"
	},
	ShoppingListItemConnection:{
		pageInfo:"PageInfo",
		edges:"ShoppingListItemEdge"
	},
	ShoppingListItemEdge:{
		node:"ShoppingListItem"
	},
	ShoppingListConnection:{
		pageInfo:"PageInfo",
		edges:"ShoppingListEdge"
	},
	ShoppingListEdge:{
		node:"ShoppingList"
	},
	SuppliesPurchase:{
		_meta:"SuppliesPurchaseMeta",
		id:"UUID",
		createdAt:"DateTime",
		items:"SuppliesPurchaseItem",
		supplier:"IngredientSupplier",
		requestedDeliveryDate:"Date",
		paginateItems:"SuppliesPurchaseItemConnection"
	},
	SuppliesPurchaseMeta:{
		id:"FieldMeta",
		createdAt:"FieldMeta",
		items:"FieldMeta",
		supplier:"FieldMeta",
		requestedDeliveryDate:"FieldMeta"
	},
	SuppliesPurchaseItem:{
		_meta:"SuppliesPurchaseItemMeta",
		id:"UUID",
		amount:"Int",
		list:"SuppliesPurchase",
		ingredient:"ProductIngredient",
		pricePaidCents:"Int",
		preferredUnit:"ProductIngredientItemQuantityUnit",
		deletedAt:"DateTime",
		purchasedAt:"DateTime",
		purchasedBy:"Staff"
	},
	SuppliesPurchaseItemMeta:{
		id:"FieldMeta",
		amount:"FieldMeta",
		list:"FieldMeta",
		ingredient:"FieldMeta",
		pricePaidCents:"FieldMeta",
		preferredUnit:"FieldMeta",
		deletedAt:"FieldMeta",
		purchasedAt:"FieldMeta",
		purchasedBy:"FieldMeta"
	},
	SuppliesPurchaseItemConnection:{
		pageInfo:"PageInfo",
		edges:"SuppliesPurchaseItemEdge"
	},
	SuppliesPurchaseItemEdge:{
		node:"SuppliesPurchaseItem"
	},
	SuppliesPurchaseConnection:{
		pageInfo:"PageInfo",
		edges:"SuppliesPurchaseEdge"
	},
	SuppliesPurchaseEdge:{
		node:"SuppliesPurchase"
	},
	InvoicingPresetConnection:{
		pageInfo:"PageInfo",
		edges:"InvoicingPresetEdge"
	},
	InvoicingPresetEdge:{
		node:"InvoicingPreset"
	},
	LogRecord:{
		_meta:"LogRecordMeta",
		id:"UUID",
		level:"Int",
		type:"String",
		message:"String",
		data:"Json",
		createdAt:"DateTime",
		shouldBeResolved:"Boolean",
		resolvedAt:"DateTime",
		resolvedBy:"User"
	},
	LogRecordMeta:{
		id:"FieldMeta",
		level:"FieldMeta",
		type:"FieldMeta",
		message:"FieldMeta",
		data:"FieldMeta",
		createdAt:"FieldMeta",
		shouldBeResolved:"FieldMeta",
		resolvedAt:"FieldMeta",
		resolvedBy:"FieldMeta"
	},
	LogRecordConnection:{
		pageInfo:"PageInfo",
		edges:"LogRecordEdge"
	},
	LogRecordEdge:{
		node:"LogRecord"
	},
	VirtualProductConnection:{
		pageInfo:"PageInfo",
		edges:"VirtualProductEdge"
	},
	VirtualProductEdge:{
		node:"VirtualProduct"
	},
	ProductMetadataConnection:{
		pageInfo:"PageInfo",
		edges:"ProductMetadataEdge"
	},
	ProductMetadataEdge:{
		node:"ProductMetadata"
	},
	WorkMonthConnection:{
		pageInfo:"PageInfo",
		edges:"WorkMonthEdge"
	},
	WorkMonthEdge:{
		node:"WorkMonth"
	},
	SalaryOptions:{
		_meta:"SalaryOptionsMeta",
		id:"UUID",
		overtimeMultiplier:"Float",
		publicHolidayMultiplier:"Float",
		weekendMultiplier:"Float",
		unique:"One",
		partTimeMonthlySalaryLimit:"Int"
	},
	SalaryOptionsMeta:{
		id:"FieldMeta",
		overtimeMultiplier:"FieldMeta",
		publicHolidayMultiplier:"FieldMeta",
		weekendMultiplier:"FieldMeta",
		unique:"FieldMeta",
		partTimeMonthlySalaryLimit:"FieldMeta"
	},
	SalaryOptionsConnection:{
		pageInfo:"PageInfo",
		edges:"SalaryOptionsEdge"
	},
	SalaryOptionsEdge:{
		node:"SalaryOptions"
	},
	TimetableShiftSwapInfoConnection:{
		pageInfo:"PageInfo",
		edges:"TimetableShiftSwapInfoEdge"
	},
	TimetableShiftSwapInfoEdge:{
		node:"TimetableShiftSwapInfo"
	},
	CashierConnection:{
		pageInfo:"PageInfo",
		edges:"CashierEdge"
	},
	CashierEdge:{
		node:"Cashier"
	},
	AnonymousSessionConnection:{
		pageInfo:"PageInfo",
		edges:"AnonymousSessionEdge"
	},
	AnonymousSessionEdge:{
		node:"AnonymousSession"
	},
	UnassignedShiftInfoConnection:{
		pageInfo:"PageInfo",
		edges:"UnassignedShiftInfoEdge"
	},
	UnassignedShiftInfoEdge:{
		node:"UnassignedShiftInfo"
	},
	TextListConnection:{
		pageInfo:"PageInfo",
		edges:"TextListEdge"
	},
	TextListEdge:{
		node:"TextList"
	},
	EmployeeQueueItemMetadataConnection:{
		pageInfo:"PageInfo",
		edges:"EmployeeQueueItemMetadataEdge"
	},
	EmployeeQueueItemMetadataEdge:{
		node:"EmployeeQueueItemMetadata"
	},
	DeliveryRegionsConnection:{
		pageInfo:"PageInfo",
		edges:"DeliveryRegionsEdge"
	},
	DeliveryRegionsEdge:{
		node:"DeliveryRegions"
	},
	ImageListConnection:{
		pageInfo:"PageInfo",
		edges:"ImageListEdge"
	},
	ImageListEdge:{
		node:"ImageList"
	},
	TimetablesEmployeePrivilegesConnection:{
		pageInfo:"PageInfo",
		edges:"TimetablesEmployeePrivilegesEdge"
	},
	TimetablesEmployeePrivilegesEdge:{
		node:"TimetablesEmployeePrivileges"
	},
	IngredientSupplierConnection:{
		pageInfo:"PageInfo",
		edges:"IngredientSupplierEdge"
	},
	IngredientSupplierEdge:{
		node:"IngredientSupplier"
	},
	IngredientSupplierListConnection:{
		pageInfo:"PageInfo",
		edges:"IngredientSupplierListEdge"
	},
	IngredientSupplierListEdge:{
		node:"IngredientSupplierList"
	},
	RedirectConnection:{
		pageInfo:"PageInfo",
		edges:"RedirectEdge"
	},
	RedirectEdge:{
		node:"Redirect"
	},
	NutritionFactsConnection:{
		pageInfo:"PageInfo",
		edges:"NutritionFactsEdge"
	},
	NutritionFactsEdge:{
		node:"NutritionFacts"
	},
	WorkspaceConnection:{
		pageInfo:"PageInfo",
		edges:"WorkspaceEdge"
	},
	WorkspaceEdge:{
		node:"Workspace"
	},
	InternalBuyerConnection:{
		pageInfo:"PageInfo",
		edges:"InternalBuyerEdge"
	},
	InternalBuyerEdge:{
		node:"InternalBuyer"
	},
	CartSummaryConnection:{
		pageInfo:"PageInfo",
		edges:"CartSummaryEdge"
	},
	CartSummaryEdge:{
		node:"CartSummary"
	},
	OrderSummaryConnection:{
		pageInfo:"PageInfo",
		edges:"OrderSummaryEdge"
	},
	OrderSummaryEdge:{
		node:"OrderSummary"
	},
	CustomerSpendingConnection:{
		pageInfo:"PageInfo",
		edges:"CustomerSpendingEdge"
	},
	CustomerSpendingEdge:{
		node:"CustomerSpending"
	},
	OrderPaymentMetadataConnection:{
		pageInfo:"PageInfo",
		edges:"OrderPaymentMetadataEdge"
	},
	OrderPaymentMetadataEdge:{
		node:"OrderPaymentMetadata"
	},
	UserMetadataConnection:{
		pageInfo:"PageInfo",
		edges:"UserMetadataEdge"
	},
	UserMetadataEdge:{
		node:"UserMetadata"
	},
	CustomerTabMetadataConnection:{
		pageInfo:"PageInfo",
		edges:"CustomerTabMetadataEdge"
	},
	CustomerTabMetadataEdge:{
		node:"CustomerTabMetadata"
	},
	IdentificationCodeConnection:{
		pageInfo:"PageInfo",
		edges:"IdentificationCodeEdge"
	},
	IdentificationCodeEdge:{
		node:"IdentificationCode"
	},
	PipelineConnection:{
		pageInfo:"PageInfo",
		edges:"PipelineEdge"
	},
	PipelineEdge:{
		node:"Pipeline"
	},
	SalesManagerConnection:{
		pageInfo:"PageInfo",
		edges:"SalesManagerEdge"
	},
	SalesManagerEdge:{
		node:"SalesManager"
	},
	CashierManagerConnection:{
		pageInfo:"PageInfo",
		edges:"CashierManagerEdge"
	},
	CashierManagerEdge:{
		node:"CashierManager"
	},
	UserRolesConnection:{
		pageInfo:"PageInfo",
		edges:"UserRolesEdge"
	},
	UserRolesEdge:{
		node:"UserRoles"
	},
	PipelineStageSentimentConnection:{
		pageInfo:"PageInfo",
		edges:"PipelineStageSentimentEdge"
	},
	PipelineStageSentimentEdge:{
		node:"PipelineStageSentiment"
	},
	DeviceIdentifierConnection:{
		pageInfo:"PageInfo",
		edges:"DeviceIdentifierEdge"
	},
	DeviceIdentifierEdge:{
		node:"DeviceIdentifier"
	},
	DeviceIdentifierMetadataConnection:{
		pageInfo:"PageInfo",
		edges:"DeviceIdentifierMetadataEdge"
	},
	DeviceIdentifierMetadataEdge:{
		node:"DeviceIdentifierMetadata"
	},
	GratuityConnection:{
		pageInfo:"PageInfo",
		edges:"GratuityEdge"
	},
	GratuityEdge:{
		node:"Gratuity"
	},
	CustomerMetadataConnection:{
		pageInfo:"PageInfo",
		edges:"CustomerMetadataEdge"
	},
	CustomerMetadataEdge:{
		node:"CustomerMetadata"
	},
	SubscriptionBoxConnection:{
		pageInfo:"PageInfo",
		edges:"SubscriptionBoxEdge"
	},
	SubscriptionBoxEdge:{
		node:"SubscriptionBox"
	},
	TimetableDayMetadataConnection:{
		pageInfo:"PageInfo",
		edges:"TimetableDayMetadataEdge"
	},
	TimetableDayMetadataEdge:{
		node:"TimetableDayMetadata"
	},
	BusinessServiceConnection:{
		pageInfo:"PageInfo",
		edges:"BusinessServiceEdge"
	},
	BusinessServiceEdge:{
		node:"BusinessService"
	},
	GridTilesConnection:{
		pageInfo:"PageInfo",
		edges:"GridTilesEdge"
	},
	GridTilesEdge:{
		node:"GridTiles"
	},
	Position:{
		_meta:"PositionMeta",
		id:"UUID",
		x:"Int",
		y:"Int"
	},
	PositionMeta:{
		id:"FieldMeta",
		x:"FieldMeta",
		y:"FieldMeta"
	},
	PositionConnection:{
		pageInfo:"PageInfo",
		edges:"PositionEdge"
	},
	PositionEdge:{
		node:"Position"
	},
	StatsEnabledWidgetType:{
		_meta:"StatsEnabledWidgetTypeMeta",
		id:"UUID",
		type:"StatsEnabledWidgetTypeType",
		layout:"StatsWidgetsLayout"
	},
	StatsEnabledWidgetTypeMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		layout:"FieldMeta"
	},
	StatsWidgetsLayout:{
		_meta:"StatsWidgetsLayoutMeta",
		id:"UUID",
		enabledWidgetTypes:"StatsEnabledWidgetType",
		items:"StatsWidget",
		enabledWidgetTypesByType:"StatsEnabledWidgetType",
		paginateEnabledWidgetTypes:"StatsEnabledWidgetTypeConnection",
		paginateItems:"StatsWidgetConnection"
	},
	StatsWidgetsLayoutMeta:{
		id:"FieldMeta",
		enabledWidgetTypes:"FieldMeta",
		items:"FieldMeta"
	},
	StatsWidget:{
		_meta:"StatsWidgetMeta",
		id:"UUID",
		order:"Int",
		size:"Int",
		type:"StatsEnabledWidgetTypeType",
		link:"String",
		title:"String",
		timeFrame:"StatsWidgetTimeFrame",
		layout:"StatsWidgetsLayout",
		icon:"Image",
		channels:"Channel",
		productCategory:"ProductCategory",
		paymentMethods:"PaymentMethod",
		hoursFrom:"String",
		hoursTo:"String",
		paginateChannels:"ChannelConnection",
		paginatePaymentMethods:"PaymentMethodConnection"
	},
	StatsWidgetMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		size:"FieldMeta",
		type:"FieldMeta",
		link:"FieldMeta",
		title:"FieldMeta",
		timeFrame:"FieldMeta",
		layout:"FieldMeta",
		icon:"FieldMeta",
		channels:"FieldMeta",
		productCategory:"FieldMeta",
		paymentMethods:"FieldMeta",
		hoursFrom:"FieldMeta",
		hoursTo:"FieldMeta"
	},
	StatsEnabledWidgetTypeConnection:{
		pageInfo:"PageInfo",
		edges:"StatsEnabledWidgetTypeEdge"
	},
	StatsEnabledWidgetTypeEdge:{
		node:"StatsEnabledWidgetType"
	},
	StatsWidgetConnection:{
		pageInfo:"PageInfo",
		edges:"StatsWidgetEdge"
	},
	StatsWidgetEdge:{
		node:"StatsWidget"
	},
	StatsWidgetsLayoutConnection:{
		pageInfo:"PageInfo",
		edges:"StatsWidgetsLayoutEdge"
	},
	StatsWidgetsLayoutEdge:{
		node:"StatsWidgetsLayout"
	},
	StatsPage:{
		_meta:"StatsPageMeta",
		id:"UUID",
		type:"StatsPageType",
		enabled:"Boolean",
		widgets:"StatsWidgetsLayout"
	},
	StatsPageMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		enabled:"FieldMeta",
		widgets:"FieldMeta"
	},
	StatsPageConnection:{
		pageInfo:"PageInfo",
		edges:"StatsPageEdge"
	},
	StatsPageEdge:{
		node:"StatsPage"
	},
	DoubleshotCoffeeEquipmentConnection:{
		pageInfo:"PageInfo",
		edges:"DoubleshotCoffeeEquipmentEdge"
	},
	DoubleshotCoffeeEquipmentEdge:{
		node:"DoubleshotCoffeeEquipment"
	},
	Expense:{
		_meta:"ExpenseMeta",
		id:"UUID",
		name:"String",
		type:"ExpenseType",
		category:"ExpenseCategory",
		supplier:"IngredientSupplier",
		changes:"ExpenseChange",
		documents:"ExpenseDocument",
		terms:"ExpenseTerm",
		venue:"Venue",
		paidByCash:"Boolean",
		changesByDate:"ExpenseChange",
		documentsByFile:"ExpenseDocument",
		paginateChanges:"ExpenseChangeConnection",
		paginateDocuments:"ExpenseDocumentConnection",
		paginateTerms:"ExpenseTermConnection"
	},
	ExpenseMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		type:"FieldMeta",
		category:"FieldMeta",
		supplier:"FieldMeta",
		changes:"FieldMeta",
		documents:"FieldMeta",
		terms:"FieldMeta",
		venue:"FieldMeta",
		paidByCash:"FieldMeta"
	},
	ExpenseCategory:{
		_meta:"ExpenseCategoryMeta",
		id:"UUID",
		name:"String",
		items:"Expense",
		order:"Int",
		itemsByChanges:"Expense",
		itemsByDocuments:"Expense",
		itemsByTerms:"Expense",
		paginateItems:"ExpenseConnection"
	},
	ExpenseCategoryMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		items:"FieldMeta",
		order:"FieldMeta"
	},
	ExpenseConnection:{
		pageInfo:"PageInfo",
		edges:"ExpenseEdge"
	},
	ExpenseEdge:{
		node:"Expense"
	},
	ExpenseChange:{
		_meta:"ExpenseChangeMeta",
		id:"UUID",
		date:"Date",
		amountCents:"Int",
		expense:"Expense"
	},
	ExpenseChangeMeta:{
		id:"FieldMeta",
		date:"FieldMeta",
		amountCents:"FieldMeta",
		expense:"FieldMeta"
	},
	ExpenseDocument:{
		_meta:"ExpenseDocumentMeta",
		id:"UUID",
		expense:"Expense",
		amountCents:"Int",
		file:"File",
		date:"Date",
		termDate:"Date"
	},
	ExpenseDocumentMeta:{
		id:"FieldMeta",
		expense:"FieldMeta",
		amountCents:"FieldMeta",
		file:"FieldMeta",
		date:"FieldMeta",
		termDate:"FieldMeta"
	},
	File:{
		_meta:"FileMeta",
		id:"UUID",
		url:"String",
		size:"Int",
		type:"String",
		name:"String"
	},
	FileMeta:{
		id:"FieldMeta",
		url:"FieldMeta",
		size:"FieldMeta",
		type:"FieldMeta",
		name:"FieldMeta"
	},
	ExpenseTerm:{
		_meta:"ExpenseTermMeta",
		id:"String",
		date:"Date",
		amountCents:"Int",
		expense:"Expense"
	},
	ExpenseTermMeta:{
		id:"FieldMeta",
		date:"FieldMeta",
		amountCents:"FieldMeta",
		expense:"FieldMeta"
	},
	ExpenseChangeConnection:{
		pageInfo:"PageInfo",
		edges:"ExpenseChangeEdge"
	},
	ExpenseChangeEdge:{
		node:"ExpenseChange"
	},
	ExpenseDocumentConnection:{
		pageInfo:"PageInfo",
		edges:"ExpenseDocumentEdge"
	},
	ExpenseDocumentEdge:{
		node:"ExpenseDocument"
	},
	ExpenseTermConnection:{
		pageInfo:"PageInfo",
		edges:"ExpenseTermEdge"
	},
	ExpenseTermEdge:{
		node:"ExpenseTerm"
	},
	ExpenseCategoryConnection:{
		pageInfo:"PageInfo",
		edges:"ExpenseCategoryEdge"
	},
	ExpenseCategoryEdge:{
		node:"ExpenseCategory"
	},
	RevenuePrediction:{
		_meta:"RevenuePredictionMeta",
		id:"UUID",
		name:"String",
		type:"RevenuePredictionType",
		channel:"Channel",
		changes:"RevenuePredictionChange",
		alwaysIncludeInTotalRevenue:"Boolean",
		recurrencePeriod:"RecurrencePeriod",
		monday:"Boolean",
		tuesday:"Boolean",
		wednesday:"Boolean",
		thursday:"Boolean",
		friday:"Boolean",
		saturday:"Boolean",
		sunday:"Boolean",
		terms:"RevenuePredictionTerm",
		paymentMethod:"PaymentMethod",
		changesByDate:"RevenuePredictionChange",
		paginateChanges:"RevenuePredictionChangeConnection",
		paginateTerms:"RevenuePredictionTermConnection"
	},
	RevenuePredictionMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		type:"FieldMeta",
		channel:"FieldMeta",
		changes:"FieldMeta",
		alwaysIncludeInTotalRevenue:"FieldMeta",
		recurrencePeriod:"FieldMeta",
		monday:"FieldMeta",
		tuesday:"FieldMeta",
		wednesday:"FieldMeta",
		thursday:"FieldMeta",
		friday:"FieldMeta",
		saturday:"FieldMeta",
		sunday:"FieldMeta",
		terms:"FieldMeta",
		paymentMethod:"FieldMeta"
	},
	RevenuePredictionChange:{
		_meta:"RevenuePredictionChangeMeta",
		id:"UUID",
		date:"Date",
		amountCents:"Int",
		prediction:"RevenuePrediction"
	},
	RevenuePredictionChangeMeta:{
		id:"FieldMeta",
		date:"FieldMeta",
		amountCents:"FieldMeta",
		prediction:"FieldMeta"
	},
	RevenuePredictionTerm:{
		_meta:"RevenuePredictionTermMeta",
		id:"String",
		date:"Date",
		amountCents:"Int",
		prediction:"RevenuePrediction"
	},
	RevenuePredictionTermMeta:{
		id:"FieldMeta",
		date:"FieldMeta",
		amountCents:"FieldMeta",
		prediction:"FieldMeta"
	},
	RevenuePredictionChangeConnection:{
		pageInfo:"PageInfo",
		edges:"RevenuePredictionChangeEdge"
	},
	RevenuePredictionChangeEdge:{
		node:"RevenuePredictionChange"
	},
	RevenuePredictionTermConnection:{
		pageInfo:"PageInfo",
		edges:"RevenuePredictionTermEdge"
	},
	RevenuePredictionTermEdge:{
		node:"RevenuePredictionTerm"
	},
	RevenuePredictionConnection:{
		pageInfo:"PageInfo",
		edges:"RevenuePredictionEdge"
	},
	RevenuePredictionEdge:{
		node:"RevenuePrediction"
	},
	FileConnection:{
		pageInfo:"PageInfo",
		edges:"FileEdge"
	},
	FileEdge:{
		node:"File"
	},
	FinancesBalanceItem:{
		_meta:"FinancesBalanceItemMeta",
		id:"UUID",
		amountCents:"Int",
		date:"Date",
		venue:"Venue",
		paidByCash:"Boolean"
	},
	FinancesBalanceItemMeta:{
		id:"FieldMeta",
		amountCents:"FieldMeta",
		date:"FieldMeta",
		venue:"FieldMeta",
		paidByCash:"FieldMeta"
	},
	FinancesBalanceItemConnection:{
		pageInfo:"PageInfo",
		edges:"FinancesBalanceItemEdge"
	},
	FinancesBalanceItemEdge:{
		node:"FinancesBalanceItem"
	},
	OrderPaymentStatsByDay:{
		_meta:"OrderPaymentStatsByDayMeta",
		id:"String",
		day:"Date",
		totalGratuityCents:"Int",
		reducedGratuityCents:"Int",
		channel:"Channel",
		paymentMethod:"PaymentMethod"
	},
	OrderPaymentStatsByDayMeta:{
		id:"FieldMeta",
		day:"FieldMeta",
		totalGratuityCents:"FieldMeta",
		reducedGratuityCents:"FieldMeta",
		channel:"FieldMeta",
		paymentMethod:"FieldMeta"
	},
	OrderPaymentStatsByDayConnection:{
		pageInfo:"PageInfo",
		edges:"OrderPaymentStatsByDayEdge"
	},
	OrderPaymentStatsByDayEdge:{
		node:"OrderPaymentStatsByDay"
	},
	WoltDriveDeliveryConnection:{
		pageInfo:"PageInfo",
		edges:"WoltDriveDeliveryEdge"
	},
	WoltDriveDeliveryEdge:{
		node:"WoltDriveDelivery"
	},
	QueryTransaction:{
		getAddress:"Address",
		listAddress:"Address",
		paginateAddress:"AddressConnection",
		validateCreateAddress:"_ValidationResult",
		validateUpdateAddress:"_ValidationResult",
		getCountry:"Country",
		listCountry:"Country",
		paginateCountry:"CountryConnection",
		validateCreateCountry:"_ValidationResult",
		validateUpdateCountry:"_ValidationResult",
		getChannel:"Channel",
		listChannel:"Channel",
		paginateChannel:"ChannelConnection",
		validateCreateChannel:"_ValidationResult",
		validateUpdateChannel:"_ValidationResult",
		getChannelPayment:"ChannelPayment",
		listChannelPayment:"ChannelPayment",
		paginateChannelPayment:"ChannelPaymentConnection",
		validateCreateChannelPayment:"_ValidationResult",
		validateUpdateChannelPayment:"_ValidationResult",
		getChannelDelivery:"ChannelDelivery",
		listChannelDelivery:"ChannelDelivery",
		paginateChannelDelivery:"ChannelDeliveryConnection",
		validateCreateChannelDelivery:"_ValidationResult",
		validateUpdateChannelDelivery:"_ValidationResult",
		getCustomer:"Customer",
		listCustomer:"Customer",
		paginateCustomer:"CustomerConnection",
		validateCreateCustomer:"_ValidationResult",
		validateUpdateCustomer:"_ValidationResult",
		getCustomerCredit:"CustomerCredit",
		listCustomerCredit:"CustomerCredit",
		paginateCustomerCredit:"CustomerCreditConnection",
		validateCreateCustomerCredit:"_ValidationResult",
		validateUpdateCustomerCredit:"_ValidationResult",
		getCustomerGroup:"CustomerGroup",
		listCustomerGroup:"CustomerGroup",
		paginateCustomerGroup:"CustomerGroupConnection",
		validateCreateCustomerGroup:"_ValidationResult",
		validateUpdateCustomerGroup:"_ValidationResult",
		getCustomerPaymentMethod:"CustomerPaymentMethod",
		listCustomerPaymentMethod:"CustomerPaymentMethod",
		paginateCustomerPaymentMethod:"CustomerPaymentMethodConnection",
		validateCreateCustomerPaymentMethod:"_ValidationResult",
		validateUpdateCustomerPaymentMethod:"_ValidationResult",
		getDeliveryMethod:"DeliveryMethod",
		listDeliveryMethod:"DeliveryMethod",
		paginateDeliveryMethod:"DeliveryMethodConnection",
		validateCreateDeliveryMethod:"_ValidationResult",
		validateUpdateDeliveryMethod:"_ValidationResult",
		getOrder:"Order",
		listOrder:"Order",
		paginateOrder:"OrderConnection",
		validateCreateOrder:"_ValidationResult",
		validateUpdateOrder:"_ValidationResult",
		getOrderDiscount:"OrderDiscount",
		listOrderDiscount:"OrderDiscount",
		paginateOrderDiscount:"OrderDiscountConnection",
		validateCreateOrderDiscount:"_ValidationResult",
		validateUpdateOrderDiscount:"_ValidationResult",
		getOrderPayment:"OrderPayment",
		listOrderPayment:"OrderPayment",
		paginateOrderPayment:"OrderPaymentConnection",
		validateCreateOrderPayment:"_ValidationResult",
		validateUpdateOrderPayment:"_ValidationResult",
		getOrderDelivery:"OrderDelivery",
		listOrderDelivery:"OrderDelivery",
		paginateOrderDelivery:"OrderDeliveryConnection",
		validateCreateOrderDelivery:"_ValidationResult",
		validateUpdateOrderDelivery:"_ValidationResult",
		getOrderItem:"OrderItem",
		listOrderItem:"OrderItem",
		paginateOrderItem:"OrderItemConnection",
		validateCreateOrderItem:"_ValidationResult",
		validateUpdateOrderItem:"_ValidationResult",
		getPaymentMethod:"PaymentMethod",
		listPaymentMethod:"PaymentMethod",
		paginatePaymentMethod:"PaymentMethodConnection",
		validateCreatePaymentMethod:"_ValidationResult",
		validateUpdatePaymentMethod:"_ValidationResult",
		getVatRate:"VatRate",
		listVatRate:"VatRate",
		paginateVatRate:"VatRateConnection",
		validateCreateVatRate:"_ValidationResult",
		validateUpdateVatRate:"_ValidationResult",
		getProduct:"Product",
		listProduct:"Product",
		paginateProduct:"ProductConnection",
		validateCreateProduct:"_ValidationResult",
		validateUpdateProduct:"_ValidationResult",
		getProductStock:"ProductStock",
		listProductStock:"ProductStock",
		paginateProductStock:"ProductStockConnection",
		validateCreateProductStock:"_ValidationResult",
		validateUpdateProductStock:"_ValidationResult",
		getProductPacking:"ProductPacking",
		listProductPacking:"ProductPacking",
		paginateProductPacking:"ProductPackingConnection",
		validateCreateProductPacking:"_ValidationResult",
		validateUpdateProductPacking:"_ValidationResult",
		getProductGroupPrice:"ProductGroupPrice",
		listProductGroupPrice:"ProductGroupPrice",
		paginateProductGroupPrice:"ProductGroupPriceConnection",
		validateCreateProductGroupPrice:"_ValidationResult",
		validateUpdateProductGroupPrice:"_ValidationResult",
		getProductRecipe:"ProductRecipe",
		listProductRecipe:"ProductRecipe",
		paginateProductRecipe:"ProductRecipeConnection",
		validateCreateProductRecipe:"_ValidationResult",
		validateUpdateProductRecipe:"_ValidationResult",
		getProductCategory:"ProductCategory",
		listProductCategory:"ProductCategory",
		paginateProductCategory:"ProductCategoryConnection",
		validateCreateProductCategory:"_ValidationResult",
		validateUpdateProductCategory:"_ValidationResult",
		getStore:"Store",
		listStore:"Store",
		paginateStore:"StoreConnection",
		validateCreateStore:"_ValidationResult",
		validateUpdateStore:"_ValidationResult",
		getTag:"Tag",
		listTag:"Tag",
		paginateTag:"TagConnection",
		validateCreateTag:"_ValidationResult",
		validateUpdateTag:"_ValidationResult",
		getCustomerPermissions:"CustomerPermissions",
		listCustomerPermissions:"CustomerPermissions",
		paginateCustomerPermissions:"CustomerPermissionsConnection",
		getImage:"Image",
		listImage:"Image",
		paginateImage:"ImageConnection",
		validateCreateImage:"_ValidationResult",
		validateUpdateImage:"_ValidationResult",
		getBusinessCategory:"BusinessCategory",
		listBusinessCategory:"BusinessCategory",
		paginateBusinessCategory:"BusinessCategoryConnection",
		validateCreateBusinessCategory:"_ValidationResult",
		validateUpdateBusinessCategory:"_ValidationResult",
		getProductList:"ProductList",
		listProductList:"ProductList",
		paginateProductList:"ProductListConnection",
		validateCreateProductList:"_ValidationResult",
		validateUpdateProductList:"_ValidationResult",
		getProductListItem:"ProductListItem",
		listProductListItem:"ProductListItem",
		paginateProductListItem:"ProductListItemConnection",
		validateCreateProductListItem:"_ValidationResult",
		validateUpdateProductListItem:"_ValidationResult",
		getProductCategoryList:"ProductCategoryList",
		listProductCategoryList:"ProductCategoryList",
		paginateProductCategoryList:"ProductCategoryListConnection",
		validateCreateProductCategoryList:"_ValidationResult",
		validateUpdateProductCategoryList:"_ValidationResult",
		getProductCategoryListItem:"ProductCategoryListItem",
		listProductCategoryListItem:"ProductCategoryListItem",
		paginateProductCategoryListItem:"ProductCategoryListItemConnection",
		validateCreateProductCategoryListItem:"_ValidationResult",
		validateUpdateProductCategoryListItem:"_ValidationResult",
		getBusinessCategoryLocale:"BusinessCategoryLocale",
		listBusinessCategoryLocale:"BusinessCategoryLocale",
		paginateBusinessCategoryLocale:"BusinessCategoryLocaleConnection",
		validateCreateBusinessCategoryLocale:"_ValidationResult",
		validateUpdateBusinessCategoryLocale:"_ValidationResult",
		getLocale:"Locale",
		listLocale:"Locale",
		paginateLocale:"LocaleConnection",
		validateCreateLocale:"_ValidationResult",
		validateUpdateLocale:"_ValidationResult",
		getProductCategoryListLocale:"ProductCategoryListLocale",
		listProductCategoryListLocale:"ProductCategoryListLocale",
		paginateProductCategoryListLocale:"ProductCategoryListLocaleConnection",
		validateCreateProductCategoryListLocale:"_ValidationResult",
		validateUpdateProductCategoryListLocale:"_ValidationResult",
		getCustomerName:"CustomerName",
		listCustomerName:"CustomerName",
		paginateCustomerName:"CustomerNameConnection",
		validateCreateCustomerName:"_ValidationResult",
		validateUpdateCustomerName:"_ValidationResult",
		getCustomerAlias:"CustomerAlias",
		listCustomerAlias:"CustomerAlias",
		paginateCustomerAlias:"CustomerAliasConnection",
		validateCreateCustomerAlias:"_ValidationResult",
		validateUpdateCustomerAlias:"_ValidationResult",
		getProductIngredientItem:"ProductIngredientItem",
		listProductIngredientItem:"ProductIngredientItem",
		paginateProductIngredientItem:"ProductIngredientItemConnection",
		validateCreateProductIngredientItem:"_ValidationResult",
		validateUpdateProductIngredientItem:"_ValidationResult",
		getProductIngredientItemQuantity:"ProductIngredientItemQuantity",
		listProductIngredientItemQuantity:"ProductIngredientItemQuantity",
		paginateProductIngredientItemQuantity:"ProductIngredientItemQuantityConnection",
		validateCreateProductIngredientItemQuantity:"_ValidationResult",
		validateUpdateProductIngredientItemQuantity:"_ValidationResult",
		getProductIngredientItemQuantityUnit:"ProductIngredientItemQuantityUnit",
		listProductIngredientItemQuantityUnit:"ProductIngredientItemQuantityUnit",
		paginateProductIngredientItemQuantityUnit:"ProductIngredientItemQuantityUnitConnection",
		validateCreateProductIngredientItemQuantityUnit:"_ValidationResult",
		validateUpdateProductIngredientItemQuantityUnit:"_ValidationResult",
		getProductIngredient:"ProductIngredient",
		listProductIngredient:"ProductIngredient",
		paginateProductIngredient:"ProductIngredientConnection",
		validateCreateProductIngredient:"_ValidationResult",
		validateUpdateProductIngredient:"_ValidationResult",
		getCustomerIngredientRating:"CustomerIngredientRating",
		listCustomerIngredientRating:"CustomerIngredientRating",
		paginateCustomerIngredientRating:"CustomerIngredientRatingConnection",
		validateCreateCustomerIngredientRating:"_ValidationResult",
		validateUpdateCustomerIngredientRating:"_ValidationResult",
		getProductIngredientRating:"ProductIngredientRating",
		listProductIngredientRating:"ProductIngredientRating",
		paginateProductIngredientRating:"ProductIngredientRatingConnection",
		validateCreateProductIngredientRating:"_ValidationResult",
		validateUpdateProductIngredientRating:"_ValidationResult",
		getProductIngredientLocale:"ProductIngredientLocale",
		listProductIngredientLocale:"ProductIngredientLocale",
		paginateProductIngredientLocale:"ProductIngredientLocaleConnection",
		validateCreateProductIngredientLocale:"_ValidationResult",
		validateUpdateProductIngredientLocale:"_ValidationResult",
		getOrderRecurrence:"OrderRecurrence",
		listOrderRecurrence:"OrderRecurrence",
		paginateOrderRecurrence:"OrderRecurrenceConnection",
		validateCreateOrderRecurrence:"_ValidationResult",
		validateUpdateOrderRecurrence:"_ValidationResult",
		getOrderRecurrenceLocale:"OrderRecurrenceLocale",
		listOrderRecurrenceLocale:"OrderRecurrenceLocale",
		paginateOrderRecurrenceLocale:"OrderRecurrenceLocaleConnection",
		validateCreateOrderRecurrenceLocale:"_ValidationResult",
		validateUpdateOrderRecurrenceLocale:"_ValidationResult",
		getBusinessCustomer:"BusinessCustomer",
		listBusinessCustomer:"BusinessCustomer",
		paginateBusinessCustomer:"BusinessCustomerConnection",
		validateCreateBusinessCustomer:"_ValidationResult",
		validateUpdateBusinessCustomer:"_ValidationResult",
		getPointOfSale:"PointOfSale",
		listPointOfSale:"PointOfSale",
		paginatePointOfSale:"PointOfSaleConnection",
		validateCreatePointOfSale:"_ValidationResult",
		validateUpdatePointOfSale:"_ValidationResult",
		getStaff:"Staff",
		listStaff:"Staff",
		paginateStaff:"StaffConnection",
		validateCreateStaff:"_ValidationResult",
		validateUpdateStaff:"_ValidationResult",
		getPointOfSalePermissions:"PointOfSalePermissions",
		listPointOfSalePermissions:"PointOfSalePermissions",
		paginatePointOfSalePermissions:"PointOfSalePermissionsConnection",
		getBlog:"Blog",
		listBlog:"Blog",
		paginateBlog:"BlogConnection",
		validateCreateBlog:"_ValidationResult",
		validateUpdateBlog:"_ValidationResult",
		getBlogLocale:"BlogLocale",
		listBlogLocale:"BlogLocale",
		paginateBlogLocale:"BlogLocaleConnection",
		validateCreateBlogLocale:"_ValidationResult",
		validateUpdateBlogLocale:"_ValidationResult",
		getBlogPost:"BlogPost",
		listBlogPost:"BlogPost",
		paginateBlogPost:"BlogPostConnection",
		validateCreateBlogPost:"_ValidationResult",
		validateUpdateBlogPost:"_ValidationResult",
		getBlogPostLocale:"BlogPostLocale",
		listBlogPostLocale:"BlogPostLocale",
		paginateBlogPostLocale:"BlogPostLocaleConnection",
		validateCreateBlogPostLocale:"_ValidationResult",
		validateUpdateBlogPostLocale:"_ValidationResult",
		getColorPallete:"ColorPallete",
		listColorPallete:"ColorPallete",
		paginateColorPallete:"ColorPalleteConnection",
		validateCreateColorPallete:"_ValidationResult",
		validateUpdateColorPallete:"_ValidationResult",
		getContent:"Content",
		listContent:"Content",
		paginateContent:"ContentConnection",
		validateCreateContent:"_ValidationResult",
		validateUpdateContent:"_ValidationResult",
		getContentBlock:"ContentBlock",
		listContentBlock:"ContentBlock",
		paginateContentBlock:"ContentBlockConnection",
		validateCreateContentBlock:"_ValidationResult",
		validateUpdateContentBlock:"_ValidationResult",
		getContentReference:"ContentReference",
		listContentReference:"ContentReference",
		paginateContentReference:"ContentReferenceConnection",
		validateCreateContentReference:"_ValidationResult",
		validateUpdateContentReference:"_ValidationResult",
		getBlogPostList:"BlogPostList",
		listBlogPostList:"BlogPostList",
		paginateBlogPostList:"BlogPostListConnection",
		validateCreateBlogPostList:"_ValidationResult",
		validateUpdateBlogPostList:"_ValidationResult",
		getBlogPostListItem:"BlogPostListItem",
		listBlogPostListItem:"BlogPostListItem",
		paginateBlogPostListItem:"BlogPostListItemConnection",
		validateCreateBlogPostListItem:"_ValidationResult",
		validateUpdateBlogPostListItem:"_ValidationResult",
		getLinkList:"LinkList",
		listLinkList:"LinkList",
		paginateLinkList:"LinkListConnection",
		validateCreateLinkList:"_ValidationResult",
		validateUpdateLinkList:"_ValidationResult",
		getLinkListItem:"LinkListItem",
		listLinkListItem:"LinkListItem",
		paginateLinkListItem:"LinkListItemConnection",
		validateCreateLinkListItem:"_ValidationResult",
		validateUpdateLinkListItem:"_ValidationResult",
		getCover:"Cover",
		listCover:"Cover",
		paginateCover:"CoverConnection",
		validateCreateCover:"_ValidationResult",
		validateUpdateCover:"_ValidationResult",
		getLink:"Link",
		listLink:"Link",
		paginateLink:"LinkConnection",
		validateCreateLink:"_ValidationResult",
		validateUpdateLink:"_ValidationResult",
		getLinkable:"Linkable",
		listLinkable:"Linkable",
		paginateLinkable:"LinkableConnection",
		validateCreateLinkable:"_ValidationResult",
		validateUpdateLinkable:"_ValidationResult",
		getMedium:"Medium",
		listMedium:"Medium",
		paginateMedium:"MediumConnection",
		validateCreateMedium:"_ValidationResult",
		validateUpdateMedium:"_ValidationResult",
		getVideo:"Video",
		listVideo:"Video",
		paginateVideo:"VideoConnection",
		validateCreateVideo:"_ValidationResult",
		validateUpdateVideo:"_ValidationResult",
		getSeo:"Seo",
		listSeo:"Seo",
		paginateSeo:"SeoConnection",
		validateCreateSeo:"_ValidationResult",
		validateUpdateSeo:"_ValidationResult",
		getProtectedImage:"ProtectedImage",
		listProtectedImage:"ProtectedImage",
		paginateProtectedImage:"ProtectedImageConnection",
		validateCreateProtectedImage:"_ValidationResult",
		validateUpdateProtectedImage:"_ValidationResult",
		getTranslationDomain:"TranslationDomain",
		listTranslationDomain:"TranslationDomain",
		paginateTranslationDomain:"TranslationDomainConnection",
		validateCreateTranslationDomain:"_ValidationResult",
		validateUpdateTranslationDomain:"_ValidationResult",
		getTranslationCatalogue:"TranslationCatalogue",
		listTranslationCatalogue:"TranslationCatalogue",
		paginateTranslationCatalogue:"TranslationCatalogueConnection",
		validateCreateTranslationCatalogue:"_ValidationResult",
		validateUpdateTranslationCatalogue:"_ValidationResult",
		getTranslationKey:"TranslationKey",
		listTranslationKey:"TranslationKey",
		paginateTranslationKey:"TranslationKeyConnection",
		validateCreateTranslationKey:"_ValidationResult",
		validateUpdateTranslationKey:"_ValidationResult",
		getTranslationValue:"TranslationValue",
		listTranslationValue:"TranslationValue",
		paginateTranslationValue:"TranslationValueConnection",
		validateCreateTranslationValue:"_ValidationResult",
		validateUpdateTranslationValue:"_ValidationResult",
		getTranslationCataloguesIdentifier:"TranslationCataloguesIdentifier",
		listTranslationCataloguesIdentifier:"TranslationCataloguesIdentifier",
		paginateTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierConnection",
		validateCreateTranslationCataloguesIdentifier:"_ValidationResult",
		validateUpdateTranslationCataloguesIdentifier:"_ValidationResult",
		getSocialsAndApps:"SocialsAndApps",
		listSocialsAndApps:"SocialsAndApps",
		paginateSocialsAndApps:"SocialsAndAppsConnection",
		validateCreateSocialsAndApps:"_ValidationResult",
		validateUpdateSocialsAndApps:"_ValidationResult",
		getProductGrid:"ProductGrid",
		listProductGrid:"ProductGrid",
		paginateProductGrid:"ProductGridConnection",
		validateCreateProductGrid:"_ValidationResult",
		validateUpdateProductGrid:"_ValidationResult",
		getProductGridItem:"ProductGridItem",
		listProductGridItem:"ProductGridItem",
		paginateProductGridItem:"ProductGridItemConnection",
		validateCreateProductGridItem:"_ValidationResult",
		validateUpdateProductGridItem:"_ValidationResult",
		getGallery:"Gallery",
		listGallery:"Gallery",
		paginateGallery:"GalleryConnection",
		validateCreateGallery:"_ValidationResult",
		validateUpdateGallery:"_ValidationResult",
		getGalleryItem:"GalleryItem",
		listGalleryItem:"GalleryItem",
		paginateGalleryItem:"GalleryItemConnection",
		validateCreateGalleryItem:"_ValidationResult",
		validateUpdateGalleryItem:"_ValidationResult",
		getHero:"Hero",
		listHero:"Hero",
		paginateHero:"HeroConnection",
		validateCreateHero:"_ValidationResult",
		validateUpdateHero:"_ValidationResult",
		getSiteMenu:"SiteMenu",
		listSiteMenu:"SiteMenu",
		paginateSiteMenu:"SiteMenuConnection",
		validateCreateSiteMenu:"_ValidationResult",
		validateUpdateSiteMenu:"_ValidationResult",
		getMenuLocale:"MenuLocale",
		listMenuLocale:"MenuLocale",
		paginateMenuLocale:"MenuLocaleConnection",
		validateCreateMenuLocale:"_ValidationResult",
		validateUpdateMenuLocale:"_ValidationResult",
		getMenuItem:"MenuItem",
		listMenuItem:"MenuItem",
		paginateMenuItem:"MenuItemConnection",
		validateCreateMenuItem:"_ValidationResult",
		validateUpdateMenuItem:"_ValidationResult",
		getPage:"Page",
		listPage:"Page",
		paginatePage:"PageConnection",
		validateCreatePage:"_ValidationResult",
		validateUpdatePage:"_ValidationResult",
		getPageLocale:"PageLocale",
		listPageLocale:"PageLocale",
		paginatePageLocale:"PageLocaleConnection",
		validateCreatePageLocale:"_ValidationResult",
		validateUpdatePageLocale:"_ValidationResult",
		getWikiPage:"WikiPage",
		listWikiPage:"WikiPage",
		paginateWikiPage:"WikiPageConnection",
		validateCreateWikiPage:"_ValidationResult",
		validateUpdateWikiPage:"_ValidationResult",
		getMenuSubitem:"MenuSubitem",
		listMenuSubitem:"MenuSubitem",
		paginateMenuSubitem:"MenuSubitemConnection",
		validateCreateMenuSubitem:"_ValidationResult",
		validateUpdateMenuSubitem:"_ValidationResult",
		getMenuLinkList:"MenuLinkList",
		listMenuLinkList:"MenuLinkList",
		paginateMenuLinkList:"MenuLinkListConnection",
		validateCreateMenuLinkList:"_ValidationResult",
		validateUpdateMenuLinkList:"_ValidationResult",
		getMenuLinkItem:"MenuLinkItem",
		listMenuLinkItem:"MenuLinkItem",
		paginateMenuLinkItem:"MenuLinkItemConnection",
		validateCreateMenuLinkItem:"_ValidationResult",
		validateUpdateMenuLinkItem:"_ValidationResult",
		getMenuProducts:"MenuProducts",
		listMenuProducts:"MenuProducts",
		paginateMenuProducts:"MenuProductsConnection",
		validateCreateMenuProducts:"_ValidationResult",
		validateUpdateMenuProducts:"_ValidationResult",
		getMenuDelivery:"MenuDelivery",
		listMenuDelivery:"MenuDelivery",
		paginateMenuDelivery:"MenuDeliveryConnection",
		validateCreateMenuDelivery:"_ValidationResult",
		validateUpdateMenuDelivery:"_ValidationResult",
		getMenuContact:"MenuContact",
		listMenuContact:"MenuContact",
		paginateMenuContact:"MenuContactConnection",
		validateCreateMenuContact:"_ValidationResult",
		validateUpdateMenuContact:"_ValidationResult",
		getDeadlineTemplate:"DeadlineTemplate",
		listDeadlineTemplate:"DeadlineTemplate",
		paginateDeadlineTemplate:"DeadlineTemplateConnection",
		validateCreateDeadlineTemplate:"_ValidationResult",
		validateUpdateDeadlineTemplate:"_ValidationResult",
		getEmployeeQueue:"EmployeeQueue",
		listEmployeeQueue:"EmployeeQueue",
		paginateEmployeeQueue:"EmployeeQueueConnection",
		validateCreateEmployeeQueue:"_ValidationResult",
		validateUpdateEmployeeQueue:"_ValidationResult",
		getTimetableDay:"TimetableDay",
		listTimetableDay:"TimetableDay",
		paginateTimetableDay:"TimetableDayConnection",
		validateCreateTimetableDay:"_ValidationResult",
		validateUpdateTimetableDay:"_ValidationResult",
		getTimetableEmployeeRole:"TimetableEmployeeRole",
		listTimetableEmployeeRole:"TimetableEmployeeRole",
		paginateTimetableEmployeeRole:"TimetableEmployeeRoleConnection",
		validateCreateTimetableEmployeeRole:"_ValidationResult",
		validateUpdateTimetableEmployeeRole:"_ValidationResult",
		getTimetableShift:"TimetableShift",
		listTimetableShift:"TimetableShift",
		paginateTimetableShift:"TimetableShiftConnection",
		validateCreateTimetableShift:"_ValidationResult",
		validateUpdateTimetableShift:"_ValidationResult",
		getTimetableShiftGroup:"TimetableShiftGroup",
		listTimetableShiftGroup:"TimetableShiftGroup",
		paginateTimetableShiftGroup:"TimetableShiftGroupConnection",
		validateCreateTimetableShiftGroup:"_ValidationResult",
		validateUpdateTimetableShiftGroup:"_ValidationResult",
		getTimetableShiftPosition:"TimetableShiftPosition",
		listTimetableShiftPosition:"TimetableShiftPosition",
		paginateTimetableShiftPosition:"TimetableShiftPositionConnection",
		validateCreateTimetableShiftPosition:"_ValidationResult",
		validateUpdateTimetableShiftPosition:"_ValidationResult",
		getTimetableTemplate:"TimetableTemplate",
		listTimetableTemplate:"TimetableTemplate",
		paginateTimetableTemplate:"TimetableTemplateConnection",
		validateCreateTimetableTemplate:"_ValidationResult",
		validateUpdateTimetableTemplate:"_ValidationResult",
		getCart:"Cart",
		listCart:"Cart",
		paginateCart:"CartConnection",
		validateCreateCart:"_ValidationResult",
		validateUpdateCart:"_ValidationResult",
		getCartItem:"CartItem",
		listCartItem:"CartItem",
		paginateCartItem:"CartItemConnection",
		validateCreateCartItem:"_ValidationResult",
		validateUpdateCartItem:"_ValidationResult",
		getEmployeeQueueItem:"EmployeeQueueItem",
		listEmployeeQueueItem:"EmployeeQueueItem",
		paginateEmployeeQueueItem:"EmployeeQueueItemConnection",
		validateCreateEmployeeQueueItem:"_ValidationResult",
		validateUpdateEmployeeQueueItem:"_ValidationResult",
		getApplication:"Application",
		listApplication:"Application",
		paginateApplication:"ApplicationConnection",
		validateCreateApplication:"_ValidationResult",
		validateUpdateApplication:"_ValidationResult",
		getApplicationShortcutList:"ApplicationShortcutList",
		listApplicationShortcutList:"ApplicationShortcutList",
		paginateApplicationShortcutList:"ApplicationShortcutListConnection",
		validateCreateApplicationShortcutList:"_ValidationResult",
		validateUpdateApplicationShortcutList:"_ValidationResult",
		getApplicationShortcutListItem:"ApplicationShortcutListItem",
		listApplicationShortcutListItem:"ApplicationShortcutListItem",
		paginateApplicationShortcutListItem:"ApplicationShortcutListItemConnection",
		validateCreateApplicationShortcutListItem:"_ValidationResult",
		validateUpdateApplicationShortcutListItem:"_ValidationResult",
		getProductBanner:"ProductBanner",
		listProductBanner:"ProductBanner",
		paginateProductBanner:"ProductBannerConnection",
		validateCreateProductBanner:"_ValidationResult",
		validateUpdateProductBanner:"_ValidationResult",
		getProductBannerItem:"ProductBannerItem",
		listProductBannerItem:"ProductBannerItem",
		paginateProductBannerItem:"ProductBannerItemConnection",
		validateCreateProductBannerItem:"_ValidationResult",
		validateUpdateProductBannerItem:"_ValidationResult",
		getProductBannerList:"ProductBannerList",
		listProductBannerList:"ProductBannerList",
		paginateProductBannerList:"ProductBannerListConnection",
		validateCreateProductBannerList:"_ValidationResult",
		validateUpdateProductBannerList:"_ValidationResult",
		getBartender:"Bartender",
		listBartender:"Bartender",
		paginateBartender:"BartenderConnection",
		validateCreateBartender:"_ValidationResult",
		validateUpdateBartender:"_ValidationResult",
		getBusinessToBusinessManager:"BusinessToBusinessManager",
		listBusinessToBusinessManager:"BusinessToBusinessManager",
		paginateBusinessToBusinessManager:"BusinessToBusinessManagerConnection",
		validateCreateBusinessToBusinessManager:"_ValidationResult",
		validateUpdateBusinessToBusinessManager:"_ValidationResult",
		getCleaner:"Cleaner",
		listCleaner:"Cleaner",
		paginateCleaner:"CleanerConnection",
		validateCreateCleaner:"_ValidationResult",
		validateUpdateCleaner:"_ValidationResult",
		getCourier:"Courier",
		listCourier:"Courier",
		paginateCourier:"CourierConnection",
		validateCreateCourier:"_ValidationResult",
		validateUpdateCourier:"_ValidationResult",
		getShiftsManager:"ShiftsManager",
		listShiftsManager:"ShiftsManager",
		paginateShiftsManager:"ShiftsManagerConnection",
		validateCreateShiftsManager:"_ValidationResult",
		validateUpdateShiftsManager:"_ValidationResult",
		getUser:"User",
		listUser:"User",
		paginateUser:"UserConnection",
		validateCreateUser:"_ValidationResult",
		validateUpdateUser:"_ValidationResult",
		getShiftsProfile:"ShiftsProfile",
		listShiftsProfile:"ShiftsProfile",
		paginateShiftsProfile:"ShiftsProfileConnection",
		validateCreateShiftsProfile:"_ValidationResult",
		validateUpdateShiftsProfile:"_ValidationResult",
		getProductIngredientCategory:"ProductIngredientCategory",
		listProductIngredientCategory:"ProductIngredientCategory",
		paginateProductIngredientCategory:"ProductIngredientCategoryConnection",
		validateCreateProductIngredientCategory:"_ValidationResult",
		validateUpdateProductIngredientCategory:"_ValidationResult",
		getProductIngredientCategoryLocale:"ProductIngredientCategoryLocale",
		listProductIngredientCategoryLocale:"ProductIngredientCategoryLocale",
		paginateProductIngredientCategoryLocale:"ProductIngredientCategoryLocaleConnection",
		validateCreateProductIngredientCategoryLocale:"_ValidationResult",
		validateUpdateProductIngredientCategoryLocale:"_ValidationResult",
		getStocksManager:"StocksManager",
		listStocksManager:"StocksManager",
		paginateStocksManager:"StocksManagerConnection",
		validateCreateStocksManager:"_ValidationResult",
		validateUpdateStocksManager:"_ValidationResult",
		getDeliveryRoute:"DeliveryRoute",
		listDeliveryRoute:"DeliveryRoute",
		paginateDeliveryRoute:"DeliveryRouteConnection",
		validateCreateDeliveryRoute:"_ValidationResult",
		validateUpdateDeliveryRoute:"_ValidationResult",
		getDeliveryWaypoint:"DeliveryWaypoint",
		listDeliveryWaypoint:"DeliveryWaypoint",
		paginateDeliveryWaypoint:"DeliveryWaypointConnection",
		validateCreateDeliveryWaypoint:"_ValidationResult",
		validateUpdateDeliveryWaypoint:"_ValidationResult",
		getAllergen:"Allergen",
		listAllergen:"Allergen",
		paginateAllergen:"AllergenConnection",
		validateCreateAllergen:"_ValidationResult",
		validateUpdateAllergen:"_ValidationResult",
		getAllergenLocale:"AllergenLocale",
		listAllergenLocale:"AllergenLocale",
		paginateAllergenLocale:"AllergenLocaleConnection",
		validateCreateAllergenLocale:"_ValidationResult",
		validateUpdateAllergenLocale:"_ValidationResult",
		getGps:"Gps",
		listGps:"Gps",
		paginateGps:"GpsConnection",
		validateCreateGps:"_ValidationResult",
		validateUpdateGps:"_ValidationResult",
		getProductCategoryTree:"ProductCategoryTree",
		listProductCategoryTree:"ProductCategoryTree",
		paginateProductCategoryTree:"ProductCategoryTreeConnection",
		getInheritedProductCategoryTag:"InheritedProductCategoryTag",
		listInheritedProductCategoryTag:"InheritedProductCategoryTag",
		paginateInheritedProductCategoryTag:"InheritedProductCategoryTagConnection",
		getNestedProductCategoryProduct:"NestedProductCategoryProduct",
		listNestedProductCategoryProduct:"NestedProductCategoryProduct",
		paginateNestedProductCategoryProduct:"NestedProductCategoryProductConnection",
		getWeekHours:"WeekHours",
		listWeekHours:"WeekHours",
		paginateWeekHours:"WeekHoursConnection",
		validateCreateWeekHours:"_ValidationResult",
		validateUpdateWeekHours:"_ValidationResult",
		getPreparedIngredientQuantity:"PreparedIngredientQuantity",
		listPreparedIngredientQuantity:"PreparedIngredientQuantity",
		paginatePreparedIngredientQuantity:"PreparedIngredientQuantityConnection",
		validateCreatePreparedIngredientQuantity:"_ValidationResult",
		validateUpdatePreparedIngredientQuantity:"_ValidationResult",
		getPreparedRecipeQuantity:"PreparedRecipeQuantity",
		listPreparedRecipeQuantity:"PreparedRecipeQuantity",
		paginatePreparedRecipeQuantity:"PreparedRecipeQuantityConnection",
		validateCreatePreparedRecipeQuantity:"_ValidationResult",
		validateUpdatePreparedRecipeQuantity:"_ValidationResult",
		getInternalOrder:"InternalOrder",
		listInternalOrder:"InternalOrder",
		paginateInternalOrder:"InternalOrderConnection",
		validateCreateInternalOrder:"_ValidationResult",
		validateUpdateInternalOrder:"_ValidationResult",
		getInternalOrderItem:"InternalOrderItem",
		listInternalOrderItem:"InternalOrderItem",
		paginateInternalOrderItem:"InternalOrderItemConnection",
		validateCreateInternalOrderItem:"_ValidationResult",
		validateUpdateInternalOrderItem:"_ValidationResult",
		getPreparedPackingQuantity:"PreparedPackingQuantity",
		listPreparedPackingQuantity:"PreparedPackingQuantity",
		paginatePreparedPackingQuantity:"PreparedPackingQuantityConnection",
		validateCreatePreparedPackingQuantity:"_ValidationResult",
		validateUpdatePreparedPackingQuantity:"_ValidationResult",
		getCourierManager:"CourierManager",
		listCourierManager:"CourierManager",
		paginateCourierManager:"CourierManagerConnection",
		validateCreateCourierManager:"_ValidationResult",
		validateUpdateCourierManager:"_ValidationResult",
		getDeliveryZone:"DeliveryZone",
		listDeliveryZone:"DeliveryZone",
		paginateDeliveryZone:"DeliveryZoneConnection",
		validateCreateDeliveryZone:"_ValidationResult",
		validateUpdateDeliveryZone:"_ValidationResult",
		getAddressMetadata:"AddressMetadata",
		listAddressMetadata:"AddressMetadata",
		paginateAddressMetadata:"AddressMetadataConnection",
		getDeliveryTimelinePreset:"DeliveryTimelinePreset",
		listDeliveryTimelinePreset:"DeliveryTimelinePreset",
		paginateDeliveryTimelinePreset:"DeliveryTimelinePresetConnection",
		validateCreateDeliveryTimelinePreset:"_ValidationResult",
		validateUpdateDeliveryTimelinePreset:"_ValidationResult",
		getOrderDeliveryTimeline:"OrderDeliveryTimeline",
		listOrderDeliveryTimeline:"OrderDeliveryTimeline",
		paginateOrderDeliveryTimeline:"OrderDeliveryTimelineConnection",
		validateCreateOrderDeliveryTimeline:"_ValidationResult",
		validateUpdateOrderDeliveryTimeline:"_ValidationResult",
		getOrderEvent:"OrderEvent",
		listOrderEvent:"OrderEvent",
		paginateOrderEvent:"OrderEventConnection",
		validateCreateOrderEvent:"_ValidationResult",
		validateUpdateOrderEvent:"_ValidationResult",
		getLiftagoRide:"LiftagoRide",
		listLiftagoRide:"LiftagoRide",
		paginateLiftagoRide:"LiftagoRideConnection",
		validateCreateLiftagoRide:"_ValidationResult",
		validateUpdateLiftagoRide:"_ValidationResult",
		getInvoice:"Invoice",
		listInvoice:"Invoice",
		paginateInvoice:"InvoiceConnection",
		validateCreateInvoice:"_ValidationResult",
		validateUpdateInvoice:"_ValidationResult",
		getInvoicingPlan:"InvoicingPlan",
		listInvoicingPlan:"InvoicingPlan",
		paginateInvoicingPlan:"InvoicingPlanConnection",
		validateCreateInvoicingPlan:"_ValidationResult",
		validateUpdateInvoicingPlan:"_ValidationResult",
		getProductPackingLocale:"ProductPackingLocale",
		listProductPackingLocale:"ProductPackingLocale",
		paginateProductPackingLocale:"ProductPackingLocaleConnection",
		validateCreateProductPackingLocale:"_ValidationResult",
		validateUpdateProductPackingLocale:"_ValidationResult",
		getProductLocale:"ProductLocale",
		listProductLocale:"ProductLocale",
		paginateProductLocale:"ProductLocaleConnection",
		validateCreateProductLocale:"_ValidationResult",
		validateUpdateProductLocale:"_ValidationResult",
		getProductRecipeLocale:"ProductRecipeLocale",
		listProductRecipeLocale:"ProductRecipeLocale",
		paginateProductRecipeLocale:"ProductRecipeLocaleConnection",
		validateCreateProductRecipeLocale:"_ValidationResult",
		validateUpdateProductRecipeLocale:"_ValidationResult",
		getUserDevice:"UserDevice",
		listUserDevice:"UserDevice",
		paginateUserDevice:"UserDeviceConnection",
		validateCreateUserDevice:"_ValidationResult",
		validateUpdateUserDevice:"_ValidationResult",
		getProtectedAction:"ProtectedAction",
		listProtectedAction:"ProtectedAction",
		paginateProtectedAction:"ProtectedActionConnection",
		validateCreateProtectedAction:"_ValidationResult",
		validateUpdateProtectedAction:"_ValidationResult",
		getPicker:"Picker",
		listPicker:"Picker",
		paginatePicker:"PickerConnection",
		validateCreatePicker:"_ValidationResult",
		validateUpdatePicker:"_ValidationResult",
		getTenantPerson:"TenantPerson",
		listTenantPerson:"TenantPerson",
		paginateTenantPerson:"TenantPersonConnection",
		getTimetableTemplateStaffOptions:"TimetableTemplateStaffOptions",
		listTimetableTemplateStaffOptions:"TimetableTemplateStaffOptions",
		paginateTimetableTemplateStaffOptions:"TimetableTemplateStaffOptionsConnection",
		validateCreateTimetableTemplateStaffOptions:"_ValidationResult",
		validateUpdateTimetableTemplateStaffOptions:"_ValidationResult",
		getShoppingList:"ShoppingList",
		listShoppingList:"ShoppingList",
		paginateShoppingList:"ShoppingListConnection",
		validateCreateShoppingList:"_ValidationResult",
		validateUpdateShoppingList:"_ValidationResult",
		getSuppliesPurchase:"SuppliesPurchase",
		listSuppliesPurchase:"SuppliesPurchase",
		paginateSuppliesPurchase:"SuppliesPurchaseConnection",
		validateCreateSuppliesPurchase:"_ValidationResult",
		validateUpdateSuppliesPurchase:"_ValidationResult",
		getInvoicingPreset:"InvoicingPreset",
		listInvoicingPreset:"InvoicingPreset",
		paginateInvoicingPreset:"InvoicingPresetConnection",
		validateCreateInvoicingPreset:"_ValidationResult",
		validateUpdateInvoicingPreset:"_ValidationResult",
		getLogRecord:"LogRecord",
		listLogRecord:"LogRecord",
		paginateLogRecord:"LogRecordConnection",
		validateCreateLogRecord:"_ValidationResult",
		validateUpdateLogRecord:"_ValidationResult",
		getBillingSubject:"BillingSubject",
		listBillingSubject:"BillingSubject",
		paginateBillingSubject:"BillingSubjectConnection",
		validateCreateBillingSubject:"_ValidationResult",
		validateUpdateBillingSubject:"_ValidationResult",
		getProductCustomerPrice:"ProductCustomerPrice",
		listProductCustomerPrice:"ProductCustomerPrice",
		paginateProductCustomerPrice:"ProductCustomerPriceConnection",
		getCartPriceLine:"CartPriceLine",
		listCartPriceLine:"CartPriceLine",
		paginateCartPriceLine:"CartPriceLineConnection",
		getShoppingListItem:"ShoppingListItem",
		listShoppingListItem:"ShoppingListItem",
		paginateShoppingListItem:"ShoppingListItemConnection",
		validateCreateShoppingListItem:"_ValidationResult",
		validateUpdateShoppingListItem:"_ValidationResult",
		getSuppliesPurchaseItem:"SuppliesPurchaseItem",
		listSuppliesPurchaseItem:"SuppliesPurchaseItem",
		paginateSuppliesPurchaseItem:"SuppliesPurchaseItemConnection",
		validateCreateSuppliesPurchaseItem:"_ValidationResult",
		validateUpdateSuppliesPurchaseItem:"_ValidationResult",
		getCustomerCreditTransaction:"CustomerCreditTransaction",
		listCustomerCreditTransaction:"CustomerCreditTransaction",
		paginateCustomerCreditTransaction:"CustomerCreditTransactionConnection",
		validateCreateCustomerCreditTransaction:"_ValidationResult",
		validateUpdateCustomerCreditTransaction:"_ValidationResult",
		getVirtualProduct:"VirtualProduct",
		listVirtualProduct:"VirtualProduct",
		paginateVirtualProduct:"VirtualProductConnection",
		validateCreateVirtualProduct:"_ValidationResult",
		validateUpdateVirtualProduct:"_ValidationResult",
		getVirtualProductEffect:"VirtualProductEffect",
		listVirtualProductEffect:"VirtualProductEffect",
		paginateVirtualProductEffect:"VirtualProductEffectConnection",
		validateCreateVirtualProductEffect:"_ValidationResult",
		validateUpdateVirtualProductEffect:"_ValidationResult",
		getOrderPriceLine:"OrderPriceLine",
		listOrderPriceLine:"OrderPriceLine",
		paginateOrderPriceLine:"OrderPriceLineConnection",
		getProductMetadata:"ProductMetadata",
		listProductMetadata:"ProductMetadata",
		paginateProductMetadata:"ProductMetadataConnection",
		getEmploymentInformation:"EmploymentInformation",
		listEmploymentInformation:"EmploymentInformation",
		paginateEmploymentInformation:"EmploymentInformationConnection",
		validateCreateEmploymentInformation:"_ValidationResult",
		validateUpdateEmploymentInformation:"_ValidationResult",
		getRemunerationProfile:"RemunerationProfile",
		listRemunerationProfile:"RemunerationProfile",
		paginateRemunerationProfile:"RemunerationProfileConnection",
		validateCreateRemunerationProfile:"_ValidationResult",
		validateUpdateRemunerationProfile:"_ValidationResult",
		getWorkMonth:"WorkMonth",
		listWorkMonth:"WorkMonth",
		paginateWorkMonth:"WorkMonthConnection",
		validateCreateWorkMonth:"_ValidationResult",
		validateUpdateWorkMonth:"_ValidationResult",
		getSalaryOptions:"SalaryOptions",
		listSalaryOptions:"SalaryOptions",
		paginateSalaryOptions:"SalaryOptionsConnection",
		validateCreateSalaryOptions:"_ValidationResult",
		validateUpdateSalaryOptions:"_ValidationResult",
		getTimetableShiftSwapInfo:"TimetableShiftSwapInfo",
		listTimetableShiftSwapInfo:"TimetableShiftSwapInfo",
		paginateTimetableShiftSwapInfo:"TimetableShiftSwapInfoConnection",
		validateCreateTimetableShiftSwapInfo:"_ValidationResult",
		validateUpdateTimetableShiftSwapInfo:"_ValidationResult",
		getProductGridCategory:"ProductGridCategory",
		listProductGridCategory:"ProductGridCategory",
		paginateProductGridCategory:"ProductGridCategoryConnection",
		validateCreateProductGridCategory:"_ValidationResult",
		validateUpdateProductGridCategory:"_ValidationResult",
		getCashier:"Cashier",
		listCashier:"Cashier",
		paginateCashier:"CashierConnection",
		validateCreateCashier:"_ValidationResult",
		validateUpdateCashier:"_ValidationResult",
		getPointOfSaleCategory:"PointOfSaleCategory",
		listPointOfSaleCategory:"PointOfSaleCategory",
		paginatePointOfSaleCategory:"PointOfSaleCategoryConnection",
		validateCreatePointOfSaleCategory:"_ValidationResult",
		validateUpdatePointOfSaleCategory:"_ValidationResult",
		getPointOfSaleCategoryLocale:"PointOfSaleCategoryLocale",
		listPointOfSaleCategoryLocale:"PointOfSaleCategoryLocale",
		paginatePointOfSaleCategoryLocale:"PointOfSaleCategoryLocaleConnection",
		validateCreatePointOfSaleCategoryLocale:"_ValidationResult",
		validateUpdatePointOfSaleCategoryLocale:"_ValidationResult",
		getPointOfSaleCategoryProduct:"PointOfSaleCategoryProduct",
		listPointOfSaleCategoryProduct:"PointOfSaleCategoryProduct",
		paginatePointOfSaleCategoryProduct:"PointOfSaleCategoryProductConnection",
		validateCreatePointOfSaleCategoryProduct:"_ValidationResult",
		validateUpdatePointOfSaleCategoryProduct:"_ValidationResult",
		getPointOfSaleCategoryProductLocale:"PointOfSaleCategoryProductLocale",
		listPointOfSaleCategoryProductLocale:"PointOfSaleCategoryProductLocale",
		paginatePointOfSaleCategoryProductLocale:"PointOfSaleCategoryProductLocaleConnection",
		validateCreatePointOfSaleCategoryProductLocale:"_ValidationResult",
		validateUpdatePointOfSaleCategoryProductLocale:"_ValidationResult",
		getCustomerTab:"CustomerTab",
		listCustomerTab:"CustomerTab",
		paginateCustomerTab:"CustomerTabConnection",
		validateCreateCustomerTab:"_ValidationResult",
		validateUpdateCustomerTab:"_ValidationResult",
		getCustomerTabItem:"CustomerTabItem",
		listCustomerTabItem:"CustomerTabItem",
		paginateCustomerTabItem:"CustomerTabItemConnection",
		validateCreateCustomerTabItem:"_ValidationResult",
		validateUpdateCustomerTabItem:"_ValidationResult",
		getAnonymousSession:"AnonymousSession",
		listAnonymousSession:"AnonymousSession",
		paginateAnonymousSession:"AnonymousSessionConnection",
		validateCreateAnonymousSession:"_ValidationResult",
		validateUpdateAnonymousSession:"_ValidationResult",
		getVoucher:"Voucher",
		listVoucher:"Voucher",
		paginateVoucher:"VoucherConnection",
		validateCreateVoucher:"_ValidationResult",
		validateUpdateVoucher:"_ValidationResult",
		getVoucherRedemption:"VoucherRedemption",
		listVoucherRedemption:"VoucherRedemption",
		paginateVoucherRedemption:"VoucherRedemptionConnection",
		validateCreateVoucherRedemption:"_ValidationResult",
		validateUpdateVoucherRedemption:"_ValidationResult",
		getUnassignedShiftInfo:"UnassignedShiftInfo",
		listUnassignedShiftInfo:"UnassignedShiftInfo",
		paginateUnassignedShiftInfo:"UnassignedShiftInfoConnection",
		validateCreateUnassignedShiftInfo:"_ValidationResult",
		validateUpdateUnassignedShiftInfo:"_ValidationResult",
		getFreshingContainer:"FreshingContainer",
		listFreshingContainer:"FreshingContainer",
		paginateFreshingContainer:"FreshingContainerConnection",
		validateCreateFreshingContainer:"_ValidationResult",
		validateUpdateFreshingContainer:"_ValidationResult",
		getTextItem:"TextItem",
		listTextItem:"TextItem",
		paginateTextItem:"TextItemConnection",
		validateCreateTextItem:"_ValidationResult",
		validateUpdateTextItem:"_ValidationResult",
		getTextList:"TextList",
		listTextList:"TextList",
		paginateTextList:"TextListConnection",
		validateCreateTextList:"_ValidationResult",
		validateUpdateTextList:"_ValidationResult",
		getEmployeeQueueItemMetadata:"EmployeeQueueItemMetadata",
		listEmployeeQueueItemMetadata:"EmployeeQueueItemMetadata",
		paginateEmployeeQueueItemMetadata:"EmployeeQueueItemMetadataConnection",
		getDeliveryRegions:"DeliveryRegions",
		listDeliveryRegions:"DeliveryRegions",
		paginateDeliveryRegions:"DeliveryRegionsConnection",
		validateCreateDeliveryRegions:"_ValidationResult",
		validateUpdateDeliveryRegions:"_ValidationResult",
		getDeliveryRegionsItem:"DeliveryRegionsItem",
		listDeliveryRegionsItem:"DeliveryRegionsItem",
		paginateDeliveryRegionsItem:"DeliveryRegionsItemConnection",
		validateCreateDeliveryRegionsItem:"_ValidationResult",
		validateUpdateDeliveryRegionsItem:"_ValidationResult",
		getImageList:"ImageList",
		listImageList:"ImageList",
		paginateImageList:"ImageListConnection",
		validateCreateImageList:"_ValidationResult",
		validateUpdateImageList:"_ValidationResult",
		getImageListItem:"ImageListItem",
		listImageListItem:"ImageListItem",
		paginateImageListItem:"ImageListItemConnection",
		validateCreateImageListItem:"_ValidationResult",
		validateUpdateImageListItem:"_ValidationResult",
		getProductSalesDay:"ProductSalesDay",
		listProductSalesDay:"ProductSalesDay",
		paginateProductSalesDay:"ProductSalesDayConnection",
		getProductSalesMonth:"ProductSalesMonth",
		listProductSalesMonth:"ProductSalesMonth",
		paginateProductSalesMonth:"ProductSalesMonthConnection",
		getProductSalesWeek:"ProductSalesWeek",
		listProductSalesWeek:"ProductSalesWeek",
		paginateProductSalesWeek:"ProductSalesWeekConnection",
		getTimetablesEmployeePrivileges:"TimetablesEmployeePrivileges",
		listTimetablesEmployeePrivileges:"TimetablesEmployeePrivileges",
		paginateTimetablesEmployeePrivileges:"TimetablesEmployeePrivilegesConnection",
		validateCreateTimetablesEmployeePrivileges:"_ValidationResult",
		validateUpdateTimetablesEmployeePrivileges:"_ValidationResult",
		getTimetableDayNote:"TimetableDayNote",
		listTimetableDayNote:"TimetableDayNote",
		paginateTimetableDayNote:"TimetableDayNoteConnection",
		validateCreateTimetableDayNote:"_ValidationResult",
		validateUpdateTimetableDayNote:"_ValidationResult",
		getDeliveryMethodLocale:"DeliveryMethodLocale",
		listDeliveryMethodLocale:"DeliveryMethodLocale",
		paginateDeliveryMethodLocale:"DeliveryMethodLocaleConnection",
		validateCreateDeliveryMethodLocale:"_ValidationResult",
		validateUpdateDeliveryMethodLocale:"_ValidationResult",
		getIngredientSupplier:"IngredientSupplier",
		listIngredientSupplier:"IngredientSupplier",
		paginateIngredientSupplier:"IngredientSupplierConnection",
		validateCreateIngredientSupplier:"_ValidationResult",
		validateUpdateIngredientSupplier:"_ValidationResult",
		getIngredientSupplierItem:"IngredientSupplierItem",
		listIngredientSupplierItem:"IngredientSupplierItem",
		paginateIngredientSupplierItem:"IngredientSupplierItemConnection",
		validateCreateIngredientSupplierItem:"_ValidationResult",
		validateUpdateIngredientSupplierItem:"_ValidationResult",
		getIngredientSupplierList:"IngredientSupplierList",
		listIngredientSupplierList:"IngredientSupplierList",
		paginateIngredientSupplierList:"IngredientSupplierListConnection",
		validateCreateIngredientSupplierList:"_ValidationResult",
		validateUpdateIngredientSupplierList:"_ValidationResult",
		getIngredientSupplierLocale:"IngredientSupplierLocale",
		listIngredientSupplierLocale:"IngredientSupplierLocale",
		paginateIngredientSupplierLocale:"IngredientSupplierLocaleConnection",
		validateCreateIngredientSupplierLocale:"_ValidationResult",
		validateUpdateIngredientSupplierLocale:"_ValidationResult",
		getRedirect:"Redirect",
		listRedirect:"Redirect",
		paginateRedirect:"RedirectConnection",
		validateCreateRedirect:"_ValidationResult",
		validateUpdateRedirect:"_ValidationResult",
		getNutritionFacts:"NutritionFacts",
		listNutritionFacts:"NutritionFacts",
		paginateNutritionFacts:"NutritionFactsConnection",
		validateCreateNutritionFacts:"_ValidationResult",
		validateUpdateNutritionFacts:"_ValidationResult",
		getVenue:"Venue",
		listVenue:"Venue",
		paginateVenue:"VenueConnection",
		validateCreateVenue:"_ValidationResult",
		validateUpdateVenue:"_ValidationResult",
		getWorkspace:"Workspace",
		listWorkspace:"Workspace",
		paginateWorkspace:"WorkspaceConnection",
		validateCreateWorkspace:"_ValidationResult",
		validateUpdateWorkspace:"_ValidationResult",
		getInternalBuyer:"InternalBuyer",
		listInternalBuyer:"InternalBuyer",
		paginateInternalBuyer:"InternalBuyerConnection",
		validateCreateInternalBuyer:"_ValidationResult",
		validateUpdateInternalBuyer:"_ValidationResult",
		getCartSummary:"CartSummary",
		listCartSummary:"CartSummary",
		paginateCartSummary:"CartSummaryConnection",
		getOrderSummary:"OrderSummary",
		listOrderSummary:"OrderSummary",
		paginateOrderSummary:"OrderSummaryConnection",
		getCustomerSpending:"CustomerSpending",
		listCustomerSpending:"CustomerSpending",
		paginateCustomerSpending:"CustomerSpendingConnection",
		getOrderPaymentMetadata:"OrderPaymentMetadata",
		listOrderPaymentMetadata:"OrderPaymentMetadata",
		paginateOrderPaymentMetadata:"OrderPaymentMetadataConnection",
		getUserMetadata:"UserMetadata",
		listUserMetadata:"UserMetadata",
		paginateUserMetadata:"UserMetadataConnection",
		getCustomerTabMetadata:"CustomerTabMetadata",
		listCustomerTabMetadata:"CustomerTabMetadata",
		paginateCustomerTabMetadata:"CustomerTabMetadataConnection",
		getVenueEmployeeRole:"VenueEmployeeRole",
		listVenueEmployeeRole:"VenueEmployeeRole",
		paginateVenueEmployeeRole:"VenueEmployeeRoleConnection",
		validateCreateVenueEmployeeRole:"_ValidationResult",
		validateUpdateVenueEmployeeRole:"_ValidationResult",
		getIdentificationAttempt:"IdentificationAttempt",
		listIdentificationAttempt:"IdentificationAttempt",
		paginateIdentificationAttempt:"IdentificationAttemptConnection",
		validateCreateIdentificationAttempt:"_ValidationResult",
		validateUpdateIdentificationAttempt:"_ValidationResult",
		getIdentificationCode:"IdentificationCode",
		listIdentificationCode:"IdentificationCode",
		paginateIdentificationCode:"IdentificationCodeConnection",
		validateCreateIdentificationCode:"_ValidationResult",
		validateUpdateIdentificationCode:"_ValidationResult",
		getIdentificationCodeLocale:"IdentificationCodeLocale",
		listIdentificationCodeLocale:"IdentificationCodeLocale",
		paginateIdentificationCodeLocale:"IdentificationCodeLocaleConnection",
		validateCreateIdentificationCodeLocale:"_ValidationResult",
		validateUpdateIdentificationCodeLocale:"_ValidationResult",
		getPipeline:"Pipeline",
		listPipeline:"Pipeline",
		paginatePipeline:"PipelineConnection",
		validateCreatePipeline:"_ValidationResult",
		validateUpdatePipeline:"_ValidationResult",
		getPipelineLead:"PipelineLead",
		listPipelineLead:"PipelineLead",
		paginatePipelineLead:"PipelineLeadConnection",
		validateCreatePipelineLead:"_ValidationResult",
		validateUpdatePipelineLead:"_ValidationResult",
		getPipelineStage:"PipelineStage",
		listPipelineStage:"PipelineStage",
		paginatePipelineStage:"PipelineStageConnection",
		validateCreatePipelineStage:"_ValidationResult",
		validateUpdatePipelineStage:"_ValidationResult",
		getPipelineStageItem:"PipelineStageItem",
		listPipelineStageItem:"PipelineStageItem",
		paginatePipelineStageItem:"PipelineStageItemConnection",
		validateCreatePipelineStageItem:"_ValidationResult",
		validateUpdatePipelineStageItem:"_ValidationResult",
		getPipelineStageLocale:"PipelineStageLocale",
		listPipelineStageLocale:"PipelineStageLocale",
		paginatePipelineStageLocale:"PipelineStageLocaleConnection",
		validateCreatePipelineStageLocale:"_ValidationResult",
		validateUpdatePipelineStageLocale:"_ValidationResult",
		getSalesManager:"SalesManager",
		listSalesManager:"SalesManager",
		paginateSalesManager:"SalesManagerConnection",
		validateCreateSalesManager:"_ValidationResult",
		validateUpdateSalesManager:"_ValidationResult",
		getCashierManager:"CashierManager",
		listCashierManager:"CashierManager",
		paginateCashierManager:"CashierManagerConnection",
		validateCreateCashierManager:"_ValidationResult",
		validateUpdateCashierManager:"_ValidationResult",
		getUserRoles:"UserRoles",
		listUserRoles:"UserRoles",
		paginateUserRoles:"UserRolesConnection",
		getPointOfSaleApplicationDevice:"PointOfSaleApplicationDevice",
		listPointOfSaleApplicationDevice:"PointOfSaleApplicationDevice",
		paginatePointOfSaleApplicationDevice:"PointOfSaleApplicationDeviceConnection",
		validateCreatePointOfSaleApplicationDevice:"_ValidationResult",
		validateUpdatePointOfSaleApplicationDevice:"_ValidationResult",
		getPointOfSaleTerminal:"PointOfSaleTerminal",
		listPointOfSaleTerminal:"PointOfSaleTerminal",
		paginatePointOfSaleTerminal:"PointOfSaleTerminalConnection",
		validateCreatePointOfSaleTerminal:"_ValidationResult",
		validateUpdatePointOfSaleTerminal:"_ValidationResult",
		getPipelineStageSentiment:"PipelineStageSentiment",
		listPipelineStageSentiment:"PipelineStageSentiment",
		paginatePipelineStageSentiment:"PipelineStageSentimentConnection",
		validateCreatePipelineStageSentiment:"_ValidationResult",
		validateUpdatePipelineStageSentiment:"_ValidationResult",
		getDeviceIdentifier:"DeviceIdentifier",
		listDeviceIdentifier:"DeviceIdentifier",
		paginateDeviceIdentifier:"DeviceIdentifierConnection",
		validateCreateDeviceIdentifier:"_ValidationResult",
		validateUpdateDeviceIdentifier:"_ValidationResult",
		getDeviceIdentifierMetadata:"DeviceIdentifierMetadata",
		listDeviceIdentifierMetadata:"DeviceIdentifierMetadata",
		paginateDeviceIdentifierMetadata:"DeviceIdentifierMetadataConnection",
		getPointOfSalePrinter:"PointOfSalePrinter",
		listPointOfSalePrinter:"PointOfSalePrinter",
		paginatePointOfSalePrinter:"PointOfSalePrinterConnection",
		validateCreatePointOfSalePrinter:"_ValidationResult",
		validateUpdatePointOfSalePrinter:"_ValidationResult",
		getGratuity:"Gratuity",
		listGratuity:"Gratuity",
		paginateGratuity:"GratuityConnection",
		validateCreateGratuity:"_ValidationResult",
		validateUpdateGratuity:"_ValidationResult",
		getFulfillmentNote:"FulfillmentNote",
		listFulfillmentNote:"FulfillmentNote",
		paginateFulfillmentNote:"FulfillmentNoteConnection",
		validateCreateFulfillmentNote:"_ValidationResult",
		validateUpdateFulfillmentNote:"_ValidationResult",
		getCustomerMetadata:"CustomerMetadata",
		listCustomerMetadata:"CustomerMetadata",
		paginateCustomerMetadata:"CustomerMetadataConnection",
		getLeadForm:"LeadForm",
		listLeadForm:"LeadForm",
		paginateLeadForm:"LeadFormConnection",
		validateCreateLeadForm:"_ValidationResult",
		validateUpdateLeadForm:"_ValidationResult",
		getSubscriptionBox:"SubscriptionBox",
		listSubscriptionBox:"SubscriptionBox",
		paginateSubscriptionBox:"SubscriptionBoxConnection",
		validateCreateSubscriptionBox:"_ValidationResult",
		validateUpdateSubscriptionBox:"_ValidationResult",
		getSubscriptionBoxLocale:"SubscriptionBoxLocale",
		listSubscriptionBoxLocale:"SubscriptionBoxLocale",
		paginateSubscriptionBoxLocale:"SubscriptionBoxLocaleConnection",
		validateCreateSubscriptionBoxLocale:"_ValidationResult",
		validateUpdateSubscriptionBoxLocale:"_ValidationResult",
		getTimetableDayMetadata:"TimetableDayMetadata",
		listTimetableDayMetadata:"TimetableDayMetadata",
		paginateTimetableDayMetadata:"TimetableDayMetadataConnection",
		getBusinessService:"BusinessService",
		listBusinessService:"BusinessService",
		paginateBusinessService:"BusinessServiceConnection",
		validateCreateBusinessService:"_ValidationResult",
		validateUpdateBusinessService:"_ValidationResult",
		getBusinessServiceEvent:"BusinessServiceEvent",
		listBusinessServiceEvent:"BusinessServiceEvent",
		paginateBusinessServiceEvent:"BusinessServiceEventConnection",
		validateCreateBusinessServiceEvent:"_ValidationResult",
		validateUpdateBusinessServiceEvent:"_ValidationResult",
		getBusinessServiceLocale:"BusinessServiceLocale",
		listBusinessServiceLocale:"BusinessServiceLocale",
		paginateBusinessServiceLocale:"BusinessServiceLocaleConnection",
		validateCreateBusinessServiceLocale:"_ValidationResult",
		validateUpdateBusinessServiceLocale:"_ValidationResult",
		getGridTileItem:"GridTileItem",
		listGridTileItem:"GridTileItem",
		paginateGridTileItem:"GridTileItemConnection",
		validateCreateGridTileItem:"_ValidationResult",
		validateUpdateGridTileItem:"_ValidationResult",
		getGridTiles:"GridTiles",
		listGridTiles:"GridTiles",
		paginateGridTiles:"GridTilesConnection",
		validateCreateGridTiles:"_ValidationResult",
		validateUpdateGridTiles:"_ValidationResult",
		getArea:"Area",
		listArea:"Area",
		paginateArea:"AreaConnection",
		validateCreateArea:"_ValidationResult",
		validateUpdateArea:"_ValidationResult",
		getPosition:"Position",
		listPosition:"Position",
		paginatePosition:"PositionConnection",
		validateCreatePosition:"_ValidationResult",
		validateUpdatePosition:"_ValidationResult",
		getStatsEnabledWidgetType:"StatsEnabledWidgetType",
		listStatsEnabledWidgetType:"StatsEnabledWidgetType",
		paginateStatsEnabledWidgetType:"StatsEnabledWidgetTypeConnection",
		validateCreateStatsEnabledWidgetType:"_ValidationResult",
		validateUpdateStatsEnabledWidgetType:"_ValidationResult",
		getStatsWidget:"StatsWidget",
		listStatsWidget:"StatsWidget",
		paginateStatsWidget:"StatsWidgetConnection",
		validateCreateStatsWidget:"_ValidationResult",
		validateUpdateStatsWidget:"_ValidationResult",
		getStatsWidgetsLayout:"StatsWidgetsLayout",
		listStatsWidgetsLayout:"StatsWidgetsLayout",
		paginateStatsWidgetsLayout:"StatsWidgetsLayoutConnection",
		validateCreateStatsWidgetsLayout:"_ValidationResult",
		validateUpdateStatsWidgetsLayout:"_ValidationResult",
		getSeat:"Seat",
		listSeat:"Seat",
		paginateSeat:"SeatConnection",
		validateCreateSeat:"_ValidationResult",
		validateUpdateSeat:"_ValidationResult",
		getTable:"Table",
		listTable:"Table",
		paginateTable:"TableConnection",
		validateCreateTable:"_ValidationResult",
		validateUpdateTable:"_ValidationResult",
		getStatsPage:"StatsPage",
		listStatsPage:"StatsPage",
		paginateStatsPage:"StatsPageConnection",
		validateCreateStatsPage:"_ValidationResult",
		validateUpdateStatsPage:"_ValidationResult",
		getUnassignReason:"UnassignReason",
		listUnassignReason:"UnassignReason",
		paginateUnassignReason:"UnassignReasonConnection",
		validateCreateUnassignReason:"_ValidationResult",
		validateUpdateUnassignReason:"_ValidationResult",
		getDoubleshotCoffeeEquipment:"DoubleshotCoffeeEquipment",
		listDoubleshotCoffeeEquipment:"DoubleshotCoffeeEquipment",
		paginateDoubleshotCoffeeEquipment:"DoubleshotCoffeeEquipmentConnection",
		validateCreateDoubleshotCoffeeEquipment:"_ValidationResult",
		validateUpdateDoubleshotCoffeeEquipment:"_ValidationResult",
		getExpense:"Expense",
		listExpense:"Expense",
		paginateExpense:"ExpenseConnection",
		validateCreateExpense:"_ValidationResult",
		validateUpdateExpense:"_ValidationResult",
		getExpenseCategory:"ExpenseCategory",
		listExpenseCategory:"ExpenseCategory",
		paginateExpenseCategory:"ExpenseCategoryConnection",
		validateCreateExpenseCategory:"_ValidationResult",
		validateUpdateExpenseCategory:"_ValidationResult",
		getExpenseChange:"ExpenseChange",
		listExpenseChange:"ExpenseChange",
		paginateExpenseChange:"ExpenseChangeConnection",
		validateCreateExpenseChange:"_ValidationResult",
		validateUpdateExpenseChange:"_ValidationResult",
		getExpenseDocument:"ExpenseDocument",
		listExpenseDocument:"ExpenseDocument",
		paginateExpenseDocument:"ExpenseDocumentConnection",
		validateCreateExpenseDocument:"_ValidationResult",
		validateUpdateExpenseDocument:"_ValidationResult",
		getRevenuePrediction:"RevenuePrediction",
		listRevenuePrediction:"RevenuePrediction",
		paginateRevenuePrediction:"RevenuePredictionConnection",
		validateCreateRevenuePrediction:"_ValidationResult",
		validateUpdateRevenuePrediction:"_ValidationResult",
		getRevenuePredictionChange:"RevenuePredictionChange",
		listRevenuePredictionChange:"RevenuePredictionChange",
		paginateRevenuePredictionChange:"RevenuePredictionChangeConnection",
		validateCreateRevenuePredictionChange:"_ValidationResult",
		validateUpdateRevenuePredictionChange:"_ValidationResult",
		getFile:"File",
		listFile:"File",
		paginateFile:"FileConnection",
		validateCreateFile:"_ValidationResult",
		validateUpdateFile:"_ValidationResult",
		getExpenseTerm:"ExpenseTerm",
		listExpenseTerm:"ExpenseTerm",
		paginateExpenseTerm:"ExpenseTermConnection",
		getLine:"Line",
		listLine:"Line",
		paginateLine:"LineConnection",
		validateCreateLine:"_ValidationResult",
		validateUpdateLine:"_ValidationResult",
		getFinancesBalanceItem:"FinancesBalanceItem",
		listFinancesBalanceItem:"FinancesBalanceItem",
		paginateFinancesBalanceItem:"FinancesBalanceItemConnection",
		validateCreateFinancesBalanceItem:"_ValidationResult",
		validateUpdateFinancesBalanceItem:"_ValidationResult",
		getRevenuePredictionTerm:"RevenuePredictionTerm",
		listRevenuePredictionTerm:"RevenuePredictionTerm",
		paginateRevenuePredictionTerm:"RevenuePredictionTermConnection",
		getOrderPaymentStatsByDay:"OrderPaymentStatsByDay",
		listOrderPaymentStatsByDay:"OrderPaymentStatsByDay",
		paginateOrderPaymentStatsByDay:"OrderPaymentStatsByDayConnection",
		getWoltDriveDelivery:"WoltDriveDelivery",
		listWoltDriveDelivery:"WoltDriveDelivery",
		paginateWoltDriveDelivery:"WoltDriveDeliveryConnection",
		validateCreateWoltDriveDelivery:"_ValidationResult",
		validateUpdateWoltDriveDelivery:"_ValidationResult"
	},
	Info:{
		description:"String"
	},
	Mutation:{
		createAddress:"AddressCreateResult",
		deleteAddress:"AddressDeleteResult",
		updateAddress:"AddressUpdateResult",
		upsertAddress:"AddressUpsertResult",
		createCountry:"CountryCreateResult",
		deleteCountry:"CountryDeleteResult",
		updateCountry:"CountryUpdateResult",
		upsertCountry:"CountryUpsertResult",
		createChannel:"ChannelCreateResult",
		deleteChannel:"ChannelDeleteResult",
		updateChannel:"ChannelUpdateResult",
		upsertChannel:"ChannelUpsertResult",
		createChannelPayment:"ChannelPaymentCreateResult",
		deleteChannelPayment:"ChannelPaymentDeleteResult",
		updateChannelPayment:"ChannelPaymentUpdateResult",
		upsertChannelPayment:"ChannelPaymentUpsertResult",
		createChannelDelivery:"ChannelDeliveryCreateResult",
		deleteChannelDelivery:"ChannelDeliveryDeleteResult",
		updateChannelDelivery:"ChannelDeliveryUpdateResult",
		upsertChannelDelivery:"ChannelDeliveryUpsertResult",
		createCustomer:"CustomerCreateResult",
		deleteCustomer:"CustomerDeleteResult",
		updateCustomer:"CustomerUpdateResult",
		upsertCustomer:"CustomerUpsertResult",
		createCustomerCredit:"CustomerCreditCreateResult",
		deleteCustomerCredit:"CustomerCreditDeleteResult",
		updateCustomerCredit:"CustomerCreditUpdateResult",
		upsertCustomerCredit:"CustomerCreditUpsertResult",
		createCustomerGroup:"CustomerGroupCreateResult",
		deleteCustomerGroup:"CustomerGroupDeleteResult",
		updateCustomerGroup:"CustomerGroupUpdateResult",
		upsertCustomerGroup:"CustomerGroupUpsertResult",
		createCustomerPaymentMethod:"CustomerPaymentMethodCreateResult",
		deleteCustomerPaymentMethod:"CustomerPaymentMethodDeleteResult",
		updateCustomerPaymentMethod:"CustomerPaymentMethodUpdateResult",
		upsertCustomerPaymentMethod:"CustomerPaymentMethodUpsertResult",
		createDeliveryMethod:"DeliveryMethodCreateResult",
		deleteDeliveryMethod:"DeliveryMethodDeleteResult",
		updateDeliveryMethod:"DeliveryMethodUpdateResult",
		upsertDeliveryMethod:"DeliveryMethodUpsertResult",
		createOrder:"OrderCreateResult",
		deleteOrder:"OrderDeleteResult",
		updateOrder:"OrderUpdateResult",
		upsertOrder:"OrderUpsertResult",
		createOrderDiscount:"OrderDiscountCreateResult",
		deleteOrderDiscount:"OrderDiscountDeleteResult",
		updateOrderDiscount:"OrderDiscountUpdateResult",
		upsertOrderDiscount:"OrderDiscountUpsertResult",
		createOrderPayment:"OrderPaymentCreateResult",
		deleteOrderPayment:"OrderPaymentDeleteResult",
		updateOrderPayment:"OrderPaymentUpdateResult",
		upsertOrderPayment:"OrderPaymentUpsertResult",
		createOrderDelivery:"OrderDeliveryCreateResult",
		deleteOrderDelivery:"OrderDeliveryDeleteResult",
		updateOrderDelivery:"OrderDeliveryUpdateResult",
		upsertOrderDelivery:"OrderDeliveryUpsertResult",
		createOrderItem:"OrderItemCreateResult",
		deleteOrderItem:"OrderItemDeleteResult",
		updateOrderItem:"OrderItemUpdateResult",
		upsertOrderItem:"OrderItemUpsertResult",
		createPaymentMethod:"PaymentMethodCreateResult",
		deletePaymentMethod:"PaymentMethodDeleteResult",
		updatePaymentMethod:"PaymentMethodUpdateResult",
		upsertPaymentMethod:"PaymentMethodUpsertResult",
		createVatRate:"VatRateCreateResult",
		deleteVatRate:"VatRateDeleteResult",
		updateVatRate:"VatRateUpdateResult",
		upsertVatRate:"VatRateUpsertResult",
		createProduct:"ProductCreateResult",
		deleteProduct:"ProductDeleteResult",
		updateProduct:"ProductUpdateResult",
		upsertProduct:"ProductUpsertResult",
		createProductStock:"ProductStockCreateResult",
		deleteProductStock:"ProductStockDeleteResult",
		updateProductStock:"ProductStockUpdateResult",
		upsertProductStock:"ProductStockUpsertResult",
		createProductPacking:"ProductPackingCreateResult",
		deleteProductPacking:"ProductPackingDeleteResult",
		updateProductPacking:"ProductPackingUpdateResult",
		upsertProductPacking:"ProductPackingUpsertResult",
		createProductGroupPrice:"ProductGroupPriceCreateResult",
		deleteProductGroupPrice:"ProductGroupPriceDeleteResult",
		updateProductGroupPrice:"ProductGroupPriceUpdateResult",
		upsertProductGroupPrice:"ProductGroupPriceUpsertResult",
		createProductRecipe:"ProductRecipeCreateResult",
		deleteProductRecipe:"ProductRecipeDeleteResult",
		updateProductRecipe:"ProductRecipeUpdateResult",
		upsertProductRecipe:"ProductRecipeUpsertResult",
		createProductCategory:"ProductCategoryCreateResult",
		deleteProductCategory:"ProductCategoryDeleteResult",
		updateProductCategory:"ProductCategoryUpdateResult",
		upsertProductCategory:"ProductCategoryUpsertResult",
		createStore:"StoreCreateResult",
		deleteStore:"StoreDeleteResult",
		updateStore:"StoreUpdateResult",
		upsertStore:"StoreUpsertResult",
		createTag:"TagCreateResult",
		deleteTag:"TagDeleteResult",
		updateTag:"TagUpdateResult",
		upsertTag:"TagUpsertResult",
		createImage:"ImageCreateResult",
		deleteImage:"ImageDeleteResult",
		updateImage:"ImageUpdateResult",
		upsertImage:"ImageUpsertResult",
		createBusinessCategory:"BusinessCategoryCreateResult",
		deleteBusinessCategory:"BusinessCategoryDeleteResult",
		updateBusinessCategory:"BusinessCategoryUpdateResult",
		upsertBusinessCategory:"BusinessCategoryUpsertResult",
		createProductList:"ProductListCreateResult",
		deleteProductList:"ProductListDeleteResult",
		updateProductList:"ProductListUpdateResult",
		upsertProductList:"ProductListUpsertResult",
		createProductListItem:"ProductListItemCreateResult",
		deleteProductListItem:"ProductListItemDeleteResult",
		updateProductListItem:"ProductListItemUpdateResult",
		upsertProductListItem:"ProductListItemUpsertResult",
		createProductCategoryList:"ProductCategoryListCreateResult",
		deleteProductCategoryList:"ProductCategoryListDeleteResult",
		updateProductCategoryList:"ProductCategoryListUpdateResult",
		upsertProductCategoryList:"ProductCategoryListUpsertResult",
		createProductCategoryListItem:"ProductCategoryListItemCreateResult",
		deleteProductCategoryListItem:"ProductCategoryListItemDeleteResult",
		updateProductCategoryListItem:"ProductCategoryListItemUpdateResult",
		upsertProductCategoryListItem:"ProductCategoryListItemUpsertResult",
		createBusinessCategoryLocale:"BusinessCategoryLocaleCreateResult",
		deleteBusinessCategoryLocale:"BusinessCategoryLocaleDeleteResult",
		updateBusinessCategoryLocale:"BusinessCategoryLocaleUpdateResult",
		upsertBusinessCategoryLocale:"BusinessCategoryLocaleUpsertResult",
		createLocale:"LocaleCreateResult",
		deleteLocale:"LocaleDeleteResult",
		updateLocale:"LocaleUpdateResult",
		upsertLocale:"LocaleUpsertResult",
		createProductCategoryListLocale:"ProductCategoryListLocaleCreateResult",
		deleteProductCategoryListLocale:"ProductCategoryListLocaleDeleteResult",
		updateProductCategoryListLocale:"ProductCategoryListLocaleUpdateResult",
		upsertProductCategoryListLocale:"ProductCategoryListLocaleUpsertResult",
		createCustomerName:"CustomerNameCreateResult",
		deleteCustomerName:"CustomerNameDeleteResult",
		updateCustomerName:"CustomerNameUpdateResult",
		upsertCustomerName:"CustomerNameUpsertResult",
		createCustomerAlias:"CustomerAliasCreateResult",
		deleteCustomerAlias:"CustomerAliasDeleteResult",
		updateCustomerAlias:"CustomerAliasUpdateResult",
		upsertCustomerAlias:"CustomerAliasUpsertResult",
		createProductIngredientItem:"ProductIngredientItemCreateResult",
		deleteProductIngredientItem:"ProductIngredientItemDeleteResult",
		updateProductIngredientItem:"ProductIngredientItemUpdateResult",
		upsertProductIngredientItem:"ProductIngredientItemUpsertResult",
		createProductIngredientItemQuantity:"ProductIngredientItemQuantityCreateResult",
		deleteProductIngredientItemQuantity:"ProductIngredientItemQuantityDeleteResult",
		updateProductIngredientItemQuantity:"ProductIngredientItemQuantityUpdateResult",
		upsertProductIngredientItemQuantity:"ProductIngredientItemQuantityUpsertResult",
		createProductIngredientItemQuantityUnit:"ProductIngredientItemQuantityUnitCreateResult",
		deleteProductIngredientItemQuantityUnit:"ProductIngredientItemQuantityUnitDeleteResult",
		updateProductIngredientItemQuantityUnit:"ProductIngredientItemQuantityUnitUpdateResult",
		upsertProductIngredientItemQuantityUnit:"ProductIngredientItemQuantityUnitUpsertResult",
		createProductIngredient:"ProductIngredientCreateResult",
		deleteProductIngredient:"ProductIngredientDeleteResult",
		updateProductIngredient:"ProductIngredientUpdateResult",
		upsertProductIngredient:"ProductIngredientUpsertResult",
		createCustomerIngredientRating:"CustomerIngredientRatingCreateResult",
		deleteCustomerIngredientRating:"CustomerIngredientRatingDeleteResult",
		updateCustomerIngredientRating:"CustomerIngredientRatingUpdateResult",
		upsertCustomerIngredientRating:"CustomerIngredientRatingUpsertResult",
		createProductIngredientRating:"ProductIngredientRatingCreateResult",
		deleteProductIngredientRating:"ProductIngredientRatingDeleteResult",
		updateProductIngredientRating:"ProductIngredientRatingUpdateResult",
		upsertProductIngredientRating:"ProductIngredientRatingUpsertResult",
		createProductIngredientLocale:"ProductIngredientLocaleCreateResult",
		deleteProductIngredientLocale:"ProductIngredientLocaleDeleteResult",
		updateProductIngredientLocale:"ProductIngredientLocaleUpdateResult",
		upsertProductIngredientLocale:"ProductIngredientLocaleUpsertResult",
		createOrderRecurrence:"OrderRecurrenceCreateResult",
		deleteOrderRecurrence:"OrderRecurrenceDeleteResult",
		updateOrderRecurrence:"OrderRecurrenceUpdateResult",
		upsertOrderRecurrence:"OrderRecurrenceUpsertResult",
		createOrderRecurrenceLocale:"OrderRecurrenceLocaleCreateResult",
		deleteOrderRecurrenceLocale:"OrderRecurrenceLocaleDeleteResult",
		updateOrderRecurrenceLocale:"OrderRecurrenceLocaleUpdateResult",
		upsertOrderRecurrenceLocale:"OrderRecurrenceLocaleUpsertResult",
		createBusinessCustomer:"BusinessCustomerCreateResult",
		deleteBusinessCustomer:"BusinessCustomerDeleteResult",
		updateBusinessCustomer:"BusinessCustomerUpdateResult",
		upsertBusinessCustomer:"BusinessCustomerUpsertResult",
		createPointOfSale:"PointOfSaleCreateResult",
		deletePointOfSale:"PointOfSaleDeleteResult",
		updatePointOfSale:"PointOfSaleUpdateResult",
		upsertPointOfSale:"PointOfSaleUpsertResult",
		createStaff:"StaffCreateResult",
		deleteStaff:"StaffDeleteResult",
		updateStaff:"StaffUpdateResult",
		upsertStaff:"StaffUpsertResult",
		createBlog:"BlogCreateResult",
		deleteBlog:"BlogDeleteResult",
		updateBlog:"BlogUpdateResult",
		upsertBlog:"BlogUpsertResult",
		createBlogLocale:"BlogLocaleCreateResult",
		deleteBlogLocale:"BlogLocaleDeleteResult",
		updateBlogLocale:"BlogLocaleUpdateResult",
		upsertBlogLocale:"BlogLocaleUpsertResult",
		createBlogPost:"BlogPostCreateResult",
		deleteBlogPost:"BlogPostDeleteResult",
		updateBlogPost:"BlogPostUpdateResult",
		upsertBlogPost:"BlogPostUpsertResult",
		createBlogPostLocale:"BlogPostLocaleCreateResult",
		deleteBlogPostLocale:"BlogPostLocaleDeleteResult",
		updateBlogPostLocale:"BlogPostLocaleUpdateResult",
		upsertBlogPostLocale:"BlogPostLocaleUpsertResult",
		createColorPallete:"ColorPalleteCreateResult",
		deleteColorPallete:"ColorPalleteDeleteResult",
		updateColorPallete:"ColorPalleteUpdateResult",
		upsertColorPallete:"ColorPalleteUpsertResult",
		createContent:"ContentCreateResult",
		deleteContent:"ContentDeleteResult",
		updateContent:"ContentUpdateResult",
		upsertContent:"ContentUpsertResult",
		createContentBlock:"ContentBlockCreateResult",
		deleteContentBlock:"ContentBlockDeleteResult",
		updateContentBlock:"ContentBlockUpdateResult",
		upsertContentBlock:"ContentBlockUpsertResult",
		createContentReference:"ContentReferenceCreateResult",
		deleteContentReference:"ContentReferenceDeleteResult",
		updateContentReference:"ContentReferenceUpdateResult",
		upsertContentReference:"ContentReferenceUpsertResult",
		createBlogPostList:"BlogPostListCreateResult",
		deleteBlogPostList:"BlogPostListDeleteResult",
		updateBlogPostList:"BlogPostListUpdateResult",
		upsertBlogPostList:"BlogPostListUpsertResult",
		createBlogPostListItem:"BlogPostListItemCreateResult",
		deleteBlogPostListItem:"BlogPostListItemDeleteResult",
		updateBlogPostListItem:"BlogPostListItemUpdateResult",
		upsertBlogPostListItem:"BlogPostListItemUpsertResult",
		createLinkList:"LinkListCreateResult",
		deleteLinkList:"LinkListDeleteResult",
		updateLinkList:"LinkListUpdateResult",
		upsertLinkList:"LinkListUpsertResult",
		createLinkListItem:"LinkListItemCreateResult",
		deleteLinkListItem:"LinkListItemDeleteResult",
		updateLinkListItem:"LinkListItemUpdateResult",
		upsertLinkListItem:"LinkListItemUpsertResult",
		createCover:"CoverCreateResult",
		deleteCover:"CoverDeleteResult",
		updateCover:"CoverUpdateResult",
		upsertCover:"CoverUpsertResult",
		createLink:"LinkCreateResult",
		deleteLink:"LinkDeleteResult",
		updateLink:"LinkUpdateResult",
		upsertLink:"LinkUpsertResult",
		createLinkable:"LinkableCreateResult",
		deleteLinkable:"LinkableDeleteResult",
		updateLinkable:"LinkableUpdateResult",
		upsertLinkable:"LinkableUpsertResult",
		createMedium:"MediumCreateResult",
		deleteMedium:"MediumDeleteResult",
		updateMedium:"MediumUpdateResult",
		upsertMedium:"MediumUpsertResult",
		createVideo:"VideoCreateResult",
		deleteVideo:"VideoDeleteResult",
		updateVideo:"VideoUpdateResult",
		upsertVideo:"VideoUpsertResult",
		createSeo:"SeoCreateResult",
		deleteSeo:"SeoDeleteResult",
		updateSeo:"SeoUpdateResult",
		upsertSeo:"SeoUpsertResult",
		createProtectedImage:"ProtectedImageCreateResult",
		deleteProtectedImage:"ProtectedImageDeleteResult",
		updateProtectedImage:"ProtectedImageUpdateResult",
		upsertProtectedImage:"ProtectedImageUpsertResult",
		createTranslationDomain:"TranslationDomainCreateResult",
		deleteTranslationDomain:"TranslationDomainDeleteResult",
		updateTranslationDomain:"TranslationDomainUpdateResult",
		upsertTranslationDomain:"TranslationDomainUpsertResult",
		createTranslationCatalogue:"TranslationCatalogueCreateResult",
		deleteTranslationCatalogue:"TranslationCatalogueDeleteResult",
		updateTranslationCatalogue:"TranslationCatalogueUpdateResult",
		upsertTranslationCatalogue:"TranslationCatalogueUpsertResult",
		createTranslationKey:"TranslationKeyCreateResult",
		deleteTranslationKey:"TranslationKeyDeleteResult",
		updateTranslationKey:"TranslationKeyUpdateResult",
		upsertTranslationKey:"TranslationKeyUpsertResult",
		createTranslationValue:"TranslationValueCreateResult",
		deleteTranslationValue:"TranslationValueDeleteResult",
		updateTranslationValue:"TranslationValueUpdateResult",
		upsertTranslationValue:"TranslationValueUpsertResult",
		createTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierCreateResult",
		deleteTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierDeleteResult",
		updateTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierUpdateResult",
		upsertTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierUpsertResult",
		createSocialsAndApps:"SocialsAndAppsCreateResult",
		deleteSocialsAndApps:"SocialsAndAppsDeleteResult",
		updateSocialsAndApps:"SocialsAndAppsUpdateResult",
		upsertSocialsAndApps:"SocialsAndAppsUpsertResult",
		createProductGrid:"ProductGridCreateResult",
		deleteProductGrid:"ProductGridDeleteResult",
		updateProductGrid:"ProductGridUpdateResult",
		upsertProductGrid:"ProductGridUpsertResult",
		createProductGridItem:"ProductGridItemCreateResult",
		deleteProductGridItem:"ProductGridItemDeleteResult",
		updateProductGridItem:"ProductGridItemUpdateResult",
		upsertProductGridItem:"ProductGridItemUpsertResult",
		createGallery:"GalleryCreateResult",
		deleteGallery:"GalleryDeleteResult",
		updateGallery:"GalleryUpdateResult",
		upsertGallery:"GalleryUpsertResult",
		createGalleryItem:"GalleryItemCreateResult",
		deleteGalleryItem:"GalleryItemDeleteResult",
		updateGalleryItem:"GalleryItemUpdateResult",
		upsertGalleryItem:"GalleryItemUpsertResult",
		createHero:"HeroCreateResult",
		deleteHero:"HeroDeleteResult",
		updateHero:"HeroUpdateResult",
		upsertHero:"HeroUpsertResult",
		createSiteMenu:"SiteMenuCreateResult",
		deleteSiteMenu:"SiteMenuDeleteResult",
		updateSiteMenu:"SiteMenuUpdateResult",
		upsertSiteMenu:"SiteMenuUpsertResult",
		createMenuLocale:"MenuLocaleCreateResult",
		deleteMenuLocale:"MenuLocaleDeleteResult",
		updateMenuLocale:"MenuLocaleUpdateResult",
		upsertMenuLocale:"MenuLocaleUpsertResult",
		createMenuItem:"MenuItemCreateResult",
		deleteMenuItem:"MenuItemDeleteResult",
		updateMenuItem:"MenuItemUpdateResult",
		upsertMenuItem:"MenuItemUpsertResult",
		createPage:"PageCreateResult",
		deletePage:"PageDeleteResult",
		updatePage:"PageUpdateResult",
		upsertPage:"PageUpsertResult",
		createPageLocale:"PageLocaleCreateResult",
		deletePageLocale:"PageLocaleDeleteResult",
		updatePageLocale:"PageLocaleUpdateResult",
		upsertPageLocale:"PageLocaleUpsertResult",
		createWikiPage:"WikiPageCreateResult",
		deleteWikiPage:"WikiPageDeleteResult",
		updateWikiPage:"WikiPageUpdateResult",
		upsertWikiPage:"WikiPageUpsertResult",
		createMenuSubitem:"MenuSubitemCreateResult",
		deleteMenuSubitem:"MenuSubitemDeleteResult",
		updateMenuSubitem:"MenuSubitemUpdateResult",
		upsertMenuSubitem:"MenuSubitemUpsertResult",
		createMenuLinkList:"MenuLinkListCreateResult",
		deleteMenuLinkList:"MenuLinkListDeleteResult",
		updateMenuLinkList:"MenuLinkListUpdateResult",
		upsertMenuLinkList:"MenuLinkListUpsertResult",
		createMenuLinkItem:"MenuLinkItemCreateResult",
		deleteMenuLinkItem:"MenuLinkItemDeleteResult",
		updateMenuLinkItem:"MenuLinkItemUpdateResult",
		upsertMenuLinkItem:"MenuLinkItemUpsertResult",
		createMenuProducts:"MenuProductsCreateResult",
		deleteMenuProducts:"MenuProductsDeleteResult",
		updateMenuProducts:"MenuProductsUpdateResult",
		upsertMenuProducts:"MenuProductsUpsertResult",
		createMenuDelivery:"MenuDeliveryCreateResult",
		deleteMenuDelivery:"MenuDeliveryDeleteResult",
		updateMenuDelivery:"MenuDeliveryUpdateResult",
		upsertMenuDelivery:"MenuDeliveryUpsertResult",
		createMenuContact:"MenuContactCreateResult",
		deleteMenuContact:"MenuContactDeleteResult",
		updateMenuContact:"MenuContactUpdateResult",
		upsertMenuContact:"MenuContactUpsertResult",
		createDeadlineTemplate:"DeadlineTemplateCreateResult",
		deleteDeadlineTemplate:"DeadlineTemplateDeleteResult",
		updateDeadlineTemplate:"DeadlineTemplateUpdateResult",
		upsertDeadlineTemplate:"DeadlineTemplateUpsertResult",
		createEmployeeQueue:"EmployeeQueueCreateResult",
		deleteEmployeeQueue:"EmployeeQueueDeleteResult",
		updateEmployeeQueue:"EmployeeQueueUpdateResult",
		upsertEmployeeQueue:"EmployeeQueueUpsertResult",
		createTimetableDay:"TimetableDayCreateResult",
		deleteTimetableDay:"TimetableDayDeleteResult",
		updateTimetableDay:"TimetableDayUpdateResult",
		upsertTimetableDay:"TimetableDayUpsertResult",
		createTimetableEmployeeRole:"TimetableEmployeeRoleCreateResult",
		deleteTimetableEmployeeRole:"TimetableEmployeeRoleDeleteResult",
		updateTimetableEmployeeRole:"TimetableEmployeeRoleUpdateResult",
		upsertTimetableEmployeeRole:"TimetableEmployeeRoleUpsertResult",
		createTimetableShift:"TimetableShiftCreateResult",
		deleteTimetableShift:"TimetableShiftDeleteResult",
		updateTimetableShift:"TimetableShiftUpdateResult",
		upsertTimetableShift:"TimetableShiftUpsertResult",
		createTimetableShiftGroup:"TimetableShiftGroupCreateResult",
		deleteTimetableShiftGroup:"TimetableShiftGroupDeleteResult",
		updateTimetableShiftGroup:"TimetableShiftGroupUpdateResult",
		upsertTimetableShiftGroup:"TimetableShiftGroupUpsertResult",
		createTimetableShiftPosition:"TimetableShiftPositionCreateResult",
		deleteTimetableShiftPosition:"TimetableShiftPositionDeleteResult",
		updateTimetableShiftPosition:"TimetableShiftPositionUpdateResult",
		upsertTimetableShiftPosition:"TimetableShiftPositionUpsertResult",
		createTimetableTemplate:"TimetableTemplateCreateResult",
		deleteTimetableTemplate:"TimetableTemplateDeleteResult",
		updateTimetableTemplate:"TimetableTemplateUpdateResult",
		upsertTimetableTemplate:"TimetableTemplateUpsertResult",
		createCart:"CartCreateResult",
		deleteCart:"CartDeleteResult",
		updateCart:"CartUpdateResult",
		upsertCart:"CartUpsertResult",
		createCartItem:"CartItemCreateResult",
		deleteCartItem:"CartItemDeleteResult",
		updateCartItem:"CartItemUpdateResult",
		upsertCartItem:"CartItemUpsertResult",
		createEmployeeQueueItem:"EmployeeQueueItemCreateResult",
		deleteEmployeeQueueItem:"EmployeeQueueItemDeleteResult",
		updateEmployeeQueueItem:"EmployeeQueueItemUpdateResult",
		upsertEmployeeQueueItem:"EmployeeQueueItemUpsertResult",
		createApplication:"ApplicationCreateResult",
		deleteApplication:"ApplicationDeleteResult",
		updateApplication:"ApplicationUpdateResult",
		upsertApplication:"ApplicationUpsertResult",
		createApplicationShortcutList:"ApplicationShortcutListCreateResult",
		deleteApplicationShortcutList:"ApplicationShortcutListDeleteResult",
		updateApplicationShortcutList:"ApplicationShortcutListUpdateResult",
		upsertApplicationShortcutList:"ApplicationShortcutListUpsertResult",
		createApplicationShortcutListItem:"ApplicationShortcutListItemCreateResult",
		deleteApplicationShortcutListItem:"ApplicationShortcutListItemDeleteResult",
		updateApplicationShortcutListItem:"ApplicationShortcutListItemUpdateResult",
		upsertApplicationShortcutListItem:"ApplicationShortcutListItemUpsertResult",
		createProductBanner:"ProductBannerCreateResult",
		deleteProductBanner:"ProductBannerDeleteResult",
		updateProductBanner:"ProductBannerUpdateResult",
		upsertProductBanner:"ProductBannerUpsertResult",
		createProductBannerItem:"ProductBannerItemCreateResult",
		deleteProductBannerItem:"ProductBannerItemDeleteResult",
		updateProductBannerItem:"ProductBannerItemUpdateResult",
		upsertProductBannerItem:"ProductBannerItemUpsertResult",
		createProductBannerList:"ProductBannerListCreateResult",
		deleteProductBannerList:"ProductBannerListDeleteResult",
		updateProductBannerList:"ProductBannerListUpdateResult",
		upsertProductBannerList:"ProductBannerListUpsertResult",
		createBartender:"BartenderCreateResult",
		deleteBartender:"BartenderDeleteResult",
		updateBartender:"BartenderUpdateResult",
		upsertBartender:"BartenderUpsertResult",
		createBusinessToBusinessManager:"BusinessToBusinessManagerCreateResult",
		deleteBusinessToBusinessManager:"BusinessToBusinessManagerDeleteResult",
		updateBusinessToBusinessManager:"BusinessToBusinessManagerUpdateResult",
		upsertBusinessToBusinessManager:"BusinessToBusinessManagerUpsertResult",
		createCleaner:"CleanerCreateResult",
		deleteCleaner:"CleanerDeleteResult",
		updateCleaner:"CleanerUpdateResult",
		upsertCleaner:"CleanerUpsertResult",
		createCourier:"CourierCreateResult",
		deleteCourier:"CourierDeleteResult",
		updateCourier:"CourierUpdateResult",
		upsertCourier:"CourierUpsertResult",
		createShiftsManager:"ShiftsManagerCreateResult",
		deleteShiftsManager:"ShiftsManagerDeleteResult",
		updateShiftsManager:"ShiftsManagerUpdateResult",
		upsertShiftsManager:"ShiftsManagerUpsertResult",
		createUser:"UserCreateResult",
		deleteUser:"UserDeleteResult",
		updateUser:"UserUpdateResult",
		upsertUser:"UserUpsertResult",
		createShiftsProfile:"ShiftsProfileCreateResult",
		deleteShiftsProfile:"ShiftsProfileDeleteResult",
		updateShiftsProfile:"ShiftsProfileUpdateResult",
		upsertShiftsProfile:"ShiftsProfileUpsertResult",
		createProductIngredientCategory:"ProductIngredientCategoryCreateResult",
		deleteProductIngredientCategory:"ProductIngredientCategoryDeleteResult",
		updateProductIngredientCategory:"ProductIngredientCategoryUpdateResult",
		upsertProductIngredientCategory:"ProductIngredientCategoryUpsertResult",
		createProductIngredientCategoryLocale:"ProductIngredientCategoryLocaleCreateResult",
		deleteProductIngredientCategoryLocale:"ProductIngredientCategoryLocaleDeleteResult",
		updateProductIngredientCategoryLocale:"ProductIngredientCategoryLocaleUpdateResult",
		upsertProductIngredientCategoryLocale:"ProductIngredientCategoryLocaleUpsertResult",
		createStocksManager:"StocksManagerCreateResult",
		deleteStocksManager:"StocksManagerDeleteResult",
		updateStocksManager:"StocksManagerUpdateResult",
		upsertStocksManager:"StocksManagerUpsertResult",
		createDeliveryRoute:"DeliveryRouteCreateResult",
		deleteDeliveryRoute:"DeliveryRouteDeleteResult",
		updateDeliveryRoute:"DeliveryRouteUpdateResult",
		upsertDeliveryRoute:"DeliveryRouteUpsertResult",
		createDeliveryWaypoint:"DeliveryWaypointCreateResult",
		deleteDeliveryWaypoint:"DeliveryWaypointDeleteResult",
		updateDeliveryWaypoint:"DeliveryWaypointUpdateResult",
		upsertDeliveryWaypoint:"DeliveryWaypointUpsertResult",
		createAllergen:"AllergenCreateResult",
		deleteAllergen:"AllergenDeleteResult",
		updateAllergen:"AllergenUpdateResult",
		upsertAllergen:"AllergenUpsertResult",
		createAllergenLocale:"AllergenLocaleCreateResult",
		deleteAllergenLocale:"AllergenLocaleDeleteResult",
		updateAllergenLocale:"AllergenLocaleUpdateResult",
		upsertAllergenLocale:"AllergenLocaleUpsertResult",
		createGps:"GpsCreateResult",
		deleteGps:"GpsDeleteResult",
		updateGps:"GpsUpdateResult",
		upsertGps:"GpsUpsertResult",
		createWeekHours:"WeekHoursCreateResult",
		deleteWeekHours:"WeekHoursDeleteResult",
		updateWeekHours:"WeekHoursUpdateResult",
		upsertWeekHours:"WeekHoursUpsertResult",
		createPreparedIngredientQuantity:"PreparedIngredientQuantityCreateResult",
		deletePreparedIngredientQuantity:"PreparedIngredientQuantityDeleteResult",
		updatePreparedIngredientQuantity:"PreparedIngredientQuantityUpdateResult",
		upsertPreparedIngredientQuantity:"PreparedIngredientQuantityUpsertResult",
		createPreparedRecipeQuantity:"PreparedRecipeQuantityCreateResult",
		deletePreparedRecipeQuantity:"PreparedRecipeQuantityDeleteResult",
		updatePreparedRecipeQuantity:"PreparedRecipeQuantityUpdateResult",
		upsertPreparedRecipeQuantity:"PreparedRecipeQuantityUpsertResult",
		createInternalOrder:"InternalOrderCreateResult",
		deleteInternalOrder:"InternalOrderDeleteResult",
		updateInternalOrder:"InternalOrderUpdateResult",
		upsertInternalOrder:"InternalOrderUpsertResult",
		createInternalOrderItem:"InternalOrderItemCreateResult",
		deleteInternalOrderItem:"InternalOrderItemDeleteResult",
		updateInternalOrderItem:"InternalOrderItemUpdateResult",
		upsertInternalOrderItem:"InternalOrderItemUpsertResult",
		createPreparedPackingQuantity:"PreparedPackingQuantityCreateResult",
		deletePreparedPackingQuantity:"PreparedPackingQuantityDeleteResult",
		updatePreparedPackingQuantity:"PreparedPackingQuantityUpdateResult",
		upsertPreparedPackingQuantity:"PreparedPackingQuantityUpsertResult",
		createCourierManager:"CourierManagerCreateResult",
		deleteCourierManager:"CourierManagerDeleteResult",
		updateCourierManager:"CourierManagerUpdateResult",
		upsertCourierManager:"CourierManagerUpsertResult",
		createDeliveryZone:"DeliveryZoneCreateResult",
		deleteDeliveryZone:"DeliveryZoneDeleteResult",
		updateDeliveryZone:"DeliveryZoneUpdateResult",
		upsertDeliveryZone:"DeliveryZoneUpsertResult",
		createDeliveryTimelinePreset:"DeliveryTimelinePresetCreateResult",
		deleteDeliveryTimelinePreset:"DeliveryTimelinePresetDeleteResult",
		updateDeliveryTimelinePreset:"DeliveryTimelinePresetUpdateResult",
		upsertDeliveryTimelinePreset:"DeliveryTimelinePresetUpsertResult",
		createOrderDeliveryTimeline:"OrderDeliveryTimelineCreateResult",
		deleteOrderDeliveryTimeline:"OrderDeliveryTimelineDeleteResult",
		updateOrderDeliveryTimeline:"OrderDeliveryTimelineUpdateResult",
		upsertOrderDeliveryTimeline:"OrderDeliveryTimelineUpsertResult",
		createOrderEvent:"OrderEventCreateResult",
		deleteOrderEvent:"OrderEventDeleteResult",
		updateOrderEvent:"OrderEventUpdateResult",
		upsertOrderEvent:"OrderEventUpsertResult",
		createLiftagoRide:"LiftagoRideCreateResult",
		deleteLiftagoRide:"LiftagoRideDeleteResult",
		updateLiftagoRide:"LiftagoRideUpdateResult",
		upsertLiftagoRide:"LiftagoRideUpsertResult",
		createInvoice:"InvoiceCreateResult",
		deleteInvoice:"InvoiceDeleteResult",
		updateInvoice:"InvoiceUpdateResult",
		upsertInvoice:"InvoiceUpsertResult",
		createInvoicingPlan:"InvoicingPlanCreateResult",
		deleteInvoicingPlan:"InvoicingPlanDeleteResult",
		updateInvoicingPlan:"InvoicingPlanUpdateResult",
		upsertInvoicingPlan:"InvoicingPlanUpsertResult",
		createProductPackingLocale:"ProductPackingLocaleCreateResult",
		deleteProductPackingLocale:"ProductPackingLocaleDeleteResult",
		updateProductPackingLocale:"ProductPackingLocaleUpdateResult",
		upsertProductPackingLocale:"ProductPackingLocaleUpsertResult",
		createProductLocale:"ProductLocaleCreateResult",
		deleteProductLocale:"ProductLocaleDeleteResult",
		updateProductLocale:"ProductLocaleUpdateResult",
		upsertProductLocale:"ProductLocaleUpsertResult",
		createProductRecipeLocale:"ProductRecipeLocaleCreateResult",
		deleteProductRecipeLocale:"ProductRecipeLocaleDeleteResult",
		updateProductRecipeLocale:"ProductRecipeLocaleUpdateResult",
		upsertProductRecipeLocale:"ProductRecipeLocaleUpsertResult",
		createUserDevice:"UserDeviceCreateResult",
		deleteUserDevice:"UserDeviceDeleteResult",
		updateUserDevice:"UserDeviceUpdateResult",
		upsertUserDevice:"UserDeviceUpsertResult",
		createProtectedAction:"ProtectedActionCreateResult",
		deleteProtectedAction:"ProtectedActionDeleteResult",
		updateProtectedAction:"ProtectedActionUpdateResult",
		upsertProtectedAction:"ProtectedActionUpsertResult",
		createPicker:"PickerCreateResult",
		deletePicker:"PickerDeleteResult",
		updatePicker:"PickerUpdateResult",
		upsertPicker:"PickerUpsertResult",
		createTimetableTemplateStaffOptions:"TimetableTemplateStaffOptionsCreateResult",
		deleteTimetableTemplateStaffOptions:"TimetableTemplateStaffOptionsDeleteResult",
		updateTimetableTemplateStaffOptions:"TimetableTemplateStaffOptionsUpdateResult",
		upsertTimetableTemplateStaffOptions:"TimetableTemplateStaffOptionsUpsertResult",
		createShoppingList:"ShoppingListCreateResult",
		deleteShoppingList:"ShoppingListDeleteResult",
		updateShoppingList:"ShoppingListUpdateResult",
		upsertShoppingList:"ShoppingListUpsertResult",
		createSuppliesPurchase:"SuppliesPurchaseCreateResult",
		deleteSuppliesPurchase:"SuppliesPurchaseDeleteResult",
		updateSuppliesPurchase:"SuppliesPurchaseUpdateResult",
		upsertSuppliesPurchase:"SuppliesPurchaseUpsertResult",
		createInvoicingPreset:"InvoicingPresetCreateResult",
		deleteInvoicingPreset:"InvoicingPresetDeleteResult",
		updateInvoicingPreset:"InvoicingPresetUpdateResult",
		upsertInvoicingPreset:"InvoicingPresetUpsertResult",
		createLogRecord:"LogRecordCreateResult",
		deleteLogRecord:"LogRecordDeleteResult",
		updateLogRecord:"LogRecordUpdateResult",
		upsertLogRecord:"LogRecordUpsertResult",
		createBillingSubject:"BillingSubjectCreateResult",
		deleteBillingSubject:"BillingSubjectDeleteResult",
		updateBillingSubject:"BillingSubjectUpdateResult",
		upsertBillingSubject:"BillingSubjectUpsertResult",
		createShoppingListItem:"ShoppingListItemCreateResult",
		deleteShoppingListItem:"ShoppingListItemDeleteResult",
		updateShoppingListItem:"ShoppingListItemUpdateResult",
		upsertShoppingListItem:"ShoppingListItemUpsertResult",
		createSuppliesPurchaseItem:"SuppliesPurchaseItemCreateResult",
		deleteSuppliesPurchaseItem:"SuppliesPurchaseItemDeleteResult",
		updateSuppliesPurchaseItem:"SuppliesPurchaseItemUpdateResult",
		upsertSuppliesPurchaseItem:"SuppliesPurchaseItemUpsertResult",
		createCustomerCreditTransaction:"CustomerCreditTransactionCreateResult",
		deleteCustomerCreditTransaction:"CustomerCreditTransactionDeleteResult",
		updateCustomerCreditTransaction:"CustomerCreditTransactionUpdateResult",
		upsertCustomerCreditTransaction:"CustomerCreditTransactionUpsertResult",
		createVirtualProduct:"VirtualProductCreateResult",
		deleteVirtualProduct:"VirtualProductDeleteResult",
		updateVirtualProduct:"VirtualProductUpdateResult",
		upsertVirtualProduct:"VirtualProductUpsertResult",
		createVirtualProductEffect:"VirtualProductEffectCreateResult",
		deleteVirtualProductEffect:"VirtualProductEffectDeleteResult",
		updateVirtualProductEffect:"VirtualProductEffectUpdateResult",
		upsertVirtualProductEffect:"VirtualProductEffectUpsertResult",
		createEmploymentInformation:"EmploymentInformationCreateResult",
		deleteEmploymentInformation:"EmploymentInformationDeleteResult",
		updateEmploymentInformation:"EmploymentInformationUpdateResult",
		upsertEmploymentInformation:"EmploymentInformationUpsertResult",
		createRemunerationProfile:"RemunerationProfileCreateResult",
		deleteRemunerationProfile:"RemunerationProfileDeleteResult",
		updateRemunerationProfile:"RemunerationProfileUpdateResult",
		upsertRemunerationProfile:"RemunerationProfileUpsertResult",
		createWorkMonth:"WorkMonthCreateResult",
		deleteWorkMonth:"WorkMonthDeleteResult",
		updateWorkMonth:"WorkMonthUpdateResult",
		upsertWorkMonth:"WorkMonthUpsertResult",
		createSalaryOptions:"SalaryOptionsCreateResult",
		deleteSalaryOptions:"SalaryOptionsDeleteResult",
		updateSalaryOptions:"SalaryOptionsUpdateResult",
		upsertSalaryOptions:"SalaryOptionsUpsertResult",
		createTimetableShiftSwapInfo:"TimetableShiftSwapInfoCreateResult",
		deleteTimetableShiftSwapInfo:"TimetableShiftSwapInfoDeleteResult",
		updateTimetableShiftSwapInfo:"TimetableShiftSwapInfoUpdateResult",
		upsertTimetableShiftSwapInfo:"TimetableShiftSwapInfoUpsertResult",
		createProductGridCategory:"ProductGridCategoryCreateResult",
		deleteProductGridCategory:"ProductGridCategoryDeleteResult",
		updateProductGridCategory:"ProductGridCategoryUpdateResult",
		upsertProductGridCategory:"ProductGridCategoryUpsertResult",
		createCashier:"CashierCreateResult",
		deleteCashier:"CashierDeleteResult",
		updateCashier:"CashierUpdateResult",
		upsertCashier:"CashierUpsertResult",
		createPointOfSaleCategory:"PointOfSaleCategoryCreateResult",
		deletePointOfSaleCategory:"PointOfSaleCategoryDeleteResult",
		updatePointOfSaleCategory:"PointOfSaleCategoryUpdateResult",
		upsertPointOfSaleCategory:"PointOfSaleCategoryUpsertResult",
		createPointOfSaleCategoryLocale:"PointOfSaleCategoryLocaleCreateResult",
		deletePointOfSaleCategoryLocale:"PointOfSaleCategoryLocaleDeleteResult",
		updatePointOfSaleCategoryLocale:"PointOfSaleCategoryLocaleUpdateResult",
		upsertPointOfSaleCategoryLocale:"PointOfSaleCategoryLocaleUpsertResult",
		createPointOfSaleCategoryProduct:"PointOfSaleCategoryProductCreateResult",
		deletePointOfSaleCategoryProduct:"PointOfSaleCategoryProductDeleteResult",
		updatePointOfSaleCategoryProduct:"PointOfSaleCategoryProductUpdateResult",
		upsertPointOfSaleCategoryProduct:"PointOfSaleCategoryProductUpsertResult",
		createPointOfSaleCategoryProductLocale:"PointOfSaleCategoryProductLocaleCreateResult",
		deletePointOfSaleCategoryProductLocale:"PointOfSaleCategoryProductLocaleDeleteResult",
		updatePointOfSaleCategoryProductLocale:"PointOfSaleCategoryProductLocaleUpdateResult",
		upsertPointOfSaleCategoryProductLocale:"PointOfSaleCategoryProductLocaleUpsertResult",
		createCustomerTab:"CustomerTabCreateResult",
		deleteCustomerTab:"CustomerTabDeleteResult",
		updateCustomerTab:"CustomerTabUpdateResult",
		upsertCustomerTab:"CustomerTabUpsertResult",
		createCustomerTabItem:"CustomerTabItemCreateResult",
		deleteCustomerTabItem:"CustomerTabItemDeleteResult",
		updateCustomerTabItem:"CustomerTabItemUpdateResult",
		upsertCustomerTabItem:"CustomerTabItemUpsertResult",
		createAnonymousSession:"AnonymousSessionCreateResult",
		deleteAnonymousSession:"AnonymousSessionDeleteResult",
		updateAnonymousSession:"AnonymousSessionUpdateResult",
		upsertAnonymousSession:"AnonymousSessionUpsertResult",
		createVoucher:"VoucherCreateResult",
		deleteVoucher:"VoucherDeleteResult",
		updateVoucher:"VoucherUpdateResult",
		upsertVoucher:"VoucherUpsertResult",
		createVoucherRedemption:"VoucherRedemptionCreateResult",
		deleteVoucherRedemption:"VoucherRedemptionDeleteResult",
		updateVoucherRedemption:"VoucherRedemptionUpdateResult",
		upsertVoucherRedemption:"VoucherRedemptionUpsertResult",
		createUnassignedShiftInfo:"UnassignedShiftInfoCreateResult",
		deleteUnassignedShiftInfo:"UnassignedShiftInfoDeleteResult",
		updateUnassignedShiftInfo:"UnassignedShiftInfoUpdateResult",
		upsertUnassignedShiftInfo:"UnassignedShiftInfoUpsertResult",
		createFreshingContainer:"FreshingContainerCreateResult",
		deleteFreshingContainer:"FreshingContainerDeleteResult",
		updateFreshingContainer:"FreshingContainerUpdateResult",
		upsertFreshingContainer:"FreshingContainerUpsertResult",
		createTextItem:"TextItemCreateResult",
		deleteTextItem:"TextItemDeleteResult",
		updateTextItem:"TextItemUpdateResult",
		upsertTextItem:"TextItemUpsertResult",
		createTextList:"TextListCreateResult",
		deleteTextList:"TextListDeleteResult",
		updateTextList:"TextListUpdateResult",
		upsertTextList:"TextListUpsertResult",
		createDeliveryRegions:"DeliveryRegionsCreateResult",
		deleteDeliveryRegions:"DeliveryRegionsDeleteResult",
		updateDeliveryRegions:"DeliveryRegionsUpdateResult",
		upsertDeliveryRegions:"DeliveryRegionsUpsertResult",
		createDeliveryRegionsItem:"DeliveryRegionsItemCreateResult",
		deleteDeliveryRegionsItem:"DeliveryRegionsItemDeleteResult",
		updateDeliveryRegionsItem:"DeliveryRegionsItemUpdateResult",
		upsertDeliveryRegionsItem:"DeliveryRegionsItemUpsertResult",
		createImageList:"ImageListCreateResult",
		deleteImageList:"ImageListDeleteResult",
		updateImageList:"ImageListUpdateResult",
		upsertImageList:"ImageListUpsertResult",
		createImageListItem:"ImageListItemCreateResult",
		deleteImageListItem:"ImageListItemDeleteResult",
		updateImageListItem:"ImageListItemUpdateResult",
		upsertImageListItem:"ImageListItemUpsertResult",
		createTimetablesEmployeePrivileges:"TimetablesEmployeePrivilegesCreateResult",
		deleteTimetablesEmployeePrivileges:"TimetablesEmployeePrivilegesDeleteResult",
		updateTimetablesEmployeePrivileges:"TimetablesEmployeePrivilegesUpdateResult",
		upsertTimetablesEmployeePrivileges:"TimetablesEmployeePrivilegesUpsertResult",
		createTimetableDayNote:"TimetableDayNoteCreateResult",
		deleteTimetableDayNote:"TimetableDayNoteDeleteResult",
		updateTimetableDayNote:"TimetableDayNoteUpdateResult",
		upsertTimetableDayNote:"TimetableDayNoteUpsertResult",
		createDeliveryMethodLocale:"DeliveryMethodLocaleCreateResult",
		deleteDeliveryMethodLocale:"DeliveryMethodLocaleDeleteResult",
		updateDeliveryMethodLocale:"DeliveryMethodLocaleUpdateResult",
		upsertDeliveryMethodLocale:"DeliveryMethodLocaleUpsertResult",
		createIngredientSupplier:"IngredientSupplierCreateResult",
		deleteIngredientSupplier:"IngredientSupplierDeleteResult",
		updateIngredientSupplier:"IngredientSupplierUpdateResult",
		upsertIngredientSupplier:"IngredientSupplierUpsertResult",
		createIngredientSupplierItem:"IngredientSupplierItemCreateResult",
		deleteIngredientSupplierItem:"IngredientSupplierItemDeleteResult",
		updateIngredientSupplierItem:"IngredientSupplierItemUpdateResult",
		upsertIngredientSupplierItem:"IngredientSupplierItemUpsertResult",
		createIngredientSupplierList:"IngredientSupplierListCreateResult",
		deleteIngredientSupplierList:"IngredientSupplierListDeleteResult",
		updateIngredientSupplierList:"IngredientSupplierListUpdateResult",
		upsertIngredientSupplierList:"IngredientSupplierListUpsertResult",
		createIngredientSupplierLocale:"IngredientSupplierLocaleCreateResult",
		deleteIngredientSupplierLocale:"IngredientSupplierLocaleDeleteResult",
		updateIngredientSupplierLocale:"IngredientSupplierLocaleUpdateResult",
		upsertIngredientSupplierLocale:"IngredientSupplierLocaleUpsertResult",
		createRedirect:"RedirectCreateResult",
		deleteRedirect:"RedirectDeleteResult",
		updateRedirect:"RedirectUpdateResult",
		upsertRedirect:"RedirectUpsertResult",
		createNutritionFacts:"NutritionFactsCreateResult",
		deleteNutritionFacts:"NutritionFactsDeleteResult",
		updateNutritionFacts:"NutritionFactsUpdateResult",
		upsertNutritionFacts:"NutritionFactsUpsertResult",
		createVenue:"VenueCreateResult",
		deleteVenue:"VenueDeleteResult",
		updateVenue:"VenueUpdateResult",
		upsertVenue:"VenueUpsertResult",
		createWorkspace:"WorkspaceCreateResult",
		deleteWorkspace:"WorkspaceDeleteResult",
		updateWorkspace:"WorkspaceUpdateResult",
		upsertWorkspace:"WorkspaceUpsertResult",
		createInternalBuyer:"InternalBuyerCreateResult",
		deleteInternalBuyer:"InternalBuyerDeleteResult",
		updateInternalBuyer:"InternalBuyerUpdateResult",
		upsertInternalBuyer:"InternalBuyerUpsertResult",
		createVenueEmployeeRole:"VenueEmployeeRoleCreateResult",
		deleteVenueEmployeeRole:"VenueEmployeeRoleDeleteResult",
		updateVenueEmployeeRole:"VenueEmployeeRoleUpdateResult",
		upsertVenueEmployeeRole:"VenueEmployeeRoleUpsertResult",
		createIdentificationAttempt:"IdentificationAttemptCreateResult",
		deleteIdentificationAttempt:"IdentificationAttemptDeleteResult",
		updateIdentificationAttempt:"IdentificationAttemptUpdateResult",
		upsertIdentificationAttempt:"IdentificationAttemptUpsertResult",
		createIdentificationCode:"IdentificationCodeCreateResult",
		deleteIdentificationCode:"IdentificationCodeDeleteResult",
		updateIdentificationCode:"IdentificationCodeUpdateResult",
		upsertIdentificationCode:"IdentificationCodeUpsertResult",
		createIdentificationCodeLocale:"IdentificationCodeLocaleCreateResult",
		deleteIdentificationCodeLocale:"IdentificationCodeLocaleDeleteResult",
		updateIdentificationCodeLocale:"IdentificationCodeLocaleUpdateResult",
		upsertIdentificationCodeLocale:"IdentificationCodeLocaleUpsertResult",
		createPipeline:"PipelineCreateResult",
		deletePipeline:"PipelineDeleteResult",
		updatePipeline:"PipelineUpdateResult",
		upsertPipeline:"PipelineUpsertResult",
		createPipelineLead:"PipelineLeadCreateResult",
		deletePipelineLead:"PipelineLeadDeleteResult",
		updatePipelineLead:"PipelineLeadUpdateResult",
		upsertPipelineLead:"PipelineLeadUpsertResult",
		createPipelineStage:"PipelineStageCreateResult",
		deletePipelineStage:"PipelineStageDeleteResult",
		updatePipelineStage:"PipelineStageUpdateResult",
		upsertPipelineStage:"PipelineStageUpsertResult",
		createPipelineStageItem:"PipelineStageItemCreateResult",
		deletePipelineStageItem:"PipelineStageItemDeleteResult",
		updatePipelineStageItem:"PipelineStageItemUpdateResult",
		upsertPipelineStageItem:"PipelineStageItemUpsertResult",
		createPipelineStageLocale:"PipelineStageLocaleCreateResult",
		deletePipelineStageLocale:"PipelineStageLocaleDeleteResult",
		updatePipelineStageLocale:"PipelineStageLocaleUpdateResult",
		upsertPipelineStageLocale:"PipelineStageLocaleUpsertResult",
		createSalesManager:"SalesManagerCreateResult",
		deleteSalesManager:"SalesManagerDeleteResult",
		updateSalesManager:"SalesManagerUpdateResult",
		upsertSalesManager:"SalesManagerUpsertResult",
		createCashierManager:"CashierManagerCreateResult",
		deleteCashierManager:"CashierManagerDeleteResult",
		updateCashierManager:"CashierManagerUpdateResult",
		upsertCashierManager:"CashierManagerUpsertResult",
		createPointOfSaleApplicationDevice:"PointOfSaleApplicationDeviceCreateResult",
		deletePointOfSaleApplicationDevice:"PointOfSaleApplicationDeviceDeleteResult",
		updatePointOfSaleApplicationDevice:"PointOfSaleApplicationDeviceUpdateResult",
		upsertPointOfSaleApplicationDevice:"PointOfSaleApplicationDeviceUpsertResult",
		createPointOfSaleTerminal:"PointOfSaleTerminalCreateResult",
		deletePointOfSaleTerminal:"PointOfSaleTerminalDeleteResult",
		updatePointOfSaleTerminal:"PointOfSaleTerminalUpdateResult",
		upsertPointOfSaleTerminal:"PointOfSaleTerminalUpsertResult",
		createPipelineStageSentiment:"PipelineStageSentimentCreateResult",
		deletePipelineStageSentiment:"PipelineStageSentimentDeleteResult",
		updatePipelineStageSentiment:"PipelineStageSentimentUpdateResult",
		upsertPipelineStageSentiment:"PipelineStageSentimentUpsertResult",
		createDeviceIdentifier:"DeviceIdentifierCreateResult",
		deleteDeviceIdentifier:"DeviceIdentifierDeleteResult",
		updateDeviceIdentifier:"DeviceIdentifierUpdateResult",
		upsertDeviceIdentifier:"DeviceIdentifierUpsertResult",
		createPointOfSalePrinter:"PointOfSalePrinterCreateResult",
		deletePointOfSalePrinter:"PointOfSalePrinterDeleteResult",
		updatePointOfSalePrinter:"PointOfSalePrinterUpdateResult",
		upsertPointOfSalePrinter:"PointOfSalePrinterUpsertResult",
		createGratuity:"GratuityCreateResult",
		deleteGratuity:"GratuityDeleteResult",
		updateGratuity:"GratuityUpdateResult",
		upsertGratuity:"GratuityUpsertResult",
		createFulfillmentNote:"FulfillmentNoteCreateResult",
		deleteFulfillmentNote:"FulfillmentNoteDeleteResult",
		updateFulfillmentNote:"FulfillmentNoteUpdateResult",
		upsertFulfillmentNote:"FulfillmentNoteUpsertResult",
		createLeadForm:"LeadFormCreateResult",
		deleteLeadForm:"LeadFormDeleteResult",
		updateLeadForm:"LeadFormUpdateResult",
		upsertLeadForm:"LeadFormUpsertResult",
		createSubscriptionBox:"SubscriptionBoxCreateResult",
		deleteSubscriptionBox:"SubscriptionBoxDeleteResult",
		updateSubscriptionBox:"SubscriptionBoxUpdateResult",
		upsertSubscriptionBox:"SubscriptionBoxUpsertResult",
		createSubscriptionBoxLocale:"SubscriptionBoxLocaleCreateResult",
		deleteSubscriptionBoxLocale:"SubscriptionBoxLocaleDeleteResult",
		updateSubscriptionBoxLocale:"SubscriptionBoxLocaleUpdateResult",
		upsertSubscriptionBoxLocale:"SubscriptionBoxLocaleUpsertResult",
		createBusinessService:"BusinessServiceCreateResult",
		deleteBusinessService:"BusinessServiceDeleteResult",
		updateBusinessService:"BusinessServiceUpdateResult",
		upsertBusinessService:"BusinessServiceUpsertResult",
		createBusinessServiceEvent:"BusinessServiceEventCreateResult",
		deleteBusinessServiceEvent:"BusinessServiceEventDeleteResult",
		updateBusinessServiceEvent:"BusinessServiceEventUpdateResult",
		upsertBusinessServiceEvent:"BusinessServiceEventUpsertResult",
		createBusinessServiceLocale:"BusinessServiceLocaleCreateResult",
		deleteBusinessServiceLocale:"BusinessServiceLocaleDeleteResult",
		updateBusinessServiceLocale:"BusinessServiceLocaleUpdateResult",
		upsertBusinessServiceLocale:"BusinessServiceLocaleUpsertResult",
		createGridTileItem:"GridTileItemCreateResult",
		deleteGridTileItem:"GridTileItemDeleteResult",
		updateGridTileItem:"GridTileItemUpdateResult",
		upsertGridTileItem:"GridTileItemUpsertResult",
		createGridTiles:"GridTilesCreateResult",
		deleteGridTiles:"GridTilesDeleteResult",
		updateGridTiles:"GridTilesUpdateResult",
		upsertGridTiles:"GridTilesUpsertResult",
		createArea:"AreaCreateResult",
		deleteArea:"AreaDeleteResult",
		updateArea:"AreaUpdateResult",
		upsertArea:"AreaUpsertResult",
		createPosition:"PositionCreateResult",
		deletePosition:"PositionDeleteResult",
		updatePosition:"PositionUpdateResult",
		upsertPosition:"PositionUpsertResult",
		createStatsEnabledWidgetType:"StatsEnabledWidgetTypeCreateResult",
		deleteStatsEnabledWidgetType:"StatsEnabledWidgetTypeDeleteResult",
		updateStatsEnabledWidgetType:"StatsEnabledWidgetTypeUpdateResult",
		upsertStatsEnabledWidgetType:"StatsEnabledWidgetTypeUpsertResult",
		createStatsWidget:"StatsWidgetCreateResult",
		deleteStatsWidget:"StatsWidgetDeleteResult",
		updateStatsWidget:"StatsWidgetUpdateResult",
		upsertStatsWidget:"StatsWidgetUpsertResult",
		createStatsWidgetsLayout:"StatsWidgetsLayoutCreateResult",
		deleteStatsWidgetsLayout:"StatsWidgetsLayoutDeleteResult",
		updateStatsWidgetsLayout:"StatsWidgetsLayoutUpdateResult",
		upsertStatsWidgetsLayout:"StatsWidgetsLayoutUpsertResult",
		createSeat:"SeatCreateResult",
		deleteSeat:"SeatDeleteResult",
		updateSeat:"SeatUpdateResult",
		upsertSeat:"SeatUpsertResult",
		createTable:"TableCreateResult",
		deleteTable:"TableDeleteResult",
		updateTable:"TableUpdateResult",
		upsertTable:"TableUpsertResult",
		createStatsPage:"StatsPageCreateResult",
		deleteStatsPage:"StatsPageDeleteResult",
		updateStatsPage:"StatsPageUpdateResult",
		upsertStatsPage:"StatsPageUpsertResult",
		createUnassignReason:"UnassignReasonCreateResult",
		deleteUnassignReason:"UnassignReasonDeleteResult",
		updateUnassignReason:"UnassignReasonUpdateResult",
		upsertUnassignReason:"UnassignReasonUpsertResult",
		createDoubleshotCoffeeEquipment:"DoubleshotCoffeeEquipmentCreateResult",
		deleteDoubleshotCoffeeEquipment:"DoubleshotCoffeeEquipmentDeleteResult",
		updateDoubleshotCoffeeEquipment:"DoubleshotCoffeeEquipmentUpdateResult",
		upsertDoubleshotCoffeeEquipment:"DoubleshotCoffeeEquipmentUpsertResult",
		createExpense:"ExpenseCreateResult",
		deleteExpense:"ExpenseDeleteResult",
		updateExpense:"ExpenseUpdateResult",
		upsertExpense:"ExpenseUpsertResult",
		createExpenseCategory:"ExpenseCategoryCreateResult",
		deleteExpenseCategory:"ExpenseCategoryDeleteResult",
		updateExpenseCategory:"ExpenseCategoryUpdateResult",
		upsertExpenseCategory:"ExpenseCategoryUpsertResult",
		createExpenseChange:"ExpenseChangeCreateResult",
		deleteExpenseChange:"ExpenseChangeDeleteResult",
		updateExpenseChange:"ExpenseChangeUpdateResult",
		upsertExpenseChange:"ExpenseChangeUpsertResult",
		createExpenseDocument:"ExpenseDocumentCreateResult",
		deleteExpenseDocument:"ExpenseDocumentDeleteResult",
		updateExpenseDocument:"ExpenseDocumentUpdateResult",
		upsertExpenseDocument:"ExpenseDocumentUpsertResult",
		createRevenuePrediction:"RevenuePredictionCreateResult",
		deleteRevenuePrediction:"RevenuePredictionDeleteResult",
		updateRevenuePrediction:"RevenuePredictionUpdateResult",
		upsertRevenuePrediction:"RevenuePredictionUpsertResult",
		createRevenuePredictionChange:"RevenuePredictionChangeCreateResult",
		deleteRevenuePredictionChange:"RevenuePredictionChangeDeleteResult",
		updateRevenuePredictionChange:"RevenuePredictionChangeUpdateResult",
		upsertRevenuePredictionChange:"RevenuePredictionChangeUpsertResult",
		createFile:"FileCreateResult",
		deleteFile:"FileDeleteResult",
		updateFile:"FileUpdateResult",
		upsertFile:"FileUpsertResult",
		createLine:"LineCreateResult",
		deleteLine:"LineDeleteResult",
		updateLine:"LineUpdateResult",
		upsertLine:"LineUpsertResult",
		createFinancesBalanceItem:"FinancesBalanceItemCreateResult",
		deleteFinancesBalanceItem:"FinancesBalanceItemDeleteResult",
		updateFinancesBalanceItem:"FinancesBalanceItemUpdateResult",
		upsertFinancesBalanceItem:"FinancesBalanceItemUpsertResult",
		createWoltDriveDelivery:"WoltDriveDeliveryCreateResult",
		deleteWoltDriveDelivery:"WoltDriveDeliveryDeleteResult",
		updateWoltDriveDelivery:"WoltDriveDeliveryUpdateResult",
		upsertWoltDriveDelivery:"WoltDriveDeliveryUpsertResult",
		transaction:"MutationTransaction",
		query:"Query",
		generateUploadUrl:"S3SignedUpload",
		generateReadUrl:"S3SignedRead"
	},
	AddressCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Address",
		validation:"_ValidationResult"
	},
	MutationResult:{
		"...on AddressCreateResult": "AddressCreateResult",
		"...on AddressDeleteResult": "AddressDeleteResult",
		"...on AddressUpdateResult": "AddressUpdateResult",
		"...on AddressUpsertResult": "AddressUpsertResult",
		"...on CountryCreateResult": "CountryCreateResult",
		"...on CountryDeleteResult": "CountryDeleteResult",
		"...on CountryUpdateResult": "CountryUpdateResult",
		"...on CountryUpsertResult": "CountryUpsertResult",
		"...on ChannelCreateResult": "ChannelCreateResult",
		"...on ChannelDeleteResult": "ChannelDeleteResult",
		"...on ChannelUpdateResult": "ChannelUpdateResult",
		"...on ChannelUpsertResult": "ChannelUpsertResult",
		"...on ChannelPaymentCreateResult": "ChannelPaymentCreateResult",
		"...on ChannelPaymentDeleteResult": "ChannelPaymentDeleteResult",
		"...on ChannelPaymentUpdateResult": "ChannelPaymentUpdateResult",
		"...on ChannelPaymentUpsertResult": "ChannelPaymentUpsertResult",
		"...on ChannelDeliveryCreateResult": "ChannelDeliveryCreateResult",
		"...on ChannelDeliveryDeleteResult": "ChannelDeliveryDeleteResult",
		"...on ChannelDeliveryUpdateResult": "ChannelDeliveryUpdateResult",
		"...on ChannelDeliveryUpsertResult": "ChannelDeliveryUpsertResult",
		"...on CustomerCreateResult": "CustomerCreateResult",
		"...on CustomerDeleteResult": "CustomerDeleteResult",
		"...on CustomerUpdateResult": "CustomerUpdateResult",
		"...on CustomerUpsertResult": "CustomerUpsertResult",
		"...on CustomerCreditCreateResult": "CustomerCreditCreateResult",
		"...on CustomerCreditDeleteResult": "CustomerCreditDeleteResult",
		"...on CustomerCreditUpdateResult": "CustomerCreditUpdateResult",
		"...on CustomerCreditUpsertResult": "CustomerCreditUpsertResult",
		"...on CustomerGroupCreateResult": "CustomerGroupCreateResult",
		"...on CustomerGroupDeleteResult": "CustomerGroupDeleteResult",
		"...on CustomerGroupUpdateResult": "CustomerGroupUpdateResult",
		"...on CustomerGroupUpsertResult": "CustomerGroupUpsertResult",
		"...on CustomerPaymentMethodCreateResult": "CustomerPaymentMethodCreateResult",
		"...on CustomerPaymentMethodDeleteResult": "CustomerPaymentMethodDeleteResult",
		"...on CustomerPaymentMethodUpdateResult": "CustomerPaymentMethodUpdateResult",
		"...on CustomerPaymentMethodUpsertResult": "CustomerPaymentMethodUpsertResult",
		"...on DeliveryMethodCreateResult": "DeliveryMethodCreateResult",
		"...on DeliveryMethodDeleteResult": "DeliveryMethodDeleteResult",
		"...on DeliveryMethodUpdateResult": "DeliveryMethodUpdateResult",
		"...on DeliveryMethodUpsertResult": "DeliveryMethodUpsertResult",
		"...on OrderCreateResult": "OrderCreateResult",
		"...on OrderDeleteResult": "OrderDeleteResult",
		"...on OrderUpdateResult": "OrderUpdateResult",
		"...on OrderUpsertResult": "OrderUpsertResult",
		"...on OrderDiscountCreateResult": "OrderDiscountCreateResult",
		"...on OrderDiscountDeleteResult": "OrderDiscountDeleteResult",
		"...on OrderDiscountUpdateResult": "OrderDiscountUpdateResult",
		"...on OrderDiscountUpsertResult": "OrderDiscountUpsertResult",
		"...on OrderPaymentCreateResult": "OrderPaymentCreateResult",
		"...on OrderPaymentDeleteResult": "OrderPaymentDeleteResult",
		"...on OrderPaymentUpdateResult": "OrderPaymentUpdateResult",
		"...on OrderPaymentUpsertResult": "OrderPaymentUpsertResult",
		"...on OrderDeliveryCreateResult": "OrderDeliveryCreateResult",
		"...on OrderDeliveryDeleteResult": "OrderDeliveryDeleteResult",
		"...on OrderDeliveryUpdateResult": "OrderDeliveryUpdateResult",
		"...on OrderDeliveryUpsertResult": "OrderDeliveryUpsertResult",
		"...on OrderItemCreateResult": "OrderItemCreateResult",
		"...on OrderItemDeleteResult": "OrderItemDeleteResult",
		"...on OrderItemUpdateResult": "OrderItemUpdateResult",
		"...on OrderItemUpsertResult": "OrderItemUpsertResult",
		"...on PaymentMethodCreateResult": "PaymentMethodCreateResult",
		"...on PaymentMethodDeleteResult": "PaymentMethodDeleteResult",
		"...on PaymentMethodUpdateResult": "PaymentMethodUpdateResult",
		"...on PaymentMethodUpsertResult": "PaymentMethodUpsertResult",
		"...on VatRateCreateResult": "VatRateCreateResult",
		"...on VatRateDeleteResult": "VatRateDeleteResult",
		"...on VatRateUpdateResult": "VatRateUpdateResult",
		"...on VatRateUpsertResult": "VatRateUpsertResult",
		"...on ProductCreateResult": "ProductCreateResult",
		"...on ProductDeleteResult": "ProductDeleteResult",
		"...on ProductUpdateResult": "ProductUpdateResult",
		"...on ProductUpsertResult": "ProductUpsertResult",
		"...on ProductStockCreateResult": "ProductStockCreateResult",
		"...on ProductStockDeleteResult": "ProductStockDeleteResult",
		"...on ProductStockUpdateResult": "ProductStockUpdateResult",
		"...on ProductStockUpsertResult": "ProductStockUpsertResult",
		"...on ProductPackingCreateResult": "ProductPackingCreateResult",
		"...on ProductPackingDeleteResult": "ProductPackingDeleteResult",
		"...on ProductPackingUpdateResult": "ProductPackingUpdateResult",
		"...on ProductPackingUpsertResult": "ProductPackingUpsertResult",
		"...on ProductGroupPriceCreateResult": "ProductGroupPriceCreateResult",
		"...on ProductGroupPriceDeleteResult": "ProductGroupPriceDeleteResult",
		"...on ProductGroupPriceUpdateResult": "ProductGroupPriceUpdateResult",
		"...on ProductGroupPriceUpsertResult": "ProductGroupPriceUpsertResult",
		"...on ProductRecipeCreateResult": "ProductRecipeCreateResult",
		"...on ProductRecipeDeleteResult": "ProductRecipeDeleteResult",
		"...on ProductRecipeUpdateResult": "ProductRecipeUpdateResult",
		"...on ProductRecipeUpsertResult": "ProductRecipeUpsertResult",
		"...on ProductCategoryCreateResult": "ProductCategoryCreateResult",
		"...on ProductCategoryDeleteResult": "ProductCategoryDeleteResult",
		"...on ProductCategoryUpdateResult": "ProductCategoryUpdateResult",
		"...on ProductCategoryUpsertResult": "ProductCategoryUpsertResult",
		"...on StoreCreateResult": "StoreCreateResult",
		"...on StoreDeleteResult": "StoreDeleteResult",
		"...on StoreUpdateResult": "StoreUpdateResult",
		"...on StoreUpsertResult": "StoreUpsertResult",
		"...on TagCreateResult": "TagCreateResult",
		"...on TagDeleteResult": "TagDeleteResult",
		"...on TagUpdateResult": "TagUpdateResult",
		"...on TagUpsertResult": "TagUpsertResult",
		"...on ImageCreateResult": "ImageCreateResult",
		"...on ImageDeleteResult": "ImageDeleteResult",
		"...on ImageUpdateResult": "ImageUpdateResult",
		"...on ImageUpsertResult": "ImageUpsertResult",
		"...on BusinessCategoryCreateResult": "BusinessCategoryCreateResult",
		"...on BusinessCategoryDeleteResult": "BusinessCategoryDeleteResult",
		"...on BusinessCategoryUpdateResult": "BusinessCategoryUpdateResult",
		"...on BusinessCategoryUpsertResult": "BusinessCategoryUpsertResult",
		"...on ProductListCreateResult": "ProductListCreateResult",
		"...on ProductListDeleteResult": "ProductListDeleteResult",
		"...on ProductListUpdateResult": "ProductListUpdateResult",
		"...on ProductListUpsertResult": "ProductListUpsertResult",
		"...on ProductListItemCreateResult": "ProductListItemCreateResult",
		"...on ProductListItemDeleteResult": "ProductListItemDeleteResult",
		"...on ProductListItemUpdateResult": "ProductListItemUpdateResult",
		"...on ProductListItemUpsertResult": "ProductListItemUpsertResult",
		"...on ProductCategoryListCreateResult": "ProductCategoryListCreateResult",
		"...on ProductCategoryListDeleteResult": "ProductCategoryListDeleteResult",
		"...on ProductCategoryListUpdateResult": "ProductCategoryListUpdateResult",
		"...on ProductCategoryListUpsertResult": "ProductCategoryListUpsertResult",
		"...on ProductCategoryListItemCreateResult": "ProductCategoryListItemCreateResult",
		"...on ProductCategoryListItemDeleteResult": "ProductCategoryListItemDeleteResult",
		"...on ProductCategoryListItemUpdateResult": "ProductCategoryListItemUpdateResult",
		"...on ProductCategoryListItemUpsertResult": "ProductCategoryListItemUpsertResult",
		"...on BusinessCategoryLocaleCreateResult": "BusinessCategoryLocaleCreateResult",
		"...on BusinessCategoryLocaleDeleteResult": "BusinessCategoryLocaleDeleteResult",
		"...on BusinessCategoryLocaleUpdateResult": "BusinessCategoryLocaleUpdateResult",
		"...on BusinessCategoryLocaleUpsertResult": "BusinessCategoryLocaleUpsertResult",
		"...on LocaleCreateResult": "LocaleCreateResult",
		"...on LocaleDeleteResult": "LocaleDeleteResult",
		"...on LocaleUpdateResult": "LocaleUpdateResult",
		"...on LocaleUpsertResult": "LocaleUpsertResult",
		"...on ProductCategoryListLocaleCreateResult": "ProductCategoryListLocaleCreateResult",
		"...on ProductCategoryListLocaleDeleteResult": "ProductCategoryListLocaleDeleteResult",
		"...on ProductCategoryListLocaleUpdateResult": "ProductCategoryListLocaleUpdateResult",
		"...on ProductCategoryListLocaleUpsertResult": "ProductCategoryListLocaleUpsertResult",
		"...on CustomerNameCreateResult": "CustomerNameCreateResult",
		"...on CustomerNameDeleteResult": "CustomerNameDeleteResult",
		"...on CustomerNameUpdateResult": "CustomerNameUpdateResult",
		"...on CustomerNameUpsertResult": "CustomerNameUpsertResult",
		"...on CustomerAliasCreateResult": "CustomerAliasCreateResult",
		"...on CustomerAliasDeleteResult": "CustomerAliasDeleteResult",
		"...on CustomerAliasUpdateResult": "CustomerAliasUpdateResult",
		"...on CustomerAliasUpsertResult": "CustomerAliasUpsertResult",
		"...on ProductIngredientItemCreateResult": "ProductIngredientItemCreateResult",
		"...on ProductIngredientItemDeleteResult": "ProductIngredientItemDeleteResult",
		"...on ProductIngredientItemUpdateResult": "ProductIngredientItemUpdateResult",
		"...on ProductIngredientItemUpsertResult": "ProductIngredientItemUpsertResult",
		"...on ProductIngredientItemQuantityCreateResult": "ProductIngredientItemQuantityCreateResult",
		"...on ProductIngredientItemQuantityDeleteResult": "ProductIngredientItemQuantityDeleteResult",
		"...on ProductIngredientItemQuantityUpdateResult": "ProductIngredientItemQuantityUpdateResult",
		"...on ProductIngredientItemQuantityUpsertResult": "ProductIngredientItemQuantityUpsertResult",
		"...on ProductIngredientItemQuantityUnitCreateResult": "ProductIngredientItemQuantityUnitCreateResult",
		"...on ProductIngredientItemQuantityUnitDeleteResult": "ProductIngredientItemQuantityUnitDeleteResult",
		"...on ProductIngredientItemQuantityUnitUpdateResult": "ProductIngredientItemQuantityUnitUpdateResult",
		"...on ProductIngredientItemQuantityUnitUpsertResult": "ProductIngredientItemQuantityUnitUpsertResult",
		"...on ProductIngredientCreateResult": "ProductIngredientCreateResult",
		"...on ProductIngredientDeleteResult": "ProductIngredientDeleteResult",
		"...on ProductIngredientUpdateResult": "ProductIngredientUpdateResult",
		"...on ProductIngredientUpsertResult": "ProductIngredientUpsertResult",
		"...on CustomerIngredientRatingCreateResult": "CustomerIngredientRatingCreateResult",
		"...on CustomerIngredientRatingDeleteResult": "CustomerIngredientRatingDeleteResult",
		"...on CustomerIngredientRatingUpdateResult": "CustomerIngredientRatingUpdateResult",
		"...on CustomerIngredientRatingUpsertResult": "CustomerIngredientRatingUpsertResult",
		"...on ProductIngredientRatingCreateResult": "ProductIngredientRatingCreateResult",
		"...on ProductIngredientRatingDeleteResult": "ProductIngredientRatingDeleteResult",
		"...on ProductIngredientRatingUpdateResult": "ProductIngredientRatingUpdateResult",
		"...on ProductIngredientRatingUpsertResult": "ProductIngredientRatingUpsertResult",
		"...on ProductIngredientLocaleCreateResult": "ProductIngredientLocaleCreateResult",
		"...on ProductIngredientLocaleDeleteResult": "ProductIngredientLocaleDeleteResult",
		"...on ProductIngredientLocaleUpdateResult": "ProductIngredientLocaleUpdateResult",
		"...on ProductIngredientLocaleUpsertResult": "ProductIngredientLocaleUpsertResult",
		"...on OrderRecurrenceCreateResult": "OrderRecurrenceCreateResult",
		"...on OrderRecurrenceDeleteResult": "OrderRecurrenceDeleteResult",
		"...on OrderRecurrenceUpdateResult": "OrderRecurrenceUpdateResult",
		"...on OrderRecurrenceUpsertResult": "OrderRecurrenceUpsertResult",
		"...on OrderRecurrenceLocaleCreateResult": "OrderRecurrenceLocaleCreateResult",
		"...on OrderRecurrenceLocaleDeleteResult": "OrderRecurrenceLocaleDeleteResult",
		"...on OrderRecurrenceLocaleUpdateResult": "OrderRecurrenceLocaleUpdateResult",
		"...on OrderRecurrenceLocaleUpsertResult": "OrderRecurrenceLocaleUpsertResult",
		"...on BusinessCustomerCreateResult": "BusinessCustomerCreateResult",
		"...on BusinessCustomerDeleteResult": "BusinessCustomerDeleteResult",
		"...on BusinessCustomerUpdateResult": "BusinessCustomerUpdateResult",
		"...on BusinessCustomerUpsertResult": "BusinessCustomerUpsertResult",
		"...on PointOfSaleCreateResult": "PointOfSaleCreateResult",
		"...on PointOfSaleDeleteResult": "PointOfSaleDeleteResult",
		"...on PointOfSaleUpdateResult": "PointOfSaleUpdateResult",
		"...on PointOfSaleUpsertResult": "PointOfSaleUpsertResult",
		"...on StaffCreateResult": "StaffCreateResult",
		"...on StaffDeleteResult": "StaffDeleteResult",
		"...on StaffUpdateResult": "StaffUpdateResult",
		"...on StaffUpsertResult": "StaffUpsertResult",
		"...on BlogCreateResult": "BlogCreateResult",
		"...on BlogDeleteResult": "BlogDeleteResult",
		"...on BlogUpdateResult": "BlogUpdateResult",
		"...on BlogUpsertResult": "BlogUpsertResult",
		"...on BlogLocaleCreateResult": "BlogLocaleCreateResult",
		"...on BlogLocaleDeleteResult": "BlogLocaleDeleteResult",
		"...on BlogLocaleUpdateResult": "BlogLocaleUpdateResult",
		"...on BlogLocaleUpsertResult": "BlogLocaleUpsertResult",
		"...on BlogPostCreateResult": "BlogPostCreateResult",
		"...on BlogPostDeleteResult": "BlogPostDeleteResult",
		"...on BlogPostUpdateResult": "BlogPostUpdateResult",
		"...on BlogPostUpsertResult": "BlogPostUpsertResult",
		"...on BlogPostLocaleCreateResult": "BlogPostLocaleCreateResult",
		"...on BlogPostLocaleDeleteResult": "BlogPostLocaleDeleteResult",
		"...on BlogPostLocaleUpdateResult": "BlogPostLocaleUpdateResult",
		"...on BlogPostLocaleUpsertResult": "BlogPostLocaleUpsertResult",
		"...on ColorPalleteCreateResult": "ColorPalleteCreateResult",
		"...on ColorPalleteDeleteResult": "ColorPalleteDeleteResult",
		"...on ColorPalleteUpdateResult": "ColorPalleteUpdateResult",
		"...on ColorPalleteUpsertResult": "ColorPalleteUpsertResult",
		"...on ContentCreateResult": "ContentCreateResult",
		"...on ContentDeleteResult": "ContentDeleteResult",
		"...on ContentUpdateResult": "ContentUpdateResult",
		"...on ContentUpsertResult": "ContentUpsertResult",
		"...on ContentBlockCreateResult": "ContentBlockCreateResult",
		"...on ContentBlockDeleteResult": "ContentBlockDeleteResult",
		"...on ContentBlockUpdateResult": "ContentBlockUpdateResult",
		"...on ContentBlockUpsertResult": "ContentBlockUpsertResult",
		"...on ContentReferenceCreateResult": "ContentReferenceCreateResult",
		"...on ContentReferenceDeleteResult": "ContentReferenceDeleteResult",
		"...on ContentReferenceUpdateResult": "ContentReferenceUpdateResult",
		"...on ContentReferenceUpsertResult": "ContentReferenceUpsertResult",
		"...on BlogPostListCreateResult": "BlogPostListCreateResult",
		"...on BlogPostListDeleteResult": "BlogPostListDeleteResult",
		"...on BlogPostListUpdateResult": "BlogPostListUpdateResult",
		"...on BlogPostListUpsertResult": "BlogPostListUpsertResult",
		"...on BlogPostListItemCreateResult": "BlogPostListItemCreateResult",
		"...on BlogPostListItemDeleteResult": "BlogPostListItemDeleteResult",
		"...on BlogPostListItemUpdateResult": "BlogPostListItemUpdateResult",
		"...on BlogPostListItemUpsertResult": "BlogPostListItemUpsertResult",
		"...on LinkListCreateResult": "LinkListCreateResult",
		"...on LinkListDeleteResult": "LinkListDeleteResult",
		"...on LinkListUpdateResult": "LinkListUpdateResult",
		"...on LinkListUpsertResult": "LinkListUpsertResult",
		"...on LinkListItemCreateResult": "LinkListItemCreateResult",
		"...on LinkListItemDeleteResult": "LinkListItemDeleteResult",
		"...on LinkListItemUpdateResult": "LinkListItemUpdateResult",
		"...on LinkListItemUpsertResult": "LinkListItemUpsertResult",
		"...on CoverCreateResult": "CoverCreateResult",
		"...on CoverDeleteResult": "CoverDeleteResult",
		"...on CoverUpdateResult": "CoverUpdateResult",
		"...on CoverUpsertResult": "CoverUpsertResult",
		"...on LinkCreateResult": "LinkCreateResult",
		"...on LinkDeleteResult": "LinkDeleteResult",
		"...on LinkUpdateResult": "LinkUpdateResult",
		"...on LinkUpsertResult": "LinkUpsertResult",
		"...on LinkableCreateResult": "LinkableCreateResult",
		"...on LinkableDeleteResult": "LinkableDeleteResult",
		"...on LinkableUpdateResult": "LinkableUpdateResult",
		"...on LinkableUpsertResult": "LinkableUpsertResult",
		"...on MediumCreateResult": "MediumCreateResult",
		"...on MediumDeleteResult": "MediumDeleteResult",
		"...on MediumUpdateResult": "MediumUpdateResult",
		"...on MediumUpsertResult": "MediumUpsertResult",
		"...on VideoCreateResult": "VideoCreateResult",
		"...on VideoDeleteResult": "VideoDeleteResult",
		"...on VideoUpdateResult": "VideoUpdateResult",
		"...on VideoUpsertResult": "VideoUpsertResult",
		"...on SeoCreateResult": "SeoCreateResult",
		"...on SeoDeleteResult": "SeoDeleteResult",
		"...on SeoUpdateResult": "SeoUpdateResult",
		"...on SeoUpsertResult": "SeoUpsertResult",
		"...on ProtectedImageCreateResult": "ProtectedImageCreateResult",
		"...on ProtectedImageDeleteResult": "ProtectedImageDeleteResult",
		"...on ProtectedImageUpdateResult": "ProtectedImageUpdateResult",
		"...on ProtectedImageUpsertResult": "ProtectedImageUpsertResult",
		"...on TranslationDomainCreateResult": "TranslationDomainCreateResult",
		"...on TranslationDomainDeleteResult": "TranslationDomainDeleteResult",
		"...on TranslationDomainUpdateResult": "TranslationDomainUpdateResult",
		"...on TranslationDomainUpsertResult": "TranslationDomainUpsertResult",
		"...on TranslationCatalogueCreateResult": "TranslationCatalogueCreateResult",
		"...on TranslationCatalogueDeleteResult": "TranslationCatalogueDeleteResult",
		"...on TranslationCatalogueUpdateResult": "TranslationCatalogueUpdateResult",
		"...on TranslationCatalogueUpsertResult": "TranslationCatalogueUpsertResult",
		"...on TranslationKeyCreateResult": "TranslationKeyCreateResult",
		"...on TranslationKeyDeleteResult": "TranslationKeyDeleteResult",
		"...on TranslationKeyUpdateResult": "TranslationKeyUpdateResult",
		"...on TranslationKeyUpsertResult": "TranslationKeyUpsertResult",
		"...on TranslationValueCreateResult": "TranslationValueCreateResult",
		"...on TranslationValueDeleteResult": "TranslationValueDeleteResult",
		"...on TranslationValueUpdateResult": "TranslationValueUpdateResult",
		"...on TranslationValueUpsertResult": "TranslationValueUpsertResult",
		"...on TranslationCataloguesIdentifierCreateResult": "TranslationCataloguesIdentifierCreateResult",
		"...on TranslationCataloguesIdentifierDeleteResult": "TranslationCataloguesIdentifierDeleteResult",
		"...on TranslationCataloguesIdentifierUpdateResult": "TranslationCataloguesIdentifierUpdateResult",
		"...on TranslationCataloguesIdentifierUpsertResult": "TranslationCataloguesIdentifierUpsertResult",
		"...on SocialsAndAppsCreateResult": "SocialsAndAppsCreateResult",
		"...on SocialsAndAppsDeleteResult": "SocialsAndAppsDeleteResult",
		"...on SocialsAndAppsUpdateResult": "SocialsAndAppsUpdateResult",
		"...on SocialsAndAppsUpsertResult": "SocialsAndAppsUpsertResult",
		"...on ProductGridCreateResult": "ProductGridCreateResult",
		"...on ProductGridDeleteResult": "ProductGridDeleteResult",
		"...on ProductGridUpdateResult": "ProductGridUpdateResult",
		"...on ProductGridUpsertResult": "ProductGridUpsertResult",
		"...on ProductGridItemCreateResult": "ProductGridItemCreateResult",
		"...on ProductGridItemDeleteResult": "ProductGridItemDeleteResult",
		"...on ProductGridItemUpdateResult": "ProductGridItemUpdateResult",
		"...on ProductGridItemUpsertResult": "ProductGridItemUpsertResult",
		"...on GalleryCreateResult": "GalleryCreateResult",
		"...on GalleryDeleteResult": "GalleryDeleteResult",
		"...on GalleryUpdateResult": "GalleryUpdateResult",
		"...on GalleryUpsertResult": "GalleryUpsertResult",
		"...on GalleryItemCreateResult": "GalleryItemCreateResult",
		"...on GalleryItemDeleteResult": "GalleryItemDeleteResult",
		"...on GalleryItemUpdateResult": "GalleryItemUpdateResult",
		"...on GalleryItemUpsertResult": "GalleryItemUpsertResult",
		"...on HeroCreateResult": "HeroCreateResult",
		"...on HeroDeleteResult": "HeroDeleteResult",
		"...on HeroUpdateResult": "HeroUpdateResult",
		"...on HeroUpsertResult": "HeroUpsertResult",
		"...on SiteMenuCreateResult": "SiteMenuCreateResult",
		"...on SiteMenuDeleteResult": "SiteMenuDeleteResult",
		"...on SiteMenuUpdateResult": "SiteMenuUpdateResult",
		"...on SiteMenuUpsertResult": "SiteMenuUpsertResult",
		"...on MenuLocaleCreateResult": "MenuLocaleCreateResult",
		"...on MenuLocaleDeleteResult": "MenuLocaleDeleteResult",
		"...on MenuLocaleUpdateResult": "MenuLocaleUpdateResult",
		"...on MenuLocaleUpsertResult": "MenuLocaleUpsertResult",
		"...on MenuItemCreateResult": "MenuItemCreateResult",
		"...on MenuItemDeleteResult": "MenuItemDeleteResult",
		"...on MenuItemUpdateResult": "MenuItemUpdateResult",
		"...on MenuItemUpsertResult": "MenuItemUpsertResult",
		"...on PageCreateResult": "PageCreateResult",
		"...on PageDeleteResult": "PageDeleteResult",
		"...on PageUpdateResult": "PageUpdateResult",
		"...on PageUpsertResult": "PageUpsertResult",
		"...on PageLocaleCreateResult": "PageLocaleCreateResult",
		"...on PageLocaleDeleteResult": "PageLocaleDeleteResult",
		"...on PageLocaleUpdateResult": "PageLocaleUpdateResult",
		"...on PageLocaleUpsertResult": "PageLocaleUpsertResult",
		"...on WikiPageCreateResult": "WikiPageCreateResult",
		"...on WikiPageDeleteResult": "WikiPageDeleteResult",
		"...on WikiPageUpdateResult": "WikiPageUpdateResult",
		"...on WikiPageUpsertResult": "WikiPageUpsertResult",
		"...on MenuSubitemCreateResult": "MenuSubitemCreateResult",
		"...on MenuSubitemDeleteResult": "MenuSubitemDeleteResult",
		"...on MenuSubitemUpdateResult": "MenuSubitemUpdateResult",
		"...on MenuSubitemUpsertResult": "MenuSubitemUpsertResult",
		"...on MenuLinkListCreateResult": "MenuLinkListCreateResult",
		"...on MenuLinkListDeleteResult": "MenuLinkListDeleteResult",
		"...on MenuLinkListUpdateResult": "MenuLinkListUpdateResult",
		"...on MenuLinkListUpsertResult": "MenuLinkListUpsertResult",
		"...on MenuLinkItemCreateResult": "MenuLinkItemCreateResult",
		"...on MenuLinkItemDeleteResult": "MenuLinkItemDeleteResult",
		"...on MenuLinkItemUpdateResult": "MenuLinkItemUpdateResult",
		"...on MenuLinkItemUpsertResult": "MenuLinkItemUpsertResult",
		"...on MenuProductsCreateResult": "MenuProductsCreateResult",
		"...on MenuProductsDeleteResult": "MenuProductsDeleteResult",
		"...on MenuProductsUpdateResult": "MenuProductsUpdateResult",
		"...on MenuProductsUpsertResult": "MenuProductsUpsertResult",
		"...on MenuDeliveryCreateResult": "MenuDeliveryCreateResult",
		"...on MenuDeliveryDeleteResult": "MenuDeliveryDeleteResult",
		"...on MenuDeliveryUpdateResult": "MenuDeliveryUpdateResult",
		"...on MenuDeliveryUpsertResult": "MenuDeliveryUpsertResult",
		"...on MenuContactCreateResult": "MenuContactCreateResult",
		"...on MenuContactDeleteResult": "MenuContactDeleteResult",
		"...on MenuContactUpdateResult": "MenuContactUpdateResult",
		"...on MenuContactUpsertResult": "MenuContactUpsertResult",
		"...on DeadlineTemplateCreateResult": "DeadlineTemplateCreateResult",
		"...on DeadlineTemplateDeleteResult": "DeadlineTemplateDeleteResult",
		"...on DeadlineTemplateUpdateResult": "DeadlineTemplateUpdateResult",
		"...on DeadlineTemplateUpsertResult": "DeadlineTemplateUpsertResult",
		"...on EmployeeQueueCreateResult": "EmployeeQueueCreateResult",
		"...on EmployeeQueueDeleteResult": "EmployeeQueueDeleteResult",
		"...on EmployeeQueueUpdateResult": "EmployeeQueueUpdateResult",
		"...on EmployeeQueueUpsertResult": "EmployeeQueueUpsertResult",
		"...on TimetableDayCreateResult": "TimetableDayCreateResult",
		"...on TimetableDayDeleteResult": "TimetableDayDeleteResult",
		"...on TimetableDayUpdateResult": "TimetableDayUpdateResult",
		"...on TimetableDayUpsertResult": "TimetableDayUpsertResult",
		"...on TimetableEmployeeRoleCreateResult": "TimetableEmployeeRoleCreateResult",
		"...on TimetableEmployeeRoleDeleteResult": "TimetableEmployeeRoleDeleteResult",
		"...on TimetableEmployeeRoleUpdateResult": "TimetableEmployeeRoleUpdateResult",
		"...on TimetableEmployeeRoleUpsertResult": "TimetableEmployeeRoleUpsertResult",
		"...on TimetableShiftCreateResult": "TimetableShiftCreateResult",
		"...on TimetableShiftDeleteResult": "TimetableShiftDeleteResult",
		"...on TimetableShiftUpdateResult": "TimetableShiftUpdateResult",
		"...on TimetableShiftUpsertResult": "TimetableShiftUpsertResult",
		"...on TimetableShiftGroupCreateResult": "TimetableShiftGroupCreateResult",
		"...on TimetableShiftGroupDeleteResult": "TimetableShiftGroupDeleteResult",
		"...on TimetableShiftGroupUpdateResult": "TimetableShiftGroupUpdateResult",
		"...on TimetableShiftGroupUpsertResult": "TimetableShiftGroupUpsertResult",
		"...on TimetableShiftPositionCreateResult": "TimetableShiftPositionCreateResult",
		"...on TimetableShiftPositionDeleteResult": "TimetableShiftPositionDeleteResult",
		"...on TimetableShiftPositionUpdateResult": "TimetableShiftPositionUpdateResult",
		"...on TimetableShiftPositionUpsertResult": "TimetableShiftPositionUpsertResult",
		"...on TimetableTemplateCreateResult": "TimetableTemplateCreateResult",
		"...on TimetableTemplateDeleteResult": "TimetableTemplateDeleteResult",
		"...on TimetableTemplateUpdateResult": "TimetableTemplateUpdateResult",
		"...on TimetableTemplateUpsertResult": "TimetableTemplateUpsertResult",
		"...on CartCreateResult": "CartCreateResult",
		"...on CartDeleteResult": "CartDeleteResult",
		"...on CartUpdateResult": "CartUpdateResult",
		"...on CartUpsertResult": "CartUpsertResult",
		"...on CartItemCreateResult": "CartItemCreateResult",
		"...on CartItemDeleteResult": "CartItemDeleteResult",
		"...on CartItemUpdateResult": "CartItemUpdateResult",
		"...on CartItemUpsertResult": "CartItemUpsertResult",
		"...on EmployeeQueueItemCreateResult": "EmployeeQueueItemCreateResult",
		"...on EmployeeQueueItemDeleteResult": "EmployeeQueueItemDeleteResult",
		"...on EmployeeQueueItemUpdateResult": "EmployeeQueueItemUpdateResult",
		"...on EmployeeQueueItemUpsertResult": "EmployeeQueueItemUpsertResult",
		"...on ApplicationCreateResult": "ApplicationCreateResult",
		"...on ApplicationDeleteResult": "ApplicationDeleteResult",
		"...on ApplicationUpdateResult": "ApplicationUpdateResult",
		"...on ApplicationUpsertResult": "ApplicationUpsertResult",
		"...on ApplicationShortcutListCreateResult": "ApplicationShortcutListCreateResult",
		"...on ApplicationShortcutListDeleteResult": "ApplicationShortcutListDeleteResult",
		"...on ApplicationShortcutListUpdateResult": "ApplicationShortcutListUpdateResult",
		"...on ApplicationShortcutListUpsertResult": "ApplicationShortcutListUpsertResult",
		"...on ApplicationShortcutListItemCreateResult": "ApplicationShortcutListItemCreateResult",
		"...on ApplicationShortcutListItemDeleteResult": "ApplicationShortcutListItemDeleteResult",
		"...on ApplicationShortcutListItemUpdateResult": "ApplicationShortcutListItemUpdateResult",
		"...on ApplicationShortcutListItemUpsertResult": "ApplicationShortcutListItemUpsertResult",
		"...on ProductBannerCreateResult": "ProductBannerCreateResult",
		"...on ProductBannerDeleteResult": "ProductBannerDeleteResult",
		"...on ProductBannerUpdateResult": "ProductBannerUpdateResult",
		"...on ProductBannerUpsertResult": "ProductBannerUpsertResult",
		"...on ProductBannerItemCreateResult": "ProductBannerItemCreateResult",
		"...on ProductBannerItemDeleteResult": "ProductBannerItemDeleteResult",
		"...on ProductBannerItemUpdateResult": "ProductBannerItemUpdateResult",
		"...on ProductBannerItemUpsertResult": "ProductBannerItemUpsertResult",
		"...on ProductBannerListCreateResult": "ProductBannerListCreateResult",
		"...on ProductBannerListDeleteResult": "ProductBannerListDeleteResult",
		"...on ProductBannerListUpdateResult": "ProductBannerListUpdateResult",
		"...on ProductBannerListUpsertResult": "ProductBannerListUpsertResult",
		"...on BartenderCreateResult": "BartenderCreateResult",
		"...on BartenderDeleteResult": "BartenderDeleteResult",
		"...on BartenderUpdateResult": "BartenderUpdateResult",
		"...on BartenderUpsertResult": "BartenderUpsertResult",
		"...on BusinessToBusinessManagerCreateResult": "BusinessToBusinessManagerCreateResult",
		"...on BusinessToBusinessManagerDeleteResult": "BusinessToBusinessManagerDeleteResult",
		"...on BusinessToBusinessManagerUpdateResult": "BusinessToBusinessManagerUpdateResult",
		"...on BusinessToBusinessManagerUpsertResult": "BusinessToBusinessManagerUpsertResult",
		"...on CleanerCreateResult": "CleanerCreateResult",
		"...on CleanerDeleteResult": "CleanerDeleteResult",
		"...on CleanerUpdateResult": "CleanerUpdateResult",
		"...on CleanerUpsertResult": "CleanerUpsertResult",
		"...on CourierCreateResult": "CourierCreateResult",
		"...on CourierDeleteResult": "CourierDeleteResult",
		"...on CourierUpdateResult": "CourierUpdateResult",
		"...on CourierUpsertResult": "CourierUpsertResult",
		"...on ShiftsManagerCreateResult": "ShiftsManagerCreateResult",
		"...on ShiftsManagerDeleteResult": "ShiftsManagerDeleteResult",
		"...on ShiftsManagerUpdateResult": "ShiftsManagerUpdateResult",
		"...on ShiftsManagerUpsertResult": "ShiftsManagerUpsertResult",
		"...on UserCreateResult": "UserCreateResult",
		"...on UserDeleteResult": "UserDeleteResult",
		"...on UserUpdateResult": "UserUpdateResult",
		"...on UserUpsertResult": "UserUpsertResult",
		"...on ShiftsProfileCreateResult": "ShiftsProfileCreateResult",
		"...on ShiftsProfileDeleteResult": "ShiftsProfileDeleteResult",
		"...on ShiftsProfileUpdateResult": "ShiftsProfileUpdateResult",
		"...on ShiftsProfileUpsertResult": "ShiftsProfileUpsertResult",
		"...on ProductIngredientCategoryCreateResult": "ProductIngredientCategoryCreateResult",
		"...on ProductIngredientCategoryDeleteResult": "ProductIngredientCategoryDeleteResult",
		"...on ProductIngredientCategoryUpdateResult": "ProductIngredientCategoryUpdateResult",
		"...on ProductIngredientCategoryUpsertResult": "ProductIngredientCategoryUpsertResult",
		"...on ProductIngredientCategoryLocaleCreateResult": "ProductIngredientCategoryLocaleCreateResult",
		"...on ProductIngredientCategoryLocaleDeleteResult": "ProductIngredientCategoryLocaleDeleteResult",
		"...on ProductIngredientCategoryLocaleUpdateResult": "ProductIngredientCategoryLocaleUpdateResult",
		"...on ProductIngredientCategoryLocaleUpsertResult": "ProductIngredientCategoryLocaleUpsertResult",
		"...on StocksManagerCreateResult": "StocksManagerCreateResult",
		"...on StocksManagerDeleteResult": "StocksManagerDeleteResult",
		"...on StocksManagerUpdateResult": "StocksManagerUpdateResult",
		"...on StocksManagerUpsertResult": "StocksManagerUpsertResult",
		"...on DeliveryRouteCreateResult": "DeliveryRouteCreateResult",
		"...on DeliveryRouteDeleteResult": "DeliveryRouteDeleteResult",
		"...on DeliveryRouteUpdateResult": "DeliveryRouteUpdateResult",
		"...on DeliveryRouteUpsertResult": "DeliveryRouteUpsertResult",
		"...on DeliveryWaypointCreateResult": "DeliveryWaypointCreateResult",
		"...on DeliveryWaypointDeleteResult": "DeliveryWaypointDeleteResult",
		"...on DeliveryWaypointUpdateResult": "DeliveryWaypointUpdateResult",
		"...on DeliveryWaypointUpsertResult": "DeliveryWaypointUpsertResult",
		"...on AllergenCreateResult": "AllergenCreateResult",
		"...on AllergenDeleteResult": "AllergenDeleteResult",
		"...on AllergenUpdateResult": "AllergenUpdateResult",
		"...on AllergenUpsertResult": "AllergenUpsertResult",
		"...on AllergenLocaleCreateResult": "AllergenLocaleCreateResult",
		"...on AllergenLocaleDeleteResult": "AllergenLocaleDeleteResult",
		"...on AllergenLocaleUpdateResult": "AllergenLocaleUpdateResult",
		"...on AllergenLocaleUpsertResult": "AllergenLocaleUpsertResult",
		"...on GpsCreateResult": "GpsCreateResult",
		"...on GpsDeleteResult": "GpsDeleteResult",
		"...on GpsUpdateResult": "GpsUpdateResult",
		"...on GpsUpsertResult": "GpsUpsertResult",
		"...on WeekHoursCreateResult": "WeekHoursCreateResult",
		"...on WeekHoursDeleteResult": "WeekHoursDeleteResult",
		"...on WeekHoursUpdateResult": "WeekHoursUpdateResult",
		"...on WeekHoursUpsertResult": "WeekHoursUpsertResult",
		"...on PreparedIngredientQuantityCreateResult": "PreparedIngredientQuantityCreateResult",
		"...on PreparedIngredientQuantityDeleteResult": "PreparedIngredientQuantityDeleteResult",
		"...on PreparedIngredientQuantityUpdateResult": "PreparedIngredientQuantityUpdateResult",
		"...on PreparedIngredientQuantityUpsertResult": "PreparedIngredientQuantityUpsertResult",
		"...on PreparedRecipeQuantityCreateResult": "PreparedRecipeQuantityCreateResult",
		"...on PreparedRecipeQuantityDeleteResult": "PreparedRecipeQuantityDeleteResult",
		"...on PreparedRecipeQuantityUpdateResult": "PreparedRecipeQuantityUpdateResult",
		"...on PreparedRecipeQuantityUpsertResult": "PreparedRecipeQuantityUpsertResult",
		"...on InternalOrderCreateResult": "InternalOrderCreateResult",
		"...on InternalOrderDeleteResult": "InternalOrderDeleteResult",
		"...on InternalOrderUpdateResult": "InternalOrderUpdateResult",
		"...on InternalOrderUpsertResult": "InternalOrderUpsertResult",
		"...on InternalOrderItemCreateResult": "InternalOrderItemCreateResult",
		"...on InternalOrderItemDeleteResult": "InternalOrderItemDeleteResult",
		"...on InternalOrderItemUpdateResult": "InternalOrderItemUpdateResult",
		"...on InternalOrderItemUpsertResult": "InternalOrderItemUpsertResult",
		"...on PreparedPackingQuantityCreateResult": "PreparedPackingQuantityCreateResult",
		"...on PreparedPackingQuantityDeleteResult": "PreparedPackingQuantityDeleteResult",
		"...on PreparedPackingQuantityUpdateResult": "PreparedPackingQuantityUpdateResult",
		"...on PreparedPackingQuantityUpsertResult": "PreparedPackingQuantityUpsertResult",
		"...on CourierManagerCreateResult": "CourierManagerCreateResult",
		"...on CourierManagerDeleteResult": "CourierManagerDeleteResult",
		"...on CourierManagerUpdateResult": "CourierManagerUpdateResult",
		"...on CourierManagerUpsertResult": "CourierManagerUpsertResult",
		"...on DeliveryZoneCreateResult": "DeliveryZoneCreateResult",
		"...on DeliveryZoneDeleteResult": "DeliveryZoneDeleteResult",
		"...on DeliveryZoneUpdateResult": "DeliveryZoneUpdateResult",
		"...on DeliveryZoneUpsertResult": "DeliveryZoneUpsertResult",
		"...on DeliveryTimelinePresetCreateResult": "DeliveryTimelinePresetCreateResult",
		"...on DeliveryTimelinePresetDeleteResult": "DeliveryTimelinePresetDeleteResult",
		"...on DeliveryTimelinePresetUpdateResult": "DeliveryTimelinePresetUpdateResult",
		"...on DeliveryTimelinePresetUpsertResult": "DeliveryTimelinePresetUpsertResult",
		"...on OrderDeliveryTimelineCreateResult": "OrderDeliveryTimelineCreateResult",
		"...on OrderDeliveryTimelineDeleteResult": "OrderDeliveryTimelineDeleteResult",
		"...on OrderDeliveryTimelineUpdateResult": "OrderDeliveryTimelineUpdateResult",
		"...on OrderDeliveryTimelineUpsertResult": "OrderDeliveryTimelineUpsertResult",
		"...on OrderEventCreateResult": "OrderEventCreateResult",
		"...on OrderEventDeleteResult": "OrderEventDeleteResult",
		"...on OrderEventUpdateResult": "OrderEventUpdateResult",
		"...on OrderEventUpsertResult": "OrderEventUpsertResult",
		"...on LiftagoRideCreateResult": "LiftagoRideCreateResult",
		"...on LiftagoRideDeleteResult": "LiftagoRideDeleteResult",
		"...on LiftagoRideUpdateResult": "LiftagoRideUpdateResult",
		"...on LiftagoRideUpsertResult": "LiftagoRideUpsertResult",
		"...on InvoiceCreateResult": "InvoiceCreateResult",
		"...on InvoiceDeleteResult": "InvoiceDeleteResult",
		"...on InvoiceUpdateResult": "InvoiceUpdateResult",
		"...on InvoiceUpsertResult": "InvoiceUpsertResult",
		"...on InvoicingPlanCreateResult": "InvoicingPlanCreateResult",
		"...on InvoicingPlanDeleteResult": "InvoicingPlanDeleteResult",
		"...on InvoicingPlanUpdateResult": "InvoicingPlanUpdateResult",
		"...on InvoicingPlanUpsertResult": "InvoicingPlanUpsertResult",
		"...on ProductPackingLocaleCreateResult": "ProductPackingLocaleCreateResult",
		"...on ProductPackingLocaleDeleteResult": "ProductPackingLocaleDeleteResult",
		"...on ProductPackingLocaleUpdateResult": "ProductPackingLocaleUpdateResult",
		"...on ProductPackingLocaleUpsertResult": "ProductPackingLocaleUpsertResult",
		"...on ProductLocaleCreateResult": "ProductLocaleCreateResult",
		"...on ProductLocaleDeleteResult": "ProductLocaleDeleteResult",
		"...on ProductLocaleUpdateResult": "ProductLocaleUpdateResult",
		"...on ProductLocaleUpsertResult": "ProductLocaleUpsertResult",
		"...on ProductRecipeLocaleCreateResult": "ProductRecipeLocaleCreateResult",
		"...on ProductRecipeLocaleDeleteResult": "ProductRecipeLocaleDeleteResult",
		"...on ProductRecipeLocaleUpdateResult": "ProductRecipeLocaleUpdateResult",
		"...on ProductRecipeLocaleUpsertResult": "ProductRecipeLocaleUpsertResult",
		"...on UserDeviceCreateResult": "UserDeviceCreateResult",
		"...on UserDeviceDeleteResult": "UserDeviceDeleteResult",
		"...on UserDeviceUpdateResult": "UserDeviceUpdateResult",
		"...on UserDeviceUpsertResult": "UserDeviceUpsertResult",
		"...on ProtectedActionCreateResult": "ProtectedActionCreateResult",
		"...on ProtectedActionDeleteResult": "ProtectedActionDeleteResult",
		"...on ProtectedActionUpdateResult": "ProtectedActionUpdateResult",
		"...on ProtectedActionUpsertResult": "ProtectedActionUpsertResult",
		"...on PickerCreateResult": "PickerCreateResult",
		"...on PickerDeleteResult": "PickerDeleteResult",
		"...on PickerUpdateResult": "PickerUpdateResult",
		"...on PickerUpsertResult": "PickerUpsertResult",
		"...on TimetableTemplateStaffOptionsCreateResult": "TimetableTemplateStaffOptionsCreateResult",
		"...on TimetableTemplateStaffOptionsDeleteResult": "TimetableTemplateStaffOptionsDeleteResult",
		"...on TimetableTemplateStaffOptionsUpdateResult": "TimetableTemplateStaffOptionsUpdateResult",
		"...on TimetableTemplateStaffOptionsUpsertResult": "TimetableTemplateStaffOptionsUpsertResult",
		"...on ShoppingListCreateResult": "ShoppingListCreateResult",
		"...on ShoppingListDeleteResult": "ShoppingListDeleteResult",
		"...on ShoppingListUpdateResult": "ShoppingListUpdateResult",
		"...on ShoppingListUpsertResult": "ShoppingListUpsertResult",
		"...on SuppliesPurchaseCreateResult": "SuppliesPurchaseCreateResult",
		"...on SuppliesPurchaseDeleteResult": "SuppliesPurchaseDeleteResult",
		"...on SuppliesPurchaseUpdateResult": "SuppliesPurchaseUpdateResult",
		"...on SuppliesPurchaseUpsertResult": "SuppliesPurchaseUpsertResult",
		"...on InvoicingPresetCreateResult": "InvoicingPresetCreateResult",
		"...on InvoicingPresetDeleteResult": "InvoicingPresetDeleteResult",
		"...on InvoicingPresetUpdateResult": "InvoicingPresetUpdateResult",
		"...on InvoicingPresetUpsertResult": "InvoicingPresetUpsertResult",
		"...on LogRecordCreateResult": "LogRecordCreateResult",
		"...on LogRecordDeleteResult": "LogRecordDeleteResult",
		"...on LogRecordUpdateResult": "LogRecordUpdateResult",
		"...on LogRecordUpsertResult": "LogRecordUpsertResult",
		"...on BillingSubjectCreateResult": "BillingSubjectCreateResult",
		"...on BillingSubjectDeleteResult": "BillingSubjectDeleteResult",
		"...on BillingSubjectUpdateResult": "BillingSubjectUpdateResult",
		"...on BillingSubjectUpsertResult": "BillingSubjectUpsertResult",
		"...on ShoppingListItemCreateResult": "ShoppingListItemCreateResult",
		"...on ShoppingListItemDeleteResult": "ShoppingListItemDeleteResult",
		"...on ShoppingListItemUpdateResult": "ShoppingListItemUpdateResult",
		"...on ShoppingListItemUpsertResult": "ShoppingListItemUpsertResult",
		"...on SuppliesPurchaseItemCreateResult": "SuppliesPurchaseItemCreateResult",
		"...on SuppliesPurchaseItemDeleteResult": "SuppliesPurchaseItemDeleteResult",
		"...on SuppliesPurchaseItemUpdateResult": "SuppliesPurchaseItemUpdateResult",
		"...on SuppliesPurchaseItemUpsertResult": "SuppliesPurchaseItemUpsertResult",
		"...on CustomerCreditTransactionCreateResult": "CustomerCreditTransactionCreateResult",
		"...on CustomerCreditTransactionDeleteResult": "CustomerCreditTransactionDeleteResult",
		"...on CustomerCreditTransactionUpdateResult": "CustomerCreditTransactionUpdateResult",
		"...on CustomerCreditTransactionUpsertResult": "CustomerCreditTransactionUpsertResult",
		"...on VirtualProductCreateResult": "VirtualProductCreateResult",
		"...on VirtualProductDeleteResult": "VirtualProductDeleteResult",
		"...on VirtualProductUpdateResult": "VirtualProductUpdateResult",
		"...on VirtualProductUpsertResult": "VirtualProductUpsertResult",
		"...on VirtualProductEffectCreateResult": "VirtualProductEffectCreateResult",
		"...on VirtualProductEffectDeleteResult": "VirtualProductEffectDeleteResult",
		"...on VirtualProductEffectUpdateResult": "VirtualProductEffectUpdateResult",
		"...on VirtualProductEffectUpsertResult": "VirtualProductEffectUpsertResult",
		"...on EmploymentInformationCreateResult": "EmploymentInformationCreateResult",
		"...on EmploymentInformationDeleteResult": "EmploymentInformationDeleteResult",
		"...on EmploymentInformationUpdateResult": "EmploymentInformationUpdateResult",
		"...on EmploymentInformationUpsertResult": "EmploymentInformationUpsertResult",
		"...on RemunerationProfileCreateResult": "RemunerationProfileCreateResult",
		"...on RemunerationProfileDeleteResult": "RemunerationProfileDeleteResult",
		"...on RemunerationProfileUpdateResult": "RemunerationProfileUpdateResult",
		"...on RemunerationProfileUpsertResult": "RemunerationProfileUpsertResult",
		"...on WorkMonthCreateResult": "WorkMonthCreateResult",
		"...on WorkMonthDeleteResult": "WorkMonthDeleteResult",
		"...on WorkMonthUpdateResult": "WorkMonthUpdateResult",
		"...on WorkMonthUpsertResult": "WorkMonthUpsertResult",
		"...on SalaryOptionsCreateResult": "SalaryOptionsCreateResult",
		"...on SalaryOptionsDeleteResult": "SalaryOptionsDeleteResult",
		"...on SalaryOptionsUpdateResult": "SalaryOptionsUpdateResult",
		"...on SalaryOptionsUpsertResult": "SalaryOptionsUpsertResult",
		"...on TimetableShiftSwapInfoCreateResult": "TimetableShiftSwapInfoCreateResult",
		"...on TimetableShiftSwapInfoDeleteResult": "TimetableShiftSwapInfoDeleteResult",
		"...on TimetableShiftSwapInfoUpdateResult": "TimetableShiftSwapInfoUpdateResult",
		"...on TimetableShiftSwapInfoUpsertResult": "TimetableShiftSwapInfoUpsertResult",
		"...on ProductGridCategoryCreateResult": "ProductGridCategoryCreateResult",
		"...on ProductGridCategoryDeleteResult": "ProductGridCategoryDeleteResult",
		"...on ProductGridCategoryUpdateResult": "ProductGridCategoryUpdateResult",
		"...on ProductGridCategoryUpsertResult": "ProductGridCategoryUpsertResult",
		"...on CashierCreateResult": "CashierCreateResult",
		"...on CashierDeleteResult": "CashierDeleteResult",
		"...on CashierUpdateResult": "CashierUpdateResult",
		"...on CashierUpsertResult": "CashierUpsertResult",
		"...on PointOfSaleCategoryCreateResult": "PointOfSaleCategoryCreateResult",
		"...on PointOfSaleCategoryDeleteResult": "PointOfSaleCategoryDeleteResult",
		"...on PointOfSaleCategoryUpdateResult": "PointOfSaleCategoryUpdateResult",
		"...on PointOfSaleCategoryUpsertResult": "PointOfSaleCategoryUpsertResult",
		"...on PointOfSaleCategoryLocaleCreateResult": "PointOfSaleCategoryLocaleCreateResult",
		"...on PointOfSaleCategoryLocaleDeleteResult": "PointOfSaleCategoryLocaleDeleteResult",
		"...on PointOfSaleCategoryLocaleUpdateResult": "PointOfSaleCategoryLocaleUpdateResult",
		"...on PointOfSaleCategoryLocaleUpsertResult": "PointOfSaleCategoryLocaleUpsertResult",
		"...on PointOfSaleCategoryProductCreateResult": "PointOfSaleCategoryProductCreateResult",
		"...on PointOfSaleCategoryProductDeleteResult": "PointOfSaleCategoryProductDeleteResult",
		"...on PointOfSaleCategoryProductUpdateResult": "PointOfSaleCategoryProductUpdateResult",
		"...on PointOfSaleCategoryProductUpsertResult": "PointOfSaleCategoryProductUpsertResult",
		"...on PointOfSaleCategoryProductLocaleCreateResult": "PointOfSaleCategoryProductLocaleCreateResult",
		"...on PointOfSaleCategoryProductLocaleDeleteResult": "PointOfSaleCategoryProductLocaleDeleteResult",
		"...on PointOfSaleCategoryProductLocaleUpdateResult": "PointOfSaleCategoryProductLocaleUpdateResult",
		"...on PointOfSaleCategoryProductLocaleUpsertResult": "PointOfSaleCategoryProductLocaleUpsertResult",
		"...on CustomerTabCreateResult": "CustomerTabCreateResult",
		"...on CustomerTabDeleteResult": "CustomerTabDeleteResult",
		"...on CustomerTabUpdateResult": "CustomerTabUpdateResult",
		"...on CustomerTabUpsertResult": "CustomerTabUpsertResult",
		"...on CustomerTabItemCreateResult": "CustomerTabItemCreateResult",
		"...on CustomerTabItemDeleteResult": "CustomerTabItemDeleteResult",
		"...on CustomerTabItemUpdateResult": "CustomerTabItemUpdateResult",
		"...on CustomerTabItemUpsertResult": "CustomerTabItemUpsertResult",
		"...on AnonymousSessionCreateResult": "AnonymousSessionCreateResult",
		"...on AnonymousSessionDeleteResult": "AnonymousSessionDeleteResult",
		"...on AnonymousSessionUpdateResult": "AnonymousSessionUpdateResult",
		"...on AnonymousSessionUpsertResult": "AnonymousSessionUpsertResult",
		"...on VoucherCreateResult": "VoucherCreateResult",
		"...on VoucherDeleteResult": "VoucherDeleteResult",
		"...on VoucherUpdateResult": "VoucherUpdateResult",
		"...on VoucherUpsertResult": "VoucherUpsertResult",
		"...on VoucherRedemptionCreateResult": "VoucherRedemptionCreateResult",
		"...on VoucherRedemptionDeleteResult": "VoucherRedemptionDeleteResult",
		"...on VoucherRedemptionUpdateResult": "VoucherRedemptionUpdateResult",
		"...on VoucherRedemptionUpsertResult": "VoucherRedemptionUpsertResult",
		"...on UnassignedShiftInfoCreateResult": "UnassignedShiftInfoCreateResult",
		"...on UnassignedShiftInfoDeleteResult": "UnassignedShiftInfoDeleteResult",
		"...on UnassignedShiftInfoUpdateResult": "UnassignedShiftInfoUpdateResult",
		"...on UnassignedShiftInfoUpsertResult": "UnassignedShiftInfoUpsertResult",
		"...on FreshingContainerCreateResult": "FreshingContainerCreateResult",
		"...on FreshingContainerDeleteResult": "FreshingContainerDeleteResult",
		"...on FreshingContainerUpdateResult": "FreshingContainerUpdateResult",
		"...on FreshingContainerUpsertResult": "FreshingContainerUpsertResult",
		"...on TextItemCreateResult": "TextItemCreateResult",
		"...on TextItemDeleteResult": "TextItemDeleteResult",
		"...on TextItemUpdateResult": "TextItemUpdateResult",
		"...on TextItemUpsertResult": "TextItemUpsertResult",
		"...on TextListCreateResult": "TextListCreateResult",
		"...on TextListDeleteResult": "TextListDeleteResult",
		"...on TextListUpdateResult": "TextListUpdateResult",
		"...on TextListUpsertResult": "TextListUpsertResult",
		"...on DeliveryRegionsCreateResult": "DeliveryRegionsCreateResult",
		"...on DeliveryRegionsDeleteResult": "DeliveryRegionsDeleteResult",
		"...on DeliveryRegionsUpdateResult": "DeliveryRegionsUpdateResult",
		"...on DeliveryRegionsUpsertResult": "DeliveryRegionsUpsertResult",
		"...on DeliveryRegionsItemCreateResult": "DeliveryRegionsItemCreateResult",
		"...on DeliveryRegionsItemDeleteResult": "DeliveryRegionsItemDeleteResult",
		"...on DeliveryRegionsItemUpdateResult": "DeliveryRegionsItemUpdateResult",
		"...on DeliveryRegionsItemUpsertResult": "DeliveryRegionsItemUpsertResult",
		"...on ImageListCreateResult": "ImageListCreateResult",
		"...on ImageListDeleteResult": "ImageListDeleteResult",
		"...on ImageListUpdateResult": "ImageListUpdateResult",
		"...on ImageListUpsertResult": "ImageListUpsertResult",
		"...on ImageListItemCreateResult": "ImageListItemCreateResult",
		"...on ImageListItemDeleteResult": "ImageListItemDeleteResult",
		"...on ImageListItemUpdateResult": "ImageListItemUpdateResult",
		"...on ImageListItemUpsertResult": "ImageListItemUpsertResult",
		"...on TimetablesEmployeePrivilegesCreateResult": "TimetablesEmployeePrivilegesCreateResult",
		"...on TimetablesEmployeePrivilegesDeleteResult": "TimetablesEmployeePrivilegesDeleteResult",
		"...on TimetablesEmployeePrivilegesUpdateResult": "TimetablesEmployeePrivilegesUpdateResult",
		"...on TimetablesEmployeePrivilegesUpsertResult": "TimetablesEmployeePrivilegesUpsertResult",
		"...on TimetableDayNoteCreateResult": "TimetableDayNoteCreateResult",
		"...on TimetableDayNoteDeleteResult": "TimetableDayNoteDeleteResult",
		"...on TimetableDayNoteUpdateResult": "TimetableDayNoteUpdateResult",
		"...on TimetableDayNoteUpsertResult": "TimetableDayNoteUpsertResult",
		"...on DeliveryMethodLocaleCreateResult": "DeliveryMethodLocaleCreateResult",
		"...on DeliveryMethodLocaleDeleteResult": "DeliveryMethodLocaleDeleteResult",
		"...on DeliveryMethodLocaleUpdateResult": "DeliveryMethodLocaleUpdateResult",
		"...on DeliveryMethodLocaleUpsertResult": "DeliveryMethodLocaleUpsertResult",
		"...on IngredientSupplierCreateResult": "IngredientSupplierCreateResult",
		"...on IngredientSupplierDeleteResult": "IngredientSupplierDeleteResult",
		"...on IngredientSupplierUpdateResult": "IngredientSupplierUpdateResult",
		"...on IngredientSupplierUpsertResult": "IngredientSupplierUpsertResult",
		"...on IngredientSupplierItemCreateResult": "IngredientSupplierItemCreateResult",
		"...on IngredientSupplierItemDeleteResult": "IngredientSupplierItemDeleteResult",
		"...on IngredientSupplierItemUpdateResult": "IngredientSupplierItemUpdateResult",
		"...on IngredientSupplierItemUpsertResult": "IngredientSupplierItemUpsertResult",
		"...on IngredientSupplierListCreateResult": "IngredientSupplierListCreateResult",
		"...on IngredientSupplierListDeleteResult": "IngredientSupplierListDeleteResult",
		"...on IngredientSupplierListUpdateResult": "IngredientSupplierListUpdateResult",
		"...on IngredientSupplierListUpsertResult": "IngredientSupplierListUpsertResult",
		"...on IngredientSupplierLocaleCreateResult": "IngredientSupplierLocaleCreateResult",
		"...on IngredientSupplierLocaleDeleteResult": "IngredientSupplierLocaleDeleteResult",
		"...on IngredientSupplierLocaleUpdateResult": "IngredientSupplierLocaleUpdateResult",
		"...on IngredientSupplierLocaleUpsertResult": "IngredientSupplierLocaleUpsertResult",
		"...on RedirectCreateResult": "RedirectCreateResult",
		"...on RedirectDeleteResult": "RedirectDeleteResult",
		"...on RedirectUpdateResult": "RedirectUpdateResult",
		"...on RedirectUpsertResult": "RedirectUpsertResult",
		"...on NutritionFactsCreateResult": "NutritionFactsCreateResult",
		"...on NutritionFactsDeleteResult": "NutritionFactsDeleteResult",
		"...on NutritionFactsUpdateResult": "NutritionFactsUpdateResult",
		"...on NutritionFactsUpsertResult": "NutritionFactsUpsertResult",
		"...on VenueCreateResult": "VenueCreateResult",
		"...on VenueDeleteResult": "VenueDeleteResult",
		"...on VenueUpdateResult": "VenueUpdateResult",
		"...on VenueUpsertResult": "VenueUpsertResult",
		"...on WorkspaceCreateResult": "WorkspaceCreateResult",
		"...on WorkspaceDeleteResult": "WorkspaceDeleteResult",
		"...on WorkspaceUpdateResult": "WorkspaceUpdateResult",
		"...on WorkspaceUpsertResult": "WorkspaceUpsertResult",
		"...on InternalBuyerCreateResult": "InternalBuyerCreateResult",
		"...on InternalBuyerDeleteResult": "InternalBuyerDeleteResult",
		"...on InternalBuyerUpdateResult": "InternalBuyerUpdateResult",
		"...on InternalBuyerUpsertResult": "InternalBuyerUpsertResult",
		"...on VenueEmployeeRoleCreateResult": "VenueEmployeeRoleCreateResult",
		"...on VenueEmployeeRoleDeleteResult": "VenueEmployeeRoleDeleteResult",
		"...on VenueEmployeeRoleUpdateResult": "VenueEmployeeRoleUpdateResult",
		"...on VenueEmployeeRoleUpsertResult": "VenueEmployeeRoleUpsertResult",
		"...on IdentificationAttemptCreateResult": "IdentificationAttemptCreateResult",
		"...on IdentificationAttemptDeleteResult": "IdentificationAttemptDeleteResult",
		"...on IdentificationAttemptUpdateResult": "IdentificationAttemptUpdateResult",
		"...on IdentificationAttemptUpsertResult": "IdentificationAttemptUpsertResult",
		"...on IdentificationCodeCreateResult": "IdentificationCodeCreateResult",
		"...on IdentificationCodeDeleteResult": "IdentificationCodeDeleteResult",
		"...on IdentificationCodeUpdateResult": "IdentificationCodeUpdateResult",
		"...on IdentificationCodeUpsertResult": "IdentificationCodeUpsertResult",
		"...on IdentificationCodeLocaleCreateResult": "IdentificationCodeLocaleCreateResult",
		"...on IdentificationCodeLocaleDeleteResult": "IdentificationCodeLocaleDeleteResult",
		"...on IdentificationCodeLocaleUpdateResult": "IdentificationCodeLocaleUpdateResult",
		"...on IdentificationCodeLocaleUpsertResult": "IdentificationCodeLocaleUpsertResult",
		"...on PipelineCreateResult": "PipelineCreateResult",
		"...on PipelineDeleteResult": "PipelineDeleteResult",
		"...on PipelineUpdateResult": "PipelineUpdateResult",
		"...on PipelineUpsertResult": "PipelineUpsertResult",
		"...on PipelineLeadCreateResult": "PipelineLeadCreateResult",
		"...on PipelineLeadDeleteResult": "PipelineLeadDeleteResult",
		"...on PipelineLeadUpdateResult": "PipelineLeadUpdateResult",
		"...on PipelineLeadUpsertResult": "PipelineLeadUpsertResult",
		"...on PipelineStageCreateResult": "PipelineStageCreateResult",
		"...on PipelineStageDeleteResult": "PipelineStageDeleteResult",
		"...on PipelineStageUpdateResult": "PipelineStageUpdateResult",
		"...on PipelineStageUpsertResult": "PipelineStageUpsertResult",
		"...on PipelineStageItemCreateResult": "PipelineStageItemCreateResult",
		"...on PipelineStageItemDeleteResult": "PipelineStageItemDeleteResult",
		"...on PipelineStageItemUpdateResult": "PipelineStageItemUpdateResult",
		"...on PipelineStageItemUpsertResult": "PipelineStageItemUpsertResult",
		"...on PipelineStageLocaleCreateResult": "PipelineStageLocaleCreateResult",
		"...on PipelineStageLocaleDeleteResult": "PipelineStageLocaleDeleteResult",
		"...on PipelineStageLocaleUpdateResult": "PipelineStageLocaleUpdateResult",
		"...on PipelineStageLocaleUpsertResult": "PipelineStageLocaleUpsertResult",
		"...on SalesManagerCreateResult": "SalesManagerCreateResult",
		"...on SalesManagerDeleteResult": "SalesManagerDeleteResult",
		"...on SalesManagerUpdateResult": "SalesManagerUpdateResult",
		"...on SalesManagerUpsertResult": "SalesManagerUpsertResult",
		"...on CashierManagerCreateResult": "CashierManagerCreateResult",
		"...on CashierManagerDeleteResult": "CashierManagerDeleteResult",
		"...on CashierManagerUpdateResult": "CashierManagerUpdateResult",
		"...on CashierManagerUpsertResult": "CashierManagerUpsertResult",
		"...on PointOfSaleApplicationDeviceCreateResult": "PointOfSaleApplicationDeviceCreateResult",
		"...on PointOfSaleApplicationDeviceDeleteResult": "PointOfSaleApplicationDeviceDeleteResult",
		"...on PointOfSaleApplicationDeviceUpdateResult": "PointOfSaleApplicationDeviceUpdateResult",
		"...on PointOfSaleApplicationDeviceUpsertResult": "PointOfSaleApplicationDeviceUpsertResult",
		"...on PointOfSaleTerminalCreateResult": "PointOfSaleTerminalCreateResult",
		"...on PointOfSaleTerminalDeleteResult": "PointOfSaleTerminalDeleteResult",
		"...on PointOfSaleTerminalUpdateResult": "PointOfSaleTerminalUpdateResult",
		"...on PointOfSaleTerminalUpsertResult": "PointOfSaleTerminalUpsertResult",
		"...on PipelineStageSentimentCreateResult": "PipelineStageSentimentCreateResult",
		"...on PipelineStageSentimentDeleteResult": "PipelineStageSentimentDeleteResult",
		"...on PipelineStageSentimentUpdateResult": "PipelineStageSentimentUpdateResult",
		"...on PipelineStageSentimentUpsertResult": "PipelineStageSentimentUpsertResult",
		"...on DeviceIdentifierCreateResult": "DeviceIdentifierCreateResult",
		"...on DeviceIdentifierDeleteResult": "DeviceIdentifierDeleteResult",
		"...on DeviceIdentifierUpdateResult": "DeviceIdentifierUpdateResult",
		"...on DeviceIdentifierUpsertResult": "DeviceIdentifierUpsertResult",
		"...on PointOfSalePrinterCreateResult": "PointOfSalePrinterCreateResult",
		"...on PointOfSalePrinterDeleteResult": "PointOfSalePrinterDeleteResult",
		"...on PointOfSalePrinterUpdateResult": "PointOfSalePrinterUpdateResult",
		"...on PointOfSalePrinterUpsertResult": "PointOfSalePrinterUpsertResult",
		"...on GratuityCreateResult": "GratuityCreateResult",
		"...on GratuityDeleteResult": "GratuityDeleteResult",
		"...on GratuityUpdateResult": "GratuityUpdateResult",
		"...on GratuityUpsertResult": "GratuityUpsertResult",
		"...on FulfillmentNoteCreateResult": "FulfillmentNoteCreateResult",
		"...on FulfillmentNoteDeleteResult": "FulfillmentNoteDeleteResult",
		"...on FulfillmentNoteUpdateResult": "FulfillmentNoteUpdateResult",
		"...on FulfillmentNoteUpsertResult": "FulfillmentNoteUpsertResult",
		"...on LeadFormCreateResult": "LeadFormCreateResult",
		"...on LeadFormDeleteResult": "LeadFormDeleteResult",
		"...on LeadFormUpdateResult": "LeadFormUpdateResult",
		"...on LeadFormUpsertResult": "LeadFormUpsertResult",
		"...on SubscriptionBoxCreateResult": "SubscriptionBoxCreateResult",
		"...on SubscriptionBoxDeleteResult": "SubscriptionBoxDeleteResult",
		"...on SubscriptionBoxUpdateResult": "SubscriptionBoxUpdateResult",
		"...on SubscriptionBoxUpsertResult": "SubscriptionBoxUpsertResult",
		"...on SubscriptionBoxLocaleCreateResult": "SubscriptionBoxLocaleCreateResult",
		"...on SubscriptionBoxLocaleDeleteResult": "SubscriptionBoxLocaleDeleteResult",
		"...on SubscriptionBoxLocaleUpdateResult": "SubscriptionBoxLocaleUpdateResult",
		"...on SubscriptionBoxLocaleUpsertResult": "SubscriptionBoxLocaleUpsertResult",
		"...on BusinessServiceCreateResult": "BusinessServiceCreateResult",
		"...on BusinessServiceDeleteResult": "BusinessServiceDeleteResult",
		"...on BusinessServiceUpdateResult": "BusinessServiceUpdateResult",
		"...on BusinessServiceUpsertResult": "BusinessServiceUpsertResult",
		"...on BusinessServiceEventCreateResult": "BusinessServiceEventCreateResult",
		"...on BusinessServiceEventDeleteResult": "BusinessServiceEventDeleteResult",
		"...on BusinessServiceEventUpdateResult": "BusinessServiceEventUpdateResult",
		"...on BusinessServiceEventUpsertResult": "BusinessServiceEventUpsertResult",
		"...on BusinessServiceLocaleCreateResult": "BusinessServiceLocaleCreateResult",
		"...on BusinessServiceLocaleDeleteResult": "BusinessServiceLocaleDeleteResult",
		"...on BusinessServiceLocaleUpdateResult": "BusinessServiceLocaleUpdateResult",
		"...on BusinessServiceLocaleUpsertResult": "BusinessServiceLocaleUpsertResult",
		"...on GridTileItemCreateResult": "GridTileItemCreateResult",
		"...on GridTileItemDeleteResult": "GridTileItemDeleteResult",
		"...on GridTileItemUpdateResult": "GridTileItemUpdateResult",
		"...on GridTileItemUpsertResult": "GridTileItemUpsertResult",
		"...on GridTilesCreateResult": "GridTilesCreateResult",
		"...on GridTilesDeleteResult": "GridTilesDeleteResult",
		"...on GridTilesUpdateResult": "GridTilesUpdateResult",
		"...on GridTilesUpsertResult": "GridTilesUpsertResult",
		"...on AreaCreateResult": "AreaCreateResult",
		"...on AreaDeleteResult": "AreaDeleteResult",
		"...on AreaUpdateResult": "AreaUpdateResult",
		"...on AreaUpsertResult": "AreaUpsertResult",
		"...on PositionCreateResult": "PositionCreateResult",
		"...on PositionDeleteResult": "PositionDeleteResult",
		"...on PositionUpdateResult": "PositionUpdateResult",
		"...on PositionUpsertResult": "PositionUpsertResult",
		"...on StatsEnabledWidgetTypeCreateResult": "StatsEnabledWidgetTypeCreateResult",
		"...on StatsEnabledWidgetTypeDeleteResult": "StatsEnabledWidgetTypeDeleteResult",
		"...on StatsEnabledWidgetTypeUpdateResult": "StatsEnabledWidgetTypeUpdateResult",
		"...on StatsEnabledWidgetTypeUpsertResult": "StatsEnabledWidgetTypeUpsertResult",
		"...on StatsWidgetCreateResult": "StatsWidgetCreateResult",
		"...on StatsWidgetDeleteResult": "StatsWidgetDeleteResult",
		"...on StatsWidgetUpdateResult": "StatsWidgetUpdateResult",
		"...on StatsWidgetUpsertResult": "StatsWidgetUpsertResult",
		"...on StatsWidgetsLayoutCreateResult": "StatsWidgetsLayoutCreateResult",
		"...on StatsWidgetsLayoutDeleteResult": "StatsWidgetsLayoutDeleteResult",
		"...on StatsWidgetsLayoutUpdateResult": "StatsWidgetsLayoutUpdateResult",
		"...on StatsWidgetsLayoutUpsertResult": "StatsWidgetsLayoutUpsertResult",
		"...on SeatCreateResult": "SeatCreateResult",
		"...on SeatDeleteResult": "SeatDeleteResult",
		"...on SeatUpdateResult": "SeatUpdateResult",
		"...on SeatUpsertResult": "SeatUpsertResult",
		"...on TableCreateResult": "TableCreateResult",
		"...on TableDeleteResult": "TableDeleteResult",
		"...on TableUpdateResult": "TableUpdateResult",
		"...on TableUpsertResult": "TableUpsertResult",
		"...on StatsPageCreateResult": "StatsPageCreateResult",
		"...on StatsPageDeleteResult": "StatsPageDeleteResult",
		"...on StatsPageUpdateResult": "StatsPageUpdateResult",
		"...on StatsPageUpsertResult": "StatsPageUpsertResult",
		"...on UnassignReasonCreateResult": "UnassignReasonCreateResult",
		"...on UnassignReasonDeleteResult": "UnassignReasonDeleteResult",
		"...on UnassignReasonUpdateResult": "UnassignReasonUpdateResult",
		"...on UnassignReasonUpsertResult": "UnassignReasonUpsertResult",
		"...on DoubleshotCoffeeEquipmentCreateResult": "DoubleshotCoffeeEquipmentCreateResult",
		"...on DoubleshotCoffeeEquipmentDeleteResult": "DoubleshotCoffeeEquipmentDeleteResult",
		"...on DoubleshotCoffeeEquipmentUpdateResult": "DoubleshotCoffeeEquipmentUpdateResult",
		"...on DoubleshotCoffeeEquipmentUpsertResult": "DoubleshotCoffeeEquipmentUpsertResult",
		"...on ExpenseCreateResult": "ExpenseCreateResult",
		"...on ExpenseDeleteResult": "ExpenseDeleteResult",
		"...on ExpenseUpdateResult": "ExpenseUpdateResult",
		"...on ExpenseUpsertResult": "ExpenseUpsertResult",
		"...on ExpenseCategoryCreateResult": "ExpenseCategoryCreateResult",
		"...on ExpenseCategoryDeleteResult": "ExpenseCategoryDeleteResult",
		"...on ExpenseCategoryUpdateResult": "ExpenseCategoryUpdateResult",
		"...on ExpenseCategoryUpsertResult": "ExpenseCategoryUpsertResult",
		"...on ExpenseChangeCreateResult": "ExpenseChangeCreateResult",
		"...on ExpenseChangeDeleteResult": "ExpenseChangeDeleteResult",
		"...on ExpenseChangeUpdateResult": "ExpenseChangeUpdateResult",
		"...on ExpenseChangeUpsertResult": "ExpenseChangeUpsertResult",
		"...on ExpenseDocumentCreateResult": "ExpenseDocumentCreateResult",
		"...on ExpenseDocumentDeleteResult": "ExpenseDocumentDeleteResult",
		"...on ExpenseDocumentUpdateResult": "ExpenseDocumentUpdateResult",
		"...on ExpenseDocumentUpsertResult": "ExpenseDocumentUpsertResult",
		"...on RevenuePredictionCreateResult": "RevenuePredictionCreateResult",
		"...on RevenuePredictionDeleteResult": "RevenuePredictionDeleteResult",
		"...on RevenuePredictionUpdateResult": "RevenuePredictionUpdateResult",
		"...on RevenuePredictionUpsertResult": "RevenuePredictionUpsertResult",
		"...on RevenuePredictionChangeCreateResult": "RevenuePredictionChangeCreateResult",
		"...on RevenuePredictionChangeDeleteResult": "RevenuePredictionChangeDeleteResult",
		"...on RevenuePredictionChangeUpdateResult": "RevenuePredictionChangeUpdateResult",
		"...on RevenuePredictionChangeUpsertResult": "RevenuePredictionChangeUpsertResult",
		"...on FileCreateResult": "FileCreateResult",
		"...on FileDeleteResult": "FileDeleteResult",
		"...on FileUpdateResult": "FileUpdateResult",
		"...on FileUpsertResult": "FileUpsertResult",
		"...on LineCreateResult": "LineCreateResult",
		"...on LineDeleteResult": "LineDeleteResult",
		"...on LineUpdateResult": "LineUpdateResult",
		"...on LineUpsertResult": "LineUpsertResult",
		"...on FinancesBalanceItemCreateResult": "FinancesBalanceItemCreateResult",
		"...on FinancesBalanceItemDeleteResult": "FinancesBalanceItemDeleteResult",
		"...on FinancesBalanceItemUpdateResult": "FinancesBalanceItemUpdateResult",
		"...on FinancesBalanceItemUpsertResult": "FinancesBalanceItemUpsertResult",
		"...on WoltDriveDeliveryCreateResult": "WoltDriveDeliveryCreateResult",
		"...on WoltDriveDeliveryDeleteResult": "WoltDriveDeliveryDeleteResult",
		"...on WoltDriveDeliveryUpdateResult": "WoltDriveDeliveryUpdateResult",
		"...on WoltDriveDeliveryUpsertResult": "WoltDriveDeliveryUpsertResult",
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError"
	},
	_MutationError:{
		path:"_PathFragment",
		paths:"_PathFragment",
		type:"_MutationErrorType",
		message:"String"
	},
	AddressDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Address"
	},
	AddressUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Address",
		validation:"_ValidationResult"
	},
	AddressUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Address",
		validation:"_ValidationResult"
	},
	CountryCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Country",
		validation:"_ValidationResult"
	},
	CountryDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Country"
	},
	CountryUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Country",
		validation:"_ValidationResult"
	},
	CountryUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Country",
		validation:"_ValidationResult"
	},
	ChannelCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Channel",
		validation:"_ValidationResult"
	},
	ChannelDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Channel"
	},
	ChannelUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Channel",
		validation:"_ValidationResult"
	},
	ChannelUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Channel",
		validation:"_ValidationResult"
	},
	ChannelPaymentCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ChannelPayment",
		validation:"_ValidationResult"
	},
	ChannelPaymentDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ChannelPayment"
	},
	ChannelPaymentUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ChannelPayment",
		validation:"_ValidationResult"
	},
	ChannelPaymentUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ChannelPayment",
		validation:"_ValidationResult"
	},
	ChannelDeliveryCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ChannelDelivery",
		validation:"_ValidationResult"
	},
	ChannelDeliveryDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ChannelDelivery"
	},
	ChannelDeliveryUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ChannelDelivery",
		validation:"_ValidationResult"
	},
	ChannelDeliveryUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ChannelDelivery",
		validation:"_ValidationResult"
	},
	CustomerCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Customer",
		validation:"_ValidationResult"
	},
	CustomerDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Customer"
	},
	CustomerUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Customer",
		validation:"_ValidationResult"
	},
	CustomerUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Customer",
		validation:"_ValidationResult"
	},
	CustomerCreditCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CustomerCredit",
		validation:"_ValidationResult"
	},
	CustomerCreditDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CustomerCredit"
	},
	CustomerCreditUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CustomerCredit",
		validation:"_ValidationResult"
	},
	CustomerCreditUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CustomerCredit",
		validation:"_ValidationResult"
	},
	CustomerGroupCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CustomerGroup",
		validation:"_ValidationResult"
	},
	CustomerGroupDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CustomerGroup"
	},
	CustomerGroupUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CustomerGroup",
		validation:"_ValidationResult"
	},
	CustomerGroupUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CustomerGroup",
		validation:"_ValidationResult"
	},
	CustomerPaymentMethodCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CustomerPaymentMethod",
		validation:"_ValidationResult"
	},
	CustomerPaymentMethodDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CustomerPaymentMethod"
	},
	CustomerPaymentMethodUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CustomerPaymentMethod",
		validation:"_ValidationResult"
	},
	CustomerPaymentMethodUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CustomerPaymentMethod",
		validation:"_ValidationResult"
	},
	DeliveryMethodCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeliveryMethod",
		validation:"_ValidationResult"
	},
	DeliveryMethodDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeliveryMethod"
	},
	DeliveryMethodUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeliveryMethod",
		validation:"_ValidationResult"
	},
	DeliveryMethodUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeliveryMethod",
		validation:"_ValidationResult"
	},
	OrderCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Order",
		validation:"_ValidationResult"
	},
	OrderDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Order"
	},
	OrderUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Order",
		validation:"_ValidationResult"
	},
	OrderUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Order",
		validation:"_ValidationResult"
	},
	OrderDiscountCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OrderDiscount",
		validation:"_ValidationResult"
	},
	OrderDiscountDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OrderDiscount"
	},
	OrderDiscountUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OrderDiscount",
		validation:"_ValidationResult"
	},
	OrderDiscountUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OrderDiscount",
		validation:"_ValidationResult"
	},
	OrderPaymentCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OrderPayment",
		validation:"_ValidationResult"
	},
	OrderPaymentDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OrderPayment"
	},
	OrderPaymentUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OrderPayment",
		validation:"_ValidationResult"
	},
	OrderPaymentUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OrderPayment",
		validation:"_ValidationResult"
	},
	OrderDeliveryCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OrderDelivery",
		validation:"_ValidationResult"
	},
	OrderDeliveryDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OrderDelivery"
	},
	OrderDeliveryUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OrderDelivery",
		validation:"_ValidationResult"
	},
	OrderDeliveryUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OrderDelivery",
		validation:"_ValidationResult"
	},
	OrderItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OrderItem",
		validation:"_ValidationResult"
	},
	OrderItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OrderItem"
	},
	OrderItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OrderItem",
		validation:"_ValidationResult"
	},
	OrderItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OrderItem",
		validation:"_ValidationResult"
	},
	PaymentMethodCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PaymentMethod",
		validation:"_ValidationResult"
	},
	PaymentMethodDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PaymentMethod"
	},
	PaymentMethodUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PaymentMethod",
		validation:"_ValidationResult"
	},
	PaymentMethodUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PaymentMethod",
		validation:"_ValidationResult"
	},
	VatRateCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"VatRate",
		validation:"_ValidationResult"
	},
	VatRateDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"VatRate"
	},
	VatRateUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"VatRate",
		validation:"_ValidationResult"
	},
	VatRateUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"VatRate",
		validation:"_ValidationResult"
	},
	ProductCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Product",
		validation:"_ValidationResult"
	},
	ProductDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Product"
	},
	ProductUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Product",
		validation:"_ValidationResult"
	},
	ProductUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Product",
		validation:"_ValidationResult"
	},
	ProductStockCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductStock",
		validation:"_ValidationResult"
	},
	ProductStockDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductStock"
	},
	ProductStockUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductStock",
		validation:"_ValidationResult"
	},
	ProductStockUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductStock",
		validation:"_ValidationResult"
	},
	ProductPackingCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductPacking",
		validation:"_ValidationResult"
	},
	ProductPackingDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductPacking"
	},
	ProductPackingUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductPacking",
		validation:"_ValidationResult"
	},
	ProductPackingUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductPacking",
		validation:"_ValidationResult"
	},
	ProductGroupPriceCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductGroupPrice",
		validation:"_ValidationResult"
	},
	ProductGroupPriceDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductGroupPrice"
	},
	ProductGroupPriceUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductGroupPrice",
		validation:"_ValidationResult"
	},
	ProductGroupPriceUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductGroupPrice",
		validation:"_ValidationResult"
	},
	ProductRecipeCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductRecipe",
		validation:"_ValidationResult"
	},
	ProductRecipeDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductRecipe"
	},
	ProductRecipeUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductRecipe",
		validation:"_ValidationResult"
	},
	ProductRecipeUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductRecipe",
		validation:"_ValidationResult"
	},
	ProductCategoryCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductCategory",
		validation:"_ValidationResult"
	},
	ProductCategoryDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductCategory"
	},
	ProductCategoryUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductCategory",
		validation:"_ValidationResult"
	},
	ProductCategoryUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductCategory",
		validation:"_ValidationResult"
	},
	StoreCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Store",
		validation:"_ValidationResult"
	},
	StoreDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Store"
	},
	StoreUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Store",
		validation:"_ValidationResult"
	},
	StoreUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Store",
		validation:"_ValidationResult"
	},
	TagCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Tag",
		validation:"_ValidationResult"
	},
	TagDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Tag"
	},
	TagUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Tag",
		validation:"_ValidationResult"
	},
	TagUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Tag",
		validation:"_ValidationResult"
	},
	ImageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image",
		validation:"_ValidationResult"
	},
	ImageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image"
	},
	ImageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image",
		validation:"_ValidationResult"
	},
	ImageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image",
		validation:"_ValidationResult"
	},
	BusinessCategoryCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessCategory",
		validation:"_ValidationResult"
	},
	BusinessCategoryDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessCategory"
	},
	BusinessCategoryUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessCategory",
		validation:"_ValidationResult"
	},
	BusinessCategoryUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessCategory",
		validation:"_ValidationResult"
	},
	ProductListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductList",
		validation:"_ValidationResult"
	},
	ProductListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductList"
	},
	ProductListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductList",
		validation:"_ValidationResult"
	},
	ProductListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductList",
		validation:"_ValidationResult"
	},
	ProductListItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductListItem",
		validation:"_ValidationResult"
	},
	ProductListItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductListItem"
	},
	ProductListItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductListItem",
		validation:"_ValidationResult"
	},
	ProductListItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductListItem",
		validation:"_ValidationResult"
	},
	ProductCategoryListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductCategoryList",
		validation:"_ValidationResult"
	},
	ProductCategoryListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductCategoryList"
	},
	ProductCategoryListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductCategoryList",
		validation:"_ValidationResult"
	},
	ProductCategoryListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductCategoryList",
		validation:"_ValidationResult"
	},
	ProductCategoryListItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductCategoryListItem",
		validation:"_ValidationResult"
	},
	ProductCategoryListItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductCategoryListItem"
	},
	ProductCategoryListItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductCategoryListItem",
		validation:"_ValidationResult"
	},
	ProductCategoryListItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductCategoryListItem",
		validation:"_ValidationResult"
	},
	BusinessCategoryLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessCategoryLocale",
		validation:"_ValidationResult"
	},
	BusinessCategoryLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessCategoryLocale"
	},
	BusinessCategoryLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessCategoryLocale",
		validation:"_ValidationResult"
	},
	BusinessCategoryLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessCategoryLocale",
		validation:"_ValidationResult"
	},
	LocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Locale",
		validation:"_ValidationResult"
	},
	LocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Locale"
	},
	LocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Locale",
		validation:"_ValidationResult"
	},
	LocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Locale",
		validation:"_ValidationResult"
	},
	ProductCategoryListLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductCategoryListLocale",
		validation:"_ValidationResult"
	},
	ProductCategoryListLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductCategoryListLocale"
	},
	ProductCategoryListLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductCategoryListLocale",
		validation:"_ValidationResult"
	},
	ProductCategoryListLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductCategoryListLocale",
		validation:"_ValidationResult"
	},
	CustomerNameCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CustomerName",
		validation:"_ValidationResult"
	},
	CustomerNameDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CustomerName"
	},
	CustomerNameUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CustomerName",
		validation:"_ValidationResult"
	},
	CustomerNameUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CustomerName",
		validation:"_ValidationResult"
	},
	CustomerAliasCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CustomerAlias",
		validation:"_ValidationResult"
	},
	CustomerAliasDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CustomerAlias"
	},
	CustomerAliasUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CustomerAlias",
		validation:"_ValidationResult"
	},
	CustomerAliasUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CustomerAlias",
		validation:"_ValidationResult"
	},
	ProductIngredientItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductIngredientItem",
		validation:"_ValidationResult"
	},
	ProductIngredientItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductIngredientItem"
	},
	ProductIngredientItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductIngredientItem",
		validation:"_ValidationResult"
	},
	ProductIngredientItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductIngredientItem",
		validation:"_ValidationResult"
	},
	ProductIngredientItemQuantityCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductIngredientItemQuantity",
		validation:"_ValidationResult"
	},
	ProductIngredientItemQuantityDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductIngredientItemQuantity"
	},
	ProductIngredientItemQuantityUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductIngredientItemQuantity",
		validation:"_ValidationResult"
	},
	ProductIngredientItemQuantityUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductIngredientItemQuantity",
		validation:"_ValidationResult"
	},
	ProductIngredientItemQuantityUnitCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductIngredientItemQuantityUnit",
		validation:"_ValidationResult"
	},
	ProductIngredientItemQuantityUnitDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductIngredientItemQuantityUnit"
	},
	ProductIngredientItemQuantityUnitUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductIngredientItemQuantityUnit",
		validation:"_ValidationResult"
	},
	ProductIngredientItemQuantityUnitUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductIngredientItemQuantityUnit",
		validation:"_ValidationResult"
	},
	ProductIngredientCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductIngredient",
		validation:"_ValidationResult"
	},
	ProductIngredientDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductIngredient"
	},
	ProductIngredientUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductIngredient",
		validation:"_ValidationResult"
	},
	ProductIngredientUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductIngredient",
		validation:"_ValidationResult"
	},
	CustomerIngredientRatingCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CustomerIngredientRating",
		validation:"_ValidationResult"
	},
	CustomerIngredientRatingDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CustomerIngredientRating"
	},
	CustomerIngredientRatingUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CustomerIngredientRating",
		validation:"_ValidationResult"
	},
	CustomerIngredientRatingUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CustomerIngredientRating",
		validation:"_ValidationResult"
	},
	ProductIngredientRatingCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductIngredientRating",
		validation:"_ValidationResult"
	},
	ProductIngredientRatingDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductIngredientRating"
	},
	ProductIngredientRatingUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductIngredientRating",
		validation:"_ValidationResult"
	},
	ProductIngredientRatingUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductIngredientRating",
		validation:"_ValidationResult"
	},
	ProductIngredientLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductIngredientLocale",
		validation:"_ValidationResult"
	},
	ProductIngredientLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductIngredientLocale"
	},
	ProductIngredientLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductIngredientLocale",
		validation:"_ValidationResult"
	},
	ProductIngredientLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductIngredientLocale",
		validation:"_ValidationResult"
	},
	OrderRecurrenceCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OrderRecurrence",
		validation:"_ValidationResult"
	},
	OrderRecurrenceDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OrderRecurrence"
	},
	OrderRecurrenceUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OrderRecurrence",
		validation:"_ValidationResult"
	},
	OrderRecurrenceUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OrderRecurrence",
		validation:"_ValidationResult"
	},
	OrderRecurrenceLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OrderRecurrenceLocale",
		validation:"_ValidationResult"
	},
	OrderRecurrenceLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OrderRecurrenceLocale"
	},
	OrderRecurrenceLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OrderRecurrenceLocale",
		validation:"_ValidationResult"
	},
	OrderRecurrenceLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OrderRecurrenceLocale",
		validation:"_ValidationResult"
	},
	BusinessCustomerCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessCustomer",
		validation:"_ValidationResult"
	},
	BusinessCustomerDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessCustomer"
	},
	BusinessCustomerUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessCustomer",
		validation:"_ValidationResult"
	},
	BusinessCustomerUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessCustomer",
		validation:"_ValidationResult"
	},
	PointOfSaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PointOfSale",
		validation:"_ValidationResult"
	},
	PointOfSaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PointOfSale"
	},
	PointOfSaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PointOfSale",
		validation:"_ValidationResult"
	},
	PointOfSaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PointOfSale",
		validation:"_ValidationResult"
	},
	StaffCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Staff",
		validation:"_ValidationResult"
	},
	StaffDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Staff"
	},
	StaffUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Staff",
		validation:"_ValidationResult"
	},
	StaffUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Staff",
		validation:"_ValidationResult"
	},
	BlogCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Blog",
		validation:"_ValidationResult"
	},
	BlogDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Blog"
	},
	BlogUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Blog",
		validation:"_ValidationResult"
	},
	BlogUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Blog",
		validation:"_ValidationResult"
	},
	BlogLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BlogLocale",
		validation:"_ValidationResult"
	},
	BlogLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BlogLocale"
	},
	BlogLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BlogLocale",
		validation:"_ValidationResult"
	},
	BlogLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BlogLocale",
		validation:"_ValidationResult"
	},
	BlogPostCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BlogPost",
		validation:"_ValidationResult"
	},
	BlogPostDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BlogPost"
	},
	BlogPostUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BlogPost",
		validation:"_ValidationResult"
	},
	BlogPostUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BlogPost",
		validation:"_ValidationResult"
	},
	BlogPostLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BlogPostLocale",
		validation:"_ValidationResult"
	},
	BlogPostLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BlogPostLocale"
	},
	BlogPostLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BlogPostLocale",
		validation:"_ValidationResult"
	},
	BlogPostLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BlogPostLocale",
		validation:"_ValidationResult"
	},
	ColorPalleteCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ColorPallete",
		validation:"_ValidationResult"
	},
	ColorPalleteDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ColorPallete"
	},
	ColorPalleteUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ColorPallete",
		validation:"_ValidationResult"
	},
	ColorPalleteUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ColorPallete",
		validation:"_ValidationResult"
	},
	ContentCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Content",
		validation:"_ValidationResult"
	},
	ContentDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Content"
	},
	ContentUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Content",
		validation:"_ValidationResult"
	},
	ContentUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Content",
		validation:"_ValidationResult"
	},
	ContentBlockCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock",
		validation:"_ValidationResult"
	},
	ContentBlockDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock"
	},
	ContentBlockUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock",
		validation:"_ValidationResult"
	},
	ContentBlockUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock",
		validation:"_ValidationResult"
	},
	ContentReferenceCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentReference",
		validation:"_ValidationResult"
	},
	ContentReferenceDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentReference"
	},
	ContentReferenceUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentReference",
		validation:"_ValidationResult"
	},
	ContentReferenceUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentReference",
		validation:"_ValidationResult"
	},
	BlogPostListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BlogPostList",
		validation:"_ValidationResult"
	},
	BlogPostListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BlogPostList"
	},
	BlogPostListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BlogPostList",
		validation:"_ValidationResult"
	},
	BlogPostListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BlogPostList",
		validation:"_ValidationResult"
	},
	BlogPostListItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BlogPostListItem",
		validation:"_ValidationResult"
	},
	BlogPostListItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BlogPostListItem"
	},
	BlogPostListItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BlogPostListItem",
		validation:"_ValidationResult"
	},
	BlogPostListItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BlogPostListItem",
		validation:"_ValidationResult"
	},
	LinkListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkList",
		validation:"_ValidationResult"
	},
	LinkListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkList"
	},
	LinkListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkList",
		validation:"_ValidationResult"
	},
	LinkListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkList",
		validation:"_ValidationResult"
	},
	LinkListItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkListItem",
		validation:"_ValidationResult"
	},
	LinkListItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkListItem"
	},
	LinkListItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkListItem",
		validation:"_ValidationResult"
	},
	LinkListItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkListItem",
		validation:"_ValidationResult"
	},
	CoverCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Cover",
		validation:"_ValidationResult"
	},
	CoverDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Cover"
	},
	CoverUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Cover",
		validation:"_ValidationResult"
	},
	CoverUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Cover",
		validation:"_ValidationResult"
	},
	LinkCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link",
		validation:"_ValidationResult"
	},
	LinkDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link"
	},
	LinkUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link",
		validation:"_ValidationResult"
	},
	LinkUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link",
		validation:"_ValidationResult"
	},
	LinkableCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable",
		validation:"_ValidationResult"
	},
	LinkableDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable"
	},
	LinkableUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable",
		validation:"_ValidationResult"
	},
	LinkableUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable",
		validation:"_ValidationResult"
	},
	MediumCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Medium",
		validation:"_ValidationResult"
	},
	MediumDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Medium"
	},
	MediumUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Medium",
		validation:"_ValidationResult"
	},
	MediumUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Medium",
		validation:"_ValidationResult"
	},
	VideoCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Video",
		validation:"_ValidationResult"
	},
	VideoDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Video"
	},
	VideoUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Video",
		validation:"_ValidationResult"
	},
	VideoUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Video",
		validation:"_ValidationResult"
	},
	SeoCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo",
		validation:"_ValidationResult"
	},
	SeoDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo"
	},
	SeoUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo",
		validation:"_ValidationResult"
	},
	SeoUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo",
		validation:"_ValidationResult"
	},
	ProtectedImageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProtectedImage",
		validation:"_ValidationResult"
	},
	ProtectedImageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProtectedImage"
	},
	ProtectedImageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProtectedImage",
		validation:"_ValidationResult"
	},
	ProtectedImageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProtectedImage",
		validation:"_ValidationResult"
	},
	TranslationDomainCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationDomain",
		validation:"_ValidationResult"
	},
	TranslationDomainDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationDomain"
	},
	TranslationDomainUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationDomain",
		validation:"_ValidationResult"
	},
	TranslationDomainUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationDomain",
		validation:"_ValidationResult"
	},
	TranslationCatalogueCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationCatalogue",
		validation:"_ValidationResult"
	},
	TranslationCatalogueDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationCatalogue"
	},
	TranslationCatalogueUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationCatalogue",
		validation:"_ValidationResult"
	},
	TranslationCatalogueUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationCatalogue",
		validation:"_ValidationResult"
	},
	TranslationKeyCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationKey",
		validation:"_ValidationResult"
	},
	TranslationKeyDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationKey"
	},
	TranslationKeyUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationKey",
		validation:"_ValidationResult"
	},
	TranslationKeyUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationKey",
		validation:"_ValidationResult"
	},
	TranslationValueCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationValue",
		validation:"_ValidationResult"
	},
	TranslationValueDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationValue"
	},
	TranslationValueUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationValue",
		validation:"_ValidationResult"
	},
	TranslationValueUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationValue",
		validation:"_ValidationResult"
	},
	TranslationCataloguesIdentifierCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationCataloguesIdentifier",
		validation:"_ValidationResult"
	},
	TranslationCataloguesIdentifierDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationCataloguesIdentifier"
	},
	TranslationCataloguesIdentifierUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationCataloguesIdentifier",
		validation:"_ValidationResult"
	},
	TranslationCataloguesIdentifierUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationCataloguesIdentifier",
		validation:"_ValidationResult"
	},
	SocialsAndAppsCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialsAndApps",
		validation:"_ValidationResult"
	},
	SocialsAndAppsDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialsAndApps"
	},
	SocialsAndAppsUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialsAndApps",
		validation:"_ValidationResult"
	},
	SocialsAndAppsUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialsAndApps",
		validation:"_ValidationResult"
	},
	ProductGridCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductGrid",
		validation:"_ValidationResult"
	},
	ProductGridDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductGrid"
	},
	ProductGridUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductGrid",
		validation:"_ValidationResult"
	},
	ProductGridUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductGrid",
		validation:"_ValidationResult"
	},
	ProductGridItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductGridItem",
		validation:"_ValidationResult"
	},
	ProductGridItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductGridItem"
	},
	ProductGridItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductGridItem",
		validation:"_ValidationResult"
	},
	ProductGridItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductGridItem",
		validation:"_ValidationResult"
	},
	GalleryCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Gallery",
		validation:"_ValidationResult"
	},
	GalleryDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Gallery"
	},
	GalleryUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Gallery",
		validation:"_ValidationResult"
	},
	GalleryUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Gallery",
		validation:"_ValidationResult"
	},
	GalleryItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GalleryItem",
		validation:"_ValidationResult"
	},
	GalleryItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GalleryItem"
	},
	GalleryItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GalleryItem",
		validation:"_ValidationResult"
	},
	GalleryItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GalleryItem",
		validation:"_ValidationResult"
	},
	HeroCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Hero",
		validation:"_ValidationResult"
	},
	HeroDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Hero"
	},
	HeroUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Hero",
		validation:"_ValidationResult"
	},
	HeroUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Hero",
		validation:"_ValidationResult"
	},
	SiteMenuCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SiteMenu",
		validation:"_ValidationResult"
	},
	SiteMenuDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SiteMenu"
	},
	SiteMenuUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SiteMenu",
		validation:"_ValidationResult"
	},
	SiteMenuUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SiteMenu",
		validation:"_ValidationResult"
	},
	MenuLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuLocale",
		validation:"_ValidationResult"
	},
	MenuLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuLocale"
	},
	MenuLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuLocale",
		validation:"_ValidationResult"
	},
	MenuLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuLocale",
		validation:"_ValidationResult"
	},
	MenuItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuItem",
		validation:"_ValidationResult"
	},
	MenuItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuItem"
	},
	MenuItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuItem",
		validation:"_ValidationResult"
	},
	MenuItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuItem",
		validation:"_ValidationResult"
	},
	PageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Page",
		validation:"_ValidationResult"
	},
	PageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Page"
	},
	PageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Page",
		validation:"_ValidationResult"
	},
	PageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Page",
		validation:"_ValidationResult"
	},
	PageLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PageLocale",
		validation:"_ValidationResult"
	},
	PageLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PageLocale"
	},
	PageLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PageLocale",
		validation:"_ValidationResult"
	},
	PageLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PageLocale",
		validation:"_ValidationResult"
	},
	WikiPageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"WikiPage",
		validation:"_ValidationResult"
	},
	WikiPageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"WikiPage"
	},
	WikiPageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"WikiPage",
		validation:"_ValidationResult"
	},
	WikiPageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"WikiPage",
		validation:"_ValidationResult"
	},
	MenuSubitemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuSubitem",
		validation:"_ValidationResult"
	},
	MenuSubitemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuSubitem"
	},
	MenuSubitemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuSubitem",
		validation:"_ValidationResult"
	},
	MenuSubitemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuSubitem",
		validation:"_ValidationResult"
	},
	MenuLinkListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuLinkList",
		validation:"_ValidationResult"
	},
	MenuLinkListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuLinkList"
	},
	MenuLinkListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuLinkList",
		validation:"_ValidationResult"
	},
	MenuLinkListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuLinkList",
		validation:"_ValidationResult"
	},
	MenuLinkItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuLinkItem",
		validation:"_ValidationResult"
	},
	MenuLinkItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuLinkItem"
	},
	MenuLinkItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuLinkItem",
		validation:"_ValidationResult"
	},
	MenuLinkItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuLinkItem",
		validation:"_ValidationResult"
	},
	MenuProductsCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuProducts",
		validation:"_ValidationResult"
	},
	MenuProductsDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuProducts"
	},
	MenuProductsUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuProducts",
		validation:"_ValidationResult"
	},
	MenuProductsUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuProducts",
		validation:"_ValidationResult"
	},
	MenuDeliveryCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuDelivery",
		validation:"_ValidationResult"
	},
	MenuDeliveryDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuDelivery"
	},
	MenuDeliveryUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuDelivery",
		validation:"_ValidationResult"
	},
	MenuDeliveryUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuDelivery",
		validation:"_ValidationResult"
	},
	MenuContactCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuContact",
		validation:"_ValidationResult"
	},
	MenuContactDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuContact"
	},
	MenuContactUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuContact",
		validation:"_ValidationResult"
	},
	MenuContactUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuContact",
		validation:"_ValidationResult"
	},
	DeadlineTemplateCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeadlineTemplate",
		validation:"_ValidationResult"
	},
	DeadlineTemplateDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeadlineTemplate"
	},
	DeadlineTemplateUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeadlineTemplate",
		validation:"_ValidationResult"
	},
	DeadlineTemplateUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeadlineTemplate",
		validation:"_ValidationResult"
	},
	EmployeeQueueCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EmployeeQueue",
		validation:"_ValidationResult"
	},
	EmployeeQueueDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EmployeeQueue"
	},
	EmployeeQueueUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EmployeeQueue",
		validation:"_ValidationResult"
	},
	EmployeeQueueUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EmployeeQueue",
		validation:"_ValidationResult"
	},
	TimetableDayCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetableDay",
		validation:"_ValidationResult"
	},
	TimetableDayDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetableDay"
	},
	TimetableDayUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetableDay",
		validation:"_ValidationResult"
	},
	TimetableDayUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetableDay",
		validation:"_ValidationResult"
	},
	TimetableEmployeeRoleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetableEmployeeRole",
		validation:"_ValidationResult"
	},
	TimetableEmployeeRoleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetableEmployeeRole"
	},
	TimetableEmployeeRoleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetableEmployeeRole",
		validation:"_ValidationResult"
	},
	TimetableEmployeeRoleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetableEmployeeRole",
		validation:"_ValidationResult"
	},
	TimetableShiftCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetableShift",
		validation:"_ValidationResult"
	},
	TimetableShiftDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetableShift"
	},
	TimetableShiftUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetableShift",
		validation:"_ValidationResult"
	},
	TimetableShiftUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetableShift",
		validation:"_ValidationResult"
	},
	TimetableShiftGroupCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetableShiftGroup",
		validation:"_ValidationResult"
	},
	TimetableShiftGroupDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetableShiftGroup"
	},
	TimetableShiftGroupUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetableShiftGroup",
		validation:"_ValidationResult"
	},
	TimetableShiftGroupUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetableShiftGroup",
		validation:"_ValidationResult"
	},
	TimetableShiftPositionCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetableShiftPosition",
		validation:"_ValidationResult"
	},
	TimetableShiftPositionDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetableShiftPosition"
	},
	TimetableShiftPositionUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetableShiftPosition",
		validation:"_ValidationResult"
	},
	TimetableShiftPositionUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetableShiftPosition",
		validation:"_ValidationResult"
	},
	TimetableTemplateCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetableTemplate",
		validation:"_ValidationResult"
	},
	TimetableTemplateDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetableTemplate"
	},
	TimetableTemplateUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetableTemplate",
		validation:"_ValidationResult"
	},
	TimetableTemplateUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetableTemplate",
		validation:"_ValidationResult"
	},
	CartCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Cart",
		validation:"_ValidationResult"
	},
	CartDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Cart"
	},
	CartUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Cart",
		validation:"_ValidationResult"
	},
	CartUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Cart",
		validation:"_ValidationResult"
	},
	CartItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CartItem",
		validation:"_ValidationResult"
	},
	CartItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CartItem"
	},
	CartItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CartItem",
		validation:"_ValidationResult"
	},
	CartItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CartItem",
		validation:"_ValidationResult"
	},
	EmployeeQueueItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EmployeeQueueItem",
		validation:"_ValidationResult"
	},
	EmployeeQueueItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EmployeeQueueItem"
	},
	EmployeeQueueItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EmployeeQueueItem",
		validation:"_ValidationResult"
	},
	EmployeeQueueItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EmployeeQueueItem",
		validation:"_ValidationResult"
	},
	ApplicationCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Application",
		validation:"_ValidationResult"
	},
	ApplicationDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Application"
	},
	ApplicationUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Application",
		validation:"_ValidationResult"
	},
	ApplicationUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Application",
		validation:"_ValidationResult"
	},
	ApplicationShortcutListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ApplicationShortcutList",
		validation:"_ValidationResult"
	},
	ApplicationShortcutListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ApplicationShortcutList"
	},
	ApplicationShortcutListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ApplicationShortcutList",
		validation:"_ValidationResult"
	},
	ApplicationShortcutListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ApplicationShortcutList",
		validation:"_ValidationResult"
	},
	ApplicationShortcutListItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ApplicationShortcutListItem",
		validation:"_ValidationResult"
	},
	ApplicationShortcutListItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ApplicationShortcutListItem"
	},
	ApplicationShortcutListItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ApplicationShortcutListItem",
		validation:"_ValidationResult"
	},
	ApplicationShortcutListItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ApplicationShortcutListItem",
		validation:"_ValidationResult"
	},
	ProductBannerCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductBanner",
		validation:"_ValidationResult"
	},
	ProductBannerDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductBanner"
	},
	ProductBannerUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductBanner",
		validation:"_ValidationResult"
	},
	ProductBannerUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductBanner",
		validation:"_ValidationResult"
	},
	ProductBannerItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductBannerItem",
		validation:"_ValidationResult"
	},
	ProductBannerItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductBannerItem"
	},
	ProductBannerItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductBannerItem",
		validation:"_ValidationResult"
	},
	ProductBannerItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductBannerItem",
		validation:"_ValidationResult"
	},
	ProductBannerListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductBannerList",
		validation:"_ValidationResult"
	},
	ProductBannerListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductBannerList"
	},
	ProductBannerListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductBannerList",
		validation:"_ValidationResult"
	},
	ProductBannerListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductBannerList",
		validation:"_ValidationResult"
	},
	BartenderCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Bartender",
		validation:"_ValidationResult"
	},
	BartenderDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Bartender"
	},
	BartenderUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Bartender",
		validation:"_ValidationResult"
	},
	BartenderUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Bartender",
		validation:"_ValidationResult"
	},
	BusinessToBusinessManagerCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessToBusinessManager",
		validation:"_ValidationResult"
	},
	BusinessToBusinessManagerDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessToBusinessManager"
	},
	BusinessToBusinessManagerUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessToBusinessManager",
		validation:"_ValidationResult"
	},
	BusinessToBusinessManagerUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessToBusinessManager",
		validation:"_ValidationResult"
	},
	CleanerCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Cleaner",
		validation:"_ValidationResult"
	},
	CleanerDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Cleaner"
	},
	CleanerUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Cleaner",
		validation:"_ValidationResult"
	},
	CleanerUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Cleaner",
		validation:"_ValidationResult"
	},
	CourierCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Courier",
		validation:"_ValidationResult"
	},
	CourierDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Courier"
	},
	CourierUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Courier",
		validation:"_ValidationResult"
	},
	CourierUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Courier",
		validation:"_ValidationResult"
	},
	ShiftsManagerCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShiftsManager",
		validation:"_ValidationResult"
	},
	ShiftsManagerDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShiftsManager"
	},
	ShiftsManagerUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShiftsManager",
		validation:"_ValidationResult"
	},
	ShiftsManagerUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShiftsManager",
		validation:"_ValidationResult"
	},
	UserCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"User",
		validation:"_ValidationResult"
	},
	UserDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"User"
	},
	UserUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"User",
		validation:"_ValidationResult"
	},
	UserUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"User",
		validation:"_ValidationResult"
	},
	ShiftsProfileCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShiftsProfile",
		validation:"_ValidationResult"
	},
	ShiftsProfileDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShiftsProfile"
	},
	ShiftsProfileUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShiftsProfile",
		validation:"_ValidationResult"
	},
	ShiftsProfileUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShiftsProfile",
		validation:"_ValidationResult"
	},
	ProductIngredientCategoryCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductIngredientCategory",
		validation:"_ValidationResult"
	},
	ProductIngredientCategoryDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductIngredientCategory"
	},
	ProductIngredientCategoryUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductIngredientCategory",
		validation:"_ValidationResult"
	},
	ProductIngredientCategoryUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductIngredientCategory",
		validation:"_ValidationResult"
	},
	ProductIngredientCategoryLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductIngredientCategoryLocale",
		validation:"_ValidationResult"
	},
	ProductIngredientCategoryLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductIngredientCategoryLocale"
	},
	ProductIngredientCategoryLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductIngredientCategoryLocale",
		validation:"_ValidationResult"
	},
	ProductIngredientCategoryLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductIngredientCategoryLocale",
		validation:"_ValidationResult"
	},
	StocksManagerCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StocksManager",
		validation:"_ValidationResult"
	},
	StocksManagerDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StocksManager"
	},
	StocksManagerUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StocksManager",
		validation:"_ValidationResult"
	},
	StocksManagerUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StocksManager",
		validation:"_ValidationResult"
	},
	DeliveryRouteCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeliveryRoute",
		validation:"_ValidationResult"
	},
	DeliveryRouteDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeliveryRoute"
	},
	DeliveryRouteUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeliveryRoute",
		validation:"_ValidationResult"
	},
	DeliveryRouteUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeliveryRoute",
		validation:"_ValidationResult"
	},
	DeliveryWaypointCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeliveryWaypoint",
		validation:"_ValidationResult"
	},
	DeliveryWaypointDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeliveryWaypoint"
	},
	DeliveryWaypointUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeliveryWaypoint",
		validation:"_ValidationResult"
	},
	DeliveryWaypointUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeliveryWaypoint",
		validation:"_ValidationResult"
	},
	AllergenCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Allergen",
		validation:"_ValidationResult"
	},
	AllergenDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Allergen"
	},
	AllergenUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Allergen",
		validation:"_ValidationResult"
	},
	AllergenUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Allergen",
		validation:"_ValidationResult"
	},
	AllergenLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AllergenLocale",
		validation:"_ValidationResult"
	},
	AllergenLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AllergenLocale"
	},
	AllergenLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AllergenLocale",
		validation:"_ValidationResult"
	},
	AllergenLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AllergenLocale",
		validation:"_ValidationResult"
	},
	GpsCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Gps",
		validation:"_ValidationResult"
	},
	GpsDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Gps"
	},
	GpsUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Gps",
		validation:"_ValidationResult"
	},
	GpsUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Gps",
		validation:"_ValidationResult"
	},
	WeekHoursCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"WeekHours",
		validation:"_ValidationResult"
	},
	WeekHoursDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"WeekHours"
	},
	WeekHoursUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"WeekHours",
		validation:"_ValidationResult"
	},
	WeekHoursUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"WeekHours",
		validation:"_ValidationResult"
	},
	PreparedIngredientQuantityCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PreparedIngredientQuantity",
		validation:"_ValidationResult"
	},
	PreparedIngredientQuantityDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PreparedIngredientQuantity"
	},
	PreparedIngredientQuantityUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PreparedIngredientQuantity",
		validation:"_ValidationResult"
	},
	PreparedIngredientQuantityUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PreparedIngredientQuantity",
		validation:"_ValidationResult"
	},
	PreparedRecipeQuantityCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PreparedRecipeQuantity",
		validation:"_ValidationResult"
	},
	PreparedRecipeQuantityDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PreparedRecipeQuantity"
	},
	PreparedRecipeQuantityUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PreparedRecipeQuantity",
		validation:"_ValidationResult"
	},
	PreparedRecipeQuantityUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PreparedRecipeQuantity",
		validation:"_ValidationResult"
	},
	InternalOrderCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InternalOrder",
		validation:"_ValidationResult"
	},
	InternalOrderDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InternalOrder"
	},
	InternalOrderUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InternalOrder",
		validation:"_ValidationResult"
	},
	InternalOrderUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InternalOrder",
		validation:"_ValidationResult"
	},
	InternalOrderItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InternalOrderItem",
		validation:"_ValidationResult"
	},
	InternalOrderItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InternalOrderItem"
	},
	InternalOrderItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InternalOrderItem",
		validation:"_ValidationResult"
	},
	InternalOrderItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InternalOrderItem",
		validation:"_ValidationResult"
	},
	PreparedPackingQuantityCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PreparedPackingQuantity",
		validation:"_ValidationResult"
	},
	PreparedPackingQuantityDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PreparedPackingQuantity"
	},
	PreparedPackingQuantityUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PreparedPackingQuantity",
		validation:"_ValidationResult"
	},
	PreparedPackingQuantityUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PreparedPackingQuantity",
		validation:"_ValidationResult"
	},
	CourierManagerCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CourierManager",
		validation:"_ValidationResult"
	},
	CourierManagerDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CourierManager"
	},
	CourierManagerUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CourierManager",
		validation:"_ValidationResult"
	},
	CourierManagerUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CourierManager",
		validation:"_ValidationResult"
	},
	DeliveryZoneCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeliveryZone",
		validation:"_ValidationResult"
	},
	DeliveryZoneDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeliveryZone"
	},
	DeliveryZoneUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeliveryZone",
		validation:"_ValidationResult"
	},
	DeliveryZoneUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeliveryZone",
		validation:"_ValidationResult"
	},
	DeliveryTimelinePresetCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeliveryTimelinePreset",
		validation:"_ValidationResult"
	},
	DeliveryTimelinePresetDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeliveryTimelinePreset"
	},
	DeliveryTimelinePresetUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeliveryTimelinePreset",
		validation:"_ValidationResult"
	},
	DeliveryTimelinePresetUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeliveryTimelinePreset",
		validation:"_ValidationResult"
	},
	OrderDeliveryTimelineCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OrderDeliveryTimeline",
		validation:"_ValidationResult"
	},
	OrderDeliveryTimelineDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OrderDeliveryTimeline"
	},
	OrderDeliveryTimelineUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OrderDeliveryTimeline",
		validation:"_ValidationResult"
	},
	OrderDeliveryTimelineUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OrderDeliveryTimeline",
		validation:"_ValidationResult"
	},
	OrderEventCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OrderEvent",
		validation:"_ValidationResult"
	},
	OrderEventDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OrderEvent"
	},
	OrderEventUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OrderEvent",
		validation:"_ValidationResult"
	},
	OrderEventUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OrderEvent",
		validation:"_ValidationResult"
	},
	LiftagoRideCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LiftagoRide",
		validation:"_ValidationResult"
	},
	LiftagoRideDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LiftagoRide"
	},
	LiftagoRideUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LiftagoRide",
		validation:"_ValidationResult"
	},
	LiftagoRideUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LiftagoRide",
		validation:"_ValidationResult"
	},
	InvoiceCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Invoice",
		validation:"_ValidationResult"
	},
	InvoiceDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Invoice"
	},
	InvoiceUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Invoice",
		validation:"_ValidationResult"
	},
	InvoiceUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Invoice",
		validation:"_ValidationResult"
	},
	InvoicingPlanCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InvoicingPlan",
		validation:"_ValidationResult"
	},
	InvoicingPlanDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InvoicingPlan"
	},
	InvoicingPlanUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InvoicingPlan",
		validation:"_ValidationResult"
	},
	InvoicingPlanUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InvoicingPlan",
		validation:"_ValidationResult"
	},
	ProductPackingLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductPackingLocale",
		validation:"_ValidationResult"
	},
	ProductPackingLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductPackingLocale"
	},
	ProductPackingLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductPackingLocale",
		validation:"_ValidationResult"
	},
	ProductPackingLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductPackingLocale",
		validation:"_ValidationResult"
	},
	ProductLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductLocale",
		validation:"_ValidationResult"
	},
	ProductLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductLocale"
	},
	ProductLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductLocale",
		validation:"_ValidationResult"
	},
	ProductLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductLocale",
		validation:"_ValidationResult"
	},
	ProductRecipeLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductRecipeLocale",
		validation:"_ValidationResult"
	},
	ProductRecipeLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductRecipeLocale"
	},
	ProductRecipeLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductRecipeLocale",
		validation:"_ValidationResult"
	},
	ProductRecipeLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductRecipeLocale",
		validation:"_ValidationResult"
	},
	UserDeviceCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"UserDevice",
		validation:"_ValidationResult"
	},
	UserDeviceDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"UserDevice"
	},
	UserDeviceUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"UserDevice",
		validation:"_ValidationResult"
	},
	UserDeviceUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"UserDevice",
		validation:"_ValidationResult"
	},
	ProtectedActionCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProtectedAction",
		validation:"_ValidationResult"
	},
	ProtectedActionDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProtectedAction"
	},
	ProtectedActionUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProtectedAction",
		validation:"_ValidationResult"
	},
	ProtectedActionUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProtectedAction",
		validation:"_ValidationResult"
	},
	PickerCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Picker",
		validation:"_ValidationResult"
	},
	PickerDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Picker"
	},
	PickerUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Picker",
		validation:"_ValidationResult"
	},
	PickerUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Picker",
		validation:"_ValidationResult"
	},
	TimetableTemplateStaffOptionsCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetableTemplateStaffOptions",
		validation:"_ValidationResult"
	},
	TimetableTemplateStaffOptionsDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetableTemplateStaffOptions"
	},
	TimetableTemplateStaffOptionsUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetableTemplateStaffOptions",
		validation:"_ValidationResult"
	},
	TimetableTemplateStaffOptionsUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetableTemplateStaffOptions",
		validation:"_ValidationResult"
	},
	ShoppingListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShoppingList",
		validation:"_ValidationResult"
	},
	ShoppingListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShoppingList"
	},
	ShoppingListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShoppingList",
		validation:"_ValidationResult"
	},
	ShoppingListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShoppingList",
		validation:"_ValidationResult"
	},
	SuppliesPurchaseCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SuppliesPurchase",
		validation:"_ValidationResult"
	},
	SuppliesPurchaseDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SuppliesPurchase"
	},
	SuppliesPurchaseUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SuppliesPurchase",
		validation:"_ValidationResult"
	},
	SuppliesPurchaseUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SuppliesPurchase",
		validation:"_ValidationResult"
	},
	InvoicingPresetCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InvoicingPreset",
		validation:"_ValidationResult"
	},
	InvoicingPresetDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InvoicingPreset"
	},
	InvoicingPresetUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InvoicingPreset",
		validation:"_ValidationResult"
	},
	InvoicingPresetUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InvoicingPreset",
		validation:"_ValidationResult"
	},
	LogRecordCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LogRecord",
		validation:"_ValidationResult"
	},
	LogRecordDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LogRecord"
	},
	LogRecordUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LogRecord",
		validation:"_ValidationResult"
	},
	LogRecordUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LogRecord",
		validation:"_ValidationResult"
	},
	BillingSubjectCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BillingSubject",
		validation:"_ValidationResult"
	},
	BillingSubjectDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BillingSubject"
	},
	BillingSubjectUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BillingSubject",
		validation:"_ValidationResult"
	},
	BillingSubjectUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BillingSubject",
		validation:"_ValidationResult"
	},
	ShoppingListItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShoppingListItem",
		validation:"_ValidationResult"
	},
	ShoppingListItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShoppingListItem"
	},
	ShoppingListItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShoppingListItem",
		validation:"_ValidationResult"
	},
	ShoppingListItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShoppingListItem",
		validation:"_ValidationResult"
	},
	SuppliesPurchaseItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SuppliesPurchaseItem",
		validation:"_ValidationResult"
	},
	SuppliesPurchaseItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SuppliesPurchaseItem"
	},
	SuppliesPurchaseItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SuppliesPurchaseItem",
		validation:"_ValidationResult"
	},
	SuppliesPurchaseItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SuppliesPurchaseItem",
		validation:"_ValidationResult"
	},
	CustomerCreditTransactionCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CustomerCreditTransaction",
		validation:"_ValidationResult"
	},
	CustomerCreditTransactionDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CustomerCreditTransaction"
	},
	CustomerCreditTransactionUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CustomerCreditTransaction",
		validation:"_ValidationResult"
	},
	CustomerCreditTransactionUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CustomerCreditTransaction",
		validation:"_ValidationResult"
	},
	VirtualProductCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"VirtualProduct",
		validation:"_ValidationResult"
	},
	VirtualProductDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"VirtualProduct"
	},
	VirtualProductUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"VirtualProduct",
		validation:"_ValidationResult"
	},
	VirtualProductUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"VirtualProduct",
		validation:"_ValidationResult"
	},
	VirtualProductEffectCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"VirtualProductEffect",
		validation:"_ValidationResult"
	},
	VirtualProductEffectDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"VirtualProductEffect"
	},
	VirtualProductEffectUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"VirtualProductEffect",
		validation:"_ValidationResult"
	},
	VirtualProductEffectUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"VirtualProductEffect",
		validation:"_ValidationResult"
	},
	EmploymentInformationCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EmploymentInformation",
		validation:"_ValidationResult"
	},
	EmploymentInformationDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EmploymentInformation"
	},
	EmploymentInformationUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EmploymentInformation",
		validation:"_ValidationResult"
	},
	EmploymentInformationUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EmploymentInformation",
		validation:"_ValidationResult"
	},
	RemunerationProfileCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RemunerationProfile",
		validation:"_ValidationResult"
	},
	RemunerationProfileDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RemunerationProfile"
	},
	RemunerationProfileUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RemunerationProfile",
		validation:"_ValidationResult"
	},
	RemunerationProfileUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RemunerationProfile",
		validation:"_ValidationResult"
	},
	WorkMonthCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"WorkMonth",
		validation:"_ValidationResult"
	},
	WorkMonthDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"WorkMonth"
	},
	WorkMonthUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"WorkMonth",
		validation:"_ValidationResult"
	},
	WorkMonthUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"WorkMonth",
		validation:"_ValidationResult"
	},
	SalaryOptionsCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SalaryOptions",
		validation:"_ValidationResult"
	},
	SalaryOptionsDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SalaryOptions"
	},
	SalaryOptionsUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SalaryOptions",
		validation:"_ValidationResult"
	},
	SalaryOptionsUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SalaryOptions",
		validation:"_ValidationResult"
	},
	TimetableShiftSwapInfoCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetableShiftSwapInfo",
		validation:"_ValidationResult"
	},
	TimetableShiftSwapInfoDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetableShiftSwapInfo"
	},
	TimetableShiftSwapInfoUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetableShiftSwapInfo",
		validation:"_ValidationResult"
	},
	TimetableShiftSwapInfoUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetableShiftSwapInfo",
		validation:"_ValidationResult"
	},
	ProductGridCategoryCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductGridCategory",
		validation:"_ValidationResult"
	},
	ProductGridCategoryDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductGridCategory"
	},
	ProductGridCategoryUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductGridCategory",
		validation:"_ValidationResult"
	},
	ProductGridCategoryUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductGridCategory",
		validation:"_ValidationResult"
	},
	CashierCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Cashier",
		validation:"_ValidationResult"
	},
	CashierDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Cashier"
	},
	CashierUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Cashier",
		validation:"_ValidationResult"
	},
	CashierUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Cashier",
		validation:"_ValidationResult"
	},
	PointOfSaleCategoryCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PointOfSaleCategory",
		validation:"_ValidationResult"
	},
	PointOfSaleCategoryDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PointOfSaleCategory"
	},
	PointOfSaleCategoryUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PointOfSaleCategory",
		validation:"_ValidationResult"
	},
	PointOfSaleCategoryUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PointOfSaleCategory",
		validation:"_ValidationResult"
	},
	PointOfSaleCategoryLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PointOfSaleCategoryLocale",
		validation:"_ValidationResult"
	},
	PointOfSaleCategoryLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PointOfSaleCategoryLocale"
	},
	PointOfSaleCategoryLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PointOfSaleCategoryLocale",
		validation:"_ValidationResult"
	},
	PointOfSaleCategoryLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PointOfSaleCategoryLocale",
		validation:"_ValidationResult"
	},
	PointOfSaleCategoryProductCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PointOfSaleCategoryProduct",
		validation:"_ValidationResult"
	},
	PointOfSaleCategoryProductDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PointOfSaleCategoryProduct"
	},
	PointOfSaleCategoryProductUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PointOfSaleCategoryProduct",
		validation:"_ValidationResult"
	},
	PointOfSaleCategoryProductUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PointOfSaleCategoryProduct",
		validation:"_ValidationResult"
	},
	PointOfSaleCategoryProductLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PointOfSaleCategoryProductLocale",
		validation:"_ValidationResult"
	},
	PointOfSaleCategoryProductLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PointOfSaleCategoryProductLocale"
	},
	PointOfSaleCategoryProductLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PointOfSaleCategoryProductLocale",
		validation:"_ValidationResult"
	},
	PointOfSaleCategoryProductLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PointOfSaleCategoryProductLocale",
		validation:"_ValidationResult"
	},
	CustomerTabCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CustomerTab",
		validation:"_ValidationResult"
	},
	CustomerTabDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CustomerTab"
	},
	CustomerTabUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CustomerTab",
		validation:"_ValidationResult"
	},
	CustomerTabUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CustomerTab",
		validation:"_ValidationResult"
	},
	CustomerTabItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CustomerTabItem",
		validation:"_ValidationResult"
	},
	CustomerTabItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CustomerTabItem"
	},
	CustomerTabItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CustomerTabItem",
		validation:"_ValidationResult"
	},
	CustomerTabItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CustomerTabItem",
		validation:"_ValidationResult"
	},
	AnonymousSessionCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AnonymousSession",
		validation:"_ValidationResult"
	},
	AnonymousSessionDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AnonymousSession"
	},
	AnonymousSessionUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AnonymousSession",
		validation:"_ValidationResult"
	},
	AnonymousSessionUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AnonymousSession",
		validation:"_ValidationResult"
	},
	VoucherCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Voucher",
		validation:"_ValidationResult"
	},
	VoucherDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Voucher"
	},
	VoucherUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Voucher",
		validation:"_ValidationResult"
	},
	VoucherUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Voucher",
		validation:"_ValidationResult"
	},
	VoucherRedemptionCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"VoucherRedemption",
		validation:"_ValidationResult"
	},
	VoucherRedemptionDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"VoucherRedemption"
	},
	VoucherRedemptionUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"VoucherRedemption",
		validation:"_ValidationResult"
	},
	VoucherRedemptionUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"VoucherRedemption",
		validation:"_ValidationResult"
	},
	UnassignedShiftInfoCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"UnassignedShiftInfo",
		validation:"_ValidationResult"
	},
	UnassignedShiftInfoDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"UnassignedShiftInfo"
	},
	UnassignedShiftInfoUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"UnassignedShiftInfo",
		validation:"_ValidationResult"
	},
	UnassignedShiftInfoUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"UnassignedShiftInfo",
		validation:"_ValidationResult"
	},
	FreshingContainerCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FreshingContainer",
		validation:"_ValidationResult"
	},
	FreshingContainerDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FreshingContainer"
	},
	FreshingContainerUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FreshingContainer",
		validation:"_ValidationResult"
	},
	FreshingContainerUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FreshingContainer",
		validation:"_ValidationResult"
	},
	TextItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextItem",
		validation:"_ValidationResult"
	},
	TextItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextItem"
	},
	TextItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextItem",
		validation:"_ValidationResult"
	},
	TextItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextItem",
		validation:"_ValidationResult"
	},
	TextListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextList",
		validation:"_ValidationResult"
	},
	TextListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextList"
	},
	TextListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextList",
		validation:"_ValidationResult"
	},
	TextListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextList",
		validation:"_ValidationResult"
	},
	DeliveryRegionsCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeliveryRegions",
		validation:"_ValidationResult"
	},
	DeliveryRegionsDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeliveryRegions"
	},
	DeliveryRegionsUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeliveryRegions",
		validation:"_ValidationResult"
	},
	DeliveryRegionsUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeliveryRegions",
		validation:"_ValidationResult"
	},
	DeliveryRegionsItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeliveryRegionsItem",
		validation:"_ValidationResult"
	},
	DeliveryRegionsItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeliveryRegionsItem"
	},
	DeliveryRegionsItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeliveryRegionsItem",
		validation:"_ValidationResult"
	},
	DeliveryRegionsItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeliveryRegionsItem",
		validation:"_ValidationResult"
	},
	ImageListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageList",
		validation:"_ValidationResult"
	},
	ImageListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageList"
	},
	ImageListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageList",
		validation:"_ValidationResult"
	},
	ImageListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageList",
		validation:"_ValidationResult"
	},
	ImageListItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageListItem",
		validation:"_ValidationResult"
	},
	ImageListItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageListItem"
	},
	ImageListItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageListItem",
		validation:"_ValidationResult"
	},
	ImageListItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageListItem",
		validation:"_ValidationResult"
	},
	TimetablesEmployeePrivilegesCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetablesEmployeePrivileges",
		validation:"_ValidationResult"
	},
	TimetablesEmployeePrivilegesDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetablesEmployeePrivileges"
	},
	TimetablesEmployeePrivilegesUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetablesEmployeePrivileges",
		validation:"_ValidationResult"
	},
	TimetablesEmployeePrivilegesUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetablesEmployeePrivileges",
		validation:"_ValidationResult"
	},
	TimetableDayNoteCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetableDayNote",
		validation:"_ValidationResult"
	},
	TimetableDayNoteDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetableDayNote"
	},
	TimetableDayNoteUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetableDayNote",
		validation:"_ValidationResult"
	},
	TimetableDayNoteUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimetableDayNote",
		validation:"_ValidationResult"
	},
	DeliveryMethodLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeliveryMethodLocale",
		validation:"_ValidationResult"
	},
	DeliveryMethodLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeliveryMethodLocale"
	},
	DeliveryMethodLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeliveryMethodLocale",
		validation:"_ValidationResult"
	},
	DeliveryMethodLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeliveryMethodLocale",
		validation:"_ValidationResult"
	},
	IngredientSupplierCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"IngredientSupplier",
		validation:"_ValidationResult"
	},
	IngredientSupplierDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"IngredientSupplier"
	},
	IngredientSupplierUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"IngredientSupplier",
		validation:"_ValidationResult"
	},
	IngredientSupplierUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"IngredientSupplier",
		validation:"_ValidationResult"
	},
	IngredientSupplierItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"IngredientSupplierItem",
		validation:"_ValidationResult"
	},
	IngredientSupplierItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"IngredientSupplierItem"
	},
	IngredientSupplierItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"IngredientSupplierItem",
		validation:"_ValidationResult"
	},
	IngredientSupplierItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"IngredientSupplierItem",
		validation:"_ValidationResult"
	},
	IngredientSupplierListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"IngredientSupplierList",
		validation:"_ValidationResult"
	},
	IngredientSupplierListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"IngredientSupplierList"
	},
	IngredientSupplierListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"IngredientSupplierList",
		validation:"_ValidationResult"
	},
	IngredientSupplierListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"IngredientSupplierList",
		validation:"_ValidationResult"
	},
	IngredientSupplierLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"IngredientSupplierLocale",
		validation:"_ValidationResult"
	},
	IngredientSupplierLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"IngredientSupplierLocale"
	},
	IngredientSupplierLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"IngredientSupplierLocale",
		validation:"_ValidationResult"
	},
	IngredientSupplierLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"IngredientSupplierLocale",
		validation:"_ValidationResult"
	},
	RedirectCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Redirect",
		validation:"_ValidationResult"
	},
	RedirectDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Redirect"
	},
	RedirectUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Redirect",
		validation:"_ValidationResult"
	},
	RedirectUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Redirect",
		validation:"_ValidationResult"
	},
	NutritionFactsCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"NutritionFacts",
		validation:"_ValidationResult"
	},
	NutritionFactsDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"NutritionFacts"
	},
	NutritionFactsUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"NutritionFacts",
		validation:"_ValidationResult"
	},
	NutritionFactsUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"NutritionFacts",
		validation:"_ValidationResult"
	},
	VenueCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Venue",
		validation:"_ValidationResult"
	},
	VenueDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Venue"
	},
	VenueUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Venue",
		validation:"_ValidationResult"
	},
	VenueUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Venue",
		validation:"_ValidationResult"
	},
	WorkspaceCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Workspace",
		validation:"_ValidationResult"
	},
	WorkspaceDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Workspace"
	},
	WorkspaceUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Workspace",
		validation:"_ValidationResult"
	},
	WorkspaceUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Workspace",
		validation:"_ValidationResult"
	},
	InternalBuyerCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InternalBuyer",
		validation:"_ValidationResult"
	},
	InternalBuyerDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InternalBuyer"
	},
	InternalBuyerUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InternalBuyer",
		validation:"_ValidationResult"
	},
	InternalBuyerUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"InternalBuyer",
		validation:"_ValidationResult"
	},
	VenueEmployeeRoleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"VenueEmployeeRole",
		validation:"_ValidationResult"
	},
	VenueEmployeeRoleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"VenueEmployeeRole"
	},
	VenueEmployeeRoleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"VenueEmployeeRole",
		validation:"_ValidationResult"
	},
	VenueEmployeeRoleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"VenueEmployeeRole",
		validation:"_ValidationResult"
	},
	IdentificationAttemptCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"IdentificationAttempt",
		validation:"_ValidationResult"
	},
	IdentificationAttemptDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"IdentificationAttempt"
	},
	IdentificationAttemptUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"IdentificationAttempt",
		validation:"_ValidationResult"
	},
	IdentificationAttemptUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"IdentificationAttempt",
		validation:"_ValidationResult"
	},
	IdentificationCodeCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"IdentificationCode",
		validation:"_ValidationResult"
	},
	IdentificationCodeDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"IdentificationCode"
	},
	IdentificationCodeUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"IdentificationCode",
		validation:"_ValidationResult"
	},
	IdentificationCodeUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"IdentificationCode",
		validation:"_ValidationResult"
	},
	IdentificationCodeLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"IdentificationCodeLocale",
		validation:"_ValidationResult"
	},
	IdentificationCodeLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"IdentificationCodeLocale"
	},
	IdentificationCodeLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"IdentificationCodeLocale",
		validation:"_ValidationResult"
	},
	IdentificationCodeLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"IdentificationCodeLocale",
		validation:"_ValidationResult"
	},
	PipelineCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Pipeline",
		validation:"_ValidationResult"
	},
	PipelineDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Pipeline"
	},
	PipelineUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Pipeline",
		validation:"_ValidationResult"
	},
	PipelineUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Pipeline",
		validation:"_ValidationResult"
	},
	PipelineLeadCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PipelineLead",
		validation:"_ValidationResult"
	},
	PipelineLeadDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PipelineLead"
	},
	PipelineLeadUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PipelineLead",
		validation:"_ValidationResult"
	},
	PipelineLeadUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PipelineLead",
		validation:"_ValidationResult"
	},
	PipelineStageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PipelineStage",
		validation:"_ValidationResult"
	},
	PipelineStageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PipelineStage"
	},
	PipelineStageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PipelineStage",
		validation:"_ValidationResult"
	},
	PipelineStageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PipelineStage",
		validation:"_ValidationResult"
	},
	PipelineStageItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PipelineStageItem",
		validation:"_ValidationResult"
	},
	PipelineStageItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PipelineStageItem"
	},
	PipelineStageItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PipelineStageItem",
		validation:"_ValidationResult"
	},
	PipelineStageItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PipelineStageItem",
		validation:"_ValidationResult"
	},
	PipelineStageLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PipelineStageLocale",
		validation:"_ValidationResult"
	},
	PipelineStageLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PipelineStageLocale"
	},
	PipelineStageLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PipelineStageLocale",
		validation:"_ValidationResult"
	},
	PipelineStageLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PipelineStageLocale",
		validation:"_ValidationResult"
	},
	SalesManagerCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SalesManager",
		validation:"_ValidationResult"
	},
	SalesManagerDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SalesManager"
	},
	SalesManagerUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SalesManager",
		validation:"_ValidationResult"
	},
	SalesManagerUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SalesManager",
		validation:"_ValidationResult"
	},
	CashierManagerCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CashierManager",
		validation:"_ValidationResult"
	},
	CashierManagerDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CashierManager"
	},
	CashierManagerUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CashierManager",
		validation:"_ValidationResult"
	},
	CashierManagerUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CashierManager",
		validation:"_ValidationResult"
	},
	PointOfSaleApplicationDeviceCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PointOfSaleApplicationDevice",
		validation:"_ValidationResult"
	},
	PointOfSaleApplicationDeviceDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PointOfSaleApplicationDevice"
	},
	PointOfSaleApplicationDeviceUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PointOfSaleApplicationDevice",
		validation:"_ValidationResult"
	},
	PointOfSaleApplicationDeviceUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PointOfSaleApplicationDevice",
		validation:"_ValidationResult"
	},
	PointOfSaleTerminalCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PointOfSaleTerminal",
		validation:"_ValidationResult"
	},
	PointOfSaleTerminalDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PointOfSaleTerminal"
	},
	PointOfSaleTerminalUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PointOfSaleTerminal",
		validation:"_ValidationResult"
	},
	PointOfSaleTerminalUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PointOfSaleTerminal",
		validation:"_ValidationResult"
	},
	PipelineStageSentimentCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PipelineStageSentiment",
		validation:"_ValidationResult"
	},
	PipelineStageSentimentDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PipelineStageSentiment"
	},
	PipelineStageSentimentUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PipelineStageSentiment",
		validation:"_ValidationResult"
	},
	PipelineStageSentimentUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PipelineStageSentiment",
		validation:"_ValidationResult"
	},
	DeviceIdentifierCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeviceIdentifier",
		validation:"_ValidationResult"
	},
	DeviceIdentifierDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeviceIdentifier"
	},
	DeviceIdentifierUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeviceIdentifier",
		validation:"_ValidationResult"
	},
	DeviceIdentifierUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DeviceIdentifier",
		validation:"_ValidationResult"
	},
	PointOfSalePrinterCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PointOfSalePrinter",
		validation:"_ValidationResult"
	},
	PointOfSalePrinterDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PointOfSalePrinter"
	},
	PointOfSalePrinterUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PointOfSalePrinter",
		validation:"_ValidationResult"
	},
	PointOfSalePrinterUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PointOfSalePrinter",
		validation:"_ValidationResult"
	},
	GratuityCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Gratuity",
		validation:"_ValidationResult"
	},
	GratuityDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Gratuity"
	},
	GratuityUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Gratuity",
		validation:"_ValidationResult"
	},
	GratuityUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Gratuity",
		validation:"_ValidationResult"
	},
	FulfillmentNoteCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FulfillmentNote",
		validation:"_ValidationResult"
	},
	FulfillmentNoteDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FulfillmentNote"
	},
	FulfillmentNoteUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FulfillmentNote",
		validation:"_ValidationResult"
	},
	FulfillmentNoteUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FulfillmentNote",
		validation:"_ValidationResult"
	},
	LeadFormCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LeadForm",
		validation:"_ValidationResult"
	},
	LeadFormDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LeadForm"
	},
	LeadFormUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LeadForm",
		validation:"_ValidationResult"
	},
	LeadFormUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LeadForm",
		validation:"_ValidationResult"
	},
	SubscriptionBoxCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SubscriptionBox",
		validation:"_ValidationResult"
	},
	SubscriptionBoxDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SubscriptionBox"
	},
	SubscriptionBoxUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SubscriptionBox",
		validation:"_ValidationResult"
	},
	SubscriptionBoxUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SubscriptionBox",
		validation:"_ValidationResult"
	},
	SubscriptionBoxLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SubscriptionBoxLocale",
		validation:"_ValidationResult"
	},
	SubscriptionBoxLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SubscriptionBoxLocale"
	},
	SubscriptionBoxLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SubscriptionBoxLocale",
		validation:"_ValidationResult"
	},
	SubscriptionBoxLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SubscriptionBoxLocale",
		validation:"_ValidationResult"
	},
	BusinessServiceCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessService",
		validation:"_ValidationResult"
	},
	BusinessServiceDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessService"
	},
	BusinessServiceUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessService",
		validation:"_ValidationResult"
	},
	BusinessServiceUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessService",
		validation:"_ValidationResult"
	},
	BusinessServiceEventCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessServiceEvent",
		validation:"_ValidationResult"
	},
	BusinessServiceEventDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessServiceEvent"
	},
	BusinessServiceEventUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessServiceEvent",
		validation:"_ValidationResult"
	},
	BusinessServiceEventUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessServiceEvent",
		validation:"_ValidationResult"
	},
	BusinessServiceLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessServiceLocale",
		validation:"_ValidationResult"
	},
	BusinessServiceLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessServiceLocale"
	},
	BusinessServiceLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessServiceLocale",
		validation:"_ValidationResult"
	},
	BusinessServiceLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessServiceLocale",
		validation:"_ValidationResult"
	},
	GridTileItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GridTileItem",
		validation:"_ValidationResult"
	},
	GridTileItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GridTileItem"
	},
	GridTileItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GridTileItem",
		validation:"_ValidationResult"
	},
	GridTileItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GridTileItem",
		validation:"_ValidationResult"
	},
	GridTilesCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GridTiles",
		validation:"_ValidationResult"
	},
	GridTilesDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GridTiles"
	},
	GridTilesUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GridTiles",
		validation:"_ValidationResult"
	},
	GridTilesUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GridTiles",
		validation:"_ValidationResult"
	},
	AreaCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Area",
		validation:"_ValidationResult"
	},
	AreaDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Area"
	},
	AreaUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Area",
		validation:"_ValidationResult"
	},
	AreaUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Area",
		validation:"_ValidationResult"
	},
	PositionCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Position",
		validation:"_ValidationResult"
	},
	PositionDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Position"
	},
	PositionUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Position",
		validation:"_ValidationResult"
	},
	PositionUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Position",
		validation:"_ValidationResult"
	},
	StatsEnabledWidgetTypeCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StatsEnabledWidgetType",
		validation:"_ValidationResult"
	},
	StatsEnabledWidgetTypeDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StatsEnabledWidgetType"
	},
	StatsEnabledWidgetTypeUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StatsEnabledWidgetType",
		validation:"_ValidationResult"
	},
	StatsEnabledWidgetTypeUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StatsEnabledWidgetType",
		validation:"_ValidationResult"
	},
	StatsWidgetCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StatsWidget",
		validation:"_ValidationResult"
	},
	StatsWidgetDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StatsWidget"
	},
	StatsWidgetUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StatsWidget",
		validation:"_ValidationResult"
	},
	StatsWidgetUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StatsWidget",
		validation:"_ValidationResult"
	},
	StatsWidgetsLayoutCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StatsWidgetsLayout",
		validation:"_ValidationResult"
	},
	StatsWidgetsLayoutDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StatsWidgetsLayout"
	},
	StatsWidgetsLayoutUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StatsWidgetsLayout",
		validation:"_ValidationResult"
	},
	StatsWidgetsLayoutUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StatsWidgetsLayout",
		validation:"_ValidationResult"
	},
	SeatCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seat",
		validation:"_ValidationResult"
	},
	SeatDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seat"
	},
	SeatUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seat",
		validation:"_ValidationResult"
	},
	SeatUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seat",
		validation:"_ValidationResult"
	},
	TableCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Table",
		validation:"_ValidationResult"
	},
	TableDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Table"
	},
	TableUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Table",
		validation:"_ValidationResult"
	},
	TableUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Table",
		validation:"_ValidationResult"
	},
	StatsPageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StatsPage",
		validation:"_ValidationResult"
	},
	StatsPageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StatsPage"
	},
	StatsPageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StatsPage",
		validation:"_ValidationResult"
	},
	StatsPageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StatsPage",
		validation:"_ValidationResult"
	},
	UnassignReasonCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"UnassignReason",
		validation:"_ValidationResult"
	},
	UnassignReasonDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"UnassignReason"
	},
	UnassignReasonUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"UnassignReason",
		validation:"_ValidationResult"
	},
	UnassignReasonUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"UnassignReason",
		validation:"_ValidationResult"
	},
	DoubleshotCoffeeEquipmentCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DoubleshotCoffeeEquipment",
		validation:"_ValidationResult"
	},
	DoubleshotCoffeeEquipmentDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DoubleshotCoffeeEquipment"
	},
	DoubleshotCoffeeEquipmentUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DoubleshotCoffeeEquipment",
		validation:"_ValidationResult"
	},
	DoubleshotCoffeeEquipmentUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DoubleshotCoffeeEquipment",
		validation:"_ValidationResult"
	},
	ExpenseCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Expense",
		validation:"_ValidationResult"
	},
	ExpenseDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Expense"
	},
	ExpenseUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Expense",
		validation:"_ValidationResult"
	},
	ExpenseUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Expense",
		validation:"_ValidationResult"
	},
	ExpenseCategoryCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ExpenseCategory",
		validation:"_ValidationResult"
	},
	ExpenseCategoryDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ExpenseCategory"
	},
	ExpenseCategoryUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ExpenseCategory",
		validation:"_ValidationResult"
	},
	ExpenseCategoryUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ExpenseCategory",
		validation:"_ValidationResult"
	},
	ExpenseChangeCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ExpenseChange",
		validation:"_ValidationResult"
	},
	ExpenseChangeDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ExpenseChange"
	},
	ExpenseChangeUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ExpenseChange",
		validation:"_ValidationResult"
	},
	ExpenseChangeUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ExpenseChange",
		validation:"_ValidationResult"
	},
	ExpenseDocumentCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ExpenseDocument",
		validation:"_ValidationResult"
	},
	ExpenseDocumentDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ExpenseDocument"
	},
	ExpenseDocumentUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ExpenseDocument",
		validation:"_ValidationResult"
	},
	ExpenseDocumentUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ExpenseDocument",
		validation:"_ValidationResult"
	},
	RevenuePredictionCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RevenuePrediction",
		validation:"_ValidationResult"
	},
	RevenuePredictionDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RevenuePrediction"
	},
	RevenuePredictionUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RevenuePrediction",
		validation:"_ValidationResult"
	},
	RevenuePredictionUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RevenuePrediction",
		validation:"_ValidationResult"
	},
	RevenuePredictionChangeCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RevenuePredictionChange",
		validation:"_ValidationResult"
	},
	RevenuePredictionChangeDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RevenuePredictionChange"
	},
	RevenuePredictionChangeUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RevenuePredictionChange",
		validation:"_ValidationResult"
	},
	RevenuePredictionChangeUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RevenuePredictionChange",
		validation:"_ValidationResult"
	},
	FileCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"File",
		validation:"_ValidationResult"
	},
	FileDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"File"
	},
	FileUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"File",
		validation:"_ValidationResult"
	},
	FileUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"File",
		validation:"_ValidationResult"
	},
	LineCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Line",
		validation:"_ValidationResult"
	},
	LineDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Line"
	},
	LineUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Line",
		validation:"_ValidationResult"
	},
	LineUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Line",
		validation:"_ValidationResult"
	},
	FinancesBalanceItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FinancesBalanceItem",
		validation:"_ValidationResult"
	},
	FinancesBalanceItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FinancesBalanceItem"
	},
	FinancesBalanceItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FinancesBalanceItem",
		validation:"_ValidationResult"
	},
	FinancesBalanceItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FinancesBalanceItem",
		validation:"_ValidationResult"
	},
	WoltDriveDeliveryCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"WoltDriveDelivery",
		validation:"_ValidationResult"
	},
	WoltDriveDeliveryDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"WoltDriveDelivery"
	},
	WoltDriveDeliveryUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"WoltDriveDelivery",
		validation:"_ValidationResult"
	},
	WoltDriveDeliveryUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"WoltDriveDelivery",
		validation:"_ValidationResult"
	},
	MutationTransaction:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		validation:"_ValidationResult",
		createAddress:"AddressCreateResult",
		deleteAddress:"AddressDeleteResult",
		updateAddress:"AddressUpdateResult",
		upsertAddress:"AddressUpsertResult",
		createCountry:"CountryCreateResult",
		deleteCountry:"CountryDeleteResult",
		updateCountry:"CountryUpdateResult",
		upsertCountry:"CountryUpsertResult",
		createChannel:"ChannelCreateResult",
		deleteChannel:"ChannelDeleteResult",
		updateChannel:"ChannelUpdateResult",
		upsertChannel:"ChannelUpsertResult",
		createChannelPayment:"ChannelPaymentCreateResult",
		deleteChannelPayment:"ChannelPaymentDeleteResult",
		updateChannelPayment:"ChannelPaymentUpdateResult",
		upsertChannelPayment:"ChannelPaymentUpsertResult",
		createChannelDelivery:"ChannelDeliveryCreateResult",
		deleteChannelDelivery:"ChannelDeliveryDeleteResult",
		updateChannelDelivery:"ChannelDeliveryUpdateResult",
		upsertChannelDelivery:"ChannelDeliveryUpsertResult",
		createCustomer:"CustomerCreateResult",
		deleteCustomer:"CustomerDeleteResult",
		updateCustomer:"CustomerUpdateResult",
		upsertCustomer:"CustomerUpsertResult",
		createCustomerCredit:"CustomerCreditCreateResult",
		deleteCustomerCredit:"CustomerCreditDeleteResult",
		updateCustomerCredit:"CustomerCreditUpdateResult",
		upsertCustomerCredit:"CustomerCreditUpsertResult",
		createCustomerGroup:"CustomerGroupCreateResult",
		deleteCustomerGroup:"CustomerGroupDeleteResult",
		updateCustomerGroup:"CustomerGroupUpdateResult",
		upsertCustomerGroup:"CustomerGroupUpsertResult",
		createCustomerPaymentMethod:"CustomerPaymentMethodCreateResult",
		deleteCustomerPaymentMethod:"CustomerPaymentMethodDeleteResult",
		updateCustomerPaymentMethod:"CustomerPaymentMethodUpdateResult",
		upsertCustomerPaymentMethod:"CustomerPaymentMethodUpsertResult",
		createDeliveryMethod:"DeliveryMethodCreateResult",
		deleteDeliveryMethod:"DeliveryMethodDeleteResult",
		updateDeliveryMethod:"DeliveryMethodUpdateResult",
		upsertDeliveryMethod:"DeliveryMethodUpsertResult",
		createOrder:"OrderCreateResult",
		deleteOrder:"OrderDeleteResult",
		updateOrder:"OrderUpdateResult",
		upsertOrder:"OrderUpsertResult",
		createOrderDiscount:"OrderDiscountCreateResult",
		deleteOrderDiscount:"OrderDiscountDeleteResult",
		updateOrderDiscount:"OrderDiscountUpdateResult",
		upsertOrderDiscount:"OrderDiscountUpsertResult",
		createOrderPayment:"OrderPaymentCreateResult",
		deleteOrderPayment:"OrderPaymentDeleteResult",
		updateOrderPayment:"OrderPaymentUpdateResult",
		upsertOrderPayment:"OrderPaymentUpsertResult",
		createOrderDelivery:"OrderDeliveryCreateResult",
		deleteOrderDelivery:"OrderDeliveryDeleteResult",
		updateOrderDelivery:"OrderDeliveryUpdateResult",
		upsertOrderDelivery:"OrderDeliveryUpsertResult",
		createOrderItem:"OrderItemCreateResult",
		deleteOrderItem:"OrderItemDeleteResult",
		updateOrderItem:"OrderItemUpdateResult",
		upsertOrderItem:"OrderItemUpsertResult",
		createPaymentMethod:"PaymentMethodCreateResult",
		deletePaymentMethod:"PaymentMethodDeleteResult",
		updatePaymentMethod:"PaymentMethodUpdateResult",
		upsertPaymentMethod:"PaymentMethodUpsertResult",
		createVatRate:"VatRateCreateResult",
		deleteVatRate:"VatRateDeleteResult",
		updateVatRate:"VatRateUpdateResult",
		upsertVatRate:"VatRateUpsertResult",
		createProduct:"ProductCreateResult",
		deleteProduct:"ProductDeleteResult",
		updateProduct:"ProductUpdateResult",
		upsertProduct:"ProductUpsertResult",
		createProductStock:"ProductStockCreateResult",
		deleteProductStock:"ProductStockDeleteResult",
		updateProductStock:"ProductStockUpdateResult",
		upsertProductStock:"ProductStockUpsertResult",
		createProductPacking:"ProductPackingCreateResult",
		deleteProductPacking:"ProductPackingDeleteResult",
		updateProductPacking:"ProductPackingUpdateResult",
		upsertProductPacking:"ProductPackingUpsertResult",
		createProductGroupPrice:"ProductGroupPriceCreateResult",
		deleteProductGroupPrice:"ProductGroupPriceDeleteResult",
		updateProductGroupPrice:"ProductGroupPriceUpdateResult",
		upsertProductGroupPrice:"ProductGroupPriceUpsertResult",
		createProductRecipe:"ProductRecipeCreateResult",
		deleteProductRecipe:"ProductRecipeDeleteResult",
		updateProductRecipe:"ProductRecipeUpdateResult",
		upsertProductRecipe:"ProductRecipeUpsertResult",
		createProductCategory:"ProductCategoryCreateResult",
		deleteProductCategory:"ProductCategoryDeleteResult",
		updateProductCategory:"ProductCategoryUpdateResult",
		upsertProductCategory:"ProductCategoryUpsertResult",
		createStore:"StoreCreateResult",
		deleteStore:"StoreDeleteResult",
		updateStore:"StoreUpdateResult",
		upsertStore:"StoreUpsertResult",
		createTag:"TagCreateResult",
		deleteTag:"TagDeleteResult",
		updateTag:"TagUpdateResult",
		upsertTag:"TagUpsertResult",
		createImage:"ImageCreateResult",
		deleteImage:"ImageDeleteResult",
		updateImage:"ImageUpdateResult",
		upsertImage:"ImageUpsertResult",
		createBusinessCategory:"BusinessCategoryCreateResult",
		deleteBusinessCategory:"BusinessCategoryDeleteResult",
		updateBusinessCategory:"BusinessCategoryUpdateResult",
		upsertBusinessCategory:"BusinessCategoryUpsertResult",
		createProductList:"ProductListCreateResult",
		deleteProductList:"ProductListDeleteResult",
		updateProductList:"ProductListUpdateResult",
		upsertProductList:"ProductListUpsertResult",
		createProductListItem:"ProductListItemCreateResult",
		deleteProductListItem:"ProductListItemDeleteResult",
		updateProductListItem:"ProductListItemUpdateResult",
		upsertProductListItem:"ProductListItemUpsertResult",
		createProductCategoryList:"ProductCategoryListCreateResult",
		deleteProductCategoryList:"ProductCategoryListDeleteResult",
		updateProductCategoryList:"ProductCategoryListUpdateResult",
		upsertProductCategoryList:"ProductCategoryListUpsertResult",
		createProductCategoryListItem:"ProductCategoryListItemCreateResult",
		deleteProductCategoryListItem:"ProductCategoryListItemDeleteResult",
		updateProductCategoryListItem:"ProductCategoryListItemUpdateResult",
		upsertProductCategoryListItem:"ProductCategoryListItemUpsertResult",
		createBusinessCategoryLocale:"BusinessCategoryLocaleCreateResult",
		deleteBusinessCategoryLocale:"BusinessCategoryLocaleDeleteResult",
		updateBusinessCategoryLocale:"BusinessCategoryLocaleUpdateResult",
		upsertBusinessCategoryLocale:"BusinessCategoryLocaleUpsertResult",
		createLocale:"LocaleCreateResult",
		deleteLocale:"LocaleDeleteResult",
		updateLocale:"LocaleUpdateResult",
		upsertLocale:"LocaleUpsertResult",
		createProductCategoryListLocale:"ProductCategoryListLocaleCreateResult",
		deleteProductCategoryListLocale:"ProductCategoryListLocaleDeleteResult",
		updateProductCategoryListLocale:"ProductCategoryListLocaleUpdateResult",
		upsertProductCategoryListLocale:"ProductCategoryListLocaleUpsertResult",
		createCustomerName:"CustomerNameCreateResult",
		deleteCustomerName:"CustomerNameDeleteResult",
		updateCustomerName:"CustomerNameUpdateResult",
		upsertCustomerName:"CustomerNameUpsertResult",
		createCustomerAlias:"CustomerAliasCreateResult",
		deleteCustomerAlias:"CustomerAliasDeleteResult",
		updateCustomerAlias:"CustomerAliasUpdateResult",
		upsertCustomerAlias:"CustomerAliasUpsertResult",
		createProductIngredientItem:"ProductIngredientItemCreateResult",
		deleteProductIngredientItem:"ProductIngredientItemDeleteResult",
		updateProductIngredientItem:"ProductIngredientItemUpdateResult",
		upsertProductIngredientItem:"ProductIngredientItemUpsertResult",
		createProductIngredientItemQuantity:"ProductIngredientItemQuantityCreateResult",
		deleteProductIngredientItemQuantity:"ProductIngredientItemQuantityDeleteResult",
		updateProductIngredientItemQuantity:"ProductIngredientItemQuantityUpdateResult",
		upsertProductIngredientItemQuantity:"ProductIngredientItemQuantityUpsertResult",
		createProductIngredientItemQuantityUnit:"ProductIngredientItemQuantityUnitCreateResult",
		deleteProductIngredientItemQuantityUnit:"ProductIngredientItemQuantityUnitDeleteResult",
		updateProductIngredientItemQuantityUnit:"ProductIngredientItemQuantityUnitUpdateResult",
		upsertProductIngredientItemQuantityUnit:"ProductIngredientItemQuantityUnitUpsertResult",
		createProductIngredient:"ProductIngredientCreateResult",
		deleteProductIngredient:"ProductIngredientDeleteResult",
		updateProductIngredient:"ProductIngredientUpdateResult",
		upsertProductIngredient:"ProductIngredientUpsertResult",
		createCustomerIngredientRating:"CustomerIngredientRatingCreateResult",
		deleteCustomerIngredientRating:"CustomerIngredientRatingDeleteResult",
		updateCustomerIngredientRating:"CustomerIngredientRatingUpdateResult",
		upsertCustomerIngredientRating:"CustomerIngredientRatingUpsertResult",
		createProductIngredientRating:"ProductIngredientRatingCreateResult",
		deleteProductIngredientRating:"ProductIngredientRatingDeleteResult",
		updateProductIngredientRating:"ProductIngredientRatingUpdateResult",
		upsertProductIngredientRating:"ProductIngredientRatingUpsertResult",
		createProductIngredientLocale:"ProductIngredientLocaleCreateResult",
		deleteProductIngredientLocale:"ProductIngredientLocaleDeleteResult",
		updateProductIngredientLocale:"ProductIngredientLocaleUpdateResult",
		upsertProductIngredientLocale:"ProductIngredientLocaleUpsertResult",
		createOrderRecurrence:"OrderRecurrenceCreateResult",
		deleteOrderRecurrence:"OrderRecurrenceDeleteResult",
		updateOrderRecurrence:"OrderRecurrenceUpdateResult",
		upsertOrderRecurrence:"OrderRecurrenceUpsertResult",
		createOrderRecurrenceLocale:"OrderRecurrenceLocaleCreateResult",
		deleteOrderRecurrenceLocale:"OrderRecurrenceLocaleDeleteResult",
		updateOrderRecurrenceLocale:"OrderRecurrenceLocaleUpdateResult",
		upsertOrderRecurrenceLocale:"OrderRecurrenceLocaleUpsertResult",
		createBusinessCustomer:"BusinessCustomerCreateResult",
		deleteBusinessCustomer:"BusinessCustomerDeleteResult",
		updateBusinessCustomer:"BusinessCustomerUpdateResult",
		upsertBusinessCustomer:"BusinessCustomerUpsertResult",
		createPointOfSale:"PointOfSaleCreateResult",
		deletePointOfSale:"PointOfSaleDeleteResult",
		updatePointOfSale:"PointOfSaleUpdateResult",
		upsertPointOfSale:"PointOfSaleUpsertResult",
		createStaff:"StaffCreateResult",
		deleteStaff:"StaffDeleteResult",
		updateStaff:"StaffUpdateResult",
		upsertStaff:"StaffUpsertResult",
		createBlog:"BlogCreateResult",
		deleteBlog:"BlogDeleteResult",
		updateBlog:"BlogUpdateResult",
		upsertBlog:"BlogUpsertResult",
		createBlogLocale:"BlogLocaleCreateResult",
		deleteBlogLocale:"BlogLocaleDeleteResult",
		updateBlogLocale:"BlogLocaleUpdateResult",
		upsertBlogLocale:"BlogLocaleUpsertResult",
		createBlogPost:"BlogPostCreateResult",
		deleteBlogPost:"BlogPostDeleteResult",
		updateBlogPost:"BlogPostUpdateResult",
		upsertBlogPost:"BlogPostUpsertResult",
		createBlogPostLocale:"BlogPostLocaleCreateResult",
		deleteBlogPostLocale:"BlogPostLocaleDeleteResult",
		updateBlogPostLocale:"BlogPostLocaleUpdateResult",
		upsertBlogPostLocale:"BlogPostLocaleUpsertResult",
		createColorPallete:"ColorPalleteCreateResult",
		deleteColorPallete:"ColorPalleteDeleteResult",
		updateColorPallete:"ColorPalleteUpdateResult",
		upsertColorPallete:"ColorPalleteUpsertResult",
		createContent:"ContentCreateResult",
		deleteContent:"ContentDeleteResult",
		updateContent:"ContentUpdateResult",
		upsertContent:"ContentUpsertResult",
		createContentBlock:"ContentBlockCreateResult",
		deleteContentBlock:"ContentBlockDeleteResult",
		updateContentBlock:"ContentBlockUpdateResult",
		upsertContentBlock:"ContentBlockUpsertResult",
		createContentReference:"ContentReferenceCreateResult",
		deleteContentReference:"ContentReferenceDeleteResult",
		updateContentReference:"ContentReferenceUpdateResult",
		upsertContentReference:"ContentReferenceUpsertResult",
		createBlogPostList:"BlogPostListCreateResult",
		deleteBlogPostList:"BlogPostListDeleteResult",
		updateBlogPostList:"BlogPostListUpdateResult",
		upsertBlogPostList:"BlogPostListUpsertResult",
		createBlogPostListItem:"BlogPostListItemCreateResult",
		deleteBlogPostListItem:"BlogPostListItemDeleteResult",
		updateBlogPostListItem:"BlogPostListItemUpdateResult",
		upsertBlogPostListItem:"BlogPostListItemUpsertResult",
		createLinkList:"LinkListCreateResult",
		deleteLinkList:"LinkListDeleteResult",
		updateLinkList:"LinkListUpdateResult",
		upsertLinkList:"LinkListUpsertResult",
		createLinkListItem:"LinkListItemCreateResult",
		deleteLinkListItem:"LinkListItemDeleteResult",
		updateLinkListItem:"LinkListItemUpdateResult",
		upsertLinkListItem:"LinkListItemUpsertResult",
		createCover:"CoverCreateResult",
		deleteCover:"CoverDeleteResult",
		updateCover:"CoverUpdateResult",
		upsertCover:"CoverUpsertResult",
		createLink:"LinkCreateResult",
		deleteLink:"LinkDeleteResult",
		updateLink:"LinkUpdateResult",
		upsertLink:"LinkUpsertResult",
		createLinkable:"LinkableCreateResult",
		deleteLinkable:"LinkableDeleteResult",
		updateLinkable:"LinkableUpdateResult",
		upsertLinkable:"LinkableUpsertResult",
		createMedium:"MediumCreateResult",
		deleteMedium:"MediumDeleteResult",
		updateMedium:"MediumUpdateResult",
		upsertMedium:"MediumUpsertResult",
		createVideo:"VideoCreateResult",
		deleteVideo:"VideoDeleteResult",
		updateVideo:"VideoUpdateResult",
		upsertVideo:"VideoUpsertResult",
		createSeo:"SeoCreateResult",
		deleteSeo:"SeoDeleteResult",
		updateSeo:"SeoUpdateResult",
		upsertSeo:"SeoUpsertResult",
		createProtectedImage:"ProtectedImageCreateResult",
		deleteProtectedImage:"ProtectedImageDeleteResult",
		updateProtectedImage:"ProtectedImageUpdateResult",
		upsertProtectedImage:"ProtectedImageUpsertResult",
		createTranslationDomain:"TranslationDomainCreateResult",
		deleteTranslationDomain:"TranslationDomainDeleteResult",
		updateTranslationDomain:"TranslationDomainUpdateResult",
		upsertTranslationDomain:"TranslationDomainUpsertResult",
		createTranslationCatalogue:"TranslationCatalogueCreateResult",
		deleteTranslationCatalogue:"TranslationCatalogueDeleteResult",
		updateTranslationCatalogue:"TranslationCatalogueUpdateResult",
		upsertTranslationCatalogue:"TranslationCatalogueUpsertResult",
		createTranslationKey:"TranslationKeyCreateResult",
		deleteTranslationKey:"TranslationKeyDeleteResult",
		updateTranslationKey:"TranslationKeyUpdateResult",
		upsertTranslationKey:"TranslationKeyUpsertResult",
		createTranslationValue:"TranslationValueCreateResult",
		deleteTranslationValue:"TranslationValueDeleteResult",
		updateTranslationValue:"TranslationValueUpdateResult",
		upsertTranslationValue:"TranslationValueUpsertResult",
		createTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierCreateResult",
		deleteTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierDeleteResult",
		updateTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierUpdateResult",
		upsertTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierUpsertResult",
		createSocialsAndApps:"SocialsAndAppsCreateResult",
		deleteSocialsAndApps:"SocialsAndAppsDeleteResult",
		updateSocialsAndApps:"SocialsAndAppsUpdateResult",
		upsertSocialsAndApps:"SocialsAndAppsUpsertResult",
		createProductGrid:"ProductGridCreateResult",
		deleteProductGrid:"ProductGridDeleteResult",
		updateProductGrid:"ProductGridUpdateResult",
		upsertProductGrid:"ProductGridUpsertResult",
		createProductGridItem:"ProductGridItemCreateResult",
		deleteProductGridItem:"ProductGridItemDeleteResult",
		updateProductGridItem:"ProductGridItemUpdateResult",
		upsertProductGridItem:"ProductGridItemUpsertResult",
		createGallery:"GalleryCreateResult",
		deleteGallery:"GalleryDeleteResult",
		updateGallery:"GalleryUpdateResult",
		upsertGallery:"GalleryUpsertResult",
		createGalleryItem:"GalleryItemCreateResult",
		deleteGalleryItem:"GalleryItemDeleteResult",
		updateGalleryItem:"GalleryItemUpdateResult",
		upsertGalleryItem:"GalleryItemUpsertResult",
		createHero:"HeroCreateResult",
		deleteHero:"HeroDeleteResult",
		updateHero:"HeroUpdateResult",
		upsertHero:"HeroUpsertResult",
		createSiteMenu:"SiteMenuCreateResult",
		deleteSiteMenu:"SiteMenuDeleteResult",
		updateSiteMenu:"SiteMenuUpdateResult",
		upsertSiteMenu:"SiteMenuUpsertResult",
		createMenuLocale:"MenuLocaleCreateResult",
		deleteMenuLocale:"MenuLocaleDeleteResult",
		updateMenuLocale:"MenuLocaleUpdateResult",
		upsertMenuLocale:"MenuLocaleUpsertResult",
		createMenuItem:"MenuItemCreateResult",
		deleteMenuItem:"MenuItemDeleteResult",
		updateMenuItem:"MenuItemUpdateResult",
		upsertMenuItem:"MenuItemUpsertResult",
		createPage:"PageCreateResult",
		deletePage:"PageDeleteResult",
		updatePage:"PageUpdateResult",
		upsertPage:"PageUpsertResult",
		createPageLocale:"PageLocaleCreateResult",
		deletePageLocale:"PageLocaleDeleteResult",
		updatePageLocale:"PageLocaleUpdateResult",
		upsertPageLocale:"PageLocaleUpsertResult",
		createWikiPage:"WikiPageCreateResult",
		deleteWikiPage:"WikiPageDeleteResult",
		updateWikiPage:"WikiPageUpdateResult",
		upsertWikiPage:"WikiPageUpsertResult",
		createMenuSubitem:"MenuSubitemCreateResult",
		deleteMenuSubitem:"MenuSubitemDeleteResult",
		updateMenuSubitem:"MenuSubitemUpdateResult",
		upsertMenuSubitem:"MenuSubitemUpsertResult",
		createMenuLinkList:"MenuLinkListCreateResult",
		deleteMenuLinkList:"MenuLinkListDeleteResult",
		updateMenuLinkList:"MenuLinkListUpdateResult",
		upsertMenuLinkList:"MenuLinkListUpsertResult",
		createMenuLinkItem:"MenuLinkItemCreateResult",
		deleteMenuLinkItem:"MenuLinkItemDeleteResult",
		updateMenuLinkItem:"MenuLinkItemUpdateResult",
		upsertMenuLinkItem:"MenuLinkItemUpsertResult",
		createMenuProducts:"MenuProductsCreateResult",
		deleteMenuProducts:"MenuProductsDeleteResult",
		updateMenuProducts:"MenuProductsUpdateResult",
		upsertMenuProducts:"MenuProductsUpsertResult",
		createMenuDelivery:"MenuDeliveryCreateResult",
		deleteMenuDelivery:"MenuDeliveryDeleteResult",
		updateMenuDelivery:"MenuDeliveryUpdateResult",
		upsertMenuDelivery:"MenuDeliveryUpsertResult",
		createMenuContact:"MenuContactCreateResult",
		deleteMenuContact:"MenuContactDeleteResult",
		updateMenuContact:"MenuContactUpdateResult",
		upsertMenuContact:"MenuContactUpsertResult",
		createDeadlineTemplate:"DeadlineTemplateCreateResult",
		deleteDeadlineTemplate:"DeadlineTemplateDeleteResult",
		updateDeadlineTemplate:"DeadlineTemplateUpdateResult",
		upsertDeadlineTemplate:"DeadlineTemplateUpsertResult",
		createEmployeeQueue:"EmployeeQueueCreateResult",
		deleteEmployeeQueue:"EmployeeQueueDeleteResult",
		updateEmployeeQueue:"EmployeeQueueUpdateResult",
		upsertEmployeeQueue:"EmployeeQueueUpsertResult",
		createTimetableDay:"TimetableDayCreateResult",
		deleteTimetableDay:"TimetableDayDeleteResult",
		updateTimetableDay:"TimetableDayUpdateResult",
		upsertTimetableDay:"TimetableDayUpsertResult",
		createTimetableEmployeeRole:"TimetableEmployeeRoleCreateResult",
		deleteTimetableEmployeeRole:"TimetableEmployeeRoleDeleteResult",
		updateTimetableEmployeeRole:"TimetableEmployeeRoleUpdateResult",
		upsertTimetableEmployeeRole:"TimetableEmployeeRoleUpsertResult",
		createTimetableShift:"TimetableShiftCreateResult",
		deleteTimetableShift:"TimetableShiftDeleteResult",
		updateTimetableShift:"TimetableShiftUpdateResult",
		upsertTimetableShift:"TimetableShiftUpsertResult",
		createTimetableShiftGroup:"TimetableShiftGroupCreateResult",
		deleteTimetableShiftGroup:"TimetableShiftGroupDeleteResult",
		updateTimetableShiftGroup:"TimetableShiftGroupUpdateResult",
		upsertTimetableShiftGroup:"TimetableShiftGroupUpsertResult",
		createTimetableShiftPosition:"TimetableShiftPositionCreateResult",
		deleteTimetableShiftPosition:"TimetableShiftPositionDeleteResult",
		updateTimetableShiftPosition:"TimetableShiftPositionUpdateResult",
		upsertTimetableShiftPosition:"TimetableShiftPositionUpsertResult",
		createTimetableTemplate:"TimetableTemplateCreateResult",
		deleteTimetableTemplate:"TimetableTemplateDeleteResult",
		updateTimetableTemplate:"TimetableTemplateUpdateResult",
		upsertTimetableTemplate:"TimetableTemplateUpsertResult",
		createCart:"CartCreateResult",
		deleteCart:"CartDeleteResult",
		updateCart:"CartUpdateResult",
		upsertCart:"CartUpsertResult",
		createCartItem:"CartItemCreateResult",
		deleteCartItem:"CartItemDeleteResult",
		updateCartItem:"CartItemUpdateResult",
		upsertCartItem:"CartItemUpsertResult",
		createEmployeeQueueItem:"EmployeeQueueItemCreateResult",
		deleteEmployeeQueueItem:"EmployeeQueueItemDeleteResult",
		updateEmployeeQueueItem:"EmployeeQueueItemUpdateResult",
		upsertEmployeeQueueItem:"EmployeeQueueItemUpsertResult",
		createApplication:"ApplicationCreateResult",
		deleteApplication:"ApplicationDeleteResult",
		updateApplication:"ApplicationUpdateResult",
		upsertApplication:"ApplicationUpsertResult",
		createApplicationShortcutList:"ApplicationShortcutListCreateResult",
		deleteApplicationShortcutList:"ApplicationShortcutListDeleteResult",
		updateApplicationShortcutList:"ApplicationShortcutListUpdateResult",
		upsertApplicationShortcutList:"ApplicationShortcutListUpsertResult",
		createApplicationShortcutListItem:"ApplicationShortcutListItemCreateResult",
		deleteApplicationShortcutListItem:"ApplicationShortcutListItemDeleteResult",
		updateApplicationShortcutListItem:"ApplicationShortcutListItemUpdateResult",
		upsertApplicationShortcutListItem:"ApplicationShortcutListItemUpsertResult",
		createProductBanner:"ProductBannerCreateResult",
		deleteProductBanner:"ProductBannerDeleteResult",
		updateProductBanner:"ProductBannerUpdateResult",
		upsertProductBanner:"ProductBannerUpsertResult",
		createProductBannerItem:"ProductBannerItemCreateResult",
		deleteProductBannerItem:"ProductBannerItemDeleteResult",
		updateProductBannerItem:"ProductBannerItemUpdateResult",
		upsertProductBannerItem:"ProductBannerItemUpsertResult",
		createProductBannerList:"ProductBannerListCreateResult",
		deleteProductBannerList:"ProductBannerListDeleteResult",
		updateProductBannerList:"ProductBannerListUpdateResult",
		upsertProductBannerList:"ProductBannerListUpsertResult",
		createBartender:"BartenderCreateResult",
		deleteBartender:"BartenderDeleteResult",
		updateBartender:"BartenderUpdateResult",
		upsertBartender:"BartenderUpsertResult",
		createBusinessToBusinessManager:"BusinessToBusinessManagerCreateResult",
		deleteBusinessToBusinessManager:"BusinessToBusinessManagerDeleteResult",
		updateBusinessToBusinessManager:"BusinessToBusinessManagerUpdateResult",
		upsertBusinessToBusinessManager:"BusinessToBusinessManagerUpsertResult",
		createCleaner:"CleanerCreateResult",
		deleteCleaner:"CleanerDeleteResult",
		updateCleaner:"CleanerUpdateResult",
		upsertCleaner:"CleanerUpsertResult",
		createCourier:"CourierCreateResult",
		deleteCourier:"CourierDeleteResult",
		updateCourier:"CourierUpdateResult",
		upsertCourier:"CourierUpsertResult",
		createShiftsManager:"ShiftsManagerCreateResult",
		deleteShiftsManager:"ShiftsManagerDeleteResult",
		updateShiftsManager:"ShiftsManagerUpdateResult",
		upsertShiftsManager:"ShiftsManagerUpsertResult",
		createUser:"UserCreateResult",
		deleteUser:"UserDeleteResult",
		updateUser:"UserUpdateResult",
		upsertUser:"UserUpsertResult",
		createShiftsProfile:"ShiftsProfileCreateResult",
		deleteShiftsProfile:"ShiftsProfileDeleteResult",
		updateShiftsProfile:"ShiftsProfileUpdateResult",
		upsertShiftsProfile:"ShiftsProfileUpsertResult",
		createProductIngredientCategory:"ProductIngredientCategoryCreateResult",
		deleteProductIngredientCategory:"ProductIngredientCategoryDeleteResult",
		updateProductIngredientCategory:"ProductIngredientCategoryUpdateResult",
		upsertProductIngredientCategory:"ProductIngredientCategoryUpsertResult",
		createProductIngredientCategoryLocale:"ProductIngredientCategoryLocaleCreateResult",
		deleteProductIngredientCategoryLocale:"ProductIngredientCategoryLocaleDeleteResult",
		updateProductIngredientCategoryLocale:"ProductIngredientCategoryLocaleUpdateResult",
		upsertProductIngredientCategoryLocale:"ProductIngredientCategoryLocaleUpsertResult",
		createStocksManager:"StocksManagerCreateResult",
		deleteStocksManager:"StocksManagerDeleteResult",
		updateStocksManager:"StocksManagerUpdateResult",
		upsertStocksManager:"StocksManagerUpsertResult",
		createDeliveryRoute:"DeliveryRouteCreateResult",
		deleteDeliveryRoute:"DeliveryRouteDeleteResult",
		updateDeliveryRoute:"DeliveryRouteUpdateResult",
		upsertDeliveryRoute:"DeliveryRouteUpsertResult",
		createDeliveryWaypoint:"DeliveryWaypointCreateResult",
		deleteDeliveryWaypoint:"DeliveryWaypointDeleteResult",
		updateDeliveryWaypoint:"DeliveryWaypointUpdateResult",
		upsertDeliveryWaypoint:"DeliveryWaypointUpsertResult",
		createAllergen:"AllergenCreateResult",
		deleteAllergen:"AllergenDeleteResult",
		updateAllergen:"AllergenUpdateResult",
		upsertAllergen:"AllergenUpsertResult",
		createAllergenLocale:"AllergenLocaleCreateResult",
		deleteAllergenLocale:"AllergenLocaleDeleteResult",
		updateAllergenLocale:"AllergenLocaleUpdateResult",
		upsertAllergenLocale:"AllergenLocaleUpsertResult",
		createGps:"GpsCreateResult",
		deleteGps:"GpsDeleteResult",
		updateGps:"GpsUpdateResult",
		upsertGps:"GpsUpsertResult",
		createWeekHours:"WeekHoursCreateResult",
		deleteWeekHours:"WeekHoursDeleteResult",
		updateWeekHours:"WeekHoursUpdateResult",
		upsertWeekHours:"WeekHoursUpsertResult",
		createPreparedIngredientQuantity:"PreparedIngredientQuantityCreateResult",
		deletePreparedIngredientQuantity:"PreparedIngredientQuantityDeleteResult",
		updatePreparedIngredientQuantity:"PreparedIngredientQuantityUpdateResult",
		upsertPreparedIngredientQuantity:"PreparedIngredientQuantityUpsertResult",
		createPreparedRecipeQuantity:"PreparedRecipeQuantityCreateResult",
		deletePreparedRecipeQuantity:"PreparedRecipeQuantityDeleteResult",
		updatePreparedRecipeQuantity:"PreparedRecipeQuantityUpdateResult",
		upsertPreparedRecipeQuantity:"PreparedRecipeQuantityUpsertResult",
		createInternalOrder:"InternalOrderCreateResult",
		deleteInternalOrder:"InternalOrderDeleteResult",
		updateInternalOrder:"InternalOrderUpdateResult",
		upsertInternalOrder:"InternalOrderUpsertResult",
		createInternalOrderItem:"InternalOrderItemCreateResult",
		deleteInternalOrderItem:"InternalOrderItemDeleteResult",
		updateInternalOrderItem:"InternalOrderItemUpdateResult",
		upsertInternalOrderItem:"InternalOrderItemUpsertResult",
		createPreparedPackingQuantity:"PreparedPackingQuantityCreateResult",
		deletePreparedPackingQuantity:"PreparedPackingQuantityDeleteResult",
		updatePreparedPackingQuantity:"PreparedPackingQuantityUpdateResult",
		upsertPreparedPackingQuantity:"PreparedPackingQuantityUpsertResult",
		createCourierManager:"CourierManagerCreateResult",
		deleteCourierManager:"CourierManagerDeleteResult",
		updateCourierManager:"CourierManagerUpdateResult",
		upsertCourierManager:"CourierManagerUpsertResult",
		createDeliveryZone:"DeliveryZoneCreateResult",
		deleteDeliveryZone:"DeliveryZoneDeleteResult",
		updateDeliveryZone:"DeliveryZoneUpdateResult",
		upsertDeliveryZone:"DeliveryZoneUpsertResult",
		createDeliveryTimelinePreset:"DeliveryTimelinePresetCreateResult",
		deleteDeliveryTimelinePreset:"DeliveryTimelinePresetDeleteResult",
		updateDeliveryTimelinePreset:"DeliveryTimelinePresetUpdateResult",
		upsertDeliveryTimelinePreset:"DeliveryTimelinePresetUpsertResult",
		createOrderDeliveryTimeline:"OrderDeliveryTimelineCreateResult",
		deleteOrderDeliveryTimeline:"OrderDeliveryTimelineDeleteResult",
		updateOrderDeliveryTimeline:"OrderDeliveryTimelineUpdateResult",
		upsertOrderDeliveryTimeline:"OrderDeliveryTimelineUpsertResult",
		createOrderEvent:"OrderEventCreateResult",
		deleteOrderEvent:"OrderEventDeleteResult",
		updateOrderEvent:"OrderEventUpdateResult",
		upsertOrderEvent:"OrderEventUpsertResult",
		createLiftagoRide:"LiftagoRideCreateResult",
		deleteLiftagoRide:"LiftagoRideDeleteResult",
		updateLiftagoRide:"LiftagoRideUpdateResult",
		upsertLiftagoRide:"LiftagoRideUpsertResult",
		createInvoice:"InvoiceCreateResult",
		deleteInvoice:"InvoiceDeleteResult",
		updateInvoice:"InvoiceUpdateResult",
		upsertInvoice:"InvoiceUpsertResult",
		createInvoicingPlan:"InvoicingPlanCreateResult",
		deleteInvoicingPlan:"InvoicingPlanDeleteResult",
		updateInvoicingPlan:"InvoicingPlanUpdateResult",
		upsertInvoicingPlan:"InvoicingPlanUpsertResult",
		createProductPackingLocale:"ProductPackingLocaleCreateResult",
		deleteProductPackingLocale:"ProductPackingLocaleDeleteResult",
		updateProductPackingLocale:"ProductPackingLocaleUpdateResult",
		upsertProductPackingLocale:"ProductPackingLocaleUpsertResult",
		createProductLocale:"ProductLocaleCreateResult",
		deleteProductLocale:"ProductLocaleDeleteResult",
		updateProductLocale:"ProductLocaleUpdateResult",
		upsertProductLocale:"ProductLocaleUpsertResult",
		createProductRecipeLocale:"ProductRecipeLocaleCreateResult",
		deleteProductRecipeLocale:"ProductRecipeLocaleDeleteResult",
		updateProductRecipeLocale:"ProductRecipeLocaleUpdateResult",
		upsertProductRecipeLocale:"ProductRecipeLocaleUpsertResult",
		createUserDevice:"UserDeviceCreateResult",
		deleteUserDevice:"UserDeviceDeleteResult",
		updateUserDevice:"UserDeviceUpdateResult",
		upsertUserDevice:"UserDeviceUpsertResult",
		createProtectedAction:"ProtectedActionCreateResult",
		deleteProtectedAction:"ProtectedActionDeleteResult",
		updateProtectedAction:"ProtectedActionUpdateResult",
		upsertProtectedAction:"ProtectedActionUpsertResult",
		createPicker:"PickerCreateResult",
		deletePicker:"PickerDeleteResult",
		updatePicker:"PickerUpdateResult",
		upsertPicker:"PickerUpsertResult",
		createTimetableTemplateStaffOptions:"TimetableTemplateStaffOptionsCreateResult",
		deleteTimetableTemplateStaffOptions:"TimetableTemplateStaffOptionsDeleteResult",
		updateTimetableTemplateStaffOptions:"TimetableTemplateStaffOptionsUpdateResult",
		upsertTimetableTemplateStaffOptions:"TimetableTemplateStaffOptionsUpsertResult",
		createShoppingList:"ShoppingListCreateResult",
		deleteShoppingList:"ShoppingListDeleteResult",
		updateShoppingList:"ShoppingListUpdateResult",
		upsertShoppingList:"ShoppingListUpsertResult",
		createSuppliesPurchase:"SuppliesPurchaseCreateResult",
		deleteSuppliesPurchase:"SuppliesPurchaseDeleteResult",
		updateSuppliesPurchase:"SuppliesPurchaseUpdateResult",
		upsertSuppliesPurchase:"SuppliesPurchaseUpsertResult",
		createInvoicingPreset:"InvoicingPresetCreateResult",
		deleteInvoicingPreset:"InvoicingPresetDeleteResult",
		updateInvoicingPreset:"InvoicingPresetUpdateResult",
		upsertInvoicingPreset:"InvoicingPresetUpsertResult",
		createLogRecord:"LogRecordCreateResult",
		deleteLogRecord:"LogRecordDeleteResult",
		updateLogRecord:"LogRecordUpdateResult",
		upsertLogRecord:"LogRecordUpsertResult",
		createBillingSubject:"BillingSubjectCreateResult",
		deleteBillingSubject:"BillingSubjectDeleteResult",
		updateBillingSubject:"BillingSubjectUpdateResult",
		upsertBillingSubject:"BillingSubjectUpsertResult",
		createShoppingListItem:"ShoppingListItemCreateResult",
		deleteShoppingListItem:"ShoppingListItemDeleteResult",
		updateShoppingListItem:"ShoppingListItemUpdateResult",
		upsertShoppingListItem:"ShoppingListItemUpsertResult",
		createSuppliesPurchaseItem:"SuppliesPurchaseItemCreateResult",
		deleteSuppliesPurchaseItem:"SuppliesPurchaseItemDeleteResult",
		updateSuppliesPurchaseItem:"SuppliesPurchaseItemUpdateResult",
		upsertSuppliesPurchaseItem:"SuppliesPurchaseItemUpsertResult",
		createCustomerCreditTransaction:"CustomerCreditTransactionCreateResult",
		deleteCustomerCreditTransaction:"CustomerCreditTransactionDeleteResult",
		updateCustomerCreditTransaction:"CustomerCreditTransactionUpdateResult",
		upsertCustomerCreditTransaction:"CustomerCreditTransactionUpsertResult",
		createVirtualProduct:"VirtualProductCreateResult",
		deleteVirtualProduct:"VirtualProductDeleteResult",
		updateVirtualProduct:"VirtualProductUpdateResult",
		upsertVirtualProduct:"VirtualProductUpsertResult",
		createVirtualProductEffect:"VirtualProductEffectCreateResult",
		deleteVirtualProductEffect:"VirtualProductEffectDeleteResult",
		updateVirtualProductEffect:"VirtualProductEffectUpdateResult",
		upsertVirtualProductEffect:"VirtualProductEffectUpsertResult",
		createEmploymentInformation:"EmploymentInformationCreateResult",
		deleteEmploymentInformation:"EmploymentInformationDeleteResult",
		updateEmploymentInformation:"EmploymentInformationUpdateResult",
		upsertEmploymentInformation:"EmploymentInformationUpsertResult",
		createRemunerationProfile:"RemunerationProfileCreateResult",
		deleteRemunerationProfile:"RemunerationProfileDeleteResult",
		updateRemunerationProfile:"RemunerationProfileUpdateResult",
		upsertRemunerationProfile:"RemunerationProfileUpsertResult",
		createWorkMonth:"WorkMonthCreateResult",
		deleteWorkMonth:"WorkMonthDeleteResult",
		updateWorkMonth:"WorkMonthUpdateResult",
		upsertWorkMonth:"WorkMonthUpsertResult",
		createSalaryOptions:"SalaryOptionsCreateResult",
		deleteSalaryOptions:"SalaryOptionsDeleteResult",
		updateSalaryOptions:"SalaryOptionsUpdateResult",
		upsertSalaryOptions:"SalaryOptionsUpsertResult",
		createTimetableShiftSwapInfo:"TimetableShiftSwapInfoCreateResult",
		deleteTimetableShiftSwapInfo:"TimetableShiftSwapInfoDeleteResult",
		updateTimetableShiftSwapInfo:"TimetableShiftSwapInfoUpdateResult",
		upsertTimetableShiftSwapInfo:"TimetableShiftSwapInfoUpsertResult",
		createProductGridCategory:"ProductGridCategoryCreateResult",
		deleteProductGridCategory:"ProductGridCategoryDeleteResult",
		updateProductGridCategory:"ProductGridCategoryUpdateResult",
		upsertProductGridCategory:"ProductGridCategoryUpsertResult",
		createCashier:"CashierCreateResult",
		deleteCashier:"CashierDeleteResult",
		updateCashier:"CashierUpdateResult",
		upsertCashier:"CashierUpsertResult",
		createPointOfSaleCategory:"PointOfSaleCategoryCreateResult",
		deletePointOfSaleCategory:"PointOfSaleCategoryDeleteResult",
		updatePointOfSaleCategory:"PointOfSaleCategoryUpdateResult",
		upsertPointOfSaleCategory:"PointOfSaleCategoryUpsertResult",
		createPointOfSaleCategoryLocale:"PointOfSaleCategoryLocaleCreateResult",
		deletePointOfSaleCategoryLocale:"PointOfSaleCategoryLocaleDeleteResult",
		updatePointOfSaleCategoryLocale:"PointOfSaleCategoryLocaleUpdateResult",
		upsertPointOfSaleCategoryLocale:"PointOfSaleCategoryLocaleUpsertResult",
		createPointOfSaleCategoryProduct:"PointOfSaleCategoryProductCreateResult",
		deletePointOfSaleCategoryProduct:"PointOfSaleCategoryProductDeleteResult",
		updatePointOfSaleCategoryProduct:"PointOfSaleCategoryProductUpdateResult",
		upsertPointOfSaleCategoryProduct:"PointOfSaleCategoryProductUpsertResult",
		createPointOfSaleCategoryProductLocale:"PointOfSaleCategoryProductLocaleCreateResult",
		deletePointOfSaleCategoryProductLocale:"PointOfSaleCategoryProductLocaleDeleteResult",
		updatePointOfSaleCategoryProductLocale:"PointOfSaleCategoryProductLocaleUpdateResult",
		upsertPointOfSaleCategoryProductLocale:"PointOfSaleCategoryProductLocaleUpsertResult",
		createCustomerTab:"CustomerTabCreateResult",
		deleteCustomerTab:"CustomerTabDeleteResult",
		updateCustomerTab:"CustomerTabUpdateResult",
		upsertCustomerTab:"CustomerTabUpsertResult",
		createCustomerTabItem:"CustomerTabItemCreateResult",
		deleteCustomerTabItem:"CustomerTabItemDeleteResult",
		updateCustomerTabItem:"CustomerTabItemUpdateResult",
		upsertCustomerTabItem:"CustomerTabItemUpsertResult",
		createAnonymousSession:"AnonymousSessionCreateResult",
		deleteAnonymousSession:"AnonymousSessionDeleteResult",
		updateAnonymousSession:"AnonymousSessionUpdateResult",
		upsertAnonymousSession:"AnonymousSessionUpsertResult",
		createVoucher:"VoucherCreateResult",
		deleteVoucher:"VoucherDeleteResult",
		updateVoucher:"VoucherUpdateResult",
		upsertVoucher:"VoucherUpsertResult",
		createVoucherRedemption:"VoucherRedemptionCreateResult",
		deleteVoucherRedemption:"VoucherRedemptionDeleteResult",
		updateVoucherRedemption:"VoucherRedemptionUpdateResult",
		upsertVoucherRedemption:"VoucherRedemptionUpsertResult",
		createUnassignedShiftInfo:"UnassignedShiftInfoCreateResult",
		deleteUnassignedShiftInfo:"UnassignedShiftInfoDeleteResult",
		updateUnassignedShiftInfo:"UnassignedShiftInfoUpdateResult",
		upsertUnassignedShiftInfo:"UnassignedShiftInfoUpsertResult",
		createFreshingContainer:"FreshingContainerCreateResult",
		deleteFreshingContainer:"FreshingContainerDeleteResult",
		updateFreshingContainer:"FreshingContainerUpdateResult",
		upsertFreshingContainer:"FreshingContainerUpsertResult",
		createTextItem:"TextItemCreateResult",
		deleteTextItem:"TextItemDeleteResult",
		updateTextItem:"TextItemUpdateResult",
		upsertTextItem:"TextItemUpsertResult",
		createTextList:"TextListCreateResult",
		deleteTextList:"TextListDeleteResult",
		updateTextList:"TextListUpdateResult",
		upsertTextList:"TextListUpsertResult",
		createDeliveryRegions:"DeliveryRegionsCreateResult",
		deleteDeliveryRegions:"DeliveryRegionsDeleteResult",
		updateDeliveryRegions:"DeliveryRegionsUpdateResult",
		upsertDeliveryRegions:"DeliveryRegionsUpsertResult",
		createDeliveryRegionsItem:"DeliveryRegionsItemCreateResult",
		deleteDeliveryRegionsItem:"DeliveryRegionsItemDeleteResult",
		updateDeliveryRegionsItem:"DeliveryRegionsItemUpdateResult",
		upsertDeliveryRegionsItem:"DeliveryRegionsItemUpsertResult",
		createImageList:"ImageListCreateResult",
		deleteImageList:"ImageListDeleteResult",
		updateImageList:"ImageListUpdateResult",
		upsertImageList:"ImageListUpsertResult",
		createImageListItem:"ImageListItemCreateResult",
		deleteImageListItem:"ImageListItemDeleteResult",
		updateImageListItem:"ImageListItemUpdateResult",
		upsertImageListItem:"ImageListItemUpsertResult",
		createTimetablesEmployeePrivileges:"TimetablesEmployeePrivilegesCreateResult",
		deleteTimetablesEmployeePrivileges:"TimetablesEmployeePrivilegesDeleteResult",
		updateTimetablesEmployeePrivileges:"TimetablesEmployeePrivilegesUpdateResult",
		upsertTimetablesEmployeePrivileges:"TimetablesEmployeePrivilegesUpsertResult",
		createTimetableDayNote:"TimetableDayNoteCreateResult",
		deleteTimetableDayNote:"TimetableDayNoteDeleteResult",
		updateTimetableDayNote:"TimetableDayNoteUpdateResult",
		upsertTimetableDayNote:"TimetableDayNoteUpsertResult",
		createDeliveryMethodLocale:"DeliveryMethodLocaleCreateResult",
		deleteDeliveryMethodLocale:"DeliveryMethodLocaleDeleteResult",
		updateDeliveryMethodLocale:"DeliveryMethodLocaleUpdateResult",
		upsertDeliveryMethodLocale:"DeliveryMethodLocaleUpsertResult",
		createIngredientSupplier:"IngredientSupplierCreateResult",
		deleteIngredientSupplier:"IngredientSupplierDeleteResult",
		updateIngredientSupplier:"IngredientSupplierUpdateResult",
		upsertIngredientSupplier:"IngredientSupplierUpsertResult",
		createIngredientSupplierItem:"IngredientSupplierItemCreateResult",
		deleteIngredientSupplierItem:"IngredientSupplierItemDeleteResult",
		updateIngredientSupplierItem:"IngredientSupplierItemUpdateResult",
		upsertIngredientSupplierItem:"IngredientSupplierItemUpsertResult",
		createIngredientSupplierList:"IngredientSupplierListCreateResult",
		deleteIngredientSupplierList:"IngredientSupplierListDeleteResult",
		updateIngredientSupplierList:"IngredientSupplierListUpdateResult",
		upsertIngredientSupplierList:"IngredientSupplierListUpsertResult",
		createIngredientSupplierLocale:"IngredientSupplierLocaleCreateResult",
		deleteIngredientSupplierLocale:"IngredientSupplierLocaleDeleteResult",
		updateIngredientSupplierLocale:"IngredientSupplierLocaleUpdateResult",
		upsertIngredientSupplierLocale:"IngredientSupplierLocaleUpsertResult",
		createRedirect:"RedirectCreateResult",
		deleteRedirect:"RedirectDeleteResult",
		updateRedirect:"RedirectUpdateResult",
		upsertRedirect:"RedirectUpsertResult",
		createNutritionFacts:"NutritionFactsCreateResult",
		deleteNutritionFacts:"NutritionFactsDeleteResult",
		updateNutritionFacts:"NutritionFactsUpdateResult",
		upsertNutritionFacts:"NutritionFactsUpsertResult",
		createVenue:"VenueCreateResult",
		deleteVenue:"VenueDeleteResult",
		updateVenue:"VenueUpdateResult",
		upsertVenue:"VenueUpsertResult",
		createWorkspace:"WorkspaceCreateResult",
		deleteWorkspace:"WorkspaceDeleteResult",
		updateWorkspace:"WorkspaceUpdateResult",
		upsertWorkspace:"WorkspaceUpsertResult",
		createInternalBuyer:"InternalBuyerCreateResult",
		deleteInternalBuyer:"InternalBuyerDeleteResult",
		updateInternalBuyer:"InternalBuyerUpdateResult",
		upsertInternalBuyer:"InternalBuyerUpsertResult",
		createVenueEmployeeRole:"VenueEmployeeRoleCreateResult",
		deleteVenueEmployeeRole:"VenueEmployeeRoleDeleteResult",
		updateVenueEmployeeRole:"VenueEmployeeRoleUpdateResult",
		upsertVenueEmployeeRole:"VenueEmployeeRoleUpsertResult",
		createIdentificationAttempt:"IdentificationAttemptCreateResult",
		deleteIdentificationAttempt:"IdentificationAttemptDeleteResult",
		updateIdentificationAttempt:"IdentificationAttemptUpdateResult",
		upsertIdentificationAttempt:"IdentificationAttemptUpsertResult",
		createIdentificationCode:"IdentificationCodeCreateResult",
		deleteIdentificationCode:"IdentificationCodeDeleteResult",
		updateIdentificationCode:"IdentificationCodeUpdateResult",
		upsertIdentificationCode:"IdentificationCodeUpsertResult",
		createIdentificationCodeLocale:"IdentificationCodeLocaleCreateResult",
		deleteIdentificationCodeLocale:"IdentificationCodeLocaleDeleteResult",
		updateIdentificationCodeLocale:"IdentificationCodeLocaleUpdateResult",
		upsertIdentificationCodeLocale:"IdentificationCodeLocaleUpsertResult",
		createPipeline:"PipelineCreateResult",
		deletePipeline:"PipelineDeleteResult",
		updatePipeline:"PipelineUpdateResult",
		upsertPipeline:"PipelineUpsertResult",
		createPipelineLead:"PipelineLeadCreateResult",
		deletePipelineLead:"PipelineLeadDeleteResult",
		updatePipelineLead:"PipelineLeadUpdateResult",
		upsertPipelineLead:"PipelineLeadUpsertResult",
		createPipelineStage:"PipelineStageCreateResult",
		deletePipelineStage:"PipelineStageDeleteResult",
		updatePipelineStage:"PipelineStageUpdateResult",
		upsertPipelineStage:"PipelineStageUpsertResult",
		createPipelineStageItem:"PipelineStageItemCreateResult",
		deletePipelineStageItem:"PipelineStageItemDeleteResult",
		updatePipelineStageItem:"PipelineStageItemUpdateResult",
		upsertPipelineStageItem:"PipelineStageItemUpsertResult",
		createPipelineStageLocale:"PipelineStageLocaleCreateResult",
		deletePipelineStageLocale:"PipelineStageLocaleDeleteResult",
		updatePipelineStageLocale:"PipelineStageLocaleUpdateResult",
		upsertPipelineStageLocale:"PipelineStageLocaleUpsertResult",
		createSalesManager:"SalesManagerCreateResult",
		deleteSalesManager:"SalesManagerDeleteResult",
		updateSalesManager:"SalesManagerUpdateResult",
		upsertSalesManager:"SalesManagerUpsertResult",
		createCashierManager:"CashierManagerCreateResult",
		deleteCashierManager:"CashierManagerDeleteResult",
		updateCashierManager:"CashierManagerUpdateResult",
		upsertCashierManager:"CashierManagerUpsertResult",
		createPointOfSaleApplicationDevice:"PointOfSaleApplicationDeviceCreateResult",
		deletePointOfSaleApplicationDevice:"PointOfSaleApplicationDeviceDeleteResult",
		updatePointOfSaleApplicationDevice:"PointOfSaleApplicationDeviceUpdateResult",
		upsertPointOfSaleApplicationDevice:"PointOfSaleApplicationDeviceUpsertResult",
		createPointOfSaleTerminal:"PointOfSaleTerminalCreateResult",
		deletePointOfSaleTerminal:"PointOfSaleTerminalDeleteResult",
		updatePointOfSaleTerminal:"PointOfSaleTerminalUpdateResult",
		upsertPointOfSaleTerminal:"PointOfSaleTerminalUpsertResult",
		createPipelineStageSentiment:"PipelineStageSentimentCreateResult",
		deletePipelineStageSentiment:"PipelineStageSentimentDeleteResult",
		updatePipelineStageSentiment:"PipelineStageSentimentUpdateResult",
		upsertPipelineStageSentiment:"PipelineStageSentimentUpsertResult",
		createDeviceIdentifier:"DeviceIdentifierCreateResult",
		deleteDeviceIdentifier:"DeviceIdentifierDeleteResult",
		updateDeviceIdentifier:"DeviceIdentifierUpdateResult",
		upsertDeviceIdentifier:"DeviceIdentifierUpsertResult",
		createPointOfSalePrinter:"PointOfSalePrinterCreateResult",
		deletePointOfSalePrinter:"PointOfSalePrinterDeleteResult",
		updatePointOfSalePrinter:"PointOfSalePrinterUpdateResult",
		upsertPointOfSalePrinter:"PointOfSalePrinterUpsertResult",
		createGratuity:"GratuityCreateResult",
		deleteGratuity:"GratuityDeleteResult",
		updateGratuity:"GratuityUpdateResult",
		upsertGratuity:"GratuityUpsertResult",
		createFulfillmentNote:"FulfillmentNoteCreateResult",
		deleteFulfillmentNote:"FulfillmentNoteDeleteResult",
		updateFulfillmentNote:"FulfillmentNoteUpdateResult",
		upsertFulfillmentNote:"FulfillmentNoteUpsertResult",
		createLeadForm:"LeadFormCreateResult",
		deleteLeadForm:"LeadFormDeleteResult",
		updateLeadForm:"LeadFormUpdateResult",
		upsertLeadForm:"LeadFormUpsertResult",
		createSubscriptionBox:"SubscriptionBoxCreateResult",
		deleteSubscriptionBox:"SubscriptionBoxDeleteResult",
		updateSubscriptionBox:"SubscriptionBoxUpdateResult",
		upsertSubscriptionBox:"SubscriptionBoxUpsertResult",
		createSubscriptionBoxLocale:"SubscriptionBoxLocaleCreateResult",
		deleteSubscriptionBoxLocale:"SubscriptionBoxLocaleDeleteResult",
		updateSubscriptionBoxLocale:"SubscriptionBoxLocaleUpdateResult",
		upsertSubscriptionBoxLocale:"SubscriptionBoxLocaleUpsertResult",
		createBusinessService:"BusinessServiceCreateResult",
		deleteBusinessService:"BusinessServiceDeleteResult",
		updateBusinessService:"BusinessServiceUpdateResult",
		upsertBusinessService:"BusinessServiceUpsertResult",
		createBusinessServiceEvent:"BusinessServiceEventCreateResult",
		deleteBusinessServiceEvent:"BusinessServiceEventDeleteResult",
		updateBusinessServiceEvent:"BusinessServiceEventUpdateResult",
		upsertBusinessServiceEvent:"BusinessServiceEventUpsertResult",
		createBusinessServiceLocale:"BusinessServiceLocaleCreateResult",
		deleteBusinessServiceLocale:"BusinessServiceLocaleDeleteResult",
		updateBusinessServiceLocale:"BusinessServiceLocaleUpdateResult",
		upsertBusinessServiceLocale:"BusinessServiceLocaleUpsertResult",
		createGridTileItem:"GridTileItemCreateResult",
		deleteGridTileItem:"GridTileItemDeleteResult",
		updateGridTileItem:"GridTileItemUpdateResult",
		upsertGridTileItem:"GridTileItemUpsertResult",
		createGridTiles:"GridTilesCreateResult",
		deleteGridTiles:"GridTilesDeleteResult",
		updateGridTiles:"GridTilesUpdateResult",
		upsertGridTiles:"GridTilesUpsertResult",
		createArea:"AreaCreateResult",
		deleteArea:"AreaDeleteResult",
		updateArea:"AreaUpdateResult",
		upsertArea:"AreaUpsertResult",
		createPosition:"PositionCreateResult",
		deletePosition:"PositionDeleteResult",
		updatePosition:"PositionUpdateResult",
		upsertPosition:"PositionUpsertResult",
		createStatsEnabledWidgetType:"StatsEnabledWidgetTypeCreateResult",
		deleteStatsEnabledWidgetType:"StatsEnabledWidgetTypeDeleteResult",
		updateStatsEnabledWidgetType:"StatsEnabledWidgetTypeUpdateResult",
		upsertStatsEnabledWidgetType:"StatsEnabledWidgetTypeUpsertResult",
		createStatsWidget:"StatsWidgetCreateResult",
		deleteStatsWidget:"StatsWidgetDeleteResult",
		updateStatsWidget:"StatsWidgetUpdateResult",
		upsertStatsWidget:"StatsWidgetUpsertResult",
		createStatsWidgetsLayout:"StatsWidgetsLayoutCreateResult",
		deleteStatsWidgetsLayout:"StatsWidgetsLayoutDeleteResult",
		updateStatsWidgetsLayout:"StatsWidgetsLayoutUpdateResult",
		upsertStatsWidgetsLayout:"StatsWidgetsLayoutUpsertResult",
		createSeat:"SeatCreateResult",
		deleteSeat:"SeatDeleteResult",
		updateSeat:"SeatUpdateResult",
		upsertSeat:"SeatUpsertResult",
		createTable:"TableCreateResult",
		deleteTable:"TableDeleteResult",
		updateTable:"TableUpdateResult",
		upsertTable:"TableUpsertResult",
		createStatsPage:"StatsPageCreateResult",
		deleteStatsPage:"StatsPageDeleteResult",
		updateStatsPage:"StatsPageUpdateResult",
		upsertStatsPage:"StatsPageUpsertResult",
		createUnassignReason:"UnassignReasonCreateResult",
		deleteUnassignReason:"UnassignReasonDeleteResult",
		updateUnassignReason:"UnassignReasonUpdateResult",
		upsertUnassignReason:"UnassignReasonUpsertResult",
		createDoubleshotCoffeeEquipment:"DoubleshotCoffeeEquipmentCreateResult",
		deleteDoubleshotCoffeeEquipment:"DoubleshotCoffeeEquipmentDeleteResult",
		updateDoubleshotCoffeeEquipment:"DoubleshotCoffeeEquipmentUpdateResult",
		upsertDoubleshotCoffeeEquipment:"DoubleshotCoffeeEquipmentUpsertResult",
		createExpense:"ExpenseCreateResult",
		deleteExpense:"ExpenseDeleteResult",
		updateExpense:"ExpenseUpdateResult",
		upsertExpense:"ExpenseUpsertResult",
		createExpenseCategory:"ExpenseCategoryCreateResult",
		deleteExpenseCategory:"ExpenseCategoryDeleteResult",
		updateExpenseCategory:"ExpenseCategoryUpdateResult",
		upsertExpenseCategory:"ExpenseCategoryUpsertResult",
		createExpenseChange:"ExpenseChangeCreateResult",
		deleteExpenseChange:"ExpenseChangeDeleteResult",
		updateExpenseChange:"ExpenseChangeUpdateResult",
		upsertExpenseChange:"ExpenseChangeUpsertResult",
		createExpenseDocument:"ExpenseDocumentCreateResult",
		deleteExpenseDocument:"ExpenseDocumentDeleteResult",
		updateExpenseDocument:"ExpenseDocumentUpdateResult",
		upsertExpenseDocument:"ExpenseDocumentUpsertResult",
		createRevenuePrediction:"RevenuePredictionCreateResult",
		deleteRevenuePrediction:"RevenuePredictionDeleteResult",
		updateRevenuePrediction:"RevenuePredictionUpdateResult",
		upsertRevenuePrediction:"RevenuePredictionUpsertResult",
		createRevenuePredictionChange:"RevenuePredictionChangeCreateResult",
		deleteRevenuePredictionChange:"RevenuePredictionChangeDeleteResult",
		updateRevenuePredictionChange:"RevenuePredictionChangeUpdateResult",
		upsertRevenuePredictionChange:"RevenuePredictionChangeUpsertResult",
		createFile:"FileCreateResult",
		deleteFile:"FileDeleteResult",
		updateFile:"FileUpdateResult",
		upsertFile:"FileUpsertResult",
		createLine:"LineCreateResult",
		deleteLine:"LineDeleteResult",
		updateLine:"LineUpdateResult",
		upsertLine:"LineUpsertResult",
		createFinancesBalanceItem:"FinancesBalanceItemCreateResult",
		deleteFinancesBalanceItem:"FinancesBalanceItemDeleteResult",
		updateFinancesBalanceItem:"FinancesBalanceItemUpdateResult",
		upsertFinancesBalanceItem:"FinancesBalanceItemUpsertResult",
		createWoltDriveDelivery:"WoltDriveDeliveryCreateResult",
		deleteWoltDriveDelivery:"WoltDriveDeliveryDeleteResult",
		updateWoltDriveDelivery:"WoltDriveDeliveryUpdateResult",
		upsertWoltDriveDelivery:"WoltDriveDeliveryUpsertResult",
		query:"Query"
	},
	_Schema:{
		enums:"_Enum",
		entities:"_Entity"
	},
	_Entity:{
		name:"String",
		customPrimaryAllowed:"Boolean",
		fields:"_Field",
		unique:"_UniqueConstraint"
	},
	_UniqueConstraint:{
		fields:"String"
	},
	_Field:{
		"...on _Column": "_Column",
		"...on _Relation": "_Relation",
		name:"String",
		type:"String",
		nullable:"Boolean",
		rules:"_Rule",
		validators:"_Validator"
	},
	_Column:{
		name:"String",
		type:"String",
		enumName:"String",
		defaultValue:"Json",
		nullable:"Boolean",
		rules:"_Rule",
		validators:"_Validator"
	},
	_OrderBy:{
		path:"String",
		direction:"_OrderByDirection"
	},
	_Relation:{
		name:"String",
		type:"String",
		side:"_RelationSide",
		targetEntity:"String",
		ownedBy:"String",
		inversedBy:"String",
		nullable:"Boolean",
		onDelete:"_OnDeleteBehaviour",
		orphanRemoval:"Boolean",
		orderBy:"_OrderBy",
		rules:"_Rule",
		validators:"_Validator"
	},
	_Rule:{
		message:"_RuleMessage",
		validator:"Int"
	},
	_Validator:{
		operation:"String",
		arguments:"_Argument"
	},
	_Argument:{
		"...on _ValidatorArgument":"_ValidatorArgument",
		"...on _PathArgument":"_PathArgument",
		"...on _LiteralArgument":"_LiteralArgument"
	},
	_ValidatorArgument:{
		validator:"Int"
	},
	_PathArgument:{
		path:"String"
	},
	_LiteralArgument:{
		value:"Json"
	},
	_RuleMessage:{
		text:"String"
	},
	_Enum:{
		name:"String",
		values:"String"
	},
	S3SignedUpload:{
		url:"String",
		headers:"S3Header",
		method:"String",
		objectKey:"String",
		bucket:"String",
		publicUrl:"String"
	},
	S3Header:{
		key:"String",
		value:"String"
	},
	S3SignedRead:{
		url:"String",
		headers:"S3Header",
		method:"String",
		objectKey:"String",
		bucket:"String"
	}
}

export const Ops = {
query: "Query" as const,
	mutation: "Mutation" as const
}


export const HOST="Specify host"



const handleFetchResponse = (response: Response): Promise<GraphQLResponse> => {
  if (!response.ok) {
    return new Promise((_, reject) => {
      response
        .text()
        .then((text) => {
          try {
            reject(JSON.parse(text));
          } catch (err) {
            reject(text);
          }
        })
        .catch(reject);
    });
  }
  return response.json();
};

export const apiFetch = (options: fetchOptions) => (query: string, variables: Record<string, unknown> = {}) => {
  const fetchOptions = options[1] || {};
  if (fetchOptions.method && fetchOptions.method === 'GET') {
    return fetch(`${options[0]}?query=${encodeURIComponent(query)}`, fetchOptions)
      .then(handleFetchResponse)
      .then((response: GraphQLResponse) => {
        if (response.errors) {
          throw new GraphQLError(response);
        }
        return response.data;
      });
  }
  return fetch(`${options[0]}`, {
    body: JSON.stringify({ query, variables }),
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    ...fetchOptions,
  })
    .then(handleFetchResponse)
    .then((response: GraphQLResponse) => {
      if (response.errors) {
        throw new GraphQLError(response);
      }
      return response.data;
    });
};




export const apiSubscription = (options: chainOptions) => (query: string) => {
  try {
    const queryString = options[0] + '?query=' + encodeURIComponent(query);
    const wsString = queryString.replace('http', 'ws');
    const host = (options.length > 1 && options[1]?.websocket?.[0]) || wsString;
    const webSocketOptions = options[1]?.websocket || [host];
    const ws = new WebSocket(...webSocketOptions);
    return {
      ws,
      on: (e: (args: any) => void) => {
        ws.onmessage = (event: any) => {
          if (event.data) {
            const parsed = JSON.parse(event.data);
            const data = parsed.data;
            return e(data);
          }
        };
      },
      off: (e: (args: any) => void) => {
        ws.onclose = e;
      },
      error: (e: (args: any) => void) => {
        ws.onerror = e;
      },
      open: (e: () => void) => {
        ws.onopen = e;
      },
    };
  } catch {
    throw new Error('No websockets implemented');
  }
};






export const InternalsBuildQuery = (
  props: AllTypesPropsType,
  returns: ReturnTypesType,
  ops: Operations,
  options?: OperationOptions,
) => {
  const ibb = (k: string, o: InputValueType | VType, p = '', root = true): string => {
    const keyForPath = purifyGraphQLKey(k);
    const newPath = [p, keyForPath].join(SEPARATOR);
    if (!o) {
      return '';
    }
    if (typeof o === 'boolean' || typeof o === 'number') {
      return k;
    }
    if (typeof o === 'string') {
      return `${k} ${o}`;
    }
    if (Array.isArray(o)) {
      const args = InternalArgsBuilt(props, returns, ops, options?.variables?.values)(o[0], newPath);
      return `${ibb(args ? `${k}(${args})` : k, o[1], p, false)}`;
    }
    if (k === '__alias') {
      return Object.entries(o)
        .map(([alias, objectUnderAlias]) => {
          if (typeof objectUnderAlias !== 'object' || Array.isArray(objectUnderAlias)) {
            throw new Error(
              'Invalid alias it should be __alias:{ YOUR_ALIAS_NAME: { OPERATION_NAME: { ...selectors }}}',
            );
          }
          const operationName = Object.keys(objectUnderAlias)[0];
          const operation = objectUnderAlias[operationName];
          return ibb(`${alias}:${operationName}`, operation, p, false);
        })
        .join('\n');
    }
    const hasOperationName = root && options?.operationName ? ' ' + options.operationName : '';
    const hasVariables = root && options?.variables?.$params ? `(${options.variables?.$params})` : '';
    const keyForDirectives = o.__directives ?? '';
    return `${k} ${keyForDirectives}${hasOperationName}${hasVariables}{${Object.entries(o)
      .filter(([k]) => k !== '__directives')
      .map((e) => ibb(...e, [p, `field<>${keyForPath}`].join(SEPARATOR), false))
      .join('\n')}}`;
  };
  return ibb;
};










export const Thunder = (fn: FetchFunction) => <
  O extends keyof typeof Ops,
  R extends keyof ValueTypes = GenericOperation<O>
>(
  operation: O,
) => <Z extends ValueTypes[R]>(o: Z | ValueTypes[R], ops?: OperationOptions) =>
  fullChainConstruct(fn)(operation)(o as any, ops) as Promise<InputType<GraphQLTypes[R], Z>>;

export const Chain = (...options: chainOptions) => Thunder(apiFetch(options));

export const SubscriptionThunder = (fn: SubscriptionFunction) => <
  O extends keyof typeof Ops,
  R extends keyof ValueTypes = GenericOperation<O>
>(
  operation: O,
) => <Z extends ValueTypes[R]>(o: Z | ValueTypes[R], ops?: OperationOptions) =>
  fullSubscriptionConstruct(fn)(operation)(o as any, ops) as SubscriptionToGraphQL<Z, GraphQLTypes[R]>;

export const Subscription = (...options: chainOptions) => SubscriptionThunder(apiSubscription(options));
export const Zeus = <
  Z extends ValueTypes[R],
  O extends keyof typeof Ops,
  R extends keyof ValueTypes = GenericOperation<O>
>(
  operation: O,
  o: Z | ValueTypes[R],
  ops?: OperationOptions,
) => InternalsBuildQuery(AllTypesProps, ReturnTypes, Ops, ops)(operation, o as any);
export const Selector = <T extends keyof ValueTypes>(key: T) => ZeusSelect<ValueTypes[T]>();

export const Gql = Chain(HOST);






export const fullChainConstruct = (fn: FetchFunction) => (t: 'query' | 'mutation' | 'subscription') => (
  o: Record<any, any>,
  options?: OperationOptions,
) => {
  const builder = InternalsBuildQuery(AllTypesProps, ReturnTypes, Ops, options);
  return fn(builder(t, o), options?.variables?.values);
};






export const fullSubscriptionConstruct = (fn: SubscriptionFunction) => (t: 'query' | 'mutation' | 'subscription') => (
  o: Record<any, any>,
  options?: OperationOptions,
) => {
  const builder = InternalsBuildQuery(AllTypesProps, ReturnTypes, Ops, options);
  return fn(builder(t, o));
};





export type AllTypesPropsType = {
  [x: string]:
    | undefined
    | boolean
    | {
        [x: string]:
          | undefined
          | string
          | {
              [x: string]: string | undefined;
            };
      };
};

export type ReturnTypesType = {
  [x: string]:
    | {
        [x: string]: string | undefined;
      }
    | undefined;
};
export type InputValueType = {
  [x: string]: undefined | boolean | string | number | [any, undefined | boolean | InputValueType] | InputValueType;
};
export type VType =
  | undefined
  | boolean
  | string
  | number
  | [any, undefined | boolean | InputValueType]
  | InputValueType;

export type PlainType = boolean | number | string | null | undefined;
export type ZeusArgsType =
  | PlainType
  | {
      [x: string]: ZeusArgsType;
    }
  | Array<ZeusArgsType>;

export type Operations = Record<string, string | undefined>;

export type VariableDefinition = {
  [x: string]: unknown;
};

export const SEPARATOR = '|';

export type fetchOptions = Parameters<typeof fetch>;
type websocketOptions = typeof WebSocket extends new (...args: infer R) => WebSocket ? R : never;
export type chainOptions = [fetchOptions[0], fetchOptions[1] & { websocket?: websocketOptions }] | [fetchOptions[0]];
export type FetchFunction = (query: string, variables?: Record<string, any>) => Promise<any>;
export type SubscriptionFunction = (query: string) => any;
type NotUndefined<T> = T extends undefined ? never : T;
export type ResolverType<F> = NotUndefined<F extends [infer ARGS, any] ? ARGS : undefined>;

export type OperationOptions<Z extends Record<string, unknown> = Record<string, unknown>> = {
  variables?: VariableInput<Z>;
  operationName?: string;
};

export interface GraphQLResponse {
  data?: Record<string, any>;
  errors?: Array<{
    message: string;
  }>;
}
export class GraphQLError extends Error {
  constructor(public response: GraphQLResponse) {
    super('');
    console.error(response);
  }
  toString() {
    return 'GraphQL Response Error';
  }
}
export type GenericOperation<O> = O extends keyof typeof Ops ? typeof Ops[O] : never;


export const purifyGraphQLKey = (k: string) => k.replace(/\([^)]*\)/g, '').replace(/^[^:]*\:/g, '');




const mapPart = (p: string) => {
  const [isArg, isField] = p.split('<>');
  if (isField) {
    return {
      v: isField,
      __type: 'field',
    } as const;
  }
  return {
    v: isArg,
    __type: 'arg',
  } as const;
};

type Part = ReturnType<typeof mapPart>;

export const ResolveFromPath = (props: AllTypesPropsType, returns: ReturnTypesType, ops: Operations) => {
  const ResolvePropsType = (mappedParts: Part[]) => {
    const oKey = ops[mappedParts[0].v];
    const propsP1 = oKey ? props[oKey] : props[mappedParts[0].v];
    if (typeof propsP1 === 'boolean' && mappedParts.length === 1) {
      return 'enum';
    }
    if (typeof propsP1 === 'object') {
      const propsP2 = propsP1[mappedParts[1].v];
      if (typeof propsP2 === 'string') {
        return rpp(
          `${propsP2}${SEPARATOR}${mappedParts
            .slice(2)
            .map((mp) => mp.v)
            .join(SEPARATOR)}`,
        );
      }
      if (typeof propsP2 === 'object') {
        const propsP3 = propsP2[mappedParts[2].v];
        if (propsP3 && mappedParts[2].__type === 'arg') {
          return rpp(
            `${propsP3}${SEPARATOR}${mappedParts
              .slice(3)
              .map((mp) => mp.v)
              .join(SEPARATOR)}`,
          );
        }
      }
    }
  };
  const ResolveReturnType = (mappedParts: Part[]) => {
    const oKey = ops[mappedParts[0].v];
    const returnP1 = oKey ? returns[oKey] : returns[mappedParts[0].v];
    if (typeof returnP1 === 'object') {
      const returnP2 = returnP1[mappedParts[1].v];
      if (returnP2) {
        return rpp(
          `${returnP2}${SEPARATOR}${mappedParts
            .slice(2)
            .map((mp) => mp.v)
            .join(SEPARATOR)}`,
        );
      }
    }
  };
  const rpp = (path: string): 'enum' | 'not' => {
    const parts = path.split(SEPARATOR).filter((l) => l.length > 0);
    const mappedParts = parts.map(mapPart);
    const propsP1 = ResolvePropsType(mappedParts);
    if (propsP1) {
      return propsP1;
    }
    const returnP1 = ResolveReturnType(mappedParts);
    if (returnP1) {
      return returnP1;
    }
    return 'not';
  };
  return rpp;
};

export const InternalArgsBuilt = (
  props: AllTypesPropsType,
  returns: ReturnTypesType,
  ops: Operations,
  variables?: Record<string, unknown>,
) => {
  const arb = (a: ZeusArgsType, p = '', root = true): string => {
    if (Array.isArray(a)) {
      return `[${a.map((arr) => arb(arr, p, false)).join(', ')}]`;
    }
    if (typeof a === 'string') {
      if (a.startsWith('$') && variables?.[a.slice(1)]) {
        return a;
      }
      const checkType = ResolveFromPath(props, returns, ops)(p);
      if (checkType === 'enum') {
        return a;
      }
      return `${JSON.stringify(a)}`;
    }
    if (typeof a === 'object') {
      if (a === null) {
        return `null`;
      }
      const returnedObjectString = Object.entries(a)
        .filter(([, v]) => typeof v !== 'undefined')
        .map(([k, v]) => `${k}: ${arb(v, [p, k].join(SEPARATOR), false)}`)
        .join(',\n');
      if (!root) {
        return `{${returnedObjectString}}`;
      }
      return returnedObjectString;
    }
    return `${a}`;
  };
  return arb;
};




export const resolverFor = <X, T extends keyof ValueTypes, Z extends keyof ValueTypes[T]>(
  type: T,
  field: Z,
  fn: (
    args: Required<ValueTypes[T]>[Z] extends [infer Input, any] ? Input : any,
    source: any,
  ) => Z extends keyof ModelTypes[T] ? ModelTypes[T][Z] | Promise<ModelTypes[T][Z]> | X : any,
) => fn as (args?: any, source?: any) => any;


export type SelectionFunction<V> = <T>(t: T | V) => T;
export const ZeusSelect = <T>() => ((t: unknown) => t) as SelectionFunction<T>;




export type UnwrapPromise<T> = T extends Promise<infer R> ? R : T;
export type ZeusState<T extends (...args: any[]) => Promise<any>> = NonNullable<UnwrapPromise<ReturnType<T>>>;
export type ZeusHook<
  T extends (...args: any[]) => Record<string, (...args: any[]) => Promise<any>>,
  N extends keyof ReturnType<T>
> = ZeusState<ReturnType<T>[N]>;

export type WithTypeNameValue<T> = T & {
  __typename?: boolean;
  __directives?: string;
};
export type AliasType<T> = WithTypeNameValue<T> & {
  __alias?: Record<string, WithTypeNameValue<T>>;
};
type DeepAnify<T> = {
  [P in keyof T]?: any;
};
type IsPayLoad<T> = T extends [any, infer PayLoad] ? PayLoad : T;
type IsArray<T, U> = T extends Array<infer R> ? InputType<R, U>[] : InputType<T, U>;
type FlattenArray<T> = T extends Array<infer R> ? R : T;
type BaseZeusResolver = boolean | 1 | string;

type IsInterfaced<SRC extends DeepAnify<DST>, DST> = FlattenArray<SRC> extends ZEUS_INTERFACES | ZEUS_UNIONS
  ? {
      [P in keyof SRC]: SRC[P] extends '__union' & infer R
        ? P extends keyof DST
          ? IsArray<R, '__typename' extends keyof DST ? DST[P] & { __typename: true } : DST[P]>
          : Record<string, unknown>
        : never;
    }[keyof DST] &
      {
        [P in keyof Omit<
          Pick<
            SRC,
            {
              [P in keyof DST]: SRC[P] extends '__union' & infer R ? never : P;
            }[keyof DST]
          >,
          '__typename'
        >]: IsPayLoad<DST[P]> extends BaseZeusResolver ? SRC[P] : IsArray<SRC[P], DST[P]>;
      }
  : {
      [P in keyof Pick<SRC, keyof DST>]: IsPayLoad<DST[P]> extends BaseZeusResolver ? SRC[P] : IsArray<SRC[P], DST[P]>;
    };

export type MapType<SRC, DST> = SRC extends DeepAnify<DST> ? IsInterfaced<SRC, DST> : never;
export type InputType<SRC, DST> = IsPayLoad<DST> extends { __alias: infer R }
  ? {
      [P in keyof R]: MapType<SRC, R[P]>[keyof MapType<SRC, R[P]>];
    } &
      MapType<SRC, Omit<IsPayLoad<DST>, '__alias'>>
  : MapType<SRC, IsPayLoad<DST>>;
export type SubscriptionToGraphQL<Z, T> = {
  ws: WebSocket;
  on: (fn: (args: InputType<T, Z>) => void) => void;
  off: (fn: (e: { data?: InputType<T, Z>; code?: number; reason?: string; message?: string }) => void) => void;
  error: (fn: (e: { data?: InputType<T, Z>; errors?: string[] }) => void) => void;
  open: () => void;
};


export const useZeusVariables =
  <T extends Record<string, unknown>>(variables: T) =>
  <
    Z extends {
      [P in keyof T]: unknown;
    },
  >(
    values: Z,
  ) => {
    return {
      $params: Object.keys(variables)
        .map((k) => `$${k}: ${variables[k as keyof T]}`)
        .join(', '),
      $: <U extends keyof Z>(variable: U) => {
        return `$${String(variable)}` as unknown as Z[U];
      },
      values,
    };
  };

export type VariableInput<Z extends Record<string, unknown>> = {
  $params: ReturnType<ReturnType<typeof useZeusVariables>>['$params'];
  values: Z;
};


type ZEUS_INTERFACES = GraphQLTypes["MutationResult"] | GraphQLTypes["_Field"]
type ZEUS_UNIONS = GraphQLTypes["_PathFragment"] | GraphQLTypes["_Argument"]

export type ValueTypes = {
    ["Query"]: AliasType<{
getAddress?: [{	by: ValueTypes["AddressUniqueWhere"],	filter?: ValueTypes["AddressWhere"] | undefined | null},ValueTypes["Address"]],
listAddress?: [{	filter?: ValueTypes["AddressWhere"] | undefined | null,	orderBy?: Array<ValueTypes["AddressOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Address"]],
paginateAddress?: [{	filter?: ValueTypes["AddressWhere"] | undefined | null,	orderBy?: Array<ValueTypes["AddressOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["AddressConnection"]],
validateCreateAddress?: [{	data: ValueTypes["AddressCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateAddress?: [{	by: ValueTypes["AddressUniqueWhere"],	data: ValueTypes["AddressUpdateInput"]},ValueTypes["_ValidationResult"]],
getCountry?: [{	by: ValueTypes["CountryUniqueWhere"],	filter?: ValueTypes["CountryWhere"] | undefined | null},ValueTypes["Country"]],
listCountry?: [{	filter?: ValueTypes["CountryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CountryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Country"]],
paginateCountry?: [{	filter?: ValueTypes["CountryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CountryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CountryConnection"]],
validateCreateCountry?: [{	data: ValueTypes["CountryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCountry?: [{	by: ValueTypes["CountryUniqueWhere"],	data: ValueTypes["CountryUpdateInput"]},ValueTypes["_ValidationResult"]],
getChannel?: [{	by: ValueTypes["ChannelUniqueWhere"],	filter?: ValueTypes["ChannelWhere"] | undefined | null},ValueTypes["Channel"]],
listChannel?: [{	filter?: ValueTypes["ChannelWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ChannelOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Channel"]],
paginateChannel?: [{	filter?: ValueTypes["ChannelWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ChannelOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ChannelConnection"]],
validateCreateChannel?: [{	data: ValueTypes["ChannelCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateChannel?: [{	by: ValueTypes["ChannelUniqueWhere"],	data: ValueTypes["ChannelUpdateInput"]},ValueTypes["_ValidationResult"]],
getChannelPayment?: [{	by: ValueTypes["ChannelPaymentUniqueWhere"],	filter?: ValueTypes["ChannelPaymentWhere"] | undefined | null},ValueTypes["ChannelPayment"]],
listChannelPayment?: [{	filter?: ValueTypes["ChannelPaymentWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ChannelPaymentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ChannelPayment"]],
paginateChannelPayment?: [{	filter?: ValueTypes["ChannelPaymentWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ChannelPaymentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ChannelPaymentConnection"]],
validateCreateChannelPayment?: [{	data: ValueTypes["ChannelPaymentCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateChannelPayment?: [{	by: ValueTypes["ChannelPaymentUniqueWhere"],	data: ValueTypes["ChannelPaymentUpdateInput"]},ValueTypes["_ValidationResult"]],
getChannelDelivery?: [{	by: ValueTypes["ChannelDeliveryUniqueWhere"],	filter?: ValueTypes["ChannelDeliveryWhere"] | undefined | null},ValueTypes["ChannelDelivery"]],
listChannelDelivery?: [{	filter?: ValueTypes["ChannelDeliveryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ChannelDeliveryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ChannelDelivery"]],
paginateChannelDelivery?: [{	filter?: ValueTypes["ChannelDeliveryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ChannelDeliveryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ChannelDeliveryConnection"]],
validateCreateChannelDelivery?: [{	data: ValueTypes["ChannelDeliveryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateChannelDelivery?: [{	by: ValueTypes["ChannelDeliveryUniqueWhere"],	data: ValueTypes["ChannelDeliveryUpdateInput"]},ValueTypes["_ValidationResult"]],
getCustomer?: [{	by: ValueTypes["CustomerUniqueWhere"],	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
listCustomer?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Customer"]],
paginateCustomer?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerConnection"]],
validateCreateCustomer?: [{	data: ValueTypes["CustomerCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCustomer?: [{	by: ValueTypes["CustomerUniqueWhere"],	data: ValueTypes["CustomerUpdateInput"]},ValueTypes["_ValidationResult"]],
getCustomerCredit?: [{	by: ValueTypes["CustomerCreditUniqueWhere"],	filter?: ValueTypes["CustomerCreditWhere"] | undefined | null},ValueTypes["CustomerCredit"]],
listCustomerCredit?: [{	filter?: ValueTypes["CustomerCreditWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerCreditOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CustomerCredit"]],
paginateCustomerCredit?: [{	filter?: ValueTypes["CustomerCreditWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerCreditOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerCreditConnection"]],
validateCreateCustomerCredit?: [{	data: ValueTypes["CustomerCreditCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCustomerCredit?: [{	by: ValueTypes["CustomerCreditUniqueWhere"],	data: ValueTypes["CustomerCreditUpdateInput"]},ValueTypes["_ValidationResult"]],
getCustomerGroup?: [{	by: ValueTypes["CustomerGroupUniqueWhere"],	filter?: ValueTypes["CustomerGroupWhere"] | undefined | null},ValueTypes["CustomerGroup"]],
listCustomerGroup?: [{	filter?: ValueTypes["CustomerGroupWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerGroupOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CustomerGroup"]],
paginateCustomerGroup?: [{	filter?: ValueTypes["CustomerGroupWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerGroupOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerGroupConnection"]],
validateCreateCustomerGroup?: [{	data: ValueTypes["CustomerGroupCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCustomerGroup?: [{	by: ValueTypes["CustomerGroupUniqueWhere"],	data: ValueTypes["CustomerGroupUpdateInput"]},ValueTypes["_ValidationResult"]],
getCustomerPaymentMethod?: [{	by: ValueTypes["CustomerPaymentMethodUniqueWhere"],	filter?: ValueTypes["CustomerPaymentMethodWhere"] | undefined | null},ValueTypes["CustomerPaymentMethod"]],
listCustomerPaymentMethod?: [{	filter?: ValueTypes["CustomerPaymentMethodWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerPaymentMethodOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CustomerPaymentMethod"]],
paginateCustomerPaymentMethod?: [{	filter?: ValueTypes["CustomerPaymentMethodWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerPaymentMethodOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerPaymentMethodConnection"]],
validateCreateCustomerPaymentMethod?: [{	data: ValueTypes["CustomerPaymentMethodCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCustomerPaymentMethod?: [{	by: ValueTypes["CustomerPaymentMethodUniqueWhere"],	data: ValueTypes["CustomerPaymentMethodUpdateInput"]},ValueTypes["_ValidationResult"]],
getDeliveryMethod?: [{	by: ValueTypes["DeliveryMethodUniqueWhere"],	filter?: ValueTypes["DeliveryMethodWhere"] | undefined | null},ValueTypes["DeliveryMethod"]],
listDeliveryMethod?: [{	filter?: ValueTypes["DeliveryMethodWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryMethodOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["DeliveryMethod"]],
paginateDeliveryMethod?: [{	filter?: ValueTypes["DeliveryMethodWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryMethodOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["DeliveryMethodConnection"]],
validateCreateDeliveryMethod?: [{	data: ValueTypes["DeliveryMethodCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDeliveryMethod?: [{	by: ValueTypes["DeliveryMethodUniqueWhere"],	data: ValueTypes["DeliveryMethodUpdateInput"]},ValueTypes["_ValidationResult"]],
getOrder?: [{	by: ValueTypes["OrderUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
listOrder?: [{	filter?: ValueTypes["OrderWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Order"]],
paginateOrder?: [{	filter?: ValueTypes["OrderWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderConnection"]],
validateCreateOrder?: [{	data: ValueTypes["OrderCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateOrder?: [{	by: ValueTypes["OrderUniqueWhere"],	data: ValueTypes["OrderUpdateInput"]},ValueTypes["_ValidationResult"]],
getOrderDiscount?: [{	by: ValueTypes["OrderDiscountUniqueWhere"],	filter?: ValueTypes["OrderDiscountWhere"] | undefined | null},ValueTypes["OrderDiscount"]],
listOrderDiscount?: [{	filter?: ValueTypes["OrderDiscountWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderDiscountOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["OrderDiscount"]],
paginateOrderDiscount?: [{	filter?: ValueTypes["OrderDiscountWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderDiscountOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderDiscountConnection"]],
validateCreateOrderDiscount?: [{	data: ValueTypes["OrderDiscountCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateOrderDiscount?: [{	by: ValueTypes["OrderDiscountUniqueWhere"],	data: ValueTypes["OrderDiscountUpdateInput"]},ValueTypes["_ValidationResult"]],
getOrderPayment?: [{	by: ValueTypes["OrderPaymentUniqueWhere"],	filter?: ValueTypes["OrderPaymentWhere"] | undefined | null},ValueTypes["OrderPayment"]],
listOrderPayment?: [{	filter?: ValueTypes["OrderPaymentWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderPaymentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["OrderPayment"]],
paginateOrderPayment?: [{	filter?: ValueTypes["OrderPaymentWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderPaymentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderPaymentConnection"]],
validateCreateOrderPayment?: [{	data: ValueTypes["OrderPaymentCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateOrderPayment?: [{	by: ValueTypes["OrderPaymentUniqueWhere"],	data: ValueTypes["OrderPaymentUpdateInput"]},ValueTypes["_ValidationResult"]],
getOrderDelivery?: [{	by: ValueTypes["OrderDeliveryUniqueWhere"],	filter?: ValueTypes["OrderDeliveryWhere"] | undefined | null},ValueTypes["OrderDelivery"]],
listOrderDelivery?: [{	filter?: ValueTypes["OrderDeliveryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderDeliveryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["OrderDelivery"]],
paginateOrderDelivery?: [{	filter?: ValueTypes["OrderDeliveryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderDeliveryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderDeliveryConnection"]],
validateCreateOrderDelivery?: [{	data: ValueTypes["OrderDeliveryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateOrderDelivery?: [{	by: ValueTypes["OrderDeliveryUniqueWhere"],	data: ValueTypes["OrderDeliveryUpdateInput"]},ValueTypes["_ValidationResult"]],
getOrderItem?: [{	by: ValueTypes["OrderItemUniqueWhere"],	filter?: ValueTypes["OrderItemWhere"] | undefined | null},ValueTypes["OrderItem"]],
listOrderItem?: [{	filter?: ValueTypes["OrderItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["OrderItem"]],
paginateOrderItem?: [{	filter?: ValueTypes["OrderItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderItemConnection"]],
validateCreateOrderItem?: [{	data: ValueTypes["OrderItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateOrderItem?: [{	by: ValueTypes["OrderItemUniqueWhere"],	data: ValueTypes["OrderItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getPaymentMethod?: [{	by: ValueTypes["PaymentMethodUniqueWhere"],	filter?: ValueTypes["PaymentMethodWhere"] | undefined | null},ValueTypes["PaymentMethod"]],
listPaymentMethod?: [{	filter?: ValueTypes["PaymentMethodWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PaymentMethodOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PaymentMethod"]],
paginatePaymentMethod?: [{	filter?: ValueTypes["PaymentMethodWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PaymentMethodOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PaymentMethodConnection"]],
validateCreatePaymentMethod?: [{	data: ValueTypes["PaymentMethodCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePaymentMethod?: [{	by: ValueTypes["PaymentMethodUniqueWhere"],	data: ValueTypes["PaymentMethodUpdateInput"]},ValueTypes["_ValidationResult"]],
getVatRate?: [{	by: ValueTypes["VatRateUniqueWhere"],	filter?: ValueTypes["VatRateWhere"] | undefined | null},ValueTypes["VatRate"]],
listVatRate?: [{	filter?: ValueTypes["VatRateWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VatRateOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["VatRate"]],
paginateVatRate?: [{	filter?: ValueTypes["VatRateWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VatRateOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["VatRateConnection"]],
validateCreateVatRate?: [{	data: ValueTypes["VatRateCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateVatRate?: [{	by: ValueTypes["VatRateUniqueWhere"],	data: ValueTypes["VatRateUpdateInput"]},ValueTypes["_ValidationResult"]],
getProduct?: [{	by: ValueTypes["ProductUniqueWhere"],	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
listProduct?: [{	filter?: ValueTypes["ProductWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Product"]],
paginateProduct?: [{	filter?: ValueTypes["ProductWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductConnection"]],
validateCreateProduct?: [{	data: ValueTypes["ProductCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProduct?: [{	by: ValueTypes["ProductUniqueWhere"],	data: ValueTypes["ProductUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductStock?: [{	by: ValueTypes["ProductStockUniqueWhere"],	filter?: ValueTypes["ProductStockWhere"] | undefined | null},ValueTypes["ProductStock"]],
listProductStock?: [{	filter?: ValueTypes["ProductStockWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductStockOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductStock"]],
paginateProductStock?: [{	filter?: ValueTypes["ProductStockWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductStockOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductStockConnection"]],
validateCreateProductStock?: [{	data: ValueTypes["ProductStockCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductStock?: [{	by: ValueTypes["ProductStockUniqueWhere"],	data: ValueTypes["ProductStockUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductPacking?: [{	by: ValueTypes["ProductPackingUniqueWhere"],	filter?: ValueTypes["ProductPackingWhere"] | undefined | null},ValueTypes["ProductPacking"]],
listProductPacking?: [{	filter?: ValueTypes["ProductPackingWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductPackingOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductPacking"]],
paginateProductPacking?: [{	filter?: ValueTypes["ProductPackingWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductPackingOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductPackingConnection"]],
validateCreateProductPacking?: [{	data: ValueTypes["ProductPackingCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductPacking?: [{	by: ValueTypes["ProductPackingUniqueWhere"],	data: ValueTypes["ProductPackingUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductGroupPrice?: [{	by: ValueTypes["ProductGroupPriceUniqueWhere"],	filter?: ValueTypes["ProductGroupPriceWhere"] | undefined | null},ValueTypes["ProductGroupPrice"]],
listProductGroupPrice?: [{	filter?: ValueTypes["ProductGroupPriceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductGroupPriceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductGroupPrice"]],
paginateProductGroupPrice?: [{	filter?: ValueTypes["ProductGroupPriceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductGroupPriceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductGroupPriceConnection"]],
validateCreateProductGroupPrice?: [{	data: ValueTypes["ProductGroupPriceCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductGroupPrice?: [{	by: ValueTypes["ProductGroupPriceUniqueWhere"],	data: ValueTypes["ProductGroupPriceUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductRecipe?: [{	by: ValueTypes["ProductRecipeUniqueWhere"],	filter?: ValueTypes["ProductRecipeWhere"] | undefined | null},ValueTypes["ProductRecipe"]],
listProductRecipe?: [{	filter?: ValueTypes["ProductRecipeWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductRecipeOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductRecipe"]],
paginateProductRecipe?: [{	filter?: ValueTypes["ProductRecipeWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductRecipeOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductRecipeConnection"]],
validateCreateProductRecipe?: [{	data: ValueTypes["ProductRecipeCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductRecipe?: [{	by: ValueTypes["ProductRecipeUniqueWhere"],	data: ValueTypes["ProductRecipeUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductCategory?: [{	by: ValueTypes["ProductCategoryUniqueWhere"],	filter?: ValueTypes["ProductCategoryWhere"] | undefined | null},ValueTypes["ProductCategory"]],
listProductCategory?: [{	filter?: ValueTypes["ProductCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCategoryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductCategory"]],
paginateProductCategory?: [{	filter?: ValueTypes["ProductCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCategoryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductCategoryConnection"]],
validateCreateProductCategory?: [{	data: ValueTypes["ProductCategoryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductCategory?: [{	by: ValueTypes["ProductCategoryUniqueWhere"],	data: ValueTypes["ProductCategoryUpdateInput"]},ValueTypes["_ValidationResult"]],
getStore?: [{	by: ValueTypes["StoreUniqueWhere"],	filter?: ValueTypes["StoreWhere"] | undefined | null},ValueTypes["Store"]],
listStore?: [{	filter?: ValueTypes["StoreWhere"] | undefined | null,	orderBy?: Array<ValueTypes["StoreOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Store"]],
paginateStore?: [{	filter?: ValueTypes["StoreWhere"] | undefined | null,	orderBy?: Array<ValueTypes["StoreOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["StoreConnection"]],
validateCreateStore?: [{	data: ValueTypes["StoreCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateStore?: [{	by: ValueTypes["StoreUniqueWhere"],	data: ValueTypes["StoreUpdateInput"]},ValueTypes["_ValidationResult"]],
getTag?: [{	by: ValueTypes["TagUniqueWhere"],	filter?: ValueTypes["TagWhere"] | undefined | null},ValueTypes["Tag"]],
listTag?: [{	filter?: ValueTypes["TagWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TagOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Tag"]],
paginateTag?: [{	filter?: ValueTypes["TagWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TagOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TagConnection"]],
validateCreateTag?: [{	data: ValueTypes["TagCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTag?: [{	by: ValueTypes["TagUniqueWhere"],	data: ValueTypes["TagUpdateInput"]},ValueTypes["_ValidationResult"]],
getCustomerPermissions?: [{	by: ValueTypes["CustomerPermissionsUniqueWhere"],	filter?: ValueTypes["CustomerPermissionsWhere"] | undefined | null},ValueTypes["CustomerPermissions"]],
listCustomerPermissions?: [{	filter?: ValueTypes["CustomerPermissionsWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerPermissionsOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CustomerPermissions"]],
paginateCustomerPermissions?: [{	filter?: ValueTypes["CustomerPermissionsWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerPermissionsOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerPermissionsConnection"]],
getImage?: [{	by: ValueTypes["ImageUniqueWhere"],	filter?: ValueTypes["ImageWhere"] | undefined | null},ValueTypes["Image"]],
listImage?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ImageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Image"]],
paginateImage?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ImageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ImageConnection"]],
validateCreateImage?: [{	data: ValueTypes["ImageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImage?: [{	by: ValueTypes["ImageUniqueWhere"],	data: ValueTypes["ImageUpdateInput"]},ValueTypes["_ValidationResult"]],
getBusinessCategory?: [{	by: ValueTypes["BusinessCategoryUniqueWhere"],	filter?: ValueTypes["BusinessCategoryWhere"] | undefined | null},ValueTypes["BusinessCategory"]],
listBusinessCategory?: [{	filter?: ValueTypes["BusinessCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessCategoryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BusinessCategory"]],
paginateBusinessCategory?: [{	filter?: ValueTypes["BusinessCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessCategoryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BusinessCategoryConnection"]],
validateCreateBusinessCategory?: [{	data: ValueTypes["BusinessCategoryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBusinessCategory?: [{	by: ValueTypes["BusinessCategoryUniqueWhere"],	data: ValueTypes["BusinessCategoryUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductList?: [{	by: ValueTypes["ProductListUniqueWhere"],	filter?: ValueTypes["ProductListWhere"] | undefined | null},ValueTypes["ProductList"]],
listProductList?: [{	filter?: ValueTypes["ProductListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductList"]],
paginateProductList?: [{	filter?: ValueTypes["ProductListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductListConnection"]],
validateCreateProductList?: [{	data: ValueTypes["ProductListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductList?: [{	by: ValueTypes["ProductListUniqueWhere"],	data: ValueTypes["ProductListUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductListItem?: [{	by: ValueTypes["ProductListItemUniqueWhere"],	filter?: ValueTypes["ProductListItemWhere"] | undefined | null},ValueTypes["ProductListItem"]],
listProductListItem?: [{	filter?: ValueTypes["ProductListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductListItem"]],
paginateProductListItem?: [{	filter?: ValueTypes["ProductListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductListItemConnection"]],
validateCreateProductListItem?: [{	data: ValueTypes["ProductListItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductListItem?: [{	by: ValueTypes["ProductListItemUniqueWhere"],	data: ValueTypes["ProductListItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductCategoryList?: [{	by: ValueTypes["ProductCategoryListUniqueWhere"],	filter?: ValueTypes["ProductCategoryListWhere"] | undefined | null},ValueTypes["ProductCategoryList"]],
listProductCategoryList?: [{	filter?: ValueTypes["ProductCategoryListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCategoryListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductCategoryList"]],
paginateProductCategoryList?: [{	filter?: ValueTypes["ProductCategoryListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCategoryListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductCategoryListConnection"]],
validateCreateProductCategoryList?: [{	data: ValueTypes["ProductCategoryListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductCategoryList?: [{	by: ValueTypes["ProductCategoryListUniqueWhere"],	data: ValueTypes["ProductCategoryListUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductCategoryListItem?: [{	by: ValueTypes["ProductCategoryListItemUniqueWhere"],	filter?: ValueTypes["ProductCategoryListItemWhere"] | undefined | null},ValueTypes["ProductCategoryListItem"]],
listProductCategoryListItem?: [{	filter?: ValueTypes["ProductCategoryListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCategoryListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductCategoryListItem"]],
paginateProductCategoryListItem?: [{	filter?: ValueTypes["ProductCategoryListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCategoryListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductCategoryListItemConnection"]],
validateCreateProductCategoryListItem?: [{	data: ValueTypes["ProductCategoryListItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductCategoryListItem?: [{	by: ValueTypes["ProductCategoryListItemUniqueWhere"],	data: ValueTypes["ProductCategoryListItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getBusinessCategoryLocale?: [{	by: ValueTypes["BusinessCategoryLocaleUniqueWhere"],	filter?: ValueTypes["BusinessCategoryLocaleWhere"] | undefined | null},ValueTypes["BusinessCategoryLocale"]],
listBusinessCategoryLocale?: [{	filter?: ValueTypes["BusinessCategoryLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessCategoryLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BusinessCategoryLocale"]],
paginateBusinessCategoryLocale?: [{	filter?: ValueTypes["BusinessCategoryLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessCategoryLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BusinessCategoryLocaleConnection"]],
validateCreateBusinessCategoryLocale?: [{	data: ValueTypes["BusinessCategoryLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBusinessCategoryLocale?: [{	by: ValueTypes["BusinessCategoryLocaleUniqueWhere"],	data: ValueTypes["BusinessCategoryLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getLocale?: [{	by: ValueTypes["LocaleUniqueWhere"],	filter?: ValueTypes["LocaleWhere"] | undefined | null},ValueTypes["Locale"]],
listLocale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Locale"]],
paginateLocale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["LocaleConnection"]],
validateCreateLocale?: [{	data: ValueTypes["LocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLocale?: [{	by: ValueTypes["LocaleUniqueWhere"],	data: ValueTypes["LocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductCategoryListLocale?: [{	by: ValueTypes["ProductCategoryListLocaleUniqueWhere"],	filter?: ValueTypes["ProductCategoryListLocaleWhere"] | undefined | null},ValueTypes["ProductCategoryListLocale"]],
listProductCategoryListLocale?: [{	filter?: ValueTypes["ProductCategoryListLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCategoryListLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductCategoryListLocale"]],
paginateProductCategoryListLocale?: [{	filter?: ValueTypes["ProductCategoryListLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCategoryListLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductCategoryListLocaleConnection"]],
validateCreateProductCategoryListLocale?: [{	data: ValueTypes["ProductCategoryListLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductCategoryListLocale?: [{	by: ValueTypes["ProductCategoryListLocaleUniqueWhere"],	data: ValueTypes["ProductCategoryListLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getCustomerName?: [{	by: ValueTypes["CustomerNameUniqueWhere"],	filter?: ValueTypes["CustomerNameWhere"] | undefined | null},ValueTypes["CustomerName"]],
listCustomerName?: [{	filter?: ValueTypes["CustomerNameWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerNameOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CustomerName"]],
paginateCustomerName?: [{	filter?: ValueTypes["CustomerNameWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerNameOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerNameConnection"]],
validateCreateCustomerName?: [{	data: ValueTypes["CustomerNameCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCustomerName?: [{	by: ValueTypes["CustomerNameUniqueWhere"],	data: ValueTypes["CustomerNameUpdateInput"]},ValueTypes["_ValidationResult"]],
getCustomerAlias?: [{	by: ValueTypes["CustomerAliasUniqueWhere"],	filter?: ValueTypes["CustomerAliasWhere"] | undefined | null},ValueTypes["CustomerAlias"]],
listCustomerAlias?: [{	filter?: ValueTypes["CustomerAliasWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerAliasOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CustomerAlias"]],
paginateCustomerAlias?: [{	filter?: ValueTypes["CustomerAliasWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerAliasOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerAliasConnection"]],
validateCreateCustomerAlias?: [{	data: ValueTypes["CustomerAliasCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCustomerAlias?: [{	by: ValueTypes["CustomerAliasUniqueWhere"],	data: ValueTypes["CustomerAliasUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductIngredientItem?: [{	by: ValueTypes["ProductIngredientItemUniqueWhere"],	filter?: ValueTypes["ProductIngredientItemWhere"] | undefined | null},ValueTypes["ProductIngredientItem"]],
listProductIngredientItem?: [{	filter?: ValueTypes["ProductIngredientItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductIngredientItem"]],
paginateProductIngredientItem?: [{	filter?: ValueTypes["ProductIngredientItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductIngredientItemConnection"]],
validateCreateProductIngredientItem?: [{	data: ValueTypes["ProductIngredientItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductIngredientItem?: [{	by: ValueTypes["ProductIngredientItemUniqueWhere"],	data: ValueTypes["ProductIngredientItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductIngredientItemQuantity?: [{	by: ValueTypes["ProductIngredientItemQuantityUniqueWhere"],	filter?: ValueTypes["ProductIngredientItemQuantityWhere"] | undefined | null},ValueTypes["ProductIngredientItemQuantity"]],
listProductIngredientItemQuantity?: [{	filter?: ValueTypes["ProductIngredientItemQuantityWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientItemQuantityOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductIngredientItemQuantity"]],
paginateProductIngredientItemQuantity?: [{	filter?: ValueTypes["ProductIngredientItemQuantityWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientItemQuantityOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductIngredientItemQuantityConnection"]],
validateCreateProductIngredientItemQuantity?: [{	data: ValueTypes["ProductIngredientItemQuantityCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductIngredientItemQuantity?: [{	by: ValueTypes["ProductIngredientItemQuantityUniqueWhere"],	data: ValueTypes["ProductIngredientItemQuantityUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductIngredientItemQuantityUnit?: [{	by: ValueTypes["ProductIngredientItemQuantityUnitUniqueWhere"],	filter?: ValueTypes["ProductIngredientItemQuantityUnitWhere"] | undefined | null},ValueTypes["ProductIngredientItemQuantityUnit"]],
listProductIngredientItemQuantityUnit?: [{	filter?: ValueTypes["ProductIngredientItemQuantityUnitWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientItemQuantityUnitOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductIngredientItemQuantityUnit"]],
paginateProductIngredientItemQuantityUnit?: [{	filter?: ValueTypes["ProductIngredientItemQuantityUnitWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientItemQuantityUnitOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductIngredientItemQuantityUnitConnection"]],
validateCreateProductIngredientItemQuantityUnit?: [{	data: ValueTypes["ProductIngredientItemQuantityUnitCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductIngredientItemQuantityUnit?: [{	by: ValueTypes["ProductIngredientItemQuantityUnitUniqueWhere"],	data: ValueTypes["ProductIngredientItemQuantityUnitUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductIngredient?: [{	by: ValueTypes["ProductIngredientUniqueWhere"],	filter?: ValueTypes["ProductIngredientWhere"] | undefined | null},ValueTypes["ProductIngredient"]],
listProductIngredient?: [{	filter?: ValueTypes["ProductIngredientWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductIngredient"]],
paginateProductIngredient?: [{	filter?: ValueTypes["ProductIngredientWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductIngredientConnection"]],
validateCreateProductIngredient?: [{	data: ValueTypes["ProductIngredientCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductIngredient?: [{	by: ValueTypes["ProductIngredientUniqueWhere"],	data: ValueTypes["ProductIngredientUpdateInput"]},ValueTypes["_ValidationResult"]],
getCustomerIngredientRating?: [{	by: ValueTypes["CustomerIngredientRatingUniqueWhere"],	filter?: ValueTypes["CustomerIngredientRatingWhere"] | undefined | null},ValueTypes["CustomerIngredientRating"]],
listCustomerIngredientRating?: [{	filter?: ValueTypes["CustomerIngredientRatingWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerIngredientRatingOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CustomerIngredientRating"]],
paginateCustomerIngredientRating?: [{	filter?: ValueTypes["CustomerIngredientRatingWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerIngredientRatingOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerIngredientRatingConnection"]],
validateCreateCustomerIngredientRating?: [{	data: ValueTypes["CustomerIngredientRatingCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCustomerIngredientRating?: [{	by: ValueTypes["CustomerIngredientRatingUniqueWhere"],	data: ValueTypes["CustomerIngredientRatingUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductIngredientRating?: [{	by: ValueTypes["ProductIngredientRatingUniqueWhere"],	filter?: ValueTypes["ProductIngredientRatingWhere"] | undefined | null},ValueTypes["ProductIngredientRating"]],
listProductIngredientRating?: [{	filter?: ValueTypes["ProductIngredientRatingWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientRatingOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductIngredientRating"]],
paginateProductIngredientRating?: [{	filter?: ValueTypes["ProductIngredientRatingWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientRatingOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductIngredientRatingConnection"]],
validateCreateProductIngredientRating?: [{	data: ValueTypes["ProductIngredientRatingCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductIngredientRating?: [{	by: ValueTypes["ProductIngredientRatingUniqueWhere"],	data: ValueTypes["ProductIngredientRatingUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductIngredientLocale?: [{	by: ValueTypes["ProductIngredientLocaleUniqueWhere"],	filter?: ValueTypes["ProductIngredientLocaleWhere"] | undefined | null},ValueTypes["ProductIngredientLocale"]],
listProductIngredientLocale?: [{	filter?: ValueTypes["ProductIngredientLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductIngredientLocale"]],
paginateProductIngredientLocale?: [{	filter?: ValueTypes["ProductIngredientLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductIngredientLocaleConnection"]],
validateCreateProductIngredientLocale?: [{	data: ValueTypes["ProductIngredientLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductIngredientLocale?: [{	by: ValueTypes["ProductIngredientLocaleUniqueWhere"],	data: ValueTypes["ProductIngredientLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getOrderRecurrence?: [{	by: ValueTypes["OrderRecurrenceUniqueWhere"],	filter?: ValueTypes["OrderRecurrenceWhere"] | undefined | null},ValueTypes["OrderRecurrence"]],
listOrderRecurrence?: [{	filter?: ValueTypes["OrderRecurrenceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderRecurrenceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["OrderRecurrence"]],
paginateOrderRecurrence?: [{	filter?: ValueTypes["OrderRecurrenceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderRecurrenceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderRecurrenceConnection"]],
validateCreateOrderRecurrence?: [{	data: ValueTypes["OrderRecurrenceCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateOrderRecurrence?: [{	by: ValueTypes["OrderRecurrenceUniqueWhere"],	data: ValueTypes["OrderRecurrenceUpdateInput"]},ValueTypes["_ValidationResult"]],
getOrderRecurrenceLocale?: [{	by: ValueTypes["OrderRecurrenceLocaleUniqueWhere"],	filter?: ValueTypes["OrderRecurrenceLocaleWhere"] | undefined | null},ValueTypes["OrderRecurrenceLocale"]],
listOrderRecurrenceLocale?: [{	filter?: ValueTypes["OrderRecurrenceLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderRecurrenceLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["OrderRecurrenceLocale"]],
paginateOrderRecurrenceLocale?: [{	filter?: ValueTypes["OrderRecurrenceLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderRecurrenceLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderRecurrenceLocaleConnection"]],
validateCreateOrderRecurrenceLocale?: [{	data: ValueTypes["OrderRecurrenceLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateOrderRecurrenceLocale?: [{	by: ValueTypes["OrderRecurrenceLocaleUniqueWhere"],	data: ValueTypes["OrderRecurrenceLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getBusinessCustomer?: [{	by: ValueTypes["BusinessCustomerUniqueWhere"],	filter?: ValueTypes["BusinessCustomerWhere"] | undefined | null},ValueTypes["BusinessCustomer"]],
listBusinessCustomer?: [{	filter?: ValueTypes["BusinessCustomerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessCustomerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BusinessCustomer"]],
paginateBusinessCustomer?: [{	filter?: ValueTypes["BusinessCustomerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessCustomerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BusinessCustomerConnection"]],
validateCreateBusinessCustomer?: [{	data: ValueTypes["BusinessCustomerCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBusinessCustomer?: [{	by: ValueTypes["BusinessCustomerUniqueWhere"],	data: ValueTypes["BusinessCustomerUpdateInput"]},ValueTypes["_ValidationResult"]],
getPointOfSale?: [{	by: ValueTypes["PointOfSaleUniqueWhere"],	filter?: ValueTypes["PointOfSaleWhere"] | undefined | null},ValueTypes["PointOfSale"]],
listPointOfSale?: [{	filter?: ValueTypes["PointOfSaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PointOfSale"]],
paginatePointOfSale?: [{	filter?: ValueTypes["PointOfSaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PointOfSaleConnection"]],
validateCreatePointOfSale?: [{	data: ValueTypes["PointOfSaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePointOfSale?: [{	by: ValueTypes["PointOfSaleUniqueWhere"],	data: ValueTypes["PointOfSaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getStaff?: [{	by: ValueTypes["StaffUniqueWhere"],	filter?: ValueTypes["StaffWhere"] | undefined | null},ValueTypes["Staff"]],
listStaff?: [{	filter?: ValueTypes["StaffWhere"] | undefined | null,	orderBy?: Array<ValueTypes["StaffOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Staff"]],
paginateStaff?: [{	filter?: ValueTypes["StaffWhere"] | undefined | null,	orderBy?: Array<ValueTypes["StaffOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["StaffConnection"]],
validateCreateStaff?: [{	data: ValueTypes["StaffCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateStaff?: [{	by: ValueTypes["StaffUniqueWhere"],	data: ValueTypes["StaffUpdateInput"]},ValueTypes["_ValidationResult"]],
getPointOfSalePermissions?: [{	by: ValueTypes["PointOfSalePermissionsUniqueWhere"],	filter?: ValueTypes["PointOfSalePermissionsWhere"] | undefined | null},ValueTypes["PointOfSalePermissions"]],
listPointOfSalePermissions?: [{	filter?: ValueTypes["PointOfSalePermissionsWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSalePermissionsOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PointOfSalePermissions"]],
paginatePointOfSalePermissions?: [{	filter?: ValueTypes["PointOfSalePermissionsWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSalePermissionsOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PointOfSalePermissionsConnection"]],
getBlog?: [{	by: ValueTypes["BlogUniqueWhere"],	filter?: ValueTypes["BlogWhere"] | undefined | null},ValueTypes["Blog"]],
listBlog?: [{	filter?: ValueTypes["BlogWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BlogOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Blog"]],
paginateBlog?: [{	filter?: ValueTypes["BlogWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BlogOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BlogConnection"]],
validateCreateBlog?: [{	data: ValueTypes["BlogCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBlog?: [{	by: ValueTypes["BlogUniqueWhere"],	data: ValueTypes["BlogUpdateInput"]},ValueTypes["_ValidationResult"]],
getBlogLocale?: [{	by: ValueTypes["BlogLocaleUniqueWhere"],	filter?: ValueTypes["BlogLocaleWhere"] | undefined | null},ValueTypes["BlogLocale"]],
listBlogLocale?: [{	filter?: ValueTypes["BlogLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BlogLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BlogLocale"]],
paginateBlogLocale?: [{	filter?: ValueTypes["BlogLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BlogLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BlogLocaleConnection"]],
validateCreateBlogLocale?: [{	data: ValueTypes["BlogLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBlogLocale?: [{	by: ValueTypes["BlogLocaleUniqueWhere"],	data: ValueTypes["BlogLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getBlogPost?: [{	by: ValueTypes["BlogPostUniqueWhere"],	filter?: ValueTypes["BlogPostWhere"] | undefined | null},ValueTypes["BlogPost"]],
listBlogPost?: [{	filter?: ValueTypes["BlogPostWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BlogPostOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BlogPost"]],
paginateBlogPost?: [{	filter?: ValueTypes["BlogPostWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BlogPostOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BlogPostConnection"]],
validateCreateBlogPost?: [{	data: ValueTypes["BlogPostCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBlogPost?: [{	by: ValueTypes["BlogPostUniqueWhere"],	data: ValueTypes["BlogPostUpdateInput"]},ValueTypes["_ValidationResult"]],
getBlogPostLocale?: [{	by: ValueTypes["BlogPostLocaleUniqueWhere"],	filter?: ValueTypes["BlogPostLocaleWhere"] | undefined | null},ValueTypes["BlogPostLocale"]],
listBlogPostLocale?: [{	filter?: ValueTypes["BlogPostLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BlogPostLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BlogPostLocale"]],
paginateBlogPostLocale?: [{	filter?: ValueTypes["BlogPostLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BlogPostLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BlogPostLocaleConnection"]],
validateCreateBlogPostLocale?: [{	data: ValueTypes["BlogPostLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBlogPostLocale?: [{	by: ValueTypes["BlogPostLocaleUniqueWhere"],	data: ValueTypes["BlogPostLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getColorPallete?: [{	by: ValueTypes["ColorPalleteUniqueWhere"],	filter?: ValueTypes["ColorPalleteWhere"] | undefined | null},ValueTypes["ColorPallete"]],
listColorPallete?: [{	filter?: ValueTypes["ColorPalleteWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ColorPalleteOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ColorPallete"]],
paginateColorPallete?: [{	filter?: ValueTypes["ColorPalleteWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ColorPalleteOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ColorPalleteConnection"]],
validateCreateColorPallete?: [{	data: ValueTypes["ColorPalleteCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateColorPallete?: [{	by: ValueTypes["ColorPalleteUniqueWhere"],	data: ValueTypes["ColorPalleteUpdateInput"]},ValueTypes["_ValidationResult"]],
getContent?: [{	by: ValueTypes["ContentUniqueWhere"],	filter?: ValueTypes["ContentWhere"] | undefined | null},ValueTypes["Content"]],
listContent?: [{	filter?: ValueTypes["ContentWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ContentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Content"]],
paginateContent?: [{	filter?: ValueTypes["ContentWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ContentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ContentConnection"]],
validateCreateContent?: [{	data: ValueTypes["ContentCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContent?: [{	by: ValueTypes["ContentUniqueWhere"],	data: ValueTypes["ContentUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentBlock?: [{	by: ValueTypes["ContentBlockUniqueWhere"],	filter?: ValueTypes["ContentBlockWhere"] | undefined | null},ValueTypes["ContentBlock"]],
listContentBlock?: [{	filter?: ValueTypes["ContentBlockWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ContentBlockOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ContentBlock"]],
paginateContentBlock?: [{	filter?: ValueTypes["ContentBlockWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ContentBlockOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ContentBlockConnection"]],
validateCreateContentBlock?: [{	data: ValueTypes["ContentBlockCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentBlock?: [{	by: ValueTypes["ContentBlockUniqueWhere"],	data: ValueTypes["ContentBlockUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentReference?: [{	by: ValueTypes["ContentReferenceUniqueWhere"],	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null},ValueTypes["ContentReference"]],
listContentReference?: [{	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ContentReferenceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ContentReference"]],
paginateContentReference?: [{	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ContentReferenceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ContentReferenceConnection"]],
validateCreateContentReference?: [{	data: ValueTypes["ContentReferenceCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentReference?: [{	by: ValueTypes["ContentReferenceUniqueWhere"],	data: ValueTypes["ContentReferenceUpdateInput"]},ValueTypes["_ValidationResult"]],
getBlogPostList?: [{	by: ValueTypes["BlogPostListUniqueWhere"],	filter?: ValueTypes["BlogPostListWhere"] | undefined | null},ValueTypes["BlogPostList"]],
listBlogPostList?: [{	filter?: ValueTypes["BlogPostListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BlogPostListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BlogPostList"]],
paginateBlogPostList?: [{	filter?: ValueTypes["BlogPostListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BlogPostListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BlogPostListConnection"]],
validateCreateBlogPostList?: [{	data: ValueTypes["BlogPostListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBlogPostList?: [{	by: ValueTypes["BlogPostListUniqueWhere"],	data: ValueTypes["BlogPostListUpdateInput"]},ValueTypes["_ValidationResult"]],
getBlogPostListItem?: [{	by: ValueTypes["BlogPostListItemUniqueWhere"],	filter?: ValueTypes["BlogPostListItemWhere"] | undefined | null},ValueTypes["BlogPostListItem"]],
listBlogPostListItem?: [{	filter?: ValueTypes["BlogPostListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BlogPostListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BlogPostListItem"]],
paginateBlogPostListItem?: [{	filter?: ValueTypes["BlogPostListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BlogPostListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BlogPostListItemConnection"]],
validateCreateBlogPostListItem?: [{	data: ValueTypes["BlogPostListItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBlogPostListItem?: [{	by: ValueTypes["BlogPostListItemUniqueWhere"],	data: ValueTypes["BlogPostListItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkList?: [{	by: ValueTypes["LinkListUniqueWhere"],	filter?: ValueTypes["LinkListWhere"] | undefined | null},ValueTypes["LinkList"]],
listLinkList?: [{	filter?: ValueTypes["LinkListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LinkListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["LinkList"]],
paginateLinkList?: [{	filter?: ValueTypes["LinkListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LinkListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["LinkListConnection"]],
validateCreateLinkList?: [{	data: ValueTypes["LinkListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkList?: [{	by: ValueTypes["LinkListUniqueWhere"],	data: ValueTypes["LinkListUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkListItem?: [{	by: ValueTypes["LinkListItemUniqueWhere"],	filter?: ValueTypes["LinkListItemWhere"] | undefined | null},ValueTypes["LinkListItem"]],
listLinkListItem?: [{	filter?: ValueTypes["LinkListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LinkListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["LinkListItem"]],
paginateLinkListItem?: [{	filter?: ValueTypes["LinkListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LinkListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["LinkListItemConnection"]],
validateCreateLinkListItem?: [{	data: ValueTypes["LinkListItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkListItem?: [{	by: ValueTypes["LinkListItemUniqueWhere"],	data: ValueTypes["LinkListItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getCover?: [{	by: ValueTypes["CoverUniqueWhere"],	filter?: ValueTypes["CoverWhere"] | undefined | null},ValueTypes["Cover"]],
listCover?: [{	filter?: ValueTypes["CoverWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CoverOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Cover"]],
paginateCover?: [{	filter?: ValueTypes["CoverWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CoverOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CoverConnection"]],
validateCreateCover?: [{	data: ValueTypes["CoverCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCover?: [{	by: ValueTypes["CoverUniqueWhere"],	data: ValueTypes["CoverUpdateInput"]},ValueTypes["_ValidationResult"]],
getLink?: [{	by: ValueTypes["LinkUniqueWhere"],	filter?: ValueTypes["LinkWhere"] | undefined | null},ValueTypes["Link"]],
listLink?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LinkOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Link"]],
paginateLink?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LinkOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["LinkConnection"]],
validateCreateLink?: [{	data: ValueTypes["LinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLink?: [{	by: ValueTypes["LinkUniqueWhere"],	data: ValueTypes["LinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkable?: [{	by: ValueTypes["LinkableUniqueWhere"],	filter?: ValueTypes["LinkableWhere"] | undefined | null},ValueTypes["Linkable"]],
listLinkable?: [{	filter?: ValueTypes["LinkableWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LinkableOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Linkable"]],
paginateLinkable?: [{	filter?: ValueTypes["LinkableWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LinkableOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["LinkableConnection"]],
validateCreateLinkable?: [{	data: ValueTypes["LinkableCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkable?: [{	by: ValueTypes["LinkableUniqueWhere"],	data: ValueTypes["LinkableUpdateInput"]},ValueTypes["_ValidationResult"]],
getMedium?: [{	by: ValueTypes["MediumUniqueWhere"],	filter?: ValueTypes["MediumWhere"] | undefined | null},ValueTypes["Medium"]],
listMedium?: [{	filter?: ValueTypes["MediumWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MediumOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Medium"]],
paginateMedium?: [{	filter?: ValueTypes["MediumWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MediumOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["MediumConnection"]],
validateCreateMedium?: [{	data: ValueTypes["MediumCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMedium?: [{	by: ValueTypes["MediumUniqueWhere"],	data: ValueTypes["MediumUpdateInput"]},ValueTypes["_ValidationResult"]],
getVideo?: [{	by: ValueTypes["VideoUniqueWhere"],	filter?: ValueTypes["VideoWhere"] | undefined | null},ValueTypes["Video"]],
listVideo?: [{	filter?: ValueTypes["VideoWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VideoOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Video"]],
paginateVideo?: [{	filter?: ValueTypes["VideoWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VideoOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["VideoConnection"]],
validateCreateVideo?: [{	data: ValueTypes["VideoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateVideo?: [{	by: ValueTypes["VideoUniqueWhere"],	data: ValueTypes["VideoUpdateInput"]},ValueTypes["_ValidationResult"]],
getSeo?: [{	by: ValueTypes["SeoUniqueWhere"],	filter?: ValueTypes["SeoWhere"] | undefined | null},ValueTypes["Seo"]],
listSeo?: [{	filter?: ValueTypes["SeoWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SeoOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Seo"]],
paginateSeo?: [{	filter?: ValueTypes["SeoWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SeoOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["SeoConnection"]],
validateCreateSeo?: [{	data: ValueTypes["SeoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSeo?: [{	by: ValueTypes["SeoUniqueWhere"],	data: ValueTypes["SeoUpdateInput"]},ValueTypes["_ValidationResult"]],
getProtectedImage?: [{	by: ValueTypes["ProtectedImageUniqueWhere"],	filter?: ValueTypes["ProtectedImageWhere"] | undefined | null},ValueTypes["ProtectedImage"]],
listProtectedImage?: [{	filter?: ValueTypes["ProtectedImageWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProtectedImageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProtectedImage"]],
paginateProtectedImage?: [{	filter?: ValueTypes["ProtectedImageWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProtectedImageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProtectedImageConnection"]],
validateCreateProtectedImage?: [{	data: ValueTypes["ProtectedImageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProtectedImage?: [{	by: ValueTypes["ProtectedImageUniqueWhere"],	data: ValueTypes["ProtectedImageUpdateInput"]},ValueTypes["_ValidationResult"]],
getTranslationDomain?: [{	by: ValueTypes["TranslationDomainUniqueWhere"],	filter?: ValueTypes["TranslationDomainWhere"] | undefined | null},ValueTypes["TranslationDomain"]],
listTranslationDomain?: [{	filter?: ValueTypes["TranslationDomainWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TranslationDomainOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TranslationDomain"]],
paginateTranslationDomain?: [{	filter?: ValueTypes["TranslationDomainWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TranslationDomainOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TranslationDomainConnection"]],
validateCreateTranslationDomain?: [{	data: ValueTypes["TranslationDomainCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTranslationDomain?: [{	by: ValueTypes["TranslationDomainUniqueWhere"],	data: ValueTypes["TranslationDomainUpdateInput"]},ValueTypes["_ValidationResult"]],
getTranslationCatalogue?: [{	by: ValueTypes["TranslationCatalogueUniqueWhere"],	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null},ValueTypes["TranslationCatalogue"]],
listTranslationCatalogue?: [{	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TranslationCatalogueOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TranslationCatalogue"]],
paginateTranslationCatalogue?: [{	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TranslationCatalogueOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TranslationCatalogueConnection"]],
validateCreateTranslationCatalogue?: [{	data: ValueTypes["TranslationCatalogueCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTranslationCatalogue?: [{	by: ValueTypes["TranslationCatalogueUniqueWhere"],	data: ValueTypes["TranslationCatalogueUpdateInput"]},ValueTypes["_ValidationResult"]],
getTranslationKey?: [{	by: ValueTypes["TranslationKeyUniqueWhere"],	filter?: ValueTypes["TranslationKeyWhere"] | undefined | null},ValueTypes["TranslationKey"]],
listTranslationKey?: [{	filter?: ValueTypes["TranslationKeyWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TranslationKeyOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TranslationKey"]],
paginateTranslationKey?: [{	filter?: ValueTypes["TranslationKeyWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TranslationKeyOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TranslationKeyConnection"]],
validateCreateTranslationKey?: [{	data: ValueTypes["TranslationKeyCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTranslationKey?: [{	by: ValueTypes["TranslationKeyUniqueWhere"],	data: ValueTypes["TranslationKeyUpdateInput"]},ValueTypes["_ValidationResult"]],
getTranslationValue?: [{	by: ValueTypes["TranslationValueUniqueWhere"],	filter?: ValueTypes["TranslationValueWhere"] | undefined | null},ValueTypes["TranslationValue"]],
listTranslationValue?: [{	filter?: ValueTypes["TranslationValueWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TranslationValueOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TranslationValue"]],
paginateTranslationValue?: [{	filter?: ValueTypes["TranslationValueWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TranslationValueOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TranslationValueConnection"]],
validateCreateTranslationValue?: [{	data: ValueTypes["TranslationValueCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTranslationValue?: [{	by: ValueTypes["TranslationValueUniqueWhere"],	data: ValueTypes["TranslationValueUpdateInput"]},ValueTypes["_ValidationResult"]],
getTranslationCataloguesIdentifier?: [{	by: ValueTypes["TranslationCataloguesIdentifierUniqueWhere"],	filter?: ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null},ValueTypes["TranslationCataloguesIdentifier"]],
listTranslationCataloguesIdentifier?: [{	filter?: ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TranslationCataloguesIdentifierOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TranslationCataloguesIdentifier"]],
paginateTranslationCataloguesIdentifier?: [{	filter?: ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TranslationCataloguesIdentifierOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TranslationCataloguesIdentifierConnection"]],
validateCreateTranslationCataloguesIdentifier?: [{	data: ValueTypes["TranslationCataloguesIdentifierCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTranslationCataloguesIdentifier?: [{	by: ValueTypes["TranslationCataloguesIdentifierUniqueWhere"],	data: ValueTypes["TranslationCataloguesIdentifierUpdateInput"]},ValueTypes["_ValidationResult"]],
getSocialsAndApps?: [{	by: ValueTypes["SocialsAndAppsUniqueWhere"],	filter?: ValueTypes["SocialsAndAppsWhere"] | undefined | null},ValueTypes["SocialsAndApps"]],
listSocialsAndApps?: [{	filter?: ValueTypes["SocialsAndAppsWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SocialsAndAppsOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["SocialsAndApps"]],
paginateSocialsAndApps?: [{	filter?: ValueTypes["SocialsAndAppsWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SocialsAndAppsOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["SocialsAndAppsConnection"]],
validateCreateSocialsAndApps?: [{	data: ValueTypes["SocialsAndAppsCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSocialsAndApps?: [{	by: ValueTypes["SocialsAndAppsUniqueWhere"],	data: ValueTypes["SocialsAndAppsUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductGrid?: [{	by: ValueTypes["ProductGridUniqueWhere"],	filter?: ValueTypes["ProductGridWhere"] | undefined | null},ValueTypes["ProductGrid"]],
listProductGrid?: [{	filter?: ValueTypes["ProductGridWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductGridOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductGrid"]],
paginateProductGrid?: [{	filter?: ValueTypes["ProductGridWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductGridOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductGridConnection"]],
validateCreateProductGrid?: [{	data: ValueTypes["ProductGridCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductGrid?: [{	by: ValueTypes["ProductGridUniqueWhere"],	data: ValueTypes["ProductGridUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductGridItem?: [{	by: ValueTypes["ProductGridItemUniqueWhere"],	filter?: ValueTypes["ProductGridItemWhere"] | undefined | null},ValueTypes["ProductGridItem"]],
listProductGridItem?: [{	filter?: ValueTypes["ProductGridItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductGridItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductGridItem"]],
paginateProductGridItem?: [{	filter?: ValueTypes["ProductGridItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductGridItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductGridItemConnection"]],
validateCreateProductGridItem?: [{	data: ValueTypes["ProductGridItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductGridItem?: [{	by: ValueTypes["ProductGridItemUniqueWhere"],	data: ValueTypes["ProductGridItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getGallery?: [{	by: ValueTypes["GalleryUniqueWhere"],	filter?: ValueTypes["GalleryWhere"] | undefined | null},ValueTypes["Gallery"]],
listGallery?: [{	filter?: ValueTypes["GalleryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["GalleryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Gallery"]],
paginateGallery?: [{	filter?: ValueTypes["GalleryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["GalleryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["GalleryConnection"]],
validateCreateGallery?: [{	data: ValueTypes["GalleryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateGallery?: [{	by: ValueTypes["GalleryUniqueWhere"],	data: ValueTypes["GalleryUpdateInput"]},ValueTypes["_ValidationResult"]],
getGalleryItem?: [{	by: ValueTypes["GalleryItemUniqueWhere"],	filter?: ValueTypes["GalleryItemWhere"] | undefined | null},ValueTypes["GalleryItem"]],
listGalleryItem?: [{	filter?: ValueTypes["GalleryItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["GalleryItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["GalleryItem"]],
paginateGalleryItem?: [{	filter?: ValueTypes["GalleryItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["GalleryItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["GalleryItemConnection"]],
validateCreateGalleryItem?: [{	data: ValueTypes["GalleryItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateGalleryItem?: [{	by: ValueTypes["GalleryItemUniqueWhere"],	data: ValueTypes["GalleryItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getHero?: [{	by: ValueTypes["HeroUniqueWhere"],	filter?: ValueTypes["HeroWhere"] | undefined | null},ValueTypes["Hero"]],
listHero?: [{	filter?: ValueTypes["HeroWhere"] | undefined | null,	orderBy?: Array<ValueTypes["HeroOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Hero"]],
paginateHero?: [{	filter?: ValueTypes["HeroWhere"] | undefined | null,	orderBy?: Array<ValueTypes["HeroOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["HeroConnection"]],
validateCreateHero?: [{	data: ValueTypes["HeroCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHero?: [{	by: ValueTypes["HeroUniqueWhere"],	data: ValueTypes["HeroUpdateInput"]},ValueTypes["_ValidationResult"]],
getSiteMenu?: [{	by: ValueTypes["SiteMenuUniqueWhere"],	filter?: ValueTypes["SiteMenuWhere"] | undefined | null},ValueTypes["SiteMenu"]],
listSiteMenu?: [{	filter?: ValueTypes["SiteMenuWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SiteMenuOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["SiteMenu"]],
paginateSiteMenu?: [{	filter?: ValueTypes["SiteMenuWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SiteMenuOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["SiteMenuConnection"]],
validateCreateSiteMenu?: [{	data: ValueTypes["SiteMenuCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSiteMenu?: [{	by: ValueTypes["SiteMenuUniqueWhere"],	data: ValueTypes["SiteMenuUpdateInput"]},ValueTypes["_ValidationResult"]],
getMenuLocale?: [{	by: ValueTypes["MenuLocaleUniqueWhere"],	filter?: ValueTypes["MenuLocaleWhere"] | undefined | null},ValueTypes["MenuLocale"]],
listMenuLocale?: [{	filter?: ValueTypes["MenuLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["MenuLocale"]],
paginateMenuLocale?: [{	filter?: ValueTypes["MenuLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["MenuLocaleConnection"]],
validateCreateMenuLocale?: [{	data: ValueTypes["MenuLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMenuLocale?: [{	by: ValueTypes["MenuLocaleUniqueWhere"],	data: ValueTypes["MenuLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getMenuItem?: [{	by: ValueTypes["MenuItemUniqueWhere"],	filter?: ValueTypes["MenuItemWhere"] | undefined | null},ValueTypes["MenuItem"]],
listMenuItem?: [{	filter?: ValueTypes["MenuItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["MenuItem"]],
paginateMenuItem?: [{	filter?: ValueTypes["MenuItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["MenuItemConnection"]],
validateCreateMenuItem?: [{	data: ValueTypes["MenuItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMenuItem?: [{	by: ValueTypes["MenuItemUniqueWhere"],	data: ValueTypes["MenuItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getPage?: [{	by: ValueTypes["PageUniqueWhere"],	filter?: ValueTypes["PageWhere"] | undefined | null},ValueTypes["Page"]],
listPage?: [{	filter?: ValueTypes["PageWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Page"]],
paginatePage?: [{	filter?: ValueTypes["PageWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PageConnection"]],
validateCreatePage?: [{	data: ValueTypes["PageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePage?: [{	by: ValueTypes["PageUniqueWhere"],	data: ValueTypes["PageUpdateInput"]},ValueTypes["_ValidationResult"]],
getPageLocale?: [{	by: ValueTypes["PageLocaleUniqueWhere"],	filter?: ValueTypes["PageLocaleWhere"] | undefined | null},ValueTypes["PageLocale"]],
listPageLocale?: [{	filter?: ValueTypes["PageLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PageLocale"]],
paginatePageLocale?: [{	filter?: ValueTypes["PageLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PageLocaleConnection"]],
validateCreatePageLocale?: [{	data: ValueTypes["PageLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePageLocale?: [{	by: ValueTypes["PageLocaleUniqueWhere"],	data: ValueTypes["PageLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getWikiPage?: [{	by: ValueTypes["WikiPageUniqueWhere"],	filter?: ValueTypes["WikiPageWhere"] | undefined | null},ValueTypes["WikiPage"]],
listWikiPage?: [{	filter?: ValueTypes["WikiPageWhere"] | undefined | null,	orderBy?: Array<ValueTypes["WikiPageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["WikiPage"]],
paginateWikiPage?: [{	filter?: ValueTypes["WikiPageWhere"] | undefined | null,	orderBy?: Array<ValueTypes["WikiPageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["WikiPageConnection"]],
validateCreateWikiPage?: [{	data: ValueTypes["WikiPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateWikiPage?: [{	by: ValueTypes["WikiPageUniqueWhere"],	data: ValueTypes["WikiPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getMenuSubitem?: [{	by: ValueTypes["MenuSubitemUniqueWhere"],	filter?: ValueTypes["MenuSubitemWhere"] | undefined | null},ValueTypes["MenuSubitem"]],
listMenuSubitem?: [{	filter?: ValueTypes["MenuSubitemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuSubitemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["MenuSubitem"]],
paginateMenuSubitem?: [{	filter?: ValueTypes["MenuSubitemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuSubitemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["MenuSubitemConnection"]],
validateCreateMenuSubitem?: [{	data: ValueTypes["MenuSubitemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMenuSubitem?: [{	by: ValueTypes["MenuSubitemUniqueWhere"],	data: ValueTypes["MenuSubitemUpdateInput"]},ValueTypes["_ValidationResult"]],
getMenuLinkList?: [{	by: ValueTypes["MenuLinkListUniqueWhere"],	filter?: ValueTypes["MenuLinkListWhere"] | undefined | null},ValueTypes["MenuLinkList"]],
listMenuLinkList?: [{	filter?: ValueTypes["MenuLinkListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuLinkListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["MenuLinkList"]],
paginateMenuLinkList?: [{	filter?: ValueTypes["MenuLinkListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuLinkListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["MenuLinkListConnection"]],
validateCreateMenuLinkList?: [{	data: ValueTypes["MenuLinkListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMenuLinkList?: [{	by: ValueTypes["MenuLinkListUniqueWhere"],	data: ValueTypes["MenuLinkListUpdateInput"]},ValueTypes["_ValidationResult"]],
getMenuLinkItem?: [{	by: ValueTypes["MenuLinkItemUniqueWhere"],	filter?: ValueTypes["MenuLinkItemWhere"] | undefined | null},ValueTypes["MenuLinkItem"]],
listMenuLinkItem?: [{	filter?: ValueTypes["MenuLinkItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuLinkItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["MenuLinkItem"]],
paginateMenuLinkItem?: [{	filter?: ValueTypes["MenuLinkItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuLinkItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["MenuLinkItemConnection"]],
validateCreateMenuLinkItem?: [{	data: ValueTypes["MenuLinkItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMenuLinkItem?: [{	by: ValueTypes["MenuLinkItemUniqueWhere"],	data: ValueTypes["MenuLinkItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getMenuProducts?: [{	by: ValueTypes["MenuProductsUniqueWhere"],	filter?: ValueTypes["MenuProductsWhere"] | undefined | null},ValueTypes["MenuProducts"]],
listMenuProducts?: [{	filter?: ValueTypes["MenuProductsWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuProductsOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["MenuProducts"]],
paginateMenuProducts?: [{	filter?: ValueTypes["MenuProductsWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuProductsOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["MenuProductsConnection"]],
validateCreateMenuProducts?: [{	data: ValueTypes["MenuProductsCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMenuProducts?: [{	by: ValueTypes["MenuProductsUniqueWhere"],	data: ValueTypes["MenuProductsUpdateInput"]},ValueTypes["_ValidationResult"]],
getMenuDelivery?: [{	by: ValueTypes["MenuDeliveryUniqueWhere"],	filter?: ValueTypes["MenuDeliveryWhere"] | undefined | null},ValueTypes["MenuDelivery"]],
listMenuDelivery?: [{	filter?: ValueTypes["MenuDeliveryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuDeliveryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["MenuDelivery"]],
paginateMenuDelivery?: [{	filter?: ValueTypes["MenuDeliveryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuDeliveryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["MenuDeliveryConnection"]],
validateCreateMenuDelivery?: [{	data: ValueTypes["MenuDeliveryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMenuDelivery?: [{	by: ValueTypes["MenuDeliveryUniqueWhere"],	data: ValueTypes["MenuDeliveryUpdateInput"]},ValueTypes["_ValidationResult"]],
getMenuContact?: [{	by: ValueTypes["MenuContactUniqueWhere"],	filter?: ValueTypes["MenuContactWhere"] | undefined | null},ValueTypes["MenuContact"]],
listMenuContact?: [{	filter?: ValueTypes["MenuContactWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuContactOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["MenuContact"]],
paginateMenuContact?: [{	filter?: ValueTypes["MenuContactWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuContactOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["MenuContactConnection"]],
validateCreateMenuContact?: [{	data: ValueTypes["MenuContactCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMenuContact?: [{	by: ValueTypes["MenuContactUniqueWhere"],	data: ValueTypes["MenuContactUpdateInput"]},ValueTypes["_ValidationResult"]],
getDeadlineTemplate?: [{	by: ValueTypes["DeadlineTemplateUniqueWhere"],	filter?: ValueTypes["DeadlineTemplateWhere"] | undefined | null},ValueTypes["DeadlineTemplate"]],
listDeadlineTemplate?: [{	filter?: ValueTypes["DeadlineTemplateWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeadlineTemplateOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["DeadlineTemplate"]],
paginateDeadlineTemplate?: [{	filter?: ValueTypes["DeadlineTemplateWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeadlineTemplateOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["DeadlineTemplateConnection"]],
validateCreateDeadlineTemplate?: [{	data: ValueTypes["DeadlineTemplateCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDeadlineTemplate?: [{	by: ValueTypes["DeadlineTemplateUniqueWhere"],	data: ValueTypes["DeadlineTemplateUpdateInput"]},ValueTypes["_ValidationResult"]],
getEmployeeQueue?: [{	by: ValueTypes["EmployeeQueueUniqueWhere"],	filter?: ValueTypes["EmployeeQueueWhere"] | undefined | null},ValueTypes["EmployeeQueue"]],
listEmployeeQueue?: [{	filter?: ValueTypes["EmployeeQueueWhere"] | undefined | null,	orderBy?: Array<ValueTypes["EmployeeQueueOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["EmployeeQueue"]],
paginateEmployeeQueue?: [{	filter?: ValueTypes["EmployeeQueueWhere"] | undefined | null,	orderBy?: Array<ValueTypes["EmployeeQueueOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["EmployeeQueueConnection"]],
validateCreateEmployeeQueue?: [{	data: ValueTypes["EmployeeQueueCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateEmployeeQueue?: [{	by: ValueTypes["EmployeeQueueUniqueWhere"],	data: ValueTypes["EmployeeQueueUpdateInput"]},ValueTypes["_ValidationResult"]],
getTimetableDay?: [{	by: ValueTypes["TimetableDayUniqueWhere"],	filter?: ValueTypes["TimetableDayWhere"] | undefined | null},ValueTypes["TimetableDay"]],
listTimetableDay?: [{	filter?: ValueTypes["TimetableDayWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableDayOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TimetableDay"]],
paginateTimetableDay?: [{	filter?: ValueTypes["TimetableDayWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableDayOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TimetableDayConnection"]],
validateCreateTimetableDay?: [{	data: ValueTypes["TimetableDayCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTimetableDay?: [{	by: ValueTypes["TimetableDayUniqueWhere"],	data: ValueTypes["TimetableDayUpdateInput"]},ValueTypes["_ValidationResult"]],
getTimetableEmployeeRole?: [{	by: ValueTypes["TimetableEmployeeRoleUniqueWhere"],	filter?: ValueTypes["TimetableEmployeeRoleWhere"] | undefined | null},ValueTypes["TimetableEmployeeRole"]],
listTimetableEmployeeRole?: [{	filter?: ValueTypes["TimetableEmployeeRoleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableEmployeeRoleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TimetableEmployeeRole"]],
paginateTimetableEmployeeRole?: [{	filter?: ValueTypes["TimetableEmployeeRoleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableEmployeeRoleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TimetableEmployeeRoleConnection"]],
validateCreateTimetableEmployeeRole?: [{	data: ValueTypes["TimetableEmployeeRoleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTimetableEmployeeRole?: [{	by: ValueTypes["TimetableEmployeeRoleUniqueWhere"],	data: ValueTypes["TimetableEmployeeRoleUpdateInput"]},ValueTypes["_ValidationResult"]],
getTimetableShift?: [{	by: ValueTypes["TimetableShiftUniqueWhere"],	filter?: ValueTypes["TimetableShiftWhere"] | undefined | null},ValueTypes["TimetableShift"]],
listTimetableShift?: [{	filter?: ValueTypes["TimetableShiftWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableShiftOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TimetableShift"]],
paginateTimetableShift?: [{	filter?: ValueTypes["TimetableShiftWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableShiftOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TimetableShiftConnection"]],
validateCreateTimetableShift?: [{	data: ValueTypes["TimetableShiftCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTimetableShift?: [{	by: ValueTypes["TimetableShiftUniqueWhere"],	data: ValueTypes["TimetableShiftUpdateInput"]},ValueTypes["_ValidationResult"]],
getTimetableShiftGroup?: [{	by: ValueTypes["TimetableShiftGroupUniqueWhere"],	filter?: ValueTypes["TimetableShiftGroupWhere"] | undefined | null},ValueTypes["TimetableShiftGroup"]],
listTimetableShiftGroup?: [{	filter?: ValueTypes["TimetableShiftGroupWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableShiftGroupOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TimetableShiftGroup"]],
paginateTimetableShiftGroup?: [{	filter?: ValueTypes["TimetableShiftGroupWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableShiftGroupOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TimetableShiftGroupConnection"]],
validateCreateTimetableShiftGroup?: [{	data: ValueTypes["TimetableShiftGroupCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTimetableShiftGroup?: [{	by: ValueTypes["TimetableShiftGroupUniqueWhere"],	data: ValueTypes["TimetableShiftGroupUpdateInput"]},ValueTypes["_ValidationResult"]],
getTimetableShiftPosition?: [{	by: ValueTypes["TimetableShiftPositionUniqueWhere"],	filter?: ValueTypes["TimetableShiftPositionWhere"] | undefined | null},ValueTypes["TimetableShiftPosition"]],
listTimetableShiftPosition?: [{	filter?: ValueTypes["TimetableShiftPositionWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableShiftPositionOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TimetableShiftPosition"]],
paginateTimetableShiftPosition?: [{	filter?: ValueTypes["TimetableShiftPositionWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableShiftPositionOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TimetableShiftPositionConnection"]],
validateCreateTimetableShiftPosition?: [{	data: ValueTypes["TimetableShiftPositionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTimetableShiftPosition?: [{	by: ValueTypes["TimetableShiftPositionUniqueWhere"],	data: ValueTypes["TimetableShiftPositionUpdateInput"]},ValueTypes["_ValidationResult"]],
getTimetableTemplate?: [{	by: ValueTypes["TimetableTemplateUniqueWhere"],	filter?: ValueTypes["TimetableTemplateWhere"] | undefined | null},ValueTypes["TimetableTemplate"]],
listTimetableTemplate?: [{	filter?: ValueTypes["TimetableTemplateWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableTemplateOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TimetableTemplate"]],
paginateTimetableTemplate?: [{	filter?: ValueTypes["TimetableTemplateWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableTemplateOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TimetableTemplateConnection"]],
validateCreateTimetableTemplate?: [{	data: ValueTypes["TimetableTemplateCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTimetableTemplate?: [{	by: ValueTypes["TimetableTemplateUniqueWhere"],	data: ValueTypes["TimetableTemplateUpdateInput"]},ValueTypes["_ValidationResult"]],
getCart?: [{	by: ValueTypes["CartUniqueWhere"],	filter?: ValueTypes["CartWhere"] | undefined | null},ValueTypes["Cart"]],
listCart?: [{	filter?: ValueTypes["CartWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CartOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Cart"]],
paginateCart?: [{	filter?: ValueTypes["CartWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CartOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CartConnection"]],
validateCreateCart?: [{	data: ValueTypes["CartCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCart?: [{	by: ValueTypes["CartUniqueWhere"],	data: ValueTypes["CartUpdateInput"]},ValueTypes["_ValidationResult"]],
getCartItem?: [{	by: ValueTypes["CartItemUniqueWhere"],	filter?: ValueTypes["CartItemWhere"] | undefined | null},ValueTypes["CartItem"]],
listCartItem?: [{	filter?: ValueTypes["CartItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CartItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CartItem"]],
paginateCartItem?: [{	filter?: ValueTypes["CartItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CartItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CartItemConnection"]],
validateCreateCartItem?: [{	data: ValueTypes["CartItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCartItem?: [{	by: ValueTypes["CartItemUniqueWhere"],	data: ValueTypes["CartItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getEmployeeQueueItem?: [{	by: ValueTypes["EmployeeQueueItemUniqueWhere"],	filter?: ValueTypes["EmployeeQueueItemWhere"] | undefined | null},ValueTypes["EmployeeQueueItem"]],
listEmployeeQueueItem?: [{	filter?: ValueTypes["EmployeeQueueItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["EmployeeQueueItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["EmployeeQueueItem"]],
paginateEmployeeQueueItem?: [{	filter?: ValueTypes["EmployeeQueueItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["EmployeeQueueItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["EmployeeQueueItemConnection"]],
validateCreateEmployeeQueueItem?: [{	data: ValueTypes["EmployeeQueueItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateEmployeeQueueItem?: [{	by: ValueTypes["EmployeeQueueItemUniqueWhere"],	data: ValueTypes["EmployeeQueueItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getApplication?: [{	by: ValueTypes["ApplicationUniqueWhere"],	filter?: ValueTypes["ApplicationWhere"] | undefined | null},ValueTypes["Application"]],
listApplication?: [{	filter?: ValueTypes["ApplicationWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ApplicationOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Application"]],
paginateApplication?: [{	filter?: ValueTypes["ApplicationWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ApplicationOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ApplicationConnection"]],
validateCreateApplication?: [{	data: ValueTypes["ApplicationCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateApplication?: [{	by: ValueTypes["ApplicationUniqueWhere"],	data: ValueTypes["ApplicationUpdateInput"]},ValueTypes["_ValidationResult"]],
getApplicationShortcutList?: [{	by: ValueTypes["ApplicationShortcutListUniqueWhere"],	filter?: ValueTypes["ApplicationShortcutListWhere"] | undefined | null},ValueTypes["ApplicationShortcutList"]],
listApplicationShortcutList?: [{	filter?: ValueTypes["ApplicationShortcutListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ApplicationShortcutListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ApplicationShortcutList"]],
paginateApplicationShortcutList?: [{	filter?: ValueTypes["ApplicationShortcutListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ApplicationShortcutListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ApplicationShortcutListConnection"]],
validateCreateApplicationShortcutList?: [{	data: ValueTypes["ApplicationShortcutListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateApplicationShortcutList?: [{	by: ValueTypes["ApplicationShortcutListUniqueWhere"],	data: ValueTypes["ApplicationShortcutListUpdateInput"]},ValueTypes["_ValidationResult"]],
getApplicationShortcutListItem?: [{	by: ValueTypes["ApplicationShortcutListItemUniqueWhere"],	filter?: ValueTypes["ApplicationShortcutListItemWhere"] | undefined | null},ValueTypes["ApplicationShortcutListItem"]],
listApplicationShortcutListItem?: [{	filter?: ValueTypes["ApplicationShortcutListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ApplicationShortcutListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ApplicationShortcutListItem"]],
paginateApplicationShortcutListItem?: [{	filter?: ValueTypes["ApplicationShortcutListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ApplicationShortcutListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ApplicationShortcutListItemConnection"]],
validateCreateApplicationShortcutListItem?: [{	data: ValueTypes["ApplicationShortcutListItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateApplicationShortcutListItem?: [{	by: ValueTypes["ApplicationShortcutListItemUniqueWhere"],	data: ValueTypes["ApplicationShortcutListItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductBanner?: [{	by: ValueTypes["ProductBannerUniqueWhere"],	filter?: ValueTypes["ProductBannerWhere"] | undefined | null},ValueTypes["ProductBanner"]],
listProductBanner?: [{	filter?: ValueTypes["ProductBannerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductBannerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductBanner"]],
paginateProductBanner?: [{	filter?: ValueTypes["ProductBannerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductBannerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductBannerConnection"]],
validateCreateProductBanner?: [{	data: ValueTypes["ProductBannerCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductBanner?: [{	by: ValueTypes["ProductBannerUniqueWhere"],	data: ValueTypes["ProductBannerUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductBannerItem?: [{	by: ValueTypes["ProductBannerItemUniqueWhere"],	filter?: ValueTypes["ProductBannerItemWhere"] | undefined | null},ValueTypes["ProductBannerItem"]],
listProductBannerItem?: [{	filter?: ValueTypes["ProductBannerItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductBannerItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductBannerItem"]],
paginateProductBannerItem?: [{	filter?: ValueTypes["ProductBannerItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductBannerItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductBannerItemConnection"]],
validateCreateProductBannerItem?: [{	data: ValueTypes["ProductBannerItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductBannerItem?: [{	by: ValueTypes["ProductBannerItemUniqueWhere"],	data: ValueTypes["ProductBannerItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductBannerList?: [{	by: ValueTypes["ProductBannerListUniqueWhere"],	filter?: ValueTypes["ProductBannerListWhere"] | undefined | null},ValueTypes["ProductBannerList"]],
listProductBannerList?: [{	filter?: ValueTypes["ProductBannerListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductBannerListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductBannerList"]],
paginateProductBannerList?: [{	filter?: ValueTypes["ProductBannerListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductBannerListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductBannerListConnection"]],
validateCreateProductBannerList?: [{	data: ValueTypes["ProductBannerListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductBannerList?: [{	by: ValueTypes["ProductBannerListUniqueWhere"],	data: ValueTypes["ProductBannerListUpdateInput"]},ValueTypes["_ValidationResult"]],
getBartender?: [{	by: ValueTypes["BartenderUniqueWhere"],	filter?: ValueTypes["BartenderWhere"] | undefined | null},ValueTypes["Bartender"]],
listBartender?: [{	filter?: ValueTypes["BartenderWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BartenderOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Bartender"]],
paginateBartender?: [{	filter?: ValueTypes["BartenderWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BartenderOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BartenderConnection"]],
validateCreateBartender?: [{	data: ValueTypes["BartenderCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBartender?: [{	by: ValueTypes["BartenderUniqueWhere"],	data: ValueTypes["BartenderUpdateInput"]},ValueTypes["_ValidationResult"]],
getBusinessToBusinessManager?: [{	by: ValueTypes["BusinessToBusinessManagerUniqueWhere"],	filter?: ValueTypes["BusinessToBusinessManagerWhere"] | undefined | null},ValueTypes["BusinessToBusinessManager"]],
listBusinessToBusinessManager?: [{	filter?: ValueTypes["BusinessToBusinessManagerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessToBusinessManagerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BusinessToBusinessManager"]],
paginateBusinessToBusinessManager?: [{	filter?: ValueTypes["BusinessToBusinessManagerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessToBusinessManagerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BusinessToBusinessManagerConnection"]],
validateCreateBusinessToBusinessManager?: [{	data: ValueTypes["BusinessToBusinessManagerCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBusinessToBusinessManager?: [{	by: ValueTypes["BusinessToBusinessManagerUniqueWhere"],	data: ValueTypes["BusinessToBusinessManagerUpdateInput"]},ValueTypes["_ValidationResult"]],
getCleaner?: [{	by: ValueTypes["CleanerUniqueWhere"],	filter?: ValueTypes["CleanerWhere"] | undefined | null},ValueTypes["Cleaner"]],
listCleaner?: [{	filter?: ValueTypes["CleanerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CleanerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Cleaner"]],
paginateCleaner?: [{	filter?: ValueTypes["CleanerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CleanerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CleanerConnection"]],
validateCreateCleaner?: [{	data: ValueTypes["CleanerCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCleaner?: [{	by: ValueTypes["CleanerUniqueWhere"],	data: ValueTypes["CleanerUpdateInput"]},ValueTypes["_ValidationResult"]],
getCourier?: [{	by: ValueTypes["CourierUniqueWhere"],	filter?: ValueTypes["CourierWhere"] | undefined | null},ValueTypes["Courier"]],
listCourier?: [{	filter?: ValueTypes["CourierWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CourierOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Courier"]],
paginateCourier?: [{	filter?: ValueTypes["CourierWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CourierOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CourierConnection"]],
validateCreateCourier?: [{	data: ValueTypes["CourierCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCourier?: [{	by: ValueTypes["CourierUniqueWhere"],	data: ValueTypes["CourierUpdateInput"]},ValueTypes["_ValidationResult"]],
getShiftsManager?: [{	by: ValueTypes["ShiftsManagerUniqueWhere"],	filter?: ValueTypes["ShiftsManagerWhere"] | undefined | null},ValueTypes["ShiftsManager"]],
listShiftsManager?: [{	filter?: ValueTypes["ShiftsManagerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ShiftsManagerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ShiftsManager"]],
paginateShiftsManager?: [{	filter?: ValueTypes["ShiftsManagerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ShiftsManagerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ShiftsManagerConnection"]],
validateCreateShiftsManager?: [{	data: ValueTypes["ShiftsManagerCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateShiftsManager?: [{	by: ValueTypes["ShiftsManagerUniqueWhere"],	data: ValueTypes["ShiftsManagerUpdateInput"]},ValueTypes["_ValidationResult"]],
getUser?: [{	by: ValueTypes["UserUniqueWhere"],	filter?: ValueTypes["UserWhere"] | undefined | null},ValueTypes["User"]],
listUser?: [{	filter?: ValueTypes["UserWhere"] | undefined | null,	orderBy?: Array<ValueTypes["UserOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["User"]],
paginateUser?: [{	filter?: ValueTypes["UserWhere"] | undefined | null,	orderBy?: Array<ValueTypes["UserOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["UserConnection"]],
validateCreateUser?: [{	data: ValueTypes["UserCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateUser?: [{	by: ValueTypes["UserUniqueWhere"],	data: ValueTypes["UserUpdateInput"]},ValueTypes["_ValidationResult"]],
getShiftsProfile?: [{	by: ValueTypes["ShiftsProfileUniqueWhere"],	filter?: ValueTypes["ShiftsProfileWhere"] | undefined | null},ValueTypes["ShiftsProfile"]],
listShiftsProfile?: [{	filter?: ValueTypes["ShiftsProfileWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ShiftsProfileOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ShiftsProfile"]],
paginateShiftsProfile?: [{	filter?: ValueTypes["ShiftsProfileWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ShiftsProfileOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ShiftsProfileConnection"]],
validateCreateShiftsProfile?: [{	data: ValueTypes["ShiftsProfileCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateShiftsProfile?: [{	by: ValueTypes["ShiftsProfileUniqueWhere"],	data: ValueTypes["ShiftsProfileUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductIngredientCategory?: [{	by: ValueTypes["ProductIngredientCategoryUniqueWhere"],	filter?: ValueTypes["ProductIngredientCategoryWhere"] | undefined | null},ValueTypes["ProductIngredientCategory"]],
listProductIngredientCategory?: [{	filter?: ValueTypes["ProductIngredientCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientCategoryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductIngredientCategory"]],
paginateProductIngredientCategory?: [{	filter?: ValueTypes["ProductIngredientCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientCategoryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductIngredientCategoryConnection"]],
validateCreateProductIngredientCategory?: [{	data: ValueTypes["ProductIngredientCategoryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductIngredientCategory?: [{	by: ValueTypes["ProductIngredientCategoryUniqueWhere"],	data: ValueTypes["ProductIngredientCategoryUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductIngredientCategoryLocale?: [{	by: ValueTypes["ProductIngredientCategoryLocaleUniqueWhere"],	filter?: ValueTypes["ProductIngredientCategoryLocaleWhere"] | undefined | null},ValueTypes["ProductIngredientCategoryLocale"]],
listProductIngredientCategoryLocale?: [{	filter?: ValueTypes["ProductIngredientCategoryLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientCategoryLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductIngredientCategoryLocale"]],
paginateProductIngredientCategoryLocale?: [{	filter?: ValueTypes["ProductIngredientCategoryLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientCategoryLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductIngredientCategoryLocaleConnection"]],
validateCreateProductIngredientCategoryLocale?: [{	data: ValueTypes["ProductIngredientCategoryLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductIngredientCategoryLocale?: [{	by: ValueTypes["ProductIngredientCategoryLocaleUniqueWhere"],	data: ValueTypes["ProductIngredientCategoryLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getStocksManager?: [{	by: ValueTypes["StocksManagerUniqueWhere"],	filter?: ValueTypes["StocksManagerWhere"] | undefined | null},ValueTypes["StocksManager"]],
listStocksManager?: [{	filter?: ValueTypes["StocksManagerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["StocksManagerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["StocksManager"]],
paginateStocksManager?: [{	filter?: ValueTypes["StocksManagerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["StocksManagerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["StocksManagerConnection"]],
validateCreateStocksManager?: [{	data: ValueTypes["StocksManagerCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateStocksManager?: [{	by: ValueTypes["StocksManagerUniqueWhere"],	data: ValueTypes["StocksManagerUpdateInput"]},ValueTypes["_ValidationResult"]],
getDeliveryRoute?: [{	by: ValueTypes["DeliveryRouteUniqueWhere"],	filter?: ValueTypes["DeliveryRouteWhere"] | undefined | null},ValueTypes["DeliveryRoute"]],
listDeliveryRoute?: [{	filter?: ValueTypes["DeliveryRouteWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryRouteOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["DeliveryRoute"]],
paginateDeliveryRoute?: [{	filter?: ValueTypes["DeliveryRouteWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryRouteOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["DeliveryRouteConnection"]],
validateCreateDeliveryRoute?: [{	data: ValueTypes["DeliveryRouteCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDeliveryRoute?: [{	by: ValueTypes["DeliveryRouteUniqueWhere"],	data: ValueTypes["DeliveryRouteUpdateInput"]},ValueTypes["_ValidationResult"]],
getDeliveryWaypoint?: [{	by: ValueTypes["DeliveryWaypointUniqueWhere"],	filter?: ValueTypes["DeliveryWaypointWhere"] | undefined | null},ValueTypes["DeliveryWaypoint"]],
listDeliveryWaypoint?: [{	filter?: ValueTypes["DeliveryWaypointWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryWaypointOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["DeliveryWaypoint"]],
paginateDeliveryWaypoint?: [{	filter?: ValueTypes["DeliveryWaypointWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryWaypointOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["DeliveryWaypointConnection"]],
validateCreateDeliveryWaypoint?: [{	data: ValueTypes["DeliveryWaypointCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDeliveryWaypoint?: [{	by: ValueTypes["DeliveryWaypointUniqueWhere"],	data: ValueTypes["DeliveryWaypointUpdateInput"]},ValueTypes["_ValidationResult"]],
getAllergen?: [{	by: ValueTypes["AllergenUniqueWhere"],	filter?: ValueTypes["AllergenWhere"] | undefined | null},ValueTypes["Allergen"]],
listAllergen?: [{	filter?: ValueTypes["AllergenWhere"] | undefined | null,	orderBy?: Array<ValueTypes["AllergenOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Allergen"]],
paginateAllergen?: [{	filter?: ValueTypes["AllergenWhere"] | undefined | null,	orderBy?: Array<ValueTypes["AllergenOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["AllergenConnection"]],
validateCreateAllergen?: [{	data: ValueTypes["AllergenCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateAllergen?: [{	by: ValueTypes["AllergenUniqueWhere"],	data: ValueTypes["AllergenUpdateInput"]},ValueTypes["_ValidationResult"]],
getAllergenLocale?: [{	by: ValueTypes["AllergenLocaleUniqueWhere"],	filter?: ValueTypes["AllergenLocaleWhere"] | undefined | null},ValueTypes["AllergenLocale"]],
listAllergenLocale?: [{	filter?: ValueTypes["AllergenLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["AllergenLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["AllergenLocale"]],
paginateAllergenLocale?: [{	filter?: ValueTypes["AllergenLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["AllergenLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["AllergenLocaleConnection"]],
validateCreateAllergenLocale?: [{	data: ValueTypes["AllergenLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateAllergenLocale?: [{	by: ValueTypes["AllergenLocaleUniqueWhere"],	data: ValueTypes["AllergenLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getGps?: [{	by: ValueTypes["GpsUniqueWhere"],	filter?: ValueTypes["GpsWhere"] | undefined | null},ValueTypes["Gps"]],
listGps?: [{	filter?: ValueTypes["GpsWhere"] | undefined | null,	orderBy?: Array<ValueTypes["GpsOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Gps"]],
paginateGps?: [{	filter?: ValueTypes["GpsWhere"] | undefined | null,	orderBy?: Array<ValueTypes["GpsOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["GpsConnection"]],
validateCreateGps?: [{	data: ValueTypes["GpsCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateGps?: [{	by: ValueTypes["GpsUniqueWhere"],	data: ValueTypes["GpsUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductCategoryTree?: [{	by: ValueTypes["ProductCategoryTreeUniqueWhere"],	filter?: ValueTypes["ProductCategoryTreeWhere"] | undefined | null},ValueTypes["ProductCategoryTree"]],
listProductCategoryTree?: [{	filter?: ValueTypes["ProductCategoryTreeWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCategoryTreeOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductCategoryTree"]],
paginateProductCategoryTree?: [{	filter?: ValueTypes["ProductCategoryTreeWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCategoryTreeOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductCategoryTreeConnection"]],
getInheritedProductCategoryTag?: [{	by: ValueTypes["InheritedProductCategoryTagUniqueWhere"],	filter?: ValueTypes["InheritedProductCategoryTagWhere"] | undefined | null},ValueTypes["InheritedProductCategoryTag"]],
listInheritedProductCategoryTag?: [{	filter?: ValueTypes["InheritedProductCategoryTagWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InheritedProductCategoryTagOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["InheritedProductCategoryTag"]],
paginateInheritedProductCategoryTag?: [{	filter?: ValueTypes["InheritedProductCategoryTagWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InheritedProductCategoryTagOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["InheritedProductCategoryTagConnection"]],
getNestedProductCategoryProduct?: [{	by: ValueTypes["NestedProductCategoryProductUniqueWhere"],	filter?: ValueTypes["NestedProductCategoryProductWhere"] | undefined | null},ValueTypes["NestedProductCategoryProduct"]],
listNestedProductCategoryProduct?: [{	filter?: ValueTypes["NestedProductCategoryProductWhere"] | undefined | null,	orderBy?: Array<ValueTypes["NestedProductCategoryProductOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["NestedProductCategoryProduct"]],
paginateNestedProductCategoryProduct?: [{	filter?: ValueTypes["NestedProductCategoryProductWhere"] | undefined | null,	orderBy?: Array<ValueTypes["NestedProductCategoryProductOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["NestedProductCategoryProductConnection"]],
getWeekHours?: [{	by: ValueTypes["WeekHoursUniqueWhere"],	filter?: ValueTypes["WeekHoursWhere"] | undefined | null},ValueTypes["WeekHours"]],
listWeekHours?: [{	filter?: ValueTypes["WeekHoursWhere"] | undefined | null,	orderBy?: Array<ValueTypes["WeekHoursOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["WeekHours"]],
paginateWeekHours?: [{	filter?: ValueTypes["WeekHoursWhere"] | undefined | null,	orderBy?: Array<ValueTypes["WeekHoursOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["WeekHoursConnection"]],
validateCreateWeekHours?: [{	data: ValueTypes["WeekHoursCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateWeekHours?: [{	by: ValueTypes["WeekHoursUniqueWhere"],	data: ValueTypes["WeekHoursUpdateInput"]},ValueTypes["_ValidationResult"]],
getPreparedIngredientQuantity?: [{	by: ValueTypes["PreparedIngredientQuantityUniqueWhere"],	filter?: ValueTypes["PreparedIngredientQuantityWhere"] | undefined | null},ValueTypes["PreparedIngredientQuantity"]],
listPreparedIngredientQuantity?: [{	filter?: ValueTypes["PreparedIngredientQuantityWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PreparedIngredientQuantityOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PreparedIngredientQuantity"]],
paginatePreparedIngredientQuantity?: [{	filter?: ValueTypes["PreparedIngredientQuantityWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PreparedIngredientQuantityOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PreparedIngredientQuantityConnection"]],
validateCreatePreparedIngredientQuantity?: [{	data: ValueTypes["PreparedIngredientQuantityCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePreparedIngredientQuantity?: [{	by: ValueTypes["PreparedIngredientQuantityUniqueWhere"],	data: ValueTypes["PreparedIngredientQuantityUpdateInput"]},ValueTypes["_ValidationResult"]],
getPreparedRecipeQuantity?: [{	by: ValueTypes["PreparedRecipeQuantityUniqueWhere"],	filter?: ValueTypes["PreparedRecipeQuantityWhere"] | undefined | null},ValueTypes["PreparedRecipeQuantity"]],
listPreparedRecipeQuantity?: [{	filter?: ValueTypes["PreparedRecipeQuantityWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PreparedRecipeQuantityOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PreparedRecipeQuantity"]],
paginatePreparedRecipeQuantity?: [{	filter?: ValueTypes["PreparedRecipeQuantityWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PreparedRecipeQuantityOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PreparedRecipeQuantityConnection"]],
validateCreatePreparedRecipeQuantity?: [{	data: ValueTypes["PreparedRecipeQuantityCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePreparedRecipeQuantity?: [{	by: ValueTypes["PreparedRecipeQuantityUniqueWhere"],	data: ValueTypes["PreparedRecipeQuantityUpdateInput"]},ValueTypes["_ValidationResult"]],
getInternalOrder?: [{	by: ValueTypes["InternalOrderUniqueWhere"],	filter?: ValueTypes["InternalOrderWhere"] | undefined | null},ValueTypes["InternalOrder"]],
listInternalOrder?: [{	filter?: ValueTypes["InternalOrderWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InternalOrderOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["InternalOrder"]],
paginateInternalOrder?: [{	filter?: ValueTypes["InternalOrderWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InternalOrderOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["InternalOrderConnection"]],
validateCreateInternalOrder?: [{	data: ValueTypes["InternalOrderCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateInternalOrder?: [{	by: ValueTypes["InternalOrderUniqueWhere"],	data: ValueTypes["InternalOrderUpdateInput"]},ValueTypes["_ValidationResult"]],
getInternalOrderItem?: [{	by: ValueTypes["InternalOrderItemUniqueWhere"],	filter?: ValueTypes["InternalOrderItemWhere"] | undefined | null},ValueTypes["InternalOrderItem"]],
listInternalOrderItem?: [{	filter?: ValueTypes["InternalOrderItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InternalOrderItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["InternalOrderItem"]],
paginateInternalOrderItem?: [{	filter?: ValueTypes["InternalOrderItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InternalOrderItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["InternalOrderItemConnection"]],
validateCreateInternalOrderItem?: [{	data: ValueTypes["InternalOrderItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateInternalOrderItem?: [{	by: ValueTypes["InternalOrderItemUniqueWhere"],	data: ValueTypes["InternalOrderItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getPreparedPackingQuantity?: [{	by: ValueTypes["PreparedPackingQuantityUniqueWhere"],	filter?: ValueTypes["PreparedPackingQuantityWhere"] | undefined | null},ValueTypes["PreparedPackingQuantity"]],
listPreparedPackingQuantity?: [{	filter?: ValueTypes["PreparedPackingQuantityWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PreparedPackingQuantityOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PreparedPackingQuantity"]],
paginatePreparedPackingQuantity?: [{	filter?: ValueTypes["PreparedPackingQuantityWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PreparedPackingQuantityOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PreparedPackingQuantityConnection"]],
validateCreatePreparedPackingQuantity?: [{	data: ValueTypes["PreparedPackingQuantityCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePreparedPackingQuantity?: [{	by: ValueTypes["PreparedPackingQuantityUniqueWhere"],	data: ValueTypes["PreparedPackingQuantityUpdateInput"]},ValueTypes["_ValidationResult"]],
getCourierManager?: [{	by: ValueTypes["CourierManagerUniqueWhere"],	filter?: ValueTypes["CourierManagerWhere"] | undefined | null},ValueTypes["CourierManager"]],
listCourierManager?: [{	filter?: ValueTypes["CourierManagerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CourierManagerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CourierManager"]],
paginateCourierManager?: [{	filter?: ValueTypes["CourierManagerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CourierManagerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CourierManagerConnection"]],
validateCreateCourierManager?: [{	data: ValueTypes["CourierManagerCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCourierManager?: [{	by: ValueTypes["CourierManagerUniqueWhere"],	data: ValueTypes["CourierManagerUpdateInput"]},ValueTypes["_ValidationResult"]],
getDeliveryZone?: [{	by: ValueTypes["DeliveryZoneUniqueWhere"],	filter?: ValueTypes["DeliveryZoneWhere"] | undefined | null},ValueTypes["DeliveryZone"]],
listDeliveryZone?: [{	filter?: ValueTypes["DeliveryZoneWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryZoneOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["DeliveryZone"]],
paginateDeliveryZone?: [{	filter?: ValueTypes["DeliveryZoneWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryZoneOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["DeliveryZoneConnection"]],
validateCreateDeliveryZone?: [{	data: ValueTypes["DeliveryZoneCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDeliveryZone?: [{	by: ValueTypes["DeliveryZoneUniqueWhere"],	data: ValueTypes["DeliveryZoneUpdateInput"]},ValueTypes["_ValidationResult"]],
getAddressMetadata?: [{	by: ValueTypes["AddressMetadataUniqueWhere"],	filter?: ValueTypes["AddressMetadataWhere"] | undefined | null},ValueTypes["AddressMetadata"]],
listAddressMetadata?: [{	filter?: ValueTypes["AddressMetadataWhere"] | undefined | null,	orderBy?: Array<ValueTypes["AddressMetadataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["AddressMetadata"]],
paginateAddressMetadata?: [{	filter?: ValueTypes["AddressMetadataWhere"] | undefined | null,	orderBy?: Array<ValueTypes["AddressMetadataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["AddressMetadataConnection"]],
getDeliveryTimelinePreset?: [{	by: ValueTypes["DeliveryTimelinePresetUniqueWhere"],	filter?: ValueTypes["DeliveryTimelinePresetWhere"] | undefined | null},ValueTypes["DeliveryTimelinePreset"]],
listDeliveryTimelinePreset?: [{	filter?: ValueTypes["DeliveryTimelinePresetWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryTimelinePresetOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["DeliveryTimelinePreset"]],
paginateDeliveryTimelinePreset?: [{	filter?: ValueTypes["DeliveryTimelinePresetWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryTimelinePresetOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["DeliveryTimelinePresetConnection"]],
validateCreateDeliveryTimelinePreset?: [{	data: ValueTypes["DeliveryTimelinePresetCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDeliveryTimelinePreset?: [{	by: ValueTypes["DeliveryTimelinePresetUniqueWhere"],	data: ValueTypes["DeliveryTimelinePresetUpdateInput"]},ValueTypes["_ValidationResult"]],
getOrderDeliveryTimeline?: [{	by: ValueTypes["OrderDeliveryTimelineUniqueWhere"],	filter?: ValueTypes["OrderDeliveryTimelineWhere"] | undefined | null},ValueTypes["OrderDeliveryTimeline"]],
listOrderDeliveryTimeline?: [{	filter?: ValueTypes["OrderDeliveryTimelineWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderDeliveryTimelineOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["OrderDeliveryTimeline"]],
paginateOrderDeliveryTimeline?: [{	filter?: ValueTypes["OrderDeliveryTimelineWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderDeliveryTimelineOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderDeliveryTimelineConnection"]],
validateCreateOrderDeliveryTimeline?: [{	data: ValueTypes["OrderDeliveryTimelineCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateOrderDeliveryTimeline?: [{	by: ValueTypes["OrderDeliveryTimelineUniqueWhere"],	data: ValueTypes["OrderDeliveryTimelineUpdateInput"]},ValueTypes["_ValidationResult"]],
getOrderEvent?: [{	by: ValueTypes["OrderEventUniqueWhere"],	filter?: ValueTypes["OrderEventWhere"] | undefined | null},ValueTypes["OrderEvent"]],
listOrderEvent?: [{	filter?: ValueTypes["OrderEventWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderEventOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["OrderEvent"]],
paginateOrderEvent?: [{	filter?: ValueTypes["OrderEventWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderEventOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderEventConnection"]],
validateCreateOrderEvent?: [{	data: ValueTypes["OrderEventCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateOrderEvent?: [{	by: ValueTypes["OrderEventUniqueWhere"],	data: ValueTypes["OrderEventUpdateInput"]},ValueTypes["_ValidationResult"]],
getLiftagoRide?: [{	by: ValueTypes["LiftagoRideUniqueWhere"],	filter?: ValueTypes["LiftagoRideWhere"] | undefined | null},ValueTypes["LiftagoRide"]],
listLiftagoRide?: [{	filter?: ValueTypes["LiftagoRideWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LiftagoRideOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["LiftagoRide"]],
paginateLiftagoRide?: [{	filter?: ValueTypes["LiftagoRideWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LiftagoRideOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["LiftagoRideConnection"]],
validateCreateLiftagoRide?: [{	data: ValueTypes["LiftagoRideCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLiftagoRide?: [{	by: ValueTypes["LiftagoRideUniqueWhere"],	data: ValueTypes["LiftagoRideUpdateInput"]},ValueTypes["_ValidationResult"]],
getInvoice?: [{	by: ValueTypes["InvoiceUniqueWhere"],	filter?: ValueTypes["InvoiceWhere"] | undefined | null},ValueTypes["Invoice"]],
listInvoice?: [{	filter?: ValueTypes["InvoiceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InvoiceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Invoice"]],
paginateInvoice?: [{	filter?: ValueTypes["InvoiceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InvoiceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["InvoiceConnection"]],
validateCreateInvoice?: [{	data: ValueTypes["InvoiceCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateInvoice?: [{	by: ValueTypes["InvoiceUniqueWhere"],	data: ValueTypes["InvoiceUpdateInput"]},ValueTypes["_ValidationResult"]],
getInvoicingPlan?: [{	by: ValueTypes["InvoicingPlanUniqueWhere"],	filter?: ValueTypes["InvoicingPlanWhere"] | undefined | null},ValueTypes["InvoicingPlan"]],
listInvoicingPlan?: [{	filter?: ValueTypes["InvoicingPlanWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InvoicingPlanOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["InvoicingPlan"]],
paginateInvoicingPlan?: [{	filter?: ValueTypes["InvoicingPlanWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InvoicingPlanOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["InvoicingPlanConnection"]],
validateCreateInvoicingPlan?: [{	data: ValueTypes["InvoicingPlanCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateInvoicingPlan?: [{	by: ValueTypes["InvoicingPlanUniqueWhere"],	data: ValueTypes["InvoicingPlanUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductPackingLocale?: [{	by: ValueTypes["ProductPackingLocaleUniqueWhere"],	filter?: ValueTypes["ProductPackingLocaleWhere"] | undefined | null},ValueTypes["ProductPackingLocale"]],
listProductPackingLocale?: [{	filter?: ValueTypes["ProductPackingLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductPackingLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductPackingLocale"]],
paginateProductPackingLocale?: [{	filter?: ValueTypes["ProductPackingLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductPackingLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductPackingLocaleConnection"]],
validateCreateProductPackingLocale?: [{	data: ValueTypes["ProductPackingLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductPackingLocale?: [{	by: ValueTypes["ProductPackingLocaleUniqueWhere"],	data: ValueTypes["ProductPackingLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductLocale?: [{	by: ValueTypes["ProductLocaleUniqueWhere"],	filter?: ValueTypes["ProductLocaleWhere"] | undefined | null},ValueTypes["ProductLocale"]],
listProductLocale?: [{	filter?: ValueTypes["ProductLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductLocale"]],
paginateProductLocale?: [{	filter?: ValueTypes["ProductLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductLocaleConnection"]],
validateCreateProductLocale?: [{	data: ValueTypes["ProductLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductLocale?: [{	by: ValueTypes["ProductLocaleUniqueWhere"],	data: ValueTypes["ProductLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductRecipeLocale?: [{	by: ValueTypes["ProductRecipeLocaleUniqueWhere"],	filter?: ValueTypes["ProductRecipeLocaleWhere"] | undefined | null},ValueTypes["ProductRecipeLocale"]],
listProductRecipeLocale?: [{	filter?: ValueTypes["ProductRecipeLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductRecipeLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductRecipeLocale"]],
paginateProductRecipeLocale?: [{	filter?: ValueTypes["ProductRecipeLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductRecipeLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductRecipeLocaleConnection"]],
validateCreateProductRecipeLocale?: [{	data: ValueTypes["ProductRecipeLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductRecipeLocale?: [{	by: ValueTypes["ProductRecipeLocaleUniqueWhere"],	data: ValueTypes["ProductRecipeLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getUserDevice?: [{	by: ValueTypes["UserDeviceUniqueWhere"],	filter?: ValueTypes["UserDeviceWhere"] | undefined | null},ValueTypes["UserDevice"]],
listUserDevice?: [{	filter?: ValueTypes["UserDeviceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["UserDeviceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["UserDevice"]],
paginateUserDevice?: [{	filter?: ValueTypes["UserDeviceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["UserDeviceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["UserDeviceConnection"]],
validateCreateUserDevice?: [{	data: ValueTypes["UserDeviceCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateUserDevice?: [{	by: ValueTypes["UserDeviceUniqueWhere"],	data: ValueTypes["UserDeviceUpdateInput"]},ValueTypes["_ValidationResult"]],
getProtectedAction?: [{	by: ValueTypes["ProtectedActionUniqueWhere"],	filter?: ValueTypes["ProtectedActionWhere"] | undefined | null},ValueTypes["ProtectedAction"]],
listProtectedAction?: [{	filter?: ValueTypes["ProtectedActionWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProtectedActionOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProtectedAction"]],
paginateProtectedAction?: [{	filter?: ValueTypes["ProtectedActionWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProtectedActionOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProtectedActionConnection"]],
validateCreateProtectedAction?: [{	data: ValueTypes["ProtectedActionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProtectedAction?: [{	by: ValueTypes["ProtectedActionUniqueWhere"],	data: ValueTypes["ProtectedActionUpdateInput"]},ValueTypes["_ValidationResult"]],
getPicker?: [{	by: ValueTypes["PickerUniqueWhere"],	filter?: ValueTypes["PickerWhere"] | undefined | null},ValueTypes["Picker"]],
listPicker?: [{	filter?: ValueTypes["PickerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PickerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Picker"]],
paginatePicker?: [{	filter?: ValueTypes["PickerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PickerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PickerConnection"]],
validateCreatePicker?: [{	data: ValueTypes["PickerCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePicker?: [{	by: ValueTypes["PickerUniqueWhere"],	data: ValueTypes["PickerUpdateInput"]},ValueTypes["_ValidationResult"]],
getTenantPerson?: [{	by: ValueTypes["TenantPersonUniqueWhere"],	filter?: ValueTypes["TenantPersonWhere"] | undefined | null},ValueTypes["TenantPerson"]],
listTenantPerson?: [{	filter?: ValueTypes["TenantPersonWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TenantPersonOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TenantPerson"]],
paginateTenantPerson?: [{	filter?: ValueTypes["TenantPersonWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TenantPersonOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TenantPersonConnection"]],
getTimetableTemplateStaffOptions?: [{	by: ValueTypes["TimetableTemplateStaffOptionsUniqueWhere"],	filter?: ValueTypes["TimetableTemplateStaffOptionsWhere"] | undefined | null},ValueTypes["TimetableTemplateStaffOptions"]],
listTimetableTemplateStaffOptions?: [{	filter?: ValueTypes["TimetableTemplateStaffOptionsWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableTemplateStaffOptionsOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TimetableTemplateStaffOptions"]],
paginateTimetableTemplateStaffOptions?: [{	filter?: ValueTypes["TimetableTemplateStaffOptionsWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableTemplateStaffOptionsOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TimetableTemplateStaffOptionsConnection"]],
validateCreateTimetableTemplateStaffOptions?: [{	data: ValueTypes["TimetableTemplateStaffOptionsCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTimetableTemplateStaffOptions?: [{	by: ValueTypes["TimetableTemplateStaffOptionsUniqueWhere"],	data: ValueTypes["TimetableTemplateStaffOptionsUpdateInput"]},ValueTypes["_ValidationResult"]],
getShoppingList?: [{	by: ValueTypes["ShoppingListUniqueWhere"],	filter?: ValueTypes["ShoppingListWhere"] | undefined | null},ValueTypes["ShoppingList"]],
listShoppingList?: [{	filter?: ValueTypes["ShoppingListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ShoppingListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ShoppingList"]],
paginateShoppingList?: [{	filter?: ValueTypes["ShoppingListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ShoppingListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ShoppingListConnection"]],
validateCreateShoppingList?: [{	data: ValueTypes["ShoppingListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateShoppingList?: [{	by: ValueTypes["ShoppingListUniqueWhere"],	data: ValueTypes["ShoppingListUpdateInput"]},ValueTypes["_ValidationResult"]],
getSuppliesPurchase?: [{	by: ValueTypes["SuppliesPurchaseUniqueWhere"],	filter?: ValueTypes["SuppliesPurchaseWhere"] | undefined | null},ValueTypes["SuppliesPurchase"]],
listSuppliesPurchase?: [{	filter?: ValueTypes["SuppliesPurchaseWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SuppliesPurchaseOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["SuppliesPurchase"]],
paginateSuppliesPurchase?: [{	filter?: ValueTypes["SuppliesPurchaseWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SuppliesPurchaseOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["SuppliesPurchaseConnection"]],
validateCreateSuppliesPurchase?: [{	data: ValueTypes["SuppliesPurchaseCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSuppliesPurchase?: [{	by: ValueTypes["SuppliesPurchaseUniqueWhere"],	data: ValueTypes["SuppliesPurchaseUpdateInput"]},ValueTypes["_ValidationResult"]],
getInvoicingPreset?: [{	by: ValueTypes["InvoicingPresetUniqueWhere"],	filter?: ValueTypes["InvoicingPresetWhere"] | undefined | null},ValueTypes["InvoicingPreset"]],
listInvoicingPreset?: [{	filter?: ValueTypes["InvoicingPresetWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InvoicingPresetOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["InvoicingPreset"]],
paginateInvoicingPreset?: [{	filter?: ValueTypes["InvoicingPresetWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InvoicingPresetOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["InvoicingPresetConnection"]],
validateCreateInvoicingPreset?: [{	data: ValueTypes["InvoicingPresetCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateInvoicingPreset?: [{	by: ValueTypes["InvoicingPresetUniqueWhere"],	data: ValueTypes["InvoicingPresetUpdateInput"]},ValueTypes["_ValidationResult"]],
getLogRecord?: [{	by: ValueTypes["LogRecordUniqueWhere"],	filter?: ValueTypes["LogRecordWhere"] | undefined | null},ValueTypes["LogRecord"]],
listLogRecord?: [{	filter?: ValueTypes["LogRecordWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LogRecordOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["LogRecord"]],
paginateLogRecord?: [{	filter?: ValueTypes["LogRecordWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LogRecordOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["LogRecordConnection"]],
validateCreateLogRecord?: [{	data: ValueTypes["LogRecordCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLogRecord?: [{	by: ValueTypes["LogRecordUniqueWhere"],	data: ValueTypes["LogRecordUpdateInput"]},ValueTypes["_ValidationResult"]],
getBillingSubject?: [{	by: ValueTypes["BillingSubjectUniqueWhere"],	filter?: ValueTypes["BillingSubjectWhere"] | undefined | null},ValueTypes["BillingSubject"]],
listBillingSubject?: [{	filter?: ValueTypes["BillingSubjectWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BillingSubjectOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BillingSubject"]],
paginateBillingSubject?: [{	filter?: ValueTypes["BillingSubjectWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BillingSubjectOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BillingSubjectConnection"]],
validateCreateBillingSubject?: [{	data: ValueTypes["BillingSubjectCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBillingSubject?: [{	by: ValueTypes["BillingSubjectUniqueWhere"],	data: ValueTypes["BillingSubjectUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductCustomerPrice?: [{	by: ValueTypes["ProductCustomerPriceUniqueWhere"],	filter?: ValueTypes["ProductCustomerPriceWhere"] | undefined | null},ValueTypes["ProductCustomerPrice"]],
listProductCustomerPrice?: [{	filter?: ValueTypes["ProductCustomerPriceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCustomerPriceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductCustomerPrice"]],
paginateProductCustomerPrice?: [{	filter?: ValueTypes["ProductCustomerPriceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCustomerPriceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductCustomerPriceConnection"]],
getCartPriceLine?: [{	by: ValueTypes["CartPriceLineUniqueWhere"],	filter?: ValueTypes["CartPriceLineWhere"] | undefined | null},ValueTypes["CartPriceLine"]],
listCartPriceLine?: [{	filter?: ValueTypes["CartPriceLineWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CartPriceLineOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CartPriceLine"]],
paginateCartPriceLine?: [{	filter?: ValueTypes["CartPriceLineWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CartPriceLineOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CartPriceLineConnection"]],
getShoppingListItem?: [{	by: ValueTypes["ShoppingListItemUniqueWhere"],	filter?: ValueTypes["ShoppingListItemWhere"] | undefined | null},ValueTypes["ShoppingListItem"]],
listShoppingListItem?: [{	filter?: ValueTypes["ShoppingListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ShoppingListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ShoppingListItem"]],
paginateShoppingListItem?: [{	filter?: ValueTypes["ShoppingListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ShoppingListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ShoppingListItemConnection"]],
validateCreateShoppingListItem?: [{	data: ValueTypes["ShoppingListItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateShoppingListItem?: [{	by: ValueTypes["ShoppingListItemUniqueWhere"],	data: ValueTypes["ShoppingListItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getSuppliesPurchaseItem?: [{	by: ValueTypes["SuppliesPurchaseItemUniqueWhere"],	filter?: ValueTypes["SuppliesPurchaseItemWhere"] | undefined | null},ValueTypes["SuppliesPurchaseItem"]],
listSuppliesPurchaseItem?: [{	filter?: ValueTypes["SuppliesPurchaseItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SuppliesPurchaseItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["SuppliesPurchaseItem"]],
paginateSuppliesPurchaseItem?: [{	filter?: ValueTypes["SuppliesPurchaseItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SuppliesPurchaseItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["SuppliesPurchaseItemConnection"]],
validateCreateSuppliesPurchaseItem?: [{	data: ValueTypes["SuppliesPurchaseItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSuppliesPurchaseItem?: [{	by: ValueTypes["SuppliesPurchaseItemUniqueWhere"],	data: ValueTypes["SuppliesPurchaseItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getCustomerCreditTransaction?: [{	by: ValueTypes["CustomerCreditTransactionUniqueWhere"],	filter?: ValueTypes["CustomerCreditTransactionWhere"] | undefined | null},ValueTypes["CustomerCreditTransaction"]],
listCustomerCreditTransaction?: [{	filter?: ValueTypes["CustomerCreditTransactionWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerCreditTransactionOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CustomerCreditTransaction"]],
paginateCustomerCreditTransaction?: [{	filter?: ValueTypes["CustomerCreditTransactionWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerCreditTransactionOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerCreditTransactionConnection"]],
validateCreateCustomerCreditTransaction?: [{	data: ValueTypes["CustomerCreditTransactionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCustomerCreditTransaction?: [{	by: ValueTypes["CustomerCreditTransactionUniqueWhere"],	data: ValueTypes["CustomerCreditTransactionUpdateInput"]},ValueTypes["_ValidationResult"]],
getVirtualProduct?: [{	by: ValueTypes["VirtualProductUniqueWhere"],	filter?: ValueTypes["VirtualProductWhere"] | undefined | null},ValueTypes["VirtualProduct"]],
listVirtualProduct?: [{	filter?: ValueTypes["VirtualProductWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VirtualProductOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["VirtualProduct"]],
paginateVirtualProduct?: [{	filter?: ValueTypes["VirtualProductWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VirtualProductOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["VirtualProductConnection"]],
validateCreateVirtualProduct?: [{	data: ValueTypes["VirtualProductCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateVirtualProduct?: [{	by: ValueTypes["VirtualProductUniqueWhere"],	data: ValueTypes["VirtualProductUpdateInput"]},ValueTypes["_ValidationResult"]],
getVirtualProductEffect?: [{	by: ValueTypes["VirtualProductEffectUniqueWhere"],	filter?: ValueTypes["VirtualProductEffectWhere"] | undefined | null},ValueTypes["VirtualProductEffect"]],
listVirtualProductEffect?: [{	filter?: ValueTypes["VirtualProductEffectWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VirtualProductEffectOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["VirtualProductEffect"]],
paginateVirtualProductEffect?: [{	filter?: ValueTypes["VirtualProductEffectWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VirtualProductEffectOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["VirtualProductEffectConnection"]],
validateCreateVirtualProductEffect?: [{	data: ValueTypes["VirtualProductEffectCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateVirtualProductEffect?: [{	by: ValueTypes["VirtualProductEffectUniqueWhere"],	data: ValueTypes["VirtualProductEffectUpdateInput"]},ValueTypes["_ValidationResult"]],
getOrderPriceLine?: [{	by: ValueTypes["OrderPriceLineUniqueWhere"],	filter?: ValueTypes["OrderPriceLineWhere"] | undefined | null},ValueTypes["OrderPriceLine"]],
listOrderPriceLine?: [{	filter?: ValueTypes["OrderPriceLineWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderPriceLineOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["OrderPriceLine"]],
paginateOrderPriceLine?: [{	filter?: ValueTypes["OrderPriceLineWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderPriceLineOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderPriceLineConnection"]],
getProductMetadata?: [{	by: ValueTypes["ProductMetadataUniqueWhere"],	filter?: ValueTypes["ProductMetadataWhere"] | undefined | null},ValueTypes["ProductMetadata"]],
listProductMetadata?: [{	filter?: ValueTypes["ProductMetadataWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductMetadataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductMetadata"]],
paginateProductMetadata?: [{	filter?: ValueTypes["ProductMetadataWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductMetadataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductMetadataConnection"]],
getEmploymentInformation?: [{	by: ValueTypes["EmploymentInformationUniqueWhere"],	filter?: ValueTypes["EmploymentInformationWhere"] | undefined | null},ValueTypes["EmploymentInformation"]],
listEmploymentInformation?: [{	filter?: ValueTypes["EmploymentInformationWhere"] | undefined | null,	orderBy?: Array<ValueTypes["EmploymentInformationOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["EmploymentInformation"]],
paginateEmploymentInformation?: [{	filter?: ValueTypes["EmploymentInformationWhere"] | undefined | null,	orderBy?: Array<ValueTypes["EmploymentInformationOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["EmploymentInformationConnection"]],
validateCreateEmploymentInformation?: [{	data: ValueTypes["EmploymentInformationCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateEmploymentInformation?: [{	by: ValueTypes["EmploymentInformationUniqueWhere"],	data: ValueTypes["EmploymentInformationUpdateInput"]},ValueTypes["_ValidationResult"]],
getRemunerationProfile?: [{	by: ValueTypes["RemunerationProfileUniqueWhere"],	filter?: ValueTypes["RemunerationProfileWhere"] | undefined | null},ValueTypes["RemunerationProfile"]],
listRemunerationProfile?: [{	filter?: ValueTypes["RemunerationProfileWhere"] | undefined | null,	orderBy?: Array<ValueTypes["RemunerationProfileOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["RemunerationProfile"]],
paginateRemunerationProfile?: [{	filter?: ValueTypes["RemunerationProfileWhere"] | undefined | null,	orderBy?: Array<ValueTypes["RemunerationProfileOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["RemunerationProfileConnection"]],
validateCreateRemunerationProfile?: [{	data: ValueTypes["RemunerationProfileCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateRemunerationProfile?: [{	by: ValueTypes["RemunerationProfileUniqueWhere"],	data: ValueTypes["RemunerationProfileUpdateInput"]},ValueTypes["_ValidationResult"]],
getWorkMonth?: [{	by: ValueTypes["WorkMonthUniqueWhere"],	filter?: ValueTypes["WorkMonthWhere"] | undefined | null},ValueTypes["WorkMonth"]],
listWorkMonth?: [{	filter?: ValueTypes["WorkMonthWhere"] | undefined | null,	orderBy?: Array<ValueTypes["WorkMonthOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["WorkMonth"]],
paginateWorkMonth?: [{	filter?: ValueTypes["WorkMonthWhere"] | undefined | null,	orderBy?: Array<ValueTypes["WorkMonthOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["WorkMonthConnection"]],
validateCreateWorkMonth?: [{	data: ValueTypes["WorkMonthCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateWorkMonth?: [{	by: ValueTypes["WorkMonthUniqueWhere"],	data: ValueTypes["WorkMonthUpdateInput"]},ValueTypes["_ValidationResult"]],
getSalaryOptions?: [{	by: ValueTypes["SalaryOptionsUniqueWhere"],	filter?: ValueTypes["SalaryOptionsWhere"] | undefined | null},ValueTypes["SalaryOptions"]],
listSalaryOptions?: [{	filter?: ValueTypes["SalaryOptionsWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SalaryOptionsOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["SalaryOptions"]],
paginateSalaryOptions?: [{	filter?: ValueTypes["SalaryOptionsWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SalaryOptionsOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["SalaryOptionsConnection"]],
validateCreateSalaryOptions?: [{	data: ValueTypes["SalaryOptionsCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSalaryOptions?: [{	by: ValueTypes["SalaryOptionsUniqueWhere"],	data: ValueTypes["SalaryOptionsUpdateInput"]},ValueTypes["_ValidationResult"]],
getTimetableShiftSwapInfo?: [{	by: ValueTypes["TimetableShiftSwapInfoUniqueWhere"],	filter?: ValueTypes["TimetableShiftSwapInfoWhere"] | undefined | null},ValueTypes["TimetableShiftSwapInfo"]],
listTimetableShiftSwapInfo?: [{	filter?: ValueTypes["TimetableShiftSwapInfoWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableShiftSwapInfoOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TimetableShiftSwapInfo"]],
paginateTimetableShiftSwapInfo?: [{	filter?: ValueTypes["TimetableShiftSwapInfoWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableShiftSwapInfoOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TimetableShiftSwapInfoConnection"]],
validateCreateTimetableShiftSwapInfo?: [{	data: ValueTypes["TimetableShiftSwapInfoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTimetableShiftSwapInfo?: [{	by: ValueTypes["TimetableShiftSwapInfoUniqueWhere"],	data: ValueTypes["TimetableShiftSwapInfoUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductGridCategory?: [{	by: ValueTypes["ProductGridCategoryUniqueWhere"],	filter?: ValueTypes["ProductGridCategoryWhere"] | undefined | null},ValueTypes["ProductGridCategory"]],
listProductGridCategory?: [{	filter?: ValueTypes["ProductGridCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductGridCategoryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductGridCategory"]],
paginateProductGridCategory?: [{	filter?: ValueTypes["ProductGridCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductGridCategoryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductGridCategoryConnection"]],
validateCreateProductGridCategory?: [{	data: ValueTypes["ProductGridCategoryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductGridCategory?: [{	by: ValueTypes["ProductGridCategoryUniqueWhere"],	data: ValueTypes["ProductGridCategoryUpdateInput"]},ValueTypes["_ValidationResult"]],
getCashier?: [{	by: ValueTypes["CashierUniqueWhere"],	filter?: ValueTypes["CashierWhere"] | undefined | null},ValueTypes["Cashier"]],
listCashier?: [{	filter?: ValueTypes["CashierWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CashierOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Cashier"]],
paginateCashier?: [{	filter?: ValueTypes["CashierWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CashierOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CashierConnection"]],
validateCreateCashier?: [{	data: ValueTypes["CashierCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCashier?: [{	by: ValueTypes["CashierUniqueWhere"],	data: ValueTypes["CashierUpdateInput"]},ValueTypes["_ValidationResult"]],
getPointOfSaleCategory?: [{	by: ValueTypes["PointOfSaleCategoryUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryWhere"] | undefined | null},ValueTypes["PointOfSaleCategory"]],
listPointOfSaleCategory?: [{	filter?: ValueTypes["PointOfSaleCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleCategoryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PointOfSaleCategory"]],
paginatePointOfSaleCategory?: [{	filter?: ValueTypes["PointOfSaleCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleCategoryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PointOfSaleCategoryConnection"]],
validateCreatePointOfSaleCategory?: [{	data: ValueTypes["PointOfSaleCategoryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePointOfSaleCategory?: [{	by: ValueTypes["PointOfSaleCategoryUniqueWhere"],	data: ValueTypes["PointOfSaleCategoryUpdateInput"]},ValueTypes["_ValidationResult"]],
getPointOfSaleCategoryLocale?: [{	by: ValueTypes["PointOfSaleCategoryLocaleUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryLocaleWhere"] | undefined | null},ValueTypes["PointOfSaleCategoryLocale"]],
listPointOfSaleCategoryLocale?: [{	filter?: ValueTypes["PointOfSaleCategoryLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleCategoryLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PointOfSaleCategoryLocale"]],
paginatePointOfSaleCategoryLocale?: [{	filter?: ValueTypes["PointOfSaleCategoryLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleCategoryLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PointOfSaleCategoryLocaleConnection"]],
validateCreatePointOfSaleCategoryLocale?: [{	data: ValueTypes["PointOfSaleCategoryLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePointOfSaleCategoryLocale?: [{	by: ValueTypes["PointOfSaleCategoryLocaleUniqueWhere"],	data: ValueTypes["PointOfSaleCategoryLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getPointOfSaleCategoryProduct?: [{	by: ValueTypes["PointOfSaleCategoryProductUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryProductWhere"] | undefined | null},ValueTypes["PointOfSaleCategoryProduct"]],
listPointOfSaleCategoryProduct?: [{	filter?: ValueTypes["PointOfSaleCategoryProductWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleCategoryProductOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PointOfSaleCategoryProduct"]],
paginatePointOfSaleCategoryProduct?: [{	filter?: ValueTypes["PointOfSaleCategoryProductWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleCategoryProductOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PointOfSaleCategoryProductConnection"]],
validateCreatePointOfSaleCategoryProduct?: [{	data: ValueTypes["PointOfSaleCategoryProductCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePointOfSaleCategoryProduct?: [{	by: ValueTypes["PointOfSaleCategoryProductUniqueWhere"],	data: ValueTypes["PointOfSaleCategoryProductUpdateInput"]},ValueTypes["_ValidationResult"]],
getPointOfSaleCategoryProductLocale?: [{	by: ValueTypes["PointOfSaleCategoryProductLocaleUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryProductLocaleWhere"] | undefined | null},ValueTypes["PointOfSaleCategoryProductLocale"]],
listPointOfSaleCategoryProductLocale?: [{	filter?: ValueTypes["PointOfSaleCategoryProductLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleCategoryProductLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PointOfSaleCategoryProductLocale"]],
paginatePointOfSaleCategoryProductLocale?: [{	filter?: ValueTypes["PointOfSaleCategoryProductLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleCategoryProductLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PointOfSaleCategoryProductLocaleConnection"]],
validateCreatePointOfSaleCategoryProductLocale?: [{	data: ValueTypes["PointOfSaleCategoryProductLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePointOfSaleCategoryProductLocale?: [{	by: ValueTypes["PointOfSaleCategoryProductLocaleUniqueWhere"],	data: ValueTypes["PointOfSaleCategoryProductLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getCustomerTab?: [{	by: ValueTypes["CustomerTabUniqueWhere"],	filter?: ValueTypes["CustomerTabWhere"] | undefined | null},ValueTypes["CustomerTab"]],
listCustomerTab?: [{	filter?: ValueTypes["CustomerTabWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerTabOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CustomerTab"]],
paginateCustomerTab?: [{	filter?: ValueTypes["CustomerTabWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerTabOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerTabConnection"]],
validateCreateCustomerTab?: [{	data: ValueTypes["CustomerTabCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCustomerTab?: [{	by: ValueTypes["CustomerTabUniqueWhere"],	data: ValueTypes["CustomerTabUpdateInput"]},ValueTypes["_ValidationResult"]],
getCustomerTabItem?: [{	by: ValueTypes["CustomerTabItemUniqueWhere"],	filter?: ValueTypes["CustomerTabItemWhere"] | undefined | null},ValueTypes["CustomerTabItem"]],
listCustomerTabItem?: [{	filter?: ValueTypes["CustomerTabItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerTabItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CustomerTabItem"]],
paginateCustomerTabItem?: [{	filter?: ValueTypes["CustomerTabItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerTabItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerTabItemConnection"]],
validateCreateCustomerTabItem?: [{	data: ValueTypes["CustomerTabItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCustomerTabItem?: [{	by: ValueTypes["CustomerTabItemUniqueWhere"],	data: ValueTypes["CustomerTabItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getAnonymousSession?: [{	by: ValueTypes["AnonymousSessionUniqueWhere"],	filter?: ValueTypes["AnonymousSessionWhere"] | undefined | null},ValueTypes["AnonymousSession"]],
listAnonymousSession?: [{	filter?: ValueTypes["AnonymousSessionWhere"] | undefined | null,	orderBy?: Array<ValueTypes["AnonymousSessionOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["AnonymousSession"]],
paginateAnonymousSession?: [{	filter?: ValueTypes["AnonymousSessionWhere"] | undefined | null,	orderBy?: Array<ValueTypes["AnonymousSessionOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["AnonymousSessionConnection"]],
validateCreateAnonymousSession?: [{	data: ValueTypes["AnonymousSessionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateAnonymousSession?: [{	by: ValueTypes["AnonymousSessionUniqueWhere"],	data: ValueTypes["AnonymousSessionUpdateInput"]},ValueTypes["_ValidationResult"]],
getVoucher?: [{	by: ValueTypes["VoucherUniqueWhere"],	filter?: ValueTypes["VoucherWhere"] | undefined | null},ValueTypes["Voucher"]],
listVoucher?: [{	filter?: ValueTypes["VoucherWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VoucherOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Voucher"]],
paginateVoucher?: [{	filter?: ValueTypes["VoucherWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VoucherOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["VoucherConnection"]],
validateCreateVoucher?: [{	data: ValueTypes["VoucherCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateVoucher?: [{	by: ValueTypes["VoucherUniqueWhere"],	data: ValueTypes["VoucherUpdateInput"]},ValueTypes["_ValidationResult"]],
getVoucherRedemption?: [{	by: ValueTypes["VoucherRedemptionUniqueWhere"],	filter?: ValueTypes["VoucherRedemptionWhere"] | undefined | null},ValueTypes["VoucherRedemption"]],
listVoucherRedemption?: [{	filter?: ValueTypes["VoucherRedemptionWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VoucherRedemptionOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["VoucherRedemption"]],
paginateVoucherRedemption?: [{	filter?: ValueTypes["VoucherRedemptionWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VoucherRedemptionOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["VoucherRedemptionConnection"]],
validateCreateVoucherRedemption?: [{	data: ValueTypes["VoucherRedemptionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateVoucherRedemption?: [{	by: ValueTypes["VoucherRedemptionUniqueWhere"],	data: ValueTypes["VoucherRedemptionUpdateInput"]},ValueTypes["_ValidationResult"]],
getUnassignedShiftInfo?: [{	by: ValueTypes["UnassignedShiftInfoUniqueWhere"],	filter?: ValueTypes["UnassignedShiftInfoWhere"] | undefined | null},ValueTypes["UnassignedShiftInfo"]],
listUnassignedShiftInfo?: [{	filter?: ValueTypes["UnassignedShiftInfoWhere"] | undefined | null,	orderBy?: Array<ValueTypes["UnassignedShiftInfoOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["UnassignedShiftInfo"]],
paginateUnassignedShiftInfo?: [{	filter?: ValueTypes["UnassignedShiftInfoWhere"] | undefined | null,	orderBy?: Array<ValueTypes["UnassignedShiftInfoOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["UnassignedShiftInfoConnection"]],
validateCreateUnassignedShiftInfo?: [{	data: ValueTypes["UnassignedShiftInfoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateUnassignedShiftInfo?: [{	by: ValueTypes["UnassignedShiftInfoUniqueWhere"],	data: ValueTypes["UnassignedShiftInfoUpdateInput"]},ValueTypes["_ValidationResult"]],
getFreshingContainer?: [{	by: ValueTypes["FreshingContainerUniqueWhere"],	filter?: ValueTypes["FreshingContainerWhere"] | undefined | null},ValueTypes["FreshingContainer"]],
listFreshingContainer?: [{	filter?: ValueTypes["FreshingContainerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["FreshingContainerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["FreshingContainer"]],
paginateFreshingContainer?: [{	filter?: ValueTypes["FreshingContainerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["FreshingContainerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["FreshingContainerConnection"]],
validateCreateFreshingContainer?: [{	data: ValueTypes["FreshingContainerCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFreshingContainer?: [{	by: ValueTypes["FreshingContainerUniqueWhere"],	data: ValueTypes["FreshingContainerUpdateInput"]},ValueTypes["_ValidationResult"]],
getTextItem?: [{	by: ValueTypes["TextItemUniqueWhere"],	filter?: ValueTypes["TextItemWhere"] | undefined | null},ValueTypes["TextItem"]],
listTextItem?: [{	filter?: ValueTypes["TextItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TextItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TextItem"]],
paginateTextItem?: [{	filter?: ValueTypes["TextItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TextItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TextItemConnection"]],
validateCreateTextItem?: [{	data: ValueTypes["TextItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTextItem?: [{	by: ValueTypes["TextItemUniqueWhere"],	data: ValueTypes["TextItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getTextList?: [{	by: ValueTypes["TextListUniqueWhere"],	filter?: ValueTypes["TextListWhere"] | undefined | null},ValueTypes["TextList"]],
listTextList?: [{	filter?: ValueTypes["TextListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TextListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TextList"]],
paginateTextList?: [{	filter?: ValueTypes["TextListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TextListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TextListConnection"]],
validateCreateTextList?: [{	data: ValueTypes["TextListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTextList?: [{	by: ValueTypes["TextListUniqueWhere"],	data: ValueTypes["TextListUpdateInput"]},ValueTypes["_ValidationResult"]],
getEmployeeQueueItemMetadata?: [{	by: ValueTypes["EmployeeQueueItemMetadataUniqueWhere"],	filter?: ValueTypes["EmployeeQueueItemMetadataWhere"] | undefined | null},ValueTypes["EmployeeQueueItemMetadata"]],
listEmployeeQueueItemMetadata?: [{	filter?: ValueTypes["EmployeeQueueItemMetadataWhere"] | undefined | null,	orderBy?: Array<ValueTypes["EmployeeQueueItemMetadataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["EmployeeQueueItemMetadata"]],
paginateEmployeeQueueItemMetadata?: [{	filter?: ValueTypes["EmployeeQueueItemMetadataWhere"] | undefined | null,	orderBy?: Array<ValueTypes["EmployeeQueueItemMetadataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["EmployeeQueueItemMetadataConnection"]],
getDeliveryRegions?: [{	by: ValueTypes["DeliveryRegionsUniqueWhere"],	filter?: ValueTypes["DeliveryRegionsWhere"] | undefined | null},ValueTypes["DeliveryRegions"]],
listDeliveryRegions?: [{	filter?: ValueTypes["DeliveryRegionsWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryRegionsOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["DeliveryRegions"]],
paginateDeliveryRegions?: [{	filter?: ValueTypes["DeliveryRegionsWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryRegionsOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["DeliveryRegionsConnection"]],
validateCreateDeliveryRegions?: [{	data: ValueTypes["DeliveryRegionsCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDeliveryRegions?: [{	by: ValueTypes["DeliveryRegionsUniqueWhere"],	data: ValueTypes["DeliveryRegionsUpdateInput"]},ValueTypes["_ValidationResult"]],
getDeliveryRegionsItem?: [{	by: ValueTypes["DeliveryRegionsItemUniqueWhere"],	filter?: ValueTypes["DeliveryRegionsItemWhere"] | undefined | null},ValueTypes["DeliveryRegionsItem"]],
listDeliveryRegionsItem?: [{	filter?: ValueTypes["DeliveryRegionsItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryRegionsItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["DeliveryRegionsItem"]],
paginateDeliveryRegionsItem?: [{	filter?: ValueTypes["DeliveryRegionsItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryRegionsItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["DeliveryRegionsItemConnection"]],
validateCreateDeliveryRegionsItem?: [{	data: ValueTypes["DeliveryRegionsItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDeliveryRegionsItem?: [{	by: ValueTypes["DeliveryRegionsItemUniqueWhere"],	data: ValueTypes["DeliveryRegionsItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getImageList?: [{	by: ValueTypes["ImageListUniqueWhere"],	filter?: ValueTypes["ImageListWhere"] | undefined | null},ValueTypes["ImageList"]],
listImageList?: [{	filter?: ValueTypes["ImageListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ImageListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ImageList"]],
paginateImageList?: [{	filter?: ValueTypes["ImageListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ImageListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ImageListConnection"]],
validateCreateImageList?: [{	data: ValueTypes["ImageListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImageList?: [{	by: ValueTypes["ImageListUniqueWhere"],	data: ValueTypes["ImageListUpdateInput"]},ValueTypes["_ValidationResult"]],
getImageListItem?: [{	by: ValueTypes["ImageListItemUniqueWhere"],	filter?: ValueTypes["ImageListItemWhere"] | undefined | null},ValueTypes["ImageListItem"]],
listImageListItem?: [{	filter?: ValueTypes["ImageListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ImageListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ImageListItem"]],
paginateImageListItem?: [{	filter?: ValueTypes["ImageListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ImageListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ImageListItemConnection"]],
validateCreateImageListItem?: [{	data: ValueTypes["ImageListItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImageListItem?: [{	by: ValueTypes["ImageListItemUniqueWhere"],	data: ValueTypes["ImageListItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductSalesDay?: [{	by: ValueTypes["ProductSalesDayUniqueWhere"],	filter?: ValueTypes["ProductSalesDayWhere"] | undefined | null},ValueTypes["ProductSalesDay"]],
listProductSalesDay?: [{	filter?: ValueTypes["ProductSalesDayWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductSalesDayOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductSalesDay"]],
paginateProductSalesDay?: [{	filter?: ValueTypes["ProductSalesDayWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductSalesDayOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductSalesDayConnection"]],
getProductSalesMonth?: [{	by: ValueTypes["ProductSalesMonthUniqueWhere"],	filter?: ValueTypes["ProductSalesMonthWhere"] | undefined | null},ValueTypes["ProductSalesMonth"]],
listProductSalesMonth?: [{	filter?: ValueTypes["ProductSalesMonthWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductSalesMonthOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductSalesMonth"]],
paginateProductSalesMonth?: [{	filter?: ValueTypes["ProductSalesMonthWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductSalesMonthOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductSalesMonthConnection"]],
getProductSalesWeek?: [{	by: ValueTypes["ProductSalesWeekUniqueWhere"],	filter?: ValueTypes["ProductSalesWeekWhere"] | undefined | null},ValueTypes["ProductSalesWeek"]],
listProductSalesWeek?: [{	filter?: ValueTypes["ProductSalesWeekWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductSalesWeekOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductSalesWeek"]],
paginateProductSalesWeek?: [{	filter?: ValueTypes["ProductSalesWeekWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductSalesWeekOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductSalesWeekConnection"]],
getTimetablesEmployeePrivileges?: [{	by: ValueTypes["TimetablesEmployeePrivilegesUniqueWhere"],	filter?: ValueTypes["TimetablesEmployeePrivilegesWhere"] | undefined | null},ValueTypes["TimetablesEmployeePrivileges"]],
listTimetablesEmployeePrivileges?: [{	filter?: ValueTypes["TimetablesEmployeePrivilegesWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetablesEmployeePrivilegesOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TimetablesEmployeePrivileges"]],
paginateTimetablesEmployeePrivileges?: [{	filter?: ValueTypes["TimetablesEmployeePrivilegesWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetablesEmployeePrivilegesOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TimetablesEmployeePrivilegesConnection"]],
validateCreateTimetablesEmployeePrivileges?: [{	data: ValueTypes["TimetablesEmployeePrivilegesCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTimetablesEmployeePrivileges?: [{	by: ValueTypes["TimetablesEmployeePrivilegesUniqueWhere"],	data: ValueTypes["TimetablesEmployeePrivilegesUpdateInput"]},ValueTypes["_ValidationResult"]],
getTimetableDayNote?: [{	by: ValueTypes["TimetableDayNoteUniqueWhere"],	filter?: ValueTypes["TimetableDayNoteWhere"] | undefined | null},ValueTypes["TimetableDayNote"]],
listTimetableDayNote?: [{	filter?: ValueTypes["TimetableDayNoteWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableDayNoteOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TimetableDayNote"]],
paginateTimetableDayNote?: [{	filter?: ValueTypes["TimetableDayNoteWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableDayNoteOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TimetableDayNoteConnection"]],
validateCreateTimetableDayNote?: [{	data: ValueTypes["TimetableDayNoteCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTimetableDayNote?: [{	by: ValueTypes["TimetableDayNoteUniqueWhere"],	data: ValueTypes["TimetableDayNoteUpdateInput"]},ValueTypes["_ValidationResult"]],
getDeliveryMethodLocale?: [{	by: ValueTypes["DeliveryMethodLocaleUniqueWhere"],	filter?: ValueTypes["DeliveryMethodLocaleWhere"] | undefined | null},ValueTypes["DeliveryMethodLocale"]],
listDeliveryMethodLocale?: [{	filter?: ValueTypes["DeliveryMethodLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryMethodLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["DeliveryMethodLocale"]],
paginateDeliveryMethodLocale?: [{	filter?: ValueTypes["DeliveryMethodLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryMethodLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["DeliveryMethodLocaleConnection"]],
validateCreateDeliveryMethodLocale?: [{	data: ValueTypes["DeliveryMethodLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDeliveryMethodLocale?: [{	by: ValueTypes["DeliveryMethodLocaleUniqueWhere"],	data: ValueTypes["DeliveryMethodLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getIngredientSupplier?: [{	by: ValueTypes["IngredientSupplierUniqueWhere"],	filter?: ValueTypes["IngredientSupplierWhere"] | undefined | null},ValueTypes["IngredientSupplier"]],
listIngredientSupplier?: [{	filter?: ValueTypes["IngredientSupplierWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IngredientSupplierOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["IngredientSupplier"]],
paginateIngredientSupplier?: [{	filter?: ValueTypes["IngredientSupplierWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IngredientSupplierOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["IngredientSupplierConnection"]],
validateCreateIngredientSupplier?: [{	data: ValueTypes["IngredientSupplierCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateIngredientSupplier?: [{	by: ValueTypes["IngredientSupplierUniqueWhere"],	data: ValueTypes["IngredientSupplierUpdateInput"]},ValueTypes["_ValidationResult"]],
getIngredientSupplierItem?: [{	by: ValueTypes["IngredientSupplierItemUniqueWhere"],	filter?: ValueTypes["IngredientSupplierItemWhere"] | undefined | null},ValueTypes["IngredientSupplierItem"]],
listIngredientSupplierItem?: [{	filter?: ValueTypes["IngredientSupplierItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IngredientSupplierItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["IngredientSupplierItem"]],
paginateIngredientSupplierItem?: [{	filter?: ValueTypes["IngredientSupplierItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IngredientSupplierItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["IngredientSupplierItemConnection"]],
validateCreateIngredientSupplierItem?: [{	data: ValueTypes["IngredientSupplierItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateIngredientSupplierItem?: [{	by: ValueTypes["IngredientSupplierItemUniqueWhere"],	data: ValueTypes["IngredientSupplierItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getIngredientSupplierList?: [{	by: ValueTypes["IngredientSupplierListUniqueWhere"],	filter?: ValueTypes["IngredientSupplierListWhere"] | undefined | null},ValueTypes["IngredientSupplierList"]],
listIngredientSupplierList?: [{	filter?: ValueTypes["IngredientSupplierListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IngredientSupplierListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["IngredientSupplierList"]],
paginateIngredientSupplierList?: [{	filter?: ValueTypes["IngredientSupplierListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IngredientSupplierListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["IngredientSupplierListConnection"]],
validateCreateIngredientSupplierList?: [{	data: ValueTypes["IngredientSupplierListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateIngredientSupplierList?: [{	by: ValueTypes["IngredientSupplierListUniqueWhere"],	data: ValueTypes["IngredientSupplierListUpdateInput"]},ValueTypes["_ValidationResult"]],
getIngredientSupplierLocale?: [{	by: ValueTypes["IngredientSupplierLocaleUniqueWhere"],	filter?: ValueTypes["IngredientSupplierLocaleWhere"] | undefined | null},ValueTypes["IngredientSupplierLocale"]],
listIngredientSupplierLocale?: [{	filter?: ValueTypes["IngredientSupplierLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IngredientSupplierLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["IngredientSupplierLocale"]],
paginateIngredientSupplierLocale?: [{	filter?: ValueTypes["IngredientSupplierLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IngredientSupplierLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["IngredientSupplierLocaleConnection"]],
validateCreateIngredientSupplierLocale?: [{	data: ValueTypes["IngredientSupplierLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateIngredientSupplierLocale?: [{	by: ValueTypes["IngredientSupplierLocaleUniqueWhere"],	data: ValueTypes["IngredientSupplierLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getRedirect?: [{	by: ValueTypes["RedirectUniqueWhere"],	filter?: ValueTypes["RedirectWhere"] | undefined | null},ValueTypes["Redirect"]],
listRedirect?: [{	filter?: ValueTypes["RedirectWhere"] | undefined | null,	orderBy?: Array<ValueTypes["RedirectOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Redirect"]],
paginateRedirect?: [{	filter?: ValueTypes["RedirectWhere"] | undefined | null,	orderBy?: Array<ValueTypes["RedirectOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["RedirectConnection"]],
validateCreateRedirect?: [{	data: ValueTypes["RedirectCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateRedirect?: [{	by: ValueTypes["RedirectUniqueWhere"],	data: ValueTypes["RedirectUpdateInput"]},ValueTypes["_ValidationResult"]],
getNutritionFacts?: [{	by: ValueTypes["NutritionFactsUniqueWhere"],	filter?: ValueTypes["NutritionFactsWhere"] | undefined | null},ValueTypes["NutritionFacts"]],
listNutritionFacts?: [{	filter?: ValueTypes["NutritionFactsWhere"] | undefined | null,	orderBy?: Array<ValueTypes["NutritionFactsOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["NutritionFacts"]],
paginateNutritionFacts?: [{	filter?: ValueTypes["NutritionFactsWhere"] | undefined | null,	orderBy?: Array<ValueTypes["NutritionFactsOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["NutritionFactsConnection"]],
validateCreateNutritionFacts?: [{	data: ValueTypes["NutritionFactsCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateNutritionFacts?: [{	by: ValueTypes["NutritionFactsUniqueWhere"],	data: ValueTypes["NutritionFactsUpdateInput"]},ValueTypes["_ValidationResult"]],
getVenue?: [{	by: ValueTypes["VenueUniqueWhere"],	filter?: ValueTypes["VenueWhere"] | undefined | null},ValueTypes["Venue"]],
listVenue?: [{	filter?: ValueTypes["VenueWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VenueOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Venue"]],
paginateVenue?: [{	filter?: ValueTypes["VenueWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VenueOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["VenueConnection"]],
validateCreateVenue?: [{	data: ValueTypes["VenueCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateVenue?: [{	by: ValueTypes["VenueUniqueWhere"],	data: ValueTypes["VenueUpdateInput"]},ValueTypes["_ValidationResult"]],
getWorkspace?: [{	by: ValueTypes["WorkspaceUniqueWhere"],	filter?: ValueTypes["WorkspaceWhere"] | undefined | null},ValueTypes["Workspace"]],
listWorkspace?: [{	filter?: ValueTypes["WorkspaceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["WorkspaceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Workspace"]],
paginateWorkspace?: [{	filter?: ValueTypes["WorkspaceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["WorkspaceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["WorkspaceConnection"]],
validateCreateWorkspace?: [{	data: ValueTypes["WorkspaceCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateWorkspace?: [{	by: ValueTypes["WorkspaceUniqueWhere"],	data: ValueTypes["WorkspaceUpdateInput"]},ValueTypes["_ValidationResult"]],
getInternalBuyer?: [{	by: ValueTypes["InternalBuyerUniqueWhere"],	filter?: ValueTypes["InternalBuyerWhere"] | undefined | null},ValueTypes["InternalBuyer"]],
listInternalBuyer?: [{	filter?: ValueTypes["InternalBuyerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InternalBuyerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["InternalBuyer"]],
paginateInternalBuyer?: [{	filter?: ValueTypes["InternalBuyerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InternalBuyerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["InternalBuyerConnection"]],
validateCreateInternalBuyer?: [{	data: ValueTypes["InternalBuyerCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateInternalBuyer?: [{	by: ValueTypes["InternalBuyerUniqueWhere"],	data: ValueTypes["InternalBuyerUpdateInput"]},ValueTypes["_ValidationResult"]],
getCartSummary?: [{	by: ValueTypes["CartSummaryUniqueWhere"],	filter?: ValueTypes["CartSummaryWhere"] | undefined | null},ValueTypes["CartSummary"]],
listCartSummary?: [{	filter?: ValueTypes["CartSummaryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CartSummaryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CartSummary"]],
paginateCartSummary?: [{	filter?: ValueTypes["CartSummaryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CartSummaryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CartSummaryConnection"]],
getOrderSummary?: [{	by: ValueTypes["OrderSummaryUniqueWhere"],	filter?: ValueTypes["OrderSummaryWhere"] | undefined | null},ValueTypes["OrderSummary"]],
listOrderSummary?: [{	filter?: ValueTypes["OrderSummaryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderSummaryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["OrderSummary"]],
paginateOrderSummary?: [{	filter?: ValueTypes["OrderSummaryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderSummaryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderSummaryConnection"]],
getCustomerSpending?: [{	by: ValueTypes["CustomerSpendingUniqueWhere"],	filter?: ValueTypes["CustomerSpendingWhere"] | undefined | null},ValueTypes["CustomerSpending"]],
listCustomerSpending?: [{	filter?: ValueTypes["CustomerSpendingWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerSpendingOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CustomerSpending"]],
paginateCustomerSpending?: [{	filter?: ValueTypes["CustomerSpendingWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerSpendingOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerSpendingConnection"]],
getOrderPaymentMetadata?: [{	by: ValueTypes["OrderPaymentMetadataUniqueWhere"],	filter?: ValueTypes["OrderPaymentMetadataWhere"] | undefined | null},ValueTypes["OrderPaymentMetadata"]],
listOrderPaymentMetadata?: [{	filter?: ValueTypes["OrderPaymentMetadataWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderPaymentMetadataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["OrderPaymentMetadata"]],
paginateOrderPaymentMetadata?: [{	filter?: ValueTypes["OrderPaymentMetadataWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderPaymentMetadataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderPaymentMetadataConnection"]],
getUserMetadata?: [{	by: ValueTypes["UserMetadataUniqueWhere"],	filter?: ValueTypes["UserMetadataWhere"] | undefined | null},ValueTypes["UserMetadata"]],
listUserMetadata?: [{	filter?: ValueTypes["UserMetadataWhere"] | undefined | null,	orderBy?: Array<ValueTypes["UserMetadataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["UserMetadata"]],
paginateUserMetadata?: [{	filter?: ValueTypes["UserMetadataWhere"] | undefined | null,	orderBy?: Array<ValueTypes["UserMetadataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["UserMetadataConnection"]],
getCustomerTabMetadata?: [{	by: ValueTypes["CustomerTabMetadataUniqueWhere"],	filter?: ValueTypes["CustomerTabMetadataWhere"] | undefined | null},ValueTypes["CustomerTabMetadata"]],
listCustomerTabMetadata?: [{	filter?: ValueTypes["CustomerTabMetadataWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerTabMetadataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CustomerTabMetadata"]],
paginateCustomerTabMetadata?: [{	filter?: ValueTypes["CustomerTabMetadataWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerTabMetadataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerTabMetadataConnection"]],
getVenueEmployeeRole?: [{	by: ValueTypes["VenueEmployeeRoleUniqueWhere"],	filter?: ValueTypes["VenueEmployeeRoleWhere"] | undefined | null},ValueTypes["VenueEmployeeRole"]],
listVenueEmployeeRole?: [{	filter?: ValueTypes["VenueEmployeeRoleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VenueEmployeeRoleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["VenueEmployeeRole"]],
paginateVenueEmployeeRole?: [{	filter?: ValueTypes["VenueEmployeeRoleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VenueEmployeeRoleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["VenueEmployeeRoleConnection"]],
validateCreateVenueEmployeeRole?: [{	data: ValueTypes["VenueEmployeeRoleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateVenueEmployeeRole?: [{	by: ValueTypes["VenueEmployeeRoleUniqueWhere"],	data: ValueTypes["VenueEmployeeRoleUpdateInput"]},ValueTypes["_ValidationResult"]],
getIdentificationAttempt?: [{	by: ValueTypes["IdentificationAttemptUniqueWhere"],	filter?: ValueTypes["IdentificationAttemptWhere"] | undefined | null},ValueTypes["IdentificationAttempt"]],
listIdentificationAttempt?: [{	filter?: ValueTypes["IdentificationAttemptWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IdentificationAttemptOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["IdentificationAttempt"]],
paginateIdentificationAttempt?: [{	filter?: ValueTypes["IdentificationAttemptWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IdentificationAttemptOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["IdentificationAttemptConnection"]],
validateCreateIdentificationAttempt?: [{	data: ValueTypes["IdentificationAttemptCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateIdentificationAttempt?: [{	by: ValueTypes["IdentificationAttemptUniqueWhere"],	data: ValueTypes["IdentificationAttemptUpdateInput"]},ValueTypes["_ValidationResult"]],
getIdentificationCode?: [{	by: ValueTypes["IdentificationCodeUniqueWhere"],	filter?: ValueTypes["IdentificationCodeWhere"] | undefined | null},ValueTypes["IdentificationCode"]],
listIdentificationCode?: [{	filter?: ValueTypes["IdentificationCodeWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IdentificationCodeOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["IdentificationCode"]],
paginateIdentificationCode?: [{	filter?: ValueTypes["IdentificationCodeWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IdentificationCodeOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["IdentificationCodeConnection"]],
validateCreateIdentificationCode?: [{	data: ValueTypes["IdentificationCodeCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateIdentificationCode?: [{	by: ValueTypes["IdentificationCodeUniqueWhere"],	data: ValueTypes["IdentificationCodeUpdateInput"]},ValueTypes["_ValidationResult"]],
getIdentificationCodeLocale?: [{	by: ValueTypes["IdentificationCodeLocaleUniqueWhere"],	filter?: ValueTypes["IdentificationCodeLocaleWhere"] | undefined | null},ValueTypes["IdentificationCodeLocale"]],
listIdentificationCodeLocale?: [{	filter?: ValueTypes["IdentificationCodeLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IdentificationCodeLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["IdentificationCodeLocale"]],
paginateIdentificationCodeLocale?: [{	filter?: ValueTypes["IdentificationCodeLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IdentificationCodeLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["IdentificationCodeLocaleConnection"]],
validateCreateIdentificationCodeLocale?: [{	data: ValueTypes["IdentificationCodeLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateIdentificationCodeLocale?: [{	by: ValueTypes["IdentificationCodeLocaleUniqueWhere"],	data: ValueTypes["IdentificationCodeLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getPipeline?: [{	by: ValueTypes["PipelineUniqueWhere"],	filter?: ValueTypes["PipelineWhere"] | undefined | null},ValueTypes["Pipeline"]],
listPipeline?: [{	filter?: ValueTypes["PipelineWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PipelineOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Pipeline"]],
paginatePipeline?: [{	filter?: ValueTypes["PipelineWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PipelineOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PipelineConnection"]],
validateCreatePipeline?: [{	data: ValueTypes["PipelineCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePipeline?: [{	by: ValueTypes["PipelineUniqueWhere"],	data: ValueTypes["PipelineUpdateInput"]},ValueTypes["_ValidationResult"]],
getPipelineLead?: [{	by: ValueTypes["PipelineLeadUniqueWhere"],	filter?: ValueTypes["PipelineLeadWhere"] | undefined | null},ValueTypes["PipelineLead"]],
listPipelineLead?: [{	filter?: ValueTypes["PipelineLeadWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PipelineLeadOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PipelineLead"]],
paginatePipelineLead?: [{	filter?: ValueTypes["PipelineLeadWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PipelineLeadOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PipelineLeadConnection"]],
validateCreatePipelineLead?: [{	data: ValueTypes["PipelineLeadCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePipelineLead?: [{	by: ValueTypes["PipelineLeadUniqueWhere"],	data: ValueTypes["PipelineLeadUpdateInput"]},ValueTypes["_ValidationResult"]],
getPipelineStage?: [{	by: ValueTypes["PipelineStageUniqueWhere"],	filter?: ValueTypes["PipelineStageWhere"] | undefined | null},ValueTypes["PipelineStage"]],
listPipelineStage?: [{	filter?: ValueTypes["PipelineStageWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PipelineStageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PipelineStage"]],
paginatePipelineStage?: [{	filter?: ValueTypes["PipelineStageWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PipelineStageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PipelineStageConnection"]],
validateCreatePipelineStage?: [{	data: ValueTypes["PipelineStageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePipelineStage?: [{	by: ValueTypes["PipelineStageUniqueWhere"],	data: ValueTypes["PipelineStageUpdateInput"]},ValueTypes["_ValidationResult"]],
getPipelineStageItem?: [{	by: ValueTypes["PipelineStageItemUniqueWhere"],	filter?: ValueTypes["PipelineStageItemWhere"] | undefined | null},ValueTypes["PipelineStageItem"]],
listPipelineStageItem?: [{	filter?: ValueTypes["PipelineStageItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PipelineStageItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PipelineStageItem"]],
paginatePipelineStageItem?: [{	filter?: ValueTypes["PipelineStageItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PipelineStageItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PipelineStageItemConnection"]],
validateCreatePipelineStageItem?: [{	data: ValueTypes["PipelineStageItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePipelineStageItem?: [{	by: ValueTypes["PipelineStageItemUniqueWhere"],	data: ValueTypes["PipelineStageItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getPipelineStageLocale?: [{	by: ValueTypes["PipelineStageLocaleUniqueWhere"],	filter?: ValueTypes["PipelineStageLocaleWhere"] | undefined | null},ValueTypes["PipelineStageLocale"]],
listPipelineStageLocale?: [{	filter?: ValueTypes["PipelineStageLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PipelineStageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PipelineStageLocale"]],
paginatePipelineStageLocale?: [{	filter?: ValueTypes["PipelineStageLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PipelineStageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PipelineStageLocaleConnection"]],
validateCreatePipelineStageLocale?: [{	data: ValueTypes["PipelineStageLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePipelineStageLocale?: [{	by: ValueTypes["PipelineStageLocaleUniqueWhere"],	data: ValueTypes["PipelineStageLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getSalesManager?: [{	by: ValueTypes["SalesManagerUniqueWhere"],	filter?: ValueTypes["SalesManagerWhere"] | undefined | null},ValueTypes["SalesManager"]],
listSalesManager?: [{	filter?: ValueTypes["SalesManagerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SalesManagerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["SalesManager"]],
paginateSalesManager?: [{	filter?: ValueTypes["SalesManagerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SalesManagerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["SalesManagerConnection"]],
validateCreateSalesManager?: [{	data: ValueTypes["SalesManagerCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSalesManager?: [{	by: ValueTypes["SalesManagerUniqueWhere"],	data: ValueTypes["SalesManagerUpdateInput"]},ValueTypes["_ValidationResult"]],
getCashierManager?: [{	by: ValueTypes["CashierManagerUniqueWhere"],	filter?: ValueTypes["CashierManagerWhere"] | undefined | null},ValueTypes["CashierManager"]],
listCashierManager?: [{	filter?: ValueTypes["CashierManagerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CashierManagerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CashierManager"]],
paginateCashierManager?: [{	filter?: ValueTypes["CashierManagerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CashierManagerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CashierManagerConnection"]],
validateCreateCashierManager?: [{	data: ValueTypes["CashierManagerCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCashierManager?: [{	by: ValueTypes["CashierManagerUniqueWhere"],	data: ValueTypes["CashierManagerUpdateInput"]},ValueTypes["_ValidationResult"]],
getUserRoles?: [{	by: ValueTypes["UserRolesUniqueWhere"],	filter?: ValueTypes["UserRolesWhere"] | undefined | null},ValueTypes["UserRoles"]],
listUserRoles?: [{	filter?: ValueTypes["UserRolesWhere"] | undefined | null,	orderBy?: Array<ValueTypes["UserRolesOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["UserRoles"]],
paginateUserRoles?: [{	filter?: ValueTypes["UserRolesWhere"] | undefined | null,	orderBy?: Array<ValueTypes["UserRolesOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["UserRolesConnection"]],
getPointOfSaleApplicationDevice?: [{	by: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"],	filter?: ValueTypes["PointOfSaleApplicationDeviceWhere"] | undefined | null},ValueTypes["PointOfSaleApplicationDevice"]],
listPointOfSaleApplicationDevice?: [{	filter?: ValueTypes["PointOfSaleApplicationDeviceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleApplicationDeviceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PointOfSaleApplicationDevice"]],
paginatePointOfSaleApplicationDevice?: [{	filter?: ValueTypes["PointOfSaleApplicationDeviceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleApplicationDeviceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PointOfSaleApplicationDeviceConnection"]],
validateCreatePointOfSaleApplicationDevice?: [{	data: ValueTypes["PointOfSaleApplicationDeviceCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePointOfSaleApplicationDevice?: [{	by: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"],	data: ValueTypes["PointOfSaleApplicationDeviceUpdateInput"]},ValueTypes["_ValidationResult"]],
getPointOfSaleTerminal?: [{	by: ValueTypes["PointOfSaleTerminalUniqueWhere"],	filter?: ValueTypes["PointOfSaleTerminalWhere"] | undefined | null},ValueTypes["PointOfSaleTerminal"]],
listPointOfSaleTerminal?: [{	filter?: ValueTypes["PointOfSaleTerminalWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleTerminalOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PointOfSaleTerminal"]],
paginatePointOfSaleTerminal?: [{	filter?: ValueTypes["PointOfSaleTerminalWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleTerminalOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PointOfSaleTerminalConnection"]],
validateCreatePointOfSaleTerminal?: [{	data: ValueTypes["PointOfSaleTerminalCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePointOfSaleTerminal?: [{	by: ValueTypes["PointOfSaleTerminalUniqueWhere"],	data: ValueTypes["PointOfSaleTerminalUpdateInput"]},ValueTypes["_ValidationResult"]],
getPipelineStageSentiment?: [{	by: ValueTypes["PipelineStageSentimentUniqueWhere"],	filter?: ValueTypes["PipelineStageSentimentWhere"] | undefined | null},ValueTypes["PipelineStageSentiment"]],
listPipelineStageSentiment?: [{	filter?: ValueTypes["PipelineStageSentimentWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PipelineStageSentimentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PipelineStageSentiment"]],
paginatePipelineStageSentiment?: [{	filter?: ValueTypes["PipelineStageSentimentWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PipelineStageSentimentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PipelineStageSentimentConnection"]],
validateCreatePipelineStageSentiment?: [{	data: ValueTypes["PipelineStageSentimentCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePipelineStageSentiment?: [{	by: ValueTypes["PipelineStageSentimentUniqueWhere"],	data: ValueTypes["PipelineStageSentimentUpdateInput"]},ValueTypes["_ValidationResult"]],
getDeviceIdentifier?: [{	by: ValueTypes["DeviceIdentifierUniqueWhere"],	filter?: ValueTypes["DeviceIdentifierWhere"] | undefined | null},ValueTypes["DeviceIdentifier"]],
listDeviceIdentifier?: [{	filter?: ValueTypes["DeviceIdentifierWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeviceIdentifierOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["DeviceIdentifier"]],
paginateDeviceIdentifier?: [{	filter?: ValueTypes["DeviceIdentifierWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeviceIdentifierOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["DeviceIdentifierConnection"]],
validateCreateDeviceIdentifier?: [{	data: ValueTypes["DeviceIdentifierCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDeviceIdentifier?: [{	by: ValueTypes["DeviceIdentifierUniqueWhere"],	data: ValueTypes["DeviceIdentifierUpdateInput"]},ValueTypes["_ValidationResult"]],
getDeviceIdentifierMetadata?: [{	by: ValueTypes["DeviceIdentifierMetadataUniqueWhere"],	filter?: ValueTypes["DeviceIdentifierMetadataWhere"] | undefined | null},ValueTypes["DeviceIdentifierMetadata"]],
listDeviceIdentifierMetadata?: [{	filter?: ValueTypes["DeviceIdentifierMetadataWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeviceIdentifierMetadataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["DeviceIdentifierMetadata"]],
paginateDeviceIdentifierMetadata?: [{	filter?: ValueTypes["DeviceIdentifierMetadataWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeviceIdentifierMetadataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["DeviceIdentifierMetadataConnection"]],
getPointOfSalePrinter?: [{	by: ValueTypes["PointOfSalePrinterUniqueWhere"],	filter?: ValueTypes["PointOfSalePrinterWhere"] | undefined | null},ValueTypes["PointOfSalePrinter"]],
listPointOfSalePrinter?: [{	filter?: ValueTypes["PointOfSalePrinterWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSalePrinterOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PointOfSalePrinter"]],
paginatePointOfSalePrinter?: [{	filter?: ValueTypes["PointOfSalePrinterWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSalePrinterOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PointOfSalePrinterConnection"]],
validateCreatePointOfSalePrinter?: [{	data: ValueTypes["PointOfSalePrinterCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePointOfSalePrinter?: [{	by: ValueTypes["PointOfSalePrinterUniqueWhere"],	data: ValueTypes["PointOfSalePrinterUpdateInput"]},ValueTypes["_ValidationResult"]],
getGratuity?: [{	by: ValueTypes["GratuityUniqueWhere"],	filter?: ValueTypes["GratuityWhere"] | undefined | null},ValueTypes["Gratuity"]],
listGratuity?: [{	filter?: ValueTypes["GratuityWhere"] | undefined | null,	orderBy?: Array<ValueTypes["GratuityOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Gratuity"]],
paginateGratuity?: [{	filter?: ValueTypes["GratuityWhere"] | undefined | null,	orderBy?: Array<ValueTypes["GratuityOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["GratuityConnection"]],
validateCreateGratuity?: [{	data: ValueTypes["GratuityCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateGratuity?: [{	by: ValueTypes["GratuityUniqueWhere"],	data: ValueTypes["GratuityUpdateInput"]},ValueTypes["_ValidationResult"]],
getFulfillmentNote?: [{	by: ValueTypes["FulfillmentNoteUniqueWhere"],	filter?: ValueTypes["FulfillmentNoteWhere"] | undefined | null},ValueTypes["FulfillmentNote"]],
listFulfillmentNote?: [{	filter?: ValueTypes["FulfillmentNoteWhere"] | undefined | null,	orderBy?: Array<ValueTypes["FulfillmentNoteOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["FulfillmentNote"]],
paginateFulfillmentNote?: [{	filter?: ValueTypes["FulfillmentNoteWhere"] | undefined | null,	orderBy?: Array<ValueTypes["FulfillmentNoteOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["FulfillmentNoteConnection"]],
validateCreateFulfillmentNote?: [{	data: ValueTypes["FulfillmentNoteCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFulfillmentNote?: [{	by: ValueTypes["FulfillmentNoteUniqueWhere"],	data: ValueTypes["FulfillmentNoteUpdateInput"]},ValueTypes["_ValidationResult"]],
getCustomerMetadata?: [{	by: ValueTypes["CustomerMetadataUniqueWhere"],	filter?: ValueTypes["CustomerMetadataWhere"] | undefined | null},ValueTypes["CustomerMetadata"]],
listCustomerMetadata?: [{	filter?: ValueTypes["CustomerMetadataWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerMetadataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CustomerMetadata"]],
paginateCustomerMetadata?: [{	filter?: ValueTypes["CustomerMetadataWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerMetadataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerMetadataConnection"]],
getLeadForm?: [{	by: ValueTypes["LeadFormUniqueWhere"],	filter?: ValueTypes["LeadFormWhere"] | undefined | null},ValueTypes["LeadForm"]],
listLeadForm?: [{	filter?: ValueTypes["LeadFormWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LeadFormOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["LeadForm"]],
paginateLeadForm?: [{	filter?: ValueTypes["LeadFormWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LeadFormOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["LeadFormConnection"]],
validateCreateLeadForm?: [{	data: ValueTypes["LeadFormCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLeadForm?: [{	by: ValueTypes["LeadFormUniqueWhere"],	data: ValueTypes["LeadFormUpdateInput"]},ValueTypes["_ValidationResult"]],
getSubscriptionBox?: [{	by: ValueTypes["SubscriptionBoxUniqueWhere"],	filter?: ValueTypes["SubscriptionBoxWhere"] | undefined | null},ValueTypes["SubscriptionBox"]],
listSubscriptionBox?: [{	filter?: ValueTypes["SubscriptionBoxWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SubscriptionBoxOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["SubscriptionBox"]],
paginateSubscriptionBox?: [{	filter?: ValueTypes["SubscriptionBoxWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SubscriptionBoxOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["SubscriptionBoxConnection"]],
validateCreateSubscriptionBox?: [{	data: ValueTypes["SubscriptionBoxCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSubscriptionBox?: [{	by: ValueTypes["SubscriptionBoxUniqueWhere"],	data: ValueTypes["SubscriptionBoxUpdateInput"]},ValueTypes["_ValidationResult"]],
getSubscriptionBoxLocale?: [{	by: ValueTypes["SubscriptionBoxLocaleUniqueWhere"],	filter?: ValueTypes["SubscriptionBoxLocaleWhere"] | undefined | null},ValueTypes["SubscriptionBoxLocale"]],
listSubscriptionBoxLocale?: [{	filter?: ValueTypes["SubscriptionBoxLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SubscriptionBoxLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["SubscriptionBoxLocale"]],
paginateSubscriptionBoxLocale?: [{	filter?: ValueTypes["SubscriptionBoxLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SubscriptionBoxLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["SubscriptionBoxLocaleConnection"]],
validateCreateSubscriptionBoxLocale?: [{	data: ValueTypes["SubscriptionBoxLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSubscriptionBoxLocale?: [{	by: ValueTypes["SubscriptionBoxLocaleUniqueWhere"],	data: ValueTypes["SubscriptionBoxLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getTimetableDayMetadata?: [{	by: ValueTypes["TimetableDayMetadataUniqueWhere"],	filter?: ValueTypes["TimetableDayMetadataWhere"] | undefined | null},ValueTypes["TimetableDayMetadata"]],
listTimetableDayMetadata?: [{	filter?: ValueTypes["TimetableDayMetadataWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableDayMetadataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TimetableDayMetadata"]],
paginateTimetableDayMetadata?: [{	filter?: ValueTypes["TimetableDayMetadataWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableDayMetadataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TimetableDayMetadataConnection"]],
getBusinessService?: [{	by: ValueTypes["BusinessServiceUniqueWhere"],	filter?: ValueTypes["BusinessServiceWhere"] | undefined | null},ValueTypes["BusinessService"]],
listBusinessService?: [{	filter?: ValueTypes["BusinessServiceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessServiceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BusinessService"]],
paginateBusinessService?: [{	filter?: ValueTypes["BusinessServiceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessServiceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BusinessServiceConnection"]],
validateCreateBusinessService?: [{	data: ValueTypes["BusinessServiceCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBusinessService?: [{	by: ValueTypes["BusinessServiceUniqueWhere"],	data: ValueTypes["BusinessServiceUpdateInput"]},ValueTypes["_ValidationResult"]],
getBusinessServiceEvent?: [{	by: ValueTypes["BusinessServiceEventUniqueWhere"],	filter?: ValueTypes["BusinessServiceEventWhere"] | undefined | null},ValueTypes["BusinessServiceEvent"]],
listBusinessServiceEvent?: [{	filter?: ValueTypes["BusinessServiceEventWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessServiceEventOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BusinessServiceEvent"]],
paginateBusinessServiceEvent?: [{	filter?: ValueTypes["BusinessServiceEventWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessServiceEventOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BusinessServiceEventConnection"]],
validateCreateBusinessServiceEvent?: [{	data: ValueTypes["BusinessServiceEventCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBusinessServiceEvent?: [{	by: ValueTypes["BusinessServiceEventUniqueWhere"],	data: ValueTypes["BusinessServiceEventUpdateInput"]},ValueTypes["_ValidationResult"]],
getBusinessServiceLocale?: [{	by: ValueTypes["BusinessServiceLocaleUniqueWhere"],	filter?: ValueTypes["BusinessServiceLocaleWhere"] | undefined | null},ValueTypes["BusinessServiceLocale"]],
listBusinessServiceLocale?: [{	filter?: ValueTypes["BusinessServiceLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessServiceLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BusinessServiceLocale"]],
paginateBusinessServiceLocale?: [{	filter?: ValueTypes["BusinessServiceLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessServiceLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BusinessServiceLocaleConnection"]],
validateCreateBusinessServiceLocale?: [{	data: ValueTypes["BusinessServiceLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBusinessServiceLocale?: [{	by: ValueTypes["BusinessServiceLocaleUniqueWhere"],	data: ValueTypes["BusinessServiceLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getGridTileItem?: [{	by: ValueTypes["GridTileItemUniqueWhere"],	filter?: ValueTypes["GridTileItemWhere"] | undefined | null},ValueTypes["GridTileItem"]],
listGridTileItem?: [{	filter?: ValueTypes["GridTileItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["GridTileItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["GridTileItem"]],
paginateGridTileItem?: [{	filter?: ValueTypes["GridTileItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["GridTileItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["GridTileItemConnection"]],
validateCreateGridTileItem?: [{	data: ValueTypes["GridTileItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateGridTileItem?: [{	by: ValueTypes["GridTileItemUniqueWhere"],	data: ValueTypes["GridTileItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getGridTiles?: [{	by: ValueTypes["GridTilesUniqueWhere"],	filter?: ValueTypes["GridTilesWhere"] | undefined | null},ValueTypes["GridTiles"]],
listGridTiles?: [{	filter?: ValueTypes["GridTilesWhere"] | undefined | null,	orderBy?: Array<ValueTypes["GridTilesOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["GridTiles"]],
paginateGridTiles?: [{	filter?: ValueTypes["GridTilesWhere"] | undefined | null,	orderBy?: Array<ValueTypes["GridTilesOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["GridTilesConnection"]],
validateCreateGridTiles?: [{	data: ValueTypes["GridTilesCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateGridTiles?: [{	by: ValueTypes["GridTilesUniqueWhere"],	data: ValueTypes["GridTilesUpdateInput"]},ValueTypes["_ValidationResult"]],
getArea?: [{	by: ValueTypes["AreaUniqueWhere"],	filter?: ValueTypes["AreaWhere"] | undefined | null},ValueTypes["Area"]],
listArea?: [{	filter?: ValueTypes["AreaWhere"] | undefined | null,	orderBy?: Array<ValueTypes["AreaOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Area"]],
paginateArea?: [{	filter?: ValueTypes["AreaWhere"] | undefined | null,	orderBy?: Array<ValueTypes["AreaOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["AreaConnection"]],
validateCreateArea?: [{	data: ValueTypes["AreaCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateArea?: [{	by: ValueTypes["AreaUniqueWhere"],	data: ValueTypes["AreaUpdateInput"]},ValueTypes["_ValidationResult"]],
getPosition?: [{	by: ValueTypes["PositionUniqueWhere"],	filter?: ValueTypes["PositionWhere"] | undefined | null},ValueTypes["Position"]],
listPosition?: [{	filter?: ValueTypes["PositionWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PositionOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Position"]],
paginatePosition?: [{	filter?: ValueTypes["PositionWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PositionOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PositionConnection"]],
validateCreatePosition?: [{	data: ValueTypes["PositionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePosition?: [{	by: ValueTypes["PositionUniqueWhere"],	data: ValueTypes["PositionUpdateInput"]},ValueTypes["_ValidationResult"]],
getStatsEnabledWidgetType?: [{	by: ValueTypes["StatsEnabledWidgetTypeUniqueWhere"],	filter?: ValueTypes["StatsEnabledWidgetTypeWhere"] | undefined | null},ValueTypes["StatsEnabledWidgetType"]],
listStatsEnabledWidgetType?: [{	filter?: ValueTypes["StatsEnabledWidgetTypeWhere"] | undefined | null,	orderBy?: Array<ValueTypes["StatsEnabledWidgetTypeOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["StatsEnabledWidgetType"]],
paginateStatsEnabledWidgetType?: [{	filter?: ValueTypes["StatsEnabledWidgetTypeWhere"] | undefined | null,	orderBy?: Array<ValueTypes["StatsEnabledWidgetTypeOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["StatsEnabledWidgetTypeConnection"]],
validateCreateStatsEnabledWidgetType?: [{	data: ValueTypes["StatsEnabledWidgetTypeCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateStatsEnabledWidgetType?: [{	by: ValueTypes["StatsEnabledWidgetTypeUniqueWhere"],	data: ValueTypes["StatsEnabledWidgetTypeUpdateInput"]},ValueTypes["_ValidationResult"]],
getStatsWidget?: [{	by: ValueTypes["StatsWidgetUniqueWhere"],	filter?: ValueTypes["StatsWidgetWhere"] | undefined | null},ValueTypes["StatsWidget"]],
listStatsWidget?: [{	filter?: ValueTypes["StatsWidgetWhere"] | undefined | null,	orderBy?: Array<ValueTypes["StatsWidgetOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["StatsWidget"]],
paginateStatsWidget?: [{	filter?: ValueTypes["StatsWidgetWhere"] | undefined | null,	orderBy?: Array<ValueTypes["StatsWidgetOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["StatsWidgetConnection"]],
validateCreateStatsWidget?: [{	data: ValueTypes["StatsWidgetCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateStatsWidget?: [{	by: ValueTypes["StatsWidgetUniqueWhere"],	data: ValueTypes["StatsWidgetUpdateInput"]},ValueTypes["_ValidationResult"]],
getStatsWidgetsLayout?: [{	by: ValueTypes["StatsWidgetsLayoutUniqueWhere"],	filter?: ValueTypes["StatsWidgetsLayoutWhere"] | undefined | null},ValueTypes["StatsWidgetsLayout"]],
listStatsWidgetsLayout?: [{	filter?: ValueTypes["StatsWidgetsLayoutWhere"] | undefined | null,	orderBy?: Array<ValueTypes["StatsWidgetsLayoutOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["StatsWidgetsLayout"]],
paginateStatsWidgetsLayout?: [{	filter?: ValueTypes["StatsWidgetsLayoutWhere"] | undefined | null,	orderBy?: Array<ValueTypes["StatsWidgetsLayoutOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["StatsWidgetsLayoutConnection"]],
validateCreateStatsWidgetsLayout?: [{	data: ValueTypes["StatsWidgetsLayoutCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateStatsWidgetsLayout?: [{	by: ValueTypes["StatsWidgetsLayoutUniqueWhere"],	data: ValueTypes["StatsWidgetsLayoutUpdateInput"]},ValueTypes["_ValidationResult"]],
getSeat?: [{	by: ValueTypes["SeatUniqueWhere"],	filter?: ValueTypes["SeatWhere"] | undefined | null},ValueTypes["Seat"]],
listSeat?: [{	filter?: ValueTypes["SeatWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SeatOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Seat"]],
paginateSeat?: [{	filter?: ValueTypes["SeatWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SeatOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["SeatConnection"]],
validateCreateSeat?: [{	data: ValueTypes["SeatCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSeat?: [{	by: ValueTypes["SeatUniqueWhere"],	data: ValueTypes["SeatUpdateInput"]},ValueTypes["_ValidationResult"]],
getTable?: [{	by: ValueTypes["TableUniqueWhere"],	filter?: ValueTypes["TableWhere"] | undefined | null},ValueTypes["Table"]],
listTable?: [{	filter?: ValueTypes["TableWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TableOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Table"]],
paginateTable?: [{	filter?: ValueTypes["TableWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TableOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TableConnection"]],
validateCreateTable?: [{	data: ValueTypes["TableCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTable?: [{	by: ValueTypes["TableUniqueWhere"],	data: ValueTypes["TableUpdateInput"]},ValueTypes["_ValidationResult"]],
getStatsPage?: [{	by: ValueTypes["StatsPageUniqueWhere"],	filter?: ValueTypes["StatsPageWhere"] | undefined | null},ValueTypes["StatsPage"]],
listStatsPage?: [{	filter?: ValueTypes["StatsPageWhere"] | undefined | null,	orderBy?: Array<ValueTypes["StatsPageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["StatsPage"]],
paginateStatsPage?: [{	filter?: ValueTypes["StatsPageWhere"] | undefined | null,	orderBy?: Array<ValueTypes["StatsPageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["StatsPageConnection"]],
validateCreateStatsPage?: [{	data: ValueTypes["StatsPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateStatsPage?: [{	by: ValueTypes["StatsPageUniqueWhere"],	data: ValueTypes["StatsPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getUnassignReason?: [{	by: ValueTypes["UnassignReasonUniqueWhere"],	filter?: ValueTypes["UnassignReasonWhere"] | undefined | null},ValueTypes["UnassignReason"]],
listUnassignReason?: [{	filter?: ValueTypes["UnassignReasonWhere"] | undefined | null,	orderBy?: Array<ValueTypes["UnassignReasonOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["UnassignReason"]],
paginateUnassignReason?: [{	filter?: ValueTypes["UnassignReasonWhere"] | undefined | null,	orderBy?: Array<ValueTypes["UnassignReasonOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["UnassignReasonConnection"]],
validateCreateUnassignReason?: [{	data: ValueTypes["UnassignReasonCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateUnassignReason?: [{	by: ValueTypes["UnassignReasonUniqueWhere"],	data: ValueTypes["UnassignReasonUpdateInput"]},ValueTypes["_ValidationResult"]],
getDoubleshotCoffeeEquipment?: [{	by: ValueTypes["DoubleshotCoffeeEquipmentUniqueWhere"],	filter?: ValueTypes["DoubleshotCoffeeEquipmentWhere"] | undefined | null},ValueTypes["DoubleshotCoffeeEquipment"]],
listDoubleshotCoffeeEquipment?: [{	filter?: ValueTypes["DoubleshotCoffeeEquipmentWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DoubleshotCoffeeEquipmentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["DoubleshotCoffeeEquipment"]],
paginateDoubleshotCoffeeEquipment?: [{	filter?: ValueTypes["DoubleshotCoffeeEquipmentWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DoubleshotCoffeeEquipmentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["DoubleshotCoffeeEquipmentConnection"]],
validateCreateDoubleshotCoffeeEquipment?: [{	data: ValueTypes["DoubleshotCoffeeEquipmentCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDoubleshotCoffeeEquipment?: [{	by: ValueTypes["DoubleshotCoffeeEquipmentUniqueWhere"],	data: ValueTypes["DoubleshotCoffeeEquipmentUpdateInput"]},ValueTypes["_ValidationResult"]],
getExpense?: [{	by: ValueTypes["ExpenseUniqueWhere"],	filter?: ValueTypes["ExpenseWhere"] | undefined | null},ValueTypes["Expense"]],
listExpense?: [{	filter?: ValueTypes["ExpenseWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ExpenseOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Expense"]],
paginateExpense?: [{	filter?: ValueTypes["ExpenseWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ExpenseOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ExpenseConnection"]],
validateCreateExpense?: [{	data: ValueTypes["ExpenseCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateExpense?: [{	by: ValueTypes["ExpenseUniqueWhere"],	data: ValueTypes["ExpenseUpdateInput"]},ValueTypes["_ValidationResult"]],
getExpenseCategory?: [{	by: ValueTypes["ExpenseCategoryUniqueWhere"],	filter?: ValueTypes["ExpenseCategoryWhere"] | undefined | null},ValueTypes["ExpenseCategory"]],
listExpenseCategory?: [{	filter?: ValueTypes["ExpenseCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ExpenseCategoryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ExpenseCategory"]],
paginateExpenseCategory?: [{	filter?: ValueTypes["ExpenseCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ExpenseCategoryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ExpenseCategoryConnection"]],
validateCreateExpenseCategory?: [{	data: ValueTypes["ExpenseCategoryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateExpenseCategory?: [{	by: ValueTypes["ExpenseCategoryUniqueWhere"],	data: ValueTypes["ExpenseCategoryUpdateInput"]},ValueTypes["_ValidationResult"]],
getExpenseChange?: [{	by: ValueTypes["ExpenseChangeUniqueWhere"],	filter?: ValueTypes["ExpenseChangeWhere"] | undefined | null},ValueTypes["ExpenseChange"]],
listExpenseChange?: [{	filter?: ValueTypes["ExpenseChangeWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ExpenseChangeOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ExpenseChange"]],
paginateExpenseChange?: [{	filter?: ValueTypes["ExpenseChangeWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ExpenseChangeOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ExpenseChangeConnection"]],
validateCreateExpenseChange?: [{	data: ValueTypes["ExpenseChangeCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateExpenseChange?: [{	by: ValueTypes["ExpenseChangeUniqueWhere"],	data: ValueTypes["ExpenseChangeUpdateInput"]},ValueTypes["_ValidationResult"]],
getExpenseDocument?: [{	by: ValueTypes["ExpenseDocumentUniqueWhere"],	filter?: ValueTypes["ExpenseDocumentWhere"] | undefined | null},ValueTypes["ExpenseDocument"]],
listExpenseDocument?: [{	filter?: ValueTypes["ExpenseDocumentWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ExpenseDocumentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ExpenseDocument"]],
paginateExpenseDocument?: [{	filter?: ValueTypes["ExpenseDocumentWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ExpenseDocumentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ExpenseDocumentConnection"]],
validateCreateExpenseDocument?: [{	data: ValueTypes["ExpenseDocumentCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateExpenseDocument?: [{	by: ValueTypes["ExpenseDocumentUniqueWhere"],	data: ValueTypes["ExpenseDocumentUpdateInput"]},ValueTypes["_ValidationResult"]],
getRevenuePrediction?: [{	by: ValueTypes["RevenuePredictionUniqueWhere"],	filter?: ValueTypes["RevenuePredictionWhere"] | undefined | null},ValueTypes["RevenuePrediction"]],
listRevenuePrediction?: [{	filter?: ValueTypes["RevenuePredictionWhere"] | undefined | null,	orderBy?: Array<ValueTypes["RevenuePredictionOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["RevenuePrediction"]],
paginateRevenuePrediction?: [{	filter?: ValueTypes["RevenuePredictionWhere"] | undefined | null,	orderBy?: Array<ValueTypes["RevenuePredictionOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["RevenuePredictionConnection"]],
validateCreateRevenuePrediction?: [{	data: ValueTypes["RevenuePredictionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateRevenuePrediction?: [{	by: ValueTypes["RevenuePredictionUniqueWhere"],	data: ValueTypes["RevenuePredictionUpdateInput"]},ValueTypes["_ValidationResult"]],
getRevenuePredictionChange?: [{	by: ValueTypes["RevenuePredictionChangeUniqueWhere"],	filter?: ValueTypes["RevenuePredictionChangeWhere"] | undefined | null},ValueTypes["RevenuePredictionChange"]],
listRevenuePredictionChange?: [{	filter?: ValueTypes["RevenuePredictionChangeWhere"] | undefined | null,	orderBy?: Array<ValueTypes["RevenuePredictionChangeOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["RevenuePredictionChange"]],
paginateRevenuePredictionChange?: [{	filter?: ValueTypes["RevenuePredictionChangeWhere"] | undefined | null,	orderBy?: Array<ValueTypes["RevenuePredictionChangeOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["RevenuePredictionChangeConnection"]],
validateCreateRevenuePredictionChange?: [{	data: ValueTypes["RevenuePredictionChangeCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateRevenuePredictionChange?: [{	by: ValueTypes["RevenuePredictionChangeUniqueWhere"],	data: ValueTypes["RevenuePredictionChangeUpdateInput"]},ValueTypes["_ValidationResult"]],
getFile?: [{	by: ValueTypes["FileUniqueWhere"],	filter?: ValueTypes["FileWhere"] | undefined | null},ValueTypes["File"]],
listFile?: [{	filter?: ValueTypes["FileWhere"] | undefined | null,	orderBy?: Array<ValueTypes["FileOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["File"]],
paginateFile?: [{	filter?: ValueTypes["FileWhere"] | undefined | null,	orderBy?: Array<ValueTypes["FileOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["FileConnection"]],
validateCreateFile?: [{	data: ValueTypes["FileCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFile?: [{	by: ValueTypes["FileUniqueWhere"],	data: ValueTypes["FileUpdateInput"]},ValueTypes["_ValidationResult"]],
getExpenseTerm?: [{	by: ValueTypes["ExpenseTermUniqueWhere"],	filter?: ValueTypes["ExpenseTermWhere"] | undefined | null},ValueTypes["ExpenseTerm"]],
listExpenseTerm?: [{	filter?: ValueTypes["ExpenseTermWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ExpenseTermOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ExpenseTerm"]],
paginateExpenseTerm?: [{	filter?: ValueTypes["ExpenseTermWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ExpenseTermOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ExpenseTermConnection"]],
getLine?: [{	by: ValueTypes["LineUniqueWhere"],	filter?: ValueTypes["LineWhere"] | undefined | null},ValueTypes["Line"]],
listLine?: [{	filter?: ValueTypes["LineWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LineOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Line"]],
paginateLine?: [{	filter?: ValueTypes["LineWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LineOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["LineConnection"]],
validateCreateLine?: [{	data: ValueTypes["LineCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLine?: [{	by: ValueTypes["LineUniqueWhere"],	data: ValueTypes["LineUpdateInput"]},ValueTypes["_ValidationResult"]],
getFinancesBalanceItem?: [{	by: ValueTypes["FinancesBalanceItemUniqueWhere"],	filter?: ValueTypes["FinancesBalanceItemWhere"] | undefined | null},ValueTypes["FinancesBalanceItem"]],
listFinancesBalanceItem?: [{	filter?: ValueTypes["FinancesBalanceItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["FinancesBalanceItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["FinancesBalanceItem"]],
paginateFinancesBalanceItem?: [{	filter?: ValueTypes["FinancesBalanceItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["FinancesBalanceItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["FinancesBalanceItemConnection"]],
validateCreateFinancesBalanceItem?: [{	data: ValueTypes["FinancesBalanceItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFinancesBalanceItem?: [{	by: ValueTypes["FinancesBalanceItemUniqueWhere"],	data: ValueTypes["FinancesBalanceItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getRevenuePredictionTerm?: [{	by: ValueTypes["RevenuePredictionTermUniqueWhere"],	filter?: ValueTypes["RevenuePredictionTermWhere"] | undefined | null},ValueTypes["RevenuePredictionTerm"]],
listRevenuePredictionTerm?: [{	filter?: ValueTypes["RevenuePredictionTermWhere"] | undefined | null,	orderBy?: Array<ValueTypes["RevenuePredictionTermOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["RevenuePredictionTerm"]],
paginateRevenuePredictionTerm?: [{	filter?: ValueTypes["RevenuePredictionTermWhere"] | undefined | null,	orderBy?: Array<ValueTypes["RevenuePredictionTermOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["RevenuePredictionTermConnection"]],
getOrderPaymentStatsByDay?: [{	by: ValueTypes["OrderPaymentStatsByDayUniqueWhere"],	filter?: ValueTypes["OrderPaymentStatsByDayWhere"] | undefined | null},ValueTypes["OrderPaymentStatsByDay"]],
listOrderPaymentStatsByDay?: [{	filter?: ValueTypes["OrderPaymentStatsByDayWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderPaymentStatsByDayOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["OrderPaymentStatsByDay"]],
paginateOrderPaymentStatsByDay?: [{	filter?: ValueTypes["OrderPaymentStatsByDayWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderPaymentStatsByDayOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderPaymentStatsByDayConnection"]],
getWoltDriveDelivery?: [{	by: ValueTypes["WoltDriveDeliveryUniqueWhere"],	filter?: ValueTypes["WoltDriveDeliveryWhere"] | undefined | null},ValueTypes["WoltDriveDelivery"]],
listWoltDriveDelivery?: [{	filter?: ValueTypes["WoltDriveDeliveryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["WoltDriveDeliveryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["WoltDriveDelivery"]],
paginateWoltDriveDelivery?: [{	filter?: ValueTypes["WoltDriveDeliveryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["WoltDriveDeliveryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["WoltDriveDeliveryConnection"]],
validateCreateWoltDriveDelivery?: [{	data: ValueTypes["WoltDriveDeliveryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateWoltDriveDelivery?: [{	by: ValueTypes["WoltDriveDeliveryUniqueWhere"],	data: ValueTypes["WoltDriveDeliveryUpdateInput"]},ValueTypes["_ValidationResult"]],
	transaction?:ValueTypes["QueryTransaction"],
	_info?:ValueTypes["Info"],
	schema?:ValueTypes["_Schema"],
	s3DummyQuery?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Address"]: AliasType<{
	_meta?:ValueTypes["AddressMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	addressLine2?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	phone?:boolean | `@${string}`,
	companyName?:boolean | `@${string}`,
	companyIdentifier?:boolean | `@${string}`,
	vatIdentifier?:boolean | `@${string}`,
	externalIdentifier?:boolean | `@${string}`,
	hidden?:boolean | `@${string}`,
customer?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
	internalNote?:boolean | `@${string}`,
country?: [{	filter?: ValueTypes["CountryWhere"] | undefined | null},ValueTypes["Country"]],
	deletedAt?:boolean | `@${string}`,
	note?:boolean | `@${string}`,
	googlePlaceId?:boolean | `@${string}`,
	raw?:boolean | `@${string}`,
	formatted?:boolean | `@${string}`,
	geocodeGeneratedAt?:boolean | `@${string}`,
	geocodeResponse?:boolean | `@${string}`,
deliveryZone?: [{	filter?: ValueTypes["DeliveryZoneWhere"] | undefined | null},ValueTypes["DeliveryZone"]],
meta?: [{	filter?: ValueTypes["AddressMetadataWhere"] | undefined | null},ValueTypes["AddressMetadata"]],
gps?: [{	filter?: ValueTypes["GpsWhere"] | undefined | null},ValueTypes["Gps"]],
	geocodeValid?:boolean | `@${string}`,
	fullName?:boolean | `@${string}`,
	fakturoidSubjectId?:boolean | `@${string}`,
invoices?: [{	filter?: ValueTypes["InvoiceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InvoiceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Invoice"]],
	addressLine1?:boolean | `@${string}`,
	city?:boolean | `@${string}`,
	postalCode?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
billingAddressOfOrders?: [{	filter?: ValueTypes["OrderWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Order"]],
deliveryAddressOfOrderDeliveries?: [{	filter?: ValueTypes["OrderDeliveryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderDeliveryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["OrderDelivery"]],
defaultDeliveryAddressOfCustomer?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
invoicesByPublicKey?: [{	by: ValueTypes["AddressInvoicesByPublicKeyUniqueWhere"],	filter?: ValueTypes["InvoiceWhere"] | undefined | null},ValueTypes["Invoice"]],
invoicesByFakturoidId?: [{	by: ValueTypes["AddressInvoicesByFakturoidIdUniqueWhere"],	filter?: ValueTypes["InvoiceWhere"] | undefined | null},ValueTypes["Invoice"]],
invoicesByOrderPayments?: [{	by: ValueTypes["AddressInvoicesByOrderPaymentsUniqueWhere"],	filter?: ValueTypes["InvoiceWhere"] | undefined | null},ValueTypes["Invoice"]],
billingAddressOfOrdersBySeq?: [{	by: ValueTypes["AddressBillingAddressOfOrdersBySeqUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
billingAddressOfOrdersByDoubleshotLegacyId?: [{	by: ValueTypes["AddressBillingAddressOfOrdersByDoubleshotLegacyIdUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
billingAddressOfOrdersByDoubleShotLegacyNumber?: [{	by: ValueTypes["AddressBillingAddressOfOrdersByDoubleShotLegacyNumberUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
billingAddressOfOrdersByDiscounts?: [{	by: ValueTypes["AddressBillingAddressOfOrdersByDiscountsUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
billingAddressOfOrdersByDelivery?: [{	by: ValueTypes["AddressBillingAddressOfOrdersByDeliveryUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
billingAddressOfOrdersByItems?: [{	by: ValueTypes["AddressBillingAddressOfOrdersByItemsUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
billingAddressOfOrdersByCart?: [{	by: ValueTypes["AddressBillingAddressOfOrdersByCartUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
billingAddressOfOrdersByEvents?: [{	by: ValueTypes["AddressBillingAddressOfOrdersByEventsUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
billingAddressOfOrdersByPriceLines?: [{	by: ValueTypes["AddressBillingAddressOfOrdersByPriceLinesUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
billingAddressOfOrdersByPayments?: [{	by: ValueTypes["AddressBillingAddressOfOrdersByPaymentsUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
billingAddressOfOrdersBySummary?: [{	by: ValueTypes["AddressBillingAddressOfOrdersBySummaryUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
billingAddressOfOrdersByGratuity?: [{	by: ValueTypes["AddressBillingAddressOfOrdersByGratuityUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
deliveryAddressOfOrderDeliveriesByTrackingCode?: [{	by: ValueTypes["AddressDeliveryAddressOfOrderDeliveriesByTrackingCodeUniqueWhere"],	filter?: ValueTypes["OrderDeliveryWhere"] | undefined | null},ValueTypes["OrderDelivery"]],
deliveryAddressOfOrderDeliveriesByOrder?: [{	by: ValueTypes["AddressDeliveryAddressOfOrderDeliveriesByOrderUniqueWhere"],	filter?: ValueTypes["OrderDeliveryWhere"] | undefined | null},ValueTypes["OrderDelivery"]],
deliveryAddressOfOrderDeliveriesByDeliveryWaypoint?: [{	by: ValueTypes["AddressDeliveryAddressOfOrderDeliveriesByDeliveryWaypointUniqueWhere"],	filter?: ValueTypes["OrderDeliveryWhere"] | undefined | null},ValueTypes["OrderDelivery"]],
deliveryAddressOfOrderDeliveriesByEvents?: [{	by: ValueTypes["AddressDeliveryAddressOfOrderDeliveriesByEventsUniqueWhere"],	filter?: ValueTypes["OrderDeliveryWhere"] | undefined | null},ValueTypes["OrderDelivery"]],
deliveryAddressOfOrderDeliveriesByLiftagoRide?: [{	by: ValueTypes["AddressDeliveryAddressOfOrderDeliveriesByLiftagoRideUniqueWhere"],	filter?: ValueTypes["OrderDeliveryWhere"] | undefined | null},ValueTypes["OrderDelivery"]],
deliveryAddressOfOrderDeliveriesByWoltDriveDelivery?: [{	by: ValueTypes["AddressDeliveryAddressOfOrderDeliveriesByWoltDriveDeliveryUniqueWhere"],	filter?: ValueTypes["OrderDeliveryWhere"] | undefined | null},ValueTypes["OrderDelivery"]],
paginateInvoices?: [{	filter?: ValueTypes["InvoiceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InvoiceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["InvoiceConnection"]],
paginateBillingAddressOfOrders?: [{	filter?: ValueTypes["OrderWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderConnection"]],
paginateDeliveryAddressOfOrderDeliveries?: [{	filter?: ValueTypes["OrderDeliveryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderDeliveryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderDeliveryConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["AddressMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	firstName?:ValueTypes["FieldMeta"],
	lastName?:ValueTypes["FieldMeta"],
	addressLine2?:ValueTypes["FieldMeta"],
	email?:ValueTypes["FieldMeta"],
	phone?:ValueTypes["FieldMeta"],
	companyName?:ValueTypes["FieldMeta"],
	companyIdentifier?:ValueTypes["FieldMeta"],
	vatIdentifier?:ValueTypes["FieldMeta"],
	externalIdentifier?:ValueTypes["FieldMeta"],
	hidden?:ValueTypes["FieldMeta"],
	customer?:ValueTypes["FieldMeta"],
	internalNote?:ValueTypes["FieldMeta"],
	country?:ValueTypes["FieldMeta"],
	deletedAt?:ValueTypes["FieldMeta"],
	note?:ValueTypes["FieldMeta"],
	googlePlaceId?:ValueTypes["FieldMeta"],
	raw?:ValueTypes["FieldMeta"],
	formatted?:ValueTypes["FieldMeta"],
	geocodeGeneratedAt?:ValueTypes["FieldMeta"],
	geocodeResponse?:ValueTypes["FieldMeta"],
	deliveryZone?:ValueTypes["FieldMeta"],
	meta?:ValueTypes["FieldMeta"],
	gps?:ValueTypes["FieldMeta"],
	geocodeValid?:ValueTypes["FieldMeta"],
	fullName?:ValueTypes["FieldMeta"],
	fakturoidSubjectId?:ValueTypes["FieldMeta"],
	invoices?:ValueTypes["FieldMeta"],
	addressLine1?:ValueTypes["FieldMeta"],
	city?:ValueTypes["FieldMeta"],
	postalCode?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	billingAddressOfOrders?:ValueTypes["FieldMeta"],
	deliveryAddressOfOrderDeliveries?:ValueTypes["FieldMeta"],
	defaultDeliveryAddressOfCustomer?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["FieldMeta"]: AliasType<{
	readable?:boolean | `@${string}`,
	updatable?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UUID"]:string;
	["Customer"]: AliasType<{
	_meta?:ValueTypes["CustomerMeta"],
	id?:boolean | `@${string}`,
addresses?: [{	filter?: ValueTypes["AddressWhere"] | undefined | null,	orderBy?: Array<ValueTypes["AddressOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Address"]],
defaultBillingAddress?: [{	filter?: ValueTypes["AddressWhere"] | undefined | null},ValueTypes["Address"]],
defaultPaymentMethod?: [{	filter?: ValueTypes["CustomerPaymentMethodWhere"] | undefined | null},ValueTypes["CustomerPaymentMethod"]],
tags?: [{	filter?: ValueTypes["TagWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TagOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Tag"]],
credits?: [{	filter?: ValueTypes["CustomerCreditWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerCreditOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CustomerCredit"]],
paymentMethods?: [{	filter?: ValueTypes["CustomerPaymentMethodWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerPaymentMethodOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CustomerPaymentMethod"]],
orders?: [{	filter?: ValueTypes["OrderWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Order"]],
permissions?: [{	filter?: ValueTypes["CustomerPermissionsWhere"] | undefined | null},ValueTypes["CustomerPermissions"]],
group?: [{	filter?: ValueTypes["CustomerGroupWhere"] | undefined | null},ValueTypes["CustomerGroup"]],
photo?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null},ValueTypes["Image"]],
	phone?:boolean | `@${string}`,
name?: [{	filter?: ValueTypes["CustomerNameWhere"] | undefined | null},ValueTypes["CustomerName"]],
	internalNote?:boolean | `@${string}`,
	welcomeMessage?:boolean | `@${string}`,
	familiarity?:boolean | `@${string}`,
ingredientRatings?: [{	filter?: ValueTypes["CustomerIngredientRatingWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerIngredientRatingOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CustomerIngredientRating"]],
business?: [{	filter?: ValueTypes["BusinessCustomerWhere"] | undefined | null},ValueTypes["BusinessCustomer"]],
ownerOfBusinesses?: [{	filter?: ValueTypes["BusinessCustomerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessCustomerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BusinessCustomer"]],
memberOfBusinesses?: [{	filter?: ValueTypes["BusinessCustomerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessCustomerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BusinessCustomer"]],
carts?: [{	filter?: ValueTypes["CartWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CartOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Cart"]],
shortcutList?: [{	filter?: ValueTypes["ApplicationShortcutListWhere"] | undefined | null},ValueTypes["ApplicationShortcutList"]],
user?: [{	filter?: ValueTypes["UserWhere"] | undefined | null},ValueTypes["User"]],
channels?: [{	filter?: ValueTypes["ChannelWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ChannelOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Channel"]],
	disabledAt?:boolean | `@${string}`,
invoices?: [{	filter?: ValueTypes["InvoiceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InvoiceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Invoice"]],
invoicingPlan?: [{	filter?: ValueTypes["InvoicingPlanWhere"] | undefined | null},ValueTypes["InvoicingPlan"]],
	email?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
billingSubjects?: [{	filter?: ValueTypes["BillingSubjectWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BillingSubjectOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BillingSubject"]],
offeredProducts?: [{	filter?: ValueTypes["ProductCustomerPriceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCustomerPriceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductCustomerPrice"]],
defaultDeliveryAddress?: [{	filter?: ValueTypes["AddressWhere"] | undefined | null},ValueTypes["Address"]],
defaultBillingSubject?: [{	filter?: ValueTypes["BillingSubjectWhere"] | undefined | null},ValueTypes["BillingSubject"]],
	prefersPackingsWithoutCardboard?:boolean | `@${string}`,
anonymousSession?: [{	filter?: ValueTypes["AnonymousSessionWhere"] | undefined | null},ValueTypes["AnonymousSession"]],
boughtVouchers?: [{	filter?: ValueTypes["VoucherWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VoucherOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Voucher"]],
ownsVouchers?: [{	filter?: ValueTypes["VoucherWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VoucherOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Voucher"]],
redeemedVouchers?: [{	filter?: ValueTypes["VoucherRedemptionWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VoucherRedemptionOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["VoucherRedemption"]],
spending?: [{	filter?: ValueTypes["CustomerSpendingWhere"] | undefined | null},ValueTypes["CustomerSpending"]],
customerTabs?: [{	filter?: ValueTypes["CustomerTabWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerTabOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CustomerTab"]],
lead?: [{	filter?: ValueTypes["PipelineLeadWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PipelineLeadOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PipelineLead"]],
	doubleshotLegacyId?:boolean | `@${string}`,
meta?: [{	filter?: ValueTypes["CustomerMetadataWhere"] | undefined | null},ValueTypes["CustomerMetadata"]],
	doubleshotLastUpdatedAt?:boolean | `@${string}`,
addressesByMeta?: [{	by: ValueTypes["CustomerAddressesByMetaUniqueWhere"],	filter?: ValueTypes["AddressWhere"] | undefined | null},ValueTypes["Address"]],
addressesByGps?: [{	by: ValueTypes["CustomerAddressesByGpsUniqueWhere"],	filter?: ValueTypes["AddressWhere"] | undefined | null},ValueTypes["Address"]],
addressesByInvoices?: [{	by: ValueTypes["CustomerAddressesByInvoicesUniqueWhere"],	filter?: ValueTypes["AddressWhere"] | undefined | null},ValueTypes["Address"]],
addressesByBillingAddressOfOrders?: [{	by: ValueTypes["CustomerAddressesByBillingAddressOfOrdersUniqueWhere"],	filter?: ValueTypes["AddressWhere"] | undefined | null},ValueTypes["Address"]],
addressesByDeliveryAddressOfOrderDeliveries?: [{	by: ValueTypes["CustomerAddressesByDeliveryAddressOfOrderDeliveriesUniqueWhere"],	filter?: ValueTypes["AddressWhere"] | undefined | null},ValueTypes["Address"]],
addressesByDefaultDeliveryAddressOfCustomer?: [{	by: ValueTypes["CustomerAddressesByDefaultDeliveryAddressOfCustomerUniqueWhere"],	filter?: ValueTypes["AddressWhere"] | undefined | null},ValueTypes["Address"]],
creditsByTransactions?: [{	by: ValueTypes["CustomerCreditsByTransactionsUniqueWhere"],	filter?: ValueTypes["CustomerCreditWhere"] | undefined | null},ValueTypes["CustomerCredit"]],
creditsByVoucherRedemption?: [{	by: ValueTypes["CustomerCreditsByVoucherRedemptionUniqueWhere"],	filter?: ValueTypes["CustomerCreditWhere"] | undefined | null},ValueTypes["CustomerCredit"]],
ordersBySeq?: [{	by: ValueTypes["CustomerOrdersBySeqUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
ordersByDoubleshotLegacyId?: [{	by: ValueTypes["CustomerOrdersByDoubleshotLegacyIdUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
ordersByDoubleShotLegacyNumber?: [{	by: ValueTypes["CustomerOrdersByDoubleShotLegacyNumberUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
ordersByDiscounts?: [{	by: ValueTypes["CustomerOrdersByDiscountsUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
ordersByDelivery?: [{	by: ValueTypes["CustomerOrdersByDeliveryUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
ordersByItems?: [{	by: ValueTypes["CustomerOrdersByItemsUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
ordersByCart?: [{	by: ValueTypes["CustomerOrdersByCartUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
ordersByEvents?: [{	by: ValueTypes["CustomerOrdersByEventsUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
ordersByPriceLines?: [{	by: ValueTypes["CustomerOrdersByPriceLinesUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
ordersByPayments?: [{	by: ValueTypes["CustomerOrdersByPaymentsUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
ordersBySummary?: [{	by: ValueTypes["CustomerOrdersBySummaryUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
ordersByGratuity?: [{	by: ValueTypes["CustomerOrdersByGratuityUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
ingredientRatingsByIngredient?: [{	by: ValueTypes["CustomerIngredientRatingsByIngredientUniqueWhere"],	filter?: ValueTypes["CustomerIngredientRatingWhere"] | undefined | null},ValueTypes["CustomerIngredientRating"]],
cartsByItems?: [{	by: ValueTypes["CustomerCartsByItemsUniqueWhere"],	filter?: ValueTypes["CartWhere"] | undefined | null},ValueTypes["Cart"]],
cartsByOrder?: [{	by: ValueTypes["CustomerCartsByOrderUniqueWhere"],	filter?: ValueTypes["CartWhere"] | undefined | null},ValueTypes["Cart"]],
cartsByPriceLines?: [{	by: ValueTypes["CustomerCartsByPriceLinesUniqueWhere"],	filter?: ValueTypes["CartWhere"] | undefined | null},ValueTypes["Cart"]],
cartsBySummary?: [{	by: ValueTypes["CustomerCartsBySummaryUniqueWhere"],	filter?: ValueTypes["CartWhere"] | undefined | null},ValueTypes["Cart"]],
invoicesByPublicKey?: [{	by: ValueTypes["CustomerInvoicesByPublicKeyUniqueWhere"],	filter?: ValueTypes["InvoiceWhere"] | undefined | null},ValueTypes["Invoice"]],
invoicesByFakturoidId?: [{	by: ValueTypes["CustomerInvoicesByFakturoidIdUniqueWhere"],	filter?: ValueTypes["InvoiceWhere"] | undefined | null},ValueTypes["Invoice"]],
invoicesByOrderPayments?: [{	by: ValueTypes["CustomerInvoicesByOrderPaymentsUniqueWhere"],	filter?: ValueTypes["InvoiceWhere"] | undefined | null},ValueTypes["Invoice"]],
billingSubjectsByInvoices?: [{	by: ValueTypes["CustomerBillingSubjectsByInvoicesUniqueWhere"],	filter?: ValueTypes["BillingSubjectWhere"] | undefined | null},ValueTypes["BillingSubject"]],
billingSubjectsByDefaultBillingSubjectOfCustomer?: [{	by: ValueTypes["CustomerBillingSubjectsByDefaultBillingSubjectOfCustomerUniqueWhere"],	filter?: ValueTypes["BillingSubjectWhere"] | undefined | null},ValueTypes["BillingSubject"]],
billingSubjectsByOrders?: [{	by: ValueTypes["CustomerBillingSubjectsByOrdersUniqueWhere"],	filter?: ValueTypes["BillingSubjectWhere"] | undefined | null},ValueTypes["BillingSubject"]],
offeredProductsByProduct?: [{	by: ValueTypes["CustomerOfferedProductsByProductUniqueWhere"],	filter?: ValueTypes["ProductCustomerPriceWhere"] | undefined | null},ValueTypes["ProductCustomerPrice"]],
boughtVouchersByCode?: [{	by: ValueTypes["CustomerBoughtVouchersByCodeUniqueWhere"],	filter?: ValueTypes["VoucherWhere"] | undefined | null},ValueTypes["Voucher"]],
boughtVouchersByRedemption?: [{	by: ValueTypes["CustomerBoughtVouchersByRedemptionUniqueWhere"],	filter?: ValueTypes["VoucherWhere"] | undefined | null},ValueTypes["Voucher"]],
ownsVouchersByCode?: [{	by: ValueTypes["CustomerOwnsVouchersByCodeUniqueWhere"],	filter?: ValueTypes["VoucherWhere"] | undefined | null},ValueTypes["Voucher"]],
ownsVouchersByRedemption?: [{	by: ValueTypes["CustomerOwnsVouchersByRedemptionUniqueWhere"],	filter?: ValueTypes["VoucherWhere"] | undefined | null},ValueTypes["Voucher"]],
redeemedVouchersByCustomerCredit?: [{	by: ValueTypes["CustomerRedeemedVouchersByCustomerCreditUniqueWhere"],	filter?: ValueTypes["VoucherRedemptionWhere"] | undefined | null},ValueTypes["VoucherRedemption"]],
redeemedVouchersByOrderDiscount?: [{	by: ValueTypes["CustomerRedeemedVouchersByOrderDiscountUniqueWhere"],	filter?: ValueTypes["VoucherRedemptionWhere"] | undefined | null},ValueTypes["VoucherRedemption"]],
redeemedVouchersByVoucher?: [{	by: ValueTypes["CustomerRedeemedVouchersByVoucherUniqueWhere"],	filter?: ValueTypes["VoucherRedemptionWhere"] | undefined | null},ValueTypes["VoucherRedemption"]],
customerTabsByItems?: [{	by: ValueTypes["CustomerCustomerTabsByItemsUniqueWhere"],	filter?: ValueTypes["CustomerTabWhere"] | undefined | null},ValueTypes["CustomerTab"]],
customerTabsByMeta?: [{	by: ValueTypes["CustomerCustomerTabsByMetaUniqueWhere"],	filter?: ValueTypes["CustomerTabWhere"] | undefined | null},ValueTypes["CustomerTab"]],
leadByStageItem?: [{	by: ValueTypes["CustomerLeadByStageItemUniqueWhere"],	filter?: ValueTypes["PipelineLeadWhere"] | undefined | null},ValueTypes["PipelineLead"]],
paginateAddresses?: [{	filter?: ValueTypes["AddressWhere"] | undefined | null,	orderBy?: Array<ValueTypes["AddressOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["AddressConnection"]],
paginateTags?: [{	filter?: ValueTypes["TagWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TagOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TagConnection"]],
paginateCredits?: [{	filter?: ValueTypes["CustomerCreditWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerCreditOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerCreditConnection"]],
paginatePaymentMethods?: [{	filter?: ValueTypes["CustomerPaymentMethodWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerPaymentMethodOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerPaymentMethodConnection"]],
paginateOrders?: [{	filter?: ValueTypes["OrderWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderConnection"]],
paginateIngredientRatings?: [{	filter?: ValueTypes["CustomerIngredientRatingWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerIngredientRatingOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerIngredientRatingConnection"]],
paginateOwnerOfBusinesses?: [{	filter?: ValueTypes["BusinessCustomerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessCustomerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BusinessCustomerConnection"]],
paginateMemberOfBusinesses?: [{	filter?: ValueTypes["BusinessCustomerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessCustomerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BusinessCustomerConnection"]],
paginateCarts?: [{	filter?: ValueTypes["CartWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CartOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CartConnection"]],
paginateChannels?: [{	filter?: ValueTypes["ChannelWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ChannelOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ChannelConnection"]],
paginateInvoices?: [{	filter?: ValueTypes["InvoiceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InvoiceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["InvoiceConnection"]],
paginateBillingSubjects?: [{	filter?: ValueTypes["BillingSubjectWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BillingSubjectOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BillingSubjectConnection"]],
paginateOfferedProducts?: [{	filter?: ValueTypes["ProductCustomerPriceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCustomerPriceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductCustomerPriceConnection"]],
paginateBoughtVouchers?: [{	filter?: ValueTypes["VoucherWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VoucherOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["VoucherConnection"]],
paginateOwnsVouchers?: [{	filter?: ValueTypes["VoucherWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VoucherOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["VoucherConnection"]],
paginateRedeemedVouchers?: [{	filter?: ValueTypes["VoucherRedemptionWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VoucherRedemptionOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["VoucherRedemptionConnection"]],
paginateCustomerTabs?: [{	filter?: ValueTypes["CustomerTabWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerTabOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerTabConnection"]],
paginateLead?: [{	filter?: ValueTypes["PipelineLeadWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PipelineLeadOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PipelineLeadConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["CustomerMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	addresses?:ValueTypes["FieldMeta"],
	defaultBillingAddress?:ValueTypes["FieldMeta"],
	defaultPaymentMethod?:ValueTypes["FieldMeta"],
	tags?:ValueTypes["FieldMeta"],
	credits?:ValueTypes["FieldMeta"],
	paymentMethods?:ValueTypes["FieldMeta"],
	orders?:ValueTypes["FieldMeta"],
	permissions?:ValueTypes["FieldMeta"],
	group?:ValueTypes["FieldMeta"],
	photo?:ValueTypes["FieldMeta"],
	phone?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	internalNote?:ValueTypes["FieldMeta"],
	welcomeMessage?:ValueTypes["FieldMeta"],
	familiarity?:ValueTypes["FieldMeta"],
	ingredientRatings?:ValueTypes["FieldMeta"],
	business?:ValueTypes["FieldMeta"],
	ownerOfBusinesses?:ValueTypes["FieldMeta"],
	memberOfBusinesses?:ValueTypes["FieldMeta"],
	carts?:ValueTypes["FieldMeta"],
	shortcutList?:ValueTypes["FieldMeta"],
	user?:ValueTypes["FieldMeta"],
	channels?:ValueTypes["FieldMeta"],
	disabledAt?:ValueTypes["FieldMeta"],
	invoices?:ValueTypes["FieldMeta"],
	invoicingPlan?:ValueTypes["FieldMeta"],
	email?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	billingSubjects?:ValueTypes["FieldMeta"],
	offeredProducts?:ValueTypes["FieldMeta"],
	defaultDeliveryAddress?:ValueTypes["FieldMeta"],
	defaultBillingSubject?:ValueTypes["FieldMeta"],
	prefersPackingsWithoutCardboard?:ValueTypes["FieldMeta"],
	anonymousSession?:ValueTypes["FieldMeta"],
	boughtVouchers?:ValueTypes["FieldMeta"],
	ownsVouchers?:ValueTypes["FieldMeta"],
	redeemedVouchers?:ValueTypes["FieldMeta"],
	spending?:ValueTypes["FieldMeta"],
	customerTabs?:ValueTypes["FieldMeta"],
	lead?:ValueTypes["FieldMeta"],
	doubleshotLegacyId?:ValueTypes["FieldMeta"],
	meta?:ValueTypes["FieldMeta"],
	doubleshotLastUpdatedAt?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["AddressWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	firstName?: ValueTypes["StringCondition"] | undefined | null,
	lastName?: ValueTypes["StringCondition"] | undefined | null,
	addressLine2?: ValueTypes["StringCondition"] | undefined | null,
	email?: ValueTypes["StringCondition"] | undefined | null,
	phone?: ValueTypes["StringCondition"] | undefined | null,
	companyName?: ValueTypes["StringCondition"] | undefined | null,
	companyIdentifier?: ValueTypes["StringCondition"] | undefined | null,
	vatIdentifier?: ValueTypes["StringCondition"] | undefined | null,
	externalIdentifier?: ValueTypes["StringCondition"] | undefined | null,
	hidden?: ValueTypes["BooleanCondition"] | undefined | null,
	customer?: ValueTypes["CustomerWhere"] | undefined | null,
	internalNote?: ValueTypes["StringCondition"] | undefined | null,
	country?: ValueTypes["CountryWhere"] | undefined | null,
	deletedAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	note?: ValueTypes["StringCondition"] | undefined | null,
	googlePlaceId?: ValueTypes["StringCondition"] | undefined | null,
	raw?: ValueTypes["StringCondition"] | undefined | null,
	formatted?: ValueTypes["StringCondition"] | undefined | null,
	geocodeGeneratedAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	geocodeResponse?: ValueTypes["StringCondition"] | undefined | null,
	deliveryZone?: ValueTypes["DeliveryZoneWhere"] | undefined | null,
	meta?: ValueTypes["AddressMetadataWhere"] | undefined | null,
	gps?: ValueTypes["GpsWhere"] | undefined | null,
	geocodeValid?: ValueTypes["BooleanCondition"] | undefined | null,
	fullName?: ValueTypes["StringCondition"] | undefined | null,
	fakturoidSubjectId?: ValueTypes["StringCondition"] | undefined | null,
	invoices?: ValueTypes["InvoiceWhere"] | undefined | null,
	addressLine1?: ValueTypes["StringCondition"] | undefined | null,
	city?: ValueTypes["StringCondition"] | undefined | null,
	postalCode?: ValueTypes["StringCondition"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	billingAddressOfOrders?: ValueTypes["OrderWhere"] | undefined | null,
	deliveryAddressOfOrderDeliveries?: ValueTypes["OrderDeliveryWhere"] | undefined | null,
	defaultDeliveryAddressOfCustomer?: ValueTypes["CustomerWhere"] | undefined | null,
	and?: Array<ValueTypes["AddressWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["AddressWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["AddressWhere"] | undefined | null
};
	["UUIDCondition"]: {
	and?: Array<ValueTypes["UUIDCondition"]> | undefined | null,
	or?: Array<ValueTypes["UUIDCondition"]> | undefined | null,
	not?: ValueTypes["UUIDCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["UUID"] | undefined | null,
	notEq?: ValueTypes["UUID"] | undefined | null,
	in?: Array<ValueTypes["UUID"]> | undefined | null,
	notIn?: Array<ValueTypes["UUID"]> | undefined | null,
	lt?: ValueTypes["UUID"] | undefined | null,
	lte?: ValueTypes["UUID"] | undefined | null,
	gt?: ValueTypes["UUID"] | undefined | null,
	gte?: ValueTypes["UUID"] | undefined | null
};
	["StringCondition"]: {
	and?: Array<ValueTypes["StringCondition"]> | undefined | null,
	or?: Array<ValueTypes["StringCondition"]> | undefined | null,
	not?: ValueTypes["StringCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: string | undefined | null,
	notEq?: string | undefined | null,
	in?: Array<string> | undefined | null,
	notIn?: Array<string> | undefined | null,
	lt?: string | undefined | null,
	lte?: string | undefined | null,
	gt?: string | undefined | null,
	gte?: string | undefined | null,
	contains?: string | undefined | null,
	startsWith?: string | undefined | null,
	endsWith?: string | undefined | null,
	containsCI?: string | undefined | null,
	startsWithCI?: string | undefined | null,
	endsWithCI?: string | undefined | null
};
	["BooleanCondition"]: {
	and?: Array<ValueTypes["BooleanCondition"]> | undefined | null,
	or?: Array<ValueTypes["BooleanCondition"]> | undefined | null,
	not?: ValueTypes["BooleanCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: boolean | undefined | null,
	notEq?: boolean | undefined | null,
	in?: Array<boolean> | undefined | null,
	notIn?: Array<boolean> | undefined | null,
	lt?: boolean | undefined | null,
	lte?: boolean | undefined | null,
	gt?: boolean | undefined | null,
	gte?: boolean | undefined | null
};
	["CustomerWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	addresses?: ValueTypes["AddressWhere"] | undefined | null,
	defaultBillingAddress?: ValueTypes["AddressWhere"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerPaymentMethodWhere"] | undefined | null,
	tags?: ValueTypes["TagWhere"] | undefined | null,
	credits?: ValueTypes["CustomerCreditWhere"] | undefined | null,
	paymentMethods?: ValueTypes["CustomerPaymentMethodWhere"] | undefined | null,
	orders?: ValueTypes["OrderWhere"] | undefined | null,
	permissions?: ValueTypes["CustomerPermissionsWhere"] | undefined | null,
	group?: ValueTypes["CustomerGroupWhere"] | undefined | null,
	photo?: ValueTypes["ImageWhere"] | undefined | null,
	phone?: ValueTypes["StringCondition"] | undefined | null,
	name?: ValueTypes["CustomerNameWhere"] | undefined | null,
	internalNote?: ValueTypes["StringCondition"] | undefined | null,
	welcomeMessage?: ValueTypes["StringCondition"] | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarityCondition"] | undefined | null,
	ingredientRatings?: ValueTypes["CustomerIngredientRatingWhere"] | undefined | null,
	business?: ValueTypes["BusinessCustomerWhere"] | undefined | null,
	ownerOfBusinesses?: ValueTypes["BusinessCustomerWhere"] | undefined | null,
	memberOfBusinesses?: ValueTypes["BusinessCustomerWhere"] | undefined | null,
	carts?: ValueTypes["CartWhere"] | undefined | null,
	shortcutList?: ValueTypes["ApplicationShortcutListWhere"] | undefined | null,
	user?: ValueTypes["UserWhere"] | undefined | null,
	channels?: ValueTypes["ChannelWhere"] | undefined | null,
	disabledAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	invoices?: ValueTypes["InvoiceWhere"] | undefined | null,
	invoicingPlan?: ValueTypes["InvoicingPlanWhere"] | undefined | null,
	email?: ValueTypes["StringCondition"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	billingSubjects?: ValueTypes["BillingSubjectWhere"] | undefined | null,
	offeredProducts?: ValueTypes["ProductCustomerPriceWhere"] | undefined | null,
	defaultDeliveryAddress?: ValueTypes["AddressWhere"] | undefined | null,
	defaultBillingSubject?: ValueTypes["BillingSubjectWhere"] | undefined | null,
	prefersPackingsWithoutCardboard?: ValueTypes["BooleanCondition"] | undefined | null,
	anonymousSession?: ValueTypes["AnonymousSessionWhere"] | undefined | null,
	boughtVouchers?: ValueTypes["VoucherWhere"] | undefined | null,
	ownsVouchers?: ValueTypes["VoucherWhere"] | undefined | null,
	redeemedVouchers?: ValueTypes["VoucherRedemptionWhere"] | undefined | null,
	spending?: ValueTypes["CustomerSpendingWhere"] | undefined | null,
	customerTabs?: ValueTypes["CustomerTabWhere"] | undefined | null,
	lead?: ValueTypes["PipelineLeadWhere"] | undefined | null,
	doubleshotLegacyId?: ValueTypes["StringCondition"] | undefined | null,
	meta?: ValueTypes["CustomerMetadataWhere"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	and?: Array<ValueTypes["CustomerWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["CustomerWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["CustomerWhere"] | undefined | null
};
	["CustomerPaymentMethodWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	caption?: ValueTypes["StringCondition"] | undefined | null,
	data?: ValueTypes["JsonCondition"] | undefined | null,
	customer?: ValueTypes["CustomerWhere"] | undefined | null,
	paymentMethod?: ValueTypes["PaymentMethodWhere"] | undefined | null,
	and?: Array<ValueTypes["CustomerPaymentMethodWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["CustomerPaymentMethodWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["CustomerPaymentMethodWhere"] | undefined | null
};
	["JsonCondition"]: {
	and?: Array<ValueTypes["JsonCondition"]> | undefined | null,
	or?: Array<ValueTypes["JsonCondition"]> | undefined | null,
	not?: ValueTypes["JsonCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null
};
	["PaymentMethodWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	code?: ValueTypes["StringCondition"] | undefined | null,
	enabled?: ValueTypes["BooleanCondition"] | undefined | null,
	deliveryMethods?: ValueTypes["DeliveryMethodWhere"] | undefined | null,
	description?: ValueTypes["StringCondition"] | undefined | null,
	internalNote?: ValueTypes["StringCondition"] | undefined | null,
	blockingDispatch?: ValueTypes["BooleanCondition"] | undefined | null,
	type?: ValueTypes["PaymentMethodTypeCondition"] | undefined | null,
	channels?: ValueTypes["ChannelPaymentWhere"] | undefined | null,
	reduceGratuityByPercentage?: ValueTypes["IntCondition"] | undefined | null,
	and?: Array<ValueTypes["PaymentMethodWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["PaymentMethodWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["PaymentMethodWhere"] | undefined | null
};
	["DeliveryMethodWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	code?: ValueTypes["StringCondition"] | undefined | null,
	enabled?: ValueTypes["BooleanCondition"] | undefined | null,
	paymentMethods?: ValueTypes["PaymentMethodWhere"] | undefined | null,
	description?: ValueTypes["StringCondition"] | undefined | null,
	internalNote?: ValueTypes["StringCondition"] | undefined | null,
	requireDeliveryAddress?: ValueTypes["BooleanCondition"] | undefined | null,
	suitableForDeliveryZones?: ValueTypes["DeliveryZoneWhere"] | undefined | null,
	channels?: ValueTypes["ChannelDeliveryWhere"] | undefined | null,
	courierHandlers?: ValueTypes["CourierWhere"] | undefined | null,
	enableDeliveryTracking?: ValueTypes["BooleanCondition"] | undefined | null,
	locales?: ValueTypes["DeliveryMethodLocaleWhere"] | undefined | null,
	timelinePreset?: ValueTypes["DeliveryTimelinePresetWhere"] | undefined | null,
	woltDriveVenueId?: ValueTypes["StringCondition"] | undefined | null,
	and?: Array<ValueTypes["DeliveryMethodWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["DeliveryMethodWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["DeliveryMethodWhere"] | undefined | null
};
	["DeliveryZoneWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	code?: ValueTypes["StringCondition"] | undefined | null,
	description?: ValueTypes["StringCondition"] | undefined | null,
	internalNote?: ValueTypes["StringCondition"] | undefined | null,
	type?: ValueTypes["DeliveryZoneTypeCondition"] | undefined | null,
	addresses?: ValueTypes["AddressWhere"] | undefined | null,
	suitableDeliveryMethods?: ValueTypes["DeliveryMethodWhere"] | undefined | null,
	deliveryZonesOfTags?: ValueTypes["TagWhere"] | undefined | null,
	deliveryZonesOfProducts?: ValueTypes["ProductWhere"] | undefined | null,
	addressesMetadata?: ValueTypes["AddressMetadataWhere"] | undefined | null,
	and?: Array<ValueTypes["DeliveryZoneWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["DeliveryZoneWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["DeliveryZoneWhere"] | undefined | null
};
	["DeliveryZoneTypeCondition"]: {
	and?: Array<ValueTypes["DeliveryZoneTypeCondition"]> | undefined | null,
	or?: Array<ValueTypes["DeliveryZoneTypeCondition"]> | undefined | null,
	not?: ValueTypes["DeliveryZoneTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["DeliveryZoneType"] | undefined | null,
	notEq?: ValueTypes["DeliveryZoneType"] | undefined | null,
	in?: Array<ValueTypes["DeliveryZoneType"]> | undefined | null,
	notIn?: Array<ValueTypes["DeliveryZoneType"]> | undefined | null,
	lt?: ValueTypes["DeliveryZoneType"] | undefined | null,
	lte?: ValueTypes["DeliveryZoneType"] | undefined | null,
	gt?: ValueTypes["DeliveryZoneType"] | undefined | null,
	gte?: ValueTypes["DeliveryZoneType"] | undefined | null
};
	["DeliveryZoneType"]:DeliveryZoneType;
	["TagWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	code?: ValueTypes["StringCondition"] | undefined | null,
	customers?: ValueTypes["CustomerWhere"] | undefined | null,
	products?: ValueTypes["ProductWhere"] | undefined | null,
	categories?: ValueTypes["ProductCategoryWhere"] | undefined | null,
	description?: ValueTypes["StringCondition"] | undefined | null,
	internalNote?: ValueTypes["StringCondition"] | undefined | null,
	addTagsOnRegistration?: ValueTypes["ChannelWhere"] | undefined | null,
	nestedCategories?: ValueTypes["InheritedProductCategoryTagWhere"] | undefined | null,
	deliveryZones?: ValueTypes["DeliveryZoneWhere"] | undefined | null,
	publicInChannels?: ValueTypes["ChannelWhere"] | undefined | null,
	allowChannelPayments?: ValueTypes["ChannelPaymentWhere"] | undefined | null,
	fulfillmentNotes?: ValueTypes["FulfillmentNoteWhere"] | undefined | null,
	and?: Array<ValueTypes["TagWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["TagWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["TagWhere"] | undefined | null
};
	["ProductWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	code?: ValueTypes["StringCondition"] | undefined | null,
	priceCents?: ValueTypes["IntCondition"] | undefined | null,
	notDiscountable?: ValueTypes["BooleanCondition"] | undefined | null,
	packing?: ValueTypes["ProductPackingWhere"] | undefined | null,
	recipe?: ValueTypes["ProductRecipeWhere"] | undefined | null,
	tags?: ValueTypes["TagWhere"] | undefined | null,
	categories?: ValueTypes["ProductCategoryWhere"] | undefined | null,
	vatRate?: ValueTypes["VatRateWhere"] | undefined | null,
	stocks?: ValueTypes["ProductStockWhere"] | undefined | null,
	groupPrices?: ValueTypes["ProductGroupPriceWhere"] | undefined | null,
	image?: ValueTypes["ImageWhere"] | undefined | null,
	description?: ValueTypes["StringCondition"] | undefined | null,
	internalNote?: ValueTypes["StringCondition"] | undefined | null,
	cartItems?: ValueTypes["CartItemWhere"] | undefined | null,
	availability?: ValueTypes["ProductAvailabilityCondition"] | undefined | null,
	order?: ValueTypes["FloatCondition"] | undefined | null,
	manager?: ValueTypes["StocksManagerWhere"] | undefined | null,
	orderItems?: ValueTypes["OrderItemWhere"] | undefined | null,
	maximumQuantityPerOrder?: ValueTypes["IntCondition"] | undefined | null,
	inheritedCategories?: ValueTypes["NestedProductCategoryProductWhere"] | undefined | null,
	deliveryZones?: ValueTypes["DeliveryZoneWhere"] | undefined | null,
	locales?: ValueTypes["ProductLocaleWhere"] | undefined | null,
	archivedAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	customerPrices?: ValueTypes["ProductCustomerPriceWhere"] | undefined | null,
	virtualProduct?: ValueTypes["VirtualProductWhere"] | undefined | null,
	meta?: ValueTypes["ProductMetadataWhere"] | undefined | null,
	page?: ValueTypes["PageWhere"] | undefined | null,
	salesDays?: ValueTypes["ProductSalesDayWhere"] | undefined | null,
	salesWeeks?: ValueTypes["ProductSalesWeekWhere"] | undefined | null,
	salesMonths?: ValueTypes["ProductSalesMonthWhere"] | undefined | null,
	fulfillmentNotes?: ValueTypes["FulfillmentNoteWhere"] | undefined | null,
	hasSubscription?: ValueTypes["BooleanCondition"] | undefined | null,
	pointOfSaleTileColor?: ValueTypes["StringCondition"] | undefined | null,
	and?: Array<ValueTypes["ProductWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ProductWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ProductWhere"] | undefined | null
};
	["IntCondition"]: {
	and?: Array<ValueTypes["IntCondition"]> | undefined | null,
	or?: Array<ValueTypes["IntCondition"]> | undefined | null,
	not?: ValueTypes["IntCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: number | undefined | null,
	notEq?: number | undefined | null,
	in?: Array<number> | undefined | null,
	notIn?: Array<number> | undefined | null,
	lt?: number | undefined | null,
	lte?: number | undefined | null,
	gt?: number | undefined | null,
	gte?: number | undefined | null
};
	["ProductPackingWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	image?: ValueTypes["ImageWhere"] | undefined | null,
	description?: ValueTypes["StringCondition"] | undefined | null,
	internalNote?: ValueTypes["StringCondition"] | undefined | null,
	volumeMl?: ValueTypes["IntCondition"] | undefined | null,
	icon?: ValueTypes["ImageWhere"] | undefined | null,
	shortName?: ValueTypes["StringCondition"] | undefined | null,
	locales?: ValueTypes["ProductPackingLocaleWhere"] | undefined | null,
	preparedPackingQuantities?: ValueTypes["PreparedPackingQuantityWhere"] | undefined | null,
	isPackedInCardboard?: ValueTypes["BooleanCondition"] | undefined | null,
	and?: Array<ValueTypes["ProductPackingWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ProductPackingWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ProductPackingWhere"] | undefined | null
};
	["ImageWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	url?: ValueTypes["StringCondition"] | undefined | null,
	width?: ValueTypes["IntCondition"] | undefined | null,
	height?: ValueTypes["IntCondition"] | undefined | null,
	size?: ValueTypes["IntCondition"] | undefined | null,
	type?: ValueTypes["StringCondition"] | undefined | null,
	alt?: ValueTypes["StringCondition"] | undefined | null,
	and?: Array<ValueTypes["ImageWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ImageWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ImageWhere"] | undefined | null
};
	["ProductPackingLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	shortName?: ValueTypes["StringCondition"] | undefined | null,
	description?: ValueTypes["StringCondition"] | undefined | null,
	root?: ValueTypes["ProductPackingWhere"] | undefined | null,
	locale?: ValueTypes["LocaleWhere"] | undefined | null,
	and?: Array<ValueTypes["ProductPackingLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ProductPackingLocaleWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ProductPackingLocaleWhere"] | undefined | null
};
	["LocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	businessCategories?: ValueTypes["BusinessCategoryLocaleWhere"] | undefined | null,
	productCategoryLists?: ValueTypes["ProductCategoryListLocaleWhere"] | undefined | null,
	productIngredients?: ValueTypes["ProductIngredientLocaleWhere"] | undefined | null,
	orderRecurrences?: ValueTypes["OrderRecurrenceLocaleWhere"] | undefined | null,
	blogs?: ValueTypes["BlogLocaleWhere"] | undefined | null,
	blogPosts?: ValueTypes["BlogPostLocaleWhere"] | undefined | null,
	identifier?: ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null,
	menus?: ValueTypes["MenuLocaleWhere"] | undefined | null,
	pages?: ValueTypes["PageLocaleWhere"] | undefined | null,
	productIngredientCategories?: ValueTypes["ProductIngredientCategoryLocaleWhere"] | undefined | null,
	allergens?: ValueTypes["AllergenLocaleWhere"] | undefined | null,
	productPackings?: ValueTypes["ProductPackingLocaleWhere"] | undefined | null,
	products?: ValueTypes["ProductLocaleWhere"] | undefined | null,
	productRecipes?: ValueTypes["ProductRecipeLocaleWhere"] | undefined | null,
	pointOfSaleCategories?: ValueTypes["PointOfSaleCategoryLocaleWhere"] | undefined | null,
	pointOfSaleCategoryProducts?: ValueTypes["PointOfSaleCategoryProductLocaleWhere"] | undefined | null,
	deliveryMethods?: ValueTypes["DeliveryMethodLocaleWhere"] | undefined | null,
	ingredientSuppliers?: ValueTypes["IngredientSupplierLocaleWhere"] | undefined | null,
	identificationCodes?: ValueTypes["IdentificationCodeLocaleWhere"] | undefined | null,
	pipelineStages?: ValueTypes["PipelineStageLocaleWhere"] | undefined | null,
	subscriptionBoxes?: ValueTypes["SubscriptionBoxLocaleWhere"] | undefined | null,
	businessServices?: ValueTypes["BusinessServiceLocaleWhere"] | undefined | null,
	and?: Array<ValueTypes["LocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["LocaleWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["LocaleWhere"] | undefined | null
};
	["BusinessCategoryLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	root?: ValueTypes["BusinessCategoryWhere"] | undefined | null,
	locale?: ValueTypes["LocaleWhere"] | undefined | null,
	title?: ValueTypes["StringCondition"] | undefined | null,
	and?: Array<ValueTypes["BusinessCategoryLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["BusinessCategoryLocaleWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["BusinessCategoryLocaleWhere"] | undefined | null
};
	["BusinessCategoryWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	visibleToNewCustomers?: ValueTypes["BooleanCondition"] | undefined | null,
	locales?: ValueTypes["BusinessCategoryLocaleWhere"] | undefined | null,
	internalName?: ValueTypes["StringCondition"] | undefined | null,
	businessCustomers?: ValueTypes["BusinessCustomerWhere"] | undefined | null,
	recurrences?: ValueTypes["OrderRecurrenceWhere"] | undefined | null,
	specificProducts?: ValueTypes["ProductListWhere"] | undefined | null,
	seasonalProductCategories?: ValueTypes["ProductCategoryListWhere"] | undefined | null,
	specificProductsProductCategories?: ValueTypes["ProductCategoryListWhere"] | undefined | null,
	slug?: ValueTypes["StringCondition"] | undefined | null,
	and?: Array<ValueTypes["BusinessCategoryWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["BusinessCategoryWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["BusinessCategoryWhere"] | undefined | null
};
	["BusinessCustomerWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	customer?: ValueTypes["CustomerWhere"] | undefined | null,
	owners?: ValueTypes["CustomerWhere"] | undefined | null,
	members?: ValueTypes["CustomerWhere"] | undefined | null,
	category?: ValueTypes["BusinessCategoryWhere"] | undefined | null,
	accountManager?: ValueTypes["BusinessToBusinessManagerWhere"] | undefined | null,
	logo?: ValueTypes["ImageWhere"] | undefined | null,
	note?: ValueTypes["StringCondition"] | undefined | null,
	businessServiceEvents?: ValueTypes["BusinessServiceEventWhere"] | undefined | null,
	doubleshotCoffeeEquipment?: ValueTypes["DoubleshotCoffeeEquipmentWhere"] | undefined | null,
	and?: Array<ValueTypes["BusinessCustomerWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["BusinessCustomerWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["BusinessCustomerWhere"] | undefined | null
};
	["BusinessToBusinessManagerWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	staff?: ValueTypes["StaffWhere"] | undefined | null,
	managedBusinesses?: ValueTypes["BusinessCustomerWhere"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	and?: Array<ValueTypes["BusinessToBusinessManagerWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["BusinessToBusinessManagerWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["BusinessToBusinessManagerWhere"] | undefined | null
};
	["StaffWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	bartender?: ValueTypes["BartenderWhere"] | undefined | null,
	courier?: ValueTypes["CourierWhere"] | undefined | null,
	cleaner?: ValueTypes["CleanerWhere"] | undefined | null,
	shiftsManager?: ValueTypes["ShiftsManagerWhere"] | undefined | null,
	businessToBusinessManager?: ValueTypes["BusinessToBusinessManagerWhere"] | undefined | null,
	user?: ValueTypes["UserWhere"] | undefined | null,
	shiftsProfile?: ValueTypes["ShiftsProfileWhere"] | undefined | null,
	stocksManager?: ValueTypes["StocksManagerWhere"] | undefined | null,
	photo?: ValueTypes["ImageWhere"] | undefined | null,
	courierManager?: ValueTypes["CourierManagerWhere"] | undefined | null,
	picker?: ValueTypes["PickerWhere"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	remunerationProfile?: ValueTypes["RemunerationProfileWhere"] | undefined | null,
	cashier?: ValueTypes["CashierWhere"] | undefined | null,
	venues?: ValueTypes["VenueWhere"] | undefined | null,
	internalBuyer?: ValueTypes["InternalBuyerWhere"] | undefined | null,
	salesManager?: ValueTypes["SalesManagerWhere"] | undefined | null,
	cashierManager?: ValueTypes["CashierManagerWhere"] | undefined | null,
	and?: Array<ValueTypes["StaffWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["StaffWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["StaffWhere"] | undefined | null
};
	["BartenderWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	staff?: ValueTypes["StaffWhere"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	and?: Array<ValueTypes["BartenderWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["BartenderWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["BartenderWhere"] | undefined | null
};
	["DateTimeCondition"]: {
	and?: Array<ValueTypes["DateTimeCondition"]> | undefined | null,
	or?: Array<ValueTypes["DateTimeCondition"]> | undefined | null,
	not?: ValueTypes["DateTimeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["DateTime"] | undefined | null,
	notEq?: ValueTypes["DateTime"] | undefined | null,
	in?: Array<ValueTypes["DateTime"]> | undefined | null,
	notIn?: Array<ValueTypes["DateTime"]> | undefined | null,
	lt?: ValueTypes["DateTime"] | undefined | null,
	lte?: ValueTypes["DateTime"] | undefined | null,
	gt?: ValueTypes["DateTime"] | undefined | null,
	gte?: ValueTypes["DateTime"] | undefined | null
};
	["DateTime"]:string;
	["CourierWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	staff?: ValueTypes["StaffWhere"] | undefined | null,
	routes?: ValueTypes["DeliveryRouteWhere"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	deliveryMethods?: ValueTypes["DeliveryMethodWhere"] | undefined | null,
	showInPicker?: ValueTypes["BooleanCondition"] | undefined | null,
	and?: Array<ValueTypes["CourierWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["CourierWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["CourierWhere"] | undefined | null
};
	["DeliveryRouteWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	courier?: ValueTypes["CourierWhere"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	waypoints?: ValueTypes["DeliveryWaypointWhere"] | undefined | null,
	dispatchAt?: ValueTypes["StringCondition"] | undefined | null,
	and?: Array<ValueTypes["DeliveryRouteWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["DeliveryRouteWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["DeliveryRouteWhere"] | undefined | null
};
	["DeliveryWaypointWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	estimatedArrival?: ValueTypes["DateTimeCondition"] | undefined | null,
	note?: ValueTypes["StringCondition"] | undefined | null,
	route?: ValueTypes["DeliveryRouteWhere"] | undefined | null,
	sortingOrder?: ValueTypes["IntCondition"] | undefined | null,
	delivery?: ValueTypes["OrderDeliveryWhere"] | undefined | null,
	estimatedDistance?: ValueTypes["IntCondition"] | undefined | null,
	estimatedDuration?: ValueTypes["IntCondition"] | undefined | null,
	originDeparture?: ValueTypes["DateTimeCondition"] | undefined | null,
	originAddress?: ValueTypes["StringCondition"] | undefined | null,
	transitMode?: ValueTypes["StringCondition"] | undefined | null,
	and?: Array<ValueTypes["DeliveryWaypointWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["DeliveryWaypointWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["DeliveryWaypointWhere"] | undefined | null
};
	["OrderDeliveryWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	priceCents?: ValueTypes["IntCondition"] | undefined | null,
	deliveredAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	method?: ValueTypes["DeliveryMethodWhere"] | undefined | null,
	vatRate?: ValueTypes["VatRateWhere"] | undefined | null,
	order?: ValueTypes["OrderWhere"] | undefined | null,
	expectedAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	state?: ValueTypes["OrderDeliveryStateCondition"] | undefined | null,
	loadingDurationHours?: ValueTypes["IntCondition"] | undefined | null,
	dispatchAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	duration?: ValueTypes["StringCondition"] | undefined | null,
	window?: ValueTypes["StringCondition"] | undefined | null,
	expectedEndAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	processingAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	deliveringAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	failedAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	internalNote?: ValueTypes["StringCondition"] | undefined | null,
	deliveryWaypoint?: ValueTypes["DeliveryWaypointWhere"] | undefined | null,
	events?: ValueTypes["OrderEventWhere"] | undefined | null,
	prepareAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	liftagoRide?: ValueTypes["LiftagoRideWhere"] | undefined | null,
	pickedAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	address?: ValueTypes["AddressWhere"] | undefined | null,
	trackingCode?: ValueTypes["StringCondition"] | undefined | null,
	woltDriveDelivery?: ValueTypes["WoltDriveDeliveryWhere"] | undefined | null,
	and?: Array<ValueTypes["OrderDeliveryWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["OrderDeliveryWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["OrderDeliveryWhere"] | undefined | null
};
	["VatRateWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	ratePermille?: ValueTypes["IntCondition"] | undefined | null,
	description?: ValueTypes["StringCondition"] | undefined | null,
	internalNote?: ValueTypes["StringCondition"] | undefined | null,
	channelDeliveries?: ValueTypes["ChannelDeliveryWhere"] | undefined | null,
	channelPayments?: ValueTypes["ChannelPaymentWhere"] | undefined | null,
	preset?: ValueTypes["VatRatePresetCondition"] | undefined | null,
	and?: Array<ValueTypes["VatRateWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["VatRateWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["VatRateWhere"] | undefined | null
};
	["ChannelDeliveryWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	priceCents?: ValueTypes["IntCondition"] | undefined | null,
	channel?: ValueTypes["ChannelWhere"] | undefined | null,
	method?: ValueTypes["DeliveryMethodWhere"] | undefined | null,
	vatRate?: ValueTypes["VatRateWhere"] | undefined | null,
	defaultVisible?: ValueTypes["BooleanCondition"] | undefined | null,
	and?: Array<ValueTypes["ChannelDeliveryWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ChannelDeliveryWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ChannelDeliveryWhere"] | undefined | null
};
	["ChannelWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	disabled?: ValueTypes["BooleanCondition"] | undefined | null,
	payments?: ValueTypes["ChannelPaymentWhere"] | undefined | null,
	deliveries?: ValueTypes["ChannelDeliveryWhere"] | undefined | null,
	pointOfSales?: ValueTypes["PointOfSaleWhere"] | undefined | null,
	carts?: ValueTypes["CartWhere"] | undefined | null,
	customers?: ValueTypes["CustomerWhere"] | undefined | null,
	code?: ValueTypes["ChannelCodeCondition"] | undefined | null,
	addTagsOnRegistration?: ValueTypes["TagWhere"] | undefined | null,
	publicTags?: ValueTypes["TagWhere"] | undefined | null,
	venue?: ValueTypes["VenueWhere"] | undefined | null,
	and?: Array<ValueTypes["ChannelWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ChannelWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ChannelWhere"] | undefined | null
};
	["ChannelPaymentWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	channel?: ValueTypes["ChannelWhere"] | undefined | null,
	method?: ValueTypes["PaymentMethodWhere"] | undefined | null,
	vatRate?: ValueTypes["VatRateWhere"] | undefined | null,
	requireBillingAddress?: ValueTypes["BooleanCondition"] | undefined | null,
	provideReceipt?: ValueTypes["BooleanCondition"] | undefined | null,
	requireBillingSubject?: ValueTypes["BooleanCondition"] | undefined | null,
	allowOnlyForTags?: ValueTypes["TagWhere"] | undefined | null,
	and?: Array<ValueTypes["ChannelPaymentWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ChannelPaymentWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ChannelPaymentWhere"] | undefined | null
};
	["PointOfSaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	code?: ValueTypes["StringCondition"] | undefined | null,
	channels?: ValueTypes["ChannelWhere"] | undefined | null,
	permissions?: ValueTypes["PointOfSalePermissionsWhere"] | undefined | null,
	tenantPersonId?: ValueTypes["UUIDCondition"] | undefined | null,
	and?: Array<ValueTypes["PointOfSaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["PointOfSaleWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["PointOfSaleWhere"] | undefined | null
};
	["PointOfSalePermissionsWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	canPlaceOrder?: ValueTypes["BooleanCondition"] | undefined | null,
	pointOfSale?: ValueTypes["PointOfSaleWhere"] | undefined | null,
	and?: Array<ValueTypes["PointOfSalePermissionsWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["PointOfSalePermissionsWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["PointOfSalePermissionsWhere"] | undefined | null
};
	["CartWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	confirmedAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	deletedAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	note?: ValueTypes["StringCondition"] | undefined | null,
	items?: ValueTypes["CartItemWhere"] | undefined | null,
	handle?: ValueTypes["StringCondition"] | undefined | null,
	state?: ValueTypes["CartStateCondition"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	channel?: ValueTypes["ChannelWhere"] | undefined | null,
	order?: ValueTypes["OrderWhere"] | undefined | null,
	customer?: ValueTypes["CustomerWhere"] | undefined | null,
	deliveryAddress?: ValueTypes["AddressWhere"] | undefined | null,
	billingAddress?: ValueTypes["AddressWhere"] | undefined | null,
	deliveryOption?: ValueTypes["StringCondition"] | undefined | null,
	paymentOption?: ValueTypes["StringCondition"] | undefined | null,
	delivery?: ValueTypes["ChannelDeliveryWhere"] | undefined | null,
	payment?: ValueTypes["ChannelPaymentWhere"] | undefined | null,
	billingSubject?: ValueTypes["BillingSubjectWhere"] | undefined | null,
	priceLines?: ValueTypes["CartPriceLineWhere"] | undefined | null,
	summary?: ValueTypes["CartSummaryWhere"] | undefined | null,
	and?: Array<ValueTypes["CartWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["CartWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["CartWhere"] | undefined | null
};
	["CartItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	quantity?: ValueTypes["IntCondition"] | undefined | null,
	cart?: ValueTypes["CartWhere"] | undefined | null,
	product?: ValueTypes["ProductWhere"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	updatedAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	fulfillmentNote?: ValueTypes["StringCondition"] | undefined | null,
	fulfillmentNotes?: ValueTypes["FulfillmentNoteWhere"] | undefined | null,
	and?: Array<ValueTypes["CartItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["CartItemWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["CartItemWhere"] | undefined | null
};
	["FulfillmentNoteWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	note?: ValueTypes["StringCondition"] | undefined | null,
	products?: ValueTypes["ProductWhere"] | undefined | null,
	tags?: ValueTypes["TagWhere"] | undefined | null,
	venues?: ValueTypes["VenueWhere"] | undefined | null,
	cartItems?: ValueTypes["CartItemWhere"] | undefined | null,
	orderItems?: ValueTypes["OrderItemWhere"] | undefined | null,
	orders?: ValueTypes["OrderWhere"] | undefined | null,
	highlight?: ValueTypes["BooleanCondition"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	emoji?: ValueTypes["StringCondition"] | undefined | null,
	and?: Array<ValueTypes["FulfillmentNoteWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["FulfillmentNoteWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["FulfillmentNoteWhere"] | undefined | null
};
	["VenueWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	deadlineTemplate?: ValueTypes["DeadlineTemplateWhere"] | undefined | null,
	timetableDays?: ValueTypes["TimetableDayWhere"] | undefined | null,
	timetableTemplates?: ValueTypes["TimetableTemplateWhere"] | undefined | null,
	staffMembers?: ValueTypes["StaffWhere"] | undefined | null,
	employeeRoles?: ValueTypes["VenueEmployeeRoleWhere"] | undefined | null,
	pointOfSaleApplicationDevices?: ValueTypes["PointOfSaleApplicationDeviceWhere"] | undefined | null,
	pointOfSaleTerminals?: ValueTypes["PointOfSaleTerminalWhere"] | undefined | null,
	pointOfSalePrinters?: ValueTypes["PointOfSalePrinterWhere"] | undefined | null,
	orders?: ValueTypes["OrderWhere"] | undefined | null,
	fulfillmentNotes?: ValueTypes["FulfillmentNoteWhere"] | undefined | null,
	areas?: ValueTypes["AreaWhere"] | undefined | null,
	enabledUnassignReasons?: ValueTypes["UnassignReasonWhere"] | undefined | null,
	categories?: ValueTypes["PointOfSaleCategoryWhere"] | undefined | null,
	channels?: ValueTypes["ChannelWhere"] | undefined | null,
	address?: ValueTypes["StringCondition"] | undefined | null,
	pointOfSalePngBase64ReceiptLogo?: ValueTypes["StringCondition"] | undefined | null,
	pointOfSaleInitialView?: ValueTypes["PointOfSaleInitialViewCondition"] | undefined | null,
	pointOfSalePreferPrintReceipt?: ValueTypes["BooleanCondition"] | undefined | null,
	and?: Array<ValueTypes["VenueWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["VenueWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["VenueWhere"] | undefined | null
};
	["DeadlineTemplateWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	startDate?: ValueTypes["DateCondition"] | undefined | null,
	period?: ValueTypes["IntCondition"] | undefined | null,
	cutoff?: ValueTypes["IntCondition"] | undefined | null,
	closed?: ValueTypes["BooleanCondition"] | undefined | null,
	venue?: ValueTypes["VenueWhere"] | undefined | null,
	and?: Array<ValueTypes["DeadlineTemplateWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["DeadlineTemplateWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["DeadlineTemplateWhere"] | undefined | null
};
	["DateCondition"]: {
	and?: Array<ValueTypes["DateCondition"]> | undefined | null,
	or?: Array<ValueTypes["DateCondition"]> | undefined | null,
	not?: ValueTypes["DateCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["Date"] | undefined | null,
	notEq?: ValueTypes["Date"] | undefined | null,
	in?: Array<ValueTypes["Date"]> | undefined | null,
	notIn?: Array<ValueTypes["Date"]> | undefined | null,
	lt?: ValueTypes["Date"] | undefined | null,
	lte?: ValueTypes["Date"] | undefined | null,
	gt?: ValueTypes["Date"] | undefined | null,
	gte?: ValueTypes["Date"] | undefined | null
};
	["Date"]:unknown;
	["TimetableDayWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	date?: ValueTypes["DateCondition"] | undefined | null,
	type?: ValueTypes["TimetableDayTypeCondition"] | undefined | null,
	shiftGroups?: ValueTypes["TimetableShiftGroupWhere"] | undefined | null,
	tipsCents?: ValueTypes["IntCondition"] | undefined | null,
	notes?: ValueTypes["TimetableDayNoteWhere"] | undefined | null,
	venue?: ValueTypes["VenueWhere"] | undefined | null,
	meta?: ValueTypes["TimetableDayMetadataWhere"] | undefined | null,
	and?: Array<ValueTypes["TimetableDayWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["TimetableDayWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["TimetableDayWhere"] | undefined | null
};
	["TimetableDayTypeCondition"]: {
	and?: Array<ValueTypes["TimetableDayTypeCondition"]> | undefined | null,
	or?: Array<ValueTypes["TimetableDayTypeCondition"]> | undefined | null,
	not?: ValueTypes["TimetableDayTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["TimetableDayType"] | undefined | null,
	notEq?: ValueTypes["TimetableDayType"] | undefined | null,
	in?: Array<ValueTypes["TimetableDayType"]> | undefined | null,
	notIn?: Array<ValueTypes["TimetableDayType"]> | undefined | null,
	lt?: ValueTypes["TimetableDayType"] | undefined | null,
	lte?: ValueTypes["TimetableDayType"] | undefined | null,
	gt?: ValueTypes["TimetableDayType"] | undefined | null,
	gte?: ValueTypes["TimetableDayType"] | undefined | null
};
	["TimetableDayType"]:TimetableDayType;
	["TimetableShiftGroupWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	shifts?: ValueTypes["TimetableShiftWhere"] | undefined | null,
	day?: ValueTypes["TimetableDayWhere"] | undefined | null,
	type?: ValueTypes["TimetableEmployeeRoleWhere"] | undefined | null,
	position?: ValueTypes["TimetableShiftPositionWhere"] | undefined | null,
	queue?: ValueTypes["EmployeeQueueWhere"] | undefined | null,
	generatedByTemplate?: ValueTypes["TimetableTemplateWhere"] | undefined | null,
	and?: Array<ValueTypes["TimetableShiftGroupWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["TimetableShiftGroupWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["TimetableShiftGroupWhere"] | undefined | null
};
	["TimetableShiftWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	locked?: ValueTypes["BooleanCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	assigned?: ValueTypes["DateCondition"] | undefined | null,
	group?: ValueTypes["TimetableShiftGroupWhere"] | undefined | null,
	shiftsProfile?: ValueTypes["ShiftsProfileWhere"] | undefined | null,
	queueItem?: ValueTypes["EmployeeQueueItemWhere"] | undefined | null,
	swapInfo?: ValueTypes["TimetableShiftSwapInfoWhere"] | undefined | null,
	isOvertime?: ValueTypes["BooleanCondition"] | undefined | null,
	and?: Array<ValueTypes["TimetableShiftWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["TimetableShiftWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["TimetableShiftWhere"] | undefined | null
};
	["ShiftsProfileWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	queueItems?: ValueTypes["EmployeeQueueItemWhere"] | undefined | null,
	staff?: ValueTypes["StaffWhere"] | undefined | null,
	roles?: ValueTypes["TimetableEmployeeRoleWhere"] | undefined | null,
	shifts?: ValueTypes["TimetableShiftWhere"] | undefined | null,
	allowSelfUnassigning?: ValueTypes["BooleanCondition"] | undefined | null,
	and?: Array<ValueTypes["ShiftsProfileWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ShiftsProfileWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ShiftsProfileWhere"] | undefined | null
};
	["EmployeeQueueItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	start?: ValueTypes["StringCondition"] | undefined | null,
	end?: ValueTypes["StringCondition"] | undefined | null,
	queue?: ValueTypes["EmployeeQueueWhere"] | undefined | null,
	shiftsProfile?: ValueTypes["ShiftsProfileWhere"] | undefined | null,
	shift?: ValueTypes["TimetableShiftWhere"] | undefined | null,
	unassignInfo?: ValueTypes["UnassignedShiftInfoWhere"] | undefined | null,
	meta?: ValueTypes["EmployeeQueueItemMetadataWhere"] | undefined | null,
	and?: Array<ValueTypes["EmployeeQueueItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["EmployeeQueueItemWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["EmployeeQueueItemWhere"] | undefined | null
};
	["EmployeeQueueWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	shiftGroup?: ValueTypes["TimetableShiftGroupWhere"] | undefined | null,
	items?: ValueTypes["EmployeeQueueItemWhere"] | undefined | null,
	contemberBugFix?: ValueTypes["BooleanCondition"] | undefined | null,
	and?: Array<ValueTypes["EmployeeQueueWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["EmployeeQueueWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["EmployeeQueueWhere"] | undefined | null
};
	["UnassignedShiftInfoWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	hoursMissed?: ValueTypes["IntCondition"] | undefined | null,
	queueItem?: ValueTypes["EmployeeQueueItemWhere"] | undefined | null,
	legacyReason?: ValueTypes["UnassignedInfoReasonCondition"] | undefined | null,
	reason?: ValueTypes["UnassignReasonWhere"] | undefined | null,
	and?: Array<ValueTypes["UnassignedShiftInfoWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["UnassignedShiftInfoWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["UnassignedShiftInfoWhere"] | undefined | null
};
	["UnassignedInfoReasonCondition"]: {
	and?: Array<ValueTypes["UnassignedInfoReasonCondition"]> | undefined | null,
	or?: Array<ValueTypes["UnassignedInfoReasonCondition"]> | undefined | null,
	not?: ValueTypes["UnassignedInfoReasonCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["UnassignedInfoReason"] | undefined | null,
	notEq?: ValueTypes["UnassignedInfoReason"] | undefined | null,
	in?: Array<ValueTypes["UnassignedInfoReason"]> | undefined | null,
	notIn?: Array<ValueTypes["UnassignedInfoReason"]> | undefined | null,
	lt?: ValueTypes["UnassignedInfoReason"] | undefined | null,
	lte?: ValueTypes["UnassignedInfoReason"] | undefined | null,
	gt?: ValueTypes["UnassignedInfoReason"] | undefined | null,
	gte?: ValueTypes["UnassignedInfoReason"] | undefined | null
};
	["UnassignedInfoReason"]:UnassignedInfoReason;
	["UnassignReasonWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	venues?: ValueTypes["VenueWhere"] | undefined | null,
	and?: Array<ValueTypes["UnassignReasonWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["UnassignReasonWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["UnassignReasonWhere"] | undefined | null
};
	["EmployeeQueueItemMetadataWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	totalMinutes?: ValueTypes["IntCondition"] | undefined | null,
	queueItem?: ValueTypes["EmployeeQueueItemWhere"] | undefined | null,
	includeInTipsCalculation?: ValueTypes["BooleanCondition"] | undefined | null,
	and?: Array<ValueTypes["EmployeeQueueItemMetadataWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["EmployeeQueueItemMetadataWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["EmployeeQueueItemMetadataWhere"] | undefined | null
};
	["TimetableEmployeeRoleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	shiftGroups?: ValueTypes["TimetableShiftGroupWhere"] | undefined | null,
	shiftsProfiles?: ValueTypes["ShiftsProfileWhere"] | undefined | null,
	shiftsManagers?: ValueTypes["ShiftsManagerWhere"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	timetableTemplates?: ValueTypes["TimetableTemplateWhere"] | undefined | null,
	color?: ValueTypes["StringCondition"] | undefined | null,
	and?: Array<ValueTypes["TimetableEmployeeRoleWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["TimetableEmployeeRoleWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["TimetableEmployeeRoleWhere"] | undefined | null
};
	["ShiftsManagerWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	staff?: ValueTypes["StaffWhere"] | undefined | null,
	managedRoles?: ValueTypes["TimetableEmployeeRoleWhere"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	and?: Array<ValueTypes["ShiftsManagerWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ShiftsManagerWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ShiftsManagerWhere"] | undefined | null
};
	["TimetableTemplateWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	startDate?: ValueTypes["DateCondition"] | undefined | null,
	period?: ValueTypes["IntCondition"] | undefined | null,
	slots?: ValueTypes["IntCondition"] | undefined | null,
	position?: ValueTypes["TimetableShiftPositionWhere"] | undefined | null,
	staffOptions?: ValueTypes["TimetableTemplateStaffOptionsWhere"] | undefined | null,
	internalName?: ValueTypes["StringCondition"] | undefined | null,
	venue?: ValueTypes["VenueWhere"] | undefined | null,
	employeeRole?: ValueTypes["TimetableEmployeeRoleWhere"] | undefined | null,
	workdaysOnly?: ValueTypes["BooleanCondition"] | undefined | null,
	monday?: ValueTypes["BooleanCondition"] | undefined | null,
	tuesday?: ValueTypes["BooleanCondition"] | undefined | null,
	wednesday?: ValueTypes["BooleanCondition"] | undefined | null,
	thursday?: ValueTypes["BooleanCondition"] | undefined | null,
	friday?: ValueTypes["BooleanCondition"] | undefined | null,
	saturday?: ValueTypes["BooleanCondition"] | undefined | null,
	sunday?: ValueTypes["BooleanCondition"] | undefined | null,
	type?: ValueTypes["TemplateTypeCondition"] | undefined | null,
	and?: Array<ValueTypes["TimetableTemplateWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["TimetableTemplateWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["TimetableTemplateWhere"] | undefined | null
};
	["TimetableShiftPositionWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	start?: ValueTypes["StringCondition"] | undefined | null,
	end?: ValueTypes["StringCondition"] | undefined | null,
	shiftGroups?: ValueTypes["TimetableShiftGroupWhere"] | undefined | null,
	timetableTemplates?: ValueTypes["TimetableTemplateWhere"] | undefined | null,
	isDynamic?: ValueTypes["BooleanCondition"] | undefined | null,
	and?: Array<ValueTypes["TimetableShiftPositionWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["TimetableShiftPositionWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["TimetableShiftPositionWhere"] | undefined | null
};
	["TimetableTemplateStaffOptionsWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	startTime?: ValueTypes["StringCondition"] | undefined | null,
	endTime?: ValueTypes["StringCondition"] | undefined | null,
	timetableTemplate?: ValueTypes["TimetableTemplateWhere"] | undefined | null,
	autoAssignedEmployee?: ValueTypes["ShiftsProfileWhere"] | undefined | null,
	and?: Array<ValueTypes["TimetableTemplateStaffOptionsWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["TimetableTemplateStaffOptionsWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["TimetableTemplateStaffOptionsWhere"] | undefined | null
};
	["TemplateTypeCondition"]: {
	and?: Array<ValueTypes["TemplateTypeCondition"]> | undefined | null,
	or?: Array<ValueTypes["TemplateTypeCondition"]> | undefined | null,
	not?: ValueTypes["TemplateTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["TemplateType"] | undefined | null,
	notEq?: ValueTypes["TemplateType"] | undefined | null,
	in?: Array<ValueTypes["TemplateType"]> | undefined | null,
	notIn?: Array<ValueTypes["TemplateType"]> | undefined | null,
	lt?: ValueTypes["TemplateType"] | undefined | null,
	lte?: ValueTypes["TemplateType"] | undefined | null,
	gt?: ValueTypes["TemplateType"] | undefined | null,
	gte?: ValueTypes["TemplateType"] | undefined | null
};
	["TemplateType"]:TemplateType;
	["TimetableShiftSwapInfoWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	assigned?: ValueTypes["DateCondition"] | undefined | null,
	requested?: ValueTypes["BooleanCondition"] | undefined | null,
	confirmed?: ValueTypes["BooleanCondition"] | undefined | null,
	swappedShiftsProfile?: ValueTypes["ShiftsProfileWhere"] | undefined | null,
	shift?: ValueTypes["TimetableShiftWhere"] | undefined | null,
	and?: Array<ValueTypes["TimetableShiftSwapInfoWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["TimetableShiftSwapInfoWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["TimetableShiftSwapInfoWhere"] | undefined | null
};
	["TimetableDayNoteWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	note?: ValueTypes["StringCondition"] | undefined | null,
	day?: ValueTypes["TimetableDayWhere"] | undefined | null,
	role?: ValueTypes["TimetableEmployeeRoleWhere"] | undefined | null,
	and?: Array<ValueTypes["TimetableDayNoteWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["TimetableDayNoteWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["TimetableDayNoteWhere"] | undefined | null
};
	["TimetableDayMetadataWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	numberOfWorkers?: ValueTypes["IntCondition"] | undefined | null,
	tipsTotalCents?: ValueTypes["IntCondition"] | undefined | null,
	totalMinutes?: ValueTypes["IntCondition"] | undefined | null,
	tipsCentsPerMinute?: ValueTypes["FloatCondition"] | undefined | null,
	day?: ValueTypes["TimetableDayWhere"] | undefined | null,
	and?: Array<ValueTypes["TimetableDayMetadataWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["TimetableDayMetadataWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["TimetableDayMetadataWhere"] | undefined | null
};
	["FloatCondition"]: {
	and?: Array<ValueTypes["FloatCondition"]> | undefined | null,
	or?: Array<ValueTypes["FloatCondition"]> | undefined | null,
	not?: ValueTypes["FloatCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: number | undefined | null,
	notEq?: number | undefined | null,
	in?: Array<number> | undefined | null,
	notIn?: Array<number> | undefined | null,
	lt?: number | undefined | null,
	lte?: number | undefined | null,
	gt?: number | undefined | null,
	gte?: number | undefined | null
};
	["VenueEmployeeRoleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	employeePrivileges?: ValueTypes["TimetablesEmployeePrivilegesWhere"] | undefined | null,
	venue?: ValueTypes["VenueWhere"] | undefined | null,
	role?: ValueTypes["TimetableEmployeeRoleWhere"] | undefined | null,
	getsTipsShare?: ValueTypes["BooleanCondition"] | undefined | null,
	notesEnabled?: ValueTypes["BooleanCondition"] | undefined | null,
	and?: Array<ValueTypes["VenueEmployeeRoleWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["VenueEmployeeRoleWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["VenueEmployeeRoleWhere"] | undefined | null
};
	["TimetablesEmployeePrivilegesWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	venueEmployeeRole?: ValueTypes["VenueEmployeeRoleWhere"] | undefined | null,
	read?: ValueTypes["BooleanCondition"] | undefined | null,
	unassign?: ValueTypes["BooleanCondition"] | undefined | null,
	assign?: ValueTypes["BooleanCondition"] | undefined | null,
	and?: Array<ValueTypes["TimetablesEmployeePrivilegesWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["TimetablesEmployeePrivilegesWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["TimetablesEmployeePrivilegesWhere"] | undefined | null
};
	["PointOfSaleApplicationDeviceWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	internalName?: ValueTypes["StringCondition"] | undefined | null,
	note?: ValueTypes["StringCondition"] | undefined | null,
	venue?: ValueTypes["VenueWhere"] | undefined | null,
	identificationCode?: ValueTypes["IdentificationCodeWhere"] | undefined | null,
	identifier?: ValueTypes["DeviceIdentifierWhere"] | undefined | null,
	terminal?: ValueTypes["PointOfSaleTerminalWhere"] | undefined | null,
	receiptPrinter?: ValueTypes["PointOfSalePrinterWhere"] | undefined | null,
	ticketPrinters?: ValueTypes["PointOfSalePrinterWhere"] | undefined | null,
	and?: Array<ValueTypes["PointOfSaleApplicationDeviceWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["PointOfSaleApplicationDeviceWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["PointOfSaleApplicationDeviceWhere"] | undefined | null
};
	["IdentificationCodeWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	code?: ValueTypes["StringCondition"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	attempts?: ValueTypes["IdentificationAttemptWhere"] | undefined | null,
	locales?: ValueTypes["IdentificationCodeLocaleWhere"] | undefined | null,
	internalName?: ValueTypes["StringCondition"] | undefined | null,
	applicationDevices?: ValueTypes["PointOfSaleApplicationDeviceWhere"] | undefined | null,
	and?: Array<ValueTypes["IdentificationCodeWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["IdentificationCodeWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["IdentificationCodeWhere"] | undefined | null
};
	["IdentificationAttemptWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	code?: ValueTypes["IdentificationCodeWhere"] | undefined | null,
	user?: ValueTypes["UserWhere"] | undefined | null,
	and?: Array<ValueTypes["IdentificationAttemptWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["IdentificationAttemptWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["IdentificationAttemptWhere"] | undefined | null
};
	["UserWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	internalNote?: ValueTypes["StringCondition"] | undefined | null,
	staff?: ValueTypes["StaffWhere"] | undefined | null,
	customer?: ValueTypes["CustomerWhere"] | undefined | null,
	tenantPersonId?: ValueTypes["UUIDCondition"] | undefined | null,
	disabledAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	devices?: ValueTypes["UserDeviceWhere"] | undefined | null,
	verifiedAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	email?: ValueTypes["StringCondition"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	deletionRequestedAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	deletionExpectedAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	deletedAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	meta?: ValueTypes["UserMetadataWhere"] | undefined | null,
	identificationAttempts?: ValueTypes["IdentificationAttemptWhere"] | undefined | null,
	roles?: ValueTypes["UserRolesWhere"] | undefined | null,
	and?: Array<ValueTypes["UserWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["UserWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["UserWhere"] | undefined | null
};
	["UserDeviceWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	lastActiveAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	platform?: ValueTypes["StringCondition"] | undefined | null,
	deviceId?: ValueTypes["StringCondition"] | undefined | null,
	notificationsEnabled?: ValueTypes["BooleanCondition"] | undefined | null,
	user?: ValueTypes["UserWhere"] | undefined | null,
	appVersion?: ValueTypes["StringCondition"] | undefined | null,
	osVersion?: ValueTypes["StringCondition"] | undefined | null,
	apiVersion?: ValueTypes["StringCondition"] | undefined | null,
	anonymousSession?: ValueTypes["AnonymousSessionWhere"] | undefined | null,
	and?: Array<ValueTypes["UserDeviceWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["UserDeviceWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["UserDeviceWhere"] | undefined | null
};
	["AnonymousSessionWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	lastActiveAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	anonymousSessionKey?: ValueTypes["StringCondition"] | undefined | null,
	email?: ValueTypes["StringCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	internalNote?: ValueTypes["StringCondition"] | undefined | null,
	customer?: ValueTypes["CustomerWhere"] | undefined | null,
	devices?: ValueTypes["UserDeviceWhere"] | undefined | null,
	and?: Array<ValueTypes["AnonymousSessionWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["AnonymousSessionWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["AnonymousSessionWhere"] | undefined | null
};
	["UserMetadataWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	userProfileUrl?: ValueTypes["StringCondition"] | undefined | null,
	tenantEmail?: ValueTypes["StringCondition"] | undefined | null,
	tenantPersonId?: ValueTypes["UUIDCondition"] | undefined | null,
	tenantIdentityId?: ValueTypes["UUIDCondition"] | undefined | null,
	globalRoles?: ValueTypes["JsonCondition"] | undefined | null,
	projectRoles?: ValueTypes["JsonCondition"] | undefined | null,
	projectRolesString?: ValueTypes["StringCondition"] | undefined | null,
	externalIdentifiers?: ValueTypes["JsonCondition"] | undefined | null,
	externalIdentifiersString?: ValueTypes["StringCondition"] | undefined | null,
	idpSlugs?: ValueTypes["JsonCondition"] | undefined | null,
	idpSlugsString?: ValueTypes["StringCondition"] | undefined | null,
	user?: ValueTypes["UserWhere"] | undefined | null,
	and?: Array<ValueTypes["UserMetadataWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["UserMetadataWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["UserMetadataWhere"] | undefined | null
};
	["UserRolesWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	isCustomer?: ValueTypes["BooleanCondition"] | undefined | null,
	isStaff?: ValueTypes["BooleanCondition"] | undefined | null,
	isBartender?: ValueTypes["BooleanCondition"] | undefined | null,
	isCashier?: ValueTypes["BooleanCondition"] | undefined | null,
	isCourier?: ValueTypes["BooleanCondition"] | undefined | null,
	isCleaner?: ValueTypes["BooleanCondition"] | undefined | null,
	isShiftsManager?: ValueTypes["BooleanCondition"] | undefined | null,
	isInternalBuyer?: ValueTypes["BooleanCondition"] | undefined | null,
	isStocksManager?: ValueTypes["BooleanCondition"] | undefined | null,
	isCourierManager?: ValueTypes["BooleanCondition"] | undefined | null,
	isCashierManager?: ValueTypes["BooleanCondition"] | undefined | null,
	isBusinessToBusinessManager?: ValueTypes["BooleanCondition"] | undefined | null,
	isPicker?: ValueTypes["BooleanCondition"] | undefined | null,
	user?: ValueTypes["UserWhere"] | undefined | null,
	and?: Array<ValueTypes["UserRolesWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["UserRolesWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["UserRolesWhere"] | undefined | null
};
	["IdentificationCodeLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	successMessage?: ValueTypes["StringCondition"] | undefined | null,
	root?: ValueTypes["IdentificationCodeWhere"] | undefined | null,
	locale?: ValueTypes["LocaleWhere"] | undefined | null,
	and?: Array<ValueTypes["IdentificationCodeLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["IdentificationCodeLocaleWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["IdentificationCodeLocaleWhere"] | undefined | null
};
	["DeviceIdentifierWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	internalName?: ValueTypes["StringCondition"] | undefined | null,
	device?: ValueTypes["PointOfSaleApplicationDeviceWhere"] | undefined | null,
	updatedAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	platform?: ValueTypes["StringCondition"] | undefined | null,
	resolution?: ValueTypes["StringCondition"] | undefined | null,
	devicePixelRatio?: ValueTypes["FloatCondition"] | undefined | null,
	updatedByUser?: ValueTypes["UserWhere"] | undefined | null,
	identifier?: ValueTypes["StringCondition"] | undefined | null,
	meta?: ValueTypes["DeviceIdentifierMetadataWhere"] | undefined | null,
	applicationVersionIdentifier?: ValueTypes["StringCondition"] | undefined | null,
	lastPointOfSaleSynchronizationErrorRawDetails?: ValueTypes["StringCondition"] | undefined | null,
	and?: Array<ValueTypes["DeviceIdentifierWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["DeviceIdentifierWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["DeviceIdentifierWhere"] | undefined | null
};
	["DeviceIdentifierMetadataWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	prettyIdentifier?: ValueTypes["StringCondition"] | undefined | null,
	deviceIdentifier?: ValueTypes["DeviceIdentifierWhere"] | undefined | null,
	and?: Array<ValueTypes["DeviceIdentifierMetadataWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["DeviceIdentifierMetadataWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["DeviceIdentifierMetadataWhere"] | undefined | null
};
	["PointOfSaleTerminalWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	internalName?: ValueTypes["StringCondition"] | undefined | null,
	note?: ValueTypes["StringCondition"] | undefined | null,
	venue?: ValueTypes["VenueWhere"] | undefined | null,
	applicationDevices?: ValueTypes["PointOfSaleApplicationDeviceWhere"] | undefined | null,
	ipAddress?: ValueTypes["StringCondition"] | undefined | null,
	port?: ValueTypes["IntCondition"] | undefined | null,
	type?: ValueTypes["PointOfSaleTerminalTypeCondition"] | undefined | null,
	and?: Array<ValueTypes["PointOfSaleTerminalWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["PointOfSaleTerminalWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["PointOfSaleTerminalWhere"] | undefined | null
};
	["PointOfSaleTerminalTypeCondition"]: {
	and?: Array<ValueTypes["PointOfSaleTerminalTypeCondition"]> | undefined | null,
	or?: Array<ValueTypes["PointOfSaleTerminalTypeCondition"]> | undefined | null,
	not?: ValueTypes["PointOfSaleTerminalTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["PointOfSaleTerminalType"] | undefined | null,
	notEq?: ValueTypes["PointOfSaleTerminalType"] | undefined | null,
	in?: Array<ValueTypes["PointOfSaleTerminalType"]> | undefined | null,
	notIn?: Array<ValueTypes["PointOfSaleTerminalType"]> | undefined | null,
	lt?: ValueTypes["PointOfSaleTerminalType"] | undefined | null,
	lte?: ValueTypes["PointOfSaleTerminalType"] | undefined | null,
	gt?: ValueTypes["PointOfSaleTerminalType"] | undefined | null,
	gte?: ValueTypes["PointOfSaleTerminalType"] | undefined | null
};
	["PointOfSaleTerminalType"]:PointOfSaleTerminalType;
	["PointOfSalePrinterWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	internalName?: ValueTypes["StringCondition"] | undefined | null,
	note?: ValueTypes["StringCondition"] | undefined | null,
	ipAddress?: ValueTypes["StringCondition"] | undefined | null,
	applicationDevicesReceipt?: ValueTypes["PointOfSaleApplicationDeviceWhere"] | undefined | null,
	applicationDevicesTicket?: ValueTypes["PointOfSaleApplicationDeviceWhere"] | undefined | null,
	venue?: ValueTypes["VenueWhere"] | undefined | null,
	ticketCategories?: ValueTypes["PointOfSaleCategoryWhere"] | undefined | null,
	and?: Array<ValueTypes["PointOfSalePrinterWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["PointOfSalePrinterWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["PointOfSalePrinterWhere"] | undefined | null
};
	["PointOfSaleCategoryWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	slug?: ValueTypes["StringCondition"] | undefined | null,
	locales?: ValueTypes["PointOfSaleCategoryLocaleWhere"] | undefined | null,
	products?: ValueTypes["PointOfSaleCategoryProductWhere"] | undefined | null,
	category?: ValueTypes["ProductCategoryWhere"] | undefined | null,
	venue?: ValueTypes["VenueWhere"] | undefined | null,
	ticketPrinters?: ValueTypes["PointOfSalePrinterWhere"] | undefined | null,
	and?: Array<ValueTypes["PointOfSaleCategoryWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["PointOfSaleCategoryWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["PointOfSaleCategoryWhere"] | undefined | null
};
	["PointOfSaleCategoryLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	title?: ValueTypes["StringCondition"] | undefined | null,
	root?: ValueTypes["PointOfSaleCategoryWhere"] | undefined | null,
	locale?: ValueTypes["LocaleWhere"] | undefined | null,
	and?: Array<ValueTypes["PointOfSaleCategoryLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["PointOfSaleCategoryLocaleWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["PointOfSaleCategoryLocaleWhere"] | undefined | null
};
	["PointOfSaleCategoryProductWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	category?: ValueTypes["PointOfSaleCategoryWhere"] | undefined | null,
	product?: ValueTypes["ProductWhere"] | undefined | null,
	locales?: ValueTypes["PointOfSaleCategoryProductLocaleWhere"] | undefined | null,
	and?: Array<ValueTypes["PointOfSaleCategoryProductWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["PointOfSaleCategoryProductWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["PointOfSaleCategoryProductWhere"] | undefined | null
};
	["PointOfSaleCategoryProductLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	title?: ValueTypes["StringCondition"] | undefined | null,
	root?: ValueTypes["PointOfSaleCategoryProductWhere"] | undefined | null,
	locale?: ValueTypes["LocaleWhere"] | undefined | null,
	and?: Array<ValueTypes["PointOfSaleCategoryProductLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["PointOfSaleCategoryProductLocaleWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["PointOfSaleCategoryProductLocaleWhere"] | undefined | null
};
	["ProductCategoryWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	code?: ValueTypes["StringCondition"] | undefined | null,
	products?: ValueTypes["ProductWhere"] | undefined | null,
	tags?: ValueTypes["TagWhere"] | undefined | null,
	parent?: ValueTypes["ProductCategoryWhere"] | undefined | null,
	children?: ValueTypes["ProductCategoryWhere"] | undefined | null,
	description?: ValueTypes["StringCondition"] | undefined | null,
	internalNote?: ValueTypes["StringCondition"] | undefined | null,
	color?: ValueTypes["StringCondition"] | undefined | null,
	image?: ValueTypes["ImageWhere"] | undefined | null,
	order?: ValueTypes["FloatCondition"] | undefined | null,
	descendants?: ValueTypes["ProductCategoryTreeWhere"] | undefined | null,
	ancestors?: ValueTypes["ProductCategoryTreeWhere"] | undefined | null,
	inheritedTags?: ValueTypes["InheritedProductCategoryTagWhere"] | undefined | null,
	nestedProducts?: ValueTypes["NestedProductCategoryProductWhere"] | undefined | null,
	and?: Array<ValueTypes["ProductCategoryWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ProductCategoryWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ProductCategoryWhere"] | undefined | null
};
	["ProductCategoryTreeWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	depth?: ValueTypes["IntCondition"] | undefined | null,
	ancestor?: ValueTypes["ProductCategoryWhere"] | undefined | null,
	descendant?: ValueTypes["ProductCategoryWhere"] | undefined | null,
	and?: Array<ValueTypes["ProductCategoryTreeWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ProductCategoryTreeWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ProductCategoryTreeWhere"] | undefined | null
};
	["InheritedProductCategoryTagWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	depth?: ValueTypes["IntCondition"] | undefined | null,
	productCategory?: ValueTypes["ProductCategoryWhere"] | undefined | null,
	tag?: ValueTypes["TagWhere"] | undefined | null,
	and?: Array<ValueTypes["InheritedProductCategoryTagWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["InheritedProductCategoryTagWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["InheritedProductCategoryTagWhere"] | undefined | null
};
	["NestedProductCategoryProductWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	depth?: ValueTypes["IntCondition"] | undefined | null,
	product?: ValueTypes["ProductWhere"] | undefined | null,
	productCategory?: ValueTypes["ProductCategoryWhere"] | undefined | null,
	and?: Array<ValueTypes["NestedProductCategoryProductWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["NestedProductCategoryProductWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["NestedProductCategoryProductWhere"] | undefined | null
};
	["OrderWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	state?: ValueTypes["OrderStateCondition"] | undefined | null,
	fulfilledAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	canceledAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	note?: ValueTypes["StringCondition"] | undefined | null,
	customer?: ValueTypes["CustomerWhere"] | undefined | null,
	channel?: ValueTypes["ChannelWhere"] | undefined | null,
	discounts?: ValueTypes["OrderDiscountWhere"] | undefined | null,
	delivery?: ValueTypes["OrderDeliveryWhere"] | undefined | null,
	items?: ValueTypes["OrderItemWhere"] | undefined | null,
	internalNote?: ValueTypes["StringCondition"] | undefined | null,
	cart?: ValueTypes["CartWhere"] | undefined | null,
	events?: ValueTypes["OrderEventWhere"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	billingAddress?: ValueTypes["AddressWhere"] | undefined | null,
	priceLines?: ValueTypes["OrderPriceLineWhere"] | undefined | null,
	payments?: ValueTypes["OrderPaymentWhere"] | undefined | null,
	seq?: ValueTypes["IntCondition"] | undefined | null,
	billingSubject?: ValueTypes["BillingSubjectWhere"] | undefined | null,
	summary?: ValueTypes["OrderSummaryWhere"] | undefined | null,
	doubleshotLegacyId?: ValueTypes["StringCondition"] | undefined | null,
	gratuity?: ValueTypes["GratuityWhere"] | undefined | null,
	venue?: ValueTypes["VenueWhere"] | undefined | null,
	fulfillmentNote?: ValueTypes["StringCondition"] | undefined | null,
	fulfillmentNotes?: ValueTypes["FulfillmentNoteWhere"] | undefined | null,
	doubleshotTotalWeightGrams?: ValueTypes["IntCondition"] | undefined | null,
	doubleShotLegacyNumber?: ValueTypes["StringCondition"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	doubleshotAdminUrl?: ValueTypes["StringCondition"] | undefined | null,
	and?: Array<ValueTypes["OrderWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["OrderWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["OrderWhere"] | undefined | null
};
	["OrderStateCondition"]: {
	and?: Array<ValueTypes["OrderStateCondition"]> | undefined | null,
	or?: Array<ValueTypes["OrderStateCondition"]> | undefined | null,
	not?: ValueTypes["OrderStateCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["OrderState"] | undefined | null,
	notEq?: ValueTypes["OrderState"] | undefined | null,
	in?: Array<ValueTypes["OrderState"]> | undefined | null,
	notIn?: Array<ValueTypes["OrderState"]> | undefined | null,
	lt?: ValueTypes["OrderState"] | undefined | null,
	lte?: ValueTypes["OrderState"] | undefined | null,
	gt?: ValueTypes["OrderState"] | undefined | null,
	gte?: ValueTypes["OrderState"] | undefined | null
};
	["OrderState"]:OrderState;
	["OrderDiscountWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	discountCents?: ValueTypes["IntCondition"] | undefined | null,
	vatRate?: ValueTypes["VatRateWhere"] | undefined | null,
	order?: ValueTypes["OrderWhere"] | undefined | null,
	description?: ValueTypes["StringCondition"] | undefined | null,
	type?: ValueTypes["OrderDiscountTypeCondition"] | undefined | null,
	customerCreditTransactions?: ValueTypes["CustomerCreditTransactionWhere"] | undefined | null,
	voucherRedemption?: ValueTypes["VoucherRedemptionWhere"] | undefined | null,
	and?: Array<ValueTypes["OrderDiscountWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["OrderDiscountWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["OrderDiscountWhere"] | undefined | null
};
	["OrderDiscountTypeCondition"]: {
	and?: Array<ValueTypes["OrderDiscountTypeCondition"]> | undefined | null,
	or?: Array<ValueTypes["OrderDiscountTypeCondition"]> | undefined | null,
	not?: ValueTypes["OrderDiscountTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["OrderDiscountType"] | undefined | null,
	notEq?: ValueTypes["OrderDiscountType"] | undefined | null,
	in?: Array<ValueTypes["OrderDiscountType"]> | undefined | null,
	notIn?: Array<ValueTypes["OrderDiscountType"]> | undefined | null,
	lt?: ValueTypes["OrderDiscountType"] | undefined | null,
	lte?: ValueTypes["OrderDiscountType"] | undefined | null,
	gt?: ValueTypes["OrderDiscountType"] | undefined | null,
	gte?: ValueTypes["OrderDiscountType"] | undefined | null
};
	["OrderDiscountType"]:OrderDiscountType;
	["CustomerCreditTransactionWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	amountCents?: ValueTypes["IntCondition"] | undefined | null,
	customerCredit?: ValueTypes["CustomerCreditWhere"] | undefined | null,
	orderDiscount?: ValueTypes["OrderDiscountWhere"] | undefined | null,
	virtualProductEffect?: ValueTypes["VirtualProductEffectWhere"] | undefined | null,
	and?: Array<ValueTypes["CustomerCreditTransactionWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["CustomerCreditTransactionWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["CustomerCreditTransactionWhere"] | undefined | null
};
	["CustomerCreditWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	initialCreditCents?: ValueTypes["IntCondition"] | undefined | null,
	remainingCreditsCents?: ValueTypes["IntCondition"] | undefined | null,
	expiresAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	reason?: ValueTypes["StringCondition"] | undefined | null,
	customer?: ValueTypes["CustomerWhere"] | undefined | null,
	vatRate?: ValueTypes["VatRateWhere"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	transactions?: ValueTypes["CustomerCreditTransactionWhere"] | undefined | null,
	voucherRedemption?: ValueTypes["VoucherRedemptionWhere"] | undefined | null,
	invoiceUrl?: ValueTypes["StringCondition"] | undefined | null,
	and?: Array<ValueTypes["CustomerCreditWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["CustomerCreditWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["CustomerCreditWhere"] | undefined | null
};
	["VoucherRedemptionWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	note?: ValueTypes["StringCondition"] | undefined | null,
	manualRedemptionNote?: ValueTypes["StringCondition"] | undefined | null,
	customerCredit?: ValueTypes["CustomerCreditWhere"] | undefined | null,
	orderDiscount?: ValueTypes["OrderDiscountWhere"] | undefined | null,
	voucher?: ValueTypes["VoucherWhere"] | undefined | null,
	customer?: ValueTypes["CustomerWhere"] | undefined | null,
	and?: Array<ValueTypes["VoucherRedemptionWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["VoucherRedemptionWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["VoucherRedemptionWhere"] | undefined | null
};
	["VoucherWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	activatedAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	expiresAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	internalNote?: ValueTypes["StringCondition"] | undefined | null,
	note?: ValueTypes["StringCondition"] | undefined | null,
	code?: ValueTypes["StringCondition"] | undefined | null,
	type?: ValueTypes["VoucherTypeCondition"] | undefined | null,
	creditCents?: ValueTypes["IntCondition"] | undefined | null,
	buyer?: ValueTypes["CustomerWhere"] | undefined | null,
	owner?: ValueTypes["CustomerWhere"] | undefined | null,
	vatRate?: ValueTypes["VatRateWhere"] | undefined | null,
	virtualProductEffect?: ValueTypes["VirtualProductEffectWhere"] | undefined | null,
	redemption?: ValueTypes["VoucherRedemptionWhere"] | undefined | null,
	and?: Array<ValueTypes["VoucherWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["VoucherWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["VoucherWhere"] | undefined | null
};
	["VoucherTypeCondition"]: {
	and?: Array<ValueTypes["VoucherTypeCondition"]> | undefined | null,
	or?: Array<ValueTypes["VoucherTypeCondition"]> | undefined | null,
	not?: ValueTypes["VoucherTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["VoucherType"] | undefined | null,
	notEq?: ValueTypes["VoucherType"] | undefined | null,
	in?: Array<ValueTypes["VoucherType"]> | undefined | null,
	notIn?: Array<ValueTypes["VoucherType"]> | undefined | null,
	lt?: ValueTypes["VoucherType"] | undefined | null,
	lte?: ValueTypes["VoucherType"] | undefined | null,
	gt?: ValueTypes["VoucherType"] | undefined | null,
	gte?: ValueTypes["VoucherType"] | undefined | null
};
	["VoucherType"]:VoucherType;
	["VirtualProductEffectWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	succeededAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	orderItem?: ValueTypes["OrderItemWhere"] | undefined | null,
	failedAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	revertedAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	resultCustomerCreditTransaction?: ValueTypes["CustomerCreditTransactionWhere"] | undefined | null,
	resultVouchers?: ValueTypes["VoucherWhere"] | undefined | null,
	and?: Array<ValueTypes["VirtualProductEffectWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["VirtualProductEffectWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["VirtualProductEffectWhere"] | undefined | null
};
	["OrderItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	unitPriceCents?: ValueTypes["IntCondition"] | undefined | null,
	quantity?: ValueTypes["IntCondition"] | undefined | null,
	vatRate?: ValueTypes["VatRateWhere"] | undefined | null,
	order?: ValueTypes["OrderWhere"] | undefined | null,
	virtualProductEffects?: ValueTypes["VirtualProductEffectWhere"] | undefined | null,
	pickedAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	note?: ValueTypes["StringCondition"] | undefined | null,
	fulfillmentNotes?: ValueTypes["FulfillmentNoteWhere"] | undefined | null,
	product?: ValueTypes["ProductWhere"] | undefined | null,
	and?: Array<ValueTypes["OrderItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["OrderItemWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["OrderItemWhere"] | undefined | null
};
	["OrderEventWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	type?: ValueTypes["StringCondition"] | undefined | null,
	data?: ValueTypes["StringCondition"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	order?: ValueTypes["OrderWhere"] | undefined | null,
	payment?: ValueTypes["OrderPaymentWhere"] | undefined | null,
	delivery?: ValueTypes["OrderDeliveryWhere"] | undefined | null,
	and?: Array<ValueTypes["OrderEventWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["OrderEventWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["OrderEventWhere"] | undefined | null
};
	["OrderPaymentWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	data?: ValueTypes["JsonCondition"] | undefined | null,
	paymentCents?: ValueTypes["IntCondition"] | undefined | null,
	method?: ValueTypes["PaymentMethodWhere"] | undefined | null,
	failedAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	state?: ValueTypes["OrderPaymentStateCondition"] | undefined | null,
	approvedAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	events?: ValueTypes["OrderEventWhere"] | undefined | null,
	order?: ValueTypes["OrderWhere"] | undefined | null,
	invoice?: ValueTypes["InvoiceWhere"] | undefined | null,
	walletType?: ValueTypes["StringCondition"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	publicReceiptUrl?: ValueTypes["StringCondition"] | undefined | null,
	priceCents?: ValueTypes["IntCondition"] | undefined | null,
	vatRate?: ValueTypes["VatRateWhere"] | undefined | null,
	meta?: ValueTypes["OrderPaymentMetadataWhere"] | undefined | null,
	otherCurrencyPriceCents?: ValueTypes["StringCondition"] | undefined | null,
	and?: Array<ValueTypes["OrderPaymentWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["OrderPaymentWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["OrderPaymentWhere"] | undefined | null
};
	["OrderPaymentStateCondition"]: {
	and?: Array<ValueTypes["OrderPaymentStateCondition"]> | undefined | null,
	or?: Array<ValueTypes["OrderPaymentStateCondition"]> | undefined | null,
	not?: ValueTypes["OrderPaymentStateCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["OrderPaymentState"] | undefined | null,
	notEq?: ValueTypes["OrderPaymentState"] | undefined | null,
	in?: Array<ValueTypes["OrderPaymentState"]> | undefined | null,
	notIn?: Array<ValueTypes["OrderPaymentState"]> | undefined | null,
	lt?: ValueTypes["OrderPaymentState"] | undefined | null,
	lte?: ValueTypes["OrderPaymentState"] | undefined | null,
	gt?: ValueTypes["OrderPaymentState"] | undefined | null,
	gte?: ValueTypes["OrderPaymentState"] | undefined | null
};
	["OrderPaymentState"]:OrderPaymentState;
	["InvoiceWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	publicKey?: ValueTypes["StringCondition"] | undefined | null,
	fakturoidId?: ValueTypes["StringCondition"] | undefined | null,
	fakturoidData?: ValueTypes["StringCondition"] | undefined | null,
	legacyUrl?: ValueTypes["StringCondition"] | undefined | null,
	customer?: ValueTypes["CustomerWhere"] | undefined | null,
	orderPayments?: ValueTypes["OrderPaymentWhere"] | undefined | null,
	address?: ValueTypes["AddressWhere"] | undefined | null,
	publicUrl?: ValueTypes["StringCondition"] | undefined | null,
	billingSubject?: ValueTypes["BillingSubjectWhere"] | undefined | null,
	and?: Array<ValueTypes["InvoiceWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["InvoiceWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["InvoiceWhere"] | undefined | null
};
	["BillingSubjectWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	fullName?: ValueTypes["StringCondition"] | undefined | null,
	addressLine1?: ValueTypes["StringCondition"] | undefined | null,
	addressLine2?: ValueTypes["StringCondition"] | undefined | null,
	city?: ValueTypes["StringCondition"] | undefined | null,
	postalCode?: ValueTypes["StringCondition"] | undefined | null,
	email?: ValueTypes["StringCondition"] | undefined | null,
	phone?: ValueTypes["StringCondition"] | undefined | null,
	companyName?: ValueTypes["StringCondition"] | undefined | null,
	companyIdentifier?: ValueTypes["StringCondition"] | undefined | null,
	vatIdentifier?: ValueTypes["StringCondition"] | undefined | null,
	externalIdentifier?: ValueTypes["StringCondition"] | undefined | null,
	hidden?: ValueTypes["BooleanCondition"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	deletedAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	note?: ValueTypes["StringCondition"] | undefined | null,
	internalNote?: ValueTypes["StringCondition"] | undefined | null,
	fakturoidSubjectId?: ValueTypes["StringCondition"] | undefined | null,
	country?: ValueTypes["CountryWhere"] | undefined | null,
	customer?: ValueTypes["CustomerWhere"] | undefined | null,
	invoices?: ValueTypes["InvoiceWhere"] | undefined | null,
	defaultBillingSubjectOfCustomer?: ValueTypes["CustomerWhere"] | undefined | null,
	orders?: ValueTypes["OrderWhere"] | undefined | null,
	and?: Array<ValueTypes["BillingSubjectWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["BillingSubjectWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["BillingSubjectWhere"] | undefined | null
};
	["CountryWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	code?: ValueTypes["StringCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	and?: Array<ValueTypes["CountryWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["CountryWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["CountryWhere"] | undefined | null
};
	["OrderPaymentMetadataWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	paymentUrl?: ValueTypes["StringCondition"] | undefined | null,
	orderPayment?: ValueTypes["OrderPaymentWhere"] | undefined | null,
	and?: Array<ValueTypes["OrderPaymentMetadataWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["OrderPaymentMetadataWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["OrderPaymentMetadataWhere"] | undefined | null
};
	["OrderPriceLineWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	unitPriceCents?: ValueTypes["IntCondition"] | undefined | null,
	quantity?: ValueTypes["IntCondition"] | undefined | null,
	type?: ValueTypes["OrderPriceLineTypeCondition"] | undefined | null,
	orderItem?: ValueTypes["OrderItemWhere"] | undefined | null,
	orderDiscount?: ValueTypes["OrderDiscountWhere"] | undefined | null,
	orderPayment?: ValueTypes["OrderPaymentWhere"] | undefined | null,
	orderDelivery?: ValueTypes["OrderDeliveryWhere"] | undefined | null,
	vatRatePermille?: ValueTypes["IntCondition"] | undefined | null,
	vatRate?: ValueTypes["VatRateWhere"] | undefined | null,
	order?: ValueTypes["OrderWhere"] | undefined | null,
	and?: Array<ValueTypes["OrderPriceLineWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["OrderPriceLineWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["OrderPriceLineWhere"] | undefined | null
};
	["OrderPriceLineTypeCondition"]: {
	and?: Array<ValueTypes["OrderPriceLineTypeCondition"]> | undefined | null,
	or?: Array<ValueTypes["OrderPriceLineTypeCondition"]> | undefined | null,
	not?: ValueTypes["OrderPriceLineTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["OrderPriceLineType"] | undefined | null,
	notEq?: ValueTypes["OrderPriceLineType"] | undefined | null,
	in?: Array<ValueTypes["OrderPriceLineType"]> | undefined | null,
	notIn?: Array<ValueTypes["OrderPriceLineType"]> | undefined | null,
	lt?: ValueTypes["OrderPriceLineType"] | undefined | null,
	lte?: ValueTypes["OrderPriceLineType"] | undefined | null,
	gt?: ValueTypes["OrderPriceLineType"] | undefined | null,
	gte?: ValueTypes["OrderPriceLineType"] | undefined | null
};
	["OrderPriceLineType"]:OrderPriceLineType;
	["OrderSummaryWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	totalPriceCents?: ValueTypes["IntCondition"] | undefined | null,
	discountPriceCents?: ValueTypes["IntCondition"] | undefined | null,
	undiscountedPriceCents?: ValueTypes["IntCondition"] | undefined | null,
	itemsQuantity?: ValueTypes["IntCondition"] | undefined | null,
	orderUrl?: ValueTypes["StringCondition"] | undefined | null,
	orderNumber?: ValueTypes["StringCondition"] | undefined | null,
	order?: ValueTypes["OrderWhere"] | undefined | null,
	and?: Array<ValueTypes["OrderSummaryWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["OrderSummaryWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["OrderSummaryWhere"] | undefined | null
};
	["GratuityWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	amountCents?: ValueTypes["IntCondition"] | undefined | null,
	order?: ValueTypes["OrderWhere"] | undefined | null,
	and?: Array<ValueTypes["GratuityWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["GratuityWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["GratuityWhere"] | undefined | null
};
	["AreaWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	venue?: ValueTypes["VenueWhere"] | undefined | null,
	tables?: ValueTypes["TableWhere"] | undefined | null,
	lines?: ValueTypes["LineWhere"] | undefined | null,
	and?: Array<ValueTypes["AreaWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["AreaWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["AreaWhere"] | undefined | null
};
	["TableWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	shape?: ValueTypes["TableShapeCondition"] | undefined | null,
	width?: ValueTypes["IntCondition"] | undefined | null,
	height?: ValueTypes["IntCondition"] | undefined | null,
	positionX?: ValueTypes["IntCondition"] | undefined | null,
	positionY?: ValueTypes["IntCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	color?: ValueTypes["StringCondition"] | undefined | null,
	customerTabs?: ValueTypes["CustomerTabWhere"] | undefined | null,
	area?: ValueTypes["AreaWhere"] | undefined | null,
	seats?: ValueTypes["SeatWhere"] | undefined | null,
	and?: Array<ValueTypes["TableWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["TableWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["TableWhere"] | undefined | null
};
	["TableShapeCondition"]: {
	and?: Array<ValueTypes["TableShapeCondition"]> | undefined | null,
	or?: Array<ValueTypes["TableShapeCondition"]> | undefined | null,
	not?: ValueTypes["TableShapeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["TableShape"] | undefined | null,
	notEq?: ValueTypes["TableShape"] | undefined | null,
	in?: Array<ValueTypes["TableShape"]> | undefined | null,
	notIn?: Array<ValueTypes["TableShape"]> | undefined | null,
	lt?: ValueTypes["TableShape"] | undefined | null,
	lte?: ValueTypes["TableShape"] | undefined | null,
	gt?: ValueTypes["TableShape"] | undefined | null,
	gte?: ValueTypes["TableShape"] | undefined | null
};
	["TableShape"]:TableShape;
	["CustomerTabWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	color?: ValueTypes["StringCondition"] | undefined | null,
	items?: ValueTypes["CustomerTabItemWhere"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	meta?: ValueTypes["CustomerTabMetadataWhere"] | undefined | null,
	customer?: ValueTypes["CustomerWhere"] | undefined | null,
	table?: ValueTypes["TableWhere"] | undefined | null,
	seat?: ValueTypes["SeatWhere"] | undefined | null,
	and?: Array<ValueTypes["CustomerTabWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["CustomerTabWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["CustomerTabWhere"] | undefined | null
};
	["CustomerTabItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	addedAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	tab?: ValueTypes["CustomerTabWhere"] | undefined | null,
	product?: ValueTypes["ProductWhere"] | undefined | null,
	paidAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	and?: Array<ValueTypes["CustomerTabItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["CustomerTabItemWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["CustomerTabItemWhere"] | undefined | null
};
	["CustomerTabMetadataWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	totalPriceCents?: ValueTypes["IntCondition"] | undefined | null,
	totalSpentCents?: ValueTypes["IntCondition"] | undefined | null,
	unpaidCents?: ValueTypes["IntCondition"] | undefined | null,
	customerTab?: ValueTypes["CustomerTabWhere"] | undefined | null,
	and?: Array<ValueTypes["CustomerTabMetadataWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["CustomerTabMetadataWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["CustomerTabMetadataWhere"] | undefined | null
};
	["SeatWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	positionX?: ValueTypes["IntCondition"] | undefined | null,
	positionY?: ValueTypes["IntCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	color?: ValueTypes["StringCondition"] | undefined | null,
	customerTabs?: ValueTypes["CustomerTabWhere"] | undefined | null,
	table?: ValueTypes["TableWhere"] | undefined | null,
	and?: Array<ValueTypes["SeatWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["SeatWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["SeatWhere"] | undefined | null
};
	["LineWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	positionStartX?: ValueTypes["IntCondition"] | undefined | null,
	positionStartY?: ValueTypes["IntCondition"] | undefined | null,
	positionEndX?: ValueTypes["IntCondition"] | undefined | null,
	positionEndY?: ValueTypes["IntCondition"] | undefined | null,
	area?: ValueTypes["AreaWhere"] | undefined | null,
	and?: Array<ValueTypes["LineWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["LineWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["LineWhere"] | undefined | null
};
	["PointOfSaleInitialViewCondition"]: {
	and?: Array<ValueTypes["PointOfSaleInitialViewCondition"]> | undefined | null,
	or?: Array<ValueTypes["PointOfSaleInitialViewCondition"]> | undefined | null,
	not?: ValueTypes["PointOfSaleInitialViewCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["PointOfSaleInitialView"] | undefined | null,
	notEq?: ValueTypes["PointOfSaleInitialView"] | undefined | null,
	in?: Array<ValueTypes["PointOfSaleInitialView"]> | undefined | null,
	notIn?: Array<ValueTypes["PointOfSaleInitialView"]> | undefined | null,
	lt?: ValueTypes["PointOfSaleInitialView"] | undefined | null,
	lte?: ValueTypes["PointOfSaleInitialView"] | undefined | null,
	gt?: ValueTypes["PointOfSaleInitialView"] | undefined | null,
	gte?: ValueTypes["PointOfSaleInitialView"] | undefined | null
};
	["PointOfSaleInitialView"]:PointOfSaleInitialView;
	["CartStateCondition"]: {
	and?: Array<ValueTypes["CartStateCondition"]> | undefined | null,
	or?: Array<ValueTypes["CartStateCondition"]> | undefined | null,
	not?: ValueTypes["CartStateCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["CartState"] | undefined | null,
	notEq?: ValueTypes["CartState"] | undefined | null,
	in?: Array<ValueTypes["CartState"]> | undefined | null,
	notIn?: Array<ValueTypes["CartState"]> | undefined | null,
	lt?: ValueTypes["CartState"] | undefined | null,
	lte?: ValueTypes["CartState"] | undefined | null,
	gt?: ValueTypes["CartState"] | undefined | null,
	gte?: ValueTypes["CartState"] | undefined | null
};
	["CartState"]:CartState;
	["CartPriceLineWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	type?: ValueTypes["CartPriceLineTypeCondition"] | undefined | null,
	item?: ValueTypes["CartItemWhere"] | undefined | null,
	product?: ValueTypes["ProductWhere"] | undefined | null,
	unitPriceCents?: ValueTypes["IntCondition"] | undefined | null,
	priceCents?: ValueTypes["IntCondition"] | undefined | null,
	quantity?: ValueTypes["IntCondition"] | undefined | null,
	vatRatePermille?: ValueTypes["IntCondition"] | undefined | null,
	vatRate?: ValueTypes["VatRateWhere"] | undefined | null,
	cart?: ValueTypes["CartWhere"] | undefined | null,
	and?: Array<ValueTypes["CartPriceLineWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["CartPriceLineWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["CartPriceLineWhere"] | undefined | null
};
	["CartPriceLineTypeCondition"]: {
	and?: Array<ValueTypes["CartPriceLineTypeCondition"]> | undefined | null,
	or?: Array<ValueTypes["CartPriceLineTypeCondition"]> | undefined | null,
	not?: ValueTypes["CartPriceLineTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["CartPriceLineType"] | undefined | null,
	notEq?: ValueTypes["CartPriceLineType"] | undefined | null,
	in?: Array<ValueTypes["CartPriceLineType"]> | undefined | null,
	notIn?: Array<ValueTypes["CartPriceLineType"]> | undefined | null,
	lt?: ValueTypes["CartPriceLineType"] | undefined | null,
	lte?: ValueTypes["CartPriceLineType"] | undefined | null,
	gt?: ValueTypes["CartPriceLineType"] | undefined | null,
	gte?: ValueTypes["CartPriceLineType"] | undefined | null
};
	["CartPriceLineType"]:CartPriceLineType;
	["CartSummaryWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	itemsPriceCents?: ValueTypes["IntCondition"] | undefined | null,
	deliveryPriceCents?: ValueTypes["IntCondition"] | undefined | null,
	totalPriceCents?: ValueTypes["IntCondition"] | undefined | null,
	itemsCount?: ValueTypes["IntCondition"] | undefined | null,
	itemsQuantity?: ValueTypes["IntCondition"] | undefined | null,
	checkoutUrl?: ValueTypes["StringCondition"] | undefined | null,
	cart?: ValueTypes["CartWhere"] | undefined | null,
	and?: Array<ValueTypes["CartSummaryWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["CartSummaryWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["CartSummaryWhere"] | undefined | null
};
	["ChannelCodeCondition"]: {
	and?: Array<ValueTypes["ChannelCodeCondition"]> | undefined | null,
	or?: Array<ValueTypes["ChannelCodeCondition"]> | undefined | null,
	not?: ValueTypes["ChannelCodeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["ChannelCode"] | undefined | null,
	notEq?: ValueTypes["ChannelCode"] | undefined | null,
	in?: Array<ValueTypes["ChannelCode"]> | undefined | null,
	notIn?: Array<ValueTypes["ChannelCode"]> | undefined | null,
	lt?: ValueTypes["ChannelCode"] | undefined | null,
	lte?: ValueTypes["ChannelCode"] | undefined | null,
	gt?: ValueTypes["ChannelCode"] | undefined | null,
	gte?: ValueTypes["ChannelCode"] | undefined | null
};
	["ChannelCode"]:ChannelCode;
	["VatRatePresetCondition"]: {
	and?: Array<ValueTypes["VatRatePresetCondition"]> | undefined | null,
	or?: Array<ValueTypes["VatRatePresetCondition"]> | undefined | null,
	not?: ValueTypes["VatRatePresetCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["VatRatePreset"] | undefined | null,
	notEq?: ValueTypes["VatRatePreset"] | undefined | null,
	in?: Array<ValueTypes["VatRatePreset"]> | undefined | null,
	notIn?: Array<ValueTypes["VatRatePreset"]> | undefined | null,
	lt?: ValueTypes["VatRatePreset"] | undefined | null,
	lte?: ValueTypes["VatRatePreset"] | undefined | null,
	gt?: ValueTypes["VatRatePreset"] | undefined | null,
	gte?: ValueTypes["VatRatePreset"] | undefined | null
};
	["VatRatePreset"]:VatRatePreset;
	["OrderDeliveryStateCondition"]: {
	and?: Array<ValueTypes["OrderDeliveryStateCondition"]> | undefined | null,
	or?: Array<ValueTypes["OrderDeliveryStateCondition"]> | undefined | null,
	not?: ValueTypes["OrderDeliveryStateCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["OrderDeliveryState"] | undefined | null,
	notEq?: ValueTypes["OrderDeliveryState"] | undefined | null,
	in?: Array<ValueTypes["OrderDeliveryState"]> | undefined | null,
	notIn?: Array<ValueTypes["OrderDeliveryState"]> | undefined | null,
	lt?: ValueTypes["OrderDeliveryState"] | undefined | null,
	lte?: ValueTypes["OrderDeliveryState"] | undefined | null,
	gt?: ValueTypes["OrderDeliveryState"] | undefined | null,
	gte?: ValueTypes["OrderDeliveryState"] | undefined | null
};
	["OrderDeliveryState"]:OrderDeliveryState;
	["LiftagoRideWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	liftagoId?: ValueTypes["StringCondition"] | undefined | null,
	data?: ValueTypes["StringCondition"] | undefined | null,
	updatedAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	delivery?: ValueTypes["OrderDeliveryWhere"] | undefined | null,
	and?: Array<ValueTypes["LiftagoRideWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["LiftagoRideWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["LiftagoRideWhere"] | undefined | null
};
	["WoltDriveDeliveryWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	state?: ValueTypes["WoltDriveDeliveryStateCondition"] | undefined | null,
	shipmentPromiseId?: ValueTypes["StringCondition"] | undefined | null,
	deliveryPrice?: ValueTypes["IntCondition"] | undefined | null,
	deliveryPriceCurrency?: ValueTypes["StringCondition"] | undefined | null,
	shipmentPromiseResponse?: ValueTypes["StringCondition"] | undefined | null,
	deliveryOrderId?: ValueTypes["StringCondition"] | undefined | null,
	trackingUrl?: ValueTypes["StringCondition"] | undefined | null,
	deliverOrderResponse?: ValueTypes["StringCondition"] | undefined | null,
	delivery?: ValueTypes["OrderDeliveryWhere"] | undefined | null,
	and?: Array<ValueTypes["WoltDriveDeliveryWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["WoltDriveDeliveryWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["WoltDriveDeliveryWhere"] | undefined | null
};
	["WoltDriveDeliveryStateCondition"]: {
	and?: Array<ValueTypes["WoltDriveDeliveryStateCondition"]> | undefined | null,
	or?: Array<ValueTypes["WoltDriveDeliveryStateCondition"]> | undefined | null,
	not?: ValueTypes["WoltDriveDeliveryStateCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["WoltDriveDeliveryState"] | undefined | null,
	notEq?: ValueTypes["WoltDriveDeliveryState"] | undefined | null,
	in?: Array<ValueTypes["WoltDriveDeliveryState"]> | undefined | null,
	notIn?: Array<ValueTypes["WoltDriveDeliveryState"]> | undefined | null,
	lt?: ValueTypes["WoltDriveDeliveryState"] | undefined | null,
	lte?: ValueTypes["WoltDriveDeliveryState"] | undefined | null,
	gt?: ValueTypes["WoltDriveDeliveryState"] | undefined | null,
	gte?: ValueTypes["WoltDriveDeliveryState"] | undefined | null
};
	["WoltDriveDeliveryState"]:WoltDriveDeliveryState;
	["CleanerWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	staff?: ValueTypes["StaffWhere"] | undefined | null,
	canReachTopShelf?: ValueTypes["BooleanCondition"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	and?: Array<ValueTypes["CleanerWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["CleanerWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["CleanerWhere"] | undefined | null
};
	["StocksManagerWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	staff?: ValueTypes["StaffWhere"] | undefined | null,
	managedProducts?: ValueTypes["ProductWhere"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	and?: Array<ValueTypes["StocksManagerWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["StocksManagerWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["StocksManagerWhere"] | undefined | null
};
	["CourierManagerWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	staff?: ValueTypes["StaffWhere"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	and?: Array<ValueTypes["CourierManagerWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["CourierManagerWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["CourierManagerWhere"] | undefined | null
};
	["PickerWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	staff?: ValueTypes["StaffWhere"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	and?: Array<ValueTypes["PickerWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["PickerWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["PickerWhere"] | undefined | null
};
	["RemunerationProfileWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	employmentInformation?: ValueTypes["EmploymentInformationWhere"] | undefined | null,
	workMonths?: ValueTypes["WorkMonthWhere"] | undefined | null,
	staff?: ValueTypes["StaffWhere"] | undefined | null,
	and?: Array<ValueTypes["RemunerationProfileWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["RemunerationProfileWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["RemunerationProfileWhere"] | undefined | null
};
	["EmploymentInformationWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	hourlyRate?: ValueTypes["IntCondition"] | undefined | null,
	remunerationProfiles?: ValueTypes["RemunerationProfileWhere"] | undefined | null,
	monthlySalary?: ValueTypes["IntCondition"] | undefined | null,
	type?: ValueTypes["EmploymentTypeCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	and?: Array<ValueTypes["EmploymentInformationWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["EmploymentInformationWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["EmploymentInformationWhere"] | undefined | null
};
	["EmploymentTypeCondition"]: {
	and?: Array<ValueTypes["EmploymentTypeCondition"]> | undefined | null,
	or?: Array<ValueTypes["EmploymentTypeCondition"]> | undefined | null,
	not?: ValueTypes["EmploymentTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["EmploymentType"] | undefined | null,
	notEq?: ValueTypes["EmploymentType"] | undefined | null,
	in?: Array<ValueTypes["EmploymentType"]> | undefined | null,
	notIn?: Array<ValueTypes["EmploymentType"]> | undefined | null,
	lt?: ValueTypes["EmploymentType"] | undefined | null,
	lte?: ValueTypes["EmploymentType"] | undefined | null,
	gt?: ValueTypes["EmploymentType"] | undefined | null,
	gte?: ValueTypes["EmploymentType"] | undefined | null
};
	["EmploymentType"]:EmploymentType;
	["WorkMonthWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	year?: ValueTypes["IntCondition"] | undefined | null,
	month?: ValueTypes["IntCondition"] | undefined | null,
	hoursWorked?: ValueTypes["FloatCondition"] | undefined | null,
	billableHours?: ValueTypes["FloatCondition"] | undefined | null,
	remunerationProfile?: ValueTypes["RemunerationProfileWhere"] | undefined | null,
	and?: Array<ValueTypes["WorkMonthWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["WorkMonthWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["WorkMonthWhere"] | undefined | null
};
	["CashierWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	staff?: ValueTypes["StaffWhere"] | undefined | null,
	and?: Array<ValueTypes["CashierWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["CashierWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["CashierWhere"] | undefined | null
};
	["InternalBuyerWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	staff?: ValueTypes["StaffWhere"] | undefined | null,
	and?: Array<ValueTypes["InternalBuyerWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["InternalBuyerWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["InternalBuyerWhere"] | undefined | null
};
	["SalesManagerWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	staff?: ValueTypes["StaffWhere"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	countries?: ValueTypes["CountryWhere"] | undefined | null,
	and?: Array<ValueTypes["SalesManagerWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["SalesManagerWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["SalesManagerWhere"] | undefined | null
};
	["CashierManagerWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	staff?: ValueTypes["StaffWhere"] | undefined | null,
	and?: Array<ValueTypes["CashierManagerWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["CashierManagerWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["CashierManagerWhere"] | undefined | null
};
	["BusinessServiceEventWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	fulfilledAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	businessCustomer?: ValueTypes["BusinessCustomerWhere"] | undefined | null,
	businessService?: ValueTypes["BusinessServiceWhere"] | undefined | null,
	filledNumberOfPeople?: ValueTypes["IntCondition"] | undefined | null,
	filledInvoiced?: ValueTypes["BooleanCondition"] | undefined | null,
	filledEquipment?: ValueTypes["StringCondition"] | undefined | null,
	filledMillTamDem?: ValueTypes["BooleanCondition"] | undefined | null,
	filledSOEspresso?: ValueTypes["BooleanCondition"] | undefined | null,
	filledFilterCoffeeInMenu?: ValueTypes["BooleanCondition"] | undefined | null,
	filledWaterMeterStatus?: ValueTypes["StringCondition"] | undefined | null,
	filledServiceAction?: ValueTypes["StringCondition"] | undefined | null,
	filledInvoiceIdentifier?: ValueTypes["StringCondition"] | undefined | null,
	filledNote?: ValueTypes["StringCondition"] | undefined | null,
	filledContact?: ValueTypes["StringCondition"] | undefined | null,
	filledPhone?: ValueTypes["BooleanCondition"] | undefined | null,
	filledEmail?: ValueTypes["BooleanCondition"] | undefined | null,
	filledGrindingStonesCondition?: ValueTypes["StringCondition"] | undefined | null,
	createdBy?: ValueTypes["StaffWhere"] | undefined | null,
	filledSupervisor?: ValueTypes["StaffWhere"] | undefined | null,
	and?: Array<ValueTypes["BusinessServiceEventWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["BusinessServiceEventWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["BusinessServiceEventWhere"] | undefined | null
};
	["BusinessServiceWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	requireNote?: ValueTypes["IntCondition"] | undefined | null,
	locales?: ValueTypes["BusinessServiceLocaleWhere"] | undefined | null,
	requireNumberOfPeople?: ValueTypes["IntCondition"] | undefined | null,
	requireInvoiced?: ValueTypes["IntCondition"] | undefined | null,
	requireEquipment?: ValueTypes["IntCondition"] | undefined | null,
	requireMillTamDem?: ValueTypes["IntCondition"] | undefined | null,
	requireSOEspresso?: ValueTypes["IntCondition"] | undefined | null,
	requireFilterCoffeeInMenu?: ValueTypes["IntCondition"] | undefined | null,
	requireWaterMeterStatus?: ValueTypes["IntCondition"] | undefined | null,
	requireServiceAction?: ValueTypes["IntCondition"] | undefined | null,
	optionsEquipment?: ValueTypes["StringCondition"] | undefined | null,
	optionsServiceAction?: ValueTypes["StringCondition"] | undefined | null,
	requireInvoiceIdentifier?: ValueTypes["IntCondition"] | undefined | null,
	requireSupervisor?: ValueTypes["IntCondition"] | undefined | null,
	requireContact?: ValueTypes["IntCondition"] | undefined | null,
	requirePhone?: ValueTypes["IntCondition"] | undefined | null,
	requireEmail?: ValueTypes["IntCondition"] | undefined | null,
	requireGrindingStonesCondition?: ValueTypes["IntCondition"] | undefined | null,
	and?: Array<ValueTypes["BusinessServiceWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["BusinessServiceWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["BusinessServiceWhere"] | undefined | null
};
	["BusinessServiceLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	labelNote?: ValueTypes["StringCondition"] | undefined | null,
	root?: ValueTypes["BusinessServiceWhere"] | undefined | null,
	locale?: ValueTypes["LocaleWhere"] | undefined | null,
	labelNumberOfPeople?: ValueTypes["StringCondition"] | undefined | null,
	labelInvoiced?: ValueTypes["StringCondition"] | undefined | null,
	labelEquipment?: ValueTypes["StringCondition"] | undefined | null,
	labelMillTamDem?: ValueTypes["StringCondition"] | undefined | null,
	labelSOEspresso?: ValueTypes["StringCondition"] | undefined | null,
	labelFilterCoffeeInMenu?: ValueTypes["StringCondition"] | undefined | null,
	labelWaterMeterStatus?: ValueTypes["StringCondition"] | undefined | null,
	labelServiceAction?: ValueTypes["StringCondition"] | undefined | null,
	labelInvoiceIdentifier?: ValueTypes["StringCondition"] | undefined | null,
	labelSupervisor?: ValueTypes["StringCondition"] | undefined | null,
	labelContact?: ValueTypes["StringCondition"] | undefined | null,
	labelPhone?: ValueTypes["StringCondition"] | undefined | null,
	labelEmail?: ValueTypes["StringCondition"] | undefined | null,
	labelGrindingStonesCondition?: ValueTypes["StringCondition"] | undefined | null,
	and?: Array<ValueTypes["BusinessServiceLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["BusinessServiceLocaleWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["BusinessServiceLocaleWhere"] | undefined | null
};
	["DoubleshotCoffeeEquipmentWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	espressoMachine?: ValueTypes["StringCondition"] | undefined | null,
	espressoGrinder?: ValueTypes["StringCondition"] | undefined | null,
	batchBrew?: ValueTypes["StringCondition"] | undefined | null,
	batchGrinder?: ValueTypes["StringCondition"] | undefined | null,
	waterFilter?: ValueTypes["StringCondition"] | undefined | null,
	mechanicalFilter?: ValueTypes["StringCondition"] | undefined | null,
	and?: Array<ValueTypes["DoubleshotCoffeeEquipmentWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["DoubleshotCoffeeEquipmentWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["DoubleshotCoffeeEquipmentWhere"] | undefined | null
};
	["OrderRecurrenceWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	internalName?: ValueTypes["StringCondition"] | undefined | null,
	locales?: ValueTypes["OrderRecurrenceLocaleWhere"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	businessCategory?: ValueTypes["BusinessCategoryWhere"] | undefined | null,
	and?: Array<ValueTypes["OrderRecurrenceWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["OrderRecurrenceWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["OrderRecurrenceWhere"] | undefined | null
};
	["OrderRecurrenceLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	root?: ValueTypes["OrderRecurrenceWhere"] | undefined | null,
	locale?: ValueTypes["LocaleWhere"] | undefined | null,
	and?: Array<ValueTypes["OrderRecurrenceLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["OrderRecurrenceLocaleWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["OrderRecurrenceLocaleWhere"] | undefined | null
};
	["ProductListWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	items?: ValueTypes["ProductListItemWhere"] | undefined | null,
	businessCategory?: ValueTypes["BusinessCategoryWhere"] | undefined | null,
	and?: Array<ValueTypes["ProductListWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ProductListWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ProductListWhere"] | undefined | null
};
	["ProductListItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	list?: ValueTypes["ProductListWhere"] | undefined | null,
	product?: ValueTypes["ProductWhere"] | undefined | null,
	defaultQuantityForOrder?: ValueTypes["IntCondition"] | undefined | null,
	and?: Array<ValueTypes["ProductListItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ProductListItemWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ProductListItemWhere"] | undefined | null
};
	["ProductCategoryListWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	items?: ValueTypes["ProductCategoryListItemWhere"] | undefined | null,
	locales?: ValueTypes["ProductCategoryListLocaleWhere"] | undefined | null,
	seasonalProductCategoriesOfBusinessCategory?: ValueTypes["BusinessCategoryWhere"] | undefined | null,
	specificProductsProductCategoriesOfBusinessCategory?: ValueTypes["BusinessCategoryWhere"] | undefined | null,
	and?: Array<ValueTypes["ProductCategoryListWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ProductCategoryListWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ProductCategoryListWhere"] | undefined | null
};
	["ProductCategoryListItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	list?: ValueTypes["ProductCategoryListWhere"] | undefined | null,
	productCategory?: ValueTypes["ProductCategoryWhere"] | undefined | null,
	showRecipeImages?: ValueTypes["BooleanCondition"] | undefined | null,
	showPackingImages?: ValueTypes["BooleanCondition"] | undefined | null,
	showAllAvailableProducts?: ValueTypes["BooleanCondition"] | undefined | null,
	and?: Array<ValueTypes["ProductCategoryListItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ProductCategoryListItemWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ProductCategoryListItemWhere"] | undefined | null
};
	["ProductCategoryListLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	root?: ValueTypes["ProductCategoryListWhere"] | undefined | null,
	locale?: ValueTypes["LocaleWhere"] | undefined | null,
	and?: Array<ValueTypes["ProductCategoryListLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ProductCategoryListLocaleWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ProductCategoryListLocaleWhere"] | undefined | null
};
	["ProductIngredientLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	root?: ValueTypes["ProductIngredientWhere"] | undefined | null,
	locale?: ValueTypes["LocaleWhere"] | undefined | null,
	and?: Array<ValueTypes["ProductIngredientLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ProductIngredientLocaleWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ProductIngredientLocaleWhere"] | undefined | null
};
	["ProductIngredientWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	internalNote?: ValueTypes["StringCondition"] | undefined | null,
	locales?: ValueTypes["ProductIngredientLocaleWhere"] | undefined | null,
	internalName?: ValueTypes["StringCondition"] | undefined | null,
	categories?: ValueTypes["ProductIngredientCategoryWhere"] | undefined | null,
	allergens?: ValueTypes["AllergenWhere"] | undefined | null,
	needsPrepping?: ValueTypes["BooleanCondition"] | undefined | null,
	allowCustomerRating?: ValueTypes["BooleanCondition"] | undefined | null,
	customerRatings?: ValueTypes["CustomerIngredientRatingWhere"] | undefined | null,
	preferredQuantityUnit?: ValueTypes["ProductIngredientItemQuantityUnitWhere"] | undefined | null,
	freshingContainer?: ValueTypes["FreshingContainerWhere"] | undefined | null,
	image?: ValueTypes["ImageWhere"] | undefined | null,
	suppliers?: ValueTypes["IngredientSupplierListWhere"] | undefined | null,
	incrementQuantityNumber?: ValueTypes["FloatCondition"] | undefined | null,
	and?: Array<ValueTypes["ProductIngredientWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ProductIngredientWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ProductIngredientWhere"] | undefined | null
};
	["ProductIngredientCategoryWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	internalName?: ValueTypes["StringCondition"] | undefined | null,
	internalNote?: ValueTypes["StringCondition"] | undefined | null,
	ingredients?: ValueTypes["ProductIngredientWhere"] | undefined | null,
	locales?: ValueTypes["ProductIngredientCategoryLocaleWhere"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	and?: Array<ValueTypes["ProductIngredientCategoryWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ProductIngredientCategoryWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ProductIngredientCategoryWhere"] | undefined | null
};
	["ProductIngredientCategoryLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	root?: ValueTypes["ProductIngredientCategoryWhere"] | undefined | null,
	locale?: ValueTypes["LocaleWhere"] | undefined | null,
	and?: Array<ValueTypes["ProductIngredientCategoryLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ProductIngredientCategoryLocaleWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ProductIngredientCategoryLocaleWhere"] | undefined | null
};
	["AllergenWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	internalName?: ValueTypes["StringCondition"] | undefined | null,
	locales?: ValueTypes["AllergenLocaleWhere"] | undefined | null,
	ingredients?: ValueTypes["ProductIngredientWhere"] | undefined | null,
	code?: ValueTypes["IntCondition"] | undefined | null,
	and?: Array<ValueTypes["AllergenWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["AllergenWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["AllergenWhere"] | undefined | null
};
	["AllergenLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	root?: ValueTypes["AllergenWhere"] | undefined | null,
	locale?: ValueTypes["LocaleWhere"] | undefined | null,
	and?: Array<ValueTypes["AllergenLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["AllergenLocaleWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["AllergenLocaleWhere"] | undefined | null
};
	["CustomerIngredientRatingWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	customer?: ValueTypes["CustomerWhere"] | undefined | null,
	rating?: ValueTypes["ProductIngredientRatingWhere"] | undefined | null,
	ingredient?: ValueTypes["ProductIngredientWhere"] | undefined | null,
	and?: Array<ValueTypes["CustomerIngredientRatingWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["CustomerIngredientRatingWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["CustomerIngredientRatingWhere"] | undefined | null
};
	["ProductIngredientRatingWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	icon?: ValueTypes["ImageWhere"] | undefined | null,
	and?: Array<ValueTypes["ProductIngredientRatingWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ProductIngredientRatingWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ProductIngredientRatingWhere"] | undefined | null
};
	["ProductIngredientItemQuantityUnitWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	and?: Array<ValueTypes["ProductIngredientItemQuantityUnitWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ProductIngredientItemQuantityUnitWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ProductIngredientItemQuantityUnitWhere"] | undefined | null
};
	["FreshingContainerWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	volumeMl?: ValueTypes["IntCondition"] | undefined | null,
	workspace?: ValueTypes["WorkspaceWhere"] | undefined | null,
	and?: Array<ValueTypes["FreshingContainerWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["FreshingContainerWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["FreshingContainerWhere"] | undefined | null
};
	["WorkspaceWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	unique?: ValueTypes["OneCondition"] | undefined | null,
	orderDeadlineTime?: ValueTypes["StringCondition"] | undefined | null,
	ordersLoadingDurationHours?: ValueTypes["IntCondition"] | undefined | null,
	freshingContainerVolumeMl?: ValueTypes["IntCondition"] | undefined | null,
	freshingPrepareOrderByOffsetMinutes?: ValueTypes["IntCondition"] | undefined | null,
	checkoutUrlTemplate?: ValueTypes["StringCondition"] | undefined | null,
	orderUrlTemplate?: ValueTypes["StringCondition"] | undefined | null,
	paymentUrlTemplate?: ValueTypes["StringCondition"] | undefined | null,
	customerProfileUrlTemplate?: ValueTypes["StringCondition"] | undefined | null,
	userProfileUrlTemplate?: ValueTypes["StringCondition"] | undefined | null,
	messengerUrl?: ValueTypes["StringCondition"] | undefined | null,
	messengerIosUrl?: ValueTypes["StringCondition"] | undefined | null,
	messengerAndroidUrl?: ValueTypes["StringCondition"] | undefined | null,
	freshingContainers?: ValueTypes["FreshingContainerWhere"] | undefined | null,
	openingHours?: ValueTypes["WeekHoursWhere"] | undefined | null,
	workingHours?: ValueTypes["WeekHoursWhere"] | undefined | null,
	defaultFreshingContainer?: ValueTypes["FreshingContainerWhere"] | undefined | null,
	creditsProduct?: ValueTypes["VirtualProductWhere"] | undefined | null,
	discountVatRate?: ValueTypes["VatRateWhere"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	businessAddress?: ValueTypes["StringCondition"] | undefined | null,
	and?: Array<ValueTypes["WorkspaceWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["WorkspaceWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["WorkspaceWhere"] | undefined | null
};
	["OneCondition"]: {
	and?: Array<ValueTypes["OneCondition"]> | undefined | null,
	or?: Array<ValueTypes["OneCondition"]> | undefined | null,
	not?: ValueTypes["OneCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["One"] | undefined | null,
	notEq?: ValueTypes["One"] | undefined | null,
	in?: Array<ValueTypes["One"]> | undefined | null,
	notIn?: Array<ValueTypes["One"]> | undefined | null,
	lt?: ValueTypes["One"] | undefined | null,
	lte?: ValueTypes["One"] | undefined | null,
	gt?: ValueTypes["One"] | undefined | null,
	gte?: ValueTypes["One"] | undefined | null
};
	["One"]:One;
	["WeekHoursWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	mon?: ValueTypes["StringCondition"] | undefined | null,
	tue?: ValueTypes["StringCondition"] | undefined | null,
	wed?: ValueTypes["StringCondition"] | undefined | null,
	thu?: ValueTypes["StringCondition"] | undefined | null,
	fri?: ValueTypes["StringCondition"] | undefined | null,
	sat?: ValueTypes["StringCondition"] | undefined | null,
	sun?: ValueTypes["StringCondition"] | undefined | null,
	and?: Array<ValueTypes["WeekHoursWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["WeekHoursWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["WeekHoursWhere"] | undefined | null
};
	["VirtualProductWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	type?: ValueTypes["VirtualProductTypeCondition"] | undefined | null,
	product?: ValueTypes["ProductWhere"] | undefined | null,
	voucherCreditCents?: ValueTypes["IntCondition"] | undefined | null,
	physicalRepresentation?: ValueTypes["VirtualProductPhysicalRepresentationTypeCondition"] | undefined | null,
	recipientEmail?: ValueTypes["BooleanCondition"] | undefined | null,
	and?: Array<ValueTypes["VirtualProductWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["VirtualProductWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["VirtualProductWhere"] | undefined | null
};
	["VirtualProductTypeCondition"]: {
	and?: Array<ValueTypes["VirtualProductTypeCondition"]> | undefined | null,
	or?: Array<ValueTypes["VirtualProductTypeCondition"]> | undefined | null,
	not?: ValueTypes["VirtualProductTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["VirtualProductType"] | undefined | null,
	notEq?: ValueTypes["VirtualProductType"] | undefined | null,
	in?: Array<ValueTypes["VirtualProductType"]> | undefined | null,
	notIn?: Array<ValueTypes["VirtualProductType"]> | undefined | null,
	lt?: ValueTypes["VirtualProductType"] | undefined | null,
	lte?: ValueTypes["VirtualProductType"] | undefined | null,
	gt?: ValueTypes["VirtualProductType"] | undefined | null,
	gte?: ValueTypes["VirtualProductType"] | undefined | null
};
	["VirtualProductType"]:VirtualProductType;
	["VirtualProductPhysicalRepresentationTypeCondition"]: {
	and?: Array<ValueTypes["VirtualProductPhysicalRepresentationTypeCondition"]> | undefined | null,
	or?: Array<ValueTypes["VirtualProductPhysicalRepresentationTypeCondition"]> | undefined | null,
	not?: ValueTypes["VirtualProductPhysicalRepresentationTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["VirtualProductPhysicalRepresentationType"] | undefined | null,
	notEq?: ValueTypes["VirtualProductPhysicalRepresentationType"] | undefined | null,
	in?: Array<ValueTypes["VirtualProductPhysicalRepresentationType"]> | undefined | null,
	notIn?: Array<ValueTypes["VirtualProductPhysicalRepresentationType"]> | undefined | null,
	lt?: ValueTypes["VirtualProductPhysicalRepresentationType"] | undefined | null,
	lte?: ValueTypes["VirtualProductPhysicalRepresentationType"] | undefined | null,
	gt?: ValueTypes["VirtualProductPhysicalRepresentationType"] | undefined | null,
	gte?: ValueTypes["VirtualProductPhysicalRepresentationType"] | undefined | null
};
	["VirtualProductPhysicalRepresentationType"]:VirtualProductPhysicalRepresentationType;
	["IngredientSupplierListWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	items?: ValueTypes["IngredientSupplierItemWhere"] | undefined | null,
	and?: Array<ValueTypes["IngredientSupplierListWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["IngredientSupplierListWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["IngredientSupplierListWhere"] | undefined | null
};
	["IngredientSupplierItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	list?: ValueTypes["IngredientSupplierListWhere"] | undefined | null,
	supplier?: ValueTypes["IngredientSupplierWhere"] | undefined | null,
	and?: Array<ValueTypes["IngredientSupplierItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["IngredientSupplierItemWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["IngredientSupplierItemWhere"] | undefined | null
};
	["IngredientSupplierWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	internalName?: ValueTypes["StringCondition"] | undefined | null,
	internalNote?: ValueTypes["StringCondition"] | undefined | null,
	locales?: ValueTypes["IngredientSupplierLocaleWhere"] | undefined | null,
	and?: Array<ValueTypes["IngredientSupplierWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["IngredientSupplierWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["IngredientSupplierWhere"] | undefined | null
};
	["IngredientSupplierLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	root?: ValueTypes["IngredientSupplierWhere"] | undefined | null,
	locale?: ValueTypes["LocaleWhere"] | undefined | null,
	and?: Array<ValueTypes["IngredientSupplierLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["IngredientSupplierLocaleWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["IngredientSupplierLocaleWhere"] | undefined | null
};
	["BlogLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	pageName?: ValueTypes["StringCondition"] | undefined | null,
	title?: ValueTypes["StringCondition"] | undefined | null,
	lead?: ValueTypes["StringCondition"] | undefined | null,
	root?: ValueTypes["BlogWhere"] | undefined | null,
	locale?: ValueTypes["LocaleWhere"] | undefined | null,
	and?: Array<ValueTypes["BlogLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["BlogLocaleWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["BlogLocaleWhere"] | undefined | null
};
	["BlogWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	unique?: ValueTypes["OneCondition"] | undefined | null,
	locales?: ValueTypes["BlogLocaleWhere"] | undefined | null,
	and?: Array<ValueTypes["BlogWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["BlogWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["BlogWhere"] | undefined | null
};
	["BlogPostLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	title?: ValueTypes["StringCondition"] | undefined | null,
	availableForWeb?: ValueTypes["BooleanCondition"] | undefined | null,
	availableForMobile?: ValueTypes["BooleanCondition"] | undefined | null,
	root?: ValueTypes["BlogPostWhere"] | undefined | null,
	locale?: ValueTypes["LocaleWhere"] | undefined | null,
	cover?: ValueTypes["CoverWhere"] | undefined | null,
	content?: ValueTypes["ContentWhere"] | undefined | null,
	link?: ValueTypes["LinkableWhere"] | undefined | null,
	seo?: ValueTypes["SeoWhere"] | undefined | null,
	products?: ValueTypes["ProductWhere"] | undefined | null,
	and?: Array<ValueTypes["BlogPostLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["BlogPostLocaleWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["BlogPostLocaleWhere"] | undefined | null
};
	["BlogPostWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	locales?: ValueTypes["BlogPostLocaleWhere"] | undefined | null,
	and?: Array<ValueTypes["BlogPostWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["BlogPostWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["BlogPostWhere"] | undefined | null
};
	["CoverWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	primaryTitle?: ValueTypes["StringCondition"] | undefined | null,
	secondaryTitle?: ValueTypes["StringCondition"] | undefined | null,
	medium?: ValueTypes["MediumWhere"] | undefined | null,
	buttonColors?: ValueTypes["ColorPalleteWhere"] | undefined | null,
	and?: Array<ValueTypes["CoverWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["CoverWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["CoverWhere"] | undefined | null
};
	["MediumWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	type?: ValueTypes["MediumTypeCondition"] | undefined | null,
	colorTheme?: ValueTypes["ColorThemeCondition"] | undefined | null,
	image?: ValueTypes["ImageWhere"] | undefined | null,
	video?: ValueTypes["VideoWhere"] | undefined | null,
	and?: Array<ValueTypes["MediumWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["MediumWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["MediumWhere"] | undefined | null
};
	["MediumTypeCondition"]: {
	and?: Array<ValueTypes["MediumTypeCondition"]> | undefined | null,
	or?: Array<ValueTypes["MediumTypeCondition"]> | undefined | null,
	not?: ValueTypes["MediumTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["MediumType"] | undefined | null,
	notEq?: ValueTypes["MediumType"] | undefined | null,
	in?: Array<ValueTypes["MediumType"]> | undefined | null,
	notIn?: Array<ValueTypes["MediumType"]> | undefined | null,
	lt?: ValueTypes["MediumType"] | undefined | null,
	lte?: ValueTypes["MediumType"] | undefined | null,
	gt?: ValueTypes["MediumType"] | undefined | null,
	gte?: ValueTypes["MediumType"] | undefined | null
};
	["MediumType"]:MediumType;
	["ColorThemeCondition"]: {
	and?: Array<ValueTypes["ColorThemeCondition"]> | undefined | null,
	or?: Array<ValueTypes["ColorThemeCondition"]> | undefined | null,
	not?: ValueTypes["ColorThemeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["ColorTheme"] | undefined | null,
	notEq?: ValueTypes["ColorTheme"] | undefined | null,
	in?: Array<ValueTypes["ColorTheme"]> | undefined | null,
	notIn?: Array<ValueTypes["ColorTheme"]> | undefined | null,
	lt?: ValueTypes["ColorTheme"] | undefined | null,
	lte?: ValueTypes["ColorTheme"] | undefined | null,
	gt?: ValueTypes["ColorTheme"] | undefined | null,
	gte?: ValueTypes["ColorTheme"] | undefined | null
};
	["ColorTheme"]:ColorTheme;
	["VideoWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	src?: ValueTypes["StringCondition"] | undefined | null,
	width?: ValueTypes["IntCondition"] | undefined | null,
	height?: ValueTypes["IntCondition"] | undefined | null,
	size?: ValueTypes["IntCondition"] | undefined | null,
	type?: ValueTypes["StringCondition"] | undefined | null,
	duration?: ValueTypes["FloatCondition"] | undefined | null,
	poster?: ValueTypes["ImageWhere"] | undefined | null,
	and?: Array<ValueTypes["VideoWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["VideoWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["VideoWhere"] | undefined | null
};
	["ColorPalleteWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	background?: ValueTypes["StringCondition"] | undefined | null,
	text?: ValueTypes["StringCondition"] | undefined | null,
	and?: Array<ValueTypes["ColorPalleteWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ColorPalleteWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ColorPalleteWhere"] | undefined | null
};
	["ContentWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	blocks?: ValueTypes["ContentBlockWhere"] | undefined | null,
	and?: Array<ValueTypes["ContentWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ContentWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ContentWhere"] | undefined | null
};
	["ContentBlockWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	json?: ValueTypes["StringCondition"] | undefined | null,
	content?: ValueTypes["ContentWhere"] | undefined | null,
	references?: ValueTypes["ContentReferenceWhere"] | undefined | null,
	and?: Array<ValueTypes["ContentBlockWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ContentBlockWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ContentBlockWhere"] | undefined | null
};
	["ContentReferenceWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	type?: ValueTypes["ContentReferenceTypeCondition"] | undefined | null,
	primaryText?: ValueTypes["StringCondition"] | undefined | null,
	secondaryText?: ValueTypes["StringCondition"] | undefined | null,
	jsonContent?: ValueTypes["StringCondition"] | undefined | null,
	block?: ValueTypes["ContentBlockWhere"] | undefined | null,
	colorPallete?: ValueTypes["ColorPalleteWhere"] | undefined | null,
	medium?: ValueTypes["MediumWhere"] | undefined | null,
	link?: ValueTypes["LinkWhere"] | undefined | null,
	blogPosts?: ValueTypes["BlogPostListWhere"] | undefined | null,
	links?: ValueTypes["LinkListWhere"] | undefined | null,
	products?: ValueTypes["ProductListWhere"] | undefined | null,
	contentSize?: ValueTypes["ContentSizeCondition"] | undefined | null,
	misc?: ValueTypes["StringCondition"] | undefined | null,
	hero?: ValueTypes["HeroWhere"] | undefined | null,
	gallery?: ValueTypes["GalleryWhere"] | undefined | null,
	socialsAndApps?: ValueTypes["SocialsAndAppsWhere"] | undefined | null,
	productGrid?: ValueTypes["ProductGridWhere"] | undefined | null,
	productBanners?: ValueTypes["ProductBannerListWhere"] | undefined | null,
	deliveryRegions?: ValueTypes["DeliveryRegionsWhere"] | undefined | null,
	textList?: ValueTypes["TextListWhere"] | undefined | null,
	gridTiles?: ValueTypes["GridTilesWhere"] | undefined | null,
	and?: Array<ValueTypes["ContentReferenceWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ContentReferenceWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ContentReferenceWhere"] | undefined | null
};
	["ContentReferenceTypeCondition"]: {
	and?: Array<ValueTypes["ContentReferenceTypeCondition"]> | undefined | null,
	or?: Array<ValueTypes["ContentReferenceTypeCondition"]> | undefined | null,
	not?: ValueTypes["ContentReferenceTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["ContentReferenceType"] | undefined | null,
	notEq?: ValueTypes["ContentReferenceType"] | undefined | null,
	in?: Array<ValueTypes["ContentReferenceType"]> | undefined | null,
	notIn?: Array<ValueTypes["ContentReferenceType"]> | undefined | null,
	lt?: ValueTypes["ContentReferenceType"] | undefined | null,
	lte?: ValueTypes["ContentReferenceType"] | undefined | null,
	gt?: ValueTypes["ContentReferenceType"] | undefined | null,
	gte?: ValueTypes["ContentReferenceType"] | undefined | null
};
	["ContentReferenceType"]:ContentReferenceType;
	["LinkWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	type?: ValueTypes["LinkTypeCondition"] | undefined | null,
	title?: ValueTypes["StringCondition"] | undefined | null,
	externalLink?: ValueTypes["StringCondition"] | undefined | null,
	internalLink?: ValueTypes["LinkableWhere"] | undefined | null,
	and?: Array<ValueTypes["LinkWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["LinkWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["LinkWhere"] | undefined | null
};
	["LinkTypeCondition"]: {
	and?: Array<ValueTypes["LinkTypeCondition"]> | undefined | null,
	or?: Array<ValueTypes["LinkTypeCondition"]> | undefined | null,
	not?: ValueTypes["LinkTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["LinkType"] | undefined | null,
	notEq?: ValueTypes["LinkType"] | undefined | null,
	in?: Array<ValueTypes["LinkType"]> | undefined | null,
	notIn?: Array<ValueTypes["LinkType"]> | undefined | null,
	lt?: ValueTypes["LinkType"] | undefined | null,
	lte?: ValueTypes["LinkType"] | undefined | null,
	gt?: ValueTypes["LinkType"] | undefined | null,
	gte?: ValueTypes["LinkType"] | undefined | null
};
	["LinkType"]:LinkType;
	["LinkableWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	url?: ValueTypes["StringCondition"] | undefined | null,
	blogPost?: ValueTypes["BlogPostLocaleWhere"] | undefined | null,
	page?: ValueTypes["PageLocaleWhere"] | undefined | null,
	wikiPage?: ValueTypes["WikiPageWhere"] | undefined | null,
	redirect?: ValueTypes["RedirectWhere"] | undefined | null,
	and?: Array<ValueTypes["LinkableWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["LinkableWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["LinkableWhere"] | undefined | null
};
	["PageLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	title?: ValueTypes["StringCondition"] | undefined | null,
	link?: ValueTypes["LinkableWhere"] | undefined | null,
	root?: ValueTypes["PageWhere"] | undefined | null,
	locale?: ValueTypes["LocaleWhere"] | undefined | null,
	seo?: ValueTypes["SeoWhere"] | undefined | null,
	content?: ValueTypes["ContentWhere"] | undefined | null,
	cover?: ValueTypes["CoverWhere"] | undefined | null,
	theme?: ValueTypes["PageThemeCondition"] | undefined | null,
	and?: Array<ValueTypes["PageLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["PageLocaleWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["PageLocaleWhere"] | undefined | null
};
	["PageWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	locales?: ValueTypes["PageLocaleWhere"] | undefined | null,
	and?: Array<ValueTypes["PageWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["PageWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["PageWhere"] | undefined | null
};
	["SeoWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	title?: ValueTypes["StringCondition"] | undefined | null,
	description?: ValueTypes["StringCondition"] | undefined | null,
	ogTitle?: ValueTypes["StringCondition"] | undefined | null,
	ogDescription?: ValueTypes["StringCondition"] | undefined | null,
	ogImage?: ValueTypes["ImageWhere"] | undefined | null,
	and?: Array<ValueTypes["SeoWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["SeoWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["SeoWhere"] | undefined | null
};
	["PageThemeCondition"]: {
	and?: Array<ValueTypes["PageThemeCondition"]> | undefined | null,
	or?: Array<ValueTypes["PageThemeCondition"]> | undefined | null,
	not?: ValueTypes["PageThemeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["PageTheme"] | undefined | null,
	notEq?: ValueTypes["PageTheme"] | undefined | null,
	in?: Array<ValueTypes["PageTheme"]> | undefined | null,
	notIn?: Array<ValueTypes["PageTheme"]> | undefined | null,
	lt?: ValueTypes["PageTheme"] | undefined | null,
	lte?: ValueTypes["PageTheme"] | undefined | null,
	gt?: ValueTypes["PageTheme"] | undefined | null,
	gte?: ValueTypes["PageTheme"] | undefined | null
};
	["PageTheme"]:PageTheme;
	["WikiPageWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	title?: ValueTypes["StringCondition"] | undefined | null,
	emoji?: ValueTypes["StringCondition"] | undefined | null,
	link?: ValueTypes["LinkableWhere"] | undefined | null,
	parent?: ValueTypes["WikiPageWhere"] | undefined | null,
	children?: ValueTypes["WikiPageWhere"] | undefined | null,
	content?: ValueTypes["ContentWhere"] | undefined | null,
	and?: Array<ValueTypes["WikiPageWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["WikiPageWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["WikiPageWhere"] | undefined | null
};
	["RedirectWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	link?: ValueTypes["LinkableWhere"] | undefined | null,
	target?: ValueTypes["LinkWhere"] | undefined | null,
	and?: Array<ValueTypes["RedirectWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["RedirectWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["RedirectWhere"] | undefined | null
};
	["BlogPostListWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	items?: ValueTypes["BlogPostListItemWhere"] | undefined | null,
	and?: Array<ValueTypes["BlogPostListWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["BlogPostListWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["BlogPostListWhere"] | undefined | null
};
	["BlogPostListItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	caption?: ValueTypes["StringCondition"] | undefined | null,
	list?: ValueTypes["BlogPostListWhere"] | undefined | null,
	blogPost?: ValueTypes["BlogPostLocaleWhere"] | undefined | null,
	and?: Array<ValueTypes["BlogPostListItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["BlogPostListItemWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["BlogPostListItemWhere"] | undefined | null
};
	["LinkListWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	items?: ValueTypes["LinkListItemWhere"] | undefined | null,
	and?: Array<ValueTypes["LinkListWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["LinkListWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["LinkListWhere"] | undefined | null
};
	["LinkListItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	isPrimary?: ValueTypes["BooleanCondition"] | undefined | null,
	list?: ValueTypes["LinkListWhere"] | undefined | null,
	link?: ValueTypes["LinkWhere"] | undefined | null,
	and?: Array<ValueTypes["LinkListItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["LinkListItemWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["LinkListItemWhere"] | undefined | null
};
	["ContentSizeCondition"]: {
	and?: Array<ValueTypes["ContentSizeCondition"]> | undefined | null,
	or?: Array<ValueTypes["ContentSizeCondition"]> | undefined | null,
	not?: ValueTypes["ContentSizeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["ContentSize"] | undefined | null,
	notEq?: ValueTypes["ContentSize"] | undefined | null,
	in?: Array<ValueTypes["ContentSize"]> | undefined | null,
	notIn?: Array<ValueTypes["ContentSize"]> | undefined | null,
	lt?: ValueTypes["ContentSize"] | undefined | null,
	lte?: ValueTypes["ContentSize"] | undefined | null,
	gt?: ValueTypes["ContentSize"] | undefined | null,
	gte?: ValueTypes["ContentSize"] | undefined | null
};
	["ContentSize"]:ContentSize;
	["HeroWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	showLogo?: ValueTypes["BooleanCondition"] | undefined | null,
	middleContent?: ValueTypes["StringCondition"] | undefined | null,
	medium?: ValueTypes["MediumWhere"] | undefined | null,
	and?: Array<ValueTypes["HeroWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["HeroWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["HeroWhere"] | undefined | null
};
	["GalleryWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	items?: ValueTypes["GalleryItemWhere"] | undefined | null,
	and?: Array<ValueTypes["GalleryWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["GalleryWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["GalleryWhere"] | undefined | null
};
	["GalleryItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	caption?: ValueTypes["StringCondition"] | undefined | null,
	list?: ValueTypes["GalleryWhere"] | undefined | null,
	medium?: ValueTypes["MediumWhere"] | undefined | null,
	and?: Array<ValueTypes["GalleryItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["GalleryItemWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["GalleryItemWhere"] | undefined | null
};
	["SocialsAndAppsWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	instagram?: ValueTypes["BooleanCondition"] | undefined | null,
	appStore?: ValueTypes["BooleanCondition"] | undefined | null,
	googlePlay?: ValueTypes["BooleanCondition"] | undefined | null,
	and?: Array<ValueTypes["SocialsAndAppsWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["SocialsAndAppsWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["SocialsAndAppsWhere"] | undefined | null
};
	["ProductGridWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	isCarousel?: ValueTypes["BooleanCondition"] | undefined | null,
	categories?: ValueTypes["ProductGridCategoryWhere"] | undefined | null,
	type?: ValueTypes["ProductGridTypeCondition"] | undefined | null,
	and?: Array<ValueTypes["ProductGridWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ProductGridWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ProductGridWhere"] | undefined | null
};
	["ProductGridCategoryWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	title?: ValueTypes["StringCondition"] | undefined | null,
	root?: ValueTypes["ProductGridWhere"] | undefined | null,
	items?: ValueTypes["ProductGridItemWhere"] | undefined | null,
	images?: ValueTypes["ImageListWhere"] | undefined | null,
	and?: Array<ValueTypes["ProductGridCategoryWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ProductGridCategoryWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ProductGridCategoryWhere"] | undefined | null
};
	["ProductGridItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	title?: ValueTypes["StringCondition"] | undefined | null,
	lead?: ValueTypes["StringCondition"] | undefined | null,
	product?: ValueTypes["ProductWhere"] | undefined | null,
	medium?: ValueTypes["MediumWhere"] | undefined | null,
	link?: ValueTypes["LinkWhere"] | undefined | null,
	category?: ValueTypes["ProductGridCategoryWhere"] | undefined | null,
	description?: ValueTypes["StringCondition"] | undefined | null,
	and?: Array<ValueTypes["ProductGridItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ProductGridItemWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ProductGridItemWhere"] | undefined | null
};
	["ImageListWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	items?: ValueTypes["ImageListItemWhere"] | undefined | null,
	and?: Array<ValueTypes["ImageListWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ImageListWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ImageListWhere"] | undefined | null
};
	["ImageListItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	list?: ValueTypes["ImageListWhere"] | undefined | null,
	image?: ValueTypes["ImageWhere"] | undefined | null,
	and?: Array<ValueTypes["ImageListItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ImageListItemWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ImageListItemWhere"] | undefined | null
};
	["ProductGridTypeCondition"]: {
	and?: Array<ValueTypes["ProductGridTypeCondition"]> | undefined | null,
	or?: Array<ValueTypes["ProductGridTypeCondition"]> | undefined | null,
	not?: ValueTypes["ProductGridTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["ProductGridType"] | undefined | null,
	notEq?: ValueTypes["ProductGridType"] | undefined | null,
	in?: Array<ValueTypes["ProductGridType"]> | undefined | null,
	notIn?: Array<ValueTypes["ProductGridType"]> | undefined | null,
	lt?: ValueTypes["ProductGridType"] | undefined | null,
	lte?: ValueTypes["ProductGridType"] | undefined | null,
	gt?: ValueTypes["ProductGridType"] | undefined | null,
	gte?: ValueTypes["ProductGridType"] | undefined | null
};
	["ProductGridType"]:ProductGridType;
	["ProductBannerListWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	items?: ValueTypes["ProductBannerItemWhere"] | undefined | null,
	and?: Array<ValueTypes["ProductBannerListWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ProductBannerListWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ProductBannerListWhere"] | undefined | null
};
	["ProductBannerItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	list?: ValueTypes["ProductBannerListWhere"] | undefined | null,
	banner?: ValueTypes["ProductBannerWhere"] | undefined | null,
	size?: ValueTypes["ProductBannerItemSizeCondition"] | undefined | null,
	and?: Array<ValueTypes["ProductBannerItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ProductBannerItemWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ProductBannerItemWhere"] | undefined | null
};
	["ProductBannerWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	beforeTitle?: ValueTypes["StringCondition"] | undefined | null,
	title?: ValueTypes["StringCondition"] | undefined | null,
	label?: ValueTypes["StringCondition"] | undefined | null,
	button?: ValueTypes["LinkWhere"] | undefined | null,
	backgroundImage?: ValueTypes["ImageWhere"] | undefined | null,
	productImage?: ValueTypes["ImageWhere"] | undefined | null,
	product?: ValueTypes["ProductWhere"] | undefined | null,
	and?: Array<ValueTypes["ProductBannerWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ProductBannerWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ProductBannerWhere"] | undefined | null
};
	["ProductBannerItemSizeCondition"]: {
	and?: Array<ValueTypes["ProductBannerItemSizeCondition"]> | undefined | null,
	or?: Array<ValueTypes["ProductBannerItemSizeCondition"]> | undefined | null,
	not?: ValueTypes["ProductBannerItemSizeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["ProductBannerItemSize"] | undefined | null,
	notEq?: ValueTypes["ProductBannerItemSize"] | undefined | null,
	in?: Array<ValueTypes["ProductBannerItemSize"]> | undefined | null,
	notIn?: Array<ValueTypes["ProductBannerItemSize"]> | undefined | null,
	lt?: ValueTypes["ProductBannerItemSize"] | undefined | null,
	lte?: ValueTypes["ProductBannerItemSize"] | undefined | null,
	gt?: ValueTypes["ProductBannerItemSize"] | undefined | null,
	gte?: ValueTypes["ProductBannerItemSize"] | undefined | null
};
	["ProductBannerItemSize"]:ProductBannerItemSize;
	["DeliveryRegionsWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	items?: ValueTypes["DeliveryRegionsItemWhere"] | undefined | null,
	and?: Array<ValueTypes["DeliveryRegionsWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["DeliveryRegionsWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["DeliveryRegionsWhere"] | undefined | null
};
	["DeliveryRegionsItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	title?: ValueTypes["StringCondition"] | undefined | null,
	offerLabel?: ValueTypes["StringCondition"] | undefined | null,
	list?: ValueTypes["DeliveryRegionsWhere"] | undefined | null,
	image?: ValueTypes["ImageWhere"] | undefined | null,
	textList?: ValueTypes["TextListWhere"] | undefined | null,
	gallery?: ValueTypes["ImageListWhere"] | undefined | null,
	and?: Array<ValueTypes["DeliveryRegionsItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["DeliveryRegionsItemWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["DeliveryRegionsItemWhere"] | undefined | null
};
	["TextListWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	items?: ValueTypes["TextItemWhere"] | undefined | null,
	and?: Array<ValueTypes["TextListWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["TextListWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["TextListWhere"] | undefined | null
};
	["TextItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	text?: ValueTypes["StringCondition"] | undefined | null,
	list?: ValueTypes["TextListWhere"] | undefined | null,
	title?: ValueTypes["StringCondition"] | undefined | null,
	and?: Array<ValueTypes["TextItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["TextItemWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["TextItemWhere"] | undefined | null
};
	["GridTilesWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	items?: ValueTypes["GridTileItemWhere"] | undefined | null,
	and?: Array<ValueTypes["GridTilesWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["GridTilesWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["GridTilesWhere"] | undefined | null
};
	["GridTileItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	text?: ValueTypes["StringCondition"] | undefined | null,
	list?: ValueTypes["GridTilesWhere"] | undefined | null,
	medium?: ValueTypes["MediumWhere"] | undefined | null,
	link?: ValueTypes["LinkWhere"] | undefined | null,
	and?: Array<ValueTypes["GridTileItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["GridTileItemWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["GridTileItemWhere"] | undefined | null
};
	["TranslationCataloguesIdentifierWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	code?: ValueTypes["StringCondition"] | undefined | null,
	catalogue?: ValueTypes["TranslationCatalogueWhere"] | undefined | null,
	and?: Array<ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null
};
	["TranslationCatalogueWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	domain?: ValueTypes["TranslationDomainWhere"] | undefined | null,
	fallback?: ValueTypes["TranslationCatalogueWhere"] | undefined | null,
	values?: ValueTypes["TranslationValueWhere"] | undefined | null,
	identifier?: ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null,
	and?: Array<ValueTypes["TranslationCatalogueWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["TranslationCatalogueWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["TranslationCatalogueWhere"] | undefined | null
};
	["TranslationDomainWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	identifier?: ValueTypes["StringCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	catalogues?: ValueTypes["TranslationCatalogueWhere"] | undefined | null,
	keys?: ValueTypes["TranslationKeyWhere"] | undefined | null,
	and?: Array<ValueTypes["TranslationDomainWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["TranslationDomainWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["TranslationDomainWhere"] | undefined | null
};
	["TranslationKeyWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	identifier?: ValueTypes["StringCondition"] | undefined | null,
	contentType?: ValueTypes["TranslationContentTypeCondition"] | undefined | null,
	note?: ValueTypes["StringCondition"] | undefined | null,
	domain?: ValueTypes["TranslationDomainWhere"] | undefined | null,
	values?: ValueTypes["TranslationValueWhere"] | undefined | null,
	and?: Array<ValueTypes["TranslationKeyWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["TranslationKeyWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["TranslationKeyWhere"] | undefined | null
};
	["TranslationContentTypeCondition"]: {
	and?: Array<ValueTypes["TranslationContentTypeCondition"]> | undefined | null,
	or?: Array<ValueTypes["TranslationContentTypeCondition"]> | undefined | null,
	not?: ValueTypes["TranslationContentTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["TranslationContentType"] | undefined | null,
	notEq?: ValueTypes["TranslationContentType"] | undefined | null,
	in?: Array<ValueTypes["TranslationContentType"]> | undefined | null,
	notIn?: Array<ValueTypes["TranslationContentType"]> | undefined | null,
	lt?: ValueTypes["TranslationContentType"] | undefined | null,
	lte?: ValueTypes["TranslationContentType"] | undefined | null,
	gt?: ValueTypes["TranslationContentType"] | undefined | null,
	gte?: ValueTypes["TranslationContentType"] | undefined | null
};
	["TranslationContentType"]:TranslationContentType;
	["TranslationValueWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	value?: ValueTypes["StringCondition"] | undefined | null,
	catalogue?: ValueTypes["TranslationCatalogueWhere"] | undefined | null,
	key?: ValueTypes["TranslationKeyWhere"] | undefined | null,
	and?: Array<ValueTypes["TranslationValueWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["TranslationValueWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["TranslationValueWhere"] | undefined | null
};
	["MenuLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	root?: ValueTypes["SiteMenuWhere"] | undefined | null,
	locale?: ValueTypes["LocaleWhere"] | undefined | null,
	items?: ValueTypes["MenuItemWhere"] | undefined | null,
	secondaryItems?: ValueTypes["LinkListWhere"] | undefined | null,
	eshopLink?: ValueTypes["LinkWhere"] | undefined | null,
	and?: Array<ValueTypes["MenuLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["MenuLocaleWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["MenuLocaleWhere"] | undefined | null
};
	["SiteMenuWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	unique?: ValueTypes["OneCondition"] | undefined | null,
	locales?: ValueTypes["MenuLocaleWhere"] | undefined | null,
	and?: Array<ValueTypes["SiteMenuWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["SiteMenuWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["SiteMenuWhere"] | undefined | null
};
	["MenuItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	menu?: ValueTypes["MenuLocaleWhere"] | undefined | null,
	link?: ValueTypes["LinkWhere"] | undefined | null,
	subitems?: ValueTypes["MenuSubitemWhere"] | undefined | null,
	and?: Array<ValueTypes["MenuItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["MenuItemWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["MenuItemWhere"] | undefined | null
};
	["MenuSubitemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	type?: ValueTypes["MenuSubitemTypeCondition"] | undefined | null,
	title?: ValueTypes["StringCondition"] | undefined | null,
	item?: ValueTypes["MenuItemWhere"] | undefined | null,
	links?: ValueTypes["MenuLinkListWhere"] | undefined | null,
	products?: ValueTypes["MenuProductsWhere"] | undefined | null,
	delivery?: ValueTypes["MenuDeliveryWhere"] | undefined | null,
	contact?: ValueTypes["MenuContactWhere"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	and?: Array<ValueTypes["MenuSubitemWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["MenuSubitemWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["MenuSubitemWhere"] | undefined | null
};
	["MenuSubitemTypeCondition"]: {
	and?: Array<ValueTypes["MenuSubitemTypeCondition"]> | undefined | null,
	or?: Array<ValueTypes["MenuSubitemTypeCondition"]> | undefined | null,
	not?: ValueTypes["MenuSubitemTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["MenuSubitemType"] | undefined | null,
	notEq?: ValueTypes["MenuSubitemType"] | undefined | null,
	in?: Array<ValueTypes["MenuSubitemType"]> | undefined | null,
	notIn?: Array<ValueTypes["MenuSubitemType"]> | undefined | null,
	lt?: ValueTypes["MenuSubitemType"] | undefined | null,
	lte?: ValueTypes["MenuSubitemType"] | undefined | null,
	gt?: ValueTypes["MenuSubitemType"] | undefined | null,
	gte?: ValueTypes["MenuSubitemType"] | undefined | null
};
	["MenuSubitemType"]:MenuSubitemType;
	["MenuLinkListWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	items?: ValueTypes["MenuLinkItemWhere"] | undefined | null,
	and?: Array<ValueTypes["MenuLinkListWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["MenuLinkListWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["MenuLinkListWhere"] | undefined | null
};
	["MenuLinkItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	list?: ValueTypes["MenuLinkListWhere"] | undefined | null,
	link?: ValueTypes["LinkWhere"] | undefined | null,
	image?: ValueTypes["ImageWhere"] | undefined | null,
	description?: ValueTypes["StringCondition"] | undefined | null,
	and?: Array<ValueTypes["MenuLinkItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["MenuLinkItemWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["MenuLinkItemWhere"] | undefined | null
};
	["MenuProductsWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	links?: ValueTypes["MenuLinkListWhere"] | undefined | null,
	buttons?: ValueTypes["LinkListWhere"] | undefined | null,
	and?: Array<ValueTypes["MenuProductsWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["MenuProductsWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["MenuProductsWhere"] | undefined | null
};
	["MenuDeliveryWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	deliveryRegions?: ValueTypes["DeliveryRegionsWhere"] | undefined | null,
	text?: ValueTypes["StringCondition"] | undefined | null,
	socialsAndApps?: ValueTypes["SocialsAndAppsWhere"] | undefined | null,
	and?: Array<ValueTypes["MenuDeliveryWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["MenuDeliveryWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["MenuDeliveryWhere"] | undefined | null
};
	["MenuContactWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	text?: ValueTypes["StringCondition"] | undefined | null,
	image?: ValueTypes["ImageWhere"] | undefined | null,
	and?: Array<ValueTypes["MenuContactWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["MenuContactWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["MenuContactWhere"] | undefined | null
};
	["ProductLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	description?: ValueTypes["StringCondition"] | undefined | null,
	root?: ValueTypes["ProductWhere"] | undefined | null,
	locale?: ValueTypes["LocaleWhere"] | undefined | null,
	featureList?: ValueTypes["TextListWhere"] | undefined | null,
	printableName?: ValueTypes["StringCondition"] | undefined | null,
	firstSticker?: ValueTypes["StringCondition"] | undefined | null,
	secondSticker?: ValueTypes["StringCondition"] | undefined | null,
	and?: Array<ValueTypes["ProductLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ProductLocaleWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ProductLocaleWhere"] | undefined | null
};
	["ProductRecipeLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	root?: ValueTypes["ProductRecipeWhere"] | undefined | null,
	locale?: ValueTypes["LocaleWhere"] | undefined | null,
	description?: ValueTypes["StringCondition"] | undefined | null,
	and?: Array<ValueTypes["ProductRecipeLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ProductRecipeLocaleWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ProductRecipeLocaleWhere"] | undefined | null
};
	["ProductRecipeWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	products?: ValueTypes["ProductWhere"] | undefined | null,
	internalNote?: ValueTypes["StringCondition"] | undefined | null,
	color?: ValueTypes["StringCondition"] | undefined | null,
	image?: ValueTypes["ImageWhere"] | undefined | null,
	icon?: ValueTypes["ImageWhere"] | undefined | null,
	ingredients?: ValueTypes["ProductIngredientItemWhere"] | undefined | null,
	needsPrepping?: ValueTypes["BooleanCondition"] | undefined | null,
	locales?: ValueTypes["ProductRecipeLocaleWhere"] | undefined | null,
	gutTuning?: ValueTypes["FloatCondition"] | undefined | null,
	freshingContainer?: ValueTypes["FreshingContainerWhere"] | undefined | null,
	description?: ValueTypes["StringCondition"] | undefined | null,
	nutritionFacts?: ValueTypes["NutritionFactsWhere"] | undefined | null,
	and?: Array<ValueTypes["ProductRecipeWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ProductRecipeWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ProductRecipeWhere"] | undefined | null
};
	["ProductIngredientItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	internalOrder?: ValueTypes["IntCondition"] | undefined | null,
	recipe?: ValueTypes["ProductRecipeWhere"] | undefined | null,
	ingredient?: ValueTypes["ProductIngredientWhere"] | undefined | null,
	quantity?: ValueTypes["ProductIngredientItemQuantityWhere"] | undefined | null,
	and?: Array<ValueTypes["ProductIngredientItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ProductIngredientItemWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ProductIngredientItemWhere"] | undefined | null
};
	["ProductIngredientItemQuantityWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	unit?: ValueTypes["ProductIngredientItemQuantityUnitWhere"] | undefined | null,
	value?: ValueTypes["FloatCondition"] | undefined | null,
	and?: Array<ValueTypes["ProductIngredientItemQuantityWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ProductIngredientItemQuantityWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ProductIngredientItemQuantityWhere"] | undefined | null
};
	["NutritionFactsWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	energyKiloJoule?: ValueTypes["FloatCondition"] | undefined | null,
	energyKiloCalorie?: ValueTypes["FloatCondition"] | undefined | null,
	fatsGrams?: ValueTypes["FloatCondition"] | undefined | null,
	fatsOfWhichSaturatedGrams?: ValueTypes["FloatCondition"] | undefined | null,
	carbohydrateGrams?: ValueTypes["FloatCondition"] | undefined | null,
	carbohydrateOfWhichSugarsGrams?: ValueTypes["FloatCondition"] | undefined | null,
	proteinGrams?: ValueTypes["FloatCondition"] | undefined | null,
	fibreGrams?: ValueTypes["FloatCondition"] | undefined | null,
	saltGrams?: ValueTypes["FloatCondition"] | undefined | null,
	and?: Array<ValueTypes["NutritionFactsWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["NutritionFactsWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["NutritionFactsWhere"] | undefined | null
};
	["DeliveryMethodLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	description?: ValueTypes["StringCondition"] | undefined | null,
	trackingCodeUrlTemplate?: ValueTypes["StringCondition"] | undefined | null,
	processingTitle?: ValueTypes["StringCondition"] | undefined | null,
	processingText?: ValueTypes["StringCondition"] | undefined | null,
	processingIconUrl?: ValueTypes["StringCondition"] | undefined | null,
	dispatchedTitle?: ValueTypes["StringCondition"] | undefined | null,
	dispatchedText?: ValueTypes["StringCondition"] | undefined | null,
	dispatchedIconUrl?: ValueTypes["StringCondition"] | undefined | null,
	fulfilledTitle?: ValueTypes["StringCondition"] | undefined | null,
	fulfilledText?: ValueTypes["StringCondition"] | undefined | null,
	fulfilledIconUrl?: ValueTypes["StringCondition"] | undefined | null,
	locale?: ValueTypes["LocaleWhere"] | undefined | null,
	root?: ValueTypes["DeliveryMethodWhere"] | undefined | null,
	and?: Array<ValueTypes["DeliveryMethodLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["DeliveryMethodLocaleWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["DeliveryMethodLocaleWhere"] | undefined | null
};
	["PipelineStageLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	root?: ValueTypes["PipelineStageWhere"] | undefined | null,
	locale?: ValueTypes["LocaleWhere"] | undefined | null,
	and?: Array<ValueTypes["PipelineStageLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["PipelineStageLocaleWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["PipelineStageLocaleWhere"] | undefined | null
};
	["PipelineStageWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	items?: ValueTypes["PipelineStageItemWhere"] | undefined | null,
	pipeline?: ValueTypes["PipelineWhere"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	locales?: ValueTypes["PipelineStageLocaleWhere"] | undefined | null,
	sentiment?: ValueTypes["PipelineStageSentimentWhere"] | undefined | null,
	type?: ValueTypes["PipelineStageTypeCondition"] | undefined | null,
	forms?: ValueTypes["LeadFormWhere"] | undefined | null,
	showItemsWeight?: ValueTypes["BooleanCondition"] | undefined | null,
	showItemsPrice?: ValueTypes["BooleanCondition"] | undefined | null,
	and?: Array<ValueTypes["PipelineStageWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["PipelineStageWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["PipelineStageWhere"] | undefined | null
};
	["PipelineStageItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	list?: ValueTypes["PipelineStageWhere"] | undefined | null,
	lead?: ValueTypes["PipelineLeadWhere"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	and?: Array<ValueTypes["PipelineStageItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["PipelineStageItemWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["PipelineStageItemWhere"] | undefined | null
};
	["PipelineLeadWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	stageItem?: ValueTypes["PipelineStageItemWhere"] | undefined | null,
	contactPerson?: ValueTypes["StringCondition"] | undefined | null,
	customer?: ValueTypes["CustomerWhere"] | undefined | null,
	cafeType?: ValueTypes["StringCondition"] | undefined | null,
	offerType?: ValueTypes["StringCondition"] | undefined | null,
	ownMachine?: ValueTypes["BooleanCondition"] | undefined | null,
	customerCity?: ValueTypes["StringCondition"] | undefined | null,
	companyId?: ValueTypes["StringCondition"] | undefined | null,
	customerName?: ValueTypes["StringCondition"] | undefined | null,
	email?: ValueTypes["StringCondition"] | undefined | null,
	phone?: ValueTypes["StringCondition"] | undefined | null,
	form?: ValueTypes["LeadFormWhere"] | undefined | null,
	meta?: ValueTypes["StringCondition"] | undefined | null,
	multiroasterType?: ValueTypes["StringCondition"] | undefined | null,
	and?: Array<ValueTypes["PipelineLeadWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["PipelineLeadWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["PipelineLeadWhere"] | undefined | null
};
	["LeadFormWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	code?: ValueTypes["StringCondition"] | undefined | null,
	stage?: ValueTypes["PipelineStageWhere"] | undefined | null,
	leads?: ValueTypes["PipelineLeadWhere"] | undefined | null,
	and?: Array<ValueTypes["LeadFormWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["LeadFormWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["LeadFormWhere"] | undefined | null
};
	["PipelineWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	unique?: ValueTypes["OneCondition"] | undefined | null,
	stages?: ValueTypes["PipelineStageWhere"] | undefined | null,
	and?: Array<ValueTypes["PipelineWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["PipelineWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["PipelineWhere"] | undefined | null
};
	["PipelineStageSentimentWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	internalName?: ValueTypes["StringCondition"] | undefined | null,
	backgroundColor?: ValueTypes["StringCondition"] | undefined | null,
	textColor?: ValueTypes["StringCondition"] | undefined | null,
	and?: Array<ValueTypes["PipelineStageSentimentWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["PipelineStageSentimentWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["PipelineStageSentimentWhere"] | undefined | null
};
	["PipelineStageTypeCondition"]: {
	and?: Array<ValueTypes["PipelineStageTypeCondition"]> | undefined | null,
	or?: Array<ValueTypes["PipelineStageTypeCondition"]> | undefined | null,
	not?: ValueTypes["PipelineStageTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["PipelineStageType"] | undefined | null,
	notEq?: ValueTypes["PipelineStageType"] | undefined | null,
	in?: Array<ValueTypes["PipelineStageType"]> | undefined | null,
	notIn?: Array<ValueTypes["PipelineStageType"]> | undefined | null,
	lt?: ValueTypes["PipelineStageType"] | undefined | null,
	lte?: ValueTypes["PipelineStageType"] | undefined | null,
	gt?: ValueTypes["PipelineStageType"] | undefined | null,
	gte?: ValueTypes["PipelineStageType"] | undefined | null
};
	["PipelineStageType"]:PipelineStageType;
	["SubscriptionBoxLocaleWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	title?: ValueTypes["StringCondition"] | undefined | null,
	stickerText?: ValueTypes["StringCondition"] | undefined | null,
	descriptionText?: ValueTypes["StringCondition"] | undefined | null,
	root?: ValueTypes["SubscriptionBoxWhere"] | undefined | null,
	locale?: ValueTypes["LocaleWhere"] | undefined | null,
	secondaryTitle?: ValueTypes["StringCondition"] | undefined | null,
	texts?: ValueTypes["TextListWhere"] | undefined | null,
	secondaryTexts?: ValueTypes["TextListWhere"] | undefined | null,
	and?: Array<ValueTypes["SubscriptionBoxLocaleWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["SubscriptionBoxLocaleWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["SubscriptionBoxLocaleWhere"] | undefined | null
};
	["SubscriptionBoxWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	locales?: ValueTypes["SubscriptionBoxLocaleWhere"] | undefined | null,
	unique?: ValueTypes["OneCondition"] | undefined | null,
	and?: Array<ValueTypes["SubscriptionBoxWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["SubscriptionBoxWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["SubscriptionBoxWhere"] | undefined | null
};
	["PreparedPackingQuantityWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	date?: ValueTypes["DateCondition"] | undefined | null,
	quantity?: ValueTypes["FloatCondition"] | undefined | null,
	recipe?: ValueTypes["ProductRecipeWhere"] | undefined | null,
	packing?: ValueTypes["ProductPackingWhere"] | undefined | null,
	packedInCardboard?: ValueTypes["BooleanCondition"] | undefined | null,
	and?: Array<ValueTypes["PreparedPackingQuantityWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["PreparedPackingQuantityWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["PreparedPackingQuantityWhere"] | undefined | null
};
	["ProductStockWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	quantity?: ValueTypes["IntCondition"] | undefined | null,
	product?: ValueTypes["ProductWhere"] | undefined | null,
	store?: ValueTypes["StoreWhere"] | undefined | null,
	and?: Array<ValueTypes["ProductStockWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ProductStockWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ProductStockWhere"] | undefined | null
};
	["StoreWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	code?: ValueTypes["StringCondition"] | undefined | null,
	description?: ValueTypes["StringCondition"] | undefined | null,
	internalNote?: ValueTypes["StringCondition"] | undefined | null,
	and?: Array<ValueTypes["StoreWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["StoreWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["StoreWhere"] | undefined | null
};
	["ProductGroupPriceWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	priceCents?: ValueTypes["IntCondition"] | undefined | null,
	group?: ValueTypes["CustomerGroupWhere"] | undefined | null,
	product?: ValueTypes["ProductWhere"] | undefined | null,
	and?: Array<ValueTypes["ProductGroupPriceWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ProductGroupPriceWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ProductGroupPriceWhere"] | undefined | null
};
	["CustomerGroupWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	productPrices?: ValueTypes["ProductGroupPriceWhere"] | undefined | null,
	customers?: ValueTypes["CustomerWhere"] | undefined | null,
	discountPermille?: ValueTypes["IntCondition"] | undefined | null,
	code?: ValueTypes["StringCondition"] | undefined | null,
	doubleshotLegacyId?: ValueTypes["StringCondition"] | undefined | null,
	and?: Array<ValueTypes["CustomerGroupWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["CustomerGroupWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["CustomerGroupWhere"] | undefined | null
};
	["ProductAvailabilityCondition"]: {
	and?: Array<ValueTypes["ProductAvailabilityCondition"]> | undefined | null,
	or?: Array<ValueTypes["ProductAvailabilityCondition"]> | undefined | null,
	not?: ValueTypes["ProductAvailabilityCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["ProductAvailability"] | undefined | null,
	notEq?: ValueTypes["ProductAvailability"] | undefined | null,
	in?: Array<ValueTypes["ProductAvailability"]> | undefined | null,
	notIn?: Array<ValueTypes["ProductAvailability"]> | undefined | null,
	lt?: ValueTypes["ProductAvailability"] | undefined | null,
	lte?: ValueTypes["ProductAvailability"] | undefined | null,
	gt?: ValueTypes["ProductAvailability"] | undefined | null,
	gte?: ValueTypes["ProductAvailability"] | undefined | null
};
	["ProductAvailability"]:ProductAvailability;
	["ProductCustomerPriceWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	groupDiscountPermille?: ValueTypes["IntCondition"] | undefined | null,
	groupPriceCents?: ValueTypes["IntCondition"] | undefined | null,
	fullPriceCents?: ValueTypes["IntCondition"] | undefined | null,
	discountedPriceCents?: ValueTypes["IntCondition"] | undefined | null,
	priceCents?: ValueTypes["IntCondition"] | undefined | null,
	offered?: ValueTypes["BooleanCondition"] | undefined | null,
	notDiscountable?: ValueTypes["BooleanCondition"] | undefined | null,
	customer?: ValueTypes["CustomerWhere"] | undefined | null,
	product?: ValueTypes["ProductWhere"] | undefined | null,
	and?: Array<ValueTypes["ProductCustomerPriceWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ProductCustomerPriceWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ProductCustomerPriceWhere"] | undefined | null
};
	["ProductMetadataWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	archived?: ValueTypes["BooleanCondition"] | undefined | null,
	available?: ValueTypes["BooleanCondition"] | undefined | null,
	availableQuantity?: ValueTypes["IntCondition"] | undefined | null,
	product?: ValueTypes["ProductWhere"] | undefined | null,
	and?: Array<ValueTypes["ProductMetadataWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ProductMetadataWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ProductMetadataWhere"] | undefined | null
};
	["ProductSalesDayWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	productName?: ValueTypes["StringCondition"] | undefined | null,
	orderDate?: ValueTypes["DateCondition"] | undefined | null,
	priceCentsSum?: ValueTypes["IntCondition"] | undefined | null,
	sum?: ValueTypes["IntCondition"] | undefined | null,
	product?: ValueTypes["ProductWhere"] | undefined | null,
	and?: Array<ValueTypes["ProductSalesDayWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ProductSalesDayWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ProductSalesDayWhere"] | undefined | null
};
	["ProductSalesWeekWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	productName?: ValueTypes["StringCondition"] | undefined | null,
	orderDate?: ValueTypes["DateCondition"] | undefined | null,
	priceCentsSum?: ValueTypes["IntCondition"] | undefined | null,
	sum?: ValueTypes["IntCondition"] | undefined | null,
	product?: ValueTypes["ProductWhere"] | undefined | null,
	and?: Array<ValueTypes["ProductSalesWeekWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ProductSalesWeekWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ProductSalesWeekWhere"] | undefined | null
};
	["ProductSalesMonthWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	productName?: ValueTypes["StringCondition"] | undefined | null,
	orderDate?: ValueTypes["DateCondition"] | undefined | null,
	priceCentsSum?: ValueTypes["IntCondition"] | undefined | null,
	sum?: ValueTypes["IntCondition"] | undefined | null,
	product?: ValueTypes["ProductWhere"] | undefined | null,
	and?: Array<ValueTypes["ProductSalesMonthWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ProductSalesMonthWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ProductSalesMonthWhere"] | undefined | null
};
	["AddressMetadataWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	deliveryZoneType?: ValueTypes["DeliveryZoneTypeCondition"] | undefined | null,
	address?: ValueTypes["AddressWhere"] | undefined | null,
	deliveryZone?: ValueTypes["DeliveryZoneWhere"] | undefined | null,
	and?: Array<ValueTypes["AddressMetadataWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["AddressMetadataWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["AddressMetadataWhere"] | undefined | null
};
	["DeliveryTimelinePresetWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	type?: ValueTypes["DeliveryTimelineTypeCondition"] | undefined | null,
	duration?: ValueTypes["StringCondition"] | undefined | null,
	window?: ValueTypes["StringCondition"] | undefined | null,
	deliveryMethod?: ValueTypes["DeliveryMethodWhere"] | undefined | null,
	and?: Array<ValueTypes["DeliveryTimelinePresetWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["DeliveryTimelinePresetWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["DeliveryTimelinePresetWhere"] | undefined | null
};
	["DeliveryTimelineTypeCondition"]: {
	and?: Array<ValueTypes["DeliveryTimelineTypeCondition"]> | undefined | null,
	or?: Array<ValueTypes["DeliveryTimelineTypeCondition"]> | undefined | null,
	not?: ValueTypes["DeliveryTimelineTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["DeliveryTimelineType"] | undefined | null,
	notEq?: ValueTypes["DeliveryTimelineType"] | undefined | null,
	in?: Array<ValueTypes["DeliveryTimelineType"]> | undefined | null,
	notIn?: Array<ValueTypes["DeliveryTimelineType"]> | undefined | null,
	lt?: ValueTypes["DeliveryTimelineType"] | undefined | null,
	lte?: ValueTypes["DeliveryTimelineType"] | undefined | null,
	gt?: ValueTypes["DeliveryTimelineType"] | undefined | null,
	gte?: ValueTypes["DeliveryTimelineType"] | undefined | null
};
	["DeliveryTimelineType"]:DeliveryTimelineType;
	["PaymentMethodTypeCondition"]: {
	and?: Array<ValueTypes["PaymentMethodTypeCondition"]> | undefined | null,
	or?: Array<ValueTypes["PaymentMethodTypeCondition"]> | undefined | null,
	not?: ValueTypes["PaymentMethodTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["PaymentMethodType"] | undefined | null,
	notEq?: ValueTypes["PaymentMethodType"] | undefined | null,
	in?: Array<ValueTypes["PaymentMethodType"]> | undefined | null,
	notIn?: Array<ValueTypes["PaymentMethodType"]> | undefined | null,
	lt?: ValueTypes["PaymentMethodType"] | undefined | null,
	lte?: ValueTypes["PaymentMethodType"] | undefined | null,
	gt?: ValueTypes["PaymentMethodType"] | undefined | null,
	gte?: ValueTypes["PaymentMethodType"] | undefined | null
};
	["PaymentMethodType"]:PaymentMethodType;
	["CustomerPermissionsWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	canPlaceOrder?: ValueTypes["BooleanCondition"] | undefined | null,
	customer?: ValueTypes["CustomerWhere"] | undefined | null,
	and?: Array<ValueTypes["CustomerPermissionsWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["CustomerPermissionsWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["CustomerPermissionsWhere"] | undefined | null
};
	["CustomerNameWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	nominative?: ValueTypes["StringCondition"] | undefined | null,
	vocative?: ValueTypes["StringCondition"] | undefined | null,
	customer?: ValueTypes["CustomerWhere"] | undefined | null,
	aliases?: ValueTypes["CustomerAliasWhere"] | undefined | null,
	and?: Array<ValueTypes["CustomerNameWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["CustomerNameWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["CustomerNameWhere"] | undefined | null
};
	["CustomerAliasWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	and?: Array<ValueTypes["CustomerAliasWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["CustomerAliasWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["CustomerAliasWhere"] | undefined | null
};
	["CustomerFamiliarityCondition"]: {
	and?: Array<ValueTypes["CustomerFamiliarityCondition"]> | undefined | null,
	or?: Array<ValueTypes["CustomerFamiliarityCondition"]> | undefined | null,
	not?: ValueTypes["CustomerFamiliarityCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	notEq?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	in?: Array<ValueTypes["CustomerFamiliarity"]> | undefined | null,
	notIn?: Array<ValueTypes["CustomerFamiliarity"]> | undefined | null,
	lt?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	lte?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	gt?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	gte?: ValueTypes["CustomerFamiliarity"] | undefined | null
};
	["CustomerFamiliarity"]:CustomerFamiliarity;
	["ApplicationShortcutListWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	items?: ValueTypes["ApplicationShortcutListItemWhere"] | undefined | null,
	customer?: ValueTypes["CustomerWhere"] | undefined | null,
	and?: Array<ValueTypes["ApplicationShortcutListWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ApplicationShortcutListWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ApplicationShortcutListWhere"] | undefined | null
};
	["ApplicationShortcutListItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	application?: ValueTypes["ApplicationWhere"] | undefined | null,
	list?: ValueTypes["ApplicationShortcutListWhere"] | undefined | null,
	and?: Array<ValueTypes["ApplicationShortcutListItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ApplicationShortcutListItemWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ApplicationShortcutListItemWhere"] | undefined | null
};
	["ApplicationWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	handle?: ValueTypes["StringCondition"] | undefined | null,
	url?: ValueTypes["StringCondition"] | undefined | null,
	color?: ValueTypes["StringCondition"] | undefined | null,
	icon?: ValueTypes["ImageWhere"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	short?: ValueTypes["StringCondition"] | undefined | null,
	and?: Array<ValueTypes["ApplicationWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ApplicationWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ApplicationWhere"] | undefined | null
};
	["InvoicingPlanWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	customer?: ValueTypes["CustomerWhere"] | undefined | null,
	preset?: ValueTypes["InvoicingPresetWhere"] | undefined | null,
	and?: Array<ValueTypes["InvoicingPlanWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["InvoicingPlanWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["InvoicingPlanWhere"] | undefined | null
};
	["InvoicingPresetWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	type?: ValueTypes["InvoicingPresetTypeCondition"] | undefined | null,
	startsAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	endsAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	intervalOfDays?: ValueTypes["IntCondition"] | undefined | null,
	invoicingPlan?: ValueTypes["InvoicingPlanWhere"] | undefined | null,
	and?: Array<ValueTypes["InvoicingPresetWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["InvoicingPresetWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["InvoicingPresetWhere"] | undefined | null
};
	["InvoicingPresetTypeCondition"]: {
	and?: Array<ValueTypes["InvoicingPresetTypeCondition"]> | undefined | null,
	or?: Array<ValueTypes["InvoicingPresetTypeCondition"]> | undefined | null,
	not?: ValueTypes["InvoicingPresetTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["InvoicingPresetType"] | undefined | null,
	notEq?: ValueTypes["InvoicingPresetType"] | undefined | null,
	in?: Array<ValueTypes["InvoicingPresetType"]> | undefined | null,
	notIn?: Array<ValueTypes["InvoicingPresetType"]> | undefined | null,
	lt?: ValueTypes["InvoicingPresetType"] | undefined | null,
	lte?: ValueTypes["InvoicingPresetType"] | undefined | null,
	gt?: ValueTypes["InvoicingPresetType"] | undefined | null,
	gte?: ValueTypes["InvoicingPresetType"] | undefined | null
};
	["InvoicingPresetType"]:InvoicingPresetType;
	["CustomerSpendingWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	totalCents?: ValueTypes["IntCondition"] | undefined | null,
	customer?: ValueTypes["CustomerWhere"] | undefined | null,
	and?: Array<ValueTypes["CustomerSpendingWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["CustomerSpendingWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["CustomerSpendingWhere"] | undefined | null
};
	["CustomerMetadataWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	isBusiness?: ValueTypes["BooleanCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	fallbackName?: ValueTypes["StringCondition"] | undefined | null,
	remainingCreditsCents?: ValueTypes["IntCondition"] | undefined | null,
	ordersTotalCents?: ValueTypes["IntCondition"] | undefined | null,
	customerProfileUrl?: ValueTypes["StringCondition"] | undefined | null,
	customer?: ValueTypes["CustomerWhere"] | undefined | null,
	and?: Array<ValueTypes["CustomerMetadataWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["CustomerMetadataWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["CustomerMetadataWhere"] | undefined | null
};
	["GpsWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	latitude?: ValueTypes["FloatCondition"] | undefined | null,
	longitude?: ValueTypes["FloatCondition"] | undefined | null,
	address?: ValueTypes["AddressWhere"] | undefined | null,
	and?: Array<ValueTypes["GpsWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["GpsWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["GpsWhere"] | undefined | null
};
	["AddressOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	firstName?: ValueTypes["OrderDirection"] | undefined | null,
	lastName?: ValueTypes["OrderDirection"] | undefined | null,
	addressLine2?: ValueTypes["OrderDirection"] | undefined | null,
	email?: ValueTypes["OrderDirection"] | undefined | null,
	phone?: ValueTypes["OrderDirection"] | undefined | null,
	companyName?: ValueTypes["OrderDirection"] | undefined | null,
	companyIdentifier?: ValueTypes["OrderDirection"] | undefined | null,
	vatIdentifier?: ValueTypes["OrderDirection"] | undefined | null,
	externalIdentifier?: ValueTypes["OrderDirection"] | undefined | null,
	hidden?: ValueTypes["OrderDirection"] | undefined | null,
	customer?: ValueTypes["CustomerOrderBy"] | undefined | null,
	internalNote?: ValueTypes["OrderDirection"] | undefined | null,
	country?: ValueTypes["CountryOrderBy"] | undefined | null,
	deletedAt?: ValueTypes["OrderDirection"] | undefined | null,
	note?: ValueTypes["OrderDirection"] | undefined | null,
	googlePlaceId?: ValueTypes["OrderDirection"] | undefined | null,
	raw?: ValueTypes["OrderDirection"] | undefined | null,
	formatted?: ValueTypes["OrderDirection"] | undefined | null,
	geocodeGeneratedAt?: ValueTypes["OrderDirection"] | undefined | null,
	geocodeResponse?: ValueTypes["OrderDirection"] | undefined | null,
	deliveryZone?: ValueTypes["DeliveryZoneOrderBy"] | undefined | null,
	meta?: ValueTypes["AddressMetadataOrderBy"] | undefined | null,
	gps?: ValueTypes["GpsOrderBy"] | undefined | null,
	geocodeValid?: ValueTypes["OrderDirection"] | undefined | null,
	fullName?: ValueTypes["OrderDirection"] | undefined | null,
	fakturoidSubjectId?: ValueTypes["OrderDirection"] | undefined | null,
	addressLine1?: ValueTypes["OrderDirection"] | undefined | null,
	city?: ValueTypes["OrderDirection"] | undefined | null,
	postalCode?: ValueTypes["OrderDirection"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null,
	defaultDeliveryAddressOfCustomer?: ValueTypes["CustomerOrderBy"] | undefined | null
};
	["OrderDirection"]:OrderDirection;
	["CustomerOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	defaultBillingAddress?: ValueTypes["AddressOrderBy"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerPaymentMethodOrderBy"] | undefined | null,
	permissions?: ValueTypes["CustomerPermissionsOrderBy"] | undefined | null,
	group?: ValueTypes["CustomerGroupOrderBy"] | undefined | null,
	photo?: ValueTypes["ImageOrderBy"] | undefined | null,
	phone?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["CustomerNameOrderBy"] | undefined | null,
	internalNote?: ValueTypes["OrderDirection"] | undefined | null,
	welcomeMessage?: ValueTypes["OrderDirection"] | undefined | null,
	familiarity?: ValueTypes["OrderDirection"] | undefined | null,
	business?: ValueTypes["BusinessCustomerOrderBy"] | undefined | null,
	shortcutList?: ValueTypes["ApplicationShortcutListOrderBy"] | undefined | null,
	user?: ValueTypes["UserOrderBy"] | undefined | null,
	disabledAt?: ValueTypes["OrderDirection"] | undefined | null,
	invoicingPlan?: ValueTypes["InvoicingPlanOrderBy"] | undefined | null,
	email?: ValueTypes["OrderDirection"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null,
	defaultDeliveryAddress?: ValueTypes["AddressOrderBy"] | undefined | null,
	defaultBillingSubject?: ValueTypes["BillingSubjectOrderBy"] | undefined | null,
	prefersPackingsWithoutCardboard?: ValueTypes["OrderDirection"] | undefined | null,
	anonymousSession?: ValueTypes["AnonymousSessionOrderBy"] | undefined | null,
	spending?: ValueTypes["CustomerSpendingOrderBy"] | undefined | null,
	doubleshotLegacyId?: ValueTypes["OrderDirection"] | undefined | null,
	meta?: ValueTypes["CustomerMetadataOrderBy"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["OrderDirection"] | undefined | null
};
	["CustomerPaymentMethodOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	caption?: ValueTypes["OrderDirection"] | undefined | null,
	data?: ValueTypes["OrderDirection"] | undefined | null,
	customer?: ValueTypes["CustomerOrderBy"] | undefined | null,
	paymentMethod?: ValueTypes["PaymentMethodOrderBy"] | undefined | null
};
	["PaymentMethodOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	code?: ValueTypes["OrderDirection"] | undefined | null,
	enabled?: ValueTypes["OrderDirection"] | undefined | null,
	description?: ValueTypes["OrderDirection"] | undefined | null,
	internalNote?: ValueTypes["OrderDirection"] | undefined | null,
	blockingDispatch?: ValueTypes["OrderDirection"] | undefined | null,
	type?: ValueTypes["OrderDirection"] | undefined | null,
	reduceGratuityByPercentage?: ValueTypes["OrderDirection"] | undefined | null
};
	["CustomerPermissionsOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	canPlaceOrder?: ValueTypes["OrderDirection"] | undefined | null,
	customer?: ValueTypes["CustomerOrderBy"] | undefined | null
};
	["CustomerGroupOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	discountPermille?: ValueTypes["OrderDirection"] | undefined | null,
	code?: ValueTypes["OrderDirection"] | undefined | null,
	doubleshotLegacyId?: ValueTypes["OrderDirection"] | undefined | null
};
	["ImageOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	url?: ValueTypes["OrderDirection"] | undefined | null,
	width?: ValueTypes["OrderDirection"] | undefined | null,
	height?: ValueTypes["OrderDirection"] | undefined | null,
	size?: ValueTypes["OrderDirection"] | undefined | null,
	type?: ValueTypes["OrderDirection"] | undefined | null,
	alt?: ValueTypes["OrderDirection"] | undefined | null
};
	["CustomerNameOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	nominative?: ValueTypes["OrderDirection"] | undefined | null,
	vocative?: ValueTypes["OrderDirection"] | undefined | null,
	customer?: ValueTypes["CustomerOrderBy"] | undefined | null
};
	["BusinessCustomerOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	customer?: ValueTypes["CustomerOrderBy"] | undefined | null,
	category?: ValueTypes["BusinessCategoryOrderBy"] | undefined | null,
	accountManager?: ValueTypes["BusinessToBusinessManagerOrderBy"] | undefined | null,
	logo?: ValueTypes["ImageOrderBy"] | undefined | null,
	note?: ValueTypes["OrderDirection"] | undefined | null,
	doubleshotCoffeeEquipment?: ValueTypes["DoubleshotCoffeeEquipmentOrderBy"] | undefined | null
};
	["BusinessCategoryOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null,
	visibleToNewCustomers?: ValueTypes["OrderDirection"] | undefined | null,
	internalName?: ValueTypes["OrderDirection"] | undefined | null,
	specificProducts?: ValueTypes["ProductListOrderBy"] | undefined | null,
	seasonalProductCategories?: ValueTypes["ProductCategoryListOrderBy"] | undefined | null,
	specificProductsProductCategories?: ValueTypes["ProductCategoryListOrderBy"] | undefined | null,
	slug?: ValueTypes["OrderDirection"] | undefined | null
};
	["ProductListOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	businessCategory?: ValueTypes["BusinessCategoryOrderBy"] | undefined | null
};
	["ProductCategoryListOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	seasonalProductCategoriesOfBusinessCategory?: ValueTypes["BusinessCategoryOrderBy"] | undefined | null,
	specificProductsProductCategoriesOfBusinessCategory?: ValueTypes["BusinessCategoryOrderBy"] | undefined | null
};
	["BusinessToBusinessManagerOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	staff?: ValueTypes["StaffOrderBy"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null
};
	["StaffOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	bartender?: ValueTypes["BartenderOrderBy"] | undefined | null,
	courier?: ValueTypes["CourierOrderBy"] | undefined | null,
	cleaner?: ValueTypes["CleanerOrderBy"] | undefined | null,
	shiftsManager?: ValueTypes["ShiftsManagerOrderBy"] | undefined | null,
	businessToBusinessManager?: ValueTypes["BusinessToBusinessManagerOrderBy"] | undefined | null,
	user?: ValueTypes["UserOrderBy"] | undefined | null,
	shiftsProfile?: ValueTypes["ShiftsProfileOrderBy"] | undefined | null,
	stocksManager?: ValueTypes["StocksManagerOrderBy"] | undefined | null,
	photo?: ValueTypes["ImageOrderBy"] | undefined | null,
	courierManager?: ValueTypes["CourierManagerOrderBy"] | undefined | null,
	picker?: ValueTypes["PickerOrderBy"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null,
	remunerationProfile?: ValueTypes["RemunerationProfileOrderBy"] | undefined | null,
	cashier?: ValueTypes["CashierOrderBy"] | undefined | null,
	internalBuyer?: ValueTypes["InternalBuyerOrderBy"] | undefined | null,
	salesManager?: ValueTypes["SalesManagerOrderBy"] | undefined | null,
	cashierManager?: ValueTypes["CashierManagerOrderBy"] | undefined | null
};
	["BartenderOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	staff?: ValueTypes["StaffOrderBy"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null
};
	["CourierOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	staff?: ValueTypes["StaffOrderBy"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null,
	showInPicker?: ValueTypes["OrderDirection"] | undefined | null
};
	["CleanerOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	staff?: ValueTypes["StaffOrderBy"] | undefined | null,
	canReachTopShelf?: ValueTypes["OrderDirection"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null
};
	["ShiftsManagerOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	staff?: ValueTypes["StaffOrderBy"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null
};
	["UserOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	internalNote?: ValueTypes["OrderDirection"] | undefined | null,
	staff?: ValueTypes["StaffOrderBy"] | undefined | null,
	customer?: ValueTypes["CustomerOrderBy"] | undefined | null,
	tenantPersonId?: ValueTypes["OrderDirection"] | undefined | null,
	disabledAt?: ValueTypes["OrderDirection"] | undefined | null,
	verifiedAt?: ValueTypes["OrderDirection"] | undefined | null,
	email?: ValueTypes["OrderDirection"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null,
	deletionRequestedAt?: ValueTypes["OrderDirection"] | undefined | null,
	deletionExpectedAt?: ValueTypes["OrderDirection"] | undefined | null,
	deletedAt?: ValueTypes["OrderDirection"] | undefined | null,
	meta?: ValueTypes["UserMetadataOrderBy"] | undefined | null,
	roles?: ValueTypes["UserRolesOrderBy"] | undefined | null
};
	["UserMetadataOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	userProfileUrl?: ValueTypes["OrderDirection"] | undefined | null,
	tenantEmail?: ValueTypes["OrderDirection"] | undefined | null,
	tenantPersonId?: ValueTypes["OrderDirection"] | undefined | null,
	tenantIdentityId?: ValueTypes["OrderDirection"] | undefined | null,
	globalRoles?: ValueTypes["OrderDirection"] | undefined | null,
	projectRoles?: ValueTypes["OrderDirection"] | undefined | null,
	projectRolesString?: ValueTypes["OrderDirection"] | undefined | null,
	externalIdentifiers?: ValueTypes["OrderDirection"] | undefined | null,
	externalIdentifiersString?: ValueTypes["OrderDirection"] | undefined | null,
	idpSlugs?: ValueTypes["OrderDirection"] | undefined | null,
	idpSlugsString?: ValueTypes["OrderDirection"] | undefined | null,
	user?: ValueTypes["UserOrderBy"] | undefined | null
};
	["UserRolesOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	isCustomer?: ValueTypes["OrderDirection"] | undefined | null,
	isStaff?: ValueTypes["OrderDirection"] | undefined | null,
	isBartender?: ValueTypes["OrderDirection"] | undefined | null,
	isCashier?: ValueTypes["OrderDirection"] | undefined | null,
	isCourier?: ValueTypes["OrderDirection"] | undefined | null,
	isCleaner?: ValueTypes["OrderDirection"] | undefined | null,
	isShiftsManager?: ValueTypes["OrderDirection"] | undefined | null,
	isInternalBuyer?: ValueTypes["OrderDirection"] | undefined | null,
	isStocksManager?: ValueTypes["OrderDirection"] | undefined | null,
	isCourierManager?: ValueTypes["OrderDirection"] | undefined | null,
	isCashierManager?: ValueTypes["OrderDirection"] | undefined | null,
	isBusinessToBusinessManager?: ValueTypes["OrderDirection"] | undefined | null,
	isPicker?: ValueTypes["OrderDirection"] | undefined | null,
	user?: ValueTypes["UserOrderBy"] | undefined | null
};
	["ShiftsProfileOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	staff?: ValueTypes["StaffOrderBy"] | undefined | null,
	allowSelfUnassigning?: ValueTypes["OrderDirection"] | undefined | null
};
	["StocksManagerOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	staff?: ValueTypes["StaffOrderBy"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null
};
	["CourierManagerOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	staff?: ValueTypes["StaffOrderBy"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null
};
	["PickerOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	staff?: ValueTypes["StaffOrderBy"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null
};
	["RemunerationProfileOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	workMonths?: ValueTypes["WorkMonthOrderBy"] | undefined | null,
	staff?: ValueTypes["StaffOrderBy"] | undefined | null
};
	["WorkMonthOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	year?: ValueTypes["OrderDirection"] | undefined | null,
	month?: ValueTypes["OrderDirection"] | undefined | null,
	hoursWorked?: ValueTypes["OrderDirection"] | undefined | null,
	billableHours?: ValueTypes["OrderDirection"] | undefined | null
};
	["CashierOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null,
	staff?: ValueTypes["StaffOrderBy"] | undefined | null
};
	["InternalBuyerOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null,
	staff?: ValueTypes["StaffOrderBy"] | undefined | null
};
	["SalesManagerOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	staff?: ValueTypes["StaffOrderBy"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null
};
	["CashierManagerOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null,
	staff?: ValueTypes["StaffOrderBy"] | undefined | null
};
	["DoubleshotCoffeeEquipmentOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	espressoMachine?: ValueTypes["OrderDirection"] | undefined | null,
	espressoGrinder?: ValueTypes["OrderDirection"] | undefined | null,
	batchBrew?: ValueTypes["OrderDirection"] | undefined | null,
	batchGrinder?: ValueTypes["OrderDirection"] | undefined | null,
	waterFilter?: ValueTypes["OrderDirection"] | undefined | null,
	mechanicalFilter?: ValueTypes["OrderDirection"] | undefined | null
};
	["ApplicationShortcutListOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	customer?: ValueTypes["CustomerOrderBy"] | undefined | null
};
	["InvoicingPlanOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	customer?: ValueTypes["CustomerOrderBy"] | undefined | null,
	preset?: ValueTypes["InvoicingPresetOrderBy"] | undefined | null
};
	["InvoicingPresetOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	type?: ValueTypes["OrderDirection"] | undefined | null,
	startsAt?: ValueTypes["OrderDirection"] | undefined | null,
	endsAt?: ValueTypes["OrderDirection"] | undefined | null,
	intervalOfDays?: ValueTypes["OrderDirection"] | undefined | null,
	invoicingPlan?: ValueTypes["InvoicingPlanOrderBy"] | undefined | null
};
	["BillingSubjectOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	fullName?: ValueTypes["OrderDirection"] | undefined | null,
	addressLine1?: ValueTypes["OrderDirection"] | undefined | null,
	addressLine2?: ValueTypes["OrderDirection"] | undefined | null,
	city?: ValueTypes["OrderDirection"] | undefined | null,
	postalCode?: ValueTypes["OrderDirection"] | undefined | null,
	email?: ValueTypes["OrderDirection"] | undefined | null,
	phone?: ValueTypes["OrderDirection"] | undefined | null,
	companyName?: ValueTypes["OrderDirection"] | undefined | null,
	companyIdentifier?: ValueTypes["OrderDirection"] | undefined | null,
	vatIdentifier?: ValueTypes["OrderDirection"] | undefined | null,
	externalIdentifier?: ValueTypes["OrderDirection"] | undefined | null,
	hidden?: ValueTypes["OrderDirection"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null,
	deletedAt?: ValueTypes["OrderDirection"] | undefined | null,
	note?: ValueTypes["OrderDirection"] | undefined | null,
	internalNote?: ValueTypes["OrderDirection"] | undefined | null,
	fakturoidSubjectId?: ValueTypes["OrderDirection"] | undefined | null,
	country?: ValueTypes["CountryOrderBy"] | undefined | null,
	customer?: ValueTypes["CustomerOrderBy"] | undefined | null,
	defaultBillingSubjectOfCustomer?: ValueTypes["CustomerOrderBy"] | undefined | null
};
	["CountryOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	code?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null
};
	["AnonymousSessionOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null,
	lastActiveAt?: ValueTypes["OrderDirection"] | undefined | null,
	anonymousSessionKey?: ValueTypes["OrderDirection"] | undefined | null,
	email?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	internalNote?: ValueTypes["OrderDirection"] | undefined | null,
	customer?: ValueTypes["CustomerOrderBy"] | undefined | null
};
	["CustomerSpendingOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	totalCents?: ValueTypes["OrderDirection"] | undefined | null,
	customer?: ValueTypes["CustomerOrderBy"] | undefined | null
};
	["CustomerMetadataOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	isBusiness?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	fallbackName?: ValueTypes["OrderDirection"] | undefined | null,
	remainingCreditsCents?: ValueTypes["OrderDirection"] | undefined | null,
	ordersTotalCents?: ValueTypes["OrderDirection"] | undefined | null,
	customerProfileUrl?: ValueTypes["OrderDirection"] | undefined | null,
	customer?: ValueTypes["CustomerOrderBy"] | undefined | null
};
	["DeliveryZoneOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	code?: ValueTypes["OrderDirection"] | undefined | null,
	description?: ValueTypes["OrderDirection"] | undefined | null,
	internalNote?: ValueTypes["OrderDirection"] | undefined | null,
	type?: ValueTypes["OrderDirection"] | undefined | null
};
	["AddressMetadataOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	deliveryZoneType?: ValueTypes["OrderDirection"] | undefined | null,
	address?: ValueTypes["AddressOrderBy"] | undefined | null,
	deliveryZone?: ValueTypes["DeliveryZoneOrderBy"] | undefined | null
};
	["GpsOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	latitude?: ValueTypes["OrderDirection"] | undefined | null,
	longitude?: ValueTypes["OrderDirection"] | undefined | null,
	address?: ValueTypes["AddressOrderBy"] | undefined | null
};
	["CustomerPaymentMethod"]: AliasType<{
	_meta?:ValueTypes["CustomerPaymentMethodMeta"],
	id?:boolean | `@${string}`,
	caption?:boolean | `@${string}`,
	data?:boolean | `@${string}`,
customer?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
paymentMethod?: [{	filter?: ValueTypes["PaymentMethodWhere"] | undefined | null},ValueTypes["PaymentMethod"]],
		__typename?: boolean | `@${string}`
}>;
	["CustomerPaymentMethodMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	caption?:ValueTypes["FieldMeta"],
	data?:ValueTypes["FieldMeta"],
	customer?:ValueTypes["FieldMeta"],
	paymentMethod?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Json"]:unknown;
	["PaymentMethod"]: AliasType<{
	_meta?:ValueTypes["PaymentMethodMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
	enabled?:boolean | `@${string}`,
deliveryMethods?: [{	filter?: ValueTypes["DeliveryMethodWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryMethodOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["DeliveryMethod"]],
	description?:boolean | `@${string}`,
	internalNote?:boolean | `@${string}`,
	blockingDispatch?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
channels?: [{	filter?: ValueTypes["ChannelPaymentWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ChannelPaymentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ChannelPayment"]],
	reduceGratuityByPercentage?:boolean | `@${string}`,
paginateDeliveryMethods?: [{	filter?: ValueTypes["DeliveryMethodWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryMethodOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["DeliveryMethodConnection"]],
paginateChannels?: [{	filter?: ValueTypes["ChannelPaymentWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ChannelPaymentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ChannelPaymentConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["PaymentMethodMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	code?:ValueTypes["FieldMeta"],
	enabled?:ValueTypes["FieldMeta"],
	deliveryMethods?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
	internalNote?:ValueTypes["FieldMeta"],
	blockingDispatch?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	channels?:ValueTypes["FieldMeta"],
	reduceGratuityByPercentage?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryMethod"]: AliasType<{
	_meta?:ValueTypes["DeliveryMethodMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
	enabled?:boolean | `@${string}`,
paymentMethods?: [{	filter?: ValueTypes["PaymentMethodWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PaymentMethodOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PaymentMethod"]],
	description?:boolean | `@${string}`,
	internalNote?:boolean | `@${string}`,
	requireDeliveryAddress?:boolean | `@${string}`,
suitableForDeliveryZones?: [{	filter?: ValueTypes["DeliveryZoneWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryZoneOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["DeliveryZone"]],
channels?: [{	filter?: ValueTypes["ChannelDeliveryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ChannelDeliveryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ChannelDelivery"]],
courierHandlers?: [{	filter?: ValueTypes["CourierWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CourierOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Courier"]],
	enableDeliveryTracking?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["DeliveryMethodLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryMethodLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["DeliveryMethodLocale"]],
timelinePreset?: [{	filter?: ValueTypes["DeliveryTimelinePresetWhere"] | undefined | null},ValueTypes["DeliveryTimelinePreset"]],
	woltDriveVenueId?:boolean | `@${string}`,
localesByLocale?: [{	by: ValueTypes["DeliveryMethodLocalesByLocaleUniqueWhere"],	filter?: ValueTypes["DeliveryMethodLocaleWhere"] | undefined | null},ValueTypes["DeliveryMethodLocale"]],
paginatePaymentMethods?: [{	filter?: ValueTypes["PaymentMethodWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PaymentMethodOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PaymentMethodConnection"]],
paginateSuitableForDeliveryZones?: [{	filter?: ValueTypes["DeliveryZoneWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryZoneOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["DeliveryZoneConnection"]],
paginateChannels?: [{	filter?: ValueTypes["ChannelDeliveryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ChannelDeliveryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ChannelDeliveryConnection"]],
paginateCourierHandlers?: [{	filter?: ValueTypes["CourierWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CourierOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CourierConnection"]],
paginateLocales?: [{	filter?: ValueTypes["DeliveryMethodLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryMethodLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["DeliveryMethodLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryMethodMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	code?:ValueTypes["FieldMeta"],
	enabled?:ValueTypes["FieldMeta"],
	paymentMethods?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
	internalNote?:ValueTypes["FieldMeta"],
	requireDeliveryAddress?:ValueTypes["FieldMeta"],
	suitableForDeliveryZones?:ValueTypes["FieldMeta"],
	channels?:ValueTypes["FieldMeta"],
	courierHandlers?:ValueTypes["FieldMeta"],
	enableDeliveryTracking?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	timelinePreset?:ValueTypes["FieldMeta"],
	woltDriveVenueId?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryZone"]: AliasType<{
	_meta?:ValueTypes["DeliveryZoneMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	internalNote?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
addresses?: [{	filter?: ValueTypes["AddressWhere"] | undefined | null,	orderBy?: Array<ValueTypes["AddressOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Address"]],
suitableDeliveryMethods?: [{	filter?: ValueTypes["DeliveryMethodWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryMethodOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["DeliveryMethod"]],
deliveryZonesOfTags?: [{	filter?: ValueTypes["TagWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TagOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Tag"]],
deliveryZonesOfProducts?: [{	filter?: ValueTypes["ProductWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Product"]],
addressesMetadata?: [{	filter?: ValueTypes["AddressMetadataWhere"] | undefined | null,	orderBy?: Array<ValueTypes["AddressMetadataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["AddressMetadata"]],
addressesByMeta?: [{	by: ValueTypes["DeliveryZoneAddressesByMetaUniqueWhere"],	filter?: ValueTypes["AddressWhere"] | undefined | null},ValueTypes["Address"]],
addressesByGps?: [{	by: ValueTypes["DeliveryZoneAddressesByGpsUniqueWhere"],	filter?: ValueTypes["AddressWhere"] | undefined | null},ValueTypes["Address"]],
addressesByInvoices?: [{	by: ValueTypes["DeliveryZoneAddressesByInvoicesUniqueWhere"],	filter?: ValueTypes["AddressWhere"] | undefined | null},ValueTypes["Address"]],
addressesByBillingAddressOfOrders?: [{	by: ValueTypes["DeliveryZoneAddressesByBillingAddressOfOrdersUniqueWhere"],	filter?: ValueTypes["AddressWhere"] | undefined | null},ValueTypes["Address"]],
addressesByDeliveryAddressOfOrderDeliveries?: [{	by: ValueTypes["DeliveryZoneAddressesByDeliveryAddressOfOrderDeliveriesUniqueWhere"],	filter?: ValueTypes["AddressWhere"] | undefined | null},ValueTypes["Address"]],
addressesByDefaultDeliveryAddressOfCustomer?: [{	by: ValueTypes["DeliveryZoneAddressesByDefaultDeliveryAddressOfCustomerUniqueWhere"],	filter?: ValueTypes["AddressWhere"] | undefined | null},ValueTypes["Address"]],
addressesMetadataByAddress?: [{	by: ValueTypes["DeliveryZoneAddressesMetadataByAddressUniqueWhere"],	filter?: ValueTypes["AddressMetadataWhere"] | undefined | null},ValueTypes["AddressMetadata"]],
paginateAddresses?: [{	filter?: ValueTypes["AddressWhere"] | undefined | null,	orderBy?: Array<ValueTypes["AddressOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["AddressConnection"]],
paginateSuitableDeliveryMethods?: [{	filter?: ValueTypes["DeliveryMethodWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryMethodOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["DeliveryMethodConnection"]],
paginateDeliveryZonesOfTags?: [{	filter?: ValueTypes["TagWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TagOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TagConnection"]],
paginateDeliveryZonesOfProducts?: [{	filter?: ValueTypes["ProductWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductConnection"]],
paginateAddressesMetadata?: [{	filter?: ValueTypes["AddressMetadataWhere"] | undefined | null,	orderBy?: Array<ValueTypes["AddressMetadataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["AddressMetadataConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryZoneMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	code?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
	internalNote?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	addresses?:ValueTypes["FieldMeta"],
	suitableDeliveryMethods?:ValueTypes["FieldMeta"],
	deliveryZonesOfTags?:ValueTypes["FieldMeta"],
	deliveryZonesOfProducts?:ValueTypes["FieldMeta"],
	addressesMetadata?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryMethodOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	code?: ValueTypes["OrderDirection"] | undefined | null,
	enabled?: ValueTypes["OrderDirection"] | undefined | null,
	description?: ValueTypes["OrderDirection"] | undefined | null,
	internalNote?: ValueTypes["OrderDirection"] | undefined | null,
	requireDeliveryAddress?: ValueTypes["OrderDirection"] | undefined | null,
	enableDeliveryTracking?: ValueTypes["OrderDirection"] | undefined | null,
	timelinePreset?: ValueTypes["DeliveryTimelinePresetOrderBy"] | undefined | null,
	woltDriveVenueId?: ValueTypes["OrderDirection"] | undefined | null
};
	["DeliveryTimelinePresetOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	type?: ValueTypes["OrderDirection"] | undefined | null,
	duration?: ValueTypes["OrderDirection"] | undefined | null,
	window?: ValueTypes["OrderDirection"] | undefined | null,
	deliveryMethod?: ValueTypes["DeliveryMethodOrderBy"] | undefined | null
};
	["Tag"]: AliasType<{
	_meta?:ValueTypes["TagMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
customers?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Customer"]],
products?: [{	filter?: ValueTypes["ProductWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Product"]],
categories?: [{	filter?: ValueTypes["ProductCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCategoryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductCategory"]],
	description?:boolean | `@${string}`,
	internalNote?:boolean | `@${string}`,
addTagsOnRegistration?: [{	filter?: ValueTypes["ChannelWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ChannelOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Channel"]],
nestedCategories?: [{	filter?: ValueTypes["InheritedProductCategoryTagWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InheritedProductCategoryTagOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["InheritedProductCategoryTag"]],
deliveryZones?: [{	filter?: ValueTypes["DeliveryZoneWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryZoneOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["DeliveryZone"]],
publicInChannels?: [{	filter?: ValueTypes["ChannelWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ChannelOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Channel"]],
allowChannelPayments?: [{	filter?: ValueTypes["ChannelPaymentWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ChannelPaymentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ChannelPayment"]],
fulfillmentNotes?: [{	filter?: ValueTypes["FulfillmentNoteWhere"] | undefined | null,	orderBy?: Array<ValueTypes["FulfillmentNoteOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["FulfillmentNote"]],
paginateCustomers?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerConnection"]],
paginateProducts?: [{	filter?: ValueTypes["ProductWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductConnection"]],
paginateCategories?: [{	filter?: ValueTypes["ProductCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCategoryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductCategoryConnection"]],
paginateAddTagsOnRegistration?: [{	filter?: ValueTypes["ChannelWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ChannelOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ChannelConnection"]],
paginateNestedCategories?: [{	filter?: ValueTypes["InheritedProductCategoryTagWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InheritedProductCategoryTagOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["InheritedProductCategoryTagConnection"]],
paginateDeliveryZones?: [{	filter?: ValueTypes["DeliveryZoneWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryZoneOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["DeliveryZoneConnection"]],
paginatePublicInChannels?: [{	filter?: ValueTypes["ChannelWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ChannelOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ChannelConnection"]],
paginateAllowChannelPayments?: [{	filter?: ValueTypes["ChannelPaymentWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ChannelPaymentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ChannelPaymentConnection"]],
paginateFulfillmentNotes?: [{	filter?: ValueTypes["FulfillmentNoteWhere"] | undefined | null,	orderBy?: Array<ValueTypes["FulfillmentNoteOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["FulfillmentNoteConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["TagMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	code?:ValueTypes["FieldMeta"],
	customers?:ValueTypes["FieldMeta"],
	products?:ValueTypes["FieldMeta"],
	categories?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
	internalNote?:ValueTypes["FieldMeta"],
	addTagsOnRegistration?:ValueTypes["FieldMeta"],
	nestedCategories?:ValueTypes["FieldMeta"],
	deliveryZones?:ValueTypes["FieldMeta"],
	publicInChannels?:ValueTypes["FieldMeta"],
	allowChannelPayments?:ValueTypes["FieldMeta"],
	fulfillmentNotes?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Product"]: AliasType<{
	_meta?:ValueTypes["ProductMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
	priceCents?:boolean | `@${string}`,
	notDiscountable?:boolean | `@${string}`,
packing?: [{	filter?: ValueTypes["ProductPackingWhere"] | undefined | null},ValueTypes["ProductPacking"]],
recipe?: [{	filter?: ValueTypes["ProductRecipeWhere"] | undefined | null},ValueTypes["ProductRecipe"]],
tags?: [{	filter?: ValueTypes["TagWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TagOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Tag"]],
categories?: [{	filter?: ValueTypes["ProductCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCategoryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductCategory"]],
vatRate?: [{	filter?: ValueTypes["VatRateWhere"] | undefined | null},ValueTypes["VatRate"]],
stocks?: [{	filter?: ValueTypes["ProductStockWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductStockOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductStock"]],
groupPrices?: [{	filter?: ValueTypes["ProductGroupPriceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductGroupPriceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductGroupPrice"]],
image?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null},ValueTypes["Image"]],
	description?:boolean | `@${string}`,
	internalNote?:boolean | `@${string}`,
cartItems?: [{	filter?: ValueTypes["CartItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CartItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CartItem"]],
	availability?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
manager?: [{	filter?: ValueTypes["StocksManagerWhere"] | undefined | null},ValueTypes["StocksManager"]],
orderItems?: [{	filter?: ValueTypes["OrderItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["OrderItem"]],
	maximumQuantityPerOrder?:boolean | `@${string}`,
inheritedCategories?: [{	filter?: ValueTypes["NestedProductCategoryProductWhere"] | undefined | null,	orderBy?: Array<ValueTypes["NestedProductCategoryProductOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["NestedProductCategoryProduct"]],
deliveryZones?: [{	filter?: ValueTypes["DeliveryZoneWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryZoneOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["DeliveryZone"]],
locales?: [{	filter?: ValueTypes["ProductLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductLocale"]],
	archivedAt?:boolean | `@${string}`,
customerPrices?: [{	filter?: ValueTypes["ProductCustomerPriceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCustomerPriceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductCustomerPrice"]],
virtualProduct?: [{	filter?: ValueTypes["VirtualProductWhere"] | undefined | null},ValueTypes["VirtualProduct"]],
meta?: [{	filter?: ValueTypes["ProductMetadataWhere"] | undefined | null},ValueTypes["ProductMetadata"]],
page?: [{	filter?: ValueTypes["PageWhere"] | undefined | null},ValueTypes["Page"]],
salesDays?: [{	filter?: ValueTypes["ProductSalesDayWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductSalesDayOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductSalesDay"]],
salesWeeks?: [{	filter?: ValueTypes["ProductSalesWeekWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductSalesWeekOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductSalesWeek"]],
salesMonths?: [{	filter?: ValueTypes["ProductSalesMonthWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductSalesMonthOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductSalesMonth"]],
fulfillmentNotes?: [{	filter?: ValueTypes["FulfillmentNoteWhere"] | undefined | null,	orderBy?: Array<ValueTypes["FulfillmentNoteOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["FulfillmentNote"]],
	hasSubscription?:boolean | `@${string}`,
	pointOfSaleTileColor?:boolean | `@${string}`,
stocksByStore?: [{	by: ValueTypes["ProductStocksByStoreUniqueWhere"],	filter?: ValueTypes["ProductStockWhere"] | undefined | null},ValueTypes["ProductStock"]],
groupPricesByGroup?: [{	by: ValueTypes["ProductGroupPricesByGroupUniqueWhere"],	filter?: ValueTypes["ProductGroupPriceWhere"] | undefined | null},ValueTypes["ProductGroupPrice"]],
cartItemsByCart?: [{	by: ValueTypes["ProductCartItemsByCartUniqueWhere"],	filter?: ValueTypes["CartItemWhere"] | undefined | null},ValueTypes["CartItem"]],
orderItemsByVirtualProductEffects?: [{	by: ValueTypes["ProductOrderItemsByVirtualProductEffectsUniqueWhere"],	filter?: ValueTypes["OrderItemWhere"] | undefined | null},ValueTypes["OrderItem"]],
localesByLocale?: [{	by: ValueTypes["ProductLocalesByLocaleUniqueWhere"],	filter?: ValueTypes["ProductLocaleWhere"] | undefined | null},ValueTypes["ProductLocale"]],
localesByFeatureList?: [{	by: ValueTypes["ProductLocalesByFeatureListUniqueWhere"],	filter?: ValueTypes["ProductLocaleWhere"] | undefined | null},ValueTypes["ProductLocale"]],
customerPricesByCustomer?: [{	by: ValueTypes["ProductCustomerPricesByCustomerUniqueWhere"],	filter?: ValueTypes["ProductCustomerPriceWhere"] | undefined | null},ValueTypes["ProductCustomerPrice"]],
paginateTags?: [{	filter?: ValueTypes["TagWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TagOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TagConnection"]],
paginateCategories?: [{	filter?: ValueTypes["ProductCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCategoryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductCategoryConnection"]],
paginateStocks?: [{	filter?: ValueTypes["ProductStockWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductStockOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductStockConnection"]],
paginateGroupPrices?: [{	filter?: ValueTypes["ProductGroupPriceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductGroupPriceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductGroupPriceConnection"]],
paginateCartItems?: [{	filter?: ValueTypes["CartItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CartItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CartItemConnection"]],
paginateOrderItems?: [{	filter?: ValueTypes["OrderItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderItemConnection"]],
paginateInheritedCategories?: [{	filter?: ValueTypes["NestedProductCategoryProductWhere"] | undefined | null,	orderBy?: Array<ValueTypes["NestedProductCategoryProductOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["NestedProductCategoryProductConnection"]],
paginateDeliveryZones?: [{	filter?: ValueTypes["DeliveryZoneWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryZoneOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["DeliveryZoneConnection"]],
paginateLocales?: [{	filter?: ValueTypes["ProductLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductLocaleConnection"]],
paginateCustomerPrices?: [{	filter?: ValueTypes["ProductCustomerPriceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCustomerPriceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductCustomerPriceConnection"]],
paginateSalesDays?: [{	filter?: ValueTypes["ProductSalesDayWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductSalesDayOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductSalesDayConnection"]],
paginateSalesWeeks?: [{	filter?: ValueTypes["ProductSalesWeekWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductSalesWeekOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductSalesWeekConnection"]],
paginateSalesMonths?: [{	filter?: ValueTypes["ProductSalesMonthWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductSalesMonthOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductSalesMonthConnection"]],
paginateFulfillmentNotes?: [{	filter?: ValueTypes["FulfillmentNoteWhere"] | undefined | null,	orderBy?: Array<ValueTypes["FulfillmentNoteOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["FulfillmentNoteConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ProductMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	code?:ValueTypes["FieldMeta"],
	priceCents?:ValueTypes["FieldMeta"],
	notDiscountable?:ValueTypes["FieldMeta"],
	packing?:ValueTypes["FieldMeta"],
	recipe?:ValueTypes["FieldMeta"],
	tags?:ValueTypes["FieldMeta"],
	categories?:ValueTypes["FieldMeta"],
	vatRate?:ValueTypes["FieldMeta"],
	stocks?:ValueTypes["FieldMeta"],
	groupPrices?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
	internalNote?:ValueTypes["FieldMeta"],
	cartItems?:ValueTypes["FieldMeta"],
	availability?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	manager?:ValueTypes["FieldMeta"],
	orderItems?:ValueTypes["FieldMeta"],
	maximumQuantityPerOrder?:ValueTypes["FieldMeta"],
	inheritedCategories?:ValueTypes["FieldMeta"],
	deliveryZones?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	archivedAt?:ValueTypes["FieldMeta"],
	customerPrices?:ValueTypes["FieldMeta"],
	virtualProduct?:ValueTypes["FieldMeta"],
	meta?:ValueTypes["FieldMeta"],
	page?:ValueTypes["FieldMeta"],
	salesDays?:ValueTypes["FieldMeta"],
	salesWeeks?:ValueTypes["FieldMeta"],
	salesMonths?:ValueTypes["FieldMeta"],
	fulfillmentNotes?:ValueTypes["FieldMeta"],
	hasSubscription?:ValueTypes["FieldMeta"],
	pointOfSaleTileColor?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProductPacking"]: AliasType<{
	_meta?:ValueTypes["ProductPackingMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
image?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null},ValueTypes["Image"]],
	description?:boolean | `@${string}`,
	internalNote?:boolean | `@${string}`,
	volumeMl?:boolean | `@${string}`,
icon?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null},ValueTypes["Image"]],
	shortName?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["ProductPackingLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductPackingLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductPackingLocale"]],
preparedPackingQuantities?: [{	filter?: ValueTypes["PreparedPackingQuantityWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PreparedPackingQuantityOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PreparedPackingQuantity"]],
	isPackedInCardboard?:boolean | `@${string}`,
localesByLocale?: [{	by: ValueTypes["ProductPackingLocalesByLocaleUniqueWhere"],	filter?: ValueTypes["ProductPackingLocaleWhere"] | undefined | null},ValueTypes["ProductPackingLocale"]],
paginateLocales?: [{	filter?: ValueTypes["ProductPackingLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductPackingLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductPackingLocaleConnection"]],
paginatePreparedPackingQuantities?: [{	filter?: ValueTypes["PreparedPackingQuantityWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PreparedPackingQuantityOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PreparedPackingQuantityConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ProductPackingMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
	internalNote?:ValueTypes["FieldMeta"],
	volumeMl?:ValueTypes["FieldMeta"],
	icon?:ValueTypes["FieldMeta"],
	shortName?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	preparedPackingQuantities?:ValueTypes["FieldMeta"],
	isPackedInCardboard?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Image"]: AliasType<{
	_meta?:ValueTypes["ImageMeta"],
	id?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
	width?:boolean | `@${string}`,
	height?:boolean | `@${string}`,
	size?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	alt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ImageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	width?:ValueTypes["FieldMeta"],
	height?:ValueTypes["FieldMeta"],
	size?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	alt?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProductPackingLocale"]: AliasType<{
	_meta?:ValueTypes["ProductPackingLocaleMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	shortName?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["ProductPackingWhere"] | undefined | null},ValueTypes["ProductPacking"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null},ValueTypes["Locale"]],
		__typename?: boolean | `@${string}`
}>;
	["ProductPackingLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	shortName?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Locale"]: AliasType<{
	_meta?:ValueTypes["LocaleMeta"],
	id?:boolean | `@${string}`,
businessCategories?: [{	filter?: ValueTypes["BusinessCategoryLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessCategoryLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BusinessCategoryLocale"]],
productCategoryLists?: [{	filter?: ValueTypes["ProductCategoryListLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCategoryListLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductCategoryListLocale"]],
productIngredients?: [{	filter?: ValueTypes["ProductIngredientLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductIngredientLocale"]],
orderRecurrences?: [{	filter?: ValueTypes["OrderRecurrenceLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderRecurrenceLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["OrderRecurrenceLocale"]],
blogs?: [{	filter?: ValueTypes["BlogLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BlogLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BlogLocale"]],
blogPosts?: [{	filter?: ValueTypes["BlogPostLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BlogPostLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BlogPostLocale"]],
identifier?: [{	filter?: ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null},ValueTypes["TranslationCataloguesIdentifier"]],
menus?: [{	filter?: ValueTypes["MenuLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["MenuLocale"]],
pages?: [{	filter?: ValueTypes["PageLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PageLocale"]],
productIngredientCategories?: [{	filter?: ValueTypes["ProductIngredientCategoryLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientCategoryLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductIngredientCategoryLocale"]],
allergens?: [{	filter?: ValueTypes["AllergenLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["AllergenLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["AllergenLocale"]],
productPackings?: [{	filter?: ValueTypes["ProductPackingLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductPackingLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductPackingLocale"]],
products?: [{	filter?: ValueTypes["ProductLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductLocale"]],
productRecipes?: [{	filter?: ValueTypes["ProductRecipeLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductRecipeLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductRecipeLocale"]],
pointOfSaleCategories?: [{	filter?: ValueTypes["PointOfSaleCategoryLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleCategoryLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PointOfSaleCategoryLocale"]],
pointOfSaleCategoryProducts?: [{	filter?: ValueTypes["PointOfSaleCategoryProductLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleCategoryProductLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PointOfSaleCategoryProductLocale"]],
deliveryMethods?: [{	filter?: ValueTypes["DeliveryMethodLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryMethodLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["DeliveryMethodLocale"]],
ingredientSuppliers?: [{	filter?: ValueTypes["IngredientSupplierLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IngredientSupplierLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["IngredientSupplierLocale"]],
identificationCodes?: [{	filter?: ValueTypes["IdentificationCodeLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IdentificationCodeLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["IdentificationCodeLocale"]],
pipelineStages?: [{	filter?: ValueTypes["PipelineStageLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PipelineStageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PipelineStageLocale"]],
subscriptionBoxes?: [{	filter?: ValueTypes["SubscriptionBoxLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SubscriptionBoxLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["SubscriptionBoxLocale"]],
businessServices?: [{	filter?: ValueTypes["BusinessServiceLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessServiceLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BusinessServiceLocale"]],
businessCategoriesByRoot?: [{	by: ValueTypes["LocaleBusinessCategoriesByRootUniqueWhere"],	filter?: ValueTypes["BusinessCategoryLocaleWhere"] | undefined | null},ValueTypes["BusinessCategoryLocale"]],
productCategoryListsByRoot?: [{	by: ValueTypes["LocaleProductCategoryListsByRootUniqueWhere"],	filter?: ValueTypes["ProductCategoryListLocaleWhere"] | undefined | null},ValueTypes["ProductCategoryListLocale"]],
productIngredientsByRoot?: [{	by: ValueTypes["LocaleProductIngredientsByRootUniqueWhere"],	filter?: ValueTypes["ProductIngredientLocaleWhere"] | undefined | null},ValueTypes["ProductIngredientLocale"]],
orderRecurrencesByRoot?: [{	by: ValueTypes["LocaleOrderRecurrencesByRootUniqueWhere"],	filter?: ValueTypes["OrderRecurrenceLocaleWhere"] | undefined | null},ValueTypes["OrderRecurrenceLocale"]],
blogsByRoot?: [{	by: ValueTypes["LocaleBlogsByRootUniqueWhere"],	filter?: ValueTypes["BlogLocaleWhere"] | undefined | null},ValueTypes["BlogLocale"]],
blogPostsByRoot?: [{	by: ValueTypes["LocaleBlogPostsByRootUniqueWhere"],	filter?: ValueTypes["BlogPostLocaleWhere"] | undefined | null},ValueTypes["BlogPostLocale"]],
blogPostsByCover?: [{	by: ValueTypes["LocaleBlogPostsByCoverUniqueWhere"],	filter?: ValueTypes["BlogPostLocaleWhere"] | undefined | null},ValueTypes["BlogPostLocale"]],
blogPostsByContent?: [{	by: ValueTypes["LocaleBlogPostsByContentUniqueWhere"],	filter?: ValueTypes["BlogPostLocaleWhere"] | undefined | null},ValueTypes["BlogPostLocale"]],
blogPostsByLink?: [{	by: ValueTypes["LocaleBlogPostsByLinkUniqueWhere"],	filter?: ValueTypes["BlogPostLocaleWhere"] | undefined | null},ValueTypes["BlogPostLocale"]],
blogPostsBySeo?: [{	by: ValueTypes["LocaleBlogPostsBySeoUniqueWhere"],	filter?: ValueTypes["BlogPostLocaleWhere"] | undefined | null},ValueTypes["BlogPostLocale"]],
menusByRoot?: [{	by: ValueTypes["LocaleMenusByRootUniqueWhere"],	filter?: ValueTypes["MenuLocaleWhere"] | undefined | null},ValueTypes["MenuLocale"]],
menusByItems?: [{	by: ValueTypes["LocaleMenusByItemsUniqueWhere"],	filter?: ValueTypes["MenuLocaleWhere"] | undefined | null},ValueTypes["MenuLocale"]],
menusBySecondaryItems?: [{	by: ValueTypes["LocaleMenusBySecondaryItemsUniqueWhere"],	filter?: ValueTypes["MenuLocaleWhere"] | undefined | null},ValueTypes["MenuLocale"]],
pagesByRoot?: [{	by: ValueTypes["LocalePagesByRootUniqueWhere"],	filter?: ValueTypes["PageLocaleWhere"] | undefined | null},ValueTypes["PageLocale"]],
pagesByLink?: [{	by: ValueTypes["LocalePagesByLinkUniqueWhere"],	filter?: ValueTypes["PageLocaleWhere"] | undefined | null},ValueTypes["PageLocale"]],
pagesBySeo?: [{	by: ValueTypes["LocalePagesBySeoUniqueWhere"],	filter?: ValueTypes["PageLocaleWhere"] | undefined | null},ValueTypes["PageLocale"]],
pagesByContent?: [{	by: ValueTypes["LocalePagesByContentUniqueWhere"],	filter?: ValueTypes["PageLocaleWhere"] | undefined | null},ValueTypes["PageLocale"]],
pagesByCover?: [{	by: ValueTypes["LocalePagesByCoverUniqueWhere"],	filter?: ValueTypes["PageLocaleWhere"] | undefined | null},ValueTypes["PageLocale"]],
productIngredientCategoriesByRoot?: [{	by: ValueTypes["LocaleProductIngredientCategoriesByRootUniqueWhere"],	filter?: ValueTypes["ProductIngredientCategoryLocaleWhere"] | undefined | null},ValueTypes["ProductIngredientCategoryLocale"]],
allergensByRoot?: [{	by: ValueTypes["LocaleAllergensByRootUniqueWhere"],	filter?: ValueTypes["AllergenLocaleWhere"] | undefined | null},ValueTypes["AllergenLocale"]],
productPackingsByRoot?: [{	by: ValueTypes["LocaleProductPackingsByRootUniqueWhere"],	filter?: ValueTypes["ProductPackingLocaleWhere"] | undefined | null},ValueTypes["ProductPackingLocale"]],
productsByRoot?: [{	by: ValueTypes["LocaleProductsByRootUniqueWhere"],	filter?: ValueTypes["ProductLocaleWhere"] | undefined | null},ValueTypes["ProductLocale"]],
productsByFeatureList?: [{	by: ValueTypes["LocaleProductsByFeatureListUniqueWhere"],	filter?: ValueTypes["ProductLocaleWhere"] | undefined | null},ValueTypes["ProductLocale"]],
productRecipesByRoot?: [{	by: ValueTypes["LocaleProductRecipesByRootUniqueWhere"],	filter?: ValueTypes["ProductRecipeLocaleWhere"] | undefined | null},ValueTypes["ProductRecipeLocale"]],
pointOfSaleCategoriesByRoot?: [{	by: ValueTypes["LocalePointOfSaleCategoriesByRootUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryLocaleWhere"] | undefined | null},ValueTypes["PointOfSaleCategoryLocale"]],
pointOfSaleCategoryProductsByRoot?: [{	by: ValueTypes["LocalePointOfSaleCategoryProductsByRootUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryProductLocaleWhere"] | undefined | null},ValueTypes["PointOfSaleCategoryProductLocale"]],
deliveryMethodsByRoot?: [{	by: ValueTypes["LocaleDeliveryMethodsByRootUniqueWhere"],	filter?: ValueTypes["DeliveryMethodLocaleWhere"] | undefined | null},ValueTypes["DeliveryMethodLocale"]],
ingredientSuppliersByRoot?: [{	by: ValueTypes["LocaleIngredientSuppliersByRootUniqueWhere"],	filter?: ValueTypes["IngredientSupplierLocaleWhere"] | undefined | null},ValueTypes["IngredientSupplierLocale"]],
identificationCodesByRoot?: [{	by: ValueTypes["LocaleIdentificationCodesByRootUniqueWhere"],	filter?: ValueTypes["IdentificationCodeLocaleWhere"] | undefined | null},ValueTypes["IdentificationCodeLocale"]],
pipelineStagesByRoot?: [{	by: ValueTypes["LocalePipelineStagesByRootUniqueWhere"],	filter?: ValueTypes["PipelineStageLocaleWhere"] | undefined | null},ValueTypes["PipelineStageLocale"]],
subscriptionBoxesByRoot?: [{	by: ValueTypes["LocaleSubscriptionBoxesByRootUniqueWhere"],	filter?: ValueTypes["SubscriptionBoxLocaleWhere"] | undefined | null},ValueTypes["SubscriptionBoxLocale"]],
subscriptionBoxesByTexts?: [{	by: ValueTypes["LocaleSubscriptionBoxesByTextsUniqueWhere"],	filter?: ValueTypes["SubscriptionBoxLocaleWhere"] | undefined | null},ValueTypes["SubscriptionBoxLocale"]],
subscriptionBoxesBySecondaryTexts?: [{	by: ValueTypes["LocaleSubscriptionBoxesBySecondaryTextsUniqueWhere"],	filter?: ValueTypes["SubscriptionBoxLocaleWhere"] | undefined | null},ValueTypes["SubscriptionBoxLocale"]],
businessServicesByRoot?: [{	by: ValueTypes["LocaleBusinessServicesByRootUniqueWhere"],	filter?: ValueTypes["BusinessServiceLocaleWhere"] | undefined | null},ValueTypes["BusinessServiceLocale"]],
paginateBusinessCategories?: [{	filter?: ValueTypes["BusinessCategoryLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessCategoryLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BusinessCategoryLocaleConnection"]],
paginateProductCategoryLists?: [{	filter?: ValueTypes["ProductCategoryListLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCategoryListLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductCategoryListLocaleConnection"]],
paginateProductIngredients?: [{	filter?: ValueTypes["ProductIngredientLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductIngredientLocaleConnection"]],
paginateOrderRecurrences?: [{	filter?: ValueTypes["OrderRecurrenceLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderRecurrenceLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderRecurrenceLocaleConnection"]],
paginateBlogs?: [{	filter?: ValueTypes["BlogLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BlogLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BlogLocaleConnection"]],
paginateBlogPosts?: [{	filter?: ValueTypes["BlogPostLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BlogPostLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BlogPostLocaleConnection"]],
paginateMenus?: [{	filter?: ValueTypes["MenuLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["MenuLocaleConnection"]],
paginatePages?: [{	filter?: ValueTypes["PageLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PageLocaleConnection"]],
paginateProductIngredientCategories?: [{	filter?: ValueTypes["ProductIngredientCategoryLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientCategoryLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductIngredientCategoryLocaleConnection"]],
paginateAllergens?: [{	filter?: ValueTypes["AllergenLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["AllergenLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["AllergenLocaleConnection"]],
paginateProductPackings?: [{	filter?: ValueTypes["ProductPackingLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductPackingLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductPackingLocaleConnection"]],
paginateProducts?: [{	filter?: ValueTypes["ProductLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductLocaleConnection"]],
paginateProductRecipes?: [{	filter?: ValueTypes["ProductRecipeLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductRecipeLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductRecipeLocaleConnection"]],
paginatePointOfSaleCategories?: [{	filter?: ValueTypes["PointOfSaleCategoryLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleCategoryLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PointOfSaleCategoryLocaleConnection"]],
paginatePointOfSaleCategoryProducts?: [{	filter?: ValueTypes["PointOfSaleCategoryProductLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleCategoryProductLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PointOfSaleCategoryProductLocaleConnection"]],
paginateDeliveryMethods?: [{	filter?: ValueTypes["DeliveryMethodLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryMethodLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["DeliveryMethodLocaleConnection"]],
paginateIngredientSuppliers?: [{	filter?: ValueTypes["IngredientSupplierLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IngredientSupplierLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["IngredientSupplierLocaleConnection"]],
paginateIdentificationCodes?: [{	filter?: ValueTypes["IdentificationCodeLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IdentificationCodeLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["IdentificationCodeLocaleConnection"]],
paginatePipelineStages?: [{	filter?: ValueTypes["PipelineStageLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PipelineStageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PipelineStageLocaleConnection"]],
paginateSubscriptionBoxes?: [{	filter?: ValueTypes["SubscriptionBoxLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SubscriptionBoxLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["SubscriptionBoxLocaleConnection"]],
paginateBusinessServices?: [{	filter?: ValueTypes["BusinessServiceLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessServiceLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BusinessServiceLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["LocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	businessCategories?:ValueTypes["FieldMeta"],
	productCategoryLists?:ValueTypes["FieldMeta"],
	productIngredients?:ValueTypes["FieldMeta"],
	orderRecurrences?:ValueTypes["FieldMeta"],
	blogs?:ValueTypes["FieldMeta"],
	blogPosts?:ValueTypes["FieldMeta"],
	identifier?:ValueTypes["FieldMeta"],
	menus?:ValueTypes["FieldMeta"],
	pages?:ValueTypes["FieldMeta"],
	productIngredientCategories?:ValueTypes["FieldMeta"],
	allergens?:ValueTypes["FieldMeta"],
	productPackings?:ValueTypes["FieldMeta"],
	products?:ValueTypes["FieldMeta"],
	productRecipes?:ValueTypes["FieldMeta"],
	pointOfSaleCategories?:ValueTypes["FieldMeta"],
	pointOfSaleCategoryProducts?:ValueTypes["FieldMeta"],
	deliveryMethods?:ValueTypes["FieldMeta"],
	ingredientSuppliers?:ValueTypes["FieldMeta"],
	identificationCodes?:ValueTypes["FieldMeta"],
	pipelineStages?:ValueTypes["FieldMeta"],
	subscriptionBoxes?:ValueTypes["FieldMeta"],
	businessServices?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessCategoryLocale"]: AliasType<{
	_meta?:ValueTypes["BusinessCategoryLocaleMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["BusinessCategoryWhere"] | undefined | null},ValueTypes["BusinessCategory"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null},ValueTypes["Locale"]],
	title?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["BusinessCategoryLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessCategory"]: AliasType<{
	_meta?:ValueTypes["BusinessCategoryMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	visibleToNewCustomers?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["BusinessCategoryLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessCategoryLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BusinessCategoryLocale"]],
	internalName?:boolean | `@${string}`,
businessCustomers?: [{	filter?: ValueTypes["BusinessCustomerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessCustomerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BusinessCustomer"]],
recurrences?: [{	filter?: ValueTypes["OrderRecurrenceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderRecurrenceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["OrderRecurrence"]],
specificProducts?: [{	filter?: ValueTypes["ProductListWhere"] | undefined | null},ValueTypes["ProductList"]],
seasonalProductCategories?: [{	filter?: ValueTypes["ProductCategoryListWhere"] | undefined | null},ValueTypes["ProductCategoryList"]],
specificProductsProductCategories?: [{	filter?: ValueTypes["ProductCategoryListWhere"] | undefined | null},ValueTypes["ProductCategoryList"]],
	slug?:boolean | `@${string}`,
localesByLocale?: [{	by: ValueTypes["BusinessCategoryLocalesByLocaleUniqueWhere"],	filter?: ValueTypes["BusinessCategoryLocaleWhere"] | undefined | null},ValueTypes["BusinessCategoryLocale"]],
businessCustomersByCustomer?: [{	by: ValueTypes["BusinessCategoryBusinessCustomersByCustomerUniqueWhere"],	filter?: ValueTypes["BusinessCustomerWhere"] | undefined | null},ValueTypes["BusinessCustomer"]],
businessCustomersByBusinessServiceEvents?: [{	by: ValueTypes["BusinessCategoryBusinessCustomersByBusinessServiceEventsUniqueWhere"],	filter?: ValueTypes["BusinessCustomerWhere"] | undefined | null},ValueTypes["BusinessCustomer"]],
businessCustomersByDoubleshotCoffeeEquipment?: [{	by: ValueTypes["BusinessCategoryBusinessCustomersByDoubleshotCoffeeEquipmentUniqueWhere"],	filter?: ValueTypes["BusinessCustomerWhere"] | undefined | null},ValueTypes["BusinessCustomer"]],
paginateLocales?: [{	filter?: ValueTypes["BusinessCategoryLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessCategoryLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BusinessCategoryLocaleConnection"]],
paginateBusinessCustomers?: [{	filter?: ValueTypes["BusinessCustomerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessCustomerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BusinessCustomerConnection"]],
paginateRecurrences?: [{	filter?: ValueTypes["OrderRecurrenceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderRecurrenceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderRecurrenceConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["BusinessCategoryMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	visibleToNewCustomers?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	internalName?:ValueTypes["FieldMeta"],
	businessCustomers?:ValueTypes["FieldMeta"],
	recurrences?:ValueTypes["FieldMeta"],
	specificProducts?:ValueTypes["FieldMeta"],
	seasonalProductCategories?:ValueTypes["FieldMeta"],
	specificProductsProductCategories?:ValueTypes["FieldMeta"],
	slug?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessCategoryLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	root?: ValueTypes["BusinessCategoryOrderBy"] | undefined | null,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null,
	title?: ValueTypes["OrderDirection"] | undefined | null
};
	["LocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	identifier?: ValueTypes["TranslationCataloguesIdentifierOrderBy"] | undefined | null
};
	["TranslationCataloguesIdentifierOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	code?: ValueTypes["OrderDirection"] | undefined | null
};
	["BusinessCustomer"]: AliasType<{
	_meta?:ValueTypes["BusinessCustomerMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
customer?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
owners?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Customer"]],
members?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Customer"]],
category?: [{	filter?: ValueTypes["BusinessCategoryWhere"] | undefined | null},ValueTypes["BusinessCategory"]],
accountManager?: [{	filter?: ValueTypes["BusinessToBusinessManagerWhere"] | undefined | null},ValueTypes["BusinessToBusinessManager"]],
logo?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null},ValueTypes["Image"]],
	note?:boolean | `@${string}`,
businessServiceEvents?: [{	filter?: ValueTypes["BusinessServiceEventWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessServiceEventOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BusinessServiceEvent"]],
doubleshotCoffeeEquipment?: [{	filter?: ValueTypes["DoubleshotCoffeeEquipmentWhere"] | undefined | null},ValueTypes["DoubleshotCoffeeEquipment"]],
paginateOwners?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerConnection"]],
paginateMembers?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerConnection"]],
paginateBusinessServiceEvents?: [{	filter?: ValueTypes["BusinessServiceEventWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessServiceEventOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BusinessServiceEventConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["BusinessCustomerMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	customer?:ValueTypes["FieldMeta"],
	owners?:ValueTypes["FieldMeta"],
	members?:ValueTypes["FieldMeta"],
	category?:ValueTypes["FieldMeta"],
	accountManager?:ValueTypes["FieldMeta"],
	logo?:ValueTypes["FieldMeta"],
	note?:ValueTypes["FieldMeta"],
	businessServiceEvents?:ValueTypes["FieldMeta"],
	doubleshotCoffeeEquipment?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessToBusinessManager"]: AliasType<{
	_meta?:ValueTypes["BusinessToBusinessManagerMeta"],
	id?:boolean | `@${string}`,
staff?: [{	filter?: ValueTypes["StaffWhere"] | undefined | null},ValueTypes["Staff"]],
managedBusinesses?: [{	filter?: ValueTypes["BusinessCustomerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessCustomerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BusinessCustomer"]],
	createdAt?:boolean | `@${string}`,
managedBusinessesByCustomer?: [{	by: ValueTypes["BusinessToBusinessManagerManagedBusinessesByCustomerUniqueWhere"],	filter?: ValueTypes["BusinessCustomerWhere"] | undefined | null},ValueTypes["BusinessCustomer"]],
managedBusinessesByBusinessServiceEvents?: [{	by: ValueTypes["BusinessToBusinessManagerManagedBusinessesByBusinessServiceEventsUniqueWhere"],	filter?: ValueTypes["BusinessCustomerWhere"] | undefined | null},ValueTypes["BusinessCustomer"]],
managedBusinessesByDoubleshotCoffeeEquipment?: [{	by: ValueTypes["BusinessToBusinessManagerManagedBusinessesByDoubleshotCoffeeEquipmentUniqueWhere"],	filter?: ValueTypes["BusinessCustomerWhere"] | undefined | null},ValueTypes["BusinessCustomer"]],
paginateManagedBusinesses?: [{	filter?: ValueTypes["BusinessCustomerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessCustomerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BusinessCustomerConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["BusinessToBusinessManagerMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	staff?:ValueTypes["FieldMeta"],
	managedBusinesses?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Staff"]: AliasType<{
	_meta?:ValueTypes["StaffMeta"],
	id?:boolean | `@${string}`,
bartender?: [{	filter?: ValueTypes["BartenderWhere"] | undefined | null},ValueTypes["Bartender"]],
courier?: [{	filter?: ValueTypes["CourierWhere"] | undefined | null},ValueTypes["Courier"]],
cleaner?: [{	filter?: ValueTypes["CleanerWhere"] | undefined | null},ValueTypes["Cleaner"]],
shiftsManager?: [{	filter?: ValueTypes["ShiftsManagerWhere"] | undefined | null},ValueTypes["ShiftsManager"]],
businessToBusinessManager?: [{	filter?: ValueTypes["BusinessToBusinessManagerWhere"] | undefined | null},ValueTypes["BusinessToBusinessManager"]],
user?: [{	filter?: ValueTypes["UserWhere"] | undefined | null},ValueTypes["User"]],
shiftsProfile?: [{	filter?: ValueTypes["ShiftsProfileWhere"] | undefined | null},ValueTypes["ShiftsProfile"]],
stocksManager?: [{	filter?: ValueTypes["StocksManagerWhere"] | undefined | null},ValueTypes["StocksManager"]],
photo?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null},ValueTypes["Image"]],
courierManager?: [{	filter?: ValueTypes["CourierManagerWhere"] | undefined | null},ValueTypes["CourierManager"]],
picker?: [{	filter?: ValueTypes["PickerWhere"] | undefined | null},ValueTypes["Picker"]],
	createdAt?:boolean | `@${string}`,
remunerationProfile?: [{	filter?: ValueTypes["RemunerationProfileWhere"] | undefined | null},ValueTypes["RemunerationProfile"]],
cashier?: [{	filter?: ValueTypes["CashierWhere"] | undefined | null},ValueTypes["Cashier"]],
venues?: [{	filter?: ValueTypes["VenueWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VenueOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Venue"]],
internalBuyer?: [{	filter?: ValueTypes["InternalBuyerWhere"] | undefined | null},ValueTypes["InternalBuyer"]],
salesManager?: [{	filter?: ValueTypes["SalesManagerWhere"] | undefined | null},ValueTypes["SalesManager"]],
cashierManager?: [{	filter?: ValueTypes["CashierManagerWhere"] | undefined | null},ValueTypes["CashierManager"]],
paginateVenues?: [{	filter?: ValueTypes["VenueWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VenueOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["VenueConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["StaffMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	bartender?:ValueTypes["FieldMeta"],
	courier?:ValueTypes["FieldMeta"],
	cleaner?:ValueTypes["FieldMeta"],
	shiftsManager?:ValueTypes["FieldMeta"],
	businessToBusinessManager?:ValueTypes["FieldMeta"],
	user?:ValueTypes["FieldMeta"],
	shiftsProfile?:ValueTypes["FieldMeta"],
	stocksManager?:ValueTypes["FieldMeta"],
	photo?:ValueTypes["FieldMeta"],
	courierManager?:ValueTypes["FieldMeta"],
	picker?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	remunerationProfile?:ValueTypes["FieldMeta"],
	cashier?:ValueTypes["FieldMeta"],
	venues?:ValueTypes["FieldMeta"],
	internalBuyer?:ValueTypes["FieldMeta"],
	salesManager?:ValueTypes["FieldMeta"],
	cashierManager?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Bartender"]: AliasType<{
	_meta?:ValueTypes["BartenderMeta"],
	id?:boolean | `@${string}`,
staff?: [{	filter?: ValueTypes["StaffWhere"] | undefined | null},ValueTypes["Staff"]],
	createdAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["BartenderMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	staff?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Courier"]: AliasType<{
	_meta?:ValueTypes["CourierMeta"],
	id?:boolean | `@${string}`,
staff?: [{	filter?: ValueTypes["StaffWhere"] | undefined | null},ValueTypes["Staff"]],
routes?: [{	filter?: ValueTypes["DeliveryRouteWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryRouteOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["DeliveryRoute"]],
	createdAt?:boolean | `@${string}`,
deliveryMethods?: [{	filter?: ValueTypes["DeliveryMethodWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryMethodOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["DeliveryMethod"]],
	showInPicker?:boolean | `@${string}`,
routesByWaypoints?: [{	by: ValueTypes["CourierRoutesByWaypointsUniqueWhere"],	filter?: ValueTypes["DeliveryRouteWhere"] | undefined | null},ValueTypes["DeliveryRoute"]],
paginateRoutes?: [{	filter?: ValueTypes["DeliveryRouteWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryRouteOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["DeliveryRouteConnection"]],
paginateDeliveryMethods?: [{	filter?: ValueTypes["DeliveryMethodWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryMethodOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["DeliveryMethodConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["CourierMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	staff?:ValueTypes["FieldMeta"],
	routes?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	deliveryMethods?:ValueTypes["FieldMeta"],
	showInPicker?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryRoute"]: AliasType<{
	_meta?:ValueTypes["DeliveryRouteMeta"],
	id?:boolean | `@${string}`,
courier?: [{	filter?: ValueTypes["CourierWhere"] | undefined | null},ValueTypes["Courier"]],
	createdAt?:boolean | `@${string}`,
waypoints?: [{	filter?: ValueTypes["DeliveryWaypointWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryWaypointOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["DeliveryWaypoint"]],
	dispatchAt?:boolean | `@${string}`,
waypointsByDelivery?: [{	by: ValueTypes["DeliveryRouteWaypointsByDeliveryUniqueWhere"],	filter?: ValueTypes["DeliveryWaypointWhere"] | undefined | null},ValueTypes["DeliveryWaypoint"]],
paginateWaypoints?: [{	filter?: ValueTypes["DeliveryWaypointWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryWaypointOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["DeliveryWaypointConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryRouteMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	courier?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	waypoints?:ValueTypes["FieldMeta"],
	dispatchAt?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryWaypoint"]: AliasType<{
	_meta?:ValueTypes["DeliveryWaypointMeta"],
	id?:boolean | `@${string}`,
	estimatedArrival?:boolean | `@${string}`,
	note?:boolean | `@${string}`,
route?: [{	filter?: ValueTypes["DeliveryRouteWhere"] | undefined | null},ValueTypes["DeliveryRoute"]],
	sortingOrder?:boolean | `@${string}`,
delivery?: [{	filter?: ValueTypes["OrderDeliveryWhere"] | undefined | null},ValueTypes["OrderDelivery"]],
	estimatedDistance?:boolean | `@${string}`,
	estimatedDuration?:boolean | `@${string}`,
	originDeparture?:boolean | `@${string}`,
	originAddress?:boolean | `@${string}`,
	transitMode?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["DeliveryWaypointMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	estimatedArrival?:ValueTypes["FieldMeta"],
	note?:ValueTypes["FieldMeta"],
	route?:ValueTypes["FieldMeta"],
	sortingOrder?:ValueTypes["FieldMeta"],
	delivery?:ValueTypes["FieldMeta"],
	estimatedDistance?:ValueTypes["FieldMeta"],
	estimatedDuration?:ValueTypes["FieldMeta"],
	originDeparture?:ValueTypes["FieldMeta"],
	originAddress?:ValueTypes["FieldMeta"],
	transitMode?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["OrderDelivery"]: AliasType<{
	_meta?:ValueTypes["OrderDeliveryMeta"],
	id?:boolean | `@${string}`,
	priceCents?:boolean | `@${string}`,
	deliveredAt?:boolean | `@${string}`,
method?: [{	filter?: ValueTypes["DeliveryMethodWhere"] | undefined | null},ValueTypes["DeliveryMethod"]],
vatRate?: [{	filter?: ValueTypes["VatRateWhere"] | undefined | null},ValueTypes["VatRate"]],
order?: [{	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
	expectedAt?:boolean | `@${string}`,
	state?:boolean | `@${string}`,
	loadingDurationHours?:boolean | `@${string}`,
	dispatchAt?:boolean | `@${string}`,
	duration?:boolean | `@${string}`,
	window?:boolean | `@${string}`,
	expectedEndAt?:boolean | `@${string}`,
	processingAt?:boolean | `@${string}`,
	deliveringAt?:boolean | `@${string}`,
	failedAt?:boolean | `@${string}`,
	internalNote?:boolean | `@${string}`,
deliveryWaypoint?: [{	filter?: ValueTypes["DeliveryWaypointWhere"] | undefined | null},ValueTypes["DeliveryWaypoint"]],
events?: [{	filter?: ValueTypes["OrderEventWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderEventOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["OrderEvent"]],
	prepareAt?:boolean | `@${string}`,
liftagoRide?: [{	filter?: ValueTypes["LiftagoRideWhere"] | undefined | null},ValueTypes["LiftagoRide"]],
	pickedAt?:boolean | `@${string}`,
address?: [{	filter?: ValueTypes["AddressWhere"] | undefined | null},ValueTypes["Address"]],
	trackingCode?:boolean | `@${string}`,
woltDriveDelivery?: [{	filter?: ValueTypes["WoltDriveDeliveryWhere"] | undefined | null},ValueTypes["WoltDriveDelivery"]],
paginateEvents?: [{	filter?: ValueTypes["OrderEventWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderEventOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderEventConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["OrderDeliveryMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	priceCents?:ValueTypes["FieldMeta"],
	deliveredAt?:ValueTypes["FieldMeta"],
	method?:ValueTypes["FieldMeta"],
	vatRate?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	expectedAt?:ValueTypes["FieldMeta"],
	state?:ValueTypes["FieldMeta"],
	loadingDurationHours?:ValueTypes["FieldMeta"],
	dispatchAt?:ValueTypes["FieldMeta"],
	duration?:ValueTypes["FieldMeta"],
	window?:ValueTypes["FieldMeta"],
	expectedEndAt?:ValueTypes["FieldMeta"],
	processingAt?:ValueTypes["FieldMeta"],
	deliveringAt?:ValueTypes["FieldMeta"],
	failedAt?:ValueTypes["FieldMeta"],
	internalNote?:ValueTypes["FieldMeta"],
	deliveryWaypoint?:ValueTypes["FieldMeta"],
	events?:ValueTypes["FieldMeta"],
	prepareAt?:ValueTypes["FieldMeta"],
	liftagoRide?:ValueTypes["FieldMeta"],
	pickedAt?:ValueTypes["FieldMeta"],
	address?:ValueTypes["FieldMeta"],
	trackingCode?:ValueTypes["FieldMeta"],
	woltDriveDelivery?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["VatRate"]: AliasType<{
	_meta?:ValueTypes["VatRateMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	ratePermille?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	internalNote?:boolean | `@${string}`,
channelDeliveries?: [{	filter?: ValueTypes["ChannelDeliveryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ChannelDeliveryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ChannelDelivery"]],
channelPayments?: [{	filter?: ValueTypes["ChannelPaymentWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ChannelPaymentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ChannelPayment"]],
	preset?:boolean | `@${string}`,
paginateChannelDeliveries?: [{	filter?: ValueTypes["ChannelDeliveryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ChannelDeliveryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ChannelDeliveryConnection"]],
paginateChannelPayments?: [{	filter?: ValueTypes["ChannelPaymentWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ChannelPaymentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ChannelPaymentConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["VatRateMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	ratePermille?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
	internalNote?:ValueTypes["FieldMeta"],
	channelDeliveries?:ValueTypes["FieldMeta"],
	channelPayments?:ValueTypes["FieldMeta"],
	preset?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ChannelDelivery"]: AliasType<{
	_meta?:ValueTypes["ChannelDeliveryMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	priceCents?:boolean | `@${string}`,
channel?: [{	filter?: ValueTypes["ChannelWhere"] | undefined | null},ValueTypes["Channel"]],
method?: [{	filter?: ValueTypes["DeliveryMethodWhere"] | undefined | null},ValueTypes["DeliveryMethod"]],
vatRate?: [{	filter?: ValueTypes["VatRateWhere"] | undefined | null},ValueTypes["VatRate"]],
	defaultVisible?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ChannelDeliveryMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	priceCents?:ValueTypes["FieldMeta"],
	channel?:ValueTypes["FieldMeta"],
	method?:ValueTypes["FieldMeta"],
	vatRate?:ValueTypes["FieldMeta"],
	defaultVisible?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Channel"]: AliasType<{
	_meta?:ValueTypes["ChannelMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	disabled?:boolean | `@${string}`,
payments?: [{	filter?: ValueTypes["ChannelPaymentWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ChannelPaymentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ChannelPayment"]],
deliveries?: [{	filter?: ValueTypes["ChannelDeliveryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ChannelDeliveryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ChannelDelivery"]],
pointOfSales?: [{	filter?: ValueTypes["PointOfSaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PointOfSale"]],
carts?: [{	filter?: ValueTypes["CartWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CartOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Cart"]],
customers?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Customer"]],
	code?:boolean | `@${string}`,
addTagsOnRegistration?: [{	filter?: ValueTypes["TagWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TagOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Tag"]],
publicTags?: [{	filter?: ValueTypes["TagWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TagOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Tag"]],
venue?: [{	filter?: ValueTypes["VenueWhere"] | undefined | null},ValueTypes["Venue"]],
cartsByItems?: [{	by: ValueTypes["ChannelCartsByItemsUniqueWhere"],	filter?: ValueTypes["CartWhere"] | undefined | null},ValueTypes["Cart"]],
cartsByOrder?: [{	by: ValueTypes["ChannelCartsByOrderUniqueWhere"],	filter?: ValueTypes["CartWhere"] | undefined | null},ValueTypes["Cart"]],
cartsByPriceLines?: [{	by: ValueTypes["ChannelCartsByPriceLinesUniqueWhere"],	filter?: ValueTypes["CartWhere"] | undefined | null},ValueTypes["Cart"]],
cartsBySummary?: [{	by: ValueTypes["ChannelCartsBySummaryUniqueWhere"],	filter?: ValueTypes["CartWhere"] | undefined | null},ValueTypes["Cart"]],
paginatePayments?: [{	filter?: ValueTypes["ChannelPaymentWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ChannelPaymentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ChannelPaymentConnection"]],
paginateDeliveries?: [{	filter?: ValueTypes["ChannelDeliveryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ChannelDeliveryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ChannelDeliveryConnection"]],
paginatePointOfSales?: [{	filter?: ValueTypes["PointOfSaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PointOfSaleConnection"]],
paginateCarts?: [{	filter?: ValueTypes["CartWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CartOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CartConnection"]],
paginateCustomers?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerConnection"]],
paginateAddTagsOnRegistration?: [{	filter?: ValueTypes["TagWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TagOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TagConnection"]],
paginatePublicTags?: [{	filter?: ValueTypes["TagWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TagOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TagConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ChannelMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	disabled?:ValueTypes["FieldMeta"],
	payments?:ValueTypes["FieldMeta"],
	deliveries?:ValueTypes["FieldMeta"],
	pointOfSales?:ValueTypes["FieldMeta"],
	carts?:ValueTypes["FieldMeta"],
	customers?:ValueTypes["FieldMeta"],
	code?:ValueTypes["FieldMeta"],
	addTagsOnRegistration?:ValueTypes["FieldMeta"],
	publicTags?:ValueTypes["FieldMeta"],
	venue?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ChannelPayment"]: AliasType<{
	_meta?:ValueTypes["ChannelPaymentMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
channel?: [{	filter?: ValueTypes["ChannelWhere"] | undefined | null},ValueTypes["Channel"]],
method?: [{	filter?: ValueTypes["PaymentMethodWhere"] | undefined | null},ValueTypes["PaymentMethod"]],
vatRate?: [{	filter?: ValueTypes["VatRateWhere"] | undefined | null},ValueTypes["VatRate"]],
	requireBillingAddress?:boolean | `@${string}`,
	provideReceipt?:boolean | `@${string}`,
	requireBillingSubject?:boolean | `@${string}`,
allowOnlyForTags?: [{	filter?: ValueTypes["TagWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TagOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Tag"]],
paginateAllowOnlyForTags?: [{	filter?: ValueTypes["TagWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TagOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TagConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ChannelPaymentMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	channel?:ValueTypes["FieldMeta"],
	method?:ValueTypes["FieldMeta"],
	vatRate?:ValueTypes["FieldMeta"],
	requireBillingAddress?:ValueTypes["FieldMeta"],
	provideReceipt?:ValueTypes["FieldMeta"],
	requireBillingSubject?:ValueTypes["FieldMeta"],
	allowOnlyForTags?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TagOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	code?: ValueTypes["OrderDirection"] | undefined | null,
	description?: ValueTypes["OrderDirection"] | undefined | null,
	internalNote?: ValueTypes["OrderDirection"] | undefined | null
};
	["TagConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TagEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PageInfo"]: AliasType<{
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["TagEdge"]: AliasType<{
	node?:ValueTypes["Tag"],
		__typename?: boolean | `@${string}`
}>;
	["ChannelPaymentOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null,
	channel?: ValueTypes["ChannelOrderBy"] | undefined | null,
	method?: ValueTypes["PaymentMethodOrderBy"] | undefined | null,
	vatRate?: ValueTypes["VatRateOrderBy"] | undefined | null,
	requireBillingAddress?: ValueTypes["OrderDirection"] | undefined | null,
	provideReceipt?: ValueTypes["OrderDirection"] | undefined | null,
	requireBillingSubject?: ValueTypes["OrderDirection"] | undefined | null
};
	["ChannelOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	disabled?: ValueTypes["OrderDirection"] | undefined | null,
	code?: ValueTypes["OrderDirection"] | undefined | null,
	venue?: ValueTypes["VenueOrderBy"] | undefined | null
};
	["VenueOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	deadlineTemplate?: ValueTypes["DeadlineTemplateOrderBy"] | undefined | null,
	address?: ValueTypes["OrderDirection"] | undefined | null,
	pointOfSalePngBase64ReceiptLogo?: ValueTypes["OrderDirection"] | undefined | null,
	pointOfSaleInitialView?: ValueTypes["OrderDirection"] | undefined | null,
	pointOfSalePreferPrintReceipt?: ValueTypes["OrderDirection"] | undefined | null
};
	["DeadlineTemplateOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	startDate?: ValueTypes["OrderDirection"] | undefined | null,
	period?: ValueTypes["OrderDirection"] | undefined | null,
	cutoff?: ValueTypes["OrderDirection"] | undefined | null,
	closed?: ValueTypes["OrderDirection"] | undefined | null,
	venue?: ValueTypes["VenueOrderBy"] | undefined | null
};
	["VatRateOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	ratePermille?: ValueTypes["OrderDirection"] | undefined | null,
	description?: ValueTypes["OrderDirection"] | undefined | null,
	internalNote?: ValueTypes["OrderDirection"] | undefined | null,
	preset?: ValueTypes["OrderDirection"] | undefined | null
};
	["ChannelDeliveryOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null,
	priceCents?: ValueTypes["OrderDirection"] | undefined | null,
	channel?: ValueTypes["ChannelOrderBy"] | undefined | null,
	method?: ValueTypes["DeliveryMethodOrderBy"] | undefined | null,
	vatRate?: ValueTypes["VatRateOrderBy"] | undefined | null,
	defaultVisible?: ValueTypes["OrderDirection"] | undefined | null
};
	["PointOfSale"]: AliasType<{
	_meta?:ValueTypes["PointOfSaleMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
channels?: [{	filter?: ValueTypes["ChannelWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ChannelOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Channel"]],
permissions?: [{	filter?: ValueTypes["PointOfSalePermissionsWhere"] | undefined | null},ValueTypes["PointOfSalePermissions"]],
	tenantPersonId?:boolean | `@${string}`,
paginateChannels?: [{	filter?: ValueTypes["ChannelWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ChannelOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ChannelConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	code?:ValueTypes["FieldMeta"],
	channels?:ValueTypes["FieldMeta"],
	permissions?:ValueTypes["FieldMeta"],
	tenantPersonId?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSalePermissions"]: AliasType<{
	_meta?:ValueTypes["PointOfSalePermissionsMeta"],
	id?:boolean | `@${string}`,
	canPlaceOrder?:boolean | `@${string}`,
pointOfSale?: [{	filter?: ValueTypes["PointOfSaleWhere"] | undefined | null},ValueTypes["PointOfSale"]],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSalePermissionsMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	canPlaceOrder?:ValueTypes["FieldMeta"],
	pointOfSale?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ChannelConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ChannelEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ChannelEdge"]: AliasType<{
	node?:ValueTypes["Channel"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	code?: ValueTypes["OrderDirection"] | undefined | null,
	permissions?: ValueTypes["PointOfSalePermissionsOrderBy"] | undefined | null,
	tenantPersonId?: ValueTypes["OrderDirection"] | undefined | null
};
	["PointOfSalePermissionsOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	canPlaceOrder?: ValueTypes["OrderDirection"] | undefined | null,
	pointOfSale?: ValueTypes["PointOfSaleOrderBy"] | undefined | null
};
	["Cart"]: AliasType<{
	_meta?:ValueTypes["CartMeta"],
	id?:boolean | `@${string}`,
	confirmedAt?:boolean | `@${string}`,
	deletedAt?:boolean | `@${string}`,
	note?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["CartItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CartItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CartItem"]],
	handle?:boolean | `@${string}`,
	state?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
channel?: [{	filter?: ValueTypes["ChannelWhere"] | undefined | null},ValueTypes["Channel"]],
order?: [{	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
customer?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
deliveryAddress?: [{	filter?: ValueTypes["AddressWhere"] | undefined | null},ValueTypes["Address"]],
billingAddress?: [{	filter?: ValueTypes["AddressWhere"] | undefined | null},ValueTypes["Address"]],
	deliveryOption?:boolean | `@${string}`,
	paymentOption?:boolean | `@${string}`,
delivery?: [{	filter?: ValueTypes["ChannelDeliveryWhere"] | undefined | null},ValueTypes["ChannelDelivery"]],
payment?: [{	filter?: ValueTypes["ChannelPaymentWhere"] | undefined | null},ValueTypes["ChannelPayment"]],
billingSubject?: [{	filter?: ValueTypes["BillingSubjectWhere"] | undefined | null},ValueTypes["BillingSubject"]],
priceLines?: [{	filter?: ValueTypes["CartPriceLineWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CartPriceLineOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CartPriceLine"]],
summary?: [{	filter?: ValueTypes["CartSummaryWhere"] | undefined | null},ValueTypes["CartSummary"]],
itemsByProduct?: [{	by: ValueTypes["CartItemsByProductUniqueWhere"],	filter?: ValueTypes["CartItemWhere"] | undefined | null},ValueTypes["CartItem"]],
paginateItems?: [{	filter?: ValueTypes["CartItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CartItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CartItemConnection"]],
paginatePriceLines?: [{	filter?: ValueTypes["CartPriceLineWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CartPriceLineOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CartPriceLineConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["CartMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	confirmedAt?:ValueTypes["FieldMeta"],
	deletedAt?:ValueTypes["FieldMeta"],
	note?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
	handle?:ValueTypes["FieldMeta"],
	state?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	channel?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	customer?:ValueTypes["FieldMeta"],
	deliveryAddress?:ValueTypes["FieldMeta"],
	billingAddress?:ValueTypes["FieldMeta"],
	deliveryOption?:ValueTypes["FieldMeta"],
	paymentOption?:ValueTypes["FieldMeta"],
	delivery?:ValueTypes["FieldMeta"],
	payment?:ValueTypes["FieldMeta"],
	billingSubject?:ValueTypes["FieldMeta"],
	priceLines?:ValueTypes["FieldMeta"],
	summary?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["CartItem"]: AliasType<{
	_meta?:ValueTypes["CartItemMeta"],
	id?:boolean | `@${string}`,
	quantity?:boolean | `@${string}`,
cart?: [{	filter?: ValueTypes["CartWhere"] | undefined | null},ValueTypes["Cart"]],
product?: [{	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	fulfillmentNote?:boolean | `@${string}`,
fulfillmentNotes?: [{	filter?: ValueTypes["FulfillmentNoteWhere"] | undefined | null,	orderBy?: Array<ValueTypes["FulfillmentNoteOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["FulfillmentNote"]],
paginateFulfillmentNotes?: [{	filter?: ValueTypes["FulfillmentNoteWhere"] | undefined | null,	orderBy?: Array<ValueTypes["FulfillmentNoteOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["FulfillmentNoteConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["CartItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	quantity?:ValueTypes["FieldMeta"],
	cart?:ValueTypes["FieldMeta"],
	product?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	updatedAt?:ValueTypes["FieldMeta"],
	fulfillmentNote?:ValueTypes["FieldMeta"],
	fulfillmentNotes?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["FulfillmentNote"]: AliasType<{
	_meta?:ValueTypes["FulfillmentNoteMeta"],
	id?:boolean | `@${string}`,
	note?:boolean | `@${string}`,
products?: [{	filter?: ValueTypes["ProductWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Product"]],
tags?: [{	filter?: ValueTypes["TagWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TagOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Tag"]],
venues?: [{	filter?: ValueTypes["VenueWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VenueOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Venue"]],
cartItems?: [{	filter?: ValueTypes["CartItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CartItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CartItem"]],
orderItems?: [{	filter?: ValueTypes["OrderItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["OrderItem"]],
orders?: [{	filter?: ValueTypes["OrderWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Order"]],
	highlight?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	emoji?:boolean | `@${string}`,
paginateProducts?: [{	filter?: ValueTypes["ProductWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductConnection"]],
paginateTags?: [{	filter?: ValueTypes["TagWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TagOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TagConnection"]],
paginateVenues?: [{	filter?: ValueTypes["VenueWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VenueOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["VenueConnection"]],
paginateCartItems?: [{	filter?: ValueTypes["CartItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CartItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CartItemConnection"]],
paginateOrderItems?: [{	filter?: ValueTypes["OrderItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderItemConnection"]],
paginateOrders?: [{	filter?: ValueTypes["OrderWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["FulfillmentNoteMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	note?:ValueTypes["FieldMeta"],
	products?:ValueTypes["FieldMeta"],
	tags?:ValueTypes["FieldMeta"],
	venues?:ValueTypes["FieldMeta"],
	cartItems?:ValueTypes["FieldMeta"],
	orderItems?:ValueTypes["FieldMeta"],
	orders?:ValueTypes["FieldMeta"],
	highlight?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	emoji?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProductOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	code?: ValueTypes["OrderDirection"] | undefined | null,
	priceCents?: ValueTypes["OrderDirection"] | undefined | null,
	notDiscountable?: ValueTypes["OrderDirection"] | undefined | null,
	packing?: ValueTypes["ProductPackingOrderBy"] | undefined | null,
	recipe?: ValueTypes["ProductRecipeOrderBy"] | undefined | null,
	vatRate?: ValueTypes["VatRateOrderBy"] | undefined | null,
	image?: ValueTypes["ImageOrderBy"] | undefined | null,
	description?: ValueTypes["OrderDirection"] | undefined | null,
	internalNote?: ValueTypes["OrderDirection"] | undefined | null,
	availability?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null,
	manager?: ValueTypes["StocksManagerOrderBy"] | undefined | null,
	maximumQuantityPerOrder?: ValueTypes["OrderDirection"] | undefined | null,
	archivedAt?: ValueTypes["OrderDirection"] | undefined | null,
	virtualProduct?: ValueTypes["VirtualProductOrderBy"] | undefined | null,
	meta?: ValueTypes["ProductMetadataOrderBy"] | undefined | null,
	page?: ValueTypes["PageOrderBy"] | undefined | null,
	hasSubscription?: ValueTypes["OrderDirection"] | undefined | null,
	pointOfSaleTileColor?: ValueTypes["OrderDirection"] | undefined | null
};
	["ProductPackingOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	image?: ValueTypes["ImageOrderBy"] | undefined | null,
	description?: ValueTypes["OrderDirection"] | undefined | null,
	internalNote?: ValueTypes["OrderDirection"] | undefined | null,
	volumeMl?: ValueTypes["OrderDirection"] | undefined | null,
	icon?: ValueTypes["ImageOrderBy"] | undefined | null,
	shortName?: ValueTypes["OrderDirection"] | undefined | null,
	isPackedInCardboard?: ValueTypes["OrderDirection"] | undefined | null
};
	["ProductRecipeOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	internalNote?: ValueTypes["OrderDirection"] | undefined | null,
	color?: ValueTypes["OrderDirection"] | undefined | null,
	image?: ValueTypes["ImageOrderBy"] | undefined | null,
	icon?: ValueTypes["ImageOrderBy"] | undefined | null,
	needsPrepping?: ValueTypes["OrderDirection"] | undefined | null,
	gutTuning?: ValueTypes["OrderDirection"] | undefined | null,
	freshingContainer?: ValueTypes["FreshingContainerOrderBy"] | undefined | null,
	description?: ValueTypes["OrderDirection"] | undefined | null,
	nutritionFacts?: ValueTypes["NutritionFactsOrderBy"] | undefined | null
};
	["FreshingContainerOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null,
	volumeMl?: ValueTypes["OrderDirection"] | undefined | null,
	workspace?: ValueTypes["WorkspaceOrderBy"] | undefined | null
};
	["WorkspaceOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	unique?: ValueTypes["OrderDirection"] | undefined | null,
	orderDeadlineTime?: ValueTypes["OrderDirection"] | undefined | null,
	ordersLoadingDurationHours?: ValueTypes["OrderDirection"] | undefined | null,
	freshingContainerVolumeMl?: ValueTypes["OrderDirection"] | undefined | null,
	freshingPrepareOrderByOffsetMinutes?: ValueTypes["OrderDirection"] | undefined | null,
	checkoutUrlTemplate?: ValueTypes["OrderDirection"] | undefined | null,
	orderUrlTemplate?: ValueTypes["OrderDirection"] | undefined | null,
	paymentUrlTemplate?: ValueTypes["OrderDirection"] | undefined | null,
	customerProfileUrlTemplate?: ValueTypes["OrderDirection"] | undefined | null,
	userProfileUrlTemplate?: ValueTypes["OrderDirection"] | undefined | null,
	messengerUrl?: ValueTypes["OrderDirection"] | undefined | null,
	messengerIosUrl?: ValueTypes["OrderDirection"] | undefined | null,
	messengerAndroidUrl?: ValueTypes["OrderDirection"] | undefined | null,
	openingHours?: ValueTypes["WeekHoursOrderBy"] | undefined | null,
	workingHours?: ValueTypes["WeekHoursOrderBy"] | undefined | null,
	defaultFreshingContainer?: ValueTypes["FreshingContainerOrderBy"] | undefined | null,
	creditsProduct?: ValueTypes["VirtualProductOrderBy"] | undefined | null,
	discountVatRate?: ValueTypes["VatRateOrderBy"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	businessAddress?: ValueTypes["OrderDirection"] | undefined | null
};
	["WeekHoursOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	mon?: ValueTypes["OrderDirection"] | undefined | null,
	tue?: ValueTypes["OrderDirection"] | undefined | null,
	wed?: ValueTypes["OrderDirection"] | undefined | null,
	thu?: ValueTypes["OrderDirection"] | undefined | null,
	fri?: ValueTypes["OrderDirection"] | undefined | null,
	sat?: ValueTypes["OrderDirection"] | undefined | null,
	sun?: ValueTypes["OrderDirection"] | undefined | null
};
	["VirtualProductOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	type?: ValueTypes["OrderDirection"] | undefined | null,
	product?: ValueTypes["ProductOrderBy"] | undefined | null,
	voucherCreditCents?: ValueTypes["OrderDirection"] | undefined | null,
	physicalRepresentation?: ValueTypes["OrderDirection"] | undefined | null,
	recipientEmail?: ValueTypes["OrderDirection"] | undefined | null
};
	["NutritionFactsOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	energyKiloJoule?: ValueTypes["OrderDirection"] | undefined | null,
	energyKiloCalorie?: ValueTypes["OrderDirection"] | undefined | null,
	fatsGrams?: ValueTypes["OrderDirection"] | undefined | null,
	fatsOfWhichSaturatedGrams?: ValueTypes["OrderDirection"] | undefined | null,
	carbohydrateGrams?: ValueTypes["OrderDirection"] | undefined | null,
	carbohydrateOfWhichSugarsGrams?: ValueTypes["OrderDirection"] | undefined | null,
	proteinGrams?: ValueTypes["OrderDirection"] | undefined | null,
	fibreGrams?: ValueTypes["OrderDirection"] | undefined | null,
	saltGrams?: ValueTypes["OrderDirection"] | undefined | null
};
	["ProductMetadataOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	archived?: ValueTypes["OrderDirection"] | undefined | null,
	available?: ValueTypes["OrderDirection"] | undefined | null,
	availableQuantity?: ValueTypes["OrderDirection"] | undefined | null,
	product?: ValueTypes["ProductOrderBy"] | undefined | null
};
	["PageOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null
};
	["Venue"]: AliasType<{
	_meta?:ValueTypes["VenueMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
deadlineTemplate?: [{	filter?: ValueTypes["DeadlineTemplateWhere"] | undefined | null},ValueTypes["DeadlineTemplate"]],
timetableDays?: [{	filter?: ValueTypes["TimetableDayWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableDayOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TimetableDay"]],
timetableTemplates?: [{	filter?: ValueTypes["TimetableTemplateWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableTemplateOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TimetableTemplate"]],
staffMembers?: [{	filter?: ValueTypes["StaffWhere"] | undefined | null,	orderBy?: Array<ValueTypes["StaffOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Staff"]],
employeeRoles?: [{	filter?: ValueTypes["VenueEmployeeRoleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VenueEmployeeRoleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["VenueEmployeeRole"]],
pointOfSaleApplicationDevices?: [{	filter?: ValueTypes["PointOfSaleApplicationDeviceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleApplicationDeviceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PointOfSaleApplicationDevice"]],
pointOfSaleTerminals?: [{	filter?: ValueTypes["PointOfSaleTerminalWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleTerminalOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PointOfSaleTerminal"]],
pointOfSalePrinters?: [{	filter?: ValueTypes["PointOfSalePrinterWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSalePrinterOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PointOfSalePrinter"]],
orders?: [{	filter?: ValueTypes["OrderWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Order"]],
fulfillmentNotes?: [{	filter?: ValueTypes["FulfillmentNoteWhere"] | undefined | null,	orderBy?: Array<ValueTypes["FulfillmentNoteOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["FulfillmentNote"]],
areas?: [{	filter?: ValueTypes["AreaWhere"] | undefined | null,	orderBy?: Array<ValueTypes["AreaOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Area"]],
enabledUnassignReasons?: [{	filter?: ValueTypes["UnassignReasonWhere"] | undefined | null,	orderBy?: Array<ValueTypes["UnassignReasonOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["UnassignReason"]],
categories?: [{	filter?: ValueTypes["PointOfSaleCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleCategoryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PointOfSaleCategory"]],
channels?: [{	filter?: ValueTypes["ChannelWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ChannelOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Channel"]],
	address?:boolean | `@${string}`,
	pointOfSalePngBase64ReceiptLogo?:boolean | `@${string}`,
	pointOfSaleInitialView?:boolean | `@${string}`,
	pointOfSalePreferPrintReceipt?:boolean | `@${string}`,
timetableDaysByDate?: [{	by: ValueTypes["VenueTimetableDaysByDateUniqueWhere"],	filter?: ValueTypes["TimetableDayWhere"] | undefined | null},ValueTypes["TimetableDay"]],
timetableDaysByShiftGroups?: [{	by: ValueTypes["VenueTimetableDaysByShiftGroupsUniqueWhere"],	filter?: ValueTypes["TimetableDayWhere"] | undefined | null},ValueTypes["TimetableDay"]],
timetableDaysByNotes?: [{	by: ValueTypes["VenueTimetableDaysByNotesUniqueWhere"],	filter?: ValueTypes["TimetableDayWhere"] | undefined | null},ValueTypes["TimetableDay"]],
timetableDaysByMeta?: [{	by: ValueTypes["VenueTimetableDaysByMetaUniqueWhere"],	filter?: ValueTypes["TimetableDayWhere"] | undefined | null},ValueTypes["TimetableDay"]],
timetableTemplatesByStaffOptions?: [{	by: ValueTypes["VenueTimetableTemplatesByStaffOptionsUniqueWhere"],	filter?: ValueTypes["TimetableTemplateWhere"] | undefined | null},ValueTypes["TimetableTemplate"]],
employeeRolesByRole?: [{	by: ValueTypes["VenueEmployeeRolesByRoleUniqueWhere"],	filter?: ValueTypes["VenueEmployeeRoleWhere"] | undefined | null},ValueTypes["VenueEmployeeRole"]],
employeeRolesByEmployeePrivileges?: [{	by: ValueTypes["VenueEmployeeRolesByEmployeePrivilegesUniqueWhere"],	filter?: ValueTypes["VenueEmployeeRoleWhere"] | undefined | null},ValueTypes["VenueEmployeeRole"]],
pointOfSaleApplicationDevicesByIdentifier?: [{	by: ValueTypes["VenuePointOfSaleApplicationDevicesByIdentifierUniqueWhere"],	filter?: ValueTypes["PointOfSaleApplicationDeviceWhere"] | undefined | null},ValueTypes["PointOfSaleApplicationDevice"]],
pointOfSaleTerminalsByApplicationDevices?: [{	by: ValueTypes["VenuePointOfSaleTerminalsByApplicationDevicesUniqueWhere"],	filter?: ValueTypes["PointOfSaleTerminalWhere"] | undefined | null},ValueTypes["PointOfSaleTerminal"]],
pointOfSalePrintersByApplicationDevicesReceipt?: [{	by: ValueTypes["VenuePointOfSalePrintersByApplicationDevicesReceiptUniqueWhere"],	filter?: ValueTypes["PointOfSalePrinterWhere"] | undefined | null},ValueTypes["PointOfSalePrinter"]],
ordersBySeq?: [{	by: ValueTypes["VenueOrdersBySeqUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
ordersByDoubleshotLegacyId?: [{	by: ValueTypes["VenueOrdersByDoubleshotLegacyIdUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
ordersByDoubleShotLegacyNumber?: [{	by: ValueTypes["VenueOrdersByDoubleShotLegacyNumberUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
ordersByDiscounts?: [{	by: ValueTypes["VenueOrdersByDiscountsUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
ordersByDelivery?: [{	by: ValueTypes["VenueOrdersByDeliveryUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
ordersByItems?: [{	by: ValueTypes["VenueOrdersByItemsUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
ordersByCart?: [{	by: ValueTypes["VenueOrdersByCartUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
ordersByEvents?: [{	by: ValueTypes["VenueOrdersByEventsUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
ordersByPriceLines?: [{	by: ValueTypes["VenueOrdersByPriceLinesUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
ordersByPayments?: [{	by: ValueTypes["VenueOrdersByPaymentsUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
ordersBySummary?: [{	by: ValueTypes["VenueOrdersBySummaryUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
ordersByGratuity?: [{	by: ValueTypes["VenueOrdersByGratuityUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
areasByTables?: [{	by: ValueTypes["VenueAreasByTablesUniqueWhere"],	filter?: ValueTypes["AreaWhere"] | undefined | null},ValueTypes["Area"]],
areasByLines?: [{	by: ValueTypes["VenueAreasByLinesUniqueWhere"],	filter?: ValueTypes["AreaWhere"] | undefined | null},ValueTypes["Area"]],
categoriesBySlug?: [{	by: ValueTypes["VenueCategoriesBySlugUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryWhere"] | undefined | null},ValueTypes["PointOfSaleCategory"]],
categoriesByLocales?: [{	by: ValueTypes["VenueCategoriesByLocalesUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryWhere"] | undefined | null},ValueTypes["PointOfSaleCategory"]],
categoriesByProducts?: [{	by: ValueTypes["VenueCategoriesByProductsUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryWhere"] | undefined | null},ValueTypes["PointOfSaleCategory"]],
channelsByCode?: [{	by: ValueTypes["VenueChannelsByCodeUniqueWhere"],	filter?: ValueTypes["ChannelWhere"] | undefined | null},ValueTypes["Channel"]],
channelsByPayments?: [{	by: ValueTypes["VenueChannelsByPaymentsUniqueWhere"],	filter?: ValueTypes["ChannelWhere"] | undefined | null},ValueTypes["Channel"]],
channelsByDeliveries?: [{	by: ValueTypes["VenueChannelsByDeliveriesUniqueWhere"],	filter?: ValueTypes["ChannelWhere"] | undefined | null},ValueTypes["Channel"]],
channelsByCarts?: [{	by: ValueTypes["VenueChannelsByCartsUniqueWhere"],	filter?: ValueTypes["ChannelWhere"] | undefined | null},ValueTypes["Channel"]],
paginateTimetableDays?: [{	filter?: ValueTypes["TimetableDayWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableDayOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TimetableDayConnection"]],
paginateTimetableTemplates?: [{	filter?: ValueTypes["TimetableTemplateWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableTemplateOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TimetableTemplateConnection"]],
paginateStaffMembers?: [{	filter?: ValueTypes["StaffWhere"] | undefined | null,	orderBy?: Array<ValueTypes["StaffOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["StaffConnection"]],
paginateEmployeeRoles?: [{	filter?: ValueTypes["VenueEmployeeRoleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VenueEmployeeRoleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["VenueEmployeeRoleConnection"]],
paginatePointOfSaleApplicationDevices?: [{	filter?: ValueTypes["PointOfSaleApplicationDeviceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleApplicationDeviceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PointOfSaleApplicationDeviceConnection"]],
paginatePointOfSaleTerminals?: [{	filter?: ValueTypes["PointOfSaleTerminalWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleTerminalOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PointOfSaleTerminalConnection"]],
paginatePointOfSalePrinters?: [{	filter?: ValueTypes["PointOfSalePrinterWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSalePrinterOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PointOfSalePrinterConnection"]],
paginateOrders?: [{	filter?: ValueTypes["OrderWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderConnection"]],
paginateFulfillmentNotes?: [{	filter?: ValueTypes["FulfillmentNoteWhere"] | undefined | null,	orderBy?: Array<ValueTypes["FulfillmentNoteOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["FulfillmentNoteConnection"]],
paginateAreas?: [{	filter?: ValueTypes["AreaWhere"] | undefined | null,	orderBy?: Array<ValueTypes["AreaOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["AreaConnection"]],
paginateEnabledUnassignReasons?: [{	filter?: ValueTypes["UnassignReasonWhere"] | undefined | null,	orderBy?: Array<ValueTypes["UnassignReasonOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["UnassignReasonConnection"]],
paginateCategories?: [{	filter?: ValueTypes["PointOfSaleCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleCategoryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PointOfSaleCategoryConnection"]],
paginateChannels?: [{	filter?: ValueTypes["ChannelWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ChannelOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ChannelConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["VenueMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	deadlineTemplate?:ValueTypes["FieldMeta"],
	timetableDays?:ValueTypes["FieldMeta"],
	timetableTemplates?:ValueTypes["FieldMeta"],
	staffMembers?:ValueTypes["FieldMeta"],
	employeeRoles?:ValueTypes["FieldMeta"],
	pointOfSaleApplicationDevices?:ValueTypes["FieldMeta"],
	pointOfSaleTerminals?:ValueTypes["FieldMeta"],
	pointOfSalePrinters?:ValueTypes["FieldMeta"],
	orders?:ValueTypes["FieldMeta"],
	fulfillmentNotes?:ValueTypes["FieldMeta"],
	areas?:ValueTypes["FieldMeta"],
	enabledUnassignReasons?:ValueTypes["FieldMeta"],
	categories?:ValueTypes["FieldMeta"],
	channels?:ValueTypes["FieldMeta"],
	address?:ValueTypes["FieldMeta"],
	pointOfSalePngBase64ReceiptLogo?:ValueTypes["FieldMeta"],
	pointOfSaleInitialView?:ValueTypes["FieldMeta"],
	pointOfSalePreferPrintReceipt?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["DeadlineTemplate"]: AliasType<{
	_meta?:ValueTypes["DeadlineTemplateMeta"],
	id?:boolean | `@${string}`,
	startDate?:boolean | `@${string}`,
	period?:boolean | `@${string}`,
	cutoff?:boolean | `@${string}`,
	closed?:boolean | `@${string}`,
venue?: [{	filter?: ValueTypes["VenueWhere"] | undefined | null},ValueTypes["Venue"]],
		__typename?: boolean | `@${string}`
}>;
	["DeadlineTemplateMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	startDate?:ValueTypes["FieldMeta"],
	period?:ValueTypes["FieldMeta"],
	cutoff?:ValueTypes["FieldMeta"],
	closed?:ValueTypes["FieldMeta"],
	venue?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableDay"]: AliasType<{
	_meta?:ValueTypes["TimetableDayMeta"],
	id?:boolean | `@${string}`,
	date?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
shiftGroups?: [{	filter?: ValueTypes["TimetableShiftGroupWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableShiftGroupOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TimetableShiftGroup"]],
	tipsCents?:boolean | `@${string}`,
notes?: [{	filter?: ValueTypes["TimetableDayNoteWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableDayNoteOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TimetableDayNote"]],
venue?: [{	filter?: ValueTypes["VenueWhere"] | undefined | null},ValueTypes["Venue"]],
meta?: [{	filter?: ValueTypes["TimetableDayMetadataWhere"] | undefined | null},ValueTypes["TimetableDayMetadata"]],
shiftGroupsByShifts?: [{	by: ValueTypes["TimetableDayShiftGroupsByShiftsUniqueWhere"],	filter?: ValueTypes["TimetableShiftGroupWhere"] | undefined | null},ValueTypes["TimetableShiftGroup"]],
shiftGroupsByQueue?: [{	by: ValueTypes["TimetableDayShiftGroupsByQueueUniqueWhere"],	filter?: ValueTypes["TimetableShiftGroupWhere"] | undefined | null},ValueTypes["TimetableShiftGroup"]],
paginateShiftGroups?: [{	filter?: ValueTypes["TimetableShiftGroupWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableShiftGroupOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TimetableShiftGroupConnection"]],
paginateNotes?: [{	filter?: ValueTypes["TimetableDayNoteWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableDayNoteOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TimetableDayNoteConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["TimetableDayMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	date?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	shiftGroups?:ValueTypes["FieldMeta"],
	tipsCents?:ValueTypes["FieldMeta"],
	notes?:ValueTypes["FieldMeta"],
	venue?:ValueTypes["FieldMeta"],
	meta?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableShiftGroup"]: AliasType<{
	_meta?:ValueTypes["TimetableShiftGroupMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
shifts?: [{	filter?: ValueTypes["TimetableShiftWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableShiftOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TimetableShift"]],
day?: [{	filter?: ValueTypes["TimetableDayWhere"] | undefined | null},ValueTypes["TimetableDay"]],
type?: [{	filter?: ValueTypes["TimetableEmployeeRoleWhere"] | undefined | null},ValueTypes["TimetableEmployeeRole"]],
position?: [{	filter?: ValueTypes["TimetableShiftPositionWhere"] | undefined | null},ValueTypes["TimetableShiftPosition"]],
queue?: [{	filter?: ValueTypes["EmployeeQueueWhere"] | undefined | null},ValueTypes["EmployeeQueue"]],
generatedByTemplate?: [{	filter?: ValueTypes["TimetableTemplateWhere"] | undefined | null},ValueTypes["TimetableTemplate"]],
shiftsByQueueItem?: [{	by: ValueTypes["TimetableShiftGroupShiftsByQueueItemUniqueWhere"],	filter?: ValueTypes["TimetableShiftWhere"] | undefined | null},ValueTypes["TimetableShift"]],
shiftsBySwapInfo?: [{	by: ValueTypes["TimetableShiftGroupShiftsBySwapInfoUniqueWhere"],	filter?: ValueTypes["TimetableShiftWhere"] | undefined | null},ValueTypes["TimetableShift"]],
paginateShifts?: [{	filter?: ValueTypes["TimetableShiftWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableShiftOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TimetableShiftConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["TimetableShiftGroupMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	shifts?:ValueTypes["FieldMeta"],
	day?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	position?:ValueTypes["FieldMeta"],
	queue?:ValueTypes["FieldMeta"],
	generatedByTemplate?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableShift"]: AliasType<{
	_meta?:ValueTypes["TimetableShiftMeta"],
	id?:boolean | `@${string}`,
	locked?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	assigned?:boolean | `@${string}`,
group?: [{	filter?: ValueTypes["TimetableShiftGroupWhere"] | undefined | null},ValueTypes["TimetableShiftGroup"]],
shiftsProfile?: [{	filter?: ValueTypes["ShiftsProfileWhere"] | undefined | null},ValueTypes["ShiftsProfile"]],
queueItem?: [{	filter?: ValueTypes["EmployeeQueueItemWhere"] | undefined | null},ValueTypes["EmployeeQueueItem"]],
swapInfo?: [{	filter?: ValueTypes["TimetableShiftSwapInfoWhere"] | undefined | null},ValueTypes["TimetableShiftSwapInfo"]],
	isOvertime?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["TimetableShiftMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	locked?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	assigned?:ValueTypes["FieldMeta"],
	group?:ValueTypes["FieldMeta"],
	shiftsProfile?:ValueTypes["FieldMeta"],
	queueItem?:ValueTypes["FieldMeta"],
	swapInfo?:ValueTypes["FieldMeta"],
	isOvertime?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ShiftsProfile"]: AliasType<{
	_meta?:ValueTypes["ShiftsProfileMeta"],
	id?:boolean | `@${string}`,
queueItems?: [{	filter?: ValueTypes["EmployeeQueueItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["EmployeeQueueItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["EmployeeQueueItem"]],
staff?: [{	filter?: ValueTypes["StaffWhere"] | undefined | null},ValueTypes["Staff"]],
roles?: [{	filter?: ValueTypes["TimetableEmployeeRoleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableEmployeeRoleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TimetableEmployeeRole"]],
shifts?: [{	filter?: ValueTypes["TimetableShiftWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableShiftOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TimetableShift"]],
	allowSelfUnassigning?:boolean | `@${string}`,
queueItemsByQueue?: [{	by: ValueTypes["ShiftsProfileQueueItemsByQueueUniqueWhere"],	filter?: ValueTypes["EmployeeQueueItemWhere"] | undefined | null},ValueTypes["EmployeeQueueItem"]],
queueItemsByShift?: [{	by: ValueTypes["ShiftsProfileQueueItemsByShiftUniqueWhere"],	filter?: ValueTypes["EmployeeQueueItemWhere"] | undefined | null},ValueTypes["EmployeeQueueItem"]],
queueItemsByUnassignInfo?: [{	by: ValueTypes["ShiftsProfileQueueItemsByUnassignInfoUniqueWhere"],	filter?: ValueTypes["EmployeeQueueItemWhere"] | undefined | null},ValueTypes["EmployeeQueueItem"]],
queueItemsByMeta?: [{	by: ValueTypes["ShiftsProfileQueueItemsByMetaUniqueWhere"],	filter?: ValueTypes["EmployeeQueueItemWhere"] | undefined | null},ValueTypes["EmployeeQueueItem"]],
shiftsByQueueItem?: [{	by: ValueTypes["ShiftsProfileShiftsByQueueItemUniqueWhere"],	filter?: ValueTypes["TimetableShiftWhere"] | undefined | null},ValueTypes["TimetableShift"]],
shiftsBySwapInfo?: [{	by: ValueTypes["ShiftsProfileShiftsBySwapInfoUniqueWhere"],	filter?: ValueTypes["TimetableShiftWhere"] | undefined | null},ValueTypes["TimetableShift"]],
paginateQueueItems?: [{	filter?: ValueTypes["EmployeeQueueItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["EmployeeQueueItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["EmployeeQueueItemConnection"]],
paginateRoles?: [{	filter?: ValueTypes["TimetableEmployeeRoleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableEmployeeRoleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TimetableEmployeeRoleConnection"]],
paginateShifts?: [{	filter?: ValueTypes["TimetableShiftWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableShiftOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TimetableShiftConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ShiftsProfileMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	queueItems?:ValueTypes["FieldMeta"],
	staff?:ValueTypes["FieldMeta"],
	roles?:ValueTypes["FieldMeta"],
	shifts?:ValueTypes["FieldMeta"],
	allowSelfUnassigning?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["EmployeeQueueItem"]: AliasType<{
	_meta?:ValueTypes["EmployeeQueueItemMeta"],
	id?:boolean | `@${string}`,
	start?:boolean | `@${string}`,
	end?:boolean | `@${string}`,
queue?: [{	filter?: ValueTypes["EmployeeQueueWhere"] | undefined | null},ValueTypes["EmployeeQueue"]],
shiftsProfile?: [{	filter?: ValueTypes["ShiftsProfileWhere"] | undefined | null},ValueTypes["ShiftsProfile"]],
shift?: [{	filter?: ValueTypes["TimetableShiftWhere"] | undefined | null},ValueTypes["TimetableShift"]],
unassignInfo?: [{	filter?: ValueTypes["UnassignedShiftInfoWhere"] | undefined | null},ValueTypes["UnassignedShiftInfo"]],
meta?: [{	filter?: ValueTypes["EmployeeQueueItemMetadataWhere"] | undefined | null},ValueTypes["EmployeeQueueItemMetadata"]],
		__typename?: boolean | `@${string}`
}>;
	["EmployeeQueueItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	start?:ValueTypes["FieldMeta"],
	end?:ValueTypes["FieldMeta"],
	queue?:ValueTypes["FieldMeta"],
	shiftsProfile?:ValueTypes["FieldMeta"],
	shift?:ValueTypes["FieldMeta"],
	unassignInfo?:ValueTypes["FieldMeta"],
	meta?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["EmployeeQueue"]: AliasType<{
	_meta?:ValueTypes["EmployeeQueueMeta"],
	id?:boolean | `@${string}`,
shiftGroup?: [{	filter?: ValueTypes["TimetableShiftGroupWhere"] | undefined | null},ValueTypes["TimetableShiftGroup"]],
items?: [{	filter?: ValueTypes["EmployeeQueueItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["EmployeeQueueItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["EmployeeQueueItem"]],
	contemberBugFix?:boolean | `@${string}`,
itemsByShiftsProfile?: [{	by: ValueTypes["EmployeeQueueItemsByShiftsProfileUniqueWhere"],	filter?: ValueTypes["EmployeeQueueItemWhere"] | undefined | null},ValueTypes["EmployeeQueueItem"]],
itemsByShift?: [{	by: ValueTypes["EmployeeQueueItemsByShiftUniqueWhere"],	filter?: ValueTypes["EmployeeQueueItemWhere"] | undefined | null},ValueTypes["EmployeeQueueItem"]],
itemsByUnassignInfo?: [{	by: ValueTypes["EmployeeQueueItemsByUnassignInfoUniqueWhere"],	filter?: ValueTypes["EmployeeQueueItemWhere"] | undefined | null},ValueTypes["EmployeeQueueItem"]],
itemsByMeta?: [{	by: ValueTypes["EmployeeQueueItemsByMetaUniqueWhere"],	filter?: ValueTypes["EmployeeQueueItemWhere"] | undefined | null},ValueTypes["EmployeeQueueItem"]],
paginateItems?: [{	filter?: ValueTypes["EmployeeQueueItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["EmployeeQueueItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["EmployeeQueueItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["EmployeeQueueMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	shiftGroup?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
	contemberBugFix?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["EmployeeQueueItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	start?: ValueTypes["OrderDirection"] | undefined | null,
	end?: ValueTypes["OrderDirection"] | undefined | null,
	queue?: ValueTypes["EmployeeQueueOrderBy"] | undefined | null,
	shiftsProfile?: ValueTypes["ShiftsProfileOrderBy"] | undefined | null,
	shift?: ValueTypes["TimetableShiftOrderBy"] | undefined | null,
	unassignInfo?: ValueTypes["UnassignedShiftInfoOrderBy"] | undefined | null,
	meta?: ValueTypes["EmployeeQueueItemMetadataOrderBy"] | undefined | null
};
	["EmployeeQueueOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	shiftGroup?: ValueTypes["TimetableShiftGroupOrderBy"] | undefined | null,
	contemberBugFix?: ValueTypes["OrderDirection"] | undefined | null
};
	["TimetableShiftGroupOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null,
	day?: ValueTypes["TimetableDayOrderBy"] | undefined | null,
	type?: ValueTypes["TimetableEmployeeRoleOrderBy"] | undefined | null,
	position?: ValueTypes["TimetableShiftPositionOrderBy"] | undefined | null,
	queue?: ValueTypes["EmployeeQueueOrderBy"] | undefined | null,
	generatedByTemplate?: ValueTypes["TimetableTemplateOrderBy"] | undefined | null
};
	["TimetableDayOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	date?: ValueTypes["OrderDirection"] | undefined | null,
	type?: ValueTypes["OrderDirection"] | undefined | null,
	tipsCents?: ValueTypes["OrderDirection"] | undefined | null,
	venue?: ValueTypes["VenueOrderBy"] | undefined | null,
	meta?: ValueTypes["TimetableDayMetadataOrderBy"] | undefined | null
};
	["TimetableDayMetadataOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	numberOfWorkers?: ValueTypes["OrderDirection"] | undefined | null,
	tipsTotalCents?: ValueTypes["OrderDirection"] | undefined | null,
	totalMinutes?: ValueTypes["OrderDirection"] | undefined | null,
	tipsCentsPerMinute?: ValueTypes["OrderDirection"] | undefined | null,
	day?: ValueTypes["TimetableDayOrderBy"] | undefined | null
};
	["TimetableEmployeeRoleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	color?: ValueTypes["OrderDirection"] | undefined | null
};
	["TimetableShiftPositionOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	start?: ValueTypes["OrderDirection"] | undefined | null,
	end?: ValueTypes["OrderDirection"] | undefined | null,
	isDynamic?: ValueTypes["OrderDirection"] | undefined | null
};
	["TimetableTemplateOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null,
	startDate?: ValueTypes["OrderDirection"] | undefined | null,
	period?: ValueTypes["OrderDirection"] | undefined | null,
	slots?: ValueTypes["OrderDirection"] | undefined | null,
	position?: ValueTypes["TimetableShiftPositionOrderBy"] | undefined | null,
	internalName?: ValueTypes["OrderDirection"] | undefined | null,
	venue?: ValueTypes["VenueOrderBy"] | undefined | null,
	employeeRole?: ValueTypes["TimetableEmployeeRoleOrderBy"] | undefined | null,
	workdaysOnly?: ValueTypes["OrderDirection"] | undefined | null,
	monday?: ValueTypes["OrderDirection"] | undefined | null,
	tuesday?: ValueTypes["OrderDirection"] | undefined | null,
	wednesday?: ValueTypes["OrderDirection"] | undefined | null,
	thursday?: ValueTypes["OrderDirection"] | undefined | null,
	friday?: ValueTypes["OrderDirection"] | undefined | null,
	saturday?: ValueTypes["OrderDirection"] | undefined | null,
	sunday?: ValueTypes["OrderDirection"] | undefined | null,
	type?: ValueTypes["OrderDirection"] | undefined | null
};
	["TimetableShiftOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	locked?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null,
	assigned?: ValueTypes["OrderDirection"] | undefined | null,
	group?: ValueTypes["TimetableShiftGroupOrderBy"] | undefined | null,
	shiftsProfile?: ValueTypes["ShiftsProfileOrderBy"] | undefined | null,
	queueItem?: ValueTypes["EmployeeQueueItemOrderBy"] | undefined | null,
	swapInfo?: ValueTypes["TimetableShiftSwapInfoOrderBy"] | undefined | null,
	isOvertime?: ValueTypes["OrderDirection"] | undefined | null
};
	["TimetableShiftSwapInfoOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	assigned?: ValueTypes["OrderDirection"] | undefined | null,
	requested?: ValueTypes["OrderDirection"] | undefined | null,
	confirmed?: ValueTypes["OrderDirection"] | undefined | null,
	swappedShiftsProfile?: ValueTypes["ShiftsProfileOrderBy"] | undefined | null,
	shift?: ValueTypes["TimetableShiftOrderBy"] | undefined | null
};
	["UnassignedShiftInfoOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	hoursMissed?: ValueTypes["OrderDirection"] | undefined | null,
	queueItem?: ValueTypes["EmployeeQueueItemOrderBy"] | undefined | null,
	legacyReason?: ValueTypes["OrderDirection"] | undefined | null,
	reason?: ValueTypes["UnassignReasonOrderBy"] | undefined | null
};
	["UnassignReasonOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null
};
	["EmployeeQueueItemMetadataOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	totalMinutes?: ValueTypes["OrderDirection"] | undefined | null,
	queueItem?: ValueTypes["EmployeeQueueItemOrderBy"] | undefined | null,
	includeInTipsCalculation?: ValueTypes["OrderDirection"] | undefined | null
};
	["EmployeeQueueItemsByShiftsProfileUniqueWhere"]: {
	shiftsProfile?: ValueTypes["ShiftsProfileUniqueWhere"] | undefined | null
};
	["ShiftsProfileUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	queueItems?: ValueTypes["EmployeeQueueItemUniqueWhere"] | undefined | null,
	staff?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	shifts?: ValueTypes["TimetableShiftUniqueWhere"] | undefined | null
};
	["EmployeeQueueItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	shiftsProfile?: ValueTypes["ShiftsProfileUniqueWhere"] | undefined | null,
	queue?: ValueTypes["EmployeeQueueUniqueWhere"] | undefined | null,
	shift?: ValueTypes["TimetableShiftUniqueWhere"] | undefined | null,
	unassignInfo?: ValueTypes["UnassignedShiftInfoUniqueWhere"] | undefined | null,
	meta?: ValueTypes["EmployeeQueueItemMetadataUniqueWhere"] | undefined | null
};
	["EmployeeQueueUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	shiftGroup?: ValueTypes["TimetableShiftGroupUniqueWhere"] | undefined | null,
	items?: ValueTypes["EmployeeQueueItemUniqueWhere"] | undefined | null
};
	["TimetableShiftGroupUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	shifts?: ValueTypes["TimetableShiftUniqueWhere"] | undefined | null,
	queue?: ValueTypes["EmployeeQueueUniqueWhere"] | undefined | null
};
	["TimetableShiftUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	queueItem?: ValueTypes["EmployeeQueueItemUniqueWhere"] | undefined | null,
	swapInfo?: ValueTypes["TimetableShiftSwapInfoUniqueWhere"] | undefined | null
};
	["TimetableShiftSwapInfoUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	swappedShiftsProfile?: ValueTypes["ShiftsProfileUniqueWhere"] | undefined | null,
	shift?: ValueTypes["TimetableShiftUniqueWhere"] | undefined | null
};
	["UnassignedShiftInfoUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	queueItem?: ValueTypes["EmployeeQueueItemUniqueWhere"] | undefined | null
};
	["EmployeeQueueItemMetadataUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	queueItem?: ValueTypes["EmployeeQueueItemUniqueWhere"] | undefined | null
};
	["StaffUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	bartender?: ValueTypes["BartenderUniqueWhere"] | undefined | null,
	courier?: ValueTypes["CourierUniqueWhere"] | undefined | null,
	cleaner?: ValueTypes["CleanerUniqueWhere"] | undefined | null,
	shiftsManager?: ValueTypes["ShiftsManagerUniqueWhere"] | undefined | null,
	businessToBusinessManager?: ValueTypes["BusinessToBusinessManagerUniqueWhere"] | undefined | null,
	user?: ValueTypes["UserUniqueWhere"] | undefined | null,
	shiftsProfile?: ValueTypes["ShiftsProfileUniqueWhere"] | undefined | null,
	stocksManager?: ValueTypes["StocksManagerUniqueWhere"] | undefined | null,
	courierManager?: ValueTypes["CourierManagerUniqueWhere"] | undefined | null,
	picker?: ValueTypes["PickerUniqueWhere"] | undefined | null,
	remunerationProfile?: ValueTypes["RemunerationProfileUniqueWhere"] | undefined | null,
	cashier?: ValueTypes["CashierUniqueWhere"] | undefined | null,
	internalBuyer?: ValueTypes["InternalBuyerUniqueWhere"] | undefined | null,
	salesManager?: ValueTypes["SalesManagerUniqueWhere"] | undefined | null,
	cashierManager?: ValueTypes["CashierManagerUniqueWhere"] | undefined | null
};
	["BartenderUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	staff?: ValueTypes["StaffUniqueWhere"] | undefined | null
};
	["CourierUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	staff?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	routes?: ValueTypes["DeliveryRouteUniqueWhere"] | undefined | null
};
	["DeliveryRouteUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	waypoints?: ValueTypes["DeliveryWaypointUniqueWhere"] | undefined | null
};
	["DeliveryWaypointUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	delivery?: ValueTypes["OrderDeliveryUniqueWhere"] | undefined | null
};
	["OrderDeliveryUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	trackingCode?: string | undefined | null,
	order?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	deliveryWaypoint?: ValueTypes["DeliveryWaypointUniqueWhere"] | undefined | null,
	events?: ValueTypes["OrderEventUniqueWhere"] | undefined | null,
	liftagoRide?: ValueTypes["LiftagoRideUniqueWhere"] | undefined | null,
	woltDriveDelivery?: ValueTypes["WoltDriveDeliveryUniqueWhere"] | undefined | null
};
	["OrderUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	seq?: number | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	doubleShotLegacyNumber?: string | undefined | null,
	discounts?: ValueTypes["OrderDiscountUniqueWhere"] | undefined | null,
	delivery?: ValueTypes["OrderDeliveryUniqueWhere"] | undefined | null,
	items?: ValueTypes["OrderItemUniqueWhere"] | undefined | null,
	cart?: ValueTypes["CartUniqueWhere"] | undefined | null,
	events?: ValueTypes["OrderEventUniqueWhere"] | undefined | null,
	priceLines?: ValueTypes["OrderPriceLineUniqueWhere"] | undefined | null,
	payments?: ValueTypes["OrderPaymentUniqueWhere"] | undefined | null,
	summary?: ValueTypes["OrderSummaryUniqueWhere"] | undefined | null,
	gratuity?: ValueTypes["GratuityUniqueWhere"] | undefined | null
};
	["OrderDiscountUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	customerCreditTransactions?: ValueTypes["CustomerCreditTransactionUniqueWhere"] | undefined | null,
	voucherRedemption?: ValueTypes["VoucherRedemptionUniqueWhere"] | undefined | null
};
	["CustomerCreditTransactionUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	virtualProductEffect?: ValueTypes["VirtualProductEffectUniqueWhere"] | undefined | null
};
	["VirtualProductEffectUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	resultCustomerCreditTransaction?: ValueTypes["CustomerCreditTransactionUniqueWhere"] | undefined | null,
	resultVouchers?: ValueTypes["VoucherUniqueWhere"] | undefined | null
};
	["VoucherUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	redemption?: ValueTypes["VoucherRedemptionUniqueWhere"] | undefined | null
};
	["VoucherRedemptionUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	customerCredit?: ValueTypes["CustomerCreditUniqueWhere"] | undefined | null,
	orderDiscount?: ValueTypes["OrderDiscountUniqueWhere"] | undefined | null,
	voucher?: ValueTypes["VoucherUniqueWhere"] | undefined | null
};
	["CustomerCreditUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	transactions?: ValueTypes["CustomerCreditTransactionUniqueWhere"] | undefined | null,
	voucherRedemption?: ValueTypes["VoucherRedemptionUniqueWhere"] | undefined | null
};
	["OrderItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	virtualProductEffects?: ValueTypes["VirtualProductEffectUniqueWhere"] | undefined | null
};
	["CartUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: ValueTypes["CartItemUniqueWhere"] | undefined | null,
	order?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	priceLines?: ValueTypes["CartPriceLineUniqueWhere"] | undefined | null,
	summary?: ValueTypes["CartSummaryUniqueWhere"] | undefined | null
};
	["CartItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	cart?: ValueTypes["CartUniqueWhere"] | undefined | null,
	product?: ValueTypes["ProductUniqueWhere"] | undefined | null
};
	["ProductUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	stocks?: ValueTypes["ProductStockUniqueWhere"] | undefined | null,
	groupPrices?: ValueTypes["ProductGroupPriceUniqueWhere"] | undefined | null,
	cartItems?: ValueTypes["CartItemUniqueWhere"] | undefined | null,
	orderItems?: ValueTypes["OrderItemUniqueWhere"] | undefined | null,
	inheritedCategories?: ValueTypes["NestedProductCategoryProductUniqueWhere"] | undefined | null,
	locales?: ValueTypes["ProductLocaleUniqueWhere"] | undefined | null,
	customerPrices?: ValueTypes["ProductCustomerPriceUniqueWhere"] | undefined | null,
	virtualProduct?: ValueTypes["VirtualProductUniqueWhere"] | undefined | null,
	meta?: ValueTypes["ProductMetadataUniqueWhere"] | undefined | null,
	page?: ValueTypes["PageUniqueWhere"] | undefined | null,
	salesDays?: ValueTypes["ProductSalesDayUniqueWhere"] | undefined | null,
	salesWeeks?: ValueTypes["ProductSalesWeekUniqueWhere"] | undefined | null,
	salesMonths?: ValueTypes["ProductSalesMonthUniqueWhere"] | undefined | null
};
	["ProductStockUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	product?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	store?: ValueTypes["StoreUniqueWhere"] | undefined | null
};
	["StoreUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	code?: string | undefined | null
};
	["ProductGroupPriceUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	group?: ValueTypes["CustomerGroupUniqueWhere"] | undefined | null,
	product?: ValueTypes["ProductUniqueWhere"] | undefined | null
};
	["CustomerGroupUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	productPrices?: ValueTypes["ProductGroupPriceUniqueWhere"] | undefined | null,
	customers?: ValueTypes["CustomerUniqueWhere"] | undefined | null
};
	["CustomerUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	addresses?: ValueTypes["AddressUniqueWhere"] | undefined | null,
	defaultBillingAddress?: ValueTypes["AddressUniqueWhere"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerPaymentMethodUniqueWhere"] | undefined | null,
	credits?: ValueTypes["CustomerCreditUniqueWhere"] | undefined | null,
	paymentMethods?: ValueTypes["CustomerPaymentMethodUniqueWhere"] | undefined | null,
	orders?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	permissions?: ValueTypes["CustomerPermissionsUniqueWhere"] | undefined | null,
	name?: ValueTypes["CustomerNameUniqueWhere"] | undefined | null,
	ingredientRatings?: ValueTypes["CustomerIngredientRatingUniqueWhere"] | undefined | null,
	business?: ValueTypes["BusinessCustomerUniqueWhere"] | undefined | null,
	carts?: ValueTypes["CartUniqueWhere"] | undefined | null,
	shortcutList?: ValueTypes["ApplicationShortcutListUniqueWhere"] | undefined | null,
	user?: ValueTypes["UserUniqueWhere"] | undefined | null,
	invoices?: ValueTypes["InvoiceUniqueWhere"] | undefined | null,
	invoicingPlan?: ValueTypes["InvoicingPlanUniqueWhere"] | undefined | null,
	billingSubjects?: ValueTypes["BillingSubjectUniqueWhere"] | undefined | null,
	offeredProducts?: ValueTypes["ProductCustomerPriceUniqueWhere"] | undefined | null,
	defaultDeliveryAddress?: ValueTypes["AddressUniqueWhere"] | undefined | null,
	defaultBillingSubject?: ValueTypes["BillingSubjectUniqueWhere"] | undefined | null,
	anonymousSession?: ValueTypes["AnonymousSessionUniqueWhere"] | undefined | null,
	boughtVouchers?: ValueTypes["VoucherUniqueWhere"] | undefined | null,
	ownsVouchers?: ValueTypes["VoucherUniqueWhere"] | undefined | null,
	redeemedVouchers?: ValueTypes["VoucherRedemptionUniqueWhere"] | undefined | null,
	spending?: ValueTypes["CustomerSpendingUniqueWhere"] | undefined | null,
	customerTabs?: ValueTypes["CustomerTabUniqueWhere"] | undefined | null,
	lead?: ValueTypes["PipelineLeadUniqueWhere"] | undefined | null,
	meta?: ValueTypes["CustomerMetadataUniqueWhere"] | undefined | null
};
	["AddressUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	meta?: ValueTypes["AddressMetadataUniqueWhere"] | undefined | null,
	gps?: ValueTypes["GpsUniqueWhere"] | undefined | null,
	invoices?: ValueTypes["InvoiceUniqueWhere"] | undefined | null,
	billingAddressOfOrders?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	deliveryAddressOfOrderDeliveries?: ValueTypes["OrderDeliveryUniqueWhere"] | undefined | null,
	defaultDeliveryAddressOfCustomer?: ValueTypes["CustomerUniqueWhere"] | undefined | null
};
	["AddressMetadataUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	address?: ValueTypes["AddressUniqueWhere"] | undefined | null
};
	["GpsUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	address?: ValueTypes["AddressUniqueWhere"] | undefined | null
};
	["InvoiceUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	publicKey?: string | undefined | null,
	fakturoidId?: string | undefined | null,
	orderPayments?: ValueTypes["OrderPaymentUniqueWhere"] | undefined | null
};
	["OrderPaymentUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	events?: ValueTypes["OrderEventUniqueWhere"] | undefined | null,
	meta?: ValueTypes["OrderPaymentMetadataUniqueWhere"] | undefined | null
};
	["OrderEventUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["OrderPaymentMetadataUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	orderPayment?: ValueTypes["OrderPaymentUniqueWhere"] | undefined | null
};
	["CustomerPaymentMethodUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["CustomerPermissionsUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	customer?: ValueTypes["CustomerUniqueWhere"] | undefined | null
};
	["CustomerNameUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	customer?: ValueTypes["CustomerUniqueWhere"] | undefined | null
};
	["CustomerIngredientRatingUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	customer?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	ingredient?: ValueTypes["ProductIngredientUniqueWhere"] | undefined | null
};
	["ProductIngredientUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	locales?: ValueTypes["ProductIngredientLocaleUniqueWhere"] | undefined | null,
	customerRatings?: ValueTypes["CustomerIngredientRatingUniqueWhere"] | undefined | null,
	suppliers?: ValueTypes["IngredientSupplierListUniqueWhere"] | undefined | null
};
	["ProductIngredientLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	root?: ValueTypes["ProductIngredientUniqueWhere"] | undefined | null,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null
};
	["LocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	businessCategories?: ValueTypes["BusinessCategoryLocaleUniqueWhere"] | undefined | null,
	productCategoryLists?: ValueTypes["ProductCategoryListLocaleUniqueWhere"] | undefined | null,
	productIngredients?: ValueTypes["ProductIngredientLocaleUniqueWhere"] | undefined | null,
	orderRecurrences?: ValueTypes["OrderRecurrenceLocaleUniqueWhere"] | undefined | null,
	blogs?: ValueTypes["BlogLocaleUniqueWhere"] | undefined | null,
	blogPosts?: ValueTypes["BlogPostLocaleUniqueWhere"] | undefined | null,
	identifier?: ValueTypes["TranslationCataloguesIdentifierUniqueWhere"] | undefined | null,
	menus?: ValueTypes["MenuLocaleUniqueWhere"] | undefined | null,
	pages?: ValueTypes["PageLocaleUniqueWhere"] | undefined | null,
	productIngredientCategories?: ValueTypes["ProductIngredientCategoryLocaleUniqueWhere"] | undefined | null,
	allergens?: ValueTypes["AllergenLocaleUniqueWhere"] | undefined | null,
	productPackings?: ValueTypes["ProductPackingLocaleUniqueWhere"] | undefined | null,
	products?: ValueTypes["ProductLocaleUniqueWhere"] | undefined | null,
	productRecipes?: ValueTypes["ProductRecipeLocaleUniqueWhere"] | undefined | null,
	pointOfSaleCategories?: ValueTypes["PointOfSaleCategoryLocaleUniqueWhere"] | undefined | null,
	pointOfSaleCategoryProducts?: ValueTypes["PointOfSaleCategoryProductLocaleUniqueWhere"] | undefined | null,
	deliveryMethods?: ValueTypes["DeliveryMethodLocaleUniqueWhere"] | undefined | null,
	ingredientSuppliers?: ValueTypes["IngredientSupplierLocaleUniqueWhere"] | undefined | null,
	identificationCodes?: ValueTypes["IdentificationCodeLocaleUniqueWhere"] | undefined | null,
	pipelineStages?: ValueTypes["PipelineStageLocaleUniqueWhere"] | undefined | null,
	subscriptionBoxes?: ValueTypes["SubscriptionBoxLocaleUniqueWhere"] | undefined | null,
	businessServices?: ValueTypes["BusinessServiceLocaleUniqueWhere"] | undefined | null
};
	["BusinessCategoryLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	root?: ValueTypes["BusinessCategoryUniqueWhere"] | undefined | null,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null
};
	["BusinessCategoryUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	slug?: string | undefined | null,
	locales?: ValueTypes["BusinessCategoryLocaleUniqueWhere"] | undefined | null,
	businessCustomers?: ValueTypes["BusinessCustomerUniqueWhere"] | undefined | null,
	specificProducts?: ValueTypes["ProductListUniqueWhere"] | undefined | null,
	seasonalProductCategories?: ValueTypes["ProductCategoryListUniqueWhere"] | undefined | null,
	specificProductsProductCategories?: ValueTypes["ProductCategoryListUniqueWhere"] | undefined | null
};
	["BusinessCustomerUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	customer?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	businessServiceEvents?: ValueTypes["BusinessServiceEventUniqueWhere"] | undefined | null,
	doubleshotCoffeeEquipment?: ValueTypes["DoubleshotCoffeeEquipmentUniqueWhere"] | undefined | null
};
	["BusinessServiceEventUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["DoubleshotCoffeeEquipmentUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["ProductListUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: ValueTypes["ProductListItemUniqueWhere"] | undefined | null,
	businessCategory?: ValueTypes["BusinessCategoryUniqueWhere"] | undefined | null
};
	["ProductListItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["ProductCategoryListUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: ValueTypes["ProductCategoryListItemUniqueWhere"] | undefined | null,
	locales?: ValueTypes["ProductCategoryListLocaleUniqueWhere"] | undefined | null,
	seasonalProductCategoriesOfBusinessCategory?: ValueTypes["BusinessCategoryUniqueWhere"] | undefined | null,
	specificProductsProductCategoriesOfBusinessCategory?: ValueTypes["BusinessCategoryUniqueWhere"] | undefined | null
};
	["ProductCategoryListItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["ProductCategoryListLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	root?: ValueTypes["ProductCategoryListUniqueWhere"] | undefined | null,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null
};
	["OrderRecurrenceLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	root?: ValueTypes["OrderRecurrenceUniqueWhere"] | undefined | null,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null
};
	["OrderRecurrenceUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	locales?: ValueTypes["OrderRecurrenceLocaleUniqueWhere"] | undefined | null
};
	["BlogLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	root?: ValueTypes["BlogUniqueWhere"] | undefined | null,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null
};
	["BlogUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	unique?: ValueTypes["One"] | undefined | null,
	locales?: ValueTypes["BlogLocaleUniqueWhere"] | undefined | null
};
	["BlogPostLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	root?: ValueTypes["BlogPostUniqueWhere"] | undefined | null,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	cover?: ValueTypes["CoverUniqueWhere"] | undefined | null,
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null,
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null,
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null
};
	["BlogPostUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	locales?: ValueTypes["BlogPostLocaleUniqueWhere"] | undefined | null
};
	["CoverUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["ContentUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	blocks?: ValueTypes["ContentBlockUniqueWhere"] | undefined | null
};
	["ContentBlockUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	references?: ValueTypes["ContentReferenceUniqueWhere"] | undefined | null
};
	["ContentReferenceUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	products?: ValueTypes["ProductListUniqueWhere"] | undefined | null,
	productBanners?: ValueTypes["ProductBannerListUniqueWhere"] | undefined | null,
	deliveryRegions?: ValueTypes["DeliveryRegionsUniqueWhere"] | undefined | null
};
	["ProductBannerListUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: ValueTypes["ProductBannerItemUniqueWhere"] | undefined | null
};
	["ProductBannerItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["DeliveryRegionsUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: ValueTypes["DeliveryRegionsItemUniqueWhere"] | undefined | null
};
	["DeliveryRegionsItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	image?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	textList?: ValueTypes["TextListUniqueWhere"] | undefined | null,
	gallery?: ValueTypes["ImageListUniqueWhere"] | undefined | null
};
	["ImageUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["TextListUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: ValueTypes["TextItemUniqueWhere"] | undefined | null
};
	["TextItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["ImageListUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: ValueTypes["ImageListItemUniqueWhere"] | undefined | null
};
	["ImageListItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	image?: ValueTypes["ImageUniqueWhere"] | undefined | null
};
	["LinkableUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	url?: string | undefined | null,
	blogPost?: ValueTypes["BlogPostLocaleUniqueWhere"] | undefined | null,
	page?: ValueTypes["PageLocaleUniqueWhere"] | undefined | null,
	wikiPage?: ValueTypes["WikiPageUniqueWhere"] | undefined | null,
	redirect?: ValueTypes["RedirectUniqueWhere"] | undefined | null
};
	["PageLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	root?: ValueTypes["PageUniqueWhere"] | undefined | null,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null,
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null,
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null,
	cover?: ValueTypes["CoverUniqueWhere"] | undefined | null
};
	["PageUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	locales?: ValueTypes["PageLocaleUniqueWhere"] | undefined | null
};
	["SeoUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	ogImage?: ValueTypes["ImageUniqueWhere"] | undefined | null
};
	["WikiPageUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null,
	children?: ValueTypes["WikiPageUniqueWhere"] | undefined | null,
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null
};
	["RedirectUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null
};
	["TranslationCataloguesIdentifierUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	catalogue?: ValueTypes["TranslationCatalogueUniqueWhere"] | undefined | null
};
	["TranslationCatalogueUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	domain?: ValueTypes["TranslationDomainUniqueWhere"] | undefined | null,
	identifier?: ValueTypes["TranslationCataloguesIdentifierUniqueWhere"] | undefined | null,
	values?: ValueTypes["TranslationValueUniqueWhere"] | undefined | null
};
	["TranslationDomainUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	identifier?: string | undefined | null,
	catalogues?: ValueTypes["TranslationCatalogueUniqueWhere"] | undefined | null,
	keys?: ValueTypes["TranslationKeyUniqueWhere"] | undefined | null
};
	["TranslationKeyUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	domain?: ValueTypes["TranslationDomainUniqueWhere"] | undefined | null,
	identifier?: string | undefined | null,
	values?: ValueTypes["TranslationValueUniqueWhere"] | undefined | null
};
	["TranslationValueUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	catalogue?: ValueTypes["TranslationCatalogueUniqueWhere"] | undefined | null,
	key?: ValueTypes["TranslationKeyUniqueWhere"] | undefined | null
};
	["MenuLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	root?: ValueTypes["SiteMenuUniqueWhere"] | undefined | null,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	items?: ValueTypes["MenuItemUniqueWhere"] | undefined | null,
	secondaryItems?: ValueTypes["LinkListUniqueWhere"] | undefined | null
};
	["SiteMenuUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	unique?: ValueTypes["One"] | undefined | null,
	locales?: ValueTypes["MenuLocaleUniqueWhere"] | undefined | null
};
	["MenuItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	subitems?: ValueTypes["MenuSubitemUniqueWhere"] | undefined | null
};
	["MenuSubitemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["LinkListUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: ValueTypes["LinkListItemUniqueWhere"] | undefined | null
};
	["LinkListItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["ProductIngredientCategoryLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	root?: ValueTypes["ProductIngredientCategoryUniqueWhere"] | undefined | null,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null
};
	["ProductIngredientCategoryUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	locales?: ValueTypes["ProductIngredientCategoryLocaleUniqueWhere"] | undefined | null
};
	["AllergenLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	root?: ValueTypes["AllergenUniqueWhere"] | undefined | null,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null
};
	["AllergenUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	code?: number | undefined | null,
	locales?: ValueTypes["AllergenLocaleUniqueWhere"] | undefined | null
};
	["ProductPackingLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	root?: ValueTypes["ProductPackingUniqueWhere"] | undefined | null,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null
};
	["ProductPackingUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	locales?: ValueTypes["ProductPackingLocaleUniqueWhere"] | undefined | null,
	preparedPackingQuantities?: ValueTypes["PreparedPackingQuantityUniqueWhere"] | undefined | null
};
	["PreparedPackingQuantityUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	date?: ValueTypes["Date"] | undefined | null,
	recipe?: ValueTypes["ProductRecipeUniqueWhere"] | undefined | null,
	packing?: ValueTypes["ProductPackingUniqueWhere"] | undefined | null,
	packedInCardboard?: boolean | undefined | null
};
	["ProductRecipeUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	products?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	ingredients?: ValueTypes["ProductIngredientItemUniqueWhere"] | undefined | null,
	locales?: ValueTypes["ProductRecipeLocaleUniqueWhere"] | undefined | null,
	nutritionFacts?: ValueTypes["NutritionFactsUniqueWhere"] | undefined | null
};
	["ProductIngredientItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	quantity?: ValueTypes["ProductIngredientItemQuantityUniqueWhere"] | undefined | null
};
	["ProductIngredientItemQuantityUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["ProductRecipeLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	root?: ValueTypes["ProductRecipeUniqueWhere"] | undefined | null,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null
};
	["NutritionFactsUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["ProductLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	root?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	featureList?: ValueTypes["TextListUniqueWhere"] | undefined | null
};
	["PointOfSaleCategoryLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	root?: ValueTypes["PointOfSaleCategoryUniqueWhere"] | undefined | null,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null
};
	["PointOfSaleCategoryUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	slug?: string | undefined | null,
	locales?: ValueTypes["PointOfSaleCategoryLocaleUniqueWhere"] | undefined | null,
	products?: ValueTypes["PointOfSaleCategoryProductUniqueWhere"] | undefined | null
};
	["PointOfSaleCategoryProductUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	locales?: ValueTypes["PointOfSaleCategoryProductLocaleUniqueWhere"] | undefined | null
};
	["PointOfSaleCategoryProductLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	root?: ValueTypes["PointOfSaleCategoryProductUniqueWhere"] | undefined | null,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null
};
	["DeliveryMethodLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	root?: ValueTypes["DeliveryMethodUniqueWhere"] | undefined | null
};
	["DeliveryMethodUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	channels?: ValueTypes["ChannelDeliveryUniqueWhere"] | undefined | null,
	locales?: ValueTypes["DeliveryMethodLocaleUniqueWhere"] | undefined | null,
	timelinePreset?: ValueTypes["DeliveryTimelinePresetUniqueWhere"] | undefined | null
};
	["ChannelDeliveryUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["DeliveryTimelinePresetUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	deliveryMethod?: ValueTypes["DeliveryMethodUniqueWhere"] | undefined | null
};
	["IngredientSupplierLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	root?: ValueTypes["IngredientSupplierUniqueWhere"] | undefined | null,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null
};
	["IngredientSupplierUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	locales?: ValueTypes["IngredientSupplierLocaleUniqueWhere"] | undefined | null
};
	["IdentificationCodeLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	root?: ValueTypes["IdentificationCodeUniqueWhere"] | undefined | null,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null
};
	["IdentificationCodeUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	attempts?: ValueTypes["IdentificationAttemptUniqueWhere"] | undefined | null,
	locales?: ValueTypes["IdentificationCodeLocaleUniqueWhere"] | undefined | null,
	applicationDevices?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null
};
	["IdentificationAttemptUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["PointOfSaleApplicationDeviceUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	identifier?: ValueTypes["DeviceIdentifierUniqueWhere"] | undefined | null
};
	["DeviceIdentifierUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	identifier?: string | undefined | null,
	device?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null,
	meta?: ValueTypes["DeviceIdentifierMetadataUniqueWhere"] | undefined | null
};
	["DeviceIdentifierMetadataUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	deviceIdentifier?: ValueTypes["DeviceIdentifierUniqueWhere"] | undefined | null
};
	["PipelineStageLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	root?: ValueTypes["PipelineStageUniqueWhere"] | undefined | null,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null
};
	["PipelineStageUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: ValueTypes["PipelineStageItemUniqueWhere"] | undefined | null,
	locales?: ValueTypes["PipelineStageLocaleUniqueWhere"] | undefined | null,
	forms?: ValueTypes["LeadFormUniqueWhere"] | undefined | null
};
	["PipelineStageItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	lead?: ValueTypes["PipelineLeadUniqueWhere"] | undefined | null
};
	["PipelineLeadUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	stageItem?: ValueTypes["PipelineStageItemUniqueWhere"] | undefined | null
};
	["LeadFormUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	leads?: ValueTypes["PipelineLeadUniqueWhere"] | undefined | null
};
	["SubscriptionBoxLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	root?: ValueTypes["SubscriptionBoxUniqueWhere"] | undefined | null,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	texts?: ValueTypes["TextListUniqueWhere"] | undefined | null,
	secondaryTexts?: ValueTypes["TextListUniqueWhere"] | undefined | null
};
	["SubscriptionBoxUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	unique?: ValueTypes["One"] | undefined | null,
	locales?: ValueTypes["SubscriptionBoxLocaleUniqueWhere"] | undefined | null
};
	["BusinessServiceLocaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	root?: ValueTypes["BusinessServiceUniqueWhere"] | undefined | null,
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null
};
	["BusinessServiceUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	locales?: ValueTypes["BusinessServiceLocaleUniqueWhere"] | undefined | null
};
	["IngredientSupplierListUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: ValueTypes["IngredientSupplierItemUniqueWhere"] | undefined | null
};
	["IngredientSupplierItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["ApplicationShortcutListUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: ValueTypes["ApplicationShortcutListItemUniqueWhere"] | undefined | null,
	customer?: ValueTypes["CustomerUniqueWhere"] | undefined | null
};
	["ApplicationShortcutListItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["UserUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	tenantPersonId?: ValueTypes["UUID"] | undefined | null,
	staff?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	customer?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	devices?: ValueTypes["UserDeviceUniqueWhere"] | undefined | null,
	meta?: ValueTypes["UserMetadataUniqueWhere"] | undefined | null,
	identificationAttempts?: ValueTypes["IdentificationAttemptUniqueWhere"] | undefined | null,
	roles?: ValueTypes["UserRolesUniqueWhere"] | undefined | null
};
	["UserDeviceUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	deviceId?: string | undefined | null
};
	["UserMetadataUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	tenantEmail?: string | undefined | null,
	tenantPersonId?: ValueTypes["UUID"] | undefined | null,
	tenantIdentityId?: ValueTypes["UUID"] | undefined | null,
	user?: ValueTypes["UserUniqueWhere"] | undefined | null
};
	["UserRolesUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	user?: ValueTypes["UserUniqueWhere"] | undefined | null
};
	["InvoicingPlanUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	customer?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	preset?: ValueTypes["InvoicingPresetUniqueWhere"] | undefined | null
};
	["InvoicingPresetUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	invoicingPlan?: ValueTypes["InvoicingPlanUniqueWhere"] | undefined | null
};
	["BillingSubjectUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	invoices?: ValueTypes["InvoiceUniqueWhere"] | undefined | null,
	defaultBillingSubjectOfCustomer?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	orders?: ValueTypes["OrderUniqueWhere"] | undefined | null
};
	["ProductCustomerPriceUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	product?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	customer?: ValueTypes["CustomerUniqueWhere"] | undefined | null
};
	["AnonymousSessionUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	anonymousSessionKey?: string | undefined | null,
	customer?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	devices?: ValueTypes["UserDeviceUniqueWhere"] | undefined | null
};
	["CustomerSpendingUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	customer?: ValueTypes["CustomerUniqueWhere"] | undefined | null
};
	["CustomerTabUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: ValueTypes["CustomerTabItemUniqueWhere"] | undefined | null,
	meta?: ValueTypes["CustomerTabMetadataUniqueWhere"] | undefined | null
};
	["CustomerTabItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["CustomerTabMetadataUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	customerTab?: ValueTypes["CustomerTabUniqueWhere"] | undefined | null
};
	["CustomerMetadataUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	customer?: ValueTypes["CustomerUniqueWhere"] | undefined | null
};
	["NestedProductCategoryProductUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["VirtualProductUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	product?: ValueTypes["ProductUniqueWhere"] | undefined | null
};
	["ProductMetadataUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	product?: ValueTypes["ProductUniqueWhere"] | undefined | null
};
	["ProductSalesDayUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["ProductSalesWeekUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["ProductSalesMonthUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["CartPriceLineUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["CartSummaryUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	cart?: ValueTypes["CartUniqueWhere"] | undefined | null
};
	["OrderPriceLineUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	orderItem?: ValueTypes["OrderItemUniqueWhere"] | undefined | null,
	orderDiscount?: ValueTypes["OrderDiscountUniqueWhere"] | undefined | null,
	orderPayment?: ValueTypes["OrderPaymentUniqueWhere"] | undefined | null,
	orderDelivery?: ValueTypes["OrderDeliveryUniqueWhere"] | undefined | null
};
	["OrderSummaryUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: ValueTypes["OrderUniqueWhere"] | undefined | null
};
	["GratuityUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: ValueTypes["OrderUniqueWhere"] | undefined | null
};
	["LiftagoRideUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	delivery?: ValueTypes["OrderDeliveryUniqueWhere"] | undefined | null
};
	["WoltDriveDeliveryUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	shipmentPromiseId?: string | undefined | null,
	deliveryOrderId?: string | undefined | null,
	delivery?: ValueTypes["OrderDeliveryUniqueWhere"] | undefined | null
};
	["CleanerUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	staff?: ValueTypes["StaffUniqueWhere"] | undefined | null
};
	["ShiftsManagerUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	staff?: ValueTypes["StaffUniqueWhere"] | undefined | null
};
	["BusinessToBusinessManagerUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	staff?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	managedBusinesses?: ValueTypes["BusinessCustomerUniqueWhere"] | undefined | null
};
	["StocksManagerUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	staff?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	managedProducts?: ValueTypes["ProductUniqueWhere"] | undefined | null
};
	["CourierManagerUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	staff?: ValueTypes["StaffUniqueWhere"] | undefined | null
};
	["PickerUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	staff?: ValueTypes["StaffUniqueWhere"] | undefined | null
};
	["RemunerationProfileUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	employmentInformation?: ValueTypes["EmploymentInformationUniqueWhere"] | undefined | null,
	staff?: ValueTypes["StaffUniqueWhere"] | undefined | null
};
	["EmploymentInformationUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["CashierUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	staff?: ValueTypes["StaffUniqueWhere"] | undefined | null
};
	["InternalBuyerUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	staff?: ValueTypes["StaffUniqueWhere"] | undefined | null
};
	["SalesManagerUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	staff?: ValueTypes["StaffUniqueWhere"] | undefined | null
};
	["CashierManagerUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	staff?: ValueTypes["StaffUniqueWhere"] | undefined | null
};
	["EmployeeQueueItemsByShiftUniqueWhere"]: {
	shift?: ValueTypes["TimetableShiftUniqueWhere"] | undefined | null
};
	["EmployeeQueueItemsByUnassignInfoUniqueWhere"]: {
	unassignInfo?: ValueTypes["UnassignedShiftInfoUniqueWhere"] | undefined | null
};
	["EmployeeQueueItemsByMetaUniqueWhere"]: {
	meta?: ValueTypes["EmployeeQueueItemMetadataUniqueWhere"] | undefined | null
};
	["EmployeeQueueItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["EmployeeQueueItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["EmployeeQueueItemEdge"]: AliasType<{
	node?:ValueTypes["EmployeeQueueItem"],
		__typename?: boolean | `@${string}`
}>;
	["UnassignedShiftInfo"]: AliasType<{
	_meta?:ValueTypes["UnassignedShiftInfoMeta"],
	id?:boolean | `@${string}`,
	hoursMissed?:boolean | `@${string}`,
queueItem?: [{	filter?: ValueTypes["EmployeeQueueItemWhere"] | undefined | null},ValueTypes["EmployeeQueueItem"]],
	legacyReason?:boolean | `@${string}`,
reason?: [{	filter?: ValueTypes["UnassignReasonWhere"] | undefined | null},ValueTypes["UnassignReason"]],
		__typename?: boolean | `@${string}`
}>;
	["UnassignedShiftInfoMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	hoursMissed?:ValueTypes["FieldMeta"],
	queueItem?:ValueTypes["FieldMeta"],
	legacyReason?:ValueTypes["FieldMeta"],
	reason?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["UnassignReason"]: AliasType<{
	_meta?:ValueTypes["UnassignReasonMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
venues?: [{	filter?: ValueTypes["VenueWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VenueOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Venue"]],
paginateVenues?: [{	filter?: ValueTypes["VenueWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VenueOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["VenueConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["UnassignReasonMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	venues?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["VenueConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["VenueEdge"],
		__typename?: boolean | `@${string}`
}>;
	["VenueEdge"]: AliasType<{
	node?:ValueTypes["Venue"],
		__typename?: boolean | `@${string}`
}>;
	["EmployeeQueueItemMetadata"]: AliasType<{
	_meta?:ValueTypes["EmployeeQueueItemMetadataMeta"],
	id?:boolean | `@${string}`,
	totalMinutes?:boolean | `@${string}`,
queueItem?: [{	filter?: ValueTypes["EmployeeQueueItemWhere"] | undefined | null},ValueTypes["EmployeeQueueItem"]],
	includeInTipsCalculation?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["EmployeeQueueItemMetadataMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	totalMinutes?:ValueTypes["FieldMeta"],
	queueItem?:ValueTypes["FieldMeta"],
	includeInTipsCalculation?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableEmployeeRole"]: AliasType<{
	_meta?:ValueTypes["TimetableEmployeeRoleMeta"],
	id?:boolean | `@${string}`,
shiftGroups?: [{	filter?: ValueTypes["TimetableShiftGroupWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableShiftGroupOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TimetableShiftGroup"]],
shiftsProfiles?: [{	filter?: ValueTypes["ShiftsProfileWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ShiftsProfileOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ShiftsProfile"]],
shiftsManagers?: [{	filter?: ValueTypes["ShiftsManagerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ShiftsManagerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ShiftsManager"]],
	name?:boolean | `@${string}`,
timetableTemplates?: [{	filter?: ValueTypes["TimetableTemplateWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableTemplateOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TimetableTemplate"]],
	color?:boolean | `@${string}`,
shiftGroupsByShifts?: [{	by: ValueTypes["TimetableEmployeeRoleShiftGroupsByShiftsUniqueWhere"],	filter?: ValueTypes["TimetableShiftGroupWhere"] | undefined | null},ValueTypes["TimetableShiftGroup"]],
shiftGroupsByQueue?: [{	by: ValueTypes["TimetableEmployeeRoleShiftGroupsByQueueUniqueWhere"],	filter?: ValueTypes["TimetableShiftGroupWhere"] | undefined | null},ValueTypes["TimetableShiftGroup"]],
timetableTemplatesByStaffOptions?: [{	by: ValueTypes["TimetableEmployeeRoleTimetableTemplatesByStaffOptionsUniqueWhere"],	filter?: ValueTypes["TimetableTemplateWhere"] | undefined | null},ValueTypes["TimetableTemplate"]],
paginateShiftGroups?: [{	filter?: ValueTypes["TimetableShiftGroupWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableShiftGroupOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TimetableShiftGroupConnection"]],
paginateShiftsProfiles?: [{	filter?: ValueTypes["ShiftsProfileWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ShiftsProfileOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ShiftsProfileConnection"]],
paginateShiftsManagers?: [{	filter?: ValueTypes["ShiftsManagerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ShiftsManagerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ShiftsManagerConnection"]],
paginateTimetableTemplates?: [{	filter?: ValueTypes["TimetableTemplateWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableTemplateOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TimetableTemplateConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["TimetableEmployeeRoleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	shiftGroups?:ValueTypes["FieldMeta"],
	shiftsProfiles?:ValueTypes["FieldMeta"],
	shiftsManagers?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	timetableTemplates?:ValueTypes["FieldMeta"],
	color?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ShiftsManager"]: AliasType<{
	_meta?:ValueTypes["ShiftsManagerMeta"],
	id?:boolean | `@${string}`,
staff?: [{	filter?: ValueTypes["StaffWhere"] | undefined | null},ValueTypes["Staff"]],
managedRoles?: [{	filter?: ValueTypes["TimetableEmployeeRoleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableEmployeeRoleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TimetableEmployeeRole"]],
	createdAt?:boolean | `@${string}`,
paginateManagedRoles?: [{	filter?: ValueTypes["TimetableEmployeeRoleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableEmployeeRoleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TimetableEmployeeRoleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ShiftsManagerMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	staff?:ValueTypes["FieldMeta"],
	managedRoles?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableEmployeeRoleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TimetableEmployeeRoleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableEmployeeRoleEdge"]: AliasType<{
	node?:ValueTypes["TimetableEmployeeRole"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableTemplate"]: AliasType<{
	_meta?:ValueTypes["TimetableTemplateMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	startDate?:boolean | `@${string}`,
	period?:boolean | `@${string}`,
	slots?:boolean | `@${string}`,
position?: [{	filter?: ValueTypes["TimetableShiftPositionWhere"] | undefined | null},ValueTypes["TimetableShiftPosition"]],
staffOptions?: [{	filter?: ValueTypes["TimetableTemplateStaffOptionsWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableTemplateStaffOptionsOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TimetableTemplateStaffOptions"]],
	internalName?:boolean | `@${string}`,
venue?: [{	filter?: ValueTypes["VenueWhere"] | undefined | null},ValueTypes["Venue"]],
employeeRole?: [{	filter?: ValueTypes["TimetableEmployeeRoleWhere"] | undefined | null},ValueTypes["TimetableEmployeeRole"]],
	workdaysOnly?:boolean | `@${string}`,
	monday?:boolean | `@${string}`,
	tuesday?:boolean | `@${string}`,
	wednesday?:boolean | `@${string}`,
	thursday?:boolean | `@${string}`,
	friday?:boolean | `@${string}`,
	saturday?:boolean | `@${string}`,
	sunday?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
paginateStaffOptions?: [{	filter?: ValueTypes["TimetableTemplateStaffOptionsWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableTemplateStaffOptionsOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TimetableTemplateStaffOptionsConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["TimetableTemplateMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	startDate?:ValueTypes["FieldMeta"],
	period?:ValueTypes["FieldMeta"],
	slots?:ValueTypes["FieldMeta"],
	position?:ValueTypes["FieldMeta"],
	staffOptions?:ValueTypes["FieldMeta"],
	internalName?:ValueTypes["FieldMeta"],
	venue?:ValueTypes["FieldMeta"],
	employeeRole?:ValueTypes["FieldMeta"],
	workdaysOnly?:ValueTypes["FieldMeta"],
	monday?:ValueTypes["FieldMeta"],
	tuesday?:ValueTypes["FieldMeta"],
	wednesday?:ValueTypes["FieldMeta"],
	thursday?:ValueTypes["FieldMeta"],
	friday?:ValueTypes["FieldMeta"],
	saturday?:ValueTypes["FieldMeta"],
	sunday?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableShiftPosition"]: AliasType<{
	_meta?:ValueTypes["TimetableShiftPositionMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	start?:boolean | `@${string}`,
	end?:boolean | `@${string}`,
shiftGroups?: [{	filter?: ValueTypes["TimetableShiftGroupWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableShiftGroupOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TimetableShiftGroup"]],
timetableTemplates?: [{	filter?: ValueTypes["TimetableTemplateWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableTemplateOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TimetableTemplate"]],
	isDynamic?:boolean | `@${string}`,
shiftGroupsByShifts?: [{	by: ValueTypes["TimetableShiftPositionShiftGroupsByShiftsUniqueWhere"],	filter?: ValueTypes["TimetableShiftGroupWhere"] | undefined | null},ValueTypes["TimetableShiftGroup"]],
shiftGroupsByQueue?: [{	by: ValueTypes["TimetableShiftPositionShiftGroupsByQueueUniqueWhere"],	filter?: ValueTypes["TimetableShiftGroupWhere"] | undefined | null},ValueTypes["TimetableShiftGroup"]],
timetableTemplatesByStaffOptions?: [{	by: ValueTypes["TimetableShiftPositionTimetableTemplatesByStaffOptionsUniqueWhere"],	filter?: ValueTypes["TimetableTemplateWhere"] | undefined | null},ValueTypes["TimetableTemplate"]],
paginateShiftGroups?: [{	filter?: ValueTypes["TimetableShiftGroupWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableShiftGroupOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TimetableShiftGroupConnection"]],
paginateTimetableTemplates?: [{	filter?: ValueTypes["TimetableTemplateWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableTemplateOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TimetableTemplateConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["TimetableShiftPositionMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	start?:ValueTypes["FieldMeta"],
	end?:ValueTypes["FieldMeta"],
	shiftGroups?:ValueTypes["FieldMeta"],
	timetableTemplates?:ValueTypes["FieldMeta"],
	isDynamic?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableShiftPositionShiftGroupsByShiftsUniqueWhere"]: {
	shifts?: ValueTypes["TimetableShiftUniqueWhere"] | undefined | null
};
	["TimetableShiftPositionShiftGroupsByQueueUniqueWhere"]: {
	queue?: ValueTypes["EmployeeQueueUniqueWhere"] | undefined | null
};
	["TimetableShiftPositionTimetableTemplatesByStaffOptionsUniqueWhere"]: {
	staffOptions?: ValueTypes["TimetableTemplateStaffOptionsUniqueWhere"] | undefined | null
};
	["TimetableTemplateStaffOptionsUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["TimetableShiftGroupConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TimetableShiftGroupEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableShiftGroupEdge"]: AliasType<{
	node?:ValueTypes["TimetableShiftGroup"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableTemplateConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TimetableTemplateEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableTemplateEdge"]: AliasType<{
	node?:ValueTypes["TimetableTemplate"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableTemplateStaffOptions"]: AliasType<{
	_meta?:ValueTypes["TimetableTemplateStaffOptionsMeta"],
	id?:boolean | `@${string}`,
	startTime?:boolean | `@${string}`,
	endTime?:boolean | `@${string}`,
timetableTemplate?: [{	filter?: ValueTypes["TimetableTemplateWhere"] | undefined | null},ValueTypes["TimetableTemplate"]],
autoAssignedEmployee?: [{	filter?: ValueTypes["ShiftsProfileWhere"] | undefined | null},ValueTypes["ShiftsProfile"]],
		__typename?: boolean | `@${string}`
}>;
	["TimetableTemplateStaffOptionsMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	startTime?:ValueTypes["FieldMeta"],
	endTime?:ValueTypes["FieldMeta"],
	timetableTemplate?:ValueTypes["FieldMeta"],
	autoAssignedEmployee?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableTemplateStaffOptionsOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	startTime?: ValueTypes["OrderDirection"] | undefined | null,
	endTime?: ValueTypes["OrderDirection"] | undefined | null,
	timetableTemplate?: ValueTypes["TimetableTemplateOrderBy"] | undefined | null,
	autoAssignedEmployee?: ValueTypes["ShiftsProfileOrderBy"] | undefined | null
};
	["TimetableTemplateStaffOptionsConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TimetableTemplateStaffOptionsEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableTemplateStaffOptionsEdge"]: AliasType<{
	node?:ValueTypes["TimetableTemplateStaffOptions"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableEmployeeRoleShiftGroupsByShiftsUniqueWhere"]: {
	shifts?: ValueTypes["TimetableShiftUniqueWhere"] | undefined | null
};
	["TimetableEmployeeRoleShiftGroupsByQueueUniqueWhere"]: {
	queue?: ValueTypes["EmployeeQueueUniqueWhere"] | undefined | null
};
	["TimetableEmployeeRoleTimetableTemplatesByStaffOptionsUniqueWhere"]: {
	staffOptions?: ValueTypes["TimetableTemplateStaffOptionsUniqueWhere"] | undefined | null
};
	["ShiftsProfileConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ShiftsProfileEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ShiftsProfileEdge"]: AliasType<{
	node?:ValueTypes["ShiftsProfile"],
		__typename?: boolean | `@${string}`
}>;
	["ShiftsManagerConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ShiftsManagerEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ShiftsManagerEdge"]: AliasType<{
	node?:ValueTypes["ShiftsManager"],
		__typename?: boolean | `@${string}`
}>;
	["ShiftsProfileQueueItemsByQueueUniqueWhere"]: {
	queue?: ValueTypes["EmployeeQueueUniqueWhere"] | undefined | null
};
	["ShiftsProfileQueueItemsByShiftUniqueWhere"]: {
	shift?: ValueTypes["TimetableShiftUniqueWhere"] | undefined | null
};
	["ShiftsProfileQueueItemsByUnassignInfoUniqueWhere"]: {
	unassignInfo?: ValueTypes["UnassignedShiftInfoUniqueWhere"] | undefined | null
};
	["ShiftsProfileQueueItemsByMetaUniqueWhere"]: {
	meta?: ValueTypes["EmployeeQueueItemMetadataUniqueWhere"] | undefined | null
};
	["ShiftsProfileShiftsByQueueItemUniqueWhere"]: {
	queueItem?: ValueTypes["EmployeeQueueItemUniqueWhere"] | undefined | null
};
	["ShiftsProfileShiftsBySwapInfoUniqueWhere"]: {
	swapInfo?: ValueTypes["TimetableShiftSwapInfoUniqueWhere"] | undefined | null
};
	["TimetableShiftConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TimetableShiftEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableShiftEdge"]: AliasType<{
	node?:ValueTypes["TimetableShift"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableShiftSwapInfo"]: AliasType<{
	_meta?:ValueTypes["TimetableShiftSwapInfoMeta"],
	id?:boolean | `@${string}`,
	assigned?:boolean | `@${string}`,
	requested?:boolean | `@${string}`,
	confirmed?:boolean | `@${string}`,
swappedShiftsProfile?: [{	filter?: ValueTypes["ShiftsProfileWhere"] | undefined | null},ValueTypes["ShiftsProfile"]],
shift?: [{	filter?: ValueTypes["TimetableShiftWhere"] | undefined | null},ValueTypes["TimetableShift"]],
		__typename?: boolean | `@${string}`
}>;
	["TimetableShiftSwapInfoMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	assigned?:ValueTypes["FieldMeta"],
	requested?:ValueTypes["FieldMeta"],
	confirmed?:ValueTypes["FieldMeta"],
	swappedShiftsProfile?:ValueTypes["FieldMeta"],
	shift?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableShiftGroupShiftsByQueueItemUniqueWhere"]: {
	queueItem?: ValueTypes["EmployeeQueueItemUniqueWhere"] | undefined | null
};
	["TimetableShiftGroupShiftsBySwapInfoUniqueWhere"]: {
	swapInfo?: ValueTypes["TimetableShiftSwapInfoUniqueWhere"] | undefined | null
};
	["TimetableDayNote"]: AliasType<{
	_meta?:ValueTypes["TimetableDayNoteMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	note?:boolean | `@${string}`,
day?: [{	filter?: ValueTypes["TimetableDayWhere"] | undefined | null},ValueTypes["TimetableDay"]],
role?: [{	filter?: ValueTypes["TimetableEmployeeRoleWhere"] | undefined | null},ValueTypes["TimetableEmployeeRole"]],
		__typename?: boolean | `@${string}`
}>;
	["TimetableDayNoteMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	note?:ValueTypes["FieldMeta"],
	day?:ValueTypes["FieldMeta"],
	role?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableDayNoteOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null,
	note?: ValueTypes["OrderDirection"] | undefined | null,
	day?: ValueTypes["TimetableDayOrderBy"] | undefined | null,
	role?: ValueTypes["TimetableEmployeeRoleOrderBy"] | undefined | null
};
	["TimetableDayMetadata"]: AliasType<{
	_meta?:ValueTypes["TimetableDayMetadataMeta"],
	id?:boolean | `@${string}`,
	numberOfWorkers?:boolean | `@${string}`,
	tipsTotalCents?:boolean | `@${string}`,
	totalMinutes?:boolean | `@${string}`,
	tipsCentsPerMinute?:boolean | `@${string}`,
day?: [{	filter?: ValueTypes["TimetableDayWhere"] | undefined | null},ValueTypes["TimetableDay"]],
		__typename?: boolean | `@${string}`
}>;
	["TimetableDayMetadataMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	numberOfWorkers?:ValueTypes["FieldMeta"],
	tipsTotalCents?:ValueTypes["FieldMeta"],
	totalMinutes?:ValueTypes["FieldMeta"],
	tipsCentsPerMinute?:ValueTypes["FieldMeta"],
	day?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableDayShiftGroupsByShiftsUniqueWhere"]: {
	shifts?: ValueTypes["TimetableShiftUniqueWhere"] | undefined | null
};
	["TimetableDayShiftGroupsByQueueUniqueWhere"]: {
	queue?: ValueTypes["EmployeeQueueUniqueWhere"] | undefined | null
};
	["TimetableDayNoteConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TimetableDayNoteEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableDayNoteEdge"]: AliasType<{
	node?:ValueTypes["TimetableDayNote"],
		__typename?: boolean | `@${string}`
}>;
	["VenueEmployeeRole"]: AliasType<{
	_meta?:ValueTypes["VenueEmployeeRoleMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
employeePrivileges?: [{	filter?: ValueTypes["TimetablesEmployeePrivilegesWhere"] | undefined | null},ValueTypes["TimetablesEmployeePrivileges"]],
venue?: [{	filter?: ValueTypes["VenueWhere"] | undefined | null},ValueTypes["Venue"]],
role?: [{	filter?: ValueTypes["TimetableEmployeeRoleWhere"] | undefined | null},ValueTypes["TimetableEmployeeRole"]],
	getsTipsShare?:boolean | `@${string}`,
	notesEnabled?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["VenueEmployeeRoleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	employeePrivileges?:ValueTypes["FieldMeta"],
	venue?:ValueTypes["FieldMeta"],
	role?:ValueTypes["FieldMeta"],
	getsTipsShare?:ValueTypes["FieldMeta"],
	notesEnabled?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TimetablesEmployeePrivileges"]: AliasType<{
	_meta?:ValueTypes["TimetablesEmployeePrivilegesMeta"],
	id?:boolean | `@${string}`,
venueEmployeeRole?: [{	filter?: ValueTypes["VenueEmployeeRoleWhere"] | undefined | null},ValueTypes["VenueEmployeeRole"]],
	read?:boolean | `@${string}`,
	unassign?:boolean | `@${string}`,
	assign?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["TimetablesEmployeePrivilegesMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	venueEmployeeRole?:ValueTypes["FieldMeta"],
	read?:ValueTypes["FieldMeta"],
	unassign?:ValueTypes["FieldMeta"],
	assign?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["VenueEmployeeRoleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null,
	employeePrivileges?: ValueTypes["TimetablesEmployeePrivilegesOrderBy"] | undefined | null,
	venue?: ValueTypes["VenueOrderBy"] | undefined | null,
	role?: ValueTypes["TimetableEmployeeRoleOrderBy"] | undefined | null,
	getsTipsShare?: ValueTypes["OrderDirection"] | undefined | null,
	notesEnabled?: ValueTypes["OrderDirection"] | undefined | null
};
	["TimetablesEmployeePrivilegesOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	venueEmployeeRole?: ValueTypes["VenueEmployeeRoleOrderBy"] | undefined | null,
	read?: ValueTypes["OrderDirection"] | undefined | null,
	unassign?: ValueTypes["OrderDirection"] | undefined | null,
	assign?: ValueTypes["OrderDirection"] | undefined | null
};
	["PointOfSaleApplicationDevice"]: AliasType<{
	_meta?:ValueTypes["PointOfSaleApplicationDeviceMeta"],
	id?:boolean | `@${string}`,
	internalName?:boolean | `@${string}`,
	note?:boolean | `@${string}`,
venue?: [{	filter?: ValueTypes["VenueWhere"] | undefined | null},ValueTypes["Venue"]],
identificationCode?: [{	filter?: ValueTypes["IdentificationCodeWhere"] | undefined | null},ValueTypes["IdentificationCode"]],
identifier?: [{	filter?: ValueTypes["DeviceIdentifierWhere"] | undefined | null},ValueTypes["DeviceIdentifier"]],
terminal?: [{	filter?: ValueTypes["PointOfSaleTerminalWhere"] | undefined | null},ValueTypes["PointOfSaleTerminal"]],
receiptPrinter?: [{	filter?: ValueTypes["PointOfSalePrinterWhere"] | undefined | null},ValueTypes["PointOfSalePrinter"]],
ticketPrinters?: [{	filter?: ValueTypes["PointOfSalePrinterWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSalePrinterOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PointOfSalePrinter"]],
paginateTicketPrinters?: [{	filter?: ValueTypes["PointOfSalePrinterWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSalePrinterOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PointOfSalePrinterConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleApplicationDeviceMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	internalName?:ValueTypes["FieldMeta"],
	note?:ValueTypes["FieldMeta"],
	venue?:ValueTypes["FieldMeta"],
	identificationCode?:ValueTypes["FieldMeta"],
	identifier?:ValueTypes["FieldMeta"],
	terminal?:ValueTypes["FieldMeta"],
	receiptPrinter?:ValueTypes["FieldMeta"],
	ticketPrinters?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["IdentificationCode"]: AliasType<{
	_meta?:ValueTypes["IdentificationCodeMeta"],
	id?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
attempts?: [{	filter?: ValueTypes["IdentificationAttemptWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IdentificationAttemptOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["IdentificationAttempt"]],
locales?: [{	filter?: ValueTypes["IdentificationCodeLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IdentificationCodeLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["IdentificationCodeLocale"]],
	internalName?:boolean | `@${string}`,
applicationDevices?: [{	filter?: ValueTypes["PointOfSaleApplicationDeviceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleApplicationDeviceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PointOfSaleApplicationDevice"]],
localesByLocale?: [{	by: ValueTypes["IdentificationCodeLocalesByLocaleUniqueWhere"],	filter?: ValueTypes["IdentificationCodeLocaleWhere"] | undefined | null},ValueTypes["IdentificationCodeLocale"]],
applicationDevicesByIdentifier?: [{	by: ValueTypes["IdentificationCodeApplicationDevicesByIdentifierUniqueWhere"],	filter?: ValueTypes["PointOfSaleApplicationDeviceWhere"] | undefined | null},ValueTypes["PointOfSaleApplicationDevice"]],
paginateAttempts?: [{	filter?: ValueTypes["IdentificationAttemptWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IdentificationAttemptOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["IdentificationAttemptConnection"]],
paginateLocales?: [{	filter?: ValueTypes["IdentificationCodeLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IdentificationCodeLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["IdentificationCodeLocaleConnection"]],
paginateApplicationDevices?: [{	filter?: ValueTypes["PointOfSaleApplicationDeviceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleApplicationDeviceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PointOfSaleApplicationDeviceConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["IdentificationCodeMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	code?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	attempts?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	internalName?:ValueTypes["FieldMeta"],
	applicationDevices?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["IdentificationAttempt"]: AliasType<{
	_meta?:ValueTypes["IdentificationAttemptMeta"],
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
code?: [{	filter?: ValueTypes["IdentificationCodeWhere"] | undefined | null},ValueTypes["IdentificationCode"]],
user?: [{	filter?: ValueTypes["UserWhere"] | undefined | null},ValueTypes["User"]],
		__typename?: boolean | `@${string}`
}>;
	["IdentificationAttemptMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	code?:ValueTypes["FieldMeta"],
	user?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["User"]: AliasType<{
	_meta?:ValueTypes["UserMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	internalNote?:boolean | `@${string}`,
staff?: [{	filter?: ValueTypes["StaffWhere"] | undefined | null},ValueTypes["Staff"]],
customer?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
	tenantPersonId?:boolean | `@${string}`,
	disabledAt?:boolean | `@${string}`,
devices?: [{	filter?: ValueTypes["UserDeviceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["UserDeviceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["UserDevice"]],
	verifiedAt?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	deletionRequestedAt?:boolean | `@${string}`,
	deletionExpectedAt?:boolean | `@${string}`,
	deletedAt?:boolean | `@${string}`,
meta?: [{	filter?: ValueTypes["UserMetadataWhere"] | undefined | null},ValueTypes["UserMetadata"]],
identificationAttempts?: [{	filter?: ValueTypes["IdentificationAttemptWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IdentificationAttemptOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["IdentificationAttempt"]],
roles?: [{	filter?: ValueTypes["UserRolesWhere"] | undefined | null},ValueTypes["UserRoles"]],
devicesByDeviceId?: [{	by: ValueTypes["UserDevicesByDeviceIdUniqueWhere"],	filter?: ValueTypes["UserDeviceWhere"] | undefined | null},ValueTypes["UserDevice"]],
paginateDevices?: [{	filter?: ValueTypes["UserDeviceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["UserDeviceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["UserDeviceConnection"]],
paginateIdentificationAttempts?: [{	filter?: ValueTypes["IdentificationAttemptWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IdentificationAttemptOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["IdentificationAttemptConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["UserMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	internalNote?:ValueTypes["FieldMeta"],
	staff?:ValueTypes["FieldMeta"],
	customer?:ValueTypes["FieldMeta"],
	tenantPersonId?:ValueTypes["FieldMeta"],
	disabledAt?:ValueTypes["FieldMeta"],
	devices?:ValueTypes["FieldMeta"],
	verifiedAt?:ValueTypes["FieldMeta"],
	email?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	deletionRequestedAt?:ValueTypes["FieldMeta"],
	deletionExpectedAt?:ValueTypes["FieldMeta"],
	deletedAt?:ValueTypes["FieldMeta"],
	meta?:ValueTypes["FieldMeta"],
	identificationAttempts?:ValueTypes["FieldMeta"],
	roles?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["UserDevice"]: AliasType<{
	_meta?:ValueTypes["UserDeviceMeta"],
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	lastActiveAt?:boolean | `@${string}`,
	platform?:boolean | `@${string}`,
	deviceId?:boolean | `@${string}`,
	notificationsEnabled?:boolean | `@${string}`,
user?: [{	filter?: ValueTypes["UserWhere"] | undefined | null},ValueTypes["User"]],
	appVersion?:boolean | `@${string}`,
	osVersion?:boolean | `@${string}`,
	apiVersion?:boolean | `@${string}`,
anonymousSession?: [{	filter?: ValueTypes["AnonymousSessionWhere"] | undefined | null},ValueTypes["AnonymousSession"]],
		__typename?: boolean | `@${string}`
}>;
	["UserDeviceMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	lastActiveAt?:ValueTypes["FieldMeta"],
	platform?:ValueTypes["FieldMeta"],
	deviceId?:ValueTypes["FieldMeta"],
	notificationsEnabled?:ValueTypes["FieldMeta"],
	user?:ValueTypes["FieldMeta"],
	appVersion?:ValueTypes["FieldMeta"],
	osVersion?:ValueTypes["FieldMeta"],
	apiVersion?:ValueTypes["FieldMeta"],
	anonymousSession?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["AnonymousSession"]: AliasType<{
	_meta?:ValueTypes["AnonymousSessionMeta"],
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	lastActiveAt?:boolean | `@${string}`,
	anonymousSessionKey?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	internalNote?:boolean | `@${string}`,
customer?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
devices?: [{	filter?: ValueTypes["UserDeviceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["UserDeviceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["UserDevice"]],
devicesByDeviceId?: [{	by: ValueTypes["AnonymousSessionDevicesByDeviceIdUniqueWhere"],	filter?: ValueTypes["UserDeviceWhere"] | undefined | null},ValueTypes["UserDevice"]],
paginateDevices?: [{	filter?: ValueTypes["UserDeviceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["UserDeviceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["UserDeviceConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["AnonymousSessionMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	lastActiveAt?:ValueTypes["FieldMeta"],
	anonymousSessionKey?:ValueTypes["FieldMeta"],
	email?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	internalNote?:ValueTypes["FieldMeta"],
	customer?:ValueTypes["FieldMeta"],
	devices?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["UserDeviceOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null,
	lastActiveAt?: ValueTypes["OrderDirection"] | undefined | null,
	platform?: ValueTypes["OrderDirection"] | undefined | null,
	deviceId?: ValueTypes["OrderDirection"] | undefined | null,
	notificationsEnabled?: ValueTypes["OrderDirection"] | undefined | null,
	user?: ValueTypes["UserOrderBy"] | undefined | null,
	appVersion?: ValueTypes["OrderDirection"] | undefined | null,
	osVersion?: ValueTypes["OrderDirection"] | undefined | null,
	apiVersion?: ValueTypes["OrderDirection"] | undefined | null,
	anonymousSession?: ValueTypes["AnonymousSessionOrderBy"] | undefined | null
};
	["AnonymousSessionDevicesByDeviceIdUniqueWhere"]: {
	deviceId?: string | undefined | null
};
	["UserDeviceConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["UserDeviceEdge"],
		__typename?: boolean | `@${string}`
}>;
	["UserDeviceEdge"]: AliasType<{
	node?:ValueTypes["UserDevice"],
		__typename?: boolean | `@${string}`
}>;
	["UserMetadata"]: AliasType<{
	_meta?:ValueTypes["UserMetadataMeta"],
	id?:boolean | `@${string}`,
	userProfileUrl?:boolean | `@${string}`,
	tenantEmail?:boolean | `@${string}`,
	tenantPersonId?:boolean | `@${string}`,
	tenantIdentityId?:boolean | `@${string}`,
	globalRoles?:boolean | `@${string}`,
	projectRoles?:boolean | `@${string}`,
	projectRolesString?:boolean | `@${string}`,
	externalIdentifiers?:boolean | `@${string}`,
	externalIdentifiersString?:boolean | `@${string}`,
	idpSlugs?:boolean | `@${string}`,
	idpSlugsString?:boolean | `@${string}`,
user?: [{	filter?: ValueTypes["UserWhere"] | undefined | null},ValueTypes["User"]],
		__typename?: boolean | `@${string}`
}>;
	["UserMetadataMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	userProfileUrl?:ValueTypes["FieldMeta"],
	tenantEmail?:ValueTypes["FieldMeta"],
	tenantPersonId?:ValueTypes["FieldMeta"],
	tenantIdentityId?:ValueTypes["FieldMeta"],
	globalRoles?:ValueTypes["FieldMeta"],
	projectRoles?:ValueTypes["FieldMeta"],
	projectRolesString?:ValueTypes["FieldMeta"],
	externalIdentifiers?:ValueTypes["FieldMeta"],
	externalIdentifiersString?:ValueTypes["FieldMeta"],
	idpSlugs?:ValueTypes["FieldMeta"],
	idpSlugsString?:ValueTypes["FieldMeta"],
	user?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["IdentificationAttemptOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null,
	code?: ValueTypes["IdentificationCodeOrderBy"] | undefined | null,
	user?: ValueTypes["UserOrderBy"] | undefined | null
};
	["IdentificationCodeOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	code?: ValueTypes["OrderDirection"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null,
	internalName?: ValueTypes["OrderDirection"] | undefined | null
};
	["UserRoles"]: AliasType<{
	_meta?:ValueTypes["UserRolesMeta"],
	id?:boolean | `@${string}`,
	isCustomer?:boolean | `@${string}`,
	isStaff?:boolean | `@${string}`,
	isBartender?:boolean | `@${string}`,
	isCashier?:boolean | `@${string}`,
	isCourier?:boolean | `@${string}`,
	isCleaner?:boolean | `@${string}`,
	isShiftsManager?:boolean | `@${string}`,
	isInternalBuyer?:boolean | `@${string}`,
	isStocksManager?:boolean | `@${string}`,
	isCourierManager?:boolean | `@${string}`,
	isCashierManager?:boolean | `@${string}`,
	isBusinessToBusinessManager?:boolean | `@${string}`,
	isPicker?:boolean | `@${string}`,
user?: [{	filter?: ValueTypes["UserWhere"] | undefined | null},ValueTypes["User"]],
		__typename?: boolean | `@${string}`
}>;
	["UserRolesMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	isCustomer?:ValueTypes["FieldMeta"],
	isStaff?:ValueTypes["FieldMeta"],
	isBartender?:ValueTypes["FieldMeta"],
	isCashier?:ValueTypes["FieldMeta"],
	isCourier?:ValueTypes["FieldMeta"],
	isCleaner?:ValueTypes["FieldMeta"],
	isShiftsManager?:ValueTypes["FieldMeta"],
	isInternalBuyer?:ValueTypes["FieldMeta"],
	isStocksManager?:ValueTypes["FieldMeta"],
	isCourierManager?:ValueTypes["FieldMeta"],
	isCashierManager?:ValueTypes["FieldMeta"],
	isBusinessToBusinessManager?:ValueTypes["FieldMeta"],
	isPicker?:ValueTypes["FieldMeta"],
	user?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["UserDevicesByDeviceIdUniqueWhere"]: {
	deviceId?: string | undefined | null
};
	["IdentificationAttemptConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["IdentificationAttemptEdge"],
		__typename?: boolean | `@${string}`
}>;
	["IdentificationAttemptEdge"]: AliasType<{
	node?:ValueTypes["IdentificationAttempt"],
		__typename?: boolean | `@${string}`
}>;
	["IdentificationCodeLocale"]: AliasType<{
	_meta?:ValueTypes["IdentificationCodeLocaleMeta"],
	id?:boolean | `@${string}`,
	successMessage?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["IdentificationCodeWhere"] | undefined | null},ValueTypes["IdentificationCode"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null},ValueTypes["Locale"]],
		__typename?: boolean | `@${string}`
}>;
	["IdentificationCodeLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	successMessage?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["IdentificationCodeLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	successMessage?: ValueTypes["OrderDirection"] | undefined | null,
	root?: ValueTypes["IdentificationCodeOrderBy"] | undefined | null,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null
};
	["PointOfSaleApplicationDeviceOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	internalName?: ValueTypes["OrderDirection"] | undefined | null,
	note?: ValueTypes["OrderDirection"] | undefined | null,
	venue?: ValueTypes["VenueOrderBy"] | undefined | null,
	identificationCode?: ValueTypes["IdentificationCodeOrderBy"] | undefined | null,
	identifier?: ValueTypes["DeviceIdentifierOrderBy"] | undefined | null,
	terminal?: ValueTypes["PointOfSaleTerminalOrderBy"] | undefined | null,
	receiptPrinter?: ValueTypes["PointOfSalePrinterOrderBy"] | undefined | null
};
	["DeviceIdentifierOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	internalName?: ValueTypes["OrderDirection"] | undefined | null,
	device?: ValueTypes["PointOfSaleApplicationDeviceOrderBy"] | undefined | null,
	updatedAt?: ValueTypes["OrderDirection"] | undefined | null,
	platform?: ValueTypes["OrderDirection"] | undefined | null,
	resolution?: ValueTypes["OrderDirection"] | undefined | null,
	devicePixelRatio?: ValueTypes["OrderDirection"] | undefined | null,
	updatedByUser?: ValueTypes["UserOrderBy"] | undefined | null,
	identifier?: ValueTypes["OrderDirection"] | undefined | null,
	meta?: ValueTypes["DeviceIdentifierMetadataOrderBy"] | undefined | null,
	applicationVersionIdentifier?: ValueTypes["OrderDirection"] | undefined | null,
	lastPointOfSaleSynchronizationErrorRawDetails?: ValueTypes["OrderDirection"] | undefined | null
};
	["DeviceIdentifierMetadataOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	prettyIdentifier?: ValueTypes["OrderDirection"] | undefined | null,
	deviceIdentifier?: ValueTypes["DeviceIdentifierOrderBy"] | undefined | null
};
	["PointOfSaleTerminalOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	internalName?: ValueTypes["OrderDirection"] | undefined | null,
	note?: ValueTypes["OrderDirection"] | undefined | null,
	venue?: ValueTypes["VenueOrderBy"] | undefined | null,
	ipAddress?: ValueTypes["OrderDirection"] | undefined | null,
	port?: ValueTypes["OrderDirection"] | undefined | null,
	type?: ValueTypes["OrderDirection"] | undefined | null
};
	["PointOfSalePrinterOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	internalName?: ValueTypes["OrderDirection"] | undefined | null,
	note?: ValueTypes["OrderDirection"] | undefined | null,
	ipAddress?: ValueTypes["OrderDirection"] | undefined | null,
	venue?: ValueTypes["VenueOrderBy"] | undefined | null
};
	["IdentificationCodeLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null
};
	["IdentificationCodeApplicationDevicesByIdentifierUniqueWhere"]: {
	identifier?: ValueTypes["DeviceIdentifierUniqueWhere"] | undefined | null
};
	["IdentificationCodeLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["IdentificationCodeLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["IdentificationCodeLocaleEdge"]: AliasType<{
	node?:ValueTypes["IdentificationCodeLocale"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleApplicationDeviceConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PointOfSaleApplicationDeviceEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleApplicationDeviceEdge"]: AliasType<{
	node?:ValueTypes["PointOfSaleApplicationDevice"],
		__typename?: boolean | `@${string}`
}>;
	["DeviceIdentifier"]: AliasType<{
	_meta?:ValueTypes["DeviceIdentifierMeta"],
	id?:boolean | `@${string}`,
	internalName?:boolean | `@${string}`,
device?: [{	filter?: ValueTypes["PointOfSaleApplicationDeviceWhere"] | undefined | null},ValueTypes["PointOfSaleApplicationDevice"]],
	updatedAt?:boolean | `@${string}`,
	platform?:boolean | `@${string}`,
	resolution?:boolean | `@${string}`,
	devicePixelRatio?:boolean | `@${string}`,
updatedByUser?: [{	filter?: ValueTypes["UserWhere"] | undefined | null},ValueTypes["User"]],
	identifier?:boolean | `@${string}`,
meta?: [{	filter?: ValueTypes["DeviceIdentifierMetadataWhere"] | undefined | null},ValueTypes["DeviceIdentifierMetadata"]],
	applicationVersionIdentifier?:boolean | `@${string}`,
	lastPointOfSaleSynchronizationErrorRawDetails?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["DeviceIdentifierMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	internalName?:ValueTypes["FieldMeta"],
	device?:ValueTypes["FieldMeta"],
	updatedAt?:ValueTypes["FieldMeta"],
	platform?:ValueTypes["FieldMeta"],
	resolution?:ValueTypes["FieldMeta"],
	devicePixelRatio?:ValueTypes["FieldMeta"],
	updatedByUser?:ValueTypes["FieldMeta"],
	identifier?:ValueTypes["FieldMeta"],
	meta?:ValueTypes["FieldMeta"],
	applicationVersionIdentifier?:ValueTypes["FieldMeta"],
	lastPointOfSaleSynchronizationErrorRawDetails?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["DeviceIdentifierMetadata"]: AliasType<{
	_meta?:ValueTypes["DeviceIdentifierMetadataMeta"],
	id?:boolean | `@${string}`,
	prettyIdentifier?:boolean | `@${string}`,
deviceIdentifier?: [{	filter?: ValueTypes["DeviceIdentifierWhere"] | undefined | null},ValueTypes["DeviceIdentifier"]],
		__typename?: boolean | `@${string}`
}>;
	["DeviceIdentifierMetadataMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	prettyIdentifier?:ValueTypes["FieldMeta"],
	deviceIdentifier?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleTerminal"]: AliasType<{
	_meta?:ValueTypes["PointOfSaleTerminalMeta"],
	id?:boolean | `@${string}`,
	internalName?:boolean | `@${string}`,
	note?:boolean | `@${string}`,
venue?: [{	filter?: ValueTypes["VenueWhere"] | undefined | null},ValueTypes["Venue"]],
applicationDevices?: [{	filter?: ValueTypes["PointOfSaleApplicationDeviceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleApplicationDeviceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PointOfSaleApplicationDevice"]],
	ipAddress?:boolean | `@${string}`,
	port?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
applicationDevicesByIdentifier?: [{	by: ValueTypes["PointOfSaleTerminalApplicationDevicesByIdentifierUniqueWhere"],	filter?: ValueTypes["PointOfSaleApplicationDeviceWhere"] | undefined | null},ValueTypes["PointOfSaleApplicationDevice"]],
paginateApplicationDevices?: [{	filter?: ValueTypes["PointOfSaleApplicationDeviceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleApplicationDeviceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PointOfSaleApplicationDeviceConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleTerminalMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	internalName?:ValueTypes["FieldMeta"],
	note?:ValueTypes["FieldMeta"],
	venue?:ValueTypes["FieldMeta"],
	applicationDevices?:ValueTypes["FieldMeta"],
	ipAddress?:ValueTypes["FieldMeta"],
	port?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleTerminalApplicationDevicesByIdentifierUniqueWhere"]: {
	identifier?: ValueTypes["DeviceIdentifierUniqueWhere"] | undefined | null
};
	["PointOfSalePrinter"]: AliasType<{
	_meta?:ValueTypes["PointOfSalePrinterMeta"],
	id?:boolean | `@${string}`,
	internalName?:boolean | `@${string}`,
	note?:boolean | `@${string}`,
	ipAddress?:boolean | `@${string}`,
applicationDevicesReceipt?: [{	filter?: ValueTypes["PointOfSaleApplicationDeviceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleApplicationDeviceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PointOfSaleApplicationDevice"]],
applicationDevicesTicket?: [{	filter?: ValueTypes["PointOfSaleApplicationDeviceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleApplicationDeviceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PointOfSaleApplicationDevice"]],
venue?: [{	filter?: ValueTypes["VenueWhere"] | undefined | null},ValueTypes["Venue"]],
ticketCategories?: [{	filter?: ValueTypes["PointOfSaleCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleCategoryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PointOfSaleCategory"]],
applicationDevicesReceiptByIdentifier?: [{	by: ValueTypes["PointOfSalePrinterApplicationDevicesReceiptByIdentifierUniqueWhere"],	filter?: ValueTypes["PointOfSaleApplicationDeviceWhere"] | undefined | null},ValueTypes["PointOfSaleApplicationDevice"]],
paginateApplicationDevicesReceipt?: [{	filter?: ValueTypes["PointOfSaleApplicationDeviceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleApplicationDeviceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PointOfSaleApplicationDeviceConnection"]],
paginateApplicationDevicesTicket?: [{	filter?: ValueTypes["PointOfSaleApplicationDeviceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleApplicationDeviceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PointOfSaleApplicationDeviceConnection"]],
paginateTicketCategories?: [{	filter?: ValueTypes["PointOfSaleCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleCategoryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PointOfSaleCategoryConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSalePrinterMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	internalName?:ValueTypes["FieldMeta"],
	note?:ValueTypes["FieldMeta"],
	ipAddress?:ValueTypes["FieldMeta"],
	applicationDevicesReceipt?:ValueTypes["FieldMeta"],
	applicationDevicesTicket?:ValueTypes["FieldMeta"],
	venue?:ValueTypes["FieldMeta"],
	ticketCategories?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleCategory"]: AliasType<{
	_meta?:ValueTypes["PointOfSaleCategoryMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	slug?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["PointOfSaleCategoryLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleCategoryLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PointOfSaleCategoryLocale"]],
products?: [{	filter?: ValueTypes["PointOfSaleCategoryProductWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleCategoryProductOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PointOfSaleCategoryProduct"]],
category?: [{	filter?: ValueTypes["ProductCategoryWhere"] | undefined | null},ValueTypes["ProductCategory"]],
venue?: [{	filter?: ValueTypes["VenueWhere"] | undefined | null},ValueTypes["Venue"]],
ticketPrinters?: [{	filter?: ValueTypes["PointOfSalePrinterWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSalePrinterOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PointOfSalePrinter"]],
localesByLocale?: [{	by: ValueTypes["PointOfSaleCategoryLocalesByLocaleUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryLocaleWhere"] | undefined | null},ValueTypes["PointOfSaleCategoryLocale"]],
productsByLocales?: [{	by: ValueTypes["PointOfSaleCategoryProductsByLocalesUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryProductWhere"] | undefined | null},ValueTypes["PointOfSaleCategoryProduct"]],
paginateLocales?: [{	filter?: ValueTypes["PointOfSaleCategoryLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleCategoryLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PointOfSaleCategoryLocaleConnection"]],
paginateProducts?: [{	filter?: ValueTypes["PointOfSaleCategoryProductWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleCategoryProductOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PointOfSaleCategoryProductConnection"]],
paginateTicketPrinters?: [{	filter?: ValueTypes["PointOfSalePrinterWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSalePrinterOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PointOfSalePrinterConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleCategoryMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	slug?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	products?:ValueTypes["FieldMeta"],
	category?:ValueTypes["FieldMeta"],
	venue?:ValueTypes["FieldMeta"],
	ticketPrinters?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleCategoryLocale"]: AliasType<{
	_meta?:ValueTypes["PointOfSaleCategoryLocaleMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["PointOfSaleCategoryWhere"] | undefined | null},ValueTypes["PointOfSaleCategory"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null},ValueTypes["Locale"]],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleCategoryLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleCategoryLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	title?: ValueTypes["OrderDirection"] | undefined | null,
	root?: ValueTypes["PointOfSaleCategoryOrderBy"] | undefined | null,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null
};
	["PointOfSaleCategoryOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null,
	slug?: ValueTypes["OrderDirection"] | undefined | null,
	category?: ValueTypes["ProductCategoryOrderBy"] | undefined | null,
	venue?: ValueTypes["VenueOrderBy"] | undefined | null
};
	["ProductCategoryOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	code?: ValueTypes["OrderDirection"] | undefined | null,
	parent?: ValueTypes["ProductCategoryOrderBy"] | undefined | null,
	description?: ValueTypes["OrderDirection"] | undefined | null,
	internalNote?: ValueTypes["OrderDirection"] | undefined | null,
	color?: ValueTypes["OrderDirection"] | undefined | null,
	image?: ValueTypes["ImageOrderBy"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null
};
	["PointOfSaleCategoryProduct"]: AliasType<{
	_meta?:ValueTypes["PointOfSaleCategoryProductMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
category?: [{	filter?: ValueTypes["PointOfSaleCategoryWhere"] | undefined | null},ValueTypes["PointOfSaleCategory"]],
product?: [{	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
locales?: [{	filter?: ValueTypes["PointOfSaleCategoryProductLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleCategoryProductLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PointOfSaleCategoryProductLocale"]],
localesByLocale?: [{	by: ValueTypes["PointOfSaleCategoryProductLocalesByLocaleUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryProductLocaleWhere"] | undefined | null},ValueTypes["PointOfSaleCategoryProductLocale"]],
paginateLocales?: [{	filter?: ValueTypes["PointOfSaleCategoryProductLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleCategoryProductLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PointOfSaleCategoryProductLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleCategoryProductMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	category?:ValueTypes["FieldMeta"],
	product?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleCategoryProductLocale"]: AliasType<{
	_meta?:ValueTypes["PointOfSaleCategoryProductLocaleMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["PointOfSaleCategoryProductWhere"] | undefined | null},ValueTypes["PointOfSaleCategoryProduct"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null},ValueTypes["Locale"]],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleCategoryProductLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleCategoryProductLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	title?: ValueTypes["OrderDirection"] | undefined | null,
	root?: ValueTypes["PointOfSaleCategoryProductOrderBy"] | undefined | null,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null
};
	["PointOfSaleCategoryProductOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null,
	category?: ValueTypes["PointOfSaleCategoryOrderBy"] | undefined | null,
	product?: ValueTypes["ProductOrderBy"] | undefined | null
};
	["PointOfSaleCategoryProductLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null
};
	["PointOfSaleCategoryProductLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PointOfSaleCategoryProductLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleCategoryProductLocaleEdge"]: AliasType<{
	node?:ValueTypes["PointOfSaleCategoryProductLocale"],
		__typename?: boolean | `@${string}`
}>;
	["ProductCategory"]: AliasType<{
	_meta?:ValueTypes["ProductCategoryMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
products?: [{	filter?: ValueTypes["ProductWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Product"]],
tags?: [{	filter?: ValueTypes["TagWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TagOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Tag"]],
parent?: [{	filter?: ValueTypes["ProductCategoryWhere"] | undefined | null},ValueTypes["ProductCategory"]],
children?: [{	filter?: ValueTypes["ProductCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCategoryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductCategory"]],
	description?:boolean | `@${string}`,
	internalNote?:boolean | `@${string}`,
	color?:boolean | `@${string}`,
image?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null},ValueTypes["Image"]],
	order?:boolean | `@${string}`,
descendants?: [{	filter?: ValueTypes["ProductCategoryTreeWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCategoryTreeOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductCategoryTree"]],
ancestors?: [{	filter?: ValueTypes["ProductCategoryTreeWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCategoryTreeOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductCategoryTree"]],
inheritedTags?: [{	filter?: ValueTypes["InheritedProductCategoryTagWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InheritedProductCategoryTagOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["InheritedProductCategoryTag"]],
nestedProducts?: [{	filter?: ValueTypes["NestedProductCategoryProductWhere"] | undefined | null,	orderBy?: Array<ValueTypes["NestedProductCategoryProductOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["NestedProductCategoryProduct"]],
childrenByCode?: [{	by: ValueTypes["ProductCategoryChildrenByCodeUniqueWhere"],	filter?: ValueTypes["ProductCategoryWhere"] | undefined | null},ValueTypes["ProductCategory"]],
childrenByChildren?: [{	by: ValueTypes["ProductCategoryChildrenByChildrenUniqueWhere"],	filter?: ValueTypes["ProductCategoryWhere"] | undefined | null},ValueTypes["ProductCategory"]],
childrenByDescendants?: [{	by: ValueTypes["ProductCategoryChildrenByDescendantsUniqueWhere"],	filter?: ValueTypes["ProductCategoryWhere"] | undefined | null},ValueTypes["ProductCategory"]],
childrenByAncestors?: [{	by: ValueTypes["ProductCategoryChildrenByAncestorsUniqueWhere"],	filter?: ValueTypes["ProductCategoryWhere"] | undefined | null},ValueTypes["ProductCategory"]],
childrenByInheritedTags?: [{	by: ValueTypes["ProductCategoryChildrenByInheritedTagsUniqueWhere"],	filter?: ValueTypes["ProductCategoryWhere"] | undefined | null},ValueTypes["ProductCategory"]],
childrenByNestedProducts?: [{	by: ValueTypes["ProductCategoryChildrenByNestedProductsUniqueWhere"],	filter?: ValueTypes["ProductCategoryWhere"] | undefined | null},ValueTypes["ProductCategory"]],
paginateProducts?: [{	filter?: ValueTypes["ProductWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductConnection"]],
paginateTags?: [{	filter?: ValueTypes["TagWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TagOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TagConnection"]],
paginateChildren?: [{	filter?: ValueTypes["ProductCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCategoryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductCategoryConnection"]],
paginateDescendants?: [{	filter?: ValueTypes["ProductCategoryTreeWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCategoryTreeOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductCategoryTreeConnection"]],
paginateAncestors?: [{	filter?: ValueTypes["ProductCategoryTreeWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCategoryTreeOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductCategoryTreeConnection"]],
paginateInheritedTags?: [{	filter?: ValueTypes["InheritedProductCategoryTagWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InheritedProductCategoryTagOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["InheritedProductCategoryTagConnection"]],
paginateNestedProducts?: [{	filter?: ValueTypes["NestedProductCategoryProductWhere"] | undefined | null,	orderBy?: Array<ValueTypes["NestedProductCategoryProductOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["NestedProductCategoryProductConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ProductCategoryMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	code?:ValueTypes["FieldMeta"],
	products?:ValueTypes["FieldMeta"],
	tags?:ValueTypes["FieldMeta"],
	parent?:ValueTypes["FieldMeta"],
	children?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
	internalNote?:ValueTypes["FieldMeta"],
	color?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	descendants?:ValueTypes["FieldMeta"],
	ancestors?:ValueTypes["FieldMeta"],
	inheritedTags?:ValueTypes["FieldMeta"],
	nestedProducts?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProductCategoryTree"]: AliasType<{
	_meta?:ValueTypes["ProductCategoryTreeMeta"],
	id?:boolean | `@${string}`,
	depth?:boolean | `@${string}`,
ancestor?: [{	filter?: ValueTypes["ProductCategoryWhere"] | undefined | null},ValueTypes["ProductCategory"]],
descendant?: [{	filter?: ValueTypes["ProductCategoryWhere"] | undefined | null},ValueTypes["ProductCategory"]],
		__typename?: boolean | `@${string}`
}>;
	["ProductCategoryTreeMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	depth?:ValueTypes["FieldMeta"],
	ancestor?:ValueTypes["FieldMeta"],
	descendant?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProductCategoryTreeOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	depth?: ValueTypes["OrderDirection"] | undefined | null,
	ancestor?: ValueTypes["ProductCategoryOrderBy"] | undefined | null,
	descendant?: ValueTypes["ProductCategoryOrderBy"] | undefined | null
};
	["InheritedProductCategoryTag"]: AliasType<{
	_meta?:ValueTypes["InheritedProductCategoryTagMeta"],
	id?:boolean | `@${string}`,
	depth?:boolean | `@${string}`,
productCategory?: [{	filter?: ValueTypes["ProductCategoryWhere"] | undefined | null},ValueTypes["ProductCategory"]],
tag?: [{	filter?: ValueTypes["TagWhere"] | undefined | null},ValueTypes["Tag"]],
		__typename?: boolean | `@${string}`
}>;
	["InheritedProductCategoryTagMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	depth?:ValueTypes["FieldMeta"],
	productCategory?:ValueTypes["FieldMeta"],
	tag?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["InheritedProductCategoryTagOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	depth?: ValueTypes["OrderDirection"] | undefined | null,
	productCategory?: ValueTypes["ProductCategoryOrderBy"] | undefined | null,
	tag?: ValueTypes["TagOrderBy"] | undefined | null
};
	["NestedProductCategoryProduct"]: AliasType<{
	_meta?:ValueTypes["NestedProductCategoryProductMeta"],
	id?:boolean | `@${string}`,
	depth?:boolean | `@${string}`,
product?: [{	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
productCategory?: [{	filter?: ValueTypes["ProductCategoryWhere"] | undefined | null},ValueTypes["ProductCategory"]],
		__typename?: boolean | `@${string}`
}>;
	["NestedProductCategoryProductMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	depth?:ValueTypes["FieldMeta"],
	product?:ValueTypes["FieldMeta"],
	productCategory?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["NestedProductCategoryProductOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	depth?: ValueTypes["OrderDirection"] | undefined | null,
	product?: ValueTypes["ProductOrderBy"] | undefined | null,
	productCategory?: ValueTypes["ProductCategoryOrderBy"] | undefined | null
};
	["ProductCategoryChildrenByCodeUniqueWhere"]: {
	code?: string | undefined | null
};
	["ProductCategoryChildrenByChildrenUniqueWhere"]: {
	children?: ValueTypes["ProductCategoryUniqueWhere"] | undefined | null
};
	["ProductCategoryUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	children?: ValueTypes["ProductCategoryUniqueWhere"] | undefined | null,
	descendants?: ValueTypes["ProductCategoryTreeUniqueWhere"] | undefined | null,
	ancestors?: ValueTypes["ProductCategoryTreeUniqueWhere"] | undefined | null,
	inheritedTags?: ValueTypes["InheritedProductCategoryTagUniqueWhere"] | undefined | null,
	nestedProducts?: ValueTypes["NestedProductCategoryProductUniqueWhere"] | undefined | null
};
	["ProductCategoryTreeUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["InheritedProductCategoryTagUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["ProductCategoryChildrenByDescendantsUniqueWhere"]: {
	descendants?: ValueTypes["ProductCategoryTreeUniqueWhere"] | undefined | null
};
	["ProductCategoryChildrenByAncestorsUniqueWhere"]: {
	ancestors?: ValueTypes["ProductCategoryTreeUniqueWhere"] | undefined | null
};
	["ProductCategoryChildrenByInheritedTagsUniqueWhere"]: {
	inheritedTags?: ValueTypes["InheritedProductCategoryTagUniqueWhere"] | undefined | null
};
	["ProductCategoryChildrenByNestedProductsUniqueWhere"]: {
	nestedProducts?: ValueTypes["NestedProductCategoryProductUniqueWhere"] | undefined | null
};
	["ProductConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProductEdge"]: AliasType<{
	node?:ValueTypes["Product"],
		__typename?: boolean | `@${string}`
}>;
	["ProductCategoryConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductCategoryEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProductCategoryEdge"]: AliasType<{
	node?:ValueTypes["ProductCategory"],
		__typename?: boolean | `@${string}`
}>;
	["ProductCategoryTreeConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductCategoryTreeEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProductCategoryTreeEdge"]: AliasType<{
	node?:ValueTypes["ProductCategoryTree"],
		__typename?: boolean | `@${string}`
}>;
	["InheritedProductCategoryTagConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["InheritedProductCategoryTagEdge"],
		__typename?: boolean | `@${string}`
}>;
	["InheritedProductCategoryTagEdge"]: AliasType<{
	node?:ValueTypes["InheritedProductCategoryTag"],
		__typename?: boolean | `@${string}`
}>;
	["NestedProductCategoryProductConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["NestedProductCategoryProductEdge"],
		__typename?: boolean | `@${string}`
}>;
	["NestedProductCategoryProductEdge"]: AliasType<{
	node?:ValueTypes["NestedProductCategoryProduct"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleCategoryLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null
};
	["PointOfSaleCategoryProductsByLocalesUniqueWhere"]: {
	locales?: ValueTypes["PointOfSaleCategoryProductLocaleUniqueWhere"] | undefined | null
};
	["PointOfSaleCategoryLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PointOfSaleCategoryLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleCategoryLocaleEdge"]: AliasType<{
	node?:ValueTypes["PointOfSaleCategoryLocale"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleCategoryProductConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PointOfSaleCategoryProductEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleCategoryProductEdge"]: AliasType<{
	node?:ValueTypes["PointOfSaleCategoryProduct"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSalePrinterConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PointOfSalePrinterEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSalePrinterEdge"]: AliasType<{
	node?:ValueTypes["PointOfSalePrinter"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSalePrinterApplicationDevicesReceiptByIdentifierUniqueWhere"]: {
	identifier?: ValueTypes["DeviceIdentifierUniqueWhere"] | undefined | null
};
	["PointOfSaleCategoryConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PointOfSaleCategoryEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleCategoryEdge"]: AliasType<{
	node?:ValueTypes["PointOfSaleCategory"],
		__typename?: boolean | `@${string}`
}>;
	["Order"]: AliasType<{
	_meta?:ValueTypes["OrderMeta"],
	id?:boolean | `@${string}`,
	state?:boolean | `@${string}`,
	fulfilledAt?:boolean | `@${string}`,
	canceledAt?:boolean | `@${string}`,
	note?:boolean | `@${string}`,
customer?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
channel?: [{	filter?: ValueTypes["ChannelWhere"] | undefined | null},ValueTypes["Channel"]],
discounts?: [{	filter?: ValueTypes["OrderDiscountWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderDiscountOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["OrderDiscount"]],
delivery?: [{	filter?: ValueTypes["OrderDeliveryWhere"] | undefined | null},ValueTypes["OrderDelivery"]],
items?: [{	filter?: ValueTypes["OrderItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["OrderItem"]],
	internalNote?:boolean | `@${string}`,
cart?: [{	filter?: ValueTypes["CartWhere"] | undefined | null},ValueTypes["Cart"]],
events?: [{	filter?: ValueTypes["OrderEventWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderEventOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["OrderEvent"]],
	createdAt?:boolean | `@${string}`,
billingAddress?: [{	filter?: ValueTypes["AddressWhere"] | undefined | null},ValueTypes["Address"]],
priceLines?: [{	filter?: ValueTypes["OrderPriceLineWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderPriceLineOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["OrderPriceLine"]],
payments?: [{	filter?: ValueTypes["OrderPaymentWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderPaymentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["OrderPayment"]],
	seq?:boolean | `@${string}`,
billingSubject?: [{	filter?: ValueTypes["BillingSubjectWhere"] | undefined | null},ValueTypes["BillingSubject"]],
summary?: [{	filter?: ValueTypes["OrderSummaryWhere"] | undefined | null},ValueTypes["OrderSummary"]],
	doubleshotLegacyId?:boolean | `@${string}`,
gratuity?: [{	filter?: ValueTypes["GratuityWhere"] | undefined | null},ValueTypes["Gratuity"]],
venue?: [{	filter?: ValueTypes["VenueWhere"] | undefined | null},ValueTypes["Venue"]],
	fulfillmentNote?:boolean | `@${string}`,
fulfillmentNotes?: [{	filter?: ValueTypes["FulfillmentNoteWhere"] | undefined | null,	orderBy?: Array<ValueTypes["FulfillmentNoteOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["FulfillmentNote"]],
	doubleshotTotalWeightGrams?:boolean | `@${string}`,
	doubleShotLegacyNumber?:boolean | `@${string}`,
	doubleshotLastUpdatedAt?:boolean | `@${string}`,
	doubleshotAdminUrl?:boolean | `@${string}`,
discountsByCustomerCreditTransactions?: [{	by: ValueTypes["OrderDiscountsByCustomerCreditTransactionsUniqueWhere"],	filter?: ValueTypes["OrderDiscountWhere"] | undefined | null},ValueTypes["OrderDiscount"]],
discountsByVoucherRedemption?: [{	by: ValueTypes["OrderDiscountsByVoucherRedemptionUniqueWhere"],	filter?: ValueTypes["OrderDiscountWhere"] | undefined | null},ValueTypes["OrderDiscount"]],
itemsByVirtualProductEffects?: [{	by: ValueTypes["OrderItemsByVirtualProductEffectsUniqueWhere"],	filter?: ValueTypes["OrderItemWhere"] | undefined | null},ValueTypes["OrderItem"]],
priceLinesByOrderItem?: [{	by: ValueTypes["OrderPriceLinesByOrderItemUniqueWhere"],	filter?: ValueTypes["OrderPriceLineWhere"] | undefined | null},ValueTypes["OrderPriceLine"]],
priceLinesByOrderDiscount?: [{	by: ValueTypes["OrderPriceLinesByOrderDiscountUniqueWhere"],	filter?: ValueTypes["OrderPriceLineWhere"] | undefined | null},ValueTypes["OrderPriceLine"]],
priceLinesByOrderPayment?: [{	by: ValueTypes["OrderPriceLinesByOrderPaymentUniqueWhere"],	filter?: ValueTypes["OrderPriceLineWhere"] | undefined | null},ValueTypes["OrderPriceLine"]],
priceLinesByOrderDelivery?: [{	by: ValueTypes["OrderPriceLinesByOrderDeliveryUniqueWhere"],	filter?: ValueTypes["OrderPriceLineWhere"] | undefined | null},ValueTypes["OrderPriceLine"]],
paymentsByEvents?: [{	by: ValueTypes["OrderPaymentsByEventsUniqueWhere"],	filter?: ValueTypes["OrderPaymentWhere"] | undefined | null},ValueTypes["OrderPayment"]],
paymentsByMeta?: [{	by: ValueTypes["OrderPaymentsByMetaUniqueWhere"],	filter?: ValueTypes["OrderPaymentWhere"] | undefined | null},ValueTypes["OrderPayment"]],
paginateDiscounts?: [{	filter?: ValueTypes["OrderDiscountWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderDiscountOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderDiscountConnection"]],
paginateItems?: [{	filter?: ValueTypes["OrderItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderItemConnection"]],
paginateEvents?: [{	filter?: ValueTypes["OrderEventWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderEventOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderEventConnection"]],
paginatePriceLines?: [{	filter?: ValueTypes["OrderPriceLineWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderPriceLineOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderPriceLineConnection"]],
paginatePayments?: [{	filter?: ValueTypes["OrderPaymentWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderPaymentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderPaymentConnection"]],
paginateFulfillmentNotes?: [{	filter?: ValueTypes["FulfillmentNoteWhere"] | undefined | null,	orderBy?: Array<ValueTypes["FulfillmentNoteOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["FulfillmentNoteConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["OrderMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	state?:ValueTypes["FieldMeta"],
	fulfilledAt?:ValueTypes["FieldMeta"],
	canceledAt?:ValueTypes["FieldMeta"],
	note?:ValueTypes["FieldMeta"],
	customer?:ValueTypes["FieldMeta"],
	channel?:ValueTypes["FieldMeta"],
	discounts?:ValueTypes["FieldMeta"],
	delivery?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
	internalNote?:ValueTypes["FieldMeta"],
	cart?:ValueTypes["FieldMeta"],
	events?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	billingAddress?:ValueTypes["FieldMeta"],
	priceLines?:ValueTypes["FieldMeta"],
	payments?:ValueTypes["FieldMeta"],
	seq?:ValueTypes["FieldMeta"],
	billingSubject?:ValueTypes["FieldMeta"],
	summary?:ValueTypes["FieldMeta"],
	doubleshotLegacyId?:ValueTypes["FieldMeta"],
	gratuity?:ValueTypes["FieldMeta"],
	venue?:ValueTypes["FieldMeta"],
	fulfillmentNote?:ValueTypes["FieldMeta"],
	fulfillmentNotes?:ValueTypes["FieldMeta"],
	doubleshotTotalWeightGrams?:ValueTypes["FieldMeta"],
	doubleShotLegacyNumber?:ValueTypes["FieldMeta"],
	doubleshotLastUpdatedAt?:ValueTypes["FieldMeta"],
	doubleshotAdminUrl?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["OrderDiscount"]: AliasType<{
	_meta?:ValueTypes["OrderDiscountMeta"],
	id?:boolean | `@${string}`,
	discountCents?:boolean | `@${string}`,
vatRate?: [{	filter?: ValueTypes["VatRateWhere"] | undefined | null},ValueTypes["VatRate"]],
order?: [{	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
	description?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
customerCreditTransactions?: [{	filter?: ValueTypes["CustomerCreditTransactionWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerCreditTransactionOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CustomerCreditTransaction"]],
voucherRedemption?: [{	filter?: ValueTypes["VoucherRedemptionWhere"] | undefined | null},ValueTypes["VoucherRedemption"]],
customerCreditTransactionsByVirtualProductEffect?: [{	by: ValueTypes["OrderDiscountCustomerCreditTransactionsByVirtualProductEffectUniqueWhere"],	filter?: ValueTypes["CustomerCreditTransactionWhere"] | undefined | null},ValueTypes["CustomerCreditTransaction"]],
paginateCustomerCreditTransactions?: [{	filter?: ValueTypes["CustomerCreditTransactionWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerCreditTransactionOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerCreditTransactionConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["OrderDiscountMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	discountCents?:ValueTypes["FieldMeta"],
	vatRate?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	customerCreditTransactions?:ValueTypes["FieldMeta"],
	voucherRedemption?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerCreditTransaction"]: AliasType<{
	_meta?:ValueTypes["CustomerCreditTransactionMeta"],
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	amountCents?:boolean | `@${string}`,
customerCredit?: [{	filter?: ValueTypes["CustomerCreditWhere"] | undefined | null},ValueTypes["CustomerCredit"]],
orderDiscount?: [{	filter?: ValueTypes["OrderDiscountWhere"] | undefined | null},ValueTypes["OrderDiscount"]],
virtualProductEffect?: [{	filter?: ValueTypes["VirtualProductEffectWhere"] | undefined | null},ValueTypes["VirtualProductEffect"]],
		__typename?: boolean | `@${string}`
}>;
	["CustomerCreditTransactionMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	amountCents?:ValueTypes["FieldMeta"],
	customerCredit?:ValueTypes["FieldMeta"],
	orderDiscount?:ValueTypes["FieldMeta"],
	virtualProductEffect?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerCredit"]: AliasType<{
	_meta?:ValueTypes["CustomerCreditMeta"],
	id?:boolean | `@${string}`,
	initialCreditCents?:boolean | `@${string}`,
	remainingCreditsCents?:boolean | `@${string}`,
	expiresAt?:boolean | `@${string}`,
	reason?:boolean | `@${string}`,
customer?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
vatRate?: [{	filter?: ValueTypes["VatRateWhere"] | undefined | null},ValueTypes["VatRate"]],
	createdAt?:boolean | `@${string}`,
transactions?: [{	filter?: ValueTypes["CustomerCreditTransactionWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerCreditTransactionOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CustomerCreditTransaction"]],
voucherRedemption?: [{	filter?: ValueTypes["VoucherRedemptionWhere"] | undefined | null},ValueTypes["VoucherRedemption"]],
	invoiceUrl?:boolean | `@${string}`,
transactionsByVirtualProductEffect?: [{	by: ValueTypes["CustomerCreditTransactionsByVirtualProductEffectUniqueWhere"],	filter?: ValueTypes["CustomerCreditTransactionWhere"] | undefined | null},ValueTypes["CustomerCreditTransaction"]],
paginateTransactions?: [{	filter?: ValueTypes["CustomerCreditTransactionWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerCreditTransactionOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerCreditTransactionConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["CustomerCreditMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	initialCreditCents?:ValueTypes["FieldMeta"],
	remainingCreditsCents?:ValueTypes["FieldMeta"],
	expiresAt?:ValueTypes["FieldMeta"],
	reason?:ValueTypes["FieldMeta"],
	customer?:ValueTypes["FieldMeta"],
	vatRate?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	transactions?:ValueTypes["FieldMeta"],
	voucherRedemption?:ValueTypes["FieldMeta"],
	invoiceUrl?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerCreditTransactionOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null,
	amountCents?: ValueTypes["OrderDirection"] | undefined | null,
	customerCredit?: ValueTypes["CustomerCreditOrderBy"] | undefined | null,
	orderDiscount?: ValueTypes["OrderDiscountOrderBy"] | undefined | null,
	virtualProductEffect?: ValueTypes["VirtualProductEffectOrderBy"] | undefined | null
};
	["CustomerCreditOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	initialCreditCents?: ValueTypes["OrderDirection"] | undefined | null,
	remainingCreditsCents?: ValueTypes["OrderDirection"] | undefined | null,
	expiresAt?: ValueTypes["OrderDirection"] | undefined | null,
	reason?: ValueTypes["OrderDirection"] | undefined | null,
	customer?: ValueTypes["CustomerOrderBy"] | undefined | null,
	vatRate?: ValueTypes["VatRateOrderBy"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null,
	voucherRedemption?: ValueTypes["VoucherRedemptionOrderBy"] | undefined | null,
	invoiceUrl?: ValueTypes["OrderDirection"] | undefined | null
};
	["VoucherRedemptionOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null,
	note?: ValueTypes["OrderDirection"] | undefined | null,
	manualRedemptionNote?: ValueTypes["OrderDirection"] | undefined | null,
	customerCredit?: ValueTypes["CustomerCreditOrderBy"] | undefined | null,
	orderDiscount?: ValueTypes["OrderDiscountOrderBy"] | undefined | null,
	voucher?: ValueTypes["VoucherOrderBy"] | undefined | null,
	customer?: ValueTypes["CustomerOrderBy"] | undefined | null
};
	["OrderDiscountOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	discountCents?: ValueTypes["OrderDirection"] | undefined | null,
	vatRate?: ValueTypes["VatRateOrderBy"] | undefined | null,
	order?: ValueTypes["OrderOrderBy"] | undefined | null,
	description?: ValueTypes["OrderDirection"] | undefined | null,
	type?: ValueTypes["OrderDirection"] | undefined | null,
	voucherRedemption?: ValueTypes["VoucherRedemptionOrderBy"] | undefined | null
};
	["OrderOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	state?: ValueTypes["OrderDirection"] | undefined | null,
	fulfilledAt?: ValueTypes["OrderDirection"] | undefined | null,
	canceledAt?: ValueTypes["OrderDirection"] | undefined | null,
	note?: ValueTypes["OrderDirection"] | undefined | null,
	customer?: ValueTypes["CustomerOrderBy"] | undefined | null,
	channel?: ValueTypes["ChannelOrderBy"] | undefined | null,
	delivery?: ValueTypes["OrderDeliveryOrderBy"] | undefined | null,
	internalNote?: ValueTypes["OrderDirection"] | undefined | null,
	cart?: ValueTypes["CartOrderBy"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null,
	billingAddress?: ValueTypes["AddressOrderBy"] | undefined | null,
	seq?: ValueTypes["OrderDirection"] | undefined | null,
	billingSubject?: ValueTypes["BillingSubjectOrderBy"] | undefined | null,
	summary?: ValueTypes["OrderSummaryOrderBy"] | undefined | null,
	doubleshotLegacyId?: ValueTypes["OrderDirection"] | undefined | null,
	gratuity?: ValueTypes["GratuityOrderBy"] | undefined | null,
	venue?: ValueTypes["VenueOrderBy"] | undefined | null,
	fulfillmentNote?: ValueTypes["OrderDirection"] | undefined | null,
	doubleshotTotalWeightGrams?: ValueTypes["OrderDirection"] | undefined | null,
	doubleShotLegacyNumber?: ValueTypes["OrderDirection"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["OrderDirection"] | undefined | null,
	doubleshotAdminUrl?: ValueTypes["OrderDirection"] | undefined | null
};
	["OrderDeliveryOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	priceCents?: ValueTypes["OrderDirection"] | undefined | null,
	deliveredAt?: ValueTypes["OrderDirection"] | undefined | null,
	method?: ValueTypes["DeliveryMethodOrderBy"] | undefined | null,
	vatRate?: ValueTypes["VatRateOrderBy"] | undefined | null,
	order?: ValueTypes["OrderOrderBy"] | undefined | null,
	expectedAt?: ValueTypes["OrderDirection"] | undefined | null,
	state?: ValueTypes["OrderDirection"] | undefined | null,
	loadingDurationHours?: ValueTypes["OrderDirection"] | undefined | null,
	dispatchAt?: ValueTypes["OrderDirection"] | undefined | null,
	duration?: ValueTypes["OrderDirection"] | undefined | null,
	window?: ValueTypes["OrderDirection"] | undefined | null,
	expectedEndAt?: ValueTypes["OrderDirection"] | undefined | null,
	processingAt?: ValueTypes["OrderDirection"] | undefined | null,
	deliveringAt?: ValueTypes["OrderDirection"] | undefined | null,
	failedAt?: ValueTypes["OrderDirection"] | undefined | null,
	internalNote?: ValueTypes["OrderDirection"] | undefined | null,
	deliveryWaypoint?: ValueTypes["DeliveryWaypointOrderBy"] | undefined | null,
	prepareAt?: ValueTypes["OrderDirection"] | undefined | null,
	liftagoRide?: ValueTypes["LiftagoRideOrderBy"] | undefined | null,
	pickedAt?: ValueTypes["OrderDirection"] | undefined | null,
	address?: ValueTypes["AddressOrderBy"] | undefined | null,
	trackingCode?: ValueTypes["OrderDirection"] | undefined | null,
	woltDriveDelivery?: ValueTypes["WoltDriveDeliveryOrderBy"] | undefined | null
};
	["DeliveryWaypointOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	estimatedArrival?: ValueTypes["OrderDirection"] | undefined | null,
	note?: ValueTypes["OrderDirection"] | undefined | null,
	route?: ValueTypes["DeliveryRouteOrderBy"] | undefined | null,
	sortingOrder?: ValueTypes["OrderDirection"] | undefined | null,
	delivery?: ValueTypes["OrderDeliveryOrderBy"] | undefined | null,
	estimatedDistance?: ValueTypes["OrderDirection"] | undefined | null,
	estimatedDuration?: ValueTypes["OrderDirection"] | undefined | null,
	originDeparture?: ValueTypes["OrderDirection"] | undefined | null,
	originAddress?: ValueTypes["OrderDirection"] | undefined | null,
	transitMode?: ValueTypes["OrderDirection"] | undefined | null
};
	["DeliveryRouteOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	courier?: ValueTypes["CourierOrderBy"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null,
	dispatchAt?: ValueTypes["OrderDirection"] | undefined | null
};
	["LiftagoRideOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	liftagoId?: ValueTypes["OrderDirection"] | undefined | null,
	data?: ValueTypes["OrderDirection"] | undefined | null,
	updatedAt?: ValueTypes["OrderDirection"] | undefined | null,
	delivery?: ValueTypes["OrderDeliveryOrderBy"] | undefined | null
};
	["WoltDriveDeliveryOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	state?: ValueTypes["OrderDirection"] | undefined | null,
	shipmentPromiseId?: ValueTypes["OrderDirection"] | undefined | null,
	deliveryPrice?: ValueTypes["OrderDirection"] | undefined | null,
	deliveryPriceCurrency?: ValueTypes["OrderDirection"] | undefined | null,
	shipmentPromiseResponse?: ValueTypes["OrderDirection"] | undefined | null,
	deliveryOrderId?: ValueTypes["OrderDirection"] | undefined | null,
	trackingUrl?: ValueTypes["OrderDirection"] | undefined | null,
	deliverOrderResponse?: ValueTypes["OrderDirection"] | undefined | null,
	delivery?: ValueTypes["OrderDeliveryOrderBy"] | undefined | null
};
	["CartOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	confirmedAt?: ValueTypes["OrderDirection"] | undefined | null,
	deletedAt?: ValueTypes["OrderDirection"] | undefined | null,
	note?: ValueTypes["OrderDirection"] | undefined | null,
	handle?: ValueTypes["OrderDirection"] | undefined | null,
	state?: ValueTypes["OrderDirection"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null,
	channel?: ValueTypes["ChannelOrderBy"] | undefined | null,
	order?: ValueTypes["OrderOrderBy"] | undefined | null,
	customer?: ValueTypes["CustomerOrderBy"] | undefined | null,
	deliveryAddress?: ValueTypes["AddressOrderBy"] | undefined | null,
	billingAddress?: ValueTypes["AddressOrderBy"] | undefined | null,
	deliveryOption?: ValueTypes["OrderDirection"] | undefined | null,
	paymentOption?: ValueTypes["OrderDirection"] | undefined | null,
	delivery?: ValueTypes["ChannelDeliveryOrderBy"] | undefined | null,
	payment?: ValueTypes["ChannelPaymentOrderBy"] | undefined | null,
	billingSubject?: ValueTypes["BillingSubjectOrderBy"] | undefined | null,
	summary?: ValueTypes["CartSummaryOrderBy"] | undefined | null
};
	["CartSummaryOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	itemsPriceCents?: ValueTypes["OrderDirection"] | undefined | null,
	deliveryPriceCents?: ValueTypes["OrderDirection"] | undefined | null,
	totalPriceCents?: ValueTypes["OrderDirection"] | undefined | null,
	itemsCount?: ValueTypes["OrderDirection"] | undefined | null,
	itemsQuantity?: ValueTypes["OrderDirection"] | undefined | null,
	checkoutUrl?: ValueTypes["OrderDirection"] | undefined | null,
	cart?: ValueTypes["CartOrderBy"] | undefined | null
};
	["OrderSummaryOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	totalPriceCents?: ValueTypes["OrderDirection"] | undefined | null,
	discountPriceCents?: ValueTypes["OrderDirection"] | undefined | null,
	undiscountedPriceCents?: ValueTypes["OrderDirection"] | undefined | null,
	itemsQuantity?: ValueTypes["OrderDirection"] | undefined | null,
	orderUrl?: ValueTypes["OrderDirection"] | undefined | null,
	orderNumber?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderOrderBy"] | undefined | null
};
	["GratuityOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	amountCents?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderOrderBy"] | undefined | null
};
	["VoucherOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null,
	activatedAt?: ValueTypes["OrderDirection"] | undefined | null,
	expiresAt?: ValueTypes["OrderDirection"] | undefined | null,
	internalNote?: ValueTypes["OrderDirection"] | undefined | null,
	note?: ValueTypes["OrderDirection"] | undefined | null,
	code?: ValueTypes["OrderDirection"] | undefined | null,
	type?: ValueTypes["OrderDirection"] | undefined | null,
	creditCents?: ValueTypes["OrderDirection"] | undefined | null,
	buyer?: ValueTypes["CustomerOrderBy"] | undefined | null,
	owner?: ValueTypes["CustomerOrderBy"] | undefined | null,
	vatRate?: ValueTypes["VatRateOrderBy"] | undefined | null,
	virtualProductEffect?: ValueTypes["VirtualProductEffectOrderBy"] | undefined | null,
	redemption?: ValueTypes["VoucherRedemptionOrderBy"] | undefined | null
};
	["VirtualProductEffectOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null,
	succeededAt?: ValueTypes["OrderDirection"] | undefined | null,
	orderItem?: ValueTypes["OrderItemOrderBy"] | undefined | null,
	failedAt?: ValueTypes["OrderDirection"] | undefined | null,
	revertedAt?: ValueTypes["OrderDirection"] | undefined | null,
	resultCustomerCreditTransaction?: ValueTypes["CustomerCreditTransactionOrderBy"] | undefined | null
};
	["OrderItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	unitPriceCents?: ValueTypes["OrderDirection"] | undefined | null,
	quantity?: ValueTypes["OrderDirection"] | undefined | null,
	vatRate?: ValueTypes["VatRateOrderBy"] | undefined | null,
	order?: ValueTypes["OrderOrderBy"] | undefined | null,
	pickedAt?: ValueTypes["OrderDirection"] | undefined | null,
	note?: ValueTypes["OrderDirection"] | undefined | null,
	product?: ValueTypes["ProductOrderBy"] | undefined | null
};
	["VoucherRedemption"]: AliasType<{
	_meta?:ValueTypes["VoucherRedemptionMeta"],
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	note?:boolean | `@${string}`,
	manualRedemptionNote?:boolean | `@${string}`,
customerCredit?: [{	filter?: ValueTypes["CustomerCreditWhere"] | undefined | null},ValueTypes["CustomerCredit"]],
orderDiscount?: [{	filter?: ValueTypes["OrderDiscountWhere"] | undefined | null},ValueTypes["OrderDiscount"]],
voucher?: [{	filter?: ValueTypes["VoucherWhere"] | undefined | null},ValueTypes["Voucher"]],
customer?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
		__typename?: boolean | `@${string}`
}>;
	["VoucherRedemptionMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	note?:ValueTypes["FieldMeta"],
	manualRedemptionNote?:ValueTypes["FieldMeta"],
	customerCredit?:ValueTypes["FieldMeta"],
	orderDiscount?:ValueTypes["FieldMeta"],
	voucher?:ValueTypes["FieldMeta"],
	customer?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Voucher"]: AliasType<{
	_meta?:ValueTypes["VoucherMeta"],
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	activatedAt?:boolean | `@${string}`,
	expiresAt?:boolean | `@${string}`,
	internalNote?:boolean | `@${string}`,
	note?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	creditCents?:boolean | `@${string}`,
buyer?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
owner?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
vatRate?: [{	filter?: ValueTypes["VatRateWhere"] | undefined | null},ValueTypes["VatRate"]],
virtualProductEffect?: [{	filter?: ValueTypes["VirtualProductEffectWhere"] | undefined | null},ValueTypes["VirtualProductEffect"]],
redemption?: [{	filter?: ValueTypes["VoucherRedemptionWhere"] | undefined | null},ValueTypes["VoucherRedemption"]],
		__typename?: boolean | `@${string}`
}>;
	["VoucherMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	activatedAt?:ValueTypes["FieldMeta"],
	expiresAt?:ValueTypes["FieldMeta"],
	internalNote?:ValueTypes["FieldMeta"],
	note?:ValueTypes["FieldMeta"],
	code?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	creditCents?:ValueTypes["FieldMeta"],
	buyer?:ValueTypes["FieldMeta"],
	owner?:ValueTypes["FieldMeta"],
	vatRate?:ValueTypes["FieldMeta"],
	virtualProductEffect?:ValueTypes["FieldMeta"],
	redemption?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["VirtualProductEffect"]: AliasType<{
	_meta?:ValueTypes["VirtualProductEffectMeta"],
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	succeededAt?:boolean | `@${string}`,
orderItem?: [{	filter?: ValueTypes["OrderItemWhere"] | undefined | null},ValueTypes["OrderItem"]],
	failedAt?:boolean | `@${string}`,
	revertedAt?:boolean | `@${string}`,
resultCustomerCreditTransaction?: [{	filter?: ValueTypes["CustomerCreditTransactionWhere"] | undefined | null},ValueTypes["CustomerCreditTransaction"]],
resultVouchers?: [{	filter?: ValueTypes["VoucherWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VoucherOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Voucher"]],
resultVouchersByCode?: [{	by: ValueTypes["VirtualProductEffectResultVouchersByCodeUniqueWhere"],	filter?: ValueTypes["VoucherWhere"] | undefined | null},ValueTypes["Voucher"]],
resultVouchersByRedemption?: [{	by: ValueTypes["VirtualProductEffectResultVouchersByRedemptionUniqueWhere"],	filter?: ValueTypes["VoucherWhere"] | undefined | null},ValueTypes["Voucher"]],
paginateResultVouchers?: [{	filter?: ValueTypes["VoucherWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VoucherOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["VoucherConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["VirtualProductEffectMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	succeededAt?:ValueTypes["FieldMeta"],
	orderItem?:ValueTypes["FieldMeta"],
	failedAt?:ValueTypes["FieldMeta"],
	revertedAt?:ValueTypes["FieldMeta"],
	resultCustomerCreditTransaction?:ValueTypes["FieldMeta"],
	resultVouchers?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["OrderItem"]: AliasType<{
	_meta?:ValueTypes["OrderItemMeta"],
	id?:boolean | `@${string}`,
	unitPriceCents?:boolean | `@${string}`,
	quantity?:boolean | `@${string}`,
vatRate?: [{	filter?: ValueTypes["VatRateWhere"] | undefined | null},ValueTypes["VatRate"]],
order?: [{	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
virtualProductEffects?: [{	filter?: ValueTypes["VirtualProductEffectWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VirtualProductEffectOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["VirtualProductEffect"]],
	pickedAt?:boolean | `@${string}`,
	note?:boolean | `@${string}`,
fulfillmentNotes?: [{	filter?: ValueTypes["FulfillmentNoteWhere"] | undefined | null,	orderBy?: Array<ValueTypes["FulfillmentNoteOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["FulfillmentNote"]],
product?: [{	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
virtualProductEffectsByResultCustomerCreditTransaction?: [{	by: ValueTypes["OrderItemVirtualProductEffectsByResultCustomerCreditTransactionUniqueWhere"],	filter?: ValueTypes["VirtualProductEffectWhere"] | undefined | null},ValueTypes["VirtualProductEffect"]],
virtualProductEffectsByResultVouchers?: [{	by: ValueTypes["OrderItemVirtualProductEffectsByResultVouchersUniqueWhere"],	filter?: ValueTypes["VirtualProductEffectWhere"] | undefined | null},ValueTypes["VirtualProductEffect"]],
paginateVirtualProductEffects?: [{	filter?: ValueTypes["VirtualProductEffectWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VirtualProductEffectOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["VirtualProductEffectConnection"]],
paginateFulfillmentNotes?: [{	filter?: ValueTypes["FulfillmentNoteWhere"] | undefined | null,	orderBy?: Array<ValueTypes["FulfillmentNoteOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["FulfillmentNoteConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["OrderItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unitPriceCents?:ValueTypes["FieldMeta"],
	quantity?:ValueTypes["FieldMeta"],
	vatRate?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	virtualProductEffects?:ValueTypes["FieldMeta"],
	pickedAt?:ValueTypes["FieldMeta"],
	note?:ValueTypes["FieldMeta"],
	fulfillmentNotes?:ValueTypes["FieldMeta"],
	product?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["FulfillmentNoteOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	note?: ValueTypes["OrderDirection"] | undefined | null,
	highlight?: ValueTypes["OrderDirection"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null,
	emoji?: ValueTypes["OrderDirection"] | undefined | null
};
	["OrderItemVirtualProductEffectsByResultCustomerCreditTransactionUniqueWhere"]: {
	resultCustomerCreditTransaction?: ValueTypes["CustomerCreditTransactionUniqueWhere"] | undefined | null
};
	["OrderItemVirtualProductEffectsByResultVouchersUniqueWhere"]: {
	resultVouchers?: ValueTypes["VoucherUniqueWhere"] | undefined | null
};
	["VirtualProductEffectConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["VirtualProductEffectEdge"],
		__typename?: boolean | `@${string}`
}>;
	["VirtualProductEffectEdge"]: AliasType<{
	node?:ValueTypes["VirtualProductEffect"],
		__typename?: boolean | `@${string}`
}>;
	["FulfillmentNoteConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FulfillmentNoteEdge"],
		__typename?: boolean | `@${string}`
}>;
	["FulfillmentNoteEdge"]: AliasType<{
	node?:ValueTypes["FulfillmentNote"],
		__typename?: boolean | `@${string}`
}>;
	["VirtualProductEffectResultVouchersByCodeUniqueWhere"]: {
	code?: string | undefined | null
};
	["VirtualProductEffectResultVouchersByRedemptionUniqueWhere"]: {
	redemption?: ValueTypes["VoucherRedemptionUniqueWhere"] | undefined | null
};
	["VoucherConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["VoucherEdge"],
		__typename?: boolean | `@${string}`
}>;
	["VoucherEdge"]: AliasType<{
	node?:ValueTypes["Voucher"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerCreditTransactionsByVirtualProductEffectUniqueWhere"]: {
	virtualProductEffect?: ValueTypes["VirtualProductEffectUniqueWhere"] | undefined | null
};
	["CustomerCreditTransactionConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CustomerCreditTransactionEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerCreditTransactionEdge"]: AliasType<{
	node?:ValueTypes["CustomerCreditTransaction"],
		__typename?: boolean | `@${string}`
}>;
	["OrderDiscountCustomerCreditTransactionsByVirtualProductEffectUniqueWhere"]: {
	virtualProductEffect?: ValueTypes["VirtualProductEffectUniqueWhere"] | undefined | null
};
	["OrderEvent"]: AliasType<{
	_meta?:ValueTypes["OrderEventMeta"],
	id?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	data?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
order?: [{	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
payment?: [{	filter?: ValueTypes["OrderPaymentWhere"] | undefined | null},ValueTypes["OrderPayment"]],
delivery?: [{	filter?: ValueTypes["OrderDeliveryWhere"] | undefined | null},ValueTypes["OrderDelivery"]],
		__typename?: boolean | `@${string}`
}>;
	["OrderEventMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	data?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	payment?:ValueTypes["FieldMeta"],
	delivery?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["OrderPayment"]: AliasType<{
	_meta?:ValueTypes["OrderPaymentMeta"],
	id?:boolean | `@${string}`,
	data?:boolean | `@${string}`,
	paymentCents?:boolean | `@${string}`,
method?: [{	filter?: ValueTypes["PaymentMethodWhere"] | undefined | null},ValueTypes["PaymentMethod"]],
	failedAt?:boolean | `@${string}`,
	state?:boolean | `@${string}`,
	approvedAt?:boolean | `@${string}`,
events?: [{	filter?: ValueTypes["OrderEventWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderEventOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["OrderEvent"]],
order?: [{	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
invoice?: [{	filter?: ValueTypes["InvoiceWhere"] | undefined | null},ValueTypes["Invoice"]],
	walletType?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	publicReceiptUrl?:boolean | `@${string}`,
	priceCents?:boolean | `@${string}`,
vatRate?: [{	filter?: ValueTypes["VatRateWhere"] | undefined | null},ValueTypes["VatRate"]],
meta?: [{	filter?: ValueTypes["OrderPaymentMetadataWhere"] | undefined | null},ValueTypes["OrderPaymentMetadata"]],
	otherCurrencyPriceCents?:boolean | `@${string}`,
paginateEvents?: [{	filter?: ValueTypes["OrderEventWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderEventOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderEventConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["OrderPaymentMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	data?:ValueTypes["FieldMeta"],
	paymentCents?:ValueTypes["FieldMeta"],
	method?:ValueTypes["FieldMeta"],
	failedAt?:ValueTypes["FieldMeta"],
	state?:ValueTypes["FieldMeta"],
	approvedAt?:ValueTypes["FieldMeta"],
	events?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	invoice?:ValueTypes["FieldMeta"],
	walletType?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	publicReceiptUrl?:ValueTypes["FieldMeta"],
	priceCents?:ValueTypes["FieldMeta"],
	vatRate?:ValueTypes["FieldMeta"],
	meta?:ValueTypes["FieldMeta"],
	otherCurrencyPriceCents?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["OrderEventOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	type?: ValueTypes["OrderDirection"] | undefined | null,
	data?: ValueTypes["OrderDirection"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderOrderBy"] | undefined | null,
	payment?: ValueTypes["OrderPaymentOrderBy"] | undefined | null,
	delivery?: ValueTypes["OrderDeliveryOrderBy"] | undefined | null
};
	["OrderPaymentOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	data?: ValueTypes["OrderDirection"] | undefined | null,
	paymentCents?: ValueTypes["OrderDirection"] | undefined | null,
	method?: ValueTypes["PaymentMethodOrderBy"] | undefined | null,
	failedAt?: ValueTypes["OrderDirection"] | undefined | null,
	state?: ValueTypes["OrderDirection"] | undefined | null,
	approvedAt?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderOrderBy"] | undefined | null,
	invoice?: ValueTypes["InvoiceOrderBy"] | undefined | null,
	walletType?: ValueTypes["OrderDirection"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null,
	publicReceiptUrl?: ValueTypes["OrderDirection"] | undefined | null,
	priceCents?: ValueTypes["OrderDirection"] | undefined | null,
	vatRate?: ValueTypes["VatRateOrderBy"] | undefined | null,
	meta?: ValueTypes["OrderPaymentMetadataOrderBy"] | undefined | null,
	otherCurrencyPriceCents?: ValueTypes["OrderDirection"] | undefined | null
};
	["InvoiceOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null,
	publicKey?: ValueTypes["OrderDirection"] | undefined | null,
	fakturoidId?: ValueTypes["OrderDirection"] | undefined | null,
	fakturoidData?: ValueTypes["OrderDirection"] | undefined | null,
	legacyUrl?: ValueTypes["OrderDirection"] | undefined | null,
	customer?: ValueTypes["CustomerOrderBy"] | undefined | null,
	address?: ValueTypes["AddressOrderBy"] | undefined | null,
	publicUrl?: ValueTypes["OrderDirection"] | undefined | null,
	billingSubject?: ValueTypes["BillingSubjectOrderBy"] | undefined | null
};
	["OrderPaymentMetadataOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	paymentUrl?: ValueTypes["OrderDirection"] | undefined | null,
	orderPayment?: ValueTypes["OrderPaymentOrderBy"] | undefined | null
};
	["Invoice"]: AliasType<{
	_meta?:ValueTypes["InvoiceMeta"],
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	publicKey?:boolean | `@${string}`,
	fakturoidId?:boolean | `@${string}`,
	fakturoidData?:boolean | `@${string}`,
	legacyUrl?:boolean | `@${string}`,
customer?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
orderPayments?: [{	filter?: ValueTypes["OrderPaymentWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderPaymentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["OrderPayment"]],
address?: [{	filter?: ValueTypes["AddressWhere"] | undefined | null},ValueTypes["Address"]],
	publicUrl?:boolean | `@${string}`,
billingSubject?: [{	filter?: ValueTypes["BillingSubjectWhere"] | undefined | null},ValueTypes["BillingSubject"]],
orderPaymentsByEvents?: [{	by: ValueTypes["InvoiceOrderPaymentsByEventsUniqueWhere"],	filter?: ValueTypes["OrderPaymentWhere"] | undefined | null},ValueTypes["OrderPayment"]],
orderPaymentsByMeta?: [{	by: ValueTypes["InvoiceOrderPaymentsByMetaUniqueWhere"],	filter?: ValueTypes["OrderPaymentWhere"] | undefined | null},ValueTypes["OrderPayment"]],
paginateOrderPayments?: [{	filter?: ValueTypes["OrderPaymentWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderPaymentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderPaymentConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["InvoiceMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	publicKey?:ValueTypes["FieldMeta"],
	fakturoidId?:ValueTypes["FieldMeta"],
	fakturoidData?:ValueTypes["FieldMeta"],
	legacyUrl?:ValueTypes["FieldMeta"],
	customer?:ValueTypes["FieldMeta"],
	orderPayments?:ValueTypes["FieldMeta"],
	address?:ValueTypes["FieldMeta"],
	publicUrl?:ValueTypes["FieldMeta"],
	billingSubject?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["BillingSubject"]: AliasType<{
	_meta?:ValueTypes["BillingSubjectMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	fullName?:boolean | `@${string}`,
	addressLine1?:boolean | `@${string}`,
	addressLine2?:boolean | `@${string}`,
	city?:boolean | `@${string}`,
	postalCode?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	phone?:boolean | `@${string}`,
	companyName?:boolean | `@${string}`,
	companyIdentifier?:boolean | `@${string}`,
	vatIdentifier?:boolean | `@${string}`,
	externalIdentifier?:boolean | `@${string}`,
	hidden?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	deletedAt?:boolean | `@${string}`,
	note?:boolean | `@${string}`,
	internalNote?:boolean | `@${string}`,
	fakturoidSubjectId?:boolean | `@${string}`,
country?: [{	filter?: ValueTypes["CountryWhere"] | undefined | null},ValueTypes["Country"]],
customer?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
invoices?: [{	filter?: ValueTypes["InvoiceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InvoiceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Invoice"]],
defaultBillingSubjectOfCustomer?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
orders?: [{	filter?: ValueTypes["OrderWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Order"]],
invoicesByPublicKey?: [{	by: ValueTypes["BillingSubjectInvoicesByPublicKeyUniqueWhere"],	filter?: ValueTypes["InvoiceWhere"] | undefined | null},ValueTypes["Invoice"]],
invoicesByFakturoidId?: [{	by: ValueTypes["BillingSubjectInvoicesByFakturoidIdUniqueWhere"],	filter?: ValueTypes["InvoiceWhere"] | undefined | null},ValueTypes["Invoice"]],
invoicesByOrderPayments?: [{	by: ValueTypes["BillingSubjectInvoicesByOrderPaymentsUniqueWhere"],	filter?: ValueTypes["InvoiceWhere"] | undefined | null},ValueTypes["Invoice"]],
ordersBySeq?: [{	by: ValueTypes["BillingSubjectOrdersBySeqUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
ordersByDoubleshotLegacyId?: [{	by: ValueTypes["BillingSubjectOrdersByDoubleshotLegacyIdUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
ordersByDoubleShotLegacyNumber?: [{	by: ValueTypes["BillingSubjectOrdersByDoubleShotLegacyNumberUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
ordersByDiscounts?: [{	by: ValueTypes["BillingSubjectOrdersByDiscountsUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
ordersByDelivery?: [{	by: ValueTypes["BillingSubjectOrdersByDeliveryUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
ordersByItems?: [{	by: ValueTypes["BillingSubjectOrdersByItemsUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
ordersByCart?: [{	by: ValueTypes["BillingSubjectOrdersByCartUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
ordersByEvents?: [{	by: ValueTypes["BillingSubjectOrdersByEventsUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
ordersByPriceLines?: [{	by: ValueTypes["BillingSubjectOrdersByPriceLinesUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
ordersByPayments?: [{	by: ValueTypes["BillingSubjectOrdersByPaymentsUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
ordersBySummary?: [{	by: ValueTypes["BillingSubjectOrdersBySummaryUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
ordersByGratuity?: [{	by: ValueTypes["BillingSubjectOrdersByGratuityUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
paginateInvoices?: [{	filter?: ValueTypes["InvoiceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InvoiceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["InvoiceConnection"]],
paginateOrders?: [{	filter?: ValueTypes["OrderWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["BillingSubjectMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	fullName?:ValueTypes["FieldMeta"],
	addressLine1?:ValueTypes["FieldMeta"],
	addressLine2?:ValueTypes["FieldMeta"],
	city?:ValueTypes["FieldMeta"],
	postalCode?:ValueTypes["FieldMeta"],
	email?:ValueTypes["FieldMeta"],
	phone?:ValueTypes["FieldMeta"],
	companyName?:ValueTypes["FieldMeta"],
	companyIdentifier?:ValueTypes["FieldMeta"],
	vatIdentifier?:ValueTypes["FieldMeta"],
	externalIdentifier?:ValueTypes["FieldMeta"],
	hidden?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	deletedAt?:ValueTypes["FieldMeta"],
	note?:ValueTypes["FieldMeta"],
	internalNote?:ValueTypes["FieldMeta"],
	fakturoidSubjectId?:ValueTypes["FieldMeta"],
	country?:ValueTypes["FieldMeta"],
	customer?:ValueTypes["FieldMeta"],
	invoices?:ValueTypes["FieldMeta"],
	defaultBillingSubjectOfCustomer?:ValueTypes["FieldMeta"],
	orders?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Country"]: AliasType<{
	_meta?:ValueTypes["CountryMeta"],
	id?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CountryMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	code?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["BillingSubjectInvoicesByPublicKeyUniqueWhere"]: {
	publicKey?: string | undefined | null
};
	["BillingSubjectInvoicesByFakturoidIdUniqueWhere"]: {
	fakturoidId?: string | undefined | null
};
	["BillingSubjectInvoicesByOrderPaymentsUniqueWhere"]: {
	orderPayments?: ValueTypes["OrderPaymentUniqueWhere"] | undefined | null
};
	["BillingSubjectOrdersBySeqUniqueWhere"]: {
	seq?: number | undefined | null
};
	["BillingSubjectOrdersByDoubleshotLegacyIdUniqueWhere"]: {
	doubleshotLegacyId?: string | undefined | null
};
	["BillingSubjectOrdersByDoubleShotLegacyNumberUniqueWhere"]: {
	doubleShotLegacyNumber?: string | undefined | null
};
	["BillingSubjectOrdersByDiscountsUniqueWhere"]: {
	discounts?: ValueTypes["OrderDiscountUniqueWhere"] | undefined | null
};
	["BillingSubjectOrdersByDeliveryUniqueWhere"]: {
	delivery?: ValueTypes["OrderDeliveryUniqueWhere"] | undefined | null
};
	["BillingSubjectOrdersByItemsUniqueWhere"]: {
	items?: ValueTypes["OrderItemUniqueWhere"] | undefined | null
};
	["BillingSubjectOrdersByCartUniqueWhere"]: {
	cart?: ValueTypes["CartUniqueWhere"] | undefined | null
};
	["BillingSubjectOrdersByEventsUniqueWhere"]: {
	events?: ValueTypes["OrderEventUniqueWhere"] | undefined | null
};
	["BillingSubjectOrdersByPriceLinesUniqueWhere"]: {
	priceLines?: ValueTypes["OrderPriceLineUniqueWhere"] | undefined | null
};
	["BillingSubjectOrdersByPaymentsUniqueWhere"]: {
	payments?: ValueTypes["OrderPaymentUniqueWhere"] | undefined | null
};
	["BillingSubjectOrdersBySummaryUniqueWhere"]: {
	summary?: ValueTypes["OrderSummaryUniqueWhere"] | undefined | null
};
	["BillingSubjectOrdersByGratuityUniqueWhere"]: {
	gratuity?: ValueTypes["GratuityUniqueWhere"] | undefined | null
};
	["InvoiceConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["InvoiceEdge"],
		__typename?: boolean | `@${string}`
}>;
	["InvoiceEdge"]: AliasType<{
	node?:ValueTypes["Invoice"],
		__typename?: boolean | `@${string}`
}>;
	["OrderConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["OrderEdge"],
		__typename?: boolean | `@${string}`
}>;
	["OrderEdge"]: AliasType<{
	node?:ValueTypes["Order"],
		__typename?: boolean | `@${string}`
}>;
	["InvoiceOrderPaymentsByEventsUniqueWhere"]: {
	events?: ValueTypes["OrderEventUniqueWhere"] | undefined | null
};
	["InvoiceOrderPaymentsByMetaUniqueWhere"]: {
	meta?: ValueTypes["OrderPaymentMetadataUniqueWhere"] | undefined | null
};
	["OrderPaymentConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["OrderPaymentEdge"],
		__typename?: boolean | `@${string}`
}>;
	["OrderPaymentEdge"]: AliasType<{
	node?:ValueTypes["OrderPayment"],
		__typename?: boolean | `@${string}`
}>;
	["OrderPaymentMetadata"]: AliasType<{
	_meta?:ValueTypes["OrderPaymentMetadataMeta"],
	id?:boolean | `@${string}`,
	paymentUrl?:boolean | `@${string}`,
orderPayment?: [{	filter?: ValueTypes["OrderPaymentWhere"] | undefined | null},ValueTypes["OrderPayment"]],
		__typename?: boolean | `@${string}`
}>;
	["OrderPaymentMetadataMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	paymentUrl?:ValueTypes["FieldMeta"],
	orderPayment?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["OrderEventConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["OrderEventEdge"],
		__typename?: boolean | `@${string}`
}>;
	["OrderEventEdge"]: AliasType<{
	node?:ValueTypes["OrderEvent"],
		__typename?: boolean | `@${string}`
}>;
	["OrderPriceLine"]: AliasType<{
	_meta?:ValueTypes["OrderPriceLineMeta"],
	id?:boolean | `@${string}`,
	unitPriceCents?:boolean | `@${string}`,
	quantity?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
orderItem?: [{	filter?: ValueTypes["OrderItemWhere"] | undefined | null},ValueTypes["OrderItem"]],
orderDiscount?: [{	filter?: ValueTypes["OrderDiscountWhere"] | undefined | null},ValueTypes["OrderDiscount"]],
orderPayment?: [{	filter?: ValueTypes["OrderPaymentWhere"] | undefined | null},ValueTypes["OrderPayment"]],
orderDelivery?: [{	filter?: ValueTypes["OrderDeliveryWhere"] | undefined | null},ValueTypes["OrderDelivery"]],
	vatRatePermille?:boolean | `@${string}`,
vatRate?: [{	filter?: ValueTypes["VatRateWhere"] | undefined | null},ValueTypes["VatRate"]],
order?: [{	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
		__typename?: boolean | `@${string}`
}>;
	["OrderPriceLineMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unitPriceCents?:ValueTypes["FieldMeta"],
	quantity?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	orderItem?:ValueTypes["FieldMeta"],
	orderDiscount?:ValueTypes["FieldMeta"],
	orderPayment?:ValueTypes["FieldMeta"],
	orderDelivery?:ValueTypes["FieldMeta"],
	vatRatePermille?:ValueTypes["FieldMeta"],
	vatRate?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["OrderPriceLineOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	unitPriceCents?: ValueTypes["OrderDirection"] | undefined | null,
	quantity?: ValueTypes["OrderDirection"] | undefined | null,
	type?: ValueTypes["OrderDirection"] | undefined | null,
	orderItem?: ValueTypes["OrderItemOrderBy"] | undefined | null,
	orderDiscount?: ValueTypes["OrderDiscountOrderBy"] | undefined | null,
	orderPayment?: ValueTypes["OrderPaymentOrderBy"] | undefined | null,
	orderDelivery?: ValueTypes["OrderDeliveryOrderBy"] | undefined | null,
	vatRatePermille?: ValueTypes["OrderDirection"] | undefined | null,
	vatRate?: ValueTypes["VatRateOrderBy"] | undefined | null,
	order?: ValueTypes["OrderOrderBy"] | undefined | null
};
	["OrderSummary"]: AliasType<{
	_meta?:ValueTypes["OrderSummaryMeta"],
	id?:boolean | `@${string}`,
	totalPriceCents?:boolean | `@${string}`,
	discountPriceCents?:boolean | `@${string}`,
	undiscountedPriceCents?:boolean | `@${string}`,
	itemsQuantity?:boolean | `@${string}`,
	orderUrl?:boolean | `@${string}`,
	orderNumber?:boolean | `@${string}`,
order?: [{	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
		__typename?: boolean | `@${string}`
}>;
	["OrderSummaryMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	totalPriceCents?:ValueTypes["FieldMeta"],
	discountPriceCents?:ValueTypes["FieldMeta"],
	undiscountedPriceCents?:ValueTypes["FieldMeta"],
	itemsQuantity?:ValueTypes["FieldMeta"],
	orderUrl?:ValueTypes["FieldMeta"],
	orderNumber?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Gratuity"]: AliasType<{
	_meta?:ValueTypes["GratuityMeta"],
	id?:boolean | `@${string}`,
	amountCents?:boolean | `@${string}`,
order?: [{	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
		__typename?: boolean | `@${string}`
}>;
	["GratuityMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	amountCents?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["OrderDiscountsByCustomerCreditTransactionsUniqueWhere"]: {
	customerCreditTransactions?: ValueTypes["CustomerCreditTransactionUniqueWhere"] | undefined | null
};
	["OrderDiscountsByVoucherRedemptionUniqueWhere"]: {
	voucherRedemption?: ValueTypes["VoucherRedemptionUniqueWhere"] | undefined | null
};
	["OrderItemsByVirtualProductEffectsUniqueWhere"]: {
	virtualProductEffects?: ValueTypes["VirtualProductEffectUniqueWhere"] | undefined | null
};
	["OrderPriceLinesByOrderItemUniqueWhere"]: {
	orderItem?: ValueTypes["OrderItemUniqueWhere"] | undefined | null
};
	["OrderPriceLinesByOrderDiscountUniqueWhere"]: {
	orderDiscount?: ValueTypes["OrderDiscountUniqueWhere"] | undefined | null
};
	["OrderPriceLinesByOrderPaymentUniqueWhere"]: {
	orderPayment?: ValueTypes["OrderPaymentUniqueWhere"] | undefined | null
};
	["OrderPriceLinesByOrderDeliveryUniqueWhere"]: {
	orderDelivery?: ValueTypes["OrderDeliveryUniqueWhere"] | undefined | null
};
	["OrderPaymentsByEventsUniqueWhere"]: {
	events?: ValueTypes["OrderEventUniqueWhere"] | undefined | null
};
	["OrderPaymentsByMetaUniqueWhere"]: {
	meta?: ValueTypes["OrderPaymentMetadataUniqueWhere"] | undefined | null
};
	["OrderDiscountConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["OrderDiscountEdge"],
		__typename?: boolean | `@${string}`
}>;
	["OrderDiscountEdge"]: AliasType<{
	node?:ValueTypes["OrderDiscount"],
		__typename?: boolean | `@${string}`
}>;
	["OrderItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["OrderItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["OrderItemEdge"]: AliasType<{
	node?:ValueTypes["OrderItem"],
		__typename?: boolean | `@${string}`
}>;
	["OrderPriceLineConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["OrderPriceLineEdge"],
		__typename?: boolean | `@${string}`
}>;
	["OrderPriceLineEdge"]: AliasType<{
	node?:ValueTypes["OrderPriceLine"],
		__typename?: boolean | `@${string}`
}>;
	["Area"]: AliasType<{
	_meta?:ValueTypes["AreaMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
venue?: [{	filter?: ValueTypes["VenueWhere"] | undefined | null},ValueTypes["Venue"]],
tables?: [{	filter?: ValueTypes["TableWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TableOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Table"]],
lines?: [{	filter?: ValueTypes["LineWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LineOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Line"]],
tablesByCustomerTabs?: [{	by: ValueTypes["AreaTablesByCustomerTabsUniqueWhere"],	filter?: ValueTypes["TableWhere"] | undefined | null},ValueTypes["Table"]],
tablesBySeats?: [{	by: ValueTypes["AreaTablesBySeatsUniqueWhere"],	filter?: ValueTypes["TableWhere"] | undefined | null},ValueTypes["Table"]],
paginateTables?: [{	filter?: ValueTypes["TableWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TableOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TableConnection"]],
paginateLines?: [{	filter?: ValueTypes["LineWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LineOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["LineConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["AreaMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	venue?:ValueTypes["FieldMeta"],
	tables?:ValueTypes["FieldMeta"],
	lines?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Table"]: AliasType<{
	_meta?:ValueTypes["TableMeta"],
	id?:boolean | `@${string}`,
	shape?:boolean | `@${string}`,
	width?:boolean | `@${string}`,
	height?:boolean | `@${string}`,
	positionX?:boolean | `@${string}`,
	positionY?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	color?:boolean | `@${string}`,
customerTabs?: [{	filter?: ValueTypes["CustomerTabWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerTabOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CustomerTab"]],
area?: [{	filter?: ValueTypes["AreaWhere"] | undefined | null},ValueTypes["Area"]],
seats?: [{	filter?: ValueTypes["SeatWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SeatOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Seat"]],
customerTabsByItems?: [{	by: ValueTypes["TableCustomerTabsByItemsUniqueWhere"],	filter?: ValueTypes["CustomerTabWhere"] | undefined | null},ValueTypes["CustomerTab"]],
customerTabsByMeta?: [{	by: ValueTypes["TableCustomerTabsByMetaUniqueWhere"],	filter?: ValueTypes["CustomerTabWhere"] | undefined | null},ValueTypes["CustomerTab"]],
seatsByCustomerTabs?: [{	by: ValueTypes["TableSeatsByCustomerTabsUniqueWhere"],	filter?: ValueTypes["SeatWhere"] | undefined | null},ValueTypes["Seat"]],
paginateCustomerTabs?: [{	filter?: ValueTypes["CustomerTabWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerTabOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerTabConnection"]],
paginateSeats?: [{	filter?: ValueTypes["SeatWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SeatOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["SeatConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["TableMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	shape?:ValueTypes["FieldMeta"],
	width?:ValueTypes["FieldMeta"],
	height?:ValueTypes["FieldMeta"],
	positionX?:ValueTypes["FieldMeta"],
	positionY?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	color?:ValueTypes["FieldMeta"],
	customerTabs?:ValueTypes["FieldMeta"],
	area?:ValueTypes["FieldMeta"],
	seats?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerTab"]: AliasType<{
	_meta?:ValueTypes["CustomerTabMeta"],
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	color?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["CustomerTabItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerTabItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CustomerTabItem"]],
	name?:boolean | `@${string}`,
meta?: [{	filter?: ValueTypes["CustomerTabMetadataWhere"] | undefined | null},ValueTypes["CustomerTabMetadata"]],
customer?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
table?: [{	filter?: ValueTypes["TableWhere"] | undefined | null},ValueTypes["Table"]],
seat?: [{	filter?: ValueTypes["SeatWhere"] | undefined | null},ValueTypes["Seat"]],
paginateItems?: [{	filter?: ValueTypes["CustomerTabItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerTabItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerTabItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["CustomerTabMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	color?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	meta?:ValueTypes["FieldMeta"],
	customer?:ValueTypes["FieldMeta"],
	table?:ValueTypes["FieldMeta"],
	seat?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerTabItem"]: AliasType<{
	_meta?:ValueTypes["CustomerTabItemMeta"],
	id?:boolean | `@${string}`,
	addedAt?:boolean | `@${string}`,
tab?: [{	filter?: ValueTypes["CustomerTabWhere"] | undefined | null},ValueTypes["CustomerTab"]],
product?: [{	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
	paidAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CustomerTabItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	addedAt?:ValueTypes["FieldMeta"],
	tab?:ValueTypes["FieldMeta"],
	product?:ValueTypes["FieldMeta"],
	paidAt?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerTabItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	addedAt?: ValueTypes["OrderDirection"] | undefined | null,
	tab?: ValueTypes["CustomerTabOrderBy"] | undefined | null,
	product?: ValueTypes["ProductOrderBy"] | undefined | null,
	paidAt?: ValueTypes["OrderDirection"] | undefined | null
};
	["CustomerTabOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null,
	color?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	meta?: ValueTypes["CustomerTabMetadataOrderBy"] | undefined | null,
	customer?: ValueTypes["CustomerOrderBy"] | undefined | null,
	table?: ValueTypes["TableOrderBy"] | undefined | null,
	seat?: ValueTypes["SeatOrderBy"] | undefined | null
};
	["CustomerTabMetadataOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	totalPriceCents?: ValueTypes["OrderDirection"] | undefined | null,
	totalSpentCents?: ValueTypes["OrderDirection"] | undefined | null,
	unpaidCents?: ValueTypes["OrderDirection"] | undefined | null,
	customerTab?: ValueTypes["CustomerTabOrderBy"] | undefined | null
};
	["TableOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	shape?: ValueTypes["OrderDirection"] | undefined | null,
	width?: ValueTypes["OrderDirection"] | undefined | null,
	height?: ValueTypes["OrderDirection"] | undefined | null,
	positionX?: ValueTypes["OrderDirection"] | undefined | null,
	positionY?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	color?: ValueTypes["OrderDirection"] | undefined | null,
	area?: ValueTypes["AreaOrderBy"] | undefined | null
};
	["AreaOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	venue?: ValueTypes["VenueOrderBy"] | undefined | null
};
	["SeatOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	positionX?: ValueTypes["OrderDirection"] | undefined | null,
	positionY?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	color?: ValueTypes["OrderDirection"] | undefined | null,
	table?: ValueTypes["TableOrderBy"] | undefined | null
};
	["CustomerTabMetadata"]: AliasType<{
	_meta?:ValueTypes["CustomerTabMetadataMeta"],
	id?:boolean | `@${string}`,
	totalPriceCents?:boolean | `@${string}`,
	totalSpentCents?:boolean | `@${string}`,
	unpaidCents?:boolean | `@${string}`,
customerTab?: [{	filter?: ValueTypes["CustomerTabWhere"] | undefined | null},ValueTypes["CustomerTab"]],
		__typename?: boolean | `@${string}`
}>;
	["CustomerTabMetadataMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	totalPriceCents?:ValueTypes["FieldMeta"],
	totalSpentCents?:ValueTypes["FieldMeta"],
	unpaidCents?:ValueTypes["FieldMeta"],
	customerTab?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Seat"]: AliasType<{
	_meta?:ValueTypes["SeatMeta"],
	id?:boolean | `@${string}`,
	positionX?:boolean | `@${string}`,
	positionY?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	color?:boolean | `@${string}`,
customerTabs?: [{	filter?: ValueTypes["CustomerTabWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerTabOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CustomerTab"]],
table?: [{	filter?: ValueTypes["TableWhere"] | undefined | null},ValueTypes["Table"]],
customerTabsByItems?: [{	by: ValueTypes["SeatCustomerTabsByItemsUniqueWhere"],	filter?: ValueTypes["CustomerTabWhere"] | undefined | null},ValueTypes["CustomerTab"]],
customerTabsByMeta?: [{	by: ValueTypes["SeatCustomerTabsByMetaUniqueWhere"],	filter?: ValueTypes["CustomerTabWhere"] | undefined | null},ValueTypes["CustomerTab"]],
paginateCustomerTabs?: [{	filter?: ValueTypes["CustomerTabWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerTabOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerTabConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["SeatMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	positionX?:ValueTypes["FieldMeta"],
	positionY?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	color?:ValueTypes["FieldMeta"],
	customerTabs?:ValueTypes["FieldMeta"],
	table?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["SeatCustomerTabsByItemsUniqueWhere"]: {
	items?: ValueTypes["CustomerTabItemUniqueWhere"] | undefined | null
};
	["SeatCustomerTabsByMetaUniqueWhere"]: {
	meta?: ValueTypes["CustomerTabMetadataUniqueWhere"] | undefined | null
};
	["CustomerTabConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CustomerTabEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerTabEdge"]: AliasType<{
	node?:ValueTypes["CustomerTab"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerTabItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CustomerTabItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerTabItemEdge"]: AliasType<{
	node?:ValueTypes["CustomerTabItem"],
		__typename?: boolean | `@${string}`
}>;
	["TableCustomerTabsByItemsUniqueWhere"]: {
	items?: ValueTypes["CustomerTabItemUniqueWhere"] | undefined | null
};
	["TableCustomerTabsByMetaUniqueWhere"]: {
	meta?: ValueTypes["CustomerTabMetadataUniqueWhere"] | undefined | null
};
	["TableSeatsByCustomerTabsUniqueWhere"]: {
	customerTabs?: ValueTypes["CustomerTabUniqueWhere"] | undefined | null
};
	["SeatConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SeatEdge"],
		__typename?: boolean | `@${string}`
}>;
	["SeatEdge"]: AliasType<{
	node?:ValueTypes["Seat"],
		__typename?: boolean | `@${string}`
}>;
	["Line"]: AliasType<{
	_meta?:ValueTypes["LineMeta"],
	id?:boolean | `@${string}`,
	positionStartX?:boolean | `@${string}`,
	positionStartY?:boolean | `@${string}`,
	positionEndX?:boolean | `@${string}`,
	positionEndY?:boolean | `@${string}`,
area?: [{	filter?: ValueTypes["AreaWhere"] | undefined | null},ValueTypes["Area"]],
		__typename?: boolean | `@${string}`
}>;
	["LineMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	positionStartX?:ValueTypes["FieldMeta"],
	positionStartY?:ValueTypes["FieldMeta"],
	positionEndX?:ValueTypes["FieldMeta"],
	positionEndY?:ValueTypes["FieldMeta"],
	area?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["LineOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	positionStartX?: ValueTypes["OrderDirection"] | undefined | null,
	positionStartY?: ValueTypes["OrderDirection"] | undefined | null,
	positionEndX?: ValueTypes["OrderDirection"] | undefined | null,
	positionEndY?: ValueTypes["OrderDirection"] | undefined | null,
	area?: ValueTypes["AreaOrderBy"] | undefined | null
};
	["AreaTablesByCustomerTabsUniqueWhere"]: {
	customerTabs?: ValueTypes["CustomerTabUniqueWhere"] | undefined | null
};
	["AreaTablesBySeatsUniqueWhere"]: {
	seats?: ValueTypes["SeatUniqueWhere"] | undefined | null
};
	["SeatUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	customerTabs?: ValueTypes["CustomerTabUniqueWhere"] | undefined | null
};
	["TableConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TableEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TableEdge"]: AliasType<{
	node?:ValueTypes["Table"],
		__typename?: boolean | `@${string}`
}>;
	["LineConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LineEdge"],
		__typename?: boolean | `@${string}`
}>;
	["LineEdge"]: AliasType<{
	node?:ValueTypes["Line"],
		__typename?: boolean | `@${string}`
}>;
	["VenueTimetableDaysByDateUniqueWhere"]: {
	date?: ValueTypes["Date"] | undefined | null
};
	["VenueTimetableDaysByShiftGroupsUniqueWhere"]: {
	shiftGroups?: ValueTypes["TimetableShiftGroupUniqueWhere"] | undefined | null
};
	["VenueTimetableDaysByNotesUniqueWhere"]: {
	notes?: ValueTypes["TimetableDayNoteUniqueWhere"] | undefined | null
};
	["TimetableDayNoteUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["VenueTimetableDaysByMetaUniqueWhere"]: {
	meta?: ValueTypes["TimetableDayMetadataUniqueWhere"] | undefined | null
};
	["TimetableDayMetadataUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	day?: ValueTypes["TimetableDayUniqueWhere"] | undefined | null
};
	["TimetableDayUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	venue?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	date?: ValueTypes["Date"] | undefined | null,
	shiftGroups?: ValueTypes["TimetableShiftGroupUniqueWhere"] | undefined | null,
	notes?: ValueTypes["TimetableDayNoteUniqueWhere"] | undefined | null,
	meta?: ValueTypes["TimetableDayMetadataUniqueWhere"] | undefined | null
};
	["VenueUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	deadlineTemplate?: ValueTypes["DeadlineTemplateUniqueWhere"] | undefined | null,
	timetableDays?: ValueTypes["TimetableDayUniqueWhere"] | undefined | null,
	timetableTemplates?: ValueTypes["TimetableTemplateUniqueWhere"] | undefined | null,
	employeeRoles?: ValueTypes["VenueEmployeeRoleUniqueWhere"] | undefined | null,
	pointOfSaleApplicationDevices?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null,
	pointOfSaleTerminals?: ValueTypes["PointOfSaleTerminalUniqueWhere"] | undefined | null,
	pointOfSalePrinters?: ValueTypes["PointOfSalePrinterUniqueWhere"] | undefined | null,
	orders?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	areas?: ValueTypes["AreaUniqueWhere"] | undefined | null,
	categories?: ValueTypes["PointOfSaleCategoryUniqueWhere"] | undefined | null,
	channels?: ValueTypes["ChannelUniqueWhere"] | undefined | null
};
	["DeadlineTemplateUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	venue?: ValueTypes["VenueUniqueWhere"] | undefined | null
};
	["TimetableTemplateUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	staffOptions?: ValueTypes["TimetableTemplateStaffOptionsUniqueWhere"] | undefined | null
};
	["VenueEmployeeRoleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	venue?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	role?: ValueTypes["TimetableEmployeeRoleUniqueWhere"] | undefined | null,
	employeePrivileges?: ValueTypes["TimetablesEmployeePrivilegesUniqueWhere"] | undefined | null
};
	["TimetableEmployeeRoleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	shiftGroups?: ValueTypes["TimetableShiftGroupUniqueWhere"] | undefined | null,
	timetableTemplates?: ValueTypes["TimetableTemplateUniqueWhere"] | undefined | null
};
	["TimetablesEmployeePrivilegesUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	venueEmployeeRole?: ValueTypes["VenueEmployeeRoleUniqueWhere"] | undefined | null
};
	["PointOfSaleTerminalUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	applicationDevices?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null
};
	["PointOfSalePrinterUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	applicationDevicesReceipt?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null
};
	["AreaUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	tables?: ValueTypes["TableUniqueWhere"] | undefined | null,
	lines?: ValueTypes["LineUniqueWhere"] | undefined | null
};
	["TableUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	customerTabs?: ValueTypes["CustomerTabUniqueWhere"] | undefined | null,
	seats?: ValueTypes["SeatUniqueWhere"] | undefined | null
};
	["LineUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["ChannelUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	code?: ValueTypes["ChannelCode"] | undefined | null,
	payments?: ValueTypes["ChannelPaymentUniqueWhere"] | undefined | null,
	deliveries?: ValueTypes["ChannelDeliveryUniqueWhere"] | undefined | null,
	carts?: ValueTypes["CartUniqueWhere"] | undefined | null
};
	["ChannelPaymentUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["VenueTimetableTemplatesByStaffOptionsUniqueWhere"]: {
	staffOptions?: ValueTypes["TimetableTemplateStaffOptionsUniqueWhere"] | undefined | null
};
	["VenueEmployeeRolesByRoleUniqueWhere"]: {
	role?: ValueTypes["TimetableEmployeeRoleUniqueWhere"] | undefined | null
};
	["VenueEmployeeRolesByEmployeePrivilegesUniqueWhere"]: {
	employeePrivileges?: ValueTypes["TimetablesEmployeePrivilegesUniqueWhere"] | undefined | null
};
	["VenuePointOfSaleApplicationDevicesByIdentifierUniqueWhere"]: {
	identifier?: ValueTypes["DeviceIdentifierUniqueWhere"] | undefined | null
};
	["VenuePointOfSaleTerminalsByApplicationDevicesUniqueWhere"]: {
	applicationDevices?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null
};
	["VenuePointOfSalePrintersByApplicationDevicesReceiptUniqueWhere"]: {
	applicationDevicesReceipt?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null
};
	["VenueOrdersBySeqUniqueWhere"]: {
	seq?: number | undefined | null
};
	["VenueOrdersByDoubleshotLegacyIdUniqueWhere"]: {
	doubleshotLegacyId?: string | undefined | null
};
	["VenueOrdersByDoubleShotLegacyNumberUniqueWhere"]: {
	doubleShotLegacyNumber?: string | undefined | null
};
	["VenueOrdersByDiscountsUniqueWhere"]: {
	discounts?: ValueTypes["OrderDiscountUniqueWhere"] | undefined | null
};
	["VenueOrdersByDeliveryUniqueWhere"]: {
	delivery?: ValueTypes["OrderDeliveryUniqueWhere"] | undefined | null
};
	["VenueOrdersByItemsUniqueWhere"]: {
	items?: ValueTypes["OrderItemUniqueWhere"] | undefined | null
};
	["VenueOrdersByCartUniqueWhere"]: {
	cart?: ValueTypes["CartUniqueWhere"] | undefined | null
};
	["VenueOrdersByEventsUniqueWhere"]: {
	events?: ValueTypes["OrderEventUniqueWhere"] | undefined | null
};
	["VenueOrdersByPriceLinesUniqueWhere"]: {
	priceLines?: ValueTypes["OrderPriceLineUniqueWhere"] | undefined | null
};
	["VenueOrdersByPaymentsUniqueWhere"]: {
	payments?: ValueTypes["OrderPaymentUniqueWhere"] | undefined | null
};
	["VenueOrdersBySummaryUniqueWhere"]: {
	summary?: ValueTypes["OrderSummaryUniqueWhere"] | undefined | null
};
	["VenueOrdersByGratuityUniqueWhere"]: {
	gratuity?: ValueTypes["GratuityUniqueWhere"] | undefined | null
};
	["VenueAreasByTablesUniqueWhere"]: {
	tables?: ValueTypes["TableUniqueWhere"] | undefined | null
};
	["VenueAreasByLinesUniqueWhere"]: {
	lines?: ValueTypes["LineUniqueWhere"] | undefined | null
};
	["VenueCategoriesBySlugUniqueWhere"]: {
	slug?: string | undefined | null
};
	["VenueCategoriesByLocalesUniqueWhere"]: {
	locales?: ValueTypes["PointOfSaleCategoryLocaleUniqueWhere"] | undefined | null
};
	["VenueCategoriesByProductsUniqueWhere"]: {
	products?: ValueTypes["PointOfSaleCategoryProductUniqueWhere"] | undefined | null
};
	["VenueChannelsByCodeUniqueWhere"]: {
	code?: ValueTypes["ChannelCode"] | undefined | null
};
	["VenueChannelsByPaymentsUniqueWhere"]: {
	payments?: ValueTypes["ChannelPaymentUniqueWhere"] | undefined | null
};
	["VenueChannelsByDeliveriesUniqueWhere"]: {
	deliveries?: ValueTypes["ChannelDeliveryUniqueWhere"] | undefined | null
};
	["VenueChannelsByCartsUniqueWhere"]: {
	carts?: ValueTypes["CartUniqueWhere"] | undefined | null
};
	["TimetableDayConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TimetableDayEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableDayEdge"]: AliasType<{
	node?:ValueTypes["TimetableDay"],
		__typename?: boolean | `@${string}`
}>;
	["StaffConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["StaffEdge"],
		__typename?: boolean | `@${string}`
}>;
	["StaffEdge"]: AliasType<{
	node?:ValueTypes["Staff"],
		__typename?: boolean | `@${string}`
}>;
	["VenueEmployeeRoleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["VenueEmployeeRoleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["VenueEmployeeRoleEdge"]: AliasType<{
	node?:ValueTypes["VenueEmployeeRole"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleTerminalConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PointOfSaleTerminalEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleTerminalEdge"]: AliasType<{
	node?:ValueTypes["PointOfSaleTerminal"],
		__typename?: boolean | `@${string}`
}>;
	["AreaConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["AreaEdge"],
		__typename?: boolean | `@${string}`
}>;
	["AreaEdge"]: AliasType<{
	node?:ValueTypes["Area"],
		__typename?: boolean | `@${string}`
}>;
	["UnassignReasonConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["UnassignReasonEdge"],
		__typename?: boolean | `@${string}`
}>;
	["UnassignReasonEdge"]: AliasType<{
	node?:ValueTypes["UnassignReason"],
		__typename?: boolean | `@${string}`
}>;
	["CartItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	quantity?: ValueTypes["OrderDirection"] | undefined | null,
	cart?: ValueTypes["CartOrderBy"] | undefined | null,
	product?: ValueTypes["ProductOrderBy"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null,
	updatedAt?: ValueTypes["OrderDirection"] | undefined | null,
	fulfillmentNote?: ValueTypes["OrderDirection"] | undefined | null
};
	["CartItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CartItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CartItemEdge"]: AliasType<{
	node?:ValueTypes["CartItem"],
		__typename?: boolean | `@${string}`
}>;
	["CartPriceLine"]: AliasType<{
	_meta?:ValueTypes["CartPriceLineMeta"],
	id?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
item?: [{	filter?: ValueTypes["CartItemWhere"] | undefined | null},ValueTypes["CartItem"]],
product?: [{	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
	unitPriceCents?:boolean | `@${string}`,
	priceCents?:boolean | `@${string}`,
	quantity?:boolean | `@${string}`,
	vatRatePermille?:boolean | `@${string}`,
vatRate?: [{	filter?: ValueTypes["VatRateWhere"] | undefined | null},ValueTypes["VatRate"]],
cart?: [{	filter?: ValueTypes["CartWhere"] | undefined | null},ValueTypes["Cart"]],
		__typename?: boolean | `@${string}`
}>;
	["CartPriceLineMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	item?:ValueTypes["FieldMeta"],
	product?:ValueTypes["FieldMeta"],
	unitPriceCents?:ValueTypes["FieldMeta"],
	priceCents?:ValueTypes["FieldMeta"],
	quantity?:ValueTypes["FieldMeta"],
	vatRatePermille?:ValueTypes["FieldMeta"],
	vatRate?:ValueTypes["FieldMeta"],
	cart?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["CartPriceLineOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	type?: ValueTypes["OrderDirection"] | undefined | null,
	item?: ValueTypes["CartItemOrderBy"] | undefined | null,
	product?: ValueTypes["ProductOrderBy"] | undefined | null,
	unitPriceCents?: ValueTypes["OrderDirection"] | undefined | null,
	priceCents?: ValueTypes["OrderDirection"] | undefined | null,
	quantity?: ValueTypes["OrderDirection"] | undefined | null,
	vatRatePermille?: ValueTypes["OrderDirection"] | undefined | null,
	vatRate?: ValueTypes["VatRateOrderBy"] | undefined | null,
	cart?: ValueTypes["CartOrderBy"] | undefined | null
};
	["CartSummary"]: AliasType<{
	_meta?:ValueTypes["CartSummaryMeta"],
	id?:boolean | `@${string}`,
	itemsPriceCents?:boolean | `@${string}`,
	deliveryPriceCents?:boolean | `@${string}`,
	totalPriceCents?:boolean | `@${string}`,
	itemsCount?:boolean | `@${string}`,
	itemsQuantity?:boolean | `@${string}`,
	checkoutUrl?:boolean | `@${string}`,
cart?: [{	filter?: ValueTypes["CartWhere"] | undefined | null},ValueTypes["Cart"]],
		__typename?: boolean | `@${string}`
}>;
	["CartSummaryMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	itemsPriceCents?:ValueTypes["FieldMeta"],
	deliveryPriceCents?:ValueTypes["FieldMeta"],
	totalPriceCents?:ValueTypes["FieldMeta"],
	itemsCount?:ValueTypes["FieldMeta"],
	itemsQuantity?:ValueTypes["FieldMeta"],
	checkoutUrl?:ValueTypes["FieldMeta"],
	cart?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["CartItemsByProductUniqueWhere"]: {
	product?: ValueTypes["ProductUniqueWhere"] | undefined | null
};
	["CartPriceLineConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CartPriceLineEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CartPriceLineEdge"]: AliasType<{
	node?:ValueTypes["CartPriceLine"],
		__typename?: boolean | `@${string}`
}>;
	["ChannelCartsByItemsUniqueWhere"]: {
	items?: ValueTypes["CartItemUniqueWhere"] | undefined | null
};
	["ChannelCartsByOrderUniqueWhere"]: {
	order?: ValueTypes["OrderUniqueWhere"] | undefined | null
};
	["ChannelCartsByPriceLinesUniqueWhere"]: {
	priceLines?: ValueTypes["CartPriceLineUniqueWhere"] | undefined | null
};
	["ChannelCartsBySummaryUniqueWhere"]: {
	summary?: ValueTypes["CartSummaryUniqueWhere"] | undefined | null
};
	["ChannelPaymentConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ChannelPaymentEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ChannelPaymentEdge"]: AliasType<{
	node?:ValueTypes["ChannelPayment"],
		__typename?: boolean | `@${string}`
}>;
	["ChannelDeliveryConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ChannelDeliveryEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ChannelDeliveryEdge"]: AliasType<{
	node?:ValueTypes["ChannelDelivery"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PointOfSaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleEdge"]: AliasType<{
	node?:ValueTypes["PointOfSale"],
		__typename?: boolean | `@${string}`
}>;
	["CartConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CartEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CartEdge"]: AliasType<{
	node?:ValueTypes["Cart"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CustomerEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerEdge"]: AliasType<{
	node?:ValueTypes["Customer"],
		__typename?: boolean | `@${string}`
}>;
	["LiftagoRide"]: AliasType<{
	_meta?:ValueTypes["LiftagoRideMeta"],
	id?:boolean | `@${string}`,
	liftagoId?:boolean | `@${string}`,
	data?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
delivery?: [{	filter?: ValueTypes["OrderDeliveryWhere"] | undefined | null},ValueTypes["OrderDelivery"]],
		__typename?: boolean | `@${string}`
}>;
	["LiftagoRideMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	liftagoId?:ValueTypes["FieldMeta"],
	data?:ValueTypes["FieldMeta"],
	updatedAt?:ValueTypes["FieldMeta"],
	delivery?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["WoltDriveDelivery"]: AliasType<{
	_meta?:ValueTypes["WoltDriveDeliveryMeta"],
	id?:boolean | `@${string}`,
	state?:boolean | `@${string}`,
	shipmentPromiseId?:boolean | `@${string}`,
	deliveryPrice?:boolean | `@${string}`,
	deliveryPriceCurrency?:boolean | `@${string}`,
	shipmentPromiseResponse?:boolean | `@${string}`,
	deliveryOrderId?:boolean | `@${string}`,
	trackingUrl?:boolean | `@${string}`,
	deliverOrderResponse?:boolean | `@${string}`,
delivery?: [{	filter?: ValueTypes["OrderDeliveryWhere"] | undefined | null},ValueTypes["OrderDelivery"]],
		__typename?: boolean | `@${string}`
}>;
	["WoltDriveDeliveryMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	state?:ValueTypes["FieldMeta"],
	shipmentPromiseId?:ValueTypes["FieldMeta"],
	deliveryPrice?:ValueTypes["FieldMeta"],
	deliveryPriceCurrency?:ValueTypes["FieldMeta"],
	shipmentPromiseResponse?:ValueTypes["FieldMeta"],
	deliveryOrderId?:ValueTypes["FieldMeta"],
	trackingUrl?:ValueTypes["FieldMeta"],
	deliverOrderResponse?:ValueTypes["FieldMeta"],
	delivery?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryRouteWaypointsByDeliveryUniqueWhere"]: {
	delivery?: ValueTypes["OrderDeliveryUniqueWhere"] | undefined | null
};
	["DeliveryWaypointConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["DeliveryWaypointEdge"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryWaypointEdge"]: AliasType<{
	node?:ValueTypes["DeliveryWaypoint"],
		__typename?: boolean | `@${string}`
}>;
	["CourierRoutesByWaypointsUniqueWhere"]: {
	waypoints?: ValueTypes["DeliveryWaypointUniqueWhere"] | undefined | null
};
	["DeliveryRouteConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["DeliveryRouteEdge"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryRouteEdge"]: AliasType<{
	node?:ValueTypes["DeliveryRoute"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryMethodConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["DeliveryMethodEdge"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryMethodEdge"]: AliasType<{
	node?:ValueTypes["DeliveryMethod"],
		__typename?: boolean | `@${string}`
}>;
	["Cleaner"]: AliasType<{
	_meta?:ValueTypes["CleanerMeta"],
	id?:boolean | `@${string}`,
staff?: [{	filter?: ValueTypes["StaffWhere"] | undefined | null},ValueTypes["Staff"]],
	canReachTopShelf?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CleanerMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	staff?:ValueTypes["FieldMeta"],
	canReachTopShelf?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["StocksManager"]: AliasType<{
	_meta?:ValueTypes["StocksManagerMeta"],
	id?:boolean | `@${string}`,
staff?: [{	filter?: ValueTypes["StaffWhere"] | undefined | null},ValueTypes["Staff"]],
managedProducts?: [{	filter?: ValueTypes["ProductWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Product"]],
	createdAt?:boolean | `@${string}`,
managedProductsByCode?: [{	by: ValueTypes["StocksManagerManagedProductsByCodeUniqueWhere"],	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
managedProductsByStocks?: [{	by: ValueTypes["StocksManagerManagedProductsByStocksUniqueWhere"],	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
managedProductsByGroupPrices?: [{	by: ValueTypes["StocksManagerManagedProductsByGroupPricesUniqueWhere"],	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
managedProductsByCartItems?: [{	by: ValueTypes["StocksManagerManagedProductsByCartItemsUniqueWhere"],	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
managedProductsByOrderItems?: [{	by: ValueTypes["StocksManagerManagedProductsByOrderItemsUniqueWhere"],	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
managedProductsByInheritedCategories?: [{	by: ValueTypes["StocksManagerManagedProductsByInheritedCategoriesUniqueWhere"],	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
managedProductsByLocales?: [{	by: ValueTypes["StocksManagerManagedProductsByLocalesUniqueWhere"],	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
managedProductsByCustomerPrices?: [{	by: ValueTypes["StocksManagerManagedProductsByCustomerPricesUniqueWhere"],	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
managedProductsByVirtualProduct?: [{	by: ValueTypes["StocksManagerManagedProductsByVirtualProductUniqueWhere"],	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
managedProductsByMeta?: [{	by: ValueTypes["StocksManagerManagedProductsByMetaUniqueWhere"],	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
managedProductsByPage?: [{	by: ValueTypes["StocksManagerManagedProductsByPageUniqueWhere"],	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
managedProductsBySalesDays?: [{	by: ValueTypes["StocksManagerManagedProductsBySalesDaysUniqueWhere"],	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
managedProductsBySalesWeeks?: [{	by: ValueTypes["StocksManagerManagedProductsBySalesWeeksUniqueWhere"],	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
managedProductsBySalesMonths?: [{	by: ValueTypes["StocksManagerManagedProductsBySalesMonthsUniqueWhere"],	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
paginateManagedProducts?: [{	filter?: ValueTypes["ProductWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["StocksManagerMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	staff?:ValueTypes["FieldMeta"],
	managedProducts?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["StocksManagerManagedProductsByCodeUniqueWhere"]: {
	code?: string | undefined | null
};
	["StocksManagerManagedProductsByStocksUniqueWhere"]: {
	stocks?: ValueTypes["ProductStockUniqueWhere"] | undefined | null
};
	["StocksManagerManagedProductsByGroupPricesUniqueWhere"]: {
	groupPrices?: ValueTypes["ProductGroupPriceUniqueWhere"] | undefined | null
};
	["StocksManagerManagedProductsByCartItemsUniqueWhere"]: {
	cartItems?: ValueTypes["CartItemUniqueWhere"] | undefined | null
};
	["StocksManagerManagedProductsByOrderItemsUniqueWhere"]: {
	orderItems?: ValueTypes["OrderItemUniqueWhere"] | undefined | null
};
	["StocksManagerManagedProductsByInheritedCategoriesUniqueWhere"]: {
	inheritedCategories?: ValueTypes["NestedProductCategoryProductUniqueWhere"] | undefined | null
};
	["StocksManagerManagedProductsByLocalesUniqueWhere"]: {
	locales?: ValueTypes["ProductLocaleUniqueWhere"] | undefined | null
};
	["StocksManagerManagedProductsByCustomerPricesUniqueWhere"]: {
	customerPrices?: ValueTypes["ProductCustomerPriceUniqueWhere"] | undefined | null
};
	["StocksManagerManagedProductsByVirtualProductUniqueWhere"]: {
	virtualProduct?: ValueTypes["VirtualProductUniqueWhere"] | undefined | null
};
	["StocksManagerManagedProductsByMetaUniqueWhere"]: {
	meta?: ValueTypes["ProductMetadataUniqueWhere"] | undefined | null
};
	["StocksManagerManagedProductsByPageUniqueWhere"]: {
	page?: ValueTypes["PageUniqueWhere"] | undefined | null
};
	["StocksManagerManagedProductsBySalesDaysUniqueWhere"]: {
	salesDays?: ValueTypes["ProductSalesDayUniqueWhere"] | undefined | null
};
	["StocksManagerManagedProductsBySalesWeeksUniqueWhere"]: {
	salesWeeks?: ValueTypes["ProductSalesWeekUniqueWhere"] | undefined | null
};
	["StocksManagerManagedProductsBySalesMonthsUniqueWhere"]: {
	salesMonths?: ValueTypes["ProductSalesMonthUniqueWhere"] | undefined | null
};
	["CourierManager"]: AliasType<{
	_meta?:ValueTypes["CourierManagerMeta"],
	id?:boolean | `@${string}`,
staff?: [{	filter?: ValueTypes["StaffWhere"] | undefined | null},ValueTypes["Staff"]],
	createdAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CourierManagerMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	staff?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Picker"]: AliasType<{
	_meta?:ValueTypes["PickerMeta"],
	id?:boolean | `@${string}`,
staff?: [{	filter?: ValueTypes["StaffWhere"] | undefined | null},ValueTypes["Staff"]],
	createdAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PickerMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	staff?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["RemunerationProfile"]: AliasType<{
	_meta?:ValueTypes["RemunerationProfileMeta"],
	id?:boolean | `@${string}`,
employmentInformation?: [{	filter?: ValueTypes["EmploymentInformationWhere"] | undefined | null,	orderBy?: Array<ValueTypes["EmploymentInformationOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["EmploymentInformation"]],
workMonths?: [{	filter?: ValueTypes["WorkMonthWhere"] | undefined | null},ValueTypes["WorkMonth"]],
staff?: [{	filter?: ValueTypes["StaffWhere"] | undefined | null},ValueTypes["Staff"]],
paginateEmploymentInformation?: [{	filter?: ValueTypes["EmploymentInformationWhere"] | undefined | null,	orderBy?: Array<ValueTypes["EmploymentInformationOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["EmploymentInformationConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["RemunerationProfileMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	employmentInformation?:ValueTypes["FieldMeta"],
	workMonths?:ValueTypes["FieldMeta"],
	staff?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["EmploymentInformation"]: AliasType<{
	_meta?:ValueTypes["EmploymentInformationMeta"],
	id?:boolean | `@${string}`,
	hourlyRate?:boolean | `@${string}`,
remunerationProfiles?: [{	filter?: ValueTypes["RemunerationProfileWhere"] | undefined | null},ValueTypes["RemunerationProfile"]],
	monthlySalary?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["EmploymentInformationMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	hourlyRate?:ValueTypes["FieldMeta"],
	remunerationProfiles?:ValueTypes["FieldMeta"],
	monthlySalary?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["EmploymentInformationOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	hourlyRate?: ValueTypes["OrderDirection"] | undefined | null,
	remunerationProfiles?: ValueTypes["RemunerationProfileOrderBy"] | undefined | null,
	monthlySalary?: ValueTypes["OrderDirection"] | undefined | null,
	type?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null
};
	["WorkMonth"]: AliasType<{
	_meta?:ValueTypes["WorkMonthMeta"],
	id?:boolean | `@${string}`,
	year?:boolean | `@${string}`,
	month?:boolean | `@${string}`,
	hoursWorked?:boolean | `@${string}`,
	billableHours?:boolean | `@${string}`,
remunerationProfile?: [{	filter?: ValueTypes["RemunerationProfileWhere"] | undefined | null,	orderBy?: Array<ValueTypes["RemunerationProfileOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["RemunerationProfile"]],
remunerationProfileByEmploymentInformation?: [{	by: ValueTypes["WorkMonthRemunerationProfileByEmploymentInformationUniqueWhere"],	filter?: ValueTypes["RemunerationProfileWhere"] | undefined | null},ValueTypes["RemunerationProfile"]],
remunerationProfileByStaff?: [{	by: ValueTypes["WorkMonthRemunerationProfileByStaffUniqueWhere"],	filter?: ValueTypes["RemunerationProfileWhere"] | undefined | null},ValueTypes["RemunerationProfile"]],
paginateRemunerationProfile?: [{	filter?: ValueTypes["RemunerationProfileWhere"] | undefined | null,	orderBy?: Array<ValueTypes["RemunerationProfileOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["RemunerationProfileConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["WorkMonthMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	year?:ValueTypes["FieldMeta"],
	month?:ValueTypes["FieldMeta"],
	hoursWorked?:ValueTypes["FieldMeta"],
	billableHours?:ValueTypes["FieldMeta"],
	remunerationProfile?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["WorkMonthRemunerationProfileByEmploymentInformationUniqueWhere"]: {
	employmentInformation?: ValueTypes["EmploymentInformationUniqueWhere"] | undefined | null
};
	["WorkMonthRemunerationProfileByStaffUniqueWhere"]: {
	staff?: ValueTypes["StaffUniqueWhere"] | undefined | null
};
	["RemunerationProfileConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["RemunerationProfileEdge"],
		__typename?: boolean | `@${string}`
}>;
	["RemunerationProfileEdge"]: AliasType<{
	node?:ValueTypes["RemunerationProfile"],
		__typename?: boolean | `@${string}`
}>;
	["EmploymentInformationConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["EmploymentInformationEdge"],
		__typename?: boolean | `@${string}`
}>;
	["EmploymentInformationEdge"]: AliasType<{
	node?:ValueTypes["EmploymentInformation"],
		__typename?: boolean | `@${string}`
}>;
	["Cashier"]: AliasType<{
	_meta?:ValueTypes["CashierMeta"],
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
staff?: [{	filter?: ValueTypes["StaffWhere"] | undefined | null},ValueTypes["Staff"]],
		__typename?: boolean | `@${string}`
}>;
	["CashierMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	staff?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["InternalBuyer"]: AliasType<{
	_meta?:ValueTypes["InternalBuyerMeta"],
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
staff?: [{	filter?: ValueTypes["StaffWhere"] | undefined | null},ValueTypes["Staff"]],
		__typename?: boolean | `@${string}`
}>;
	["InternalBuyerMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	staff?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["SalesManager"]: AliasType<{
	_meta?:ValueTypes["SalesManagerMeta"],
	id?:boolean | `@${string}`,
staff?: [{	filter?: ValueTypes["StaffWhere"] | undefined | null},ValueTypes["Staff"]],
	createdAt?:boolean | `@${string}`,
countries?: [{	filter?: ValueTypes["CountryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CountryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Country"]],
paginateCountries?: [{	filter?: ValueTypes["CountryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CountryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CountryConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["SalesManagerMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	staff?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	countries?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["CountryConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CountryEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CountryEdge"]: AliasType<{
	node?:ValueTypes["Country"],
		__typename?: boolean | `@${string}`
}>;
	["CashierManager"]: AliasType<{
	_meta?:ValueTypes["CashierManagerMeta"],
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
staff?: [{	filter?: ValueTypes["StaffWhere"] | undefined | null},ValueTypes["Staff"]],
		__typename?: boolean | `@${string}`
}>;
	["CashierManagerMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	staff?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessToBusinessManagerManagedBusinessesByCustomerUniqueWhere"]: {
	customer?: ValueTypes["CustomerUniqueWhere"] | undefined | null
};
	["BusinessToBusinessManagerManagedBusinessesByBusinessServiceEventsUniqueWhere"]: {
	businessServiceEvents?: ValueTypes["BusinessServiceEventUniqueWhere"] | undefined | null
};
	["BusinessToBusinessManagerManagedBusinessesByDoubleshotCoffeeEquipmentUniqueWhere"]: {
	doubleshotCoffeeEquipment?: ValueTypes["DoubleshotCoffeeEquipmentUniqueWhere"] | undefined | null
};
	["BusinessCustomerConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BusinessCustomerEdge"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessCustomerEdge"]: AliasType<{
	node?:ValueTypes["BusinessCustomer"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessServiceEvent"]: AliasType<{
	_meta?:ValueTypes["BusinessServiceEventMeta"],
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	fulfilledAt?:boolean | `@${string}`,
businessCustomer?: [{	filter?: ValueTypes["BusinessCustomerWhere"] | undefined | null},ValueTypes["BusinessCustomer"]],
businessService?: [{	filter?: ValueTypes["BusinessServiceWhere"] | undefined | null},ValueTypes["BusinessService"]],
	filledNumberOfPeople?:boolean | `@${string}`,
	filledInvoiced?:boolean | `@${string}`,
	filledEquipment?:boolean | `@${string}`,
	filledMillTamDem?:boolean | `@${string}`,
	filledSOEspresso?:boolean | `@${string}`,
	filledFilterCoffeeInMenu?:boolean | `@${string}`,
	filledWaterMeterStatus?:boolean | `@${string}`,
	filledServiceAction?:boolean | `@${string}`,
	filledInvoiceIdentifier?:boolean | `@${string}`,
	filledNote?:boolean | `@${string}`,
	filledContact?:boolean | `@${string}`,
	filledPhone?:boolean | `@${string}`,
	filledEmail?:boolean | `@${string}`,
	filledGrindingStonesCondition?:boolean | `@${string}`,
createdBy?: [{	filter?: ValueTypes["StaffWhere"] | undefined | null},ValueTypes["Staff"]],
filledSupervisor?: [{	filter?: ValueTypes["StaffWhere"] | undefined | null},ValueTypes["Staff"]],
		__typename?: boolean | `@${string}`
}>;
	["BusinessServiceEventMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	fulfilledAt?:ValueTypes["FieldMeta"],
	businessCustomer?:ValueTypes["FieldMeta"],
	businessService?:ValueTypes["FieldMeta"],
	filledNumberOfPeople?:ValueTypes["FieldMeta"],
	filledInvoiced?:ValueTypes["FieldMeta"],
	filledEquipment?:ValueTypes["FieldMeta"],
	filledMillTamDem?:ValueTypes["FieldMeta"],
	filledSOEspresso?:ValueTypes["FieldMeta"],
	filledFilterCoffeeInMenu?:ValueTypes["FieldMeta"],
	filledWaterMeterStatus?:ValueTypes["FieldMeta"],
	filledServiceAction?:ValueTypes["FieldMeta"],
	filledInvoiceIdentifier?:ValueTypes["FieldMeta"],
	filledNote?:ValueTypes["FieldMeta"],
	filledContact?:ValueTypes["FieldMeta"],
	filledPhone?:ValueTypes["FieldMeta"],
	filledEmail?:ValueTypes["FieldMeta"],
	filledGrindingStonesCondition?:ValueTypes["FieldMeta"],
	createdBy?:ValueTypes["FieldMeta"],
	filledSupervisor?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessService"]: AliasType<{
	_meta?:ValueTypes["BusinessServiceMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	requireNote?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["BusinessServiceLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessServiceLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BusinessServiceLocale"]],
	requireNumberOfPeople?:boolean | `@${string}`,
	requireInvoiced?:boolean | `@${string}`,
	requireEquipment?:boolean | `@${string}`,
	requireMillTamDem?:boolean | `@${string}`,
	requireSOEspresso?:boolean | `@${string}`,
	requireFilterCoffeeInMenu?:boolean | `@${string}`,
	requireWaterMeterStatus?:boolean | `@${string}`,
	requireServiceAction?:boolean | `@${string}`,
	optionsEquipment?:boolean | `@${string}`,
	optionsServiceAction?:boolean | `@${string}`,
	requireInvoiceIdentifier?:boolean | `@${string}`,
	requireSupervisor?:boolean | `@${string}`,
	requireContact?:boolean | `@${string}`,
	requirePhone?:boolean | `@${string}`,
	requireEmail?:boolean | `@${string}`,
	requireGrindingStonesCondition?:boolean | `@${string}`,
localesByLocale?: [{	by: ValueTypes["BusinessServiceLocalesByLocaleUniqueWhere"],	filter?: ValueTypes["BusinessServiceLocaleWhere"] | undefined | null},ValueTypes["BusinessServiceLocale"]],
paginateLocales?: [{	filter?: ValueTypes["BusinessServiceLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessServiceLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BusinessServiceLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["BusinessServiceMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	requireNote?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	requireNumberOfPeople?:ValueTypes["FieldMeta"],
	requireInvoiced?:ValueTypes["FieldMeta"],
	requireEquipment?:ValueTypes["FieldMeta"],
	requireMillTamDem?:ValueTypes["FieldMeta"],
	requireSOEspresso?:ValueTypes["FieldMeta"],
	requireFilterCoffeeInMenu?:ValueTypes["FieldMeta"],
	requireWaterMeterStatus?:ValueTypes["FieldMeta"],
	requireServiceAction?:ValueTypes["FieldMeta"],
	optionsEquipment?:ValueTypes["FieldMeta"],
	optionsServiceAction?:ValueTypes["FieldMeta"],
	requireInvoiceIdentifier?:ValueTypes["FieldMeta"],
	requireSupervisor?:ValueTypes["FieldMeta"],
	requireContact?:ValueTypes["FieldMeta"],
	requirePhone?:ValueTypes["FieldMeta"],
	requireEmail?:ValueTypes["FieldMeta"],
	requireGrindingStonesCondition?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessServiceLocale"]: AliasType<{
	_meta?:ValueTypes["BusinessServiceLocaleMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	labelNote?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["BusinessServiceWhere"] | undefined | null},ValueTypes["BusinessService"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null},ValueTypes["Locale"]],
	labelNumberOfPeople?:boolean | `@${string}`,
	labelInvoiced?:boolean | `@${string}`,
	labelEquipment?:boolean | `@${string}`,
	labelMillTamDem?:boolean | `@${string}`,
	labelSOEspresso?:boolean | `@${string}`,
	labelFilterCoffeeInMenu?:boolean | `@${string}`,
	labelWaterMeterStatus?:boolean | `@${string}`,
	labelServiceAction?:boolean | `@${string}`,
	labelInvoiceIdentifier?:boolean | `@${string}`,
	labelSupervisor?:boolean | `@${string}`,
	labelContact?:boolean | `@${string}`,
	labelPhone?:boolean | `@${string}`,
	labelEmail?:boolean | `@${string}`,
	labelGrindingStonesCondition?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["BusinessServiceLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	labelNote?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	labelNumberOfPeople?:ValueTypes["FieldMeta"],
	labelInvoiced?:ValueTypes["FieldMeta"],
	labelEquipment?:ValueTypes["FieldMeta"],
	labelMillTamDem?:ValueTypes["FieldMeta"],
	labelSOEspresso?:ValueTypes["FieldMeta"],
	labelFilterCoffeeInMenu?:ValueTypes["FieldMeta"],
	labelWaterMeterStatus?:ValueTypes["FieldMeta"],
	labelServiceAction?:ValueTypes["FieldMeta"],
	labelInvoiceIdentifier?:ValueTypes["FieldMeta"],
	labelSupervisor?:ValueTypes["FieldMeta"],
	labelContact?:ValueTypes["FieldMeta"],
	labelPhone?:ValueTypes["FieldMeta"],
	labelEmail?:ValueTypes["FieldMeta"],
	labelGrindingStonesCondition?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessServiceLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	labelNote?: ValueTypes["OrderDirection"] | undefined | null,
	root?: ValueTypes["BusinessServiceOrderBy"] | undefined | null,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null,
	labelNumberOfPeople?: ValueTypes["OrderDirection"] | undefined | null,
	labelInvoiced?: ValueTypes["OrderDirection"] | undefined | null,
	labelEquipment?: ValueTypes["OrderDirection"] | undefined | null,
	labelMillTamDem?: ValueTypes["OrderDirection"] | undefined | null,
	labelSOEspresso?: ValueTypes["OrderDirection"] | undefined | null,
	labelFilterCoffeeInMenu?: ValueTypes["OrderDirection"] | undefined | null,
	labelWaterMeterStatus?: ValueTypes["OrderDirection"] | undefined | null,
	labelServiceAction?: ValueTypes["OrderDirection"] | undefined | null,
	labelInvoiceIdentifier?: ValueTypes["OrderDirection"] | undefined | null,
	labelSupervisor?: ValueTypes["OrderDirection"] | undefined | null,
	labelContact?: ValueTypes["OrderDirection"] | undefined | null,
	labelPhone?: ValueTypes["OrderDirection"] | undefined | null,
	labelEmail?: ValueTypes["OrderDirection"] | undefined | null,
	labelGrindingStonesCondition?: ValueTypes["OrderDirection"] | undefined | null
};
	["BusinessServiceOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null,
	requireNote?: ValueTypes["OrderDirection"] | undefined | null,
	requireNumberOfPeople?: ValueTypes["OrderDirection"] | undefined | null,
	requireInvoiced?: ValueTypes["OrderDirection"] | undefined | null,
	requireEquipment?: ValueTypes["OrderDirection"] | undefined | null,
	requireMillTamDem?: ValueTypes["OrderDirection"] | undefined | null,
	requireSOEspresso?: ValueTypes["OrderDirection"] | undefined | null,
	requireFilterCoffeeInMenu?: ValueTypes["OrderDirection"] | undefined | null,
	requireWaterMeterStatus?: ValueTypes["OrderDirection"] | undefined | null,
	requireServiceAction?: ValueTypes["OrderDirection"] | undefined | null,
	optionsEquipment?: ValueTypes["OrderDirection"] | undefined | null,
	optionsServiceAction?: ValueTypes["OrderDirection"] | undefined | null,
	requireInvoiceIdentifier?: ValueTypes["OrderDirection"] | undefined | null,
	requireSupervisor?: ValueTypes["OrderDirection"] | undefined | null,
	requireContact?: ValueTypes["OrderDirection"] | undefined | null,
	requirePhone?: ValueTypes["OrderDirection"] | undefined | null,
	requireEmail?: ValueTypes["OrderDirection"] | undefined | null,
	requireGrindingStonesCondition?: ValueTypes["OrderDirection"] | undefined | null
};
	["BusinessServiceLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null
};
	["BusinessServiceLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BusinessServiceLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessServiceLocaleEdge"]: AliasType<{
	node?:ValueTypes["BusinessServiceLocale"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessServiceEventOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null,
	fulfilledAt?: ValueTypes["OrderDirection"] | undefined | null,
	businessCustomer?: ValueTypes["BusinessCustomerOrderBy"] | undefined | null,
	businessService?: ValueTypes["BusinessServiceOrderBy"] | undefined | null,
	filledNumberOfPeople?: ValueTypes["OrderDirection"] | undefined | null,
	filledInvoiced?: ValueTypes["OrderDirection"] | undefined | null,
	filledEquipment?: ValueTypes["OrderDirection"] | undefined | null,
	filledMillTamDem?: ValueTypes["OrderDirection"] | undefined | null,
	filledSOEspresso?: ValueTypes["OrderDirection"] | undefined | null,
	filledFilterCoffeeInMenu?: ValueTypes["OrderDirection"] | undefined | null,
	filledWaterMeterStatus?: ValueTypes["OrderDirection"] | undefined | null,
	filledServiceAction?: ValueTypes["OrderDirection"] | undefined | null,
	filledInvoiceIdentifier?: ValueTypes["OrderDirection"] | undefined | null,
	filledNote?: ValueTypes["OrderDirection"] | undefined | null,
	filledContact?: ValueTypes["OrderDirection"] | undefined | null,
	filledPhone?: ValueTypes["OrderDirection"] | undefined | null,
	filledEmail?: ValueTypes["OrderDirection"] | undefined | null,
	filledGrindingStonesCondition?: ValueTypes["OrderDirection"] | undefined | null,
	createdBy?: ValueTypes["StaffOrderBy"] | undefined | null,
	filledSupervisor?: ValueTypes["StaffOrderBy"] | undefined | null
};
	["DoubleshotCoffeeEquipment"]: AliasType<{
	_meta?:ValueTypes["DoubleshotCoffeeEquipmentMeta"],
	id?:boolean | `@${string}`,
	espressoMachine?:boolean | `@${string}`,
	espressoGrinder?:boolean | `@${string}`,
	batchBrew?:boolean | `@${string}`,
	batchGrinder?:boolean | `@${string}`,
	waterFilter?:boolean | `@${string}`,
	mechanicalFilter?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["DoubleshotCoffeeEquipmentMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	espressoMachine?:ValueTypes["FieldMeta"],
	espressoGrinder?:ValueTypes["FieldMeta"],
	batchBrew?:ValueTypes["FieldMeta"],
	batchGrinder?:ValueTypes["FieldMeta"],
	waterFilter?:ValueTypes["FieldMeta"],
	mechanicalFilter?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessServiceEventConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BusinessServiceEventEdge"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessServiceEventEdge"]: AliasType<{
	node?:ValueTypes["BusinessServiceEvent"],
		__typename?: boolean | `@${string}`
}>;
	["OrderRecurrence"]: AliasType<{
	_meta?:ValueTypes["OrderRecurrenceMeta"],
	id?:boolean | `@${string}`,
	internalName?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["OrderRecurrenceLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderRecurrenceLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["OrderRecurrenceLocale"]],
	order?:boolean | `@${string}`,
businessCategory?: [{	filter?: ValueTypes["BusinessCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessCategoryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BusinessCategory"]],
localesByLocale?: [{	by: ValueTypes["OrderRecurrenceLocalesByLocaleUniqueWhere"],	filter?: ValueTypes["OrderRecurrenceLocaleWhere"] | undefined | null},ValueTypes["OrderRecurrenceLocale"]],
paginateLocales?: [{	filter?: ValueTypes["OrderRecurrenceLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderRecurrenceLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderRecurrenceLocaleConnection"]],
paginateBusinessCategory?: [{	filter?: ValueTypes["BusinessCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessCategoryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BusinessCategoryConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["OrderRecurrenceMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	internalName?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	businessCategory?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["OrderRecurrenceLocale"]: AliasType<{
	_meta?:ValueTypes["OrderRecurrenceLocaleMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["OrderRecurrenceWhere"] | undefined | null},ValueTypes["OrderRecurrence"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null},ValueTypes["Locale"]],
		__typename?: boolean | `@${string}`
}>;
	["OrderRecurrenceLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["OrderRecurrenceLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	root?: ValueTypes["OrderRecurrenceOrderBy"] | undefined | null,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null
};
	["OrderRecurrenceOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	internalName?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null
};
	["OrderRecurrenceLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null
};
	["OrderRecurrenceLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["OrderRecurrenceLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["OrderRecurrenceLocaleEdge"]: AliasType<{
	node?:ValueTypes["OrderRecurrenceLocale"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessCategoryConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BusinessCategoryEdge"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessCategoryEdge"]: AliasType<{
	node?:ValueTypes["BusinessCategory"],
		__typename?: boolean | `@${string}`
}>;
	["ProductList"]: AliasType<{
	_meta?:ValueTypes["ProductListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["ProductListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductListItem"]],
businessCategory?: [{	filter?: ValueTypes["BusinessCategoryWhere"] | undefined | null},ValueTypes["BusinessCategory"]],
paginateItems?: [{	filter?: ValueTypes["ProductListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductListItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ProductListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
	businessCategory?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProductListItem"]: AliasType<{
	_meta?:ValueTypes["ProductListItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
list?: [{	filter?: ValueTypes["ProductListWhere"] | undefined | null},ValueTypes["ProductList"]],
product?: [{	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
	defaultQuantityForOrder?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProductListItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	product?:ValueTypes["FieldMeta"],
	defaultQuantityForOrder?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProductListItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null,
	list?: ValueTypes["ProductListOrderBy"] | undefined | null,
	product?: ValueTypes["ProductOrderBy"] | undefined | null,
	defaultQuantityForOrder?: ValueTypes["OrderDirection"] | undefined | null
};
	["ProductListItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductListItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProductListItemEdge"]: AliasType<{
	node?:ValueTypes["ProductListItem"],
		__typename?: boolean | `@${string}`
}>;
	["ProductCategoryList"]: AliasType<{
	_meta?:ValueTypes["ProductCategoryListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["ProductCategoryListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCategoryListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductCategoryListItem"]],
locales?: [{	filter?: ValueTypes["ProductCategoryListLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCategoryListLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductCategoryListLocale"]],
seasonalProductCategoriesOfBusinessCategory?: [{	filter?: ValueTypes["BusinessCategoryWhere"] | undefined | null},ValueTypes["BusinessCategory"]],
specificProductsProductCategoriesOfBusinessCategory?: [{	filter?: ValueTypes["BusinessCategoryWhere"] | undefined | null},ValueTypes["BusinessCategory"]],
localesByLocale?: [{	by: ValueTypes["ProductCategoryListLocalesByLocaleUniqueWhere"],	filter?: ValueTypes["ProductCategoryListLocaleWhere"] | undefined | null},ValueTypes["ProductCategoryListLocale"]],
paginateItems?: [{	filter?: ValueTypes["ProductCategoryListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCategoryListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductCategoryListItemConnection"]],
paginateLocales?: [{	filter?: ValueTypes["ProductCategoryListLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCategoryListLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductCategoryListLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ProductCategoryListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	seasonalProductCategoriesOfBusinessCategory?:ValueTypes["FieldMeta"],
	specificProductsProductCategoriesOfBusinessCategory?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProductCategoryListItem"]: AliasType<{
	_meta?:ValueTypes["ProductCategoryListItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
list?: [{	filter?: ValueTypes["ProductCategoryListWhere"] | undefined | null},ValueTypes["ProductCategoryList"]],
productCategory?: [{	filter?: ValueTypes["ProductCategoryWhere"] | undefined | null},ValueTypes["ProductCategory"]],
	showRecipeImages?:boolean | `@${string}`,
	showPackingImages?:boolean | `@${string}`,
	showAllAvailableProducts?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProductCategoryListItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	productCategory?:ValueTypes["FieldMeta"],
	showRecipeImages?:ValueTypes["FieldMeta"],
	showPackingImages?:ValueTypes["FieldMeta"],
	showAllAvailableProducts?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProductCategoryListItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null,
	list?: ValueTypes["ProductCategoryListOrderBy"] | undefined | null,
	productCategory?: ValueTypes["ProductCategoryOrderBy"] | undefined | null,
	showRecipeImages?: ValueTypes["OrderDirection"] | undefined | null,
	showPackingImages?: ValueTypes["OrderDirection"] | undefined | null,
	showAllAvailableProducts?: ValueTypes["OrderDirection"] | undefined | null
};
	["ProductCategoryListLocale"]: AliasType<{
	_meta?:ValueTypes["ProductCategoryListLocaleMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["ProductCategoryListWhere"] | undefined | null},ValueTypes["ProductCategoryList"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null},ValueTypes["Locale"]],
		__typename?: boolean | `@${string}`
}>;
	["ProductCategoryListLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProductCategoryListLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	root?: ValueTypes["ProductCategoryListOrderBy"] | undefined | null,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null
};
	["ProductCategoryListLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null
};
	["ProductCategoryListItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductCategoryListItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProductCategoryListItemEdge"]: AliasType<{
	node?:ValueTypes["ProductCategoryListItem"],
		__typename?: boolean | `@${string}`
}>;
	["ProductCategoryListLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductCategoryListLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProductCategoryListLocaleEdge"]: AliasType<{
	node?:ValueTypes["ProductCategoryListLocale"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessCategoryLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null
};
	["BusinessCategoryBusinessCustomersByCustomerUniqueWhere"]: {
	customer?: ValueTypes["CustomerUniqueWhere"] | undefined | null
};
	["BusinessCategoryBusinessCustomersByBusinessServiceEventsUniqueWhere"]: {
	businessServiceEvents?: ValueTypes["BusinessServiceEventUniqueWhere"] | undefined | null
};
	["BusinessCategoryBusinessCustomersByDoubleshotCoffeeEquipmentUniqueWhere"]: {
	doubleshotCoffeeEquipment?: ValueTypes["DoubleshotCoffeeEquipmentUniqueWhere"] | undefined | null
};
	["BusinessCategoryLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BusinessCategoryLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessCategoryLocaleEdge"]: AliasType<{
	node?:ValueTypes["BusinessCategoryLocale"],
		__typename?: boolean | `@${string}`
}>;
	["OrderRecurrenceConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["OrderRecurrenceEdge"],
		__typename?: boolean | `@${string}`
}>;
	["OrderRecurrenceEdge"]: AliasType<{
	node?:ValueTypes["OrderRecurrence"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientLocale"]: AliasType<{
	_meta?:ValueTypes["ProductIngredientLocaleMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["ProductIngredientWhere"] | undefined | null},ValueTypes["ProductIngredient"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null},ValueTypes["Locale"]],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredient"]: AliasType<{
	_meta?:ValueTypes["ProductIngredientMeta"],
	id?:boolean | `@${string}`,
	internalNote?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["ProductIngredientLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductIngredientLocale"]],
	internalName?:boolean | `@${string}`,
categories?: [{	filter?: ValueTypes["ProductIngredientCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientCategoryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductIngredientCategory"]],
allergens?: [{	filter?: ValueTypes["AllergenWhere"] | undefined | null,	orderBy?: Array<ValueTypes["AllergenOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Allergen"]],
	needsPrepping?:boolean | `@${string}`,
	allowCustomerRating?:boolean | `@${string}`,
customerRatings?: [{	filter?: ValueTypes["CustomerIngredientRatingWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerIngredientRatingOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CustomerIngredientRating"]],
preferredQuantityUnit?: [{	filter?: ValueTypes["ProductIngredientItemQuantityUnitWhere"] | undefined | null},ValueTypes["ProductIngredientItemQuantityUnit"]],
freshingContainer?: [{	filter?: ValueTypes["FreshingContainerWhere"] | undefined | null},ValueTypes["FreshingContainer"]],
image?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null},ValueTypes["Image"]],
suppliers?: [{	filter?: ValueTypes["IngredientSupplierListWhere"] | undefined | null},ValueTypes["IngredientSupplierList"]],
	incrementQuantityNumber?:boolean | `@${string}`,
localesByLocale?: [{	by: ValueTypes["ProductIngredientLocalesByLocaleUniqueWhere"],	filter?: ValueTypes["ProductIngredientLocaleWhere"] | undefined | null},ValueTypes["ProductIngredientLocale"]],
customerRatingsByCustomer?: [{	by: ValueTypes["ProductIngredientCustomerRatingsByCustomerUniqueWhere"],	filter?: ValueTypes["CustomerIngredientRatingWhere"] | undefined | null},ValueTypes["CustomerIngredientRating"]],
paginateLocales?: [{	filter?: ValueTypes["ProductIngredientLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductIngredientLocaleConnection"]],
paginateCategories?: [{	filter?: ValueTypes["ProductIngredientCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientCategoryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductIngredientCategoryConnection"]],
paginateAllergens?: [{	filter?: ValueTypes["AllergenWhere"] | undefined | null,	orderBy?: Array<ValueTypes["AllergenOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["AllergenConnection"]],
paginateCustomerRatings?: [{	filter?: ValueTypes["CustomerIngredientRatingWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerIngredientRatingOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerIngredientRatingConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	internalNote?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	internalName?:ValueTypes["FieldMeta"],
	categories?:ValueTypes["FieldMeta"],
	allergens?:ValueTypes["FieldMeta"],
	needsPrepping?:ValueTypes["FieldMeta"],
	allowCustomerRating?:ValueTypes["FieldMeta"],
	customerRatings?:ValueTypes["FieldMeta"],
	preferredQuantityUnit?:ValueTypes["FieldMeta"],
	freshingContainer?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	suppliers?:ValueTypes["FieldMeta"],
	incrementQuantityNumber?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	root?: ValueTypes["ProductIngredientOrderBy"] | undefined | null,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null
};
	["ProductIngredientOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	internalNote?: ValueTypes["OrderDirection"] | undefined | null,
	internalName?: ValueTypes["OrderDirection"] | undefined | null,
	needsPrepping?: ValueTypes["OrderDirection"] | undefined | null,
	allowCustomerRating?: ValueTypes["OrderDirection"] | undefined | null,
	preferredQuantityUnit?: ValueTypes["ProductIngredientItemQuantityUnitOrderBy"] | undefined | null,
	freshingContainer?: ValueTypes["FreshingContainerOrderBy"] | undefined | null,
	image?: ValueTypes["ImageOrderBy"] | undefined | null,
	suppliers?: ValueTypes["IngredientSupplierListOrderBy"] | undefined | null,
	incrementQuantityNumber?: ValueTypes["OrderDirection"] | undefined | null
};
	["ProductIngredientItemQuantityUnitOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null
};
	["IngredientSupplierListOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null
};
	["ProductIngredientCategory"]: AliasType<{
	_meta?:ValueTypes["ProductIngredientCategoryMeta"],
	id?:boolean | `@${string}`,
	internalName?:boolean | `@${string}`,
	internalNote?:boolean | `@${string}`,
ingredients?: [{	filter?: ValueTypes["ProductIngredientWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductIngredient"]],
locales?: [{	filter?: ValueTypes["ProductIngredientCategoryLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientCategoryLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductIngredientCategoryLocale"]],
	order?:boolean | `@${string}`,
localesByLocale?: [{	by: ValueTypes["ProductIngredientCategoryLocalesByLocaleUniqueWhere"],	filter?: ValueTypes["ProductIngredientCategoryLocaleWhere"] | undefined | null},ValueTypes["ProductIngredientCategoryLocale"]],
paginateIngredients?: [{	filter?: ValueTypes["ProductIngredientWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductIngredientConnection"]],
paginateLocales?: [{	filter?: ValueTypes["ProductIngredientCategoryLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientCategoryLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductIngredientCategoryLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientCategoryMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	internalName?:ValueTypes["FieldMeta"],
	internalNote?:ValueTypes["FieldMeta"],
	ingredients?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientCategoryLocale"]: AliasType<{
	_meta?:ValueTypes["ProductIngredientCategoryLocaleMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["ProductIngredientCategoryWhere"] | undefined | null},ValueTypes["ProductIngredientCategory"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null},ValueTypes["Locale"]],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientCategoryLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientCategoryLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	root?: ValueTypes["ProductIngredientCategoryOrderBy"] | undefined | null,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null
};
	["ProductIngredientCategoryOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	internalName?: ValueTypes["OrderDirection"] | undefined | null,
	internalNote?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null
};
	["ProductIngredientCategoryLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null
};
	["ProductIngredientConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductIngredientEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientEdge"]: AliasType<{
	node?:ValueTypes["ProductIngredient"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientCategoryLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductIngredientCategoryLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientCategoryLocaleEdge"]: AliasType<{
	node?:ValueTypes["ProductIngredientCategoryLocale"],
		__typename?: boolean | `@${string}`
}>;
	["Allergen"]: AliasType<{
	_meta?:ValueTypes["AllergenMeta"],
	id?:boolean | `@${string}`,
	internalName?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["AllergenLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["AllergenLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["AllergenLocale"]],
ingredients?: [{	filter?: ValueTypes["ProductIngredientWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductIngredient"]],
	code?:boolean | `@${string}`,
localesByLocale?: [{	by: ValueTypes["AllergenLocalesByLocaleUniqueWhere"],	filter?: ValueTypes["AllergenLocaleWhere"] | undefined | null},ValueTypes["AllergenLocale"]],
paginateLocales?: [{	filter?: ValueTypes["AllergenLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["AllergenLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["AllergenLocaleConnection"]],
paginateIngredients?: [{	filter?: ValueTypes["ProductIngredientWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductIngredientConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["AllergenMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	internalName?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	ingredients?:ValueTypes["FieldMeta"],
	code?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["AllergenLocale"]: AliasType<{
	_meta?:ValueTypes["AllergenLocaleMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["AllergenWhere"] | undefined | null},ValueTypes["Allergen"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null},ValueTypes["Locale"]],
		__typename?: boolean | `@${string}`
}>;
	["AllergenLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["AllergenLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	root?: ValueTypes["AllergenOrderBy"] | undefined | null,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null
};
	["AllergenOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	internalName?: ValueTypes["OrderDirection"] | undefined | null,
	code?: ValueTypes["OrderDirection"] | undefined | null
};
	["AllergenLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null
};
	["AllergenLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["AllergenLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["AllergenLocaleEdge"]: AliasType<{
	node?:ValueTypes["AllergenLocale"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerIngredientRating"]: AliasType<{
	_meta?:ValueTypes["CustomerIngredientRatingMeta"],
	id?:boolean | `@${string}`,
customer?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
rating?: [{	filter?: ValueTypes["ProductIngredientRatingWhere"] | undefined | null},ValueTypes["ProductIngredientRating"]],
ingredient?: [{	filter?: ValueTypes["ProductIngredientWhere"] | undefined | null},ValueTypes["ProductIngredient"]],
		__typename?: boolean | `@${string}`
}>;
	["CustomerIngredientRatingMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	customer?:ValueTypes["FieldMeta"],
	rating?:ValueTypes["FieldMeta"],
	ingredient?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientRating"]: AliasType<{
	_meta?:ValueTypes["ProductIngredientRatingMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
icon?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null},ValueTypes["Image"]],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientRatingMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	icon?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerIngredientRatingOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	customer?: ValueTypes["CustomerOrderBy"] | undefined | null,
	rating?: ValueTypes["ProductIngredientRatingOrderBy"] | undefined | null,
	ingredient?: ValueTypes["ProductIngredientOrderBy"] | undefined | null
};
	["ProductIngredientRatingOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	icon?: ValueTypes["ImageOrderBy"] | undefined | null
};
	["ProductIngredientItemQuantityUnit"]: AliasType<{
	_meta?:ValueTypes["ProductIngredientItemQuantityUnitMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientItemQuantityUnitMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["FreshingContainer"]: AliasType<{
	_meta?:ValueTypes["FreshingContainerMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	volumeMl?:boolean | `@${string}`,
workspace?: [{	filter?: ValueTypes["WorkspaceWhere"] | undefined | null},ValueTypes["Workspace"]],
		__typename?: boolean | `@${string}`
}>;
	["FreshingContainerMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	volumeMl?:ValueTypes["FieldMeta"],
	workspace?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Workspace"]: AliasType<{
	_meta?:ValueTypes["WorkspaceMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
	orderDeadlineTime?:boolean | `@${string}`,
	ordersLoadingDurationHours?:boolean | `@${string}`,
	freshingContainerVolumeMl?:boolean | `@${string}`,
	freshingPrepareOrderByOffsetMinutes?:boolean | `@${string}`,
	checkoutUrlTemplate?:boolean | `@${string}`,
	orderUrlTemplate?:boolean | `@${string}`,
	paymentUrlTemplate?:boolean | `@${string}`,
	customerProfileUrlTemplate?:boolean | `@${string}`,
	userProfileUrlTemplate?:boolean | `@${string}`,
	messengerUrl?:boolean | `@${string}`,
	messengerIosUrl?:boolean | `@${string}`,
	messengerAndroidUrl?:boolean | `@${string}`,
freshingContainers?: [{	filter?: ValueTypes["FreshingContainerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["FreshingContainerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["FreshingContainer"]],
openingHours?: [{	filter?: ValueTypes["WeekHoursWhere"] | undefined | null},ValueTypes["WeekHours"]],
workingHours?: [{	filter?: ValueTypes["WeekHoursWhere"] | undefined | null},ValueTypes["WeekHours"]],
defaultFreshingContainer?: [{	filter?: ValueTypes["FreshingContainerWhere"] | undefined | null},ValueTypes["FreshingContainer"]],
creditsProduct?: [{	filter?: ValueTypes["VirtualProductWhere"] | undefined | null},ValueTypes["VirtualProduct"]],
discountVatRate?: [{	filter?: ValueTypes["VatRateWhere"] | undefined | null},ValueTypes["VatRate"]],
	name?:boolean | `@${string}`,
	businessAddress?:boolean | `@${string}`,
paginateFreshingContainers?: [{	filter?: ValueTypes["FreshingContainerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["FreshingContainerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["FreshingContainerConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["WorkspaceMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	orderDeadlineTime?:ValueTypes["FieldMeta"],
	ordersLoadingDurationHours?:ValueTypes["FieldMeta"],
	freshingContainerVolumeMl?:ValueTypes["FieldMeta"],
	freshingPrepareOrderByOffsetMinutes?:ValueTypes["FieldMeta"],
	checkoutUrlTemplate?:ValueTypes["FieldMeta"],
	orderUrlTemplate?:ValueTypes["FieldMeta"],
	paymentUrlTemplate?:ValueTypes["FieldMeta"],
	customerProfileUrlTemplate?:ValueTypes["FieldMeta"],
	userProfileUrlTemplate?:ValueTypes["FieldMeta"],
	messengerUrl?:ValueTypes["FieldMeta"],
	messengerIosUrl?:ValueTypes["FieldMeta"],
	messengerAndroidUrl?:ValueTypes["FieldMeta"],
	freshingContainers?:ValueTypes["FieldMeta"],
	openingHours?:ValueTypes["FieldMeta"],
	workingHours?:ValueTypes["FieldMeta"],
	defaultFreshingContainer?:ValueTypes["FieldMeta"],
	creditsProduct?:ValueTypes["FieldMeta"],
	discountVatRate?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	businessAddress?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["WeekHours"]: AliasType<{
	_meta?:ValueTypes["WeekHoursMeta"],
	id?:boolean | `@${string}`,
	mon?:boolean | `@${string}`,
	tue?:boolean | `@${string}`,
	wed?:boolean | `@${string}`,
	thu?:boolean | `@${string}`,
	fri?:boolean | `@${string}`,
	sat?:boolean | `@${string}`,
	sun?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["WeekHoursMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	mon?:ValueTypes["FieldMeta"],
	tue?:ValueTypes["FieldMeta"],
	wed?:ValueTypes["FieldMeta"],
	thu?:ValueTypes["FieldMeta"],
	fri?:ValueTypes["FieldMeta"],
	sat?:ValueTypes["FieldMeta"],
	sun?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["VirtualProduct"]: AliasType<{
	_meta?:ValueTypes["VirtualProductMeta"],
	id?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
product?: [{	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
	voucherCreditCents?:boolean | `@${string}`,
	physicalRepresentation?:boolean | `@${string}`,
	recipientEmail?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["VirtualProductMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	product?:ValueTypes["FieldMeta"],
	voucherCreditCents?:ValueTypes["FieldMeta"],
	physicalRepresentation?:ValueTypes["FieldMeta"],
	recipientEmail?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["FreshingContainerConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FreshingContainerEdge"],
		__typename?: boolean | `@${string}`
}>;
	["FreshingContainerEdge"]: AliasType<{
	node?:ValueTypes["FreshingContainer"],
		__typename?: boolean | `@${string}`
}>;
	["IngredientSupplierList"]: AliasType<{
	_meta?:ValueTypes["IngredientSupplierListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["IngredientSupplierItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IngredientSupplierItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["IngredientSupplierItem"]],
paginateItems?: [{	filter?: ValueTypes["IngredientSupplierItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IngredientSupplierItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["IngredientSupplierItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["IngredientSupplierListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["IngredientSupplierItem"]: AliasType<{
	_meta?:ValueTypes["IngredientSupplierItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
list?: [{	filter?: ValueTypes["IngredientSupplierListWhere"] | undefined | null},ValueTypes["IngredientSupplierList"]],
supplier?: [{	filter?: ValueTypes["IngredientSupplierWhere"] | undefined | null},ValueTypes["IngredientSupplier"]],
		__typename?: boolean | `@${string}`
}>;
	["IngredientSupplierItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	supplier?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["IngredientSupplier"]: AliasType<{
	_meta?:ValueTypes["IngredientSupplierMeta"],
	id?:boolean | `@${string}`,
	internalName?:boolean | `@${string}`,
	internalNote?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["IngredientSupplierLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IngredientSupplierLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["IngredientSupplierLocale"]],
localesByLocale?: [{	by: ValueTypes["IngredientSupplierLocalesByLocaleUniqueWhere"],	filter?: ValueTypes["IngredientSupplierLocaleWhere"] | undefined | null},ValueTypes["IngredientSupplierLocale"]],
paginateLocales?: [{	filter?: ValueTypes["IngredientSupplierLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IngredientSupplierLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["IngredientSupplierLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["IngredientSupplierMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	internalName?:ValueTypes["FieldMeta"],
	internalNote?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["IngredientSupplierLocale"]: AliasType<{
	_meta?:ValueTypes["IngredientSupplierLocaleMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["IngredientSupplierWhere"] | undefined | null},ValueTypes["IngredientSupplier"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null},ValueTypes["Locale"]],
		__typename?: boolean | `@${string}`
}>;
	["IngredientSupplierLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["IngredientSupplierLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	root?: ValueTypes["IngredientSupplierOrderBy"] | undefined | null,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null
};
	["IngredientSupplierOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	internalName?: ValueTypes["OrderDirection"] | undefined | null,
	internalNote?: ValueTypes["OrderDirection"] | undefined | null
};
	["IngredientSupplierLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null
};
	["IngredientSupplierLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["IngredientSupplierLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["IngredientSupplierLocaleEdge"]: AliasType<{
	node?:ValueTypes["IngredientSupplierLocale"],
		__typename?: boolean | `@${string}`
}>;
	["IngredientSupplierItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null,
	list?: ValueTypes["IngredientSupplierListOrderBy"] | undefined | null,
	supplier?: ValueTypes["IngredientSupplierOrderBy"] | undefined | null
};
	["IngredientSupplierItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["IngredientSupplierItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["IngredientSupplierItemEdge"]: AliasType<{
	node?:ValueTypes["IngredientSupplierItem"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null
};
	["ProductIngredientCustomerRatingsByCustomerUniqueWhere"]: {
	customer?: ValueTypes["CustomerUniqueWhere"] | undefined | null
};
	["ProductIngredientLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductIngredientLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientLocaleEdge"]: AliasType<{
	node?:ValueTypes["ProductIngredientLocale"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientCategoryConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductIngredientCategoryEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientCategoryEdge"]: AliasType<{
	node?:ValueTypes["ProductIngredientCategory"],
		__typename?: boolean | `@${string}`
}>;
	["AllergenConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["AllergenEdge"],
		__typename?: boolean | `@${string}`
}>;
	["AllergenEdge"]: AliasType<{
	node?:ValueTypes["Allergen"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerIngredientRatingConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CustomerIngredientRatingEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerIngredientRatingEdge"]: AliasType<{
	node?:ValueTypes["CustomerIngredientRating"],
		__typename?: boolean | `@${string}`
}>;
	["BlogLocale"]: AliasType<{
	_meta?:ValueTypes["BlogLocaleMeta"],
	id?:boolean | `@${string}`,
	pageName?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	lead?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["BlogWhere"] | undefined | null},ValueTypes["Blog"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null},ValueTypes["Locale"]],
		__typename?: boolean | `@${string}`
}>;
	["BlogLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	pageName?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	lead?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Blog"]: AliasType<{
	_meta?:ValueTypes["BlogMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["BlogLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BlogLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BlogLocale"]],
localesByLocale?: [{	by: ValueTypes["BlogLocalesByLocaleUniqueWhere"],	filter?: ValueTypes["BlogLocaleWhere"] | undefined | null},ValueTypes["BlogLocale"]],
paginateLocales?: [{	filter?: ValueTypes["BlogLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BlogLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BlogLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["BlogMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["BlogLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	pageName?: ValueTypes["OrderDirection"] | undefined | null,
	title?: ValueTypes["OrderDirection"] | undefined | null,
	lead?: ValueTypes["OrderDirection"] | undefined | null,
	root?: ValueTypes["BlogOrderBy"] | undefined | null,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null
};
	["BlogOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	unique?: ValueTypes["OrderDirection"] | undefined | null
};
	["BlogLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null
};
	["BlogLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BlogLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["BlogLocaleEdge"]: AliasType<{
	node?:ValueTypes["BlogLocale"],
		__typename?: boolean | `@${string}`
}>;
	["BlogPostLocale"]: AliasType<{
	_meta?:ValueTypes["BlogPostLocaleMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	availableForWeb?:boolean | `@${string}`,
	availableForMobile?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["BlogPostWhere"] | undefined | null},ValueTypes["BlogPost"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null},ValueTypes["Locale"]],
cover?: [{	filter?: ValueTypes["CoverWhere"] | undefined | null},ValueTypes["Cover"]],
content?: [{	filter?: ValueTypes["ContentWhere"] | undefined | null},ValueTypes["Content"]],
link?: [{	filter?: ValueTypes["LinkableWhere"] | undefined | null},ValueTypes["Linkable"]],
seo?: [{	filter?: ValueTypes["SeoWhere"] | undefined | null},ValueTypes["Seo"]],
products?: [{	filter?: ValueTypes["ProductWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Product"]],
paginateProducts?: [{	filter?: ValueTypes["ProductWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["BlogPostLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	availableForWeb?:ValueTypes["FieldMeta"],
	availableForMobile?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	cover?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	products?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["BlogPost"]: AliasType<{
	_meta?:ValueTypes["BlogPostMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["BlogPostLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BlogPostLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BlogPostLocale"]],
localesByLocale?: [{	by: ValueTypes["BlogPostLocalesByLocaleUniqueWhere"],	filter?: ValueTypes["BlogPostLocaleWhere"] | undefined | null},ValueTypes["BlogPostLocale"]],
localesByCover?: [{	by: ValueTypes["BlogPostLocalesByCoverUniqueWhere"],	filter?: ValueTypes["BlogPostLocaleWhere"] | undefined | null},ValueTypes["BlogPostLocale"]],
localesByContent?: [{	by: ValueTypes["BlogPostLocalesByContentUniqueWhere"],	filter?: ValueTypes["BlogPostLocaleWhere"] | undefined | null},ValueTypes["BlogPostLocale"]],
localesByLink?: [{	by: ValueTypes["BlogPostLocalesByLinkUniqueWhere"],	filter?: ValueTypes["BlogPostLocaleWhere"] | undefined | null},ValueTypes["BlogPostLocale"]],
localesBySeo?: [{	by: ValueTypes["BlogPostLocalesBySeoUniqueWhere"],	filter?: ValueTypes["BlogPostLocaleWhere"] | undefined | null},ValueTypes["BlogPostLocale"]],
paginateLocales?: [{	filter?: ValueTypes["BlogPostLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BlogPostLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BlogPostLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["BlogPostMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["BlogPostLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	title?: ValueTypes["OrderDirection"] | undefined | null,
	availableForWeb?: ValueTypes["OrderDirection"] | undefined | null,
	availableForMobile?: ValueTypes["OrderDirection"] | undefined | null,
	root?: ValueTypes["BlogPostOrderBy"] | undefined | null,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null,
	cover?: ValueTypes["CoverOrderBy"] | undefined | null,
	content?: ValueTypes["ContentOrderBy"] | undefined | null,
	link?: ValueTypes["LinkableOrderBy"] | undefined | null,
	seo?: ValueTypes["SeoOrderBy"] | undefined | null
};
	["BlogPostOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null
};
	["CoverOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	primaryTitle?: ValueTypes["OrderDirection"] | undefined | null,
	secondaryTitle?: ValueTypes["OrderDirection"] | undefined | null,
	medium?: ValueTypes["MediumOrderBy"] | undefined | null,
	buttonColors?: ValueTypes["ColorPalleteOrderBy"] | undefined | null
};
	["MediumOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	type?: ValueTypes["OrderDirection"] | undefined | null,
	colorTheme?: ValueTypes["OrderDirection"] | undefined | null,
	image?: ValueTypes["ImageOrderBy"] | undefined | null,
	video?: ValueTypes["VideoOrderBy"] | undefined | null
};
	["VideoOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	src?: ValueTypes["OrderDirection"] | undefined | null,
	width?: ValueTypes["OrderDirection"] | undefined | null,
	height?: ValueTypes["OrderDirection"] | undefined | null,
	size?: ValueTypes["OrderDirection"] | undefined | null,
	type?: ValueTypes["OrderDirection"] | undefined | null,
	duration?: ValueTypes["OrderDirection"] | undefined | null,
	poster?: ValueTypes["ImageOrderBy"] | undefined | null
};
	["ColorPalleteOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	background?: ValueTypes["OrderDirection"] | undefined | null,
	text?: ValueTypes["OrderDirection"] | undefined | null
};
	["ContentOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null
};
	["LinkableOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	url?: ValueTypes["OrderDirection"] | undefined | null,
	blogPost?: ValueTypes["BlogPostLocaleOrderBy"] | undefined | null,
	page?: ValueTypes["PageLocaleOrderBy"] | undefined | null,
	wikiPage?: ValueTypes["WikiPageOrderBy"] | undefined | null,
	redirect?: ValueTypes["RedirectOrderBy"] | undefined | null
};
	["PageLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	title?: ValueTypes["OrderDirection"] | undefined | null,
	link?: ValueTypes["LinkableOrderBy"] | undefined | null,
	root?: ValueTypes["PageOrderBy"] | undefined | null,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null,
	seo?: ValueTypes["SeoOrderBy"] | undefined | null,
	content?: ValueTypes["ContentOrderBy"] | undefined | null,
	cover?: ValueTypes["CoverOrderBy"] | undefined | null,
	theme?: ValueTypes["OrderDirection"] | undefined | null
};
	["SeoOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	title?: ValueTypes["OrderDirection"] | undefined | null,
	description?: ValueTypes["OrderDirection"] | undefined | null,
	ogTitle?: ValueTypes["OrderDirection"] | undefined | null,
	ogDescription?: ValueTypes["OrderDirection"] | undefined | null,
	ogImage?: ValueTypes["ImageOrderBy"] | undefined | null
};
	["WikiPageOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null,
	title?: ValueTypes["OrderDirection"] | undefined | null,
	emoji?: ValueTypes["OrderDirection"] | undefined | null,
	link?: ValueTypes["LinkableOrderBy"] | undefined | null,
	parent?: ValueTypes["WikiPageOrderBy"] | undefined | null,
	content?: ValueTypes["ContentOrderBy"] | undefined | null
};
	["RedirectOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	link?: ValueTypes["LinkableOrderBy"] | undefined | null,
	target?: ValueTypes["LinkOrderBy"] | undefined | null
};
	["LinkOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	type?: ValueTypes["OrderDirection"] | undefined | null,
	title?: ValueTypes["OrderDirection"] | undefined | null,
	externalLink?: ValueTypes["OrderDirection"] | undefined | null,
	internalLink?: ValueTypes["LinkableOrderBy"] | undefined | null
};
	["BlogPostLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null
};
	["BlogPostLocalesByCoverUniqueWhere"]: {
	cover?: ValueTypes["CoverUniqueWhere"] | undefined | null
};
	["BlogPostLocalesByContentUniqueWhere"]: {
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null
};
	["BlogPostLocalesByLinkUniqueWhere"]: {
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null
};
	["BlogPostLocalesBySeoUniqueWhere"]: {
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null
};
	["BlogPostLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BlogPostLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["BlogPostLocaleEdge"]: AliasType<{
	node?:ValueTypes["BlogPostLocale"],
		__typename?: boolean | `@${string}`
}>;
	["Cover"]: AliasType<{
	_meta?:ValueTypes["CoverMeta"],
	id?:boolean | `@${string}`,
	primaryTitle?:boolean | `@${string}`,
	secondaryTitle?:boolean | `@${string}`,
medium?: [{	filter?: ValueTypes["MediumWhere"] | undefined | null},ValueTypes["Medium"]],
buttonColors?: [{	filter?: ValueTypes["ColorPalleteWhere"] | undefined | null},ValueTypes["ColorPallete"]],
		__typename?: boolean | `@${string}`
}>;
	["CoverMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	primaryTitle?:ValueTypes["FieldMeta"],
	secondaryTitle?:ValueTypes["FieldMeta"],
	medium?:ValueTypes["FieldMeta"],
	buttonColors?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Medium"]: AliasType<{
	_meta?:ValueTypes["MediumMeta"],
	id?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	colorTheme?:boolean | `@${string}`,
image?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null},ValueTypes["Image"]],
video?: [{	filter?: ValueTypes["VideoWhere"] | undefined | null},ValueTypes["Video"]],
		__typename?: boolean | `@${string}`
}>;
	["MediumMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	colorTheme?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	video?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Video"]: AliasType<{
	_meta?:ValueTypes["VideoMeta"],
	id?:boolean | `@${string}`,
	src?:boolean | `@${string}`,
	width?:boolean | `@${string}`,
	height?:boolean | `@${string}`,
	size?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	duration?:boolean | `@${string}`,
poster?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null},ValueTypes["Image"]],
		__typename?: boolean | `@${string}`
}>;
	["VideoMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	src?:ValueTypes["FieldMeta"],
	width?:ValueTypes["FieldMeta"],
	height?:ValueTypes["FieldMeta"],
	size?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	duration?:ValueTypes["FieldMeta"],
	poster?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ColorPallete"]: AliasType<{
	_meta?:ValueTypes["ColorPalleteMeta"],
	id?:boolean | `@${string}`,
	background?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ColorPalleteMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	background?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Content"]: AliasType<{
	_meta?:ValueTypes["ContentMeta"],
	id?:boolean | `@${string}`,
blocks?: [{	filter?: ValueTypes["ContentBlockWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ContentBlockOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ContentBlock"]],
blocksByReferences?: [{	by: ValueTypes["ContentBlocksByReferencesUniqueWhere"],	filter?: ValueTypes["ContentBlockWhere"] | undefined | null},ValueTypes["ContentBlock"]],
paginateBlocks?: [{	filter?: ValueTypes["ContentBlockWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ContentBlockOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ContentBlockConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ContentMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	blocks?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlock"]: AliasType<{
	_meta?:ValueTypes["ContentBlockMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	json?:boolean | `@${string}`,
content?: [{	filter?: ValueTypes["ContentWhere"] | undefined | null},ValueTypes["Content"]],
references?: [{	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ContentReferenceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ContentReference"]],
referencesByProducts?: [{	by: ValueTypes["ContentBlockReferencesByProductsUniqueWhere"],	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null},ValueTypes["ContentReference"]],
referencesByProductBanners?: [{	by: ValueTypes["ContentBlockReferencesByProductBannersUniqueWhere"],	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null},ValueTypes["ContentReference"]],
referencesByDeliveryRegions?: [{	by: ValueTypes["ContentBlockReferencesByDeliveryRegionsUniqueWhere"],	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null},ValueTypes["ContentReference"]],
paginateReferences?: [{	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ContentReferenceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ContentReferenceConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	json?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	references?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReference"]: AliasType<{
	_meta?:ValueTypes["ContentReferenceMeta"],
	id?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	primaryText?:boolean | `@${string}`,
	secondaryText?:boolean | `@${string}`,
	jsonContent?:boolean | `@${string}`,
block?: [{	filter?: ValueTypes["ContentBlockWhere"] | undefined | null},ValueTypes["ContentBlock"]],
colorPallete?: [{	filter?: ValueTypes["ColorPalleteWhere"] | undefined | null},ValueTypes["ColorPallete"]],
medium?: [{	filter?: ValueTypes["MediumWhere"] | undefined | null},ValueTypes["Medium"]],
link?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null},ValueTypes["Link"]],
blogPosts?: [{	filter?: ValueTypes["BlogPostListWhere"] | undefined | null},ValueTypes["BlogPostList"]],
links?: [{	filter?: ValueTypes["LinkListWhere"] | undefined | null},ValueTypes["LinkList"]],
products?: [{	filter?: ValueTypes["ProductListWhere"] | undefined | null},ValueTypes["ProductList"]],
	contentSize?:boolean | `@${string}`,
	misc?:boolean | `@${string}`,
hero?: [{	filter?: ValueTypes["HeroWhere"] | undefined | null},ValueTypes["Hero"]],
gallery?: [{	filter?: ValueTypes["GalleryWhere"] | undefined | null},ValueTypes["Gallery"]],
socialsAndApps?: [{	filter?: ValueTypes["SocialsAndAppsWhere"] | undefined | null},ValueTypes["SocialsAndApps"]],
productGrid?: [{	filter?: ValueTypes["ProductGridWhere"] | undefined | null},ValueTypes["ProductGrid"]],
productBanners?: [{	filter?: ValueTypes["ProductBannerListWhere"] | undefined | null},ValueTypes["ProductBannerList"]],
deliveryRegions?: [{	filter?: ValueTypes["DeliveryRegionsWhere"] | undefined | null},ValueTypes["DeliveryRegions"]],
textList?: [{	filter?: ValueTypes["TextListWhere"] | undefined | null},ValueTypes["TextList"]],
gridTiles?: [{	filter?: ValueTypes["GridTilesWhere"] | undefined | null},ValueTypes["GridTiles"]],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	primaryText?:ValueTypes["FieldMeta"],
	secondaryText?:ValueTypes["FieldMeta"],
	jsonContent?:ValueTypes["FieldMeta"],
	block?:ValueTypes["FieldMeta"],
	colorPallete?:ValueTypes["FieldMeta"],
	medium?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	blogPosts?:ValueTypes["FieldMeta"],
	links?:ValueTypes["FieldMeta"],
	products?:ValueTypes["FieldMeta"],
	contentSize?:ValueTypes["FieldMeta"],
	misc?:ValueTypes["FieldMeta"],
	hero?:ValueTypes["FieldMeta"],
	gallery?:ValueTypes["FieldMeta"],
	socialsAndApps?:ValueTypes["FieldMeta"],
	productGrid?:ValueTypes["FieldMeta"],
	productBanners?:ValueTypes["FieldMeta"],
	deliveryRegions?:ValueTypes["FieldMeta"],
	textList?:ValueTypes["FieldMeta"],
	gridTiles?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Link"]: AliasType<{
	_meta?:ValueTypes["LinkMeta"],
	id?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	externalLink?:boolean | `@${string}`,
internalLink?: [{	filter?: ValueTypes["LinkableWhere"] | undefined | null},ValueTypes["Linkable"]],
		__typename?: boolean | `@${string}`
}>;
	["LinkMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	externalLink?:ValueTypes["FieldMeta"],
	internalLink?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Linkable"]: AliasType<{
	_meta?:ValueTypes["LinkableMeta"],
	id?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
blogPost?: [{	filter?: ValueTypes["BlogPostLocaleWhere"] | undefined | null},ValueTypes["BlogPostLocale"]],
page?: [{	filter?: ValueTypes["PageLocaleWhere"] | undefined | null},ValueTypes["PageLocale"]],
wikiPage?: [{	filter?: ValueTypes["WikiPageWhere"] | undefined | null},ValueTypes["WikiPage"]],
redirect?: [{	filter?: ValueTypes["RedirectWhere"] | undefined | null},ValueTypes["Redirect"]],
		__typename?: boolean | `@${string}`
}>;
	["LinkableMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	blogPost?:ValueTypes["FieldMeta"],
	page?:ValueTypes["FieldMeta"],
	wikiPage?:ValueTypes["FieldMeta"],
	redirect?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PageLocale"]: AliasType<{
	_meta?:ValueTypes["PageLocaleMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
link?: [{	filter?: ValueTypes["LinkableWhere"] | undefined | null},ValueTypes["Linkable"]],
root?: [{	filter?: ValueTypes["PageWhere"] | undefined | null},ValueTypes["Page"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null},ValueTypes["Locale"]],
seo?: [{	filter?: ValueTypes["SeoWhere"] | undefined | null},ValueTypes["Seo"]],
content?: [{	filter?: ValueTypes["ContentWhere"] | undefined | null},ValueTypes["Content"]],
cover?: [{	filter?: ValueTypes["CoverWhere"] | undefined | null},ValueTypes["Cover"]],
	theme?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PageLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	cover?:ValueTypes["FieldMeta"],
	theme?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Page"]: AliasType<{
	_meta?:ValueTypes["PageMeta"],
	id?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["PageLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PageLocale"]],
localesByLocale?: [{	by: ValueTypes["PageLocalesByLocaleUniqueWhere"],	filter?: ValueTypes["PageLocaleWhere"] | undefined | null},ValueTypes["PageLocale"]],
localesByLink?: [{	by: ValueTypes["PageLocalesByLinkUniqueWhere"],	filter?: ValueTypes["PageLocaleWhere"] | undefined | null},ValueTypes["PageLocale"]],
localesBySeo?: [{	by: ValueTypes["PageLocalesBySeoUniqueWhere"],	filter?: ValueTypes["PageLocaleWhere"] | undefined | null},ValueTypes["PageLocale"]],
localesByContent?: [{	by: ValueTypes["PageLocalesByContentUniqueWhere"],	filter?: ValueTypes["PageLocaleWhere"] | undefined | null},ValueTypes["PageLocale"]],
localesByCover?: [{	by: ValueTypes["PageLocalesByCoverUniqueWhere"],	filter?: ValueTypes["PageLocaleWhere"] | undefined | null},ValueTypes["PageLocale"]],
paginateLocales?: [{	filter?: ValueTypes["PageLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PageLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["PageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PageLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null
};
	["PageLocalesByLinkUniqueWhere"]: {
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null
};
	["PageLocalesBySeoUniqueWhere"]: {
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null
};
	["PageLocalesByContentUniqueWhere"]: {
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null
};
	["PageLocalesByCoverUniqueWhere"]: {
	cover?: ValueTypes["CoverUniqueWhere"] | undefined | null
};
	["PageLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PageLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PageLocaleEdge"]: AliasType<{
	node?:ValueTypes["PageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["Seo"]: AliasType<{
	_meta?:ValueTypes["SeoMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	ogTitle?:boolean | `@${string}`,
	ogDescription?:boolean | `@${string}`,
ogImage?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null},ValueTypes["Image"]],
		__typename?: boolean | `@${string}`
}>;
	["SeoMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
	ogTitle?:ValueTypes["FieldMeta"],
	ogDescription?:ValueTypes["FieldMeta"],
	ogImage?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["WikiPage"]: AliasType<{
	_meta?:ValueTypes["WikiPageMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	emoji?:boolean | `@${string}`,
link?: [{	filter?: ValueTypes["LinkableWhere"] | undefined | null},ValueTypes["Linkable"]],
parent?: [{	filter?: ValueTypes["WikiPageWhere"] | undefined | null},ValueTypes["WikiPage"]],
children?: [{	filter?: ValueTypes["WikiPageWhere"] | undefined | null,	orderBy?: Array<ValueTypes["WikiPageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["WikiPage"]],
content?: [{	filter?: ValueTypes["ContentWhere"] | undefined | null},ValueTypes["Content"]],
childrenByLink?: [{	by: ValueTypes["WikiPageChildrenByLinkUniqueWhere"],	filter?: ValueTypes["WikiPageWhere"] | undefined | null},ValueTypes["WikiPage"]],
childrenByChildren?: [{	by: ValueTypes["WikiPageChildrenByChildrenUniqueWhere"],	filter?: ValueTypes["WikiPageWhere"] | undefined | null},ValueTypes["WikiPage"]],
childrenByContent?: [{	by: ValueTypes["WikiPageChildrenByContentUniqueWhere"],	filter?: ValueTypes["WikiPageWhere"] | undefined | null},ValueTypes["WikiPage"]],
paginateChildren?: [{	filter?: ValueTypes["WikiPageWhere"] | undefined | null,	orderBy?: Array<ValueTypes["WikiPageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["WikiPageConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["WikiPageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	emoji?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	parent?:ValueTypes["FieldMeta"],
	children?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["WikiPageChildrenByLinkUniqueWhere"]: {
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null
};
	["WikiPageChildrenByChildrenUniqueWhere"]: {
	children?: ValueTypes["WikiPageUniqueWhere"] | undefined | null
};
	["WikiPageChildrenByContentUniqueWhere"]: {
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null
};
	["WikiPageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["WikiPageEdge"],
		__typename?: boolean | `@${string}`
}>;
	["WikiPageEdge"]: AliasType<{
	node?:ValueTypes["WikiPage"],
		__typename?: boolean | `@${string}`
}>;
	["Redirect"]: AliasType<{
	_meta?:ValueTypes["RedirectMeta"],
	id?:boolean | `@${string}`,
link?: [{	filter?: ValueTypes["LinkableWhere"] | undefined | null},ValueTypes["Linkable"]],
target?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null},ValueTypes["Link"]],
		__typename?: boolean | `@${string}`
}>;
	["RedirectMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	target?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["BlogPostList"]: AliasType<{
	_meta?:ValueTypes["BlogPostListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["BlogPostListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BlogPostListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BlogPostListItem"]],
paginateItems?: [{	filter?: ValueTypes["BlogPostListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BlogPostListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BlogPostListItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["BlogPostListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["BlogPostListItem"]: AliasType<{
	_meta?:ValueTypes["BlogPostListItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	caption?:boolean | `@${string}`,
list?: [{	filter?: ValueTypes["BlogPostListWhere"] | undefined | null},ValueTypes["BlogPostList"]],
blogPost?: [{	filter?: ValueTypes["BlogPostLocaleWhere"] | undefined | null},ValueTypes["BlogPostLocale"]],
		__typename?: boolean | `@${string}`
}>;
	["BlogPostListItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	caption?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	blogPost?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["BlogPostListItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null,
	caption?: ValueTypes["OrderDirection"] | undefined | null,
	list?: ValueTypes["BlogPostListOrderBy"] | undefined | null,
	blogPost?: ValueTypes["BlogPostLocaleOrderBy"] | undefined | null
};
	["BlogPostListOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null
};
	["BlogPostListItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BlogPostListItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["BlogPostListItemEdge"]: AliasType<{
	node?:ValueTypes["BlogPostListItem"],
		__typename?: boolean | `@${string}`
}>;
	["LinkList"]: AliasType<{
	_meta?:ValueTypes["LinkListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["LinkListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LinkListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["LinkListItem"]],
paginateItems?: [{	filter?: ValueTypes["LinkListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LinkListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["LinkListItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["LinkListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["LinkListItem"]: AliasType<{
	_meta?:ValueTypes["LinkListItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	isPrimary?:boolean | `@${string}`,
list?: [{	filter?: ValueTypes["LinkListWhere"] | undefined | null},ValueTypes["LinkList"]],
link?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null},ValueTypes["Link"]],
		__typename?: boolean | `@${string}`
}>;
	["LinkListItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	isPrimary?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["LinkListItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null,
	isPrimary?: ValueTypes["OrderDirection"] | undefined | null,
	list?: ValueTypes["LinkListOrderBy"] | undefined | null,
	link?: ValueTypes["LinkOrderBy"] | undefined | null
};
	["LinkListOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null
};
	["LinkListItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LinkListItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["LinkListItemEdge"]: AliasType<{
	node?:ValueTypes["LinkListItem"],
		__typename?: boolean | `@${string}`
}>;
	["Hero"]: AliasType<{
	_meta?:ValueTypes["HeroMeta"],
	id?:boolean | `@${string}`,
	showLogo?:boolean | `@${string}`,
	middleContent?:boolean | `@${string}`,
medium?: [{	filter?: ValueTypes["MediumWhere"] | undefined | null},ValueTypes["Medium"]],
		__typename?: boolean | `@${string}`
}>;
	["HeroMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	showLogo?:ValueTypes["FieldMeta"],
	middleContent?:ValueTypes["FieldMeta"],
	medium?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Gallery"]: AliasType<{
	_meta?:ValueTypes["GalleryMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["GalleryItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["GalleryItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["GalleryItem"]],
paginateItems?: [{	filter?: ValueTypes["GalleryItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["GalleryItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["GalleryItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["GalleryMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryItem"]: AliasType<{
	_meta?:ValueTypes["GalleryItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	caption?:boolean | `@${string}`,
list?: [{	filter?: ValueTypes["GalleryWhere"] | undefined | null},ValueTypes["Gallery"]],
medium?: [{	filter?: ValueTypes["MediumWhere"] | undefined | null},ValueTypes["Medium"]],
		__typename?: boolean | `@${string}`
}>;
	["GalleryItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	caption?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	medium?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null,
	caption?: ValueTypes["OrderDirection"] | undefined | null,
	list?: ValueTypes["GalleryOrderBy"] | undefined | null,
	medium?: ValueTypes["MediumOrderBy"] | undefined | null
};
	["GalleryOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null
};
	["GalleryItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["GalleryItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryItemEdge"]: AliasType<{
	node?:ValueTypes["GalleryItem"],
		__typename?: boolean | `@${string}`
}>;
	["SocialsAndApps"]: AliasType<{
	_meta?:ValueTypes["SocialsAndAppsMeta"],
	id?:boolean | `@${string}`,
	instagram?:boolean | `@${string}`,
	appStore?:boolean | `@${string}`,
	googlePlay?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SocialsAndAppsMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	instagram?:ValueTypes["FieldMeta"],
	appStore?:ValueTypes["FieldMeta"],
	googlePlay?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProductGrid"]: AliasType<{
	_meta?:ValueTypes["ProductGridMeta"],
	id?:boolean | `@${string}`,
	isCarousel?:boolean | `@${string}`,
categories?: [{	filter?: ValueTypes["ProductGridCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductGridCategoryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductGridCategory"]],
	type?:boolean | `@${string}`,
categoriesByItems?: [{	by: ValueTypes["ProductGridCategoriesByItemsUniqueWhere"],	filter?: ValueTypes["ProductGridCategoryWhere"] | undefined | null},ValueTypes["ProductGridCategory"]],
categoriesByImages?: [{	by: ValueTypes["ProductGridCategoriesByImagesUniqueWhere"],	filter?: ValueTypes["ProductGridCategoryWhere"] | undefined | null},ValueTypes["ProductGridCategory"]],
paginateCategories?: [{	filter?: ValueTypes["ProductGridCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductGridCategoryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductGridCategoryConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ProductGridMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	isCarousel?:ValueTypes["FieldMeta"],
	categories?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProductGridCategory"]: AliasType<{
	_meta?:ValueTypes["ProductGridCategoryMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["ProductGridWhere"] | undefined | null},ValueTypes["ProductGrid"]],
items?: [{	filter?: ValueTypes["ProductGridItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductGridItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductGridItem"]],
images?: [{	filter?: ValueTypes["ImageListWhere"] | undefined | null},ValueTypes["ImageList"]],
paginateItems?: [{	filter?: ValueTypes["ProductGridItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductGridItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductGridItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ProductGridCategoryMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
	images?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProductGridItem"]: AliasType<{
	_meta?:ValueTypes["ProductGridItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	lead?:boolean | `@${string}`,
product?: [{	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
medium?: [{	filter?: ValueTypes["MediumWhere"] | undefined | null},ValueTypes["Medium"]],
link?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null},ValueTypes["Link"]],
category?: [{	filter?: ValueTypes["ProductGridCategoryWhere"] | undefined | null},ValueTypes["ProductGridCategory"]],
	description?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProductGridItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	lead?:ValueTypes["FieldMeta"],
	product?:ValueTypes["FieldMeta"],
	medium?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	category?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProductGridItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null,
	title?: ValueTypes["OrderDirection"] | undefined | null,
	lead?: ValueTypes["OrderDirection"] | undefined | null,
	product?: ValueTypes["ProductOrderBy"] | undefined | null,
	medium?: ValueTypes["MediumOrderBy"] | undefined | null,
	link?: ValueTypes["LinkOrderBy"] | undefined | null,
	category?: ValueTypes["ProductGridCategoryOrderBy"] | undefined | null,
	description?: ValueTypes["OrderDirection"] | undefined | null
};
	["ProductGridCategoryOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null,
	title?: ValueTypes["OrderDirection"] | undefined | null,
	root?: ValueTypes["ProductGridOrderBy"] | undefined | null,
	images?: ValueTypes["ImageListOrderBy"] | undefined | null
};
	["ProductGridOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	isCarousel?: ValueTypes["OrderDirection"] | undefined | null,
	type?: ValueTypes["OrderDirection"] | undefined | null
};
	["ImageListOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null
};
	["ImageList"]: AliasType<{
	_meta?:ValueTypes["ImageListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["ImageListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ImageListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ImageListItem"]],
itemsByImage?: [{	by: ValueTypes["ImageListItemsByImageUniqueWhere"],	filter?: ValueTypes["ImageListItemWhere"] | undefined | null},ValueTypes["ImageListItem"]],
paginateItems?: [{	filter?: ValueTypes["ImageListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ImageListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ImageListItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ImageListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListItem"]: AliasType<{
	_meta?:ValueTypes["ImageListItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
list?: [{	filter?: ValueTypes["ImageListWhere"] | undefined | null},ValueTypes["ImageList"]],
image?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null},ValueTypes["Image"]],
		__typename?: boolean | `@${string}`
}>;
	["ImageListItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null,
	list?: ValueTypes["ImageListOrderBy"] | undefined | null,
	image?: ValueTypes["ImageOrderBy"] | undefined | null
};
	["ImageListItemsByImageUniqueWhere"]: {
	image?: ValueTypes["ImageUniqueWhere"] | undefined | null
};
	["ImageListItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ImageListItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListItemEdge"]: AliasType<{
	node?:ValueTypes["ImageListItem"],
		__typename?: boolean | `@${string}`
}>;
	["ProductGridItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductGridItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProductGridItemEdge"]: AliasType<{
	node?:ValueTypes["ProductGridItem"],
		__typename?: boolean | `@${string}`
}>;
	["ProductGridCategoriesByItemsUniqueWhere"]: {
	items?: ValueTypes["ProductGridItemUniqueWhere"] | undefined | null
};
	["ProductGridItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["ProductGridCategoriesByImagesUniqueWhere"]: {
	images?: ValueTypes["ImageListUniqueWhere"] | undefined | null
};
	["ProductGridCategoryConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductGridCategoryEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProductGridCategoryEdge"]: AliasType<{
	node?:ValueTypes["ProductGridCategory"],
		__typename?: boolean | `@${string}`
}>;
	["ProductBannerList"]: AliasType<{
	_meta?:ValueTypes["ProductBannerListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["ProductBannerItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductBannerItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductBannerItem"]],
paginateItems?: [{	filter?: ValueTypes["ProductBannerItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductBannerItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductBannerItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ProductBannerListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProductBannerItem"]: AliasType<{
	_meta?:ValueTypes["ProductBannerItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
list?: [{	filter?: ValueTypes["ProductBannerListWhere"] | undefined | null},ValueTypes["ProductBannerList"]],
banner?: [{	filter?: ValueTypes["ProductBannerWhere"] | undefined | null},ValueTypes["ProductBanner"]],
	size?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProductBannerItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	banner?:ValueTypes["FieldMeta"],
	size?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProductBanner"]: AliasType<{
	_meta?:ValueTypes["ProductBannerMeta"],
	id?:boolean | `@${string}`,
	beforeTitle?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	label?:boolean | `@${string}`,
button?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null},ValueTypes["Link"]],
backgroundImage?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null},ValueTypes["Image"]],
productImage?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null},ValueTypes["Image"]],
product?: [{	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
		__typename?: boolean | `@${string}`
}>;
	["ProductBannerMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	beforeTitle?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	label?:ValueTypes["FieldMeta"],
	button?:ValueTypes["FieldMeta"],
	backgroundImage?:ValueTypes["FieldMeta"],
	productImage?:ValueTypes["FieldMeta"],
	product?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProductBannerItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null,
	list?: ValueTypes["ProductBannerListOrderBy"] | undefined | null,
	banner?: ValueTypes["ProductBannerOrderBy"] | undefined | null,
	size?: ValueTypes["OrderDirection"] | undefined | null
};
	["ProductBannerListOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null
};
	["ProductBannerOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	beforeTitle?: ValueTypes["OrderDirection"] | undefined | null,
	title?: ValueTypes["OrderDirection"] | undefined | null,
	label?: ValueTypes["OrderDirection"] | undefined | null,
	button?: ValueTypes["LinkOrderBy"] | undefined | null,
	backgroundImage?: ValueTypes["ImageOrderBy"] | undefined | null,
	productImage?: ValueTypes["ImageOrderBy"] | undefined | null,
	product?: ValueTypes["ProductOrderBy"] | undefined | null
};
	["ProductBannerItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductBannerItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProductBannerItemEdge"]: AliasType<{
	node?:ValueTypes["ProductBannerItem"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryRegions"]: AliasType<{
	_meta?:ValueTypes["DeliveryRegionsMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["DeliveryRegionsItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryRegionsItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["DeliveryRegionsItem"]],
itemsByImage?: [{	by: ValueTypes["DeliveryRegionsItemsByImageUniqueWhere"],	filter?: ValueTypes["DeliveryRegionsItemWhere"] | undefined | null},ValueTypes["DeliveryRegionsItem"]],
itemsByTextList?: [{	by: ValueTypes["DeliveryRegionsItemsByTextListUniqueWhere"],	filter?: ValueTypes["DeliveryRegionsItemWhere"] | undefined | null},ValueTypes["DeliveryRegionsItem"]],
itemsByGallery?: [{	by: ValueTypes["DeliveryRegionsItemsByGalleryUniqueWhere"],	filter?: ValueTypes["DeliveryRegionsItemWhere"] | undefined | null},ValueTypes["DeliveryRegionsItem"]],
paginateItems?: [{	filter?: ValueTypes["DeliveryRegionsItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryRegionsItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["DeliveryRegionsItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryRegionsMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryRegionsItem"]: AliasType<{
	_meta?:ValueTypes["DeliveryRegionsItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	offerLabel?:boolean | `@${string}`,
list?: [{	filter?: ValueTypes["DeliveryRegionsWhere"] | undefined | null},ValueTypes["DeliveryRegions"]],
image?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null},ValueTypes["Image"]],
textList?: [{	filter?: ValueTypes["TextListWhere"] | undefined | null},ValueTypes["TextList"]],
gallery?: [{	filter?: ValueTypes["ImageListWhere"] | undefined | null},ValueTypes["ImageList"]],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryRegionsItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	offerLabel?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	textList?:ValueTypes["FieldMeta"],
	gallery?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TextList"]: AliasType<{
	_meta?:ValueTypes["TextListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["TextItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TextItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TextItem"]],
paginateItems?: [{	filter?: ValueTypes["TextItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TextItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TextItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["TextListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TextItem"]: AliasType<{
	_meta?:ValueTypes["TextItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
list?: [{	filter?: ValueTypes["TextListWhere"] | undefined | null},ValueTypes["TextList"]],
	title?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["TextItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TextItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null,
	text?: ValueTypes["OrderDirection"] | undefined | null,
	list?: ValueTypes["TextListOrderBy"] | undefined | null,
	title?: ValueTypes["OrderDirection"] | undefined | null
};
	["TextListOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null
};
	["TextItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TextItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TextItemEdge"]: AliasType<{
	node?:ValueTypes["TextItem"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryRegionsItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null,
	title?: ValueTypes["OrderDirection"] | undefined | null,
	offerLabel?: ValueTypes["OrderDirection"] | undefined | null,
	list?: ValueTypes["DeliveryRegionsOrderBy"] | undefined | null,
	image?: ValueTypes["ImageOrderBy"] | undefined | null,
	textList?: ValueTypes["TextListOrderBy"] | undefined | null,
	gallery?: ValueTypes["ImageListOrderBy"] | undefined | null
};
	["DeliveryRegionsOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null
};
	["DeliveryRegionsItemsByImageUniqueWhere"]: {
	image?: ValueTypes["ImageUniqueWhere"] | undefined | null
};
	["DeliveryRegionsItemsByTextListUniqueWhere"]: {
	textList?: ValueTypes["TextListUniqueWhere"] | undefined | null
};
	["DeliveryRegionsItemsByGalleryUniqueWhere"]: {
	gallery?: ValueTypes["ImageListUniqueWhere"] | undefined | null
};
	["DeliveryRegionsItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["DeliveryRegionsItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryRegionsItemEdge"]: AliasType<{
	node?:ValueTypes["DeliveryRegionsItem"],
		__typename?: boolean | `@${string}`
}>;
	["GridTiles"]: AliasType<{
	_meta?:ValueTypes["GridTilesMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["GridTileItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["GridTileItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["GridTileItem"]],
itemsByLink?: [{	by: ValueTypes["GridTilesItemsByLinkUniqueWhere"],	filter?: ValueTypes["GridTileItemWhere"] | undefined | null},ValueTypes["GridTileItem"]],
paginateItems?: [{	filter?: ValueTypes["GridTileItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["GridTileItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["GridTileItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["GridTilesMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["GridTileItem"]: AliasType<{
	_meta?:ValueTypes["GridTileItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
list?: [{	filter?: ValueTypes["GridTilesWhere"] | undefined | null},ValueTypes["GridTiles"]],
medium?: [{	filter?: ValueTypes["MediumWhere"] | undefined | null},ValueTypes["Medium"]],
link?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null},ValueTypes["Link"]],
		__typename?: boolean | `@${string}`
}>;
	["GridTileItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	medium?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["GridTileItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null,
	text?: ValueTypes["OrderDirection"] | undefined | null,
	list?: ValueTypes["GridTilesOrderBy"] | undefined | null,
	medium?: ValueTypes["MediumOrderBy"] | undefined | null,
	link?: ValueTypes["LinkOrderBy"] | undefined | null
};
	["GridTilesOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null
};
	["GridTilesItemsByLinkUniqueWhere"]: {
	link?: ValueTypes["LinkUniqueWhere"] | undefined | null
};
	["LinkUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["GridTileItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["GridTileItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["GridTileItemEdge"]: AliasType<{
	node?:ValueTypes["GridTileItem"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	type?: ValueTypes["OrderDirection"] | undefined | null,
	primaryText?: ValueTypes["OrderDirection"] | undefined | null,
	secondaryText?: ValueTypes["OrderDirection"] | undefined | null,
	jsonContent?: ValueTypes["OrderDirection"] | undefined | null,
	block?: ValueTypes["ContentBlockOrderBy"] | undefined | null,
	colorPallete?: ValueTypes["ColorPalleteOrderBy"] | undefined | null,
	medium?: ValueTypes["MediumOrderBy"] | undefined | null,
	link?: ValueTypes["LinkOrderBy"] | undefined | null,
	blogPosts?: ValueTypes["BlogPostListOrderBy"] | undefined | null,
	links?: ValueTypes["LinkListOrderBy"] | undefined | null,
	products?: ValueTypes["ProductListOrderBy"] | undefined | null,
	contentSize?: ValueTypes["OrderDirection"] | undefined | null,
	misc?: ValueTypes["OrderDirection"] | undefined | null,
	hero?: ValueTypes["HeroOrderBy"] | undefined | null,
	gallery?: ValueTypes["GalleryOrderBy"] | undefined | null,
	socialsAndApps?: ValueTypes["SocialsAndAppsOrderBy"] | undefined | null,
	productGrid?: ValueTypes["ProductGridOrderBy"] | undefined | null,
	productBanners?: ValueTypes["ProductBannerListOrderBy"] | undefined | null,
	deliveryRegions?: ValueTypes["DeliveryRegionsOrderBy"] | undefined | null,
	textList?: ValueTypes["TextListOrderBy"] | undefined | null,
	gridTiles?: ValueTypes["GridTilesOrderBy"] | undefined | null
};
	["ContentBlockOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null,
	json?: ValueTypes["OrderDirection"] | undefined | null,
	content?: ValueTypes["ContentOrderBy"] | undefined | null
};
	["HeroOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	showLogo?: ValueTypes["OrderDirection"] | undefined | null,
	middleContent?: ValueTypes["OrderDirection"] | undefined | null,
	medium?: ValueTypes["MediumOrderBy"] | undefined | null
};
	["SocialsAndAppsOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	instagram?: ValueTypes["OrderDirection"] | undefined | null,
	appStore?: ValueTypes["OrderDirection"] | undefined | null,
	googlePlay?: ValueTypes["OrderDirection"] | undefined | null
};
	["ContentBlockReferencesByProductsUniqueWhere"]: {
	products?: ValueTypes["ProductListUniqueWhere"] | undefined | null
};
	["ContentBlockReferencesByProductBannersUniqueWhere"]: {
	productBanners?: ValueTypes["ProductBannerListUniqueWhere"] | undefined | null
};
	["ContentBlockReferencesByDeliveryRegionsUniqueWhere"]: {
	deliveryRegions?: ValueTypes["DeliveryRegionsUniqueWhere"] | undefined | null
};
	["ContentReferenceConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentReferenceEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceEdge"]: AliasType<{
	node?:ValueTypes["ContentReference"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlocksByReferencesUniqueWhere"]: {
	references?: ValueTypes["ContentReferenceUniqueWhere"] | undefined | null
};
	["ContentBlockConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentBlockEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockEdge"]: AliasType<{
	node?:ValueTypes["ContentBlock"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCataloguesIdentifier"]: AliasType<{
	_meta?:ValueTypes["TranslationCataloguesIdentifierMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
catalogue?: [{	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TranslationCatalogueOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TranslationCatalogue"]],
catalogueByDomain?: [{	by: ValueTypes["TranslationCataloguesIdentifierCatalogueByDomainUniqueWhere"],	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null},ValueTypes["TranslationCatalogue"]],
catalogueByValues?: [{	by: ValueTypes["TranslationCataloguesIdentifierCatalogueByValuesUniqueWhere"],	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null},ValueTypes["TranslationCatalogue"]],
paginateCatalogue?: [{	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TranslationCatalogueOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TranslationCatalogueConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCataloguesIdentifierMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	code?:ValueTypes["FieldMeta"],
	catalogue?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCatalogue"]: AliasType<{
	_meta?:ValueTypes["TranslationCatalogueMeta"],
	id?:boolean | `@${string}`,
domain?: [{	filter?: ValueTypes["TranslationDomainWhere"] | undefined | null},ValueTypes["TranslationDomain"]],
fallback?: [{	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null},ValueTypes["TranslationCatalogue"]],
values?: [{	filter?: ValueTypes["TranslationValueWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TranslationValueOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TranslationValue"]],
identifier?: [{	filter?: ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null},ValueTypes["TranslationCataloguesIdentifier"]],
valuesByKey?: [{	by: ValueTypes["TranslationCatalogueValuesByKeyUniqueWhere"],	filter?: ValueTypes["TranslationValueWhere"] | undefined | null},ValueTypes["TranslationValue"]],
paginateValues?: [{	filter?: ValueTypes["TranslationValueWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TranslationValueOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TranslationValueConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCatalogueMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	domain?:ValueTypes["FieldMeta"],
	fallback?:ValueTypes["FieldMeta"],
	values?:ValueTypes["FieldMeta"],
	identifier?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationDomain"]: AliasType<{
	_meta?:ValueTypes["TranslationDomainMeta"],
	id?:boolean | `@${string}`,
	identifier?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
catalogues?: [{	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TranslationCatalogueOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TranslationCatalogue"]],
keys?: [{	filter?: ValueTypes["TranslationKeyWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TranslationKeyOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TranslationKey"]],
cataloguesByIdentifier?: [{	by: ValueTypes["TranslationDomainCataloguesByIdentifierUniqueWhere"],	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null},ValueTypes["TranslationCatalogue"]],
cataloguesByValues?: [{	by: ValueTypes["TranslationDomainCataloguesByValuesUniqueWhere"],	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null},ValueTypes["TranslationCatalogue"]],
keysByIdentifier?: [{	by: ValueTypes["TranslationDomainKeysByIdentifierUniqueWhere"],	filter?: ValueTypes["TranslationKeyWhere"] | undefined | null},ValueTypes["TranslationKey"]],
keysByValues?: [{	by: ValueTypes["TranslationDomainKeysByValuesUniqueWhere"],	filter?: ValueTypes["TranslationKeyWhere"] | undefined | null},ValueTypes["TranslationKey"]],
paginateCatalogues?: [{	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TranslationCatalogueOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TranslationCatalogueConnection"]],
paginateKeys?: [{	filter?: ValueTypes["TranslationKeyWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TranslationKeyOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TranslationKeyConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["TranslationDomainMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	identifier?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	catalogues?:ValueTypes["FieldMeta"],
	keys?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCatalogueOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	domain?: ValueTypes["TranslationDomainOrderBy"] | undefined | null,
	fallback?: ValueTypes["TranslationCatalogueOrderBy"] | undefined | null,
	identifier?: ValueTypes["TranslationCataloguesIdentifierOrderBy"] | undefined | null
};
	["TranslationDomainOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	identifier?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null
};
	["TranslationKey"]: AliasType<{
	_meta?:ValueTypes["TranslationKeyMeta"],
	id?:boolean | `@${string}`,
	identifier?:boolean | `@${string}`,
	contentType?:boolean | `@${string}`,
	note?:boolean | `@${string}`,
domain?: [{	filter?: ValueTypes["TranslationDomainWhere"] | undefined | null},ValueTypes["TranslationDomain"]],
values?: [{	filter?: ValueTypes["TranslationValueWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TranslationValueOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TranslationValue"]],
valuesByCatalogue?: [{	by: ValueTypes["TranslationKeyValuesByCatalogueUniqueWhere"],	filter?: ValueTypes["TranslationValueWhere"] | undefined | null},ValueTypes["TranslationValue"]],
paginateValues?: [{	filter?: ValueTypes["TranslationValueWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TranslationValueOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TranslationValueConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["TranslationKeyMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	identifier?:ValueTypes["FieldMeta"],
	contentType?:ValueTypes["FieldMeta"],
	note?:ValueTypes["FieldMeta"],
	domain?:ValueTypes["FieldMeta"],
	values?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationValue"]: AliasType<{
	_meta?:ValueTypes["TranslationValueMeta"],
	id?:boolean | `@${string}`,
	value?:boolean | `@${string}`,
catalogue?: [{	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null},ValueTypes["TranslationCatalogue"]],
key?: [{	filter?: ValueTypes["TranslationKeyWhere"] | undefined | null},ValueTypes["TranslationKey"]],
		__typename?: boolean | `@${string}`
}>;
	["TranslationValueMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	value?:ValueTypes["FieldMeta"],
	catalogue?:ValueTypes["FieldMeta"],
	key?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationValueOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	value?: ValueTypes["OrderDirection"] | undefined | null,
	catalogue?: ValueTypes["TranslationCatalogueOrderBy"] | undefined | null,
	key?: ValueTypes["TranslationKeyOrderBy"] | undefined | null
};
	["TranslationKeyOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	identifier?: ValueTypes["OrderDirection"] | undefined | null,
	contentType?: ValueTypes["OrderDirection"] | undefined | null,
	note?: ValueTypes["OrderDirection"] | undefined | null,
	domain?: ValueTypes["TranslationDomainOrderBy"] | undefined | null
};
	["TranslationKeyValuesByCatalogueUniqueWhere"]: {
	catalogue?: ValueTypes["TranslationCatalogueUniqueWhere"] | undefined | null
};
	["TranslationValueConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TranslationValueEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationValueEdge"]: AliasType<{
	node?:ValueTypes["TranslationValue"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationDomainCataloguesByIdentifierUniqueWhere"]: {
	identifier?: ValueTypes["TranslationCataloguesIdentifierUniqueWhere"] | undefined | null
};
	["TranslationDomainCataloguesByValuesUniqueWhere"]: {
	values?: ValueTypes["TranslationValueUniqueWhere"] | undefined | null
};
	["TranslationDomainKeysByIdentifierUniqueWhere"]: {
	identifier?: string | undefined | null
};
	["TranslationDomainKeysByValuesUniqueWhere"]: {
	values?: ValueTypes["TranslationValueUniqueWhere"] | undefined | null
};
	["TranslationCatalogueConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TranslationCatalogueEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCatalogueEdge"]: AliasType<{
	node?:ValueTypes["TranslationCatalogue"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationKeyConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TranslationKeyEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationKeyEdge"]: AliasType<{
	node?:ValueTypes["TranslationKey"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCatalogueValuesByKeyUniqueWhere"]: {
	key?: ValueTypes["TranslationKeyUniqueWhere"] | undefined | null
};
	["TranslationCataloguesIdentifierCatalogueByDomainUniqueWhere"]: {
	domain?: ValueTypes["TranslationDomainUniqueWhere"] | undefined | null
};
	["TranslationCataloguesIdentifierCatalogueByValuesUniqueWhere"]: {
	values?: ValueTypes["TranslationValueUniqueWhere"] | undefined | null
};
	["MenuLocale"]: AliasType<{
	_meta?:ValueTypes["MenuLocaleMeta"],
	id?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["SiteMenuWhere"] | undefined | null},ValueTypes["SiteMenu"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null},ValueTypes["Locale"]],
items?: [{	filter?: ValueTypes["MenuItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["MenuItem"]],
secondaryItems?: [{	filter?: ValueTypes["LinkListWhere"] | undefined | null},ValueTypes["LinkList"]],
eshopLink?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null},ValueTypes["Link"]],
itemsBySubitems?: [{	by: ValueTypes["MenuLocaleItemsBySubitemsUniqueWhere"],	filter?: ValueTypes["MenuItemWhere"] | undefined | null},ValueTypes["MenuItem"]],
paginateItems?: [{	filter?: ValueTypes["MenuItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["MenuItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["MenuLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
	secondaryItems?:ValueTypes["FieldMeta"],
	eshopLink?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["SiteMenu"]: AliasType<{
	_meta?:ValueTypes["SiteMenuMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["MenuLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["MenuLocale"]],
localesByLocale?: [{	by: ValueTypes["SiteMenuLocalesByLocaleUniqueWhere"],	filter?: ValueTypes["MenuLocaleWhere"] | undefined | null},ValueTypes["MenuLocale"]],
localesByItems?: [{	by: ValueTypes["SiteMenuLocalesByItemsUniqueWhere"],	filter?: ValueTypes["MenuLocaleWhere"] | undefined | null},ValueTypes["MenuLocale"]],
localesBySecondaryItems?: [{	by: ValueTypes["SiteMenuLocalesBySecondaryItemsUniqueWhere"],	filter?: ValueTypes["MenuLocaleWhere"] | undefined | null},ValueTypes["MenuLocale"]],
paginateLocales?: [{	filter?: ValueTypes["MenuLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["MenuLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["SiteMenuMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["MenuLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	root?: ValueTypes["SiteMenuOrderBy"] | undefined | null,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null,
	secondaryItems?: ValueTypes["LinkListOrderBy"] | undefined | null,
	eshopLink?: ValueTypes["LinkOrderBy"] | undefined | null
};
	["SiteMenuOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	unique?: ValueTypes["OrderDirection"] | undefined | null
};
	["SiteMenuLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null
};
	["SiteMenuLocalesByItemsUniqueWhere"]: {
	items?: ValueTypes["MenuItemUniqueWhere"] | undefined | null
};
	["SiteMenuLocalesBySecondaryItemsUniqueWhere"]: {
	secondaryItems?: ValueTypes["LinkListUniqueWhere"] | undefined | null
};
	["MenuLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["MenuLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["MenuLocaleEdge"]: AliasType<{
	node?:ValueTypes["MenuLocale"],
		__typename?: boolean | `@${string}`
}>;
	["MenuItem"]: AliasType<{
	_meta?:ValueTypes["MenuItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
menu?: [{	filter?: ValueTypes["MenuLocaleWhere"] | undefined | null},ValueTypes["MenuLocale"]],
link?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null},ValueTypes["Link"]],
subitems?: [{	filter?: ValueTypes["MenuSubitemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuSubitemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["MenuSubitem"]],
paginateSubitems?: [{	filter?: ValueTypes["MenuSubitemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuSubitemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["MenuSubitemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["MenuItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	menu?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	subitems?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["MenuSubitem"]: AliasType<{
	_meta?:ValueTypes["MenuSubitemMeta"],
	id?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
item?: [{	filter?: ValueTypes["MenuItemWhere"] | undefined | null},ValueTypes["MenuItem"]],
links?: [{	filter?: ValueTypes["MenuLinkListWhere"] | undefined | null},ValueTypes["MenuLinkList"]],
products?: [{	filter?: ValueTypes["MenuProductsWhere"] | undefined | null},ValueTypes["MenuProducts"]],
delivery?: [{	filter?: ValueTypes["MenuDeliveryWhere"] | undefined | null},ValueTypes["MenuDelivery"]],
contact?: [{	filter?: ValueTypes["MenuContactWhere"] | undefined | null},ValueTypes["MenuContact"]],
	order?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["MenuSubitemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	item?:ValueTypes["FieldMeta"],
	links?:ValueTypes["FieldMeta"],
	products?:ValueTypes["FieldMeta"],
	delivery?:ValueTypes["FieldMeta"],
	contact?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["MenuLinkList"]: AliasType<{
	_meta?:ValueTypes["MenuLinkListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["MenuLinkItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuLinkItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["MenuLinkItem"]],
paginateItems?: [{	filter?: ValueTypes["MenuLinkItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuLinkItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["MenuLinkItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["MenuLinkListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["MenuLinkItem"]: AliasType<{
	_meta?:ValueTypes["MenuLinkItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
list?: [{	filter?: ValueTypes["MenuLinkListWhere"] | undefined | null},ValueTypes["MenuLinkList"]],
link?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null},ValueTypes["Link"]],
image?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null},ValueTypes["Image"]],
	description?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["MenuLinkItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["MenuLinkItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null,
	list?: ValueTypes["MenuLinkListOrderBy"] | undefined | null,
	link?: ValueTypes["LinkOrderBy"] | undefined | null,
	image?: ValueTypes["ImageOrderBy"] | undefined | null,
	description?: ValueTypes["OrderDirection"] | undefined | null
};
	["MenuLinkListOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null
};
	["MenuLinkItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["MenuLinkItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["MenuLinkItemEdge"]: AliasType<{
	node?:ValueTypes["MenuLinkItem"],
		__typename?: boolean | `@${string}`
}>;
	["MenuProducts"]: AliasType<{
	_meta?:ValueTypes["MenuProductsMeta"],
	id?:boolean | `@${string}`,
links?: [{	filter?: ValueTypes["MenuLinkListWhere"] | undefined | null},ValueTypes["MenuLinkList"]],
buttons?: [{	filter?: ValueTypes["LinkListWhere"] | undefined | null},ValueTypes["LinkList"]],
		__typename?: boolean | `@${string}`
}>;
	["MenuProductsMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	links?:ValueTypes["FieldMeta"],
	buttons?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["MenuDelivery"]: AliasType<{
	_meta?:ValueTypes["MenuDeliveryMeta"],
	id?:boolean | `@${string}`,
deliveryRegions?: [{	filter?: ValueTypes["DeliveryRegionsWhere"] | undefined | null},ValueTypes["DeliveryRegions"]],
	text?:boolean | `@${string}`,
socialsAndApps?: [{	filter?: ValueTypes["SocialsAndAppsWhere"] | undefined | null},ValueTypes["SocialsAndApps"]],
		__typename?: boolean | `@${string}`
}>;
	["MenuDeliveryMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	deliveryRegions?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	socialsAndApps?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["MenuContact"]: AliasType<{
	_meta?:ValueTypes["MenuContactMeta"],
	id?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
image?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null},ValueTypes["Image"]],
		__typename?: boolean | `@${string}`
}>;
	["MenuContactMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["MenuSubitemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	type?: ValueTypes["OrderDirection"] | undefined | null,
	title?: ValueTypes["OrderDirection"] | undefined | null,
	item?: ValueTypes["MenuItemOrderBy"] | undefined | null,
	links?: ValueTypes["MenuLinkListOrderBy"] | undefined | null,
	products?: ValueTypes["MenuProductsOrderBy"] | undefined | null,
	delivery?: ValueTypes["MenuDeliveryOrderBy"] | undefined | null,
	contact?: ValueTypes["MenuContactOrderBy"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null
};
	["MenuItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null,
	menu?: ValueTypes["MenuLocaleOrderBy"] | undefined | null,
	link?: ValueTypes["LinkOrderBy"] | undefined | null
};
	["MenuProductsOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	links?: ValueTypes["MenuLinkListOrderBy"] | undefined | null,
	buttons?: ValueTypes["LinkListOrderBy"] | undefined | null
};
	["MenuDeliveryOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	deliveryRegions?: ValueTypes["DeliveryRegionsOrderBy"] | undefined | null,
	text?: ValueTypes["OrderDirection"] | undefined | null,
	socialsAndApps?: ValueTypes["SocialsAndAppsOrderBy"] | undefined | null
};
	["MenuContactOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	text?: ValueTypes["OrderDirection"] | undefined | null,
	image?: ValueTypes["ImageOrderBy"] | undefined | null
};
	["MenuSubitemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["MenuSubitemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["MenuSubitemEdge"]: AliasType<{
	node?:ValueTypes["MenuSubitem"],
		__typename?: boolean | `@${string}`
}>;
	["MenuLocaleItemsBySubitemsUniqueWhere"]: {
	subitems?: ValueTypes["MenuSubitemUniqueWhere"] | undefined | null
};
	["MenuItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["MenuItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["MenuItemEdge"]: AliasType<{
	node?:ValueTypes["MenuItem"],
		__typename?: boolean | `@${string}`
}>;
	["ProductPackingLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	shortName?: ValueTypes["OrderDirection"] | undefined | null,
	description?: ValueTypes["OrderDirection"] | undefined | null,
	root?: ValueTypes["ProductPackingOrderBy"] | undefined | null,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null
};
	["ProductLocale"]: AliasType<{
	_meta?:ValueTypes["ProductLocaleMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null},ValueTypes["Locale"]],
featureList?: [{	filter?: ValueTypes["TextListWhere"] | undefined | null},ValueTypes["TextList"]],
	printableName?:boolean | `@${string}`,
	firstSticker?:boolean | `@${string}`,
	secondSticker?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProductLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	featureList?:ValueTypes["FieldMeta"],
	printableName?:ValueTypes["FieldMeta"],
	firstSticker?:ValueTypes["FieldMeta"],
	secondSticker?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProductLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	description?: ValueTypes["OrderDirection"] | undefined | null,
	root?: ValueTypes["ProductOrderBy"] | undefined | null,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null,
	featureList?: ValueTypes["TextListOrderBy"] | undefined | null,
	printableName?: ValueTypes["OrderDirection"] | undefined | null,
	firstSticker?: ValueTypes["OrderDirection"] | undefined | null,
	secondSticker?: ValueTypes["OrderDirection"] | undefined | null
};
	["ProductRecipeLocale"]: AliasType<{
	_meta?:ValueTypes["ProductRecipeLocaleMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["ProductRecipeWhere"] | undefined | null},ValueTypes["ProductRecipe"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null},ValueTypes["Locale"]],
	description?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProductRecipeLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProductRecipe"]: AliasType<{
	_meta?:ValueTypes["ProductRecipeMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
products?: [{	filter?: ValueTypes["ProductWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Product"]],
	internalNote?:boolean | `@${string}`,
	color?:boolean | `@${string}`,
image?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null},ValueTypes["Image"]],
icon?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null},ValueTypes["Image"]],
ingredients?: [{	filter?: ValueTypes["ProductIngredientItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductIngredientItem"]],
	needsPrepping?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["ProductRecipeLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductRecipeLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductRecipeLocale"]],
	gutTuning?:boolean | `@${string}`,
freshingContainer?: [{	filter?: ValueTypes["FreshingContainerWhere"] | undefined | null},ValueTypes["FreshingContainer"]],
	description?:boolean | `@${string}`,
nutritionFacts?: [{	filter?: ValueTypes["NutritionFactsWhere"] | undefined | null},ValueTypes["NutritionFacts"]],
productsByCode?: [{	by: ValueTypes["ProductRecipeProductsByCodeUniqueWhere"],	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
productsByStocks?: [{	by: ValueTypes["ProductRecipeProductsByStocksUniqueWhere"],	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
productsByGroupPrices?: [{	by: ValueTypes["ProductRecipeProductsByGroupPricesUniqueWhere"],	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
productsByCartItems?: [{	by: ValueTypes["ProductRecipeProductsByCartItemsUniqueWhere"],	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
productsByOrderItems?: [{	by: ValueTypes["ProductRecipeProductsByOrderItemsUniqueWhere"],	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
productsByInheritedCategories?: [{	by: ValueTypes["ProductRecipeProductsByInheritedCategoriesUniqueWhere"],	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
productsByLocales?: [{	by: ValueTypes["ProductRecipeProductsByLocalesUniqueWhere"],	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
productsByCustomerPrices?: [{	by: ValueTypes["ProductRecipeProductsByCustomerPricesUniqueWhere"],	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
productsByVirtualProduct?: [{	by: ValueTypes["ProductRecipeProductsByVirtualProductUniqueWhere"],	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
productsByMeta?: [{	by: ValueTypes["ProductRecipeProductsByMetaUniqueWhere"],	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
productsByPage?: [{	by: ValueTypes["ProductRecipeProductsByPageUniqueWhere"],	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
productsBySalesDays?: [{	by: ValueTypes["ProductRecipeProductsBySalesDaysUniqueWhere"],	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
productsBySalesWeeks?: [{	by: ValueTypes["ProductRecipeProductsBySalesWeeksUniqueWhere"],	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
productsBySalesMonths?: [{	by: ValueTypes["ProductRecipeProductsBySalesMonthsUniqueWhere"],	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
ingredientsByQuantity?: [{	by: ValueTypes["ProductRecipeIngredientsByQuantityUniqueWhere"],	filter?: ValueTypes["ProductIngredientItemWhere"] | undefined | null},ValueTypes["ProductIngredientItem"]],
localesByLocale?: [{	by: ValueTypes["ProductRecipeLocalesByLocaleUniqueWhere"],	filter?: ValueTypes["ProductRecipeLocaleWhere"] | undefined | null},ValueTypes["ProductRecipeLocale"]],
paginateProducts?: [{	filter?: ValueTypes["ProductWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductConnection"]],
paginateIngredients?: [{	filter?: ValueTypes["ProductIngredientItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductIngredientItemConnection"]],
paginateLocales?: [{	filter?: ValueTypes["ProductRecipeLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductRecipeLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductRecipeLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ProductRecipeMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	products?:ValueTypes["FieldMeta"],
	internalNote?:ValueTypes["FieldMeta"],
	color?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	icon?:ValueTypes["FieldMeta"],
	ingredients?:ValueTypes["FieldMeta"],
	needsPrepping?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	gutTuning?:ValueTypes["FieldMeta"],
	freshingContainer?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
	nutritionFacts?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientItem"]: AliasType<{
	_meta?:ValueTypes["ProductIngredientItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	internalOrder?:boolean | `@${string}`,
recipe?: [{	filter?: ValueTypes["ProductRecipeWhere"] | undefined | null},ValueTypes["ProductRecipe"]],
ingredient?: [{	filter?: ValueTypes["ProductIngredientWhere"] | undefined | null},ValueTypes["ProductIngredient"]],
quantity?: [{	filter?: ValueTypes["ProductIngredientItemQuantityWhere"] | undefined | null},ValueTypes["ProductIngredientItemQuantity"]],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	internalOrder?:ValueTypes["FieldMeta"],
	recipe?:ValueTypes["FieldMeta"],
	ingredient?:ValueTypes["FieldMeta"],
	quantity?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientItemQuantity"]: AliasType<{
	_meta?:ValueTypes["ProductIngredientItemQuantityMeta"],
	id?:boolean | `@${string}`,
unit?: [{	filter?: ValueTypes["ProductIngredientItemQuantityUnitWhere"] | undefined | null},ValueTypes["ProductIngredientItemQuantityUnit"]],
	value?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientItemQuantityMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unit?:ValueTypes["FieldMeta"],
	value?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null,
	internalOrder?: ValueTypes["OrderDirection"] | undefined | null,
	recipe?: ValueTypes["ProductRecipeOrderBy"] | undefined | null,
	ingredient?: ValueTypes["ProductIngredientOrderBy"] | undefined | null,
	quantity?: ValueTypes["ProductIngredientItemQuantityOrderBy"] | undefined | null
};
	["ProductIngredientItemQuantityOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	unit?: ValueTypes["ProductIngredientItemQuantityUnitOrderBy"] | undefined | null,
	value?: ValueTypes["OrderDirection"] | undefined | null
};
	["ProductRecipeLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	root?: ValueTypes["ProductRecipeOrderBy"] | undefined | null,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null,
	description?: ValueTypes["OrderDirection"] | undefined | null
};
	["NutritionFacts"]: AliasType<{
	_meta?:ValueTypes["NutritionFactsMeta"],
	id?:boolean | `@${string}`,
	energyKiloJoule?:boolean | `@${string}`,
	energyKiloCalorie?:boolean | `@${string}`,
	fatsGrams?:boolean | `@${string}`,
	fatsOfWhichSaturatedGrams?:boolean | `@${string}`,
	carbohydrateGrams?:boolean | `@${string}`,
	carbohydrateOfWhichSugarsGrams?:boolean | `@${string}`,
	proteinGrams?:boolean | `@${string}`,
	fibreGrams?:boolean | `@${string}`,
	saltGrams?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["NutritionFactsMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	energyKiloJoule?:ValueTypes["FieldMeta"],
	energyKiloCalorie?:ValueTypes["FieldMeta"],
	fatsGrams?:ValueTypes["FieldMeta"],
	fatsOfWhichSaturatedGrams?:ValueTypes["FieldMeta"],
	carbohydrateGrams?:ValueTypes["FieldMeta"],
	carbohydrateOfWhichSugarsGrams?:ValueTypes["FieldMeta"],
	proteinGrams?:ValueTypes["FieldMeta"],
	fibreGrams?:ValueTypes["FieldMeta"],
	saltGrams?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProductRecipeProductsByCodeUniqueWhere"]: {
	code?: string | undefined | null
};
	["ProductRecipeProductsByStocksUniqueWhere"]: {
	stocks?: ValueTypes["ProductStockUniqueWhere"] | undefined | null
};
	["ProductRecipeProductsByGroupPricesUniqueWhere"]: {
	groupPrices?: ValueTypes["ProductGroupPriceUniqueWhere"] | undefined | null
};
	["ProductRecipeProductsByCartItemsUniqueWhere"]: {
	cartItems?: ValueTypes["CartItemUniqueWhere"] | undefined | null
};
	["ProductRecipeProductsByOrderItemsUniqueWhere"]: {
	orderItems?: ValueTypes["OrderItemUniqueWhere"] | undefined | null
};
	["ProductRecipeProductsByInheritedCategoriesUniqueWhere"]: {
	inheritedCategories?: ValueTypes["NestedProductCategoryProductUniqueWhere"] | undefined | null
};
	["ProductRecipeProductsByLocalesUniqueWhere"]: {
	locales?: ValueTypes["ProductLocaleUniqueWhere"] | undefined | null
};
	["ProductRecipeProductsByCustomerPricesUniqueWhere"]: {
	customerPrices?: ValueTypes["ProductCustomerPriceUniqueWhere"] | undefined | null
};
	["ProductRecipeProductsByVirtualProductUniqueWhere"]: {
	virtualProduct?: ValueTypes["VirtualProductUniqueWhere"] | undefined | null
};
	["ProductRecipeProductsByMetaUniqueWhere"]: {
	meta?: ValueTypes["ProductMetadataUniqueWhere"] | undefined | null
};
	["ProductRecipeProductsByPageUniqueWhere"]: {
	page?: ValueTypes["PageUniqueWhere"] | undefined | null
};
	["ProductRecipeProductsBySalesDaysUniqueWhere"]: {
	salesDays?: ValueTypes["ProductSalesDayUniqueWhere"] | undefined | null
};
	["ProductRecipeProductsBySalesWeeksUniqueWhere"]: {
	salesWeeks?: ValueTypes["ProductSalesWeekUniqueWhere"] | undefined | null
};
	["ProductRecipeProductsBySalesMonthsUniqueWhere"]: {
	salesMonths?: ValueTypes["ProductSalesMonthUniqueWhere"] | undefined | null
};
	["ProductRecipeIngredientsByQuantityUniqueWhere"]: {
	quantity?: ValueTypes["ProductIngredientItemQuantityUniqueWhere"] | undefined | null
};
	["ProductRecipeLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null
};
	["ProductIngredientItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductIngredientItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientItemEdge"]: AliasType<{
	node?:ValueTypes["ProductIngredientItem"],
		__typename?: boolean | `@${string}`
}>;
	["ProductRecipeLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductRecipeLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProductRecipeLocaleEdge"]: AliasType<{
	node?:ValueTypes["ProductRecipeLocale"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryMethodLocale"]: AliasType<{
	_meta?:ValueTypes["DeliveryMethodLocaleMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	trackingCodeUrlTemplate?:boolean | `@${string}`,
	processingTitle?:boolean | `@${string}`,
	processingText?:boolean | `@${string}`,
	processingIconUrl?:boolean | `@${string}`,
	dispatchedTitle?:boolean | `@${string}`,
	dispatchedText?:boolean | `@${string}`,
	dispatchedIconUrl?:boolean | `@${string}`,
	fulfilledTitle?:boolean | `@${string}`,
	fulfilledText?:boolean | `@${string}`,
	fulfilledIconUrl?:boolean | `@${string}`,
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null},ValueTypes["Locale"]],
root?: [{	filter?: ValueTypes["DeliveryMethodWhere"] | undefined | null},ValueTypes["DeliveryMethod"]],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryMethodLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
	trackingCodeUrlTemplate?:ValueTypes["FieldMeta"],
	processingTitle?:ValueTypes["FieldMeta"],
	processingText?:ValueTypes["FieldMeta"],
	processingIconUrl?:ValueTypes["FieldMeta"],
	dispatchedTitle?:ValueTypes["FieldMeta"],
	dispatchedText?:ValueTypes["FieldMeta"],
	dispatchedIconUrl?:ValueTypes["FieldMeta"],
	fulfilledTitle?:ValueTypes["FieldMeta"],
	fulfilledText?:ValueTypes["FieldMeta"],
	fulfilledIconUrl?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryMethodLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	description?: ValueTypes["OrderDirection"] | undefined | null,
	trackingCodeUrlTemplate?: ValueTypes["OrderDirection"] | undefined | null,
	processingTitle?: ValueTypes["OrderDirection"] | undefined | null,
	processingText?: ValueTypes["OrderDirection"] | undefined | null,
	processingIconUrl?: ValueTypes["OrderDirection"] | undefined | null,
	dispatchedTitle?: ValueTypes["OrderDirection"] | undefined | null,
	dispatchedText?: ValueTypes["OrderDirection"] | undefined | null,
	dispatchedIconUrl?: ValueTypes["OrderDirection"] | undefined | null,
	fulfilledTitle?: ValueTypes["OrderDirection"] | undefined | null,
	fulfilledText?: ValueTypes["OrderDirection"] | undefined | null,
	fulfilledIconUrl?: ValueTypes["OrderDirection"] | undefined | null,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null,
	root?: ValueTypes["DeliveryMethodOrderBy"] | undefined | null
};
	["PipelineStageLocale"]: AliasType<{
	_meta?:ValueTypes["PipelineStageLocaleMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["PipelineStageWhere"] | undefined | null},ValueTypes["PipelineStage"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null},ValueTypes["Locale"]],
		__typename?: boolean | `@${string}`
}>;
	["PipelineStageLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineStage"]: AliasType<{
	_meta?:ValueTypes["PipelineStageMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["PipelineStageItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PipelineStageItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PipelineStageItem"]],
pipeline?: [{	filter?: ValueTypes["PipelineWhere"] | undefined | null},ValueTypes["Pipeline"]],
	order?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["PipelineStageLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PipelineStageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PipelineStageLocale"]],
sentiment?: [{	filter?: ValueTypes["PipelineStageSentimentWhere"] | undefined | null},ValueTypes["PipelineStageSentiment"]],
	type?:boolean | `@${string}`,
forms?: [{	filter?: ValueTypes["LeadFormWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LeadFormOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["LeadForm"]],
	showItemsWeight?:boolean | `@${string}`,
	showItemsPrice?:boolean | `@${string}`,
itemsByLead?: [{	by: ValueTypes["PipelineStageItemsByLeadUniqueWhere"],	filter?: ValueTypes["PipelineStageItemWhere"] | undefined | null},ValueTypes["PipelineStageItem"]],
localesByLocale?: [{	by: ValueTypes["PipelineStageLocalesByLocaleUniqueWhere"],	filter?: ValueTypes["PipelineStageLocaleWhere"] | undefined | null},ValueTypes["PipelineStageLocale"]],
formsByCode?: [{	by: ValueTypes["PipelineStageFormsByCodeUniqueWhere"],	filter?: ValueTypes["LeadFormWhere"] | undefined | null},ValueTypes["LeadForm"]],
formsByLeads?: [{	by: ValueTypes["PipelineStageFormsByLeadsUniqueWhere"],	filter?: ValueTypes["LeadFormWhere"] | undefined | null},ValueTypes["LeadForm"]],
paginateItems?: [{	filter?: ValueTypes["PipelineStageItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PipelineStageItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PipelineStageItemConnection"]],
paginateLocales?: [{	filter?: ValueTypes["PipelineStageLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PipelineStageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PipelineStageLocaleConnection"]],
paginateForms?: [{	filter?: ValueTypes["LeadFormWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LeadFormOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["LeadFormConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["PipelineStageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
	pipeline?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	sentiment?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	forms?:ValueTypes["FieldMeta"],
	showItemsWeight?:ValueTypes["FieldMeta"],
	showItemsPrice?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineStageItem"]: AliasType<{
	_meta?:ValueTypes["PipelineStageItemMeta"],
	id?:boolean | `@${string}`,
list?: [{	filter?: ValueTypes["PipelineStageWhere"] | undefined | null},ValueTypes["PipelineStage"]],
lead?: [{	filter?: ValueTypes["PipelineLeadWhere"] | undefined | null},ValueTypes["PipelineLead"]],
	order?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PipelineStageItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	lead?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineLead"]: AliasType<{
	_meta?:ValueTypes["PipelineLeadMeta"],
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
stageItem?: [{	filter?: ValueTypes["PipelineStageItemWhere"] | undefined | null},ValueTypes["PipelineStageItem"]],
	contactPerson?:boolean | `@${string}`,
customer?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
	cafeType?:boolean | `@${string}`,
	offerType?:boolean | `@${string}`,
	ownMachine?:boolean | `@${string}`,
	customerCity?:boolean | `@${string}`,
	companyId?:boolean | `@${string}`,
	customerName?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	phone?:boolean | `@${string}`,
form?: [{	filter?: ValueTypes["LeadFormWhere"] | undefined | null},ValueTypes["LeadForm"]],
	meta?:boolean | `@${string}`,
	multiroasterType?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PipelineLeadMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	stageItem?:ValueTypes["FieldMeta"],
	contactPerson?:ValueTypes["FieldMeta"],
	customer?:ValueTypes["FieldMeta"],
	cafeType?:ValueTypes["FieldMeta"],
	offerType?:ValueTypes["FieldMeta"],
	ownMachine?:ValueTypes["FieldMeta"],
	customerCity?:ValueTypes["FieldMeta"],
	companyId?:ValueTypes["FieldMeta"],
	customerName?:ValueTypes["FieldMeta"],
	email?:ValueTypes["FieldMeta"],
	phone?:ValueTypes["FieldMeta"],
	form?:ValueTypes["FieldMeta"],
	meta?:ValueTypes["FieldMeta"],
	multiroasterType?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["LeadForm"]: AliasType<{
	_meta?:ValueTypes["LeadFormMeta"],
	id?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
stage?: [{	filter?: ValueTypes["PipelineStageWhere"] | undefined | null},ValueTypes["PipelineStage"]],
leads?: [{	filter?: ValueTypes["PipelineLeadWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PipelineLeadOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PipelineLead"]],
leadsByStageItem?: [{	by: ValueTypes["LeadFormLeadsByStageItemUniqueWhere"],	filter?: ValueTypes["PipelineLeadWhere"] | undefined | null},ValueTypes["PipelineLead"]],
paginateLeads?: [{	filter?: ValueTypes["PipelineLeadWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PipelineLeadOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PipelineLeadConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["LeadFormMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	code?:ValueTypes["FieldMeta"],
	stage?:ValueTypes["FieldMeta"],
	leads?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineLeadOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null,
	stageItem?: ValueTypes["PipelineStageItemOrderBy"] | undefined | null,
	contactPerson?: ValueTypes["OrderDirection"] | undefined | null,
	customer?: ValueTypes["CustomerOrderBy"] | undefined | null,
	cafeType?: ValueTypes["OrderDirection"] | undefined | null,
	offerType?: ValueTypes["OrderDirection"] | undefined | null,
	ownMachine?: ValueTypes["OrderDirection"] | undefined | null,
	customerCity?: ValueTypes["OrderDirection"] | undefined | null,
	companyId?: ValueTypes["OrderDirection"] | undefined | null,
	customerName?: ValueTypes["OrderDirection"] | undefined | null,
	email?: ValueTypes["OrderDirection"] | undefined | null,
	phone?: ValueTypes["OrderDirection"] | undefined | null,
	form?: ValueTypes["LeadFormOrderBy"] | undefined | null,
	meta?: ValueTypes["OrderDirection"] | undefined | null,
	multiroasterType?: ValueTypes["OrderDirection"] | undefined | null
};
	["PipelineStageItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	list?: ValueTypes["PipelineStageOrderBy"] | undefined | null,
	lead?: ValueTypes["PipelineLeadOrderBy"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null
};
	["PipelineStageOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	pipeline?: ValueTypes["PipelineOrderBy"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null,
	sentiment?: ValueTypes["PipelineStageSentimentOrderBy"] | undefined | null,
	type?: ValueTypes["OrderDirection"] | undefined | null,
	showItemsWeight?: ValueTypes["OrderDirection"] | undefined | null,
	showItemsPrice?: ValueTypes["OrderDirection"] | undefined | null
};
	["PipelineOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	unique?: ValueTypes["OrderDirection"] | undefined | null
};
	["PipelineStageSentimentOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	internalName?: ValueTypes["OrderDirection"] | undefined | null,
	backgroundColor?: ValueTypes["OrderDirection"] | undefined | null,
	textColor?: ValueTypes["OrderDirection"] | undefined | null
};
	["LeadFormOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	code?: ValueTypes["OrderDirection"] | undefined | null,
	stage?: ValueTypes["PipelineStageOrderBy"] | undefined | null
};
	["LeadFormLeadsByStageItemUniqueWhere"]: {
	stageItem?: ValueTypes["PipelineStageItemUniqueWhere"] | undefined | null
};
	["PipelineLeadConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PipelineLeadEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineLeadEdge"]: AliasType<{
	node?:ValueTypes["PipelineLead"],
		__typename?: boolean | `@${string}`
}>;
	["Pipeline"]: AliasType<{
	_meta?:ValueTypes["PipelineMeta"],
	id?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
stages?: [{	filter?: ValueTypes["PipelineStageWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PipelineStageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PipelineStage"]],
stagesByItems?: [{	by: ValueTypes["PipelineStagesByItemsUniqueWhere"],	filter?: ValueTypes["PipelineStageWhere"] | undefined | null},ValueTypes["PipelineStage"]],
stagesByLocales?: [{	by: ValueTypes["PipelineStagesByLocalesUniqueWhere"],	filter?: ValueTypes["PipelineStageWhere"] | undefined | null},ValueTypes["PipelineStage"]],
stagesByForms?: [{	by: ValueTypes["PipelineStagesByFormsUniqueWhere"],	filter?: ValueTypes["PipelineStageWhere"] | undefined | null},ValueTypes["PipelineStage"]],
paginateStages?: [{	filter?: ValueTypes["PipelineStageWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PipelineStageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PipelineStageConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["PipelineMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	stages?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineStagesByItemsUniqueWhere"]: {
	items?: ValueTypes["PipelineStageItemUniqueWhere"] | undefined | null
};
	["PipelineStagesByLocalesUniqueWhere"]: {
	locales?: ValueTypes["PipelineStageLocaleUniqueWhere"] | undefined | null
};
	["PipelineStagesByFormsUniqueWhere"]: {
	forms?: ValueTypes["LeadFormUniqueWhere"] | undefined | null
};
	["PipelineStageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PipelineStageEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineStageEdge"]: AliasType<{
	node?:ValueTypes["PipelineStage"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineStageLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	root?: ValueTypes["PipelineStageOrderBy"] | undefined | null,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null
};
	["PipelineStageSentiment"]: AliasType<{
	_meta?:ValueTypes["PipelineStageSentimentMeta"],
	id?:boolean | `@${string}`,
	internalName?:boolean | `@${string}`,
	backgroundColor?:boolean | `@${string}`,
	textColor?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PipelineStageSentimentMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	internalName?:ValueTypes["FieldMeta"],
	backgroundColor?:ValueTypes["FieldMeta"],
	textColor?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineStageItemsByLeadUniqueWhere"]: {
	lead?: ValueTypes["PipelineLeadUniqueWhere"] | undefined | null
};
	["PipelineStageLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null
};
	["PipelineStageFormsByCodeUniqueWhere"]: {
	code?: string | undefined | null
};
	["PipelineStageFormsByLeadsUniqueWhere"]: {
	leads?: ValueTypes["PipelineLeadUniqueWhere"] | undefined | null
};
	["PipelineStageItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PipelineStageItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineStageItemEdge"]: AliasType<{
	node?:ValueTypes["PipelineStageItem"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineStageLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PipelineStageLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineStageLocaleEdge"]: AliasType<{
	node?:ValueTypes["PipelineStageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["LeadFormConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LeadFormEdge"],
		__typename?: boolean | `@${string}`
}>;
	["LeadFormEdge"]: AliasType<{
	node?:ValueTypes["LeadForm"],
		__typename?: boolean | `@${string}`
}>;
	["SubscriptionBoxLocale"]: AliasType<{
	_meta?:ValueTypes["SubscriptionBoxLocaleMeta"],
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	stickerText?:boolean | `@${string}`,
	descriptionText?:boolean | `@${string}`,
root?: [{	filter?: ValueTypes["SubscriptionBoxWhere"] | undefined | null},ValueTypes["SubscriptionBox"]],
locale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null},ValueTypes["Locale"]],
	secondaryTitle?:boolean | `@${string}`,
texts?: [{	filter?: ValueTypes["TextListWhere"] | undefined | null},ValueTypes["TextList"]],
secondaryTexts?: [{	filter?: ValueTypes["TextListWhere"] | undefined | null},ValueTypes["TextList"]],
		__typename?: boolean | `@${string}`
}>;
	["SubscriptionBoxLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	stickerText?:ValueTypes["FieldMeta"],
	descriptionText?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	secondaryTitle?:ValueTypes["FieldMeta"],
	texts?:ValueTypes["FieldMeta"],
	secondaryTexts?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["SubscriptionBox"]: AliasType<{
	_meta?:ValueTypes["SubscriptionBoxMeta"],
	id?:boolean | `@${string}`,
locales?: [{	filter?: ValueTypes["SubscriptionBoxLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SubscriptionBoxLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["SubscriptionBoxLocale"]],
	unique?:boolean | `@${string}`,
localesByLocale?: [{	by: ValueTypes["SubscriptionBoxLocalesByLocaleUniqueWhere"],	filter?: ValueTypes["SubscriptionBoxLocaleWhere"] | undefined | null},ValueTypes["SubscriptionBoxLocale"]],
localesByTexts?: [{	by: ValueTypes["SubscriptionBoxLocalesByTextsUniqueWhere"],	filter?: ValueTypes["SubscriptionBoxLocaleWhere"] | undefined | null},ValueTypes["SubscriptionBoxLocale"]],
localesBySecondaryTexts?: [{	by: ValueTypes["SubscriptionBoxLocalesBySecondaryTextsUniqueWhere"],	filter?: ValueTypes["SubscriptionBoxLocaleWhere"] | undefined | null},ValueTypes["SubscriptionBoxLocale"]],
paginateLocales?: [{	filter?: ValueTypes["SubscriptionBoxLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SubscriptionBoxLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["SubscriptionBoxLocaleConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["SubscriptionBoxMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["SubscriptionBoxLocaleOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	title?: ValueTypes["OrderDirection"] | undefined | null,
	stickerText?: ValueTypes["OrderDirection"] | undefined | null,
	descriptionText?: ValueTypes["OrderDirection"] | undefined | null,
	root?: ValueTypes["SubscriptionBoxOrderBy"] | undefined | null,
	locale?: ValueTypes["LocaleOrderBy"] | undefined | null,
	secondaryTitle?: ValueTypes["OrderDirection"] | undefined | null,
	texts?: ValueTypes["TextListOrderBy"] | undefined | null,
	secondaryTexts?: ValueTypes["TextListOrderBy"] | undefined | null
};
	["SubscriptionBoxOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	unique?: ValueTypes["OrderDirection"] | undefined | null
};
	["SubscriptionBoxLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null
};
	["SubscriptionBoxLocalesByTextsUniqueWhere"]: {
	texts?: ValueTypes["TextListUniqueWhere"] | undefined | null
};
	["SubscriptionBoxLocalesBySecondaryTextsUniqueWhere"]: {
	secondaryTexts?: ValueTypes["TextListUniqueWhere"] | undefined | null
};
	["SubscriptionBoxLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SubscriptionBoxLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["SubscriptionBoxLocaleEdge"]: AliasType<{
	node?:ValueTypes["SubscriptionBoxLocale"],
		__typename?: boolean | `@${string}`
}>;
	["LocaleBusinessCategoriesByRootUniqueWhere"]: {
	root?: ValueTypes["BusinessCategoryUniqueWhere"] | undefined | null
};
	["LocaleProductCategoryListsByRootUniqueWhere"]: {
	root?: ValueTypes["ProductCategoryListUniqueWhere"] | undefined | null
};
	["LocaleProductIngredientsByRootUniqueWhere"]: {
	root?: ValueTypes["ProductIngredientUniqueWhere"] | undefined | null
};
	["LocaleOrderRecurrencesByRootUniqueWhere"]: {
	root?: ValueTypes["OrderRecurrenceUniqueWhere"] | undefined | null
};
	["LocaleBlogsByRootUniqueWhere"]: {
	root?: ValueTypes["BlogUniqueWhere"] | undefined | null
};
	["LocaleBlogPostsByRootUniqueWhere"]: {
	root?: ValueTypes["BlogPostUniqueWhere"] | undefined | null
};
	["LocaleBlogPostsByCoverUniqueWhere"]: {
	cover?: ValueTypes["CoverUniqueWhere"] | undefined | null
};
	["LocaleBlogPostsByContentUniqueWhere"]: {
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null
};
	["LocaleBlogPostsByLinkUniqueWhere"]: {
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null
};
	["LocaleBlogPostsBySeoUniqueWhere"]: {
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null
};
	["LocaleMenusByRootUniqueWhere"]: {
	root?: ValueTypes["SiteMenuUniqueWhere"] | undefined | null
};
	["LocaleMenusByItemsUniqueWhere"]: {
	items?: ValueTypes["MenuItemUniqueWhere"] | undefined | null
};
	["LocaleMenusBySecondaryItemsUniqueWhere"]: {
	secondaryItems?: ValueTypes["LinkListUniqueWhere"] | undefined | null
};
	["LocalePagesByRootUniqueWhere"]: {
	root?: ValueTypes["PageUniqueWhere"] | undefined | null
};
	["LocalePagesByLinkUniqueWhere"]: {
	link?: ValueTypes["LinkableUniqueWhere"] | undefined | null
};
	["LocalePagesBySeoUniqueWhere"]: {
	seo?: ValueTypes["SeoUniqueWhere"] | undefined | null
};
	["LocalePagesByContentUniqueWhere"]: {
	content?: ValueTypes["ContentUniqueWhere"] | undefined | null
};
	["LocalePagesByCoverUniqueWhere"]: {
	cover?: ValueTypes["CoverUniqueWhere"] | undefined | null
};
	["LocaleProductIngredientCategoriesByRootUniqueWhere"]: {
	root?: ValueTypes["ProductIngredientCategoryUniqueWhere"] | undefined | null
};
	["LocaleAllergensByRootUniqueWhere"]: {
	root?: ValueTypes["AllergenUniqueWhere"] | undefined | null
};
	["LocaleProductPackingsByRootUniqueWhere"]: {
	root?: ValueTypes["ProductPackingUniqueWhere"] | undefined | null
};
	["LocaleProductsByRootUniqueWhere"]: {
	root?: ValueTypes["ProductUniqueWhere"] | undefined | null
};
	["LocaleProductsByFeatureListUniqueWhere"]: {
	featureList?: ValueTypes["TextListUniqueWhere"] | undefined | null
};
	["LocaleProductRecipesByRootUniqueWhere"]: {
	root?: ValueTypes["ProductRecipeUniqueWhere"] | undefined | null
};
	["LocalePointOfSaleCategoriesByRootUniqueWhere"]: {
	root?: ValueTypes["PointOfSaleCategoryUniqueWhere"] | undefined | null
};
	["LocalePointOfSaleCategoryProductsByRootUniqueWhere"]: {
	root?: ValueTypes["PointOfSaleCategoryProductUniqueWhere"] | undefined | null
};
	["LocaleDeliveryMethodsByRootUniqueWhere"]: {
	root?: ValueTypes["DeliveryMethodUniqueWhere"] | undefined | null
};
	["LocaleIngredientSuppliersByRootUniqueWhere"]: {
	root?: ValueTypes["IngredientSupplierUniqueWhere"] | undefined | null
};
	["LocaleIdentificationCodesByRootUniqueWhere"]: {
	root?: ValueTypes["IdentificationCodeUniqueWhere"] | undefined | null
};
	["LocalePipelineStagesByRootUniqueWhere"]: {
	root?: ValueTypes["PipelineStageUniqueWhere"] | undefined | null
};
	["LocaleSubscriptionBoxesByRootUniqueWhere"]: {
	root?: ValueTypes["SubscriptionBoxUniqueWhere"] | undefined | null
};
	["LocaleSubscriptionBoxesByTextsUniqueWhere"]: {
	texts?: ValueTypes["TextListUniqueWhere"] | undefined | null
};
	["LocaleSubscriptionBoxesBySecondaryTextsUniqueWhere"]: {
	secondaryTexts?: ValueTypes["TextListUniqueWhere"] | undefined | null
};
	["LocaleBusinessServicesByRootUniqueWhere"]: {
	root?: ValueTypes["BusinessServiceUniqueWhere"] | undefined | null
};
	["ProductPackingLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductPackingLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProductPackingLocaleEdge"]: AliasType<{
	node?:ValueTypes["ProductPackingLocale"],
		__typename?: boolean | `@${string}`
}>;
	["ProductLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProductLocaleEdge"]: AliasType<{
	node?:ValueTypes["ProductLocale"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryMethodLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["DeliveryMethodLocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryMethodLocaleEdge"]: AliasType<{
	node?:ValueTypes["DeliveryMethodLocale"],
		__typename?: boolean | `@${string}`
}>;
	["PreparedPackingQuantity"]: AliasType<{
	_meta?:ValueTypes["PreparedPackingQuantityMeta"],
	id?:boolean | `@${string}`,
	date?:boolean | `@${string}`,
	quantity?:boolean | `@${string}`,
recipe?: [{	filter?: ValueTypes["ProductRecipeWhere"] | undefined | null},ValueTypes["ProductRecipe"]],
packing?: [{	filter?: ValueTypes["ProductPackingWhere"] | undefined | null},ValueTypes["ProductPacking"]],
	packedInCardboard?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PreparedPackingQuantityMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	date?:ValueTypes["FieldMeta"],
	quantity?:ValueTypes["FieldMeta"],
	recipe?:ValueTypes["FieldMeta"],
	packing?:ValueTypes["FieldMeta"],
	packedInCardboard?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PreparedPackingQuantityOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	date?: ValueTypes["OrderDirection"] | undefined | null,
	quantity?: ValueTypes["OrderDirection"] | undefined | null,
	recipe?: ValueTypes["ProductRecipeOrderBy"] | undefined | null,
	packing?: ValueTypes["ProductPackingOrderBy"] | undefined | null,
	packedInCardboard?: ValueTypes["OrderDirection"] | undefined | null
};
	["ProductPackingLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null
};
	["PreparedPackingQuantityConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PreparedPackingQuantityEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PreparedPackingQuantityEdge"]: AliasType<{
	node?:ValueTypes["PreparedPackingQuantity"],
		__typename?: boolean | `@${string}`
}>;
	["ProductStock"]: AliasType<{
	_meta?:ValueTypes["ProductStockMeta"],
	id?:boolean | `@${string}`,
	quantity?:boolean | `@${string}`,
product?: [{	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
store?: [{	filter?: ValueTypes["StoreWhere"] | undefined | null},ValueTypes["Store"]],
		__typename?: boolean | `@${string}`
}>;
	["ProductStockMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	quantity?:ValueTypes["FieldMeta"],
	product?:ValueTypes["FieldMeta"],
	store?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Store"]: AliasType<{
	_meta?:ValueTypes["StoreMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	internalNote?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["StoreMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	code?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
	internalNote?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProductStockOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	quantity?: ValueTypes["OrderDirection"] | undefined | null,
	product?: ValueTypes["ProductOrderBy"] | undefined | null,
	store?: ValueTypes["StoreOrderBy"] | undefined | null
};
	["StoreOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	code?: ValueTypes["OrderDirection"] | undefined | null,
	description?: ValueTypes["OrderDirection"] | undefined | null,
	internalNote?: ValueTypes["OrderDirection"] | undefined | null
};
	["ProductGroupPrice"]: AliasType<{
	_meta?:ValueTypes["ProductGroupPriceMeta"],
	id?:boolean | `@${string}`,
	priceCents?:boolean | `@${string}`,
group?: [{	filter?: ValueTypes["CustomerGroupWhere"] | undefined | null},ValueTypes["CustomerGroup"]],
product?: [{	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
		__typename?: boolean | `@${string}`
}>;
	["ProductGroupPriceMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	priceCents?:ValueTypes["FieldMeta"],
	group?:ValueTypes["FieldMeta"],
	product?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerGroup"]: AliasType<{
	_meta?:ValueTypes["CustomerGroupMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
productPrices?: [{	filter?: ValueTypes["ProductGroupPriceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductGroupPriceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductGroupPrice"]],
customers?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Customer"]],
	discountPermille?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
	doubleshotLegacyId?:boolean | `@${string}`,
productPricesByProduct?: [{	by: ValueTypes["CustomerGroupProductPricesByProductUniqueWhere"],	filter?: ValueTypes["ProductGroupPriceWhere"] | undefined | null},ValueTypes["ProductGroupPrice"]],
customersByDoubleshotLegacyId?: [{	by: ValueTypes["CustomerGroupCustomersByDoubleshotLegacyIdUniqueWhere"],	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
customersByAddresses?: [{	by: ValueTypes["CustomerGroupCustomersByAddressesUniqueWhere"],	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
customersByDefaultBillingAddress?: [{	by: ValueTypes["CustomerGroupCustomersByDefaultBillingAddressUniqueWhere"],	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
customersByDefaultPaymentMethod?: [{	by: ValueTypes["CustomerGroupCustomersByDefaultPaymentMethodUniqueWhere"],	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
customersByCredits?: [{	by: ValueTypes["CustomerGroupCustomersByCreditsUniqueWhere"],	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
customersByPaymentMethods?: [{	by: ValueTypes["CustomerGroupCustomersByPaymentMethodsUniqueWhere"],	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
customersByOrders?: [{	by: ValueTypes["CustomerGroupCustomersByOrdersUniqueWhere"],	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
customersByPermissions?: [{	by: ValueTypes["CustomerGroupCustomersByPermissionsUniqueWhere"],	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
customersByName?: [{	by: ValueTypes["CustomerGroupCustomersByNameUniqueWhere"],	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
customersByIngredientRatings?: [{	by: ValueTypes["CustomerGroupCustomersByIngredientRatingsUniqueWhere"],	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
customersByBusiness?: [{	by: ValueTypes["CustomerGroupCustomersByBusinessUniqueWhere"],	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
customersByCarts?: [{	by: ValueTypes["CustomerGroupCustomersByCartsUniqueWhere"],	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
customersByShortcutList?: [{	by: ValueTypes["CustomerGroupCustomersByShortcutListUniqueWhere"],	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
customersByUser?: [{	by: ValueTypes["CustomerGroupCustomersByUserUniqueWhere"],	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
customersByInvoices?: [{	by: ValueTypes["CustomerGroupCustomersByInvoicesUniqueWhere"],	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
customersByInvoicingPlan?: [{	by: ValueTypes["CustomerGroupCustomersByInvoicingPlanUniqueWhere"],	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
customersByBillingSubjects?: [{	by: ValueTypes["CustomerGroupCustomersByBillingSubjectsUniqueWhere"],	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
customersByOfferedProducts?: [{	by: ValueTypes["CustomerGroupCustomersByOfferedProductsUniqueWhere"],	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
customersByDefaultDeliveryAddress?: [{	by: ValueTypes["CustomerGroupCustomersByDefaultDeliveryAddressUniqueWhere"],	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
customersByDefaultBillingSubject?: [{	by: ValueTypes["CustomerGroupCustomersByDefaultBillingSubjectUniqueWhere"],	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
customersByAnonymousSession?: [{	by: ValueTypes["CustomerGroupCustomersByAnonymousSessionUniqueWhere"],	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
customersByBoughtVouchers?: [{	by: ValueTypes["CustomerGroupCustomersByBoughtVouchersUniqueWhere"],	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
customersByOwnsVouchers?: [{	by: ValueTypes["CustomerGroupCustomersByOwnsVouchersUniqueWhere"],	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
customersByRedeemedVouchers?: [{	by: ValueTypes["CustomerGroupCustomersByRedeemedVouchersUniqueWhere"],	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
customersBySpending?: [{	by: ValueTypes["CustomerGroupCustomersBySpendingUniqueWhere"],	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
customersByCustomerTabs?: [{	by: ValueTypes["CustomerGroupCustomersByCustomerTabsUniqueWhere"],	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
customersByLead?: [{	by: ValueTypes["CustomerGroupCustomersByLeadUniqueWhere"],	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
customersByMeta?: [{	by: ValueTypes["CustomerGroupCustomersByMetaUniqueWhere"],	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
paginateProductPrices?: [{	filter?: ValueTypes["ProductGroupPriceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductGroupPriceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductGroupPriceConnection"]],
paginateCustomers?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["CustomerGroupMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	productPrices?:ValueTypes["FieldMeta"],
	customers?:ValueTypes["FieldMeta"],
	discountPermille?:ValueTypes["FieldMeta"],
	code?:ValueTypes["FieldMeta"],
	doubleshotLegacyId?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProductGroupPriceOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	priceCents?: ValueTypes["OrderDirection"] | undefined | null,
	group?: ValueTypes["CustomerGroupOrderBy"] | undefined | null,
	product?: ValueTypes["ProductOrderBy"] | undefined | null
};
	["CustomerGroupProductPricesByProductUniqueWhere"]: {
	product?: ValueTypes["ProductUniqueWhere"] | undefined | null
};
	["CustomerGroupCustomersByDoubleshotLegacyIdUniqueWhere"]: {
	doubleshotLegacyId?: string | undefined | null
};
	["CustomerGroupCustomersByAddressesUniqueWhere"]: {
	addresses?: ValueTypes["AddressUniqueWhere"] | undefined | null
};
	["CustomerGroupCustomersByDefaultBillingAddressUniqueWhere"]: {
	defaultBillingAddress?: ValueTypes["AddressUniqueWhere"] | undefined | null
};
	["CustomerGroupCustomersByDefaultPaymentMethodUniqueWhere"]: {
	defaultPaymentMethod?: ValueTypes["CustomerPaymentMethodUniqueWhere"] | undefined | null
};
	["CustomerGroupCustomersByCreditsUniqueWhere"]: {
	credits?: ValueTypes["CustomerCreditUniqueWhere"] | undefined | null
};
	["CustomerGroupCustomersByPaymentMethodsUniqueWhere"]: {
	paymentMethods?: ValueTypes["CustomerPaymentMethodUniqueWhere"] | undefined | null
};
	["CustomerGroupCustomersByOrdersUniqueWhere"]: {
	orders?: ValueTypes["OrderUniqueWhere"] | undefined | null
};
	["CustomerGroupCustomersByPermissionsUniqueWhere"]: {
	permissions?: ValueTypes["CustomerPermissionsUniqueWhere"] | undefined | null
};
	["CustomerGroupCustomersByNameUniqueWhere"]: {
	name?: ValueTypes["CustomerNameUniqueWhere"] | undefined | null
};
	["CustomerGroupCustomersByIngredientRatingsUniqueWhere"]: {
	ingredientRatings?: ValueTypes["CustomerIngredientRatingUniqueWhere"] | undefined | null
};
	["CustomerGroupCustomersByBusinessUniqueWhere"]: {
	business?: ValueTypes["BusinessCustomerUniqueWhere"] | undefined | null
};
	["CustomerGroupCustomersByCartsUniqueWhere"]: {
	carts?: ValueTypes["CartUniqueWhere"] | undefined | null
};
	["CustomerGroupCustomersByShortcutListUniqueWhere"]: {
	shortcutList?: ValueTypes["ApplicationShortcutListUniqueWhere"] | undefined | null
};
	["CustomerGroupCustomersByUserUniqueWhere"]: {
	user?: ValueTypes["UserUniqueWhere"] | undefined | null
};
	["CustomerGroupCustomersByInvoicesUniqueWhere"]: {
	invoices?: ValueTypes["InvoiceUniqueWhere"] | undefined | null
};
	["CustomerGroupCustomersByInvoicingPlanUniqueWhere"]: {
	invoicingPlan?: ValueTypes["InvoicingPlanUniqueWhere"] | undefined | null
};
	["CustomerGroupCustomersByBillingSubjectsUniqueWhere"]: {
	billingSubjects?: ValueTypes["BillingSubjectUniqueWhere"] | undefined | null
};
	["CustomerGroupCustomersByOfferedProductsUniqueWhere"]: {
	offeredProducts?: ValueTypes["ProductCustomerPriceUniqueWhere"] | undefined | null
};
	["CustomerGroupCustomersByDefaultDeliveryAddressUniqueWhere"]: {
	defaultDeliveryAddress?: ValueTypes["AddressUniqueWhere"] | undefined | null
};
	["CustomerGroupCustomersByDefaultBillingSubjectUniqueWhere"]: {
	defaultBillingSubject?: ValueTypes["BillingSubjectUniqueWhere"] | undefined | null
};
	["CustomerGroupCustomersByAnonymousSessionUniqueWhere"]: {
	anonymousSession?: ValueTypes["AnonymousSessionUniqueWhere"] | undefined | null
};
	["CustomerGroupCustomersByBoughtVouchersUniqueWhere"]: {
	boughtVouchers?: ValueTypes["VoucherUniqueWhere"] | undefined | null
};
	["CustomerGroupCustomersByOwnsVouchersUniqueWhere"]: {
	ownsVouchers?: ValueTypes["VoucherUniqueWhere"] | undefined | null
};
	["CustomerGroupCustomersByRedeemedVouchersUniqueWhere"]: {
	redeemedVouchers?: ValueTypes["VoucherRedemptionUniqueWhere"] | undefined | null
};
	["CustomerGroupCustomersBySpendingUniqueWhere"]: {
	spending?: ValueTypes["CustomerSpendingUniqueWhere"] | undefined | null
};
	["CustomerGroupCustomersByCustomerTabsUniqueWhere"]: {
	customerTabs?: ValueTypes["CustomerTabUniqueWhere"] | undefined | null
};
	["CustomerGroupCustomersByLeadUniqueWhere"]: {
	lead?: ValueTypes["PipelineLeadUniqueWhere"] | undefined | null
};
	["CustomerGroupCustomersByMetaUniqueWhere"]: {
	meta?: ValueTypes["CustomerMetadataUniqueWhere"] | undefined | null
};
	["ProductGroupPriceConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductGroupPriceEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProductGroupPriceEdge"]: AliasType<{
	node?:ValueTypes["ProductGroupPrice"],
		__typename?: boolean | `@${string}`
}>;
	["ProductCustomerPrice"]: AliasType<{
	_meta?:ValueTypes["ProductCustomerPriceMeta"],
	id?:boolean | `@${string}`,
	groupDiscountPermille?:boolean | `@${string}`,
	groupPriceCents?:boolean | `@${string}`,
	fullPriceCents?:boolean | `@${string}`,
	discountedPriceCents?:boolean | `@${string}`,
	priceCents?:boolean | `@${string}`,
	offered?:boolean | `@${string}`,
	notDiscountable?:boolean | `@${string}`,
customer?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
product?: [{	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
		__typename?: boolean | `@${string}`
}>;
	["ProductCustomerPriceMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	groupDiscountPermille?:ValueTypes["FieldMeta"],
	groupPriceCents?:ValueTypes["FieldMeta"],
	fullPriceCents?:ValueTypes["FieldMeta"],
	discountedPriceCents?:ValueTypes["FieldMeta"],
	priceCents?:ValueTypes["FieldMeta"],
	offered?:ValueTypes["FieldMeta"],
	notDiscountable?:ValueTypes["FieldMeta"],
	customer?:ValueTypes["FieldMeta"],
	product?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProductCustomerPriceOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	groupDiscountPermille?: ValueTypes["OrderDirection"] | undefined | null,
	groupPriceCents?: ValueTypes["OrderDirection"] | undefined | null,
	fullPriceCents?: ValueTypes["OrderDirection"] | undefined | null,
	discountedPriceCents?: ValueTypes["OrderDirection"] | undefined | null,
	priceCents?: ValueTypes["OrderDirection"] | undefined | null,
	offered?: ValueTypes["OrderDirection"] | undefined | null,
	notDiscountable?: ValueTypes["OrderDirection"] | undefined | null,
	customer?: ValueTypes["CustomerOrderBy"] | undefined | null,
	product?: ValueTypes["ProductOrderBy"] | undefined | null
};
	["ProductMetadata"]: AliasType<{
	_meta?:ValueTypes["ProductMetadataMeta"],
	id?:boolean | `@${string}`,
	archived?:boolean | `@${string}`,
	available?:boolean | `@${string}`,
	availableQuantity?:boolean | `@${string}`,
product?: [{	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
		__typename?: boolean | `@${string}`
}>;
	["ProductMetadataMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	archived?:ValueTypes["FieldMeta"],
	available?:ValueTypes["FieldMeta"],
	availableQuantity?:ValueTypes["FieldMeta"],
	product?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProductSalesDay"]: AliasType<{
	_meta?:ValueTypes["ProductSalesDayMeta"],
	id?:boolean | `@${string}`,
	productName?:boolean | `@${string}`,
	orderDate?:boolean | `@${string}`,
	priceCentsSum?:boolean | `@${string}`,
	sum?:boolean | `@${string}`,
product?: [{	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
		__typename?: boolean | `@${string}`
}>;
	["ProductSalesDayMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	productName?:ValueTypes["FieldMeta"],
	orderDate?:ValueTypes["FieldMeta"],
	priceCentsSum?:ValueTypes["FieldMeta"],
	sum?:ValueTypes["FieldMeta"],
	product?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProductSalesDayOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	productName?: ValueTypes["OrderDirection"] | undefined | null,
	orderDate?: ValueTypes["OrderDirection"] | undefined | null,
	priceCentsSum?: ValueTypes["OrderDirection"] | undefined | null,
	sum?: ValueTypes["OrderDirection"] | undefined | null,
	product?: ValueTypes["ProductOrderBy"] | undefined | null
};
	["ProductSalesWeek"]: AliasType<{
	_meta?:ValueTypes["ProductSalesWeekMeta"],
	id?:boolean | `@${string}`,
	productName?:boolean | `@${string}`,
	orderDate?:boolean | `@${string}`,
	priceCentsSum?:boolean | `@${string}`,
	sum?:boolean | `@${string}`,
product?: [{	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
		__typename?: boolean | `@${string}`
}>;
	["ProductSalesWeekMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	productName?:ValueTypes["FieldMeta"],
	orderDate?:ValueTypes["FieldMeta"],
	priceCentsSum?:ValueTypes["FieldMeta"],
	sum?:ValueTypes["FieldMeta"],
	product?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProductSalesWeekOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	productName?: ValueTypes["OrderDirection"] | undefined | null,
	orderDate?: ValueTypes["OrderDirection"] | undefined | null,
	priceCentsSum?: ValueTypes["OrderDirection"] | undefined | null,
	sum?: ValueTypes["OrderDirection"] | undefined | null,
	product?: ValueTypes["ProductOrderBy"] | undefined | null
};
	["ProductSalesMonth"]: AliasType<{
	_meta?:ValueTypes["ProductSalesMonthMeta"],
	id?:boolean | `@${string}`,
	productName?:boolean | `@${string}`,
	orderDate?:boolean | `@${string}`,
	priceCentsSum?:boolean | `@${string}`,
	sum?:boolean | `@${string}`,
product?: [{	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
		__typename?: boolean | `@${string}`
}>;
	["ProductSalesMonthMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	productName?:ValueTypes["FieldMeta"],
	orderDate?:ValueTypes["FieldMeta"],
	priceCentsSum?:ValueTypes["FieldMeta"],
	sum?:ValueTypes["FieldMeta"],
	product?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProductSalesMonthOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	productName?: ValueTypes["OrderDirection"] | undefined | null,
	orderDate?: ValueTypes["OrderDirection"] | undefined | null,
	priceCentsSum?: ValueTypes["OrderDirection"] | undefined | null,
	sum?: ValueTypes["OrderDirection"] | undefined | null,
	product?: ValueTypes["ProductOrderBy"] | undefined | null
};
	["ProductStocksByStoreUniqueWhere"]: {
	store?: ValueTypes["StoreUniqueWhere"] | undefined | null
};
	["ProductGroupPricesByGroupUniqueWhere"]: {
	group?: ValueTypes["CustomerGroupUniqueWhere"] | undefined | null
};
	["ProductCartItemsByCartUniqueWhere"]: {
	cart?: ValueTypes["CartUniqueWhere"] | undefined | null
};
	["ProductOrderItemsByVirtualProductEffectsUniqueWhere"]: {
	virtualProductEffects?: ValueTypes["VirtualProductEffectUniqueWhere"] | undefined | null
};
	["ProductLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null
};
	["ProductLocalesByFeatureListUniqueWhere"]: {
	featureList?: ValueTypes["TextListUniqueWhere"] | undefined | null
};
	["ProductCustomerPricesByCustomerUniqueWhere"]: {
	customer?: ValueTypes["CustomerUniqueWhere"] | undefined | null
};
	["ProductStockConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductStockEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProductStockEdge"]: AliasType<{
	node?:ValueTypes["ProductStock"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryZoneConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["DeliveryZoneEdge"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryZoneEdge"]: AliasType<{
	node?:ValueTypes["DeliveryZone"],
		__typename?: boolean | `@${string}`
}>;
	["ProductCustomerPriceConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductCustomerPriceEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProductCustomerPriceEdge"]: AliasType<{
	node?:ValueTypes["ProductCustomerPrice"],
		__typename?: boolean | `@${string}`
}>;
	["ProductSalesDayConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductSalesDayEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProductSalesDayEdge"]: AliasType<{
	node?:ValueTypes["ProductSalesDay"],
		__typename?: boolean | `@${string}`
}>;
	["ProductSalesWeekConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductSalesWeekEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProductSalesWeekEdge"]: AliasType<{
	node?:ValueTypes["ProductSalesWeek"],
		__typename?: boolean | `@${string}`
}>;
	["ProductSalesMonthConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductSalesMonthEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProductSalesMonthEdge"]: AliasType<{
	node?:ValueTypes["ProductSalesMonth"],
		__typename?: boolean | `@${string}`
}>;
	["AddressMetadata"]: AliasType<{
	_meta?:ValueTypes["AddressMetadataMeta"],
	id?:boolean | `@${string}`,
	deliveryZoneType?:boolean | `@${string}`,
address?: [{	filter?: ValueTypes["AddressWhere"] | undefined | null},ValueTypes["Address"]],
deliveryZone?: [{	filter?: ValueTypes["DeliveryZoneWhere"] | undefined | null},ValueTypes["DeliveryZone"]],
		__typename?: boolean | `@${string}`
}>;
	["AddressMetadataMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	deliveryZoneType?:ValueTypes["FieldMeta"],
	address?:ValueTypes["FieldMeta"],
	deliveryZone?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryZoneAddressesByMetaUniqueWhere"]: {
	meta?: ValueTypes["AddressMetadataUniqueWhere"] | undefined | null
};
	["DeliveryZoneAddressesByGpsUniqueWhere"]: {
	gps?: ValueTypes["GpsUniqueWhere"] | undefined | null
};
	["DeliveryZoneAddressesByInvoicesUniqueWhere"]: {
	invoices?: ValueTypes["InvoiceUniqueWhere"] | undefined | null
};
	["DeliveryZoneAddressesByBillingAddressOfOrdersUniqueWhere"]: {
	billingAddressOfOrders?: ValueTypes["OrderUniqueWhere"] | undefined | null
};
	["DeliveryZoneAddressesByDeliveryAddressOfOrderDeliveriesUniqueWhere"]: {
	deliveryAddressOfOrderDeliveries?: ValueTypes["OrderDeliveryUniqueWhere"] | undefined | null
};
	["DeliveryZoneAddressesByDefaultDeliveryAddressOfCustomerUniqueWhere"]: {
	defaultDeliveryAddressOfCustomer?: ValueTypes["CustomerUniqueWhere"] | undefined | null
};
	["DeliveryZoneAddressesMetadataByAddressUniqueWhere"]: {
	address?: ValueTypes["AddressUniqueWhere"] | undefined | null
};
	["AddressConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["AddressEdge"],
		__typename?: boolean | `@${string}`
}>;
	["AddressEdge"]: AliasType<{
	node?:ValueTypes["Address"],
		__typename?: boolean | `@${string}`
}>;
	["AddressMetadataConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["AddressMetadataEdge"],
		__typename?: boolean | `@${string}`
}>;
	["AddressMetadataEdge"]: AliasType<{
	node?:ValueTypes["AddressMetadata"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryTimelinePreset"]: AliasType<{
	_meta?:ValueTypes["DeliveryTimelinePresetMeta"],
	id?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	duration?:boolean | `@${string}`,
	window?:boolean | `@${string}`,
deliveryMethod?: [{	filter?: ValueTypes["DeliveryMethodWhere"] | undefined | null},ValueTypes["DeliveryMethod"]],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryTimelinePresetMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	duration?:ValueTypes["FieldMeta"],
	window?:ValueTypes["FieldMeta"],
	deliveryMethod?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryMethodLocalesByLocaleUniqueWhere"]: {
	locale?: ValueTypes["LocaleUniqueWhere"] | undefined | null
};
	["PaymentMethodConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PaymentMethodEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PaymentMethodEdge"]: AliasType<{
	node?:ValueTypes["PaymentMethod"],
		__typename?: boolean | `@${string}`
}>;
	["CourierConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CourierEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CourierEdge"]: AliasType<{
	node?:ValueTypes["Courier"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerPermissions"]: AliasType<{
	_meta?:ValueTypes["CustomerPermissionsMeta"],
	id?:boolean | `@${string}`,
	canPlaceOrder?:boolean | `@${string}`,
customer?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
		__typename?: boolean | `@${string}`
}>;
	["CustomerPermissionsMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	canPlaceOrder?:ValueTypes["FieldMeta"],
	customer?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerName"]: AliasType<{
	_meta?:ValueTypes["CustomerNameMeta"],
	id?:boolean | `@${string}`,
	nominative?:boolean | `@${string}`,
	vocative?:boolean | `@${string}`,
customer?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
aliases?: [{	filter?: ValueTypes["CustomerAliasWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerAliasOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CustomerAlias"]],
paginateAliases?: [{	filter?: ValueTypes["CustomerAliasWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerAliasOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerAliasConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["CustomerNameMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	nominative?:ValueTypes["FieldMeta"],
	vocative?:ValueTypes["FieldMeta"],
	customer?:ValueTypes["FieldMeta"],
	aliases?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerAlias"]: AliasType<{
	_meta?:ValueTypes["CustomerAliasMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CustomerAliasMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerAliasOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null
};
	["CustomerAliasConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CustomerAliasEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerAliasEdge"]: AliasType<{
	node?:ValueTypes["CustomerAlias"],
		__typename?: boolean | `@${string}`
}>;
	["ApplicationShortcutList"]: AliasType<{
	_meta?:ValueTypes["ApplicationShortcutListMeta"],
	id?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["ApplicationShortcutListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ApplicationShortcutListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ApplicationShortcutListItem"]],
customer?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
paginateItems?: [{	filter?: ValueTypes["ApplicationShortcutListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ApplicationShortcutListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ApplicationShortcutListItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ApplicationShortcutListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
	customer?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ApplicationShortcutListItem"]: AliasType<{
	_meta?:ValueTypes["ApplicationShortcutListItemMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
application?: [{	filter?: ValueTypes["ApplicationWhere"] | undefined | null},ValueTypes["Application"]],
list?: [{	filter?: ValueTypes["ApplicationShortcutListWhere"] | undefined | null},ValueTypes["ApplicationShortcutList"]],
		__typename?: boolean | `@${string}`
}>;
	["ApplicationShortcutListItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	application?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["Application"]: AliasType<{
	_meta?:ValueTypes["ApplicationMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	handle?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
	color?:boolean | `@${string}`,
icon?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null},ValueTypes["Image"]],
	name?:boolean | `@${string}`,
	short?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ApplicationMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	handle?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	color?:ValueTypes["FieldMeta"],
	icon?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	short?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ApplicationShortcutListItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null,
	application?: ValueTypes["ApplicationOrderBy"] | undefined | null,
	list?: ValueTypes["ApplicationShortcutListOrderBy"] | undefined | null
};
	["ApplicationOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null,
	handle?: ValueTypes["OrderDirection"] | undefined | null,
	url?: ValueTypes["OrderDirection"] | undefined | null,
	color?: ValueTypes["OrderDirection"] | undefined | null,
	icon?: ValueTypes["ImageOrderBy"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	short?: ValueTypes["OrderDirection"] | undefined | null
};
	["ApplicationShortcutListItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ApplicationShortcutListItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ApplicationShortcutListItemEdge"]: AliasType<{
	node?:ValueTypes["ApplicationShortcutListItem"],
		__typename?: boolean | `@${string}`
}>;
	["InvoicingPlan"]: AliasType<{
	_meta?:ValueTypes["InvoicingPlanMeta"],
	id?:boolean | `@${string}`,
customer?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
preset?: [{	filter?: ValueTypes["InvoicingPresetWhere"] | undefined | null},ValueTypes["InvoicingPreset"]],
		__typename?: boolean | `@${string}`
}>;
	["InvoicingPlanMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	customer?:ValueTypes["FieldMeta"],
	preset?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["InvoicingPreset"]: AliasType<{
	_meta?:ValueTypes["InvoicingPresetMeta"],
	id?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	startsAt?:boolean | `@${string}`,
	endsAt?:boolean | `@${string}`,
	intervalOfDays?:boolean | `@${string}`,
invoicingPlan?: [{	filter?: ValueTypes["InvoicingPlanWhere"] | undefined | null},ValueTypes["InvoicingPlan"]],
		__typename?: boolean | `@${string}`
}>;
	["InvoicingPresetMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	startsAt?:ValueTypes["FieldMeta"],
	endsAt?:ValueTypes["FieldMeta"],
	intervalOfDays?:ValueTypes["FieldMeta"],
	invoicingPlan?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerSpending"]: AliasType<{
	_meta?:ValueTypes["CustomerSpendingMeta"],
	id?:boolean | `@${string}`,
	totalCents?:boolean | `@${string}`,
customer?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
		__typename?: boolean | `@${string}`
}>;
	["CustomerSpendingMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	totalCents?:ValueTypes["FieldMeta"],
	customer?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerMetadata"]: AliasType<{
	_meta?:ValueTypes["CustomerMetadataMeta"],
	id?:boolean | `@${string}`,
	isBusiness?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	fallbackName?:boolean | `@${string}`,
	remainingCreditsCents?:boolean | `@${string}`,
	ordersTotalCents?:boolean | `@${string}`,
	customerProfileUrl?:boolean | `@${string}`,
customer?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
		__typename?: boolean | `@${string}`
}>;
	["CustomerMetadataMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	isBusiness?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	fallbackName?:ValueTypes["FieldMeta"],
	remainingCreditsCents?:ValueTypes["FieldMeta"],
	ordersTotalCents?:ValueTypes["FieldMeta"],
	customerProfileUrl?:ValueTypes["FieldMeta"],
	customer?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerAddressesByMetaUniqueWhere"]: {
	meta?: ValueTypes["AddressMetadataUniqueWhere"] | undefined | null
};
	["CustomerAddressesByGpsUniqueWhere"]: {
	gps?: ValueTypes["GpsUniqueWhere"] | undefined | null
};
	["CustomerAddressesByInvoicesUniqueWhere"]: {
	invoices?: ValueTypes["InvoiceUniqueWhere"] | undefined | null
};
	["CustomerAddressesByBillingAddressOfOrdersUniqueWhere"]: {
	billingAddressOfOrders?: ValueTypes["OrderUniqueWhere"] | undefined | null
};
	["CustomerAddressesByDeliveryAddressOfOrderDeliveriesUniqueWhere"]: {
	deliveryAddressOfOrderDeliveries?: ValueTypes["OrderDeliveryUniqueWhere"] | undefined | null
};
	["CustomerAddressesByDefaultDeliveryAddressOfCustomerUniqueWhere"]: {
	defaultDeliveryAddressOfCustomer?: ValueTypes["CustomerUniqueWhere"] | undefined | null
};
	["CustomerCreditsByTransactionsUniqueWhere"]: {
	transactions?: ValueTypes["CustomerCreditTransactionUniqueWhere"] | undefined | null
};
	["CustomerCreditsByVoucherRedemptionUniqueWhere"]: {
	voucherRedemption?: ValueTypes["VoucherRedemptionUniqueWhere"] | undefined | null
};
	["CustomerOrdersBySeqUniqueWhere"]: {
	seq?: number | undefined | null
};
	["CustomerOrdersByDoubleshotLegacyIdUniqueWhere"]: {
	doubleshotLegacyId?: string | undefined | null
};
	["CustomerOrdersByDoubleShotLegacyNumberUniqueWhere"]: {
	doubleShotLegacyNumber?: string | undefined | null
};
	["CustomerOrdersByDiscountsUniqueWhere"]: {
	discounts?: ValueTypes["OrderDiscountUniqueWhere"] | undefined | null
};
	["CustomerOrdersByDeliveryUniqueWhere"]: {
	delivery?: ValueTypes["OrderDeliveryUniqueWhere"] | undefined | null
};
	["CustomerOrdersByItemsUniqueWhere"]: {
	items?: ValueTypes["OrderItemUniqueWhere"] | undefined | null
};
	["CustomerOrdersByCartUniqueWhere"]: {
	cart?: ValueTypes["CartUniqueWhere"] | undefined | null
};
	["CustomerOrdersByEventsUniqueWhere"]: {
	events?: ValueTypes["OrderEventUniqueWhere"] | undefined | null
};
	["CustomerOrdersByPriceLinesUniqueWhere"]: {
	priceLines?: ValueTypes["OrderPriceLineUniqueWhere"] | undefined | null
};
	["CustomerOrdersByPaymentsUniqueWhere"]: {
	payments?: ValueTypes["OrderPaymentUniqueWhere"] | undefined | null
};
	["CustomerOrdersBySummaryUniqueWhere"]: {
	summary?: ValueTypes["OrderSummaryUniqueWhere"] | undefined | null
};
	["CustomerOrdersByGratuityUniqueWhere"]: {
	gratuity?: ValueTypes["GratuityUniqueWhere"] | undefined | null
};
	["CustomerIngredientRatingsByIngredientUniqueWhere"]: {
	ingredient?: ValueTypes["ProductIngredientUniqueWhere"] | undefined | null
};
	["CustomerCartsByItemsUniqueWhere"]: {
	items?: ValueTypes["CartItemUniqueWhere"] | undefined | null
};
	["CustomerCartsByOrderUniqueWhere"]: {
	order?: ValueTypes["OrderUniqueWhere"] | undefined | null
};
	["CustomerCartsByPriceLinesUniqueWhere"]: {
	priceLines?: ValueTypes["CartPriceLineUniqueWhere"] | undefined | null
};
	["CustomerCartsBySummaryUniqueWhere"]: {
	summary?: ValueTypes["CartSummaryUniqueWhere"] | undefined | null
};
	["CustomerInvoicesByPublicKeyUniqueWhere"]: {
	publicKey?: string | undefined | null
};
	["CustomerInvoicesByFakturoidIdUniqueWhere"]: {
	fakturoidId?: string | undefined | null
};
	["CustomerInvoicesByOrderPaymentsUniqueWhere"]: {
	orderPayments?: ValueTypes["OrderPaymentUniqueWhere"] | undefined | null
};
	["CustomerBillingSubjectsByInvoicesUniqueWhere"]: {
	invoices?: ValueTypes["InvoiceUniqueWhere"] | undefined | null
};
	["CustomerBillingSubjectsByDefaultBillingSubjectOfCustomerUniqueWhere"]: {
	defaultBillingSubjectOfCustomer?: ValueTypes["CustomerUniqueWhere"] | undefined | null
};
	["CustomerBillingSubjectsByOrdersUniqueWhere"]: {
	orders?: ValueTypes["OrderUniqueWhere"] | undefined | null
};
	["CustomerOfferedProductsByProductUniqueWhere"]: {
	product?: ValueTypes["ProductUniqueWhere"] | undefined | null
};
	["CustomerBoughtVouchersByCodeUniqueWhere"]: {
	code?: string | undefined | null
};
	["CustomerBoughtVouchersByRedemptionUniqueWhere"]: {
	redemption?: ValueTypes["VoucherRedemptionUniqueWhere"] | undefined | null
};
	["CustomerOwnsVouchersByCodeUniqueWhere"]: {
	code?: string | undefined | null
};
	["CustomerOwnsVouchersByRedemptionUniqueWhere"]: {
	redemption?: ValueTypes["VoucherRedemptionUniqueWhere"] | undefined | null
};
	["CustomerRedeemedVouchersByCustomerCreditUniqueWhere"]: {
	customerCredit?: ValueTypes["CustomerCreditUniqueWhere"] | undefined | null
};
	["CustomerRedeemedVouchersByOrderDiscountUniqueWhere"]: {
	orderDiscount?: ValueTypes["OrderDiscountUniqueWhere"] | undefined | null
};
	["CustomerRedeemedVouchersByVoucherUniqueWhere"]: {
	voucher?: ValueTypes["VoucherUniqueWhere"] | undefined | null
};
	["CustomerCustomerTabsByItemsUniqueWhere"]: {
	items?: ValueTypes["CustomerTabItemUniqueWhere"] | undefined | null
};
	["CustomerCustomerTabsByMetaUniqueWhere"]: {
	meta?: ValueTypes["CustomerTabMetadataUniqueWhere"] | undefined | null
};
	["CustomerLeadByStageItemUniqueWhere"]: {
	stageItem?: ValueTypes["PipelineStageItemUniqueWhere"] | undefined | null
};
	["CustomerCreditConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CustomerCreditEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerCreditEdge"]: AliasType<{
	node?:ValueTypes["CustomerCredit"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerPaymentMethodConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CustomerPaymentMethodEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerPaymentMethodEdge"]: AliasType<{
	node?:ValueTypes["CustomerPaymentMethod"],
		__typename?: boolean | `@${string}`
}>;
	["BillingSubjectConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BillingSubjectEdge"],
		__typename?: boolean | `@${string}`
}>;
	["BillingSubjectEdge"]: AliasType<{
	node?:ValueTypes["BillingSubject"],
		__typename?: boolean | `@${string}`
}>;
	["VoucherRedemptionConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["VoucherRedemptionEdge"],
		__typename?: boolean | `@${string}`
}>;
	["VoucherRedemptionEdge"]: AliasType<{
	node?:ValueTypes["VoucherRedemption"],
		__typename?: boolean | `@${string}`
}>;
	["Gps"]: AliasType<{
	_meta?:ValueTypes["GpsMeta"],
	id?:boolean | `@${string}`,
	latitude?:boolean | `@${string}`,
	longitude?:boolean | `@${string}`,
address?: [{	filter?: ValueTypes["AddressWhere"] | undefined | null},ValueTypes["Address"]],
		__typename?: boolean | `@${string}`
}>;
	["GpsMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	latitude?:ValueTypes["FieldMeta"],
	longitude?:ValueTypes["FieldMeta"],
	address?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["AddressInvoicesByPublicKeyUniqueWhere"]: {
	publicKey?: string | undefined | null
};
	["AddressInvoicesByFakturoidIdUniqueWhere"]: {
	fakturoidId?: string | undefined | null
};
	["AddressInvoicesByOrderPaymentsUniqueWhere"]: {
	orderPayments?: ValueTypes["OrderPaymentUniqueWhere"] | undefined | null
};
	["AddressBillingAddressOfOrdersBySeqUniqueWhere"]: {
	seq?: number | undefined | null
};
	["AddressBillingAddressOfOrdersByDoubleshotLegacyIdUniqueWhere"]: {
	doubleshotLegacyId?: string | undefined | null
};
	["AddressBillingAddressOfOrdersByDoubleShotLegacyNumberUniqueWhere"]: {
	doubleShotLegacyNumber?: string | undefined | null
};
	["AddressBillingAddressOfOrdersByDiscountsUniqueWhere"]: {
	discounts?: ValueTypes["OrderDiscountUniqueWhere"] | undefined | null
};
	["AddressBillingAddressOfOrdersByDeliveryUniqueWhere"]: {
	delivery?: ValueTypes["OrderDeliveryUniqueWhere"] | undefined | null
};
	["AddressBillingAddressOfOrdersByItemsUniqueWhere"]: {
	items?: ValueTypes["OrderItemUniqueWhere"] | undefined | null
};
	["AddressBillingAddressOfOrdersByCartUniqueWhere"]: {
	cart?: ValueTypes["CartUniqueWhere"] | undefined | null
};
	["AddressBillingAddressOfOrdersByEventsUniqueWhere"]: {
	events?: ValueTypes["OrderEventUniqueWhere"] | undefined | null
};
	["AddressBillingAddressOfOrdersByPriceLinesUniqueWhere"]: {
	priceLines?: ValueTypes["OrderPriceLineUniqueWhere"] | undefined | null
};
	["AddressBillingAddressOfOrdersByPaymentsUniqueWhere"]: {
	payments?: ValueTypes["OrderPaymentUniqueWhere"] | undefined | null
};
	["AddressBillingAddressOfOrdersBySummaryUniqueWhere"]: {
	summary?: ValueTypes["OrderSummaryUniqueWhere"] | undefined | null
};
	["AddressBillingAddressOfOrdersByGratuityUniqueWhere"]: {
	gratuity?: ValueTypes["GratuityUniqueWhere"] | undefined | null
};
	["AddressDeliveryAddressOfOrderDeliveriesByTrackingCodeUniqueWhere"]: {
	trackingCode?: string | undefined | null
};
	["AddressDeliveryAddressOfOrderDeliveriesByOrderUniqueWhere"]: {
	order?: ValueTypes["OrderUniqueWhere"] | undefined | null
};
	["AddressDeliveryAddressOfOrderDeliveriesByDeliveryWaypointUniqueWhere"]: {
	deliveryWaypoint?: ValueTypes["DeliveryWaypointUniqueWhere"] | undefined | null
};
	["AddressDeliveryAddressOfOrderDeliveriesByEventsUniqueWhere"]: {
	events?: ValueTypes["OrderEventUniqueWhere"] | undefined | null
};
	["AddressDeliveryAddressOfOrderDeliveriesByLiftagoRideUniqueWhere"]: {
	liftagoRide?: ValueTypes["LiftagoRideUniqueWhere"] | undefined | null
};
	["AddressDeliveryAddressOfOrderDeliveriesByWoltDriveDeliveryUniqueWhere"]: {
	woltDriveDelivery?: ValueTypes["WoltDriveDeliveryUniqueWhere"] | undefined | null
};
	["OrderDeliveryConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["OrderDeliveryEdge"],
		__typename?: boolean | `@${string}`
}>;
	["OrderDeliveryEdge"]: AliasType<{
	node?:ValueTypes["OrderDelivery"],
		__typename?: boolean | `@${string}`
}>;
	["_ValidationResult"]: AliasType<{
	valid?:boolean | `@${string}`,
	errors?:ValueTypes["_ValidationError"],
		__typename?: boolean | `@${string}`
}>;
	["_ValidationError"]: AliasType<{
	path?:ValueTypes["_PathFragment"],
	message?:ValueTypes["_ValidationMessage"],
		__typename?: boolean | `@${string}`
}>;
	["_PathFragment"]: AliasType<{		["...on _FieldPathFragment"] : ValueTypes["_FieldPathFragment"],
		["...on _IndexPathFragment"] : ValueTypes["_IndexPathFragment"]
		__typename?: boolean | `@${string}`
}>;
	["_FieldPathFragment"]: AliasType<{
	field?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_IndexPathFragment"]: AliasType<{
	index?:boolean | `@${string}`,
	alias?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_ValidationMessage"]: AliasType<{
	text?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AddressCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	addressLine2?: string | undefined | null,
	email?: string | undefined | null,
	phone?: string | undefined | null,
	companyName?: string | undefined | null,
	companyIdentifier?: string | undefined | null,
	vatIdentifier?: string | undefined | null,
	externalIdentifier?: string | undefined | null,
	hidden?: boolean | undefined | null,
	customer?: ValueTypes["AddressCreateCustomerEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	country?: ValueTypes["AddressCreateCountryEntityRelationInput"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	googlePlaceId?: string | undefined | null,
	raw?: string | undefined | null,
	formatted?: string | undefined | null,
	geocodeGeneratedAt?: ValueTypes["DateTime"] | undefined | null,
	geocodeResponse?: string | undefined | null,
	deliveryZone?: ValueTypes["AddressCreateDeliveryZoneEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["AddressCreateMetaEntityRelationInput"] | undefined | null,
	gps?: ValueTypes["AddressCreateGpsEntityRelationInput"] | undefined | null,
	geocodeValid?: boolean | undefined | null,
	fullName?: string | undefined | null,
	fakturoidSubjectId?: string | undefined | null,
	invoices?: Array<ValueTypes["AddressCreateInvoicesEntityRelationInput"]> | undefined | null,
	addressLine1?: string | undefined | null,
	city?: string | undefined | null,
	postalCode?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingAddressOfOrders?: Array<ValueTypes["AddressCreateBillingAddressOfOrdersEntityRelationInput"]> | undefined | null,
	deliveryAddressOfOrderDeliveries?: Array<ValueTypes["AddressCreateDeliveryAddressOfOrderDeliveriesEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddressOfCustomer?: ValueTypes["AddressCreateDefaultDeliveryAddressOfCustomerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AddressCreateCustomerEntityRelationInput"]: {
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerWithoutAddressesCreateInput"] | undefined | null
};
	["CustomerWithoutAddressesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerCreateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerCreateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerCreatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerCreateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerCreateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerCreateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerCreateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerCreateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerCreateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerCreateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreateDefaultBillingAddressEntityRelationInput"]: {
	connect?: ValueTypes["AddressUniqueWhere"] | undefined | null,
	create?: ValueTypes["AddressCreateInput"] | undefined | null
};
	["CustomerCreateDefaultPaymentMethodEntityRelationInput"]: {
	connect?: ValueTypes["CustomerPaymentMethodUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerPaymentMethodCreateInput"] | undefined | null
};
	["CustomerPaymentMethodCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	caption?: string | undefined | null,
	data?: ValueTypes["Json"] | undefined | null,
	customer?: ValueTypes["CustomerPaymentMethodCreateCustomerEntityRelationInput"] | undefined | null,
	paymentMethod?: ValueTypes["CustomerPaymentMethodCreatePaymentMethodEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerPaymentMethodCreateCustomerEntityRelationInput"]: {
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerWithoutPaymentMethodsCreateInput"] | undefined | null
};
	["CustomerWithoutPaymentMethodsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	addresses?: Array<ValueTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerCreateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerCreateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerCreatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerCreateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerCreateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerCreateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerCreateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerCreateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerCreateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerCreateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreateAddressesEntityRelationInput"]: {
	connect?: ValueTypes["AddressUniqueWhere"] | undefined | null,
	create?: ValueTypes["AddressWithoutCustomerCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["AddressWithoutCustomerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	addressLine2?: string | undefined | null,
	email?: string | undefined | null,
	phone?: string | undefined | null,
	companyName?: string | undefined | null,
	companyIdentifier?: string | undefined | null,
	vatIdentifier?: string | undefined | null,
	externalIdentifier?: string | undefined | null,
	hidden?: boolean | undefined | null,
	internalNote?: string | undefined | null,
	country?: ValueTypes["AddressCreateCountryEntityRelationInput"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	googlePlaceId?: string | undefined | null,
	raw?: string | undefined | null,
	formatted?: string | undefined | null,
	geocodeGeneratedAt?: ValueTypes["DateTime"] | undefined | null,
	geocodeResponse?: string | undefined | null,
	deliveryZone?: ValueTypes["AddressCreateDeliveryZoneEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["AddressCreateMetaEntityRelationInput"] | undefined | null,
	gps?: ValueTypes["AddressCreateGpsEntityRelationInput"] | undefined | null,
	geocodeValid?: boolean | undefined | null,
	fullName?: string | undefined | null,
	fakturoidSubjectId?: string | undefined | null,
	invoices?: Array<ValueTypes["AddressCreateInvoicesEntityRelationInput"]> | undefined | null,
	addressLine1?: string | undefined | null,
	city?: string | undefined | null,
	postalCode?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingAddressOfOrders?: Array<ValueTypes["AddressCreateBillingAddressOfOrdersEntityRelationInput"]> | undefined | null,
	deliveryAddressOfOrderDeliveries?: Array<ValueTypes["AddressCreateDeliveryAddressOfOrderDeliveriesEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddressOfCustomer?: ValueTypes["AddressCreateDefaultDeliveryAddressOfCustomerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AddressCreateCountryEntityRelationInput"]: {
	connect?: ValueTypes["CountryUniqueWhere"] | undefined | null,
	create?: ValueTypes["CountryCreateInput"] | undefined | null
};
	["CountryUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	code?: string | undefined | null
};
	["CountryCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	order?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AddressCreateDeliveryZoneEntityRelationInput"]: {
	connect?: ValueTypes["DeliveryZoneUniqueWhere"] | undefined | null,
	create?: ValueTypes["DeliveryZoneWithoutAddressesCreateInput"] | undefined | null
};
	["DeliveryZoneUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	addresses?: ValueTypes["AddressUniqueWhere"] | undefined | null,
	addressesMetadata?: ValueTypes["AddressMetadataUniqueWhere"] | undefined | null
};
	["DeliveryZoneWithoutAddressesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	type?: ValueTypes["DeliveryZoneType"] | undefined | null,
	suitableDeliveryMethods?: Array<ValueTypes["DeliveryZoneCreateSuitableDeliveryMethodsEntityRelationInput"]> | undefined | null,
	deliveryZonesOfTags?: Array<ValueTypes["DeliveryZoneCreateDeliveryZonesOfTagsEntityRelationInput"]> | undefined | null,
	deliveryZonesOfProducts?: Array<ValueTypes["DeliveryZoneCreateDeliveryZonesOfProductsEntityRelationInput"]> | undefined | null,
	addressesMetadata?: Array<ValueTypes["DeliveryZoneCreateAddressesMetadataEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryZoneCreateSuitableDeliveryMethodsEntityRelationInput"]: {
	connect?: ValueTypes["DeliveryMethodUniqueWhere"] | undefined | null,
	create?: ValueTypes["DeliveryMethodWithoutSuitableForDeliveryZonesCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["DeliveryMethodWithoutSuitableForDeliveryZonesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	enabled?: boolean | undefined | null,
	paymentMethods?: Array<ValueTypes["DeliveryMethodCreatePaymentMethodsEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	requireDeliveryAddress?: boolean | undefined | null,
	channels?: Array<ValueTypes["DeliveryMethodCreateChannelsEntityRelationInput"]> | undefined | null,
	courierHandlers?: Array<ValueTypes["DeliveryMethodCreateCourierHandlersEntityRelationInput"]> | undefined | null,
	enableDeliveryTracking?: boolean | undefined | null,
	locales?: Array<ValueTypes["DeliveryMethodCreateLocalesEntityRelationInput"]> | undefined | null,
	timelinePreset?: ValueTypes["DeliveryMethodCreateTimelinePresetEntityRelationInput"] | undefined | null,
	woltDriveVenueId?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryMethodCreatePaymentMethodsEntityRelationInput"]: {
	connect?: ValueTypes["PaymentMethodUniqueWhere"] | undefined | null,
	create?: ValueTypes["PaymentMethodWithoutDeliveryMethodsCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PaymentMethodUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	channels?: ValueTypes["ChannelPaymentUniqueWhere"] | undefined | null
};
	["PaymentMethodWithoutDeliveryMethodsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	enabled?: boolean | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	blockingDispatch?: boolean | undefined | null,
	type?: ValueTypes["PaymentMethodType"] | undefined | null,
	channels?: Array<ValueTypes["PaymentMethodCreateChannelsEntityRelationInput"]> | undefined | null,
	reduceGratuityByPercentage?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PaymentMethodCreateChannelsEntityRelationInput"]: {
	connect?: ValueTypes["ChannelPaymentUniqueWhere"] | undefined | null,
	create?: ValueTypes["ChannelPaymentWithoutMethodCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ChannelPaymentWithoutMethodCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	channel?: ValueTypes["ChannelPaymentCreateChannelEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["ChannelPaymentCreateVatRateEntityRelationInput"] | undefined | null,
	requireBillingAddress?: boolean | undefined | null,
	provideReceipt?: boolean | undefined | null,
	requireBillingSubject?: boolean | undefined | null,
	allowOnlyForTags?: Array<ValueTypes["ChannelPaymentCreateAllowOnlyForTagsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ChannelPaymentCreateChannelEntityRelationInput"]: {
	connect?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	create?: ValueTypes["ChannelWithoutPaymentsCreateInput"] | undefined | null
};
	["ChannelWithoutPaymentsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	disabled?: boolean | undefined | null,
	deliveries?: Array<ValueTypes["ChannelCreateDeliveriesEntityRelationInput"]> | undefined | null,
	pointOfSales?: Array<ValueTypes["ChannelCreatePointOfSalesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["ChannelCreateCartsEntityRelationInput"]> | undefined | null,
	customers?: Array<ValueTypes["ChannelCreateCustomersEntityRelationInput"]> | undefined | null,
	code?: ValueTypes["ChannelCode"] | undefined | null,
	addTagsOnRegistration?: Array<ValueTypes["ChannelCreateAddTagsOnRegistrationEntityRelationInput"]> | undefined | null,
	publicTags?: Array<ValueTypes["ChannelCreatePublicTagsEntityRelationInput"]> | undefined | null,
	venue?: ValueTypes["ChannelCreateVenueEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ChannelCreateDeliveriesEntityRelationInput"]: {
	connect?: ValueTypes["ChannelDeliveryUniqueWhere"] | undefined | null,
	create?: ValueTypes["ChannelDeliveryWithoutChannelCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ChannelDeliveryWithoutChannelCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	priceCents?: number | undefined | null,
	method?: ValueTypes["ChannelDeliveryCreateMethodEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["ChannelDeliveryCreateVatRateEntityRelationInput"] | undefined | null,
	defaultVisible?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ChannelDeliveryCreateMethodEntityRelationInput"]: {
	connect?: ValueTypes["DeliveryMethodUniqueWhere"] | undefined | null,
	create?: ValueTypes["DeliveryMethodWithoutChannelsCreateInput"] | undefined | null
};
	["DeliveryMethodWithoutChannelsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	enabled?: boolean | undefined | null,
	paymentMethods?: Array<ValueTypes["DeliveryMethodCreatePaymentMethodsEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	requireDeliveryAddress?: boolean | undefined | null,
	suitableForDeliveryZones?: Array<ValueTypes["DeliveryMethodCreateSuitableForDeliveryZonesEntityRelationInput"]> | undefined | null,
	courierHandlers?: Array<ValueTypes["DeliveryMethodCreateCourierHandlersEntityRelationInput"]> | undefined | null,
	enableDeliveryTracking?: boolean | undefined | null,
	locales?: Array<ValueTypes["DeliveryMethodCreateLocalesEntityRelationInput"]> | undefined | null,
	timelinePreset?: ValueTypes["DeliveryMethodCreateTimelinePresetEntityRelationInput"] | undefined | null,
	woltDriveVenueId?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryMethodCreateSuitableForDeliveryZonesEntityRelationInput"]: {
	connect?: ValueTypes["DeliveryZoneUniqueWhere"] | undefined | null,
	create?: ValueTypes["DeliveryZoneWithoutSuitableDeliveryMethodsCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["DeliveryZoneWithoutSuitableDeliveryMethodsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	type?: ValueTypes["DeliveryZoneType"] | undefined | null,
	addresses?: Array<ValueTypes["DeliveryZoneCreateAddressesEntityRelationInput"]> | undefined | null,
	deliveryZonesOfTags?: Array<ValueTypes["DeliveryZoneCreateDeliveryZonesOfTagsEntityRelationInput"]> | undefined | null,
	deliveryZonesOfProducts?: Array<ValueTypes["DeliveryZoneCreateDeliveryZonesOfProductsEntityRelationInput"]> | undefined | null,
	addressesMetadata?: Array<ValueTypes["DeliveryZoneCreateAddressesMetadataEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryZoneCreateAddressesEntityRelationInput"]: {
	connect?: ValueTypes["AddressUniqueWhere"] | undefined | null,
	create?: ValueTypes["AddressWithoutDeliveryZoneCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["AddressWithoutDeliveryZoneCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	addressLine2?: string | undefined | null,
	email?: string | undefined | null,
	phone?: string | undefined | null,
	companyName?: string | undefined | null,
	companyIdentifier?: string | undefined | null,
	vatIdentifier?: string | undefined | null,
	externalIdentifier?: string | undefined | null,
	hidden?: boolean | undefined | null,
	customer?: ValueTypes["AddressCreateCustomerEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	country?: ValueTypes["AddressCreateCountryEntityRelationInput"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	googlePlaceId?: string | undefined | null,
	raw?: string | undefined | null,
	formatted?: string | undefined | null,
	geocodeGeneratedAt?: ValueTypes["DateTime"] | undefined | null,
	geocodeResponse?: string | undefined | null,
	meta?: ValueTypes["AddressCreateMetaEntityRelationInput"] | undefined | null,
	gps?: ValueTypes["AddressCreateGpsEntityRelationInput"] | undefined | null,
	geocodeValid?: boolean | undefined | null,
	fullName?: string | undefined | null,
	fakturoidSubjectId?: string | undefined | null,
	invoices?: Array<ValueTypes["AddressCreateInvoicesEntityRelationInput"]> | undefined | null,
	addressLine1?: string | undefined | null,
	city?: string | undefined | null,
	postalCode?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingAddressOfOrders?: Array<ValueTypes["AddressCreateBillingAddressOfOrdersEntityRelationInput"]> | undefined | null,
	deliveryAddressOfOrderDeliveries?: Array<ValueTypes["AddressCreateDeliveryAddressOfOrderDeliveriesEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddressOfCustomer?: ValueTypes["AddressCreateDefaultDeliveryAddressOfCustomerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AddressCreateMetaEntityRelationInput"]: {
	connect?: ValueTypes["AddressMetadataUniqueWhere"] | undefined | null
};
	["AddressCreateGpsEntityRelationInput"]: {
	connect?: ValueTypes["GpsUniqueWhere"] | undefined | null,
	create?: ValueTypes["GpsWithoutAddressCreateInput"] | undefined | null
};
	["GpsWithoutAddressCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	latitude?: number | undefined | null,
	longitude?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AddressCreateInvoicesEntityRelationInput"]: {
	connect?: ValueTypes["InvoiceUniqueWhere"] | undefined | null,
	create?: ValueTypes["InvoiceWithoutAddressCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["InvoiceWithoutAddressCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	publicKey?: string | undefined | null,
	fakturoidId?: string | undefined | null,
	fakturoidData?: string | undefined | null,
	legacyUrl?: string | undefined | null,
	customer?: ValueTypes["InvoiceCreateCustomerEntityRelationInput"] | undefined | null,
	orderPayments?: Array<ValueTypes["InvoiceCreateOrderPaymentsEntityRelationInput"]> | undefined | null,
	publicUrl?: string | undefined | null,
	billingSubject?: ValueTypes["InvoiceCreateBillingSubjectEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InvoiceCreateCustomerEntityRelationInput"]: {
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerWithoutInvoicesCreateInput"] | undefined | null
};
	["CustomerWithoutInvoicesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	addresses?: Array<ValueTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerCreateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerCreateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerCreatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerCreateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerCreateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerCreateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerCreateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoicingPlan?: ValueTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerCreateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerCreateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerCreateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreateTagsEntityRelationInput"]: {
	connect?: ValueTypes["TagUniqueWhere"] | undefined | null,
	create?: ValueTypes["TagWithoutCustomersCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TagUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	nestedCategories?: ValueTypes["InheritedProductCategoryTagUniqueWhere"] | undefined | null
};
	["TagWithoutCustomersCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	products?: Array<ValueTypes["TagCreateProductsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["TagCreateCategoriesEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	addTagsOnRegistration?: Array<ValueTypes["TagCreateAddTagsOnRegistrationEntityRelationInput"]> | undefined | null,
	nestedCategories?: Array<ValueTypes["TagCreateNestedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["TagCreateDeliveryZonesEntityRelationInput"]> | undefined | null,
	publicInChannels?: Array<ValueTypes["TagCreatePublicInChannelsEntityRelationInput"]> | undefined | null,
	allowChannelPayments?: Array<ValueTypes["TagCreateAllowChannelPaymentsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["TagCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TagCreateProductsEntityRelationInput"]: {
	connect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductWithoutTagsCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductWithoutTagsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	priceCents?: number | undefined | null,
	notDiscountable?: boolean | undefined | null,
	packing?: ValueTypes["ProductCreatePackingEntityRelationInput"] | undefined | null,
	recipe?: ValueTypes["ProductCreateRecipeEntityRelationInput"] | undefined | null,
	categories?: Array<ValueTypes["ProductCreateCategoriesEntityRelationInput"]> | undefined | null,
	vatRate?: ValueTypes["ProductCreateVatRateEntityRelationInput"] | undefined | null,
	stocks?: Array<ValueTypes["ProductCreateStocksEntityRelationInput"]> | undefined | null,
	groupPrices?: Array<ValueTypes["ProductCreateGroupPricesEntityRelationInput"]> | undefined | null,
	image?: ValueTypes["ProductCreateImageEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	cartItems?: Array<ValueTypes["ProductCreateCartItemsEntityRelationInput"]> | undefined | null,
	availability?: ValueTypes["ProductAvailability"] | undefined | null,
	order?: number | undefined | null,
	manager?: ValueTypes["ProductCreateManagerEntityRelationInput"] | undefined | null,
	orderItems?: Array<ValueTypes["ProductCreateOrderItemsEntityRelationInput"]> | undefined | null,
	maximumQuantityPerOrder?: number | undefined | null,
	inheritedCategories?: Array<ValueTypes["ProductCreateInheritedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["ProductCreateDeliveryZonesEntityRelationInput"]> | undefined | null,
	locales?: Array<ValueTypes["ProductCreateLocalesEntityRelationInput"]> | undefined | null,
	archivedAt?: ValueTypes["DateTime"] | undefined | null,
	customerPrices?: Array<ValueTypes["ProductCreateCustomerPricesEntityRelationInput"]> | undefined | null,
	virtualProduct?: ValueTypes["ProductCreateVirtualProductEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["ProductCreateMetaEntityRelationInput"] | undefined | null,
	page?: ValueTypes["ProductCreatePageEntityRelationInput"] | undefined | null,
	salesDays?: Array<ValueTypes["ProductCreateSalesDaysEntityRelationInput"]> | undefined | null,
	salesWeeks?: Array<ValueTypes["ProductCreateSalesWeeksEntityRelationInput"]> | undefined | null,
	salesMonths?: Array<ValueTypes["ProductCreateSalesMonthsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["ProductCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	hasSubscription?: boolean | undefined | null,
	pointOfSaleTileColor?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCreatePackingEntityRelationInput"]: {
	connect?: ValueTypes["ProductPackingUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductPackingCreateInput"] | undefined | null
};
	["ProductPackingCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	image?: ValueTypes["ProductPackingCreateImageEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	volumeMl?: number | undefined | null,
	icon?: ValueTypes["ProductPackingCreateIconEntityRelationInput"] | undefined | null,
	shortName?: string | undefined | null,
	locales?: Array<ValueTypes["ProductPackingCreateLocalesEntityRelationInput"]> | undefined | null,
	preparedPackingQuantities?: Array<ValueTypes["ProductPackingCreatePreparedPackingQuantitiesEntityRelationInput"]> | undefined | null,
	isPackedInCardboard?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductPackingCreateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["ImageCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	url?: string | undefined | null,
	width?: number | undefined | null,
	height?: number | undefined | null,
	size?: number | undefined | null,
	type?: string | undefined | null,
	alt?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductPackingCreateIconEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["ProductPackingCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["ProductPackingLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductPackingLocaleWithoutRootCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductPackingLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	shortName?: string | undefined | null,
	description?: string | undefined | null,
	locale?: ValueTypes["ProductPackingLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductPackingLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["LocaleWithoutProductPackingsCreateInput"] | undefined | null
};
	["LocaleWithoutProductPackingsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	businessCategories?: Array<ValueTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleCreateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleCreatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleCreateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreateBusinessCategoriesEntityRelationInput"]: {
	connect?: ValueTypes["BusinessCategoryLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["BusinessCategoryLocaleWithoutLocaleCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["BusinessCategoryLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	root?: ValueTypes["BusinessCategoryLocaleCreateRootEntityRelationInput"] | undefined | null,
	title?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessCategoryLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["BusinessCategoryUniqueWhere"] | undefined | null,
	create?: ValueTypes["BusinessCategoryWithoutLocalesCreateInput"] | undefined | null
};
	["BusinessCategoryWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	visibleToNewCustomers?: boolean | undefined | null,
	internalName?: string | undefined | null,
	businessCustomers?: Array<ValueTypes["BusinessCategoryCreateBusinessCustomersEntityRelationInput"]> | undefined | null,
	recurrences?: Array<ValueTypes["BusinessCategoryCreateRecurrencesEntityRelationInput"]> | undefined | null,
	specificProducts?: ValueTypes["BusinessCategoryCreateSpecificProductsEntityRelationInput"] | undefined | null,
	seasonalProductCategories?: ValueTypes["BusinessCategoryCreateSeasonalProductCategoriesEntityRelationInput"] | undefined | null,
	specificProductsProductCategories?: ValueTypes["BusinessCategoryCreateSpecificProductsProductCategoriesEntityRelationInput"] | undefined | null,
	slug?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessCategoryCreateBusinessCustomersEntityRelationInput"]: {
	connect?: ValueTypes["BusinessCustomerUniqueWhere"] | undefined | null,
	create?: ValueTypes["BusinessCustomerWithoutCategoryCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["BusinessCustomerWithoutCategoryCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	customer?: ValueTypes["BusinessCustomerCreateCustomerEntityRelationInput"] | undefined | null,
	owners?: Array<ValueTypes["BusinessCustomerCreateOwnersEntityRelationInput"]> | undefined | null,
	members?: Array<ValueTypes["BusinessCustomerCreateMembersEntityRelationInput"]> | undefined | null,
	accountManager?: ValueTypes["BusinessCustomerCreateAccountManagerEntityRelationInput"] | undefined | null,
	logo?: ValueTypes["BusinessCustomerCreateLogoEntityRelationInput"] | undefined | null,
	note?: string | undefined | null,
	businessServiceEvents?: Array<ValueTypes["BusinessCustomerCreateBusinessServiceEventsEntityRelationInput"]> | undefined | null,
	doubleshotCoffeeEquipment?: ValueTypes["BusinessCustomerCreateDoubleshotCoffeeEquipmentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessCustomerCreateCustomerEntityRelationInput"]: {
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerWithoutBusinessCreateInput"] | undefined | null
};
	["CustomerWithoutBusinessCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	addresses?: Array<ValueTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerCreateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerCreateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerCreatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerCreateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerCreateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerCreateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerCreateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerCreateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerCreateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreateCreditsEntityRelationInput"]: {
	connect?: ValueTypes["CustomerCreditUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerCreditWithoutCustomerCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerCreditWithoutCustomerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	initialCreditCents?: number | undefined | null,
	remainingCreditsCents?: number | undefined | null,
	expiresAt?: ValueTypes["DateTime"] | undefined | null,
	reason?: string | undefined | null,
	vatRate?: ValueTypes["CustomerCreditCreateVatRateEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	transactions?: Array<ValueTypes["CustomerCreditCreateTransactionsEntityRelationInput"]> | undefined | null,
	voucherRedemption?: ValueTypes["CustomerCreditCreateVoucherRedemptionEntityRelationInput"] | undefined | null,
	invoiceUrl?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreditCreateVatRateEntityRelationInput"]: {
	connect?: ValueTypes["VatRateUniqueWhere"] | undefined | null,
	create?: ValueTypes["VatRateCreateInput"] | undefined | null
};
	["VatRateUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	preset?: ValueTypes["VatRatePreset"] | undefined | null,
	channelDeliveries?: ValueTypes["ChannelDeliveryUniqueWhere"] | undefined | null,
	channelPayments?: ValueTypes["ChannelPaymentUniqueWhere"] | undefined | null
};
	["VatRateCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	ratePermille?: number | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	channelDeliveries?: Array<ValueTypes["VatRateCreateChannelDeliveriesEntityRelationInput"]> | undefined | null,
	channelPayments?: Array<ValueTypes["VatRateCreateChannelPaymentsEntityRelationInput"]> | undefined | null,
	preset?: ValueTypes["VatRatePreset"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VatRateCreateChannelDeliveriesEntityRelationInput"]: {
	connect?: ValueTypes["ChannelDeliveryUniqueWhere"] | undefined | null,
	create?: ValueTypes["ChannelDeliveryWithoutVatRateCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ChannelDeliveryWithoutVatRateCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	priceCents?: number | undefined | null,
	channel?: ValueTypes["ChannelDeliveryCreateChannelEntityRelationInput"] | undefined | null,
	method?: ValueTypes["ChannelDeliveryCreateMethodEntityRelationInput"] | undefined | null,
	defaultVisible?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ChannelDeliveryCreateChannelEntityRelationInput"]: {
	connect?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	create?: ValueTypes["ChannelWithoutDeliveriesCreateInput"] | undefined | null
};
	["ChannelWithoutDeliveriesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	disabled?: boolean | undefined | null,
	payments?: Array<ValueTypes["ChannelCreatePaymentsEntityRelationInput"]> | undefined | null,
	pointOfSales?: Array<ValueTypes["ChannelCreatePointOfSalesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["ChannelCreateCartsEntityRelationInput"]> | undefined | null,
	customers?: Array<ValueTypes["ChannelCreateCustomersEntityRelationInput"]> | undefined | null,
	code?: ValueTypes["ChannelCode"] | undefined | null,
	addTagsOnRegistration?: Array<ValueTypes["ChannelCreateAddTagsOnRegistrationEntityRelationInput"]> | undefined | null,
	publicTags?: Array<ValueTypes["ChannelCreatePublicTagsEntityRelationInput"]> | undefined | null,
	venue?: ValueTypes["ChannelCreateVenueEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ChannelCreatePaymentsEntityRelationInput"]: {
	connect?: ValueTypes["ChannelPaymentUniqueWhere"] | undefined | null,
	create?: ValueTypes["ChannelPaymentWithoutChannelCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ChannelPaymentWithoutChannelCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	method?: ValueTypes["ChannelPaymentCreateMethodEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["ChannelPaymentCreateVatRateEntityRelationInput"] | undefined | null,
	requireBillingAddress?: boolean | undefined | null,
	provideReceipt?: boolean | undefined | null,
	requireBillingSubject?: boolean | undefined | null,
	allowOnlyForTags?: Array<ValueTypes["ChannelPaymentCreateAllowOnlyForTagsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ChannelPaymentCreateMethodEntityRelationInput"]: {
	connect?: ValueTypes["PaymentMethodUniqueWhere"] | undefined | null,
	create?: ValueTypes["PaymentMethodWithoutChannelsCreateInput"] | undefined | null
};
	["PaymentMethodWithoutChannelsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	enabled?: boolean | undefined | null,
	deliveryMethods?: Array<ValueTypes["PaymentMethodCreateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	blockingDispatch?: boolean | undefined | null,
	type?: ValueTypes["PaymentMethodType"] | undefined | null,
	reduceGratuityByPercentage?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PaymentMethodCreateDeliveryMethodsEntityRelationInput"]: {
	connect?: ValueTypes["DeliveryMethodUniqueWhere"] | undefined | null,
	create?: ValueTypes["DeliveryMethodWithoutPaymentMethodsCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["DeliveryMethodWithoutPaymentMethodsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	enabled?: boolean | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	requireDeliveryAddress?: boolean | undefined | null,
	suitableForDeliveryZones?: Array<ValueTypes["DeliveryMethodCreateSuitableForDeliveryZonesEntityRelationInput"]> | undefined | null,
	channels?: Array<ValueTypes["DeliveryMethodCreateChannelsEntityRelationInput"]> | undefined | null,
	courierHandlers?: Array<ValueTypes["DeliveryMethodCreateCourierHandlersEntityRelationInput"]> | undefined | null,
	enableDeliveryTracking?: boolean | undefined | null,
	locales?: Array<ValueTypes["DeliveryMethodCreateLocalesEntityRelationInput"]> | undefined | null,
	timelinePreset?: ValueTypes["DeliveryMethodCreateTimelinePresetEntityRelationInput"] | undefined | null,
	woltDriveVenueId?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryMethodCreateChannelsEntityRelationInput"]: {
	connect?: ValueTypes["ChannelDeliveryUniqueWhere"] | undefined | null,
	create?: ValueTypes["ChannelDeliveryWithoutMethodCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ChannelDeliveryWithoutMethodCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	priceCents?: number | undefined | null,
	channel?: ValueTypes["ChannelDeliveryCreateChannelEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["ChannelDeliveryCreateVatRateEntityRelationInput"] | undefined | null,
	defaultVisible?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ChannelDeliveryCreateVatRateEntityRelationInput"]: {
	connect?: ValueTypes["VatRateUniqueWhere"] | undefined | null,
	create?: ValueTypes["VatRateWithoutChannelDeliveriesCreateInput"] | undefined | null
};
	["VatRateWithoutChannelDeliveriesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	ratePermille?: number | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	channelPayments?: Array<ValueTypes["VatRateCreateChannelPaymentsEntityRelationInput"]> | undefined | null,
	preset?: ValueTypes["VatRatePreset"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VatRateCreateChannelPaymentsEntityRelationInput"]: {
	connect?: ValueTypes["ChannelPaymentUniqueWhere"] | undefined | null,
	create?: ValueTypes["ChannelPaymentWithoutVatRateCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ChannelPaymentWithoutVatRateCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	channel?: ValueTypes["ChannelPaymentCreateChannelEntityRelationInput"] | undefined | null,
	method?: ValueTypes["ChannelPaymentCreateMethodEntityRelationInput"] | undefined | null,
	requireBillingAddress?: boolean | undefined | null,
	provideReceipt?: boolean | undefined | null,
	requireBillingSubject?: boolean | undefined | null,
	allowOnlyForTags?: Array<ValueTypes["ChannelPaymentCreateAllowOnlyForTagsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ChannelPaymentCreateAllowOnlyForTagsEntityRelationInput"]: {
	connect?: ValueTypes["TagUniqueWhere"] | undefined | null,
	create?: ValueTypes["TagWithoutAllowChannelPaymentsCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TagWithoutAllowChannelPaymentsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	customers?: Array<ValueTypes["TagCreateCustomersEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["TagCreateProductsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["TagCreateCategoriesEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	addTagsOnRegistration?: Array<ValueTypes["TagCreateAddTagsOnRegistrationEntityRelationInput"]> | undefined | null,
	nestedCategories?: Array<ValueTypes["TagCreateNestedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["TagCreateDeliveryZonesEntityRelationInput"]> | undefined | null,
	publicInChannels?: Array<ValueTypes["TagCreatePublicInChannelsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["TagCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TagCreateCustomersEntityRelationInput"]: {
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerWithoutTagsCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerWithoutTagsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	addresses?: Array<ValueTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	credits?: Array<ValueTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerCreateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerCreatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerCreateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerCreateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerCreateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerCreateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerCreateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerCreateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerCreateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreatePaymentMethodsEntityRelationInput"]: {
	connect?: ValueTypes["CustomerPaymentMethodUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerPaymentMethodWithoutCustomerCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerPaymentMethodWithoutCustomerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	caption?: string | undefined | null,
	data?: ValueTypes["Json"] | undefined | null,
	paymentMethod?: ValueTypes["CustomerPaymentMethodCreatePaymentMethodEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerPaymentMethodCreatePaymentMethodEntityRelationInput"]: {
	connect?: ValueTypes["PaymentMethodUniqueWhere"] | undefined | null,
	create?: ValueTypes["PaymentMethodCreateInput"] | undefined | null
};
	["PaymentMethodCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	enabled?: boolean | undefined | null,
	deliveryMethods?: Array<ValueTypes["PaymentMethodCreateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	blockingDispatch?: boolean | undefined | null,
	type?: ValueTypes["PaymentMethodType"] | undefined | null,
	channels?: Array<ValueTypes["PaymentMethodCreateChannelsEntityRelationInput"]> | undefined | null,
	reduceGratuityByPercentage?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreateOrdersEntityRelationInput"]: {
	connect?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	create?: ValueTypes["OrderWithoutCustomerCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["OrderWithoutCustomerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	state?: ValueTypes["OrderState"] | undefined | null,
	fulfilledAt?: ValueTypes["DateTime"] | undefined | null,
	canceledAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	channel?: ValueTypes["OrderCreateChannelEntityRelationInput"] | undefined | null,
	discounts?: Array<ValueTypes["OrderCreateDiscountsEntityRelationInput"]> | undefined | null,
	delivery?: ValueTypes["OrderCreateDeliveryEntityRelationInput"] | undefined | null,
	items?: Array<ValueTypes["OrderCreateItemsEntityRelationInput"]> | undefined | null,
	internalNote?: string | undefined | null,
	cart?: ValueTypes["OrderCreateCartEntityRelationInput"] | undefined | null,
	events?: Array<ValueTypes["OrderCreateEventsEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingAddress?: ValueTypes["OrderCreateBillingAddressEntityRelationInput"] | undefined | null,
	priceLines?: Array<ValueTypes["OrderCreatePriceLinesEntityRelationInput"]> | undefined | null,
	payments?: Array<ValueTypes["OrderCreatePaymentsEntityRelationInput"]> | undefined | null,
	seq?: number | undefined | null,
	billingSubject?: ValueTypes["OrderCreateBillingSubjectEntityRelationInput"] | undefined | null,
	summary?: ValueTypes["OrderCreateSummaryEntityRelationInput"] | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	gratuity?: ValueTypes["OrderCreateGratuityEntityRelationInput"] | undefined | null,
	venue?: ValueTypes["OrderCreateVenueEntityRelationInput"] | undefined | null,
	fulfillmentNote?: string | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["OrderCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	doubleshotTotalWeightGrams?: number | undefined | null,
	doubleShotLegacyNumber?: string | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	doubleshotAdminUrl?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderCreateChannelEntityRelationInput"]: {
	connect?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	create?: ValueTypes["ChannelCreateInput"] | undefined | null
};
	["ChannelCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	disabled?: boolean | undefined | null,
	payments?: Array<ValueTypes["ChannelCreatePaymentsEntityRelationInput"]> | undefined | null,
	deliveries?: Array<ValueTypes["ChannelCreateDeliveriesEntityRelationInput"]> | undefined | null,
	pointOfSales?: Array<ValueTypes["ChannelCreatePointOfSalesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["ChannelCreateCartsEntityRelationInput"]> | undefined | null,
	customers?: Array<ValueTypes["ChannelCreateCustomersEntityRelationInput"]> | undefined | null,
	code?: ValueTypes["ChannelCode"] | undefined | null,
	addTagsOnRegistration?: Array<ValueTypes["ChannelCreateAddTagsOnRegistrationEntityRelationInput"]> | undefined | null,
	publicTags?: Array<ValueTypes["ChannelCreatePublicTagsEntityRelationInput"]> | undefined | null,
	venue?: ValueTypes["ChannelCreateVenueEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ChannelCreatePointOfSalesEntityRelationInput"]: {
	connect?: ValueTypes["PointOfSaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["PointOfSaleWithoutChannelsCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PointOfSaleUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	tenantPersonId?: ValueTypes["UUID"] | undefined | null,
	permissions?: ValueTypes["PointOfSalePermissionsUniqueWhere"] | undefined | null
};
	["PointOfSalePermissionsUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	pointOfSale?: ValueTypes["PointOfSaleUniqueWhere"] | undefined | null
};
	["PointOfSaleWithoutChannelsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	permissions?: ValueTypes["PointOfSaleCreatePermissionsEntityRelationInput"] | undefined | null,
	tenantPersonId?: ValueTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleCreatePermissionsEntityRelationInput"]: {
	connect?: ValueTypes["PointOfSalePermissionsUniqueWhere"] | undefined | null
};
	["ChannelCreateCartsEntityRelationInput"]: {
	connect?: ValueTypes["CartUniqueWhere"] | undefined | null,
	create?: ValueTypes["CartWithoutChannelCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["CartWithoutChannelCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	confirmedAt?: ValueTypes["DateTime"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	items?: Array<ValueTypes["CartCreateItemsEntityRelationInput"]> | undefined | null,
	handle?: string | undefined | null,
	state?: ValueTypes["CartState"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	order?: ValueTypes["CartCreateOrderEntityRelationInput"] | undefined | null,
	customer?: ValueTypes["CartCreateCustomerEntityRelationInput"] | undefined | null,
	deliveryAddress?: ValueTypes["CartCreateDeliveryAddressEntityRelationInput"] | undefined | null,
	billingAddress?: ValueTypes["CartCreateBillingAddressEntityRelationInput"] | undefined | null,
	deliveryOption?: string | undefined | null,
	paymentOption?: string | undefined | null,
	delivery?: ValueTypes["CartCreateDeliveryEntityRelationInput"] | undefined | null,
	payment?: ValueTypes["CartCreatePaymentEntityRelationInput"] | undefined | null,
	billingSubject?: ValueTypes["CartCreateBillingSubjectEntityRelationInput"] | undefined | null,
	priceLines?: Array<ValueTypes["CartCreatePriceLinesEntityRelationInput"]> | undefined | null,
	summary?: ValueTypes["CartCreateSummaryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CartCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["CartItemUniqueWhere"] | undefined | null,
	create?: ValueTypes["CartItemWithoutCartCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["CartItemWithoutCartCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	quantity?: number | undefined | null,
	product?: ValueTypes["CartItemCreateProductEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	updatedAt?: ValueTypes["DateTime"] | undefined | null,
	fulfillmentNote?: string | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["CartItemCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CartItemCreateProductEntityRelationInput"]: {
	connect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductWithoutCartItemsCreateInput"] | undefined | null
};
	["ProductWithoutCartItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	priceCents?: number | undefined | null,
	notDiscountable?: boolean | undefined | null,
	packing?: ValueTypes["ProductCreatePackingEntityRelationInput"] | undefined | null,
	recipe?: ValueTypes["ProductCreateRecipeEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["ProductCreateTagsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["ProductCreateCategoriesEntityRelationInput"]> | undefined | null,
	vatRate?: ValueTypes["ProductCreateVatRateEntityRelationInput"] | undefined | null,
	stocks?: Array<ValueTypes["ProductCreateStocksEntityRelationInput"]> | undefined | null,
	groupPrices?: Array<ValueTypes["ProductCreateGroupPricesEntityRelationInput"]> | undefined | null,
	image?: ValueTypes["ProductCreateImageEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	availability?: ValueTypes["ProductAvailability"] | undefined | null,
	order?: number | undefined | null,
	manager?: ValueTypes["ProductCreateManagerEntityRelationInput"] | undefined | null,
	orderItems?: Array<ValueTypes["ProductCreateOrderItemsEntityRelationInput"]> | undefined | null,
	maximumQuantityPerOrder?: number | undefined | null,
	inheritedCategories?: Array<ValueTypes["ProductCreateInheritedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["ProductCreateDeliveryZonesEntityRelationInput"]> | undefined | null,
	locales?: Array<ValueTypes["ProductCreateLocalesEntityRelationInput"]> | undefined | null,
	archivedAt?: ValueTypes["DateTime"] | undefined | null,
	customerPrices?: Array<ValueTypes["ProductCreateCustomerPricesEntityRelationInput"]> | undefined | null,
	virtualProduct?: ValueTypes["ProductCreateVirtualProductEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["ProductCreateMetaEntityRelationInput"] | undefined | null,
	page?: ValueTypes["ProductCreatePageEntityRelationInput"] | undefined | null,
	salesDays?: Array<ValueTypes["ProductCreateSalesDaysEntityRelationInput"]> | undefined | null,
	salesWeeks?: Array<ValueTypes["ProductCreateSalesWeeksEntityRelationInput"]> | undefined | null,
	salesMonths?: Array<ValueTypes["ProductCreateSalesMonthsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["ProductCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	hasSubscription?: boolean | undefined | null,
	pointOfSaleTileColor?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCreateRecipeEntityRelationInput"]: {
	connect?: ValueTypes["ProductRecipeUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductRecipeWithoutProductsCreateInput"] | undefined | null
};
	["ProductRecipeWithoutProductsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	internalNote?: string | undefined | null,
	color?: string | undefined | null,
	image?: ValueTypes["ProductRecipeCreateImageEntityRelationInput"] | undefined | null,
	icon?: ValueTypes["ProductRecipeCreateIconEntityRelationInput"] | undefined | null,
	ingredients?: Array<ValueTypes["ProductRecipeCreateIngredientsEntityRelationInput"]> | undefined | null,
	needsPrepping?: boolean | undefined | null,
	locales?: Array<ValueTypes["ProductRecipeCreateLocalesEntityRelationInput"]> | undefined | null,
	gutTuning?: number | undefined | null,
	freshingContainer?: ValueTypes["ProductRecipeCreateFreshingContainerEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	nutritionFacts?: ValueTypes["ProductRecipeCreateNutritionFactsEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductRecipeCreateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["ProductRecipeCreateIconEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["ProductRecipeCreateIngredientsEntityRelationInput"]: {
	connect?: ValueTypes["ProductIngredientItemUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductIngredientItemWithoutRecipeCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductIngredientItemWithoutRecipeCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	internalOrder?: number | undefined | null,
	ingredient?: ValueTypes["ProductIngredientItemCreateIngredientEntityRelationInput"] | undefined | null,
	quantity?: ValueTypes["ProductIngredientItemCreateQuantityEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientItemCreateIngredientEntityRelationInput"]: {
	connect?: ValueTypes["ProductIngredientUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductIngredientCreateInput"] | undefined | null
};
	["ProductIngredientCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	internalNote?: string | undefined | null,
	locales?: Array<ValueTypes["ProductIngredientCreateLocalesEntityRelationInput"]> | undefined | null,
	internalName?: string | undefined | null,
	categories?: Array<ValueTypes["ProductIngredientCreateCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["ProductIngredientCreateAllergensEntityRelationInput"]> | undefined | null,
	needsPrepping?: boolean | undefined | null,
	allowCustomerRating?: boolean | undefined | null,
	customerRatings?: Array<ValueTypes["ProductIngredientCreateCustomerRatingsEntityRelationInput"]> | undefined | null,
	preferredQuantityUnit?: ValueTypes["ProductIngredientCreatePreferredQuantityUnitEntityRelationInput"] | undefined | null,
	freshingContainer?: ValueTypes["ProductIngredientCreateFreshingContainerEntityRelationInput"] | undefined | null,
	image?: ValueTypes["ProductIngredientCreateImageEntityRelationInput"] | undefined | null,
	suppliers?: ValueTypes["ProductIngredientCreateSuppliersEntityRelationInput"] | undefined | null,
	incrementQuantityNumber?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["ProductIngredientLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductIngredientLocaleWithoutRootCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductIngredientLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	locale?: ValueTypes["ProductIngredientLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["LocaleWithoutProductIngredientsCreateInput"] | undefined | null
};
	["LocaleWithoutProductIngredientsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	businessCategories?: Array<ValueTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleCreateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleCreatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleCreateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreateProductCategoryListsEntityRelationInput"]: {
	connect?: ValueTypes["ProductCategoryListLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductCategoryListLocaleWithoutLocaleCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductCategoryListLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	root?: ValueTypes["ProductCategoryListLocaleCreateRootEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCategoryListLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["ProductCategoryListUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductCategoryListWithoutLocalesCreateInput"] | undefined | null
};
	["ProductCategoryListWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: Array<ValueTypes["ProductCategoryListCreateItemsEntityRelationInput"]> | undefined | null,
	seasonalProductCategoriesOfBusinessCategory?: ValueTypes["ProductCategoryListCreateSeasonalProductCategoriesOfBusinessCategoryEntityRelationInput"] | undefined | null,
	specificProductsProductCategoriesOfBusinessCategory?: ValueTypes["ProductCategoryListCreateSpecificProductsProductCategoriesOfBusinessCategoryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCategoryListCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["ProductCategoryListItemUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductCategoryListItemWithoutListCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductCategoryListItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	productCategory?: ValueTypes["ProductCategoryListItemCreateProductCategoryEntityRelationInput"] | undefined | null,
	showRecipeImages?: boolean | undefined | null,
	showPackingImages?: boolean | undefined | null,
	showAllAvailableProducts?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCategoryListItemCreateProductCategoryEntityRelationInput"]: {
	connect?: ValueTypes["ProductCategoryUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductCategoryCreateInput"] | undefined | null
};
	["ProductCategoryCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	products?: Array<ValueTypes["ProductCategoryCreateProductsEntityRelationInput"]> | undefined | null,
	tags?: Array<ValueTypes["ProductCategoryCreateTagsEntityRelationInput"]> | undefined | null,
	parent?: ValueTypes["ProductCategoryCreateParentEntityRelationInput"] | undefined | null,
	children?: Array<ValueTypes["ProductCategoryCreateChildrenEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	color?: string | undefined | null,
	image?: ValueTypes["ProductCategoryCreateImageEntityRelationInput"] | undefined | null,
	order?: number | undefined | null,
	descendants?: Array<ValueTypes["ProductCategoryCreateDescendantsEntityRelationInput"]> | undefined | null,
	ancestors?: Array<ValueTypes["ProductCategoryCreateAncestorsEntityRelationInput"]> | undefined | null,
	inheritedTags?: Array<ValueTypes["ProductCategoryCreateInheritedTagsEntityRelationInput"]> | undefined | null,
	nestedProducts?: Array<ValueTypes["ProductCategoryCreateNestedProductsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCategoryCreateProductsEntityRelationInput"]: {
	connect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductWithoutCategoriesCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductWithoutCategoriesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	priceCents?: number | undefined | null,
	notDiscountable?: boolean | undefined | null,
	packing?: ValueTypes["ProductCreatePackingEntityRelationInput"] | undefined | null,
	recipe?: ValueTypes["ProductCreateRecipeEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["ProductCreateTagsEntityRelationInput"]> | undefined | null,
	vatRate?: ValueTypes["ProductCreateVatRateEntityRelationInput"] | undefined | null,
	stocks?: Array<ValueTypes["ProductCreateStocksEntityRelationInput"]> | undefined | null,
	groupPrices?: Array<ValueTypes["ProductCreateGroupPricesEntityRelationInput"]> | undefined | null,
	image?: ValueTypes["ProductCreateImageEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	cartItems?: Array<ValueTypes["ProductCreateCartItemsEntityRelationInput"]> | undefined | null,
	availability?: ValueTypes["ProductAvailability"] | undefined | null,
	order?: number | undefined | null,
	manager?: ValueTypes["ProductCreateManagerEntityRelationInput"] | undefined | null,
	orderItems?: Array<ValueTypes["ProductCreateOrderItemsEntityRelationInput"]> | undefined | null,
	maximumQuantityPerOrder?: number | undefined | null,
	inheritedCategories?: Array<ValueTypes["ProductCreateInheritedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["ProductCreateDeliveryZonesEntityRelationInput"]> | undefined | null,
	locales?: Array<ValueTypes["ProductCreateLocalesEntityRelationInput"]> | undefined | null,
	archivedAt?: ValueTypes["DateTime"] | undefined | null,
	customerPrices?: Array<ValueTypes["ProductCreateCustomerPricesEntityRelationInput"]> | undefined | null,
	virtualProduct?: ValueTypes["ProductCreateVirtualProductEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["ProductCreateMetaEntityRelationInput"] | undefined | null,
	page?: ValueTypes["ProductCreatePageEntityRelationInput"] | undefined | null,
	salesDays?: Array<ValueTypes["ProductCreateSalesDaysEntityRelationInput"]> | undefined | null,
	salesWeeks?: Array<ValueTypes["ProductCreateSalesWeeksEntityRelationInput"]> | undefined | null,
	salesMonths?: Array<ValueTypes["ProductCreateSalesMonthsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["ProductCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	hasSubscription?: boolean | undefined | null,
	pointOfSaleTileColor?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCreateTagsEntityRelationInput"]: {
	connect?: ValueTypes["TagUniqueWhere"] | undefined | null,
	create?: ValueTypes["TagWithoutProductsCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TagWithoutProductsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	customers?: Array<ValueTypes["TagCreateCustomersEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["TagCreateCategoriesEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	addTagsOnRegistration?: Array<ValueTypes["TagCreateAddTagsOnRegistrationEntityRelationInput"]> | undefined | null,
	nestedCategories?: Array<ValueTypes["TagCreateNestedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["TagCreateDeliveryZonesEntityRelationInput"]> | undefined | null,
	publicInChannels?: Array<ValueTypes["TagCreatePublicInChannelsEntityRelationInput"]> | undefined | null,
	allowChannelPayments?: Array<ValueTypes["TagCreateAllowChannelPaymentsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["TagCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TagCreateCategoriesEntityRelationInput"]: {
	connect?: ValueTypes["ProductCategoryUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductCategoryWithoutTagsCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductCategoryWithoutTagsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	products?: Array<ValueTypes["ProductCategoryCreateProductsEntityRelationInput"]> | undefined | null,
	parent?: ValueTypes["ProductCategoryCreateParentEntityRelationInput"] | undefined | null,
	children?: Array<ValueTypes["ProductCategoryCreateChildrenEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	color?: string | undefined | null,
	image?: ValueTypes["ProductCategoryCreateImageEntityRelationInput"] | undefined | null,
	order?: number | undefined | null,
	descendants?: Array<ValueTypes["ProductCategoryCreateDescendantsEntityRelationInput"]> | undefined | null,
	ancestors?: Array<ValueTypes["ProductCategoryCreateAncestorsEntityRelationInput"]> | undefined | null,
	inheritedTags?: Array<ValueTypes["ProductCategoryCreateInheritedTagsEntityRelationInput"]> | undefined | null,
	nestedProducts?: Array<ValueTypes["ProductCategoryCreateNestedProductsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCategoryCreateParentEntityRelationInput"]: {
	connect?: ValueTypes["ProductCategoryUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductCategoryWithoutChildrenCreateInput"] | undefined | null
};
	["ProductCategoryWithoutChildrenCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	products?: Array<ValueTypes["ProductCategoryCreateProductsEntityRelationInput"]> | undefined | null,
	tags?: Array<ValueTypes["ProductCategoryCreateTagsEntityRelationInput"]> | undefined | null,
	parent?: ValueTypes["ProductCategoryCreateParentEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	color?: string | undefined | null,
	image?: ValueTypes["ProductCategoryCreateImageEntityRelationInput"] | undefined | null,
	order?: number | undefined | null,
	descendants?: Array<ValueTypes["ProductCategoryCreateDescendantsEntityRelationInput"]> | undefined | null,
	ancestors?: Array<ValueTypes["ProductCategoryCreateAncestorsEntityRelationInput"]> | undefined | null,
	inheritedTags?: Array<ValueTypes["ProductCategoryCreateInheritedTagsEntityRelationInput"]> | undefined | null,
	nestedProducts?: Array<ValueTypes["ProductCategoryCreateNestedProductsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCategoryCreateTagsEntityRelationInput"]: {
	connect?: ValueTypes["TagUniqueWhere"] | undefined | null,
	create?: ValueTypes["TagWithoutCategoriesCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TagWithoutCategoriesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	customers?: Array<ValueTypes["TagCreateCustomersEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["TagCreateProductsEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	addTagsOnRegistration?: Array<ValueTypes["TagCreateAddTagsOnRegistrationEntityRelationInput"]> | undefined | null,
	nestedCategories?: Array<ValueTypes["TagCreateNestedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["TagCreateDeliveryZonesEntityRelationInput"]> | undefined | null,
	publicInChannels?: Array<ValueTypes["TagCreatePublicInChannelsEntityRelationInput"]> | undefined | null,
	allowChannelPayments?: Array<ValueTypes["TagCreateAllowChannelPaymentsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["TagCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TagCreateAddTagsOnRegistrationEntityRelationInput"]: {
	connect?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	create?: ValueTypes["ChannelWithoutAddTagsOnRegistrationCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ChannelWithoutAddTagsOnRegistrationCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	disabled?: boolean | undefined | null,
	payments?: Array<ValueTypes["ChannelCreatePaymentsEntityRelationInput"]> | undefined | null,
	deliveries?: Array<ValueTypes["ChannelCreateDeliveriesEntityRelationInput"]> | undefined | null,
	pointOfSales?: Array<ValueTypes["ChannelCreatePointOfSalesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["ChannelCreateCartsEntityRelationInput"]> | undefined | null,
	customers?: Array<ValueTypes["ChannelCreateCustomersEntityRelationInput"]> | undefined | null,
	code?: ValueTypes["ChannelCode"] | undefined | null,
	publicTags?: Array<ValueTypes["ChannelCreatePublicTagsEntityRelationInput"]> | undefined | null,
	venue?: ValueTypes["ChannelCreateVenueEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ChannelCreateCustomersEntityRelationInput"]: {
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerWithoutChannelsCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerWithoutChannelsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	addresses?: Array<ValueTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerCreateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerCreateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerCreatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerCreateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerCreateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerCreateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerCreateUserEntityRelationInput"] | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerCreateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerCreateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerCreateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreatePermissionsEntityRelationInput"]: {
	connect?: ValueTypes["CustomerPermissionsUniqueWhere"] | undefined | null
};
	["CustomerCreateGroupEntityRelationInput"]: {
	connect?: ValueTypes["CustomerGroupUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerGroupWithoutCustomersCreateInput"] | undefined | null
};
	["CustomerGroupWithoutCustomersCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	productPrices?: Array<ValueTypes["CustomerGroupCreateProductPricesEntityRelationInput"]> | undefined | null,
	discountPermille?: number | undefined | null,
	code?: string | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerGroupCreateProductPricesEntityRelationInput"]: {
	connect?: ValueTypes["ProductGroupPriceUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductGroupPriceWithoutGroupCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductGroupPriceWithoutGroupCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	priceCents?: number | undefined | null,
	product?: ValueTypes["ProductGroupPriceCreateProductEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductGroupPriceCreateProductEntityRelationInput"]: {
	connect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductWithoutGroupPricesCreateInput"] | undefined | null
};
	["ProductWithoutGroupPricesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	priceCents?: number | undefined | null,
	notDiscountable?: boolean | undefined | null,
	packing?: ValueTypes["ProductCreatePackingEntityRelationInput"] | undefined | null,
	recipe?: ValueTypes["ProductCreateRecipeEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["ProductCreateTagsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["ProductCreateCategoriesEntityRelationInput"]> | undefined | null,
	vatRate?: ValueTypes["ProductCreateVatRateEntityRelationInput"] | undefined | null,
	stocks?: Array<ValueTypes["ProductCreateStocksEntityRelationInput"]> | undefined | null,
	image?: ValueTypes["ProductCreateImageEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	cartItems?: Array<ValueTypes["ProductCreateCartItemsEntityRelationInput"]> | undefined | null,
	availability?: ValueTypes["ProductAvailability"] | undefined | null,
	order?: number | undefined | null,
	manager?: ValueTypes["ProductCreateManagerEntityRelationInput"] | undefined | null,
	orderItems?: Array<ValueTypes["ProductCreateOrderItemsEntityRelationInput"]> | undefined | null,
	maximumQuantityPerOrder?: number | undefined | null,
	inheritedCategories?: Array<ValueTypes["ProductCreateInheritedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["ProductCreateDeliveryZonesEntityRelationInput"]> | undefined | null,
	locales?: Array<ValueTypes["ProductCreateLocalesEntityRelationInput"]> | undefined | null,
	archivedAt?: ValueTypes["DateTime"] | undefined | null,
	customerPrices?: Array<ValueTypes["ProductCreateCustomerPricesEntityRelationInput"]> | undefined | null,
	virtualProduct?: ValueTypes["ProductCreateVirtualProductEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["ProductCreateMetaEntityRelationInput"] | undefined | null,
	page?: ValueTypes["ProductCreatePageEntityRelationInput"] | undefined | null,
	salesDays?: Array<ValueTypes["ProductCreateSalesDaysEntityRelationInput"]> | undefined | null,
	salesWeeks?: Array<ValueTypes["ProductCreateSalesWeeksEntityRelationInput"]> | undefined | null,
	salesMonths?: Array<ValueTypes["ProductCreateSalesMonthsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["ProductCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	hasSubscription?: boolean | undefined | null,
	pointOfSaleTileColor?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCreateCategoriesEntityRelationInput"]: {
	connect?: ValueTypes["ProductCategoryUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductCategoryWithoutProductsCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductCategoryWithoutProductsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	tags?: Array<ValueTypes["ProductCategoryCreateTagsEntityRelationInput"]> | undefined | null,
	parent?: ValueTypes["ProductCategoryCreateParentEntityRelationInput"] | undefined | null,
	children?: Array<ValueTypes["ProductCategoryCreateChildrenEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	color?: string | undefined | null,
	image?: ValueTypes["ProductCategoryCreateImageEntityRelationInput"] | undefined | null,
	order?: number | undefined | null,
	descendants?: Array<ValueTypes["ProductCategoryCreateDescendantsEntityRelationInput"]> | undefined | null,
	ancestors?: Array<ValueTypes["ProductCategoryCreateAncestorsEntityRelationInput"]> | undefined | null,
	inheritedTags?: Array<ValueTypes["ProductCategoryCreateInheritedTagsEntityRelationInput"]> | undefined | null,
	nestedProducts?: Array<ValueTypes["ProductCategoryCreateNestedProductsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCategoryCreateChildrenEntityRelationInput"]: {
	connect?: ValueTypes["ProductCategoryUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductCategoryWithoutParentCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductCategoryWithoutParentCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	products?: Array<ValueTypes["ProductCategoryCreateProductsEntityRelationInput"]> | undefined | null,
	tags?: Array<ValueTypes["ProductCategoryCreateTagsEntityRelationInput"]> | undefined | null,
	children?: Array<ValueTypes["ProductCategoryCreateChildrenEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	color?: string | undefined | null,
	image?: ValueTypes["ProductCategoryCreateImageEntityRelationInput"] | undefined | null,
	order?: number | undefined | null,
	descendants?: Array<ValueTypes["ProductCategoryCreateDescendantsEntityRelationInput"]> | undefined | null,
	ancestors?: Array<ValueTypes["ProductCategoryCreateAncestorsEntityRelationInput"]> | undefined | null,
	inheritedTags?: Array<ValueTypes["ProductCategoryCreateInheritedTagsEntityRelationInput"]> | undefined | null,
	nestedProducts?: Array<ValueTypes["ProductCategoryCreateNestedProductsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCategoryCreateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["ProductCategoryCreateDescendantsEntityRelationInput"]: {
	connect?: ValueTypes["ProductCategoryTreeUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductCategoryCreateAncestorsEntityRelationInput"]: {
	connect?: ValueTypes["ProductCategoryTreeUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductCategoryCreateInheritedTagsEntityRelationInput"]: {
	connect?: ValueTypes["InheritedProductCategoryTagUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductCategoryCreateNestedProductsEntityRelationInput"]: {
	connect?: ValueTypes["NestedProductCategoryProductUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductCreateVatRateEntityRelationInput"]: {
	connect?: ValueTypes["VatRateUniqueWhere"] | undefined | null,
	create?: ValueTypes["VatRateCreateInput"] | undefined | null
};
	["ProductCreateStocksEntityRelationInput"]: {
	connect?: ValueTypes["ProductStockUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductStockWithoutProductCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductStockWithoutProductCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	quantity?: number | undefined | null,
	store?: ValueTypes["ProductStockCreateStoreEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductStockCreateStoreEntityRelationInput"]: {
	connect?: ValueTypes["StoreUniqueWhere"] | undefined | null,
	create?: ValueTypes["StoreCreateInput"] | undefined | null
};
	["StoreCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCreateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["ProductCreateCartItemsEntityRelationInput"]: {
	connect?: ValueTypes["CartItemUniqueWhere"] | undefined | null,
	create?: ValueTypes["CartItemWithoutProductCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["CartItemWithoutProductCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	quantity?: number | undefined | null,
	cart?: ValueTypes["CartItemCreateCartEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	updatedAt?: ValueTypes["DateTime"] | undefined | null,
	fulfillmentNote?: string | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["CartItemCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CartItemCreateCartEntityRelationInput"]: {
	connect?: ValueTypes["CartUniqueWhere"] | undefined | null,
	create?: ValueTypes["CartWithoutItemsCreateInput"] | undefined | null
};
	["CartWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	confirmedAt?: ValueTypes["DateTime"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	handle?: string | undefined | null,
	state?: ValueTypes["CartState"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	channel?: ValueTypes["CartCreateChannelEntityRelationInput"] | undefined | null,
	order?: ValueTypes["CartCreateOrderEntityRelationInput"] | undefined | null,
	customer?: ValueTypes["CartCreateCustomerEntityRelationInput"] | undefined | null,
	deliveryAddress?: ValueTypes["CartCreateDeliveryAddressEntityRelationInput"] | undefined | null,
	billingAddress?: ValueTypes["CartCreateBillingAddressEntityRelationInput"] | undefined | null,
	deliveryOption?: string | undefined | null,
	paymentOption?: string | undefined | null,
	delivery?: ValueTypes["CartCreateDeliveryEntityRelationInput"] | undefined | null,
	payment?: ValueTypes["CartCreatePaymentEntityRelationInput"] | undefined | null,
	billingSubject?: ValueTypes["CartCreateBillingSubjectEntityRelationInput"] | undefined | null,
	priceLines?: Array<ValueTypes["CartCreatePriceLinesEntityRelationInput"]> | undefined | null,
	summary?: ValueTypes["CartCreateSummaryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CartCreateChannelEntityRelationInput"]: {
	connect?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	create?: ValueTypes["ChannelWithoutCartsCreateInput"] | undefined | null
};
	["ChannelWithoutCartsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	disabled?: boolean | undefined | null,
	payments?: Array<ValueTypes["ChannelCreatePaymentsEntityRelationInput"]> | undefined | null,
	deliveries?: Array<ValueTypes["ChannelCreateDeliveriesEntityRelationInput"]> | undefined | null,
	pointOfSales?: Array<ValueTypes["ChannelCreatePointOfSalesEntityRelationInput"]> | undefined | null,
	customers?: Array<ValueTypes["ChannelCreateCustomersEntityRelationInput"]> | undefined | null,
	code?: ValueTypes["ChannelCode"] | undefined | null,
	addTagsOnRegistration?: Array<ValueTypes["ChannelCreateAddTagsOnRegistrationEntityRelationInput"]> | undefined | null,
	publicTags?: Array<ValueTypes["ChannelCreatePublicTagsEntityRelationInput"]> | undefined | null,
	venue?: ValueTypes["ChannelCreateVenueEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ChannelCreateAddTagsOnRegistrationEntityRelationInput"]: {
	connect?: ValueTypes["TagUniqueWhere"] | undefined | null,
	create?: ValueTypes["TagWithoutAddTagsOnRegistrationCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TagWithoutAddTagsOnRegistrationCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	customers?: Array<ValueTypes["TagCreateCustomersEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["TagCreateProductsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["TagCreateCategoriesEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	nestedCategories?: Array<ValueTypes["TagCreateNestedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["TagCreateDeliveryZonesEntityRelationInput"]> | undefined | null,
	publicInChannels?: Array<ValueTypes["TagCreatePublicInChannelsEntityRelationInput"]> | undefined | null,
	allowChannelPayments?: Array<ValueTypes["TagCreateAllowChannelPaymentsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["TagCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TagCreateNestedCategoriesEntityRelationInput"]: {
	connect?: ValueTypes["InheritedProductCategoryTagUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["TagCreateDeliveryZonesEntityRelationInput"]: {
	connect?: ValueTypes["DeliveryZoneUniqueWhere"] | undefined | null,
	create?: ValueTypes["DeliveryZoneWithoutDeliveryZonesOfTagsCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["DeliveryZoneWithoutDeliveryZonesOfTagsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	type?: ValueTypes["DeliveryZoneType"] | undefined | null,
	addresses?: Array<ValueTypes["DeliveryZoneCreateAddressesEntityRelationInput"]> | undefined | null,
	suitableDeliveryMethods?: Array<ValueTypes["DeliveryZoneCreateSuitableDeliveryMethodsEntityRelationInput"]> | undefined | null,
	deliveryZonesOfProducts?: Array<ValueTypes["DeliveryZoneCreateDeliveryZonesOfProductsEntityRelationInput"]> | undefined | null,
	addressesMetadata?: Array<ValueTypes["DeliveryZoneCreateAddressesMetadataEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryZoneCreateDeliveryZonesOfProductsEntityRelationInput"]: {
	connect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductWithoutDeliveryZonesCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductWithoutDeliveryZonesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	priceCents?: number | undefined | null,
	notDiscountable?: boolean | undefined | null,
	packing?: ValueTypes["ProductCreatePackingEntityRelationInput"] | undefined | null,
	recipe?: ValueTypes["ProductCreateRecipeEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["ProductCreateTagsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["ProductCreateCategoriesEntityRelationInput"]> | undefined | null,
	vatRate?: ValueTypes["ProductCreateVatRateEntityRelationInput"] | undefined | null,
	stocks?: Array<ValueTypes["ProductCreateStocksEntityRelationInput"]> | undefined | null,
	groupPrices?: Array<ValueTypes["ProductCreateGroupPricesEntityRelationInput"]> | undefined | null,
	image?: ValueTypes["ProductCreateImageEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	cartItems?: Array<ValueTypes["ProductCreateCartItemsEntityRelationInput"]> | undefined | null,
	availability?: ValueTypes["ProductAvailability"] | undefined | null,
	order?: number | undefined | null,
	manager?: ValueTypes["ProductCreateManagerEntityRelationInput"] | undefined | null,
	orderItems?: Array<ValueTypes["ProductCreateOrderItemsEntityRelationInput"]> | undefined | null,
	maximumQuantityPerOrder?: number | undefined | null,
	inheritedCategories?: Array<ValueTypes["ProductCreateInheritedCategoriesEntityRelationInput"]> | undefined | null,
	locales?: Array<ValueTypes["ProductCreateLocalesEntityRelationInput"]> | undefined | null,
	archivedAt?: ValueTypes["DateTime"] | undefined | null,
	customerPrices?: Array<ValueTypes["ProductCreateCustomerPricesEntityRelationInput"]> | undefined | null,
	virtualProduct?: ValueTypes["ProductCreateVirtualProductEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["ProductCreateMetaEntityRelationInput"] | undefined | null,
	page?: ValueTypes["ProductCreatePageEntityRelationInput"] | undefined | null,
	salesDays?: Array<ValueTypes["ProductCreateSalesDaysEntityRelationInput"]> | undefined | null,
	salesWeeks?: Array<ValueTypes["ProductCreateSalesWeeksEntityRelationInput"]> | undefined | null,
	salesMonths?: Array<ValueTypes["ProductCreateSalesMonthsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["ProductCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	hasSubscription?: boolean | undefined | null,
	pointOfSaleTileColor?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCreateGroupPricesEntityRelationInput"]: {
	connect?: ValueTypes["ProductGroupPriceUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductGroupPriceWithoutProductCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductGroupPriceWithoutProductCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	priceCents?: number | undefined | null,
	group?: ValueTypes["ProductGroupPriceCreateGroupEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductGroupPriceCreateGroupEntityRelationInput"]: {
	connect?: ValueTypes["CustomerGroupUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerGroupWithoutProductPricesCreateInput"] | undefined | null
};
	["CustomerGroupWithoutProductPricesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	customers?: Array<ValueTypes["CustomerGroupCreateCustomersEntityRelationInput"]> | undefined | null,
	discountPermille?: number | undefined | null,
	code?: string | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerGroupCreateCustomersEntityRelationInput"]: {
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerWithoutGroupCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerWithoutGroupCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	addresses?: Array<ValueTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerCreateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerCreatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerCreateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerCreateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerCreateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerCreateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerCreateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerCreateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerCreateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreatePhotoEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["CustomerCreateNameEntityRelationInput"]: {
	connect?: ValueTypes["CustomerNameUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerNameWithoutCustomerCreateInput"] | undefined | null
};
	["CustomerNameWithoutCustomerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	nominative?: string | undefined | null,
	vocative?: string | undefined | null,
	aliases?: Array<ValueTypes["CustomerNameCreateAliasesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerNameCreateAliasesEntityRelationInput"]: {
	connect?: ValueTypes["CustomerAliasUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerAliasCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerAliasUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["CustomerAliasCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	order?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreateIngredientRatingsEntityRelationInput"]: {
	connect?: ValueTypes["CustomerIngredientRatingUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerIngredientRatingWithoutCustomerCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerIngredientRatingWithoutCustomerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	rating?: ValueTypes["CustomerIngredientRatingCreateRatingEntityRelationInput"] | undefined | null,
	ingredient?: ValueTypes["CustomerIngredientRatingCreateIngredientEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerIngredientRatingCreateRatingEntityRelationInput"]: {
	connect?: ValueTypes["ProductIngredientRatingUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductIngredientRatingCreateInput"] | undefined | null
};
	["ProductIngredientRatingUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["ProductIngredientRatingCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	name?: string | undefined | null,
	icon?: ValueTypes["ProductIngredientRatingCreateIconEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientRatingCreateIconEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["CustomerIngredientRatingCreateIngredientEntityRelationInput"]: {
	connect?: ValueTypes["ProductIngredientUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductIngredientWithoutCustomerRatingsCreateInput"] | undefined | null
};
	["ProductIngredientWithoutCustomerRatingsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	internalNote?: string | undefined | null,
	locales?: Array<ValueTypes["ProductIngredientCreateLocalesEntityRelationInput"]> | undefined | null,
	internalName?: string | undefined | null,
	categories?: Array<ValueTypes["ProductIngredientCreateCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["ProductIngredientCreateAllergensEntityRelationInput"]> | undefined | null,
	needsPrepping?: boolean | undefined | null,
	allowCustomerRating?: boolean | undefined | null,
	preferredQuantityUnit?: ValueTypes["ProductIngredientCreatePreferredQuantityUnitEntityRelationInput"] | undefined | null,
	freshingContainer?: ValueTypes["ProductIngredientCreateFreshingContainerEntityRelationInput"] | undefined | null,
	image?: ValueTypes["ProductIngredientCreateImageEntityRelationInput"] | undefined | null,
	suppliers?: ValueTypes["ProductIngredientCreateSuppliersEntityRelationInput"] | undefined | null,
	incrementQuantityNumber?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientCreateCategoriesEntityRelationInput"]: {
	connect?: ValueTypes["ProductIngredientCategoryUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductIngredientCategoryWithoutIngredientsCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductIngredientCategoryWithoutIngredientsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	internalName?: string | undefined | null,
	internalNote?: string | undefined | null,
	locales?: Array<ValueTypes["ProductIngredientCategoryCreateLocalesEntityRelationInput"]> | undefined | null,
	order?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientCategoryCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["ProductIngredientCategoryLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductIngredientCategoryLocaleWithoutRootCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductIngredientCategoryLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	locale?: ValueTypes["ProductIngredientCategoryLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientCategoryLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["LocaleWithoutProductIngredientCategoriesCreateInput"] | undefined | null
};
	["LocaleWithoutProductIngredientCategoriesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	businessCategories?: Array<ValueTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleCreateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleCreatePagesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleCreateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreateProductIngredientsEntityRelationInput"]: {
	connect?: ValueTypes["ProductIngredientLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductIngredientLocaleWithoutLocaleCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductIngredientLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	root?: ValueTypes["ProductIngredientLocaleCreateRootEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["ProductIngredientUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductIngredientWithoutLocalesCreateInput"] | undefined | null
};
	["ProductIngredientWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	internalNote?: string | undefined | null,
	internalName?: string | undefined | null,
	categories?: Array<ValueTypes["ProductIngredientCreateCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["ProductIngredientCreateAllergensEntityRelationInput"]> | undefined | null,
	needsPrepping?: boolean | undefined | null,
	allowCustomerRating?: boolean | undefined | null,
	customerRatings?: Array<ValueTypes["ProductIngredientCreateCustomerRatingsEntityRelationInput"]> | undefined | null,
	preferredQuantityUnit?: ValueTypes["ProductIngredientCreatePreferredQuantityUnitEntityRelationInput"] | undefined | null,
	freshingContainer?: ValueTypes["ProductIngredientCreateFreshingContainerEntityRelationInput"] | undefined | null,
	image?: ValueTypes["ProductIngredientCreateImageEntityRelationInput"] | undefined | null,
	suppliers?: ValueTypes["ProductIngredientCreateSuppliersEntityRelationInput"] | undefined | null,
	incrementQuantityNumber?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientCreateAllergensEntityRelationInput"]: {
	connect?: ValueTypes["AllergenUniqueWhere"] | undefined | null,
	create?: ValueTypes["AllergenWithoutIngredientsCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["AllergenWithoutIngredientsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	internalName?: string | undefined | null,
	locales?: Array<ValueTypes["AllergenCreateLocalesEntityRelationInput"]> | undefined | null,
	code?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AllergenCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["AllergenLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["AllergenLocaleWithoutRootCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["AllergenLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	locale?: ValueTypes["AllergenLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AllergenLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["LocaleWithoutAllergensCreateInput"] | undefined | null
};
	["LocaleWithoutAllergensCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	businessCategories?: Array<ValueTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleCreateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleCreatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleCreateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreateOrderRecurrencesEntityRelationInput"]: {
	connect?: ValueTypes["OrderRecurrenceLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["OrderRecurrenceLocaleWithoutLocaleCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["OrderRecurrenceLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	root?: ValueTypes["OrderRecurrenceLocaleCreateRootEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderRecurrenceLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["OrderRecurrenceUniqueWhere"] | undefined | null,
	create?: ValueTypes["OrderRecurrenceWithoutLocalesCreateInput"] | undefined | null
};
	["OrderRecurrenceWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	internalName?: string | undefined | null,
	order?: number | undefined | null,
	businessCategory?: Array<ValueTypes["OrderRecurrenceCreateBusinessCategoryEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderRecurrenceCreateBusinessCategoryEntityRelationInput"]: {
	connect?: ValueTypes["BusinessCategoryUniqueWhere"] | undefined | null,
	create?: ValueTypes["BusinessCategoryWithoutRecurrencesCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["BusinessCategoryWithoutRecurrencesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	visibleToNewCustomers?: boolean | undefined | null,
	locales?: Array<ValueTypes["BusinessCategoryCreateLocalesEntityRelationInput"]> | undefined | null,
	internalName?: string | undefined | null,
	businessCustomers?: Array<ValueTypes["BusinessCategoryCreateBusinessCustomersEntityRelationInput"]> | undefined | null,
	specificProducts?: ValueTypes["BusinessCategoryCreateSpecificProductsEntityRelationInput"] | undefined | null,
	seasonalProductCategories?: ValueTypes["BusinessCategoryCreateSeasonalProductCategoriesEntityRelationInput"] | undefined | null,
	specificProductsProductCategories?: ValueTypes["BusinessCategoryCreateSpecificProductsProductCategoriesEntityRelationInput"] | undefined | null,
	slug?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessCategoryCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["BusinessCategoryLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["BusinessCategoryLocaleWithoutRootCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["BusinessCategoryLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	locale?: ValueTypes["BusinessCategoryLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	title?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessCategoryLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["LocaleWithoutBusinessCategoriesCreateInput"] | undefined | null
};
	["LocaleWithoutBusinessCategoriesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleCreateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleCreatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleCreateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreateBlogsEntityRelationInput"]: {
	connect?: ValueTypes["BlogLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["BlogLocaleWithoutLocaleCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["BlogLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	pageName?: string | undefined | null,
	title?: string | undefined | null,
	lead?: string | undefined | null,
	root?: ValueTypes["BlogLocaleCreateRootEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BlogLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["BlogUniqueWhere"] | undefined | null,
	create?: ValueTypes["BlogWithoutLocalesCreateInput"] | undefined | null
};
	["BlogWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	unique?: ValueTypes["One"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreateBlogPostsEntityRelationInput"]: {
	connect?: ValueTypes["BlogPostLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["BlogPostLocaleWithoutLocaleCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["BlogPostLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	availableForWeb?: boolean | undefined | null,
	availableForMobile?: boolean | undefined | null,
	root?: ValueTypes["BlogPostLocaleCreateRootEntityRelationInput"] | undefined | null,
	cover?: ValueTypes["BlogPostLocaleCreateCoverEntityRelationInput"] | undefined | null,
	content?: ValueTypes["BlogPostLocaleCreateContentEntityRelationInput"] | undefined | null,
	link?: ValueTypes["BlogPostLocaleCreateLinkEntityRelationInput"] | undefined | null,
	seo?: ValueTypes["BlogPostLocaleCreateSeoEntityRelationInput"] | undefined | null,
	products?: Array<ValueTypes["BlogPostLocaleCreateProductsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BlogPostLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["BlogPostUniqueWhere"] | undefined | null,
	create?: ValueTypes["BlogPostWithoutLocalesCreateInput"] | undefined | null
};
	["BlogPostWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BlogPostLocaleCreateCoverEntityRelationInput"]: {
	connect?: ValueTypes["CoverUniqueWhere"] | undefined | null,
	create?: ValueTypes["CoverCreateInput"] | undefined | null
};
	["CoverCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	primaryTitle?: string | undefined | null,
	secondaryTitle?: string | undefined | null,
	medium?: ValueTypes["CoverCreateMediumEntityRelationInput"] | undefined | null,
	buttonColors?: ValueTypes["CoverCreateButtonColorsEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CoverCreateMediumEntityRelationInput"]: {
	connect?: ValueTypes["MediumUniqueWhere"] | undefined | null,
	create?: ValueTypes["MediumCreateInput"] | undefined | null
};
	["MediumUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["MediumCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	type?: ValueTypes["MediumType"] | undefined | null,
	colorTheme?: ValueTypes["ColorTheme"] | undefined | null,
	image?: ValueTypes["MediumCreateImageEntityRelationInput"] | undefined | null,
	video?: ValueTypes["MediumCreateVideoEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MediumCreateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["MediumCreateVideoEntityRelationInput"]: {
	connect?: ValueTypes["VideoUniqueWhere"] | undefined | null,
	create?: ValueTypes["VideoCreateInput"] | undefined | null
};
	["VideoUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["VideoCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	src?: string | undefined | null,
	width?: number | undefined | null,
	height?: number | undefined | null,
	size?: number | undefined | null,
	type?: string | undefined | null,
	duration?: number | undefined | null,
	poster?: ValueTypes["VideoCreatePosterEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VideoCreatePosterEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["CoverCreateButtonColorsEntityRelationInput"]: {
	connect?: ValueTypes["ColorPalleteUniqueWhere"] | undefined | null,
	create?: ValueTypes["ColorPalleteCreateInput"] | undefined | null
};
	["ColorPalleteUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["ColorPalleteCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	background?: string | undefined | null,
	text?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BlogPostLocaleCreateContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null,
	create?: ValueTypes["ContentCreateInput"] | undefined | null
};
	["ContentCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	blocks?: Array<ValueTypes["ContentCreateBlocksEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentCreateBlocksEntityRelationInput"]: {
	connect?: ValueTypes["ContentBlockUniqueWhere"] | undefined | null,
	create?: ValueTypes["ContentBlockWithoutContentCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ContentBlockWithoutContentCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	json?: string | undefined | null,
	references?: Array<ValueTypes["ContentBlockCreateReferencesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentBlockCreateReferencesEntityRelationInput"]: {
	connect?: ValueTypes["ContentReferenceUniqueWhere"] | undefined | null,
	create?: ValueTypes["ContentReferenceWithoutBlockCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ContentReferenceWithoutBlockCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	type?: ValueTypes["ContentReferenceType"] | undefined | null,
	primaryText?: string | undefined | null,
	secondaryText?: string | undefined | null,
	jsonContent?: string | undefined | null,
	colorPallete?: ValueTypes["ContentReferenceCreateColorPalleteEntityRelationInput"] | undefined | null,
	medium?: ValueTypes["ContentReferenceCreateMediumEntityRelationInput"] | undefined | null,
	link?: ValueTypes["ContentReferenceCreateLinkEntityRelationInput"] | undefined | null,
	blogPosts?: ValueTypes["ContentReferenceCreateBlogPostsEntityRelationInput"] | undefined | null,
	links?: ValueTypes["ContentReferenceCreateLinksEntityRelationInput"] | undefined | null,
	products?: ValueTypes["ContentReferenceCreateProductsEntityRelationInput"] | undefined | null,
	contentSize?: ValueTypes["ContentSize"] | undefined | null,
	misc?: string | undefined | null,
	hero?: ValueTypes["ContentReferenceCreateHeroEntityRelationInput"] | undefined | null,
	gallery?: ValueTypes["ContentReferenceCreateGalleryEntityRelationInput"] | undefined | null,
	socialsAndApps?: ValueTypes["ContentReferenceCreateSocialsAndAppsEntityRelationInput"] | undefined | null,
	productGrid?: ValueTypes["ContentReferenceCreateProductGridEntityRelationInput"] | undefined | null,
	productBanners?: ValueTypes["ContentReferenceCreateProductBannersEntityRelationInput"] | undefined | null,
	deliveryRegions?: ValueTypes["ContentReferenceCreateDeliveryRegionsEntityRelationInput"] | undefined | null,
	textList?: ValueTypes["ContentReferenceCreateTextListEntityRelationInput"] | undefined | null,
	gridTiles?: ValueTypes["ContentReferenceCreateGridTilesEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentReferenceCreateColorPalleteEntityRelationInput"]: {
	connect?: ValueTypes["ColorPalleteUniqueWhere"] | undefined | null,
	create?: ValueTypes["ColorPalleteCreateInput"] | undefined | null
};
	["ContentReferenceCreateMediumEntityRelationInput"]: {
	connect?: ValueTypes["MediumUniqueWhere"] | undefined | null,
	create?: ValueTypes["MediumCreateInput"] | undefined | null
};
	["ContentReferenceCreateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null,
	create?: ValueTypes["LinkCreateInput"] | undefined | null
};
	["LinkCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	type?: ValueTypes["LinkType"] | undefined | null,
	title?: string | undefined | null,
	externalLink?: string | undefined | null,
	internalLink?: ValueTypes["LinkCreateInternalLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkCreateInternalLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null,
	create?: ValueTypes["LinkableCreateInput"] | undefined | null
};
	["LinkableCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	url?: string | undefined | null,
	blogPost?: ValueTypes["LinkableCreateBlogPostEntityRelationInput"] | undefined | null,
	page?: ValueTypes["LinkableCreatePageEntityRelationInput"] | undefined | null,
	wikiPage?: ValueTypes["LinkableCreateWikiPageEntityRelationInput"] | undefined | null,
	redirect?: ValueTypes["LinkableCreateRedirectEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkableCreateBlogPostEntityRelationInput"]: {
	connect?: ValueTypes["BlogPostLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["BlogPostLocaleWithoutLinkCreateInput"] | undefined | null
};
	["BlogPostLocaleWithoutLinkCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	availableForWeb?: boolean | undefined | null,
	availableForMobile?: boolean | undefined | null,
	root?: ValueTypes["BlogPostLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["BlogPostLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	cover?: ValueTypes["BlogPostLocaleCreateCoverEntityRelationInput"] | undefined | null,
	content?: ValueTypes["BlogPostLocaleCreateContentEntityRelationInput"] | undefined | null,
	seo?: ValueTypes["BlogPostLocaleCreateSeoEntityRelationInput"] | undefined | null,
	products?: Array<ValueTypes["BlogPostLocaleCreateProductsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BlogPostLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["LocaleWithoutBlogPostsCreateInput"] | undefined | null
};
	["LocaleWithoutBlogPostsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	businessCategories?: Array<ValueTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleCreateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleCreatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleCreateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreateIdentifierEntityRelationInput"]: {
	connect?: ValueTypes["TranslationCataloguesIdentifierUniqueWhere"] | undefined | null,
	create?: ValueTypes["TranslationCataloguesIdentifierCreateInput"] | undefined | null
};
	["TranslationCataloguesIdentifierCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	catalogue?: Array<ValueTypes["TranslationCataloguesIdentifierCreateCatalogueEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationCataloguesIdentifierCreateCatalogueEntityRelationInput"]: {
	connect?: ValueTypes["TranslationCatalogueUniqueWhere"] | undefined | null,
	create?: ValueTypes["TranslationCatalogueWithoutIdentifierCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TranslationCatalogueWithoutIdentifierCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	domain?: ValueTypes["TranslationCatalogueCreateDomainEntityRelationInput"] | undefined | null,
	fallback?: ValueTypes["TranslationCatalogueCreateFallbackEntityRelationInput"] | undefined | null,
	values?: Array<ValueTypes["TranslationCatalogueCreateValuesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationCatalogueCreateDomainEntityRelationInput"]: {
	connect?: ValueTypes["TranslationDomainUniqueWhere"] | undefined | null,
	create?: ValueTypes["TranslationDomainWithoutCataloguesCreateInput"] | undefined | null
};
	["TranslationDomainWithoutCataloguesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	identifier?: string | undefined | null,
	name?: string | undefined | null,
	keys?: Array<ValueTypes["TranslationDomainCreateKeysEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationDomainCreateKeysEntityRelationInput"]: {
	connect?: ValueTypes["TranslationKeyUniqueWhere"] | undefined | null,
	create?: ValueTypes["TranslationKeyWithoutDomainCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TranslationKeyWithoutDomainCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	identifier?: string | undefined | null,
	contentType?: ValueTypes["TranslationContentType"] | undefined | null,
	note?: string | undefined | null,
	values?: Array<ValueTypes["TranslationKeyCreateValuesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationKeyCreateValuesEntityRelationInput"]: {
	connect?: ValueTypes["TranslationValueUniqueWhere"] | undefined | null,
	create?: ValueTypes["TranslationValueWithoutKeyCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TranslationValueWithoutKeyCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	value?: string | undefined | null,
	catalogue?: ValueTypes["TranslationValueCreateCatalogueEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationValueCreateCatalogueEntityRelationInput"]: {
	connect?: ValueTypes["TranslationCatalogueUniqueWhere"] | undefined | null,
	create?: ValueTypes["TranslationCatalogueWithoutValuesCreateInput"] | undefined | null
};
	["TranslationCatalogueWithoutValuesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	domain?: ValueTypes["TranslationCatalogueCreateDomainEntityRelationInput"] | undefined | null,
	fallback?: ValueTypes["TranslationCatalogueCreateFallbackEntityRelationInput"] | undefined | null,
	identifier?: ValueTypes["TranslationCatalogueCreateIdentifierEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationCatalogueCreateFallbackEntityRelationInput"]: {
	connect?: ValueTypes["TranslationCatalogueUniqueWhere"] | undefined | null,
	create?: ValueTypes["TranslationCatalogueCreateInput"] | undefined | null
};
	["TranslationCatalogueCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	domain?: ValueTypes["TranslationCatalogueCreateDomainEntityRelationInput"] | undefined | null,
	fallback?: ValueTypes["TranslationCatalogueCreateFallbackEntityRelationInput"] | undefined | null,
	values?: Array<ValueTypes["TranslationCatalogueCreateValuesEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["TranslationCatalogueCreateIdentifierEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationCatalogueCreateValuesEntityRelationInput"]: {
	connect?: ValueTypes["TranslationValueUniqueWhere"] | undefined | null,
	create?: ValueTypes["TranslationValueWithoutCatalogueCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TranslationValueWithoutCatalogueCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	value?: string | undefined | null,
	key?: ValueTypes["TranslationValueCreateKeyEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationValueCreateKeyEntityRelationInput"]: {
	connect?: ValueTypes["TranslationKeyUniqueWhere"] | undefined | null,
	create?: ValueTypes["TranslationKeyWithoutValuesCreateInput"] | undefined | null
};
	["TranslationKeyWithoutValuesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	identifier?: string | undefined | null,
	contentType?: ValueTypes["TranslationContentType"] | undefined | null,
	note?: string | undefined | null,
	domain?: ValueTypes["TranslationKeyCreateDomainEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationKeyCreateDomainEntityRelationInput"]: {
	connect?: ValueTypes["TranslationDomainUniqueWhere"] | undefined | null,
	create?: ValueTypes["TranslationDomainWithoutKeysCreateInput"] | undefined | null
};
	["TranslationDomainWithoutKeysCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	identifier?: string | undefined | null,
	name?: string | undefined | null,
	catalogues?: Array<ValueTypes["TranslationDomainCreateCataloguesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationDomainCreateCataloguesEntityRelationInput"]: {
	connect?: ValueTypes["TranslationCatalogueUniqueWhere"] | undefined | null,
	create?: ValueTypes["TranslationCatalogueWithoutDomainCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TranslationCatalogueWithoutDomainCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	fallback?: ValueTypes["TranslationCatalogueCreateFallbackEntityRelationInput"] | undefined | null,
	values?: Array<ValueTypes["TranslationCatalogueCreateValuesEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["TranslationCatalogueCreateIdentifierEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationCatalogueCreateIdentifierEntityRelationInput"]: {
	connect?: ValueTypes["TranslationCataloguesIdentifierUniqueWhere"] | undefined | null,
	create?: ValueTypes["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"] | undefined | null
};
	["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreateMenusEntityRelationInput"]: {
	connect?: ValueTypes["MenuLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["MenuLocaleWithoutLocaleCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["MenuLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	root?: ValueTypes["MenuLocaleCreateRootEntityRelationInput"] | undefined | null,
	items?: Array<ValueTypes["MenuLocaleCreateItemsEntityRelationInput"]> | undefined | null,
	secondaryItems?: ValueTypes["MenuLocaleCreateSecondaryItemsEntityRelationInput"] | undefined | null,
	eshopLink?: ValueTypes["MenuLocaleCreateEshopLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MenuLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["SiteMenuUniqueWhere"] | undefined | null,
	create?: ValueTypes["SiteMenuWithoutLocalesCreateInput"] | undefined | null
};
	["SiteMenuWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	unique?: ValueTypes["One"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MenuLocaleCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["MenuItemUniqueWhere"] | undefined | null,
	create?: ValueTypes["MenuItemWithoutMenuCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["MenuItemWithoutMenuCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	link?: ValueTypes["MenuItemCreateLinkEntityRelationInput"] | undefined | null,
	subitems?: Array<ValueTypes["MenuItemCreateSubitemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MenuItemCreateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null,
	create?: ValueTypes["LinkCreateInput"] | undefined | null
};
	["MenuItemCreateSubitemsEntityRelationInput"]: {
	connect?: ValueTypes["MenuSubitemUniqueWhere"] | undefined | null,
	create?: ValueTypes["MenuSubitemWithoutItemCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["MenuSubitemWithoutItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	type?: ValueTypes["MenuSubitemType"] | undefined | null,
	title?: string | undefined | null,
	links?: ValueTypes["MenuSubitemCreateLinksEntityRelationInput"] | undefined | null,
	products?: ValueTypes["MenuSubitemCreateProductsEntityRelationInput"] | undefined | null,
	delivery?: ValueTypes["MenuSubitemCreateDeliveryEntityRelationInput"] | undefined | null,
	contact?: ValueTypes["MenuSubitemCreateContactEntityRelationInput"] | undefined | null,
	order?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MenuSubitemCreateLinksEntityRelationInput"]: {
	connect?: ValueTypes["MenuLinkListUniqueWhere"] | undefined | null,
	create?: ValueTypes["MenuLinkListCreateInput"] | undefined | null
};
	["MenuLinkListUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: ValueTypes["MenuLinkItemUniqueWhere"] | undefined | null
};
	["MenuLinkItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["MenuLinkListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: Array<ValueTypes["MenuLinkListCreateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MenuLinkListCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["MenuLinkItemUniqueWhere"] | undefined | null,
	create?: ValueTypes["MenuLinkItemWithoutListCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["MenuLinkItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	link?: ValueTypes["MenuLinkItemCreateLinkEntityRelationInput"] | undefined | null,
	image?: ValueTypes["MenuLinkItemCreateImageEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MenuLinkItemCreateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null,
	create?: ValueTypes["LinkCreateInput"] | undefined | null
};
	["MenuLinkItemCreateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["MenuSubitemCreateProductsEntityRelationInput"]: {
	connect?: ValueTypes["MenuProductsUniqueWhere"] | undefined | null,
	create?: ValueTypes["MenuProductsCreateInput"] | undefined | null
};
	["MenuProductsUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	buttons?: ValueTypes["LinkListUniqueWhere"] | undefined | null
};
	["MenuProductsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	links?: ValueTypes["MenuProductsCreateLinksEntityRelationInput"] | undefined | null,
	buttons?: ValueTypes["MenuProductsCreateButtonsEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MenuProductsCreateLinksEntityRelationInput"]: {
	connect?: ValueTypes["MenuLinkListUniqueWhere"] | undefined | null,
	create?: ValueTypes["MenuLinkListCreateInput"] | undefined | null
};
	["MenuProductsCreateButtonsEntityRelationInput"]: {
	connect?: ValueTypes["LinkListUniqueWhere"] | undefined | null,
	create?: ValueTypes["LinkListCreateInput"] | undefined | null
};
	["LinkListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: Array<ValueTypes["LinkListCreateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkListCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["LinkListItemUniqueWhere"] | undefined | null,
	create?: ValueTypes["LinkListItemWithoutListCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["LinkListItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	isPrimary?: boolean | undefined | null,
	link?: ValueTypes["LinkListItemCreateLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkListItemCreateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null,
	create?: ValueTypes["LinkCreateInput"] | undefined | null
};
	["MenuSubitemCreateDeliveryEntityRelationInput"]: {
	connect?: ValueTypes["MenuDeliveryUniqueWhere"] | undefined | null,
	create?: ValueTypes["MenuDeliveryCreateInput"] | undefined | null
};
	["MenuDeliveryUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	deliveryRegions?: ValueTypes["DeliveryRegionsUniqueWhere"] | undefined | null
};
	["MenuDeliveryCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	deliveryRegions?: ValueTypes["MenuDeliveryCreateDeliveryRegionsEntityRelationInput"] | undefined | null,
	text?: string | undefined | null,
	socialsAndApps?: ValueTypes["MenuDeliveryCreateSocialsAndAppsEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MenuDeliveryCreateDeliveryRegionsEntityRelationInput"]: {
	connect?: ValueTypes["DeliveryRegionsUniqueWhere"] | undefined | null,
	create?: ValueTypes["DeliveryRegionsCreateInput"] | undefined | null
};
	["DeliveryRegionsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: Array<ValueTypes["DeliveryRegionsCreateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryRegionsCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["DeliveryRegionsItemUniqueWhere"] | undefined | null,
	create?: ValueTypes["DeliveryRegionsItemWithoutListCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["DeliveryRegionsItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	title?: string | undefined | null,
	offerLabel?: string | undefined | null,
	image?: ValueTypes["DeliveryRegionsItemCreateImageEntityRelationInput"] | undefined | null,
	textList?: ValueTypes["DeliveryRegionsItemCreateTextListEntityRelationInput"] | undefined | null,
	gallery?: ValueTypes["DeliveryRegionsItemCreateGalleryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryRegionsItemCreateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["DeliveryRegionsItemCreateTextListEntityRelationInput"]: {
	connect?: ValueTypes["TextListUniqueWhere"] | undefined | null,
	create?: ValueTypes["TextListCreateInput"] | undefined | null
};
	["TextListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: Array<ValueTypes["TextListCreateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TextListCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["TextItemUniqueWhere"] | undefined | null,
	create?: ValueTypes["TextItemWithoutListCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TextItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	text?: string | undefined | null,
	title?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryRegionsItemCreateGalleryEntityRelationInput"]: {
	connect?: ValueTypes["ImageListUniqueWhere"] | undefined | null,
	create?: ValueTypes["ImageListCreateInput"] | undefined | null
};
	["ImageListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: Array<ValueTypes["ImageListCreateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ImageListCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["ImageListItemUniqueWhere"] | undefined | null,
	create?: ValueTypes["ImageListItemWithoutListCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ImageListItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	image?: ValueTypes["ImageListItemCreateImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ImageListItemCreateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["MenuDeliveryCreateSocialsAndAppsEntityRelationInput"]: {
	connect?: ValueTypes["SocialsAndAppsUniqueWhere"] | undefined | null,
	create?: ValueTypes["SocialsAndAppsCreateInput"] | undefined | null
};
	["SocialsAndAppsUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["SocialsAndAppsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	instagram?: boolean | undefined | null,
	appStore?: boolean | undefined | null,
	googlePlay?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MenuSubitemCreateContactEntityRelationInput"]: {
	connect?: ValueTypes["MenuContactUniqueWhere"] | undefined | null,
	create?: ValueTypes["MenuContactCreateInput"] | undefined | null
};
	["MenuContactUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["MenuContactCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	text?: string | undefined | null,
	image?: ValueTypes["MenuContactCreateImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MenuContactCreateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["MenuLocaleCreateSecondaryItemsEntityRelationInput"]: {
	connect?: ValueTypes["LinkListUniqueWhere"] | undefined | null,
	create?: ValueTypes["LinkListCreateInput"] | undefined | null
};
	["MenuLocaleCreateEshopLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null,
	create?: ValueTypes["LinkCreateInput"] | undefined | null
};
	["LocaleCreatePagesEntityRelationInput"]: {
	connect?: ValueTypes["PageLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["PageLocaleWithoutLocaleCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PageLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	link?: ValueTypes["PageLocaleCreateLinkEntityRelationInput"] | undefined | null,
	root?: ValueTypes["PageLocaleCreateRootEntityRelationInput"] | undefined | null,
	seo?: ValueTypes["PageLocaleCreateSeoEntityRelationInput"] | undefined | null,
	content?: ValueTypes["PageLocaleCreateContentEntityRelationInput"] | undefined | null,
	cover?: ValueTypes["PageLocaleCreateCoverEntityRelationInput"] | undefined | null,
	theme?: ValueTypes["PageTheme"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PageLocaleCreateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null,
	create?: ValueTypes["LinkableWithoutPageCreateInput"] | undefined | null
};
	["LinkableWithoutPageCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	url?: string | undefined | null,
	blogPost?: ValueTypes["LinkableCreateBlogPostEntityRelationInput"] | undefined | null,
	wikiPage?: ValueTypes["LinkableCreateWikiPageEntityRelationInput"] | undefined | null,
	redirect?: ValueTypes["LinkableCreateRedirectEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkableCreateWikiPageEntityRelationInput"]: {
	connect?: ValueTypes["WikiPageUniqueWhere"] | undefined | null,
	create?: ValueTypes["WikiPageWithoutLinkCreateInput"] | undefined | null
};
	["WikiPageWithoutLinkCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	title?: string | undefined | null,
	emoji?: string | undefined | null,
	parent?: ValueTypes["WikiPageCreateParentEntityRelationInput"] | undefined | null,
	children?: Array<ValueTypes["WikiPageCreateChildrenEntityRelationInput"]> | undefined | null,
	content?: ValueTypes["WikiPageCreateContentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["WikiPageCreateParentEntityRelationInput"]: {
	connect?: ValueTypes["WikiPageUniqueWhere"] | undefined | null,
	create?: ValueTypes["WikiPageWithoutChildrenCreateInput"] | undefined | null
};
	["WikiPageWithoutChildrenCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	title?: string | undefined | null,
	emoji?: string | undefined | null,
	link?: ValueTypes["WikiPageCreateLinkEntityRelationInput"] | undefined | null,
	parent?: ValueTypes["WikiPageCreateParentEntityRelationInput"] | undefined | null,
	content?: ValueTypes["WikiPageCreateContentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["WikiPageCreateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null,
	create?: ValueTypes["LinkableWithoutWikiPageCreateInput"] | undefined | null
};
	["LinkableWithoutWikiPageCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	url?: string | undefined | null,
	blogPost?: ValueTypes["LinkableCreateBlogPostEntityRelationInput"] | undefined | null,
	page?: ValueTypes["LinkableCreatePageEntityRelationInput"] | undefined | null,
	redirect?: ValueTypes["LinkableCreateRedirectEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkableCreatePageEntityRelationInput"]: {
	connect?: ValueTypes["PageLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["PageLocaleWithoutLinkCreateInput"] | undefined | null
};
	["PageLocaleWithoutLinkCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	root?: ValueTypes["PageLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["PageLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	seo?: ValueTypes["PageLocaleCreateSeoEntityRelationInput"] | undefined | null,
	content?: ValueTypes["PageLocaleCreateContentEntityRelationInput"] | undefined | null,
	cover?: ValueTypes["PageLocaleCreateCoverEntityRelationInput"] | undefined | null,
	theme?: ValueTypes["PageTheme"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PageLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["PageUniqueWhere"] | undefined | null,
	create?: ValueTypes["PageWithoutLocalesCreateInput"] | undefined | null
};
	["PageWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PageLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["LocaleWithoutPagesCreateInput"] | undefined | null
};
	["LocaleWithoutPagesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	businessCategories?: Array<ValueTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleCreateMenusEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleCreateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreateProductIngredientCategoriesEntityRelationInput"]: {
	connect?: ValueTypes["ProductIngredientCategoryLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductIngredientCategoryLocaleWithoutLocaleCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductIngredientCategoryLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	root?: ValueTypes["ProductIngredientCategoryLocaleCreateRootEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientCategoryLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["ProductIngredientCategoryUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductIngredientCategoryWithoutLocalesCreateInput"] | undefined | null
};
	["ProductIngredientCategoryWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	internalName?: string | undefined | null,
	internalNote?: string | undefined | null,
	ingredients?: Array<ValueTypes["ProductIngredientCategoryCreateIngredientsEntityRelationInput"]> | undefined | null,
	order?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientCategoryCreateIngredientsEntityRelationInput"]: {
	connect?: ValueTypes["ProductIngredientUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductIngredientWithoutCategoriesCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductIngredientWithoutCategoriesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	internalNote?: string | undefined | null,
	locales?: Array<ValueTypes["ProductIngredientCreateLocalesEntityRelationInput"]> | undefined | null,
	internalName?: string | undefined | null,
	allergens?: Array<ValueTypes["ProductIngredientCreateAllergensEntityRelationInput"]> | undefined | null,
	needsPrepping?: boolean | undefined | null,
	allowCustomerRating?: boolean | undefined | null,
	customerRatings?: Array<ValueTypes["ProductIngredientCreateCustomerRatingsEntityRelationInput"]> | undefined | null,
	preferredQuantityUnit?: ValueTypes["ProductIngredientCreatePreferredQuantityUnitEntityRelationInput"] | undefined | null,
	freshingContainer?: ValueTypes["ProductIngredientCreateFreshingContainerEntityRelationInput"] | undefined | null,
	image?: ValueTypes["ProductIngredientCreateImageEntityRelationInput"] | undefined | null,
	suppliers?: ValueTypes["ProductIngredientCreateSuppliersEntityRelationInput"] | undefined | null,
	incrementQuantityNumber?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientCreateCustomerRatingsEntityRelationInput"]: {
	connect?: ValueTypes["CustomerIngredientRatingUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerIngredientRatingWithoutIngredientCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerIngredientRatingWithoutIngredientCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	customer?: ValueTypes["CustomerIngredientRatingCreateCustomerEntityRelationInput"] | undefined | null,
	rating?: ValueTypes["CustomerIngredientRatingCreateRatingEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerIngredientRatingCreateCustomerEntityRelationInput"]: {
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerWithoutIngredientRatingsCreateInput"] | undefined | null
};
	["CustomerWithoutIngredientRatingsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	addresses?: Array<ValueTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerCreateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerCreateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerCreatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerCreateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	business?: ValueTypes["CustomerCreateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerCreateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerCreateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerCreateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerCreateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerCreateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreateBusinessEntityRelationInput"]: {
	connect?: ValueTypes["BusinessCustomerUniqueWhere"] | undefined | null,
	create?: ValueTypes["BusinessCustomerWithoutCustomerCreateInput"] | undefined | null
};
	["BusinessCustomerWithoutCustomerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	owners?: Array<ValueTypes["BusinessCustomerCreateOwnersEntityRelationInput"]> | undefined | null,
	members?: Array<ValueTypes["BusinessCustomerCreateMembersEntityRelationInput"]> | undefined | null,
	category?: ValueTypes["BusinessCustomerCreateCategoryEntityRelationInput"] | undefined | null,
	accountManager?: ValueTypes["BusinessCustomerCreateAccountManagerEntityRelationInput"] | undefined | null,
	logo?: ValueTypes["BusinessCustomerCreateLogoEntityRelationInput"] | undefined | null,
	note?: string | undefined | null,
	businessServiceEvents?: Array<ValueTypes["BusinessCustomerCreateBusinessServiceEventsEntityRelationInput"]> | undefined | null,
	doubleshotCoffeeEquipment?: ValueTypes["BusinessCustomerCreateDoubleshotCoffeeEquipmentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessCustomerCreateOwnersEntityRelationInput"]: {
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerWithoutOwnerOfBusinessesCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerWithoutOwnerOfBusinessesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	addresses?: Array<ValueTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerCreateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerCreateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerCreatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerCreateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerCreateBusinessEntityRelationInput"] | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerCreateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerCreateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerCreateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerCreateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerCreateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreateMemberOfBusinessesEntityRelationInput"]: {
	connect?: ValueTypes["BusinessCustomerUniqueWhere"] | undefined | null,
	create?: ValueTypes["BusinessCustomerWithoutMembersCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["BusinessCustomerWithoutMembersCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	customer?: ValueTypes["BusinessCustomerCreateCustomerEntityRelationInput"] | undefined | null,
	owners?: Array<ValueTypes["BusinessCustomerCreateOwnersEntityRelationInput"]> | undefined | null,
	category?: ValueTypes["BusinessCustomerCreateCategoryEntityRelationInput"] | undefined | null,
	accountManager?: ValueTypes["BusinessCustomerCreateAccountManagerEntityRelationInput"] | undefined | null,
	logo?: ValueTypes["BusinessCustomerCreateLogoEntityRelationInput"] | undefined | null,
	note?: string | undefined | null,
	businessServiceEvents?: Array<ValueTypes["BusinessCustomerCreateBusinessServiceEventsEntityRelationInput"]> | undefined | null,
	doubleshotCoffeeEquipment?: ValueTypes["BusinessCustomerCreateDoubleshotCoffeeEquipmentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessCustomerCreateCategoryEntityRelationInput"]: {
	connect?: ValueTypes["BusinessCategoryUniqueWhere"] | undefined | null,
	create?: ValueTypes["BusinessCategoryWithoutBusinessCustomersCreateInput"] | undefined | null
};
	["BusinessCategoryWithoutBusinessCustomersCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	visibleToNewCustomers?: boolean | undefined | null,
	locales?: Array<ValueTypes["BusinessCategoryCreateLocalesEntityRelationInput"]> | undefined | null,
	internalName?: string | undefined | null,
	recurrences?: Array<ValueTypes["BusinessCategoryCreateRecurrencesEntityRelationInput"]> | undefined | null,
	specificProducts?: ValueTypes["BusinessCategoryCreateSpecificProductsEntityRelationInput"] | undefined | null,
	seasonalProductCategories?: ValueTypes["BusinessCategoryCreateSeasonalProductCategoriesEntityRelationInput"] | undefined | null,
	specificProductsProductCategories?: ValueTypes["BusinessCategoryCreateSpecificProductsProductCategoriesEntityRelationInput"] | undefined | null,
	slug?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessCategoryCreateRecurrencesEntityRelationInput"]: {
	connect?: ValueTypes["OrderRecurrenceUniqueWhere"] | undefined | null,
	create?: ValueTypes["OrderRecurrenceWithoutBusinessCategoryCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["OrderRecurrenceWithoutBusinessCategoryCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	internalName?: string | undefined | null,
	locales?: Array<ValueTypes["OrderRecurrenceCreateLocalesEntityRelationInput"]> | undefined | null,
	order?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderRecurrenceCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["OrderRecurrenceLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["OrderRecurrenceLocaleWithoutRootCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["OrderRecurrenceLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	locale?: ValueTypes["OrderRecurrenceLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderRecurrenceLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["LocaleWithoutOrderRecurrencesCreateInput"] | undefined | null
};
	["LocaleWithoutOrderRecurrencesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	businessCategories?: Array<ValueTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleCreateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleCreatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleCreateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreateAllergensEntityRelationInput"]: {
	connect?: ValueTypes["AllergenLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["AllergenLocaleWithoutLocaleCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["AllergenLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	root?: ValueTypes["AllergenLocaleCreateRootEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AllergenLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["AllergenUniqueWhere"] | undefined | null,
	create?: ValueTypes["AllergenWithoutLocalesCreateInput"] | undefined | null
};
	["AllergenWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	internalName?: string | undefined | null,
	ingredients?: Array<ValueTypes["AllergenCreateIngredientsEntityRelationInput"]> | undefined | null,
	code?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AllergenCreateIngredientsEntityRelationInput"]: {
	connect?: ValueTypes["ProductIngredientUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductIngredientWithoutAllergensCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductIngredientWithoutAllergensCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	internalNote?: string | undefined | null,
	locales?: Array<ValueTypes["ProductIngredientCreateLocalesEntityRelationInput"]> | undefined | null,
	internalName?: string | undefined | null,
	categories?: Array<ValueTypes["ProductIngredientCreateCategoriesEntityRelationInput"]> | undefined | null,
	needsPrepping?: boolean | undefined | null,
	allowCustomerRating?: boolean | undefined | null,
	customerRatings?: Array<ValueTypes["ProductIngredientCreateCustomerRatingsEntityRelationInput"]> | undefined | null,
	preferredQuantityUnit?: ValueTypes["ProductIngredientCreatePreferredQuantityUnitEntityRelationInput"] | undefined | null,
	freshingContainer?: ValueTypes["ProductIngredientCreateFreshingContainerEntityRelationInput"] | undefined | null,
	image?: ValueTypes["ProductIngredientCreateImageEntityRelationInput"] | undefined | null,
	suppliers?: ValueTypes["ProductIngredientCreateSuppliersEntityRelationInput"] | undefined | null,
	incrementQuantityNumber?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientCreatePreferredQuantityUnitEntityRelationInput"]: {
	connect?: ValueTypes["ProductIngredientItemQuantityUnitUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductIngredientItemQuantityUnitCreateInput"] | undefined | null
};
	["ProductIngredientItemQuantityUnitUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null
};
	["ProductIngredientItemQuantityUnitCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientCreateFreshingContainerEntityRelationInput"]: {
	connect?: ValueTypes["FreshingContainerUniqueWhere"] | undefined | null,
	create?: ValueTypes["FreshingContainerCreateInput"] | undefined | null
};
	["FreshingContainerUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["FreshingContainerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	volumeMl?: number | undefined | null,
	workspace?: ValueTypes["FreshingContainerCreateWorkspaceEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FreshingContainerCreateWorkspaceEntityRelationInput"]: {
	connect?: ValueTypes["WorkspaceUniqueWhere"] | undefined | null,
	create?: ValueTypes["WorkspaceWithoutFreshingContainersCreateInput"] | undefined | null
};
	["WorkspaceUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	unique?: ValueTypes["One"] | undefined | null,
	freshingContainers?: ValueTypes["FreshingContainerUniqueWhere"] | undefined | null,
	openingHours?: ValueTypes["WeekHoursUniqueWhere"] | undefined | null,
	workingHours?: ValueTypes["WeekHoursUniqueWhere"] | undefined | null,
	creditsProduct?: ValueTypes["VirtualProductUniqueWhere"] | undefined | null,
	discountVatRate?: ValueTypes["VatRateUniqueWhere"] | undefined | null
};
	["WeekHoursUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["WorkspaceWithoutFreshingContainersCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	unique?: ValueTypes["One"] | undefined | null,
	orderDeadlineTime?: string | undefined | null,
	ordersLoadingDurationHours?: number | undefined | null,
	freshingContainerVolumeMl?: number | undefined | null,
	freshingPrepareOrderByOffsetMinutes?: number | undefined | null,
	checkoutUrlTemplate?: string | undefined | null,
	orderUrlTemplate?: string | undefined | null,
	paymentUrlTemplate?: string | undefined | null,
	customerProfileUrlTemplate?: string | undefined | null,
	userProfileUrlTemplate?: string | undefined | null,
	messengerUrl?: string | undefined | null,
	messengerIosUrl?: string | undefined | null,
	messengerAndroidUrl?: string | undefined | null,
	openingHours?: ValueTypes["WorkspaceCreateOpeningHoursEntityRelationInput"] | undefined | null,
	workingHours?: ValueTypes["WorkspaceCreateWorkingHoursEntityRelationInput"] | undefined | null,
	defaultFreshingContainer?: ValueTypes["WorkspaceCreateDefaultFreshingContainerEntityRelationInput"] | undefined | null,
	creditsProduct?: ValueTypes["WorkspaceCreateCreditsProductEntityRelationInput"] | undefined | null,
	discountVatRate?: ValueTypes["WorkspaceCreateDiscountVatRateEntityRelationInput"] | undefined | null,
	name?: string | undefined | null,
	businessAddress?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["WorkspaceCreateOpeningHoursEntityRelationInput"]: {
	connect?: ValueTypes["WeekHoursUniqueWhere"] | undefined | null,
	create?: ValueTypes["WeekHoursCreateInput"] | undefined | null
};
	["WeekHoursCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	mon?: string | undefined | null,
	tue?: string | undefined | null,
	wed?: string | undefined | null,
	thu?: string | undefined | null,
	fri?: string | undefined | null,
	sat?: string | undefined | null,
	sun?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["WorkspaceCreateWorkingHoursEntityRelationInput"]: {
	connect?: ValueTypes["WeekHoursUniqueWhere"] | undefined | null,
	create?: ValueTypes["WeekHoursCreateInput"] | undefined | null
};
	["WorkspaceCreateDefaultFreshingContainerEntityRelationInput"]: {
	connect?: ValueTypes["FreshingContainerUniqueWhere"] | undefined | null,
	create?: ValueTypes["FreshingContainerCreateInput"] | undefined | null
};
	["WorkspaceCreateCreditsProductEntityRelationInput"]: {
	connect?: ValueTypes["VirtualProductUniqueWhere"] | undefined | null,
	create?: ValueTypes["VirtualProductCreateInput"] | undefined | null
};
	["VirtualProductCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	type?: ValueTypes["VirtualProductType"] | undefined | null,
	product?: ValueTypes["VirtualProductCreateProductEntityRelationInput"] | undefined | null,
	voucherCreditCents?: number | undefined | null,
	physicalRepresentation?: ValueTypes["VirtualProductPhysicalRepresentationType"] | undefined | null,
	recipientEmail?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VirtualProductCreateProductEntityRelationInput"]: {
	connect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductWithoutVirtualProductCreateInput"] | undefined | null
};
	["ProductWithoutVirtualProductCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	priceCents?: number | undefined | null,
	notDiscountable?: boolean | undefined | null,
	packing?: ValueTypes["ProductCreatePackingEntityRelationInput"] | undefined | null,
	recipe?: ValueTypes["ProductCreateRecipeEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["ProductCreateTagsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["ProductCreateCategoriesEntityRelationInput"]> | undefined | null,
	vatRate?: ValueTypes["ProductCreateVatRateEntityRelationInput"] | undefined | null,
	stocks?: Array<ValueTypes["ProductCreateStocksEntityRelationInput"]> | undefined | null,
	groupPrices?: Array<ValueTypes["ProductCreateGroupPricesEntityRelationInput"]> | undefined | null,
	image?: ValueTypes["ProductCreateImageEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	cartItems?: Array<ValueTypes["ProductCreateCartItemsEntityRelationInput"]> | undefined | null,
	availability?: ValueTypes["ProductAvailability"] | undefined | null,
	order?: number | undefined | null,
	manager?: ValueTypes["ProductCreateManagerEntityRelationInput"] | undefined | null,
	orderItems?: Array<ValueTypes["ProductCreateOrderItemsEntityRelationInput"]> | undefined | null,
	maximumQuantityPerOrder?: number | undefined | null,
	inheritedCategories?: Array<ValueTypes["ProductCreateInheritedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["ProductCreateDeliveryZonesEntityRelationInput"]> | undefined | null,
	locales?: Array<ValueTypes["ProductCreateLocalesEntityRelationInput"]> | undefined | null,
	archivedAt?: ValueTypes["DateTime"] | undefined | null,
	customerPrices?: Array<ValueTypes["ProductCreateCustomerPricesEntityRelationInput"]> | undefined | null,
	meta?: ValueTypes["ProductCreateMetaEntityRelationInput"] | undefined | null,
	page?: ValueTypes["ProductCreatePageEntityRelationInput"] | undefined | null,
	salesDays?: Array<ValueTypes["ProductCreateSalesDaysEntityRelationInput"]> | undefined | null,
	salesWeeks?: Array<ValueTypes["ProductCreateSalesWeeksEntityRelationInput"]> | undefined | null,
	salesMonths?: Array<ValueTypes["ProductCreateSalesMonthsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["ProductCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	hasSubscription?: boolean | undefined | null,
	pointOfSaleTileColor?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCreateManagerEntityRelationInput"]: {
	connect?: ValueTypes["StocksManagerUniqueWhere"] | undefined | null,
	create?: ValueTypes["StocksManagerWithoutManagedProductsCreateInput"] | undefined | null
};
	["StocksManagerWithoutManagedProductsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	staff?: ValueTypes["StocksManagerCreateStaffEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StocksManagerCreateStaffEntityRelationInput"]: {
	connect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	create?: ValueTypes["StaffWithoutStocksManagerCreateInput"] | undefined | null
};
	["StaffWithoutStocksManagerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	bartender?: ValueTypes["StaffCreateBartenderEntityRelationInput"] | undefined | null,
	courier?: ValueTypes["StaffCreateCourierEntityRelationInput"] | undefined | null,
	cleaner?: ValueTypes["StaffCreateCleanerEntityRelationInput"] | undefined | null,
	shiftsManager?: ValueTypes["StaffCreateShiftsManagerEntityRelationInput"] | undefined | null,
	businessToBusinessManager?: ValueTypes["StaffCreateBusinessToBusinessManagerEntityRelationInput"] | undefined | null,
	user?: ValueTypes["StaffCreateUserEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["StaffCreateShiftsProfileEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["StaffCreatePhotoEntityRelationInput"] | undefined | null,
	courierManager?: ValueTypes["StaffCreateCourierManagerEntityRelationInput"] | undefined | null,
	picker?: ValueTypes["StaffCreatePickerEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	remunerationProfile?: ValueTypes["StaffCreateRemunerationProfileEntityRelationInput"] | undefined | null,
	cashier?: ValueTypes["StaffCreateCashierEntityRelationInput"] | undefined | null,
	venues?: Array<ValueTypes["StaffCreateVenuesEntityRelationInput"]> | undefined | null,
	internalBuyer?: ValueTypes["StaffCreateInternalBuyerEntityRelationInput"] | undefined | null,
	salesManager?: ValueTypes["StaffCreateSalesManagerEntityRelationInput"] | undefined | null,
	cashierManager?: ValueTypes["StaffCreateCashierManagerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StaffCreateBartenderEntityRelationInput"]: {
	connect?: ValueTypes["BartenderUniqueWhere"] | undefined | null,
	create?: ValueTypes["BartenderWithoutStaffCreateInput"] | undefined | null
};
	["BartenderWithoutStaffCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StaffCreateCourierEntityRelationInput"]: {
	connect?: ValueTypes["CourierUniqueWhere"] | undefined | null,
	create?: ValueTypes["CourierWithoutStaffCreateInput"] | undefined | null
};
	["CourierWithoutStaffCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	routes?: Array<ValueTypes["CourierCreateRoutesEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	deliveryMethods?: Array<ValueTypes["CourierCreateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	showInPicker?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CourierCreateRoutesEntityRelationInput"]: {
	connect?: ValueTypes["DeliveryRouteUniqueWhere"] | undefined | null,
	create?: ValueTypes["DeliveryRouteWithoutCourierCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["DeliveryRouteWithoutCourierCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	waypoints?: Array<ValueTypes["DeliveryRouteCreateWaypointsEntityRelationInput"]> | undefined | null,
	dispatchAt?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryRouteCreateWaypointsEntityRelationInput"]: {
	connect?: ValueTypes["DeliveryWaypointUniqueWhere"] | undefined | null,
	create?: ValueTypes["DeliveryWaypointWithoutRouteCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["DeliveryWaypointWithoutRouteCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	estimatedArrival?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	sortingOrder?: number | undefined | null,
	delivery?: ValueTypes["DeliveryWaypointCreateDeliveryEntityRelationInput"] | undefined | null,
	estimatedDistance?: number | undefined | null,
	estimatedDuration?: number | undefined | null,
	originDeparture?: ValueTypes["DateTime"] | undefined | null,
	originAddress?: string | undefined | null,
	transitMode?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryWaypointCreateDeliveryEntityRelationInput"]: {
	connect?: ValueTypes["OrderDeliveryUniqueWhere"] | undefined | null,
	create?: ValueTypes["OrderDeliveryWithoutDeliveryWaypointCreateInput"] | undefined | null
};
	["OrderDeliveryWithoutDeliveryWaypointCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	priceCents?: number | undefined | null,
	deliveredAt?: ValueTypes["DateTime"] | undefined | null,
	method?: ValueTypes["OrderDeliveryCreateMethodEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["OrderDeliveryCreateVatRateEntityRelationInput"] | undefined | null,
	order?: ValueTypes["OrderDeliveryCreateOrderEntityRelationInput"] | undefined | null,
	expectedAt?: ValueTypes["DateTime"] | undefined | null,
	state?: ValueTypes["OrderDeliveryState"] | undefined | null,
	loadingDurationHours?: number | undefined | null,
	dispatchAt?: ValueTypes["DateTime"] | undefined | null,
	duration?: string | undefined | null,
	window?: string | undefined | null,
	expectedEndAt?: ValueTypes["DateTime"] | undefined | null,
	processingAt?: ValueTypes["DateTime"] | undefined | null,
	deliveringAt?: ValueTypes["DateTime"] | undefined | null,
	failedAt?: ValueTypes["DateTime"] | undefined | null,
	internalNote?: string | undefined | null,
	events?: Array<ValueTypes["OrderDeliveryCreateEventsEntityRelationInput"]> | undefined | null,
	prepareAt?: ValueTypes["DateTime"] | undefined | null,
	liftagoRide?: ValueTypes["OrderDeliveryCreateLiftagoRideEntityRelationInput"] | undefined | null,
	pickedAt?: ValueTypes["DateTime"] | undefined | null,
	address?: ValueTypes["OrderDeliveryCreateAddressEntityRelationInput"] | undefined | null,
	trackingCode?: string | undefined | null,
	woltDriveDelivery?: ValueTypes["OrderDeliveryCreateWoltDriveDeliveryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderDeliveryCreateMethodEntityRelationInput"]: {
	connect?: ValueTypes["DeliveryMethodUniqueWhere"] | undefined | null,
	create?: ValueTypes["DeliveryMethodCreateInput"] | undefined | null
};
	["DeliveryMethodCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	enabled?: boolean | undefined | null,
	paymentMethods?: Array<ValueTypes["DeliveryMethodCreatePaymentMethodsEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	requireDeliveryAddress?: boolean | undefined | null,
	suitableForDeliveryZones?: Array<ValueTypes["DeliveryMethodCreateSuitableForDeliveryZonesEntityRelationInput"]> | undefined | null,
	channels?: Array<ValueTypes["DeliveryMethodCreateChannelsEntityRelationInput"]> | undefined | null,
	courierHandlers?: Array<ValueTypes["DeliveryMethodCreateCourierHandlersEntityRelationInput"]> | undefined | null,
	enableDeliveryTracking?: boolean | undefined | null,
	locales?: Array<ValueTypes["DeliveryMethodCreateLocalesEntityRelationInput"]> | undefined | null,
	timelinePreset?: ValueTypes["DeliveryMethodCreateTimelinePresetEntityRelationInput"] | undefined | null,
	woltDriveVenueId?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryMethodCreateCourierHandlersEntityRelationInput"]: {
	connect?: ValueTypes["CourierUniqueWhere"] | undefined | null,
	create?: ValueTypes["CourierWithoutDeliveryMethodsCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["CourierWithoutDeliveryMethodsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	staff?: ValueTypes["CourierCreateStaffEntityRelationInput"] | undefined | null,
	routes?: Array<ValueTypes["CourierCreateRoutesEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	showInPicker?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CourierCreateStaffEntityRelationInput"]: {
	connect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	create?: ValueTypes["StaffWithoutCourierCreateInput"] | undefined | null
};
	["StaffWithoutCourierCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	bartender?: ValueTypes["StaffCreateBartenderEntityRelationInput"] | undefined | null,
	cleaner?: ValueTypes["StaffCreateCleanerEntityRelationInput"] | undefined | null,
	shiftsManager?: ValueTypes["StaffCreateShiftsManagerEntityRelationInput"] | undefined | null,
	businessToBusinessManager?: ValueTypes["StaffCreateBusinessToBusinessManagerEntityRelationInput"] | undefined | null,
	user?: ValueTypes["StaffCreateUserEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["StaffCreateShiftsProfileEntityRelationInput"] | undefined | null,
	stocksManager?: ValueTypes["StaffCreateStocksManagerEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["StaffCreatePhotoEntityRelationInput"] | undefined | null,
	courierManager?: ValueTypes["StaffCreateCourierManagerEntityRelationInput"] | undefined | null,
	picker?: ValueTypes["StaffCreatePickerEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	remunerationProfile?: ValueTypes["StaffCreateRemunerationProfileEntityRelationInput"] | undefined | null,
	cashier?: ValueTypes["StaffCreateCashierEntityRelationInput"] | undefined | null,
	venues?: Array<ValueTypes["StaffCreateVenuesEntityRelationInput"]> | undefined | null,
	internalBuyer?: ValueTypes["StaffCreateInternalBuyerEntityRelationInput"] | undefined | null,
	salesManager?: ValueTypes["StaffCreateSalesManagerEntityRelationInput"] | undefined | null,
	cashierManager?: ValueTypes["StaffCreateCashierManagerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StaffCreateCleanerEntityRelationInput"]: {
	connect?: ValueTypes["CleanerUniqueWhere"] | undefined | null,
	create?: ValueTypes["CleanerWithoutStaffCreateInput"] | undefined | null
};
	["CleanerWithoutStaffCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	canReachTopShelf?: boolean | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StaffCreateShiftsManagerEntityRelationInput"]: {
	connect?: ValueTypes["ShiftsManagerUniqueWhere"] | undefined | null,
	create?: ValueTypes["ShiftsManagerWithoutStaffCreateInput"] | undefined | null
};
	["ShiftsManagerWithoutStaffCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	managedRoles?: Array<ValueTypes["ShiftsManagerCreateManagedRolesEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ShiftsManagerCreateManagedRolesEntityRelationInput"]: {
	connect?: ValueTypes["TimetableEmployeeRoleUniqueWhere"] | undefined | null,
	create?: ValueTypes["TimetableEmployeeRoleWithoutShiftsManagersCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TimetableEmployeeRoleWithoutShiftsManagersCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	shiftGroups?: Array<ValueTypes["TimetableEmployeeRoleCreateShiftGroupsEntityRelationInput"]> | undefined | null,
	shiftsProfiles?: Array<ValueTypes["TimetableEmployeeRoleCreateShiftsProfilesEntityRelationInput"]> | undefined | null,
	name?: string | undefined | null,
	timetableTemplates?: Array<ValueTypes["TimetableEmployeeRoleCreateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	color?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableEmployeeRoleCreateShiftGroupsEntityRelationInput"]: {
	connect?: ValueTypes["TimetableShiftGroupUniqueWhere"] | undefined | null,
	create?: ValueTypes["TimetableShiftGroupWithoutTypeCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TimetableShiftGroupWithoutTypeCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	shifts?: Array<ValueTypes["TimetableShiftGroupCreateShiftsEntityRelationInput"]> | undefined | null,
	day?: ValueTypes["TimetableShiftGroupCreateDayEntityRelationInput"] | undefined | null,
	position?: ValueTypes["TimetableShiftGroupCreatePositionEntityRelationInput"] | undefined | null,
	queue?: ValueTypes["TimetableShiftGroupCreateQueueEntityRelationInput"] | undefined | null,
	generatedByTemplate?: ValueTypes["TimetableShiftGroupCreateGeneratedByTemplateEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableShiftGroupCreateShiftsEntityRelationInput"]: {
	connect?: ValueTypes["TimetableShiftUniqueWhere"] | undefined | null,
	create?: ValueTypes["TimetableShiftWithoutGroupCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TimetableShiftWithoutGroupCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	locked?: boolean | undefined | null,
	order?: number | undefined | null,
	assigned?: ValueTypes["Date"] | undefined | null,
	shiftsProfile?: ValueTypes["TimetableShiftCreateShiftsProfileEntityRelationInput"] | undefined | null,
	queueItem?: ValueTypes["TimetableShiftCreateQueueItemEntityRelationInput"] | undefined | null,
	swapInfo?: ValueTypes["TimetableShiftCreateSwapInfoEntityRelationInput"] | undefined | null,
	isOvertime?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableShiftCreateShiftsProfileEntityRelationInput"]: {
	connect?: ValueTypes["ShiftsProfileUniqueWhere"] | undefined | null,
	create?: ValueTypes["ShiftsProfileWithoutShiftsCreateInput"] | undefined | null
};
	["ShiftsProfileWithoutShiftsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	queueItems?: Array<ValueTypes["ShiftsProfileCreateQueueItemsEntityRelationInput"]> | undefined | null,
	staff?: ValueTypes["ShiftsProfileCreateStaffEntityRelationInput"] | undefined | null,
	roles?: Array<ValueTypes["ShiftsProfileCreateRolesEntityRelationInput"]> | undefined | null,
	allowSelfUnassigning?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ShiftsProfileCreateQueueItemsEntityRelationInput"]: {
	connect?: ValueTypes["EmployeeQueueItemUniqueWhere"] | undefined | null,
	create?: ValueTypes["EmployeeQueueItemWithoutShiftsProfileCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["EmployeeQueueItemWithoutShiftsProfileCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	start?: string | undefined | null,
	end?: string | undefined | null,
	queue?: ValueTypes["EmployeeQueueItemCreateQueueEntityRelationInput"] | undefined | null,
	shift?: ValueTypes["EmployeeQueueItemCreateShiftEntityRelationInput"] | undefined | null,
	unassignInfo?: ValueTypes["EmployeeQueueItemCreateUnassignInfoEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["EmployeeQueueItemCreateMetaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["EmployeeQueueItemCreateQueueEntityRelationInput"]: {
	connect?: ValueTypes["EmployeeQueueUniqueWhere"] | undefined | null,
	create?: ValueTypes["EmployeeQueueWithoutItemsCreateInput"] | undefined | null
};
	["EmployeeQueueWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	shiftGroup?: ValueTypes["EmployeeQueueCreateShiftGroupEntityRelationInput"] | undefined | null,
	contemberBugFix?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["EmployeeQueueCreateShiftGroupEntityRelationInput"]: {
	connect?: ValueTypes["TimetableShiftGroupUniqueWhere"] | undefined | null,
	create?: ValueTypes["TimetableShiftGroupWithoutQueueCreateInput"] | undefined | null
};
	["TimetableShiftGroupWithoutQueueCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	shifts?: Array<ValueTypes["TimetableShiftGroupCreateShiftsEntityRelationInput"]> | undefined | null,
	day?: ValueTypes["TimetableShiftGroupCreateDayEntityRelationInput"] | undefined | null,
	type?: ValueTypes["TimetableShiftGroupCreateTypeEntityRelationInput"] | undefined | null,
	position?: ValueTypes["TimetableShiftGroupCreatePositionEntityRelationInput"] | undefined | null,
	generatedByTemplate?: ValueTypes["TimetableShiftGroupCreateGeneratedByTemplateEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableShiftGroupCreateDayEntityRelationInput"]: {
	connect?: ValueTypes["TimetableDayUniqueWhere"] | undefined | null,
	create?: ValueTypes["TimetableDayWithoutShiftGroupsCreateInput"] | undefined | null
};
	["TimetableDayWithoutShiftGroupsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	date?: ValueTypes["Date"] | undefined | null,
	type?: ValueTypes["TimetableDayType"] | undefined | null,
	tipsCents?: number | undefined | null,
	notes?: Array<ValueTypes["TimetableDayCreateNotesEntityRelationInput"]> | undefined | null,
	venue?: ValueTypes["TimetableDayCreateVenueEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["TimetableDayCreateMetaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableDayCreateNotesEntityRelationInput"]: {
	connect?: ValueTypes["TimetableDayNoteUniqueWhere"] | undefined | null,
	create?: ValueTypes["TimetableDayNoteWithoutDayCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TimetableDayNoteWithoutDayCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	note?: string | undefined | null,
	role?: ValueTypes["TimetableDayNoteCreateRoleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableDayNoteCreateRoleEntityRelationInput"]: {
	connect?: ValueTypes["TimetableEmployeeRoleUniqueWhere"] | undefined | null,
	create?: ValueTypes["TimetableEmployeeRoleCreateInput"] | undefined | null
};
	["TimetableEmployeeRoleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	shiftGroups?: Array<ValueTypes["TimetableEmployeeRoleCreateShiftGroupsEntityRelationInput"]> | undefined | null,
	shiftsProfiles?: Array<ValueTypes["TimetableEmployeeRoleCreateShiftsProfilesEntityRelationInput"]> | undefined | null,
	shiftsManagers?: Array<ValueTypes["TimetableEmployeeRoleCreateShiftsManagersEntityRelationInput"]> | undefined | null,
	name?: string | undefined | null,
	timetableTemplates?: Array<ValueTypes["TimetableEmployeeRoleCreateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	color?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableEmployeeRoleCreateShiftsProfilesEntityRelationInput"]: {
	connect?: ValueTypes["ShiftsProfileUniqueWhere"] | undefined | null,
	create?: ValueTypes["ShiftsProfileWithoutRolesCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ShiftsProfileWithoutRolesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	queueItems?: Array<ValueTypes["ShiftsProfileCreateQueueItemsEntityRelationInput"]> | undefined | null,
	staff?: ValueTypes["ShiftsProfileCreateStaffEntityRelationInput"] | undefined | null,
	shifts?: Array<ValueTypes["ShiftsProfileCreateShiftsEntityRelationInput"]> | undefined | null,
	allowSelfUnassigning?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ShiftsProfileCreateStaffEntityRelationInput"]: {
	connect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	create?: ValueTypes["StaffWithoutShiftsProfileCreateInput"] | undefined | null
};
	["StaffWithoutShiftsProfileCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	bartender?: ValueTypes["StaffCreateBartenderEntityRelationInput"] | undefined | null,
	courier?: ValueTypes["StaffCreateCourierEntityRelationInput"] | undefined | null,
	cleaner?: ValueTypes["StaffCreateCleanerEntityRelationInput"] | undefined | null,
	shiftsManager?: ValueTypes["StaffCreateShiftsManagerEntityRelationInput"] | undefined | null,
	businessToBusinessManager?: ValueTypes["StaffCreateBusinessToBusinessManagerEntityRelationInput"] | undefined | null,
	user?: ValueTypes["StaffCreateUserEntityRelationInput"] | undefined | null,
	stocksManager?: ValueTypes["StaffCreateStocksManagerEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["StaffCreatePhotoEntityRelationInput"] | undefined | null,
	courierManager?: ValueTypes["StaffCreateCourierManagerEntityRelationInput"] | undefined | null,
	picker?: ValueTypes["StaffCreatePickerEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	remunerationProfile?: ValueTypes["StaffCreateRemunerationProfileEntityRelationInput"] | undefined | null,
	cashier?: ValueTypes["StaffCreateCashierEntityRelationInput"] | undefined | null,
	venues?: Array<ValueTypes["StaffCreateVenuesEntityRelationInput"]> | undefined | null,
	internalBuyer?: ValueTypes["StaffCreateInternalBuyerEntityRelationInput"] | undefined | null,
	salesManager?: ValueTypes["StaffCreateSalesManagerEntityRelationInput"] | undefined | null,
	cashierManager?: ValueTypes["StaffCreateCashierManagerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StaffCreateBusinessToBusinessManagerEntityRelationInput"]: {
	connect?: ValueTypes["BusinessToBusinessManagerUniqueWhere"] | undefined | null,
	create?: ValueTypes["BusinessToBusinessManagerWithoutStaffCreateInput"] | undefined | null
};
	["BusinessToBusinessManagerWithoutStaffCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	managedBusinesses?: Array<ValueTypes["BusinessToBusinessManagerCreateManagedBusinessesEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessToBusinessManagerCreateManagedBusinessesEntityRelationInput"]: {
	connect?: ValueTypes["BusinessCustomerUniqueWhere"] | undefined | null,
	create?: ValueTypes["BusinessCustomerWithoutAccountManagerCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["BusinessCustomerWithoutAccountManagerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	customer?: ValueTypes["BusinessCustomerCreateCustomerEntityRelationInput"] | undefined | null,
	owners?: Array<ValueTypes["BusinessCustomerCreateOwnersEntityRelationInput"]> | undefined | null,
	members?: Array<ValueTypes["BusinessCustomerCreateMembersEntityRelationInput"]> | undefined | null,
	category?: ValueTypes["BusinessCustomerCreateCategoryEntityRelationInput"] | undefined | null,
	logo?: ValueTypes["BusinessCustomerCreateLogoEntityRelationInput"] | undefined | null,
	note?: string | undefined | null,
	businessServiceEvents?: Array<ValueTypes["BusinessCustomerCreateBusinessServiceEventsEntityRelationInput"]> | undefined | null,
	doubleshotCoffeeEquipment?: ValueTypes["BusinessCustomerCreateDoubleshotCoffeeEquipmentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessCustomerCreateMembersEntityRelationInput"]: {
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerWithoutMemberOfBusinessesCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerWithoutMemberOfBusinessesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	addresses?: Array<ValueTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerCreateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerCreateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerCreatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerCreateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerCreateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerCreateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerCreateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerCreateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerCreateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerCreateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreateOwnerOfBusinessesEntityRelationInput"]: {
	connect?: ValueTypes["BusinessCustomerUniqueWhere"] | undefined | null,
	create?: ValueTypes["BusinessCustomerWithoutOwnersCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["BusinessCustomerWithoutOwnersCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	customer?: ValueTypes["BusinessCustomerCreateCustomerEntityRelationInput"] | undefined | null,
	members?: Array<ValueTypes["BusinessCustomerCreateMembersEntityRelationInput"]> | undefined | null,
	category?: ValueTypes["BusinessCustomerCreateCategoryEntityRelationInput"] | undefined | null,
	accountManager?: ValueTypes["BusinessCustomerCreateAccountManagerEntityRelationInput"] | undefined | null,
	logo?: ValueTypes["BusinessCustomerCreateLogoEntityRelationInput"] | undefined | null,
	note?: string | undefined | null,
	businessServiceEvents?: Array<ValueTypes["BusinessCustomerCreateBusinessServiceEventsEntityRelationInput"]> | undefined | null,
	doubleshotCoffeeEquipment?: ValueTypes["BusinessCustomerCreateDoubleshotCoffeeEquipmentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessCustomerCreateAccountManagerEntityRelationInput"]: {
	connect?: ValueTypes["BusinessToBusinessManagerUniqueWhere"] | undefined | null,
	create?: ValueTypes["BusinessToBusinessManagerWithoutManagedBusinessesCreateInput"] | undefined | null
};
	["BusinessToBusinessManagerWithoutManagedBusinessesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	staff?: ValueTypes["BusinessToBusinessManagerCreateStaffEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessToBusinessManagerCreateStaffEntityRelationInput"]: {
	connect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	create?: ValueTypes["StaffWithoutBusinessToBusinessManagerCreateInput"] | undefined | null
};
	["StaffWithoutBusinessToBusinessManagerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	bartender?: ValueTypes["StaffCreateBartenderEntityRelationInput"] | undefined | null,
	courier?: ValueTypes["StaffCreateCourierEntityRelationInput"] | undefined | null,
	cleaner?: ValueTypes["StaffCreateCleanerEntityRelationInput"] | undefined | null,
	shiftsManager?: ValueTypes["StaffCreateShiftsManagerEntityRelationInput"] | undefined | null,
	user?: ValueTypes["StaffCreateUserEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["StaffCreateShiftsProfileEntityRelationInput"] | undefined | null,
	stocksManager?: ValueTypes["StaffCreateStocksManagerEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["StaffCreatePhotoEntityRelationInput"] | undefined | null,
	courierManager?: ValueTypes["StaffCreateCourierManagerEntityRelationInput"] | undefined | null,
	picker?: ValueTypes["StaffCreatePickerEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	remunerationProfile?: ValueTypes["StaffCreateRemunerationProfileEntityRelationInput"] | undefined | null,
	cashier?: ValueTypes["StaffCreateCashierEntityRelationInput"] | undefined | null,
	venues?: Array<ValueTypes["StaffCreateVenuesEntityRelationInput"]> | undefined | null,
	internalBuyer?: ValueTypes["StaffCreateInternalBuyerEntityRelationInput"] | undefined | null,
	salesManager?: ValueTypes["StaffCreateSalesManagerEntityRelationInput"] | undefined | null,
	cashierManager?: ValueTypes["StaffCreateCashierManagerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StaffCreateUserEntityRelationInput"]: {
	connect?: ValueTypes["UserUniqueWhere"] | undefined | null,
	create?: ValueTypes["UserWithoutStaffCreateInput"] | undefined | null
};
	["UserWithoutStaffCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	internalNote?: string | undefined | null,
	customer?: ValueTypes["UserCreateCustomerEntityRelationInput"] | undefined | null,
	tenantPersonId?: ValueTypes["UUID"] | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	devices?: Array<ValueTypes["UserCreateDevicesEntityRelationInput"]> | undefined | null,
	verifiedAt?: ValueTypes["DateTime"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	deletionRequestedAt?: ValueTypes["DateTime"] | undefined | null,
	deletionExpectedAt?: ValueTypes["DateTime"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	meta?: ValueTypes["UserCreateMetaEntityRelationInput"] | undefined | null,
	identificationAttempts?: Array<ValueTypes["UserCreateIdentificationAttemptsEntityRelationInput"]> | undefined | null,
	roles?: ValueTypes["UserCreateRolesEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserCreateCustomerEntityRelationInput"]: {
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerWithoutUserCreateInput"] | undefined | null
};
	["CustomerWithoutUserCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	addresses?: Array<ValueTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerCreateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerCreateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerCreatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerCreateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerCreateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerCreateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerCreateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerCreateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerCreateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreateCartsEntityRelationInput"]: {
	connect?: ValueTypes["CartUniqueWhere"] | undefined | null,
	create?: ValueTypes["CartWithoutCustomerCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["CartWithoutCustomerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	confirmedAt?: ValueTypes["DateTime"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	items?: Array<ValueTypes["CartCreateItemsEntityRelationInput"]> | undefined | null,
	handle?: string | undefined | null,
	state?: ValueTypes["CartState"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	channel?: ValueTypes["CartCreateChannelEntityRelationInput"] | undefined | null,
	order?: ValueTypes["CartCreateOrderEntityRelationInput"] | undefined | null,
	deliveryAddress?: ValueTypes["CartCreateDeliveryAddressEntityRelationInput"] | undefined | null,
	billingAddress?: ValueTypes["CartCreateBillingAddressEntityRelationInput"] | undefined | null,
	deliveryOption?: string | undefined | null,
	paymentOption?: string | undefined | null,
	delivery?: ValueTypes["CartCreateDeliveryEntityRelationInput"] | undefined | null,
	payment?: ValueTypes["CartCreatePaymentEntityRelationInput"] | undefined | null,
	billingSubject?: ValueTypes["CartCreateBillingSubjectEntityRelationInput"] | undefined | null,
	priceLines?: Array<ValueTypes["CartCreatePriceLinesEntityRelationInput"]> | undefined | null,
	summary?: ValueTypes["CartCreateSummaryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CartCreateOrderEntityRelationInput"]: {
	connect?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	create?: ValueTypes["OrderWithoutCartCreateInput"] | undefined | null
};
	["OrderWithoutCartCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	state?: ValueTypes["OrderState"] | undefined | null,
	fulfilledAt?: ValueTypes["DateTime"] | undefined | null,
	canceledAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	customer?: ValueTypes["OrderCreateCustomerEntityRelationInput"] | undefined | null,
	channel?: ValueTypes["OrderCreateChannelEntityRelationInput"] | undefined | null,
	discounts?: Array<ValueTypes["OrderCreateDiscountsEntityRelationInput"]> | undefined | null,
	delivery?: ValueTypes["OrderCreateDeliveryEntityRelationInput"] | undefined | null,
	items?: Array<ValueTypes["OrderCreateItemsEntityRelationInput"]> | undefined | null,
	internalNote?: string | undefined | null,
	events?: Array<ValueTypes["OrderCreateEventsEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingAddress?: ValueTypes["OrderCreateBillingAddressEntityRelationInput"] | undefined | null,
	priceLines?: Array<ValueTypes["OrderCreatePriceLinesEntityRelationInput"]> | undefined | null,
	payments?: Array<ValueTypes["OrderCreatePaymentsEntityRelationInput"]> | undefined | null,
	seq?: number | undefined | null,
	billingSubject?: ValueTypes["OrderCreateBillingSubjectEntityRelationInput"] | undefined | null,
	summary?: ValueTypes["OrderCreateSummaryEntityRelationInput"] | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	gratuity?: ValueTypes["OrderCreateGratuityEntityRelationInput"] | undefined | null,
	venue?: ValueTypes["OrderCreateVenueEntityRelationInput"] | undefined | null,
	fulfillmentNote?: string | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["OrderCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	doubleshotTotalWeightGrams?: number | undefined | null,
	doubleShotLegacyNumber?: string | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	doubleshotAdminUrl?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderCreateCustomerEntityRelationInput"]: {
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerWithoutOrdersCreateInput"] | undefined | null
};
	["CustomerWithoutOrdersCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	addresses?: Array<ValueTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerCreateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerCreateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerCreatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerCreateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerCreateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerCreateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerCreateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerCreateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerCreateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerCreateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreateShortcutListEntityRelationInput"]: {
	connect?: ValueTypes["ApplicationShortcutListUniqueWhere"] | undefined | null,
	create?: ValueTypes["ApplicationShortcutListWithoutCustomerCreateInput"] | undefined | null
};
	["ApplicationShortcutListWithoutCustomerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: Array<ValueTypes["ApplicationShortcutListCreateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ApplicationShortcutListCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["ApplicationShortcutListItemUniqueWhere"] | undefined | null,
	create?: ValueTypes["ApplicationShortcutListItemWithoutListCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ApplicationShortcutListItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	application?: ValueTypes["ApplicationShortcutListItemCreateApplicationEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ApplicationShortcutListItemCreateApplicationEntityRelationInput"]: {
	connect?: ValueTypes["ApplicationUniqueWhere"] | undefined | null,
	create?: ValueTypes["ApplicationCreateInput"] | undefined | null
};
	["ApplicationUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	handle?: string | undefined | null,
	icon?: ValueTypes["ImageUniqueWhere"] | undefined | null
};
	["ApplicationCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	handle?: string | undefined | null,
	url?: string | undefined | null,
	color?: string | undefined | null,
	icon?: ValueTypes["ApplicationCreateIconEntityRelationInput"] | undefined | null,
	name?: string | undefined | null,
	short?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ApplicationCreateIconEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["CustomerCreateUserEntityRelationInput"]: {
	connect?: ValueTypes["UserUniqueWhere"] | undefined | null,
	create?: ValueTypes["UserWithoutCustomerCreateInput"] | undefined | null
};
	["UserWithoutCustomerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	internalNote?: string | undefined | null,
	staff?: ValueTypes["UserCreateStaffEntityRelationInput"] | undefined | null,
	tenantPersonId?: ValueTypes["UUID"] | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	devices?: Array<ValueTypes["UserCreateDevicesEntityRelationInput"]> | undefined | null,
	verifiedAt?: ValueTypes["DateTime"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	deletionRequestedAt?: ValueTypes["DateTime"] | undefined | null,
	deletionExpectedAt?: ValueTypes["DateTime"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	meta?: ValueTypes["UserCreateMetaEntityRelationInput"] | undefined | null,
	identificationAttempts?: Array<ValueTypes["UserCreateIdentificationAttemptsEntityRelationInput"]> | undefined | null,
	roles?: ValueTypes["UserCreateRolesEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserCreateStaffEntityRelationInput"]: {
	connect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	create?: ValueTypes["StaffWithoutUserCreateInput"] | undefined | null
};
	["StaffWithoutUserCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	bartender?: ValueTypes["StaffCreateBartenderEntityRelationInput"] | undefined | null,
	courier?: ValueTypes["StaffCreateCourierEntityRelationInput"] | undefined | null,
	cleaner?: ValueTypes["StaffCreateCleanerEntityRelationInput"] | undefined | null,
	shiftsManager?: ValueTypes["StaffCreateShiftsManagerEntityRelationInput"] | undefined | null,
	businessToBusinessManager?: ValueTypes["StaffCreateBusinessToBusinessManagerEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["StaffCreateShiftsProfileEntityRelationInput"] | undefined | null,
	stocksManager?: ValueTypes["StaffCreateStocksManagerEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["StaffCreatePhotoEntityRelationInput"] | undefined | null,
	courierManager?: ValueTypes["StaffCreateCourierManagerEntityRelationInput"] | undefined | null,
	picker?: ValueTypes["StaffCreatePickerEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	remunerationProfile?: ValueTypes["StaffCreateRemunerationProfileEntityRelationInput"] | undefined | null,
	cashier?: ValueTypes["StaffCreateCashierEntityRelationInput"] | undefined | null,
	venues?: Array<ValueTypes["StaffCreateVenuesEntityRelationInput"]> | undefined | null,
	internalBuyer?: ValueTypes["StaffCreateInternalBuyerEntityRelationInput"] | undefined | null,
	salesManager?: ValueTypes["StaffCreateSalesManagerEntityRelationInput"] | undefined | null,
	cashierManager?: ValueTypes["StaffCreateCashierManagerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StaffCreateShiftsProfileEntityRelationInput"]: {
	connect?: ValueTypes["ShiftsProfileUniqueWhere"] | undefined | null,
	create?: ValueTypes["ShiftsProfileWithoutStaffCreateInput"] | undefined | null
};
	["ShiftsProfileWithoutStaffCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	queueItems?: Array<ValueTypes["ShiftsProfileCreateQueueItemsEntityRelationInput"]> | undefined | null,
	roles?: Array<ValueTypes["ShiftsProfileCreateRolesEntityRelationInput"]> | undefined | null,
	shifts?: Array<ValueTypes["ShiftsProfileCreateShiftsEntityRelationInput"]> | undefined | null,
	allowSelfUnassigning?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ShiftsProfileCreateRolesEntityRelationInput"]: {
	connect?: ValueTypes["TimetableEmployeeRoleUniqueWhere"] | undefined | null,
	create?: ValueTypes["TimetableEmployeeRoleWithoutShiftsProfilesCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TimetableEmployeeRoleWithoutShiftsProfilesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	shiftGroups?: Array<ValueTypes["TimetableEmployeeRoleCreateShiftGroupsEntityRelationInput"]> | undefined | null,
	shiftsManagers?: Array<ValueTypes["TimetableEmployeeRoleCreateShiftsManagersEntityRelationInput"]> | undefined | null,
	name?: string | undefined | null,
	timetableTemplates?: Array<ValueTypes["TimetableEmployeeRoleCreateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	color?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableEmployeeRoleCreateShiftsManagersEntityRelationInput"]: {
	connect?: ValueTypes["ShiftsManagerUniqueWhere"] | undefined | null,
	create?: ValueTypes["ShiftsManagerWithoutManagedRolesCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ShiftsManagerWithoutManagedRolesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	staff?: ValueTypes["ShiftsManagerCreateStaffEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ShiftsManagerCreateStaffEntityRelationInput"]: {
	connect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	create?: ValueTypes["StaffWithoutShiftsManagerCreateInput"] | undefined | null
};
	["StaffWithoutShiftsManagerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	bartender?: ValueTypes["StaffCreateBartenderEntityRelationInput"] | undefined | null,
	courier?: ValueTypes["StaffCreateCourierEntityRelationInput"] | undefined | null,
	cleaner?: ValueTypes["StaffCreateCleanerEntityRelationInput"] | undefined | null,
	businessToBusinessManager?: ValueTypes["StaffCreateBusinessToBusinessManagerEntityRelationInput"] | undefined | null,
	user?: ValueTypes["StaffCreateUserEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["StaffCreateShiftsProfileEntityRelationInput"] | undefined | null,
	stocksManager?: ValueTypes["StaffCreateStocksManagerEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["StaffCreatePhotoEntityRelationInput"] | undefined | null,
	courierManager?: ValueTypes["StaffCreateCourierManagerEntityRelationInput"] | undefined | null,
	picker?: ValueTypes["StaffCreatePickerEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	remunerationProfile?: ValueTypes["StaffCreateRemunerationProfileEntityRelationInput"] | undefined | null,
	cashier?: ValueTypes["StaffCreateCashierEntityRelationInput"] | undefined | null,
	venues?: Array<ValueTypes["StaffCreateVenuesEntityRelationInput"]> | undefined | null,
	internalBuyer?: ValueTypes["StaffCreateInternalBuyerEntityRelationInput"] | undefined | null,
	salesManager?: ValueTypes["StaffCreateSalesManagerEntityRelationInput"] | undefined | null,
	cashierManager?: ValueTypes["StaffCreateCashierManagerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StaffCreateStocksManagerEntityRelationInput"]: {
	connect?: ValueTypes["StocksManagerUniqueWhere"] | undefined | null,
	create?: ValueTypes["StocksManagerWithoutStaffCreateInput"] | undefined | null
};
	["StocksManagerWithoutStaffCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	managedProducts?: Array<ValueTypes["StocksManagerCreateManagedProductsEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StocksManagerCreateManagedProductsEntityRelationInput"]: {
	connect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductWithoutManagerCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductWithoutManagerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	priceCents?: number | undefined | null,
	notDiscountable?: boolean | undefined | null,
	packing?: ValueTypes["ProductCreatePackingEntityRelationInput"] | undefined | null,
	recipe?: ValueTypes["ProductCreateRecipeEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["ProductCreateTagsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["ProductCreateCategoriesEntityRelationInput"]> | undefined | null,
	vatRate?: ValueTypes["ProductCreateVatRateEntityRelationInput"] | undefined | null,
	stocks?: Array<ValueTypes["ProductCreateStocksEntityRelationInput"]> | undefined | null,
	groupPrices?: Array<ValueTypes["ProductCreateGroupPricesEntityRelationInput"]> | undefined | null,
	image?: ValueTypes["ProductCreateImageEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	cartItems?: Array<ValueTypes["ProductCreateCartItemsEntityRelationInput"]> | undefined | null,
	availability?: ValueTypes["ProductAvailability"] | undefined | null,
	order?: number | undefined | null,
	orderItems?: Array<ValueTypes["ProductCreateOrderItemsEntityRelationInput"]> | undefined | null,
	maximumQuantityPerOrder?: number | undefined | null,
	inheritedCategories?: Array<ValueTypes["ProductCreateInheritedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["ProductCreateDeliveryZonesEntityRelationInput"]> | undefined | null,
	locales?: Array<ValueTypes["ProductCreateLocalesEntityRelationInput"]> | undefined | null,
	archivedAt?: ValueTypes["DateTime"] | undefined | null,
	customerPrices?: Array<ValueTypes["ProductCreateCustomerPricesEntityRelationInput"]> | undefined | null,
	virtualProduct?: ValueTypes["ProductCreateVirtualProductEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["ProductCreateMetaEntityRelationInput"] | undefined | null,
	page?: ValueTypes["ProductCreatePageEntityRelationInput"] | undefined | null,
	salesDays?: Array<ValueTypes["ProductCreateSalesDaysEntityRelationInput"]> | undefined | null,
	salesWeeks?: Array<ValueTypes["ProductCreateSalesWeeksEntityRelationInput"]> | undefined | null,
	salesMonths?: Array<ValueTypes["ProductCreateSalesMonthsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["ProductCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	hasSubscription?: boolean | undefined | null,
	pointOfSaleTileColor?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCreateOrderItemsEntityRelationInput"]: {
	connect?: ValueTypes["OrderItemUniqueWhere"] | undefined | null,
	create?: ValueTypes["OrderItemWithoutProductCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["OrderItemWithoutProductCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	unitPriceCents?: number | undefined | null,
	quantity?: number | undefined | null,
	vatRate?: ValueTypes["OrderItemCreateVatRateEntityRelationInput"] | undefined | null,
	order?: ValueTypes["OrderItemCreateOrderEntityRelationInput"] | undefined | null,
	virtualProductEffects?: Array<ValueTypes["OrderItemCreateVirtualProductEffectsEntityRelationInput"]> | undefined | null,
	pickedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["OrderItemCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderItemCreateVatRateEntityRelationInput"]: {
	connect?: ValueTypes["VatRateUniqueWhere"] | undefined | null,
	create?: ValueTypes["VatRateCreateInput"] | undefined | null
};
	["OrderItemCreateOrderEntityRelationInput"]: {
	connect?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	create?: ValueTypes["OrderWithoutItemsCreateInput"] | undefined | null
};
	["OrderWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	state?: ValueTypes["OrderState"] | undefined | null,
	fulfilledAt?: ValueTypes["DateTime"] | undefined | null,
	canceledAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	customer?: ValueTypes["OrderCreateCustomerEntityRelationInput"] | undefined | null,
	channel?: ValueTypes["OrderCreateChannelEntityRelationInput"] | undefined | null,
	discounts?: Array<ValueTypes["OrderCreateDiscountsEntityRelationInput"]> | undefined | null,
	delivery?: ValueTypes["OrderCreateDeliveryEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	cart?: ValueTypes["OrderCreateCartEntityRelationInput"] | undefined | null,
	events?: Array<ValueTypes["OrderCreateEventsEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingAddress?: ValueTypes["OrderCreateBillingAddressEntityRelationInput"] | undefined | null,
	priceLines?: Array<ValueTypes["OrderCreatePriceLinesEntityRelationInput"]> | undefined | null,
	payments?: Array<ValueTypes["OrderCreatePaymentsEntityRelationInput"]> | undefined | null,
	seq?: number | undefined | null,
	billingSubject?: ValueTypes["OrderCreateBillingSubjectEntityRelationInput"] | undefined | null,
	summary?: ValueTypes["OrderCreateSummaryEntityRelationInput"] | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	gratuity?: ValueTypes["OrderCreateGratuityEntityRelationInput"] | undefined | null,
	venue?: ValueTypes["OrderCreateVenueEntityRelationInput"] | undefined | null,
	fulfillmentNote?: string | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["OrderCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	doubleshotTotalWeightGrams?: number | undefined | null,
	doubleShotLegacyNumber?: string | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	doubleshotAdminUrl?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderCreateDiscountsEntityRelationInput"]: {
	connect?: ValueTypes["OrderDiscountUniqueWhere"] | undefined | null,
	create?: ValueTypes["OrderDiscountWithoutOrderCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["OrderDiscountWithoutOrderCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	discountCents?: number | undefined | null,
	vatRate?: ValueTypes["OrderDiscountCreateVatRateEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	type?: ValueTypes["OrderDiscountType"] | undefined | null,
	customerCreditTransactions?: Array<ValueTypes["OrderDiscountCreateCustomerCreditTransactionsEntityRelationInput"]> | undefined | null,
	voucherRedemption?: ValueTypes["OrderDiscountCreateVoucherRedemptionEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderDiscountCreateVatRateEntityRelationInput"]: {
	connect?: ValueTypes["VatRateUniqueWhere"] | undefined | null,
	create?: ValueTypes["VatRateCreateInput"] | undefined | null
};
	["OrderDiscountCreateCustomerCreditTransactionsEntityRelationInput"]: {
	connect?: ValueTypes["CustomerCreditTransactionUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerCreditTransactionWithoutOrderDiscountCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerCreditTransactionWithoutOrderDiscountCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	amountCents?: number | undefined | null,
	customerCredit?: ValueTypes["CustomerCreditTransactionCreateCustomerCreditEntityRelationInput"] | undefined | null,
	virtualProductEffect?: ValueTypes["CustomerCreditTransactionCreateVirtualProductEffectEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreditTransactionCreateCustomerCreditEntityRelationInput"]: {
	connect?: ValueTypes["CustomerCreditUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerCreditWithoutTransactionsCreateInput"] | undefined | null
};
	["CustomerCreditWithoutTransactionsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	initialCreditCents?: number | undefined | null,
	remainingCreditsCents?: number | undefined | null,
	expiresAt?: ValueTypes["DateTime"] | undefined | null,
	reason?: string | undefined | null,
	customer?: ValueTypes["CustomerCreditCreateCustomerEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["CustomerCreditCreateVatRateEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	voucherRedemption?: ValueTypes["CustomerCreditCreateVoucherRedemptionEntityRelationInput"] | undefined | null,
	invoiceUrl?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreditCreateCustomerEntityRelationInput"]: {
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerWithoutCreditsCreateInput"] | undefined | null
};
	["CustomerWithoutCreditsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	addresses?: Array<ValueTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerCreateTagsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerCreateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerCreatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerCreateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerCreateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerCreateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerCreateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerCreateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerCreateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerCreateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreateChannelsEntityRelationInput"]: {
	connect?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	create?: ValueTypes["ChannelWithoutCustomersCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ChannelWithoutCustomersCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	disabled?: boolean | undefined | null,
	payments?: Array<ValueTypes["ChannelCreatePaymentsEntityRelationInput"]> | undefined | null,
	deliveries?: Array<ValueTypes["ChannelCreateDeliveriesEntityRelationInput"]> | undefined | null,
	pointOfSales?: Array<ValueTypes["ChannelCreatePointOfSalesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["ChannelCreateCartsEntityRelationInput"]> | undefined | null,
	code?: ValueTypes["ChannelCode"] | undefined | null,
	addTagsOnRegistration?: Array<ValueTypes["ChannelCreateAddTagsOnRegistrationEntityRelationInput"]> | undefined | null,
	publicTags?: Array<ValueTypes["ChannelCreatePublicTagsEntityRelationInput"]> | undefined | null,
	venue?: ValueTypes["ChannelCreateVenueEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ChannelCreatePublicTagsEntityRelationInput"]: {
	connect?: ValueTypes["TagUniqueWhere"] | undefined | null,
	create?: ValueTypes["TagWithoutPublicInChannelsCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TagWithoutPublicInChannelsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	customers?: Array<ValueTypes["TagCreateCustomersEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["TagCreateProductsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["TagCreateCategoriesEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	addTagsOnRegistration?: Array<ValueTypes["TagCreateAddTagsOnRegistrationEntityRelationInput"]> | undefined | null,
	nestedCategories?: Array<ValueTypes["TagCreateNestedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["TagCreateDeliveryZonesEntityRelationInput"]> | undefined | null,
	allowChannelPayments?: Array<ValueTypes["TagCreateAllowChannelPaymentsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["TagCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TagCreateAllowChannelPaymentsEntityRelationInput"]: {
	connect?: ValueTypes["ChannelPaymentUniqueWhere"] | undefined | null,
	create?: ValueTypes["ChannelPaymentWithoutAllowOnlyForTagsCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ChannelPaymentWithoutAllowOnlyForTagsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	channel?: ValueTypes["ChannelPaymentCreateChannelEntityRelationInput"] | undefined | null,
	method?: ValueTypes["ChannelPaymentCreateMethodEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["ChannelPaymentCreateVatRateEntityRelationInput"] | undefined | null,
	requireBillingAddress?: boolean | undefined | null,
	provideReceipt?: boolean | undefined | null,
	requireBillingSubject?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ChannelPaymentCreateVatRateEntityRelationInput"]: {
	connect?: ValueTypes["VatRateUniqueWhere"] | undefined | null,
	create?: ValueTypes["VatRateWithoutChannelPaymentsCreateInput"] | undefined | null
};
	["VatRateWithoutChannelPaymentsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	ratePermille?: number | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	channelDeliveries?: Array<ValueTypes["VatRateCreateChannelDeliveriesEntityRelationInput"]> | undefined | null,
	preset?: ValueTypes["VatRatePreset"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TagCreateFulfillmentNotesEntityRelationInput"]: {
	connect?: ValueTypes["FulfillmentNoteUniqueWhere"] | undefined | null,
	create?: ValueTypes["FulfillmentNoteWithoutTagsCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["FulfillmentNoteUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["FulfillmentNoteWithoutTagsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	note?: string | undefined | null,
	products?: Array<ValueTypes["FulfillmentNoteCreateProductsEntityRelationInput"]> | undefined | null,
	venues?: Array<ValueTypes["FulfillmentNoteCreateVenuesEntityRelationInput"]> | undefined | null,
	cartItems?: Array<ValueTypes["FulfillmentNoteCreateCartItemsEntityRelationInput"]> | undefined | null,
	orderItems?: Array<ValueTypes["FulfillmentNoteCreateOrderItemsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["FulfillmentNoteCreateOrdersEntityRelationInput"]> | undefined | null,
	highlight?: boolean | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	emoji?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FulfillmentNoteCreateProductsEntityRelationInput"]: {
	connect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductWithoutFulfillmentNotesCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductWithoutFulfillmentNotesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	priceCents?: number | undefined | null,
	notDiscountable?: boolean | undefined | null,
	packing?: ValueTypes["ProductCreatePackingEntityRelationInput"] | undefined | null,
	recipe?: ValueTypes["ProductCreateRecipeEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["ProductCreateTagsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["ProductCreateCategoriesEntityRelationInput"]> | undefined | null,
	vatRate?: ValueTypes["ProductCreateVatRateEntityRelationInput"] | undefined | null,
	stocks?: Array<ValueTypes["ProductCreateStocksEntityRelationInput"]> | undefined | null,
	groupPrices?: Array<ValueTypes["ProductCreateGroupPricesEntityRelationInput"]> | undefined | null,
	image?: ValueTypes["ProductCreateImageEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	cartItems?: Array<ValueTypes["ProductCreateCartItemsEntityRelationInput"]> | undefined | null,
	availability?: ValueTypes["ProductAvailability"] | undefined | null,
	order?: number | undefined | null,
	manager?: ValueTypes["ProductCreateManagerEntityRelationInput"] | undefined | null,
	orderItems?: Array<ValueTypes["ProductCreateOrderItemsEntityRelationInput"]> | undefined | null,
	maximumQuantityPerOrder?: number | undefined | null,
	inheritedCategories?: Array<ValueTypes["ProductCreateInheritedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["ProductCreateDeliveryZonesEntityRelationInput"]> | undefined | null,
	locales?: Array<ValueTypes["ProductCreateLocalesEntityRelationInput"]> | undefined | null,
	archivedAt?: ValueTypes["DateTime"] | undefined | null,
	customerPrices?: Array<ValueTypes["ProductCreateCustomerPricesEntityRelationInput"]> | undefined | null,
	virtualProduct?: ValueTypes["ProductCreateVirtualProductEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["ProductCreateMetaEntityRelationInput"] | undefined | null,
	page?: ValueTypes["ProductCreatePageEntityRelationInput"] | undefined | null,
	salesDays?: Array<ValueTypes["ProductCreateSalesDaysEntityRelationInput"]> | undefined | null,
	salesWeeks?: Array<ValueTypes["ProductCreateSalesWeeksEntityRelationInput"]> | undefined | null,
	salesMonths?: Array<ValueTypes["ProductCreateSalesMonthsEntityRelationInput"]> | undefined | null,
	hasSubscription?: boolean | undefined | null,
	pointOfSaleTileColor?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCreateInheritedCategoriesEntityRelationInput"]: {
	connect?: ValueTypes["NestedProductCategoryProductUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductCreateDeliveryZonesEntityRelationInput"]: {
	connect?: ValueTypes["DeliveryZoneUniqueWhere"] | undefined | null,
	create?: ValueTypes["DeliveryZoneWithoutDeliveryZonesOfProductsCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["DeliveryZoneWithoutDeliveryZonesOfProductsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	type?: ValueTypes["DeliveryZoneType"] | undefined | null,
	addresses?: Array<ValueTypes["DeliveryZoneCreateAddressesEntityRelationInput"]> | undefined | null,
	suitableDeliveryMethods?: Array<ValueTypes["DeliveryZoneCreateSuitableDeliveryMethodsEntityRelationInput"]> | undefined | null,
	deliveryZonesOfTags?: Array<ValueTypes["DeliveryZoneCreateDeliveryZonesOfTagsEntityRelationInput"]> | undefined | null,
	addressesMetadata?: Array<ValueTypes["DeliveryZoneCreateAddressesMetadataEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryZoneCreateDeliveryZonesOfTagsEntityRelationInput"]: {
	connect?: ValueTypes["TagUniqueWhere"] | undefined | null,
	create?: ValueTypes["TagWithoutDeliveryZonesCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TagWithoutDeliveryZonesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	customers?: Array<ValueTypes["TagCreateCustomersEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["TagCreateProductsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["TagCreateCategoriesEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	addTagsOnRegistration?: Array<ValueTypes["TagCreateAddTagsOnRegistrationEntityRelationInput"]> | undefined | null,
	nestedCategories?: Array<ValueTypes["TagCreateNestedCategoriesEntityRelationInput"]> | undefined | null,
	publicInChannels?: Array<ValueTypes["TagCreatePublicInChannelsEntityRelationInput"]> | undefined | null,
	allowChannelPayments?: Array<ValueTypes["TagCreateAllowChannelPaymentsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["TagCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TagCreatePublicInChannelsEntityRelationInput"]: {
	connect?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	create?: ValueTypes["ChannelWithoutPublicTagsCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ChannelWithoutPublicTagsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	disabled?: boolean | undefined | null,
	payments?: Array<ValueTypes["ChannelCreatePaymentsEntityRelationInput"]> | undefined | null,
	deliveries?: Array<ValueTypes["ChannelCreateDeliveriesEntityRelationInput"]> | undefined | null,
	pointOfSales?: Array<ValueTypes["ChannelCreatePointOfSalesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["ChannelCreateCartsEntityRelationInput"]> | undefined | null,
	customers?: Array<ValueTypes["ChannelCreateCustomersEntityRelationInput"]> | undefined | null,
	code?: ValueTypes["ChannelCode"] | undefined | null,
	addTagsOnRegistration?: Array<ValueTypes["ChannelCreateAddTagsOnRegistrationEntityRelationInput"]> | undefined | null,
	venue?: ValueTypes["ChannelCreateVenueEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ChannelCreateVenueEntityRelationInput"]: {
	connect?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	create?: ValueTypes["VenueWithoutChannelsCreateInput"] | undefined | null
};
	["VenueWithoutChannelsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	deadlineTemplate?: ValueTypes["VenueCreateDeadlineTemplateEntityRelationInput"] | undefined | null,
	timetableDays?: Array<ValueTypes["VenueCreateTimetableDaysEntityRelationInput"]> | undefined | null,
	timetableTemplates?: Array<ValueTypes["VenueCreateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	staffMembers?: Array<ValueTypes["VenueCreateStaffMembersEntityRelationInput"]> | undefined | null,
	employeeRoles?: Array<ValueTypes["VenueCreateEmployeeRolesEntityRelationInput"]> | undefined | null,
	pointOfSaleApplicationDevices?: Array<ValueTypes["VenueCreatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined | null,
	pointOfSaleTerminals?: Array<ValueTypes["VenueCreatePointOfSaleTerminalsEntityRelationInput"]> | undefined | null,
	pointOfSalePrinters?: Array<ValueTypes["VenueCreatePointOfSalePrintersEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["VenueCreateOrdersEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["VenueCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	areas?: Array<ValueTypes["VenueCreateAreasEntityRelationInput"]> | undefined | null,
	enabledUnassignReasons?: Array<ValueTypes["VenueCreateEnabledUnassignReasonsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["VenueCreateCategoriesEntityRelationInput"]> | undefined | null,
	address?: string | undefined | null,
	pointOfSalePngBase64ReceiptLogo?: string | undefined | null,
	pointOfSaleInitialView?: ValueTypes["PointOfSaleInitialView"] | undefined | null,
	pointOfSalePreferPrintReceipt?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VenueCreateDeadlineTemplateEntityRelationInput"]: {
	connect?: ValueTypes["DeadlineTemplateUniqueWhere"] | undefined | null,
	create?: ValueTypes["DeadlineTemplateWithoutVenueCreateInput"] | undefined | null
};
	["DeadlineTemplateWithoutVenueCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	startDate?: ValueTypes["Date"] | undefined | null,
	period?: number | undefined | null,
	cutoff?: number | undefined | null,
	closed?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VenueCreateTimetableDaysEntityRelationInput"]: {
	connect?: ValueTypes["TimetableDayUniqueWhere"] | undefined | null,
	create?: ValueTypes["TimetableDayWithoutVenueCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TimetableDayWithoutVenueCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	date?: ValueTypes["Date"] | undefined | null,
	type?: ValueTypes["TimetableDayType"] | undefined | null,
	shiftGroups?: Array<ValueTypes["TimetableDayCreateShiftGroupsEntityRelationInput"]> | undefined | null,
	tipsCents?: number | undefined | null,
	notes?: Array<ValueTypes["TimetableDayCreateNotesEntityRelationInput"]> | undefined | null,
	meta?: ValueTypes["TimetableDayCreateMetaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableDayCreateShiftGroupsEntityRelationInput"]: {
	connect?: ValueTypes["TimetableShiftGroupUniqueWhere"] | undefined | null,
	create?: ValueTypes["TimetableShiftGroupWithoutDayCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TimetableShiftGroupWithoutDayCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	shifts?: Array<ValueTypes["TimetableShiftGroupCreateShiftsEntityRelationInput"]> | undefined | null,
	type?: ValueTypes["TimetableShiftGroupCreateTypeEntityRelationInput"] | undefined | null,
	position?: ValueTypes["TimetableShiftGroupCreatePositionEntityRelationInput"] | undefined | null,
	queue?: ValueTypes["TimetableShiftGroupCreateQueueEntityRelationInput"] | undefined | null,
	generatedByTemplate?: ValueTypes["TimetableShiftGroupCreateGeneratedByTemplateEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableShiftGroupCreateTypeEntityRelationInput"]: {
	connect?: ValueTypes["TimetableEmployeeRoleUniqueWhere"] | undefined | null,
	create?: ValueTypes["TimetableEmployeeRoleWithoutShiftGroupsCreateInput"] | undefined | null
};
	["TimetableEmployeeRoleWithoutShiftGroupsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	shiftsProfiles?: Array<ValueTypes["TimetableEmployeeRoleCreateShiftsProfilesEntityRelationInput"]> | undefined | null,
	shiftsManagers?: Array<ValueTypes["TimetableEmployeeRoleCreateShiftsManagersEntityRelationInput"]> | undefined | null,
	name?: string | undefined | null,
	timetableTemplates?: Array<ValueTypes["TimetableEmployeeRoleCreateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	color?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableEmployeeRoleCreateTimetableTemplatesEntityRelationInput"]: {
	connect?: ValueTypes["TimetableTemplateUniqueWhere"] | undefined | null,
	create?: ValueTypes["TimetableTemplateWithoutEmployeeRoleCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TimetableTemplateWithoutEmployeeRoleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	startDate?: ValueTypes["Date"] | undefined | null,
	period?: number | undefined | null,
	slots?: number | undefined | null,
	position?: ValueTypes["TimetableTemplateCreatePositionEntityRelationInput"] | undefined | null,
	staffOptions?: Array<ValueTypes["TimetableTemplateCreateStaffOptionsEntityRelationInput"]> | undefined | null,
	internalName?: string | undefined | null,
	venue?: ValueTypes["TimetableTemplateCreateVenueEntityRelationInput"] | undefined | null,
	workdaysOnly?: boolean | undefined | null,
	monday?: boolean | undefined | null,
	tuesday?: boolean | undefined | null,
	wednesday?: boolean | undefined | null,
	thursday?: boolean | undefined | null,
	friday?: boolean | undefined | null,
	saturday?: boolean | undefined | null,
	sunday?: boolean | undefined | null,
	type?: ValueTypes["TemplateType"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableTemplateCreatePositionEntityRelationInput"]: {
	connect?: ValueTypes["TimetableShiftPositionUniqueWhere"] | undefined | null,
	create?: ValueTypes["TimetableShiftPositionWithoutTimetableTemplatesCreateInput"] | undefined | null
};
	["TimetableShiftPositionUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	shiftGroups?: ValueTypes["TimetableShiftGroupUniqueWhere"] | undefined | null,
	timetableTemplates?: ValueTypes["TimetableTemplateUniqueWhere"] | undefined | null
};
	["TimetableShiftPositionWithoutTimetableTemplatesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	start?: string | undefined | null,
	end?: string | undefined | null,
	shiftGroups?: Array<ValueTypes["TimetableShiftPositionCreateShiftGroupsEntityRelationInput"]> | undefined | null,
	isDynamic?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableShiftPositionCreateShiftGroupsEntityRelationInput"]: {
	connect?: ValueTypes["TimetableShiftGroupUniqueWhere"] | undefined | null,
	create?: ValueTypes["TimetableShiftGroupWithoutPositionCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TimetableShiftGroupWithoutPositionCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	shifts?: Array<ValueTypes["TimetableShiftGroupCreateShiftsEntityRelationInput"]> | undefined | null,
	day?: ValueTypes["TimetableShiftGroupCreateDayEntityRelationInput"] | undefined | null,
	type?: ValueTypes["TimetableShiftGroupCreateTypeEntityRelationInput"] | undefined | null,
	queue?: ValueTypes["TimetableShiftGroupCreateQueueEntityRelationInput"] | undefined | null,
	generatedByTemplate?: ValueTypes["TimetableShiftGroupCreateGeneratedByTemplateEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableShiftGroupCreateQueueEntityRelationInput"]: {
	connect?: ValueTypes["EmployeeQueueUniqueWhere"] | undefined | null,
	create?: ValueTypes["EmployeeQueueWithoutShiftGroupCreateInput"] | undefined | null
};
	["EmployeeQueueWithoutShiftGroupCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: Array<ValueTypes["EmployeeQueueCreateItemsEntityRelationInput"]> | undefined | null,
	contemberBugFix?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["EmployeeQueueCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["EmployeeQueueItemUniqueWhere"] | undefined | null,
	create?: ValueTypes["EmployeeQueueItemWithoutQueueCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["EmployeeQueueItemWithoutQueueCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	start?: string | undefined | null,
	end?: string | undefined | null,
	shiftsProfile?: ValueTypes["EmployeeQueueItemCreateShiftsProfileEntityRelationInput"] | undefined | null,
	shift?: ValueTypes["EmployeeQueueItemCreateShiftEntityRelationInput"] | undefined | null,
	unassignInfo?: ValueTypes["EmployeeQueueItemCreateUnassignInfoEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["EmployeeQueueItemCreateMetaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["EmployeeQueueItemCreateShiftsProfileEntityRelationInput"]: {
	connect?: ValueTypes["ShiftsProfileUniqueWhere"] | undefined | null,
	create?: ValueTypes["ShiftsProfileWithoutQueueItemsCreateInput"] | undefined | null
};
	["ShiftsProfileWithoutQueueItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	staff?: ValueTypes["ShiftsProfileCreateStaffEntityRelationInput"] | undefined | null,
	roles?: Array<ValueTypes["ShiftsProfileCreateRolesEntityRelationInput"]> | undefined | null,
	shifts?: Array<ValueTypes["ShiftsProfileCreateShiftsEntityRelationInput"]> | undefined | null,
	allowSelfUnassigning?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ShiftsProfileCreateShiftsEntityRelationInput"]: {
	connect?: ValueTypes["TimetableShiftUniqueWhere"] | undefined | null,
	create?: ValueTypes["TimetableShiftWithoutShiftsProfileCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TimetableShiftWithoutShiftsProfileCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	locked?: boolean | undefined | null,
	order?: number | undefined | null,
	assigned?: ValueTypes["Date"] | undefined | null,
	group?: ValueTypes["TimetableShiftCreateGroupEntityRelationInput"] | undefined | null,
	queueItem?: ValueTypes["TimetableShiftCreateQueueItemEntityRelationInput"] | undefined | null,
	swapInfo?: ValueTypes["TimetableShiftCreateSwapInfoEntityRelationInput"] | undefined | null,
	isOvertime?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableShiftCreateGroupEntityRelationInput"]: {
	connect?: ValueTypes["TimetableShiftGroupUniqueWhere"] | undefined | null,
	create?: ValueTypes["TimetableShiftGroupWithoutShiftsCreateInput"] | undefined | null
};
	["TimetableShiftGroupWithoutShiftsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	day?: ValueTypes["TimetableShiftGroupCreateDayEntityRelationInput"] | undefined | null,
	type?: ValueTypes["TimetableShiftGroupCreateTypeEntityRelationInput"] | undefined | null,
	position?: ValueTypes["TimetableShiftGroupCreatePositionEntityRelationInput"] | undefined | null,
	queue?: ValueTypes["TimetableShiftGroupCreateQueueEntityRelationInput"] | undefined | null,
	generatedByTemplate?: ValueTypes["TimetableShiftGroupCreateGeneratedByTemplateEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableShiftGroupCreatePositionEntityRelationInput"]: {
	connect?: ValueTypes["TimetableShiftPositionUniqueWhere"] | undefined | null,
	create?: ValueTypes["TimetableShiftPositionWithoutShiftGroupsCreateInput"] | undefined | null
};
	["TimetableShiftPositionWithoutShiftGroupsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	start?: string | undefined | null,
	end?: string | undefined | null,
	timetableTemplates?: Array<ValueTypes["TimetableShiftPositionCreateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	isDynamic?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableShiftPositionCreateTimetableTemplatesEntityRelationInput"]: {
	connect?: ValueTypes["TimetableTemplateUniqueWhere"] | undefined | null,
	create?: ValueTypes["TimetableTemplateWithoutPositionCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TimetableTemplateWithoutPositionCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	startDate?: ValueTypes["Date"] | undefined | null,
	period?: number | undefined | null,
	slots?: number | undefined | null,
	staffOptions?: Array<ValueTypes["TimetableTemplateCreateStaffOptionsEntityRelationInput"]> | undefined | null,
	internalName?: string | undefined | null,
	venue?: ValueTypes["TimetableTemplateCreateVenueEntityRelationInput"] | undefined | null,
	employeeRole?: ValueTypes["TimetableTemplateCreateEmployeeRoleEntityRelationInput"] | undefined | null,
	workdaysOnly?: boolean | undefined | null,
	monday?: boolean | undefined | null,
	tuesday?: boolean | undefined | null,
	wednesday?: boolean | undefined | null,
	thursday?: boolean | undefined | null,
	friday?: boolean | undefined | null,
	saturday?: boolean | undefined | null,
	sunday?: boolean | undefined | null,
	type?: ValueTypes["TemplateType"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableTemplateCreateStaffOptionsEntityRelationInput"]: {
	connect?: ValueTypes["TimetableTemplateStaffOptionsUniqueWhere"] | undefined | null,
	create?: ValueTypes["TimetableTemplateStaffOptionsWithoutTimetableTemplateCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TimetableTemplateStaffOptionsWithoutTimetableTemplateCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	startTime?: string | undefined | null,
	endTime?: string | undefined | null,
	autoAssignedEmployee?: ValueTypes["TimetableTemplateStaffOptionsCreateAutoAssignedEmployeeEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableTemplateStaffOptionsCreateAutoAssignedEmployeeEntityRelationInput"]: {
	connect?: ValueTypes["ShiftsProfileUniqueWhere"] | undefined | null,
	create?: ValueTypes["ShiftsProfileCreateInput"] | undefined | null
};
	["ShiftsProfileCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	queueItems?: Array<ValueTypes["ShiftsProfileCreateQueueItemsEntityRelationInput"]> | undefined | null,
	staff?: ValueTypes["ShiftsProfileCreateStaffEntityRelationInput"] | undefined | null,
	roles?: Array<ValueTypes["ShiftsProfileCreateRolesEntityRelationInput"]> | undefined | null,
	shifts?: Array<ValueTypes["ShiftsProfileCreateShiftsEntityRelationInput"]> | undefined | null,
	allowSelfUnassigning?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableTemplateCreateVenueEntityRelationInput"]: {
	connect?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	create?: ValueTypes["VenueWithoutTimetableTemplatesCreateInput"] | undefined | null
};
	["VenueWithoutTimetableTemplatesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	deadlineTemplate?: ValueTypes["VenueCreateDeadlineTemplateEntityRelationInput"] | undefined | null,
	timetableDays?: Array<ValueTypes["VenueCreateTimetableDaysEntityRelationInput"]> | undefined | null,
	staffMembers?: Array<ValueTypes["VenueCreateStaffMembersEntityRelationInput"]> | undefined | null,
	employeeRoles?: Array<ValueTypes["VenueCreateEmployeeRolesEntityRelationInput"]> | undefined | null,
	pointOfSaleApplicationDevices?: Array<ValueTypes["VenueCreatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined | null,
	pointOfSaleTerminals?: Array<ValueTypes["VenueCreatePointOfSaleTerminalsEntityRelationInput"]> | undefined | null,
	pointOfSalePrinters?: Array<ValueTypes["VenueCreatePointOfSalePrintersEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["VenueCreateOrdersEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["VenueCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	areas?: Array<ValueTypes["VenueCreateAreasEntityRelationInput"]> | undefined | null,
	enabledUnassignReasons?: Array<ValueTypes["VenueCreateEnabledUnassignReasonsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["VenueCreateCategoriesEntityRelationInput"]> | undefined | null,
	channels?: Array<ValueTypes["VenueCreateChannelsEntityRelationInput"]> | undefined | null,
	address?: string | undefined | null,
	pointOfSalePngBase64ReceiptLogo?: string | undefined | null,
	pointOfSaleInitialView?: ValueTypes["PointOfSaleInitialView"] | undefined | null,
	pointOfSalePreferPrintReceipt?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VenueCreateStaffMembersEntityRelationInput"]: {
	connect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	create?: ValueTypes["StaffWithoutVenuesCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["StaffWithoutVenuesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	bartender?: ValueTypes["StaffCreateBartenderEntityRelationInput"] | undefined | null,
	courier?: ValueTypes["StaffCreateCourierEntityRelationInput"] | undefined | null,
	cleaner?: ValueTypes["StaffCreateCleanerEntityRelationInput"] | undefined | null,
	shiftsManager?: ValueTypes["StaffCreateShiftsManagerEntityRelationInput"] | undefined | null,
	businessToBusinessManager?: ValueTypes["StaffCreateBusinessToBusinessManagerEntityRelationInput"] | undefined | null,
	user?: ValueTypes["StaffCreateUserEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["StaffCreateShiftsProfileEntityRelationInput"] | undefined | null,
	stocksManager?: ValueTypes["StaffCreateStocksManagerEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["StaffCreatePhotoEntityRelationInput"] | undefined | null,
	courierManager?: ValueTypes["StaffCreateCourierManagerEntityRelationInput"] | undefined | null,
	picker?: ValueTypes["StaffCreatePickerEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	remunerationProfile?: ValueTypes["StaffCreateRemunerationProfileEntityRelationInput"] | undefined | null,
	cashier?: ValueTypes["StaffCreateCashierEntityRelationInput"] | undefined | null,
	internalBuyer?: ValueTypes["StaffCreateInternalBuyerEntityRelationInput"] | undefined | null,
	salesManager?: ValueTypes["StaffCreateSalesManagerEntityRelationInput"] | undefined | null,
	cashierManager?: ValueTypes["StaffCreateCashierManagerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StaffCreatePhotoEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["StaffCreateCourierManagerEntityRelationInput"]: {
	connect?: ValueTypes["CourierManagerUniqueWhere"] | undefined | null,
	create?: ValueTypes["CourierManagerWithoutStaffCreateInput"] | undefined | null
};
	["CourierManagerWithoutStaffCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StaffCreatePickerEntityRelationInput"]: {
	connect?: ValueTypes["PickerUniqueWhere"] | undefined | null,
	create?: ValueTypes["PickerWithoutStaffCreateInput"] | undefined | null
};
	["PickerWithoutStaffCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StaffCreateRemunerationProfileEntityRelationInput"]: {
	connect?: ValueTypes["RemunerationProfileUniqueWhere"] | undefined | null,
	create?: ValueTypes["RemunerationProfileWithoutStaffCreateInput"] | undefined | null
};
	["RemunerationProfileWithoutStaffCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	employmentInformation?: Array<ValueTypes["RemunerationProfileCreateEmploymentInformationEntityRelationInput"]> | undefined | null,
	workMonths?: ValueTypes["RemunerationProfileCreateWorkMonthsEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RemunerationProfileCreateEmploymentInformationEntityRelationInput"]: {
	connect?: ValueTypes["EmploymentInformationUniqueWhere"] | undefined | null,
	create?: ValueTypes["EmploymentInformationWithoutRemunerationProfilesCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["EmploymentInformationWithoutRemunerationProfilesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	hourlyRate?: number | undefined | null,
	monthlySalary?: number | undefined | null,
	type?: ValueTypes["EmploymentType"] | undefined | null,
	name?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RemunerationProfileCreateWorkMonthsEntityRelationInput"]: {
	connect?: ValueTypes["WorkMonthUniqueWhere"] | undefined | null,
	create?: ValueTypes["WorkMonthWithoutRemunerationProfileCreateInput"] | undefined | null
};
	["WorkMonthUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	remunerationProfile?: ValueTypes["RemunerationProfileUniqueWhere"] | undefined | null
};
	["WorkMonthWithoutRemunerationProfileCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	year?: number | undefined | null,
	month?: number | undefined | null,
	hoursWorked?: number | undefined | null,
	billableHours?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StaffCreateCashierEntityRelationInput"]: {
	connect?: ValueTypes["CashierUniqueWhere"] | undefined | null,
	create?: ValueTypes["CashierWithoutStaffCreateInput"] | undefined | null
};
	["CashierWithoutStaffCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StaffCreateInternalBuyerEntityRelationInput"]: {
	connect?: ValueTypes["InternalBuyerUniqueWhere"] | undefined | null,
	create?: ValueTypes["InternalBuyerWithoutStaffCreateInput"] | undefined | null
};
	["InternalBuyerWithoutStaffCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StaffCreateSalesManagerEntityRelationInput"]: {
	connect?: ValueTypes["SalesManagerUniqueWhere"] | undefined | null,
	create?: ValueTypes["SalesManagerWithoutStaffCreateInput"] | undefined | null
};
	["SalesManagerWithoutStaffCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	countries?: Array<ValueTypes["SalesManagerCreateCountriesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SalesManagerCreateCountriesEntityRelationInput"]: {
	connect?: ValueTypes["CountryUniqueWhere"] | undefined | null,
	create?: ValueTypes["CountryCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["StaffCreateCashierManagerEntityRelationInput"]: {
	connect?: ValueTypes["CashierManagerUniqueWhere"] | undefined | null,
	create?: ValueTypes["CashierManagerWithoutStaffCreateInput"] | undefined | null
};
	["CashierManagerWithoutStaffCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VenueCreateEmployeeRolesEntityRelationInput"]: {
	connect?: ValueTypes["VenueEmployeeRoleUniqueWhere"] | undefined | null,
	create?: ValueTypes["VenueEmployeeRoleWithoutVenueCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["VenueEmployeeRoleWithoutVenueCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	employeePrivileges?: ValueTypes["VenueEmployeeRoleCreateEmployeePrivilegesEntityRelationInput"] | undefined | null,
	role?: ValueTypes["VenueEmployeeRoleCreateRoleEntityRelationInput"] | undefined | null,
	getsTipsShare?: boolean | undefined | null,
	notesEnabled?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VenueEmployeeRoleCreateEmployeePrivilegesEntityRelationInput"]: {
	connect?: ValueTypes["TimetablesEmployeePrivilegesUniqueWhere"] | undefined | null,
	create?: ValueTypes["TimetablesEmployeePrivilegesWithoutVenueEmployeeRoleCreateInput"] | undefined | null
};
	["TimetablesEmployeePrivilegesWithoutVenueEmployeeRoleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	read?: boolean | undefined | null,
	unassign?: boolean | undefined | null,
	assign?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VenueEmployeeRoleCreateRoleEntityRelationInput"]: {
	connect?: ValueTypes["TimetableEmployeeRoleUniqueWhere"] | undefined | null,
	create?: ValueTypes["TimetableEmployeeRoleCreateInput"] | undefined | null
};
	["VenueCreatePointOfSaleApplicationDevicesEntityRelationInput"]: {
	connect?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null,
	create?: ValueTypes["PointOfSaleApplicationDeviceWithoutVenueCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PointOfSaleApplicationDeviceWithoutVenueCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	internalName?: string | undefined | null,
	note?: string | undefined | null,
	identificationCode?: ValueTypes["PointOfSaleApplicationDeviceCreateIdentificationCodeEntityRelationInput"] | undefined | null,
	identifier?: ValueTypes["PointOfSaleApplicationDeviceCreateIdentifierEntityRelationInput"] | undefined | null,
	terminal?: ValueTypes["PointOfSaleApplicationDeviceCreateTerminalEntityRelationInput"] | undefined | null,
	receiptPrinter?: ValueTypes["PointOfSaleApplicationDeviceCreateReceiptPrinterEntityRelationInput"] | undefined | null,
	ticketPrinters?: Array<ValueTypes["PointOfSaleApplicationDeviceCreateTicketPrintersEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleApplicationDeviceCreateIdentificationCodeEntityRelationInput"]: {
	connect?: ValueTypes["IdentificationCodeUniqueWhere"] | undefined | null,
	create?: ValueTypes["IdentificationCodeWithoutApplicationDevicesCreateInput"] | undefined | null
};
	["IdentificationCodeWithoutApplicationDevicesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	attempts?: Array<ValueTypes["IdentificationCodeCreateAttemptsEntityRelationInput"]> | undefined | null,
	locales?: Array<ValueTypes["IdentificationCodeCreateLocalesEntityRelationInput"]> | undefined | null,
	internalName?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IdentificationCodeCreateAttemptsEntityRelationInput"]: {
	connect?: ValueTypes["IdentificationAttemptUniqueWhere"] | undefined | null,
	create?: ValueTypes["IdentificationAttemptWithoutCodeCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["IdentificationAttemptWithoutCodeCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	user?: ValueTypes["IdentificationAttemptCreateUserEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IdentificationAttemptCreateUserEntityRelationInput"]: {
	connect?: ValueTypes["UserUniqueWhere"] | undefined | null,
	create?: ValueTypes["UserWithoutIdentificationAttemptsCreateInput"] | undefined | null
};
	["UserWithoutIdentificationAttemptsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	internalNote?: string | undefined | null,
	staff?: ValueTypes["UserCreateStaffEntityRelationInput"] | undefined | null,
	customer?: ValueTypes["UserCreateCustomerEntityRelationInput"] | undefined | null,
	tenantPersonId?: ValueTypes["UUID"] | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	devices?: Array<ValueTypes["UserCreateDevicesEntityRelationInput"]> | undefined | null,
	verifiedAt?: ValueTypes["DateTime"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	deletionRequestedAt?: ValueTypes["DateTime"] | undefined | null,
	deletionExpectedAt?: ValueTypes["DateTime"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	meta?: ValueTypes["UserCreateMetaEntityRelationInput"] | undefined | null,
	roles?: ValueTypes["UserCreateRolesEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserCreateDevicesEntityRelationInput"]: {
	connect?: ValueTypes["UserDeviceUniqueWhere"] | undefined | null,
	create?: ValueTypes["UserDeviceWithoutUserCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["UserDeviceWithoutUserCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	lastActiveAt?: ValueTypes["DateTime"] | undefined | null,
	platform?: string | undefined | null,
	deviceId?: string | undefined | null,
	notificationsEnabled?: boolean | undefined | null,
	appVersion?: string | undefined | null,
	osVersion?: string | undefined | null,
	apiVersion?: string | undefined | null,
	anonymousSession?: ValueTypes["UserDeviceCreateAnonymousSessionEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserDeviceCreateAnonymousSessionEntityRelationInput"]: {
	connect?: ValueTypes["AnonymousSessionUniqueWhere"] | undefined | null,
	create?: ValueTypes["AnonymousSessionWithoutDevicesCreateInput"] | undefined | null
};
	["AnonymousSessionWithoutDevicesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	lastActiveAt?: ValueTypes["DateTime"] | undefined | null,
	anonymousSessionKey?: string | undefined | null,
	email?: string | undefined | null,
	name?: string | undefined | null,
	internalNote?: string | undefined | null,
	customer?: ValueTypes["AnonymousSessionCreateCustomerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AnonymousSessionCreateCustomerEntityRelationInput"]: {
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerWithoutAnonymousSessionCreateInput"] | undefined | null
};
	["CustomerWithoutAnonymousSessionCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	addresses?: Array<ValueTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerCreateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerCreateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerCreatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerCreateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerCreateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerCreateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerCreateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerCreateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerCreateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerCreateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreateInvoicesEntityRelationInput"]: {
	connect?: ValueTypes["InvoiceUniqueWhere"] | undefined | null,
	create?: ValueTypes["InvoiceWithoutCustomerCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["InvoiceWithoutCustomerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	publicKey?: string | undefined | null,
	fakturoidId?: string | undefined | null,
	fakturoidData?: string | undefined | null,
	legacyUrl?: string | undefined | null,
	orderPayments?: Array<ValueTypes["InvoiceCreateOrderPaymentsEntityRelationInput"]> | undefined | null,
	address?: ValueTypes["InvoiceCreateAddressEntityRelationInput"] | undefined | null,
	publicUrl?: string | undefined | null,
	billingSubject?: ValueTypes["InvoiceCreateBillingSubjectEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InvoiceCreateOrderPaymentsEntityRelationInput"]: {
	connect?: ValueTypes["OrderPaymentUniqueWhere"] | undefined | null,
	create?: ValueTypes["OrderPaymentWithoutInvoiceCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["OrderPaymentWithoutInvoiceCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	data?: ValueTypes["Json"] | undefined | null,
	paymentCents?: number | undefined | null,
	method?: ValueTypes["OrderPaymentCreateMethodEntityRelationInput"] | undefined | null,
	failedAt?: ValueTypes["DateTime"] | undefined | null,
	state?: ValueTypes["OrderPaymentState"] | undefined | null,
	approvedAt?: ValueTypes["DateTime"] | undefined | null,
	events?: Array<ValueTypes["OrderPaymentCreateEventsEntityRelationInput"]> | undefined | null,
	order?: ValueTypes["OrderPaymentCreateOrderEntityRelationInput"] | undefined | null,
	walletType?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	publicReceiptUrl?: string | undefined | null,
	priceCents?: number | undefined | null,
	vatRate?: ValueTypes["OrderPaymentCreateVatRateEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["OrderPaymentCreateMetaEntityRelationInput"] | undefined | null,
	otherCurrencyPriceCents?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderPaymentCreateMethodEntityRelationInput"]: {
	connect?: ValueTypes["PaymentMethodUniqueWhere"] | undefined | null,
	create?: ValueTypes["PaymentMethodCreateInput"] | undefined | null
};
	["OrderPaymentCreateEventsEntityRelationInput"]: {
	connect?: ValueTypes["OrderEventUniqueWhere"] | undefined | null,
	create?: ValueTypes["OrderEventWithoutPaymentCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["OrderEventWithoutPaymentCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	type?: string | undefined | null,
	data?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	order?: ValueTypes["OrderEventCreateOrderEntityRelationInput"] | undefined | null,
	delivery?: ValueTypes["OrderEventCreateDeliveryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderEventCreateOrderEntityRelationInput"]: {
	connect?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	create?: ValueTypes["OrderWithoutEventsCreateInput"] | undefined | null
};
	["OrderWithoutEventsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	state?: ValueTypes["OrderState"] | undefined | null,
	fulfilledAt?: ValueTypes["DateTime"] | undefined | null,
	canceledAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	customer?: ValueTypes["OrderCreateCustomerEntityRelationInput"] | undefined | null,
	channel?: ValueTypes["OrderCreateChannelEntityRelationInput"] | undefined | null,
	discounts?: Array<ValueTypes["OrderCreateDiscountsEntityRelationInput"]> | undefined | null,
	delivery?: ValueTypes["OrderCreateDeliveryEntityRelationInput"] | undefined | null,
	items?: Array<ValueTypes["OrderCreateItemsEntityRelationInput"]> | undefined | null,
	internalNote?: string | undefined | null,
	cart?: ValueTypes["OrderCreateCartEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingAddress?: ValueTypes["OrderCreateBillingAddressEntityRelationInput"] | undefined | null,
	priceLines?: Array<ValueTypes["OrderCreatePriceLinesEntityRelationInput"]> | undefined | null,
	payments?: Array<ValueTypes["OrderCreatePaymentsEntityRelationInput"]> | undefined | null,
	seq?: number | undefined | null,
	billingSubject?: ValueTypes["OrderCreateBillingSubjectEntityRelationInput"] | undefined | null,
	summary?: ValueTypes["OrderCreateSummaryEntityRelationInput"] | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	gratuity?: ValueTypes["OrderCreateGratuityEntityRelationInput"] | undefined | null,
	venue?: ValueTypes["OrderCreateVenueEntityRelationInput"] | undefined | null,
	fulfillmentNote?: string | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["OrderCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	doubleshotTotalWeightGrams?: number | undefined | null,
	doubleShotLegacyNumber?: string | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	doubleshotAdminUrl?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderCreateDeliveryEntityRelationInput"]: {
	connect?: ValueTypes["OrderDeliveryUniqueWhere"] | undefined | null,
	create?: ValueTypes["OrderDeliveryWithoutOrderCreateInput"] | undefined | null
};
	["OrderDeliveryWithoutOrderCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	priceCents?: number | undefined | null,
	deliveredAt?: ValueTypes["DateTime"] | undefined | null,
	method?: ValueTypes["OrderDeliveryCreateMethodEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["OrderDeliveryCreateVatRateEntityRelationInput"] | undefined | null,
	expectedAt?: ValueTypes["DateTime"] | undefined | null,
	state?: ValueTypes["OrderDeliveryState"] | undefined | null,
	loadingDurationHours?: number | undefined | null,
	dispatchAt?: ValueTypes["DateTime"] | undefined | null,
	duration?: string | undefined | null,
	window?: string | undefined | null,
	expectedEndAt?: ValueTypes["DateTime"] | undefined | null,
	processingAt?: ValueTypes["DateTime"] | undefined | null,
	deliveringAt?: ValueTypes["DateTime"] | undefined | null,
	failedAt?: ValueTypes["DateTime"] | undefined | null,
	internalNote?: string | undefined | null,
	deliveryWaypoint?: ValueTypes["OrderDeliveryCreateDeliveryWaypointEntityRelationInput"] | undefined | null,
	events?: Array<ValueTypes["OrderDeliveryCreateEventsEntityRelationInput"]> | undefined | null,
	prepareAt?: ValueTypes["DateTime"] | undefined | null,
	liftagoRide?: ValueTypes["OrderDeliveryCreateLiftagoRideEntityRelationInput"] | undefined | null,
	pickedAt?: ValueTypes["DateTime"] | undefined | null,
	address?: ValueTypes["OrderDeliveryCreateAddressEntityRelationInput"] | undefined | null,
	trackingCode?: string | undefined | null,
	woltDriveDelivery?: ValueTypes["OrderDeliveryCreateWoltDriveDeliveryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderDeliveryCreateVatRateEntityRelationInput"]: {
	connect?: ValueTypes["VatRateUniqueWhere"] | undefined | null,
	create?: ValueTypes["VatRateCreateInput"] | undefined | null
};
	["OrderDeliveryCreateDeliveryWaypointEntityRelationInput"]: {
	connect?: ValueTypes["DeliveryWaypointUniqueWhere"] | undefined | null,
	create?: ValueTypes["DeliveryWaypointWithoutDeliveryCreateInput"] | undefined | null
};
	["DeliveryWaypointWithoutDeliveryCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	estimatedArrival?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	route?: ValueTypes["DeliveryWaypointCreateRouteEntityRelationInput"] | undefined | null,
	sortingOrder?: number | undefined | null,
	estimatedDistance?: number | undefined | null,
	estimatedDuration?: number | undefined | null,
	originDeparture?: ValueTypes["DateTime"] | undefined | null,
	originAddress?: string | undefined | null,
	transitMode?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryWaypointCreateRouteEntityRelationInput"]: {
	connect?: ValueTypes["DeliveryRouteUniqueWhere"] | undefined | null,
	create?: ValueTypes["DeliveryRouteWithoutWaypointsCreateInput"] | undefined | null
};
	["DeliveryRouteWithoutWaypointsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	courier?: ValueTypes["DeliveryRouteCreateCourierEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	dispatchAt?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryRouteCreateCourierEntityRelationInput"]: {
	connect?: ValueTypes["CourierUniqueWhere"] | undefined | null,
	create?: ValueTypes["CourierWithoutRoutesCreateInput"] | undefined | null
};
	["CourierWithoutRoutesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	staff?: ValueTypes["CourierCreateStaffEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	deliveryMethods?: Array<ValueTypes["CourierCreateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	showInPicker?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CourierCreateDeliveryMethodsEntityRelationInput"]: {
	connect?: ValueTypes["DeliveryMethodUniqueWhere"] | undefined | null,
	create?: ValueTypes["DeliveryMethodWithoutCourierHandlersCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["DeliveryMethodWithoutCourierHandlersCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	enabled?: boolean | undefined | null,
	paymentMethods?: Array<ValueTypes["DeliveryMethodCreatePaymentMethodsEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	requireDeliveryAddress?: boolean | undefined | null,
	suitableForDeliveryZones?: Array<ValueTypes["DeliveryMethodCreateSuitableForDeliveryZonesEntityRelationInput"]> | undefined | null,
	channels?: Array<ValueTypes["DeliveryMethodCreateChannelsEntityRelationInput"]> | undefined | null,
	enableDeliveryTracking?: boolean | undefined | null,
	locales?: Array<ValueTypes["DeliveryMethodCreateLocalesEntityRelationInput"]> | undefined | null,
	timelinePreset?: ValueTypes["DeliveryMethodCreateTimelinePresetEntityRelationInput"] | undefined | null,
	woltDriveVenueId?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryMethodCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["DeliveryMethodLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["DeliveryMethodLocaleWithoutRootCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["DeliveryMethodLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	description?: string | undefined | null,
	trackingCodeUrlTemplate?: string | undefined | null,
	processingTitle?: string | undefined | null,
	processingText?: string | undefined | null,
	processingIconUrl?: string | undefined | null,
	dispatchedTitle?: string | undefined | null,
	dispatchedText?: string | undefined | null,
	dispatchedIconUrl?: string | undefined | null,
	fulfilledTitle?: string | undefined | null,
	fulfilledText?: string | undefined | null,
	fulfilledIconUrl?: string | undefined | null,
	locale?: ValueTypes["DeliveryMethodLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryMethodLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["LocaleWithoutDeliveryMethodsCreateInput"] | undefined | null
};
	["LocaleWithoutDeliveryMethodsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	businessCategories?: Array<ValueTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleCreateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleCreatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleCreateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreateProductPackingsEntityRelationInput"]: {
	connect?: ValueTypes["ProductPackingLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductPackingLocaleWithoutLocaleCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductPackingLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	shortName?: string | undefined | null,
	description?: string | undefined | null,
	root?: ValueTypes["ProductPackingLocaleCreateRootEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductPackingLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["ProductPackingUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductPackingWithoutLocalesCreateInput"] | undefined | null
};
	["ProductPackingWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	image?: ValueTypes["ProductPackingCreateImageEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	volumeMl?: number | undefined | null,
	icon?: ValueTypes["ProductPackingCreateIconEntityRelationInput"] | undefined | null,
	shortName?: string | undefined | null,
	preparedPackingQuantities?: Array<ValueTypes["ProductPackingCreatePreparedPackingQuantitiesEntityRelationInput"]> | undefined | null,
	isPackedInCardboard?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductPackingCreatePreparedPackingQuantitiesEntityRelationInput"]: {
	connect?: ValueTypes["PreparedPackingQuantityUniqueWhere"] | undefined | null,
	create?: ValueTypes["PreparedPackingQuantityWithoutPackingCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PreparedPackingQuantityWithoutPackingCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	date?: ValueTypes["Date"] | undefined | null,
	quantity?: number | undefined | null,
	recipe?: ValueTypes["PreparedPackingQuantityCreateRecipeEntityRelationInput"] | undefined | null,
	packedInCardboard?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PreparedPackingQuantityCreateRecipeEntityRelationInput"]: {
	connect?: ValueTypes["ProductRecipeUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductRecipeCreateInput"] | undefined | null
};
	["ProductRecipeCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	products?: Array<ValueTypes["ProductRecipeCreateProductsEntityRelationInput"]> | undefined | null,
	internalNote?: string | undefined | null,
	color?: string | undefined | null,
	image?: ValueTypes["ProductRecipeCreateImageEntityRelationInput"] | undefined | null,
	icon?: ValueTypes["ProductRecipeCreateIconEntityRelationInput"] | undefined | null,
	ingredients?: Array<ValueTypes["ProductRecipeCreateIngredientsEntityRelationInput"]> | undefined | null,
	needsPrepping?: boolean | undefined | null,
	locales?: Array<ValueTypes["ProductRecipeCreateLocalesEntityRelationInput"]> | undefined | null,
	gutTuning?: number | undefined | null,
	freshingContainer?: ValueTypes["ProductRecipeCreateFreshingContainerEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	nutritionFacts?: ValueTypes["ProductRecipeCreateNutritionFactsEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductRecipeCreateProductsEntityRelationInput"]: {
	connect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductWithoutRecipeCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductWithoutRecipeCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	priceCents?: number | undefined | null,
	notDiscountable?: boolean | undefined | null,
	packing?: ValueTypes["ProductCreatePackingEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["ProductCreateTagsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["ProductCreateCategoriesEntityRelationInput"]> | undefined | null,
	vatRate?: ValueTypes["ProductCreateVatRateEntityRelationInput"] | undefined | null,
	stocks?: Array<ValueTypes["ProductCreateStocksEntityRelationInput"]> | undefined | null,
	groupPrices?: Array<ValueTypes["ProductCreateGroupPricesEntityRelationInput"]> | undefined | null,
	image?: ValueTypes["ProductCreateImageEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	cartItems?: Array<ValueTypes["ProductCreateCartItemsEntityRelationInput"]> | undefined | null,
	availability?: ValueTypes["ProductAvailability"] | undefined | null,
	order?: number | undefined | null,
	manager?: ValueTypes["ProductCreateManagerEntityRelationInput"] | undefined | null,
	orderItems?: Array<ValueTypes["ProductCreateOrderItemsEntityRelationInput"]> | undefined | null,
	maximumQuantityPerOrder?: number | undefined | null,
	inheritedCategories?: Array<ValueTypes["ProductCreateInheritedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["ProductCreateDeliveryZonesEntityRelationInput"]> | undefined | null,
	locales?: Array<ValueTypes["ProductCreateLocalesEntityRelationInput"]> | undefined | null,
	archivedAt?: ValueTypes["DateTime"] | undefined | null,
	customerPrices?: Array<ValueTypes["ProductCreateCustomerPricesEntityRelationInput"]> | undefined | null,
	virtualProduct?: ValueTypes["ProductCreateVirtualProductEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["ProductCreateMetaEntityRelationInput"] | undefined | null,
	page?: ValueTypes["ProductCreatePageEntityRelationInput"] | undefined | null,
	salesDays?: Array<ValueTypes["ProductCreateSalesDaysEntityRelationInput"]> | undefined | null,
	salesWeeks?: Array<ValueTypes["ProductCreateSalesWeeksEntityRelationInput"]> | undefined | null,
	salesMonths?: Array<ValueTypes["ProductCreateSalesMonthsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["ProductCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	hasSubscription?: boolean | undefined | null,
	pointOfSaleTileColor?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["ProductLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductLocaleWithoutRootCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	description?: string | undefined | null,
	locale?: ValueTypes["ProductLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	featureList?: ValueTypes["ProductLocaleCreateFeatureListEntityRelationInput"] | undefined | null,
	printableName?: string | undefined | null,
	firstSticker?: string | undefined | null,
	secondSticker?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["LocaleWithoutProductsCreateInput"] | undefined | null
};
	["LocaleWithoutProductsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	businessCategories?: Array<ValueTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleCreateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleCreatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreateProductRecipesEntityRelationInput"]: {
	connect?: ValueTypes["ProductRecipeLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductRecipeLocaleWithoutLocaleCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductRecipeLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	root?: ValueTypes["ProductRecipeLocaleCreateRootEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductRecipeLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["ProductRecipeUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductRecipeWithoutLocalesCreateInput"] | undefined | null
};
	["ProductRecipeWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	products?: Array<ValueTypes["ProductRecipeCreateProductsEntityRelationInput"]> | undefined | null,
	internalNote?: string | undefined | null,
	color?: string | undefined | null,
	image?: ValueTypes["ProductRecipeCreateImageEntityRelationInput"] | undefined | null,
	icon?: ValueTypes["ProductRecipeCreateIconEntityRelationInput"] | undefined | null,
	ingredients?: Array<ValueTypes["ProductRecipeCreateIngredientsEntityRelationInput"]> | undefined | null,
	needsPrepping?: boolean | undefined | null,
	gutTuning?: number | undefined | null,
	freshingContainer?: ValueTypes["ProductRecipeCreateFreshingContainerEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	nutritionFacts?: ValueTypes["ProductRecipeCreateNutritionFactsEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductRecipeCreateFreshingContainerEntityRelationInput"]: {
	connect?: ValueTypes["FreshingContainerUniqueWhere"] | undefined | null,
	create?: ValueTypes["FreshingContainerCreateInput"] | undefined | null
};
	["ProductRecipeCreateNutritionFactsEntityRelationInput"]: {
	connect?: ValueTypes["NutritionFactsUniqueWhere"] | undefined | null,
	create?: ValueTypes["NutritionFactsCreateInput"] | undefined | null
};
	["NutritionFactsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	energyKiloJoule?: number | undefined | null,
	energyKiloCalorie?: number | undefined | null,
	fatsGrams?: number | undefined | null,
	fatsOfWhichSaturatedGrams?: number | undefined | null,
	carbohydrateGrams?: number | undefined | null,
	carbohydrateOfWhichSugarsGrams?: number | undefined | null,
	proteinGrams?: number | undefined | null,
	fibreGrams?: number | undefined | null,
	saltGrams?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]: {
	connect?: ValueTypes["PointOfSaleCategoryLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["PointOfSaleCategoryLocaleWithoutLocaleCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PointOfSaleCategoryLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	root?: ValueTypes["PointOfSaleCategoryLocaleCreateRootEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleCategoryLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["PointOfSaleCategoryUniqueWhere"] | undefined | null,
	create?: ValueTypes["PointOfSaleCategoryWithoutLocalesCreateInput"] | undefined | null
};
	["PointOfSaleCategoryWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	slug?: string | undefined | null,
	products?: Array<ValueTypes["PointOfSaleCategoryCreateProductsEntityRelationInput"]> | undefined | null,
	category?: ValueTypes["PointOfSaleCategoryCreateCategoryEntityRelationInput"] | undefined | null,
	venue?: ValueTypes["PointOfSaleCategoryCreateVenueEntityRelationInput"] | undefined | null,
	ticketPrinters?: Array<ValueTypes["PointOfSaleCategoryCreateTicketPrintersEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleCategoryCreateProductsEntityRelationInput"]: {
	connect?: ValueTypes["PointOfSaleCategoryProductUniqueWhere"] | undefined | null,
	create?: ValueTypes["PointOfSaleCategoryProductWithoutCategoryCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PointOfSaleCategoryProductWithoutCategoryCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	product?: ValueTypes["PointOfSaleCategoryProductCreateProductEntityRelationInput"] | undefined | null,
	locales?: Array<ValueTypes["PointOfSaleCategoryProductCreateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleCategoryProductCreateProductEntityRelationInput"]: {
	connect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductCreateInput"] | undefined | null
};
	["ProductCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	priceCents?: number | undefined | null,
	notDiscountable?: boolean | undefined | null,
	packing?: ValueTypes["ProductCreatePackingEntityRelationInput"] | undefined | null,
	recipe?: ValueTypes["ProductCreateRecipeEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["ProductCreateTagsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["ProductCreateCategoriesEntityRelationInput"]> | undefined | null,
	vatRate?: ValueTypes["ProductCreateVatRateEntityRelationInput"] | undefined | null,
	stocks?: Array<ValueTypes["ProductCreateStocksEntityRelationInput"]> | undefined | null,
	groupPrices?: Array<ValueTypes["ProductCreateGroupPricesEntityRelationInput"]> | undefined | null,
	image?: ValueTypes["ProductCreateImageEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	cartItems?: Array<ValueTypes["ProductCreateCartItemsEntityRelationInput"]> | undefined | null,
	availability?: ValueTypes["ProductAvailability"] | undefined | null,
	order?: number | undefined | null,
	manager?: ValueTypes["ProductCreateManagerEntityRelationInput"] | undefined | null,
	orderItems?: Array<ValueTypes["ProductCreateOrderItemsEntityRelationInput"]> | undefined | null,
	maximumQuantityPerOrder?: number | undefined | null,
	inheritedCategories?: Array<ValueTypes["ProductCreateInheritedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["ProductCreateDeliveryZonesEntityRelationInput"]> | undefined | null,
	locales?: Array<ValueTypes["ProductCreateLocalesEntityRelationInput"]> | undefined | null,
	archivedAt?: ValueTypes["DateTime"] | undefined | null,
	customerPrices?: Array<ValueTypes["ProductCreateCustomerPricesEntityRelationInput"]> | undefined | null,
	virtualProduct?: ValueTypes["ProductCreateVirtualProductEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["ProductCreateMetaEntityRelationInput"] | undefined | null,
	page?: ValueTypes["ProductCreatePageEntityRelationInput"] | undefined | null,
	salesDays?: Array<ValueTypes["ProductCreateSalesDaysEntityRelationInput"]> | undefined | null,
	salesWeeks?: Array<ValueTypes["ProductCreateSalesWeeksEntityRelationInput"]> | undefined | null,
	salesMonths?: Array<ValueTypes["ProductCreateSalesMonthsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["ProductCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	hasSubscription?: boolean | undefined | null,
	pointOfSaleTileColor?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCreateCustomerPricesEntityRelationInput"]: {
	connect?: ValueTypes["ProductCustomerPriceUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductCreateVirtualProductEntityRelationInput"]: {
	connect?: ValueTypes["VirtualProductUniqueWhere"] | undefined | null,
	create?: ValueTypes["VirtualProductWithoutProductCreateInput"] | undefined | null
};
	["VirtualProductWithoutProductCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	type?: ValueTypes["VirtualProductType"] | undefined | null,
	voucherCreditCents?: number | undefined | null,
	physicalRepresentation?: ValueTypes["VirtualProductPhysicalRepresentationType"] | undefined | null,
	recipientEmail?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCreateMetaEntityRelationInput"]: {
	connect?: ValueTypes["ProductMetadataUniqueWhere"] | undefined | null
};
	["ProductCreatePageEntityRelationInput"]: {
	connect?: ValueTypes["PageUniqueWhere"] | undefined | null,
	create?: ValueTypes["PageCreateInput"] | undefined | null
};
	["PageCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	locales?: Array<ValueTypes["PageCreateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PageCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["PageLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["PageLocaleWithoutRootCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PageLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	link?: ValueTypes["PageLocaleCreateLinkEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["PageLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	seo?: ValueTypes["PageLocaleCreateSeoEntityRelationInput"] | undefined | null,
	content?: ValueTypes["PageLocaleCreateContentEntityRelationInput"] | undefined | null,
	cover?: ValueTypes["PageLocaleCreateCoverEntityRelationInput"] | undefined | null,
	theme?: ValueTypes["PageTheme"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PageLocaleCreateSeoEntityRelationInput"]: {
	connect?: ValueTypes["SeoUniqueWhere"] | undefined | null,
	create?: ValueTypes["SeoCreateInput"] | undefined | null
};
	["SeoCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	description?: string | undefined | null,
	ogTitle?: string | undefined | null,
	ogDescription?: string | undefined | null,
	ogImage?: ValueTypes["SeoCreateOgImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SeoCreateOgImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["PageLocaleCreateContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null,
	create?: ValueTypes["ContentCreateInput"] | undefined | null
};
	["PageLocaleCreateCoverEntityRelationInput"]: {
	connect?: ValueTypes["CoverUniqueWhere"] | undefined | null,
	create?: ValueTypes["CoverCreateInput"] | undefined | null
};
	["ProductCreateSalesDaysEntityRelationInput"]: {
	connect?: ValueTypes["ProductSalesDayUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductCreateSalesWeeksEntityRelationInput"]: {
	connect?: ValueTypes["ProductSalesWeekUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductCreateSalesMonthsEntityRelationInput"]: {
	connect?: ValueTypes["ProductSalesMonthUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductCreateFulfillmentNotesEntityRelationInput"]: {
	connect?: ValueTypes["FulfillmentNoteUniqueWhere"] | undefined | null,
	create?: ValueTypes["FulfillmentNoteWithoutProductsCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["FulfillmentNoteWithoutProductsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	note?: string | undefined | null,
	tags?: Array<ValueTypes["FulfillmentNoteCreateTagsEntityRelationInput"]> | undefined | null,
	venues?: Array<ValueTypes["FulfillmentNoteCreateVenuesEntityRelationInput"]> | undefined | null,
	cartItems?: Array<ValueTypes["FulfillmentNoteCreateCartItemsEntityRelationInput"]> | undefined | null,
	orderItems?: Array<ValueTypes["FulfillmentNoteCreateOrderItemsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["FulfillmentNoteCreateOrdersEntityRelationInput"]> | undefined | null,
	highlight?: boolean | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	emoji?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FulfillmentNoteCreateTagsEntityRelationInput"]: {
	connect?: ValueTypes["TagUniqueWhere"] | undefined | null,
	create?: ValueTypes["TagWithoutFulfillmentNotesCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TagWithoutFulfillmentNotesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	customers?: Array<ValueTypes["TagCreateCustomersEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["TagCreateProductsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["TagCreateCategoriesEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	addTagsOnRegistration?: Array<ValueTypes["TagCreateAddTagsOnRegistrationEntityRelationInput"]> | undefined | null,
	nestedCategories?: Array<ValueTypes["TagCreateNestedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["TagCreateDeliveryZonesEntityRelationInput"]> | undefined | null,
	publicInChannels?: Array<ValueTypes["TagCreatePublicInChannelsEntityRelationInput"]> | undefined | null,
	allowChannelPayments?: Array<ValueTypes["TagCreateAllowChannelPaymentsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FulfillmentNoteCreateVenuesEntityRelationInput"]: {
	connect?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	create?: ValueTypes["VenueWithoutFulfillmentNotesCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["VenueWithoutFulfillmentNotesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	deadlineTemplate?: ValueTypes["VenueCreateDeadlineTemplateEntityRelationInput"] | undefined | null,
	timetableDays?: Array<ValueTypes["VenueCreateTimetableDaysEntityRelationInput"]> | undefined | null,
	timetableTemplates?: Array<ValueTypes["VenueCreateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	staffMembers?: Array<ValueTypes["VenueCreateStaffMembersEntityRelationInput"]> | undefined | null,
	employeeRoles?: Array<ValueTypes["VenueCreateEmployeeRolesEntityRelationInput"]> | undefined | null,
	pointOfSaleApplicationDevices?: Array<ValueTypes["VenueCreatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined | null,
	pointOfSaleTerminals?: Array<ValueTypes["VenueCreatePointOfSaleTerminalsEntityRelationInput"]> | undefined | null,
	pointOfSalePrinters?: Array<ValueTypes["VenueCreatePointOfSalePrintersEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["VenueCreateOrdersEntityRelationInput"]> | undefined | null,
	areas?: Array<ValueTypes["VenueCreateAreasEntityRelationInput"]> | undefined | null,
	enabledUnassignReasons?: Array<ValueTypes["VenueCreateEnabledUnassignReasonsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["VenueCreateCategoriesEntityRelationInput"]> | undefined | null,
	channels?: Array<ValueTypes["VenueCreateChannelsEntityRelationInput"]> | undefined | null,
	address?: string | undefined | null,
	pointOfSalePngBase64ReceiptLogo?: string | undefined | null,
	pointOfSaleInitialView?: ValueTypes["PointOfSaleInitialView"] | undefined | null,
	pointOfSalePreferPrintReceipt?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VenueCreateTimetableTemplatesEntityRelationInput"]: {
	connect?: ValueTypes["TimetableTemplateUniqueWhere"] | undefined | null,
	create?: ValueTypes["TimetableTemplateWithoutVenueCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TimetableTemplateWithoutVenueCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	startDate?: ValueTypes["Date"] | undefined | null,
	period?: number | undefined | null,
	slots?: number | undefined | null,
	position?: ValueTypes["TimetableTemplateCreatePositionEntityRelationInput"] | undefined | null,
	staffOptions?: Array<ValueTypes["TimetableTemplateCreateStaffOptionsEntityRelationInput"]> | undefined | null,
	internalName?: string | undefined | null,
	employeeRole?: ValueTypes["TimetableTemplateCreateEmployeeRoleEntityRelationInput"] | undefined | null,
	workdaysOnly?: boolean | undefined | null,
	monday?: boolean | undefined | null,
	tuesday?: boolean | undefined | null,
	wednesday?: boolean | undefined | null,
	thursday?: boolean | undefined | null,
	friday?: boolean | undefined | null,
	saturday?: boolean | undefined | null,
	sunday?: boolean | undefined | null,
	type?: ValueTypes["TemplateType"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableTemplateCreateEmployeeRoleEntityRelationInput"]: {
	connect?: ValueTypes["TimetableEmployeeRoleUniqueWhere"] | undefined | null,
	create?: ValueTypes["TimetableEmployeeRoleWithoutTimetableTemplatesCreateInput"] | undefined | null
};
	["TimetableEmployeeRoleWithoutTimetableTemplatesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	shiftGroups?: Array<ValueTypes["TimetableEmployeeRoleCreateShiftGroupsEntityRelationInput"]> | undefined | null,
	shiftsProfiles?: Array<ValueTypes["TimetableEmployeeRoleCreateShiftsProfilesEntityRelationInput"]> | undefined | null,
	shiftsManagers?: Array<ValueTypes["TimetableEmployeeRoleCreateShiftsManagersEntityRelationInput"]> | undefined | null,
	name?: string | undefined | null,
	color?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VenueCreatePointOfSaleTerminalsEntityRelationInput"]: {
	connect?: ValueTypes["PointOfSaleTerminalUniqueWhere"] | undefined | null,
	create?: ValueTypes["PointOfSaleTerminalWithoutVenueCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PointOfSaleTerminalWithoutVenueCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	internalName?: string | undefined | null,
	note?: string | undefined | null,
	applicationDevices?: Array<ValueTypes["PointOfSaleTerminalCreateApplicationDevicesEntityRelationInput"]> | undefined | null,
	ipAddress?: string | undefined | null,
	port?: number | undefined | null,
	type?: ValueTypes["PointOfSaleTerminalType"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleTerminalCreateApplicationDevicesEntityRelationInput"]: {
	connect?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null,
	create?: ValueTypes["PointOfSaleApplicationDeviceWithoutTerminalCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PointOfSaleApplicationDeviceWithoutTerminalCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	internalName?: string | undefined | null,
	note?: string | undefined | null,
	venue?: ValueTypes["PointOfSaleApplicationDeviceCreateVenueEntityRelationInput"] | undefined | null,
	identificationCode?: ValueTypes["PointOfSaleApplicationDeviceCreateIdentificationCodeEntityRelationInput"] | undefined | null,
	identifier?: ValueTypes["PointOfSaleApplicationDeviceCreateIdentifierEntityRelationInput"] | undefined | null,
	receiptPrinter?: ValueTypes["PointOfSaleApplicationDeviceCreateReceiptPrinterEntityRelationInput"] | undefined | null,
	ticketPrinters?: Array<ValueTypes["PointOfSaleApplicationDeviceCreateTicketPrintersEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleApplicationDeviceCreateVenueEntityRelationInput"]: {
	connect?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	create?: ValueTypes["VenueWithoutPointOfSaleApplicationDevicesCreateInput"] | undefined | null
};
	["VenueWithoutPointOfSaleApplicationDevicesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	deadlineTemplate?: ValueTypes["VenueCreateDeadlineTemplateEntityRelationInput"] | undefined | null,
	timetableDays?: Array<ValueTypes["VenueCreateTimetableDaysEntityRelationInput"]> | undefined | null,
	timetableTemplates?: Array<ValueTypes["VenueCreateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	staffMembers?: Array<ValueTypes["VenueCreateStaffMembersEntityRelationInput"]> | undefined | null,
	employeeRoles?: Array<ValueTypes["VenueCreateEmployeeRolesEntityRelationInput"]> | undefined | null,
	pointOfSaleTerminals?: Array<ValueTypes["VenueCreatePointOfSaleTerminalsEntityRelationInput"]> | undefined | null,
	pointOfSalePrinters?: Array<ValueTypes["VenueCreatePointOfSalePrintersEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["VenueCreateOrdersEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["VenueCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	areas?: Array<ValueTypes["VenueCreateAreasEntityRelationInput"]> | undefined | null,
	enabledUnassignReasons?: Array<ValueTypes["VenueCreateEnabledUnassignReasonsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["VenueCreateCategoriesEntityRelationInput"]> | undefined | null,
	channels?: Array<ValueTypes["VenueCreateChannelsEntityRelationInput"]> | undefined | null,
	address?: string | undefined | null,
	pointOfSalePngBase64ReceiptLogo?: string | undefined | null,
	pointOfSaleInitialView?: ValueTypes["PointOfSaleInitialView"] | undefined | null,
	pointOfSalePreferPrintReceipt?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VenueCreatePointOfSalePrintersEntityRelationInput"]: {
	connect?: ValueTypes["PointOfSalePrinterUniqueWhere"] | undefined | null,
	create?: ValueTypes["PointOfSalePrinterWithoutVenueCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PointOfSalePrinterWithoutVenueCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	internalName?: string | undefined | null,
	note?: string | undefined | null,
	ipAddress?: string | undefined | null,
	applicationDevicesReceipt?: Array<ValueTypes["PointOfSalePrinterCreateApplicationDevicesReceiptEntityRelationInput"]> | undefined | null,
	applicationDevicesTicket?: Array<ValueTypes["PointOfSalePrinterCreateApplicationDevicesTicketEntityRelationInput"]> | undefined | null,
	ticketCategories?: Array<ValueTypes["PointOfSalePrinterCreateTicketCategoriesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSalePrinterCreateApplicationDevicesReceiptEntityRelationInput"]: {
	connect?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null,
	create?: ValueTypes["PointOfSaleApplicationDeviceWithoutReceiptPrinterCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PointOfSaleApplicationDeviceWithoutReceiptPrinterCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	internalName?: string | undefined | null,
	note?: string | undefined | null,
	venue?: ValueTypes["PointOfSaleApplicationDeviceCreateVenueEntityRelationInput"] | undefined | null,
	identificationCode?: ValueTypes["PointOfSaleApplicationDeviceCreateIdentificationCodeEntityRelationInput"] | undefined | null,
	identifier?: ValueTypes["PointOfSaleApplicationDeviceCreateIdentifierEntityRelationInput"] | undefined | null,
	terminal?: ValueTypes["PointOfSaleApplicationDeviceCreateTerminalEntityRelationInput"] | undefined | null,
	ticketPrinters?: Array<ValueTypes["PointOfSaleApplicationDeviceCreateTicketPrintersEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleApplicationDeviceCreateIdentifierEntityRelationInput"]: {
	connect?: ValueTypes["DeviceIdentifierUniqueWhere"] | undefined | null,
	create?: ValueTypes["DeviceIdentifierWithoutDeviceCreateInput"] | undefined | null
};
	["DeviceIdentifierWithoutDeviceCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	internalName?: string | undefined | null,
	updatedAt?: ValueTypes["DateTime"] | undefined | null,
	platform?: string | undefined | null,
	resolution?: string | undefined | null,
	devicePixelRatio?: number | undefined | null,
	updatedByUser?: ValueTypes["DeviceIdentifierCreateUpdatedByUserEntityRelationInput"] | undefined | null,
	identifier?: string | undefined | null,
	applicationVersionIdentifier?: string | undefined | null,
	lastPointOfSaleSynchronizationErrorRawDetails?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeviceIdentifierCreateUpdatedByUserEntityRelationInput"]: {
	connect?: ValueTypes["UserUniqueWhere"] | undefined | null,
	create?: ValueTypes["UserCreateInput"] | undefined | null
};
	["UserCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	internalNote?: string | undefined | null,
	staff?: ValueTypes["UserCreateStaffEntityRelationInput"] | undefined | null,
	customer?: ValueTypes["UserCreateCustomerEntityRelationInput"] | undefined | null,
	tenantPersonId?: ValueTypes["UUID"] | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	devices?: Array<ValueTypes["UserCreateDevicesEntityRelationInput"]> | undefined | null,
	verifiedAt?: ValueTypes["DateTime"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	deletionRequestedAt?: ValueTypes["DateTime"] | undefined | null,
	deletionExpectedAt?: ValueTypes["DateTime"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	meta?: ValueTypes["UserCreateMetaEntityRelationInput"] | undefined | null,
	identificationAttempts?: Array<ValueTypes["UserCreateIdentificationAttemptsEntityRelationInput"]> | undefined | null,
	roles?: ValueTypes["UserCreateRolesEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserCreateMetaEntityRelationInput"]: {
	connect?: ValueTypes["UserMetadataUniqueWhere"] | undefined | null
};
	["UserCreateIdentificationAttemptsEntityRelationInput"]: {
	connect?: ValueTypes["IdentificationAttemptUniqueWhere"] | undefined | null,
	create?: ValueTypes["IdentificationAttemptWithoutUserCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["IdentificationAttemptWithoutUserCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	code?: ValueTypes["IdentificationAttemptCreateCodeEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IdentificationAttemptCreateCodeEntityRelationInput"]: {
	connect?: ValueTypes["IdentificationCodeUniqueWhere"] | undefined | null,
	create?: ValueTypes["IdentificationCodeWithoutAttemptsCreateInput"] | undefined | null
};
	["IdentificationCodeWithoutAttemptsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	locales?: Array<ValueTypes["IdentificationCodeCreateLocalesEntityRelationInput"]> | undefined | null,
	internalName?: string | undefined | null,
	applicationDevices?: Array<ValueTypes["IdentificationCodeCreateApplicationDevicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IdentificationCodeCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["IdentificationCodeLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["IdentificationCodeLocaleWithoutRootCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["IdentificationCodeLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	successMessage?: string | undefined | null,
	locale?: ValueTypes["IdentificationCodeLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IdentificationCodeLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["LocaleWithoutIdentificationCodesCreateInput"] | undefined | null
};
	["LocaleWithoutIdentificationCodesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	businessCategories?: Array<ValueTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleCreateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleCreatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleCreateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreateProductsEntityRelationInput"]: {
	connect?: ValueTypes["ProductLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductLocaleWithoutLocaleCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	description?: string | undefined | null,
	root?: ValueTypes["ProductLocaleCreateRootEntityRelationInput"] | undefined | null,
	featureList?: ValueTypes["ProductLocaleCreateFeatureListEntityRelationInput"] | undefined | null,
	printableName?: string | undefined | null,
	firstSticker?: string | undefined | null,
	secondSticker?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductWithoutLocalesCreateInput"] | undefined | null
};
	["ProductWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	priceCents?: number | undefined | null,
	notDiscountable?: boolean | undefined | null,
	packing?: ValueTypes["ProductCreatePackingEntityRelationInput"] | undefined | null,
	recipe?: ValueTypes["ProductCreateRecipeEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["ProductCreateTagsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["ProductCreateCategoriesEntityRelationInput"]> | undefined | null,
	vatRate?: ValueTypes["ProductCreateVatRateEntityRelationInput"] | undefined | null,
	stocks?: Array<ValueTypes["ProductCreateStocksEntityRelationInput"]> | undefined | null,
	groupPrices?: Array<ValueTypes["ProductCreateGroupPricesEntityRelationInput"]> | undefined | null,
	image?: ValueTypes["ProductCreateImageEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	cartItems?: Array<ValueTypes["ProductCreateCartItemsEntityRelationInput"]> | undefined | null,
	availability?: ValueTypes["ProductAvailability"] | undefined | null,
	order?: number | undefined | null,
	manager?: ValueTypes["ProductCreateManagerEntityRelationInput"] | undefined | null,
	orderItems?: Array<ValueTypes["ProductCreateOrderItemsEntityRelationInput"]> | undefined | null,
	maximumQuantityPerOrder?: number | undefined | null,
	inheritedCategories?: Array<ValueTypes["ProductCreateInheritedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["ProductCreateDeliveryZonesEntityRelationInput"]> | undefined | null,
	archivedAt?: ValueTypes["DateTime"] | undefined | null,
	customerPrices?: Array<ValueTypes["ProductCreateCustomerPricesEntityRelationInput"]> | undefined | null,
	virtualProduct?: ValueTypes["ProductCreateVirtualProductEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["ProductCreateMetaEntityRelationInput"] | undefined | null,
	page?: ValueTypes["ProductCreatePageEntityRelationInput"] | undefined | null,
	salesDays?: Array<ValueTypes["ProductCreateSalesDaysEntityRelationInput"]> | undefined | null,
	salesWeeks?: Array<ValueTypes["ProductCreateSalesWeeksEntityRelationInput"]> | undefined | null,
	salesMonths?: Array<ValueTypes["ProductCreateSalesMonthsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["ProductCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	hasSubscription?: boolean | undefined | null,
	pointOfSaleTileColor?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductLocaleCreateFeatureListEntityRelationInput"]: {
	connect?: ValueTypes["TextListUniqueWhere"] | undefined | null,
	create?: ValueTypes["TextListCreateInput"] | undefined | null
};
	["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]: {
	connect?: ValueTypes["PointOfSaleCategoryProductLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["PointOfSaleCategoryProductLocaleWithoutLocaleCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PointOfSaleCategoryProductLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	root?: ValueTypes["PointOfSaleCategoryProductLocaleCreateRootEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleCategoryProductLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["PointOfSaleCategoryProductUniqueWhere"] | undefined | null,
	create?: ValueTypes["PointOfSaleCategoryProductWithoutLocalesCreateInput"] | undefined | null
};
	["PointOfSaleCategoryProductWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	category?: ValueTypes["PointOfSaleCategoryProductCreateCategoryEntityRelationInput"] | undefined | null,
	product?: ValueTypes["PointOfSaleCategoryProductCreateProductEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleCategoryProductCreateCategoryEntityRelationInput"]: {
	connect?: ValueTypes["PointOfSaleCategoryUniqueWhere"] | undefined | null,
	create?: ValueTypes["PointOfSaleCategoryWithoutProductsCreateInput"] | undefined | null
};
	["PointOfSaleCategoryWithoutProductsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	slug?: string | undefined | null,
	locales?: Array<ValueTypes["PointOfSaleCategoryCreateLocalesEntityRelationInput"]> | undefined | null,
	category?: ValueTypes["PointOfSaleCategoryCreateCategoryEntityRelationInput"] | undefined | null,
	venue?: ValueTypes["PointOfSaleCategoryCreateVenueEntityRelationInput"] | undefined | null,
	ticketPrinters?: Array<ValueTypes["PointOfSaleCategoryCreateTicketPrintersEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleCategoryCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["PointOfSaleCategoryLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["PointOfSaleCategoryLocaleWithoutRootCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PointOfSaleCategoryLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	locale?: ValueTypes["PointOfSaleCategoryLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleCategoryLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["LocaleWithoutPointOfSaleCategoriesCreateInput"] | undefined | null
};
	["LocaleWithoutPointOfSaleCategoriesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	businessCategories?: Array<ValueTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleCreateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleCreatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleCreateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreateDeliveryMethodsEntityRelationInput"]: {
	connect?: ValueTypes["DeliveryMethodLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["DeliveryMethodLocaleWithoutLocaleCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["DeliveryMethodLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	description?: string | undefined | null,
	trackingCodeUrlTemplate?: string | undefined | null,
	processingTitle?: string | undefined | null,
	processingText?: string | undefined | null,
	processingIconUrl?: string | undefined | null,
	dispatchedTitle?: string | undefined | null,
	dispatchedText?: string | undefined | null,
	dispatchedIconUrl?: string | undefined | null,
	fulfilledTitle?: string | undefined | null,
	fulfilledText?: string | undefined | null,
	fulfilledIconUrl?: string | undefined | null,
	root?: ValueTypes["DeliveryMethodLocaleCreateRootEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryMethodLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["DeliveryMethodUniqueWhere"] | undefined | null,
	create?: ValueTypes["DeliveryMethodWithoutLocalesCreateInput"] | undefined | null
};
	["DeliveryMethodWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	enabled?: boolean | undefined | null,
	paymentMethods?: Array<ValueTypes["DeliveryMethodCreatePaymentMethodsEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	requireDeliveryAddress?: boolean | undefined | null,
	suitableForDeliveryZones?: Array<ValueTypes["DeliveryMethodCreateSuitableForDeliveryZonesEntityRelationInput"]> | undefined | null,
	channels?: Array<ValueTypes["DeliveryMethodCreateChannelsEntityRelationInput"]> | undefined | null,
	courierHandlers?: Array<ValueTypes["DeliveryMethodCreateCourierHandlersEntityRelationInput"]> | undefined | null,
	enableDeliveryTracking?: boolean | undefined | null,
	timelinePreset?: ValueTypes["DeliveryMethodCreateTimelinePresetEntityRelationInput"] | undefined | null,
	woltDriveVenueId?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryMethodCreateTimelinePresetEntityRelationInput"]: {
	connect?: ValueTypes["DeliveryTimelinePresetUniqueWhere"] | undefined | null,
	create?: ValueTypes["DeliveryTimelinePresetWithoutDeliveryMethodCreateInput"] | undefined | null
};
	["DeliveryTimelinePresetWithoutDeliveryMethodCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	type?: ValueTypes["DeliveryTimelineType"] | undefined | null,
	duration?: string | undefined | null,
	window?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreateIngredientSuppliersEntityRelationInput"]: {
	connect?: ValueTypes["IngredientSupplierLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["IngredientSupplierLocaleWithoutLocaleCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["IngredientSupplierLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	root?: ValueTypes["IngredientSupplierLocaleCreateRootEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IngredientSupplierLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["IngredientSupplierUniqueWhere"] | undefined | null,
	create?: ValueTypes["IngredientSupplierWithoutLocalesCreateInput"] | undefined | null
};
	["IngredientSupplierWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	internalName?: string | undefined | null,
	internalNote?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreateIdentificationCodesEntityRelationInput"]: {
	connect?: ValueTypes["IdentificationCodeLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["IdentificationCodeLocaleWithoutLocaleCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["IdentificationCodeLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	successMessage?: string | undefined | null,
	root?: ValueTypes["IdentificationCodeLocaleCreateRootEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IdentificationCodeLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["IdentificationCodeUniqueWhere"] | undefined | null,
	create?: ValueTypes["IdentificationCodeWithoutLocalesCreateInput"] | undefined | null
};
	["IdentificationCodeWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	attempts?: Array<ValueTypes["IdentificationCodeCreateAttemptsEntityRelationInput"]> | undefined | null,
	internalName?: string | undefined | null,
	applicationDevices?: Array<ValueTypes["IdentificationCodeCreateApplicationDevicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IdentificationCodeCreateApplicationDevicesEntityRelationInput"]: {
	connect?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null,
	create?: ValueTypes["PointOfSaleApplicationDeviceWithoutIdentificationCodeCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PointOfSaleApplicationDeviceWithoutIdentificationCodeCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	internalName?: string | undefined | null,
	note?: string | undefined | null,
	venue?: ValueTypes["PointOfSaleApplicationDeviceCreateVenueEntityRelationInput"] | undefined | null,
	identifier?: ValueTypes["PointOfSaleApplicationDeviceCreateIdentifierEntityRelationInput"] | undefined | null,
	terminal?: ValueTypes["PointOfSaleApplicationDeviceCreateTerminalEntityRelationInput"] | undefined | null,
	receiptPrinter?: ValueTypes["PointOfSaleApplicationDeviceCreateReceiptPrinterEntityRelationInput"] | undefined | null,
	ticketPrinters?: Array<ValueTypes["PointOfSaleApplicationDeviceCreateTicketPrintersEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleApplicationDeviceCreateTerminalEntityRelationInput"]: {
	connect?: ValueTypes["PointOfSaleTerminalUniqueWhere"] | undefined | null,
	create?: ValueTypes["PointOfSaleTerminalWithoutApplicationDevicesCreateInput"] | undefined | null
};
	["PointOfSaleTerminalWithoutApplicationDevicesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	internalName?: string | undefined | null,
	note?: string | undefined | null,
	venue?: ValueTypes["PointOfSaleTerminalCreateVenueEntityRelationInput"] | undefined | null,
	ipAddress?: string | undefined | null,
	port?: number | undefined | null,
	type?: ValueTypes["PointOfSaleTerminalType"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleTerminalCreateVenueEntityRelationInput"]: {
	connect?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	create?: ValueTypes["VenueWithoutPointOfSaleTerminalsCreateInput"] | undefined | null
};
	["VenueWithoutPointOfSaleTerminalsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	deadlineTemplate?: ValueTypes["VenueCreateDeadlineTemplateEntityRelationInput"] | undefined | null,
	timetableDays?: Array<ValueTypes["VenueCreateTimetableDaysEntityRelationInput"]> | undefined | null,
	timetableTemplates?: Array<ValueTypes["VenueCreateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	staffMembers?: Array<ValueTypes["VenueCreateStaffMembersEntityRelationInput"]> | undefined | null,
	employeeRoles?: Array<ValueTypes["VenueCreateEmployeeRolesEntityRelationInput"]> | undefined | null,
	pointOfSaleApplicationDevices?: Array<ValueTypes["VenueCreatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined | null,
	pointOfSalePrinters?: Array<ValueTypes["VenueCreatePointOfSalePrintersEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["VenueCreateOrdersEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["VenueCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	areas?: Array<ValueTypes["VenueCreateAreasEntityRelationInput"]> | undefined | null,
	enabledUnassignReasons?: Array<ValueTypes["VenueCreateEnabledUnassignReasonsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["VenueCreateCategoriesEntityRelationInput"]> | undefined | null,
	channels?: Array<ValueTypes["VenueCreateChannelsEntityRelationInput"]> | undefined | null,
	address?: string | undefined | null,
	pointOfSalePngBase64ReceiptLogo?: string | undefined | null,
	pointOfSaleInitialView?: ValueTypes["PointOfSaleInitialView"] | undefined | null,
	pointOfSalePreferPrintReceipt?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VenueCreateOrdersEntityRelationInput"]: {
	connect?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	create?: ValueTypes["OrderWithoutVenueCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["OrderWithoutVenueCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	state?: ValueTypes["OrderState"] | undefined | null,
	fulfilledAt?: ValueTypes["DateTime"] | undefined | null,
	canceledAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	customer?: ValueTypes["OrderCreateCustomerEntityRelationInput"] | undefined | null,
	channel?: ValueTypes["OrderCreateChannelEntityRelationInput"] | undefined | null,
	discounts?: Array<ValueTypes["OrderCreateDiscountsEntityRelationInput"]> | undefined | null,
	delivery?: ValueTypes["OrderCreateDeliveryEntityRelationInput"] | undefined | null,
	items?: Array<ValueTypes["OrderCreateItemsEntityRelationInput"]> | undefined | null,
	internalNote?: string | undefined | null,
	cart?: ValueTypes["OrderCreateCartEntityRelationInput"] | undefined | null,
	events?: Array<ValueTypes["OrderCreateEventsEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingAddress?: ValueTypes["OrderCreateBillingAddressEntityRelationInput"] | undefined | null,
	priceLines?: Array<ValueTypes["OrderCreatePriceLinesEntityRelationInput"]> | undefined | null,
	payments?: Array<ValueTypes["OrderCreatePaymentsEntityRelationInput"]> | undefined | null,
	seq?: number | undefined | null,
	billingSubject?: ValueTypes["OrderCreateBillingSubjectEntityRelationInput"] | undefined | null,
	summary?: ValueTypes["OrderCreateSummaryEntityRelationInput"] | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	gratuity?: ValueTypes["OrderCreateGratuityEntityRelationInput"] | undefined | null,
	fulfillmentNote?: string | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["OrderCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	doubleshotTotalWeightGrams?: number | undefined | null,
	doubleShotLegacyNumber?: string | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	doubleshotAdminUrl?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["OrderItemUniqueWhere"] | undefined | null,
	create?: ValueTypes["OrderItemWithoutOrderCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["OrderItemWithoutOrderCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	unitPriceCents?: number | undefined | null,
	quantity?: number | undefined | null,
	vatRate?: ValueTypes["OrderItemCreateVatRateEntityRelationInput"] | undefined | null,
	virtualProductEffects?: Array<ValueTypes["OrderItemCreateVirtualProductEffectsEntityRelationInput"]> | undefined | null,
	pickedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["OrderItemCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	product?: ValueTypes["OrderItemCreateProductEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderItemCreateVirtualProductEffectsEntityRelationInput"]: {
	connect?: ValueTypes["VirtualProductEffectUniqueWhere"] | undefined | null,
	create?: ValueTypes["VirtualProductEffectWithoutOrderItemCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["VirtualProductEffectWithoutOrderItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	succeededAt?: ValueTypes["DateTime"] | undefined | null,
	failedAt?: ValueTypes["DateTime"] | undefined | null,
	revertedAt?: ValueTypes["DateTime"] | undefined | null,
	resultCustomerCreditTransaction?: ValueTypes["VirtualProductEffectCreateResultCustomerCreditTransactionEntityRelationInput"] | undefined | null,
	resultVouchers?: Array<ValueTypes["VirtualProductEffectCreateResultVouchersEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VirtualProductEffectCreateResultCustomerCreditTransactionEntityRelationInput"]: {
	connect?: ValueTypes["CustomerCreditTransactionUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerCreditTransactionWithoutVirtualProductEffectCreateInput"] | undefined | null
};
	["CustomerCreditTransactionWithoutVirtualProductEffectCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	amountCents?: number | undefined | null,
	customerCredit?: ValueTypes["CustomerCreditTransactionCreateCustomerCreditEntityRelationInput"] | undefined | null,
	orderDiscount?: ValueTypes["CustomerCreditTransactionCreateOrderDiscountEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreditTransactionCreateOrderDiscountEntityRelationInput"]: {
	connect?: ValueTypes["OrderDiscountUniqueWhere"] | undefined | null,
	create?: ValueTypes["OrderDiscountWithoutCustomerCreditTransactionsCreateInput"] | undefined | null
};
	["OrderDiscountWithoutCustomerCreditTransactionsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	discountCents?: number | undefined | null,
	vatRate?: ValueTypes["OrderDiscountCreateVatRateEntityRelationInput"] | undefined | null,
	order?: ValueTypes["OrderDiscountCreateOrderEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	type?: ValueTypes["OrderDiscountType"] | undefined | null,
	voucherRedemption?: ValueTypes["OrderDiscountCreateVoucherRedemptionEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderDiscountCreateOrderEntityRelationInput"]: {
	connect?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	create?: ValueTypes["OrderWithoutDiscountsCreateInput"] | undefined | null
};
	["OrderWithoutDiscountsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	state?: ValueTypes["OrderState"] | undefined | null,
	fulfilledAt?: ValueTypes["DateTime"] | undefined | null,
	canceledAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	customer?: ValueTypes["OrderCreateCustomerEntityRelationInput"] | undefined | null,
	channel?: ValueTypes["OrderCreateChannelEntityRelationInput"] | undefined | null,
	delivery?: ValueTypes["OrderCreateDeliveryEntityRelationInput"] | undefined | null,
	items?: Array<ValueTypes["OrderCreateItemsEntityRelationInput"]> | undefined | null,
	internalNote?: string | undefined | null,
	cart?: ValueTypes["OrderCreateCartEntityRelationInput"] | undefined | null,
	events?: Array<ValueTypes["OrderCreateEventsEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingAddress?: ValueTypes["OrderCreateBillingAddressEntityRelationInput"] | undefined | null,
	priceLines?: Array<ValueTypes["OrderCreatePriceLinesEntityRelationInput"]> | undefined | null,
	payments?: Array<ValueTypes["OrderCreatePaymentsEntityRelationInput"]> | undefined | null,
	seq?: number | undefined | null,
	billingSubject?: ValueTypes["OrderCreateBillingSubjectEntityRelationInput"] | undefined | null,
	summary?: ValueTypes["OrderCreateSummaryEntityRelationInput"] | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	gratuity?: ValueTypes["OrderCreateGratuityEntityRelationInput"] | undefined | null,
	venue?: ValueTypes["OrderCreateVenueEntityRelationInput"] | undefined | null,
	fulfillmentNote?: string | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["OrderCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	doubleshotTotalWeightGrams?: number | undefined | null,
	doubleShotLegacyNumber?: string | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	doubleshotAdminUrl?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderCreateCartEntityRelationInput"]: {
	connect?: ValueTypes["CartUniqueWhere"] | undefined | null,
	create?: ValueTypes["CartWithoutOrderCreateInput"] | undefined | null
};
	["CartWithoutOrderCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	confirmedAt?: ValueTypes["DateTime"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	items?: Array<ValueTypes["CartCreateItemsEntityRelationInput"]> | undefined | null,
	handle?: string | undefined | null,
	state?: ValueTypes["CartState"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	channel?: ValueTypes["CartCreateChannelEntityRelationInput"] | undefined | null,
	customer?: ValueTypes["CartCreateCustomerEntityRelationInput"] | undefined | null,
	deliveryAddress?: ValueTypes["CartCreateDeliveryAddressEntityRelationInput"] | undefined | null,
	billingAddress?: ValueTypes["CartCreateBillingAddressEntityRelationInput"] | undefined | null,
	deliveryOption?: string | undefined | null,
	paymentOption?: string | undefined | null,
	delivery?: ValueTypes["CartCreateDeliveryEntityRelationInput"] | undefined | null,
	payment?: ValueTypes["CartCreatePaymentEntityRelationInput"] | undefined | null,
	billingSubject?: ValueTypes["CartCreateBillingSubjectEntityRelationInput"] | undefined | null,
	priceLines?: Array<ValueTypes["CartCreatePriceLinesEntityRelationInput"]> | undefined | null,
	summary?: ValueTypes["CartCreateSummaryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CartCreateCustomerEntityRelationInput"]: {
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerWithoutCartsCreateInput"] | undefined | null
};
	["CustomerWithoutCartsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	addresses?: Array<ValueTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerCreateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerCreateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerCreatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerCreateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerCreateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerCreateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerCreateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerCreateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerCreateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreateInvoicingPlanEntityRelationInput"]: {
	connect?: ValueTypes["InvoicingPlanUniqueWhere"] | undefined | null,
	create?: ValueTypes["InvoicingPlanWithoutCustomerCreateInput"] | undefined | null
};
	["InvoicingPlanWithoutCustomerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	preset?: ValueTypes["InvoicingPlanCreatePresetEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InvoicingPlanCreatePresetEntityRelationInput"]: {
	connect?: ValueTypes["InvoicingPresetUniqueWhere"] | undefined | null,
	create?: ValueTypes["InvoicingPresetWithoutInvoicingPlanCreateInput"] | undefined | null
};
	["InvoicingPresetWithoutInvoicingPlanCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	type?: ValueTypes["InvoicingPresetType"] | undefined | null,
	startsAt?: ValueTypes["DateTime"] | undefined | null,
	endsAt?: ValueTypes["DateTime"] | undefined | null,
	intervalOfDays?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreateBillingSubjectsEntityRelationInput"]: {
	connect?: ValueTypes["BillingSubjectUniqueWhere"] | undefined | null,
	create?: ValueTypes["BillingSubjectWithoutCustomerCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["BillingSubjectWithoutCustomerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	fullName?: string | undefined | null,
	addressLine1?: string | undefined | null,
	addressLine2?: string | undefined | null,
	city?: string | undefined | null,
	postalCode?: string | undefined | null,
	email?: string | undefined | null,
	phone?: string | undefined | null,
	companyName?: string | undefined | null,
	companyIdentifier?: string | undefined | null,
	vatIdentifier?: string | undefined | null,
	externalIdentifier?: string | undefined | null,
	hidden?: boolean | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	internalNote?: string | undefined | null,
	fakturoidSubjectId?: string | undefined | null,
	country?: ValueTypes["BillingSubjectCreateCountryEntityRelationInput"] | undefined | null,
	invoices?: Array<ValueTypes["BillingSubjectCreateInvoicesEntityRelationInput"]> | undefined | null,
	defaultBillingSubjectOfCustomer?: ValueTypes["BillingSubjectCreateDefaultBillingSubjectOfCustomerEntityRelationInput"] | undefined | null,
	orders?: Array<ValueTypes["BillingSubjectCreateOrdersEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BillingSubjectCreateCountryEntityRelationInput"]: {
	connect?: ValueTypes["CountryUniqueWhere"] | undefined | null,
	create?: ValueTypes["CountryCreateInput"] | undefined | null
};
	["BillingSubjectCreateInvoicesEntityRelationInput"]: {
	connect?: ValueTypes["InvoiceUniqueWhere"] | undefined | null,
	create?: ValueTypes["InvoiceWithoutBillingSubjectCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["InvoiceWithoutBillingSubjectCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	publicKey?: string | undefined | null,
	fakturoidId?: string | undefined | null,
	fakturoidData?: string | undefined | null,
	legacyUrl?: string | undefined | null,
	customer?: ValueTypes["InvoiceCreateCustomerEntityRelationInput"] | undefined | null,
	orderPayments?: Array<ValueTypes["InvoiceCreateOrderPaymentsEntityRelationInput"]> | undefined | null,
	address?: ValueTypes["InvoiceCreateAddressEntityRelationInput"] | undefined | null,
	publicUrl?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InvoiceCreateAddressEntityRelationInput"]: {
	connect?: ValueTypes["AddressUniqueWhere"] | undefined | null,
	create?: ValueTypes["AddressWithoutInvoicesCreateInput"] | undefined | null
};
	["AddressWithoutInvoicesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	addressLine2?: string | undefined | null,
	email?: string | undefined | null,
	phone?: string | undefined | null,
	companyName?: string | undefined | null,
	companyIdentifier?: string | undefined | null,
	vatIdentifier?: string | undefined | null,
	externalIdentifier?: string | undefined | null,
	hidden?: boolean | undefined | null,
	customer?: ValueTypes["AddressCreateCustomerEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	country?: ValueTypes["AddressCreateCountryEntityRelationInput"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	googlePlaceId?: string | undefined | null,
	raw?: string | undefined | null,
	formatted?: string | undefined | null,
	geocodeGeneratedAt?: ValueTypes["DateTime"] | undefined | null,
	geocodeResponse?: string | undefined | null,
	deliveryZone?: ValueTypes["AddressCreateDeliveryZoneEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["AddressCreateMetaEntityRelationInput"] | undefined | null,
	gps?: ValueTypes["AddressCreateGpsEntityRelationInput"] | undefined | null,
	geocodeValid?: boolean | undefined | null,
	fullName?: string | undefined | null,
	fakturoidSubjectId?: string | undefined | null,
	addressLine1?: string | undefined | null,
	city?: string | undefined | null,
	postalCode?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingAddressOfOrders?: Array<ValueTypes["AddressCreateBillingAddressOfOrdersEntityRelationInput"]> | undefined | null,
	deliveryAddressOfOrderDeliveries?: Array<ValueTypes["AddressCreateDeliveryAddressOfOrderDeliveriesEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddressOfCustomer?: ValueTypes["AddressCreateDefaultDeliveryAddressOfCustomerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AddressCreateBillingAddressOfOrdersEntityRelationInput"]: {
	connect?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	create?: ValueTypes["OrderWithoutBillingAddressCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["OrderWithoutBillingAddressCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	state?: ValueTypes["OrderState"] | undefined | null,
	fulfilledAt?: ValueTypes["DateTime"] | undefined | null,
	canceledAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	customer?: ValueTypes["OrderCreateCustomerEntityRelationInput"] | undefined | null,
	channel?: ValueTypes["OrderCreateChannelEntityRelationInput"] | undefined | null,
	discounts?: Array<ValueTypes["OrderCreateDiscountsEntityRelationInput"]> | undefined | null,
	delivery?: ValueTypes["OrderCreateDeliveryEntityRelationInput"] | undefined | null,
	items?: Array<ValueTypes["OrderCreateItemsEntityRelationInput"]> | undefined | null,
	internalNote?: string | undefined | null,
	cart?: ValueTypes["OrderCreateCartEntityRelationInput"] | undefined | null,
	events?: Array<ValueTypes["OrderCreateEventsEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	priceLines?: Array<ValueTypes["OrderCreatePriceLinesEntityRelationInput"]> | undefined | null,
	payments?: Array<ValueTypes["OrderCreatePaymentsEntityRelationInput"]> | undefined | null,
	seq?: number | undefined | null,
	billingSubject?: ValueTypes["OrderCreateBillingSubjectEntityRelationInput"] | undefined | null,
	summary?: ValueTypes["OrderCreateSummaryEntityRelationInput"] | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	gratuity?: ValueTypes["OrderCreateGratuityEntityRelationInput"] | undefined | null,
	venue?: ValueTypes["OrderCreateVenueEntityRelationInput"] | undefined | null,
	fulfillmentNote?: string | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["OrderCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	doubleshotTotalWeightGrams?: number | undefined | null,
	doubleShotLegacyNumber?: string | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	doubleshotAdminUrl?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderCreateEventsEntityRelationInput"]: {
	connect?: ValueTypes["OrderEventUniqueWhere"] | undefined | null,
	create?: ValueTypes["OrderEventWithoutOrderCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["OrderEventWithoutOrderCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	type?: string | undefined | null,
	data?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	payment?: ValueTypes["OrderEventCreatePaymentEntityRelationInput"] | undefined | null,
	delivery?: ValueTypes["OrderEventCreateDeliveryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderEventCreatePaymentEntityRelationInput"]: {
	connect?: ValueTypes["OrderPaymentUniqueWhere"] | undefined | null,
	create?: ValueTypes["OrderPaymentWithoutEventsCreateInput"] | undefined | null
};
	["OrderPaymentWithoutEventsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	data?: ValueTypes["Json"] | undefined | null,
	paymentCents?: number | undefined | null,
	method?: ValueTypes["OrderPaymentCreateMethodEntityRelationInput"] | undefined | null,
	failedAt?: ValueTypes["DateTime"] | undefined | null,
	state?: ValueTypes["OrderPaymentState"] | undefined | null,
	approvedAt?: ValueTypes["DateTime"] | undefined | null,
	order?: ValueTypes["OrderPaymentCreateOrderEntityRelationInput"] | undefined | null,
	invoice?: ValueTypes["OrderPaymentCreateInvoiceEntityRelationInput"] | undefined | null,
	walletType?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	publicReceiptUrl?: string | undefined | null,
	priceCents?: number | undefined | null,
	vatRate?: ValueTypes["OrderPaymentCreateVatRateEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["OrderPaymentCreateMetaEntityRelationInput"] | undefined | null,
	otherCurrencyPriceCents?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderPaymentCreateOrderEntityRelationInput"]: {
	connect?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	create?: ValueTypes["OrderWithoutPaymentsCreateInput"] | undefined | null
};
	["OrderWithoutPaymentsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	state?: ValueTypes["OrderState"] | undefined | null,
	fulfilledAt?: ValueTypes["DateTime"] | undefined | null,
	canceledAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	customer?: ValueTypes["OrderCreateCustomerEntityRelationInput"] | undefined | null,
	channel?: ValueTypes["OrderCreateChannelEntityRelationInput"] | undefined | null,
	discounts?: Array<ValueTypes["OrderCreateDiscountsEntityRelationInput"]> | undefined | null,
	delivery?: ValueTypes["OrderCreateDeliveryEntityRelationInput"] | undefined | null,
	items?: Array<ValueTypes["OrderCreateItemsEntityRelationInput"]> | undefined | null,
	internalNote?: string | undefined | null,
	cart?: ValueTypes["OrderCreateCartEntityRelationInput"] | undefined | null,
	events?: Array<ValueTypes["OrderCreateEventsEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingAddress?: ValueTypes["OrderCreateBillingAddressEntityRelationInput"] | undefined | null,
	priceLines?: Array<ValueTypes["OrderCreatePriceLinesEntityRelationInput"]> | undefined | null,
	seq?: number | undefined | null,
	billingSubject?: ValueTypes["OrderCreateBillingSubjectEntityRelationInput"] | undefined | null,
	summary?: ValueTypes["OrderCreateSummaryEntityRelationInput"] | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	gratuity?: ValueTypes["OrderCreateGratuityEntityRelationInput"] | undefined | null,
	venue?: ValueTypes["OrderCreateVenueEntityRelationInput"] | undefined | null,
	fulfillmentNote?: string | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["OrderCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	doubleshotTotalWeightGrams?: number | undefined | null,
	doubleShotLegacyNumber?: string | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	doubleshotAdminUrl?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderCreateBillingAddressEntityRelationInput"]: {
	connect?: ValueTypes["AddressUniqueWhere"] | undefined | null,
	create?: ValueTypes["AddressWithoutBillingAddressOfOrdersCreateInput"] | undefined | null
};
	["AddressWithoutBillingAddressOfOrdersCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	addressLine2?: string | undefined | null,
	email?: string | undefined | null,
	phone?: string | undefined | null,
	companyName?: string | undefined | null,
	companyIdentifier?: string | undefined | null,
	vatIdentifier?: string | undefined | null,
	externalIdentifier?: string | undefined | null,
	hidden?: boolean | undefined | null,
	customer?: ValueTypes["AddressCreateCustomerEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	country?: ValueTypes["AddressCreateCountryEntityRelationInput"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	googlePlaceId?: string | undefined | null,
	raw?: string | undefined | null,
	formatted?: string | undefined | null,
	geocodeGeneratedAt?: ValueTypes["DateTime"] | undefined | null,
	geocodeResponse?: string | undefined | null,
	deliveryZone?: ValueTypes["AddressCreateDeliveryZoneEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["AddressCreateMetaEntityRelationInput"] | undefined | null,
	gps?: ValueTypes["AddressCreateGpsEntityRelationInput"] | undefined | null,
	geocodeValid?: boolean | undefined | null,
	fullName?: string | undefined | null,
	fakturoidSubjectId?: string | undefined | null,
	invoices?: Array<ValueTypes["AddressCreateInvoicesEntityRelationInput"]> | undefined | null,
	addressLine1?: string | undefined | null,
	city?: string | undefined | null,
	postalCode?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	deliveryAddressOfOrderDeliveries?: Array<ValueTypes["AddressCreateDeliveryAddressOfOrderDeliveriesEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddressOfCustomer?: ValueTypes["AddressCreateDefaultDeliveryAddressOfCustomerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AddressCreateDeliveryAddressOfOrderDeliveriesEntityRelationInput"]: {
	connect?: ValueTypes["OrderDeliveryUniqueWhere"] | undefined | null,
	create?: ValueTypes["OrderDeliveryWithoutAddressCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["OrderDeliveryWithoutAddressCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	priceCents?: number | undefined | null,
	deliveredAt?: ValueTypes["DateTime"] | undefined | null,
	method?: ValueTypes["OrderDeliveryCreateMethodEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["OrderDeliveryCreateVatRateEntityRelationInput"] | undefined | null,
	order?: ValueTypes["OrderDeliveryCreateOrderEntityRelationInput"] | undefined | null,
	expectedAt?: ValueTypes["DateTime"] | undefined | null,
	state?: ValueTypes["OrderDeliveryState"] | undefined | null,
	loadingDurationHours?: number | undefined | null,
	dispatchAt?: ValueTypes["DateTime"] | undefined | null,
	duration?: string | undefined | null,
	window?: string | undefined | null,
	expectedEndAt?: ValueTypes["DateTime"] | undefined | null,
	processingAt?: ValueTypes["DateTime"] | undefined | null,
	deliveringAt?: ValueTypes["DateTime"] | undefined | null,
	failedAt?: ValueTypes["DateTime"] | undefined | null,
	internalNote?: string | undefined | null,
	deliveryWaypoint?: ValueTypes["OrderDeliveryCreateDeliveryWaypointEntityRelationInput"] | undefined | null,
	events?: Array<ValueTypes["OrderDeliveryCreateEventsEntityRelationInput"]> | undefined | null,
	prepareAt?: ValueTypes["DateTime"] | undefined | null,
	liftagoRide?: ValueTypes["OrderDeliveryCreateLiftagoRideEntityRelationInput"] | undefined | null,
	pickedAt?: ValueTypes["DateTime"] | undefined | null,
	trackingCode?: string | undefined | null,
	woltDriveDelivery?: ValueTypes["OrderDeliveryCreateWoltDriveDeliveryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderDeliveryCreateOrderEntityRelationInput"]: {
	connect?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	create?: ValueTypes["OrderWithoutDeliveryCreateInput"] | undefined | null
};
	["OrderWithoutDeliveryCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	state?: ValueTypes["OrderState"] | undefined | null,
	fulfilledAt?: ValueTypes["DateTime"] | undefined | null,
	canceledAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	customer?: ValueTypes["OrderCreateCustomerEntityRelationInput"] | undefined | null,
	channel?: ValueTypes["OrderCreateChannelEntityRelationInput"] | undefined | null,
	discounts?: Array<ValueTypes["OrderCreateDiscountsEntityRelationInput"]> | undefined | null,
	items?: Array<ValueTypes["OrderCreateItemsEntityRelationInput"]> | undefined | null,
	internalNote?: string | undefined | null,
	cart?: ValueTypes["OrderCreateCartEntityRelationInput"] | undefined | null,
	events?: Array<ValueTypes["OrderCreateEventsEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingAddress?: ValueTypes["OrderCreateBillingAddressEntityRelationInput"] | undefined | null,
	priceLines?: Array<ValueTypes["OrderCreatePriceLinesEntityRelationInput"]> | undefined | null,
	payments?: Array<ValueTypes["OrderCreatePaymentsEntityRelationInput"]> | undefined | null,
	seq?: number | undefined | null,
	billingSubject?: ValueTypes["OrderCreateBillingSubjectEntityRelationInput"] | undefined | null,
	summary?: ValueTypes["OrderCreateSummaryEntityRelationInput"] | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	gratuity?: ValueTypes["OrderCreateGratuityEntityRelationInput"] | undefined | null,
	venue?: ValueTypes["OrderCreateVenueEntityRelationInput"] | undefined | null,
	fulfillmentNote?: string | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["OrderCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	doubleshotTotalWeightGrams?: number | undefined | null,
	doubleShotLegacyNumber?: string | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	doubleshotAdminUrl?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderCreatePriceLinesEntityRelationInput"]: {
	connect?: ValueTypes["OrderPriceLineUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["OrderCreatePaymentsEntityRelationInput"]: {
	connect?: ValueTypes["OrderPaymentUniqueWhere"] | undefined | null,
	create?: ValueTypes["OrderPaymentWithoutOrderCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["OrderPaymentWithoutOrderCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	data?: ValueTypes["Json"] | undefined | null,
	paymentCents?: number | undefined | null,
	method?: ValueTypes["OrderPaymentCreateMethodEntityRelationInput"] | undefined | null,
	failedAt?: ValueTypes["DateTime"] | undefined | null,
	state?: ValueTypes["OrderPaymentState"] | undefined | null,
	approvedAt?: ValueTypes["DateTime"] | undefined | null,
	events?: Array<ValueTypes["OrderPaymentCreateEventsEntityRelationInput"]> | undefined | null,
	invoice?: ValueTypes["OrderPaymentCreateInvoiceEntityRelationInput"] | undefined | null,
	walletType?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	publicReceiptUrl?: string | undefined | null,
	priceCents?: number | undefined | null,
	vatRate?: ValueTypes["OrderPaymentCreateVatRateEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["OrderPaymentCreateMetaEntityRelationInput"] | undefined | null,
	otherCurrencyPriceCents?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderPaymentCreateInvoiceEntityRelationInput"]: {
	connect?: ValueTypes["InvoiceUniqueWhere"] | undefined | null,
	create?: ValueTypes["InvoiceWithoutOrderPaymentsCreateInput"] | undefined | null
};
	["InvoiceWithoutOrderPaymentsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	publicKey?: string | undefined | null,
	fakturoidId?: string | undefined | null,
	fakturoidData?: string | undefined | null,
	legacyUrl?: string | undefined | null,
	customer?: ValueTypes["InvoiceCreateCustomerEntityRelationInput"] | undefined | null,
	address?: ValueTypes["InvoiceCreateAddressEntityRelationInput"] | undefined | null,
	publicUrl?: string | undefined | null,
	billingSubject?: ValueTypes["InvoiceCreateBillingSubjectEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InvoiceCreateBillingSubjectEntityRelationInput"]: {
	connect?: ValueTypes["BillingSubjectUniqueWhere"] | undefined | null,
	create?: ValueTypes["BillingSubjectWithoutInvoicesCreateInput"] | undefined | null
};
	["BillingSubjectWithoutInvoicesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	fullName?: string | undefined | null,
	addressLine1?: string | undefined | null,
	addressLine2?: string | undefined | null,
	city?: string | undefined | null,
	postalCode?: string | undefined | null,
	email?: string | undefined | null,
	phone?: string | undefined | null,
	companyName?: string | undefined | null,
	companyIdentifier?: string | undefined | null,
	vatIdentifier?: string | undefined | null,
	externalIdentifier?: string | undefined | null,
	hidden?: boolean | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	internalNote?: string | undefined | null,
	fakturoidSubjectId?: string | undefined | null,
	country?: ValueTypes["BillingSubjectCreateCountryEntityRelationInput"] | undefined | null,
	customer?: ValueTypes["BillingSubjectCreateCustomerEntityRelationInput"] | undefined | null,
	defaultBillingSubjectOfCustomer?: ValueTypes["BillingSubjectCreateDefaultBillingSubjectOfCustomerEntityRelationInput"] | undefined | null,
	orders?: Array<ValueTypes["BillingSubjectCreateOrdersEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BillingSubjectCreateCustomerEntityRelationInput"]: {
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerWithoutBillingSubjectsCreateInput"] | undefined | null
};
	["CustomerWithoutBillingSubjectsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	addresses?: Array<ValueTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerCreateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerCreateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerCreatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerCreateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerCreateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerCreateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerCreateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerCreateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerCreateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerCreateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreateOfferedProductsEntityRelationInput"]: {
	connect?: ValueTypes["ProductCustomerPriceUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerCreateDefaultDeliveryAddressEntityRelationInput"]: {
	connect?: ValueTypes["AddressUniqueWhere"] | undefined | null,
	create?: ValueTypes["AddressWithoutDefaultDeliveryAddressOfCustomerCreateInput"] | undefined | null
};
	["AddressWithoutDefaultDeliveryAddressOfCustomerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	addressLine2?: string | undefined | null,
	email?: string | undefined | null,
	phone?: string | undefined | null,
	companyName?: string | undefined | null,
	companyIdentifier?: string | undefined | null,
	vatIdentifier?: string | undefined | null,
	externalIdentifier?: string | undefined | null,
	hidden?: boolean | undefined | null,
	customer?: ValueTypes["AddressCreateCustomerEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	country?: ValueTypes["AddressCreateCountryEntityRelationInput"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	googlePlaceId?: string | undefined | null,
	raw?: string | undefined | null,
	formatted?: string | undefined | null,
	geocodeGeneratedAt?: ValueTypes["DateTime"] | undefined | null,
	geocodeResponse?: string | undefined | null,
	deliveryZone?: ValueTypes["AddressCreateDeliveryZoneEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["AddressCreateMetaEntityRelationInput"] | undefined | null,
	gps?: ValueTypes["AddressCreateGpsEntityRelationInput"] | undefined | null,
	geocodeValid?: boolean | undefined | null,
	fullName?: string | undefined | null,
	fakturoidSubjectId?: string | undefined | null,
	invoices?: Array<ValueTypes["AddressCreateInvoicesEntityRelationInput"]> | undefined | null,
	addressLine1?: string | undefined | null,
	city?: string | undefined | null,
	postalCode?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingAddressOfOrders?: Array<ValueTypes["AddressCreateBillingAddressOfOrdersEntityRelationInput"]> | undefined | null,
	deliveryAddressOfOrderDeliveries?: Array<ValueTypes["AddressCreateDeliveryAddressOfOrderDeliveriesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreateDefaultBillingSubjectEntityRelationInput"]: {
	connect?: ValueTypes["BillingSubjectUniqueWhere"] | undefined | null,
	create?: ValueTypes["BillingSubjectWithoutDefaultBillingSubjectOfCustomerCreateInput"] | undefined | null
};
	["BillingSubjectWithoutDefaultBillingSubjectOfCustomerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	fullName?: string | undefined | null,
	addressLine1?: string | undefined | null,
	addressLine2?: string | undefined | null,
	city?: string | undefined | null,
	postalCode?: string | undefined | null,
	email?: string | undefined | null,
	phone?: string | undefined | null,
	companyName?: string | undefined | null,
	companyIdentifier?: string | undefined | null,
	vatIdentifier?: string | undefined | null,
	externalIdentifier?: string | undefined | null,
	hidden?: boolean | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	internalNote?: string | undefined | null,
	fakturoidSubjectId?: string | undefined | null,
	country?: ValueTypes["BillingSubjectCreateCountryEntityRelationInput"] | undefined | null,
	customer?: ValueTypes["BillingSubjectCreateCustomerEntityRelationInput"] | undefined | null,
	invoices?: Array<ValueTypes["BillingSubjectCreateInvoicesEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["BillingSubjectCreateOrdersEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BillingSubjectCreateOrdersEntityRelationInput"]: {
	connect?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	create?: ValueTypes["OrderWithoutBillingSubjectCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["OrderWithoutBillingSubjectCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	state?: ValueTypes["OrderState"] | undefined | null,
	fulfilledAt?: ValueTypes["DateTime"] | undefined | null,
	canceledAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	customer?: ValueTypes["OrderCreateCustomerEntityRelationInput"] | undefined | null,
	channel?: ValueTypes["OrderCreateChannelEntityRelationInput"] | undefined | null,
	discounts?: Array<ValueTypes["OrderCreateDiscountsEntityRelationInput"]> | undefined | null,
	delivery?: ValueTypes["OrderCreateDeliveryEntityRelationInput"] | undefined | null,
	items?: Array<ValueTypes["OrderCreateItemsEntityRelationInput"]> | undefined | null,
	internalNote?: string | undefined | null,
	cart?: ValueTypes["OrderCreateCartEntityRelationInput"] | undefined | null,
	events?: Array<ValueTypes["OrderCreateEventsEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingAddress?: ValueTypes["OrderCreateBillingAddressEntityRelationInput"] | undefined | null,
	priceLines?: Array<ValueTypes["OrderCreatePriceLinesEntityRelationInput"]> | undefined | null,
	payments?: Array<ValueTypes["OrderCreatePaymentsEntityRelationInput"]> | undefined | null,
	seq?: number | undefined | null,
	summary?: ValueTypes["OrderCreateSummaryEntityRelationInput"] | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	gratuity?: ValueTypes["OrderCreateGratuityEntityRelationInput"] | undefined | null,
	venue?: ValueTypes["OrderCreateVenueEntityRelationInput"] | undefined | null,
	fulfillmentNote?: string | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["OrderCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	doubleshotTotalWeightGrams?: number | undefined | null,
	doubleShotLegacyNumber?: string | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	doubleshotAdminUrl?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderCreateSummaryEntityRelationInput"]: {
	connect?: ValueTypes["OrderSummaryUniqueWhere"] | undefined | null
};
	["OrderCreateGratuityEntityRelationInput"]: {
	connect?: ValueTypes["GratuityUniqueWhere"] | undefined | null,
	create?: ValueTypes["GratuityWithoutOrderCreateInput"] | undefined | null
};
	["GratuityWithoutOrderCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	amountCents?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderCreateVenueEntityRelationInput"]: {
	connect?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	create?: ValueTypes["VenueWithoutOrdersCreateInput"] | undefined | null
};
	["VenueWithoutOrdersCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	deadlineTemplate?: ValueTypes["VenueCreateDeadlineTemplateEntityRelationInput"] | undefined | null,
	timetableDays?: Array<ValueTypes["VenueCreateTimetableDaysEntityRelationInput"]> | undefined | null,
	timetableTemplates?: Array<ValueTypes["VenueCreateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	staffMembers?: Array<ValueTypes["VenueCreateStaffMembersEntityRelationInput"]> | undefined | null,
	employeeRoles?: Array<ValueTypes["VenueCreateEmployeeRolesEntityRelationInput"]> | undefined | null,
	pointOfSaleApplicationDevices?: Array<ValueTypes["VenueCreatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined | null,
	pointOfSaleTerminals?: Array<ValueTypes["VenueCreatePointOfSaleTerminalsEntityRelationInput"]> | undefined | null,
	pointOfSalePrinters?: Array<ValueTypes["VenueCreatePointOfSalePrintersEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["VenueCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	areas?: Array<ValueTypes["VenueCreateAreasEntityRelationInput"]> | undefined | null,
	enabledUnassignReasons?: Array<ValueTypes["VenueCreateEnabledUnassignReasonsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["VenueCreateCategoriesEntityRelationInput"]> | undefined | null,
	channels?: Array<ValueTypes["VenueCreateChannelsEntityRelationInput"]> | undefined | null,
	address?: string | undefined | null,
	pointOfSalePngBase64ReceiptLogo?: string | undefined | null,
	pointOfSaleInitialView?: ValueTypes["PointOfSaleInitialView"] | undefined | null,
	pointOfSalePreferPrintReceipt?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VenueCreateFulfillmentNotesEntityRelationInput"]: {
	connect?: ValueTypes["FulfillmentNoteUniqueWhere"] | undefined | null,
	create?: ValueTypes["FulfillmentNoteWithoutVenuesCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["FulfillmentNoteWithoutVenuesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	note?: string | undefined | null,
	products?: Array<ValueTypes["FulfillmentNoteCreateProductsEntityRelationInput"]> | undefined | null,
	tags?: Array<ValueTypes["FulfillmentNoteCreateTagsEntityRelationInput"]> | undefined | null,
	cartItems?: Array<ValueTypes["FulfillmentNoteCreateCartItemsEntityRelationInput"]> | undefined | null,
	orderItems?: Array<ValueTypes["FulfillmentNoteCreateOrderItemsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["FulfillmentNoteCreateOrdersEntityRelationInput"]> | undefined | null,
	highlight?: boolean | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	emoji?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FulfillmentNoteCreateCartItemsEntityRelationInput"]: {
	connect?: ValueTypes["CartItemUniqueWhere"] | undefined | null,
	create?: ValueTypes["CartItemWithoutFulfillmentNotesCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["CartItemWithoutFulfillmentNotesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	quantity?: number | undefined | null,
	cart?: ValueTypes["CartItemCreateCartEntityRelationInput"] | undefined | null,
	product?: ValueTypes["CartItemCreateProductEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	updatedAt?: ValueTypes["DateTime"] | undefined | null,
	fulfillmentNote?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FulfillmentNoteCreateOrderItemsEntityRelationInput"]: {
	connect?: ValueTypes["OrderItemUniqueWhere"] | undefined | null,
	create?: ValueTypes["OrderItemWithoutFulfillmentNotesCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["OrderItemWithoutFulfillmentNotesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	unitPriceCents?: number | undefined | null,
	quantity?: number | undefined | null,
	vatRate?: ValueTypes["OrderItemCreateVatRateEntityRelationInput"] | undefined | null,
	order?: ValueTypes["OrderItemCreateOrderEntityRelationInput"] | undefined | null,
	virtualProductEffects?: Array<ValueTypes["OrderItemCreateVirtualProductEffectsEntityRelationInput"]> | undefined | null,
	pickedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	product?: ValueTypes["OrderItemCreateProductEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderItemCreateProductEntityRelationInput"]: {
	connect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductWithoutOrderItemsCreateInput"] | undefined | null
};
	["ProductWithoutOrderItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	priceCents?: number | undefined | null,
	notDiscountable?: boolean | undefined | null,
	packing?: ValueTypes["ProductCreatePackingEntityRelationInput"] | undefined | null,
	recipe?: ValueTypes["ProductCreateRecipeEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["ProductCreateTagsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["ProductCreateCategoriesEntityRelationInput"]> | undefined | null,
	vatRate?: ValueTypes["ProductCreateVatRateEntityRelationInput"] | undefined | null,
	stocks?: Array<ValueTypes["ProductCreateStocksEntityRelationInput"]> | undefined | null,
	groupPrices?: Array<ValueTypes["ProductCreateGroupPricesEntityRelationInput"]> | undefined | null,
	image?: ValueTypes["ProductCreateImageEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	cartItems?: Array<ValueTypes["ProductCreateCartItemsEntityRelationInput"]> | undefined | null,
	availability?: ValueTypes["ProductAvailability"] | undefined | null,
	order?: number | undefined | null,
	manager?: ValueTypes["ProductCreateManagerEntityRelationInput"] | undefined | null,
	maximumQuantityPerOrder?: number | undefined | null,
	inheritedCategories?: Array<ValueTypes["ProductCreateInheritedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["ProductCreateDeliveryZonesEntityRelationInput"]> | undefined | null,
	locales?: Array<ValueTypes["ProductCreateLocalesEntityRelationInput"]> | undefined | null,
	archivedAt?: ValueTypes["DateTime"] | undefined | null,
	customerPrices?: Array<ValueTypes["ProductCreateCustomerPricesEntityRelationInput"]> | undefined | null,
	virtualProduct?: ValueTypes["ProductCreateVirtualProductEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["ProductCreateMetaEntityRelationInput"] | undefined | null,
	page?: ValueTypes["ProductCreatePageEntityRelationInput"] | undefined | null,
	salesDays?: Array<ValueTypes["ProductCreateSalesDaysEntityRelationInput"]> | undefined | null,
	salesWeeks?: Array<ValueTypes["ProductCreateSalesWeeksEntityRelationInput"]> | undefined | null,
	salesMonths?: Array<ValueTypes["ProductCreateSalesMonthsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["ProductCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	hasSubscription?: boolean | undefined | null,
	pointOfSaleTileColor?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FulfillmentNoteCreateOrdersEntityRelationInput"]: {
	connect?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	create?: ValueTypes["OrderWithoutFulfillmentNotesCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["OrderWithoutFulfillmentNotesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	state?: ValueTypes["OrderState"] | undefined | null,
	fulfilledAt?: ValueTypes["DateTime"] | undefined | null,
	canceledAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	customer?: ValueTypes["OrderCreateCustomerEntityRelationInput"] | undefined | null,
	channel?: ValueTypes["OrderCreateChannelEntityRelationInput"] | undefined | null,
	discounts?: Array<ValueTypes["OrderCreateDiscountsEntityRelationInput"]> | undefined | null,
	delivery?: ValueTypes["OrderCreateDeliveryEntityRelationInput"] | undefined | null,
	items?: Array<ValueTypes["OrderCreateItemsEntityRelationInput"]> | undefined | null,
	internalNote?: string | undefined | null,
	cart?: ValueTypes["OrderCreateCartEntityRelationInput"] | undefined | null,
	events?: Array<ValueTypes["OrderCreateEventsEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingAddress?: ValueTypes["OrderCreateBillingAddressEntityRelationInput"] | undefined | null,
	priceLines?: Array<ValueTypes["OrderCreatePriceLinesEntityRelationInput"]> | undefined | null,
	payments?: Array<ValueTypes["OrderCreatePaymentsEntityRelationInput"]> | undefined | null,
	seq?: number | undefined | null,
	billingSubject?: ValueTypes["OrderCreateBillingSubjectEntityRelationInput"] | undefined | null,
	summary?: ValueTypes["OrderCreateSummaryEntityRelationInput"] | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	gratuity?: ValueTypes["OrderCreateGratuityEntityRelationInput"] | undefined | null,
	venue?: ValueTypes["OrderCreateVenueEntityRelationInput"] | undefined | null,
	fulfillmentNote?: string | undefined | null,
	doubleshotTotalWeightGrams?: number | undefined | null,
	doubleShotLegacyNumber?: string | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	doubleshotAdminUrl?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderCreateBillingSubjectEntityRelationInput"]: {
	connect?: ValueTypes["BillingSubjectUniqueWhere"] | undefined | null,
	create?: ValueTypes["BillingSubjectWithoutOrdersCreateInput"] | undefined | null
};
	["BillingSubjectWithoutOrdersCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	fullName?: string | undefined | null,
	addressLine1?: string | undefined | null,
	addressLine2?: string | undefined | null,
	city?: string | undefined | null,
	postalCode?: string | undefined | null,
	email?: string | undefined | null,
	phone?: string | undefined | null,
	companyName?: string | undefined | null,
	companyIdentifier?: string | undefined | null,
	vatIdentifier?: string | undefined | null,
	externalIdentifier?: string | undefined | null,
	hidden?: boolean | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	internalNote?: string | undefined | null,
	fakturoidSubjectId?: string | undefined | null,
	country?: ValueTypes["BillingSubjectCreateCountryEntityRelationInput"] | undefined | null,
	customer?: ValueTypes["BillingSubjectCreateCustomerEntityRelationInput"] | undefined | null,
	invoices?: Array<ValueTypes["BillingSubjectCreateInvoicesEntityRelationInput"]> | undefined | null,
	defaultBillingSubjectOfCustomer?: ValueTypes["BillingSubjectCreateDefaultBillingSubjectOfCustomerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BillingSubjectCreateDefaultBillingSubjectOfCustomerEntityRelationInput"]: {
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerWithoutDefaultBillingSubjectCreateInput"] | undefined | null
};
	["CustomerWithoutDefaultBillingSubjectCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	addresses?: Array<ValueTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerCreateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerCreateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerCreatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerCreateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerCreateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerCreateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerCreateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerCreateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerCreateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerCreateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreateAnonymousSessionEntityRelationInput"]: {
	connect?: ValueTypes["AnonymousSessionUniqueWhere"] | undefined | null,
	create?: ValueTypes["AnonymousSessionWithoutCustomerCreateInput"] | undefined | null
};
	["AnonymousSessionWithoutCustomerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	lastActiveAt?: ValueTypes["DateTime"] | undefined | null,
	anonymousSessionKey?: string | undefined | null,
	email?: string | undefined | null,
	name?: string | undefined | null,
	internalNote?: string | undefined | null,
	devices?: Array<ValueTypes["AnonymousSessionCreateDevicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AnonymousSessionCreateDevicesEntityRelationInput"]: {
	connect?: ValueTypes["UserDeviceUniqueWhere"] | undefined | null,
	create?: ValueTypes["UserDeviceWithoutAnonymousSessionCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["UserDeviceWithoutAnonymousSessionCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	lastActiveAt?: ValueTypes["DateTime"] | undefined | null,
	platform?: string | undefined | null,
	deviceId?: string | undefined | null,
	notificationsEnabled?: boolean | undefined | null,
	user?: ValueTypes["UserDeviceCreateUserEntityRelationInput"] | undefined | null,
	appVersion?: string | undefined | null,
	osVersion?: string | undefined | null,
	apiVersion?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserDeviceCreateUserEntityRelationInput"]: {
	connect?: ValueTypes["UserUniqueWhere"] | undefined | null,
	create?: ValueTypes["UserWithoutDevicesCreateInput"] | undefined | null
};
	["UserWithoutDevicesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	internalNote?: string | undefined | null,
	staff?: ValueTypes["UserCreateStaffEntityRelationInput"] | undefined | null,
	customer?: ValueTypes["UserCreateCustomerEntityRelationInput"] | undefined | null,
	tenantPersonId?: ValueTypes["UUID"] | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	verifiedAt?: ValueTypes["DateTime"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	deletionRequestedAt?: ValueTypes["DateTime"] | undefined | null,
	deletionExpectedAt?: ValueTypes["DateTime"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	meta?: ValueTypes["UserCreateMetaEntityRelationInput"] | undefined | null,
	identificationAttempts?: Array<ValueTypes["UserCreateIdentificationAttemptsEntityRelationInput"]> | undefined | null,
	roles?: ValueTypes["UserCreateRolesEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserCreateRolesEntityRelationInput"]: {
	connect?: ValueTypes["UserRolesUniqueWhere"] | undefined | null
};
	["CustomerCreateBoughtVouchersEntityRelationInput"]: {
	connect?: ValueTypes["VoucherUniqueWhere"] | undefined | null,
	create?: ValueTypes["VoucherWithoutBuyerCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["VoucherWithoutBuyerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	activatedAt?: ValueTypes["DateTime"] | undefined | null,
	expiresAt?: ValueTypes["DateTime"] | undefined | null,
	internalNote?: string | undefined | null,
	note?: string | undefined | null,
	code?: string | undefined | null,
	type?: ValueTypes["VoucherType"] | undefined | null,
	creditCents?: number | undefined | null,
	owner?: ValueTypes["VoucherCreateOwnerEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["VoucherCreateVatRateEntityRelationInput"] | undefined | null,
	virtualProductEffect?: ValueTypes["VoucherCreateVirtualProductEffectEntityRelationInput"] | undefined | null,
	redemption?: ValueTypes["VoucherCreateRedemptionEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VoucherCreateOwnerEntityRelationInput"]: {
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerWithoutOwnsVouchersCreateInput"] | undefined | null
};
	["CustomerWithoutOwnsVouchersCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	addresses?: Array<ValueTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerCreateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerCreateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerCreatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerCreateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerCreateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerCreateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerCreateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerCreateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerCreateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerCreateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreateRedeemedVouchersEntityRelationInput"]: {
	connect?: ValueTypes["VoucherRedemptionUniqueWhere"] | undefined | null,
	create?: ValueTypes["VoucherRedemptionWithoutCustomerCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["VoucherRedemptionWithoutCustomerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	manualRedemptionNote?: string | undefined | null,
	customerCredit?: ValueTypes["VoucherRedemptionCreateCustomerCreditEntityRelationInput"] | undefined | null,
	orderDiscount?: ValueTypes["VoucherRedemptionCreateOrderDiscountEntityRelationInput"] | undefined | null,
	voucher?: ValueTypes["VoucherRedemptionCreateVoucherEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VoucherRedemptionCreateCustomerCreditEntityRelationInput"]: {
	connect?: ValueTypes["CustomerCreditUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerCreditWithoutVoucherRedemptionCreateInput"] | undefined | null
};
	["CustomerCreditWithoutVoucherRedemptionCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	initialCreditCents?: number | undefined | null,
	remainingCreditsCents?: number | undefined | null,
	expiresAt?: ValueTypes["DateTime"] | undefined | null,
	reason?: string | undefined | null,
	customer?: ValueTypes["CustomerCreditCreateCustomerEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["CustomerCreditCreateVatRateEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	transactions?: Array<ValueTypes["CustomerCreditCreateTransactionsEntityRelationInput"]> | undefined | null,
	invoiceUrl?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreditCreateTransactionsEntityRelationInput"]: {
	connect?: ValueTypes["CustomerCreditTransactionUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerCreditTransactionWithoutCustomerCreditCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerCreditTransactionWithoutCustomerCreditCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	amountCents?: number | undefined | null,
	orderDiscount?: ValueTypes["CustomerCreditTransactionCreateOrderDiscountEntityRelationInput"] | undefined | null,
	virtualProductEffect?: ValueTypes["CustomerCreditTransactionCreateVirtualProductEffectEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreditTransactionCreateVirtualProductEffectEntityRelationInput"]: {
	connect?: ValueTypes["VirtualProductEffectUniqueWhere"] | undefined | null,
	create?: ValueTypes["VirtualProductEffectWithoutResultCustomerCreditTransactionCreateInput"] | undefined | null
};
	["VirtualProductEffectWithoutResultCustomerCreditTransactionCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	succeededAt?: ValueTypes["DateTime"] | undefined | null,
	orderItem?: ValueTypes["VirtualProductEffectCreateOrderItemEntityRelationInput"] | undefined | null,
	failedAt?: ValueTypes["DateTime"] | undefined | null,
	revertedAt?: ValueTypes["DateTime"] | undefined | null,
	resultVouchers?: Array<ValueTypes["VirtualProductEffectCreateResultVouchersEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VirtualProductEffectCreateOrderItemEntityRelationInput"]: {
	connect?: ValueTypes["OrderItemUniqueWhere"] | undefined | null,
	create?: ValueTypes["OrderItemWithoutVirtualProductEffectsCreateInput"] | undefined | null
};
	["OrderItemWithoutVirtualProductEffectsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	unitPriceCents?: number | undefined | null,
	quantity?: number | undefined | null,
	vatRate?: ValueTypes["OrderItemCreateVatRateEntityRelationInput"] | undefined | null,
	order?: ValueTypes["OrderItemCreateOrderEntityRelationInput"] | undefined | null,
	pickedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["OrderItemCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	product?: ValueTypes["OrderItemCreateProductEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderItemCreateFulfillmentNotesEntityRelationInput"]: {
	connect?: ValueTypes["FulfillmentNoteUniqueWhere"] | undefined | null,
	create?: ValueTypes["FulfillmentNoteWithoutOrderItemsCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["FulfillmentNoteWithoutOrderItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	note?: string | undefined | null,
	products?: Array<ValueTypes["FulfillmentNoteCreateProductsEntityRelationInput"]> | undefined | null,
	tags?: Array<ValueTypes["FulfillmentNoteCreateTagsEntityRelationInput"]> | undefined | null,
	venues?: Array<ValueTypes["FulfillmentNoteCreateVenuesEntityRelationInput"]> | undefined | null,
	cartItems?: Array<ValueTypes["FulfillmentNoteCreateCartItemsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["FulfillmentNoteCreateOrdersEntityRelationInput"]> | undefined | null,
	highlight?: boolean | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	emoji?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VirtualProductEffectCreateResultVouchersEntityRelationInput"]: {
	connect?: ValueTypes["VoucherUniqueWhere"] | undefined | null,
	create?: ValueTypes["VoucherWithoutVirtualProductEffectCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["VoucherWithoutVirtualProductEffectCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	activatedAt?: ValueTypes["DateTime"] | undefined | null,
	expiresAt?: ValueTypes["DateTime"] | undefined | null,
	internalNote?: string | undefined | null,
	note?: string | undefined | null,
	code?: string | undefined | null,
	type?: ValueTypes["VoucherType"] | undefined | null,
	creditCents?: number | undefined | null,
	buyer?: ValueTypes["VoucherCreateBuyerEntityRelationInput"] | undefined | null,
	owner?: ValueTypes["VoucherCreateOwnerEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["VoucherCreateVatRateEntityRelationInput"] | undefined | null,
	redemption?: ValueTypes["VoucherCreateRedemptionEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VoucherCreateBuyerEntityRelationInput"]: {
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerWithoutBoughtVouchersCreateInput"] | undefined | null
};
	["CustomerWithoutBoughtVouchersCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	addresses?: Array<ValueTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerCreateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerCreateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerCreatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerCreateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerCreateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerCreateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerCreateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerCreateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerCreateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerCreateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreateOwnsVouchersEntityRelationInput"]: {
	connect?: ValueTypes["VoucherUniqueWhere"] | undefined | null,
	create?: ValueTypes["VoucherWithoutOwnerCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["VoucherWithoutOwnerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	activatedAt?: ValueTypes["DateTime"] | undefined | null,
	expiresAt?: ValueTypes["DateTime"] | undefined | null,
	internalNote?: string | undefined | null,
	note?: string | undefined | null,
	code?: string | undefined | null,
	type?: ValueTypes["VoucherType"] | undefined | null,
	creditCents?: number | undefined | null,
	buyer?: ValueTypes["VoucherCreateBuyerEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["VoucherCreateVatRateEntityRelationInput"] | undefined | null,
	virtualProductEffect?: ValueTypes["VoucherCreateVirtualProductEffectEntityRelationInput"] | undefined | null,
	redemption?: ValueTypes["VoucherCreateRedemptionEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VoucherCreateVatRateEntityRelationInput"]: {
	connect?: ValueTypes["VatRateUniqueWhere"] | undefined | null,
	create?: ValueTypes["VatRateCreateInput"] | undefined | null
};
	["VoucherCreateVirtualProductEffectEntityRelationInput"]: {
	connect?: ValueTypes["VirtualProductEffectUniqueWhere"] | undefined | null,
	create?: ValueTypes["VirtualProductEffectWithoutResultVouchersCreateInput"] | undefined | null
};
	["VirtualProductEffectWithoutResultVouchersCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	succeededAt?: ValueTypes["DateTime"] | undefined | null,
	orderItem?: ValueTypes["VirtualProductEffectCreateOrderItemEntityRelationInput"] | undefined | null,
	failedAt?: ValueTypes["DateTime"] | undefined | null,
	revertedAt?: ValueTypes["DateTime"] | undefined | null,
	resultCustomerCreditTransaction?: ValueTypes["VirtualProductEffectCreateResultCustomerCreditTransactionEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VoucherCreateRedemptionEntityRelationInput"]: {
	connect?: ValueTypes["VoucherRedemptionUniqueWhere"] | undefined | null,
	create?: ValueTypes["VoucherRedemptionWithoutVoucherCreateInput"] | undefined | null
};
	["VoucherRedemptionWithoutVoucherCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	manualRedemptionNote?: string | undefined | null,
	customerCredit?: ValueTypes["VoucherRedemptionCreateCustomerCreditEntityRelationInput"] | undefined | null,
	orderDiscount?: ValueTypes["VoucherRedemptionCreateOrderDiscountEntityRelationInput"] | undefined | null,
	customer?: ValueTypes["VoucherRedemptionCreateCustomerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VoucherRedemptionCreateOrderDiscountEntityRelationInput"]: {
	connect?: ValueTypes["OrderDiscountUniqueWhere"] | undefined | null,
	create?: ValueTypes["OrderDiscountWithoutVoucherRedemptionCreateInput"] | undefined | null
};
	["OrderDiscountWithoutVoucherRedemptionCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	discountCents?: number | undefined | null,
	vatRate?: ValueTypes["OrderDiscountCreateVatRateEntityRelationInput"] | undefined | null,
	order?: ValueTypes["OrderDiscountCreateOrderEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	type?: ValueTypes["OrderDiscountType"] | undefined | null,
	customerCreditTransactions?: Array<ValueTypes["OrderDiscountCreateCustomerCreditTransactionsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VoucherRedemptionCreateCustomerEntityRelationInput"]: {
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerWithoutRedeemedVouchersCreateInput"] | undefined | null
};
	["CustomerWithoutRedeemedVouchersCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	addresses?: Array<ValueTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerCreateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerCreateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerCreatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerCreateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerCreateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerCreateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerCreateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerCreateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerCreateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerCreateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreateSpendingEntityRelationInput"]: {
	connect?: ValueTypes["CustomerSpendingUniqueWhere"] | undefined | null
};
	["CustomerCreateCustomerTabsEntityRelationInput"]: {
	connect?: ValueTypes["CustomerTabUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerTabWithoutCustomerCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerTabWithoutCustomerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	color?: string | undefined | null,
	items?: Array<ValueTypes["CustomerTabCreateItemsEntityRelationInput"]> | undefined | null,
	name?: string | undefined | null,
	meta?: ValueTypes["CustomerTabCreateMetaEntityRelationInput"] | undefined | null,
	table?: ValueTypes["CustomerTabCreateTableEntityRelationInput"] | undefined | null,
	seat?: ValueTypes["CustomerTabCreateSeatEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerTabCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["CustomerTabItemUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerTabItemWithoutTabCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerTabItemWithoutTabCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	addedAt?: ValueTypes["DateTime"] | undefined | null,
	product?: ValueTypes["CustomerTabItemCreateProductEntityRelationInput"] | undefined | null,
	paidAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerTabItemCreateProductEntityRelationInput"]: {
	connect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductCreateInput"] | undefined | null
};
	["CustomerTabCreateMetaEntityRelationInput"]: {
	connect?: ValueTypes["CustomerTabMetadataUniqueWhere"] | undefined | null
};
	["CustomerTabCreateTableEntityRelationInput"]: {
	connect?: ValueTypes["TableUniqueWhere"] | undefined | null,
	create?: ValueTypes["TableWithoutCustomerTabsCreateInput"] | undefined | null
};
	["TableWithoutCustomerTabsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	shape?: ValueTypes["TableShape"] | undefined | null,
	width?: number | undefined | null,
	height?: number | undefined | null,
	positionX?: number | undefined | null,
	positionY?: number | undefined | null,
	name?: string | undefined | null,
	color?: string | undefined | null,
	area?: ValueTypes["TableCreateAreaEntityRelationInput"] | undefined | null,
	seats?: Array<ValueTypes["TableCreateSeatsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TableCreateAreaEntityRelationInput"]: {
	connect?: ValueTypes["AreaUniqueWhere"] | undefined | null,
	create?: ValueTypes["AreaWithoutTablesCreateInput"] | undefined | null
};
	["AreaWithoutTablesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	name?: string | undefined | null,
	venue?: ValueTypes["AreaCreateVenueEntityRelationInput"] | undefined | null,
	lines?: Array<ValueTypes["AreaCreateLinesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AreaCreateVenueEntityRelationInput"]: {
	connect?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	create?: ValueTypes["VenueWithoutAreasCreateInput"] | undefined | null
};
	["VenueWithoutAreasCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	deadlineTemplate?: ValueTypes["VenueCreateDeadlineTemplateEntityRelationInput"] | undefined | null,
	timetableDays?: Array<ValueTypes["VenueCreateTimetableDaysEntityRelationInput"]> | undefined | null,
	timetableTemplates?: Array<ValueTypes["VenueCreateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	staffMembers?: Array<ValueTypes["VenueCreateStaffMembersEntityRelationInput"]> | undefined | null,
	employeeRoles?: Array<ValueTypes["VenueCreateEmployeeRolesEntityRelationInput"]> | undefined | null,
	pointOfSaleApplicationDevices?: Array<ValueTypes["VenueCreatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined | null,
	pointOfSaleTerminals?: Array<ValueTypes["VenueCreatePointOfSaleTerminalsEntityRelationInput"]> | undefined | null,
	pointOfSalePrinters?: Array<ValueTypes["VenueCreatePointOfSalePrintersEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["VenueCreateOrdersEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["VenueCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	enabledUnassignReasons?: Array<ValueTypes["VenueCreateEnabledUnassignReasonsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["VenueCreateCategoriesEntityRelationInput"]> | undefined | null,
	channels?: Array<ValueTypes["VenueCreateChannelsEntityRelationInput"]> | undefined | null,
	address?: string | undefined | null,
	pointOfSalePngBase64ReceiptLogo?: string | undefined | null,
	pointOfSaleInitialView?: ValueTypes["PointOfSaleInitialView"] | undefined | null,
	pointOfSalePreferPrintReceipt?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VenueCreateEnabledUnassignReasonsEntityRelationInput"]: {
	connect?: ValueTypes["UnassignReasonUniqueWhere"] | undefined | null,
	create?: ValueTypes["UnassignReasonWithoutVenuesCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["UnassignReasonUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["UnassignReasonWithoutVenuesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	name?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VenueCreateCategoriesEntityRelationInput"]: {
	connect?: ValueTypes["PointOfSaleCategoryUniqueWhere"] | undefined | null,
	create?: ValueTypes["PointOfSaleCategoryWithoutVenueCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PointOfSaleCategoryWithoutVenueCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	slug?: string | undefined | null,
	locales?: Array<ValueTypes["PointOfSaleCategoryCreateLocalesEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["PointOfSaleCategoryCreateProductsEntityRelationInput"]> | undefined | null,
	category?: ValueTypes["PointOfSaleCategoryCreateCategoryEntityRelationInput"] | undefined | null,
	ticketPrinters?: Array<ValueTypes["PointOfSaleCategoryCreateTicketPrintersEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleCategoryCreateCategoryEntityRelationInput"]: {
	connect?: ValueTypes["ProductCategoryUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductCategoryCreateInput"] | undefined | null
};
	["PointOfSaleCategoryCreateTicketPrintersEntityRelationInput"]: {
	connect?: ValueTypes["PointOfSalePrinterUniqueWhere"] | undefined | null,
	create?: ValueTypes["PointOfSalePrinterWithoutTicketCategoriesCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PointOfSalePrinterWithoutTicketCategoriesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	internalName?: string | undefined | null,
	note?: string | undefined | null,
	ipAddress?: string | undefined | null,
	applicationDevicesReceipt?: Array<ValueTypes["PointOfSalePrinterCreateApplicationDevicesReceiptEntityRelationInput"]> | undefined | null,
	applicationDevicesTicket?: Array<ValueTypes["PointOfSalePrinterCreateApplicationDevicesTicketEntityRelationInput"]> | undefined | null,
	venue?: ValueTypes["PointOfSalePrinterCreateVenueEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSalePrinterCreateApplicationDevicesTicketEntityRelationInput"]: {
	connect?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null,
	create?: ValueTypes["PointOfSaleApplicationDeviceWithoutTicketPrintersCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PointOfSaleApplicationDeviceWithoutTicketPrintersCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	internalName?: string | undefined | null,
	note?: string | undefined | null,
	venue?: ValueTypes["PointOfSaleApplicationDeviceCreateVenueEntityRelationInput"] | undefined | null,
	identificationCode?: ValueTypes["PointOfSaleApplicationDeviceCreateIdentificationCodeEntityRelationInput"] | undefined | null,
	identifier?: ValueTypes["PointOfSaleApplicationDeviceCreateIdentifierEntityRelationInput"] | undefined | null,
	terminal?: ValueTypes["PointOfSaleApplicationDeviceCreateTerminalEntityRelationInput"] | undefined | null,
	receiptPrinter?: ValueTypes["PointOfSaleApplicationDeviceCreateReceiptPrinterEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleApplicationDeviceCreateReceiptPrinterEntityRelationInput"]: {
	connect?: ValueTypes["PointOfSalePrinterUniqueWhere"] | undefined | null,
	create?: ValueTypes["PointOfSalePrinterWithoutApplicationDevicesReceiptCreateInput"] | undefined | null
};
	["PointOfSalePrinterWithoutApplicationDevicesReceiptCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	internalName?: string | undefined | null,
	note?: string | undefined | null,
	ipAddress?: string | undefined | null,
	applicationDevicesTicket?: Array<ValueTypes["PointOfSalePrinterCreateApplicationDevicesTicketEntityRelationInput"]> | undefined | null,
	venue?: ValueTypes["PointOfSalePrinterCreateVenueEntityRelationInput"] | undefined | null,
	ticketCategories?: Array<ValueTypes["PointOfSalePrinterCreateTicketCategoriesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSalePrinterCreateVenueEntityRelationInput"]: {
	connect?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	create?: ValueTypes["VenueWithoutPointOfSalePrintersCreateInput"] | undefined | null
};
	["VenueWithoutPointOfSalePrintersCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	deadlineTemplate?: ValueTypes["VenueCreateDeadlineTemplateEntityRelationInput"] | undefined | null,
	timetableDays?: Array<ValueTypes["VenueCreateTimetableDaysEntityRelationInput"]> | undefined | null,
	timetableTemplates?: Array<ValueTypes["VenueCreateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	staffMembers?: Array<ValueTypes["VenueCreateStaffMembersEntityRelationInput"]> | undefined | null,
	employeeRoles?: Array<ValueTypes["VenueCreateEmployeeRolesEntityRelationInput"]> | undefined | null,
	pointOfSaleApplicationDevices?: Array<ValueTypes["VenueCreatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined | null,
	pointOfSaleTerminals?: Array<ValueTypes["VenueCreatePointOfSaleTerminalsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["VenueCreateOrdersEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["VenueCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	areas?: Array<ValueTypes["VenueCreateAreasEntityRelationInput"]> | undefined | null,
	enabledUnassignReasons?: Array<ValueTypes["VenueCreateEnabledUnassignReasonsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["VenueCreateCategoriesEntityRelationInput"]> | undefined | null,
	channels?: Array<ValueTypes["VenueCreateChannelsEntityRelationInput"]> | undefined | null,
	address?: string | undefined | null,
	pointOfSalePngBase64ReceiptLogo?: string | undefined | null,
	pointOfSaleInitialView?: ValueTypes["PointOfSaleInitialView"] | undefined | null,
	pointOfSalePreferPrintReceipt?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VenueCreateAreasEntityRelationInput"]: {
	connect?: ValueTypes["AreaUniqueWhere"] | undefined | null,
	create?: ValueTypes["AreaWithoutVenueCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["AreaWithoutVenueCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	name?: string | undefined | null,
	tables?: Array<ValueTypes["AreaCreateTablesEntityRelationInput"]> | undefined | null,
	lines?: Array<ValueTypes["AreaCreateLinesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AreaCreateTablesEntityRelationInput"]: {
	connect?: ValueTypes["TableUniqueWhere"] | undefined | null,
	create?: ValueTypes["TableWithoutAreaCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["TableWithoutAreaCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	shape?: ValueTypes["TableShape"] | undefined | null,
	width?: number | undefined | null,
	height?: number | undefined | null,
	positionX?: number | undefined | null,
	positionY?: number | undefined | null,
	name?: string | undefined | null,
	color?: string | undefined | null,
	customerTabs?: Array<ValueTypes["TableCreateCustomerTabsEntityRelationInput"]> | undefined | null,
	seats?: Array<ValueTypes["TableCreateSeatsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TableCreateCustomerTabsEntityRelationInput"]: {
	connect?: ValueTypes["CustomerTabUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerTabWithoutTableCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerTabWithoutTableCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	color?: string | undefined | null,
	items?: Array<ValueTypes["CustomerTabCreateItemsEntityRelationInput"]> | undefined | null,
	name?: string | undefined | null,
	meta?: ValueTypes["CustomerTabCreateMetaEntityRelationInput"] | undefined | null,
	customer?: ValueTypes["CustomerTabCreateCustomerEntityRelationInput"] | undefined | null,
	seat?: ValueTypes["CustomerTabCreateSeatEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerTabCreateCustomerEntityRelationInput"]: {
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerWithoutCustomerTabsCreateInput"] | undefined | null
};
	["CustomerWithoutCustomerTabsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	addresses?: Array<ValueTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerCreateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerCreateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerCreatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerCreateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerCreateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerCreateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerCreateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerCreateSpendingEntityRelationInput"] | undefined | null,
	lead?: Array<ValueTypes["CustomerCreateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerCreateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreateLeadEntityRelationInput"]: {
	connect?: ValueTypes["PipelineLeadUniqueWhere"] | undefined | null,
	create?: ValueTypes["PipelineLeadWithoutCustomerCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PipelineLeadWithoutCustomerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	stageItem?: ValueTypes["PipelineLeadCreateStageItemEntityRelationInput"] | undefined | null,
	contactPerson?: string | undefined | null,
	cafeType?: string | undefined | null,
	offerType?: string | undefined | null,
	ownMachine?: boolean | undefined | null,
	customerCity?: string | undefined | null,
	companyId?: string | undefined | null,
	customerName?: string | undefined | null,
	email?: string | undefined | null,
	phone?: string | undefined | null,
	form?: ValueTypes["PipelineLeadCreateFormEntityRelationInput"] | undefined | null,
	meta?: string | undefined | null,
	multiroasterType?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PipelineLeadCreateStageItemEntityRelationInput"]: {
	connect?: ValueTypes["PipelineStageItemUniqueWhere"] | undefined | null,
	create?: ValueTypes["PipelineStageItemWithoutLeadCreateInput"] | undefined | null
};
	["PipelineStageItemWithoutLeadCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	list?: ValueTypes["PipelineStageItemCreateListEntityRelationInput"] | undefined | null,
	order?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PipelineStageItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["PipelineStageUniqueWhere"] | undefined | null,
	create?: ValueTypes["PipelineStageWithoutItemsCreateInput"] | undefined | null
};
	["PipelineStageWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	pipeline?: ValueTypes["PipelineStageCreatePipelineEntityRelationInput"] | undefined | null,
	order?: number | undefined | null,
	locales?: Array<ValueTypes["PipelineStageCreateLocalesEntityRelationInput"]> | undefined | null,
	sentiment?: ValueTypes["PipelineStageCreateSentimentEntityRelationInput"] | undefined | null,
	type?: ValueTypes["PipelineStageType"] | undefined | null,
	forms?: Array<ValueTypes["PipelineStageCreateFormsEntityRelationInput"]> | undefined | null,
	showItemsWeight?: boolean | undefined | null,
	showItemsPrice?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PipelineStageCreatePipelineEntityRelationInput"]: {
	connect?: ValueTypes["PipelineUniqueWhere"] | undefined | null,
	create?: ValueTypes["PipelineWithoutStagesCreateInput"] | undefined | null
};
	["PipelineUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	unique?: ValueTypes["One"] | undefined | null,
	stages?: ValueTypes["PipelineStageUniqueWhere"] | undefined | null
};
	["PipelineWithoutStagesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	unique?: ValueTypes["One"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PipelineStageCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["PipelineStageLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["PipelineStageLocaleWithoutRootCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PipelineStageLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	locale?: ValueTypes["PipelineStageLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PipelineStageLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["LocaleWithoutPipelineStagesCreateInput"] | undefined | null
};
	["LocaleWithoutPipelineStagesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	businessCategories?: Array<ValueTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleCreateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleCreatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleCreateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreateSubscriptionBoxesEntityRelationInput"]: {
	connect?: ValueTypes["SubscriptionBoxLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["SubscriptionBoxLocaleWithoutLocaleCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["SubscriptionBoxLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	stickerText?: string | undefined | null,
	descriptionText?: string | undefined | null,
	root?: ValueTypes["SubscriptionBoxLocaleCreateRootEntityRelationInput"] | undefined | null,
	secondaryTitle?: string | undefined | null,
	texts?: ValueTypes["SubscriptionBoxLocaleCreateTextsEntityRelationInput"] | undefined | null,
	secondaryTexts?: ValueTypes["SubscriptionBoxLocaleCreateSecondaryTextsEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SubscriptionBoxLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["SubscriptionBoxUniqueWhere"] | undefined | null,
	create?: ValueTypes["SubscriptionBoxWithoutLocalesCreateInput"] | undefined | null
};
	["SubscriptionBoxWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	unique?: ValueTypes["One"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SubscriptionBoxLocaleCreateTextsEntityRelationInput"]: {
	connect?: ValueTypes["TextListUniqueWhere"] | undefined | null,
	create?: ValueTypes["TextListCreateInput"] | undefined | null
};
	["SubscriptionBoxLocaleCreateSecondaryTextsEntityRelationInput"]: {
	connect?: ValueTypes["TextListUniqueWhere"] | undefined | null,
	create?: ValueTypes["TextListCreateInput"] | undefined | null
};
	["LocaleCreateBusinessServicesEntityRelationInput"]: {
	connect?: ValueTypes["BusinessServiceLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["BusinessServiceLocaleWithoutLocaleCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["BusinessServiceLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	labelNote?: string | undefined | null,
	root?: ValueTypes["BusinessServiceLocaleCreateRootEntityRelationInput"] | undefined | null,
	labelNumberOfPeople?: string | undefined | null,
	labelInvoiced?: string | undefined | null,
	labelEquipment?: string | undefined | null,
	labelMillTamDem?: string | undefined | null,
	labelSOEspresso?: string | undefined | null,
	labelFilterCoffeeInMenu?: string | undefined | null,
	labelWaterMeterStatus?: string | undefined | null,
	labelServiceAction?: string | undefined | null,
	labelInvoiceIdentifier?: string | undefined | null,
	labelSupervisor?: string | undefined | null,
	labelContact?: string | undefined | null,
	labelPhone?: string | undefined | null,
	labelEmail?: string | undefined | null,
	labelGrindingStonesCondition?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessServiceLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["BusinessServiceUniqueWhere"] | undefined | null,
	create?: ValueTypes["BusinessServiceWithoutLocalesCreateInput"] | undefined | null
};
	["BusinessServiceWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	requireNote?: number | undefined | null,
	requireNumberOfPeople?: number | undefined | null,
	requireInvoiced?: number | undefined | null,
	requireEquipment?: number | undefined | null,
	requireMillTamDem?: number | undefined | null,
	requireSOEspresso?: number | undefined | null,
	requireFilterCoffeeInMenu?: number | undefined | null,
	requireWaterMeterStatus?: number | undefined | null,
	requireServiceAction?: number | undefined | null,
	optionsEquipment?: string | undefined | null,
	optionsServiceAction?: string | undefined | null,
	requireInvoiceIdentifier?: number | undefined | null,
	requireSupervisor?: number | undefined | null,
	requireContact?: number | undefined | null,
	requirePhone?: number | undefined | null,
	requireEmail?: number | undefined | null,
	requireGrindingStonesCondition?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PipelineStageCreateSentimentEntityRelationInput"]: {
	connect?: ValueTypes["PipelineStageSentimentUniqueWhere"] | undefined | null,
	create?: ValueTypes["PipelineStageSentimentCreateInput"] | undefined | null
};
	["PipelineStageSentimentUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["PipelineStageSentimentCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	internalName?: string | undefined | null,
	backgroundColor?: string | undefined | null,
	textColor?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PipelineStageCreateFormsEntityRelationInput"]: {
	connect?: ValueTypes["LeadFormUniqueWhere"] | undefined | null,
	create?: ValueTypes["LeadFormWithoutStageCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["LeadFormWithoutStageCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	leads?: Array<ValueTypes["LeadFormCreateLeadsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LeadFormCreateLeadsEntityRelationInput"]: {
	connect?: ValueTypes["PipelineLeadUniqueWhere"] | undefined | null,
	create?: ValueTypes["PipelineLeadWithoutFormCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PipelineLeadWithoutFormCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	stageItem?: ValueTypes["PipelineLeadCreateStageItemEntityRelationInput"] | undefined | null,
	contactPerson?: string | undefined | null,
	customer?: ValueTypes["PipelineLeadCreateCustomerEntityRelationInput"] | undefined | null,
	cafeType?: string | undefined | null,
	offerType?: string | undefined | null,
	ownMachine?: boolean | undefined | null,
	customerCity?: string | undefined | null,
	companyId?: string | undefined | null,
	customerName?: string | undefined | null,
	email?: string | undefined | null,
	phone?: string | undefined | null,
	meta?: string | undefined | null,
	multiroasterType?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PipelineLeadCreateCustomerEntityRelationInput"]: {
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerWithoutLeadCreateInput"] | undefined | null
};
	["CustomerWithoutLeadCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	addresses?: Array<ValueTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerCreateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerCreateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerCreatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerCreateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerCreateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerCreateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerCreateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerCreateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerCreateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreateMetaEntityRelationInput"]: {
	connect?: ValueTypes["CustomerMetadataUniqueWhere"] | undefined | null
};
	["PipelineLeadCreateFormEntityRelationInput"]: {
	connect?: ValueTypes["LeadFormUniqueWhere"] | undefined | null,
	create?: ValueTypes["LeadFormWithoutLeadsCreateInput"] | undefined | null
};
	["LeadFormWithoutLeadsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	stage?: ValueTypes["LeadFormCreateStageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LeadFormCreateStageEntityRelationInput"]: {
	connect?: ValueTypes["PipelineStageUniqueWhere"] | undefined | null,
	create?: ValueTypes["PipelineStageWithoutFormsCreateInput"] | undefined | null
};
	["PipelineStageWithoutFormsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: Array<ValueTypes["PipelineStageCreateItemsEntityRelationInput"]> | undefined | null,
	pipeline?: ValueTypes["PipelineStageCreatePipelineEntityRelationInput"] | undefined | null,
	order?: number | undefined | null,
	locales?: Array<ValueTypes["PipelineStageCreateLocalesEntityRelationInput"]> | undefined | null,
	sentiment?: ValueTypes["PipelineStageCreateSentimentEntityRelationInput"] | undefined | null,
	type?: ValueTypes["PipelineStageType"] | undefined | null,
	showItemsWeight?: boolean | undefined | null,
	showItemsPrice?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PipelineStageCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["PipelineStageItemUniqueWhere"] | undefined | null,
	create?: ValueTypes["PipelineStageItemWithoutListCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PipelineStageItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	lead?: ValueTypes["PipelineStageItemCreateLeadEntityRelationInput"] | undefined | null,
	order?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PipelineStageItemCreateLeadEntityRelationInput"]: {
	connect?: ValueTypes["PipelineLeadUniqueWhere"] | undefined | null,
	create?: ValueTypes["PipelineLeadWithoutStageItemCreateInput"] | undefined | null
};
	["PipelineLeadWithoutStageItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	contactPerson?: string | undefined | null,
	customer?: ValueTypes["PipelineLeadCreateCustomerEntityRelationInput"] | undefined | null,
	cafeType?: string | undefined | null,
	offerType?: string | undefined | null,
	ownMachine?: boolean | undefined | null,
	customerCity?: string | undefined | null,
	companyId?: string | undefined | null,
	customerName?: string | undefined | null,
	email?: string | undefined | null,
	phone?: string | undefined | null,
	form?: ValueTypes["PipelineLeadCreateFormEntityRelationInput"] | undefined | null,
	meta?: string | undefined | null,
	multiroasterType?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerTabCreateSeatEntityRelationInput"]: {
	connect?: ValueTypes["SeatUniqueWhere"] | undefined | null,
	create?: ValueTypes["SeatWithoutCustomerTabsCreateInput"] | undefined | null
};
	["SeatWithoutCustomerTabsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	positionX?: number | undefined | null,
	positionY?: number | undefined | null,
	name?: string | undefined | null,
	color?: string | undefined | null,
	table?: ValueTypes["SeatCreateTableEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SeatCreateTableEntityRelationInput"]: {
	connect?: ValueTypes["TableUniqueWhere"] | undefined | null,
	create?: ValueTypes["TableWithoutSeatsCreateInput"] | undefined | null
};
	["TableWithoutSeatsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	shape?: ValueTypes["TableShape"] | undefined | null,
	width?: number | undefined | null,
	height?: number | undefined | null,
	positionX?: number | undefined | null,
	positionY?: number | undefined | null,
	name?: string | undefined | null,
	color?: string | undefined | null,
	customerTabs?: Array<ValueTypes["TableCreateCustomerTabsEntityRelationInput"]> | undefined | null,
	area?: ValueTypes["TableCreateAreaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TableCreateSeatsEntityRelationInput"]: {
	connect?: ValueTypes["SeatUniqueWhere"] | undefined | null,
	create?: ValueTypes["SeatWithoutTableCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["SeatWithoutTableCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	positionX?: number | undefined | null,
	positionY?: number | undefined | null,
	name?: string | undefined | null,
	color?: string | undefined | null,
	customerTabs?: Array<ValueTypes["SeatCreateCustomerTabsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SeatCreateCustomerTabsEntityRelationInput"]: {
	connect?: ValueTypes["CustomerTabUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerTabWithoutSeatCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerTabWithoutSeatCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	color?: string | undefined | null,
	items?: Array<ValueTypes["CustomerTabCreateItemsEntityRelationInput"]> | undefined | null,
	name?: string | undefined | null,
	meta?: ValueTypes["CustomerTabCreateMetaEntityRelationInput"] | undefined | null,
	customer?: ValueTypes["CustomerTabCreateCustomerEntityRelationInput"] | undefined | null,
	table?: ValueTypes["CustomerTabCreateTableEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AreaCreateLinesEntityRelationInput"]: {
	connect?: ValueTypes["LineUniqueWhere"] | undefined | null,
	create?: ValueTypes["LineWithoutAreaCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["LineWithoutAreaCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	positionStartX?: number | undefined | null,
	positionStartY?: number | undefined | null,
	positionEndX?: number | undefined | null,
	positionEndY?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VenueCreateChannelsEntityRelationInput"]: {
	connect?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	create?: ValueTypes["ChannelWithoutVenueCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ChannelWithoutVenueCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	disabled?: boolean | undefined | null,
	payments?: Array<ValueTypes["ChannelCreatePaymentsEntityRelationInput"]> | undefined | null,
	deliveries?: Array<ValueTypes["ChannelCreateDeliveriesEntityRelationInput"]> | undefined | null,
	pointOfSales?: Array<ValueTypes["ChannelCreatePointOfSalesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["ChannelCreateCartsEntityRelationInput"]> | undefined | null,
	customers?: Array<ValueTypes["ChannelCreateCustomersEntityRelationInput"]> | undefined | null,
	code?: ValueTypes["ChannelCode"] | undefined | null,
	addTagsOnRegistration?: Array<ValueTypes["ChannelCreateAddTagsOnRegistrationEntityRelationInput"]> | undefined | null,
	publicTags?: Array<ValueTypes["ChannelCreatePublicTagsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSalePrinterCreateTicketCategoriesEntityRelationInput"]: {
	connect?: ValueTypes["PointOfSaleCategoryUniqueWhere"] | undefined | null,
	create?: ValueTypes["PointOfSaleCategoryWithoutTicketPrintersCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PointOfSaleCategoryWithoutTicketPrintersCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	slug?: string | undefined | null,
	locales?: Array<ValueTypes["PointOfSaleCategoryCreateLocalesEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["PointOfSaleCategoryCreateProductsEntityRelationInput"]> | undefined | null,
	category?: ValueTypes["PointOfSaleCategoryCreateCategoryEntityRelationInput"] | undefined | null,
	venue?: ValueTypes["PointOfSaleCategoryCreateVenueEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleCategoryCreateVenueEntityRelationInput"]: {
	connect?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	create?: ValueTypes["VenueWithoutCategoriesCreateInput"] | undefined | null
};
	["VenueWithoutCategoriesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	deadlineTemplate?: ValueTypes["VenueCreateDeadlineTemplateEntityRelationInput"] | undefined | null,
	timetableDays?: Array<ValueTypes["VenueCreateTimetableDaysEntityRelationInput"]> | undefined | null,
	timetableTemplates?: Array<ValueTypes["VenueCreateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	staffMembers?: Array<ValueTypes["VenueCreateStaffMembersEntityRelationInput"]> | undefined | null,
	employeeRoles?: Array<ValueTypes["VenueCreateEmployeeRolesEntityRelationInput"]> | undefined | null,
	pointOfSaleApplicationDevices?: Array<ValueTypes["VenueCreatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined | null,
	pointOfSaleTerminals?: Array<ValueTypes["VenueCreatePointOfSaleTerminalsEntityRelationInput"]> | undefined | null,
	pointOfSalePrinters?: Array<ValueTypes["VenueCreatePointOfSalePrintersEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["VenueCreateOrdersEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["VenueCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	areas?: Array<ValueTypes["VenueCreateAreasEntityRelationInput"]> | undefined | null,
	enabledUnassignReasons?: Array<ValueTypes["VenueCreateEnabledUnassignReasonsEntityRelationInput"]> | undefined | null,
	channels?: Array<ValueTypes["VenueCreateChannelsEntityRelationInput"]> | undefined | null,
	address?: string | undefined | null,
	pointOfSalePngBase64ReceiptLogo?: string | undefined | null,
	pointOfSaleInitialView?: ValueTypes["PointOfSaleInitialView"] | undefined | null,
	pointOfSalePreferPrintReceipt?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VoucherRedemptionCreateVoucherEntityRelationInput"]: {
	connect?: ValueTypes["VoucherUniqueWhere"] | undefined | null,
	create?: ValueTypes["VoucherWithoutRedemptionCreateInput"] | undefined | null
};
	["VoucherWithoutRedemptionCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	activatedAt?: ValueTypes["DateTime"] | undefined | null,
	expiresAt?: ValueTypes["DateTime"] | undefined | null,
	internalNote?: string | undefined | null,
	note?: string | undefined | null,
	code?: string | undefined | null,
	type?: ValueTypes["VoucherType"] | undefined | null,
	creditCents?: number | undefined | null,
	buyer?: ValueTypes["VoucherCreateBuyerEntityRelationInput"] | undefined | null,
	owner?: ValueTypes["VoucherCreateOwnerEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["VoucherCreateVatRateEntityRelationInput"] | undefined | null,
	virtualProductEffect?: ValueTypes["VoucherCreateVirtualProductEffectEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderCreateFulfillmentNotesEntityRelationInput"]: {
	connect?: ValueTypes["FulfillmentNoteUniqueWhere"] | undefined | null,
	create?: ValueTypes["FulfillmentNoteWithoutOrdersCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["FulfillmentNoteWithoutOrdersCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	note?: string | undefined | null,
	products?: Array<ValueTypes["FulfillmentNoteCreateProductsEntityRelationInput"]> | undefined | null,
	tags?: Array<ValueTypes["FulfillmentNoteCreateTagsEntityRelationInput"]> | undefined | null,
	venues?: Array<ValueTypes["FulfillmentNoteCreateVenuesEntityRelationInput"]> | undefined | null,
	cartItems?: Array<ValueTypes["FulfillmentNoteCreateCartItemsEntityRelationInput"]> | undefined | null,
	orderItems?: Array<ValueTypes["FulfillmentNoteCreateOrderItemsEntityRelationInput"]> | undefined | null,
	highlight?: boolean | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	emoji?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderPaymentCreateVatRateEntityRelationInput"]: {
	connect?: ValueTypes["VatRateUniqueWhere"] | undefined | null,
	create?: ValueTypes["VatRateCreateInput"] | undefined | null
};
	["OrderPaymentCreateMetaEntityRelationInput"]: {
	connect?: ValueTypes["OrderPaymentMetadataUniqueWhere"] | undefined | null
};
	["OrderDeliveryCreateEventsEntityRelationInput"]: {
	connect?: ValueTypes["OrderEventUniqueWhere"] | undefined | null,
	create?: ValueTypes["OrderEventWithoutDeliveryCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["OrderEventWithoutDeliveryCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	type?: string | undefined | null,
	data?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	order?: ValueTypes["OrderEventCreateOrderEntityRelationInput"] | undefined | null,
	payment?: ValueTypes["OrderEventCreatePaymentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderDeliveryCreateLiftagoRideEntityRelationInput"]: {
	connect?: ValueTypes["LiftagoRideUniqueWhere"] | undefined | null,
	create?: ValueTypes["LiftagoRideWithoutDeliveryCreateInput"] | undefined | null
};
	["LiftagoRideWithoutDeliveryCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	liftagoId?: string | undefined | null,
	data?: string | undefined | null,
	updatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderDeliveryCreateWoltDriveDeliveryEntityRelationInput"]: {
	connect?: ValueTypes["WoltDriveDeliveryUniqueWhere"] | undefined | null,
	create?: ValueTypes["WoltDriveDeliveryWithoutDeliveryCreateInput"] | undefined | null
};
	["WoltDriveDeliveryWithoutDeliveryCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	state?: ValueTypes["WoltDriveDeliveryState"] | undefined | null,
	shipmentPromiseId?: string | undefined | null,
	deliveryPrice?: number | undefined | null,
	deliveryPriceCurrency?: string | undefined | null,
	shipmentPromiseResponse?: string | undefined | null,
	deliveryOrderId?: string | undefined | null,
	trackingUrl?: string | undefined | null,
	deliverOrderResponse?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AddressCreateDefaultDeliveryAddressOfCustomerEntityRelationInput"]: {
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerWithoutDefaultDeliveryAddressCreateInput"] | undefined | null
};
	["CustomerWithoutDefaultDeliveryAddressCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	addresses?: Array<ValueTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerCreateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerCreateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerCreatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerCreateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerCreateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerCreateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerCreateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerCreateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerCreateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerCreateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderEventCreateDeliveryEntityRelationInput"]: {
	connect?: ValueTypes["OrderDeliveryUniqueWhere"] | undefined | null,
	create?: ValueTypes["OrderDeliveryWithoutEventsCreateInput"] | undefined | null
};
	["OrderDeliveryWithoutEventsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	priceCents?: number | undefined | null,
	deliveredAt?: ValueTypes["DateTime"] | undefined | null,
	method?: ValueTypes["OrderDeliveryCreateMethodEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["OrderDeliveryCreateVatRateEntityRelationInput"] | undefined | null,
	order?: ValueTypes["OrderDeliveryCreateOrderEntityRelationInput"] | undefined | null,
	expectedAt?: ValueTypes["DateTime"] | undefined | null,
	state?: ValueTypes["OrderDeliveryState"] | undefined | null,
	loadingDurationHours?: number | undefined | null,
	dispatchAt?: ValueTypes["DateTime"] | undefined | null,
	duration?: string | undefined | null,
	window?: string | undefined | null,
	expectedEndAt?: ValueTypes["DateTime"] | undefined | null,
	processingAt?: ValueTypes["DateTime"] | undefined | null,
	deliveringAt?: ValueTypes["DateTime"] | undefined | null,
	failedAt?: ValueTypes["DateTime"] | undefined | null,
	internalNote?: string | undefined | null,
	deliveryWaypoint?: ValueTypes["OrderDeliveryCreateDeliveryWaypointEntityRelationInput"] | undefined | null,
	prepareAt?: ValueTypes["DateTime"] | undefined | null,
	liftagoRide?: ValueTypes["OrderDeliveryCreateLiftagoRideEntityRelationInput"] | undefined | null,
	pickedAt?: ValueTypes["DateTime"] | undefined | null,
	address?: ValueTypes["OrderDeliveryCreateAddressEntityRelationInput"] | undefined | null,
	trackingCode?: string | undefined | null,
	woltDriveDelivery?: ValueTypes["OrderDeliveryCreateWoltDriveDeliveryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderDeliveryCreateAddressEntityRelationInput"]: {
	connect?: ValueTypes["AddressUniqueWhere"] | undefined | null,
	create?: ValueTypes["AddressWithoutDeliveryAddressOfOrderDeliveriesCreateInput"] | undefined | null
};
	["AddressWithoutDeliveryAddressOfOrderDeliveriesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	addressLine2?: string | undefined | null,
	email?: string | undefined | null,
	phone?: string | undefined | null,
	companyName?: string | undefined | null,
	companyIdentifier?: string | undefined | null,
	vatIdentifier?: string | undefined | null,
	externalIdentifier?: string | undefined | null,
	hidden?: boolean | undefined | null,
	customer?: ValueTypes["AddressCreateCustomerEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	country?: ValueTypes["AddressCreateCountryEntityRelationInput"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	googlePlaceId?: string | undefined | null,
	raw?: string | undefined | null,
	formatted?: string | undefined | null,
	geocodeGeneratedAt?: ValueTypes["DateTime"] | undefined | null,
	geocodeResponse?: string | undefined | null,
	deliveryZone?: ValueTypes["AddressCreateDeliveryZoneEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["AddressCreateMetaEntityRelationInput"] | undefined | null,
	gps?: ValueTypes["AddressCreateGpsEntityRelationInput"] | undefined | null,
	geocodeValid?: boolean | undefined | null,
	fullName?: string | undefined | null,
	fakturoidSubjectId?: string | undefined | null,
	invoices?: Array<ValueTypes["AddressCreateInvoicesEntityRelationInput"]> | undefined | null,
	addressLine1?: string | undefined | null,
	city?: string | undefined | null,
	postalCode?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingAddressOfOrders?: Array<ValueTypes["AddressCreateBillingAddressOfOrdersEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddressOfCustomer?: ValueTypes["AddressCreateDefaultDeliveryAddressOfCustomerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CartCreateDeliveryAddressEntityRelationInput"]: {
	connect?: ValueTypes["AddressUniqueWhere"] | undefined | null,
	create?: ValueTypes["AddressCreateInput"] | undefined | null
};
	["CartCreateBillingAddressEntityRelationInput"]: {
	connect?: ValueTypes["AddressUniqueWhere"] | undefined | null,
	create?: ValueTypes["AddressCreateInput"] | undefined | null
};
	["CartCreateDeliveryEntityRelationInput"]: {
	connect?: ValueTypes["ChannelDeliveryUniqueWhere"] | undefined | null,
	create?: ValueTypes["ChannelDeliveryCreateInput"] | undefined | null
};
	["ChannelDeliveryCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	priceCents?: number | undefined | null,
	channel?: ValueTypes["ChannelDeliveryCreateChannelEntityRelationInput"] | undefined | null,
	method?: ValueTypes["ChannelDeliveryCreateMethodEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["ChannelDeliveryCreateVatRateEntityRelationInput"] | undefined | null,
	defaultVisible?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CartCreatePaymentEntityRelationInput"]: {
	connect?: ValueTypes["ChannelPaymentUniqueWhere"] | undefined | null,
	create?: ValueTypes["ChannelPaymentCreateInput"] | undefined | null
};
	["ChannelPaymentCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	channel?: ValueTypes["ChannelPaymentCreateChannelEntityRelationInput"] | undefined | null,
	method?: ValueTypes["ChannelPaymentCreateMethodEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["ChannelPaymentCreateVatRateEntityRelationInput"] | undefined | null,
	requireBillingAddress?: boolean | undefined | null,
	provideReceipt?: boolean | undefined | null,
	requireBillingSubject?: boolean | undefined | null,
	allowOnlyForTags?: Array<ValueTypes["ChannelPaymentCreateAllowOnlyForTagsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CartCreateBillingSubjectEntityRelationInput"]: {
	connect?: ValueTypes["BillingSubjectUniqueWhere"] | undefined | null,
	create?: ValueTypes["BillingSubjectCreateInput"] | undefined | null
};
	["BillingSubjectCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	fullName?: string | undefined | null,
	addressLine1?: string | undefined | null,
	addressLine2?: string | undefined | null,
	city?: string | undefined | null,
	postalCode?: string | undefined | null,
	email?: string | undefined | null,
	phone?: string | undefined | null,
	companyName?: string | undefined | null,
	companyIdentifier?: string | undefined | null,
	vatIdentifier?: string | undefined | null,
	externalIdentifier?: string | undefined | null,
	hidden?: boolean | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	internalNote?: string | undefined | null,
	fakturoidSubjectId?: string | undefined | null,
	country?: ValueTypes["BillingSubjectCreateCountryEntityRelationInput"] | undefined | null,
	customer?: ValueTypes["BillingSubjectCreateCustomerEntityRelationInput"] | undefined | null,
	invoices?: Array<ValueTypes["BillingSubjectCreateInvoicesEntityRelationInput"]> | undefined | null,
	defaultBillingSubjectOfCustomer?: ValueTypes["BillingSubjectCreateDefaultBillingSubjectOfCustomerEntityRelationInput"] | undefined | null,
	orders?: Array<ValueTypes["BillingSubjectCreateOrdersEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CartCreatePriceLinesEntityRelationInput"]: {
	connect?: ValueTypes["CartPriceLineUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CartCreateSummaryEntityRelationInput"]: {
	connect?: ValueTypes["CartSummaryUniqueWhere"] | undefined | null
};
	["OrderDiscountCreateVoucherRedemptionEntityRelationInput"]: {
	connect?: ValueTypes["VoucherRedemptionUniqueWhere"] | undefined | null,
	create?: ValueTypes["VoucherRedemptionWithoutOrderDiscountCreateInput"] | undefined | null
};
	["VoucherRedemptionWithoutOrderDiscountCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	manualRedemptionNote?: string | undefined | null,
	customerCredit?: ValueTypes["VoucherRedemptionCreateCustomerCreditEntityRelationInput"] | undefined | null,
	voucher?: ValueTypes["VoucherRedemptionCreateVoucherEntityRelationInput"] | undefined | null,
	customer?: ValueTypes["VoucherRedemptionCreateCustomerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleApplicationDeviceCreateTicketPrintersEntityRelationInput"]: {
	connect?: ValueTypes["PointOfSalePrinterUniqueWhere"] | undefined | null,
	create?: ValueTypes["PointOfSalePrinterWithoutApplicationDevicesTicketCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PointOfSalePrinterWithoutApplicationDevicesTicketCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	internalName?: string | undefined | null,
	note?: string | undefined | null,
	ipAddress?: string | undefined | null,
	applicationDevicesReceipt?: Array<ValueTypes["PointOfSalePrinterCreateApplicationDevicesReceiptEntityRelationInput"]> | undefined | null,
	venue?: ValueTypes["PointOfSalePrinterCreateVenueEntityRelationInput"] | undefined | null,
	ticketCategories?: Array<ValueTypes["PointOfSalePrinterCreateTicketCategoriesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleCreatePipelineStagesEntityRelationInput"]: {
	connect?: ValueTypes["PipelineStageLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["PipelineStageLocaleWithoutLocaleCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PipelineStageLocaleWithoutLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	root?: ValueTypes["PipelineStageLocaleCreateRootEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PipelineStageLocaleCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["PipelineStageUniqueWhere"] | undefined | null,
	create?: ValueTypes["PipelineStageWithoutLocalesCreateInput"] | undefined | null
};
	["PipelineStageWithoutLocalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: Array<ValueTypes["PipelineStageCreateItemsEntityRelationInput"]> | undefined | null,
	pipeline?: ValueTypes["PipelineStageCreatePipelineEntityRelationInput"] | undefined | null,
	order?: number | undefined | null,
	sentiment?: ValueTypes["PipelineStageCreateSentimentEntityRelationInput"] | undefined | null,
	type?: ValueTypes["PipelineStageType"] | undefined | null,
	forms?: Array<ValueTypes["PipelineStageCreateFormsEntityRelationInput"]> | undefined | null,
	showItemsWeight?: boolean | undefined | null,
	showItemsPrice?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleCategoryProductCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["PointOfSaleCategoryProductLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["PointOfSaleCategoryProductLocaleWithoutRootCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PointOfSaleCategoryProductLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	locale?: ValueTypes["PointOfSaleCategoryProductLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleCategoryProductLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["LocaleWithoutPointOfSaleCategoryProductsCreateInput"] | undefined | null
};
	["LocaleWithoutPointOfSaleCategoryProductsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	businessCategories?: Array<ValueTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleCreateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleCreatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleCreateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductRecipeCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["ProductRecipeLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductRecipeLocaleWithoutRootCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductRecipeLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	locale?: ValueTypes["ProductRecipeLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductRecipeLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["LocaleWithoutProductRecipesCreateInput"] | undefined | null
};
	["LocaleWithoutProductRecipesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	businessCategories?: Array<ValueTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleCreateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleCreatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleCreateProductsEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableShiftGroupCreateGeneratedByTemplateEntityRelationInput"]: {
	connect?: ValueTypes["TimetableTemplateUniqueWhere"] | undefined | null,
	create?: ValueTypes["TimetableTemplateCreateInput"] | undefined | null
};
	["TimetableTemplateCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	startDate?: ValueTypes["Date"] | undefined | null,
	period?: number | undefined | null,
	slots?: number | undefined | null,
	position?: ValueTypes["TimetableTemplateCreatePositionEntityRelationInput"] | undefined | null,
	staffOptions?: Array<ValueTypes["TimetableTemplateCreateStaffOptionsEntityRelationInput"]> | undefined | null,
	internalName?: string | undefined | null,
	venue?: ValueTypes["TimetableTemplateCreateVenueEntityRelationInput"] | undefined | null,
	employeeRole?: ValueTypes["TimetableTemplateCreateEmployeeRoleEntityRelationInput"] | undefined | null,
	workdaysOnly?: boolean | undefined | null,
	monday?: boolean | undefined | null,
	tuesday?: boolean | undefined | null,
	wednesday?: boolean | undefined | null,
	thursday?: boolean | undefined | null,
	friday?: boolean | undefined | null,
	saturday?: boolean | undefined | null,
	sunday?: boolean | undefined | null,
	type?: ValueTypes["TemplateType"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableShiftCreateQueueItemEntityRelationInput"]: {
	connect?: ValueTypes["EmployeeQueueItemUniqueWhere"] | undefined | null,
	create?: ValueTypes["EmployeeQueueItemWithoutShiftCreateInput"] | undefined | null
};
	["EmployeeQueueItemWithoutShiftCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	start?: string | undefined | null,
	end?: string | undefined | null,
	queue?: ValueTypes["EmployeeQueueItemCreateQueueEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["EmployeeQueueItemCreateShiftsProfileEntityRelationInput"] | undefined | null,
	unassignInfo?: ValueTypes["EmployeeQueueItemCreateUnassignInfoEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["EmployeeQueueItemCreateMetaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["EmployeeQueueItemCreateUnassignInfoEntityRelationInput"]: {
	connect?: ValueTypes["UnassignedShiftInfoUniqueWhere"] | undefined | null,
	create?: ValueTypes["UnassignedShiftInfoWithoutQueueItemCreateInput"] | undefined | null
};
	["UnassignedShiftInfoWithoutQueueItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	hoursMissed?: number | undefined | null,
	legacyReason?: ValueTypes["UnassignedInfoReason"] | undefined | null,
	reason?: ValueTypes["UnassignedShiftInfoCreateReasonEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UnassignedShiftInfoCreateReasonEntityRelationInput"]: {
	connect?: ValueTypes["UnassignReasonUniqueWhere"] | undefined | null,
	create?: ValueTypes["UnassignReasonCreateInput"] | undefined | null
};
	["UnassignReasonCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	name?: string | undefined | null,
	venues?: Array<ValueTypes["UnassignReasonCreateVenuesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UnassignReasonCreateVenuesEntityRelationInput"]: {
	connect?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	create?: ValueTypes["VenueWithoutEnabledUnassignReasonsCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["VenueWithoutEnabledUnassignReasonsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	deadlineTemplate?: ValueTypes["VenueCreateDeadlineTemplateEntityRelationInput"] | undefined | null,
	timetableDays?: Array<ValueTypes["VenueCreateTimetableDaysEntityRelationInput"]> | undefined | null,
	timetableTemplates?: Array<ValueTypes["VenueCreateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	staffMembers?: Array<ValueTypes["VenueCreateStaffMembersEntityRelationInput"]> | undefined | null,
	employeeRoles?: Array<ValueTypes["VenueCreateEmployeeRolesEntityRelationInput"]> | undefined | null,
	pointOfSaleApplicationDevices?: Array<ValueTypes["VenueCreatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined | null,
	pointOfSaleTerminals?: Array<ValueTypes["VenueCreatePointOfSaleTerminalsEntityRelationInput"]> | undefined | null,
	pointOfSalePrinters?: Array<ValueTypes["VenueCreatePointOfSalePrintersEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["VenueCreateOrdersEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["VenueCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	areas?: Array<ValueTypes["VenueCreateAreasEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["VenueCreateCategoriesEntityRelationInput"]> | undefined | null,
	channels?: Array<ValueTypes["VenueCreateChannelsEntityRelationInput"]> | undefined | null,
	address?: string | undefined | null,
	pointOfSalePngBase64ReceiptLogo?: string | undefined | null,
	pointOfSaleInitialView?: ValueTypes["PointOfSaleInitialView"] | undefined | null,
	pointOfSalePreferPrintReceipt?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["EmployeeQueueItemCreateMetaEntityRelationInput"]: {
	connect?: ValueTypes["EmployeeQueueItemMetadataUniqueWhere"] | undefined | null
};
	["TimetableShiftCreateSwapInfoEntityRelationInput"]: {
	connect?: ValueTypes["TimetableShiftSwapInfoUniqueWhere"] | undefined | null,
	create?: ValueTypes["TimetableShiftSwapInfoWithoutShiftCreateInput"] | undefined | null
};
	["TimetableShiftSwapInfoWithoutShiftCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	assigned?: ValueTypes["Date"] | undefined | null,
	requested?: boolean | undefined | null,
	confirmed?: boolean | undefined | null,
	swappedShiftsProfile?: ValueTypes["TimetableShiftSwapInfoCreateSwappedShiftsProfileEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableShiftSwapInfoCreateSwappedShiftsProfileEntityRelationInput"]: {
	connect?: ValueTypes["ShiftsProfileUniqueWhere"] | undefined | null,
	create?: ValueTypes["ShiftsProfileCreateInput"] | undefined | null
};
	["EmployeeQueueItemCreateShiftEntityRelationInput"]: {
	connect?: ValueTypes["TimetableShiftUniqueWhere"] | undefined | null,
	create?: ValueTypes["TimetableShiftWithoutQueueItemCreateInput"] | undefined | null
};
	["TimetableShiftWithoutQueueItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	locked?: boolean | undefined | null,
	order?: number | undefined | null,
	assigned?: ValueTypes["Date"] | undefined | null,
	group?: ValueTypes["TimetableShiftCreateGroupEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["TimetableShiftCreateShiftsProfileEntityRelationInput"] | undefined | null,
	swapInfo?: ValueTypes["TimetableShiftCreateSwapInfoEntityRelationInput"] | undefined | null,
	isOvertime?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableDayCreateMetaEntityRelationInput"]: {
	connect?: ValueTypes["TimetableDayMetadataUniqueWhere"] | undefined | null
};
	["DeliveryZoneCreateAddressesMetadataEntityRelationInput"]: {
	connect?: ValueTypes["AddressMetadataUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerCreditCreateVoucherRedemptionEntityRelationInput"]: {
	connect?: ValueTypes["VoucherRedemptionUniqueWhere"] | undefined | null,
	create?: ValueTypes["VoucherRedemptionWithoutCustomerCreditCreateInput"] | undefined | null
};
	["VoucherRedemptionWithoutCustomerCreditCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	manualRedemptionNote?: string | undefined | null,
	orderDiscount?: ValueTypes["VoucherRedemptionCreateOrderDiscountEntityRelationInput"] | undefined | null,
	voucher?: ValueTypes["VoucherRedemptionCreateVoucherEntityRelationInput"] | undefined | null,
	customer?: ValueTypes["VoucherRedemptionCreateCustomerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StaffCreateVenuesEntityRelationInput"]: {
	connect?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	create?: ValueTypes["VenueWithoutStaffMembersCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["VenueWithoutStaffMembersCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	deadlineTemplate?: ValueTypes["VenueCreateDeadlineTemplateEntityRelationInput"] | undefined | null,
	timetableDays?: Array<ValueTypes["VenueCreateTimetableDaysEntityRelationInput"]> | undefined | null,
	timetableTemplates?: Array<ValueTypes["VenueCreateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	employeeRoles?: Array<ValueTypes["VenueCreateEmployeeRolesEntityRelationInput"]> | undefined | null,
	pointOfSaleApplicationDevices?: Array<ValueTypes["VenueCreatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined | null,
	pointOfSaleTerminals?: Array<ValueTypes["VenueCreatePointOfSaleTerminalsEntityRelationInput"]> | undefined | null,
	pointOfSalePrinters?: Array<ValueTypes["VenueCreatePointOfSalePrintersEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["VenueCreateOrdersEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["VenueCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	areas?: Array<ValueTypes["VenueCreateAreasEntityRelationInput"]> | undefined | null,
	enabledUnassignReasons?: Array<ValueTypes["VenueCreateEnabledUnassignReasonsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["VenueCreateCategoriesEntityRelationInput"]> | undefined | null,
	channels?: Array<ValueTypes["VenueCreateChannelsEntityRelationInput"]> | undefined | null,
	address?: string | undefined | null,
	pointOfSalePngBase64ReceiptLogo?: string | undefined | null,
	pointOfSaleInitialView?: ValueTypes["PointOfSaleInitialView"] | undefined | null,
	pointOfSalePreferPrintReceipt?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessCustomerCreateLogoEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["BusinessCustomerCreateBusinessServiceEventsEntityRelationInput"]: {
	connect?: ValueTypes["BusinessServiceEventUniqueWhere"] | undefined | null,
	create?: ValueTypes["BusinessServiceEventWithoutBusinessCustomerCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["BusinessServiceEventWithoutBusinessCustomerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	fulfilledAt?: ValueTypes["DateTime"] | undefined | null,
	businessService?: ValueTypes["BusinessServiceEventCreateBusinessServiceEntityRelationInput"] | undefined | null,
	filledNumberOfPeople?: number | undefined | null,
	filledInvoiced?: boolean | undefined | null,
	filledEquipment?: string | undefined | null,
	filledMillTamDem?: boolean | undefined | null,
	filledSOEspresso?: boolean | undefined | null,
	filledFilterCoffeeInMenu?: boolean | undefined | null,
	filledWaterMeterStatus?: string | undefined | null,
	filledServiceAction?: string | undefined | null,
	filledInvoiceIdentifier?: string | undefined | null,
	filledNote?: string | undefined | null,
	filledContact?: string | undefined | null,
	filledPhone?: boolean | undefined | null,
	filledEmail?: boolean | undefined | null,
	filledGrindingStonesCondition?: string | undefined | null,
	createdBy?: ValueTypes["BusinessServiceEventCreateCreatedByEntityRelationInput"] | undefined | null,
	filledSupervisor?: ValueTypes["BusinessServiceEventCreateFilledSupervisorEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessServiceEventCreateBusinessServiceEntityRelationInput"]: {
	connect?: ValueTypes["BusinessServiceUniqueWhere"] | undefined | null,
	create?: ValueTypes["BusinessServiceCreateInput"] | undefined | null
};
	["BusinessServiceCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	requireNote?: number | undefined | null,
	locales?: Array<ValueTypes["BusinessServiceCreateLocalesEntityRelationInput"]> | undefined | null,
	requireNumberOfPeople?: number | undefined | null,
	requireInvoiced?: number | undefined | null,
	requireEquipment?: number | undefined | null,
	requireMillTamDem?: number | undefined | null,
	requireSOEspresso?: number | undefined | null,
	requireFilterCoffeeInMenu?: number | undefined | null,
	requireWaterMeterStatus?: number | undefined | null,
	requireServiceAction?: number | undefined | null,
	optionsEquipment?: string | undefined | null,
	optionsServiceAction?: string | undefined | null,
	requireInvoiceIdentifier?: number | undefined | null,
	requireSupervisor?: number | undefined | null,
	requireContact?: number | undefined | null,
	requirePhone?: number | undefined | null,
	requireEmail?: number | undefined | null,
	requireGrindingStonesCondition?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessServiceCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["BusinessServiceLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["BusinessServiceLocaleWithoutRootCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["BusinessServiceLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	labelNote?: string | undefined | null,
	locale?: ValueTypes["BusinessServiceLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	labelNumberOfPeople?: string | undefined | null,
	labelInvoiced?: string | undefined | null,
	labelEquipment?: string | undefined | null,
	labelMillTamDem?: string | undefined | null,
	labelSOEspresso?: string | undefined | null,
	labelFilterCoffeeInMenu?: string | undefined | null,
	labelWaterMeterStatus?: string | undefined | null,
	labelServiceAction?: string | undefined | null,
	labelInvoiceIdentifier?: string | undefined | null,
	labelSupervisor?: string | undefined | null,
	labelContact?: string | undefined | null,
	labelPhone?: string | undefined | null,
	labelEmail?: string | undefined | null,
	labelGrindingStonesCondition?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessServiceLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["LocaleWithoutBusinessServicesCreateInput"] | undefined | null
};
	["LocaleWithoutBusinessServicesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	businessCategories?: Array<ValueTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleCreateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleCreatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleCreateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessServiceEventCreateCreatedByEntityRelationInput"]: {
	connect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	create?: ValueTypes["StaffCreateInput"] | undefined | null
};
	["StaffCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	bartender?: ValueTypes["StaffCreateBartenderEntityRelationInput"] | undefined | null,
	courier?: ValueTypes["StaffCreateCourierEntityRelationInput"] | undefined | null,
	cleaner?: ValueTypes["StaffCreateCleanerEntityRelationInput"] | undefined | null,
	shiftsManager?: ValueTypes["StaffCreateShiftsManagerEntityRelationInput"] | undefined | null,
	businessToBusinessManager?: ValueTypes["StaffCreateBusinessToBusinessManagerEntityRelationInput"] | undefined | null,
	user?: ValueTypes["StaffCreateUserEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["StaffCreateShiftsProfileEntityRelationInput"] | undefined | null,
	stocksManager?: ValueTypes["StaffCreateStocksManagerEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["StaffCreatePhotoEntityRelationInput"] | undefined | null,
	courierManager?: ValueTypes["StaffCreateCourierManagerEntityRelationInput"] | undefined | null,
	picker?: ValueTypes["StaffCreatePickerEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	remunerationProfile?: ValueTypes["StaffCreateRemunerationProfileEntityRelationInput"] | undefined | null,
	cashier?: ValueTypes["StaffCreateCashierEntityRelationInput"] | undefined | null,
	venues?: Array<ValueTypes["StaffCreateVenuesEntityRelationInput"]> | undefined | null,
	internalBuyer?: ValueTypes["StaffCreateInternalBuyerEntityRelationInput"] | undefined | null,
	salesManager?: ValueTypes["StaffCreateSalesManagerEntityRelationInput"] | undefined | null,
	cashierManager?: ValueTypes["StaffCreateCashierManagerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessServiceEventCreateFilledSupervisorEntityRelationInput"]: {
	connect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	create?: ValueTypes["StaffCreateInput"] | undefined | null
};
	["BusinessCustomerCreateDoubleshotCoffeeEquipmentEntityRelationInput"]: {
	connect?: ValueTypes["DoubleshotCoffeeEquipmentUniqueWhere"] | undefined | null,
	create?: ValueTypes["DoubleshotCoffeeEquipmentCreateInput"] | undefined | null
};
	["DoubleshotCoffeeEquipmentCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	espressoMachine?: string | undefined | null,
	espressoGrinder?: string | undefined | null,
	batchBrew?: string | undefined | null,
	batchGrinder?: string | undefined | null,
	waterFilter?: string | undefined | null,
	mechanicalFilter?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableDayCreateVenueEntityRelationInput"]: {
	connect?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	create?: ValueTypes["VenueWithoutTimetableDaysCreateInput"] | undefined | null
};
	["VenueWithoutTimetableDaysCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	deadlineTemplate?: ValueTypes["VenueCreateDeadlineTemplateEntityRelationInput"] | undefined | null,
	timetableTemplates?: Array<ValueTypes["VenueCreateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	staffMembers?: Array<ValueTypes["VenueCreateStaffMembersEntityRelationInput"]> | undefined | null,
	employeeRoles?: Array<ValueTypes["VenueCreateEmployeeRolesEntityRelationInput"]> | undefined | null,
	pointOfSaleApplicationDevices?: Array<ValueTypes["VenueCreatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined | null,
	pointOfSaleTerminals?: Array<ValueTypes["VenueCreatePointOfSaleTerminalsEntityRelationInput"]> | undefined | null,
	pointOfSalePrinters?: Array<ValueTypes["VenueCreatePointOfSalePrintersEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["VenueCreateOrdersEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["VenueCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	areas?: Array<ValueTypes["VenueCreateAreasEntityRelationInput"]> | undefined | null,
	enabledUnassignReasons?: Array<ValueTypes["VenueCreateEnabledUnassignReasonsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["VenueCreateCategoriesEntityRelationInput"]> | undefined | null,
	channels?: Array<ValueTypes["VenueCreateChannelsEntityRelationInput"]> | undefined | null,
	address?: string | undefined | null,
	pointOfSalePngBase64ReceiptLogo?: string | undefined | null,
	pointOfSaleInitialView?: ValueTypes["PointOfSaleInitialView"] | undefined | null,
	pointOfSalePreferPrintReceipt?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["WorkspaceCreateDiscountVatRateEntityRelationInput"]: {
	connect?: ValueTypes["VatRateUniqueWhere"] | undefined | null,
	create?: ValueTypes["VatRateCreateInput"] | undefined | null
};
	["ProductIngredientCreateImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["ProductIngredientCreateSuppliersEntityRelationInput"]: {
	connect?: ValueTypes["IngredientSupplierListUniqueWhere"] | undefined | null,
	create?: ValueTypes["IngredientSupplierListCreateInput"] | undefined | null
};
	["IngredientSupplierListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: Array<ValueTypes["IngredientSupplierListCreateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IngredientSupplierListCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["IngredientSupplierItemUniqueWhere"] | undefined | null,
	create?: ValueTypes["IngredientSupplierItemWithoutListCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["IngredientSupplierItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	supplier?: ValueTypes["IngredientSupplierItemCreateSupplierEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IngredientSupplierItemCreateSupplierEntityRelationInput"]: {
	connect?: ValueTypes["IngredientSupplierUniqueWhere"] | undefined | null,
	create?: ValueTypes["IngredientSupplierCreateInput"] | undefined | null
};
	["IngredientSupplierCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	internalName?: string | undefined | null,
	internalNote?: string | undefined | null,
	locales?: Array<ValueTypes["IngredientSupplierCreateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IngredientSupplierCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["IngredientSupplierLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["IngredientSupplierLocaleWithoutRootCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["IngredientSupplierLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	locale?: ValueTypes["IngredientSupplierLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IngredientSupplierLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["LocaleWithoutIngredientSuppliersCreateInput"] | undefined | null
};
	["LocaleWithoutIngredientSuppliersCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	businessCategories?: Array<ValueTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleCreateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleCreatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleCreateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessCategoryCreateSpecificProductsEntityRelationInput"]: {
	connect?: ValueTypes["ProductListUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductListWithoutBusinessCategoryCreateInput"] | undefined | null
};
	["ProductListWithoutBusinessCategoryCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: Array<ValueTypes["ProductListCreateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductListCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["ProductListItemUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductListItemWithoutListCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductListItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	product?: ValueTypes["ProductListItemCreateProductEntityRelationInput"] | undefined | null,
	defaultQuantityForOrder?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductListItemCreateProductEntityRelationInput"]: {
	connect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductCreateInput"] | undefined | null
};
	["BusinessCategoryCreateSeasonalProductCategoriesEntityRelationInput"]: {
	connect?: ValueTypes["ProductCategoryListUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductCategoryListWithoutSeasonalProductCategoriesOfBusinessCategoryCreateInput"] | undefined | null
};
	["ProductCategoryListWithoutSeasonalProductCategoriesOfBusinessCategoryCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: Array<ValueTypes["ProductCategoryListCreateItemsEntityRelationInput"]> | undefined | null,
	locales?: Array<ValueTypes["ProductCategoryListCreateLocalesEntityRelationInput"]> | undefined | null,
	specificProductsProductCategoriesOfBusinessCategory?: ValueTypes["ProductCategoryListCreateSpecificProductsProductCategoriesOfBusinessCategoryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCategoryListCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["ProductCategoryListLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductCategoryListLocaleWithoutRootCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductCategoryListLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	locale?: ValueTypes["ProductCategoryListLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCategoryListLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["LocaleWithoutProductCategoryListsCreateInput"] | undefined | null
};
	["LocaleWithoutProductCategoryListsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	businessCategories?: Array<ValueTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleCreateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleCreatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleCreateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCategoryListCreateSpecificProductsProductCategoriesOfBusinessCategoryEntityRelationInput"]: {
	connect?: ValueTypes["BusinessCategoryUniqueWhere"] | undefined | null,
	create?: ValueTypes["BusinessCategoryWithoutSpecificProductsProductCategoriesCreateInput"] | undefined | null
};
	["BusinessCategoryWithoutSpecificProductsProductCategoriesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	visibleToNewCustomers?: boolean | undefined | null,
	locales?: Array<ValueTypes["BusinessCategoryCreateLocalesEntityRelationInput"]> | undefined | null,
	internalName?: string | undefined | null,
	businessCustomers?: Array<ValueTypes["BusinessCategoryCreateBusinessCustomersEntityRelationInput"]> | undefined | null,
	recurrences?: Array<ValueTypes["BusinessCategoryCreateRecurrencesEntityRelationInput"]> | undefined | null,
	specificProducts?: ValueTypes["BusinessCategoryCreateSpecificProductsEntityRelationInput"] | undefined | null,
	seasonalProductCategories?: ValueTypes["BusinessCategoryCreateSeasonalProductCategoriesEntityRelationInput"] | undefined | null,
	slug?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessCategoryCreateSpecificProductsProductCategoriesEntityRelationInput"]: {
	connect?: ValueTypes["ProductCategoryListUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductCategoryListWithoutSpecificProductsProductCategoriesOfBusinessCategoryCreateInput"] | undefined | null
};
	["ProductCategoryListWithoutSpecificProductsProductCategoriesOfBusinessCategoryCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: Array<ValueTypes["ProductCategoryListCreateItemsEntityRelationInput"]> | undefined | null,
	locales?: Array<ValueTypes["ProductCategoryListCreateLocalesEntityRelationInput"]> | undefined | null,
	seasonalProductCategoriesOfBusinessCategory?: ValueTypes["ProductCategoryListCreateSeasonalProductCategoriesOfBusinessCategoryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCategoryListCreateSeasonalProductCategoriesOfBusinessCategoryEntityRelationInput"]: {
	connect?: ValueTypes["BusinessCategoryUniqueWhere"] | undefined | null,
	create?: ValueTypes["BusinessCategoryWithoutSeasonalProductCategoriesCreateInput"] | undefined | null
};
	["BusinessCategoryWithoutSeasonalProductCategoriesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	visibleToNewCustomers?: boolean | undefined | null,
	locales?: Array<ValueTypes["BusinessCategoryCreateLocalesEntityRelationInput"]> | undefined | null,
	internalName?: string | undefined | null,
	businessCustomers?: Array<ValueTypes["BusinessCategoryCreateBusinessCustomersEntityRelationInput"]> | undefined | null,
	recurrences?: Array<ValueTypes["BusinessCategoryCreateRecurrencesEntityRelationInput"]> | undefined | null,
	specificProducts?: ValueTypes["BusinessCategoryCreateSpecificProductsEntityRelationInput"] | undefined | null,
	specificProductsProductCategories?: ValueTypes["BusinessCategoryCreateSpecificProductsProductCategoriesEntityRelationInput"] | undefined | null,
	slug?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkableCreateRedirectEntityRelationInput"]: {
	connect?: ValueTypes["RedirectUniqueWhere"] | undefined | null,
	create?: ValueTypes["RedirectWithoutLinkCreateInput"] | undefined | null
};
	["RedirectWithoutLinkCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	target?: ValueTypes["RedirectCreateTargetEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RedirectCreateTargetEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null,
	create?: ValueTypes["LinkCreateInput"] | undefined | null
};
	["WikiPageCreateContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null,
	create?: ValueTypes["ContentCreateInput"] | undefined | null
};
	["WikiPageCreateChildrenEntityRelationInput"]: {
	connect?: ValueTypes["WikiPageUniqueWhere"] | undefined | null,
	create?: ValueTypes["WikiPageWithoutParentCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["WikiPageWithoutParentCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	title?: string | undefined | null,
	emoji?: string | undefined | null,
	link?: ValueTypes["WikiPageCreateLinkEntityRelationInput"] | undefined | null,
	children?: Array<ValueTypes["WikiPageCreateChildrenEntityRelationInput"]> | undefined | null,
	content?: ValueTypes["WikiPageCreateContentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BlogPostLocaleCreateSeoEntityRelationInput"]: {
	connect?: ValueTypes["SeoUniqueWhere"] | undefined | null,
	create?: ValueTypes["SeoCreateInput"] | undefined | null
};
	["BlogPostLocaleCreateProductsEntityRelationInput"]: {
	connect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ContentReferenceCreateBlogPostsEntityRelationInput"]: {
	connect?: ValueTypes["BlogPostListUniqueWhere"] | undefined | null,
	create?: ValueTypes["BlogPostListCreateInput"] | undefined | null
};
	["BlogPostListUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: ValueTypes["BlogPostListItemUniqueWhere"] | undefined | null
};
	["BlogPostListItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["BlogPostListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: Array<ValueTypes["BlogPostListCreateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BlogPostListCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["BlogPostListItemUniqueWhere"] | undefined | null,
	create?: ValueTypes["BlogPostListItemWithoutListCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["BlogPostListItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	caption?: string | undefined | null,
	blogPost?: ValueTypes["BlogPostListItemCreateBlogPostEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BlogPostListItemCreateBlogPostEntityRelationInput"]: {
	connect?: ValueTypes["BlogPostLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["BlogPostLocaleCreateInput"] | undefined | null
};
	["BlogPostLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	availableForWeb?: boolean | undefined | null,
	availableForMobile?: boolean | undefined | null,
	root?: ValueTypes["BlogPostLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["BlogPostLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	cover?: ValueTypes["BlogPostLocaleCreateCoverEntityRelationInput"] | undefined | null,
	content?: ValueTypes["BlogPostLocaleCreateContentEntityRelationInput"] | undefined | null,
	link?: ValueTypes["BlogPostLocaleCreateLinkEntityRelationInput"] | undefined | null,
	seo?: ValueTypes["BlogPostLocaleCreateSeoEntityRelationInput"] | undefined | null,
	products?: Array<ValueTypes["BlogPostLocaleCreateProductsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BlogPostLocaleCreateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null,
	create?: ValueTypes["LinkableWithoutBlogPostCreateInput"] | undefined | null
};
	["LinkableWithoutBlogPostCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	url?: string | undefined | null,
	page?: ValueTypes["LinkableCreatePageEntityRelationInput"] | undefined | null,
	wikiPage?: ValueTypes["LinkableCreateWikiPageEntityRelationInput"] | undefined | null,
	redirect?: ValueTypes["LinkableCreateRedirectEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentReferenceCreateLinksEntityRelationInput"]: {
	connect?: ValueTypes["LinkListUniqueWhere"] | undefined | null,
	create?: ValueTypes["LinkListCreateInput"] | undefined | null
};
	["ContentReferenceCreateProductsEntityRelationInput"]: {
	connect?: ValueTypes["ProductListUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductListCreateInput"] | undefined | null
};
	["ProductListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: Array<ValueTypes["ProductListCreateItemsEntityRelationInput"]> | undefined | null,
	businessCategory?: ValueTypes["ProductListCreateBusinessCategoryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductListCreateBusinessCategoryEntityRelationInput"]: {
	connect?: ValueTypes["BusinessCategoryUniqueWhere"] | undefined | null,
	create?: ValueTypes["BusinessCategoryWithoutSpecificProductsCreateInput"] | undefined | null
};
	["BusinessCategoryWithoutSpecificProductsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	visibleToNewCustomers?: boolean | undefined | null,
	locales?: Array<ValueTypes["BusinessCategoryCreateLocalesEntityRelationInput"]> | undefined | null,
	internalName?: string | undefined | null,
	businessCustomers?: Array<ValueTypes["BusinessCategoryCreateBusinessCustomersEntityRelationInput"]> | undefined | null,
	recurrences?: Array<ValueTypes["BusinessCategoryCreateRecurrencesEntityRelationInput"]> | undefined | null,
	seasonalProductCategories?: ValueTypes["BusinessCategoryCreateSeasonalProductCategoriesEntityRelationInput"] | undefined | null,
	specificProductsProductCategories?: ValueTypes["BusinessCategoryCreateSpecificProductsProductCategoriesEntityRelationInput"] | undefined | null,
	slug?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentReferenceCreateHeroEntityRelationInput"]: {
	connect?: ValueTypes["HeroUniqueWhere"] | undefined | null,
	create?: ValueTypes["HeroCreateInput"] | undefined | null
};
	["HeroUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["HeroCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	showLogo?: boolean | undefined | null,
	middleContent?: string | undefined | null,
	medium?: ValueTypes["HeroCreateMediumEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HeroCreateMediumEntityRelationInput"]: {
	connect?: ValueTypes["MediumUniqueWhere"] | undefined | null,
	create?: ValueTypes["MediumCreateInput"] | undefined | null
};
	["ContentReferenceCreateGalleryEntityRelationInput"]: {
	connect?: ValueTypes["GalleryUniqueWhere"] | undefined | null,
	create?: ValueTypes["GalleryCreateInput"] | undefined | null
};
	["GalleryUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: ValueTypes["GalleryItemUniqueWhere"] | undefined | null
};
	["GalleryItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["GalleryCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: Array<ValueTypes["GalleryCreateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GalleryCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["GalleryItemUniqueWhere"] | undefined | null,
	create?: ValueTypes["GalleryItemWithoutListCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["GalleryItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	caption?: string | undefined | null,
	medium?: ValueTypes["GalleryItemCreateMediumEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GalleryItemCreateMediumEntityRelationInput"]: {
	connect?: ValueTypes["MediumUniqueWhere"] | undefined | null,
	create?: ValueTypes["MediumCreateInput"] | undefined | null
};
	["ContentReferenceCreateSocialsAndAppsEntityRelationInput"]: {
	connect?: ValueTypes["SocialsAndAppsUniqueWhere"] | undefined | null,
	create?: ValueTypes["SocialsAndAppsCreateInput"] | undefined | null
};
	["ContentReferenceCreateProductGridEntityRelationInput"]: {
	connect?: ValueTypes["ProductGridUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductGridCreateInput"] | undefined | null
};
	["ProductGridUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	categories?: ValueTypes["ProductGridCategoryUniqueWhere"] | undefined | null
};
	["ProductGridCategoryUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: ValueTypes["ProductGridItemUniqueWhere"] | undefined | null,
	images?: ValueTypes["ImageListUniqueWhere"] | undefined | null
};
	["ProductGridCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	isCarousel?: boolean | undefined | null,
	categories?: Array<ValueTypes["ProductGridCreateCategoriesEntityRelationInput"]> | undefined | null,
	type?: ValueTypes["ProductGridType"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductGridCreateCategoriesEntityRelationInput"]: {
	connect?: ValueTypes["ProductGridCategoryUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductGridCategoryWithoutRootCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductGridCategoryWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	title?: string | undefined | null,
	items?: Array<ValueTypes["ProductGridCategoryCreateItemsEntityRelationInput"]> | undefined | null,
	images?: ValueTypes["ProductGridCategoryCreateImagesEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductGridCategoryCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["ProductGridItemUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductGridItemWithoutCategoryCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductGridItemWithoutCategoryCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	title?: string | undefined | null,
	lead?: string | undefined | null,
	product?: ValueTypes["ProductGridItemCreateProductEntityRelationInput"] | undefined | null,
	medium?: ValueTypes["ProductGridItemCreateMediumEntityRelationInput"] | undefined | null,
	link?: ValueTypes["ProductGridItemCreateLinkEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductGridItemCreateProductEntityRelationInput"]: {
	connect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductCreateInput"] | undefined | null
};
	["ProductGridItemCreateMediumEntityRelationInput"]: {
	connect?: ValueTypes["MediumUniqueWhere"] | undefined | null,
	create?: ValueTypes["MediumCreateInput"] | undefined | null
};
	["ProductGridItemCreateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null,
	create?: ValueTypes["LinkCreateInput"] | undefined | null
};
	["ProductGridCategoryCreateImagesEntityRelationInput"]: {
	connect?: ValueTypes["ImageListUniqueWhere"] | undefined | null,
	create?: ValueTypes["ImageListCreateInput"] | undefined | null
};
	["ContentReferenceCreateProductBannersEntityRelationInput"]: {
	connect?: ValueTypes["ProductBannerListUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductBannerListCreateInput"] | undefined | null
};
	["ProductBannerListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: Array<ValueTypes["ProductBannerListCreateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductBannerListCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["ProductBannerItemUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductBannerItemWithoutListCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductBannerItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	banner?: ValueTypes["ProductBannerItemCreateBannerEntityRelationInput"] | undefined | null,
	size?: ValueTypes["ProductBannerItemSize"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductBannerItemCreateBannerEntityRelationInput"]: {
	connect?: ValueTypes["ProductBannerUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductBannerCreateInput"] | undefined | null
};
	["ProductBannerUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	button?: ValueTypes["LinkUniqueWhere"] | undefined | null
};
	["ProductBannerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	beforeTitle?: string | undefined | null,
	title?: string | undefined | null,
	label?: string | undefined | null,
	button?: ValueTypes["ProductBannerCreateButtonEntityRelationInput"] | undefined | null,
	backgroundImage?: ValueTypes["ProductBannerCreateBackgroundImageEntityRelationInput"] | undefined | null,
	productImage?: ValueTypes["ProductBannerCreateProductImageEntityRelationInput"] | undefined | null,
	product?: ValueTypes["ProductBannerCreateProductEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductBannerCreateButtonEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null,
	create?: ValueTypes["LinkCreateInput"] | undefined | null
};
	["ProductBannerCreateBackgroundImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["ProductBannerCreateProductImageEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["ProductBannerCreateProductEntityRelationInput"]: {
	connect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductCreateInput"] | undefined | null
};
	["ContentReferenceCreateDeliveryRegionsEntityRelationInput"]: {
	connect?: ValueTypes["DeliveryRegionsUniqueWhere"] | undefined | null,
	create?: ValueTypes["DeliveryRegionsCreateInput"] | undefined | null
};
	["ContentReferenceCreateTextListEntityRelationInput"]: {
	connect?: ValueTypes["TextListUniqueWhere"] | undefined | null,
	create?: ValueTypes["TextListCreateInput"] | undefined | null
};
	["ContentReferenceCreateGridTilesEntityRelationInput"]: {
	connect?: ValueTypes["GridTilesUniqueWhere"] | undefined | null,
	create?: ValueTypes["GridTilesCreateInput"] | undefined | null
};
	["GridTilesUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: ValueTypes["GridTileItemUniqueWhere"] | undefined | null
};
	["GridTileItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	link?: ValueTypes["LinkUniqueWhere"] | undefined | null
};
	["GridTilesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: Array<ValueTypes["GridTilesCreateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GridTilesCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["GridTileItemUniqueWhere"] | undefined | null,
	create?: ValueTypes["GridTileItemWithoutListCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["GridTileItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	text?: string | undefined | null,
	medium?: ValueTypes["GridTileItemCreateMediumEntityRelationInput"] | undefined | null,
	link?: ValueTypes["GridTileItemCreateLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GridTileItemCreateMediumEntityRelationInput"]: {
	connect?: ValueTypes["MediumUniqueWhere"] | undefined | null,
	create?: ValueTypes["MediumCreateInput"] | undefined | null
};
	["GridTileItemCreateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null,
	create?: ValueTypes["LinkCreateInput"] | undefined | null
};
	["CartItemCreateFulfillmentNotesEntityRelationInput"]: {
	connect?: ValueTypes["FulfillmentNoteUniqueWhere"] | undefined | null,
	create?: ValueTypes["FulfillmentNoteWithoutCartItemsCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["FulfillmentNoteWithoutCartItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	note?: string | undefined | null,
	products?: Array<ValueTypes["FulfillmentNoteCreateProductsEntityRelationInput"]> | undefined | null,
	tags?: Array<ValueTypes["FulfillmentNoteCreateTagsEntityRelationInput"]> | undefined | null,
	venues?: Array<ValueTypes["FulfillmentNoteCreateVenuesEntityRelationInput"]> | undefined | null,
	orderItems?: Array<ValueTypes["FulfillmentNoteCreateOrderItemsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["FulfillmentNoteCreateOrdersEntityRelationInput"]> | undefined | null,
	highlight?: boolean | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	emoji?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientItemCreateQuantityEntityRelationInput"]: {
	connect?: ValueTypes["ProductIngredientItemQuantityUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductIngredientItemQuantityCreateInput"] | undefined | null
};
	["ProductIngredientItemQuantityCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	unit?: ValueTypes["ProductIngredientItemQuantityCreateUnitEntityRelationInput"] | undefined | null,
	value?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientItemQuantityCreateUnitEntityRelationInput"]: {
	connect?: ValueTypes["ProductIngredientItemQuantityUnitUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductIngredientItemQuantityUnitCreateInput"] | undefined | null
};
	["AddressUpdateInput"]: {
	name?: string | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	addressLine2?: string | undefined | null,
	email?: string | undefined | null,
	phone?: string | undefined | null,
	companyName?: string | undefined | null,
	companyIdentifier?: string | undefined | null,
	vatIdentifier?: string | undefined | null,
	externalIdentifier?: string | undefined | null,
	hidden?: boolean | undefined | null,
	customer?: ValueTypes["AddressUpdateCustomerEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	country?: ValueTypes["AddressUpdateCountryEntityRelationInput"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	googlePlaceId?: string | undefined | null,
	raw?: string | undefined | null,
	formatted?: string | undefined | null,
	geocodeGeneratedAt?: ValueTypes["DateTime"] | undefined | null,
	geocodeResponse?: string | undefined | null,
	deliveryZone?: ValueTypes["AddressUpdateDeliveryZoneEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["AddressUpdateMetaEntityRelationInput"] | undefined | null,
	gps?: ValueTypes["AddressUpdateGpsEntityRelationInput"] | undefined | null,
	geocodeValid?: boolean | undefined | null,
	fullName?: string | undefined | null,
	fakturoidSubjectId?: string | undefined | null,
	invoices?: Array<ValueTypes["AddressUpdateInvoicesEntityRelationInput"]> | undefined | null,
	addressLine1?: string | undefined | null,
	city?: string | undefined | null,
	postalCode?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingAddressOfOrders?: Array<ValueTypes["AddressUpdateBillingAddressOfOrdersEntityRelationInput"]> | undefined | null,
	deliveryAddressOfOrderDeliveries?: Array<ValueTypes["AddressUpdateDeliveryAddressOfOrderDeliveriesEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddressOfCustomer?: ValueTypes["AddressUpdateDefaultDeliveryAddressOfCustomerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AddressUpdateCustomerEntityRelationInput"]: {
	create?: ValueTypes["CustomerWithoutAddressesCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerWithoutAddressesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["AddressUpsertCustomerRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CustomerWithoutAddressesUpdateInput"]: {
	defaultBillingAddress?: ValueTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerUpdateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerUpdateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerUpdateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerUpdateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerUpdateDefaultBillingAddressEntityRelationInput"]: {
	create?: ValueTypes["AddressCreateInput"] | undefined | null,
	update?: ValueTypes["AddressUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CustomerUpsertDefaultBillingAddressRelationInput"] | undefined | null,
	connect?: ValueTypes["AddressUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CustomerUpsertDefaultBillingAddressRelationInput"]: {
	update?: ValueTypes["AddressUpdateInput"] | undefined | null,
	create?: ValueTypes["AddressCreateInput"] | undefined | null
};
	["CustomerUpdateDefaultPaymentMethodEntityRelationInput"]: {
	create?: ValueTypes["CustomerPaymentMethodCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerPaymentMethodUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CustomerUpsertDefaultPaymentMethodRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerPaymentMethodUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CustomerPaymentMethodUpdateInput"]: {
	caption?: string | undefined | null,
	data?: ValueTypes["Json"] | undefined | null,
	customer?: ValueTypes["CustomerPaymentMethodUpdateCustomerEntityRelationInput"] | undefined | null,
	paymentMethod?: ValueTypes["CustomerPaymentMethodUpdatePaymentMethodEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerPaymentMethodUpdateCustomerEntityRelationInput"]: {
	create?: ValueTypes["CustomerWithoutPaymentMethodsCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerWithoutPaymentMethodsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CustomerPaymentMethodUpsertCustomerRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["CustomerWithoutPaymentMethodsUpdateInput"]: {
	addresses?: Array<ValueTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerUpdateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerUpdateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerUpdateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerUpdateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerUpdateAddressesEntityRelationInput"]: {
	create?: ValueTypes["AddressWithoutCustomerCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerUpdateAddressesRelationInput"] | undefined | null,
	upsert?: ValueTypes["CustomerUpsertAddressesRelationInput"] | undefined | null,
	connect?: ValueTypes["AddressUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["AddressUniqueWhere"] | undefined | null,
	delete?: ValueTypes["AddressUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerUpdateAddressesRelationInput"]: {
	by?: ValueTypes["AddressUniqueWhere"] | undefined | null,
	data?: ValueTypes["AddressWithoutCustomerUpdateInput"] | undefined | null
};
	["AddressWithoutCustomerUpdateInput"]: {
	name?: string | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	addressLine2?: string | undefined | null,
	email?: string | undefined | null,
	phone?: string | undefined | null,
	companyName?: string | undefined | null,
	companyIdentifier?: string | undefined | null,
	vatIdentifier?: string | undefined | null,
	externalIdentifier?: string | undefined | null,
	hidden?: boolean | undefined | null,
	internalNote?: string | undefined | null,
	country?: ValueTypes["AddressUpdateCountryEntityRelationInput"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	googlePlaceId?: string | undefined | null,
	raw?: string | undefined | null,
	formatted?: string | undefined | null,
	geocodeGeneratedAt?: ValueTypes["DateTime"] | undefined | null,
	geocodeResponse?: string | undefined | null,
	deliveryZone?: ValueTypes["AddressUpdateDeliveryZoneEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["AddressUpdateMetaEntityRelationInput"] | undefined | null,
	gps?: ValueTypes["AddressUpdateGpsEntityRelationInput"] | undefined | null,
	geocodeValid?: boolean | undefined | null,
	fullName?: string | undefined | null,
	fakturoidSubjectId?: string | undefined | null,
	invoices?: Array<ValueTypes["AddressUpdateInvoicesEntityRelationInput"]> | undefined | null,
	addressLine1?: string | undefined | null,
	city?: string | undefined | null,
	postalCode?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingAddressOfOrders?: Array<ValueTypes["AddressUpdateBillingAddressOfOrdersEntityRelationInput"]> | undefined | null,
	deliveryAddressOfOrderDeliveries?: Array<ValueTypes["AddressUpdateDeliveryAddressOfOrderDeliveriesEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddressOfCustomer?: ValueTypes["AddressUpdateDefaultDeliveryAddressOfCustomerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AddressUpdateCountryEntityRelationInput"]: {
	create?: ValueTypes["CountryCreateInput"] | undefined | null,
	update?: ValueTypes["CountryUpdateInput"] | undefined | null,
	upsert?: ValueTypes["AddressUpsertCountryRelationInput"] | undefined | null,
	connect?: ValueTypes["CountryUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["CountryUpdateInput"]: {
	code?: string | undefined | null,
	order?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AddressUpsertCountryRelationInput"]: {
	update?: ValueTypes["CountryUpdateInput"] | undefined | null,
	create?: ValueTypes["CountryCreateInput"] | undefined | null
};
	["AddressUpdateDeliveryZoneEntityRelationInput"]: {
	create?: ValueTypes["DeliveryZoneWithoutAddressesCreateInput"] | undefined | null,
	update?: ValueTypes["DeliveryZoneWithoutAddressesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["AddressUpsertDeliveryZoneRelationInput"] | undefined | null,
	connect?: ValueTypes["DeliveryZoneUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["DeliveryZoneWithoutAddressesUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	type?: ValueTypes["DeliveryZoneType"] | undefined | null,
	suitableDeliveryMethods?: Array<ValueTypes["DeliveryZoneUpdateSuitableDeliveryMethodsEntityRelationInput"]> | undefined | null,
	deliveryZonesOfTags?: Array<ValueTypes["DeliveryZoneUpdateDeliveryZonesOfTagsEntityRelationInput"]> | undefined | null,
	deliveryZonesOfProducts?: Array<ValueTypes["DeliveryZoneUpdateDeliveryZonesOfProductsEntityRelationInput"]> | undefined | null,
	addressesMetadata?: Array<ValueTypes["DeliveryZoneUpdateAddressesMetadataEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryZoneUpdateSuitableDeliveryMethodsEntityRelationInput"]: {
	create?: ValueTypes["DeliveryMethodWithoutSuitableForDeliveryZonesCreateInput"] | undefined | null,
	update?: ValueTypes["DeliveryZoneUpdateSuitableDeliveryMethodsRelationInput"] | undefined | null,
	upsert?: ValueTypes["DeliveryZoneUpsertSuitableDeliveryMethodsRelationInput"] | undefined | null,
	connect?: ValueTypes["DeliveryMethodUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["DeliveryMethodUniqueWhere"] | undefined | null,
	delete?: ValueTypes["DeliveryMethodUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["DeliveryZoneUpdateSuitableDeliveryMethodsRelationInput"]: {
	by?: ValueTypes["DeliveryMethodUniqueWhere"] | undefined | null,
	data?: ValueTypes["DeliveryMethodWithoutSuitableForDeliveryZonesUpdateInput"] | undefined | null
};
	["DeliveryMethodWithoutSuitableForDeliveryZonesUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	enabled?: boolean | undefined | null,
	paymentMethods?: Array<ValueTypes["DeliveryMethodUpdatePaymentMethodsEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	requireDeliveryAddress?: boolean | undefined | null,
	channels?: Array<ValueTypes["DeliveryMethodUpdateChannelsEntityRelationInput"]> | undefined | null,
	courierHandlers?: Array<ValueTypes["DeliveryMethodUpdateCourierHandlersEntityRelationInput"]> | undefined | null,
	enableDeliveryTracking?: boolean | undefined | null,
	locales?: Array<ValueTypes["DeliveryMethodUpdateLocalesEntityRelationInput"]> | undefined | null,
	timelinePreset?: ValueTypes["DeliveryMethodUpdateTimelinePresetEntityRelationInput"] | undefined | null,
	woltDriveVenueId?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryMethodUpdatePaymentMethodsEntityRelationInput"]: {
	create?: ValueTypes["PaymentMethodWithoutDeliveryMethodsCreateInput"] | undefined | null,
	update?: ValueTypes["DeliveryMethodUpdatePaymentMethodsRelationInput"] | undefined | null,
	upsert?: ValueTypes["DeliveryMethodUpsertPaymentMethodsRelationInput"] | undefined | null,
	connect?: ValueTypes["PaymentMethodUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["PaymentMethodUniqueWhere"] | undefined | null,
	delete?: ValueTypes["PaymentMethodUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["DeliveryMethodUpdatePaymentMethodsRelationInput"]: {
	by?: ValueTypes["PaymentMethodUniqueWhere"] | undefined | null,
	data?: ValueTypes["PaymentMethodWithoutDeliveryMethodsUpdateInput"] | undefined | null
};
	["PaymentMethodWithoutDeliveryMethodsUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	enabled?: boolean | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	blockingDispatch?: boolean | undefined | null,
	type?: ValueTypes["PaymentMethodType"] | undefined | null,
	channels?: Array<ValueTypes["PaymentMethodUpdateChannelsEntityRelationInput"]> | undefined | null,
	reduceGratuityByPercentage?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PaymentMethodUpdateChannelsEntityRelationInput"]: {
	create?: ValueTypes["ChannelPaymentWithoutMethodCreateInput"] | undefined | null,
	update?: ValueTypes["PaymentMethodUpdateChannelsRelationInput"] | undefined | null,
	upsert?: ValueTypes["PaymentMethodUpsertChannelsRelationInput"] | undefined | null,
	connect?: ValueTypes["ChannelPaymentUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ChannelPaymentUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ChannelPaymentUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PaymentMethodUpdateChannelsRelationInput"]: {
	by?: ValueTypes["ChannelPaymentUniqueWhere"] | undefined | null,
	data?: ValueTypes["ChannelPaymentWithoutMethodUpdateInput"] | undefined | null
};
	["ChannelPaymentWithoutMethodUpdateInput"]: {
	order?: number | undefined | null,
	channel?: ValueTypes["ChannelPaymentUpdateChannelEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["ChannelPaymentUpdateVatRateEntityRelationInput"] | undefined | null,
	requireBillingAddress?: boolean | undefined | null,
	provideReceipt?: boolean | undefined | null,
	requireBillingSubject?: boolean | undefined | null,
	allowOnlyForTags?: Array<ValueTypes["ChannelPaymentUpdateAllowOnlyForTagsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ChannelPaymentUpdateChannelEntityRelationInput"]: {
	create?: ValueTypes["ChannelWithoutPaymentsCreateInput"] | undefined | null,
	update?: ValueTypes["ChannelWithoutPaymentsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ChannelPaymentUpsertChannelRelationInput"] | undefined | null,
	connect?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["ChannelWithoutPaymentsUpdateInput"]: {
	name?: string | undefined | null,
	disabled?: boolean | undefined | null,
	deliveries?: Array<ValueTypes["ChannelUpdateDeliveriesEntityRelationInput"]> | undefined | null,
	pointOfSales?: Array<ValueTypes["ChannelUpdatePointOfSalesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["ChannelUpdateCartsEntityRelationInput"]> | undefined | null,
	customers?: Array<ValueTypes["ChannelUpdateCustomersEntityRelationInput"]> | undefined | null,
	code?: ValueTypes["ChannelCode"] | undefined | null,
	addTagsOnRegistration?: Array<ValueTypes["ChannelUpdateAddTagsOnRegistrationEntityRelationInput"]> | undefined | null,
	publicTags?: Array<ValueTypes["ChannelUpdatePublicTagsEntityRelationInput"]> | undefined | null,
	venue?: ValueTypes["ChannelUpdateVenueEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ChannelUpdateDeliveriesEntityRelationInput"]: {
	create?: ValueTypes["ChannelDeliveryWithoutChannelCreateInput"] | undefined | null,
	update?: ValueTypes["ChannelUpdateDeliveriesRelationInput"] | undefined | null,
	upsert?: ValueTypes["ChannelUpsertDeliveriesRelationInput"] | undefined | null,
	connect?: ValueTypes["ChannelDeliveryUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ChannelDeliveryUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ChannelDeliveryUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ChannelUpdateDeliveriesRelationInput"]: {
	by?: ValueTypes["ChannelDeliveryUniqueWhere"] | undefined | null,
	data?: ValueTypes["ChannelDeliveryWithoutChannelUpdateInput"] | undefined | null
};
	["ChannelDeliveryWithoutChannelUpdateInput"]: {
	order?: number | undefined | null,
	priceCents?: number | undefined | null,
	method?: ValueTypes["ChannelDeliveryUpdateMethodEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["ChannelDeliveryUpdateVatRateEntityRelationInput"] | undefined | null,
	defaultVisible?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ChannelDeliveryUpdateMethodEntityRelationInput"]: {
	create?: ValueTypes["DeliveryMethodWithoutChannelsCreateInput"] | undefined | null,
	update?: ValueTypes["DeliveryMethodWithoutChannelsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ChannelDeliveryUpsertMethodRelationInput"] | undefined | null,
	connect?: ValueTypes["DeliveryMethodUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["DeliveryMethodWithoutChannelsUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	enabled?: boolean | undefined | null,
	paymentMethods?: Array<ValueTypes["DeliveryMethodUpdatePaymentMethodsEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	requireDeliveryAddress?: boolean | undefined | null,
	suitableForDeliveryZones?: Array<ValueTypes["DeliveryMethodUpdateSuitableForDeliveryZonesEntityRelationInput"]> | undefined | null,
	courierHandlers?: Array<ValueTypes["DeliveryMethodUpdateCourierHandlersEntityRelationInput"]> | undefined | null,
	enableDeliveryTracking?: boolean | undefined | null,
	locales?: Array<ValueTypes["DeliveryMethodUpdateLocalesEntityRelationInput"]> | undefined | null,
	timelinePreset?: ValueTypes["DeliveryMethodUpdateTimelinePresetEntityRelationInput"] | undefined | null,
	woltDriveVenueId?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryMethodUpdateSuitableForDeliveryZonesEntityRelationInput"]: {
	create?: ValueTypes["DeliveryZoneWithoutSuitableDeliveryMethodsCreateInput"] | undefined | null,
	update?: ValueTypes["DeliveryMethodUpdateSuitableForDeliveryZonesRelationInput"] | undefined | null,
	upsert?: ValueTypes["DeliveryMethodUpsertSuitableForDeliveryZonesRelationInput"] | undefined | null,
	connect?: ValueTypes["DeliveryZoneUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["DeliveryZoneUniqueWhere"] | undefined | null,
	delete?: ValueTypes["DeliveryZoneUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["DeliveryMethodUpdateSuitableForDeliveryZonesRelationInput"]: {
	by?: ValueTypes["DeliveryZoneUniqueWhere"] | undefined | null,
	data?: ValueTypes["DeliveryZoneWithoutSuitableDeliveryMethodsUpdateInput"] | undefined | null
};
	["DeliveryZoneWithoutSuitableDeliveryMethodsUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	type?: ValueTypes["DeliveryZoneType"] | undefined | null,
	addresses?: Array<ValueTypes["DeliveryZoneUpdateAddressesEntityRelationInput"]> | undefined | null,
	deliveryZonesOfTags?: Array<ValueTypes["DeliveryZoneUpdateDeliveryZonesOfTagsEntityRelationInput"]> | undefined | null,
	deliveryZonesOfProducts?: Array<ValueTypes["DeliveryZoneUpdateDeliveryZonesOfProductsEntityRelationInput"]> | undefined | null,
	addressesMetadata?: Array<ValueTypes["DeliveryZoneUpdateAddressesMetadataEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryZoneUpdateAddressesEntityRelationInput"]: {
	create?: ValueTypes["AddressWithoutDeliveryZoneCreateInput"] | undefined | null,
	update?: ValueTypes["DeliveryZoneUpdateAddressesRelationInput"] | undefined | null,
	upsert?: ValueTypes["DeliveryZoneUpsertAddressesRelationInput"] | undefined | null,
	connect?: ValueTypes["AddressUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["AddressUniqueWhere"] | undefined | null,
	delete?: ValueTypes["AddressUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["DeliveryZoneUpdateAddressesRelationInput"]: {
	by?: ValueTypes["AddressUniqueWhere"] | undefined | null,
	data?: ValueTypes["AddressWithoutDeliveryZoneUpdateInput"] | undefined | null
};
	["AddressWithoutDeliveryZoneUpdateInput"]: {
	name?: string | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	addressLine2?: string | undefined | null,
	email?: string | undefined | null,
	phone?: string | undefined | null,
	companyName?: string | undefined | null,
	companyIdentifier?: string | undefined | null,
	vatIdentifier?: string | undefined | null,
	externalIdentifier?: string | undefined | null,
	hidden?: boolean | undefined | null,
	customer?: ValueTypes["AddressUpdateCustomerEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	country?: ValueTypes["AddressUpdateCountryEntityRelationInput"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	googlePlaceId?: string | undefined | null,
	raw?: string | undefined | null,
	formatted?: string | undefined | null,
	geocodeGeneratedAt?: ValueTypes["DateTime"] | undefined | null,
	geocodeResponse?: string | undefined | null,
	meta?: ValueTypes["AddressUpdateMetaEntityRelationInput"] | undefined | null,
	gps?: ValueTypes["AddressUpdateGpsEntityRelationInput"] | undefined | null,
	geocodeValid?: boolean | undefined | null,
	fullName?: string | undefined | null,
	fakturoidSubjectId?: string | undefined | null,
	invoices?: Array<ValueTypes["AddressUpdateInvoicesEntityRelationInput"]> | undefined | null,
	addressLine1?: string | undefined | null,
	city?: string | undefined | null,
	postalCode?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingAddressOfOrders?: Array<ValueTypes["AddressUpdateBillingAddressOfOrdersEntityRelationInput"]> | undefined | null,
	deliveryAddressOfOrderDeliveries?: Array<ValueTypes["AddressUpdateDeliveryAddressOfOrderDeliveriesEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddressOfCustomer?: ValueTypes["AddressUpdateDefaultDeliveryAddressOfCustomerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AddressUpdateMetaEntityRelationInput"]: {
	connect?: ValueTypes["AddressMetadataUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["AddressUpdateGpsEntityRelationInput"]: {
	create?: ValueTypes["GpsWithoutAddressCreateInput"] | undefined | null,
	update?: ValueTypes["GpsWithoutAddressUpdateInput"] | undefined | null,
	upsert?: ValueTypes["AddressUpsertGpsRelationInput"] | undefined | null,
	connect?: ValueTypes["GpsUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["GpsWithoutAddressUpdateInput"]: {
	latitude?: number | undefined | null,
	longitude?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AddressUpsertGpsRelationInput"]: {
	update?: ValueTypes["GpsWithoutAddressUpdateInput"] | undefined | null,
	create?: ValueTypes["GpsWithoutAddressCreateInput"] | undefined | null
};
	["AddressUpdateInvoicesEntityRelationInput"]: {
	create?: ValueTypes["InvoiceWithoutAddressCreateInput"] | undefined | null,
	update?: ValueTypes["AddressUpdateInvoicesRelationInput"] | undefined | null,
	upsert?: ValueTypes["AddressUpsertInvoicesRelationInput"] | undefined | null,
	connect?: ValueTypes["InvoiceUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["InvoiceUniqueWhere"] | undefined | null,
	delete?: ValueTypes["InvoiceUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["AddressUpdateInvoicesRelationInput"]: {
	by?: ValueTypes["InvoiceUniqueWhere"] | undefined | null,
	data?: ValueTypes["InvoiceWithoutAddressUpdateInput"] | undefined | null
};
	["InvoiceWithoutAddressUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	publicKey?: string | undefined | null,
	fakturoidId?: string | undefined | null,
	fakturoidData?: string | undefined | null,
	legacyUrl?: string | undefined | null,
	customer?: ValueTypes["InvoiceUpdateCustomerEntityRelationInput"] | undefined | null,
	orderPayments?: Array<ValueTypes["InvoiceUpdateOrderPaymentsEntityRelationInput"]> | undefined | null,
	publicUrl?: string | undefined | null,
	billingSubject?: ValueTypes["InvoiceUpdateBillingSubjectEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InvoiceUpdateCustomerEntityRelationInput"]: {
	create?: ValueTypes["CustomerWithoutInvoicesCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerWithoutInvoicesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["InvoiceUpsertCustomerRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CustomerWithoutInvoicesUpdateInput"]: {
	addresses?: Array<ValueTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerUpdateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerUpdateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerUpdateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoicingPlan?: ValueTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerUpdateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerUpdateTagsEntityRelationInput"]: {
	create?: ValueTypes["TagWithoutCustomersCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerUpdateTagsRelationInput"] | undefined | null,
	upsert?: ValueTypes["CustomerUpsertTagsRelationInput"] | undefined | null,
	connect?: ValueTypes["TagUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["TagUniqueWhere"] | undefined | null,
	delete?: ValueTypes["TagUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerUpdateTagsRelationInput"]: {
	by?: ValueTypes["TagUniqueWhere"] | undefined | null,
	data?: ValueTypes["TagWithoutCustomersUpdateInput"] | undefined | null
};
	["TagWithoutCustomersUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	products?: Array<ValueTypes["TagUpdateProductsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["TagUpdateCategoriesEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	addTagsOnRegistration?: Array<ValueTypes["TagUpdateAddTagsOnRegistrationEntityRelationInput"]> | undefined | null,
	nestedCategories?: Array<ValueTypes["TagUpdateNestedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["TagUpdateDeliveryZonesEntityRelationInput"]> | undefined | null,
	publicInChannels?: Array<ValueTypes["TagUpdatePublicInChannelsEntityRelationInput"]> | undefined | null,
	allowChannelPayments?: Array<ValueTypes["TagUpdateAllowChannelPaymentsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["TagUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TagUpdateProductsEntityRelationInput"]: {
	create?: ValueTypes["ProductWithoutTagsCreateInput"] | undefined | null,
	update?: ValueTypes["TagUpdateProductsRelationInput"] | undefined | null,
	upsert?: ValueTypes["TagUpsertProductsRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["TagUpdateProductsRelationInput"]: {
	by?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	data?: ValueTypes["ProductWithoutTagsUpdateInput"] | undefined | null
};
	["ProductWithoutTagsUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	priceCents?: number | undefined | null,
	notDiscountable?: boolean | undefined | null,
	packing?: ValueTypes["ProductUpdatePackingEntityRelationInput"] | undefined | null,
	recipe?: ValueTypes["ProductUpdateRecipeEntityRelationInput"] | undefined | null,
	categories?: Array<ValueTypes["ProductUpdateCategoriesEntityRelationInput"]> | undefined | null,
	vatRate?: ValueTypes["ProductUpdateVatRateEntityRelationInput"] | undefined | null,
	stocks?: Array<ValueTypes["ProductUpdateStocksEntityRelationInput"]> | undefined | null,
	groupPrices?: Array<ValueTypes["ProductUpdateGroupPricesEntityRelationInput"]> | undefined | null,
	image?: ValueTypes["ProductUpdateImageEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	cartItems?: Array<ValueTypes["ProductUpdateCartItemsEntityRelationInput"]> | undefined | null,
	availability?: ValueTypes["ProductAvailability"] | undefined | null,
	order?: number | undefined | null,
	manager?: ValueTypes["ProductUpdateManagerEntityRelationInput"] | undefined | null,
	orderItems?: Array<ValueTypes["ProductUpdateOrderItemsEntityRelationInput"]> | undefined | null,
	maximumQuantityPerOrder?: number | undefined | null,
	inheritedCategories?: Array<ValueTypes["ProductUpdateInheritedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["ProductUpdateDeliveryZonesEntityRelationInput"]> | undefined | null,
	locales?: Array<ValueTypes["ProductUpdateLocalesEntityRelationInput"]> | undefined | null,
	archivedAt?: ValueTypes["DateTime"] | undefined | null,
	customerPrices?: Array<ValueTypes["ProductUpdateCustomerPricesEntityRelationInput"]> | undefined | null,
	virtualProduct?: ValueTypes["ProductUpdateVirtualProductEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["ProductUpdateMetaEntityRelationInput"] | undefined | null,
	page?: ValueTypes["ProductUpdatePageEntityRelationInput"] | undefined | null,
	salesDays?: Array<ValueTypes["ProductUpdateSalesDaysEntityRelationInput"]> | undefined | null,
	salesWeeks?: Array<ValueTypes["ProductUpdateSalesWeeksEntityRelationInput"]> | undefined | null,
	salesMonths?: Array<ValueTypes["ProductUpdateSalesMonthsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["ProductUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	hasSubscription?: boolean | undefined | null,
	pointOfSaleTileColor?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductUpdatePackingEntityRelationInput"]: {
	create?: ValueTypes["ProductPackingCreateInput"] | undefined | null,
	update?: ValueTypes["ProductPackingUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductUpsertPackingRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductPackingUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductPackingUpdateInput"]: {
	name?: string | undefined | null,
	image?: ValueTypes["ProductPackingUpdateImageEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	volumeMl?: number | undefined | null,
	icon?: ValueTypes["ProductPackingUpdateIconEntityRelationInput"] | undefined | null,
	shortName?: string | undefined | null,
	locales?: Array<ValueTypes["ProductPackingUpdateLocalesEntityRelationInput"]> | undefined | null,
	preparedPackingQuantities?: Array<ValueTypes["ProductPackingUpdatePreparedPackingQuantitiesEntityRelationInput"]> | undefined | null,
	isPackedInCardboard?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductPackingUpdateImageEntityRelationInput"]: {
	create?: ValueTypes["ImageCreateInput"] | undefined | null,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductPackingUpsertImageRelationInput"] | undefined | null,
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ImageUpdateInput"]: {
	url?: string | undefined | null,
	width?: number | undefined | null,
	height?: number | undefined | null,
	size?: number | undefined | null,
	type?: string | undefined | null,
	alt?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductPackingUpsertImageRelationInput"]: {
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["ProductPackingUpdateIconEntityRelationInput"]: {
	create?: ValueTypes["ImageCreateInput"] | undefined | null,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductPackingUpsertIconRelationInput"] | undefined | null,
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductPackingUpsertIconRelationInput"]: {
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["ProductPackingUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["ProductPackingLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ValueTypes["ProductPackingUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ValueTypes["ProductPackingUpsertLocalesRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductPackingLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductPackingLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductPackingLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductPackingUpdateLocalesRelationInput"]: {
	by?: ValueTypes["ProductPackingLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["ProductPackingLocaleWithoutRootUpdateInput"] | undefined | null
};
	["ProductPackingLocaleWithoutRootUpdateInput"]: {
	name?: string | undefined | null,
	shortName?: string | undefined | null,
	description?: string | undefined | null,
	locale?: ValueTypes["ProductPackingLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductPackingLocaleUpdateLocaleEntityRelationInput"]: {
	create?: ValueTypes["LocaleWithoutProductPackingsCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleWithoutProductPackingsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductPackingLocaleUpsertLocaleRelationInput"] | undefined | null,
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutProductPackingsUpdateInput"]: {
	businessCategories?: Array<ValueTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleUpdateBusinessCategoriesEntityRelationInput"]: {
	create?: ValueTypes["BusinessCategoryLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleUpdateBusinessCategoriesRelationInput"] | undefined | null,
	upsert?: ValueTypes["LocaleUpsertBusinessCategoriesRelationInput"] | undefined | null,
	connect?: ValueTypes["BusinessCategoryLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["BusinessCategoryLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["BusinessCategoryLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateBusinessCategoriesRelationInput"]: {
	by?: ValueTypes["BusinessCategoryLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["BusinessCategoryLocaleWithoutLocaleUpdateInput"] | undefined | null
};
	["BusinessCategoryLocaleWithoutLocaleUpdateInput"]: {
	name?: string | undefined | null,
	root?: ValueTypes["BusinessCategoryLocaleUpdateRootEntityRelationInput"] | undefined | null,
	title?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessCategoryLocaleUpdateRootEntityRelationInput"]: {
	create?: ValueTypes["BusinessCategoryWithoutLocalesCreateInput"] | undefined | null,
	update?: ValueTypes["BusinessCategoryWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["BusinessCategoryLocaleUpsertRootRelationInput"] | undefined | null,
	connect?: ValueTypes["BusinessCategoryUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["BusinessCategoryWithoutLocalesUpdateInput"]: {
	order?: number | undefined | null,
	visibleToNewCustomers?: boolean | undefined | null,
	internalName?: string | undefined | null,
	businessCustomers?: Array<ValueTypes["BusinessCategoryUpdateBusinessCustomersEntityRelationInput"]> | undefined | null,
	recurrences?: Array<ValueTypes["BusinessCategoryUpdateRecurrencesEntityRelationInput"]> | undefined | null,
	specificProducts?: ValueTypes["BusinessCategoryUpdateSpecificProductsEntityRelationInput"] | undefined | null,
	seasonalProductCategories?: ValueTypes["BusinessCategoryUpdateSeasonalProductCategoriesEntityRelationInput"] | undefined | null,
	specificProductsProductCategories?: ValueTypes["BusinessCategoryUpdateSpecificProductsProductCategoriesEntityRelationInput"] | undefined | null,
	slug?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessCategoryUpdateBusinessCustomersEntityRelationInput"]: {
	create?: ValueTypes["BusinessCustomerWithoutCategoryCreateInput"] | undefined | null,
	update?: ValueTypes["BusinessCategoryUpdateBusinessCustomersRelationInput"] | undefined | null,
	upsert?: ValueTypes["BusinessCategoryUpsertBusinessCustomersRelationInput"] | undefined | null,
	connect?: ValueTypes["BusinessCustomerUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["BusinessCustomerUniqueWhere"] | undefined | null,
	delete?: ValueTypes["BusinessCustomerUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["BusinessCategoryUpdateBusinessCustomersRelationInput"]: {
	by?: ValueTypes["BusinessCustomerUniqueWhere"] | undefined | null,
	data?: ValueTypes["BusinessCustomerWithoutCategoryUpdateInput"] | undefined | null
};
	["BusinessCustomerWithoutCategoryUpdateInput"]: {
	name?: string | undefined | null,
	customer?: ValueTypes["BusinessCustomerUpdateCustomerEntityRelationInput"] | undefined | null,
	owners?: Array<ValueTypes["BusinessCustomerUpdateOwnersEntityRelationInput"]> | undefined | null,
	members?: Array<ValueTypes["BusinessCustomerUpdateMembersEntityRelationInput"]> | undefined | null,
	accountManager?: ValueTypes["BusinessCustomerUpdateAccountManagerEntityRelationInput"] | undefined | null,
	logo?: ValueTypes["BusinessCustomerUpdateLogoEntityRelationInput"] | undefined | null,
	note?: string | undefined | null,
	businessServiceEvents?: Array<ValueTypes["BusinessCustomerUpdateBusinessServiceEventsEntityRelationInput"]> | undefined | null,
	doubleshotCoffeeEquipment?: ValueTypes["BusinessCustomerUpdateDoubleshotCoffeeEquipmentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessCustomerUpdateCustomerEntityRelationInput"]: {
	create?: ValueTypes["CustomerWithoutBusinessCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerWithoutBusinessUpdateInput"] | undefined | null,
	upsert?: ValueTypes["BusinessCustomerUpsertCustomerRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CustomerWithoutBusinessUpdateInput"]: {
	addresses?: Array<ValueTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerUpdateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerUpdateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerUpdateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerUpdateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerUpdateCreditsEntityRelationInput"]: {
	create?: ValueTypes["CustomerCreditWithoutCustomerCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerUpdateCreditsRelationInput"] | undefined | null,
	upsert?: ValueTypes["CustomerUpsertCreditsRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerCreditUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["CustomerCreditUniqueWhere"] | undefined | null,
	delete?: ValueTypes["CustomerCreditUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerUpdateCreditsRelationInput"]: {
	by?: ValueTypes["CustomerCreditUniqueWhere"] | undefined | null,
	data?: ValueTypes["CustomerCreditWithoutCustomerUpdateInput"] | undefined | null
};
	["CustomerCreditWithoutCustomerUpdateInput"]: {
	initialCreditCents?: number | undefined | null,
	remainingCreditsCents?: number | undefined | null,
	expiresAt?: ValueTypes["DateTime"] | undefined | null,
	reason?: string | undefined | null,
	vatRate?: ValueTypes["CustomerCreditUpdateVatRateEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	transactions?: Array<ValueTypes["CustomerCreditUpdateTransactionsEntityRelationInput"]> | undefined | null,
	voucherRedemption?: ValueTypes["CustomerCreditUpdateVoucherRedemptionEntityRelationInput"] | undefined | null,
	invoiceUrl?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreditUpdateVatRateEntityRelationInput"]: {
	create?: ValueTypes["VatRateCreateInput"] | undefined | null,
	update?: ValueTypes["VatRateUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CustomerCreditUpsertVatRateRelationInput"] | undefined | null,
	connect?: ValueTypes["VatRateUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["VatRateUpdateInput"]: {
	name?: string | undefined | null,
	ratePermille?: number | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	channelDeliveries?: Array<ValueTypes["VatRateUpdateChannelDeliveriesEntityRelationInput"]> | undefined | null,
	channelPayments?: Array<ValueTypes["VatRateUpdateChannelPaymentsEntityRelationInput"]> | undefined | null,
	preset?: ValueTypes["VatRatePreset"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VatRateUpdateChannelDeliveriesEntityRelationInput"]: {
	create?: ValueTypes["ChannelDeliveryWithoutVatRateCreateInput"] | undefined | null,
	update?: ValueTypes["VatRateUpdateChannelDeliveriesRelationInput"] | undefined | null,
	upsert?: ValueTypes["VatRateUpsertChannelDeliveriesRelationInput"] | undefined | null,
	connect?: ValueTypes["ChannelDeliveryUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ChannelDeliveryUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ChannelDeliveryUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["VatRateUpdateChannelDeliveriesRelationInput"]: {
	by?: ValueTypes["ChannelDeliveryUniqueWhere"] | undefined | null,
	data?: ValueTypes["ChannelDeliveryWithoutVatRateUpdateInput"] | undefined | null
};
	["ChannelDeliveryWithoutVatRateUpdateInput"]: {
	order?: number | undefined | null,
	priceCents?: number | undefined | null,
	channel?: ValueTypes["ChannelDeliveryUpdateChannelEntityRelationInput"] | undefined | null,
	method?: ValueTypes["ChannelDeliveryUpdateMethodEntityRelationInput"] | undefined | null,
	defaultVisible?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ChannelDeliveryUpdateChannelEntityRelationInput"]: {
	create?: ValueTypes["ChannelWithoutDeliveriesCreateInput"] | undefined | null,
	update?: ValueTypes["ChannelWithoutDeliveriesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ChannelDeliveryUpsertChannelRelationInput"] | undefined | null,
	connect?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["ChannelWithoutDeliveriesUpdateInput"]: {
	name?: string | undefined | null,
	disabled?: boolean | undefined | null,
	payments?: Array<ValueTypes["ChannelUpdatePaymentsEntityRelationInput"]> | undefined | null,
	pointOfSales?: Array<ValueTypes["ChannelUpdatePointOfSalesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["ChannelUpdateCartsEntityRelationInput"]> | undefined | null,
	customers?: Array<ValueTypes["ChannelUpdateCustomersEntityRelationInput"]> | undefined | null,
	code?: ValueTypes["ChannelCode"] | undefined | null,
	addTagsOnRegistration?: Array<ValueTypes["ChannelUpdateAddTagsOnRegistrationEntityRelationInput"]> | undefined | null,
	publicTags?: Array<ValueTypes["ChannelUpdatePublicTagsEntityRelationInput"]> | undefined | null,
	venue?: ValueTypes["ChannelUpdateVenueEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ChannelUpdatePaymentsEntityRelationInput"]: {
	create?: ValueTypes["ChannelPaymentWithoutChannelCreateInput"] | undefined | null,
	update?: ValueTypes["ChannelUpdatePaymentsRelationInput"] | undefined | null,
	upsert?: ValueTypes["ChannelUpsertPaymentsRelationInput"] | undefined | null,
	connect?: ValueTypes["ChannelPaymentUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ChannelPaymentUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ChannelPaymentUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ChannelUpdatePaymentsRelationInput"]: {
	by?: ValueTypes["ChannelPaymentUniqueWhere"] | undefined | null,
	data?: ValueTypes["ChannelPaymentWithoutChannelUpdateInput"] | undefined | null
};
	["ChannelPaymentWithoutChannelUpdateInput"]: {
	order?: number | undefined | null,
	method?: ValueTypes["ChannelPaymentUpdateMethodEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["ChannelPaymentUpdateVatRateEntityRelationInput"] | undefined | null,
	requireBillingAddress?: boolean | undefined | null,
	provideReceipt?: boolean | undefined | null,
	requireBillingSubject?: boolean | undefined | null,
	allowOnlyForTags?: Array<ValueTypes["ChannelPaymentUpdateAllowOnlyForTagsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ChannelPaymentUpdateMethodEntityRelationInput"]: {
	create?: ValueTypes["PaymentMethodWithoutChannelsCreateInput"] | undefined | null,
	update?: ValueTypes["PaymentMethodWithoutChannelsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ChannelPaymentUpsertMethodRelationInput"] | undefined | null,
	connect?: ValueTypes["PaymentMethodUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["PaymentMethodWithoutChannelsUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	enabled?: boolean | undefined | null,
	deliveryMethods?: Array<ValueTypes["PaymentMethodUpdateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	blockingDispatch?: boolean | undefined | null,
	type?: ValueTypes["PaymentMethodType"] | undefined | null,
	reduceGratuityByPercentage?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PaymentMethodUpdateDeliveryMethodsEntityRelationInput"]: {
	create?: ValueTypes["DeliveryMethodWithoutPaymentMethodsCreateInput"] | undefined | null,
	update?: ValueTypes["PaymentMethodUpdateDeliveryMethodsRelationInput"] | undefined | null,
	upsert?: ValueTypes["PaymentMethodUpsertDeliveryMethodsRelationInput"] | undefined | null,
	connect?: ValueTypes["DeliveryMethodUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["DeliveryMethodUniqueWhere"] | undefined | null,
	delete?: ValueTypes["DeliveryMethodUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PaymentMethodUpdateDeliveryMethodsRelationInput"]: {
	by?: ValueTypes["DeliveryMethodUniqueWhere"] | undefined | null,
	data?: ValueTypes["DeliveryMethodWithoutPaymentMethodsUpdateInput"] | undefined | null
};
	["DeliveryMethodWithoutPaymentMethodsUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	enabled?: boolean | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	requireDeliveryAddress?: boolean | undefined | null,
	suitableForDeliveryZones?: Array<ValueTypes["DeliveryMethodUpdateSuitableForDeliveryZonesEntityRelationInput"]> | undefined | null,
	channels?: Array<ValueTypes["DeliveryMethodUpdateChannelsEntityRelationInput"]> | undefined | null,
	courierHandlers?: Array<ValueTypes["DeliveryMethodUpdateCourierHandlersEntityRelationInput"]> | undefined | null,
	enableDeliveryTracking?: boolean | undefined | null,
	locales?: Array<ValueTypes["DeliveryMethodUpdateLocalesEntityRelationInput"]> | undefined | null,
	timelinePreset?: ValueTypes["DeliveryMethodUpdateTimelinePresetEntityRelationInput"] | undefined | null,
	woltDriveVenueId?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryMethodUpdateChannelsEntityRelationInput"]: {
	create?: ValueTypes["ChannelDeliveryWithoutMethodCreateInput"] | undefined | null,
	update?: ValueTypes["DeliveryMethodUpdateChannelsRelationInput"] | undefined | null,
	upsert?: ValueTypes["DeliveryMethodUpsertChannelsRelationInput"] | undefined | null,
	connect?: ValueTypes["ChannelDeliveryUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ChannelDeliveryUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ChannelDeliveryUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["DeliveryMethodUpdateChannelsRelationInput"]: {
	by?: ValueTypes["ChannelDeliveryUniqueWhere"] | undefined | null,
	data?: ValueTypes["ChannelDeliveryWithoutMethodUpdateInput"] | undefined | null
};
	["ChannelDeliveryWithoutMethodUpdateInput"]: {
	order?: number | undefined | null,
	priceCents?: number | undefined | null,
	channel?: ValueTypes["ChannelDeliveryUpdateChannelEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["ChannelDeliveryUpdateVatRateEntityRelationInput"] | undefined | null,
	defaultVisible?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ChannelDeliveryUpdateVatRateEntityRelationInput"]: {
	create?: ValueTypes["VatRateWithoutChannelDeliveriesCreateInput"] | undefined | null,
	update?: ValueTypes["VatRateWithoutChannelDeliveriesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ChannelDeliveryUpsertVatRateRelationInput"] | undefined | null,
	connect?: ValueTypes["VatRateUniqueWhere"] | undefined | null
};
	["VatRateWithoutChannelDeliveriesUpdateInput"]: {
	name?: string | undefined | null,
	ratePermille?: number | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	channelPayments?: Array<ValueTypes["VatRateUpdateChannelPaymentsEntityRelationInput"]> | undefined | null,
	preset?: ValueTypes["VatRatePreset"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VatRateUpdateChannelPaymentsEntityRelationInput"]: {
	create?: ValueTypes["ChannelPaymentWithoutVatRateCreateInput"] | undefined | null,
	update?: ValueTypes["VatRateUpdateChannelPaymentsRelationInput"] | undefined | null,
	upsert?: ValueTypes["VatRateUpsertChannelPaymentsRelationInput"] | undefined | null,
	connect?: ValueTypes["ChannelPaymentUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ChannelPaymentUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ChannelPaymentUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["VatRateUpdateChannelPaymentsRelationInput"]: {
	by?: ValueTypes["ChannelPaymentUniqueWhere"] | undefined | null,
	data?: ValueTypes["ChannelPaymentWithoutVatRateUpdateInput"] | undefined | null
};
	["ChannelPaymentWithoutVatRateUpdateInput"]: {
	order?: number | undefined | null,
	channel?: ValueTypes["ChannelPaymentUpdateChannelEntityRelationInput"] | undefined | null,
	method?: ValueTypes["ChannelPaymentUpdateMethodEntityRelationInput"] | undefined | null,
	requireBillingAddress?: boolean | undefined | null,
	provideReceipt?: boolean | undefined | null,
	requireBillingSubject?: boolean | undefined | null,
	allowOnlyForTags?: Array<ValueTypes["ChannelPaymentUpdateAllowOnlyForTagsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ChannelPaymentUpdateAllowOnlyForTagsEntityRelationInput"]: {
	create?: ValueTypes["TagWithoutAllowChannelPaymentsCreateInput"] | undefined | null,
	update?: ValueTypes["ChannelPaymentUpdateAllowOnlyForTagsRelationInput"] | undefined | null,
	upsert?: ValueTypes["ChannelPaymentUpsertAllowOnlyForTagsRelationInput"] | undefined | null,
	connect?: ValueTypes["TagUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["TagUniqueWhere"] | undefined | null,
	delete?: ValueTypes["TagUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ChannelPaymentUpdateAllowOnlyForTagsRelationInput"]: {
	by?: ValueTypes["TagUniqueWhere"] | undefined | null,
	data?: ValueTypes["TagWithoutAllowChannelPaymentsUpdateInput"] | undefined | null
};
	["TagWithoutAllowChannelPaymentsUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	customers?: Array<ValueTypes["TagUpdateCustomersEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["TagUpdateProductsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["TagUpdateCategoriesEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	addTagsOnRegistration?: Array<ValueTypes["TagUpdateAddTagsOnRegistrationEntityRelationInput"]> | undefined | null,
	nestedCategories?: Array<ValueTypes["TagUpdateNestedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["TagUpdateDeliveryZonesEntityRelationInput"]> | undefined | null,
	publicInChannels?: Array<ValueTypes["TagUpdatePublicInChannelsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["TagUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TagUpdateCustomersEntityRelationInput"]: {
	create?: ValueTypes["CustomerWithoutTagsCreateInput"] | undefined | null,
	update?: ValueTypes["TagUpdateCustomersRelationInput"] | undefined | null,
	upsert?: ValueTypes["TagUpsertCustomersRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	delete?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["TagUpdateCustomersRelationInput"]: {
	by?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	data?: ValueTypes["CustomerWithoutTagsUpdateInput"] | undefined | null
};
	["CustomerWithoutTagsUpdateInput"]: {
	addresses?: Array<ValueTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	credits?: Array<ValueTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerUpdateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerUpdateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerUpdateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerUpdateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerUpdatePaymentMethodsEntityRelationInput"]: {
	create?: ValueTypes["CustomerPaymentMethodWithoutCustomerCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerUpdatePaymentMethodsRelationInput"] | undefined | null,
	upsert?: ValueTypes["CustomerUpsertPaymentMethodsRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerPaymentMethodUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["CustomerPaymentMethodUniqueWhere"] | undefined | null,
	delete?: ValueTypes["CustomerPaymentMethodUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerUpdatePaymentMethodsRelationInput"]: {
	by?: ValueTypes["CustomerPaymentMethodUniqueWhere"] | undefined | null,
	data?: ValueTypes["CustomerPaymentMethodWithoutCustomerUpdateInput"] | undefined | null
};
	["CustomerPaymentMethodWithoutCustomerUpdateInput"]: {
	caption?: string | undefined | null,
	data?: ValueTypes["Json"] | undefined | null,
	paymentMethod?: ValueTypes["CustomerPaymentMethodUpdatePaymentMethodEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerPaymentMethodUpdatePaymentMethodEntityRelationInput"]: {
	create?: ValueTypes["PaymentMethodCreateInput"] | undefined | null,
	update?: ValueTypes["PaymentMethodUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CustomerPaymentMethodUpsertPaymentMethodRelationInput"] | undefined | null,
	connect?: ValueTypes["PaymentMethodUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["PaymentMethodUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	enabled?: boolean | undefined | null,
	deliveryMethods?: Array<ValueTypes["PaymentMethodUpdateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	blockingDispatch?: boolean | undefined | null,
	type?: ValueTypes["PaymentMethodType"] | undefined | null,
	channels?: Array<ValueTypes["PaymentMethodUpdateChannelsEntityRelationInput"]> | undefined | null,
	reduceGratuityByPercentage?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerPaymentMethodUpsertPaymentMethodRelationInput"]: {
	update?: ValueTypes["PaymentMethodUpdateInput"] | undefined | null,
	create?: ValueTypes["PaymentMethodCreateInput"] | undefined | null
};
	["CustomerUpsertPaymentMethodsRelationInput"]: {
	by?: ValueTypes["CustomerPaymentMethodUniqueWhere"] | undefined | null,
	update?: ValueTypes["CustomerPaymentMethodWithoutCustomerUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerPaymentMethodWithoutCustomerCreateInput"] | undefined | null
};
	["CustomerUpdateOrdersEntityRelationInput"]: {
	create?: ValueTypes["OrderWithoutCustomerCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerUpdateOrdersRelationInput"] | undefined | null,
	upsert?: ValueTypes["CustomerUpsertOrdersRelationInput"] | undefined | null,
	connect?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	delete?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerUpdateOrdersRelationInput"]: {
	by?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	data?: ValueTypes["OrderWithoutCustomerUpdateInput"] | undefined | null
};
	["OrderWithoutCustomerUpdateInput"]: {
	state?: ValueTypes["OrderState"] | undefined | null,
	fulfilledAt?: ValueTypes["DateTime"] | undefined | null,
	canceledAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	channel?: ValueTypes["OrderUpdateChannelEntityRelationInput"] | undefined | null,
	discounts?: Array<ValueTypes["OrderUpdateDiscountsEntityRelationInput"]> | undefined | null,
	delivery?: ValueTypes["OrderUpdateDeliveryEntityRelationInput"] | undefined | null,
	items?: Array<ValueTypes["OrderUpdateItemsEntityRelationInput"]> | undefined | null,
	internalNote?: string | undefined | null,
	cart?: ValueTypes["OrderUpdateCartEntityRelationInput"] | undefined | null,
	events?: Array<ValueTypes["OrderUpdateEventsEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingAddress?: ValueTypes["OrderUpdateBillingAddressEntityRelationInput"] | undefined | null,
	priceLines?: Array<ValueTypes["OrderUpdatePriceLinesEntityRelationInput"]> | undefined | null,
	payments?: Array<ValueTypes["OrderUpdatePaymentsEntityRelationInput"]> | undefined | null,
	seq?: number | undefined | null,
	billingSubject?: ValueTypes["OrderUpdateBillingSubjectEntityRelationInput"] | undefined | null,
	summary?: ValueTypes["OrderUpdateSummaryEntityRelationInput"] | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	gratuity?: ValueTypes["OrderUpdateGratuityEntityRelationInput"] | undefined | null,
	venue?: ValueTypes["OrderUpdateVenueEntityRelationInput"] | undefined | null,
	fulfillmentNote?: string | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["OrderUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	doubleshotTotalWeightGrams?: number | undefined | null,
	doubleShotLegacyNumber?: string | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	doubleshotAdminUrl?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderUpdateChannelEntityRelationInput"]: {
	create?: ValueTypes["ChannelCreateInput"] | undefined | null,
	update?: ValueTypes["ChannelUpdateInput"] | undefined | null,
	upsert?: ValueTypes["OrderUpsertChannelRelationInput"] | undefined | null,
	connect?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["ChannelUpdateInput"]: {
	name?: string | undefined | null,
	disabled?: boolean | undefined | null,
	payments?: Array<ValueTypes["ChannelUpdatePaymentsEntityRelationInput"]> | undefined | null,
	deliveries?: Array<ValueTypes["ChannelUpdateDeliveriesEntityRelationInput"]> | undefined | null,
	pointOfSales?: Array<ValueTypes["ChannelUpdatePointOfSalesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["ChannelUpdateCartsEntityRelationInput"]> | undefined | null,
	customers?: Array<ValueTypes["ChannelUpdateCustomersEntityRelationInput"]> | undefined | null,
	code?: ValueTypes["ChannelCode"] | undefined | null,
	addTagsOnRegistration?: Array<ValueTypes["ChannelUpdateAddTagsOnRegistrationEntityRelationInput"]> | undefined | null,
	publicTags?: Array<ValueTypes["ChannelUpdatePublicTagsEntityRelationInput"]> | undefined | null,
	venue?: ValueTypes["ChannelUpdateVenueEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ChannelUpdatePointOfSalesEntityRelationInput"]: {
	create?: ValueTypes["PointOfSaleWithoutChannelsCreateInput"] | undefined | null,
	update?: ValueTypes["ChannelUpdatePointOfSalesRelationInput"] | undefined | null,
	upsert?: ValueTypes["ChannelUpsertPointOfSalesRelationInput"] | undefined | null,
	connect?: ValueTypes["PointOfSaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["PointOfSaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["PointOfSaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ChannelUpdatePointOfSalesRelationInput"]: {
	by?: ValueTypes["PointOfSaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["PointOfSaleWithoutChannelsUpdateInput"] | undefined | null
};
	["PointOfSaleWithoutChannelsUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	permissions?: ValueTypes["PointOfSaleUpdatePermissionsEntityRelationInput"] | undefined | null,
	tenantPersonId?: ValueTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleUpdatePermissionsEntityRelationInput"]: {
	connect?: ValueTypes["PointOfSalePermissionsUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ChannelUpsertPointOfSalesRelationInput"]: {
	by?: ValueTypes["PointOfSaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["PointOfSaleWithoutChannelsUpdateInput"] | undefined | null,
	create?: ValueTypes["PointOfSaleWithoutChannelsCreateInput"] | undefined | null
};
	["ChannelUpdateCartsEntityRelationInput"]: {
	create?: ValueTypes["CartWithoutChannelCreateInput"] | undefined | null,
	update?: ValueTypes["ChannelUpdateCartsRelationInput"] | undefined | null,
	upsert?: ValueTypes["ChannelUpsertCartsRelationInput"] | undefined | null,
	connect?: ValueTypes["CartUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["CartUniqueWhere"] | undefined | null,
	delete?: ValueTypes["CartUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ChannelUpdateCartsRelationInput"]: {
	by?: ValueTypes["CartUniqueWhere"] | undefined | null,
	data?: ValueTypes["CartWithoutChannelUpdateInput"] | undefined | null
};
	["CartWithoutChannelUpdateInput"]: {
	confirmedAt?: ValueTypes["DateTime"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	items?: Array<ValueTypes["CartUpdateItemsEntityRelationInput"]> | undefined | null,
	handle?: string | undefined | null,
	state?: ValueTypes["CartState"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	order?: ValueTypes["CartUpdateOrderEntityRelationInput"] | undefined | null,
	customer?: ValueTypes["CartUpdateCustomerEntityRelationInput"] | undefined | null,
	deliveryAddress?: ValueTypes["CartUpdateDeliveryAddressEntityRelationInput"] | undefined | null,
	billingAddress?: ValueTypes["CartUpdateBillingAddressEntityRelationInput"] | undefined | null,
	deliveryOption?: string | undefined | null,
	paymentOption?: string | undefined | null,
	delivery?: ValueTypes["CartUpdateDeliveryEntityRelationInput"] | undefined | null,
	payment?: ValueTypes["CartUpdatePaymentEntityRelationInput"] | undefined | null,
	billingSubject?: ValueTypes["CartUpdateBillingSubjectEntityRelationInput"] | undefined | null,
	priceLines?: Array<ValueTypes["CartUpdatePriceLinesEntityRelationInput"]> | undefined | null,
	summary?: ValueTypes["CartUpdateSummaryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CartUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["CartItemWithoutCartCreateInput"] | undefined | null,
	update?: ValueTypes["CartUpdateItemsRelationInput"] | undefined | null,
	upsert?: ValueTypes["CartUpsertItemsRelationInput"] | undefined | null,
	connect?: ValueTypes["CartItemUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["CartItemUniqueWhere"] | undefined | null,
	delete?: ValueTypes["CartItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CartUpdateItemsRelationInput"]: {
	by?: ValueTypes["CartItemUniqueWhere"] | undefined | null,
	data?: ValueTypes["CartItemWithoutCartUpdateInput"] | undefined | null
};
	["CartItemWithoutCartUpdateInput"]: {
	quantity?: number | undefined | null,
	product?: ValueTypes["CartItemUpdateProductEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	updatedAt?: ValueTypes["DateTime"] | undefined | null,
	fulfillmentNote?: string | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["CartItemUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CartItemUpdateProductEntityRelationInput"]: {
	create?: ValueTypes["ProductWithoutCartItemsCreateInput"] | undefined | null,
	update?: ValueTypes["ProductWithoutCartItemsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CartItemUpsertProductRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductWithoutCartItemsUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	priceCents?: number | undefined | null,
	notDiscountable?: boolean | undefined | null,
	packing?: ValueTypes["ProductUpdatePackingEntityRelationInput"] | undefined | null,
	recipe?: ValueTypes["ProductUpdateRecipeEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["ProductUpdateTagsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["ProductUpdateCategoriesEntityRelationInput"]> | undefined | null,
	vatRate?: ValueTypes["ProductUpdateVatRateEntityRelationInput"] | undefined | null,
	stocks?: Array<ValueTypes["ProductUpdateStocksEntityRelationInput"]> | undefined | null,
	groupPrices?: Array<ValueTypes["ProductUpdateGroupPricesEntityRelationInput"]> | undefined | null,
	image?: ValueTypes["ProductUpdateImageEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	availability?: ValueTypes["ProductAvailability"] | undefined | null,
	order?: number | undefined | null,
	manager?: ValueTypes["ProductUpdateManagerEntityRelationInput"] | undefined | null,
	orderItems?: Array<ValueTypes["ProductUpdateOrderItemsEntityRelationInput"]> | undefined | null,
	maximumQuantityPerOrder?: number | undefined | null,
	inheritedCategories?: Array<ValueTypes["ProductUpdateInheritedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["ProductUpdateDeliveryZonesEntityRelationInput"]> | undefined | null,
	locales?: Array<ValueTypes["ProductUpdateLocalesEntityRelationInput"]> | undefined | null,
	archivedAt?: ValueTypes["DateTime"] | undefined | null,
	customerPrices?: Array<ValueTypes["ProductUpdateCustomerPricesEntityRelationInput"]> | undefined | null,
	virtualProduct?: ValueTypes["ProductUpdateVirtualProductEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["ProductUpdateMetaEntityRelationInput"] | undefined | null,
	page?: ValueTypes["ProductUpdatePageEntityRelationInput"] | undefined | null,
	salesDays?: Array<ValueTypes["ProductUpdateSalesDaysEntityRelationInput"]> | undefined | null,
	salesWeeks?: Array<ValueTypes["ProductUpdateSalesWeeksEntityRelationInput"]> | undefined | null,
	salesMonths?: Array<ValueTypes["ProductUpdateSalesMonthsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["ProductUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	hasSubscription?: boolean | undefined | null,
	pointOfSaleTileColor?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductUpdateRecipeEntityRelationInput"]: {
	create?: ValueTypes["ProductRecipeWithoutProductsCreateInput"] | undefined | null,
	update?: ValueTypes["ProductRecipeWithoutProductsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductUpsertRecipeRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductRecipeUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductRecipeWithoutProductsUpdateInput"]: {
	name?: string | undefined | null,
	internalNote?: string | undefined | null,
	color?: string | undefined | null,
	image?: ValueTypes["ProductRecipeUpdateImageEntityRelationInput"] | undefined | null,
	icon?: ValueTypes["ProductRecipeUpdateIconEntityRelationInput"] | undefined | null,
	ingredients?: Array<ValueTypes["ProductRecipeUpdateIngredientsEntityRelationInput"]> | undefined | null,
	needsPrepping?: boolean | undefined | null,
	locales?: Array<ValueTypes["ProductRecipeUpdateLocalesEntityRelationInput"]> | undefined | null,
	gutTuning?: number | undefined | null,
	freshingContainer?: ValueTypes["ProductRecipeUpdateFreshingContainerEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	nutritionFacts?: ValueTypes["ProductRecipeUpdateNutritionFactsEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductRecipeUpdateImageEntityRelationInput"]: {
	create?: ValueTypes["ImageCreateInput"] | undefined | null,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductRecipeUpsertImageRelationInput"] | undefined | null,
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductRecipeUpsertImageRelationInput"]: {
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["ProductRecipeUpdateIconEntityRelationInput"]: {
	create?: ValueTypes["ImageCreateInput"] | undefined | null,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductRecipeUpsertIconRelationInput"] | undefined | null,
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductRecipeUpsertIconRelationInput"]: {
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["ProductRecipeUpdateIngredientsEntityRelationInput"]: {
	create?: ValueTypes["ProductIngredientItemWithoutRecipeCreateInput"] | undefined | null,
	update?: ValueTypes["ProductRecipeUpdateIngredientsRelationInput"] | undefined | null,
	upsert?: ValueTypes["ProductRecipeUpsertIngredientsRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductIngredientItemUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductIngredientItemUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductIngredientItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductRecipeUpdateIngredientsRelationInput"]: {
	by?: ValueTypes["ProductIngredientItemUniqueWhere"] | undefined | null,
	data?: ValueTypes["ProductIngredientItemWithoutRecipeUpdateInput"] | undefined | null
};
	["ProductIngredientItemWithoutRecipeUpdateInput"]: {
	order?: number | undefined | null,
	internalOrder?: number | undefined | null,
	ingredient?: ValueTypes["ProductIngredientItemUpdateIngredientEntityRelationInput"] | undefined | null,
	quantity?: ValueTypes["ProductIngredientItemUpdateQuantityEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientItemUpdateIngredientEntityRelationInput"]: {
	create?: ValueTypes["ProductIngredientCreateInput"] | undefined | null,
	update?: ValueTypes["ProductIngredientUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductIngredientItemUpsertIngredientRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductIngredientUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductIngredientUpdateInput"]: {
	internalNote?: string | undefined | null,
	locales?: Array<ValueTypes["ProductIngredientUpdateLocalesEntityRelationInput"]> | undefined | null,
	internalName?: string | undefined | null,
	categories?: Array<ValueTypes["ProductIngredientUpdateCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["ProductIngredientUpdateAllergensEntityRelationInput"]> | undefined | null,
	needsPrepping?: boolean | undefined | null,
	allowCustomerRating?: boolean | undefined | null,
	customerRatings?: Array<ValueTypes["ProductIngredientUpdateCustomerRatingsEntityRelationInput"]> | undefined | null,
	preferredQuantityUnit?: ValueTypes["ProductIngredientUpdatePreferredQuantityUnitEntityRelationInput"] | undefined | null,
	freshingContainer?: ValueTypes["ProductIngredientUpdateFreshingContainerEntityRelationInput"] | undefined | null,
	image?: ValueTypes["ProductIngredientUpdateImageEntityRelationInput"] | undefined | null,
	suppliers?: ValueTypes["ProductIngredientUpdateSuppliersEntityRelationInput"] | undefined | null,
	incrementQuantityNumber?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["ProductIngredientLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ValueTypes["ProductIngredientUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ValueTypes["ProductIngredientUpsertLocalesRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductIngredientLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductIngredientLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductIngredientLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductIngredientUpdateLocalesRelationInput"]: {
	by?: ValueTypes["ProductIngredientLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["ProductIngredientLocaleWithoutRootUpdateInput"] | undefined | null
};
	["ProductIngredientLocaleWithoutRootUpdateInput"]: {
	name?: string | undefined | null,
	locale?: ValueTypes["ProductIngredientLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientLocaleUpdateLocaleEntityRelationInput"]: {
	create?: ValueTypes["LocaleWithoutProductIngredientsCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleWithoutProductIngredientsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductIngredientLocaleUpsertLocaleRelationInput"] | undefined | null,
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutProductIngredientsUpdateInput"]: {
	businessCategories?: Array<ValueTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleUpdateProductCategoryListsEntityRelationInput"]: {
	create?: ValueTypes["ProductCategoryListLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleUpdateProductCategoryListsRelationInput"] | undefined | null,
	upsert?: ValueTypes["LocaleUpsertProductCategoryListsRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductCategoryListLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductCategoryListLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductCategoryListLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateProductCategoryListsRelationInput"]: {
	by?: ValueTypes["ProductCategoryListLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["ProductCategoryListLocaleWithoutLocaleUpdateInput"] | undefined | null
};
	["ProductCategoryListLocaleWithoutLocaleUpdateInput"]: {
	name?: string | undefined | null,
	root?: ValueTypes["ProductCategoryListLocaleUpdateRootEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCategoryListLocaleUpdateRootEntityRelationInput"]: {
	create?: ValueTypes["ProductCategoryListWithoutLocalesCreateInput"] | undefined | null,
	update?: ValueTypes["ProductCategoryListWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductCategoryListLocaleUpsertRootRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductCategoryListUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductCategoryListWithoutLocalesUpdateInput"]: {
	items?: Array<ValueTypes["ProductCategoryListUpdateItemsEntityRelationInput"]> | undefined | null,
	seasonalProductCategoriesOfBusinessCategory?: ValueTypes["ProductCategoryListUpdateSeasonalProductCategoriesOfBusinessCategoryEntityRelationInput"] | undefined | null,
	specificProductsProductCategoriesOfBusinessCategory?: ValueTypes["ProductCategoryListUpdateSpecificProductsProductCategoriesOfBusinessCategoryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCategoryListUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["ProductCategoryListItemWithoutListCreateInput"] | undefined | null,
	update?: ValueTypes["ProductCategoryListUpdateItemsRelationInput"] | undefined | null,
	upsert?: ValueTypes["ProductCategoryListUpsertItemsRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductCategoryListItemUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductCategoryListItemUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductCategoryListItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductCategoryListUpdateItemsRelationInput"]: {
	by?: ValueTypes["ProductCategoryListItemUniqueWhere"] | undefined | null,
	data?: ValueTypes["ProductCategoryListItemWithoutListUpdateInput"] | undefined | null
};
	["ProductCategoryListItemWithoutListUpdateInput"]: {
	order?: number | undefined | null,
	productCategory?: ValueTypes["ProductCategoryListItemUpdateProductCategoryEntityRelationInput"] | undefined | null,
	showRecipeImages?: boolean | undefined | null,
	showPackingImages?: boolean | undefined | null,
	showAllAvailableProducts?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCategoryListItemUpdateProductCategoryEntityRelationInput"]: {
	create?: ValueTypes["ProductCategoryCreateInput"] | undefined | null,
	update?: ValueTypes["ProductCategoryUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductCategoryListItemUpsertProductCategoryRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductCategoryUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductCategoryUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	products?: Array<ValueTypes["ProductCategoryUpdateProductsEntityRelationInput"]> | undefined | null,
	tags?: Array<ValueTypes["ProductCategoryUpdateTagsEntityRelationInput"]> | undefined | null,
	parent?: ValueTypes["ProductCategoryUpdateParentEntityRelationInput"] | undefined | null,
	children?: Array<ValueTypes["ProductCategoryUpdateChildrenEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	color?: string | undefined | null,
	image?: ValueTypes["ProductCategoryUpdateImageEntityRelationInput"] | undefined | null,
	order?: number | undefined | null,
	descendants?: Array<ValueTypes["ProductCategoryUpdateDescendantsEntityRelationInput"]> | undefined | null,
	ancestors?: Array<ValueTypes["ProductCategoryUpdateAncestorsEntityRelationInput"]> | undefined | null,
	inheritedTags?: Array<ValueTypes["ProductCategoryUpdateInheritedTagsEntityRelationInput"]> | undefined | null,
	nestedProducts?: Array<ValueTypes["ProductCategoryUpdateNestedProductsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCategoryUpdateProductsEntityRelationInput"]: {
	create?: ValueTypes["ProductWithoutCategoriesCreateInput"] | undefined | null,
	update?: ValueTypes["ProductCategoryUpdateProductsRelationInput"] | undefined | null,
	upsert?: ValueTypes["ProductCategoryUpsertProductsRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductCategoryUpdateProductsRelationInput"]: {
	by?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	data?: ValueTypes["ProductWithoutCategoriesUpdateInput"] | undefined | null
};
	["ProductWithoutCategoriesUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	priceCents?: number | undefined | null,
	notDiscountable?: boolean | undefined | null,
	packing?: ValueTypes["ProductUpdatePackingEntityRelationInput"] | undefined | null,
	recipe?: ValueTypes["ProductUpdateRecipeEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["ProductUpdateTagsEntityRelationInput"]> | undefined | null,
	vatRate?: ValueTypes["ProductUpdateVatRateEntityRelationInput"] | undefined | null,
	stocks?: Array<ValueTypes["ProductUpdateStocksEntityRelationInput"]> | undefined | null,
	groupPrices?: Array<ValueTypes["ProductUpdateGroupPricesEntityRelationInput"]> | undefined | null,
	image?: ValueTypes["ProductUpdateImageEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	cartItems?: Array<ValueTypes["ProductUpdateCartItemsEntityRelationInput"]> | undefined | null,
	availability?: ValueTypes["ProductAvailability"] | undefined | null,
	order?: number | undefined | null,
	manager?: ValueTypes["ProductUpdateManagerEntityRelationInput"] | undefined | null,
	orderItems?: Array<ValueTypes["ProductUpdateOrderItemsEntityRelationInput"]> | undefined | null,
	maximumQuantityPerOrder?: number | undefined | null,
	inheritedCategories?: Array<ValueTypes["ProductUpdateInheritedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["ProductUpdateDeliveryZonesEntityRelationInput"]> | undefined | null,
	locales?: Array<ValueTypes["ProductUpdateLocalesEntityRelationInput"]> | undefined | null,
	archivedAt?: ValueTypes["DateTime"] | undefined | null,
	customerPrices?: Array<ValueTypes["ProductUpdateCustomerPricesEntityRelationInput"]> | undefined | null,
	virtualProduct?: ValueTypes["ProductUpdateVirtualProductEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["ProductUpdateMetaEntityRelationInput"] | undefined | null,
	page?: ValueTypes["ProductUpdatePageEntityRelationInput"] | undefined | null,
	salesDays?: Array<ValueTypes["ProductUpdateSalesDaysEntityRelationInput"]> | undefined | null,
	salesWeeks?: Array<ValueTypes["ProductUpdateSalesWeeksEntityRelationInput"]> | undefined | null,
	salesMonths?: Array<ValueTypes["ProductUpdateSalesMonthsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["ProductUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	hasSubscription?: boolean | undefined | null,
	pointOfSaleTileColor?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductUpdateTagsEntityRelationInput"]: {
	create?: ValueTypes["TagWithoutProductsCreateInput"] | undefined | null,
	update?: ValueTypes["ProductUpdateTagsRelationInput"] | undefined | null,
	upsert?: ValueTypes["ProductUpsertTagsRelationInput"] | undefined | null,
	connect?: ValueTypes["TagUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["TagUniqueWhere"] | undefined | null,
	delete?: ValueTypes["TagUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductUpdateTagsRelationInput"]: {
	by?: ValueTypes["TagUniqueWhere"] | undefined | null,
	data?: ValueTypes["TagWithoutProductsUpdateInput"] | undefined | null
};
	["TagWithoutProductsUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	customers?: Array<ValueTypes["TagUpdateCustomersEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["TagUpdateCategoriesEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	addTagsOnRegistration?: Array<ValueTypes["TagUpdateAddTagsOnRegistrationEntityRelationInput"]> | undefined | null,
	nestedCategories?: Array<ValueTypes["TagUpdateNestedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["TagUpdateDeliveryZonesEntityRelationInput"]> | undefined | null,
	publicInChannels?: Array<ValueTypes["TagUpdatePublicInChannelsEntityRelationInput"]> | undefined | null,
	allowChannelPayments?: Array<ValueTypes["TagUpdateAllowChannelPaymentsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["TagUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TagUpdateCategoriesEntityRelationInput"]: {
	create?: ValueTypes["ProductCategoryWithoutTagsCreateInput"] | undefined | null,
	update?: ValueTypes["TagUpdateCategoriesRelationInput"] | undefined | null,
	upsert?: ValueTypes["TagUpsertCategoriesRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductCategoryUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductCategoryUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductCategoryUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["TagUpdateCategoriesRelationInput"]: {
	by?: ValueTypes["ProductCategoryUniqueWhere"] | undefined | null,
	data?: ValueTypes["ProductCategoryWithoutTagsUpdateInput"] | undefined | null
};
	["ProductCategoryWithoutTagsUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	products?: Array<ValueTypes["ProductCategoryUpdateProductsEntityRelationInput"]> | undefined | null,
	parent?: ValueTypes["ProductCategoryUpdateParentEntityRelationInput"] | undefined | null,
	children?: Array<ValueTypes["ProductCategoryUpdateChildrenEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	color?: string | undefined | null,
	image?: ValueTypes["ProductCategoryUpdateImageEntityRelationInput"] | undefined | null,
	order?: number | undefined | null,
	descendants?: Array<ValueTypes["ProductCategoryUpdateDescendantsEntityRelationInput"]> | undefined | null,
	ancestors?: Array<ValueTypes["ProductCategoryUpdateAncestorsEntityRelationInput"]> | undefined | null,
	inheritedTags?: Array<ValueTypes["ProductCategoryUpdateInheritedTagsEntityRelationInput"]> | undefined | null,
	nestedProducts?: Array<ValueTypes["ProductCategoryUpdateNestedProductsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCategoryUpdateParentEntityRelationInput"]: {
	create?: ValueTypes["ProductCategoryWithoutChildrenCreateInput"] | undefined | null,
	update?: ValueTypes["ProductCategoryWithoutChildrenUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductCategoryUpsertParentRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductCategoryUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductCategoryWithoutChildrenUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	products?: Array<ValueTypes["ProductCategoryUpdateProductsEntityRelationInput"]> | undefined | null,
	tags?: Array<ValueTypes["ProductCategoryUpdateTagsEntityRelationInput"]> | undefined | null,
	parent?: ValueTypes["ProductCategoryUpdateParentEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	color?: string | undefined | null,
	image?: ValueTypes["ProductCategoryUpdateImageEntityRelationInput"] | undefined | null,
	order?: number | undefined | null,
	descendants?: Array<ValueTypes["ProductCategoryUpdateDescendantsEntityRelationInput"]> | undefined | null,
	ancestors?: Array<ValueTypes["ProductCategoryUpdateAncestorsEntityRelationInput"]> | undefined | null,
	inheritedTags?: Array<ValueTypes["ProductCategoryUpdateInheritedTagsEntityRelationInput"]> | undefined | null,
	nestedProducts?: Array<ValueTypes["ProductCategoryUpdateNestedProductsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCategoryUpdateTagsEntityRelationInput"]: {
	create?: ValueTypes["TagWithoutCategoriesCreateInput"] | undefined | null,
	update?: ValueTypes["ProductCategoryUpdateTagsRelationInput"] | undefined | null,
	upsert?: ValueTypes["ProductCategoryUpsertTagsRelationInput"] | undefined | null,
	connect?: ValueTypes["TagUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["TagUniqueWhere"] | undefined | null,
	delete?: ValueTypes["TagUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductCategoryUpdateTagsRelationInput"]: {
	by?: ValueTypes["TagUniqueWhere"] | undefined | null,
	data?: ValueTypes["TagWithoutCategoriesUpdateInput"] | undefined | null
};
	["TagWithoutCategoriesUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	customers?: Array<ValueTypes["TagUpdateCustomersEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["TagUpdateProductsEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	addTagsOnRegistration?: Array<ValueTypes["TagUpdateAddTagsOnRegistrationEntityRelationInput"]> | undefined | null,
	nestedCategories?: Array<ValueTypes["TagUpdateNestedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["TagUpdateDeliveryZonesEntityRelationInput"]> | undefined | null,
	publicInChannels?: Array<ValueTypes["TagUpdatePublicInChannelsEntityRelationInput"]> | undefined | null,
	allowChannelPayments?: Array<ValueTypes["TagUpdateAllowChannelPaymentsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["TagUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TagUpdateAddTagsOnRegistrationEntityRelationInput"]: {
	create?: ValueTypes["ChannelWithoutAddTagsOnRegistrationCreateInput"] | undefined | null,
	update?: ValueTypes["TagUpdateAddTagsOnRegistrationRelationInput"] | undefined | null,
	upsert?: ValueTypes["TagUpsertAddTagsOnRegistrationRelationInput"] | undefined | null,
	connect?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["TagUpdateAddTagsOnRegistrationRelationInput"]: {
	by?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	data?: ValueTypes["ChannelWithoutAddTagsOnRegistrationUpdateInput"] | undefined | null
};
	["ChannelWithoutAddTagsOnRegistrationUpdateInput"]: {
	name?: string | undefined | null,
	disabled?: boolean | undefined | null,
	payments?: Array<ValueTypes["ChannelUpdatePaymentsEntityRelationInput"]> | undefined | null,
	deliveries?: Array<ValueTypes["ChannelUpdateDeliveriesEntityRelationInput"]> | undefined | null,
	pointOfSales?: Array<ValueTypes["ChannelUpdatePointOfSalesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["ChannelUpdateCartsEntityRelationInput"]> | undefined | null,
	customers?: Array<ValueTypes["ChannelUpdateCustomersEntityRelationInput"]> | undefined | null,
	code?: ValueTypes["ChannelCode"] | undefined | null,
	publicTags?: Array<ValueTypes["ChannelUpdatePublicTagsEntityRelationInput"]> | undefined | null,
	venue?: ValueTypes["ChannelUpdateVenueEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ChannelUpdateCustomersEntityRelationInput"]: {
	create?: ValueTypes["CustomerWithoutChannelsCreateInput"] | undefined | null,
	update?: ValueTypes["ChannelUpdateCustomersRelationInput"] | undefined | null,
	upsert?: ValueTypes["ChannelUpsertCustomersRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	delete?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ChannelUpdateCustomersRelationInput"]: {
	by?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	data?: ValueTypes["CustomerWithoutChannelsUpdateInput"] | undefined | null
};
	["CustomerWithoutChannelsUpdateInput"]: {
	addresses?: Array<ValueTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerUpdateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerUpdateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerUpdateUserEntityRelationInput"] | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerUpdateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerUpdatePermissionsEntityRelationInput"]: {
	connect?: ValueTypes["CustomerPermissionsUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CustomerUpdateGroupEntityRelationInput"]: {
	create?: ValueTypes["CustomerGroupWithoutCustomersCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerGroupWithoutCustomersUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CustomerUpsertGroupRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerGroupUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CustomerGroupWithoutCustomersUpdateInput"]: {
	name?: string | undefined | null,
	productPrices?: Array<ValueTypes["CustomerGroupUpdateProductPricesEntityRelationInput"]> | undefined | null,
	discountPermille?: number | undefined | null,
	code?: string | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerGroupUpdateProductPricesEntityRelationInput"]: {
	create?: ValueTypes["ProductGroupPriceWithoutGroupCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerGroupUpdateProductPricesRelationInput"] | undefined | null,
	upsert?: ValueTypes["CustomerGroupUpsertProductPricesRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductGroupPriceUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductGroupPriceUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductGroupPriceUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerGroupUpdateProductPricesRelationInput"]: {
	by?: ValueTypes["ProductGroupPriceUniqueWhere"] | undefined | null,
	data?: ValueTypes["ProductGroupPriceWithoutGroupUpdateInput"] | undefined | null
};
	["ProductGroupPriceWithoutGroupUpdateInput"]: {
	priceCents?: number | undefined | null,
	product?: ValueTypes["ProductGroupPriceUpdateProductEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductGroupPriceUpdateProductEntityRelationInput"]: {
	create?: ValueTypes["ProductWithoutGroupPricesCreateInput"] | undefined | null,
	update?: ValueTypes["ProductWithoutGroupPricesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductGroupPriceUpsertProductRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductUniqueWhere"] | undefined | null
};
	["ProductWithoutGroupPricesUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	priceCents?: number | undefined | null,
	notDiscountable?: boolean | undefined | null,
	packing?: ValueTypes["ProductUpdatePackingEntityRelationInput"] | undefined | null,
	recipe?: ValueTypes["ProductUpdateRecipeEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["ProductUpdateTagsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["ProductUpdateCategoriesEntityRelationInput"]> | undefined | null,
	vatRate?: ValueTypes["ProductUpdateVatRateEntityRelationInput"] | undefined | null,
	stocks?: Array<ValueTypes["ProductUpdateStocksEntityRelationInput"]> | undefined | null,
	image?: ValueTypes["ProductUpdateImageEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	cartItems?: Array<ValueTypes["ProductUpdateCartItemsEntityRelationInput"]> | undefined | null,
	availability?: ValueTypes["ProductAvailability"] | undefined | null,
	order?: number | undefined | null,
	manager?: ValueTypes["ProductUpdateManagerEntityRelationInput"] | undefined | null,
	orderItems?: Array<ValueTypes["ProductUpdateOrderItemsEntityRelationInput"]> | undefined | null,
	maximumQuantityPerOrder?: number | undefined | null,
	inheritedCategories?: Array<ValueTypes["ProductUpdateInheritedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["ProductUpdateDeliveryZonesEntityRelationInput"]> | undefined | null,
	locales?: Array<ValueTypes["ProductUpdateLocalesEntityRelationInput"]> | undefined | null,
	archivedAt?: ValueTypes["DateTime"] | undefined | null,
	customerPrices?: Array<ValueTypes["ProductUpdateCustomerPricesEntityRelationInput"]> | undefined | null,
	virtualProduct?: ValueTypes["ProductUpdateVirtualProductEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["ProductUpdateMetaEntityRelationInput"] | undefined | null,
	page?: ValueTypes["ProductUpdatePageEntityRelationInput"] | undefined | null,
	salesDays?: Array<ValueTypes["ProductUpdateSalesDaysEntityRelationInput"]> | undefined | null,
	salesWeeks?: Array<ValueTypes["ProductUpdateSalesWeeksEntityRelationInput"]> | undefined | null,
	salesMonths?: Array<ValueTypes["ProductUpdateSalesMonthsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["ProductUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	hasSubscription?: boolean | undefined | null,
	pointOfSaleTileColor?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductUpdateCategoriesEntityRelationInput"]: {
	create?: ValueTypes["ProductCategoryWithoutProductsCreateInput"] | undefined | null,
	update?: ValueTypes["ProductUpdateCategoriesRelationInput"] | undefined | null,
	upsert?: ValueTypes["ProductUpsertCategoriesRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductCategoryUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductCategoryUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductCategoryUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductUpdateCategoriesRelationInput"]: {
	by?: ValueTypes["ProductCategoryUniqueWhere"] | undefined | null,
	data?: ValueTypes["ProductCategoryWithoutProductsUpdateInput"] | undefined | null
};
	["ProductCategoryWithoutProductsUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	tags?: Array<ValueTypes["ProductCategoryUpdateTagsEntityRelationInput"]> | undefined | null,
	parent?: ValueTypes["ProductCategoryUpdateParentEntityRelationInput"] | undefined | null,
	children?: Array<ValueTypes["ProductCategoryUpdateChildrenEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	color?: string | undefined | null,
	image?: ValueTypes["ProductCategoryUpdateImageEntityRelationInput"] | undefined | null,
	order?: number | undefined | null,
	descendants?: Array<ValueTypes["ProductCategoryUpdateDescendantsEntityRelationInput"]> | undefined | null,
	ancestors?: Array<ValueTypes["ProductCategoryUpdateAncestorsEntityRelationInput"]> | undefined | null,
	inheritedTags?: Array<ValueTypes["ProductCategoryUpdateInheritedTagsEntityRelationInput"]> | undefined | null,
	nestedProducts?: Array<ValueTypes["ProductCategoryUpdateNestedProductsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCategoryUpdateChildrenEntityRelationInput"]: {
	create?: ValueTypes["ProductCategoryWithoutParentCreateInput"] | undefined | null,
	update?: ValueTypes["ProductCategoryUpdateChildrenRelationInput"] | undefined | null,
	upsert?: ValueTypes["ProductCategoryUpsertChildrenRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductCategoryUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductCategoryUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductCategoryUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductCategoryUpdateChildrenRelationInput"]: {
	by?: ValueTypes["ProductCategoryUniqueWhere"] | undefined | null,
	data?: ValueTypes["ProductCategoryWithoutParentUpdateInput"] | undefined | null
};
	["ProductCategoryWithoutParentUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	products?: Array<ValueTypes["ProductCategoryUpdateProductsEntityRelationInput"]> | undefined | null,
	tags?: Array<ValueTypes["ProductCategoryUpdateTagsEntityRelationInput"]> | undefined | null,
	children?: Array<ValueTypes["ProductCategoryUpdateChildrenEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	color?: string | undefined | null,
	image?: ValueTypes["ProductCategoryUpdateImageEntityRelationInput"] | undefined | null,
	order?: number | undefined | null,
	descendants?: Array<ValueTypes["ProductCategoryUpdateDescendantsEntityRelationInput"]> | undefined | null,
	ancestors?: Array<ValueTypes["ProductCategoryUpdateAncestorsEntityRelationInput"]> | undefined | null,
	inheritedTags?: Array<ValueTypes["ProductCategoryUpdateInheritedTagsEntityRelationInput"]> | undefined | null,
	nestedProducts?: Array<ValueTypes["ProductCategoryUpdateNestedProductsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCategoryUpdateImageEntityRelationInput"]: {
	create?: ValueTypes["ImageCreateInput"] | undefined | null,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductCategoryUpsertImageRelationInput"] | undefined | null,
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductCategoryUpsertImageRelationInput"]: {
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["ProductCategoryUpdateDescendantsEntityRelationInput"]: {
	connect?: ValueTypes["ProductCategoryTreeUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductCategoryTreeUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductCategoryTreeUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductCategoryUpdateAncestorsEntityRelationInput"]: {
	connect?: ValueTypes["ProductCategoryTreeUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductCategoryTreeUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductCategoryTreeUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductCategoryUpdateInheritedTagsEntityRelationInput"]: {
	connect?: ValueTypes["InheritedProductCategoryTagUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["InheritedProductCategoryTagUniqueWhere"] | undefined | null,
	delete?: ValueTypes["InheritedProductCategoryTagUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductCategoryUpdateNestedProductsEntityRelationInput"]: {
	connect?: ValueTypes["NestedProductCategoryProductUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["NestedProductCategoryProductUniqueWhere"] | undefined | null,
	delete?: ValueTypes["NestedProductCategoryProductUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductCategoryUpsertChildrenRelationInput"]: {
	by?: ValueTypes["ProductCategoryUniqueWhere"] | undefined | null,
	update?: ValueTypes["ProductCategoryWithoutParentUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductCategoryWithoutParentCreateInput"] | undefined | null
};
	["ProductUpsertCategoriesRelationInput"]: {
	by?: ValueTypes["ProductCategoryUniqueWhere"] | undefined | null,
	update?: ValueTypes["ProductCategoryWithoutProductsUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductCategoryWithoutProductsCreateInput"] | undefined | null
};
	["ProductUpdateVatRateEntityRelationInput"]: {
	create?: ValueTypes["VatRateCreateInput"] | undefined | null,
	update?: ValueTypes["VatRateUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductUpsertVatRateRelationInput"] | undefined | null,
	connect?: ValueTypes["VatRateUniqueWhere"] | undefined | null
};
	["ProductUpsertVatRateRelationInput"]: {
	update?: ValueTypes["VatRateUpdateInput"] | undefined | null,
	create?: ValueTypes["VatRateCreateInput"] | undefined | null
};
	["ProductUpdateStocksEntityRelationInput"]: {
	create?: ValueTypes["ProductStockWithoutProductCreateInput"] | undefined | null,
	update?: ValueTypes["ProductUpdateStocksRelationInput"] | undefined | null,
	upsert?: ValueTypes["ProductUpsertStocksRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductStockUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductStockUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductStockUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductUpdateStocksRelationInput"]: {
	by?: ValueTypes["ProductStockUniqueWhere"] | undefined | null,
	data?: ValueTypes["ProductStockWithoutProductUpdateInput"] | undefined | null
};
	["ProductStockWithoutProductUpdateInput"]: {
	quantity?: number | undefined | null,
	store?: ValueTypes["ProductStockUpdateStoreEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductStockUpdateStoreEntityRelationInput"]: {
	create?: ValueTypes["StoreCreateInput"] | undefined | null,
	update?: ValueTypes["StoreUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductStockUpsertStoreRelationInput"] | undefined | null,
	connect?: ValueTypes["StoreUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["StoreUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductStockUpsertStoreRelationInput"]: {
	update?: ValueTypes["StoreUpdateInput"] | undefined | null,
	create?: ValueTypes["StoreCreateInput"] | undefined | null
};
	["ProductUpsertStocksRelationInput"]: {
	by?: ValueTypes["ProductStockUniqueWhere"] | undefined | null,
	update?: ValueTypes["ProductStockWithoutProductUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductStockWithoutProductCreateInput"] | undefined | null
};
	["ProductUpdateImageEntityRelationInput"]: {
	create?: ValueTypes["ImageCreateInput"] | undefined | null,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductUpsertImageRelationInput"] | undefined | null,
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductUpsertImageRelationInput"]: {
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["ProductUpdateCartItemsEntityRelationInput"]: {
	create?: ValueTypes["CartItemWithoutProductCreateInput"] | undefined | null,
	update?: ValueTypes["ProductUpdateCartItemsRelationInput"] | undefined | null,
	upsert?: ValueTypes["ProductUpsertCartItemsRelationInput"] | undefined | null,
	connect?: ValueTypes["CartItemUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["CartItemUniqueWhere"] | undefined | null,
	delete?: ValueTypes["CartItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductUpdateCartItemsRelationInput"]: {
	by?: ValueTypes["CartItemUniqueWhere"] | undefined | null,
	data?: ValueTypes["CartItemWithoutProductUpdateInput"] | undefined | null
};
	["CartItemWithoutProductUpdateInput"]: {
	quantity?: number | undefined | null,
	cart?: ValueTypes["CartItemUpdateCartEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	updatedAt?: ValueTypes["DateTime"] | undefined | null,
	fulfillmentNote?: string | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["CartItemUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CartItemUpdateCartEntityRelationInput"]: {
	create?: ValueTypes["CartWithoutItemsCreateInput"] | undefined | null,
	update?: ValueTypes["CartWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CartItemUpsertCartRelationInput"] | undefined | null,
	connect?: ValueTypes["CartUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CartWithoutItemsUpdateInput"]: {
	confirmedAt?: ValueTypes["DateTime"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	handle?: string | undefined | null,
	state?: ValueTypes["CartState"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	channel?: ValueTypes["CartUpdateChannelEntityRelationInput"] | undefined | null,
	order?: ValueTypes["CartUpdateOrderEntityRelationInput"] | undefined | null,
	customer?: ValueTypes["CartUpdateCustomerEntityRelationInput"] | undefined | null,
	deliveryAddress?: ValueTypes["CartUpdateDeliveryAddressEntityRelationInput"] | undefined | null,
	billingAddress?: ValueTypes["CartUpdateBillingAddressEntityRelationInput"] | undefined | null,
	deliveryOption?: string | undefined | null,
	paymentOption?: string | undefined | null,
	delivery?: ValueTypes["CartUpdateDeliveryEntityRelationInput"] | undefined | null,
	payment?: ValueTypes["CartUpdatePaymentEntityRelationInput"] | undefined | null,
	billingSubject?: ValueTypes["CartUpdateBillingSubjectEntityRelationInput"] | undefined | null,
	priceLines?: Array<ValueTypes["CartUpdatePriceLinesEntityRelationInput"]> | undefined | null,
	summary?: ValueTypes["CartUpdateSummaryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CartUpdateChannelEntityRelationInput"]: {
	create?: ValueTypes["ChannelWithoutCartsCreateInput"] | undefined | null,
	update?: ValueTypes["ChannelWithoutCartsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CartUpsertChannelRelationInput"] | undefined | null,
	connect?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ChannelWithoutCartsUpdateInput"]: {
	name?: string | undefined | null,
	disabled?: boolean | undefined | null,
	payments?: Array<ValueTypes["ChannelUpdatePaymentsEntityRelationInput"]> | undefined | null,
	deliveries?: Array<ValueTypes["ChannelUpdateDeliveriesEntityRelationInput"]> | undefined | null,
	pointOfSales?: Array<ValueTypes["ChannelUpdatePointOfSalesEntityRelationInput"]> | undefined | null,
	customers?: Array<ValueTypes["ChannelUpdateCustomersEntityRelationInput"]> | undefined | null,
	code?: ValueTypes["ChannelCode"] | undefined | null,
	addTagsOnRegistration?: Array<ValueTypes["ChannelUpdateAddTagsOnRegistrationEntityRelationInput"]> | undefined | null,
	publicTags?: Array<ValueTypes["ChannelUpdatePublicTagsEntityRelationInput"]> | undefined | null,
	venue?: ValueTypes["ChannelUpdateVenueEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ChannelUpdateAddTagsOnRegistrationEntityRelationInput"]: {
	create?: ValueTypes["TagWithoutAddTagsOnRegistrationCreateInput"] | undefined | null,
	update?: ValueTypes["ChannelUpdateAddTagsOnRegistrationRelationInput"] | undefined | null,
	upsert?: ValueTypes["ChannelUpsertAddTagsOnRegistrationRelationInput"] | undefined | null,
	connect?: ValueTypes["TagUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["TagUniqueWhere"] | undefined | null,
	delete?: ValueTypes["TagUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ChannelUpdateAddTagsOnRegistrationRelationInput"]: {
	by?: ValueTypes["TagUniqueWhere"] | undefined | null,
	data?: ValueTypes["TagWithoutAddTagsOnRegistrationUpdateInput"] | undefined | null
};
	["TagWithoutAddTagsOnRegistrationUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	customers?: Array<ValueTypes["TagUpdateCustomersEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["TagUpdateProductsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["TagUpdateCategoriesEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	nestedCategories?: Array<ValueTypes["TagUpdateNestedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["TagUpdateDeliveryZonesEntityRelationInput"]> | undefined | null,
	publicInChannels?: Array<ValueTypes["TagUpdatePublicInChannelsEntityRelationInput"]> | undefined | null,
	allowChannelPayments?: Array<ValueTypes["TagUpdateAllowChannelPaymentsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["TagUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TagUpdateNestedCategoriesEntityRelationInput"]: {
	connect?: ValueTypes["InheritedProductCategoryTagUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["InheritedProductCategoryTagUniqueWhere"] | undefined | null,
	delete?: ValueTypes["InheritedProductCategoryTagUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["TagUpdateDeliveryZonesEntityRelationInput"]: {
	create?: ValueTypes["DeliveryZoneWithoutDeliveryZonesOfTagsCreateInput"] | undefined | null,
	update?: ValueTypes["TagUpdateDeliveryZonesRelationInput"] | undefined | null,
	upsert?: ValueTypes["TagUpsertDeliveryZonesRelationInput"] | undefined | null,
	connect?: ValueTypes["DeliveryZoneUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["DeliveryZoneUniqueWhere"] | undefined | null,
	delete?: ValueTypes["DeliveryZoneUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["TagUpdateDeliveryZonesRelationInput"]: {
	by?: ValueTypes["DeliveryZoneUniqueWhere"] | undefined | null,
	data?: ValueTypes["DeliveryZoneWithoutDeliveryZonesOfTagsUpdateInput"] | undefined | null
};
	["DeliveryZoneWithoutDeliveryZonesOfTagsUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	type?: ValueTypes["DeliveryZoneType"] | undefined | null,
	addresses?: Array<ValueTypes["DeliveryZoneUpdateAddressesEntityRelationInput"]> | undefined | null,
	suitableDeliveryMethods?: Array<ValueTypes["DeliveryZoneUpdateSuitableDeliveryMethodsEntityRelationInput"]> | undefined | null,
	deliveryZonesOfProducts?: Array<ValueTypes["DeliveryZoneUpdateDeliveryZonesOfProductsEntityRelationInput"]> | undefined | null,
	addressesMetadata?: Array<ValueTypes["DeliveryZoneUpdateAddressesMetadataEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryZoneUpdateDeliveryZonesOfProductsEntityRelationInput"]: {
	create?: ValueTypes["ProductWithoutDeliveryZonesCreateInput"] | undefined | null,
	update?: ValueTypes["DeliveryZoneUpdateDeliveryZonesOfProductsRelationInput"] | undefined | null,
	upsert?: ValueTypes["DeliveryZoneUpsertDeliveryZonesOfProductsRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["DeliveryZoneUpdateDeliveryZonesOfProductsRelationInput"]: {
	by?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	data?: ValueTypes["ProductWithoutDeliveryZonesUpdateInput"] | undefined | null
};
	["ProductWithoutDeliveryZonesUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	priceCents?: number | undefined | null,
	notDiscountable?: boolean | undefined | null,
	packing?: ValueTypes["ProductUpdatePackingEntityRelationInput"] | undefined | null,
	recipe?: ValueTypes["ProductUpdateRecipeEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["ProductUpdateTagsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["ProductUpdateCategoriesEntityRelationInput"]> | undefined | null,
	vatRate?: ValueTypes["ProductUpdateVatRateEntityRelationInput"] | undefined | null,
	stocks?: Array<ValueTypes["ProductUpdateStocksEntityRelationInput"]> | undefined | null,
	groupPrices?: Array<ValueTypes["ProductUpdateGroupPricesEntityRelationInput"]> | undefined | null,
	image?: ValueTypes["ProductUpdateImageEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	cartItems?: Array<ValueTypes["ProductUpdateCartItemsEntityRelationInput"]> | undefined | null,
	availability?: ValueTypes["ProductAvailability"] | undefined | null,
	order?: number | undefined | null,
	manager?: ValueTypes["ProductUpdateManagerEntityRelationInput"] | undefined | null,
	orderItems?: Array<ValueTypes["ProductUpdateOrderItemsEntityRelationInput"]> | undefined | null,
	maximumQuantityPerOrder?: number | undefined | null,
	inheritedCategories?: Array<ValueTypes["ProductUpdateInheritedCategoriesEntityRelationInput"]> | undefined | null,
	locales?: Array<ValueTypes["ProductUpdateLocalesEntityRelationInput"]> | undefined | null,
	archivedAt?: ValueTypes["DateTime"] | undefined | null,
	customerPrices?: Array<ValueTypes["ProductUpdateCustomerPricesEntityRelationInput"]> | undefined | null,
	virtualProduct?: ValueTypes["ProductUpdateVirtualProductEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["ProductUpdateMetaEntityRelationInput"] | undefined | null,
	page?: ValueTypes["ProductUpdatePageEntityRelationInput"] | undefined | null,
	salesDays?: Array<ValueTypes["ProductUpdateSalesDaysEntityRelationInput"]> | undefined | null,
	salesWeeks?: Array<ValueTypes["ProductUpdateSalesWeeksEntityRelationInput"]> | undefined | null,
	salesMonths?: Array<ValueTypes["ProductUpdateSalesMonthsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["ProductUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	hasSubscription?: boolean | undefined | null,
	pointOfSaleTileColor?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductUpdateGroupPricesEntityRelationInput"]: {
	create?: ValueTypes["ProductGroupPriceWithoutProductCreateInput"] | undefined | null,
	update?: ValueTypes["ProductUpdateGroupPricesRelationInput"] | undefined | null,
	upsert?: ValueTypes["ProductUpsertGroupPricesRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductGroupPriceUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductGroupPriceUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductGroupPriceUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductUpdateGroupPricesRelationInput"]: {
	by?: ValueTypes["ProductGroupPriceUniqueWhere"] | undefined | null,
	data?: ValueTypes["ProductGroupPriceWithoutProductUpdateInput"] | undefined | null
};
	["ProductGroupPriceWithoutProductUpdateInput"]: {
	priceCents?: number | undefined | null,
	group?: ValueTypes["ProductGroupPriceUpdateGroupEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductGroupPriceUpdateGroupEntityRelationInput"]: {
	create?: ValueTypes["CustomerGroupWithoutProductPricesCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerGroupWithoutProductPricesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductGroupPriceUpsertGroupRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerGroupUniqueWhere"] | undefined | null
};
	["CustomerGroupWithoutProductPricesUpdateInput"]: {
	name?: string | undefined | null,
	customers?: Array<ValueTypes["CustomerGroupUpdateCustomersEntityRelationInput"]> | undefined | null,
	discountPermille?: number | undefined | null,
	code?: string | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerGroupUpdateCustomersEntityRelationInput"]: {
	create?: ValueTypes["CustomerWithoutGroupCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerGroupUpdateCustomersRelationInput"] | undefined | null,
	upsert?: ValueTypes["CustomerGroupUpsertCustomersRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	delete?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerGroupUpdateCustomersRelationInput"]: {
	by?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	data?: ValueTypes["CustomerWithoutGroupUpdateInput"] | undefined | null
};
	["CustomerWithoutGroupUpdateInput"]: {
	addresses?: Array<ValueTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerUpdateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerUpdateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerUpdateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerUpdatePhotoEntityRelationInput"]: {
	create?: ValueTypes["ImageCreateInput"] | undefined | null,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CustomerUpsertPhotoRelationInput"] | undefined | null,
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CustomerUpsertPhotoRelationInput"]: {
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["CustomerUpdateNameEntityRelationInput"]: {
	create?: ValueTypes["CustomerNameWithoutCustomerCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerNameWithoutCustomerUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CustomerUpsertNameRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerNameUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CustomerNameWithoutCustomerUpdateInput"]: {
	nominative?: string | undefined | null,
	vocative?: string | undefined | null,
	aliases?: Array<ValueTypes["CustomerNameUpdateAliasesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerNameUpdateAliasesEntityRelationInput"]: {
	create?: ValueTypes["CustomerAliasCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerNameUpdateAliasesRelationInput"] | undefined | null,
	upsert?: ValueTypes["CustomerNameUpsertAliasesRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerAliasUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["CustomerAliasUniqueWhere"] | undefined | null,
	delete?: ValueTypes["CustomerAliasUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerNameUpdateAliasesRelationInput"]: {
	by?: ValueTypes["CustomerAliasUniqueWhere"] | undefined | null,
	data?: ValueTypes["CustomerAliasUpdateInput"] | undefined | null
};
	["CustomerAliasUpdateInput"]: {
	name?: string | undefined | null,
	order?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerNameUpsertAliasesRelationInput"]: {
	by?: ValueTypes["CustomerAliasUniqueWhere"] | undefined | null,
	update?: ValueTypes["CustomerAliasUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerAliasCreateInput"] | undefined | null
};
	["CustomerUpsertNameRelationInput"]: {
	update?: ValueTypes["CustomerNameWithoutCustomerUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerNameWithoutCustomerCreateInput"] | undefined | null
};
	["CustomerUpdateIngredientRatingsEntityRelationInput"]: {
	create?: ValueTypes["CustomerIngredientRatingWithoutCustomerCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerUpdateIngredientRatingsRelationInput"] | undefined | null,
	upsert?: ValueTypes["CustomerUpsertIngredientRatingsRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerIngredientRatingUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["CustomerIngredientRatingUniqueWhere"] | undefined | null,
	delete?: ValueTypes["CustomerIngredientRatingUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerUpdateIngredientRatingsRelationInput"]: {
	by?: ValueTypes["CustomerIngredientRatingUniqueWhere"] | undefined | null,
	data?: ValueTypes["CustomerIngredientRatingWithoutCustomerUpdateInput"] | undefined | null
};
	["CustomerIngredientRatingWithoutCustomerUpdateInput"]: {
	rating?: ValueTypes["CustomerIngredientRatingUpdateRatingEntityRelationInput"] | undefined | null,
	ingredient?: ValueTypes["CustomerIngredientRatingUpdateIngredientEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerIngredientRatingUpdateRatingEntityRelationInput"]: {
	create?: ValueTypes["ProductIngredientRatingCreateInput"] | undefined | null,
	update?: ValueTypes["ProductIngredientRatingUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CustomerIngredientRatingUpsertRatingRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductIngredientRatingUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductIngredientRatingUpdateInput"]: {
	order?: number | undefined | null,
	name?: string | undefined | null,
	icon?: ValueTypes["ProductIngredientRatingUpdateIconEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientRatingUpdateIconEntityRelationInput"]: {
	create?: ValueTypes["ImageCreateInput"] | undefined | null,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductIngredientRatingUpsertIconRelationInput"] | undefined | null,
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductIngredientRatingUpsertIconRelationInput"]: {
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["CustomerIngredientRatingUpsertRatingRelationInput"]: {
	update?: ValueTypes["ProductIngredientRatingUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductIngredientRatingCreateInput"] | undefined | null
};
	["CustomerIngredientRatingUpdateIngredientEntityRelationInput"]: {
	create?: ValueTypes["ProductIngredientWithoutCustomerRatingsCreateInput"] | undefined | null,
	update?: ValueTypes["ProductIngredientWithoutCustomerRatingsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CustomerIngredientRatingUpsertIngredientRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductIngredientUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductIngredientWithoutCustomerRatingsUpdateInput"]: {
	internalNote?: string | undefined | null,
	locales?: Array<ValueTypes["ProductIngredientUpdateLocalesEntityRelationInput"]> | undefined | null,
	internalName?: string | undefined | null,
	categories?: Array<ValueTypes["ProductIngredientUpdateCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["ProductIngredientUpdateAllergensEntityRelationInput"]> | undefined | null,
	needsPrepping?: boolean | undefined | null,
	allowCustomerRating?: boolean | undefined | null,
	preferredQuantityUnit?: ValueTypes["ProductIngredientUpdatePreferredQuantityUnitEntityRelationInput"] | undefined | null,
	freshingContainer?: ValueTypes["ProductIngredientUpdateFreshingContainerEntityRelationInput"] | undefined | null,
	image?: ValueTypes["ProductIngredientUpdateImageEntityRelationInput"] | undefined | null,
	suppliers?: ValueTypes["ProductIngredientUpdateSuppliersEntityRelationInput"] | undefined | null,
	incrementQuantityNumber?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientUpdateCategoriesEntityRelationInput"]: {
	create?: ValueTypes["ProductIngredientCategoryWithoutIngredientsCreateInput"] | undefined | null,
	update?: ValueTypes["ProductIngredientUpdateCategoriesRelationInput"] | undefined | null,
	upsert?: ValueTypes["ProductIngredientUpsertCategoriesRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductIngredientCategoryUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductIngredientCategoryUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductIngredientCategoryUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductIngredientUpdateCategoriesRelationInput"]: {
	by?: ValueTypes["ProductIngredientCategoryUniqueWhere"] | undefined | null,
	data?: ValueTypes["ProductIngredientCategoryWithoutIngredientsUpdateInput"] | undefined | null
};
	["ProductIngredientCategoryWithoutIngredientsUpdateInput"]: {
	internalName?: string | undefined | null,
	internalNote?: string | undefined | null,
	locales?: Array<ValueTypes["ProductIngredientCategoryUpdateLocalesEntityRelationInput"]> | undefined | null,
	order?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientCategoryUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["ProductIngredientCategoryLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ValueTypes["ProductIngredientCategoryUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ValueTypes["ProductIngredientCategoryUpsertLocalesRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductIngredientCategoryLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductIngredientCategoryLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductIngredientCategoryLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductIngredientCategoryUpdateLocalesRelationInput"]: {
	by?: ValueTypes["ProductIngredientCategoryLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["ProductIngredientCategoryLocaleWithoutRootUpdateInput"] | undefined | null
};
	["ProductIngredientCategoryLocaleWithoutRootUpdateInput"]: {
	name?: string | undefined | null,
	locale?: ValueTypes["ProductIngredientCategoryLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientCategoryLocaleUpdateLocaleEntityRelationInput"]: {
	create?: ValueTypes["LocaleWithoutProductIngredientCategoriesCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleWithoutProductIngredientCategoriesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductIngredientCategoryLocaleUpsertLocaleRelationInput"] | undefined | null,
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutProductIngredientCategoriesUpdateInput"]: {
	businessCategories?: Array<ValueTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleUpdateProductIngredientsEntityRelationInput"]: {
	create?: ValueTypes["ProductIngredientLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleUpdateProductIngredientsRelationInput"] | undefined | null,
	upsert?: ValueTypes["LocaleUpsertProductIngredientsRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductIngredientLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductIngredientLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductIngredientLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateProductIngredientsRelationInput"]: {
	by?: ValueTypes["ProductIngredientLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["ProductIngredientLocaleWithoutLocaleUpdateInput"] | undefined | null
};
	["ProductIngredientLocaleWithoutLocaleUpdateInput"]: {
	name?: string | undefined | null,
	root?: ValueTypes["ProductIngredientLocaleUpdateRootEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientLocaleUpdateRootEntityRelationInput"]: {
	create?: ValueTypes["ProductIngredientWithoutLocalesCreateInput"] | undefined | null,
	update?: ValueTypes["ProductIngredientWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductIngredientLocaleUpsertRootRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductIngredientUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductIngredientWithoutLocalesUpdateInput"]: {
	internalNote?: string | undefined | null,
	internalName?: string | undefined | null,
	categories?: Array<ValueTypes["ProductIngredientUpdateCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["ProductIngredientUpdateAllergensEntityRelationInput"]> | undefined | null,
	needsPrepping?: boolean | undefined | null,
	allowCustomerRating?: boolean | undefined | null,
	customerRatings?: Array<ValueTypes["ProductIngredientUpdateCustomerRatingsEntityRelationInput"]> | undefined | null,
	preferredQuantityUnit?: ValueTypes["ProductIngredientUpdatePreferredQuantityUnitEntityRelationInput"] | undefined | null,
	freshingContainer?: ValueTypes["ProductIngredientUpdateFreshingContainerEntityRelationInput"] | undefined | null,
	image?: ValueTypes["ProductIngredientUpdateImageEntityRelationInput"] | undefined | null,
	suppliers?: ValueTypes["ProductIngredientUpdateSuppliersEntityRelationInput"] | undefined | null,
	incrementQuantityNumber?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientUpdateAllergensEntityRelationInput"]: {
	create?: ValueTypes["AllergenWithoutIngredientsCreateInput"] | undefined | null,
	update?: ValueTypes["ProductIngredientUpdateAllergensRelationInput"] | undefined | null,
	upsert?: ValueTypes["ProductIngredientUpsertAllergensRelationInput"] | undefined | null,
	connect?: ValueTypes["AllergenUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["AllergenUniqueWhere"] | undefined | null,
	delete?: ValueTypes["AllergenUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductIngredientUpdateAllergensRelationInput"]: {
	by?: ValueTypes["AllergenUniqueWhere"] | undefined | null,
	data?: ValueTypes["AllergenWithoutIngredientsUpdateInput"] | undefined | null
};
	["AllergenWithoutIngredientsUpdateInput"]: {
	internalName?: string | undefined | null,
	locales?: Array<ValueTypes["AllergenUpdateLocalesEntityRelationInput"]> | undefined | null,
	code?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AllergenUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["AllergenLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ValueTypes["AllergenUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ValueTypes["AllergenUpsertLocalesRelationInput"] | undefined | null,
	connect?: ValueTypes["AllergenLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["AllergenLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["AllergenLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["AllergenUpdateLocalesRelationInput"]: {
	by?: ValueTypes["AllergenLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["AllergenLocaleWithoutRootUpdateInput"] | undefined | null
};
	["AllergenLocaleWithoutRootUpdateInput"]: {
	name?: string | undefined | null,
	locale?: ValueTypes["AllergenLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AllergenLocaleUpdateLocaleEntityRelationInput"]: {
	create?: ValueTypes["LocaleWithoutAllergensCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleWithoutAllergensUpdateInput"] | undefined | null,
	upsert?: ValueTypes["AllergenLocaleUpsertLocaleRelationInput"] | undefined | null,
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutAllergensUpdateInput"]: {
	businessCategories?: Array<ValueTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleUpdateOrderRecurrencesEntityRelationInput"]: {
	create?: ValueTypes["OrderRecurrenceLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleUpdateOrderRecurrencesRelationInput"] | undefined | null,
	upsert?: ValueTypes["LocaleUpsertOrderRecurrencesRelationInput"] | undefined | null,
	connect?: ValueTypes["OrderRecurrenceLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["OrderRecurrenceLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["OrderRecurrenceLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateOrderRecurrencesRelationInput"]: {
	by?: ValueTypes["OrderRecurrenceLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["OrderRecurrenceLocaleWithoutLocaleUpdateInput"] | undefined | null
};
	["OrderRecurrenceLocaleWithoutLocaleUpdateInput"]: {
	name?: string | undefined | null,
	root?: ValueTypes["OrderRecurrenceLocaleUpdateRootEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderRecurrenceLocaleUpdateRootEntityRelationInput"]: {
	create?: ValueTypes["OrderRecurrenceWithoutLocalesCreateInput"] | undefined | null,
	update?: ValueTypes["OrderRecurrenceWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["OrderRecurrenceLocaleUpsertRootRelationInput"] | undefined | null,
	connect?: ValueTypes["OrderRecurrenceUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["OrderRecurrenceWithoutLocalesUpdateInput"]: {
	internalName?: string | undefined | null,
	order?: number | undefined | null,
	businessCategory?: Array<ValueTypes["OrderRecurrenceUpdateBusinessCategoryEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderRecurrenceUpdateBusinessCategoryEntityRelationInput"]: {
	create?: ValueTypes["BusinessCategoryWithoutRecurrencesCreateInput"] | undefined | null,
	update?: ValueTypes["OrderRecurrenceUpdateBusinessCategoryRelationInput"] | undefined | null,
	upsert?: ValueTypes["OrderRecurrenceUpsertBusinessCategoryRelationInput"] | undefined | null,
	connect?: ValueTypes["BusinessCategoryUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["BusinessCategoryUniqueWhere"] | undefined | null,
	delete?: ValueTypes["BusinessCategoryUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["OrderRecurrenceUpdateBusinessCategoryRelationInput"]: {
	by?: ValueTypes["BusinessCategoryUniqueWhere"] | undefined | null,
	data?: ValueTypes["BusinessCategoryWithoutRecurrencesUpdateInput"] | undefined | null
};
	["BusinessCategoryWithoutRecurrencesUpdateInput"]: {
	order?: number | undefined | null,
	visibleToNewCustomers?: boolean | undefined | null,
	locales?: Array<ValueTypes["BusinessCategoryUpdateLocalesEntityRelationInput"]> | undefined | null,
	internalName?: string | undefined | null,
	businessCustomers?: Array<ValueTypes["BusinessCategoryUpdateBusinessCustomersEntityRelationInput"]> | undefined | null,
	specificProducts?: ValueTypes["BusinessCategoryUpdateSpecificProductsEntityRelationInput"] | undefined | null,
	seasonalProductCategories?: ValueTypes["BusinessCategoryUpdateSeasonalProductCategoriesEntityRelationInput"] | undefined | null,
	specificProductsProductCategories?: ValueTypes["BusinessCategoryUpdateSpecificProductsProductCategoriesEntityRelationInput"] | undefined | null,
	slug?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessCategoryUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["BusinessCategoryLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ValueTypes["BusinessCategoryUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ValueTypes["BusinessCategoryUpsertLocalesRelationInput"] | undefined | null,
	connect?: ValueTypes["BusinessCategoryLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["BusinessCategoryLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["BusinessCategoryLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["BusinessCategoryUpdateLocalesRelationInput"]: {
	by?: ValueTypes["BusinessCategoryLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["BusinessCategoryLocaleWithoutRootUpdateInput"] | undefined | null
};
	["BusinessCategoryLocaleWithoutRootUpdateInput"]: {
	name?: string | undefined | null,
	locale?: ValueTypes["BusinessCategoryLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	title?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessCategoryLocaleUpdateLocaleEntityRelationInput"]: {
	create?: ValueTypes["LocaleWithoutBusinessCategoriesCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleWithoutBusinessCategoriesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["BusinessCategoryLocaleUpsertLocaleRelationInput"] | undefined | null,
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutBusinessCategoriesUpdateInput"]: {
	productCategoryLists?: Array<ValueTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleUpdateBlogsEntityRelationInput"]: {
	create?: ValueTypes["BlogLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleUpdateBlogsRelationInput"] | undefined | null,
	upsert?: ValueTypes["LocaleUpsertBlogsRelationInput"] | undefined | null,
	connect?: ValueTypes["BlogLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["BlogLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["BlogLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateBlogsRelationInput"]: {
	by?: ValueTypes["BlogLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["BlogLocaleWithoutLocaleUpdateInput"] | undefined | null
};
	["BlogLocaleWithoutLocaleUpdateInput"]: {
	pageName?: string | undefined | null,
	title?: string | undefined | null,
	lead?: string | undefined | null,
	root?: ValueTypes["BlogLocaleUpdateRootEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BlogLocaleUpdateRootEntityRelationInput"]: {
	create?: ValueTypes["BlogWithoutLocalesCreateInput"] | undefined | null,
	update?: ValueTypes["BlogWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["BlogLocaleUpsertRootRelationInput"] | undefined | null,
	connect?: ValueTypes["BlogUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["BlogWithoutLocalesUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BlogLocaleUpsertRootRelationInput"]: {
	update?: ValueTypes["BlogWithoutLocalesUpdateInput"] | undefined | null,
	create?: ValueTypes["BlogWithoutLocalesCreateInput"] | undefined | null
};
	["LocaleUpsertBlogsRelationInput"]: {
	by?: ValueTypes["BlogLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["BlogLocaleWithoutLocaleUpdateInput"] | undefined | null,
	create?: ValueTypes["BlogLocaleWithoutLocaleCreateInput"] | undefined | null
};
	["LocaleUpdateBlogPostsEntityRelationInput"]: {
	create?: ValueTypes["BlogPostLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleUpdateBlogPostsRelationInput"] | undefined | null,
	upsert?: ValueTypes["LocaleUpsertBlogPostsRelationInput"] | undefined | null,
	connect?: ValueTypes["BlogPostLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["BlogPostLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["BlogPostLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateBlogPostsRelationInput"]: {
	by?: ValueTypes["BlogPostLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["BlogPostLocaleWithoutLocaleUpdateInput"] | undefined | null
};
	["BlogPostLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined | null,
	availableForWeb?: boolean | undefined | null,
	availableForMobile?: boolean | undefined | null,
	root?: ValueTypes["BlogPostLocaleUpdateRootEntityRelationInput"] | undefined | null,
	cover?: ValueTypes["BlogPostLocaleUpdateCoverEntityRelationInput"] | undefined | null,
	content?: ValueTypes["BlogPostLocaleUpdateContentEntityRelationInput"] | undefined | null,
	link?: ValueTypes["BlogPostLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	seo?: ValueTypes["BlogPostLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	products?: Array<ValueTypes["BlogPostLocaleUpdateProductsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BlogPostLocaleUpdateRootEntityRelationInput"]: {
	create?: ValueTypes["BlogPostWithoutLocalesCreateInput"] | undefined | null,
	update?: ValueTypes["BlogPostWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["BlogPostLocaleUpsertRootRelationInput"] | undefined | null,
	connect?: ValueTypes["BlogPostUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["BlogPostWithoutLocalesUpdateInput"]: {
	order?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BlogPostLocaleUpsertRootRelationInput"]: {
	update?: ValueTypes["BlogPostWithoutLocalesUpdateInput"] | undefined | null,
	create?: ValueTypes["BlogPostWithoutLocalesCreateInput"] | undefined | null
};
	["BlogPostLocaleUpdateCoverEntityRelationInput"]: {
	create?: ValueTypes["CoverCreateInput"] | undefined | null,
	update?: ValueTypes["CoverUpdateInput"] | undefined | null,
	upsert?: ValueTypes["BlogPostLocaleUpsertCoverRelationInput"] | undefined | null,
	connect?: ValueTypes["CoverUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CoverUpdateInput"]: {
	primaryTitle?: string | undefined | null,
	secondaryTitle?: string | undefined | null,
	medium?: ValueTypes["CoverUpdateMediumEntityRelationInput"] | undefined | null,
	buttonColors?: ValueTypes["CoverUpdateButtonColorsEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CoverUpdateMediumEntityRelationInput"]: {
	create?: ValueTypes["MediumCreateInput"] | undefined | null,
	update?: ValueTypes["MediumUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CoverUpsertMediumRelationInput"] | undefined | null,
	connect?: ValueTypes["MediumUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["MediumUpdateInput"]: {
	type?: ValueTypes["MediumType"] | undefined | null,
	colorTheme?: ValueTypes["ColorTheme"] | undefined | null,
	image?: ValueTypes["MediumUpdateImageEntityRelationInput"] | undefined | null,
	video?: ValueTypes["MediumUpdateVideoEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MediumUpdateImageEntityRelationInput"]: {
	create?: ValueTypes["ImageCreateInput"] | undefined | null,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ValueTypes["MediumUpsertImageRelationInput"] | undefined | null,
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["MediumUpsertImageRelationInput"]: {
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["MediumUpdateVideoEntityRelationInput"]: {
	create?: ValueTypes["VideoCreateInput"] | undefined | null,
	update?: ValueTypes["VideoUpdateInput"] | undefined | null,
	upsert?: ValueTypes["MediumUpsertVideoRelationInput"] | undefined | null,
	connect?: ValueTypes["VideoUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["VideoUpdateInput"]: {
	src?: string | undefined | null,
	width?: number | undefined | null,
	height?: number | undefined | null,
	size?: number | undefined | null,
	type?: string | undefined | null,
	duration?: number | undefined | null,
	poster?: ValueTypes["VideoUpdatePosterEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VideoUpdatePosterEntityRelationInput"]: {
	create?: ValueTypes["ImageCreateInput"] | undefined | null,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ValueTypes["VideoUpsertPosterRelationInput"] | undefined | null,
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["VideoUpsertPosterRelationInput"]: {
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["MediumUpsertVideoRelationInput"]: {
	update?: ValueTypes["VideoUpdateInput"] | undefined | null,
	create?: ValueTypes["VideoCreateInput"] | undefined | null
};
	["CoverUpsertMediumRelationInput"]: {
	update?: ValueTypes["MediumUpdateInput"] | undefined | null,
	create?: ValueTypes["MediumCreateInput"] | undefined | null
};
	["CoverUpdateButtonColorsEntityRelationInput"]: {
	create?: ValueTypes["ColorPalleteCreateInput"] | undefined | null,
	update?: ValueTypes["ColorPalleteUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CoverUpsertButtonColorsRelationInput"] | undefined | null,
	connect?: ValueTypes["ColorPalleteUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ColorPalleteUpdateInput"]: {
	background?: string | undefined | null,
	text?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CoverUpsertButtonColorsRelationInput"]: {
	update?: ValueTypes["ColorPalleteUpdateInput"] | undefined | null,
	create?: ValueTypes["ColorPalleteCreateInput"] | undefined | null
};
	["BlogPostLocaleUpsertCoverRelationInput"]: {
	update?: ValueTypes["CoverUpdateInput"] | undefined | null,
	create?: ValueTypes["CoverCreateInput"] | undefined | null
};
	["BlogPostLocaleUpdateContentEntityRelationInput"]: {
	create?: ValueTypes["ContentCreateInput"] | undefined | null,
	update?: ValueTypes["ContentUpdateInput"] | undefined | null,
	upsert?: ValueTypes["BlogPostLocaleUpsertContentRelationInput"] | undefined | null,
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ContentUpdateInput"]: {
	blocks?: Array<ValueTypes["ContentUpdateBlocksEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentUpdateBlocksEntityRelationInput"]: {
	create?: ValueTypes["ContentBlockWithoutContentCreateInput"] | undefined | null,
	update?: ValueTypes["ContentUpdateBlocksRelationInput"] | undefined | null,
	upsert?: ValueTypes["ContentUpsertBlocksRelationInput"] | undefined | null,
	connect?: ValueTypes["ContentBlockUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ContentBlockUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ContentBlockUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ContentUpdateBlocksRelationInput"]: {
	by?: ValueTypes["ContentBlockUniqueWhere"] | undefined | null,
	data?: ValueTypes["ContentBlockWithoutContentUpdateInput"] | undefined | null
};
	["ContentBlockWithoutContentUpdateInput"]: {
	order?: number | undefined | null,
	json?: string | undefined | null,
	references?: Array<ValueTypes["ContentBlockUpdateReferencesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentBlockUpdateReferencesEntityRelationInput"]: {
	create?: ValueTypes["ContentReferenceWithoutBlockCreateInput"] | undefined | null,
	update?: ValueTypes["ContentBlockUpdateReferencesRelationInput"] | undefined | null,
	upsert?: ValueTypes["ContentBlockUpsertReferencesRelationInput"] | undefined | null,
	connect?: ValueTypes["ContentReferenceUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ContentReferenceUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ContentReferenceUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ContentBlockUpdateReferencesRelationInput"]: {
	by?: ValueTypes["ContentReferenceUniqueWhere"] | undefined | null,
	data?: ValueTypes["ContentReferenceWithoutBlockUpdateInput"] | undefined | null
};
	["ContentReferenceWithoutBlockUpdateInput"]: {
	type?: ValueTypes["ContentReferenceType"] | undefined | null,
	primaryText?: string | undefined | null,
	secondaryText?: string | undefined | null,
	jsonContent?: string | undefined | null,
	colorPallete?: ValueTypes["ContentReferenceUpdateColorPalleteEntityRelationInput"] | undefined | null,
	medium?: ValueTypes["ContentReferenceUpdateMediumEntityRelationInput"] | undefined | null,
	link?: ValueTypes["ContentReferenceUpdateLinkEntityRelationInput"] | undefined | null,
	blogPosts?: ValueTypes["ContentReferenceUpdateBlogPostsEntityRelationInput"] | undefined | null,
	links?: ValueTypes["ContentReferenceUpdateLinksEntityRelationInput"] | undefined | null,
	products?: ValueTypes["ContentReferenceUpdateProductsEntityRelationInput"] | undefined | null,
	contentSize?: ValueTypes["ContentSize"] | undefined | null,
	misc?: string | undefined | null,
	hero?: ValueTypes["ContentReferenceUpdateHeroEntityRelationInput"] | undefined | null,
	gallery?: ValueTypes["ContentReferenceUpdateGalleryEntityRelationInput"] | undefined | null,
	socialsAndApps?: ValueTypes["ContentReferenceUpdateSocialsAndAppsEntityRelationInput"] | undefined | null,
	productGrid?: ValueTypes["ContentReferenceUpdateProductGridEntityRelationInput"] | undefined | null,
	productBanners?: ValueTypes["ContentReferenceUpdateProductBannersEntityRelationInput"] | undefined | null,
	deliveryRegions?: ValueTypes["ContentReferenceUpdateDeliveryRegionsEntityRelationInput"] | undefined | null,
	textList?: ValueTypes["ContentReferenceUpdateTextListEntityRelationInput"] | undefined | null,
	gridTiles?: ValueTypes["ContentReferenceUpdateGridTilesEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentReferenceUpdateColorPalleteEntityRelationInput"]: {
	create?: ValueTypes["ColorPalleteCreateInput"] | undefined | null,
	update?: ValueTypes["ColorPalleteUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ContentReferenceUpsertColorPalleteRelationInput"] | undefined | null,
	connect?: ValueTypes["ColorPalleteUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ContentReferenceUpsertColorPalleteRelationInput"]: {
	update?: ValueTypes["ColorPalleteUpdateInput"] | undefined | null,
	create?: ValueTypes["ColorPalleteCreateInput"] | undefined | null
};
	["ContentReferenceUpdateMediumEntityRelationInput"]: {
	create?: ValueTypes["MediumCreateInput"] | undefined | null,
	update?: ValueTypes["MediumUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ContentReferenceUpsertMediumRelationInput"] | undefined | null,
	connect?: ValueTypes["MediumUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ContentReferenceUpsertMediumRelationInput"]: {
	update?: ValueTypes["MediumUpdateInput"] | undefined | null,
	create?: ValueTypes["MediumCreateInput"] | undefined | null
};
	["ContentReferenceUpdateLinkEntityRelationInput"]: {
	create?: ValueTypes["LinkCreateInput"] | undefined | null,
	update?: ValueTypes["LinkUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ContentReferenceUpsertLinkRelationInput"] | undefined | null,
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["LinkUpdateInput"]: {
	type?: ValueTypes["LinkType"] | undefined | null,
	title?: string | undefined | null,
	externalLink?: string | undefined | null,
	internalLink?: ValueTypes["LinkUpdateInternalLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkUpdateInternalLinkEntityRelationInput"]: {
	create?: ValueTypes["LinkableCreateInput"] | undefined | null,
	update?: ValueTypes["LinkableUpdateInput"] | undefined | null,
	upsert?: ValueTypes["LinkUpsertInternalLinkRelationInput"] | undefined | null,
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["LinkableUpdateInput"]: {
	url?: string | undefined | null,
	blogPost?: ValueTypes["LinkableUpdateBlogPostEntityRelationInput"] | undefined | null,
	page?: ValueTypes["LinkableUpdatePageEntityRelationInput"] | undefined | null,
	wikiPage?: ValueTypes["LinkableUpdateWikiPageEntityRelationInput"] | undefined | null,
	redirect?: ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkableUpdateBlogPostEntityRelationInput"]: {
	create?: ValueTypes["BlogPostLocaleWithoutLinkCreateInput"] | undefined | null,
	update?: ValueTypes["BlogPostLocaleWithoutLinkUpdateInput"] | undefined | null,
	upsert?: ValueTypes["LinkableUpsertBlogPostRelationInput"] | undefined | null,
	connect?: ValueTypes["BlogPostLocaleUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["BlogPostLocaleWithoutLinkUpdateInput"]: {
	title?: string | undefined | null,
	availableForWeb?: boolean | undefined | null,
	availableForMobile?: boolean | undefined | null,
	root?: ValueTypes["BlogPostLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["BlogPostLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	cover?: ValueTypes["BlogPostLocaleUpdateCoverEntityRelationInput"] | undefined | null,
	content?: ValueTypes["BlogPostLocaleUpdateContentEntityRelationInput"] | undefined | null,
	seo?: ValueTypes["BlogPostLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	products?: Array<ValueTypes["BlogPostLocaleUpdateProductsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BlogPostLocaleUpdateLocaleEntityRelationInput"]: {
	create?: ValueTypes["LocaleWithoutBlogPostsCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleWithoutBlogPostsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["BlogPostLocaleUpsertLocaleRelationInput"] | undefined | null,
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutBlogPostsUpdateInput"]: {
	businessCategories?: Array<ValueTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleUpdateIdentifierEntityRelationInput"]: {
	create?: ValueTypes["TranslationCataloguesIdentifierCreateInput"] | undefined | null,
	update?: ValueTypes["TranslationCataloguesIdentifierUpdateInput"] | undefined | null,
	upsert?: ValueTypes["LocaleUpsertIdentifierRelationInput"] | undefined | null,
	connect?: ValueTypes["TranslationCataloguesIdentifierUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["TranslationCataloguesIdentifierUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	catalogue?: Array<ValueTypes["TranslationCataloguesIdentifierUpdateCatalogueEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationCataloguesIdentifierUpdateCatalogueEntityRelationInput"]: {
	create?: ValueTypes["TranslationCatalogueWithoutIdentifierCreateInput"] | undefined | null,
	update?: ValueTypes["TranslationCataloguesIdentifierUpdateCatalogueRelationInput"] | undefined | null,
	upsert?: ValueTypes["TranslationCataloguesIdentifierUpsertCatalogueRelationInput"] | undefined | null,
	connect?: ValueTypes["TranslationCatalogueUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["TranslationCatalogueUniqueWhere"] | undefined | null,
	delete?: ValueTypes["TranslationCatalogueUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["TranslationCataloguesIdentifierUpdateCatalogueRelationInput"]: {
	by?: ValueTypes["TranslationCatalogueUniqueWhere"] | undefined | null,
	data?: ValueTypes["TranslationCatalogueWithoutIdentifierUpdateInput"] | undefined | null
};
	["TranslationCatalogueWithoutIdentifierUpdateInput"]: {
	domain?: ValueTypes["TranslationCatalogueUpdateDomainEntityRelationInput"] | undefined | null,
	fallback?: ValueTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"] | undefined | null,
	values?: Array<ValueTypes["TranslationCatalogueUpdateValuesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationCatalogueUpdateDomainEntityRelationInput"]: {
	create?: ValueTypes["TranslationDomainWithoutCataloguesCreateInput"] | undefined | null,
	update?: ValueTypes["TranslationDomainWithoutCataloguesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["TranslationCatalogueUpsertDomainRelationInput"] | undefined | null,
	connect?: ValueTypes["TranslationDomainUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["TranslationDomainWithoutCataloguesUpdateInput"]: {
	identifier?: string | undefined | null,
	name?: string | undefined | null,
	keys?: Array<ValueTypes["TranslationDomainUpdateKeysEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationDomainUpdateKeysEntityRelationInput"]: {
	create?: ValueTypes["TranslationKeyWithoutDomainCreateInput"] | undefined | null,
	update?: ValueTypes["TranslationDomainUpdateKeysRelationInput"] | undefined | null,
	upsert?: ValueTypes["TranslationDomainUpsertKeysRelationInput"] | undefined | null,
	connect?: ValueTypes["TranslationKeyUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["TranslationKeyUniqueWhere"] | undefined | null,
	delete?: ValueTypes["TranslationKeyUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["TranslationDomainUpdateKeysRelationInput"]: {
	by?: ValueTypes["TranslationKeyUniqueWhere"] | undefined | null,
	data?: ValueTypes["TranslationKeyWithoutDomainUpdateInput"] | undefined | null
};
	["TranslationKeyWithoutDomainUpdateInput"]: {
	identifier?: string | undefined | null,
	contentType?: ValueTypes["TranslationContentType"] | undefined | null,
	note?: string | undefined | null,
	values?: Array<ValueTypes["TranslationKeyUpdateValuesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationKeyUpdateValuesEntityRelationInput"]: {
	create?: ValueTypes["TranslationValueWithoutKeyCreateInput"] | undefined | null,
	update?: ValueTypes["TranslationKeyUpdateValuesRelationInput"] | undefined | null,
	upsert?: ValueTypes["TranslationKeyUpsertValuesRelationInput"] | undefined | null,
	connect?: ValueTypes["TranslationValueUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["TranslationValueUniqueWhere"] | undefined | null,
	delete?: ValueTypes["TranslationValueUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["TranslationKeyUpdateValuesRelationInput"]: {
	by?: ValueTypes["TranslationValueUniqueWhere"] | undefined | null,
	data?: ValueTypes["TranslationValueWithoutKeyUpdateInput"] | undefined | null
};
	["TranslationValueWithoutKeyUpdateInput"]: {
	value?: string | undefined | null,
	catalogue?: ValueTypes["TranslationValueUpdateCatalogueEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationValueUpdateCatalogueEntityRelationInput"]: {
	create?: ValueTypes["TranslationCatalogueWithoutValuesCreateInput"] | undefined | null,
	update?: ValueTypes["TranslationCatalogueWithoutValuesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["TranslationValueUpsertCatalogueRelationInput"] | undefined | null,
	connect?: ValueTypes["TranslationCatalogueUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["TranslationCatalogueWithoutValuesUpdateInput"]: {
	domain?: ValueTypes["TranslationCatalogueUpdateDomainEntityRelationInput"] | undefined | null,
	fallback?: ValueTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"] | undefined | null,
	identifier?: ValueTypes["TranslationCatalogueUpdateIdentifierEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationCatalogueUpdateFallbackEntityRelationInput"]: {
	create?: ValueTypes["TranslationCatalogueCreateInput"] | undefined | null,
	update?: ValueTypes["TranslationCatalogueUpdateInput"] | undefined | null,
	upsert?: ValueTypes["TranslationCatalogueUpsertFallbackRelationInput"] | undefined | null,
	connect?: ValueTypes["TranslationCatalogueUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["TranslationCatalogueUpdateInput"]: {
	domain?: ValueTypes["TranslationCatalogueUpdateDomainEntityRelationInput"] | undefined | null,
	fallback?: ValueTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"] | undefined | null,
	values?: Array<ValueTypes["TranslationCatalogueUpdateValuesEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["TranslationCatalogueUpdateIdentifierEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationCatalogueUpdateValuesEntityRelationInput"]: {
	create?: ValueTypes["TranslationValueWithoutCatalogueCreateInput"] | undefined | null,
	update?: ValueTypes["TranslationCatalogueUpdateValuesRelationInput"] | undefined | null,
	upsert?: ValueTypes["TranslationCatalogueUpsertValuesRelationInput"] | undefined | null,
	connect?: ValueTypes["TranslationValueUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["TranslationValueUniqueWhere"] | undefined | null,
	delete?: ValueTypes["TranslationValueUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["TranslationCatalogueUpdateValuesRelationInput"]: {
	by?: ValueTypes["TranslationValueUniqueWhere"] | undefined | null,
	data?: ValueTypes["TranslationValueWithoutCatalogueUpdateInput"] | undefined | null
};
	["TranslationValueWithoutCatalogueUpdateInput"]: {
	value?: string | undefined | null,
	key?: ValueTypes["TranslationValueUpdateKeyEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationValueUpdateKeyEntityRelationInput"]: {
	create?: ValueTypes["TranslationKeyWithoutValuesCreateInput"] | undefined | null,
	update?: ValueTypes["TranslationKeyWithoutValuesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["TranslationValueUpsertKeyRelationInput"] | undefined | null,
	connect?: ValueTypes["TranslationKeyUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["TranslationKeyWithoutValuesUpdateInput"]: {
	identifier?: string | undefined | null,
	contentType?: ValueTypes["TranslationContentType"] | undefined | null,
	note?: string | undefined | null,
	domain?: ValueTypes["TranslationKeyUpdateDomainEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationKeyUpdateDomainEntityRelationInput"]: {
	create?: ValueTypes["TranslationDomainWithoutKeysCreateInput"] | undefined | null,
	update?: ValueTypes["TranslationDomainWithoutKeysUpdateInput"] | undefined | null,
	upsert?: ValueTypes["TranslationKeyUpsertDomainRelationInput"] | undefined | null,
	connect?: ValueTypes["TranslationDomainUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["TranslationDomainWithoutKeysUpdateInput"]: {
	identifier?: string | undefined | null,
	name?: string | undefined | null,
	catalogues?: Array<ValueTypes["TranslationDomainUpdateCataloguesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationDomainUpdateCataloguesEntityRelationInput"]: {
	create?: ValueTypes["TranslationCatalogueWithoutDomainCreateInput"] | undefined | null,
	update?: ValueTypes["TranslationDomainUpdateCataloguesRelationInput"] | undefined | null,
	upsert?: ValueTypes["TranslationDomainUpsertCataloguesRelationInput"] | undefined | null,
	connect?: ValueTypes["TranslationCatalogueUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["TranslationCatalogueUniqueWhere"] | undefined | null,
	delete?: ValueTypes["TranslationCatalogueUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["TranslationDomainUpdateCataloguesRelationInput"]: {
	by?: ValueTypes["TranslationCatalogueUniqueWhere"] | undefined | null,
	data?: ValueTypes["TranslationCatalogueWithoutDomainUpdateInput"] | undefined | null
};
	["TranslationCatalogueWithoutDomainUpdateInput"]: {
	fallback?: ValueTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"] | undefined | null,
	values?: Array<ValueTypes["TranslationCatalogueUpdateValuesEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["TranslationCatalogueUpdateIdentifierEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationCatalogueUpdateIdentifierEntityRelationInput"]: {
	create?: ValueTypes["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"] | undefined | null,
	update?: ValueTypes["TranslationCataloguesIdentifierWithoutCatalogueUpdateInput"] | undefined | null,
	upsert?: ValueTypes["TranslationCatalogueUpsertIdentifierRelationInput"] | undefined | null,
	connect?: ValueTypes["TranslationCataloguesIdentifierUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["TranslationCataloguesIdentifierWithoutCatalogueUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationCatalogueUpsertIdentifierRelationInput"]: {
	update?: ValueTypes["TranslationCataloguesIdentifierWithoutCatalogueUpdateInput"] | undefined | null,
	create?: ValueTypes["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"] | undefined | null
};
	["TranslationDomainUpsertCataloguesRelationInput"]: {
	by?: ValueTypes["TranslationCatalogueUniqueWhere"] | undefined | null,
	update?: ValueTypes["TranslationCatalogueWithoutDomainUpdateInput"] | undefined | null,
	create?: ValueTypes["TranslationCatalogueWithoutDomainCreateInput"] | undefined | null
};
	["TranslationKeyUpsertDomainRelationInput"]: {
	update?: ValueTypes["TranslationDomainWithoutKeysUpdateInput"] | undefined | null,
	create?: ValueTypes["TranslationDomainWithoutKeysCreateInput"] | undefined | null
};
	["TranslationValueUpsertKeyRelationInput"]: {
	update?: ValueTypes["TranslationKeyWithoutValuesUpdateInput"] | undefined | null,
	create?: ValueTypes["TranslationKeyWithoutValuesCreateInput"] | undefined | null
};
	["TranslationCatalogueUpsertValuesRelationInput"]: {
	by?: ValueTypes["TranslationValueUniqueWhere"] | undefined | null,
	update?: ValueTypes["TranslationValueWithoutCatalogueUpdateInput"] | undefined | null,
	create?: ValueTypes["TranslationValueWithoutCatalogueCreateInput"] | undefined | null
};
	["TranslationCatalogueUpsertFallbackRelationInput"]: {
	update?: ValueTypes["TranslationCatalogueUpdateInput"] | undefined | null,
	create?: ValueTypes["TranslationCatalogueCreateInput"] | undefined | null
};
	["TranslationValueUpsertCatalogueRelationInput"]: {
	update?: ValueTypes["TranslationCatalogueWithoutValuesUpdateInput"] | undefined | null,
	create?: ValueTypes["TranslationCatalogueWithoutValuesCreateInput"] | undefined | null
};
	["TranslationKeyUpsertValuesRelationInput"]: {
	by?: ValueTypes["TranslationValueUniqueWhere"] | undefined | null,
	update?: ValueTypes["TranslationValueWithoutKeyUpdateInput"] | undefined | null,
	create?: ValueTypes["TranslationValueWithoutKeyCreateInput"] | undefined | null
};
	["TranslationDomainUpsertKeysRelationInput"]: {
	by?: ValueTypes["TranslationKeyUniqueWhere"] | undefined | null,
	update?: ValueTypes["TranslationKeyWithoutDomainUpdateInput"] | undefined | null,
	create?: ValueTypes["TranslationKeyWithoutDomainCreateInput"] | undefined | null
};
	["TranslationCatalogueUpsertDomainRelationInput"]: {
	update?: ValueTypes["TranslationDomainWithoutCataloguesUpdateInput"] | undefined | null,
	create?: ValueTypes["TranslationDomainWithoutCataloguesCreateInput"] | undefined | null
};
	["TranslationCataloguesIdentifierUpsertCatalogueRelationInput"]: {
	by?: ValueTypes["TranslationCatalogueUniqueWhere"] | undefined | null,
	update?: ValueTypes["TranslationCatalogueWithoutIdentifierUpdateInput"] | undefined | null,
	create?: ValueTypes["TranslationCatalogueWithoutIdentifierCreateInput"] | undefined | null
};
	["LocaleUpsertIdentifierRelationInput"]: {
	update?: ValueTypes["TranslationCataloguesIdentifierUpdateInput"] | undefined | null,
	create?: ValueTypes["TranslationCataloguesIdentifierCreateInput"] | undefined | null
};
	["LocaleUpdateMenusEntityRelationInput"]: {
	create?: ValueTypes["MenuLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleUpdateMenusRelationInput"] | undefined | null,
	upsert?: ValueTypes["LocaleUpsertMenusRelationInput"] | undefined | null,
	connect?: ValueTypes["MenuLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["MenuLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["MenuLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateMenusRelationInput"]: {
	by?: ValueTypes["MenuLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["MenuLocaleWithoutLocaleUpdateInput"] | undefined | null
};
	["MenuLocaleWithoutLocaleUpdateInput"]: {
	root?: ValueTypes["MenuLocaleUpdateRootEntityRelationInput"] | undefined | null,
	items?: Array<ValueTypes["MenuLocaleUpdateItemsEntityRelationInput"]> | undefined | null,
	secondaryItems?: ValueTypes["MenuLocaleUpdateSecondaryItemsEntityRelationInput"] | undefined | null,
	eshopLink?: ValueTypes["MenuLocaleUpdateEshopLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MenuLocaleUpdateRootEntityRelationInput"]: {
	create?: ValueTypes["SiteMenuWithoutLocalesCreateInput"] | undefined | null,
	update?: ValueTypes["SiteMenuWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["MenuLocaleUpsertRootRelationInput"] | undefined | null,
	connect?: ValueTypes["SiteMenuUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["SiteMenuWithoutLocalesUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MenuLocaleUpsertRootRelationInput"]: {
	update?: ValueTypes["SiteMenuWithoutLocalesUpdateInput"] | undefined | null,
	create?: ValueTypes["SiteMenuWithoutLocalesCreateInput"] | undefined | null
};
	["MenuLocaleUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["MenuItemWithoutMenuCreateInput"] | undefined | null,
	update?: ValueTypes["MenuLocaleUpdateItemsRelationInput"] | undefined | null,
	upsert?: ValueTypes["MenuLocaleUpsertItemsRelationInput"] | undefined | null,
	connect?: ValueTypes["MenuItemUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["MenuItemUniqueWhere"] | undefined | null,
	delete?: ValueTypes["MenuItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["MenuLocaleUpdateItemsRelationInput"]: {
	by?: ValueTypes["MenuItemUniqueWhere"] | undefined | null,
	data?: ValueTypes["MenuItemWithoutMenuUpdateInput"] | undefined | null
};
	["MenuItemWithoutMenuUpdateInput"]: {
	order?: number | undefined | null,
	link?: ValueTypes["MenuItemUpdateLinkEntityRelationInput"] | undefined | null,
	subitems?: Array<ValueTypes["MenuItemUpdateSubitemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MenuItemUpdateLinkEntityRelationInput"]: {
	create?: ValueTypes["LinkCreateInput"] | undefined | null,
	update?: ValueTypes["LinkUpdateInput"] | undefined | null,
	upsert?: ValueTypes["MenuItemUpsertLinkRelationInput"] | undefined | null,
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["MenuItemUpsertLinkRelationInput"]: {
	update?: ValueTypes["LinkUpdateInput"] | undefined | null,
	create?: ValueTypes["LinkCreateInput"] | undefined | null
};
	["MenuItemUpdateSubitemsEntityRelationInput"]: {
	create?: ValueTypes["MenuSubitemWithoutItemCreateInput"] | undefined | null,
	update?: ValueTypes["MenuItemUpdateSubitemsRelationInput"] | undefined | null,
	upsert?: ValueTypes["MenuItemUpsertSubitemsRelationInput"] | undefined | null,
	connect?: ValueTypes["MenuSubitemUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["MenuSubitemUniqueWhere"] | undefined | null,
	delete?: ValueTypes["MenuSubitemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["MenuItemUpdateSubitemsRelationInput"]: {
	by?: ValueTypes["MenuSubitemUniqueWhere"] | undefined | null,
	data?: ValueTypes["MenuSubitemWithoutItemUpdateInput"] | undefined | null
};
	["MenuSubitemWithoutItemUpdateInput"]: {
	type?: ValueTypes["MenuSubitemType"] | undefined | null,
	title?: string | undefined | null,
	links?: ValueTypes["MenuSubitemUpdateLinksEntityRelationInput"] | undefined | null,
	products?: ValueTypes["MenuSubitemUpdateProductsEntityRelationInput"] | undefined | null,
	delivery?: ValueTypes["MenuSubitemUpdateDeliveryEntityRelationInput"] | undefined | null,
	contact?: ValueTypes["MenuSubitemUpdateContactEntityRelationInput"] | undefined | null,
	order?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MenuSubitemUpdateLinksEntityRelationInput"]: {
	create?: ValueTypes["MenuLinkListCreateInput"] | undefined | null,
	update?: ValueTypes["MenuLinkListUpdateInput"] | undefined | null,
	upsert?: ValueTypes["MenuSubitemUpsertLinksRelationInput"] | undefined | null,
	connect?: ValueTypes["MenuLinkListUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["MenuLinkListUpdateInput"]: {
	items?: Array<ValueTypes["MenuLinkListUpdateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MenuLinkListUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["MenuLinkItemWithoutListCreateInput"] | undefined | null,
	update?: ValueTypes["MenuLinkListUpdateItemsRelationInput"] | undefined | null,
	upsert?: ValueTypes["MenuLinkListUpsertItemsRelationInput"] | undefined | null,
	connect?: ValueTypes["MenuLinkItemUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["MenuLinkItemUniqueWhere"] | undefined | null,
	delete?: ValueTypes["MenuLinkItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["MenuLinkListUpdateItemsRelationInput"]: {
	by?: ValueTypes["MenuLinkItemUniqueWhere"] | undefined | null,
	data?: ValueTypes["MenuLinkItemWithoutListUpdateInput"] | undefined | null
};
	["MenuLinkItemWithoutListUpdateInput"]: {
	order?: number | undefined | null,
	link?: ValueTypes["MenuLinkItemUpdateLinkEntityRelationInput"] | undefined | null,
	image?: ValueTypes["MenuLinkItemUpdateImageEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MenuLinkItemUpdateLinkEntityRelationInput"]: {
	create?: ValueTypes["LinkCreateInput"] | undefined | null,
	update?: ValueTypes["LinkUpdateInput"] | undefined | null,
	upsert?: ValueTypes["MenuLinkItemUpsertLinkRelationInput"] | undefined | null,
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["MenuLinkItemUpsertLinkRelationInput"]: {
	update?: ValueTypes["LinkUpdateInput"] | undefined | null,
	create?: ValueTypes["LinkCreateInput"] | undefined | null
};
	["MenuLinkItemUpdateImageEntityRelationInput"]: {
	create?: ValueTypes["ImageCreateInput"] | undefined | null,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ValueTypes["MenuLinkItemUpsertImageRelationInput"] | undefined | null,
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["MenuLinkItemUpsertImageRelationInput"]: {
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["MenuLinkListUpsertItemsRelationInput"]: {
	by?: ValueTypes["MenuLinkItemUniqueWhere"] | undefined | null,
	update?: ValueTypes["MenuLinkItemWithoutListUpdateInput"] | undefined | null,
	create?: ValueTypes["MenuLinkItemWithoutListCreateInput"] | undefined | null
};
	["MenuSubitemUpsertLinksRelationInput"]: {
	update?: ValueTypes["MenuLinkListUpdateInput"] | undefined | null,
	create?: ValueTypes["MenuLinkListCreateInput"] | undefined | null
};
	["MenuSubitemUpdateProductsEntityRelationInput"]: {
	create?: ValueTypes["MenuProductsCreateInput"] | undefined | null,
	update?: ValueTypes["MenuProductsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["MenuSubitemUpsertProductsRelationInput"] | undefined | null,
	connect?: ValueTypes["MenuProductsUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["MenuProductsUpdateInput"]: {
	links?: ValueTypes["MenuProductsUpdateLinksEntityRelationInput"] | undefined | null,
	buttons?: ValueTypes["MenuProductsUpdateButtonsEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MenuProductsUpdateLinksEntityRelationInput"]: {
	create?: ValueTypes["MenuLinkListCreateInput"] | undefined | null,
	update?: ValueTypes["MenuLinkListUpdateInput"] | undefined | null,
	upsert?: ValueTypes["MenuProductsUpsertLinksRelationInput"] | undefined | null,
	connect?: ValueTypes["MenuLinkListUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["MenuProductsUpsertLinksRelationInput"]: {
	update?: ValueTypes["MenuLinkListUpdateInput"] | undefined | null,
	create?: ValueTypes["MenuLinkListCreateInput"] | undefined | null
};
	["MenuProductsUpdateButtonsEntityRelationInput"]: {
	create?: ValueTypes["LinkListCreateInput"] | undefined | null,
	update?: ValueTypes["LinkListUpdateInput"] | undefined | null,
	upsert?: ValueTypes["MenuProductsUpsertButtonsRelationInput"] | undefined | null,
	connect?: ValueTypes["LinkListUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["LinkListUpdateInput"]: {
	items?: Array<ValueTypes["LinkListUpdateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkListUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["LinkListItemWithoutListCreateInput"] | undefined | null,
	update?: ValueTypes["LinkListUpdateItemsRelationInput"] | undefined | null,
	upsert?: ValueTypes["LinkListUpsertItemsRelationInput"] | undefined | null,
	connect?: ValueTypes["LinkListItemUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["LinkListItemUniqueWhere"] | undefined | null,
	delete?: ValueTypes["LinkListItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LinkListUpdateItemsRelationInput"]: {
	by?: ValueTypes["LinkListItemUniqueWhere"] | undefined | null,
	data?: ValueTypes["LinkListItemWithoutListUpdateInput"] | undefined | null
};
	["LinkListItemWithoutListUpdateInput"]: {
	order?: number | undefined | null,
	isPrimary?: boolean | undefined | null,
	link?: ValueTypes["LinkListItemUpdateLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkListItemUpdateLinkEntityRelationInput"]: {
	create?: ValueTypes["LinkCreateInput"] | undefined | null,
	update?: ValueTypes["LinkUpdateInput"] | undefined | null,
	upsert?: ValueTypes["LinkListItemUpsertLinkRelationInput"] | undefined | null,
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["LinkListItemUpsertLinkRelationInput"]: {
	update?: ValueTypes["LinkUpdateInput"] | undefined | null,
	create?: ValueTypes["LinkCreateInput"] | undefined | null
};
	["LinkListUpsertItemsRelationInput"]: {
	by?: ValueTypes["LinkListItemUniqueWhere"] | undefined | null,
	update?: ValueTypes["LinkListItemWithoutListUpdateInput"] | undefined | null,
	create?: ValueTypes["LinkListItemWithoutListCreateInput"] | undefined | null
};
	["MenuProductsUpsertButtonsRelationInput"]: {
	update?: ValueTypes["LinkListUpdateInput"] | undefined | null,
	create?: ValueTypes["LinkListCreateInput"] | undefined | null
};
	["MenuSubitemUpsertProductsRelationInput"]: {
	update?: ValueTypes["MenuProductsUpdateInput"] | undefined | null,
	create?: ValueTypes["MenuProductsCreateInput"] | undefined | null
};
	["MenuSubitemUpdateDeliveryEntityRelationInput"]: {
	create?: ValueTypes["MenuDeliveryCreateInput"] | undefined | null,
	update?: ValueTypes["MenuDeliveryUpdateInput"] | undefined | null,
	upsert?: ValueTypes["MenuSubitemUpsertDeliveryRelationInput"] | undefined | null,
	connect?: ValueTypes["MenuDeliveryUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["MenuDeliveryUpdateInput"]: {
	deliveryRegions?: ValueTypes["MenuDeliveryUpdateDeliveryRegionsEntityRelationInput"] | undefined | null,
	text?: string | undefined | null,
	socialsAndApps?: ValueTypes["MenuDeliveryUpdateSocialsAndAppsEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MenuDeliveryUpdateDeliveryRegionsEntityRelationInput"]: {
	create?: ValueTypes["DeliveryRegionsCreateInput"] | undefined | null,
	update?: ValueTypes["DeliveryRegionsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["MenuDeliveryUpsertDeliveryRegionsRelationInput"] | undefined | null,
	connect?: ValueTypes["DeliveryRegionsUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["DeliveryRegionsUpdateInput"]: {
	items?: Array<ValueTypes["DeliveryRegionsUpdateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryRegionsUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["DeliveryRegionsItemWithoutListCreateInput"] | undefined | null,
	update?: ValueTypes["DeliveryRegionsUpdateItemsRelationInput"] | undefined | null,
	upsert?: ValueTypes["DeliveryRegionsUpsertItemsRelationInput"] | undefined | null,
	connect?: ValueTypes["DeliveryRegionsItemUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["DeliveryRegionsItemUniqueWhere"] | undefined | null,
	delete?: ValueTypes["DeliveryRegionsItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["DeliveryRegionsUpdateItemsRelationInput"]: {
	by?: ValueTypes["DeliveryRegionsItemUniqueWhere"] | undefined | null,
	data?: ValueTypes["DeliveryRegionsItemWithoutListUpdateInput"] | undefined | null
};
	["DeliveryRegionsItemWithoutListUpdateInput"]: {
	order?: number | undefined | null,
	title?: string | undefined | null,
	offerLabel?: string | undefined | null,
	image?: ValueTypes["DeliveryRegionsItemUpdateImageEntityRelationInput"] | undefined | null,
	textList?: ValueTypes["DeliveryRegionsItemUpdateTextListEntityRelationInput"] | undefined | null,
	gallery?: ValueTypes["DeliveryRegionsItemUpdateGalleryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryRegionsItemUpdateImageEntityRelationInput"]: {
	create?: ValueTypes["ImageCreateInput"] | undefined | null,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ValueTypes["DeliveryRegionsItemUpsertImageRelationInput"] | undefined | null,
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["DeliveryRegionsItemUpsertImageRelationInput"]: {
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["DeliveryRegionsItemUpdateTextListEntityRelationInput"]: {
	create?: ValueTypes["TextListCreateInput"] | undefined | null,
	update?: ValueTypes["TextListUpdateInput"] | undefined | null,
	upsert?: ValueTypes["DeliveryRegionsItemUpsertTextListRelationInput"] | undefined | null,
	connect?: ValueTypes["TextListUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["TextListUpdateInput"]: {
	items?: Array<ValueTypes["TextListUpdateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TextListUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["TextItemWithoutListCreateInput"] | undefined | null,
	update?: ValueTypes["TextListUpdateItemsRelationInput"] | undefined | null,
	upsert?: ValueTypes["TextListUpsertItemsRelationInput"] | undefined | null,
	connect?: ValueTypes["TextItemUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["TextItemUniqueWhere"] | undefined | null,
	delete?: ValueTypes["TextItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["TextListUpdateItemsRelationInput"]: {
	by?: ValueTypes["TextItemUniqueWhere"] | undefined | null,
	data?: ValueTypes["TextItemWithoutListUpdateInput"] | undefined | null
};
	["TextItemWithoutListUpdateInput"]: {
	order?: number | undefined | null,
	text?: string | undefined | null,
	title?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TextListUpsertItemsRelationInput"]: {
	by?: ValueTypes["TextItemUniqueWhere"] | undefined | null,
	update?: ValueTypes["TextItemWithoutListUpdateInput"] | undefined | null,
	create?: ValueTypes["TextItemWithoutListCreateInput"] | undefined | null
};
	["DeliveryRegionsItemUpsertTextListRelationInput"]: {
	update?: ValueTypes["TextListUpdateInput"] | undefined | null,
	create?: ValueTypes["TextListCreateInput"] | undefined | null
};
	["DeliveryRegionsItemUpdateGalleryEntityRelationInput"]: {
	create?: ValueTypes["ImageListCreateInput"] | undefined | null,
	update?: ValueTypes["ImageListUpdateInput"] | undefined | null,
	upsert?: ValueTypes["DeliveryRegionsItemUpsertGalleryRelationInput"] | undefined | null,
	connect?: ValueTypes["ImageListUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ImageListUpdateInput"]: {
	items?: Array<ValueTypes["ImageListUpdateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ImageListUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["ImageListItemWithoutListCreateInput"] | undefined | null,
	update?: ValueTypes["ImageListUpdateItemsRelationInput"] | undefined | null,
	upsert?: ValueTypes["ImageListUpsertItemsRelationInput"] | undefined | null,
	connect?: ValueTypes["ImageListItemUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ImageListItemUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ImageListItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ImageListUpdateItemsRelationInput"]: {
	by?: ValueTypes["ImageListItemUniqueWhere"] | undefined | null,
	data?: ValueTypes["ImageListItemWithoutListUpdateInput"] | undefined | null
};
	["ImageListItemWithoutListUpdateInput"]: {
	order?: number | undefined | null,
	image?: ValueTypes["ImageListItemUpdateImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ImageListItemUpdateImageEntityRelationInput"]: {
	create?: ValueTypes["ImageCreateInput"] | undefined | null,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ImageListItemUpsertImageRelationInput"] | undefined | null,
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ImageListItemUpsertImageRelationInput"]: {
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["ImageListUpsertItemsRelationInput"]: {
	by?: ValueTypes["ImageListItemUniqueWhere"] | undefined | null,
	update?: ValueTypes["ImageListItemWithoutListUpdateInput"] | undefined | null,
	create?: ValueTypes["ImageListItemWithoutListCreateInput"] | undefined | null
};
	["DeliveryRegionsItemUpsertGalleryRelationInput"]: {
	update?: ValueTypes["ImageListUpdateInput"] | undefined | null,
	create?: ValueTypes["ImageListCreateInput"] | undefined | null
};
	["DeliveryRegionsUpsertItemsRelationInput"]: {
	by?: ValueTypes["DeliveryRegionsItemUniqueWhere"] | undefined | null,
	update?: ValueTypes["DeliveryRegionsItemWithoutListUpdateInput"] | undefined | null,
	create?: ValueTypes["DeliveryRegionsItemWithoutListCreateInput"] | undefined | null
};
	["MenuDeliveryUpsertDeliveryRegionsRelationInput"]: {
	update?: ValueTypes["DeliveryRegionsUpdateInput"] | undefined | null,
	create?: ValueTypes["DeliveryRegionsCreateInput"] | undefined | null
};
	["MenuDeliveryUpdateSocialsAndAppsEntityRelationInput"]: {
	create?: ValueTypes["SocialsAndAppsCreateInput"] | undefined | null,
	update?: ValueTypes["SocialsAndAppsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["MenuDeliveryUpsertSocialsAndAppsRelationInput"] | undefined | null,
	connect?: ValueTypes["SocialsAndAppsUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["SocialsAndAppsUpdateInput"]: {
	instagram?: boolean | undefined | null,
	appStore?: boolean | undefined | null,
	googlePlay?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MenuDeliveryUpsertSocialsAndAppsRelationInput"]: {
	update?: ValueTypes["SocialsAndAppsUpdateInput"] | undefined | null,
	create?: ValueTypes["SocialsAndAppsCreateInput"] | undefined | null
};
	["MenuSubitemUpsertDeliveryRelationInput"]: {
	update?: ValueTypes["MenuDeliveryUpdateInput"] | undefined | null,
	create?: ValueTypes["MenuDeliveryCreateInput"] | undefined | null
};
	["MenuSubitemUpdateContactEntityRelationInput"]: {
	create?: ValueTypes["MenuContactCreateInput"] | undefined | null,
	update?: ValueTypes["MenuContactUpdateInput"] | undefined | null,
	upsert?: ValueTypes["MenuSubitemUpsertContactRelationInput"] | undefined | null,
	connect?: ValueTypes["MenuContactUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["MenuContactUpdateInput"]: {
	text?: string | undefined | null,
	image?: ValueTypes["MenuContactUpdateImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MenuContactUpdateImageEntityRelationInput"]: {
	create?: ValueTypes["ImageCreateInput"] | undefined | null,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ValueTypes["MenuContactUpsertImageRelationInput"] | undefined | null,
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["MenuContactUpsertImageRelationInput"]: {
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["MenuSubitemUpsertContactRelationInput"]: {
	update?: ValueTypes["MenuContactUpdateInput"] | undefined | null,
	create?: ValueTypes["MenuContactCreateInput"] | undefined | null
};
	["MenuItemUpsertSubitemsRelationInput"]: {
	by?: ValueTypes["MenuSubitemUniqueWhere"] | undefined | null,
	update?: ValueTypes["MenuSubitemWithoutItemUpdateInput"] | undefined | null,
	create?: ValueTypes["MenuSubitemWithoutItemCreateInput"] | undefined | null
};
	["MenuLocaleUpsertItemsRelationInput"]: {
	by?: ValueTypes["MenuItemUniqueWhere"] | undefined | null,
	update?: ValueTypes["MenuItemWithoutMenuUpdateInput"] | undefined | null,
	create?: ValueTypes["MenuItemWithoutMenuCreateInput"] | undefined | null
};
	["MenuLocaleUpdateSecondaryItemsEntityRelationInput"]: {
	create?: ValueTypes["LinkListCreateInput"] | undefined | null,
	update?: ValueTypes["LinkListUpdateInput"] | undefined | null,
	upsert?: ValueTypes["MenuLocaleUpsertSecondaryItemsRelationInput"] | undefined | null,
	connect?: ValueTypes["LinkListUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["MenuLocaleUpsertSecondaryItemsRelationInput"]: {
	update?: ValueTypes["LinkListUpdateInput"] | undefined | null,
	create?: ValueTypes["LinkListCreateInput"] | undefined | null
};
	["MenuLocaleUpdateEshopLinkEntityRelationInput"]: {
	create?: ValueTypes["LinkCreateInput"] | undefined | null,
	update?: ValueTypes["LinkUpdateInput"] | undefined | null,
	upsert?: ValueTypes["MenuLocaleUpsertEshopLinkRelationInput"] | undefined | null,
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["MenuLocaleUpsertEshopLinkRelationInput"]: {
	update?: ValueTypes["LinkUpdateInput"] | undefined | null,
	create?: ValueTypes["LinkCreateInput"] | undefined | null
};
	["LocaleUpsertMenusRelationInput"]: {
	by?: ValueTypes["MenuLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["MenuLocaleWithoutLocaleUpdateInput"] | undefined | null,
	create?: ValueTypes["MenuLocaleWithoutLocaleCreateInput"] | undefined | null
};
	["LocaleUpdatePagesEntityRelationInput"]: {
	create?: ValueTypes["PageLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleUpdatePagesRelationInput"] | undefined | null,
	upsert?: ValueTypes["LocaleUpsertPagesRelationInput"] | undefined | null,
	connect?: ValueTypes["PageLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["PageLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["PageLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdatePagesRelationInput"]: {
	by?: ValueTypes["PageLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["PageLocaleWithoutLocaleUpdateInput"] | undefined | null
};
	["PageLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined | null,
	link?: ValueTypes["PageLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	root?: ValueTypes["PageLocaleUpdateRootEntityRelationInput"] | undefined | null,
	seo?: ValueTypes["PageLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	content?: ValueTypes["PageLocaleUpdateContentEntityRelationInput"] | undefined | null,
	cover?: ValueTypes["PageLocaleUpdateCoverEntityRelationInput"] | undefined | null,
	theme?: ValueTypes["PageTheme"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PageLocaleUpdateLinkEntityRelationInput"]: {
	create?: ValueTypes["LinkableWithoutPageCreateInput"] | undefined | null,
	update?: ValueTypes["LinkableWithoutPageUpdateInput"] | undefined | null,
	upsert?: ValueTypes["PageLocaleUpsertLinkRelationInput"] | undefined | null,
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["LinkableWithoutPageUpdateInput"]: {
	url?: string | undefined | null,
	blogPost?: ValueTypes["LinkableUpdateBlogPostEntityRelationInput"] | undefined | null,
	wikiPage?: ValueTypes["LinkableUpdateWikiPageEntityRelationInput"] | undefined | null,
	redirect?: ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkableUpdateWikiPageEntityRelationInput"]: {
	create?: ValueTypes["WikiPageWithoutLinkCreateInput"] | undefined | null,
	update?: ValueTypes["WikiPageWithoutLinkUpdateInput"] | undefined | null,
	upsert?: ValueTypes["LinkableUpsertWikiPageRelationInput"] | undefined | null,
	connect?: ValueTypes["WikiPageUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["WikiPageWithoutLinkUpdateInput"]: {
	order?: number | undefined | null,
	title?: string | undefined | null,
	emoji?: string | undefined | null,
	parent?: ValueTypes["WikiPageUpdateParentEntityRelationInput"] | undefined | null,
	children?: Array<ValueTypes["WikiPageUpdateChildrenEntityRelationInput"]> | undefined | null,
	content?: ValueTypes["WikiPageUpdateContentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["WikiPageUpdateParentEntityRelationInput"]: {
	create?: ValueTypes["WikiPageWithoutChildrenCreateInput"] | undefined | null,
	update?: ValueTypes["WikiPageWithoutChildrenUpdateInput"] | undefined | null,
	upsert?: ValueTypes["WikiPageUpsertParentRelationInput"] | undefined | null,
	connect?: ValueTypes["WikiPageUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["WikiPageWithoutChildrenUpdateInput"]: {
	order?: number | undefined | null,
	title?: string | undefined | null,
	emoji?: string | undefined | null,
	link?: ValueTypes["WikiPageUpdateLinkEntityRelationInput"] | undefined | null,
	parent?: ValueTypes["WikiPageUpdateParentEntityRelationInput"] | undefined | null,
	content?: ValueTypes["WikiPageUpdateContentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["WikiPageUpdateLinkEntityRelationInput"]: {
	create?: ValueTypes["LinkableWithoutWikiPageCreateInput"] | undefined | null,
	update?: ValueTypes["LinkableWithoutWikiPageUpdateInput"] | undefined | null,
	upsert?: ValueTypes["WikiPageUpsertLinkRelationInput"] | undefined | null,
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["LinkableWithoutWikiPageUpdateInput"]: {
	url?: string | undefined | null,
	blogPost?: ValueTypes["LinkableUpdateBlogPostEntityRelationInput"] | undefined | null,
	page?: ValueTypes["LinkableUpdatePageEntityRelationInput"] | undefined | null,
	redirect?: ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkableUpdatePageEntityRelationInput"]: {
	create?: ValueTypes["PageLocaleWithoutLinkCreateInput"] | undefined | null,
	update?: ValueTypes["PageLocaleWithoutLinkUpdateInput"] | undefined | null,
	upsert?: ValueTypes["LinkableUpsertPageRelationInput"] | undefined | null,
	connect?: ValueTypes["PageLocaleUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PageLocaleWithoutLinkUpdateInput"]: {
	title?: string | undefined | null,
	root?: ValueTypes["PageLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["PageLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	seo?: ValueTypes["PageLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	content?: ValueTypes["PageLocaleUpdateContentEntityRelationInput"] | undefined | null,
	cover?: ValueTypes["PageLocaleUpdateCoverEntityRelationInput"] | undefined | null,
	theme?: ValueTypes["PageTheme"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PageLocaleUpdateRootEntityRelationInput"]: {
	create?: ValueTypes["PageWithoutLocalesCreateInput"] | undefined | null,
	update?: ValueTypes["PageWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["PageLocaleUpsertRootRelationInput"] | undefined | null,
	connect?: ValueTypes["PageUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["PageWithoutLocalesUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null
};
	["PageLocaleUpsertRootRelationInput"]: {
	update?: ValueTypes["PageWithoutLocalesUpdateInput"] | undefined | null,
	create?: ValueTypes["PageWithoutLocalesCreateInput"] | undefined | null
};
	["PageLocaleUpdateLocaleEntityRelationInput"]: {
	create?: ValueTypes["LocaleWithoutPagesCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleWithoutPagesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["PageLocaleUpsertLocaleRelationInput"] | undefined | null,
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutPagesUpdateInput"]: {
	businessCategories?: Array<ValueTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]: {
	create?: ValueTypes["ProductIngredientCategoryLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleUpdateProductIngredientCategoriesRelationInput"] | undefined | null,
	upsert?: ValueTypes["LocaleUpsertProductIngredientCategoriesRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductIngredientCategoryLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductIngredientCategoryLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductIngredientCategoryLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateProductIngredientCategoriesRelationInput"]: {
	by?: ValueTypes["ProductIngredientCategoryLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["ProductIngredientCategoryLocaleWithoutLocaleUpdateInput"] | undefined | null
};
	["ProductIngredientCategoryLocaleWithoutLocaleUpdateInput"]: {
	name?: string | undefined | null,
	root?: ValueTypes["ProductIngredientCategoryLocaleUpdateRootEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientCategoryLocaleUpdateRootEntityRelationInput"]: {
	create?: ValueTypes["ProductIngredientCategoryWithoutLocalesCreateInput"] | undefined | null,
	update?: ValueTypes["ProductIngredientCategoryWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductIngredientCategoryLocaleUpsertRootRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductIngredientCategoryUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductIngredientCategoryWithoutLocalesUpdateInput"]: {
	internalName?: string | undefined | null,
	internalNote?: string | undefined | null,
	ingredients?: Array<ValueTypes["ProductIngredientCategoryUpdateIngredientsEntityRelationInput"]> | undefined | null,
	order?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientCategoryUpdateIngredientsEntityRelationInput"]: {
	create?: ValueTypes["ProductIngredientWithoutCategoriesCreateInput"] | undefined | null,
	update?: ValueTypes["ProductIngredientCategoryUpdateIngredientsRelationInput"] | undefined | null,
	upsert?: ValueTypes["ProductIngredientCategoryUpsertIngredientsRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductIngredientUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductIngredientUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductIngredientUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductIngredientCategoryUpdateIngredientsRelationInput"]: {
	by?: ValueTypes["ProductIngredientUniqueWhere"] | undefined | null,
	data?: ValueTypes["ProductIngredientWithoutCategoriesUpdateInput"] | undefined | null
};
	["ProductIngredientWithoutCategoriesUpdateInput"]: {
	internalNote?: string | undefined | null,
	locales?: Array<ValueTypes["ProductIngredientUpdateLocalesEntityRelationInput"]> | undefined | null,
	internalName?: string | undefined | null,
	allergens?: Array<ValueTypes["ProductIngredientUpdateAllergensEntityRelationInput"]> | undefined | null,
	needsPrepping?: boolean | undefined | null,
	allowCustomerRating?: boolean | undefined | null,
	customerRatings?: Array<ValueTypes["ProductIngredientUpdateCustomerRatingsEntityRelationInput"]> | undefined | null,
	preferredQuantityUnit?: ValueTypes["ProductIngredientUpdatePreferredQuantityUnitEntityRelationInput"] | undefined | null,
	freshingContainer?: ValueTypes["ProductIngredientUpdateFreshingContainerEntityRelationInput"] | undefined | null,
	image?: ValueTypes["ProductIngredientUpdateImageEntityRelationInput"] | undefined | null,
	suppliers?: ValueTypes["ProductIngredientUpdateSuppliersEntityRelationInput"] | undefined | null,
	incrementQuantityNumber?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientUpdateCustomerRatingsEntityRelationInput"]: {
	create?: ValueTypes["CustomerIngredientRatingWithoutIngredientCreateInput"] | undefined | null,
	update?: ValueTypes["ProductIngredientUpdateCustomerRatingsRelationInput"] | undefined | null,
	upsert?: ValueTypes["ProductIngredientUpsertCustomerRatingsRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerIngredientRatingUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["CustomerIngredientRatingUniqueWhere"] | undefined | null,
	delete?: ValueTypes["CustomerIngredientRatingUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductIngredientUpdateCustomerRatingsRelationInput"]: {
	by?: ValueTypes["CustomerIngredientRatingUniqueWhere"] | undefined | null,
	data?: ValueTypes["CustomerIngredientRatingWithoutIngredientUpdateInput"] | undefined | null
};
	["CustomerIngredientRatingWithoutIngredientUpdateInput"]: {
	customer?: ValueTypes["CustomerIngredientRatingUpdateCustomerEntityRelationInput"] | undefined | null,
	rating?: ValueTypes["CustomerIngredientRatingUpdateRatingEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerIngredientRatingUpdateCustomerEntityRelationInput"]: {
	create?: ValueTypes["CustomerWithoutIngredientRatingsCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerWithoutIngredientRatingsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CustomerIngredientRatingUpsertCustomerRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["CustomerWithoutIngredientRatingsUpdateInput"]: {
	addresses?: Array<ValueTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerUpdateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerUpdateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	business?: ValueTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerUpdateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerUpdateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerUpdateBusinessEntityRelationInput"]: {
	create?: ValueTypes["BusinessCustomerWithoutCustomerCreateInput"] | undefined | null,
	update?: ValueTypes["BusinessCustomerWithoutCustomerUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CustomerUpsertBusinessRelationInput"] | undefined | null,
	connect?: ValueTypes["BusinessCustomerUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["BusinessCustomerWithoutCustomerUpdateInput"]: {
	name?: string | undefined | null,
	owners?: Array<ValueTypes["BusinessCustomerUpdateOwnersEntityRelationInput"]> | undefined | null,
	members?: Array<ValueTypes["BusinessCustomerUpdateMembersEntityRelationInput"]> | undefined | null,
	category?: ValueTypes["BusinessCustomerUpdateCategoryEntityRelationInput"] | undefined | null,
	accountManager?: ValueTypes["BusinessCustomerUpdateAccountManagerEntityRelationInput"] | undefined | null,
	logo?: ValueTypes["BusinessCustomerUpdateLogoEntityRelationInput"] | undefined | null,
	note?: string | undefined | null,
	businessServiceEvents?: Array<ValueTypes["BusinessCustomerUpdateBusinessServiceEventsEntityRelationInput"]> | undefined | null,
	doubleshotCoffeeEquipment?: ValueTypes["BusinessCustomerUpdateDoubleshotCoffeeEquipmentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessCustomerUpdateOwnersEntityRelationInput"]: {
	create?: ValueTypes["CustomerWithoutOwnerOfBusinessesCreateInput"] | undefined | null,
	update?: ValueTypes["BusinessCustomerUpdateOwnersRelationInput"] | undefined | null,
	upsert?: ValueTypes["BusinessCustomerUpsertOwnersRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	delete?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["BusinessCustomerUpdateOwnersRelationInput"]: {
	by?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	data?: ValueTypes["CustomerWithoutOwnerOfBusinessesUpdateInput"] | undefined | null
};
	["CustomerWithoutOwnerOfBusinessesUpdateInput"]: {
	addresses?: Array<ValueTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerUpdateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerUpdateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerUpdateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerUpdateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerUpdateMemberOfBusinessesEntityRelationInput"]: {
	create?: ValueTypes["BusinessCustomerWithoutMembersCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerUpdateMemberOfBusinessesRelationInput"] | undefined | null,
	upsert?: ValueTypes["CustomerUpsertMemberOfBusinessesRelationInput"] | undefined | null,
	connect?: ValueTypes["BusinessCustomerUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["BusinessCustomerUniqueWhere"] | undefined | null,
	delete?: ValueTypes["BusinessCustomerUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerUpdateMemberOfBusinessesRelationInput"]: {
	by?: ValueTypes["BusinessCustomerUniqueWhere"] | undefined | null,
	data?: ValueTypes["BusinessCustomerWithoutMembersUpdateInput"] | undefined | null
};
	["BusinessCustomerWithoutMembersUpdateInput"]: {
	name?: string | undefined | null,
	customer?: ValueTypes["BusinessCustomerUpdateCustomerEntityRelationInput"] | undefined | null,
	owners?: Array<ValueTypes["BusinessCustomerUpdateOwnersEntityRelationInput"]> | undefined | null,
	category?: ValueTypes["BusinessCustomerUpdateCategoryEntityRelationInput"] | undefined | null,
	accountManager?: ValueTypes["BusinessCustomerUpdateAccountManagerEntityRelationInput"] | undefined | null,
	logo?: ValueTypes["BusinessCustomerUpdateLogoEntityRelationInput"] | undefined | null,
	note?: string | undefined | null,
	businessServiceEvents?: Array<ValueTypes["BusinessCustomerUpdateBusinessServiceEventsEntityRelationInput"]> | undefined | null,
	doubleshotCoffeeEquipment?: ValueTypes["BusinessCustomerUpdateDoubleshotCoffeeEquipmentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessCustomerUpdateCategoryEntityRelationInput"]: {
	create?: ValueTypes["BusinessCategoryWithoutBusinessCustomersCreateInput"] | undefined | null,
	update?: ValueTypes["BusinessCategoryWithoutBusinessCustomersUpdateInput"] | undefined | null,
	upsert?: ValueTypes["BusinessCustomerUpsertCategoryRelationInput"] | undefined | null,
	connect?: ValueTypes["BusinessCategoryUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["BusinessCategoryWithoutBusinessCustomersUpdateInput"]: {
	order?: number | undefined | null,
	visibleToNewCustomers?: boolean | undefined | null,
	locales?: Array<ValueTypes["BusinessCategoryUpdateLocalesEntityRelationInput"]> | undefined | null,
	internalName?: string | undefined | null,
	recurrences?: Array<ValueTypes["BusinessCategoryUpdateRecurrencesEntityRelationInput"]> | undefined | null,
	specificProducts?: ValueTypes["BusinessCategoryUpdateSpecificProductsEntityRelationInput"] | undefined | null,
	seasonalProductCategories?: ValueTypes["BusinessCategoryUpdateSeasonalProductCategoriesEntityRelationInput"] | undefined | null,
	specificProductsProductCategories?: ValueTypes["BusinessCategoryUpdateSpecificProductsProductCategoriesEntityRelationInput"] | undefined | null,
	slug?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessCategoryUpdateRecurrencesEntityRelationInput"]: {
	create?: ValueTypes["OrderRecurrenceWithoutBusinessCategoryCreateInput"] | undefined | null,
	update?: ValueTypes["BusinessCategoryUpdateRecurrencesRelationInput"] | undefined | null,
	upsert?: ValueTypes["BusinessCategoryUpsertRecurrencesRelationInput"] | undefined | null,
	connect?: ValueTypes["OrderRecurrenceUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["OrderRecurrenceUniqueWhere"] | undefined | null,
	delete?: ValueTypes["OrderRecurrenceUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["BusinessCategoryUpdateRecurrencesRelationInput"]: {
	by?: ValueTypes["OrderRecurrenceUniqueWhere"] | undefined | null,
	data?: ValueTypes["OrderRecurrenceWithoutBusinessCategoryUpdateInput"] | undefined | null
};
	["OrderRecurrenceWithoutBusinessCategoryUpdateInput"]: {
	internalName?: string | undefined | null,
	locales?: Array<ValueTypes["OrderRecurrenceUpdateLocalesEntityRelationInput"]> | undefined | null,
	order?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderRecurrenceUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["OrderRecurrenceLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ValueTypes["OrderRecurrenceUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ValueTypes["OrderRecurrenceUpsertLocalesRelationInput"] | undefined | null,
	connect?: ValueTypes["OrderRecurrenceLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["OrderRecurrenceLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["OrderRecurrenceLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["OrderRecurrenceUpdateLocalesRelationInput"]: {
	by?: ValueTypes["OrderRecurrenceLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["OrderRecurrenceLocaleWithoutRootUpdateInput"] | undefined | null
};
	["OrderRecurrenceLocaleWithoutRootUpdateInput"]: {
	name?: string | undefined | null,
	locale?: ValueTypes["OrderRecurrenceLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderRecurrenceLocaleUpdateLocaleEntityRelationInput"]: {
	create?: ValueTypes["LocaleWithoutOrderRecurrencesCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleWithoutOrderRecurrencesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["OrderRecurrenceLocaleUpsertLocaleRelationInput"] | undefined | null,
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutOrderRecurrencesUpdateInput"]: {
	businessCategories?: Array<ValueTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleUpdateAllergensEntityRelationInput"]: {
	create?: ValueTypes["AllergenLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleUpdateAllergensRelationInput"] | undefined | null,
	upsert?: ValueTypes["LocaleUpsertAllergensRelationInput"] | undefined | null,
	connect?: ValueTypes["AllergenLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["AllergenLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["AllergenLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateAllergensRelationInput"]: {
	by?: ValueTypes["AllergenLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["AllergenLocaleWithoutLocaleUpdateInput"] | undefined | null
};
	["AllergenLocaleWithoutLocaleUpdateInput"]: {
	name?: string | undefined | null,
	root?: ValueTypes["AllergenLocaleUpdateRootEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AllergenLocaleUpdateRootEntityRelationInput"]: {
	create?: ValueTypes["AllergenWithoutLocalesCreateInput"] | undefined | null,
	update?: ValueTypes["AllergenWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["AllergenLocaleUpsertRootRelationInput"] | undefined | null,
	connect?: ValueTypes["AllergenUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["AllergenWithoutLocalesUpdateInput"]: {
	internalName?: string | undefined | null,
	ingredients?: Array<ValueTypes["AllergenUpdateIngredientsEntityRelationInput"]> | undefined | null,
	code?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AllergenUpdateIngredientsEntityRelationInput"]: {
	create?: ValueTypes["ProductIngredientWithoutAllergensCreateInput"] | undefined | null,
	update?: ValueTypes["AllergenUpdateIngredientsRelationInput"] | undefined | null,
	upsert?: ValueTypes["AllergenUpsertIngredientsRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductIngredientUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductIngredientUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductIngredientUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["AllergenUpdateIngredientsRelationInput"]: {
	by?: ValueTypes["ProductIngredientUniqueWhere"] | undefined | null,
	data?: ValueTypes["ProductIngredientWithoutAllergensUpdateInput"] | undefined | null
};
	["ProductIngredientWithoutAllergensUpdateInput"]: {
	internalNote?: string | undefined | null,
	locales?: Array<ValueTypes["ProductIngredientUpdateLocalesEntityRelationInput"]> | undefined | null,
	internalName?: string | undefined | null,
	categories?: Array<ValueTypes["ProductIngredientUpdateCategoriesEntityRelationInput"]> | undefined | null,
	needsPrepping?: boolean | undefined | null,
	allowCustomerRating?: boolean | undefined | null,
	customerRatings?: Array<ValueTypes["ProductIngredientUpdateCustomerRatingsEntityRelationInput"]> | undefined | null,
	preferredQuantityUnit?: ValueTypes["ProductIngredientUpdatePreferredQuantityUnitEntityRelationInput"] | undefined | null,
	freshingContainer?: ValueTypes["ProductIngredientUpdateFreshingContainerEntityRelationInput"] | undefined | null,
	image?: ValueTypes["ProductIngredientUpdateImageEntityRelationInput"] | undefined | null,
	suppliers?: ValueTypes["ProductIngredientUpdateSuppliersEntityRelationInput"] | undefined | null,
	incrementQuantityNumber?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientUpdatePreferredQuantityUnitEntityRelationInput"]: {
	create?: ValueTypes["ProductIngredientItemQuantityUnitCreateInput"] | undefined | null,
	update?: ValueTypes["ProductIngredientItemQuantityUnitUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductIngredientUpsertPreferredQuantityUnitRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductIngredientItemQuantityUnitUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductIngredientItemQuantityUnitUpdateInput"]: {
	name?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientUpsertPreferredQuantityUnitRelationInput"]: {
	update?: ValueTypes["ProductIngredientItemQuantityUnitUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductIngredientItemQuantityUnitCreateInput"] | undefined | null
};
	["ProductIngredientUpdateFreshingContainerEntityRelationInput"]: {
	create?: ValueTypes["FreshingContainerCreateInput"] | undefined | null,
	update?: ValueTypes["FreshingContainerUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductIngredientUpsertFreshingContainerRelationInput"] | undefined | null,
	connect?: ValueTypes["FreshingContainerUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["FreshingContainerUpdateInput"]: {
	order?: number | undefined | null,
	volumeMl?: number | undefined | null,
	workspace?: ValueTypes["FreshingContainerUpdateWorkspaceEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FreshingContainerUpdateWorkspaceEntityRelationInput"]: {
	create?: ValueTypes["WorkspaceWithoutFreshingContainersCreateInput"] | undefined | null,
	update?: ValueTypes["WorkspaceWithoutFreshingContainersUpdateInput"] | undefined | null,
	upsert?: ValueTypes["FreshingContainerUpsertWorkspaceRelationInput"] | undefined | null,
	connect?: ValueTypes["WorkspaceUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["WorkspaceWithoutFreshingContainersUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null,
	orderDeadlineTime?: string | undefined | null,
	ordersLoadingDurationHours?: number | undefined | null,
	freshingContainerVolumeMl?: number | undefined | null,
	freshingPrepareOrderByOffsetMinutes?: number | undefined | null,
	checkoutUrlTemplate?: string | undefined | null,
	orderUrlTemplate?: string | undefined | null,
	paymentUrlTemplate?: string | undefined | null,
	customerProfileUrlTemplate?: string | undefined | null,
	userProfileUrlTemplate?: string | undefined | null,
	messengerUrl?: string | undefined | null,
	messengerIosUrl?: string | undefined | null,
	messengerAndroidUrl?: string | undefined | null,
	openingHours?: ValueTypes["WorkspaceUpdateOpeningHoursEntityRelationInput"] | undefined | null,
	workingHours?: ValueTypes["WorkspaceUpdateWorkingHoursEntityRelationInput"] | undefined | null,
	defaultFreshingContainer?: ValueTypes["WorkspaceUpdateDefaultFreshingContainerEntityRelationInput"] | undefined | null,
	creditsProduct?: ValueTypes["WorkspaceUpdateCreditsProductEntityRelationInput"] | undefined | null,
	discountVatRate?: ValueTypes["WorkspaceUpdateDiscountVatRateEntityRelationInput"] | undefined | null,
	name?: string | undefined | null,
	businessAddress?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["WorkspaceUpdateOpeningHoursEntityRelationInput"]: {
	create?: ValueTypes["WeekHoursCreateInput"] | undefined | null,
	update?: ValueTypes["WeekHoursUpdateInput"] | undefined | null,
	upsert?: ValueTypes["WorkspaceUpsertOpeningHoursRelationInput"] | undefined | null,
	connect?: ValueTypes["WeekHoursUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["WeekHoursUpdateInput"]: {
	mon?: string | undefined | null,
	tue?: string | undefined | null,
	wed?: string | undefined | null,
	thu?: string | undefined | null,
	fri?: string | undefined | null,
	sat?: string | undefined | null,
	sun?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["WorkspaceUpsertOpeningHoursRelationInput"]: {
	update?: ValueTypes["WeekHoursUpdateInput"] | undefined | null,
	create?: ValueTypes["WeekHoursCreateInput"] | undefined | null
};
	["WorkspaceUpdateWorkingHoursEntityRelationInput"]: {
	create?: ValueTypes["WeekHoursCreateInput"] | undefined | null,
	update?: ValueTypes["WeekHoursUpdateInput"] | undefined | null,
	upsert?: ValueTypes["WorkspaceUpsertWorkingHoursRelationInput"] | undefined | null,
	connect?: ValueTypes["WeekHoursUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["WorkspaceUpsertWorkingHoursRelationInput"]: {
	update?: ValueTypes["WeekHoursUpdateInput"] | undefined | null,
	create?: ValueTypes["WeekHoursCreateInput"] | undefined | null
};
	["WorkspaceUpdateDefaultFreshingContainerEntityRelationInput"]: {
	create?: ValueTypes["FreshingContainerCreateInput"] | undefined | null,
	update?: ValueTypes["FreshingContainerUpdateInput"] | undefined | null,
	upsert?: ValueTypes["WorkspaceUpsertDefaultFreshingContainerRelationInput"] | undefined | null,
	connect?: ValueTypes["FreshingContainerUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["WorkspaceUpsertDefaultFreshingContainerRelationInput"]: {
	update?: ValueTypes["FreshingContainerUpdateInput"] | undefined | null,
	create?: ValueTypes["FreshingContainerCreateInput"] | undefined | null
};
	["WorkspaceUpdateCreditsProductEntityRelationInput"]: {
	create?: ValueTypes["VirtualProductCreateInput"] | undefined | null,
	update?: ValueTypes["VirtualProductUpdateInput"] | undefined | null,
	upsert?: ValueTypes["WorkspaceUpsertCreditsProductRelationInput"] | undefined | null,
	connect?: ValueTypes["VirtualProductUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["VirtualProductUpdateInput"]: {
	type?: ValueTypes["VirtualProductType"] | undefined | null,
	product?: ValueTypes["VirtualProductUpdateProductEntityRelationInput"] | undefined | null,
	voucherCreditCents?: number | undefined | null,
	physicalRepresentation?: ValueTypes["VirtualProductPhysicalRepresentationType"] | undefined | null,
	recipientEmail?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VirtualProductUpdateProductEntityRelationInput"]: {
	create?: ValueTypes["ProductWithoutVirtualProductCreateInput"] | undefined | null,
	update?: ValueTypes["ProductWithoutVirtualProductUpdateInput"] | undefined | null,
	upsert?: ValueTypes["VirtualProductUpsertProductRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductWithoutVirtualProductUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	priceCents?: number | undefined | null,
	notDiscountable?: boolean | undefined | null,
	packing?: ValueTypes["ProductUpdatePackingEntityRelationInput"] | undefined | null,
	recipe?: ValueTypes["ProductUpdateRecipeEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["ProductUpdateTagsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["ProductUpdateCategoriesEntityRelationInput"]> | undefined | null,
	vatRate?: ValueTypes["ProductUpdateVatRateEntityRelationInput"] | undefined | null,
	stocks?: Array<ValueTypes["ProductUpdateStocksEntityRelationInput"]> | undefined | null,
	groupPrices?: Array<ValueTypes["ProductUpdateGroupPricesEntityRelationInput"]> | undefined | null,
	image?: ValueTypes["ProductUpdateImageEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	cartItems?: Array<ValueTypes["ProductUpdateCartItemsEntityRelationInput"]> | undefined | null,
	availability?: ValueTypes["ProductAvailability"] | undefined | null,
	order?: number | undefined | null,
	manager?: ValueTypes["ProductUpdateManagerEntityRelationInput"] | undefined | null,
	orderItems?: Array<ValueTypes["ProductUpdateOrderItemsEntityRelationInput"]> | undefined | null,
	maximumQuantityPerOrder?: number | undefined | null,
	inheritedCategories?: Array<ValueTypes["ProductUpdateInheritedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["ProductUpdateDeliveryZonesEntityRelationInput"]> | undefined | null,
	locales?: Array<ValueTypes["ProductUpdateLocalesEntityRelationInput"]> | undefined | null,
	archivedAt?: ValueTypes["DateTime"] | undefined | null,
	customerPrices?: Array<ValueTypes["ProductUpdateCustomerPricesEntityRelationInput"]> | undefined | null,
	meta?: ValueTypes["ProductUpdateMetaEntityRelationInput"] | undefined | null,
	page?: ValueTypes["ProductUpdatePageEntityRelationInput"] | undefined | null,
	salesDays?: Array<ValueTypes["ProductUpdateSalesDaysEntityRelationInput"]> | undefined | null,
	salesWeeks?: Array<ValueTypes["ProductUpdateSalesWeeksEntityRelationInput"]> | undefined | null,
	salesMonths?: Array<ValueTypes["ProductUpdateSalesMonthsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["ProductUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	hasSubscription?: boolean | undefined | null,
	pointOfSaleTileColor?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductUpdateManagerEntityRelationInput"]: {
	create?: ValueTypes["StocksManagerWithoutManagedProductsCreateInput"] | undefined | null,
	update?: ValueTypes["StocksManagerWithoutManagedProductsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductUpsertManagerRelationInput"] | undefined | null,
	connect?: ValueTypes["StocksManagerUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["StocksManagerWithoutManagedProductsUpdateInput"]: {
	staff?: ValueTypes["StocksManagerUpdateStaffEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StocksManagerUpdateStaffEntityRelationInput"]: {
	create?: ValueTypes["StaffWithoutStocksManagerCreateInput"] | undefined | null,
	update?: ValueTypes["StaffWithoutStocksManagerUpdateInput"] | undefined | null,
	upsert?: ValueTypes["StocksManagerUpsertStaffRelationInput"] | undefined | null,
	connect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["StaffWithoutStocksManagerUpdateInput"]: {
	bartender?: ValueTypes["StaffUpdateBartenderEntityRelationInput"] | undefined | null,
	courier?: ValueTypes["StaffUpdateCourierEntityRelationInput"] | undefined | null,
	cleaner?: ValueTypes["StaffUpdateCleanerEntityRelationInput"] | undefined | null,
	shiftsManager?: ValueTypes["StaffUpdateShiftsManagerEntityRelationInput"] | undefined | null,
	businessToBusinessManager?: ValueTypes["StaffUpdateBusinessToBusinessManagerEntityRelationInput"] | undefined | null,
	user?: ValueTypes["StaffUpdateUserEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["StaffUpdateShiftsProfileEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["StaffUpdatePhotoEntityRelationInput"] | undefined | null,
	courierManager?: ValueTypes["StaffUpdateCourierManagerEntityRelationInput"] | undefined | null,
	picker?: ValueTypes["StaffUpdatePickerEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	remunerationProfile?: ValueTypes["StaffUpdateRemunerationProfileEntityRelationInput"] | undefined | null,
	cashier?: ValueTypes["StaffUpdateCashierEntityRelationInput"] | undefined | null,
	venues?: Array<ValueTypes["StaffUpdateVenuesEntityRelationInput"]> | undefined | null,
	internalBuyer?: ValueTypes["StaffUpdateInternalBuyerEntityRelationInput"] | undefined | null,
	salesManager?: ValueTypes["StaffUpdateSalesManagerEntityRelationInput"] | undefined | null,
	cashierManager?: ValueTypes["StaffUpdateCashierManagerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StaffUpdateBartenderEntityRelationInput"]: {
	create?: ValueTypes["BartenderWithoutStaffCreateInput"] | undefined | null,
	update?: ValueTypes["BartenderWithoutStaffUpdateInput"] | undefined | null,
	upsert?: ValueTypes["StaffUpsertBartenderRelationInput"] | undefined | null,
	connect?: ValueTypes["BartenderUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["BartenderWithoutStaffUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StaffUpsertBartenderRelationInput"]: {
	update?: ValueTypes["BartenderWithoutStaffUpdateInput"] | undefined | null,
	create?: ValueTypes["BartenderWithoutStaffCreateInput"] | undefined | null
};
	["StaffUpdateCourierEntityRelationInput"]: {
	create?: ValueTypes["CourierWithoutStaffCreateInput"] | undefined | null,
	update?: ValueTypes["CourierWithoutStaffUpdateInput"] | undefined | null,
	upsert?: ValueTypes["StaffUpsertCourierRelationInput"] | undefined | null,
	connect?: ValueTypes["CourierUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CourierWithoutStaffUpdateInput"]: {
	routes?: Array<ValueTypes["CourierUpdateRoutesEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	deliveryMethods?: Array<ValueTypes["CourierUpdateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	showInPicker?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CourierUpdateRoutesEntityRelationInput"]: {
	create?: ValueTypes["DeliveryRouteWithoutCourierCreateInput"] | undefined | null,
	update?: ValueTypes["CourierUpdateRoutesRelationInput"] | undefined | null,
	upsert?: ValueTypes["CourierUpsertRoutesRelationInput"] | undefined | null,
	connect?: ValueTypes["DeliveryRouteUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["DeliveryRouteUniqueWhere"] | undefined | null,
	delete?: ValueTypes["DeliveryRouteUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CourierUpdateRoutesRelationInput"]: {
	by?: ValueTypes["DeliveryRouteUniqueWhere"] | undefined | null,
	data?: ValueTypes["DeliveryRouteWithoutCourierUpdateInput"] | undefined | null
};
	["DeliveryRouteWithoutCourierUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	waypoints?: Array<ValueTypes["DeliveryRouteUpdateWaypointsEntityRelationInput"]> | undefined | null,
	dispatchAt?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryRouteUpdateWaypointsEntityRelationInput"]: {
	create?: ValueTypes["DeliveryWaypointWithoutRouteCreateInput"] | undefined | null,
	update?: ValueTypes["DeliveryRouteUpdateWaypointsRelationInput"] | undefined | null,
	upsert?: ValueTypes["DeliveryRouteUpsertWaypointsRelationInput"] | undefined | null,
	connect?: ValueTypes["DeliveryWaypointUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["DeliveryWaypointUniqueWhere"] | undefined | null,
	delete?: ValueTypes["DeliveryWaypointUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["DeliveryRouteUpdateWaypointsRelationInput"]: {
	by?: ValueTypes["DeliveryWaypointUniqueWhere"] | undefined | null,
	data?: ValueTypes["DeliveryWaypointWithoutRouteUpdateInput"] | undefined | null
};
	["DeliveryWaypointWithoutRouteUpdateInput"]: {
	estimatedArrival?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	sortingOrder?: number | undefined | null,
	delivery?: ValueTypes["DeliveryWaypointUpdateDeliveryEntityRelationInput"] | undefined | null,
	estimatedDistance?: number | undefined | null,
	estimatedDuration?: number | undefined | null,
	originDeparture?: ValueTypes["DateTime"] | undefined | null,
	originAddress?: string | undefined | null,
	transitMode?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryWaypointUpdateDeliveryEntityRelationInput"]: {
	create?: ValueTypes["OrderDeliveryWithoutDeliveryWaypointCreateInput"] | undefined | null,
	update?: ValueTypes["OrderDeliveryWithoutDeliveryWaypointUpdateInput"] | undefined | null,
	upsert?: ValueTypes["DeliveryWaypointUpsertDeliveryRelationInput"] | undefined | null,
	connect?: ValueTypes["OrderDeliveryUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["OrderDeliveryWithoutDeliveryWaypointUpdateInput"]: {
	priceCents?: number | undefined | null,
	deliveredAt?: ValueTypes["DateTime"] | undefined | null,
	method?: ValueTypes["OrderDeliveryUpdateMethodEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["OrderDeliveryUpdateVatRateEntityRelationInput"] | undefined | null,
	order?: ValueTypes["OrderDeliveryUpdateOrderEntityRelationInput"] | undefined | null,
	expectedAt?: ValueTypes["DateTime"] | undefined | null,
	state?: ValueTypes["OrderDeliveryState"] | undefined | null,
	loadingDurationHours?: number | undefined | null,
	dispatchAt?: ValueTypes["DateTime"] | undefined | null,
	duration?: string | undefined | null,
	window?: string | undefined | null,
	expectedEndAt?: ValueTypes["DateTime"] | undefined | null,
	processingAt?: ValueTypes["DateTime"] | undefined | null,
	deliveringAt?: ValueTypes["DateTime"] | undefined | null,
	failedAt?: ValueTypes["DateTime"] | undefined | null,
	internalNote?: string | undefined | null,
	events?: Array<ValueTypes["OrderDeliveryUpdateEventsEntityRelationInput"]> | undefined | null,
	prepareAt?: ValueTypes["DateTime"] | undefined | null,
	liftagoRide?: ValueTypes["OrderDeliveryUpdateLiftagoRideEntityRelationInput"] | undefined | null,
	pickedAt?: ValueTypes["DateTime"] | undefined | null,
	address?: ValueTypes["OrderDeliveryUpdateAddressEntityRelationInput"] | undefined | null,
	trackingCode?: string | undefined | null,
	woltDriveDelivery?: ValueTypes["OrderDeliveryUpdateWoltDriveDeliveryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderDeliveryUpdateMethodEntityRelationInput"]: {
	create?: ValueTypes["DeliveryMethodCreateInput"] | undefined | null,
	update?: ValueTypes["DeliveryMethodUpdateInput"] | undefined | null,
	upsert?: ValueTypes["OrderDeliveryUpsertMethodRelationInput"] | undefined | null,
	connect?: ValueTypes["DeliveryMethodUniqueWhere"] | undefined | null
};
	["DeliveryMethodUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	enabled?: boolean | undefined | null,
	paymentMethods?: Array<ValueTypes["DeliveryMethodUpdatePaymentMethodsEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	requireDeliveryAddress?: boolean | undefined | null,
	suitableForDeliveryZones?: Array<ValueTypes["DeliveryMethodUpdateSuitableForDeliveryZonesEntityRelationInput"]> | undefined | null,
	channels?: Array<ValueTypes["DeliveryMethodUpdateChannelsEntityRelationInput"]> | undefined | null,
	courierHandlers?: Array<ValueTypes["DeliveryMethodUpdateCourierHandlersEntityRelationInput"]> | undefined | null,
	enableDeliveryTracking?: boolean | undefined | null,
	locales?: Array<ValueTypes["DeliveryMethodUpdateLocalesEntityRelationInput"]> | undefined | null,
	timelinePreset?: ValueTypes["DeliveryMethodUpdateTimelinePresetEntityRelationInput"] | undefined | null,
	woltDriveVenueId?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryMethodUpdateCourierHandlersEntityRelationInput"]: {
	create?: ValueTypes["CourierWithoutDeliveryMethodsCreateInput"] | undefined | null,
	update?: ValueTypes["DeliveryMethodUpdateCourierHandlersRelationInput"] | undefined | null,
	upsert?: ValueTypes["DeliveryMethodUpsertCourierHandlersRelationInput"] | undefined | null,
	connect?: ValueTypes["CourierUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["CourierUniqueWhere"] | undefined | null,
	delete?: ValueTypes["CourierUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["DeliveryMethodUpdateCourierHandlersRelationInput"]: {
	by?: ValueTypes["CourierUniqueWhere"] | undefined | null,
	data?: ValueTypes["CourierWithoutDeliveryMethodsUpdateInput"] | undefined | null
};
	["CourierWithoutDeliveryMethodsUpdateInput"]: {
	staff?: ValueTypes["CourierUpdateStaffEntityRelationInput"] | undefined | null,
	routes?: Array<ValueTypes["CourierUpdateRoutesEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	showInPicker?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CourierUpdateStaffEntityRelationInput"]: {
	create?: ValueTypes["StaffWithoutCourierCreateInput"] | undefined | null,
	update?: ValueTypes["StaffWithoutCourierUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CourierUpsertStaffRelationInput"] | undefined | null,
	connect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["StaffWithoutCourierUpdateInput"]: {
	bartender?: ValueTypes["StaffUpdateBartenderEntityRelationInput"] | undefined | null,
	cleaner?: ValueTypes["StaffUpdateCleanerEntityRelationInput"] | undefined | null,
	shiftsManager?: ValueTypes["StaffUpdateShiftsManagerEntityRelationInput"] | undefined | null,
	businessToBusinessManager?: ValueTypes["StaffUpdateBusinessToBusinessManagerEntityRelationInput"] | undefined | null,
	user?: ValueTypes["StaffUpdateUserEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["StaffUpdateShiftsProfileEntityRelationInput"] | undefined | null,
	stocksManager?: ValueTypes["StaffUpdateStocksManagerEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["StaffUpdatePhotoEntityRelationInput"] | undefined | null,
	courierManager?: ValueTypes["StaffUpdateCourierManagerEntityRelationInput"] | undefined | null,
	picker?: ValueTypes["StaffUpdatePickerEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	remunerationProfile?: ValueTypes["StaffUpdateRemunerationProfileEntityRelationInput"] | undefined | null,
	cashier?: ValueTypes["StaffUpdateCashierEntityRelationInput"] | undefined | null,
	venues?: Array<ValueTypes["StaffUpdateVenuesEntityRelationInput"]> | undefined | null,
	internalBuyer?: ValueTypes["StaffUpdateInternalBuyerEntityRelationInput"] | undefined | null,
	salesManager?: ValueTypes["StaffUpdateSalesManagerEntityRelationInput"] | undefined | null,
	cashierManager?: ValueTypes["StaffUpdateCashierManagerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StaffUpdateCleanerEntityRelationInput"]: {
	create?: ValueTypes["CleanerWithoutStaffCreateInput"] | undefined | null,
	update?: ValueTypes["CleanerWithoutStaffUpdateInput"] | undefined | null,
	upsert?: ValueTypes["StaffUpsertCleanerRelationInput"] | undefined | null,
	connect?: ValueTypes["CleanerUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CleanerWithoutStaffUpdateInput"]: {
	canReachTopShelf?: boolean | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StaffUpsertCleanerRelationInput"]: {
	update?: ValueTypes["CleanerWithoutStaffUpdateInput"] | undefined | null,
	create?: ValueTypes["CleanerWithoutStaffCreateInput"] | undefined | null
};
	["StaffUpdateShiftsManagerEntityRelationInput"]: {
	create?: ValueTypes["ShiftsManagerWithoutStaffCreateInput"] | undefined | null,
	update?: ValueTypes["ShiftsManagerWithoutStaffUpdateInput"] | undefined | null,
	upsert?: ValueTypes["StaffUpsertShiftsManagerRelationInput"] | undefined | null,
	connect?: ValueTypes["ShiftsManagerUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ShiftsManagerWithoutStaffUpdateInput"]: {
	managedRoles?: Array<ValueTypes["ShiftsManagerUpdateManagedRolesEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ShiftsManagerUpdateManagedRolesEntityRelationInput"]: {
	create?: ValueTypes["TimetableEmployeeRoleWithoutShiftsManagersCreateInput"] | undefined | null,
	update?: ValueTypes["ShiftsManagerUpdateManagedRolesRelationInput"] | undefined | null,
	upsert?: ValueTypes["ShiftsManagerUpsertManagedRolesRelationInput"] | undefined | null,
	connect?: ValueTypes["TimetableEmployeeRoleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["TimetableEmployeeRoleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["TimetableEmployeeRoleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ShiftsManagerUpdateManagedRolesRelationInput"]: {
	by?: ValueTypes["TimetableEmployeeRoleUniqueWhere"] | undefined | null,
	data?: ValueTypes["TimetableEmployeeRoleWithoutShiftsManagersUpdateInput"] | undefined | null
};
	["TimetableEmployeeRoleWithoutShiftsManagersUpdateInput"]: {
	shiftGroups?: Array<ValueTypes["TimetableEmployeeRoleUpdateShiftGroupsEntityRelationInput"]> | undefined | null,
	shiftsProfiles?: Array<ValueTypes["TimetableEmployeeRoleUpdateShiftsProfilesEntityRelationInput"]> | undefined | null,
	name?: string | undefined | null,
	timetableTemplates?: Array<ValueTypes["TimetableEmployeeRoleUpdateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	color?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableEmployeeRoleUpdateShiftGroupsEntityRelationInput"]: {
	create?: ValueTypes["TimetableShiftGroupWithoutTypeCreateInput"] | undefined | null,
	update?: ValueTypes["TimetableEmployeeRoleUpdateShiftGroupsRelationInput"] | undefined | null,
	upsert?: ValueTypes["TimetableEmployeeRoleUpsertShiftGroupsRelationInput"] | undefined | null,
	connect?: ValueTypes["TimetableShiftGroupUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["TimetableShiftGroupUniqueWhere"] | undefined | null,
	delete?: ValueTypes["TimetableShiftGroupUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["TimetableEmployeeRoleUpdateShiftGroupsRelationInput"]: {
	by?: ValueTypes["TimetableShiftGroupUniqueWhere"] | undefined | null,
	data?: ValueTypes["TimetableShiftGroupWithoutTypeUpdateInput"] | undefined | null
};
	["TimetableShiftGroupWithoutTypeUpdateInput"]: {
	order?: number | undefined | null,
	shifts?: Array<ValueTypes["TimetableShiftGroupUpdateShiftsEntityRelationInput"]> | undefined | null,
	day?: ValueTypes["TimetableShiftGroupUpdateDayEntityRelationInput"] | undefined | null,
	position?: ValueTypes["TimetableShiftGroupUpdatePositionEntityRelationInput"] | undefined | null,
	queue?: ValueTypes["TimetableShiftGroupUpdateQueueEntityRelationInput"] | undefined | null,
	generatedByTemplate?: ValueTypes["TimetableShiftGroupUpdateGeneratedByTemplateEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableShiftGroupUpdateShiftsEntityRelationInput"]: {
	create?: ValueTypes["TimetableShiftWithoutGroupCreateInput"] | undefined | null,
	update?: ValueTypes["TimetableShiftGroupUpdateShiftsRelationInput"] | undefined | null,
	upsert?: ValueTypes["TimetableShiftGroupUpsertShiftsRelationInput"] | undefined | null,
	connect?: ValueTypes["TimetableShiftUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["TimetableShiftUniqueWhere"] | undefined | null,
	delete?: ValueTypes["TimetableShiftUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["TimetableShiftGroupUpdateShiftsRelationInput"]: {
	by?: ValueTypes["TimetableShiftUniqueWhere"] | undefined | null,
	data?: ValueTypes["TimetableShiftWithoutGroupUpdateInput"] | undefined | null
};
	["TimetableShiftWithoutGroupUpdateInput"]: {
	locked?: boolean | undefined | null,
	order?: number | undefined | null,
	assigned?: ValueTypes["Date"] | undefined | null,
	shiftsProfile?: ValueTypes["TimetableShiftUpdateShiftsProfileEntityRelationInput"] | undefined | null,
	queueItem?: ValueTypes["TimetableShiftUpdateQueueItemEntityRelationInput"] | undefined | null,
	swapInfo?: ValueTypes["TimetableShiftUpdateSwapInfoEntityRelationInput"] | undefined | null,
	isOvertime?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableShiftUpdateShiftsProfileEntityRelationInput"]: {
	create?: ValueTypes["ShiftsProfileWithoutShiftsCreateInput"] | undefined | null,
	update?: ValueTypes["ShiftsProfileWithoutShiftsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["TimetableShiftUpsertShiftsProfileRelationInput"] | undefined | null,
	connect?: ValueTypes["ShiftsProfileUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ShiftsProfileWithoutShiftsUpdateInput"]: {
	queueItems?: Array<ValueTypes["ShiftsProfileUpdateQueueItemsEntityRelationInput"]> | undefined | null,
	staff?: ValueTypes["ShiftsProfileUpdateStaffEntityRelationInput"] | undefined | null,
	roles?: Array<ValueTypes["ShiftsProfileUpdateRolesEntityRelationInput"]> | undefined | null,
	allowSelfUnassigning?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ShiftsProfileUpdateQueueItemsEntityRelationInput"]: {
	create?: ValueTypes["EmployeeQueueItemWithoutShiftsProfileCreateInput"] | undefined | null,
	update?: ValueTypes["ShiftsProfileUpdateQueueItemsRelationInput"] | undefined | null,
	upsert?: ValueTypes["ShiftsProfileUpsertQueueItemsRelationInput"] | undefined | null,
	connect?: ValueTypes["EmployeeQueueItemUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["EmployeeQueueItemUniqueWhere"] | undefined | null,
	delete?: ValueTypes["EmployeeQueueItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ShiftsProfileUpdateQueueItemsRelationInput"]: {
	by?: ValueTypes["EmployeeQueueItemUniqueWhere"] | undefined | null,
	data?: ValueTypes["EmployeeQueueItemWithoutShiftsProfileUpdateInput"] | undefined | null
};
	["EmployeeQueueItemWithoutShiftsProfileUpdateInput"]: {
	start?: string | undefined | null,
	end?: string | undefined | null,
	queue?: ValueTypes["EmployeeQueueItemUpdateQueueEntityRelationInput"] | undefined | null,
	shift?: ValueTypes["EmployeeQueueItemUpdateShiftEntityRelationInput"] | undefined | null,
	unassignInfo?: ValueTypes["EmployeeQueueItemUpdateUnassignInfoEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["EmployeeQueueItemUpdateMetaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["EmployeeQueueItemUpdateQueueEntityRelationInput"]: {
	create?: ValueTypes["EmployeeQueueWithoutItemsCreateInput"] | undefined | null,
	update?: ValueTypes["EmployeeQueueWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["EmployeeQueueItemUpsertQueueRelationInput"] | undefined | null,
	connect?: ValueTypes["EmployeeQueueUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["EmployeeQueueWithoutItemsUpdateInput"]: {
	shiftGroup?: ValueTypes["EmployeeQueueUpdateShiftGroupEntityRelationInput"] | undefined | null,
	contemberBugFix?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["EmployeeQueueUpdateShiftGroupEntityRelationInput"]: {
	create?: ValueTypes["TimetableShiftGroupWithoutQueueCreateInput"] | undefined | null,
	update?: ValueTypes["TimetableShiftGroupWithoutQueueUpdateInput"] | undefined | null,
	upsert?: ValueTypes["EmployeeQueueUpsertShiftGroupRelationInput"] | undefined | null,
	connect?: ValueTypes["TimetableShiftGroupUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["TimetableShiftGroupWithoutQueueUpdateInput"]: {
	order?: number | undefined | null,
	shifts?: Array<ValueTypes["TimetableShiftGroupUpdateShiftsEntityRelationInput"]> | undefined | null,
	day?: ValueTypes["TimetableShiftGroupUpdateDayEntityRelationInput"] | undefined | null,
	type?: ValueTypes["TimetableShiftGroupUpdateTypeEntityRelationInput"] | undefined | null,
	position?: ValueTypes["TimetableShiftGroupUpdatePositionEntityRelationInput"] | undefined | null,
	generatedByTemplate?: ValueTypes["TimetableShiftGroupUpdateGeneratedByTemplateEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableShiftGroupUpdateDayEntityRelationInput"]: {
	create?: ValueTypes["TimetableDayWithoutShiftGroupsCreateInput"] | undefined | null,
	update?: ValueTypes["TimetableDayWithoutShiftGroupsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["TimetableShiftGroupUpsertDayRelationInput"] | undefined | null,
	connect?: ValueTypes["TimetableDayUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["TimetableDayWithoutShiftGroupsUpdateInput"]: {
	date?: ValueTypes["Date"] | undefined | null,
	type?: ValueTypes["TimetableDayType"] | undefined | null,
	tipsCents?: number | undefined | null,
	notes?: Array<ValueTypes["TimetableDayUpdateNotesEntityRelationInput"]> | undefined | null,
	venue?: ValueTypes["TimetableDayUpdateVenueEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["TimetableDayUpdateMetaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableDayUpdateNotesEntityRelationInput"]: {
	create?: ValueTypes["TimetableDayNoteWithoutDayCreateInput"] | undefined | null,
	update?: ValueTypes["TimetableDayUpdateNotesRelationInput"] | undefined | null,
	upsert?: ValueTypes["TimetableDayUpsertNotesRelationInput"] | undefined | null,
	connect?: ValueTypes["TimetableDayNoteUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["TimetableDayNoteUniqueWhere"] | undefined | null,
	delete?: ValueTypes["TimetableDayNoteUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["TimetableDayUpdateNotesRelationInput"]: {
	by?: ValueTypes["TimetableDayNoteUniqueWhere"] | undefined | null,
	data?: ValueTypes["TimetableDayNoteWithoutDayUpdateInput"] | undefined | null
};
	["TimetableDayNoteWithoutDayUpdateInput"]: {
	order?: number | undefined | null,
	note?: string | undefined | null,
	role?: ValueTypes["TimetableDayNoteUpdateRoleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableDayNoteUpdateRoleEntityRelationInput"]: {
	create?: ValueTypes["TimetableEmployeeRoleCreateInput"] | undefined | null,
	update?: ValueTypes["TimetableEmployeeRoleUpdateInput"] | undefined | null,
	upsert?: ValueTypes["TimetableDayNoteUpsertRoleRelationInput"] | undefined | null,
	connect?: ValueTypes["TimetableEmployeeRoleUniqueWhere"] | undefined | null
};
	["TimetableEmployeeRoleUpdateInput"]: {
	shiftGroups?: Array<ValueTypes["TimetableEmployeeRoleUpdateShiftGroupsEntityRelationInput"]> | undefined | null,
	shiftsProfiles?: Array<ValueTypes["TimetableEmployeeRoleUpdateShiftsProfilesEntityRelationInput"]> | undefined | null,
	shiftsManagers?: Array<ValueTypes["TimetableEmployeeRoleUpdateShiftsManagersEntityRelationInput"]> | undefined | null,
	name?: string | undefined | null,
	timetableTemplates?: Array<ValueTypes["TimetableEmployeeRoleUpdateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	color?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableEmployeeRoleUpdateShiftsProfilesEntityRelationInput"]: {
	create?: ValueTypes["ShiftsProfileWithoutRolesCreateInput"] | undefined | null,
	update?: ValueTypes["TimetableEmployeeRoleUpdateShiftsProfilesRelationInput"] | undefined | null,
	upsert?: ValueTypes["TimetableEmployeeRoleUpsertShiftsProfilesRelationInput"] | undefined | null,
	connect?: ValueTypes["ShiftsProfileUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ShiftsProfileUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ShiftsProfileUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["TimetableEmployeeRoleUpdateShiftsProfilesRelationInput"]: {
	by?: ValueTypes["ShiftsProfileUniqueWhere"] | undefined | null,
	data?: ValueTypes["ShiftsProfileWithoutRolesUpdateInput"] | undefined | null
};
	["ShiftsProfileWithoutRolesUpdateInput"]: {
	queueItems?: Array<ValueTypes["ShiftsProfileUpdateQueueItemsEntityRelationInput"]> | undefined | null,
	staff?: ValueTypes["ShiftsProfileUpdateStaffEntityRelationInput"] | undefined | null,
	shifts?: Array<ValueTypes["ShiftsProfileUpdateShiftsEntityRelationInput"]> | undefined | null,
	allowSelfUnassigning?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ShiftsProfileUpdateStaffEntityRelationInput"]: {
	create?: ValueTypes["StaffWithoutShiftsProfileCreateInput"] | undefined | null,
	update?: ValueTypes["StaffWithoutShiftsProfileUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ShiftsProfileUpsertStaffRelationInput"] | undefined | null,
	connect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["StaffWithoutShiftsProfileUpdateInput"]: {
	bartender?: ValueTypes["StaffUpdateBartenderEntityRelationInput"] | undefined | null,
	courier?: ValueTypes["StaffUpdateCourierEntityRelationInput"] | undefined | null,
	cleaner?: ValueTypes["StaffUpdateCleanerEntityRelationInput"] | undefined | null,
	shiftsManager?: ValueTypes["StaffUpdateShiftsManagerEntityRelationInput"] | undefined | null,
	businessToBusinessManager?: ValueTypes["StaffUpdateBusinessToBusinessManagerEntityRelationInput"] | undefined | null,
	user?: ValueTypes["StaffUpdateUserEntityRelationInput"] | undefined | null,
	stocksManager?: ValueTypes["StaffUpdateStocksManagerEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["StaffUpdatePhotoEntityRelationInput"] | undefined | null,
	courierManager?: ValueTypes["StaffUpdateCourierManagerEntityRelationInput"] | undefined | null,
	picker?: ValueTypes["StaffUpdatePickerEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	remunerationProfile?: ValueTypes["StaffUpdateRemunerationProfileEntityRelationInput"] | undefined | null,
	cashier?: ValueTypes["StaffUpdateCashierEntityRelationInput"] | undefined | null,
	venues?: Array<ValueTypes["StaffUpdateVenuesEntityRelationInput"]> | undefined | null,
	internalBuyer?: ValueTypes["StaffUpdateInternalBuyerEntityRelationInput"] | undefined | null,
	salesManager?: ValueTypes["StaffUpdateSalesManagerEntityRelationInput"] | undefined | null,
	cashierManager?: ValueTypes["StaffUpdateCashierManagerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StaffUpdateBusinessToBusinessManagerEntityRelationInput"]: {
	create?: ValueTypes["BusinessToBusinessManagerWithoutStaffCreateInput"] | undefined | null,
	update?: ValueTypes["BusinessToBusinessManagerWithoutStaffUpdateInput"] | undefined | null,
	upsert?: ValueTypes["StaffUpsertBusinessToBusinessManagerRelationInput"] | undefined | null,
	connect?: ValueTypes["BusinessToBusinessManagerUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["BusinessToBusinessManagerWithoutStaffUpdateInput"]: {
	managedBusinesses?: Array<ValueTypes["BusinessToBusinessManagerUpdateManagedBusinessesEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessToBusinessManagerUpdateManagedBusinessesEntityRelationInput"]: {
	create?: ValueTypes["BusinessCustomerWithoutAccountManagerCreateInput"] | undefined | null,
	update?: ValueTypes["BusinessToBusinessManagerUpdateManagedBusinessesRelationInput"] | undefined | null,
	upsert?: ValueTypes["BusinessToBusinessManagerUpsertManagedBusinessesRelationInput"] | undefined | null,
	connect?: ValueTypes["BusinessCustomerUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["BusinessCustomerUniqueWhere"] | undefined | null,
	delete?: ValueTypes["BusinessCustomerUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["BusinessToBusinessManagerUpdateManagedBusinessesRelationInput"]: {
	by?: ValueTypes["BusinessCustomerUniqueWhere"] | undefined | null,
	data?: ValueTypes["BusinessCustomerWithoutAccountManagerUpdateInput"] | undefined | null
};
	["BusinessCustomerWithoutAccountManagerUpdateInput"]: {
	name?: string | undefined | null,
	customer?: ValueTypes["BusinessCustomerUpdateCustomerEntityRelationInput"] | undefined | null,
	owners?: Array<ValueTypes["BusinessCustomerUpdateOwnersEntityRelationInput"]> | undefined | null,
	members?: Array<ValueTypes["BusinessCustomerUpdateMembersEntityRelationInput"]> | undefined | null,
	category?: ValueTypes["BusinessCustomerUpdateCategoryEntityRelationInput"] | undefined | null,
	logo?: ValueTypes["BusinessCustomerUpdateLogoEntityRelationInput"] | undefined | null,
	note?: string | undefined | null,
	businessServiceEvents?: Array<ValueTypes["BusinessCustomerUpdateBusinessServiceEventsEntityRelationInput"]> | undefined | null,
	doubleshotCoffeeEquipment?: ValueTypes["BusinessCustomerUpdateDoubleshotCoffeeEquipmentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessCustomerUpdateMembersEntityRelationInput"]: {
	create?: ValueTypes["CustomerWithoutMemberOfBusinessesCreateInput"] | undefined | null,
	update?: ValueTypes["BusinessCustomerUpdateMembersRelationInput"] | undefined | null,
	upsert?: ValueTypes["BusinessCustomerUpsertMembersRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	delete?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["BusinessCustomerUpdateMembersRelationInput"]: {
	by?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	data?: ValueTypes["CustomerWithoutMemberOfBusinessesUpdateInput"] | undefined | null
};
	["CustomerWithoutMemberOfBusinessesUpdateInput"]: {
	addresses?: Array<ValueTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerUpdateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerUpdateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerUpdateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerUpdateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]: {
	create?: ValueTypes["BusinessCustomerWithoutOwnersCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerUpdateOwnerOfBusinessesRelationInput"] | undefined | null,
	upsert?: ValueTypes["CustomerUpsertOwnerOfBusinessesRelationInput"] | undefined | null,
	connect?: ValueTypes["BusinessCustomerUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["BusinessCustomerUniqueWhere"] | undefined | null,
	delete?: ValueTypes["BusinessCustomerUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerUpdateOwnerOfBusinessesRelationInput"]: {
	by?: ValueTypes["BusinessCustomerUniqueWhere"] | undefined | null,
	data?: ValueTypes["BusinessCustomerWithoutOwnersUpdateInput"] | undefined | null
};
	["BusinessCustomerWithoutOwnersUpdateInput"]: {
	name?: string | undefined | null,
	customer?: ValueTypes["BusinessCustomerUpdateCustomerEntityRelationInput"] | undefined | null,
	members?: Array<ValueTypes["BusinessCustomerUpdateMembersEntityRelationInput"]> | undefined | null,
	category?: ValueTypes["BusinessCustomerUpdateCategoryEntityRelationInput"] | undefined | null,
	accountManager?: ValueTypes["BusinessCustomerUpdateAccountManagerEntityRelationInput"] | undefined | null,
	logo?: ValueTypes["BusinessCustomerUpdateLogoEntityRelationInput"] | undefined | null,
	note?: string | undefined | null,
	businessServiceEvents?: Array<ValueTypes["BusinessCustomerUpdateBusinessServiceEventsEntityRelationInput"]> | undefined | null,
	doubleshotCoffeeEquipment?: ValueTypes["BusinessCustomerUpdateDoubleshotCoffeeEquipmentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessCustomerUpdateAccountManagerEntityRelationInput"]: {
	create?: ValueTypes["BusinessToBusinessManagerWithoutManagedBusinessesCreateInput"] | undefined | null,
	update?: ValueTypes["BusinessToBusinessManagerWithoutManagedBusinessesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["BusinessCustomerUpsertAccountManagerRelationInput"] | undefined | null,
	connect?: ValueTypes["BusinessToBusinessManagerUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["BusinessToBusinessManagerWithoutManagedBusinessesUpdateInput"]: {
	staff?: ValueTypes["BusinessToBusinessManagerUpdateStaffEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessToBusinessManagerUpdateStaffEntityRelationInput"]: {
	create?: ValueTypes["StaffWithoutBusinessToBusinessManagerCreateInput"] | undefined | null,
	update?: ValueTypes["StaffWithoutBusinessToBusinessManagerUpdateInput"] | undefined | null,
	upsert?: ValueTypes["BusinessToBusinessManagerUpsertStaffRelationInput"] | undefined | null,
	connect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["StaffWithoutBusinessToBusinessManagerUpdateInput"]: {
	bartender?: ValueTypes["StaffUpdateBartenderEntityRelationInput"] | undefined | null,
	courier?: ValueTypes["StaffUpdateCourierEntityRelationInput"] | undefined | null,
	cleaner?: ValueTypes["StaffUpdateCleanerEntityRelationInput"] | undefined | null,
	shiftsManager?: ValueTypes["StaffUpdateShiftsManagerEntityRelationInput"] | undefined | null,
	user?: ValueTypes["StaffUpdateUserEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["StaffUpdateShiftsProfileEntityRelationInput"] | undefined | null,
	stocksManager?: ValueTypes["StaffUpdateStocksManagerEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["StaffUpdatePhotoEntityRelationInput"] | undefined | null,
	courierManager?: ValueTypes["StaffUpdateCourierManagerEntityRelationInput"] | undefined | null,
	picker?: ValueTypes["StaffUpdatePickerEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	remunerationProfile?: ValueTypes["StaffUpdateRemunerationProfileEntityRelationInput"] | undefined | null,
	cashier?: ValueTypes["StaffUpdateCashierEntityRelationInput"] | undefined | null,
	venues?: Array<ValueTypes["StaffUpdateVenuesEntityRelationInput"]> | undefined | null,
	internalBuyer?: ValueTypes["StaffUpdateInternalBuyerEntityRelationInput"] | undefined | null,
	salesManager?: ValueTypes["StaffUpdateSalesManagerEntityRelationInput"] | undefined | null,
	cashierManager?: ValueTypes["StaffUpdateCashierManagerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StaffUpdateUserEntityRelationInput"]: {
	create?: ValueTypes["UserWithoutStaffCreateInput"] | undefined | null,
	update?: ValueTypes["UserWithoutStaffUpdateInput"] | undefined | null,
	upsert?: ValueTypes["StaffUpsertUserRelationInput"] | undefined | null,
	connect?: ValueTypes["UserUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["UserWithoutStaffUpdateInput"]: {
	name?: string | undefined | null,
	internalNote?: string | undefined | null,
	customer?: ValueTypes["UserUpdateCustomerEntityRelationInput"] | undefined | null,
	tenantPersonId?: ValueTypes["UUID"] | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	devices?: Array<ValueTypes["UserUpdateDevicesEntityRelationInput"]> | undefined | null,
	verifiedAt?: ValueTypes["DateTime"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	deletionRequestedAt?: ValueTypes["DateTime"] | undefined | null,
	deletionExpectedAt?: ValueTypes["DateTime"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	meta?: ValueTypes["UserUpdateMetaEntityRelationInput"] | undefined | null,
	identificationAttempts?: Array<ValueTypes["UserUpdateIdentificationAttemptsEntityRelationInput"]> | undefined | null,
	roles?: ValueTypes["UserUpdateRolesEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserUpdateCustomerEntityRelationInput"]: {
	create?: ValueTypes["CustomerWithoutUserCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerWithoutUserUpdateInput"] | undefined | null,
	upsert?: ValueTypes["UserUpsertCustomerRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CustomerWithoutUserUpdateInput"]: {
	addresses?: Array<ValueTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerUpdateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerUpdateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerUpdateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerUpdateCartsEntityRelationInput"]: {
	create?: ValueTypes["CartWithoutCustomerCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerUpdateCartsRelationInput"] | undefined | null,
	upsert?: ValueTypes["CustomerUpsertCartsRelationInput"] | undefined | null,
	connect?: ValueTypes["CartUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["CartUniqueWhere"] | undefined | null,
	delete?: ValueTypes["CartUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerUpdateCartsRelationInput"]: {
	by?: ValueTypes["CartUniqueWhere"] | undefined | null,
	data?: ValueTypes["CartWithoutCustomerUpdateInput"] | undefined | null
};
	["CartWithoutCustomerUpdateInput"]: {
	confirmedAt?: ValueTypes["DateTime"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	items?: Array<ValueTypes["CartUpdateItemsEntityRelationInput"]> | undefined | null,
	handle?: string | undefined | null,
	state?: ValueTypes["CartState"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	channel?: ValueTypes["CartUpdateChannelEntityRelationInput"] | undefined | null,
	order?: ValueTypes["CartUpdateOrderEntityRelationInput"] | undefined | null,
	deliveryAddress?: ValueTypes["CartUpdateDeliveryAddressEntityRelationInput"] | undefined | null,
	billingAddress?: ValueTypes["CartUpdateBillingAddressEntityRelationInput"] | undefined | null,
	deliveryOption?: string | undefined | null,
	paymentOption?: string | undefined | null,
	delivery?: ValueTypes["CartUpdateDeliveryEntityRelationInput"] | undefined | null,
	payment?: ValueTypes["CartUpdatePaymentEntityRelationInput"] | undefined | null,
	billingSubject?: ValueTypes["CartUpdateBillingSubjectEntityRelationInput"] | undefined | null,
	priceLines?: Array<ValueTypes["CartUpdatePriceLinesEntityRelationInput"]> | undefined | null,
	summary?: ValueTypes["CartUpdateSummaryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CartUpdateOrderEntityRelationInput"]: {
	create?: ValueTypes["OrderWithoutCartCreateInput"] | undefined | null,
	update?: ValueTypes["OrderWithoutCartUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CartUpsertOrderRelationInput"] | undefined | null,
	connect?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["OrderWithoutCartUpdateInput"]: {
	state?: ValueTypes["OrderState"] | undefined | null,
	fulfilledAt?: ValueTypes["DateTime"] | undefined | null,
	canceledAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	customer?: ValueTypes["OrderUpdateCustomerEntityRelationInput"] | undefined | null,
	channel?: ValueTypes["OrderUpdateChannelEntityRelationInput"] | undefined | null,
	discounts?: Array<ValueTypes["OrderUpdateDiscountsEntityRelationInput"]> | undefined | null,
	delivery?: ValueTypes["OrderUpdateDeliveryEntityRelationInput"] | undefined | null,
	items?: Array<ValueTypes["OrderUpdateItemsEntityRelationInput"]> | undefined | null,
	internalNote?: string | undefined | null,
	events?: Array<ValueTypes["OrderUpdateEventsEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingAddress?: ValueTypes["OrderUpdateBillingAddressEntityRelationInput"] | undefined | null,
	priceLines?: Array<ValueTypes["OrderUpdatePriceLinesEntityRelationInput"]> | undefined | null,
	payments?: Array<ValueTypes["OrderUpdatePaymentsEntityRelationInput"]> | undefined | null,
	seq?: number | undefined | null,
	billingSubject?: ValueTypes["OrderUpdateBillingSubjectEntityRelationInput"] | undefined | null,
	summary?: ValueTypes["OrderUpdateSummaryEntityRelationInput"] | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	gratuity?: ValueTypes["OrderUpdateGratuityEntityRelationInput"] | undefined | null,
	venue?: ValueTypes["OrderUpdateVenueEntityRelationInput"] | undefined | null,
	fulfillmentNote?: string | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["OrderUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	doubleshotTotalWeightGrams?: number | undefined | null,
	doubleShotLegacyNumber?: string | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	doubleshotAdminUrl?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderUpdateCustomerEntityRelationInput"]: {
	create?: ValueTypes["CustomerWithoutOrdersCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerWithoutOrdersUpdateInput"] | undefined | null,
	upsert?: ValueTypes["OrderUpsertCustomerRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CustomerWithoutOrdersUpdateInput"]: {
	addresses?: Array<ValueTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerUpdateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerUpdateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerUpdateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerUpdateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerUpdateShortcutListEntityRelationInput"]: {
	create?: ValueTypes["ApplicationShortcutListWithoutCustomerCreateInput"] | undefined | null,
	update?: ValueTypes["ApplicationShortcutListWithoutCustomerUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CustomerUpsertShortcutListRelationInput"] | undefined | null,
	connect?: ValueTypes["ApplicationShortcutListUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ApplicationShortcutListWithoutCustomerUpdateInput"]: {
	items?: Array<ValueTypes["ApplicationShortcutListUpdateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ApplicationShortcutListUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["ApplicationShortcutListItemWithoutListCreateInput"] | undefined | null,
	update?: ValueTypes["ApplicationShortcutListUpdateItemsRelationInput"] | undefined | null,
	upsert?: ValueTypes["ApplicationShortcutListUpsertItemsRelationInput"] | undefined | null,
	connect?: ValueTypes["ApplicationShortcutListItemUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ApplicationShortcutListItemUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ApplicationShortcutListItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ApplicationShortcutListUpdateItemsRelationInput"]: {
	by?: ValueTypes["ApplicationShortcutListItemUniqueWhere"] | undefined | null,
	data?: ValueTypes["ApplicationShortcutListItemWithoutListUpdateInput"] | undefined | null
};
	["ApplicationShortcutListItemWithoutListUpdateInput"]: {
	order?: number | undefined | null,
	application?: ValueTypes["ApplicationShortcutListItemUpdateApplicationEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ApplicationShortcutListItemUpdateApplicationEntityRelationInput"]: {
	create?: ValueTypes["ApplicationCreateInput"] | undefined | null,
	update?: ValueTypes["ApplicationUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ApplicationShortcutListItemUpsertApplicationRelationInput"] | undefined | null,
	connect?: ValueTypes["ApplicationUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ApplicationUpdateInput"]: {
	order?: number | undefined | null,
	handle?: string | undefined | null,
	url?: string | undefined | null,
	color?: string | undefined | null,
	icon?: ValueTypes["ApplicationUpdateIconEntityRelationInput"] | undefined | null,
	name?: string | undefined | null,
	short?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ApplicationUpdateIconEntityRelationInput"]: {
	create?: ValueTypes["ImageCreateInput"] | undefined | null,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ApplicationUpsertIconRelationInput"] | undefined | null,
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ApplicationUpsertIconRelationInput"]: {
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["ApplicationShortcutListItemUpsertApplicationRelationInput"]: {
	update?: ValueTypes["ApplicationUpdateInput"] | undefined | null,
	create?: ValueTypes["ApplicationCreateInput"] | undefined | null
};
	["ApplicationShortcutListUpsertItemsRelationInput"]: {
	by?: ValueTypes["ApplicationShortcutListItemUniqueWhere"] | undefined | null,
	update?: ValueTypes["ApplicationShortcutListItemWithoutListUpdateInput"] | undefined | null,
	create?: ValueTypes["ApplicationShortcutListItemWithoutListCreateInput"] | undefined | null
};
	["CustomerUpsertShortcutListRelationInput"]: {
	update?: ValueTypes["ApplicationShortcutListWithoutCustomerUpdateInput"] | undefined | null,
	create?: ValueTypes["ApplicationShortcutListWithoutCustomerCreateInput"] | undefined | null
};
	["CustomerUpdateUserEntityRelationInput"]: {
	create?: ValueTypes["UserWithoutCustomerCreateInput"] | undefined | null,
	update?: ValueTypes["UserWithoutCustomerUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CustomerUpsertUserRelationInput"] | undefined | null,
	connect?: ValueTypes["UserUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["UserWithoutCustomerUpdateInput"]: {
	name?: string | undefined | null,
	internalNote?: string | undefined | null,
	staff?: ValueTypes["UserUpdateStaffEntityRelationInput"] | undefined | null,
	tenantPersonId?: ValueTypes["UUID"] | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	devices?: Array<ValueTypes["UserUpdateDevicesEntityRelationInput"]> | undefined | null,
	verifiedAt?: ValueTypes["DateTime"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	deletionRequestedAt?: ValueTypes["DateTime"] | undefined | null,
	deletionExpectedAt?: ValueTypes["DateTime"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	meta?: ValueTypes["UserUpdateMetaEntityRelationInput"] | undefined | null,
	identificationAttempts?: Array<ValueTypes["UserUpdateIdentificationAttemptsEntityRelationInput"]> | undefined | null,
	roles?: ValueTypes["UserUpdateRolesEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserUpdateStaffEntityRelationInput"]: {
	create?: ValueTypes["StaffWithoutUserCreateInput"] | undefined | null,
	update?: ValueTypes["StaffWithoutUserUpdateInput"] | undefined | null,
	upsert?: ValueTypes["UserUpsertStaffRelationInput"] | undefined | null,
	connect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["StaffWithoutUserUpdateInput"]: {
	bartender?: ValueTypes["StaffUpdateBartenderEntityRelationInput"] | undefined | null,
	courier?: ValueTypes["StaffUpdateCourierEntityRelationInput"] | undefined | null,
	cleaner?: ValueTypes["StaffUpdateCleanerEntityRelationInput"] | undefined | null,
	shiftsManager?: ValueTypes["StaffUpdateShiftsManagerEntityRelationInput"] | undefined | null,
	businessToBusinessManager?: ValueTypes["StaffUpdateBusinessToBusinessManagerEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["StaffUpdateShiftsProfileEntityRelationInput"] | undefined | null,
	stocksManager?: ValueTypes["StaffUpdateStocksManagerEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["StaffUpdatePhotoEntityRelationInput"] | undefined | null,
	courierManager?: ValueTypes["StaffUpdateCourierManagerEntityRelationInput"] | undefined | null,
	picker?: ValueTypes["StaffUpdatePickerEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	remunerationProfile?: ValueTypes["StaffUpdateRemunerationProfileEntityRelationInput"] | undefined | null,
	cashier?: ValueTypes["StaffUpdateCashierEntityRelationInput"] | undefined | null,
	venues?: Array<ValueTypes["StaffUpdateVenuesEntityRelationInput"]> | undefined | null,
	internalBuyer?: ValueTypes["StaffUpdateInternalBuyerEntityRelationInput"] | undefined | null,
	salesManager?: ValueTypes["StaffUpdateSalesManagerEntityRelationInput"] | undefined | null,
	cashierManager?: ValueTypes["StaffUpdateCashierManagerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StaffUpdateShiftsProfileEntityRelationInput"]: {
	create?: ValueTypes["ShiftsProfileWithoutStaffCreateInput"] | undefined | null,
	update?: ValueTypes["ShiftsProfileWithoutStaffUpdateInput"] | undefined | null,
	upsert?: ValueTypes["StaffUpsertShiftsProfileRelationInput"] | undefined | null,
	connect?: ValueTypes["ShiftsProfileUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ShiftsProfileWithoutStaffUpdateInput"]: {
	queueItems?: Array<ValueTypes["ShiftsProfileUpdateQueueItemsEntityRelationInput"]> | undefined | null,
	roles?: Array<ValueTypes["ShiftsProfileUpdateRolesEntityRelationInput"]> | undefined | null,
	shifts?: Array<ValueTypes["ShiftsProfileUpdateShiftsEntityRelationInput"]> | undefined | null,
	allowSelfUnassigning?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ShiftsProfileUpdateRolesEntityRelationInput"]: {
	create?: ValueTypes["TimetableEmployeeRoleWithoutShiftsProfilesCreateInput"] | undefined | null,
	update?: ValueTypes["ShiftsProfileUpdateRolesRelationInput"] | undefined | null,
	upsert?: ValueTypes["ShiftsProfileUpsertRolesRelationInput"] | undefined | null,
	connect?: ValueTypes["TimetableEmployeeRoleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["TimetableEmployeeRoleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["TimetableEmployeeRoleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ShiftsProfileUpdateRolesRelationInput"]: {
	by?: ValueTypes["TimetableEmployeeRoleUniqueWhere"] | undefined | null,
	data?: ValueTypes["TimetableEmployeeRoleWithoutShiftsProfilesUpdateInput"] | undefined | null
};
	["TimetableEmployeeRoleWithoutShiftsProfilesUpdateInput"]: {
	shiftGroups?: Array<ValueTypes["TimetableEmployeeRoleUpdateShiftGroupsEntityRelationInput"]> | undefined | null,
	shiftsManagers?: Array<ValueTypes["TimetableEmployeeRoleUpdateShiftsManagersEntityRelationInput"]> | undefined | null,
	name?: string | undefined | null,
	timetableTemplates?: Array<ValueTypes["TimetableEmployeeRoleUpdateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	color?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableEmployeeRoleUpdateShiftsManagersEntityRelationInput"]: {
	create?: ValueTypes["ShiftsManagerWithoutManagedRolesCreateInput"] | undefined | null,
	update?: ValueTypes["TimetableEmployeeRoleUpdateShiftsManagersRelationInput"] | undefined | null,
	upsert?: ValueTypes["TimetableEmployeeRoleUpsertShiftsManagersRelationInput"] | undefined | null,
	connect?: ValueTypes["ShiftsManagerUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ShiftsManagerUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ShiftsManagerUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["TimetableEmployeeRoleUpdateShiftsManagersRelationInput"]: {
	by?: ValueTypes["ShiftsManagerUniqueWhere"] | undefined | null,
	data?: ValueTypes["ShiftsManagerWithoutManagedRolesUpdateInput"] | undefined | null
};
	["ShiftsManagerWithoutManagedRolesUpdateInput"]: {
	staff?: ValueTypes["ShiftsManagerUpdateStaffEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ShiftsManagerUpdateStaffEntityRelationInput"]: {
	create?: ValueTypes["StaffWithoutShiftsManagerCreateInput"] | undefined | null,
	update?: ValueTypes["StaffWithoutShiftsManagerUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ShiftsManagerUpsertStaffRelationInput"] | undefined | null,
	connect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["StaffWithoutShiftsManagerUpdateInput"]: {
	bartender?: ValueTypes["StaffUpdateBartenderEntityRelationInput"] | undefined | null,
	courier?: ValueTypes["StaffUpdateCourierEntityRelationInput"] | undefined | null,
	cleaner?: ValueTypes["StaffUpdateCleanerEntityRelationInput"] | undefined | null,
	businessToBusinessManager?: ValueTypes["StaffUpdateBusinessToBusinessManagerEntityRelationInput"] | undefined | null,
	user?: ValueTypes["StaffUpdateUserEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["StaffUpdateShiftsProfileEntityRelationInput"] | undefined | null,
	stocksManager?: ValueTypes["StaffUpdateStocksManagerEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["StaffUpdatePhotoEntityRelationInput"] | undefined | null,
	courierManager?: ValueTypes["StaffUpdateCourierManagerEntityRelationInput"] | undefined | null,
	picker?: ValueTypes["StaffUpdatePickerEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	remunerationProfile?: ValueTypes["StaffUpdateRemunerationProfileEntityRelationInput"] | undefined | null,
	cashier?: ValueTypes["StaffUpdateCashierEntityRelationInput"] | undefined | null,
	venues?: Array<ValueTypes["StaffUpdateVenuesEntityRelationInput"]> | undefined | null,
	internalBuyer?: ValueTypes["StaffUpdateInternalBuyerEntityRelationInput"] | undefined | null,
	salesManager?: ValueTypes["StaffUpdateSalesManagerEntityRelationInput"] | undefined | null,
	cashierManager?: ValueTypes["StaffUpdateCashierManagerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StaffUpdateStocksManagerEntityRelationInput"]: {
	create?: ValueTypes["StocksManagerWithoutStaffCreateInput"] | undefined | null,
	update?: ValueTypes["StocksManagerWithoutStaffUpdateInput"] | undefined | null,
	upsert?: ValueTypes["StaffUpsertStocksManagerRelationInput"] | undefined | null,
	connect?: ValueTypes["StocksManagerUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["StocksManagerWithoutStaffUpdateInput"]: {
	managedProducts?: Array<ValueTypes["StocksManagerUpdateManagedProductsEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StocksManagerUpdateManagedProductsEntityRelationInput"]: {
	create?: ValueTypes["ProductWithoutManagerCreateInput"] | undefined | null,
	update?: ValueTypes["StocksManagerUpdateManagedProductsRelationInput"] | undefined | null,
	upsert?: ValueTypes["StocksManagerUpsertManagedProductsRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["StocksManagerUpdateManagedProductsRelationInput"]: {
	by?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	data?: ValueTypes["ProductWithoutManagerUpdateInput"] | undefined | null
};
	["ProductWithoutManagerUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	priceCents?: number | undefined | null,
	notDiscountable?: boolean | undefined | null,
	packing?: ValueTypes["ProductUpdatePackingEntityRelationInput"] | undefined | null,
	recipe?: ValueTypes["ProductUpdateRecipeEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["ProductUpdateTagsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["ProductUpdateCategoriesEntityRelationInput"]> | undefined | null,
	vatRate?: ValueTypes["ProductUpdateVatRateEntityRelationInput"] | undefined | null,
	stocks?: Array<ValueTypes["ProductUpdateStocksEntityRelationInput"]> | undefined | null,
	groupPrices?: Array<ValueTypes["ProductUpdateGroupPricesEntityRelationInput"]> | undefined | null,
	image?: ValueTypes["ProductUpdateImageEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	cartItems?: Array<ValueTypes["ProductUpdateCartItemsEntityRelationInput"]> | undefined | null,
	availability?: ValueTypes["ProductAvailability"] | undefined | null,
	order?: number | undefined | null,
	orderItems?: Array<ValueTypes["ProductUpdateOrderItemsEntityRelationInput"]> | undefined | null,
	maximumQuantityPerOrder?: number | undefined | null,
	inheritedCategories?: Array<ValueTypes["ProductUpdateInheritedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["ProductUpdateDeliveryZonesEntityRelationInput"]> | undefined | null,
	locales?: Array<ValueTypes["ProductUpdateLocalesEntityRelationInput"]> | undefined | null,
	archivedAt?: ValueTypes["DateTime"] | undefined | null,
	customerPrices?: Array<ValueTypes["ProductUpdateCustomerPricesEntityRelationInput"]> | undefined | null,
	virtualProduct?: ValueTypes["ProductUpdateVirtualProductEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["ProductUpdateMetaEntityRelationInput"] | undefined | null,
	page?: ValueTypes["ProductUpdatePageEntityRelationInput"] | undefined | null,
	salesDays?: Array<ValueTypes["ProductUpdateSalesDaysEntityRelationInput"]> | undefined | null,
	salesWeeks?: Array<ValueTypes["ProductUpdateSalesWeeksEntityRelationInput"]> | undefined | null,
	salesMonths?: Array<ValueTypes["ProductUpdateSalesMonthsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["ProductUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	hasSubscription?: boolean | undefined | null,
	pointOfSaleTileColor?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductUpdateOrderItemsEntityRelationInput"]: {
	create?: ValueTypes["OrderItemWithoutProductCreateInput"] | undefined | null,
	update?: ValueTypes["ProductUpdateOrderItemsRelationInput"] | undefined | null,
	upsert?: ValueTypes["ProductUpsertOrderItemsRelationInput"] | undefined | null,
	connect?: ValueTypes["OrderItemUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["OrderItemUniqueWhere"] | undefined | null,
	delete?: ValueTypes["OrderItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductUpdateOrderItemsRelationInput"]: {
	by?: ValueTypes["OrderItemUniqueWhere"] | undefined | null,
	data?: ValueTypes["OrderItemWithoutProductUpdateInput"] | undefined | null
};
	["OrderItemWithoutProductUpdateInput"]: {
	unitPriceCents?: number | undefined | null,
	quantity?: number | undefined | null,
	vatRate?: ValueTypes["OrderItemUpdateVatRateEntityRelationInput"] | undefined | null,
	order?: ValueTypes["OrderItemUpdateOrderEntityRelationInput"] | undefined | null,
	virtualProductEffects?: Array<ValueTypes["OrderItemUpdateVirtualProductEffectsEntityRelationInput"]> | undefined | null,
	pickedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["OrderItemUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderItemUpdateVatRateEntityRelationInput"]: {
	create?: ValueTypes["VatRateCreateInput"] | undefined | null,
	update?: ValueTypes["VatRateUpdateInput"] | undefined | null,
	upsert?: ValueTypes["OrderItemUpsertVatRateRelationInput"] | undefined | null,
	connect?: ValueTypes["VatRateUniqueWhere"] | undefined | null
};
	["OrderItemUpsertVatRateRelationInput"]: {
	update?: ValueTypes["VatRateUpdateInput"] | undefined | null,
	create?: ValueTypes["VatRateCreateInput"] | undefined | null
};
	["OrderItemUpdateOrderEntityRelationInput"]: {
	create?: ValueTypes["OrderWithoutItemsCreateInput"] | undefined | null,
	update?: ValueTypes["OrderWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["OrderItemUpsertOrderRelationInput"] | undefined | null,
	connect?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["OrderWithoutItemsUpdateInput"]: {
	state?: ValueTypes["OrderState"] | undefined | null,
	fulfilledAt?: ValueTypes["DateTime"] | undefined | null,
	canceledAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	customer?: ValueTypes["OrderUpdateCustomerEntityRelationInput"] | undefined | null,
	channel?: ValueTypes["OrderUpdateChannelEntityRelationInput"] | undefined | null,
	discounts?: Array<ValueTypes["OrderUpdateDiscountsEntityRelationInput"]> | undefined | null,
	delivery?: ValueTypes["OrderUpdateDeliveryEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	cart?: ValueTypes["OrderUpdateCartEntityRelationInput"] | undefined | null,
	events?: Array<ValueTypes["OrderUpdateEventsEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingAddress?: ValueTypes["OrderUpdateBillingAddressEntityRelationInput"] | undefined | null,
	priceLines?: Array<ValueTypes["OrderUpdatePriceLinesEntityRelationInput"]> | undefined | null,
	payments?: Array<ValueTypes["OrderUpdatePaymentsEntityRelationInput"]> | undefined | null,
	seq?: number | undefined | null,
	billingSubject?: ValueTypes["OrderUpdateBillingSubjectEntityRelationInput"] | undefined | null,
	summary?: ValueTypes["OrderUpdateSummaryEntityRelationInput"] | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	gratuity?: ValueTypes["OrderUpdateGratuityEntityRelationInput"] | undefined | null,
	venue?: ValueTypes["OrderUpdateVenueEntityRelationInput"] | undefined | null,
	fulfillmentNote?: string | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["OrderUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	doubleshotTotalWeightGrams?: number | undefined | null,
	doubleShotLegacyNumber?: string | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	doubleshotAdminUrl?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderUpdateDiscountsEntityRelationInput"]: {
	create?: ValueTypes["OrderDiscountWithoutOrderCreateInput"] | undefined | null,
	update?: ValueTypes["OrderUpdateDiscountsRelationInput"] | undefined | null,
	upsert?: ValueTypes["OrderUpsertDiscountsRelationInput"] | undefined | null,
	connect?: ValueTypes["OrderDiscountUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["OrderDiscountUniqueWhere"] | undefined | null,
	delete?: ValueTypes["OrderDiscountUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["OrderUpdateDiscountsRelationInput"]: {
	by?: ValueTypes["OrderDiscountUniqueWhere"] | undefined | null,
	data?: ValueTypes["OrderDiscountWithoutOrderUpdateInput"] | undefined | null
};
	["OrderDiscountWithoutOrderUpdateInput"]: {
	discountCents?: number | undefined | null,
	vatRate?: ValueTypes["OrderDiscountUpdateVatRateEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	type?: ValueTypes["OrderDiscountType"] | undefined | null,
	customerCreditTransactions?: Array<ValueTypes["OrderDiscountUpdateCustomerCreditTransactionsEntityRelationInput"]> | undefined | null,
	voucherRedemption?: ValueTypes["OrderDiscountUpdateVoucherRedemptionEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderDiscountUpdateVatRateEntityRelationInput"]: {
	create?: ValueTypes["VatRateCreateInput"] | undefined | null,
	update?: ValueTypes["VatRateUpdateInput"] | undefined | null,
	upsert?: ValueTypes["OrderDiscountUpsertVatRateRelationInput"] | undefined | null,
	connect?: ValueTypes["VatRateUniqueWhere"] | undefined | null
};
	["OrderDiscountUpsertVatRateRelationInput"]: {
	update?: ValueTypes["VatRateUpdateInput"] | undefined | null,
	create?: ValueTypes["VatRateCreateInput"] | undefined | null
};
	["OrderDiscountUpdateCustomerCreditTransactionsEntityRelationInput"]: {
	create?: ValueTypes["CustomerCreditTransactionWithoutOrderDiscountCreateInput"] | undefined | null,
	update?: ValueTypes["OrderDiscountUpdateCustomerCreditTransactionsRelationInput"] | undefined | null,
	upsert?: ValueTypes["OrderDiscountUpsertCustomerCreditTransactionsRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerCreditTransactionUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["CustomerCreditTransactionUniqueWhere"] | undefined | null,
	delete?: ValueTypes["CustomerCreditTransactionUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["OrderDiscountUpdateCustomerCreditTransactionsRelationInput"]: {
	by?: ValueTypes["CustomerCreditTransactionUniqueWhere"] | undefined | null,
	data?: ValueTypes["CustomerCreditTransactionWithoutOrderDiscountUpdateInput"] | undefined | null
};
	["CustomerCreditTransactionWithoutOrderDiscountUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	amountCents?: number | undefined | null,
	customerCredit?: ValueTypes["CustomerCreditTransactionUpdateCustomerCreditEntityRelationInput"] | undefined | null,
	virtualProductEffect?: ValueTypes["CustomerCreditTransactionUpdateVirtualProductEffectEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreditTransactionUpdateCustomerCreditEntityRelationInput"]: {
	create?: ValueTypes["CustomerCreditWithoutTransactionsCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerCreditWithoutTransactionsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CustomerCreditTransactionUpsertCustomerCreditRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerCreditUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CustomerCreditWithoutTransactionsUpdateInput"]: {
	initialCreditCents?: number | undefined | null,
	remainingCreditsCents?: number | undefined | null,
	expiresAt?: ValueTypes["DateTime"] | undefined | null,
	reason?: string | undefined | null,
	customer?: ValueTypes["CustomerCreditUpdateCustomerEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["CustomerCreditUpdateVatRateEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	voucherRedemption?: ValueTypes["CustomerCreditUpdateVoucherRedemptionEntityRelationInput"] | undefined | null,
	invoiceUrl?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreditUpdateCustomerEntityRelationInput"]: {
	create?: ValueTypes["CustomerWithoutCreditsCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerWithoutCreditsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CustomerCreditUpsertCustomerRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null
};
	["CustomerWithoutCreditsUpdateInput"]: {
	addresses?: Array<ValueTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerUpdateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerUpdateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerUpdateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerUpdateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerUpdateChannelsEntityRelationInput"]: {
	create?: ValueTypes["ChannelWithoutCustomersCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerUpdateChannelsRelationInput"] | undefined | null,
	upsert?: ValueTypes["CustomerUpsertChannelsRelationInput"] | undefined | null,
	connect?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerUpdateChannelsRelationInput"]: {
	by?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	data?: ValueTypes["ChannelWithoutCustomersUpdateInput"] | undefined | null
};
	["ChannelWithoutCustomersUpdateInput"]: {
	name?: string | undefined | null,
	disabled?: boolean | undefined | null,
	payments?: Array<ValueTypes["ChannelUpdatePaymentsEntityRelationInput"]> | undefined | null,
	deliveries?: Array<ValueTypes["ChannelUpdateDeliveriesEntityRelationInput"]> | undefined | null,
	pointOfSales?: Array<ValueTypes["ChannelUpdatePointOfSalesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["ChannelUpdateCartsEntityRelationInput"]> | undefined | null,
	code?: ValueTypes["ChannelCode"] | undefined | null,
	addTagsOnRegistration?: Array<ValueTypes["ChannelUpdateAddTagsOnRegistrationEntityRelationInput"]> | undefined | null,
	publicTags?: Array<ValueTypes["ChannelUpdatePublicTagsEntityRelationInput"]> | undefined | null,
	venue?: ValueTypes["ChannelUpdateVenueEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ChannelUpdatePublicTagsEntityRelationInput"]: {
	create?: ValueTypes["TagWithoutPublicInChannelsCreateInput"] | undefined | null,
	update?: ValueTypes["ChannelUpdatePublicTagsRelationInput"] | undefined | null,
	upsert?: ValueTypes["ChannelUpsertPublicTagsRelationInput"] | undefined | null,
	connect?: ValueTypes["TagUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["TagUniqueWhere"] | undefined | null,
	delete?: ValueTypes["TagUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ChannelUpdatePublicTagsRelationInput"]: {
	by?: ValueTypes["TagUniqueWhere"] | undefined | null,
	data?: ValueTypes["TagWithoutPublicInChannelsUpdateInput"] | undefined | null
};
	["TagWithoutPublicInChannelsUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	customers?: Array<ValueTypes["TagUpdateCustomersEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["TagUpdateProductsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["TagUpdateCategoriesEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	addTagsOnRegistration?: Array<ValueTypes["TagUpdateAddTagsOnRegistrationEntityRelationInput"]> | undefined | null,
	nestedCategories?: Array<ValueTypes["TagUpdateNestedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["TagUpdateDeliveryZonesEntityRelationInput"]> | undefined | null,
	allowChannelPayments?: Array<ValueTypes["TagUpdateAllowChannelPaymentsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["TagUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TagUpdateAllowChannelPaymentsEntityRelationInput"]: {
	create?: ValueTypes["ChannelPaymentWithoutAllowOnlyForTagsCreateInput"] | undefined | null,
	update?: ValueTypes["TagUpdateAllowChannelPaymentsRelationInput"] | undefined | null,
	upsert?: ValueTypes["TagUpsertAllowChannelPaymentsRelationInput"] | undefined | null,
	connect?: ValueTypes["ChannelPaymentUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ChannelPaymentUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ChannelPaymentUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["TagUpdateAllowChannelPaymentsRelationInput"]: {
	by?: ValueTypes["ChannelPaymentUniqueWhere"] | undefined | null,
	data?: ValueTypes["ChannelPaymentWithoutAllowOnlyForTagsUpdateInput"] | undefined | null
};
	["ChannelPaymentWithoutAllowOnlyForTagsUpdateInput"]: {
	order?: number | undefined | null,
	channel?: ValueTypes["ChannelPaymentUpdateChannelEntityRelationInput"] | undefined | null,
	method?: ValueTypes["ChannelPaymentUpdateMethodEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["ChannelPaymentUpdateVatRateEntityRelationInput"] | undefined | null,
	requireBillingAddress?: boolean | undefined | null,
	provideReceipt?: boolean | undefined | null,
	requireBillingSubject?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ChannelPaymentUpdateVatRateEntityRelationInput"]: {
	create?: ValueTypes["VatRateWithoutChannelPaymentsCreateInput"] | undefined | null,
	update?: ValueTypes["VatRateWithoutChannelPaymentsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ChannelPaymentUpsertVatRateRelationInput"] | undefined | null,
	connect?: ValueTypes["VatRateUniqueWhere"] | undefined | null
};
	["VatRateWithoutChannelPaymentsUpdateInput"]: {
	name?: string | undefined | null,
	ratePermille?: number | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	channelDeliveries?: Array<ValueTypes["VatRateUpdateChannelDeliveriesEntityRelationInput"]> | undefined | null,
	preset?: ValueTypes["VatRatePreset"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ChannelPaymentUpsertVatRateRelationInput"]: {
	update?: ValueTypes["VatRateWithoutChannelPaymentsUpdateInput"] | undefined | null,
	create?: ValueTypes["VatRateWithoutChannelPaymentsCreateInput"] | undefined | null
};
	["TagUpsertAllowChannelPaymentsRelationInput"]: {
	by?: ValueTypes["ChannelPaymentUniqueWhere"] | undefined | null,
	update?: ValueTypes["ChannelPaymentWithoutAllowOnlyForTagsUpdateInput"] | undefined | null,
	create?: ValueTypes["ChannelPaymentWithoutAllowOnlyForTagsCreateInput"] | undefined | null
};
	["TagUpdateFulfillmentNotesEntityRelationInput"]: {
	create?: ValueTypes["FulfillmentNoteWithoutTagsCreateInput"] | undefined | null,
	update?: ValueTypes["TagUpdateFulfillmentNotesRelationInput"] | undefined | null,
	upsert?: ValueTypes["TagUpsertFulfillmentNotesRelationInput"] | undefined | null,
	connect?: ValueTypes["FulfillmentNoteUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["FulfillmentNoteUniqueWhere"] | undefined | null,
	delete?: ValueTypes["FulfillmentNoteUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["TagUpdateFulfillmentNotesRelationInput"]: {
	by?: ValueTypes["FulfillmentNoteUniqueWhere"] | undefined | null,
	data?: ValueTypes["FulfillmentNoteWithoutTagsUpdateInput"] | undefined | null
};
	["FulfillmentNoteWithoutTagsUpdateInput"]: {
	note?: string | undefined | null,
	products?: Array<ValueTypes["FulfillmentNoteUpdateProductsEntityRelationInput"]> | undefined | null,
	venues?: Array<ValueTypes["FulfillmentNoteUpdateVenuesEntityRelationInput"]> | undefined | null,
	cartItems?: Array<ValueTypes["FulfillmentNoteUpdateCartItemsEntityRelationInput"]> | undefined | null,
	orderItems?: Array<ValueTypes["FulfillmentNoteUpdateOrderItemsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["FulfillmentNoteUpdateOrdersEntityRelationInput"]> | undefined | null,
	highlight?: boolean | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	emoji?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FulfillmentNoteUpdateProductsEntityRelationInput"]: {
	create?: ValueTypes["ProductWithoutFulfillmentNotesCreateInput"] | undefined | null,
	update?: ValueTypes["FulfillmentNoteUpdateProductsRelationInput"] | undefined | null,
	upsert?: ValueTypes["FulfillmentNoteUpsertProductsRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["FulfillmentNoteUpdateProductsRelationInput"]: {
	by?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	data?: ValueTypes["ProductWithoutFulfillmentNotesUpdateInput"] | undefined | null
};
	["ProductWithoutFulfillmentNotesUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	priceCents?: number | undefined | null,
	notDiscountable?: boolean | undefined | null,
	packing?: ValueTypes["ProductUpdatePackingEntityRelationInput"] | undefined | null,
	recipe?: ValueTypes["ProductUpdateRecipeEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["ProductUpdateTagsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["ProductUpdateCategoriesEntityRelationInput"]> | undefined | null,
	vatRate?: ValueTypes["ProductUpdateVatRateEntityRelationInput"] | undefined | null,
	stocks?: Array<ValueTypes["ProductUpdateStocksEntityRelationInput"]> | undefined | null,
	groupPrices?: Array<ValueTypes["ProductUpdateGroupPricesEntityRelationInput"]> | undefined | null,
	image?: ValueTypes["ProductUpdateImageEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	cartItems?: Array<ValueTypes["ProductUpdateCartItemsEntityRelationInput"]> | undefined | null,
	availability?: ValueTypes["ProductAvailability"] | undefined | null,
	order?: number | undefined | null,
	manager?: ValueTypes["ProductUpdateManagerEntityRelationInput"] | undefined | null,
	orderItems?: Array<ValueTypes["ProductUpdateOrderItemsEntityRelationInput"]> | undefined | null,
	maximumQuantityPerOrder?: number | undefined | null,
	inheritedCategories?: Array<ValueTypes["ProductUpdateInheritedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["ProductUpdateDeliveryZonesEntityRelationInput"]> | undefined | null,
	locales?: Array<ValueTypes["ProductUpdateLocalesEntityRelationInput"]> | undefined | null,
	archivedAt?: ValueTypes["DateTime"] | undefined | null,
	customerPrices?: Array<ValueTypes["ProductUpdateCustomerPricesEntityRelationInput"]> | undefined | null,
	virtualProduct?: ValueTypes["ProductUpdateVirtualProductEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["ProductUpdateMetaEntityRelationInput"] | undefined | null,
	page?: ValueTypes["ProductUpdatePageEntityRelationInput"] | undefined | null,
	salesDays?: Array<ValueTypes["ProductUpdateSalesDaysEntityRelationInput"]> | undefined | null,
	salesWeeks?: Array<ValueTypes["ProductUpdateSalesWeeksEntityRelationInput"]> | undefined | null,
	salesMonths?: Array<ValueTypes["ProductUpdateSalesMonthsEntityRelationInput"]> | undefined | null,
	hasSubscription?: boolean | undefined | null,
	pointOfSaleTileColor?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductUpdateInheritedCategoriesEntityRelationInput"]: {
	connect?: ValueTypes["NestedProductCategoryProductUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["NestedProductCategoryProductUniqueWhere"] | undefined | null,
	delete?: ValueTypes["NestedProductCategoryProductUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductUpdateDeliveryZonesEntityRelationInput"]: {
	create?: ValueTypes["DeliveryZoneWithoutDeliveryZonesOfProductsCreateInput"] | undefined | null,
	update?: ValueTypes["ProductUpdateDeliveryZonesRelationInput"] | undefined | null,
	upsert?: ValueTypes["ProductUpsertDeliveryZonesRelationInput"] | undefined | null,
	connect?: ValueTypes["DeliveryZoneUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["DeliveryZoneUniqueWhere"] | undefined | null,
	delete?: ValueTypes["DeliveryZoneUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductUpdateDeliveryZonesRelationInput"]: {
	by?: ValueTypes["DeliveryZoneUniqueWhere"] | undefined | null,
	data?: ValueTypes["DeliveryZoneWithoutDeliveryZonesOfProductsUpdateInput"] | undefined | null
};
	["DeliveryZoneWithoutDeliveryZonesOfProductsUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	type?: ValueTypes["DeliveryZoneType"] | undefined | null,
	addresses?: Array<ValueTypes["DeliveryZoneUpdateAddressesEntityRelationInput"]> | undefined | null,
	suitableDeliveryMethods?: Array<ValueTypes["DeliveryZoneUpdateSuitableDeliveryMethodsEntityRelationInput"]> | undefined | null,
	deliveryZonesOfTags?: Array<ValueTypes["DeliveryZoneUpdateDeliveryZonesOfTagsEntityRelationInput"]> | undefined | null,
	addressesMetadata?: Array<ValueTypes["DeliveryZoneUpdateAddressesMetadataEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryZoneUpdateDeliveryZonesOfTagsEntityRelationInput"]: {
	create?: ValueTypes["TagWithoutDeliveryZonesCreateInput"] | undefined | null,
	update?: ValueTypes["DeliveryZoneUpdateDeliveryZonesOfTagsRelationInput"] | undefined | null,
	upsert?: ValueTypes["DeliveryZoneUpsertDeliveryZonesOfTagsRelationInput"] | undefined | null,
	connect?: ValueTypes["TagUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["TagUniqueWhere"] | undefined | null,
	delete?: ValueTypes["TagUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["DeliveryZoneUpdateDeliveryZonesOfTagsRelationInput"]: {
	by?: ValueTypes["TagUniqueWhere"] | undefined | null,
	data?: ValueTypes["TagWithoutDeliveryZonesUpdateInput"] | undefined | null
};
	["TagWithoutDeliveryZonesUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	customers?: Array<ValueTypes["TagUpdateCustomersEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["TagUpdateProductsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["TagUpdateCategoriesEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	addTagsOnRegistration?: Array<ValueTypes["TagUpdateAddTagsOnRegistrationEntityRelationInput"]> | undefined | null,
	nestedCategories?: Array<ValueTypes["TagUpdateNestedCategoriesEntityRelationInput"]> | undefined | null,
	publicInChannels?: Array<ValueTypes["TagUpdatePublicInChannelsEntityRelationInput"]> | undefined | null,
	allowChannelPayments?: Array<ValueTypes["TagUpdateAllowChannelPaymentsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["TagUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TagUpdatePublicInChannelsEntityRelationInput"]: {
	create?: ValueTypes["ChannelWithoutPublicTagsCreateInput"] | undefined | null,
	update?: ValueTypes["TagUpdatePublicInChannelsRelationInput"] | undefined | null,
	upsert?: ValueTypes["TagUpsertPublicInChannelsRelationInput"] | undefined | null,
	connect?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["TagUpdatePublicInChannelsRelationInput"]: {
	by?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	data?: ValueTypes["ChannelWithoutPublicTagsUpdateInput"] | undefined | null
};
	["ChannelWithoutPublicTagsUpdateInput"]: {
	name?: string | undefined | null,
	disabled?: boolean | undefined | null,
	payments?: Array<ValueTypes["ChannelUpdatePaymentsEntityRelationInput"]> | undefined | null,
	deliveries?: Array<ValueTypes["ChannelUpdateDeliveriesEntityRelationInput"]> | undefined | null,
	pointOfSales?: Array<ValueTypes["ChannelUpdatePointOfSalesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["ChannelUpdateCartsEntityRelationInput"]> | undefined | null,
	customers?: Array<ValueTypes["ChannelUpdateCustomersEntityRelationInput"]> | undefined | null,
	code?: ValueTypes["ChannelCode"] | undefined | null,
	addTagsOnRegistration?: Array<ValueTypes["ChannelUpdateAddTagsOnRegistrationEntityRelationInput"]> | undefined | null,
	venue?: ValueTypes["ChannelUpdateVenueEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ChannelUpdateVenueEntityRelationInput"]: {
	create?: ValueTypes["VenueWithoutChannelsCreateInput"] | undefined | null,
	update?: ValueTypes["VenueWithoutChannelsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ChannelUpsertVenueRelationInput"] | undefined | null,
	connect?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["VenueWithoutChannelsUpdateInput"]: {
	name?: string | undefined | null,
	deadlineTemplate?: ValueTypes["VenueUpdateDeadlineTemplateEntityRelationInput"] | undefined | null,
	timetableDays?: Array<ValueTypes["VenueUpdateTimetableDaysEntityRelationInput"]> | undefined | null,
	timetableTemplates?: Array<ValueTypes["VenueUpdateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	staffMembers?: Array<ValueTypes["VenueUpdateStaffMembersEntityRelationInput"]> | undefined | null,
	employeeRoles?: Array<ValueTypes["VenueUpdateEmployeeRolesEntityRelationInput"]> | undefined | null,
	pointOfSaleApplicationDevices?: Array<ValueTypes["VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined | null,
	pointOfSaleTerminals?: Array<ValueTypes["VenueUpdatePointOfSaleTerminalsEntityRelationInput"]> | undefined | null,
	pointOfSalePrinters?: Array<ValueTypes["VenueUpdatePointOfSalePrintersEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["VenueUpdateOrdersEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["VenueUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	areas?: Array<ValueTypes["VenueUpdateAreasEntityRelationInput"]> | undefined | null,
	enabledUnassignReasons?: Array<ValueTypes["VenueUpdateEnabledUnassignReasonsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["VenueUpdateCategoriesEntityRelationInput"]> | undefined | null,
	address?: string | undefined | null,
	pointOfSalePngBase64ReceiptLogo?: string | undefined | null,
	pointOfSaleInitialView?: ValueTypes["PointOfSaleInitialView"] | undefined | null,
	pointOfSalePreferPrintReceipt?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VenueUpdateDeadlineTemplateEntityRelationInput"]: {
	create?: ValueTypes["DeadlineTemplateWithoutVenueCreateInput"] | undefined | null,
	update?: ValueTypes["DeadlineTemplateWithoutVenueUpdateInput"] | undefined | null,
	upsert?: ValueTypes["VenueUpsertDeadlineTemplateRelationInput"] | undefined | null,
	connect?: ValueTypes["DeadlineTemplateUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["DeadlineTemplateWithoutVenueUpdateInput"]: {
	startDate?: ValueTypes["Date"] | undefined | null,
	period?: number | undefined | null,
	cutoff?: number | undefined | null,
	closed?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VenueUpsertDeadlineTemplateRelationInput"]: {
	update?: ValueTypes["DeadlineTemplateWithoutVenueUpdateInput"] | undefined | null,
	create?: ValueTypes["DeadlineTemplateWithoutVenueCreateInput"] | undefined | null
};
	["VenueUpdateTimetableDaysEntityRelationInput"]: {
	create?: ValueTypes["TimetableDayWithoutVenueCreateInput"] | undefined | null,
	update?: ValueTypes["VenueUpdateTimetableDaysRelationInput"] | undefined | null,
	upsert?: ValueTypes["VenueUpsertTimetableDaysRelationInput"] | undefined | null,
	connect?: ValueTypes["TimetableDayUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["TimetableDayUniqueWhere"] | undefined | null,
	delete?: ValueTypes["TimetableDayUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["VenueUpdateTimetableDaysRelationInput"]: {
	by?: ValueTypes["TimetableDayUniqueWhere"] | undefined | null,
	data?: ValueTypes["TimetableDayWithoutVenueUpdateInput"] | undefined | null
};
	["TimetableDayWithoutVenueUpdateInput"]: {
	date?: ValueTypes["Date"] | undefined | null,
	type?: ValueTypes["TimetableDayType"] | undefined | null,
	shiftGroups?: Array<ValueTypes["TimetableDayUpdateShiftGroupsEntityRelationInput"]> | undefined | null,
	tipsCents?: number | undefined | null,
	notes?: Array<ValueTypes["TimetableDayUpdateNotesEntityRelationInput"]> | undefined | null,
	meta?: ValueTypes["TimetableDayUpdateMetaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableDayUpdateShiftGroupsEntityRelationInput"]: {
	create?: ValueTypes["TimetableShiftGroupWithoutDayCreateInput"] | undefined | null,
	update?: ValueTypes["TimetableDayUpdateShiftGroupsRelationInput"] | undefined | null,
	upsert?: ValueTypes["TimetableDayUpsertShiftGroupsRelationInput"] | undefined | null,
	connect?: ValueTypes["TimetableShiftGroupUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["TimetableShiftGroupUniqueWhere"] | undefined | null,
	delete?: ValueTypes["TimetableShiftGroupUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["TimetableDayUpdateShiftGroupsRelationInput"]: {
	by?: ValueTypes["TimetableShiftGroupUniqueWhere"] | undefined | null,
	data?: ValueTypes["TimetableShiftGroupWithoutDayUpdateInput"] | undefined | null
};
	["TimetableShiftGroupWithoutDayUpdateInput"]: {
	order?: number | undefined | null,
	shifts?: Array<ValueTypes["TimetableShiftGroupUpdateShiftsEntityRelationInput"]> | undefined | null,
	type?: ValueTypes["TimetableShiftGroupUpdateTypeEntityRelationInput"] | undefined | null,
	position?: ValueTypes["TimetableShiftGroupUpdatePositionEntityRelationInput"] | undefined | null,
	queue?: ValueTypes["TimetableShiftGroupUpdateQueueEntityRelationInput"] | undefined | null,
	generatedByTemplate?: ValueTypes["TimetableShiftGroupUpdateGeneratedByTemplateEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableShiftGroupUpdateTypeEntityRelationInput"]: {
	create?: ValueTypes["TimetableEmployeeRoleWithoutShiftGroupsCreateInput"] | undefined | null,
	update?: ValueTypes["TimetableEmployeeRoleWithoutShiftGroupsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["TimetableShiftGroupUpsertTypeRelationInput"] | undefined | null,
	connect?: ValueTypes["TimetableEmployeeRoleUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["TimetableEmployeeRoleWithoutShiftGroupsUpdateInput"]: {
	shiftsProfiles?: Array<ValueTypes["TimetableEmployeeRoleUpdateShiftsProfilesEntityRelationInput"]> | undefined | null,
	shiftsManagers?: Array<ValueTypes["TimetableEmployeeRoleUpdateShiftsManagersEntityRelationInput"]> | undefined | null,
	name?: string | undefined | null,
	timetableTemplates?: Array<ValueTypes["TimetableEmployeeRoleUpdateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	color?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableEmployeeRoleUpdateTimetableTemplatesEntityRelationInput"]: {
	create?: ValueTypes["TimetableTemplateWithoutEmployeeRoleCreateInput"] | undefined | null,
	update?: ValueTypes["TimetableEmployeeRoleUpdateTimetableTemplatesRelationInput"] | undefined | null,
	upsert?: ValueTypes["TimetableEmployeeRoleUpsertTimetableTemplatesRelationInput"] | undefined | null,
	connect?: ValueTypes["TimetableTemplateUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["TimetableTemplateUniqueWhere"] | undefined | null,
	delete?: ValueTypes["TimetableTemplateUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["TimetableEmployeeRoleUpdateTimetableTemplatesRelationInput"]: {
	by?: ValueTypes["TimetableTemplateUniqueWhere"] | undefined | null,
	data?: ValueTypes["TimetableTemplateWithoutEmployeeRoleUpdateInput"] | undefined | null
};
	["TimetableTemplateWithoutEmployeeRoleUpdateInput"]: {
	order?: number | undefined | null,
	startDate?: ValueTypes["Date"] | undefined | null,
	period?: number | undefined | null,
	slots?: number | undefined | null,
	position?: ValueTypes["TimetableTemplateUpdatePositionEntityRelationInput"] | undefined | null,
	staffOptions?: Array<ValueTypes["TimetableTemplateUpdateStaffOptionsEntityRelationInput"]> | undefined | null,
	internalName?: string | undefined | null,
	venue?: ValueTypes["TimetableTemplateUpdateVenueEntityRelationInput"] | undefined | null,
	workdaysOnly?: boolean | undefined | null,
	monday?: boolean | undefined | null,
	tuesday?: boolean | undefined | null,
	wednesday?: boolean | undefined | null,
	thursday?: boolean | undefined | null,
	friday?: boolean | undefined | null,
	saturday?: boolean | undefined | null,
	sunday?: boolean | undefined | null,
	type?: ValueTypes["TemplateType"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableTemplateUpdatePositionEntityRelationInput"]: {
	create?: ValueTypes["TimetableShiftPositionWithoutTimetableTemplatesCreateInput"] | undefined | null,
	update?: ValueTypes["TimetableShiftPositionWithoutTimetableTemplatesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["TimetableTemplateUpsertPositionRelationInput"] | undefined | null,
	connect?: ValueTypes["TimetableShiftPositionUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["TimetableShiftPositionWithoutTimetableTemplatesUpdateInput"]: {
	name?: string | undefined | null,
	start?: string | undefined | null,
	end?: string | undefined | null,
	shiftGroups?: Array<ValueTypes["TimetableShiftPositionUpdateShiftGroupsEntityRelationInput"]> | undefined | null,
	isDynamic?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableShiftPositionUpdateShiftGroupsEntityRelationInput"]: {
	create?: ValueTypes["TimetableShiftGroupWithoutPositionCreateInput"] | undefined | null,
	update?: ValueTypes["TimetableShiftPositionUpdateShiftGroupsRelationInput"] | undefined | null,
	upsert?: ValueTypes["TimetableShiftPositionUpsertShiftGroupsRelationInput"] | undefined | null,
	connect?: ValueTypes["TimetableShiftGroupUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["TimetableShiftGroupUniqueWhere"] | undefined | null,
	delete?: ValueTypes["TimetableShiftGroupUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["TimetableShiftPositionUpdateShiftGroupsRelationInput"]: {
	by?: ValueTypes["TimetableShiftGroupUniqueWhere"] | undefined | null,
	data?: ValueTypes["TimetableShiftGroupWithoutPositionUpdateInput"] | undefined | null
};
	["TimetableShiftGroupWithoutPositionUpdateInput"]: {
	order?: number | undefined | null,
	shifts?: Array<ValueTypes["TimetableShiftGroupUpdateShiftsEntityRelationInput"]> | undefined | null,
	day?: ValueTypes["TimetableShiftGroupUpdateDayEntityRelationInput"] | undefined | null,
	type?: ValueTypes["TimetableShiftGroupUpdateTypeEntityRelationInput"] | undefined | null,
	queue?: ValueTypes["TimetableShiftGroupUpdateQueueEntityRelationInput"] | undefined | null,
	generatedByTemplate?: ValueTypes["TimetableShiftGroupUpdateGeneratedByTemplateEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableShiftGroupUpdateQueueEntityRelationInput"]: {
	create?: ValueTypes["EmployeeQueueWithoutShiftGroupCreateInput"] | undefined | null,
	update?: ValueTypes["EmployeeQueueWithoutShiftGroupUpdateInput"] | undefined | null,
	upsert?: ValueTypes["TimetableShiftGroupUpsertQueueRelationInput"] | undefined | null,
	connect?: ValueTypes["EmployeeQueueUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["EmployeeQueueWithoutShiftGroupUpdateInput"]: {
	items?: Array<ValueTypes["EmployeeQueueUpdateItemsEntityRelationInput"]> | undefined | null,
	contemberBugFix?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["EmployeeQueueUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["EmployeeQueueItemWithoutQueueCreateInput"] | undefined | null,
	update?: ValueTypes["EmployeeQueueUpdateItemsRelationInput"] | undefined | null,
	upsert?: ValueTypes["EmployeeQueueUpsertItemsRelationInput"] | undefined | null,
	connect?: ValueTypes["EmployeeQueueItemUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["EmployeeQueueItemUniqueWhere"] | undefined | null,
	delete?: ValueTypes["EmployeeQueueItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["EmployeeQueueUpdateItemsRelationInput"]: {
	by?: ValueTypes["EmployeeQueueItemUniqueWhere"] | undefined | null,
	data?: ValueTypes["EmployeeQueueItemWithoutQueueUpdateInput"] | undefined | null
};
	["EmployeeQueueItemWithoutQueueUpdateInput"]: {
	start?: string | undefined | null,
	end?: string | undefined | null,
	shiftsProfile?: ValueTypes["EmployeeQueueItemUpdateShiftsProfileEntityRelationInput"] | undefined | null,
	shift?: ValueTypes["EmployeeQueueItemUpdateShiftEntityRelationInput"] | undefined | null,
	unassignInfo?: ValueTypes["EmployeeQueueItemUpdateUnassignInfoEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["EmployeeQueueItemUpdateMetaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["EmployeeQueueItemUpdateShiftsProfileEntityRelationInput"]: {
	create?: ValueTypes["ShiftsProfileWithoutQueueItemsCreateInput"] | undefined | null,
	update?: ValueTypes["ShiftsProfileWithoutQueueItemsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["EmployeeQueueItemUpsertShiftsProfileRelationInput"] | undefined | null,
	connect?: ValueTypes["ShiftsProfileUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["ShiftsProfileWithoutQueueItemsUpdateInput"]: {
	staff?: ValueTypes["ShiftsProfileUpdateStaffEntityRelationInput"] | undefined | null,
	roles?: Array<ValueTypes["ShiftsProfileUpdateRolesEntityRelationInput"]> | undefined | null,
	shifts?: Array<ValueTypes["ShiftsProfileUpdateShiftsEntityRelationInput"]> | undefined | null,
	allowSelfUnassigning?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ShiftsProfileUpdateShiftsEntityRelationInput"]: {
	create?: ValueTypes["TimetableShiftWithoutShiftsProfileCreateInput"] | undefined | null,
	update?: ValueTypes["ShiftsProfileUpdateShiftsRelationInput"] | undefined | null,
	upsert?: ValueTypes["ShiftsProfileUpsertShiftsRelationInput"] | undefined | null,
	connect?: ValueTypes["TimetableShiftUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["TimetableShiftUniqueWhere"] | undefined | null,
	delete?: ValueTypes["TimetableShiftUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ShiftsProfileUpdateShiftsRelationInput"]: {
	by?: ValueTypes["TimetableShiftUniqueWhere"] | undefined | null,
	data?: ValueTypes["TimetableShiftWithoutShiftsProfileUpdateInput"] | undefined | null
};
	["TimetableShiftWithoutShiftsProfileUpdateInput"]: {
	locked?: boolean | undefined | null,
	order?: number | undefined | null,
	assigned?: ValueTypes["Date"] | undefined | null,
	group?: ValueTypes["TimetableShiftUpdateGroupEntityRelationInput"] | undefined | null,
	queueItem?: ValueTypes["TimetableShiftUpdateQueueItemEntityRelationInput"] | undefined | null,
	swapInfo?: ValueTypes["TimetableShiftUpdateSwapInfoEntityRelationInput"] | undefined | null,
	isOvertime?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableShiftUpdateGroupEntityRelationInput"]: {
	create?: ValueTypes["TimetableShiftGroupWithoutShiftsCreateInput"] | undefined | null,
	update?: ValueTypes["TimetableShiftGroupWithoutShiftsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["TimetableShiftUpsertGroupRelationInput"] | undefined | null,
	connect?: ValueTypes["TimetableShiftGroupUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["TimetableShiftGroupWithoutShiftsUpdateInput"]: {
	order?: number | undefined | null,
	day?: ValueTypes["TimetableShiftGroupUpdateDayEntityRelationInput"] | undefined | null,
	type?: ValueTypes["TimetableShiftGroupUpdateTypeEntityRelationInput"] | undefined | null,
	position?: ValueTypes["TimetableShiftGroupUpdatePositionEntityRelationInput"] | undefined | null,
	queue?: ValueTypes["TimetableShiftGroupUpdateQueueEntityRelationInput"] | undefined | null,
	generatedByTemplate?: ValueTypes["TimetableShiftGroupUpdateGeneratedByTemplateEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableShiftGroupUpdatePositionEntityRelationInput"]: {
	create?: ValueTypes["TimetableShiftPositionWithoutShiftGroupsCreateInput"] | undefined | null,
	update?: ValueTypes["TimetableShiftPositionWithoutShiftGroupsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["TimetableShiftGroupUpsertPositionRelationInput"] | undefined | null,
	connect?: ValueTypes["TimetableShiftPositionUniqueWhere"] | undefined | null
};
	["TimetableShiftPositionWithoutShiftGroupsUpdateInput"]: {
	name?: string | undefined | null,
	start?: string | undefined | null,
	end?: string | undefined | null,
	timetableTemplates?: Array<ValueTypes["TimetableShiftPositionUpdateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	isDynamic?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableShiftPositionUpdateTimetableTemplatesEntityRelationInput"]: {
	create?: ValueTypes["TimetableTemplateWithoutPositionCreateInput"] | undefined | null,
	update?: ValueTypes["TimetableShiftPositionUpdateTimetableTemplatesRelationInput"] | undefined | null,
	upsert?: ValueTypes["TimetableShiftPositionUpsertTimetableTemplatesRelationInput"] | undefined | null,
	connect?: ValueTypes["TimetableTemplateUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["TimetableTemplateUniqueWhere"] | undefined | null,
	delete?: ValueTypes["TimetableTemplateUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["TimetableShiftPositionUpdateTimetableTemplatesRelationInput"]: {
	by?: ValueTypes["TimetableTemplateUniqueWhere"] | undefined | null,
	data?: ValueTypes["TimetableTemplateWithoutPositionUpdateInput"] | undefined | null
};
	["TimetableTemplateWithoutPositionUpdateInput"]: {
	order?: number | undefined | null,
	startDate?: ValueTypes["Date"] | undefined | null,
	period?: number | undefined | null,
	slots?: number | undefined | null,
	staffOptions?: Array<ValueTypes["TimetableTemplateUpdateStaffOptionsEntityRelationInput"]> | undefined | null,
	internalName?: string | undefined | null,
	venue?: ValueTypes["TimetableTemplateUpdateVenueEntityRelationInput"] | undefined | null,
	employeeRole?: ValueTypes["TimetableTemplateUpdateEmployeeRoleEntityRelationInput"] | undefined | null,
	workdaysOnly?: boolean | undefined | null,
	monday?: boolean | undefined | null,
	tuesday?: boolean | undefined | null,
	wednesday?: boolean | undefined | null,
	thursday?: boolean | undefined | null,
	friday?: boolean | undefined | null,
	saturday?: boolean | undefined | null,
	sunday?: boolean | undefined | null,
	type?: ValueTypes["TemplateType"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableTemplateUpdateStaffOptionsEntityRelationInput"]: {
	create?: ValueTypes["TimetableTemplateStaffOptionsWithoutTimetableTemplateCreateInput"] | undefined | null,
	update?: ValueTypes["TimetableTemplateUpdateStaffOptionsRelationInput"] | undefined | null,
	upsert?: ValueTypes["TimetableTemplateUpsertStaffOptionsRelationInput"] | undefined | null,
	connect?: ValueTypes["TimetableTemplateStaffOptionsUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["TimetableTemplateStaffOptionsUniqueWhere"] | undefined | null,
	delete?: ValueTypes["TimetableTemplateStaffOptionsUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["TimetableTemplateUpdateStaffOptionsRelationInput"]: {
	by?: ValueTypes["TimetableTemplateStaffOptionsUniqueWhere"] | undefined | null,
	data?: ValueTypes["TimetableTemplateStaffOptionsWithoutTimetableTemplateUpdateInput"] | undefined | null
};
	["TimetableTemplateStaffOptionsWithoutTimetableTemplateUpdateInput"]: {
	startTime?: string | undefined | null,
	endTime?: string | undefined | null,
	autoAssignedEmployee?: ValueTypes["TimetableTemplateStaffOptionsUpdateAutoAssignedEmployeeEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableTemplateStaffOptionsUpdateAutoAssignedEmployeeEntityRelationInput"]: {
	create?: ValueTypes["ShiftsProfileCreateInput"] | undefined | null,
	update?: ValueTypes["ShiftsProfileUpdateInput"] | undefined | null,
	upsert?: ValueTypes["TimetableTemplateStaffOptionsUpsertAutoAssignedEmployeeRelationInput"] | undefined | null,
	connect?: ValueTypes["ShiftsProfileUniqueWhere"] | undefined | null
};
	["ShiftsProfileUpdateInput"]: {
	queueItems?: Array<ValueTypes["ShiftsProfileUpdateQueueItemsEntityRelationInput"]> | undefined | null,
	staff?: ValueTypes["ShiftsProfileUpdateStaffEntityRelationInput"] | undefined | null,
	roles?: Array<ValueTypes["ShiftsProfileUpdateRolesEntityRelationInput"]> | undefined | null,
	shifts?: Array<ValueTypes["ShiftsProfileUpdateShiftsEntityRelationInput"]> | undefined | null,
	allowSelfUnassigning?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableTemplateStaffOptionsUpsertAutoAssignedEmployeeRelationInput"]: {
	update?: ValueTypes["ShiftsProfileUpdateInput"] | undefined | null,
	create?: ValueTypes["ShiftsProfileCreateInput"] | undefined | null
};
	["TimetableTemplateUpsertStaffOptionsRelationInput"]: {
	by?: ValueTypes["TimetableTemplateStaffOptionsUniqueWhere"] | undefined | null,
	update?: ValueTypes["TimetableTemplateStaffOptionsWithoutTimetableTemplateUpdateInput"] | undefined | null,
	create?: ValueTypes["TimetableTemplateStaffOptionsWithoutTimetableTemplateCreateInput"] | undefined | null
};
	["TimetableTemplateUpdateVenueEntityRelationInput"]: {
	create?: ValueTypes["VenueWithoutTimetableTemplatesCreateInput"] | undefined | null,
	update?: ValueTypes["VenueWithoutTimetableTemplatesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["TimetableTemplateUpsertVenueRelationInput"] | undefined | null,
	connect?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["VenueWithoutTimetableTemplatesUpdateInput"]: {
	name?: string | undefined | null,
	deadlineTemplate?: ValueTypes["VenueUpdateDeadlineTemplateEntityRelationInput"] | undefined | null,
	timetableDays?: Array<ValueTypes["VenueUpdateTimetableDaysEntityRelationInput"]> | undefined | null,
	staffMembers?: Array<ValueTypes["VenueUpdateStaffMembersEntityRelationInput"]> | undefined | null,
	employeeRoles?: Array<ValueTypes["VenueUpdateEmployeeRolesEntityRelationInput"]> | undefined | null,
	pointOfSaleApplicationDevices?: Array<ValueTypes["VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined | null,
	pointOfSaleTerminals?: Array<ValueTypes["VenueUpdatePointOfSaleTerminalsEntityRelationInput"]> | undefined | null,
	pointOfSalePrinters?: Array<ValueTypes["VenueUpdatePointOfSalePrintersEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["VenueUpdateOrdersEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["VenueUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	areas?: Array<ValueTypes["VenueUpdateAreasEntityRelationInput"]> | undefined | null,
	enabledUnassignReasons?: Array<ValueTypes["VenueUpdateEnabledUnassignReasonsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["VenueUpdateCategoriesEntityRelationInput"]> | undefined | null,
	channels?: Array<ValueTypes["VenueUpdateChannelsEntityRelationInput"]> | undefined | null,
	address?: string | undefined | null,
	pointOfSalePngBase64ReceiptLogo?: string | undefined | null,
	pointOfSaleInitialView?: ValueTypes["PointOfSaleInitialView"] | undefined | null,
	pointOfSalePreferPrintReceipt?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VenueUpdateStaffMembersEntityRelationInput"]: {
	create?: ValueTypes["StaffWithoutVenuesCreateInput"] | undefined | null,
	update?: ValueTypes["VenueUpdateStaffMembersRelationInput"] | undefined | null,
	upsert?: ValueTypes["VenueUpsertStaffMembersRelationInput"] | undefined | null,
	connect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	delete?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["VenueUpdateStaffMembersRelationInput"]: {
	by?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	data?: ValueTypes["StaffWithoutVenuesUpdateInput"] | undefined | null
};
	["StaffWithoutVenuesUpdateInput"]: {
	bartender?: ValueTypes["StaffUpdateBartenderEntityRelationInput"] | undefined | null,
	courier?: ValueTypes["StaffUpdateCourierEntityRelationInput"] | undefined | null,
	cleaner?: ValueTypes["StaffUpdateCleanerEntityRelationInput"] | undefined | null,
	shiftsManager?: ValueTypes["StaffUpdateShiftsManagerEntityRelationInput"] | undefined | null,
	businessToBusinessManager?: ValueTypes["StaffUpdateBusinessToBusinessManagerEntityRelationInput"] | undefined | null,
	user?: ValueTypes["StaffUpdateUserEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["StaffUpdateShiftsProfileEntityRelationInput"] | undefined | null,
	stocksManager?: ValueTypes["StaffUpdateStocksManagerEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["StaffUpdatePhotoEntityRelationInput"] | undefined | null,
	courierManager?: ValueTypes["StaffUpdateCourierManagerEntityRelationInput"] | undefined | null,
	picker?: ValueTypes["StaffUpdatePickerEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	remunerationProfile?: ValueTypes["StaffUpdateRemunerationProfileEntityRelationInput"] | undefined | null,
	cashier?: ValueTypes["StaffUpdateCashierEntityRelationInput"] | undefined | null,
	internalBuyer?: ValueTypes["StaffUpdateInternalBuyerEntityRelationInput"] | undefined | null,
	salesManager?: ValueTypes["StaffUpdateSalesManagerEntityRelationInput"] | undefined | null,
	cashierManager?: ValueTypes["StaffUpdateCashierManagerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StaffUpdatePhotoEntityRelationInput"]: {
	create?: ValueTypes["ImageCreateInput"] | undefined | null,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ValueTypes["StaffUpsertPhotoRelationInput"] | undefined | null,
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["StaffUpsertPhotoRelationInput"]: {
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["StaffUpdateCourierManagerEntityRelationInput"]: {
	create?: ValueTypes["CourierManagerWithoutStaffCreateInput"] | undefined | null,
	update?: ValueTypes["CourierManagerWithoutStaffUpdateInput"] | undefined | null,
	upsert?: ValueTypes["StaffUpsertCourierManagerRelationInput"] | undefined | null,
	connect?: ValueTypes["CourierManagerUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CourierManagerWithoutStaffUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StaffUpsertCourierManagerRelationInput"]: {
	update?: ValueTypes["CourierManagerWithoutStaffUpdateInput"] | undefined | null,
	create?: ValueTypes["CourierManagerWithoutStaffCreateInput"] | undefined | null
};
	["StaffUpdatePickerEntityRelationInput"]: {
	create?: ValueTypes["PickerWithoutStaffCreateInput"] | undefined | null,
	update?: ValueTypes["PickerWithoutStaffUpdateInput"] | undefined | null,
	upsert?: ValueTypes["StaffUpsertPickerRelationInput"] | undefined | null,
	connect?: ValueTypes["PickerUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PickerWithoutStaffUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StaffUpsertPickerRelationInput"]: {
	update?: ValueTypes["PickerWithoutStaffUpdateInput"] | undefined | null,
	create?: ValueTypes["PickerWithoutStaffCreateInput"] | undefined | null
};
	["StaffUpdateRemunerationProfileEntityRelationInput"]: {
	create?: ValueTypes["RemunerationProfileWithoutStaffCreateInput"] | undefined | null,
	update?: ValueTypes["RemunerationProfileWithoutStaffUpdateInput"] | undefined | null,
	upsert?: ValueTypes["StaffUpsertRemunerationProfileRelationInput"] | undefined | null,
	connect?: ValueTypes["RemunerationProfileUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["RemunerationProfileWithoutStaffUpdateInput"]: {
	employmentInformation?: Array<ValueTypes["RemunerationProfileUpdateEmploymentInformationEntityRelationInput"]> | undefined | null,
	workMonths?: ValueTypes["RemunerationProfileUpdateWorkMonthsEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RemunerationProfileUpdateEmploymentInformationEntityRelationInput"]: {
	create?: ValueTypes["EmploymentInformationWithoutRemunerationProfilesCreateInput"] | undefined | null,
	update?: ValueTypes["RemunerationProfileUpdateEmploymentInformationRelationInput"] | undefined | null,
	upsert?: ValueTypes["RemunerationProfileUpsertEmploymentInformationRelationInput"] | undefined | null,
	connect?: ValueTypes["EmploymentInformationUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["EmploymentInformationUniqueWhere"] | undefined | null,
	delete?: ValueTypes["EmploymentInformationUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["RemunerationProfileUpdateEmploymentInformationRelationInput"]: {
	by?: ValueTypes["EmploymentInformationUniqueWhere"] | undefined | null,
	data?: ValueTypes["EmploymentInformationWithoutRemunerationProfilesUpdateInput"] | undefined | null
};
	["EmploymentInformationWithoutRemunerationProfilesUpdateInput"]: {
	hourlyRate?: number | undefined | null,
	monthlySalary?: number | undefined | null,
	type?: ValueTypes["EmploymentType"] | undefined | null,
	name?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RemunerationProfileUpsertEmploymentInformationRelationInput"]: {
	by?: ValueTypes["EmploymentInformationUniqueWhere"] | undefined | null,
	update?: ValueTypes["EmploymentInformationWithoutRemunerationProfilesUpdateInput"] | undefined | null,
	create?: ValueTypes["EmploymentInformationWithoutRemunerationProfilesCreateInput"] | undefined | null
};
	["RemunerationProfileUpdateWorkMonthsEntityRelationInput"]: {
	create?: ValueTypes["WorkMonthWithoutRemunerationProfileCreateInput"] | undefined | null,
	update?: ValueTypes["WorkMonthWithoutRemunerationProfileUpdateInput"] | undefined | null,
	upsert?: ValueTypes["RemunerationProfileUpsertWorkMonthsRelationInput"] | undefined | null,
	connect?: ValueTypes["WorkMonthUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["WorkMonthWithoutRemunerationProfileUpdateInput"]: {
	year?: number | undefined | null,
	month?: number | undefined | null,
	hoursWorked?: number | undefined | null,
	billableHours?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RemunerationProfileUpsertWorkMonthsRelationInput"]: {
	update?: ValueTypes["WorkMonthWithoutRemunerationProfileUpdateInput"] | undefined | null,
	create?: ValueTypes["WorkMonthWithoutRemunerationProfileCreateInput"] | undefined | null
};
	["StaffUpsertRemunerationProfileRelationInput"]: {
	update?: ValueTypes["RemunerationProfileWithoutStaffUpdateInput"] | undefined | null,
	create?: ValueTypes["RemunerationProfileWithoutStaffCreateInput"] | undefined | null
};
	["StaffUpdateCashierEntityRelationInput"]: {
	create?: ValueTypes["CashierWithoutStaffCreateInput"] | undefined | null,
	update?: ValueTypes["CashierWithoutStaffUpdateInput"] | undefined | null,
	upsert?: ValueTypes["StaffUpsertCashierRelationInput"] | undefined | null,
	connect?: ValueTypes["CashierUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CashierWithoutStaffUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StaffUpsertCashierRelationInput"]: {
	update?: ValueTypes["CashierWithoutStaffUpdateInput"] | undefined | null,
	create?: ValueTypes["CashierWithoutStaffCreateInput"] | undefined | null
};
	["StaffUpdateInternalBuyerEntityRelationInput"]: {
	create?: ValueTypes["InternalBuyerWithoutStaffCreateInput"] | undefined | null,
	update?: ValueTypes["InternalBuyerWithoutStaffUpdateInput"] | undefined | null,
	upsert?: ValueTypes["StaffUpsertInternalBuyerRelationInput"] | undefined | null,
	connect?: ValueTypes["InternalBuyerUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["InternalBuyerWithoutStaffUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StaffUpsertInternalBuyerRelationInput"]: {
	update?: ValueTypes["InternalBuyerWithoutStaffUpdateInput"] | undefined | null,
	create?: ValueTypes["InternalBuyerWithoutStaffCreateInput"] | undefined | null
};
	["StaffUpdateSalesManagerEntityRelationInput"]: {
	create?: ValueTypes["SalesManagerWithoutStaffCreateInput"] | undefined | null,
	update?: ValueTypes["SalesManagerWithoutStaffUpdateInput"] | undefined | null,
	upsert?: ValueTypes["StaffUpsertSalesManagerRelationInput"] | undefined | null,
	connect?: ValueTypes["SalesManagerUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["SalesManagerWithoutStaffUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	countries?: Array<ValueTypes["SalesManagerUpdateCountriesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SalesManagerUpdateCountriesEntityRelationInput"]: {
	create?: ValueTypes["CountryCreateInput"] | undefined | null,
	update?: ValueTypes["SalesManagerUpdateCountriesRelationInput"] | undefined | null,
	upsert?: ValueTypes["SalesManagerUpsertCountriesRelationInput"] | undefined | null,
	connect?: ValueTypes["CountryUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["CountryUniqueWhere"] | undefined | null,
	delete?: ValueTypes["CountryUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["SalesManagerUpdateCountriesRelationInput"]: {
	by?: ValueTypes["CountryUniqueWhere"] | undefined | null,
	data?: ValueTypes["CountryUpdateInput"] | undefined | null
};
	["SalesManagerUpsertCountriesRelationInput"]: {
	by?: ValueTypes["CountryUniqueWhere"] | undefined | null,
	update?: ValueTypes["CountryUpdateInput"] | undefined | null,
	create?: ValueTypes["CountryCreateInput"] | undefined | null
};
	["StaffUpsertSalesManagerRelationInput"]: {
	update?: ValueTypes["SalesManagerWithoutStaffUpdateInput"] | undefined | null,
	create?: ValueTypes["SalesManagerWithoutStaffCreateInput"] | undefined | null
};
	["StaffUpdateCashierManagerEntityRelationInput"]: {
	create?: ValueTypes["CashierManagerWithoutStaffCreateInput"] | undefined | null,
	update?: ValueTypes["CashierManagerWithoutStaffUpdateInput"] | undefined | null,
	upsert?: ValueTypes["StaffUpsertCashierManagerRelationInput"] | undefined | null,
	connect?: ValueTypes["CashierManagerUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CashierManagerWithoutStaffUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StaffUpsertCashierManagerRelationInput"]: {
	update?: ValueTypes["CashierManagerWithoutStaffUpdateInput"] | undefined | null,
	create?: ValueTypes["CashierManagerWithoutStaffCreateInput"] | undefined | null
};
	["VenueUpsertStaffMembersRelationInput"]: {
	by?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	update?: ValueTypes["StaffWithoutVenuesUpdateInput"] | undefined | null,
	create?: ValueTypes["StaffWithoutVenuesCreateInput"] | undefined | null
};
	["VenueUpdateEmployeeRolesEntityRelationInput"]: {
	create?: ValueTypes["VenueEmployeeRoleWithoutVenueCreateInput"] | undefined | null,
	update?: ValueTypes["VenueUpdateEmployeeRolesRelationInput"] | undefined | null,
	upsert?: ValueTypes["VenueUpsertEmployeeRolesRelationInput"] | undefined | null,
	connect?: ValueTypes["VenueEmployeeRoleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["VenueEmployeeRoleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["VenueEmployeeRoleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["VenueUpdateEmployeeRolesRelationInput"]: {
	by?: ValueTypes["VenueEmployeeRoleUniqueWhere"] | undefined | null,
	data?: ValueTypes["VenueEmployeeRoleWithoutVenueUpdateInput"] | undefined | null
};
	["VenueEmployeeRoleWithoutVenueUpdateInput"]: {
	order?: number | undefined | null,
	employeePrivileges?: ValueTypes["VenueEmployeeRoleUpdateEmployeePrivilegesEntityRelationInput"] | undefined | null,
	role?: ValueTypes["VenueEmployeeRoleUpdateRoleEntityRelationInput"] | undefined | null,
	getsTipsShare?: boolean | undefined | null,
	notesEnabled?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VenueEmployeeRoleUpdateEmployeePrivilegesEntityRelationInput"]: {
	create?: ValueTypes["TimetablesEmployeePrivilegesWithoutVenueEmployeeRoleCreateInput"] | undefined | null,
	update?: ValueTypes["TimetablesEmployeePrivilegesWithoutVenueEmployeeRoleUpdateInput"] | undefined | null,
	upsert?: ValueTypes["VenueEmployeeRoleUpsertEmployeePrivilegesRelationInput"] | undefined | null,
	connect?: ValueTypes["TimetablesEmployeePrivilegesUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["TimetablesEmployeePrivilegesWithoutVenueEmployeeRoleUpdateInput"]: {
	read?: boolean | undefined | null,
	unassign?: boolean | undefined | null,
	assign?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VenueEmployeeRoleUpsertEmployeePrivilegesRelationInput"]: {
	update?: ValueTypes["TimetablesEmployeePrivilegesWithoutVenueEmployeeRoleUpdateInput"] | undefined | null,
	create?: ValueTypes["TimetablesEmployeePrivilegesWithoutVenueEmployeeRoleCreateInput"] | undefined | null
};
	["VenueEmployeeRoleUpdateRoleEntityRelationInput"]: {
	create?: ValueTypes["TimetableEmployeeRoleCreateInput"] | undefined | null,
	update?: ValueTypes["TimetableEmployeeRoleUpdateInput"] | undefined | null,
	upsert?: ValueTypes["VenueEmployeeRoleUpsertRoleRelationInput"] | undefined | null,
	connect?: ValueTypes["TimetableEmployeeRoleUniqueWhere"] | undefined | null
};
	["VenueEmployeeRoleUpsertRoleRelationInput"]: {
	update?: ValueTypes["TimetableEmployeeRoleUpdateInput"] | undefined | null,
	create?: ValueTypes["TimetableEmployeeRoleCreateInput"] | undefined | null
};
	["VenueUpsertEmployeeRolesRelationInput"]: {
	by?: ValueTypes["VenueEmployeeRoleUniqueWhere"] | undefined | null,
	update?: ValueTypes["VenueEmployeeRoleWithoutVenueUpdateInput"] | undefined | null,
	create?: ValueTypes["VenueEmployeeRoleWithoutVenueCreateInput"] | undefined | null
};
	["VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput"]: {
	create?: ValueTypes["PointOfSaleApplicationDeviceWithoutVenueCreateInput"] | undefined | null,
	update?: ValueTypes["VenueUpdatePointOfSaleApplicationDevicesRelationInput"] | undefined | null,
	upsert?: ValueTypes["VenueUpsertPointOfSaleApplicationDevicesRelationInput"] | undefined | null,
	connect?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null,
	delete?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["VenueUpdatePointOfSaleApplicationDevicesRelationInput"]: {
	by?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null,
	data?: ValueTypes["PointOfSaleApplicationDeviceWithoutVenueUpdateInput"] | undefined | null
};
	["PointOfSaleApplicationDeviceWithoutVenueUpdateInput"]: {
	internalName?: string | undefined | null,
	note?: string | undefined | null,
	identificationCode?: ValueTypes["PointOfSaleApplicationDeviceUpdateIdentificationCodeEntityRelationInput"] | undefined | null,
	identifier?: ValueTypes["PointOfSaleApplicationDeviceUpdateIdentifierEntityRelationInput"] | undefined | null,
	terminal?: ValueTypes["PointOfSaleApplicationDeviceUpdateTerminalEntityRelationInput"] | undefined | null,
	receiptPrinter?: ValueTypes["PointOfSaleApplicationDeviceUpdateReceiptPrinterEntityRelationInput"] | undefined | null,
	ticketPrinters?: Array<ValueTypes["PointOfSaleApplicationDeviceUpdateTicketPrintersEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleApplicationDeviceUpdateIdentificationCodeEntityRelationInput"]: {
	create?: ValueTypes["IdentificationCodeWithoutApplicationDevicesCreateInput"] | undefined | null,
	update?: ValueTypes["IdentificationCodeWithoutApplicationDevicesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["PointOfSaleApplicationDeviceUpsertIdentificationCodeRelationInput"] | undefined | null,
	connect?: ValueTypes["IdentificationCodeUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["IdentificationCodeWithoutApplicationDevicesUpdateInput"]: {
	code?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	attempts?: Array<ValueTypes["IdentificationCodeUpdateAttemptsEntityRelationInput"]> | undefined | null,
	locales?: Array<ValueTypes["IdentificationCodeUpdateLocalesEntityRelationInput"]> | undefined | null,
	internalName?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IdentificationCodeUpdateAttemptsEntityRelationInput"]: {
	create?: ValueTypes["IdentificationAttemptWithoutCodeCreateInput"] | undefined | null,
	update?: ValueTypes["IdentificationCodeUpdateAttemptsRelationInput"] | undefined | null,
	upsert?: ValueTypes["IdentificationCodeUpsertAttemptsRelationInput"] | undefined | null,
	connect?: ValueTypes["IdentificationAttemptUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["IdentificationAttemptUniqueWhere"] | undefined | null,
	delete?: ValueTypes["IdentificationAttemptUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["IdentificationCodeUpdateAttemptsRelationInput"]: {
	by?: ValueTypes["IdentificationAttemptUniqueWhere"] | undefined | null,
	data?: ValueTypes["IdentificationAttemptWithoutCodeUpdateInput"] | undefined | null
};
	["IdentificationAttemptWithoutCodeUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	user?: ValueTypes["IdentificationAttemptUpdateUserEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IdentificationAttemptUpdateUserEntityRelationInput"]: {
	create?: ValueTypes["UserWithoutIdentificationAttemptsCreateInput"] | undefined | null,
	update?: ValueTypes["UserWithoutIdentificationAttemptsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["IdentificationAttemptUpsertUserRelationInput"] | undefined | null,
	connect?: ValueTypes["UserUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["UserWithoutIdentificationAttemptsUpdateInput"]: {
	name?: string | undefined | null,
	internalNote?: string | undefined | null,
	staff?: ValueTypes["UserUpdateStaffEntityRelationInput"] | undefined | null,
	customer?: ValueTypes["UserUpdateCustomerEntityRelationInput"] | undefined | null,
	tenantPersonId?: ValueTypes["UUID"] | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	devices?: Array<ValueTypes["UserUpdateDevicesEntityRelationInput"]> | undefined | null,
	verifiedAt?: ValueTypes["DateTime"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	deletionRequestedAt?: ValueTypes["DateTime"] | undefined | null,
	deletionExpectedAt?: ValueTypes["DateTime"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	meta?: ValueTypes["UserUpdateMetaEntityRelationInput"] | undefined | null,
	roles?: ValueTypes["UserUpdateRolesEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserUpdateDevicesEntityRelationInput"]: {
	create?: ValueTypes["UserDeviceWithoutUserCreateInput"] | undefined | null,
	update?: ValueTypes["UserUpdateDevicesRelationInput"] | undefined | null,
	upsert?: ValueTypes["UserUpsertDevicesRelationInput"] | undefined | null,
	connect?: ValueTypes["UserDeviceUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["UserDeviceUniqueWhere"] | undefined | null,
	delete?: ValueTypes["UserDeviceUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["UserUpdateDevicesRelationInput"]: {
	by?: ValueTypes["UserDeviceUniqueWhere"] | undefined | null,
	data?: ValueTypes["UserDeviceWithoutUserUpdateInput"] | undefined | null
};
	["UserDeviceWithoutUserUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	lastActiveAt?: ValueTypes["DateTime"] | undefined | null,
	platform?: string | undefined | null,
	deviceId?: string | undefined | null,
	notificationsEnabled?: boolean | undefined | null,
	appVersion?: string | undefined | null,
	osVersion?: string | undefined | null,
	apiVersion?: string | undefined | null,
	anonymousSession?: ValueTypes["UserDeviceUpdateAnonymousSessionEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserDeviceUpdateAnonymousSessionEntityRelationInput"]: {
	create?: ValueTypes["AnonymousSessionWithoutDevicesCreateInput"] | undefined | null,
	update?: ValueTypes["AnonymousSessionWithoutDevicesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["UserDeviceUpsertAnonymousSessionRelationInput"] | undefined | null,
	connect?: ValueTypes["AnonymousSessionUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["AnonymousSessionWithoutDevicesUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	lastActiveAt?: ValueTypes["DateTime"] | undefined | null,
	anonymousSessionKey?: string | undefined | null,
	email?: string | undefined | null,
	name?: string | undefined | null,
	internalNote?: string | undefined | null,
	customer?: ValueTypes["AnonymousSessionUpdateCustomerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AnonymousSessionUpdateCustomerEntityRelationInput"]: {
	create?: ValueTypes["CustomerWithoutAnonymousSessionCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerWithoutAnonymousSessionUpdateInput"] | undefined | null,
	upsert?: ValueTypes["AnonymousSessionUpsertCustomerRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CustomerWithoutAnonymousSessionUpdateInput"]: {
	addresses?: Array<ValueTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerUpdateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerUpdateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerUpdateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerUpdateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerUpdateInvoicesEntityRelationInput"]: {
	create?: ValueTypes["InvoiceWithoutCustomerCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerUpdateInvoicesRelationInput"] | undefined | null,
	upsert?: ValueTypes["CustomerUpsertInvoicesRelationInput"] | undefined | null,
	connect?: ValueTypes["InvoiceUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["InvoiceUniqueWhere"] | undefined | null,
	delete?: ValueTypes["InvoiceUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerUpdateInvoicesRelationInput"]: {
	by?: ValueTypes["InvoiceUniqueWhere"] | undefined | null,
	data?: ValueTypes["InvoiceWithoutCustomerUpdateInput"] | undefined | null
};
	["InvoiceWithoutCustomerUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	publicKey?: string | undefined | null,
	fakturoidId?: string | undefined | null,
	fakturoidData?: string | undefined | null,
	legacyUrl?: string | undefined | null,
	orderPayments?: Array<ValueTypes["InvoiceUpdateOrderPaymentsEntityRelationInput"]> | undefined | null,
	address?: ValueTypes["InvoiceUpdateAddressEntityRelationInput"] | undefined | null,
	publicUrl?: string | undefined | null,
	billingSubject?: ValueTypes["InvoiceUpdateBillingSubjectEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InvoiceUpdateOrderPaymentsEntityRelationInput"]: {
	create?: ValueTypes["OrderPaymentWithoutInvoiceCreateInput"] | undefined | null,
	update?: ValueTypes["InvoiceUpdateOrderPaymentsRelationInput"] | undefined | null,
	upsert?: ValueTypes["InvoiceUpsertOrderPaymentsRelationInput"] | undefined | null,
	connect?: ValueTypes["OrderPaymentUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["OrderPaymentUniqueWhere"] | undefined | null,
	delete?: ValueTypes["OrderPaymentUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["InvoiceUpdateOrderPaymentsRelationInput"]: {
	by?: ValueTypes["OrderPaymentUniqueWhere"] | undefined | null,
	data?: ValueTypes["OrderPaymentWithoutInvoiceUpdateInput"] | undefined | null
};
	["OrderPaymentWithoutInvoiceUpdateInput"]: {
	data?: ValueTypes["Json"] | undefined | null,
	paymentCents?: number | undefined | null,
	method?: ValueTypes["OrderPaymentUpdateMethodEntityRelationInput"] | undefined | null,
	failedAt?: ValueTypes["DateTime"] | undefined | null,
	state?: ValueTypes["OrderPaymentState"] | undefined | null,
	approvedAt?: ValueTypes["DateTime"] | undefined | null,
	events?: Array<ValueTypes["OrderPaymentUpdateEventsEntityRelationInput"]> | undefined | null,
	order?: ValueTypes["OrderPaymentUpdateOrderEntityRelationInput"] | undefined | null,
	walletType?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	publicReceiptUrl?: string | undefined | null,
	priceCents?: number | undefined | null,
	vatRate?: ValueTypes["OrderPaymentUpdateVatRateEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["OrderPaymentUpdateMetaEntityRelationInput"] | undefined | null,
	otherCurrencyPriceCents?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderPaymentUpdateMethodEntityRelationInput"]: {
	create?: ValueTypes["PaymentMethodCreateInput"] | undefined | null,
	update?: ValueTypes["PaymentMethodUpdateInput"] | undefined | null,
	upsert?: ValueTypes["OrderPaymentUpsertMethodRelationInput"] | undefined | null,
	connect?: ValueTypes["PaymentMethodUniqueWhere"] | undefined | null
};
	["OrderPaymentUpsertMethodRelationInput"]: {
	update?: ValueTypes["PaymentMethodUpdateInput"] | undefined | null,
	create?: ValueTypes["PaymentMethodCreateInput"] | undefined | null
};
	["OrderPaymentUpdateEventsEntityRelationInput"]: {
	create?: ValueTypes["OrderEventWithoutPaymentCreateInput"] | undefined | null,
	update?: ValueTypes["OrderPaymentUpdateEventsRelationInput"] | undefined | null,
	upsert?: ValueTypes["OrderPaymentUpsertEventsRelationInput"] | undefined | null,
	connect?: ValueTypes["OrderEventUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["OrderEventUniqueWhere"] | undefined | null,
	delete?: ValueTypes["OrderEventUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["OrderPaymentUpdateEventsRelationInput"]: {
	by?: ValueTypes["OrderEventUniqueWhere"] | undefined | null,
	data?: ValueTypes["OrderEventWithoutPaymentUpdateInput"] | undefined | null
};
	["OrderEventWithoutPaymentUpdateInput"]: {
	type?: string | undefined | null,
	data?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	order?: ValueTypes["OrderEventUpdateOrderEntityRelationInput"] | undefined | null,
	delivery?: ValueTypes["OrderEventUpdateDeliveryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderEventUpdateOrderEntityRelationInput"]: {
	create?: ValueTypes["OrderWithoutEventsCreateInput"] | undefined | null,
	update?: ValueTypes["OrderWithoutEventsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["OrderEventUpsertOrderRelationInput"] | undefined | null,
	connect?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["OrderWithoutEventsUpdateInput"]: {
	state?: ValueTypes["OrderState"] | undefined | null,
	fulfilledAt?: ValueTypes["DateTime"] | undefined | null,
	canceledAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	customer?: ValueTypes["OrderUpdateCustomerEntityRelationInput"] | undefined | null,
	channel?: ValueTypes["OrderUpdateChannelEntityRelationInput"] | undefined | null,
	discounts?: Array<ValueTypes["OrderUpdateDiscountsEntityRelationInput"]> | undefined | null,
	delivery?: ValueTypes["OrderUpdateDeliveryEntityRelationInput"] | undefined | null,
	items?: Array<ValueTypes["OrderUpdateItemsEntityRelationInput"]> | undefined | null,
	internalNote?: string | undefined | null,
	cart?: ValueTypes["OrderUpdateCartEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingAddress?: ValueTypes["OrderUpdateBillingAddressEntityRelationInput"] | undefined | null,
	priceLines?: Array<ValueTypes["OrderUpdatePriceLinesEntityRelationInput"]> | undefined | null,
	payments?: Array<ValueTypes["OrderUpdatePaymentsEntityRelationInput"]> | undefined | null,
	seq?: number | undefined | null,
	billingSubject?: ValueTypes["OrderUpdateBillingSubjectEntityRelationInput"] | undefined | null,
	summary?: ValueTypes["OrderUpdateSummaryEntityRelationInput"] | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	gratuity?: ValueTypes["OrderUpdateGratuityEntityRelationInput"] | undefined | null,
	venue?: ValueTypes["OrderUpdateVenueEntityRelationInput"] | undefined | null,
	fulfillmentNote?: string | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["OrderUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	doubleshotTotalWeightGrams?: number | undefined | null,
	doubleShotLegacyNumber?: string | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	doubleshotAdminUrl?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderUpdateDeliveryEntityRelationInput"]: {
	create?: ValueTypes["OrderDeliveryWithoutOrderCreateInput"] | undefined | null,
	update?: ValueTypes["OrderDeliveryWithoutOrderUpdateInput"] | undefined | null,
	upsert?: ValueTypes["OrderUpsertDeliveryRelationInput"] | undefined | null,
	connect?: ValueTypes["OrderDeliveryUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["OrderDeliveryWithoutOrderUpdateInput"]: {
	priceCents?: number | undefined | null,
	deliveredAt?: ValueTypes["DateTime"] | undefined | null,
	method?: ValueTypes["OrderDeliveryUpdateMethodEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["OrderDeliveryUpdateVatRateEntityRelationInput"] | undefined | null,
	expectedAt?: ValueTypes["DateTime"] | undefined | null,
	state?: ValueTypes["OrderDeliveryState"] | undefined | null,
	loadingDurationHours?: number | undefined | null,
	dispatchAt?: ValueTypes["DateTime"] | undefined | null,
	duration?: string | undefined | null,
	window?: string | undefined | null,
	expectedEndAt?: ValueTypes["DateTime"] | undefined | null,
	processingAt?: ValueTypes["DateTime"] | undefined | null,
	deliveringAt?: ValueTypes["DateTime"] | undefined | null,
	failedAt?: ValueTypes["DateTime"] | undefined | null,
	internalNote?: string | undefined | null,
	deliveryWaypoint?: ValueTypes["OrderDeliveryUpdateDeliveryWaypointEntityRelationInput"] | undefined | null,
	events?: Array<ValueTypes["OrderDeliveryUpdateEventsEntityRelationInput"]> | undefined | null,
	prepareAt?: ValueTypes["DateTime"] | undefined | null,
	liftagoRide?: ValueTypes["OrderDeliveryUpdateLiftagoRideEntityRelationInput"] | undefined | null,
	pickedAt?: ValueTypes["DateTime"] | undefined | null,
	address?: ValueTypes["OrderDeliveryUpdateAddressEntityRelationInput"] | undefined | null,
	trackingCode?: string | undefined | null,
	woltDriveDelivery?: ValueTypes["OrderDeliveryUpdateWoltDriveDeliveryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderDeliveryUpdateVatRateEntityRelationInput"]: {
	create?: ValueTypes["VatRateCreateInput"] | undefined | null,
	update?: ValueTypes["VatRateUpdateInput"] | undefined | null,
	upsert?: ValueTypes["OrderDeliveryUpsertVatRateRelationInput"] | undefined | null,
	connect?: ValueTypes["VatRateUniqueWhere"] | undefined | null
};
	["OrderDeliveryUpsertVatRateRelationInput"]: {
	update?: ValueTypes["VatRateUpdateInput"] | undefined | null,
	create?: ValueTypes["VatRateCreateInput"] | undefined | null
};
	["OrderDeliveryUpdateDeliveryWaypointEntityRelationInput"]: {
	create?: ValueTypes["DeliveryWaypointWithoutDeliveryCreateInput"] | undefined | null,
	update?: ValueTypes["DeliveryWaypointWithoutDeliveryUpdateInput"] | undefined | null,
	upsert?: ValueTypes["OrderDeliveryUpsertDeliveryWaypointRelationInput"] | undefined | null,
	connect?: ValueTypes["DeliveryWaypointUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["DeliveryWaypointWithoutDeliveryUpdateInput"]: {
	estimatedArrival?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	route?: ValueTypes["DeliveryWaypointUpdateRouteEntityRelationInput"] | undefined | null,
	sortingOrder?: number | undefined | null,
	estimatedDistance?: number | undefined | null,
	estimatedDuration?: number | undefined | null,
	originDeparture?: ValueTypes["DateTime"] | undefined | null,
	originAddress?: string | undefined | null,
	transitMode?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryWaypointUpdateRouteEntityRelationInput"]: {
	create?: ValueTypes["DeliveryRouteWithoutWaypointsCreateInput"] | undefined | null,
	update?: ValueTypes["DeliveryRouteWithoutWaypointsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["DeliveryWaypointUpsertRouteRelationInput"] | undefined | null,
	connect?: ValueTypes["DeliveryRouteUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["DeliveryRouteWithoutWaypointsUpdateInput"]: {
	courier?: ValueTypes["DeliveryRouteUpdateCourierEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	dispatchAt?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryRouteUpdateCourierEntityRelationInput"]: {
	create?: ValueTypes["CourierWithoutRoutesCreateInput"] | undefined | null,
	update?: ValueTypes["CourierWithoutRoutesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["DeliveryRouteUpsertCourierRelationInput"] | undefined | null,
	connect?: ValueTypes["CourierUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CourierWithoutRoutesUpdateInput"]: {
	staff?: ValueTypes["CourierUpdateStaffEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	deliveryMethods?: Array<ValueTypes["CourierUpdateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	showInPicker?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CourierUpdateDeliveryMethodsEntityRelationInput"]: {
	create?: ValueTypes["DeliveryMethodWithoutCourierHandlersCreateInput"] | undefined | null,
	update?: ValueTypes["CourierUpdateDeliveryMethodsRelationInput"] | undefined | null,
	upsert?: ValueTypes["CourierUpsertDeliveryMethodsRelationInput"] | undefined | null,
	connect?: ValueTypes["DeliveryMethodUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["DeliveryMethodUniqueWhere"] | undefined | null,
	delete?: ValueTypes["DeliveryMethodUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CourierUpdateDeliveryMethodsRelationInput"]: {
	by?: ValueTypes["DeliveryMethodUniqueWhere"] | undefined | null,
	data?: ValueTypes["DeliveryMethodWithoutCourierHandlersUpdateInput"] | undefined | null
};
	["DeliveryMethodWithoutCourierHandlersUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	enabled?: boolean | undefined | null,
	paymentMethods?: Array<ValueTypes["DeliveryMethodUpdatePaymentMethodsEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	requireDeliveryAddress?: boolean | undefined | null,
	suitableForDeliveryZones?: Array<ValueTypes["DeliveryMethodUpdateSuitableForDeliveryZonesEntityRelationInput"]> | undefined | null,
	channels?: Array<ValueTypes["DeliveryMethodUpdateChannelsEntityRelationInput"]> | undefined | null,
	enableDeliveryTracking?: boolean | undefined | null,
	locales?: Array<ValueTypes["DeliveryMethodUpdateLocalesEntityRelationInput"]> | undefined | null,
	timelinePreset?: ValueTypes["DeliveryMethodUpdateTimelinePresetEntityRelationInput"] | undefined | null,
	woltDriveVenueId?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryMethodUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["DeliveryMethodLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ValueTypes["DeliveryMethodUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ValueTypes["DeliveryMethodUpsertLocalesRelationInput"] | undefined | null,
	connect?: ValueTypes["DeliveryMethodLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["DeliveryMethodLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["DeliveryMethodLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["DeliveryMethodUpdateLocalesRelationInput"]: {
	by?: ValueTypes["DeliveryMethodLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["DeliveryMethodLocaleWithoutRootUpdateInput"] | undefined | null
};
	["DeliveryMethodLocaleWithoutRootUpdateInput"]: {
	name?: string | undefined | null,
	description?: string | undefined | null,
	trackingCodeUrlTemplate?: string | undefined | null,
	processingTitle?: string | undefined | null,
	processingText?: string | undefined | null,
	processingIconUrl?: string | undefined | null,
	dispatchedTitle?: string | undefined | null,
	dispatchedText?: string | undefined | null,
	dispatchedIconUrl?: string | undefined | null,
	fulfilledTitle?: string | undefined | null,
	fulfilledText?: string | undefined | null,
	fulfilledIconUrl?: string | undefined | null,
	locale?: ValueTypes["DeliveryMethodLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryMethodLocaleUpdateLocaleEntityRelationInput"]: {
	create?: ValueTypes["LocaleWithoutDeliveryMethodsCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleWithoutDeliveryMethodsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["DeliveryMethodLocaleUpsertLocaleRelationInput"] | undefined | null,
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutDeliveryMethodsUpdateInput"]: {
	businessCategories?: Array<ValueTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleUpdateProductPackingsEntityRelationInput"]: {
	create?: ValueTypes["ProductPackingLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleUpdateProductPackingsRelationInput"] | undefined | null,
	upsert?: ValueTypes["LocaleUpsertProductPackingsRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductPackingLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductPackingLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductPackingLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateProductPackingsRelationInput"]: {
	by?: ValueTypes["ProductPackingLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["ProductPackingLocaleWithoutLocaleUpdateInput"] | undefined | null
};
	["ProductPackingLocaleWithoutLocaleUpdateInput"]: {
	name?: string | undefined | null,
	shortName?: string | undefined | null,
	description?: string | undefined | null,
	root?: ValueTypes["ProductPackingLocaleUpdateRootEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductPackingLocaleUpdateRootEntityRelationInput"]: {
	create?: ValueTypes["ProductPackingWithoutLocalesCreateInput"] | undefined | null,
	update?: ValueTypes["ProductPackingWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductPackingLocaleUpsertRootRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductPackingUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductPackingWithoutLocalesUpdateInput"]: {
	name?: string | undefined | null,
	image?: ValueTypes["ProductPackingUpdateImageEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	volumeMl?: number | undefined | null,
	icon?: ValueTypes["ProductPackingUpdateIconEntityRelationInput"] | undefined | null,
	shortName?: string | undefined | null,
	preparedPackingQuantities?: Array<ValueTypes["ProductPackingUpdatePreparedPackingQuantitiesEntityRelationInput"]> | undefined | null,
	isPackedInCardboard?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductPackingUpdatePreparedPackingQuantitiesEntityRelationInput"]: {
	create?: ValueTypes["PreparedPackingQuantityWithoutPackingCreateInput"] | undefined | null,
	update?: ValueTypes["ProductPackingUpdatePreparedPackingQuantitiesRelationInput"] | undefined | null,
	upsert?: ValueTypes["ProductPackingUpsertPreparedPackingQuantitiesRelationInput"] | undefined | null,
	connect?: ValueTypes["PreparedPackingQuantityUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["PreparedPackingQuantityUniqueWhere"] | undefined | null,
	delete?: ValueTypes["PreparedPackingQuantityUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductPackingUpdatePreparedPackingQuantitiesRelationInput"]: {
	by?: ValueTypes["PreparedPackingQuantityUniqueWhere"] | undefined | null,
	data?: ValueTypes["PreparedPackingQuantityWithoutPackingUpdateInput"] | undefined | null
};
	["PreparedPackingQuantityWithoutPackingUpdateInput"]: {
	date?: ValueTypes["Date"] | undefined | null,
	quantity?: number | undefined | null,
	recipe?: ValueTypes["PreparedPackingQuantityUpdateRecipeEntityRelationInput"] | undefined | null,
	packedInCardboard?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PreparedPackingQuantityUpdateRecipeEntityRelationInput"]: {
	create?: ValueTypes["ProductRecipeCreateInput"] | undefined | null,
	update?: ValueTypes["ProductRecipeUpdateInput"] | undefined | null,
	upsert?: ValueTypes["PreparedPackingQuantityUpsertRecipeRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductRecipeUniqueWhere"] | undefined | null
};
	["ProductRecipeUpdateInput"]: {
	name?: string | undefined | null,
	products?: Array<ValueTypes["ProductRecipeUpdateProductsEntityRelationInput"]> | undefined | null,
	internalNote?: string | undefined | null,
	color?: string | undefined | null,
	image?: ValueTypes["ProductRecipeUpdateImageEntityRelationInput"] | undefined | null,
	icon?: ValueTypes["ProductRecipeUpdateIconEntityRelationInput"] | undefined | null,
	ingredients?: Array<ValueTypes["ProductRecipeUpdateIngredientsEntityRelationInput"]> | undefined | null,
	needsPrepping?: boolean | undefined | null,
	locales?: Array<ValueTypes["ProductRecipeUpdateLocalesEntityRelationInput"]> | undefined | null,
	gutTuning?: number | undefined | null,
	freshingContainer?: ValueTypes["ProductRecipeUpdateFreshingContainerEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	nutritionFacts?: ValueTypes["ProductRecipeUpdateNutritionFactsEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductRecipeUpdateProductsEntityRelationInput"]: {
	create?: ValueTypes["ProductWithoutRecipeCreateInput"] | undefined | null,
	update?: ValueTypes["ProductRecipeUpdateProductsRelationInput"] | undefined | null,
	upsert?: ValueTypes["ProductRecipeUpsertProductsRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductRecipeUpdateProductsRelationInput"]: {
	by?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	data?: ValueTypes["ProductWithoutRecipeUpdateInput"] | undefined | null
};
	["ProductWithoutRecipeUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	priceCents?: number | undefined | null,
	notDiscountable?: boolean | undefined | null,
	packing?: ValueTypes["ProductUpdatePackingEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["ProductUpdateTagsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["ProductUpdateCategoriesEntityRelationInput"]> | undefined | null,
	vatRate?: ValueTypes["ProductUpdateVatRateEntityRelationInput"] | undefined | null,
	stocks?: Array<ValueTypes["ProductUpdateStocksEntityRelationInput"]> | undefined | null,
	groupPrices?: Array<ValueTypes["ProductUpdateGroupPricesEntityRelationInput"]> | undefined | null,
	image?: ValueTypes["ProductUpdateImageEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	cartItems?: Array<ValueTypes["ProductUpdateCartItemsEntityRelationInput"]> | undefined | null,
	availability?: ValueTypes["ProductAvailability"] | undefined | null,
	order?: number | undefined | null,
	manager?: ValueTypes["ProductUpdateManagerEntityRelationInput"] | undefined | null,
	orderItems?: Array<ValueTypes["ProductUpdateOrderItemsEntityRelationInput"]> | undefined | null,
	maximumQuantityPerOrder?: number | undefined | null,
	inheritedCategories?: Array<ValueTypes["ProductUpdateInheritedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["ProductUpdateDeliveryZonesEntityRelationInput"]> | undefined | null,
	locales?: Array<ValueTypes["ProductUpdateLocalesEntityRelationInput"]> | undefined | null,
	archivedAt?: ValueTypes["DateTime"] | undefined | null,
	customerPrices?: Array<ValueTypes["ProductUpdateCustomerPricesEntityRelationInput"]> | undefined | null,
	virtualProduct?: ValueTypes["ProductUpdateVirtualProductEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["ProductUpdateMetaEntityRelationInput"] | undefined | null,
	page?: ValueTypes["ProductUpdatePageEntityRelationInput"] | undefined | null,
	salesDays?: Array<ValueTypes["ProductUpdateSalesDaysEntityRelationInput"]> | undefined | null,
	salesWeeks?: Array<ValueTypes["ProductUpdateSalesWeeksEntityRelationInput"]> | undefined | null,
	salesMonths?: Array<ValueTypes["ProductUpdateSalesMonthsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["ProductUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	hasSubscription?: boolean | undefined | null,
	pointOfSaleTileColor?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["ProductLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ValueTypes["ProductUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ValueTypes["ProductUpsertLocalesRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductUpdateLocalesRelationInput"]: {
	by?: ValueTypes["ProductLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["ProductLocaleWithoutRootUpdateInput"] | undefined | null
};
	["ProductLocaleWithoutRootUpdateInput"]: {
	name?: string | undefined | null,
	description?: string | undefined | null,
	locale?: ValueTypes["ProductLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	featureList?: ValueTypes["ProductLocaleUpdateFeatureListEntityRelationInput"] | undefined | null,
	printableName?: string | undefined | null,
	firstSticker?: string | undefined | null,
	secondSticker?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductLocaleUpdateLocaleEntityRelationInput"]: {
	create?: ValueTypes["LocaleWithoutProductsCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleWithoutProductsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductLocaleUpsertLocaleRelationInput"] | undefined | null,
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutProductsUpdateInput"]: {
	businessCategories?: Array<ValueTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleUpdateProductRecipesEntityRelationInput"]: {
	create?: ValueTypes["ProductRecipeLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleUpdateProductRecipesRelationInput"] | undefined | null,
	upsert?: ValueTypes["LocaleUpsertProductRecipesRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductRecipeLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductRecipeLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductRecipeLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateProductRecipesRelationInput"]: {
	by?: ValueTypes["ProductRecipeLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["ProductRecipeLocaleWithoutLocaleUpdateInput"] | undefined | null
};
	["ProductRecipeLocaleWithoutLocaleUpdateInput"]: {
	name?: string | undefined | null,
	root?: ValueTypes["ProductRecipeLocaleUpdateRootEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductRecipeLocaleUpdateRootEntityRelationInput"]: {
	create?: ValueTypes["ProductRecipeWithoutLocalesCreateInput"] | undefined | null,
	update?: ValueTypes["ProductRecipeWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductRecipeLocaleUpsertRootRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductRecipeUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductRecipeWithoutLocalesUpdateInput"]: {
	name?: string | undefined | null,
	products?: Array<ValueTypes["ProductRecipeUpdateProductsEntityRelationInput"]> | undefined | null,
	internalNote?: string | undefined | null,
	color?: string | undefined | null,
	image?: ValueTypes["ProductRecipeUpdateImageEntityRelationInput"] | undefined | null,
	icon?: ValueTypes["ProductRecipeUpdateIconEntityRelationInput"] | undefined | null,
	ingredients?: Array<ValueTypes["ProductRecipeUpdateIngredientsEntityRelationInput"]> | undefined | null,
	needsPrepping?: boolean | undefined | null,
	gutTuning?: number | undefined | null,
	freshingContainer?: ValueTypes["ProductRecipeUpdateFreshingContainerEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	nutritionFacts?: ValueTypes["ProductRecipeUpdateNutritionFactsEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductRecipeUpdateFreshingContainerEntityRelationInput"]: {
	create?: ValueTypes["FreshingContainerCreateInput"] | undefined | null,
	update?: ValueTypes["FreshingContainerUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductRecipeUpsertFreshingContainerRelationInput"] | undefined | null,
	connect?: ValueTypes["FreshingContainerUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductRecipeUpsertFreshingContainerRelationInput"]: {
	update?: ValueTypes["FreshingContainerUpdateInput"] | undefined | null,
	create?: ValueTypes["FreshingContainerCreateInput"] | undefined | null
};
	["ProductRecipeUpdateNutritionFactsEntityRelationInput"]: {
	create?: ValueTypes["NutritionFactsCreateInput"] | undefined | null,
	update?: ValueTypes["NutritionFactsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductRecipeUpsertNutritionFactsRelationInput"] | undefined | null,
	connect?: ValueTypes["NutritionFactsUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["NutritionFactsUpdateInput"]: {
	energyKiloJoule?: number | undefined | null,
	energyKiloCalorie?: number | undefined | null,
	fatsGrams?: number | undefined | null,
	fatsOfWhichSaturatedGrams?: number | undefined | null,
	carbohydrateGrams?: number | undefined | null,
	carbohydrateOfWhichSugarsGrams?: number | undefined | null,
	proteinGrams?: number | undefined | null,
	fibreGrams?: number | undefined | null,
	saltGrams?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductRecipeUpsertNutritionFactsRelationInput"]: {
	update?: ValueTypes["NutritionFactsUpdateInput"] | undefined | null,
	create?: ValueTypes["NutritionFactsCreateInput"] | undefined | null
};
	["ProductRecipeLocaleUpsertRootRelationInput"]: {
	update?: ValueTypes["ProductRecipeWithoutLocalesUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductRecipeWithoutLocalesCreateInput"] | undefined | null
};
	["LocaleUpsertProductRecipesRelationInput"]: {
	by?: ValueTypes["ProductRecipeLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["ProductRecipeLocaleWithoutLocaleUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductRecipeLocaleWithoutLocaleCreateInput"] | undefined | null
};
	["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]: {
	create?: ValueTypes["PointOfSaleCategoryLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleUpdatePointOfSaleCategoriesRelationInput"] | undefined | null,
	upsert?: ValueTypes["LocaleUpsertPointOfSaleCategoriesRelationInput"] | undefined | null,
	connect?: ValueTypes["PointOfSaleCategoryLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["PointOfSaleCategoryLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["PointOfSaleCategoryLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdatePointOfSaleCategoriesRelationInput"]: {
	by?: ValueTypes["PointOfSaleCategoryLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["PointOfSaleCategoryLocaleWithoutLocaleUpdateInput"] | undefined | null
};
	["PointOfSaleCategoryLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined | null,
	root?: ValueTypes["PointOfSaleCategoryLocaleUpdateRootEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleCategoryLocaleUpdateRootEntityRelationInput"]: {
	create?: ValueTypes["PointOfSaleCategoryWithoutLocalesCreateInput"] | undefined | null,
	update?: ValueTypes["PointOfSaleCategoryWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["PointOfSaleCategoryLocaleUpsertRootRelationInput"] | undefined | null,
	connect?: ValueTypes["PointOfSaleCategoryUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["PointOfSaleCategoryWithoutLocalesUpdateInput"]: {
	order?: number | undefined | null,
	slug?: string | undefined | null,
	products?: Array<ValueTypes["PointOfSaleCategoryUpdateProductsEntityRelationInput"]> | undefined | null,
	category?: ValueTypes["PointOfSaleCategoryUpdateCategoryEntityRelationInput"] | undefined | null,
	venue?: ValueTypes["PointOfSaleCategoryUpdateVenueEntityRelationInput"] | undefined | null,
	ticketPrinters?: Array<ValueTypes["PointOfSaleCategoryUpdateTicketPrintersEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleCategoryUpdateProductsEntityRelationInput"]: {
	create?: ValueTypes["PointOfSaleCategoryProductWithoutCategoryCreateInput"] | undefined | null,
	update?: ValueTypes["PointOfSaleCategoryUpdateProductsRelationInput"] | undefined | null,
	upsert?: ValueTypes["PointOfSaleCategoryUpsertProductsRelationInput"] | undefined | null,
	connect?: ValueTypes["PointOfSaleCategoryProductUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["PointOfSaleCategoryProductUniqueWhere"] | undefined | null,
	delete?: ValueTypes["PointOfSaleCategoryProductUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PointOfSaleCategoryUpdateProductsRelationInput"]: {
	by?: ValueTypes["PointOfSaleCategoryProductUniqueWhere"] | undefined | null,
	data?: ValueTypes["PointOfSaleCategoryProductWithoutCategoryUpdateInput"] | undefined | null
};
	["PointOfSaleCategoryProductWithoutCategoryUpdateInput"]: {
	order?: number | undefined | null,
	product?: ValueTypes["PointOfSaleCategoryProductUpdateProductEntityRelationInput"] | undefined | null,
	locales?: Array<ValueTypes["PointOfSaleCategoryProductUpdateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleCategoryProductUpdateProductEntityRelationInput"]: {
	create?: ValueTypes["ProductCreateInput"] | undefined | null,
	update?: ValueTypes["ProductUpdateInput"] | undefined | null,
	upsert?: ValueTypes["PointOfSaleCategoryProductUpsertProductRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductUniqueWhere"] | undefined | null
};
	["ProductUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	priceCents?: number | undefined | null,
	notDiscountable?: boolean | undefined | null,
	packing?: ValueTypes["ProductUpdatePackingEntityRelationInput"] | undefined | null,
	recipe?: ValueTypes["ProductUpdateRecipeEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["ProductUpdateTagsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["ProductUpdateCategoriesEntityRelationInput"]> | undefined | null,
	vatRate?: ValueTypes["ProductUpdateVatRateEntityRelationInput"] | undefined | null,
	stocks?: Array<ValueTypes["ProductUpdateStocksEntityRelationInput"]> | undefined | null,
	groupPrices?: Array<ValueTypes["ProductUpdateGroupPricesEntityRelationInput"]> | undefined | null,
	image?: ValueTypes["ProductUpdateImageEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	cartItems?: Array<ValueTypes["ProductUpdateCartItemsEntityRelationInput"]> | undefined | null,
	availability?: ValueTypes["ProductAvailability"] | undefined | null,
	order?: number | undefined | null,
	manager?: ValueTypes["ProductUpdateManagerEntityRelationInput"] | undefined | null,
	orderItems?: Array<ValueTypes["ProductUpdateOrderItemsEntityRelationInput"]> | undefined | null,
	maximumQuantityPerOrder?: number | undefined | null,
	inheritedCategories?: Array<ValueTypes["ProductUpdateInheritedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["ProductUpdateDeliveryZonesEntityRelationInput"]> | undefined | null,
	locales?: Array<ValueTypes["ProductUpdateLocalesEntityRelationInput"]> | undefined | null,
	archivedAt?: ValueTypes["DateTime"] | undefined | null,
	customerPrices?: Array<ValueTypes["ProductUpdateCustomerPricesEntityRelationInput"]> | undefined | null,
	virtualProduct?: ValueTypes["ProductUpdateVirtualProductEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["ProductUpdateMetaEntityRelationInput"] | undefined | null,
	page?: ValueTypes["ProductUpdatePageEntityRelationInput"] | undefined | null,
	salesDays?: Array<ValueTypes["ProductUpdateSalesDaysEntityRelationInput"]> | undefined | null,
	salesWeeks?: Array<ValueTypes["ProductUpdateSalesWeeksEntityRelationInput"]> | undefined | null,
	salesMonths?: Array<ValueTypes["ProductUpdateSalesMonthsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["ProductUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	hasSubscription?: boolean | undefined | null,
	pointOfSaleTileColor?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductUpdateCustomerPricesEntityRelationInput"]: {
	connect?: ValueTypes["ProductCustomerPriceUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductCustomerPriceUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductCustomerPriceUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductUpdateVirtualProductEntityRelationInput"]: {
	create?: ValueTypes["VirtualProductWithoutProductCreateInput"] | undefined | null,
	update?: ValueTypes["VirtualProductWithoutProductUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductUpsertVirtualProductRelationInput"] | undefined | null,
	connect?: ValueTypes["VirtualProductUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["VirtualProductWithoutProductUpdateInput"]: {
	type?: ValueTypes["VirtualProductType"] | undefined | null,
	voucherCreditCents?: number | undefined | null,
	physicalRepresentation?: ValueTypes["VirtualProductPhysicalRepresentationType"] | undefined | null,
	recipientEmail?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductUpsertVirtualProductRelationInput"]: {
	update?: ValueTypes["VirtualProductWithoutProductUpdateInput"] | undefined | null,
	create?: ValueTypes["VirtualProductWithoutProductCreateInput"] | undefined | null
};
	["ProductUpdateMetaEntityRelationInput"]: {
	connect?: ValueTypes["ProductMetadataUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductUpdatePageEntityRelationInput"]: {
	create?: ValueTypes["PageCreateInput"] | undefined | null,
	update?: ValueTypes["PageUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductUpsertPageRelationInput"] | undefined | null,
	connect?: ValueTypes["PageUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PageUpdateInput"]: {
	locales?: Array<ValueTypes["PageUpdateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PageUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["PageLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ValueTypes["PageUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ValueTypes["PageUpsertLocalesRelationInput"] | undefined | null,
	connect?: ValueTypes["PageLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["PageLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["PageLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PageUpdateLocalesRelationInput"]: {
	by?: ValueTypes["PageLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["PageLocaleWithoutRootUpdateInput"] | undefined | null
};
	["PageLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined | null,
	link?: ValueTypes["PageLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["PageLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	seo?: ValueTypes["PageLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	content?: ValueTypes["PageLocaleUpdateContentEntityRelationInput"] | undefined | null,
	cover?: ValueTypes["PageLocaleUpdateCoverEntityRelationInput"] | undefined | null,
	theme?: ValueTypes["PageTheme"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PageLocaleUpdateSeoEntityRelationInput"]: {
	create?: ValueTypes["SeoCreateInput"] | undefined | null,
	update?: ValueTypes["SeoUpdateInput"] | undefined | null,
	upsert?: ValueTypes["PageLocaleUpsertSeoRelationInput"] | undefined | null,
	connect?: ValueTypes["SeoUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["SeoUpdateInput"]: {
	title?: string | undefined | null,
	description?: string | undefined | null,
	ogTitle?: string | undefined | null,
	ogDescription?: string | undefined | null,
	ogImage?: ValueTypes["SeoUpdateOgImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SeoUpdateOgImageEntityRelationInput"]: {
	create?: ValueTypes["ImageCreateInput"] | undefined | null,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ValueTypes["SeoUpsertOgImageRelationInput"] | undefined | null,
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["SeoUpsertOgImageRelationInput"]: {
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["PageLocaleUpsertSeoRelationInput"]: {
	update?: ValueTypes["SeoUpdateInput"] | undefined | null,
	create?: ValueTypes["SeoCreateInput"] | undefined | null
};
	["PageLocaleUpdateContentEntityRelationInput"]: {
	create?: ValueTypes["ContentCreateInput"] | undefined | null,
	update?: ValueTypes["ContentUpdateInput"] | undefined | null,
	upsert?: ValueTypes["PageLocaleUpsertContentRelationInput"] | undefined | null,
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PageLocaleUpsertContentRelationInput"]: {
	update?: ValueTypes["ContentUpdateInput"] | undefined | null,
	create?: ValueTypes["ContentCreateInput"] | undefined | null
};
	["PageLocaleUpdateCoverEntityRelationInput"]: {
	create?: ValueTypes["CoverCreateInput"] | undefined | null,
	update?: ValueTypes["CoverUpdateInput"] | undefined | null,
	upsert?: ValueTypes["PageLocaleUpsertCoverRelationInput"] | undefined | null,
	connect?: ValueTypes["CoverUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PageLocaleUpsertCoverRelationInput"]: {
	update?: ValueTypes["CoverUpdateInput"] | undefined | null,
	create?: ValueTypes["CoverCreateInput"] | undefined | null
};
	["PageUpsertLocalesRelationInput"]: {
	by?: ValueTypes["PageLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["PageLocaleWithoutRootUpdateInput"] | undefined | null,
	create?: ValueTypes["PageLocaleWithoutRootCreateInput"] | undefined | null
};
	["ProductUpsertPageRelationInput"]: {
	update?: ValueTypes["PageUpdateInput"] | undefined | null,
	create?: ValueTypes["PageCreateInput"] | undefined | null
};
	["ProductUpdateSalesDaysEntityRelationInput"]: {
	connect?: ValueTypes["ProductSalesDayUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductSalesDayUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductSalesDayUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductUpdateSalesWeeksEntityRelationInput"]: {
	connect?: ValueTypes["ProductSalesWeekUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductSalesWeekUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductSalesWeekUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductUpdateSalesMonthsEntityRelationInput"]: {
	connect?: ValueTypes["ProductSalesMonthUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductSalesMonthUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductSalesMonthUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductUpdateFulfillmentNotesEntityRelationInput"]: {
	create?: ValueTypes["FulfillmentNoteWithoutProductsCreateInput"] | undefined | null,
	update?: ValueTypes["ProductUpdateFulfillmentNotesRelationInput"] | undefined | null,
	upsert?: ValueTypes["ProductUpsertFulfillmentNotesRelationInput"] | undefined | null,
	connect?: ValueTypes["FulfillmentNoteUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["FulfillmentNoteUniqueWhere"] | undefined | null,
	delete?: ValueTypes["FulfillmentNoteUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductUpdateFulfillmentNotesRelationInput"]: {
	by?: ValueTypes["FulfillmentNoteUniqueWhere"] | undefined | null,
	data?: ValueTypes["FulfillmentNoteWithoutProductsUpdateInput"] | undefined | null
};
	["FulfillmentNoteWithoutProductsUpdateInput"]: {
	note?: string | undefined | null,
	tags?: Array<ValueTypes["FulfillmentNoteUpdateTagsEntityRelationInput"]> | undefined | null,
	venues?: Array<ValueTypes["FulfillmentNoteUpdateVenuesEntityRelationInput"]> | undefined | null,
	cartItems?: Array<ValueTypes["FulfillmentNoteUpdateCartItemsEntityRelationInput"]> | undefined | null,
	orderItems?: Array<ValueTypes["FulfillmentNoteUpdateOrderItemsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["FulfillmentNoteUpdateOrdersEntityRelationInput"]> | undefined | null,
	highlight?: boolean | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	emoji?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FulfillmentNoteUpdateTagsEntityRelationInput"]: {
	create?: ValueTypes["TagWithoutFulfillmentNotesCreateInput"] | undefined | null,
	update?: ValueTypes["FulfillmentNoteUpdateTagsRelationInput"] | undefined | null,
	upsert?: ValueTypes["FulfillmentNoteUpsertTagsRelationInput"] | undefined | null,
	connect?: ValueTypes["TagUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["TagUniqueWhere"] | undefined | null,
	delete?: ValueTypes["TagUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["FulfillmentNoteUpdateTagsRelationInput"]: {
	by?: ValueTypes["TagUniqueWhere"] | undefined | null,
	data?: ValueTypes["TagWithoutFulfillmentNotesUpdateInput"] | undefined | null
};
	["TagWithoutFulfillmentNotesUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	customers?: Array<ValueTypes["TagUpdateCustomersEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["TagUpdateProductsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["TagUpdateCategoriesEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	addTagsOnRegistration?: Array<ValueTypes["TagUpdateAddTagsOnRegistrationEntityRelationInput"]> | undefined | null,
	nestedCategories?: Array<ValueTypes["TagUpdateNestedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["TagUpdateDeliveryZonesEntityRelationInput"]> | undefined | null,
	publicInChannels?: Array<ValueTypes["TagUpdatePublicInChannelsEntityRelationInput"]> | undefined | null,
	allowChannelPayments?: Array<ValueTypes["TagUpdateAllowChannelPaymentsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FulfillmentNoteUpsertTagsRelationInput"]: {
	by?: ValueTypes["TagUniqueWhere"] | undefined | null,
	update?: ValueTypes["TagWithoutFulfillmentNotesUpdateInput"] | undefined | null,
	create?: ValueTypes["TagWithoutFulfillmentNotesCreateInput"] | undefined | null
};
	["FulfillmentNoteUpdateVenuesEntityRelationInput"]: {
	create?: ValueTypes["VenueWithoutFulfillmentNotesCreateInput"] | undefined | null,
	update?: ValueTypes["FulfillmentNoteUpdateVenuesRelationInput"] | undefined | null,
	upsert?: ValueTypes["FulfillmentNoteUpsertVenuesRelationInput"] | undefined | null,
	connect?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	delete?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["FulfillmentNoteUpdateVenuesRelationInput"]: {
	by?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	data?: ValueTypes["VenueWithoutFulfillmentNotesUpdateInput"] | undefined | null
};
	["VenueWithoutFulfillmentNotesUpdateInput"]: {
	name?: string | undefined | null,
	deadlineTemplate?: ValueTypes["VenueUpdateDeadlineTemplateEntityRelationInput"] | undefined | null,
	timetableDays?: Array<ValueTypes["VenueUpdateTimetableDaysEntityRelationInput"]> | undefined | null,
	timetableTemplates?: Array<ValueTypes["VenueUpdateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	staffMembers?: Array<ValueTypes["VenueUpdateStaffMembersEntityRelationInput"]> | undefined | null,
	employeeRoles?: Array<ValueTypes["VenueUpdateEmployeeRolesEntityRelationInput"]> | undefined | null,
	pointOfSaleApplicationDevices?: Array<ValueTypes["VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined | null,
	pointOfSaleTerminals?: Array<ValueTypes["VenueUpdatePointOfSaleTerminalsEntityRelationInput"]> | undefined | null,
	pointOfSalePrinters?: Array<ValueTypes["VenueUpdatePointOfSalePrintersEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["VenueUpdateOrdersEntityRelationInput"]> | undefined | null,
	areas?: Array<ValueTypes["VenueUpdateAreasEntityRelationInput"]> | undefined | null,
	enabledUnassignReasons?: Array<ValueTypes["VenueUpdateEnabledUnassignReasonsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["VenueUpdateCategoriesEntityRelationInput"]> | undefined | null,
	channels?: Array<ValueTypes["VenueUpdateChannelsEntityRelationInput"]> | undefined | null,
	address?: string | undefined | null,
	pointOfSalePngBase64ReceiptLogo?: string | undefined | null,
	pointOfSaleInitialView?: ValueTypes["PointOfSaleInitialView"] | undefined | null,
	pointOfSalePreferPrintReceipt?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VenueUpdateTimetableTemplatesEntityRelationInput"]: {
	create?: ValueTypes["TimetableTemplateWithoutVenueCreateInput"] | undefined | null,
	update?: ValueTypes["VenueUpdateTimetableTemplatesRelationInput"] | undefined | null,
	upsert?: ValueTypes["VenueUpsertTimetableTemplatesRelationInput"] | undefined | null,
	connect?: ValueTypes["TimetableTemplateUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["TimetableTemplateUniqueWhere"] | undefined | null,
	delete?: ValueTypes["TimetableTemplateUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["VenueUpdateTimetableTemplatesRelationInput"]: {
	by?: ValueTypes["TimetableTemplateUniqueWhere"] | undefined | null,
	data?: ValueTypes["TimetableTemplateWithoutVenueUpdateInput"] | undefined | null
};
	["TimetableTemplateWithoutVenueUpdateInput"]: {
	order?: number | undefined | null,
	startDate?: ValueTypes["Date"] | undefined | null,
	period?: number | undefined | null,
	slots?: number | undefined | null,
	position?: ValueTypes["TimetableTemplateUpdatePositionEntityRelationInput"] | undefined | null,
	staffOptions?: Array<ValueTypes["TimetableTemplateUpdateStaffOptionsEntityRelationInput"]> | undefined | null,
	internalName?: string | undefined | null,
	employeeRole?: ValueTypes["TimetableTemplateUpdateEmployeeRoleEntityRelationInput"] | undefined | null,
	workdaysOnly?: boolean | undefined | null,
	monday?: boolean | undefined | null,
	tuesday?: boolean | undefined | null,
	wednesday?: boolean | undefined | null,
	thursday?: boolean | undefined | null,
	friday?: boolean | undefined | null,
	saturday?: boolean | undefined | null,
	sunday?: boolean | undefined | null,
	type?: ValueTypes["TemplateType"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableTemplateUpdateEmployeeRoleEntityRelationInput"]: {
	create?: ValueTypes["TimetableEmployeeRoleWithoutTimetableTemplatesCreateInput"] | undefined | null,
	update?: ValueTypes["TimetableEmployeeRoleWithoutTimetableTemplatesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["TimetableTemplateUpsertEmployeeRoleRelationInput"] | undefined | null,
	connect?: ValueTypes["TimetableEmployeeRoleUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["TimetableEmployeeRoleWithoutTimetableTemplatesUpdateInput"]: {
	shiftGroups?: Array<ValueTypes["TimetableEmployeeRoleUpdateShiftGroupsEntityRelationInput"]> | undefined | null,
	shiftsProfiles?: Array<ValueTypes["TimetableEmployeeRoleUpdateShiftsProfilesEntityRelationInput"]> | undefined | null,
	shiftsManagers?: Array<ValueTypes["TimetableEmployeeRoleUpdateShiftsManagersEntityRelationInput"]> | undefined | null,
	name?: string | undefined | null,
	color?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableTemplateUpsertEmployeeRoleRelationInput"]: {
	update?: ValueTypes["TimetableEmployeeRoleWithoutTimetableTemplatesUpdateInput"] | undefined | null,
	create?: ValueTypes["TimetableEmployeeRoleWithoutTimetableTemplatesCreateInput"] | undefined | null
};
	["VenueUpsertTimetableTemplatesRelationInput"]: {
	by?: ValueTypes["TimetableTemplateUniqueWhere"] | undefined | null,
	update?: ValueTypes["TimetableTemplateWithoutVenueUpdateInput"] | undefined | null,
	create?: ValueTypes["TimetableTemplateWithoutVenueCreateInput"] | undefined | null
};
	["VenueUpdatePointOfSaleTerminalsEntityRelationInput"]: {
	create?: ValueTypes["PointOfSaleTerminalWithoutVenueCreateInput"] | undefined | null,
	update?: ValueTypes["VenueUpdatePointOfSaleTerminalsRelationInput"] | undefined | null,
	upsert?: ValueTypes["VenueUpsertPointOfSaleTerminalsRelationInput"] | undefined | null,
	connect?: ValueTypes["PointOfSaleTerminalUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["PointOfSaleTerminalUniqueWhere"] | undefined | null,
	delete?: ValueTypes["PointOfSaleTerminalUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["VenueUpdatePointOfSaleTerminalsRelationInput"]: {
	by?: ValueTypes["PointOfSaleTerminalUniqueWhere"] | undefined | null,
	data?: ValueTypes["PointOfSaleTerminalWithoutVenueUpdateInput"] | undefined | null
};
	["PointOfSaleTerminalWithoutVenueUpdateInput"]: {
	internalName?: string | undefined | null,
	note?: string | undefined | null,
	applicationDevices?: Array<ValueTypes["PointOfSaleTerminalUpdateApplicationDevicesEntityRelationInput"]> | undefined | null,
	ipAddress?: string | undefined | null,
	port?: number | undefined | null,
	type?: ValueTypes["PointOfSaleTerminalType"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleTerminalUpdateApplicationDevicesEntityRelationInput"]: {
	create?: ValueTypes["PointOfSaleApplicationDeviceWithoutTerminalCreateInput"] | undefined | null,
	update?: ValueTypes["PointOfSaleTerminalUpdateApplicationDevicesRelationInput"] | undefined | null,
	upsert?: ValueTypes["PointOfSaleTerminalUpsertApplicationDevicesRelationInput"] | undefined | null,
	connect?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null,
	delete?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PointOfSaleTerminalUpdateApplicationDevicesRelationInput"]: {
	by?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null,
	data?: ValueTypes["PointOfSaleApplicationDeviceWithoutTerminalUpdateInput"] | undefined | null
};
	["PointOfSaleApplicationDeviceWithoutTerminalUpdateInput"]: {
	internalName?: string | undefined | null,
	note?: string | undefined | null,
	venue?: ValueTypes["PointOfSaleApplicationDeviceUpdateVenueEntityRelationInput"] | undefined | null,
	identificationCode?: ValueTypes["PointOfSaleApplicationDeviceUpdateIdentificationCodeEntityRelationInput"] | undefined | null,
	identifier?: ValueTypes["PointOfSaleApplicationDeviceUpdateIdentifierEntityRelationInput"] | undefined | null,
	receiptPrinter?: ValueTypes["PointOfSaleApplicationDeviceUpdateReceiptPrinterEntityRelationInput"] | undefined | null,
	ticketPrinters?: Array<ValueTypes["PointOfSaleApplicationDeviceUpdateTicketPrintersEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleApplicationDeviceUpdateVenueEntityRelationInput"]: {
	create?: ValueTypes["VenueWithoutPointOfSaleApplicationDevicesCreateInput"] | undefined | null,
	update?: ValueTypes["VenueWithoutPointOfSaleApplicationDevicesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["PointOfSaleApplicationDeviceUpsertVenueRelationInput"] | undefined | null,
	connect?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["VenueWithoutPointOfSaleApplicationDevicesUpdateInput"]: {
	name?: string | undefined | null,
	deadlineTemplate?: ValueTypes["VenueUpdateDeadlineTemplateEntityRelationInput"] | undefined | null,
	timetableDays?: Array<ValueTypes["VenueUpdateTimetableDaysEntityRelationInput"]> | undefined | null,
	timetableTemplates?: Array<ValueTypes["VenueUpdateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	staffMembers?: Array<ValueTypes["VenueUpdateStaffMembersEntityRelationInput"]> | undefined | null,
	employeeRoles?: Array<ValueTypes["VenueUpdateEmployeeRolesEntityRelationInput"]> | undefined | null,
	pointOfSaleTerminals?: Array<ValueTypes["VenueUpdatePointOfSaleTerminalsEntityRelationInput"]> | undefined | null,
	pointOfSalePrinters?: Array<ValueTypes["VenueUpdatePointOfSalePrintersEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["VenueUpdateOrdersEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["VenueUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	areas?: Array<ValueTypes["VenueUpdateAreasEntityRelationInput"]> | undefined | null,
	enabledUnassignReasons?: Array<ValueTypes["VenueUpdateEnabledUnassignReasonsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["VenueUpdateCategoriesEntityRelationInput"]> | undefined | null,
	channels?: Array<ValueTypes["VenueUpdateChannelsEntityRelationInput"]> | undefined | null,
	address?: string | undefined | null,
	pointOfSalePngBase64ReceiptLogo?: string | undefined | null,
	pointOfSaleInitialView?: ValueTypes["PointOfSaleInitialView"] | undefined | null,
	pointOfSalePreferPrintReceipt?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VenueUpdatePointOfSalePrintersEntityRelationInput"]: {
	create?: ValueTypes["PointOfSalePrinterWithoutVenueCreateInput"] | undefined | null,
	update?: ValueTypes["VenueUpdatePointOfSalePrintersRelationInput"] | undefined | null,
	upsert?: ValueTypes["VenueUpsertPointOfSalePrintersRelationInput"] | undefined | null,
	connect?: ValueTypes["PointOfSalePrinterUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["PointOfSalePrinterUniqueWhere"] | undefined | null,
	delete?: ValueTypes["PointOfSalePrinterUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["VenueUpdatePointOfSalePrintersRelationInput"]: {
	by?: ValueTypes["PointOfSalePrinterUniqueWhere"] | undefined | null,
	data?: ValueTypes["PointOfSalePrinterWithoutVenueUpdateInput"] | undefined | null
};
	["PointOfSalePrinterWithoutVenueUpdateInput"]: {
	internalName?: string | undefined | null,
	note?: string | undefined | null,
	ipAddress?: string | undefined | null,
	applicationDevicesReceipt?: Array<ValueTypes["PointOfSalePrinterUpdateApplicationDevicesReceiptEntityRelationInput"]> | undefined | null,
	applicationDevicesTicket?: Array<ValueTypes["PointOfSalePrinterUpdateApplicationDevicesTicketEntityRelationInput"]> | undefined | null,
	ticketCategories?: Array<ValueTypes["PointOfSalePrinterUpdateTicketCategoriesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSalePrinterUpdateApplicationDevicesReceiptEntityRelationInput"]: {
	create?: ValueTypes["PointOfSaleApplicationDeviceWithoutReceiptPrinterCreateInput"] | undefined | null,
	update?: ValueTypes["PointOfSalePrinterUpdateApplicationDevicesReceiptRelationInput"] | undefined | null,
	upsert?: ValueTypes["PointOfSalePrinterUpsertApplicationDevicesReceiptRelationInput"] | undefined | null,
	connect?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null,
	delete?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PointOfSalePrinterUpdateApplicationDevicesReceiptRelationInput"]: {
	by?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null,
	data?: ValueTypes["PointOfSaleApplicationDeviceWithoutReceiptPrinterUpdateInput"] | undefined | null
};
	["PointOfSaleApplicationDeviceWithoutReceiptPrinterUpdateInput"]: {
	internalName?: string | undefined | null,
	note?: string | undefined | null,
	venue?: ValueTypes["PointOfSaleApplicationDeviceUpdateVenueEntityRelationInput"] | undefined | null,
	identificationCode?: ValueTypes["PointOfSaleApplicationDeviceUpdateIdentificationCodeEntityRelationInput"] | undefined | null,
	identifier?: ValueTypes["PointOfSaleApplicationDeviceUpdateIdentifierEntityRelationInput"] | undefined | null,
	terminal?: ValueTypes["PointOfSaleApplicationDeviceUpdateTerminalEntityRelationInput"] | undefined | null,
	ticketPrinters?: Array<ValueTypes["PointOfSaleApplicationDeviceUpdateTicketPrintersEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleApplicationDeviceUpdateIdentifierEntityRelationInput"]: {
	create?: ValueTypes["DeviceIdentifierWithoutDeviceCreateInput"] | undefined | null,
	update?: ValueTypes["DeviceIdentifierWithoutDeviceUpdateInput"] | undefined | null,
	upsert?: ValueTypes["PointOfSaleApplicationDeviceUpsertIdentifierRelationInput"] | undefined | null,
	connect?: ValueTypes["DeviceIdentifierUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["DeviceIdentifierWithoutDeviceUpdateInput"]: {
	internalName?: string | undefined | null,
	updatedAt?: ValueTypes["DateTime"] | undefined | null,
	platform?: string | undefined | null,
	resolution?: string | undefined | null,
	devicePixelRatio?: number | undefined | null,
	updatedByUser?: ValueTypes["DeviceIdentifierUpdateUpdatedByUserEntityRelationInput"] | undefined | null,
	identifier?: string | undefined | null,
	applicationVersionIdentifier?: string | undefined | null,
	lastPointOfSaleSynchronizationErrorRawDetails?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeviceIdentifierUpdateUpdatedByUserEntityRelationInput"]: {
	create?: ValueTypes["UserCreateInput"] | undefined | null,
	update?: ValueTypes["UserUpdateInput"] | undefined | null,
	upsert?: ValueTypes["DeviceIdentifierUpsertUpdatedByUserRelationInput"] | undefined | null,
	connect?: ValueTypes["UserUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["UserUpdateInput"]: {
	name?: string | undefined | null,
	internalNote?: string | undefined | null,
	staff?: ValueTypes["UserUpdateStaffEntityRelationInput"] | undefined | null,
	customer?: ValueTypes["UserUpdateCustomerEntityRelationInput"] | undefined | null,
	tenantPersonId?: ValueTypes["UUID"] | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	devices?: Array<ValueTypes["UserUpdateDevicesEntityRelationInput"]> | undefined | null,
	verifiedAt?: ValueTypes["DateTime"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	deletionRequestedAt?: ValueTypes["DateTime"] | undefined | null,
	deletionExpectedAt?: ValueTypes["DateTime"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	meta?: ValueTypes["UserUpdateMetaEntityRelationInput"] | undefined | null,
	identificationAttempts?: Array<ValueTypes["UserUpdateIdentificationAttemptsEntityRelationInput"]> | undefined | null,
	roles?: ValueTypes["UserUpdateRolesEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserUpdateMetaEntityRelationInput"]: {
	connect?: ValueTypes["UserMetadataUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["UserUpdateIdentificationAttemptsEntityRelationInput"]: {
	create?: ValueTypes["IdentificationAttemptWithoutUserCreateInput"] | undefined | null,
	update?: ValueTypes["UserUpdateIdentificationAttemptsRelationInput"] | undefined | null,
	upsert?: ValueTypes["UserUpsertIdentificationAttemptsRelationInput"] | undefined | null,
	connect?: ValueTypes["IdentificationAttemptUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["IdentificationAttemptUniqueWhere"] | undefined | null,
	delete?: ValueTypes["IdentificationAttemptUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["UserUpdateIdentificationAttemptsRelationInput"]: {
	by?: ValueTypes["IdentificationAttemptUniqueWhere"] | undefined | null,
	data?: ValueTypes["IdentificationAttemptWithoutUserUpdateInput"] | undefined | null
};
	["IdentificationAttemptWithoutUserUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	code?: ValueTypes["IdentificationAttemptUpdateCodeEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IdentificationAttemptUpdateCodeEntityRelationInput"]: {
	create?: ValueTypes["IdentificationCodeWithoutAttemptsCreateInput"] | undefined | null,
	update?: ValueTypes["IdentificationCodeWithoutAttemptsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["IdentificationAttemptUpsertCodeRelationInput"] | undefined | null,
	connect?: ValueTypes["IdentificationCodeUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["IdentificationCodeWithoutAttemptsUpdateInput"]: {
	code?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	locales?: Array<ValueTypes["IdentificationCodeUpdateLocalesEntityRelationInput"]> | undefined | null,
	internalName?: string | undefined | null,
	applicationDevices?: Array<ValueTypes["IdentificationCodeUpdateApplicationDevicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IdentificationCodeUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["IdentificationCodeLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ValueTypes["IdentificationCodeUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ValueTypes["IdentificationCodeUpsertLocalesRelationInput"] | undefined | null,
	connect?: ValueTypes["IdentificationCodeLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["IdentificationCodeLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["IdentificationCodeLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["IdentificationCodeUpdateLocalesRelationInput"]: {
	by?: ValueTypes["IdentificationCodeLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["IdentificationCodeLocaleWithoutRootUpdateInput"] | undefined | null
};
	["IdentificationCodeLocaleWithoutRootUpdateInput"]: {
	successMessage?: string | undefined | null,
	locale?: ValueTypes["IdentificationCodeLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IdentificationCodeLocaleUpdateLocaleEntityRelationInput"]: {
	create?: ValueTypes["LocaleWithoutIdentificationCodesCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleWithoutIdentificationCodesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["IdentificationCodeLocaleUpsertLocaleRelationInput"] | undefined | null,
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutIdentificationCodesUpdateInput"]: {
	businessCategories?: Array<ValueTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleUpdateProductsEntityRelationInput"]: {
	create?: ValueTypes["ProductLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleUpdateProductsRelationInput"] | undefined | null,
	upsert?: ValueTypes["LocaleUpsertProductsRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateProductsRelationInput"]: {
	by?: ValueTypes["ProductLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["ProductLocaleWithoutLocaleUpdateInput"] | undefined | null
};
	["ProductLocaleWithoutLocaleUpdateInput"]: {
	name?: string | undefined | null,
	description?: string | undefined | null,
	root?: ValueTypes["ProductLocaleUpdateRootEntityRelationInput"] | undefined | null,
	featureList?: ValueTypes["ProductLocaleUpdateFeatureListEntityRelationInput"] | undefined | null,
	printableName?: string | undefined | null,
	firstSticker?: string | undefined | null,
	secondSticker?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductLocaleUpdateRootEntityRelationInput"]: {
	create?: ValueTypes["ProductWithoutLocalesCreateInput"] | undefined | null,
	update?: ValueTypes["ProductWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductLocaleUpsertRootRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductWithoutLocalesUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	priceCents?: number | undefined | null,
	notDiscountable?: boolean | undefined | null,
	packing?: ValueTypes["ProductUpdatePackingEntityRelationInput"] | undefined | null,
	recipe?: ValueTypes["ProductUpdateRecipeEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["ProductUpdateTagsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["ProductUpdateCategoriesEntityRelationInput"]> | undefined | null,
	vatRate?: ValueTypes["ProductUpdateVatRateEntityRelationInput"] | undefined | null,
	stocks?: Array<ValueTypes["ProductUpdateStocksEntityRelationInput"]> | undefined | null,
	groupPrices?: Array<ValueTypes["ProductUpdateGroupPricesEntityRelationInput"]> | undefined | null,
	image?: ValueTypes["ProductUpdateImageEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	cartItems?: Array<ValueTypes["ProductUpdateCartItemsEntityRelationInput"]> | undefined | null,
	availability?: ValueTypes["ProductAvailability"] | undefined | null,
	order?: number | undefined | null,
	manager?: ValueTypes["ProductUpdateManagerEntityRelationInput"] | undefined | null,
	orderItems?: Array<ValueTypes["ProductUpdateOrderItemsEntityRelationInput"]> | undefined | null,
	maximumQuantityPerOrder?: number | undefined | null,
	inheritedCategories?: Array<ValueTypes["ProductUpdateInheritedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["ProductUpdateDeliveryZonesEntityRelationInput"]> | undefined | null,
	archivedAt?: ValueTypes["DateTime"] | undefined | null,
	customerPrices?: Array<ValueTypes["ProductUpdateCustomerPricesEntityRelationInput"]> | undefined | null,
	virtualProduct?: ValueTypes["ProductUpdateVirtualProductEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["ProductUpdateMetaEntityRelationInput"] | undefined | null,
	page?: ValueTypes["ProductUpdatePageEntityRelationInput"] | undefined | null,
	salesDays?: Array<ValueTypes["ProductUpdateSalesDaysEntityRelationInput"]> | undefined | null,
	salesWeeks?: Array<ValueTypes["ProductUpdateSalesWeeksEntityRelationInput"]> | undefined | null,
	salesMonths?: Array<ValueTypes["ProductUpdateSalesMonthsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["ProductUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	hasSubscription?: boolean | undefined | null,
	pointOfSaleTileColor?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductLocaleUpsertRootRelationInput"]: {
	update?: ValueTypes["ProductWithoutLocalesUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductWithoutLocalesCreateInput"] | undefined | null
};
	["ProductLocaleUpdateFeatureListEntityRelationInput"]: {
	create?: ValueTypes["TextListCreateInput"] | undefined | null,
	update?: ValueTypes["TextListUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductLocaleUpsertFeatureListRelationInput"] | undefined | null,
	connect?: ValueTypes["TextListUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductLocaleUpsertFeatureListRelationInput"]: {
	update?: ValueTypes["TextListUpdateInput"] | undefined | null,
	create?: ValueTypes["TextListCreateInput"] | undefined | null
};
	["LocaleUpsertProductsRelationInput"]: {
	by?: ValueTypes["ProductLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["ProductLocaleWithoutLocaleUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductLocaleWithoutLocaleCreateInput"] | undefined | null
};
	["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]: {
	create?: ValueTypes["PointOfSaleCategoryProductLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleUpdatePointOfSaleCategoryProductsRelationInput"] | undefined | null,
	upsert?: ValueTypes["LocaleUpsertPointOfSaleCategoryProductsRelationInput"] | undefined | null,
	connect?: ValueTypes["PointOfSaleCategoryProductLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["PointOfSaleCategoryProductLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["PointOfSaleCategoryProductLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdatePointOfSaleCategoryProductsRelationInput"]: {
	by?: ValueTypes["PointOfSaleCategoryProductLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["PointOfSaleCategoryProductLocaleWithoutLocaleUpdateInput"] | undefined | null
};
	["PointOfSaleCategoryProductLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined | null,
	root?: ValueTypes["PointOfSaleCategoryProductLocaleUpdateRootEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleCategoryProductLocaleUpdateRootEntityRelationInput"]: {
	create?: ValueTypes["PointOfSaleCategoryProductWithoutLocalesCreateInput"] | undefined | null,
	update?: ValueTypes["PointOfSaleCategoryProductWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["PointOfSaleCategoryProductLocaleUpsertRootRelationInput"] | undefined | null,
	connect?: ValueTypes["PointOfSaleCategoryProductUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["PointOfSaleCategoryProductWithoutLocalesUpdateInput"]: {
	order?: number | undefined | null,
	category?: ValueTypes["PointOfSaleCategoryProductUpdateCategoryEntityRelationInput"] | undefined | null,
	product?: ValueTypes["PointOfSaleCategoryProductUpdateProductEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleCategoryProductUpdateCategoryEntityRelationInput"]: {
	create?: ValueTypes["PointOfSaleCategoryWithoutProductsCreateInput"] | undefined | null,
	update?: ValueTypes["PointOfSaleCategoryWithoutProductsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["PointOfSaleCategoryProductUpsertCategoryRelationInput"] | undefined | null,
	connect?: ValueTypes["PointOfSaleCategoryUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["PointOfSaleCategoryWithoutProductsUpdateInput"]: {
	order?: number | undefined | null,
	slug?: string | undefined | null,
	locales?: Array<ValueTypes["PointOfSaleCategoryUpdateLocalesEntityRelationInput"]> | undefined | null,
	category?: ValueTypes["PointOfSaleCategoryUpdateCategoryEntityRelationInput"] | undefined | null,
	venue?: ValueTypes["PointOfSaleCategoryUpdateVenueEntityRelationInput"] | undefined | null,
	ticketPrinters?: Array<ValueTypes["PointOfSaleCategoryUpdateTicketPrintersEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleCategoryUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["PointOfSaleCategoryLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ValueTypes["PointOfSaleCategoryUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ValueTypes["PointOfSaleCategoryUpsertLocalesRelationInput"] | undefined | null,
	connect?: ValueTypes["PointOfSaleCategoryLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["PointOfSaleCategoryLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["PointOfSaleCategoryLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PointOfSaleCategoryUpdateLocalesRelationInput"]: {
	by?: ValueTypes["PointOfSaleCategoryLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["PointOfSaleCategoryLocaleWithoutRootUpdateInput"] | undefined | null
};
	["PointOfSaleCategoryLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined | null,
	locale?: ValueTypes["PointOfSaleCategoryLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleCategoryLocaleUpdateLocaleEntityRelationInput"]: {
	create?: ValueTypes["LocaleWithoutPointOfSaleCategoriesCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleWithoutPointOfSaleCategoriesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["PointOfSaleCategoryLocaleUpsertLocaleRelationInput"] | undefined | null,
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutPointOfSaleCategoriesUpdateInput"]: {
	businessCategories?: Array<ValueTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleUpdateDeliveryMethodsEntityRelationInput"]: {
	create?: ValueTypes["DeliveryMethodLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleUpdateDeliveryMethodsRelationInput"] | undefined | null,
	upsert?: ValueTypes["LocaleUpsertDeliveryMethodsRelationInput"] | undefined | null,
	connect?: ValueTypes["DeliveryMethodLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["DeliveryMethodLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["DeliveryMethodLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateDeliveryMethodsRelationInput"]: {
	by?: ValueTypes["DeliveryMethodLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["DeliveryMethodLocaleWithoutLocaleUpdateInput"] | undefined | null
};
	["DeliveryMethodLocaleWithoutLocaleUpdateInput"]: {
	name?: string | undefined | null,
	description?: string | undefined | null,
	trackingCodeUrlTemplate?: string | undefined | null,
	processingTitle?: string | undefined | null,
	processingText?: string | undefined | null,
	processingIconUrl?: string | undefined | null,
	dispatchedTitle?: string | undefined | null,
	dispatchedText?: string | undefined | null,
	dispatchedIconUrl?: string | undefined | null,
	fulfilledTitle?: string | undefined | null,
	fulfilledText?: string | undefined | null,
	fulfilledIconUrl?: string | undefined | null,
	root?: ValueTypes["DeliveryMethodLocaleUpdateRootEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryMethodLocaleUpdateRootEntityRelationInput"]: {
	create?: ValueTypes["DeliveryMethodWithoutLocalesCreateInput"] | undefined | null,
	update?: ValueTypes["DeliveryMethodWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["DeliveryMethodLocaleUpsertRootRelationInput"] | undefined | null,
	connect?: ValueTypes["DeliveryMethodUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["DeliveryMethodWithoutLocalesUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	enabled?: boolean | undefined | null,
	paymentMethods?: Array<ValueTypes["DeliveryMethodUpdatePaymentMethodsEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	requireDeliveryAddress?: boolean | undefined | null,
	suitableForDeliveryZones?: Array<ValueTypes["DeliveryMethodUpdateSuitableForDeliveryZonesEntityRelationInput"]> | undefined | null,
	channels?: Array<ValueTypes["DeliveryMethodUpdateChannelsEntityRelationInput"]> | undefined | null,
	courierHandlers?: Array<ValueTypes["DeliveryMethodUpdateCourierHandlersEntityRelationInput"]> | undefined | null,
	enableDeliveryTracking?: boolean | undefined | null,
	timelinePreset?: ValueTypes["DeliveryMethodUpdateTimelinePresetEntityRelationInput"] | undefined | null,
	woltDriveVenueId?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryMethodUpdateTimelinePresetEntityRelationInput"]: {
	create?: ValueTypes["DeliveryTimelinePresetWithoutDeliveryMethodCreateInput"] | undefined | null,
	update?: ValueTypes["DeliveryTimelinePresetWithoutDeliveryMethodUpdateInput"] | undefined | null,
	upsert?: ValueTypes["DeliveryMethodUpsertTimelinePresetRelationInput"] | undefined | null,
	connect?: ValueTypes["DeliveryTimelinePresetUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["DeliveryTimelinePresetWithoutDeliveryMethodUpdateInput"]: {
	type?: ValueTypes["DeliveryTimelineType"] | undefined | null,
	duration?: string | undefined | null,
	window?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryMethodUpsertTimelinePresetRelationInput"]: {
	update?: ValueTypes["DeliveryTimelinePresetWithoutDeliveryMethodUpdateInput"] | undefined | null,
	create?: ValueTypes["DeliveryTimelinePresetWithoutDeliveryMethodCreateInput"] | undefined | null
};
	["DeliveryMethodLocaleUpsertRootRelationInput"]: {
	update?: ValueTypes["DeliveryMethodWithoutLocalesUpdateInput"] | undefined | null,
	create?: ValueTypes["DeliveryMethodWithoutLocalesCreateInput"] | undefined | null
};
	["LocaleUpsertDeliveryMethodsRelationInput"]: {
	by?: ValueTypes["DeliveryMethodLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["DeliveryMethodLocaleWithoutLocaleUpdateInput"] | undefined | null,
	create?: ValueTypes["DeliveryMethodLocaleWithoutLocaleCreateInput"] | undefined | null
};
	["LocaleUpdateIngredientSuppliersEntityRelationInput"]: {
	create?: ValueTypes["IngredientSupplierLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleUpdateIngredientSuppliersRelationInput"] | undefined | null,
	upsert?: ValueTypes["LocaleUpsertIngredientSuppliersRelationInput"] | undefined | null,
	connect?: ValueTypes["IngredientSupplierLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["IngredientSupplierLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["IngredientSupplierLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateIngredientSuppliersRelationInput"]: {
	by?: ValueTypes["IngredientSupplierLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["IngredientSupplierLocaleWithoutLocaleUpdateInput"] | undefined | null
};
	["IngredientSupplierLocaleWithoutLocaleUpdateInput"]: {
	name?: string | undefined | null,
	root?: ValueTypes["IngredientSupplierLocaleUpdateRootEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IngredientSupplierLocaleUpdateRootEntityRelationInput"]: {
	create?: ValueTypes["IngredientSupplierWithoutLocalesCreateInput"] | undefined | null,
	update?: ValueTypes["IngredientSupplierWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["IngredientSupplierLocaleUpsertRootRelationInput"] | undefined | null,
	connect?: ValueTypes["IngredientSupplierUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["IngredientSupplierWithoutLocalesUpdateInput"]: {
	internalName?: string | undefined | null,
	internalNote?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IngredientSupplierLocaleUpsertRootRelationInput"]: {
	update?: ValueTypes["IngredientSupplierWithoutLocalesUpdateInput"] | undefined | null,
	create?: ValueTypes["IngredientSupplierWithoutLocalesCreateInput"] | undefined | null
};
	["LocaleUpsertIngredientSuppliersRelationInput"]: {
	by?: ValueTypes["IngredientSupplierLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["IngredientSupplierLocaleWithoutLocaleUpdateInput"] | undefined | null,
	create?: ValueTypes["IngredientSupplierLocaleWithoutLocaleCreateInput"] | undefined | null
};
	["LocaleUpdateIdentificationCodesEntityRelationInput"]: {
	create?: ValueTypes["IdentificationCodeLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleUpdateIdentificationCodesRelationInput"] | undefined | null,
	upsert?: ValueTypes["LocaleUpsertIdentificationCodesRelationInput"] | undefined | null,
	connect?: ValueTypes["IdentificationCodeLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["IdentificationCodeLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["IdentificationCodeLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateIdentificationCodesRelationInput"]: {
	by?: ValueTypes["IdentificationCodeLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["IdentificationCodeLocaleWithoutLocaleUpdateInput"] | undefined | null
};
	["IdentificationCodeLocaleWithoutLocaleUpdateInput"]: {
	successMessage?: string | undefined | null,
	root?: ValueTypes["IdentificationCodeLocaleUpdateRootEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IdentificationCodeLocaleUpdateRootEntityRelationInput"]: {
	create?: ValueTypes["IdentificationCodeWithoutLocalesCreateInput"] | undefined | null,
	update?: ValueTypes["IdentificationCodeWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["IdentificationCodeLocaleUpsertRootRelationInput"] | undefined | null,
	connect?: ValueTypes["IdentificationCodeUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["IdentificationCodeWithoutLocalesUpdateInput"]: {
	code?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	attempts?: Array<ValueTypes["IdentificationCodeUpdateAttemptsEntityRelationInput"]> | undefined | null,
	internalName?: string | undefined | null,
	applicationDevices?: Array<ValueTypes["IdentificationCodeUpdateApplicationDevicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IdentificationCodeUpdateApplicationDevicesEntityRelationInput"]: {
	create?: ValueTypes["PointOfSaleApplicationDeviceWithoutIdentificationCodeCreateInput"] | undefined | null,
	update?: ValueTypes["IdentificationCodeUpdateApplicationDevicesRelationInput"] | undefined | null,
	upsert?: ValueTypes["IdentificationCodeUpsertApplicationDevicesRelationInput"] | undefined | null,
	connect?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null,
	delete?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["IdentificationCodeUpdateApplicationDevicesRelationInput"]: {
	by?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null,
	data?: ValueTypes["PointOfSaleApplicationDeviceWithoutIdentificationCodeUpdateInput"] | undefined | null
};
	["PointOfSaleApplicationDeviceWithoutIdentificationCodeUpdateInput"]: {
	internalName?: string | undefined | null,
	note?: string | undefined | null,
	venue?: ValueTypes["PointOfSaleApplicationDeviceUpdateVenueEntityRelationInput"] | undefined | null,
	identifier?: ValueTypes["PointOfSaleApplicationDeviceUpdateIdentifierEntityRelationInput"] | undefined | null,
	terminal?: ValueTypes["PointOfSaleApplicationDeviceUpdateTerminalEntityRelationInput"] | undefined | null,
	receiptPrinter?: ValueTypes["PointOfSaleApplicationDeviceUpdateReceiptPrinterEntityRelationInput"] | undefined | null,
	ticketPrinters?: Array<ValueTypes["PointOfSaleApplicationDeviceUpdateTicketPrintersEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleApplicationDeviceUpdateTerminalEntityRelationInput"]: {
	create?: ValueTypes["PointOfSaleTerminalWithoutApplicationDevicesCreateInput"] | undefined | null,
	update?: ValueTypes["PointOfSaleTerminalWithoutApplicationDevicesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["PointOfSaleApplicationDeviceUpsertTerminalRelationInput"] | undefined | null,
	connect?: ValueTypes["PointOfSaleTerminalUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PointOfSaleTerminalWithoutApplicationDevicesUpdateInput"]: {
	internalName?: string | undefined | null,
	note?: string | undefined | null,
	venue?: ValueTypes["PointOfSaleTerminalUpdateVenueEntityRelationInput"] | undefined | null,
	ipAddress?: string | undefined | null,
	port?: number | undefined | null,
	type?: ValueTypes["PointOfSaleTerminalType"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleTerminalUpdateVenueEntityRelationInput"]: {
	create?: ValueTypes["VenueWithoutPointOfSaleTerminalsCreateInput"] | undefined | null,
	update?: ValueTypes["VenueWithoutPointOfSaleTerminalsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["PointOfSaleTerminalUpsertVenueRelationInput"] | undefined | null,
	connect?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["VenueWithoutPointOfSaleTerminalsUpdateInput"]: {
	name?: string | undefined | null,
	deadlineTemplate?: ValueTypes["VenueUpdateDeadlineTemplateEntityRelationInput"] | undefined | null,
	timetableDays?: Array<ValueTypes["VenueUpdateTimetableDaysEntityRelationInput"]> | undefined | null,
	timetableTemplates?: Array<ValueTypes["VenueUpdateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	staffMembers?: Array<ValueTypes["VenueUpdateStaffMembersEntityRelationInput"]> | undefined | null,
	employeeRoles?: Array<ValueTypes["VenueUpdateEmployeeRolesEntityRelationInput"]> | undefined | null,
	pointOfSaleApplicationDevices?: Array<ValueTypes["VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined | null,
	pointOfSalePrinters?: Array<ValueTypes["VenueUpdatePointOfSalePrintersEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["VenueUpdateOrdersEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["VenueUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	areas?: Array<ValueTypes["VenueUpdateAreasEntityRelationInput"]> | undefined | null,
	enabledUnassignReasons?: Array<ValueTypes["VenueUpdateEnabledUnassignReasonsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["VenueUpdateCategoriesEntityRelationInput"]> | undefined | null,
	channels?: Array<ValueTypes["VenueUpdateChannelsEntityRelationInput"]> | undefined | null,
	address?: string | undefined | null,
	pointOfSalePngBase64ReceiptLogo?: string | undefined | null,
	pointOfSaleInitialView?: ValueTypes["PointOfSaleInitialView"] | undefined | null,
	pointOfSalePreferPrintReceipt?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VenueUpdateOrdersEntityRelationInput"]: {
	create?: ValueTypes["OrderWithoutVenueCreateInput"] | undefined | null,
	update?: ValueTypes["VenueUpdateOrdersRelationInput"] | undefined | null,
	upsert?: ValueTypes["VenueUpsertOrdersRelationInput"] | undefined | null,
	connect?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	delete?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["VenueUpdateOrdersRelationInput"]: {
	by?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	data?: ValueTypes["OrderWithoutVenueUpdateInput"] | undefined | null
};
	["OrderWithoutVenueUpdateInput"]: {
	state?: ValueTypes["OrderState"] | undefined | null,
	fulfilledAt?: ValueTypes["DateTime"] | undefined | null,
	canceledAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	customer?: ValueTypes["OrderUpdateCustomerEntityRelationInput"] | undefined | null,
	channel?: ValueTypes["OrderUpdateChannelEntityRelationInput"] | undefined | null,
	discounts?: Array<ValueTypes["OrderUpdateDiscountsEntityRelationInput"]> | undefined | null,
	delivery?: ValueTypes["OrderUpdateDeliveryEntityRelationInput"] | undefined | null,
	items?: Array<ValueTypes["OrderUpdateItemsEntityRelationInput"]> | undefined | null,
	internalNote?: string | undefined | null,
	cart?: ValueTypes["OrderUpdateCartEntityRelationInput"] | undefined | null,
	events?: Array<ValueTypes["OrderUpdateEventsEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingAddress?: ValueTypes["OrderUpdateBillingAddressEntityRelationInput"] | undefined | null,
	priceLines?: Array<ValueTypes["OrderUpdatePriceLinesEntityRelationInput"]> | undefined | null,
	payments?: Array<ValueTypes["OrderUpdatePaymentsEntityRelationInput"]> | undefined | null,
	seq?: number | undefined | null,
	billingSubject?: ValueTypes["OrderUpdateBillingSubjectEntityRelationInput"] | undefined | null,
	summary?: ValueTypes["OrderUpdateSummaryEntityRelationInput"] | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	gratuity?: ValueTypes["OrderUpdateGratuityEntityRelationInput"] | undefined | null,
	fulfillmentNote?: string | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["OrderUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	doubleshotTotalWeightGrams?: number | undefined | null,
	doubleShotLegacyNumber?: string | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	doubleshotAdminUrl?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["OrderItemWithoutOrderCreateInput"] | undefined | null,
	update?: ValueTypes["OrderUpdateItemsRelationInput"] | undefined | null,
	upsert?: ValueTypes["OrderUpsertItemsRelationInput"] | undefined | null,
	connect?: ValueTypes["OrderItemUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["OrderItemUniqueWhere"] | undefined | null,
	delete?: ValueTypes["OrderItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["OrderUpdateItemsRelationInput"]: {
	by?: ValueTypes["OrderItemUniqueWhere"] | undefined | null,
	data?: ValueTypes["OrderItemWithoutOrderUpdateInput"] | undefined | null
};
	["OrderItemWithoutOrderUpdateInput"]: {
	unitPriceCents?: number | undefined | null,
	quantity?: number | undefined | null,
	vatRate?: ValueTypes["OrderItemUpdateVatRateEntityRelationInput"] | undefined | null,
	virtualProductEffects?: Array<ValueTypes["OrderItemUpdateVirtualProductEffectsEntityRelationInput"]> | undefined | null,
	pickedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["OrderItemUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	product?: ValueTypes["OrderItemUpdateProductEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderItemUpdateVirtualProductEffectsEntityRelationInput"]: {
	create?: ValueTypes["VirtualProductEffectWithoutOrderItemCreateInput"] | undefined | null,
	update?: ValueTypes["OrderItemUpdateVirtualProductEffectsRelationInput"] | undefined | null,
	upsert?: ValueTypes["OrderItemUpsertVirtualProductEffectsRelationInput"] | undefined | null,
	connect?: ValueTypes["VirtualProductEffectUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["VirtualProductEffectUniqueWhere"] | undefined | null,
	delete?: ValueTypes["VirtualProductEffectUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["OrderItemUpdateVirtualProductEffectsRelationInput"]: {
	by?: ValueTypes["VirtualProductEffectUniqueWhere"] | undefined | null,
	data?: ValueTypes["VirtualProductEffectWithoutOrderItemUpdateInput"] | undefined | null
};
	["VirtualProductEffectWithoutOrderItemUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	succeededAt?: ValueTypes["DateTime"] | undefined | null,
	failedAt?: ValueTypes["DateTime"] | undefined | null,
	revertedAt?: ValueTypes["DateTime"] | undefined | null,
	resultCustomerCreditTransaction?: ValueTypes["VirtualProductEffectUpdateResultCustomerCreditTransactionEntityRelationInput"] | undefined | null,
	resultVouchers?: Array<ValueTypes["VirtualProductEffectUpdateResultVouchersEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VirtualProductEffectUpdateResultCustomerCreditTransactionEntityRelationInput"]: {
	create?: ValueTypes["CustomerCreditTransactionWithoutVirtualProductEffectCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerCreditTransactionWithoutVirtualProductEffectUpdateInput"] | undefined | null,
	upsert?: ValueTypes["VirtualProductEffectUpsertResultCustomerCreditTransactionRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerCreditTransactionUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CustomerCreditTransactionWithoutVirtualProductEffectUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	amountCents?: number | undefined | null,
	customerCredit?: ValueTypes["CustomerCreditTransactionUpdateCustomerCreditEntityRelationInput"] | undefined | null,
	orderDiscount?: ValueTypes["CustomerCreditTransactionUpdateOrderDiscountEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreditTransactionUpdateOrderDiscountEntityRelationInput"]: {
	create?: ValueTypes["OrderDiscountWithoutCustomerCreditTransactionsCreateInput"] | undefined | null,
	update?: ValueTypes["OrderDiscountWithoutCustomerCreditTransactionsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CustomerCreditTransactionUpsertOrderDiscountRelationInput"] | undefined | null,
	connect?: ValueTypes["OrderDiscountUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["OrderDiscountWithoutCustomerCreditTransactionsUpdateInput"]: {
	discountCents?: number | undefined | null,
	vatRate?: ValueTypes["OrderDiscountUpdateVatRateEntityRelationInput"] | undefined | null,
	order?: ValueTypes["OrderDiscountUpdateOrderEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	type?: ValueTypes["OrderDiscountType"] | undefined | null,
	voucherRedemption?: ValueTypes["OrderDiscountUpdateVoucherRedemptionEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderDiscountUpdateOrderEntityRelationInput"]: {
	create?: ValueTypes["OrderWithoutDiscountsCreateInput"] | undefined | null,
	update?: ValueTypes["OrderWithoutDiscountsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["OrderDiscountUpsertOrderRelationInput"] | undefined | null,
	connect?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["OrderWithoutDiscountsUpdateInput"]: {
	state?: ValueTypes["OrderState"] | undefined | null,
	fulfilledAt?: ValueTypes["DateTime"] | undefined | null,
	canceledAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	customer?: ValueTypes["OrderUpdateCustomerEntityRelationInput"] | undefined | null,
	channel?: ValueTypes["OrderUpdateChannelEntityRelationInput"] | undefined | null,
	delivery?: ValueTypes["OrderUpdateDeliveryEntityRelationInput"] | undefined | null,
	items?: Array<ValueTypes["OrderUpdateItemsEntityRelationInput"]> | undefined | null,
	internalNote?: string | undefined | null,
	cart?: ValueTypes["OrderUpdateCartEntityRelationInput"] | undefined | null,
	events?: Array<ValueTypes["OrderUpdateEventsEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingAddress?: ValueTypes["OrderUpdateBillingAddressEntityRelationInput"] | undefined | null,
	priceLines?: Array<ValueTypes["OrderUpdatePriceLinesEntityRelationInput"]> | undefined | null,
	payments?: Array<ValueTypes["OrderUpdatePaymentsEntityRelationInput"]> | undefined | null,
	seq?: number | undefined | null,
	billingSubject?: ValueTypes["OrderUpdateBillingSubjectEntityRelationInput"] | undefined | null,
	summary?: ValueTypes["OrderUpdateSummaryEntityRelationInput"] | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	gratuity?: ValueTypes["OrderUpdateGratuityEntityRelationInput"] | undefined | null,
	venue?: ValueTypes["OrderUpdateVenueEntityRelationInput"] | undefined | null,
	fulfillmentNote?: string | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["OrderUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	doubleshotTotalWeightGrams?: number | undefined | null,
	doubleShotLegacyNumber?: string | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	doubleshotAdminUrl?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderUpdateCartEntityRelationInput"]: {
	create?: ValueTypes["CartWithoutOrderCreateInput"] | undefined | null,
	update?: ValueTypes["CartWithoutOrderUpdateInput"] | undefined | null,
	upsert?: ValueTypes["OrderUpsertCartRelationInput"] | undefined | null,
	connect?: ValueTypes["CartUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CartWithoutOrderUpdateInput"]: {
	confirmedAt?: ValueTypes["DateTime"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	items?: Array<ValueTypes["CartUpdateItemsEntityRelationInput"]> | undefined | null,
	handle?: string | undefined | null,
	state?: ValueTypes["CartState"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	channel?: ValueTypes["CartUpdateChannelEntityRelationInput"] | undefined | null,
	customer?: ValueTypes["CartUpdateCustomerEntityRelationInput"] | undefined | null,
	deliveryAddress?: ValueTypes["CartUpdateDeliveryAddressEntityRelationInput"] | undefined | null,
	billingAddress?: ValueTypes["CartUpdateBillingAddressEntityRelationInput"] | undefined | null,
	deliveryOption?: string | undefined | null,
	paymentOption?: string | undefined | null,
	delivery?: ValueTypes["CartUpdateDeliveryEntityRelationInput"] | undefined | null,
	payment?: ValueTypes["CartUpdatePaymentEntityRelationInput"] | undefined | null,
	billingSubject?: ValueTypes["CartUpdateBillingSubjectEntityRelationInput"] | undefined | null,
	priceLines?: Array<ValueTypes["CartUpdatePriceLinesEntityRelationInput"]> | undefined | null,
	summary?: ValueTypes["CartUpdateSummaryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CartUpdateCustomerEntityRelationInput"]: {
	create?: ValueTypes["CustomerWithoutCartsCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerWithoutCartsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CartUpsertCustomerRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CustomerWithoutCartsUpdateInput"]: {
	addresses?: Array<ValueTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerUpdateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerUpdateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerUpdateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerUpdateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerUpdateInvoicingPlanEntityRelationInput"]: {
	create?: ValueTypes["InvoicingPlanWithoutCustomerCreateInput"] | undefined | null,
	update?: ValueTypes["InvoicingPlanWithoutCustomerUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CustomerUpsertInvoicingPlanRelationInput"] | undefined | null,
	connect?: ValueTypes["InvoicingPlanUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["InvoicingPlanWithoutCustomerUpdateInput"]: {
	preset?: ValueTypes["InvoicingPlanUpdatePresetEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InvoicingPlanUpdatePresetEntityRelationInput"]: {
	create?: ValueTypes["InvoicingPresetWithoutInvoicingPlanCreateInput"] | undefined | null,
	update?: ValueTypes["InvoicingPresetWithoutInvoicingPlanUpdateInput"] | undefined | null,
	upsert?: ValueTypes["InvoicingPlanUpsertPresetRelationInput"] | undefined | null,
	connect?: ValueTypes["InvoicingPresetUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["InvoicingPresetWithoutInvoicingPlanUpdateInput"]: {
	type?: ValueTypes["InvoicingPresetType"] | undefined | null,
	startsAt?: ValueTypes["DateTime"] | undefined | null,
	endsAt?: ValueTypes["DateTime"] | undefined | null,
	intervalOfDays?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InvoicingPlanUpsertPresetRelationInput"]: {
	update?: ValueTypes["InvoicingPresetWithoutInvoicingPlanUpdateInput"] | undefined | null,
	create?: ValueTypes["InvoicingPresetWithoutInvoicingPlanCreateInput"] | undefined | null
};
	["CustomerUpsertInvoicingPlanRelationInput"]: {
	update?: ValueTypes["InvoicingPlanWithoutCustomerUpdateInput"] | undefined | null,
	create?: ValueTypes["InvoicingPlanWithoutCustomerCreateInput"] | undefined | null
};
	["CustomerUpdateBillingSubjectsEntityRelationInput"]: {
	create?: ValueTypes["BillingSubjectWithoutCustomerCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerUpdateBillingSubjectsRelationInput"] | undefined | null,
	upsert?: ValueTypes["CustomerUpsertBillingSubjectsRelationInput"] | undefined | null,
	connect?: ValueTypes["BillingSubjectUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["BillingSubjectUniqueWhere"] | undefined | null,
	delete?: ValueTypes["BillingSubjectUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerUpdateBillingSubjectsRelationInput"]: {
	by?: ValueTypes["BillingSubjectUniqueWhere"] | undefined | null,
	data?: ValueTypes["BillingSubjectWithoutCustomerUpdateInput"] | undefined | null
};
	["BillingSubjectWithoutCustomerUpdateInput"]: {
	name?: string | undefined | null,
	fullName?: string | undefined | null,
	addressLine1?: string | undefined | null,
	addressLine2?: string | undefined | null,
	city?: string | undefined | null,
	postalCode?: string | undefined | null,
	email?: string | undefined | null,
	phone?: string | undefined | null,
	companyName?: string | undefined | null,
	companyIdentifier?: string | undefined | null,
	vatIdentifier?: string | undefined | null,
	externalIdentifier?: string | undefined | null,
	hidden?: boolean | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	internalNote?: string | undefined | null,
	fakturoidSubjectId?: string | undefined | null,
	country?: ValueTypes["BillingSubjectUpdateCountryEntityRelationInput"] | undefined | null,
	invoices?: Array<ValueTypes["BillingSubjectUpdateInvoicesEntityRelationInput"]> | undefined | null,
	defaultBillingSubjectOfCustomer?: ValueTypes["BillingSubjectUpdateDefaultBillingSubjectOfCustomerEntityRelationInput"] | undefined | null,
	orders?: Array<ValueTypes["BillingSubjectUpdateOrdersEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BillingSubjectUpdateCountryEntityRelationInput"]: {
	create?: ValueTypes["CountryCreateInput"] | undefined | null,
	update?: ValueTypes["CountryUpdateInput"] | undefined | null,
	upsert?: ValueTypes["BillingSubjectUpsertCountryRelationInput"] | undefined | null,
	connect?: ValueTypes["CountryUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["BillingSubjectUpsertCountryRelationInput"]: {
	update?: ValueTypes["CountryUpdateInput"] | undefined | null,
	create?: ValueTypes["CountryCreateInput"] | undefined | null
};
	["BillingSubjectUpdateInvoicesEntityRelationInput"]: {
	create?: ValueTypes["InvoiceWithoutBillingSubjectCreateInput"] | undefined | null,
	update?: ValueTypes["BillingSubjectUpdateInvoicesRelationInput"] | undefined | null,
	upsert?: ValueTypes["BillingSubjectUpsertInvoicesRelationInput"] | undefined | null,
	connect?: ValueTypes["InvoiceUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["InvoiceUniqueWhere"] | undefined | null,
	delete?: ValueTypes["InvoiceUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["BillingSubjectUpdateInvoicesRelationInput"]: {
	by?: ValueTypes["InvoiceUniqueWhere"] | undefined | null,
	data?: ValueTypes["InvoiceWithoutBillingSubjectUpdateInput"] | undefined | null
};
	["InvoiceWithoutBillingSubjectUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	publicKey?: string | undefined | null,
	fakturoidId?: string | undefined | null,
	fakturoidData?: string | undefined | null,
	legacyUrl?: string | undefined | null,
	customer?: ValueTypes["InvoiceUpdateCustomerEntityRelationInput"] | undefined | null,
	orderPayments?: Array<ValueTypes["InvoiceUpdateOrderPaymentsEntityRelationInput"]> | undefined | null,
	address?: ValueTypes["InvoiceUpdateAddressEntityRelationInput"] | undefined | null,
	publicUrl?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InvoiceUpdateAddressEntityRelationInput"]: {
	create?: ValueTypes["AddressWithoutInvoicesCreateInput"] | undefined | null,
	update?: ValueTypes["AddressWithoutInvoicesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["InvoiceUpsertAddressRelationInput"] | undefined | null,
	connect?: ValueTypes["AddressUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["AddressWithoutInvoicesUpdateInput"]: {
	name?: string | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	addressLine2?: string | undefined | null,
	email?: string | undefined | null,
	phone?: string | undefined | null,
	companyName?: string | undefined | null,
	companyIdentifier?: string | undefined | null,
	vatIdentifier?: string | undefined | null,
	externalIdentifier?: string | undefined | null,
	hidden?: boolean | undefined | null,
	customer?: ValueTypes["AddressUpdateCustomerEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	country?: ValueTypes["AddressUpdateCountryEntityRelationInput"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	googlePlaceId?: string | undefined | null,
	raw?: string | undefined | null,
	formatted?: string | undefined | null,
	geocodeGeneratedAt?: ValueTypes["DateTime"] | undefined | null,
	geocodeResponse?: string | undefined | null,
	deliveryZone?: ValueTypes["AddressUpdateDeliveryZoneEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["AddressUpdateMetaEntityRelationInput"] | undefined | null,
	gps?: ValueTypes["AddressUpdateGpsEntityRelationInput"] | undefined | null,
	geocodeValid?: boolean | undefined | null,
	fullName?: string | undefined | null,
	fakturoidSubjectId?: string | undefined | null,
	addressLine1?: string | undefined | null,
	city?: string | undefined | null,
	postalCode?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingAddressOfOrders?: Array<ValueTypes["AddressUpdateBillingAddressOfOrdersEntityRelationInput"]> | undefined | null,
	deliveryAddressOfOrderDeliveries?: Array<ValueTypes["AddressUpdateDeliveryAddressOfOrderDeliveriesEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddressOfCustomer?: ValueTypes["AddressUpdateDefaultDeliveryAddressOfCustomerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AddressUpdateBillingAddressOfOrdersEntityRelationInput"]: {
	create?: ValueTypes["OrderWithoutBillingAddressCreateInput"] | undefined | null,
	update?: ValueTypes["AddressUpdateBillingAddressOfOrdersRelationInput"] | undefined | null,
	upsert?: ValueTypes["AddressUpsertBillingAddressOfOrdersRelationInput"] | undefined | null,
	connect?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	delete?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["AddressUpdateBillingAddressOfOrdersRelationInput"]: {
	by?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	data?: ValueTypes["OrderWithoutBillingAddressUpdateInput"] | undefined | null
};
	["OrderWithoutBillingAddressUpdateInput"]: {
	state?: ValueTypes["OrderState"] | undefined | null,
	fulfilledAt?: ValueTypes["DateTime"] | undefined | null,
	canceledAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	customer?: ValueTypes["OrderUpdateCustomerEntityRelationInput"] | undefined | null,
	channel?: ValueTypes["OrderUpdateChannelEntityRelationInput"] | undefined | null,
	discounts?: Array<ValueTypes["OrderUpdateDiscountsEntityRelationInput"]> | undefined | null,
	delivery?: ValueTypes["OrderUpdateDeliveryEntityRelationInput"] | undefined | null,
	items?: Array<ValueTypes["OrderUpdateItemsEntityRelationInput"]> | undefined | null,
	internalNote?: string | undefined | null,
	cart?: ValueTypes["OrderUpdateCartEntityRelationInput"] | undefined | null,
	events?: Array<ValueTypes["OrderUpdateEventsEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	priceLines?: Array<ValueTypes["OrderUpdatePriceLinesEntityRelationInput"]> | undefined | null,
	payments?: Array<ValueTypes["OrderUpdatePaymentsEntityRelationInput"]> | undefined | null,
	seq?: number | undefined | null,
	billingSubject?: ValueTypes["OrderUpdateBillingSubjectEntityRelationInput"] | undefined | null,
	summary?: ValueTypes["OrderUpdateSummaryEntityRelationInput"] | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	gratuity?: ValueTypes["OrderUpdateGratuityEntityRelationInput"] | undefined | null,
	venue?: ValueTypes["OrderUpdateVenueEntityRelationInput"] | undefined | null,
	fulfillmentNote?: string | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["OrderUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	doubleshotTotalWeightGrams?: number | undefined | null,
	doubleShotLegacyNumber?: string | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	doubleshotAdminUrl?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderUpdateEventsEntityRelationInput"]: {
	create?: ValueTypes["OrderEventWithoutOrderCreateInput"] | undefined | null,
	update?: ValueTypes["OrderUpdateEventsRelationInput"] | undefined | null,
	upsert?: ValueTypes["OrderUpsertEventsRelationInput"] | undefined | null,
	connect?: ValueTypes["OrderEventUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["OrderEventUniqueWhere"] | undefined | null,
	delete?: ValueTypes["OrderEventUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["OrderUpdateEventsRelationInput"]: {
	by?: ValueTypes["OrderEventUniqueWhere"] | undefined | null,
	data?: ValueTypes["OrderEventWithoutOrderUpdateInput"] | undefined | null
};
	["OrderEventWithoutOrderUpdateInput"]: {
	type?: string | undefined | null,
	data?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	payment?: ValueTypes["OrderEventUpdatePaymentEntityRelationInput"] | undefined | null,
	delivery?: ValueTypes["OrderEventUpdateDeliveryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderEventUpdatePaymentEntityRelationInput"]: {
	create?: ValueTypes["OrderPaymentWithoutEventsCreateInput"] | undefined | null,
	update?: ValueTypes["OrderPaymentWithoutEventsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["OrderEventUpsertPaymentRelationInput"] | undefined | null,
	connect?: ValueTypes["OrderPaymentUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["OrderPaymentWithoutEventsUpdateInput"]: {
	data?: ValueTypes["Json"] | undefined | null,
	paymentCents?: number | undefined | null,
	method?: ValueTypes["OrderPaymentUpdateMethodEntityRelationInput"] | undefined | null,
	failedAt?: ValueTypes["DateTime"] | undefined | null,
	state?: ValueTypes["OrderPaymentState"] | undefined | null,
	approvedAt?: ValueTypes["DateTime"] | undefined | null,
	order?: ValueTypes["OrderPaymentUpdateOrderEntityRelationInput"] | undefined | null,
	invoice?: ValueTypes["OrderPaymentUpdateInvoiceEntityRelationInput"] | undefined | null,
	walletType?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	publicReceiptUrl?: string | undefined | null,
	priceCents?: number | undefined | null,
	vatRate?: ValueTypes["OrderPaymentUpdateVatRateEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["OrderPaymentUpdateMetaEntityRelationInput"] | undefined | null,
	otherCurrencyPriceCents?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderPaymentUpdateOrderEntityRelationInput"]: {
	create?: ValueTypes["OrderWithoutPaymentsCreateInput"] | undefined | null,
	update?: ValueTypes["OrderWithoutPaymentsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["OrderPaymentUpsertOrderRelationInput"] | undefined | null,
	connect?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["OrderWithoutPaymentsUpdateInput"]: {
	state?: ValueTypes["OrderState"] | undefined | null,
	fulfilledAt?: ValueTypes["DateTime"] | undefined | null,
	canceledAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	customer?: ValueTypes["OrderUpdateCustomerEntityRelationInput"] | undefined | null,
	channel?: ValueTypes["OrderUpdateChannelEntityRelationInput"] | undefined | null,
	discounts?: Array<ValueTypes["OrderUpdateDiscountsEntityRelationInput"]> | undefined | null,
	delivery?: ValueTypes["OrderUpdateDeliveryEntityRelationInput"] | undefined | null,
	items?: Array<ValueTypes["OrderUpdateItemsEntityRelationInput"]> | undefined | null,
	internalNote?: string | undefined | null,
	cart?: ValueTypes["OrderUpdateCartEntityRelationInput"] | undefined | null,
	events?: Array<ValueTypes["OrderUpdateEventsEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingAddress?: ValueTypes["OrderUpdateBillingAddressEntityRelationInput"] | undefined | null,
	priceLines?: Array<ValueTypes["OrderUpdatePriceLinesEntityRelationInput"]> | undefined | null,
	seq?: number | undefined | null,
	billingSubject?: ValueTypes["OrderUpdateBillingSubjectEntityRelationInput"] | undefined | null,
	summary?: ValueTypes["OrderUpdateSummaryEntityRelationInput"] | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	gratuity?: ValueTypes["OrderUpdateGratuityEntityRelationInput"] | undefined | null,
	venue?: ValueTypes["OrderUpdateVenueEntityRelationInput"] | undefined | null,
	fulfillmentNote?: string | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["OrderUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	doubleshotTotalWeightGrams?: number | undefined | null,
	doubleShotLegacyNumber?: string | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	doubleshotAdminUrl?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderUpdateBillingAddressEntityRelationInput"]: {
	create?: ValueTypes["AddressWithoutBillingAddressOfOrdersCreateInput"] | undefined | null,
	update?: ValueTypes["AddressWithoutBillingAddressOfOrdersUpdateInput"] | undefined | null,
	upsert?: ValueTypes["OrderUpsertBillingAddressRelationInput"] | undefined | null,
	connect?: ValueTypes["AddressUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["AddressWithoutBillingAddressOfOrdersUpdateInput"]: {
	name?: string | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	addressLine2?: string | undefined | null,
	email?: string | undefined | null,
	phone?: string | undefined | null,
	companyName?: string | undefined | null,
	companyIdentifier?: string | undefined | null,
	vatIdentifier?: string | undefined | null,
	externalIdentifier?: string | undefined | null,
	hidden?: boolean | undefined | null,
	customer?: ValueTypes["AddressUpdateCustomerEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	country?: ValueTypes["AddressUpdateCountryEntityRelationInput"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	googlePlaceId?: string | undefined | null,
	raw?: string | undefined | null,
	formatted?: string | undefined | null,
	geocodeGeneratedAt?: ValueTypes["DateTime"] | undefined | null,
	geocodeResponse?: string | undefined | null,
	deliveryZone?: ValueTypes["AddressUpdateDeliveryZoneEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["AddressUpdateMetaEntityRelationInput"] | undefined | null,
	gps?: ValueTypes["AddressUpdateGpsEntityRelationInput"] | undefined | null,
	geocodeValid?: boolean | undefined | null,
	fullName?: string | undefined | null,
	fakturoidSubjectId?: string | undefined | null,
	invoices?: Array<ValueTypes["AddressUpdateInvoicesEntityRelationInput"]> | undefined | null,
	addressLine1?: string | undefined | null,
	city?: string | undefined | null,
	postalCode?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	deliveryAddressOfOrderDeliveries?: Array<ValueTypes["AddressUpdateDeliveryAddressOfOrderDeliveriesEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddressOfCustomer?: ValueTypes["AddressUpdateDefaultDeliveryAddressOfCustomerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AddressUpdateDeliveryAddressOfOrderDeliveriesEntityRelationInput"]: {
	create?: ValueTypes["OrderDeliveryWithoutAddressCreateInput"] | undefined | null,
	update?: ValueTypes["AddressUpdateDeliveryAddressOfOrderDeliveriesRelationInput"] | undefined | null,
	upsert?: ValueTypes["AddressUpsertDeliveryAddressOfOrderDeliveriesRelationInput"] | undefined | null,
	connect?: ValueTypes["OrderDeliveryUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["OrderDeliveryUniqueWhere"] | undefined | null,
	delete?: ValueTypes["OrderDeliveryUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["AddressUpdateDeliveryAddressOfOrderDeliveriesRelationInput"]: {
	by?: ValueTypes["OrderDeliveryUniqueWhere"] | undefined | null,
	data?: ValueTypes["OrderDeliveryWithoutAddressUpdateInput"] | undefined | null
};
	["OrderDeliveryWithoutAddressUpdateInput"]: {
	priceCents?: number | undefined | null,
	deliveredAt?: ValueTypes["DateTime"] | undefined | null,
	method?: ValueTypes["OrderDeliveryUpdateMethodEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["OrderDeliveryUpdateVatRateEntityRelationInput"] | undefined | null,
	order?: ValueTypes["OrderDeliveryUpdateOrderEntityRelationInput"] | undefined | null,
	expectedAt?: ValueTypes["DateTime"] | undefined | null,
	state?: ValueTypes["OrderDeliveryState"] | undefined | null,
	loadingDurationHours?: number | undefined | null,
	dispatchAt?: ValueTypes["DateTime"] | undefined | null,
	duration?: string | undefined | null,
	window?: string | undefined | null,
	expectedEndAt?: ValueTypes["DateTime"] | undefined | null,
	processingAt?: ValueTypes["DateTime"] | undefined | null,
	deliveringAt?: ValueTypes["DateTime"] | undefined | null,
	failedAt?: ValueTypes["DateTime"] | undefined | null,
	internalNote?: string | undefined | null,
	deliveryWaypoint?: ValueTypes["OrderDeliveryUpdateDeliveryWaypointEntityRelationInput"] | undefined | null,
	events?: Array<ValueTypes["OrderDeliveryUpdateEventsEntityRelationInput"]> | undefined | null,
	prepareAt?: ValueTypes["DateTime"] | undefined | null,
	liftagoRide?: ValueTypes["OrderDeliveryUpdateLiftagoRideEntityRelationInput"] | undefined | null,
	pickedAt?: ValueTypes["DateTime"] | undefined | null,
	trackingCode?: string | undefined | null,
	woltDriveDelivery?: ValueTypes["OrderDeliveryUpdateWoltDriveDeliveryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderDeliveryUpdateOrderEntityRelationInput"]: {
	create?: ValueTypes["OrderWithoutDeliveryCreateInput"] | undefined | null,
	update?: ValueTypes["OrderWithoutDeliveryUpdateInput"] | undefined | null,
	upsert?: ValueTypes["OrderDeliveryUpsertOrderRelationInput"] | undefined | null,
	connect?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["OrderWithoutDeliveryUpdateInput"]: {
	state?: ValueTypes["OrderState"] | undefined | null,
	fulfilledAt?: ValueTypes["DateTime"] | undefined | null,
	canceledAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	customer?: ValueTypes["OrderUpdateCustomerEntityRelationInput"] | undefined | null,
	channel?: ValueTypes["OrderUpdateChannelEntityRelationInput"] | undefined | null,
	discounts?: Array<ValueTypes["OrderUpdateDiscountsEntityRelationInput"]> | undefined | null,
	items?: Array<ValueTypes["OrderUpdateItemsEntityRelationInput"]> | undefined | null,
	internalNote?: string | undefined | null,
	cart?: ValueTypes["OrderUpdateCartEntityRelationInput"] | undefined | null,
	events?: Array<ValueTypes["OrderUpdateEventsEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingAddress?: ValueTypes["OrderUpdateBillingAddressEntityRelationInput"] | undefined | null,
	priceLines?: Array<ValueTypes["OrderUpdatePriceLinesEntityRelationInput"]> | undefined | null,
	payments?: Array<ValueTypes["OrderUpdatePaymentsEntityRelationInput"]> | undefined | null,
	seq?: number | undefined | null,
	billingSubject?: ValueTypes["OrderUpdateBillingSubjectEntityRelationInput"] | undefined | null,
	summary?: ValueTypes["OrderUpdateSummaryEntityRelationInput"] | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	gratuity?: ValueTypes["OrderUpdateGratuityEntityRelationInput"] | undefined | null,
	venue?: ValueTypes["OrderUpdateVenueEntityRelationInput"] | undefined | null,
	fulfillmentNote?: string | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["OrderUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	doubleshotTotalWeightGrams?: number | undefined | null,
	doubleShotLegacyNumber?: string | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	doubleshotAdminUrl?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderUpdatePriceLinesEntityRelationInput"]: {
	connect?: ValueTypes["OrderPriceLineUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["OrderPriceLineUniqueWhere"] | undefined | null,
	delete?: ValueTypes["OrderPriceLineUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["OrderUpdatePaymentsEntityRelationInput"]: {
	create?: ValueTypes["OrderPaymentWithoutOrderCreateInput"] | undefined | null,
	update?: ValueTypes["OrderUpdatePaymentsRelationInput"] | undefined | null,
	upsert?: ValueTypes["OrderUpsertPaymentsRelationInput"] | undefined | null,
	connect?: ValueTypes["OrderPaymentUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["OrderPaymentUniqueWhere"] | undefined | null,
	delete?: ValueTypes["OrderPaymentUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["OrderUpdatePaymentsRelationInput"]: {
	by?: ValueTypes["OrderPaymentUniqueWhere"] | undefined | null,
	data?: ValueTypes["OrderPaymentWithoutOrderUpdateInput"] | undefined | null
};
	["OrderPaymentWithoutOrderUpdateInput"]: {
	data?: ValueTypes["Json"] | undefined | null,
	paymentCents?: number | undefined | null,
	method?: ValueTypes["OrderPaymentUpdateMethodEntityRelationInput"] | undefined | null,
	failedAt?: ValueTypes["DateTime"] | undefined | null,
	state?: ValueTypes["OrderPaymentState"] | undefined | null,
	approvedAt?: ValueTypes["DateTime"] | undefined | null,
	events?: Array<ValueTypes["OrderPaymentUpdateEventsEntityRelationInput"]> | undefined | null,
	invoice?: ValueTypes["OrderPaymentUpdateInvoiceEntityRelationInput"] | undefined | null,
	walletType?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	publicReceiptUrl?: string | undefined | null,
	priceCents?: number | undefined | null,
	vatRate?: ValueTypes["OrderPaymentUpdateVatRateEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["OrderPaymentUpdateMetaEntityRelationInput"] | undefined | null,
	otherCurrencyPriceCents?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderPaymentUpdateInvoiceEntityRelationInput"]: {
	create?: ValueTypes["InvoiceWithoutOrderPaymentsCreateInput"] | undefined | null,
	update?: ValueTypes["InvoiceWithoutOrderPaymentsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["OrderPaymentUpsertInvoiceRelationInput"] | undefined | null,
	connect?: ValueTypes["InvoiceUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["InvoiceWithoutOrderPaymentsUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	publicKey?: string | undefined | null,
	fakturoidId?: string | undefined | null,
	fakturoidData?: string | undefined | null,
	legacyUrl?: string | undefined | null,
	customer?: ValueTypes["InvoiceUpdateCustomerEntityRelationInput"] | undefined | null,
	address?: ValueTypes["InvoiceUpdateAddressEntityRelationInput"] | undefined | null,
	publicUrl?: string | undefined | null,
	billingSubject?: ValueTypes["InvoiceUpdateBillingSubjectEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InvoiceUpdateBillingSubjectEntityRelationInput"]: {
	create?: ValueTypes["BillingSubjectWithoutInvoicesCreateInput"] | undefined | null,
	update?: ValueTypes["BillingSubjectWithoutInvoicesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["InvoiceUpsertBillingSubjectRelationInput"] | undefined | null,
	connect?: ValueTypes["BillingSubjectUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["BillingSubjectWithoutInvoicesUpdateInput"]: {
	name?: string | undefined | null,
	fullName?: string | undefined | null,
	addressLine1?: string | undefined | null,
	addressLine2?: string | undefined | null,
	city?: string | undefined | null,
	postalCode?: string | undefined | null,
	email?: string | undefined | null,
	phone?: string | undefined | null,
	companyName?: string | undefined | null,
	companyIdentifier?: string | undefined | null,
	vatIdentifier?: string | undefined | null,
	externalIdentifier?: string | undefined | null,
	hidden?: boolean | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	internalNote?: string | undefined | null,
	fakturoidSubjectId?: string | undefined | null,
	country?: ValueTypes["BillingSubjectUpdateCountryEntityRelationInput"] | undefined | null,
	customer?: ValueTypes["BillingSubjectUpdateCustomerEntityRelationInput"] | undefined | null,
	defaultBillingSubjectOfCustomer?: ValueTypes["BillingSubjectUpdateDefaultBillingSubjectOfCustomerEntityRelationInput"] | undefined | null,
	orders?: Array<ValueTypes["BillingSubjectUpdateOrdersEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BillingSubjectUpdateCustomerEntityRelationInput"]: {
	create?: ValueTypes["CustomerWithoutBillingSubjectsCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerWithoutBillingSubjectsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["BillingSubjectUpsertCustomerRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CustomerWithoutBillingSubjectsUpdateInput"]: {
	addresses?: Array<ValueTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerUpdateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerUpdateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerUpdateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerUpdateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerUpdateOfferedProductsEntityRelationInput"]: {
	connect?: ValueTypes["ProductCustomerPriceUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductCustomerPriceUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductCustomerPriceUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"]: {
	create?: ValueTypes["AddressWithoutDefaultDeliveryAddressOfCustomerCreateInput"] | undefined | null,
	update?: ValueTypes["AddressWithoutDefaultDeliveryAddressOfCustomerUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CustomerUpsertDefaultDeliveryAddressRelationInput"] | undefined | null,
	connect?: ValueTypes["AddressUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["AddressWithoutDefaultDeliveryAddressOfCustomerUpdateInput"]: {
	name?: string | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	addressLine2?: string | undefined | null,
	email?: string | undefined | null,
	phone?: string | undefined | null,
	companyName?: string | undefined | null,
	companyIdentifier?: string | undefined | null,
	vatIdentifier?: string | undefined | null,
	externalIdentifier?: string | undefined | null,
	hidden?: boolean | undefined | null,
	customer?: ValueTypes["AddressUpdateCustomerEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	country?: ValueTypes["AddressUpdateCountryEntityRelationInput"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	googlePlaceId?: string | undefined | null,
	raw?: string | undefined | null,
	formatted?: string | undefined | null,
	geocodeGeneratedAt?: ValueTypes["DateTime"] | undefined | null,
	geocodeResponse?: string | undefined | null,
	deliveryZone?: ValueTypes["AddressUpdateDeliveryZoneEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["AddressUpdateMetaEntityRelationInput"] | undefined | null,
	gps?: ValueTypes["AddressUpdateGpsEntityRelationInput"] | undefined | null,
	geocodeValid?: boolean | undefined | null,
	fullName?: string | undefined | null,
	fakturoidSubjectId?: string | undefined | null,
	invoices?: Array<ValueTypes["AddressUpdateInvoicesEntityRelationInput"]> | undefined | null,
	addressLine1?: string | undefined | null,
	city?: string | undefined | null,
	postalCode?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingAddressOfOrders?: Array<ValueTypes["AddressUpdateBillingAddressOfOrdersEntityRelationInput"]> | undefined | null,
	deliveryAddressOfOrderDeliveries?: Array<ValueTypes["AddressUpdateDeliveryAddressOfOrderDeliveriesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerUpsertDefaultDeliveryAddressRelationInput"]: {
	update?: ValueTypes["AddressWithoutDefaultDeliveryAddressOfCustomerUpdateInput"] | undefined | null,
	create?: ValueTypes["AddressWithoutDefaultDeliveryAddressOfCustomerCreateInput"] | undefined | null
};
	["CustomerUpdateDefaultBillingSubjectEntityRelationInput"]: {
	create?: ValueTypes["BillingSubjectWithoutDefaultBillingSubjectOfCustomerCreateInput"] | undefined | null,
	update?: ValueTypes["BillingSubjectWithoutDefaultBillingSubjectOfCustomerUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CustomerUpsertDefaultBillingSubjectRelationInput"] | undefined | null,
	connect?: ValueTypes["BillingSubjectUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["BillingSubjectWithoutDefaultBillingSubjectOfCustomerUpdateInput"]: {
	name?: string | undefined | null,
	fullName?: string | undefined | null,
	addressLine1?: string | undefined | null,
	addressLine2?: string | undefined | null,
	city?: string | undefined | null,
	postalCode?: string | undefined | null,
	email?: string | undefined | null,
	phone?: string | undefined | null,
	companyName?: string | undefined | null,
	companyIdentifier?: string | undefined | null,
	vatIdentifier?: string | undefined | null,
	externalIdentifier?: string | undefined | null,
	hidden?: boolean | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	internalNote?: string | undefined | null,
	fakturoidSubjectId?: string | undefined | null,
	country?: ValueTypes["BillingSubjectUpdateCountryEntityRelationInput"] | undefined | null,
	customer?: ValueTypes["BillingSubjectUpdateCustomerEntityRelationInput"] | undefined | null,
	invoices?: Array<ValueTypes["BillingSubjectUpdateInvoicesEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["BillingSubjectUpdateOrdersEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BillingSubjectUpdateOrdersEntityRelationInput"]: {
	create?: ValueTypes["OrderWithoutBillingSubjectCreateInput"] | undefined | null,
	update?: ValueTypes["BillingSubjectUpdateOrdersRelationInput"] | undefined | null,
	upsert?: ValueTypes["BillingSubjectUpsertOrdersRelationInput"] | undefined | null,
	connect?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	delete?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["BillingSubjectUpdateOrdersRelationInput"]: {
	by?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	data?: ValueTypes["OrderWithoutBillingSubjectUpdateInput"] | undefined | null
};
	["OrderWithoutBillingSubjectUpdateInput"]: {
	state?: ValueTypes["OrderState"] | undefined | null,
	fulfilledAt?: ValueTypes["DateTime"] | undefined | null,
	canceledAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	customer?: ValueTypes["OrderUpdateCustomerEntityRelationInput"] | undefined | null,
	channel?: ValueTypes["OrderUpdateChannelEntityRelationInput"] | undefined | null,
	discounts?: Array<ValueTypes["OrderUpdateDiscountsEntityRelationInput"]> | undefined | null,
	delivery?: ValueTypes["OrderUpdateDeliveryEntityRelationInput"] | undefined | null,
	items?: Array<ValueTypes["OrderUpdateItemsEntityRelationInput"]> | undefined | null,
	internalNote?: string | undefined | null,
	cart?: ValueTypes["OrderUpdateCartEntityRelationInput"] | undefined | null,
	events?: Array<ValueTypes["OrderUpdateEventsEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingAddress?: ValueTypes["OrderUpdateBillingAddressEntityRelationInput"] | undefined | null,
	priceLines?: Array<ValueTypes["OrderUpdatePriceLinesEntityRelationInput"]> | undefined | null,
	payments?: Array<ValueTypes["OrderUpdatePaymentsEntityRelationInput"]> | undefined | null,
	seq?: number | undefined | null,
	summary?: ValueTypes["OrderUpdateSummaryEntityRelationInput"] | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	gratuity?: ValueTypes["OrderUpdateGratuityEntityRelationInput"] | undefined | null,
	venue?: ValueTypes["OrderUpdateVenueEntityRelationInput"] | undefined | null,
	fulfillmentNote?: string | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["OrderUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	doubleshotTotalWeightGrams?: number | undefined | null,
	doubleShotLegacyNumber?: string | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	doubleshotAdminUrl?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderUpdateSummaryEntityRelationInput"]: {
	connect?: ValueTypes["OrderSummaryUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["OrderUpdateGratuityEntityRelationInput"]: {
	create?: ValueTypes["GratuityWithoutOrderCreateInput"] | undefined | null,
	update?: ValueTypes["GratuityWithoutOrderUpdateInput"] | undefined | null,
	upsert?: ValueTypes["OrderUpsertGratuityRelationInput"] | undefined | null,
	connect?: ValueTypes["GratuityUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["GratuityWithoutOrderUpdateInput"]: {
	amountCents?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderUpsertGratuityRelationInput"]: {
	update?: ValueTypes["GratuityWithoutOrderUpdateInput"] | undefined | null,
	create?: ValueTypes["GratuityWithoutOrderCreateInput"] | undefined | null
};
	["OrderUpdateVenueEntityRelationInput"]: {
	create?: ValueTypes["VenueWithoutOrdersCreateInput"] | undefined | null,
	update?: ValueTypes["VenueWithoutOrdersUpdateInput"] | undefined | null,
	upsert?: ValueTypes["OrderUpsertVenueRelationInput"] | undefined | null,
	connect?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["VenueWithoutOrdersUpdateInput"]: {
	name?: string | undefined | null,
	deadlineTemplate?: ValueTypes["VenueUpdateDeadlineTemplateEntityRelationInput"] | undefined | null,
	timetableDays?: Array<ValueTypes["VenueUpdateTimetableDaysEntityRelationInput"]> | undefined | null,
	timetableTemplates?: Array<ValueTypes["VenueUpdateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	staffMembers?: Array<ValueTypes["VenueUpdateStaffMembersEntityRelationInput"]> | undefined | null,
	employeeRoles?: Array<ValueTypes["VenueUpdateEmployeeRolesEntityRelationInput"]> | undefined | null,
	pointOfSaleApplicationDevices?: Array<ValueTypes["VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined | null,
	pointOfSaleTerminals?: Array<ValueTypes["VenueUpdatePointOfSaleTerminalsEntityRelationInput"]> | undefined | null,
	pointOfSalePrinters?: Array<ValueTypes["VenueUpdatePointOfSalePrintersEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["VenueUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	areas?: Array<ValueTypes["VenueUpdateAreasEntityRelationInput"]> | undefined | null,
	enabledUnassignReasons?: Array<ValueTypes["VenueUpdateEnabledUnassignReasonsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["VenueUpdateCategoriesEntityRelationInput"]> | undefined | null,
	channels?: Array<ValueTypes["VenueUpdateChannelsEntityRelationInput"]> | undefined | null,
	address?: string | undefined | null,
	pointOfSalePngBase64ReceiptLogo?: string | undefined | null,
	pointOfSaleInitialView?: ValueTypes["PointOfSaleInitialView"] | undefined | null,
	pointOfSalePreferPrintReceipt?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VenueUpdateFulfillmentNotesEntityRelationInput"]: {
	create?: ValueTypes["FulfillmentNoteWithoutVenuesCreateInput"] | undefined | null,
	update?: ValueTypes["VenueUpdateFulfillmentNotesRelationInput"] | undefined | null,
	upsert?: ValueTypes["VenueUpsertFulfillmentNotesRelationInput"] | undefined | null,
	connect?: ValueTypes["FulfillmentNoteUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["FulfillmentNoteUniqueWhere"] | undefined | null,
	delete?: ValueTypes["FulfillmentNoteUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["VenueUpdateFulfillmentNotesRelationInput"]: {
	by?: ValueTypes["FulfillmentNoteUniqueWhere"] | undefined | null,
	data?: ValueTypes["FulfillmentNoteWithoutVenuesUpdateInput"] | undefined | null
};
	["FulfillmentNoteWithoutVenuesUpdateInput"]: {
	note?: string | undefined | null,
	products?: Array<ValueTypes["FulfillmentNoteUpdateProductsEntityRelationInput"]> | undefined | null,
	tags?: Array<ValueTypes["FulfillmentNoteUpdateTagsEntityRelationInput"]> | undefined | null,
	cartItems?: Array<ValueTypes["FulfillmentNoteUpdateCartItemsEntityRelationInput"]> | undefined | null,
	orderItems?: Array<ValueTypes["FulfillmentNoteUpdateOrderItemsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["FulfillmentNoteUpdateOrdersEntityRelationInput"]> | undefined | null,
	highlight?: boolean | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	emoji?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FulfillmentNoteUpdateCartItemsEntityRelationInput"]: {
	create?: ValueTypes["CartItemWithoutFulfillmentNotesCreateInput"] | undefined | null,
	update?: ValueTypes["FulfillmentNoteUpdateCartItemsRelationInput"] | undefined | null,
	upsert?: ValueTypes["FulfillmentNoteUpsertCartItemsRelationInput"] | undefined | null,
	connect?: ValueTypes["CartItemUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["CartItemUniqueWhere"] | undefined | null,
	delete?: ValueTypes["CartItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["FulfillmentNoteUpdateCartItemsRelationInput"]: {
	by?: ValueTypes["CartItemUniqueWhere"] | undefined | null,
	data?: ValueTypes["CartItemWithoutFulfillmentNotesUpdateInput"] | undefined | null
};
	["CartItemWithoutFulfillmentNotesUpdateInput"]: {
	quantity?: number | undefined | null,
	cart?: ValueTypes["CartItemUpdateCartEntityRelationInput"] | undefined | null,
	product?: ValueTypes["CartItemUpdateProductEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	updatedAt?: ValueTypes["DateTime"] | undefined | null,
	fulfillmentNote?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FulfillmentNoteUpsertCartItemsRelationInput"]: {
	by?: ValueTypes["CartItemUniqueWhere"] | undefined | null,
	update?: ValueTypes["CartItemWithoutFulfillmentNotesUpdateInput"] | undefined | null,
	create?: ValueTypes["CartItemWithoutFulfillmentNotesCreateInput"] | undefined | null
};
	["FulfillmentNoteUpdateOrderItemsEntityRelationInput"]: {
	create?: ValueTypes["OrderItemWithoutFulfillmentNotesCreateInput"] | undefined | null,
	update?: ValueTypes["FulfillmentNoteUpdateOrderItemsRelationInput"] | undefined | null,
	upsert?: ValueTypes["FulfillmentNoteUpsertOrderItemsRelationInput"] | undefined | null,
	connect?: ValueTypes["OrderItemUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["OrderItemUniqueWhere"] | undefined | null,
	delete?: ValueTypes["OrderItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["FulfillmentNoteUpdateOrderItemsRelationInput"]: {
	by?: ValueTypes["OrderItemUniqueWhere"] | undefined | null,
	data?: ValueTypes["OrderItemWithoutFulfillmentNotesUpdateInput"] | undefined | null
};
	["OrderItemWithoutFulfillmentNotesUpdateInput"]: {
	unitPriceCents?: number | undefined | null,
	quantity?: number | undefined | null,
	vatRate?: ValueTypes["OrderItemUpdateVatRateEntityRelationInput"] | undefined | null,
	order?: ValueTypes["OrderItemUpdateOrderEntityRelationInput"] | undefined | null,
	virtualProductEffects?: Array<ValueTypes["OrderItemUpdateVirtualProductEffectsEntityRelationInput"]> | undefined | null,
	pickedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	product?: ValueTypes["OrderItemUpdateProductEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderItemUpdateProductEntityRelationInput"]: {
	create?: ValueTypes["ProductWithoutOrderItemsCreateInput"] | undefined | null,
	update?: ValueTypes["ProductWithoutOrderItemsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["OrderItemUpsertProductRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductWithoutOrderItemsUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	priceCents?: number | undefined | null,
	notDiscountable?: boolean | undefined | null,
	packing?: ValueTypes["ProductUpdatePackingEntityRelationInput"] | undefined | null,
	recipe?: ValueTypes["ProductUpdateRecipeEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["ProductUpdateTagsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["ProductUpdateCategoriesEntityRelationInput"]> | undefined | null,
	vatRate?: ValueTypes["ProductUpdateVatRateEntityRelationInput"] | undefined | null,
	stocks?: Array<ValueTypes["ProductUpdateStocksEntityRelationInput"]> | undefined | null,
	groupPrices?: Array<ValueTypes["ProductUpdateGroupPricesEntityRelationInput"]> | undefined | null,
	image?: ValueTypes["ProductUpdateImageEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	cartItems?: Array<ValueTypes["ProductUpdateCartItemsEntityRelationInput"]> | undefined | null,
	availability?: ValueTypes["ProductAvailability"] | undefined | null,
	order?: number | undefined | null,
	manager?: ValueTypes["ProductUpdateManagerEntityRelationInput"] | undefined | null,
	maximumQuantityPerOrder?: number | undefined | null,
	inheritedCategories?: Array<ValueTypes["ProductUpdateInheritedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["ProductUpdateDeliveryZonesEntityRelationInput"]> | undefined | null,
	locales?: Array<ValueTypes["ProductUpdateLocalesEntityRelationInput"]> | undefined | null,
	archivedAt?: ValueTypes["DateTime"] | undefined | null,
	customerPrices?: Array<ValueTypes["ProductUpdateCustomerPricesEntityRelationInput"]> | undefined | null,
	virtualProduct?: ValueTypes["ProductUpdateVirtualProductEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["ProductUpdateMetaEntityRelationInput"] | undefined | null,
	page?: ValueTypes["ProductUpdatePageEntityRelationInput"] | undefined | null,
	salesDays?: Array<ValueTypes["ProductUpdateSalesDaysEntityRelationInput"]> | undefined | null,
	salesWeeks?: Array<ValueTypes["ProductUpdateSalesWeeksEntityRelationInput"]> | undefined | null,
	salesMonths?: Array<ValueTypes["ProductUpdateSalesMonthsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["ProductUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	hasSubscription?: boolean | undefined | null,
	pointOfSaleTileColor?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderItemUpsertProductRelationInput"]: {
	update?: ValueTypes["ProductWithoutOrderItemsUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductWithoutOrderItemsCreateInput"] | undefined | null
};
	["FulfillmentNoteUpsertOrderItemsRelationInput"]: {
	by?: ValueTypes["OrderItemUniqueWhere"] | undefined | null,
	update?: ValueTypes["OrderItemWithoutFulfillmentNotesUpdateInput"] | undefined | null,
	create?: ValueTypes["OrderItemWithoutFulfillmentNotesCreateInput"] | undefined | null
};
	["FulfillmentNoteUpdateOrdersEntityRelationInput"]: {
	create?: ValueTypes["OrderWithoutFulfillmentNotesCreateInput"] | undefined | null,
	update?: ValueTypes["FulfillmentNoteUpdateOrdersRelationInput"] | undefined | null,
	upsert?: ValueTypes["FulfillmentNoteUpsertOrdersRelationInput"] | undefined | null,
	connect?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	delete?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["FulfillmentNoteUpdateOrdersRelationInput"]: {
	by?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	data?: ValueTypes["OrderWithoutFulfillmentNotesUpdateInput"] | undefined | null
};
	["OrderWithoutFulfillmentNotesUpdateInput"]: {
	state?: ValueTypes["OrderState"] | undefined | null,
	fulfilledAt?: ValueTypes["DateTime"] | undefined | null,
	canceledAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	customer?: ValueTypes["OrderUpdateCustomerEntityRelationInput"] | undefined | null,
	channel?: ValueTypes["OrderUpdateChannelEntityRelationInput"] | undefined | null,
	discounts?: Array<ValueTypes["OrderUpdateDiscountsEntityRelationInput"]> | undefined | null,
	delivery?: ValueTypes["OrderUpdateDeliveryEntityRelationInput"] | undefined | null,
	items?: Array<ValueTypes["OrderUpdateItemsEntityRelationInput"]> | undefined | null,
	internalNote?: string | undefined | null,
	cart?: ValueTypes["OrderUpdateCartEntityRelationInput"] | undefined | null,
	events?: Array<ValueTypes["OrderUpdateEventsEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingAddress?: ValueTypes["OrderUpdateBillingAddressEntityRelationInput"] | undefined | null,
	priceLines?: Array<ValueTypes["OrderUpdatePriceLinesEntityRelationInput"]> | undefined | null,
	payments?: Array<ValueTypes["OrderUpdatePaymentsEntityRelationInput"]> | undefined | null,
	seq?: number | undefined | null,
	billingSubject?: ValueTypes["OrderUpdateBillingSubjectEntityRelationInput"] | undefined | null,
	summary?: ValueTypes["OrderUpdateSummaryEntityRelationInput"] | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	gratuity?: ValueTypes["OrderUpdateGratuityEntityRelationInput"] | undefined | null,
	venue?: ValueTypes["OrderUpdateVenueEntityRelationInput"] | undefined | null,
	fulfillmentNote?: string | undefined | null,
	doubleshotTotalWeightGrams?: number | undefined | null,
	doubleShotLegacyNumber?: string | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	doubleshotAdminUrl?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderUpdateBillingSubjectEntityRelationInput"]: {
	create?: ValueTypes["BillingSubjectWithoutOrdersCreateInput"] | undefined | null,
	update?: ValueTypes["BillingSubjectWithoutOrdersUpdateInput"] | undefined | null,
	upsert?: ValueTypes["OrderUpsertBillingSubjectRelationInput"] | undefined | null,
	connect?: ValueTypes["BillingSubjectUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["BillingSubjectWithoutOrdersUpdateInput"]: {
	name?: string | undefined | null,
	fullName?: string | undefined | null,
	addressLine1?: string | undefined | null,
	addressLine2?: string | undefined | null,
	city?: string | undefined | null,
	postalCode?: string | undefined | null,
	email?: string | undefined | null,
	phone?: string | undefined | null,
	companyName?: string | undefined | null,
	companyIdentifier?: string | undefined | null,
	vatIdentifier?: string | undefined | null,
	externalIdentifier?: string | undefined | null,
	hidden?: boolean | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	internalNote?: string | undefined | null,
	fakturoidSubjectId?: string | undefined | null,
	country?: ValueTypes["BillingSubjectUpdateCountryEntityRelationInput"] | undefined | null,
	customer?: ValueTypes["BillingSubjectUpdateCustomerEntityRelationInput"] | undefined | null,
	invoices?: Array<ValueTypes["BillingSubjectUpdateInvoicesEntityRelationInput"]> | undefined | null,
	defaultBillingSubjectOfCustomer?: ValueTypes["BillingSubjectUpdateDefaultBillingSubjectOfCustomerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BillingSubjectUpdateDefaultBillingSubjectOfCustomerEntityRelationInput"]: {
	create?: ValueTypes["CustomerWithoutDefaultBillingSubjectCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerWithoutDefaultBillingSubjectUpdateInput"] | undefined | null,
	upsert?: ValueTypes["BillingSubjectUpsertDefaultBillingSubjectOfCustomerRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CustomerWithoutDefaultBillingSubjectUpdateInput"]: {
	addresses?: Array<ValueTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerUpdateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerUpdateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerUpdateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerUpdateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerUpdateAnonymousSessionEntityRelationInput"]: {
	create?: ValueTypes["AnonymousSessionWithoutCustomerCreateInput"] | undefined | null,
	update?: ValueTypes["AnonymousSessionWithoutCustomerUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CustomerUpsertAnonymousSessionRelationInput"] | undefined | null,
	connect?: ValueTypes["AnonymousSessionUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["AnonymousSessionWithoutCustomerUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	lastActiveAt?: ValueTypes["DateTime"] | undefined | null,
	anonymousSessionKey?: string | undefined | null,
	email?: string | undefined | null,
	name?: string | undefined | null,
	internalNote?: string | undefined | null,
	devices?: Array<ValueTypes["AnonymousSessionUpdateDevicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AnonymousSessionUpdateDevicesEntityRelationInput"]: {
	create?: ValueTypes["UserDeviceWithoutAnonymousSessionCreateInput"] | undefined | null,
	update?: ValueTypes["AnonymousSessionUpdateDevicesRelationInput"] | undefined | null,
	upsert?: ValueTypes["AnonymousSessionUpsertDevicesRelationInput"] | undefined | null,
	connect?: ValueTypes["UserDeviceUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["UserDeviceUniqueWhere"] | undefined | null,
	delete?: ValueTypes["UserDeviceUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["AnonymousSessionUpdateDevicesRelationInput"]: {
	by?: ValueTypes["UserDeviceUniqueWhere"] | undefined | null,
	data?: ValueTypes["UserDeviceWithoutAnonymousSessionUpdateInput"] | undefined | null
};
	["UserDeviceWithoutAnonymousSessionUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	lastActiveAt?: ValueTypes["DateTime"] | undefined | null,
	platform?: string | undefined | null,
	deviceId?: string | undefined | null,
	notificationsEnabled?: boolean | undefined | null,
	user?: ValueTypes["UserDeviceUpdateUserEntityRelationInput"] | undefined | null,
	appVersion?: string | undefined | null,
	osVersion?: string | undefined | null,
	apiVersion?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserDeviceUpdateUserEntityRelationInput"]: {
	create?: ValueTypes["UserWithoutDevicesCreateInput"] | undefined | null,
	update?: ValueTypes["UserWithoutDevicesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["UserDeviceUpsertUserRelationInput"] | undefined | null,
	connect?: ValueTypes["UserUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["UserWithoutDevicesUpdateInput"]: {
	name?: string | undefined | null,
	internalNote?: string | undefined | null,
	staff?: ValueTypes["UserUpdateStaffEntityRelationInput"] | undefined | null,
	customer?: ValueTypes["UserUpdateCustomerEntityRelationInput"] | undefined | null,
	tenantPersonId?: ValueTypes["UUID"] | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	verifiedAt?: ValueTypes["DateTime"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	deletionRequestedAt?: ValueTypes["DateTime"] | undefined | null,
	deletionExpectedAt?: ValueTypes["DateTime"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	meta?: ValueTypes["UserUpdateMetaEntityRelationInput"] | undefined | null,
	identificationAttempts?: Array<ValueTypes["UserUpdateIdentificationAttemptsEntityRelationInput"]> | undefined | null,
	roles?: ValueTypes["UserUpdateRolesEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserUpdateRolesEntityRelationInput"]: {
	connect?: ValueTypes["UserRolesUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["UserDeviceUpsertUserRelationInput"]: {
	update?: ValueTypes["UserWithoutDevicesUpdateInput"] | undefined | null,
	create?: ValueTypes["UserWithoutDevicesCreateInput"] | undefined | null
};
	["AnonymousSessionUpsertDevicesRelationInput"]: {
	by?: ValueTypes["UserDeviceUniqueWhere"] | undefined | null,
	update?: ValueTypes["UserDeviceWithoutAnonymousSessionUpdateInput"] | undefined | null,
	create?: ValueTypes["UserDeviceWithoutAnonymousSessionCreateInput"] | undefined | null
};
	["CustomerUpsertAnonymousSessionRelationInput"]: {
	update?: ValueTypes["AnonymousSessionWithoutCustomerUpdateInput"] | undefined | null,
	create?: ValueTypes["AnonymousSessionWithoutCustomerCreateInput"] | undefined | null
};
	["CustomerUpdateBoughtVouchersEntityRelationInput"]: {
	create?: ValueTypes["VoucherWithoutBuyerCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerUpdateBoughtVouchersRelationInput"] | undefined | null,
	upsert?: ValueTypes["CustomerUpsertBoughtVouchersRelationInput"] | undefined | null,
	connect?: ValueTypes["VoucherUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["VoucherUniqueWhere"] | undefined | null,
	delete?: ValueTypes["VoucherUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerUpdateBoughtVouchersRelationInput"]: {
	by?: ValueTypes["VoucherUniqueWhere"] | undefined | null,
	data?: ValueTypes["VoucherWithoutBuyerUpdateInput"] | undefined | null
};
	["VoucherWithoutBuyerUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	activatedAt?: ValueTypes["DateTime"] | undefined | null,
	expiresAt?: ValueTypes["DateTime"] | undefined | null,
	internalNote?: string | undefined | null,
	note?: string | undefined | null,
	code?: string | undefined | null,
	type?: ValueTypes["VoucherType"] | undefined | null,
	creditCents?: number | undefined | null,
	owner?: ValueTypes["VoucherUpdateOwnerEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["VoucherUpdateVatRateEntityRelationInput"] | undefined | null,
	virtualProductEffect?: ValueTypes["VoucherUpdateVirtualProductEffectEntityRelationInput"] | undefined | null,
	redemption?: ValueTypes["VoucherUpdateRedemptionEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VoucherUpdateOwnerEntityRelationInput"]: {
	create?: ValueTypes["CustomerWithoutOwnsVouchersCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerWithoutOwnsVouchersUpdateInput"] | undefined | null,
	upsert?: ValueTypes["VoucherUpsertOwnerRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CustomerWithoutOwnsVouchersUpdateInput"]: {
	addresses?: Array<ValueTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerUpdateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerUpdateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerUpdateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerUpdateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerUpdateRedeemedVouchersEntityRelationInput"]: {
	create?: ValueTypes["VoucherRedemptionWithoutCustomerCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerUpdateRedeemedVouchersRelationInput"] | undefined | null,
	upsert?: ValueTypes["CustomerUpsertRedeemedVouchersRelationInput"] | undefined | null,
	connect?: ValueTypes["VoucherRedemptionUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["VoucherRedemptionUniqueWhere"] | undefined | null,
	delete?: ValueTypes["VoucherRedemptionUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerUpdateRedeemedVouchersRelationInput"]: {
	by?: ValueTypes["VoucherRedemptionUniqueWhere"] | undefined | null,
	data?: ValueTypes["VoucherRedemptionWithoutCustomerUpdateInput"] | undefined | null
};
	["VoucherRedemptionWithoutCustomerUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	manualRedemptionNote?: string | undefined | null,
	customerCredit?: ValueTypes["VoucherRedemptionUpdateCustomerCreditEntityRelationInput"] | undefined | null,
	orderDiscount?: ValueTypes["VoucherRedemptionUpdateOrderDiscountEntityRelationInput"] | undefined | null,
	voucher?: ValueTypes["VoucherRedemptionUpdateVoucherEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VoucherRedemptionUpdateCustomerCreditEntityRelationInput"]: {
	create?: ValueTypes["CustomerCreditWithoutVoucherRedemptionCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerCreditWithoutVoucherRedemptionUpdateInput"] | undefined | null,
	upsert?: ValueTypes["VoucherRedemptionUpsertCustomerCreditRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerCreditUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CustomerCreditWithoutVoucherRedemptionUpdateInput"]: {
	initialCreditCents?: number | undefined | null,
	remainingCreditsCents?: number | undefined | null,
	expiresAt?: ValueTypes["DateTime"] | undefined | null,
	reason?: string | undefined | null,
	customer?: ValueTypes["CustomerCreditUpdateCustomerEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["CustomerCreditUpdateVatRateEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	transactions?: Array<ValueTypes["CustomerCreditUpdateTransactionsEntityRelationInput"]> | undefined | null,
	invoiceUrl?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreditUpdateTransactionsEntityRelationInput"]: {
	create?: ValueTypes["CustomerCreditTransactionWithoutCustomerCreditCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerCreditUpdateTransactionsRelationInput"] | undefined | null,
	upsert?: ValueTypes["CustomerCreditUpsertTransactionsRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerCreditTransactionUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["CustomerCreditTransactionUniqueWhere"] | undefined | null,
	delete?: ValueTypes["CustomerCreditTransactionUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerCreditUpdateTransactionsRelationInput"]: {
	by?: ValueTypes["CustomerCreditTransactionUniqueWhere"] | undefined | null,
	data?: ValueTypes["CustomerCreditTransactionWithoutCustomerCreditUpdateInput"] | undefined | null
};
	["CustomerCreditTransactionWithoutCustomerCreditUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	amountCents?: number | undefined | null,
	orderDiscount?: ValueTypes["CustomerCreditTransactionUpdateOrderDiscountEntityRelationInput"] | undefined | null,
	virtualProductEffect?: ValueTypes["CustomerCreditTransactionUpdateVirtualProductEffectEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreditTransactionUpdateVirtualProductEffectEntityRelationInput"]: {
	create?: ValueTypes["VirtualProductEffectWithoutResultCustomerCreditTransactionCreateInput"] | undefined | null,
	update?: ValueTypes["VirtualProductEffectWithoutResultCustomerCreditTransactionUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CustomerCreditTransactionUpsertVirtualProductEffectRelationInput"] | undefined | null,
	connect?: ValueTypes["VirtualProductEffectUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["VirtualProductEffectWithoutResultCustomerCreditTransactionUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	succeededAt?: ValueTypes["DateTime"] | undefined | null,
	orderItem?: ValueTypes["VirtualProductEffectUpdateOrderItemEntityRelationInput"] | undefined | null,
	failedAt?: ValueTypes["DateTime"] | undefined | null,
	revertedAt?: ValueTypes["DateTime"] | undefined | null,
	resultVouchers?: Array<ValueTypes["VirtualProductEffectUpdateResultVouchersEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VirtualProductEffectUpdateOrderItemEntityRelationInput"]: {
	create?: ValueTypes["OrderItemWithoutVirtualProductEffectsCreateInput"] | undefined | null,
	update?: ValueTypes["OrderItemWithoutVirtualProductEffectsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["VirtualProductEffectUpsertOrderItemRelationInput"] | undefined | null,
	connect?: ValueTypes["OrderItemUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["OrderItemWithoutVirtualProductEffectsUpdateInput"]: {
	unitPriceCents?: number | undefined | null,
	quantity?: number | undefined | null,
	vatRate?: ValueTypes["OrderItemUpdateVatRateEntityRelationInput"] | undefined | null,
	order?: ValueTypes["OrderItemUpdateOrderEntityRelationInput"] | undefined | null,
	pickedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["OrderItemUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	product?: ValueTypes["OrderItemUpdateProductEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderItemUpdateFulfillmentNotesEntityRelationInput"]: {
	create?: ValueTypes["FulfillmentNoteWithoutOrderItemsCreateInput"] | undefined | null,
	update?: ValueTypes["OrderItemUpdateFulfillmentNotesRelationInput"] | undefined | null,
	upsert?: ValueTypes["OrderItemUpsertFulfillmentNotesRelationInput"] | undefined | null,
	connect?: ValueTypes["FulfillmentNoteUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["FulfillmentNoteUniqueWhere"] | undefined | null,
	delete?: ValueTypes["FulfillmentNoteUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["OrderItemUpdateFulfillmentNotesRelationInput"]: {
	by?: ValueTypes["FulfillmentNoteUniqueWhere"] | undefined | null,
	data?: ValueTypes["FulfillmentNoteWithoutOrderItemsUpdateInput"] | undefined | null
};
	["FulfillmentNoteWithoutOrderItemsUpdateInput"]: {
	note?: string | undefined | null,
	products?: Array<ValueTypes["FulfillmentNoteUpdateProductsEntityRelationInput"]> | undefined | null,
	tags?: Array<ValueTypes["FulfillmentNoteUpdateTagsEntityRelationInput"]> | undefined | null,
	venues?: Array<ValueTypes["FulfillmentNoteUpdateVenuesEntityRelationInput"]> | undefined | null,
	cartItems?: Array<ValueTypes["FulfillmentNoteUpdateCartItemsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["FulfillmentNoteUpdateOrdersEntityRelationInput"]> | undefined | null,
	highlight?: boolean | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	emoji?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderItemUpsertFulfillmentNotesRelationInput"]: {
	by?: ValueTypes["FulfillmentNoteUniqueWhere"] | undefined | null,
	update?: ValueTypes["FulfillmentNoteWithoutOrderItemsUpdateInput"] | undefined | null,
	create?: ValueTypes["FulfillmentNoteWithoutOrderItemsCreateInput"] | undefined | null
};
	["VirtualProductEffectUpsertOrderItemRelationInput"]: {
	update?: ValueTypes["OrderItemWithoutVirtualProductEffectsUpdateInput"] | undefined | null,
	create?: ValueTypes["OrderItemWithoutVirtualProductEffectsCreateInput"] | undefined | null
};
	["VirtualProductEffectUpdateResultVouchersEntityRelationInput"]: {
	create?: ValueTypes["VoucherWithoutVirtualProductEffectCreateInput"] | undefined | null,
	update?: ValueTypes["VirtualProductEffectUpdateResultVouchersRelationInput"] | undefined | null,
	upsert?: ValueTypes["VirtualProductEffectUpsertResultVouchersRelationInput"] | undefined | null,
	connect?: ValueTypes["VoucherUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["VoucherUniqueWhere"] | undefined | null,
	delete?: ValueTypes["VoucherUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["VirtualProductEffectUpdateResultVouchersRelationInput"]: {
	by?: ValueTypes["VoucherUniqueWhere"] | undefined | null,
	data?: ValueTypes["VoucherWithoutVirtualProductEffectUpdateInput"] | undefined | null
};
	["VoucherWithoutVirtualProductEffectUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	activatedAt?: ValueTypes["DateTime"] | undefined | null,
	expiresAt?: ValueTypes["DateTime"] | undefined | null,
	internalNote?: string | undefined | null,
	note?: string | undefined | null,
	code?: string | undefined | null,
	type?: ValueTypes["VoucherType"] | undefined | null,
	creditCents?: number | undefined | null,
	buyer?: ValueTypes["VoucherUpdateBuyerEntityRelationInput"] | undefined | null,
	owner?: ValueTypes["VoucherUpdateOwnerEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["VoucherUpdateVatRateEntityRelationInput"] | undefined | null,
	redemption?: ValueTypes["VoucherUpdateRedemptionEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VoucherUpdateBuyerEntityRelationInput"]: {
	create?: ValueTypes["CustomerWithoutBoughtVouchersCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerWithoutBoughtVouchersUpdateInput"] | undefined | null,
	upsert?: ValueTypes["VoucherUpsertBuyerRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CustomerWithoutBoughtVouchersUpdateInput"]: {
	addresses?: Array<ValueTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerUpdateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerUpdateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerUpdateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerUpdateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerUpdateOwnsVouchersEntityRelationInput"]: {
	create?: ValueTypes["VoucherWithoutOwnerCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerUpdateOwnsVouchersRelationInput"] | undefined | null,
	upsert?: ValueTypes["CustomerUpsertOwnsVouchersRelationInput"] | undefined | null,
	connect?: ValueTypes["VoucherUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["VoucherUniqueWhere"] | undefined | null,
	delete?: ValueTypes["VoucherUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerUpdateOwnsVouchersRelationInput"]: {
	by?: ValueTypes["VoucherUniqueWhere"] | undefined | null,
	data?: ValueTypes["VoucherWithoutOwnerUpdateInput"] | undefined | null
};
	["VoucherWithoutOwnerUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	activatedAt?: ValueTypes["DateTime"] | undefined | null,
	expiresAt?: ValueTypes["DateTime"] | undefined | null,
	internalNote?: string | undefined | null,
	note?: string | undefined | null,
	code?: string | undefined | null,
	type?: ValueTypes["VoucherType"] | undefined | null,
	creditCents?: number | undefined | null,
	buyer?: ValueTypes["VoucherUpdateBuyerEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["VoucherUpdateVatRateEntityRelationInput"] | undefined | null,
	virtualProductEffect?: ValueTypes["VoucherUpdateVirtualProductEffectEntityRelationInput"] | undefined | null,
	redemption?: ValueTypes["VoucherUpdateRedemptionEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VoucherUpdateVatRateEntityRelationInput"]: {
	create?: ValueTypes["VatRateCreateInput"] | undefined | null,
	update?: ValueTypes["VatRateUpdateInput"] | undefined | null,
	upsert?: ValueTypes["VoucherUpsertVatRateRelationInput"] | undefined | null,
	connect?: ValueTypes["VatRateUniqueWhere"] | undefined | null
};
	["VoucherUpsertVatRateRelationInput"]: {
	update?: ValueTypes["VatRateUpdateInput"] | undefined | null,
	create?: ValueTypes["VatRateCreateInput"] | undefined | null
};
	["VoucherUpdateVirtualProductEffectEntityRelationInput"]: {
	create?: ValueTypes["VirtualProductEffectWithoutResultVouchersCreateInput"] | undefined | null,
	update?: ValueTypes["VirtualProductEffectWithoutResultVouchersUpdateInput"] | undefined | null,
	upsert?: ValueTypes["VoucherUpsertVirtualProductEffectRelationInput"] | undefined | null,
	connect?: ValueTypes["VirtualProductEffectUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["VirtualProductEffectWithoutResultVouchersUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	succeededAt?: ValueTypes["DateTime"] | undefined | null,
	orderItem?: ValueTypes["VirtualProductEffectUpdateOrderItemEntityRelationInput"] | undefined | null,
	failedAt?: ValueTypes["DateTime"] | undefined | null,
	revertedAt?: ValueTypes["DateTime"] | undefined | null,
	resultCustomerCreditTransaction?: ValueTypes["VirtualProductEffectUpdateResultCustomerCreditTransactionEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VoucherUpsertVirtualProductEffectRelationInput"]: {
	update?: ValueTypes["VirtualProductEffectWithoutResultVouchersUpdateInput"] | undefined | null,
	create?: ValueTypes["VirtualProductEffectWithoutResultVouchersCreateInput"] | undefined | null
};
	["VoucherUpdateRedemptionEntityRelationInput"]: {
	create?: ValueTypes["VoucherRedemptionWithoutVoucherCreateInput"] | undefined | null,
	update?: ValueTypes["VoucherRedemptionWithoutVoucherUpdateInput"] | undefined | null,
	upsert?: ValueTypes["VoucherUpsertRedemptionRelationInput"] | undefined | null,
	connect?: ValueTypes["VoucherRedemptionUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["VoucherRedemptionWithoutVoucherUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	manualRedemptionNote?: string | undefined | null,
	customerCredit?: ValueTypes["VoucherRedemptionUpdateCustomerCreditEntityRelationInput"] | undefined | null,
	orderDiscount?: ValueTypes["VoucherRedemptionUpdateOrderDiscountEntityRelationInput"] | undefined | null,
	customer?: ValueTypes["VoucherRedemptionUpdateCustomerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VoucherRedemptionUpdateOrderDiscountEntityRelationInput"]: {
	create?: ValueTypes["OrderDiscountWithoutVoucherRedemptionCreateInput"] | undefined | null,
	update?: ValueTypes["OrderDiscountWithoutVoucherRedemptionUpdateInput"] | undefined | null,
	upsert?: ValueTypes["VoucherRedemptionUpsertOrderDiscountRelationInput"] | undefined | null,
	connect?: ValueTypes["OrderDiscountUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["OrderDiscountWithoutVoucherRedemptionUpdateInput"]: {
	discountCents?: number | undefined | null,
	vatRate?: ValueTypes["OrderDiscountUpdateVatRateEntityRelationInput"] | undefined | null,
	order?: ValueTypes["OrderDiscountUpdateOrderEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	type?: ValueTypes["OrderDiscountType"] | undefined | null,
	customerCreditTransactions?: Array<ValueTypes["OrderDiscountUpdateCustomerCreditTransactionsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VoucherRedemptionUpsertOrderDiscountRelationInput"]: {
	update?: ValueTypes["OrderDiscountWithoutVoucherRedemptionUpdateInput"] | undefined | null,
	create?: ValueTypes["OrderDiscountWithoutVoucherRedemptionCreateInput"] | undefined | null
};
	["VoucherRedemptionUpdateCustomerEntityRelationInput"]: {
	create?: ValueTypes["CustomerWithoutRedeemedVouchersCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerWithoutRedeemedVouchersUpdateInput"] | undefined | null,
	upsert?: ValueTypes["VoucherRedemptionUpsertCustomerRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CustomerWithoutRedeemedVouchersUpdateInput"]: {
	addresses?: Array<ValueTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerUpdateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerUpdateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerUpdateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerUpdateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerUpdateSpendingEntityRelationInput"]: {
	connect?: ValueTypes["CustomerSpendingUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CustomerUpdateCustomerTabsEntityRelationInput"]: {
	create?: ValueTypes["CustomerTabWithoutCustomerCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerUpdateCustomerTabsRelationInput"] | undefined | null,
	upsert?: ValueTypes["CustomerUpsertCustomerTabsRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerTabUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["CustomerTabUniqueWhere"] | undefined | null,
	delete?: ValueTypes["CustomerTabUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerUpdateCustomerTabsRelationInput"]: {
	by?: ValueTypes["CustomerTabUniqueWhere"] | undefined | null,
	data?: ValueTypes["CustomerTabWithoutCustomerUpdateInput"] | undefined | null
};
	["CustomerTabWithoutCustomerUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	color?: string | undefined | null,
	items?: Array<ValueTypes["CustomerTabUpdateItemsEntityRelationInput"]> | undefined | null,
	name?: string | undefined | null,
	meta?: ValueTypes["CustomerTabUpdateMetaEntityRelationInput"] | undefined | null,
	table?: ValueTypes["CustomerTabUpdateTableEntityRelationInput"] | undefined | null,
	seat?: ValueTypes["CustomerTabUpdateSeatEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerTabUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["CustomerTabItemWithoutTabCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerTabUpdateItemsRelationInput"] | undefined | null,
	upsert?: ValueTypes["CustomerTabUpsertItemsRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerTabItemUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["CustomerTabItemUniqueWhere"] | undefined | null,
	delete?: ValueTypes["CustomerTabItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerTabUpdateItemsRelationInput"]: {
	by?: ValueTypes["CustomerTabItemUniqueWhere"] | undefined | null,
	data?: ValueTypes["CustomerTabItemWithoutTabUpdateInput"] | undefined | null
};
	["CustomerTabItemWithoutTabUpdateInput"]: {
	addedAt?: ValueTypes["DateTime"] | undefined | null,
	product?: ValueTypes["CustomerTabItemUpdateProductEntityRelationInput"] | undefined | null,
	paidAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerTabItemUpdateProductEntityRelationInput"]: {
	create?: ValueTypes["ProductCreateInput"] | undefined | null,
	update?: ValueTypes["ProductUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CustomerTabItemUpsertProductRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CustomerTabItemUpsertProductRelationInput"]: {
	update?: ValueTypes["ProductUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductCreateInput"] | undefined | null
};
	["CustomerTabUpsertItemsRelationInput"]: {
	by?: ValueTypes["CustomerTabItemUniqueWhere"] | undefined | null,
	update?: ValueTypes["CustomerTabItemWithoutTabUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerTabItemWithoutTabCreateInput"] | undefined | null
};
	["CustomerTabUpdateMetaEntityRelationInput"]: {
	connect?: ValueTypes["CustomerTabMetadataUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CustomerTabUpdateTableEntityRelationInput"]: {
	create?: ValueTypes["TableWithoutCustomerTabsCreateInput"] | undefined | null,
	update?: ValueTypes["TableWithoutCustomerTabsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CustomerTabUpsertTableRelationInput"] | undefined | null,
	connect?: ValueTypes["TableUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["TableWithoutCustomerTabsUpdateInput"]: {
	shape?: ValueTypes["TableShape"] | undefined | null,
	width?: number | undefined | null,
	height?: number | undefined | null,
	positionX?: number | undefined | null,
	positionY?: number | undefined | null,
	name?: string | undefined | null,
	color?: string | undefined | null,
	area?: ValueTypes["TableUpdateAreaEntityRelationInput"] | undefined | null,
	seats?: Array<ValueTypes["TableUpdateSeatsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TableUpdateAreaEntityRelationInput"]: {
	create?: ValueTypes["AreaWithoutTablesCreateInput"] | undefined | null,
	update?: ValueTypes["AreaWithoutTablesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["TableUpsertAreaRelationInput"] | undefined | null,
	connect?: ValueTypes["AreaUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["AreaWithoutTablesUpdateInput"]: {
	order?: number | undefined | null,
	name?: string | undefined | null,
	venue?: ValueTypes["AreaUpdateVenueEntityRelationInput"] | undefined | null,
	lines?: Array<ValueTypes["AreaUpdateLinesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AreaUpdateVenueEntityRelationInput"]: {
	create?: ValueTypes["VenueWithoutAreasCreateInput"] | undefined | null,
	update?: ValueTypes["VenueWithoutAreasUpdateInput"] | undefined | null,
	upsert?: ValueTypes["AreaUpsertVenueRelationInput"] | undefined | null,
	connect?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["VenueWithoutAreasUpdateInput"]: {
	name?: string | undefined | null,
	deadlineTemplate?: ValueTypes["VenueUpdateDeadlineTemplateEntityRelationInput"] | undefined | null,
	timetableDays?: Array<ValueTypes["VenueUpdateTimetableDaysEntityRelationInput"]> | undefined | null,
	timetableTemplates?: Array<ValueTypes["VenueUpdateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	staffMembers?: Array<ValueTypes["VenueUpdateStaffMembersEntityRelationInput"]> | undefined | null,
	employeeRoles?: Array<ValueTypes["VenueUpdateEmployeeRolesEntityRelationInput"]> | undefined | null,
	pointOfSaleApplicationDevices?: Array<ValueTypes["VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined | null,
	pointOfSaleTerminals?: Array<ValueTypes["VenueUpdatePointOfSaleTerminalsEntityRelationInput"]> | undefined | null,
	pointOfSalePrinters?: Array<ValueTypes["VenueUpdatePointOfSalePrintersEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["VenueUpdateOrdersEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["VenueUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	enabledUnassignReasons?: Array<ValueTypes["VenueUpdateEnabledUnassignReasonsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["VenueUpdateCategoriesEntityRelationInput"]> | undefined | null,
	channels?: Array<ValueTypes["VenueUpdateChannelsEntityRelationInput"]> | undefined | null,
	address?: string | undefined | null,
	pointOfSalePngBase64ReceiptLogo?: string | undefined | null,
	pointOfSaleInitialView?: ValueTypes["PointOfSaleInitialView"] | undefined | null,
	pointOfSalePreferPrintReceipt?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VenueUpdateEnabledUnassignReasonsEntityRelationInput"]: {
	create?: ValueTypes["UnassignReasonWithoutVenuesCreateInput"] | undefined | null,
	update?: ValueTypes["VenueUpdateEnabledUnassignReasonsRelationInput"] | undefined | null,
	upsert?: ValueTypes["VenueUpsertEnabledUnassignReasonsRelationInput"] | undefined | null,
	connect?: ValueTypes["UnassignReasonUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["UnassignReasonUniqueWhere"] | undefined | null,
	delete?: ValueTypes["UnassignReasonUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["VenueUpdateEnabledUnassignReasonsRelationInput"]: {
	by?: ValueTypes["UnassignReasonUniqueWhere"] | undefined | null,
	data?: ValueTypes["UnassignReasonWithoutVenuesUpdateInput"] | undefined | null
};
	["UnassignReasonWithoutVenuesUpdateInput"]: {
	order?: number | undefined | null,
	name?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VenueUpsertEnabledUnassignReasonsRelationInput"]: {
	by?: ValueTypes["UnassignReasonUniqueWhere"] | undefined | null,
	update?: ValueTypes["UnassignReasonWithoutVenuesUpdateInput"] | undefined | null,
	create?: ValueTypes["UnassignReasonWithoutVenuesCreateInput"] | undefined | null
};
	["VenueUpdateCategoriesEntityRelationInput"]: {
	create?: ValueTypes["PointOfSaleCategoryWithoutVenueCreateInput"] | undefined | null,
	update?: ValueTypes["VenueUpdateCategoriesRelationInput"] | undefined | null,
	upsert?: ValueTypes["VenueUpsertCategoriesRelationInput"] | undefined | null,
	connect?: ValueTypes["PointOfSaleCategoryUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["PointOfSaleCategoryUniqueWhere"] | undefined | null,
	delete?: ValueTypes["PointOfSaleCategoryUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["VenueUpdateCategoriesRelationInput"]: {
	by?: ValueTypes["PointOfSaleCategoryUniqueWhere"] | undefined | null,
	data?: ValueTypes["PointOfSaleCategoryWithoutVenueUpdateInput"] | undefined | null
};
	["PointOfSaleCategoryWithoutVenueUpdateInput"]: {
	order?: number | undefined | null,
	slug?: string | undefined | null,
	locales?: Array<ValueTypes["PointOfSaleCategoryUpdateLocalesEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["PointOfSaleCategoryUpdateProductsEntityRelationInput"]> | undefined | null,
	category?: ValueTypes["PointOfSaleCategoryUpdateCategoryEntityRelationInput"] | undefined | null,
	ticketPrinters?: Array<ValueTypes["PointOfSaleCategoryUpdateTicketPrintersEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleCategoryUpdateCategoryEntityRelationInput"]: {
	create?: ValueTypes["ProductCategoryCreateInput"] | undefined | null,
	update?: ValueTypes["ProductCategoryUpdateInput"] | undefined | null,
	upsert?: ValueTypes["PointOfSaleCategoryUpsertCategoryRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductCategoryUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PointOfSaleCategoryUpsertCategoryRelationInput"]: {
	update?: ValueTypes["ProductCategoryUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductCategoryCreateInput"] | undefined | null
};
	["PointOfSaleCategoryUpdateTicketPrintersEntityRelationInput"]: {
	create?: ValueTypes["PointOfSalePrinterWithoutTicketCategoriesCreateInput"] | undefined | null,
	update?: ValueTypes["PointOfSaleCategoryUpdateTicketPrintersRelationInput"] | undefined | null,
	upsert?: ValueTypes["PointOfSaleCategoryUpsertTicketPrintersRelationInput"] | undefined | null,
	connect?: ValueTypes["PointOfSalePrinterUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["PointOfSalePrinterUniqueWhere"] | undefined | null,
	delete?: ValueTypes["PointOfSalePrinterUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PointOfSaleCategoryUpdateTicketPrintersRelationInput"]: {
	by?: ValueTypes["PointOfSalePrinterUniqueWhere"] | undefined | null,
	data?: ValueTypes["PointOfSalePrinterWithoutTicketCategoriesUpdateInput"] | undefined | null
};
	["PointOfSalePrinterWithoutTicketCategoriesUpdateInput"]: {
	internalName?: string | undefined | null,
	note?: string | undefined | null,
	ipAddress?: string | undefined | null,
	applicationDevicesReceipt?: Array<ValueTypes["PointOfSalePrinterUpdateApplicationDevicesReceiptEntityRelationInput"]> | undefined | null,
	applicationDevicesTicket?: Array<ValueTypes["PointOfSalePrinterUpdateApplicationDevicesTicketEntityRelationInput"]> | undefined | null,
	venue?: ValueTypes["PointOfSalePrinterUpdateVenueEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSalePrinterUpdateApplicationDevicesTicketEntityRelationInput"]: {
	create?: ValueTypes["PointOfSaleApplicationDeviceWithoutTicketPrintersCreateInput"] | undefined | null,
	update?: ValueTypes["PointOfSalePrinterUpdateApplicationDevicesTicketRelationInput"] | undefined | null,
	upsert?: ValueTypes["PointOfSalePrinterUpsertApplicationDevicesTicketRelationInput"] | undefined | null,
	connect?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null,
	delete?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PointOfSalePrinterUpdateApplicationDevicesTicketRelationInput"]: {
	by?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null,
	data?: ValueTypes["PointOfSaleApplicationDeviceWithoutTicketPrintersUpdateInput"] | undefined | null
};
	["PointOfSaleApplicationDeviceWithoutTicketPrintersUpdateInput"]: {
	internalName?: string | undefined | null,
	note?: string | undefined | null,
	venue?: ValueTypes["PointOfSaleApplicationDeviceUpdateVenueEntityRelationInput"] | undefined | null,
	identificationCode?: ValueTypes["PointOfSaleApplicationDeviceUpdateIdentificationCodeEntityRelationInput"] | undefined | null,
	identifier?: ValueTypes["PointOfSaleApplicationDeviceUpdateIdentifierEntityRelationInput"] | undefined | null,
	terminal?: ValueTypes["PointOfSaleApplicationDeviceUpdateTerminalEntityRelationInput"] | undefined | null,
	receiptPrinter?: ValueTypes["PointOfSaleApplicationDeviceUpdateReceiptPrinterEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleApplicationDeviceUpdateReceiptPrinterEntityRelationInput"]: {
	create?: ValueTypes["PointOfSalePrinterWithoutApplicationDevicesReceiptCreateInput"] | undefined | null,
	update?: ValueTypes["PointOfSalePrinterWithoutApplicationDevicesReceiptUpdateInput"] | undefined | null,
	upsert?: ValueTypes["PointOfSaleApplicationDeviceUpsertReceiptPrinterRelationInput"] | undefined | null,
	connect?: ValueTypes["PointOfSalePrinterUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PointOfSalePrinterWithoutApplicationDevicesReceiptUpdateInput"]: {
	internalName?: string | undefined | null,
	note?: string | undefined | null,
	ipAddress?: string | undefined | null,
	applicationDevicesTicket?: Array<ValueTypes["PointOfSalePrinterUpdateApplicationDevicesTicketEntityRelationInput"]> | undefined | null,
	venue?: ValueTypes["PointOfSalePrinterUpdateVenueEntityRelationInput"] | undefined | null,
	ticketCategories?: Array<ValueTypes["PointOfSalePrinterUpdateTicketCategoriesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSalePrinterUpdateVenueEntityRelationInput"]: {
	create?: ValueTypes["VenueWithoutPointOfSalePrintersCreateInput"] | undefined | null,
	update?: ValueTypes["VenueWithoutPointOfSalePrintersUpdateInput"] | undefined | null,
	upsert?: ValueTypes["PointOfSalePrinterUpsertVenueRelationInput"] | undefined | null,
	connect?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["VenueWithoutPointOfSalePrintersUpdateInput"]: {
	name?: string | undefined | null,
	deadlineTemplate?: ValueTypes["VenueUpdateDeadlineTemplateEntityRelationInput"] | undefined | null,
	timetableDays?: Array<ValueTypes["VenueUpdateTimetableDaysEntityRelationInput"]> | undefined | null,
	timetableTemplates?: Array<ValueTypes["VenueUpdateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	staffMembers?: Array<ValueTypes["VenueUpdateStaffMembersEntityRelationInput"]> | undefined | null,
	employeeRoles?: Array<ValueTypes["VenueUpdateEmployeeRolesEntityRelationInput"]> | undefined | null,
	pointOfSaleApplicationDevices?: Array<ValueTypes["VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined | null,
	pointOfSaleTerminals?: Array<ValueTypes["VenueUpdatePointOfSaleTerminalsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["VenueUpdateOrdersEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["VenueUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	areas?: Array<ValueTypes["VenueUpdateAreasEntityRelationInput"]> | undefined | null,
	enabledUnassignReasons?: Array<ValueTypes["VenueUpdateEnabledUnassignReasonsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["VenueUpdateCategoriesEntityRelationInput"]> | undefined | null,
	channels?: Array<ValueTypes["VenueUpdateChannelsEntityRelationInput"]> | undefined | null,
	address?: string | undefined | null,
	pointOfSalePngBase64ReceiptLogo?: string | undefined | null,
	pointOfSaleInitialView?: ValueTypes["PointOfSaleInitialView"] | undefined | null,
	pointOfSalePreferPrintReceipt?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VenueUpdateAreasEntityRelationInput"]: {
	create?: ValueTypes["AreaWithoutVenueCreateInput"] | undefined | null,
	update?: ValueTypes["VenueUpdateAreasRelationInput"] | undefined | null,
	upsert?: ValueTypes["VenueUpsertAreasRelationInput"] | undefined | null,
	connect?: ValueTypes["AreaUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["AreaUniqueWhere"] | undefined | null,
	delete?: ValueTypes["AreaUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["VenueUpdateAreasRelationInput"]: {
	by?: ValueTypes["AreaUniqueWhere"] | undefined | null,
	data?: ValueTypes["AreaWithoutVenueUpdateInput"] | undefined | null
};
	["AreaWithoutVenueUpdateInput"]: {
	order?: number | undefined | null,
	name?: string | undefined | null,
	tables?: Array<ValueTypes["AreaUpdateTablesEntityRelationInput"]> | undefined | null,
	lines?: Array<ValueTypes["AreaUpdateLinesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AreaUpdateTablesEntityRelationInput"]: {
	create?: ValueTypes["TableWithoutAreaCreateInput"] | undefined | null,
	update?: ValueTypes["AreaUpdateTablesRelationInput"] | undefined | null,
	upsert?: ValueTypes["AreaUpsertTablesRelationInput"] | undefined | null,
	connect?: ValueTypes["TableUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["TableUniqueWhere"] | undefined | null,
	delete?: ValueTypes["TableUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["AreaUpdateTablesRelationInput"]: {
	by?: ValueTypes["TableUniqueWhere"] | undefined | null,
	data?: ValueTypes["TableWithoutAreaUpdateInput"] | undefined | null
};
	["TableWithoutAreaUpdateInput"]: {
	shape?: ValueTypes["TableShape"] | undefined | null,
	width?: number | undefined | null,
	height?: number | undefined | null,
	positionX?: number | undefined | null,
	positionY?: number | undefined | null,
	name?: string | undefined | null,
	color?: string | undefined | null,
	customerTabs?: Array<ValueTypes["TableUpdateCustomerTabsEntityRelationInput"]> | undefined | null,
	seats?: Array<ValueTypes["TableUpdateSeatsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TableUpdateCustomerTabsEntityRelationInput"]: {
	create?: ValueTypes["CustomerTabWithoutTableCreateInput"] | undefined | null,
	update?: ValueTypes["TableUpdateCustomerTabsRelationInput"] | undefined | null,
	upsert?: ValueTypes["TableUpsertCustomerTabsRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerTabUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["CustomerTabUniqueWhere"] | undefined | null,
	delete?: ValueTypes["CustomerTabUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["TableUpdateCustomerTabsRelationInput"]: {
	by?: ValueTypes["CustomerTabUniqueWhere"] | undefined | null,
	data?: ValueTypes["CustomerTabWithoutTableUpdateInput"] | undefined | null
};
	["CustomerTabWithoutTableUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	color?: string | undefined | null,
	items?: Array<ValueTypes["CustomerTabUpdateItemsEntityRelationInput"]> | undefined | null,
	name?: string | undefined | null,
	meta?: ValueTypes["CustomerTabUpdateMetaEntityRelationInput"] | undefined | null,
	customer?: ValueTypes["CustomerTabUpdateCustomerEntityRelationInput"] | undefined | null,
	seat?: ValueTypes["CustomerTabUpdateSeatEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerTabUpdateCustomerEntityRelationInput"]: {
	create?: ValueTypes["CustomerWithoutCustomerTabsCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerWithoutCustomerTabsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CustomerTabUpsertCustomerRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CustomerWithoutCustomerTabsUpdateInput"]: {
	addresses?: Array<ValueTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerUpdateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerUpdateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerUpdateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined | null,
	lead?: Array<ValueTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerUpdateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerUpdateLeadEntityRelationInput"]: {
	create?: ValueTypes["PipelineLeadWithoutCustomerCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerUpdateLeadRelationInput"] | undefined | null,
	upsert?: ValueTypes["CustomerUpsertLeadRelationInput"] | undefined | null,
	connect?: ValueTypes["PipelineLeadUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["PipelineLeadUniqueWhere"] | undefined | null,
	delete?: ValueTypes["PipelineLeadUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CustomerUpdateLeadRelationInput"]: {
	by?: ValueTypes["PipelineLeadUniqueWhere"] | undefined | null,
	data?: ValueTypes["PipelineLeadWithoutCustomerUpdateInput"] | undefined | null
};
	["PipelineLeadWithoutCustomerUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	stageItem?: ValueTypes["PipelineLeadUpdateStageItemEntityRelationInput"] | undefined | null,
	contactPerson?: string | undefined | null,
	cafeType?: string | undefined | null,
	offerType?: string | undefined | null,
	ownMachine?: boolean | undefined | null,
	customerCity?: string | undefined | null,
	companyId?: string | undefined | null,
	customerName?: string | undefined | null,
	email?: string | undefined | null,
	phone?: string | undefined | null,
	form?: ValueTypes["PipelineLeadUpdateFormEntityRelationInput"] | undefined | null,
	meta?: string | undefined | null,
	multiroasterType?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PipelineLeadUpdateStageItemEntityRelationInput"]: {
	create?: ValueTypes["PipelineStageItemWithoutLeadCreateInput"] | undefined | null,
	update?: ValueTypes["PipelineStageItemWithoutLeadUpdateInput"] | undefined | null,
	upsert?: ValueTypes["PipelineLeadUpsertStageItemRelationInput"] | undefined | null,
	connect?: ValueTypes["PipelineStageItemUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PipelineStageItemWithoutLeadUpdateInput"]: {
	list?: ValueTypes["PipelineStageItemUpdateListEntityRelationInput"] | undefined | null,
	order?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PipelineStageItemUpdateListEntityRelationInput"]: {
	create?: ValueTypes["PipelineStageWithoutItemsCreateInput"] | undefined | null,
	update?: ValueTypes["PipelineStageWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["PipelineStageItemUpsertListRelationInput"] | undefined | null,
	connect?: ValueTypes["PipelineStageUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["PipelineStageWithoutItemsUpdateInput"]: {
	pipeline?: ValueTypes["PipelineStageUpdatePipelineEntityRelationInput"] | undefined | null,
	order?: number | undefined | null,
	locales?: Array<ValueTypes["PipelineStageUpdateLocalesEntityRelationInput"]> | undefined | null,
	sentiment?: ValueTypes["PipelineStageUpdateSentimentEntityRelationInput"] | undefined | null,
	type?: ValueTypes["PipelineStageType"] | undefined | null,
	forms?: Array<ValueTypes["PipelineStageUpdateFormsEntityRelationInput"]> | undefined | null,
	showItemsWeight?: boolean | undefined | null,
	showItemsPrice?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PipelineStageUpdatePipelineEntityRelationInput"]: {
	create?: ValueTypes["PipelineWithoutStagesCreateInput"] | undefined | null,
	update?: ValueTypes["PipelineWithoutStagesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["PipelineStageUpsertPipelineRelationInput"] | undefined | null,
	connect?: ValueTypes["PipelineUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PipelineWithoutStagesUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PipelineStageUpsertPipelineRelationInput"]: {
	update?: ValueTypes["PipelineWithoutStagesUpdateInput"] | undefined | null,
	create?: ValueTypes["PipelineWithoutStagesCreateInput"] | undefined | null
};
	["PipelineStageUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["PipelineStageLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ValueTypes["PipelineStageUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ValueTypes["PipelineStageUpsertLocalesRelationInput"] | undefined | null,
	connect?: ValueTypes["PipelineStageLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["PipelineStageLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["PipelineStageLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PipelineStageUpdateLocalesRelationInput"]: {
	by?: ValueTypes["PipelineStageLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["PipelineStageLocaleWithoutRootUpdateInput"] | undefined | null
};
	["PipelineStageLocaleWithoutRootUpdateInput"]: {
	name?: string | undefined | null,
	locale?: ValueTypes["PipelineStageLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PipelineStageLocaleUpdateLocaleEntityRelationInput"]: {
	create?: ValueTypes["LocaleWithoutPipelineStagesCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleWithoutPipelineStagesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["PipelineStageLocaleUpsertLocaleRelationInput"] | undefined | null,
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutPipelineStagesUpdateInput"]: {
	businessCategories?: Array<ValueTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleUpdateSubscriptionBoxesEntityRelationInput"]: {
	create?: ValueTypes["SubscriptionBoxLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleUpdateSubscriptionBoxesRelationInput"] | undefined | null,
	upsert?: ValueTypes["LocaleUpsertSubscriptionBoxesRelationInput"] | undefined | null,
	connect?: ValueTypes["SubscriptionBoxLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["SubscriptionBoxLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["SubscriptionBoxLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateSubscriptionBoxesRelationInput"]: {
	by?: ValueTypes["SubscriptionBoxLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["SubscriptionBoxLocaleWithoutLocaleUpdateInput"] | undefined | null
};
	["SubscriptionBoxLocaleWithoutLocaleUpdateInput"]: {
	title?: string | undefined | null,
	stickerText?: string | undefined | null,
	descriptionText?: string | undefined | null,
	root?: ValueTypes["SubscriptionBoxLocaleUpdateRootEntityRelationInput"] | undefined | null,
	secondaryTitle?: string | undefined | null,
	texts?: ValueTypes["SubscriptionBoxLocaleUpdateTextsEntityRelationInput"] | undefined | null,
	secondaryTexts?: ValueTypes["SubscriptionBoxLocaleUpdateSecondaryTextsEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SubscriptionBoxLocaleUpdateRootEntityRelationInput"]: {
	create?: ValueTypes["SubscriptionBoxWithoutLocalesCreateInput"] | undefined | null,
	update?: ValueTypes["SubscriptionBoxWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["SubscriptionBoxLocaleUpsertRootRelationInput"] | undefined | null,
	connect?: ValueTypes["SubscriptionBoxUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["SubscriptionBoxWithoutLocalesUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SubscriptionBoxLocaleUpsertRootRelationInput"]: {
	update?: ValueTypes["SubscriptionBoxWithoutLocalesUpdateInput"] | undefined | null,
	create?: ValueTypes["SubscriptionBoxWithoutLocalesCreateInput"] | undefined | null
};
	["SubscriptionBoxLocaleUpdateTextsEntityRelationInput"]: {
	create?: ValueTypes["TextListCreateInput"] | undefined | null,
	update?: ValueTypes["TextListUpdateInput"] | undefined | null,
	upsert?: ValueTypes["SubscriptionBoxLocaleUpsertTextsRelationInput"] | undefined | null,
	connect?: ValueTypes["TextListUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["SubscriptionBoxLocaleUpsertTextsRelationInput"]: {
	update?: ValueTypes["TextListUpdateInput"] | undefined | null,
	create?: ValueTypes["TextListCreateInput"] | undefined | null
};
	["SubscriptionBoxLocaleUpdateSecondaryTextsEntityRelationInput"]: {
	create?: ValueTypes["TextListCreateInput"] | undefined | null,
	update?: ValueTypes["TextListUpdateInput"] | undefined | null,
	upsert?: ValueTypes["SubscriptionBoxLocaleUpsertSecondaryTextsRelationInput"] | undefined | null,
	connect?: ValueTypes["TextListUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["SubscriptionBoxLocaleUpsertSecondaryTextsRelationInput"]: {
	update?: ValueTypes["TextListUpdateInput"] | undefined | null,
	create?: ValueTypes["TextListCreateInput"] | undefined | null
};
	["LocaleUpsertSubscriptionBoxesRelationInput"]: {
	by?: ValueTypes["SubscriptionBoxLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["SubscriptionBoxLocaleWithoutLocaleUpdateInput"] | undefined | null,
	create?: ValueTypes["SubscriptionBoxLocaleWithoutLocaleCreateInput"] | undefined | null
};
	["LocaleUpdateBusinessServicesEntityRelationInput"]: {
	create?: ValueTypes["BusinessServiceLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleUpdateBusinessServicesRelationInput"] | undefined | null,
	upsert?: ValueTypes["LocaleUpsertBusinessServicesRelationInput"] | undefined | null,
	connect?: ValueTypes["BusinessServiceLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["BusinessServiceLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["BusinessServiceLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdateBusinessServicesRelationInput"]: {
	by?: ValueTypes["BusinessServiceLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["BusinessServiceLocaleWithoutLocaleUpdateInput"] | undefined | null
};
	["BusinessServiceLocaleWithoutLocaleUpdateInput"]: {
	name?: string | undefined | null,
	labelNote?: string | undefined | null,
	root?: ValueTypes["BusinessServiceLocaleUpdateRootEntityRelationInput"] | undefined | null,
	labelNumberOfPeople?: string | undefined | null,
	labelInvoiced?: string | undefined | null,
	labelEquipment?: string | undefined | null,
	labelMillTamDem?: string | undefined | null,
	labelSOEspresso?: string | undefined | null,
	labelFilterCoffeeInMenu?: string | undefined | null,
	labelWaterMeterStatus?: string | undefined | null,
	labelServiceAction?: string | undefined | null,
	labelInvoiceIdentifier?: string | undefined | null,
	labelSupervisor?: string | undefined | null,
	labelContact?: string | undefined | null,
	labelPhone?: string | undefined | null,
	labelEmail?: string | undefined | null,
	labelGrindingStonesCondition?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessServiceLocaleUpdateRootEntityRelationInput"]: {
	create?: ValueTypes["BusinessServiceWithoutLocalesCreateInput"] | undefined | null,
	update?: ValueTypes["BusinessServiceWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["BusinessServiceLocaleUpsertRootRelationInput"] | undefined | null,
	connect?: ValueTypes["BusinessServiceUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["BusinessServiceWithoutLocalesUpdateInput"]: {
	order?: number | undefined | null,
	requireNote?: number | undefined | null,
	requireNumberOfPeople?: number | undefined | null,
	requireInvoiced?: number | undefined | null,
	requireEquipment?: number | undefined | null,
	requireMillTamDem?: number | undefined | null,
	requireSOEspresso?: number | undefined | null,
	requireFilterCoffeeInMenu?: number | undefined | null,
	requireWaterMeterStatus?: number | undefined | null,
	requireServiceAction?: number | undefined | null,
	optionsEquipment?: string | undefined | null,
	optionsServiceAction?: string | undefined | null,
	requireInvoiceIdentifier?: number | undefined | null,
	requireSupervisor?: number | undefined | null,
	requireContact?: number | undefined | null,
	requirePhone?: number | undefined | null,
	requireEmail?: number | undefined | null,
	requireGrindingStonesCondition?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessServiceLocaleUpsertRootRelationInput"]: {
	update?: ValueTypes["BusinessServiceWithoutLocalesUpdateInput"] | undefined | null,
	create?: ValueTypes["BusinessServiceWithoutLocalesCreateInput"] | undefined | null
};
	["LocaleUpsertBusinessServicesRelationInput"]: {
	by?: ValueTypes["BusinessServiceLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["BusinessServiceLocaleWithoutLocaleUpdateInput"] | undefined | null,
	create?: ValueTypes["BusinessServiceLocaleWithoutLocaleCreateInput"] | undefined | null
};
	["PipelineStageLocaleUpsertLocaleRelationInput"]: {
	update?: ValueTypes["LocaleWithoutPipelineStagesUpdateInput"] | undefined | null,
	create?: ValueTypes["LocaleWithoutPipelineStagesCreateInput"] | undefined | null
};
	["PipelineStageUpsertLocalesRelationInput"]: {
	by?: ValueTypes["PipelineStageLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["PipelineStageLocaleWithoutRootUpdateInput"] | undefined | null,
	create?: ValueTypes["PipelineStageLocaleWithoutRootCreateInput"] | undefined | null
};
	["PipelineStageUpdateSentimentEntityRelationInput"]: {
	create?: ValueTypes["PipelineStageSentimentCreateInput"] | undefined | null,
	update?: ValueTypes["PipelineStageSentimentUpdateInput"] | undefined | null,
	upsert?: ValueTypes["PipelineStageUpsertSentimentRelationInput"] | undefined | null,
	connect?: ValueTypes["PipelineStageSentimentUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PipelineStageSentimentUpdateInput"]: {
	internalName?: string | undefined | null,
	backgroundColor?: string | undefined | null,
	textColor?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PipelineStageUpsertSentimentRelationInput"]: {
	update?: ValueTypes["PipelineStageSentimentUpdateInput"] | undefined | null,
	create?: ValueTypes["PipelineStageSentimentCreateInput"] | undefined | null
};
	["PipelineStageUpdateFormsEntityRelationInput"]: {
	create?: ValueTypes["LeadFormWithoutStageCreateInput"] | undefined | null,
	update?: ValueTypes["PipelineStageUpdateFormsRelationInput"] | undefined | null,
	upsert?: ValueTypes["PipelineStageUpsertFormsRelationInput"] | undefined | null,
	connect?: ValueTypes["LeadFormUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["LeadFormUniqueWhere"] | undefined | null,
	delete?: ValueTypes["LeadFormUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PipelineStageUpdateFormsRelationInput"]: {
	by?: ValueTypes["LeadFormUniqueWhere"] | undefined | null,
	data?: ValueTypes["LeadFormWithoutStageUpdateInput"] | undefined | null
};
	["LeadFormWithoutStageUpdateInput"]: {
	code?: string | undefined | null,
	leads?: Array<ValueTypes["LeadFormUpdateLeadsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LeadFormUpdateLeadsEntityRelationInput"]: {
	create?: ValueTypes["PipelineLeadWithoutFormCreateInput"] | undefined | null,
	update?: ValueTypes["LeadFormUpdateLeadsRelationInput"] | undefined | null,
	upsert?: ValueTypes["LeadFormUpsertLeadsRelationInput"] | undefined | null,
	connect?: ValueTypes["PipelineLeadUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["PipelineLeadUniqueWhere"] | undefined | null,
	delete?: ValueTypes["PipelineLeadUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LeadFormUpdateLeadsRelationInput"]: {
	by?: ValueTypes["PipelineLeadUniqueWhere"] | undefined | null,
	data?: ValueTypes["PipelineLeadWithoutFormUpdateInput"] | undefined | null
};
	["PipelineLeadWithoutFormUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	stageItem?: ValueTypes["PipelineLeadUpdateStageItemEntityRelationInput"] | undefined | null,
	contactPerson?: string | undefined | null,
	customer?: ValueTypes["PipelineLeadUpdateCustomerEntityRelationInput"] | undefined | null,
	cafeType?: string | undefined | null,
	offerType?: string | undefined | null,
	ownMachine?: boolean | undefined | null,
	customerCity?: string | undefined | null,
	companyId?: string | undefined | null,
	customerName?: string | undefined | null,
	email?: string | undefined | null,
	phone?: string | undefined | null,
	meta?: string | undefined | null,
	multiroasterType?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PipelineLeadUpdateCustomerEntityRelationInput"]: {
	create?: ValueTypes["CustomerWithoutLeadCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerWithoutLeadUpdateInput"] | undefined | null,
	upsert?: ValueTypes["PipelineLeadUpsertCustomerRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CustomerWithoutLeadUpdateInput"]: {
	addresses?: Array<ValueTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerUpdateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerUpdateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerUpdateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerUpdateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerUpdateMetaEntityRelationInput"]: {
	connect?: ValueTypes["CustomerMetadataUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PipelineLeadUpsertCustomerRelationInput"]: {
	update?: ValueTypes["CustomerWithoutLeadUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerWithoutLeadCreateInput"] | undefined | null
};
	["LeadFormUpsertLeadsRelationInput"]: {
	by?: ValueTypes["PipelineLeadUniqueWhere"] | undefined | null,
	update?: ValueTypes["PipelineLeadWithoutFormUpdateInput"] | undefined | null,
	create?: ValueTypes["PipelineLeadWithoutFormCreateInput"] | undefined | null
};
	["PipelineStageUpsertFormsRelationInput"]: {
	by?: ValueTypes["LeadFormUniqueWhere"] | undefined | null,
	update?: ValueTypes["LeadFormWithoutStageUpdateInput"] | undefined | null,
	create?: ValueTypes["LeadFormWithoutStageCreateInput"] | undefined | null
};
	["PipelineStageItemUpsertListRelationInput"]: {
	update?: ValueTypes["PipelineStageWithoutItemsUpdateInput"] | undefined | null,
	create?: ValueTypes["PipelineStageWithoutItemsCreateInput"] | undefined | null
};
	["PipelineLeadUpsertStageItemRelationInput"]: {
	update?: ValueTypes["PipelineStageItemWithoutLeadUpdateInput"] | undefined | null,
	create?: ValueTypes["PipelineStageItemWithoutLeadCreateInput"] | undefined | null
};
	["PipelineLeadUpdateFormEntityRelationInput"]: {
	create?: ValueTypes["LeadFormWithoutLeadsCreateInput"] | undefined | null,
	update?: ValueTypes["LeadFormWithoutLeadsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["PipelineLeadUpsertFormRelationInput"] | undefined | null,
	connect?: ValueTypes["LeadFormUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["LeadFormWithoutLeadsUpdateInput"]: {
	code?: string | undefined | null,
	stage?: ValueTypes["LeadFormUpdateStageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LeadFormUpdateStageEntityRelationInput"]: {
	create?: ValueTypes["PipelineStageWithoutFormsCreateInput"] | undefined | null,
	update?: ValueTypes["PipelineStageWithoutFormsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["LeadFormUpsertStageRelationInput"] | undefined | null,
	connect?: ValueTypes["PipelineStageUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PipelineStageWithoutFormsUpdateInput"]: {
	items?: Array<ValueTypes["PipelineStageUpdateItemsEntityRelationInput"]> | undefined | null,
	pipeline?: ValueTypes["PipelineStageUpdatePipelineEntityRelationInput"] | undefined | null,
	order?: number | undefined | null,
	locales?: Array<ValueTypes["PipelineStageUpdateLocalesEntityRelationInput"]> | undefined | null,
	sentiment?: ValueTypes["PipelineStageUpdateSentimentEntityRelationInput"] | undefined | null,
	type?: ValueTypes["PipelineStageType"] | undefined | null,
	showItemsWeight?: boolean | undefined | null,
	showItemsPrice?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PipelineStageUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["PipelineStageItemWithoutListCreateInput"] | undefined | null,
	update?: ValueTypes["PipelineStageUpdateItemsRelationInput"] | undefined | null,
	upsert?: ValueTypes["PipelineStageUpsertItemsRelationInput"] | undefined | null,
	connect?: ValueTypes["PipelineStageItemUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["PipelineStageItemUniqueWhere"] | undefined | null,
	delete?: ValueTypes["PipelineStageItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PipelineStageUpdateItemsRelationInput"]: {
	by?: ValueTypes["PipelineStageItemUniqueWhere"] | undefined | null,
	data?: ValueTypes["PipelineStageItemWithoutListUpdateInput"] | undefined | null
};
	["PipelineStageItemWithoutListUpdateInput"]: {
	lead?: ValueTypes["PipelineStageItemUpdateLeadEntityRelationInput"] | undefined | null,
	order?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PipelineStageItemUpdateLeadEntityRelationInput"]: {
	create?: ValueTypes["PipelineLeadWithoutStageItemCreateInput"] | undefined | null,
	update?: ValueTypes["PipelineLeadWithoutStageItemUpdateInput"] | undefined | null,
	upsert?: ValueTypes["PipelineStageItemUpsertLeadRelationInput"] | undefined | null,
	connect?: ValueTypes["PipelineLeadUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PipelineLeadWithoutStageItemUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	contactPerson?: string | undefined | null,
	customer?: ValueTypes["PipelineLeadUpdateCustomerEntityRelationInput"] | undefined | null,
	cafeType?: string | undefined | null,
	offerType?: string | undefined | null,
	ownMachine?: boolean | undefined | null,
	customerCity?: string | undefined | null,
	companyId?: string | undefined | null,
	customerName?: string | undefined | null,
	email?: string | undefined | null,
	phone?: string | undefined | null,
	form?: ValueTypes["PipelineLeadUpdateFormEntityRelationInput"] | undefined | null,
	meta?: string | undefined | null,
	multiroasterType?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PipelineStageItemUpsertLeadRelationInput"]: {
	update?: ValueTypes["PipelineLeadWithoutStageItemUpdateInput"] | undefined | null,
	create?: ValueTypes["PipelineLeadWithoutStageItemCreateInput"] | undefined | null
};
	["PipelineStageUpsertItemsRelationInput"]: {
	by?: ValueTypes["PipelineStageItemUniqueWhere"] | undefined | null,
	update?: ValueTypes["PipelineStageItemWithoutListUpdateInput"] | undefined | null,
	create?: ValueTypes["PipelineStageItemWithoutListCreateInput"] | undefined | null
};
	["LeadFormUpsertStageRelationInput"]: {
	update?: ValueTypes["PipelineStageWithoutFormsUpdateInput"] | undefined | null,
	create?: ValueTypes["PipelineStageWithoutFormsCreateInput"] | undefined | null
};
	["PipelineLeadUpsertFormRelationInput"]: {
	update?: ValueTypes["LeadFormWithoutLeadsUpdateInput"] | undefined | null,
	create?: ValueTypes["LeadFormWithoutLeadsCreateInput"] | undefined | null
};
	["CustomerUpsertLeadRelationInput"]: {
	by?: ValueTypes["PipelineLeadUniqueWhere"] | undefined | null,
	update?: ValueTypes["PipelineLeadWithoutCustomerUpdateInput"] | undefined | null,
	create?: ValueTypes["PipelineLeadWithoutCustomerCreateInput"] | undefined | null
};
	["CustomerTabUpsertCustomerRelationInput"]: {
	update?: ValueTypes["CustomerWithoutCustomerTabsUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerWithoutCustomerTabsCreateInput"] | undefined | null
};
	["CustomerTabUpdateSeatEntityRelationInput"]: {
	create?: ValueTypes["SeatWithoutCustomerTabsCreateInput"] | undefined | null,
	update?: ValueTypes["SeatWithoutCustomerTabsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CustomerTabUpsertSeatRelationInput"] | undefined | null,
	connect?: ValueTypes["SeatUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["SeatWithoutCustomerTabsUpdateInput"]: {
	positionX?: number | undefined | null,
	positionY?: number | undefined | null,
	name?: string | undefined | null,
	color?: string | undefined | null,
	table?: ValueTypes["SeatUpdateTableEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SeatUpdateTableEntityRelationInput"]: {
	create?: ValueTypes["TableWithoutSeatsCreateInput"] | undefined | null,
	update?: ValueTypes["TableWithoutSeatsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["SeatUpsertTableRelationInput"] | undefined | null,
	connect?: ValueTypes["TableUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["TableWithoutSeatsUpdateInput"]: {
	shape?: ValueTypes["TableShape"] | undefined | null,
	width?: number | undefined | null,
	height?: number | undefined | null,
	positionX?: number | undefined | null,
	positionY?: number | undefined | null,
	name?: string | undefined | null,
	color?: string | undefined | null,
	customerTabs?: Array<ValueTypes["TableUpdateCustomerTabsEntityRelationInput"]> | undefined | null,
	area?: ValueTypes["TableUpdateAreaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SeatUpsertTableRelationInput"]: {
	update?: ValueTypes["TableWithoutSeatsUpdateInput"] | undefined | null,
	create?: ValueTypes["TableWithoutSeatsCreateInput"] | undefined | null
};
	["CustomerTabUpsertSeatRelationInput"]: {
	update?: ValueTypes["SeatWithoutCustomerTabsUpdateInput"] | undefined | null,
	create?: ValueTypes["SeatWithoutCustomerTabsCreateInput"] | undefined | null
};
	["TableUpsertCustomerTabsRelationInput"]: {
	by?: ValueTypes["CustomerTabUniqueWhere"] | undefined | null,
	update?: ValueTypes["CustomerTabWithoutTableUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerTabWithoutTableCreateInput"] | undefined | null
};
	["TableUpdateSeatsEntityRelationInput"]: {
	create?: ValueTypes["SeatWithoutTableCreateInput"] | undefined | null,
	update?: ValueTypes["TableUpdateSeatsRelationInput"] | undefined | null,
	upsert?: ValueTypes["TableUpsertSeatsRelationInput"] | undefined | null,
	connect?: ValueTypes["SeatUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["SeatUniqueWhere"] | undefined | null,
	delete?: ValueTypes["SeatUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["TableUpdateSeatsRelationInput"]: {
	by?: ValueTypes["SeatUniqueWhere"] | undefined | null,
	data?: ValueTypes["SeatWithoutTableUpdateInput"] | undefined | null
};
	["SeatWithoutTableUpdateInput"]: {
	positionX?: number | undefined | null,
	positionY?: number | undefined | null,
	name?: string | undefined | null,
	color?: string | undefined | null,
	customerTabs?: Array<ValueTypes["SeatUpdateCustomerTabsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SeatUpdateCustomerTabsEntityRelationInput"]: {
	create?: ValueTypes["CustomerTabWithoutSeatCreateInput"] | undefined | null,
	update?: ValueTypes["SeatUpdateCustomerTabsRelationInput"] | undefined | null,
	upsert?: ValueTypes["SeatUpsertCustomerTabsRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerTabUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["CustomerTabUniqueWhere"] | undefined | null,
	delete?: ValueTypes["CustomerTabUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["SeatUpdateCustomerTabsRelationInput"]: {
	by?: ValueTypes["CustomerTabUniqueWhere"] | undefined | null,
	data?: ValueTypes["CustomerTabWithoutSeatUpdateInput"] | undefined | null
};
	["CustomerTabWithoutSeatUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	color?: string | undefined | null,
	items?: Array<ValueTypes["CustomerTabUpdateItemsEntityRelationInput"]> | undefined | null,
	name?: string | undefined | null,
	meta?: ValueTypes["CustomerTabUpdateMetaEntityRelationInput"] | undefined | null,
	customer?: ValueTypes["CustomerTabUpdateCustomerEntityRelationInput"] | undefined | null,
	table?: ValueTypes["CustomerTabUpdateTableEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SeatUpsertCustomerTabsRelationInput"]: {
	by?: ValueTypes["CustomerTabUniqueWhere"] | undefined | null,
	update?: ValueTypes["CustomerTabWithoutSeatUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerTabWithoutSeatCreateInput"] | undefined | null
};
	["TableUpsertSeatsRelationInput"]: {
	by?: ValueTypes["SeatUniqueWhere"] | undefined | null,
	update?: ValueTypes["SeatWithoutTableUpdateInput"] | undefined | null,
	create?: ValueTypes["SeatWithoutTableCreateInput"] | undefined | null
};
	["AreaUpsertTablesRelationInput"]: {
	by?: ValueTypes["TableUniqueWhere"] | undefined | null,
	update?: ValueTypes["TableWithoutAreaUpdateInput"] | undefined | null,
	create?: ValueTypes["TableWithoutAreaCreateInput"] | undefined | null
};
	["AreaUpdateLinesEntityRelationInput"]: {
	create?: ValueTypes["LineWithoutAreaCreateInput"] | undefined | null,
	update?: ValueTypes["AreaUpdateLinesRelationInput"] | undefined | null,
	upsert?: ValueTypes["AreaUpsertLinesRelationInput"] | undefined | null,
	connect?: ValueTypes["LineUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["LineUniqueWhere"] | undefined | null,
	delete?: ValueTypes["LineUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["AreaUpdateLinesRelationInput"]: {
	by?: ValueTypes["LineUniqueWhere"] | undefined | null,
	data?: ValueTypes["LineWithoutAreaUpdateInput"] | undefined | null
};
	["LineWithoutAreaUpdateInput"]: {
	positionStartX?: number | undefined | null,
	positionStartY?: number | undefined | null,
	positionEndX?: number | undefined | null,
	positionEndY?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AreaUpsertLinesRelationInput"]: {
	by?: ValueTypes["LineUniqueWhere"] | undefined | null,
	update?: ValueTypes["LineWithoutAreaUpdateInput"] | undefined | null,
	create?: ValueTypes["LineWithoutAreaCreateInput"] | undefined | null
};
	["VenueUpsertAreasRelationInput"]: {
	by?: ValueTypes["AreaUniqueWhere"] | undefined | null,
	update?: ValueTypes["AreaWithoutVenueUpdateInput"] | undefined | null,
	create?: ValueTypes["AreaWithoutVenueCreateInput"] | undefined | null
};
	["VenueUpdateChannelsEntityRelationInput"]: {
	create?: ValueTypes["ChannelWithoutVenueCreateInput"] | undefined | null,
	update?: ValueTypes["VenueUpdateChannelsRelationInput"] | undefined | null,
	upsert?: ValueTypes["VenueUpsertChannelsRelationInput"] | undefined | null,
	connect?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["VenueUpdateChannelsRelationInput"]: {
	by?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	data?: ValueTypes["ChannelWithoutVenueUpdateInput"] | undefined | null
};
	["ChannelWithoutVenueUpdateInput"]: {
	name?: string | undefined | null,
	disabled?: boolean | undefined | null,
	payments?: Array<ValueTypes["ChannelUpdatePaymentsEntityRelationInput"]> | undefined | null,
	deliveries?: Array<ValueTypes["ChannelUpdateDeliveriesEntityRelationInput"]> | undefined | null,
	pointOfSales?: Array<ValueTypes["ChannelUpdatePointOfSalesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["ChannelUpdateCartsEntityRelationInput"]> | undefined | null,
	customers?: Array<ValueTypes["ChannelUpdateCustomersEntityRelationInput"]> | undefined | null,
	code?: ValueTypes["ChannelCode"] | undefined | null,
	addTagsOnRegistration?: Array<ValueTypes["ChannelUpdateAddTagsOnRegistrationEntityRelationInput"]> | undefined | null,
	publicTags?: Array<ValueTypes["ChannelUpdatePublicTagsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VenueUpsertChannelsRelationInput"]: {
	by?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	update?: ValueTypes["ChannelWithoutVenueUpdateInput"] | undefined | null,
	create?: ValueTypes["ChannelWithoutVenueCreateInput"] | undefined | null
};
	["PointOfSalePrinterUpsertVenueRelationInput"]: {
	update?: ValueTypes["VenueWithoutPointOfSalePrintersUpdateInput"] | undefined | null,
	create?: ValueTypes["VenueWithoutPointOfSalePrintersCreateInput"] | undefined | null
};
	["PointOfSalePrinterUpdateTicketCategoriesEntityRelationInput"]: {
	create?: ValueTypes["PointOfSaleCategoryWithoutTicketPrintersCreateInput"] | undefined | null,
	update?: ValueTypes["PointOfSalePrinterUpdateTicketCategoriesRelationInput"] | undefined | null,
	upsert?: ValueTypes["PointOfSalePrinterUpsertTicketCategoriesRelationInput"] | undefined | null,
	connect?: ValueTypes["PointOfSaleCategoryUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["PointOfSaleCategoryUniqueWhere"] | undefined | null,
	delete?: ValueTypes["PointOfSaleCategoryUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PointOfSalePrinterUpdateTicketCategoriesRelationInput"]: {
	by?: ValueTypes["PointOfSaleCategoryUniqueWhere"] | undefined | null,
	data?: ValueTypes["PointOfSaleCategoryWithoutTicketPrintersUpdateInput"] | undefined | null
};
	["PointOfSaleCategoryWithoutTicketPrintersUpdateInput"]: {
	order?: number | undefined | null,
	slug?: string | undefined | null,
	locales?: Array<ValueTypes["PointOfSaleCategoryUpdateLocalesEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["PointOfSaleCategoryUpdateProductsEntityRelationInput"]> | undefined | null,
	category?: ValueTypes["PointOfSaleCategoryUpdateCategoryEntityRelationInput"] | undefined | null,
	venue?: ValueTypes["PointOfSaleCategoryUpdateVenueEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleCategoryUpdateVenueEntityRelationInput"]: {
	create?: ValueTypes["VenueWithoutCategoriesCreateInput"] | undefined | null,
	update?: ValueTypes["VenueWithoutCategoriesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["PointOfSaleCategoryUpsertVenueRelationInput"] | undefined | null,
	connect?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["VenueWithoutCategoriesUpdateInput"]: {
	name?: string | undefined | null,
	deadlineTemplate?: ValueTypes["VenueUpdateDeadlineTemplateEntityRelationInput"] | undefined | null,
	timetableDays?: Array<ValueTypes["VenueUpdateTimetableDaysEntityRelationInput"]> | undefined | null,
	timetableTemplates?: Array<ValueTypes["VenueUpdateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	staffMembers?: Array<ValueTypes["VenueUpdateStaffMembersEntityRelationInput"]> | undefined | null,
	employeeRoles?: Array<ValueTypes["VenueUpdateEmployeeRolesEntityRelationInput"]> | undefined | null,
	pointOfSaleApplicationDevices?: Array<ValueTypes["VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined | null,
	pointOfSaleTerminals?: Array<ValueTypes["VenueUpdatePointOfSaleTerminalsEntityRelationInput"]> | undefined | null,
	pointOfSalePrinters?: Array<ValueTypes["VenueUpdatePointOfSalePrintersEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["VenueUpdateOrdersEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["VenueUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	areas?: Array<ValueTypes["VenueUpdateAreasEntityRelationInput"]> | undefined | null,
	enabledUnassignReasons?: Array<ValueTypes["VenueUpdateEnabledUnassignReasonsEntityRelationInput"]> | undefined | null,
	channels?: Array<ValueTypes["VenueUpdateChannelsEntityRelationInput"]> | undefined | null,
	address?: string | undefined | null,
	pointOfSalePngBase64ReceiptLogo?: string | undefined | null,
	pointOfSaleInitialView?: ValueTypes["PointOfSaleInitialView"] | undefined | null,
	pointOfSalePreferPrintReceipt?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleCategoryUpsertVenueRelationInput"]: {
	update?: ValueTypes["VenueWithoutCategoriesUpdateInput"] | undefined | null,
	create?: ValueTypes["VenueWithoutCategoriesCreateInput"] | undefined | null
};
	["PointOfSalePrinterUpsertTicketCategoriesRelationInput"]: {
	by?: ValueTypes["PointOfSaleCategoryUniqueWhere"] | undefined | null,
	update?: ValueTypes["PointOfSaleCategoryWithoutTicketPrintersUpdateInput"] | undefined | null,
	create?: ValueTypes["PointOfSaleCategoryWithoutTicketPrintersCreateInput"] | undefined | null
};
	["PointOfSaleApplicationDeviceUpsertReceiptPrinterRelationInput"]: {
	update?: ValueTypes["PointOfSalePrinterWithoutApplicationDevicesReceiptUpdateInput"] | undefined | null,
	create?: ValueTypes["PointOfSalePrinterWithoutApplicationDevicesReceiptCreateInput"] | undefined | null
};
	["PointOfSalePrinterUpsertApplicationDevicesTicketRelationInput"]: {
	by?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null,
	update?: ValueTypes["PointOfSaleApplicationDeviceWithoutTicketPrintersUpdateInput"] | undefined | null,
	create?: ValueTypes["PointOfSaleApplicationDeviceWithoutTicketPrintersCreateInput"] | undefined | null
};
	["PointOfSaleCategoryUpsertTicketPrintersRelationInput"]: {
	by?: ValueTypes["PointOfSalePrinterUniqueWhere"] | undefined | null,
	update?: ValueTypes["PointOfSalePrinterWithoutTicketCategoriesUpdateInput"] | undefined | null,
	create?: ValueTypes["PointOfSalePrinterWithoutTicketCategoriesCreateInput"] | undefined | null
};
	["VenueUpsertCategoriesRelationInput"]: {
	by?: ValueTypes["PointOfSaleCategoryUniqueWhere"] | undefined | null,
	update?: ValueTypes["PointOfSaleCategoryWithoutVenueUpdateInput"] | undefined | null,
	create?: ValueTypes["PointOfSaleCategoryWithoutVenueCreateInput"] | undefined | null
};
	["AreaUpsertVenueRelationInput"]: {
	update?: ValueTypes["VenueWithoutAreasUpdateInput"] | undefined | null,
	create?: ValueTypes["VenueWithoutAreasCreateInput"] | undefined | null
};
	["TableUpsertAreaRelationInput"]: {
	update?: ValueTypes["AreaWithoutTablesUpdateInput"] | undefined | null,
	create?: ValueTypes["AreaWithoutTablesCreateInput"] | undefined | null
};
	["CustomerTabUpsertTableRelationInput"]: {
	update?: ValueTypes["TableWithoutCustomerTabsUpdateInput"] | undefined | null,
	create?: ValueTypes["TableWithoutCustomerTabsCreateInput"] | undefined | null
};
	["CustomerUpsertCustomerTabsRelationInput"]: {
	by?: ValueTypes["CustomerTabUniqueWhere"] | undefined | null,
	update?: ValueTypes["CustomerTabWithoutCustomerUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerTabWithoutCustomerCreateInput"] | undefined | null
};
	["VoucherRedemptionUpsertCustomerRelationInput"]: {
	update?: ValueTypes["CustomerWithoutRedeemedVouchersUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerWithoutRedeemedVouchersCreateInput"] | undefined | null
};
	["VoucherUpsertRedemptionRelationInput"]: {
	update?: ValueTypes["VoucherRedemptionWithoutVoucherUpdateInput"] | undefined | null,
	create?: ValueTypes["VoucherRedemptionWithoutVoucherCreateInput"] | undefined | null
};
	["CustomerUpsertOwnsVouchersRelationInput"]: {
	by?: ValueTypes["VoucherUniqueWhere"] | undefined | null,
	update?: ValueTypes["VoucherWithoutOwnerUpdateInput"] | undefined | null,
	create?: ValueTypes["VoucherWithoutOwnerCreateInput"] | undefined | null
};
	["VoucherUpsertBuyerRelationInput"]: {
	update?: ValueTypes["CustomerWithoutBoughtVouchersUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerWithoutBoughtVouchersCreateInput"] | undefined | null
};
	["VirtualProductEffectUpsertResultVouchersRelationInput"]: {
	by?: ValueTypes["VoucherUniqueWhere"] | undefined | null,
	update?: ValueTypes["VoucherWithoutVirtualProductEffectUpdateInput"] | undefined | null,
	create?: ValueTypes["VoucherWithoutVirtualProductEffectCreateInput"] | undefined | null
};
	["CustomerCreditTransactionUpsertVirtualProductEffectRelationInput"]: {
	update?: ValueTypes["VirtualProductEffectWithoutResultCustomerCreditTransactionUpdateInput"] | undefined | null,
	create?: ValueTypes["VirtualProductEffectWithoutResultCustomerCreditTransactionCreateInput"] | undefined | null
};
	["CustomerCreditUpsertTransactionsRelationInput"]: {
	by?: ValueTypes["CustomerCreditTransactionUniqueWhere"] | undefined | null,
	update?: ValueTypes["CustomerCreditTransactionWithoutCustomerCreditUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerCreditTransactionWithoutCustomerCreditCreateInput"] | undefined | null
};
	["VoucherRedemptionUpsertCustomerCreditRelationInput"]: {
	update?: ValueTypes["CustomerCreditWithoutVoucherRedemptionUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerCreditWithoutVoucherRedemptionCreateInput"] | undefined | null
};
	["VoucherRedemptionUpdateVoucherEntityRelationInput"]: {
	create?: ValueTypes["VoucherWithoutRedemptionCreateInput"] | undefined | null,
	update?: ValueTypes["VoucherWithoutRedemptionUpdateInput"] | undefined | null,
	upsert?: ValueTypes["VoucherRedemptionUpsertVoucherRelationInput"] | undefined | null,
	connect?: ValueTypes["VoucherUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["VoucherWithoutRedemptionUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	activatedAt?: ValueTypes["DateTime"] | undefined | null,
	expiresAt?: ValueTypes["DateTime"] | undefined | null,
	internalNote?: string | undefined | null,
	note?: string | undefined | null,
	code?: string | undefined | null,
	type?: ValueTypes["VoucherType"] | undefined | null,
	creditCents?: number | undefined | null,
	buyer?: ValueTypes["VoucherUpdateBuyerEntityRelationInput"] | undefined | null,
	owner?: ValueTypes["VoucherUpdateOwnerEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["VoucherUpdateVatRateEntityRelationInput"] | undefined | null,
	virtualProductEffect?: ValueTypes["VoucherUpdateVirtualProductEffectEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VoucherRedemptionUpsertVoucherRelationInput"]: {
	update?: ValueTypes["VoucherWithoutRedemptionUpdateInput"] | undefined | null,
	create?: ValueTypes["VoucherWithoutRedemptionCreateInput"] | undefined | null
};
	["CustomerUpsertRedeemedVouchersRelationInput"]: {
	by?: ValueTypes["VoucherRedemptionUniqueWhere"] | undefined | null,
	update?: ValueTypes["VoucherRedemptionWithoutCustomerUpdateInput"] | undefined | null,
	create?: ValueTypes["VoucherRedemptionWithoutCustomerCreateInput"] | undefined | null
};
	["VoucherUpsertOwnerRelationInput"]: {
	update?: ValueTypes["CustomerWithoutOwnsVouchersUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerWithoutOwnsVouchersCreateInput"] | undefined | null
};
	["CustomerUpsertBoughtVouchersRelationInput"]: {
	by?: ValueTypes["VoucherUniqueWhere"] | undefined | null,
	update?: ValueTypes["VoucherWithoutBuyerUpdateInput"] | undefined | null,
	create?: ValueTypes["VoucherWithoutBuyerCreateInput"] | undefined | null
};
	["BillingSubjectUpsertDefaultBillingSubjectOfCustomerRelationInput"]: {
	update?: ValueTypes["CustomerWithoutDefaultBillingSubjectUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerWithoutDefaultBillingSubjectCreateInput"] | undefined | null
};
	["OrderUpsertBillingSubjectRelationInput"]: {
	update?: ValueTypes["BillingSubjectWithoutOrdersUpdateInput"] | undefined | null,
	create?: ValueTypes["BillingSubjectWithoutOrdersCreateInput"] | undefined | null
};
	["FulfillmentNoteUpsertOrdersRelationInput"]: {
	by?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	update?: ValueTypes["OrderWithoutFulfillmentNotesUpdateInput"] | undefined | null,
	create?: ValueTypes["OrderWithoutFulfillmentNotesCreateInput"] | undefined | null
};
	["VenueUpsertFulfillmentNotesRelationInput"]: {
	by?: ValueTypes["FulfillmentNoteUniqueWhere"] | undefined | null,
	update?: ValueTypes["FulfillmentNoteWithoutVenuesUpdateInput"] | undefined | null,
	create?: ValueTypes["FulfillmentNoteWithoutVenuesCreateInput"] | undefined | null
};
	["OrderUpsertVenueRelationInput"]: {
	update?: ValueTypes["VenueWithoutOrdersUpdateInput"] | undefined | null,
	create?: ValueTypes["VenueWithoutOrdersCreateInput"] | undefined | null
};
	["OrderUpdateFulfillmentNotesEntityRelationInput"]: {
	create?: ValueTypes["FulfillmentNoteWithoutOrdersCreateInput"] | undefined | null,
	update?: ValueTypes["OrderUpdateFulfillmentNotesRelationInput"] | undefined | null,
	upsert?: ValueTypes["OrderUpsertFulfillmentNotesRelationInput"] | undefined | null,
	connect?: ValueTypes["FulfillmentNoteUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["FulfillmentNoteUniqueWhere"] | undefined | null,
	delete?: ValueTypes["FulfillmentNoteUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["OrderUpdateFulfillmentNotesRelationInput"]: {
	by?: ValueTypes["FulfillmentNoteUniqueWhere"] | undefined | null,
	data?: ValueTypes["FulfillmentNoteWithoutOrdersUpdateInput"] | undefined | null
};
	["FulfillmentNoteWithoutOrdersUpdateInput"]: {
	note?: string | undefined | null,
	products?: Array<ValueTypes["FulfillmentNoteUpdateProductsEntityRelationInput"]> | undefined | null,
	tags?: Array<ValueTypes["FulfillmentNoteUpdateTagsEntityRelationInput"]> | undefined | null,
	venues?: Array<ValueTypes["FulfillmentNoteUpdateVenuesEntityRelationInput"]> | undefined | null,
	cartItems?: Array<ValueTypes["FulfillmentNoteUpdateCartItemsEntityRelationInput"]> | undefined | null,
	orderItems?: Array<ValueTypes["FulfillmentNoteUpdateOrderItemsEntityRelationInput"]> | undefined | null,
	highlight?: boolean | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	emoji?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderUpsertFulfillmentNotesRelationInput"]: {
	by?: ValueTypes["FulfillmentNoteUniqueWhere"] | undefined | null,
	update?: ValueTypes["FulfillmentNoteWithoutOrdersUpdateInput"] | undefined | null,
	create?: ValueTypes["FulfillmentNoteWithoutOrdersCreateInput"] | undefined | null
};
	["BillingSubjectUpsertOrdersRelationInput"]: {
	by?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	update?: ValueTypes["OrderWithoutBillingSubjectUpdateInput"] | undefined | null,
	create?: ValueTypes["OrderWithoutBillingSubjectCreateInput"] | undefined | null
};
	["CustomerUpsertDefaultBillingSubjectRelationInput"]: {
	update?: ValueTypes["BillingSubjectWithoutDefaultBillingSubjectOfCustomerUpdateInput"] | undefined | null,
	create?: ValueTypes["BillingSubjectWithoutDefaultBillingSubjectOfCustomerCreateInput"] | undefined | null
};
	["BillingSubjectUpsertCustomerRelationInput"]: {
	update?: ValueTypes["CustomerWithoutBillingSubjectsUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerWithoutBillingSubjectsCreateInput"] | undefined | null
};
	["InvoiceUpsertBillingSubjectRelationInput"]: {
	update?: ValueTypes["BillingSubjectWithoutInvoicesUpdateInput"] | undefined | null,
	create?: ValueTypes["BillingSubjectWithoutInvoicesCreateInput"] | undefined | null
};
	["OrderPaymentUpsertInvoiceRelationInput"]: {
	update?: ValueTypes["InvoiceWithoutOrderPaymentsUpdateInput"] | undefined | null,
	create?: ValueTypes["InvoiceWithoutOrderPaymentsCreateInput"] | undefined | null
};
	["OrderPaymentUpdateVatRateEntityRelationInput"]: {
	create?: ValueTypes["VatRateCreateInput"] | undefined | null,
	update?: ValueTypes["VatRateUpdateInput"] | undefined | null,
	upsert?: ValueTypes["OrderPaymentUpsertVatRateRelationInput"] | undefined | null,
	connect?: ValueTypes["VatRateUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["OrderPaymentUpsertVatRateRelationInput"]: {
	update?: ValueTypes["VatRateUpdateInput"] | undefined | null,
	create?: ValueTypes["VatRateCreateInput"] | undefined | null
};
	["OrderPaymentUpdateMetaEntityRelationInput"]: {
	connect?: ValueTypes["OrderPaymentMetadataUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["OrderUpsertPaymentsRelationInput"]: {
	by?: ValueTypes["OrderPaymentUniqueWhere"] | undefined | null,
	update?: ValueTypes["OrderPaymentWithoutOrderUpdateInput"] | undefined | null,
	create?: ValueTypes["OrderPaymentWithoutOrderCreateInput"] | undefined | null
};
	["OrderDeliveryUpsertOrderRelationInput"]: {
	update?: ValueTypes["OrderWithoutDeliveryUpdateInput"] | undefined | null,
	create?: ValueTypes["OrderWithoutDeliveryCreateInput"] | undefined | null
};
	["OrderDeliveryUpdateEventsEntityRelationInput"]: {
	create?: ValueTypes["OrderEventWithoutDeliveryCreateInput"] | undefined | null,
	update?: ValueTypes["OrderDeliveryUpdateEventsRelationInput"] | undefined | null,
	upsert?: ValueTypes["OrderDeliveryUpsertEventsRelationInput"] | undefined | null,
	connect?: ValueTypes["OrderEventUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["OrderEventUniqueWhere"] | undefined | null,
	delete?: ValueTypes["OrderEventUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["OrderDeliveryUpdateEventsRelationInput"]: {
	by?: ValueTypes["OrderEventUniqueWhere"] | undefined | null,
	data?: ValueTypes["OrderEventWithoutDeliveryUpdateInput"] | undefined | null
};
	["OrderEventWithoutDeliveryUpdateInput"]: {
	type?: string | undefined | null,
	data?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	order?: ValueTypes["OrderEventUpdateOrderEntityRelationInput"] | undefined | null,
	payment?: ValueTypes["OrderEventUpdatePaymentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderDeliveryUpsertEventsRelationInput"]: {
	by?: ValueTypes["OrderEventUniqueWhere"] | undefined | null,
	update?: ValueTypes["OrderEventWithoutDeliveryUpdateInput"] | undefined | null,
	create?: ValueTypes["OrderEventWithoutDeliveryCreateInput"] | undefined | null
};
	["OrderDeliveryUpdateLiftagoRideEntityRelationInput"]: {
	create?: ValueTypes["LiftagoRideWithoutDeliveryCreateInput"] | undefined | null,
	update?: ValueTypes["LiftagoRideWithoutDeliveryUpdateInput"] | undefined | null,
	upsert?: ValueTypes["OrderDeliveryUpsertLiftagoRideRelationInput"] | undefined | null,
	connect?: ValueTypes["LiftagoRideUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["LiftagoRideWithoutDeliveryUpdateInput"]: {
	liftagoId?: string | undefined | null,
	data?: string | undefined | null,
	updatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderDeliveryUpsertLiftagoRideRelationInput"]: {
	update?: ValueTypes["LiftagoRideWithoutDeliveryUpdateInput"] | undefined | null,
	create?: ValueTypes["LiftagoRideWithoutDeliveryCreateInput"] | undefined | null
};
	["OrderDeliveryUpdateWoltDriveDeliveryEntityRelationInput"]: {
	create?: ValueTypes["WoltDriveDeliveryWithoutDeliveryCreateInput"] | undefined | null,
	update?: ValueTypes["WoltDriveDeliveryWithoutDeliveryUpdateInput"] | undefined | null,
	upsert?: ValueTypes["OrderDeliveryUpsertWoltDriveDeliveryRelationInput"] | undefined | null,
	connect?: ValueTypes["WoltDriveDeliveryUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["WoltDriveDeliveryWithoutDeliveryUpdateInput"]: {
	state?: ValueTypes["WoltDriveDeliveryState"] | undefined | null,
	shipmentPromiseId?: string | undefined | null,
	deliveryPrice?: number | undefined | null,
	deliveryPriceCurrency?: string | undefined | null,
	shipmentPromiseResponse?: string | undefined | null,
	deliveryOrderId?: string | undefined | null,
	trackingUrl?: string | undefined | null,
	deliverOrderResponse?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderDeliveryUpsertWoltDriveDeliveryRelationInput"]: {
	update?: ValueTypes["WoltDriveDeliveryWithoutDeliveryUpdateInput"] | undefined | null,
	create?: ValueTypes["WoltDriveDeliveryWithoutDeliveryCreateInput"] | undefined | null
};
	["AddressUpsertDeliveryAddressOfOrderDeliveriesRelationInput"]: {
	by?: ValueTypes["OrderDeliveryUniqueWhere"] | undefined | null,
	update?: ValueTypes["OrderDeliveryWithoutAddressUpdateInput"] | undefined | null,
	create?: ValueTypes["OrderDeliveryWithoutAddressCreateInput"] | undefined | null
};
	["AddressUpdateDefaultDeliveryAddressOfCustomerEntityRelationInput"]: {
	create?: ValueTypes["CustomerWithoutDefaultDeliveryAddressCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerWithoutDefaultDeliveryAddressUpdateInput"] | undefined | null,
	upsert?: ValueTypes["AddressUpsertDefaultDeliveryAddressOfCustomerRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CustomerWithoutDefaultDeliveryAddressUpdateInput"]: {
	addresses?: Array<ValueTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerUpdateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerUpdateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerUpdateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerUpdateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AddressUpsertDefaultDeliveryAddressOfCustomerRelationInput"]: {
	update?: ValueTypes["CustomerWithoutDefaultDeliveryAddressUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerWithoutDefaultDeliveryAddressCreateInput"] | undefined | null
};
	["OrderUpsertBillingAddressRelationInput"]: {
	update?: ValueTypes["AddressWithoutBillingAddressOfOrdersUpdateInput"] | undefined | null,
	create?: ValueTypes["AddressWithoutBillingAddressOfOrdersCreateInput"] | undefined | null
};
	["OrderPaymentUpsertOrderRelationInput"]: {
	update?: ValueTypes["OrderWithoutPaymentsUpdateInput"] | undefined | null,
	create?: ValueTypes["OrderWithoutPaymentsCreateInput"] | undefined | null
};
	["OrderEventUpsertPaymentRelationInput"]: {
	update?: ValueTypes["OrderPaymentWithoutEventsUpdateInput"] | undefined | null,
	create?: ValueTypes["OrderPaymentWithoutEventsCreateInput"] | undefined | null
};
	["OrderEventUpdateDeliveryEntityRelationInput"]: {
	create?: ValueTypes["OrderDeliveryWithoutEventsCreateInput"] | undefined | null,
	update?: ValueTypes["OrderDeliveryWithoutEventsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["OrderEventUpsertDeliveryRelationInput"] | undefined | null,
	connect?: ValueTypes["OrderDeliveryUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["OrderDeliveryWithoutEventsUpdateInput"]: {
	priceCents?: number | undefined | null,
	deliveredAt?: ValueTypes["DateTime"] | undefined | null,
	method?: ValueTypes["OrderDeliveryUpdateMethodEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["OrderDeliveryUpdateVatRateEntityRelationInput"] | undefined | null,
	order?: ValueTypes["OrderDeliveryUpdateOrderEntityRelationInput"] | undefined | null,
	expectedAt?: ValueTypes["DateTime"] | undefined | null,
	state?: ValueTypes["OrderDeliveryState"] | undefined | null,
	loadingDurationHours?: number | undefined | null,
	dispatchAt?: ValueTypes["DateTime"] | undefined | null,
	duration?: string | undefined | null,
	window?: string | undefined | null,
	expectedEndAt?: ValueTypes["DateTime"] | undefined | null,
	processingAt?: ValueTypes["DateTime"] | undefined | null,
	deliveringAt?: ValueTypes["DateTime"] | undefined | null,
	failedAt?: ValueTypes["DateTime"] | undefined | null,
	internalNote?: string | undefined | null,
	deliveryWaypoint?: ValueTypes["OrderDeliveryUpdateDeliveryWaypointEntityRelationInput"] | undefined | null,
	prepareAt?: ValueTypes["DateTime"] | undefined | null,
	liftagoRide?: ValueTypes["OrderDeliveryUpdateLiftagoRideEntityRelationInput"] | undefined | null,
	pickedAt?: ValueTypes["DateTime"] | undefined | null,
	address?: ValueTypes["OrderDeliveryUpdateAddressEntityRelationInput"] | undefined | null,
	trackingCode?: string | undefined | null,
	woltDriveDelivery?: ValueTypes["OrderDeliveryUpdateWoltDriveDeliveryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderDeliveryUpdateAddressEntityRelationInput"]: {
	create?: ValueTypes["AddressWithoutDeliveryAddressOfOrderDeliveriesCreateInput"] | undefined | null,
	update?: ValueTypes["AddressWithoutDeliveryAddressOfOrderDeliveriesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["OrderDeliveryUpsertAddressRelationInput"] | undefined | null,
	connect?: ValueTypes["AddressUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["AddressWithoutDeliveryAddressOfOrderDeliveriesUpdateInput"]: {
	name?: string | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	addressLine2?: string | undefined | null,
	email?: string | undefined | null,
	phone?: string | undefined | null,
	companyName?: string | undefined | null,
	companyIdentifier?: string | undefined | null,
	vatIdentifier?: string | undefined | null,
	externalIdentifier?: string | undefined | null,
	hidden?: boolean | undefined | null,
	customer?: ValueTypes["AddressUpdateCustomerEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	country?: ValueTypes["AddressUpdateCountryEntityRelationInput"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	googlePlaceId?: string | undefined | null,
	raw?: string | undefined | null,
	formatted?: string | undefined | null,
	geocodeGeneratedAt?: ValueTypes["DateTime"] | undefined | null,
	geocodeResponse?: string | undefined | null,
	deliveryZone?: ValueTypes["AddressUpdateDeliveryZoneEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["AddressUpdateMetaEntityRelationInput"] | undefined | null,
	gps?: ValueTypes["AddressUpdateGpsEntityRelationInput"] | undefined | null,
	geocodeValid?: boolean | undefined | null,
	fullName?: string | undefined | null,
	fakturoidSubjectId?: string | undefined | null,
	invoices?: Array<ValueTypes["AddressUpdateInvoicesEntityRelationInput"]> | undefined | null,
	addressLine1?: string | undefined | null,
	city?: string | undefined | null,
	postalCode?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingAddressOfOrders?: Array<ValueTypes["AddressUpdateBillingAddressOfOrdersEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddressOfCustomer?: ValueTypes["AddressUpdateDefaultDeliveryAddressOfCustomerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderDeliveryUpsertAddressRelationInput"]: {
	update?: ValueTypes["AddressWithoutDeliveryAddressOfOrderDeliveriesUpdateInput"] | undefined | null,
	create?: ValueTypes["AddressWithoutDeliveryAddressOfOrderDeliveriesCreateInput"] | undefined | null
};
	["OrderEventUpsertDeliveryRelationInput"]: {
	update?: ValueTypes["OrderDeliveryWithoutEventsUpdateInput"] | undefined | null,
	create?: ValueTypes["OrderDeliveryWithoutEventsCreateInput"] | undefined | null
};
	["OrderUpsertEventsRelationInput"]: {
	by?: ValueTypes["OrderEventUniqueWhere"] | undefined | null,
	update?: ValueTypes["OrderEventWithoutOrderUpdateInput"] | undefined | null,
	create?: ValueTypes["OrderEventWithoutOrderCreateInput"] | undefined | null
};
	["AddressUpsertBillingAddressOfOrdersRelationInput"]: {
	by?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	update?: ValueTypes["OrderWithoutBillingAddressUpdateInput"] | undefined | null,
	create?: ValueTypes["OrderWithoutBillingAddressCreateInput"] | undefined | null
};
	["InvoiceUpsertAddressRelationInput"]: {
	update?: ValueTypes["AddressWithoutInvoicesUpdateInput"] | undefined | null,
	create?: ValueTypes["AddressWithoutInvoicesCreateInput"] | undefined | null
};
	["BillingSubjectUpsertInvoicesRelationInput"]: {
	by?: ValueTypes["InvoiceUniqueWhere"] | undefined | null,
	update?: ValueTypes["InvoiceWithoutBillingSubjectUpdateInput"] | undefined | null,
	create?: ValueTypes["InvoiceWithoutBillingSubjectCreateInput"] | undefined | null
};
	["CustomerUpsertBillingSubjectsRelationInput"]: {
	by?: ValueTypes["BillingSubjectUniqueWhere"] | undefined | null,
	update?: ValueTypes["BillingSubjectWithoutCustomerUpdateInput"] | undefined | null,
	create?: ValueTypes["BillingSubjectWithoutCustomerCreateInput"] | undefined | null
};
	["CartUpsertCustomerRelationInput"]: {
	update?: ValueTypes["CustomerWithoutCartsUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerWithoutCartsCreateInput"] | undefined | null
};
	["CartUpdateDeliveryAddressEntityRelationInput"]: {
	create?: ValueTypes["AddressCreateInput"] | undefined | null,
	update?: ValueTypes["AddressUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CartUpsertDeliveryAddressRelationInput"] | undefined | null,
	connect?: ValueTypes["AddressUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CartUpsertDeliveryAddressRelationInput"]: {
	update?: ValueTypes["AddressUpdateInput"] | undefined | null,
	create?: ValueTypes["AddressCreateInput"] | undefined | null
};
	["CartUpdateBillingAddressEntityRelationInput"]: {
	create?: ValueTypes["AddressCreateInput"] | undefined | null,
	update?: ValueTypes["AddressUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CartUpsertBillingAddressRelationInput"] | undefined | null,
	connect?: ValueTypes["AddressUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CartUpsertBillingAddressRelationInput"]: {
	update?: ValueTypes["AddressUpdateInput"] | undefined | null,
	create?: ValueTypes["AddressCreateInput"] | undefined | null
};
	["CartUpdateDeliveryEntityRelationInput"]: {
	create?: ValueTypes["ChannelDeliveryCreateInput"] | undefined | null,
	update?: ValueTypes["ChannelDeliveryUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CartUpsertDeliveryRelationInput"] | undefined | null,
	connect?: ValueTypes["ChannelDeliveryUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ChannelDeliveryUpdateInput"]: {
	order?: number | undefined | null,
	priceCents?: number | undefined | null,
	channel?: ValueTypes["ChannelDeliveryUpdateChannelEntityRelationInput"] | undefined | null,
	method?: ValueTypes["ChannelDeliveryUpdateMethodEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["ChannelDeliveryUpdateVatRateEntityRelationInput"] | undefined | null,
	defaultVisible?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CartUpsertDeliveryRelationInput"]: {
	update?: ValueTypes["ChannelDeliveryUpdateInput"] | undefined | null,
	create?: ValueTypes["ChannelDeliveryCreateInput"] | undefined | null
};
	["CartUpdatePaymentEntityRelationInput"]: {
	create?: ValueTypes["ChannelPaymentCreateInput"] | undefined | null,
	update?: ValueTypes["ChannelPaymentUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CartUpsertPaymentRelationInput"] | undefined | null,
	connect?: ValueTypes["ChannelPaymentUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ChannelPaymentUpdateInput"]: {
	order?: number | undefined | null,
	channel?: ValueTypes["ChannelPaymentUpdateChannelEntityRelationInput"] | undefined | null,
	method?: ValueTypes["ChannelPaymentUpdateMethodEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["ChannelPaymentUpdateVatRateEntityRelationInput"] | undefined | null,
	requireBillingAddress?: boolean | undefined | null,
	provideReceipt?: boolean | undefined | null,
	requireBillingSubject?: boolean | undefined | null,
	allowOnlyForTags?: Array<ValueTypes["ChannelPaymentUpdateAllowOnlyForTagsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CartUpsertPaymentRelationInput"]: {
	update?: ValueTypes["ChannelPaymentUpdateInput"] | undefined | null,
	create?: ValueTypes["ChannelPaymentCreateInput"] | undefined | null
};
	["CartUpdateBillingSubjectEntityRelationInput"]: {
	create?: ValueTypes["BillingSubjectCreateInput"] | undefined | null,
	update?: ValueTypes["BillingSubjectUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CartUpsertBillingSubjectRelationInput"] | undefined | null,
	connect?: ValueTypes["BillingSubjectUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["BillingSubjectUpdateInput"]: {
	name?: string | undefined | null,
	fullName?: string | undefined | null,
	addressLine1?: string | undefined | null,
	addressLine2?: string | undefined | null,
	city?: string | undefined | null,
	postalCode?: string | undefined | null,
	email?: string | undefined | null,
	phone?: string | undefined | null,
	companyName?: string | undefined | null,
	companyIdentifier?: string | undefined | null,
	vatIdentifier?: string | undefined | null,
	externalIdentifier?: string | undefined | null,
	hidden?: boolean | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	internalNote?: string | undefined | null,
	fakturoidSubjectId?: string | undefined | null,
	country?: ValueTypes["BillingSubjectUpdateCountryEntityRelationInput"] | undefined | null,
	customer?: ValueTypes["BillingSubjectUpdateCustomerEntityRelationInput"] | undefined | null,
	invoices?: Array<ValueTypes["BillingSubjectUpdateInvoicesEntityRelationInput"]> | undefined | null,
	defaultBillingSubjectOfCustomer?: ValueTypes["BillingSubjectUpdateDefaultBillingSubjectOfCustomerEntityRelationInput"] | undefined | null,
	orders?: Array<ValueTypes["BillingSubjectUpdateOrdersEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CartUpsertBillingSubjectRelationInput"]: {
	update?: ValueTypes["BillingSubjectUpdateInput"] | undefined | null,
	create?: ValueTypes["BillingSubjectCreateInput"] | undefined | null
};
	["CartUpdatePriceLinesEntityRelationInput"]: {
	connect?: ValueTypes["CartPriceLineUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["CartPriceLineUniqueWhere"] | undefined | null,
	delete?: ValueTypes["CartPriceLineUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CartUpdateSummaryEntityRelationInput"]: {
	connect?: ValueTypes["CartSummaryUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["OrderUpsertCartRelationInput"]: {
	update?: ValueTypes["CartWithoutOrderUpdateInput"] | undefined | null,
	create?: ValueTypes["CartWithoutOrderCreateInput"] | undefined | null
};
	["OrderDiscountUpsertOrderRelationInput"]: {
	update?: ValueTypes["OrderWithoutDiscountsUpdateInput"] | undefined | null,
	create?: ValueTypes["OrderWithoutDiscountsCreateInput"] | undefined | null
};
	["OrderDiscountUpdateVoucherRedemptionEntityRelationInput"]: {
	create?: ValueTypes["VoucherRedemptionWithoutOrderDiscountCreateInput"] | undefined | null,
	update?: ValueTypes["VoucherRedemptionWithoutOrderDiscountUpdateInput"] | undefined | null,
	upsert?: ValueTypes["OrderDiscountUpsertVoucherRedemptionRelationInput"] | undefined | null,
	connect?: ValueTypes["VoucherRedemptionUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["VoucherRedemptionWithoutOrderDiscountUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	manualRedemptionNote?: string | undefined | null,
	customerCredit?: ValueTypes["VoucherRedemptionUpdateCustomerCreditEntityRelationInput"] | undefined | null,
	voucher?: ValueTypes["VoucherRedemptionUpdateVoucherEntityRelationInput"] | undefined | null,
	customer?: ValueTypes["VoucherRedemptionUpdateCustomerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderDiscountUpsertVoucherRedemptionRelationInput"]: {
	update?: ValueTypes["VoucherRedemptionWithoutOrderDiscountUpdateInput"] | undefined | null,
	create?: ValueTypes["VoucherRedemptionWithoutOrderDiscountCreateInput"] | undefined | null
};
	["CustomerCreditTransactionUpsertOrderDiscountRelationInput"]: {
	update?: ValueTypes["OrderDiscountWithoutCustomerCreditTransactionsUpdateInput"] | undefined | null,
	create?: ValueTypes["OrderDiscountWithoutCustomerCreditTransactionsCreateInput"] | undefined | null
};
	["VirtualProductEffectUpsertResultCustomerCreditTransactionRelationInput"]: {
	update?: ValueTypes["CustomerCreditTransactionWithoutVirtualProductEffectUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerCreditTransactionWithoutVirtualProductEffectCreateInput"] | undefined | null
};
	["OrderItemUpsertVirtualProductEffectsRelationInput"]: {
	by?: ValueTypes["VirtualProductEffectUniqueWhere"] | undefined | null,
	update?: ValueTypes["VirtualProductEffectWithoutOrderItemUpdateInput"] | undefined | null,
	create?: ValueTypes["VirtualProductEffectWithoutOrderItemCreateInput"] | undefined | null
};
	["OrderUpsertItemsRelationInput"]: {
	by?: ValueTypes["OrderItemUniqueWhere"] | undefined | null,
	update?: ValueTypes["OrderItemWithoutOrderUpdateInput"] | undefined | null,
	create?: ValueTypes["OrderItemWithoutOrderCreateInput"] | undefined | null
};
	["VenueUpsertOrdersRelationInput"]: {
	by?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	update?: ValueTypes["OrderWithoutVenueUpdateInput"] | undefined | null,
	create?: ValueTypes["OrderWithoutVenueCreateInput"] | undefined | null
};
	["PointOfSaleTerminalUpsertVenueRelationInput"]: {
	update?: ValueTypes["VenueWithoutPointOfSaleTerminalsUpdateInput"] | undefined | null,
	create?: ValueTypes["VenueWithoutPointOfSaleTerminalsCreateInput"] | undefined | null
};
	["PointOfSaleApplicationDeviceUpsertTerminalRelationInput"]: {
	update?: ValueTypes["PointOfSaleTerminalWithoutApplicationDevicesUpdateInput"] | undefined | null,
	create?: ValueTypes["PointOfSaleTerminalWithoutApplicationDevicesCreateInput"] | undefined | null
};
	["PointOfSaleApplicationDeviceUpdateTicketPrintersEntityRelationInput"]: {
	create?: ValueTypes["PointOfSalePrinterWithoutApplicationDevicesTicketCreateInput"] | undefined | null,
	update?: ValueTypes["PointOfSaleApplicationDeviceUpdateTicketPrintersRelationInput"] | undefined | null,
	upsert?: ValueTypes["PointOfSaleApplicationDeviceUpsertTicketPrintersRelationInput"] | undefined | null,
	connect?: ValueTypes["PointOfSalePrinterUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["PointOfSalePrinterUniqueWhere"] | undefined | null,
	delete?: ValueTypes["PointOfSalePrinterUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PointOfSaleApplicationDeviceUpdateTicketPrintersRelationInput"]: {
	by?: ValueTypes["PointOfSalePrinterUniqueWhere"] | undefined | null,
	data?: ValueTypes["PointOfSalePrinterWithoutApplicationDevicesTicketUpdateInput"] | undefined | null
};
	["PointOfSalePrinterWithoutApplicationDevicesTicketUpdateInput"]: {
	internalName?: string | undefined | null,
	note?: string | undefined | null,
	ipAddress?: string | undefined | null,
	applicationDevicesReceipt?: Array<ValueTypes["PointOfSalePrinterUpdateApplicationDevicesReceiptEntityRelationInput"]> | undefined | null,
	venue?: ValueTypes["PointOfSalePrinterUpdateVenueEntityRelationInput"] | undefined | null,
	ticketCategories?: Array<ValueTypes["PointOfSalePrinterUpdateTicketCategoriesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleApplicationDeviceUpsertTicketPrintersRelationInput"]: {
	by?: ValueTypes["PointOfSalePrinterUniqueWhere"] | undefined | null,
	update?: ValueTypes["PointOfSalePrinterWithoutApplicationDevicesTicketUpdateInput"] | undefined | null,
	create?: ValueTypes["PointOfSalePrinterWithoutApplicationDevicesTicketCreateInput"] | undefined | null
};
	["IdentificationCodeUpsertApplicationDevicesRelationInput"]: {
	by?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null,
	update?: ValueTypes["PointOfSaleApplicationDeviceWithoutIdentificationCodeUpdateInput"] | undefined | null,
	create?: ValueTypes["PointOfSaleApplicationDeviceWithoutIdentificationCodeCreateInput"] | undefined | null
};
	["IdentificationCodeLocaleUpsertRootRelationInput"]: {
	update?: ValueTypes["IdentificationCodeWithoutLocalesUpdateInput"] | undefined | null,
	create?: ValueTypes["IdentificationCodeWithoutLocalesCreateInput"] | undefined | null
};
	["LocaleUpsertIdentificationCodesRelationInput"]: {
	by?: ValueTypes["IdentificationCodeLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["IdentificationCodeLocaleWithoutLocaleUpdateInput"] | undefined | null,
	create?: ValueTypes["IdentificationCodeLocaleWithoutLocaleCreateInput"] | undefined | null
};
	["LocaleUpdatePipelineStagesEntityRelationInput"]: {
	create?: ValueTypes["PipelineStageLocaleWithoutLocaleCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleUpdatePipelineStagesRelationInput"] | undefined | null,
	upsert?: ValueTypes["LocaleUpsertPipelineStagesRelationInput"] | undefined | null,
	connect?: ValueTypes["PipelineStageLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["PipelineStageLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["PipelineStageLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["LocaleUpdatePipelineStagesRelationInput"]: {
	by?: ValueTypes["PipelineStageLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["PipelineStageLocaleWithoutLocaleUpdateInput"] | undefined | null
};
	["PipelineStageLocaleWithoutLocaleUpdateInput"]: {
	name?: string | undefined | null,
	root?: ValueTypes["PipelineStageLocaleUpdateRootEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PipelineStageLocaleUpdateRootEntityRelationInput"]: {
	create?: ValueTypes["PipelineStageWithoutLocalesCreateInput"] | undefined | null,
	update?: ValueTypes["PipelineStageWithoutLocalesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["PipelineStageLocaleUpsertRootRelationInput"] | undefined | null,
	connect?: ValueTypes["PipelineStageUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["PipelineStageWithoutLocalesUpdateInput"]: {
	items?: Array<ValueTypes["PipelineStageUpdateItemsEntityRelationInput"]> | undefined | null,
	pipeline?: ValueTypes["PipelineStageUpdatePipelineEntityRelationInput"] | undefined | null,
	order?: number | undefined | null,
	sentiment?: ValueTypes["PipelineStageUpdateSentimentEntityRelationInput"] | undefined | null,
	type?: ValueTypes["PipelineStageType"] | undefined | null,
	forms?: Array<ValueTypes["PipelineStageUpdateFormsEntityRelationInput"]> | undefined | null,
	showItemsWeight?: boolean | undefined | null,
	showItemsPrice?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PipelineStageLocaleUpsertRootRelationInput"]: {
	update?: ValueTypes["PipelineStageWithoutLocalesUpdateInput"] | undefined | null,
	create?: ValueTypes["PipelineStageWithoutLocalesCreateInput"] | undefined | null
};
	["LocaleUpsertPipelineStagesRelationInput"]: {
	by?: ValueTypes["PipelineStageLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["PipelineStageLocaleWithoutLocaleUpdateInput"] | undefined | null,
	create?: ValueTypes["PipelineStageLocaleWithoutLocaleCreateInput"] | undefined | null
};
	["PointOfSaleCategoryLocaleUpsertLocaleRelationInput"]: {
	update?: ValueTypes["LocaleWithoutPointOfSaleCategoriesUpdateInput"] | undefined | null,
	create?: ValueTypes["LocaleWithoutPointOfSaleCategoriesCreateInput"] | undefined | null
};
	["PointOfSaleCategoryUpsertLocalesRelationInput"]: {
	by?: ValueTypes["PointOfSaleCategoryLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["PointOfSaleCategoryLocaleWithoutRootUpdateInput"] | undefined | null,
	create?: ValueTypes["PointOfSaleCategoryLocaleWithoutRootCreateInput"] | undefined | null
};
	["PointOfSaleCategoryProductUpsertCategoryRelationInput"]: {
	update?: ValueTypes["PointOfSaleCategoryWithoutProductsUpdateInput"] | undefined | null,
	create?: ValueTypes["PointOfSaleCategoryWithoutProductsCreateInput"] | undefined | null
};
	["PointOfSaleCategoryProductLocaleUpsertRootRelationInput"]: {
	update?: ValueTypes["PointOfSaleCategoryProductWithoutLocalesUpdateInput"] | undefined | null,
	create?: ValueTypes["PointOfSaleCategoryProductWithoutLocalesCreateInput"] | undefined | null
};
	["LocaleUpsertPointOfSaleCategoryProductsRelationInput"]: {
	by?: ValueTypes["PointOfSaleCategoryProductLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["PointOfSaleCategoryProductLocaleWithoutLocaleUpdateInput"] | undefined | null,
	create?: ValueTypes["PointOfSaleCategoryProductLocaleWithoutLocaleCreateInput"] | undefined | null
};
	["IdentificationCodeLocaleUpsertLocaleRelationInput"]: {
	update?: ValueTypes["LocaleWithoutIdentificationCodesUpdateInput"] | undefined | null,
	create?: ValueTypes["LocaleWithoutIdentificationCodesCreateInput"] | undefined | null
};
	["IdentificationCodeUpsertLocalesRelationInput"]: {
	by?: ValueTypes["IdentificationCodeLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["IdentificationCodeLocaleWithoutRootUpdateInput"] | undefined | null,
	create?: ValueTypes["IdentificationCodeLocaleWithoutRootCreateInput"] | undefined | null
};
	["IdentificationAttemptUpsertCodeRelationInput"]: {
	update?: ValueTypes["IdentificationCodeWithoutAttemptsUpdateInput"] | undefined | null,
	create?: ValueTypes["IdentificationCodeWithoutAttemptsCreateInput"] | undefined | null
};
	["UserUpsertIdentificationAttemptsRelationInput"]: {
	by?: ValueTypes["IdentificationAttemptUniqueWhere"] | undefined | null,
	update?: ValueTypes["IdentificationAttemptWithoutUserUpdateInput"] | undefined | null,
	create?: ValueTypes["IdentificationAttemptWithoutUserCreateInput"] | undefined | null
};
	["DeviceIdentifierUpsertUpdatedByUserRelationInput"]: {
	update?: ValueTypes["UserUpdateInput"] | undefined | null,
	create?: ValueTypes["UserCreateInput"] | undefined | null
};
	["PointOfSaleApplicationDeviceUpsertIdentifierRelationInput"]: {
	update?: ValueTypes["DeviceIdentifierWithoutDeviceUpdateInput"] | undefined | null,
	create?: ValueTypes["DeviceIdentifierWithoutDeviceCreateInput"] | undefined | null
};
	["PointOfSalePrinterUpsertApplicationDevicesReceiptRelationInput"]: {
	by?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null,
	update?: ValueTypes["PointOfSaleApplicationDeviceWithoutReceiptPrinterUpdateInput"] | undefined | null,
	create?: ValueTypes["PointOfSaleApplicationDeviceWithoutReceiptPrinterCreateInput"] | undefined | null
};
	["VenueUpsertPointOfSalePrintersRelationInput"]: {
	by?: ValueTypes["PointOfSalePrinterUniqueWhere"] | undefined | null,
	update?: ValueTypes["PointOfSalePrinterWithoutVenueUpdateInput"] | undefined | null,
	create?: ValueTypes["PointOfSalePrinterWithoutVenueCreateInput"] | undefined | null
};
	["PointOfSaleApplicationDeviceUpsertVenueRelationInput"]: {
	update?: ValueTypes["VenueWithoutPointOfSaleApplicationDevicesUpdateInput"] | undefined | null,
	create?: ValueTypes["VenueWithoutPointOfSaleApplicationDevicesCreateInput"] | undefined | null
};
	["PointOfSaleTerminalUpsertApplicationDevicesRelationInput"]: {
	by?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null,
	update?: ValueTypes["PointOfSaleApplicationDeviceWithoutTerminalUpdateInput"] | undefined | null,
	create?: ValueTypes["PointOfSaleApplicationDeviceWithoutTerminalCreateInput"] | undefined | null
};
	["VenueUpsertPointOfSaleTerminalsRelationInput"]: {
	by?: ValueTypes["PointOfSaleTerminalUniqueWhere"] | undefined | null,
	update?: ValueTypes["PointOfSaleTerminalWithoutVenueUpdateInput"] | undefined | null,
	create?: ValueTypes["PointOfSaleTerminalWithoutVenueCreateInput"] | undefined | null
};
	["FulfillmentNoteUpsertVenuesRelationInput"]: {
	by?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	update?: ValueTypes["VenueWithoutFulfillmentNotesUpdateInput"] | undefined | null,
	create?: ValueTypes["VenueWithoutFulfillmentNotesCreateInput"] | undefined | null
};
	["ProductUpsertFulfillmentNotesRelationInput"]: {
	by?: ValueTypes["FulfillmentNoteUniqueWhere"] | undefined | null,
	update?: ValueTypes["FulfillmentNoteWithoutProductsUpdateInput"] | undefined | null,
	create?: ValueTypes["FulfillmentNoteWithoutProductsCreateInput"] | undefined | null
};
	["PointOfSaleCategoryProductUpsertProductRelationInput"]: {
	update?: ValueTypes["ProductUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductCreateInput"] | undefined | null
};
	["PointOfSaleCategoryProductUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["PointOfSaleCategoryProductLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ValueTypes["PointOfSaleCategoryProductUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ValueTypes["PointOfSaleCategoryProductUpsertLocalesRelationInput"] | undefined | null,
	connect?: ValueTypes["PointOfSaleCategoryProductLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["PointOfSaleCategoryProductLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["PointOfSaleCategoryProductLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PointOfSaleCategoryProductUpdateLocalesRelationInput"]: {
	by?: ValueTypes["PointOfSaleCategoryProductLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["PointOfSaleCategoryProductLocaleWithoutRootUpdateInput"] | undefined | null
};
	["PointOfSaleCategoryProductLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined | null,
	locale?: ValueTypes["PointOfSaleCategoryProductLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleCategoryProductLocaleUpdateLocaleEntityRelationInput"]: {
	create?: ValueTypes["LocaleWithoutPointOfSaleCategoryProductsCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleWithoutPointOfSaleCategoryProductsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["PointOfSaleCategoryProductLocaleUpsertLocaleRelationInput"] | undefined | null,
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutPointOfSaleCategoryProductsUpdateInput"]: {
	businessCategories?: Array<ValueTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleCategoryProductLocaleUpsertLocaleRelationInput"]: {
	update?: ValueTypes["LocaleWithoutPointOfSaleCategoryProductsUpdateInput"] | undefined | null,
	create?: ValueTypes["LocaleWithoutPointOfSaleCategoryProductsCreateInput"] | undefined | null
};
	["PointOfSaleCategoryProductUpsertLocalesRelationInput"]: {
	by?: ValueTypes["PointOfSaleCategoryProductLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["PointOfSaleCategoryProductLocaleWithoutRootUpdateInput"] | undefined | null,
	create?: ValueTypes["PointOfSaleCategoryProductLocaleWithoutRootCreateInput"] | undefined | null
};
	["PointOfSaleCategoryUpsertProductsRelationInput"]: {
	by?: ValueTypes["PointOfSaleCategoryProductUniqueWhere"] | undefined | null,
	update?: ValueTypes["PointOfSaleCategoryProductWithoutCategoryUpdateInput"] | undefined | null,
	create?: ValueTypes["PointOfSaleCategoryProductWithoutCategoryCreateInput"] | undefined | null
};
	["PointOfSaleCategoryLocaleUpsertRootRelationInput"]: {
	update?: ValueTypes["PointOfSaleCategoryWithoutLocalesUpdateInput"] | undefined | null,
	create?: ValueTypes["PointOfSaleCategoryWithoutLocalesCreateInput"] | undefined | null
};
	["LocaleUpsertPointOfSaleCategoriesRelationInput"]: {
	by?: ValueTypes["PointOfSaleCategoryLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["PointOfSaleCategoryLocaleWithoutLocaleUpdateInput"] | undefined | null,
	create?: ValueTypes["PointOfSaleCategoryLocaleWithoutLocaleCreateInput"] | undefined | null
};
	["ProductLocaleUpsertLocaleRelationInput"]: {
	update?: ValueTypes["LocaleWithoutProductsUpdateInput"] | undefined | null,
	create?: ValueTypes["LocaleWithoutProductsCreateInput"] | undefined | null
};
	["ProductUpsertLocalesRelationInput"]: {
	by?: ValueTypes["ProductLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["ProductLocaleWithoutRootUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductLocaleWithoutRootCreateInput"] | undefined | null
};
	["ProductRecipeUpsertProductsRelationInput"]: {
	by?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	update?: ValueTypes["ProductWithoutRecipeUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductWithoutRecipeCreateInput"] | undefined | null
};
	["ProductRecipeUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["ProductRecipeLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ValueTypes["ProductRecipeUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ValueTypes["ProductRecipeUpsertLocalesRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductRecipeLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductRecipeLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductRecipeLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductRecipeUpdateLocalesRelationInput"]: {
	by?: ValueTypes["ProductRecipeLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["ProductRecipeLocaleWithoutRootUpdateInput"] | undefined | null
};
	["ProductRecipeLocaleWithoutRootUpdateInput"]: {
	name?: string | undefined | null,
	locale?: ValueTypes["ProductRecipeLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductRecipeLocaleUpdateLocaleEntityRelationInput"]: {
	create?: ValueTypes["LocaleWithoutProductRecipesCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleWithoutProductRecipesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductRecipeLocaleUpsertLocaleRelationInput"] | undefined | null,
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutProductRecipesUpdateInput"]: {
	businessCategories?: Array<ValueTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductRecipeLocaleUpsertLocaleRelationInput"]: {
	update?: ValueTypes["LocaleWithoutProductRecipesUpdateInput"] | undefined | null,
	create?: ValueTypes["LocaleWithoutProductRecipesCreateInput"] | undefined | null
};
	["ProductRecipeUpsertLocalesRelationInput"]: {
	by?: ValueTypes["ProductRecipeLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["ProductRecipeLocaleWithoutRootUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductRecipeLocaleWithoutRootCreateInput"] | undefined | null
};
	["PreparedPackingQuantityUpsertRecipeRelationInput"]: {
	update?: ValueTypes["ProductRecipeUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductRecipeCreateInput"] | undefined | null
};
	["ProductPackingUpsertPreparedPackingQuantitiesRelationInput"]: {
	by?: ValueTypes["PreparedPackingQuantityUniqueWhere"] | undefined | null,
	update?: ValueTypes["PreparedPackingQuantityWithoutPackingUpdateInput"] | undefined | null,
	create?: ValueTypes["PreparedPackingQuantityWithoutPackingCreateInput"] | undefined | null
};
	["ProductPackingLocaleUpsertRootRelationInput"]: {
	update?: ValueTypes["ProductPackingWithoutLocalesUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductPackingWithoutLocalesCreateInput"] | undefined | null
};
	["LocaleUpsertProductPackingsRelationInput"]: {
	by?: ValueTypes["ProductPackingLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["ProductPackingLocaleWithoutLocaleUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductPackingLocaleWithoutLocaleCreateInput"] | undefined | null
};
	["DeliveryMethodLocaleUpsertLocaleRelationInput"]: {
	update?: ValueTypes["LocaleWithoutDeliveryMethodsUpdateInput"] | undefined | null,
	create?: ValueTypes["LocaleWithoutDeliveryMethodsCreateInput"] | undefined | null
};
	["DeliveryMethodUpsertLocalesRelationInput"]: {
	by?: ValueTypes["DeliveryMethodLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["DeliveryMethodLocaleWithoutRootUpdateInput"] | undefined | null,
	create?: ValueTypes["DeliveryMethodLocaleWithoutRootCreateInput"] | undefined | null
};
	["CourierUpsertDeliveryMethodsRelationInput"]: {
	by?: ValueTypes["DeliveryMethodUniqueWhere"] | undefined | null,
	update?: ValueTypes["DeliveryMethodWithoutCourierHandlersUpdateInput"] | undefined | null,
	create?: ValueTypes["DeliveryMethodWithoutCourierHandlersCreateInput"] | undefined | null
};
	["DeliveryRouteUpsertCourierRelationInput"]: {
	update?: ValueTypes["CourierWithoutRoutesUpdateInput"] | undefined | null,
	create?: ValueTypes["CourierWithoutRoutesCreateInput"] | undefined | null
};
	["DeliveryWaypointUpsertRouteRelationInput"]: {
	update?: ValueTypes["DeliveryRouteWithoutWaypointsUpdateInput"] | undefined | null,
	create?: ValueTypes["DeliveryRouteWithoutWaypointsCreateInput"] | undefined | null
};
	["OrderDeliveryUpsertDeliveryWaypointRelationInput"]: {
	update?: ValueTypes["DeliveryWaypointWithoutDeliveryUpdateInput"] | undefined | null,
	create?: ValueTypes["DeliveryWaypointWithoutDeliveryCreateInput"] | undefined | null
};
	["OrderUpsertDeliveryRelationInput"]: {
	update?: ValueTypes["OrderDeliveryWithoutOrderUpdateInput"] | undefined | null,
	create?: ValueTypes["OrderDeliveryWithoutOrderCreateInput"] | undefined | null
};
	["OrderEventUpsertOrderRelationInput"]: {
	update?: ValueTypes["OrderWithoutEventsUpdateInput"] | undefined | null,
	create?: ValueTypes["OrderWithoutEventsCreateInput"] | undefined | null
};
	["OrderPaymentUpsertEventsRelationInput"]: {
	by?: ValueTypes["OrderEventUniqueWhere"] | undefined | null,
	update?: ValueTypes["OrderEventWithoutPaymentUpdateInput"] | undefined | null,
	create?: ValueTypes["OrderEventWithoutPaymentCreateInput"] | undefined | null
};
	["InvoiceUpsertOrderPaymentsRelationInput"]: {
	by?: ValueTypes["OrderPaymentUniqueWhere"] | undefined | null,
	update?: ValueTypes["OrderPaymentWithoutInvoiceUpdateInput"] | undefined | null,
	create?: ValueTypes["OrderPaymentWithoutInvoiceCreateInput"] | undefined | null
};
	["CustomerUpsertInvoicesRelationInput"]: {
	by?: ValueTypes["InvoiceUniqueWhere"] | undefined | null,
	update?: ValueTypes["InvoiceWithoutCustomerUpdateInput"] | undefined | null,
	create?: ValueTypes["InvoiceWithoutCustomerCreateInput"] | undefined | null
};
	["AnonymousSessionUpsertCustomerRelationInput"]: {
	update?: ValueTypes["CustomerWithoutAnonymousSessionUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerWithoutAnonymousSessionCreateInput"] | undefined | null
};
	["UserDeviceUpsertAnonymousSessionRelationInput"]: {
	update?: ValueTypes["AnonymousSessionWithoutDevicesUpdateInput"] | undefined | null,
	create?: ValueTypes["AnonymousSessionWithoutDevicesCreateInput"] | undefined | null
};
	["UserUpsertDevicesRelationInput"]: {
	by?: ValueTypes["UserDeviceUniqueWhere"] | undefined | null,
	update?: ValueTypes["UserDeviceWithoutUserUpdateInput"] | undefined | null,
	create?: ValueTypes["UserDeviceWithoutUserCreateInput"] | undefined | null
};
	["IdentificationAttemptUpsertUserRelationInput"]: {
	update?: ValueTypes["UserWithoutIdentificationAttemptsUpdateInput"] | undefined | null,
	create?: ValueTypes["UserWithoutIdentificationAttemptsCreateInput"] | undefined | null
};
	["IdentificationCodeUpsertAttemptsRelationInput"]: {
	by?: ValueTypes["IdentificationAttemptUniqueWhere"] | undefined | null,
	update?: ValueTypes["IdentificationAttemptWithoutCodeUpdateInput"] | undefined | null,
	create?: ValueTypes["IdentificationAttemptWithoutCodeCreateInput"] | undefined | null
};
	["PointOfSaleApplicationDeviceUpsertIdentificationCodeRelationInput"]: {
	update?: ValueTypes["IdentificationCodeWithoutApplicationDevicesUpdateInput"] | undefined | null,
	create?: ValueTypes["IdentificationCodeWithoutApplicationDevicesCreateInput"] | undefined | null
};
	["VenueUpsertPointOfSaleApplicationDevicesRelationInput"]: {
	by?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null,
	update?: ValueTypes["PointOfSaleApplicationDeviceWithoutVenueUpdateInput"] | undefined | null,
	create?: ValueTypes["PointOfSaleApplicationDeviceWithoutVenueCreateInput"] | undefined | null
};
	["TimetableTemplateUpsertVenueRelationInput"]: {
	update?: ValueTypes["VenueWithoutTimetableTemplatesUpdateInput"] | undefined | null,
	create?: ValueTypes["VenueWithoutTimetableTemplatesCreateInput"] | undefined | null
};
	["TimetableShiftPositionUpsertTimetableTemplatesRelationInput"]: {
	by?: ValueTypes["TimetableTemplateUniqueWhere"] | undefined | null,
	update?: ValueTypes["TimetableTemplateWithoutPositionUpdateInput"] | undefined | null,
	create?: ValueTypes["TimetableTemplateWithoutPositionCreateInput"] | undefined | null
};
	["TimetableShiftGroupUpsertPositionRelationInput"]: {
	update?: ValueTypes["TimetableShiftPositionWithoutShiftGroupsUpdateInput"] | undefined | null,
	create?: ValueTypes["TimetableShiftPositionWithoutShiftGroupsCreateInput"] | undefined | null
};
	["TimetableShiftGroupUpdateGeneratedByTemplateEntityRelationInput"]: {
	create?: ValueTypes["TimetableTemplateCreateInput"] | undefined | null,
	update?: ValueTypes["TimetableTemplateUpdateInput"] | undefined | null,
	upsert?: ValueTypes["TimetableShiftGroupUpsertGeneratedByTemplateRelationInput"] | undefined | null,
	connect?: ValueTypes["TimetableTemplateUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["TimetableTemplateUpdateInput"]: {
	order?: number | undefined | null,
	startDate?: ValueTypes["Date"] | undefined | null,
	period?: number | undefined | null,
	slots?: number | undefined | null,
	position?: ValueTypes["TimetableTemplateUpdatePositionEntityRelationInput"] | undefined | null,
	staffOptions?: Array<ValueTypes["TimetableTemplateUpdateStaffOptionsEntityRelationInput"]> | undefined | null,
	internalName?: string | undefined | null,
	venue?: ValueTypes["TimetableTemplateUpdateVenueEntityRelationInput"] | undefined | null,
	employeeRole?: ValueTypes["TimetableTemplateUpdateEmployeeRoleEntityRelationInput"] | undefined | null,
	workdaysOnly?: boolean | undefined | null,
	monday?: boolean | undefined | null,
	tuesday?: boolean | undefined | null,
	wednesday?: boolean | undefined | null,
	thursday?: boolean | undefined | null,
	friday?: boolean | undefined | null,
	saturday?: boolean | undefined | null,
	sunday?: boolean | undefined | null,
	type?: ValueTypes["TemplateType"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableShiftGroupUpsertGeneratedByTemplateRelationInput"]: {
	update?: ValueTypes["TimetableTemplateUpdateInput"] | undefined | null,
	create?: ValueTypes["TimetableTemplateCreateInput"] | undefined | null
};
	["TimetableShiftUpsertGroupRelationInput"]: {
	update?: ValueTypes["TimetableShiftGroupWithoutShiftsUpdateInput"] | undefined | null,
	create?: ValueTypes["TimetableShiftGroupWithoutShiftsCreateInput"] | undefined | null
};
	["TimetableShiftUpdateQueueItemEntityRelationInput"]: {
	create?: ValueTypes["EmployeeQueueItemWithoutShiftCreateInput"] | undefined | null,
	update?: ValueTypes["EmployeeQueueItemWithoutShiftUpdateInput"] | undefined | null,
	upsert?: ValueTypes["TimetableShiftUpsertQueueItemRelationInput"] | undefined | null,
	connect?: ValueTypes["EmployeeQueueItemUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["EmployeeQueueItemWithoutShiftUpdateInput"]: {
	start?: string | undefined | null,
	end?: string | undefined | null,
	queue?: ValueTypes["EmployeeQueueItemUpdateQueueEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["EmployeeQueueItemUpdateShiftsProfileEntityRelationInput"] | undefined | null,
	unassignInfo?: ValueTypes["EmployeeQueueItemUpdateUnassignInfoEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["EmployeeQueueItemUpdateMetaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["EmployeeQueueItemUpdateUnassignInfoEntityRelationInput"]: {
	create?: ValueTypes["UnassignedShiftInfoWithoutQueueItemCreateInput"] | undefined | null,
	update?: ValueTypes["UnassignedShiftInfoWithoutQueueItemUpdateInput"] | undefined | null,
	upsert?: ValueTypes["EmployeeQueueItemUpsertUnassignInfoRelationInput"] | undefined | null,
	connect?: ValueTypes["UnassignedShiftInfoUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["UnassignedShiftInfoWithoutQueueItemUpdateInput"]: {
	hoursMissed?: number | undefined | null,
	legacyReason?: ValueTypes["UnassignedInfoReason"] | undefined | null,
	reason?: ValueTypes["UnassignedShiftInfoUpdateReasonEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UnassignedShiftInfoUpdateReasonEntityRelationInput"]: {
	create?: ValueTypes["UnassignReasonCreateInput"] | undefined | null,
	update?: ValueTypes["UnassignReasonUpdateInput"] | undefined | null,
	upsert?: ValueTypes["UnassignedShiftInfoUpsertReasonRelationInput"] | undefined | null,
	connect?: ValueTypes["UnassignReasonUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["UnassignReasonUpdateInput"]: {
	order?: number | undefined | null,
	name?: string | undefined | null,
	venues?: Array<ValueTypes["UnassignReasonUpdateVenuesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UnassignReasonUpdateVenuesEntityRelationInput"]: {
	create?: ValueTypes["VenueWithoutEnabledUnassignReasonsCreateInput"] | undefined | null,
	update?: ValueTypes["UnassignReasonUpdateVenuesRelationInput"] | undefined | null,
	upsert?: ValueTypes["UnassignReasonUpsertVenuesRelationInput"] | undefined | null,
	connect?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	delete?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["UnassignReasonUpdateVenuesRelationInput"]: {
	by?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	data?: ValueTypes["VenueWithoutEnabledUnassignReasonsUpdateInput"] | undefined | null
};
	["VenueWithoutEnabledUnassignReasonsUpdateInput"]: {
	name?: string | undefined | null,
	deadlineTemplate?: ValueTypes["VenueUpdateDeadlineTemplateEntityRelationInput"] | undefined | null,
	timetableDays?: Array<ValueTypes["VenueUpdateTimetableDaysEntityRelationInput"]> | undefined | null,
	timetableTemplates?: Array<ValueTypes["VenueUpdateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	staffMembers?: Array<ValueTypes["VenueUpdateStaffMembersEntityRelationInput"]> | undefined | null,
	employeeRoles?: Array<ValueTypes["VenueUpdateEmployeeRolesEntityRelationInput"]> | undefined | null,
	pointOfSaleApplicationDevices?: Array<ValueTypes["VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined | null,
	pointOfSaleTerminals?: Array<ValueTypes["VenueUpdatePointOfSaleTerminalsEntityRelationInput"]> | undefined | null,
	pointOfSalePrinters?: Array<ValueTypes["VenueUpdatePointOfSalePrintersEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["VenueUpdateOrdersEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["VenueUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	areas?: Array<ValueTypes["VenueUpdateAreasEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["VenueUpdateCategoriesEntityRelationInput"]> | undefined | null,
	channels?: Array<ValueTypes["VenueUpdateChannelsEntityRelationInput"]> | undefined | null,
	address?: string | undefined | null,
	pointOfSalePngBase64ReceiptLogo?: string | undefined | null,
	pointOfSaleInitialView?: ValueTypes["PointOfSaleInitialView"] | undefined | null,
	pointOfSalePreferPrintReceipt?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UnassignReasonUpsertVenuesRelationInput"]: {
	by?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	update?: ValueTypes["VenueWithoutEnabledUnassignReasonsUpdateInput"] | undefined | null,
	create?: ValueTypes["VenueWithoutEnabledUnassignReasonsCreateInput"] | undefined | null
};
	["UnassignedShiftInfoUpsertReasonRelationInput"]: {
	update?: ValueTypes["UnassignReasonUpdateInput"] | undefined | null,
	create?: ValueTypes["UnassignReasonCreateInput"] | undefined | null
};
	["EmployeeQueueItemUpsertUnassignInfoRelationInput"]: {
	update?: ValueTypes["UnassignedShiftInfoWithoutQueueItemUpdateInput"] | undefined | null,
	create?: ValueTypes["UnassignedShiftInfoWithoutQueueItemCreateInput"] | undefined | null
};
	["EmployeeQueueItemUpdateMetaEntityRelationInput"]: {
	connect?: ValueTypes["EmployeeQueueItemMetadataUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["TimetableShiftUpsertQueueItemRelationInput"]: {
	update?: ValueTypes["EmployeeQueueItemWithoutShiftUpdateInput"] | undefined | null,
	create?: ValueTypes["EmployeeQueueItemWithoutShiftCreateInput"] | undefined | null
};
	["TimetableShiftUpdateSwapInfoEntityRelationInput"]: {
	create?: ValueTypes["TimetableShiftSwapInfoWithoutShiftCreateInput"] | undefined | null,
	update?: ValueTypes["TimetableShiftSwapInfoWithoutShiftUpdateInput"] | undefined | null,
	upsert?: ValueTypes["TimetableShiftUpsertSwapInfoRelationInput"] | undefined | null,
	connect?: ValueTypes["TimetableShiftSwapInfoUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["TimetableShiftSwapInfoWithoutShiftUpdateInput"]: {
	assigned?: ValueTypes["Date"] | undefined | null,
	requested?: boolean | undefined | null,
	confirmed?: boolean | undefined | null,
	swappedShiftsProfile?: ValueTypes["TimetableShiftSwapInfoUpdateSwappedShiftsProfileEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableShiftSwapInfoUpdateSwappedShiftsProfileEntityRelationInput"]: {
	create?: ValueTypes["ShiftsProfileCreateInput"] | undefined | null,
	update?: ValueTypes["ShiftsProfileUpdateInput"] | undefined | null,
	upsert?: ValueTypes["TimetableShiftSwapInfoUpsertSwappedShiftsProfileRelationInput"] | undefined | null,
	connect?: ValueTypes["ShiftsProfileUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["TimetableShiftSwapInfoUpsertSwappedShiftsProfileRelationInput"]: {
	update?: ValueTypes["ShiftsProfileUpdateInput"] | undefined | null,
	create?: ValueTypes["ShiftsProfileCreateInput"] | undefined | null
};
	["TimetableShiftUpsertSwapInfoRelationInput"]: {
	update?: ValueTypes["TimetableShiftSwapInfoWithoutShiftUpdateInput"] | undefined | null,
	create?: ValueTypes["TimetableShiftSwapInfoWithoutShiftCreateInput"] | undefined | null
};
	["ShiftsProfileUpsertShiftsRelationInput"]: {
	by?: ValueTypes["TimetableShiftUniqueWhere"] | undefined | null,
	update?: ValueTypes["TimetableShiftWithoutShiftsProfileUpdateInput"] | undefined | null,
	create?: ValueTypes["TimetableShiftWithoutShiftsProfileCreateInput"] | undefined | null
};
	["EmployeeQueueItemUpsertShiftsProfileRelationInput"]: {
	update?: ValueTypes["ShiftsProfileWithoutQueueItemsUpdateInput"] | undefined | null,
	create?: ValueTypes["ShiftsProfileWithoutQueueItemsCreateInput"] | undefined | null
};
	["EmployeeQueueItemUpdateShiftEntityRelationInput"]: {
	create?: ValueTypes["TimetableShiftWithoutQueueItemCreateInput"] | undefined | null,
	update?: ValueTypes["TimetableShiftWithoutQueueItemUpdateInput"] | undefined | null,
	upsert?: ValueTypes["EmployeeQueueItemUpsertShiftRelationInput"] | undefined | null,
	connect?: ValueTypes["TimetableShiftUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["TimetableShiftWithoutQueueItemUpdateInput"]: {
	locked?: boolean | undefined | null,
	order?: number | undefined | null,
	assigned?: ValueTypes["Date"] | undefined | null,
	group?: ValueTypes["TimetableShiftUpdateGroupEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["TimetableShiftUpdateShiftsProfileEntityRelationInput"] | undefined | null,
	swapInfo?: ValueTypes["TimetableShiftUpdateSwapInfoEntityRelationInput"] | undefined | null,
	isOvertime?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["EmployeeQueueItemUpsertShiftRelationInput"]: {
	update?: ValueTypes["TimetableShiftWithoutQueueItemUpdateInput"] | undefined | null,
	create?: ValueTypes["TimetableShiftWithoutQueueItemCreateInput"] | undefined | null
};
	["EmployeeQueueUpsertItemsRelationInput"]: {
	by?: ValueTypes["EmployeeQueueItemUniqueWhere"] | undefined | null,
	update?: ValueTypes["EmployeeQueueItemWithoutQueueUpdateInput"] | undefined | null,
	create?: ValueTypes["EmployeeQueueItemWithoutQueueCreateInput"] | undefined | null
};
	["TimetableShiftGroupUpsertQueueRelationInput"]: {
	update?: ValueTypes["EmployeeQueueWithoutShiftGroupUpdateInput"] | undefined | null,
	create?: ValueTypes["EmployeeQueueWithoutShiftGroupCreateInput"] | undefined | null
};
	["TimetableShiftPositionUpsertShiftGroupsRelationInput"]: {
	by?: ValueTypes["TimetableShiftGroupUniqueWhere"] | undefined | null,
	update?: ValueTypes["TimetableShiftGroupWithoutPositionUpdateInput"] | undefined | null,
	create?: ValueTypes["TimetableShiftGroupWithoutPositionCreateInput"] | undefined | null
};
	["TimetableTemplateUpsertPositionRelationInput"]: {
	update?: ValueTypes["TimetableShiftPositionWithoutTimetableTemplatesUpdateInput"] | undefined | null,
	create?: ValueTypes["TimetableShiftPositionWithoutTimetableTemplatesCreateInput"] | undefined | null
};
	["TimetableEmployeeRoleUpsertTimetableTemplatesRelationInput"]: {
	by?: ValueTypes["TimetableTemplateUniqueWhere"] | undefined | null,
	update?: ValueTypes["TimetableTemplateWithoutEmployeeRoleUpdateInput"] | undefined | null,
	create?: ValueTypes["TimetableTemplateWithoutEmployeeRoleCreateInput"] | undefined | null
};
	["TimetableShiftGroupUpsertTypeRelationInput"]: {
	update?: ValueTypes["TimetableEmployeeRoleWithoutShiftGroupsUpdateInput"] | undefined | null,
	create?: ValueTypes["TimetableEmployeeRoleWithoutShiftGroupsCreateInput"] | undefined | null
};
	["TimetableDayUpsertShiftGroupsRelationInput"]: {
	by?: ValueTypes["TimetableShiftGroupUniqueWhere"] | undefined | null,
	update?: ValueTypes["TimetableShiftGroupWithoutDayUpdateInput"] | undefined | null,
	create?: ValueTypes["TimetableShiftGroupWithoutDayCreateInput"] | undefined | null
};
	["TimetableDayUpdateMetaEntityRelationInput"]: {
	connect?: ValueTypes["TimetableDayMetadataUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["VenueUpsertTimetableDaysRelationInput"]: {
	by?: ValueTypes["TimetableDayUniqueWhere"] | undefined | null,
	update?: ValueTypes["TimetableDayWithoutVenueUpdateInput"] | undefined | null,
	create?: ValueTypes["TimetableDayWithoutVenueCreateInput"] | undefined | null
};
	["ChannelUpsertVenueRelationInput"]: {
	update?: ValueTypes["VenueWithoutChannelsUpdateInput"] | undefined | null,
	create?: ValueTypes["VenueWithoutChannelsCreateInput"] | undefined | null
};
	["TagUpsertPublicInChannelsRelationInput"]: {
	by?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	update?: ValueTypes["ChannelWithoutPublicTagsUpdateInput"] | undefined | null,
	create?: ValueTypes["ChannelWithoutPublicTagsCreateInput"] | undefined | null
};
	["DeliveryZoneUpsertDeliveryZonesOfTagsRelationInput"]: {
	by?: ValueTypes["TagUniqueWhere"] | undefined | null,
	update?: ValueTypes["TagWithoutDeliveryZonesUpdateInput"] | undefined | null,
	create?: ValueTypes["TagWithoutDeliveryZonesCreateInput"] | undefined | null
};
	["DeliveryZoneUpdateAddressesMetadataEntityRelationInput"]: {
	connect?: ValueTypes["AddressMetadataUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["AddressMetadataUniqueWhere"] | undefined | null,
	delete?: ValueTypes["AddressMetadataUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductUpsertDeliveryZonesRelationInput"]: {
	by?: ValueTypes["DeliveryZoneUniqueWhere"] | undefined | null,
	update?: ValueTypes["DeliveryZoneWithoutDeliveryZonesOfProductsUpdateInput"] | undefined | null,
	create?: ValueTypes["DeliveryZoneWithoutDeliveryZonesOfProductsCreateInput"] | undefined | null
};
	["FulfillmentNoteUpsertProductsRelationInput"]: {
	by?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	update?: ValueTypes["ProductWithoutFulfillmentNotesUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductWithoutFulfillmentNotesCreateInput"] | undefined | null
};
	["TagUpsertFulfillmentNotesRelationInput"]: {
	by?: ValueTypes["FulfillmentNoteUniqueWhere"] | undefined | null,
	update?: ValueTypes["FulfillmentNoteWithoutTagsUpdateInput"] | undefined | null,
	create?: ValueTypes["FulfillmentNoteWithoutTagsCreateInput"] | undefined | null
};
	["ChannelUpsertPublicTagsRelationInput"]: {
	by?: ValueTypes["TagUniqueWhere"] | undefined | null,
	update?: ValueTypes["TagWithoutPublicInChannelsUpdateInput"] | undefined | null,
	create?: ValueTypes["TagWithoutPublicInChannelsCreateInput"] | undefined | null
};
	["CustomerUpsertChannelsRelationInput"]: {
	by?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	update?: ValueTypes["ChannelWithoutCustomersUpdateInput"] | undefined | null,
	create?: ValueTypes["ChannelWithoutCustomersCreateInput"] | undefined | null
};
	["CustomerCreditUpsertCustomerRelationInput"]: {
	update?: ValueTypes["CustomerWithoutCreditsUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerWithoutCreditsCreateInput"] | undefined | null
};
	["CustomerCreditUpdateVoucherRedemptionEntityRelationInput"]: {
	create?: ValueTypes["VoucherRedemptionWithoutCustomerCreditCreateInput"] | undefined | null,
	update?: ValueTypes["VoucherRedemptionWithoutCustomerCreditUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CustomerCreditUpsertVoucherRedemptionRelationInput"] | undefined | null,
	connect?: ValueTypes["VoucherRedemptionUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["VoucherRedemptionWithoutCustomerCreditUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	manualRedemptionNote?: string | undefined | null,
	orderDiscount?: ValueTypes["VoucherRedemptionUpdateOrderDiscountEntityRelationInput"] | undefined | null,
	voucher?: ValueTypes["VoucherRedemptionUpdateVoucherEntityRelationInput"] | undefined | null,
	customer?: ValueTypes["VoucherRedemptionUpdateCustomerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreditUpsertVoucherRedemptionRelationInput"]: {
	update?: ValueTypes["VoucherRedemptionWithoutCustomerCreditUpdateInput"] | undefined | null,
	create?: ValueTypes["VoucherRedemptionWithoutCustomerCreditCreateInput"] | undefined | null
};
	["CustomerCreditTransactionUpsertCustomerCreditRelationInput"]: {
	update?: ValueTypes["CustomerCreditWithoutTransactionsUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerCreditWithoutTransactionsCreateInput"] | undefined | null
};
	["OrderDiscountUpsertCustomerCreditTransactionsRelationInput"]: {
	by?: ValueTypes["CustomerCreditTransactionUniqueWhere"] | undefined | null,
	update?: ValueTypes["CustomerCreditTransactionWithoutOrderDiscountUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerCreditTransactionWithoutOrderDiscountCreateInput"] | undefined | null
};
	["OrderUpsertDiscountsRelationInput"]: {
	by?: ValueTypes["OrderDiscountUniqueWhere"] | undefined | null,
	update?: ValueTypes["OrderDiscountWithoutOrderUpdateInput"] | undefined | null,
	create?: ValueTypes["OrderDiscountWithoutOrderCreateInput"] | undefined | null
};
	["OrderItemUpsertOrderRelationInput"]: {
	update?: ValueTypes["OrderWithoutItemsUpdateInput"] | undefined | null,
	create?: ValueTypes["OrderWithoutItemsCreateInput"] | undefined | null
};
	["ProductUpsertOrderItemsRelationInput"]: {
	by?: ValueTypes["OrderItemUniqueWhere"] | undefined | null,
	update?: ValueTypes["OrderItemWithoutProductUpdateInput"] | undefined | null,
	create?: ValueTypes["OrderItemWithoutProductCreateInput"] | undefined | null
};
	["StocksManagerUpsertManagedProductsRelationInput"]: {
	by?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	update?: ValueTypes["ProductWithoutManagerUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductWithoutManagerCreateInput"] | undefined | null
};
	["StaffUpsertStocksManagerRelationInput"]: {
	update?: ValueTypes["StocksManagerWithoutStaffUpdateInput"] | undefined | null,
	create?: ValueTypes["StocksManagerWithoutStaffCreateInput"] | undefined | null
};
	["StaffUpdateVenuesEntityRelationInput"]: {
	create?: ValueTypes["VenueWithoutStaffMembersCreateInput"] | undefined | null,
	update?: ValueTypes["StaffUpdateVenuesRelationInput"] | undefined | null,
	upsert?: ValueTypes["StaffUpsertVenuesRelationInput"] | undefined | null,
	connect?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	delete?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["StaffUpdateVenuesRelationInput"]: {
	by?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	data?: ValueTypes["VenueWithoutStaffMembersUpdateInput"] | undefined | null
};
	["VenueWithoutStaffMembersUpdateInput"]: {
	name?: string | undefined | null,
	deadlineTemplate?: ValueTypes["VenueUpdateDeadlineTemplateEntityRelationInput"] | undefined | null,
	timetableDays?: Array<ValueTypes["VenueUpdateTimetableDaysEntityRelationInput"]> | undefined | null,
	timetableTemplates?: Array<ValueTypes["VenueUpdateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	employeeRoles?: Array<ValueTypes["VenueUpdateEmployeeRolesEntityRelationInput"]> | undefined | null,
	pointOfSaleApplicationDevices?: Array<ValueTypes["VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined | null,
	pointOfSaleTerminals?: Array<ValueTypes["VenueUpdatePointOfSaleTerminalsEntityRelationInput"]> | undefined | null,
	pointOfSalePrinters?: Array<ValueTypes["VenueUpdatePointOfSalePrintersEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["VenueUpdateOrdersEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["VenueUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	areas?: Array<ValueTypes["VenueUpdateAreasEntityRelationInput"]> | undefined | null,
	enabledUnassignReasons?: Array<ValueTypes["VenueUpdateEnabledUnassignReasonsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["VenueUpdateCategoriesEntityRelationInput"]> | undefined | null,
	channels?: Array<ValueTypes["VenueUpdateChannelsEntityRelationInput"]> | undefined | null,
	address?: string | undefined | null,
	pointOfSalePngBase64ReceiptLogo?: string | undefined | null,
	pointOfSaleInitialView?: ValueTypes["PointOfSaleInitialView"] | undefined | null,
	pointOfSalePreferPrintReceipt?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StaffUpsertVenuesRelationInput"]: {
	by?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	update?: ValueTypes["VenueWithoutStaffMembersUpdateInput"] | undefined | null,
	create?: ValueTypes["VenueWithoutStaffMembersCreateInput"] | undefined | null
};
	["ShiftsManagerUpsertStaffRelationInput"]: {
	update?: ValueTypes["StaffWithoutShiftsManagerUpdateInput"] | undefined | null,
	create?: ValueTypes["StaffWithoutShiftsManagerCreateInput"] | undefined | null
};
	["TimetableEmployeeRoleUpsertShiftsManagersRelationInput"]: {
	by?: ValueTypes["ShiftsManagerUniqueWhere"] | undefined | null,
	update?: ValueTypes["ShiftsManagerWithoutManagedRolesUpdateInput"] | undefined | null,
	create?: ValueTypes["ShiftsManagerWithoutManagedRolesCreateInput"] | undefined | null
};
	["ShiftsProfileUpsertRolesRelationInput"]: {
	by?: ValueTypes["TimetableEmployeeRoleUniqueWhere"] | undefined | null,
	update?: ValueTypes["TimetableEmployeeRoleWithoutShiftsProfilesUpdateInput"] | undefined | null,
	create?: ValueTypes["TimetableEmployeeRoleWithoutShiftsProfilesCreateInput"] | undefined | null
};
	["StaffUpsertShiftsProfileRelationInput"]: {
	update?: ValueTypes["ShiftsProfileWithoutStaffUpdateInput"] | undefined | null,
	create?: ValueTypes["ShiftsProfileWithoutStaffCreateInput"] | undefined | null
};
	["UserUpsertStaffRelationInput"]: {
	update?: ValueTypes["StaffWithoutUserUpdateInput"] | undefined | null,
	create?: ValueTypes["StaffWithoutUserCreateInput"] | undefined | null
};
	["CustomerUpsertUserRelationInput"]: {
	update?: ValueTypes["UserWithoutCustomerUpdateInput"] | undefined | null,
	create?: ValueTypes["UserWithoutCustomerCreateInput"] | undefined | null
};
	["OrderUpsertCustomerRelationInput"]: {
	update?: ValueTypes["CustomerWithoutOrdersUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerWithoutOrdersCreateInput"] | undefined | null
};
	["CartUpsertOrderRelationInput"]: {
	update?: ValueTypes["OrderWithoutCartUpdateInput"] | undefined | null,
	create?: ValueTypes["OrderWithoutCartCreateInput"] | undefined | null
};
	["CustomerUpsertCartsRelationInput"]: {
	by?: ValueTypes["CartUniqueWhere"] | undefined | null,
	update?: ValueTypes["CartWithoutCustomerUpdateInput"] | undefined | null,
	create?: ValueTypes["CartWithoutCustomerCreateInput"] | undefined | null
};
	["UserUpsertCustomerRelationInput"]: {
	update?: ValueTypes["CustomerWithoutUserUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerWithoutUserCreateInput"] | undefined | null
};
	["StaffUpsertUserRelationInput"]: {
	update?: ValueTypes["UserWithoutStaffUpdateInput"] | undefined | null,
	create?: ValueTypes["UserWithoutStaffCreateInput"] | undefined | null
};
	["BusinessToBusinessManagerUpsertStaffRelationInput"]: {
	update?: ValueTypes["StaffWithoutBusinessToBusinessManagerUpdateInput"] | undefined | null,
	create?: ValueTypes["StaffWithoutBusinessToBusinessManagerCreateInput"] | undefined | null
};
	["BusinessCustomerUpsertAccountManagerRelationInput"]: {
	update?: ValueTypes["BusinessToBusinessManagerWithoutManagedBusinessesUpdateInput"] | undefined | null,
	create?: ValueTypes["BusinessToBusinessManagerWithoutManagedBusinessesCreateInput"] | undefined | null
};
	["BusinessCustomerUpdateLogoEntityRelationInput"]: {
	create?: ValueTypes["ImageCreateInput"] | undefined | null,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ValueTypes["BusinessCustomerUpsertLogoRelationInput"] | undefined | null,
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["BusinessCustomerUpsertLogoRelationInput"]: {
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["BusinessCustomerUpdateBusinessServiceEventsEntityRelationInput"]: {
	create?: ValueTypes["BusinessServiceEventWithoutBusinessCustomerCreateInput"] | undefined | null,
	update?: ValueTypes["BusinessCustomerUpdateBusinessServiceEventsRelationInput"] | undefined | null,
	upsert?: ValueTypes["BusinessCustomerUpsertBusinessServiceEventsRelationInput"] | undefined | null,
	connect?: ValueTypes["BusinessServiceEventUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["BusinessServiceEventUniqueWhere"] | undefined | null,
	delete?: ValueTypes["BusinessServiceEventUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["BusinessCustomerUpdateBusinessServiceEventsRelationInput"]: {
	by?: ValueTypes["BusinessServiceEventUniqueWhere"] | undefined | null,
	data?: ValueTypes["BusinessServiceEventWithoutBusinessCustomerUpdateInput"] | undefined | null
};
	["BusinessServiceEventWithoutBusinessCustomerUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	fulfilledAt?: ValueTypes["DateTime"] | undefined | null,
	businessService?: ValueTypes["BusinessServiceEventUpdateBusinessServiceEntityRelationInput"] | undefined | null,
	filledNumberOfPeople?: number | undefined | null,
	filledInvoiced?: boolean | undefined | null,
	filledEquipment?: string | undefined | null,
	filledMillTamDem?: boolean | undefined | null,
	filledSOEspresso?: boolean | undefined | null,
	filledFilterCoffeeInMenu?: boolean | undefined | null,
	filledWaterMeterStatus?: string | undefined | null,
	filledServiceAction?: string | undefined | null,
	filledInvoiceIdentifier?: string | undefined | null,
	filledNote?: string | undefined | null,
	filledContact?: string | undefined | null,
	filledPhone?: boolean | undefined | null,
	filledEmail?: boolean | undefined | null,
	filledGrindingStonesCondition?: string | undefined | null,
	createdBy?: ValueTypes["BusinessServiceEventUpdateCreatedByEntityRelationInput"] | undefined | null,
	filledSupervisor?: ValueTypes["BusinessServiceEventUpdateFilledSupervisorEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessServiceEventUpdateBusinessServiceEntityRelationInput"]: {
	create?: ValueTypes["BusinessServiceCreateInput"] | undefined | null,
	update?: ValueTypes["BusinessServiceUpdateInput"] | undefined | null,
	upsert?: ValueTypes["BusinessServiceEventUpsertBusinessServiceRelationInput"] | undefined | null,
	connect?: ValueTypes["BusinessServiceUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["BusinessServiceUpdateInput"]: {
	order?: number | undefined | null,
	requireNote?: number | undefined | null,
	locales?: Array<ValueTypes["BusinessServiceUpdateLocalesEntityRelationInput"]> | undefined | null,
	requireNumberOfPeople?: number | undefined | null,
	requireInvoiced?: number | undefined | null,
	requireEquipment?: number | undefined | null,
	requireMillTamDem?: number | undefined | null,
	requireSOEspresso?: number | undefined | null,
	requireFilterCoffeeInMenu?: number | undefined | null,
	requireWaterMeterStatus?: number | undefined | null,
	requireServiceAction?: number | undefined | null,
	optionsEquipment?: string | undefined | null,
	optionsServiceAction?: string | undefined | null,
	requireInvoiceIdentifier?: number | undefined | null,
	requireSupervisor?: number | undefined | null,
	requireContact?: number | undefined | null,
	requirePhone?: number | undefined | null,
	requireEmail?: number | undefined | null,
	requireGrindingStonesCondition?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessServiceUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["BusinessServiceLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ValueTypes["BusinessServiceUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ValueTypes["BusinessServiceUpsertLocalesRelationInput"] | undefined | null,
	connect?: ValueTypes["BusinessServiceLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["BusinessServiceLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["BusinessServiceLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["BusinessServiceUpdateLocalesRelationInput"]: {
	by?: ValueTypes["BusinessServiceLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["BusinessServiceLocaleWithoutRootUpdateInput"] | undefined | null
};
	["BusinessServiceLocaleWithoutRootUpdateInput"]: {
	name?: string | undefined | null,
	labelNote?: string | undefined | null,
	locale?: ValueTypes["BusinessServiceLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	labelNumberOfPeople?: string | undefined | null,
	labelInvoiced?: string | undefined | null,
	labelEquipment?: string | undefined | null,
	labelMillTamDem?: string | undefined | null,
	labelSOEspresso?: string | undefined | null,
	labelFilterCoffeeInMenu?: string | undefined | null,
	labelWaterMeterStatus?: string | undefined | null,
	labelServiceAction?: string | undefined | null,
	labelInvoiceIdentifier?: string | undefined | null,
	labelSupervisor?: string | undefined | null,
	labelContact?: string | undefined | null,
	labelPhone?: string | undefined | null,
	labelEmail?: string | undefined | null,
	labelGrindingStonesCondition?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessServiceLocaleUpdateLocaleEntityRelationInput"]: {
	create?: ValueTypes["LocaleWithoutBusinessServicesCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleWithoutBusinessServicesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["BusinessServiceLocaleUpsertLocaleRelationInput"] | undefined | null,
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutBusinessServicesUpdateInput"]: {
	businessCategories?: Array<ValueTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessServiceLocaleUpsertLocaleRelationInput"]: {
	update?: ValueTypes["LocaleWithoutBusinessServicesUpdateInput"] | undefined | null,
	create?: ValueTypes["LocaleWithoutBusinessServicesCreateInput"] | undefined | null
};
	["BusinessServiceUpsertLocalesRelationInput"]: {
	by?: ValueTypes["BusinessServiceLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["BusinessServiceLocaleWithoutRootUpdateInput"] | undefined | null,
	create?: ValueTypes["BusinessServiceLocaleWithoutRootCreateInput"] | undefined | null
};
	["BusinessServiceEventUpsertBusinessServiceRelationInput"]: {
	update?: ValueTypes["BusinessServiceUpdateInput"] | undefined | null,
	create?: ValueTypes["BusinessServiceCreateInput"] | undefined | null
};
	["BusinessServiceEventUpdateCreatedByEntityRelationInput"]: {
	create?: ValueTypes["StaffCreateInput"] | undefined | null,
	update?: ValueTypes["StaffUpdateInput"] | undefined | null,
	upsert?: ValueTypes["BusinessServiceEventUpsertCreatedByRelationInput"] | undefined | null,
	connect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["StaffUpdateInput"]: {
	bartender?: ValueTypes["StaffUpdateBartenderEntityRelationInput"] | undefined | null,
	courier?: ValueTypes["StaffUpdateCourierEntityRelationInput"] | undefined | null,
	cleaner?: ValueTypes["StaffUpdateCleanerEntityRelationInput"] | undefined | null,
	shiftsManager?: ValueTypes["StaffUpdateShiftsManagerEntityRelationInput"] | undefined | null,
	businessToBusinessManager?: ValueTypes["StaffUpdateBusinessToBusinessManagerEntityRelationInput"] | undefined | null,
	user?: ValueTypes["StaffUpdateUserEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["StaffUpdateShiftsProfileEntityRelationInput"] | undefined | null,
	stocksManager?: ValueTypes["StaffUpdateStocksManagerEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["StaffUpdatePhotoEntityRelationInput"] | undefined | null,
	courierManager?: ValueTypes["StaffUpdateCourierManagerEntityRelationInput"] | undefined | null,
	picker?: ValueTypes["StaffUpdatePickerEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	remunerationProfile?: ValueTypes["StaffUpdateRemunerationProfileEntityRelationInput"] | undefined | null,
	cashier?: ValueTypes["StaffUpdateCashierEntityRelationInput"] | undefined | null,
	venues?: Array<ValueTypes["StaffUpdateVenuesEntityRelationInput"]> | undefined | null,
	internalBuyer?: ValueTypes["StaffUpdateInternalBuyerEntityRelationInput"] | undefined | null,
	salesManager?: ValueTypes["StaffUpdateSalesManagerEntityRelationInput"] | undefined | null,
	cashierManager?: ValueTypes["StaffUpdateCashierManagerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessServiceEventUpsertCreatedByRelationInput"]: {
	update?: ValueTypes["StaffUpdateInput"] | undefined | null,
	create?: ValueTypes["StaffCreateInput"] | undefined | null
};
	["BusinessServiceEventUpdateFilledSupervisorEntityRelationInput"]: {
	create?: ValueTypes["StaffCreateInput"] | undefined | null,
	update?: ValueTypes["StaffUpdateInput"] | undefined | null,
	upsert?: ValueTypes["BusinessServiceEventUpsertFilledSupervisorRelationInput"] | undefined | null,
	connect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["BusinessServiceEventUpsertFilledSupervisorRelationInput"]: {
	update?: ValueTypes["StaffUpdateInput"] | undefined | null,
	create?: ValueTypes["StaffCreateInput"] | undefined | null
};
	["BusinessCustomerUpsertBusinessServiceEventsRelationInput"]: {
	by?: ValueTypes["BusinessServiceEventUniqueWhere"] | undefined | null,
	update?: ValueTypes["BusinessServiceEventWithoutBusinessCustomerUpdateInput"] | undefined | null,
	create?: ValueTypes["BusinessServiceEventWithoutBusinessCustomerCreateInput"] | undefined | null
};
	["BusinessCustomerUpdateDoubleshotCoffeeEquipmentEntityRelationInput"]: {
	create?: ValueTypes["DoubleshotCoffeeEquipmentCreateInput"] | undefined | null,
	update?: ValueTypes["DoubleshotCoffeeEquipmentUpdateInput"] | undefined | null,
	upsert?: ValueTypes["BusinessCustomerUpsertDoubleshotCoffeeEquipmentRelationInput"] | undefined | null,
	connect?: ValueTypes["DoubleshotCoffeeEquipmentUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["DoubleshotCoffeeEquipmentUpdateInput"]: {
	espressoMachine?: string | undefined | null,
	espressoGrinder?: string | undefined | null,
	batchBrew?: string | undefined | null,
	batchGrinder?: string | undefined | null,
	waterFilter?: string | undefined | null,
	mechanicalFilter?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessCustomerUpsertDoubleshotCoffeeEquipmentRelationInput"]: {
	update?: ValueTypes["DoubleshotCoffeeEquipmentUpdateInput"] | undefined | null,
	create?: ValueTypes["DoubleshotCoffeeEquipmentCreateInput"] | undefined | null
};
	["CustomerUpsertOwnerOfBusinessesRelationInput"]: {
	by?: ValueTypes["BusinessCustomerUniqueWhere"] | undefined | null,
	update?: ValueTypes["BusinessCustomerWithoutOwnersUpdateInput"] | undefined | null,
	create?: ValueTypes["BusinessCustomerWithoutOwnersCreateInput"] | undefined | null
};
	["BusinessCustomerUpsertMembersRelationInput"]: {
	by?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	update?: ValueTypes["CustomerWithoutMemberOfBusinessesUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerWithoutMemberOfBusinessesCreateInput"] | undefined | null
};
	["BusinessToBusinessManagerUpsertManagedBusinessesRelationInput"]: {
	by?: ValueTypes["BusinessCustomerUniqueWhere"] | undefined | null,
	update?: ValueTypes["BusinessCustomerWithoutAccountManagerUpdateInput"] | undefined | null,
	create?: ValueTypes["BusinessCustomerWithoutAccountManagerCreateInput"] | undefined | null
};
	["StaffUpsertBusinessToBusinessManagerRelationInput"]: {
	update?: ValueTypes["BusinessToBusinessManagerWithoutStaffUpdateInput"] | undefined | null,
	create?: ValueTypes["BusinessToBusinessManagerWithoutStaffCreateInput"] | undefined | null
};
	["ShiftsProfileUpsertStaffRelationInput"]: {
	update?: ValueTypes["StaffWithoutShiftsProfileUpdateInput"] | undefined | null,
	create?: ValueTypes["StaffWithoutShiftsProfileCreateInput"] | undefined | null
};
	["TimetableEmployeeRoleUpsertShiftsProfilesRelationInput"]: {
	by?: ValueTypes["ShiftsProfileUniqueWhere"] | undefined | null,
	update?: ValueTypes["ShiftsProfileWithoutRolesUpdateInput"] | undefined | null,
	create?: ValueTypes["ShiftsProfileWithoutRolesCreateInput"] | undefined | null
};
	["TimetableDayNoteUpsertRoleRelationInput"]: {
	update?: ValueTypes["TimetableEmployeeRoleUpdateInput"] | undefined | null,
	create?: ValueTypes["TimetableEmployeeRoleCreateInput"] | undefined | null
};
	["TimetableDayUpsertNotesRelationInput"]: {
	by?: ValueTypes["TimetableDayNoteUniqueWhere"] | undefined | null,
	update?: ValueTypes["TimetableDayNoteWithoutDayUpdateInput"] | undefined | null,
	create?: ValueTypes["TimetableDayNoteWithoutDayCreateInput"] | undefined | null
};
	["TimetableDayUpdateVenueEntityRelationInput"]: {
	create?: ValueTypes["VenueWithoutTimetableDaysCreateInput"] | undefined | null,
	update?: ValueTypes["VenueWithoutTimetableDaysUpdateInput"] | undefined | null,
	upsert?: ValueTypes["TimetableDayUpsertVenueRelationInput"] | undefined | null,
	connect?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["VenueWithoutTimetableDaysUpdateInput"]: {
	name?: string | undefined | null,
	deadlineTemplate?: ValueTypes["VenueUpdateDeadlineTemplateEntityRelationInput"] | undefined | null,
	timetableTemplates?: Array<ValueTypes["VenueUpdateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	staffMembers?: Array<ValueTypes["VenueUpdateStaffMembersEntityRelationInput"]> | undefined | null,
	employeeRoles?: Array<ValueTypes["VenueUpdateEmployeeRolesEntityRelationInput"]> | undefined | null,
	pointOfSaleApplicationDevices?: Array<ValueTypes["VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined | null,
	pointOfSaleTerminals?: Array<ValueTypes["VenueUpdatePointOfSaleTerminalsEntityRelationInput"]> | undefined | null,
	pointOfSalePrinters?: Array<ValueTypes["VenueUpdatePointOfSalePrintersEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["VenueUpdateOrdersEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["VenueUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	areas?: Array<ValueTypes["VenueUpdateAreasEntityRelationInput"]> | undefined | null,
	enabledUnassignReasons?: Array<ValueTypes["VenueUpdateEnabledUnassignReasonsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["VenueUpdateCategoriesEntityRelationInput"]> | undefined | null,
	channels?: Array<ValueTypes["VenueUpdateChannelsEntityRelationInput"]> | undefined | null,
	address?: string | undefined | null,
	pointOfSalePngBase64ReceiptLogo?: string | undefined | null,
	pointOfSaleInitialView?: ValueTypes["PointOfSaleInitialView"] | undefined | null,
	pointOfSalePreferPrintReceipt?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableDayUpsertVenueRelationInput"]: {
	update?: ValueTypes["VenueWithoutTimetableDaysUpdateInput"] | undefined | null,
	create?: ValueTypes["VenueWithoutTimetableDaysCreateInput"] | undefined | null
};
	["TimetableShiftGroupUpsertDayRelationInput"]: {
	update?: ValueTypes["TimetableDayWithoutShiftGroupsUpdateInput"] | undefined | null,
	create?: ValueTypes["TimetableDayWithoutShiftGroupsCreateInput"] | undefined | null
};
	["EmployeeQueueUpsertShiftGroupRelationInput"]: {
	update?: ValueTypes["TimetableShiftGroupWithoutQueueUpdateInput"] | undefined | null,
	create?: ValueTypes["TimetableShiftGroupWithoutQueueCreateInput"] | undefined | null
};
	["EmployeeQueueItemUpsertQueueRelationInput"]: {
	update?: ValueTypes["EmployeeQueueWithoutItemsUpdateInput"] | undefined | null,
	create?: ValueTypes["EmployeeQueueWithoutItemsCreateInput"] | undefined | null
};
	["ShiftsProfileUpsertQueueItemsRelationInput"]: {
	by?: ValueTypes["EmployeeQueueItemUniqueWhere"] | undefined | null,
	update?: ValueTypes["EmployeeQueueItemWithoutShiftsProfileUpdateInput"] | undefined | null,
	create?: ValueTypes["EmployeeQueueItemWithoutShiftsProfileCreateInput"] | undefined | null
};
	["TimetableShiftUpsertShiftsProfileRelationInput"]: {
	update?: ValueTypes["ShiftsProfileWithoutShiftsUpdateInput"] | undefined | null,
	create?: ValueTypes["ShiftsProfileWithoutShiftsCreateInput"] | undefined | null
};
	["TimetableShiftGroupUpsertShiftsRelationInput"]: {
	by?: ValueTypes["TimetableShiftUniqueWhere"] | undefined | null,
	update?: ValueTypes["TimetableShiftWithoutGroupUpdateInput"] | undefined | null,
	create?: ValueTypes["TimetableShiftWithoutGroupCreateInput"] | undefined | null
};
	["TimetableEmployeeRoleUpsertShiftGroupsRelationInput"]: {
	by?: ValueTypes["TimetableShiftGroupUniqueWhere"] | undefined | null,
	update?: ValueTypes["TimetableShiftGroupWithoutTypeUpdateInput"] | undefined | null,
	create?: ValueTypes["TimetableShiftGroupWithoutTypeCreateInput"] | undefined | null
};
	["ShiftsManagerUpsertManagedRolesRelationInput"]: {
	by?: ValueTypes["TimetableEmployeeRoleUniqueWhere"] | undefined | null,
	update?: ValueTypes["TimetableEmployeeRoleWithoutShiftsManagersUpdateInput"] | undefined | null,
	create?: ValueTypes["TimetableEmployeeRoleWithoutShiftsManagersCreateInput"] | undefined | null
};
	["StaffUpsertShiftsManagerRelationInput"]: {
	update?: ValueTypes["ShiftsManagerWithoutStaffUpdateInput"] | undefined | null,
	create?: ValueTypes["ShiftsManagerWithoutStaffCreateInput"] | undefined | null
};
	["CourierUpsertStaffRelationInput"]: {
	update?: ValueTypes["StaffWithoutCourierUpdateInput"] | undefined | null,
	create?: ValueTypes["StaffWithoutCourierCreateInput"] | undefined | null
};
	["DeliveryMethodUpsertCourierHandlersRelationInput"]: {
	by?: ValueTypes["CourierUniqueWhere"] | undefined | null,
	update?: ValueTypes["CourierWithoutDeliveryMethodsUpdateInput"] | undefined | null,
	create?: ValueTypes["CourierWithoutDeliveryMethodsCreateInput"] | undefined | null
};
	["OrderDeliveryUpsertMethodRelationInput"]: {
	update?: ValueTypes["DeliveryMethodUpdateInput"] | undefined | null,
	create?: ValueTypes["DeliveryMethodCreateInput"] | undefined | null
};
	["DeliveryWaypointUpsertDeliveryRelationInput"]: {
	update?: ValueTypes["OrderDeliveryWithoutDeliveryWaypointUpdateInput"] | undefined | null,
	create?: ValueTypes["OrderDeliveryWithoutDeliveryWaypointCreateInput"] | undefined | null
};
	["DeliveryRouteUpsertWaypointsRelationInput"]: {
	by?: ValueTypes["DeliveryWaypointUniqueWhere"] | undefined | null,
	update?: ValueTypes["DeliveryWaypointWithoutRouteUpdateInput"] | undefined | null,
	create?: ValueTypes["DeliveryWaypointWithoutRouteCreateInput"] | undefined | null
};
	["CourierUpsertRoutesRelationInput"]: {
	by?: ValueTypes["DeliveryRouteUniqueWhere"] | undefined | null,
	update?: ValueTypes["DeliveryRouteWithoutCourierUpdateInput"] | undefined | null,
	create?: ValueTypes["DeliveryRouteWithoutCourierCreateInput"] | undefined | null
};
	["StaffUpsertCourierRelationInput"]: {
	update?: ValueTypes["CourierWithoutStaffUpdateInput"] | undefined | null,
	create?: ValueTypes["CourierWithoutStaffCreateInput"] | undefined | null
};
	["StocksManagerUpsertStaffRelationInput"]: {
	update?: ValueTypes["StaffWithoutStocksManagerUpdateInput"] | undefined | null,
	create?: ValueTypes["StaffWithoutStocksManagerCreateInput"] | undefined | null
};
	["ProductUpsertManagerRelationInput"]: {
	update?: ValueTypes["StocksManagerWithoutManagedProductsUpdateInput"] | undefined | null,
	create?: ValueTypes["StocksManagerWithoutManagedProductsCreateInput"] | undefined | null
};
	["VirtualProductUpsertProductRelationInput"]: {
	update?: ValueTypes["ProductWithoutVirtualProductUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductWithoutVirtualProductCreateInput"] | undefined | null
};
	["WorkspaceUpsertCreditsProductRelationInput"]: {
	update?: ValueTypes["VirtualProductUpdateInput"] | undefined | null,
	create?: ValueTypes["VirtualProductCreateInput"] | undefined | null
};
	["WorkspaceUpdateDiscountVatRateEntityRelationInput"]: {
	create?: ValueTypes["VatRateCreateInput"] | undefined | null,
	update?: ValueTypes["VatRateUpdateInput"] | undefined | null,
	upsert?: ValueTypes["WorkspaceUpsertDiscountVatRateRelationInput"] | undefined | null,
	connect?: ValueTypes["VatRateUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["WorkspaceUpsertDiscountVatRateRelationInput"]: {
	update?: ValueTypes["VatRateUpdateInput"] | undefined | null,
	create?: ValueTypes["VatRateCreateInput"] | undefined | null
};
	["FreshingContainerUpsertWorkspaceRelationInput"]: {
	update?: ValueTypes["WorkspaceWithoutFreshingContainersUpdateInput"] | undefined | null,
	create?: ValueTypes["WorkspaceWithoutFreshingContainersCreateInput"] | undefined | null
};
	["ProductIngredientUpsertFreshingContainerRelationInput"]: {
	update?: ValueTypes["FreshingContainerUpdateInput"] | undefined | null,
	create?: ValueTypes["FreshingContainerCreateInput"] | undefined | null
};
	["ProductIngredientUpdateImageEntityRelationInput"]: {
	create?: ValueTypes["ImageCreateInput"] | undefined | null,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductIngredientUpsertImageRelationInput"] | undefined | null,
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductIngredientUpsertImageRelationInput"]: {
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["ProductIngredientUpdateSuppliersEntityRelationInput"]: {
	create?: ValueTypes["IngredientSupplierListCreateInput"] | undefined | null,
	update?: ValueTypes["IngredientSupplierListUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductIngredientUpsertSuppliersRelationInput"] | undefined | null,
	connect?: ValueTypes["IngredientSupplierListUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["IngredientSupplierListUpdateInput"]: {
	items?: Array<ValueTypes["IngredientSupplierListUpdateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IngredientSupplierListUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["IngredientSupplierItemWithoutListCreateInput"] | undefined | null,
	update?: ValueTypes["IngredientSupplierListUpdateItemsRelationInput"] | undefined | null,
	upsert?: ValueTypes["IngredientSupplierListUpsertItemsRelationInput"] | undefined | null,
	connect?: ValueTypes["IngredientSupplierItemUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["IngredientSupplierItemUniqueWhere"] | undefined | null,
	delete?: ValueTypes["IngredientSupplierItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["IngredientSupplierListUpdateItemsRelationInput"]: {
	by?: ValueTypes["IngredientSupplierItemUniqueWhere"] | undefined | null,
	data?: ValueTypes["IngredientSupplierItemWithoutListUpdateInput"] | undefined | null
};
	["IngredientSupplierItemWithoutListUpdateInput"]: {
	order?: number | undefined | null,
	supplier?: ValueTypes["IngredientSupplierItemUpdateSupplierEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IngredientSupplierItemUpdateSupplierEntityRelationInput"]: {
	create?: ValueTypes["IngredientSupplierCreateInput"] | undefined | null,
	update?: ValueTypes["IngredientSupplierUpdateInput"] | undefined | null,
	upsert?: ValueTypes["IngredientSupplierItemUpsertSupplierRelationInput"] | undefined | null,
	connect?: ValueTypes["IngredientSupplierUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["IngredientSupplierUpdateInput"]: {
	internalName?: string | undefined | null,
	internalNote?: string | undefined | null,
	locales?: Array<ValueTypes["IngredientSupplierUpdateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IngredientSupplierUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["IngredientSupplierLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ValueTypes["IngredientSupplierUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ValueTypes["IngredientSupplierUpsertLocalesRelationInput"] | undefined | null,
	connect?: ValueTypes["IngredientSupplierLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["IngredientSupplierLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["IngredientSupplierLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["IngredientSupplierUpdateLocalesRelationInput"]: {
	by?: ValueTypes["IngredientSupplierLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["IngredientSupplierLocaleWithoutRootUpdateInput"] | undefined | null
};
	["IngredientSupplierLocaleWithoutRootUpdateInput"]: {
	name?: string | undefined | null,
	locale?: ValueTypes["IngredientSupplierLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IngredientSupplierLocaleUpdateLocaleEntityRelationInput"]: {
	create?: ValueTypes["LocaleWithoutIngredientSuppliersCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleWithoutIngredientSuppliersUpdateInput"] | undefined | null,
	upsert?: ValueTypes["IngredientSupplierLocaleUpsertLocaleRelationInput"] | undefined | null,
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutIngredientSuppliersUpdateInput"]: {
	businessCategories?: Array<ValueTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IngredientSupplierLocaleUpsertLocaleRelationInput"]: {
	update?: ValueTypes["LocaleWithoutIngredientSuppliersUpdateInput"] | undefined | null,
	create?: ValueTypes["LocaleWithoutIngredientSuppliersCreateInput"] | undefined | null
};
	["IngredientSupplierUpsertLocalesRelationInput"]: {
	by?: ValueTypes["IngredientSupplierLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["IngredientSupplierLocaleWithoutRootUpdateInput"] | undefined | null,
	create?: ValueTypes["IngredientSupplierLocaleWithoutRootCreateInput"] | undefined | null
};
	["IngredientSupplierItemUpsertSupplierRelationInput"]: {
	update?: ValueTypes["IngredientSupplierUpdateInput"] | undefined | null,
	create?: ValueTypes["IngredientSupplierCreateInput"] | undefined | null
};
	["IngredientSupplierListUpsertItemsRelationInput"]: {
	by?: ValueTypes["IngredientSupplierItemUniqueWhere"] | undefined | null,
	update?: ValueTypes["IngredientSupplierItemWithoutListUpdateInput"] | undefined | null,
	create?: ValueTypes["IngredientSupplierItemWithoutListCreateInput"] | undefined | null
};
	["ProductIngredientUpsertSuppliersRelationInput"]: {
	update?: ValueTypes["IngredientSupplierListUpdateInput"] | undefined | null,
	create?: ValueTypes["IngredientSupplierListCreateInput"] | undefined | null
};
	["AllergenUpsertIngredientsRelationInput"]: {
	by?: ValueTypes["ProductIngredientUniqueWhere"] | undefined | null,
	update?: ValueTypes["ProductIngredientWithoutAllergensUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductIngredientWithoutAllergensCreateInput"] | undefined | null
};
	["AllergenLocaleUpsertRootRelationInput"]: {
	update?: ValueTypes["AllergenWithoutLocalesUpdateInput"] | undefined | null,
	create?: ValueTypes["AllergenWithoutLocalesCreateInput"] | undefined | null
};
	["LocaleUpsertAllergensRelationInput"]: {
	by?: ValueTypes["AllergenLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["AllergenLocaleWithoutLocaleUpdateInput"] | undefined | null,
	create?: ValueTypes["AllergenLocaleWithoutLocaleCreateInput"] | undefined | null
};
	["OrderRecurrenceLocaleUpsertLocaleRelationInput"]: {
	update?: ValueTypes["LocaleWithoutOrderRecurrencesUpdateInput"] | undefined | null,
	create?: ValueTypes["LocaleWithoutOrderRecurrencesCreateInput"] | undefined | null
};
	["OrderRecurrenceUpsertLocalesRelationInput"]: {
	by?: ValueTypes["OrderRecurrenceLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["OrderRecurrenceLocaleWithoutRootUpdateInput"] | undefined | null,
	create?: ValueTypes["OrderRecurrenceLocaleWithoutRootCreateInput"] | undefined | null
};
	["BusinessCategoryUpsertRecurrencesRelationInput"]: {
	by?: ValueTypes["OrderRecurrenceUniqueWhere"] | undefined | null,
	update?: ValueTypes["OrderRecurrenceWithoutBusinessCategoryUpdateInput"] | undefined | null,
	create?: ValueTypes["OrderRecurrenceWithoutBusinessCategoryCreateInput"] | undefined | null
};
	["BusinessCategoryUpdateSpecificProductsEntityRelationInput"]: {
	create?: ValueTypes["ProductListWithoutBusinessCategoryCreateInput"] | undefined | null,
	update?: ValueTypes["ProductListWithoutBusinessCategoryUpdateInput"] | undefined | null,
	upsert?: ValueTypes["BusinessCategoryUpsertSpecificProductsRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductListUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductListWithoutBusinessCategoryUpdateInput"]: {
	items?: Array<ValueTypes["ProductListUpdateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductListUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["ProductListItemWithoutListCreateInput"] | undefined | null,
	update?: ValueTypes["ProductListUpdateItemsRelationInput"] | undefined | null,
	upsert?: ValueTypes["ProductListUpsertItemsRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductListItemUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductListItemUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductListItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductListUpdateItemsRelationInput"]: {
	by?: ValueTypes["ProductListItemUniqueWhere"] | undefined | null,
	data?: ValueTypes["ProductListItemWithoutListUpdateInput"] | undefined | null
};
	["ProductListItemWithoutListUpdateInput"]: {
	order?: number | undefined | null,
	product?: ValueTypes["ProductListItemUpdateProductEntityRelationInput"] | undefined | null,
	defaultQuantityForOrder?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductListItemUpdateProductEntityRelationInput"]: {
	create?: ValueTypes["ProductCreateInput"] | undefined | null,
	update?: ValueTypes["ProductUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductListItemUpsertProductRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductListItemUpsertProductRelationInput"]: {
	update?: ValueTypes["ProductUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductCreateInput"] | undefined | null
};
	["ProductListUpsertItemsRelationInput"]: {
	by?: ValueTypes["ProductListItemUniqueWhere"] | undefined | null,
	update?: ValueTypes["ProductListItemWithoutListUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductListItemWithoutListCreateInput"] | undefined | null
};
	["BusinessCategoryUpsertSpecificProductsRelationInput"]: {
	update?: ValueTypes["ProductListWithoutBusinessCategoryUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductListWithoutBusinessCategoryCreateInput"] | undefined | null
};
	["BusinessCategoryUpdateSeasonalProductCategoriesEntityRelationInput"]: {
	create?: ValueTypes["ProductCategoryListWithoutSeasonalProductCategoriesOfBusinessCategoryCreateInput"] | undefined | null,
	update?: ValueTypes["ProductCategoryListWithoutSeasonalProductCategoriesOfBusinessCategoryUpdateInput"] | undefined | null,
	upsert?: ValueTypes["BusinessCategoryUpsertSeasonalProductCategoriesRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductCategoryListUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductCategoryListWithoutSeasonalProductCategoriesOfBusinessCategoryUpdateInput"]: {
	items?: Array<ValueTypes["ProductCategoryListUpdateItemsEntityRelationInput"]> | undefined | null,
	locales?: Array<ValueTypes["ProductCategoryListUpdateLocalesEntityRelationInput"]> | undefined | null,
	specificProductsProductCategoriesOfBusinessCategory?: ValueTypes["ProductCategoryListUpdateSpecificProductsProductCategoriesOfBusinessCategoryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCategoryListUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["ProductCategoryListLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ValueTypes["ProductCategoryListUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ValueTypes["ProductCategoryListUpsertLocalesRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductCategoryListLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductCategoryListLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductCategoryListLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductCategoryListUpdateLocalesRelationInput"]: {
	by?: ValueTypes["ProductCategoryListLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["ProductCategoryListLocaleWithoutRootUpdateInput"] | undefined | null
};
	["ProductCategoryListLocaleWithoutRootUpdateInput"]: {
	name?: string | undefined | null,
	locale?: ValueTypes["ProductCategoryListLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCategoryListLocaleUpdateLocaleEntityRelationInput"]: {
	create?: ValueTypes["LocaleWithoutProductCategoryListsCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleWithoutProductCategoryListsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductCategoryListLocaleUpsertLocaleRelationInput"] | undefined | null,
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutProductCategoryListsUpdateInput"]: {
	businessCategories?: Array<ValueTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCategoryListLocaleUpsertLocaleRelationInput"]: {
	update?: ValueTypes["LocaleWithoutProductCategoryListsUpdateInput"] | undefined | null,
	create?: ValueTypes["LocaleWithoutProductCategoryListsCreateInput"] | undefined | null
};
	["ProductCategoryListUpsertLocalesRelationInput"]: {
	by?: ValueTypes["ProductCategoryListLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["ProductCategoryListLocaleWithoutRootUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductCategoryListLocaleWithoutRootCreateInput"] | undefined | null
};
	["ProductCategoryListUpdateSpecificProductsProductCategoriesOfBusinessCategoryEntityRelationInput"]: {
	create?: ValueTypes["BusinessCategoryWithoutSpecificProductsProductCategoriesCreateInput"] | undefined | null,
	update?: ValueTypes["BusinessCategoryWithoutSpecificProductsProductCategoriesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductCategoryListUpsertSpecificProductsProductCategoriesOfBusinessCategoryRelationInput"] | undefined | null,
	connect?: ValueTypes["BusinessCategoryUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["BusinessCategoryWithoutSpecificProductsProductCategoriesUpdateInput"]: {
	order?: number | undefined | null,
	visibleToNewCustomers?: boolean | undefined | null,
	locales?: Array<ValueTypes["BusinessCategoryUpdateLocalesEntityRelationInput"]> | undefined | null,
	internalName?: string | undefined | null,
	businessCustomers?: Array<ValueTypes["BusinessCategoryUpdateBusinessCustomersEntityRelationInput"]> | undefined | null,
	recurrences?: Array<ValueTypes["BusinessCategoryUpdateRecurrencesEntityRelationInput"]> | undefined | null,
	specificProducts?: ValueTypes["BusinessCategoryUpdateSpecificProductsEntityRelationInput"] | undefined | null,
	seasonalProductCategories?: ValueTypes["BusinessCategoryUpdateSeasonalProductCategoriesEntityRelationInput"] | undefined | null,
	slug?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCategoryListUpsertSpecificProductsProductCategoriesOfBusinessCategoryRelationInput"]: {
	update?: ValueTypes["BusinessCategoryWithoutSpecificProductsProductCategoriesUpdateInput"] | undefined | null,
	create?: ValueTypes["BusinessCategoryWithoutSpecificProductsProductCategoriesCreateInput"] | undefined | null
};
	["BusinessCategoryUpsertSeasonalProductCategoriesRelationInput"]: {
	update?: ValueTypes["ProductCategoryListWithoutSeasonalProductCategoriesOfBusinessCategoryUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductCategoryListWithoutSeasonalProductCategoriesOfBusinessCategoryCreateInput"] | undefined | null
};
	["BusinessCategoryUpdateSpecificProductsProductCategoriesEntityRelationInput"]: {
	create?: ValueTypes["ProductCategoryListWithoutSpecificProductsProductCategoriesOfBusinessCategoryCreateInput"] | undefined | null,
	update?: ValueTypes["ProductCategoryListWithoutSpecificProductsProductCategoriesOfBusinessCategoryUpdateInput"] | undefined | null,
	upsert?: ValueTypes["BusinessCategoryUpsertSpecificProductsProductCategoriesRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductCategoryListUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductCategoryListWithoutSpecificProductsProductCategoriesOfBusinessCategoryUpdateInput"]: {
	items?: Array<ValueTypes["ProductCategoryListUpdateItemsEntityRelationInput"]> | undefined | null,
	locales?: Array<ValueTypes["ProductCategoryListUpdateLocalesEntityRelationInput"]> | undefined | null,
	seasonalProductCategoriesOfBusinessCategory?: ValueTypes["ProductCategoryListUpdateSeasonalProductCategoriesOfBusinessCategoryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCategoryListUpdateSeasonalProductCategoriesOfBusinessCategoryEntityRelationInput"]: {
	create?: ValueTypes["BusinessCategoryWithoutSeasonalProductCategoriesCreateInput"] | undefined | null,
	update?: ValueTypes["BusinessCategoryWithoutSeasonalProductCategoriesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductCategoryListUpsertSeasonalProductCategoriesOfBusinessCategoryRelationInput"] | undefined | null,
	connect?: ValueTypes["BusinessCategoryUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["BusinessCategoryWithoutSeasonalProductCategoriesUpdateInput"]: {
	order?: number | undefined | null,
	visibleToNewCustomers?: boolean | undefined | null,
	locales?: Array<ValueTypes["BusinessCategoryUpdateLocalesEntityRelationInput"]> | undefined | null,
	internalName?: string | undefined | null,
	businessCustomers?: Array<ValueTypes["BusinessCategoryUpdateBusinessCustomersEntityRelationInput"]> | undefined | null,
	recurrences?: Array<ValueTypes["BusinessCategoryUpdateRecurrencesEntityRelationInput"]> | undefined | null,
	specificProducts?: ValueTypes["BusinessCategoryUpdateSpecificProductsEntityRelationInput"] | undefined | null,
	specificProductsProductCategories?: ValueTypes["BusinessCategoryUpdateSpecificProductsProductCategoriesEntityRelationInput"] | undefined | null,
	slug?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCategoryListUpsertSeasonalProductCategoriesOfBusinessCategoryRelationInput"]: {
	update?: ValueTypes["BusinessCategoryWithoutSeasonalProductCategoriesUpdateInput"] | undefined | null,
	create?: ValueTypes["BusinessCategoryWithoutSeasonalProductCategoriesCreateInput"] | undefined | null
};
	["BusinessCategoryUpsertSpecificProductsProductCategoriesRelationInput"]: {
	update?: ValueTypes["ProductCategoryListWithoutSpecificProductsProductCategoriesOfBusinessCategoryUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductCategoryListWithoutSpecificProductsProductCategoriesOfBusinessCategoryCreateInput"] | undefined | null
};
	["BusinessCustomerUpsertCategoryRelationInput"]: {
	update?: ValueTypes["BusinessCategoryWithoutBusinessCustomersUpdateInput"] | undefined | null,
	create?: ValueTypes["BusinessCategoryWithoutBusinessCustomersCreateInput"] | undefined | null
};
	["CustomerUpsertMemberOfBusinessesRelationInput"]: {
	by?: ValueTypes["BusinessCustomerUniqueWhere"] | undefined | null,
	update?: ValueTypes["BusinessCustomerWithoutMembersUpdateInput"] | undefined | null,
	create?: ValueTypes["BusinessCustomerWithoutMembersCreateInput"] | undefined | null
};
	["BusinessCustomerUpsertOwnersRelationInput"]: {
	by?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	update?: ValueTypes["CustomerWithoutOwnerOfBusinessesUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerWithoutOwnerOfBusinessesCreateInput"] | undefined | null
};
	["CustomerUpsertBusinessRelationInput"]: {
	update?: ValueTypes["BusinessCustomerWithoutCustomerUpdateInput"] | undefined | null,
	create?: ValueTypes["BusinessCustomerWithoutCustomerCreateInput"] | undefined | null
};
	["CustomerIngredientRatingUpsertCustomerRelationInput"]: {
	update?: ValueTypes["CustomerWithoutIngredientRatingsUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerWithoutIngredientRatingsCreateInput"] | undefined | null
};
	["ProductIngredientUpsertCustomerRatingsRelationInput"]: {
	by?: ValueTypes["CustomerIngredientRatingUniqueWhere"] | undefined | null,
	update?: ValueTypes["CustomerIngredientRatingWithoutIngredientUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerIngredientRatingWithoutIngredientCreateInput"] | undefined | null
};
	["ProductIngredientCategoryUpsertIngredientsRelationInput"]: {
	by?: ValueTypes["ProductIngredientUniqueWhere"] | undefined | null,
	update?: ValueTypes["ProductIngredientWithoutCategoriesUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductIngredientWithoutCategoriesCreateInput"] | undefined | null
};
	["ProductIngredientCategoryLocaleUpsertRootRelationInput"]: {
	update?: ValueTypes["ProductIngredientCategoryWithoutLocalesUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductIngredientCategoryWithoutLocalesCreateInput"] | undefined | null
};
	["LocaleUpsertProductIngredientCategoriesRelationInput"]: {
	by?: ValueTypes["ProductIngredientCategoryLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["ProductIngredientCategoryLocaleWithoutLocaleUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductIngredientCategoryLocaleWithoutLocaleCreateInput"] | undefined | null
};
	["PageLocaleUpsertLocaleRelationInput"]: {
	update?: ValueTypes["LocaleWithoutPagesUpdateInput"] | undefined | null,
	create?: ValueTypes["LocaleWithoutPagesCreateInput"] | undefined | null
};
	["LinkableUpsertPageRelationInput"]: {
	update?: ValueTypes["PageLocaleWithoutLinkUpdateInput"] | undefined | null,
	create?: ValueTypes["PageLocaleWithoutLinkCreateInput"] | undefined | null
};
	["LinkableUpdateRedirectEntityRelationInput"]: {
	create?: ValueTypes["RedirectWithoutLinkCreateInput"] | undefined | null,
	update?: ValueTypes["RedirectWithoutLinkUpdateInput"] | undefined | null,
	upsert?: ValueTypes["LinkableUpsertRedirectRelationInput"] | undefined | null,
	connect?: ValueTypes["RedirectUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["RedirectWithoutLinkUpdateInput"]: {
	target?: ValueTypes["RedirectUpdateTargetEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RedirectUpdateTargetEntityRelationInput"]: {
	create?: ValueTypes["LinkCreateInput"] | undefined | null,
	update?: ValueTypes["LinkUpdateInput"] | undefined | null,
	upsert?: ValueTypes["RedirectUpsertTargetRelationInput"] | undefined | null,
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["RedirectUpsertTargetRelationInput"]: {
	update?: ValueTypes["LinkUpdateInput"] | undefined | null,
	create?: ValueTypes["LinkCreateInput"] | undefined | null
};
	["LinkableUpsertRedirectRelationInput"]: {
	update?: ValueTypes["RedirectWithoutLinkUpdateInput"] | undefined | null,
	create?: ValueTypes["RedirectWithoutLinkCreateInput"] | undefined | null
};
	["WikiPageUpsertLinkRelationInput"]: {
	update?: ValueTypes["LinkableWithoutWikiPageUpdateInput"] | undefined | null,
	create?: ValueTypes["LinkableWithoutWikiPageCreateInput"] | undefined | null
};
	["WikiPageUpdateContentEntityRelationInput"]: {
	create?: ValueTypes["ContentCreateInput"] | undefined | null,
	update?: ValueTypes["ContentUpdateInput"] | undefined | null,
	upsert?: ValueTypes["WikiPageUpsertContentRelationInput"] | undefined | null,
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["WikiPageUpsertContentRelationInput"]: {
	update?: ValueTypes["ContentUpdateInput"] | undefined | null,
	create?: ValueTypes["ContentCreateInput"] | undefined | null
};
	["WikiPageUpsertParentRelationInput"]: {
	update?: ValueTypes["WikiPageWithoutChildrenUpdateInput"] | undefined | null,
	create?: ValueTypes["WikiPageWithoutChildrenCreateInput"] | undefined | null
};
	["WikiPageUpdateChildrenEntityRelationInput"]: {
	create?: ValueTypes["WikiPageWithoutParentCreateInput"] | undefined | null,
	update?: ValueTypes["WikiPageUpdateChildrenRelationInput"] | undefined | null,
	upsert?: ValueTypes["WikiPageUpsertChildrenRelationInput"] | undefined | null,
	connect?: ValueTypes["WikiPageUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["WikiPageUniqueWhere"] | undefined | null,
	delete?: ValueTypes["WikiPageUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["WikiPageUpdateChildrenRelationInput"]: {
	by?: ValueTypes["WikiPageUniqueWhere"] | undefined | null,
	data?: ValueTypes["WikiPageWithoutParentUpdateInput"] | undefined | null
};
	["WikiPageWithoutParentUpdateInput"]: {
	order?: number | undefined | null,
	title?: string | undefined | null,
	emoji?: string | undefined | null,
	link?: ValueTypes["WikiPageUpdateLinkEntityRelationInput"] | undefined | null,
	children?: Array<ValueTypes["WikiPageUpdateChildrenEntityRelationInput"]> | undefined | null,
	content?: ValueTypes["WikiPageUpdateContentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["WikiPageUpsertChildrenRelationInput"]: {
	by?: ValueTypes["WikiPageUniqueWhere"] | undefined | null,
	update?: ValueTypes["WikiPageWithoutParentUpdateInput"] | undefined | null,
	create?: ValueTypes["WikiPageWithoutParentCreateInput"] | undefined | null
};
	["LinkableUpsertWikiPageRelationInput"]: {
	update?: ValueTypes["WikiPageWithoutLinkUpdateInput"] | undefined | null,
	create?: ValueTypes["WikiPageWithoutLinkCreateInput"] | undefined | null
};
	["PageLocaleUpsertLinkRelationInput"]: {
	update?: ValueTypes["LinkableWithoutPageUpdateInput"] | undefined | null,
	create?: ValueTypes["LinkableWithoutPageCreateInput"] | undefined | null
};
	["LocaleUpsertPagesRelationInput"]: {
	by?: ValueTypes["PageLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["PageLocaleWithoutLocaleUpdateInput"] | undefined | null,
	create?: ValueTypes["PageLocaleWithoutLocaleCreateInput"] | undefined | null
};
	["BlogPostLocaleUpsertLocaleRelationInput"]: {
	update?: ValueTypes["LocaleWithoutBlogPostsUpdateInput"] | undefined | null,
	create?: ValueTypes["LocaleWithoutBlogPostsCreateInput"] | undefined | null
};
	["BlogPostLocaleUpdateSeoEntityRelationInput"]: {
	create?: ValueTypes["SeoCreateInput"] | undefined | null,
	update?: ValueTypes["SeoUpdateInput"] | undefined | null,
	upsert?: ValueTypes["BlogPostLocaleUpsertSeoRelationInput"] | undefined | null,
	connect?: ValueTypes["SeoUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["BlogPostLocaleUpsertSeoRelationInput"]: {
	update?: ValueTypes["SeoUpdateInput"] | undefined | null,
	create?: ValueTypes["SeoCreateInput"] | undefined | null
};
	["BlogPostLocaleUpdateProductsEntityRelationInput"]: {
	create?: ValueTypes["ProductCreateInput"] | undefined | null,
	update?: ValueTypes["BlogPostLocaleUpdateProductsRelationInput"] | undefined | null,
	upsert?: ValueTypes["BlogPostLocaleUpsertProductsRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["BlogPostLocaleUpdateProductsRelationInput"]: {
	by?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	data?: ValueTypes["ProductUpdateInput"] | undefined | null
};
	["BlogPostLocaleUpsertProductsRelationInput"]: {
	by?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	update?: ValueTypes["ProductUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductCreateInput"] | undefined | null
};
	["LinkableUpsertBlogPostRelationInput"]: {
	update?: ValueTypes["BlogPostLocaleWithoutLinkUpdateInput"] | undefined | null,
	create?: ValueTypes["BlogPostLocaleWithoutLinkCreateInput"] | undefined | null
};
	["LinkUpsertInternalLinkRelationInput"]: {
	update?: ValueTypes["LinkableUpdateInput"] | undefined | null,
	create?: ValueTypes["LinkableCreateInput"] | undefined | null
};
	["ContentReferenceUpsertLinkRelationInput"]: {
	update?: ValueTypes["LinkUpdateInput"] | undefined | null,
	create?: ValueTypes["LinkCreateInput"] | undefined | null
};
	["ContentReferenceUpdateBlogPostsEntityRelationInput"]: {
	create?: ValueTypes["BlogPostListCreateInput"] | undefined | null,
	update?: ValueTypes["BlogPostListUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ContentReferenceUpsertBlogPostsRelationInput"] | undefined | null,
	connect?: ValueTypes["BlogPostListUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["BlogPostListUpdateInput"]: {
	items?: Array<ValueTypes["BlogPostListUpdateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BlogPostListUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["BlogPostListItemWithoutListCreateInput"] | undefined | null,
	update?: ValueTypes["BlogPostListUpdateItemsRelationInput"] | undefined | null,
	upsert?: ValueTypes["BlogPostListUpsertItemsRelationInput"] | undefined | null,
	connect?: ValueTypes["BlogPostListItemUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["BlogPostListItemUniqueWhere"] | undefined | null,
	delete?: ValueTypes["BlogPostListItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["BlogPostListUpdateItemsRelationInput"]: {
	by?: ValueTypes["BlogPostListItemUniqueWhere"] | undefined | null,
	data?: ValueTypes["BlogPostListItemWithoutListUpdateInput"] | undefined | null
};
	["BlogPostListItemWithoutListUpdateInput"]: {
	order?: number | undefined | null,
	caption?: string | undefined | null,
	blogPost?: ValueTypes["BlogPostListItemUpdateBlogPostEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BlogPostListItemUpdateBlogPostEntityRelationInput"]: {
	create?: ValueTypes["BlogPostLocaleCreateInput"] | undefined | null,
	update?: ValueTypes["BlogPostLocaleUpdateInput"] | undefined | null,
	upsert?: ValueTypes["BlogPostListItemUpsertBlogPostRelationInput"] | undefined | null,
	connect?: ValueTypes["BlogPostLocaleUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["BlogPostLocaleUpdateInput"]: {
	title?: string | undefined | null,
	availableForWeb?: boolean | undefined | null,
	availableForMobile?: boolean | undefined | null,
	root?: ValueTypes["BlogPostLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["BlogPostLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	cover?: ValueTypes["BlogPostLocaleUpdateCoverEntityRelationInput"] | undefined | null,
	content?: ValueTypes["BlogPostLocaleUpdateContentEntityRelationInput"] | undefined | null,
	link?: ValueTypes["BlogPostLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	seo?: ValueTypes["BlogPostLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	products?: Array<ValueTypes["BlogPostLocaleUpdateProductsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BlogPostLocaleUpdateLinkEntityRelationInput"]: {
	create?: ValueTypes["LinkableWithoutBlogPostCreateInput"] | undefined | null,
	update?: ValueTypes["LinkableWithoutBlogPostUpdateInput"] | undefined | null,
	upsert?: ValueTypes["BlogPostLocaleUpsertLinkRelationInput"] | undefined | null,
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["LinkableWithoutBlogPostUpdateInput"]: {
	url?: string | undefined | null,
	page?: ValueTypes["LinkableUpdatePageEntityRelationInput"] | undefined | null,
	wikiPage?: ValueTypes["LinkableUpdateWikiPageEntityRelationInput"] | undefined | null,
	redirect?: ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BlogPostLocaleUpsertLinkRelationInput"]: {
	update?: ValueTypes["LinkableWithoutBlogPostUpdateInput"] | undefined | null,
	create?: ValueTypes["LinkableWithoutBlogPostCreateInput"] | undefined | null
};
	["BlogPostListItemUpsertBlogPostRelationInput"]: {
	update?: ValueTypes["BlogPostLocaleUpdateInput"] | undefined | null,
	create?: ValueTypes["BlogPostLocaleCreateInput"] | undefined | null
};
	["BlogPostListUpsertItemsRelationInput"]: {
	by?: ValueTypes["BlogPostListItemUniqueWhere"] | undefined | null,
	update?: ValueTypes["BlogPostListItemWithoutListUpdateInput"] | undefined | null,
	create?: ValueTypes["BlogPostListItemWithoutListCreateInput"] | undefined | null
};
	["ContentReferenceUpsertBlogPostsRelationInput"]: {
	update?: ValueTypes["BlogPostListUpdateInput"] | undefined | null,
	create?: ValueTypes["BlogPostListCreateInput"] | undefined | null
};
	["ContentReferenceUpdateLinksEntityRelationInput"]: {
	create?: ValueTypes["LinkListCreateInput"] | undefined | null,
	update?: ValueTypes["LinkListUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ContentReferenceUpsertLinksRelationInput"] | undefined | null,
	connect?: ValueTypes["LinkListUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ContentReferenceUpsertLinksRelationInput"]: {
	update?: ValueTypes["LinkListUpdateInput"] | undefined | null,
	create?: ValueTypes["LinkListCreateInput"] | undefined | null
};
	["ContentReferenceUpdateProductsEntityRelationInput"]: {
	create?: ValueTypes["ProductListCreateInput"] | undefined | null,
	update?: ValueTypes["ProductListUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ContentReferenceUpsertProductsRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductListUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductListUpdateInput"]: {
	items?: Array<ValueTypes["ProductListUpdateItemsEntityRelationInput"]> | undefined | null,
	businessCategory?: ValueTypes["ProductListUpdateBusinessCategoryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductListUpdateBusinessCategoryEntityRelationInput"]: {
	create?: ValueTypes["BusinessCategoryWithoutSpecificProductsCreateInput"] | undefined | null,
	update?: ValueTypes["BusinessCategoryWithoutSpecificProductsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductListUpsertBusinessCategoryRelationInput"] | undefined | null,
	connect?: ValueTypes["BusinessCategoryUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["BusinessCategoryWithoutSpecificProductsUpdateInput"]: {
	order?: number | undefined | null,
	visibleToNewCustomers?: boolean | undefined | null,
	locales?: Array<ValueTypes["BusinessCategoryUpdateLocalesEntityRelationInput"]> | undefined | null,
	internalName?: string | undefined | null,
	businessCustomers?: Array<ValueTypes["BusinessCategoryUpdateBusinessCustomersEntityRelationInput"]> | undefined | null,
	recurrences?: Array<ValueTypes["BusinessCategoryUpdateRecurrencesEntityRelationInput"]> | undefined | null,
	seasonalProductCategories?: ValueTypes["BusinessCategoryUpdateSeasonalProductCategoriesEntityRelationInput"] | undefined | null,
	specificProductsProductCategories?: ValueTypes["BusinessCategoryUpdateSpecificProductsProductCategoriesEntityRelationInput"] | undefined | null,
	slug?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductListUpsertBusinessCategoryRelationInput"]: {
	update?: ValueTypes["BusinessCategoryWithoutSpecificProductsUpdateInput"] | undefined | null,
	create?: ValueTypes["BusinessCategoryWithoutSpecificProductsCreateInput"] | undefined | null
};
	["ContentReferenceUpsertProductsRelationInput"]: {
	update?: ValueTypes["ProductListUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductListCreateInput"] | undefined | null
};
	["ContentReferenceUpdateHeroEntityRelationInput"]: {
	create?: ValueTypes["HeroCreateInput"] | undefined | null,
	update?: ValueTypes["HeroUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ContentReferenceUpsertHeroRelationInput"] | undefined | null,
	connect?: ValueTypes["HeroUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["HeroUpdateInput"]: {
	showLogo?: boolean | undefined | null,
	middleContent?: string | undefined | null,
	medium?: ValueTypes["HeroUpdateMediumEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["HeroUpdateMediumEntityRelationInput"]: {
	create?: ValueTypes["MediumCreateInput"] | undefined | null,
	update?: ValueTypes["MediumUpdateInput"] | undefined | null,
	upsert?: ValueTypes["HeroUpsertMediumRelationInput"] | undefined | null,
	connect?: ValueTypes["MediumUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["HeroUpsertMediumRelationInput"]: {
	update?: ValueTypes["MediumUpdateInput"] | undefined | null,
	create?: ValueTypes["MediumCreateInput"] | undefined | null
};
	["ContentReferenceUpsertHeroRelationInput"]: {
	update?: ValueTypes["HeroUpdateInput"] | undefined | null,
	create?: ValueTypes["HeroCreateInput"] | undefined | null
};
	["ContentReferenceUpdateGalleryEntityRelationInput"]: {
	create?: ValueTypes["GalleryCreateInput"] | undefined | null,
	update?: ValueTypes["GalleryUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ContentReferenceUpsertGalleryRelationInput"] | undefined | null,
	connect?: ValueTypes["GalleryUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["GalleryUpdateInput"]: {
	items?: Array<ValueTypes["GalleryUpdateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GalleryUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["GalleryItemWithoutListCreateInput"] | undefined | null,
	update?: ValueTypes["GalleryUpdateItemsRelationInput"] | undefined | null,
	upsert?: ValueTypes["GalleryUpsertItemsRelationInput"] | undefined | null,
	connect?: ValueTypes["GalleryItemUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["GalleryItemUniqueWhere"] | undefined | null,
	delete?: ValueTypes["GalleryItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["GalleryUpdateItemsRelationInput"]: {
	by?: ValueTypes["GalleryItemUniqueWhere"] | undefined | null,
	data?: ValueTypes["GalleryItemWithoutListUpdateInput"] | undefined | null
};
	["GalleryItemWithoutListUpdateInput"]: {
	order?: number | undefined | null,
	caption?: string | undefined | null,
	medium?: ValueTypes["GalleryItemUpdateMediumEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GalleryItemUpdateMediumEntityRelationInput"]: {
	create?: ValueTypes["MediumCreateInput"] | undefined | null,
	update?: ValueTypes["MediumUpdateInput"] | undefined | null,
	upsert?: ValueTypes["GalleryItemUpsertMediumRelationInput"] | undefined | null,
	connect?: ValueTypes["MediumUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["GalleryItemUpsertMediumRelationInput"]: {
	update?: ValueTypes["MediumUpdateInput"] | undefined | null,
	create?: ValueTypes["MediumCreateInput"] | undefined | null
};
	["GalleryUpsertItemsRelationInput"]: {
	by?: ValueTypes["GalleryItemUniqueWhere"] | undefined | null,
	update?: ValueTypes["GalleryItemWithoutListUpdateInput"] | undefined | null,
	create?: ValueTypes["GalleryItemWithoutListCreateInput"] | undefined | null
};
	["ContentReferenceUpsertGalleryRelationInput"]: {
	update?: ValueTypes["GalleryUpdateInput"] | undefined | null,
	create?: ValueTypes["GalleryCreateInput"] | undefined | null
};
	["ContentReferenceUpdateSocialsAndAppsEntityRelationInput"]: {
	create?: ValueTypes["SocialsAndAppsCreateInput"] | undefined | null,
	update?: ValueTypes["SocialsAndAppsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ContentReferenceUpsertSocialsAndAppsRelationInput"] | undefined | null,
	connect?: ValueTypes["SocialsAndAppsUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ContentReferenceUpsertSocialsAndAppsRelationInput"]: {
	update?: ValueTypes["SocialsAndAppsUpdateInput"] | undefined | null,
	create?: ValueTypes["SocialsAndAppsCreateInput"] | undefined | null
};
	["ContentReferenceUpdateProductGridEntityRelationInput"]: {
	create?: ValueTypes["ProductGridCreateInput"] | undefined | null,
	update?: ValueTypes["ProductGridUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ContentReferenceUpsertProductGridRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductGridUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductGridUpdateInput"]: {
	isCarousel?: boolean | undefined | null,
	categories?: Array<ValueTypes["ProductGridUpdateCategoriesEntityRelationInput"]> | undefined | null,
	type?: ValueTypes["ProductGridType"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductGridUpdateCategoriesEntityRelationInput"]: {
	create?: ValueTypes["ProductGridCategoryWithoutRootCreateInput"] | undefined | null,
	update?: ValueTypes["ProductGridUpdateCategoriesRelationInput"] | undefined | null,
	upsert?: ValueTypes["ProductGridUpsertCategoriesRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductGridCategoryUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductGridCategoryUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductGridCategoryUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductGridUpdateCategoriesRelationInput"]: {
	by?: ValueTypes["ProductGridCategoryUniqueWhere"] | undefined | null,
	data?: ValueTypes["ProductGridCategoryWithoutRootUpdateInput"] | undefined | null
};
	["ProductGridCategoryWithoutRootUpdateInput"]: {
	order?: number | undefined | null,
	title?: string | undefined | null,
	items?: Array<ValueTypes["ProductGridCategoryUpdateItemsEntityRelationInput"]> | undefined | null,
	images?: ValueTypes["ProductGridCategoryUpdateImagesEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductGridCategoryUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["ProductGridItemWithoutCategoryCreateInput"] | undefined | null,
	update?: ValueTypes["ProductGridCategoryUpdateItemsRelationInput"] | undefined | null,
	upsert?: ValueTypes["ProductGridCategoryUpsertItemsRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductGridItemUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductGridItemUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductGridItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductGridCategoryUpdateItemsRelationInput"]: {
	by?: ValueTypes["ProductGridItemUniqueWhere"] | undefined | null,
	data?: ValueTypes["ProductGridItemWithoutCategoryUpdateInput"] | undefined | null
};
	["ProductGridItemWithoutCategoryUpdateInput"]: {
	order?: number | undefined | null,
	title?: string | undefined | null,
	lead?: string | undefined | null,
	product?: ValueTypes["ProductGridItemUpdateProductEntityRelationInput"] | undefined | null,
	medium?: ValueTypes["ProductGridItemUpdateMediumEntityRelationInput"] | undefined | null,
	link?: ValueTypes["ProductGridItemUpdateLinkEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductGridItemUpdateProductEntityRelationInput"]: {
	create?: ValueTypes["ProductCreateInput"] | undefined | null,
	update?: ValueTypes["ProductUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductGridItemUpsertProductRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductGridItemUpsertProductRelationInput"]: {
	update?: ValueTypes["ProductUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductCreateInput"] | undefined | null
};
	["ProductGridItemUpdateMediumEntityRelationInput"]: {
	create?: ValueTypes["MediumCreateInput"] | undefined | null,
	update?: ValueTypes["MediumUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductGridItemUpsertMediumRelationInput"] | undefined | null,
	connect?: ValueTypes["MediumUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductGridItemUpsertMediumRelationInput"]: {
	update?: ValueTypes["MediumUpdateInput"] | undefined | null,
	create?: ValueTypes["MediumCreateInput"] | undefined | null
};
	["ProductGridItemUpdateLinkEntityRelationInput"]: {
	create?: ValueTypes["LinkCreateInput"] | undefined | null,
	update?: ValueTypes["LinkUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductGridItemUpsertLinkRelationInput"] | undefined | null,
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductGridItemUpsertLinkRelationInput"]: {
	update?: ValueTypes["LinkUpdateInput"] | undefined | null,
	create?: ValueTypes["LinkCreateInput"] | undefined | null
};
	["ProductGridCategoryUpsertItemsRelationInput"]: {
	by?: ValueTypes["ProductGridItemUniqueWhere"] | undefined | null,
	update?: ValueTypes["ProductGridItemWithoutCategoryUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductGridItemWithoutCategoryCreateInput"] | undefined | null
};
	["ProductGridCategoryUpdateImagesEntityRelationInput"]: {
	create?: ValueTypes["ImageListCreateInput"] | undefined | null,
	update?: ValueTypes["ImageListUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductGridCategoryUpsertImagesRelationInput"] | undefined | null,
	connect?: ValueTypes["ImageListUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductGridCategoryUpsertImagesRelationInput"]: {
	update?: ValueTypes["ImageListUpdateInput"] | undefined | null,
	create?: ValueTypes["ImageListCreateInput"] | undefined | null
};
	["ProductGridUpsertCategoriesRelationInput"]: {
	by?: ValueTypes["ProductGridCategoryUniqueWhere"] | undefined | null,
	update?: ValueTypes["ProductGridCategoryWithoutRootUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductGridCategoryWithoutRootCreateInput"] | undefined | null
};
	["ContentReferenceUpsertProductGridRelationInput"]: {
	update?: ValueTypes["ProductGridUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductGridCreateInput"] | undefined | null
};
	["ContentReferenceUpdateProductBannersEntityRelationInput"]: {
	create?: ValueTypes["ProductBannerListCreateInput"] | undefined | null,
	update?: ValueTypes["ProductBannerListUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ContentReferenceUpsertProductBannersRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductBannerListUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductBannerListUpdateInput"]: {
	items?: Array<ValueTypes["ProductBannerListUpdateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductBannerListUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["ProductBannerItemWithoutListCreateInput"] | undefined | null,
	update?: ValueTypes["ProductBannerListUpdateItemsRelationInput"] | undefined | null,
	upsert?: ValueTypes["ProductBannerListUpsertItemsRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductBannerItemUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ProductBannerItemUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ProductBannerItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ProductBannerListUpdateItemsRelationInput"]: {
	by?: ValueTypes["ProductBannerItemUniqueWhere"] | undefined | null,
	data?: ValueTypes["ProductBannerItemWithoutListUpdateInput"] | undefined | null
};
	["ProductBannerItemWithoutListUpdateInput"]: {
	order?: number | undefined | null,
	banner?: ValueTypes["ProductBannerItemUpdateBannerEntityRelationInput"] | undefined | null,
	size?: ValueTypes["ProductBannerItemSize"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductBannerItemUpdateBannerEntityRelationInput"]: {
	create?: ValueTypes["ProductBannerCreateInput"] | undefined | null,
	update?: ValueTypes["ProductBannerUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductBannerItemUpsertBannerRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductBannerUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductBannerUpdateInput"]: {
	beforeTitle?: string | undefined | null,
	title?: string | undefined | null,
	label?: string | undefined | null,
	button?: ValueTypes["ProductBannerUpdateButtonEntityRelationInput"] | undefined | null,
	backgroundImage?: ValueTypes["ProductBannerUpdateBackgroundImageEntityRelationInput"] | undefined | null,
	productImage?: ValueTypes["ProductBannerUpdateProductImageEntityRelationInput"] | undefined | null,
	product?: ValueTypes["ProductBannerUpdateProductEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductBannerUpdateButtonEntityRelationInput"]: {
	create?: ValueTypes["LinkCreateInput"] | undefined | null,
	update?: ValueTypes["LinkUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductBannerUpsertButtonRelationInput"] | undefined | null,
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductBannerUpsertButtonRelationInput"]: {
	update?: ValueTypes["LinkUpdateInput"] | undefined | null,
	create?: ValueTypes["LinkCreateInput"] | undefined | null
};
	["ProductBannerUpdateBackgroundImageEntityRelationInput"]: {
	create?: ValueTypes["ImageCreateInput"] | undefined | null,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductBannerUpsertBackgroundImageRelationInput"] | undefined | null,
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductBannerUpsertBackgroundImageRelationInput"]: {
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["ProductBannerUpdateProductImageEntityRelationInput"]: {
	create?: ValueTypes["ImageCreateInput"] | undefined | null,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductBannerUpsertProductImageRelationInput"] | undefined | null,
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductBannerUpsertProductImageRelationInput"]: {
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["ProductBannerUpdateProductEntityRelationInput"]: {
	create?: ValueTypes["ProductCreateInput"] | undefined | null,
	update?: ValueTypes["ProductUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductBannerUpsertProductRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductBannerUpsertProductRelationInput"]: {
	update?: ValueTypes["ProductUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductCreateInput"] | undefined | null
};
	["ProductBannerItemUpsertBannerRelationInput"]: {
	update?: ValueTypes["ProductBannerUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductBannerCreateInput"] | undefined | null
};
	["ProductBannerListUpsertItemsRelationInput"]: {
	by?: ValueTypes["ProductBannerItemUniqueWhere"] | undefined | null,
	update?: ValueTypes["ProductBannerItemWithoutListUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductBannerItemWithoutListCreateInput"] | undefined | null
};
	["ContentReferenceUpsertProductBannersRelationInput"]: {
	update?: ValueTypes["ProductBannerListUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductBannerListCreateInput"] | undefined | null
};
	["ContentReferenceUpdateDeliveryRegionsEntityRelationInput"]: {
	create?: ValueTypes["DeliveryRegionsCreateInput"] | undefined | null,
	update?: ValueTypes["DeliveryRegionsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ContentReferenceUpsertDeliveryRegionsRelationInput"] | undefined | null,
	connect?: ValueTypes["DeliveryRegionsUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ContentReferenceUpsertDeliveryRegionsRelationInput"]: {
	update?: ValueTypes["DeliveryRegionsUpdateInput"] | undefined | null,
	create?: ValueTypes["DeliveryRegionsCreateInput"] | undefined | null
};
	["ContentReferenceUpdateTextListEntityRelationInput"]: {
	create?: ValueTypes["TextListCreateInput"] | undefined | null,
	update?: ValueTypes["TextListUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ContentReferenceUpsertTextListRelationInput"] | undefined | null,
	connect?: ValueTypes["TextListUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ContentReferenceUpsertTextListRelationInput"]: {
	update?: ValueTypes["TextListUpdateInput"] | undefined | null,
	create?: ValueTypes["TextListCreateInput"] | undefined | null
};
	["ContentReferenceUpdateGridTilesEntityRelationInput"]: {
	create?: ValueTypes["GridTilesCreateInput"] | undefined | null,
	update?: ValueTypes["GridTilesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ContentReferenceUpsertGridTilesRelationInput"] | undefined | null,
	connect?: ValueTypes["GridTilesUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["GridTilesUpdateInput"]: {
	items?: Array<ValueTypes["GridTilesUpdateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GridTilesUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["GridTileItemWithoutListCreateInput"] | undefined | null,
	update?: ValueTypes["GridTilesUpdateItemsRelationInput"] | undefined | null,
	upsert?: ValueTypes["GridTilesUpsertItemsRelationInput"] | undefined | null,
	connect?: ValueTypes["GridTileItemUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["GridTileItemUniqueWhere"] | undefined | null,
	delete?: ValueTypes["GridTileItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["GridTilesUpdateItemsRelationInput"]: {
	by?: ValueTypes["GridTileItemUniqueWhere"] | undefined | null,
	data?: ValueTypes["GridTileItemWithoutListUpdateInput"] | undefined | null
};
	["GridTileItemWithoutListUpdateInput"]: {
	order?: number | undefined | null,
	text?: string | undefined | null,
	medium?: ValueTypes["GridTileItemUpdateMediumEntityRelationInput"] | undefined | null,
	link?: ValueTypes["GridTileItemUpdateLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GridTileItemUpdateMediumEntityRelationInput"]: {
	create?: ValueTypes["MediumCreateInput"] | undefined | null,
	update?: ValueTypes["MediumUpdateInput"] | undefined | null,
	upsert?: ValueTypes["GridTileItemUpsertMediumRelationInput"] | undefined | null,
	connect?: ValueTypes["MediumUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["GridTileItemUpsertMediumRelationInput"]: {
	update?: ValueTypes["MediumUpdateInput"] | undefined | null,
	create?: ValueTypes["MediumCreateInput"] | undefined | null
};
	["GridTileItemUpdateLinkEntityRelationInput"]: {
	create?: ValueTypes["LinkCreateInput"] | undefined | null,
	update?: ValueTypes["LinkUpdateInput"] | undefined | null,
	upsert?: ValueTypes["GridTileItemUpsertLinkRelationInput"] | undefined | null,
	connect?: ValueTypes["LinkUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["GridTileItemUpsertLinkRelationInput"]: {
	update?: ValueTypes["LinkUpdateInput"] | undefined | null,
	create?: ValueTypes["LinkCreateInput"] | undefined | null
};
	["GridTilesUpsertItemsRelationInput"]: {
	by?: ValueTypes["GridTileItemUniqueWhere"] | undefined | null,
	update?: ValueTypes["GridTileItemWithoutListUpdateInput"] | undefined | null,
	create?: ValueTypes["GridTileItemWithoutListCreateInput"] | undefined | null
};
	["ContentReferenceUpsertGridTilesRelationInput"]: {
	update?: ValueTypes["GridTilesUpdateInput"] | undefined | null,
	create?: ValueTypes["GridTilesCreateInput"] | undefined | null
};
	["ContentBlockUpsertReferencesRelationInput"]: {
	by?: ValueTypes["ContentReferenceUniqueWhere"] | undefined | null,
	update?: ValueTypes["ContentReferenceWithoutBlockUpdateInput"] | undefined | null,
	create?: ValueTypes["ContentReferenceWithoutBlockCreateInput"] | undefined | null
};
	["ContentUpsertBlocksRelationInput"]: {
	by?: ValueTypes["ContentBlockUniqueWhere"] | undefined | null,
	update?: ValueTypes["ContentBlockWithoutContentUpdateInput"] | undefined | null,
	create?: ValueTypes["ContentBlockWithoutContentCreateInput"] | undefined | null
};
	["BlogPostLocaleUpsertContentRelationInput"]: {
	update?: ValueTypes["ContentUpdateInput"] | undefined | null,
	create?: ValueTypes["ContentCreateInput"] | undefined | null
};
	["LocaleUpsertBlogPostsRelationInput"]: {
	by?: ValueTypes["BlogPostLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["BlogPostLocaleWithoutLocaleUpdateInput"] | undefined | null,
	create?: ValueTypes["BlogPostLocaleWithoutLocaleCreateInput"] | undefined | null
};
	["BusinessCategoryLocaleUpsertLocaleRelationInput"]: {
	update?: ValueTypes["LocaleWithoutBusinessCategoriesUpdateInput"] | undefined | null,
	create?: ValueTypes["LocaleWithoutBusinessCategoriesCreateInput"] | undefined | null
};
	["BusinessCategoryUpsertLocalesRelationInput"]: {
	by?: ValueTypes["BusinessCategoryLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["BusinessCategoryLocaleWithoutRootUpdateInput"] | undefined | null,
	create?: ValueTypes["BusinessCategoryLocaleWithoutRootCreateInput"] | undefined | null
};
	["OrderRecurrenceUpsertBusinessCategoryRelationInput"]: {
	by?: ValueTypes["BusinessCategoryUniqueWhere"] | undefined | null,
	update?: ValueTypes["BusinessCategoryWithoutRecurrencesUpdateInput"] | undefined | null,
	create?: ValueTypes["BusinessCategoryWithoutRecurrencesCreateInput"] | undefined | null
};
	["OrderRecurrenceLocaleUpsertRootRelationInput"]: {
	update?: ValueTypes["OrderRecurrenceWithoutLocalesUpdateInput"] | undefined | null,
	create?: ValueTypes["OrderRecurrenceWithoutLocalesCreateInput"] | undefined | null
};
	["LocaleUpsertOrderRecurrencesRelationInput"]: {
	by?: ValueTypes["OrderRecurrenceLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["OrderRecurrenceLocaleWithoutLocaleUpdateInput"] | undefined | null,
	create?: ValueTypes["OrderRecurrenceLocaleWithoutLocaleCreateInput"] | undefined | null
};
	["AllergenLocaleUpsertLocaleRelationInput"]: {
	update?: ValueTypes["LocaleWithoutAllergensUpdateInput"] | undefined | null,
	create?: ValueTypes["LocaleWithoutAllergensCreateInput"] | undefined | null
};
	["AllergenUpsertLocalesRelationInput"]: {
	by?: ValueTypes["AllergenLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["AllergenLocaleWithoutRootUpdateInput"] | undefined | null,
	create?: ValueTypes["AllergenLocaleWithoutRootCreateInput"] | undefined | null
};
	["ProductIngredientUpsertAllergensRelationInput"]: {
	by?: ValueTypes["AllergenUniqueWhere"] | undefined | null,
	update?: ValueTypes["AllergenWithoutIngredientsUpdateInput"] | undefined | null,
	create?: ValueTypes["AllergenWithoutIngredientsCreateInput"] | undefined | null
};
	["ProductIngredientLocaleUpsertRootRelationInput"]: {
	update?: ValueTypes["ProductIngredientWithoutLocalesUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductIngredientWithoutLocalesCreateInput"] | undefined | null
};
	["LocaleUpsertProductIngredientsRelationInput"]: {
	by?: ValueTypes["ProductIngredientLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["ProductIngredientLocaleWithoutLocaleUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductIngredientLocaleWithoutLocaleCreateInput"] | undefined | null
};
	["ProductIngredientCategoryLocaleUpsertLocaleRelationInput"]: {
	update?: ValueTypes["LocaleWithoutProductIngredientCategoriesUpdateInput"] | undefined | null,
	create?: ValueTypes["LocaleWithoutProductIngredientCategoriesCreateInput"] | undefined | null
};
	["ProductIngredientCategoryUpsertLocalesRelationInput"]: {
	by?: ValueTypes["ProductIngredientCategoryLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["ProductIngredientCategoryLocaleWithoutRootUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductIngredientCategoryLocaleWithoutRootCreateInput"] | undefined | null
};
	["ProductIngredientUpsertCategoriesRelationInput"]: {
	by?: ValueTypes["ProductIngredientCategoryUniqueWhere"] | undefined | null,
	update?: ValueTypes["ProductIngredientCategoryWithoutIngredientsUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductIngredientCategoryWithoutIngredientsCreateInput"] | undefined | null
};
	["CustomerIngredientRatingUpsertIngredientRelationInput"]: {
	update?: ValueTypes["ProductIngredientWithoutCustomerRatingsUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductIngredientWithoutCustomerRatingsCreateInput"] | undefined | null
};
	["CustomerUpsertIngredientRatingsRelationInput"]: {
	by?: ValueTypes["CustomerIngredientRatingUniqueWhere"] | undefined | null,
	update?: ValueTypes["CustomerIngredientRatingWithoutCustomerUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerIngredientRatingWithoutCustomerCreateInput"] | undefined | null
};
	["CustomerGroupUpsertCustomersRelationInput"]: {
	by?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	update?: ValueTypes["CustomerWithoutGroupUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerWithoutGroupCreateInput"] | undefined | null
};
	["ProductGroupPriceUpsertGroupRelationInput"]: {
	update?: ValueTypes["CustomerGroupWithoutProductPricesUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerGroupWithoutProductPricesCreateInput"] | undefined | null
};
	["ProductUpsertGroupPricesRelationInput"]: {
	by?: ValueTypes["ProductGroupPriceUniqueWhere"] | undefined | null,
	update?: ValueTypes["ProductGroupPriceWithoutProductUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductGroupPriceWithoutProductCreateInput"] | undefined | null
};
	["DeliveryZoneUpsertDeliveryZonesOfProductsRelationInput"]: {
	by?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	update?: ValueTypes["ProductWithoutDeliveryZonesUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductWithoutDeliveryZonesCreateInput"] | undefined | null
};
	["TagUpsertDeliveryZonesRelationInput"]: {
	by?: ValueTypes["DeliveryZoneUniqueWhere"] | undefined | null,
	update?: ValueTypes["DeliveryZoneWithoutDeliveryZonesOfTagsUpdateInput"] | undefined | null,
	create?: ValueTypes["DeliveryZoneWithoutDeliveryZonesOfTagsCreateInput"] | undefined | null
};
	["ChannelUpsertAddTagsOnRegistrationRelationInput"]: {
	by?: ValueTypes["TagUniqueWhere"] | undefined | null,
	update?: ValueTypes["TagWithoutAddTagsOnRegistrationUpdateInput"] | undefined | null,
	create?: ValueTypes["TagWithoutAddTagsOnRegistrationCreateInput"] | undefined | null
};
	["CartUpsertChannelRelationInput"]: {
	update?: ValueTypes["ChannelWithoutCartsUpdateInput"] | undefined | null,
	create?: ValueTypes["ChannelWithoutCartsCreateInput"] | undefined | null
};
	["CartItemUpsertCartRelationInput"]: {
	update?: ValueTypes["CartWithoutItemsUpdateInput"] | undefined | null,
	create?: ValueTypes["CartWithoutItemsCreateInput"] | undefined | null
};
	["CartItemUpdateFulfillmentNotesEntityRelationInput"]: {
	create?: ValueTypes["FulfillmentNoteWithoutCartItemsCreateInput"] | undefined | null,
	update?: ValueTypes["CartItemUpdateFulfillmentNotesRelationInput"] | undefined | null,
	upsert?: ValueTypes["CartItemUpsertFulfillmentNotesRelationInput"] | undefined | null,
	connect?: ValueTypes["FulfillmentNoteUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["FulfillmentNoteUniqueWhere"] | undefined | null,
	delete?: ValueTypes["FulfillmentNoteUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["CartItemUpdateFulfillmentNotesRelationInput"]: {
	by?: ValueTypes["FulfillmentNoteUniqueWhere"] | undefined | null,
	data?: ValueTypes["FulfillmentNoteWithoutCartItemsUpdateInput"] | undefined | null
};
	["FulfillmentNoteWithoutCartItemsUpdateInput"]: {
	note?: string | undefined | null,
	products?: Array<ValueTypes["FulfillmentNoteUpdateProductsEntityRelationInput"]> | undefined | null,
	tags?: Array<ValueTypes["FulfillmentNoteUpdateTagsEntityRelationInput"]> | undefined | null,
	venues?: Array<ValueTypes["FulfillmentNoteUpdateVenuesEntityRelationInput"]> | undefined | null,
	orderItems?: Array<ValueTypes["FulfillmentNoteUpdateOrderItemsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["FulfillmentNoteUpdateOrdersEntityRelationInput"]> | undefined | null,
	highlight?: boolean | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	emoji?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CartItemUpsertFulfillmentNotesRelationInput"]: {
	by?: ValueTypes["FulfillmentNoteUniqueWhere"] | undefined | null,
	update?: ValueTypes["FulfillmentNoteWithoutCartItemsUpdateInput"] | undefined | null,
	create?: ValueTypes["FulfillmentNoteWithoutCartItemsCreateInput"] | undefined | null
};
	["ProductUpsertCartItemsRelationInput"]: {
	by?: ValueTypes["CartItemUniqueWhere"] | undefined | null,
	update?: ValueTypes["CartItemWithoutProductUpdateInput"] | undefined | null,
	create?: ValueTypes["CartItemWithoutProductCreateInput"] | undefined | null
};
	["ProductGroupPriceUpsertProductRelationInput"]: {
	update?: ValueTypes["ProductWithoutGroupPricesUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductWithoutGroupPricesCreateInput"] | undefined | null
};
	["CustomerGroupUpsertProductPricesRelationInput"]: {
	by?: ValueTypes["ProductGroupPriceUniqueWhere"] | undefined | null,
	update?: ValueTypes["ProductGroupPriceWithoutGroupUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductGroupPriceWithoutGroupCreateInput"] | undefined | null
};
	["CustomerUpsertGroupRelationInput"]: {
	update?: ValueTypes["CustomerGroupWithoutCustomersUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerGroupWithoutCustomersCreateInput"] | undefined | null
};
	["ChannelUpsertCustomersRelationInput"]: {
	by?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	update?: ValueTypes["CustomerWithoutChannelsUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerWithoutChannelsCreateInput"] | undefined | null
};
	["TagUpsertAddTagsOnRegistrationRelationInput"]: {
	by?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	update?: ValueTypes["ChannelWithoutAddTagsOnRegistrationUpdateInput"] | undefined | null,
	create?: ValueTypes["ChannelWithoutAddTagsOnRegistrationCreateInput"] | undefined | null
};
	["ProductCategoryUpsertTagsRelationInput"]: {
	by?: ValueTypes["TagUniqueWhere"] | undefined | null,
	update?: ValueTypes["TagWithoutCategoriesUpdateInput"] | undefined | null,
	create?: ValueTypes["TagWithoutCategoriesCreateInput"] | undefined | null
};
	["ProductCategoryUpsertParentRelationInput"]: {
	update?: ValueTypes["ProductCategoryWithoutChildrenUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductCategoryWithoutChildrenCreateInput"] | undefined | null
};
	["TagUpsertCategoriesRelationInput"]: {
	by?: ValueTypes["ProductCategoryUniqueWhere"] | undefined | null,
	update?: ValueTypes["ProductCategoryWithoutTagsUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductCategoryWithoutTagsCreateInput"] | undefined | null
};
	["ProductUpsertTagsRelationInput"]: {
	by?: ValueTypes["TagUniqueWhere"] | undefined | null,
	update?: ValueTypes["TagWithoutProductsUpdateInput"] | undefined | null,
	create?: ValueTypes["TagWithoutProductsCreateInput"] | undefined | null
};
	["ProductCategoryUpsertProductsRelationInput"]: {
	by?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	update?: ValueTypes["ProductWithoutCategoriesUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductWithoutCategoriesCreateInput"] | undefined | null
};
	["ProductCategoryListItemUpsertProductCategoryRelationInput"]: {
	update?: ValueTypes["ProductCategoryUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductCategoryCreateInput"] | undefined | null
};
	["ProductCategoryListUpsertItemsRelationInput"]: {
	by?: ValueTypes["ProductCategoryListItemUniqueWhere"] | undefined | null,
	update?: ValueTypes["ProductCategoryListItemWithoutListUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductCategoryListItemWithoutListCreateInput"] | undefined | null
};
	["ProductCategoryListLocaleUpsertRootRelationInput"]: {
	update?: ValueTypes["ProductCategoryListWithoutLocalesUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductCategoryListWithoutLocalesCreateInput"] | undefined | null
};
	["LocaleUpsertProductCategoryListsRelationInput"]: {
	by?: ValueTypes["ProductCategoryListLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["ProductCategoryListLocaleWithoutLocaleUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductCategoryListLocaleWithoutLocaleCreateInput"] | undefined | null
};
	["ProductIngredientLocaleUpsertLocaleRelationInput"]: {
	update?: ValueTypes["LocaleWithoutProductIngredientsUpdateInput"] | undefined | null,
	create?: ValueTypes["LocaleWithoutProductIngredientsCreateInput"] | undefined | null
};
	["ProductIngredientUpsertLocalesRelationInput"]: {
	by?: ValueTypes["ProductIngredientLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["ProductIngredientLocaleWithoutRootUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductIngredientLocaleWithoutRootCreateInput"] | undefined | null
};
	["ProductIngredientItemUpsertIngredientRelationInput"]: {
	update?: ValueTypes["ProductIngredientUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductIngredientCreateInput"] | undefined | null
};
	["ProductIngredientItemUpdateQuantityEntityRelationInput"]: {
	create?: ValueTypes["ProductIngredientItemQuantityCreateInput"] | undefined | null,
	update?: ValueTypes["ProductIngredientItemQuantityUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductIngredientItemUpsertQuantityRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductIngredientItemQuantityUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductIngredientItemQuantityUpdateInput"]: {
	unit?: ValueTypes["ProductIngredientItemQuantityUpdateUnitEntityRelationInput"] | undefined | null,
	value?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientItemQuantityUpdateUnitEntityRelationInput"]: {
	create?: ValueTypes["ProductIngredientItemQuantityUnitCreateInput"] | undefined | null,
	update?: ValueTypes["ProductIngredientItemQuantityUnitUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductIngredientItemQuantityUpsertUnitRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductIngredientItemQuantityUnitUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductIngredientItemQuantityUpsertUnitRelationInput"]: {
	update?: ValueTypes["ProductIngredientItemQuantityUnitUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductIngredientItemQuantityUnitCreateInput"] | undefined | null
};
	["ProductIngredientItemUpsertQuantityRelationInput"]: {
	update?: ValueTypes["ProductIngredientItemQuantityUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductIngredientItemQuantityCreateInput"] | undefined | null
};
	["ProductRecipeUpsertIngredientsRelationInput"]: {
	by?: ValueTypes["ProductIngredientItemUniqueWhere"] | undefined | null,
	update?: ValueTypes["ProductIngredientItemWithoutRecipeUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductIngredientItemWithoutRecipeCreateInput"] | undefined | null
};
	["ProductUpsertRecipeRelationInput"]: {
	update?: ValueTypes["ProductRecipeWithoutProductsUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductRecipeWithoutProductsCreateInput"] | undefined | null
};
	["CartItemUpsertProductRelationInput"]: {
	update?: ValueTypes["ProductWithoutCartItemsUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductWithoutCartItemsCreateInput"] | undefined | null
};
	["CartUpsertItemsRelationInput"]: {
	by?: ValueTypes["CartItemUniqueWhere"] | undefined | null,
	update?: ValueTypes["CartItemWithoutCartUpdateInput"] | undefined | null,
	create?: ValueTypes["CartItemWithoutCartCreateInput"] | undefined | null
};
	["ChannelUpsertCartsRelationInput"]: {
	by?: ValueTypes["CartUniqueWhere"] | undefined | null,
	update?: ValueTypes["CartWithoutChannelUpdateInput"] | undefined | null,
	create?: ValueTypes["CartWithoutChannelCreateInput"] | undefined | null
};
	["OrderUpsertChannelRelationInput"]: {
	update?: ValueTypes["ChannelUpdateInput"] | undefined | null,
	create?: ValueTypes["ChannelCreateInput"] | undefined | null
};
	["CustomerUpsertOrdersRelationInput"]: {
	by?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	update?: ValueTypes["OrderWithoutCustomerUpdateInput"] | undefined | null,
	create?: ValueTypes["OrderWithoutCustomerCreateInput"] | undefined | null
};
	["TagUpsertCustomersRelationInput"]: {
	by?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	update?: ValueTypes["CustomerWithoutTagsUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerWithoutTagsCreateInput"] | undefined | null
};
	["ChannelPaymentUpsertAllowOnlyForTagsRelationInput"]: {
	by?: ValueTypes["TagUniqueWhere"] | undefined | null,
	update?: ValueTypes["TagWithoutAllowChannelPaymentsUpdateInput"] | undefined | null,
	create?: ValueTypes["TagWithoutAllowChannelPaymentsCreateInput"] | undefined | null
};
	["VatRateUpsertChannelPaymentsRelationInput"]: {
	by?: ValueTypes["ChannelPaymentUniqueWhere"] | undefined | null,
	update?: ValueTypes["ChannelPaymentWithoutVatRateUpdateInput"] | undefined | null,
	create?: ValueTypes["ChannelPaymentWithoutVatRateCreateInput"] | undefined | null
};
	["ChannelDeliveryUpsertVatRateRelationInput"]: {
	update?: ValueTypes["VatRateWithoutChannelDeliveriesUpdateInput"] | undefined | null,
	create?: ValueTypes["VatRateWithoutChannelDeliveriesCreateInput"] | undefined | null
};
	["DeliveryMethodUpsertChannelsRelationInput"]: {
	by?: ValueTypes["ChannelDeliveryUniqueWhere"] | undefined | null,
	update?: ValueTypes["ChannelDeliveryWithoutMethodUpdateInput"] | undefined | null,
	create?: ValueTypes["ChannelDeliveryWithoutMethodCreateInput"] | undefined | null
};
	["PaymentMethodUpsertDeliveryMethodsRelationInput"]: {
	by?: ValueTypes["DeliveryMethodUniqueWhere"] | undefined | null,
	update?: ValueTypes["DeliveryMethodWithoutPaymentMethodsUpdateInput"] | undefined | null,
	create?: ValueTypes["DeliveryMethodWithoutPaymentMethodsCreateInput"] | undefined | null
};
	["ChannelPaymentUpsertMethodRelationInput"]: {
	update?: ValueTypes["PaymentMethodWithoutChannelsUpdateInput"] | undefined | null,
	create?: ValueTypes["PaymentMethodWithoutChannelsCreateInput"] | undefined | null
};
	["ChannelUpsertPaymentsRelationInput"]: {
	by?: ValueTypes["ChannelPaymentUniqueWhere"] | undefined | null,
	update?: ValueTypes["ChannelPaymentWithoutChannelUpdateInput"] | undefined | null,
	create?: ValueTypes["ChannelPaymentWithoutChannelCreateInput"] | undefined | null
};
	["ChannelDeliveryUpsertChannelRelationInput"]: {
	update?: ValueTypes["ChannelWithoutDeliveriesUpdateInput"] | undefined | null,
	create?: ValueTypes["ChannelWithoutDeliveriesCreateInput"] | undefined | null
};
	["VatRateUpsertChannelDeliveriesRelationInput"]: {
	by?: ValueTypes["ChannelDeliveryUniqueWhere"] | undefined | null,
	update?: ValueTypes["ChannelDeliveryWithoutVatRateUpdateInput"] | undefined | null,
	create?: ValueTypes["ChannelDeliveryWithoutVatRateCreateInput"] | undefined | null
};
	["CustomerCreditUpsertVatRateRelationInput"]: {
	update?: ValueTypes["VatRateUpdateInput"] | undefined | null,
	create?: ValueTypes["VatRateCreateInput"] | undefined | null
};
	["CustomerUpsertCreditsRelationInput"]: {
	by?: ValueTypes["CustomerCreditUniqueWhere"] | undefined | null,
	update?: ValueTypes["CustomerCreditWithoutCustomerUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerCreditWithoutCustomerCreateInput"] | undefined | null
};
	["BusinessCustomerUpsertCustomerRelationInput"]: {
	update?: ValueTypes["CustomerWithoutBusinessUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerWithoutBusinessCreateInput"] | undefined | null
};
	["BusinessCategoryUpsertBusinessCustomersRelationInput"]: {
	by?: ValueTypes["BusinessCustomerUniqueWhere"] | undefined | null,
	update?: ValueTypes["BusinessCustomerWithoutCategoryUpdateInput"] | undefined | null,
	create?: ValueTypes["BusinessCustomerWithoutCategoryCreateInput"] | undefined | null
};
	["BusinessCategoryLocaleUpsertRootRelationInput"]: {
	update?: ValueTypes["BusinessCategoryWithoutLocalesUpdateInput"] | undefined | null,
	create?: ValueTypes["BusinessCategoryWithoutLocalesCreateInput"] | undefined | null
};
	["LocaleUpsertBusinessCategoriesRelationInput"]: {
	by?: ValueTypes["BusinessCategoryLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["BusinessCategoryLocaleWithoutLocaleUpdateInput"] | undefined | null,
	create?: ValueTypes["BusinessCategoryLocaleWithoutLocaleCreateInput"] | undefined | null
};
	["ProductPackingLocaleUpsertLocaleRelationInput"]: {
	update?: ValueTypes["LocaleWithoutProductPackingsUpdateInput"] | undefined | null,
	create?: ValueTypes["LocaleWithoutProductPackingsCreateInput"] | undefined | null
};
	["ProductPackingUpsertLocalesRelationInput"]: {
	by?: ValueTypes["ProductPackingLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["ProductPackingLocaleWithoutRootUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductPackingLocaleWithoutRootCreateInput"] | undefined | null
};
	["ProductUpsertPackingRelationInput"]: {
	update?: ValueTypes["ProductPackingUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductPackingCreateInput"] | undefined | null
};
	["TagUpsertProductsRelationInput"]: {
	by?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	update?: ValueTypes["ProductWithoutTagsUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductWithoutTagsCreateInput"] | undefined | null
};
	["CustomerUpsertTagsRelationInput"]: {
	by?: ValueTypes["TagUniqueWhere"] | undefined | null,
	update?: ValueTypes["TagWithoutCustomersUpdateInput"] | undefined | null,
	create?: ValueTypes["TagWithoutCustomersCreateInput"] | undefined | null
};
	["InvoiceUpsertCustomerRelationInput"]: {
	update?: ValueTypes["CustomerWithoutInvoicesUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerWithoutInvoicesCreateInput"] | undefined | null
};
	["AddressUpsertInvoicesRelationInput"]: {
	by?: ValueTypes["InvoiceUniqueWhere"] | undefined | null,
	update?: ValueTypes["InvoiceWithoutAddressUpdateInput"] | undefined | null,
	create?: ValueTypes["InvoiceWithoutAddressCreateInput"] | undefined | null
};
	["DeliveryZoneUpsertAddressesRelationInput"]: {
	by?: ValueTypes["AddressUniqueWhere"] | undefined | null,
	update?: ValueTypes["AddressWithoutDeliveryZoneUpdateInput"] | undefined | null,
	create?: ValueTypes["AddressWithoutDeliveryZoneCreateInput"] | undefined | null
};
	["DeliveryMethodUpsertSuitableForDeliveryZonesRelationInput"]: {
	by?: ValueTypes["DeliveryZoneUniqueWhere"] | undefined | null,
	update?: ValueTypes["DeliveryZoneWithoutSuitableDeliveryMethodsUpdateInput"] | undefined | null,
	create?: ValueTypes["DeliveryZoneWithoutSuitableDeliveryMethodsCreateInput"] | undefined | null
};
	["ChannelDeliveryUpsertMethodRelationInput"]: {
	update?: ValueTypes["DeliveryMethodWithoutChannelsUpdateInput"] | undefined | null,
	create?: ValueTypes["DeliveryMethodWithoutChannelsCreateInput"] | undefined | null
};
	["ChannelUpsertDeliveriesRelationInput"]: {
	by?: ValueTypes["ChannelDeliveryUniqueWhere"] | undefined | null,
	update?: ValueTypes["ChannelDeliveryWithoutChannelUpdateInput"] | undefined | null,
	create?: ValueTypes["ChannelDeliveryWithoutChannelCreateInput"] | undefined | null
};
	["ChannelPaymentUpsertChannelRelationInput"]: {
	update?: ValueTypes["ChannelWithoutPaymentsUpdateInput"] | undefined | null,
	create?: ValueTypes["ChannelWithoutPaymentsCreateInput"] | undefined | null
};
	["PaymentMethodUpsertChannelsRelationInput"]: {
	by?: ValueTypes["ChannelPaymentUniqueWhere"] | undefined | null,
	update?: ValueTypes["ChannelPaymentWithoutMethodUpdateInput"] | undefined | null,
	create?: ValueTypes["ChannelPaymentWithoutMethodCreateInput"] | undefined | null
};
	["DeliveryMethodUpsertPaymentMethodsRelationInput"]: {
	by?: ValueTypes["PaymentMethodUniqueWhere"] | undefined | null,
	update?: ValueTypes["PaymentMethodWithoutDeliveryMethodsUpdateInput"] | undefined | null,
	create?: ValueTypes["PaymentMethodWithoutDeliveryMethodsCreateInput"] | undefined | null
};
	["DeliveryZoneUpsertSuitableDeliveryMethodsRelationInput"]: {
	by?: ValueTypes["DeliveryMethodUniqueWhere"] | undefined | null,
	update?: ValueTypes["DeliveryMethodWithoutSuitableForDeliveryZonesUpdateInput"] | undefined | null,
	create?: ValueTypes["DeliveryMethodWithoutSuitableForDeliveryZonesCreateInput"] | undefined | null
};
	["AddressUpsertDeliveryZoneRelationInput"]: {
	update?: ValueTypes["DeliveryZoneWithoutAddressesUpdateInput"] | undefined | null,
	create?: ValueTypes["DeliveryZoneWithoutAddressesCreateInput"] | undefined | null
};
	["CustomerUpsertAddressesRelationInput"]: {
	by?: ValueTypes["AddressUniqueWhere"] | undefined | null,
	update?: ValueTypes["AddressWithoutCustomerUpdateInput"] | undefined | null,
	create?: ValueTypes["AddressWithoutCustomerCreateInput"] | undefined | null
};
	["CustomerPaymentMethodUpsertCustomerRelationInput"]: {
	update?: ValueTypes["CustomerWithoutPaymentMethodsUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerWithoutPaymentMethodsCreateInput"] | undefined | null
};
	["CustomerUpsertDefaultPaymentMethodRelationInput"]: {
	update?: ValueTypes["CustomerPaymentMethodUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerPaymentMethodCreateInput"] | undefined | null
};
	["AddressUpsertCustomerRelationInput"]: {
	update?: ValueTypes["CustomerWithoutAddressesUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerWithoutAddressesCreateInput"] | undefined | null
};
	["CustomerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	addresses?: Array<ValueTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerCreateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerCreateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerCreatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerCreateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerCreateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerCreateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerCreateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerCreateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerCreateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerCreateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerUpdateInput"]: {
	addresses?: Array<ValueTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerUpdateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerUpdateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerUpdateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerUpdateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreditCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	initialCreditCents?: number | undefined | null,
	remainingCreditsCents?: number | undefined | null,
	expiresAt?: ValueTypes["DateTime"] | undefined | null,
	reason?: string | undefined | null,
	customer?: ValueTypes["CustomerCreditCreateCustomerEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["CustomerCreditCreateVatRateEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	transactions?: Array<ValueTypes["CustomerCreditCreateTransactionsEntityRelationInput"]> | undefined | null,
	voucherRedemption?: ValueTypes["CustomerCreditCreateVoucherRedemptionEntityRelationInput"] | undefined | null,
	invoiceUrl?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreditUpdateInput"]: {
	initialCreditCents?: number | undefined | null,
	remainingCreditsCents?: number | undefined | null,
	expiresAt?: ValueTypes["DateTime"] | undefined | null,
	reason?: string | undefined | null,
	customer?: ValueTypes["CustomerCreditUpdateCustomerEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["CustomerCreditUpdateVatRateEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	transactions?: Array<ValueTypes["CustomerCreditUpdateTransactionsEntityRelationInput"]> | undefined | null,
	voucherRedemption?: ValueTypes["CustomerCreditUpdateVoucherRedemptionEntityRelationInput"] | undefined | null,
	invoiceUrl?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerGroupConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CustomerGroupEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerGroupEdge"]: AliasType<{
	node?:ValueTypes["CustomerGroup"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerGroupCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	productPrices?: Array<ValueTypes["CustomerGroupCreateProductPricesEntityRelationInput"]> | undefined | null,
	customers?: Array<ValueTypes["CustomerGroupCreateCustomersEntityRelationInput"]> | undefined | null,
	discountPermille?: number | undefined | null,
	code?: string | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerGroupUpdateInput"]: {
	name?: string | undefined | null,
	productPrices?: Array<ValueTypes["CustomerGroupUpdateProductPricesEntityRelationInput"]> | undefined | null,
	customers?: Array<ValueTypes["CustomerGroupUpdateCustomersEntityRelationInput"]> | undefined | null,
	discountPermille?: number | undefined | null,
	code?: string | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	state?: ValueTypes["OrderState"] | undefined | null,
	fulfilledAt?: ValueTypes["DateTime"] | undefined | null,
	canceledAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	customer?: ValueTypes["OrderCreateCustomerEntityRelationInput"] | undefined | null,
	channel?: ValueTypes["OrderCreateChannelEntityRelationInput"] | undefined | null,
	discounts?: Array<ValueTypes["OrderCreateDiscountsEntityRelationInput"]> | undefined | null,
	delivery?: ValueTypes["OrderCreateDeliveryEntityRelationInput"] | undefined | null,
	items?: Array<ValueTypes["OrderCreateItemsEntityRelationInput"]> | undefined | null,
	internalNote?: string | undefined | null,
	cart?: ValueTypes["OrderCreateCartEntityRelationInput"] | undefined | null,
	events?: Array<ValueTypes["OrderCreateEventsEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingAddress?: ValueTypes["OrderCreateBillingAddressEntityRelationInput"] | undefined | null,
	priceLines?: Array<ValueTypes["OrderCreatePriceLinesEntityRelationInput"]> | undefined | null,
	payments?: Array<ValueTypes["OrderCreatePaymentsEntityRelationInput"]> | undefined | null,
	seq?: number | undefined | null,
	billingSubject?: ValueTypes["OrderCreateBillingSubjectEntityRelationInput"] | undefined | null,
	summary?: ValueTypes["OrderCreateSummaryEntityRelationInput"] | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	gratuity?: ValueTypes["OrderCreateGratuityEntityRelationInput"] | undefined | null,
	venue?: ValueTypes["OrderCreateVenueEntityRelationInput"] | undefined | null,
	fulfillmentNote?: string | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["OrderCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	doubleshotTotalWeightGrams?: number | undefined | null,
	doubleShotLegacyNumber?: string | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	doubleshotAdminUrl?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderUpdateInput"]: {
	state?: ValueTypes["OrderState"] | undefined | null,
	fulfilledAt?: ValueTypes["DateTime"] | undefined | null,
	canceledAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	customer?: ValueTypes["OrderUpdateCustomerEntityRelationInput"] | undefined | null,
	channel?: ValueTypes["OrderUpdateChannelEntityRelationInput"] | undefined | null,
	discounts?: Array<ValueTypes["OrderUpdateDiscountsEntityRelationInput"]> | undefined | null,
	delivery?: ValueTypes["OrderUpdateDeliveryEntityRelationInput"] | undefined | null,
	items?: Array<ValueTypes["OrderUpdateItemsEntityRelationInput"]> | undefined | null,
	internalNote?: string | undefined | null,
	cart?: ValueTypes["OrderUpdateCartEntityRelationInput"] | undefined | null,
	events?: Array<ValueTypes["OrderUpdateEventsEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingAddress?: ValueTypes["OrderUpdateBillingAddressEntityRelationInput"] | undefined | null,
	priceLines?: Array<ValueTypes["OrderUpdatePriceLinesEntityRelationInput"]> | undefined | null,
	payments?: Array<ValueTypes["OrderUpdatePaymentsEntityRelationInput"]> | undefined | null,
	seq?: number | undefined | null,
	billingSubject?: ValueTypes["OrderUpdateBillingSubjectEntityRelationInput"] | undefined | null,
	summary?: ValueTypes["OrderUpdateSummaryEntityRelationInput"] | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	gratuity?: ValueTypes["OrderUpdateGratuityEntityRelationInput"] | undefined | null,
	venue?: ValueTypes["OrderUpdateVenueEntityRelationInput"] | undefined | null,
	fulfillmentNote?: string | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["OrderUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	doubleshotTotalWeightGrams?: number | undefined | null,
	doubleShotLegacyNumber?: string | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	doubleshotAdminUrl?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderDiscountCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	discountCents?: number | undefined | null,
	vatRate?: ValueTypes["OrderDiscountCreateVatRateEntityRelationInput"] | undefined | null,
	order?: ValueTypes["OrderDiscountCreateOrderEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	type?: ValueTypes["OrderDiscountType"] | undefined | null,
	customerCreditTransactions?: Array<ValueTypes["OrderDiscountCreateCustomerCreditTransactionsEntityRelationInput"]> | undefined | null,
	voucherRedemption?: ValueTypes["OrderDiscountCreateVoucherRedemptionEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderDiscountUpdateInput"]: {
	discountCents?: number | undefined | null,
	vatRate?: ValueTypes["OrderDiscountUpdateVatRateEntityRelationInput"] | undefined | null,
	order?: ValueTypes["OrderDiscountUpdateOrderEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	type?: ValueTypes["OrderDiscountType"] | undefined | null,
	customerCreditTransactions?: Array<ValueTypes["OrderDiscountUpdateCustomerCreditTransactionsEntityRelationInput"]> | undefined | null,
	voucherRedemption?: ValueTypes["OrderDiscountUpdateVoucherRedemptionEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderPaymentCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	data?: ValueTypes["Json"] | undefined | null,
	paymentCents?: number | undefined | null,
	method?: ValueTypes["OrderPaymentCreateMethodEntityRelationInput"] | undefined | null,
	failedAt?: ValueTypes["DateTime"] | undefined | null,
	state?: ValueTypes["OrderPaymentState"] | undefined | null,
	approvedAt?: ValueTypes["DateTime"] | undefined | null,
	events?: Array<ValueTypes["OrderPaymentCreateEventsEntityRelationInput"]> | undefined | null,
	order?: ValueTypes["OrderPaymentCreateOrderEntityRelationInput"] | undefined | null,
	invoice?: ValueTypes["OrderPaymentCreateInvoiceEntityRelationInput"] | undefined | null,
	walletType?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	publicReceiptUrl?: string | undefined | null,
	priceCents?: number | undefined | null,
	vatRate?: ValueTypes["OrderPaymentCreateVatRateEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["OrderPaymentCreateMetaEntityRelationInput"] | undefined | null,
	otherCurrencyPriceCents?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderPaymentUpdateInput"]: {
	data?: ValueTypes["Json"] | undefined | null,
	paymentCents?: number | undefined | null,
	method?: ValueTypes["OrderPaymentUpdateMethodEntityRelationInput"] | undefined | null,
	failedAt?: ValueTypes["DateTime"] | undefined | null,
	state?: ValueTypes["OrderPaymentState"] | undefined | null,
	approvedAt?: ValueTypes["DateTime"] | undefined | null,
	events?: Array<ValueTypes["OrderPaymentUpdateEventsEntityRelationInput"]> | undefined | null,
	order?: ValueTypes["OrderPaymentUpdateOrderEntityRelationInput"] | undefined | null,
	invoice?: ValueTypes["OrderPaymentUpdateInvoiceEntityRelationInput"] | undefined | null,
	walletType?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	publicReceiptUrl?: string | undefined | null,
	priceCents?: number | undefined | null,
	vatRate?: ValueTypes["OrderPaymentUpdateVatRateEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["OrderPaymentUpdateMetaEntityRelationInput"] | undefined | null,
	otherCurrencyPriceCents?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderDeliveryCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	priceCents?: number | undefined | null,
	deliveredAt?: ValueTypes["DateTime"] | undefined | null,
	method?: ValueTypes["OrderDeliveryCreateMethodEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["OrderDeliveryCreateVatRateEntityRelationInput"] | undefined | null,
	order?: ValueTypes["OrderDeliveryCreateOrderEntityRelationInput"] | undefined | null,
	expectedAt?: ValueTypes["DateTime"] | undefined | null,
	state?: ValueTypes["OrderDeliveryState"] | undefined | null,
	loadingDurationHours?: number | undefined | null,
	dispatchAt?: ValueTypes["DateTime"] | undefined | null,
	duration?: string | undefined | null,
	window?: string | undefined | null,
	expectedEndAt?: ValueTypes["DateTime"] | undefined | null,
	processingAt?: ValueTypes["DateTime"] | undefined | null,
	deliveringAt?: ValueTypes["DateTime"] | undefined | null,
	failedAt?: ValueTypes["DateTime"] | undefined | null,
	internalNote?: string | undefined | null,
	deliveryWaypoint?: ValueTypes["OrderDeliveryCreateDeliveryWaypointEntityRelationInput"] | undefined | null,
	events?: Array<ValueTypes["OrderDeliveryCreateEventsEntityRelationInput"]> | undefined | null,
	prepareAt?: ValueTypes["DateTime"] | undefined | null,
	liftagoRide?: ValueTypes["OrderDeliveryCreateLiftagoRideEntityRelationInput"] | undefined | null,
	pickedAt?: ValueTypes["DateTime"] | undefined | null,
	address?: ValueTypes["OrderDeliveryCreateAddressEntityRelationInput"] | undefined | null,
	trackingCode?: string | undefined | null,
	woltDriveDelivery?: ValueTypes["OrderDeliveryCreateWoltDriveDeliveryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderDeliveryUpdateInput"]: {
	priceCents?: number | undefined | null,
	deliveredAt?: ValueTypes["DateTime"] | undefined | null,
	method?: ValueTypes["OrderDeliveryUpdateMethodEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["OrderDeliveryUpdateVatRateEntityRelationInput"] | undefined | null,
	order?: ValueTypes["OrderDeliveryUpdateOrderEntityRelationInput"] | undefined | null,
	expectedAt?: ValueTypes["DateTime"] | undefined | null,
	state?: ValueTypes["OrderDeliveryState"] | undefined | null,
	loadingDurationHours?: number | undefined | null,
	dispatchAt?: ValueTypes["DateTime"] | undefined | null,
	duration?: string | undefined | null,
	window?: string | undefined | null,
	expectedEndAt?: ValueTypes["DateTime"] | undefined | null,
	processingAt?: ValueTypes["DateTime"] | undefined | null,
	deliveringAt?: ValueTypes["DateTime"] | undefined | null,
	failedAt?: ValueTypes["DateTime"] | undefined | null,
	internalNote?: string | undefined | null,
	deliveryWaypoint?: ValueTypes["OrderDeliveryUpdateDeliveryWaypointEntityRelationInput"] | undefined | null,
	events?: Array<ValueTypes["OrderDeliveryUpdateEventsEntityRelationInput"]> | undefined | null,
	prepareAt?: ValueTypes["DateTime"] | undefined | null,
	liftagoRide?: ValueTypes["OrderDeliveryUpdateLiftagoRideEntityRelationInput"] | undefined | null,
	pickedAt?: ValueTypes["DateTime"] | undefined | null,
	address?: ValueTypes["OrderDeliveryUpdateAddressEntityRelationInput"] | undefined | null,
	trackingCode?: string | undefined | null,
	woltDriveDelivery?: ValueTypes["OrderDeliveryUpdateWoltDriveDeliveryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	unitPriceCents?: number | undefined | null,
	quantity?: number | undefined | null,
	vatRate?: ValueTypes["OrderItemCreateVatRateEntityRelationInput"] | undefined | null,
	order?: ValueTypes["OrderItemCreateOrderEntityRelationInput"] | undefined | null,
	virtualProductEffects?: Array<ValueTypes["OrderItemCreateVirtualProductEffectsEntityRelationInput"]> | undefined | null,
	pickedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["OrderItemCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	product?: ValueTypes["OrderItemCreateProductEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderItemUpdateInput"]: {
	unitPriceCents?: number | undefined | null,
	quantity?: number | undefined | null,
	vatRate?: ValueTypes["OrderItemUpdateVatRateEntityRelationInput"] | undefined | null,
	order?: ValueTypes["OrderItemUpdateOrderEntityRelationInput"] | undefined | null,
	virtualProductEffects?: Array<ValueTypes["OrderItemUpdateVirtualProductEffectsEntityRelationInput"]> | undefined | null,
	pickedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["OrderItemUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	product?: ValueTypes["OrderItemUpdateProductEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VatRateConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["VatRateEdge"],
		__typename?: boolean | `@${string}`
}>;
	["VatRateEdge"]: AliasType<{
	node?:ValueTypes["VatRate"],
		__typename?: boolean | `@${string}`
}>;
	["ProductStockCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	quantity?: number | undefined | null,
	product?: ValueTypes["ProductStockCreateProductEntityRelationInput"] | undefined | null,
	store?: ValueTypes["ProductStockCreateStoreEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductStockCreateProductEntityRelationInput"]: {
	connect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductWithoutStocksCreateInput"] | undefined | null
};
	["ProductWithoutStocksCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	priceCents?: number | undefined | null,
	notDiscountable?: boolean | undefined | null,
	packing?: ValueTypes["ProductCreatePackingEntityRelationInput"] | undefined | null,
	recipe?: ValueTypes["ProductCreateRecipeEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["ProductCreateTagsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["ProductCreateCategoriesEntityRelationInput"]> | undefined | null,
	vatRate?: ValueTypes["ProductCreateVatRateEntityRelationInput"] | undefined | null,
	groupPrices?: Array<ValueTypes["ProductCreateGroupPricesEntityRelationInput"]> | undefined | null,
	image?: ValueTypes["ProductCreateImageEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	cartItems?: Array<ValueTypes["ProductCreateCartItemsEntityRelationInput"]> | undefined | null,
	availability?: ValueTypes["ProductAvailability"] | undefined | null,
	order?: number | undefined | null,
	manager?: ValueTypes["ProductCreateManagerEntityRelationInput"] | undefined | null,
	orderItems?: Array<ValueTypes["ProductCreateOrderItemsEntityRelationInput"]> | undefined | null,
	maximumQuantityPerOrder?: number | undefined | null,
	inheritedCategories?: Array<ValueTypes["ProductCreateInheritedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["ProductCreateDeliveryZonesEntityRelationInput"]> | undefined | null,
	locales?: Array<ValueTypes["ProductCreateLocalesEntityRelationInput"]> | undefined | null,
	archivedAt?: ValueTypes["DateTime"] | undefined | null,
	customerPrices?: Array<ValueTypes["ProductCreateCustomerPricesEntityRelationInput"]> | undefined | null,
	virtualProduct?: ValueTypes["ProductCreateVirtualProductEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["ProductCreateMetaEntityRelationInput"] | undefined | null,
	page?: ValueTypes["ProductCreatePageEntityRelationInput"] | undefined | null,
	salesDays?: Array<ValueTypes["ProductCreateSalesDaysEntityRelationInput"]> | undefined | null,
	salesWeeks?: Array<ValueTypes["ProductCreateSalesWeeksEntityRelationInput"]> | undefined | null,
	salesMonths?: Array<ValueTypes["ProductCreateSalesMonthsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["ProductCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	hasSubscription?: boolean | undefined | null,
	pointOfSaleTileColor?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductStockUpdateInput"]: {
	quantity?: number | undefined | null,
	product?: ValueTypes["ProductStockUpdateProductEntityRelationInput"] | undefined | null,
	store?: ValueTypes["ProductStockUpdateStoreEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductStockUpdateProductEntityRelationInput"]: {
	create?: ValueTypes["ProductWithoutStocksCreateInput"] | undefined | null,
	update?: ValueTypes["ProductWithoutStocksUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductStockUpsertProductRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductWithoutStocksUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	priceCents?: number | undefined | null,
	notDiscountable?: boolean | undefined | null,
	packing?: ValueTypes["ProductUpdatePackingEntityRelationInput"] | undefined | null,
	recipe?: ValueTypes["ProductUpdateRecipeEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["ProductUpdateTagsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["ProductUpdateCategoriesEntityRelationInput"]> | undefined | null,
	vatRate?: ValueTypes["ProductUpdateVatRateEntityRelationInput"] | undefined | null,
	groupPrices?: Array<ValueTypes["ProductUpdateGroupPricesEntityRelationInput"]> | undefined | null,
	image?: ValueTypes["ProductUpdateImageEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	cartItems?: Array<ValueTypes["ProductUpdateCartItemsEntityRelationInput"]> | undefined | null,
	availability?: ValueTypes["ProductAvailability"] | undefined | null,
	order?: number | undefined | null,
	manager?: ValueTypes["ProductUpdateManagerEntityRelationInput"] | undefined | null,
	orderItems?: Array<ValueTypes["ProductUpdateOrderItemsEntityRelationInput"]> | undefined | null,
	maximumQuantityPerOrder?: number | undefined | null,
	inheritedCategories?: Array<ValueTypes["ProductUpdateInheritedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["ProductUpdateDeliveryZonesEntityRelationInput"]> | undefined | null,
	locales?: Array<ValueTypes["ProductUpdateLocalesEntityRelationInput"]> | undefined | null,
	archivedAt?: ValueTypes["DateTime"] | undefined | null,
	customerPrices?: Array<ValueTypes["ProductUpdateCustomerPricesEntityRelationInput"]> | undefined | null,
	virtualProduct?: ValueTypes["ProductUpdateVirtualProductEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["ProductUpdateMetaEntityRelationInput"] | undefined | null,
	page?: ValueTypes["ProductUpdatePageEntityRelationInput"] | undefined | null,
	salesDays?: Array<ValueTypes["ProductUpdateSalesDaysEntityRelationInput"]> | undefined | null,
	salesWeeks?: Array<ValueTypes["ProductUpdateSalesWeeksEntityRelationInput"]> | undefined | null,
	salesMonths?: Array<ValueTypes["ProductUpdateSalesMonthsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["ProductUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	hasSubscription?: boolean | undefined | null,
	pointOfSaleTileColor?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductStockUpsertProductRelationInput"]: {
	update?: ValueTypes["ProductWithoutStocksUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductWithoutStocksCreateInput"] | undefined | null
};
	["ProductPackingConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductPackingEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProductPackingEdge"]: AliasType<{
	node?:ValueTypes["ProductPacking"],
		__typename?: boolean | `@${string}`
}>;
	["ProductGroupPriceCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	priceCents?: number | undefined | null,
	group?: ValueTypes["ProductGroupPriceCreateGroupEntityRelationInput"] | undefined | null,
	product?: ValueTypes["ProductGroupPriceCreateProductEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductGroupPriceUpdateInput"]: {
	priceCents?: number | undefined | null,
	group?: ValueTypes["ProductGroupPriceUpdateGroupEntityRelationInput"] | undefined | null,
	product?: ValueTypes["ProductGroupPriceUpdateProductEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductRecipeConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductRecipeEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProductRecipeEdge"]: AliasType<{
	node?:ValueTypes["ProductRecipe"],
		__typename?: boolean | `@${string}`
}>;
	["StoreConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["StoreEdge"],
		__typename?: boolean | `@${string}`
}>;
	["StoreEdge"]: AliasType<{
	node?:ValueTypes["Store"],
		__typename?: boolean | `@${string}`
}>;
	["TagCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	customers?: Array<ValueTypes["TagCreateCustomersEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["TagCreateProductsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["TagCreateCategoriesEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	addTagsOnRegistration?: Array<ValueTypes["TagCreateAddTagsOnRegistrationEntityRelationInput"]> | undefined | null,
	nestedCategories?: Array<ValueTypes["TagCreateNestedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["TagCreateDeliveryZonesEntityRelationInput"]> | undefined | null,
	publicInChannels?: Array<ValueTypes["TagCreatePublicInChannelsEntityRelationInput"]> | undefined | null,
	allowChannelPayments?: Array<ValueTypes["TagCreateAllowChannelPaymentsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["TagCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TagUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	customers?: Array<ValueTypes["TagUpdateCustomersEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["TagUpdateProductsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["TagUpdateCategoriesEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	addTagsOnRegistration?: Array<ValueTypes["TagUpdateAddTagsOnRegistrationEntityRelationInput"]> | undefined | null,
	nestedCategories?: Array<ValueTypes["TagUpdateNestedCategoriesEntityRelationInput"]> | undefined | null,
	deliveryZones?: Array<ValueTypes["TagUpdateDeliveryZonesEntityRelationInput"]> | undefined | null,
	publicInChannels?: Array<ValueTypes["TagUpdatePublicInChannelsEntityRelationInput"]> | undefined | null,
	allowChannelPayments?: Array<ValueTypes["TagUpdateAllowChannelPaymentsEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["TagUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerPermissionsConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CustomerPermissionsEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerPermissionsEdge"]: AliasType<{
	node?:ValueTypes["CustomerPermissions"],
		__typename?: boolean | `@${string}`
}>;
	["ImageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ImageEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ImageEdge"]: AliasType<{
	node?:ValueTypes["Image"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessCategoryCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	visibleToNewCustomers?: boolean | undefined | null,
	locales?: Array<ValueTypes["BusinessCategoryCreateLocalesEntityRelationInput"]> | undefined | null,
	internalName?: string | undefined | null,
	businessCustomers?: Array<ValueTypes["BusinessCategoryCreateBusinessCustomersEntityRelationInput"]> | undefined | null,
	recurrences?: Array<ValueTypes["BusinessCategoryCreateRecurrencesEntityRelationInput"]> | undefined | null,
	specificProducts?: ValueTypes["BusinessCategoryCreateSpecificProductsEntityRelationInput"] | undefined | null,
	seasonalProductCategories?: ValueTypes["BusinessCategoryCreateSeasonalProductCategoriesEntityRelationInput"] | undefined | null,
	specificProductsProductCategories?: ValueTypes["BusinessCategoryCreateSpecificProductsProductCategoriesEntityRelationInput"] | undefined | null,
	slug?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessCategoryUpdateInput"]: {
	order?: number | undefined | null,
	visibleToNewCustomers?: boolean | undefined | null,
	locales?: Array<ValueTypes["BusinessCategoryUpdateLocalesEntityRelationInput"]> | undefined | null,
	internalName?: string | undefined | null,
	businessCustomers?: Array<ValueTypes["BusinessCategoryUpdateBusinessCustomersEntityRelationInput"]> | undefined | null,
	recurrences?: Array<ValueTypes["BusinessCategoryUpdateRecurrencesEntityRelationInput"]> | undefined | null,
	specificProducts?: ValueTypes["BusinessCategoryUpdateSpecificProductsEntityRelationInput"] | undefined | null,
	seasonalProductCategories?: ValueTypes["BusinessCategoryUpdateSeasonalProductCategoriesEntityRelationInput"] | undefined | null,
	specificProductsProductCategories?: ValueTypes["BusinessCategoryUpdateSpecificProductsProductCategoriesEntityRelationInput"] | undefined | null,
	slug?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProductListEdge"]: AliasType<{
	node?:ValueTypes["ProductList"],
		__typename?: boolean | `@${string}`
}>;
	["ProductListItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	list?: ValueTypes["ProductListItemCreateListEntityRelationInput"] | undefined | null,
	product?: ValueTypes["ProductListItemCreateProductEntityRelationInput"] | undefined | null,
	defaultQuantityForOrder?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductListItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["ProductListUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductListWithoutItemsCreateInput"] | undefined | null
};
	["ProductListWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	businessCategory?: ValueTypes["ProductListCreateBusinessCategoryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductListItemUpdateInput"]: {
	order?: number | undefined | null,
	list?: ValueTypes["ProductListItemUpdateListEntityRelationInput"] | undefined | null,
	product?: ValueTypes["ProductListItemUpdateProductEntityRelationInput"] | undefined | null,
	defaultQuantityForOrder?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductListItemUpdateListEntityRelationInput"]: {
	create?: ValueTypes["ProductListWithoutItemsCreateInput"] | undefined | null,
	update?: ValueTypes["ProductListWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductListItemUpsertListRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductListUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductListWithoutItemsUpdateInput"]: {
	businessCategory?: ValueTypes["ProductListUpdateBusinessCategoryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductListItemUpsertListRelationInput"]: {
	update?: ValueTypes["ProductListWithoutItemsUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductListWithoutItemsCreateInput"] | undefined | null
};
	["ProductCategoryListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductCategoryListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProductCategoryListEdge"]: AliasType<{
	node?:ValueTypes["ProductCategoryList"],
		__typename?: boolean | `@${string}`
}>;
	["ProductCategoryListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: Array<ValueTypes["ProductCategoryListCreateItemsEntityRelationInput"]> | undefined | null,
	locales?: Array<ValueTypes["ProductCategoryListCreateLocalesEntityRelationInput"]> | undefined | null,
	seasonalProductCategoriesOfBusinessCategory?: ValueTypes["ProductCategoryListCreateSeasonalProductCategoriesOfBusinessCategoryEntityRelationInput"] | undefined | null,
	specificProductsProductCategoriesOfBusinessCategory?: ValueTypes["ProductCategoryListCreateSpecificProductsProductCategoriesOfBusinessCategoryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCategoryListUpdateInput"]: {
	items?: Array<ValueTypes["ProductCategoryListUpdateItemsEntityRelationInput"]> | undefined | null,
	locales?: Array<ValueTypes["ProductCategoryListUpdateLocalesEntityRelationInput"]> | undefined | null,
	seasonalProductCategoriesOfBusinessCategory?: ValueTypes["ProductCategoryListUpdateSeasonalProductCategoriesOfBusinessCategoryEntityRelationInput"] | undefined | null,
	specificProductsProductCategoriesOfBusinessCategory?: ValueTypes["ProductCategoryListUpdateSpecificProductsProductCategoriesOfBusinessCategoryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCategoryListItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	list?: ValueTypes["ProductCategoryListItemCreateListEntityRelationInput"] | undefined | null,
	productCategory?: ValueTypes["ProductCategoryListItemCreateProductCategoryEntityRelationInput"] | undefined | null,
	showRecipeImages?: boolean | undefined | null,
	showPackingImages?: boolean | undefined | null,
	showAllAvailableProducts?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCategoryListItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["ProductCategoryListUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductCategoryListWithoutItemsCreateInput"] | undefined | null
};
	["ProductCategoryListWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	locales?: Array<ValueTypes["ProductCategoryListCreateLocalesEntityRelationInput"]> | undefined | null,
	seasonalProductCategoriesOfBusinessCategory?: ValueTypes["ProductCategoryListCreateSeasonalProductCategoriesOfBusinessCategoryEntityRelationInput"] | undefined | null,
	specificProductsProductCategoriesOfBusinessCategory?: ValueTypes["ProductCategoryListCreateSpecificProductsProductCategoriesOfBusinessCategoryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCategoryListItemUpdateInput"]: {
	order?: number | undefined | null,
	list?: ValueTypes["ProductCategoryListItemUpdateListEntityRelationInput"] | undefined | null,
	productCategory?: ValueTypes["ProductCategoryListItemUpdateProductCategoryEntityRelationInput"] | undefined | null,
	showRecipeImages?: boolean | undefined | null,
	showPackingImages?: boolean | undefined | null,
	showAllAvailableProducts?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCategoryListItemUpdateListEntityRelationInput"]: {
	create?: ValueTypes["ProductCategoryListWithoutItemsCreateInput"] | undefined | null,
	update?: ValueTypes["ProductCategoryListWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductCategoryListItemUpsertListRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductCategoryListUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductCategoryListWithoutItemsUpdateInput"]: {
	locales?: Array<ValueTypes["ProductCategoryListUpdateLocalesEntityRelationInput"]> | undefined | null,
	seasonalProductCategoriesOfBusinessCategory?: ValueTypes["ProductCategoryListUpdateSeasonalProductCategoriesOfBusinessCategoryEntityRelationInput"] | undefined | null,
	specificProductsProductCategoriesOfBusinessCategory?: ValueTypes["ProductCategoryListUpdateSpecificProductsProductCategoriesOfBusinessCategoryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCategoryListItemUpsertListRelationInput"]: {
	update?: ValueTypes["ProductCategoryListWithoutItemsUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductCategoryListWithoutItemsCreateInput"] | undefined | null
};
	["BusinessCategoryLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	root?: ValueTypes["BusinessCategoryLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["BusinessCategoryLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	title?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessCategoryLocaleUpdateInput"]: {
	name?: string | undefined | null,
	root?: ValueTypes["BusinessCategoryLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["BusinessCategoryLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	title?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LocaleEdge"],
		__typename?: boolean | `@${string}`
}>;
	["LocaleEdge"]: AliasType<{
	node?:ValueTypes["Locale"],
		__typename?: boolean | `@${string}`
}>;
	["LocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	businessCategories?: Array<ValueTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleCreateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleCreatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleCreateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LocaleUpdateInput"]: {
	businessCategories?: Array<ValueTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCategoryListLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	root?: ValueTypes["ProductCategoryListLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["ProductCategoryListLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductCategoryListLocaleUpdateInput"]: {
	name?: string | undefined | null,
	root?: ValueTypes["ProductCategoryListLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["ProductCategoryListLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerNameConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CustomerNameEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerNameEdge"]: AliasType<{
	node?:ValueTypes["CustomerName"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerNameCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	nominative?: string | undefined | null,
	vocative?: string | undefined | null,
	customer?: ValueTypes["CustomerNameCreateCustomerEntityRelationInput"] | undefined | null,
	aliases?: Array<ValueTypes["CustomerNameCreateAliasesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerNameCreateCustomerEntityRelationInput"]: {
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerWithoutNameCreateInput"] | undefined | null
};
	["CustomerWithoutNameCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	addresses?: Array<ValueTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerCreateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerCreateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerCreatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerCreateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerCreateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerCreateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerCreateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerCreateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerCreateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerNameUpdateInput"]: {
	nominative?: string | undefined | null,
	vocative?: string | undefined | null,
	customer?: ValueTypes["CustomerNameUpdateCustomerEntityRelationInput"] | undefined | null,
	aliases?: Array<ValueTypes["CustomerNameUpdateAliasesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerNameUpdateCustomerEntityRelationInput"]: {
	create?: ValueTypes["CustomerWithoutNameCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerWithoutNameUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CustomerNameUpsertCustomerRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CustomerWithoutNameUpdateInput"]: {
	addresses?: Array<ValueTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerUpdateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerUpdateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerUpdateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerNameUpsertCustomerRelationInput"]: {
	update?: ValueTypes["CustomerWithoutNameUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerWithoutNameCreateInput"] | undefined | null
};
	["ProductIngredientItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	internalOrder?: number | undefined | null,
	recipe?: ValueTypes["ProductIngredientItemCreateRecipeEntityRelationInput"] | undefined | null,
	ingredient?: ValueTypes["ProductIngredientItemCreateIngredientEntityRelationInput"] | undefined | null,
	quantity?: ValueTypes["ProductIngredientItemCreateQuantityEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientItemCreateRecipeEntityRelationInput"]: {
	connect?: ValueTypes["ProductRecipeUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductRecipeWithoutIngredientsCreateInput"] | undefined | null
};
	["ProductRecipeWithoutIngredientsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	products?: Array<ValueTypes["ProductRecipeCreateProductsEntityRelationInput"]> | undefined | null,
	internalNote?: string | undefined | null,
	color?: string | undefined | null,
	image?: ValueTypes["ProductRecipeCreateImageEntityRelationInput"] | undefined | null,
	icon?: ValueTypes["ProductRecipeCreateIconEntityRelationInput"] | undefined | null,
	needsPrepping?: boolean | undefined | null,
	locales?: Array<ValueTypes["ProductRecipeCreateLocalesEntityRelationInput"]> | undefined | null,
	gutTuning?: number | undefined | null,
	freshingContainer?: ValueTypes["ProductRecipeCreateFreshingContainerEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	nutritionFacts?: ValueTypes["ProductRecipeCreateNutritionFactsEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientItemUpdateInput"]: {
	order?: number | undefined | null,
	internalOrder?: number | undefined | null,
	recipe?: ValueTypes["ProductIngredientItemUpdateRecipeEntityRelationInput"] | undefined | null,
	ingredient?: ValueTypes["ProductIngredientItemUpdateIngredientEntityRelationInput"] | undefined | null,
	quantity?: ValueTypes["ProductIngredientItemUpdateQuantityEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientItemUpdateRecipeEntityRelationInput"]: {
	create?: ValueTypes["ProductRecipeWithoutIngredientsCreateInput"] | undefined | null,
	update?: ValueTypes["ProductRecipeWithoutIngredientsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductIngredientItemUpsertRecipeRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductRecipeUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductRecipeWithoutIngredientsUpdateInput"]: {
	name?: string | undefined | null,
	products?: Array<ValueTypes["ProductRecipeUpdateProductsEntityRelationInput"]> | undefined | null,
	internalNote?: string | undefined | null,
	color?: string | undefined | null,
	image?: ValueTypes["ProductRecipeUpdateImageEntityRelationInput"] | undefined | null,
	icon?: ValueTypes["ProductRecipeUpdateIconEntityRelationInput"] | undefined | null,
	needsPrepping?: boolean | undefined | null,
	locales?: Array<ValueTypes["ProductRecipeUpdateLocalesEntityRelationInput"]> | undefined | null,
	gutTuning?: number | undefined | null,
	freshingContainer?: ValueTypes["ProductRecipeUpdateFreshingContainerEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	nutritionFacts?: ValueTypes["ProductRecipeUpdateNutritionFactsEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientItemUpsertRecipeRelationInput"]: {
	update?: ValueTypes["ProductRecipeWithoutIngredientsUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductRecipeWithoutIngredientsCreateInput"] | undefined | null
};
	["ProductIngredientItemQuantityConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductIngredientItemQuantityEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientItemQuantityEdge"]: AliasType<{
	node?:ValueTypes["ProductIngredientItemQuantity"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientItemQuantityUnitConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductIngredientItemQuantityUnitEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientItemQuantityUnitEdge"]: AliasType<{
	node?:ValueTypes["ProductIngredientItemQuantityUnit"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerIngredientRatingCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	customer?: ValueTypes["CustomerIngredientRatingCreateCustomerEntityRelationInput"] | undefined | null,
	rating?: ValueTypes["CustomerIngredientRatingCreateRatingEntityRelationInput"] | undefined | null,
	ingredient?: ValueTypes["CustomerIngredientRatingCreateIngredientEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerIngredientRatingUpdateInput"]: {
	customer?: ValueTypes["CustomerIngredientRatingUpdateCustomerEntityRelationInput"] | undefined | null,
	rating?: ValueTypes["CustomerIngredientRatingUpdateRatingEntityRelationInput"] | undefined | null,
	ingredient?: ValueTypes["CustomerIngredientRatingUpdateIngredientEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientRatingConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductIngredientRatingEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientRatingEdge"]: AliasType<{
	node?:ValueTypes["ProductIngredientRating"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	root?: ValueTypes["ProductIngredientLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["ProductIngredientLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientLocaleUpdateInput"]: {
	name?: string | undefined | null,
	root?: ValueTypes["ProductIngredientLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["ProductIngredientLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderRecurrenceCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	internalName?: string | undefined | null,
	locales?: Array<ValueTypes["OrderRecurrenceCreateLocalesEntityRelationInput"]> | undefined | null,
	order?: number | undefined | null,
	businessCategory?: Array<ValueTypes["OrderRecurrenceCreateBusinessCategoryEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderRecurrenceUpdateInput"]: {
	internalName?: string | undefined | null,
	locales?: Array<ValueTypes["OrderRecurrenceUpdateLocalesEntityRelationInput"]> | undefined | null,
	order?: number | undefined | null,
	businessCategory?: Array<ValueTypes["OrderRecurrenceUpdateBusinessCategoryEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderRecurrenceLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	root?: ValueTypes["OrderRecurrenceLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["OrderRecurrenceLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderRecurrenceLocaleUpdateInput"]: {
	name?: string | undefined | null,
	root?: ValueTypes["OrderRecurrenceLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["OrderRecurrenceLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessCustomerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	customer?: ValueTypes["BusinessCustomerCreateCustomerEntityRelationInput"] | undefined | null,
	owners?: Array<ValueTypes["BusinessCustomerCreateOwnersEntityRelationInput"]> | undefined | null,
	members?: Array<ValueTypes["BusinessCustomerCreateMembersEntityRelationInput"]> | undefined | null,
	category?: ValueTypes["BusinessCustomerCreateCategoryEntityRelationInput"] | undefined | null,
	accountManager?: ValueTypes["BusinessCustomerCreateAccountManagerEntityRelationInput"] | undefined | null,
	logo?: ValueTypes["BusinessCustomerCreateLogoEntityRelationInput"] | undefined | null,
	note?: string | undefined | null,
	businessServiceEvents?: Array<ValueTypes["BusinessCustomerCreateBusinessServiceEventsEntityRelationInput"]> | undefined | null,
	doubleshotCoffeeEquipment?: ValueTypes["BusinessCustomerCreateDoubleshotCoffeeEquipmentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessCustomerUpdateInput"]: {
	name?: string | undefined | null,
	customer?: ValueTypes["BusinessCustomerUpdateCustomerEntityRelationInput"] | undefined | null,
	owners?: Array<ValueTypes["BusinessCustomerUpdateOwnersEntityRelationInput"]> | undefined | null,
	members?: Array<ValueTypes["BusinessCustomerUpdateMembersEntityRelationInput"]> | undefined | null,
	category?: ValueTypes["BusinessCustomerUpdateCategoryEntityRelationInput"] | undefined | null,
	accountManager?: ValueTypes["BusinessCustomerUpdateAccountManagerEntityRelationInput"] | undefined | null,
	logo?: ValueTypes["BusinessCustomerUpdateLogoEntityRelationInput"] | undefined | null,
	note?: string | undefined | null,
	businessServiceEvents?: Array<ValueTypes["BusinessCustomerUpdateBusinessServiceEventsEntityRelationInput"]> | undefined | null,
	doubleshotCoffeeEquipment?: ValueTypes["BusinessCustomerUpdateDoubleshotCoffeeEquipmentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	channels?: Array<ValueTypes["PointOfSaleCreateChannelsEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["PointOfSaleCreatePermissionsEntityRelationInput"] | undefined | null,
	tenantPersonId?: ValueTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleCreateChannelsEntityRelationInput"]: {
	connect?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	create?: ValueTypes["ChannelWithoutPointOfSalesCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ChannelWithoutPointOfSalesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	disabled?: boolean | undefined | null,
	payments?: Array<ValueTypes["ChannelCreatePaymentsEntityRelationInput"]> | undefined | null,
	deliveries?: Array<ValueTypes["ChannelCreateDeliveriesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["ChannelCreateCartsEntityRelationInput"]> | undefined | null,
	customers?: Array<ValueTypes["ChannelCreateCustomersEntityRelationInput"]> | undefined | null,
	code?: ValueTypes["ChannelCode"] | undefined | null,
	addTagsOnRegistration?: Array<ValueTypes["ChannelCreateAddTagsOnRegistrationEntityRelationInput"]> | undefined | null,
	publicTags?: Array<ValueTypes["ChannelCreatePublicTagsEntityRelationInput"]> | undefined | null,
	venue?: ValueTypes["ChannelCreateVenueEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	channels?: Array<ValueTypes["PointOfSaleUpdateChannelsEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["PointOfSaleUpdatePermissionsEntityRelationInput"] | undefined | null,
	tenantPersonId?: ValueTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleUpdateChannelsEntityRelationInput"]: {
	create?: ValueTypes["ChannelWithoutPointOfSalesCreateInput"] | undefined | null,
	update?: ValueTypes["PointOfSaleUpdateChannelsRelationInput"] | undefined | null,
	upsert?: ValueTypes["PointOfSaleUpsertChannelsRelationInput"] | undefined | null,
	connect?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PointOfSaleUpdateChannelsRelationInput"]: {
	by?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	data?: ValueTypes["ChannelWithoutPointOfSalesUpdateInput"] | undefined | null
};
	["ChannelWithoutPointOfSalesUpdateInput"]: {
	name?: string | undefined | null,
	disabled?: boolean | undefined | null,
	payments?: Array<ValueTypes["ChannelUpdatePaymentsEntityRelationInput"]> | undefined | null,
	deliveries?: Array<ValueTypes["ChannelUpdateDeliveriesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["ChannelUpdateCartsEntityRelationInput"]> | undefined | null,
	customers?: Array<ValueTypes["ChannelUpdateCustomersEntityRelationInput"]> | undefined | null,
	code?: ValueTypes["ChannelCode"] | undefined | null,
	addTagsOnRegistration?: Array<ValueTypes["ChannelUpdateAddTagsOnRegistrationEntityRelationInput"]> | undefined | null,
	publicTags?: Array<ValueTypes["ChannelUpdatePublicTagsEntityRelationInput"]> | undefined | null,
	venue?: ValueTypes["ChannelUpdateVenueEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleUpsertChannelsRelationInput"]: {
	by?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	update?: ValueTypes["ChannelWithoutPointOfSalesUpdateInput"] | undefined | null,
	create?: ValueTypes["ChannelWithoutPointOfSalesCreateInput"] | undefined | null
};
	["PointOfSalePermissionsConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PointOfSalePermissionsEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSalePermissionsEdge"]: AliasType<{
	node?:ValueTypes["PointOfSalePermissions"],
		__typename?: boolean | `@${string}`
}>;
	["BlogConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BlogEdge"],
		__typename?: boolean | `@${string}`
}>;
	["BlogEdge"]: AliasType<{
	node?:ValueTypes["Blog"],
		__typename?: boolean | `@${string}`
}>;
	["BlogCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	unique?: ValueTypes["One"] | undefined | null,
	locales?: Array<ValueTypes["BlogCreateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BlogCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["BlogLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["BlogLocaleWithoutRootCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["BlogLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	pageName?: string | undefined | null,
	title?: string | undefined | null,
	lead?: string | undefined | null,
	locale?: ValueTypes["BlogLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BlogLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["LocaleWithoutBlogsCreateInput"] | undefined | null
};
	["LocaleWithoutBlogsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	businessCategories?: Array<ValueTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleCreateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleCreatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleCreateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BlogUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null,
	locales?: Array<ValueTypes["BlogUpdateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BlogUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["BlogLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ValueTypes["BlogUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ValueTypes["BlogUpsertLocalesRelationInput"] | undefined | null,
	connect?: ValueTypes["BlogLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["BlogLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["BlogLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["BlogUpdateLocalesRelationInput"]: {
	by?: ValueTypes["BlogLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["BlogLocaleWithoutRootUpdateInput"] | undefined | null
};
	["BlogLocaleWithoutRootUpdateInput"]: {
	pageName?: string | undefined | null,
	title?: string | undefined | null,
	lead?: string | undefined | null,
	locale?: ValueTypes["BlogLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BlogLocaleUpdateLocaleEntityRelationInput"]: {
	create?: ValueTypes["LocaleWithoutBlogsCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleWithoutBlogsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["BlogLocaleUpsertLocaleRelationInput"] | undefined | null,
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutBlogsUpdateInput"]: {
	businessCategories?: Array<ValueTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BlogLocaleUpsertLocaleRelationInput"]: {
	update?: ValueTypes["LocaleWithoutBlogsUpdateInput"] | undefined | null,
	create?: ValueTypes["LocaleWithoutBlogsCreateInput"] | undefined | null
};
	["BlogUpsertLocalesRelationInput"]: {
	by?: ValueTypes["BlogLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["BlogLocaleWithoutRootUpdateInput"] | undefined | null,
	create?: ValueTypes["BlogLocaleWithoutRootCreateInput"] | undefined | null
};
	["BlogLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	pageName?: string | undefined | null,
	title?: string | undefined | null,
	lead?: string | undefined | null,
	root?: ValueTypes["BlogLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["BlogLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BlogLocaleUpdateInput"]: {
	pageName?: string | undefined | null,
	title?: string | undefined | null,
	lead?: string | undefined | null,
	root?: ValueTypes["BlogLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["BlogLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BlogPostConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BlogPostEdge"],
		__typename?: boolean | `@${string}`
}>;
	["BlogPostEdge"]: AliasType<{
	node?:ValueTypes["BlogPost"],
		__typename?: boolean | `@${string}`
}>;
	["BlogPostCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	locales?: Array<ValueTypes["BlogPostCreateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BlogPostCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["BlogPostLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["BlogPostLocaleWithoutRootCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["BlogPostLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	availableForWeb?: boolean | undefined | null,
	availableForMobile?: boolean | undefined | null,
	locale?: ValueTypes["BlogPostLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	cover?: ValueTypes["BlogPostLocaleCreateCoverEntityRelationInput"] | undefined | null,
	content?: ValueTypes["BlogPostLocaleCreateContentEntityRelationInput"] | undefined | null,
	link?: ValueTypes["BlogPostLocaleCreateLinkEntityRelationInput"] | undefined | null,
	seo?: ValueTypes["BlogPostLocaleCreateSeoEntityRelationInput"] | undefined | null,
	products?: Array<ValueTypes["BlogPostLocaleCreateProductsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BlogPostUpdateInput"]: {
	order?: number | undefined | null,
	locales?: Array<ValueTypes["BlogPostUpdateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BlogPostUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["BlogPostLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ValueTypes["BlogPostUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ValueTypes["BlogPostUpsertLocalesRelationInput"] | undefined | null,
	connect?: ValueTypes["BlogPostLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["BlogPostLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["BlogPostLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["BlogPostUpdateLocalesRelationInput"]: {
	by?: ValueTypes["BlogPostLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["BlogPostLocaleWithoutRootUpdateInput"] | undefined | null
};
	["BlogPostLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined | null,
	availableForWeb?: boolean | undefined | null,
	availableForMobile?: boolean | undefined | null,
	locale?: ValueTypes["BlogPostLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	cover?: ValueTypes["BlogPostLocaleUpdateCoverEntityRelationInput"] | undefined | null,
	content?: ValueTypes["BlogPostLocaleUpdateContentEntityRelationInput"] | undefined | null,
	link?: ValueTypes["BlogPostLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	seo?: ValueTypes["BlogPostLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	products?: Array<ValueTypes["BlogPostLocaleUpdateProductsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BlogPostUpsertLocalesRelationInput"]: {
	by?: ValueTypes["BlogPostLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["BlogPostLocaleWithoutRootUpdateInput"] | undefined | null,
	create?: ValueTypes["BlogPostLocaleWithoutRootCreateInput"] | undefined | null
};
	["ColorPalleteConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ColorPalleteEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ColorPalleteEdge"]: AliasType<{
	node?:ValueTypes["ColorPallete"],
		__typename?: boolean | `@${string}`
}>;
	["ContentConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ContentEdge"]: AliasType<{
	node?:ValueTypes["Content"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	json?: string | undefined | null,
	content?: ValueTypes["ContentBlockCreateContentEntityRelationInput"] | undefined | null,
	references?: Array<ValueTypes["ContentBlockCreateReferencesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentBlockCreateContentEntityRelationInput"]: {
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null,
	create?: ValueTypes["ContentWithoutBlocksCreateInput"] | undefined | null
};
	["ContentWithoutBlocksCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentBlockUpdateInput"]: {
	order?: number | undefined | null,
	json?: string | undefined | null,
	content?: ValueTypes["ContentBlockUpdateContentEntityRelationInput"] | undefined | null,
	references?: Array<ValueTypes["ContentBlockUpdateReferencesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentBlockUpdateContentEntityRelationInput"]: {
	create?: ValueTypes["ContentWithoutBlocksCreateInput"] | undefined | null,
	update?: ValueTypes["ContentWithoutBlocksUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ContentBlockUpsertContentRelationInput"] | undefined | null,
	connect?: ValueTypes["ContentUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["ContentWithoutBlocksUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null
};
	["ContentBlockUpsertContentRelationInput"]: {
	update?: ValueTypes["ContentWithoutBlocksUpdateInput"] | undefined | null,
	create?: ValueTypes["ContentWithoutBlocksCreateInput"] | undefined | null
};
	["ContentReferenceCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	type?: ValueTypes["ContentReferenceType"] | undefined | null,
	primaryText?: string | undefined | null,
	secondaryText?: string | undefined | null,
	jsonContent?: string | undefined | null,
	block?: ValueTypes["ContentReferenceCreateBlockEntityRelationInput"] | undefined | null,
	colorPallete?: ValueTypes["ContentReferenceCreateColorPalleteEntityRelationInput"] | undefined | null,
	medium?: ValueTypes["ContentReferenceCreateMediumEntityRelationInput"] | undefined | null,
	link?: ValueTypes["ContentReferenceCreateLinkEntityRelationInput"] | undefined | null,
	blogPosts?: ValueTypes["ContentReferenceCreateBlogPostsEntityRelationInput"] | undefined | null,
	links?: ValueTypes["ContentReferenceCreateLinksEntityRelationInput"] | undefined | null,
	products?: ValueTypes["ContentReferenceCreateProductsEntityRelationInput"] | undefined | null,
	contentSize?: ValueTypes["ContentSize"] | undefined | null,
	misc?: string | undefined | null,
	hero?: ValueTypes["ContentReferenceCreateHeroEntityRelationInput"] | undefined | null,
	gallery?: ValueTypes["ContentReferenceCreateGalleryEntityRelationInput"] | undefined | null,
	socialsAndApps?: ValueTypes["ContentReferenceCreateSocialsAndAppsEntityRelationInput"] | undefined | null,
	productGrid?: ValueTypes["ContentReferenceCreateProductGridEntityRelationInput"] | undefined | null,
	productBanners?: ValueTypes["ContentReferenceCreateProductBannersEntityRelationInput"] | undefined | null,
	deliveryRegions?: ValueTypes["ContentReferenceCreateDeliveryRegionsEntityRelationInput"] | undefined | null,
	textList?: ValueTypes["ContentReferenceCreateTextListEntityRelationInput"] | undefined | null,
	gridTiles?: ValueTypes["ContentReferenceCreateGridTilesEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentReferenceCreateBlockEntityRelationInput"]: {
	connect?: ValueTypes["ContentBlockUniqueWhere"] | undefined | null,
	create?: ValueTypes["ContentBlockWithoutReferencesCreateInput"] | undefined | null
};
	["ContentBlockWithoutReferencesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	json?: string | undefined | null,
	content?: ValueTypes["ContentBlockCreateContentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentReferenceUpdateInput"]: {
	type?: ValueTypes["ContentReferenceType"] | undefined | null,
	primaryText?: string | undefined | null,
	secondaryText?: string | undefined | null,
	jsonContent?: string | undefined | null,
	block?: ValueTypes["ContentReferenceUpdateBlockEntityRelationInput"] | undefined | null,
	colorPallete?: ValueTypes["ContentReferenceUpdateColorPalleteEntityRelationInput"] | undefined | null,
	medium?: ValueTypes["ContentReferenceUpdateMediumEntityRelationInput"] | undefined | null,
	link?: ValueTypes["ContentReferenceUpdateLinkEntityRelationInput"] | undefined | null,
	blogPosts?: ValueTypes["ContentReferenceUpdateBlogPostsEntityRelationInput"] | undefined | null,
	links?: ValueTypes["ContentReferenceUpdateLinksEntityRelationInput"] | undefined | null,
	products?: ValueTypes["ContentReferenceUpdateProductsEntityRelationInput"] | undefined | null,
	contentSize?: ValueTypes["ContentSize"] | undefined | null,
	misc?: string | undefined | null,
	hero?: ValueTypes["ContentReferenceUpdateHeroEntityRelationInput"] | undefined | null,
	gallery?: ValueTypes["ContentReferenceUpdateGalleryEntityRelationInput"] | undefined | null,
	socialsAndApps?: ValueTypes["ContentReferenceUpdateSocialsAndAppsEntityRelationInput"] | undefined | null,
	productGrid?: ValueTypes["ContentReferenceUpdateProductGridEntityRelationInput"] | undefined | null,
	productBanners?: ValueTypes["ContentReferenceUpdateProductBannersEntityRelationInput"] | undefined | null,
	deliveryRegions?: ValueTypes["ContentReferenceUpdateDeliveryRegionsEntityRelationInput"] | undefined | null,
	textList?: ValueTypes["ContentReferenceUpdateTextListEntityRelationInput"] | undefined | null,
	gridTiles?: ValueTypes["ContentReferenceUpdateGridTilesEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentReferenceUpdateBlockEntityRelationInput"]: {
	create?: ValueTypes["ContentBlockWithoutReferencesCreateInput"] | undefined | null,
	update?: ValueTypes["ContentBlockWithoutReferencesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ContentReferenceUpsertBlockRelationInput"] | undefined | null,
	connect?: ValueTypes["ContentBlockUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["ContentBlockWithoutReferencesUpdateInput"]: {
	order?: number | undefined | null,
	json?: string | undefined | null,
	content?: ValueTypes["ContentBlockUpdateContentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ContentReferenceUpsertBlockRelationInput"]: {
	update?: ValueTypes["ContentBlockWithoutReferencesUpdateInput"] | undefined | null,
	create?: ValueTypes["ContentBlockWithoutReferencesCreateInput"] | undefined | null
};
	["BlogPostListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BlogPostListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["BlogPostListEdge"]: AliasType<{
	node?:ValueTypes["BlogPostList"],
		__typename?: boolean | `@${string}`
}>;
	["BlogPostListItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	caption?: string | undefined | null,
	list?: ValueTypes["BlogPostListItemCreateListEntityRelationInput"] | undefined | null,
	blogPost?: ValueTypes["BlogPostListItemCreateBlogPostEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BlogPostListItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["BlogPostListUniqueWhere"] | undefined | null,
	create?: ValueTypes["BlogPostListWithoutItemsCreateInput"] | undefined | null
};
	["BlogPostListWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BlogPostListItemUpdateInput"]: {
	order?: number | undefined | null,
	caption?: string | undefined | null,
	list?: ValueTypes["BlogPostListItemUpdateListEntityRelationInput"] | undefined | null,
	blogPost?: ValueTypes["BlogPostListItemUpdateBlogPostEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BlogPostListItemUpdateListEntityRelationInput"]: {
	create?: ValueTypes["BlogPostListWithoutItemsCreateInput"] | undefined | null,
	update?: ValueTypes["BlogPostListWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["BlogPostListItemUpsertListRelationInput"] | undefined | null,
	connect?: ValueTypes["BlogPostListUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["BlogPostListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null
};
	["BlogPostListItemUpsertListRelationInput"]: {
	update?: ValueTypes["BlogPostListWithoutItemsUpdateInput"] | undefined | null,
	create?: ValueTypes["BlogPostListWithoutItemsCreateInput"] | undefined | null
};
	["LinkListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LinkListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["LinkListEdge"]: AliasType<{
	node?:ValueTypes["LinkList"],
		__typename?: boolean | `@${string}`
}>;
	["LinkListItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	isPrimary?: boolean | undefined | null,
	list?: ValueTypes["LinkListItemCreateListEntityRelationInput"] | undefined | null,
	link?: ValueTypes["LinkListItemCreateLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkListItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["LinkListUniqueWhere"] | undefined | null,
	create?: ValueTypes["LinkListWithoutItemsCreateInput"] | undefined | null
};
	["LinkListWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkListItemUpdateInput"]: {
	order?: number | undefined | null,
	isPrimary?: boolean | undefined | null,
	list?: ValueTypes["LinkListItemUpdateListEntityRelationInput"] | undefined | null,
	link?: ValueTypes["LinkListItemUpdateLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LinkListItemUpdateListEntityRelationInput"]: {
	create?: ValueTypes["LinkListWithoutItemsCreateInput"] | undefined | null,
	update?: ValueTypes["LinkListWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["LinkListItemUpsertListRelationInput"] | undefined | null,
	connect?: ValueTypes["LinkListUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LinkListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null
};
	["LinkListItemUpsertListRelationInput"]: {
	update?: ValueTypes["LinkListWithoutItemsUpdateInput"] | undefined | null,
	create?: ValueTypes["LinkListWithoutItemsCreateInput"] | undefined | null
};
	["CoverConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CoverEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CoverEdge"]: AliasType<{
	node?:ValueTypes["Cover"],
		__typename?: boolean | `@${string}`
}>;
	["LinkConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LinkEdge"],
		__typename?: boolean | `@${string}`
}>;
	["LinkEdge"]: AliasType<{
	node?:ValueTypes["Link"],
		__typename?: boolean | `@${string}`
}>;
	["LinkableConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LinkableEdge"],
		__typename?: boolean | `@${string}`
}>;
	["LinkableEdge"]: AliasType<{
	node?:ValueTypes["Linkable"],
		__typename?: boolean | `@${string}`
}>;
	["MediumConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["MediumEdge"],
		__typename?: boolean | `@${string}`
}>;
	["MediumEdge"]: AliasType<{
	node?:ValueTypes["Medium"],
		__typename?: boolean | `@${string}`
}>;
	["VideoConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["VideoEdge"],
		__typename?: boolean | `@${string}`
}>;
	["VideoEdge"]: AliasType<{
	node?:ValueTypes["Video"],
		__typename?: boolean | `@${string}`
}>;
	["SeoConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SeoEdge"],
		__typename?: boolean | `@${string}`
}>;
	["SeoEdge"]: AliasType<{
	node?:ValueTypes["Seo"],
		__typename?: boolean | `@${string}`
}>;
	["ProtectedImage"]: AliasType<{
	_meta?:ValueTypes["ProtectedImageMeta"],
	id?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
	width?:boolean | `@${string}`,
	height?:boolean | `@${string}`,
	size?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	alt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProtectedImageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	width?:ValueTypes["FieldMeta"],
	height?:ValueTypes["FieldMeta"],
	size?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	alt?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProtectedImageUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["ProtectedImageWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	url?: ValueTypes["StringCondition"] | undefined | null,
	width?: ValueTypes["IntCondition"] | undefined | null,
	height?: ValueTypes["IntCondition"] | undefined | null,
	size?: ValueTypes["IntCondition"] | undefined | null,
	type?: ValueTypes["StringCondition"] | undefined | null,
	alt?: ValueTypes["StringCondition"] | undefined | null,
	and?: Array<ValueTypes["ProtectedImageWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ProtectedImageWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ProtectedImageWhere"] | undefined | null
};
	["ProtectedImageOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	url?: ValueTypes["OrderDirection"] | undefined | null,
	width?: ValueTypes["OrderDirection"] | undefined | null,
	height?: ValueTypes["OrderDirection"] | undefined | null,
	size?: ValueTypes["OrderDirection"] | undefined | null,
	type?: ValueTypes["OrderDirection"] | undefined | null,
	alt?: ValueTypes["OrderDirection"] | undefined | null
};
	["ProtectedImageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProtectedImageEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProtectedImageEdge"]: AliasType<{
	node?:ValueTypes["ProtectedImage"],
		__typename?: boolean | `@${string}`
}>;
	["ProtectedImageCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	url?: string | undefined | null,
	width?: number | undefined | null,
	height?: number | undefined | null,
	size?: number | undefined | null,
	type?: string | undefined | null,
	alt?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProtectedImageUpdateInput"]: {
	url?: string | undefined | null,
	width?: number | undefined | null,
	height?: number | undefined | null,
	size?: number | undefined | null,
	type?: string | undefined | null,
	alt?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationDomainConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TranslationDomainEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationDomainEdge"]: AliasType<{
	node?:ValueTypes["TranslationDomain"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationDomainCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	identifier?: string | undefined | null,
	name?: string | undefined | null,
	catalogues?: Array<ValueTypes["TranslationDomainCreateCataloguesEntityRelationInput"]> | undefined | null,
	keys?: Array<ValueTypes["TranslationDomainCreateKeysEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationDomainUpdateInput"]: {
	identifier?: string | undefined | null,
	name?: string | undefined | null,
	catalogues?: Array<ValueTypes["TranslationDomainUpdateCataloguesEntityRelationInput"]> | undefined | null,
	keys?: Array<ValueTypes["TranslationDomainUpdateKeysEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationKeyCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	identifier?: string | undefined | null,
	contentType?: ValueTypes["TranslationContentType"] | undefined | null,
	note?: string | undefined | null,
	domain?: ValueTypes["TranslationKeyCreateDomainEntityRelationInput"] | undefined | null,
	values?: Array<ValueTypes["TranslationKeyCreateValuesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationKeyUpdateInput"]: {
	identifier?: string | undefined | null,
	contentType?: ValueTypes["TranslationContentType"] | undefined | null,
	note?: string | undefined | null,
	domain?: ValueTypes["TranslationKeyUpdateDomainEntityRelationInput"] | undefined | null,
	values?: Array<ValueTypes["TranslationKeyUpdateValuesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationValueCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	value?: string | undefined | null,
	catalogue?: ValueTypes["TranslationValueCreateCatalogueEntityRelationInput"] | undefined | null,
	key?: ValueTypes["TranslationValueCreateKeyEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationValueUpdateInput"]: {
	value?: string | undefined | null,
	catalogue?: ValueTypes["TranslationValueUpdateCatalogueEntityRelationInput"] | undefined | null,
	key?: ValueTypes["TranslationValueUpdateKeyEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TranslationCataloguesIdentifierConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TranslationCataloguesIdentifierEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCataloguesIdentifierEdge"]: AliasType<{
	node?:ValueTypes["TranslationCataloguesIdentifier"],
		__typename?: boolean | `@${string}`
}>;
	["SocialsAndAppsConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SocialsAndAppsEdge"],
		__typename?: boolean | `@${string}`
}>;
	["SocialsAndAppsEdge"]: AliasType<{
	node?:ValueTypes["SocialsAndApps"],
		__typename?: boolean | `@${string}`
}>;
	["ProductGridConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductGridEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProductGridEdge"]: AliasType<{
	node?:ValueTypes["ProductGrid"],
		__typename?: boolean | `@${string}`
}>;
	["ProductGridItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	title?: string | undefined | null,
	lead?: string | undefined | null,
	product?: ValueTypes["ProductGridItemCreateProductEntityRelationInput"] | undefined | null,
	medium?: ValueTypes["ProductGridItemCreateMediumEntityRelationInput"] | undefined | null,
	link?: ValueTypes["ProductGridItemCreateLinkEntityRelationInput"] | undefined | null,
	category?: ValueTypes["ProductGridItemCreateCategoryEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductGridItemCreateCategoryEntityRelationInput"]: {
	connect?: ValueTypes["ProductGridCategoryUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductGridCategoryWithoutItemsCreateInput"] | undefined | null
};
	["ProductGridCategoryWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	title?: string | undefined | null,
	root?: ValueTypes["ProductGridCategoryCreateRootEntityRelationInput"] | undefined | null,
	images?: ValueTypes["ProductGridCategoryCreateImagesEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductGridCategoryCreateRootEntityRelationInput"]: {
	connect?: ValueTypes["ProductGridUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductGridWithoutCategoriesCreateInput"] | undefined | null
};
	["ProductGridWithoutCategoriesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	isCarousel?: boolean | undefined | null,
	type?: ValueTypes["ProductGridType"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductGridItemUpdateInput"]: {
	order?: number | undefined | null,
	title?: string | undefined | null,
	lead?: string | undefined | null,
	product?: ValueTypes["ProductGridItemUpdateProductEntityRelationInput"] | undefined | null,
	medium?: ValueTypes["ProductGridItemUpdateMediumEntityRelationInput"] | undefined | null,
	link?: ValueTypes["ProductGridItemUpdateLinkEntityRelationInput"] | undefined | null,
	category?: ValueTypes["ProductGridItemUpdateCategoryEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductGridItemUpdateCategoryEntityRelationInput"]: {
	create?: ValueTypes["ProductGridCategoryWithoutItemsCreateInput"] | undefined | null,
	update?: ValueTypes["ProductGridCategoryWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductGridItemUpsertCategoryRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductGridCategoryUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductGridCategoryWithoutItemsUpdateInput"]: {
	order?: number | undefined | null,
	title?: string | undefined | null,
	root?: ValueTypes["ProductGridCategoryUpdateRootEntityRelationInput"] | undefined | null,
	images?: ValueTypes["ProductGridCategoryUpdateImagesEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductGridCategoryUpdateRootEntityRelationInput"]: {
	create?: ValueTypes["ProductGridWithoutCategoriesCreateInput"] | undefined | null,
	update?: ValueTypes["ProductGridWithoutCategoriesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductGridCategoryUpsertRootRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductGridUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductGridWithoutCategoriesUpdateInput"]: {
	isCarousel?: boolean | undefined | null,
	type?: ValueTypes["ProductGridType"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductGridCategoryUpsertRootRelationInput"]: {
	update?: ValueTypes["ProductGridWithoutCategoriesUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductGridWithoutCategoriesCreateInput"] | undefined | null
};
	["ProductGridItemUpsertCategoryRelationInput"]: {
	update?: ValueTypes["ProductGridCategoryWithoutItemsUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductGridCategoryWithoutItemsCreateInput"] | undefined | null
};
	["GalleryConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["GalleryEdge"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryEdge"]: AliasType<{
	node?:ValueTypes["Gallery"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	caption?: string | undefined | null,
	list?: ValueTypes["GalleryItemCreateListEntityRelationInput"] | undefined | null,
	medium?: ValueTypes["GalleryItemCreateMediumEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GalleryItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["GalleryUniqueWhere"] | undefined | null,
	create?: ValueTypes["GalleryWithoutItemsCreateInput"] | undefined | null
};
	["GalleryWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GalleryItemUpdateInput"]: {
	order?: number | undefined | null,
	caption?: string | undefined | null,
	list?: ValueTypes["GalleryItemUpdateListEntityRelationInput"] | undefined | null,
	medium?: ValueTypes["GalleryItemUpdateMediumEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GalleryItemUpdateListEntityRelationInput"]: {
	create?: ValueTypes["GalleryWithoutItemsCreateInput"] | undefined | null,
	update?: ValueTypes["GalleryWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["GalleryItemUpsertListRelationInput"] | undefined | null,
	connect?: ValueTypes["GalleryUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["GalleryWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null
};
	["GalleryItemUpsertListRelationInput"]: {
	update?: ValueTypes["GalleryWithoutItemsUpdateInput"] | undefined | null,
	create?: ValueTypes["GalleryWithoutItemsCreateInput"] | undefined | null
};
	["HeroConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["HeroEdge"],
		__typename?: boolean | `@${string}`
}>;
	["HeroEdge"]: AliasType<{
	node?:ValueTypes["Hero"],
		__typename?: boolean | `@${string}`
}>;
	["SiteMenuConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SiteMenuEdge"],
		__typename?: boolean | `@${string}`
}>;
	["SiteMenuEdge"]: AliasType<{
	node?:ValueTypes["SiteMenu"],
		__typename?: boolean | `@${string}`
}>;
	["SiteMenuCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	unique?: ValueTypes["One"] | undefined | null,
	locales?: Array<ValueTypes["SiteMenuCreateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SiteMenuCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["MenuLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["MenuLocaleWithoutRootCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["MenuLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	locale?: ValueTypes["MenuLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	items?: Array<ValueTypes["MenuLocaleCreateItemsEntityRelationInput"]> | undefined | null,
	secondaryItems?: ValueTypes["MenuLocaleCreateSecondaryItemsEntityRelationInput"] | undefined | null,
	eshopLink?: ValueTypes["MenuLocaleCreateEshopLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MenuLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["LocaleWithoutMenusCreateInput"] | undefined | null
};
	["LocaleWithoutMenusCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	businessCategories?: Array<ValueTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined | null,
	pages?: Array<ValueTypes["LocaleCreatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleCreateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SiteMenuUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null,
	locales?: Array<ValueTypes["SiteMenuUpdateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SiteMenuUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["MenuLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ValueTypes["SiteMenuUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ValueTypes["SiteMenuUpsertLocalesRelationInput"] | undefined | null,
	connect?: ValueTypes["MenuLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["MenuLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["MenuLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["SiteMenuUpdateLocalesRelationInput"]: {
	by?: ValueTypes["MenuLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["MenuLocaleWithoutRootUpdateInput"] | undefined | null
};
	["MenuLocaleWithoutRootUpdateInput"]: {
	locale?: ValueTypes["MenuLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	items?: Array<ValueTypes["MenuLocaleUpdateItemsEntityRelationInput"]> | undefined | null,
	secondaryItems?: ValueTypes["MenuLocaleUpdateSecondaryItemsEntityRelationInput"] | undefined | null,
	eshopLink?: ValueTypes["MenuLocaleUpdateEshopLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MenuLocaleUpdateLocaleEntityRelationInput"]: {
	create?: ValueTypes["LocaleWithoutMenusCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleWithoutMenusUpdateInput"] | undefined | null,
	upsert?: ValueTypes["MenuLocaleUpsertLocaleRelationInput"] | undefined | null,
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutMenusUpdateInput"]: {
	businessCategories?: Array<ValueTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined | null,
	pages?: Array<ValueTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined | null,
	subscriptionBoxes?: Array<ValueTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MenuLocaleUpsertLocaleRelationInput"]: {
	update?: ValueTypes["LocaleWithoutMenusUpdateInput"] | undefined | null,
	create?: ValueTypes["LocaleWithoutMenusCreateInput"] | undefined | null
};
	["SiteMenuUpsertLocalesRelationInput"]: {
	by?: ValueTypes["MenuLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["MenuLocaleWithoutRootUpdateInput"] | undefined | null,
	create?: ValueTypes["MenuLocaleWithoutRootCreateInput"] | undefined | null
};
	["MenuLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	root?: ValueTypes["MenuLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["MenuLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	items?: Array<ValueTypes["MenuLocaleCreateItemsEntityRelationInput"]> | undefined | null,
	secondaryItems?: ValueTypes["MenuLocaleCreateSecondaryItemsEntityRelationInput"] | undefined | null,
	eshopLink?: ValueTypes["MenuLocaleCreateEshopLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MenuLocaleUpdateInput"]: {
	root?: ValueTypes["MenuLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["MenuLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	items?: Array<ValueTypes["MenuLocaleUpdateItemsEntityRelationInput"]> | undefined | null,
	secondaryItems?: ValueTypes["MenuLocaleUpdateSecondaryItemsEntityRelationInput"] | undefined | null,
	eshopLink?: ValueTypes["MenuLocaleUpdateEshopLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MenuItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	menu?: ValueTypes["MenuItemCreateMenuEntityRelationInput"] | undefined | null,
	link?: ValueTypes["MenuItemCreateLinkEntityRelationInput"] | undefined | null,
	subitems?: Array<ValueTypes["MenuItemCreateSubitemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MenuItemCreateMenuEntityRelationInput"]: {
	connect?: ValueTypes["MenuLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["MenuLocaleWithoutItemsCreateInput"] | undefined | null
};
	["MenuLocaleWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	root?: ValueTypes["MenuLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["MenuLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	secondaryItems?: ValueTypes["MenuLocaleCreateSecondaryItemsEntityRelationInput"] | undefined | null,
	eshopLink?: ValueTypes["MenuLocaleCreateEshopLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MenuItemUpdateInput"]: {
	order?: number | undefined | null,
	menu?: ValueTypes["MenuItemUpdateMenuEntityRelationInput"] | undefined | null,
	link?: ValueTypes["MenuItemUpdateLinkEntityRelationInput"] | undefined | null,
	subitems?: Array<ValueTypes["MenuItemUpdateSubitemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MenuItemUpdateMenuEntityRelationInput"]: {
	create?: ValueTypes["MenuLocaleWithoutItemsCreateInput"] | undefined | null,
	update?: ValueTypes["MenuLocaleWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["MenuItemUpsertMenuRelationInput"] | undefined | null,
	connect?: ValueTypes["MenuLocaleUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["MenuLocaleWithoutItemsUpdateInput"]: {
	root?: ValueTypes["MenuLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["MenuLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	secondaryItems?: ValueTypes["MenuLocaleUpdateSecondaryItemsEntityRelationInput"] | undefined | null,
	eshopLink?: ValueTypes["MenuLocaleUpdateEshopLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MenuItemUpsertMenuRelationInput"]: {
	update?: ValueTypes["MenuLocaleWithoutItemsUpdateInput"] | undefined | null,
	create?: ValueTypes["MenuLocaleWithoutItemsCreateInput"] | undefined | null
};
	["PageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PageEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PageEdge"]: AliasType<{
	node?:ValueTypes["Page"],
		__typename?: boolean | `@${string}`
}>;
	["PageLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	link?: ValueTypes["PageLocaleCreateLinkEntityRelationInput"] | undefined | null,
	root?: ValueTypes["PageLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["PageLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	seo?: ValueTypes["PageLocaleCreateSeoEntityRelationInput"] | undefined | null,
	content?: ValueTypes["PageLocaleCreateContentEntityRelationInput"] | undefined | null,
	cover?: ValueTypes["PageLocaleCreateCoverEntityRelationInput"] | undefined | null,
	theme?: ValueTypes["PageTheme"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PageLocaleUpdateInput"]: {
	title?: string | undefined | null,
	link?: ValueTypes["PageLocaleUpdateLinkEntityRelationInput"] | undefined | null,
	root?: ValueTypes["PageLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["PageLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	seo?: ValueTypes["PageLocaleUpdateSeoEntityRelationInput"] | undefined | null,
	content?: ValueTypes["PageLocaleUpdateContentEntityRelationInput"] | undefined | null,
	cover?: ValueTypes["PageLocaleUpdateCoverEntityRelationInput"] | undefined | null,
	theme?: ValueTypes["PageTheme"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["WikiPageCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	title?: string | undefined | null,
	emoji?: string | undefined | null,
	link?: ValueTypes["WikiPageCreateLinkEntityRelationInput"] | undefined | null,
	parent?: ValueTypes["WikiPageCreateParentEntityRelationInput"] | undefined | null,
	children?: Array<ValueTypes["WikiPageCreateChildrenEntityRelationInput"]> | undefined | null,
	content?: ValueTypes["WikiPageCreateContentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["WikiPageUpdateInput"]: {
	order?: number | undefined | null,
	title?: string | undefined | null,
	emoji?: string | undefined | null,
	link?: ValueTypes["WikiPageUpdateLinkEntityRelationInput"] | undefined | null,
	parent?: ValueTypes["WikiPageUpdateParentEntityRelationInput"] | undefined | null,
	children?: Array<ValueTypes["WikiPageUpdateChildrenEntityRelationInput"]> | undefined | null,
	content?: ValueTypes["WikiPageUpdateContentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MenuSubitemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	type?: ValueTypes["MenuSubitemType"] | undefined | null,
	title?: string | undefined | null,
	item?: ValueTypes["MenuSubitemCreateItemEntityRelationInput"] | undefined | null,
	links?: ValueTypes["MenuSubitemCreateLinksEntityRelationInput"] | undefined | null,
	products?: ValueTypes["MenuSubitemCreateProductsEntityRelationInput"] | undefined | null,
	delivery?: ValueTypes["MenuSubitemCreateDeliveryEntityRelationInput"] | undefined | null,
	contact?: ValueTypes["MenuSubitemCreateContactEntityRelationInput"] | undefined | null,
	order?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MenuSubitemCreateItemEntityRelationInput"]: {
	connect?: ValueTypes["MenuItemUniqueWhere"] | undefined | null,
	create?: ValueTypes["MenuItemWithoutSubitemsCreateInput"] | undefined | null
};
	["MenuItemWithoutSubitemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	menu?: ValueTypes["MenuItemCreateMenuEntityRelationInput"] | undefined | null,
	link?: ValueTypes["MenuItemCreateLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MenuSubitemUpdateInput"]: {
	type?: ValueTypes["MenuSubitemType"] | undefined | null,
	title?: string | undefined | null,
	item?: ValueTypes["MenuSubitemUpdateItemEntityRelationInput"] | undefined | null,
	links?: ValueTypes["MenuSubitemUpdateLinksEntityRelationInput"] | undefined | null,
	products?: ValueTypes["MenuSubitemUpdateProductsEntityRelationInput"] | undefined | null,
	delivery?: ValueTypes["MenuSubitemUpdateDeliveryEntityRelationInput"] | undefined | null,
	contact?: ValueTypes["MenuSubitemUpdateContactEntityRelationInput"] | undefined | null,
	order?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MenuSubitemUpdateItemEntityRelationInput"]: {
	create?: ValueTypes["MenuItemWithoutSubitemsCreateInput"] | undefined | null,
	update?: ValueTypes["MenuItemWithoutSubitemsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["MenuSubitemUpsertItemRelationInput"] | undefined | null,
	connect?: ValueTypes["MenuItemUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["MenuItemWithoutSubitemsUpdateInput"]: {
	order?: number | undefined | null,
	menu?: ValueTypes["MenuItemUpdateMenuEntityRelationInput"] | undefined | null,
	link?: ValueTypes["MenuItemUpdateLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MenuSubitemUpsertItemRelationInput"]: {
	update?: ValueTypes["MenuItemWithoutSubitemsUpdateInput"] | undefined | null,
	create?: ValueTypes["MenuItemWithoutSubitemsCreateInput"] | undefined | null
};
	["MenuLinkListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["MenuLinkListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["MenuLinkListEdge"]: AliasType<{
	node?:ValueTypes["MenuLinkList"],
		__typename?: boolean | `@${string}`
}>;
	["MenuLinkItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	list?: ValueTypes["MenuLinkItemCreateListEntityRelationInput"] | undefined | null,
	link?: ValueTypes["MenuLinkItemCreateLinkEntityRelationInput"] | undefined | null,
	image?: ValueTypes["MenuLinkItemCreateImageEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MenuLinkItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["MenuLinkListUniqueWhere"] | undefined | null,
	create?: ValueTypes["MenuLinkListWithoutItemsCreateInput"] | undefined | null
};
	["MenuLinkListWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MenuLinkItemUpdateInput"]: {
	order?: number | undefined | null,
	list?: ValueTypes["MenuLinkItemUpdateListEntityRelationInput"] | undefined | null,
	link?: ValueTypes["MenuLinkItemUpdateLinkEntityRelationInput"] | undefined | null,
	image?: ValueTypes["MenuLinkItemUpdateImageEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["MenuLinkItemUpdateListEntityRelationInput"]: {
	create?: ValueTypes["MenuLinkListWithoutItemsCreateInput"] | undefined | null,
	update?: ValueTypes["MenuLinkListWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["MenuLinkItemUpsertListRelationInput"] | undefined | null,
	connect?: ValueTypes["MenuLinkListUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["MenuLinkListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null
};
	["MenuLinkItemUpsertListRelationInput"]: {
	update?: ValueTypes["MenuLinkListWithoutItemsUpdateInput"] | undefined | null,
	create?: ValueTypes["MenuLinkListWithoutItemsCreateInput"] | undefined | null
};
	["MenuProductsConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["MenuProductsEdge"],
		__typename?: boolean | `@${string}`
}>;
	["MenuProductsEdge"]: AliasType<{
	node?:ValueTypes["MenuProducts"],
		__typename?: boolean | `@${string}`
}>;
	["MenuDeliveryConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["MenuDeliveryEdge"],
		__typename?: boolean | `@${string}`
}>;
	["MenuDeliveryEdge"]: AliasType<{
	node?:ValueTypes["MenuDelivery"],
		__typename?: boolean | `@${string}`
}>;
	["MenuContactConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["MenuContactEdge"],
		__typename?: boolean | `@${string}`
}>;
	["MenuContactEdge"]: AliasType<{
	node?:ValueTypes["MenuContact"],
		__typename?: boolean | `@${string}`
}>;
	["DeadlineTemplateConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["DeadlineTemplateEdge"],
		__typename?: boolean | `@${string}`
}>;
	["DeadlineTemplateEdge"]: AliasType<{
	node?:ValueTypes["DeadlineTemplate"],
		__typename?: boolean | `@${string}`
}>;
	["DeadlineTemplateCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	startDate?: ValueTypes["Date"] | undefined | null,
	period?: number | undefined | null,
	cutoff?: number | undefined | null,
	closed?: boolean | undefined | null,
	venue?: ValueTypes["DeadlineTemplateCreateVenueEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeadlineTemplateCreateVenueEntityRelationInput"]: {
	connect?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	create?: ValueTypes["VenueWithoutDeadlineTemplateCreateInput"] | undefined | null
};
	["VenueWithoutDeadlineTemplateCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	timetableDays?: Array<ValueTypes["VenueCreateTimetableDaysEntityRelationInput"]> | undefined | null,
	timetableTemplates?: Array<ValueTypes["VenueCreateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	staffMembers?: Array<ValueTypes["VenueCreateStaffMembersEntityRelationInput"]> | undefined | null,
	employeeRoles?: Array<ValueTypes["VenueCreateEmployeeRolesEntityRelationInput"]> | undefined | null,
	pointOfSaleApplicationDevices?: Array<ValueTypes["VenueCreatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined | null,
	pointOfSaleTerminals?: Array<ValueTypes["VenueCreatePointOfSaleTerminalsEntityRelationInput"]> | undefined | null,
	pointOfSalePrinters?: Array<ValueTypes["VenueCreatePointOfSalePrintersEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["VenueCreateOrdersEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["VenueCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	areas?: Array<ValueTypes["VenueCreateAreasEntityRelationInput"]> | undefined | null,
	enabledUnassignReasons?: Array<ValueTypes["VenueCreateEnabledUnassignReasonsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["VenueCreateCategoriesEntityRelationInput"]> | undefined | null,
	channels?: Array<ValueTypes["VenueCreateChannelsEntityRelationInput"]> | undefined | null,
	address?: string | undefined | null,
	pointOfSalePngBase64ReceiptLogo?: string | undefined | null,
	pointOfSaleInitialView?: ValueTypes["PointOfSaleInitialView"] | undefined | null,
	pointOfSalePreferPrintReceipt?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeadlineTemplateUpdateInput"]: {
	startDate?: ValueTypes["Date"] | undefined | null,
	period?: number | undefined | null,
	cutoff?: number | undefined | null,
	closed?: boolean | undefined | null,
	venue?: ValueTypes["DeadlineTemplateUpdateVenueEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeadlineTemplateUpdateVenueEntityRelationInput"]: {
	create?: ValueTypes["VenueWithoutDeadlineTemplateCreateInput"] | undefined | null,
	update?: ValueTypes["VenueWithoutDeadlineTemplateUpdateInput"] | undefined | null,
	upsert?: ValueTypes["DeadlineTemplateUpsertVenueRelationInput"] | undefined | null,
	connect?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["VenueWithoutDeadlineTemplateUpdateInput"]: {
	name?: string | undefined | null,
	timetableDays?: Array<ValueTypes["VenueUpdateTimetableDaysEntityRelationInput"]> | undefined | null,
	timetableTemplates?: Array<ValueTypes["VenueUpdateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	staffMembers?: Array<ValueTypes["VenueUpdateStaffMembersEntityRelationInput"]> | undefined | null,
	employeeRoles?: Array<ValueTypes["VenueUpdateEmployeeRolesEntityRelationInput"]> | undefined | null,
	pointOfSaleApplicationDevices?: Array<ValueTypes["VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined | null,
	pointOfSaleTerminals?: Array<ValueTypes["VenueUpdatePointOfSaleTerminalsEntityRelationInput"]> | undefined | null,
	pointOfSalePrinters?: Array<ValueTypes["VenueUpdatePointOfSalePrintersEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["VenueUpdateOrdersEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["VenueUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	areas?: Array<ValueTypes["VenueUpdateAreasEntityRelationInput"]> | undefined | null,
	enabledUnassignReasons?: Array<ValueTypes["VenueUpdateEnabledUnassignReasonsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["VenueUpdateCategoriesEntityRelationInput"]> | undefined | null,
	channels?: Array<ValueTypes["VenueUpdateChannelsEntityRelationInput"]> | undefined | null,
	address?: string | undefined | null,
	pointOfSalePngBase64ReceiptLogo?: string | undefined | null,
	pointOfSaleInitialView?: ValueTypes["PointOfSaleInitialView"] | undefined | null,
	pointOfSalePreferPrintReceipt?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeadlineTemplateUpsertVenueRelationInput"]: {
	update?: ValueTypes["VenueWithoutDeadlineTemplateUpdateInput"] | undefined | null,
	create?: ValueTypes["VenueWithoutDeadlineTemplateCreateInput"] | undefined | null
};
	["EmployeeQueueConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["EmployeeQueueEdge"],
		__typename?: boolean | `@${string}`
}>;
	["EmployeeQueueEdge"]: AliasType<{
	node?:ValueTypes["EmployeeQueue"],
		__typename?: boolean | `@${string}`
}>;
	["EmployeeQueueCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	shiftGroup?: ValueTypes["EmployeeQueueCreateShiftGroupEntityRelationInput"] | undefined | null,
	items?: Array<ValueTypes["EmployeeQueueCreateItemsEntityRelationInput"]> | undefined | null,
	contemberBugFix?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["EmployeeQueueUpdateInput"]: {
	shiftGroup?: ValueTypes["EmployeeQueueUpdateShiftGroupEntityRelationInput"] | undefined | null,
	items?: Array<ValueTypes["EmployeeQueueUpdateItemsEntityRelationInput"]> | undefined | null,
	contemberBugFix?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableDayCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	date?: ValueTypes["Date"] | undefined | null,
	type?: ValueTypes["TimetableDayType"] | undefined | null,
	shiftGroups?: Array<ValueTypes["TimetableDayCreateShiftGroupsEntityRelationInput"]> | undefined | null,
	tipsCents?: number | undefined | null,
	notes?: Array<ValueTypes["TimetableDayCreateNotesEntityRelationInput"]> | undefined | null,
	venue?: ValueTypes["TimetableDayCreateVenueEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["TimetableDayCreateMetaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableDayUpdateInput"]: {
	date?: ValueTypes["Date"] | undefined | null,
	type?: ValueTypes["TimetableDayType"] | undefined | null,
	shiftGroups?: Array<ValueTypes["TimetableDayUpdateShiftGroupsEntityRelationInput"]> | undefined | null,
	tipsCents?: number | undefined | null,
	notes?: Array<ValueTypes["TimetableDayUpdateNotesEntityRelationInput"]> | undefined | null,
	venue?: ValueTypes["TimetableDayUpdateVenueEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["TimetableDayUpdateMetaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableShiftCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	locked?: boolean | undefined | null,
	order?: number | undefined | null,
	assigned?: ValueTypes["Date"] | undefined | null,
	group?: ValueTypes["TimetableShiftCreateGroupEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["TimetableShiftCreateShiftsProfileEntityRelationInput"] | undefined | null,
	queueItem?: ValueTypes["TimetableShiftCreateQueueItemEntityRelationInput"] | undefined | null,
	swapInfo?: ValueTypes["TimetableShiftCreateSwapInfoEntityRelationInput"] | undefined | null,
	isOvertime?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableShiftUpdateInput"]: {
	locked?: boolean | undefined | null,
	order?: number | undefined | null,
	assigned?: ValueTypes["Date"] | undefined | null,
	group?: ValueTypes["TimetableShiftUpdateGroupEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["TimetableShiftUpdateShiftsProfileEntityRelationInput"] | undefined | null,
	queueItem?: ValueTypes["TimetableShiftUpdateQueueItemEntityRelationInput"] | undefined | null,
	swapInfo?: ValueTypes["TimetableShiftUpdateSwapInfoEntityRelationInput"] | undefined | null,
	isOvertime?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableShiftGroupCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	shifts?: Array<ValueTypes["TimetableShiftGroupCreateShiftsEntityRelationInput"]> | undefined | null,
	day?: ValueTypes["TimetableShiftGroupCreateDayEntityRelationInput"] | undefined | null,
	type?: ValueTypes["TimetableShiftGroupCreateTypeEntityRelationInput"] | undefined | null,
	position?: ValueTypes["TimetableShiftGroupCreatePositionEntityRelationInput"] | undefined | null,
	queue?: ValueTypes["TimetableShiftGroupCreateQueueEntityRelationInput"] | undefined | null,
	generatedByTemplate?: ValueTypes["TimetableShiftGroupCreateGeneratedByTemplateEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableShiftGroupUpdateInput"]: {
	order?: number | undefined | null,
	shifts?: Array<ValueTypes["TimetableShiftGroupUpdateShiftsEntityRelationInput"]> | undefined | null,
	day?: ValueTypes["TimetableShiftGroupUpdateDayEntityRelationInput"] | undefined | null,
	type?: ValueTypes["TimetableShiftGroupUpdateTypeEntityRelationInput"] | undefined | null,
	position?: ValueTypes["TimetableShiftGroupUpdatePositionEntityRelationInput"] | undefined | null,
	queue?: ValueTypes["TimetableShiftGroupUpdateQueueEntityRelationInput"] | undefined | null,
	generatedByTemplate?: ValueTypes["TimetableShiftGroupUpdateGeneratedByTemplateEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableShiftPositionConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TimetableShiftPositionEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableShiftPositionEdge"]: AliasType<{
	node?:ValueTypes["TimetableShiftPosition"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableShiftPositionCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	start?: string | undefined | null,
	end?: string | undefined | null,
	shiftGroups?: Array<ValueTypes["TimetableShiftPositionCreateShiftGroupsEntityRelationInput"]> | undefined | null,
	timetableTemplates?: Array<ValueTypes["TimetableShiftPositionCreateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	isDynamic?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableShiftPositionUpdateInput"]: {
	name?: string | undefined | null,
	start?: string | undefined | null,
	end?: string | undefined | null,
	shiftGroups?: Array<ValueTypes["TimetableShiftPositionUpdateShiftGroupsEntityRelationInput"]> | undefined | null,
	timetableTemplates?: Array<ValueTypes["TimetableShiftPositionUpdateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	isDynamic?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CartCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	confirmedAt?: ValueTypes["DateTime"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	items?: Array<ValueTypes["CartCreateItemsEntityRelationInput"]> | undefined | null,
	handle?: string | undefined | null,
	state?: ValueTypes["CartState"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	channel?: ValueTypes["CartCreateChannelEntityRelationInput"] | undefined | null,
	order?: ValueTypes["CartCreateOrderEntityRelationInput"] | undefined | null,
	customer?: ValueTypes["CartCreateCustomerEntityRelationInput"] | undefined | null,
	deliveryAddress?: ValueTypes["CartCreateDeliveryAddressEntityRelationInput"] | undefined | null,
	billingAddress?: ValueTypes["CartCreateBillingAddressEntityRelationInput"] | undefined | null,
	deliveryOption?: string | undefined | null,
	paymentOption?: string | undefined | null,
	delivery?: ValueTypes["CartCreateDeliveryEntityRelationInput"] | undefined | null,
	payment?: ValueTypes["CartCreatePaymentEntityRelationInput"] | undefined | null,
	billingSubject?: ValueTypes["CartCreateBillingSubjectEntityRelationInput"] | undefined | null,
	priceLines?: Array<ValueTypes["CartCreatePriceLinesEntityRelationInput"]> | undefined | null,
	summary?: ValueTypes["CartCreateSummaryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CartUpdateInput"]: {
	confirmedAt?: ValueTypes["DateTime"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	items?: Array<ValueTypes["CartUpdateItemsEntityRelationInput"]> | undefined | null,
	handle?: string | undefined | null,
	state?: ValueTypes["CartState"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	channel?: ValueTypes["CartUpdateChannelEntityRelationInput"] | undefined | null,
	order?: ValueTypes["CartUpdateOrderEntityRelationInput"] | undefined | null,
	customer?: ValueTypes["CartUpdateCustomerEntityRelationInput"] | undefined | null,
	deliveryAddress?: ValueTypes["CartUpdateDeliveryAddressEntityRelationInput"] | undefined | null,
	billingAddress?: ValueTypes["CartUpdateBillingAddressEntityRelationInput"] | undefined | null,
	deliveryOption?: string | undefined | null,
	paymentOption?: string | undefined | null,
	delivery?: ValueTypes["CartUpdateDeliveryEntityRelationInput"] | undefined | null,
	payment?: ValueTypes["CartUpdatePaymentEntityRelationInput"] | undefined | null,
	billingSubject?: ValueTypes["CartUpdateBillingSubjectEntityRelationInput"] | undefined | null,
	priceLines?: Array<ValueTypes["CartUpdatePriceLinesEntityRelationInput"]> | undefined | null,
	summary?: ValueTypes["CartUpdateSummaryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CartItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	quantity?: number | undefined | null,
	cart?: ValueTypes["CartItemCreateCartEntityRelationInput"] | undefined | null,
	product?: ValueTypes["CartItemCreateProductEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	updatedAt?: ValueTypes["DateTime"] | undefined | null,
	fulfillmentNote?: string | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["CartItemCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CartItemUpdateInput"]: {
	quantity?: number | undefined | null,
	cart?: ValueTypes["CartItemUpdateCartEntityRelationInput"] | undefined | null,
	product?: ValueTypes["CartItemUpdateProductEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	updatedAt?: ValueTypes["DateTime"] | undefined | null,
	fulfillmentNote?: string | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["CartItemUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["EmployeeQueueItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	start?: string | undefined | null,
	end?: string | undefined | null,
	queue?: ValueTypes["EmployeeQueueItemCreateQueueEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["EmployeeQueueItemCreateShiftsProfileEntityRelationInput"] | undefined | null,
	shift?: ValueTypes["EmployeeQueueItemCreateShiftEntityRelationInput"] | undefined | null,
	unassignInfo?: ValueTypes["EmployeeQueueItemCreateUnassignInfoEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["EmployeeQueueItemCreateMetaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["EmployeeQueueItemUpdateInput"]: {
	start?: string | undefined | null,
	end?: string | undefined | null,
	queue?: ValueTypes["EmployeeQueueItemUpdateQueueEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["EmployeeQueueItemUpdateShiftsProfileEntityRelationInput"] | undefined | null,
	shift?: ValueTypes["EmployeeQueueItemUpdateShiftEntityRelationInput"] | undefined | null,
	unassignInfo?: ValueTypes["EmployeeQueueItemUpdateUnassignInfoEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["EmployeeQueueItemUpdateMetaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ApplicationConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ApplicationEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ApplicationEdge"]: AliasType<{
	node?:ValueTypes["Application"],
		__typename?: boolean | `@${string}`
}>;
	["ApplicationShortcutListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ApplicationShortcutListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ApplicationShortcutListEdge"]: AliasType<{
	node?:ValueTypes["ApplicationShortcutList"],
		__typename?: boolean | `@${string}`
}>;
	["ApplicationShortcutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: Array<ValueTypes["ApplicationShortcutListCreateItemsEntityRelationInput"]> | undefined | null,
	customer?: ValueTypes["ApplicationShortcutListCreateCustomerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ApplicationShortcutListCreateCustomerEntityRelationInput"]: {
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerWithoutShortcutListCreateInput"] | undefined | null
};
	["CustomerWithoutShortcutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	addresses?: Array<ValueTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerCreateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerCreateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerCreatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerCreateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerCreateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerCreateCartsEntityRelationInput"]> | undefined | null,
	user?: ValueTypes["CustomerCreateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerCreateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerCreateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerCreateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ApplicationShortcutListUpdateInput"]: {
	items?: Array<ValueTypes["ApplicationShortcutListUpdateItemsEntityRelationInput"]> | undefined | null,
	customer?: ValueTypes["ApplicationShortcutListUpdateCustomerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ApplicationShortcutListUpdateCustomerEntityRelationInput"]: {
	create?: ValueTypes["CustomerWithoutShortcutListCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerWithoutShortcutListUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ApplicationShortcutListUpsertCustomerRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CustomerWithoutShortcutListUpdateInput"]: {
	addresses?: Array<ValueTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerUpdateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerUpdateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined | null,
	user?: ValueTypes["CustomerUpdateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined | null,
	invoicingPlan?: ValueTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerUpdateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ApplicationShortcutListUpsertCustomerRelationInput"]: {
	update?: ValueTypes["CustomerWithoutShortcutListUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerWithoutShortcutListCreateInput"] | undefined | null
};
	["ApplicationShortcutListItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	application?: ValueTypes["ApplicationShortcutListItemCreateApplicationEntityRelationInput"] | undefined | null,
	list?: ValueTypes["ApplicationShortcutListItemCreateListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ApplicationShortcutListItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["ApplicationShortcutListUniqueWhere"] | undefined | null,
	create?: ValueTypes["ApplicationShortcutListWithoutItemsCreateInput"] | undefined | null
};
	["ApplicationShortcutListWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	customer?: ValueTypes["ApplicationShortcutListCreateCustomerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ApplicationShortcutListItemUpdateInput"]: {
	order?: number | undefined | null,
	application?: ValueTypes["ApplicationShortcutListItemUpdateApplicationEntityRelationInput"] | undefined | null,
	list?: ValueTypes["ApplicationShortcutListItemUpdateListEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ApplicationShortcutListItemUpdateListEntityRelationInput"]: {
	create?: ValueTypes["ApplicationShortcutListWithoutItemsCreateInput"] | undefined | null,
	update?: ValueTypes["ApplicationShortcutListWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ApplicationShortcutListItemUpsertListRelationInput"] | undefined | null,
	connect?: ValueTypes["ApplicationShortcutListUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ApplicationShortcutListWithoutItemsUpdateInput"]: {
	customer?: ValueTypes["ApplicationShortcutListUpdateCustomerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ApplicationShortcutListItemUpsertListRelationInput"]: {
	update?: ValueTypes["ApplicationShortcutListWithoutItemsUpdateInput"] | undefined | null,
	create?: ValueTypes["ApplicationShortcutListWithoutItemsCreateInput"] | undefined | null
};
	["ProductBannerConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductBannerEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProductBannerEdge"]: AliasType<{
	node?:ValueTypes["ProductBanner"],
		__typename?: boolean | `@${string}`
}>;
	["ProductBannerItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	list?: ValueTypes["ProductBannerItemCreateListEntityRelationInput"] | undefined | null,
	banner?: ValueTypes["ProductBannerItemCreateBannerEntityRelationInput"] | undefined | null,
	size?: ValueTypes["ProductBannerItemSize"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductBannerItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["ProductBannerListUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductBannerListWithoutItemsCreateInput"] | undefined | null
};
	["ProductBannerListWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductBannerItemUpdateInput"]: {
	order?: number | undefined | null,
	list?: ValueTypes["ProductBannerItemUpdateListEntityRelationInput"] | undefined | null,
	banner?: ValueTypes["ProductBannerItemUpdateBannerEntityRelationInput"] | undefined | null,
	size?: ValueTypes["ProductBannerItemSize"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductBannerItemUpdateListEntityRelationInput"]: {
	create?: ValueTypes["ProductBannerListWithoutItemsCreateInput"] | undefined | null,
	update?: ValueTypes["ProductBannerListWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ProductBannerItemUpsertListRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductBannerListUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ProductBannerListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null
};
	["ProductBannerItemUpsertListRelationInput"]: {
	update?: ValueTypes["ProductBannerListWithoutItemsUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductBannerListWithoutItemsCreateInput"] | undefined | null
};
	["ProductBannerListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductBannerListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProductBannerListEdge"]: AliasType<{
	node?:ValueTypes["ProductBannerList"],
		__typename?: boolean | `@${string}`
}>;
	["BartenderConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BartenderEdge"],
		__typename?: boolean | `@${string}`
}>;
	["BartenderEdge"]: AliasType<{
	node?:ValueTypes["Bartender"],
		__typename?: boolean | `@${string}`
}>;
	["BartenderCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	staff?: ValueTypes["BartenderCreateStaffEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BartenderCreateStaffEntityRelationInput"]: {
	connect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	create?: ValueTypes["StaffWithoutBartenderCreateInput"] | undefined | null
};
	["StaffWithoutBartenderCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	courier?: ValueTypes["StaffCreateCourierEntityRelationInput"] | undefined | null,
	cleaner?: ValueTypes["StaffCreateCleanerEntityRelationInput"] | undefined | null,
	shiftsManager?: ValueTypes["StaffCreateShiftsManagerEntityRelationInput"] | undefined | null,
	businessToBusinessManager?: ValueTypes["StaffCreateBusinessToBusinessManagerEntityRelationInput"] | undefined | null,
	user?: ValueTypes["StaffCreateUserEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["StaffCreateShiftsProfileEntityRelationInput"] | undefined | null,
	stocksManager?: ValueTypes["StaffCreateStocksManagerEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["StaffCreatePhotoEntityRelationInput"] | undefined | null,
	courierManager?: ValueTypes["StaffCreateCourierManagerEntityRelationInput"] | undefined | null,
	picker?: ValueTypes["StaffCreatePickerEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	remunerationProfile?: ValueTypes["StaffCreateRemunerationProfileEntityRelationInput"] | undefined | null,
	cashier?: ValueTypes["StaffCreateCashierEntityRelationInput"] | undefined | null,
	venues?: Array<ValueTypes["StaffCreateVenuesEntityRelationInput"]> | undefined | null,
	internalBuyer?: ValueTypes["StaffCreateInternalBuyerEntityRelationInput"] | undefined | null,
	salesManager?: ValueTypes["StaffCreateSalesManagerEntityRelationInput"] | undefined | null,
	cashierManager?: ValueTypes["StaffCreateCashierManagerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BartenderUpdateInput"]: {
	staff?: ValueTypes["BartenderUpdateStaffEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BartenderUpdateStaffEntityRelationInput"]: {
	create?: ValueTypes["StaffWithoutBartenderCreateInput"] | undefined | null,
	update?: ValueTypes["StaffWithoutBartenderUpdateInput"] | undefined | null,
	upsert?: ValueTypes["BartenderUpsertStaffRelationInput"] | undefined | null,
	connect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["StaffWithoutBartenderUpdateInput"]: {
	courier?: ValueTypes["StaffUpdateCourierEntityRelationInput"] | undefined | null,
	cleaner?: ValueTypes["StaffUpdateCleanerEntityRelationInput"] | undefined | null,
	shiftsManager?: ValueTypes["StaffUpdateShiftsManagerEntityRelationInput"] | undefined | null,
	businessToBusinessManager?: ValueTypes["StaffUpdateBusinessToBusinessManagerEntityRelationInput"] | undefined | null,
	user?: ValueTypes["StaffUpdateUserEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["StaffUpdateShiftsProfileEntityRelationInput"] | undefined | null,
	stocksManager?: ValueTypes["StaffUpdateStocksManagerEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["StaffUpdatePhotoEntityRelationInput"] | undefined | null,
	courierManager?: ValueTypes["StaffUpdateCourierManagerEntityRelationInput"] | undefined | null,
	picker?: ValueTypes["StaffUpdatePickerEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	remunerationProfile?: ValueTypes["StaffUpdateRemunerationProfileEntityRelationInput"] | undefined | null,
	cashier?: ValueTypes["StaffUpdateCashierEntityRelationInput"] | undefined | null,
	venues?: Array<ValueTypes["StaffUpdateVenuesEntityRelationInput"]> | undefined | null,
	internalBuyer?: ValueTypes["StaffUpdateInternalBuyerEntityRelationInput"] | undefined | null,
	salesManager?: ValueTypes["StaffUpdateSalesManagerEntityRelationInput"] | undefined | null,
	cashierManager?: ValueTypes["StaffUpdateCashierManagerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BartenderUpsertStaffRelationInput"]: {
	update?: ValueTypes["StaffWithoutBartenderUpdateInput"] | undefined | null,
	create?: ValueTypes["StaffWithoutBartenderCreateInput"] | undefined | null
};
	["BusinessToBusinessManagerConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BusinessToBusinessManagerEdge"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessToBusinessManagerEdge"]: AliasType<{
	node?:ValueTypes["BusinessToBusinessManager"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessToBusinessManagerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	staff?: ValueTypes["BusinessToBusinessManagerCreateStaffEntityRelationInput"] | undefined | null,
	managedBusinesses?: Array<ValueTypes["BusinessToBusinessManagerCreateManagedBusinessesEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessToBusinessManagerUpdateInput"]: {
	staff?: ValueTypes["BusinessToBusinessManagerUpdateStaffEntityRelationInput"] | undefined | null,
	managedBusinesses?: Array<ValueTypes["BusinessToBusinessManagerUpdateManagedBusinessesEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CleanerConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CleanerEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CleanerEdge"]: AliasType<{
	node?:ValueTypes["Cleaner"],
		__typename?: boolean | `@${string}`
}>;
	["CleanerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	staff?: ValueTypes["CleanerCreateStaffEntityRelationInput"] | undefined | null,
	canReachTopShelf?: boolean | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CleanerCreateStaffEntityRelationInput"]: {
	connect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	create?: ValueTypes["StaffWithoutCleanerCreateInput"] | undefined | null
};
	["StaffWithoutCleanerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	bartender?: ValueTypes["StaffCreateBartenderEntityRelationInput"] | undefined | null,
	courier?: ValueTypes["StaffCreateCourierEntityRelationInput"] | undefined | null,
	shiftsManager?: ValueTypes["StaffCreateShiftsManagerEntityRelationInput"] | undefined | null,
	businessToBusinessManager?: ValueTypes["StaffCreateBusinessToBusinessManagerEntityRelationInput"] | undefined | null,
	user?: ValueTypes["StaffCreateUserEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["StaffCreateShiftsProfileEntityRelationInput"] | undefined | null,
	stocksManager?: ValueTypes["StaffCreateStocksManagerEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["StaffCreatePhotoEntityRelationInput"] | undefined | null,
	courierManager?: ValueTypes["StaffCreateCourierManagerEntityRelationInput"] | undefined | null,
	picker?: ValueTypes["StaffCreatePickerEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	remunerationProfile?: ValueTypes["StaffCreateRemunerationProfileEntityRelationInput"] | undefined | null,
	cashier?: ValueTypes["StaffCreateCashierEntityRelationInput"] | undefined | null,
	venues?: Array<ValueTypes["StaffCreateVenuesEntityRelationInput"]> | undefined | null,
	internalBuyer?: ValueTypes["StaffCreateInternalBuyerEntityRelationInput"] | undefined | null,
	salesManager?: ValueTypes["StaffCreateSalesManagerEntityRelationInput"] | undefined | null,
	cashierManager?: ValueTypes["StaffCreateCashierManagerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CleanerUpdateInput"]: {
	staff?: ValueTypes["CleanerUpdateStaffEntityRelationInput"] | undefined | null,
	canReachTopShelf?: boolean | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CleanerUpdateStaffEntityRelationInput"]: {
	create?: ValueTypes["StaffWithoutCleanerCreateInput"] | undefined | null,
	update?: ValueTypes["StaffWithoutCleanerUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CleanerUpsertStaffRelationInput"] | undefined | null,
	connect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["StaffWithoutCleanerUpdateInput"]: {
	bartender?: ValueTypes["StaffUpdateBartenderEntityRelationInput"] | undefined | null,
	courier?: ValueTypes["StaffUpdateCourierEntityRelationInput"] | undefined | null,
	shiftsManager?: ValueTypes["StaffUpdateShiftsManagerEntityRelationInput"] | undefined | null,
	businessToBusinessManager?: ValueTypes["StaffUpdateBusinessToBusinessManagerEntityRelationInput"] | undefined | null,
	user?: ValueTypes["StaffUpdateUserEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["StaffUpdateShiftsProfileEntityRelationInput"] | undefined | null,
	stocksManager?: ValueTypes["StaffUpdateStocksManagerEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["StaffUpdatePhotoEntityRelationInput"] | undefined | null,
	courierManager?: ValueTypes["StaffUpdateCourierManagerEntityRelationInput"] | undefined | null,
	picker?: ValueTypes["StaffUpdatePickerEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	remunerationProfile?: ValueTypes["StaffUpdateRemunerationProfileEntityRelationInput"] | undefined | null,
	cashier?: ValueTypes["StaffUpdateCashierEntityRelationInput"] | undefined | null,
	venues?: Array<ValueTypes["StaffUpdateVenuesEntityRelationInput"]> | undefined | null,
	internalBuyer?: ValueTypes["StaffUpdateInternalBuyerEntityRelationInput"] | undefined | null,
	salesManager?: ValueTypes["StaffUpdateSalesManagerEntityRelationInput"] | undefined | null,
	cashierManager?: ValueTypes["StaffUpdateCashierManagerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CleanerUpsertStaffRelationInput"]: {
	update?: ValueTypes["StaffWithoutCleanerUpdateInput"] | undefined | null,
	create?: ValueTypes["StaffWithoutCleanerCreateInput"] | undefined | null
};
	["CourierCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	staff?: ValueTypes["CourierCreateStaffEntityRelationInput"] | undefined | null,
	routes?: Array<ValueTypes["CourierCreateRoutesEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	deliveryMethods?: Array<ValueTypes["CourierCreateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	showInPicker?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CourierUpdateInput"]: {
	staff?: ValueTypes["CourierUpdateStaffEntityRelationInput"] | undefined | null,
	routes?: Array<ValueTypes["CourierUpdateRoutesEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	deliveryMethods?: Array<ValueTypes["CourierUpdateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	showInPicker?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ShiftsManagerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	staff?: ValueTypes["ShiftsManagerCreateStaffEntityRelationInput"] | undefined | null,
	managedRoles?: Array<ValueTypes["ShiftsManagerCreateManagedRolesEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ShiftsManagerUpdateInput"]: {
	staff?: ValueTypes["ShiftsManagerUpdateStaffEntityRelationInput"] | undefined | null,
	managedRoles?: Array<ValueTypes["ShiftsManagerUpdateManagedRolesEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["UserEdge"],
		__typename?: boolean | `@${string}`
}>;
	["UserEdge"]: AliasType<{
	node?:ValueTypes["User"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientCategoryCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	internalName?: string | undefined | null,
	internalNote?: string | undefined | null,
	ingredients?: Array<ValueTypes["ProductIngredientCategoryCreateIngredientsEntityRelationInput"]> | undefined | null,
	locales?: Array<ValueTypes["ProductIngredientCategoryCreateLocalesEntityRelationInput"]> | undefined | null,
	order?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientCategoryUpdateInput"]: {
	internalName?: string | undefined | null,
	internalNote?: string | undefined | null,
	ingredients?: Array<ValueTypes["ProductIngredientCategoryUpdateIngredientsEntityRelationInput"]> | undefined | null,
	locales?: Array<ValueTypes["ProductIngredientCategoryUpdateLocalesEntityRelationInput"]> | undefined | null,
	order?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientCategoryLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	root?: ValueTypes["ProductIngredientCategoryLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["ProductIngredientCategoryLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductIngredientCategoryLocaleUpdateInput"]: {
	name?: string | undefined | null,
	root?: ValueTypes["ProductIngredientCategoryLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["ProductIngredientCategoryLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StocksManagerConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["StocksManagerEdge"],
		__typename?: boolean | `@${string}`
}>;
	["StocksManagerEdge"]: AliasType<{
	node?:ValueTypes["StocksManager"],
		__typename?: boolean | `@${string}`
}>;
	["StocksManagerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	staff?: ValueTypes["StocksManagerCreateStaffEntityRelationInput"] | undefined | null,
	managedProducts?: Array<ValueTypes["StocksManagerCreateManagedProductsEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StocksManagerUpdateInput"]: {
	staff?: ValueTypes["StocksManagerUpdateStaffEntityRelationInput"] | undefined | null,
	managedProducts?: Array<ValueTypes["StocksManagerUpdateManagedProductsEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryRouteCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	courier?: ValueTypes["DeliveryRouteCreateCourierEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	waypoints?: Array<ValueTypes["DeliveryRouteCreateWaypointsEntityRelationInput"]> | undefined | null,
	dispatchAt?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryRouteUpdateInput"]: {
	courier?: ValueTypes["DeliveryRouteUpdateCourierEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	waypoints?: Array<ValueTypes["DeliveryRouteUpdateWaypointsEntityRelationInput"]> | undefined | null,
	dispatchAt?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryWaypointCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	estimatedArrival?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	route?: ValueTypes["DeliveryWaypointCreateRouteEntityRelationInput"] | undefined | null,
	sortingOrder?: number | undefined | null,
	delivery?: ValueTypes["DeliveryWaypointCreateDeliveryEntityRelationInput"] | undefined | null,
	estimatedDistance?: number | undefined | null,
	estimatedDuration?: number | undefined | null,
	originDeparture?: ValueTypes["DateTime"] | undefined | null,
	originAddress?: string | undefined | null,
	transitMode?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryWaypointUpdateInput"]: {
	estimatedArrival?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	route?: ValueTypes["DeliveryWaypointUpdateRouteEntityRelationInput"] | undefined | null,
	sortingOrder?: number | undefined | null,
	delivery?: ValueTypes["DeliveryWaypointUpdateDeliveryEntityRelationInput"] | undefined | null,
	estimatedDistance?: number | undefined | null,
	estimatedDuration?: number | undefined | null,
	originDeparture?: ValueTypes["DateTime"] | undefined | null,
	originAddress?: string | undefined | null,
	transitMode?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AllergenCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	internalName?: string | undefined | null,
	locales?: Array<ValueTypes["AllergenCreateLocalesEntityRelationInput"]> | undefined | null,
	ingredients?: Array<ValueTypes["AllergenCreateIngredientsEntityRelationInput"]> | undefined | null,
	code?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AllergenUpdateInput"]: {
	internalName?: string | undefined | null,
	locales?: Array<ValueTypes["AllergenUpdateLocalesEntityRelationInput"]> | undefined | null,
	ingredients?: Array<ValueTypes["AllergenUpdateIngredientsEntityRelationInput"]> | undefined | null,
	code?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AllergenLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	root?: ValueTypes["AllergenLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["AllergenLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AllergenLocaleUpdateInput"]: {
	name?: string | undefined | null,
	root?: ValueTypes["AllergenLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["AllergenLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GpsConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["GpsEdge"],
		__typename?: boolean | `@${string}`
}>;
	["GpsEdge"]: AliasType<{
	node?:ValueTypes["Gps"],
		__typename?: boolean | `@${string}`
}>;
	["GpsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	latitude?: number | undefined | null,
	longitude?: number | undefined | null,
	address?: ValueTypes["GpsCreateAddressEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GpsCreateAddressEntityRelationInput"]: {
	connect?: ValueTypes["AddressUniqueWhere"] | undefined | null,
	create?: ValueTypes["AddressWithoutGpsCreateInput"] | undefined | null
};
	["AddressWithoutGpsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	addressLine2?: string | undefined | null,
	email?: string | undefined | null,
	phone?: string | undefined | null,
	companyName?: string | undefined | null,
	companyIdentifier?: string | undefined | null,
	vatIdentifier?: string | undefined | null,
	externalIdentifier?: string | undefined | null,
	hidden?: boolean | undefined | null,
	customer?: ValueTypes["AddressCreateCustomerEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	country?: ValueTypes["AddressCreateCountryEntityRelationInput"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	googlePlaceId?: string | undefined | null,
	raw?: string | undefined | null,
	formatted?: string | undefined | null,
	geocodeGeneratedAt?: ValueTypes["DateTime"] | undefined | null,
	geocodeResponse?: string | undefined | null,
	deliveryZone?: ValueTypes["AddressCreateDeliveryZoneEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["AddressCreateMetaEntityRelationInput"] | undefined | null,
	geocodeValid?: boolean | undefined | null,
	fullName?: string | undefined | null,
	fakturoidSubjectId?: string | undefined | null,
	invoices?: Array<ValueTypes["AddressCreateInvoicesEntityRelationInput"]> | undefined | null,
	addressLine1?: string | undefined | null,
	city?: string | undefined | null,
	postalCode?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingAddressOfOrders?: Array<ValueTypes["AddressCreateBillingAddressOfOrdersEntityRelationInput"]> | undefined | null,
	deliveryAddressOfOrderDeliveries?: Array<ValueTypes["AddressCreateDeliveryAddressOfOrderDeliveriesEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddressOfCustomer?: ValueTypes["AddressCreateDefaultDeliveryAddressOfCustomerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GpsUpdateInput"]: {
	latitude?: number | undefined | null,
	longitude?: number | undefined | null,
	address?: ValueTypes["GpsUpdateAddressEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GpsUpdateAddressEntityRelationInput"]: {
	create?: ValueTypes["AddressWithoutGpsCreateInput"] | undefined | null,
	update?: ValueTypes["AddressWithoutGpsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["GpsUpsertAddressRelationInput"] | undefined | null,
	connect?: ValueTypes["AddressUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["AddressWithoutGpsUpdateInput"]: {
	name?: string | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	addressLine2?: string | undefined | null,
	email?: string | undefined | null,
	phone?: string | undefined | null,
	companyName?: string | undefined | null,
	companyIdentifier?: string | undefined | null,
	vatIdentifier?: string | undefined | null,
	externalIdentifier?: string | undefined | null,
	hidden?: boolean | undefined | null,
	customer?: ValueTypes["AddressUpdateCustomerEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	country?: ValueTypes["AddressUpdateCountryEntityRelationInput"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	googlePlaceId?: string | undefined | null,
	raw?: string | undefined | null,
	formatted?: string | undefined | null,
	geocodeGeneratedAt?: ValueTypes["DateTime"] | undefined | null,
	geocodeResponse?: string | undefined | null,
	deliveryZone?: ValueTypes["AddressUpdateDeliveryZoneEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["AddressUpdateMetaEntityRelationInput"] | undefined | null,
	geocodeValid?: boolean | undefined | null,
	fullName?: string | undefined | null,
	fakturoidSubjectId?: string | undefined | null,
	invoices?: Array<ValueTypes["AddressUpdateInvoicesEntityRelationInput"]> | undefined | null,
	addressLine1?: string | undefined | null,
	city?: string | undefined | null,
	postalCode?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingAddressOfOrders?: Array<ValueTypes["AddressUpdateBillingAddressOfOrdersEntityRelationInput"]> | undefined | null,
	deliveryAddressOfOrderDeliveries?: Array<ValueTypes["AddressUpdateDeliveryAddressOfOrderDeliveriesEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddressOfCustomer?: ValueTypes["AddressUpdateDefaultDeliveryAddressOfCustomerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GpsUpsertAddressRelationInput"]: {
	update?: ValueTypes["AddressWithoutGpsUpdateInput"] | undefined | null,
	create?: ValueTypes["AddressWithoutGpsCreateInput"] | undefined | null
};
	["WeekHoursConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["WeekHoursEdge"],
		__typename?: boolean | `@${string}`
}>;
	["WeekHoursEdge"]: AliasType<{
	node?:ValueTypes["WeekHours"],
		__typename?: boolean | `@${string}`
}>;
	["PreparedIngredientQuantity"]: AliasType<{
	_meta?:ValueTypes["PreparedIngredientQuantityMeta"],
	id?:boolean | `@${string}`,
	date?:boolean | `@${string}`,
	quantity?:boolean | `@${string}`,
	usedQuantity?:boolean | `@${string}`,
ingredient?: [{	filter?: ValueTypes["ProductIngredientWhere"] | undefined | null},ValueTypes["ProductIngredient"]],
unit?: [{	filter?: ValueTypes["ProductIngredientItemQuantityUnitWhere"] | undefined | null},ValueTypes["ProductIngredientItemQuantityUnit"]],
		__typename?: boolean | `@${string}`
}>;
	["PreparedIngredientQuantityMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	date?:ValueTypes["FieldMeta"],
	quantity?:ValueTypes["FieldMeta"],
	usedQuantity?:ValueTypes["FieldMeta"],
	ingredient?:ValueTypes["FieldMeta"],
	unit?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PreparedIngredientQuantityUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	date?: ValueTypes["Date"] | undefined | null,
	ingredient?: ValueTypes["ProductIngredientUniqueWhere"] | undefined | null,
	unit?: ValueTypes["ProductIngredientItemQuantityUnitUniqueWhere"] | undefined | null
};
	["PreparedIngredientQuantityWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	date?: ValueTypes["DateCondition"] | undefined | null,
	quantity?: ValueTypes["FloatCondition"] | undefined | null,
	usedQuantity?: ValueTypes["FloatCondition"] | undefined | null,
	ingredient?: ValueTypes["ProductIngredientWhere"] | undefined | null,
	unit?: ValueTypes["ProductIngredientItemQuantityUnitWhere"] | undefined | null,
	and?: Array<ValueTypes["PreparedIngredientQuantityWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["PreparedIngredientQuantityWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["PreparedIngredientQuantityWhere"] | undefined | null
};
	["PreparedIngredientQuantityOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	date?: ValueTypes["OrderDirection"] | undefined | null,
	quantity?: ValueTypes["OrderDirection"] | undefined | null,
	usedQuantity?: ValueTypes["OrderDirection"] | undefined | null,
	ingredient?: ValueTypes["ProductIngredientOrderBy"] | undefined | null,
	unit?: ValueTypes["ProductIngredientItemQuantityUnitOrderBy"] | undefined | null
};
	["PreparedIngredientQuantityConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PreparedIngredientQuantityEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PreparedIngredientQuantityEdge"]: AliasType<{
	node?:ValueTypes["PreparedIngredientQuantity"],
		__typename?: boolean | `@${string}`
}>;
	["PreparedIngredientQuantityCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	date?: ValueTypes["Date"] | undefined | null,
	quantity?: number | undefined | null,
	usedQuantity?: number | undefined | null,
	ingredient?: ValueTypes["PreparedIngredientQuantityCreateIngredientEntityRelationInput"] | undefined | null,
	unit?: ValueTypes["PreparedIngredientQuantityCreateUnitEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PreparedIngredientQuantityCreateIngredientEntityRelationInput"]: {
	connect?: ValueTypes["ProductIngredientUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductIngredientCreateInput"] | undefined | null
};
	["PreparedIngredientQuantityCreateUnitEntityRelationInput"]: {
	connect?: ValueTypes["ProductIngredientItemQuantityUnitUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductIngredientItemQuantityUnitCreateInput"] | undefined | null
};
	["PreparedIngredientQuantityUpdateInput"]: {
	date?: ValueTypes["Date"] | undefined | null,
	quantity?: number | undefined | null,
	usedQuantity?: number | undefined | null,
	ingredient?: ValueTypes["PreparedIngredientQuantityUpdateIngredientEntityRelationInput"] | undefined | null,
	unit?: ValueTypes["PreparedIngredientQuantityUpdateUnitEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PreparedIngredientQuantityUpdateIngredientEntityRelationInput"]: {
	create?: ValueTypes["ProductIngredientCreateInput"] | undefined | null,
	update?: ValueTypes["ProductIngredientUpdateInput"] | undefined | null,
	upsert?: ValueTypes["PreparedIngredientQuantityUpsertIngredientRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductIngredientUniqueWhere"] | undefined | null
};
	["PreparedIngredientQuantityUpsertIngredientRelationInput"]: {
	update?: ValueTypes["ProductIngredientUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductIngredientCreateInput"] | undefined | null
};
	["PreparedIngredientQuantityUpdateUnitEntityRelationInput"]: {
	create?: ValueTypes["ProductIngredientItemQuantityUnitCreateInput"] | undefined | null,
	update?: ValueTypes["ProductIngredientItemQuantityUnitUpdateInput"] | undefined | null,
	upsert?: ValueTypes["PreparedIngredientQuantityUpsertUnitRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductIngredientItemQuantityUnitUniqueWhere"] | undefined | null
};
	["PreparedIngredientQuantityUpsertUnitRelationInput"]: {
	update?: ValueTypes["ProductIngredientItemQuantityUnitUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductIngredientItemQuantityUnitCreateInput"] | undefined | null
};
	["PreparedRecipeQuantity"]: AliasType<{
	_meta?:ValueTypes["PreparedRecipeQuantityMeta"],
	id?:boolean | `@${string}`,
	date?:boolean | `@${string}`,
	quantity?:boolean | `@${string}`,
recipe?: [{	filter?: ValueTypes["ProductRecipeWhere"] | undefined | null},ValueTypes["ProductRecipe"]],
	usedQuantity?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PreparedRecipeQuantityMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	date?:ValueTypes["FieldMeta"],
	quantity?:ValueTypes["FieldMeta"],
	recipe?:ValueTypes["FieldMeta"],
	usedQuantity?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PreparedRecipeQuantityUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	date?: ValueTypes["Date"] | undefined | null,
	recipe?: ValueTypes["ProductRecipeUniqueWhere"] | undefined | null
};
	["PreparedRecipeQuantityWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	date?: ValueTypes["DateCondition"] | undefined | null,
	quantity?: ValueTypes["FloatCondition"] | undefined | null,
	recipe?: ValueTypes["ProductRecipeWhere"] | undefined | null,
	usedQuantity?: ValueTypes["FloatCondition"] | undefined | null,
	and?: Array<ValueTypes["PreparedRecipeQuantityWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["PreparedRecipeQuantityWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["PreparedRecipeQuantityWhere"] | undefined | null
};
	["PreparedRecipeQuantityOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	date?: ValueTypes["OrderDirection"] | undefined | null,
	quantity?: ValueTypes["OrderDirection"] | undefined | null,
	recipe?: ValueTypes["ProductRecipeOrderBy"] | undefined | null,
	usedQuantity?: ValueTypes["OrderDirection"] | undefined | null
};
	["PreparedRecipeQuantityConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PreparedRecipeQuantityEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PreparedRecipeQuantityEdge"]: AliasType<{
	node?:ValueTypes["PreparedRecipeQuantity"],
		__typename?: boolean | `@${string}`
}>;
	["PreparedRecipeQuantityCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	date?: ValueTypes["Date"] | undefined | null,
	quantity?: number | undefined | null,
	recipe?: ValueTypes["PreparedRecipeQuantityCreateRecipeEntityRelationInput"] | undefined | null,
	usedQuantity?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PreparedRecipeQuantityCreateRecipeEntityRelationInput"]: {
	connect?: ValueTypes["ProductRecipeUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductRecipeCreateInput"] | undefined | null
};
	["PreparedRecipeQuantityUpdateInput"]: {
	date?: ValueTypes["Date"] | undefined | null,
	quantity?: number | undefined | null,
	recipe?: ValueTypes["PreparedRecipeQuantityUpdateRecipeEntityRelationInput"] | undefined | null,
	usedQuantity?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PreparedRecipeQuantityUpdateRecipeEntityRelationInput"]: {
	create?: ValueTypes["ProductRecipeCreateInput"] | undefined | null,
	update?: ValueTypes["ProductRecipeUpdateInput"] | undefined | null,
	upsert?: ValueTypes["PreparedRecipeQuantityUpsertRecipeRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductRecipeUniqueWhere"] | undefined | null
};
	["PreparedRecipeQuantityUpsertRecipeRelationInput"]: {
	update?: ValueTypes["ProductRecipeUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductRecipeCreateInput"] | undefined | null
};
	["InternalOrder"]: AliasType<{
	_meta?:ValueTypes["InternalOrderMeta"],
	id?:boolean | `@${string}`,
	state?:boolean | `@${string}`,
	fulfilledAt?:boolean | `@${string}`,
	canceledAt?:boolean | `@${string}`,
	targetPlace?:boolean | `@${string}`,
	note?:boolean | `@${string}`,
	internalNote?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["InternalOrderItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InternalOrderItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["InternalOrderItem"]],
	createdAt?:boolean | `@${string}`,
paginateItems?: [{	filter?: ValueTypes["InternalOrderItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InternalOrderItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["InternalOrderItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["InternalOrderMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	state?:ValueTypes["FieldMeta"],
	fulfilledAt?:ValueTypes["FieldMeta"],
	canceledAt?:ValueTypes["FieldMeta"],
	targetPlace?:ValueTypes["FieldMeta"],
	note?:ValueTypes["FieldMeta"],
	internalNote?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["InternalOrderState"]:InternalOrderState;
	["InternalOrderItem"]: AliasType<{
	_meta?:ValueTypes["InternalOrderItemMeta"],
	id?:boolean | `@${string}`,
	quantity?:boolean | `@${string}`,
internalOrder?: [{	filter?: ValueTypes["InternalOrderWhere"] | undefined | null},ValueTypes["InternalOrder"]],
product?: [{	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
		__typename?: boolean | `@${string}`
}>;
	["InternalOrderItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	quantity?:ValueTypes["FieldMeta"],
	internalOrder?:ValueTypes["FieldMeta"],
	product?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["InternalOrderWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	state?: ValueTypes["InternalOrderStateCondition"] | undefined | null,
	fulfilledAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	canceledAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	targetPlace?: ValueTypes["StringCondition"] | undefined | null,
	note?: ValueTypes["StringCondition"] | undefined | null,
	internalNote?: ValueTypes["StringCondition"] | undefined | null,
	items?: ValueTypes["InternalOrderItemWhere"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	and?: Array<ValueTypes["InternalOrderWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["InternalOrderWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["InternalOrderWhere"] | undefined | null
};
	["InternalOrderStateCondition"]: {
	and?: Array<ValueTypes["InternalOrderStateCondition"]> | undefined | null,
	or?: Array<ValueTypes["InternalOrderStateCondition"]> | undefined | null,
	not?: ValueTypes["InternalOrderStateCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["InternalOrderState"] | undefined | null,
	notEq?: ValueTypes["InternalOrderState"] | undefined | null,
	in?: Array<ValueTypes["InternalOrderState"]> | undefined | null,
	notIn?: Array<ValueTypes["InternalOrderState"]> | undefined | null,
	lt?: ValueTypes["InternalOrderState"] | undefined | null,
	lte?: ValueTypes["InternalOrderState"] | undefined | null,
	gt?: ValueTypes["InternalOrderState"] | undefined | null,
	gte?: ValueTypes["InternalOrderState"] | undefined | null
};
	["InternalOrderItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	quantity?: ValueTypes["IntCondition"] | undefined | null,
	internalOrder?: ValueTypes["InternalOrderWhere"] | undefined | null,
	product?: ValueTypes["ProductWhere"] | undefined | null,
	and?: Array<ValueTypes["InternalOrderItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["InternalOrderItemWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["InternalOrderItemWhere"] | undefined | null
};
	["InternalOrderItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	quantity?: ValueTypes["OrderDirection"] | undefined | null,
	internalOrder?: ValueTypes["InternalOrderOrderBy"] | undefined | null,
	product?: ValueTypes["ProductOrderBy"] | undefined | null
};
	["InternalOrderOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	state?: ValueTypes["OrderDirection"] | undefined | null,
	fulfilledAt?: ValueTypes["OrderDirection"] | undefined | null,
	canceledAt?: ValueTypes["OrderDirection"] | undefined | null,
	targetPlace?: ValueTypes["OrderDirection"] | undefined | null,
	note?: ValueTypes["OrderDirection"] | undefined | null,
	internalNote?: ValueTypes["OrderDirection"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null
};
	["InternalOrderItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["InternalOrderItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["InternalOrderItemEdge"]: AliasType<{
	node?:ValueTypes["InternalOrderItem"],
		__typename?: boolean | `@${string}`
}>;
	["InternalOrderUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: ValueTypes["InternalOrderItemUniqueWhere"] | undefined | null
};
	["InternalOrderItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["InternalOrderConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["InternalOrderEdge"],
		__typename?: boolean | `@${string}`
}>;
	["InternalOrderEdge"]: AliasType<{
	node?:ValueTypes["InternalOrder"],
		__typename?: boolean | `@${string}`
}>;
	["InternalOrderCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	state?: ValueTypes["InternalOrderState"] | undefined | null,
	fulfilledAt?: ValueTypes["DateTime"] | undefined | null,
	canceledAt?: ValueTypes["DateTime"] | undefined | null,
	targetPlace?: string | undefined | null,
	note?: string | undefined | null,
	internalNote?: string | undefined | null,
	items?: Array<ValueTypes["InternalOrderCreateItemsEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InternalOrderCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["InternalOrderItemUniqueWhere"] | undefined | null,
	create?: ValueTypes["InternalOrderItemWithoutInternalOrderCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["InternalOrderItemWithoutInternalOrderCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	quantity?: number | undefined | null,
	product?: ValueTypes["InternalOrderItemCreateProductEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InternalOrderItemCreateProductEntityRelationInput"]: {
	connect?: ValueTypes["ProductUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductCreateInput"] | undefined | null
};
	["InternalOrderUpdateInput"]: {
	state?: ValueTypes["InternalOrderState"] | undefined | null,
	fulfilledAt?: ValueTypes["DateTime"] | undefined | null,
	canceledAt?: ValueTypes["DateTime"] | undefined | null,
	targetPlace?: string | undefined | null,
	note?: string | undefined | null,
	internalNote?: string | undefined | null,
	items?: Array<ValueTypes["InternalOrderUpdateItemsEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InternalOrderUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["InternalOrderItemWithoutInternalOrderCreateInput"] | undefined | null,
	update?: ValueTypes["InternalOrderUpdateItemsRelationInput"] | undefined | null,
	upsert?: ValueTypes["InternalOrderUpsertItemsRelationInput"] | undefined | null,
	connect?: ValueTypes["InternalOrderItemUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["InternalOrderItemUniqueWhere"] | undefined | null,
	delete?: ValueTypes["InternalOrderItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["InternalOrderUpdateItemsRelationInput"]: {
	by?: ValueTypes["InternalOrderItemUniqueWhere"] | undefined | null,
	data?: ValueTypes["InternalOrderItemWithoutInternalOrderUpdateInput"] | undefined | null
};
	["InternalOrderItemWithoutInternalOrderUpdateInput"]: {
	quantity?: number | undefined | null,
	product?: ValueTypes["InternalOrderItemUpdateProductEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InternalOrderItemUpdateProductEntityRelationInput"]: {
	create?: ValueTypes["ProductCreateInput"] | undefined | null,
	update?: ValueTypes["ProductUpdateInput"] | undefined | null,
	upsert?: ValueTypes["InternalOrderItemUpsertProductRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductUniqueWhere"] | undefined | null
};
	["InternalOrderItemUpsertProductRelationInput"]: {
	update?: ValueTypes["ProductUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductCreateInput"] | undefined | null
};
	["InternalOrderUpsertItemsRelationInput"]: {
	by?: ValueTypes["InternalOrderItemUniqueWhere"] | undefined | null,
	update?: ValueTypes["InternalOrderItemWithoutInternalOrderUpdateInput"] | undefined | null,
	create?: ValueTypes["InternalOrderItemWithoutInternalOrderCreateInput"] | undefined | null
};
	["InternalOrderItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	quantity?: number | undefined | null,
	internalOrder?: ValueTypes["InternalOrderItemCreateInternalOrderEntityRelationInput"] | undefined | null,
	product?: ValueTypes["InternalOrderItemCreateProductEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InternalOrderItemCreateInternalOrderEntityRelationInput"]: {
	connect?: ValueTypes["InternalOrderUniqueWhere"] | undefined | null,
	create?: ValueTypes["InternalOrderWithoutItemsCreateInput"] | undefined | null
};
	["InternalOrderWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	state?: ValueTypes["InternalOrderState"] | undefined | null,
	fulfilledAt?: ValueTypes["DateTime"] | undefined | null,
	canceledAt?: ValueTypes["DateTime"] | undefined | null,
	targetPlace?: string | undefined | null,
	note?: string | undefined | null,
	internalNote?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InternalOrderItemUpdateInput"]: {
	quantity?: number | undefined | null,
	internalOrder?: ValueTypes["InternalOrderItemUpdateInternalOrderEntityRelationInput"] | undefined | null,
	product?: ValueTypes["InternalOrderItemUpdateProductEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InternalOrderItemUpdateInternalOrderEntityRelationInput"]: {
	create?: ValueTypes["InternalOrderWithoutItemsCreateInput"] | undefined | null,
	update?: ValueTypes["InternalOrderWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["InternalOrderItemUpsertInternalOrderRelationInput"] | undefined | null,
	connect?: ValueTypes["InternalOrderUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["InternalOrderWithoutItemsUpdateInput"]: {
	state?: ValueTypes["InternalOrderState"] | undefined | null,
	fulfilledAt?: ValueTypes["DateTime"] | undefined | null,
	canceledAt?: ValueTypes["DateTime"] | undefined | null,
	targetPlace?: string | undefined | null,
	note?: string | undefined | null,
	internalNote?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InternalOrderItemUpsertInternalOrderRelationInput"]: {
	update?: ValueTypes["InternalOrderWithoutItemsUpdateInput"] | undefined | null,
	create?: ValueTypes["InternalOrderWithoutItemsCreateInput"] | undefined | null
};
	["PreparedPackingQuantityCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	date?: ValueTypes["Date"] | undefined | null,
	quantity?: number | undefined | null,
	recipe?: ValueTypes["PreparedPackingQuantityCreateRecipeEntityRelationInput"] | undefined | null,
	packing?: ValueTypes["PreparedPackingQuantityCreatePackingEntityRelationInput"] | undefined | null,
	packedInCardboard?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PreparedPackingQuantityCreatePackingEntityRelationInput"]: {
	connect?: ValueTypes["ProductPackingUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductPackingWithoutPreparedPackingQuantitiesCreateInput"] | undefined | null
};
	["ProductPackingWithoutPreparedPackingQuantitiesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	image?: ValueTypes["ProductPackingCreateImageEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	volumeMl?: number | undefined | null,
	icon?: ValueTypes["ProductPackingCreateIconEntityRelationInput"] | undefined | null,
	shortName?: string | undefined | null,
	locales?: Array<ValueTypes["ProductPackingCreateLocalesEntityRelationInput"]> | undefined | null,
	isPackedInCardboard?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PreparedPackingQuantityUpdateInput"]: {
	date?: ValueTypes["Date"] | undefined | null,
	quantity?: number | undefined | null,
	recipe?: ValueTypes["PreparedPackingQuantityUpdateRecipeEntityRelationInput"] | undefined | null,
	packing?: ValueTypes["PreparedPackingQuantityUpdatePackingEntityRelationInput"] | undefined | null,
	packedInCardboard?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PreparedPackingQuantityUpdatePackingEntityRelationInput"]: {
	create?: ValueTypes["ProductPackingWithoutPreparedPackingQuantitiesCreateInput"] | undefined | null,
	update?: ValueTypes["ProductPackingWithoutPreparedPackingQuantitiesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["PreparedPackingQuantityUpsertPackingRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductPackingUniqueWhere"] | undefined | null
};
	["ProductPackingWithoutPreparedPackingQuantitiesUpdateInput"]: {
	name?: string | undefined | null,
	image?: ValueTypes["ProductPackingUpdateImageEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	volumeMl?: number | undefined | null,
	icon?: ValueTypes["ProductPackingUpdateIconEntityRelationInput"] | undefined | null,
	shortName?: string | undefined | null,
	locales?: Array<ValueTypes["ProductPackingUpdateLocalesEntityRelationInput"]> | undefined | null,
	isPackedInCardboard?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PreparedPackingQuantityUpsertPackingRelationInput"]: {
	update?: ValueTypes["ProductPackingWithoutPreparedPackingQuantitiesUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductPackingWithoutPreparedPackingQuantitiesCreateInput"] | undefined | null
};
	["CourierManagerConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CourierManagerEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CourierManagerEdge"]: AliasType<{
	node?:ValueTypes["CourierManager"],
		__typename?: boolean | `@${string}`
}>;
	["CourierManagerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	staff?: ValueTypes["CourierManagerCreateStaffEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CourierManagerCreateStaffEntityRelationInput"]: {
	connect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	create?: ValueTypes["StaffWithoutCourierManagerCreateInput"] | undefined | null
};
	["StaffWithoutCourierManagerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	bartender?: ValueTypes["StaffCreateBartenderEntityRelationInput"] | undefined | null,
	courier?: ValueTypes["StaffCreateCourierEntityRelationInput"] | undefined | null,
	cleaner?: ValueTypes["StaffCreateCleanerEntityRelationInput"] | undefined | null,
	shiftsManager?: ValueTypes["StaffCreateShiftsManagerEntityRelationInput"] | undefined | null,
	businessToBusinessManager?: ValueTypes["StaffCreateBusinessToBusinessManagerEntityRelationInput"] | undefined | null,
	user?: ValueTypes["StaffCreateUserEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["StaffCreateShiftsProfileEntityRelationInput"] | undefined | null,
	stocksManager?: ValueTypes["StaffCreateStocksManagerEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["StaffCreatePhotoEntityRelationInput"] | undefined | null,
	picker?: ValueTypes["StaffCreatePickerEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	remunerationProfile?: ValueTypes["StaffCreateRemunerationProfileEntityRelationInput"] | undefined | null,
	cashier?: ValueTypes["StaffCreateCashierEntityRelationInput"] | undefined | null,
	venues?: Array<ValueTypes["StaffCreateVenuesEntityRelationInput"]> | undefined | null,
	internalBuyer?: ValueTypes["StaffCreateInternalBuyerEntityRelationInput"] | undefined | null,
	salesManager?: ValueTypes["StaffCreateSalesManagerEntityRelationInput"] | undefined | null,
	cashierManager?: ValueTypes["StaffCreateCashierManagerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CourierManagerUpdateInput"]: {
	staff?: ValueTypes["CourierManagerUpdateStaffEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CourierManagerUpdateStaffEntityRelationInput"]: {
	create?: ValueTypes["StaffWithoutCourierManagerCreateInput"] | undefined | null,
	update?: ValueTypes["StaffWithoutCourierManagerUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CourierManagerUpsertStaffRelationInput"] | undefined | null,
	connect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["StaffWithoutCourierManagerUpdateInput"]: {
	bartender?: ValueTypes["StaffUpdateBartenderEntityRelationInput"] | undefined | null,
	courier?: ValueTypes["StaffUpdateCourierEntityRelationInput"] | undefined | null,
	cleaner?: ValueTypes["StaffUpdateCleanerEntityRelationInput"] | undefined | null,
	shiftsManager?: ValueTypes["StaffUpdateShiftsManagerEntityRelationInput"] | undefined | null,
	businessToBusinessManager?: ValueTypes["StaffUpdateBusinessToBusinessManagerEntityRelationInput"] | undefined | null,
	user?: ValueTypes["StaffUpdateUserEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["StaffUpdateShiftsProfileEntityRelationInput"] | undefined | null,
	stocksManager?: ValueTypes["StaffUpdateStocksManagerEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["StaffUpdatePhotoEntityRelationInput"] | undefined | null,
	picker?: ValueTypes["StaffUpdatePickerEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	remunerationProfile?: ValueTypes["StaffUpdateRemunerationProfileEntityRelationInput"] | undefined | null,
	cashier?: ValueTypes["StaffUpdateCashierEntityRelationInput"] | undefined | null,
	venues?: Array<ValueTypes["StaffUpdateVenuesEntityRelationInput"]> | undefined | null,
	internalBuyer?: ValueTypes["StaffUpdateInternalBuyerEntityRelationInput"] | undefined | null,
	salesManager?: ValueTypes["StaffUpdateSalesManagerEntityRelationInput"] | undefined | null,
	cashierManager?: ValueTypes["StaffUpdateCashierManagerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CourierManagerUpsertStaffRelationInput"]: {
	update?: ValueTypes["StaffWithoutCourierManagerUpdateInput"] | undefined | null,
	create?: ValueTypes["StaffWithoutCourierManagerCreateInput"] | undefined | null
};
	["DeliveryZoneCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	type?: ValueTypes["DeliveryZoneType"] | undefined | null,
	addresses?: Array<ValueTypes["DeliveryZoneCreateAddressesEntityRelationInput"]> | undefined | null,
	suitableDeliveryMethods?: Array<ValueTypes["DeliveryZoneCreateSuitableDeliveryMethodsEntityRelationInput"]> | undefined | null,
	deliveryZonesOfTags?: Array<ValueTypes["DeliveryZoneCreateDeliveryZonesOfTagsEntityRelationInput"]> | undefined | null,
	deliveryZonesOfProducts?: Array<ValueTypes["DeliveryZoneCreateDeliveryZonesOfProductsEntityRelationInput"]> | undefined | null,
	addressesMetadata?: Array<ValueTypes["DeliveryZoneCreateAddressesMetadataEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryZoneUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	type?: ValueTypes["DeliveryZoneType"] | undefined | null,
	addresses?: Array<ValueTypes["DeliveryZoneUpdateAddressesEntityRelationInput"]> | undefined | null,
	suitableDeliveryMethods?: Array<ValueTypes["DeliveryZoneUpdateSuitableDeliveryMethodsEntityRelationInput"]> | undefined | null,
	deliveryZonesOfTags?: Array<ValueTypes["DeliveryZoneUpdateDeliveryZonesOfTagsEntityRelationInput"]> | undefined | null,
	deliveryZonesOfProducts?: Array<ValueTypes["DeliveryZoneUpdateDeliveryZonesOfProductsEntityRelationInput"]> | undefined | null,
	addressesMetadata?: Array<ValueTypes["DeliveryZoneUpdateAddressesMetadataEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryTimelinePresetConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["DeliveryTimelinePresetEdge"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryTimelinePresetEdge"]: AliasType<{
	node?:ValueTypes["DeliveryTimelinePreset"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryTimelinePresetCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	type?: ValueTypes["DeliveryTimelineType"] | undefined | null,
	duration?: string | undefined | null,
	window?: string | undefined | null,
	deliveryMethod?: ValueTypes["DeliveryTimelinePresetCreateDeliveryMethodEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryTimelinePresetCreateDeliveryMethodEntityRelationInput"]: {
	connect?: ValueTypes["DeliveryMethodUniqueWhere"] | undefined | null,
	create?: ValueTypes["DeliveryMethodWithoutTimelinePresetCreateInput"] | undefined | null
};
	["DeliveryMethodWithoutTimelinePresetCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	code?: string | undefined | null,
	enabled?: boolean | undefined | null,
	paymentMethods?: Array<ValueTypes["DeliveryMethodCreatePaymentMethodsEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	requireDeliveryAddress?: boolean | undefined | null,
	suitableForDeliveryZones?: Array<ValueTypes["DeliveryMethodCreateSuitableForDeliveryZonesEntityRelationInput"]> | undefined | null,
	channels?: Array<ValueTypes["DeliveryMethodCreateChannelsEntityRelationInput"]> | undefined | null,
	courierHandlers?: Array<ValueTypes["DeliveryMethodCreateCourierHandlersEntityRelationInput"]> | undefined | null,
	enableDeliveryTracking?: boolean | undefined | null,
	locales?: Array<ValueTypes["DeliveryMethodCreateLocalesEntityRelationInput"]> | undefined | null,
	woltDriveVenueId?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryTimelinePresetUpdateInput"]: {
	type?: ValueTypes["DeliveryTimelineType"] | undefined | null,
	duration?: string | undefined | null,
	window?: string | undefined | null,
	deliveryMethod?: ValueTypes["DeliveryTimelinePresetUpdateDeliveryMethodEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryTimelinePresetUpdateDeliveryMethodEntityRelationInput"]: {
	create?: ValueTypes["DeliveryMethodWithoutTimelinePresetCreateInput"] | undefined | null,
	update?: ValueTypes["DeliveryMethodWithoutTimelinePresetUpdateInput"] | undefined | null,
	upsert?: ValueTypes["DeliveryTimelinePresetUpsertDeliveryMethodRelationInput"] | undefined | null,
	connect?: ValueTypes["DeliveryMethodUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["DeliveryMethodWithoutTimelinePresetUpdateInput"]: {
	name?: string | undefined | null,
	code?: string | undefined | null,
	enabled?: boolean | undefined | null,
	paymentMethods?: Array<ValueTypes["DeliveryMethodUpdatePaymentMethodsEntityRelationInput"]> | undefined | null,
	description?: string | undefined | null,
	internalNote?: string | undefined | null,
	requireDeliveryAddress?: boolean | undefined | null,
	suitableForDeliveryZones?: Array<ValueTypes["DeliveryMethodUpdateSuitableForDeliveryZonesEntityRelationInput"]> | undefined | null,
	channels?: Array<ValueTypes["DeliveryMethodUpdateChannelsEntityRelationInput"]> | undefined | null,
	courierHandlers?: Array<ValueTypes["DeliveryMethodUpdateCourierHandlersEntityRelationInput"]> | undefined | null,
	enableDeliveryTracking?: boolean | undefined | null,
	locales?: Array<ValueTypes["DeliveryMethodUpdateLocalesEntityRelationInput"]> | undefined | null,
	woltDriveVenueId?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryTimelinePresetUpsertDeliveryMethodRelationInput"]: {
	update?: ValueTypes["DeliveryMethodWithoutTimelinePresetUpdateInput"] | undefined | null,
	create?: ValueTypes["DeliveryMethodWithoutTimelinePresetCreateInput"] | undefined | null
};
	["OrderDeliveryTimeline"]: AliasType<{
	_meta?:ValueTypes["OrderDeliveryTimelineMeta"],
	id?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	prepareAt?:boolean | `@${string}`,
	loadingHours?:boolean | `@${string}`,
	dispatchAt?:boolean | `@${string}`,
	duration?:boolean | `@${string}`,
	window?:boolean | `@${string}`,
	expectedEndAt?:boolean | `@${string}`,
	expectedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["OrderDeliveryTimelineMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	prepareAt?:ValueTypes["FieldMeta"],
	loadingHours?:ValueTypes["FieldMeta"],
	dispatchAt?:ValueTypes["FieldMeta"],
	duration?:ValueTypes["FieldMeta"],
	window?:ValueTypes["FieldMeta"],
	expectedEndAt?:ValueTypes["FieldMeta"],
	expectedAt?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["OrderDeliveryTimelineUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["OrderDeliveryTimelineWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	type?: ValueTypes["DeliveryTimelineTypeCondition"] | undefined | null,
	prepareAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	loadingHours?: ValueTypes["IntCondition"] | undefined | null,
	dispatchAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	duration?: ValueTypes["StringCondition"] | undefined | null,
	window?: ValueTypes["StringCondition"] | undefined | null,
	expectedEndAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	expectedAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	and?: Array<ValueTypes["OrderDeliveryTimelineWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["OrderDeliveryTimelineWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["OrderDeliveryTimelineWhere"] | undefined | null
};
	["OrderDeliveryTimelineOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	type?: ValueTypes["OrderDirection"] | undefined | null,
	prepareAt?: ValueTypes["OrderDirection"] | undefined | null,
	loadingHours?: ValueTypes["OrderDirection"] | undefined | null,
	dispatchAt?: ValueTypes["OrderDirection"] | undefined | null,
	duration?: ValueTypes["OrderDirection"] | undefined | null,
	window?: ValueTypes["OrderDirection"] | undefined | null,
	expectedEndAt?: ValueTypes["OrderDirection"] | undefined | null,
	expectedAt?: ValueTypes["OrderDirection"] | undefined | null
};
	["OrderDeliveryTimelineConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["OrderDeliveryTimelineEdge"],
		__typename?: boolean | `@${string}`
}>;
	["OrderDeliveryTimelineEdge"]: AliasType<{
	node?:ValueTypes["OrderDeliveryTimeline"],
		__typename?: boolean | `@${string}`
}>;
	["OrderDeliveryTimelineCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	type?: ValueTypes["DeliveryTimelineType"] | undefined | null,
	prepareAt?: ValueTypes["DateTime"] | undefined | null,
	loadingHours?: number | undefined | null,
	dispatchAt?: ValueTypes["DateTime"] | undefined | null,
	duration?: string | undefined | null,
	window?: string | undefined | null,
	expectedEndAt?: ValueTypes["DateTime"] | undefined | null,
	expectedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderDeliveryTimelineUpdateInput"]: {
	type?: ValueTypes["DeliveryTimelineType"] | undefined | null,
	prepareAt?: ValueTypes["DateTime"] | undefined | null,
	loadingHours?: number | undefined | null,
	dispatchAt?: ValueTypes["DateTime"] | undefined | null,
	duration?: string | undefined | null,
	window?: string | undefined | null,
	expectedEndAt?: ValueTypes["DateTime"] | undefined | null,
	expectedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderEventCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	type?: string | undefined | null,
	data?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	order?: ValueTypes["OrderEventCreateOrderEntityRelationInput"] | undefined | null,
	payment?: ValueTypes["OrderEventCreatePaymentEntityRelationInput"] | undefined | null,
	delivery?: ValueTypes["OrderEventCreateDeliveryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["OrderEventUpdateInput"]: {
	type?: string | undefined | null,
	data?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	order?: ValueTypes["OrderEventUpdateOrderEntityRelationInput"] | undefined | null,
	payment?: ValueTypes["OrderEventUpdatePaymentEntityRelationInput"] | undefined | null,
	delivery?: ValueTypes["OrderEventUpdateDeliveryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LiftagoRideConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LiftagoRideEdge"],
		__typename?: boolean | `@${string}`
}>;
	["LiftagoRideEdge"]: AliasType<{
	node?:ValueTypes["LiftagoRide"],
		__typename?: boolean | `@${string}`
}>;
	["LiftagoRideCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	liftagoId?: string | undefined | null,
	data?: string | undefined | null,
	updatedAt?: ValueTypes["DateTime"] | undefined | null,
	delivery?: ValueTypes["LiftagoRideCreateDeliveryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LiftagoRideCreateDeliveryEntityRelationInput"]: {
	connect?: ValueTypes["OrderDeliveryUniqueWhere"] | undefined | null,
	create?: ValueTypes["OrderDeliveryWithoutLiftagoRideCreateInput"] | undefined | null
};
	["OrderDeliveryWithoutLiftagoRideCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	priceCents?: number | undefined | null,
	deliveredAt?: ValueTypes["DateTime"] | undefined | null,
	method?: ValueTypes["OrderDeliveryCreateMethodEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["OrderDeliveryCreateVatRateEntityRelationInput"] | undefined | null,
	order?: ValueTypes["OrderDeliveryCreateOrderEntityRelationInput"] | undefined | null,
	expectedAt?: ValueTypes["DateTime"] | undefined | null,
	state?: ValueTypes["OrderDeliveryState"] | undefined | null,
	loadingDurationHours?: number | undefined | null,
	dispatchAt?: ValueTypes["DateTime"] | undefined | null,
	duration?: string | undefined | null,
	window?: string | undefined | null,
	expectedEndAt?: ValueTypes["DateTime"] | undefined | null,
	processingAt?: ValueTypes["DateTime"] | undefined | null,
	deliveringAt?: ValueTypes["DateTime"] | undefined | null,
	failedAt?: ValueTypes["DateTime"] | undefined | null,
	internalNote?: string | undefined | null,
	deliveryWaypoint?: ValueTypes["OrderDeliveryCreateDeliveryWaypointEntityRelationInput"] | undefined | null,
	events?: Array<ValueTypes["OrderDeliveryCreateEventsEntityRelationInput"]> | undefined | null,
	prepareAt?: ValueTypes["DateTime"] | undefined | null,
	pickedAt?: ValueTypes["DateTime"] | undefined | null,
	address?: ValueTypes["OrderDeliveryCreateAddressEntityRelationInput"] | undefined | null,
	trackingCode?: string | undefined | null,
	woltDriveDelivery?: ValueTypes["OrderDeliveryCreateWoltDriveDeliveryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LiftagoRideUpdateInput"]: {
	liftagoId?: string | undefined | null,
	data?: string | undefined | null,
	updatedAt?: ValueTypes["DateTime"] | undefined | null,
	delivery?: ValueTypes["LiftagoRideUpdateDeliveryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LiftagoRideUpdateDeliveryEntityRelationInput"]: {
	create?: ValueTypes["OrderDeliveryWithoutLiftagoRideCreateInput"] | undefined | null,
	update?: ValueTypes["OrderDeliveryWithoutLiftagoRideUpdateInput"] | undefined | null,
	upsert?: ValueTypes["LiftagoRideUpsertDeliveryRelationInput"] | undefined | null,
	connect?: ValueTypes["OrderDeliveryUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["OrderDeliveryWithoutLiftagoRideUpdateInput"]: {
	priceCents?: number | undefined | null,
	deliveredAt?: ValueTypes["DateTime"] | undefined | null,
	method?: ValueTypes["OrderDeliveryUpdateMethodEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["OrderDeliveryUpdateVatRateEntityRelationInput"] | undefined | null,
	order?: ValueTypes["OrderDeliveryUpdateOrderEntityRelationInput"] | undefined | null,
	expectedAt?: ValueTypes["DateTime"] | undefined | null,
	state?: ValueTypes["OrderDeliveryState"] | undefined | null,
	loadingDurationHours?: number | undefined | null,
	dispatchAt?: ValueTypes["DateTime"] | undefined | null,
	duration?: string | undefined | null,
	window?: string | undefined | null,
	expectedEndAt?: ValueTypes["DateTime"] | undefined | null,
	processingAt?: ValueTypes["DateTime"] | undefined | null,
	deliveringAt?: ValueTypes["DateTime"] | undefined | null,
	failedAt?: ValueTypes["DateTime"] | undefined | null,
	internalNote?: string | undefined | null,
	deliveryWaypoint?: ValueTypes["OrderDeliveryUpdateDeliveryWaypointEntityRelationInput"] | undefined | null,
	events?: Array<ValueTypes["OrderDeliveryUpdateEventsEntityRelationInput"]> | undefined | null,
	prepareAt?: ValueTypes["DateTime"] | undefined | null,
	pickedAt?: ValueTypes["DateTime"] | undefined | null,
	address?: ValueTypes["OrderDeliveryUpdateAddressEntityRelationInput"] | undefined | null,
	trackingCode?: string | undefined | null,
	woltDriveDelivery?: ValueTypes["OrderDeliveryUpdateWoltDriveDeliveryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LiftagoRideUpsertDeliveryRelationInput"]: {
	update?: ValueTypes["OrderDeliveryWithoutLiftagoRideUpdateInput"] | undefined | null,
	create?: ValueTypes["OrderDeliveryWithoutLiftagoRideCreateInput"] | undefined | null
};
	["InvoiceCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	publicKey?: string | undefined | null,
	fakturoidId?: string | undefined | null,
	fakturoidData?: string | undefined | null,
	legacyUrl?: string | undefined | null,
	customer?: ValueTypes["InvoiceCreateCustomerEntityRelationInput"] | undefined | null,
	orderPayments?: Array<ValueTypes["InvoiceCreateOrderPaymentsEntityRelationInput"]> | undefined | null,
	address?: ValueTypes["InvoiceCreateAddressEntityRelationInput"] | undefined | null,
	publicUrl?: string | undefined | null,
	billingSubject?: ValueTypes["InvoiceCreateBillingSubjectEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InvoiceUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	publicKey?: string | undefined | null,
	fakturoidId?: string | undefined | null,
	fakturoidData?: string | undefined | null,
	legacyUrl?: string | undefined | null,
	customer?: ValueTypes["InvoiceUpdateCustomerEntityRelationInput"] | undefined | null,
	orderPayments?: Array<ValueTypes["InvoiceUpdateOrderPaymentsEntityRelationInput"]> | undefined | null,
	address?: ValueTypes["InvoiceUpdateAddressEntityRelationInput"] | undefined | null,
	publicUrl?: string | undefined | null,
	billingSubject?: ValueTypes["InvoiceUpdateBillingSubjectEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InvoicingPlanConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["InvoicingPlanEdge"],
		__typename?: boolean | `@${string}`
}>;
	["InvoicingPlanEdge"]: AliasType<{
	node?:ValueTypes["InvoicingPlan"],
		__typename?: boolean | `@${string}`
}>;
	["InvoicingPlanCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	customer?: ValueTypes["InvoicingPlanCreateCustomerEntityRelationInput"] | undefined | null,
	preset?: ValueTypes["InvoicingPlanCreatePresetEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InvoicingPlanCreateCustomerEntityRelationInput"]: {
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerWithoutInvoicingPlanCreateInput"] | undefined | null
};
	["CustomerWithoutInvoicingPlanCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	addresses?: Array<ValueTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerCreateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerCreateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerCreatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerCreateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerCreateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerCreateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerCreateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerCreateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerCreateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerCreateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InvoicingPlanUpdateInput"]: {
	customer?: ValueTypes["InvoicingPlanUpdateCustomerEntityRelationInput"] | undefined | null,
	preset?: ValueTypes["InvoicingPlanUpdatePresetEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InvoicingPlanUpdateCustomerEntityRelationInput"]: {
	create?: ValueTypes["CustomerWithoutInvoicingPlanCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerWithoutInvoicingPlanUpdateInput"] | undefined | null,
	upsert?: ValueTypes["InvoicingPlanUpsertCustomerRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["CustomerWithoutInvoicingPlanUpdateInput"]: {
	addresses?: Array<ValueTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined | null,
	defaultBillingAddress?: ValueTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined | null,
	defaultPaymentMethod?: ValueTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined | null,
	tags?: Array<ValueTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined | null,
	credits?: Array<ValueTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined | null,
	paymentMethods?: Array<ValueTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined | null,
	permissions?: ValueTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined | null,
	group?: ValueTypes["CustomerUpdateGroupEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined | null,
	phone?: string | undefined | null,
	name?: ValueTypes["CustomerUpdateNameEntityRelationInput"] | undefined | null,
	internalNote?: string | undefined | null,
	welcomeMessage?: string | undefined | null,
	familiarity?: ValueTypes["CustomerFamiliarity"] | undefined | null,
	ingredientRatings?: Array<ValueTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined | null,
	business?: ValueTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined | null,
	ownerOfBusinesses?: Array<ValueTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined | null,
	memberOfBusinesses?: Array<ValueTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined | null,
	carts?: Array<ValueTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined | null,
	shortcutList?: ValueTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined | null,
	user?: ValueTypes["CustomerUpdateUserEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined | null,
	disabledAt?: ValueTypes["DateTime"] | undefined | null,
	invoices?: Array<ValueTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined | null,
	email?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingSubjects?: Array<ValueTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined | null,
	offeredProducts?: Array<ValueTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined | null,
	defaultDeliveryAddress?: ValueTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined | null,
	defaultBillingSubject?: ValueTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined | null,
	prefersPackingsWithoutCardboard?: boolean | undefined | null,
	anonymousSession?: ValueTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined | null,
	boughtVouchers?: Array<ValueTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined | null,
	ownsVouchers?: Array<ValueTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined | null,
	redeemedVouchers?: Array<ValueTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined | null,
	spending?: ValueTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined | null,
	customerTabs?: Array<ValueTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined | null,
	lead?: Array<ValueTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	meta?: ValueTypes["CustomerUpdateMetaEntityRelationInput"] | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InvoicingPlanUpsertCustomerRelationInput"]: {
	update?: ValueTypes["CustomerWithoutInvoicingPlanUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerWithoutInvoicingPlanCreateInput"] | undefined | null
};
	["ProductPackingLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	shortName?: string | undefined | null,
	description?: string | undefined | null,
	root?: ValueTypes["ProductPackingLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["ProductPackingLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductPackingLocaleUpdateInput"]: {
	name?: string | undefined | null,
	shortName?: string | undefined | null,
	description?: string | undefined | null,
	root?: ValueTypes["ProductPackingLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["ProductPackingLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	description?: string | undefined | null,
	root?: ValueTypes["ProductLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["ProductLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	featureList?: ValueTypes["ProductLocaleCreateFeatureListEntityRelationInput"] | undefined | null,
	printableName?: string | undefined | null,
	firstSticker?: string | undefined | null,
	secondSticker?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductLocaleUpdateInput"]: {
	name?: string | undefined | null,
	description?: string | undefined | null,
	root?: ValueTypes["ProductLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["ProductLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	featureList?: ValueTypes["ProductLocaleUpdateFeatureListEntityRelationInput"] | undefined | null,
	printableName?: string | undefined | null,
	firstSticker?: string | undefined | null,
	secondSticker?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductRecipeLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	root?: ValueTypes["ProductRecipeLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["ProductRecipeLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductRecipeLocaleUpdateInput"]: {
	name?: string | undefined | null,
	root?: ValueTypes["ProductRecipeLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["ProductRecipeLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	description?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserDeviceCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	lastActiveAt?: ValueTypes["DateTime"] | undefined | null,
	platform?: string | undefined | null,
	deviceId?: string | undefined | null,
	notificationsEnabled?: boolean | undefined | null,
	user?: ValueTypes["UserDeviceCreateUserEntityRelationInput"] | undefined | null,
	appVersion?: string | undefined | null,
	osVersion?: string | undefined | null,
	apiVersion?: string | undefined | null,
	anonymousSession?: ValueTypes["UserDeviceCreateAnonymousSessionEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UserDeviceUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	lastActiveAt?: ValueTypes["DateTime"] | undefined | null,
	platform?: string | undefined | null,
	deviceId?: string | undefined | null,
	notificationsEnabled?: boolean | undefined | null,
	user?: ValueTypes["UserDeviceUpdateUserEntityRelationInput"] | undefined | null,
	appVersion?: string | undefined | null,
	osVersion?: string | undefined | null,
	apiVersion?: string | undefined | null,
	anonymousSession?: ValueTypes["UserDeviceUpdateAnonymousSessionEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProtectedAction"]: AliasType<{
	_meta?:ValueTypes["ProtectedActionMeta"],
	id?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	data?:boolean | `@${string}`,
	publicKey?:boolean | `@${string}`,
	secretKeyHash?:boolean | `@${string}`,
	confirmKeyHash?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	expiresAt?:boolean | `@${string}`,
	usedAt?:boolean | `@${string}`,
	service?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProtectedActionMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	data?:ValueTypes["FieldMeta"],
	publicKey?:ValueTypes["FieldMeta"],
	secretKeyHash?:ValueTypes["FieldMeta"],
	confirmKeyHash?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	expiresAt?:ValueTypes["FieldMeta"],
	usedAt?:ValueTypes["FieldMeta"],
	service?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ProtectedActionType"]:ProtectedActionType;
	["ProtectedActionUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	publicKey?: string | undefined | null
};
	["ProtectedActionWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	type?: ValueTypes["ProtectedActionTypeCondition"] | undefined | null,
	data?: ValueTypes["JsonCondition"] | undefined | null,
	publicKey?: ValueTypes["StringCondition"] | undefined | null,
	secretKeyHash?: ValueTypes["StringCondition"] | undefined | null,
	confirmKeyHash?: ValueTypes["StringCondition"] | undefined | null,
	url?: ValueTypes["StringCondition"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	expiresAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	usedAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	service?: ValueTypes["StringCondition"] | undefined | null,
	and?: Array<ValueTypes["ProtectedActionWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ProtectedActionWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ProtectedActionWhere"] | undefined | null
};
	["ProtectedActionTypeCondition"]: {
	and?: Array<ValueTypes["ProtectedActionTypeCondition"]> | undefined | null,
	or?: Array<ValueTypes["ProtectedActionTypeCondition"]> | undefined | null,
	not?: ValueTypes["ProtectedActionTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["ProtectedActionType"] | undefined | null,
	notEq?: ValueTypes["ProtectedActionType"] | undefined | null,
	in?: Array<ValueTypes["ProtectedActionType"]> | undefined | null,
	notIn?: Array<ValueTypes["ProtectedActionType"]> | undefined | null,
	lt?: ValueTypes["ProtectedActionType"] | undefined | null,
	lte?: ValueTypes["ProtectedActionType"] | undefined | null,
	gt?: ValueTypes["ProtectedActionType"] | undefined | null,
	gte?: ValueTypes["ProtectedActionType"] | undefined | null
};
	["ProtectedActionOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	type?: ValueTypes["OrderDirection"] | undefined | null,
	data?: ValueTypes["OrderDirection"] | undefined | null,
	publicKey?: ValueTypes["OrderDirection"] | undefined | null,
	secretKeyHash?: ValueTypes["OrderDirection"] | undefined | null,
	confirmKeyHash?: ValueTypes["OrderDirection"] | undefined | null,
	url?: ValueTypes["OrderDirection"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null,
	expiresAt?: ValueTypes["OrderDirection"] | undefined | null,
	usedAt?: ValueTypes["OrderDirection"] | undefined | null,
	service?: ValueTypes["OrderDirection"] | undefined | null
};
	["ProtectedActionConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProtectedActionEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProtectedActionEdge"]: AliasType<{
	node?:ValueTypes["ProtectedAction"],
		__typename?: boolean | `@${string}`
}>;
	["ProtectedActionCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	type?: ValueTypes["ProtectedActionType"] | undefined | null,
	data?: ValueTypes["Json"] | undefined | null,
	publicKey?: string | undefined | null,
	secretKeyHash?: string | undefined | null,
	confirmKeyHash?: string | undefined | null,
	url?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	expiresAt?: ValueTypes["DateTime"] | undefined | null,
	usedAt?: ValueTypes["DateTime"] | undefined | null,
	service?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProtectedActionUpdateInput"]: {
	type?: ValueTypes["ProtectedActionType"] | undefined | null,
	data?: ValueTypes["Json"] | undefined | null,
	publicKey?: string | undefined | null,
	secretKeyHash?: string | undefined | null,
	confirmKeyHash?: string | undefined | null,
	url?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	expiresAt?: ValueTypes["DateTime"] | undefined | null,
	usedAt?: ValueTypes["DateTime"] | undefined | null,
	service?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PickerConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PickerEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PickerEdge"]: AliasType<{
	node?:ValueTypes["Picker"],
		__typename?: boolean | `@${string}`
}>;
	["PickerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	staff?: ValueTypes["PickerCreateStaffEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PickerCreateStaffEntityRelationInput"]: {
	connect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	create?: ValueTypes["StaffWithoutPickerCreateInput"] | undefined | null
};
	["StaffWithoutPickerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	bartender?: ValueTypes["StaffCreateBartenderEntityRelationInput"] | undefined | null,
	courier?: ValueTypes["StaffCreateCourierEntityRelationInput"] | undefined | null,
	cleaner?: ValueTypes["StaffCreateCleanerEntityRelationInput"] | undefined | null,
	shiftsManager?: ValueTypes["StaffCreateShiftsManagerEntityRelationInput"] | undefined | null,
	businessToBusinessManager?: ValueTypes["StaffCreateBusinessToBusinessManagerEntityRelationInput"] | undefined | null,
	user?: ValueTypes["StaffCreateUserEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["StaffCreateShiftsProfileEntityRelationInput"] | undefined | null,
	stocksManager?: ValueTypes["StaffCreateStocksManagerEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["StaffCreatePhotoEntityRelationInput"] | undefined | null,
	courierManager?: ValueTypes["StaffCreateCourierManagerEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	remunerationProfile?: ValueTypes["StaffCreateRemunerationProfileEntityRelationInput"] | undefined | null,
	cashier?: ValueTypes["StaffCreateCashierEntityRelationInput"] | undefined | null,
	venues?: Array<ValueTypes["StaffCreateVenuesEntityRelationInput"]> | undefined | null,
	internalBuyer?: ValueTypes["StaffCreateInternalBuyerEntityRelationInput"] | undefined | null,
	salesManager?: ValueTypes["StaffCreateSalesManagerEntityRelationInput"] | undefined | null,
	cashierManager?: ValueTypes["StaffCreateCashierManagerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PickerUpdateInput"]: {
	staff?: ValueTypes["PickerUpdateStaffEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PickerUpdateStaffEntityRelationInput"]: {
	create?: ValueTypes["StaffWithoutPickerCreateInput"] | undefined | null,
	update?: ValueTypes["StaffWithoutPickerUpdateInput"] | undefined | null,
	upsert?: ValueTypes["PickerUpsertStaffRelationInput"] | undefined | null,
	connect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["StaffWithoutPickerUpdateInput"]: {
	bartender?: ValueTypes["StaffUpdateBartenderEntityRelationInput"] | undefined | null,
	courier?: ValueTypes["StaffUpdateCourierEntityRelationInput"] | undefined | null,
	cleaner?: ValueTypes["StaffUpdateCleanerEntityRelationInput"] | undefined | null,
	shiftsManager?: ValueTypes["StaffUpdateShiftsManagerEntityRelationInput"] | undefined | null,
	businessToBusinessManager?: ValueTypes["StaffUpdateBusinessToBusinessManagerEntityRelationInput"] | undefined | null,
	user?: ValueTypes["StaffUpdateUserEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["StaffUpdateShiftsProfileEntityRelationInput"] | undefined | null,
	stocksManager?: ValueTypes["StaffUpdateStocksManagerEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["StaffUpdatePhotoEntityRelationInput"] | undefined | null,
	courierManager?: ValueTypes["StaffUpdateCourierManagerEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	remunerationProfile?: ValueTypes["StaffUpdateRemunerationProfileEntityRelationInput"] | undefined | null,
	cashier?: ValueTypes["StaffUpdateCashierEntityRelationInput"] | undefined | null,
	venues?: Array<ValueTypes["StaffUpdateVenuesEntityRelationInput"]> | undefined | null,
	internalBuyer?: ValueTypes["StaffUpdateInternalBuyerEntityRelationInput"] | undefined | null,
	salesManager?: ValueTypes["StaffUpdateSalesManagerEntityRelationInput"] | undefined | null,
	cashierManager?: ValueTypes["StaffUpdateCashierManagerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PickerUpsertStaffRelationInput"]: {
	update?: ValueTypes["StaffWithoutPickerUpdateInput"] | undefined | null,
	create?: ValueTypes["StaffWithoutPickerCreateInput"] | undefined | null
};
	["TenantPerson"]: AliasType<{
	_meta?:ValueTypes["TenantPersonMeta"],
	id?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	externalIdentifier?:boolean | `@${string}`,
	personId?:boolean | `@${string}`,
	identityId?:boolean | `@${string}`,
	globalRoles?:boolean | `@${string}`,
	projectRoles?:boolean | `@${string}`,
	projectRolesString?:boolean | `@${string}`,
	externalIdentifiers?:boolean | `@${string}`,
	externalIdentifiersString?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["TenantPersonMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	email?:ValueTypes["FieldMeta"],
	externalIdentifier?:ValueTypes["FieldMeta"],
	personId?:ValueTypes["FieldMeta"],
	identityId?:ValueTypes["FieldMeta"],
	globalRoles?:ValueTypes["FieldMeta"],
	projectRoles?:ValueTypes["FieldMeta"],
	projectRolesString?:ValueTypes["FieldMeta"],
	externalIdentifiers?:ValueTypes["FieldMeta"],
	externalIdentifiersString?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["TenantPersonUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["TenantPersonWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	email?: ValueTypes["StringCondition"] | undefined | null,
	externalIdentifier?: ValueTypes["StringCondition"] | undefined | null,
	personId?: ValueTypes["UUIDCondition"] | undefined | null,
	identityId?: ValueTypes["UUIDCondition"] | undefined | null,
	globalRoles?: ValueTypes["JsonCondition"] | undefined | null,
	projectRoles?: ValueTypes["JsonCondition"] | undefined | null,
	projectRolesString?: ValueTypes["StringCondition"] | undefined | null,
	externalIdentifiers?: ValueTypes["JsonCondition"] | undefined | null,
	externalIdentifiersString?: ValueTypes["StringCondition"] | undefined | null,
	and?: Array<ValueTypes["TenantPersonWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["TenantPersonWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["TenantPersonWhere"] | undefined | null
};
	["TenantPersonOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	email?: ValueTypes["OrderDirection"] | undefined | null,
	externalIdentifier?: ValueTypes["OrderDirection"] | undefined | null,
	personId?: ValueTypes["OrderDirection"] | undefined | null,
	identityId?: ValueTypes["OrderDirection"] | undefined | null,
	globalRoles?: ValueTypes["OrderDirection"] | undefined | null,
	projectRoles?: ValueTypes["OrderDirection"] | undefined | null,
	projectRolesString?: ValueTypes["OrderDirection"] | undefined | null,
	externalIdentifiers?: ValueTypes["OrderDirection"] | undefined | null,
	externalIdentifiersString?: ValueTypes["OrderDirection"] | undefined | null
};
	["TenantPersonConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TenantPersonEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TenantPersonEdge"]: AliasType<{
	node?:ValueTypes["TenantPerson"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableTemplateStaffOptionsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	startTime?: string | undefined | null,
	endTime?: string | undefined | null,
	timetableTemplate?: ValueTypes["TimetableTemplateStaffOptionsCreateTimetableTemplateEntityRelationInput"] | undefined | null,
	autoAssignedEmployee?: ValueTypes["TimetableTemplateStaffOptionsCreateAutoAssignedEmployeeEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableTemplateStaffOptionsCreateTimetableTemplateEntityRelationInput"]: {
	connect?: ValueTypes["TimetableTemplateUniqueWhere"] | undefined | null,
	create?: ValueTypes["TimetableTemplateWithoutStaffOptionsCreateInput"] | undefined | null
};
	["TimetableTemplateWithoutStaffOptionsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	startDate?: ValueTypes["Date"] | undefined | null,
	period?: number | undefined | null,
	slots?: number | undefined | null,
	position?: ValueTypes["TimetableTemplateCreatePositionEntityRelationInput"] | undefined | null,
	internalName?: string | undefined | null,
	venue?: ValueTypes["TimetableTemplateCreateVenueEntityRelationInput"] | undefined | null,
	employeeRole?: ValueTypes["TimetableTemplateCreateEmployeeRoleEntityRelationInput"] | undefined | null,
	workdaysOnly?: boolean | undefined | null,
	monday?: boolean | undefined | null,
	tuesday?: boolean | undefined | null,
	wednesday?: boolean | undefined | null,
	thursday?: boolean | undefined | null,
	friday?: boolean | undefined | null,
	saturday?: boolean | undefined | null,
	sunday?: boolean | undefined | null,
	type?: ValueTypes["TemplateType"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableTemplateStaffOptionsUpdateInput"]: {
	startTime?: string | undefined | null,
	endTime?: string | undefined | null,
	timetableTemplate?: ValueTypes["TimetableTemplateStaffOptionsUpdateTimetableTemplateEntityRelationInput"] | undefined | null,
	autoAssignedEmployee?: ValueTypes["TimetableTemplateStaffOptionsUpdateAutoAssignedEmployeeEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableTemplateStaffOptionsUpdateTimetableTemplateEntityRelationInput"]: {
	create?: ValueTypes["TimetableTemplateWithoutStaffOptionsCreateInput"] | undefined | null,
	update?: ValueTypes["TimetableTemplateWithoutStaffOptionsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["TimetableTemplateStaffOptionsUpsertTimetableTemplateRelationInput"] | undefined | null,
	connect?: ValueTypes["TimetableTemplateUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["TimetableTemplateWithoutStaffOptionsUpdateInput"]: {
	order?: number | undefined | null,
	startDate?: ValueTypes["Date"] | undefined | null,
	period?: number | undefined | null,
	slots?: number | undefined | null,
	position?: ValueTypes["TimetableTemplateUpdatePositionEntityRelationInput"] | undefined | null,
	internalName?: string | undefined | null,
	venue?: ValueTypes["TimetableTemplateUpdateVenueEntityRelationInput"] | undefined | null,
	employeeRole?: ValueTypes["TimetableTemplateUpdateEmployeeRoleEntityRelationInput"] | undefined | null,
	workdaysOnly?: boolean | undefined | null,
	monday?: boolean | undefined | null,
	tuesday?: boolean | undefined | null,
	wednesday?: boolean | undefined | null,
	thursday?: boolean | undefined | null,
	friday?: boolean | undefined | null,
	saturday?: boolean | undefined | null,
	sunday?: boolean | undefined | null,
	type?: ValueTypes["TemplateType"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableTemplateStaffOptionsUpsertTimetableTemplateRelationInput"]: {
	update?: ValueTypes["TimetableTemplateWithoutStaffOptionsUpdateInput"] | undefined | null,
	create?: ValueTypes["TimetableTemplateWithoutStaffOptionsCreateInput"] | undefined | null
};
	["ShoppingList"]: AliasType<{
	_meta?:ValueTypes["ShoppingListMeta"],
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["ShoppingListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ShoppingListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ShoppingListItem"]],
supplier?: [{	filter?: ValueTypes["IngredientSupplierWhere"] | undefined | null},ValueTypes["IngredientSupplier"]],
paginateItems?: [{	filter?: ValueTypes["ShoppingListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ShoppingListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ShoppingListItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ShoppingListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
	supplier?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ShoppingListItem"]: AliasType<{
	_meta?:ValueTypes["ShoppingListItemMeta"],
	id?:boolean | `@${string}`,
	amount?:boolean | `@${string}`,
list?: [{	filter?: ValueTypes["ShoppingListWhere"] | undefined | null},ValueTypes["ShoppingList"]],
ingredient?: [{	filter?: ValueTypes["ProductIngredientWhere"] | undefined | null},ValueTypes["ProductIngredient"]],
preferredUnit?: [{	filter?: ValueTypes["ProductIngredientItemQuantityUnitWhere"] | undefined | null},ValueTypes["ProductIngredientItemQuantityUnit"]],
	wasPurcahsed?:boolean | `@${string}`,
	wasTransferred?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ShoppingListItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	amount?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	ingredient?:ValueTypes["FieldMeta"],
	preferredUnit?:ValueTypes["FieldMeta"],
	wasPurcahsed?:ValueTypes["FieldMeta"],
	wasTransferred?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ShoppingListWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	items?: ValueTypes["ShoppingListItemWhere"] | undefined | null,
	supplier?: ValueTypes["IngredientSupplierWhere"] | undefined | null,
	and?: Array<ValueTypes["ShoppingListWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ShoppingListWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ShoppingListWhere"] | undefined | null
};
	["ShoppingListItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	amount?: ValueTypes["IntCondition"] | undefined | null,
	list?: ValueTypes["ShoppingListWhere"] | undefined | null,
	ingredient?: ValueTypes["ProductIngredientWhere"] | undefined | null,
	preferredUnit?: ValueTypes["ProductIngredientItemQuantityUnitWhere"] | undefined | null,
	wasPurcahsed?: ValueTypes["BooleanCondition"] | undefined | null,
	wasTransferred?: ValueTypes["BooleanCondition"] | undefined | null,
	and?: Array<ValueTypes["ShoppingListItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ShoppingListItemWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ShoppingListItemWhere"] | undefined | null
};
	["ShoppingListItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	amount?: ValueTypes["OrderDirection"] | undefined | null,
	list?: ValueTypes["ShoppingListOrderBy"] | undefined | null,
	ingredient?: ValueTypes["ProductIngredientOrderBy"] | undefined | null,
	preferredUnit?: ValueTypes["ProductIngredientItemQuantityUnitOrderBy"] | undefined | null,
	wasPurcahsed?: ValueTypes["OrderDirection"] | undefined | null,
	wasTransferred?: ValueTypes["OrderDirection"] | undefined | null
};
	["ShoppingListOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null,
	supplier?: ValueTypes["IngredientSupplierOrderBy"] | undefined | null
};
	["ShoppingListItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ShoppingListItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ShoppingListItemEdge"]: AliasType<{
	node?:ValueTypes["ShoppingListItem"],
		__typename?: boolean | `@${string}`
}>;
	["ShoppingListUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	supplier?: ValueTypes["IngredientSupplierUniqueWhere"] | undefined | null,
	items?: ValueTypes["ShoppingListItemUniqueWhere"] | undefined | null
};
	["ShoppingListItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["ShoppingListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ShoppingListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ShoppingListEdge"]: AliasType<{
	node?:ValueTypes["ShoppingList"],
		__typename?: boolean | `@${string}`
}>;
	["ShoppingListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	items?: Array<ValueTypes["ShoppingListCreateItemsEntityRelationInput"]> | undefined | null,
	supplier?: ValueTypes["ShoppingListCreateSupplierEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ShoppingListCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["ShoppingListItemUniqueWhere"] | undefined | null,
	create?: ValueTypes["ShoppingListItemWithoutListCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ShoppingListItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	amount?: number | undefined | null,
	ingredient?: ValueTypes["ShoppingListItemCreateIngredientEntityRelationInput"] | undefined | null,
	preferredUnit?: ValueTypes["ShoppingListItemCreatePreferredUnitEntityRelationInput"] | undefined | null,
	wasPurcahsed?: boolean | undefined | null,
	wasTransferred?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ShoppingListItemCreateIngredientEntityRelationInput"]: {
	connect?: ValueTypes["ProductIngredientUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductIngredientCreateInput"] | undefined | null
};
	["ShoppingListItemCreatePreferredUnitEntityRelationInput"]: {
	connect?: ValueTypes["ProductIngredientItemQuantityUnitUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductIngredientItemQuantityUnitCreateInput"] | undefined | null
};
	["ShoppingListCreateSupplierEntityRelationInput"]: {
	connect?: ValueTypes["IngredientSupplierUniqueWhere"] | undefined | null,
	create?: ValueTypes["IngredientSupplierCreateInput"] | undefined | null
};
	["ShoppingListUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	items?: Array<ValueTypes["ShoppingListUpdateItemsEntityRelationInput"]> | undefined | null,
	supplier?: ValueTypes["ShoppingListUpdateSupplierEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ShoppingListUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["ShoppingListItemWithoutListCreateInput"] | undefined | null,
	update?: ValueTypes["ShoppingListUpdateItemsRelationInput"] | undefined | null,
	upsert?: ValueTypes["ShoppingListUpsertItemsRelationInput"] | undefined | null,
	connect?: ValueTypes["ShoppingListItemUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ShoppingListItemUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ShoppingListItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ShoppingListUpdateItemsRelationInput"]: {
	by?: ValueTypes["ShoppingListItemUniqueWhere"] | undefined | null,
	data?: ValueTypes["ShoppingListItemWithoutListUpdateInput"] | undefined | null
};
	["ShoppingListItemWithoutListUpdateInput"]: {
	amount?: number | undefined | null,
	ingredient?: ValueTypes["ShoppingListItemUpdateIngredientEntityRelationInput"] | undefined | null,
	preferredUnit?: ValueTypes["ShoppingListItemUpdatePreferredUnitEntityRelationInput"] | undefined | null,
	wasPurcahsed?: boolean | undefined | null,
	wasTransferred?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ShoppingListItemUpdateIngredientEntityRelationInput"]: {
	create?: ValueTypes["ProductIngredientCreateInput"] | undefined | null,
	update?: ValueTypes["ProductIngredientUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ShoppingListItemUpsertIngredientRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductIngredientUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["ShoppingListItemUpsertIngredientRelationInput"]: {
	update?: ValueTypes["ProductIngredientUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductIngredientCreateInput"] | undefined | null
};
	["ShoppingListItemUpdatePreferredUnitEntityRelationInput"]: {
	create?: ValueTypes["ProductIngredientItemQuantityUnitCreateInput"] | undefined | null,
	update?: ValueTypes["ProductIngredientItemQuantityUnitUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ShoppingListItemUpsertPreferredUnitRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductIngredientItemQuantityUnitUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ShoppingListItemUpsertPreferredUnitRelationInput"]: {
	update?: ValueTypes["ProductIngredientItemQuantityUnitUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductIngredientItemQuantityUnitCreateInput"] | undefined | null
};
	["ShoppingListUpsertItemsRelationInput"]: {
	by?: ValueTypes["ShoppingListItemUniqueWhere"] | undefined | null,
	update?: ValueTypes["ShoppingListItemWithoutListUpdateInput"] | undefined | null,
	create?: ValueTypes["ShoppingListItemWithoutListCreateInput"] | undefined | null
};
	["ShoppingListUpdateSupplierEntityRelationInput"]: {
	create?: ValueTypes["IngredientSupplierCreateInput"] | undefined | null,
	update?: ValueTypes["IngredientSupplierUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ShoppingListUpsertSupplierRelationInput"] | undefined | null,
	connect?: ValueTypes["IngredientSupplierUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["ShoppingListUpsertSupplierRelationInput"]: {
	update?: ValueTypes["IngredientSupplierUpdateInput"] | undefined | null,
	create?: ValueTypes["IngredientSupplierCreateInput"] | undefined | null
};
	["SuppliesPurchase"]: AliasType<{
	_meta?:ValueTypes["SuppliesPurchaseMeta"],
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["SuppliesPurchaseItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SuppliesPurchaseItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["SuppliesPurchaseItem"]],
supplier?: [{	filter?: ValueTypes["IngredientSupplierWhere"] | undefined | null},ValueTypes["IngredientSupplier"]],
	requestedDeliveryDate?:boolean | `@${string}`,
paginateItems?: [{	filter?: ValueTypes["SuppliesPurchaseItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SuppliesPurchaseItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["SuppliesPurchaseItemConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["SuppliesPurchaseMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
	supplier?:ValueTypes["FieldMeta"],
	requestedDeliveryDate?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["SuppliesPurchaseItem"]: AliasType<{
	_meta?:ValueTypes["SuppliesPurchaseItemMeta"],
	id?:boolean | `@${string}`,
	amount?:boolean | `@${string}`,
list?: [{	filter?: ValueTypes["SuppliesPurchaseWhere"] | undefined | null},ValueTypes["SuppliesPurchase"]],
ingredient?: [{	filter?: ValueTypes["ProductIngredientWhere"] | undefined | null},ValueTypes["ProductIngredient"]],
	pricePaidCents?:boolean | `@${string}`,
preferredUnit?: [{	filter?: ValueTypes["ProductIngredientItemQuantityUnitWhere"] | undefined | null},ValueTypes["ProductIngredientItemQuantityUnit"]],
	deletedAt?:boolean | `@${string}`,
	purchasedAt?:boolean | `@${string}`,
purchasedBy?: [{	filter?: ValueTypes["StaffWhere"] | undefined | null},ValueTypes["Staff"]],
		__typename?: boolean | `@${string}`
}>;
	["SuppliesPurchaseItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	amount?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	ingredient?:ValueTypes["FieldMeta"],
	pricePaidCents?:ValueTypes["FieldMeta"],
	preferredUnit?:ValueTypes["FieldMeta"],
	deletedAt?:ValueTypes["FieldMeta"],
	purchasedAt?:ValueTypes["FieldMeta"],
	purchasedBy?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["SuppliesPurchaseWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	items?: ValueTypes["SuppliesPurchaseItemWhere"] | undefined | null,
	supplier?: ValueTypes["IngredientSupplierWhere"] | undefined | null,
	requestedDeliveryDate?: ValueTypes["DateCondition"] | undefined | null,
	and?: Array<ValueTypes["SuppliesPurchaseWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["SuppliesPurchaseWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["SuppliesPurchaseWhere"] | undefined | null
};
	["SuppliesPurchaseItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	amount?: ValueTypes["IntCondition"] | undefined | null,
	list?: ValueTypes["SuppliesPurchaseWhere"] | undefined | null,
	ingredient?: ValueTypes["ProductIngredientWhere"] | undefined | null,
	pricePaidCents?: ValueTypes["IntCondition"] | undefined | null,
	preferredUnit?: ValueTypes["ProductIngredientItemQuantityUnitWhere"] | undefined | null,
	deletedAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	purchasedAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	purchasedBy?: ValueTypes["StaffWhere"] | undefined | null,
	and?: Array<ValueTypes["SuppliesPurchaseItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["SuppliesPurchaseItemWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["SuppliesPurchaseItemWhere"] | undefined | null
};
	["SuppliesPurchaseItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	amount?: ValueTypes["OrderDirection"] | undefined | null,
	list?: ValueTypes["SuppliesPurchaseOrderBy"] | undefined | null,
	ingredient?: ValueTypes["ProductIngredientOrderBy"] | undefined | null,
	pricePaidCents?: ValueTypes["OrderDirection"] | undefined | null,
	preferredUnit?: ValueTypes["ProductIngredientItemQuantityUnitOrderBy"] | undefined | null,
	deletedAt?: ValueTypes["OrderDirection"] | undefined | null,
	purchasedAt?: ValueTypes["OrderDirection"] | undefined | null,
	purchasedBy?: ValueTypes["StaffOrderBy"] | undefined | null
};
	["SuppliesPurchaseOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null,
	supplier?: ValueTypes["IngredientSupplierOrderBy"] | undefined | null,
	requestedDeliveryDate?: ValueTypes["OrderDirection"] | undefined | null
};
	["SuppliesPurchaseItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SuppliesPurchaseItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["SuppliesPurchaseItemEdge"]: AliasType<{
	node?:ValueTypes["SuppliesPurchaseItem"],
		__typename?: boolean | `@${string}`
}>;
	["SuppliesPurchaseUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	supplier?: ValueTypes["IngredientSupplierUniqueWhere"] | undefined | null,
	items?: ValueTypes["SuppliesPurchaseItemUniqueWhere"] | undefined | null
};
	["SuppliesPurchaseItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["SuppliesPurchaseConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SuppliesPurchaseEdge"],
		__typename?: boolean | `@${string}`
}>;
	["SuppliesPurchaseEdge"]: AliasType<{
	node?:ValueTypes["SuppliesPurchase"],
		__typename?: boolean | `@${string}`
}>;
	["SuppliesPurchaseCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	items?: Array<ValueTypes["SuppliesPurchaseCreateItemsEntityRelationInput"]> | undefined | null,
	supplier?: ValueTypes["SuppliesPurchaseCreateSupplierEntityRelationInput"] | undefined | null,
	requestedDeliveryDate?: ValueTypes["Date"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SuppliesPurchaseCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["SuppliesPurchaseItemUniqueWhere"] | undefined | null,
	create?: ValueTypes["SuppliesPurchaseItemWithoutListCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["SuppliesPurchaseItemWithoutListCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	amount?: number | undefined | null,
	ingredient?: ValueTypes["SuppliesPurchaseItemCreateIngredientEntityRelationInput"] | undefined | null,
	pricePaidCents?: number | undefined | null,
	preferredUnit?: ValueTypes["SuppliesPurchaseItemCreatePreferredUnitEntityRelationInput"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	purchasedAt?: ValueTypes["DateTime"] | undefined | null,
	purchasedBy?: ValueTypes["SuppliesPurchaseItemCreatePurchasedByEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SuppliesPurchaseItemCreateIngredientEntityRelationInput"]: {
	connect?: ValueTypes["ProductIngredientUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductIngredientCreateInput"] | undefined | null
};
	["SuppliesPurchaseItemCreatePreferredUnitEntityRelationInput"]: {
	connect?: ValueTypes["ProductIngredientItemQuantityUnitUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductIngredientItemQuantityUnitCreateInput"] | undefined | null
};
	["SuppliesPurchaseItemCreatePurchasedByEntityRelationInput"]: {
	connect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	create?: ValueTypes["StaffCreateInput"] | undefined | null
};
	["SuppliesPurchaseCreateSupplierEntityRelationInput"]: {
	connect?: ValueTypes["IngredientSupplierUniqueWhere"] | undefined | null,
	create?: ValueTypes["IngredientSupplierCreateInput"] | undefined | null
};
	["SuppliesPurchaseUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	items?: Array<ValueTypes["SuppliesPurchaseUpdateItemsEntityRelationInput"]> | undefined | null,
	supplier?: ValueTypes["SuppliesPurchaseUpdateSupplierEntityRelationInput"] | undefined | null,
	requestedDeliveryDate?: ValueTypes["Date"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SuppliesPurchaseUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["SuppliesPurchaseItemWithoutListCreateInput"] | undefined | null,
	update?: ValueTypes["SuppliesPurchaseUpdateItemsRelationInput"] | undefined | null,
	upsert?: ValueTypes["SuppliesPurchaseUpsertItemsRelationInput"] | undefined | null,
	connect?: ValueTypes["SuppliesPurchaseItemUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["SuppliesPurchaseItemUniqueWhere"] | undefined | null,
	delete?: ValueTypes["SuppliesPurchaseItemUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["SuppliesPurchaseUpdateItemsRelationInput"]: {
	by?: ValueTypes["SuppliesPurchaseItemUniqueWhere"] | undefined | null,
	data?: ValueTypes["SuppliesPurchaseItemWithoutListUpdateInput"] | undefined | null
};
	["SuppliesPurchaseItemWithoutListUpdateInput"]: {
	amount?: number | undefined | null,
	ingredient?: ValueTypes["SuppliesPurchaseItemUpdateIngredientEntityRelationInput"] | undefined | null,
	pricePaidCents?: number | undefined | null,
	preferredUnit?: ValueTypes["SuppliesPurchaseItemUpdatePreferredUnitEntityRelationInput"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	purchasedAt?: ValueTypes["DateTime"] | undefined | null,
	purchasedBy?: ValueTypes["SuppliesPurchaseItemUpdatePurchasedByEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SuppliesPurchaseItemUpdateIngredientEntityRelationInput"]: {
	create?: ValueTypes["ProductIngredientCreateInput"] | undefined | null,
	update?: ValueTypes["ProductIngredientUpdateInput"] | undefined | null,
	upsert?: ValueTypes["SuppliesPurchaseItemUpsertIngredientRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductIngredientUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["SuppliesPurchaseItemUpsertIngredientRelationInput"]: {
	update?: ValueTypes["ProductIngredientUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductIngredientCreateInput"] | undefined | null
};
	["SuppliesPurchaseItemUpdatePreferredUnitEntityRelationInput"]: {
	create?: ValueTypes["ProductIngredientItemQuantityUnitCreateInput"] | undefined | null,
	update?: ValueTypes["ProductIngredientItemQuantityUnitUpdateInput"] | undefined | null,
	upsert?: ValueTypes["SuppliesPurchaseItemUpsertPreferredUnitRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductIngredientItemQuantityUnitUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["SuppliesPurchaseItemUpsertPreferredUnitRelationInput"]: {
	update?: ValueTypes["ProductIngredientItemQuantityUnitUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductIngredientItemQuantityUnitCreateInput"] | undefined | null
};
	["SuppliesPurchaseItemUpdatePurchasedByEntityRelationInput"]: {
	create?: ValueTypes["StaffCreateInput"] | undefined | null,
	update?: ValueTypes["StaffUpdateInput"] | undefined | null,
	upsert?: ValueTypes["SuppliesPurchaseItemUpsertPurchasedByRelationInput"] | undefined | null,
	connect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["SuppliesPurchaseItemUpsertPurchasedByRelationInput"]: {
	update?: ValueTypes["StaffUpdateInput"] | undefined | null,
	create?: ValueTypes["StaffCreateInput"] | undefined | null
};
	["SuppliesPurchaseUpsertItemsRelationInput"]: {
	by?: ValueTypes["SuppliesPurchaseItemUniqueWhere"] | undefined | null,
	update?: ValueTypes["SuppliesPurchaseItemWithoutListUpdateInput"] | undefined | null,
	create?: ValueTypes["SuppliesPurchaseItemWithoutListCreateInput"] | undefined | null
};
	["SuppliesPurchaseUpdateSupplierEntityRelationInput"]: {
	create?: ValueTypes["IngredientSupplierCreateInput"] | undefined | null,
	update?: ValueTypes["IngredientSupplierUpdateInput"] | undefined | null,
	upsert?: ValueTypes["SuppliesPurchaseUpsertSupplierRelationInput"] | undefined | null,
	connect?: ValueTypes["IngredientSupplierUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["SuppliesPurchaseUpsertSupplierRelationInput"]: {
	update?: ValueTypes["IngredientSupplierUpdateInput"] | undefined | null,
	create?: ValueTypes["IngredientSupplierCreateInput"] | undefined | null
};
	["InvoicingPresetConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["InvoicingPresetEdge"],
		__typename?: boolean | `@${string}`
}>;
	["InvoicingPresetEdge"]: AliasType<{
	node?:ValueTypes["InvoicingPreset"],
		__typename?: boolean | `@${string}`
}>;
	["InvoicingPresetCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	type?: ValueTypes["InvoicingPresetType"] | undefined | null,
	startsAt?: ValueTypes["DateTime"] | undefined | null,
	endsAt?: ValueTypes["DateTime"] | undefined | null,
	intervalOfDays?: number | undefined | null,
	invoicingPlan?: ValueTypes["InvoicingPresetCreateInvoicingPlanEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InvoicingPresetCreateInvoicingPlanEntityRelationInput"]: {
	connect?: ValueTypes["InvoicingPlanUniqueWhere"] | undefined | null,
	create?: ValueTypes["InvoicingPlanWithoutPresetCreateInput"] | undefined | null
};
	["InvoicingPlanWithoutPresetCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	customer?: ValueTypes["InvoicingPlanCreateCustomerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InvoicingPresetUpdateInput"]: {
	type?: ValueTypes["InvoicingPresetType"] | undefined | null,
	startsAt?: ValueTypes["DateTime"] | undefined | null,
	endsAt?: ValueTypes["DateTime"] | undefined | null,
	intervalOfDays?: number | undefined | null,
	invoicingPlan?: ValueTypes["InvoicingPresetUpdateInvoicingPlanEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InvoicingPresetUpdateInvoicingPlanEntityRelationInput"]: {
	create?: ValueTypes["InvoicingPlanWithoutPresetCreateInput"] | undefined | null,
	update?: ValueTypes["InvoicingPlanWithoutPresetUpdateInput"] | undefined | null,
	upsert?: ValueTypes["InvoicingPresetUpsertInvoicingPlanRelationInput"] | undefined | null,
	connect?: ValueTypes["InvoicingPlanUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["InvoicingPlanWithoutPresetUpdateInput"]: {
	customer?: ValueTypes["InvoicingPlanUpdateCustomerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InvoicingPresetUpsertInvoicingPlanRelationInput"]: {
	update?: ValueTypes["InvoicingPlanWithoutPresetUpdateInput"] | undefined | null,
	create?: ValueTypes["InvoicingPlanWithoutPresetCreateInput"] | undefined | null
};
	["LogRecord"]: AliasType<{
	_meta?:ValueTypes["LogRecordMeta"],
	id?:boolean | `@${string}`,
	level?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
	data?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	shouldBeResolved?:boolean | `@${string}`,
	resolvedAt?:boolean | `@${string}`,
resolvedBy?: [{	filter?: ValueTypes["UserWhere"] | undefined | null},ValueTypes["User"]],
		__typename?: boolean | `@${string}`
}>;
	["LogRecordMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	level?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	message?:ValueTypes["FieldMeta"],
	data?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	shouldBeResolved?:ValueTypes["FieldMeta"],
	resolvedAt?:ValueTypes["FieldMeta"],
	resolvedBy?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["LogRecordUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["LogRecordWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	level?: ValueTypes["IntCondition"] | undefined | null,
	type?: ValueTypes["StringCondition"] | undefined | null,
	message?: ValueTypes["StringCondition"] | undefined | null,
	data?: ValueTypes["JsonCondition"] | undefined | null,
	createdAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	shouldBeResolved?: ValueTypes["BooleanCondition"] | undefined | null,
	resolvedAt?: ValueTypes["DateTimeCondition"] | undefined | null,
	resolvedBy?: ValueTypes["UserWhere"] | undefined | null,
	and?: Array<ValueTypes["LogRecordWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["LogRecordWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["LogRecordWhere"] | undefined | null
};
	["LogRecordOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	level?: ValueTypes["OrderDirection"] | undefined | null,
	type?: ValueTypes["OrderDirection"] | undefined | null,
	message?: ValueTypes["OrderDirection"] | undefined | null,
	data?: ValueTypes["OrderDirection"] | undefined | null,
	createdAt?: ValueTypes["OrderDirection"] | undefined | null,
	shouldBeResolved?: ValueTypes["OrderDirection"] | undefined | null,
	resolvedAt?: ValueTypes["OrderDirection"] | undefined | null,
	resolvedBy?: ValueTypes["UserOrderBy"] | undefined | null
};
	["LogRecordConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LogRecordEdge"],
		__typename?: boolean | `@${string}`
}>;
	["LogRecordEdge"]: AliasType<{
	node?:ValueTypes["LogRecord"],
		__typename?: boolean | `@${string}`
}>;
	["LogRecordCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	level?: number | undefined | null,
	type?: string | undefined | null,
	message?: string | undefined | null,
	data?: ValueTypes["Json"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	shouldBeResolved?: boolean | undefined | null,
	resolvedAt?: ValueTypes["DateTime"] | undefined | null,
	resolvedBy?: ValueTypes["LogRecordCreateResolvedByEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LogRecordCreateResolvedByEntityRelationInput"]: {
	connect?: ValueTypes["UserUniqueWhere"] | undefined | null,
	create?: ValueTypes["UserCreateInput"] | undefined | null
};
	["LogRecordUpdateInput"]: {
	level?: number | undefined | null,
	type?: string | undefined | null,
	message?: string | undefined | null,
	data?: ValueTypes["Json"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	shouldBeResolved?: boolean | undefined | null,
	resolvedAt?: ValueTypes["DateTime"] | undefined | null,
	resolvedBy?: ValueTypes["LogRecordUpdateResolvedByEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LogRecordUpdateResolvedByEntityRelationInput"]: {
	create?: ValueTypes["UserCreateInput"] | undefined | null,
	update?: ValueTypes["UserUpdateInput"] | undefined | null,
	upsert?: ValueTypes["LogRecordUpsertResolvedByRelationInput"] | undefined | null,
	connect?: ValueTypes["UserUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["LogRecordUpsertResolvedByRelationInput"]: {
	update?: ValueTypes["UserUpdateInput"] | undefined | null,
	create?: ValueTypes["UserCreateInput"] | undefined | null
};
	["ShoppingListItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	amount?: number | undefined | null,
	list?: ValueTypes["ShoppingListItemCreateListEntityRelationInput"] | undefined | null,
	ingredient?: ValueTypes["ShoppingListItemCreateIngredientEntityRelationInput"] | undefined | null,
	preferredUnit?: ValueTypes["ShoppingListItemCreatePreferredUnitEntityRelationInput"] | undefined | null,
	wasPurcahsed?: boolean | undefined | null,
	wasTransferred?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ShoppingListItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["ShoppingListUniqueWhere"] | undefined | null,
	create?: ValueTypes["ShoppingListWithoutItemsCreateInput"] | undefined | null
};
	["ShoppingListWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	supplier?: ValueTypes["ShoppingListCreateSupplierEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ShoppingListItemUpdateInput"]: {
	amount?: number | undefined | null,
	list?: ValueTypes["ShoppingListItemUpdateListEntityRelationInput"] | undefined | null,
	ingredient?: ValueTypes["ShoppingListItemUpdateIngredientEntityRelationInput"] | undefined | null,
	preferredUnit?: ValueTypes["ShoppingListItemUpdatePreferredUnitEntityRelationInput"] | undefined | null,
	wasPurcahsed?: boolean | undefined | null,
	wasTransferred?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ShoppingListItemUpdateListEntityRelationInput"]: {
	create?: ValueTypes["ShoppingListWithoutItemsCreateInput"] | undefined | null,
	update?: ValueTypes["ShoppingListWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ShoppingListItemUpsertListRelationInput"] | undefined | null,
	connect?: ValueTypes["ShoppingListUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["ShoppingListWithoutItemsUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	supplier?: ValueTypes["ShoppingListUpdateSupplierEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ShoppingListItemUpsertListRelationInput"]: {
	update?: ValueTypes["ShoppingListWithoutItemsUpdateInput"] | undefined | null,
	create?: ValueTypes["ShoppingListWithoutItemsCreateInput"] | undefined | null
};
	["SuppliesPurchaseItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	amount?: number | undefined | null,
	list?: ValueTypes["SuppliesPurchaseItemCreateListEntityRelationInput"] | undefined | null,
	ingredient?: ValueTypes["SuppliesPurchaseItemCreateIngredientEntityRelationInput"] | undefined | null,
	pricePaidCents?: number | undefined | null,
	preferredUnit?: ValueTypes["SuppliesPurchaseItemCreatePreferredUnitEntityRelationInput"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	purchasedAt?: ValueTypes["DateTime"] | undefined | null,
	purchasedBy?: ValueTypes["SuppliesPurchaseItemCreatePurchasedByEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SuppliesPurchaseItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["SuppliesPurchaseUniqueWhere"] | undefined | null,
	create?: ValueTypes["SuppliesPurchaseWithoutItemsCreateInput"] | undefined | null
};
	["SuppliesPurchaseWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	supplier?: ValueTypes["SuppliesPurchaseCreateSupplierEntityRelationInput"] | undefined | null,
	requestedDeliveryDate?: ValueTypes["Date"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SuppliesPurchaseItemUpdateInput"]: {
	amount?: number | undefined | null,
	list?: ValueTypes["SuppliesPurchaseItemUpdateListEntityRelationInput"] | undefined | null,
	ingredient?: ValueTypes["SuppliesPurchaseItemUpdateIngredientEntityRelationInput"] | undefined | null,
	pricePaidCents?: number | undefined | null,
	preferredUnit?: ValueTypes["SuppliesPurchaseItemUpdatePreferredUnitEntityRelationInput"] | undefined | null,
	deletedAt?: ValueTypes["DateTime"] | undefined | null,
	purchasedAt?: ValueTypes["DateTime"] | undefined | null,
	purchasedBy?: ValueTypes["SuppliesPurchaseItemUpdatePurchasedByEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SuppliesPurchaseItemUpdateListEntityRelationInput"]: {
	create?: ValueTypes["SuppliesPurchaseWithoutItemsCreateInput"] | undefined | null,
	update?: ValueTypes["SuppliesPurchaseWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["SuppliesPurchaseItemUpsertListRelationInput"] | undefined | null,
	connect?: ValueTypes["SuppliesPurchaseUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["SuppliesPurchaseWithoutItemsUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	supplier?: ValueTypes["SuppliesPurchaseUpdateSupplierEntityRelationInput"] | undefined | null,
	requestedDeliveryDate?: ValueTypes["Date"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SuppliesPurchaseItemUpsertListRelationInput"]: {
	update?: ValueTypes["SuppliesPurchaseWithoutItemsUpdateInput"] | undefined | null,
	create?: ValueTypes["SuppliesPurchaseWithoutItemsCreateInput"] | undefined | null
};
	["CustomerCreditTransactionCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	amountCents?: number | undefined | null,
	customerCredit?: ValueTypes["CustomerCreditTransactionCreateCustomerCreditEntityRelationInput"] | undefined | null,
	orderDiscount?: ValueTypes["CustomerCreditTransactionCreateOrderDiscountEntityRelationInput"] | undefined | null,
	virtualProductEffect?: ValueTypes["CustomerCreditTransactionCreateVirtualProductEffectEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerCreditTransactionUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	amountCents?: number | undefined | null,
	customerCredit?: ValueTypes["CustomerCreditTransactionUpdateCustomerCreditEntityRelationInput"] | undefined | null,
	orderDiscount?: ValueTypes["CustomerCreditTransactionUpdateOrderDiscountEntityRelationInput"] | undefined | null,
	virtualProductEffect?: ValueTypes["CustomerCreditTransactionUpdateVirtualProductEffectEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VirtualProductConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["VirtualProductEdge"],
		__typename?: boolean | `@${string}`
}>;
	["VirtualProductEdge"]: AliasType<{
	node?:ValueTypes["VirtualProduct"],
		__typename?: boolean | `@${string}`
}>;
	["VirtualProductEffectCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	succeededAt?: ValueTypes["DateTime"] | undefined | null,
	orderItem?: ValueTypes["VirtualProductEffectCreateOrderItemEntityRelationInput"] | undefined | null,
	failedAt?: ValueTypes["DateTime"] | undefined | null,
	revertedAt?: ValueTypes["DateTime"] | undefined | null,
	resultCustomerCreditTransaction?: ValueTypes["VirtualProductEffectCreateResultCustomerCreditTransactionEntityRelationInput"] | undefined | null,
	resultVouchers?: Array<ValueTypes["VirtualProductEffectCreateResultVouchersEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VirtualProductEffectUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	succeededAt?: ValueTypes["DateTime"] | undefined | null,
	orderItem?: ValueTypes["VirtualProductEffectUpdateOrderItemEntityRelationInput"] | undefined | null,
	failedAt?: ValueTypes["DateTime"] | undefined | null,
	revertedAt?: ValueTypes["DateTime"] | undefined | null,
	resultCustomerCreditTransaction?: ValueTypes["VirtualProductEffectUpdateResultCustomerCreditTransactionEntityRelationInput"] | undefined | null,
	resultVouchers?: Array<ValueTypes["VirtualProductEffectUpdateResultVouchersEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductMetadataConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductMetadataEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ProductMetadataEdge"]: AliasType<{
	node?:ValueTypes["ProductMetadata"],
		__typename?: boolean | `@${string}`
}>;
	["EmploymentInformationCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	hourlyRate?: number | undefined | null,
	remunerationProfiles?: ValueTypes["EmploymentInformationCreateRemunerationProfilesEntityRelationInput"] | undefined | null,
	monthlySalary?: number | undefined | null,
	type?: ValueTypes["EmploymentType"] | undefined | null,
	name?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["EmploymentInformationCreateRemunerationProfilesEntityRelationInput"]: {
	connect?: ValueTypes["RemunerationProfileUniqueWhere"] | undefined | null,
	create?: ValueTypes["RemunerationProfileWithoutEmploymentInformationCreateInput"] | undefined | null
};
	["RemunerationProfileWithoutEmploymentInformationCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	workMonths?: ValueTypes["RemunerationProfileCreateWorkMonthsEntityRelationInput"] | undefined | null,
	staff?: ValueTypes["RemunerationProfileCreateStaffEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RemunerationProfileCreateStaffEntityRelationInput"]: {
	connect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	create?: ValueTypes["StaffWithoutRemunerationProfileCreateInput"] | undefined | null
};
	["StaffWithoutRemunerationProfileCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	bartender?: ValueTypes["StaffCreateBartenderEntityRelationInput"] | undefined | null,
	courier?: ValueTypes["StaffCreateCourierEntityRelationInput"] | undefined | null,
	cleaner?: ValueTypes["StaffCreateCleanerEntityRelationInput"] | undefined | null,
	shiftsManager?: ValueTypes["StaffCreateShiftsManagerEntityRelationInput"] | undefined | null,
	businessToBusinessManager?: ValueTypes["StaffCreateBusinessToBusinessManagerEntityRelationInput"] | undefined | null,
	user?: ValueTypes["StaffCreateUserEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["StaffCreateShiftsProfileEntityRelationInput"] | undefined | null,
	stocksManager?: ValueTypes["StaffCreateStocksManagerEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["StaffCreatePhotoEntityRelationInput"] | undefined | null,
	courierManager?: ValueTypes["StaffCreateCourierManagerEntityRelationInput"] | undefined | null,
	picker?: ValueTypes["StaffCreatePickerEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	cashier?: ValueTypes["StaffCreateCashierEntityRelationInput"] | undefined | null,
	venues?: Array<ValueTypes["StaffCreateVenuesEntityRelationInput"]> | undefined | null,
	internalBuyer?: ValueTypes["StaffCreateInternalBuyerEntityRelationInput"] | undefined | null,
	salesManager?: ValueTypes["StaffCreateSalesManagerEntityRelationInput"] | undefined | null,
	cashierManager?: ValueTypes["StaffCreateCashierManagerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["EmploymentInformationUpdateInput"]: {
	hourlyRate?: number | undefined | null,
	remunerationProfiles?: ValueTypes["EmploymentInformationUpdateRemunerationProfilesEntityRelationInput"] | undefined | null,
	monthlySalary?: number | undefined | null,
	type?: ValueTypes["EmploymentType"] | undefined | null,
	name?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["EmploymentInformationUpdateRemunerationProfilesEntityRelationInput"]: {
	create?: ValueTypes["RemunerationProfileWithoutEmploymentInformationCreateInput"] | undefined | null,
	update?: ValueTypes["RemunerationProfileWithoutEmploymentInformationUpdateInput"] | undefined | null,
	upsert?: ValueTypes["EmploymentInformationUpsertRemunerationProfilesRelationInput"] | undefined | null,
	connect?: ValueTypes["RemunerationProfileUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["RemunerationProfileWithoutEmploymentInformationUpdateInput"]: {
	workMonths?: ValueTypes["RemunerationProfileUpdateWorkMonthsEntityRelationInput"] | undefined | null,
	staff?: ValueTypes["RemunerationProfileUpdateStaffEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RemunerationProfileUpdateStaffEntityRelationInput"]: {
	create?: ValueTypes["StaffWithoutRemunerationProfileCreateInput"] | undefined | null,
	update?: ValueTypes["StaffWithoutRemunerationProfileUpdateInput"] | undefined | null,
	upsert?: ValueTypes["RemunerationProfileUpsertStaffRelationInput"] | undefined | null,
	connect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["StaffWithoutRemunerationProfileUpdateInput"]: {
	bartender?: ValueTypes["StaffUpdateBartenderEntityRelationInput"] | undefined | null,
	courier?: ValueTypes["StaffUpdateCourierEntityRelationInput"] | undefined | null,
	cleaner?: ValueTypes["StaffUpdateCleanerEntityRelationInput"] | undefined | null,
	shiftsManager?: ValueTypes["StaffUpdateShiftsManagerEntityRelationInput"] | undefined | null,
	businessToBusinessManager?: ValueTypes["StaffUpdateBusinessToBusinessManagerEntityRelationInput"] | undefined | null,
	user?: ValueTypes["StaffUpdateUserEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["StaffUpdateShiftsProfileEntityRelationInput"] | undefined | null,
	stocksManager?: ValueTypes["StaffUpdateStocksManagerEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["StaffUpdatePhotoEntityRelationInput"] | undefined | null,
	courierManager?: ValueTypes["StaffUpdateCourierManagerEntityRelationInput"] | undefined | null,
	picker?: ValueTypes["StaffUpdatePickerEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	cashier?: ValueTypes["StaffUpdateCashierEntityRelationInput"] | undefined | null,
	venues?: Array<ValueTypes["StaffUpdateVenuesEntityRelationInput"]> | undefined | null,
	internalBuyer?: ValueTypes["StaffUpdateInternalBuyerEntityRelationInput"] | undefined | null,
	salesManager?: ValueTypes["StaffUpdateSalesManagerEntityRelationInput"] | undefined | null,
	cashierManager?: ValueTypes["StaffUpdateCashierManagerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RemunerationProfileUpsertStaffRelationInput"]: {
	update?: ValueTypes["StaffWithoutRemunerationProfileUpdateInput"] | undefined | null,
	create?: ValueTypes["StaffWithoutRemunerationProfileCreateInput"] | undefined | null
};
	["EmploymentInformationUpsertRemunerationProfilesRelationInput"]: {
	update?: ValueTypes["RemunerationProfileWithoutEmploymentInformationUpdateInput"] | undefined | null,
	create?: ValueTypes["RemunerationProfileWithoutEmploymentInformationCreateInput"] | undefined | null
};
	["RemunerationProfileCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	employmentInformation?: Array<ValueTypes["RemunerationProfileCreateEmploymentInformationEntityRelationInput"]> | undefined | null,
	workMonths?: ValueTypes["RemunerationProfileCreateWorkMonthsEntityRelationInput"] | undefined | null,
	staff?: ValueTypes["RemunerationProfileCreateStaffEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RemunerationProfileUpdateInput"]: {
	employmentInformation?: Array<ValueTypes["RemunerationProfileUpdateEmploymentInformationEntityRelationInput"]> | undefined | null,
	workMonths?: ValueTypes["RemunerationProfileUpdateWorkMonthsEntityRelationInput"] | undefined | null,
	staff?: ValueTypes["RemunerationProfileUpdateStaffEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["WorkMonthConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["WorkMonthEdge"],
		__typename?: boolean | `@${string}`
}>;
	["WorkMonthEdge"]: AliasType<{
	node?:ValueTypes["WorkMonth"],
		__typename?: boolean | `@${string}`
}>;
	["WorkMonthCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	year?: number | undefined | null,
	month?: number | undefined | null,
	hoursWorked?: number | undefined | null,
	billableHours?: number | undefined | null,
	remunerationProfile?: Array<ValueTypes["WorkMonthCreateRemunerationProfileEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["WorkMonthCreateRemunerationProfileEntityRelationInput"]: {
	connect?: ValueTypes["RemunerationProfileUniqueWhere"] | undefined | null,
	create?: ValueTypes["RemunerationProfileWithoutWorkMonthsCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["RemunerationProfileWithoutWorkMonthsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	employmentInformation?: Array<ValueTypes["RemunerationProfileCreateEmploymentInformationEntityRelationInput"]> | undefined | null,
	staff?: ValueTypes["RemunerationProfileCreateStaffEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["WorkMonthUpdateInput"]: {
	year?: number | undefined | null,
	month?: number | undefined | null,
	hoursWorked?: number | undefined | null,
	billableHours?: number | undefined | null,
	remunerationProfile?: Array<ValueTypes["WorkMonthUpdateRemunerationProfileEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["WorkMonthUpdateRemunerationProfileEntityRelationInput"]: {
	create?: ValueTypes["RemunerationProfileWithoutWorkMonthsCreateInput"] | undefined | null,
	update?: ValueTypes["WorkMonthUpdateRemunerationProfileRelationInput"] | undefined | null,
	upsert?: ValueTypes["WorkMonthUpsertRemunerationProfileRelationInput"] | undefined | null,
	connect?: ValueTypes["RemunerationProfileUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["RemunerationProfileUniqueWhere"] | undefined | null,
	delete?: ValueTypes["RemunerationProfileUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["WorkMonthUpdateRemunerationProfileRelationInput"]: {
	by?: ValueTypes["RemunerationProfileUniqueWhere"] | undefined | null,
	data?: ValueTypes["RemunerationProfileWithoutWorkMonthsUpdateInput"] | undefined | null
};
	["RemunerationProfileWithoutWorkMonthsUpdateInput"]: {
	employmentInformation?: Array<ValueTypes["RemunerationProfileUpdateEmploymentInformationEntityRelationInput"]> | undefined | null,
	staff?: ValueTypes["RemunerationProfileUpdateStaffEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["WorkMonthUpsertRemunerationProfileRelationInput"]: {
	by?: ValueTypes["RemunerationProfileUniqueWhere"] | undefined | null,
	update?: ValueTypes["RemunerationProfileWithoutWorkMonthsUpdateInput"] | undefined | null,
	create?: ValueTypes["RemunerationProfileWithoutWorkMonthsCreateInput"] | undefined | null
};
	["SalaryOptions"]: AliasType<{
	_meta?:ValueTypes["SalaryOptionsMeta"],
	id?:boolean | `@${string}`,
	overtimeMultiplier?:boolean | `@${string}`,
	publicHolidayMultiplier?:boolean | `@${string}`,
	weekendMultiplier?:boolean | `@${string}`,
	unique?:boolean | `@${string}`,
	partTimeMonthlySalaryLimit?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SalaryOptionsMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	overtimeMultiplier?:ValueTypes["FieldMeta"],
	publicHolidayMultiplier?:ValueTypes["FieldMeta"],
	weekendMultiplier?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	partTimeMonthlySalaryLimit?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["SalaryOptionsUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	unique?: ValueTypes["One"] | undefined | null
};
	["SalaryOptionsWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	overtimeMultiplier?: ValueTypes["FloatCondition"] | undefined | null,
	publicHolidayMultiplier?: ValueTypes["FloatCondition"] | undefined | null,
	weekendMultiplier?: ValueTypes["FloatCondition"] | undefined | null,
	unique?: ValueTypes["OneCondition"] | undefined | null,
	partTimeMonthlySalaryLimit?: ValueTypes["IntCondition"] | undefined | null,
	and?: Array<ValueTypes["SalaryOptionsWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["SalaryOptionsWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["SalaryOptionsWhere"] | undefined | null
};
	["SalaryOptionsOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	overtimeMultiplier?: ValueTypes["OrderDirection"] | undefined | null,
	publicHolidayMultiplier?: ValueTypes["OrderDirection"] | undefined | null,
	weekendMultiplier?: ValueTypes["OrderDirection"] | undefined | null,
	unique?: ValueTypes["OrderDirection"] | undefined | null,
	partTimeMonthlySalaryLimit?: ValueTypes["OrderDirection"] | undefined | null
};
	["SalaryOptionsConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SalaryOptionsEdge"],
		__typename?: boolean | `@${string}`
}>;
	["SalaryOptionsEdge"]: AliasType<{
	node?:ValueTypes["SalaryOptions"],
		__typename?: boolean | `@${string}`
}>;
	["SalaryOptionsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	overtimeMultiplier?: number | undefined | null,
	publicHolidayMultiplier?: number | undefined | null,
	weekendMultiplier?: number | undefined | null,
	unique?: ValueTypes["One"] | undefined | null,
	partTimeMonthlySalaryLimit?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SalaryOptionsUpdateInput"]: {
	overtimeMultiplier?: number | undefined | null,
	publicHolidayMultiplier?: number | undefined | null,
	weekendMultiplier?: number | undefined | null,
	unique?: ValueTypes["One"] | undefined | null,
	partTimeMonthlySalaryLimit?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableShiftSwapInfoConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TimetableShiftSwapInfoEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableShiftSwapInfoEdge"]: AliasType<{
	node?:ValueTypes["TimetableShiftSwapInfo"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableShiftSwapInfoCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	assigned?: ValueTypes["Date"] | undefined | null,
	requested?: boolean | undefined | null,
	confirmed?: boolean | undefined | null,
	swappedShiftsProfile?: ValueTypes["TimetableShiftSwapInfoCreateSwappedShiftsProfileEntityRelationInput"] | undefined | null,
	shift?: ValueTypes["TimetableShiftSwapInfoCreateShiftEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableShiftSwapInfoCreateShiftEntityRelationInput"]: {
	connect?: ValueTypes["TimetableShiftUniqueWhere"] | undefined | null,
	create?: ValueTypes["TimetableShiftWithoutSwapInfoCreateInput"] | undefined | null
};
	["TimetableShiftWithoutSwapInfoCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	locked?: boolean | undefined | null,
	order?: number | undefined | null,
	assigned?: ValueTypes["Date"] | undefined | null,
	group?: ValueTypes["TimetableShiftCreateGroupEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["TimetableShiftCreateShiftsProfileEntityRelationInput"] | undefined | null,
	queueItem?: ValueTypes["TimetableShiftCreateQueueItemEntityRelationInput"] | undefined | null,
	isOvertime?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableShiftSwapInfoUpdateInput"]: {
	assigned?: ValueTypes["Date"] | undefined | null,
	requested?: boolean | undefined | null,
	confirmed?: boolean | undefined | null,
	swappedShiftsProfile?: ValueTypes["TimetableShiftSwapInfoUpdateSwappedShiftsProfileEntityRelationInput"] | undefined | null,
	shift?: ValueTypes["TimetableShiftSwapInfoUpdateShiftEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableShiftSwapInfoUpdateShiftEntityRelationInput"]: {
	create?: ValueTypes["TimetableShiftWithoutSwapInfoCreateInput"] | undefined | null,
	update?: ValueTypes["TimetableShiftWithoutSwapInfoUpdateInput"] | undefined | null,
	upsert?: ValueTypes["TimetableShiftSwapInfoUpsertShiftRelationInput"] | undefined | null,
	connect?: ValueTypes["TimetableShiftUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["TimetableShiftWithoutSwapInfoUpdateInput"]: {
	locked?: boolean | undefined | null,
	order?: number | undefined | null,
	assigned?: ValueTypes["Date"] | undefined | null,
	group?: ValueTypes["TimetableShiftUpdateGroupEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["TimetableShiftUpdateShiftsProfileEntityRelationInput"] | undefined | null,
	queueItem?: ValueTypes["TimetableShiftUpdateQueueItemEntityRelationInput"] | undefined | null,
	isOvertime?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableShiftSwapInfoUpsertShiftRelationInput"]: {
	update?: ValueTypes["TimetableShiftWithoutSwapInfoUpdateInput"] | undefined | null,
	create?: ValueTypes["TimetableShiftWithoutSwapInfoCreateInput"] | undefined | null
};
	["ProductGridCategoryCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	title?: string | undefined | null,
	root?: ValueTypes["ProductGridCategoryCreateRootEntityRelationInput"] | undefined | null,
	items?: Array<ValueTypes["ProductGridCategoryCreateItemsEntityRelationInput"]> | undefined | null,
	images?: ValueTypes["ProductGridCategoryCreateImagesEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ProductGridCategoryUpdateInput"]: {
	order?: number | undefined | null,
	title?: string | undefined | null,
	root?: ValueTypes["ProductGridCategoryUpdateRootEntityRelationInput"] | undefined | null,
	items?: Array<ValueTypes["ProductGridCategoryUpdateItemsEntityRelationInput"]> | undefined | null,
	images?: ValueTypes["ProductGridCategoryUpdateImagesEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CashierConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CashierEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CashierEdge"]: AliasType<{
	node?:ValueTypes["Cashier"],
		__typename?: boolean | `@${string}`
}>;
	["CashierCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	staff?: ValueTypes["CashierCreateStaffEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CashierCreateStaffEntityRelationInput"]: {
	connect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	create?: ValueTypes["StaffWithoutCashierCreateInput"] | undefined | null
};
	["StaffWithoutCashierCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	bartender?: ValueTypes["StaffCreateBartenderEntityRelationInput"] | undefined | null,
	courier?: ValueTypes["StaffCreateCourierEntityRelationInput"] | undefined | null,
	cleaner?: ValueTypes["StaffCreateCleanerEntityRelationInput"] | undefined | null,
	shiftsManager?: ValueTypes["StaffCreateShiftsManagerEntityRelationInput"] | undefined | null,
	businessToBusinessManager?: ValueTypes["StaffCreateBusinessToBusinessManagerEntityRelationInput"] | undefined | null,
	user?: ValueTypes["StaffCreateUserEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["StaffCreateShiftsProfileEntityRelationInput"] | undefined | null,
	stocksManager?: ValueTypes["StaffCreateStocksManagerEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["StaffCreatePhotoEntityRelationInput"] | undefined | null,
	courierManager?: ValueTypes["StaffCreateCourierManagerEntityRelationInput"] | undefined | null,
	picker?: ValueTypes["StaffCreatePickerEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	remunerationProfile?: ValueTypes["StaffCreateRemunerationProfileEntityRelationInput"] | undefined | null,
	venues?: Array<ValueTypes["StaffCreateVenuesEntityRelationInput"]> | undefined | null,
	internalBuyer?: ValueTypes["StaffCreateInternalBuyerEntityRelationInput"] | undefined | null,
	salesManager?: ValueTypes["StaffCreateSalesManagerEntityRelationInput"] | undefined | null,
	cashierManager?: ValueTypes["StaffCreateCashierManagerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CashierUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	staff?: ValueTypes["CashierUpdateStaffEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CashierUpdateStaffEntityRelationInput"]: {
	create?: ValueTypes["StaffWithoutCashierCreateInput"] | undefined | null,
	update?: ValueTypes["StaffWithoutCashierUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CashierUpsertStaffRelationInput"] | undefined | null,
	connect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["StaffWithoutCashierUpdateInput"]: {
	bartender?: ValueTypes["StaffUpdateBartenderEntityRelationInput"] | undefined | null,
	courier?: ValueTypes["StaffUpdateCourierEntityRelationInput"] | undefined | null,
	cleaner?: ValueTypes["StaffUpdateCleanerEntityRelationInput"] | undefined | null,
	shiftsManager?: ValueTypes["StaffUpdateShiftsManagerEntityRelationInput"] | undefined | null,
	businessToBusinessManager?: ValueTypes["StaffUpdateBusinessToBusinessManagerEntityRelationInput"] | undefined | null,
	user?: ValueTypes["StaffUpdateUserEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["StaffUpdateShiftsProfileEntityRelationInput"] | undefined | null,
	stocksManager?: ValueTypes["StaffUpdateStocksManagerEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["StaffUpdatePhotoEntityRelationInput"] | undefined | null,
	courierManager?: ValueTypes["StaffUpdateCourierManagerEntityRelationInput"] | undefined | null,
	picker?: ValueTypes["StaffUpdatePickerEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	remunerationProfile?: ValueTypes["StaffUpdateRemunerationProfileEntityRelationInput"] | undefined | null,
	venues?: Array<ValueTypes["StaffUpdateVenuesEntityRelationInput"]> | undefined | null,
	internalBuyer?: ValueTypes["StaffUpdateInternalBuyerEntityRelationInput"] | undefined | null,
	salesManager?: ValueTypes["StaffUpdateSalesManagerEntityRelationInput"] | undefined | null,
	cashierManager?: ValueTypes["StaffUpdateCashierManagerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CashierUpsertStaffRelationInput"]: {
	update?: ValueTypes["StaffWithoutCashierUpdateInput"] | undefined | null,
	create?: ValueTypes["StaffWithoutCashierCreateInput"] | undefined | null
};
	["PointOfSaleCategoryCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	slug?: string | undefined | null,
	locales?: Array<ValueTypes["PointOfSaleCategoryCreateLocalesEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["PointOfSaleCategoryCreateProductsEntityRelationInput"]> | undefined | null,
	category?: ValueTypes["PointOfSaleCategoryCreateCategoryEntityRelationInput"] | undefined | null,
	venue?: ValueTypes["PointOfSaleCategoryCreateVenueEntityRelationInput"] | undefined | null,
	ticketPrinters?: Array<ValueTypes["PointOfSaleCategoryCreateTicketPrintersEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleCategoryUpdateInput"]: {
	order?: number | undefined | null,
	slug?: string | undefined | null,
	locales?: Array<ValueTypes["PointOfSaleCategoryUpdateLocalesEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["PointOfSaleCategoryUpdateProductsEntityRelationInput"]> | undefined | null,
	category?: ValueTypes["PointOfSaleCategoryUpdateCategoryEntityRelationInput"] | undefined | null,
	venue?: ValueTypes["PointOfSaleCategoryUpdateVenueEntityRelationInput"] | undefined | null,
	ticketPrinters?: Array<ValueTypes["PointOfSaleCategoryUpdateTicketPrintersEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleCategoryLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	root?: ValueTypes["PointOfSaleCategoryLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["PointOfSaleCategoryLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleCategoryLocaleUpdateInput"]: {
	title?: string | undefined | null,
	root?: ValueTypes["PointOfSaleCategoryLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["PointOfSaleCategoryLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleCategoryProductCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	category?: ValueTypes["PointOfSaleCategoryProductCreateCategoryEntityRelationInput"] | undefined | null,
	product?: ValueTypes["PointOfSaleCategoryProductCreateProductEntityRelationInput"] | undefined | null,
	locales?: Array<ValueTypes["PointOfSaleCategoryProductCreateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleCategoryProductUpdateInput"]: {
	order?: number | undefined | null,
	category?: ValueTypes["PointOfSaleCategoryProductUpdateCategoryEntityRelationInput"] | undefined | null,
	product?: ValueTypes["PointOfSaleCategoryProductUpdateProductEntityRelationInput"] | undefined | null,
	locales?: Array<ValueTypes["PointOfSaleCategoryProductUpdateLocalesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleCategoryProductLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	root?: ValueTypes["PointOfSaleCategoryProductLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["PointOfSaleCategoryProductLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleCategoryProductLocaleUpdateInput"]: {
	title?: string | undefined | null,
	root?: ValueTypes["PointOfSaleCategoryProductLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["PointOfSaleCategoryProductLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerTabCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	color?: string | undefined | null,
	items?: Array<ValueTypes["CustomerTabCreateItemsEntityRelationInput"]> | undefined | null,
	name?: string | undefined | null,
	meta?: ValueTypes["CustomerTabCreateMetaEntityRelationInput"] | undefined | null,
	customer?: ValueTypes["CustomerTabCreateCustomerEntityRelationInput"] | undefined | null,
	table?: ValueTypes["CustomerTabCreateTableEntityRelationInput"] | undefined | null,
	seat?: ValueTypes["CustomerTabCreateSeatEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerTabUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	color?: string | undefined | null,
	items?: Array<ValueTypes["CustomerTabUpdateItemsEntityRelationInput"]> | undefined | null,
	name?: string | undefined | null,
	meta?: ValueTypes["CustomerTabUpdateMetaEntityRelationInput"] | undefined | null,
	customer?: ValueTypes["CustomerTabUpdateCustomerEntityRelationInput"] | undefined | null,
	table?: ValueTypes["CustomerTabUpdateTableEntityRelationInput"] | undefined | null,
	seat?: ValueTypes["CustomerTabUpdateSeatEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerTabItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	addedAt?: ValueTypes["DateTime"] | undefined | null,
	tab?: ValueTypes["CustomerTabItemCreateTabEntityRelationInput"] | undefined | null,
	product?: ValueTypes["CustomerTabItemCreateProductEntityRelationInput"] | undefined | null,
	paidAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerTabItemCreateTabEntityRelationInput"]: {
	connect?: ValueTypes["CustomerTabUniqueWhere"] | undefined | null,
	create?: ValueTypes["CustomerTabWithoutItemsCreateInput"] | undefined | null
};
	["CustomerTabWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	color?: string | undefined | null,
	name?: string | undefined | null,
	meta?: ValueTypes["CustomerTabCreateMetaEntityRelationInput"] | undefined | null,
	customer?: ValueTypes["CustomerTabCreateCustomerEntityRelationInput"] | undefined | null,
	table?: ValueTypes["CustomerTabCreateTableEntityRelationInput"] | undefined | null,
	seat?: ValueTypes["CustomerTabCreateSeatEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerTabItemUpdateInput"]: {
	addedAt?: ValueTypes["DateTime"] | undefined | null,
	tab?: ValueTypes["CustomerTabItemUpdateTabEntityRelationInput"] | undefined | null,
	product?: ValueTypes["CustomerTabItemUpdateProductEntityRelationInput"] | undefined | null,
	paidAt?: ValueTypes["DateTime"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerTabItemUpdateTabEntityRelationInput"]: {
	create?: ValueTypes["CustomerTabWithoutItemsCreateInput"] | undefined | null,
	update?: ValueTypes["CustomerTabWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CustomerTabItemUpsertTabRelationInput"] | undefined | null,
	connect?: ValueTypes["CustomerTabUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["CustomerTabWithoutItemsUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	color?: string | undefined | null,
	name?: string | undefined | null,
	meta?: ValueTypes["CustomerTabUpdateMetaEntityRelationInput"] | undefined | null,
	customer?: ValueTypes["CustomerTabUpdateCustomerEntityRelationInput"] | undefined | null,
	table?: ValueTypes["CustomerTabUpdateTableEntityRelationInput"] | undefined | null,
	seat?: ValueTypes["CustomerTabUpdateSeatEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerTabItemUpsertTabRelationInput"]: {
	update?: ValueTypes["CustomerTabWithoutItemsUpdateInput"] | undefined | null,
	create?: ValueTypes["CustomerTabWithoutItemsCreateInput"] | undefined | null
};
	["AnonymousSessionConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["AnonymousSessionEdge"],
		__typename?: boolean | `@${string}`
}>;
	["AnonymousSessionEdge"]: AliasType<{
	node?:ValueTypes["AnonymousSession"],
		__typename?: boolean | `@${string}`
}>;
	["AnonymousSessionCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	lastActiveAt?: ValueTypes["DateTime"] | undefined | null,
	anonymousSessionKey?: string | undefined | null,
	email?: string | undefined | null,
	name?: string | undefined | null,
	internalNote?: string | undefined | null,
	customer?: ValueTypes["AnonymousSessionCreateCustomerEntityRelationInput"] | undefined | null,
	devices?: Array<ValueTypes["AnonymousSessionCreateDevicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AnonymousSessionUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	lastActiveAt?: ValueTypes["DateTime"] | undefined | null,
	anonymousSessionKey?: string | undefined | null,
	email?: string | undefined | null,
	name?: string | undefined | null,
	internalNote?: string | undefined | null,
	customer?: ValueTypes["AnonymousSessionUpdateCustomerEntityRelationInput"] | undefined | null,
	devices?: Array<ValueTypes["AnonymousSessionUpdateDevicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VoucherCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	activatedAt?: ValueTypes["DateTime"] | undefined | null,
	expiresAt?: ValueTypes["DateTime"] | undefined | null,
	internalNote?: string | undefined | null,
	note?: string | undefined | null,
	code?: string | undefined | null,
	type?: ValueTypes["VoucherType"] | undefined | null,
	creditCents?: number | undefined | null,
	buyer?: ValueTypes["VoucherCreateBuyerEntityRelationInput"] | undefined | null,
	owner?: ValueTypes["VoucherCreateOwnerEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["VoucherCreateVatRateEntityRelationInput"] | undefined | null,
	virtualProductEffect?: ValueTypes["VoucherCreateVirtualProductEffectEntityRelationInput"] | undefined | null,
	redemption?: ValueTypes["VoucherCreateRedemptionEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VoucherUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	activatedAt?: ValueTypes["DateTime"] | undefined | null,
	expiresAt?: ValueTypes["DateTime"] | undefined | null,
	internalNote?: string | undefined | null,
	note?: string | undefined | null,
	code?: string | undefined | null,
	type?: ValueTypes["VoucherType"] | undefined | null,
	creditCents?: number | undefined | null,
	buyer?: ValueTypes["VoucherUpdateBuyerEntityRelationInput"] | undefined | null,
	owner?: ValueTypes["VoucherUpdateOwnerEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["VoucherUpdateVatRateEntityRelationInput"] | undefined | null,
	virtualProductEffect?: ValueTypes["VoucherUpdateVirtualProductEffectEntityRelationInput"] | undefined | null,
	redemption?: ValueTypes["VoucherUpdateRedemptionEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VoucherRedemptionCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	manualRedemptionNote?: string | undefined | null,
	customerCredit?: ValueTypes["VoucherRedemptionCreateCustomerCreditEntityRelationInput"] | undefined | null,
	orderDiscount?: ValueTypes["VoucherRedemptionCreateOrderDiscountEntityRelationInput"] | undefined | null,
	voucher?: ValueTypes["VoucherRedemptionCreateVoucherEntityRelationInput"] | undefined | null,
	customer?: ValueTypes["VoucherRedemptionCreateCustomerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VoucherRedemptionUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	manualRedemptionNote?: string | undefined | null,
	customerCredit?: ValueTypes["VoucherRedemptionUpdateCustomerCreditEntityRelationInput"] | undefined | null,
	orderDiscount?: ValueTypes["VoucherRedemptionUpdateOrderDiscountEntityRelationInput"] | undefined | null,
	voucher?: ValueTypes["VoucherRedemptionUpdateVoucherEntityRelationInput"] | undefined | null,
	customer?: ValueTypes["VoucherRedemptionUpdateCustomerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UnassignedShiftInfoConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["UnassignedShiftInfoEdge"],
		__typename?: boolean | `@${string}`
}>;
	["UnassignedShiftInfoEdge"]: AliasType<{
	node?:ValueTypes["UnassignedShiftInfo"],
		__typename?: boolean | `@${string}`
}>;
	["UnassignedShiftInfoCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	hoursMissed?: number | undefined | null,
	queueItem?: ValueTypes["UnassignedShiftInfoCreateQueueItemEntityRelationInput"] | undefined | null,
	legacyReason?: ValueTypes["UnassignedInfoReason"] | undefined | null,
	reason?: ValueTypes["UnassignedShiftInfoCreateReasonEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UnassignedShiftInfoCreateQueueItemEntityRelationInput"]: {
	connect?: ValueTypes["EmployeeQueueItemUniqueWhere"] | undefined | null,
	create?: ValueTypes["EmployeeQueueItemWithoutUnassignInfoCreateInput"] | undefined | null
};
	["EmployeeQueueItemWithoutUnassignInfoCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	start?: string | undefined | null,
	end?: string | undefined | null,
	queue?: ValueTypes["EmployeeQueueItemCreateQueueEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["EmployeeQueueItemCreateShiftsProfileEntityRelationInput"] | undefined | null,
	shift?: ValueTypes["EmployeeQueueItemCreateShiftEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["EmployeeQueueItemCreateMetaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UnassignedShiftInfoUpdateInput"]: {
	hoursMissed?: number | undefined | null,
	queueItem?: ValueTypes["UnassignedShiftInfoUpdateQueueItemEntityRelationInput"] | undefined | null,
	legacyReason?: ValueTypes["UnassignedInfoReason"] | undefined | null,
	reason?: ValueTypes["UnassignedShiftInfoUpdateReasonEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UnassignedShiftInfoUpdateQueueItemEntityRelationInput"]: {
	create?: ValueTypes["EmployeeQueueItemWithoutUnassignInfoCreateInput"] | undefined | null,
	update?: ValueTypes["EmployeeQueueItemWithoutUnassignInfoUpdateInput"] | undefined | null,
	upsert?: ValueTypes["UnassignedShiftInfoUpsertQueueItemRelationInput"] | undefined | null,
	connect?: ValueTypes["EmployeeQueueItemUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["EmployeeQueueItemWithoutUnassignInfoUpdateInput"]: {
	start?: string | undefined | null,
	end?: string | undefined | null,
	queue?: ValueTypes["EmployeeQueueItemUpdateQueueEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["EmployeeQueueItemUpdateShiftsProfileEntityRelationInput"] | undefined | null,
	shift?: ValueTypes["EmployeeQueueItemUpdateShiftEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["EmployeeQueueItemUpdateMetaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["UnassignedShiftInfoUpsertQueueItemRelationInput"]: {
	update?: ValueTypes["EmployeeQueueItemWithoutUnassignInfoUpdateInput"] | undefined | null,
	create?: ValueTypes["EmployeeQueueItemWithoutUnassignInfoCreateInput"] | undefined | null
};
	["TextItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	text?: string | undefined | null,
	list?: ValueTypes["TextItemCreateListEntityRelationInput"] | undefined | null,
	title?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TextItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["TextListUniqueWhere"] | undefined | null,
	create?: ValueTypes["TextListWithoutItemsCreateInput"] | undefined | null
};
	["TextListWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TextItemUpdateInput"]: {
	order?: number | undefined | null,
	text?: string | undefined | null,
	list?: ValueTypes["TextItemUpdateListEntityRelationInput"] | undefined | null,
	title?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TextItemUpdateListEntityRelationInput"]: {
	create?: ValueTypes["TextListWithoutItemsCreateInput"] | undefined | null,
	update?: ValueTypes["TextListWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["TextItemUpsertListRelationInput"] | undefined | null,
	connect?: ValueTypes["TextListUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["TextListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null
};
	["TextItemUpsertListRelationInput"]: {
	update?: ValueTypes["TextListWithoutItemsUpdateInput"] | undefined | null,
	create?: ValueTypes["TextListWithoutItemsCreateInput"] | undefined | null
};
	["TextListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TextListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TextListEdge"]: AliasType<{
	node?:ValueTypes["TextList"],
		__typename?: boolean | `@${string}`
}>;
	["EmployeeQueueItemMetadataConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["EmployeeQueueItemMetadataEdge"],
		__typename?: boolean | `@${string}`
}>;
	["EmployeeQueueItemMetadataEdge"]: AliasType<{
	node?:ValueTypes["EmployeeQueueItemMetadata"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryRegionsConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["DeliveryRegionsEdge"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryRegionsEdge"]: AliasType<{
	node?:ValueTypes["DeliveryRegions"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryRegionsItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	title?: string | undefined | null,
	offerLabel?: string | undefined | null,
	list?: ValueTypes["DeliveryRegionsItemCreateListEntityRelationInput"] | undefined | null,
	image?: ValueTypes["DeliveryRegionsItemCreateImageEntityRelationInput"] | undefined | null,
	textList?: ValueTypes["DeliveryRegionsItemCreateTextListEntityRelationInput"] | undefined | null,
	gallery?: ValueTypes["DeliveryRegionsItemCreateGalleryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryRegionsItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["DeliveryRegionsUniqueWhere"] | undefined | null,
	create?: ValueTypes["DeliveryRegionsWithoutItemsCreateInput"] | undefined | null
};
	["DeliveryRegionsWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryRegionsItemUpdateInput"]: {
	order?: number | undefined | null,
	title?: string | undefined | null,
	offerLabel?: string | undefined | null,
	list?: ValueTypes["DeliveryRegionsItemUpdateListEntityRelationInput"] | undefined | null,
	image?: ValueTypes["DeliveryRegionsItemUpdateImageEntityRelationInput"] | undefined | null,
	textList?: ValueTypes["DeliveryRegionsItemUpdateTextListEntityRelationInput"] | undefined | null,
	gallery?: ValueTypes["DeliveryRegionsItemUpdateGalleryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryRegionsItemUpdateListEntityRelationInput"]: {
	create?: ValueTypes["DeliveryRegionsWithoutItemsCreateInput"] | undefined | null,
	update?: ValueTypes["DeliveryRegionsWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["DeliveryRegionsItemUpsertListRelationInput"] | undefined | null,
	connect?: ValueTypes["DeliveryRegionsUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["DeliveryRegionsWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryRegionsItemUpsertListRelationInput"]: {
	update?: ValueTypes["DeliveryRegionsWithoutItemsUpdateInput"] | undefined | null,
	create?: ValueTypes["DeliveryRegionsWithoutItemsCreateInput"] | undefined | null
};
	["ImageListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ImageListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListEdge"]: AliasType<{
	node?:ValueTypes["ImageList"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	list?: ValueTypes["ImageListItemCreateListEntityRelationInput"] | undefined | null,
	image?: ValueTypes["ImageListItemCreateImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ImageListItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["ImageListUniqueWhere"] | undefined | null,
	create?: ValueTypes["ImageListWithoutItemsCreateInput"] | undefined | null
};
	["ImageListWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ImageListItemUpdateInput"]: {
	order?: number | undefined | null,
	list?: ValueTypes["ImageListItemUpdateListEntityRelationInput"] | undefined | null,
	image?: ValueTypes["ImageListItemUpdateImageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ImageListItemUpdateListEntityRelationInput"]: {
	create?: ValueTypes["ImageListWithoutItemsCreateInput"] | undefined | null,
	update?: ValueTypes["ImageListWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ImageListItemUpsertListRelationInput"] | undefined | null,
	connect?: ValueTypes["ImageListUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["ImageListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null
};
	["ImageListItemUpsertListRelationInput"]: {
	update?: ValueTypes["ImageListWithoutItemsUpdateInput"] | undefined | null,
	create?: ValueTypes["ImageListWithoutItemsCreateInput"] | undefined | null
};
	["TimetablesEmployeePrivilegesConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TimetablesEmployeePrivilegesEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TimetablesEmployeePrivilegesEdge"]: AliasType<{
	node?:ValueTypes["TimetablesEmployeePrivileges"],
		__typename?: boolean | `@${string}`
}>;
	["TimetablesEmployeePrivilegesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	venueEmployeeRole?: ValueTypes["TimetablesEmployeePrivilegesCreateVenueEmployeeRoleEntityRelationInput"] | undefined | null,
	read?: boolean | undefined | null,
	unassign?: boolean | undefined | null,
	assign?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetablesEmployeePrivilegesCreateVenueEmployeeRoleEntityRelationInput"]: {
	connect?: ValueTypes["VenueEmployeeRoleUniqueWhere"] | undefined | null,
	create?: ValueTypes["VenueEmployeeRoleWithoutEmployeePrivilegesCreateInput"] | undefined | null
};
	["VenueEmployeeRoleWithoutEmployeePrivilegesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	venue?: ValueTypes["VenueEmployeeRoleCreateVenueEntityRelationInput"] | undefined | null,
	role?: ValueTypes["VenueEmployeeRoleCreateRoleEntityRelationInput"] | undefined | null,
	getsTipsShare?: boolean | undefined | null,
	notesEnabled?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VenueEmployeeRoleCreateVenueEntityRelationInput"]: {
	connect?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	create?: ValueTypes["VenueWithoutEmployeeRolesCreateInput"] | undefined | null
};
	["VenueWithoutEmployeeRolesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	deadlineTemplate?: ValueTypes["VenueCreateDeadlineTemplateEntityRelationInput"] | undefined | null,
	timetableDays?: Array<ValueTypes["VenueCreateTimetableDaysEntityRelationInput"]> | undefined | null,
	timetableTemplates?: Array<ValueTypes["VenueCreateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	staffMembers?: Array<ValueTypes["VenueCreateStaffMembersEntityRelationInput"]> | undefined | null,
	pointOfSaleApplicationDevices?: Array<ValueTypes["VenueCreatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined | null,
	pointOfSaleTerminals?: Array<ValueTypes["VenueCreatePointOfSaleTerminalsEntityRelationInput"]> | undefined | null,
	pointOfSalePrinters?: Array<ValueTypes["VenueCreatePointOfSalePrintersEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["VenueCreateOrdersEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["VenueCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	areas?: Array<ValueTypes["VenueCreateAreasEntityRelationInput"]> | undefined | null,
	enabledUnassignReasons?: Array<ValueTypes["VenueCreateEnabledUnassignReasonsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["VenueCreateCategoriesEntityRelationInput"]> | undefined | null,
	channels?: Array<ValueTypes["VenueCreateChannelsEntityRelationInput"]> | undefined | null,
	address?: string | undefined | null,
	pointOfSalePngBase64ReceiptLogo?: string | undefined | null,
	pointOfSaleInitialView?: ValueTypes["PointOfSaleInitialView"] | undefined | null,
	pointOfSalePreferPrintReceipt?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetablesEmployeePrivilegesUpdateInput"]: {
	venueEmployeeRole?: ValueTypes["TimetablesEmployeePrivilegesUpdateVenueEmployeeRoleEntityRelationInput"] | undefined | null,
	read?: boolean | undefined | null,
	unassign?: boolean | undefined | null,
	assign?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetablesEmployeePrivilegesUpdateVenueEmployeeRoleEntityRelationInput"]: {
	create?: ValueTypes["VenueEmployeeRoleWithoutEmployeePrivilegesCreateInput"] | undefined | null,
	update?: ValueTypes["VenueEmployeeRoleWithoutEmployeePrivilegesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["TimetablesEmployeePrivilegesUpsertVenueEmployeeRoleRelationInput"] | undefined | null,
	connect?: ValueTypes["VenueEmployeeRoleUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["VenueEmployeeRoleWithoutEmployeePrivilegesUpdateInput"]: {
	order?: number | undefined | null,
	venue?: ValueTypes["VenueEmployeeRoleUpdateVenueEntityRelationInput"] | undefined | null,
	role?: ValueTypes["VenueEmployeeRoleUpdateRoleEntityRelationInput"] | undefined | null,
	getsTipsShare?: boolean | undefined | null,
	notesEnabled?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VenueEmployeeRoleUpdateVenueEntityRelationInput"]: {
	create?: ValueTypes["VenueWithoutEmployeeRolesCreateInput"] | undefined | null,
	update?: ValueTypes["VenueWithoutEmployeeRolesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["VenueEmployeeRoleUpsertVenueRelationInput"] | undefined | null,
	connect?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["VenueWithoutEmployeeRolesUpdateInput"]: {
	name?: string | undefined | null,
	deadlineTemplate?: ValueTypes["VenueUpdateDeadlineTemplateEntityRelationInput"] | undefined | null,
	timetableDays?: Array<ValueTypes["VenueUpdateTimetableDaysEntityRelationInput"]> | undefined | null,
	timetableTemplates?: Array<ValueTypes["VenueUpdateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	staffMembers?: Array<ValueTypes["VenueUpdateStaffMembersEntityRelationInput"]> | undefined | null,
	pointOfSaleApplicationDevices?: Array<ValueTypes["VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined | null,
	pointOfSaleTerminals?: Array<ValueTypes["VenueUpdatePointOfSaleTerminalsEntityRelationInput"]> | undefined | null,
	pointOfSalePrinters?: Array<ValueTypes["VenueUpdatePointOfSalePrintersEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["VenueUpdateOrdersEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["VenueUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	areas?: Array<ValueTypes["VenueUpdateAreasEntityRelationInput"]> | undefined | null,
	enabledUnassignReasons?: Array<ValueTypes["VenueUpdateEnabledUnassignReasonsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["VenueUpdateCategoriesEntityRelationInput"]> | undefined | null,
	channels?: Array<ValueTypes["VenueUpdateChannelsEntityRelationInput"]> | undefined | null,
	address?: string | undefined | null,
	pointOfSalePngBase64ReceiptLogo?: string | undefined | null,
	pointOfSaleInitialView?: ValueTypes["PointOfSaleInitialView"] | undefined | null,
	pointOfSalePreferPrintReceipt?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VenueEmployeeRoleUpsertVenueRelationInput"]: {
	update?: ValueTypes["VenueWithoutEmployeeRolesUpdateInput"] | undefined | null,
	create?: ValueTypes["VenueWithoutEmployeeRolesCreateInput"] | undefined | null
};
	["TimetablesEmployeePrivilegesUpsertVenueEmployeeRoleRelationInput"]: {
	update?: ValueTypes["VenueEmployeeRoleWithoutEmployeePrivilegesUpdateInput"] | undefined | null,
	create?: ValueTypes["VenueEmployeeRoleWithoutEmployeePrivilegesCreateInput"] | undefined | null
};
	["TimetableDayNoteCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	note?: string | undefined | null,
	day?: ValueTypes["TimetableDayNoteCreateDayEntityRelationInput"] | undefined | null,
	role?: ValueTypes["TimetableDayNoteCreateRoleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableDayNoteCreateDayEntityRelationInput"]: {
	connect?: ValueTypes["TimetableDayUniqueWhere"] | undefined | null,
	create?: ValueTypes["TimetableDayWithoutNotesCreateInput"] | undefined | null
};
	["TimetableDayWithoutNotesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	date?: ValueTypes["Date"] | undefined | null,
	type?: ValueTypes["TimetableDayType"] | undefined | null,
	shiftGroups?: Array<ValueTypes["TimetableDayCreateShiftGroupsEntityRelationInput"]> | undefined | null,
	tipsCents?: number | undefined | null,
	venue?: ValueTypes["TimetableDayCreateVenueEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["TimetableDayCreateMetaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableDayNoteUpdateInput"]: {
	order?: number | undefined | null,
	note?: string | undefined | null,
	day?: ValueTypes["TimetableDayNoteUpdateDayEntityRelationInput"] | undefined | null,
	role?: ValueTypes["TimetableDayNoteUpdateRoleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableDayNoteUpdateDayEntityRelationInput"]: {
	create?: ValueTypes["TimetableDayWithoutNotesCreateInput"] | undefined | null,
	update?: ValueTypes["TimetableDayWithoutNotesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["TimetableDayNoteUpsertDayRelationInput"] | undefined | null,
	connect?: ValueTypes["TimetableDayUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["TimetableDayWithoutNotesUpdateInput"]: {
	date?: ValueTypes["Date"] | undefined | null,
	type?: ValueTypes["TimetableDayType"] | undefined | null,
	shiftGroups?: Array<ValueTypes["TimetableDayUpdateShiftGroupsEntityRelationInput"]> | undefined | null,
	tipsCents?: number | undefined | null,
	venue?: ValueTypes["TimetableDayUpdateVenueEntityRelationInput"] | undefined | null,
	meta?: ValueTypes["TimetableDayUpdateMetaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableDayNoteUpsertDayRelationInput"]: {
	update?: ValueTypes["TimetableDayWithoutNotesUpdateInput"] | undefined | null,
	create?: ValueTypes["TimetableDayWithoutNotesCreateInput"] | undefined | null
};
	["DeliveryMethodLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	description?: string | undefined | null,
	trackingCodeUrlTemplate?: string | undefined | null,
	processingTitle?: string | undefined | null,
	processingText?: string | undefined | null,
	processingIconUrl?: string | undefined | null,
	dispatchedTitle?: string | undefined | null,
	dispatchedText?: string | undefined | null,
	dispatchedIconUrl?: string | undefined | null,
	fulfilledTitle?: string | undefined | null,
	fulfilledText?: string | undefined | null,
	fulfilledIconUrl?: string | undefined | null,
	locale?: ValueTypes["DeliveryMethodLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	root?: ValueTypes["DeliveryMethodLocaleCreateRootEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeliveryMethodLocaleUpdateInput"]: {
	name?: string | undefined | null,
	description?: string | undefined | null,
	trackingCodeUrlTemplate?: string | undefined | null,
	processingTitle?: string | undefined | null,
	processingText?: string | undefined | null,
	processingIconUrl?: string | undefined | null,
	dispatchedTitle?: string | undefined | null,
	dispatchedText?: string | undefined | null,
	dispatchedIconUrl?: string | undefined | null,
	fulfilledTitle?: string | undefined | null,
	fulfilledText?: string | undefined | null,
	fulfilledIconUrl?: string | undefined | null,
	locale?: ValueTypes["DeliveryMethodLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	root?: ValueTypes["DeliveryMethodLocaleUpdateRootEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IngredientSupplierConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["IngredientSupplierEdge"],
		__typename?: boolean | `@${string}`
}>;
	["IngredientSupplierEdge"]: AliasType<{
	node?:ValueTypes["IngredientSupplier"],
		__typename?: boolean | `@${string}`
}>;
	["IngredientSupplierItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	list?: ValueTypes["IngredientSupplierItemCreateListEntityRelationInput"] | undefined | null,
	supplier?: ValueTypes["IngredientSupplierItemCreateSupplierEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IngredientSupplierItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["IngredientSupplierListUniqueWhere"] | undefined | null,
	create?: ValueTypes["IngredientSupplierListWithoutItemsCreateInput"] | undefined | null
};
	["IngredientSupplierListWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IngredientSupplierItemUpdateInput"]: {
	order?: number | undefined | null,
	list?: ValueTypes["IngredientSupplierItemUpdateListEntityRelationInput"] | undefined | null,
	supplier?: ValueTypes["IngredientSupplierItemUpdateSupplierEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IngredientSupplierItemUpdateListEntityRelationInput"]: {
	create?: ValueTypes["IngredientSupplierListWithoutItemsCreateInput"] | undefined | null,
	update?: ValueTypes["IngredientSupplierListWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["IngredientSupplierItemUpsertListRelationInput"] | undefined | null,
	connect?: ValueTypes["IngredientSupplierListUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["IngredientSupplierListWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null
};
	["IngredientSupplierItemUpsertListRelationInput"]: {
	update?: ValueTypes["IngredientSupplierListWithoutItemsUpdateInput"] | undefined | null,
	create?: ValueTypes["IngredientSupplierListWithoutItemsCreateInput"] | undefined | null
};
	["IngredientSupplierListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["IngredientSupplierListEdge"],
		__typename?: boolean | `@${string}`
}>;
	["IngredientSupplierListEdge"]: AliasType<{
	node?:ValueTypes["IngredientSupplierList"],
		__typename?: boolean | `@${string}`
}>;
	["IngredientSupplierLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	root?: ValueTypes["IngredientSupplierLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["IngredientSupplierLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IngredientSupplierLocaleUpdateInput"]: {
	name?: string | undefined | null,
	root?: ValueTypes["IngredientSupplierLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["IngredientSupplierLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RedirectConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["RedirectEdge"],
		__typename?: boolean | `@${string}`
}>;
	["RedirectEdge"]: AliasType<{
	node?:ValueTypes["Redirect"],
		__typename?: boolean | `@${string}`
}>;
	["RedirectCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	link?: ValueTypes["RedirectCreateLinkEntityRelationInput"] | undefined | null,
	target?: ValueTypes["RedirectCreateTargetEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RedirectCreateLinkEntityRelationInput"]: {
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null,
	create?: ValueTypes["LinkableWithoutRedirectCreateInput"] | undefined | null
};
	["LinkableWithoutRedirectCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	url?: string | undefined | null,
	blogPost?: ValueTypes["LinkableCreateBlogPostEntityRelationInput"] | undefined | null,
	page?: ValueTypes["LinkableCreatePageEntityRelationInput"] | undefined | null,
	wikiPage?: ValueTypes["LinkableCreateWikiPageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RedirectUpdateInput"]: {
	link?: ValueTypes["RedirectUpdateLinkEntityRelationInput"] | undefined | null,
	target?: ValueTypes["RedirectUpdateTargetEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RedirectUpdateLinkEntityRelationInput"]: {
	create?: ValueTypes["LinkableWithoutRedirectCreateInput"] | undefined | null,
	update?: ValueTypes["LinkableWithoutRedirectUpdateInput"] | undefined | null,
	upsert?: ValueTypes["RedirectUpsertLinkRelationInput"] | undefined | null,
	connect?: ValueTypes["LinkableUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["LinkableWithoutRedirectUpdateInput"]: {
	url?: string | undefined | null,
	blogPost?: ValueTypes["LinkableUpdateBlogPostEntityRelationInput"] | undefined | null,
	page?: ValueTypes["LinkableUpdatePageEntityRelationInput"] | undefined | null,
	wikiPage?: ValueTypes["LinkableUpdateWikiPageEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RedirectUpsertLinkRelationInput"]: {
	update?: ValueTypes["LinkableWithoutRedirectUpdateInput"] | undefined | null,
	create?: ValueTypes["LinkableWithoutRedirectCreateInput"] | undefined | null
};
	["NutritionFactsConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["NutritionFactsEdge"],
		__typename?: boolean | `@${string}`
}>;
	["NutritionFactsEdge"]: AliasType<{
	node?:ValueTypes["NutritionFacts"],
		__typename?: boolean | `@${string}`
}>;
	["VenueCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	deadlineTemplate?: ValueTypes["VenueCreateDeadlineTemplateEntityRelationInput"] | undefined | null,
	timetableDays?: Array<ValueTypes["VenueCreateTimetableDaysEntityRelationInput"]> | undefined | null,
	timetableTemplates?: Array<ValueTypes["VenueCreateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	staffMembers?: Array<ValueTypes["VenueCreateStaffMembersEntityRelationInput"]> | undefined | null,
	employeeRoles?: Array<ValueTypes["VenueCreateEmployeeRolesEntityRelationInput"]> | undefined | null,
	pointOfSaleApplicationDevices?: Array<ValueTypes["VenueCreatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined | null,
	pointOfSaleTerminals?: Array<ValueTypes["VenueCreatePointOfSaleTerminalsEntityRelationInput"]> | undefined | null,
	pointOfSalePrinters?: Array<ValueTypes["VenueCreatePointOfSalePrintersEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["VenueCreateOrdersEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["VenueCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	areas?: Array<ValueTypes["VenueCreateAreasEntityRelationInput"]> | undefined | null,
	enabledUnassignReasons?: Array<ValueTypes["VenueCreateEnabledUnassignReasonsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["VenueCreateCategoriesEntityRelationInput"]> | undefined | null,
	channels?: Array<ValueTypes["VenueCreateChannelsEntityRelationInput"]> | undefined | null,
	address?: string | undefined | null,
	pointOfSalePngBase64ReceiptLogo?: string | undefined | null,
	pointOfSaleInitialView?: ValueTypes["PointOfSaleInitialView"] | undefined | null,
	pointOfSalePreferPrintReceipt?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VenueUpdateInput"]: {
	name?: string | undefined | null,
	deadlineTemplate?: ValueTypes["VenueUpdateDeadlineTemplateEntityRelationInput"] | undefined | null,
	timetableDays?: Array<ValueTypes["VenueUpdateTimetableDaysEntityRelationInput"]> | undefined | null,
	timetableTemplates?: Array<ValueTypes["VenueUpdateTimetableTemplatesEntityRelationInput"]> | undefined | null,
	staffMembers?: Array<ValueTypes["VenueUpdateStaffMembersEntityRelationInput"]> | undefined | null,
	employeeRoles?: Array<ValueTypes["VenueUpdateEmployeeRolesEntityRelationInput"]> | undefined | null,
	pointOfSaleApplicationDevices?: Array<ValueTypes["VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined | null,
	pointOfSaleTerminals?: Array<ValueTypes["VenueUpdatePointOfSaleTerminalsEntityRelationInput"]> | undefined | null,
	pointOfSalePrinters?: Array<ValueTypes["VenueUpdatePointOfSalePrintersEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["VenueUpdateOrdersEntityRelationInput"]> | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["VenueUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	areas?: Array<ValueTypes["VenueUpdateAreasEntityRelationInput"]> | undefined | null,
	enabledUnassignReasons?: Array<ValueTypes["VenueUpdateEnabledUnassignReasonsEntityRelationInput"]> | undefined | null,
	categories?: Array<ValueTypes["VenueUpdateCategoriesEntityRelationInput"]> | undefined | null,
	channels?: Array<ValueTypes["VenueUpdateChannelsEntityRelationInput"]> | undefined | null,
	address?: string | undefined | null,
	pointOfSalePngBase64ReceiptLogo?: string | undefined | null,
	pointOfSaleInitialView?: ValueTypes["PointOfSaleInitialView"] | undefined | null,
	pointOfSalePreferPrintReceipt?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["WorkspaceConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["WorkspaceEdge"],
		__typename?: boolean | `@${string}`
}>;
	["WorkspaceEdge"]: AliasType<{
	node?:ValueTypes["Workspace"],
		__typename?: boolean | `@${string}`
}>;
	["WorkspaceCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	unique?: ValueTypes["One"] | undefined | null,
	orderDeadlineTime?: string | undefined | null,
	ordersLoadingDurationHours?: number | undefined | null,
	freshingContainerVolumeMl?: number | undefined | null,
	freshingPrepareOrderByOffsetMinutes?: number | undefined | null,
	checkoutUrlTemplate?: string | undefined | null,
	orderUrlTemplate?: string | undefined | null,
	paymentUrlTemplate?: string | undefined | null,
	customerProfileUrlTemplate?: string | undefined | null,
	userProfileUrlTemplate?: string | undefined | null,
	messengerUrl?: string | undefined | null,
	messengerIosUrl?: string | undefined | null,
	messengerAndroidUrl?: string | undefined | null,
	freshingContainers?: Array<ValueTypes["WorkspaceCreateFreshingContainersEntityRelationInput"]> | undefined | null,
	openingHours?: ValueTypes["WorkspaceCreateOpeningHoursEntityRelationInput"] | undefined | null,
	workingHours?: ValueTypes["WorkspaceCreateWorkingHoursEntityRelationInput"] | undefined | null,
	defaultFreshingContainer?: ValueTypes["WorkspaceCreateDefaultFreshingContainerEntityRelationInput"] | undefined | null,
	creditsProduct?: ValueTypes["WorkspaceCreateCreditsProductEntityRelationInput"] | undefined | null,
	discountVatRate?: ValueTypes["WorkspaceCreateDiscountVatRateEntityRelationInput"] | undefined | null,
	name?: string | undefined | null,
	businessAddress?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["WorkspaceCreateFreshingContainersEntityRelationInput"]: {
	connect?: ValueTypes["FreshingContainerUniqueWhere"] | undefined | null,
	create?: ValueTypes["FreshingContainerWithoutWorkspaceCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["FreshingContainerWithoutWorkspaceCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	volumeMl?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["WorkspaceUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null,
	orderDeadlineTime?: string | undefined | null,
	ordersLoadingDurationHours?: number | undefined | null,
	freshingContainerVolumeMl?: number | undefined | null,
	freshingPrepareOrderByOffsetMinutes?: number | undefined | null,
	checkoutUrlTemplate?: string | undefined | null,
	orderUrlTemplate?: string | undefined | null,
	paymentUrlTemplate?: string | undefined | null,
	customerProfileUrlTemplate?: string | undefined | null,
	userProfileUrlTemplate?: string | undefined | null,
	messengerUrl?: string | undefined | null,
	messengerIosUrl?: string | undefined | null,
	messengerAndroidUrl?: string | undefined | null,
	freshingContainers?: Array<ValueTypes["WorkspaceUpdateFreshingContainersEntityRelationInput"]> | undefined | null,
	openingHours?: ValueTypes["WorkspaceUpdateOpeningHoursEntityRelationInput"] | undefined | null,
	workingHours?: ValueTypes["WorkspaceUpdateWorkingHoursEntityRelationInput"] | undefined | null,
	defaultFreshingContainer?: ValueTypes["WorkspaceUpdateDefaultFreshingContainerEntityRelationInput"] | undefined | null,
	creditsProduct?: ValueTypes["WorkspaceUpdateCreditsProductEntityRelationInput"] | undefined | null,
	discountVatRate?: ValueTypes["WorkspaceUpdateDiscountVatRateEntityRelationInput"] | undefined | null,
	name?: string | undefined | null,
	businessAddress?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["WorkspaceUpdateFreshingContainersEntityRelationInput"]: {
	create?: ValueTypes["FreshingContainerWithoutWorkspaceCreateInput"] | undefined | null,
	update?: ValueTypes["WorkspaceUpdateFreshingContainersRelationInput"] | undefined | null,
	upsert?: ValueTypes["WorkspaceUpsertFreshingContainersRelationInput"] | undefined | null,
	connect?: ValueTypes["FreshingContainerUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["FreshingContainerUniqueWhere"] | undefined | null,
	delete?: ValueTypes["FreshingContainerUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["WorkspaceUpdateFreshingContainersRelationInput"]: {
	by?: ValueTypes["FreshingContainerUniqueWhere"] | undefined | null,
	data?: ValueTypes["FreshingContainerWithoutWorkspaceUpdateInput"] | undefined | null
};
	["FreshingContainerWithoutWorkspaceUpdateInput"]: {
	order?: number | undefined | null,
	volumeMl?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["WorkspaceUpsertFreshingContainersRelationInput"]: {
	by?: ValueTypes["FreshingContainerUniqueWhere"] | undefined | null,
	update?: ValueTypes["FreshingContainerWithoutWorkspaceUpdateInput"] | undefined | null,
	create?: ValueTypes["FreshingContainerWithoutWorkspaceCreateInput"] | undefined | null
};
	["InternalBuyerConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["InternalBuyerEdge"],
		__typename?: boolean | `@${string}`
}>;
	["InternalBuyerEdge"]: AliasType<{
	node?:ValueTypes["InternalBuyer"],
		__typename?: boolean | `@${string}`
}>;
	["InternalBuyerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	staff?: ValueTypes["InternalBuyerCreateStaffEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InternalBuyerCreateStaffEntityRelationInput"]: {
	connect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	create?: ValueTypes["StaffWithoutInternalBuyerCreateInput"] | undefined | null
};
	["StaffWithoutInternalBuyerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	bartender?: ValueTypes["StaffCreateBartenderEntityRelationInput"] | undefined | null,
	courier?: ValueTypes["StaffCreateCourierEntityRelationInput"] | undefined | null,
	cleaner?: ValueTypes["StaffCreateCleanerEntityRelationInput"] | undefined | null,
	shiftsManager?: ValueTypes["StaffCreateShiftsManagerEntityRelationInput"] | undefined | null,
	businessToBusinessManager?: ValueTypes["StaffCreateBusinessToBusinessManagerEntityRelationInput"] | undefined | null,
	user?: ValueTypes["StaffCreateUserEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["StaffCreateShiftsProfileEntityRelationInput"] | undefined | null,
	stocksManager?: ValueTypes["StaffCreateStocksManagerEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["StaffCreatePhotoEntityRelationInput"] | undefined | null,
	courierManager?: ValueTypes["StaffCreateCourierManagerEntityRelationInput"] | undefined | null,
	picker?: ValueTypes["StaffCreatePickerEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	remunerationProfile?: ValueTypes["StaffCreateRemunerationProfileEntityRelationInput"] | undefined | null,
	cashier?: ValueTypes["StaffCreateCashierEntityRelationInput"] | undefined | null,
	venues?: Array<ValueTypes["StaffCreateVenuesEntityRelationInput"]> | undefined | null,
	salesManager?: ValueTypes["StaffCreateSalesManagerEntityRelationInput"] | undefined | null,
	cashierManager?: ValueTypes["StaffCreateCashierManagerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InternalBuyerUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	staff?: ValueTypes["InternalBuyerUpdateStaffEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InternalBuyerUpdateStaffEntityRelationInput"]: {
	create?: ValueTypes["StaffWithoutInternalBuyerCreateInput"] | undefined | null,
	update?: ValueTypes["StaffWithoutInternalBuyerUpdateInput"] | undefined | null,
	upsert?: ValueTypes["InternalBuyerUpsertStaffRelationInput"] | undefined | null,
	connect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["StaffWithoutInternalBuyerUpdateInput"]: {
	bartender?: ValueTypes["StaffUpdateBartenderEntityRelationInput"] | undefined | null,
	courier?: ValueTypes["StaffUpdateCourierEntityRelationInput"] | undefined | null,
	cleaner?: ValueTypes["StaffUpdateCleanerEntityRelationInput"] | undefined | null,
	shiftsManager?: ValueTypes["StaffUpdateShiftsManagerEntityRelationInput"] | undefined | null,
	businessToBusinessManager?: ValueTypes["StaffUpdateBusinessToBusinessManagerEntityRelationInput"] | undefined | null,
	user?: ValueTypes["StaffUpdateUserEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["StaffUpdateShiftsProfileEntityRelationInput"] | undefined | null,
	stocksManager?: ValueTypes["StaffUpdateStocksManagerEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["StaffUpdatePhotoEntityRelationInput"] | undefined | null,
	courierManager?: ValueTypes["StaffUpdateCourierManagerEntityRelationInput"] | undefined | null,
	picker?: ValueTypes["StaffUpdatePickerEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	remunerationProfile?: ValueTypes["StaffUpdateRemunerationProfileEntityRelationInput"] | undefined | null,
	cashier?: ValueTypes["StaffUpdateCashierEntityRelationInput"] | undefined | null,
	venues?: Array<ValueTypes["StaffUpdateVenuesEntityRelationInput"]> | undefined | null,
	salesManager?: ValueTypes["StaffUpdateSalesManagerEntityRelationInput"] | undefined | null,
	cashierManager?: ValueTypes["StaffUpdateCashierManagerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["InternalBuyerUpsertStaffRelationInput"]: {
	update?: ValueTypes["StaffWithoutInternalBuyerUpdateInput"] | undefined | null,
	create?: ValueTypes["StaffWithoutInternalBuyerCreateInput"] | undefined | null
};
	["CartSummaryConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CartSummaryEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CartSummaryEdge"]: AliasType<{
	node?:ValueTypes["CartSummary"],
		__typename?: boolean | `@${string}`
}>;
	["OrderSummaryConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["OrderSummaryEdge"],
		__typename?: boolean | `@${string}`
}>;
	["OrderSummaryEdge"]: AliasType<{
	node?:ValueTypes["OrderSummary"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerSpendingConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CustomerSpendingEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerSpendingEdge"]: AliasType<{
	node?:ValueTypes["CustomerSpending"],
		__typename?: boolean | `@${string}`
}>;
	["OrderPaymentMetadataConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["OrderPaymentMetadataEdge"],
		__typename?: boolean | `@${string}`
}>;
	["OrderPaymentMetadataEdge"]: AliasType<{
	node?:ValueTypes["OrderPaymentMetadata"],
		__typename?: boolean | `@${string}`
}>;
	["UserMetadataConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["UserMetadataEdge"],
		__typename?: boolean | `@${string}`
}>;
	["UserMetadataEdge"]: AliasType<{
	node?:ValueTypes["UserMetadata"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerTabMetadataConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CustomerTabMetadataEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerTabMetadataEdge"]: AliasType<{
	node?:ValueTypes["CustomerTabMetadata"],
		__typename?: boolean | `@${string}`
}>;
	["VenueEmployeeRoleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	employeePrivileges?: ValueTypes["VenueEmployeeRoleCreateEmployeePrivilegesEntityRelationInput"] | undefined | null,
	venue?: ValueTypes["VenueEmployeeRoleCreateVenueEntityRelationInput"] | undefined | null,
	role?: ValueTypes["VenueEmployeeRoleCreateRoleEntityRelationInput"] | undefined | null,
	getsTipsShare?: boolean | undefined | null,
	notesEnabled?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["VenueEmployeeRoleUpdateInput"]: {
	order?: number | undefined | null,
	employeePrivileges?: ValueTypes["VenueEmployeeRoleUpdateEmployeePrivilegesEntityRelationInput"] | undefined | null,
	venue?: ValueTypes["VenueEmployeeRoleUpdateVenueEntityRelationInput"] | undefined | null,
	role?: ValueTypes["VenueEmployeeRoleUpdateRoleEntityRelationInput"] | undefined | null,
	getsTipsShare?: boolean | undefined | null,
	notesEnabled?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IdentificationAttemptCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	code?: ValueTypes["IdentificationAttemptCreateCodeEntityRelationInput"] | undefined | null,
	user?: ValueTypes["IdentificationAttemptCreateUserEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IdentificationAttemptUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	code?: ValueTypes["IdentificationAttemptUpdateCodeEntityRelationInput"] | undefined | null,
	user?: ValueTypes["IdentificationAttemptUpdateUserEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IdentificationCodeConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["IdentificationCodeEdge"],
		__typename?: boolean | `@${string}`
}>;
	["IdentificationCodeEdge"]: AliasType<{
	node?:ValueTypes["IdentificationCode"],
		__typename?: boolean | `@${string}`
}>;
	["IdentificationCodeCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	attempts?: Array<ValueTypes["IdentificationCodeCreateAttemptsEntityRelationInput"]> | undefined | null,
	locales?: Array<ValueTypes["IdentificationCodeCreateLocalesEntityRelationInput"]> | undefined | null,
	internalName?: string | undefined | null,
	applicationDevices?: Array<ValueTypes["IdentificationCodeCreateApplicationDevicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IdentificationCodeUpdateInput"]: {
	code?: string | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	attempts?: Array<ValueTypes["IdentificationCodeUpdateAttemptsEntityRelationInput"]> | undefined | null,
	locales?: Array<ValueTypes["IdentificationCodeUpdateLocalesEntityRelationInput"]> | undefined | null,
	internalName?: string | undefined | null,
	applicationDevices?: Array<ValueTypes["IdentificationCodeUpdateApplicationDevicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IdentificationCodeLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	successMessage?: string | undefined | null,
	root?: ValueTypes["IdentificationCodeLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["IdentificationCodeLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["IdentificationCodeLocaleUpdateInput"]: {
	successMessage?: string | undefined | null,
	root?: ValueTypes["IdentificationCodeLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["IdentificationCodeLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PipelineConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PipelineEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineEdge"]: AliasType<{
	node?:ValueTypes["Pipeline"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	unique?: ValueTypes["One"] | undefined | null,
	stages?: Array<ValueTypes["PipelineCreateStagesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PipelineCreateStagesEntityRelationInput"]: {
	connect?: ValueTypes["PipelineStageUniqueWhere"] | undefined | null,
	create?: ValueTypes["PipelineStageWithoutPipelineCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["PipelineStageWithoutPipelineCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: Array<ValueTypes["PipelineStageCreateItemsEntityRelationInput"]> | undefined | null,
	order?: number | undefined | null,
	locales?: Array<ValueTypes["PipelineStageCreateLocalesEntityRelationInput"]> | undefined | null,
	sentiment?: ValueTypes["PipelineStageCreateSentimentEntityRelationInput"] | undefined | null,
	type?: ValueTypes["PipelineStageType"] | undefined | null,
	forms?: Array<ValueTypes["PipelineStageCreateFormsEntityRelationInput"]> | undefined | null,
	showItemsWeight?: boolean | undefined | null,
	showItemsPrice?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PipelineUpdateInput"]: {
	unique?: ValueTypes["One"] | undefined | null,
	stages?: Array<ValueTypes["PipelineUpdateStagesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PipelineUpdateStagesEntityRelationInput"]: {
	create?: ValueTypes["PipelineStageWithoutPipelineCreateInput"] | undefined | null,
	update?: ValueTypes["PipelineUpdateStagesRelationInput"] | undefined | null,
	upsert?: ValueTypes["PipelineUpsertStagesRelationInput"] | undefined | null,
	connect?: ValueTypes["PipelineStageUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["PipelineStageUniqueWhere"] | undefined | null,
	delete?: ValueTypes["PipelineStageUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["PipelineUpdateStagesRelationInput"]: {
	by?: ValueTypes["PipelineStageUniqueWhere"] | undefined | null,
	data?: ValueTypes["PipelineStageWithoutPipelineUpdateInput"] | undefined | null
};
	["PipelineStageWithoutPipelineUpdateInput"]: {
	items?: Array<ValueTypes["PipelineStageUpdateItemsEntityRelationInput"]> | undefined | null,
	order?: number | undefined | null,
	locales?: Array<ValueTypes["PipelineStageUpdateLocalesEntityRelationInput"]> | undefined | null,
	sentiment?: ValueTypes["PipelineStageUpdateSentimentEntityRelationInput"] | undefined | null,
	type?: ValueTypes["PipelineStageType"] | undefined | null,
	forms?: Array<ValueTypes["PipelineStageUpdateFormsEntityRelationInput"]> | undefined | null,
	showItemsWeight?: boolean | undefined | null,
	showItemsPrice?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PipelineUpsertStagesRelationInput"]: {
	by?: ValueTypes["PipelineStageUniqueWhere"] | undefined | null,
	update?: ValueTypes["PipelineStageWithoutPipelineUpdateInput"] | undefined | null,
	create?: ValueTypes["PipelineStageWithoutPipelineCreateInput"] | undefined | null
};
	["PipelineLeadCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	stageItem?: ValueTypes["PipelineLeadCreateStageItemEntityRelationInput"] | undefined | null,
	contactPerson?: string | undefined | null,
	customer?: ValueTypes["PipelineLeadCreateCustomerEntityRelationInput"] | undefined | null,
	cafeType?: string | undefined | null,
	offerType?: string | undefined | null,
	ownMachine?: boolean | undefined | null,
	customerCity?: string | undefined | null,
	companyId?: string | undefined | null,
	customerName?: string | undefined | null,
	email?: string | undefined | null,
	phone?: string | undefined | null,
	form?: ValueTypes["PipelineLeadCreateFormEntityRelationInput"] | undefined | null,
	meta?: string | undefined | null,
	multiroasterType?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PipelineLeadUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	stageItem?: ValueTypes["PipelineLeadUpdateStageItemEntityRelationInput"] | undefined | null,
	contactPerson?: string | undefined | null,
	customer?: ValueTypes["PipelineLeadUpdateCustomerEntityRelationInput"] | undefined | null,
	cafeType?: string | undefined | null,
	offerType?: string | undefined | null,
	ownMachine?: boolean | undefined | null,
	customerCity?: string | undefined | null,
	companyId?: string | undefined | null,
	customerName?: string | undefined | null,
	email?: string | undefined | null,
	phone?: string | undefined | null,
	form?: ValueTypes["PipelineLeadUpdateFormEntityRelationInput"] | undefined | null,
	meta?: string | undefined | null,
	multiroasterType?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PipelineStageCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: Array<ValueTypes["PipelineStageCreateItemsEntityRelationInput"]> | undefined | null,
	pipeline?: ValueTypes["PipelineStageCreatePipelineEntityRelationInput"] | undefined | null,
	order?: number | undefined | null,
	locales?: Array<ValueTypes["PipelineStageCreateLocalesEntityRelationInput"]> | undefined | null,
	sentiment?: ValueTypes["PipelineStageCreateSentimentEntityRelationInput"] | undefined | null,
	type?: ValueTypes["PipelineStageType"] | undefined | null,
	forms?: Array<ValueTypes["PipelineStageCreateFormsEntityRelationInput"]> | undefined | null,
	showItemsWeight?: boolean | undefined | null,
	showItemsPrice?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PipelineStageUpdateInput"]: {
	items?: Array<ValueTypes["PipelineStageUpdateItemsEntityRelationInput"]> | undefined | null,
	pipeline?: ValueTypes["PipelineStageUpdatePipelineEntityRelationInput"] | undefined | null,
	order?: number | undefined | null,
	locales?: Array<ValueTypes["PipelineStageUpdateLocalesEntityRelationInput"]> | undefined | null,
	sentiment?: ValueTypes["PipelineStageUpdateSentimentEntityRelationInput"] | undefined | null,
	type?: ValueTypes["PipelineStageType"] | undefined | null,
	forms?: Array<ValueTypes["PipelineStageUpdateFormsEntityRelationInput"]> | undefined | null,
	showItemsWeight?: boolean | undefined | null,
	showItemsPrice?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PipelineStageItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	list?: ValueTypes["PipelineStageItemCreateListEntityRelationInput"] | undefined | null,
	lead?: ValueTypes["PipelineStageItemCreateLeadEntityRelationInput"] | undefined | null,
	order?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PipelineStageItemUpdateInput"]: {
	list?: ValueTypes["PipelineStageItemUpdateListEntityRelationInput"] | undefined | null,
	lead?: ValueTypes["PipelineStageItemUpdateLeadEntityRelationInput"] | undefined | null,
	order?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PipelineStageLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	root?: ValueTypes["PipelineStageLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["PipelineStageLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PipelineStageLocaleUpdateInput"]: {
	name?: string | undefined | null,
	root?: ValueTypes["PipelineStageLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["PipelineStageLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SalesManagerConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SalesManagerEdge"],
		__typename?: boolean | `@${string}`
}>;
	["SalesManagerEdge"]: AliasType<{
	node?:ValueTypes["SalesManager"],
		__typename?: boolean | `@${string}`
}>;
	["SalesManagerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	staff?: ValueTypes["SalesManagerCreateStaffEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	countries?: Array<ValueTypes["SalesManagerCreateCountriesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SalesManagerCreateStaffEntityRelationInput"]: {
	connect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	create?: ValueTypes["StaffWithoutSalesManagerCreateInput"] | undefined | null
};
	["StaffWithoutSalesManagerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	bartender?: ValueTypes["StaffCreateBartenderEntityRelationInput"] | undefined | null,
	courier?: ValueTypes["StaffCreateCourierEntityRelationInput"] | undefined | null,
	cleaner?: ValueTypes["StaffCreateCleanerEntityRelationInput"] | undefined | null,
	shiftsManager?: ValueTypes["StaffCreateShiftsManagerEntityRelationInput"] | undefined | null,
	businessToBusinessManager?: ValueTypes["StaffCreateBusinessToBusinessManagerEntityRelationInput"] | undefined | null,
	user?: ValueTypes["StaffCreateUserEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["StaffCreateShiftsProfileEntityRelationInput"] | undefined | null,
	stocksManager?: ValueTypes["StaffCreateStocksManagerEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["StaffCreatePhotoEntityRelationInput"] | undefined | null,
	courierManager?: ValueTypes["StaffCreateCourierManagerEntityRelationInput"] | undefined | null,
	picker?: ValueTypes["StaffCreatePickerEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	remunerationProfile?: ValueTypes["StaffCreateRemunerationProfileEntityRelationInput"] | undefined | null,
	cashier?: ValueTypes["StaffCreateCashierEntityRelationInput"] | undefined | null,
	venues?: Array<ValueTypes["StaffCreateVenuesEntityRelationInput"]> | undefined | null,
	internalBuyer?: ValueTypes["StaffCreateInternalBuyerEntityRelationInput"] | undefined | null,
	cashierManager?: ValueTypes["StaffCreateCashierManagerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SalesManagerUpdateInput"]: {
	staff?: ValueTypes["SalesManagerUpdateStaffEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	countries?: Array<ValueTypes["SalesManagerUpdateCountriesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SalesManagerUpdateStaffEntityRelationInput"]: {
	create?: ValueTypes["StaffWithoutSalesManagerCreateInput"] | undefined | null,
	update?: ValueTypes["StaffWithoutSalesManagerUpdateInput"] | undefined | null,
	upsert?: ValueTypes["SalesManagerUpsertStaffRelationInput"] | undefined | null,
	connect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["StaffWithoutSalesManagerUpdateInput"]: {
	bartender?: ValueTypes["StaffUpdateBartenderEntityRelationInput"] | undefined | null,
	courier?: ValueTypes["StaffUpdateCourierEntityRelationInput"] | undefined | null,
	cleaner?: ValueTypes["StaffUpdateCleanerEntityRelationInput"] | undefined | null,
	shiftsManager?: ValueTypes["StaffUpdateShiftsManagerEntityRelationInput"] | undefined | null,
	businessToBusinessManager?: ValueTypes["StaffUpdateBusinessToBusinessManagerEntityRelationInput"] | undefined | null,
	user?: ValueTypes["StaffUpdateUserEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["StaffUpdateShiftsProfileEntityRelationInput"] | undefined | null,
	stocksManager?: ValueTypes["StaffUpdateStocksManagerEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["StaffUpdatePhotoEntityRelationInput"] | undefined | null,
	courierManager?: ValueTypes["StaffUpdateCourierManagerEntityRelationInput"] | undefined | null,
	picker?: ValueTypes["StaffUpdatePickerEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	remunerationProfile?: ValueTypes["StaffUpdateRemunerationProfileEntityRelationInput"] | undefined | null,
	cashier?: ValueTypes["StaffUpdateCashierEntityRelationInput"] | undefined | null,
	venues?: Array<ValueTypes["StaffUpdateVenuesEntityRelationInput"]> | undefined | null,
	internalBuyer?: ValueTypes["StaffUpdateInternalBuyerEntityRelationInput"] | undefined | null,
	cashierManager?: ValueTypes["StaffUpdateCashierManagerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SalesManagerUpsertStaffRelationInput"]: {
	update?: ValueTypes["StaffWithoutSalesManagerUpdateInput"] | undefined | null,
	create?: ValueTypes["StaffWithoutSalesManagerCreateInput"] | undefined | null
};
	["CashierManagerConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CashierManagerEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CashierManagerEdge"]: AliasType<{
	node?:ValueTypes["CashierManager"],
		__typename?: boolean | `@${string}`
}>;
	["CashierManagerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	staff?: ValueTypes["CashierManagerCreateStaffEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CashierManagerCreateStaffEntityRelationInput"]: {
	connect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	create?: ValueTypes["StaffWithoutCashierManagerCreateInput"] | undefined | null
};
	["StaffWithoutCashierManagerCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	bartender?: ValueTypes["StaffCreateBartenderEntityRelationInput"] | undefined | null,
	courier?: ValueTypes["StaffCreateCourierEntityRelationInput"] | undefined | null,
	cleaner?: ValueTypes["StaffCreateCleanerEntityRelationInput"] | undefined | null,
	shiftsManager?: ValueTypes["StaffCreateShiftsManagerEntityRelationInput"] | undefined | null,
	businessToBusinessManager?: ValueTypes["StaffCreateBusinessToBusinessManagerEntityRelationInput"] | undefined | null,
	user?: ValueTypes["StaffCreateUserEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["StaffCreateShiftsProfileEntityRelationInput"] | undefined | null,
	stocksManager?: ValueTypes["StaffCreateStocksManagerEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["StaffCreatePhotoEntityRelationInput"] | undefined | null,
	courierManager?: ValueTypes["StaffCreateCourierManagerEntityRelationInput"] | undefined | null,
	picker?: ValueTypes["StaffCreatePickerEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	remunerationProfile?: ValueTypes["StaffCreateRemunerationProfileEntityRelationInput"] | undefined | null,
	cashier?: ValueTypes["StaffCreateCashierEntityRelationInput"] | undefined | null,
	venues?: Array<ValueTypes["StaffCreateVenuesEntityRelationInput"]> | undefined | null,
	internalBuyer?: ValueTypes["StaffCreateInternalBuyerEntityRelationInput"] | undefined | null,
	salesManager?: ValueTypes["StaffCreateSalesManagerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CashierManagerUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	staff?: ValueTypes["CashierManagerUpdateStaffEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CashierManagerUpdateStaffEntityRelationInput"]: {
	create?: ValueTypes["StaffWithoutCashierManagerCreateInput"] | undefined | null,
	update?: ValueTypes["StaffWithoutCashierManagerUpdateInput"] | undefined | null,
	upsert?: ValueTypes["CashierManagerUpsertStaffRelationInput"] | undefined | null,
	connect?: ValueTypes["StaffUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["StaffWithoutCashierManagerUpdateInput"]: {
	bartender?: ValueTypes["StaffUpdateBartenderEntityRelationInput"] | undefined | null,
	courier?: ValueTypes["StaffUpdateCourierEntityRelationInput"] | undefined | null,
	cleaner?: ValueTypes["StaffUpdateCleanerEntityRelationInput"] | undefined | null,
	shiftsManager?: ValueTypes["StaffUpdateShiftsManagerEntityRelationInput"] | undefined | null,
	businessToBusinessManager?: ValueTypes["StaffUpdateBusinessToBusinessManagerEntityRelationInput"] | undefined | null,
	user?: ValueTypes["StaffUpdateUserEntityRelationInput"] | undefined | null,
	shiftsProfile?: ValueTypes["StaffUpdateShiftsProfileEntityRelationInput"] | undefined | null,
	stocksManager?: ValueTypes["StaffUpdateStocksManagerEntityRelationInput"] | undefined | null,
	photo?: ValueTypes["StaffUpdatePhotoEntityRelationInput"] | undefined | null,
	courierManager?: ValueTypes["StaffUpdateCourierManagerEntityRelationInput"] | undefined | null,
	picker?: ValueTypes["StaffUpdatePickerEntityRelationInput"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	remunerationProfile?: ValueTypes["StaffUpdateRemunerationProfileEntityRelationInput"] | undefined | null,
	cashier?: ValueTypes["StaffUpdateCashierEntityRelationInput"] | undefined | null,
	venues?: Array<ValueTypes["StaffUpdateVenuesEntityRelationInput"]> | undefined | null,
	internalBuyer?: ValueTypes["StaffUpdateInternalBuyerEntityRelationInput"] | undefined | null,
	salesManager?: ValueTypes["StaffUpdateSalesManagerEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CashierManagerUpsertStaffRelationInput"]: {
	update?: ValueTypes["StaffWithoutCashierManagerUpdateInput"] | undefined | null,
	create?: ValueTypes["StaffWithoutCashierManagerCreateInput"] | undefined | null
};
	["UserRolesConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["UserRolesEdge"],
		__typename?: boolean | `@${string}`
}>;
	["UserRolesEdge"]: AliasType<{
	node?:ValueTypes["UserRoles"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleApplicationDeviceCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	internalName?: string | undefined | null,
	note?: string | undefined | null,
	venue?: ValueTypes["PointOfSaleApplicationDeviceCreateVenueEntityRelationInput"] | undefined | null,
	identificationCode?: ValueTypes["PointOfSaleApplicationDeviceCreateIdentificationCodeEntityRelationInput"] | undefined | null,
	identifier?: ValueTypes["PointOfSaleApplicationDeviceCreateIdentifierEntityRelationInput"] | undefined | null,
	terminal?: ValueTypes["PointOfSaleApplicationDeviceCreateTerminalEntityRelationInput"] | undefined | null,
	receiptPrinter?: ValueTypes["PointOfSaleApplicationDeviceCreateReceiptPrinterEntityRelationInput"] | undefined | null,
	ticketPrinters?: Array<ValueTypes["PointOfSaleApplicationDeviceCreateTicketPrintersEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleApplicationDeviceUpdateInput"]: {
	internalName?: string | undefined | null,
	note?: string | undefined | null,
	venue?: ValueTypes["PointOfSaleApplicationDeviceUpdateVenueEntityRelationInput"] | undefined | null,
	identificationCode?: ValueTypes["PointOfSaleApplicationDeviceUpdateIdentificationCodeEntityRelationInput"] | undefined | null,
	identifier?: ValueTypes["PointOfSaleApplicationDeviceUpdateIdentifierEntityRelationInput"] | undefined | null,
	terminal?: ValueTypes["PointOfSaleApplicationDeviceUpdateTerminalEntityRelationInput"] | undefined | null,
	receiptPrinter?: ValueTypes["PointOfSaleApplicationDeviceUpdateReceiptPrinterEntityRelationInput"] | undefined | null,
	ticketPrinters?: Array<ValueTypes["PointOfSaleApplicationDeviceUpdateTicketPrintersEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleTerminalCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	internalName?: string | undefined | null,
	note?: string | undefined | null,
	venue?: ValueTypes["PointOfSaleTerminalCreateVenueEntityRelationInput"] | undefined | null,
	applicationDevices?: Array<ValueTypes["PointOfSaleTerminalCreateApplicationDevicesEntityRelationInput"]> | undefined | null,
	ipAddress?: string | undefined | null,
	port?: number | undefined | null,
	type?: ValueTypes["PointOfSaleTerminalType"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSaleTerminalUpdateInput"]: {
	internalName?: string | undefined | null,
	note?: string | undefined | null,
	venue?: ValueTypes["PointOfSaleTerminalUpdateVenueEntityRelationInput"] | undefined | null,
	applicationDevices?: Array<ValueTypes["PointOfSaleTerminalUpdateApplicationDevicesEntityRelationInput"]> | undefined | null,
	ipAddress?: string | undefined | null,
	port?: number | undefined | null,
	type?: ValueTypes["PointOfSaleTerminalType"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PipelineStageSentimentConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PipelineStageSentimentEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineStageSentimentEdge"]: AliasType<{
	node?:ValueTypes["PipelineStageSentiment"],
		__typename?: boolean | `@${string}`
}>;
	["DeviceIdentifierConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["DeviceIdentifierEdge"],
		__typename?: boolean | `@${string}`
}>;
	["DeviceIdentifierEdge"]: AliasType<{
	node?:ValueTypes["DeviceIdentifier"],
		__typename?: boolean | `@${string}`
}>;
	["DeviceIdentifierCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	internalName?: string | undefined | null,
	device?: ValueTypes["DeviceIdentifierCreateDeviceEntityRelationInput"] | undefined | null,
	updatedAt?: ValueTypes["DateTime"] | undefined | null,
	platform?: string | undefined | null,
	resolution?: string | undefined | null,
	devicePixelRatio?: number | undefined | null,
	updatedByUser?: ValueTypes["DeviceIdentifierCreateUpdatedByUserEntityRelationInput"] | undefined | null,
	identifier?: string | undefined | null,
	applicationVersionIdentifier?: string | undefined | null,
	lastPointOfSaleSynchronizationErrorRawDetails?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeviceIdentifierCreateDeviceEntityRelationInput"]: {
	connect?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null,
	create?: ValueTypes["PointOfSaleApplicationDeviceWithoutIdentifierCreateInput"] | undefined | null
};
	["PointOfSaleApplicationDeviceWithoutIdentifierCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	internalName?: string | undefined | null,
	note?: string | undefined | null,
	venue?: ValueTypes["PointOfSaleApplicationDeviceCreateVenueEntityRelationInput"] | undefined | null,
	identificationCode?: ValueTypes["PointOfSaleApplicationDeviceCreateIdentificationCodeEntityRelationInput"] | undefined | null,
	terminal?: ValueTypes["PointOfSaleApplicationDeviceCreateTerminalEntityRelationInput"] | undefined | null,
	receiptPrinter?: ValueTypes["PointOfSaleApplicationDeviceCreateReceiptPrinterEntityRelationInput"] | undefined | null,
	ticketPrinters?: Array<ValueTypes["PointOfSaleApplicationDeviceCreateTicketPrintersEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeviceIdentifierUpdateInput"]: {
	internalName?: string | undefined | null,
	device?: ValueTypes["DeviceIdentifierUpdateDeviceEntityRelationInput"] | undefined | null,
	updatedAt?: ValueTypes["DateTime"] | undefined | null,
	platform?: string | undefined | null,
	resolution?: string | undefined | null,
	devicePixelRatio?: number | undefined | null,
	updatedByUser?: ValueTypes["DeviceIdentifierUpdateUpdatedByUserEntityRelationInput"] | undefined | null,
	identifier?: string | undefined | null,
	applicationVersionIdentifier?: string | undefined | null,
	lastPointOfSaleSynchronizationErrorRawDetails?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeviceIdentifierUpdateDeviceEntityRelationInput"]: {
	create?: ValueTypes["PointOfSaleApplicationDeviceWithoutIdentifierCreateInput"] | undefined | null,
	update?: ValueTypes["PointOfSaleApplicationDeviceWithoutIdentifierUpdateInput"] | undefined | null,
	upsert?: ValueTypes["DeviceIdentifierUpsertDeviceRelationInput"] | undefined | null,
	connect?: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["PointOfSaleApplicationDeviceWithoutIdentifierUpdateInput"]: {
	internalName?: string | undefined | null,
	note?: string | undefined | null,
	venue?: ValueTypes["PointOfSaleApplicationDeviceUpdateVenueEntityRelationInput"] | undefined | null,
	identificationCode?: ValueTypes["PointOfSaleApplicationDeviceUpdateIdentificationCodeEntityRelationInput"] | undefined | null,
	terminal?: ValueTypes["PointOfSaleApplicationDeviceUpdateTerminalEntityRelationInput"] | undefined | null,
	receiptPrinter?: ValueTypes["PointOfSaleApplicationDeviceUpdateReceiptPrinterEntityRelationInput"] | undefined | null,
	ticketPrinters?: Array<ValueTypes["PointOfSaleApplicationDeviceUpdateTicketPrintersEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["DeviceIdentifierUpsertDeviceRelationInput"]: {
	update?: ValueTypes["PointOfSaleApplicationDeviceWithoutIdentifierUpdateInput"] | undefined | null,
	create?: ValueTypes["PointOfSaleApplicationDeviceWithoutIdentifierCreateInput"] | undefined | null
};
	["DeviceIdentifierMetadataConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["DeviceIdentifierMetadataEdge"],
		__typename?: boolean | `@${string}`
}>;
	["DeviceIdentifierMetadataEdge"]: AliasType<{
	node?:ValueTypes["DeviceIdentifierMetadata"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSalePrinterCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	internalName?: string | undefined | null,
	note?: string | undefined | null,
	ipAddress?: string | undefined | null,
	applicationDevicesReceipt?: Array<ValueTypes["PointOfSalePrinterCreateApplicationDevicesReceiptEntityRelationInput"]> | undefined | null,
	applicationDevicesTicket?: Array<ValueTypes["PointOfSalePrinterCreateApplicationDevicesTicketEntityRelationInput"]> | undefined | null,
	venue?: ValueTypes["PointOfSalePrinterCreateVenueEntityRelationInput"] | undefined | null,
	ticketCategories?: Array<ValueTypes["PointOfSalePrinterCreateTicketCategoriesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PointOfSalePrinterUpdateInput"]: {
	internalName?: string | undefined | null,
	note?: string | undefined | null,
	ipAddress?: string | undefined | null,
	applicationDevicesReceipt?: Array<ValueTypes["PointOfSalePrinterUpdateApplicationDevicesReceiptEntityRelationInput"]> | undefined | null,
	applicationDevicesTicket?: Array<ValueTypes["PointOfSalePrinterUpdateApplicationDevicesTicketEntityRelationInput"]> | undefined | null,
	venue?: ValueTypes["PointOfSalePrinterUpdateVenueEntityRelationInput"] | undefined | null,
	ticketCategories?: Array<ValueTypes["PointOfSalePrinterUpdateTicketCategoriesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GratuityConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["GratuityEdge"],
		__typename?: boolean | `@${string}`
}>;
	["GratuityEdge"]: AliasType<{
	node?:ValueTypes["Gratuity"],
		__typename?: boolean | `@${string}`
}>;
	["GratuityCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	amountCents?: number | undefined | null,
	order?: ValueTypes["GratuityCreateOrderEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GratuityCreateOrderEntityRelationInput"]: {
	connect?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	create?: ValueTypes["OrderWithoutGratuityCreateInput"] | undefined | null
};
	["OrderWithoutGratuityCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	state?: ValueTypes["OrderState"] | undefined | null,
	fulfilledAt?: ValueTypes["DateTime"] | undefined | null,
	canceledAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	customer?: ValueTypes["OrderCreateCustomerEntityRelationInput"] | undefined | null,
	channel?: ValueTypes["OrderCreateChannelEntityRelationInput"] | undefined | null,
	discounts?: Array<ValueTypes["OrderCreateDiscountsEntityRelationInput"]> | undefined | null,
	delivery?: ValueTypes["OrderCreateDeliveryEntityRelationInput"] | undefined | null,
	items?: Array<ValueTypes["OrderCreateItemsEntityRelationInput"]> | undefined | null,
	internalNote?: string | undefined | null,
	cart?: ValueTypes["OrderCreateCartEntityRelationInput"] | undefined | null,
	events?: Array<ValueTypes["OrderCreateEventsEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingAddress?: ValueTypes["OrderCreateBillingAddressEntityRelationInput"] | undefined | null,
	priceLines?: Array<ValueTypes["OrderCreatePriceLinesEntityRelationInput"]> | undefined | null,
	payments?: Array<ValueTypes["OrderCreatePaymentsEntityRelationInput"]> | undefined | null,
	seq?: number | undefined | null,
	billingSubject?: ValueTypes["OrderCreateBillingSubjectEntityRelationInput"] | undefined | null,
	summary?: ValueTypes["OrderCreateSummaryEntityRelationInput"] | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	venue?: ValueTypes["OrderCreateVenueEntityRelationInput"] | undefined | null,
	fulfillmentNote?: string | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["OrderCreateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	doubleshotTotalWeightGrams?: number | undefined | null,
	doubleShotLegacyNumber?: string | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	doubleshotAdminUrl?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GratuityUpdateInput"]: {
	amountCents?: number | undefined | null,
	order?: ValueTypes["GratuityUpdateOrderEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GratuityUpdateOrderEntityRelationInput"]: {
	create?: ValueTypes["OrderWithoutGratuityCreateInput"] | undefined | null,
	update?: ValueTypes["OrderWithoutGratuityUpdateInput"] | undefined | null,
	upsert?: ValueTypes["GratuityUpsertOrderRelationInput"] | undefined | null,
	connect?: ValueTypes["OrderUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["OrderWithoutGratuityUpdateInput"]: {
	state?: ValueTypes["OrderState"] | undefined | null,
	fulfilledAt?: ValueTypes["DateTime"] | undefined | null,
	canceledAt?: ValueTypes["DateTime"] | undefined | null,
	note?: string | undefined | null,
	customer?: ValueTypes["OrderUpdateCustomerEntityRelationInput"] | undefined | null,
	channel?: ValueTypes["OrderUpdateChannelEntityRelationInput"] | undefined | null,
	discounts?: Array<ValueTypes["OrderUpdateDiscountsEntityRelationInput"]> | undefined | null,
	delivery?: ValueTypes["OrderUpdateDeliveryEntityRelationInput"] | undefined | null,
	items?: Array<ValueTypes["OrderUpdateItemsEntityRelationInput"]> | undefined | null,
	internalNote?: string | undefined | null,
	cart?: ValueTypes["OrderUpdateCartEntityRelationInput"] | undefined | null,
	events?: Array<ValueTypes["OrderUpdateEventsEntityRelationInput"]> | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	billingAddress?: ValueTypes["OrderUpdateBillingAddressEntityRelationInput"] | undefined | null,
	priceLines?: Array<ValueTypes["OrderUpdatePriceLinesEntityRelationInput"]> | undefined | null,
	payments?: Array<ValueTypes["OrderUpdatePaymentsEntityRelationInput"]> | undefined | null,
	seq?: number | undefined | null,
	billingSubject?: ValueTypes["OrderUpdateBillingSubjectEntityRelationInput"] | undefined | null,
	summary?: ValueTypes["OrderUpdateSummaryEntityRelationInput"] | undefined | null,
	doubleshotLegacyId?: string | undefined | null,
	venue?: ValueTypes["OrderUpdateVenueEntityRelationInput"] | undefined | null,
	fulfillmentNote?: string | undefined | null,
	fulfillmentNotes?: Array<ValueTypes["OrderUpdateFulfillmentNotesEntityRelationInput"]> | undefined | null,
	doubleshotTotalWeightGrams?: number | undefined | null,
	doubleShotLegacyNumber?: string | undefined | null,
	doubleshotLastUpdatedAt?: ValueTypes["DateTime"] | undefined | null,
	doubleshotAdminUrl?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GratuityUpsertOrderRelationInput"]: {
	update?: ValueTypes["OrderWithoutGratuityUpdateInput"] | undefined | null,
	create?: ValueTypes["OrderWithoutGratuityCreateInput"] | undefined | null
};
	["FulfillmentNoteCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	note?: string | undefined | null,
	products?: Array<ValueTypes["FulfillmentNoteCreateProductsEntityRelationInput"]> | undefined | null,
	tags?: Array<ValueTypes["FulfillmentNoteCreateTagsEntityRelationInput"]> | undefined | null,
	venues?: Array<ValueTypes["FulfillmentNoteCreateVenuesEntityRelationInput"]> | undefined | null,
	cartItems?: Array<ValueTypes["FulfillmentNoteCreateCartItemsEntityRelationInput"]> | undefined | null,
	orderItems?: Array<ValueTypes["FulfillmentNoteCreateOrderItemsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["FulfillmentNoteCreateOrdersEntityRelationInput"]> | undefined | null,
	highlight?: boolean | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	emoji?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FulfillmentNoteUpdateInput"]: {
	note?: string | undefined | null,
	products?: Array<ValueTypes["FulfillmentNoteUpdateProductsEntityRelationInput"]> | undefined | null,
	tags?: Array<ValueTypes["FulfillmentNoteUpdateTagsEntityRelationInput"]> | undefined | null,
	venues?: Array<ValueTypes["FulfillmentNoteUpdateVenuesEntityRelationInput"]> | undefined | null,
	cartItems?: Array<ValueTypes["FulfillmentNoteUpdateCartItemsEntityRelationInput"]> | undefined | null,
	orderItems?: Array<ValueTypes["FulfillmentNoteUpdateOrderItemsEntityRelationInput"]> | undefined | null,
	orders?: Array<ValueTypes["FulfillmentNoteUpdateOrdersEntityRelationInput"]> | undefined | null,
	highlight?: boolean | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	emoji?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["CustomerMetadataConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CustomerMetadataEdge"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerMetadataEdge"]: AliasType<{
	node?:ValueTypes["CustomerMetadata"],
		__typename?: boolean | `@${string}`
}>;
	["LeadFormCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	code?: string | undefined | null,
	stage?: ValueTypes["LeadFormCreateStageEntityRelationInput"] | undefined | null,
	leads?: Array<ValueTypes["LeadFormCreateLeadsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LeadFormUpdateInput"]: {
	code?: string | undefined | null,
	stage?: ValueTypes["LeadFormUpdateStageEntityRelationInput"] | undefined | null,
	leads?: Array<ValueTypes["LeadFormUpdateLeadsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SubscriptionBoxConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SubscriptionBoxEdge"],
		__typename?: boolean | `@${string}`
}>;
	["SubscriptionBoxEdge"]: AliasType<{
	node?:ValueTypes["SubscriptionBox"],
		__typename?: boolean | `@${string}`
}>;
	["SubscriptionBoxCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	locales?: Array<ValueTypes["SubscriptionBoxCreateLocalesEntityRelationInput"]> | undefined | null,
	unique?: ValueTypes["One"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SubscriptionBoxCreateLocalesEntityRelationInput"]: {
	connect?: ValueTypes["SubscriptionBoxLocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["SubscriptionBoxLocaleWithoutRootCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["SubscriptionBoxLocaleWithoutRootCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	stickerText?: string | undefined | null,
	descriptionText?: string | undefined | null,
	locale?: ValueTypes["SubscriptionBoxLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	secondaryTitle?: string | undefined | null,
	texts?: ValueTypes["SubscriptionBoxLocaleCreateTextsEntityRelationInput"] | undefined | null,
	secondaryTexts?: ValueTypes["SubscriptionBoxLocaleCreateSecondaryTextsEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SubscriptionBoxLocaleCreateLocaleEntityRelationInput"]: {
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	create?: ValueTypes["LocaleWithoutSubscriptionBoxesCreateInput"] | undefined | null
};
	["LocaleWithoutSubscriptionBoxesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	businessCategories?: Array<ValueTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleCreateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleCreatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleCreateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SubscriptionBoxUpdateInput"]: {
	locales?: Array<ValueTypes["SubscriptionBoxUpdateLocalesEntityRelationInput"]> | undefined | null,
	unique?: ValueTypes["One"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SubscriptionBoxUpdateLocalesEntityRelationInput"]: {
	create?: ValueTypes["SubscriptionBoxLocaleWithoutRootCreateInput"] | undefined | null,
	update?: ValueTypes["SubscriptionBoxUpdateLocalesRelationInput"] | undefined | null,
	upsert?: ValueTypes["SubscriptionBoxUpsertLocalesRelationInput"] | undefined | null,
	connect?: ValueTypes["SubscriptionBoxLocaleUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["SubscriptionBoxLocaleUniqueWhere"] | undefined | null,
	delete?: ValueTypes["SubscriptionBoxLocaleUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["SubscriptionBoxUpdateLocalesRelationInput"]: {
	by?: ValueTypes["SubscriptionBoxLocaleUniqueWhere"] | undefined | null,
	data?: ValueTypes["SubscriptionBoxLocaleWithoutRootUpdateInput"] | undefined | null
};
	["SubscriptionBoxLocaleWithoutRootUpdateInput"]: {
	title?: string | undefined | null,
	stickerText?: string | undefined | null,
	descriptionText?: string | undefined | null,
	locale?: ValueTypes["SubscriptionBoxLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	secondaryTitle?: string | undefined | null,
	texts?: ValueTypes["SubscriptionBoxLocaleUpdateTextsEntityRelationInput"] | undefined | null,
	secondaryTexts?: ValueTypes["SubscriptionBoxLocaleUpdateSecondaryTextsEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SubscriptionBoxLocaleUpdateLocaleEntityRelationInput"]: {
	create?: ValueTypes["LocaleWithoutSubscriptionBoxesCreateInput"] | undefined | null,
	update?: ValueTypes["LocaleWithoutSubscriptionBoxesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["SubscriptionBoxLocaleUpsertLocaleRelationInput"] | undefined | null,
	connect?: ValueTypes["LocaleUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["LocaleWithoutSubscriptionBoxesUpdateInput"]: {
	businessCategories?: Array<ValueTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined | null,
	productCategoryLists?: Array<ValueTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined | null,
	productIngredients?: Array<ValueTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined | null,
	orderRecurrences?: Array<ValueTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined | null,
	blogs?: Array<ValueTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined | null,
	blogPosts?: Array<ValueTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined | null,
	identifier?: ValueTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined | null,
	menus?: Array<ValueTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined | null,
	pages?: Array<ValueTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined | null,
	productIngredientCategories?: Array<ValueTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined | null,
	allergens?: Array<ValueTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined | null,
	productPackings?: Array<ValueTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined | null,
	products?: Array<ValueTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined | null,
	productRecipes?: Array<ValueTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategories?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined | null,
	pointOfSaleCategoryProducts?: Array<ValueTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined | null,
	deliveryMethods?: Array<ValueTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined | null,
	ingredientSuppliers?: Array<ValueTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined | null,
	identificationCodes?: Array<ValueTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined | null,
	pipelineStages?: Array<ValueTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined | null,
	businessServices?: Array<ValueTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SubscriptionBoxLocaleUpsertLocaleRelationInput"]: {
	update?: ValueTypes["LocaleWithoutSubscriptionBoxesUpdateInput"] | undefined | null,
	create?: ValueTypes["LocaleWithoutSubscriptionBoxesCreateInput"] | undefined | null
};
	["SubscriptionBoxUpsertLocalesRelationInput"]: {
	by?: ValueTypes["SubscriptionBoxLocaleUniqueWhere"] | undefined | null,
	update?: ValueTypes["SubscriptionBoxLocaleWithoutRootUpdateInput"] | undefined | null,
	create?: ValueTypes["SubscriptionBoxLocaleWithoutRootCreateInput"] | undefined | null
};
	["SubscriptionBoxLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	title?: string | undefined | null,
	stickerText?: string | undefined | null,
	descriptionText?: string | undefined | null,
	root?: ValueTypes["SubscriptionBoxLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["SubscriptionBoxLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	secondaryTitle?: string | undefined | null,
	texts?: ValueTypes["SubscriptionBoxLocaleCreateTextsEntityRelationInput"] | undefined | null,
	secondaryTexts?: ValueTypes["SubscriptionBoxLocaleCreateSecondaryTextsEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SubscriptionBoxLocaleUpdateInput"]: {
	title?: string | undefined | null,
	stickerText?: string | undefined | null,
	descriptionText?: string | undefined | null,
	root?: ValueTypes["SubscriptionBoxLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["SubscriptionBoxLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	secondaryTitle?: string | undefined | null,
	texts?: ValueTypes["SubscriptionBoxLocaleUpdateTextsEntityRelationInput"] | undefined | null,
	secondaryTexts?: ValueTypes["SubscriptionBoxLocaleUpdateSecondaryTextsEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TimetableDayMetadataConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TimetableDayMetadataEdge"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableDayMetadataEdge"]: AliasType<{
	node?:ValueTypes["TimetableDayMetadata"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessServiceConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BusinessServiceEdge"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessServiceEdge"]: AliasType<{
	node?:ValueTypes["BusinessService"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessServiceEventCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	fulfilledAt?: ValueTypes["DateTime"] | undefined | null,
	businessCustomer?: ValueTypes["BusinessServiceEventCreateBusinessCustomerEntityRelationInput"] | undefined | null,
	businessService?: ValueTypes["BusinessServiceEventCreateBusinessServiceEntityRelationInput"] | undefined | null,
	filledNumberOfPeople?: number | undefined | null,
	filledInvoiced?: boolean | undefined | null,
	filledEquipment?: string | undefined | null,
	filledMillTamDem?: boolean | undefined | null,
	filledSOEspresso?: boolean | undefined | null,
	filledFilterCoffeeInMenu?: boolean | undefined | null,
	filledWaterMeterStatus?: string | undefined | null,
	filledServiceAction?: string | undefined | null,
	filledInvoiceIdentifier?: string | undefined | null,
	filledNote?: string | undefined | null,
	filledContact?: string | undefined | null,
	filledPhone?: boolean | undefined | null,
	filledEmail?: boolean | undefined | null,
	filledGrindingStonesCondition?: string | undefined | null,
	createdBy?: ValueTypes["BusinessServiceEventCreateCreatedByEntityRelationInput"] | undefined | null,
	filledSupervisor?: ValueTypes["BusinessServiceEventCreateFilledSupervisorEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessServiceEventCreateBusinessCustomerEntityRelationInput"]: {
	connect?: ValueTypes["BusinessCustomerUniqueWhere"] | undefined | null,
	create?: ValueTypes["BusinessCustomerWithoutBusinessServiceEventsCreateInput"] | undefined | null
};
	["BusinessCustomerWithoutBusinessServiceEventsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	customer?: ValueTypes["BusinessCustomerCreateCustomerEntityRelationInput"] | undefined | null,
	owners?: Array<ValueTypes["BusinessCustomerCreateOwnersEntityRelationInput"]> | undefined | null,
	members?: Array<ValueTypes["BusinessCustomerCreateMembersEntityRelationInput"]> | undefined | null,
	category?: ValueTypes["BusinessCustomerCreateCategoryEntityRelationInput"] | undefined | null,
	accountManager?: ValueTypes["BusinessCustomerCreateAccountManagerEntityRelationInput"] | undefined | null,
	logo?: ValueTypes["BusinessCustomerCreateLogoEntityRelationInput"] | undefined | null,
	note?: string | undefined | null,
	doubleshotCoffeeEquipment?: ValueTypes["BusinessCustomerCreateDoubleshotCoffeeEquipmentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessServiceEventUpdateInput"]: {
	createdAt?: ValueTypes["DateTime"] | undefined | null,
	fulfilledAt?: ValueTypes["DateTime"] | undefined | null,
	businessCustomer?: ValueTypes["BusinessServiceEventUpdateBusinessCustomerEntityRelationInput"] | undefined | null,
	businessService?: ValueTypes["BusinessServiceEventUpdateBusinessServiceEntityRelationInput"] | undefined | null,
	filledNumberOfPeople?: number | undefined | null,
	filledInvoiced?: boolean | undefined | null,
	filledEquipment?: string | undefined | null,
	filledMillTamDem?: boolean | undefined | null,
	filledSOEspresso?: boolean | undefined | null,
	filledFilterCoffeeInMenu?: boolean | undefined | null,
	filledWaterMeterStatus?: string | undefined | null,
	filledServiceAction?: string | undefined | null,
	filledInvoiceIdentifier?: string | undefined | null,
	filledNote?: string | undefined | null,
	filledContact?: string | undefined | null,
	filledPhone?: boolean | undefined | null,
	filledEmail?: boolean | undefined | null,
	filledGrindingStonesCondition?: string | undefined | null,
	createdBy?: ValueTypes["BusinessServiceEventUpdateCreatedByEntityRelationInput"] | undefined | null,
	filledSupervisor?: ValueTypes["BusinessServiceEventUpdateFilledSupervisorEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessServiceEventUpdateBusinessCustomerEntityRelationInput"]: {
	create?: ValueTypes["BusinessCustomerWithoutBusinessServiceEventsCreateInput"] | undefined | null,
	update?: ValueTypes["BusinessCustomerWithoutBusinessServiceEventsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["BusinessServiceEventUpsertBusinessCustomerRelationInput"] | undefined | null,
	connect?: ValueTypes["BusinessCustomerUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["BusinessCustomerWithoutBusinessServiceEventsUpdateInput"]: {
	name?: string | undefined | null,
	customer?: ValueTypes["BusinessCustomerUpdateCustomerEntityRelationInput"] | undefined | null,
	owners?: Array<ValueTypes["BusinessCustomerUpdateOwnersEntityRelationInput"]> | undefined | null,
	members?: Array<ValueTypes["BusinessCustomerUpdateMembersEntityRelationInput"]> | undefined | null,
	category?: ValueTypes["BusinessCustomerUpdateCategoryEntityRelationInput"] | undefined | null,
	accountManager?: ValueTypes["BusinessCustomerUpdateAccountManagerEntityRelationInput"] | undefined | null,
	logo?: ValueTypes["BusinessCustomerUpdateLogoEntityRelationInput"] | undefined | null,
	note?: string | undefined | null,
	doubleshotCoffeeEquipment?: ValueTypes["BusinessCustomerUpdateDoubleshotCoffeeEquipmentEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessServiceEventUpsertBusinessCustomerRelationInput"]: {
	update?: ValueTypes["BusinessCustomerWithoutBusinessServiceEventsUpdateInput"] | undefined | null,
	create?: ValueTypes["BusinessCustomerWithoutBusinessServiceEventsCreateInput"] | undefined | null
};
	["BusinessServiceLocaleCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	labelNote?: string | undefined | null,
	root?: ValueTypes["BusinessServiceLocaleCreateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["BusinessServiceLocaleCreateLocaleEntityRelationInput"] | undefined | null,
	labelNumberOfPeople?: string | undefined | null,
	labelInvoiced?: string | undefined | null,
	labelEquipment?: string | undefined | null,
	labelMillTamDem?: string | undefined | null,
	labelSOEspresso?: string | undefined | null,
	labelFilterCoffeeInMenu?: string | undefined | null,
	labelWaterMeterStatus?: string | undefined | null,
	labelServiceAction?: string | undefined | null,
	labelInvoiceIdentifier?: string | undefined | null,
	labelSupervisor?: string | undefined | null,
	labelContact?: string | undefined | null,
	labelPhone?: string | undefined | null,
	labelEmail?: string | undefined | null,
	labelGrindingStonesCondition?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["BusinessServiceLocaleUpdateInput"]: {
	name?: string | undefined | null,
	labelNote?: string | undefined | null,
	root?: ValueTypes["BusinessServiceLocaleUpdateRootEntityRelationInput"] | undefined | null,
	locale?: ValueTypes["BusinessServiceLocaleUpdateLocaleEntityRelationInput"] | undefined | null,
	labelNumberOfPeople?: string | undefined | null,
	labelInvoiced?: string | undefined | null,
	labelEquipment?: string | undefined | null,
	labelMillTamDem?: string | undefined | null,
	labelSOEspresso?: string | undefined | null,
	labelFilterCoffeeInMenu?: string | undefined | null,
	labelWaterMeterStatus?: string | undefined | null,
	labelServiceAction?: string | undefined | null,
	labelInvoiceIdentifier?: string | undefined | null,
	labelSupervisor?: string | undefined | null,
	labelContact?: string | undefined | null,
	labelPhone?: string | undefined | null,
	labelEmail?: string | undefined | null,
	labelGrindingStonesCondition?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GridTileItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	text?: string | undefined | null,
	list?: ValueTypes["GridTileItemCreateListEntityRelationInput"] | undefined | null,
	medium?: ValueTypes["GridTileItemCreateMediumEntityRelationInput"] | undefined | null,
	link?: ValueTypes["GridTileItemCreateLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GridTileItemCreateListEntityRelationInput"]: {
	connect?: ValueTypes["GridTilesUniqueWhere"] | undefined | null,
	create?: ValueTypes["GridTilesWithoutItemsCreateInput"] | undefined | null
};
	["GridTilesWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GridTileItemUpdateInput"]: {
	order?: number | undefined | null,
	text?: string | undefined | null,
	list?: ValueTypes["GridTileItemUpdateListEntityRelationInput"] | undefined | null,
	medium?: ValueTypes["GridTileItemUpdateMediumEntityRelationInput"] | undefined | null,
	link?: ValueTypes["GridTileItemUpdateLinkEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["GridTileItemUpdateListEntityRelationInput"]: {
	create?: ValueTypes["GridTilesWithoutItemsCreateInput"] | undefined | null,
	update?: ValueTypes["GridTilesWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["GridTileItemUpsertListRelationInput"] | undefined | null,
	connect?: ValueTypes["GridTilesUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["GridTilesWithoutItemsUpdateInput"]: {
	_dummy_field_?: boolean | undefined | null
};
	["GridTileItemUpsertListRelationInput"]: {
	update?: ValueTypes["GridTilesWithoutItemsUpdateInput"] | undefined | null,
	create?: ValueTypes["GridTilesWithoutItemsCreateInput"] | undefined | null
};
	["GridTilesConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["GridTilesEdge"],
		__typename?: boolean | `@${string}`
}>;
	["GridTilesEdge"]: AliasType<{
	node?:ValueTypes["GridTiles"],
		__typename?: boolean | `@${string}`
}>;
	["AreaCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	name?: string | undefined | null,
	venue?: ValueTypes["AreaCreateVenueEntityRelationInput"] | undefined | null,
	tables?: Array<ValueTypes["AreaCreateTablesEntityRelationInput"]> | undefined | null,
	lines?: Array<ValueTypes["AreaCreateLinesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["AreaUpdateInput"]: {
	order?: number | undefined | null,
	name?: string | undefined | null,
	venue?: ValueTypes["AreaUpdateVenueEntityRelationInput"] | undefined | null,
	tables?: Array<ValueTypes["AreaUpdateTablesEntityRelationInput"]> | undefined | null,
	lines?: Array<ValueTypes["AreaUpdateLinesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["Position"]: AliasType<{
	_meta?:ValueTypes["PositionMeta"],
	id?:boolean | `@${string}`,
	x?:boolean | `@${string}`,
	y?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PositionMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	x?:ValueTypes["FieldMeta"],
	y?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["PositionUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["PositionWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	x?: ValueTypes["IntCondition"] | undefined | null,
	y?: ValueTypes["IntCondition"] | undefined | null,
	and?: Array<ValueTypes["PositionWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["PositionWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["PositionWhere"] | undefined | null
};
	["PositionOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	x?: ValueTypes["OrderDirection"] | undefined | null,
	y?: ValueTypes["OrderDirection"] | undefined | null
};
	["PositionConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PositionEdge"],
		__typename?: boolean | `@${string}`
}>;
	["PositionEdge"]: AliasType<{
	node?:ValueTypes["Position"],
		__typename?: boolean | `@${string}`
}>;
	["PositionCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	x?: number | undefined | null,
	y?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["PositionUpdateInput"]: {
	x?: number | undefined | null,
	y?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StatsEnabledWidgetType"]: AliasType<{
	_meta?:ValueTypes["StatsEnabledWidgetTypeMeta"],
	id?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
layout?: [{	filter?: ValueTypes["StatsWidgetsLayoutWhere"] | undefined | null},ValueTypes["StatsWidgetsLayout"]],
		__typename?: boolean | `@${string}`
}>;
	["StatsEnabledWidgetTypeMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	layout?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["StatsEnabledWidgetTypeType"]:StatsEnabledWidgetTypeType;
	["StatsWidgetsLayout"]: AliasType<{
	_meta?:ValueTypes["StatsWidgetsLayoutMeta"],
	id?:boolean | `@${string}`,
enabledWidgetTypes?: [{	filter?: ValueTypes["StatsEnabledWidgetTypeWhere"] | undefined | null,	orderBy?: Array<ValueTypes["StatsEnabledWidgetTypeOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["StatsEnabledWidgetType"]],
items?: [{	filter?: ValueTypes["StatsWidgetWhere"] | undefined | null,	orderBy?: Array<ValueTypes["StatsWidgetOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["StatsWidget"]],
enabledWidgetTypesByType?: [{	by: ValueTypes["StatsWidgetsLayoutEnabledWidgetTypesByTypeUniqueWhere"],	filter?: ValueTypes["StatsEnabledWidgetTypeWhere"] | undefined | null},ValueTypes["StatsEnabledWidgetType"]],
paginateEnabledWidgetTypes?: [{	filter?: ValueTypes["StatsEnabledWidgetTypeWhere"] | undefined | null,	orderBy?: Array<ValueTypes["StatsEnabledWidgetTypeOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["StatsEnabledWidgetTypeConnection"]],
paginateItems?: [{	filter?: ValueTypes["StatsWidgetWhere"] | undefined | null,	orderBy?: Array<ValueTypes["StatsWidgetOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["StatsWidgetConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["StatsWidgetsLayoutMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	enabledWidgetTypes?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["StatsEnabledWidgetTypeWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	type?: ValueTypes["StatsEnabledWidgetTypeTypeCondition"] | undefined | null,
	layout?: ValueTypes["StatsWidgetsLayoutWhere"] | undefined | null,
	and?: Array<ValueTypes["StatsEnabledWidgetTypeWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["StatsEnabledWidgetTypeWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["StatsEnabledWidgetTypeWhere"] | undefined | null
};
	["StatsEnabledWidgetTypeTypeCondition"]: {
	and?: Array<ValueTypes["StatsEnabledWidgetTypeTypeCondition"]> | undefined | null,
	or?: Array<ValueTypes["StatsEnabledWidgetTypeTypeCondition"]> | undefined | null,
	not?: ValueTypes["StatsEnabledWidgetTypeTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["StatsEnabledWidgetTypeType"] | undefined | null,
	notEq?: ValueTypes["StatsEnabledWidgetTypeType"] | undefined | null,
	in?: Array<ValueTypes["StatsEnabledWidgetTypeType"]> | undefined | null,
	notIn?: Array<ValueTypes["StatsEnabledWidgetTypeType"]> | undefined | null,
	lt?: ValueTypes["StatsEnabledWidgetTypeType"] | undefined | null,
	lte?: ValueTypes["StatsEnabledWidgetTypeType"] | undefined | null,
	gt?: ValueTypes["StatsEnabledWidgetTypeType"] | undefined | null,
	gte?: ValueTypes["StatsEnabledWidgetTypeType"] | undefined | null
};
	["StatsWidgetsLayoutWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	enabledWidgetTypes?: ValueTypes["StatsEnabledWidgetTypeWhere"] | undefined | null,
	items?: ValueTypes["StatsWidgetWhere"] | undefined | null,
	and?: Array<ValueTypes["StatsWidgetsLayoutWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["StatsWidgetsLayoutWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["StatsWidgetsLayoutWhere"] | undefined | null
};
	["StatsWidgetWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	size?: ValueTypes["IntCondition"] | undefined | null,
	type?: ValueTypes["StatsEnabledWidgetTypeTypeCondition"] | undefined | null,
	link?: ValueTypes["StringCondition"] | undefined | null,
	title?: ValueTypes["StringCondition"] | undefined | null,
	timeFrame?: ValueTypes["StatsWidgetTimeFrameCondition"] | undefined | null,
	layout?: ValueTypes["StatsWidgetsLayoutWhere"] | undefined | null,
	icon?: ValueTypes["ImageWhere"] | undefined | null,
	channels?: ValueTypes["ChannelWhere"] | undefined | null,
	productCategory?: ValueTypes["ProductCategoryWhere"] | undefined | null,
	paymentMethods?: ValueTypes["PaymentMethodWhere"] | undefined | null,
	hoursFrom?: ValueTypes["StringCondition"] | undefined | null,
	hoursTo?: ValueTypes["StringCondition"] | undefined | null,
	and?: Array<ValueTypes["StatsWidgetWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["StatsWidgetWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["StatsWidgetWhere"] | undefined | null
};
	["StatsWidgetTimeFrameCondition"]: {
	and?: Array<ValueTypes["StatsWidgetTimeFrameCondition"]> | undefined | null,
	or?: Array<ValueTypes["StatsWidgetTimeFrameCondition"]> | undefined | null,
	not?: ValueTypes["StatsWidgetTimeFrameCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["StatsWidgetTimeFrame"] | undefined | null,
	notEq?: ValueTypes["StatsWidgetTimeFrame"] | undefined | null,
	in?: Array<ValueTypes["StatsWidgetTimeFrame"]> | undefined | null,
	notIn?: Array<ValueTypes["StatsWidgetTimeFrame"]> | undefined | null,
	lt?: ValueTypes["StatsWidgetTimeFrame"] | undefined | null,
	lte?: ValueTypes["StatsWidgetTimeFrame"] | undefined | null,
	gt?: ValueTypes["StatsWidgetTimeFrame"] | undefined | null,
	gte?: ValueTypes["StatsWidgetTimeFrame"] | undefined | null
};
	["StatsWidgetTimeFrame"]:StatsWidgetTimeFrame;
	["StatsEnabledWidgetTypeOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	type?: ValueTypes["OrderDirection"] | undefined | null,
	layout?: ValueTypes["StatsWidgetsLayoutOrderBy"] | undefined | null
};
	["StatsWidgetsLayoutOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null
};
	["StatsWidget"]: AliasType<{
	_meta?:ValueTypes["StatsWidgetMeta"],
	id?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	size?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	link?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	timeFrame?:boolean | `@${string}`,
layout?: [{	filter?: ValueTypes["StatsWidgetsLayoutWhere"] | undefined | null},ValueTypes["StatsWidgetsLayout"]],
icon?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null},ValueTypes["Image"]],
channels?: [{	filter?: ValueTypes["ChannelWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ChannelOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Channel"]],
productCategory?: [{	filter?: ValueTypes["ProductCategoryWhere"] | undefined | null},ValueTypes["ProductCategory"]],
paymentMethods?: [{	filter?: ValueTypes["PaymentMethodWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PaymentMethodOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PaymentMethod"]],
	hoursFrom?:boolean | `@${string}`,
	hoursTo?:boolean | `@${string}`,
paginateChannels?: [{	filter?: ValueTypes["ChannelWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ChannelOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ChannelConnection"]],
paginatePaymentMethods?: [{	filter?: ValueTypes["PaymentMethodWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PaymentMethodOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PaymentMethodConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["StatsWidgetMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	size?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	timeFrame?:ValueTypes["FieldMeta"],
	layout?:ValueTypes["FieldMeta"],
	icon?:ValueTypes["FieldMeta"],
	channels?:ValueTypes["FieldMeta"],
	productCategory?:ValueTypes["FieldMeta"],
	paymentMethods?:ValueTypes["FieldMeta"],
	hoursFrom?:ValueTypes["FieldMeta"],
	hoursTo?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["StatsWidgetOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null,
	size?: ValueTypes["OrderDirection"] | undefined | null,
	type?: ValueTypes["OrderDirection"] | undefined | null,
	link?: ValueTypes["OrderDirection"] | undefined | null,
	title?: ValueTypes["OrderDirection"] | undefined | null,
	timeFrame?: ValueTypes["OrderDirection"] | undefined | null,
	layout?: ValueTypes["StatsWidgetsLayoutOrderBy"] | undefined | null,
	icon?: ValueTypes["ImageOrderBy"] | undefined | null,
	productCategory?: ValueTypes["ProductCategoryOrderBy"] | undefined | null,
	hoursFrom?: ValueTypes["OrderDirection"] | undefined | null,
	hoursTo?: ValueTypes["OrderDirection"] | undefined | null
};
	["StatsWidgetsLayoutEnabledWidgetTypesByTypeUniqueWhere"]: {
	type?: ValueTypes["StatsEnabledWidgetTypeType"] | undefined | null
};
	["StatsEnabledWidgetTypeConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["StatsEnabledWidgetTypeEdge"],
		__typename?: boolean | `@${string}`
}>;
	["StatsEnabledWidgetTypeEdge"]: AliasType<{
	node?:ValueTypes["StatsEnabledWidgetType"],
		__typename?: boolean | `@${string}`
}>;
	["StatsWidgetConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["StatsWidgetEdge"],
		__typename?: boolean | `@${string}`
}>;
	["StatsWidgetEdge"]: AliasType<{
	node?:ValueTypes["StatsWidget"],
		__typename?: boolean | `@${string}`
}>;
	["StatsEnabledWidgetTypeUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	layout?: ValueTypes["StatsWidgetsLayoutUniqueWhere"] | undefined | null,
	type?: ValueTypes["StatsEnabledWidgetTypeType"] | undefined | null
};
	["StatsWidgetsLayoutUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	enabledWidgetTypes?: ValueTypes["StatsEnabledWidgetTypeUniqueWhere"] | undefined | null,
	items?: ValueTypes["StatsWidgetUniqueWhere"] | undefined | null
};
	["StatsWidgetUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["StatsEnabledWidgetTypeCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	type?: ValueTypes["StatsEnabledWidgetTypeType"] | undefined | null,
	layout?: ValueTypes["StatsEnabledWidgetTypeCreateLayoutEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StatsEnabledWidgetTypeCreateLayoutEntityRelationInput"]: {
	connect?: ValueTypes["StatsWidgetsLayoutUniqueWhere"] | undefined | null,
	create?: ValueTypes["StatsWidgetsLayoutWithoutEnabledWidgetTypesCreateInput"] | undefined | null
};
	["StatsWidgetsLayoutWithoutEnabledWidgetTypesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: Array<ValueTypes["StatsWidgetsLayoutCreateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StatsWidgetsLayoutCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["StatsWidgetUniqueWhere"] | undefined | null,
	create?: ValueTypes["StatsWidgetWithoutLayoutCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["StatsWidgetWithoutLayoutCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	size?: number | undefined | null,
	type?: ValueTypes["StatsEnabledWidgetTypeType"] | undefined | null,
	link?: string | undefined | null,
	title?: string | undefined | null,
	timeFrame?: ValueTypes["StatsWidgetTimeFrame"] | undefined | null,
	icon?: ValueTypes["StatsWidgetCreateIconEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["StatsWidgetCreateChannelsEntityRelationInput"]> | undefined | null,
	productCategory?: ValueTypes["StatsWidgetCreateProductCategoryEntityRelationInput"] | undefined | null,
	paymentMethods?: Array<ValueTypes["StatsWidgetCreatePaymentMethodsEntityRelationInput"]> | undefined | null,
	hoursFrom?: string | undefined | null,
	hoursTo?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StatsWidgetCreateIconEntityRelationInput"]: {
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["StatsWidgetCreateChannelsEntityRelationInput"]: {
	connect?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	create?: ValueTypes["ChannelCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["StatsWidgetCreateProductCategoryEntityRelationInput"]: {
	connect?: ValueTypes["ProductCategoryUniqueWhere"] | undefined | null,
	create?: ValueTypes["ProductCategoryCreateInput"] | undefined | null
};
	["StatsWidgetCreatePaymentMethodsEntityRelationInput"]: {
	connect?: ValueTypes["PaymentMethodUniqueWhere"] | undefined | null,
	create?: ValueTypes["PaymentMethodCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["StatsEnabledWidgetTypeUpdateInput"]: {
	type?: ValueTypes["StatsEnabledWidgetTypeType"] | undefined | null,
	layout?: ValueTypes["StatsEnabledWidgetTypeUpdateLayoutEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StatsEnabledWidgetTypeUpdateLayoutEntityRelationInput"]: {
	create?: ValueTypes["StatsWidgetsLayoutWithoutEnabledWidgetTypesCreateInput"] | undefined | null,
	update?: ValueTypes["StatsWidgetsLayoutWithoutEnabledWidgetTypesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["StatsEnabledWidgetTypeUpsertLayoutRelationInput"] | undefined | null,
	connect?: ValueTypes["StatsWidgetsLayoutUniqueWhere"] | undefined | null
};
	["StatsWidgetsLayoutWithoutEnabledWidgetTypesUpdateInput"]: {
	items?: Array<ValueTypes["StatsWidgetsLayoutUpdateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StatsWidgetsLayoutUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["StatsWidgetWithoutLayoutCreateInput"] | undefined | null,
	update?: ValueTypes["StatsWidgetsLayoutUpdateItemsRelationInput"] | undefined | null,
	upsert?: ValueTypes["StatsWidgetsLayoutUpsertItemsRelationInput"] | undefined | null,
	connect?: ValueTypes["StatsWidgetUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["StatsWidgetUniqueWhere"] | undefined | null,
	delete?: ValueTypes["StatsWidgetUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["StatsWidgetsLayoutUpdateItemsRelationInput"]: {
	by?: ValueTypes["StatsWidgetUniqueWhere"] | undefined | null,
	data?: ValueTypes["StatsWidgetWithoutLayoutUpdateInput"] | undefined | null
};
	["StatsWidgetWithoutLayoutUpdateInput"]: {
	order?: number | undefined | null,
	size?: number | undefined | null,
	type?: ValueTypes["StatsEnabledWidgetTypeType"] | undefined | null,
	link?: string | undefined | null,
	title?: string | undefined | null,
	timeFrame?: ValueTypes["StatsWidgetTimeFrame"] | undefined | null,
	icon?: ValueTypes["StatsWidgetUpdateIconEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["StatsWidgetUpdateChannelsEntityRelationInput"]> | undefined | null,
	productCategory?: ValueTypes["StatsWidgetUpdateProductCategoryEntityRelationInput"] | undefined | null,
	paymentMethods?: Array<ValueTypes["StatsWidgetUpdatePaymentMethodsEntityRelationInput"]> | undefined | null,
	hoursFrom?: string | undefined | null,
	hoursTo?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StatsWidgetUpdateIconEntityRelationInput"]: {
	create?: ValueTypes["ImageCreateInput"] | undefined | null,
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	upsert?: ValueTypes["StatsWidgetUpsertIconRelationInput"] | undefined | null,
	connect?: ValueTypes["ImageUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["StatsWidgetUpsertIconRelationInput"]: {
	update?: ValueTypes["ImageUpdateInput"] | undefined | null,
	create?: ValueTypes["ImageCreateInput"] | undefined | null
};
	["StatsWidgetUpdateChannelsEntityRelationInput"]: {
	create?: ValueTypes["ChannelCreateInput"] | undefined | null,
	update?: ValueTypes["StatsWidgetUpdateChannelsRelationInput"] | undefined | null,
	upsert?: ValueTypes["StatsWidgetUpsertChannelsRelationInput"] | undefined | null,
	connect?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["StatsWidgetUpdateChannelsRelationInput"]: {
	by?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	data?: ValueTypes["ChannelUpdateInput"] | undefined | null
};
	["StatsWidgetUpsertChannelsRelationInput"]: {
	by?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	update?: ValueTypes["ChannelUpdateInput"] | undefined | null,
	create?: ValueTypes["ChannelCreateInput"] | undefined | null
};
	["StatsWidgetUpdateProductCategoryEntityRelationInput"]: {
	create?: ValueTypes["ProductCategoryCreateInput"] | undefined | null,
	update?: ValueTypes["ProductCategoryUpdateInput"] | undefined | null,
	upsert?: ValueTypes["StatsWidgetUpsertProductCategoryRelationInput"] | undefined | null,
	connect?: ValueTypes["ProductCategoryUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["StatsWidgetUpsertProductCategoryRelationInput"]: {
	update?: ValueTypes["ProductCategoryUpdateInput"] | undefined | null,
	create?: ValueTypes["ProductCategoryCreateInput"] | undefined | null
};
	["StatsWidgetUpdatePaymentMethodsEntityRelationInput"]: {
	create?: ValueTypes["PaymentMethodCreateInput"] | undefined | null,
	update?: ValueTypes["StatsWidgetUpdatePaymentMethodsRelationInput"] | undefined | null,
	upsert?: ValueTypes["StatsWidgetUpsertPaymentMethodsRelationInput"] | undefined | null,
	connect?: ValueTypes["PaymentMethodUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["PaymentMethodUniqueWhere"] | undefined | null,
	delete?: ValueTypes["PaymentMethodUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["StatsWidgetUpdatePaymentMethodsRelationInput"]: {
	by?: ValueTypes["PaymentMethodUniqueWhere"] | undefined | null,
	data?: ValueTypes["PaymentMethodUpdateInput"] | undefined | null
};
	["StatsWidgetUpsertPaymentMethodsRelationInput"]: {
	by?: ValueTypes["PaymentMethodUniqueWhere"] | undefined | null,
	update?: ValueTypes["PaymentMethodUpdateInput"] | undefined | null,
	create?: ValueTypes["PaymentMethodCreateInput"] | undefined | null
};
	["StatsWidgetsLayoutUpsertItemsRelationInput"]: {
	by?: ValueTypes["StatsWidgetUniqueWhere"] | undefined | null,
	update?: ValueTypes["StatsWidgetWithoutLayoutUpdateInput"] | undefined | null,
	create?: ValueTypes["StatsWidgetWithoutLayoutCreateInput"] | undefined | null
};
	["StatsEnabledWidgetTypeUpsertLayoutRelationInput"]: {
	update?: ValueTypes["StatsWidgetsLayoutWithoutEnabledWidgetTypesUpdateInput"] | undefined | null,
	create?: ValueTypes["StatsWidgetsLayoutWithoutEnabledWidgetTypesCreateInput"] | undefined | null
};
	["StatsWidgetCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	size?: number | undefined | null,
	type?: ValueTypes["StatsEnabledWidgetTypeType"] | undefined | null,
	link?: string | undefined | null,
	title?: string | undefined | null,
	timeFrame?: ValueTypes["StatsWidgetTimeFrame"] | undefined | null,
	layout?: ValueTypes["StatsWidgetCreateLayoutEntityRelationInput"] | undefined | null,
	icon?: ValueTypes["StatsWidgetCreateIconEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["StatsWidgetCreateChannelsEntityRelationInput"]> | undefined | null,
	productCategory?: ValueTypes["StatsWidgetCreateProductCategoryEntityRelationInput"] | undefined | null,
	paymentMethods?: Array<ValueTypes["StatsWidgetCreatePaymentMethodsEntityRelationInput"]> | undefined | null,
	hoursFrom?: string | undefined | null,
	hoursTo?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StatsWidgetCreateLayoutEntityRelationInput"]: {
	connect?: ValueTypes["StatsWidgetsLayoutUniqueWhere"] | undefined | null,
	create?: ValueTypes["StatsWidgetsLayoutWithoutItemsCreateInput"] | undefined | null
};
	["StatsWidgetsLayoutWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	enabledWidgetTypes?: Array<ValueTypes["StatsWidgetsLayoutCreateEnabledWidgetTypesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StatsWidgetsLayoutCreateEnabledWidgetTypesEntityRelationInput"]: {
	connect?: ValueTypes["StatsEnabledWidgetTypeUniqueWhere"] | undefined | null,
	create?: ValueTypes["StatsEnabledWidgetTypeWithoutLayoutCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["StatsEnabledWidgetTypeWithoutLayoutCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	type?: ValueTypes["StatsEnabledWidgetTypeType"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StatsWidgetUpdateInput"]: {
	order?: number | undefined | null,
	size?: number | undefined | null,
	type?: ValueTypes["StatsEnabledWidgetTypeType"] | undefined | null,
	link?: string | undefined | null,
	title?: string | undefined | null,
	timeFrame?: ValueTypes["StatsWidgetTimeFrame"] | undefined | null,
	layout?: ValueTypes["StatsWidgetUpdateLayoutEntityRelationInput"] | undefined | null,
	icon?: ValueTypes["StatsWidgetUpdateIconEntityRelationInput"] | undefined | null,
	channels?: Array<ValueTypes["StatsWidgetUpdateChannelsEntityRelationInput"]> | undefined | null,
	productCategory?: ValueTypes["StatsWidgetUpdateProductCategoryEntityRelationInput"] | undefined | null,
	paymentMethods?: Array<ValueTypes["StatsWidgetUpdatePaymentMethodsEntityRelationInput"]> | undefined | null,
	hoursFrom?: string | undefined | null,
	hoursTo?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StatsWidgetUpdateLayoutEntityRelationInput"]: {
	create?: ValueTypes["StatsWidgetsLayoutWithoutItemsCreateInput"] | undefined | null,
	update?: ValueTypes["StatsWidgetsLayoutWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["StatsWidgetUpsertLayoutRelationInput"] | undefined | null,
	connect?: ValueTypes["StatsWidgetsLayoutUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["StatsWidgetsLayoutWithoutItemsUpdateInput"]: {
	enabledWidgetTypes?: Array<ValueTypes["StatsWidgetsLayoutUpdateEnabledWidgetTypesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StatsWidgetsLayoutUpdateEnabledWidgetTypesEntityRelationInput"]: {
	create?: ValueTypes["StatsEnabledWidgetTypeWithoutLayoutCreateInput"] | undefined | null,
	update?: ValueTypes["StatsWidgetsLayoutUpdateEnabledWidgetTypesRelationInput"] | undefined | null,
	upsert?: ValueTypes["StatsWidgetsLayoutUpsertEnabledWidgetTypesRelationInput"] | undefined | null,
	connect?: ValueTypes["StatsEnabledWidgetTypeUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["StatsEnabledWidgetTypeUniqueWhere"] | undefined | null,
	delete?: ValueTypes["StatsEnabledWidgetTypeUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["StatsWidgetsLayoutUpdateEnabledWidgetTypesRelationInput"]: {
	by?: ValueTypes["StatsEnabledWidgetTypeUniqueWhere"] | undefined | null,
	data?: ValueTypes["StatsEnabledWidgetTypeWithoutLayoutUpdateInput"] | undefined | null
};
	["StatsEnabledWidgetTypeWithoutLayoutUpdateInput"]: {
	type?: ValueTypes["StatsEnabledWidgetTypeType"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StatsWidgetsLayoutUpsertEnabledWidgetTypesRelationInput"]: {
	by?: ValueTypes["StatsEnabledWidgetTypeUniqueWhere"] | undefined | null,
	update?: ValueTypes["StatsEnabledWidgetTypeWithoutLayoutUpdateInput"] | undefined | null,
	create?: ValueTypes["StatsEnabledWidgetTypeWithoutLayoutCreateInput"] | undefined | null
};
	["StatsWidgetUpsertLayoutRelationInput"]: {
	update?: ValueTypes["StatsWidgetsLayoutWithoutItemsUpdateInput"] | undefined | null,
	create?: ValueTypes["StatsWidgetsLayoutWithoutItemsCreateInput"] | undefined | null
};
	["StatsWidgetsLayoutConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["StatsWidgetsLayoutEdge"],
		__typename?: boolean | `@${string}`
}>;
	["StatsWidgetsLayoutEdge"]: AliasType<{
	node?:ValueTypes["StatsWidgetsLayout"],
		__typename?: boolean | `@${string}`
}>;
	["StatsWidgetsLayoutCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	enabledWidgetTypes?: Array<ValueTypes["StatsWidgetsLayoutCreateEnabledWidgetTypesEntityRelationInput"]> | undefined | null,
	items?: Array<ValueTypes["StatsWidgetsLayoutCreateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StatsWidgetsLayoutUpdateInput"]: {
	enabledWidgetTypes?: Array<ValueTypes["StatsWidgetsLayoutUpdateEnabledWidgetTypesEntityRelationInput"]> | undefined | null,
	items?: Array<ValueTypes["StatsWidgetsLayoutUpdateItemsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SeatCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	positionX?: number | undefined | null,
	positionY?: number | undefined | null,
	name?: string | undefined | null,
	color?: string | undefined | null,
	customerTabs?: Array<ValueTypes["SeatCreateCustomerTabsEntityRelationInput"]> | undefined | null,
	table?: ValueTypes["SeatCreateTableEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["SeatUpdateInput"]: {
	positionX?: number | undefined | null,
	positionY?: number | undefined | null,
	name?: string | undefined | null,
	color?: string | undefined | null,
	customerTabs?: Array<ValueTypes["SeatUpdateCustomerTabsEntityRelationInput"]> | undefined | null,
	table?: ValueTypes["SeatUpdateTableEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TableCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	shape?: ValueTypes["TableShape"] | undefined | null,
	width?: number | undefined | null,
	height?: number | undefined | null,
	positionX?: number | undefined | null,
	positionY?: number | undefined | null,
	name?: string | undefined | null,
	color?: string | undefined | null,
	customerTabs?: Array<ValueTypes["TableCreateCustomerTabsEntityRelationInput"]> | undefined | null,
	area?: ValueTypes["TableCreateAreaEntityRelationInput"] | undefined | null,
	seats?: Array<ValueTypes["TableCreateSeatsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["TableUpdateInput"]: {
	shape?: ValueTypes["TableShape"] | undefined | null,
	width?: number | undefined | null,
	height?: number | undefined | null,
	positionX?: number | undefined | null,
	positionY?: number | undefined | null,
	name?: string | undefined | null,
	color?: string | undefined | null,
	customerTabs?: Array<ValueTypes["TableUpdateCustomerTabsEntityRelationInput"]> | undefined | null,
	area?: ValueTypes["TableUpdateAreaEntityRelationInput"] | undefined | null,
	seats?: Array<ValueTypes["TableUpdateSeatsEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StatsPage"]: AliasType<{
	_meta?:ValueTypes["StatsPageMeta"],
	id?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	enabled?:boolean | `@${string}`,
widgets?: [{	filter?: ValueTypes["StatsWidgetsLayoutWhere"] | undefined | null},ValueTypes["StatsWidgetsLayout"]],
		__typename?: boolean | `@${string}`
}>;
	["StatsPageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	enabled?:ValueTypes["FieldMeta"],
	widgets?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["StatsPageType"]:StatsPageType;
	["StatsPageUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	type?: ValueTypes["StatsPageType"] | undefined | null,
	widgets?: ValueTypes["StatsWidgetsLayoutUniqueWhere"] | undefined | null
};
	["StatsPageWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	type?: ValueTypes["StatsPageTypeCondition"] | undefined | null,
	enabled?: ValueTypes["BooleanCondition"] | undefined | null,
	widgets?: ValueTypes["StatsWidgetsLayoutWhere"] | undefined | null,
	and?: Array<ValueTypes["StatsPageWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["StatsPageWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["StatsPageWhere"] | undefined | null
};
	["StatsPageTypeCondition"]: {
	and?: Array<ValueTypes["StatsPageTypeCondition"]> | undefined | null,
	or?: Array<ValueTypes["StatsPageTypeCondition"]> | undefined | null,
	not?: ValueTypes["StatsPageTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["StatsPageType"] | undefined | null,
	notEq?: ValueTypes["StatsPageType"] | undefined | null,
	in?: Array<ValueTypes["StatsPageType"]> | undefined | null,
	notIn?: Array<ValueTypes["StatsPageType"]> | undefined | null,
	lt?: ValueTypes["StatsPageType"] | undefined | null,
	lte?: ValueTypes["StatsPageType"] | undefined | null,
	gt?: ValueTypes["StatsPageType"] | undefined | null,
	gte?: ValueTypes["StatsPageType"] | undefined | null
};
	["StatsPageOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	type?: ValueTypes["OrderDirection"] | undefined | null,
	enabled?: ValueTypes["OrderDirection"] | undefined | null,
	widgets?: ValueTypes["StatsWidgetsLayoutOrderBy"] | undefined | null
};
	["StatsPageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["StatsPageEdge"],
		__typename?: boolean | `@${string}`
}>;
	["StatsPageEdge"]: AliasType<{
	node?:ValueTypes["StatsPage"],
		__typename?: boolean | `@${string}`
}>;
	["StatsPageCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	type?: ValueTypes["StatsPageType"] | undefined | null,
	enabled?: boolean | undefined | null,
	widgets?: ValueTypes["StatsPageCreateWidgetsEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StatsPageCreateWidgetsEntityRelationInput"]: {
	connect?: ValueTypes["StatsWidgetsLayoutUniqueWhere"] | undefined | null,
	create?: ValueTypes["StatsWidgetsLayoutCreateInput"] | undefined | null
};
	["StatsPageUpdateInput"]: {
	type?: ValueTypes["StatsPageType"] | undefined | null,
	enabled?: boolean | undefined | null,
	widgets?: ValueTypes["StatsPageUpdateWidgetsEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["StatsPageUpdateWidgetsEntityRelationInput"]: {
	create?: ValueTypes["StatsWidgetsLayoutCreateInput"] | undefined | null,
	update?: ValueTypes["StatsWidgetsLayoutUpdateInput"] | undefined | null,
	upsert?: ValueTypes["StatsPageUpsertWidgetsRelationInput"] | undefined | null,
	connect?: ValueTypes["StatsWidgetsLayoutUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["StatsPageUpsertWidgetsRelationInput"]: {
	update?: ValueTypes["StatsWidgetsLayoutUpdateInput"] | undefined | null,
	create?: ValueTypes["StatsWidgetsLayoutCreateInput"] | undefined | null
};
	["DoubleshotCoffeeEquipmentConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["DoubleshotCoffeeEquipmentEdge"],
		__typename?: boolean | `@${string}`
}>;
	["DoubleshotCoffeeEquipmentEdge"]: AliasType<{
	node?:ValueTypes["DoubleshotCoffeeEquipment"],
		__typename?: boolean | `@${string}`
}>;
	["Expense"]: AliasType<{
	_meta?:ValueTypes["ExpenseMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
category?: [{	filter?: ValueTypes["ExpenseCategoryWhere"] | undefined | null},ValueTypes["ExpenseCategory"]],
supplier?: [{	filter?: ValueTypes["IngredientSupplierWhere"] | undefined | null},ValueTypes["IngredientSupplier"]],
changes?: [{	filter?: ValueTypes["ExpenseChangeWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ExpenseChangeOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ExpenseChange"]],
documents?: [{	filter?: ValueTypes["ExpenseDocumentWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ExpenseDocumentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ExpenseDocument"]],
terms?: [{	filter?: ValueTypes["ExpenseTermWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ExpenseTermOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ExpenseTerm"]],
venue?: [{	filter?: ValueTypes["VenueWhere"] | undefined | null},ValueTypes["Venue"]],
	paidByCash?:boolean | `@${string}`,
changesByDate?: [{	by: ValueTypes["ExpenseChangesByDateUniqueWhere"],	filter?: ValueTypes["ExpenseChangeWhere"] | undefined | null},ValueTypes["ExpenseChange"]],
documentsByFile?: [{	by: ValueTypes["ExpenseDocumentsByFileUniqueWhere"],	filter?: ValueTypes["ExpenseDocumentWhere"] | undefined | null},ValueTypes["ExpenseDocument"]],
paginateChanges?: [{	filter?: ValueTypes["ExpenseChangeWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ExpenseChangeOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ExpenseChangeConnection"]],
paginateDocuments?: [{	filter?: ValueTypes["ExpenseDocumentWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ExpenseDocumentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ExpenseDocumentConnection"]],
paginateTerms?: [{	filter?: ValueTypes["ExpenseTermWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ExpenseTermOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ExpenseTermConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ExpenseMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	category?:ValueTypes["FieldMeta"],
	supplier?:ValueTypes["FieldMeta"],
	changes?:ValueTypes["FieldMeta"],
	documents?:ValueTypes["FieldMeta"],
	terms?:ValueTypes["FieldMeta"],
	venue?:ValueTypes["FieldMeta"],
	paidByCash?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ExpenseType"]:ExpenseType;
	["ExpenseCategory"]: AliasType<{
	_meta?:ValueTypes["ExpenseCategoryMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
items?: [{	filter?: ValueTypes["ExpenseWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ExpenseOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Expense"]],
	order?:boolean | `@${string}`,
itemsByChanges?: [{	by: ValueTypes["ExpenseCategoryItemsByChangesUniqueWhere"],	filter?: ValueTypes["ExpenseWhere"] | undefined | null},ValueTypes["Expense"]],
itemsByDocuments?: [{	by: ValueTypes["ExpenseCategoryItemsByDocumentsUniqueWhere"],	filter?: ValueTypes["ExpenseWhere"] | undefined | null},ValueTypes["Expense"]],
itemsByTerms?: [{	by: ValueTypes["ExpenseCategoryItemsByTermsUniqueWhere"],	filter?: ValueTypes["ExpenseWhere"] | undefined | null},ValueTypes["Expense"]],
paginateItems?: [{	filter?: ValueTypes["ExpenseWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ExpenseOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ExpenseConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["ExpenseCategoryMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ExpenseWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	type?: ValueTypes["ExpenseTypeCondition"] | undefined | null,
	category?: ValueTypes["ExpenseCategoryWhere"] | undefined | null,
	supplier?: ValueTypes["IngredientSupplierWhere"] | undefined | null,
	changes?: ValueTypes["ExpenseChangeWhere"] | undefined | null,
	documents?: ValueTypes["ExpenseDocumentWhere"] | undefined | null,
	terms?: ValueTypes["ExpenseTermWhere"] | undefined | null,
	venue?: ValueTypes["VenueWhere"] | undefined | null,
	paidByCash?: ValueTypes["BooleanCondition"] | undefined | null,
	and?: Array<ValueTypes["ExpenseWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ExpenseWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ExpenseWhere"] | undefined | null
};
	["ExpenseTypeCondition"]: {
	and?: Array<ValueTypes["ExpenseTypeCondition"]> | undefined | null,
	or?: Array<ValueTypes["ExpenseTypeCondition"]> | undefined | null,
	not?: ValueTypes["ExpenseTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["ExpenseType"] | undefined | null,
	notEq?: ValueTypes["ExpenseType"] | undefined | null,
	in?: Array<ValueTypes["ExpenseType"]> | undefined | null,
	notIn?: Array<ValueTypes["ExpenseType"]> | undefined | null,
	lt?: ValueTypes["ExpenseType"] | undefined | null,
	lte?: ValueTypes["ExpenseType"] | undefined | null,
	gt?: ValueTypes["ExpenseType"] | undefined | null,
	gte?: ValueTypes["ExpenseType"] | undefined | null
};
	["ExpenseCategoryWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	items?: ValueTypes["ExpenseWhere"] | undefined | null,
	order?: ValueTypes["IntCondition"] | undefined | null,
	and?: Array<ValueTypes["ExpenseCategoryWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ExpenseCategoryWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ExpenseCategoryWhere"] | undefined | null
};
	["ExpenseChangeWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	date?: ValueTypes["DateCondition"] | undefined | null,
	amountCents?: ValueTypes["IntCondition"] | undefined | null,
	expense?: ValueTypes["ExpenseWhere"] | undefined | null,
	and?: Array<ValueTypes["ExpenseChangeWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ExpenseChangeWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ExpenseChangeWhere"] | undefined | null
};
	["ExpenseDocumentWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	expense?: ValueTypes["ExpenseWhere"] | undefined | null,
	amountCents?: ValueTypes["IntCondition"] | undefined | null,
	file?: ValueTypes["FileWhere"] | undefined | null,
	date?: ValueTypes["DateCondition"] | undefined | null,
	termDate?: ValueTypes["DateCondition"] | undefined | null,
	and?: Array<ValueTypes["ExpenseDocumentWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ExpenseDocumentWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ExpenseDocumentWhere"] | undefined | null
};
	["FileWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	url?: ValueTypes["StringCondition"] | undefined | null,
	size?: ValueTypes["IntCondition"] | undefined | null,
	type?: ValueTypes["StringCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	and?: Array<ValueTypes["FileWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["FileWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["FileWhere"] | undefined | null
};
	["ExpenseTermWhere"]: {
	id?: ValueTypes["StringCondition"] | undefined | null,
	date?: ValueTypes["DateCondition"] | undefined | null,
	amountCents?: ValueTypes["IntCondition"] | undefined | null,
	expense?: ValueTypes["ExpenseWhere"] | undefined | null,
	and?: Array<ValueTypes["ExpenseTermWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["ExpenseTermWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["ExpenseTermWhere"] | undefined | null
};
	["ExpenseOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	type?: ValueTypes["OrderDirection"] | undefined | null,
	category?: ValueTypes["ExpenseCategoryOrderBy"] | undefined | null,
	supplier?: ValueTypes["IngredientSupplierOrderBy"] | undefined | null,
	venue?: ValueTypes["VenueOrderBy"] | undefined | null,
	paidByCash?: ValueTypes["OrderDirection"] | undefined | null
};
	["ExpenseCategoryOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	order?: ValueTypes["OrderDirection"] | undefined | null
};
	["ExpenseCategoryItemsByChangesUniqueWhere"]: {
	changes?: ValueTypes["ExpenseChangeUniqueWhere"] | undefined | null
};
	["ExpenseChangeUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	expense?: ValueTypes["ExpenseUniqueWhere"] | undefined | null,
	date?: ValueTypes["Date"] | undefined | null
};
	["ExpenseUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	changes?: ValueTypes["ExpenseChangeUniqueWhere"] | undefined | null,
	documents?: ValueTypes["ExpenseDocumentUniqueWhere"] | undefined | null,
	terms?: ValueTypes["ExpenseTermUniqueWhere"] | undefined | null
};
	["ExpenseDocumentUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	file?: ValueTypes["FileUniqueWhere"] | undefined | null
};
	["FileUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["ExpenseTermUniqueWhere"]: {
	id?: string | undefined | null
};
	["ExpenseCategoryItemsByDocumentsUniqueWhere"]: {
	documents?: ValueTypes["ExpenseDocumentUniqueWhere"] | undefined | null
};
	["ExpenseCategoryItemsByTermsUniqueWhere"]: {
	terms?: ValueTypes["ExpenseTermUniqueWhere"] | undefined | null
};
	["ExpenseConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ExpenseEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ExpenseEdge"]: AliasType<{
	node?:ValueTypes["Expense"],
		__typename?: boolean | `@${string}`
}>;
	["ExpenseChange"]: AliasType<{
	_meta?:ValueTypes["ExpenseChangeMeta"],
	id?:boolean | `@${string}`,
	date?:boolean | `@${string}`,
	amountCents?:boolean | `@${string}`,
expense?: [{	filter?: ValueTypes["ExpenseWhere"] | undefined | null},ValueTypes["Expense"]],
		__typename?: boolean | `@${string}`
}>;
	["ExpenseChangeMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	date?:ValueTypes["FieldMeta"],
	amountCents?:ValueTypes["FieldMeta"],
	expense?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ExpenseChangeOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	date?: ValueTypes["OrderDirection"] | undefined | null,
	amountCents?: ValueTypes["OrderDirection"] | undefined | null,
	expense?: ValueTypes["ExpenseOrderBy"] | undefined | null
};
	["ExpenseDocument"]: AliasType<{
	_meta?:ValueTypes["ExpenseDocumentMeta"],
	id?:boolean | `@${string}`,
expense?: [{	filter?: ValueTypes["ExpenseWhere"] | undefined | null},ValueTypes["Expense"]],
	amountCents?:boolean | `@${string}`,
file?: [{	filter?: ValueTypes["FileWhere"] | undefined | null},ValueTypes["File"]],
	date?:boolean | `@${string}`,
	termDate?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ExpenseDocumentMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	expense?:ValueTypes["FieldMeta"],
	amountCents?:ValueTypes["FieldMeta"],
	file?:ValueTypes["FieldMeta"],
	date?:ValueTypes["FieldMeta"],
	termDate?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["File"]: AliasType<{
	_meta?:ValueTypes["FileMeta"],
	id?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
	size?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FileMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	size?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ExpenseDocumentOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	expense?: ValueTypes["ExpenseOrderBy"] | undefined | null,
	amountCents?: ValueTypes["OrderDirection"] | undefined | null,
	file?: ValueTypes["FileOrderBy"] | undefined | null,
	date?: ValueTypes["OrderDirection"] | undefined | null,
	termDate?: ValueTypes["OrderDirection"] | undefined | null
};
	["FileOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	url?: ValueTypes["OrderDirection"] | undefined | null,
	size?: ValueTypes["OrderDirection"] | undefined | null,
	type?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null
};
	["ExpenseTerm"]: AliasType<{
	_meta?:ValueTypes["ExpenseTermMeta"],
	id?:boolean | `@${string}`,
	date?:boolean | `@${string}`,
	amountCents?:boolean | `@${string}`,
expense?: [{	filter?: ValueTypes["ExpenseWhere"] | undefined | null},ValueTypes["Expense"]],
		__typename?: boolean | `@${string}`
}>;
	["ExpenseTermMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	date?:ValueTypes["FieldMeta"],
	amountCents?:ValueTypes["FieldMeta"],
	expense?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["ExpenseTermOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	date?: ValueTypes["OrderDirection"] | undefined | null,
	amountCents?: ValueTypes["OrderDirection"] | undefined | null,
	expense?: ValueTypes["ExpenseOrderBy"] | undefined | null
};
	["ExpenseChangesByDateUniqueWhere"]: {
	date?: ValueTypes["Date"] | undefined | null
};
	["ExpenseDocumentsByFileUniqueWhere"]: {
	file?: ValueTypes["FileUniqueWhere"] | undefined | null
};
	["ExpenseChangeConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ExpenseChangeEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ExpenseChangeEdge"]: AliasType<{
	node?:ValueTypes["ExpenseChange"],
		__typename?: boolean | `@${string}`
}>;
	["ExpenseDocumentConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ExpenseDocumentEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ExpenseDocumentEdge"]: AliasType<{
	node?:ValueTypes["ExpenseDocument"],
		__typename?: boolean | `@${string}`
}>;
	["ExpenseTermConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ExpenseTermEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ExpenseTermEdge"]: AliasType<{
	node?:ValueTypes["ExpenseTerm"],
		__typename?: boolean | `@${string}`
}>;
	["ExpenseCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	type?: ValueTypes["ExpenseType"] | undefined | null,
	category?: ValueTypes["ExpenseCreateCategoryEntityRelationInput"] | undefined | null,
	supplier?: ValueTypes["ExpenseCreateSupplierEntityRelationInput"] | undefined | null,
	changes?: Array<ValueTypes["ExpenseCreateChangesEntityRelationInput"]> | undefined | null,
	documents?: Array<ValueTypes["ExpenseCreateDocumentsEntityRelationInput"]> | undefined | null,
	terms?: Array<ValueTypes["ExpenseCreateTermsEntityRelationInput"]> | undefined | null,
	venue?: ValueTypes["ExpenseCreateVenueEntityRelationInput"] | undefined | null,
	paidByCash?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ExpenseCreateCategoryEntityRelationInput"]: {
	connect?: ValueTypes["ExpenseCategoryUniqueWhere"] | undefined | null,
	create?: ValueTypes["ExpenseCategoryWithoutItemsCreateInput"] | undefined | null
};
	["ExpenseCategoryUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	items?: ValueTypes["ExpenseUniqueWhere"] | undefined | null
};
	["ExpenseCategoryWithoutItemsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	order?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ExpenseCreateSupplierEntityRelationInput"]: {
	connect?: ValueTypes["IngredientSupplierUniqueWhere"] | undefined | null,
	create?: ValueTypes["IngredientSupplierCreateInput"] | undefined | null
};
	["ExpenseCreateChangesEntityRelationInput"]: {
	connect?: ValueTypes["ExpenseChangeUniqueWhere"] | undefined | null,
	create?: ValueTypes["ExpenseChangeWithoutExpenseCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ExpenseChangeWithoutExpenseCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	date?: ValueTypes["Date"] | undefined | null,
	amountCents?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ExpenseCreateDocumentsEntityRelationInput"]: {
	connect?: ValueTypes["ExpenseDocumentUniqueWhere"] | undefined | null,
	create?: ValueTypes["ExpenseDocumentWithoutExpenseCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ExpenseDocumentWithoutExpenseCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	amountCents?: number | undefined | null,
	file?: ValueTypes["ExpenseDocumentCreateFileEntityRelationInput"] | undefined | null,
	date?: ValueTypes["Date"] | undefined | null,
	termDate?: ValueTypes["Date"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ExpenseDocumentCreateFileEntityRelationInput"]: {
	connect?: ValueTypes["FileUniqueWhere"] | undefined | null,
	create?: ValueTypes["FileCreateInput"] | undefined | null
};
	["FileCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	url?: string | undefined | null,
	size?: number | undefined | null,
	type?: string | undefined | null,
	name?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ExpenseCreateTermsEntityRelationInput"]: {
	connect?: ValueTypes["ExpenseTermUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ExpenseCreateVenueEntityRelationInput"]: {
	connect?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	create?: ValueTypes["VenueCreateInput"] | undefined | null
};
	["ExpenseUpdateInput"]: {
	name?: string | undefined | null,
	type?: ValueTypes["ExpenseType"] | undefined | null,
	category?: ValueTypes["ExpenseUpdateCategoryEntityRelationInput"] | undefined | null,
	supplier?: ValueTypes["ExpenseUpdateSupplierEntityRelationInput"] | undefined | null,
	changes?: Array<ValueTypes["ExpenseUpdateChangesEntityRelationInput"]> | undefined | null,
	documents?: Array<ValueTypes["ExpenseUpdateDocumentsEntityRelationInput"]> | undefined | null,
	terms?: Array<ValueTypes["ExpenseUpdateTermsEntityRelationInput"]> | undefined | null,
	venue?: ValueTypes["ExpenseUpdateVenueEntityRelationInput"] | undefined | null,
	paidByCash?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ExpenseUpdateCategoryEntityRelationInput"]: {
	create?: ValueTypes["ExpenseCategoryWithoutItemsCreateInput"] | undefined | null,
	update?: ValueTypes["ExpenseCategoryWithoutItemsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ExpenseUpsertCategoryRelationInput"] | undefined | null,
	connect?: ValueTypes["ExpenseCategoryUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ExpenseCategoryWithoutItemsUpdateInput"]: {
	name?: string | undefined | null,
	order?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ExpenseUpsertCategoryRelationInput"]: {
	update?: ValueTypes["ExpenseCategoryWithoutItemsUpdateInput"] | undefined | null,
	create?: ValueTypes["ExpenseCategoryWithoutItemsCreateInput"] | undefined | null
};
	["ExpenseUpdateSupplierEntityRelationInput"]: {
	create?: ValueTypes["IngredientSupplierCreateInput"] | undefined | null,
	update?: ValueTypes["IngredientSupplierUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ExpenseUpsertSupplierRelationInput"] | undefined | null,
	connect?: ValueTypes["IngredientSupplierUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ExpenseUpsertSupplierRelationInput"]: {
	update?: ValueTypes["IngredientSupplierUpdateInput"] | undefined | null,
	create?: ValueTypes["IngredientSupplierCreateInput"] | undefined | null
};
	["ExpenseUpdateChangesEntityRelationInput"]: {
	create?: ValueTypes["ExpenseChangeWithoutExpenseCreateInput"] | undefined | null,
	update?: ValueTypes["ExpenseUpdateChangesRelationInput"] | undefined | null,
	upsert?: ValueTypes["ExpenseUpsertChangesRelationInput"] | undefined | null,
	connect?: ValueTypes["ExpenseChangeUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ExpenseChangeUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ExpenseChangeUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ExpenseUpdateChangesRelationInput"]: {
	by?: ValueTypes["ExpenseChangeUniqueWhere"] | undefined | null,
	data?: ValueTypes["ExpenseChangeWithoutExpenseUpdateInput"] | undefined | null
};
	["ExpenseChangeWithoutExpenseUpdateInput"]: {
	date?: ValueTypes["Date"] | undefined | null,
	amountCents?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ExpenseUpsertChangesRelationInput"]: {
	by?: ValueTypes["ExpenseChangeUniqueWhere"] | undefined | null,
	update?: ValueTypes["ExpenseChangeWithoutExpenseUpdateInput"] | undefined | null,
	create?: ValueTypes["ExpenseChangeWithoutExpenseCreateInput"] | undefined | null
};
	["ExpenseUpdateDocumentsEntityRelationInput"]: {
	create?: ValueTypes["ExpenseDocumentWithoutExpenseCreateInput"] | undefined | null,
	update?: ValueTypes["ExpenseUpdateDocumentsRelationInput"] | undefined | null,
	upsert?: ValueTypes["ExpenseUpsertDocumentsRelationInput"] | undefined | null,
	connect?: ValueTypes["ExpenseDocumentUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ExpenseDocumentUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ExpenseDocumentUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ExpenseUpdateDocumentsRelationInput"]: {
	by?: ValueTypes["ExpenseDocumentUniqueWhere"] | undefined | null,
	data?: ValueTypes["ExpenseDocumentWithoutExpenseUpdateInput"] | undefined | null
};
	["ExpenseDocumentWithoutExpenseUpdateInput"]: {
	amountCents?: number | undefined | null,
	file?: ValueTypes["ExpenseDocumentUpdateFileEntityRelationInput"] | undefined | null,
	date?: ValueTypes["Date"] | undefined | null,
	termDate?: ValueTypes["Date"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ExpenseDocumentUpdateFileEntityRelationInput"]: {
	create?: ValueTypes["FileCreateInput"] | undefined | null,
	update?: ValueTypes["FileUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ExpenseDocumentUpsertFileRelationInput"] | undefined | null,
	connect?: ValueTypes["FileUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["FileUpdateInput"]: {
	url?: string | undefined | null,
	size?: number | undefined | null,
	type?: string | undefined | null,
	name?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ExpenseDocumentUpsertFileRelationInput"]: {
	update?: ValueTypes["FileUpdateInput"] | undefined | null,
	create?: ValueTypes["FileCreateInput"] | undefined | null
};
	["ExpenseUpsertDocumentsRelationInput"]: {
	by?: ValueTypes["ExpenseDocumentUniqueWhere"] | undefined | null,
	update?: ValueTypes["ExpenseDocumentWithoutExpenseUpdateInput"] | undefined | null,
	create?: ValueTypes["ExpenseDocumentWithoutExpenseCreateInput"] | undefined | null
};
	["ExpenseUpdateTermsEntityRelationInput"]: {
	connect?: ValueTypes["ExpenseTermUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ExpenseTermUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ExpenseTermUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ExpenseUpdateVenueEntityRelationInput"]: {
	create?: ValueTypes["VenueCreateInput"] | undefined | null,
	update?: ValueTypes["VenueUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ExpenseUpsertVenueRelationInput"] | undefined | null,
	connect?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ExpenseUpsertVenueRelationInput"]: {
	update?: ValueTypes["VenueUpdateInput"] | undefined | null,
	create?: ValueTypes["VenueCreateInput"] | undefined | null
};
	["ExpenseCategoryConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ExpenseCategoryEdge"],
		__typename?: boolean | `@${string}`
}>;
	["ExpenseCategoryEdge"]: AliasType<{
	node?:ValueTypes["ExpenseCategory"],
		__typename?: boolean | `@${string}`
}>;
	["ExpenseCategoryCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	items?: Array<ValueTypes["ExpenseCategoryCreateItemsEntityRelationInput"]> | undefined | null,
	order?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ExpenseCategoryCreateItemsEntityRelationInput"]: {
	connect?: ValueTypes["ExpenseUniqueWhere"] | undefined | null,
	create?: ValueTypes["ExpenseWithoutCategoryCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["ExpenseWithoutCategoryCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	type?: ValueTypes["ExpenseType"] | undefined | null,
	supplier?: ValueTypes["ExpenseCreateSupplierEntityRelationInput"] | undefined | null,
	changes?: Array<ValueTypes["ExpenseCreateChangesEntityRelationInput"]> | undefined | null,
	documents?: Array<ValueTypes["ExpenseCreateDocumentsEntityRelationInput"]> | undefined | null,
	terms?: Array<ValueTypes["ExpenseCreateTermsEntityRelationInput"]> | undefined | null,
	venue?: ValueTypes["ExpenseCreateVenueEntityRelationInput"] | undefined | null,
	paidByCash?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ExpenseCategoryUpdateInput"]: {
	name?: string | undefined | null,
	items?: Array<ValueTypes["ExpenseCategoryUpdateItemsEntityRelationInput"]> | undefined | null,
	order?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ExpenseCategoryUpdateItemsEntityRelationInput"]: {
	create?: ValueTypes["ExpenseWithoutCategoryCreateInput"] | undefined | null,
	update?: ValueTypes["ExpenseCategoryUpdateItemsRelationInput"] | undefined | null,
	upsert?: ValueTypes["ExpenseCategoryUpsertItemsRelationInput"] | undefined | null,
	connect?: ValueTypes["ExpenseUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["ExpenseUniqueWhere"] | undefined | null,
	delete?: ValueTypes["ExpenseUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["ExpenseCategoryUpdateItemsRelationInput"]: {
	by?: ValueTypes["ExpenseUniqueWhere"] | undefined | null,
	data?: ValueTypes["ExpenseWithoutCategoryUpdateInput"] | undefined | null
};
	["ExpenseWithoutCategoryUpdateInput"]: {
	name?: string | undefined | null,
	type?: ValueTypes["ExpenseType"] | undefined | null,
	supplier?: ValueTypes["ExpenseUpdateSupplierEntityRelationInput"] | undefined | null,
	changes?: Array<ValueTypes["ExpenseUpdateChangesEntityRelationInput"]> | undefined | null,
	documents?: Array<ValueTypes["ExpenseUpdateDocumentsEntityRelationInput"]> | undefined | null,
	terms?: Array<ValueTypes["ExpenseUpdateTermsEntityRelationInput"]> | undefined | null,
	venue?: ValueTypes["ExpenseUpdateVenueEntityRelationInput"] | undefined | null,
	paidByCash?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ExpenseCategoryUpsertItemsRelationInput"]: {
	by?: ValueTypes["ExpenseUniqueWhere"] | undefined | null,
	update?: ValueTypes["ExpenseWithoutCategoryUpdateInput"] | undefined | null,
	create?: ValueTypes["ExpenseWithoutCategoryCreateInput"] | undefined | null
};
	["ExpenseChangeCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	date?: ValueTypes["Date"] | undefined | null,
	amountCents?: number | undefined | null,
	expense?: ValueTypes["ExpenseChangeCreateExpenseEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ExpenseChangeCreateExpenseEntityRelationInput"]: {
	connect?: ValueTypes["ExpenseUniqueWhere"] | undefined | null,
	create?: ValueTypes["ExpenseWithoutChangesCreateInput"] | undefined | null
};
	["ExpenseWithoutChangesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	type?: ValueTypes["ExpenseType"] | undefined | null,
	category?: ValueTypes["ExpenseCreateCategoryEntityRelationInput"] | undefined | null,
	supplier?: ValueTypes["ExpenseCreateSupplierEntityRelationInput"] | undefined | null,
	documents?: Array<ValueTypes["ExpenseCreateDocumentsEntityRelationInput"]> | undefined | null,
	terms?: Array<ValueTypes["ExpenseCreateTermsEntityRelationInput"]> | undefined | null,
	venue?: ValueTypes["ExpenseCreateVenueEntityRelationInput"] | undefined | null,
	paidByCash?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ExpenseChangeUpdateInput"]: {
	date?: ValueTypes["Date"] | undefined | null,
	amountCents?: number | undefined | null,
	expense?: ValueTypes["ExpenseChangeUpdateExpenseEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ExpenseChangeUpdateExpenseEntityRelationInput"]: {
	create?: ValueTypes["ExpenseWithoutChangesCreateInput"] | undefined | null,
	update?: ValueTypes["ExpenseWithoutChangesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ExpenseChangeUpsertExpenseRelationInput"] | undefined | null,
	connect?: ValueTypes["ExpenseUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["ExpenseWithoutChangesUpdateInput"]: {
	name?: string | undefined | null,
	type?: ValueTypes["ExpenseType"] | undefined | null,
	category?: ValueTypes["ExpenseUpdateCategoryEntityRelationInput"] | undefined | null,
	supplier?: ValueTypes["ExpenseUpdateSupplierEntityRelationInput"] | undefined | null,
	documents?: Array<ValueTypes["ExpenseUpdateDocumentsEntityRelationInput"]> | undefined | null,
	terms?: Array<ValueTypes["ExpenseUpdateTermsEntityRelationInput"]> | undefined | null,
	venue?: ValueTypes["ExpenseUpdateVenueEntityRelationInput"] | undefined | null,
	paidByCash?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ExpenseChangeUpsertExpenseRelationInput"]: {
	update?: ValueTypes["ExpenseWithoutChangesUpdateInput"] | undefined | null,
	create?: ValueTypes["ExpenseWithoutChangesCreateInput"] | undefined | null
};
	["ExpenseDocumentCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	expense?: ValueTypes["ExpenseDocumentCreateExpenseEntityRelationInput"] | undefined | null,
	amountCents?: number | undefined | null,
	file?: ValueTypes["ExpenseDocumentCreateFileEntityRelationInput"] | undefined | null,
	date?: ValueTypes["Date"] | undefined | null,
	termDate?: ValueTypes["Date"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ExpenseDocumentCreateExpenseEntityRelationInput"]: {
	connect?: ValueTypes["ExpenseUniqueWhere"] | undefined | null,
	create?: ValueTypes["ExpenseWithoutDocumentsCreateInput"] | undefined | null
};
	["ExpenseWithoutDocumentsCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	type?: ValueTypes["ExpenseType"] | undefined | null,
	category?: ValueTypes["ExpenseCreateCategoryEntityRelationInput"] | undefined | null,
	supplier?: ValueTypes["ExpenseCreateSupplierEntityRelationInput"] | undefined | null,
	changes?: Array<ValueTypes["ExpenseCreateChangesEntityRelationInput"]> | undefined | null,
	terms?: Array<ValueTypes["ExpenseCreateTermsEntityRelationInput"]> | undefined | null,
	venue?: ValueTypes["ExpenseCreateVenueEntityRelationInput"] | undefined | null,
	paidByCash?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ExpenseDocumentUpdateInput"]: {
	expense?: ValueTypes["ExpenseDocumentUpdateExpenseEntityRelationInput"] | undefined | null,
	amountCents?: number | undefined | null,
	file?: ValueTypes["ExpenseDocumentUpdateFileEntityRelationInput"] | undefined | null,
	date?: ValueTypes["Date"] | undefined | null,
	termDate?: ValueTypes["Date"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ExpenseDocumentUpdateExpenseEntityRelationInput"]: {
	create?: ValueTypes["ExpenseWithoutDocumentsCreateInput"] | undefined | null,
	update?: ValueTypes["ExpenseWithoutDocumentsUpdateInput"] | undefined | null,
	upsert?: ValueTypes["ExpenseDocumentUpsertExpenseRelationInput"] | undefined | null,
	connect?: ValueTypes["ExpenseUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["ExpenseWithoutDocumentsUpdateInput"]: {
	name?: string | undefined | null,
	type?: ValueTypes["ExpenseType"] | undefined | null,
	category?: ValueTypes["ExpenseUpdateCategoryEntityRelationInput"] | undefined | null,
	supplier?: ValueTypes["ExpenseUpdateSupplierEntityRelationInput"] | undefined | null,
	changes?: Array<ValueTypes["ExpenseUpdateChangesEntityRelationInput"]> | undefined | null,
	terms?: Array<ValueTypes["ExpenseUpdateTermsEntityRelationInput"]> | undefined | null,
	venue?: ValueTypes["ExpenseUpdateVenueEntityRelationInput"] | undefined | null,
	paidByCash?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["ExpenseDocumentUpsertExpenseRelationInput"]: {
	update?: ValueTypes["ExpenseWithoutDocumentsUpdateInput"] | undefined | null,
	create?: ValueTypes["ExpenseWithoutDocumentsCreateInput"] | undefined | null
};
	["RevenuePrediction"]: AliasType<{
	_meta?:ValueTypes["RevenuePredictionMeta"],
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
channel?: [{	filter?: ValueTypes["ChannelWhere"] | undefined | null},ValueTypes["Channel"]],
changes?: [{	filter?: ValueTypes["RevenuePredictionChangeWhere"] | undefined | null,	orderBy?: Array<ValueTypes["RevenuePredictionChangeOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["RevenuePredictionChange"]],
	alwaysIncludeInTotalRevenue?:boolean | `@${string}`,
	recurrencePeriod?:boolean | `@${string}`,
	monday?:boolean | `@${string}`,
	tuesday?:boolean | `@${string}`,
	wednesday?:boolean | `@${string}`,
	thursday?:boolean | `@${string}`,
	friday?:boolean | `@${string}`,
	saturday?:boolean | `@${string}`,
	sunday?:boolean | `@${string}`,
terms?: [{	filter?: ValueTypes["RevenuePredictionTermWhere"] | undefined | null,	orderBy?: Array<ValueTypes["RevenuePredictionTermOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["RevenuePredictionTerm"]],
paymentMethod?: [{	filter?: ValueTypes["PaymentMethodWhere"] | undefined | null},ValueTypes["PaymentMethod"]],
changesByDate?: [{	by: ValueTypes["RevenuePredictionChangesByDateUniqueWhere"],	filter?: ValueTypes["RevenuePredictionChangeWhere"] | undefined | null},ValueTypes["RevenuePredictionChange"]],
paginateChanges?: [{	filter?: ValueTypes["RevenuePredictionChangeWhere"] | undefined | null,	orderBy?: Array<ValueTypes["RevenuePredictionChangeOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["RevenuePredictionChangeConnection"]],
paginateTerms?: [{	filter?: ValueTypes["RevenuePredictionTermWhere"] | undefined | null,	orderBy?: Array<ValueTypes["RevenuePredictionTermOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["RevenuePredictionTermConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["RevenuePredictionMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	channel?:ValueTypes["FieldMeta"],
	changes?:ValueTypes["FieldMeta"],
	alwaysIncludeInTotalRevenue?:ValueTypes["FieldMeta"],
	recurrencePeriod?:ValueTypes["FieldMeta"],
	monday?:ValueTypes["FieldMeta"],
	tuesday?:ValueTypes["FieldMeta"],
	wednesday?:ValueTypes["FieldMeta"],
	thursday?:ValueTypes["FieldMeta"],
	friday?:ValueTypes["FieldMeta"],
	saturday?:ValueTypes["FieldMeta"],
	sunday?:ValueTypes["FieldMeta"],
	terms?:ValueTypes["FieldMeta"],
	paymentMethod?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["RevenuePredictionType"]:RevenuePredictionType;
	["RevenuePredictionChange"]: AliasType<{
	_meta?:ValueTypes["RevenuePredictionChangeMeta"],
	id?:boolean | `@${string}`,
	date?:boolean | `@${string}`,
	amountCents?:boolean | `@${string}`,
prediction?: [{	filter?: ValueTypes["RevenuePredictionWhere"] | undefined | null},ValueTypes["RevenuePrediction"]],
		__typename?: boolean | `@${string}`
}>;
	["RevenuePredictionChangeMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	date?:ValueTypes["FieldMeta"],
	amountCents?:ValueTypes["FieldMeta"],
	prediction?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["RevenuePredictionWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	name?: ValueTypes["StringCondition"] | undefined | null,
	type?: ValueTypes["RevenuePredictionTypeCondition"] | undefined | null,
	channel?: ValueTypes["ChannelWhere"] | undefined | null,
	changes?: ValueTypes["RevenuePredictionChangeWhere"] | undefined | null,
	alwaysIncludeInTotalRevenue?: ValueTypes["BooleanCondition"] | undefined | null,
	recurrencePeriod?: ValueTypes["RecurrencePeriodCondition"] | undefined | null,
	monday?: ValueTypes["BooleanCondition"] | undefined | null,
	tuesday?: ValueTypes["BooleanCondition"] | undefined | null,
	wednesday?: ValueTypes["BooleanCondition"] | undefined | null,
	thursday?: ValueTypes["BooleanCondition"] | undefined | null,
	friday?: ValueTypes["BooleanCondition"] | undefined | null,
	saturday?: ValueTypes["BooleanCondition"] | undefined | null,
	sunday?: ValueTypes["BooleanCondition"] | undefined | null,
	terms?: ValueTypes["RevenuePredictionTermWhere"] | undefined | null,
	paymentMethod?: ValueTypes["PaymentMethodWhere"] | undefined | null,
	and?: Array<ValueTypes["RevenuePredictionWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["RevenuePredictionWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["RevenuePredictionWhere"] | undefined | null
};
	["RevenuePredictionTypeCondition"]: {
	and?: Array<ValueTypes["RevenuePredictionTypeCondition"]> | undefined | null,
	or?: Array<ValueTypes["RevenuePredictionTypeCondition"]> | undefined | null,
	not?: ValueTypes["RevenuePredictionTypeCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["RevenuePredictionType"] | undefined | null,
	notEq?: ValueTypes["RevenuePredictionType"] | undefined | null,
	in?: Array<ValueTypes["RevenuePredictionType"]> | undefined | null,
	notIn?: Array<ValueTypes["RevenuePredictionType"]> | undefined | null,
	lt?: ValueTypes["RevenuePredictionType"] | undefined | null,
	lte?: ValueTypes["RevenuePredictionType"] | undefined | null,
	gt?: ValueTypes["RevenuePredictionType"] | undefined | null,
	gte?: ValueTypes["RevenuePredictionType"] | undefined | null
};
	["RevenuePredictionChangeWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	date?: ValueTypes["DateCondition"] | undefined | null,
	amountCents?: ValueTypes["IntCondition"] | undefined | null,
	prediction?: ValueTypes["RevenuePredictionWhere"] | undefined | null,
	and?: Array<ValueTypes["RevenuePredictionChangeWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["RevenuePredictionChangeWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["RevenuePredictionChangeWhere"] | undefined | null
};
	["RecurrencePeriodCondition"]: {
	and?: Array<ValueTypes["RecurrencePeriodCondition"]> | undefined | null,
	or?: Array<ValueTypes["RecurrencePeriodCondition"]> | undefined | null,
	not?: ValueTypes["RecurrencePeriodCondition"] | undefined | null,
	null?: boolean | undefined | null,
	isNull?: boolean | undefined | null,
	eq?: ValueTypes["RecurrencePeriod"] | undefined | null,
	notEq?: ValueTypes["RecurrencePeriod"] | undefined | null,
	in?: Array<ValueTypes["RecurrencePeriod"]> | undefined | null,
	notIn?: Array<ValueTypes["RecurrencePeriod"]> | undefined | null,
	lt?: ValueTypes["RecurrencePeriod"] | undefined | null,
	lte?: ValueTypes["RecurrencePeriod"] | undefined | null,
	gt?: ValueTypes["RecurrencePeriod"] | undefined | null,
	gte?: ValueTypes["RecurrencePeriod"] | undefined | null
};
	["RecurrencePeriod"]:RecurrencePeriod;
	["RevenuePredictionTermWhere"]: {
	id?: ValueTypes["StringCondition"] | undefined | null,
	date?: ValueTypes["DateCondition"] | undefined | null,
	amountCents?: ValueTypes["IntCondition"] | undefined | null,
	prediction?: ValueTypes["RevenuePredictionWhere"] | undefined | null,
	and?: Array<ValueTypes["RevenuePredictionTermWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["RevenuePredictionTermWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["RevenuePredictionTermWhere"] | undefined | null
};
	["RevenuePredictionChangeOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	date?: ValueTypes["OrderDirection"] | undefined | null,
	amountCents?: ValueTypes["OrderDirection"] | undefined | null,
	prediction?: ValueTypes["RevenuePredictionOrderBy"] | undefined | null
};
	["RevenuePredictionOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	name?: ValueTypes["OrderDirection"] | undefined | null,
	type?: ValueTypes["OrderDirection"] | undefined | null,
	channel?: ValueTypes["ChannelOrderBy"] | undefined | null,
	alwaysIncludeInTotalRevenue?: ValueTypes["OrderDirection"] | undefined | null,
	recurrencePeriod?: ValueTypes["OrderDirection"] | undefined | null,
	monday?: ValueTypes["OrderDirection"] | undefined | null,
	tuesday?: ValueTypes["OrderDirection"] | undefined | null,
	wednesday?: ValueTypes["OrderDirection"] | undefined | null,
	thursday?: ValueTypes["OrderDirection"] | undefined | null,
	friday?: ValueTypes["OrderDirection"] | undefined | null,
	saturday?: ValueTypes["OrderDirection"] | undefined | null,
	sunday?: ValueTypes["OrderDirection"] | undefined | null,
	paymentMethod?: ValueTypes["PaymentMethodOrderBy"] | undefined | null
};
	["RevenuePredictionTerm"]: AliasType<{
	_meta?:ValueTypes["RevenuePredictionTermMeta"],
	id?:boolean | `@${string}`,
	date?:boolean | `@${string}`,
	amountCents?:boolean | `@${string}`,
prediction?: [{	filter?: ValueTypes["RevenuePredictionWhere"] | undefined | null},ValueTypes["RevenuePrediction"]],
		__typename?: boolean | `@${string}`
}>;
	["RevenuePredictionTermMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	date?:ValueTypes["FieldMeta"],
	amountCents?:ValueTypes["FieldMeta"],
	prediction?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["RevenuePredictionTermOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	date?: ValueTypes["OrderDirection"] | undefined | null,
	amountCents?: ValueTypes["OrderDirection"] | undefined | null,
	prediction?: ValueTypes["RevenuePredictionOrderBy"] | undefined | null
};
	["RevenuePredictionChangesByDateUniqueWhere"]: {
	date?: ValueTypes["Date"] | undefined | null
};
	["RevenuePredictionChangeConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["RevenuePredictionChangeEdge"],
		__typename?: boolean | `@${string}`
}>;
	["RevenuePredictionChangeEdge"]: AliasType<{
	node?:ValueTypes["RevenuePredictionChange"],
		__typename?: boolean | `@${string}`
}>;
	["RevenuePredictionTermConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["RevenuePredictionTermEdge"],
		__typename?: boolean | `@${string}`
}>;
	["RevenuePredictionTermEdge"]: AliasType<{
	node?:ValueTypes["RevenuePredictionTerm"],
		__typename?: boolean | `@${string}`
}>;
	["RevenuePredictionUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	changes?: ValueTypes["RevenuePredictionChangeUniqueWhere"] | undefined | null,
	terms?: ValueTypes["RevenuePredictionTermUniqueWhere"] | undefined | null
};
	["RevenuePredictionChangeUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	prediction?: ValueTypes["RevenuePredictionUniqueWhere"] | undefined | null,
	date?: ValueTypes["Date"] | undefined | null
};
	["RevenuePredictionTermUniqueWhere"]: {
	id?: string | undefined | null
};
	["RevenuePredictionConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["RevenuePredictionEdge"],
		__typename?: boolean | `@${string}`
}>;
	["RevenuePredictionEdge"]: AliasType<{
	node?:ValueTypes["RevenuePrediction"],
		__typename?: boolean | `@${string}`
}>;
	["RevenuePredictionCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	type?: ValueTypes["RevenuePredictionType"] | undefined | null,
	channel?: ValueTypes["RevenuePredictionCreateChannelEntityRelationInput"] | undefined | null,
	changes?: Array<ValueTypes["RevenuePredictionCreateChangesEntityRelationInput"]> | undefined | null,
	alwaysIncludeInTotalRevenue?: boolean | undefined | null,
	recurrencePeriod?: ValueTypes["RecurrencePeriod"] | undefined | null,
	monday?: boolean | undefined | null,
	tuesday?: boolean | undefined | null,
	wednesday?: boolean | undefined | null,
	thursday?: boolean | undefined | null,
	friday?: boolean | undefined | null,
	saturday?: boolean | undefined | null,
	sunday?: boolean | undefined | null,
	terms?: Array<ValueTypes["RevenuePredictionCreateTermsEntityRelationInput"]> | undefined | null,
	paymentMethod?: ValueTypes["RevenuePredictionCreatePaymentMethodEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RevenuePredictionCreateChannelEntityRelationInput"]: {
	connect?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	create?: ValueTypes["ChannelCreateInput"] | undefined | null
};
	["RevenuePredictionCreateChangesEntityRelationInput"]: {
	connect?: ValueTypes["RevenuePredictionChangeUniqueWhere"] | undefined | null,
	create?: ValueTypes["RevenuePredictionChangeWithoutPredictionCreateInput"] | undefined | null,
	alias?: string | undefined | null
};
	["RevenuePredictionChangeWithoutPredictionCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	date?: ValueTypes["Date"] | undefined | null,
	amountCents?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RevenuePredictionCreateTermsEntityRelationInput"]: {
	connect?: ValueTypes["RevenuePredictionTermUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["RevenuePredictionCreatePaymentMethodEntityRelationInput"]: {
	connect?: ValueTypes["PaymentMethodUniqueWhere"] | undefined | null,
	create?: ValueTypes["PaymentMethodCreateInput"] | undefined | null
};
	["RevenuePredictionUpdateInput"]: {
	name?: string | undefined | null,
	type?: ValueTypes["RevenuePredictionType"] | undefined | null,
	channel?: ValueTypes["RevenuePredictionUpdateChannelEntityRelationInput"] | undefined | null,
	changes?: Array<ValueTypes["RevenuePredictionUpdateChangesEntityRelationInput"]> | undefined | null,
	alwaysIncludeInTotalRevenue?: boolean | undefined | null,
	recurrencePeriod?: ValueTypes["RecurrencePeriod"] | undefined | null,
	monday?: boolean | undefined | null,
	tuesday?: boolean | undefined | null,
	wednesday?: boolean | undefined | null,
	thursday?: boolean | undefined | null,
	friday?: boolean | undefined | null,
	saturday?: boolean | undefined | null,
	sunday?: boolean | undefined | null,
	terms?: Array<ValueTypes["RevenuePredictionUpdateTermsEntityRelationInput"]> | undefined | null,
	paymentMethod?: ValueTypes["RevenuePredictionUpdatePaymentMethodEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RevenuePredictionUpdateChannelEntityRelationInput"]: {
	create?: ValueTypes["ChannelCreateInput"] | undefined | null,
	update?: ValueTypes["ChannelUpdateInput"] | undefined | null,
	upsert?: ValueTypes["RevenuePredictionUpsertChannelRelationInput"] | undefined | null,
	connect?: ValueTypes["ChannelUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["RevenuePredictionUpsertChannelRelationInput"]: {
	update?: ValueTypes["ChannelUpdateInput"] | undefined | null,
	create?: ValueTypes["ChannelCreateInput"] | undefined | null
};
	["RevenuePredictionUpdateChangesEntityRelationInput"]: {
	create?: ValueTypes["RevenuePredictionChangeWithoutPredictionCreateInput"] | undefined | null,
	update?: ValueTypes["RevenuePredictionUpdateChangesRelationInput"] | undefined | null,
	upsert?: ValueTypes["RevenuePredictionUpsertChangesRelationInput"] | undefined | null,
	connect?: ValueTypes["RevenuePredictionChangeUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["RevenuePredictionChangeUniqueWhere"] | undefined | null,
	delete?: ValueTypes["RevenuePredictionChangeUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["RevenuePredictionUpdateChangesRelationInput"]: {
	by?: ValueTypes["RevenuePredictionChangeUniqueWhere"] | undefined | null,
	data?: ValueTypes["RevenuePredictionChangeWithoutPredictionUpdateInput"] | undefined | null
};
	["RevenuePredictionChangeWithoutPredictionUpdateInput"]: {
	date?: ValueTypes["Date"] | undefined | null,
	amountCents?: number | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RevenuePredictionUpsertChangesRelationInput"]: {
	by?: ValueTypes["RevenuePredictionChangeUniqueWhere"] | undefined | null,
	update?: ValueTypes["RevenuePredictionChangeWithoutPredictionUpdateInput"] | undefined | null,
	create?: ValueTypes["RevenuePredictionChangeWithoutPredictionCreateInput"] | undefined | null
};
	["RevenuePredictionUpdateTermsEntityRelationInput"]: {
	connect?: ValueTypes["RevenuePredictionTermUniqueWhere"] | undefined | null,
	disconnect?: ValueTypes["RevenuePredictionTermUniqueWhere"] | undefined | null,
	delete?: ValueTypes["RevenuePredictionTermUniqueWhere"] | undefined | null,
	alias?: string | undefined | null
};
	["RevenuePredictionUpdatePaymentMethodEntityRelationInput"]: {
	create?: ValueTypes["PaymentMethodCreateInput"] | undefined | null,
	update?: ValueTypes["PaymentMethodUpdateInput"] | undefined | null,
	upsert?: ValueTypes["RevenuePredictionUpsertPaymentMethodRelationInput"] | undefined | null,
	connect?: ValueTypes["PaymentMethodUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["RevenuePredictionUpsertPaymentMethodRelationInput"]: {
	update?: ValueTypes["PaymentMethodUpdateInput"] | undefined | null,
	create?: ValueTypes["PaymentMethodCreateInput"] | undefined | null
};
	["RevenuePredictionChangeCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	date?: ValueTypes["Date"] | undefined | null,
	amountCents?: number | undefined | null,
	prediction?: ValueTypes["RevenuePredictionChangeCreatePredictionEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RevenuePredictionChangeCreatePredictionEntityRelationInput"]: {
	connect?: ValueTypes["RevenuePredictionUniqueWhere"] | undefined | null,
	create?: ValueTypes["RevenuePredictionWithoutChangesCreateInput"] | undefined | null
};
	["RevenuePredictionWithoutChangesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	name?: string | undefined | null,
	type?: ValueTypes["RevenuePredictionType"] | undefined | null,
	channel?: ValueTypes["RevenuePredictionCreateChannelEntityRelationInput"] | undefined | null,
	alwaysIncludeInTotalRevenue?: boolean | undefined | null,
	recurrencePeriod?: ValueTypes["RecurrencePeriod"] | undefined | null,
	monday?: boolean | undefined | null,
	tuesday?: boolean | undefined | null,
	wednesday?: boolean | undefined | null,
	thursday?: boolean | undefined | null,
	friday?: boolean | undefined | null,
	saturday?: boolean | undefined | null,
	sunday?: boolean | undefined | null,
	terms?: Array<ValueTypes["RevenuePredictionCreateTermsEntityRelationInput"]> | undefined | null,
	paymentMethod?: ValueTypes["RevenuePredictionCreatePaymentMethodEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RevenuePredictionChangeUpdateInput"]: {
	date?: ValueTypes["Date"] | undefined | null,
	amountCents?: number | undefined | null,
	prediction?: ValueTypes["RevenuePredictionChangeUpdatePredictionEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RevenuePredictionChangeUpdatePredictionEntityRelationInput"]: {
	create?: ValueTypes["RevenuePredictionWithoutChangesCreateInput"] | undefined | null,
	update?: ValueTypes["RevenuePredictionWithoutChangesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["RevenuePredictionChangeUpsertPredictionRelationInput"] | undefined | null,
	connect?: ValueTypes["RevenuePredictionUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["RevenuePredictionWithoutChangesUpdateInput"]: {
	name?: string | undefined | null,
	type?: ValueTypes["RevenuePredictionType"] | undefined | null,
	channel?: ValueTypes["RevenuePredictionUpdateChannelEntityRelationInput"] | undefined | null,
	alwaysIncludeInTotalRevenue?: boolean | undefined | null,
	recurrencePeriod?: ValueTypes["RecurrencePeriod"] | undefined | null,
	monday?: boolean | undefined | null,
	tuesday?: boolean | undefined | null,
	wednesday?: boolean | undefined | null,
	thursday?: boolean | undefined | null,
	friday?: boolean | undefined | null,
	saturday?: boolean | undefined | null,
	sunday?: boolean | undefined | null,
	terms?: Array<ValueTypes["RevenuePredictionUpdateTermsEntityRelationInput"]> | undefined | null,
	paymentMethod?: ValueTypes["RevenuePredictionUpdatePaymentMethodEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["RevenuePredictionChangeUpsertPredictionRelationInput"]: {
	update?: ValueTypes["RevenuePredictionWithoutChangesUpdateInput"] | undefined | null,
	create?: ValueTypes["RevenuePredictionWithoutChangesCreateInput"] | undefined | null
};
	["FileConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FileEdge"],
		__typename?: boolean | `@${string}`
}>;
	["FileEdge"]: AliasType<{
	node?:ValueTypes["File"],
		__typename?: boolean | `@${string}`
}>;
	["LineCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	positionStartX?: number | undefined | null,
	positionStartY?: number | undefined | null,
	positionEndX?: number | undefined | null,
	positionEndY?: number | undefined | null,
	area?: ValueTypes["LineCreateAreaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LineCreateAreaEntityRelationInput"]: {
	connect?: ValueTypes["AreaUniqueWhere"] | undefined | null,
	create?: ValueTypes["AreaWithoutLinesCreateInput"] | undefined | null
};
	["AreaWithoutLinesCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	order?: number | undefined | null,
	name?: string | undefined | null,
	venue?: ValueTypes["AreaCreateVenueEntityRelationInput"] | undefined | null,
	tables?: Array<ValueTypes["AreaCreateTablesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LineUpdateInput"]: {
	positionStartX?: number | undefined | null,
	positionStartY?: number | undefined | null,
	positionEndX?: number | undefined | null,
	positionEndY?: number | undefined | null,
	area?: ValueTypes["LineUpdateAreaEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LineUpdateAreaEntityRelationInput"]: {
	create?: ValueTypes["AreaWithoutLinesCreateInput"] | undefined | null,
	update?: ValueTypes["AreaWithoutLinesUpdateInput"] | undefined | null,
	upsert?: ValueTypes["LineUpsertAreaRelationInput"] | undefined | null,
	connect?: ValueTypes["AreaUniqueWhere"] | undefined | null,
	delete?: boolean | undefined | null
};
	["AreaWithoutLinesUpdateInput"]: {
	order?: number | undefined | null,
	name?: string | undefined | null,
	venue?: ValueTypes["AreaUpdateVenueEntityRelationInput"] | undefined | null,
	tables?: Array<ValueTypes["AreaUpdateTablesEntityRelationInput"]> | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["LineUpsertAreaRelationInput"]: {
	update?: ValueTypes["AreaWithoutLinesUpdateInput"] | undefined | null,
	create?: ValueTypes["AreaWithoutLinesCreateInput"] | undefined | null
};
	["FinancesBalanceItem"]: AliasType<{
	_meta?:ValueTypes["FinancesBalanceItemMeta"],
	id?:boolean | `@${string}`,
	amountCents?:boolean | `@${string}`,
	date?:boolean | `@${string}`,
venue?: [{	filter?: ValueTypes["VenueWhere"] | undefined | null},ValueTypes["Venue"]],
	paidByCash?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FinancesBalanceItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	amountCents?:ValueTypes["FieldMeta"],
	date?:ValueTypes["FieldMeta"],
	venue?:ValueTypes["FieldMeta"],
	paidByCash?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["FinancesBalanceItemUniqueWhere"]: {
	id?: ValueTypes["UUID"] | undefined | null
};
	["FinancesBalanceItemWhere"]: {
	id?: ValueTypes["UUIDCondition"] | undefined | null,
	amountCents?: ValueTypes["IntCondition"] | undefined | null,
	date?: ValueTypes["DateCondition"] | undefined | null,
	venue?: ValueTypes["VenueWhere"] | undefined | null,
	paidByCash?: ValueTypes["BooleanCondition"] | undefined | null,
	and?: Array<ValueTypes["FinancesBalanceItemWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["FinancesBalanceItemWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["FinancesBalanceItemWhere"] | undefined | null
};
	["FinancesBalanceItemOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	amountCents?: ValueTypes["OrderDirection"] | undefined | null,
	date?: ValueTypes["OrderDirection"] | undefined | null,
	venue?: ValueTypes["VenueOrderBy"] | undefined | null,
	paidByCash?: ValueTypes["OrderDirection"] | undefined | null
};
	["FinancesBalanceItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FinancesBalanceItemEdge"],
		__typename?: boolean | `@${string}`
}>;
	["FinancesBalanceItemEdge"]: AliasType<{
	node?:ValueTypes["FinancesBalanceItem"],
		__typename?: boolean | `@${string}`
}>;
	["FinancesBalanceItemCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	amountCents?: number | undefined | null,
	date?: ValueTypes["Date"] | undefined | null,
	venue?: ValueTypes["FinancesBalanceItemCreateVenueEntityRelationInput"] | undefined | null,
	paidByCash?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FinancesBalanceItemCreateVenueEntityRelationInput"]: {
	connect?: ValueTypes["VenueUniqueWhere"] | undefined | null,
	create?: ValueTypes["VenueCreateInput"] | undefined | null
};
	["FinancesBalanceItemUpdateInput"]: {
	amountCents?: number | undefined | null,
	date?: ValueTypes["Date"] | undefined | null,
	venue?: ValueTypes["FinancesBalanceItemUpdateVenueEntityRelationInput"] | undefined | null,
	paidByCash?: boolean | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["FinancesBalanceItemUpdateVenueEntityRelationInput"]: {
	create?: ValueTypes["VenueCreateInput"] | undefined | null,
	update?: ValueTypes["VenueUpdateInput"] | undefined | null,
	upsert?: ValueTypes["FinancesBalanceItemUpsertVenueRelationInput"] | undefined | null,
	connect?: ValueTypes["VenueUniqueWhere"] | undefined | null
};
	["FinancesBalanceItemUpsertVenueRelationInput"]: {
	update?: ValueTypes["VenueUpdateInput"] | undefined | null,
	create?: ValueTypes["VenueCreateInput"] | undefined | null
};
	["OrderPaymentStatsByDay"]: AliasType<{
	_meta?:ValueTypes["OrderPaymentStatsByDayMeta"],
	id?:boolean | `@${string}`,
	day?:boolean | `@${string}`,
	totalGratuityCents?:boolean | `@${string}`,
	reducedGratuityCents?:boolean | `@${string}`,
channel?: [{	filter?: ValueTypes["ChannelWhere"] | undefined | null},ValueTypes["Channel"]],
paymentMethod?: [{	filter?: ValueTypes["PaymentMethodWhere"] | undefined | null},ValueTypes["PaymentMethod"]],
		__typename?: boolean | `@${string}`
}>;
	["OrderPaymentStatsByDayMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	day?:ValueTypes["FieldMeta"],
	totalGratuityCents?:ValueTypes["FieldMeta"],
	reducedGratuityCents?:ValueTypes["FieldMeta"],
	channel?:ValueTypes["FieldMeta"],
	paymentMethod?:ValueTypes["FieldMeta"],
		__typename?: boolean | `@${string}`
}>;
	["OrderPaymentStatsByDayUniqueWhere"]: {
	id?: string | undefined | null
};
	["OrderPaymentStatsByDayWhere"]: {
	id?: ValueTypes["StringCondition"] | undefined | null,
	day?: ValueTypes["DateCondition"] | undefined | null,
	totalGratuityCents?: ValueTypes["IntCondition"] | undefined | null,
	reducedGratuityCents?: ValueTypes["IntCondition"] | undefined | null,
	channel?: ValueTypes["ChannelWhere"] | undefined | null,
	paymentMethod?: ValueTypes["PaymentMethodWhere"] | undefined | null,
	and?: Array<ValueTypes["OrderPaymentStatsByDayWhere"] | undefined | null> | undefined | null,
	or?: Array<ValueTypes["OrderPaymentStatsByDayWhere"] | undefined | null> | undefined | null,
	not?: ValueTypes["OrderPaymentStatsByDayWhere"] | undefined | null
};
	["OrderPaymentStatsByDayOrderBy"]: {
	_random?: boolean | undefined | null,
	_randomSeeded?: number | undefined | null,
	id?: ValueTypes["OrderDirection"] | undefined | null,
	day?: ValueTypes["OrderDirection"] | undefined | null,
	totalGratuityCents?: ValueTypes["OrderDirection"] | undefined | null,
	reducedGratuityCents?: ValueTypes["OrderDirection"] | undefined | null,
	channel?: ValueTypes["ChannelOrderBy"] | undefined | null,
	paymentMethod?: ValueTypes["PaymentMethodOrderBy"] | undefined | null
};
	["OrderPaymentStatsByDayConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["OrderPaymentStatsByDayEdge"],
		__typename?: boolean | `@${string}`
}>;
	["OrderPaymentStatsByDayEdge"]: AliasType<{
	node?:ValueTypes["OrderPaymentStatsByDay"],
		__typename?: boolean | `@${string}`
}>;
	["WoltDriveDeliveryConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["WoltDriveDeliveryEdge"],
		__typename?: boolean | `@${string}`
}>;
	["WoltDriveDeliveryEdge"]: AliasType<{
	node?:ValueTypes["WoltDriveDelivery"],
		__typename?: boolean | `@${string}`
}>;
	["WoltDriveDeliveryCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	state?: ValueTypes["WoltDriveDeliveryState"] | undefined | null,
	shipmentPromiseId?: string | undefined | null,
	deliveryPrice?: number | undefined | null,
	deliveryPriceCurrency?: string | undefined | null,
	shipmentPromiseResponse?: string | undefined | null,
	deliveryOrderId?: string | undefined | null,
	trackingUrl?: string | undefined | null,
	deliverOrderResponse?: string | undefined | null,
	delivery?: ValueTypes["WoltDriveDeliveryCreateDeliveryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["WoltDriveDeliveryCreateDeliveryEntityRelationInput"]: {
	connect?: ValueTypes["OrderDeliveryUniqueWhere"] | undefined | null,
	create?: ValueTypes["OrderDeliveryWithoutWoltDriveDeliveryCreateInput"] | undefined | null
};
	["OrderDeliveryWithoutWoltDriveDeliveryCreateInput"]: {
	id?: ValueTypes["UUID"] | undefined | null,
	priceCents?: number | undefined | null,
	deliveredAt?: ValueTypes["DateTime"] | undefined | null,
	method?: ValueTypes["OrderDeliveryCreateMethodEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["OrderDeliveryCreateVatRateEntityRelationInput"] | undefined | null,
	order?: ValueTypes["OrderDeliveryCreateOrderEntityRelationInput"] | undefined | null,
	expectedAt?: ValueTypes["DateTime"] | undefined | null,
	state?: ValueTypes["OrderDeliveryState"] | undefined | null,
	loadingDurationHours?: number | undefined | null,
	dispatchAt?: ValueTypes["DateTime"] | undefined | null,
	duration?: string | undefined | null,
	window?: string | undefined | null,
	expectedEndAt?: ValueTypes["DateTime"] | undefined | null,
	processingAt?: ValueTypes["DateTime"] | undefined | null,
	deliveringAt?: ValueTypes["DateTime"] | undefined | null,
	failedAt?: ValueTypes["DateTime"] | undefined | null,
	internalNote?: string | undefined | null,
	deliveryWaypoint?: ValueTypes["OrderDeliveryCreateDeliveryWaypointEntityRelationInput"] | undefined | null,
	events?: Array<ValueTypes["OrderDeliveryCreateEventsEntityRelationInput"]> | undefined | null,
	prepareAt?: ValueTypes["DateTime"] | undefined | null,
	liftagoRide?: ValueTypes["OrderDeliveryCreateLiftagoRideEntityRelationInput"] | undefined | null,
	pickedAt?: ValueTypes["DateTime"] | undefined | null,
	address?: ValueTypes["OrderDeliveryCreateAddressEntityRelationInput"] | undefined | null,
	trackingCode?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["WoltDriveDeliveryUpdateInput"]: {
	state?: ValueTypes["WoltDriveDeliveryState"] | undefined | null,
	shipmentPromiseId?: string | undefined | null,
	deliveryPrice?: number | undefined | null,
	deliveryPriceCurrency?: string | undefined | null,
	shipmentPromiseResponse?: string | undefined | null,
	deliveryOrderId?: string | undefined | null,
	trackingUrl?: string | undefined | null,
	deliverOrderResponse?: string | undefined | null,
	delivery?: ValueTypes["WoltDriveDeliveryUpdateDeliveryEntityRelationInput"] | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["WoltDriveDeliveryUpdateDeliveryEntityRelationInput"]: {
	create?: ValueTypes["OrderDeliveryWithoutWoltDriveDeliveryCreateInput"] | undefined | null,
	update?: ValueTypes["OrderDeliveryWithoutWoltDriveDeliveryUpdateInput"] | undefined | null,
	upsert?: ValueTypes["WoltDriveDeliveryUpsertDeliveryRelationInput"] | undefined | null,
	connect?: ValueTypes["OrderDeliveryUniqueWhere"] | undefined | null,
	disconnect?: boolean | undefined | null,
	delete?: boolean | undefined | null
};
	["OrderDeliveryWithoutWoltDriveDeliveryUpdateInput"]: {
	priceCents?: number | undefined | null,
	deliveredAt?: ValueTypes["DateTime"] | undefined | null,
	method?: ValueTypes["OrderDeliveryUpdateMethodEntityRelationInput"] | undefined | null,
	vatRate?: ValueTypes["OrderDeliveryUpdateVatRateEntityRelationInput"] | undefined | null,
	order?: ValueTypes["OrderDeliveryUpdateOrderEntityRelationInput"] | undefined | null,
	expectedAt?: ValueTypes["DateTime"] | undefined | null,
	state?: ValueTypes["OrderDeliveryState"] | undefined | null,
	loadingDurationHours?: number | undefined | null,
	dispatchAt?: ValueTypes["DateTime"] | undefined | null,
	duration?: string | undefined | null,
	window?: string | undefined | null,
	expectedEndAt?: ValueTypes["DateTime"] | undefined | null,
	processingAt?: ValueTypes["DateTime"] | undefined | null,
	deliveringAt?: ValueTypes["DateTime"] | undefined | null,
	failedAt?: ValueTypes["DateTime"] | undefined | null,
	internalNote?: string | undefined | null,
	deliveryWaypoint?: ValueTypes["OrderDeliveryUpdateDeliveryWaypointEntityRelationInput"] | undefined | null,
	events?: Array<ValueTypes["OrderDeliveryUpdateEventsEntityRelationInput"]> | undefined | null,
	prepareAt?: ValueTypes["DateTime"] | undefined | null,
	liftagoRide?: ValueTypes["OrderDeliveryUpdateLiftagoRideEntityRelationInput"] | undefined | null,
	pickedAt?: ValueTypes["DateTime"] | undefined | null,
	address?: ValueTypes["OrderDeliveryUpdateAddressEntityRelationInput"] | undefined | null,
	trackingCode?: string | undefined | null,
	_dummy_field_?: boolean | undefined | null
};
	["WoltDriveDeliveryUpsertDeliveryRelationInput"]: {
	update?: ValueTypes["OrderDeliveryWithoutWoltDriveDeliveryUpdateInput"] | undefined | null,
	create?: ValueTypes["OrderDeliveryWithoutWoltDriveDeliveryCreateInput"] | undefined | null
};
	["QueryTransaction"]: AliasType<{
getAddress?: [{	by: ValueTypes["AddressUniqueWhere"],	filter?: ValueTypes["AddressWhere"] | undefined | null},ValueTypes["Address"]],
listAddress?: [{	filter?: ValueTypes["AddressWhere"] | undefined | null,	orderBy?: Array<ValueTypes["AddressOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Address"]],
paginateAddress?: [{	filter?: ValueTypes["AddressWhere"] | undefined | null,	orderBy?: Array<ValueTypes["AddressOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["AddressConnection"]],
validateCreateAddress?: [{	data: ValueTypes["AddressCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateAddress?: [{	by: ValueTypes["AddressUniqueWhere"],	data: ValueTypes["AddressUpdateInput"]},ValueTypes["_ValidationResult"]],
getCountry?: [{	by: ValueTypes["CountryUniqueWhere"],	filter?: ValueTypes["CountryWhere"] | undefined | null},ValueTypes["Country"]],
listCountry?: [{	filter?: ValueTypes["CountryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CountryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Country"]],
paginateCountry?: [{	filter?: ValueTypes["CountryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CountryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CountryConnection"]],
validateCreateCountry?: [{	data: ValueTypes["CountryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCountry?: [{	by: ValueTypes["CountryUniqueWhere"],	data: ValueTypes["CountryUpdateInput"]},ValueTypes["_ValidationResult"]],
getChannel?: [{	by: ValueTypes["ChannelUniqueWhere"],	filter?: ValueTypes["ChannelWhere"] | undefined | null},ValueTypes["Channel"]],
listChannel?: [{	filter?: ValueTypes["ChannelWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ChannelOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Channel"]],
paginateChannel?: [{	filter?: ValueTypes["ChannelWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ChannelOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ChannelConnection"]],
validateCreateChannel?: [{	data: ValueTypes["ChannelCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateChannel?: [{	by: ValueTypes["ChannelUniqueWhere"],	data: ValueTypes["ChannelUpdateInput"]},ValueTypes["_ValidationResult"]],
getChannelPayment?: [{	by: ValueTypes["ChannelPaymentUniqueWhere"],	filter?: ValueTypes["ChannelPaymentWhere"] | undefined | null},ValueTypes["ChannelPayment"]],
listChannelPayment?: [{	filter?: ValueTypes["ChannelPaymentWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ChannelPaymentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ChannelPayment"]],
paginateChannelPayment?: [{	filter?: ValueTypes["ChannelPaymentWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ChannelPaymentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ChannelPaymentConnection"]],
validateCreateChannelPayment?: [{	data: ValueTypes["ChannelPaymentCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateChannelPayment?: [{	by: ValueTypes["ChannelPaymentUniqueWhere"],	data: ValueTypes["ChannelPaymentUpdateInput"]},ValueTypes["_ValidationResult"]],
getChannelDelivery?: [{	by: ValueTypes["ChannelDeliveryUniqueWhere"],	filter?: ValueTypes["ChannelDeliveryWhere"] | undefined | null},ValueTypes["ChannelDelivery"]],
listChannelDelivery?: [{	filter?: ValueTypes["ChannelDeliveryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ChannelDeliveryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ChannelDelivery"]],
paginateChannelDelivery?: [{	filter?: ValueTypes["ChannelDeliveryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ChannelDeliveryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ChannelDeliveryConnection"]],
validateCreateChannelDelivery?: [{	data: ValueTypes["ChannelDeliveryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateChannelDelivery?: [{	by: ValueTypes["ChannelDeliveryUniqueWhere"],	data: ValueTypes["ChannelDeliveryUpdateInput"]},ValueTypes["_ValidationResult"]],
getCustomer?: [{	by: ValueTypes["CustomerUniqueWhere"],	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["Customer"]],
listCustomer?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Customer"]],
paginateCustomer?: [{	filter?: ValueTypes["CustomerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerConnection"]],
validateCreateCustomer?: [{	data: ValueTypes["CustomerCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCustomer?: [{	by: ValueTypes["CustomerUniqueWhere"],	data: ValueTypes["CustomerUpdateInput"]},ValueTypes["_ValidationResult"]],
getCustomerCredit?: [{	by: ValueTypes["CustomerCreditUniqueWhere"],	filter?: ValueTypes["CustomerCreditWhere"] | undefined | null},ValueTypes["CustomerCredit"]],
listCustomerCredit?: [{	filter?: ValueTypes["CustomerCreditWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerCreditOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CustomerCredit"]],
paginateCustomerCredit?: [{	filter?: ValueTypes["CustomerCreditWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerCreditOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerCreditConnection"]],
validateCreateCustomerCredit?: [{	data: ValueTypes["CustomerCreditCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCustomerCredit?: [{	by: ValueTypes["CustomerCreditUniqueWhere"],	data: ValueTypes["CustomerCreditUpdateInput"]},ValueTypes["_ValidationResult"]],
getCustomerGroup?: [{	by: ValueTypes["CustomerGroupUniqueWhere"],	filter?: ValueTypes["CustomerGroupWhere"] | undefined | null},ValueTypes["CustomerGroup"]],
listCustomerGroup?: [{	filter?: ValueTypes["CustomerGroupWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerGroupOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CustomerGroup"]],
paginateCustomerGroup?: [{	filter?: ValueTypes["CustomerGroupWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerGroupOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerGroupConnection"]],
validateCreateCustomerGroup?: [{	data: ValueTypes["CustomerGroupCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCustomerGroup?: [{	by: ValueTypes["CustomerGroupUniqueWhere"],	data: ValueTypes["CustomerGroupUpdateInput"]},ValueTypes["_ValidationResult"]],
getCustomerPaymentMethod?: [{	by: ValueTypes["CustomerPaymentMethodUniqueWhere"],	filter?: ValueTypes["CustomerPaymentMethodWhere"] | undefined | null},ValueTypes["CustomerPaymentMethod"]],
listCustomerPaymentMethod?: [{	filter?: ValueTypes["CustomerPaymentMethodWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerPaymentMethodOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CustomerPaymentMethod"]],
paginateCustomerPaymentMethod?: [{	filter?: ValueTypes["CustomerPaymentMethodWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerPaymentMethodOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerPaymentMethodConnection"]],
validateCreateCustomerPaymentMethod?: [{	data: ValueTypes["CustomerPaymentMethodCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCustomerPaymentMethod?: [{	by: ValueTypes["CustomerPaymentMethodUniqueWhere"],	data: ValueTypes["CustomerPaymentMethodUpdateInput"]},ValueTypes["_ValidationResult"]],
getDeliveryMethod?: [{	by: ValueTypes["DeliveryMethodUniqueWhere"],	filter?: ValueTypes["DeliveryMethodWhere"] | undefined | null},ValueTypes["DeliveryMethod"]],
listDeliveryMethod?: [{	filter?: ValueTypes["DeliveryMethodWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryMethodOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["DeliveryMethod"]],
paginateDeliveryMethod?: [{	filter?: ValueTypes["DeliveryMethodWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryMethodOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["DeliveryMethodConnection"]],
validateCreateDeliveryMethod?: [{	data: ValueTypes["DeliveryMethodCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDeliveryMethod?: [{	by: ValueTypes["DeliveryMethodUniqueWhere"],	data: ValueTypes["DeliveryMethodUpdateInput"]},ValueTypes["_ValidationResult"]],
getOrder?: [{	by: ValueTypes["OrderUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["Order"]],
listOrder?: [{	filter?: ValueTypes["OrderWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Order"]],
paginateOrder?: [{	filter?: ValueTypes["OrderWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderConnection"]],
validateCreateOrder?: [{	data: ValueTypes["OrderCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateOrder?: [{	by: ValueTypes["OrderUniqueWhere"],	data: ValueTypes["OrderUpdateInput"]},ValueTypes["_ValidationResult"]],
getOrderDiscount?: [{	by: ValueTypes["OrderDiscountUniqueWhere"],	filter?: ValueTypes["OrderDiscountWhere"] | undefined | null},ValueTypes["OrderDiscount"]],
listOrderDiscount?: [{	filter?: ValueTypes["OrderDiscountWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderDiscountOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["OrderDiscount"]],
paginateOrderDiscount?: [{	filter?: ValueTypes["OrderDiscountWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderDiscountOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderDiscountConnection"]],
validateCreateOrderDiscount?: [{	data: ValueTypes["OrderDiscountCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateOrderDiscount?: [{	by: ValueTypes["OrderDiscountUniqueWhere"],	data: ValueTypes["OrderDiscountUpdateInput"]},ValueTypes["_ValidationResult"]],
getOrderPayment?: [{	by: ValueTypes["OrderPaymentUniqueWhere"],	filter?: ValueTypes["OrderPaymentWhere"] | undefined | null},ValueTypes["OrderPayment"]],
listOrderPayment?: [{	filter?: ValueTypes["OrderPaymentWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderPaymentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["OrderPayment"]],
paginateOrderPayment?: [{	filter?: ValueTypes["OrderPaymentWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderPaymentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderPaymentConnection"]],
validateCreateOrderPayment?: [{	data: ValueTypes["OrderPaymentCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateOrderPayment?: [{	by: ValueTypes["OrderPaymentUniqueWhere"],	data: ValueTypes["OrderPaymentUpdateInput"]},ValueTypes["_ValidationResult"]],
getOrderDelivery?: [{	by: ValueTypes["OrderDeliveryUniqueWhere"],	filter?: ValueTypes["OrderDeliveryWhere"] | undefined | null},ValueTypes["OrderDelivery"]],
listOrderDelivery?: [{	filter?: ValueTypes["OrderDeliveryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderDeliveryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["OrderDelivery"]],
paginateOrderDelivery?: [{	filter?: ValueTypes["OrderDeliveryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderDeliveryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderDeliveryConnection"]],
validateCreateOrderDelivery?: [{	data: ValueTypes["OrderDeliveryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateOrderDelivery?: [{	by: ValueTypes["OrderDeliveryUniqueWhere"],	data: ValueTypes["OrderDeliveryUpdateInput"]},ValueTypes["_ValidationResult"]],
getOrderItem?: [{	by: ValueTypes["OrderItemUniqueWhere"],	filter?: ValueTypes["OrderItemWhere"] | undefined | null},ValueTypes["OrderItem"]],
listOrderItem?: [{	filter?: ValueTypes["OrderItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["OrderItem"]],
paginateOrderItem?: [{	filter?: ValueTypes["OrderItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderItemConnection"]],
validateCreateOrderItem?: [{	data: ValueTypes["OrderItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateOrderItem?: [{	by: ValueTypes["OrderItemUniqueWhere"],	data: ValueTypes["OrderItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getPaymentMethod?: [{	by: ValueTypes["PaymentMethodUniqueWhere"],	filter?: ValueTypes["PaymentMethodWhere"] | undefined | null},ValueTypes["PaymentMethod"]],
listPaymentMethod?: [{	filter?: ValueTypes["PaymentMethodWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PaymentMethodOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PaymentMethod"]],
paginatePaymentMethod?: [{	filter?: ValueTypes["PaymentMethodWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PaymentMethodOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PaymentMethodConnection"]],
validateCreatePaymentMethod?: [{	data: ValueTypes["PaymentMethodCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePaymentMethod?: [{	by: ValueTypes["PaymentMethodUniqueWhere"],	data: ValueTypes["PaymentMethodUpdateInput"]},ValueTypes["_ValidationResult"]],
getVatRate?: [{	by: ValueTypes["VatRateUniqueWhere"],	filter?: ValueTypes["VatRateWhere"] | undefined | null},ValueTypes["VatRate"]],
listVatRate?: [{	filter?: ValueTypes["VatRateWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VatRateOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["VatRate"]],
paginateVatRate?: [{	filter?: ValueTypes["VatRateWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VatRateOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["VatRateConnection"]],
validateCreateVatRate?: [{	data: ValueTypes["VatRateCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateVatRate?: [{	by: ValueTypes["VatRateUniqueWhere"],	data: ValueTypes["VatRateUpdateInput"]},ValueTypes["_ValidationResult"]],
getProduct?: [{	by: ValueTypes["ProductUniqueWhere"],	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["Product"]],
listProduct?: [{	filter?: ValueTypes["ProductWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Product"]],
paginateProduct?: [{	filter?: ValueTypes["ProductWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductConnection"]],
validateCreateProduct?: [{	data: ValueTypes["ProductCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProduct?: [{	by: ValueTypes["ProductUniqueWhere"],	data: ValueTypes["ProductUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductStock?: [{	by: ValueTypes["ProductStockUniqueWhere"],	filter?: ValueTypes["ProductStockWhere"] | undefined | null},ValueTypes["ProductStock"]],
listProductStock?: [{	filter?: ValueTypes["ProductStockWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductStockOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductStock"]],
paginateProductStock?: [{	filter?: ValueTypes["ProductStockWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductStockOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductStockConnection"]],
validateCreateProductStock?: [{	data: ValueTypes["ProductStockCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductStock?: [{	by: ValueTypes["ProductStockUniqueWhere"],	data: ValueTypes["ProductStockUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductPacking?: [{	by: ValueTypes["ProductPackingUniqueWhere"],	filter?: ValueTypes["ProductPackingWhere"] | undefined | null},ValueTypes["ProductPacking"]],
listProductPacking?: [{	filter?: ValueTypes["ProductPackingWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductPackingOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductPacking"]],
paginateProductPacking?: [{	filter?: ValueTypes["ProductPackingWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductPackingOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductPackingConnection"]],
validateCreateProductPacking?: [{	data: ValueTypes["ProductPackingCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductPacking?: [{	by: ValueTypes["ProductPackingUniqueWhere"],	data: ValueTypes["ProductPackingUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductGroupPrice?: [{	by: ValueTypes["ProductGroupPriceUniqueWhere"],	filter?: ValueTypes["ProductGroupPriceWhere"] | undefined | null},ValueTypes["ProductGroupPrice"]],
listProductGroupPrice?: [{	filter?: ValueTypes["ProductGroupPriceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductGroupPriceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductGroupPrice"]],
paginateProductGroupPrice?: [{	filter?: ValueTypes["ProductGroupPriceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductGroupPriceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductGroupPriceConnection"]],
validateCreateProductGroupPrice?: [{	data: ValueTypes["ProductGroupPriceCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductGroupPrice?: [{	by: ValueTypes["ProductGroupPriceUniqueWhere"],	data: ValueTypes["ProductGroupPriceUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductRecipe?: [{	by: ValueTypes["ProductRecipeUniqueWhere"],	filter?: ValueTypes["ProductRecipeWhere"] | undefined | null},ValueTypes["ProductRecipe"]],
listProductRecipe?: [{	filter?: ValueTypes["ProductRecipeWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductRecipeOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductRecipe"]],
paginateProductRecipe?: [{	filter?: ValueTypes["ProductRecipeWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductRecipeOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductRecipeConnection"]],
validateCreateProductRecipe?: [{	data: ValueTypes["ProductRecipeCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductRecipe?: [{	by: ValueTypes["ProductRecipeUniqueWhere"],	data: ValueTypes["ProductRecipeUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductCategory?: [{	by: ValueTypes["ProductCategoryUniqueWhere"],	filter?: ValueTypes["ProductCategoryWhere"] | undefined | null},ValueTypes["ProductCategory"]],
listProductCategory?: [{	filter?: ValueTypes["ProductCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCategoryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductCategory"]],
paginateProductCategory?: [{	filter?: ValueTypes["ProductCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCategoryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductCategoryConnection"]],
validateCreateProductCategory?: [{	data: ValueTypes["ProductCategoryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductCategory?: [{	by: ValueTypes["ProductCategoryUniqueWhere"],	data: ValueTypes["ProductCategoryUpdateInput"]},ValueTypes["_ValidationResult"]],
getStore?: [{	by: ValueTypes["StoreUniqueWhere"],	filter?: ValueTypes["StoreWhere"] | undefined | null},ValueTypes["Store"]],
listStore?: [{	filter?: ValueTypes["StoreWhere"] | undefined | null,	orderBy?: Array<ValueTypes["StoreOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Store"]],
paginateStore?: [{	filter?: ValueTypes["StoreWhere"] | undefined | null,	orderBy?: Array<ValueTypes["StoreOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["StoreConnection"]],
validateCreateStore?: [{	data: ValueTypes["StoreCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateStore?: [{	by: ValueTypes["StoreUniqueWhere"],	data: ValueTypes["StoreUpdateInput"]},ValueTypes["_ValidationResult"]],
getTag?: [{	by: ValueTypes["TagUniqueWhere"],	filter?: ValueTypes["TagWhere"] | undefined | null},ValueTypes["Tag"]],
listTag?: [{	filter?: ValueTypes["TagWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TagOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Tag"]],
paginateTag?: [{	filter?: ValueTypes["TagWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TagOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TagConnection"]],
validateCreateTag?: [{	data: ValueTypes["TagCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTag?: [{	by: ValueTypes["TagUniqueWhere"],	data: ValueTypes["TagUpdateInput"]},ValueTypes["_ValidationResult"]],
getCustomerPermissions?: [{	by: ValueTypes["CustomerPermissionsUniqueWhere"],	filter?: ValueTypes["CustomerPermissionsWhere"] | undefined | null},ValueTypes["CustomerPermissions"]],
listCustomerPermissions?: [{	filter?: ValueTypes["CustomerPermissionsWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerPermissionsOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CustomerPermissions"]],
paginateCustomerPermissions?: [{	filter?: ValueTypes["CustomerPermissionsWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerPermissionsOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerPermissionsConnection"]],
getImage?: [{	by: ValueTypes["ImageUniqueWhere"],	filter?: ValueTypes["ImageWhere"] | undefined | null},ValueTypes["Image"]],
listImage?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ImageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Image"]],
paginateImage?: [{	filter?: ValueTypes["ImageWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ImageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ImageConnection"]],
validateCreateImage?: [{	data: ValueTypes["ImageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImage?: [{	by: ValueTypes["ImageUniqueWhere"],	data: ValueTypes["ImageUpdateInput"]},ValueTypes["_ValidationResult"]],
getBusinessCategory?: [{	by: ValueTypes["BusinessCategoryUniqueWhere"],	filter?: ValueTypes["BusinessCategoryWhere"] | undefined | null},ValueTypes["BusinessCategory"]],
listBusinessCategory?: [{	filter?: ValueTypes["BusinessCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessCategoryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BusinessCategory"]],
paginateBusinessCategory?: [{	filter?: ValueTypes["BusinessCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessCategoryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BusinessCategoryConnection"]],
validateCreateBusinessCategory?: [{	data: ValueTypes["BusinessCategoryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBusinessCategory?: [{	by: ValueTypes["BusinessCategoryUniqueWhere"],	data: ValueTypes["BusinessCategoryUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductList?: [{	by: ValueTypes["ProductListUniqueWhere"],	filter?: ValueTypes["ProductListWhere"] | undefined | null},ValueTypes["ProductList"]],
listProductList?: [{	filter?: ValueTypes["ProductListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductList"]],
paginateProductList?: [{	filter?: ValueTypes["ProductListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductListConnection"]],
validateCreateProductList?: [{	data: ValueTypes["ProductListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductList?: [{	by: ValueTypes["ProductListUniqueWhere"],	data: ValueTypes["ProductListUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductListItem?: [{	by: ValueTypes["ProductListItemUniqueWhere"],	filter?: ValueTypes["ProductListItemWhere"] | undefined | null},ValueTypes["ProductListItem"]],
listProductListItem?: [{	filter?: ValueTypes["ProductListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductListItem"]],
paginateProductListItem?: [{	filter?: ValueTypes["ProductListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductListItemConnection"]],
validateCreateProductListItem?: [{	data: ValueTypes["ProductListItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductListItem?: [{	by: ValueTypes["ProductListItemUniqueWhere"],	data: ValueTypes["ProductListItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductCategoryList?: [{	by: ValueTypes["ProductCategoryListUniqueWhere"],	filter?: ValueTypes["ProductCategoryListWhere"] | undefined | null},ValueTypes["ProductCategoryList"]],
listProductCategoryList?: [{	filter?: ValueTypes["ProductCategoryListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCategoryListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductCategoryList"]],
paginateProductCategoryList?: [{	filter?: ValueTypes["ProductCategoryListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCategoryListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductCategoryListConnection"]],
validateCreateProductCategoryList?: [{	data: ValueTypes["ProductCategoryListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductCategoryList?: [{	by: ValueTypes["ProductCategoryListUniqueWhere"],	data: ValueTypes["ProductCategoryListUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductCategoryListItem?: [{	by: ValueTypes["ProductCategoryListItemUniqueWhere"],	filter?: ValueTypes["ProductCategoryListItemWhere"] | undefined | null},ValueTypes["ProductCategoryListItem"]],
listProductCategoryListItem?: [{	filter?: ValueTypes["ProductCategoryListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCategoryListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductCategoryListItem"]],
paginateProductCategoryListItem?: [{	filter?: ValueTypes["ProductCategoryListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCategoryListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductCategoryListItemConnection"]],
validateCreateProductCategoryListItem?: [{	data: ValueTypes["ProductCategoryListItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductCategoryListItem?: [{	by: ValueTypes["ProductCategoryListItemUniqueWhere"],	data: ValueTypes["ProductCategoryListItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getBusinessCategoryLocale?: [{	by: ValueTypes["BusinessCategoryLocaleUniqueWhere"],	filter?: ValueTypes["BusinessCategoryLocaleWhere"] | undefined | null},ValueTypes["BusinessCategoryLocale"]],
listBusinessCategoryLocale?: [{	filter?: ValueTypes["BusinessCategoryLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessCategoryLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BusinessCategoryLocale"]],
paginateBusinessCategoryLocale?: [{	filter?: ValueTypes["BusinessCategoryLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessCategoryLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BusinessCategoryLocaleConnection"]],
validateCreateBusinessCategoryLocale?: [{	data: ValueTypes["BusinessCategoryLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBusinessCategoryLocale?: [{	by: ValueTypes["BusinessCategoryLocaleUniqueWhere"],	data: ValueTypes["BusinessCategoryLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getLocale?: [{	by: ValueTypes["LocaleUniqueWhere"],	filter?: ValueTypes["LocaleWhere"] | undefined | null},ValueTypes["Locale"]],
listLocale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Locale"]],
paginateLocale?: [{	filter?: ValueTypes["LocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["LocaleConnection"]],
validateCreateLocale?: [{	data: ValueTypes["LocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLocale?: [{	by: ValueTypes["LocaleUniqueWhere"],	data: ValueTypes["LocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductCategoryListLocale?: [{	by: ValueTypes["ProductCategoryListLocaleUniqueWhere"],	filter?: ValueTypes["ProductCategoryListLocaleWhere"] | undefined | null},ValueTypes["ProductCategoryListLocale"]],
listProductCategoryListLocale?: [{	filter?: ValueTypes["ProductCategoryListLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCategoryListLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductCategoryListLocale"]],
paginateProductCategoryListLocale?: [{	filter?: ValueTypes["ProductCategoryListLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCategoryListLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductCategoryListLocaleConnection"]],
validateCreateProductCategoryListLocale?: [{	data: ValueTypes["ProductCategoryListLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductCategoryListLocale?: [{	by: ValueTypes["ProductCategoryListLocaleUniqueWhere"],	data: ValueTypes["ProductCategoryListLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getCustomerName?: [{	by: ValueTypes["CustomerNameUniqueWhere"],	filter?: ValueTypes["CustomerNameWhere"] | undefined | null},ValueTypes["CustomerName"]],
listCustomerName?: [{	filter?: ValueTypes["CustomerNameWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerNameOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CustomerName"]],
paginateCustomerName?: [{	filter?: ValueTypes["CustomerNameWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerNameOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerNameConnection"]],
validateCreateCustomerName?: [{	data: ValueTypes["CustomerNameCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCustomerName?: [{	by: ValueTypes["CustomerNameUniqueWhere"],	data: ValueTypes["CustomerNameUpdateInput"]},ValueTypes["_ValidationResult"]],
getCustomerAlias?: [{	by: ValueTypes["CustomerAliasUniqueWhere"],	filter?: ValueTypes["CustomerAliasWhere"] | undefined | null},ValueTypes["CustomerAlias"]],
listCustomerAlias?: [{	filter?: ValueTypes["CustomerAliasWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerAliasOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CustomerAlias"]],
paginateCustomerAlias?: [{	filter?: ValueTypes["CustomerAliasWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerAliasOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerAliasConnection"]],
validateCreateCustomerAlias?: [{	data: ValueTypes["CustomerAliasCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCustomerAlias?: [{	by: ValueTypes["CustomerAliasUniqueWhere"],	data: ValueTypes["CustomerAliasUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductIngredientItem?: [{	by: ValueTypes["ProductIngredientItemUniqueWhere"],	filter?: ValueTypes["ProductIngredientItemWhere"] | undefined | null},ValueTypes["ProductIngredientItem"]],
listProductIngredientItem?: [{	filter?: ValueTypes["ProductIngredientItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductIngredientItem"]],
paginateProductIngredientItem?: [{	filter?: ValueTypes["ProductIngredientItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductIngredientItemConnection"]],
validateCreateProductIngredientItem?: [{	data: ValueTypes["ProductIngredientItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductIngredientItem?: [{	by: ValueTypes["ProductIngredientItemUniqueWhere"],	data: ValueTypes["ProductIngredientItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductIngredientItemQuantity?: [{	by: ValueTypes["ProductIngredientItemQuantityUniqueWhere"],	filter?: ValueTypes["ProductIngredientItemQuantityWhere"] | undefined | null},ValueTypes["ProductIngredientItemQuantity"]],
listProductIngredientItemQuantity?: [{	filter?: ValueTypes["ProductIngredientItemQuantityWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientItemQuantityOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductIngredientItemQuantity"]],
paginateProductIngredientItemQuantity?: [{	filter?: ValueTypes["ProductIngredientItemQuantityWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientItemQuantityOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductIngredientItemQuantityConnection"]],
validateCreateProductIngredientItemQuantity?: [{	data: ValueTypes["ProductIngredientItemQuantityCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductIngredientItemQuantity?: [{	by: ValueTypes["ProductIngredientItemQuantityUniqueWhere"],	data: ValueTypes["ProductIngredientItemQuantityUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductIngredientItemQuantityUnit?: [{	by: ValueTypes["ProductIngredientItemQuantityUnitUniqueWhere"],	filter?: ValueTypes["ProductIngredientItemQuantityUnitWhere"] | undefined | null},ValueTypes["ProductIngredientItemQuantityUnit"]],
listProductIngredientItemQuantityUnit?: [{	filter?: ValueTypes["ProductIngredientItemQuantityUnitWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientItemQuantityUnitOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductIngredientItemQuantityUnit"]],
paginateProductIngredientItemQuantityUnit?: [{	filter?: ValueTypes["ProductIngredientItemQuantityUnitWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientItemQuantityUnitOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductIngredientItemQuantityUnitConnection"]],
validateCreateProductIngredientItemQuantityUnit?: [{	data: ValueTypes["ProductIngredientItemQuantityUnitCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductIngredientItemQuantityUnit?: [{	by: ValueTypes["ProductIngredientItemQuantityUnitUniqueWhere"],	data: ValueTypes["ProductIngredientItemQuantityUnitUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductIngredient?: [{	by: ValueTypes["ProductIngredientUniqueWhere"],	filter?: ValueTypes["ProductIngredientWhere"] | undefined | null},ValueTypes["ProductIngredient"]],
listProductIngredient?: [{	filter?: ValueTypes["ProductIngredientWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductIngredient"]],
paginateProductIngredient?: [{	filter?: ValueTypes["ProductIngredientWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductIngredientConnection"]],
validateCreateProductIngredient?: [{	data: ValueTypes["ProductIngredientCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductIngredient?: [{	by: ValueTypes["ProductIngredientUniqueWhere"],	data: ValueTypes["ProductIngredientUpdateInput"]},ValueTypes["_ValidationResult"]],
getCustomerIngredientRating?: [{	by: ValueTypes["CustomerIngredientRatingUniqueWhere"],	filter?: ValueTypes["CustomerIngredientRatingWhere"] | undefined | null},ValueTypes["CustomerIngredientRating"]],
listCustomerIngredientRating?: [{	filter?: ValueTypes["CustomerIngredientRatingWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerIngredientRatingOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CustomerIngredientRating"]],
paginateCustomerIngredientRating?: [{	filter?: ValueTypes["CustomerIngredientRatingWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerIngredientRatingOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerIngredientRatingConnection"]],
validateCreateCustomerIngredientRating?: [{	data: ValueTypes["CustomerIngredientRatingCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCustomerIngredientRating?: [{	by: ValueTypes["CustomerIngredientRatingUniqueWhere"],	data: ValueTypes["CustomerIngredientRatingUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductIngredientRating?: [{	by: ValueTypes["ProductIngredientRatingUniqueWhere"],	filter?: ValueTypes["ProductIngredientRatingWhere"] | undefined | null},ValueTypes["ProductIngredientRating"]],
listProductIngredientRating?: [{	filter?: ValueTypes["ProductIngredientRatingWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientRatingOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductIngredientRating"]],
paginateProductIngredientRating?: [{	filter?: ValueTypes["ProductIngredientRatingWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientRatingOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductIngredientRatingConnection"]],
validateCreateProductIngredientRating?: [{	data: ValueTypes["ProductIngredientRatingCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductIngredientRating?: [{	by: ValueTypes["ProductIngredientRatingUniqueWhere"],	data: ValueTypes["ProductIngredientRatingUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductIngredientLocale?: [{	by: ValueTypes["ProductIngredientLocaleUniqueWhere"],	filter?: ValueTypes["ProductIngredientLocaleWhere"] | undefined | null},ValueTypes["ProductIngredientLocale"]],
listProductIngredientLocale?: [{	filter?: ValueTypes["ProductIngredientLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductIngredientLocale"]],
paginateProductIngredientLocale?: [{	filter?: ValueTypes["ProductIngredientLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductIngredientLocaleConnection"]],
validateCreateProductIngredientLocale?: [{	data: ValueTypes["ProductIngredientLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductIngredientLocale?: [{	by: ValueTypes["ProductIngredientLocaleUniqueWhere"],	data: ValueTypes["ProductIngredientLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getOrderRecurrence?: [{	by: ValueTypes["OrderRecurrenceUniqueWhere"],	filter?: ValueTypes["OrderRecurrenceWhere"] | undefined | null},ValueTypes["OrderRecurrence"]],
listOrderRecurrence?: [{	filter?: ValueTypes["OrderRecurrenceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderRecurrenceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["OrderRecurrence"]],
paginateOrderRecurrence?: [{	filter?: ValueTypes["OrderRecurrenceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderRecurrenceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderRecurrenceConnection"]],
validateCreateOrderRecurrence?: [{	data: ValueTypes["OrderRecurrenceCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateOrderRecurrence?: [{	by: ValueTypes["OrderRecurrenceUniqueWhere"],	data: ValueTypes["OrderRecurrenceUpdateInput"]},ValueTypes["_ValidationResult"]],
getOrderRecurrenceLocale?: [{	by: ValueTypes["OrderRecurrenceLocaleUniqueWhere"],	filter?: ValueTypes["OrderRecurrenceLocaleWhere"] | undefined | null},ValueTypes["OrderRecurrenceLocale"]],
listOrderRecurrenceLocale?: [{	filter?: ValueTypes["OrderRecurrenceLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderRecurrenceLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["OrderRecurrenceLocale"]],
paginateOrderRecurrenceLocale?: [{	filter?: ValueTypes["OrderRecurrenceLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderRecurrenceLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderRecurrenceLocaleConnection"]],
validateCreateOrderRecurrenceLocale?: [{	data: ValueTypes["OrderRecurrenceLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateOrderRecurrenceLocale?: [{	by: ValueTypes["OrderRecurrenceLocaleUniqueWhere"],	data: ValueTypes["OrderRecurrenceLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getBusinessCustomer?: [{	by: ValueTypes["BusinessCustomerUniqueWhere"],	filter?: ValueTypes["BusinessCustomerWhere"] | undefined | null},ValueTypes["BusinessCustomer"]],
listBusinessCustomer?: [{	filter?: ValueTypes["BusinessCustomerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessCustomerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BusinessCustomer"]],
paginateBusinessCustomer?: [{	filter?: ValueTypes["BusinessCustomerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessCustomerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BusinessCustomerConnection"]],
validateCreateBusinessCustomer?: [{	data: ValueTypes["BusinessCustomerCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBusinessCustomer?: [{	by: ValueTypes["BusinessCustomerUniqueWhere"],	data: ValueTypes["BusinessCustomerUpdateInput"]},ValueTypes["_ValidationResult"]],
getPointOfSale?: [{	by: ValueTypes["PointOfSaleUniqueWhere"],	filter?: ValueTypes["PointOfSaleWhere"] | undefined | null},ValueTypes["PointOfSale"]],
listPointOfSale?: [{	filter?: ValueTypes["PointOfSaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PointOfSale"]],
paginatePointOfSale?: [{	filter?: ValueTypes["PointOfSaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PointOfSaleConnection"]],
validateCreatePointOfSale?: [{	data: ValueTypes["PointOfSaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePointOfSale?: [{	by: ValueTypes["PointOfSaleUniqueWhere"],	data: ValueTypes["PointOfSaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getStaff?: [{	by: ValueTypes["StaffUniqueWhere"],	filter?: ValueTypes["StaffWhere"] | undefined | null},ValueTypes["Staff"]],
listStaff?: [{	filter?: ValueTypes["StaffWhere"] | undefined | null,	orderBy?: Array<ValueTypes["StaffOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Staff"]],
paginateStaff?: [{	filter?: ValueTypes["StaffWhere"] | undefined | null,	orderBy?: Array<ValueTypes["StaffOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["StaffConnection"]],
validateCreateStaff?: [{	data: ValueTypes["StaffCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateStaff?: [{	by: ValueTypes["StaffUniqueWhere"],	data: ValueTypes["StaffUpdateInput"]},ValueTypes["_ValidationResult"]],
getPointOfSalePermissions?: [{	by: ValueTypes["PointOfSalePermissionsUniqueWhere"],	filter?: ValueTypes["PointOfSalePermissionsWhere"] | undefined | null},ValueTypes["PointOfSalePermissions"]],
listPointOfSalePermissions?: [{	filter?: ValueTypes["PointOfSalePermissionsWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSalePermissionsOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PointOfSalePermissions"]],
paginatePointOfSalePermissions?: [{	filter?: ValueTypes["PointOfSalePermissionsWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSalePermissionsOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PointOfSalePermissionsConnection"]],
getBlog?: [{	by: ValueTypes["BlogUniqueWhere"],	filter?: ValueTypes["BlogWhere"] | undefined | null},ValueTypes["Blog"]],
listBlog?: [{	filter?: ValueTypes["BlogWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BlogOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Blog"]],
paginateBlog?: [{	filter?: ValueTypes["BlogWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BlogOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BlogConnection"]],
validateCreateBlog?: [{	data: ValueTypes["BlogCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBlog?: [{	by: ValueTypes["BlogUniqueWhere"],	data: ValueTypes["BlogUpdateInput"]},ValueTypes["_ValidationResult"]],
getBlogLocale?: [{	by: ValueTypes["BlogLocaleUniqueWhere"],	filter?: ValueTypes["BlogLocaleWhere"] | undefined | null},ValueTypes["BlogLocale"]],
listBlogLocale?: [{	filter?: ValueTypes["BlogLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BlogLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BlogLocale"]],
paginateBlogLocale?: [{	filter?: ValueTypes["BlogLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BlogLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BlogLocaleConnection"]],
validateCreateBlogLocale?: [{	data: ValueTypes["BlogLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBlogLocale?: [{	by: ValueTypes["BlogLocaleUniqueWhere"],	data: ValueTypes["BlogLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getBlogPost?: [{	by: ValueTypes["BlogPostUniqueWhere"],	filter?: ValueTypes["BlogPostWhere"] | undefined | null},ValueTypes["BlogPost"]],
listBlogPost?: [{	filter?: ValueTypes["BlogPostWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BlogPostOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BlogPost"]],
paginateBlogPost?: [{	filter?: ValueTypes["BlogPostWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BlogPostOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BlogPostConnection"]],
validateCreateBlogPost?: [{	data: ValueTypes["BlogPostCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBlogPost?: [{	by: ValueTypes["BlogPostUniqueWhere"],	data: ValueTypes["BlogPostUpdateInput"]},ValueTypes["_ValidationResult"]],
getBlogPostLocale?: [{	by: ValueTypes["BlogPostLocaleUniqueWhere"],	filter?: ValueTypes["BlogPostLocaleWhere"] | undefined | null},ValueTypes["BlogPostLocale"]],
listBlogPostLocale?: [{	filter?: ValueTypes["BlogPostLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BlogPostLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BlogPostLocale"]],
paginateBlogPostLocale?: [{	filter?: ValueTypes["BlogPostLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BlogPostLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BlogPostLocaleConnection"]],
validateCreateBlogPostLocale?: [{	data: ValueTypes["BlogPostLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBlogPostLocale?: [{	by: ValueTypes["BlogPostLocaleUniqueWhere"],	data: ValueTypes["BlogPostLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getColorPallete?: [{	by: ValueTypes["ColorPalleteUniqueWhere"],	filter?: ValueTypes["ColorPalleteWhere"] | undefined | null},ValueTypes["ColorPallete"]],
listColorPallete?: [{	filter?: ValueTypes["ColorPalleteWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ColorPalleteOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ColorPallete"]],
paginateColorPallete?: [{	filter?: ValueTypes["ColorPalleteWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ColorPalleteOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ColorPalleteConnection"]],
validateCreateColorPallete?: [{	data: ValueTypes["ColorPalleteCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateColorPallete?: [{	by: ValueTypes["ColorPalleteUniqueWhere"],	data: ValueTypes["ColorPalleteUpdateInput"]},ValueTypes["_ValidationResult"]],
getContent?: [{	by: ValueTypes["ContentUniqueWhere"],	filter?: ValueTypes["ContentWhere"] | undefined | null},ValueTypes["Content"]],
listContent?: [{	filter?: ValueTypes["ContentWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ContentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Content"]],
paginateContent?: [{	filter?: ValueTypes["ContentWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ContentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ContentConnection"]],
validateCreateContent?: [{	data: ValueTypes["ContentCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContent?: [{	by: ValueTypes["ContentUniqueWhere"],	data: ValueTypes["ContentUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentBlock?: [{	by: ValueTypes["ContentBlockUniqueWhere"],	filter?: ValueTypes["ContentBlockWhere"] | undefined | null},ValueTypes["ContentBlock"]],
listContentBlock?: [{	filter?: ValueTypes["ContentBlockWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ContentBlockOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ContentBlock"]],
paginateContentBlock?: [{	filter?: ValueTypes["ContentBlockWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ContentBlockOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ContentBlockConnection"]],
validateCreateContentBlock?: [{	data: ValueTypes["ContentBlockCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentBlock?: [{	by: ValueTypes["ContentBlockUniqueWhere"],	data: ValueTypes["ContentBlockUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentReference?: [{	by: ValueTypes["ContentReferenceUniqueWhere"],	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null},ValueTypes["ContentReference"]],
listContentReference?: [{	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ContentReferenceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ContentReference"]],
paginateContentReference?: [{	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ContentReferenceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ContentReferenceConnection"]],
validateCreateContentReference?: [{	data: ValueTypes["ContentReferenceCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentReference?: [{	by: ValueTypes["ContentReferenceUniqueWhere"],	data: ValueTypes["ContentReferenceUpdateInput"]},ValueTypes["_ValidationResult"]],
getBlogPostList?: [{	by: ValueTypes["BlogPostListUniqueWhere"],	filter?: ValueTypes["BlogPostListWhere"] | undefined | null},ValueTypes["BlogPostList"]],
listBlogPostList?: [{	filter?: ValueTypes["BlogPostListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BlogPostListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BlogPostList"]],
paginateBlogPostList?: [{	filter?: ValueTypes["BlogPostListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BlogPostListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BlogPostListConnection"]],
validateCreateBlogPostList?: [{	data: ValueTypes["BlogPostListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBlogPostList?: [{	by: ValueTypes["BlogPostListUniqueWhere"],	data: ValueTypes["BlogPostListUpdateInput"]},ValueTypes["_ValidationResult"]],
getBlogPostListItem?: [{	by: ValueTypes["BlogPostListItemUniqueWhere"],	filter?: ValueTypes["BlogPostListItemWhere"] | undefined | null},ValueTypes["BlogPostListItem"]],
listBlogPostListItem?: [{	filter?: ValueTypes["BlogPostListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BlogPostListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BlogPostListItem"]],
paginateBlogPostListItem?: [{	filter?: ValueTypes["BlogPostListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BlogPostListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BlogPostListItemConnection"]],
validateCreateBlogPostListItem?: [{	data: ValueTypes["BlogPostListItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBlogPostListItem?: [{	by: ValueTypes["BlogPostListItemUniqueWhere"],	data: ValueTypes["BlogPostListItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkList?: [{	by: ValueTypes["LinkListUniqueWhere"],	filter?: ValueTypes["LinkListWhere"] | undefined | null},ValueTypes["LinkList"]],
listLinkList?: [{	filter?: ValueTypes["LinkListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LinkListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["LinkList"]],
paginateLinkList?: [{	filter?: ValueTypes["LinkListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LinkListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["LinkListConnection"]],
validateCreateLinkList?: [{	data: ValueTypes["LinkListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkList?: [{	by: ValueTypes["LinkListUniqueWhere"],	data: ValueTypes["LinkListUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkListItem?: [{	by: ValueTypes["LinkListItemUniqueWhere"],	filter?: ValueTypes["LinkListItemWhere"] | undefined | null},ValueTypes["LinkListItem"]],
listLinkListItem?: [{	filter?: ValueTypes["LinkListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LinkListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["LinkListItem"]],
paginateLinkListItem?: [{	filter?: ValueTypes["LinkListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LinkListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["LinkListItemConnection"]],
validateCreateLinkListItem?: [{	data: ValueTypes["LinkListItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkListItem?: [{	by: ValueTypes["LinkListItemUniqueWhere"],	data: ValueTypes["LinkListItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getCover?: [{	by: ValueTypes["CoverUniqueWhere"],	filter?: ValueTypes["CoverWhere"] | undefined | null},ValueTypes["Cover"]],
listCover?: [{	filter?: ValueTypes["CoverWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CoverOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Cover"]],
paginateCover?: [{	filter?: ValueTypes["CoverWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CoverOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CoverConnection"]],
validateCreateCover?: [{	data: ValueTypes["CoverCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCover?: [{	by: ValueTypes["CoverUniqueWhere"],	data: ValueTypes["CoverUpdateInput"]},ValueTypes["_ValidationResult"]],
getLink?: [{	by: ValueTypes["LinkUniqueWhere"],	filter?: ValueTypes["LinkWhere"] | undefined | null},ValueTypes["Link"]],
listLink?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LinkOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Link"]],
paginateLink?: [{	filter?: ValueTypes["LinkWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LinkOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["LinkConnection"]],
validateCreateLink?: [{	data: ValueTypes["LinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLink?: [{	by: ValueTypes["LinkUniqueWhere"],	data: ValueTypes["LinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkable?: [{	by: ValueTypes["LinkableUniqueWhere"],	filter?: ValueTypes["LinkableWhere"] | undefined | null},ValueTypes["Linkable"]],
listLinkable?: [{	filter?: ValueTypes["LinkableWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LinkableOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Linkable"]],
paginateLinkable?: [{	filter?: ValueTypes["LinkableWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LinkableOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["LinkableConnection"]],
validateCreateLinkable?: [{	data: ValueTypes["LinkableCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkable?: [{	by: ValueTypes["LinkableUniqueWhere"],	data: ValueTypes["LinkableUpdateInput"]},ValueTypes["_ValidationResult"]],
getMedium?: [{	by: ValueTypes["MediumUniqueWhere"],	filter?: ValueTypes["MediumWhere"] | undefined | null},ValueTypes["Medium"]],
listMedium?: [{	filter?: ValueTypes["MediumWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MediumOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Medium"]],
paginateMedium?: [{	filter?: ValueTypes["MediumWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MediumOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["MediumConnection"]],
validateCreateMedium?: [{	data: ValueTypes["MediumCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMedium?: [{	by: ValueTypes["MediumUniqueWhere"],	data: ValueTypes["MediumUpdateInput"]},ValueTypes["_ValidationResult"]],
getVideo?: [{	by: ValueTypes["VideoUniqueWhere"],	filter?: ValueTypes["VideoWhere"] | undefined | null},ValueTypes["Video"]],
listVideo?: [{	filter?: ValueTypes["VideoWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VideoOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Video"]],
paginateVideo?: [{	filter?: ValueTypes["VideoWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VideoOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["VideoConnection"]],
validateCreateVideo?: [{	data: ValueTypes["VideoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateVideo?: [{	by: ValueTypes["VideoUniqueWhere"],	data: ValueTypes["VideoUpdateInput"]},ValueTypes["_ValidationResult"]],
getSeo?: [{	by: ValueTypes["SeoUniqueWhere"],	filter?: ValueTypes["SeoWhere"] | undefined | null},ValueTypes["Seo"]],
listSeo?: [{	filter?: ValueTypes["SeoWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SeoOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Seo"]],
paginateSeo?: [{	filter?: ValueTypes["SeoWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SeoOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["SeoConnection"]],
validateCreateSeo?: [{	data: ValueTypes["SeoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSeo?: [{	by: ValueTypes["SeoUniqueWhere"],	data: ValueTypes["SeoUpdateInput"]},ValueTypes["_ValidationResult"]],
getProtectedImage?: [{	by: ValueTypes["ProtectedImageUniqueWhere"],	filter?: ValueTypes["ProtectedImageWhere"] | undefined | null},ValueTypes["ProtectedImage"]],
listProtectedImage?: [{	filter?: ValueTypes["ProtectedImageWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProtectedImageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProtectedImage"]],
paginateProtectedImage?: [{	filter?: ValueTypes["ProtectedImageWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProtectedImageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProtectedImageConnection"]],
validateCreateProtectedImage?: [{	data: ValueTypes["ProtectedImageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProtectedImage?: [{	by: ValueTypes["ProtectedImageUniqueWhere"],	data: ValueTypes["ProtectedImageUpdateInput"]},ValueTypes["_ValidationResult"]],
getTranslationDomain?: [{	by: ValueTypes["TranslationDomainUniqueWhere"],	filter?: ValueTypes["TranslationDomainWhere"] | undefined | null},ValueTypes["TranslationDomain"]],
listTranslationDomain?: [{	filter?: ValueTypes["TranslationDomainWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TranslationDomainOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TranslationDomain"]],
paginateTranslationDomain?: [{	filter?: ValueTypes["TranslationDomainWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TranslationDomainOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TranslationDomainConnection"]],
validateCreateTranslationDomain?: [{	data: ValueTypes["TranslationDomainCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTranslationDomain?: [{	by: ValueTypes["TranslationDomainUniqueWhere"],	data: ValueTypes["TranslationDomainUpdateInput"]},ValueTypes["_ValidationResult"]],
getTranslationCatalogue?: [{	by: ValueTypes["TranslationCatalogueUniqueWhere"],	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null},ValueTypes["TranslationCatalogue"]],
listTranslationCatalogue?: [{	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TranslationCatalogueOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TranslationCatalogue"]],
paginateTranslationCatalogue?: [{	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TranslationCatalogueOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TranslationCatalogueConnection"]],
validateCreateTranslationCatalogue?: [{	data: ValueTypes["TranslationCatalogueCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTranslationCatalogue?: [{	by: ValueTypes["TranslationCatalogueUniqueWhere"],	data: ValueTypes["TranslationCatalogueUpdateInput"]},ValueTypes["_ValidationResult"]],
getTranslationKey?: [{	by: ValueTypes["TranslationKeyUniqueWhere"],	filter?: ValueTypes["TranslationKeyWhere"] | undefined | null},ValueTypes["TranslationKey"]],
listTranslationKey?: [{	filter?: ValueTypes["TranslationKeyWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TranslationKeyOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TranslationKey"]],
paginateTranslationKey?: [{	filter?: ValueTypes["TranslationKeyWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TranslationKeyOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TranslationKeyConnection"]],
validateCreateTranslationKey?: [{	data: ValueTypes["TranslationKeyCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTranslationKey?: [{	by: ValueTypes["TranslationKeyUniqueWhere"],	data: ValueTypes["TranslationKeyUpdateInput"]},ValueTypes["_ValidationResult"]],
getTranslationValue?: [{	by: ValueTypes["TranslationValueUniqueWhere"],	filter?: ValueTypes["TranslationValueWhere"] | undefined | null},ValueTypes["TranslationValue"]],
listTranslationValue?: [{	filter?: ValueTypes["TranslationValueWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TranslationValueOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TranslationValue"]],
paginateTranslationValue?: [{	filter?: ValueTypes["TranslationValueWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TranslationValueOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TranslationValueConnection"]],
validateCreateTranslationValue?: [{	data: ValueTypes["TranslationValueCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTranslationValue?: [{	by: ValueTypes["TranslationValueUniqueWhere"],	data: ValueTypes["TranslationValueUpdateInput"]},ValueTypes["_ValidationResult"]],
getTranslationCataloguesIdentifier?: [{	by: ValueTypes["TranslationCataloguesIdentifierUniqueWhere"],	filter?: ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null},ValueTypes["TranslationCataloguesIdentifier"]],
listTranslationCataloguesIdentifier?: [{	filter?: ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TranslationCataloguesIdentifierOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TranslationCataloguesIdentifier"]],
paginateTranslationCataloguesIdentifier?: [{	filter?: ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TranslationCataloguesIdentifierOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TranslationCataloguesIdentifierConnection"]],
validateCreateTranslationCataloguesIdentifier?: [{	data: ValueTypes["TranslationCataloguesIdentifierCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTranslationCataloguesIdentifier?: [{	by: ValueTypes["TranslationCataloguesIdentifierUniqueWhere"],	data: ValueTypes["TranslationCataloguesIdentifierUpdateInput"]},ValueTypes["_ValidationResult"]],
getSocialsAndApps?: [{	by: ValueTypes["SocialsAndAppsUniqueWhere"],	filter?: ValueTypes["SocialsAndAppsWhere"] | undefined | null},ValueTypes["SocialsAndApps"]],
listSocialsAndApps?: [{	filter?: ValueTypes["SocialsAndAppsWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SocialsAndAppsOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["SocialsAndApps"]],
paginateSocialsAndApps?: [{	filter?: ValueTypes["SocialsAndAppsWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SocialsAndAppsOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["SocialsAndAppsConnection"]],
validateCreateSocialsAndApps?: [{	data: ValueTypes["SocialsAndAppsCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSocialsAndApps?: [{	by: ValueTypes["SocialsAndAppsUniqueWhere"],	data: ValueTypes["SocialsAndAppsUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductGrid?: [{	by: ValueTypes["ProductGridUniqueWhere"],	filter?: ValueTypes["ProductGridWhere"] | undefined | null},ValueTypes["ProductGrid"]],
listProductGrid?: [{	filter?: ValueTypes["ProductGridWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductGridOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductGrid"]],
paginateProductGrid?: [{	filter?: ValueTypes["ProductGridWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductGridOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductGridConnection"]],
validateCreateProductGrid?: [{	data: ValueTypes["ProductGridCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductGrid?: [{	by: ValueTypes["ProductGridUniqueWhere"],	data: ValueTypes["ProductGridUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductGridItem?: [{	by: ValueTypes["ProductGridItemUniqueWhere"],	filter?: ValueTypes["ProductGridItemWhere"] | undefined | null},ValueTypes["ProductGridItem"]],
listProductGridItem?: [{	filter?: ValueTypes["ProductGridItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductGridItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductGridItem"]],
paginateProductGridItem?: [{	filter?: ValueTypes["ProductGridItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductGridItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductGridItemConnection"]],
validateCreateProductGridItem?: [{	data: ValueTypes["ProductGridItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductGridItem?: [{	by: ValueTypes["ProductGridItemUniqueWhere"],	data: ValueTypes["ProductGridItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getGallery?: [{	by: ValueTypes["GalleryUniqueWhere"],	filter?: ValueTypes["GalleryWhere"] | undefined | null},ValueTypes["Gallery"]],
listGallery?: [{	filter?: ValueTypes["GalleryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["GalleryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Gallery"]],
paginateGallery?: [{	filter?: ValueTypes["GalleryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["GalleryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["GalleryConnection"]],
validateCreateGallery?: [{	data: ValueTypes["GalleryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateGallery?: [{	by: ValueTypes["GalleryUniqueWhere"],	data: ValueTypes["GalleryUpdateInput"]},ValueTypes["_ValidationResult"]],
getGalleryItem?: [{	by: ValueTypes["GalleryItemUniqueWhere"],	filter?: ValueTypes["GalleryItemWhere"] | undefined | null},ValueTypes["GalleryItem"]],
listGalleryItem?: [{	filter?: ValueTypes["GalleryItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["GalleryItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["GalleryItem"]],
paginateGalleryItem?: [{	filter?: ValueTypes["GalleryItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["GalleryItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["GalleryItemConnection"]],
validateCreateGalleryItem?: [{	data: ValueTypes["GalleryItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateGalleryItem?: [{	by: ValueTypes["GalleryItemUniqueWhere"],	data: ValueTypes["GalleryItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getHero?: [{	by: ValueTypes["HeroUniqueWhere"],	filter?: ValueTypes["HeroWhere"] | undefined | null},ValueTypes["Hero"]],
listHero?: [{	filter?: ValueTypes["HeroWhere"] | undefined | null,	orderBy?: Array<ValueTypes["HeroOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Hero"]],
paginateHero?: [{	filter?: ValueTypes["HeroWhere"] | undefined | null,	orderBy?: Array<ValueTypes["HeroOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["HeroConnection"]],
validateCreateHero?: [{	data: ValueTypes["HeroCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHero?: [{	by: ValueTypes["HeroUniqueWhere"],	data: ValueTypes["HeroUpdateInput"]},ValueTypes["_ValidationResult"]],
getSiteMenu?: [{	by: ValueTypes["SiteMenuUniqueWhere"],	filter?: ValueTypes["SiteMenuWhere"] | undefined | null},ValueTypes["SiteMenu"]],
listSiteMenu?: [{	filter?: ValueTypes["SiteMenuWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SiteMenuOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["SiteMenu"]],
paginateSiteMenu?: [{	filter?: ValueTypes["SiteMenuWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SiteMenuOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["SiteMenuConnection"]],
validateCreateSiteMenu?: [{	data: ValueTypes["SiteMenuCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSiteMenu?: [{	by: ValueTypes["SiteMenuUniqueWhere"],	data: ValueTypes["SiteMenuUpdateInput"]},ValueTypes["_ValidationResult"]],
getMenuLocale?: [{	by: ValueTypes["MenuLocaleUniqueWhere"],	filter?: ValueTypes["MenuLocaleWhere"] | undefined | null},ValueTypes["MenuLocale"]],
listMenuLocale?: [{	filter?: ValueTypes["MenuLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["MenuLocale"]],
paginateMenuLocale?: [{	filter?: ValueTypes["MenuLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["MenuLocaleConnection"]],
validateCreateMenuLocale?: [{	data: ValueTypes["MenuLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMenuLocale?: [{	by: ValueTypes["MenuLocaleUniqueWhere"],	data: ValueTypes["MenuLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getMenuItem?: [{	by: ValueTypes["MenuItemUniqueWhere"],	filter?: ValueTypes["MenuItemWhere"] | undefined | null},ValueTypes["MenuItem"]],
listMenuItem?: [{	filter?: ValueTypes["MenuItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["MenuItem"]],
paginateMenuItem?: [{	filter?: ValueTypes["MenuItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["MenuItemConnection"]],
validateCreateMenuItem?: [{	data: ValueTypes["MenuItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMenuItem?: [{	by: ValueTypes["MenuItemUniqueWhere"],	data: ValueTypes["MenuItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getPage?: [{	by: ValueTypes["PageUniqueWhere"],	filter?: ValueTypes["PageWhere"] | undefined | null},ValueTypes["Page"]],
listPage?: [{	filter?: ValueTypes["PageWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Page"]],
paginatePage?: [{	filter?: ValueTypes["PageWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PageConnection"]],
validateCreatePage?: [{	data: ValueTypes["PageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePage?: [{	by: ValueTypes["PageUniqueWhere"],	data: ValueTypes["PageUpdateInput"]},ValueTypes["_ValidationResult"]],
getPageLocale?: [{	by: ValueTypes["PageLocaleUniqueWhere"],	filter?: ValueTypes["PageLocaleWhere"] | undefined | null},ValueTypes["PageLocale"]],
listPageLocale?: [{	filter?: ValueTypes["PageLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PageLocale"]],
paginatePageLocale?: [{	filter?: ValueTypes["PageLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PageLocaleConnection"]],
validateCreatePageLocale?: [{	data: ValueTypes["PageLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePageLocale?: [{	by: ValueTypes["PageLocaleUniqueWhere"],	data: ValueTypes["PageLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getWikiPage?: [{	by: ValueTypes["WikiPageUniqueWhere"],	filter?: ValueTypes["WikiPageWhere"] | undefined | null},ValueTypes["WikiPage"]],
listWikiPage?: [{	filter?: ValueTypes["WikiPageWhere"] | undefined | null,	orderBy?: Array<ValueTypes["WikiPageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["WikiPage"]],
paginateWikiPage?: [{	filter?: ValueTypes["WikiPageWhere"] | undefined | null,	orderBy?: Array<ValueTypes["WikiPageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["WikiPageConnection"]],
validateCreateWikiPage?: [{	data: ValueTypes["WikiPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateWikiPage?: [{	by: ValueTypes["WikiPageUniqueWhere"],	data: ValueTypes["WikiPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getMenuSubitem?: [{	by: ValueTypes["MenuSubitemUniqueWhere"],	filter?: ValueTypes["MenuSubitemWhere"] | undefined | null},ValueTypes["MenuSubitem"]],
listMenuSubitem?: [{	filter?: ValueTypes["MenuSubitemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuSubitemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["MenuSubitem"]],
paginateMenuSubitem?: [{	filter?: ValueTypes["MenuSubitemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuSubitemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["MenuSubitemConnection"]],
validateCreateMenuSubitem?: [{	data: ValueTypes["MenuSubitemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMenuSubitem?: [{	by: ValueTypes["MenuSubitemUniqueWhere"],	data: ValueTypes["MenuSubitemUpdateInput"]},ValueTypes["_ValidationResult"]],
getMenuLinkList?: [{	by: ValueTypes["MenuLinkListUniqueWhere"],	filter?: ValueTypes["MenuLinkListWhere"] | undefined | null},ValueTypes["MenuLinkList"]],
listMenuLinkList?: [{	filter?: ValueTypes["MenuLinkListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuLinkListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["MenuLinkList"]],
paginateMenuLinkList?: [{	filter?: ValueTypes["MenuLinkListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuLinkListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["MenuLinkListConnection"]],
validateCreateMenuLinkList?: [{	data: ValueTypes["MenuLinkListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMenuLinkList?: [{	by: ValueTypes["MenuLinkListUniqueWhere"],	data: ValueTypes["MenuLinkListUpdateInput"]},ValueTypes["_ValidationResult"]],
getMenuLinkItem?: [{	by: ValueTypes["MenuLinkItemUniqueWhere"],	filter?: ValueTypes["MenuLinkItemWhere"] | undefined | null},ValueTypes["MenuLinkItem"]],
listMenuLinkItem?: [{	filter?: ValueTypes["MenuLinkItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuLinkItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["MenuLinkItem"]],
paginateMenuLinkItem?: [{	filter?: ValueTypes["MenuLinkItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuLinkItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["MenuLinkItemConnection"]],
validateCreateMenuLinkItem?: [{	data: ValueTypes["MenuLinkItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMenuLinkItem?: [{	by: ValueTypes["MenuLinkItemUniqueWhere"],	data: ValueTypes["MenuLinkItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getMenuProducts?: [{	by: ValueTypes["MenuProductsUniqueWhere"],	filter?: ValueTypes["MenuProductsWhere"] | undefined | null},ValueTypes["MenuProducts"]],
listMenuProducts?: [{	filter?: ValueTypes["MenuProductsWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuProductsOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["MenuProducts"]],
paginateMenuProducts?: [{	filter?: ValueTypes["MenuProductsWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuProductsOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["MenuProductsConnection"]],
validateCreateMenuProducts?: [{	data: ValueTypes["MenuProductsCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMenuProducts?: [{	by: ValueTypes["MenuProductsUniqueWhere"],	data: ValueTypes["MenuProductsUpdateInput"]},ValueTypes["_ValidationResult"]],
getMenuDelivery?: [{	by: ValueTypes["MenuDeliveryUniqueWhere"],	filter?: ValueTypes["MenuDeliveryWhere"] | undefined | null},ValueTypes["MenuDelivery"]],
listMenuDelivery?: [{	filter?: ValueTypes["MenuDeliveryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuDeliveryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["MenuDelivery"]],
paginateMenuDelivery?: [{	filter?: ValueTypes["MenuDeliveryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuDeliveryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["MenuDeliveryConnection"]],
validateCreateMenuDelivery?: [{	data: ValueTypes["MenuDeliveryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMenuDelivery?: [{	by: ValueTypes["MenuDeliveryUniqueWhere"],	data: ValueTypes["MenuDeliveryUpdateInput"]},ValueTypes["_ValidationResult"]],
getMenuContact?: [{	by: ValueTypes["MenuContactUniqueWhere"],	filter?: ValueTypes["MenuContactWhere"] | undefined | null},ValueTypes["MenuContact"]],
listMenuContact?: [{	filter?: ValueTypes["MenuContactWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuContactOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["MenuContact"]],
paginateMenuContact?: [{	filter?: ValueTypes["MenuContactWhere"] | undefined | null,	orderBy?: Array<ValueTypes["MenuContactOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["MenuContactConnection"]],
validateCreateMenuContact?: [{	data: ValueTypes["MenuContactCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMenuContact?: [{	by: ValueTypes["MenuContactUniqueWhere"],	data: ValueTypes["MenuContactUpdateInput"]},ValueTypes["_ValidationResult"]],
getDeadlineTemplate?: [{	by: ValueTypes["DeadlineTemplateUniqueWhere"],	filter?: ValueTypes["DeadlineTemplateWhere"] | undefined | null},ValueTypes["DeadlineTemplate"]],
listDeadlineTemplate?: [{	filter?: ValueTypes["DeadlineTemplateWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeadlineTemplateOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["DeadlineTemplate"]],
paginateDeadlineTemplate?: [{	filter?: ValueTypes["DeadlineTemplateWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeadlineTemplateOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["DeadlineTemplateConnection"]],
validateCreateDeadlineTemplate?: [{	data: ValueTypes["DeadlineTemplateCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDeadlineTemplate?: [{	by: ValueTypes["DeadlineTemplateUniqueWhere"],	data: ValueTypes["DeadlineTemplateUpdateInput"]},ValueTypes["_ValidationResult"]],
getEmployeeQueue?: [{	by: ValueTypes["EmployeeQueueUniqueWhere"],	filter?: ValueTypes["EmployeeQueueWhere"] | undefined | null},ValueTypes["EmployeeQueue"]],
listEmployeeQueue?: [{	filter?: ValueTypes["EmployeeQueueWhere"] | undefined | null,	orderBy?: Array<ValueTypes["EmployeeQueueOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["EmployeeQueue"]],
paginateEmployeeQueue?: [{	filter?: ValueTypes["EmployeeQueueWhere"] | undefined | null,	orderBy?: Array<ValueTypes["EmployeeQueueOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["EmployeeQueueConnection"]],
validateCreateEmployeeQueue?: [{	data: ValueTypes["EmployeeQueueCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateEmployeeQueue?: [{	by: ValueTypes["EmployeeQueueUniqueWhere"],	data: ValueTypes["EmployeeQueueUpdateInput"]},ValueTypes["_ValidationResult"]],
getTimetableDay?: [{	by: ValueTypes["TimetableDayUniqueWhere"],	filter?: ValueTypes["TimetableDayWhere"] | undefined | null},ValueTypes["TimetableDay"]],
listTimetableDay?: [{	filter?: ValueTypes["TimetableDayWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableDayOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TimetableDay"]],
paginateTimetableDay?: [{	filter?: ValueTypes["TimetableDayWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableDayOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TimetableDayConnection"]],
validateCreateTimetableDay?: [{	data: ValueTypes["TimetableDayCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTimetableDay?: [{	by: ValueTypes["TimetableDayUniqueWhere"],	data: ValueTypes["TimetableDayUpdateInput"]},ValueTypes["_ValidationResult"]],
getTimetableEmployeeRole?: [{	by: ValueTypes["TimetableEmployeeRoleUniqueWhere"],	filter?: ValueTypes["TimetableEmployeeRoleWhere"] | undefined | null},ValueTypes["TimetableEmployeeRole"]],
listTimetableEmployeeRole?: [{	filter?: ValueTypes["TimetableEmployeeRoleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableEmployeeRoleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TimetableEmployeeRole"]],
paginateTimetableEmployeeRole?: [{	filter?: ValueTypes["TimetableEmployeeRoleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableEmployeeRoleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TimetableEmployeeRoleConnection"]],
validateCreateTimetableEmployeeRole?: [{	data: ValueTypes["TimetableEmployeeRoleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTimetableEmployeeRole?: [{	by: ValueTypes["TimetableEmployeeRoleUniqueWhere"],	data: ValueTypes["TimetableEmployeeRoleUpdateInput"]},ValueTypes["_ValidationResult"]],
getTimetableShift?: [{	by: ValueTypes["TimetableShiftUniqueWhere"],	filter?: ValueTypes["TimetableShiftWhere"] | undefined | null},ValueTypes["TimetableShift"]],
listTimetableShift?: [{	filter?: ValueTypes["TimetableShiftWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableShiftOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TimetableShift"]],
paginateTimetableShift?: [{	filter?: ValueTypes["TimetableShiftWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableShiftOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TimetableShiftConnection"]],
validateCreateTimetableShift?: [{	data: ValueTypes["TimetableShiftCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTimetableShift?: [{	by: ValueTypes["TimetableShiftUniqueWhere"],	data: ValueTypes["TimetableShiftUpdateInput"]},ValueTypes["_ValidationResult"]],
getTimetableShiftGroup?: [{	by: ValueTypes["TimetableShiftGroupUniqueWhere"],	filter?: ValueTypes["TimetableShiftGroupWhere"] | undefined | null},ValueTypes["TimetableShiftGroup"]],
listTimetableShiftGroup?: [{	filter?: ValueTypes["TimetableShiftGroupWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableShiftGroupOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TimetableShiftGroup"]],
paginateTimetableShiftGroup?: [{	filter?: ValueTypes["TimetableShiftGroupWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableShiftGroupOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TimetableShiftGroupConnection"]],
validateCreateTimetableShiftGroup?: [{	data: ValueTypes["TimetableShiftGroupCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTimetableShiftGroup?: [{	by: ValueTypes["TimetableShiftGroupUniqueWhere"],	data: ValueTypes["TimetableShiftGroupUpdateInput"]},ValueTypes["_ValidationResult"]],
getTimetableShiftPosition?: [{	by: ValueTypes["TimetableShiftPositionUniqueWhere"],	filter?: ValueTypes["TimetableShiftPositionWhere"] | undefined | null},ValueTypes["TimetableShiftPosition"]],
listTimetableShiftPosition?: [{	filter?: ValueTypes["TimetableShiftPositionWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableShiftPositionOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TimetableShiftPosition"]],
paginateTimetableShiftPosition?: [{	filter?: ValueTypes["TimetableShiftPositionWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableShiftPositionOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TimetableShiftPositionConnection"]],
validateCreateTimetableShiftPosition?: [{	data: ValueTypes["TimetableShiftPositionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTimetableShiftPosition?: [{	by: ValueTypes["TimetableShiftPositionUniqueWhere"],	data: ValueTypes["TimetableShiftPositionUpdateInput"]},ValueTypes["_ValidationResult"]],
getTimetableTemplate?: [{	by: ValueTypes["TimetableTemplateUniqueWhere"],	filter?: ValueTypes["TimetableTemplateWhere"] | undefined | null},ValueTypes["TimetableTemplate"]],
listTimetableTemplate?: [{	filter?: ValueTypes["TimetableTemplateWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableTemplateOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TimetableTemplate"]],
paginateTimetableTemplate?: [{	filter?: ValueTypes["TimetableTemplateWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableTemplateOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TimetableTemplateConnection"]],
validateCreateTimetableTemplate?: [{	data: ValueTypes["TimetableTemplateCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTimetableTemplate?: [{	by: ValueTypes["TimetableTemplateUniqueWhere"],	data: ValueTypes["TimetableTemplateUpdateInput"]},ValueTypes["_ValidationResult"]],
getCart?: [{	by: ValueTypes["CartUniqueWhere"],	filter?: ValueTypes["CartWhere"] | undefined | null},ValueTypes["Cart"]],
listCart?: [{	filter?: ValueTypes["CartWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CartOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Cart"]],
paginateCart?: [{	filter?: ValueTypes["CartWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CartOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CartConnection"]],
validateCreateCart?: [{	data: ValueTypes["CartCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCart?: [{	by: ValueTypes["CartUniqueWhere"],	data: ValueTypes["CartUpdateInput"]},ValueTypes["_ValidationResult"]],
getCartItem?: [{	by: ValueTypes["CartItemUniqueWhere"],	filter?: ValueTypes["CartItemWhere"] | undefined | null},ValueTypes["CartItem"]],
listCartItem?: [{	filter?: ValueTypes["CartItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CartItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CartItem"]],
paginateCartItem?: [{	filter?: ValueTypes["CartItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CartItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CartItemConnection"]],
validateCreateCartItem?: [{	data: ValueTypes["CartItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCartItem?: [{	by: ValueTypes["CartItemUniqueWhere"],	data: ValueTypes["CartItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getEmployeeQueueItem?: [{	by: ValueTypes["EmployeeQueueItemUniqueWhere"],	filter?: ValueTypes["EmployeeQueueItemWhere"] | undefined | null},ValueTypes["EmployeeQueueItem"]],
listEmployeeQueueItem?: [{	filter?: ValueTypes["EmployeeQueueItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["EmployeeQueueItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["EmployeeQueueItem"]],
paginateEmployeeQueueItem?: [{	filter?: ValueTypes["EmployeeQueueItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["EmployeeQueueItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["EmployeeQueueItemConnection"]],
validateCreateEmployeeQueueItem?: [{	data: ValueTypes["EmployeeQueueItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateEmployeeQueueItem?: [{	by: ValueTypes["EmployeeQueueItemUniqueWhere"],	data: ValueTypes["EmployeeQueueItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getApplication?: [{	by: ValueTypes["ApplicationUniqueWhere"],	filter?: ValueTypes["ApplicationWhere"] | undefined | null},ValueTypes["Application"]],
listApplication?: [{	filter?: ValueTypes["ApplicationWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ApplicationOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Application"]],
paginateApplication?: [{	filter?: ValueTypes["ApplicationWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ApplicationOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ApplicationConnection"]],
validateCreateApplication?: [{	data: ValueTypes["ApplicationCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateApplication?: [{	by: ValueTypes["ApplicationUniqueWhere"],	data: ValueTypes["ApplicationUpdateInput"]},ValueTypes["_ValidationResult"]],
getApplicationShortcutList?: [{	by: ValueTypes["ApplicationShortcutListUniqueWhere"],	filter?: ValueTypes["ApplicationShortcutListWhere"] | undefined | null},ValueTypes["ApplicationShortcutList"]],
listApplicationShortcutList?: [{	filter?: ValueTypes["ApplicationShortcutListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ApplicationShortcutListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ApplicationShortcutList"]],
paginateApplicationShortcutList?: [{	filter?: ValueTypes["ApplicationShortcutListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ApplicationShortcutListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ApplicationShortcutListConnection"]],
validateCreateApplicationShortcutList?: [{	data: ValueTypes["ApplicationShortcutListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateApplicationShortcutList?: [{	by: ValueTypes["ApplicationShortcutListUniqueWhere"],	data: ValueTypes["ApplicationShortcutListUpdateInput"]},ValueTypes["_ValidationResult"]],
getApplicationShortcutListItem?: [{	by: ValueTypes["ApplicationShortcutListItemUniqueWhere"],	filter?: ValueTypes["ApplicationShortcutListItemWhere"] | undefined | null},ValueTypes["ApplicationShortcutListItem"]],
listApplicationShortcutListItem?: [{	filter?: ValueTypes["ApplicationShortcutListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ApplicationShortcutListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ApplicationShortcutListItem"]],
paginateApplicationShortcutListItem?: [{	filter?: ValueTypes["ApplicationShortcutListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ApplicationShortcutListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ApplicationShortcutListItemConnection"]],
validateCreateApplicationShortcutListItem?: [{	data: ValueTypes["ApplicationShortcutListItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateApplicationShortcutListItem?: [{	by: ValueTypes["ApplicationShortcutListItemUniqueWhere"],	data: ValueTypes["ApplicationShortcutListItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductBanner?: [{	by: ValueTypes["ProductBannerUniqueWhere"],	filter?: ValueTypes["ProductBannerWhere"] | undefined | null},ValueTypes["ProductBanner"]],
listProductBanner?: [{	filter?: ValueTypes["ProductBannerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductBannerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductBanner"]],
paginateProductBanner?: [{	filter?: ValueTypes["ProductBannerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductBannerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductBannerConnection"]],
validateCreateProductBanner?: [{	data: ValueTypes["ProductBannerCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductBanner?: [{	by: ValueTypes["ProductBannerUniqueWhere"],	data: ValueTypes["ProductBannerUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductBannerItem?: [{	by: ValueTypes["ProductBannerItemUniqueWhere"],	filter?: ValueTypes["ProductBannerItemWhere"] | undefined | null},ValueTypes["ProductBannerItem"]],
listProductBannerItem?: [{	filter?: ValueTypes["ProductBannerItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductBannerItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductBannerItem"]],
paginateProductBannerItem?: [{	filter?: ValueTypes["ProductBannerItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductBannerItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductBannerItemConnection"]],
validateCreateProductBannerItem?: [{	data: ValueTypes["ProductBannerItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductBannerItem?: [{	by: ValueTypes["ProductBannerItemUniqueWhere"],	data: ValueTypes["ProductBannerItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductBannerList?: [{	by: ValueTypes["ProductBannerListUniqueWhere"],	filter?: ValueTypes["ProductBannerListWhere"] | undefined | null},ValueTypes["ProductBannerList"]],
listProductBannerList?: [{	filter?: ValueTypes["ProductBannerListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductBannerListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductBannerList"]],
paginateProductBannerList?: [{	filter?: ValueTypes["ProductBannerListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductBannerListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductBannerListConnection"]],
validateCreateProductBannerList?: [{	data: ValueTypes["ProductBannerListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductBannerList?: [{	by: ValueTypes["ProductBannerListUniqueWhere"],	data: ValueTypes["ProductBannerListUpdateInput"]},ValueTypes["_ValidationResult"]],
getBartender?: [{	by: ValueTypes["BartenderUniqueWhere"],	filter?: ValueTypes["BartenderWhere"] | undefined | null},ValueTypes["Bartender"]],
listBartender?: [{	filter?: ValueTypes["BartenderWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BartenderOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Bartender"]],
paginateBartender?: [{	filter?: ValueTypes["BartenderWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BartenderOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BartenderConnection"]],
validateCreateBartender?: [{	data: ValueTypes["BartenderCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBartender?: [{	by: ValueTypes["BartenderUniqueWhere"],	data: ValueTypes["BartenderUpdateInput"]},ValueTypes["_ValidationResult"]],
getBusinessToBusinessManager?: [{	by: ValueTypes["BusinessToBusinessManagerUniqueWhere"],	filter?: ValueTypes["BusinessToBusinessManagerWhere"] | undefined | null},ValueTypes["BusinessToBusinessManager"]],
listBusinessToBusinessManager?: [{	filter?: ValueTypes["BusinessToBusinessManagerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessToBusinessManagerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BusinessToBusinessManager"]],
paginateBusinessToBusinessManager?: [{	filter?: ValueTypes["BusinessToBusinessManagerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessToBusinessManagerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BusinessToBusinessManagerConnection"]],
validateCreateBusinessToBusinessManager?: [{	data: ValueTypes["BusinessToBusinessManagerCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBusinessToBusinessManager?: [{	by: ValueTypes["BusinessToBusinessManagerUniqueWhere"],	data: ValueTypes["BusinessToBusinessManagerUpdateInput"]},ValueTypes["_ValidationResult"]],
getCleaner?: [{	by: ValueTypes["CleanerUniqueWhere"],	filter?: ValueTypes["CleanerWhere"] | undefined | null},ValueTypes["Cleaner"]],
listCleaner?: [{	filter?: ValueTypes["CleanerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CleanerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Cleaner"]],
paginateCleaner?: [{	filter?: ValueTypes["CleanerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CleanerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CleanerConnection"]],
validateCreateCleaner?: [{	data: ValueTypes["CleanerCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCleaner?: [{	by: ValueTypes["CleanerUniqueWhere"],	data: ValueTypes["CleanerUpdateInput"]},ValueTypes["_ValidationResult"]],
getCourier?: [{	by: ValueTypes["CourierUniqueWhere"],	filter?: ValueTypes["CourierWhere"] | undefined | null},ValueTypes["Courier"]],
listCourier?: [{	filter?: ValueTypes["CourierWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CourierOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Courier"]],
paginateCourier?: [{	filter?: ValueTypes["CourierWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CourierOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CourierConnection"]],
validateCreateCourier?: [{	data: ValueTypes["CourierCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCourier?: [{	by: ValueTypes["CourierUniqueWhere"],	data: ValueTypes["CourierUpdateInput"]},ValueTypes["_ValidationResult"]],
getShiftsManager?: [{	by: ValueTypes["ShiftsManagerUniqueWhere"],	filter?: ValueTypes["ShiftsManagerWhere"] | undefined | null},ValueTypes["ShiftsManager"]],
listShiftsManager?: [{	filter?: ValueTypes["ShiftsManagerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ShiftsManagerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ShiftsManager"]],
paginateShiftsManager?: [{	filter?: ValueTypes["ShiftsManagerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ShiftsManagerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ShiftsManagerConnection"]],
validateCreateShiftsManager?: [{	data: ValueTypes["ShiftsManagerCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateShiftsManager?: [{	by: ValueTypes["ShiftsManagerUniqueWhere"],	data: ValueTypes["ShiftsManagerUpdateInput"]},ValueTypes["_ValidationResult"]],
getUser?: [{	by: ValueTypes["UserUniqueWhere"],	filter?: ValueTypes["UserWhere"] | undefined | null},ValueTypes["User"]],
listUser?: [{	filter?: ValueTypes["UserWhere"] | undefined | null,	orderBy?: Array<ValueTypes["UserOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["User"]],
paginateUser?: [{	filter?: ValueTypes["UserWhere"] | undefined | null,	orderBy?: Array<ValueTypes["UserOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["UserConnection"]],
validateCreateUser?: [{	data: ValueTypes["UserCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateUser?: [{	by: ValueTypes["UserUniqueWhere"],	data: ValueTypes["UserUpdateInput"]},ValueTypes["_ValidationResult"]],
getShiftsProfile?: [{	by: ValueTypes["ShiftsProfileUniqueWhere"],	filter?: ValueTypes["ShiftsProfileWhere"] | undefined | null},ValueTypes["ShiftsProfile"]],
listShiftsProfile?: [{	filter?: ValueTypes["ShiftsProfileWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ShiftsProfileOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ShiftsProfile"]],
paginateShiftsProfile?: [{	filter?: ValueTypes["ShiftsProfileWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ShiftsProfileOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ShiftsProfileConnection"]],
validateCreateShiftsProfile?: [{	data: ValueTypes["ShiftsProfileCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateShiftsProfile?: [{	by: ValueTypes["ShiftsProfileUniqueWhere"],	data: ValueTypes["ShiftsProfileUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductIngredientCategory?: [{	by: ValueTypes["ProductIngredientCategoryUniqueWhere"],	filter?: ValueTypes["ProductIngredientCategoryWhere"] | undefined | null},ValueTypes["ProductIngredientCategory"]],
listProductIngredientCategory?: [{	filter?: ValueTypes["ProductIngredientCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientCategoryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductIngredientCategory"]],
paginateProductIngredientCategory?: [{	filter?: ValueTypes["ProductIngredientCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientCategoryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductIngredientCategoryConnection"]],
validateCreateProductIngredientCategory?: [{	data: ValueTypes["ProductIngredientCategoryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductIngredientCategory?: [{	by: ValueTypes["ProductIngredientCategoryUniqueWhere"],	data: ValueTypes["ProductIngredientCategoryUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductIngredientCategoryLocale?: [{	by: ValueTypes["ProductIngredientCategoryLocaleUniqueWhere"],	filter?: ValueTypes["ProductIngredientCategoryLocaleWhere"] | undefined | null},ValueTypes["ProductIngredientCategoryLocale"]],
listProductIngredientCategoryLocale?: [{	filter?: ValueTypes["ProductIngredientCategoryLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientCategoryLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductIngredientCategoryLocale"]],
paginateProductIngredientCategoryLocale?: [{	filter?: ValueTypes["ProductIngredientCategoryLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductIngredientCategoryLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductIngredientCategoryLocaleConnection"]],
validateCreateProductIngredientCategoryLocale?: [{	data: ValueTypes["ProductIngredientCategoryLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductIngredientCategoryLocale?: [{	by: ValueTypes["ProductIngredientCategoryLocaleUniqueWhere"],	data: ValueTypes["ProductIngredientCategoryLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getStocksManager?: [{	by: ValueTypes["StocksManagerUniqueWhere"],	filter?: ValueTypes["StocksManagerWhere"] | undefined | null},ValueTypes["StocksManager"]],
listStocksManager?: [{	filter?: ValueTypes["StocksManagerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["StocksManagerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["StocksManager"]],
paginateStocksManager?: [{	filter?: ValueTypes["StocksManagerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["StocksManagerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["StocksManagerConnection"]],
validateCreateStocksManager?: [{	data: ValueTypes["StocksManagerCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateStocksManager?: [{	by: ValueTypes["StocksManagerUniqueWhere"],	data: ValueTypes["StocksManagerUpdateInput"]},ValueTypes["_ValidationResult"]],
getDeliveryRoute?: [{	by: ValueTypes["DeliveryRouteUniqueWhere"],	filter?: ValueTypes["DeliveryRouteWhere"] | undefined | null},ValueTypes["DeliveryRoute"]],
listDeliveryRoute?: [{	filter?: ValueTypes["DeliveryRouteWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryRouteOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["DeliveryRoute"]],
paginateDeliveryRoute?: [{	filter?: ValueTypes["DeliveryRouteWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryRouteOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["DeliveryRouteConnection"]],
validateCreateDeliveryRoute?: [{	data: ValueTypes["DeliveryRouteCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDeliveryRoute?: [{	by: ValueTypes["DeliveryRouteUniqueWhere"],	data: ValueTypes["DeliveryRouteUpdateInput"]},ValueTypes["_ValidationResult"]],
getDeliveryWaypoint?: [{	by: ValueTypes["DeliveryWaypointUniqueWhere"],	filter?: ValueTypes["DeliveryWaypointWhere"] | undefined | null},ValueTypes["DeliveryWaypoint"]],
listDeliveryWaypoint?: [{	filter?: ValueTypes["DeliveryWaypointWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryWaypointOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["DeliveryWaypoint"]],
paginateDeliveryWaypoint?: [{	filter?: ValueTypes["DeliveryWaypointWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryWaypointOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["DeliveryWaypointConnection"]],
validateCreateDeliveryWaypoint?: [{	data: ValueTypes["DeliveryWaypointCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDeliveryWaypoint?: [{	by: ValueTypes["DeliveryWaypointUniqueWhere"],	data: ValueTypes["DeliveryWaypointUpdateInput"]},ValueTypes["_ValidationResult"]],
getAllergen?: [{	by: ValueTypes["AllergenUniqueWhere"],	filter?: ValueTypes["AllergenWhere"] | undefined | null},ValueTypes["Allergen"]],
listAllergen?: [{	filter?: ValueTypes["AllergenWhere"] | undefined | null,	orderBy?: Array<ValueTypes["AllergenOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Allergen"]],
paginateAllergen?: [{	filter?: ValueTypes["AllergenWhere"] | undefined | null,	orderBy?: Array<ValueTypes["AllergenOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["AllergenConnection"]],
validateCreateAllergen?: [{	data: ValueTypes["AllergenCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateAllergen?: [{	by: ValueTypes["AllergenUniqueWhere"],	data: ValueTypes["AllergenUpdateInput"]},ValueTypes["_ValidationResult"]],
getAllergenLocale?: [{	by: ValueTypes["AllergenLocaleUniqueWhere"],	filter?: ValueTypes["AllergenLocaleWhere"] | undefined | null},ValueTypes["AllergenLocale"]],
listAllergenLocale?: [{	filter?: ValueTypes["AllergenLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["AllergenLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["AllergenLocale"]],
paginateAllergenLocale?: [{	filter?: ValueTypes["AllergenLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["AllergenLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["AllergenLocaleConnection"]],
validateCreateAllergenLocale?: [{	data: ValueTypes["AllergenLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateAllergenLocale?: [{	by: ValueTypes["AllergenLocaleUniqueWhere"],	data: ValueTypes["AllergenLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getGps?: [{	by: ValueTypes["GpsUniqueWhere"],	filter?: ValueTypes["GpsWhere"] | undefined | null},ValueTypes["Gps"]],
listGps?: [{	filter?: ValueTypes["GpsWhere"] | undefined | null,	orderBy?: Array<ValueTypes["GpsOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Gps"]],
paginateGps?: [{	filter?: ValueTypes["GpsWhere"] | undefined | null,	orderBy?: Array<ValueTypes["GpsOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["GpsConnection"]],
validateCreateGps?: [{	data: ValueTypes["GpsCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateGps?: [{	by: ValueTypes["GpsUniqueWhere"],	data: ValueTypes["GpsUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductCategoryTree?: [{	by: ValueTypes["ProductCategoryTreeUniqueWhere"],	filter?: ValueTypes["ProductCategoryTreeWhere"] | undefined | null},ValueTypes["ProductCategoryTree"]],
listProductCategoryTree?: [{	filter?: ValueTypes["ProductCategoryTreeWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCategoryTreeOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductCategoryTree"]],
paginateProductCategoryTree?: [{	filter?: ValueTypes["ProductCategoryTreeWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCategoryTreeOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductCategoryTreeConnection"]],
getInheritedProductCategoryTag?: [{	by: ValueTypes["InheritedProductCategoryTagUniqueWhere"],	filter?: ValueTypes["InheritedProductCategoryTagWhere"] | undefined | null},ValueTypes["InheritedProductCategoryTag"]],
listInheritedProductCategoryTag?: [{	filter?: ValueTypes["InheritedProductCategoryTagWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InheritedProductCategoryTagOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["InheritedProductCategoryTag"]],
paginateInheritedProductCategoryTag?: [{	filter?: ValueTypes["InheritedProductCategoryTagWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InheritedProductCategoryTagOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["InheritedProductCategoryTagConnection"]],
getNestedProductCategoryProduct?: [{	by: ValueTypes["NestedProductCategoryProductUniqueWhere"],	filter?: ValueTypes["NestedProductCategoryProductWhere"] | undefined | null},ValueTypes["NestedProductCategoryProduct"]],
listNestedProductCategoryProduct?: [{	filter?: ValueTypes["NestedProductCategoryProductWhere"] | undefined | null,	orderBy?: Array<ValueTypes["NestedProductCategoryProductOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["NestedProductCategoryProduct"]],
paginateNestedProductCategoryProduct?: [{	filter?: ValueTypes["NestedProductCategoryProductWhere"] | undefined | null,	orderBy?: Array<ValueTypes["NestedProductCategoryProductOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["NestedProductCategoryProductConnection"]],
getWeekHours?: [{	by: ValueTypes["WeekHoursUniqueWhere"],	filter?: ValueTypes["WeekHoursWhere"] | undefined | null},ValueTypes["WeekHours"]],
listWeekHours?: [{	filter?: ValueTypes["WeekHoursWhere"] | undefined | null,	orderBy?: Array<ValueTypes["WeekHoursOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["WeekHours"]],
paginateWeekHours?: [{	filter?: ValueTypes["WeekHoursWhere"] | undefined | null,	orderBy?: Array<ValueTypes["WeekHoursOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["WeekHoursConnection"]],
validateCreateWeekHours?: [{	data: ValueTypes["WeekHoursCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateWeekHours?: [{	by: ValueTypes["WeekHoursUniqueWhere"],	data: ValueTypes["WeekHoursUpdateInput"]},ValueTypes["_ValidationResult"]],
getPreparedIngredientQuantity?: [{	by: ValueTypes["PreparedIngredientQuantityUniqueWhere"],	filter?: ValueTypes["PreparedIngredientQuantityWhere"] | undefined | null},ValueTypes["PreparedIngredientQuantity"]],
listPreparedIngredientQuantity?: [{	filter?: ValueTypes["PreparedIngredientQuantityWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PreparedIngredientQuantityOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PreparedIngredientQuantity"]],
paginatePreparedIngredientQuantity?: [{	filter?: ValueTypes["PreparedIngredientQuantityWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PreparedIngredientQuantityOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PreparedIngredientQuantityConnection"]],
validateCreatePreparedIngredientQuantity?: [{	data: ValueTypes["PreparedIngredientQuantityCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePreparedIngredientQuantity?: [{	by: ValueTypes["PreparedIngredientQuantityUniqueWhere"],	data: ValueTypes["PreparedIngredientQuantityUpdateInput"]},ValueTypes["_ValidationResult"]],
getPreparedRecipeQuantity?: [{	by: ValueTypes["PreparedRecipeQuantityUniqueWhere"],	filter?: ValueTypes["PreparedRecipeQuantityWhere"] | undefined | null},ValueTypes["PreparedRecipeQuantity"]],
listPreparedRecipeQuantity?: [{	filter?: ValueTypes["PreparedRecipeQuantityWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PreparedRecipeQuantityOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PreparedRecipeQuantity"]],
paginatePreparedRecipeQuantity?: [{	filter?: ValueTypes["PreparedRecipeQuantityWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PreparedRecipeQuantityOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PreparedRecipeQuantityConnection"]],
validateCreatePreparedRecipeQuantity?: [{	data: ValueTypes["PreparedRecipeQuantityCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePreparedRecipeQuantity?: [{	by: ValueTypes["PreparedRecipeQuantityUniqueWhere"],	data: ValueTypes["PreparedRecipeQuantityUpdateInput"]},ValueTypes["_ValidationResult"]],
getInternalOrder?: [{	by: ValueTypes["InternalOrderUniqueWhere"],	filter?: ValueTypes["InternalOrderWhere"] | undefined | null},ValueTypes["InternalOrder"]],
listInternalOrder?: [{	filter?: ValueTypes["InternalOrderWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InternalOrderOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["InternalOrder"]],
paginateInternalOrder?: [{	filter?: ValueTypes["InternalOrderWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InternalOrderOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["InternalOrderConnection"]],
validateCreateInternalOrder?: [{	data: ValueTypes["InternalOrderCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateInternalOrder?: [{	by: ValueTypes["InternalOrderUniqueWhere"],	data: ValueTypes["InternalOrderUpdateInput"]},ValueTypes["_ValidationResult"]],
getInternalOrderItem?: [{	by: ValueTypes["InternalOrderItemUniqueWhere"],	filter?: ValueTypes["InternalOrderItemWhere"] | undefined | null},ValueTypes["InternalOrderItem"]],
listInternalOrderItem?: [{	filter?: ValueTypes["InternalOrderItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InternalOrderItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["InternalOrderItem"]],
paginateInternalOrderItem?: [{	filter?: ValueTypes["InternalOrderItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InternalOrderItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["InternalOrderItemConnection"]],
validateCreateInternalOrderItem?: [{	data: ValueTypes["InternalOrderItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateInternalOrderItem?: [{	by: ValueTypes["InternalOrderItemUniqueWhere"],	data: ValueTypes["InternalOrderItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getPreparedPackingQuantity?: [{	by: ValueTypes["PreparedPackingQuantityUniqueWhere"],	filter?: ValueTypes["PreparedPackingQuantityWhere"] | undefined | null},ValueTypes["PreparedPackingQuantity"]],
listPreparedPackingQuantity?: [{	filter?: ValueTypes["PreparedPackingQuantityWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PreparedPackingQuantityOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PreparedPackingQuantity"]],
paginatePreparedPackingQuantity?: [{	filter?: ValueTypes["PreparedPackingQuantityWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PreparedPackingQuantityOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PreparedPackingQuantityConnection"]],
validateCreatePreparedPackingQuantity?: [{	data: ValueTypes["PreparedPackingQuantityCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePreparedPackingQuantity?: [{	by: ValueTypes["PreparedPackingQuantityUniqueWhere"],	data: ValueTypes["PreparedPackingQuantityUpdateInput"]},ValueTypes["_ValidationResult"]],
getCourierManager?: [{	by: ValueTypes["CourierManagerUniqueWhere"],	filter?: ValueTypes["CourierManagerWhere"] | undefined | null},ValueTypes["CourierManager"]],
listCourierManager?: [{	filter?: ValueTypes["CourierManagerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CourierManagerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CourierManager"]],
paginateCourierManager?: [{	filter?: ValueTypes["CourierManagerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CourierManagerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CourierManagerConnection"]],
validateCreateCourierManager?: [{	data: ValueTypes["CourierManagerCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCourierManager?: [{	by: ValueTypes["CourierManagerUniqueWhere"],	data: ValueTypes["CourierManagerUpdateInput"]},ValueTypes["_ValidationResult"]],
getDeliveryZone?: [{	by: ValueTypes["DeliveryZoneUniqueWhere"],	filter?: ValueTypes["DeliveryZoneWhere"] | undefined | null},ValueTypes["DeliveryZone"]],
listDeliveryZone?: [{	filter?: ValueTypes["DeliveryZoneWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryZoneOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["DeliveryZone"]],
paginateDeliveryZone?: [{	filter?: ValueTypes["DeliveryZoneWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryZoneOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["DeliveryZoneConnection"]],
validateCreateDeliveryZone?: [{	data: ValueTypes["DeliveryZoneCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDeliveryZone?: [{	by: ValueTypes["DeliveryZoneUniqueWhere"],	data: ValueTypes["DeliveryZoneUpdateInput"]},ValueTypes["_ValidationResult"]],
getAddressMetadata?: [{	by: ValueTypes["AddressMetadataUniqueWhere"],	filter?: ValueTypes["AddressMetadataWhere"] | undefined | null},ValueTypes["AddressMetadata"]],
listAddressMetadata?: [{	filter?: ValueTypes["AddressMetadataWhere"] | undefined | null,	orderBy?: Array<ValueTypes["AddressMetadataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["AddressMetadata"]],
paginateAddressMetadata?: [{	filter?: ValueTypes["AddressMetadataWhere"] | undefined | null,	orderBy?: Array<ValueTypes["AddressMetadataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["AddressMetadataConnection"]],
getDeliveryTimelinePreset?: [{	by: ValueTypes["DeliveryTimelinePresetUniqueWhere"],	filter?: ValueTypes["DeliveryTimelinePresetWhere"] | undefined | null},ValueTypes["DeliveryTimelinePreset"]],
listDeliveryTimelinePreset?: [{	filter?: ValueTypes["DeliveryTimelinePresetWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryTimelinePresetOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["DeliveryTimelinePreset"]],
paginateDeliveryTimelinePreset?: [{	filter?: ValueTypes["DeliveryTimelinePresetWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryTimelinePresetOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["DeliveryTimelinePresetConnection"]],
validateCreateDeliveryTimelinePreset?: [{	data: ValueTypes["DeliveryTimelinePresetCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDeliveryTimelinePreset?: [{	by: ValueTypes["DeliveryTimelinePresetUniqueWhere"],	data: ValueTypes["DeliveryTimelinePresetUpdateInput"]},ValueTypes["_ValidationResult"]],
getOrderDeliveryTimeline?: [{	by: ValueTypes["OrderDeliveryTimelineUniqueWhere"],	filter?: ValueTypes["OrderDeliveryTimelineWhere"] | undefined | null},ValueTypes["OrderDeliveryTimeline"]],
listOrderDeliveryTimeline?: [{	filter?: ValueTypes["OrderDeliveryTimelineWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderDeliveryTimelineOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["OrderDeliveryTimeline"]],
paginateOrderDeliveryTimeline?: [{	filter?: ValueTypes["OrderDeliveryTimelineWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderDeliveryTimelineOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderDeliveryTimelineConnection"]],
validateCreateOrderDeliveryTimeline?: [{	data: ValueTypes["OrderDeliveryTimelineCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateOrderDeliveryTimeline?: [{	by: ValueTypes["OrderDeliveryTimelineUniqueWhere"],	data: ValueTypes["OrderDeliveryTimelineUpdateInput"]},ValueTypes["_ValidationResult"]],
getOrderEvent?: [{	by: ValueTypes["OrderEventUniqueWhere"],	filter?: ValueTypes["OrderEventWhere"] | undefined | null},ValueTypes["OrderEvent"]],
listOrderEvent?: [{	filter?: ValueTypes["OrderEventWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderEventOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["OrderEvent"]],
paginateOrderEvent?: [{	filter?: ValueTypes["OrderEventWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderEventOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderEventConnection"]],
validateCreateOrderEvent?: [{	data: ValueTypes["OrderEventCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateOrderEvent?: [{	by: ValueTypes["OrderEventUniqueWhere"],	data: ValueTypes["OrderEventUpdateInput"]},ValueTypes["_ValidationResult"]],
getLiftagoRide?: [{	by: ValueTypes["LiftagoRideUniqueWhere"],	filter?: ValueTypes["LiftagoRideWhere"] | undefined | null},ValueTypes["LiftagoRide"]],
listLiftagoRide?: [{	filter?: ValueTypes["LiftagoRideWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LiftagoRideOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["LiftagoRide"]],
paginateLiftagoRide?: [{	filter?: ValueTypes["LiftagoRideWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LiftagoRideOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["LiftagoRideConnection"]],
validateCreateLiftagoRide?: [{	data: ValueTypes["LiftagoRideCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLiftagoRide?: [{	by: ValueTypes["LiftagoRideUniqueWhere"],	data: ValueTypes["LiftagoRideUpdateInput"]},ValueTypes["_ValidationResult"]],
getInvoice?: [{	by: ValueTypes["InvoiceUniqueWhere"],	filter?: ValueTypes["InvoiceWhere"] | undefined | null},ValueTypes["Invoice"]],
listInvoice?: [{	filter?: ValueTypes["InvoiceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InvoiceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Invoice"]],
paginateInvoice?: [{	filter?: ValueTypes["InvoiceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InvoiceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["InvoiceConnection"]],
validateCreateInvoice?: [{	data: ValueTypes["InvoiceCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateInvoice?: [{	by: ValueTypes["InvoiceUniqueWhere"],	data: ValueTypes["InvoiceUpdateInput"]},ValueTypes["_ValidationResult"]],
getInvoicingPlan?: [{	by: ValueTypes["InvoicingPlanUniqueWhere"],	filter?: ValueTypes["InvoicingPlanWhere"] | undefined | null},ValueTypes["InvoicingPlan"]],
listInvoicingPlan?: [{	filter?: ValueTypes["InvoicingPlanWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InvoicingPlanOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["InvoicingPlan"]],
paginateInvoicingPlan?: [{	filter?: ValueTypes["InvoicingPlanWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InvoicingPlanOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["InvoicingPlanConnection"]],
validateCreateInvoicingPlan?: [{	data: ValueTypes["InvoicingPlanCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateInvoicingPlan?: [{	by: ValueTypes["InvoicingPlanUniqueWhere"],	data: ValueTypes["InvoicingPlanUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductPackingLocale?: [{	by: ValueTypes["ProductPackingLocaleUniqueWhere"],	filter?: ValueTypes["ProductPackingLocaleWhere"] | undefined | null},ValueTypes["ProductPackingLocale"]],
listProductPackingLocale?: [{	filter?: ValueTypes["ProductPackingLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductPackingLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductPackingLocale"]],
paginateProductPackingLocale?: [{	filter?: ValueTypes["ProductPackingLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductPackingLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductPackingLocaleConnection"]],
validateCreateProductPackingLocale?: [{	data: ValueTypes["ProductPackingLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductPackingLocale?: [{	by: ValueTypes["ProductPackingLocaleUniqueWhere"],	data: ValueTypes["ProductPackingLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductLocale?: [{	by: ValueTypes["ProductLocaleUniqueWhere"],	filter?: ValueTypes["ProductLocaleWhere"] | undefined | null},ValueTypes["ProductLocale"]],
listProductLocale?: [{	filter?: ValueTypes["ProductLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductLocale"]],
paginateProductLocale?: [{	filter?: ValueTypes["ProductLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductLocaleConnection"]],
validateCreateProductLocale?: [{	data: ValueTypes["ProductLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductLocale?: [{	by: ValueTypes["ProductLocaleUniqueWhere"],	data: ValueTypes["ProductLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductRecipeLocale?: [{	by: ValueTypes["ProductRecipeLocaleUniqueWhere"],	filter?: ValueTypes["ProductRecipeLocaleWhere"] | undefined | null},ValueTypes["ProductRecipeLocale"]],
listProductRecipeLocale?: [{	filter?: ValueTypes["ProductRecipeLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductRecipeLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductRecipeLocale"]],
paginateProductRecipeLocale?: [{	filter?: ValueTypes["ProductRecipeLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductRecipeLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductRecipeLocaleConnection"]],
validateCreateProductRecipeLocale?: [{	data: ValueTypes["ProductRecipeLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductRecipeLocale?: [{	by: ValueTypes["ProductRecipeLocaleUniqueWhere"],	data: ValueTypes["ProductRecipeLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getUserDevice?: [{	by: ValueTypes["UserDeviceUniqueWhere"],	filter?: ValueTypes["UserDeviceWhere"] | undefined | null},ValueTypes["UserDevice"]],
listUserDevice?: [{	filter?: ValueTypes["UserDeviceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["UserDeviceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["UserDevice"]],
paginateUserDevice?: [{	filter?: ValueTypes["UserDeviceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["UserDeviceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["UserDeviceConnection"]],
validateCreateUserDevice?: [{	data: ValueTypes["UserDeviceCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateUserDevice?: [{	by: ValueTypes["UserDeviceUniqueWhere"],	data: ValueTypes["UserDeviceUpdateInput"]},ValueTypes["_ValidationResult"]],
getProtectedAction?: [{	by: ValueTypes["ProtectedActionUniqueWhere"],	filter?: ValueTypes["ProtectedActionWhere"] | undefined | null},ValueTypes["ProtectedAction"]],
listProtectedAction?: [{	filter?: ValueTypes["ProtectedActionWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProtectedActionOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProtectedAction"]],
paginateProtectedAction?: [{	filter?: ValueTypes["ProtectedActionWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProtectedActionOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProtectedActionConnection"]],
validateCreateProtectedAction?: [{	data: ValueTypes["ProtectedActionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProtectedAction?: [{	by: ValueTypes["ProtectedActionUniqueWhere"],	data: ValueTypes["ProtectedActionUpdateInput"]},ValueTypes["_ValidationResult"]],
getPicker?: [{	by: ValueTypes["PickerUniqueWhere"],	filter?: ValueTypes["PickerWhere"] | undefined | null},ValueTypes["Picker"]],
listPicker?: [{	filter?: ValueTypes["PickerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PickerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Picker"]],
paginatePicker?: [{	filter?: ValueTypes["PickerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PickerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PickerConnection"]],
validateCreatePicker?: [{	data: ValueTypes["PickerCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePicker?: [{	by: ValueTypes["PickerUniqueWhere"],	data: ValueTypes["PickerUpdateInput"]},ValueTypes["_ValidationResult"]],
getTenantPerson?: [{	by: ValueTypes["TenantPersonUniqueWhere"],	filter?: ValueTypes["TenantPersonWhere"] | undefined | null},ValueTypes["TenantPerson"]],
listTenantPerson?: [{	filter?: ValueTypes["TenantPersonWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TenantPersonOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TenantPerson"]],
paginateTenantPerson?: [{	filter?: ValueTypes["TenantPersonWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TenantPersonOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TenantPersonConnection"]],
getTimetableTemplateStaffOptions?: [{	by: ValueTypes["TimetableTemplateStaffOptionsUniqueWhere"],	filter?: ValueTypes["TimetableTemplateStaffOptionsWhere"] | undefined | null},ValueTypes["TimetableTemplateStaffOptions"]],
listTimetableTemplateStaffOptions?: [{	filter?: ValueTypes["TimetableTemplateStaffOptionsWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableTemplateStaffOptionsOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TimetableTemplateStaffOptions"]],
paginateTimetableTemplateStaffOptions?: [{	filter?: ValueTypes["TimetableTemplateStaffOptionsWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableTemplateStaffOptionsOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TimetableTemplateStaffOptionsConnection"]],
validateCreateTimetableTemplateStaffOptions?: [{	data: ValueTypes["TimetableTemplateStaffOptionsCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTimetableTemplateStaffOptions?: [{	by: ValueTypes["TimetableTemplateStaffOptionsUniqueWhere"],	data: ValueTypes["TimetableTemplateStaffOptionsUpdateInput"]},ValueTypes["_ValidationResult"]],
getShoppingList?: [{	by: ValueTypes["ShoppingListUniqueWhere"],	filter?: ValueTypes["ShoppingListWhere"] | undefined | null},ValueTypes["ShoppingList"]],
listShoppingList?: [{	filter?: ValueTypes["ShoppingListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ShoppingListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ShoppingList"]],
paginateShoppingList?: [{	filter?: ValueTypes["ShoppingListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ShoppingListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ShoppingListConnection"]],
validateCreateShoppingList?: [{	data: ValueTypes["ShoppingListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateShoppingList?: [{	by: ValueTypes["ShoppingListUniqueWhere"],	data: ValueTypes["ShoppingListUpdateInput"]},ValueTypes["_ValidationResult"]],
getSuppliesPurchase?: [{	by: ValueTypes["SuppliesPurchaseUniqueWhere"],	filter?: ValueTypes["SuppliesPurchaseWhere"] | undefined | null},ValueTypes["SuppliesPurchase"]],
listSuppliesPurchase?: [{	filter?: ValueTypes["SuppliesPurchaseWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SuppliesPurchaseOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["SuppliesPurchase"]],
paginateSuppliesPurchase?: [{	filter?: ValueTypes["SuppliesPurchaseWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SuppliesPurchaseOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["SuppliesPurchaseConnection"]],
validateCreateSuppliesPurchase?: [{	data: ValueTypes["SuppliesPurchaseCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSuppliesPurchase?: [{	by: ValueTypes["SuppliesPurchaseUniqueWhere"],	data: ValueTypes["SuppliesPurchaseUpdateInput"]},ValueTypes["_ValidationResult"]],
getInvoicingPreset?: [{	by: ValueTypes["InvoicingPresetUniqueWhere"],	filter?: ValueTypes["InvoicingPresetWhere"] | undefined | null},ValueTypes["InvoicingPreset"]],
listInvoicingPreset?: [{	filter?: ValueTypes["InvoicingPresetWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InvoicingPresetOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["InvoicingPreset"]],
paginateInvoicingPreset?: [{	filter?: ValueTypes["InvoicingPresetWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InvoicingPresetOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["InvoicingPresetConnection"]],
validateCreateInvoicingPreset?: [{	data: ValueTypes["InvoicingPresetCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateInvoicingPreset?: [{	by: ValueTypes["InvoicingPresetUniqueWhere"],	data: ValueTypes["InvoicingPresetUpdateInput"]},ValueTypes["_ValidationResult"]],
getLogRecord?: [{	by: ValueTypes["LogRecordUniqueWhere"],	filter?: ValueTypes["LogRecordWhere"] | undefined | null},ValueTypes["LogRecord"]],
listLogRecord?: [{	filter?: ValueTypes["LogRecordWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LogRecordOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["LogRecord"]],
paginateLogRecord?: [{	filter?: ValueTypes["LogRecordWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LogRecordOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["LogRecordConnection"]],
validateCreateLogRecord?: [{	data: ValueTypes["LogRecordCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLogRecord?: [{	by: ValueTypes["LogRecordUniqueWhere"],	data: ValueTypes["LogRecordUpdateInput"]},ValueTypes["_ValidationResult"]],
getBillingSubject?: [{	by: ValueTypes["BillingSubjectUniqueWhere"],	filter?: ValueTypes["BillingSubjectWhere"] | undefined | null},ValueTypes["BillingSubject"]],
listBillingSubject?: [{	filter?: ValueTypes["BillingSubjectWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BillingSubjectOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BillingSubject"]],
paginateBillingSubject?: [{	filter?: ValueTypes["BillingSubjectWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BillingSubjectOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BillingSubjectConnection"]],
validateCreateBillingSubject?: [{	data: ValueTypes["BillingSubjectCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBillingSubject?: [{	by: ValueTypes["BillingSubjectUniqueWhere"],	data: ValueTypes["BillingSubjectUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductCustomerPrice?: [{	by: ValueTypes["ProductCustomerPriceUniqueWhere"],	filter?: ValueTypes["ProductCustomerPriceWhere"] | undefined | null},ValueTypes["ProductCustomerPrice"]],
listProductCustomerPrice?: [{	filter?: ValueTypes["ProductCustomerPriceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCustomerPriceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductCustomerPrice"]],
paginateProductCustomerPrice?: [{	filter?: ValueTypes["ProductCustomerPriceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductCustomerPriceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductCustomerPriceConnection"]],
getCartPriceLine?: [{	by: ValueTypes["CartPriceLineUniqueWhere"],	filter?: ValueTypes["CartPriceLineWhere"] | undefined | null},ValueTypes["CartPriceLine"]],
listCartPriceLine?: [{	filter?: ValueTypes["CartPriceLineWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CartPriceLineOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CartPriceLine"]],
paginateCartPriceLine?: [{	filter?: ValueTypes["CartPriceLineWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CartPriceLineOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CartPriceLineConnection"]],
getShoppingListItem?: [{	by: ValueTypes["ShoppingListItemUniqueWhere"],	filter?: ValueTypes["ShoppingListItemWhere"] | undefined | null},ValueTypes["ShoppingListItem"]],
listShoppingListItem?: [{	filter?: ValueTypes["ShoppingListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ShoppingListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ShoppingListItem"]],
paginateShoppingListItem?: [{	filter?: ValueTypes["ShoppingListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ShoppingListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ShoppingListItemConnection"]],
validateCreateShoppingListItem?: [{	data: ValueTypes["ShoppingListItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateShoppingListItem?: [{	by: ValueTypes["ShoppingListItemUniqueWhere"],	data: ValueTypes["ShoppingListItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getSuppliesPurchaseItem?: [{	by: ValueTypes["SuppliesPurchaseItemUniqueWhere"],	filter?: ValueTypes["SuppliesPurchaseItemWhere"] | undefined | null},ValueTypes["SuppliesPurchaseItem"]],
listSuppliesPurchaseItem?: [{	filter?: ValueTypes["SuppliesPurchaseItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SuppliesPurchaseItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["SuppliesPurchaseItem"]],
paginateSuppliesPurchaseItem?: [{	filter?: ValueTypes["SuppliesPurchaseItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SuppliesPurchaseItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["SuppliesPurchaseItemConnection"]],
validateCreateSuppliesPurchaseItem?: [{	data: ValueTypes["SuppliesPurchaseItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSuppliesPurchaseItem?: [{	by: ValueTypes["SuppliesPurchaseItemUniqueWhere"],	data: ValueTypes["SuppliesPurchaseItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getCustomerCreditTransaction?: [{	by: ValueTypes["CustomerCreditTransactionUniqueWhere"],	filter?: ValueTypes["CustomerCreditTransactionWhere"] | undefined | null},ValueTypes["CustomerCreditTransaction"]],
listCustomerCreditTransaction?: [{	filter?: ValueTypes["CustomerCreditTransactionWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerCreditTransactionOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CustomerCreditTransaction"]],
paginateCustomerCreditTransaction?: [{	filter?: ValueTypes["CustomerCreditTransactionWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerCreditTransactionOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerCreditTransactionConnection"]],
validateCreateCustomerCreditTransaction?: [{	data: ValueTypes["CustomerCreditTransactionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCustomerCreditTransaction?: [{	by: ValueTypes["CustomerCreditTransactionUniqueWhere"],	data: ValueTypes["CustomerCreditTransactionUpdateInput"]},ValueTypes["_ValidationResult"]],
getVirtualProduct?: [{	by: ValueTypes["VirtualProductUniqueWhere"],	filter?: ValueTypes["VirtualProductWhere"] | undefined | null},ValueTypes["VirtualProduct"]],
listVirtualProduct?: [{	filter?: ValueTypes["VirtualProductWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VirtualProductOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["VirtualProduct"]],
paginateVirtualProduct?: [{	filter?: ValueTypes["VirtualProductWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VirtualProductOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["VirtualProductConnection"]],
validateCreateVirtualProduct?: [{	data: ValueTypes["VirtualProductCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateVirtualProduct?: [{	by: ValueTypes["VirtualProductUniqueWhere"],	data: ValueTypes["VirtualProductUpdateInput"]},ValueTypes["_ValidationResult"]],
getVirtualProductEffect?: [{	by: ValueTypes["VirtualProductEffectUniqueWhere"],	filter?: ValueTypes["VirtualProductEffectWhere"] | undefined | null},ValueTypes["VirtualProductEffect"]],
listVirtualProductEffect?: [{	filter?: ValueTypes["VirtualProductEffectWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VirtualProductEffectOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["VirtualProductEffect"]],
paginateVirtualProductEffect?: [{	filter?: ValueTypes["VirtualProductEffectWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VirtualProductEffectOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["VirtualProductEffectConnection"]],
validateCreateVirtualProductEffect?: [{	data: ValueTypes["VirtualProductEffectCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateVirtualProductEffect?: [{	by: ValueTypes["VirtualProductEffectUniqueWhere"],	data: ValueTypes["VirtualProductEffectUpdateInput"]},ValueTypes["_ValidationResult"]],
getOrderPriceLine?: [{	by: ValueTypes["OrderPriceLineUniqueWhere"],	filter?: ValueTypes["OrderPriceLineWhere"] | undefined | null},ValueTypes["OrderPriceLine"]],
listOrderPriceLine?: [{	filter?: ValueTypes["OrderPriceLineWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderPriceLineOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["OrderPriceLine"]],
paginateOrderPriceLine?: [{	filter?: ValueTypes["OrderPriceLineWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderPriceLineOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderPriceLineConnection"]],
getProductMetadata?: [{	by: ValueTypes["ProductMetadataUniqueWhere"],	filter?: ValueTypes["ProductMetadataWhere"] | undefined | null},ValueTypes["ProductMetadata"]],
listProductMetadata?: [{	filter?: ValueTypes["ProductMetadataWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductMetadataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductMetadata"]],
paginateProductMetadata?: [{	filter?: ValueTypes["ProductMetadataWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductMetadataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductMetadataConnection"]],
getEmploymentInformation?: [{	by: ValueTypes["EmploymentInformationUniqueWhere"],	filter?: ValueTypes["EmploymentInformationWhere"] | undefined | null},ValueTypes["EmploymentInformation"]],
listEmploymentInformation?: [{	filter?: ValueTypes["EmploymentInformationWhere"] | undefined | null,	orderBy?: Array<ValueTypes["EmploymentInformationOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["EmploymentInformation"]],
paginateEmploymentInformation?: [{	filter?: ValueTypes["EmploymentInformationWhere"] | undefined | null,	orderBy?: Array<ValueTypes["EmploymentInformationOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["EmploymentInformationConnection"]],
validateCreateEmploymentInformation?: [{	data: ValueTypes["EmploymentInformationCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateEmploymentInformation?: [{	by: ValueTypes["EmploymentInformationUniqueWhere"],	data: ValueTypes["EmploymentInformationUpdateInput"]},ValueTypes["_ValidationResult"]],
getRemunerationProfile?: [{	by: ValueTypes["RemunerationProfileUniqueWhere"],	filter?: ValueTypes["RemunerationProfileWhere"] | undefined | null},ValueTypes["RemunerationProfile"]],
listRemunerationProfile?: [{	filter?: ValueTypes["RemunerationProfileWhere"] | undefined | null,	orderBy?: Array<ValueTypes["RemunerationProfileOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["RemunerationProfile"]],
paginateRemunerationProfile?: [{	filter?: ValueTypes["RemunerationProfileWhere"] | undefined | null,	orderBy?: Array<ValueTypes["RemunerationProfileOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["RemunerationProfileConnection"]],
validateCreateRemunerationProfile?: [{	data: ValueTypes["RemunerationProfileCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateRemunerationProfile?: [{	by: ValueTypes["RemunerationProfileUniqueWhere"],	data: ValueTypes["RemunerationProfileUpdateInput"]},ValueTypes["_ValidationResult"]],
getWorkMonth?: [{	by: ValueTypes["WorkMonthUniqueWhere"],	filter?: ValueTypes["WorkMonthWhere"] | undefined | null},ValueTypes["WorkMonth"]],
listWorkMonth?: [{	filter?: ValueTypes["WorkMonthWhere"] | undefined | null,	orderBy?: Array<ValueTypes["WorkMonthOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["WorkMonth"]],
paginateWorkMonth?: [{	filter?: ValueTypes["WorkMonthWhere"] | undefined | null,	orderBy?: Array<ValueTypes["WorkMonthOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["WorkMonthConnection"]],
validateCreateWorkMonth?: [{	data: ValueTypes["WorkMonthCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateWorkMonth?: [{	by: ValueTypes["WorkMonthUniqueWhere"],	data: ValueTypes["WorkMonthUpdateInput"]},ValueTypes["_ValidationResult"]],
getSalaryOptions?: [{	by: ValueTypes["SalaryOptionsUniqueWhere"],	filter?: ValueTypes["SalaryOptionsWhere"] | undefined | null},ValueTypes["SalaryOptions"]],
listSalaryOptions?: [{	filter?: ValueTypes["SalaryOptionsWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SalaryOptionsOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["SalaryOptions"]],
paginateSalaryOptions?: [{	filter?: ValueTypes["SalaryOptionsWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SalaryOptionsOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["SalaryOptionsConnection"]],
validateCreateSalaryOptions?: [{	data: ValueTypes["SalaryOptionsCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSalaryOptions?: [{	by: ValueTypes["SalaryOptionsUniqueWhere"],	data: ValueTypes["SalaryOptionsUpdateInput"]},ValueTypes["_ValidationResult"]],
getTimetableShiftSwapInfo?: [{	by: ValueTypes["TimetableShiftSwapInfoUniqueWhere"],	filter?: ValueTypes["TimetableShiftSwapInfoWhere"] | undefined | null},ValueTypes["TimetableShiftSwapInfo"]],
listTimetableShiftSwapInfo?: [{	filter?: ValueTypes["TimetableShiftSwapInfoWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableShiftSwapInfoOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TimetableShiftSwapInfo"]],
paginateTimetableShiftSwapInfo?: [{	filter?: ValueTypes["TimetableShiftSwapInfoWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableShiftSwapInfoOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TimetableShiftSwapInfoConnection"]],
validateCreateTimetableShiftSwapInfo?: [{	data: ValueTypes["TimetableShiftSwapInfoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTimetableShiftSwapInfo?: [{	by: ValueTypes["TimetableShiftSwapInfoUniqueWhere"],	data: ValueTypes["TimetableShiftSwapInfoUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductGridCategory?: [{	by: ValueTypes["ProductGridCategoryUniqueWhere"],	filter?: ValueTypes["ProductGridCategoryWhere"] | undefined | null},ValueTypes["ProductGridCategory"]],
listProductGridCategory?: [{	filter?: ValueTypes["ProductGridCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductGridCategoryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductGridCategory"]],
paginateProductGridCategory?: [{	filter?: ValueTypes["ProductGridCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductGridCategoryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductGridCategoryConnection"]],
validateCreateProductGridCategory?: [{	data: ValueTypes["ProductGridCategoryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductGridCategory?: [{	by: ValueTypes["ProductGridCategoryUniqueWhere"],	data: ValueTypes["ProductGridCategoryUpdateInput"]},ValueTypes["_ValidationResult"]],
getCashier?: [{	by: ValueTypes["CashierUniqueWhere"],	filter?: ValueTypes["CashierWhere"] | undefined | null},ValueTypes["Cashier"]],
listCashier?: [{	filter?: ValueTypes["CashierWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CashierOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Cashier"]],
paginateCashier?: [{	filter?: ValueTypes["CashierWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CashierOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CashierConnection"]],
validateCreateCashier?: [{	data: ValueTypes["CashierCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCashier?: [{	by: ValueTypes["CashierUniqueWhere"],	data: ValueTypes["CashierUpdateInput"]},ValueTypes["_ValidationResult"]],
getPointOfSaleCategory?: [{	by: ValueTypes["PointOfSaleCategoryUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryWhere"] | undefined | null},ValueTypes["PointOfSaleCategory"]],
listPointOfSaleCategory?: [{	filter?: ValueTypes["PointOfSaleCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleCategoryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PointOfSaleCategory"]],
paginatePointOfSaleCategory?: [{	filter?: ValueTypes["PointOfSaleCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleCategoryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PointOfSaleCategoryConnection"]],
validateCreatePointOfSaleCategory?: [{	data: ValueTypes["PointOfSaleCategoryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePointOfSaleCategory?: [{	by: ValueTypes["PointOfSaleCategoryUniqueWhere"],	data: ValueTypes["PointOfSaleCategoryUpdateInput"]},ValueTypes["_ValidationResult"]],
getPointOfSaleCategoryLocale?: [{	by: ValueTypes["PointOfSaleCategoryLocaleUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryLocaleWhere"] | undefined | null},ValueTypes["PointOfSaleCategoryLocale"]],
listPointOfSaleCategoryLocale?: [{	filter?: ValueTypes["PointOfSaleCategoryLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleCategoryLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PointOfSaleCategoryLocale"]],
paginatePointOfSaleCategoryLocale?: [{	filter?: ValueTypes["PointOfSaleCategoryLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleCategoryLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PointOfSaleCategoryLocaleConnection"]],
validateCreatePointOfSaleCategoryLocale?: [{	data: ValueTypes["PointOfSaleCategoryLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePointOfSaleCategoryLocale?: [{	by: ValueTypes["PointOfSaleCategoryLocaleUniqueWhere"],	data: ValueTypes["PointOfSaleCategoryLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getPointOfSaleCategoryProduct?: [{	by: ValueTypes["PointOfSaleCategoryProductUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryProductWhere"] | undefined | null},ValueTypes["PointOfSaleCategoryProduct"]],
listPointOfSaleCategoryProduct?: [{	filter?: ValueTypes["PointOfSaleCategoryProductWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleCategoryProductOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PointOfSaleCategoryProduct"]],
paginatePointOfSaleCategoryProduct?: [{	filter?: ValueTypes["PointOfSaleCategoryProductWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleCategoryProductOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PointOfSaleCategoryProductConnection"]],
validateCreatePointOfSaleCategoryProduct?: [{	data: ValueTypes["PointOfSaleCategoryProductCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePointOfSaleCategoryProduct?: [{	by: ValueTypes["PointOfSaleCategoryProductUniqueWhere"],	data: ValueTypes["PointOfSaleCategoryProductUpdateInput"]},ValueTypes["_ValidationResult"]],
getPointOfSaleCategoryProductLocale?: [{	by: ValueTypes["PointOfSaleCategoryProductLocaleUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryProductLocaleWhere"] | undefined | null},ValueTypes["PointOfSaleCategoryProductLocale"]],
listPointOfSaleCategoryProductLocale?: [{	filter?: ValueTypes["PointOfSaleCategoryProductLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleCategoryProductLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PointOfSaleCategoryProductLocale"]],
paginatePointOfSaleCategoryProductLocale?: [{	filter?: ValueTypes["PointOfSaleCategoryProductLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleCategoryProductLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PointOfSaleCategoryProductLocaleConnection"]],
validateCreatePointOfSaleCategoryProductLocale?: [{	data: ValueTypes["PointOfSaleCategoryProductLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePointOfSaleCategoryProductLocale?: [{	by: ValueTypes["PointOfSaleCategoryProductLocaleUniqueWhere"],	data: ValueTypes["PointOfSaleCategoryProductLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getCustomerTab?: [{	by: ValueTypes["CustomerTabUniqueWhere"],	filter?: ValueTypes["CustomerTabWhere"] | undefined | null},ValueTypes["CustomerTab"]],
listCustomerTab?: [{	filter?: ValueTypes["CustomerTabWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerTabOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CustomerTab"]],
paginateCustomerTab?: [{	filter?: ValueTypes["CustomerTabWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerTabOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerTabConnection"]],
validateCreateCustomerTab?: [{	data: ValueTypes["CustomerTabCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCustomerTab?: [{	by: ValueTypes["CustomerTabUniqueWhere"],	data: ValueTypes["CustomerTabUpdateInput"]},ValueTypes["_ValidationResult"]],
getCustomerTabItem?: [{	by: ValueTypes["CustomerTabItemUniqueWhere"],	filter?: ValueTypes["CustomerTabItemWhere"] | undefined | null},ValueTypes["CustomerTabItem"]],
listCustomerTabItem?: [{	filter?: ValueTypes["CustomerTabItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerTabItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CustomerTabItem"]],
paginateCustomerTabItem?: [{	filter?: ValueTypes["CustomerTabItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerTabItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerTabItemConnection"]],
validateCreateCustomerTabItem?: [{	data: ValueTypes["CustomerTabItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCustomerTabItem?: [{	by: ValueTypes["CustomerTabItemUniqueWhere"],	data: ValueTypes["CustomerTabItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getAnonymousSession?: [{	by: ValueTypes["AnonymousSessionUniqueWhere"],	filter?: ValueTypes["AnonymousSessionWhere"] | undefined | null},ValueTypes["AnonymousSession"]],
listAnonymousSession?: [{	filter?: ValueTypes["AnonymousSessionWhere"] | undefined | null,	orderBy?: Array<ValueTypes["AnonymousSessionOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["AnonymousSession"]],
paginateAnonymousSession?: [{	filter?: ValueTypes["AnonymousSessionWhere"] | undefined | null,	orderBy?: Array<ValueTypes["AnonymousSessionOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["AnonymousSessionConnection"]],
validateCreateAnonymousSession?: [{	data: ValueTypes["AnonymousSessionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateAnonymousSession?: [{	by: ValueTypes["AnonymousSessionUniqueWhere"],	data: ValueTypes["AnonymousSessionUpdateInput"]},ValueTypes["_ValidationResult"]],
getVoucher?: [{	by: ValueTypes["VoucherUniqueWhere"],	filter?: ValueTypes["VoucherWhere"] | undefined | null},ValueTypes["Voucher"]],
listVoucher?: [{	filter?: ValueTypes["VoucherWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VoucherOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Voucher"]],
paginateVoucher?: [{	filter?: ValueTypes["VoucherWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VoucherOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["VoucherConnection"]],
validateCreateVoucher?: [{	data: ValueTypes["VoucherCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateVoucher?: [{	by: ValueTypes["VoucherUniqueWhere"],	data: ValueTypes["VoucherUpdateInput"]},ValueTypes["_ValidationResult"]],
getVoucherRedemption?: [{	by: ValueTypes["VoucherRedemptionUniqueWhere"],	filter?: ValueTypes["VoucherRedemptionWhere"] | undefined | null},ValueTypes["VoucherRedemption"]],
listVoucherRedemption?: [{	filter?: ValueTypes["VoucherRedemptionWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VoucherRedemptionOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["VoucherRedemption"]],
paginateVoucherRedemption?: [{	filter?: ValueTypes["VoucherRedemptionWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VoucherRedemptionOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["VoucherRedemptionConnection"]],
validateCreateVoucherRedemption?: [{	data: ValueTypes["VoucherRedemptionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateVoucherRedemption?: [{	by: ValueTypes["VoucherRedemptionUniqueWhere"],	data: ValueTypes["VoucherRedemptionUpdateInput"]},ValueTypes["_ValidationResult"]],
getUnassignedShiftInfo?: [{	by: ValueTypes["UnassignedShiftInfoUniqueWhere"],	filter?: ValueTypes["UnassignedShiftInfoWhere"] | undefined | null},ValueTypes["UnassignedShiftInfo"]],
listUnassignedShiftInfo?: [{	filter?: ValueTypes["UnassignedShiftInfoWhere"] | undefined | null,	orderBy?: Array<ValueTypes["UnassignedShiftInfoOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["UnassignedShiftInfo"]],
paginateUnassignedShiftInfo?: [{	filter?: ValueTypes["UnassignedShiftInfoWhere"] | undefined | null,	orderBy?: Array<ValueTypes["UnassignedShiftInfoOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["UnassignedShiftInfoConnection"]],
validateCreateUnassignedShiftInfo?: [{	data: ValueTypes["UnassignedShiftInfoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateUnassignedShiftInfo?: [{	by: ValueTypes["UnassignedShiftInfoUniqueWhere"],	data: ValueTypes["UnassignedShiftInfoUpdateInput"]},ValueTypes["_ValidationResult"]],
getFreshingContainer?: [{	by: ValueTypes["FreshingContainerUniqueWhere"],	filter?: ValueTypes["FreshingContainerWhere"] | undefined | null},ValueTypes["FreshingContainer"]],
listFreshingContainer?: [{	filter?: ValueTypes["FreshingContainerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["FreshingContainerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["FreshingContainer"]],
paginateFreshingContainer?: [{	filter?: ValueTypes["FreshingContainerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["FreshingContainerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["FreshingContainerConnection"]],
validateCreateFreshingContainer?: [{	data: ValueTypes["FreshingContainerCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFreshingContainer?: [{	by: ValueTypes["FreshingContainerUniqueWhere"],	data: ValueTypes["FreshingContainerUpdateInput"]},ValueTypes["_ValidationResult"]],
getTextItem?: [{	by: ValueTypes["TextItemUniqueWhere"],	filter?: ValueTypes["TextItemWhere"] | undefined | null},ValueTypes["TextItem"]],
listTextItem?: [{	filter?: ValueTypes["TextItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TextItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TextItem"]],
paginateTextItem?: [{	filter?: ValueTypes["TextItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TextItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TextItemConnection"]],
validateCreateTextItem?: [{	data: ValueTypes["TextItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTextItem?: [{	by: ValueTypes["TextItemUniqueWhere"],	data: ValueTypes["TextItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getTextList?: [{	by: ValueTypes["TextListUniqueWhere"],	filter?: ValueTypes["TextListWhere"] | undefined | null},ValueTypes["TextList"]],
listTextList?: [{	filter?: ValueTypes["TextListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TextListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TextList"]],
paginateTextList?: [{	filter?: ValueTypes["TextListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TextListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TextListConnection"]],
validateCreateTextList?: [{	data: ValueTypes["TextListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTextList?: [{	by: ValueTypes["TextListUniqueWhere"],	data: ValueTypes["TextListUpdateInput"]},ValueTypes["_ValidationResult"]],
getEmployeeQueueItemMetadata?: [{	by: ValueTypes["EmployeeQueueItemMetadataUniqueWhere"],	filter?: ValueTypes["EmployeeQueueItemMetadataWhere"] | undefined | null},ValueTypes["EmployeeQueueItemMetadata"]],
listEmployeeQueueItemMetadata?: [{	filter?: ValueTypes["EmployeeQueueItemMetadataWhere"] | undefined | null,	orderBy?: Array<ValueTypes["EmployeeQueueItemMetadataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["EmployeeQueueItemMetadata"]],
paginateEmployeeQueueItemMetadata?: [{	filter?: ValueTypes["EmployeeQueueItemMetadataWhere"] | undefined | null,	orderBy?: Array<ValueTypes["EmployeeQueueItemMetadataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["EmployeeQueueItemMetadataConnection"]],
getDeliveryRegions?: [{	by: ValueTypes["DeliveryRegionsUniqueWhere"],	filter?: ValueTypes["DeliveryRegionsWhere"] | undefined | null},ValueTypes["DeliveryRegions"]],
listDeliveryRegions?: [{	filter?: ValueTypes["DeliveryRegionsWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryRegionsOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["DeliveryRegions"]],
paginateDeliveryRegions?: [{	filter?: ValueTypes["DeliveryRegionsWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryRegionsOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["DeliveryRegionsConnection"]],
validateCreateDeliveryRegions?: [{	data: ValueTypes["DeliveryRegionsCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDeliveryRegions?: [{	by: ValueTypes["DeliveryRegionsUniqueWhere"],	data: ValueTypes["DeliveryRegionsUpdateInput"]},ValueTypes["_ValidationResult"]],
getDeliveryRegionsItem?: [{	by: ValueTypes["DeliveryRegionsItemUniqueWhere"],	filter?: ValueTypes["DeliveryRegionsItemWhere"] | undefined | null},ValueTypes["DeliveryRegionsItem"]],
listDeliveryRegionsItem?: [{	filter?: ValueTypes["DeliveryRegionsItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryRegionsItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["DeliveryRegionsItem"]],
paginateDeliveryRegionsItem?: [{	filter?: ValueTypes["DeliveryRegionsItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryRegionsItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["DeliveryRegionsItemConnection"]],
validateCreateDeliveryRegionsItem?: [{	data: ValueTypes["DeliveryRegionsItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDeliveryRegionsItem?: [{	by: ValueTypes["DeliveryRegionsItemUniqueWhere"],	data: ValueTypes["DeliveryRegionsItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getImageList?: [{	by: ValueTypes["ImageListUniqueWhere"],	filter?: ValueTypes["ImageListWhere"] | undefined | null},ValueTypes["ImageList"]],
listImageList?: [{	filter?: ValueTypes["ImageListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ImageListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ImageList"]],
paginateImageList?: [{	filter?: ValueTypes["ImageListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ImageListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ImageListConnection"]],
validateCreateImageList?: [{	data: ValueTypes["ImageListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImageList?: [{	by: ValueTypes["ImageListUniqueWhere"],	data: ValueTypes["ImageListUpdateInput"]},ValueTypes["_ValidationResult"]],
getImageListItem?: [{	by: ValueTypes["ImageListItemUniqueWhere"],	filter?: ValueTypes["ImageListItemWhere"] | undefined | null},ValueTypes["ImageListItem"]],
listImageListItem?: [{	filter?: ValueTypes["ImageListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ImageListItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ImageListItem"]],
paginateImageListItem?: [{	filter?: ValueTypes["ImageListItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ImageListItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ImageListItemConnection"]],
validateCreateImageListItem?: [{	data: ValueTypes["ImageListItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImageListItem?: [{	by: ValueTypes["ImageListItemUniqueWhere"],	data: ValueTypes["ImageListItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductSalesDay?: [{	by: ValueTypes["ProductSalesDayUniqueWhere"],	filter?: ValueTypes["ProductSalesDayWhere"] | undefined | null},ValueTypes["ProductSalesDay"]],
listProductSalesDay?: [{	filter?: ValueTypes["ProductSalesDayWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductSalesDayOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductSalesDay"]],
paginateProductSalesDay?: [{	filter?: ValueTypes["ProductSalesDayWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductSalesDayOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductSalesDayConnection"]],
getProductSalesMonth?: [{	by: ValueTypes["ProductSalesMonthUniqueWhere"],	filter?: ValueTypes["ProductSalesMonthWhere"] | undefined | null},ValueTypes["ProductSalesMonth"]],
listProductSalesMonth?: [{	filter?: ValueTypes["ProductSalesMonthWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductSalesMonthOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductSalesMonth"]],
paginateProductSalesMonth?: [{	filter?: ValueTypes["ProductSalesMonthWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductSalesMonthOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductSalesMonthConnection"]],
getProductSalesWeek?: [{	by: ValueTypes["ProductSalesWeekUniqueWhere"],	filter?: ValueTypes["ProductSalesWeekWhere"] | undefined | null},ValueTypes["ProductSalesWeek"]],
listProductSalesWeek?: [{	filter?: ValueTypes["ProductSalesWeekWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductSalesWeekOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ProductSalesWeek"]],
paginateProductSalesWeek?: [{	filter?: ValueTypes["ProductSalesWeekWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ProductSalesWeekOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ProductSalesWeekConnection"]],
getTimetablesEmployeePrivileges?: [{	by: ValueTypes["TimetablesEmployeePrivilegesUniqueWhere"],	filter?: ValueTypes["TimetablesEmployeePrivilegesWhere"] | undefined | null},ValueTypes["TimetablesEmployeePrivileges"]],
listTimetablesEmployeePrivileges?: [{	filter?: ValueTypes["TimetablesEmployeePrivilegesWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetablesEmployeePrivilegesOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TimetablesEmployeePrivileges"]],
paginateTimetablesEmployeePrivileges?: [{	filter?: ValueTypes["TimetablesEmployeePrivilegesWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetablesEmployeePrivilegesOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TimetablesEmployeePrivilegesConnection"]],
validateCreateTimetablesEmployeePrivileges?: [{	data: ValueTypes["TimetablesEmployeePrivilegesCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTimetablesEmployeePrivileges?: [{	by: ValueTypes["TimetablesEmployeePrivilegesUniqueWhere"],	data: ValueTypes["TimetablesEmployeePrivilegesUpdateInput"]},ValueTypes["_ValidationResult"]],
getTimetableDayNote?: [{	by: ValueTypes["TimetableDayNoteUniqueWhere"],	filter?: ValueTypes["TimetableDayNoteWhere"] | undefined | null},ValueTypes["TimetableDayNote"]],
listTimetableDayNote?: [{	filter?: ValueTypes["TimetableDayNoteWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableDayNoteOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TimetableDayNote"]],
paginateTimetableDayNote?: [{	filter?: ValueTypes["TimetableDayNoteWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableDayNoteOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TimetableDayNoteConnection"]],
validateCreateTimetableDayNote?: [{	data: ValueTypes["TimetableDayNoteCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTimetableDayNote?: [{	by: ValueTypes["TimetableDayNoteUniqueWhere"],	data: ValueTypes["TimetableDayNoteUpdateInput"]},ValueTypes["_ValidationResult"]],
getDeliveryMethodLocale?: [{	by: ValueTypes["DeliveryMethodLocaleUniqueWhere"],	filter?: ValueTypes["DeliveryMethodLocaleWhere"] | undefined | null},ValueTypes["DeliveryMethodLocale"]],
listDeliveryMethodLocale?: [{	filter?: ValueTypes["DeliveryMethodLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryMethodLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["DeliveryMethodLocale"]],
paginateDeliveryMethodLocale?: [{	filter?: ValueTypes["DeliveryMethodLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeliveryMethodLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["DeliveryMethodLocaleConnection"]],
validateCreateDeliveryMethodLocale?: [{	data: ValueTypes["DeliveryMethodLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDeliveryMethodLocale?: [{	by: ValueTypes["DeliveryMethodLocaleUniqueWhere"],	data: ValueTypes["DeliveryMethodLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getIngredientSupplier?: [{	by: ValueTypes["IngredientSupplierUniqueWhere"],	filter?: ValueTypes["IngredientSupplierWhere"] | undefined | null},ValueTypes["IngredientSupplier"]],
listIngredientSupplier?: [{	filter?: ValueTypes["IngredientSupplierWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IngredientSupplierOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["IngredientSupplier"]],
paginateIngredientSupplier?: [{	filter?: ValueTypes["IngredientSupplierWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IngredientSupplierOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["IngredientSupplierConnection"]],
validateCreateIngredientSupplier?: [{	data: ValueTypes["IngredientSupplierCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateIngredientSupplier?: [{	by: ValueTypes["IngredientSupplierUniqueWhere"],	data: ValueTypes["IngredientSupplierUpdateInput"]},ValueTypes["_ValidationResult"]],
getIngredientSupplierItem?: [{	by: ValueTypes["IngredientSupplierItemUniqueWhere"],	filter?: ValueTypes["IngredientSupplierItemWhere"] | undefined | null},ValueTypes["IngredientSupplierItem"]],
listIngredientSupplierItem?: [{	filter?: ValueTypes["IngredientSupplierItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IngredientSupplierItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["IngredientSupplierItem"]],
paginateIngredientSupplierItem?: [{	filter?: ValueTypes["IngredientSupplierItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IngredientSupplierItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["IngredientSupplierItemConnection"]],
validateCreateIngredientSupplierItem?: [{	data: ValueTypes["IngredientSupplierItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateIngredientSupplierItem?: [{	by: ValueTypes["IngredientSupplierItemUniqueWhere"],	data: ValueTypes["IngredientSupplierItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getIngredientSupplierList?: [{	by: ValueTypes["IngredientSupplierListUniqueWhere"],	filter?: ValueTypes["IngredientSupplierListWhere"] | undefined | null},ValueTypes["IngredientSupplierList"]],
listIngredientSupplierList?: [{	filter?: ValueTypes["IngredientSupplierListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IngredientSupplierListOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["IngredientSupplierList"]],
paginateIngredientSupplierList?: [{	filter?: ValueTypes["IngredientSupplierListWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IngredientSupplierListOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["IngredientSupplierListConnection"]],
validateCreateIngredientSupplierList?: [{	data: ValueTypes["IngredientSupplierListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateIngredientSupplierList?: [{	by: ValueTypes["IngredientSupplierListUniqueWhere"],	data: ValueTypes["IngredientSupplierListUpdateInput"]},ValueTypes["_ValidationResult"]],
getIngredientSupplierLocale?: [{	by: ValueTypes["IngredientSupplierLocaleUniqueWhere"],	filter?: ValueTypes["IngredientSupplierLocaleWhere"] | undefined | null},ValueTypes["IngredientSupplierLocale"]],
listIngredientSupplierLocale?: [{	filter?: ValueTypes["IngredientSupplierLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IngredientSupplierLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["IngredientSupplierLocale"]],
paginateIngredientSupplierLocale?: [{	filter?: ValueTypes["IngredientSupplierLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IngredientSupplierLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["IngredientSupplierLocaleConnection"]],
validateCreateIngredientSupplierLocale?: [{	data: ValueTypes["IngredientSupplierLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateIngredientSupplierLocale?: [{	by: ValueTypes["IngredientSupplierLocaleUniqueWhere"],	data: ValueTypes["IngredientSupplierLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getRedirect?: [{	by: ValueTypes["RedirectUniqueWhere"],	filter?: ValueTypes["RedirectWhere"] | undefined | null},ValueTypes["Redirect"]],
listRedirect?: [{	filter?: ValueTypes["RedirectWhere"] | undefined | null,	orderBy?: Array<ValueTypes["RedirectOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Redirect"]],
paginateRedirect?: [{	filter?: ValueTypes["RedirectWhere"] | undefined | null,	orderBy?: Array<ValueTypes["RedirectOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["RedirectConnection"]],
validateCreateRedirect?: [{	data: ValueTypes["RedirectCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateRedirect?: [{	by: ValueTypes["RedirectUniqueWhere"],	data: ValueTypes["RedirectUpdateInput"]},ValueTypes["_ValidationResult"]],
getNutritionFacts?: [{	by: ValueTypes["NutritionFactsUniqueWhere"],	filter?: ValueTypes["NutritionFactsWhere"] | undefined | null},ValueTypes["NutritionFacts"]],
listNutritionFacts?: [{	filter?: ValueTypes["NutritionFactsWhere"] | undefined | null,	orderBy?: Array<ValueTypes["NutritionFactsOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["NutritionFacts"]],
paginateNutritionFacts?: [{	filter?: ValueTypes["NutritionFactsWhere"] | undefined | null,	orderBy?: Array<ValueTypes["NutritionFactsOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["NutritionFactsConnection"]],
validateCreateNutritionFacts?: [{	data: ValueTypes["NutritionFactsCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateNutritionFacts?: [{	by: ValueTypes["NutritionFactsUniqueWhere"],	data: ValueTypes["NutritionFactsUpdateInput"]},ValueTypes["_ValidationResult"]],
getVenue?: [{	by: ValueTypes["VenueUniqueWhere"],	filter?: ValueTypes["VenueWhere"] | undefined | null},ValueTypes["Venue"]],
listVenue?: [{	filter?: ValueTypes["VenueWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VenueOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Venue"]],
paginateVenue?: [{	filter?: ValueTypes["VenueWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VenueOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["VenueConnection"]],
validateCreateVenue?: [{	data: ValueTypes["VenueCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateVenue?: [{	by: ValueTypes["VenueUniqueWhere"],	data: ValueTypes["VenueUpdateInput"]},ValueTypes["_ValidationResult"]],
getWorkspace?: [{	by: ValueTypes["WorkspaceUniqueWhere"],	filter?: ValueTypes["WorkspaceWhere"] | undefined | null},ValueTypes["Workspace"]],
listWorkspace?: [{	filter?: ValueTypes["WorkspaceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["WorkspaceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Workspace"]],
paginateWorkspace?: [{	filter?: ValueTypes["WorkspaceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["WorkspaceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["WorkspaceConnection"]],
validateCreateWorkspace?: [{	data: ValueTypes["WorkspaceCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateWorkspace?: [{	by: ValueTypes["WorkspaceUniqueWhere"],	data: ValueTypes["WorkspaceUpdateInput"]},ValueTypes["_ValidationResult"]],
getInternalBuyer?: [{	by: ValueTypes["InternalBuyerUniqueWhere"],	filter?: ValueTypes["InternalBuyerWhere"] | undefined | null},ValueTypes["InternalBuyer"]],
listInternalBuyer?: [{	filter?: ValueTypes["InternalBuyerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InternalBuyerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["InternalBuyer"]],
paginateInternalBuyer?: [{	filter?: ValueTypes["InternalBuyerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["InternalBuyerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["InternalBuyerConnection"]],
validateCreateInternalBuyer?: [{	data: ValueTypes["InternalBuyerCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateInternalBuyer?: [{	by: ValueTypes["InternalBuyerUniqueWhere"],	data: ValueTypes["InternalBuyerUpdateInput"]},ValueTypes["_ValidationResult"]],
getCartSummary?: [{	by: ValueTypes["CartSummaryUniqueWhere"],	filter?: ValueTypes["CartSummaryWhere"] | undefined | null},ValueTypes["CartSummary"]],
listCartSummary?: [{	filter?: ValueTypes["CartSummaryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CartSummaryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CartSummary"]],
paginateCartSummary?: [{	filter?: ValueTypes["CartSummaryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CartSummaryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CartSummaryConnection"]],
getOrderSummary?: [{	by: ValueTypes["OrderSummaryUniqueWhere"],	filter?: ValueTypes["OrderSummaryWhere"] | undefined | null},ValueTypes["OrderSummary"]],
listOrderSummary?: [{	filter?: ValueTypes["OrderSummaryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderSummaryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["OrderSummary"]],
paginateOrderSummary?: [{	filter?: ValueTypes["OrderSummaryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderSummaryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderSummaryConnection"]],
getCustomerSpending?: [{	by: ValueTypes["CustomerSpendingUniqueWhere"],	filter?: ValueTypes["CustomerSpendingWhere"] | undefined | null},ValueTypes["CustomerSpending"]],
listCustomerSpending?: [{	filter?: ValueTypes["CustomerSpendingWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerSpendingOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CustomerSpending"]],
paginateCustomerSpending?: [{	filter?: ValueTypes["CustomerSpendingWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerSpendingOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerSpendingConnection"]],
getOrderPaymentMetadata?: [{	by: ValueTypes["OrderPaymentMetadataUniqueWhere"],	filter?: ValueTypes["OrderPaymentMetadataWhere"] | undefined | null},ValueTypes["OrderPaymentMetadata"]],
listOrderPaymentMetadata?: [{	filter?: ValueTypes["OrderPaymentMetadataWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderPaymentMetadataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["OrderPaymentMetadata"]],
paginateOrderPaymentMetadata?: [{	filter?: ValueTypes["OrderPaymentMetadataWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderPaymentMetadataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderPaymentMetadataConnection"]],
getUserMetadata?: [{	by: ValueTypes["UserMetadataUniqueWhere"],	filter?: ValueTypes["UserMetadataWhere"] | undefined | null},ValueTypes["UserMetadata"]],
listUserMetadata?: [{	filter?: ValueTypes["UserMetadataWhere"] | undefined | null,	orderBy?: Array<ValueTypes["UserMetadataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["UserMetadata"]],
paginateUserMetadata?: [{	filter?: ValueTypes["UserMetadataWhere"] | undefined | null,	orderBy?: Array<ValueTypes["UserMetadataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["UserMetadataConnection"]],
getCustomerTabMetadata?: [{	by: ValueTypes["CustomerTabMetadataUniqueWhere"],	filter?: ValueTypes["CustomerTabMetadataWhere"] | undefined | null},ValueTypes["CustomerTabMetadata"]],
listCustomerTabMetadata?: [{	filter?: ValueTypes["CustomerTabMetadataWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerTabMetadataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CustomerTabMetadata"]],
paginateCustomerTabMetadata?: [{	filter?: ValueTypes["CustomerTabMetadataWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerTabMetadataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerTabMetadataConnection"]],
getVenueEmployeeRole?: [{	by: ValueTypes["VenueEmployeeRoleUniqueWhere"],	filter?: ValueTypes["VenueEmployeeRoleWhere"] | undefined | null},ValueTypes["VenueEmployeeRole"]],
listVenueEmployeeRole?: [{	filter?: ValueTypes["VenueEmployeeRoleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VenueEmployeeRoleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["VenueEmployeeRole"]],
paginateVenueEmployeeRole?: [{	filter?: ValueTypes["VenueEmployeeRoleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["VenueEmployeeRoleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["VenueEmployeeRoleConnection"]],
validateCreateVenueEmployeeRole?: [{	data: ValueTypes["VenueEmployeeRoleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateVenueEmployeeRole?: [{	by: ValueTypes["VenueEmployeeRoleUniqueWhere"],	data: ValueTypes["VenueEmployeeRoleUpdateInput"]},ValueTypes["_ValidationResult"]],
getIdentificationAttempt?: [{	by: ValueTypes["IdentificationAttemptUniqueWhere"],	filter?: ValueTypes["IdentificationAttemptWhere"] | undefined | null},ValueTypes["IdentificationAttempt"]],
listIdentificationAttempt?: [{	filter?: ValueTypes["IdentificationAttemptWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IdentificationAttemptOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["IdentificationAttempt"]],
paginateIdentificationAttempt?: [{	filter?: ValueTypes["IdentificationAttemptWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IdentificationAttemptOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["IdentificationAttemptConnection"]],
validateCreateIdentificationAttempt?: [{	data: ValueTypes["IdentificationAttemptCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateIdentificationAttempt?: [{	by: ValueTypes["IdentificationAttemptUniqueWhere"],	data: ValueTypes["IdentificationAttemptUpdateInput"]},ValueTypes["_ValidationResult"]],
getIdentificationCode?: [{	by: ValueTypes["IdentificationCodeUniqueWhere"],	filter?: ValueTypes["IdentificationCodeWhere"] | undefined | null},ValueTypes["IdentificationCode"]],
listIdentificationCode?: [{	filter?: ValueTypes["IdentificationCodeWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IdentificationCodeOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["IdentificationCode"]],
paginateIdentificationCode?: [{	filter?: ValueTypes["IdentificationCodeWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IdentificationCodeOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["IdentificationCodeConnection"]],
validateCreateIdentificationCode?: [{	data: ValueTypes["IdentificationCodeCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateIdentificationCode?: [{	by: ValueTypes["IdentificationCodeUniqueWhere"],	data: ValueTypes["IdentificationCodeUpdateInput"]},ValueTypes["_ValidationResult"]],
getIdentificationCodeLocale?: [{	by: ValueTypes["IdentificationCodeLocaleUniqueWhere"],	filter?: ValueTypes["IdentificationCodeLocaleWhere"] | undefined | null},ValueTypes["IdentificationCodeLocale"]],
listIdentificationCodeLocale?: [{	filter?: ValueTypes["IdentificationCodeLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IdentificationCodeLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["IdentificationCodeLocale"]],
paginateIdentificationCodeLocale?: [{	filter?: ValueTypes["IdentificationCodeLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["IdentificationCodeLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["IdentificationCodeLocaleConnection"]],
validateCreateIdentificationCodeLocale?: [{	data: ValueTypes["IdentificationCodeLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateIdentificationCodeLocale?: [{	by: ValueTypes["IdentificationCodeLocaleUniqueWhere"],	data: ValueTypes["IdentificationCodeLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getPipeline?: [{	by: ValueTypes["PipelineUniqueWhere"],	filter?: ValueTypes["PipelineWhere"] | undefined | null},ValueTypes["Pipeline"]],
listPipeline?: [{	filter?: ValueTypes["PipelineWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PipelineOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Pipeline"]],
paginatePipeline?: [{	filter?: ValueTypes["PipelineWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PipelineOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PipelineConnection"]],
validateCreatePipeline?: [{	data: ValueTypes["PipelineCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePipeline?: [{	by: ValueTypes["PipelineUniqueWhere"],	data: ValueTypes["PipelineUpdateInput"]},ValueTypes["_ValidationResult"]],
getPipelineLead?: [{	by: ValueTypes["PipelineLeadUniqueWhere"],	filter?: ValueTypes["PipelineLeadWhere"] | undefined | null},ValueTypes["PipelineLead"]],
listPipelineLead?: [{	filter?: ValueTypes["PipelineLeadWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PipelineLeadOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PipelineLead"]],
paginatePipelineLead?: [{	filter?: ValueTypes["PipelineLeadWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PipelineLeadOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PipelineLeadConnection"]],
validateCreatePipelineLead?: [{	data: ValueTypes["PipelineLeadCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePipelineLead?: [{	by: ValueTypes["PipelineLeadUniqueWhere"],	data: ValueTypes["PipelineLeadUpdateInput"]},ValueTypes["_ValidationResult"]],
getPipelineStage?: [{	by: ValueTypes["PipelineStageUniqueWhere"],	filter?: ValueTypes["PipelineStageWhere"] | undefined | null},ValueTypes["PipelineStage"]],
listPipelineStage?: [{	filter?: ValueTypes["PipelineStageWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PipelineStageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PipelineStage"]],
paginatePipelineStage?: [{	filter?: ValueTypes["PipelineStageWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PipelineStageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PipelineStageConnection"]],
validateCreatePipelineStage?: [{	data: ValueTypes["PipelineStageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePipelineStage?: [{	by: ValueTypes["PipelineStageUniqueWhere"],	data: ValueTypes["PipelineStageUpdateInput"]},ValueTypes["_ValidationResult"]],
getPipelineStageItem?: [{	by: ValueTypes["PipelineStageItemUniqueWhere"],	filter?: ValueTypes["PipelineStageItemWhere"] | undefined | null},ValueTypes["PipelineStageItem"]],
listPipelineStageItem?: [{	filter?: ValueTypes["PipelineStageItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PipelineStageItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PipelineStageItem"]],
paginatePipelineStageItem?: [{	filter?: ValueTypes["PipelineStageItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PipelineStageItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PipelineStageItemConnection"]],
validateCreatePipelineStageItem?: [{	data: ValueTypes["PipelineStageItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePipelineStageItem?: [{	by: ValueTypes["PipelineStageItemUniqueWhere"],	data: ValueTypes["PipelineStageItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getPipelineStageLocale?: [{	by: ValueTypes["PipelineStageLocaleUniqueWhere"],	filter?: ValueTypes["PipelineStageLocaleWhere"] | undefined | null},ValueTypes["PipelineStageLocale"]],
listPipelineStageLocale?: [{	filter?: ValueTypes["PipelineStageLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PipelineStageLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PipelineStageLocale"]],
paginatePipelineStageLocale?: [{	filter?: ValueTypes["PipelineStageLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PipelineStageLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PipelineStageLocaleConnection"]],
validateCreatePipelineStageLocale?: [{	data: ValueTypes["PipelineStageLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePipelineStageLocale?: [{	by: ValueTypes["PipelineStageLocaleUniqueWhere"],	data: ValueTypes["PipelineStageLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getSalesManager?: [{	by: ValueTypes["SalesManagerUniqueWhere"],	filter?: ValueTypes["SalesManagerWhere"] | undefined | null},ValueTypes["SalesManager"]],
listSalesManager?: [{	filter?: ValueTypes["SalesManagerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SalesManagerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["SalesManager"]],
paginateSalesManager?: [{	filter?: ValueTypes["SalesManagerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SalesManagerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["SalesManagerConnection"]],
validateCreateSalesManager?: [{	data: ValueTypes["SalesManagerCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSalesManager?: [{	by: ValueTypes["SalesManagerUniqueWhere"],	data: ValueTypes["SalesManagerUpdateInput"]},ValueTypes["_ValidationResult"]],
getCashierManager?: [{	by: ValueTypes["CashierManagerUniqueWhere"],	filter?: ValueTypes["CashierManagerWhere"] | undefined | null},ValueTypes["CashierManager"]],
listCashierManager?: [{	filter?: ValueTypes["CashierManagerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CashierManagerOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CashierManager"]],
paginateCashierManager?: [{	filter?: ValueTypes["CashierManagerWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CashierManagerOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CashierManagerConnection"]],
validateCreateCashierManager?: [{	data: ValueTypes["CashierManagerCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCashierManager?: [{	by: ValueTypes["CashierManagerUniqueWhere"],	data: ValueTypes["CashierManagerUpdateInput"]},ValueTypes["_ValidationResult"]],
getUserRoles?: [{	by: ValueTypes["UserRolesUniqueWhere"],	filter?: ValueTypes["UserRolesWhere"] | undefined | null},ValueTypes["UserRoles"]],
listUserRoles?: [{	filter?: ValueTypes["UserRolesWhere"] | undefined | null,	orderBy?: Array<ValueTypes["UserRolesOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["UserRoles"]],
paginateUserRoles?: [{	filter?: ValueTypes["UserRolesWhere"] | undefined | null,	orderBy?: Array<ValueTypes["UserRolesOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["UserRolesConnection"]],
getPointOfSaleApplicationDevice?: [{	by: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"],	filter?: ValueTypes["PointOfSaleApplicationDeviceWhere"] | undefined | null},ValueTypes["PointOfSaleApplicationDevice"]],
listPointOfSaleApplicationDevice?: [{	filter?: ValueTypes["PointOfSaleApplicationDeviceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleApplicationDeviceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PointOfSaleApplicationDevice"]],
paginatePointOfSaleApplicationDevice?: [{	filter?: ValueTypes["PointOfSaleApplicationDeviceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleApplicationDeviceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PointOfSaleApplicationDeviceConnection"]],
validateCreatePointOfSaleApplicationDevice?: [{	data: ValueTypes["PointOfSaleApplicationDeviceCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePointOfSaleApplicationDevice?: [{	by: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"],	data: ValueTypes["PointOfSaleApplicationDeviceUpdateInput"]},ValueTypes["_ValidationResult"]],
getPointOfSaleTerminal?: [{	by: ValueTypes["PointOfSaleTerminalUniqueWhere"],	filter?: ValueTypes["PointOfSaleTerminalWhere"] | undefined | null},ValueTypes["PointOfSaleTerminal"]],
listPointOfSaleTerminal?: [{	filter?: ValueTypes["PointOfSaleTerminalWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleTerminalOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PointOfSaleTerminal"]],
paginatePointOfSaleTerminal?: [{	filter?: ValueTypes["PointOfSaleTerminalWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSaleTerminalOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PointOfSaleTerminalConnection"]],
validateCreatePointOfSaleTerminal?: [{	data: ValueTypes["PointOfSaleTerminalCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePointOfSaleTerminal?: [{	by: ValueTypes["PointOfSaleTerminalUniqueWhere"],	data: ValueTypes["PointOfSaleTerminalUpdateInput"]},ValueTypes["_ValidationResult"]],
getPipelineStageSentiment?: [{	by: ValueTypes["PipelineStageSentimentUniqueWhere"],	filter?: ValueTypes["PipelineStageSentimentWhere"] | undefined | null},ValueTypes["PipelineStageSentiment"]],
listPipelineStageSentiment?: [{	filter?: ValueTypes["PipelineStageSentimentWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PipelineStageSentimentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PipelineStageSentiment"]],
paginatePipelineStageSentiment?: [{	filter?: ValueTypes["PipelineStageSentimentWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PipelineStageSentimentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PipelineStageSentimentConnection"]],
validateCreatePipelineStageSentiment?: [{	data: ValueTypes["PipelineStageSentimentCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePipelineStageSentiment?: [{	by: ValueTypes["PipelineStageSentimentUniqueWhere"],	data: ValueTypes["PipelineStageSentimentUpdateInput"]},ValueTypes["_ValidationResult"]],
getDeviceIdentifier?: [{	by: ValueTypes["DeviceIdentifierUniqueWhere"],	filter?: ValueTypes["DeviceIdentifierWhere"] | undefined | null},ValueTypes["DeviceIdentifier"]],
listDeviceIdentifier?: [{	filter?: ValueTypes["DeviceIdentifierWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeviceIdentifierOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["DeviceIdentifier"]],
paginateDeviceIdentifier?: [{	filter?: ValueTypes["DeviceIdentifierWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeviceIdentifierOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["DeviceIdentifierConnection"]],
validateCreateDeviceIdentifier?: [{	data: ValueTypes["DeviceIdentifierCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDeviceIdentifier?: [{	by: ValueTypes["DeviceIdentifierUniqueWhere"],	data: ValueTypes["DeviceIdentifierUpdateInput"]},ValueTypes["_ValidationResult"]],
getDeviceIdentifierMetadata?: [{	by: ValueTypes["DeviceIdentifierMetadataUniqueWhere"],	filter?: ValueTypes["DeviceIdentifierMetadataWhere"] | undefined | null},ValueTypes["DeviceIdentifierMetadata"]],
listDeviceIdentifierMetadata?: [{	filter?: ValueTypes["DeviceIdentifierMetadataWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeviceIdentifierMetadataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["DeviceIdentifierMetadata"]],
paginateDeviceIdentifierMetadata?: [{	filter?: ValueTypes["DeviceIdentifierMetadataWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DeviceIdentifierMetadataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["DeviceIdentifierMetadataConnection"]],
getPointOfSalePrinter?: [{	by: ValueTypes["PointOfSalePrinterUniqueWhere"],	filter?: ValueTypes["PointOfSalePrinterWhere"] | undefined | null},ValueTypes["PointOfSalePrinter"]],
listPointOfSalePrinter?: [{	filter?: ValueTypes["PointOfSalePrinterWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSalePrinterOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["PointOfSalePrinter"]],
paginatePointOfSalePrinter?: [{	filter?: ValueTypes["PointOfSalePrinterWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PointOfSalePrinterOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PointOfSalePrinterConnection"]],
validateCreatePointOfSalePrinter?: [{	data: ValueTypes["PointOfSalePrinterCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePointOfSalePrinter?: [{	by: ValueTypes["PointOfSalePrinterUniqueWhere"],	data: ValueTypes["PointOfSalePrinterUpdateInput"]},ValueTypes["_ValidationResult"]],
getGratuity?: [{	by: ValueTypes["GratuityUniqueWhere"],	filter?: ValueTypes["GratuityWhere"] | undefined | null},ValueTypes["Gratuity"]],
listGratuity?: [{	filter?: ValueTypes["GratuityWhere"] | undefined | null,	orderBy?: Array<ValueTypes["GratuityOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Gratuity"]],
paginateGratuity?: [{	filter?: ValueTypes["GratuityWhere"] | undefined | null,	orderBy?: Array<ValueTypes["GratuityOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["GratuityConnection"]],
validateCreateGratuity?: [{	data: ValueTypes["GratuityCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateGratuity?: [{	by: ValueTypes["GratuityUniqueWhere"],	data: ValueTypes["GratuityUpdateInput"]},ValueTypes["_ValidationResult"]],
getFulfillmentNote?: [{	by: ValueTypes["FulfillmentNoteUniqueWhere"],	filter?: ValueTypes["FulfillmentNoteWhere"] | undefined | null},ValueTypes["FulfillmentNote"]],
listFulfillmentNote?: [{	filter?: ValueTypes["FulfillmentNoteWhere"] | undefined | null,	orderBy?: Array<ValueTypes["FulfillmentNoteOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["FulfillmentNote"]],
paginateFulfillmentNote?: [{	filter?: ValueTypes["FulfillmentNoteWhere"] | undefined | null,	orderBy?: Array<ValueTypes["FulfillmentNoteOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["FulfillmentNoteConnection"]],
validateCreateFulfillmentNote?: [{	data: ValueTypes["FulfillmentNoteCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFulfillmentNote?: [{	by: ValueTypes["FulfillmentNoteUniqueWhere"],	data: ValueTypes["FulfillmentNoteUpdateInput"]},ValueTypes["_ValidationResult"]],
getCustomerMetadata?: [{	by: ValueTypes["CustomerMetadataUniqueWhere"],	filter?: ValueTypes["CustomerMetadataWhere"] | undefined | null},ValueTypes["CustomerMetadata"]],
listCustomerMetadata?: [{	filter?: ValueTypes["CustomerMetadataWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerMetadataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["CustomerMetadata"]],
paginateCustomerMetadata?: [{	filter?: ValueTypes["CustomerMetadataWhere"] | undefined | null,	orderBy?: Array<ValueTypes["CustomerMetadataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["CustomerMetadataConnection"]],
getLeadForm?: [{	by: ValueTypes["LeadFormUniqueWhere"],	filter?: ValueTypes["LeadFormWhere"] | undefined | null},ValueTypes["LeadForm"]],
listLeadForm?: [{	filter?: ValueTypes["LeadFormWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LeadFormOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["LeadForm"]],
paginateLeadForm?: [{	filter?: ValueTypes["LeadFormWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LeadFormOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["LeadFormConnection"]],
validateCreateLeadForm?: [{	data: ValueTypes["LeadFormCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLeadForm?: [{	by: ValueTypes["LeadFormUniqueWhere"],	data: ValueTypes["LeadFormUpdateInput"]},ValueTypes["_ValidationResult"]],
getSubscriptionBox?: [{	by: ValueTypes["SubscriptionBoxUniqueWhere"],	filter?: ValueTypes["SubscriptionBoxWhere"] | undefined | null},ValueTypes["SubscriptionBox"]],
listSubscriptionBox?: [{	filter?: ValueTypes["SubscriptionBoxWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SubscriptionBoxOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["SubscriptionBox"]],
paginateSubscriptionBox?: [{	filter?: ValueTypes["SubscriptionBoxWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SubscriptionBoxOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["SubscriptionBoxConnection"]],
validateCreateSubscriptionBox?: [{	data: ValueTypes["SubscriptionBoxCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSubscriptionBox?: [{	by: ValueTypes["SubscriptionBoxUniqueWhere"],	data: ValueTypes["SubscriptionBoxUpdateInput"]},ValueTypes["_ValidationResult"]],
getSubscriptionBoxLocale?: [{	by: ValueTypes["SubscriptionBoxLocaleUniqueWhere"],	filter?: ValueTypes["SubscriptionBoxLocaleWhere"] | undefined | null},ValueTypes["SubscriptionBoxLocale"]],
listSubscriptionBoxLocale?: [{	filter?: ValueTypes["SubscriptionBoxLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SubscriptionBoxLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["SubscriptionBoxLocale"]],
paginateSubscriptionBoxLocale?: [{	filter?: ValueTypes["SubscriptionBoxLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SubscriptionBoxLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["SubscriptionBoxLocaleConnection"]],
validateCreateSubscriptionBoxLocale?: [{	data: ValueTypes["SubscriptionBoxLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSubscriptionBoxLocale?: [{	by: ValueTypes["SubscriptionBoxLocaleUniqueWhere"],	data: ValueTypes["SubscriptionBoxLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getTimetableDayMetadata?: [{	by: ValueTypes["TimetableDayMetadataUniqueWhere"],	filter?: ValueTypes["TimetableDayMetadataWhere"] | undefined | null},ValueTypes["TimetableDayMetadata"]],
listTimetableDayMetadata?: [{	filter?: ValueTypes["TimetableDayMetadataWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableDayMetadataOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["TimetableDayMetadata"]],
paginateTimetableDayMetadata?: [{	filter?: ValueTypes["TimetableDayMetadataWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TimetableDayMetadataOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TimetableDayMetadataConnection"]],
getBusinessService?: [{	by: ValueTypes["BusinessServiceUniqueWhere"],	filter?: ValueTypes["BusinessServiceWhere"] | undefined | null},ValueTypes["BusinessService"]],
listBusinessService?: [{	filter?: ValueTypes["BusinessServiceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessServiceOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BusinessService"]],
paginateBusinessService?: [{	filter?: ValueTypes["BusinessServiceWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessServiceOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BusinessServiceConnection"]],
validateCreateBusinessService?: [{	data: ValueTypes["BusinessServiceCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBusinessService?: [{	by: ValueTypes["BusinessServiceUniqueWhere"],	data: ValueTypes["BusinessServiceUpdateInput"]},ValueTypes["_ValidationResult"]],
getBusinessServiceEvent?: [{	by: ValueTypes["BusinessServiceEventUniqueWhere"],	filter?: ValueTypes["BusinessServiceEventWhere"] | undefined | null},ValueTypes["BusinessServiceEvent"]],
listBusinessServiceEvent?: [{	filter?: ValueTypes["BusinessServiceEventWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessServiceEventOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BusinessServiceEvent"]],
paginateBusinessServiceEvent?: [{	filter?: ValueTypes["BusinessServiceEventWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessServiceEventOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BusinessServiceEventConnection"]],
validateCreateBusinessServiceEvent?: [{	data: ValueTypes["BusinessServiceEventCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBusinessServiceEvent?: [{	by: ValueTypes["BusinessServiceEventUniqueWhere"],	data: ValueTypes["BusinessServiceEventUpdateInput"]},ValueTypes["_ValidationResult"]],
getBusinessServiceLocale?: [{	by: ValueTypes["BusinessServiceLocaleUniqueWhere"],	filter?: ValueTypes["BusinessServiceLocaleWhere"] | undefined | null},ValueTypes["BusinessServiceLocale"]],
listBusinessServiceLocale?: [{	filter?: ValueTypes["BusinessServiceLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessServiceLocaleOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["BusinessServiceLocale"]],
paginateBusinessServiceLocale?: [{	filter?: ValueTypes["BusinessServiceLocaleWhere"] | undefined | null,	orderBy?: Array<ValueTypes["BusinessServiceLocaleOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["BusinessServiceLocaleConnection"]],
validateCreateBusinessServiceLocale?: [{	data: ValueTypes["BusinessServiceLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBusinessServiceLocale?: [{	by: ValueTypes["BusinessServiceLocaleUniqueWhere"],	data: ValueTypes["BusinessServiceLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getGridTileItem?: [{	by: ValueTypes["GridTileItemUniqueWhere"],	filter?: ValueTypes["GridTileItemWhere"] | undefined | null},ValueTypes["GridTileItem"]],
listGridTileItem?: [{	filter?: ValueTypes["GridTileItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["GridTileItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["GridTileItem"]],
paginateGridTileItem?: [{	filter?: ValueTypes["GridTileItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["GridTileItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["GridTileItemConnection"]],
validateCreateGridTileItem?: [{	data: ValueTypes["GridTileItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateGridTileItem?: [{	by: ValueTypes["GridTileItemUniqueWhere"],	data: ValueTypes["GridTileItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getGridTiles?: [{	by: ValueTypes["GridTilesUniqueWhere"],	filter?: ValueTypes["GridTilesWhere"] | undefined | null},ValueTypes["GridTiles"]],
listGridTiles?: [{	filter?: ValueTypes["GridTilesWhere"] | undefined | null,	orderBy?: Array<ValueTypes["GridTilesOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["GridTiles"]],
paginateGridTiles?: [{	filter?: ValueTypes["GridTilesWhere"] | undefined | null,	orderBy?: Array<ValueTypes["GridTilesOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["GridTilesConnection"]],
validateCreateGridTiles?: [{	data: ValueTypes["GridTilesCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateGridTiles?: [{	by: ValueTypes["GridTilesUniqueWhere"],	data: ValueTypes["GridTilesUpdateInput"]},ValueTypes["_ValidationResult"]],
getArea?: [{	by: ValueTypes["AreaUniqueWhere"],	filter?: ValueTypes["AreaWhere"] | undefined | null},ValueTypes["Area"]],
listArea?: [{	filter?: ValueTypes["AreaWhere"] | undefined | null,	orderBy?: Array<ValueTypes["AreaOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Area"]],
paginateArea?: [{	filter?: ValueTypes["AreaWhere"] | undefined | null,	orderBy?: Array<ValueTypes["AreaOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["AreaConnection"]],
validateCreateArea?: [{	data: ValueTypes["AreaCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateArea?: [{	by: ValueTypes["AreaUniqueWhere"],	data: ValueTypes["AreaUpdateInput"]},ValueTypes["_ValidationResult"]],
getPosition?: [{	by: ValueTypes["PositionUniqueWhere"],	filter?: ValueTypes["PositionWhere"] | undefined | null},ValueTypes["Position"]],
listPosition?: [{	filter?: ValueTypes["PositionWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PositionOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Position"]],
paginatePosition?: [{	filter?: ValueTypes["PositionWhere"] | undefined | null,	orderBy?: Array<ValueTypes["PositionOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["PositionConnection"]],
validateCreatePosition?: [{	data: ValueTypes["PositionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePosition?: [{	by: ValueTypes["PositionUniqueWhere"],	data: ValueTypes["PositionUpdateInput"]},ValueTypes["_ValidationResult"]],
getStatsEnabledWidgetType?: [{	by: ValueTypes["StatsEnabledWidgetTypeUniqueWhere"],	filter?: ValueTypes["StatsEnabledWidgetTypeWhere"] | undefined | null},ValueTypes["StatsEnabledWidgetType"]],
listStatsEnabledWidgetType?: [{	filter?: ValueTypes["StatsEnabledWidgetTypeWhere"] | undefined | null,	orderBy?: Array<ValueTypes["StatsEnabledWidgetTypeOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["StatsEnabledWidgetType"]],
paginateStatsEnabledWidgetType?: [{	filter?: ValueTypes["StatsEnabledWidgetTypeWhere"] | undefined | null,	orderBy?: Array<ValueTypes["StatsEnabledWidgetTypeOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["StatsEnabledWidgetTypeConnection"]],
validateCreateStatsEnabledWidgetType?: [{	data: ValueTypes["StatsEnabledWidgetTypeCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateStatsEnabledWidgetType?: [{	by: ValueTypes["StatsEnabledWidgetTypeUniqueWhere"],	data: ValueTypes["StatsEnabledWidgetTypeUpdateInput"]},ValueTypes["_ValidationResult"]],
getStatsWidget?: [{	by: ValueTypes["StatsWidgetUniqueWhere"],	filter?: ValueTypes["StatsWidgetWhere"] | undefined | null},ValueTypes["StatsWidget"]],
listStatsWidget?: [{	filter?: ValueTypes["StatsWidgetWhere"] | undefined | null,	orderBy?: Array<ValueTypes["StatsWidgetOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["StatsWidget"]],
paginateStatsWidget?: [{	filter?: ValueTypes["StatsWidgetWhere"] | undefined | null,	orderBy?: Array<ValueTypes["StatsWidgetOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["StatsWidgetConnection"]],
validateCreateStatsWidget?: [{	data: ValueTypes["StatsWidgetCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateStatsWidget?: [{	by: ValueTypes["StatsWidgetUniqueWhere"],	data: ValueTypes["StatsWidgetUpdateInput"]},ValueTypes["_ValidationResult"]],
getStatsWidgetsLayout?: [{	by: ValueTypes["StatsWidgetsLayoutUniqueWhere"],	filter?: ValueTypes["StatsWidgetsLayoutWhere"] | undefined | null},ValueTypes["StatsWidgetsLayout"]],
listStatsWidgetsLayout?: [{	filter?: ValueTypes["StatsWidgetsLayoutWhere"] | undefined | null,	orderBy?: Array<ValueTypes["StatsWidgetsLayoutOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["StatsWidgetsLayout"]],
paginateStatsWidgetsLayout?: [{	filter?: ValueTypes["StatsWidgetsLayoutWhere"] | undefined | null,	orderBy?: Array<ValueTypes["StatsWidgetsLayoutOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["StatsWidgetsLayoutConnection"]],
validateCreateStatsWidgetsLayout?: [{	data: ValueTypes["StatsWidgetsLayoutCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateStatsWidgetsLayout?: [{	by: ValueTypes["StatsWidgetsLayoutUniqueWhere"],	data: ValueTypes["StatsWidgetsLayoutUpdateInput"]},ValueTypes["_ValidationResult"]],
getSeat?: [{	by: ValueTypes["SeatUniqueWhere"],	filter?: ValueTypes["SeatWhere"] | undefined | null},ValueTypes["Seat"]],
listSeat?: [{	filter?: ValueTypes["SeatWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SeatOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Seat"]],
paginateSeat?: [{	filter?: ValueTypes["SeatWhere"] | undefined | null,	orderBy?: Array<ValueTypes["SeatOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["SeatConnection"]],
validateCreateSeat?: [{	data: ValueTypes["SeatCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSeat?: [{	by: ValueTypes["SeatUniqueWhere"],	data: ValueTypes["SeatUpdateInput"]},ValueTypes["_ValidationResult"]],
getTable?: [{	by: ValueTypes["TableUniqueWhere"],	filter?: ValueTypes["TableWhere"] | undefined | null},ValueTypes["Table"]],
listTable?: [{	filter?: ValueTypes["TableWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TableOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Table"]],
paginateTable?: [{	filter?: ValueTypes["TableWhere"] | undefined | null,	orderBy?: Array<ValueTypes["TableOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["TableConnection"]],
validateCreateTable?: [{	data: ValueTypes["TableCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTable?: [{	by: ValueTypes["TableUniqueWhere"],	data: ValueTypes["TableUpdateInput"]},ValueTypes["_ValidationResult"]],
getStatsPage?: [{	by: ValueTypes["StatsPageUniqueWhere"],	filter?: ValueTypes["StatsPageWhere"] | undefined | null},ValueTypes["StatsPage"]],
listStatsPage?: [{	filter?: ValueTypes["StatsPageWhere"] | undefined | null,	orderBy?: Array<ValueTypes["StatsPageOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["StatsPage"]],
paginateStatsPage?: [{	filter?: ValueTypes["StatsPageWhere"] | undefined | null,	orderBy?: Array<ValueTypes["StatsPageOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["StatsPageConnection"]],
validateCreateStatsPage?: [{	data: ValueTypes["StatsPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateStatsPage?: [{	by: ValueTypes["StatsPageUniqueWhere"],	data: ValueTypes["StatsPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getUnassignReason?: [{	by: ValueTypes["UnassignReasonUniqueWhere"],	filter?: ValueTypes["UnassignReasonWhere"] | undefined | null},ValueTypes["UnassignReason"]],
listUnassignReason?: [{	filter?: ValueTypes["UnassignReasonWhere"] | undefined | null,	orderBy?: Array<ValueTypes["UnassignReasonOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["UnassignReason"]],
paginateUnassignReason?: [{	filter?: ValueTypes["UnassignReasonWhere"] | undefined | null,	orderBy?: Array<ValueTypes["UnassignReasonOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["UnassignReasonConnection"]],
validateCreateUnassignReason?: [{	data: ValueTypes["UnassignReasonCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateUnassignReason?: [{	by: ValueTypes["UnassignReasonUniqueWhere"],	data: ValueTypes["UnassignReasonUpdateInput"]},ValueTypes["_ValidationResult"]],
getDoubleshotCoffeeEquipment?: [{	by: ValueTypes["DoubleshotCoffeeEquipmentUniqueWhere"],	filter?: ValueTypes["DoubleshotCoffeeEquipmentWhere"] | undefined | null},ValueTypes["DoubleshotCoffeeEquipment"]],
listDoubleshotCoffeeEquipment?: [{	filter?: ValueTypes["DoubleshotCoffeeEquipmentWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DoubleshotCoffeeEquipmentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["DoubleshotCoffeeEquipment"]],
paginateDoubleshotCoffeeEquipment?: [{	filter?: ValueTypes["DoubleshotCoffeeEquipmentWhere"] | undefined | null,	orderBy?: Array<ValueTypes["DoubleshotCoffeeEquipmentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["DoubleshotCoffeeEquipmentConnection"]],
validateCreateDoubleshotCoffeeEquipment?: [{	data: ValueTypes["DoubleshotCoffeeEquipmentCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDoubleshotCoffeeEquipment?: [{	by: ValueTypes["DoubleshotCoffeeEquipmentUniqueWhere"],	data: ValueTypes["DoubleshotCoffeeEquipmentUpdateInput"]},ValueTypes["_ValidationResult"]],
getExpense?: [{	by: ValueTypes["ExpenseUniqueWhere"],	filter?: ValueTypes["ExpenseWhere"] | undefined | null},ValueTypes["Expense"]],
listExpense?: [{	filter?: ValueTypes["ExpenseWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ExpenseOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Expense"]],
paginateExpense?: [{	filter?: ValueTypes["ExpenseWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ExpenseOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ExpenseConnection"]],
validateCreateExpense?: [{	data: ValueTypes["ExpenseCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateExpense?: [{	by: ValueTypes["ExpenseUniqueWhere"],	data: ValueTypes["ExpenseUpdateInput"]},ValueTypes["_ValidationResult"]],
getExpenseCategory?: [{	by: ValueTypes["ExpenseCategoryUniqueWhere"],	filter?: ValueTypes["ExpenseCategoryWhere"] | undefined | null},ValueTypes["ExpenseCategory"]],
listExpenseCategory?: [{	filter?: ValueTypes["ExpenseCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ExpenseCategoryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ExpenseCategory"]],
paginateExpenseCategory?: [{	filter?: ValueTypes["ExpenseCategoryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ExpenseCategoryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ExpenseCategoryConnection"]],
validateCreateExpenseCategory?: [{	data: ValueTypes["ExpenseCategoryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateExpenseCategory?: [{	by: ValueTypes["ExpenseCategoryUniqueWhere"],	data: ValueTypes["ExpenseCategoryUpdateInput"]},ValueTypes["_ValidationResult"]],
getExpenseChange?: [{	by: ValueTypes["ExpenseChangeUniqueWhere"],	filter?: ValueTypes["ExpenseChangeWhere"] | undefined | null},ValueTypes["ExpenseChange"]],
listExpenseChange?: [{	filter?: ValueTypes["ExpenseChangeWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ExpenseChangeOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ExpenseChange"]],
paginateExpenseChange?: [{	filter?: ValueTypes["ExpenseChangeWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ExpenseChangeOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ExpenseChangeConnection"]],
validateCreateExpenseChange?: [{	data: ValueTypes["ExpenseChangeCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateExpenseChange?: [{	by: ValueTypes["ExpenseChangeUniqueWhere"],	data: ValueTypes["ExpenseChangeUpdateInput"]},ValueTypes["_ValidationResult"]],
getExpenseDocument?: [{	by: ValueTypes["ExpenseDocumentUniqueWhere"],	filter?: ValueTypes["ExpenseDocumentWhere"] | undefined | null},ValueTypes["ExpenseDocument"]],
listExpenseDocument?: [{	filter?: ValueTypes["ExpenseDocumentWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ExpenseDocumentOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ExpenseDocument"]],
paginateExpenseDocument?: [{	filter?: ValueTypes["ExpenseDocumentWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ExpenseDocumentOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ExpenseDocumentConnection"]],
validateCreateExpenseDocument?: [{	data: ValueTypes["ExpenseDocumentCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateExpenseDocument?: [{	by: ValueTypes["ExpenseDocumentUniqueWhere"],	data: ValueTypes["ExpenseDocumentUpdateInput"]},ValueTypes["_ValidationResult"]],
getRevenuePrediction?: [{	by: ValueTypes["RevenuePredictionUniqueWhere"],	filter?: ValueTypes["RevenuePredictionWhere"] | undefined | null},ValueTypes["RevenuePrediction"]],
listRevenuePrediction?: [{	filter?: ValueTypes["RevenuePredictionWhere"] | undefined | null,	orderBy?: Array<ValueTypes["RevenuePredictionOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["RevenuePrediction"]],
paginateRevenuePrediction?: [{	filter?: ValueTypes["RevenuePredictionWhere"] | undefined | null,	orderBy?: Array<ValueTypes["RevenuePredictionOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["RevenuePredictionConnection"]],
validateCreateRevenuePrediction?: [{	data: ValueTypes["RevenuePredictionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateRevenuePrediction?: [{	by: ValueTypes["RevenuePredictionUniqueWhere"],	data: ValueTypes["RevenuePredictionUpdateInput"]},ValueTypes["_ValidationResult"]],
getRevenuePredictionChange?: [{	by: ValueTypes["RevenuePredictionChangeUniqueWhere"],	filter?: ValueTypes["RevenuePredictionChangeWhere"] | undefined | null},ValueTypes["RevenuePredictionChange"]],
listRevenuePredictionChange?: [{	filter?: ValueTypes["RevenuePredictionChangeWhere"] | undefined | null,	orderBy?: Array<ValueTypes["RevenuePredictionChangeOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["RevenuePredictionChange"]],
paginateRevenuePredictionChange?: [{	filter?: ValueTypes["RevenuePredictionChangeWhere"] | undefined | null,	orderBy?: Array<ValueTypes["RevenuePredictionChangeOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["RevenuePredictionChangeConnection"]],
validateCreateRevenuePredictionChange?: [{	data: ValueTypes["RevenuePredictionChangeCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateRevenuePredictionChange?: [{	by: ValueTypes["RevenuePredictionChangeUniqueWhere"],	data: ValueTypes["RevenuePredictionChangeUpdateInput"]},ValueTypes["_ValidationResult"]],
getFile?: [{	by: ValueTypes["FileUniqueWhere"],	filter?: ValueTypes["FileWhere"] | undefined | null},ValueTypes["File"]],
listFile?: [{	filter?: ValueTypes["FileWhere"] | undefined | null,	orderBy?: Array<ValueTypes["FileOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["File"]],
paginateFile?: [{	filter?: ValueTypes["FileWhere"] | undefined | null,	orderBy?: Array<ValueTypes["FileOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["FileConnection"]],
validateCreateFile?: [{	data: ValueTypes["FileCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFile?: [{	by: ValueTypes["FileUniqueWhere"],	data: ValueTypes["FileUpdateInput"]},ValueTypes["_ValidationResult"]],
getExpenseTerm?: [{	by: ValueTypes["ExpenseTermUniqueWhere"],	filter?: ValueTypes["ExpenseTermWhere"] | undefined | null},ValueTypes["ExpenseTerm"]],
listExpenseTerm?: [{	filter?: ValueTypes["ExpenseTermWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ExpenseTermOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["ExpenseTerm"]],
paginateExpenseTerm?: [{	filter?: ValueTypes["ExpenseTermWhere"] | undefined | null,	orderBy?: Array<ValueTypes["ExpenseTermOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["ExpenseTermConnection"]],
getLine?: [{	by: ValueTypes["LineUniqueWhere"],	filter?: ValueTypes["LineWhere"] | undefined | null},ValueTypes["Line"]],
listLine?: [{	filter?: ValueTypes["LineWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LineOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["Line"]],
paginateLine?: [{	filter?: ValueTypes["LineWhere"] | undefined | null,	orderBy?: Array<ValueTypes["LineOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["LineConnection"]],
validateCreateLine?: [{	data: ValueTypes["LineCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLine?: [{	by: ValueTypes["LineUniqueWhere"],	data: ValueTypes["LineUpdateInput"]},ValueTypes["_ValidationResult"]],
getFinancesBalanceItem?: [{	by: ValueTypes["FinancesBalanceItemUniqueWhere"],	filter?: ValueTypes["FinancesBalanceItemWhere"] | undefined | null},ValueTypes["FinancesBalanceItem"]],
listFinancesBalanceItem?: [{	filter?: ValueTypes["FinancesBalanceItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["FinancesBalanceItemOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["FinancesBalanceItem"]],
paginateFinancesBalanceItem?: [{	filter?: ValueTypes["FinancesBalanceItemWhere"] | undefined | null,	orderBy?: Array<ValueTypes["FinancesBalanceItemOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["FinancesBalanceItemConnection"]],
validateCreateFinancesBalanceItem?: [{	data: ValueTypes["FinancesBalanceItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFinancesBalanceItem?: [{	by: ValueTypes["FinancesBalanceItemUniqueWhere"],	data: ValueTypes["FinancesBalanceItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getRevenuePredictionTerm?: [{	by: ValueTypes["RevenuePredictionTermUniqueWhere"],	filter?: ValueTypes["RevenuePredictionTermWhere"] | undefined | null},ValueTypes["RevenuePredictionTerm"]],
listRevenuePredictionTerm?: [{	filter?: ValueTypes["RevenuePredictionTermWhere"] | undefined | null,	orderBy?: Array<ValueTypes["RevenuePredictionTermOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["RevenuePredictionTerm"]],
paginateRevenuePredictionTerm?: [{	filter?: ValueTypes["RevenuePredictionTermWhere"] | undefined | null,	orderBy?: Array<ValueTypes["RevenuePredictionTermOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["RevenuePredictionTermConnection"]],
getOrderPaymentStatsByDay?: [{	by: ValueTypes["OrderPaymentStatsByDayUniqueWhere"],	filter?: ValueTypes["OrderPaymentStatsByDayWhere"] | undefined | null},ValueTypes["OrderPaymentStatsByDay"]],
listOrderPaymentStatsByDay?: [{	filter?: ValueTypes["OrderPaymentStatsByDayWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderPaymentStatsByDayOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["OrderPaymentStatsByDay"]],
paginateOrderPaymentStatsByDay?: [{	filter?: ValueTypes["OrderPaymentStatsByDayWhere"] | undefined | null,	orderBy?: Array<ValueTypes["OrderPaymentStatsByDayOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["OrderPaymentStatsByDayConnection"]],
getWoltDriveDelivery?: [{	by: ValueTypes["WoltDriveDeliveryUniqueWhere"],	filter?: ValueTypes["WoltDriveDeliveryWhere"] | undefined | null},ValueTypes["WoltDriveDelivery"]],
listWoltDriveDelivery?: [{	filter?: ValueTypes["WoltDriveDeliveryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["WoltDriveDeliveryOrderBy"]> | undefined | null,	offset?: number | undefined | null,	limit?: number | undefined | null},ValueTypes["WoltDriveDelivery"]],
paginateWoltDriveDelivery?: [{	filter?: ValueTypes["WoltDriveDeliveryWhere"] | undefined | null,	orderBy?: Array<ValueTypes["WoltDriveDeliveryOrderBy"]> | undefined | null,	skip?: number | undefined | null,	first?: number | undefined | null},ValueTypes["WoltDriveDeliveryConnection"]],
validateCreateWoltDriveDelivery?: [{	data: ValueTypes["WoltDriveDeliveryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateWoltDriveDelivery?: [{	by: ValueTypes["WoltDriveDeliveryUniqueWhere"],	data: ValueTypes["WoltDriveDeliveryUpdateInput"]},ValueTypes["_ValidationResult"]],
		__typename?: boolean | `@${string}`
}>;
	["Info"]: AliasType<{
	description?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Mutation"]: AliasType<{
createAddress?: [{	data: ValueTypes["AddressCreateInput"]},ValueTypes["AddressCreateResult"]],
deleteAddress?: [{	by: ValueTypes["AddressUniqueWhere"],	filter?: ValueTypes["AddressWhere"] | undefined | null},ValueTypes["AddressDeleteResult"]],
updateAddress?: [{	by: ValueTypes["AddressUniqueWhere"],	filter?: ValueTypes["AddressWhere"] | undefined | null,	data: ValueTypes["AddressUpdateInput"]},ValueTypes["AddressUpdateResult"]],
upsertAddress?: [{	by: ValueTypes["AddressUniqueWhere"],	filter?: ValueTypes["AddressWhere"] | undefined | null,	update: ValueTypes["AddressUpdateInput"],	create: ValueTypes["AddressCreateInput"]},ValueTypes["AddressUpsertResult"]],
createCountry?: [{	data: ValueTypes["CountryCreateInput"]},ValueTypes["CountryCreateResult"]],
deleteCountry?: [{	by: ValueTypes["CountryUniqueWhere"],	filter?: ValueTypes["CountryWhere"] | undefined | null},ValueTypes["CountryDeleteResult"]],
updateCountry?: [{	by: ValueTypes["CountryUniqueWhere"],	filter?: ValueTypes["CountryWhere"] | undefined | null,	data: ValueTypes["CountryUpdateInput"]},ValueTypes["CountryUpdateResult"]],
upsertCountry?: [{	by: ValueTypes["CountryUniqueWhere"],	filter?: ValueTypes["CountryWhere"] | undefined | null,	update: ValueTypes["CountryUpdateInput"],	create: ValueTypes["CountryCreateInput"]},ValueTypes["CountryUpsertResult"]],
createChannel?: [{	data: ValueTypes["ChannelCreateInput"]},ValueTypes["ChannelCreateResult"]],
deleteChannel?: [{	by: ValueTypes["ChannelUniqueWhere"],	filter?: ValueTypes["ChannelWhere"] | undefined | null},ValueTypes["ChannelDeleteResult"]],
updateChannel?: [{	by: ValueTypes["ChannelUniqueWhere"],	filter?: ValueTypes["ChannelWhere"] | undefined | null,	data: ValueTypes["ChannelUpdateInput"]},ValueTypes["ChannelUpdateResult"]],
upsertChannel?: [{	by: ValueTypes["ChannelUniqueWhere"],	filter?: ValueTypes["ChannelWhere"] | undefined | null,	update: ValueTypes["ChannelUpdateInput"],	create: ValueTypes["ChannelCreateInput"]},ValueTypes["ChannelUpsertResult"]],
createChannelPayment?: [{	data: ValueTypes["ChannelPaymentCreateInput"]},ValueTypes["ChannelPaymentCreateResult"]],
deleteChannelPayment?: [{	by: ValueTypes["ChannelPaymentUniqueWhere"],	filter?: ValueTypes["ChannelPaymentWhere"] | undefined | null},ValueTypes["ChannelPaymentDeleteResult"]],
updateChannelPayment?: [{	by: ValueTypes["ChannelPaymentUniqueWhere"],	filter?: ValueTypes["ChannelPaymentWhere"] | undefined | null,	data: ValueTypes["ChannelPaymentUpdateInput"]},ValueTypes["ChannelPaymentUpdateResult"]],
upsertChannelPayment?: [{	by: ValueTypes["ChannelPaymentUniqueWhere"],	filter?: ValueTypes["ChannelPaymentWhere"] | undefined | null,	update: ValueTypes["ChannelPaymentUpdateInput"],	create: ValueTypes["ChannelPaymentCreateInput"]},ValueTypes["ChannelPaymentUpsertResult"]],
createChannelDelivery?: [{	data: ValueTypes["ChannelDeliveryCreateInput"]},ValueTypes["ChannelDeliveryCreateResult"]],
deleteChannelDelivery?: [{	by: ValueTypes["ChannelDeliveryUniqueWhere"],	filter?: ValueTypes["ChannelDeliveryWhere"] | undefined | null},ValueTypes["ChannelDeliveryDeleteResult"]],
updateChannelDelivery?: [{	by: ValueTypes["ChannelDeliveryUniqueWhere"],	filter?: ValueTypes["ChannelDeliveryWhere"] | undefined | null,	data: ValueTypes["ChannelDeliveryUpdateInput"]},ValueTypes["ChannelDeliveryUpdateResult"]],
upsertChannelDelivery?: [{	by: ValueTypes["ChannelDeliveryUniqueWhere"],	filter?: ValueTypes["ChannelDeliveryWhere"] | undefined | null,	update: ValueTypes["ChannelDeliveryUpdateInput"],	create: ValueTypes["ChannelDeliveryCreateInput"]},ValueTypes["ChannelDeliveryUpsertResult"]],
createCustomer?: [{	data: ValueTypes["CustomerCreateInput"]},ValueTypes["CustomerCreateResult"]],
deleteCustomer?: [{	by: ValueTypes["CustomerUniqueWhere"],	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["CustomerDeleteResult"]],
updateCustomer?: [{	by: ValueTypes["CustomerUniqueWhere"],	filter?: ValueTypes["CustomerWhere"] | undefined | null,	data: ValueTypes["CustomerUpdateInput"]},ValueTypes["CustomerUpdateResult"]],
upsertCustomer?: [{	by: ValueTypes["CustomerUniqueWhere"],	filter?: ValueTypes["CustomerWhere"] | undefined | null,	update: ValueTypes["CustomerUpdateInput"],	create: ValueTypes["CustomerCreateInput"]},ValueTypes["CustomerUpsertResult"]],
createCustomerCredit?: [{	data: ValueTypes["CustomerCreditCreateInput"]},ValueTypes["CustomerCreditCreateResult"]],
deleteCustomerCredit?: [{	by: ValueTypes["CustomerCreditUniqueWhere"],	filter?: ValueTypes["CustomerCreditWhere"] | undefined | null},ValueTypes["CustomerCreditDeleteResult"]],
updateCustomerCredit?: [{	by: ValueTypes["CustomerCreditUniqueWhere"],	filter?: ValueTypes["CustomerCreditWhere"] | undefined | null,	data: ValueTypes["CustomerCreditUpdateInput"]},ValueTypes["CustomerCreditUpdateResult"]],
upsertCustomerCredit?: [{	by: ValueTypes["CustomerCreditUniqueWhere"],	filter?: ValueTypes["CustomerCreditWhere"] | undefined | null,	update: ValueTypes["CustomerCreditUpdateInput"],	create: ValueTypes["CustomerCreditCreateInput"]},ValueTypes["CustomerCreditUpsertResult"]],
createCustomerGroup?: [{	data: ValueTypes["CustomerGroupCreateInput"]},ValueTypes["CustomerGroupCreateResult"]],
deleteCustomerGroup?: [{	by: ValueTypes["CustomerGroupUniqueWhere"],	filter?: ValueTypes["CustomerGroupWhere"] | undefined | null},ValueTypes["CustomerGroupDeleteResult"]],
updateCustomerGroup?: [{	by: ValueTypes["CustomerGroupUniqueWhere"],	filter?: ValueTypes["CustomerGroupWhere"] | undefined | null,	data: ValueTypes["CustomerGroupUpdateInput"]},ValueTypes["CustomerGroupUpdateResult"]],
upsertCustomerGroup?: [{	by: ValueTypes["CustomerGroupUniqueWhere"],	filter?: ValueTypes["CustomerGroupWhere"] | undefined | null,	update: ValueTypes["CustomerGroupUpdateInput"],	create: ValueTypes["CustomerGroupCreateInput"]},ValueTypes["CustomerGroupUpsertResult"]],
createCustomerPaymentMethod?: [{	data: ValueTypes["CustomerPaymentMethodCreateInput"]},ValueTypes["CustomerPaymentMethodCreateResult"]],
deleteCustomerPaymentMethod?: [{	by: ValueTypes["CustomerPaymentMethodUniqueWhere"],	filter?: ValueTypes["CustomerPaymentMethodWhere"] | undefined | null},ValueTypes["CustomerPaymentMethodDeleteResult"]],
updateCustomerPaymentMethod?: [{	by: ValueTypes["CustomerPaymentMethodUniqueWhere"],	filter?: ValueTypes["CustomerPaymentMethodWhere"] | undefined | null,	data: ValueTypes["CustomerPaymentMethodUpdateInput"]},ValueTypes["CustomerPaymentMethodUpdateResult"]],
upsertCustomerPaymentMethod?: [{	by: ValueTypes["CustomerPaymentMethodUniqueWhere"],	filter?: ValueTypes["CustomerPaymentMethodWhere"] | undefined | null,	update: ValueTypes["CustomerPaymentMethodUpdateInput"],	create: ValueTypes["CustomerPaymentMethodCreateInput"]},ValueTypes["CustomerPaymentMethodUpsertResult"]],
createDeliveryMethod?: [{	data: ValueTypes["DeliveryMethodCreateInput"]},ValueTypes["DeliveryMethodCreateResult"]],
deleteDeliveryMethod?: [{	by: ValueTypes["DeliveryMethodUniqueWhere"],	filter?: ValueTypes["DeliveryMethodWhere"] | undefined | null},ValueTypes["DeliveryMethodDeleteResult"]],
updateDeliveryMethod?: [{	by: ValueTypes["DeliveryMethodUniqueWhere"],	filter?: ValueTypes["DeliveryMethodWhere"] | undefined | null,	data: ValueTypes["DeliveryMethodUpdateInput"]},ValueTypes["DeliveryMethodUpdateResult"]],
upsertDeliveryMethod?: [{	by: ValueTypes["DeliveryMethodUniqueWhere"],	filter?: ValueTypes["DeliveryMethodWhere"] | undefined | null,	update: ValueTypes["DeliveryMethodUpdateInput"],	create: ValueTypes["DeliveryMethodCreateInput"]},ValueTypes["DeliveryMethodUpsertResult"]],
createOrder?: [{	data: ValueTypes["OrderCreateInput"]},ValueTypes["OrderCreateResult"]],
deleteOrder?: [{	by: ValueTypes["OrderUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["OrderDeleteResult"]],
updateOrder?: [{	by: ValueTypes["OrderUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null,	data: ValueTypes["OrderUpdateInput"]},ValueTypes["OrderUpdateResult"]],
upsertOrder?: [{	by: ValueTypes["OrderUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null,	update: ValueTypes["OrderUpdateInput"],	create: ValueTypes["OrderCreateInput"]},ValueTypes["OrderUpsertResult"]],
createOrderDiscount?: [{	data: ValueTypes["OrderDiscountCreateInput"]},ValueTypes["OrderDiscountCreateResult"]],
deleteOrderDiscount?: [{	by: ValueTypes["OrderDiscountUniqueWhere"],	filter?: ValueTypes["OrderDiscountWhere"] | undefined | null},ValueTypes["OrderDiscountDeleteResult"]],
updateOrderDiscount?: [{	by: ValueTypes["OrderDiscountUniqueWhere"],	filter?: ValueTypes["OrderDiscountWhere"] | undefined | null,	data: ValueTypes["OrderDiscountUpdateInput"]},ValueTypes["OrderDiscountUpdateResult"]],
upsertOrderDiscount?: [{	by: ValueTypes["OrderDiscountUniqueWhere"],	filter?: ValueTypes["OrderDiscountWhere"] | undefined | null,	update: ValueTypes["OrderDiscountUpdateInput"],	create: ValueTypes["OrderDiscountCreateInput"]},ValueTypes["OrderDiscountUpsertResult"]],
createOrderPayment?: [{	data: ValueTypes["OrderPaymentCreateInput"]},ValueTypes["OrderPaymentCreateResult"]],
deleteOrderPayment?: [{	by: ValueTypes["OrderPaymentUniqueWhere"],	filter?: ValueTypes["OrderPaymentWhere"] | undefined | null},ValueTypes["OrderPaymentDeleteResult"]],
updateOrderPayment?: [{	by: ValueTypes["OrderPaymentUniqueWhere"],	filter?: ValueTypes["OrderPaymentWhere"] | undefined | null,	data: ValueTypes["OrderPaymentUpdateInput"]},ValueTypes["OrderPaymentUpdateResult"]],
upsertOrderPayment?: [{	by: ValueTypes["OrderPaymentUniqueWhere"],	filter?: ValueTypes["OrderPaymentWhere"] | undefined | null,	update: ValueTypes["OrderPaymentUpdateInput"],	create: ValueTypes["OrderPaymentCreateInput"]},ValueTypes["OrderPaymentUpsertResult"]],
createOrderDelivery?: [{	data: ValueTypes["OrderDeliveryCreateInput"]},ValueTypes["OrderDeliveryCreateResult"]],
deleteOrderDelivery?: [{	by: ValueTypes["OrderDeliveryUniqueWhere"],	filter?: ValueTypes["OrderDeliveryWhere"] | undefined | null},ValueTypes["OrderDeliveryDeleteResult"]],
updateOrderDelivery?: [{	by: ValueTypes["OrderDeliveryUniqueWhere"],	filter?: ValueTypes["OrderDeliveryWhere"] | undefined | null,	data: ValueTypes["OrderDeliveryUpdateInput"]},ValueTypes["OrderDeliveryUpdateResult"]],
upsertOrderDelivery?: [{	by: ValueTypes["OrderDeliveryUniqueWhere"],	filter?: ValueTypes["OrderDeliveryWhere"] | undefined | null,	update: ValueTypes["OrderDeliveryUpdateInput"],	create: ValueTypes["OrderDeliveryCreateInput"]},ValueTypes["OrderDeliveryUpsertResult"]],
createOrderItem?: [{	data: ValueTypes["OrderItemCreateInput"]},ValueTypes["OrderItemCreateResult"]],
deleteOrderItem?: [{	by: ValueTypes["OrderItemUniqueWhere"],	filter?: ValueTypes["OrderItemWhere"] | undefined | null},ValueTypes["OrderItemDeleteResult"]],
updateOrderItem?: [{	by: ValueTypes["OrderItemUniqueWhere"],	filter?: ValueTypes["OrderItemWhere"] | undefined | null,	data: ValueTypes["OrderItemUpdateInput"]},ValueTypes["OrderItemUpdateResult"]],
upsertOrderItem?: [{	by: ValueTypes["OrderItemUniqueWhere"],	filter?: ValueTypes["OrderItemWhere"] | undefined | null,	update: ValueTypes["OrderItemUpdateInput"],	create: ValueTypes["OrderItemCreateInput"]},ValueTypes["OrderItemUpsertResult"]],
createPaymentMethod?: [{	data: ValueTypes["PaymentMethodCreateInput"]},ValueTypes["PaymentMethodCreateResult"]],
deletePaymentMethod?: [{	by: ValueTypes["PaymentMethodUniqueWhere"],	filter?: ValueTypes["PaymentMethodWhere"] | undefined | null},ValueTypes["PaymentMethodDeleteResult"]],
updatePaymentMethod?: [{	by: ValueTypes["PaymentMethodUniqueWhere"],	filter?: ValueTypes["PaymentMethodWhere"] | undefined | null,	data: ValueTypes["PaymentMethodUpdateInput"]},ValueTypes["PaymentMethodUpdateResult"]],
upsertPaymentMethod?: [{	by: ValueTypes["PaymentMethodUniqueWhere"],	filter?: ValueTypes["PaymentMethodWhere"] | undefined | null,	update: ValueTypes["PaymentMethodUpdateInput"],	create: ValueTypes["PaymentMethodCreateInput"]},ValueTypes["PaymentMethodUpsertResult"]],
createVatRate?: [{	data: ValueTypes["VatRateCreateInput"]},ValueTypes["VatRateCreateResult"]],
deleteVatRate?: [{	by: ValueTypes["VatRateUniqueWhere"],	filter?: ValueTypes["VatRateWhere"] | undefined | null},ValueTypes["VatRateDeleteResult"]],
updateVatRate?: [{	by: ValueTypes["VatRateUniqueWhere"],	filter?: ValueTypes["VatRateWhere"] | undefined | null,	data: ValueTypes["VatRateUpdateInput"]},ValueTypes["VatRateUpdateResult"]],
upsertVatRate?: [{	by: ValueTypes["VatRateUniqueWhere"],	filter?: ValueTypes["VatRateWhere"] | undefined | null,	update: ValueTypes["VatRateUpdateInput"],	create: ValueTypes["VatRateCreateInput"]},ValueTypes["VatRateUpsertResult"]],
createProduct?: [{	data: ValueTypes["ProductCreateInput"]},ValueTypes["ProductCreateResult"]],
deleteProduct?: [{	by: ValueTypes["ProductUniqueWhere"],	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["ProductDeleteResult"]],
updateProduct?: [{	by: ValueTypes["ProductUniqueWhere"],	filter?: ValueTypes["ProductWhere"] | undefined | null,	data: ValueTypes["ProductUpdateInput"]},ValueTypes["ProductUpdateResult"]],
upsertProduct?: [{	by: ValueTypes["ProductUniqueWhere"],	filter?: ValueTypes["ProductWhere"] | undefined | null,	update: ValueTypes["ProductUpdateInput"],	create: ValueTypes["ProductCreateInput"]},ValueTypes["ProductUpsertResult"]],
createProductStock?: [{	data: ValueTypes["ProductStockCreateInput"]},ValueTypes["ProductStockCreateResult"]],
deleteProductStock?: [{	by: ValueTypes["ProductStockUniqueWhere"],	filter?: ValueTypes["ProductStockWhere"] | undefined | null},ValueTypes["ProductStockDeleteResult"]],
updateProductStock?: [{	by: ValueTypes["ProductStockUniqueWhere"],	filter?: ValueTypes["ProductStockWhere"] | undefined | null,	data: ValueTypes["ProductStockUpdateInput"]},ValueTypes["ProductStockUpdateResult"]],
upsertProductStock?: [{	by: ValueTypes["ProductStockUniqueWhere"],	filter?: ValueTypes["ProductStockWhere"] | undefined | null,	update: ValueTypes["ProductStockUpdateInput"],	create: ValueTypes["ProductStockCreateInput"]},ValueTypes["ProductStockUpsertResult"]],
createProductPacking?: [{	data: ValueTypes["ProductPackingCreateInput"]},ValueTypes["ProductPackingCreateResult"]],
deleteProductPacking?: [{	by: ValueTypes["ProductPackingUniqueWhere"],	filter?: ValueTypes["ProductPackingWhere"] | undefined | null},ValueTypes["ProductPackingDeleteResult"]],
updateProductPacking?: [{	by: ValueTypes["ProductPackingUniqueWhere"],	filter?: ValueTypes["ProductPackingWhere"] | undefined | null,	data: ValueTypes["ProductPackingUpdateInput"]},ValueTypes["ProductPackingUpdateResult"]],
upsertProductPacking?: [{	by: ValueTypes["ProductPackingUniqueWhere"],	filter?: ValueTypes["ProductPackingWhere"] | undefined | null,	update: ValueTypes["ProductPackingUpdateInput"],	create: ValueTypes["ProductPackingCreateInput"]},ValueTypes["ProductPackingUpsertResult"]],
createProductGroupPrice?: [{	data: ValueTypes["ProductGroupPriceCreateInput"]},ValueTypes["ProductGroupPriceCreateResult"]],
deleteProductGroupPrice?: [{	by: ValueTypes["ProductGroupPriceUniqueWhere"],	filter?: ValueTypes["ProductGroupPriceWhere"] | undefined | null},ValueTypes["ProductGroupPriceDeleteResult"]],
updateProductGroupPrice?: [{	by: ValueTypes["ProductGroupPriceUniqueWhere"],	filter?: ValueTypes["ProductGroupPriceWhere"] | undefined | null,	data: ValueTypes["ProductGroupPriceUpdateInput"]},ValueTypes["ProductGroupPriceUpdateResult"]],
upsertProductGroupPrice?: [{	by: ValueTypes["ProductGroupPriceUniqueWhere"],	filter?: ValueTypes["ProductGroupPriceWhere"] | undefined | null,	update: ValueTypes["ProductGroupPriceUpdateInput"],	create: ValueTypes["ProductGroupPriceCreateInput"]},ValueTypes["ProductGroupPriceUpsertResult"]],
createProductRecipe?: [{	data: ValueTypes["ProductRecipeCreateInput"]},ValueTypes["ProductRecipeCreateResult"]],
deleteProductRecipe?: [{	by: ValueTypes["ProductRecipeUniqueWhere"],	filter?: ValueTypes["ProductRecipeWhere"] | undefined | null},ValueTypes["ProductRecipeDeleteResult"]],
updateProductRecipe?: [{	by: ValueTypes["ProductRecipeUniqueWhere"],	filter?: ValueTypes["ProductRecipeWhere"] | undefined | null,	data: ValueTypes["ProductRecipeUpdateInput"]},ValueTypes["ProductRecipeUpdateResult"]],
upsertProductRecipe?: [{	by: ValueTypes["ProductRecipeUniqueWhere"],	filter?: ValueTypes["ProductRecipeWhere"] | undefined | null,	update: ValueTypes["ProductRecipeUpdateInput"],	create: ValueTypes["ProductRecipeCreateInput"]},ValueTypes["ProductRecipeUpsertResult"]],
createProductCategory?: [{	data: ValueTypes["ProductCategoryCreateInput"]},ValueTypes["ProductCategoryCreateResult"]],
deleteProductCategory?: [{	by: ValueTypes["ProductCategoryUniqueWhere"],	filter?: ValueTypes["ProductCategoryWhere"] | undefined | null},ValueTypes["ProductCategoryDeleteResult"]],
updateProductCategory?: [{	by: ValueTypes["ProductCategoryUniqueWhere"],	filter?: ValueTypes["ProductCategoryWhere"] | undefined | null,	data: ValueTypes["ProductCategoryUpdateInput"]},ValueTypes["ProductCategoryUpdateResult"]],
upsertProductCategory?: [{	by: ValueTypes["ProductCategoryUniqueWhere"],	filter?: ValueTypes["ProductCategoryWhere"] | undefined | null,	update: ValueTypes["ProductCategoryUpdateInput"],	create: ValueTypes["ProductCategoryCreateInput"]},ValueTypes["ProductCategoryUpsertResult"]],
createStore?: [{	data: ValueTypes["StoreCreateInput"]},ValueTypes["StoreCreateResult"]],
deleteStore?: [{	by: ValueTypes["StoreUniqueWhere"],	filter?: ValueTypes["StoreWhere"] | undefined | null},ValueTypes["StoreDeleteResult"]],
updateStore?: [{	by: ValueTypes["StoreUniqueWhere"],	filter?: ValueTypes["StoreWhere"] | undefined | null,	data: ValueTypes["StoreUpdateInput"]},ValueTypes["StoreUpdateResult"]],
upsertStore?: [{	by: ValueTypes["StoreUniqueWhere"],	filter?: ValueTypes["StoreWhere"] | undefined | null,	update: ValueTypes["StoreUpdateInput"],	create: ValueTypes["StoreCreateInput"]},ValueTypes["StoreUpsertResult"]],
createTag?: [{	data: ValueTypes["TagCreateInput"]},ValueTypes["TagCreateResult"]],
deleteTag?: [{	by: ValueTypes["TagUniqueWhere"],	filter?: ValueTypes["TagWhere"] | undefined | null},ValueTypes["TagDeleteResult"]],
updateTag?: [{	by: ValueTypes["TagUniqueWhere"],	filter?: ValueTypes["TagWhere"] | undefined | null,	data: ValueTypes["TagUpdateInput"]},ValueTypes["TagUpdateResult"]],
upsertTag?: [{	by: ValueTypes["TagUniqueWhere"],	filter?: ValueTypes["TagWhere"] | undefined | null,	update: ValueTypes["TagUpdateInput"],	create: ValueTypes["TagCreateInput"]},ValueTypes["TagUpsertResult"]],
createImage?: [{	data: ValueTypes["ImageCreateInput"]},ValueTypes["ImageCreateResult"]],
deleteImage?: [{	by: ValueTypes["ImageUniqueWhere"],	filter?: ValueTypes["ImageWhere"] | undefined | null},ValueTypes["ImageDeleteResult"]],
updateImage?: [{	by: ValueTypes["ImageUniqueWhere"],	filter?: ValueTypes["ImageWhere"] | undefined | null,	data: ValueTypes["ImageUpdateInput"]},ValueTypes["ImageUpdateResult"]],
upsertImage?: [{	by: ValueTypes["ImageUniqueWhere"],	filter?: ValueTypes["ImageWhere"] | undefined | null,	update: ValueTypes["ImageUpdateInput"],	create: ValueTypes["ImageCreateInput"]},ValueTypes["ImageUpsertResult"]],
createBusinessCategory?: [{	data: ValueTypes["BusinessCategoryCreateInput"]},ValueTypes["BusinessCategoryCreateResult"]],
deleteBusinessCategory?: [{	by: ValueTypes["BusinessCategoryUniqueWhere"],	filter?: ValueTypes["BusinessCategoryWhere"] | undefined | null},ValueTypes["BusinessCategoryDeleteResult"]],
updateBusinessCategory?: [{	by: ValueTypes["BusinessCategoryUniqueWhere"],	filter?: ValueTypes["BusinessCategoryWhere"] | undefined | null,	data: ValueTypes["BusinessCategoryUpdateInput"]},ValueTypes["BusinessCategoryUpdateResult"]],
upsertBusinessCategory?: [{	by: ValueTypes["BusinessCategoryUniqueWhere"],	filter?: ValueTypes["BusinessCategoryWhere"] | undefined | null,	update: ValueTypes["BusinessCategoryUpdateInput"],	create: ValueTypes["BusinessCategoryCreateInput"]},ValueTypes["BusinessCategoryUpsertResult"]],
createProductList?: [{	data: ValueTypes["ProductListCreateInput"]},ValueTypes["ProductListCreateResult"]],
deleteProductList?: [{	by: ValueTypes["ProductListUniqueWhere"],	filter?: ValueTypes["ProductListWhere"] | undefined | null},ValueTypes["ProductListDeleteResult"]],
updateProductList?: [{	by: ValueTypes["ProductListUniqueWhere"],	filter?: ValueTypes["ProductListWhere"] | undefined | null,	data: ValueTypes["ProductListUpdateInput"]},ValueTypes["ProductListUpdateResult"]],
upsertProductList?: [{	by: ValueTypes["ProductListUniqueWhere"],	filter?: ValueTypes["ProductListWhere"] | undefined | null,	update: ValueTypes["ProductListUpdateInput"],	create: ValueTypes["ProductListCreateInput"]},ValueTypes["ProductListUpsertResult"]],
createProductListItem?: [{	data: ValueTypes["ProductListItemCreateInput"]},ValueTypes["ProductListItemCreateResult"]],
deleteProductListItem?: [{	by: ValueTypes["ProductListItemUniqueWhere"],	filter?: ValueTypes["ProductListItemWhere"] | undefined | null},ValueTypes["ProductListItemDeleteResult"]],
updateProductListItem?: [{	by: ValueTypes["ProductListItemUniqueWhere"],	filter?: ValueTypes["ProductListItemWhere"] | undefined | null,	data: ValueTypes["ProductListItemUpdateInput"]},ValueTypes["ProductListItemUpdateResult"]],
upsertProductListItem?: [{	by: ValueTypes["ProductListItemUniqueWhere"],	filter?: ValueTypes["ProductListItemWhere"] | undefined | null,	update: ValueTypes["ProductListItemUpdateInput"],	create: ValueTypes["ProductListItemCreateInput"]},ValueTypes["ProductListItemUpsertResult"]],
createProductCategoryList?: [{	data: ValueTypes["ProductCategoryListCreateInput"]},ValueTypes["ProductCategoryListCreateResult"]],
deleteProductCategoryList?: [{	by: ValueTypes["ProductCategoryListUniqueWhere"],	filter?: ValueTypes["ProductCategoryListWhere"] | undefined | null},ValueTypes["ProductCategoryListDeleteResult"]],
updateProductCategoryList?: [{	by: ValueTypes["ProductCategoryListUniqueWhere"],	filter?: ValueTypes["ProductCategoryListWhere"] | undefined | null,	data: ValueTypes["ProductCategoryListUpdateInput"]},ValueTypes["ProductCategoryListUpdateResult"]],
upsertProductCategoryList?: [{	by: ValueTypes["ProductCategoryListUniqueWhere"],	filter?: ValueTypes["ProductCategoryListWhere"] | undefined | null,	update: ValueTypes["ProductCategoryListUpdateInput"],	create: ValueTypes["ProductCategoryListCreateInput"]},ValueTypes["ProductCategoryListUpsertResult"]],
createProductCategoryListItem?: [{	data: ValueTypes["ProductCategoryListItemCreateInput"]},ValueTypes["ProductCategoryListItemCreateResult"]],
deleteProductCategoryListItem?: [{	by: ValueTypes["ProductCategoryListItemUniqueWhere"],	filter?: ValueTypes["ProductCategoryListItemWhere"] | undefined | null},ValueTypes["ProductCategoryListItemDeleteResult"]],
updateProductCategoryListItem?: [{	by: ValueTypes["ProductCategoryListItemUniqueWhere"],	filter?: ValueTypes["ProductCategoryListItemWhere"] | undefined | null,	data: ValueTypes["ProductCategoryListItemUpdateInput"]},ValueTypes["ProductCategoryListItemUpdateResult"]],
upsertProductCategoryListItem?: [{	by: ValueTypes["ProductCategoryListItemUniqueWhere"],	filter?: ValueTypes["ProductCategoryListItemWhere"] | undefined | null,	update: ValueTypes["ProductCategoryListItemUpdateInput"],	create: ValueTypes["ProductCategoryListItemCreateInput"]},ValueTypes["ProductCategoryListItemUpsertResult"]],
createBusinessCategoryLocale?: [{	data: ValueTypes["BusinessCategoryLocaleCreateInput"]},ValueTypes["BusinessCategoryLocaleCreateResult"]],
deleteBusinessCategoryLocale?: [{	by: ValueTypes["BusinessCategoryLocaleUniqueWhere"],	filter?: ValueTypes["BusinessCategoryLocaleWhere"] | undefined | null},ValueTypes["BusinessCategoryLocaleDeleteResult"]],
updateBusinessCategoryLocale?: [{	by: ValueTypes["BusinessCategoryLocaleUniqueWhere"],	filter?: ValueTypes["BusinessCategoryLocaleWhere"] | undefined | null,	data: ValueTypes["BusinessCategoryLocaleUpdateInput"]},ValueTypes["BusinessCategoryLocaleUpdateResult"]],
upsertBusinessCategoryLocale?: [{	by: ValueTypes["BusinessCategoryLocaleUniqueWhere"],	filter?: ValueTypes["BusinessCategoryLocaleWhere"] | undefined | null,	update: ValueTypes["BusinessCategoryLocaleUpdateInput"],	create: ValueTypes["BusinessCategoryLocaleCreateInput"]},ValueTypes["BusinessCategoryLocaleUpsertResult"]],
createLocale?: [{	data: ValueTypes["LocaleCreateInput"]},ValueTypes["LocaleCreateResult"]],
deleteLocale?: [{	by: ValueTypes["LocaleUniqueWhere"],	filter?: ValueTypes["LocaleWhere"] | undefined | null},ValueTypes["LocaleDeleteResult"]],
updateLocale?: [{	by: ValueTypes["LocaleUniqueWhere"],	filter?: ValueTypes["LocaleWhere"] | undefined | null,	data: ValueTypes["LocaleUpdateInput"]},ValueTypes["LocaleUpdateResult"]],
upsertLocale?: [{	by: ValueTypes["LocaleUniqueWhere"],	filter?: ValueTypes["LocaleWhere"] | undefined | null,	update: ValueTypes["LocaleUpdateInput"],	create: ValueTypes["LocaleCreateInput"]},ValueTypes["LocaleUpsertResult"]],
createProductCategoryListLocale?: [{	data: ValueTypes["ProductCategoryListLocaleCreateInput"]},ValueTypes["ProductCategoryListLocaleCreateResult"]],
deleteProductCategoryListLocale?: [{	by: ValueTypes["ProductCategoryListLocaleUniqueWhere"],	filter?: ValueTypes["ProductCategoryListLocaleWhere"] | undefined | null},ValueTypes["ProductCategoryListLocaleDeleteResult"]],
updateProductCategoryListLocale?: [{	by: ValueTypes["ProductCategoryListLocaleUniqueWhere"],	filter?: ValueTypes["ProductCategoryListLocaleWhere"] | undefined | null,	data: ValueTypes["ProductCategoryListLocaleUpdateInput"]},ValueTypes["ProductCategoryListLocaleUpdateResult"]],
upsertProductCategoryListLocale?: [{	by: ValueTypes["ProductCategoryListLocaleUniqueWhere"],	filter?: ValueTypes["ProductCategoryListLocaleWhere"] | undefined | null,	update: ValueTypes["ProductCategoryListLocaleUpdateInput"],	create: ValueTypes["ProductCategoryListLocaleCreateInput"]},ValueTypes["ProductCategoryListLocaleUpsertResult"]],
createCustomerName?: [{	data: ValueTypes["CustomerNameCreateInput"]},ValueTypes["CustomerNameCreateResult"]],
deleteCustomerName?: [{	by: ValueTypes["CustomerNameUniqueWhere"],	filter?: ValueTypes["CustomerNameWhere"] | undefined | null},ValueTypes["CustomerNameDeleteResult"]],
updateCustomerName?: [{	by: ValueTypes["CustomerNameUniqueWhere"],	filter?: ValueTypes["CustomerNameWhere"] | undefined | null,	data: ValueTypes["CustomerNameUpdateInput"]},ValueTypes["CustomerNameUpdateResult"]],
upsertCustomerName?: [{	by: ValueTypes["CustomerNameUniqueWhere"],	filter?: ValueTypes["CustomerNameWhere"] | undefined | null,	update: ValueTypes["CustomerNameUpdateInput"],	create: ValueTypes["CustomerNameCreateInput"]},ValueTypes["CustomerNameUpsertResult"]],
createCustomerAlias?: [{	data: ValueTypes["CustomerAliasCreateInput"]},ValueTypes["CustomerAliasCreateResult"]],
deleteCustomerAlias?: [{	by: ValueTypes["CustomerAliasUniqueWhere"],	filter?: ValueTypes["CustomerAliasWhere"] | undefined | null},ValueTypes["CustomerAliasDeleteResult"]],
updateCustomerAlias?: [{	by: ValueTypes["CustomerAliasUniqueWhere"],	filter?: ValueTypes["CustomerAliasWhere"] | undefined | null,	data: ValueTypes["CustomerAliasUpdateInput"]},ValueTypes["CustomerAliasUpdateResult"]],
upsertCustomerAlias?: [{	by: ValueTypes["CustomerAliasUniqueWhere"],	filter?: ValueTypes["CustomerAliasWhere"] | undefined | null,	update: ValueTypes["CustomerAliasUpdateInput"],	create: ValueTypes["CustomerAliasCreateInput"]},ValueTypes["CustomerAliasUpsertResult"]],
createProductIngredientItem?: [{	data: ValueTypes["ProductIngredientItemCreateInput"]},ValueTypes["ProductIngredientItemCreateResult"]],
deleteProductIngredientItem?: [{	by: ValueTypes["ProductIngredientItemUniqueWhere"],	filter?: ValueTypes["ProductIngredientItemWhere"] | undefined | null},ValueTypes["ProductIngredientItemDeleteResult"]],
updateProductIngredientItem?: [{	by: ValueTypes["ProductIngredientItemUniqueWhere"],	filter?: ValueTypes["ProductIngredientItemWhere"] | undefined | null,	data: ValueTypes["ProductIngredientItemUpdateInput"]},ValueTypes["ProductIngredientItemUpdateResult"]],
upsertProductIngredientItem?: [{	by: ValueTypes["ProductIngredientItemUniqueWhere"],	filter?: ValueTypes["ProductIngredientItemWhere"] | undefined | null,	update: ValueTypes["ProductIngredientItemUpdateInput"],	create: ValueTypes["ProductIngredientItemCreateInput"]},ValueTypes["ProductIngredientItemUpsertResult"]],
createProductIngredientItemQuantity?: [{	data: ValueTypes["ProductIngredientItemQuantityCreateInput"]},ValueTypes["ProductIngredientItemQuantityCreateResult"]],
deleteProductIngredientItemQuantity?: [{	by: ValueTypes["ProductIngredientItemQuantityUniqueWhere"],	filter?: ValueTypes["ProductIngredientItemQuantityWhere"] | undefined | null},ValueTypes["ProductIngredientItemQuantityDeleteResult"]],
updateProductIngredientItemQuantity?: [{	by: ValueTypes["ProductIngredientItemQuantityUniqueWhere"],	filter?: ValueTypes["ProductIngredientItemQuantityWhere"] | undefined | null,	data: ValueTypes["ProductIngredientItemQuantityUpdateInput"]},ValueTypes["ProductIngredientItemQuantityUpdateResult"]],
upsertProductIngredientItemQuantity?: [{	by: ValueTypes["ProductIngredientItemQuantityUniqueWhere"],	filter?: ValueTypes["ProductIngredientItemQuantityWhere"] | undefined | null,	update: ValueTypes["ProductIngredientItemQuantityUpdateInput"],	create: ValueTypes["ProductIngredientItemQuantityCreateInput"]},ValueTypes["ProductIngredientItemQuantityUpsertResult"]],
createProductIngredientItemQuantityUnit?: [{	data: ValueTypes["ProductIngredientItemQuantityUnitCreateInput"]},ValueTypes["ProductIngredientItemQuantityUnitCreateResult"]],
deleteProductIngredientItemQuantityUnit?: [{	by: ValueTypes["ProductIngredientItemQuantityUnitUniqueWhere"],	filter?: ValueTypes["ProductIngredientItemQuantityUnitWhere"] | undefined | null},ValueTypes["ProductIngredientItemQuantityUnitDeleteResult"]],
updateProductIngredientItemQuantityUnit?: [{	by: ValueTypes["ProductIngredientItemQuantityUnitUniqueWhere"],	filter?: ValueTypes["ProductIngredientItemQuantityUnitWhere"] | undefined | null,	data: ValueTypes["ProductIngredientItemQuantityUnitUpdateInput"]},ValueTypes["ProductIngredientItemQuantityUnitUpdateResult"]],
upsertProductIngredientItemQuantityUnit?: [{	by: ValueTypes["ProductIngredientItemQuantityUnitUniqueWhere"],	filter?: ValueTypes["ProductIngredientItemQuantityUnitWhere"] | undefined | null,	update: ValueTypes["ProductIngredientItemQuantityUnitUpdateInput"],	create: ValueTypes["ProductIngredientItemQuantityUnitCreateInput"]},ValueTypes["ProductIngredientItemQuantityUnitUpsertResult"]],
createProductIngredient?: [{	data: ValueTypes["ProductIngredientCreateInput"]},ValueTypes["ProductIngredientCreateResult"]],
deleteProductIngredient?: [{	by: ValueTypes["ProductIngredientUniqueWhere"],	filter?: ValueTypes["ProductIngredientWhere"] | undefined | null},ValueTypes["ProductIngredientDeleteResult"]],
updateProductIngredient?: [{	by: ValueTypes["ProductIngredientUniqueWhere"],	filter?: ValueTypes["ProductIngredientWhere"] | undefined | null,	data: ValueTypes["ProductIngredientUpdateInput"]},ValueTypes["ProductIngredientUpdateResult"]],
upsertProductIngredient?: [{	by: ValueTypes["ProductIngredientUniqueWhere"],	filter?: ValueTypes["ProductIngredientWhere"] | undefined | null,	update: ValueTypes["ProductIngredientUpdateInput"],	create: ValueTypes["ProductIngredientCreateInput"]},ValueTypes["ProductIngredientUpsertResult"]],
createCustomerIngredientRating?: [{	data: ValueTypes["CustomerIngredientRatingCreateInput"]},ValueTypes["CustomerIngredientRatingCreateResult"]],
deleteCustomerIngredientRating?: [{	by: ValueTypes["CustomerIngredientRatingUniqueWhere"],	filter?: ValueTypes["CustomerIngredientRatingWhere"] | undefined | null},ValueTypes["CustomerIngredientRatingDeleteResult"]],
updateCustomerIngredientRating?: [{	by: ValueTypes["CustomerIngredientRatingUniqueWhere"],	filter?: ValueTypes["CustomerIngredientRatingWhere"] | undefined | null,	data: ValueTypes["CustomerIngredientRatingUpdateInput"]},ValueTypes["CustomerIngredientRatingUpdateResult"]],
upsertCustomerIngredientRating?: [{	by: ValueTypes["CustomerIngredientRatingUniqueWhere"],	filter?: ValueTypes["CustomerIngredientRatingWhere"] | undefined | null,	update: ValueTypes["CustomerIngredientRatingUpdateInput"],	create: ValueTypes["CustomerIngredientRatingCreateInput"]},ValueTypes["CustomerIngredientRatingUpsertResult"]],
createProductIngredientRating?: [{	data: ValueTypes["ProductIngredientRatingCreateInput"]},ValueTypes["ProductIngredientRatingCreateResult"]],
deleteProductIngredientRating?: [{	by: ValueTypes["ProductIngredientRatingUniqueWhere"],	filter?: ValueTypes["ProductIngredientRatingWhere"] | undefined | null},ValueTypes["ProductIngredientRatingDeleteResult"]],
updateProductIngredientRating?: [{	by: ValueTypes["ProductIngredientRatingUniqueWhere"],	filter?: ValueTypes["ProductIngredientRatingWhere"] | undefined | null,	data: ValueTypes["ProductIngredientRatingUpdateInput"]},ValueTypes["ProductIngredientRatingUpdateResult"]],
upsertProductIngredientRating?: [{	by: ValueTypes["ProductIngredientRatingUniqueWhere"],	filter?: ValueTypes["ProductIngredientRatingWhere"] | undefined | null,	update: ValueTypes["ProductIngredientRatingUpdateInput"],	create: ValueTypes["ProductIngredientRatingCreateInput"]},ValueTypes["ProductIngredientRatingUpsertResult"]],
createProductIngredientLocale?: [{	data: ValueTypes["ProductIngredientLocaleCreateInput"]},ValueTypes["ProductIngredientLocaleCreateResult"]],
deleteProductIngredientLocale?: [{	by: ValueTypes["ProductIngredientLocaleUniqueWhere"],	filter?: ValueTypes["ProductIngredientLocaleWhere"] | undefined | null},ValueTypes["ProductIngredientLocaleDeleteResult"]],
updateProductIngredientLocale?: [{	by: ValueTypes["ProductIngredientLocaleUniqueWhere"],	filter?: ValueTypes["ProductIngredientLocaleWhere"] | undefined | null,	data: ValueTypes["ProductIngredientLocaleUpdateInput"]},ValueTypes["ProductIngredientLocaleUpdateResult"]],
upsertProductIngredientLocale?: [{	by: ValueTypes["ProductIngredientLocaleUniqueWhere"],	filter?: ValueTypes["ProductIngredientLocaleWhere"] | undefined | null,	update: ValueTypes["ProductIngredientLocaleUpdateInput"],	create: ValueTypes["ProductIngredientLocaleCreateInput"]},ValueTypes["ProductIngredientLocaleUpsertResult"]],
createOrderRecurrence?: [{	data: ValueTypes["OrderRecurrenceCreateInput"]},ValueTypes["OrderRecurrenceCreateResult"]],
deleteOrderRecurrence?: [{	by: ValueTypes["OrderRecurrenceUniqueWhere"],	filter?: ValueTypes["OrderRecurrenceWhere"] | undefined | null},ValueTypes["OrderRecurrenceDeleteResult"]],
updateOrderRecurrence?: [{	by: ValueTypes["OrderRecurrenceUniqueWhere"],	filter?: ValueTypes["OrderRecurrenceWhere"] | undefined | null,	data: ValueTypes["OrderRecurrenceUpdateInput"]},ValueTypes["OrderRecurrenceUpdateResult"]],
upsertOrderRecurrence?: [{	by: ValueTypes["OrderRecurrenceUniqueWhere"],	filter?: ValueTypes["OrderRecurrenceWhere"] | undefined | null,	update: ValueTypes["OrderRecurrenceUpdateInput"],	create: ValueTypes["OrderRecurrenceCreateInput"]},ValueTypes["OrderRecurrenceUpsertResult"]],
createOrderRecurrenceLocale?: [{	data: ValueTypes["OrderRecurrenceLocaleCreateInput"]},ValueTypes["OrderRecurrenceLocaleCreateResult"]],
deleteOrderRecurrenceLocale?: [{	by: ValueTypes["OrderRecurrenceLocaleUniqueWhere"],	filter?: ValueTypes["OrderRecurrenceLocaleWhere"] | undefined | null},ValueTypes["OrderRecurrenceLocaleDeleteResult"]],
updateOrderRecurrenceLocale?: [{	by: ValueTypes["OrderRecurrenceLocaleUniqueWhere"],	filter?: ValueTypes["OrderRecurrenceLocaleWhere"] | undefined | null,	data: ValueTypes["OrderRecurrenceLocaleUpdateInput"]},ValueTypes["OrderRecurrenceLocaleUpdateResult"]],
upsertOrderRecurrenceLocale?: [{	by: ValueTypes["OrderRecurrenceLocaleUniqueWhere"],	filter?: ValueTypes["OrderRecurrenceLocaleWhere"] | undefined | null,	update: ValueTypes["OrderRecurrenceLocaleUpdateInput"],	create: ValueTypes["OrderRecurrenceLocaleCreateInput"]},ValueTypes["OrderRecurrenceLocaleUpsertResult"]],
createBusinessCustomer?: [{	data: ValueTypes["BusinessCustomerCreateInput"]},ValueTypes["BusinessCustomerCreateResult"]],
deleteBusinessCustomer?: [{	by: ValueTypes["BusinessCustomerUniqueWhere"],	filter?: ValueTypes["BusinessCustomerWhere"] | undefined | null},ValueTypes["BusinessCustomerDeleteResult"]],
updateBusinessCustomer?: [{	by: ValueTypes["BusinessCustomerUniqueWhere"],	filter?: ValueTypes["BusinessCustomerWhere"] | undefined | null,	data: ValueTypes["BusinessCustomerUpdateInput"]},ValueTypes["BusinessCustomerUpdateResult"]],
upsertBusinessCustomer?: [{	by: ValueTypes["BusinessCustomerUniqueWhere"],	filter?: ValueTypes["BusinessCustomerWhere"] | undefined | null,	update: ValueTypes["BusinessCustomerUpdateInput"],	create: ValueTypes["BusinessCustomerCreateInput"]},ValueTypes["BusinessCustomerUpsertResult"]],
createPointOfSale?: [{	data: ValueTypes["PointOfSaleCreateInput"]},ValueTypes["PointOfSaleCreateResult"]],
deletePointOfSale?: [{	by: ValueTypes["PointOfSaleUniqueWhere"],	filter?: ValueTypes["PointOfSaleWhere"] | undefined | null},ValueTypes["PointOfSaleDeleteResult"]],
updatePointOfSale?: [{	by: ValueTypes["PointOfSaleUniqueWhere"],	filter?: ValueTypes["PointOfSaleWhere"] | undefined | null,	data: ValueTypes["PointOfSaleUpdateInput"]},ValueTypes["PointOfSaleUpdateResult"]],
upsertPointOfSale?: [{	by: ValueTypes["PointOfSaleUniqueWhere"],	filter?: ValueTypes["PointOfSaleWhere"] | undefined | null,	update: ValueTypes["PointOfSaleUpdateInput"],	create: ValueTypes["PointOfSaleCreateInput"]},ValueTypes["PointOfSaleUpsertResult"]],
createStaff?: [{	data: ValueTypes["StaffCreateInput"]},ValueTypes["StaffCreateResult"]],
deleteStaff?: [{	by: ValueTypes["StaffUniqueWhere"],	filter?: ValueTypes["StaffWhere"] | undefined | null},ValueTypes["StaffDeleteResult"]],
updateStaff?: [{	by: ValueTypes["StaffUniqueWhere"],	filter?: ValueTypes["StaffWhere"] | undefined | null,	data: ValueTypes["StaffUpdateInput"]},ValueTypes["StaffUpdateResult"]],
upsertStaff?: [{	by: ValueTypes["StaffUniqueWhere"],	filter?: ValueTypes["StaffWhere"] | undefined | null,	update: ValueTypes["StaffUpdateInput"],	create: ValueTypes["StaffCreateInput"]},ValueTypes["StaffUpsertResult"]],
createBlog?: [{	data: ValueTypes["BlogCreateInput"]},ValueTypes["BlogCreateResult"]],
deleteBlog?: [{	by: ValueTypes["BlogUniqueWhere"],	filter?: ValueTypes["BlogWhere"] | undefined | null},ValueTypes["BlogDeleteResult"]],
updateBlog?: [{	by: ValueTypes["BlogUniqueWhere"],	filter?: ValueTypes["BlogWhere"] | undefined | null,	data: ValueTypes["BlogUpdateInput"]},ValueTypes["BlogUpdateResult"]],
upsertBlog?: [{	by: ValueTypes["BlogUniqueWhere"],	filter?: ValueTypes["BlogWhere"] | undefined | null,	update: ValueTypes["BlogUpdateInput"],	create: ValueTypes["BlogCreateInput"]},ValueTypes["BlogUpsertResult"]],
createBlogLocale?: [{	data: ValueTypes["BlogLocaleCreateInput"]},ValueTypes["BlogLocaleCreateResult"]],
deleteBlogLocale?: [{	by: ValueTypes["BlogLocaleUniqueWhere"],	filter?: ValueTypes["BlogLocaleWhere"] | undefined | null},ValueTypes["BlogLocaleDeleteResult"]],
updateBlogLocale?: [{	by: ValueTypes["BlogLocaleUniqueWhere"],	filter?: ValueTypes["BlogLocaleWhere"] | undefined | null,	data: ValueTypes["BlogLocaleUpdateInput"]},ValueTypes["BlogLocaleUpdateResult"]],
upsertBlogLocale?: [{	by: ValueTypes["BlogLocaleUniqueWhere"],	filter?: ValueTypes["BlogLocaleWhere"] | undefined | null,	update: ValueTypes["BlogLocaleUpdateInput"],	create: ValueTypes["BlogLocaleCreateInput"]},ValueTypes["BlogLocaleUpsertResult"]],
createBlogPost?: [{	data: ValueTypes["BlogPostCreateInput"]},ValueTypes["BlogPostCreateResult"]],
deleteBlogPost?: [{	by: ValueTypes["BlogPostUniqueWhere"],	filter?: ValueTypes["BlogPostWhere"] | undefined | null},ValueTypes["BlogPostDeleteResult"]],
updateBlogPost?: [{	by: ValueTypes["BlogPostUniqueWhere"],	filter?: ValueTypes["BlogPostWhere"] | undefined | null,	data: ValueTypes["BlogPostUpdateInput"]},ValueTypes["BlogPostUpdateResult"]],
upsertBlogPost?: [{	by: ValueTypes["BlogPostUniqueWhere"],	filter?: ValueTypes["BlogPostWhere"] | undefined | null,	update: ValueTypes["BlogPostUpdateInput"],	create: ValueTypes["BlogPostCreateInput"]},ValueTypes["BlogPostUpsertResult"]],
createBlogPostLocale?: [{	data: ValueTypes["BlogPostLocaleCreateInput"]},ValueTypes["BlogPostLocaleCreateResult"]],
deleteBlogPostLocale?: [{	by: ValueTypes["BlogPostLocaleUniqueWhere"],	filter?: ValueTypes["BlogPostLocaleWhere"] | undefined | null},ValueTypes["BlogPostLocaleDeleteResult"]],
updateBlogPostLocale?: [{	by: ValueTypes["BlogPostLocaleUniqueWhere"],	filter?: ValueTypes["BlogPostLocaleWhere"] | undefined | null,	data: ValueTypes["BlogPostLocaleUpdateInput"]},ValueTypes["BlogPostLocaleUpdateResult"]],
upsertBlogPostLocale?: [{	by: ValueTypes["BlogPostLocaleUniqueWhere"],	filter?: ValueTypes["BlogPostLocaleWhere"] | undefined | null,	update: ValueTypes["BlogPostLocaleUpdateInput"],	create: ValueTypes["BlogPostLocaleCreateInput"]},ValueTypes["BlogPostLocaleUpsertResult"]],
createColorPallete?: [{	data: ValueTypes["ColorPalleteCreateInput"]},ValueTypes["ColorPalleteCreateResult"]],
deleteColorPallete?: [{	by: ValueTypes["ColorPalleteUniqueWhere"],	filter?: ValueTypes["ColorPalleteWhere"] | undefined | null},ValueTypes["ColorPalleteDeleteResult"]],
updateColorPallete?: [{	by: ValueTypes["ColorPalleteUniqueWhere"],	filter?: ValueTypes["ColorPalleteWhere"] | undefined | null,	data: ValueTypes["ColorPalleteUpdateInput"]},ValueTypes["ColorPalleteUpdateResult"]],
upsertColorPallete?: [{	by: ValueTypes["ColorPalleteUniqueWhere"],	filter?: ValueTypes["ColorPalleteWhere"] | undefined | null,	update: ValueTypes["ColorPalleteUpdateInput"],	create: ValueTypes["ColorPalleteCreateInput"]},ValueTypes["ColorPalleteUpsertResult"]],
createContent?: [{	data: ValueTypes["ContentCreateInput"]},ValueTypes["ContentCreateResult"]],
deleteContent?: [{	by: ValueTypes["ContentUniqueWhere"],	filter?: ValueTypes["ContentWhere"] | undefined | null},ValueTypes["ContentDeleteResult"]],
updateContent?: [{	by: ValueTypes["ContentUniqueWhere"],	filter?: ValueTypes["ContentWhere"] | undefined | null,	data: ValueTypes["ContentUpdateInput"]},ValueTypes["ContentUpdateResult"]],
upsertContent?: [{	by: ValueTypes["ContentUniqueWhere"],	filter?: ValueTypes["ContentWhere"] | undefined | null,	update: ValueTypes["ContentUpdateInput"],	create: ValueTypes["ContentCreateInput"]},ValueTypes["ContentUpsertResult"]],
createContentBlock?: [{	data: ValueTypes["ContentBlockCreateInput"]},ValueTypes["ContentBlockCreateResult"]],
deleteContentBlock?: [{	by: ValueTypes["ContentBlockUniqueWhere"],	filter?: ValueTypes["ContentBlockWhere"] | undefined | null},ValueTypes["ContentBlockDeleteResult"]],
updateContentBlock?: [{	by: ValueTypes["ContentBlockUniqueWhere"],	filter?: ValueTypes["ContentBlockWhere"] | undefined | null,	data: ValueTypes["ContentBlockUpdateInput"]},ValueTypes["ContentBlockUpdateResult"]],
upsertContentBlock?: [{	by: ValueTypes["ContentBlockUniqueWhere"],	filter?: ValueTypes["ContentBlockWhere"] | undefined | null,	update: ValueTypes["ContentBlockUpdateInput"],	create: ValueTypes["ContentBlockCreateInput"]},ValueTypes["ContentBlockUpsertResult"]],
createContentReference?: [{	data: ValueTypes["ContentReferenceCreateInput"]},ValueTypes["ContentReferenceCreateResult"]],
deleteContentReference?: [{	by: ValueTypes["ContentReferenceUniqueWhere"],	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null},ValueTypes["ContentReferenceDeleteResult"]],
updateContentReference?: [{	by: ValueTypes["ContentReferenceUniqueWhere"],	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null,	data: ValueTypes["ContentReferenceUpdateInput"]},ValueTypes["ContentReferenceUpdateResult"]],
upsertContentReference?: [{	by: ValueTypes["ContentReferenceUniqueWhere"],	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null,	update: ValueTypes["ContentReferenceUpdateInput"],	create: ValueTypes["ContentReferenceCreateInput"]},ValueTypes["ContentReferenceUpsertResult"]],
createBlogPostList?: [{	data: ValueTypes["BlogPostListCreateInput"]},ValueTypes["BlogPostListCreateResult"]],
deleteBlogPostList?: [{	by: ValueTypes["BlogPostListUniqueWhere"],	filter?: ValueTypes["BlogPostListWhere"] | undefined | null},ValueTypes["BlogPostListDeleteResult"]],
updateBlogPostList?: [{	by: ValueTypes["BlogPostListUniqueWhere"],	filter?: ValueTypes["BlogPostListWhere"] | undefined | null,	data: ValueTypes["BlogPostListUpdateInput"]},ValueTypes["BlogPostListUpdateResult"]],
upsertBlogPostList?: [{	by: ValueTypes["BlogPostListUniqueWhere"],	filter?: ValueTypes["BlogPostListWhere"] | undefined | null,	update: ValueTypes["BlogPostListUpdateInput"],	create: ValueTypes["BlogPostListCreateInput"]},ValueTypes["BlogPostListUpsertResult"]],
createBlogPostListItem?: [{	data: ValueTypes["BlogPostListItemCreateInput"]},ValueTypes["BlogPostListItemCreateResult"]],
deleteBlogPostListItem?: [{	by: ValueTypes["BlogPostListItemUniqueWhere"],	filter?: ValueTypes["BlogPostListItemWhere"] | undefined | null},ValueTypes["BlogPostListItemDeleteResult"]],
updateBlogPostListItem?: [{	by: ValueTypes["BlogPostListItemUniqueWhere"],	filter?: ValueTypes["BlogPostListItemWhere"] | undefined | null,	data: ValueTypes["BlogPostListItemUpdateInput"]},ValueTypes["BlogPostListItemUpdateResult"]],
upsertBlogPostListItem?: [{	by: ValueTypes["BlogPostListItemUniqueWhere"],	filter?: ValueTypes["BlogPostListItemWhere"] | undefined | null,	update: ValueTypes["BlogPostListItemUpdateInput"],	create: ValueTypes["BlogPostListItemCreateInput"]},ValueTypes["BlogPostListItemUpsertResult"]],
createLinkList?: [{	data: ValueTypes["LinkListCreateInput"]},ValueTypes["LinkListCreateResult"]],
deleteLinkList?: [{	by: ValueTypes["LinkListUniqueWhere"],	filter?: ValueTypes["LinkListWhere"] | undefined | null},ValueTypes["LinkListDeleteResult"]],
updateLinkList?: [{	by: ValueTypes["LinkListUniqueWhere"],	filter?: ValueTypes["LinkListWhere"] | undefined | null,	data: ValueTypes["LinkListUpdateInput"]},ValueTypes["LinkListUpdateResult"]],
upsertLinkList?: [{	by: ValueTypes["LinkListUniqueWhere"],	filter?: ValueTypes["LinkListWhere"] | undefined | null,	update: ValueTypes["LinkListUpdateInput"],	create: ValueTypes["LinkListCreateInput"]},ValueTypes["LinkListUpsertResult"]],
createLinkListItem?: [{	data: ValueTypes["LinkListItemCreateInput"]},ValueTypes["LinkListItemCreateResult"]],
deleteLinkListItem?: [{	by: ValueTypes["LinkListItemUniqueWhere"],	filter?: ValueTypes["LinkListItemWhere"] | undefined | null},ValueTypes["LinkListItemDeleteResult"]],
updateLinkListItem?: [{	by: ValueTypes["LinkListItemUniqueWhere"],	filter?: ValueTypes["LinkListItemWhere"] | undefined | null,	data: ValueTypes["LinkListItemUpdateInput"]},ValueTypes["LinkListItemUpdateResult"]],
upsertLinkListItem?: [{	by: ValueTypes["LinkListItemUniqueWhere"],	filter?: ValueTypes["LinkListItemWhere"] | undefined | null,	update: ValueTypes["LinkListItemUpdateInput"],	create: ValueTypes["LinkListItemCreateInput"]},ValueTypes["LinkListItemUpsertResult"]],
createCover?: [{	data: ValueTypes["CoverCreateInput"]},ValueTypes["CoverCreateResult"]],
deleteCover?: [{	by: ValueTypes["CoverUniqueWhere"],	filter?: ValueTypes["CoverWhere"] | undefined | null},ValueTypes["CoverDeleteResult"]],
updateCover?: [{	by: ValueTypes["CoverUniqueWhere"],	filter?: ValueTypes["CoverWhere"] | undefined | null,	data: ValueTypes["CoverUpdateInput"]},ValueTypes["CoverUpdateResult"]],
upsertCover?: [{	by: ValueTypes["CoverUniqueWhere"],	filter?: ValueTypes["CoverWhere"] | undefined | null,	update: ValueTypes["CoverUpdateInput"],	create: ValueTypes["CoverCreateInput"]},ValueTypes["CoverUpsertResult"]],
createLink?: [{	data: ValueTypes["LinkCreateInput"]},ValueTypes["LinkCreateResult"]],
deleteLink?: [{	by: ValueTypes["LinkUniqueWhere"],	filter?: ValueTypes["LinkWhere"] | undefined | null},ValueTypes["LinkDeleteResult"]],
updateLink?: [{	by: ValueTypes["LinkUniqueWhere"],	filter?: ValueTypes["LinkWhere"] | undefined | null,	data: ValueTypes["LinkUpdateInput"]},ValueTypes["LinkUpdateResult"]],
upsertLink?: [{	by: ValueTypes["LinkUniqueWhere"],	filter?: ValueTypes["LinkWhere"] | undefined | null,	update: ValueTypes["LinkUpdateInput"],	create: ValueTypes["LinkCreateInput"]},ValueTypes["LinkUpsertResult"]],
createLinkable?: [{	data: ValueTypes["LinkableCreateInput"]},ValueTypes["LinkableCreateResult"]],
deleteLinkable?: [{	by: ValueTypes["LinkableUniqueWhere"],	filter?: ValueTypes["LinkableWhere"] | undefined | null},ValueTypes["LinkableDeleteResult"]],
updateLinkable?: [{	by: ValueTypes["LinkableUniqueWhere"],	filter?: ValueTypes["LinkableWhere"] | undefined | null,	data: ValueTypes["LinkableUpdateInput"]},ValueTypes["LinkableUpdateResult"]],
upsertLinkable?: [{	by: ValueTypes["LinkableUniqueWhere"],	filter?: ValueTypes["LinkableWhere"] | undefined | null,	update: ValueTypes["LinkableUpdateInput"],	create: ValueTypes["LinkableCreateInput"]},ValueTypes["LinkableUpsertResult"]],
createMedium?: [{	data: ValueTypes["MediumCreateInput"]},ValueTypes["MediumCreateResult"]],
deleteMedium?: [{	by: ValueTypes["MediumUniqueWhere"],	filter?: ValueTypes["MediumWhere"] | undefined | null},ValueTypes["MediumDeleteResult"]],
updateMedium?: [{	by: ValueTypes["MediumUniqueWhere"],	filter?: ValueTypes["MediumWhere"] | undefined | null,	data: ValueTypes["MediumUpdateInput"]},ValueTypes["MediumUpdateResult"]],
upsertMedium?: [{	by: ValueTypes["MediumUniqueWhere"],	filter?: ValueTypes["MediumWhere"] | undefined | null,	update: ValueTypes["MediumUpdateInput"],	create: ValueTypes["MediumCreateInput"]},ValueTypes["MediumUpsertResult"]],
createVideo?: [{	data: ValueTypes["VideoCreateInput"]},ValueTypes["VideoCreateResult"]],
deleteVideo?: [{	by: ValueTypes["VideoUniqueWhere"],	filter?: ValueTypes["VideoWhere"] | undefined | null},ValueTypes["VideoDeleteResult"]],
updateVideo?: [{	by: ValueTypes["VideoUniqueWhere"],	filter?: ValueTypes["VideoWhere"] | undefined | null,	data: ValueTypes["VideoUpdateInput"]},ValueTypes["VideoUpdateResult"]],
upsertVideo?: [{	by: ValueTypes["VideoUniqueWhere"],	filter?: ValueTypes["VideoWhere"] | undefined | null,	update: ValueTypes["VideoUpdateInput"],	create: ValueTypes["VideoCreateInput"]},ValueTypes["VideoUpsertResult"]],
createSeo?: [{	data: ValueTypes["SeoCreateInput"]},ValueTypes["SeoCreateResult"]],
deleteSeo?: [{	by: ValueTypes["SeoUniqueWhere"],	filter?: ValueTypes["SeoWhere"] | undefined | null},ValueTypes["SeoDeleteResult"]],
updateSeo?: [{	by: ValueTypes["SeoUniqueWhere"],	filter?: ValueTypes["SeoWhere"] | undefined | null,	data: ValueTypes["SeoUpdateInput"]},ValueTypes["SeoUpdateResult"]],
upsertSeo?: [{	by: ValueTypes["SeoUniqueWhere"],	filter?: ValueTypes["SeoWhere"] | undefined | null,	update: ValueTypes["SeoUpdateInput"],	create: ValueTypes["SeoCreateInput"]},ValueTypes["SeoUpsertResult"]],
createProtectedImage?: [{	data: ValueTypes["ProtectedImageCreateInput"]},ValueTypes["ProtectedImageCreateResult"]],
deleteProtectedImage?: [{	by: ValueTypes["ProtectedImageUniqueWhere"],	filter?: ValueTypes["ProtectedImageWhere"] | undefined | null},ValueTypes["ProtectedImageDeleteResult"]],
updateProtectedImage?: [{	by: ValueTypes["ProtectedImageUniqueWhere"],	filter?: ValueTypes["ProtectedImageWhere"] | undefined | null,	data: ValueTypes["ProtectedImageUpdateInput"]},ValueTypes["ProtectedImageUpdateResult"]],
upsertProtectedImage?: [{	by: ValueTypes["ProtectedImageUniqueWhere"],	filter?: ValueTypes["ProtectedImageWhere"] | undefined | null,	update: ValueTypes["ProtectedImageUpdateInput"],	create: ValueTypes["ProtectedImageCreateInput"]},ValueTypes["ProtectedImageUpsertResult"]],
createTranslationDomain?: [{	data: ValueTypes["TranslationDomainCreateInput"]},ValueTypes["TranslationDomainCreateResult"]],
deleteTranslationDomain?: [{	by: ValueTypes["TranslationDomainUniqueWhere"],	filter?: ValueTypes["TranslationDomainWhere"] | undefined | null},ValueTypes["TranslationDomainDeleteResult"]],
updateTranslationDomain?: [{	by: ValueTypes["TranslationDomainUniqueWhere"],	filter?: ValueTypes["TranslationDomainWhere"] | undefined | null,	data: ValueTypes["TranslationDomainUpdateInput"]},ValueTypes["TranslationDomainUpdateResult"]],
upsertTranslationDomain?: [{	by: ValueTypes["TranslationDomainUniqueWhere"],	filter?: ValueTypes["TranslationDomainWhere"] | undefined | null,	update: ValueTypes["TranslationDomainUpdateInput"],	create: ValueTypes["TranslationDomainCreateInput"]},ValueTypes["TranslationDomainUpsertResult"]],
createTranslationCatalogue?: [{	data: ValueTypes["TranslationCatalogueCreateInput"]},ValueTypes["TranslationCatalogueCreateResult"]],
deleteTranslationCatalogue?: [{	by: ValueTypes["TranslationCatalogueUniqueWhere"],	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null},ValueTypes["TranslationCatalogueDeleteResult"]],
updateTranslationCatalogue?: [{	by: ValueTypes["TranslationCatalogueUniqueWhere"],	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null,	data: ValueTypes["TranslationCatalogueUpdateInput"]},ValueTypes["TranslationCatalogueUpdateResult"]],
upsertTranslationCatalogue?: [{	by: ValueTypes["TranslationCatalogueUniqueWhere"],	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null,	update: ValueTypes["TranslationCatalogueUpdateInput"],	create: ValueTypes["TranslationCatalogueCreateInput"]},ValueTypes["TranslationCatalogueUpsertResult"]],
createTranslationKey?: [{	data: ValueTypes["TranslationKeyCreateInput"]},ValueTypes["TranslationKeyCreateResult"]],
deleteTranslationKey?: [{	by: ValueTypes["TranslationKeyUniqueWhere"],	filter?: ValueTypes["TranslationKeyWhere"] | undefined | null},ValueTypes["TranslationKeyDeleteResult"]],
updateTranslationKey?: [{	by: ValueTypes["TranslationKeyUniqueWhere"],	filter?: ValueTypes["TranslationKeyWhere"] | undefined | null,	data: ValueTypes["TranslationKeyUpdateInput"]},ValueTypes["TranslationKeyUpdateResult"]],
upsertTranslationKey?: [{	by: ValueTypes["TranslationKeyUniqueWhere"],	filter?: ValueTypes["TranslationKeyWhere"] | undefined | null,	update: ValueTypes["TranslationKeyUpdateInput"],	create: ValueTypes["TranslationKeyCreateInput"]},ValueTypes["TranslationKeyUpsertResult"]],
createTranslationValue?: [{	data: ValueTypes["TranslationValueCreateInput"]},ValueTypes["TranslationValueCreateResult"]],
deleteTranslationValue?: [{	by: ValueTypes["TranslationValueUniqueWhere"],	filter?: ValueTypes["TranslationValueWhere"] | undefined | null},ValueTypes["TranslationValueDeleteResult"]],
updateTranslationValue?: [{	by: ValueTypes["TranslationValueUniqueWhere"],	filter?: ValueTypes["TranslationValueWhere"] | undefined | null,	data: ValueTypes["TranslationValueUpdateInput"]},ValueTypes["TranslationValueUpdateResult"]],
upsertTranslationValue?: [{	by: ValueTypes["TranslationValueUniqueWhere"],	filter?: ValueTypes["TranslationValueWhere"] | undefined | null,	update: ValueTypes["TranslationValueUpdateInput"],	create: ValueTypes["TranslationValueCreateInput"]},ValueTypes["TranslationValueUpsertResult"]],
createTranslationCataloguesIdentifier?: [{	data: ValueTypes["TranslationCataloguesIdentifierCreateInput"]},ValueTypes["TranslationCataloguesIdentifierCreateResult"]],
deleteTranslationCataloguesIdentifier?: [{	by: ValueTypes["TranslationCataloguesIdentifierUniqueWhere"],	filter?: ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null},ValueTypes["TranslationCataloguesIdentifierDeleteResult"]],
updateTranslationCataloguesIdentifier?: [{	by: ValueTypes["TranslationCataloguesIdentifierUniqueWhere"],	filter?: ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null,	data: ValueTypes["TranslationCataloguesIdentifierUpdateInput"]},ValueTypes["TranslationCataloguesIdentifierUpdateResult"]],
upsertTranslationCataloguesIdentifier?: [{	by: ValueTypes["TranslationCataloguesIdentifierUniqueWhere"],	filter?: ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null,	update: ValueTypes["TranslationCataloguesIdentifierUpdateInput"],	create: ValueTypes["TranslationCataloguesIdentifierCreateInput"]},ValueTypes["TranslationCataloguesIdentifierUpsertResult"]],
createSocialsAndApps?: [{	data: ValueTypes["SocialsAndAppsCreateInput"]},ValueTypes["SocialsAndAppsCreateResult"]],
deleteSocialsAndApps?: [{	by: ValueTypes["SocialsAndAppsUniqueWhere"],	filter?: ValueTypes["SocialsAndAppsWhere"] | undefined | null},ValueTypes["SocialsAndAppsDeleteResult"]],
updateSocialsAndApps?: [{	by: ValueTypes["SocialsAndAppsUniqueWhere"],	filter?: ValueTypes["SocialsAndAppsWhere"] | undefined | null,	data: ValueTypes["SocialsAndAppsUpdateInput"]},ValueTypes["SocialsAndAppsUpdateResult"]],
upsertSocialsAndApps?: [{	by: ValueTypes["SocialsAndAppsUniqueWhere"],	filter?: ValueTypes["SocialsAndAppsWhere"] | undefined | null,	update: ValueTypes["SocialsAndAppsUpdateInput"],	create: ValueTypes["SocialsAndAppsCreateInput"]},ValueTypes["SocialsAndAppsUpsertResult"]],
createProductGrid?: [{	data: ValueTypes["ProductGridCreateInput"]},ValueTypes["ProductGridCreateResult"]],
deleteProductGrid?: [{	by: ValueTypes["ProductGridUniqueWhere"],	filter?: ValueTypes["ProductGridWhere"] | undefined | null},ValueTypes["ProductGridDeleteResult"]],
updateProductGrid?: [{	by: ValueTypes["ProductGridUniqueWhere"],	filter?: ValueTypes["ProductGridWhere"] | undefined | null,	data: ValueTypes["ProductGridUpdateInput"]},ValueTypes["ProductGridUpdateResult"]],
upsertProductGrid?: [{	by: ValueTypes["ProductGridUniqueWhere"],	filter?: ValueTypes["ProductGridWhere"] | undefined | null,	update: ValueTypes["ProductGridUpdateInput"],	create: ValueTypes["ProductGridCreateInput"]},ValueTypes["ProductGridUpsertResult"]],
createProductGridItem?: [{	data: ValueTypes["ProductGridItemCreateInput"]},ValueTypes["ProductGridItemCreateResult"]],
deleteProductGridItem?: [{	by: ValueTypes["ProductGridItemUniqueWhere"],	filter?: ValueTypes["ProductGridItemWhere"] | undefined | null},ValueTypes["ProductGridItemDeleteResult"]],
updateProductGridItem?: [{	by: ValueTypes["ProductGridItemUniqueWhere"],	filter?: ValueTypes["ProductGridItemWhere"] | undefined | null,	data: ValueTypes["ProductGridItemUpdateInput"]},ValueTypes["ProductGridItemUpdateResult"]],
upsertProductGridItem?: [{	by: ValueTypes["ProductGridItemUniqueWhere"],	filter?: ValueTypes["ProductGridItemWhere"] | undefined | null,	update: ValueTypes["ProductGridItemUpdateInput"],	create: ValueTypes["ProductGridItemCreateInput"]},ValueTypes["ProductGridItemUpsertResult"]],
createGallery?: [{	data: ValueTypes["GalleryCreateInput"]},ValueTypes["GalleryCreateResult"]],
deleteGallery?: [{	by: ValueTypes["GalleryUniqueWhere"],	filter?: ValueTypes["GalleryWhere"] | undefined | null},ValueTypes["GalleryDeleteResult"]],
updateGallery?: [{	by: ValueTypes["GalleryUniqueWhere"],	filter?: ValueTypes["GalleryWhere"] | undefined | null,	data: ValueTypes["GalleryUpdateInput"]},ValueTypes["GalleryUpdateResult"]],
upsertGallery?: [{	by: ValueTypes["GalleryUniqueWhere"],	filter?: ValueTypes["GalleryWhere"] | undefined | null,	update: ValueTypes["GalleryUpdateInput"],	create: ValueTypes["GalleryCreateInput"]},ValueTypes["GalleryUpsertResult"]],
createGalleryItem?: [{	data: ValueTypes["GalleryItemCreateInput"]},ValueTypes["GalleryItemCreateResult"]],
deleteGalleryItem?: [{	by: ValueTypes["GalleryItemUniqueWhere"],	filter?: ValueTypes["GalleryItemWhere"] | undefined | null},ValueTypes["GalleryItemDeleteResult"]],
updateGalleryItem?: [{	by: ValueTypes["GalleryItemUniqueWhere"],	filter?: ValueTypes["GalleryItemWhere"] | undefined | null,	data: ValueTypes["GalleryItemUpdateInput"]},ValueTypes["GalleryItemUpdateResult"]],
upsertGalleryItem?: [{	by: ValueTypes["GalleryItemUniqueWhere"],	filter?: ValueTypes["GalleryItemWhere"] | undefined | null,	update: ValueTypes["GalleryItemUpdateInput"],	create: ValueTypes["GalleryItemCreateInput"]},ValueTypes["GalleryItemUpsertResult"]],
createHero?: [{	data: ValueTypes["HeroCreateInput"]},ValueTypes["HeroCreateResult"]],
deleteHero?: [{	by: ValueTypes["HeroUniqueWhere"],	filter?: ValueTypes["HeroWhere"] | undefined | null},ValueTypes["HeroDeleteResult"]],
updateHero?: [{	by: ValueTypes["HeroUniqueWhere"],	filter?: ValueTypes["HeroWhere"] | undefined | null,	data: ValueTypes["HeroUpdateInput"]},ValueTypes["HeroUpdateResult"]],
upsertHero?: [{	by: ValueTypes["HeroUniqueWhere"],	filter?: ValueTypes["HeroWhere"] | undefined | null,	update: ValueTypes["HeroUpdateInput"],	create: ValueTypes["HeroCreateInput"]},ValueTypes["HeroUpsertResult"]],
createSiteMenu?: [{	data: ValueTypes["SiteMenuCreateInput"]},ValueTypes["SiteMenuCreateResult"]],
deleteSiteMenu?: [{	by: ValueTypes["SiteMenuUniqueWhere"],	filter?: ValueTypes["SiteMenuWhere"] | undefined | null},ValueTypes["SiteMenuDeleteResult"]],
updateSiteMenu?: [{	by: ValueTypes["SiteMenuUniqueWhere"],	filter?: ValueTypes["SiteMenuWhere"] | undefined | null,	data: ValueTypes["SiteMenuUpdateInput"]},ValueTypes["SiteMenuUpdateResult"]],
upsertSiteMenu?: [{	by: ValueTypes["SiteMenuUniqueWhere"],	filter?: ValueTypes["SiteMenuWhere"] | undefined | null,	update: ValueTypes["SiteMenuUpdateInput"],	create: ValueTypes["SiteMenuCreateInput"]},ValueTypes["SiteMenuUpsertResult"]],
createMenuLocale?: [{	data: ValueTypes["MenuLocaleCreateInput"]},ValueTypes["MenuLocaleCreateResult"]],
deleteMenuLocale?: [{	by: ValueTypes["MenuLocaleUniqueWhere"],	filter?: ValueTypes["MenuLocaleWhere"] | undefined | null},ValueTypes["MenuLocaleDeleteResult"]],
updateMenuLocale?: [{	by: ValueTypes["MenuLocaleUniqueWhere"],	filter?: ValueTypes["MenuLocaleWhere"] | undefined | null,	data: ValueTypes["MenuLocaleUpdateInput"]},ValueTypes["MenuLocaleUpdateResult"]],
upsertMenuLocale?: [{	by: ValueTypes["MenuLocaleUniqueWhere"],	filter?: ValueTypes["MenuLocaleWhere"] | undefined | null,	update: ValueTypes["MenuLocaleUpdateInput"],	create: ValueTypes["MenuLocaleCreateInput"]},ValueTypes["MenuLocaleUpsertResult"]],
createMenuItem?: [{	data: ValueTypes["MenuItemCreateInput"]},ValueTypes["MenuItemCreateResult"]],
deleteMenuItem?: [{	by: ValueTypes["MenuItemUniqueWhere"],	filter?: ValueTypes["MenuItemWhere"] | undefined | null},ValueTypes["MenuItemDeleteResult"]],
updateMenuItem?: [{	by: ValueTypes["MenuItemUniqueWhere"],	filter?: ValueTypes["MenuItemWhere"] | undefined | null,	data: ValueTypes["MenuItemUpdateInput"]},ValueTypes["MenuItemUpdateResult"]],
upsertMenuItem?: [{	by: ValueTypes["MenuItemUniqueWhere"],	filter?: ValueTypes["MenuItemWhere"] | undefined | null,	update: ValueTypes["MenuItemUpdateInput"],	create: ValueTypes["MenuItemCreateInput"]},ValueTypes["MenuItemUpsertResult"]],
createPage?: [{	data: ValueTypes["PageCreateInput"]},ValueTypes["PageCreateResult"]],
deletePage?: [{	by: ValueTypes["PageUniqueWhere"],	filter?: ValueTypes["PageWhere"] | undefined | null},ValueTypes["PageDeleteResult"]],
updatePage?: [{	by: ValueTypes["PageUniqueWhere"],	filter?: ValueTypes["PageWhere"] | undefined | null,	data: ValueTypes["PageUpdateInput"]},ValueTypes["PageUpdateResult"]],
upsertPage?: [{	by: ValueTypes["PageUniqueWhere"],	filter?: ValueTypes["PageWhere"] | undefined | null,	update: ValueTypes["PageUpdateInput"],	create: ValueTypes["PageCreateInput"]},ValueTypes["PageUpsertResult"]],
createPageLocale?: [{	data: ValueTypes["PageLocaleCreateInput"]},ValueTypes["PageLocaleCreateResult"]],
deletePageLocale?: [{	by: ValueTypes["PageLocaleUniqueWhere"],	filter?: ValueTypes["PageLocaleWhere"] | undefined | null},ValueTypes["PageLocaleDeleteResult"]],
updatePageLocale?: [{	by: ValueTypes["PageLocaleUniqueWhere"],	filter?: ValueTypes["PageLocaleWhere"] | undefined | null,	data: ValueTypes["PageLocaleUpdateInput"]},ValueTypes["PageLocaleUpdateResult"]],
upsertPageLocale?: [{	by: ValueTypes["PageLocaleUniqueWhere"],	filter?: ValueTypes["PageLocaleWhere"] | undefined | null,	update: ValueTypes["PageLocaleUpdateInput"],	create: ValueTypes["PageLocaleCreateInput"]},ValueTypes["PageLocaleUpsertResult"]],
createWikiPage?: [{	data: ValueTypes["WikiPageCreateInput"]},ValueTypes["WikiPageCreateResult"]],
deleteWikiPage?: [{	by: ValueTypes["WikiPageUniqueWhere"],	filter?: ValueTypes["WikiPageWhere"] | undefined | null},ValueTypes["WikiPageDeleteResult"]],
updateWikiPage?: [{	by: ValueTypes["WikiPageUniqueWhere"],	filter?: ValueTypes["WikiPageWhere"] | undefined | null,	data: ValueTypes["WikiPageUpdateInput"]},ValueTypes["WikiPageUpdateResult"]],
upsertWikiPage?: [{	by: ValueTypes["WikiPageUniqueWhere"],	filter?: ValueTypes["WikiPageWhere"] | undefined | null,	update: ValueTypes["WikiPageUpdateInput"],	create: ValueTypes["WikiPageCreateInput"]},ValueTypes["WikiPageUpsertResult"]],
createMenuSubitem?: [{	data: ValueTypes["MenuSubitemCreateInput"]},ValueTypes["MenuSubitemCreateResult"]],
deleteMenuSubitem?: [{	by: ValueTypes["MenuSubitemUniqueWhere"],	filter?: ValueTypes["MenuSubitemWhere"] | undefined | null},ValueTypes["MenuSubitemDeleteResult"]],
updateMenuSubitem?: [{	by: ValueTypes["MenuSubitemUniqueWhere"],	filter?: ValueTypes["MenuSubitemWhere"] | undefined | null,	data: ValueTypes["MenuSubitemUpdateInput"]},ValueTypes["MenuSubitemUpdateResult"]],
upsertMenuSubitem?: [{	by: ValueTypes["MenuSubitemUniqueWhere"],	filter?: ValueTypes["MenuSubitemWhere"] | undefined | null,	update: ValueTypes["MenuSubitemUpdateInput"],	create: ValueTypes["MenuSubitemCreateInput"]},ValueTypes["MenuSubitemUpsertResult"]],
createMenuLinkList?: [{	data: ValueTypes["MenuLinkListCreateInput"]},ValueTypes["MenuLinkListCreateResult"]],
deleteMenuLinkList?: [{	by: ValueTypes["MenuLinkListUniqueWhere"],	filter?: ValueTypes["MenuLinkListWhere"] | undefined | null},ValueTypes["MenuLinkListDeleteResult"]],
updateMenuLinkList?: [{	by: ValueTypes["MenuLinkListUniqueWhere"],	filter?: ValueTypes["MenuLinkListWhere"] | undefined | null,	data: ValueTypes["MenuLinkListUpdateInput"]},ValueTypes["MenuLinkListUpdateResult"]],
upsertMenuLinkList?: [{	by: ValueTypes["MenuLinkListUniqueWhere"],	filter?: ValueTypes["MenuLinkListWhere"] | undefined | null,	update: ValueTypes["MenuLinkListUpdateInput"],	create: ValueTypes["MenuLinkListCreateInput"]},ValueTypes["MenuLinkListUpsertResult"]],
createMenuLinkItem?: [{	data: ValueTypes["MenuLinkItemCreateInput"]},ValueTypes["MenuLinkItemCreateResult"]],
deleteMenuLinkItem?: [{	by: ValueTypes["MenuLinkItemUniqueWhere"],	filter?: ValueTypes["MenuLinkItemWhere"] | undefined | null},ValueTypes["MenuLinkItemDeleteResult"]],
updateMenuLinkItem?: [{	by: ValueTypes["MenuLinkItemUniqueWhere"],	filter?: ValueTypes["MenuLinkItemWhere"] | undefined | null,	data: ValueTypes["MenuLinkItemUpdateInput"]},ValueTypes["MenuLinkItemUpdateResult"]],
upsertMenuLinkItem?: [{	by: ValueTypes["MenuLinkItemUniqueWhere"],	filter?: ValueTypes["MenuLinkItemWhere"] | undefined | null,	update: ValueTypes["MenuLinkItemUpdateInput"],	create: ValueTypes["MenuLinkItemCreateInput"]},ValueTypes["MenuLinkItemUpsertResult"]],
createMenuProducts?: [{	data: ValueTypes["MenuProductsCreateInput"]},ValueTypes["MenuProductsCreateResult"]],
deleteMenuProducts?: [{	by: ValueTypes["MenuProductsUniqueWhere"],	filter?: ValueTypes["MenuProductsWhere"] | undefined | null},ValueTypes["MenuProductsDeleteResult"]],
updateMenuProducts?: [{	by: ValueTypes["MenuProductsUniqueWhere"],	filter?: ValueTypes["MenuProductsWhere"] | undefined | null,	data: ValueTypes["MenuProductsUpdateInput"]},ValueTypes["MenuProductsUpdateResult"]],
upsertMenuProducts?: [{	by: ValueTypes["MenuProductsUniqueWhere"],	filter?: ValueTypes["MenuProductsWhere"] | undefined | null,	update: ValueTypes["MenuProductsUpdateInput"],	create: ValueTypes["MenuProductsCreateInput"]},ValueTypes["MenuProductsUpsertResult"]],
createMenuDelivery?: [{	data: ValueTypes["MenuDeliveryCreateInput"]},ValueTypes["MenuDeliveryCreateResult"]],
deleteMenuDelivery?: [{	by: ValueTypes["MenuDeliveryUniqueWhere"],	filter?: ValueTypes["MenuDeliveryWhere"] | undefined | null},ValueTypes["MenuDeliveryDeleteResult"]],
updateMenuDelivery?: [{	by: ValueTypes["MenuDeliveryUniqueWhere"],	filter?: ValueTypes["MenuDeliveryWhere"] | undefined | null,	data: ValueTypes["MenuDeliveryUpdateInput"]},ValueTypes["MenuDeliveryUpdateResult"]],
upsertMenuDelivery?: [{	by: ValueTypes["MenuDeliveryUniqueWhere"],	filter?: ValueTypes["MenuDeliveryWhere"] | undefined | null,	update: ValueTypes["MenuDeliveryUpdateInput"],	create: ValueTypes["MenuDeliveryCreateInput"]},ValueTypes["MenuDeliveryUpsertResult"]],
createMenuContact?: [{	data: ValueTypes["MenuContactCreateInput"]},ValueTypes["MenuContactCreateResult"]],
deleteMenuContact?: [{	by: ValueTypes["MenuContactUniqueWhere"],	filter?: ValueTypes["MenuContactWhere"] | undefined | null},ValueTypes["MenuContactDeleteResult"]],
updateMenuContact?: [{	by: ValueTypes["MenuContactUniqueWhere"],	filter?: ValueTypes["MenuContactWhere"] | undefined | null,	data: ValueTypes["MenuContactUpdateInput"]},ValueTypes["MenuContactUpdateResult"]],
upsertMenuContact?: [{	by: ValueTypes["MenuContactUniqueWhere"],	filter?: ValueTypes["MenuContactWhere"] | undefined | null,	update: ValueTypes["MenuContactUpdateInput"],	create: ValueTypes["MenuContactCreateInput"]},ValueTypes["MenuContactUpsertResult"]],
createDeadlineTemplate?: [{	data: ValueTypes["DeadlineTemplateCreateInput"]},ValueTypes["DeadlineTemplateCreateResult"]],
deleteDeadlineTemplate?: [{	by: ValueTypes["DeadlineTemplateUniqueWhere"],	filter?: ValueTypes["DeadlineTemplateWhere"] | undefined | null},ValueTypes["DeadlineTemplateDeleteResult"]],
updateDeadlineTemplate?: [{	by: ValueTypes["DeadlineTemplateUniqueWhere"],	filter?: ValueTypes["DeadlineTemplateWhere"] | undefined | null,	data: ValueTypes["DeadlineTemplateUpdateInput"]},ValueTypes["DeadlineTemplateUpdateResult"]],
upsertDeadlineTemplate?: [{	by: ValueTypes["DeadlineTemplateUniqueWhere"],	filter?: ValueTypes["DeadlineTemplateWhere"] | undefined | null,	update: ValueTypes["DeadlineTemplateUpdateInput"],	create: ValueTypes["DeadlineTemplateCreateInput"]},ValueTypes["DeadlineTemplateUpsertResult"]],
createEmployeeQueue?: [{	data: ValueTypes["EmployeeQueueCreateInput"]},ValueTypes["EmployeeQueueCreateResult"]],
deleteEmployeeQueue?: [{	by: ValueTypes["EmployeeQueueUniqueWhere"],	filter?: ValueTypes["EmployeeQueueWhere"] | undefined | null},ValueTypes["EmployeeQueueDeleteResult"]],
updateEmployeeQueue?: [{	by: ValueTypes["EmployeeQueueUniqueWhere"],	filter?: ValueTypes["EmployeeQueueWhere"] | undefined | null,	data: ValueTypes["EmployeeQueueUpdateInput"]},ValueTypes["EmployeeQueueUpdateResult"]],
upsertEmployeeQueue?: [{	by: ValueTypes["EmployeeQueueUniqueWhere"],	filter?: ValueTypes["EmployeeQueueWhere"] | undefined | null,	update: ValueTypes["EmployeeQueueUpdateInput"],	create: ValueTypes["EmployeeQueueCreateInput"]},ValueTypes["EmployeeQueueUpsertResult"]],
createTimetableDay?: [{	data: ValueTypes["TimetableDayCreateInput"]},ValueTypes["TimetableDayCreateResult"]],
deleteTimetableDay?: [{	by: ValueTypes["TimetableDayUniqueWhere"],	filter?: ValueTypes["TimetableDayWhere"] | undefined | null},ValueTypes["TimetableDayDeleteResult"]],
updateTimetableDay?: [{	by: ValueTypes["TimetableDayUniqueWhere"],	filter?: ValueTypes["TimetableDayWhere"] | undefined | null,	data: ValueTypes["TimetableDayUpdateInput"]},ValueTypes["TimetableDayUpdateResult"]],
upsertTimetableDay?: [{	by: ValueTypes["TimetableDayUniqueWhere"],	filter?: ValueTypes["TimetableDayWhere"] | undefined | null,	update: ValueTypes["TimetableDayUpdateInput"],	create: ValueTypes["TimetableDayCreateInput"]},ValueTypes["TimetableDayUpsertResult"]],
createTimetableEmployeeRole?: [{	data: ValueTypes["TimetableEmployeeRoleCreateInput"]},ValueTypes["TimetableEmployeeRoleCreateResult"]],
deleteTimetableEmployeeRole?: [{	by: ValueTypes["TimetableEmployeeRoleUniqueWhere"],	filter?: ValueTypes["TimetableEmployeeRoleWhere"] | undefined | null},ValueTypes["TimetableEmployeeRoleDeleteResult"]],
updateTimetableEmployeeRole?: [{	by: ValueTypes["TimetableEmployeeRoleUniqueWhere"],	filter?: ValueTypes["TimetableEmployeeRoleWhere"] | undefined | null,	data: ValueTypes["TimetableEmployeeRoleUpdateInput"]},ValueTypes["TimetableEmployeeRoleUpdateResult"]],
upsertTimetableEmployeeRole?: [{	by: ValueTypes["TimetableEmployeeRoleUniqueWhere"],	filter?: ValueTypes["TimetableEmployeeRoleWhere"] | undefined | null,	update: ValueTypes["TimetableEmployeeRoleUpdateInput"],	create: ValueTypes["TimetableEmployeeRoleCreateInput"]},ValueTypes["TimetableEmployeeRoleUpsertResult"]],
createTimetableShift?: [{	data: ValueTypes["TimetableShiftCreateInput"]},ValueTypes["TimetableShiftCreateResult"]],
deleteTimetableShift?: [{	by: ValueTypes["TimetableShiftUniqueWhere"],	filter?: ValueTypes["TimetableShiftWhere"] | undefined | null},ValueTypes["TimetableShiftDeleteResult"]],
updateTimetableShift?: [{	by: ValueTypes["TimetableShiftUniqueWhere"],	filter?: ValueTypes["TimetableShiftWhere"] | undefined | null,	data: ValueTypes["TimetableShiftUpdateInput"]},ValueTypes["TimetableShiftUpdateResult"]],
upsertTimetableShift?: [{	by: ValueTypes["TimetableShiftUniqueWhere"],	filter?: ValueTypes["TimetableShiftWhere"] | undefined | null,	update: ValueTypes["TimetableShiftUpdateInput"],	create: ValueTypes["TimetableShiftCreateInput"]},ValueTypes["TimetableShiftUpsertResult"]],
createTimetableShiftGroup?: [{	data: ValueTypes["TimetableShiftGroupCreateInput"]},ValueTypes["TimetableShiftGroupCreateResult"]],
deleteTimetableShiftGroup?: [{	by: ValueTypes["TimetableShiftGroupUniqueWhere"],	filter?: ValueTypes["TimetableShiftGroupWhere"] | undefined | null},ValueTypes["TimetableShiftGroupDeleteResult"]],
updateTimetableShiftGroup?: [{	by: ValueTypes["TimetableShiftGroupUniqueWhere"],	filter?: ValueTypes["TimetableShiftGroupWhere"] | undefined | null,	data: ValueTypes["TimetableShiftGroupUpdateInput"]},ValueTypes["TimetableShiftGroupUpdateResult"]],
upsertTimetableShiftGroup?: [{	by: ValueTypes["TimetableShiftGroupUniqueWhere"],	filter?: ValueTypes["TimetableShiftGroupWhere"] | undefined | null,	update: ValueTypes["TimetableShiftGroupUpdateInput"],	create: ValueTypes["TimetableShiftGroupCreateInput"]},ValueTypes["TimetableShiftGroupUpsertResult"]],
createTimetableShiftPosition?: [{	data: ValueTypes["TimetableShiftPositionCreateInput"]},ValueTypes["TimetableShiftPositionCreateResult"]],
deleteTimetableShiftPosition?: [{	by: ValueTypes["TimetableShiftPositionUniqueWhere"],	filter?: ValueTypes["TimetableShiftPositionWhere"] | undefined | null},ValueTypes["TimetableShiftPositionDeleteResult"]],
updateTimetableShiftPosition?: [{	by: ValueTypes["TimetableShiftPositionUniqueWhere"],	filter?: ValueTypes["TimetableShiftPositionWhere"] | undefined | null,	data: ValueTypes["TimetableShiftPositionUpdateInput"]},ValueTypes["TimetableShiftPositionUpdateResult"]],
upsertTimetableShiftPosition?: [{	by: ValueTypes["TimetableShiftPositionUniqueWhere"],	filter?: ValueTypes["TimetableShiftPositionWhere"] | undefined | null,	update: ValueTypes["TimetableShiftPositionUpdateInput"],	create: ValueTypes["TimetableShiftPositionCreateInput"]},ValueTypes["TimetableShiftPositionUpsertResult"]],
createTimetableTemplate?: [{	data: ValueTypes["TimetableTemplateCreateInput"]},ValueTypes["TimetableTemplateCreateResult"]],
deleteTimetableTemplate?: [{	by: ValueTypes["TimetableTemplateUniqueWhere"],	filter?: ValueTypes["TimetableTemplateWhere"] | undefined | null},ValueTypes["TimetableTemplateDeleteResult"]],
updateTimetableTemplate?: [{	by: ValueTypes["TimetableTemplateUniqueWhere"],	filter?: ValueTypes["TimetableTemplateWhere"] | undefined | null,	data: ValueTypes["TimetableTemplateUpdateInput"]},ValueTypes["TimetableTemplateUpdateResult"]],
upsertTimetableTemplate?: [{	by: ValueTypes["TimetableTemplateUniqueWhere"],	filter?: ValueTypes["TimetableTemplateWhere"] | undefined | null,	update: ValueTypes["TimetableTemplateUpdateInput"],	create: ValueTypes["TimetableTemplateCreateInput"]},ValueTypes["TimetableTemplateUpsertResult"]],
createCart?: [{	data: ValueTypes["CartCreateInput"]},ValueTypes["CartCreateResult"]],
deleteCart?: [{	by: ValueTypes["CartUniqueWhere"],	filter?: ValueTypes["CartWhere"] | undefined | null},ValueTypes["CartDeleteResult"]],
updateCart?: [{	by: ValueTypes["CartUniqueWhere"],	filter?: ValueTypes["CartWhere"] | undefined | null,	data: ValueTypes["CartUpdateInput"]},ValueTypes["CartUpdateResult"]],
upsertCart?: [{	by: ValueTypes["CartUniqueWhere"],	filter?: ValueTypes["CartWhere"] | undefined | null,	update: ValueTypes["CartUpdateInput"],	create: ValueTypes["CartCreateInput"]},ValueTypes["CartUpsertResult"]],
createCartItem?: [{	data: ValueTypes["CartItemCreateInput"]},ValueTypes["CartItemCreateResult"]],
deleteCartItem?: [{	by: ValueTypes["CartItemUniqueWhere"],	filter?: ValueTypes["CartItemWhere"] | undefined | null},ValueTypes["CartItemDeleteResult"]],
updateCartItem?: [{	by: ValueTypes["CartItemUniqueWhere"],	filter?: ValueTypes["CartItemWhere"] | undefined | null,	data: ValueTypes["CartItemUpdateInput"]},ValueTypes["CartItemUpdateResult"]],
upsertCartItem?: [{	by: ValueTypes["CartItemUniqueWhere"],	filter?: ValueTypes["CartItemWhere"] | undefined | null,	update: ValueTypes["CartItemUpdateInput"],	create: ValueTypes["CartItemCreateInput"]},ValueTypes["CartItemUpsertResult"]],
createEmployeeQueueItem?: [{	data: ValueTypes["EmployeeQueueItemCreateInput"]},ValueTypes["EmployeeQueueItemCreateResult"]],
deleteEmployeeQueueItem?: [{	by: ValueTypes["EmployeeQueueItemUniqueWhere"],	filter?: ValueTypes["EmployeeQueueItemWhere"] | undefined | null},ValueTypes["EmployeeQueueItemDeleteResult"]],
updateEmployeeQueueItem?: [{	by: ValueTypes["EmployeeQueueItemUniqueWhere"],	filter?: ValueTypes["EmployeeQueueItemWhere"] | undefined | null,	data: ValueTypes["EmployeeQueueItemUpdateInput"]},ValueTypes["EmployeeQueueItemUpdateResult"]],
upsertEmployeeQueueItem?: [{	by: ValueTypes["EmployeeQueueItemUniqueWhere"],	filter?: ValueTypes["EmployeeQueueItemWhere"] | undefined | null,	update: ValueTypes["EmployeeQueueItemUpdateInput"],	create: ValueTypes["EmployeeQueueItemCreateInput"]},ValueTypes["EmployeeQueueItemUpsertResult"]],
createApplication?: [{	data: ValueTypes["ApplicationCreateInput"]},ValueTypes["ApplicationCreateResult"]],
deleteApplication?: [{	by: ValueTypes["ApplicationUniqueWhere"],	filter?: ValueTypes["ApplicationWhere"] | undefined | null},ValueTypes["ApplicationDeleteResult"]],
updateApplication?: [{	by: ValueTypes["ApplicationUniqueWhere"],	filter?: ValueTypes["ApplicationWhere"] | undefined | null,	data: ValueTypes["ApplicationUpdateInput"]},ValueTypes["ApplicationUpdateResult"]],
upsertApplication?: [{	by: ValueTypes["ApplicationUniqueWhere"],	filter?: ValueTypes["ApplicationWhere"] | undefined | null,	update: ValueTypes["ApplicationUpdateInput"],	create: ValueTypes["ApplicationCreateInput"]},ValueTypes["ApplicationUpsertResult"]],
createApplicationShortcutList?: [{	data: ValueTypes["ApplicationShortcutListCreateInput"]},ValueTypes["ApplicationShortcutListCreateResult"]],
deleteApplicationShortcutList?: [{	by: ValueTypes["ApplicationShortcutListUniqueWhere"],	filter?: ValueTypes["ApplicationShortcutListWhere"] | undefined | null},ValueTypes["ApplicationShortcutListDeleteResult"]],
updateApplicationShortcutList?: [{	by: ValueTypes["ApplicationShortcutListUniqueWhere"],	filter?: ValueTypes["ApplicationShortcutListWhere"] | undefined | null,	data: ValueTypes["ApplicationShortcutListUpdateInput"]},ValueTypes["ApplicationShortcutListUpdateResult"]],
upsertApplicationShortcutList?: [{	by: ValueTypes["ApplicationShortcutListUniqueWhere"],	filter?: ValueTypes["ApplicationShortcutListWhere"] | undefined | null,	update: ValueTypes["ApplicationShortcutListUpdateInput"],	create: ValueTypes["ApplicationShortcutListCreateInput"]},ValueTypes["ApplicationShortcutListUpsertResult"]],
createApplicationShortcutListItem?: [{	data: ValueTypes["ApplicationShortcutListItemCreateInput"]},ValueTypes["ApplicationShortcutListItemCreateResult"]],
deleteApplicationShortcutListItem?: [{	by: ValueTypes["ApplicationShortcutListItemUniqueWhere"],	filter?: ValueTypes["ApplicationShortcutListItemWhere"] | undefined | null},ValueTypes["ApplicationShortcutListItemDeleteResult"]],
updateApplicationShortcutListItem?: [{	by: ValueTypes["ApplicationShortcutListItemUniqueWhere"],	filter?: ValueTypes["ApplicationShortcutListItemWhere"] | undefined | null,	data: ValueTypes["ApplicationShortcutListItemUpdateInput"]},ValueTypes["ApplicationShortcutListItemUpdateResult"]],
upsertApplicationShortcutListItem?: [{	by: ValueTypes["ApplicationShortcutListItemUniqueWhere"],	filter?: ValueTypes["ApplicationShortcutListItemWhere"] | undefined | null,	update: ValueTypes["ApplicationShortcutListItemUpdateInput"],	create: ValueTypes["ApplicationShortcutListItemCreateInput"]},ValueTypes["ApplicationShortcutListItemUpsertResult"]],
createProductBanner?: [{	data: ValueTypes["ProductBannerCreateInput"]},ValueTypes["ProductBannerCreateResult"]],
deleteProductBanner?: [{	by: ValueTypes["ProductBannerUniqueWhere"],	filter?: ValueTypes["ProductBannerWhere"] | undefined | null},ValueTypes["ProductBannerDeleteResult"]],
updateProductBanner?: [{	by: ValueTypes["ProductBannerUniqueWhere"],	filter?: ValueTypes["ProductBannerWhere"] | undefined | null,	data: ValueTypes["ProductBannerUpdateInput"]},ValueTypes["ProductBannerUpdateResult"]],
upsertProductBanner?: [{	by: ValueTypes["ProductBannerUniqueWhere"],	filter?: ValueTypes["ProductBannerWhere"] | undefined | null,	update: ValueTypes["ProductBannerUpdateInput"],	create: ValueTypes["ProductBannerCreateInput"]},ValueTypes["ProductBannerUpsertResult"]],
createProductBannerItem?: [{	data: ValueTypes["ProductBannerItemCreateInput"]},ValueTypes["ProductBannerItemCreateResult"]],
deleteProductBannerItem?: [{	by: ValueTypes["ProductBannerItemUniqueWhere"],	filter?: ValueTypes["ProductBannerItemWhere"] | undefined | null},ValueTypes["ProductBannerItemDeleteResult"]],
updateProductBannerItem?: [{	by: ValueTypes["ProductBannerItemUniqueWhere"],	filter?: ValueTypes["ProductBannerItemWhere"] | undefined | null,	data: ValueTypes["ProductBannerItemUpdateInput"]},ValueTypes["ProductBannerItemUpdateResult"]],
upsertProductBannerItem?: [{	by: ValueTypes["ProductBannerItemUniqueWhere"],	filter?: ValueTypes["ProductBannerItemWhere"] | undefined | null,	update: ValueTypes["ProductBannerItemUpdateInput"],	create: ValueTypes["ProductBannerItemCreateInput"]},ValueTypes["ProductBannerItemUpsertResult"]],
createProductBannerList?: [{	data: ValueTypes["ProductBannerListCreateInput"]},ValueTypes["ProductBannerListCreateResult"]],
deleteProductBannerList?: [{	by: ValueTypes["ProductBannerListUniqueWhere"],	filter?: ValueTypes["ProductBannerListWhere"] | undefined | null},ValueTypes["ProductBannerListDeleteResult"]],
updateProductBannerList?: [{	by: ValueTypes["ProductBannerListUniqueWhere"],	filter?: ValueTypes["ProductBannerListWhere"] | undefined | null,	data: ValueTypes["ProductBannerListUpdateInput"]},ValueTypes["ProductBannerListUpdateResult"]],
upsertProductBannerList?: [{	by: ValueTypes["ProductBannerListUniqueWhere"],	filter?: ValueTypes["ProductBannerListWhere"] | undefined | null,	update: ValueTypes["ProductBannerListUpdateInput"],	create: ValueTypes["ProductBannerListCreateInput"]},ValueTypes["ProductBannerListUpsertResult"]],
createBartender?: [{	data: ValueTypes["BartenderCreateInput"]},ValueTypes["BartenderCreateResult"]],
deleteBartender?: [{	by: ValueTypes["BartenderUniqueWhere"],	filter?: ValueTypes["BartenderWhere"] | undefined | null},ValueTypes["BartenderDeleteResult"]],
updateBartender?: [{	by: ValueTypes["BartenderUniqueWhere"],	filter?: ValueTypes["BartenderWhere"] | undefined | null,	data: ValueTypes["BartenderUpdateInput"]},ValueTypes["BartenderUpdateResult"]],
upsertBartender?: [{	by: ValueTypes["BartenderUniqueWhere"],	filter?: ValueTypes["BartenderWhere"] | undefined | null,	update: ValueTypes["BartenderUpdateInput"],	create: ValueTypes["BartenderCreateInput"]},ValueTypes["BartenderUpsertResult"]],
createBusinessToBusinessManager?: [{	data: ValueTypes["BusinessToBusinessManagerCreateInput"]},ValueTypes["BusinessToBusinessManagerCreateResult"]],
deleteBusinessToBusinessManager?: [{	by: ValueTypes["BusinessToBusinessManagerUniqueWhere"],	filter?: ValueTypes["BusinessToBusinessManagerWhere"] | undefined | null},ValueTypes["BusinessToBusinessManagerDeleteResult"]],
updateBusinessToBusinessManager?: [{	by: ValueTypes["BusinessToBusinessManagerUniqueWhere"],	filter?: ValueTypes["BusinessToBusinessManagerWhere"] | undefined | null,	data: ValueTypes["BusinessToBusinessManagerUpdateInput"]},ValueTypes["BusinessToBusinessManagerUpdateResult"]],
upsertBusinessToBusinessManager?: [{	by: ValueTypes["BusinessToBusinessManagerUniqueWhere"],	filter?: ValueTypes["BusinessToBusinessManagerWhere"] | undefined | null,	update: ValueTypes["BusinessToBusinessManagerUpdateInput"],	create: ValueTypes["BusinessToBusinessManagerCreateInput"]},ValueTypes["BusinessToBusinessManagerUpsertResult"]],
createCleaner?: [{	data: ValueTypes["CleanerCreateInput"]},ValueTypes["CleanerCreateResult"]],
deleteCleaner?: [{	by: ValueTypes["CleanerUniqueWhere"],	filter?: ValueTypes["CleanerWhere"] | undefined | null},ValueTypes["CleanerDeleteResult"]],
updateCleaner?: [{	by: ValueTypes["CleanerUniqueWhere"],	filter?: ValueTypes["CleanerWhere"] | undefined | null,	data: ValueTypes["CleanerUpdateInput"]},ValueTypes["CleanerUpdateResult"]],
upsertCleaner?: [{	by: ValueTypes["CleanerUniqueWhere"],	filter?: ValueTypes["CleanerWhere"] | undefined | null,	update: ValueTypes["CleanerUpdateInput"],	create: ValueTypes["CleanerCreateInput"]},ValueTypes["CleanerUpsertResult"]],
createCourier?: [{	data: ValueTypes["CourierCreateInput"]},ValueTypes["CourierCreateResult"]],
deleteCourier?: [{	by: ValueTypes["CourierUniqueWhere"],	filter?: ValueTypes["CourierWhere"] | undefined | null},ValueTypes["CourierDeleteResult"]],
updateCourier?: [{	by: ValueTypes["CourierUniqueWhere"],	filter?: ValueTypes["CourierWhere"] | undefined | null,	data: ValueTypes["CourierUpdateInput"]},ValueTypes["CourierUpdateResult"]],
upsertCourier?: [{	by: ValueTypes["CourierUniqueWhere"],	filter?: ValueTypes["CourierWhere"] | undefined | null,	update: ValueTypes["CourierUpdateInput"],	create: ValueTypes["CourierCreateInput"]},ValueTypes["CourierUpsertResult"]],
createShiftsManager?: [{	data: ValueTypes["ShiftsManagerCreateInput"]},ValueTypes["ShiftsManagerCreateResult"]],
deleteShiftsManager?: [{	by: ValueTypes["ShiftsManagerUniqueWhere"],	filter?: ValueTypes["ShiftsManagerWhere"] | undefined | null},ValueTypes["ShiftsManagerDeleteResult"]],
updateShiftsManager?: [{	by: ValueTypes["ShiftsManagerUniqueWhere"],	filter?: ValueTypes["ShiftsManagerWhere"] | undefined | null,	data: ValueTypes["ShiftsManagerUpdateInput"]},ValueTypes["ShiftsManagerUpdateResult"]],
upsertShiftsManager?: [{	by: ValueTypes["ShiftsManagerUniqueWhere"],	filter?: ValueTypes["ShiftsManagerWhere"] | undefined | null,	update: ValueTypes["ShiftsManagerUpdateInput"],	create: ValueTypes["ShiftsManagerCreateInput"]},ValueTypes["ShiftsManagerUpsertResult"]],
createUser?: [{	data: ValueTypes["UserCreateInput"]},ValueTypes["UserCreateResult"]],
deleteUser?: [{	by: ValueTypes["UserUniqueWhere"],	filter?: ValueTypes["UserWhere"] | undefined | null},ValueTypes["UserDeleteResult"]],
updateUser?: [{	by: ValueTypes["UserUniqueWhere"],	filter?: ValueTypes["UserWhere"] | undefined | null,	data: ValueTypes["UserUpdateInput"]},ValueTypes["UserUpdateResult"]],
upsertUser?: [{	by: ValueTypes["UserUniqueWhere"],	filter?: ValueTypes["UserWhere"] | undefined | null,	update: ValueTypes["UserUpdateInput"],	create: ValueTypes["UserCreateInput"]},ValueTypes["UserUpsertResult"]],
createShiftsProfile?: [{	data: ValueTypes["ShiftsProfileCreateInput"]},ValueTypes["ShiftsProfileCreateResult"]],
deleteShiftsProfile?: [{	by: ValueTypes["ShiftsProfileUniqueWhere"],	filter?: ValueTypes["ShiftsProfileWhere"] | undefined | null},ValueTypes["ShiftsProfileDeleteResult"]],
updateShiftsProfile?: [{	by: ValueTypes["ShiftsProfileUniqueWhere"],	filter?: ValueTypes["ShiftsProfileWhere"] | undefined | null,	data: ValueTypes["ShiftsProfileUpdateInput"]},ValueTypes["ShiftsProfileUpdateResult"]],
upsertShiftsProfile?: [{	by: ValueTypes["ShiftsProfileUniqueWhere"],	filter?: ValueTypes["ShiftsProfileWhere"] | undefined | null,	update: ValueTypes["ShiftsProfileUpdateInput"],	create: ValueTypes["ShiftsProfileCreateInput"]},ValueTypes["ShiftsProfileUpsertResult"]],
createProductIngredientCategory?: [{	data: ValueTypes["ProductIngredientCategoryCreateInput"]},ValueTypes["ProductIngredientCategoryCreateResult"]],
deleteProductIngredientCategory?: [{	by: ValueTypes["ProductIngredientCategoryUniqueWhere"],	filter?: ValueTypes["ProductIngredientCategoryWhere"] | undefined | null},ValueTypes["ProductIngredientCategoryDeleteResult"]],
updateProductIngredientCategory?: [{	by: ValueTypes["ProductIngredientCategoryUniqueWhere"],	filter?: ValueTypes["ProductIngredientCategoryWhere"] | undefined | null,	data: ValueTypes["ProductIngredientCategoryUpdateInput"]},ValueTypes["ProductIngredientCategoryUpdateResult"]],
upsertProductIngredientCategory?: [{	by: ValueTypes["ProductIngredientCategoryUniqueWhere"],	filter?: ValueTypes["ProductIngredientCategoryWhere"] | undefined | null,	update: ValueTypes["ProductIngredientCategoryUpdateInput"],	create: ValueTypes["ProductIngredientCategoryCreateInput"]},ValueTypes["ProductIngredientCategoryUpsertResult"]],
createProductIngredientCategoryLocale?: [{	data: ValueTypes["ProductIngredientCategoryLocaleCreateInput"]},ValueTypes["ProductIngredientCategoryLocaleCreateResult"]],
deleteProductIngredientCategoryLocale?: [{	by: ValueTypes["ProductIngredientCategoryLocaleUniqueWhere"],	filter?: ValueTypes["ProductIngredientCategoryLocaleWhere"] | undefined | null},ValueTypes["ProductIngredientCategoryLocaleDeleteResult"]],
updateProductIngredientCategoryLocale?: [{	by: ValueTypes["ProductIngredientCategoryLocaleUniqueWhere"],	filter?: ValueTypes["ProductIngredientCategoryLocaleWhere"] | undefined | null,	data: ValueTypes["ProductIngredientCategoryLocaleUpdateInput"]},ValueTypes["ProductIngredientCategoryLocaleUpdateResult"]],
upsertProductIngredientCategoryLocale?: [{	by: ValueTypes["ProductIngredientCategoryLocaleUniqueWhere"],	filter?: ValueTypes["ProductIngredientCategoryLocaleWhere"] | undefined | null,	update: ValueTypes["ProductIngredientCategoryLocaleUpdateInput"],	create: ValueTypes["ProductIngredientCategoryLocaleCreateInput"]},ValueTypes["ProductIngredientCategoryLocaleUpsertResult"]],
createStocksManager?: [{	data: ValueTypes["StocksManagerCreateInput"]},ValueTypes["StocksManagerCreateResult"]],
deleteStocksManager?: [{	by: ValueTypes["StocksManagerUniqueWhere"],	filter?: ValueTypes["StocksManagerWhere"] | undefined | null},ValueTypes["StocksManagerDeleteResult"]],
updateStocksManager?: [{	by: ValueTypes["StocksManagerUniqueWhere"],	filter?: ValueTypes["StocksManagerWhere"] | undefined | null,	data: ValueTypes["StocksManagerUpdateInput"]},ValueTypes["StocksManagerUpdateResult"]],
upsertStocksManager?: [{	by: ValueTypes["StocksManagerUniqueWhere"],	filter?: ValueTypes["StocksManagerWhere"] | undefined | null,	update: ValueTypes["StocksManagerUpdateInput"],	create: ValueTypes["StocksManagerCreateInput"]},ValueTypes["StocksManagerUpsertResult"]],
createDeliveryRoute?: [{	data: ValueTypes["DeliveryRouteCreateInput"]},ValueTypes["DeliveryRouteCreateResult"]],
deleteDeliveryRoute?: [{	by: ValueTypes["DeliveryRouteUniqueWhere"],	filter?: ValueTypes["DeliveryRouteWhere"] | undefined | null},ValueTypes["DeliveryRouteDeleteResult"]],
updateDeliveryRoute?: [{	by: ValueTypes["DeliveryRouteUniqueWhere"],	filter?: ValueTypes["DeliveryRouteWhere"] | undefined | null,	data: ValueTypes["DeliveryRouteUpdateInput"]},ValueTypes["DeliveryRouteUpdateResult"]],
upsertDeliveryRoute?: [{	by: ValueTypes["DeliveryRouteUniqueWhere"],	filter?: ValueTypes["DeliveryRouteWhere"] | undefined | null,	update: ValueTypes["DeliveryRouteUpdateInput"],	create: ValueTypes["DeliveryRouteCreateInput"]},ValueTypes["DeliveryRouteUpsertResult"]],
createDeliveryWaypoint?: [{	data: ValueTypes["DeliveryWaypointCreateInput"]},ValueTypes["DeliveryWaypointCreateResult"]],
deleteDeliveryWaypoint?: [{	by: ValueTypes["DeliveryWaypointUniqueWhere"],	filter?: ValueTypes["DeliveryWaypointWhere"] | undefined | null},ValueTypes["DeliveryWaypointDeleteResult"]],
updateDeliveryWaypoint?: [{	by: ValueTypes["DeliveryWaypointUniqueWhere"],	filter?: ValueTypes["DeliveryWaypointWhere"] | undefined | null,	data: ValueTypes["DeliveryWaypointUpdateInput"]},ValueTypes["DeliveryWaypointUpdateResult"]],
upsertDeliveryWaypoint?: [{	by: ValueTypes["DeliveryWaypointUniqueWhere"],	filter?: ValueTypes["DeliveryWaypointWhere"] | undefined | null,	update: ValueTypes["DeliveryWaypointUpdateInput"],	create: ValueTypes["DeliveryWaypointCreateInput"]},ValueTypes["DeliveryWaypointUpsertResult"]],
createAllergen?: [{	data: ValueTypes["AllergenCreateInput"]},ValueTypes["AllergenCreateResult"]],
deleteAllergen?: [{	by: ValueTypes["AllergenUniqueWhere"],	filter?: ValueTypes["AllergenWhere"] | undefined | null},ValueTypes["AllergenDeleteResult"]],
updateAllergen?: [{	by: ValueTypes["AllergenUniqueWhere"],	filter?: ValueTypes["AllergenWhere"] | undefined | null,	data: ValueTypes["AllergenUpdateInput"]},ValueTypes["AllergenUpdateResult"]],
upsertAllergen?: [{	by: ValueTypes["AllergenUniqueWhere"],	filter?: ValueTypes["AllergenWhere"] | undefined | null,	update: ValueTypes["AllergenUpdateInput"],	create: ValueTypes["AllergenCreateInput"]},ValueTypes["AllergenUpsertResult"]],
createAllergenLocale?: [{	data: ValueTypes["AllergenLocaleCreateInput"]},ValueTypes["AllergenLocaleCreateResult"]],
deleteAllergenLocale?: [{	by: ValueTypes["AllergenLocaleUniqueWhere"],	filter?: ValueTypes["AllergenLocaleWhere"] | undefined | null},ValueTypes["AllergenLocaleDeleteResult"]],
updateAllergenLocale?: [{	by: ValueTypes["AllergenLocaleUniqueWhere"],	filter?: ValueTypes["AllergenLocaleWhere"] | undefined | null,	data: ValueTypes["AllergenLocaleUpdateInput"]},ValueTypes["AllergenLocaleUpdateResult"]],
upsertAllergenLocale?: [{	by: ValueTypes["AllergenLocaleUniqueWhere"],	filter?: ValueTypes["AllergenLocaleWhere"] | undefined | null,	update: ValueTypes["AllergenLocaleUpdateInput"],	create: ValueTypes["AllergenLocaleCreateInput"]},ValueTypes["AllergenLocaleUpsertResult"]],
createGps?: [{	data: ValueTypes["GpsCreateInput"]},ValueTypes["GpsCreateResult"]],
deleteGps?: [{	by: ValueTypes["GpsUniqueWhere"],	filter?: ValueTypes["GpsWhere"] | undefined | null},ValueTypes["GpsDeleteResult"]],
updateGps?: [{	by: ValueTypes["GpsUniqueWhere"],	filter?: ValueTypes["GpsWhere"] | undefined | null,	data: ValueTypes["GpsUpdateInput"]},ValueTypes["GpsUpdateResult"]],
upsertGps?: [{	by: ValueTypes["GpsUniqueWhere"],	filter?: ValueTypes["GpsWhere"] | undefined | null,	update: ValueTypes["GpsUpdateInput"],	create: ValueTypes["GpsCreateInput"]},ValueTypes["GpsUpsertResult"]],
createWeekHours?: [{	data: ValueTypes["WeekHoursCreateInput"]},ValueTypes["WeekHoursCreateResult"]],
deleteWeekHours?: [{	by: ValueTypes["WeekHoursUniqueWhere"],	filter?: ValueTypes["WeekHoursWhere"] | undefined | null},ValueTypes["WeekHoursDeleteResult"]],
updateWeekHours?: [{	by: ValueTypes["WeekHoursUniqueWhere"],	filter?: ValueTypes["WeekHoursWhere"] | undefined | null,	data: ValueTypes["WeekHoursUpdateInput"]},ValueTypes["WeekHoursUpdateResult"]],
upsertWeekHours?: [{	by: ValueTypes["WeekHoursUniqueWhere"],	filter?: ValueTypes["WeekHoursWhere"] | undefined | null,	update: ValueTypes["WeekHoursUpdateInput"],	create: ValueTypes["WeekHoursCreateInput"]},ValueTypes["WeekHoursUpsertResult"]],
createPreparedIngredientQuantity?: [{	data: ValueTypes["PreparedIngredientQuantityCreateInput"]},ValueTypes["PreparedIngredientQuantityCreateResult"]],
deletePreparedIngredientQuantity?: [{	by: ValueTypes["PreparedIngredientQuantityUniqueWhere"],	filter?: ValueTypes["PreparedIngredientQuantityWhere"] | undefined | null},ValueTypes["PreparedIngredientQuantityDeleteResult"]],
updatePreparedIngredientQuantity?: [{	by: ValueTypes["PreparedIngredientQuantityUniqueWhere"],	filter?: ValueTypes["PreparedIngredientQuantityWhere"] | undefined | null,	data: ValueTypes["PreparedIngredientQuantityUpdateInput"]},ValueTypes["PreparedIngredientQuantityUpdateResult"]],
upsertPreparedIngredientQuantity?: [{	by: ValueTypes["PreparedIngredientQuantityUniqueWhere"],	filter?: ValueTypes["PreparedIngredientQuantityWhere"] | undefined | null,	update: ValueTypes["PreparedIngredientQuantityUpdateInput"],	create: ValueTypes["PreparedIngredientQuantityCreateInput"]},ValueTypes["PreparedIngredientQuantityUpsertResult"]],
createPreparedRecipeQuantity?: [{	data: ValueTypes["PreparedRecipeQuantityCreateInput"]},ValueTypes["PreparedRecipeQuantityCreateResult"]],
deletePreparedRecipeQuantity?: [{	by: ValueTypes["PreparedRecipeQuantityUniqueWhere"],	filter?: ValueTypes["PreparedRecipeQuantityWhere"] | undefined | null},ValueTypes["PreparedRecipeQuantityDeleteResult"]],
updatePreparedRecipeQuantity?: [{	by: ValueTypes["PreparedRecipeQuantityUniqueWhere"],	filter?: ValueTypes["PreparedRecipeQuantityWhere"] | undefined | null,	data: ValueTypes["PreparedRecipeQuantityUpdateInput"]},ValueTypes["PreparedRecipeQuantityUpdateResult"]],
upsertPreparedRecipeQuantity?: [{	by: ValueTypes["PreparedRecipeQuantityUniqueWhere"],	filter?: ValueTypes["PreparedRecipeQuantityWhere"] | undefined | null,	update: ValueTypes["PreparedRecipeQuantityUpdateInput"],	create: ValueTypes["PreparedRecipeQuantityCreateInput"]},ValueTypes["PreparedRecipeQuantityUpsertResult"]],
createInternalOrder?: [{	data: ValueTypes["InternalOrderCreateInput"]},ValueTypes["InternalOrderCreateResult"]],
deleteInternalOrder?: [{	by: ValueTypes["InternalOrderUniqueWhere"],	filter?: ValueTypes["InternalOrderWhere"] | undefined | null},ValueTypes["InternalOrderDeleteResult"]],
updateInternalOrder?: [{	by: ValueTypes["InternalOrderUniqueWhere"],	filter?: ValueTypes["InternalOrderWhere"] | undefined | null,	data: ValueTypes["InternalOrderUpdateInput"]},ValueTypes["InternalOrderUpdateResult"]],
upsertInternalOrder?: [{	by: ValueTypes["InternalOrderUniqueWhere"],	filter?: ValueTypes["InternalOrderWhere"] | undefined | null,	update: ValueTypes["InternalOrderUpdateInput"],	create: ValueTypes["InternalOrderCreateInput"]},ValueTypes["InternalOrderUpsertResult"]],
createInternalOrderItem?: [{	data: ValueTypes["InternalOrderItemCreateInput"]},ValueTypes["InternalOrderItemCreateResult"]],
deleteInternalOrderItem?: [{	by: ValueTypes["InternalOrderItemUniqueWhere"],	filter?: ValueTypes["InternalOrderItemWhere"] | undefined | null},ValueTypes["InternalOrderItemDeleteResult"]],
updateInternalOrderItem?: [{	by: ValueTypes["InternalOrderItemUniqueWhere"],	filter?: ValueTypes["InternalOrderItemWhere"] | undefined | null,	data: ValueTypes["InternalOrderItemUpdateInput"]},ValueTypes["InternalOrderItemUpdateResult"]],
upsertInternalOrderItem?: [{	by: ValueTypes["InternalOrderItemUniqueWhere"],	filter?: ValueTypes["InternalOrderItemWhere"] | undefined | null,	update: ValueTypes["InternalOrderItemUpdateInput"],	create: ValueTypes["InternalOrderItemCreateInput"]},ValueTypes["InternalOrderItemUpsertResult"]],
createPreparedPackingQuantity?: [{	data: ValueTypes["PreparedPackingQuantityCreateInput"]},ValueTypes["PreparedPackingQuantityCreateResult"]],
deletePreparedPackingQuantity?: [{	by: ValueTypes["PreparedPackingQuantityUniqueWhere"],	filter?: ValueTypes["PreparedPackingQuantityWhere"] | undefined | null},ValueTypes["PreparedPackingQuantityDeleteResult"]],
updatePreparedPackingQuantity?: [{	by: ValueTypes["PreparedPackingQuantityUniqueWhere"],	filter?: ValueTypes["PreparedPackingQuantityWhere"] | undefined | null,	data: ValueTypes["PreparedPackingQuantityUpdateInput"]},ValueTypes["PreparedPackingQuantityUpdateResult"]],
upsertPreparedPackingQuantity?: [{	by: ValueTypes["PreparedPackingQuantityUniqueWhere"],	filter?: ValueTypes["PreparedPackingQuantityWhere"] | undefined | null,	update: ValueTypes["PreparedPackingQuantityUpdateInput"],	create: ValueTypes["PreparedPackingQuantityCreateInput"]},ValueTypes["PreparedPackingQuantityUpsertResult"]],
createCourierManager?: [{	data: ValueTypes["CourierManagerCreateInput"]},ValueTypes["CourierManagerCreateResult"]],
deleteCourierManager?: [{	by: ValueTypes["CourierManagerUniqueWhere"],	filter?: ValueTypes["CourierManagerWhere"] | undefined | null},ValueTypes["CourierManagerDeleteResult"]],
updateCourierManager?: [{	by: ValueTypes["CourierManagerUniqueWhere"],	filter?: ValueTypes["CourierManagerWhere"] | undefined | null,	data: ValueTypes["CourierManagerUpdateInput"]},ValueTypes["CourierManagerUpdateResult"]],
upsertCourierManager?: [{	by: ValueTypes["CourierManagerUniqueWhere"],	filter?: ValueTypes["CourierManagerWhere"] | undefined | null,	update: ValueTypes["CourierManagerUpdateInput"],	create: ValueTypes["CourierManagerCreateInput"]},ValueTypes["CourierManagerUpsertResult"]],
createDeliveryZone?: [{	data: ValueTypes["DeliveryZoneCreateInput"]},ValueTypes["DeliveryZoneCreateResult"]],
deleteDeliveryZone?: [{	by: ValueTypes["DeliveryZoneUniqueWhere"],	filter?: ValueTypes["DeliveryZoneWhere"] | undefined | null},ValueTypes["DeliveryZoneDeleteResult"]],
updateDeliveryZone?: [{	by: ValueTypes["DeliveryZoneUniqueWhere"],	filter?: ValueTypes["DeliveryZoneWhere"] | undefined | null,	data: ValueTypes["DeliveryZoneUpdateInput"]},ValueTypes["DeliveryZoneUpdateResult"]],
upsertDeliveryZone?: [{	by: ValueTypes["DeliveryZoneUniqueWhere"],	filter?: ValueTypes["DeliveryZoneWhere"] | undefined | null,	update: ValueTypes["DeliveryZoneUpdateInput"],	create: ValueTypes["DeliveryZoneCreateInput"]},ValueTypes["DeliveryZoneUpsertResult"]],
createDeliveryTimelinePreset?: [{	data: ValueTypes["DeliveryTimelinePresetCreateInput"]},ValueTypes["DeliveryTimelinePresetCreateResult"]],
deleteDeliveryTimelinePreset?: [{	by: ValueTypes["DeliveryTimelinePresetUniqueWhere"],	filter?: ValueTypes["DeliveryTimelinePresetWhere"] | undefined | null},ValueTypes["DeliveryTimelinePresetDeleteResult"]],
updateDeliveryTimelinePreset?: [{	by: ValueTypes["DeliveryTimelinePresetUniqueWhere"],	filter?: ValueTypes["DeliveryTimelinePresetWhere"] | undefined | null,	data: ValueTypes["DeliveryTimelinePresetUpdateInput"]},ValueTypes["DeliveryTimelinePresetUpdateResult"]],
upsertDeliveryTimelinePreset?: [{	by: ValueTypes["DeliveryTimelinePresetUniqueWhere"],	filter?: ValueTypes["DeliveryTimelinePresetWhere"] | undefined | null,	update: ValueTypes["DeliveryTimelinePresetUpdateInput"],	create: ValueTypes["DeliveryTimelinePresetCreateInput"]},ValueTypes["DeliveryTimelinePresetUpsertResult"]],
createOrderDeliveryTimeline?: [{	data: ValueTypes["OrderDeliveryTimelineCreateInput"]},ValueTypes["OrderDeliveryTimelineCreateResult"]],
deleteOrderDeliveryTimeline?: [{	by: ValueTypes["OrderDeliveryTimelineUniqueWhere"],	filter?: ValueTypes["OrderDeliveryTimelineWhere"] | undefined | null},ValueTypes["OrderDeliveryTimelineDeleteResult"]],
updateOrderDeliveryTimeline?: [{	by: ValueTypes["OrderDeliveryTimelineUniqueWhere"],	filter?: ValueTypes["OrderDeliveryTimelineWhere"] | undefined | null,	data: ValueTypes["OrderDeliveryTimelineUpdateInput"]},ValueTypes["OrderDeliveryTimelineUpdateResult"]],
upsertOrderDeliveryTimeline?: [{	by: ValueTypes["OrderDeliveryTimelineUniqueWhere"],	filter?: ValueTypes["OrderDeliveryTimelineWhere"] | undefined | null,	update: ValueTypes["OrderDeliveryTimelineUpdateInput"],	create: ValueTypes["OrderDeliveryTimelineCreateInput"]},ValueTypes["OrderDeliveryTimelineUpsertResult"]],
createOrderEvent?: [{	data: ValueTypes["OrderEventCreateInput"]},ValueTypes["OrderEventCreateResult"]],
deleteOrderEvent?: [{	by: ValueTypes["OrderEventUniqueWhere"],	filter?: ValueTypes["OrderEventWhere"] | undefined | null},ValueTypes["OrderEventDeleteResult"]],
updateOrderEvent?: [{	by: ValueTypes["OrderEventUniqueWhere"],	filter?: ValueTypes["OrderEventWhere"] | undefined | null,	data: ValueTypes["OrderEventUpdateInput"]},ValueTypes["OrderEventUpdateResult"]],
upsertOrderEvent?: [{	by: ValueTypes["OrderEventUniqueWhere"],	filter?: ValueTypes["OrderEventWhere"] | undefined | null,	update: ValueTypes["OrderEventUpdateInput"],	create: ValueTypes["OrderEventCreateInput"]},ValueTypes["OrderEventUpsertResult"]],
createLiftagoRide?: [{	data: ValueTypes["LiftagoRideCreateInput"]},ValueTypes["LiftagoRideCreateResult"]],
deleteLiftagoRide?: [{	by: ValueTypes["LiftagoRideUniqueWhere"],	filter?: ValueTypes["LiftagoRideWhere"] | undefined | null},ValueTypes["LiftagoRideDeleteResult"]],
updateLiftagoRide?: [{	by: ValueTypes["LiftagoRideUniqueWhere"],	filter?: ValueTypes["LiftagoRideWhere"] | undefined | null,	data: ValueTypes["LiftagoRideUpdateInput"]},ValueTypes["LiftagoRideUpdateResult"]],
upsertLiftagoRide?: [{	by: ValueTypes["LiftagoRideUniqueWhere"],	filter?: ValueTypes["LiftagoRideWhere"] | undefined | null,	update: ValueTypes["LiftagoRideUpdateInput"],	create: ValueTypes["LiftagoRideCreateInput"]},ValueTypes["LiftagoRideUpsertResult"]],
createInvoice?: [{	data: ValueTypes["InvoiceCreateInput"]},ValueTypes["InvoiceCreateResult"]],
deleteInvoice?: [{	by: ValueTypes["InvoiceUniqueWhere"],	filter?: ValueTypes["InvoiceWhere"] | undefined | null},ValueTypes["InvoiceDeleteResult"]],
updateInvoice?: [{	by: ValueTypes["InvoiceUniqueWhere"],	filter?: ValueTypes["InvoiceWhere"] | undefined | null,	data: ValueTypes["InvoiceUpdateInput"]},ValueTypes["InvoiceUpdateResult"]],
upsertInvoice?: [{	by: ValueTypes["InvoiceUniqueWhere"],	filter?: ValueTypes["InvoiceWhere"] | undefined | null,	update: ValueTypes["InvoiceUpdateInput"],	create: ValueTypes["InvoiceCreateInput"]},ValueTypes["InvoiceUpsertResult"]],
createInvoicingPlan?: [{	data: ValueTypes["InvoicingPlanCreateInput"]},ValueTypes["InvoicingPlanCreateResult"]],
deleteInvoicingPlan?: [{	by: ValueTypes["InvoicingPlanUniqueWhere"],	filter?: ValueTypes["InvoicingPlanWhere"] | undefined | null},ValueTypes["InvoicingPlanDeleteResult"]],
updateInvoicingPlan?: [{	by: ValueTypes["InvoicingPlanUniqueWhere"],	filter?: ValueTypes["InvoicingPlanWhere"] | undefined | null,	data: ValueTypes["InvoicingPlanUpdateInput"]},ValueTypes["InvoicingPlanUpdateResult"]],
upsertInvoicingPlan?: [{	by: ValueTypes["InvoicingPlanUniqueWhere"],	filter?: ValueTypes["InvoicingPlanWhere"] | undefined | null,	update: ValueTypes["InvoicingPlanUpdateInput"],	create: ValueTypes["InvoicingPlanCreateInput"]},ValueTypes["InvoicingPlanUpsertResult"]],
createProductPackingLocale?: [{	data: ValueTypes["ProductPackingLocaleCreateInput"]},ValueTypes["ProductPackingLocaleCreateResult"]],
deleteProductPackingLocale?: [{	by: ValueTypes["ProductPackingLocaleUniqueWhere"],	filter?: ValueTypes["ProductPackingLocaleWhere"] | undefined | null},ValueTypes["ProductPackingLocaleDeleteResult"]],
updateProductPackingLocale?: [{	by: ValueTypes["ProductPackingLocaleUniqueWhere"],	filter?: ValueTypes["ProductPackingLocaleWhere"] | undefined | null,	data: ValueTypes["ProductPackingLocaleUpdateInput"]},ValueTypes["ProductPackingLocaleUpdateResult"]],
upsertProductPackingLocale?: [{	by: ValueTypes["ProductPackingLocaleUniqueWhere"],	filter?: ValueTypes["ProductPackingLocaleWhere"] | undefined | null,	update: ValueTypes["ProductPackingLocaleUpdateInput"],	create: ValueTypes["ProductPackingLocaleCreateInput"]},ValueTypes["ProductPackingLocaleUpsertResult"]],
createProductLocale?: [{	data: ValueTypes["ProductLocaleCreateInput"]},ValueTypes["ProductLocaleCreateResult"]],
deleteProductLocale?: [{	by: ValueTypes["ProductLocaleUniqueWhere"],	filter?: ValueTypes["ProductLocaleWhere"] | undefined | null},ValueTypes["ProductLocaleDeleteResult"]],
updateProductLocale?: [{	by: ValueTypes["ProductLocaleUniqueWhere"],	filter?: ValueTypes["ProductLocaleWhere"] | undefined | null,	data: ValueTypes["ProductLocaleUpdateInput"]},ValueTypes["ProductLocaleUpdateResult"]],
upsertProductLocale?: [{	by: ValueTypes["ProductLocaleUniqueWhere"],	filter?: ValueTypes["ProductLocaleWhere"] | undefined | null,	update: ValueTypes["ProductLocaleUpdateInput"],	create: ValueTypes["ProductLocaleCreateInput"]},ValueTypes["ProductLocaleUpsertResult"]],
createProductRecipeLocale?: [{	data: ValueTypes["ProductRecipeLocaleCreateInput"]},ValueTypes["ProductRecipeLocaleCreateResult"]],
deleteProductRecipeLocale?: [{	by: ValueTypes["ProductRecipeLocaleUniqueWhere"],	filter?: ValueTypes["ProductRecipeLocaleWhere"] | undefined | null},ValueTypes["ProductRecipeLocaleDeleteResult"]],
updateProductRecipeLocale?: [{	by: ValueTypes["ProductRecipeLocaleUniqueWhere"],	filter?: ValueTypes["ProductRecipeLocaleWhere"] | undefined | null,	data: ValueTypes["ProductRecipeLocaleUpdateInput"]},ValueTypes["ProductRecipeLocaleUpdateResult"]],
upsertProductRecipeLocale?: [{	by: ValueTypes["ProductRecipeLocaleUniqueWhere"],	filter?: ValueTypes["ProductRecipeLocaleWhere"] | undefined | null,	update: ValueTypes["ProductRecipeLocaleUpdateInput"],	create: ValueTypes["ProductRecipeLocaleCreateInput"]},ValueTypes["ProductRecipeLocaleUpsertResult"]],
createUserDevice?: [{	data: ValueTypes["UserDeviceCreateInput"]},ValueTypes["UserDeviceCreateResult"]],
deleteUserDevice?: [{	by: ValueTypes["UserDeviceUniqueWhere"],	filter?: ValueTypes["UserDeviceWhere"] | undefined | null},ValueTypes["UserDeviceDeleteResult"]],
updateUserDevice?: [{	by: ValueTypes["UserDeviceUniqueWhere"],	filter?: ValueTypes["UserDeviceWhere"] | undefined | null,	data: ValueTypes["UserDeviceUpdateInput"]},ValueTypes["UserDeviceUpdateResult"]],
upsertUserDevice?: [{	by: ValueTypes["UserDeviceUniqueWhere"],	filter?: ValueTypes["UserDeviceWhere"] | undefined | null,	update: ValueTypes["UserDeviceUpdateInput"],	create: ValueTypes["UserDeviceCreateInput"]},ValueTypes["UserDeviceUpsertResult"]],
createProtectedAction?: [{	data: ValueTypes["ProtectedActionCreateInput"]},ValueTypes["ProtectedActionCreateResult"]],
deleteProtectedAction?: [{	by: ValueTypes["ProtectedActionUniqueWhere"],	filter?: ValueTypes["ProtectedActionWhere"] | undefined | null},ValueTypes["ProtectedActionDeleteResult"]],
updateProtectedAction?: [{	by: ValueTypes["ProtectedActionUniqueWhere"],	filter?: ValueTypes["ProtectedActionWhere"] | undefined | null,	data: ValueTypes["ProtectedActionUpdateInput"]},ValueTypes["ProtectedActionUpdateResult"]],
upsertProtectedAction?: [{	by: ValueTypes["ProtectedActionUniqueWhere"],	filter?: ValueTypes["ProtectedActionWhere"] | undefined | null,	update: ValueTypes["ProtectedActionUpdateInput"],	create: ValueTypes["ProtectedActionCreateInput"]},ValueTypes["ProtectedActionUpsertResult"]],
createPicker?: [{	data: ValueTypes["PickerCreateInput"]},ValueTypes["PickerCreateResult"]],
deletePicker?: [{	by: ValueTypes["PickerUniqueWhere"],	filter?: ValueTypes["PickerWhere"] | undefined | null},ValueTypes["PickerDeleteResult"]],
updatePicker?: [{	by: ValueTypes["PickerUniqueWhere"],	filter?: ValueTypes["PickerWhere"] | undefined | null,	data: ValueTypes["PickerUpdateInput"]},ValueTypes["PickerUpdateResult"]],
upsertPicker?: [{	by: ValueTypes["PickerUniqueWhere"],	filter?: ValueTypes["PickerWhere"] | undefined | null,	update: ValueTypes["PickerUpdateInput"],	create: ValueTypes["PickerCreateInput"]},ValueTypes["PickerUpsertResult"]],
createTimetableTemplateStaffOptions?: [{	data: ValueTypes["TimetableTemplateStaffOptionsCreateInput"]},ValueTypes["TimetableTemplateStaffOptionsCreateResult"]],
deleteTimetableTemplateStaffOptions?: [{	by: ValueTypes["TimetableTemplateStaffOptionsUniqueWhere"],	filter?: ValueTypes["TimetableTemplateStaffOptionsWhere"] | undefined | null},ValueTypes["TimetableTemplateStaffOptionsDeleteResult"]],
updateTimetableTemplateStaffOptions?: [{	by: ValueTypes["TimetableTemplateStaffOptionsUniqueWhere"],	filter?: ValueTypes["TimetableTemplateStaffOptionsWhere"] | undefined | null,	data: ValueTypes["TimetableTemplateStaffOptionsUpdateInput"]},ValueTypes["TimetableTemplateStaffOptionsUpdateResult"]],
upsertTimetableTemplateStaffOptions?: [{	by: ValueTypes["TimetableTemplateStaffOptionsUniqueWhere"],	filter?: ValueTypes["TimetableTemplateStaffOptionsWhere"] | undefined | null,	update: ValueTypes["TimetableTemplateStaffOptionsUpdateInput"],	create: ValueTypes["TimetableTemplateStaffOptionsCreateInput"]},ValueTypes["TimetableTemplateStaffOptionsUpsertResult"]],
createShoppingList?: [{	data: ValueTypes["ShoppingListCreateInput"]},ValueTypes["ShoppingListCreateResult"]],
deleteShoppingList?: [{	by: ValueTypes["ShoppingListUniqueWhere"],	filter?: ValueTypes["ShoppingListWhere"] | undefined | null},ValueTypes["ShoppingListDeleteResult"]],
updateShoppingList?: [{	by: ValueTypes["ShoppingListUniqueWhere"],	filter?: ValueTypes["ShoppingListWhere"] | undefined | null,	data: ValueTypes["ShoppingListUpdateInput"]},ValueTypes["ShoppingListUpdateResult"]],
upsertShoppingList?: [{	by: ValueTypes["ShoppingListUniqueWhere"],	filter?: ValueTypes["ShoppingListWhere"] | undefined | null,	update: ValueTypes["ShoppingListUpdateInput"],	create: ValueTypes["ShoppingListCreateInput"]},ValueTypes["ShoppingListUpsertResult"]],
createSuppliesPurchase?: [{	data: ValueTypes["SuppliesPurchaseCreateInput"]},ValueTypes["SuppliesPurchaseCreateResult"]],
deleteSuppliesPurchase?: [{	by: ValueTypes["SuppliesPurchaseUniqueWhere"],	filter?: ValueTypes["SuppliesPurchaseWhere"] | undefined | null},ValueTypes["SuppliesPurchaseDeleteResult"]],
updateSuppliesPurchase?: [{	by: ValueTypes["SuppliesPurchaseUniqueWhere"],	filter?: ValueTypes["SuppliesPurchaseWhere"] | undefined | null,	data: ValueTypes["SuppliesPurchaseUpdateInput"]},ValueTypes["SuppliesPurchaseUpdateResult"]],
upsertSuppliesPurchase?: [{	by: ValueTypes["SuppliesPurchaseUniqueWhere"],	filter?: ValueTypes["SuppliesPurchaseWhere"] | undefined | null,	update: ValueTypes["SuppliesPurchaseUpdateInput"],	create: ValueTypes["SuppliesPurchaseCreateInput"]},ValueTypes["SuppliesPurchaseUpsertResult"]],
createInvoicingPreset?: [{	data: ValueTypes["InvoicingPresetCreateInput"]},ValueTypes["InvoicingPresetCreateResult"]],
deleteInvoicingPreset?: [{	by: ValueTypes["InvoicingPresetUniqueWhere"],	filter?: ValueTypes["InvoicingPresetWhere"] | undefined | null},ValueTypes["InvoicingPresetDeleteResult"]],
updateInvoicingPreset?: [{	by: ValueTypes["InvoicingPresetUniqueWhere"],	filter?: ValueTypes["InvoicingPresetWhere"] | undefined | null,	data: ValueTypes["InvoicingPresetUpdateInput"]},ValueTypes["InvoicingPresetUpdateResult"]],
upsertInvoicingPreset?: [{	by: ValueTypes["InvoicingPresetUniqueWhere"],	filter?: ValueTypes["InvoicingPresetWhere"] | undefined | null,	update: ValueTypes["InvoicingPresetUpdateInput"],	create: ValueTypes["InvoicingPresetCreateInput"]},ValueTypes["InvoicingPresetUpsertResult"]],
createLogRecord?: [{	data: ValueTypes["LogRecordCreateInput"]},ValueTypes["LogRecordCreateResult"]],
deleteLogRecord?: [{	by: ValueTypes["LogRecordUniqueWhere"],	filter?: ValueTypes["LogRecordWhere"] | undefined | null},ValueTypes["LogRecordDeleteResult"]],
updateLogRecord?: [{	by: ValueTypes["LogRecordUniqueWhere"],	filter?: ValueTypes["LogRecordWhere"] | undefined | null,	data: ValueTypes["LogRecordUpdateInput"]},ValueTypes["LogRecordUpdateResult"]],
upsertLogRecord?: [{	by: ValueTypes["LogRecordUniqueWhere"],	filter?: ValueTypes["LogRecordWhere"] | undefined | null,	update: ValueTypes["LogRecordUpdateInput"],	create: ValueTypes["LogRecordCreateInput"]},ValueTypes["LogRecordUpsertResult"]],
createBillingSubject?: [{	data: ValueTypes["BillingSubjectCreateInput"]},ValueTypes["BillingSubjectCreateResult"]],
deleteBillingSubject?: [{	by: ValueTypes["BillingSubjectUniqueWhere"],	filter?: ValueTypes["BillingSubjectWhere"] | undefined | null},ValueTypes["BillingSubjectDeleteResult"]],
updateBillingSubject?: [{	by: ValueTypes["BillingSubjectUniqueWhere"],	filter?: ValueTypes["BillingSubjectWhere"] | undefined | null,	data: ValueTypes["BillingSubjectUpdateInput"]},ValueTypes["BillingSubjectUpdateResult"]],
upsertBillingSubject?: [{	by: ValueTypes["BillingSubjectUniqueWhere"],	filter?: ValueTypes["BillingSubjectWhere"] | undefined | null,	update: ValueTypes["BillingSubjectUpdateInput"],	create: ValueTypes["BillingSubjectCreateInput"]},ValueTypes["BillingSubjectUpsertResult"]],
createShoppingListItem?: [{	data: ValueTypes["ShoppingListItemCreateInput"]},ValueTypes["ShoppingListItemCreateResult"]],
deleteShoppingListItem?: [{	by: ValueTypes["ShoppingListItemUniqueWhere"],	filter?: ValueTypes["ShoppingListItemWhere"] | undefined | null},ValueTypes["ShoppingListItemDeleteResult"]],
updateShoppingListItem?: [{	by: ValueTypes["ShoppingListItemUniqueWhere"],	filter?: ValueTypes["ShoppingListItemWhere"] | undefined | null,	data: ValueTypes["ShoppingListItemUpdateInput"]},ValueTypes["ShoppingListItemUpdateResult"]],
upsertShoppingListItem?: [{	by: ValueTypes["ShoppingListItemUniqueWhere"],	filter?: ValueTypes["ShoppingListItemWhere"] | undefined | null,	update: ValueTypes["ShoppingListItemUpdateInput"],	create: ValueTypes["ShoppingListItemCreateInput"]},ValueTypes["ShoppingListItemUpsertResult"]],
createSuppliesPurchaseItem?: [{	data: ValueTypes["SuppliesPurchaseItemCreateInput"]},ValueTypes["SuppliesPurchaseItemCreateResult"]],
deleteSuppliesPurchaseItem?: [{	by: ValueTypes["SuppliesPurchaseItemUniqueWhere"],	filter?: ValueTypes["SuppliesPurchaseItemWhere"] | undefined | null},ValueTypes["SuppliesPurchaseItemDeleteResult"]],
updateSuppliesPurchaseItem?: [{	by: ValueTypes["SuppliesPurchaseItemUniqueWhere"],	filter?: ValueTypes["SuppliesPurchaseItemWhere"] | undefined | null,	data: ValueTypes["SuppliesPurchaseItemUpdateInput"]},ValueTypes["SuppliesPurchaseItemUpdateResult"]],
upsertSuppliesPurchaseItem?: [{	by: ValueTypes["SuppliesPurchaseItemUniqueWhere"],	filter?: ValueTypes["SuppliesPurchaseItemWhere"] | undefined | null,	update: ValueTypes["SuppliesPurchaseItemUpdateInput"],	create: ValueTypes["SuppliesPurchaseItemCreateInput"]},ValueTypes["SuppliesPurchaseItemUpsertResult"]],
createCustomerCreditTransaction?: [{	data: ValueTypes["CustomerCreditTransactionCreateInput"]},ValueTypes["CustomerCreditTransactionCreateResult"]],
deleteCustomerCreditTransaction?: [{	by: ValueTypes["CustomerCreditTransactionUniqueWhere"],	filter?: ValueTypes["CustomerCreditTransactionWhere"] | undefined | null},ValueTypes["CustomerCreditTransactionDeleteResult"]],
updateCustomerCreditTransaction?: [{	by: ValueTypes["CustomerCreditTransactionUniqueWhere"],	filter?: ValueTypes["CustomerCreditTransactionWhere"] | undefined | null,	data: ValueTypes["CustomerCreditTransactionUpdateInput"]},ValueTypes["CustomerCreditTransactionUpdateResult"]],
upsertCustomerCreditTransaction?: [{	by: ValueTypes["CustomerCreditTransactionUniqueWhere"],	filter?: ValueTypes["CustomerCreditTransactionWhere"] | undefined | null,	update: ValueTypes["CustomerCreditTransactionUpdateInput"],	create: ValueTypes["CustomerCreditTransactionCreateInput"]},ValueTypes["CustomerCreditTransactionUpsertResult"]],
createVirtualProduct?: [{	data: ValueTypes["VirtualProductCreateInput"]},ValueTypes["VirtualProductCreateResult"]],
deleteVirtualProduct?: [{	by: ValueTypes["VirtualProductUniqueWhere"],	filter?: ValueTypes["VirtualProductWhere"] | undefined | null},ValueTypes["VirtualProductDeleteResult"]],
updateVirtualProduct?: [{	by: ValueTypes["VirtualProductUniqueWhere"],	filter?: ValueTypes["VirtualProductWhere"] | undefined | null,	data: ValueTypes["VirtualProductUpdateInput"]},ValueTypes["VirtualProductUpdateResult"]],
upsertVirtualProduct?: [{	by: ValueTypes["VirtualProductUniqueWhere"],	filter?: ValueTypes["VirtualProductWhere"] | undefined | null,	update: ValueTypes["VirtualProductUpdateInput"],	create: ValueTypes["VirtualProductCreateInput"]},ValueTypes["VirtualProductUpsertResult"]],
createVirtualProductEffect?: [{	data: ValueTypes["VirtualProductEffectCreateInput"]},ValueTypes["VirtualProductEffectCreateResult"]],
deleteVirtualProductEffect?: [{	by: ValueTypes["VirtualProductEffectUniqueWhere"],	filter?: ValueTypes["VirtualProductEffectWhere"] | undefined | null},ValueTypes["VirtualProductEffectDeleteResult"]],
updateVirtualProductEffect?: [{	by: ValueTypes["VirtualProductEffectUniqueWhere"],	filter?: ValueTypes["VirtualProductEffectWhere"] | undefined | null,	data: ValueTypes["VirtualProductEffectUpdateInput"]},ValueTypes["VirtualProductEffectUpdateResult"]],
upsertVirtualProductEffect?: [{	by: ValueTypes["VirtualProductEffectUniqueWhere"],	filter?: ValueTypes["VirtualProductEffectWhere"] | undefined | null,	update: ValueTypes["VirtualProductEffectUpdateInput"],	create: ValueTypes["VirtualProductEffectCreateInput"]},ValueTypes["VirtualProductEffectUpsertResult"]],
createEmploymentInformation?: [{	data: ValueTypes["EmploymentInformationCreateInput"]},ValueTypes["EmploymentInformationCreateResult"]],
deleteEmploymentInformation?: [{	by: ValueTypes["EmploymentInformationUniqueWhere"],	filter?: ValueTypes["EmploymentInformationWhere"] | undefined | null},ValueTypes["EmploymentInformationDeleteResult"]],
updateEmploymentInformation?: [{	by: ValueTypes["EmploymentInformationUniqueWhere"],	filter?: ValueTypes["EmploymentInformationWhere"] | undefined | null,	data: ValueTypes["EmploymentInformationUpdateInput"]},ValueTypes["EmploymentInformationUpdateResult"]],
upsertEmploymentInformation?: [{	by: ValueTypes["EmploymentInformationUniqueWhere"],	filter?: ValueTypes["EmploymentInformationWhere"] | undefined | null,	update: ValueTypes["EmploymentInformationUpdateInput"],	create: ValueTypes["EmploymentInformationCreateInput"]},ValueTypes["EmploymentInformationUpsertResult"]],
createRemunerationProfile?: [{	data: ValueTypes["RemunerationProfileCreateInput"]},ValueTypes["RemunerationProfileCreateResult"]],
deleteRemunerationProfile?: [{	by: ValueTypes["RemunerationProfileUniqueWhere"],	filter?: ValueTypes["RemunerationProfileWhere"] | undefined | null},ValueTypes["RemunerationProfileDeleteResult"]],
updateRemunerationProfile?: [{	by: ValueTypes["RemunerationProfileUniqueWhere"],	filter?: ValueTypes["RemunerationProfileWhere"] | undefined | null,	data: ValueTypes["RemunerationProfileUpdateInput"]},ValueTypes["RemunerationProfileUpdateResult"]],
upsertRemunerationProfile?: [{	by: ValueTypes["RemunerationProfileUniqueWhere"],	filter?: ValueTypes["RemunerationProfileWhere"] | undefined | null,	update: ValueTypes["RemunerationProfileUpdateInput"],	create: ValueTypes["RemunerationProfileCreateInput"]},ValueTypes["RemunerationProfileUpsertResult"]],
createWorkMonth?: [{	data: ValueTypes["WorkMonthCreateInput"]},ValueTypes["WorkMonthCreateResult"]],
deleteWorkMonth?: [{	by: ValueTypes["WorkMonthUniqueWhere"],	filter?: ValueTypes["WorkMonthWhere"] | undefined | null},ValueTypes["WorkMonthDeleteResult"]],
updateWorkMonth?: [{	by: ValueTypes["WorkMonthUniqueWhere"],	filter?: ValueTypes["WorkMonthWhere"] | undefined | null,	data: ValueTypes["WorkMonthUpdateInput"]},ValueTypes["WorkMonthUpdateResult"]],
upsertWorkMonth?: [{	by: ValueTypes["WorkMonthUniqueWhere"],	filter?: ValueTypes["WorkMonthWhere"] | undefined | null,	update: ValueTypes["WorkMonthUpdateInput"],	create: ValueTypes["WorkMonthCreateInput"]},ValueTypes["WorkMonthUpsertResult"]],
createSalaryOptions?: [{	data: ValueTypes["SalaryOptionsCreateInput"]},ValueTypes["SalaryOptionsCreateResult"]],
deleteSalaryOptions?: [{	by: ValueTypes["SalaryOptionsUniqueWhere"],	filter?: ValueTypes["SalaryOptionsWhere"] | undefined | null},ValueTypes["SalaryOptionsDeleteResult"]],
updateSalaryOptions?: [{	by: ValueTypes["SalaryOptionsUniqueWhere"],	filter?: ValueTypes["SalaryOptionsWhere"] | undefined | null,	data: ValueTypes["SalaryOptionsUpdateInput"]},ValueTypes["SalaryOptionsUpdateResult"]],
upsertSalaryOptions?: [{	by: ValueTypes["SalaryOptionsUniqueWhere"],	filter?: ValueTypes["SalaryOptionsWhere"] | undefined | null,	update: ValueTypes["SalaryOptionsUpdateInput"],	create: ValueTypes["SalaryOptionsCreateInput"]},ValueTypes["SalaryOptionsUpsertResult"]],
createTimetableShiftSwapInfo?: [{	data: ValueTypes["TimetableShiftSwapInfoCreateInput"]},ValueTypes["TimetableShiftSwapInfoCreateResult"]],
deleteTimetableShiftSwapInfo?: [{	by: ValueTypes["TimetableShiftSwapInfoUniqueWhere"],	filter?: ValueTypes["TimetableShiftSwapInfoWhere"] | undefined | null},ValueTypes["TimetableShiftSwapInfoDeleteResult"]],
updateTimetableShiftSwapInfo?: [{	by: ValueTypes["TimetableShiftSwapInfoUniqueWhere"],	filter?: ValueTypes["TimetableShiftSwapInfoWhere"] | undefined | null,	data: ValueTypes["TimetableShiftSwapInfoUpdateInput"]},ValueTypes["TimetableShiftSwapInfoUpdateResult"]],
upsertTimetableShiftSwapInfo?: [{	by: ValueTypes["TimetableShiftSwapInfoUniqueWhere"],	filter?: ValueTypes["TimetableShiftSwapInfoWhere"] | undefined | null,	update: ValueTypes["TimetableShiftSwapInfoUpdateInput"],	create: ValueTypes["TimetableShiftSwapInfoCreateInput"]},ValueTypes["TimetableShiftSwapInfoUpsertResult"]],
createProductGridCategory?: [{	data: ValueTypes["ProductGridCategoryCreateInput"]},ValueTypes["ProductGridCategoryCreateResult"]],
deleteProductGridCategory?: [{	by: ValueTypes["ProductGridCategoryUniqueWhere"],	filter?: ValueTypes["ProductGridCategoryWhere"] | undefined | null},ValueTypes["ProductGridCategoryDeleteResult"]],
updateProductGridCategory?: [{	by: ValueTypes["ProductGridCategoryUniqueWhere"],	filter?: ValueTypes["ProductGridCategoryWhere"] | undefined | null,	data: ValueTypes["ProductGridCategoryUpdateInput"]},ValueTypes["ProductGridCategoryUpdateResult"]],
upsertProductGridCategory?: [{	by: ValueTypes["ProductGridCategoryUniqueWhere"],	filter?: ValueTypes["ProductGridCategoryWhere"] | undefined | null,	update: ValueTypes["ProductGridCategoryUpdateInput"],	create: ValueTypes["ProductGridCategoryCreateInput"]},ValueTypes["ProductGridCategoryUpsertResult"]],
createCashier?: [{	data: ValueTypes["CashierCreateInput"]},ValueTypes["CashierCreateResult"]],
deleteCashier?: [{	by: ValueTypes["CashierUniqueWhere"],	filter?: ValueTypes["CashierWhere"] | undefined | null},ValueTypes["CashierDeleteResult"]],
updateCashier?: [{	by: ValueTypes["CashierUniqueWhere"],	filter?: ValueTypes["CashierWhere"] | undefined | null,	data: ValueTypes["CashierUpdateInput"]},ValueTypes["CashierUpdateResult"]],
upsertCashier?: [{	by: ValueTypes["CashierUniqueWhere"],	filter?: ValueTypes["CashierWhere"] | undefined | null,	update: ValueTypes["CashierUpdateInput"],	create: ValueTypes["CashierCreateInput"]},ValueTypes["CashierUpsertResult"]],
createPointOfSaleCategory?: [{	data: ValueTypes["PointOfSaleCategoryCreateInput"]},ValueTypes["PointOfSaleCategoryCreateResult"]],
deletePointOfSaleCategory?: [{	by: ValueTypes["PointOfSaleCategoryUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryWhere"] | undefined | null},ValueTypes["PointOfSaleCategoryDeleteResult"]],
updatePointOfSaleCategory?: [{	by: ValueTypes["PointOfSaleCategoryUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryWhere"] | undefined | null,	data: ValueTypes["PointOfSaleCategoryUpdateInput"]},ValueTypes["PointOfSaleCategoryUpdateResult"]],
upsertPointOfSaleCategory?: [{	by: ValueTypes["PointOfSaleCategoryUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryWhere"] | undefined | null,	update: ValueTypes["PointOfSaleCategoryUpdateInput"],	create: ValueTypes["PointOfSaleCategoryCreateInput"]},ValueTypes["PointOfSaleCategoryUpsertResult"]],
createPointOfSaleCategoryLocale?: [{	data: ValueTypes["PointOfSaleCategoryLocaleCreateInput"]},ValueTypes["PointOfSaleCategoryLocaleCreateResult"]],
deletePointOfSaleCategoryLocale?: [{	by: ValueTypes["PointOfSaleCategoryLocaleUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryLocaleWhere"] | undefined | null},ValueTypes["PointOfSaleCategoryLocaleDeleteResult"]],
updatePointOfSaleCategoryLocale?: [{	by: ValueTypes["PointOfSaleCategoryLocaleUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryLocaleWhere"] | undefined | null,	data: ValueTypes["PointOfSaleCategoryLocaleUpdateInput"]},ValueTypes["PointOfSaleCategoryLocaleUpdateResult"]],
upsertPointOfSaleCategoryLocale?: [{	by: ValueTypes["PointOfSaleCategoryLocaleUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryLocaleWhere"] | undefined | null,	update: ValueTypes["PointOfSaleCategoryLocaleUpdateInput"],	create: ValueTypes["PointOfSaleCategoryLocaleCreateInput"]},ValueTypes["PointOfSaleCategoryLocaleUpsertResult"]],
createPointOfSaleCategoryProduct?: [{	data: ValueTypes["PointOfSaleCategoryProductCreateInput"]},ValueTypes["PointOfSaleCategoryProductCreateResult"]],
deletePointOfSaleCategoryProduct?: [{	by: ValueTypes["PointOfSaleCategoryProductUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryProductWhere"] | undefined | null},ValueTypes["PointOfSaleCategoryProductDeleteResult"]],
updatePointOfSaleCategoryProduct?: [{	by: ValueTypes["PointOfSaleCategoryProductUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryProductWhere"] | undefined | null,	data: ValueTypes["PointOfSaleCategoryProductUpdateInput"]},ValueTypes["PointOfSaleCategoryProductUpdateResult"]],
upsertPointOfSaleCategoryProduct?: [{	by: ValueTypes["PointOfSaleCategoryProductUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryProductWhere"] | undefined | null,	update: ValueTypes["PointOfSaleCategoryProductUpdateInput"],	create: ValueTypes["PointOfSaleCategoryProductCreateInput"]},ValueTypes["PointOfSaleCategoryProductUpsertResult"]],
createPointOfSaleCategoryProductLocale?: [{	data: ValueTypes["PointOfSaleCategoryProductLocaleCreateInput"]},ValueTypes["PointOfSaleCategoryProductLocaleCreateResult"]],
deletePointOfSaleCategoryProductLocale?: [{	by: ValueTypes["PointOfSaleCategoryProductLocaleUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryProductLocaleWhere"] | undefined | null},ValueTypes["PointOfSaleCategoryProductLocaleDeleteResult"]],
updatePointOfSaleCategoryProductLocale?: [{	by: ValueTypes["PointOfSaleCategoryProductLocaleUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryProductLocaleWhere"] | undefined | null,	data: ValueTypes["PointOfSaleCategoryProductLocaleUpdateInput"]},ValueTypes["PointOfSaleCategoryProductLocaleUpdateResult"]],
upsertPointOfSaleCategoryProductLocale?: [{	by: ValueTypes["PointOfSaleCategoryProductLocaleUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryProductLocaleWhere"] | undefined | null,	update: ValueTypes["PointOfSaleCategoryProductLocaleUpdateInput"],	create: ValueTypes["PointOfSaleCategoryProductLocaleCreateInput"]},ValueTypes["PointOfSaleCategoryProductLocaleUpsertResult"]],
createCustomerTab?: [{	data: ValueTypes["CustomerTabCreateInput"]},ValueTypes["CustomerTabCreateResult"]],
deleteCustomerTab?: [{	by: ValueTypes["CustomerTabUniqueWhere"],	filter?: ValueTypes["CustomerTabWhere"] | undefined | null},ValueTypes["CustomerTabDeleteResult"]],
updateCustomerTab?: [{	by: ValueTypes["CustomerTabUniqueWhere"],	filter?: ValueTypes["CustomerTabWhere"] | undefined | null,	data: ValueTypes["CustomerTabUpdateInput"]},ValueTypes["CustomerTabUpdateResult"]],
upsertCustomerTab?: [{	by: ValueTypes["CustomerTabUniqueWhere"],	filter?: ValueTypes["CustomerTabWhere"] | undefined | null,	update: ValueTypes["CustomerTabUpdateInput"],	create: ValueTypes["CustomerTabCreateInput"]},ValueTypes["CustomerTabUpsertResult"]],
createCustomerTabItem?: [{	data: ValueTypes["CustomerTabItemCreateInput"]},ValueTypes["CustomerTabItemCreateResult"]],
deleteCustomerTabItem?: [{	by: ValueTypes["CustomerTabItemUniqueWhere"],	filter?: ValueTypes["CustomerTabItemWhere"] | undefined | null},ValueTypes["CustomerTabItemDeleteResult"]],
updateCustomerTabItem?: [{	by: ValueTypes["CustomerTabItemUniqueWhere"],	filter?: ValueTypes["CustomerTabItemWhere"] | undefined | null,	data: ValueTypes["CustomerTabItemUpdateInput"]},ValueTypes["CustomerTabItemUpdateResult"]],
upsertCustomerTabItem?: [{	by: ValueTypes["CustomerTabItemUniqueWhere"],	filter?: ValueTypes["CustomerTabItemWhere"] | undefined | null,	update: ValueTypes["CustomerTabItemUpdateInput"],	create: ValueTypes["CustomerTabItemCreateInput"]},ValueTypes["CustomerTabItemUpsertResult"]],
createAnonymousSession?: [{	data: ValueTypes["AnonymousSessionCreateInput"]},ValueTypes["AnonymousSessionCreateResult"]],
deleteAnonymousSession?: [{	by: ValueTypes["AnonymousSessionUniqueWhere"],	filter?: ValueTypes["AnonymousSessionWhere"] | undefined | null},ValueTypes["AnonymousSessionDeleteResult"]],
updateAnonymousSession?: [{	by: ValueTypes["AnonymousSessionUniqueWhere"],	filter?: ValueTypes["AnonymousSessionWhere"] | undefined | null,	data: ValueTypes["AnonymousSessionUpdateInput"]},ValueTypes["AnonymousSessionUpdateResult"]],
upsertAnonymousSession?: [{	by: ValueTypes["AnonymousSessionUniqueWhere"],	filter?: ValueTypes["AnonymousSessionWhere"] | undefined | null,	update: ValueTypes["AnonymousSessionUpdateInput"],	create: ValueTypes["AnonymousSessionCreateInput"]},ValueTypes["AnonymousSessionUpsertResult"]],
createVoucher?: [{	data: ValueTypes["VoucherCreateInput"]},ValueTypes["VoucherCreateResult"]],
deleteVoucher?: [{	by: ValueTypes["VoucherUniqueWhere"],	filter?: ValueTypes["VoucherWhere"] | undefined | null},ValueTypes["VoucherDeleteResult"]],
updateVoucher?: [{	by: ValueTypes["VoucherUniqueWhere"],	filter?: ValueTypes["VoucherWhere"] | undefined | null,	data: ValueTypes["VoucherUpdateInput"]},ValueTypes["VoucherUpdateResult"]],
upsertVoucher?: [{	by: ValueTypes["VoucherUniqueWhere"],	filter?: ValueTypes["VoucherWhere"] | undefined | null,	update: ValueTypes["VoucherUpdateInput"],	create: ValueTypes["VoucherCreateInput"]},ValueTypes["VoucherUpsertResult"]],
createVoucherRedemption?: [{	data: ValueTypes["VoucherRedemptionCreateInput"]},ValueTypes["VoucherRedemptionCreateResult"]],
deleteVoucherRedemption?: [{	by: ValueTypes["VoucherRedemptionUniqueWhere"],	filter?: ValueTypes["VoucherRedemptionWhere"] | undefined | null},ValueTypes["VoucherRedemptionDeleteResult"]],
updateVoucherRedemption?: [{	by: ValueTypes["VoucherRedemptionUniqueWhere"],	filter?: ValueTypes["VoucherRedemptionWhere"] | undefined | null,	data: ValueTypes["VoucherRedemptionUpdateInput"]},ValueTypes["VoucherRedemptionUpdateResult"]],
upsertVoucherRedemption?: [{	by: ValueTypes["VoucherRedemptionUniqueWhere"],	filter?: ValueTypes["VoucherRedemptionWhere"] | undefined | null,	update: ValueTypes["VoucherRedemptionUpdateInput"],	create: ValueTypes["VoucherRedemptionCreateInput"]},ValueTypes["VoucherRedemptionUpsertResult"]],
createUnassignedShiftInfo?: [{	data: ValueTypes["UnassignedShiftInfoCreateInput"]},ValueTypes["UnassignedShiftInfoCreateResult"]],
deleteUnassignedShiftInfo?: [{	by: ValueTypes["UnassignedShiftInfoUniqueWhere"],	filter?: ValueTypes["UnassignedShiftInfoWhere"] | undefined | null},ValueTypes["UnassignedShiftInfoDeleteResult"]],
updateUnassignedShiftInfo?: [{	by: ValueTypes["UnassignedShiftInfoUniqueWhere"],	filter?: ValueTypes["UnassignedShiftInfoWhere"] | undefined | null,	data: ValueTypes["UnassignedShiftInfoUpdateInput"]},ValueTypes["UnassignedShiftInfoUpdateResult"]],
upsertUnassignedShiftInfo?: [{	by: ValueTypes["UnassignedShiftInfoUniqueWhere"],	filter?: ValueTypes["UnassignedShiftInfoWhere"] | undefined | null,	update: ValueTypes["UnassignedShiftInfoUpdateInput"],	create: ValueTypes["UnassignedShiftInfoCreateInput"]},ValueTypes["UnassignedShiftInfoUpsertResult"]],
createFreshingContainer?: [{	data: ValueTypes["FreshingContainerCreateInput"]},ValueTypes["FreshingContainerCreateResult"]],
deleteFreshingContainer?: [{	by: ValueTypes["FreshingContainerUniqueWhere"],	filter?: ValueTypes["FreshingContainerWhere"] | undefined | null},ValueTypes["FreshingContainerDeleteResult"]],
updateFreshingContainer?: [{	by: ValueTypes["FreshingContainerUniqueWhere"],	filter?: ValueTypes["FreshingContainerWhere"] | undefined | null,	data: ValueTypes["FreshingContainerUpdateInput"]},ValueTypes["FreshingContainerUpdateResult"]],
upsertFreshingContainer?: [{	by: ValueTypes["FreshingContainerUniqueWhere"],	filter?: ValueTypes["FreshingContainerWhere"] | undefined | null,	update: ValueTypes["FreshingContainerUpdateInput"],	create: ValueTypes["FreshingContainerCreateInput"]},ValueTypes["FreshingContainerUpsertResult"]],
createTextItem?: [{	data: ValueTypes["TextItemCreateInput"]},ValueTypes["TextItemCreateResult"]],
deleteTextItem?: [{	by: ValueTypes["TextItemUniqueWhere"],	filter?: ValueTypes["TextItemWhere"] | undefined | null},ValueTypes["TextItemDeleteResult"]],
updateTextItem?: [{	by: ValueTypes["TextItemUniqueWhere"],	filter?: ValueTypes["TextItemWhere"] | undefined | null,	data: ValueTypes["TextItemUpdateInput"]},ValueTypes["TextItemUpdateResult"]],
upsertTextItem?: [{	by: ValueTypes["TextItemUniqueWhere"],	filter?: ValueTypes["TextItemWhere"] | undefined | null,	update: ValueTypes["TextItemUpdateInput"],	create: ValueTypes["TextItemCreateInput"]},ValueTypes["TextItemUpsertResult"]],
createTextList?: [{	data: ValueTypes["TextListCreateInput"]},ValueTypes["TextListCreateResult"]],
deleteTextList?: [{	by: ValueTypes["TextListUniqueWhere"],	filter?: ValueTypes["TextListWhere"] | undefined | null},ValueTypes["TextListDeleteResult"]],
updateTextList?: [{	by: ValueTypes["TextListUniqueWhere"],	filter?: ValueTypes["TextListWhere"] | undefined | null,	data: ValueTypes["TextListUpdateInput"]},ValueTypes["TextListUpdateResult"]],
upsertTextList?: [{	by: ValueTypes["TextListUniqueWhere"],	filter?: ValueTypes["TextListWhere"] | undefined | null,	update: ValueTypes["TextListUpdateInput"],	create: ValueTypes["TextListCreateInput"]},ValueTypes["TextListUpsertResult"]],
createDeliveryRegions?: [{	data: ValueTypes["DeliveryRegionsCreateInput"]},ValueTypes["DeliveryRegionsCreateResult"]],
deleteDeliveryRegions?: [{	by: ValueTypes["DeliveryRegionsUniqueWhere"],	filter?: ValueTypes["DeliveryRegionsWhere"] | undefined | null},ValueTypes["DeliveryRegionsDeleteResult"]],
updateDeliveryRegions?: [{	by: ValueTypes["DeliveryRegionsUniqueWhere"],	filter?: ValueTypes["DeliveryRegionsWhere"] | undefined | null,	data: ValueTypes["DeliveryRegionsUpdateInput"]},ValueTypes["DeliveryRegionsUpdateResult"]],
upsertDeliveryRegions?: [{	by: ValueTypes["DeliveryRegionsUniqueWhere"],	filter?: ValueTypes["DeliveryRegionsWhere"] | undefined | null,	update: ValueTypes["DeliveryRegionsUpdateInput"],	create: ValueTypes["DeliveryRegionsCreateInput"]},ValueTypes["DeliveryRegionsUpsertResult"]],
createDeliveryRegionsItem?: [{	data: ValueTypes["DeliveryRegionsItemCreateInput"]},ValueTypes["DeliveryRegionsItemCreateResult"]],
deleteDeliveryRegionsItem?: [{	by: ValueTypes["DeliveryRegionsItemUniqueWhere"],	filter?: ValueTypes["DeliveryRegionsItemWhere"] | undefined | null},ValueTypes["DeliveryRegionsItemDeleteResult"]],
updateDeliveryRegionsItem?: [{	by: ValueTypes["DeliveryRegionsItemUniqueWhere"],	filter?: ValueTypes["DeliveryRegionsItemWhere"] | undefined | null,	data: ValueTypes["DeliveryRegionsItemUpdateInput"]},ValueTypes["DeliveryRegionsItemUpdateResult"]],
upsertDeliveryRegionsItem?: [{	by: ValueTypes["DeliveryRegionsItemUniqueWhere"],	filter?: ValueTypes["DeliveryRegionsItemWhere"] | undefined | null,	update: ValueTypes["DeliveryRegionsItemUpdateInput"],	create: ValueTypes["DeliveryRegionsItemCreateInput"]},ValueTypes["DeliveryRegionsItemUpsertResult"]],
createImageList?: [{	data: ValueTypes["ImageListCreateInput"]},ValueTypes["ImageListCreateResult"]],
deleteImageList?: [{	by: ValueTypes["ImageListUniqueWhere"],	filter?: ValueTypes["ImageListWhere"] | undefined | null},ValueTypes["ImageListDeleteResult"]],
updateImageList?: [{	by: ValueTypes["ImageListUniqueWhere"],	filter?: ValueTypes["ImageListWhere"] | undefined | null,	data: ValueTypes["ImageListUpdateInput"]},ValueTypes["ImageListUpdateResult"]],
upsertImageList?: [{	by: ValueTypes["ImageListUniqueWhere"],	filter?: ValueTypes["ImageListWhere"] | undefined | null,	update: ValueTypes["ImageListUpdateInput"],	create: ValueTypes["ImageListCreateInput"]},ValueTypes["ImageListUpsertResult"]],
createImageListItem?: [{	data: ValueTypes["ImageListItemCreateInput"]},ValueTypes["ImageListItemCreateResult"]],
deleteImageListItem?: [{	by: ValueTypes["ImageListItemUniqueWhere"],	filter?: ValueTypes["ImageListItemWhere"] | undefined | null},ValueTypes["ImageListItemDeleteResult"]],
updateImageListItem?: [{	by: ValueTypes["ImageListItemUniqueWhere"],	filter?: ValueTypes["ImageListItemWhere"] | undefined | null,	data: ValueTypes["ImageListItemUpdateInput"]},ValueTypes["ImageListItemUpdateResult"]],
upsertImageListItem?: [{	by: ValueTypes["ImageListItemUniqueWhere"],	filter?: ValueTypes["ImageListItemWhere"] | undefined | null,	update: ValueTypes["ImageListItemUpdateInput"],	create: ValueTypes["ImageListItemCreateInput"]},ValueTypes["ImageListItemUpsertResult"]],
createTimetablesEmployeePrivileges?: [{	data: ValueTypes["TimetablesEmployeePrivilegesCreateInput"]},ValueTypes["TimetablesEmployeePrivilegesCreateResult"]],
deleteTimetablesEmployeePrivileges?: [{	by: ValueTypes["TimetablesEmployeePrivilegesUniqueWhere"],	filter?: ValueTypes["TimetablesEmployeePrivilegesWhere"] | undefined | null},ValueTypes["TimetablesEmployeePrivilegesDeleteResult"]],
updateTimetablesEmployeePrivileges?: [{	by: ValueTypes["TimetablesEmployeePrivilegesUniqueWhere"],	filter?: ValueTypes["TimetablesEmployeePrivilegesWhere"] | undefined | null,	data: ValueTypes["TimetablesEmployeePrivilegesUpdateInput"]},ValueTypes["TimetablesEmployeePrivilegesUpdateResult"]],
upsertTimetablesEmployeePrivileges?: [{	by: ValueTypes["TimetablesEmployeePrivilegesUniqueWhere"],	filter?: ValueTypes["TimetablesEmployeePrivilegesWhere"] | undefined | null,	update: ValueTypes["TimetablesEmployeePrivilegesUpdateInput"],	create: ValueTypes["TimetablesEmployeePrivilegesCreateInput"]},ValueTypes["TimetablesEmployeePrivilegesUpsertResult"]],
createTimetableDayNote?: [{	data: ValueTypes["TimetableDayNoteCreateInput"]},ValueTypes["TimetableDayNoteCreateResult"]],
deleteTimetableDayNote?: [{	by: ValueTypes["TimetableDayNoteUniqueWhere"],	filter?: ValueTypes["TimetableDayNoteWhere"] | undefined | null},ValueTypes["TimetableDayNoteDeleteResult"]],
updateTimetableDayNote?: [{	by: ValueTypes["TimetableDayNoteUniqueWhere"],	filter?: ValueTypes["TimetableDayNoteWhere"] | undefined | null,	data: ValueTypes["TimetableDayNoteUpdateInput"]},ValueTypes["TimetableDayNoteUpdateResult"]],
upsertTimetableDayNote?: [{	by: ValueTypes["TimetableDayNoteUniqueWhere"],	filter?: ValueTypes["TimetableDayNoteWhere"] | undefined | null,	update: ValueTypes["TimetableDayNoteUpdateInput"],	create: ValueTypes["TimetableDayNoteCreateInput"]},ValueTypes["TimetableDayNoteUpsertResult"]],
createDeliveryMethodLocale?: [{	data: ValueTypes["DeliveryMethodLocaleCreateInput"]},ValueTypes["DeliveryMethodLocaleCreateResult"]],
deleteDeliveryMethodLocale?: [{	by: ValueTypes["DeliveryMethodLocaleUniqueWhere"],	filter?: ValueTypes["DeliveryMethodLocaleWhere"] | undefined | null},ValueTypes["DeliveryMethodLocaleDeleteResult"]],
updateDeliveryMethodLocale?: [{	by: ValueTypes["DeliveryMethodLocaleUniqueWhere"],	filter?: ValueTypes["DeliveryMethodLocaleWhere"] | undefined | null,	data: ValueTypes["DeliveryMethodLocaleUpdateInput"]},ValueTypes["DeliveryMethodLocaleUpdateResult"]],
upsertDeliveryMethodLocale?: [{	by: ValueTypes["DeliveryMethodLocaleUniqueWhere"],	filter?: ValueTypes["DeliveryMethodLocaleWhere"] | undefined | null,	update: ValueTypes["DeliveryMethodLocaleUpdateInput"],	create: ValueTypes["DeliveryMethodLocaleCreateInput"]},ValueTypes["DeliveryMethodLocaleUpsertResult"]],
createIngredientSupplier?: [{	data: ValueTypes["IngredientSupplierCreateInput"]},ValueTypes["IngredientSupplierCreateResult"]],
deleteIngredientSupplier?: [{	by: ValueTypes["IngredientSupplierUniqueWhere"],	filter?: ValueTypes["IngredientSupplierWhere"] | undefined | null},ValueTypes["IngredientSupplierDeleteResult"]],
updateIngredientSupplier?: [{	by: ValueTypes["IngredientSupplierUniqueWhere"],	filter?: ValueTypes["IngredientSupplierWhere"] | undefined | null,	data: ValueTypes["IngredientSupplierUpdateInput"]},ValueTypes["IngredientSupplierUpdateResult"]],
upsertIngredientSupplier?: [{	by: ValueTypes["IngredientSupplierUniqueWhere"],	filter?: ValueTypes["IngredientSupplierWhere"] | undefined | null,	update: ValueTypes["IngredientSupplierUpdateInput"],	create: ValueTypes["IngredientSupplierCreateInput"]},ValueTypes["IngredientSupplierUpsertResult"]],
createIngredientSupplierItem?: [{	data: ValueTypes["IngredientSupplierItemCreateInput"]},ValueTypes["IngredientSupplierItemCreateResult"]],
deleteIngredientSupplierItem?: [{	by: ValueTypes["IngredientSupplierItemUniqueWhere"],	filter?: ValueTypes["IngredientSupplierItemWhere"] | undefined | null},ValueTypes["IngredientSupplierItemDeleteResult"]],
updateIngredientSupplierItem?: [{	by: ValueTypes["IngredientSupplierItemUniqueWhere"],	filter?: ValueTypes["IngredientSupplierItemWhere"] | undefined | null,	data: ValueTypes["IngredientSupplierItemUpdateInput"]},ValueTypes["IngredientSupplierItemUpdateResult"]],
upsertIngredientSupplierItem?: [{	by: ValueTypes["IngredientSupplierItemUniqueWhere"],	filter?: ValueTypes["IngredientSupplierItemWhere"] | undefined | null,	update: ValueTypes["IngredientSupplierItemUpdateInput"],	create: ValueTypes["IngredientSupplierItemCreateInput"]},ValueTypes["IngredientSupplierItemUpsertResult"]],
createIngredientSupplierList?: [{	data: ValueTypes["IngredientSupplierListCreateInput"]},ValueTypes["IngredientSupplierListCreateResult"]],
deleteIngredientSupplierList?: [{	by: ValueTypes["IngredientSupplierListUniqueWhere"],	filter?: ValueTypes["IngredientSupplierListWhere"] | undefined | null},ValueTypes["IngredientSupplierListDeleteResult"]],
updateIngredientSupplierList?: [{	by: ValueTypes["IngredientSupplierListUniqueWhere"],	filter?: ValueTypes["IngredientSupplierListWhere"] | undefined | null,	data: ValueTypes["IngredientSupplierListUpdateInput"]},ValueTypes["IngredientSupplierListUpdateResult"]],
upsertIngredientSupplierList?: [{	by: ValueTypes["IngredientSupplierListUniqueWhere"],	filter?: ValueTypes["IngredientSupplierListWhere"] | undefined | null,	update: ValueTypes["IngredientSupplierListUpdateInput"],	create: ValueTypes["IngredientSupplierListCreateInput"]},ValueTypes["IngredientSupplierListUpsertResult"]],
createIngredientSupplierLocale?: [{	data: ValueTypes["IngredientSupplierLocaleCreateInput"]},ValueTypes["IngredientSupplierLocaleCreateResult"]],
deleteIngredientSupplierLocale?: [{	by: ValueTypes["IngredientSupplierLocaleUniqueWhere"],	filter?: ValueTypes["IngredientSupplierLocaleWhere"] | undefined | null},ValueTypes["IngredientSupplierLocaleDeleteResult"]],
updateIngredientSupplierLocale?: [{	by: ValueTypes["IngredientSupplierLocaleUniqueWhere"],	filter?: ValueTypes["IngredientSupplierLocaleWhere"] | undefined | null,	data: ValueTypes["IngredientSupplierLocaleUpdateInput"]},ValueTypes["IngredientSupplierLocaleUpdateResult"]],
upsertIngredientSupplierLocale?: [{	by: ValueTypes["IngredientSupplierLocaleUniqueWhere"],	filter?: ValueTypes["IngredientSupplierLocaleWhere"] | undefined | null,	update: ValueTypes["IngredientSupplierLocaleUpdateInput"],	create: ValueTypes["IngredientSupplierLocaleCreateInput"]},ValueTypes["IngredientSupplierLocaleUpsertResult"]],
createRedirect?: [{	data: ValueTypes["RedirectCreateInput"]},ValueTypes["RedirectCreateResult"]],
deleteRedirect?: [{	by: ValueTypes["RedirectUniqueWhere"],	filter?: ValueTypes["RedirectWhere"] | undefined | null},ValueTypes["RedirectDeleteResult"]],
updateRedirect?: [{	by: ValueTypes["RedirectUniqueWhere"],	filter?: ValueTypes["RedirectWhere"] | undefined | null,	data: ValueTypes["RedirectUpdateInput"]},ValueTypes["RedirectUpdateResult"]],
upsertRedirect?: [{	by: ValueTypes["RedirectUniqueWhere"],	filter?: ValueTypes["RedirectWhere"] | undefined | null,	update: ValueTypes["RedirectUpdateInput"],	create: ValueTypes["RedirectCreateInput"]},ValueTypes["RedirectUpsertResult"]],
createNutritionFacts?: [{	data: ValueTypes["NutritionFactsCreateInput"]},ValueTypes["NutritionFactsCreateResult"]],
deleteNutritionFacts?: [{	by: ValueTypes["NutritionFactsUniqueWhere"],	filter?: ValueTypes["NutritionFactsWhere"] | undefined | null},ValueTypes["NutritionFactsDeleteResult"]],
updateNutritionFacts?: [{	by: ValueTypes["NutritionFactsUniqueWhere"],	filter?: ValueTypes["NutritionFactsWhere"] | undefined | null,	data: ValueTypes["NutritionFactsUpdateInput"]},ValueTypes["NutritionFactsUpdateResult"]],
upsertNutritionFacts?: [{	by: ValueTypes["NutritionFactsUniqueWhere"],	filter?: ValueTypes["NutritionFactsWhere"] | undefined | null,	update: ValueTypes["NutritionFactsUpdateInput"],	create: ValueTypes["NutritionFactsCreateInput"]},ValueTypes["NutritionFactsUpsertResult"]],
createVenue?: [{	data: ValueTypes["VenueCreateInput"]},ValueTypes["VenueCreateResult"]],
deleteVenue?: [{	by: ValueTypes["VenueUniqueWhere"],	filter?: ValueTypes["VenueWhere"] | undefined | null},ValueTypes["VenueDeleteResult"]],
updateVenue?: [{	by: ValueTypes["VenueUniqueWhere"],	filter?: ValueTypes["VenueWhere"] | undefined | null,	data: ValueTypes["VenueUpdateInput"]},ValueTypes["VenueUpdateResult"]],
upsertVenue?: [{	by: ValueTypes["VenueUniqueWhere"],	filter?: ValueTypes["VenueWhere"] | undefined | null,	update: ValueTypes["VenueUpdateInput"],	create: ValueTypes["VenueCreateInput"]},ValueTypes["VenueUpsertResult"]],
createWorkspace?: [{	data: ValueTypes["WorkspaceCreateInput"]},ValueTypes["WorkspaceCreateResult"]],
deleteWorkspace?: [{	by: ValueTypes["WorkspaceUniqueWhere"],	filter?: ValueTypes["WorkspaceWhere"] | undefined | null},ValueTypes["WorkspaceDeleteResult"]],
updateWorkspace?: [{	by: ValueTypes["WorkspaceUniqueWhere"],	filter?: ValueTypes["WorkspaceWhere"] | undefined | null,	data: ValueTypes["WorkspaceUpdateInput"]},ValueTypes["WorkspaceUpdateResult"]],
upsertWorkspace?: [{	by: ValueTypes["WorkspaceUniqueWhere"],	filter?: ValueTypes["WorkspaceWhere"] | undefined | null,	update: ValueTypes["WorkspaceUpdateInput"],	create: ValueTypes["WorkspaceCreateInput"]},ValueTypes["WorkspaceUpsertResult"]],
createInternalBuyer?: [{	data: ValueTypes["InternalBuyerCreateInput"]},ValueTypes["InternalBuyerCreateResult"]],
deleteInternalBuyer?: [{	by: ValueTypes["InternalBuyerUniqueWhere"],	filter?: ValueTypes["InternalBuyerWhere"] | undefined | null},ValueTypes["InternalBuyerDeleteResult"]],
updateInternalBuyer?: [{	by: ValueTypes["InternalBuyerUniqueWhere"],	filter?: ValueTypes["InternalBuyerWhere"] | undefined | null,	data: ValueTypes["InternalBuyerUpdateInput"]},ValueTypes["InternalBuyerUpdateResult"]],
upsertInternalBuyer?: [{	by: ValueTypes["InternalBuyerUniqueWhere"],	filter?: ValueTypes["InternalBuyerWhere"] | undefined | null,	update: ValueTypes["InternalBuyerUpdateInput"],	create: ValueTypes["InternalBuyerCreateInput"]},ValueTypes["InternalBuyerUpsertResult"]],
createVenueEmployeeRole?: [{	data: ValueTypes["VenueEmployeeRoleCreateInput"]},ValueTypes["VenueEmployeeRoleCreateResult"]],
deleteVenueEmployeeRole?: [{	by: ValueTypes["VenueEmployeeRoleUniqueWhere"],	filter?: ValueTypes["VenueEmployeeRoleWhere"] | undefined | null},ValueTypes["VenueEmployeeRoleDeleteResult"]],
updateVenueEmployeeRole?: [{	by: ValueTypes["VenueEmployeeRoleUniqueWhere"],	filter?: ValueTypes["VenueEmployeeRoleWhere"] | undefined | null,	data: ValueTypes["VenueEmployeeRoleUpdateInput"]},ValueTypes["VenueEmployeeRoleUpdateResult"]],
upsertVenueEmployeeRole?: [{	by: ValueTypes["VenueEmployeeRoleUniqueWhere"],	filter?: ValueTypes["VenueEmployeeRoleWhere"] | undefined | null,	update: ValueTypes["VenueEmployeeRoleUpdateInput"],	create: ValueTypes["VenueEmployeeRoleCreateInput"]},ValueTypes["VenueEmployeeRoleUpsertResult"]],
createIdentificationAttempt?: [{	data: ValueTypes["IdentificationAttemptCreateInput"]},ValueTypes["IdentificationAttemptCreateResult"]],
deleteIdentificationAttempt?: [{	by: ValueTypes["IdentificationAttemptUniqueWhere"],	filter?: ValueTypes["IdentificationAttemptWhere"] | undefined | null},ValueTypes["IdentificationAttemptDeleteResult"]],
updateIdentificationAttempt?: [{	by: ValueTypes["IdentificationAttemptUniqueWhere"],	filter?: ValueTypes["IdentificationAttemptWhere"] | undefined | null,	data: ValueTypes["IdentificationAttemptUpdateInput"]},ValueTypes["IdentificationAttemptUpdateResult"]],
upsertIdentificationAttempt?: [{	by: ValueTypes["IdentificationAttemptUniqueWhere"],	filter?: ValueTypes["IdentificationAttemptWhere"] | undefined | null,	update: ValueTypes["IdentificationAttemptUpdateInput"],	create: ValueTypes["IdentificationAttemptCreateInput"]},ValueTypes["IdentificationAttemptUpsertResult"]],
createIdentificationCode?: [{	data: ValueTypes["IdentificationCodeCreateInput"]},ValueTypes["IdentificationCodeCreateResult"]],
deleteIdentificationCode?: [{	by: ValueTypes["IdentificationCodeUniqueWhere"],	filter?: ValueTypes["IdentificationCodeWhere"] | undefined | null},ValueTypes["IdentificationCodeDeleteResult"]],
updateIdentificationCode?: [{	by: ValueTypes["IdentificationCodeUniqueWhere"],	filter?: ValueTypes["IdentificationCodeWhere"] | undefined | null,	data: ValueTypes["IdentificationCodeUpdateInput"]},ValueTypes["IdentificationCodeUpdateResult"]],
upsertIdentificationCode?: [{	by: ValueTypes["IdentificationCodeUniqueWhere"],	filter?: ValueTypes["IdentificationCodeWhere"] | undefined | null,	update: ValueTypes["IdentificationCodeUpdateInput"],	create: ValueTypes["IdentificationCodeCreateInput"]},ValueTypes["IdentificationCodeUpsertResult"]],
createIdentificationCodeLocale?: [{	data: ValueTypes["IdentificationCodeLocaleCreateInput"]},ValueTypes["IdentificationCodeLocaleCreateResult"]],
deleteIdentificationCodeLocale?: [{	by: ValueTypes["IdentificationCodeLocaleUniqueWhere"],	filter?: ValueTypes["IdentificationCodeLocaleWhere"] | undefined | null},ValueTypes["IdentificationCodeLocaleDeleteResult"]],
updateIdentificationCodeLocale?: [{	by: ValueTypes["IdentificationCodeLocaleUniqueWhere"],	filter?: ValueTypes["IdentificationCodeLocaleWhere"] | undefined | null,	data: ValueTypes["IdentificationCodeLocaleUpdateInput"]},ValueTypes["IdentificationCodeLocaleUpdateResult"]],
upsertIdentificationCodeLocale?: [{	by: ValueTypes["IdentificationCodeLocaleUniqueWhere"],	filter?: ValueTypes["IdentificationCodeLocaleWhere"] | undefined | null,	update: ValueTypes["IdentificationCodeLocaleUpdateInput"],	create: ValueTypes["IdentificationCodeLocaleCreateInput"]},ValueTypes["IdentificationCodeLocaleUpsertResult"]],
createPipeline?: [{	data: ValueTypes["PipelineCreateInput"]},ValueTypes["PipelineCreateResult"]],
deletePipeline?: [{	by: ValueTypes["PipelineUniqueWhere"],	filter?: ValueTypes["PipelineWhere"] | undefined | null},ValueTypes["PipelineDeleteResult"]],
updatePipeline?: [{	by: ValueTypes["PipelineUniqueWhere"],	filter?: ValueTypes["PipelineWhere"] | undefined | null,	data: ValueTypes["PipelineUpdateInput"]},ValueTypes["PipelineUpdateResult"]],
upsertPipeline?: [{	by: ValueTypes["PipelineUniqueWhere"],	filter?: ValueTypes["PipelineWhere"] | undefined | null,	update: ValueTypes["PipelineUpdateInput"],	create: ValueTypes["PipelineCreateInput"]},ValueTypes["PipelineUpsertResult"]],
createPipelineLead?: [{	data: ValueTypes["PipelineLeadCreateInput"]},ValueTypes["PipelineLeadCreateResult"]],
deletePipelineLead?: [{	by: ValueTypes["PipelineLeadUniqueWhere"],	filter?: ValueTypes["PipelineLeadWhere"] | undefined | null},ValueTypes["PipelineLeadDeleteResult"]],
updatePipelineLead?: [{	by: ValueTypes["PipelineLeadUniqueWhere"],	filter?: ValueTypes["PipelineLeadWhere"] | undefined | null,	data: ValueTypes["PipelineLeadUpdateInput"]},ValueTypes["PipelineLeadUpdateResult"]],
upsertPipelineLead?: [{	by: ValueTypes["PipelineLeadUniqueWhere"],	filter?: ValueTypes["PipelineLeadWhere"] | undefined | null,	update: ValueTypes["PipelineLeadUpdateInput"],	create: ValueTypes["PipelineLeadCreateInput"]},ValueTypes["PipelineLeadUpsertResult"]],
createPipelineStage?: [{	data: ValueTypes["PipelineStageCreateInput"]},ValueTypes["PipelineStageCreateResult"]],
deletePipelineStage?: [{	by: ValueTypes["PipelineStageUniqueWhere"],	filter?: ValueTypes["PipelineStageWhere"] | undefined | null},ValueTypes["PipelineStageDeleteResult"]],
updatePipelineStage?: [{	by: ValueTypes["PipelineStageUniqueWhere"],	filter?: ValueTypes["PipelineStageWhere"] | undefined | null,	data: ValueTypes["PipelineStageUpdateInput"]},ValueTypes["PipelineStageUpdateResult"]],
upsertPipelineStage?: [{	by: ValueTypes["PipelineStageUniqueWhere"],	filter?: ValueTypes["PipelineStageWhere"] | undefined | null,	update: ValueTypes["PipelineStageUpdateInput"],	create: ValueTypes["PipelineStageCreateInput"]},ValueTypes["PipelineStageUpsertResult"]],
createPipelineStageItem?: [{	data: ValueTypes["PipelineStageItemCreateInput"]},ValueTypes["PipelineStageItemCreateResult"]],
deletePipelineStageItem?: [{	by: ValueTypes["PipelineStageItemUniqueWhere"],	filter?: ValueTypes["PipelineStageItemWhere"] | undefined | null},ValueTypes["PipelineStageItemDeleteResult"]],
updatePipelineStageItem?: [{	by: ValueTypes["PipelineStageItemUniqueWhere"],	filter?: ValueTypes["PipelineStageItemWhere"] | undefined | null,	data: ValueTypes["PipelineStageItemUpdateInput"]},ValueTypes["PipelineStageItemUpdateResult"]],
upsertPipelineStageItem?: [{	by: ValueTypes["PipelineStageItemUniqueWhere"],	filter?: ValueTypes["PipelineStageItemWhere"] | undefined | null,	update: ValueTypes["PipelineStageItemUpdateInput"],	create: ValueTypes["PipelineStageItemCreateInput"]},ValueTypes["PipelineStageItemUpsertResult"]],
createPipelineStageLocale?: [{	data: ValueTypes["PipelineStageLocaleCreateInput"]},ValueTypes["PipelineStageLocaleCreateResult"]],
deletePipelineStageLocale?: [{	by: ValueTypes["PipelineStageLocaleUniqueWhere"],	filter?: ValueTypes["PipelineStageLocaleWhere"] | undefined | null},ValueTypes["PipelineStageLocaleDeleteResult"]],
updatePipelineStageLocale?: [{	by: ValueTypes["PipelineStageLocaleUniqueWhere"],	filter?: ValueTypes["PipelineStageLocaleWhere"] | undefined | null,	data: ValueTypes["PipelineStageLocaleUpdateInput"]},ValueTypes["PipelineStageLocaleUpdateResult"]],
upsertPipelineStageLocale?: [{	by: ValueTypes["PipelineStageLocaleUniqueWhere"],	filter?: ValueTypes["PipelineStageLocaleWhere"] | undefined | null,	update: ValueTypes["PipelineStageLocaleUpdateInput"],	create: ValueTypes["PipelineStageLocaleCreateInput"]},ValueTypes["PipelineStageLocaleUpsertResult"]],
createSalesManager?: [{	data: ValueTypes["SalesManagerCreateInput"]},ValueTypes["SalesManagerCreateResult"]],
deleteSalesManager?: [{	by: ValueTypes["SalesManagerUniqueWhere"],	filter?: ValueTypes["SalesManagerWhere"] | undefined | null},ValueTypes["SalesManagerDeleteResult"]],
updateSalesManager?: [{	by: ValueTypes["SalesManagerUniqueWhere"],	filter?: ValueTypes["SalesManagerWhere"] | undefined | null,	data: ValueTypes["SalesManagerUpdateInput"]},ValueTypes["SalesManagerUpdateResult"]],
upsertSalesManager?: [{	by: ValueTypes["SalesManagerUniqueWhere"],	filter?: ValueTypes["SalesManagerWhere"] | undefined | null,	update: ValueTypes["SalesManagerUpdateInput"],	create: ValueTypes["SalesManagerCreateInput"]},ValueTypes["SalesManagerUpsertResult"]],
createCashierManager?: [{	data: ValueTypes["CashierManagerCreateInput"]},ValueTypes["CashierManagerCreateResult"]],
deleteCashierManager?: [{	by: ValueTypes["CashierManagerUniqueWhere"],	filter?: ValueTypes["CashierManagerWhere"] | undefined | null},ValueTypes["CashierManagerDeleteResult"]],
updateCashierManager?: [{	by: ValueTypes["CashierManagerUniqueWhere"],	filter?: ValueTypes["CashierManagerWhere"] | undefined | null,	data: ValueTypes["CashierManagerUpdateInput"]},ValueTypes["CashierManagerUpdateResult"]],
upsertCashierManager?: [{	by: ValueTypes["CashierManagerUniqueWhere"],	filter?: ValueTypes["CashierManagerWhere"] | undefined | null,	update: ValueTypes["CashierManagerUpdateInput"],	create: ValueTypes["CashierManagerCreateInput"]},ValueTypes["CashierManagerUpsertResult"]],
createPointOfSaleApplicationDevice?: [{	data: ValueTypes["PointOfSaleApplicationDeviceCreateInput"]},ValueTypes["PointOfSaleApplicationDeviceCreateResult"]],
deletePointOfSaleApplicationDevice?: [{	by: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"],	filter?: ValueTypes["PointOfSaleApplicationDeviceWhere"] | undefined | null},ValueTypes["PointOfSaleApplicationDeviceDeleteResult"]],
updatePointOfSaleApplicationDevice?: [{	by: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"],	filter?: ValueTypes["PointOfSaleApplicationDeviceWhere"] | undefined | null,	data: ValueTypes["PointOfSaleApplicationDeviceUpdateInput"]},ValueTypes["PointOfSaleApplicationDeviceUpdateResult"]],
upsertPointOfSaleApplicationDevice?: [{	by: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"],	filter?: ValueTypes["PointOfSaleApplicationDeviceWhere"] | undefined | null,	update: ValueTypes["PointOfSaleApplicationDeviceUpdateInput"],	create: ValueTypes["PointOfSaleApplicationDeviceCreateInput"]},ValueTypes["PointOfSaleApplicationDeviceUpsertResult"]],
createPointOfSaleTerminal?: [{	data: ValueTypes["PointOfSaleTerminalCreateInput"]},ValueTypes["PointOfSaleTerminalCreateResult"]],
deletePointOfSaleTerminal?: [{	by: ValueTypes["PointOfSaleTerminalUniqueWhere"],	filter?: ValueTypes["PointOfSaleTerminalWhere"] | undefined | null},ValueTypes["PointOfSaleTerminalDeleteResult"]],
updatePointOfSaleTerminal?: [{	by: ValueTypes["PointOfSaleTerminalUniqueWhere"],	filter?: ValueTypes["PointOfSaleTerminalWhere"] | undefined | null,	data: ValueTypes["PointOfSaleTerminalUpdateInput"]},ValueTypes["PointOfSaleTerminalUpdateResult"]],
upsertPointOfSaleTerminal?: [{	by: ValueTypes["PointOfSaleTerminalUniqueWhere"],	filter?: ValueTypes["PointOfSaleTerminalWhere"] | undefined | null,	update: ValueTypes["PointOfSaleTerminalUpdateInput"],	create: ValueTypes["PointOfSaleTerminalCreateInput"]},ValueTypes["PointOfSaleTerminalUpsertResult"]],
createPipelineStageSentiment?: [{	data: ValueTypes["PipelineStageSentimentCreateInput"]},ValueTypes["PipelineStageSentimentCreateResult"]],
deletePipelineStageSentiment?: [{	by: ValueTypes["PipelineStageSentimentUniqueWhere"],	filter?: ValueTypes["PipelineStageSentimentWhere"] | undefined | null},ValueTypes["PipelineStageSentimentDeleteResult"]],
updatePipelineStageSentiment?: [{	by: ValueTypes["PipelineStageSentimentUniqueWhere"],	filter?: ValueTypes["PipelineStageSentimentWhere"] | undefined | null,	data: ValueTypes["PipelineStageSentimentUpdateInput"]},ValueTypes["PipelineStageSentimentUpdateResult"]],
upsertPipelineStageSentiment?: [{	by: ValueTypes["PipelineStageSentimentUniqueWhere"],	filter?: ValueTypes["PipelineStageSentimentWhere"] | undefined | null,	update: ValueTypes["PipelineStageSentimentUpdateInput"],	create: ValueTypes["PipelineStageSentimentCreateInput"]},ValueTypes["PipelineStageSentimentUpsertResult"]],
createDeviceIdentifier?: [{	data: ValueTypes["DeviceIdentifierCreateInput"]},ValueTypes["DeviceIdentifierCreateResult"]],
deleteDeviceIdentifier?: [{	by: ValueTypes["DeviceIdentifierUniqueWhere"],	filter?: ValueTypes["DeviceIdentifierWhere"] | undefined | null},ValueTypes["DeviceIdentifierDeleteResult"]],
updateDeviceIdentifier?: [{	by: ValueTypes["DeviceIdentifierUniqueWhere"],	filter?: ValueTypes["DeviceIdentifierWhere"] | undefined | null,	data: ValueTypes["DeviceIdentifierUpdateInput"]},ValueTypes["DeviceIdentifierUpdateResult"]],
upsertDeviceIdentifier?: [{	by: ValueTypes["DeviceIdentifierUniqueWhere"],	filter?: ValueTypes["DeviceIdentifierWhere"] | undefined | null,	update: ValueTypes["DeviceIdentifierUpdateInput"],	create: ValueTypes["DeviceIdentifierCreateInput"]},ValueTypes["DeviceIdentifierUpsertResult"]],
createPointOfSalePrinter?: [{	data: ValueTypes["PointOfSalePrinterCreateInput"]},ValueTypes["PointOfSalePrinterCreateResult"]],
deletePointOfSalePrinter?: [{	by: ValueTypes["PointOfSalePrinterUniqueWhere"],	filter?: ValueTypes["PointOfSalePrinterWhere"] | undefined | null},ValueTypes["PointOfSalePrinterDeleteResult"]],
updatePointOfSalePrinter?: [{	by: ValueTypes["PointOfSalePrinterUniqueWhere"],	filter?: ValueTypes["PointOfSalePrinterWhere"] | undefined | null,	data: ValueTypes["PointOfSalePrinterUpdateInput"]},ValueTypes["PointOfSalePrinterUpdateResult"]],
upsertPointOfSalePrinter?: [{	by: ValueTypes["PointOfSalePrinterUniqueWhere"],	filter?: ValueTypes["PointOfSalePrinterWhere"] | undefined | null,	update: ValueTypes["PointOfSalePrinterUpdateInput"],	create: ValueTypes["PointOfSalePrinterCreateInput"]},ValueTypes["PointOfSalePrinterUpsertResult"]],
createGratuity?: [{	data: ValueTypes["GratuityCreateInput"]},ValueTypes["GratuityCreateResult"]],
deleteGratuity?: [{	by: ValueTypes["GratuityUniqueWhere"],	filter?: ValueTypes["GratuityWhere"] | undefined | null},ValueTypes["GratuityDeleteResult"]],
updateGratuity?: [{	by: ValueTypes["GratuityUniqueWhere"],	filter?: ValueTypes["GratuityWhere"] | undefined | null,	data: ValueTypes["GratuityUpdateInput"]},ValueTypes["GratuityUpdateResult"]],
upsertGratuity?: [{	by: ValueTypes["GratuityUniqueWhere"],	filter?: ValueTypes["GratuityWhere"] | undefined | null,	update: ValueTypes["GratuityUpdateInput"],	create: ValueTypes["GratuityCreateInput"]},ValueTypes["GratuityUpsertResult"]],
createFulfillmentNote?: [{	data: ValueTypes["FulfillmentNoteCreateInput"]},ValueTypes["FulfillmentNoteCreateResult"]],
deleteFulfillmentNote?: [{	by: ValueTypes["FulfillmentNoteUniqueWhere"],	filter?: ValueTypes["FulfillmentNoteWhere"] | undefined | null},ValueTypes["FulfillmentNoteDeleteResult"]],
updateFulfillmentNote?: [{	by: ValueTypes["FulfillmentNoteUniqueWhere"],	filter?: ValueTypes["FulfillmentNoteWhere"] | undefined | null,	data: ValueTypes["FulfillmentNoteUpdateInput"]},ValueTypes["FulfillmentNoteUpdateResult"]],
upsertFulfillmentNote?: [{	by: ValueTypes["FulfillmentNoteUniqueWhere"],	filter?: ValueTypes["FulfillmentNoteWhere"] | undefined | null,	update: ValueTypes["FulfillmentNoteUpdateInput"],	create: ValueTypes["FulfillmentNoteCreateInput"]},ValueTypes["FulfillmentNoteUpsertResult"]],
createLeadForm?: [{	data: ValueTypes["LeadFormCreateInput"]},ValueTypes["LeadFormCreateResult"]],
deleteLeadForm?: [{	by: ValueTypes["LeadFormUniqueWhere"],	filter?: ValueTypes["LeadFormWhere"] | undefined | null},ValueTypes["LeadFormDeleteResult"]],
updateLeadForm?: [{	by: ValueTypes["LeadFormUniqueWhere"],	filter?: ValueTypes["LeadFormWhere"] | undefined | null,	data: ValueTypes["LeadFormUpdateInput"]},ValueTypes["LeadFormUpdateResult"]],
upsertLeadForm?: [{	by: ValueTypes["LeadFormUniqueWhere"],	filter?: ValueTypes["LeadFormWhere"] | undefined | null,	update: ValueTypes["LeadFormUpdateInput"],	create: ValueTypes["LeadFormCreateInput"]},ValueTypes["LeadFormUpsertResult"]],
createSubscriptionBox?: [{	data: ValueTypes["SubscriptionBoxCreateInput"]},ValueTypes["SubscriptionBoxCreateResult"]],
deleteSubscriptionBox?: [{	by: ValueTypes["SubscriptionBoxUniqueWhere"],	filter?: ValueTypes["SubscriptionBoxWhere"] | undefined | null},ValueTypes["SubscriptionBoxDeleteResult"]],
updateSubscriptionBox?: [{	by: ValueTypes["SubscriptionBoxUniqueWhere"],	filter?: ValueTypes["SubscriptionBoxWhere"] | undefined | null,	data: ValueTypes["SubscriptionBoxUpdateInput"]},ValueTypes["SubscriptionBoxUpdateResult"]],
upsertSubscriptionBox?: [{	by: ValueTypes["SubscriptionBoxUniqueWhere"],	filter?: ValueTypes["SubscriptionBoxWhere"] | undefined | null,	update: ValueTypes["SubscriptionBoxUpdateInput"],	create: ValueTypes["SubscriptionBoxCreateInput"]},ValueTypes["SubscriptionBoxUpsertResult"]],
createSubscriptionBoxLocale?: [{	data: ValueTypes["SubscriptionBoxLocaleCreateInput"]},ValueTypes["SubscriptionBoxLocaleCreateResult"]],
deleteSubscriptionBoxLocale?: [{	by: ValueTypes["SubscriptionBoxLocaleUniqueWhere"],	filter?: ValueTypes["SubscriptionBoxLocaleWhere"] | undefined | null},ValueTypes["SubscriptionBoxLocaleDeleteResult"]],
updateSubscriptionBoxLocale?: [{	by: ValueTypes["SubscriptionBoxLocaleUniqueWhere"],	filter?: ValueTypes["SubscriptionBoxLocaleWhere"] | undefined | null,	data: ValueTypes["SubscriptionBoxLocaleUpdateInput"]},ValueTypes["SubscriptionBoxLocaleUpdateResult"]],
upsertSubscriptionBoxLocale?: [{	by: ValueTypes["SubscriptionBoxLocaleUniqueWhere"],	filter?: ValueTypes["SubscriptionBoxLocaleWhere"] | undefined | null,	update: ValueTypes["SubscriptionBoxLocaleUpdateInput"],	create: ValueTypes["SubscriptionBoxLocaleCreateInput"]},ValueTypes["SubscriptionBoxLocaleUpsertResult"]],
createBusinessService?: [{	data: ValueTypes["BusinessServiceCreateInput"]},ValueTypes["BusinessServiceCreateResult"]],
deleteBusinessService?: [{	by: ValueTypes["BusinessServiceUniqueWhere"],	filter?: ValueTypes["BusinessServiceWhere"] | undefined | null},ValueTypes["BusinessServiceDeleteResult"]],
updateBusinessService?: [{	by: ValueTypes["BusinessServiceUniqueWhere"],	filter?: ValueTypes["BusinessServiceWhere"] | undefined | null,	data: ValueTypes["BusinessServiceUpdateInput"]},ValueTypes["BusinessServiceUpdateResult"]],
upsertBusinessService?: [{	by: ValueTypes["BusinessServiceUniqueWhere"],	filter?: ValueTypes["BusinessServiceWhere"] | undefined | null,	update: ValueTypes["BusinessServiceUpdateInput"],	create: ValueTypes["BusinessServiceCreateInput"]},ValueTypes["BusinessServiceUpsertResult"]],
createBusinessServiceEvent?: [{	data: ValueTypes["BusinessServiceEventCreateInput"]},ValueTypes["BusinessServiceEventCreateResult"]],
deleteBusinessServiceEvent?: [{	by: ValueTypes["BusinessServiceEventUniqueWhere"],	filter?: ValueTypes["BusinessServiceEventWhere"] | undefined | null},ValueTypes["BusinessServiceEventDeleteResult"]],
updateBusinessServiceEvent?: [{	by: ValueTypes["BusinessServiceEventUniqueWhere"],	filter?: ValueTypes["BusinessServiceEventWhere"] | undefined | null,	data: ValueTypes["BusinessServiceEventUpdateInput"]},ValueTypes["BusinessServiceEventUpdateResult"]],
upsertBusinessServiceEvent?: [{	by: ValueTypes["BusinessServiceEventUniqueWhere"],	filter?: ValueTypes["BusinessServiceEventWhere"] | undefined | null,	update: ValueTypes["BusinessServiceEventUpdateInput"],	create: ValueTypes["BusinessServiceEventCreateInput"]},ValueTypes["BusinessServiceEventUpsertResult"]],
createBusinessServiceLocale?: [{	data: ValueTypes["BusinessServiceLocaleCreateInput"]},ValueTypes["BusinessServiceLocaleCreateResult"]],
deleteBusinessServiceLocale?: [{	by: ValueTypes["BusinessServiceLocaleUniqueWhere"],	filter?: ValueTypes["BusinessServiceLocaleWhere"] | undefined | null},ValueTypes["BusinessServiceLocaleDeleteResult"]],
updateBusinessServiceLocale?: [{	by: ValueTypes["BusinessServiceLocaleUniqueWhere"],	filter?: ValueTypes["BusinessServiceLocaleWhere"] | undefined | null,	data: ValueTypes["BusinessServiceLocaleUpdateInput"]},ValueTypes["BusinessServiceLocaleUpdateResult"]],
upsertBusinessServiceLocale?: [{	by: ValueTypes["BusinessServiceLocaleUniqueWhere"],	filter?: ValueTypes["BusinessServiceLocaleWhere"] | undefined | null,	update: ValueTypes["BusinessServiceLocaleUpdateInput"],	create: ValueTypes["BusinessServiceLocaleCreateInput"]},ValueTypes["BusinessServiceLocaleUpsertResult"]],
createGridTileItem?: [{	data: ValueTypes["GridTileItemCreateInput"]},ValueTypes["GridTileItemCreateResult"]],
deleteGridTileItem?: [{	by: ValueTypes["GridTileItemUniqueWhere"],	filter?: ValueTypes["GridTileItemWhere"] | undefined | null},ValueTypes["GridTileItemDeleteResult"]],
updateGridTileItem?: [{	by: ValueTypes["GridTileItemUniqueWhere"],	filter?: ValueTypes["GridTileItemWhere"] | undefined | null,	data: ValueTypes["GridTileItemUpdateInput"]},ValueTypes["GridTileItemUpdateResult"]],
upsertGridTileItem?: [{	by: ValueTypes["GridTileItemUniqueWhere"],	filter?: ValueTypes["GridTileItemWhere"] | undefined | null,	update: ValueTypes["GridTileItemUpdateInput"],	create: ValueTypes["GridTileItemCreateInput"]},ValueTypes["GridTileItemUpsertResult"]],
createGridTiles?: [{	data: ValueTypes["GridTilesCreateInput"]},ValueTypes["GridTilesCreateResult"]],
deleteGridTiles?: [{	by: ValueTypes["GridTilesUniqueWhere"],	filter?: ValueTypes["GridTilesWhere"] | undefined | null},ValueTypes["GridTilesDeleteResult"]],
updateGridTiles?: [{	by: ValueTypes["GridTilesUniqueWhere"],	filter?: ValueTypes["GridTilesWhere"] | undefined | null,	data: ValueTypes["GridTilesUpdateInput"]},ValueTypes["GridTilesUpdateResult"]],
upsertGridTiles?: [{	by: ValueTypes["GridTilesUniqueWhere"],	filter?: ValueTypes["GridTilesWhere"] | undefined | null,	update: ValueTypes["GridTilesUpdateInput"],	create: ValueTypes["GridTilesCreateInput"]},ValueTypes["GridTilesUpsertResult"]],
createArea?: [{	data: ValueTypes["AreaCreateInput"]},ValueTypes["AreaCreateResult"]],
deleteArea?: [{	by: ValueTypes["AreaUniqueWhere"],	filter?: ValueTypes["AreaWhere"] | undefined | null},ValueTypes["AreaDeleteResult"]],
updateArea?: [{	by: ValueTypes["AreaUniqueWhere"],	filter?: ValueTypes["AreaWhere"] | undefined | null,	data: ValueTypes["AreaUpdateInput"]},ValueTypes["AreaUpdateResult"]],
upsertArea?: [{	by: ValueTypes["AreaUniqueWhere"],	filter?: ValueTypes["AreaWhere"] | undefined | null,	update: ValueTypes["AreaUpdateInput"],	create: ValueTypes["AreaCreateInput"]},ValueTypes["AreaUpsertResult"]],
createPosition?: [{	data: ValueTypes["PositionCreateInput"]},ValueTypes["PositionCreateResult"]],
deletePosition?: [{	by: ValueTypes["PositionUniqueWhere"],	filter?: ValueTypes["PositionWhere"] | undefined | null},ValueTypes["PositionDeleteResult"]],
updatePosition?: [{	by: ValueTypes["PositionUniqueWhere"],	filter?: ValueTypes["PositionWhere"] | undefined | null,	data: ValueTypes["PositionUpdateInput"]},ValueTypes["PositionUpdateResult"]],
upsertPosition?: [{	by: ValueTypes["PositionUniqueWhere"],	filter?: ValueTypes["PositionWhere"] | undefined | null,	update: ValueTypes["PositionUpdateInput"],	create: ValueTypes["PositionCreateInput"]},ValueTypes["PositionUpsertResult"]],
createStatsEnabledWidgetType?: [{	data: ValueTypes["StatsEnabledWidgetTypeCreateInput"]},ValueTypes["StatsEnabledWidgetTypeCreateResult"]],
deleteStatsEnabledWidgetType?: [{	by: ValueTypes["StatsEnabledWidgetTypeUniqueWhere"],	filter?: ValueTypes["StatsEnabledWidgetTypeWhere"] | undefined | null},ValueTypes["StatsEnabledWidgetTypeDeleteResult"]],
updateStatsEnabledWidgetType?: [{	by: ValueTypes["StatsEnabledWidgetTypeUniqueWhere"],	filter?: ValueTypes["StatsEnabledWidgetTypeWhere"] | undefined | null,	data: ValueTypes["StatsEnabledWidgetTypeUpdateInput"]},ValueTypes["StatsEnabledWidgetTypeUpdateResult"]],
upsertStatsEnabledWidgetType?: [{	by: ValueTypes["StatsEnabledWidgetTypeUniqueWhere"],	filter?: ValueTypes["StatsEnabledWidgetTypeWhere"] | undefined | null,	update: ValueTypes["StatsEnabledWidgetTypeUpdateInput"],	create: ValueTypes["StatsEnabledWidgetTypeCreateInput"]},ValueTypes["StatsEnabledWidgetTypeUpsertResult"]],
createStatsWidget?: [{	data: ValueTypes["StatsWidgetCreateInput"]},ValueTypes["StatsWidgetCreateResult"]],
deleteStatsWidget?: [{	by: ValueTypes["StatsWidgetUniqueWhere"],	filter?: ValueTypes["StatsWidgetWhere"] | undefined | null},ValueTypes["StatsWidgetDeleteResult"]],
updateStatsWidget?: [{	by: ValueTypes["StatsWidgetUniqueWhere"],	filter?: ValueTypes["StatsWidgetWhere"] | undefined | null,	data: ValueTypes["StatsWidgetUpdateInput"]},ValueTypes["StatsWidgetUpdateResult"]],
upsertStatsWidget?: [{	by: ValueTypes["StatsWidgetUniqueWhere"],	filter?: ValueTypes["StatsWidgetWhere"] | undefined | null,	update: ValueTypes["StatsWidgetUpdateInput"],	create: ValueTypes["StatsWidgetCreateInput"]},ValueTypes["StatsWidgetUpsertResult"]],
createStatsWidgetsLayout?: [{	data: ValueTypes["StatsWidgetsLayoutCreateInput"]},ValueTypes["StatsWidgetsLayoutCreateResult"]],
deleteStatsWidgetsLayout?: [{	by: ValueTypes["StatsWidgetsLayoutUniqueWhere"],	filter?: ValueTypes["StatsWidgetsLayoutWhere"] | undefined | null},ValueTypes["StatsWidgetsLayoutDeleteResult"]],
updateStatsWidgetsLayout?: [{	by: ValueTypes["StatsWidgetsLayoutUniqueWhere"],	filter?: ValueTypes["StatsWidgetsLayoutWhere"] | undefined | null,	data: ValueTypes["StatsWidgetsLayoutUpdateInput"]},ValueTypes["StatsWidgetsLayoutUpdateResult"]],
upsertStatsWidgetsLayout?: [{	by: ValueTypes["StatsWidgetsLayoutUniqueWhere"],	filter?: ValueTypes["StatsWidgetsLayoutWhere"] | undefined | null,	update: ValueTypes["StatsWidgetsLayoutUpdateInput"],	create: ValueTypes["StatsWidgetsLayoutCreateInput"]},ValueTypes["StatsWidgetsLayoutUpsertResult"]],
createSeat?: [{	data: ValueTypes["SeatCreateInput"]},ValueTypes["SeatCreateResult"]],
deleteSeat?: [{	by: ValueTypes["SeatUniqueWhere"],	filter?: ValueTypes["SeatWhere"] | undefined | null},ValueTypes["SeatDeleteResult"]],
updateSeat?: [{	by: ValueTypes["SeatUniqueWhere"],	filter?: ValueTypes["SeatWhere"] | undefined | null,	data: ValueTypes["SeatUpdateInput"]},ValueTypes["SeatUpdateResult"]],
upsertSeat?: [{	by: ValueTypes["SeatUniqueWhere"],	filter?: ValueTypes["SeatWhere"] | undefined | null,	update: ValueTypes["SeatUpdateInput"],	create: ValueTypes["SeatCreateInput"]},ValueTypes["SeatUpsertResult"]],
createTable?: [{	data: ValueTypes["TableCreateInput"]},ValueTypes["TableCreateResult"]],
deleteTable?: [{	by: ValueTypes["TableUniqueWhere"],	filter?: ValueTypes["TableWhere"] | undefined | null},ValueTypes["TableDeleteResult"]],
updateTable?: [{	by: ValueTypes["TableUniqueWhere"],	filter?: ValueTypes["TableWhere"] | undefined | null,	data: ValueTypes["TableUpdateInput"]},ValueTypes["TableUpdateResult"]],
upsertTable?: [{	by: ValueTypes["TableUniqueWhere"],	filter?: ValueTypes["TableWhere"] | undefined | null,	update: ValueTypes["TableUpdateInput"],	create: ValueTypes["TableCreateInput"]},ValueTypes["TableUpsertResult"]],
createStatsPage?: [{	data: ValueTypes["StatsPageCreateInput"]},ValueTypes["StatsPageCreateResult"]],
deleteStatsPage?: [{	by: ValueTypes["StatsPageUniqueWhere"],	filter?: ValueTypes["StatsPageWhere"] | undefined | null},ValueTypes["StatsPageDeleteResult"]],
updateStatsPage?: [{	by: ValueTypes["StatsPageUniqueWhere"],	filter?: ValueTypes["StatsPageWhere"] | undefined | null,	data: ValueTypes["StatsPageUpdateInput"]},ValueTypes["StatsPageUpdateResult"]],
upsertStatsPage?: [{	by: ValueTypes["StatsPageUniqueWhere"],	filter?: ValueTypes["StatsPageWhere"] | undefined | null,	update: ValueTypes["StatsPageUpdateInput"],	create: ValueTypes["StatsPageCreateInput"]},ValueTypes["StatsPageUpsertResult"]],
createUnassignReason?: [{	data: ValueTypes["UnassignReasonCreateInput"]},ValueTypes["UnassignReasonCreateResult"]],
deleteUnassignReason?: [{	by: ValueTypes["UnassignReasonUniqueWhere"],	filter?: ValueTypes["UnassignReasonWhere"] | undefined | null},ValueTypes["UnassignReasonDeleteResult"]],
updateUnassignReason?: [{	by: ValueTypes["UnassignReasonUniqueWhere"],	filter?: ValueTypes["UnassignReasonWhere"] | undefined | null,	data: ValueTypes["UnassignReasonUpdateInput"]},ValueTypes["UnassignReasonUpdateResult"]],
upsertUnassignReason?: [{	by: ValueTypes["UnassignReasonUniqueWhere"],	filter?: ValueTypes["UnassignReasonWhere"] | undefined | null,	update: ValueTypes["UnassignReasonUpdateInput"],	create: ValueTypes["UnassignReasonCreateInput"]},ValueTypes["UnassignReasonUpsertResult"]],
createDoubleshotCoffeeEquipment?: [{	data: ValueTypes["DoubleshotCoffeeEquipmentCreateInput"]},ValueTypes["DoubleshotCoffeeEquipmentCreateResult"]],
deleteDoubleshotCoffeeEquipment?: [{	by: ValueTypes["DoubleshotCoffeeEquipmentUniqueWhere"],	filter?: ValueTypes["DoubleshotCoffeeEquipmentWhere"] | undefined | null},ValueTypes["DoubleshotCoffeeEquipmentDeleteResult"]],
updateDoubleshotCoffeeEquipment?: [{	by: ValueTypes["DoubleshotCoffeeEquipmentUniqueWhere"],	filter?: ValueTypes["DoubleshotCoffeeEquipmentWhere"] | undefined | null,	data: ValueTypes["DoubleshotCoffeeEquipmentUpdateInput"]},ValueTypes["DoubleshotCoffeeEquipmentUpdateResult"]],
upsertDoubleshotCoffeeEquipment?: [{	by: ValueTypes["DoubleshotCoffeeEquipmentUniqueWhere"],	filter?: ValueTypes["DoubleshotCoffeeEquipmentWhere"] | undefined | null,	update: ValueTypes["DoubleshotCoffeeEquipmentUpdateInput"],	create: ValueTypes["DoubleshotCoffeeEquipmentCreateInput"]},ValueTypes["DoubleshotCoffeeEquipmentUpsertResult"]],
createExpense?: [{	data: ValueTypes["ExpenseCreateInput"]},ValueTypes["ExpenseCreateResult"]],
deleteExpense?: [{	by: ValueTypes["ExpenseUniqueWhere"],	filter?: ValueTypes["ExpenseWhere"] | undefined | null},ValueTypes["ExpenseDeleteResult"]],
updateExpense?: [{	by: ValueTypes["ExpenseUniqueWhere"],	filter?: ValueTypes["ExpenseWhere"] | undefined | null,	data: ValueTypes["ExpenseUpdateInput"]},ValueTypes["ExpenseUpdateResult"]],
upsertExpense?: [{	by: ValueTypes["ExpenseUniqueWhere"],	filter?: ValueTypes["ExpenseWhere"] | undefined | null,	update: ValueTypes["ExpenseUpdateInput"],	create: ValueTypes["ExpenseCreateInput"]},ValueTypes["ExpenseUpsertResult"]],
createExpenseCategory?: [{	data: ValueTypes["ExpenseCategoryCreateInput"]},ValueTypes["ExpenseCategoryCreateResult"]],
deleteExpenseCategory?: [{	by: ValueTypes["ExpenseCategoryUniqueWhere"],	filter?: ValueTypes["ExpenseCategoryWhere"] | undefined | null},ValueTypes["ExpenseCategoryDeleteResult"]],
updateExpenseCategory?: [{	by: ValueTypes["ExpenseCategoryUniqueWhere"],	filter?: ValueTypes["ExpenseCategoryWhere"] | undefined | null,	data: ValueTypes["ExpenseCategoryUpdateInput"]},ValueTypes["ExpenseCategoryUpdateResult"]],
upsertExpenseCategory?: [{	by: ValueTypes["ExpenseCategoryUniqueWhere"],	filter?: ValueTypes["ExpenseCategoryWhere"] | undefined | null,	update: ValueTypes["ExpenseCategoryUpdateInput"],	create: ValueTypes["ExpenseCategoryCreateInput"]},ValueTypes["ExpenseCategoryUpsertResult"]],
createExpenseChange?: [{	data: ValueTypes["ExpenseChangeCreateInput"]},ValueTypes["ExpenseChangeCreateResult"]],
deleteExpenseChange?: [{	by: ValueTypes["ExpenseChangeUniqueWhere"],	filter?: ValueTypes["ExpenseChangeWhere"] | undefined | null},ValueTypes["ExpenseChangeDeleteResult"]],
updateExpenseChange?: [{	by: ValueTypes["ExpenseChangeUniqueWhere"],	filter?: ValueTypes["ExpenseChangeWhere"] | undefined | null,	data: ValueTypes["ExpenseChangeUpdateInput"]},ValueTypes["ExpenseChangeUpdateResult"]],
upsertExpenseChange?: [{	by: ValueTypes["ExpenseChangeUniqueWhere"],	filter?: ValueTypes["ExpenseChangeWhere"] | undefined | null,	update: ValueTypes["ExpenseChangeUpdateInput"],	create: ValueTypes["ExpenseChangeCreateInput"]},ValueTypes["ExpenseChangeUpsertResult"]],
createExpenseDocument?: [{	data: ValueTypes["ExpenseDocumentCreateInput"]},ValueTypes["ExpenseDocumentCreateResult"]],
deleteExpenseDocument?: [{	by: ValueTypes["ExpenseDocumentUniqueWhere"],	filter?: ValueTypes["ExpenseDocumentWhere"] | undefined | null},ValueTypes["ExpenseDocumentDeleteResult"]],
updateExpenseDocument?: [{	by: ValueTypes["ExpenseDocumentUniqueWhere"],	filter?: ValueTypes["ExpenseDocumentWhere"] | undefined | null,	data: ValueTypes["ExpenseDocumentUpdateInput"]},ValueTypes["ExpenseDocumentUpdateResult"]],
upsertExpenseDocument?: [{	by: ValueTypes["ExpenseDocumentUniqueWhere"],	filter?: ValueTypes["ExpenseDocumentWhere"] | undefined | null,	update: ValueTypes["ExpenseDocumentUpdateInput"],	create: ValueTypes["ExpenseDocumentCreateInput"]},ValueTypes["ExpenseDocumentUpsertResult"]],
createRevenuePrediction?: [{	data: ValueTypes["RevenuePredictionCreateInput"]},ValueTypes["RevenuePredictionCreateResult"]],
deleteRevenuePrediction?: [{	by: ValueTypes["RevenuePredictionUniqueWhere"],	filter?: ValueTypes["RevenuePredictionWhere"] | undefined | null},ValueTypes["RevenuePredictionDeleteResult"]],
updateRevenuePrediction?: [{	by: ValueTypes["RevenuePredictionUniqueWhere"],	filter?: ValueTypes["RevenuePredictionWhere"] | undefined | null,	data: ValueTypes["RevenuePredictionUpdateInput"]},ValueTypes["RevenuePredictionUpdateResult"]],
upsertRevenuePrediction?: [{	by: ValueTypes["RevenuePredictionUniqueWhere"],	filter?: ValueTypes["RevenuePredictionWhere"] | undefined | null,	update: ValueTypes["RevenuePredictionUpdateInput"],	create: ValueTypes["RevenuePredictionCreateInput"]},ValueTypes["RevenuePredictionUpsertResult"]],
createRevenuePredictionChange?: [{	data: ValueTypes["RevenuePredictionChangeCreateInput"]},ValueTypes["RevenuePredictionChangeCreateResult"]],
deleteRevenuePredictionChange?: [{	by: ValueTypes["RevenuePredictionChangeUniqueWhere"],	filter?: ValueTypes["RevenuePredictionChangeWhere"] | undefined | null},ValueTypes["RevenuePredictionChangeDeleteResult"]],
updateRevenuePredictionChange?: [{	by: ValueTypes["RevenuePredictionChangeUniqueWhere"],	filter?: ValueTypes["RevenuePredictionChangeWhere"] | undefined | null,	data: ValueTypes["RevenuePredictionChangeUpdateInput"]},ValueTypes["RevenuePredictionChangeUpdateResult"]],
upsertRevenuePredictionChange?: [{	by: ValueTypes["RevenuePredictionChangeUniqueWhere"],	filter?: ValueTypes["RevenuePredictionChangeWhere"] | undefined | null,	update: ValueTypes["RevenuePredictionChangeUpdateInput"],	create: ValueTypes["RevenuePredictionChangeCreateInput"]},ValueTypes["RevenuePredictionChangeUpsertResult"]],
createFile?: [{	data: ValueTypes["FileCreateInput"]},ValueTypes["FileCreateResult"]],
deleteFile?: [{	by: ValueTypes["FileUniqueWhere"],	filter?: ValueTypes["FileWhere"] | undefined | null},ValueTypes["FileDeleteResult"]],
updateFile?: [{	by: ValueTypes["FileUniqueWhere"],	filter?: ValueTypes["FileWhere"] | undefined | null,	data: ValueTypes["FileUpdateInput"]},ValueTypes["FileUpdateResult"]],
upsertFile?: [{	by: ValueTypes["FileUniqueWhere"],	filter?: ValueTypes["FileWhere"] | undefined | null,	update: ValueTypes["FileUpdateInput"],	create: ValueTypes["FileCreateInput"]},ValueTypes["FileUpsertResult"]],
createLine?: [{	data: ValueTypes["LineCreateInput"]},ValueTypes["LineCreateResult"]],
deleteLine?: [{	by: ValueTypes["LineUniqueWhere"],	filter?: ValueTypes["LineWhere"] | undefined | null},ValueTypes["LineDeleteResult"]],
updateLine?: [{	by: ValueTypes["LineUniqueWhere"],	filter?: ValueTypes["LineWhere"] | undefined | null,	data: ValueTypes["LineUpdateInput"]},ValueTypes["LineUpdateResult"]],
upsertLine?: [{	by: ValueTypes["LineUniqueWhere"],	filter?: ValueTypes["LineWhere"] | undefined | null,	update: ValueTypes["LineUpdateInput"],	create: ValueTypes["LineCreateInput"]},ValueTypes["LineUpsertResult"]],
createFinancesBalanceItem?: [{	data: ValueTypes["FinancesBalanceItemCreateInput"]},ValueTypes["FinancesBalanceItemCreateResult"]],
deleteFinancesBalanceItem?: [{	by: ValueTypes["FinancesBalanceItemUniqueWhere"],	filter?: ValueTypes["FinancesBalanceItemWhere"] | undefined | null},ValueTypes["FinancesBalanceItemDeleteResult"]],
updateFinancesBalanceItem?: [{	by: ValueTypes["FinancesBalanceItemUniqueWhere"],	filter?: ValueTypes["FinancesBalanceItemWhere"] | undefined | null,	data: ValueTypes["FinancesBalanceItemUpdateInput"]},ValueTypes["FinancesBalanceItemUpdateResult"]],
upsertFinancesBalanceItem?: [{	by: ValueTypes["FinancesBalanceItemUniqueWhere"],	filter?: ValueTypes["FinancesBalanceItemWhere"] | undefined | null,	update: ValueTypes["FinancesBalanceItemUpdateInput"],	create: ValueTypes["FinancesBalanceItemCreateInput"]},ValueTypes["FinancesBalanceItemUpsertResult"]],
createWoltDriveDelivery?: [{	data: ValueTypes["WoltDriveDeliveryCreateInput"]},ValueTypes["WoltDriveDeliveryCreateResult"]],
deleteWoltDriveDelivery?: [{	by: ValueTypes["WoltDriveDeliveryUniqueWhere"],	filter?: ValueTypes["WoltDriveDeliveryWhere"] | undefined | null},ValueTypes["WoltDriveDeliveryDeleteResult"]],
updateWoltDriveDelivery?: [{	by: ValueTypes["WoltDriveDeliveryUniqueWhere"],	filter?: ValueTypes["WoltDriveDeliveryWhere"] | undefined | null,	data: ValueTypes["WoltDriveDeliveryUpdateInput"]},ValueTypes["WoltDriveDeliveryUpdateResult"]],
upsertWoltDriveDelivery?: [{	by: ValueTypes["WoltDriveDeliveryUniqueWhere"],	filter?: ValueTypes["WoltDriveDeliveryWhere"] | undefined | null,	update: ValueTypes["WoltDriveDeliveryUpdateInput"],	create: ValueTypes["WoltDriveDeliveryCreateInput"]},ValueTypes["WoltDriveDeliveryUpsertResult"]],
transaction?: [{	options?: ValueTypes["MutationTransactionOptions"] | undefined | null},ValueTypes["MutationTransaction"]],
	query?:ValueTypes["Query"],
generateUploadUrl?: [{	contentType: string,	expiration?: number | undefined | null,	prefix?: string | undefined | null},ValueTypes["S3SignedUpload"]],
generateReadUrl?: [{	objectKey: string,	expiration?: number | undefined | null},ValueTypes["S3SignedRead"]],
		__typename?: boolean | `@${string}`
}>;
	["AddressCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Address"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MutationResult"]:AliasType<{
		ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"];
		['...on AddressCreateResult']?: Omit<ValueTypes["AddressCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AddressDeleteResult']?: Omit<ValueTypes["AddressDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on AddressUpdateResult']?: Omit<ValueTypes["AddressUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AddressUpsertResult']?: Omit<ValueTypes["AddressUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on CountryCreateResult']?: Omit<ValueTypes["CountryCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CountryDeleteResult']?: Omit<ValueTypes["CountryDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on CountryUpdateResult']?: Omit<ValueTypes["CountryUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CountryUpsertResult']?: Omit<ValueTypes["CountryUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ChannelCreateResult']?: Omit<ValueTypes["ChannelCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ChannelDeleteResult']?: Omit<ValueTypes["ChannelDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ChannelUpdateResult']?: Omit<ValueTypes["ChannelUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ChannelUpsertResult']?: Omit<ValueTypes["ChannelUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ChannelPaymentCreateResult']?: Omit<ValueTypes["ChannelPaymentCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ChannelPaymentDeleteResult']?: Omit<ValueTypes["ChannelPaymentDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ChannelPaymentUpdateResult']?: Omit<ValueTypes["ChannelPaymentUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ChannelPaymentUpsertResult']?: Omit<ValueTypes["ChannelPaymentUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ChannelDeliveryCreateResult']?: Omit<ValueTypes["ChannelDeliveryCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ChannelDeliveryDeleteResult']?: Omit<ValueTypes["ChannelDeliveryDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ChannelDeliveryUpdateResult']?: Omit<ValueTypes["ChannelDeliveryUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ChannelDeliveryUpsertResult']?: Omit<ValueTypes["ChannelDeliveryUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerCreateResult']?: Omit<ValueTypes["CustomerCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerDeleteResult']?: Omit<ValueTypes["CustomerDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerUpdateResult']?: Omit<ValueTypes["CustomerUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerUpsertResult']?: Omit<ValueTypes["CustomerUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerCreditCreateResult']?: Omit<ValueTypes["CustomerCreditCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerCreditDeleteResult']?: Omit<ValueTypes["CustomerCreditDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerCreditUpdateResult']?: Omit<ValueTypes["CustomerCreditUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerCreditUpsertResult']?: Omit<ValueTypes["CustomerCreditUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerGroupCreateResult']?: Omit<ValueTypes["CustomerGroupCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerGroupDeleteResult']?: Omit<ValueTypes["CustomerGroupDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerGroupUpdateResult']?: Omit<ValueTypes["CustomerGroupUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerGroupUpsertResult']?: Omit<ValueTypes["CustomerGroupUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerPaymentMethodCreateResult']?: Omit<ValueTypes["CustomerPaymentMethodCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerPaymentMethodDeleteResult']?: Omit<ValueTypes["CustomerPaymentMethodDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerPaymentMethodUpdateResult']?: Omit<ValueTypes["CustomerPaymentMethodUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerPaymentMethodUpsertResult']?: Omit<ValueTypes["CustomerPaymentMethodUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeliveryMethodCreateResult']?: Omit<ValueTypes["DeliveryMethodCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeliveryMethodDeleteResult']?: Omit<ValueTypes["DeliveryMethodDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeliveryMethodUpdateResult']?: Omit<ValueTypes["DeliveryMethodUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeliveryMethodUpsertResult']?: Omit<ValueTypes["DeliveryMethodUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on OrderCreateResult']?: Omit<ValueTypes["OrderCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on OrderDeleteResult']?: Omit<ValueTypes["OrderDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on OrderUpdateResult']?: Omit<ValueTypes["OrderUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on OrderUpsertResult']?: Omit<ValueTypes["OrderUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on OrderDiscountCreateResult']?: Omit<ValueTypes["OrderDiscountCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on OrderDiscountDeleteResult']?: Omit<ValueTypes["OrderDiscountDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on OrderDiscountUpdateResult']?: Omit<ValueTypes["OrderDiscountUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on OrderDiscountUpsertResult']?: Omit<ValueTypes["OrderDiscountUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on OrderPaymentCreateResult']?: Omit<ValueTypes["OrderPaymentCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on OrderPaymentDeleteResult']?: Omit<ValueTypes["OrderPaymentDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on OrderPaymentUpdateResult']?: Omit<ValueTypes["OrderPaymentUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on OrderPaymentUpsertResult']?: Omit<ValueTypes["OrderPaymentUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on OrderDeliveryCreateResult']?: Omit<ValueTypes["OrderDeliveryCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on OrderDeliveryDeleteResult']?: Omit<ValueTypes["OrderDeliveryDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on OrderDeliveryUpdateResult']?: Omit<ValueTypes["OrderDeliveryUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on OrderDeliveryUpsertResult']?: Omit<ValueTypes["OrderDeliveryUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on OrderItemCreateResult']?: Omit<ValueTypes["OrderItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on OrderItemDeleteResult']?: Omit<ValueTypes["OrderItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on OrderItemUpdateResult']?: Omit<ValueTypes["OrderItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on OrderItemUpsertResult']?: Omit<ValueTypes["OrderItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PaymentMethodCreateResult']?: Omit<ValueTypes["PaymentMethodCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PaymentMethodDeleteResult']?: Omit<ValueTypes["PaymentMethodDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PaymentMethodUpdateResult']?: Omit<ValueTypes["PaymentMethodUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PaymentMethodUpsertResult']?: Omit<ValueTypes["PaymentMethodUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on VatRateCreateResult']?: Omit<ValueTypes["VatRateCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on VatRateDeleteResult']?: Omit<ValueTypes["VatRateDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on VatRateUpdateResult']?: Omit<ValueTypes["VatRateUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on VatRateUpsertResult']?: Omit<ValueTypes["VatRateUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductCreateResult']?: Omit<ValueTypes["ProductCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductDeleteResult']?: Omit<ValueTypes["ProductDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductUpdateResult']?: Omit<ValueTypes["ProductUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductUpsertResult']?: Omit<ValueTypes["ProductUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductStockCreateResult']?: Omit<ValueTypes["ProductStockCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductStockDeleteResult']?: Omit<ValueTypes["ProductStockDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductStockUpdateResult']?: Omit<ValueTypes["ProductStockUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductStockUpsertResult']?: Omit<ValueTypes["ProductStockUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductPackingCreateResult']?: Omit<ValueTypes["ProductPackingCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductPackingDeleteResult']?: Omit<ValueTypes["ProductPackingDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductPackingUpdateResult']?: Omit<ValueTypes["ProductPackingUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductPackingUpsertResult']?: Omit<ValueTypes["ProductPackingUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductGroupPriceCreateResult']?: Omit<ValueTypes["ProductGroupPriceCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductGroupPriceDeleteResult']?: Omit<ValueTypes["ProductGroupPriceDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductGroupPriceUpdateResult']?: Omit<ValueTypes["ProductGroupPriceUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductGroupPriceUpsertResult']?: Omit<ValueTypes["ProductGroupPriceUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductRecipeCreateResult']?: Omit<ValueTypes["ProductRecipeCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductRecipeDeleteResult']?: Omit<ValueTypes["ProductRecipeDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductRecipeUpdateResult']?: Omit<ValueTypes["ProductRecipeUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductRecipeUpsertResult']?: Omit<ValueTypes["ProductRecipeUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductCategoryCreateResult']?: Omit<ValueTypes["ProductCategoryCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductCategoryDeleteResult']?: Omit<ValueTypes["ProductCategoryDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductCategoryUpdateResult']?: Omit<ValueTypes["ProductCategoryUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductCategoryUpsertResult']?: Omit<ValueTypes["ProductCategoryUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on StoreCreateResult']?: Omit<ValueTypes["StoreCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StoreDeleteResult']?: Omit<ValueTypes["StoreDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on StoreUpdateResult']?: Omit<ValueTypes["StoreUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StoreUpsertResult']?: Omit<ValueTypes["StoreUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TagCreateResult']?: Omit<ValueTypes["TagCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TagDeleteResult']?: Omit<ValueTypes["TagDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TagUpdateResult']?: Omit<ValueTypes["TagUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TagUpsertResult']?: Omit<ValueTypes["TagUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageCreateResult']?: Omit<ValueTypes["ImageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageDeleteResult']?: Omit<ValueTypes["ImageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageUpdateResult']?: Omit<ValueTypes["ImageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageUpsertResult']?: Omit<ValueTypes["ImageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessCategoryCreateResult']?: Omit<ValueTypes["BusinessCategoryCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessCategoryDeleteResult']?: Omit<ValueTypes["BusinessCategoryDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessCategoryUpdateResult']?: Omit<ValueTypes["BusinessCategoryUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessCategoryUpsertResult']?: Omit<ValueTypes["BusinessCategoryUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductListCreateResult']?: Omit<ValueTypes["ProductListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductListDeleteResult']?: Omit<ValueTypes["ProductListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductListUpdateResult']?: Omit<ValueTypes["ProductListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductListUpsertResult']?: Omit<ValueTypes["ProductListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductListItemCreateResult']?: Omit<ValueTypes["ProductListItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductListItemDeleteResult']?: Omit<ValueTypes["ProductListItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductListItemUpdateResult']?: Omit<ValueTypes["ProductListItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductListItemUpsertResult']?: Omit<ValueTypes["ProductListItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductCategoryListCreateResult']?: Omit<ValueTypes["ProductCategoryListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductCategoryListDeleteResult']?: Omit<ValueTypes["ProductCategoryListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductCategoryListUpdateResult']?: Omit<ValueTypes["ProductCategoryListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductCategoryListUpsertResult']?: Omit<ValueTypes["ProductCategoryListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductCategoryListItemCreateResult']?: Omit<ValueTypes["ProductCategoryListItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductCategoryListItemDeleteResult']?: Omit<ValueTypes["ProductCategoryListItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductCategoryListItemUpdateResult']?: Omit<ValueTypes["ProductCategoryListItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductCategoryListItemUpsertResult']?: Omit<ValueTypes["ProductCategoryListItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessCategoryLocaleCreateResult']?: Omit<ValueTypes["BusinessCategoryLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessCategoryLocaleDeleteResult']?: Omit<ValueTypes["BusinessCategoryLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessCategoryLocaleUpdateResult']?: Omit<ValueTypes["BusinessCategoryLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessCategoryLocaleUpsertResult']?: Omit<ValueTypes["BusinessCategoryLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LocaleCreateResult']?: Omit<ValueTypes["LocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LocaleDeleteResult']?: Omit<ValueTypes["LocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LocaleUpdateResult']?: Omit<ValueTypes["LocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LocaleUpsertResult']?: Omit<ValueTypes["LocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductCategoryListLocaleCreateResult']?: Omit<ValueTypes["ProductCategoryListLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductCategoryListLocaleDeleteResult']?: Omit<ValueTypes["ProductCategoryListLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductCategoryListLocaleUpdateResult']?: Omit<ValueTypes["ProductCategoryListLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductCategoryListLocaleUpsertResult']?: Omit<ValueTypes["ProductCategoryListLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerNameCreateResult']?: Omit<ValueTypes["CustomerNameCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerNameDeleteResult']?: Omit<ValueTypes["CustomerNameDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerNameUpdateResult']?: Omit<ValueTypes["CustomerNameUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerNameUpsertResult']?: Omit<ValueTypes["CustomerNameUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerAliasCreateResult']?: Omit<ValueTypes["CustomerAliasCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerAliasDeleteResult']?: Omit<ValueTypes["CustomerAliasDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerAliasUpdateResult']?: Omit<ValueTypes["CustomerAliasUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerAliasUpsertResult']?: Omit<ValueTypes["CustomerAliasUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductIngredientItemCreateResult']?: Omit<ValueTypes["ProductIngredientItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductIngredientItemDeleteResult']?: Omit<ValueTypes["ProductIngredientItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductIngredientItemUpdateResult']?: Omit<ValueTypes["ProductIngredientItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductIngredientItemUpsertResult']?: Omit<ValueTypes["ProductIngredientItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductIngredientItemQuantityCreateResult']?: Omit<ValueTypes["ProductIngredientItemQuantityCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductIngredientItemQuantityDeleteResult']?: Omit<ValueTypes["ProductIngredientItemQuantityDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductIngredientItemQuantityUpdateResult']?: Omit<ValueTypes["ProductIngredientItemQuantityUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductIngredientItemQuantityUpsertResult']?: Omit<ValueTypes["ProductIngredientItemQuantityUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductIngredientItemQuantityUnitCreateResult']?: Omit<ValueTypes["ProductIngredientItemQuantityUnitCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductIngredientItemQuantityUnitDeleteResult']?: Omit<ValueTypes["ProductIngredientItemQuantityUnitDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductIngredientItemQuantityUnitUpdateResult']?: Omit<ValueTypes["ProductIngredientItemQuantityUnitUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductIngredientItemQuantityUnitUpsertResult']?: Omit<ValueTypes["ProductIngredientItemQuantityUnitUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductIngredientCreateResult']?: Omit<ValueTypes["ProductIngredientCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductIngredientDeleteResult']?: Omit<ValueTypes["ProductIngredientDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductIngredientUpdateResult']?: Omit<ValueTypes["ProductIngredientUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductIngredientUpsertResult']?: Omit<ValueTypes["ProductIngredientUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerIngredientRatingCreateResult']?: Omit<ValueTypes["CustomerIngredientRatingCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerIngredientRatingDeleteResult']?: Omit<ValueTypes["CustomerIngredientRatingDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerIngredientRatingUpdateResult']?: Omit<ValueTypes["CustomerIngredientRatingUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerIngredientRatingUpsertResult']?: Omit<ValueTypes["CustomerIngredientRatingUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductIngredientRatingCreateResult']?: Omit<ValueTypes["ProductIngredientRatingCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductIngredientRatingDeleteResult']?: Omit<ValueTypes["ProductIngredientRatingDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductIngredientRatingUpdateResult']?: Omit<ValueTypes["ProductIngredientRatingUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductIngredientRatingUpsertResult']?: Omit<ValueTypes["ProductIngredientRatingUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductIngredientLocaleCreateResult']?: Omit<ValueTypes["ProductIngredientLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductIngredientLocaleDeleteResult']?: Omit<ValueTypes["ProductIngredientLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductIngredientLocaleUpdateResult']?: Omit<ValueTypes["ProductIngredientLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductIngredientLocaleUpsertResult']?: Omit<ValueTypes["ProductIngredientLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on OrderRecurrenceCreateResult']?: Omit<ValueTypes["OrderRecurrenceCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on OrderRecurrenceDeleteResult']?: Omit<ValueTypes["OrderRecurrenceDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on OrderRecurrenceUpdateResult']?: Omit<ValueTypes["OrderRecurrenceUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on OrderRecurrenceUpsertResult']?: Omit<ValueTypes["OrderRecurrenceUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on OrderRecurrenceLocaleCreateResult']?: Omit<ValueTypes["OrderRecurrenceLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on OrderRecurrenceLocaleDeleteResult']?: Omit<ValueTypes["OrderRecurrenceLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on OrderRecurrenceLocaleUpdateResult']?: Omit<ValueTypes["OrderRecurrenceLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on OrderRecurrenceLocaleUpsertResult']?: Omit<ValueTypes["OrderRecurrenceLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessCustomerCreateResult']?: Omit<ValueTypes["BusinessCustomerCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessCustomerDeleteResult']?: Omit<ValueTypes["BusinessCustomerDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessCustomerUpdateResult']?: Omit<ValueTypes["BusinessCustomerUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessCustomerUpsertResult']?: Omit<ValueTypes["BusinessCustomerUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PointOfSaleCreateResult']?: Omit<ValueTypes["PointOfSaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PointOfSaleDeleteResult']?: Omit<ValueTypes["PointOfSaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PointOfSaleUpdateResult']?: Omit<ValueTypes["PointOfSaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PointOfSaleUpsertResult']?: Omit<ValueTypes["PointOfSaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on StaffCreateResult']?: Omit<ValueTypes["StaffCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StaffDeleteResult']?: Omit<ValueTypes["StaffDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on StaffUpdateResult']?: Omit<ValueTypes["StaffUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StaffUpsertResult']?: Omit<ValueTypes["StaffUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogCreateResult']?: Omit<ValueTypes["BlogCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogDeleteResult']?: Omit<ValueTypes["BlogDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogUpdateResult']?: Omit<ValueTypes["BlogUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogUpsertResult']?: Omit<ValueTypes["BlogUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogLocaleCreateResult']?: Omit<ValueTypes["BlogLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogLocaleDeleteResult']?: Omit<ValueTypes["BlogLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogLocaleUpdateResult']?: Omit<ValueTypes["BlogLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogLocaleUpsertResult']?: Omit<ValueTypes["BlogLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostCreateResult']?: Omit<ValueTypes["BlogPostCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostDeleteResult']?: Omit<ValueTypes["BlogPostDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostUpdateResult']?: Omit<ValueTypes["BlogPostUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostUpsertResult']?: Omit<ValueTypes["BlogPostUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostLocaleCreateResult']?: Omit<ValueTypes["BlogPostLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostLocaleDeleteResult']?: Omit<ValueTypes["BlogPostLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostLocaleUpdateResult']?: Omit<ValueTypes["BlogPostLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostLocaleUpsertResult']?: Omit<ValueTypes["BlogPostLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ColorPalleteCreateResult']?: Omit<ValueTypes["ColorPalleteCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ColorPalleteDeleteResult']?: Omit<ValueTypes["ColorPalleteDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ColorPalleteUpdateResult']?: Omit<ValueTypes["ColorPalleteUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ColorPalleteUpsertResult']?: Omit<ValueTypes["ColorPalleteUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentCreateResult']?: Omit<ValueTypes["ContentCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentDeleteResult']?: Omit<ValueTypes["ContentDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentUpdateResult']?: Omit<ValueTypes["ContentUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentUpsertResult']?: Omit<ValueTypes["ContentUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockCreateResult']?: Omit<ValueTypes["ContentBlockCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockDeleteResult']?: Omit<ValueTypes["ContentBlockDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockUpdateResult']?: Omit<ValueTypes["ContentBlockUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockUpsertResult']?: Omit<ValueTypes["ContentBlockUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceCreateResult']?: Omit<ValueTypes["ContentReferenceCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceDeleteResult']?: Omit<ValueTypes["ContentReferenceDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceUpdateResult']?: Omit<ValueTypes["ContentReferenceUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceUpsertResult']?: Omit<ValueTypes["ContentReferenceUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostListCreateResult']?: Omit<ValueTypes["BlogPostListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostListDeleteResult']?: Omit<ValueTypes["BlogPostListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostListUpdateResult']?: Omit<ValueTypes["BlogPostListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostListUpsertResult']?: Omit<ValueTypes["BlogPostListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostListItemCreateResult']?: Omit<ValueTypes["BlogPostListItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostListItemDeleteResult']?: Omit<ValueTypes["BlogPostListItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostListItemUpdateResult']?: Omit<ValueTypes["BlogPostListItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostListItemUpsertResult']?: Omit<ValueTypes["BlogPostListItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkListCreateResult']?: Omit<ValueTypes["LinkListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkListDeleteResult']?: Omit<ValueTypes["LinkListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkListUpdateResult']?: Omit<ValueTypes["LinkListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkListUpsertResult']?: Omit<ValueTypes["LinkListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkListItemCreateResult']?: Omit<ValueTypes["LinkListItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkListItemDeleteResult']?: Omit<ValueTypes["LinkListItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkListItemUpdateResult']?: Omit<ValueTypes["LinkListItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkListItemUpsertResult']?: Omit<ValueTypes["LinkListItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on CoverCreateResult']?: Omit<ValueTypes["CoverCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CoverDeleteResult']?: Omit<ValueTypes["CoverDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on CoverUpdateResult']?: Omit<ValueTypes["CoverUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CoverUpsertResult']?: Omit<ValueTypes["CoverUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkCreateResult']?: Omit<ValueTypes["LinkCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkDeleteResult']?: Omit<ValueTypes["LinkDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkUpdateResult']?: Omit<ValueTypes["LinkUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkUpsertResult']?: Omit<ValueTypes["LinkUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableCreateResult']?: Omit<ValueTypes["LinkableCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableDeleteResult']?: Omit<ValueTypes["LinkableDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableUpdateResult']?: Omit<ValueTypes["LinkableUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableUpsertResult']?: Omit<ValueTypes["LinkableUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumCreateResult']?: Omit<ValueTypes["MediumCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumDeleteResult']?: Omit<ValueTypes["MediumDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumUpdateResult']?: Omit<ValueTypes["MediumUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumUpsertResult']?: Omit<ValueTypes["MediumUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on VideoCreateResult']?: Omit<ValueTypes["VideoCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on VideoDeleteResult']?: Omit<ValueTypes["VideoDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on VideoUpdateResult']?: Omit<ValueTypes["VideoUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on VideoUpsertResult']?: Omit<ValueTypes["VideoUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoCreateResult']?: Omit<ValueTypes["SeoCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoDeleteResult']?: Omit<ValueTypes["SeoDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoUpdateResult']?: Omit<ValueTypes["SeoUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoUpsertResult']?: Omit<ValueTypes["SeoUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProtectedImageCreateResult']?: Omit<ValueTypes["ProtectedImageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProtectedImageDeleteResult']?: Omit<ValueTypes["ProtectedImageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProtectedImageUpdateResult']?: Omit<ValueTypes["ProtectedImageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProtectedImageUpsertResult']?: Omit<ValueTypes["ProtectedImageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationDomainCreateResult']?: Omit<ValueTypes["TranslationDomainCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationDomainDeleteResult']?: Omit<ValueTypes["TranslationDomainDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationDomainUpdateResult']?: Omit<ValueTypes["TranslationDomainUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationDomainUpsertResult']?: Omit<ValueTypes["TranslationDomainUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationCatalogueCreateResult']?: Omit<ValueTypes["TranslationCatalogueCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationCatalogueDeleteResult']?: Omit<ValueTypes["TranslationCatalogueDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationCatalogueUpdateResult']?: Omit<ValueTypes["TranslationCatalogueUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationCatalogueUpsertResult']?: Omit<ValueTypes["TranslationCatalogueUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationKeyCreateResult']?: Omit<ValueTypes["TranslationKeyCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationKeyDeleteResult']?: Omit<ValueTypes["TranslationKeyDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationKeyUpdateResult']?: Omit<ValueTypes["TranslationKeyUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationKeyUpsertResult']?: Omit<ValueTypes["TranslationKeyUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationValueCreateResult']?: Omit<ValueTypes["TranslationValueCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationValueDeleteResult']?: Omit<ValueTypes["TranslationValueDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationValueUpdateResult']?: Omit<ValueTypes["TranslationValueUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationValueUpsertResult']?: Omit<ValueTypes["TranslationValueUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationCataloguesIdentifierCreateResult']?: Omit<ValueTypes["TranslationCataloguesIdentifierCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationCataloguesIdentifierDeleteResult']?: Omit<ValueTypes["TranslationCataloguesIdentifierDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationCataloguesIdentifierUpdateResult']?: Omit<ValueTypes["TranslationCataloguesIdentifierUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationCataloguesIdentifierUpsertResult']?: Omit<ValueTypes["TranslationCataloguesIdentifierUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialsAndAppsCreateResult']?: Omit<ValueTypes["SocialsAndAppsCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialsAndAppsDeleteResult']?: Omit<ValueTypes["SocialsAndAppsDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialsAndAppsUpdateResult']?: Omit<ValueTypes["SocialsAndAppsUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialsAndAppsUpsertResult']?: Omit<ValueTypes["SocialsAndAppsUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductGridCreateResult']?: Omit<ValueTypes["ProductGridCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductGridDeleteResult']?: Omit<ValueTypes["ProductGridDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductGridUpdateResult']?: Omit<ValueTypes["ProductGridUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductGridUpsertResult']?: Omit<ValueTypes["ProductGridUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductGridItemCreateResult']?: Omit<ValueTypes["ProductGridItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductGridItemDeleteResult']?: Omit<ValueTypes["ProductGridItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductGridItemUpdateResult']?: Omit<ValueTypes["ProductGridItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductGridItemUpsertResult']?: Omit<ValueTypes["ProductGridItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryCreateResult']?: Omit<ValueTypes["GalleryCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryDeleteResult']?: Omit<ValueTypes["GalleryDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryUpdateResult']?: Omit<ValueTypes["GalleryUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryUpsertResult']?: Omit<ValueTypes["GalleryUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryItemCreateResult']?: Omit<ValueTypes["GalleryItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryItemDeleteResult']?: Omit<ValueTypes["GalleryItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryItemUpdateResult']?: Omit<ValueTypes["GalleryItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryItemUpsertResult']?: Omit<ValueTypes["GalleryItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeroCreateResult']?: Omit<ValueTypes["HeroCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeroDeleteResult']?: Omit<ValueTypes["HeroDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeroUpdateResult']?: Omit<ValueTypes["HeroUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeroUpsertResult']?: Omit<ValueTypes["HeroUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SiteMenuCreateResult']?: Omit<ValueTypes["SiteMenuCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SiteMenuDeleteResult']?: Omit<ValueTypes["SiteMenuDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SiteMenuUpdateResult']?: Omit<ValueTypes["SiteMenuUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SiteMenuUpsertResult']?: Omit<ValueTypes["SiteMenuUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuLocaleCreateResult']?: Omit<ValueTypes["MenuLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuLocaleDeleteResult']?: Omit<ValueTypes["MenuLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuLocaleUpdateResult']?: Omit<ValueTypes["MenuLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuLocaleUpsertResult']?: Omit<ValueTypes["MenuLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuItemCreateResult']?: Omit<ValueTypes["MenuItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuItemDeleteResult']?: Omit<ValueTypes["MenuItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuItemUpdateResult']?: Omit<ValueTypes["MenuItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuItemUpsertResult']?: Omit<ValueTypes["MenuItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PageCreateResult']?: Omit<ValueTypes["PageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PageDeleteResult']?: Omit<ValueTypes["PageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PageUpdateResult']?: Omit<ValueTypes["PageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PageUpsertResult']?: Omit<ValueTypes["PageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PageLocaleCreateResult']?: Omit<ValueTypes["PageLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PageLocaleDeleteResult']?: Omit<ValueTypes["PageLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PageLocaleUpdateResult']?: Omit<ValueTypes["PageLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PageLocaleUpsertResult']?: Omit<ValueTypes["PageLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on WikiPageCreateResult']?: Omit<ValueTypes["WikiPageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on WikiPageDeleteResult']?: Omit<ValueTypes["WikiPageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on WikiPageUpdateResult']?: Omit<ValueTypes["WikiPageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on WikiPageUpsertResult']?: Omit<ValueTypes["WikiPageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuSubitemCreateResult']?: Omit<ValueTypes["MenuSubitemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuSubitemDeleteResult']?: Omit<ValueTypes["MenuSubitemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuSubitemUpdateResult']?: Omit<ValueTypes["MenuSubitemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuSubitemUpsertResult']?: Omit<ValueTypes["MenuSubitemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuLinkListCreateResult']?: Omit<ValueTypes["MenuLinkListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuLinkListDeleteResult']?: Omit<ValueTypes["MenuLinkListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuLinkListUpdateResult']?: Omit<ValueTypes["MenuLinkListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuLinkListUpsertResult']?: Omit<ValueTypes["MenuLinkListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuLinkItemCreateResult']?: Omit<ValueTypes["MenuLinkItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuLinkItemDeleteResult']?: Omit<ValueTypes["MenuLinkItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuLinkItemUpdateResult']?: Omit<ValueTypes["MenuLinkItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuLinkItemUpsertResult']?: Omit<ValueTypes["MenuLinkItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuProductsCreateResult']?: Omit<ValueTypes["MenuProductsCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuProductsDeleteResult']?: Omit<ValueTypes["MenuProductsDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuProductsUpdateResult']?: Omit<ValueTypes["MenuProductsUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuProductsUpsertResult']?: Omit<ValueTypes["MenuProductsUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuDeliveryCreateResult']?: Omit<ValueTypes["MenuDeliveryCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuDeliveryDeleteResult']?: Omit<ValueTypes["MenuDeliveryDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuDeliveryUpdateResult']?: Omit<ValueTypes["MenuDeliveryUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuDeliveryUpsertResult']?: Omit<ValueTypes["MenuDeliveryUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuContactCreateResult']?: Omit<ValueTypes["MenuContactCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuContactDeleteResult']?: Omit<ValueTypes["MenuContactDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuContactUpdateResult']?: Omit<ValueTypes["MenuContactUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuContactUpsertResult']?: Omit<ValueTypes["MenuContactUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeadlineTemplateCreateResult']?: Omit<ValueTypes["DeadlineTemplateCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeadlineTemplateDeleteResult']?: Omit<ValueTypes["DeadlineTemplateDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeadlineTemplateUpdateResult']?: Omit<ValueTypes["DeadlineTemplateUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeadlineTemplateUpsertResult']?: Omit<ValueTypes["DeadlineTemplateUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on EmployeeQueueCreateResult']?: Omit<ValueTypes["EmployeeQueueCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on EmployeeQueueDeleteResult']?: Omit<ValueTypes["EmployeeQueueDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on EmployeeQueueUpdateResult']?: Omit<ValueTypes["EmployeeQueueUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on EmployeeQueueUpsertResult']?: Omit<ValueTypes["EmployeeQueueUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetableDayCreateResult']?: Omit<ValueTypes["TimetableDayCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetableDayDeleteResult']?: Omit<ValueTypes["TimetableDayDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetableDayUpdateResult']?: Omit<ValueTypes["TimetableDayUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetableDayUpsertResult']?: Omit<ValueTypes["TimetableDayUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetableEmployeeRoleCreateResult']?: Omit<ValueTypes["TimetableEmployeeRoleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetableEmployeeRoleDeleteResult']?: Omit<ValueTypes["TimetableEmployeeRoleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetableEmployeeRoleUpdateResult']?: Omit<ValueTypes["TimetableEmployeeRoleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetableEmployeeRoleUpsertResult']?: Omit<ValueTypes["TimetableEmployeeRoleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetableShiftCreateResult']?: Omit<ValueTypes["TimetableShiftCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetableShiftDeleteResult']?: Omit<ValueTypes["TimetableShiftDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetableShiftUpdateResult']?: Omit<ValueTypes["TimetableShiftUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetableShiftUpsertResult']?: Omit<ValueTypes["TimetableShiftUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetableShiftGroupCreateResult']?: Omit<ValueTypes["TimetableShiftGroupCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetableShiftGroupDeleteResult']?: Omit<ValueTypes["TimetableShiftGroupDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetableShiftGroupUpdateResult']?: Omit<ValueTypes["TimetableShiftGroupUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetableShiftGroupUpsertResult']?: Omit<ValueTypes["TimetableShiftGroupUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetableShiftPositionCreateResult']?: Omit<ValueTypes["TimetableShiftPositionCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetableShiftPositionDeleteResult']?: Omit<ValueTypes["TimetableShiftPositionDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetableShiftPositionUpdateResult']?: Omit<ValueTypes["TimetableShiftPositionUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetableShiftPositionUpsertResult']?: Omit<ValueTypes["TimetableShiftPositionUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetableTemplateCreateResult']?: Omit<ValueTypes["TimetableTemplateCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetableTemplateDeleteResult']?: Omit<ValueTypes["TimetableTemplateDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetableTemplateUpdateResult']?: Omit<ValueTypes["TimetableTemplateUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetableTemplateUpsertResult']?: Omit<ValueTypes["TimetableTemplateUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on CartCreateResult']?: Omit<ValueTypes["CartCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CartDeleteResult']?: Omit<ValueTypes["CartDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on CartUpdateResult']?: Omit<ValueTypes["CartUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CartUpsertResult']?: Omit<ValueTypes["CartUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on CartItemCreateResult']?: Omit<ValueTypes["CartItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CartItemDeleteResult']?: Omit<ValueTypes["CartItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on CartItemUpdateResult']?: Omit<ValueTypes["CartItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CartItemUpsertResult']?: Omit<ValueTypes["CartItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on EmployeeQueueItemCreateResult']?: Omit<ValueTypes["EmployeeQueueItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on EmployeeQueueItemDeleteResult']?: Omit<ValueTypes["EmployeeQueueItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on EmployeeQueueItemUpdateResult']?: Omit<ValueTypes["EmployeeQueueItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on EmployeeQueueItemUpsertResult']?: Omit<ValueTypes["EmployeeQueueItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ApplicationCreateResult']?: Omit<ValueTypes["ApplicationCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ApplicationDeleteResult']?: Omit<ValueTypes["ApplicationDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ApplicationUpdateResult']?: Omit<ValueTypes["ApplicationUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ApplicationUpsertResult']?: Omit<ValueTypes["ApplicationUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ApplicationShortcutListCreateResult']?: Omit<ValueTypes["ApplicationShortcutListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ApplicationShortcutListDeleteResult']?: Omit<ValueTypes["ApplicationShortcutListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ApplicationShortcutListUpdateResult']?: Omit<ValueTypes["ApplicationShortcutListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ApplicationShortcutListUpsertResult']?: Omit<ValueTypes["ApplicationShortcutListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ApplicationShortcutListItemCreateResult']?: Omit<ValueTypes["ApplicationShortcutListItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ApplicationShortcutListItemDeleteResult']?: Omit<ValueTypes["ApplicationShortcutListItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ApplicationShortcutListItemUpdateResult']?: Omit<ValueTypes["ApplicationShortcutListItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ApplicationShortcutListItemUpsertResult']?: Omit<ValueTypes["ApplicationShortcutListItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductBannerCreateResult']?: Omit<ValueTypes["ProductBannerCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductBannerDeleteResult']?: Omit<ValueTypes["ProductBannerDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductBannerUpdateResult']?: Omit<ValueTypes["ProductBannerUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductBannerUpsertResult']?: Omit<ValueTypes["ProductBannerUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductBannerItemCreateResult']?: Omit<ValueTypes["ProductBannerItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductBannerItemDeleteResult']?: Omit<ValueTypes["ProductBannerItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductBannerItemUpdateResult']?: Omit<ValueTypes["ProductBannerItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductBannerItemUpsertResult']?: Omit<ValueTypes["ProductBannerItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductBannerListCreateResult']?: Omit<ValueTypes["ProductBannerListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductBannerListDeleteResult']?: Omit<ValueTypes["ProductBannerListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductBannerListUpdateResult']?: Omit<ValueTypes["ProductBannerListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductBannerListUpsertResult']?: Omit<ValueTypes["ProductBannerListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BartenderCreateResult']?: Omit<ValueTypes["BartenderCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BartenderDeleteResult']?: Omit<ValueTypes["BartenderDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BartenderUpdateResult']?: Omit<ValueTypes["BartenderUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BartenderUpsertResult']?: Omit<ValueTypes["BartenderUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessToBusinessManagerCreateResult']?: Omit<ValueTypes["BusinessToBusinessManagerCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessToBusinessManagerDeleteResult']?: Omit<ValueTypes["BusinessToBusinessManagerDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessToBusinessManagerUpdateResult']?: Omit<ValueTypes["BusinessToBusinessManagerUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessToBusinessManagerUpsertResult']?: Omit<ValueTypes["BusinessToBusinessManagerUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on CleanerCreateResult']?: Omit<ValueTypes["CleanerCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CleanerDeleteResult']?: Omit<ValueTypes["CleanerDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on CleanerUpdateResult']?: Omit<ValueTypes["CleanerUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CleanerUpsertResult']?: Omit<ValueTypes["CleanerUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on CourierCreateResult']?: Omit<ValueTypes["CourierCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CourierDeleteResult']?: Omit<ValueTypes["CourierDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on CourierUpdateResult']?: Omit<ValueTypes["CourierUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CourierUpsertResult']?: Omit<ValueTypes["CourierUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShiftsManagerCreateResult']?: Omit<ValueTypes["ShiftsManagerCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShiftsManagerDeleteResult']?: Omit<ValueTypes["ShiftsManagerDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShiftsManagerUpdateResult']?: Omit<ValueTypes["ShiftsManagerUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShiftsManagerUpsertResult']?: Omit<ValueTypes["ShiftsManagerUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserCreateResult']?: Omit<ValueTypes["UserCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserDeleteResult']?: Omit<ValueTypes["UserDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserUpdateResult']?: Omit<ValueTypes["UserUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserUpsertResult']?: Omit<ValueTypes["UserUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShiftsProfileCreateResult']?: Omit<ValueTypes["ShiftsProfileCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShiftsProfileDeleteResult']?: Omit<ValueTypes["ShiftsProfileDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShiftsProfileUpdateResult']?: Omit<ValueTypes["ShiftsProfileUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShiftsProfileUpsertResult']?: Omit<ValueTypes["ShiftsProfileUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductIngredientCategoryCreateResult']?: Omit<ValueTypes["ProductIngredientCategoryCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductIngredientCategoryDeleteResult']?: Omit<ValueTypes["ProductIngredientCategoryDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductIngredientCategoryUpdateResult']?: Omit<ValueTypes["ProductIngredientCategoryUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductIngredientCategoryUpsertResult']?: Omit<ValueTypes["ProductIngredientCategoryUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductIngredientCategoryLocaleCreateResult']?: Omit<ValueTypes["ProductIngredientCategoryLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductIngredientCategoryLocaleDeleteResult']?: Omit<ValueTypes["ProductIngredientCategoryLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductIngredientCategoryLocaleUpdateResult']?: Omit<ValueTypes["ProductIngredientCategoryLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductIngredientCategoryLocaleUpsertResult']?: Omit<ValueTypes["ProductIngredientCategoryLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on StocksManagerCreateResult']?: Omit<ValueTypes["StocksManagerCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StocksManagerDeleteResult']?: Omit<ValueTypes["StocksManagerDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on StocksManagerUpdateResult']?: Omit<ValueTypes["StocksManagerUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StocksManagerUpsertResult']?: Omit<ValueTypes["StocksManagerUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeliveryRouteCreateResult']?: Omit<ValueTypes["DeliveryRouteCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeliveryRouteDeleteResult']?: Omit<ValueTypes["DeliveryRouteDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeliveryRouteUpdateResult']?: Omit<ValueTypes["DeliveryRouteUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeliveryRouteUpsertResult']?: Omit<ValueTypes["DeliveryRouteUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeliveryWaypointCreateResult']?: Omit<ValueTypes["DeliveryWaypointCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeliveryWaypointDeleteResult']?: Omit<ValueTypes["DeliveryWaypointDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeliveryWaypointUpdateResult']?: Omit<ValueTypes["DeliveryWaypointUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeliveryWaypointUpsertResult']?: Omit<ValueTypes["DeliveryWaypointUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on AllergenCreateResult']?: Omit<ValueTypes["AllergenCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AllergenDeleteResult']?: Omit<ValueTypes["AllergenDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on AllergenUpdateResult']?: Omit<ValueTypes["AllergenUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AllergenUpsertResult']?: Omit<ValueTypes["AllergenUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on AllergenLocaleCreateResult']?: Omit<ValueTypes["AllergenLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AllergenLocaleDeleteResult']?: Omit<ValueTypes["AllergenLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on AllergenLocaleUpdateResult']?: Omit<ValueTypes["AllergenLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AllergenLocaleUpsertResult']?: Omit<ValueTypes["AllergenLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on GpsCreateResult']?: Omit<ValueTypes["GpsCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GpsDeleteResult']?: Omit<ValueTypes["GpsDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on GpsUpdateResult']?: Omit<ValueTypes["GpsUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GpsUpsertResult']?: Omit<ValueTypes["GpsUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on WeekHoursCreateResult']?: Omit<ValueTypes["WeekHoursCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on WeekHoursDeleteResult']?: Omit<ValueTypes["WeekHoursDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on WeekHoursUpdateResult']?: Omit<ValueTypes["WeekHoursUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on WeekHoursUpsertResult']?: Omit<ValueTypes["WeekHoursUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PreparedIngredientQuantityCreateResult']?: Omit<ValueTypes["PreparedIngredientQuantityCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PreparedIngredientQuantityDeleteResult']?: Omit<ValueTypes["PreparedIngredientQuantityDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PreparedIngredientQuantityUpdateResult']?: Omit<ValueTypes["PreparedIngredientQuantityUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PreparedIngredientQuantityUpsertResult']?: Omit<ValueTypes["PreparedIngredientQuantityUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PreparedRecipeQuantityCreateResult']?: Omit<ValueTypes["PreparedRecipeQuantityCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PreparedRecipeQuantityDeleteResult']?: Omit<ValueTypes["PreparedRecipeQuantityDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PreparedRecipeQuantityUpdateResult']?: Omit<ValueTypes["PreparedRecipeQuantityUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PreparedRecipeQuantityUpsertResult']?: Omit<ValueTypes["PreparedRecipeQuantityUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on InternalOrderCreateResult']?: Omit<ValueTypes["InternalOrderCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on InternalOrderDeleteResult']?: Omit<ValueTypes["InternalOrderDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on InternalOrderUpdateResult']?: Omit<ValueTypes["InternalOrderUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on InternalOrderUpsertResult']?: Omit<ValueTypes["InternalOrderUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on InternalOrderItemCreateResult']?: Omit<ValueTypes["InternalOrderItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on InternalOrderItemDeleteResult']?: Omit<ValueTypes["InternalOrderItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on InternalOrderItemUpdateResult']?: Omit<ValueTypes["InternalOrderItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on InternalOrderItemUpsertResult']?: Omit<ValueTypes["InternalOrderItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PreparedPackingQuantityCreateResult']?: Omit<ValueTypes["PreparedPackingQuantityCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PreparedPackingQuantityDeleteResult']?: Omit<ValueTypes["PreparedPackingQuantityDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PreparedPackingQuantityUpdateResult']?: Omit<ValueTypes["PreparedPackingQuantityUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PreparedPackingQuantityUpsertResult']?: Omit<ValueTypes["PreparedPackingQuantityUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on CourierManagerCreateResult']?: Omit<ValueTypes["CourierManagerCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CourierManagerDeleteResult']?: Omit<ValueTypes["CourierManagerDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on CourierManagerUpdateResult']?: Omit<ValueTypes["CourierManagerUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CourierManagerUpsertResult']?: Omit<ValueTypes["CourierManagerUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeliveryZoneCreateResult']?: Omit<ValueTypes["DeliveryZoneCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeliveryZoneDeleteResult']?: Omit<ValueTypes["DeliveryZoneDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeliveryZoneUpdateResult']?: Omit<ValueTypes["DeliveryZoneUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeliveryZoneUpsertResult']?: Omit<ValueTypes["DeliveryZoneUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeliveryTimelinePresetCreateResult']?: Omit<ValueTypes["DeliveryTimelinePresetCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeliveryTimelinePresetDeleteResult']?: Omit<ValueTypes["DeliveryTimelinePresetDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeliveryTimelinePresetUpdateResult']?: Omit<ValueTypes["DeliveryTimelinePresetUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeliveryTimelinePresetUpsertResult']?: Omit<ValueTypes["DeliveryTimelinePresetUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on OrderDeliveryTimelineCreateResult']?: Omit<ValueTypes["OrderDeliveryTimelineCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on OrderDeliveryTimelineDeleteResult']?: Omit<ValueTypes["OrderDeliveryTimelineDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on OrderDeliveryTimelineUpdateResult']?: Omit<ValueTypes["OrderDeliveryTimelineUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on OrderDeliveryTimelineUpsertResult']?: Omit<ValueTypes["OrderDeliveryTimelineUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on OrderEventCreateResult']?: Omit<ValueTypes["OrderEventCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on OrderEventDeleteResult']?: Omit<ValueTypes["OrderEventDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on OrderEventUpdateResult']?: Omit<ValueTypes["OrderEventUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on OrderEventUpsertResult']?: Omit<ValueTypes["OrderEventUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LiftagoRideCreateResult']?: Omit<ValueTypes["LiftagoRideCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LiftagoRideDeleteResult']?: Omit<ValueTypes["LiftagoRideDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LiftagoRideUpdateResult']?: Omit<ValueTypes["LiftagoRideUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LiftagoRideUpsertResult']?: Omit<ValueTypes["LiftagoRideUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on InvoiceCreateResult']?: Omit<ValueTypes["InvoiceCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on InvoiceDeleteResult']?: Omit<ValueTypes["InvoiceDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on InvoiceUpdateResult']?: Omit<ValueTypes["InvoiceUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on InvoiceUpsertResult']?: Omit<ValueTypes["InvoiceUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on InvoicingPlanCreateResult']?: Omit<ValueTypes["InvoicingPlanCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on InvoicingPlanDeleteResult']?: Omit<ValueTypes["InvoicingPlanDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on InvoicingPlanUpdateResult']?: Omit<ValueTypes["InvoicingPlanUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on InvoicingPlanUpsertResult']?: Omit<ValueTypes["InvoicingPlanUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductPackingLocaleCreateResult']?: Omit<ValueTypes["ProductPackingLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductPackingLocaleDeleteResult']?: Omit<ValueTypes["ProductPackingLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductPackingLocaleUpdateResult']?: Omit<ValueTypes["ProductPackingLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductPackingLocaleUpsertResult']?: Omit<ValueTypes["ProductPackingLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductLocaleCreateResult']?: Omit<ValueTypes["ProductLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductLocaleDeleteResult']?: Omit<ValueTypes["ProductLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductLocaleUpdateResult']?: Omit<ValueTypes["ProductLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductLocaleUpsertResult']?: Omit<ValueTypes["ProductLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductRecipeLocaleCreateResult']?: Omit<ValueTypes["ProductRecipeLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductRecipeLocaleDeleteResult']?: Omit<ValueTypes["ProductRecipeLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductRecipeLocaleUpdateResult']?: Omit<ValueTypes["ProductRecipeLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductRecipeLocaleUpsertResult']?: Omit<ValueTypes["ProductRecipeLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserDeviceCreateResult']?: Omit<ValueTypes["UserDeviceCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserDeviceDeleteResult']?: Omit<ValueTypes["UserDeviceDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserDeviceUpdateResult']?: Omit<ValueTypes["UserDeviceUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserDeviceUpsertResult']?: Omit<ValueTypes["UserDeviceUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProtectedActionCreateResult']?: Omit<ValueTypes["ProtectedActionCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProtectedActionDeleteResult']?: Omit<ValueTypes["ProtectedActionDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProtectedActionUpdateResult']?: Omit<ValueTypes["ProtectedActionUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProtectedActionUpsertResult']?: Omit<ValueTypes["ProtectedActionUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PickerCreateResult']?: Omit<ValueTypes["PickerCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PickerDeleteResult']?: Omit<ValueTypes["PickerDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PickerUpdateResult']?: Omit<ValueTypes["PickerUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PickerUpsertResult']?: Omit<ValueTypes["PickerUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetableTemplateStaffOptionsCreateResult']?: Omit<ValueTypes["TimetableTemplateStaffOptionsCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetableTemplateStaffOptionsDeleteResult']?: Omit<ValueTypes["TimetableTemplateStaffOptionsDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetableTemplateStaffOptionsUpdateResult']?: Omit<ValueTypes["TimetableTemplateStaffOptionsUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetableTemplateStaffOptionsUpsertResult']?: Omit<ValueTypes["TimetableTemplateStaffOptionsUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShoppingListCreateResult']?: Omit<ValueTypes["ShoppingListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShoppingListDeleteResult']?: Omit<ValueTypes["ShoppingListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShoppingListUpdateResult']?: Omit<ValueTypes["ShoppingListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShoppingListUpsertResult']?: Omit<ValueTypes["ShoppingListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SuppliesPurchaseCreateResult']?: Omit<ValueTypes["SuppliesPurchaseCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SuppliesPurchaseDeleteResult']?: Omit<ValueTypes["SuppliesPurchaseDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SuppliesPurchaseUpdateResult']?: Omit<ValueTypes["SuppliesPurchaseUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SuppliesPurchaseUpsertResult']?: Omit<ValueTypes["SuppliesPurchaseUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on InvoicingPresetCreateResult']?: Omit<ValueTypes["InvoicingPresetCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on InvoicingPresetDeleteResult']?: Omit<ValueTypes["InvoicingPresetDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on InvoicingPresetUpdateResult']?: Omit<ValueTypes["InvoicingPresetUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on InvoicingPresetUpsertResult']?: Omit<ValueTypes["InvoicingPresetUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LogRecordCreateResult']?: Omit<ValueTypes["LogRecordCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LogRecordDeleteResult']?: Omit<ValueTypes["LogRecordDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LogRecordUpdateResult']?: Omit<ValueTypes["LogRecordUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LogRecordUpsertResult']?: Omit<ValueTypes["LogRecordUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BillingSubjectCreateResult']?: Omit<ValueTypes["BillingSubjectCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BillingSubjectDeleteResult']?: Omit<ValueTypes["BillingSubjectDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BillingSubjectUpdateResult']?: Omit<ValueTypes["BillingSubjectUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BillingSubjectUpsertResult']?: Omit<ValueTypes["BillingSubjectUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShoppingListItemCreateResult']?: Omit<ValueTypes["ShoppingListItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShoppingListItemDeleteResult']?: Omit<ValueTypes["ShoppingListItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShoppingListItemUpdateResult']?: Omit<ValueTypes["ShoppingListItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShoppingListItemUpsertResult']?: Omit<ValueTypes["ShoppingListItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SuppliesPurchaseItemCreateResult']?: Omit<ValueTypes["SuppliesPurchaseItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SuppliesPurchaseItemDeleteResult']?: Omit<ValueTypes["SuppliesPurchaseItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SuppliesPurchaseItemUpdateResult']?: Omit<ValueTypes["SuppliesPurchaseItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SuppliesPurchaseItemUpsertResult']?: Omit<ValueTypes["SuppliesPurchaseItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerCreditTransactionCreateResult']?: Omit<ValueTypes["CustomerCreditTransactionCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerCreditTransactionDeleteResult']?: Omit<ValueTypes["CustomerCreditTransactionDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerCreditTransactionUpdateResult']?: Omit<ValueTypes["CustomerCreditTransactionUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerCreditTransactionUpsertResult']?: Omit<ValueTypes["CustomerCreditTransactionUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on VirtualProductCreateResult']?: Omit<ValueTypes["VirtualProductCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on VirtualProductDeleteResult']?: Omit<ValueTypes["VirtualProductDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on VirtualProductUpdateResult']?: Omit<ValueTypes["VirtualProductUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on VirtualProductUpsertResult']?: Omit<ValueTypes["VirtualProductUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on VirtualProductEffectCreateResult']?: Omit<ValueTypes["VirtualProductEffectCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on VirtualProductEffectDeleteResult']?: Omit<ValueTypes["VirtualProductEffectDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on VirtualProductEffectUpdateResult']?: Omit<ValueTypes["VirtualProductEffectUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on VirtualProductEffectUpsertResult']?: Omit<ValueTypes["VirtualProductEffectUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on EmploymentInformationCreateResult']?: Omit<ValueTypes["EmploymentInformationCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on EmploymentInformationDeleteResult']?: Omit<ValueTypes["EmploymentInformationDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on EmploymentInformationUpdateResult']?: Omit<ValueTypes["EmploymentInformationUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on EmploymentInformationUpsertResult']?: Omit<ValueTypes["EmploymentInformationUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on RemunerationProfileCreateResult']?: Omit<ValueTypes["RemunerationProfileCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RemunerationProfileDeleteResult']?: Omit<ValueTypes["RemunerationProfileDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on RemunerationProfileUpdateResult']?: Omit<ValueTypes["RemunerationProfileUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RemunerationProfileUpsertResult']?: Omit<ValueTypes["RemunerationProfileUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on WorkMonthCreateResult']?: Omit<ValueTypes["WorkMonthCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on WorkMonthDeleteResult']?: Omit<ValueTypes["WorkMonthDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on WorkMonthUpdateResult']?: Omit<ValueTypes["WorkMonthUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on WorkMonthUpsertResult']?: Omit<ValueTypes["WorkMonthUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SalaryOptionsCreateResult']?: Omit<ValueTypes["SalaryOptionsCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SalaryOptionsDeleteResult']?: Omit<ValueTypes["SalaryOptionsDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SalaryOptionsUpdateResult']?: Omit<ValueTypes["SalaryOptionsUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SalaryOptionsUpsertResult']?: Omit<ValueTypes["SalaryOptionsUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetableShiftSwapInfoCreateResult']?: Omit<ValueTypes["TimetableShiftSwapInfoCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetableShiftSwapInfoDeleteResult']?: Omit<ValueTypes["TimetableShiftSwapInfoDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetableShiftSwapInfoUpdateResult']?: Omit<ValueTypes["TimetableShiftSwapInfoUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetableShiftSwapInfoUpsertResult']?: Omit<ValueTypes["TimetableShiftSwapInfoUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductGridCategoryCreateResult']?: Omit<ValueTypes["ProductGridCategoryCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductGridCategoryDeleteResult']?: Omit<ValueTypes["ProductGridCategoryDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductGridCategoryUpdateResult']?: Omit<ValueTypes["ProductGridCategoryUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductGridCategoryUpsertResult']?: Omit<ValueTypes["ProductGridCategoryUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on CashierCreateResult']?: Omit<ValueTypes["CashierCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CashierDeleteResult']?: Omit<ValueTypes["CashierDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on CashierUpdateResult']?: Omit<ValueTypes["CashierUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CashierUpsertResult']?: Omit<ValueTypes["CashierUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PointOfSaleCategoryCreateResult']?: Omit<ValueTypes["PointOfSaleCategoryCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PointOfSaleCategoryDeleteResult']?: Omit<ValueTypes["PointOfSaleCategoryDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PointOfSaleCategoryUpdateResult']?: Omit<ValueTypes["PointOfSaleCategoryUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PointOfSaleCategoryUpsertResult']?: Omit<ValueTypes["PointOfSaleCategoryUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PointOfSaleCategoryLocaleCreateResult']?: Omit<ValueTypes["PointOfSaleCategoryLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PointOfSaleCategoryLocaleDeleteResult']?: Omit<ValueTypes["PointOfSaleCategoryLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PointOfSaleCategoryLocaleUpdateResult']?: Omit<ValueTypes["PointOfSaleCategoryLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PointOfSaleCategoryLocaleUpsertResult']?: Omit<ValueTypes["PointOfSaleCategoryLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PointOfSaleCategoryProductCreateResult']?: Omit<ValueTypes["PointOfSaleCategoryProductCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PointOfSaleCategoryProductDeleteResult']?: Omit<ValueTypes["PointOfSaleCategoryProductDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PointOfSaleCategoryProductUpdateResult']?: Omit<ValueTypes["PointOfSaleCategoryProductUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PointOfSaleCategoryProductUpsertResult']?: Omit<ValueTypes["PointOfSaleCategoryProductUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PointOfSaleCategoryProductLocaleCreateResult']?: Omit<ValueTypes["PointOfSaleCategoryProductLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PointOfSaleCategoryProductLocaleDeleteResult']?: Omit<ValueTypes["PointOfSaleCategoryProductLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PointOfSaleCategoryProductLocaleUpdateResult']?: Omit<ValueTypes["PointOfSaleCategoryProductLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PointOfSaleCategoryProductLocaleUpsertResult']?: Omit<ValueTypes["PointOfSaleCategoryProductLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerTabCreateResult']?: Omit<ValueTypes["CustomerTabCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerTabDeleteResult']?: Omit<ValueTypes["CustomerTabDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerTabUpdateResult']?: Omit<ValueTypes["CustomerTabUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerTabUpsertResult']?: Omit<ValueTypes["CustomerTabUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerTabItemCreateResult']?: Omit<ValueTypes["CustomerTabItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerTabItemDeleteResult']?: Omit<ValueTypes["CustomerTabItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerTabItemUpdateResult']?: Omit<ValueTypes["CustomerTabItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CustomerTabItemUpsertResult']?: Omit<ValueTypes["CustomerTabItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on AnonymousSessionCreateResult']?: Omit<ValueTypes["AnonymousSessionCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AnonymousSessionDeleteResult']?: Omit<ValueTypes["AnonymousSessionDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on AnonymousSessionUpdateResult']?: Omit<ValueTypes["AnonymousSessionUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AnonymousSessionUpsertResult']?: Omit<ValueTypes["AnonymousSessionUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on VoucherCreateResult']?: Omit<ValueTypes["VoucherCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on VoucherDeleteResult']?: Omit<ValueTypes["VoucherDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on VoucherUpdateResult']?: Omit<ValueTypes["VoucherUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on VoucherUpsertResult']?: Omit<ValueTypes["VoucherUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on VoucherRedemptionCreateResult']?: Omit<ValueTypes["VoucherRedemptionCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on VoucherRedemptionDeleteResult']?: Omit<ValueTypes["VoucherRedemptionDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on VoucherRedemptionUpdateResult']?: Omit<ValueTypes["VoucherRedemptionUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on VoucherRedemptionUpsertResult']?: Omit<ValueTypes["VoucherRedemptionUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on UnassignedShiftInfoCreateResult']?: Omit<ValueTypes["UnassignedShiftInfoCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on UnassignedShiftInfoDeleteResult']?: Omit<ValueTypes["UnassignedShiftInfoDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on UnassignedShiftInfoUpdateResult']?: Omit<ValueTypes["UnassignedShiftInfoUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on UnassignedShiftInfoUpsertResult']?: Omit<ValueTypes["UnassignedShiftInfoUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FreshingContainerCreateResult']?: Omit<ValueTypes["FreshingContainerCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FreshingContainerDeleteResult']?: Omit<ValueTypes["FreshingContainerDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FreshingContainerUpdateResult']?: Omit<ValueTypes["FreshingContainerUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FreshingContainerUpsertResult']?: Omit<ValueTypes["FreshingContainerUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextItemCreateResult']?: Omit<ValueTypes["TextItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextItemDeleteResult']?: Omit<ValueTypes["TextItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextItemUpdateResult']?: Omit<ValueTypes["TextItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextItemUpsertResult']?: Omit<ValueTypes["TextItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextListCreateResult']?: Omit<ValueTypes["TextListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextListDeleteResult']?: Omit<ValueTypes["TextListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextListUpdateResult']?: Omit<ValueTypes["TextListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextListUpsertResult']?: Omit<ValueTypes["TextListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeliveryRegionsCreateResult']?: Omit<ValueTypes["DeliveryRegionsCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeliveryRegionsDeleteResult']?: Omit<ValueTypes["DeliveryRegionsDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeliveryRegionsUpdateResult']?: Omit<ValueTypes["DeliveryRegionsUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeliveryRegionsUpsertResult']?: Omit<ValueTypes["DeliveryRegionsUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeliveryRegionsItemCreateResult']?: Omit<ValueTypes["DeliveryRegionsItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeliveryRegionsItemDeleteResult']?: Omit<ValueTypes["DeliveryRegionsItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeliveryRegionsItemUpdateResult']?: Omit<ValueTypes["DeliveryRegionsItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeliveryRegionsItemUpsertResult']?: Omit<ValueTypes["DeliveryRegionsItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageListCreateResult']?: Omit<ValueTypes["ImageListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageListDeleteResult']?: Omit<ValueTypes["ImageListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageListUpdateResult']?: Omit<ValueTypes["ImageListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageListUpsertResult']?: Omit<ValueTypes["ImageListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageListItemCreateResult']?: Omit<ValueTypes["ImageListItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageListItemDeleteResult']?: Omit<ValueTypes["ImageListItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageListItemUpdateResult']?: Omit<ValueTypes["ImageListItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageListItemUpsertResult']?: Omit<ValueTypes["ImageListItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetablesEmployeePrivilegesCreateResult']?: Omit<ValueTypes["TimetablesEmployeePrivilegesCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetablesEmployeePrivilegesDeleteResult']?: Omit<ValueTypes["TimetablesEmployeePrivilegesDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetablesEmployeePrivilegesUpdateResult']?: Omit<ValueTypes["TimetablesEmployeePrivilegesUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetablesEmployeePrivilegesUpsertResult']?: Omit<ValueTypes["TimetablesEmployeePrivilegesUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetableDayNoteCreateResult']?: Omit<ValueTypes["TimetableDayNoteCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetableDayNoteDeleteResult']?: Omit<ValueTypes["TimetableDayNoteDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetableDayNoteUpdateResult']?: Omit<ValueTypes["TimetableDayNoteUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimetableDayNoteUpsertResult']?: Omit<ValueTypes["TimetableDayNoteUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeliveryMethodLocaleCreateResult']?: Omit<ValueTypes["DeliveryMethodLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeliveryMethodLocaleDeleteResult']?: Omit<ValueTypes["DeliveryMethodLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeliveryMethodLocaleUpdateResult']?: Omit<ValueTypes["DeliveryMethodLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeliveryMethodLocaleUpsertResult']?: Omit<ValueTypes["DeliveryMethodLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on IngredientSupplierCreateResult']?: Omit<ValueTypes["IngredientSupplierCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on IngredientSupplierDeleteResult']?: Omit<ValueTypes["IngredientSupplierDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on IngredientSupplierUpdateResult']?: Omit<ValueTypes["IngredientSupplierUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on IngredientSupplierUpsertResult']?: Omit<ValueTypes["IngredientSupplierUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on IngredientSupplierItemCreateResult']?: Omit<ValueTypes["IngredientSupplierItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on IngredientSupplierItemDeleteResult']?: Omit<ValueTypes["IngredientSupplierItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on IngredientSupplierItemUpdateResult']?: Omit<ValueTypes["IngredientSupplierItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on IngredientSupplierItemUpsertResult']?: Omit<ValueTypes["IngredientSupplierItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on IngredientSupplierListCreateResult']?: Omit<ValueTypes["IngredientSupplierListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on IngredientSupplierListDeleteResult']?: Omit<ValueTypes["IngredientSupplierListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on IngredientSupplierListUpdateResult']?: Omit<ValueTypes["IngredientSupplierListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on IngredientSupplierListUpsertResult']?: Omit<ValueTypes["IngredientSupplierListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on IngredientSupplierLocaleCreateResult']?: Omit<ValueTypes["IngredientSupplierLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on IngredientSupplierLocaleDeleteResult']?: Omit<ValueTypes["IngredientSupplierLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on IngredientSupplierLocaleUpdateResult']?: Omit<ValueTypes["IngredientSupplierLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on IngredientSupplierLocaleUpsertResult']?: Omit<ValueTypes["IngredientSupplierLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on RedirectCreateResult']?: Omit<ValueTypes["RedirectCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RedirectDeleteResult']?: Omit<ValueTypes["RedirectDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on RedirectUpdateResult']?: Omit<ValueTypes["RedirectUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RedirectUpsertResult']?: Omit<ValueTypes["RedirectUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on NutritionFactsCreateResult']?: Omit<ValueTypes["NutritionFactsCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on NutritionFactsDeleteResult']?: Omit<ValueTypes["NutritionFactsDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on NutritionFactsUpdateResult']?: Omit<ValueTypes["NutritionFactsUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on NutritionFactsUpsertResult']?: Omit<ValueTypes["NutritionFactsUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on VenueCreateResult']?: Omit<ValueTypes["VenueCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on VenueDeleteResult']?: Omit<ValueTypes["VenueDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on VenueUpdateResult']?: Omit<ValueTypes["VenueUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on VenueUpsertResult']?: Omit<ValueTypes["VenueUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on WorkspaceCreateResult']?: Omit<ValueTypes["WorkspaceCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on WorkspaceDeleteResult']?: Omit<ValueTypes["WorkspaceDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on WorkspaceUpdateResult']?: Omit<ValueTypes["WorkspaceUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on WorkspaceUpsertResult']?: Omit<ValueTypes["WorkspaceUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on InternalBuyerCreateResult']?: Omit<ValueTypes["InternalBuyerCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on InternalBuyerDeleteResult']?: Omit<ValueTypes["InternalBuyerDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on InternalBuyerUpdateResult']?: Omit<ValueTypes["InternalBuyerUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on InternalBuyerUpsertResult']?: Omit<ValueTypes["InternalBuyerUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on VenueEmployeeRoleCreateResult']?: Omit<ValueTypes["VenueEmployeeRoleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on VenueEmployeeRoleDeleteResult']?: Omit<ValueTypes["VenueEmployeeRoleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on VenueEmployeeRoleUpdateResult']?: Omit<ValueTypes["VenueEmployeeRoleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on VenueEmployeeRoleUpsertResult']?: Omit<ValueTypes["VenueEmployeeRoleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on IdentificationAttemptCreateResult']?: Omit<ValueTypes["IdentificationAttemptCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on IdentificationAttemptDeleteResult']?: Omit<ValueTypes["IdentificationAttemptDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on IdentificationAttemptUpdateResult']?: Omit<ValueTypes["IdentificationAttemptUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on IdentificationAttemptUpsertResult']?: Omit<ValueTypes["IdentificationAttemptUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on IdentificationCodeCreateResult']?: Omit<ValueTypes["IdentificationCodeCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on IdentificationCodeDeleteResult']?: Omit<ValueTypes["IdentificationCodeDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on IdentificationCodeUpdateResult']?: Omit<ValueTypes["IdentificationCodeUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on IdentificationCodeUpsertResult']?: Omit<ValueTypes["IdentificationCodeUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on IdentificationCodeLocaleCreateResult']?: Omit<ValueTypes["IdentificationCodeLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on IdentificationCodeLocaleDeleteResult']?: Omit<ValueTypes["IdentificationCodeLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on IdentificationCodeLocaleUpdateResult']?: Omit<ValueTypes["IdentificationCodeLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on IdentificationCodeLocaleUpsertResult']?: Omit<ValueTypes["IdentificationCodeLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PipelineCreateResult']?: Omit<ValueTypes["PipelineCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PipelineDeleteResult']?: Omit<ValueTypes["PipelineDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PipelineUpdateResult']?: Omit<ValueTypes["PipelineUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PipelineUpsertResult']?: Omit<ValueTypes["PipelineUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PipelineLeadCreateResult']?: Omit<ValueTypes["PipelineLeadCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PipelineLeadDeleteResult']?: Omit<ValueTypes["PipelineLeadDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PipelineLeadUpdateResult']?: Omit<ValueTypes["PipelineLeadUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PipelineLeadUpsertResult']?: Omit<ValueTypes["PipelineLeadUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PipelineStageCreateResult']?: Omit<ValueTypes["PipelineStageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PipelineStageDeleteResult']?: Omit<ValueTypes["PipelineStageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PipelineStageUpdateResult']?: Omit<ValueTypes["PipelineStageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PipelineStageUpsertResult']?: Omit<ValueTypes["PipelineStageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PipelineStageItemCreateResult']?: Omit<ValueTypes["PipelineStageItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PipelineStageItemDeleteResult']?: Omit<ValueTypes["PipelineStageItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PipelineStageItemUpdateResult']?: Omit<ValueTypes["PipelineStageItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PipelineStageItemUpsertResult']?: Omit<ValueTypes["PipelineStageItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PipelineStageLocaleCreateResult']?: Omit<ValueTypes["PipelineStageLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PipelineStageLocaleDeleteResult']?: Omit<ValueTypes["PipelineStageLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PipelineStageLocaleUpdateResult']?: Omit<ValueTypes["PipelineStageLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PipelineStageLocaleUpsertResult']?: Omit<ValueTypes["PipelineStageLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SalesManagerCreateResult']?: Omit<ValueTypes["SalesManagerCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SalesManagerDeleteResult']?: Omit<ValueTypes["SalesManagerDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SalesManagerUpdateResult']?: Omit<ValueTypes["SalesManagerUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SalesManagerUpsertResult']?: Omit<ValueTypes["SalesManagerUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on CashierManagerCreateResult']?: Omit<ValueTypes["CashierManagerCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CashierManagerDeleteResult']?: Omit<ValueTypes["CashierManagerDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on CashierManagerUpdateResult']?: Omit<ValueTypes["CashierManagerUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CashierManagerUpsertResult']?: Omit<ValueTypes["CashierManagerUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PointOfSaleApplicationDeviceCreateResult']?: Omit<ValueTypes["PointOfSaleApplicationDeviceCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PointOfSaleApplicationDeviceDeleteResult']?: Omit<ValueTypes["PointOfSaleApplicationDeviceDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PointOfSaleApplicationDeviceUpdateResult']?: Omit<ValueTypes["PointOfSaleApplicationDeviceUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PointOfSaleApplicationDeviceUpsertResult']?: Omit<ValueTypes["PointOfSaleApplicationDeviceUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PointOfSaleTerminalCreateResult']?: Omit<ValueTypes["PointOfSaleTerminalCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PointOfSaleTerminalDeleteResult']?: Omit<ValueTypes["PointOfSaleTerminalDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PointOfSaleTerminalUpdateResult']?: Omit<ValueTypes["PointOfSaleTerminalUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PointOfSaleTerminalUpsertResult']?: Omit<ValueTypes["PointOfSaleTerminalUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PipelineStageSentimentCreateResult']?: Omit<ValueTypes["PipelineStageSentimentCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PipelineStageSentimentDeleteResult']?: Omit<ValueTypes["PipelineStageSentimentDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PipelineStageSentimentUpdateResult']?: Omit<ValueTypes["PipelineStageSentimentUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PipelineStageSentimentUpsertResult']?: Omit<ValueTypes["PipelineStageSentimentUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeviceIdentifierCreateResult']?: Omit<ValueTypes["DeviceIdentifierCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeviceIdentifierDeleteResult']?: Omit<ValueTypes["DeviceIdentifierDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeviceIdentifierUpdateResult']?: Omit<ValueTypes["DeviceIdentifierUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DeviceIdentifierUpsertResult']?: Omit<ValueTypes["DeviceIdentifierUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PointOfSalePrinterCreateResult']?: Omit<ValueTypes["PointOfSalePrinterCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PointOfSalePrinterDeleteResult']?: Omit<ValueTypes["PointOfSalePrinterDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PointOfSalePrinterUpdateResult']?: Omit<ValueTypes["PointOfSalePrinterUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PointOfSalePrinterUpsertResult']?: Omit<ValueTypes["PointOfSalePrinterUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on GratuityCreateResult']?: Omit<ValueTypes["GratuityCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GratuityDeleteResult']?: Omit<ValueTypes["GratuityDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on GratuityUpdateResult']?: Omit<ValueTypes["GratuityUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GratuityUpsertResult']?: Omit<ValueTypes["GratuityUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FulfillmentNoteCreateResult']?: Omit<ValueTypes["FulfillmentNoteCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FulfillmentNoteDeleteResult']?: Omit<ValueTypes["FulfillmentNoteDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FulfillmentNoteUpdateResult']?: Omit<ValueTypes["FulfillmentNoteUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FulfillmentNoteUpsertResult']?: Omit<ValueTypes["FulfillmentNoteUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LeadFormCreateResult']?: Omit<ValueTypes["LeadFormCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LeadFormDeleteResult']?: Omit<ValueTypes["LeadFormDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LeadFormUpdateResult']?: Omit<ValueTypes["LeadFormUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LeadFormUpsertResult']?: Omit<ValueTypes["LeadFormUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SubscriptionBoxCreateResult']?: Omit<ValueTypes["SubscriptionBoxCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SubscriptionBoxDeleteResult']?: Omit<ValueTypes["SubscriptionBoxDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SubscriptionBoxUpdateResult']?: Omit<ValueTypes["SubscriptionBoxUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SubscriptionBoxUpsertResult']?: Omit<ValueTypes["SubscriptionBoxUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SubscriptionBoxLocaleCreateResult']?: Omit<ValueTypes["SubscriptionBoxLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SubscriptionBoxLocaleDeleteResult']?: Omit<ValueTypes["SubscriptionBoxLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SubscriptionBoxLocaleUpdateResult']?: Omit<ValueTypes["SubscriptionBoxLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SubscriptionBoxLocaleUpsertResult']?: Omit<ValueTypes["SubscriptionBoxLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessServiceCreateResult']?: Omit<ValueTypes["BusinessServiceCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessServiceDeleteResult']?: Omit<ValueTypes["BusinessServiceDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessServiceUpdateResult']?: Omit<ValueTypes["BusinessServiceUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessServiceUpsertResult']?: Omit<ValueTypes["BusinessServiceUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessServiceEventCreateResult']?: Omit<ValueTypes["BusinessServiceEventCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessServiceEventDeleteResult']?: Omit<ValueTypes["BusinessServiceEventDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessServiceEventUpdateResult']?: Omit<ValueTypes["BusinessServiceEventUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessServiceEventUpsertResult']?: Omit<ValueTypes["BusinessServiceEventUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessServiceLocaleCreateResult']?: Omit<ValueTypes["BusinessServiceLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessServiceLocaleDeleteResult']?: Omit<ValueTypes["BusinessServiceLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessServiceLocaleUpdateResult']?: Omit<ValueTypes["BusinessServiceLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessServiceLocaleUpsertResult']?: Omit<ValueTypes["BusinessServiceLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on GridTileItemCreateResult']?: Omit<ValueTypes["GridTileItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GridTileItemDeleteResult']?: Omit<ValueTypes["GridTileItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on GridTileItemUpdateResult']?: Omit<ValueTypes["GridTileItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GridTileItemUpsertResult']?: Omit<ValueTypes["GridTileItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on GridTilesCreateResult']?: Omit<ValueTypes["GridTilesCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GridTilesDeleteResult']?: Omit<ValueTypes["GridTilesDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on GridTilesUpdateResult']?: Omit<ValueTypes["GridTilesUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GridTilesUpsertResult']?: Omit<ValueTypes["GridTilesUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on AreaCreateResult']?: Omit<ValueTypes["AreaCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AreaDeleteResult']?: Omit<ValueTypes["AreaDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on AreaUpdateResult']?: Omit<ValueTypes["AreaUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AreaUpsertResult']?: Omit<ValueTypes["AreaUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PositionCreateResult']?: Omit<ValueTypes["PositionCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PositionDeleteResult']?: Omit<ValueTypes["PositionDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PositionUpdateResult']?: Omit<ValueTypes["PositionUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PositionUpsertResult']?: Omit<ValueTypes["PositionUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on StatsEnabledWidgetTypeCreateResult']?: Omit<ValueTypes["StatsEnabledWidgetTypeCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StatsEnabledWidgetTypeDeleteResult']?: Omit<ValueTypes["StatsEnabledWidgetTypeDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on StatsEnabledWidgetTypeUpdateResult']?: Omit<ValueTypes["StatsEnabledWidgetTypeUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StatsEnabledWidgetTypeUpsertResult']?: Omit<ValueTypes["StatsEnabledWidgetTypeUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on StatsWidgetCreateResult']?: Omit<ValueTypes["StatsWidgetCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StatsWidgetDeleteResult']?: Omit<ValueTypes["StatsWidgetDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on StatsWidgetUpdateResult']?: Omit<ValueTypes["StatsWidgetUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StatsWidgetUpsertResult']?: Omit<ValueTypes["StatsWidgetUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on StatsWidgetsLayoutCreateResult']?: Omit<ValueTypes["StatsWidgetsLayoutCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StatsWidgetsLayoutDeleteResult']?: Omit<ValueTypes["StatsWidgetsLayoutDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on StatsWidgetsLayoutUpdateResult']?: Omit<ValueTypes["StatsWidgetsLayoutUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StatsWidgetsLayoutUpsertResult']?: Omit<ValueTypes["StatsWidgetsLayoutUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeatCreateResult']?: Omit<ValueTypes["SeatCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeatDeleteResult']?: Omit<ValueTypes["SeatDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeatUpdateResult']?: Omit<ValueTypes["SeatUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeatUpsertResult']?: Omit<ValueTypes["SeatUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TableCreateResult']?: Omit<ValueTypes["TableCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TableDeleteResult']?: Omit<ValueTypes["TableDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TableUpdateResult']?: Omit<ValueTypes["TableUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TableUpsertResult']?: Omit<ValueTypes["TableUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on StatsPageCreateResult']?: Omit<ValueTypes["StatsPageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StatsPageDeleteResult']?: Omit<ValueTypes["StatsPageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on StatsPageUpdateResult']?: Omit<ValueTypes["StatsPageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StatsPageUpsertResult']?: Omit<ValueTypes["StatsPageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on UnassignReasonCreateResult']?: Omit<ValueTypes["UnassignReasonCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on UnassignReasonDeleteResult']?: Omit<ValueTypes["UnassignReasonDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on UnassignReasonUpdateResult']?: Omit<ValueTypes["UnassignReasonUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on UnassignReasonUpsertResult']?: Omit<ValueTypes["UnassignReasonUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on DoubleshotCoffeeEquipmentCreateResult']?: Omit<ValueTypes["DoubleshotCoffeeEquipmentCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DoubleshotCoffeeEquipmentDeleteResult']?: Omit<ValueTypes["DoubleshotCoffeeEquipmentDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on DoubleshotCoffeeEquipmentUpdateResult']?: Omit<ValueTypes["DoubleshotCoffeeEquipmentUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DoubleshotCoffeeEquipmentUpsertResult']?: Omit<ValueTypes["DoubleshotCoffeeEquipmentUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ExpenseCreateResult']?: Omit<ValueTypes["ExpenseCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ExpenseDeleteResult']?: Omit<ValueTypes["ExpenseDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ExpenseUpdateResult']?: Omit<ValueTypes["ExpenseUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ExpenseUpsertResult']?: Omit<ValueTypes["ExpenseUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ExpenseCategoryCreateResult']?: Omit<ValueTypes["ExpenseCategoryCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ExpenseCategoryDeleteResult']?: Omit<ValueTypes["ExpenseCategoryDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ExpenseCategoryUpdateResult']?: Omit<ValueTypes["ExpenseCategoryUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ExpenseCategoryUpsertResult']?: Omit<ValueTypes["ExpenseCategoryUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ExpenseChangeCreateResult']?: Omit<ValueTypes["ExpenseChangeCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ExpenseChangeDeleteResult']?: Omit<ValueTypes["ExpenseChangeDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ExpenseChangeUpdateResult']?: Omit<ValueTypes["ExpenseChangeUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ExpenseChangeUpsertResult']?: Omit<ValueTypes["ExpenseChangeUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ExpenseDocumentCreateResult']?: Omit<ValueTypes["ExpenseDocumentCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ExpenseDocumentDeleteResult']?: Omit<ValueTypes["ExpenseDocumentDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ExpenseDocumentUpdateResult']?: Omit<ValueTypes["ExpenseDocumentUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ExpenseDocumentUpsertResult']?: Omit<ValueTypes["ExpenseDocumentUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on RevenuePredictionCreateResult']?: Omit<ValueTypes["RevenuePredictionCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RevenuePredictionDeleteResult']?: Omit<ValueTypes["RevenuePredictionDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on RevenuePredictionUpdateResult']?: Omit<ValueTypes["RevenuePredictionUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RevenuePredictionUpsertResult']?: Omit<ValueTypes["RevenuePredictionUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on RevenuePredictionChangeCreateResult']?: Omit<ValueTypes["RevenuePredictionChangeCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RevenuePredictionChangeDeleteResult']?: Omit<ValueTypes["RevenuePredictionChangeDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on RevenuePredictionChangeUpdateResult']?: Omit<ValueTypes["RevenuePredictionChangeUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RevenuePredictionChangeUpsertResult']?: Omit<ValueTypes["RevenuePredictionChangeUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FileCreateResult']?: Omit<ValueTypes["FileCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FileDeleteResult']?: Omit<ValueTypes["FileDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FileUpdateResult']?: Omit<ValueTypes["FileUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FileUpsertResult']?: Omit<ValueTypes["FileUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LineCreateResult']?: Omit<ValueTypes["LineCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LineDeleteResult']?: Omit<ValueTypes["LineDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LineUpdateResult']?: Omit<ValueTypes["LineUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LineUpsertResult']?: Omit<ValueTypes["LineUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FinancesBalanceItemCreateResult']?: Omit<ValueTypes["FinancesBalanceItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FinancesBalanceItemDeleteResult']?: Omit<ValueTypes["FinancesBalanceItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FinancesBalanceItemUpdateResult']?: Omit<ValueTypes["FinancesBalanceItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FinancesBalanceItemUpsertResult']?: Omit<ValueTypes["FinancesBalanceItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on WoltDriveDeliveryCreateResult']?: Omit<ValueTypes["WoltDriveDeliveryCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on WoltDriveDeliveryDeleteResult']?: Omit<ValueTypes["WoltDriveDeliveryDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on WoltDriveDeliveryUpdateResult']?: Omit<ValueTypes["WoltDriveDeliveryUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on WoltDriveDeliveryUpsertResult']?: Omit<ValueTypes["WoltDriveDeliveryUpsertResult"],keyof ValueTypes["MutationResult"]>;
		__typename?: boolean | `@${string}`
}>;
	["_MutationError"]: AliasType<{
	path?:ValueTypes["_PathFragment"],
	paths?:ValueTypes["_PathFragment"],
	type?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_MutationErrorType"]:_MutationErrorType;
	["AddressDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Address"],
		__typename?: boolean | `@${string}`
}>;
	["AddressUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Address"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["AddressUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Address"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CountryCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Country"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CountryDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Country"],
		__typename?: boolean | `@${string}`
}>;
	["CountryUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Country"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CountryUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Country"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ChannelCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Channel"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ChannelDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Channel"],
		__typename?: boolean | `@${string}`
}>;
	["ChannelUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Channel"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ChannelUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Channel"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ChannelPaymentCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ChannelPayment"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ChannelPaymentDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ChannelPayment"],
		__typename?: boolean | `@${string}`
}>;
	["ChannelPaymentUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ChannelPayment"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ChannelPaymentUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ChannelPayment"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ChannelDeliveryCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ChannelDelivery"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ChannelDeliveryDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ChannelDelivery"],
		__typename?: boolean | `@${string}`
}>;
	["ChannelDeliveryUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ChannelDelivery"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ChannelDeliveryUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ChannelDelivery"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Customer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Customer"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Customer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Customer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerCreditCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CustomerCredit"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerCreditDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CustomerCredit"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerCreditUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CustomerCredit"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerCreditUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CustomerCredit"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerGroupCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CustomerGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerGroupDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CustomerGroup"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerGroupUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CustomerGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerGroupUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CustomerGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerPaymentMethodCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CustomerPaymentMethod"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerPaymentMethodDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CustomerPaymentMethod"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerPaymentMethodUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CustomerPaymentMethod"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerPaymentMethodUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CustomerPaymentMethod"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryMethodCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeliveryMethod"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryMethodDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeliveryMethod"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryMethodUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeliveryMethod"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryMethodUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeliveryMethod"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["OrderCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Order"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["OrderDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Order"],
		__typename?: boolean | `@${string}`
}>;
	["OrderUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Order"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["OrderUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Order"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["OrderDiscountCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OrderDiscount"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["OrderDiscountDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OrderDiscount"],
		__typename?: boolean | `@${string}`
}>;
	["OrderDiscountUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OrderDiscount"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["OrderDiscountUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OrderDiscount"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["OrderPaymentCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OrderPayment"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["OrderPaymentDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OrderPayment"],
		__typename?: boolean | `@${string}`
}>;
	["OrderPaymentUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OrderPayment"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["OrderPaymentUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OrderPayment"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["OrderDeliveryCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OrderDelivery"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["OrderDeliveryDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OrderDelivery"],
		__typename?: boolean | `@${string}`
}>;
	["OrderDeliveryUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OrderDelivery"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["OrderDeliveryUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OrderDelivery"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["OrderItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OrderItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["OrderItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OrderItem"],
		__typename?: boolean | `@${string}`
}>;
	["OrderItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OrderItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["OrderItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OrderItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PaymentMethodCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PaymentMethod"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PaymentMethodDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PaymentMethod"],
		__typename?: boolean | `@${string}`
}>;
	["PaymentMethodUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PaymentMethod"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PaymentMethodUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PaymentMethod"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["VatRateCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["VatRate"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["VatRateDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["VatRate"],
		__typename?: boolean | `@${string}`
}>;
	["VatRateUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["VatRate"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["VatRateUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["VatRate"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Product"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Product"],
		__typename?: boolean | `@${string}`
}>;
	["ProductUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Product"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Product"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductStockCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductStock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductStockDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductStock"],
		__typename?: boolean | `@${string}`
}>;
	["ProductStockUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductStock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductStockUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductStock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductPackingCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductPacking"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductPackingDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductPacking"],
		__typename?: boolean | `@${string}`
}>;
	["ProductPackingUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductPacking"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductPackingUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductPacking"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductGroupPriceCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductGroupPrice"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductGroupPriceDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductGroupPrice"],
		__typename?: boolean | `@${string}`
}>;
	["ProductGroupPriceUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductGroupPrice"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductGroupPriceUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductGroupPrice"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductRecipeCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductRecipe"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductRecipeDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductRecipe"],
		__typename?: boolean | `@${string}`
}>;
	["ProductRecipeUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductRecipe"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductRecipeUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductRecipe"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductCategoryCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductCategoryDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductCategory"],
		__typename?: boolean | `@${string}`
}>;
	["ProductCategoryUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductCategoryUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StoreCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Store"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StoreDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Store"],
		__typename?: boolean | `@${string}`
}>;
	["StoreUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Store"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StoreUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Store"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TagCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Tag"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TagDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Tag"],
		__typename?: boolean | `@${string}`
}>;
	["TagUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Tag"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TagUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Tag"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
		__typename?: boolean | `@${string}`
}>;
	["ImageUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessCategoryCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessCategoryDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessCategory"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessCategoryUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessCategoryUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductList"],
		__typename?: boolean | `@${string}`
}>;
	["ProductListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductListItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductListItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductListItem"],
		__typename?: boolean | `@${string}`
}>;
	["ProductListItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductListItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductCategoryListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductCategoryList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductCategoryListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductCategoryList"],
		__typename?: boolean | `@${string}`
}>;
	["ProductCategoryListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductCategoryList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductCategoryListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductCategoryList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductCategoryListItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductCategoryListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductCategoryListItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductCategoryListItem"],
		__typename?: boolean | `@${string}`
}>;
	["ProductCategoryListItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductCategoryListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductCategoryListItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductCategoryListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessCategoryLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessCategoryLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessCategoryLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessCategoryLocale"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessCategoryLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessCategoryLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessCategoryLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessCategoryLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Locale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Locale"],
		__typename?: boolean | `@${string}`
}>;
	["LocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Locale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Locale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductCategoryListLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductCategoryListLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductCategoryListLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductCategoryListLocale"],
		__typename?: boolean | `@${string}`
}>;
	["ProductCategoryListLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductCategoryListLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductCategoryListLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductCategoryListLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerNameCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CustomerName"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerNameDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CustomerName"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerNameUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CustomerName"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerNameUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CustomerName"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerAliasCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CustomerAlias"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerAliasDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CustomerAlias"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerAliasUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CustomerAlias"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerAliasUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CustomerAlias"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductIngredientItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductIngredientItem"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductIngredientItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductIngredientItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientItemQuantityCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductIngredientItemQuantity"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientItemQuantityDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductIngredientItemQuantity"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientItemQuantityUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductIngredientItemQuantity"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientItemQuantityUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductIngredientItemQuantity"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientItemQuantityUnitCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductIngredientItemQuantityUnit"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientItemQuantityUnitDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductIngredientItemQuantityUnit"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientItemQuantityUnitUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductIngredientItemQuantityUnit"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientItemQuantityUnitUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductIngredientItemQuantityUnit"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductIngredient"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductIngredient"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductIngredient"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductIngredient"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerIngredientRatingCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CustomerIngredientRating"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerIngredientRatingDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CustomerIngredientRating"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerIngredientRatingUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CustomerIngredientRating"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerIngredientRatingUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CustomerIngredientRating"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientRatingCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductIngredientRating"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientRatingDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductIngredientRating"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientRatingUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductIngredientRating"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientRatingUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductIngredientRating"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductIngredientLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductIngredientLocale"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductIngredientLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductIngredientLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["OrderRecurrenceCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OrderRecurrence"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["OrderRecurrenceDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OrderRecurrence"],
		__typename?: boolean | `@${string}`
}>;
	["OrderRecurrenceUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OrderRecurrence"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["OrderRecurrenceUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OrderRecurrence"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["OrderRecurrenceLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OrderRecurrenceLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["OrderRecurrenceLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OrderRecurrenceLocale"],
		__typename?: boolean | `@${string}`
}>;
	["OrderRecurrenceLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OrderRecurrenceLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["OrderRecurrenceLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OrderRecurrenceLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessCustomerCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessCustomer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessCustomerDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessCustomer"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessCustomerUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessCustomer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessCustomerUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessCustomer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PointOfSale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PointOfSale"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PointOfSale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PointOfSale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StaffCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Staff"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StaffDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Staff"],
		__typename?: boolean | `@${string}`
}>;
	["StaffUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Staff"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StaffUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Staff"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BlogCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Blog"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BlogDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Blog"],
		__typename?: boolean | `@${string}`
}>;
	["BlogUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Blog"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BlogUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Blog"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BlogLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BlogLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogLocale"],
		__typename?: boolean | `@${string}`
}>;
	["BlogLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BlogLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BlogPostCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPost"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BlogPostDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPost"],
		__typename?: boolean | `@${string}`
}>;
	["BlogPostUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPost"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BlogPostUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPost"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BlogPostLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPostLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BlogPostLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPostLocale"],
		__typename?: boolean | `@${string}`
}>;
	["BlogPostLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPostLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BlogPostLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPostLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ColorPalleteCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ColorPallete"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ColorPalleteDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ColorPallete"],
		__typename?: boolean | `@${string}`
}>;
	["ColorPalleteUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ColorPallete"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ColorPalleteUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ColorPallete"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
		__typename?: boolean | `@${string}`
}>;
	["ContentUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentBlockUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ContentReferenceUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BlogPostListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPostList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BlogPostListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPostList"],
		__typename?: boolean | `@${string}`
}>;
	["BlogPostListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPostList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BlogPostListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPostList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BlogPostListItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPostListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BlogPostListItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPostListItem"],
		__typename?: boolean | `@${string}`
}>;
	["BlogPostListItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPostListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BlogPostListItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPostListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkList"],
		__typename?: boolean | `@${string}`
}>;
	["LinkListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkListItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkListItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkListItem"],
		__typename?: boolean | `@${string}`
}>;
	["LinkListItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkListItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CoverCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Cover"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CoverDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Cover"],
		__typename?: boolean | `@${string}`
}>;
	["CoverUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Cover"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CoverUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Cover"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
		__typename?: boolean | `@${string}`
}>;
	["LinkUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkableCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkableDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
		__typename?: boolean | `@${string}`
}>;
	["LinkableUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LinkableUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Medium"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Medium"],
		__typename?: boolean | `@${string}`
}>;
	["MediumUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Medium"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MediumUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Medium"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["VideoCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Video"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["VideoDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Video"],
		__typename?: boolean | `@${string}`
}>;
	["VideoUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Video"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["VideoUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Video"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SeoCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SeoDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
		__typename?: boolean | `@${string}`
}>;
	["SeoUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SeoUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProtectedImageCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProtectedImage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProtectedImageDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProtectedImage"],
		__typename?: boolean | `@${string}`
}>;
	["ProtectedImageUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProtectedImage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProtectedImageUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProtectedImage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationDomainCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationDomain"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationDomainDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationDomain"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationDomainUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationDomain"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationDomainUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationDomain"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCatalogueCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationCatalogue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCatalogueDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationCatalogue"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCatalogueUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationCatalogue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCatalogueUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationCatalogue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationKeyCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationKey"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationKeyDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationKey"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationKeyUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationKey"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationKeyUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationKey"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationValueCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationValue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationValueDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationValue"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationValueUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationValue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationValueUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationValue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCataloguesIdentifierCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationCataloguesIdentifier"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCataloguesIdentifierDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationCataloguesIdentifier"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCataloguesIdentifierUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationCataloguesIdentifier"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TranslationCataloguesIdentifierUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationCataloguesIdentifier"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SocialsAndAppsCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialsAndApps"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SocialsAndAppsDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialsAndApps"],
		__typename?: boolean | `@${string}`
}>;
	["SocialsAndAppsUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialsAndApps"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SocialsAndAppsUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialsAndApps"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductGridCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductGrid"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductGridDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductGrid"],
		__typename?: boolean | `@${string}`
}>;
	["ProductGridUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductGrid"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductGridUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductGrid"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductGridItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductGridItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductGridItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductGridItem"],
		__typename?: boolean | `@${string}`
}>;
	["ProductGridItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductGridItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductGridItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductGridItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Gallery"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Gallery"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Gallery"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Gallery"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GalleryItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GalleryItem"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GalleryItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GalleryItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GalleryItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeroCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Hero"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeroDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Hero"],
		__typename?: boolean | `@${string}`
}>;
	["HeroUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Hero"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["HeroUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Hero"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SiteMenuCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SiteMenu"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SiteMenuDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SiteMenu"],
		__typename?: boolean | `@${string}`
}>;
	["SiteMenuUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SiteMenu"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SiteMenuUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SiteMenu"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MenuLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MenuLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuLocale"],
		__typename?: boolean | `@${string}`
}>;
	["MenuLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MenuLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MenuItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MenuItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuItem"],
		__typename?: boolean | `@${string}`
}>;
	["MenuItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MenuItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PageCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Page"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PageDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Page"],
		__typename?: boolean | `@${string}`
}>;
	["PageUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Page"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PageUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Page"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PageLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PageLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["PageLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PageLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["WikiPageCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["WikiPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["WikiPageDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["WikiPage"],
		__typename?: boolean | `@${string}`
}>;
	["WikiPageUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["WikiPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["WikiPageUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["WikiPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MenuSubitemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuSubitem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MenuSubitemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuSubitem"],
		__typename?: boolean | `@${string}`
}>;
	["MenuSubitemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuSubitem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MenuSubitemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuSubitem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MenuLinkListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuLinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MenuLinkListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuLinkList"],
		__typename?: boolean | `@${string}`
}>;
	["MenuLinkListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuLinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MenuLinkListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuLinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MenuLinkItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuLinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MenuLinkItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuLinkItem"],
		__typename?: boolean | `@${string}`
}>;
	["MenuLinkItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuLinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MenuLinkItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuLinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MenuProductsCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuProducts"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MenuProductsDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuProducts"],
		__typename?: boolean | `@${string}`
}>;
	["MenuProductsUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuProducts"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MenuProductsUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuProducts"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MenuDeliveryCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuDelivery"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MenuDeliveryDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuDelivery"],
		__typename?: boolean | `@${string}`
}>;
	["MenuDeliveryUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuDelivery"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MenuDeliveryUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuDelivery"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MenuContactCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuContact"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MenuContactDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuContact"],
		__typename?: boolean | `@${string}`
}>;
	["MenuContactUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuContact"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MenuContactUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuContact"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DeadlineTemplateCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeadlineTemplate"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DeadlineTemplateDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeadlineTemplate"],
		__typename?: boolean | `@${string}`
}>;
	["DeadlineTemplateUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeadlineTemplate"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DeadlineTemplateUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeadlineTemplate"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["EmployeeQueueCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EmployeeQueue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["EmployeeQueueDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EmployeeQueue"],
		__typename?: boolean | `@${string}`
}>;
	["EmployeeQueueUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EmployeeQueue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["EmployeeQueueUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EmployeeQueue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableDayCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetableDay"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableDayDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetableDay"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableDayUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetableDay"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableDayUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetableDay"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableEmployeeRoleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetableEmployeeRole"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableEmployeeRoleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetableEmployeeRole"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableEmployeeRoleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetableEmployeeRole"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableEmployeeRoleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetableEmployeeRole"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableShiftCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetableShift"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableShiftDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetableShift"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableShiftUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetableShift"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableShiftUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetableShift"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableShiftGroupCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetableShiftGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableShiftGroupDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetableShiftGroup"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableShiftGroupUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetableShiftGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableShiftGroupUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetableShiftGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableShiftPositionCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetableShiftPosition"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableShiftPositionDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetableShiftPosition"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableShiftPositionUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetableShiftPosition"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableShiftPositionUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetableShiftPosition"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableTemplateCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetableTemplate"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableTemplateDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetableTemplate"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableTemplateUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetableTemplate"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableTemplateUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetableTemplate"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CartCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Cart"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CartDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Cart"],
		__typename?: boolean | `@${string}`
}>;
	["CartUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Cart"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CartUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Cart"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CartItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CartItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CartItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CartItem"],
		__typename?: boolean | `@${string}`
}>;
	["CartItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CartItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CartItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CartItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["EmployeeQueueItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EmployeeQueueItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["EmployeeQueueItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EmployeeQueueItem"],
		__typename?: boolean | `@${string}`
}>;
	["EmployeeQueueItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EmployeeQueueItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["EmployeeQueueItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EmployeeQueueItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ApplicationCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Application"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ApplicationDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Application"],
		__typename?: boolean | `@${string}`
}>;
	["ApplicationUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Application"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ApplicationUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Application"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ApplicationShortcutListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ApplicationShortcutList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ApplicationShortcutListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ApplicationShortcutList"],
		__typename?: boolean | `@${string}`
}>;
	["ApplicationShortcutListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ApplicationShortcutList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ApplicationShortcutListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ApplicationShortcutList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ApplicationShortcutListItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ApplicationShortcutListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ApplicationShortcutListItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ApplicationShortcutListItem"],
		__typename?: boolean | `@${string}`
}>;
	["ApplicationShortcutListItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ApplicationShortcutListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ApplicationShortcutListItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ApplicationShortcutListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductBannerCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductBanner"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductBannerDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductBanner"],
		__typename?: boolean | `@${string}`
}>;
	["ProductBannerUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductBanner"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductBannerUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductBanner"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductBannerItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductBannerItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductBannerItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductBannerItem"],
		__typename?: boolean | `@${string}`
}>;
	["ProductBannerItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductBannerItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductBannerItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductBannerItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductBannerListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductBannerList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductBannerListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductBannerList"],
		__typename?: boolean | `@${string}`
}>;
	["ProductBannerListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductBannerList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductBannerListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductBannerList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BartenderCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Bartender"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BartenderDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Bartender"],
		__typename?: boolean | `@${string}`
}>;
	["BartenderUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Bartender"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BartenderUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Bartender"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessToBusinessManagerCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessToBusinessManager"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessToBusinessManagerDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessToBusinessManager"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessToBusinessManagerUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessToBusinessManager"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessToBusinessManagerUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessToBusinessManager"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CleanerCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Cleaner"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CleanerDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Cleaner"],
		__typename?: boolean | `@${string}`
}>;
	["CleanerUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Cleaner"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CleanerUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Cleaner"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CourierCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Courier"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CourierDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Courier"],
		__typename?: boolean | `@${string}`
}>;
	["CourierUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Courier"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CourierUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Courier"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ShiftsManagerCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShiftsManager"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ShiftsManagerDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShiftsManager"],
		__typename?: boolean | `@${string}`
}>;
	["ShiftsManagerUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShiftsManager"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ShiftsManagerUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShiftsManager"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["User"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["User"],
		__typename?: boolean | `@${string}`
}>;
	["UserUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["User"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["User"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ShiftsProfileCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShiftsProfile"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ShiftsProfileDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShiftsProfile"],
		__typename?: boolean | `@${string}`
}>;
	["ShiftsProfileUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShiftsProfile"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ShiftsProfileUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShiftsProfile"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientCategoryCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductIngredientCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientCategoryDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductIngredientCategory"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientCategoryUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductIngredientCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientCategoryUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductIngredientCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientCategoryLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductIngredientCategoryLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientCategoryLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductIngredientCategoryLocale"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientCategoryLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductIngredientCategoryLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductIngredientCategoryLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductIngredientCategoryLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StocksManagerCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StocksManager"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StocksManagerDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StocksManager"],
		__typename?: boolean | `@${string}`
}>;
	["StocksManagerUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StocksManager"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StocksManagerUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StocksManager"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryRouteCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeliveryRoute"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryRouteDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeliveryRoute"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryRouteUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeliveryRoute"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryRouteUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeliveryRoute"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryWaypointCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeliveryWaypoint"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryWaypointDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeliveryWaypoint"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryWaypointUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeliveryWaypoint"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryWaypointUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeliveryWaypoint"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["AllergenCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Allergen"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["AllergenDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Allergen"],
		__typename?: boolean | `@${string}`
}>;
	["AllergenUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Allergen"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["AllergenUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Allergen"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["AllergenLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AllergenLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["AllergenLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AllergenLocale"],
		__typename?: boolean | `@${string}`
}>;
	["AllergenLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AllergenLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["AllergenLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AllergenLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GpsCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Gps"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GpsDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Gps"],
		__typename?: boolean | `@${string}`
}>;
	["GpsUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Gps"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GpsUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Gps"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["WeekHoursCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["WeekHours"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["WeekHoursDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["WeekHours"],
		__typename?: boolean | `@${string}`
}>;
	["WeekHoursUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["WeekHours"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["WeekHoursUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["WeekHours"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PreparedIngredientQuantityCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PreparedIngredientQuantity"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PreparedIngredientQuantityDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PreparedIngredientQuantity"],
		__typename?: boolean | `@${string}`
}>;
	["PreparedIngredientQuantityUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PreparedIngredientQuantity"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PreparedIngredientQuantityUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PreparedIngredientQuantity"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PreparedRecipeQuantityCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PreparedRecipeQuantity"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PreparedRecipeQuantityDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PreparedRecipeQuantity"],
		__typename?: boolean | `@${string}`
}>;
	["PreparedRecipeQuantityUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PreparedRecipeQuantity"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PreparedRecipeQuantityUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PreparedRecipeQuantity"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InternalOrderCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InternalOrder"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InternalOrderDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InternalOrder"],
		__typename?: boolean | `@${string}`
}>;
	["InternalOrderUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InternalOrder"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InternalOrderUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InternalOrder"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InternalOrderItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InternalOrderItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InternalOrderItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InternalOrderItem"],
		__typename?: boolean | `@${string}`
}>;
	["InternalOrderItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InternalOrderItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InternalOrderItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InternalOrderItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PreparedPackingQuantityCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PreparedPackingQuantity"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PreparedPackingQuantityDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PreparedPackingQuantity"],
		__typename?: boolean | `@${string}`
}>;
	["PreparedPackingQuantityUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PreparedPackingQuantity"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PreparedPackingQuantityUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PreparedPackingQuantity"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CourierManagerCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CourierManager"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CourierManagerDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CourierManager"],
		__typename?: boolean | `@${string}`
}>;
	["CourierManagerUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CourierManager"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CourierManagerUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CourierManager"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryZoneCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeliveryZone"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryZoneDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeliveryZone"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryZoneUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeliveryZone"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryZoneUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeliveryZone"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryTimelinePresetCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeliveryTimelinePreset"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryTimelinePresetDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeliveryTimelinePreset"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryTimelinePresetUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeliveryTimelinePreset"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryTimelinePresetUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeliveryTimelinePreset"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["OrderDeliveryTimelineCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OrderDeliveryTimeline"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["OrderDeliveryTimelineDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OrderDeliveryTimeline"],
		__typename?: boolean | `@${string}`
}>;
	["OrderDeliveryTimelineUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OrderDeliveryTimeline"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["OrderDeliveryTimelineUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OrderDeliveryTimeline"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["OrderEventCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OrderEvent"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["OrderEventDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OrderEvent"],
		__typename?: boolean | `@${string}`
}>;
	["OrderEventUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OrderEvent"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["OrderEventUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OrderEvent"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LiftagoRideCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LiftagoRide"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LiftagoRideDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LiftagoRide"],
		__typename?: boolean | `@${string}`
}>;
	["LiftagoRideUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LiftagoRide"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LiftagoRideUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LiftagoRide"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InvoiceCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Invoice"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InvoiceDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Invoice"],
		__typename?: boolean | `@${string}`
}>;
	["InvoiceUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Invoice"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InvoiceUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Invoice"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InvoicingPlanCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InvoicingPlan"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InvoicingPlanDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InvoicingPlan"],
		__typename?: boolean | `@${string}`
}>;
	["InvoicingPlanUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InvoicingPlan"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InvoicingPlanUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InvoicingPlan"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductPackingLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductPackingLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductPackingLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductPackingLocale"],
		__typename?: boolean | `@${string}`
}>;
	["ProductPackingLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductPackingLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductPackingLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductPackingLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductLocale"],
		__typename?: boolean | `@${string}`
}>;
	["ProductLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductRecipeLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductRecipeLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductRecipeLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductRecipeLocale"],
		__typename?: boolean | `@${string}`
}>;
	["ProductRecipeLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductRecipeLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductRecipeLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductRecipeLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserDeviceCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["UserDevice"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserDeviceDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["UserDevice"],
		__typename?: boolean | `@${string}`
}>;
	["UserDeviceUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["UserDevice"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UserDeviceUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["UserDevice"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProtectedActionCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProtectedAction"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProtectedActionDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProtectedAction"],
		__typename?: boolean | `@${string}`
}>;
	["ProtectedActionUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProtectedAction"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProtectedActionUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProtectedAction"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PickerCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Picker"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PickerDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Picker"],
		__typename?: boolean | `@${string}`
}>;
	["PickerUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Picker"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PickerUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Picker"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableTemplateStaffOptionsCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetableTemplateStaffOptions"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableTemplateStaffOptionsDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetableTemplateStaffOptions"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableTemplateStaffOptionsUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetableTemplateStaffOptions"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableTemplateStaffOptionsUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetableTemplateStaffOptions"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ShoppingListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShoppingList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ShoppingListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShoppingList"],
		__typename?: boolean | `@${string}`
}>;
	["ShoppingListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShoppingList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ShoppingListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShoppingList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SuppliesPurchaseCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SuppliesPurchase"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SuppliesPurchaseDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SuppliesPurchase"],
		__typename?: boolean | `@${string}`
}>;
	["SuppliesPurchaseUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SuppliesPurchase"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SuppliesPurchaseUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SuppliesPurchase"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InvoicingPresetCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InvoicingPreset"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InvoicingPresetDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InvoicingPreset"],
		__typename?: boolean | `@${string}`
}>;
	["InvoicingPresetUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InvoicingPreset"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InvoicingPresetUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InvoicingPreset"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LogRecordCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LogRecord"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LogRecordDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LogRecord"],
		__typename?: boolean | `@${string}`
}>;
	["LogRecordUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LogRecord"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LogRecordUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LogRecord"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BillingSubjectCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BillingSubject"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BillingSubjectDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BillingSubject"],
		__typename?: boolean | `@${string}`
}>;
	["BillingSubjectUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BillingSubject"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BillingSubjectUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BillingSubject"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ShoppingListItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShoppingListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ShoppingListItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShoppingListItem"],
		__typename?: boolean | `@${string}`
}>;
	["ShoppingListItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShoppingListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ShoppingListItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShoppingListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SuppliesPurchaseItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SuppliesPurchaseItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SuppliesPurchaseItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SuppliesPurchaseItem"],
		__typename?: boolean | `@${string}`
}>;
	["SuppliesPurchaseItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SuppliesPurchaseItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SuppliesPurchaseItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SuppliesPurchaseItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerCreditTransactionCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CustomerCreditTransaction"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerCreditTransactionDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CustomerCreditTransaction"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerCreditTransactionUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CustomerCreditTransaction"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerCreditTransactionUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CustomerCreditTransaction"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["VirtualProductCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["VirtualProduct"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["VirtualProductDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["VirtualProduct"],
		__typename?: boolean | `@${string}`
}>;
	["VirtualProductUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["VirtualProduct"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["VirtualProductUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["VirtualProduct"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["VirtualProductEffectCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["VirtualProductEffect"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["VirtualProductEffectDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["VirtualProductEffect"],
		__typename?: boolean | `@${string}`
}>;
	["VirtualProductEffectUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["VirtualProductEffect"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["VirtualProductEffectUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["VirtualProductEffect"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["EmploymentInformationCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EmploymentInformation"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["EmploymentInformationDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EmploymentInformation"],
		__typename?: boolean | `@${string}`
}>;
	["EmploymentInformationUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EmploymentInformation"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["EmploymentInformationUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EmploymentInformation"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RemunerationProfileCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RemunerationProfile"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RemunerationProfileDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RemunerationProfile"],
		__typename?: boolean | `@${string}`
}>;
	["RemunerationProfileUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RemunerationProfile"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RemunerationProfileUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RemunerationProfile"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["WorkMonthCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["WorkMonth"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["WorkMonthDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["WorkMonth"],
		__typename?: boolean | `@${string}`
}>;
	["WorkMonthUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["WorkMonth"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["WorkMonthUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["WorkMonth"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SalaryOptionsCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SalaryOptions"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SalaryOptionsDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SalaryOptions"],
		__typename?: boolean | `@${string}`
}>;
	["SalaryOptionsUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SalaryOptions"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SalaryOptionsUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SalaryOptions"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableShiftSwapInfoCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetableShiftSwapInfo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableShiftSwapInfoDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetableShiftSwapInfo"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableShiftSwapInfoUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetableShiftSwapInfo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableShiftSwapInfoUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetableShiftSwapInfo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductGridCategoryCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductGridCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductGridCategoryDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductGridCategory"],
		__typename?: boolean | `@${string}`
}>;
	["ProductGridCategoryUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductGridCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ProductGridCategoryUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductGridCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CashierCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Cashier"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CashierDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Cashier"],
		__typename?: boolean | `@${string}`
}>;
	["CashierUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Cashier"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CashierUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Cashier"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleCategoryCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PointOfSaleCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleCategoryDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PointOfSaleCategory"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleCategoryUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PointOfSaleCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleCategoryUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PointOfSaleCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleCategoryLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PointOfSaleCategoryLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleCategoryLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PointOfSaleCategoryLocale"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleCategoryLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PointOfSaleCategoryLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleCategoryLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PointOfSaleCategoryLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleCategoryProductCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PointOfSaleCategoryProduct"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleCategoryProductDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PointOfSaleCategoryProduct"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleCategoryProductUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PointOfSaleCategoryProduct"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleCategoryProductUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PointOfSaleCategoryProduct"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleCategoryProductLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PointOfSaleCategoryProductLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleCategoryProductLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PointOfSaleCategoryProductLocale"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleCategoryProductLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PointOfSaleCategoryProductLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleCategoryProductLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PointOfSaleCategoryProductLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerTabCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CustomerTab"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerTabDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CustomerTab"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerTabUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CustomerTab"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerTabUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CustomerTab"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerTabItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CustomerTabItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerTabItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CustomerTabItem"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerTabItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CustomerTabItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerTabItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CustomerTabItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["AnonymousSessionCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AnonymousSession"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["AnonymousSessionDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AnonymousSession"],
		__typename?: boolean | `@${string}`
}>;
	["AnonymousSessionUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AnonymousSession"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["AnonymousSessionUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AnonymousSession"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["VoucherCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Voucher"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["VoucherDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Voucher"],
		__typename?: boolean | `@${string}`
}>;
	["VoucherUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Voucher"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["VoucherUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Voucher"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["VoucherRedemptionCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["VoucherRedemption"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["VoucherRedemptionDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["VoucherRedemption"],
		__typename?: boolean | `@${string}`
}>;
	["VoucherRedemptionUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["VoucherRedemption"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["VoucherRedemptionUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["VoucherRedemption"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UnassignedShiftInfoCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["UnassignedShiftInfo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UnassignedShiftInfoDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["UnassignedShiftInfo"],
		__typename?: boolean | `@${string}`
}>;
	["UnassignedShiftInfoUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["UnassignedShiftInfo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UnassignedShiftInfoUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["UnassignedShiftInfo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FreshingContainerCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FreshingContainer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FreshingContainerDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FreshingContainer"],
		__typename?: boolean | `@${string}`
}>;
	["FreshingContainerUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FreshingContainer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FreshingContainerUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FreshingContainer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TextItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TextItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextItem"],
		__typename?: boolean | `@${string}`
}>;
	["TextItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TextItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TextListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TextListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextList"],
		__typename?: boolean | `@${string}`
}>;
	["TextListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TextListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryRegionsCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeliveryRegions"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryRegionsDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeliveryRegions"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryRegionsUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeliveryRegions"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryRegionsUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeliveryRegions"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryRegionsItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeliveryRegionsItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryRegionsItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeliveryRegionsItem"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryRegionsItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeliveryRegionsItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryRegionsItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeliveryRegionsItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageList"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageListItem"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ImageListItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TimetablesEmployeePrivilegesCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetablesEmployeePrivileges"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TimetablesEmployeePrivilegesDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetablesEmployeePrivileges"],
		__typename?: boolean | `@${string}`
}>;
	["TimetablesEmployeePrivilegesUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetablesEmployeePrivileges"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TimetablesEmployeePrivilegesUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetablesEmployeePrivileges"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableDayNoteCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetableDayNote"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableDayNoteDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetableDayNote"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableDayNoteUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetableDayNote"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TimetableDayNoteUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimetableDayNote"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryMethodLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeliveryMethodLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryMethodLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeliveryMethodLocale"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryMethodLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeliveryMethodLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DeliveryMethodLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeliveryMethodLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["IngredientSupplierCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["IngredientSupplier"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["IngredientSupplierDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["IngredientSupplier"],
		__typename?: boolean | `@${string}`
}>;
	["IngredientSupplierUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["IngredientSupplier"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["IngredientSupplierUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["IngredientSupplier"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["IngredientSupplierItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["IngredientSupplierItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["IngredientSupplierItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["IngredientSupplierItem"],
		__typename?: boolean | `@${string}`
}>;
	["IngredientSupplierItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["IngredientSupplierItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["IngredientSupplierItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["IngredientSupplierItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["IngredientSupplierListCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["IngredientSupplierList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["IngredientSupplierListDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["IngredientSupplierList"],
		__typename?: boolean | `@${string}`
}>;
	["IngredientSupplierListUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["IngredientSupplierList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["IngredientSupplierListUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["IngredientSupplierList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["IngredientSupplierLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["IngredientSupplierLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["IngredientSupplierLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["IngredientSupplierLocale"],
		__typename?: boolean | `@${string}`
}>;
	["IngredientSupplierLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["IngredientSupplierLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["IngredientSupplierLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["IngredientSupplierLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RedirectCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Redirect"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RedirectDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Redirect"],
		__typename?: boolean | `@${string}`
}>;
	["RedirectUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Redirect"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RedirectUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Redirect"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["NutritionFactsCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NutritionFacts"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["NutritionFactsDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NutritionFacts"],
		__typename?: boolean | `@${string}`
}>;
	["NutritionFactsUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NutritionFacts"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["NutritionFactsUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NutritionFacts"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["VenueCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Venue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["VenueDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Venue"],
		__typename?: boolean | `@${string}`
}>;
	["VenueUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Venue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["VenueUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Venue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["WorkspaceCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Workspace"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["WorkspaceDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Workspace"],
		__typename?: boolean | `@${string}`
}>;
	["WorkspaceUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Workspace"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["WorkspaceUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Workspace"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InternalBuyerCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InternalBuyer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InternalBuyerDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InternalBuyer"],
		__typename?: boolean | `@${string}`
}>;
	["InternalBuyerUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InternalBuyer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["InternalBuyerUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InternalBuyer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["VenueEmployeeRoleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["VenueEmployeeRole"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["VenueEmployeeRoleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["VenueEmployeeRole"],
		__typename?: boolean | `@${string}`
}>;
	["VenueEmployeeRoleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["VenueEmployeeRole"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["VenueEmployeeRoleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["VenueEmployeeRole"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["IdentificationAttemptCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["IdentificationAttempt"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["IdentificationAttemptDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["IdentificationAttempt"],
		__typename?: boolean | `@${string}`
}>;
	["IdentificationAttemptUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["IdentificationAttempt"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["IdentificationAttemptUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["IdentificationAttempt"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["IdentificationCodeCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["IdentificationCode"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["IdentificationCodeDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["IdentificationCode"],
		__typename?: boolean | `@${string}`
}>;
	["IdentificationCodeUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["IdentificationCode"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["IdentificationCodeUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["IdentificationCode"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["IdentificationCodeLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["IdentificationCodeLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["IdentificationCodeLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["IdentificationCodeLocale"],
		__typename?: boolean | `@${string}`
}>;
	["IdentificationCodeLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["IdentificationCodeLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["IdentificationCodeLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["IdentificationCodeLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Pipeline"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Pipeline"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Pipeline"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Pipeline"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineLeadCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PipelineLead"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineLeadDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PipelineLead"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineLeadUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PipelineLead"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineLeadUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PipelineLead"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineStageCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PipelineStage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineStageDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PipelineStage"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineStageUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PipelineStage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineStageUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PipelineStage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineStageItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PipelineStageItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineStageItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PipelineStageItem"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineStageItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PipelineStageItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineStageItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PipelineStageItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineStageLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PipelineStageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineStageLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PipelineStageLocale"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineStageLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PipelineStageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineStageLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PipelineStageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SalesManagerCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SalesManager"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SalesManagerDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SalesManager"],
		__typename?: boolean | `@${string}`
}>;
	["SalesManagerUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SalesManager"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SalesManagerUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SalesManager"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CashierManagerCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CashierManager"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CashierManagerDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CashierManager"],
		__typename?: boolean | `@${string}`
}>;
	["CashierManagerUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CashierManager"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["CashierManagerUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CashierManager"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleApplicationDeviceCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PointOfSaleApplicationDevice"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleApplicationDeviceDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PointOfSaleApplicationDevice"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleApplicationDeviceUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PointOfSaleApplicationDevice"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleApplicationDeviceUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PointOfSaleApplicationDevice"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleTerminalCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PointOfSaleTerminal"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleTerminalDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PointOfSaleTerminal"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleTerminalUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PointOfSaleTerminal"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSaleTerminalUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PointOfSaleTerminal"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineStageSentimentCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PipelineStageSentiment"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineStageSentimentDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PipelineStageSentiment"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineStageSentimentUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PipelineStageSentiment"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PipelineStageSentimentUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PipelineStageSentiment"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DeviceIdentifierCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeviceIdentifier"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DeviceIdentifierDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeviceIdentifier"],
		__typename?: boolean | `@${string}`
}>;
	["DeviceIdentifierUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeviceIdentifier"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DeviceIdentifierUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DeviceIdentifier"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSalePrinterCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PointOfSalePrinter"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSalePrinterDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PointOfSalePrinter"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSalePrinterUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PointOfSalePrinter"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PointOfSalePrinterUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PointOfSalePrinter"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GratuityCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Gratuity"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GratuityDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Gratuity"],
		__typename?: boolean | `@${string}`
}>;
	["GratuityUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Gratuity"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GratuityUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Gratuity"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FulfillmentNoteCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FulfillmentNote"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FulfillmentNoteDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FulfillmentNote"],
		__typename?: boolean | `@${string}`
}>;
	["FulfillmentNoteUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FulfillmentNote"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FulfillmentNoteUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FulfillmentNote"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LeadFormCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LeadForm"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LeadFormDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LeadForm"],
		__typename?: boolean | `@${string}`
}>;
	["LeadFormUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LeadForm"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LeadFormUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LeadForm"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SubscriptionBoxCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SubscriptionBox"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SubscriptionBoxDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SubscriptionBox"],
		__typename?: boolean | `@${string}`
}>;
	["SubscriptionBoxUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SubscriptionBox"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SubscriptionBoxUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SubscriptionBox"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SubscriptionBoxLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SubscriptionBoxLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SubscriptionBoxLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SubscriptionBoxLocale"],
		__typename?: boolean | `@${string}`
}>;
	["SubscriptionBoxLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SubscriptionBoxLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SubscriptionBoxLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SubscriptionBoxLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessServiceCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessService"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessServiceDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessService"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessServiceUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessService"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessServiceUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessService"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessServiceEventCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessServiceEvent"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessServiceEventDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessServiceEvent"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessServiceEventUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessServiceEvent"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessServiceEventUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessServiceEvent"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessServiceLocaleCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessServiceLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessServiceLocaleDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessServiceLocale"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessServiceLocaleUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessServiceLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["BusinessServiceLocaleUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessServiceLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GridTileItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GridTileItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GridTileItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GridTileItem"],
		__typename?: boolean | `@${string}`
}>;
	["GridTileItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GridTileItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GridTileItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GridTileItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GridTilesCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GridTiles"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GridTilesDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GridTiles"],
		__typename?: boolean | `@${string}`
}>;
	["GridTilesUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GridTiles"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["GridTilesUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GridTiles"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["AreaCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Area"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["AreaDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Area"],
		__typename?: boolean | `@${string}`
}>;
	["AreaUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Area"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["AreaUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Area"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PositionCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Position"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PositionDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Position"],
		__typename?: boolean | `@${string}`
}>;
	["PositionUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Position"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["PositionUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Position"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StatsEnabledWidgetTypeCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StatsEnabledWidgetType"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StatsEnabledWidgetTypeDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StatsEnabledWidgetType"],
		__typename?: boolean | `@${string}`
}>;
	["StatsEnabledWidgetTypeUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StatsEnabledWidgetType"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StatsEnabledWidgetTypeUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StatsEnabledWidgetType"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StatsWidgetCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StatsWidget"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StatsWidgetDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StatsWidget"],
		__typename?: boolean | `@${string}`
}>;
	["StatsWidgetUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StatsWidget"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StatsWidgetUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StatsWidget"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StatsWidgetsLayoutCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StatsWidgetsLayout"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StatsWidgetsLayoutDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StatsWidgetsLayout"],
		__typename?: boolean | `@${string}`
}>;
	["StatsWidgetsLayoutUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StatsWidgetsLayout"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StatsWidgetsLayoutUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StatsWidgetsLayout"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SeatCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seat"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SeatDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seat"],
		__typename?: boolean | `@${string}`
}>;
	["SeatUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seat"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["SeatUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seat"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TableCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Table"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TableDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Table"],
		__typename?: boolean | `@${string}`
}>;
	["TableUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Table"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["TableUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Table"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StatsPageCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StatsPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StatsPageDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StatsPage"],
		__typename?: boolean | `@${string}`
}>;
	["StatsPageUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StatsPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["StatsPageUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StatsPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UnassignReasonCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["UnassignReason"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UnassignReasonDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["UnassignReason"],
		__typename?: boolean | `@${string}`
}>;
	["UnassignReasonUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["UnassignReason"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["UnassignReasonUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["UnassignReason"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DoubleshotCoffeeEquipmentCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DoubleshotCoffeeEquipment"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DoubleshotCoffeeEquipmentDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DoubleshotCoffeeEquipment"],
		__typename?: boolean | `@${string}`
}>;
	["DoubleshotCoffeeEquipmentUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DoubleshotCoffeeEquipment"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["DoubleshotCoffeeEquipmentUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DoubleshotCoffeeEquipment"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ExpenseCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Expense"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ExpenseDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Expense"],
		__typename?: boolean | `@${string}`
}>;
	["ExpenseUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Expense"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ExpenseUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Expense"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ExpenseCategoryCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ExpenseCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ExpenseCategoryDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ExpenseCategory"],
		__typename?: boolean | `@${string}`
}>;
	["ExpenseCategoryUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ExpenseCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ExpenseCategoryUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ExpenseCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ExpenseChangeCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ExpenseChange"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ExpenseChangeDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ExpenseChange"],
		__typename?: boolean | `@${string}`
}>;
	["ExpenseChangeUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ExpenseChange"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ExpenseChangeUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ExpenseChange"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ExpenseDocumentCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ExpenseDocument"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ExpenseDocumentDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ExpenseDocument"],
		__typename?: boolean | `@${string}`
}>;
	["ExpenseDocumentUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ExpenseDocument"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["ExpenseDocumentUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ExpenseDocument"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RevenuePredictionCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RevenuePrediction"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RevenuePredictionDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RevenuePrediction"],
		__typename?: boolean | `@${string}`
}>;
	["RevenuePredictionUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RevenuePrediction"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RevenuePredictionUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RevenuePrediction"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RevenuePredictionChangeCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RevenuePredictionChange"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RevenuePredictionChangeDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RevenuePredictionChange"],
		__typename?: boolean | `@${string}`
}>;
	["RevenuePredictionChangeUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RevenuePredictionChange"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["RevenuePredictionChangeUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RevenuePredictionChange"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FileCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["File"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FileDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["File"],
		__typename?: boolean | `@${string}`
}>;
	["FileUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["File"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FileUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["File"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LineCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Line"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LineDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Line"],
		__typename?: boolean | `@${string}`
}>;
	["LineUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Line"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["LineUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Line"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FinancesBalanceItemCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FinancesBalanceItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FinancesBalanceItemDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FinancesBalanceItem"],
		__typename?: boolean | `@${string}`
}>;
	["FinancesBalanceItemUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FinancesBalanceItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["FinancesBalanceItemUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FinancesBalanceItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["WoltDriveDeliveryCreateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["WoltDriveDelivery"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["WoltDriveDeliveryDeleteResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["WoltDriveDelivery"],
		__typename?: boolean | `@${string}`
}>;
	["WoltDriveDeliveryUpdateResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["WoltDriveDelivery"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["WoltDriveDeliveryUpsertResult"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["WoltDriveDelivery"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean | `@${string}`
}>;
	["MutationTransaction"]: AliasType<{
	ok?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	errors?:ValueTypes["_MutationError"],
	validation?:ValueTypes["_ValidationResult"],
createAddress?: [{	data: ValueTypes["AddressCreateInput"]},ValueTypes["AddressCreateResult"]],
deleteAddress?: [{	by: ValueTypes["AddressUniqueWhere"],	filter?: ValueTypes["AddressWhere"] | undefined | null},ValueTypes["AddressDeleteResult"]],
updateAddress?: [{	by: ValueTypes["AddressUniqueWhere"],	filter?: ValueTypes["AddressWhere"] | undefined | null,	data: ValueTypes["AddressUpdateInput"]},ValueTypes["AddressUpdateResult"]],
upsertAddress?: [{	by: ValueTypes["AddressUniqueWhere"],	filter?: ValueTypes["AddressWhere"] | undefined | null,	update: ValueTypes["AddressUpdateInput"],	create: ValueTypes["AddressCreateInput"]},ValueTypes["AddressUpsertResult"]],
createCountry?: [{	data: ValueTypes["CountryCreateInput"]},ValueTypes["CountryCreateResult"]],
deleteCountry?: [{	by: ValueTypes["CountryUniqueWhere"],	filter?: ValueTypes["CountryWhere"] | undefined | null},ValueTypes["CountryDeleteResult"]],
updateCountry?: [{	by: ValueTypes["CountryUniqueWhere"],	filter?: ValueTypes["CountryWhere"] | undefined | null,	data: ValueTypes["CountryUpdateInput"]},ValueTypes["CountryUpdateResult"]],
upsertCountry?: [{	by: ValueTypes["CountryUniqueWhere"],	filter?: ValueTypes["CountryWhere"] | undefined | null,	update: ValueTypes["CountryUpdateInput"],	create: ValueTypes["CountryCreateInput"]},ValueTypes["CountryUpsertResult"]],
createChannel?: [{	data: ValueTypes["ChannelCreateInput"]},ValueTypes["ChannelCreateResult"]],
deleteChannel?: [{	by: ValueTypes["ChannelUniqueWhere"],	filter?: ValueTypes["ChannelWhere"] | undefined | null},ValueTypes["ChannelDeleteResult"]],
updateChannel?: [{	by: ValueTypes["ChannelUniqueWhere"],	filter?: ValueTypes["ChannelWhere"] | undefined | null,	data: ValueTypes["ChannelUpdateInput"]},ValueTypes["ChannelUpdateResult"]],
upsertChannel?: [{	by: ValueTypes["ChannelUniqueWhere"],	filter?: ValueTypes["ChannelWhere"] | undefined | null,	update: ValueTypes["ChannelUpdateInput"],	create: ValueTypes["ChannelCreateInput"]},ValueTypes["ChannelUpsertResult"]],
createChannelPayment?: [{	data: ValueTypes["ChannelPaymentCreateInput"]},ValueTypes["ChannelPaymentCreateResult"]],
deleteChannelPayment?: [{	by: ValueTypes["ChannelPaymentUniqueWhere"],	filter?: ValueTypes["ChannelPaymentWhere"] | undefined | null},ValueTypes["ChannelPaymentDeleteResult"]],
updateChannelPayment?: [{	by: ValueTypes["ChannelPaymentUniqueWhere"],	filter?: ValueTypes["ChannelPaymentWhere"] | undefined | null,	data: ValueTypes["ChannelPaymentUpdateInput"]},ValueTypes["ChannelPaymentUpdateResult"]],
upsertChannelPayment?: [{	by: ValueTypes["ChannelPaymentUniqueWhere"],	filter?: ValueTypes["ChannelPaymentWhere"] | undefined | null,	update: ValueTypes["ChannelPaymentUpdateInput"],	create: ValueTypes["ChannelPaymentCreateInput"]},ValueTypes["ChannelPaymentUpsertResult"]],
createChannelDelivery?: [{	data: ValueTypes["ChannelDeliveryCreateInput"]},ValueTypes["ChannelDeliveryCreateResult"]],
deleteChannelDelivery?: [{	by: ValueTypes["ChannelDeliveryUniqueWhere"],	filter?: ValueTypes["ChannelDeliveryWhere"] | undefined | null},ValueTypes["ChannelDeliveryDeleteResult"]],
updateChannelDelivery?: [{	by: ValueTypes["ChannelDeliveryUniqueWhere"],	filter?: ValueTypes["ChannelDeliveryWhere"] | undefined | null,	data: ValueTypes["ChannelDeliveryUpdateInput"]},ValueTypes["ChannelDeliveryUpdateResult"]],
upsertChannelDelivery?: [{	by: ValueTypes["ChannelDeliveryUniqueWhere"],	filter?: ValueTypes["ChannelDeliveryWhere"] | undefined | null,	update: ValueTypes["ChannelDeliveryUpdateInput"],	create: ValueTypes["ChannelDeliveryCreateInput"]},ValueTypes["ChannelDeliveryUpsertResult"]],
createCustomer?: [{	data: ValueTypes["CustomerCreateInput"]},ValueTypes["CustomerCreateResult"]],
deleteCustomer?: [{	by: ValueTypes["CustomerUniqueWhere"],	filter?: ValueTypes["CustomerWhere"] | undefined | null},ValueTypes["CustomerDeleteResult"]],
updateCustomer?: [{	by: ValueTypes["CustomerUniqueWhere"],	filter?: ValueTypes["CustomerWhere"] | undefined | null,	data: ValueTypes["CustomerUpdateInput"]},ValueTypes["CustomerUpdateResult"]],
upsertCustomer?: [{	by: ValueTypes["CustomerUniqueWhere"],	filter?: ValueTypes["CustomerWhere"] | undefined | null,	update: ValueTypes["CustomerUpdateInput"],	create: ValueTypes["CustomerCreateInput"]},ValueTypes["CustomerUpsertResult"]],
createCustomerCredit?: [{	data: ValueTypes["CustomerCreditCreateInput"]},ValueTypes["CustomerCreditCreateResult"]],
deleteCustomerCredit?: [{	by: ValueTypes["CustomerCreditUniqueWhere"],	filter?: ValueTypes["CustomerCreditWhere"] | undefined | null},ValueTypes["CustomerCreditDeleteResult"]],
updateCustomerCredit?: [{	by: ValueTypes["CustomerCreditUniqueWhere"],	filter?: ValueTypes["CustomerCreditWhere"] | undefined | null,	data: ValueTypes["CustomerCreditUpdateInput"]},ValueTypes["CustomerCreditUpdateResult"]],
upsertCustomerCredit?: [{	by: ValueTypes["CustomerCreditUniqueWhere"],	filter?: ValueTypes["CustomerCreditWhere"] | undefined | null,	update: ValueTypes["CustomerCreditUpdateInput"],	create: ValueTypes["CustomerCreditCreateInput"]},ValueTypes["CustomerCreditUpsertResult"]],
createCustomerGroup?: [{	data: ValueTypes["CustomerGroupCreateInput"]},ValueTypes["CustomerGroupCreateResult"]],
deleteCustomerGroup?: [{	by: ValueTypes["CustomerGroupUniqueWhere"],	filter?: ValueTypes["CustomerGroupWhere"] | undefined | null},ValueTypes["CustomerGroupDeleteResult"]],
updateCustomerGroup?: [{	by: ValueTypes["CustomerGroupUniqueWhere"],	filter?: ValueTypes["CustomerGroupWhere"] | undefined | null,	data: ValueTypes["CustomerGroupUpdateInput"]},ValueTypes["CustomerGroupUpdateResult"]],
upsertCustomerGroup?: [{	by: ValueTypes["CustomerGroupUniqueWhere"],	filter?: ValueTypes["CustomerGroupWhere"] | undefined | null,	update: ValueTypes["CustomerGroupUpdateInput"],	create: ValueTypes["CustomerGroupCreateInput"]},ValueTypes["CustomerGroupUpsertResult"]],
createCustomerPaymentMethod?: [{	data: ValueTypes["CustomerPaymentMethodCreateInput"]},ValueTypes["CustomerPaymentMethodCreateResult"]],
deleteCustomerPaymentMethod?: [{	by: ValueTypes["CustomerPaymentMethodUniqueWhere"],	filter?: ValueTypes["CustomerPaymentMethodWhere"] | undefined | null},ValueTypes["CustomerPaymentMethodDeleteResult"]],
updateCustomerPaymentMethod?: [{	by: ValueTypes["CustomerPaymentMethodUniqueWhere"],	filter?: ValueTypes["CustomerPaymentMethodWhere"] | undefined | null,	data: ValueTypes["CustomerPaymentMethodUpdateInput"]},ValueTypes["CustomerPaymentMethodUpdateResult"]],
upsertCustomerPaymentMethod?: [{	by: ValueTypes["CustomerPaymentMethodUniqueWhere"],	filter?: ValueTypes["CustomerPaymentMethodWhere"] | undefined | null,	update: ValueTypes["CustomerPaymentMethodUpdateInput"],	create: ValueTypes["CustomerPaymentMethodCreateInput"]},ValueTypes["CustomerPaymentMethodUpsertResult"]],
createDeliveryMethod?: [{	data: ValueTypes["DeliveryMethodCreateInput"]},ValueTypes["DeliveryMethodCreateResult"]],
deleteDeliveryMethod?: [{	by: ValueTypes["DeliveryMethodUniqueWhere"],	filter?: ValueTypes["DeliveryMethodWhere"] | undefined | null},ValueTypes["DeliveryMethodDeleteResult"]],
updateDeliveryMethod?: [{	by: ValueTypes["DeliveryMethodUniqueWhere"],	filter?: ValueTypes["DeliveryMethodWhere"] | undefined | null,	data: ValueTypes["DeliveryMethodUpdateInput"]},ValueTypes["DeliveryMethodUpdateResult"]],
upsertDeliveryMethod?: [{	by: ValueTypes["DeliveryMethodUniqueWhere"],	filter?: ValueTypes["DeliveryMethodWhere"] | undefined | null,	update: ValueTypes["DeliveryMethodUpdateInput"],	create: ValueTypes["DeliveryMethodCreateInput"]},ValueTypes["DeliveryMethodUpsertResult"]],
createOrder?: [{	data: ValueTypes["OrderCreateInput"]},ValueTypes["OrderCreateResult"]],
deleteOrder?: [{	by: ValueTypes["OrderUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null},ValueTypes["OrderDeleteResult"]],
updateOrder?: [{	by: ValueTypes["OrderUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null,	data: ValueTypes["OrderUpdateInput"]},ValueTypes["OrderUpdateResult"]],
upsertOrder?: [{	by: ValueTypes["OrderUniqueWhere"],	filter?: ValueTypes["OrderWhere"] | undefined | null,	update: ValueTypes["OrderUpdateInput"],	create: ValueTypes["OrderCreateInput"]},ValueTypes["OrderUpsertResult"]],
createOrderDiscount?: [{	data: ValueTypes["OrderDiscountCreateInput"]},ValueTypes["OrderDiscountCreateResult"]],
deleteOrderDiscount?: [{	by: ValueTypes["OrderDiscountUniqueWhere"],	filter?: ValueTypes["OrderDiscountWhere"] | undefined | null},ValueTypes["OrderDiscountDeleteResult"]],
updateOrderDiscount?: [{	by: ValueTypes["OrderDiscountUniqueWhere"],	filter?: ValueTypes["OrderDiscountWhere"] | undefined | null,	data: ValueTypes["OrderDiscountUpdateInput"]},ValueTypes["OrderDiscountUpdateResult"]],
upsertOrderDiscount?: [{	by: ValueTypes["OrderDiscountUniqueWhere"],	filter?: ValueTypes["OrderDiscountWhere"] | undefined | null,	update: ValueTypes["OrderDiscountUpdateInput"],	create: ValueTypes["OrderDiscountCreateInput"]},ValueTypes["OrderDiscountUpsertResult"]],
createOrderPayment?: [{	data: ValueTypes["OrderPaymentCreateInput"]},ValueTypes["OrderPaymentCreateResult"]],
deleteOrderPayment?: [{	by: ValueTypes["OrderPaymentUniqueWhere"],	filter?: ValueTypes["OrderPaymentWhere"] | undefined | null},ValueTypes["OrderPaymentDeleteResult"]],
updateOrderPayment?: [{	by: ValueTypes["OrderPaymentUniqueWhere"],	filter?: ValueTypes["OrderPaymentWhere"] | undefined | null,	data: ValueTypes["OrderPaymentUpdateInput"]},ValueTypes["OrderPaymentUpdateResult"]],
upsertOrderPayment?: [{	by: ValueTypes["OrderPaymentUniqueWhere"],	filter?: ValueTypes["OrderPaymentWhere"] | undefined | null,	update: ValueTypes["OrderPaymentUpdateInput"],	create: ValueTypes["OrderPaymentCreateInput"]},ValueTypes["OrderPaymentUpsertResult"]],
createOrderDelivery?: [{	data: ValueTypes["OrderDeliveryCreateInput"]},ValueTypes["OrderDeliveryCreateResult"]],
deleteOrderDelivery?: [{	by: ValueTypes["OrderDeliveryUniqueWhere"],	filter?: ValueTypes["OrderDeliveryWhere"] | undefined | null},ValueTypes["OrderDeliveryDeleteResult"]],
updateOrderDelivery?: [{	by: ValueTypes["OrderDeliveryUniqueWhere"],	filter?: ValueTypes["OrderDeliveryWhere"] | undefined | null,	data: ValueTypes["OrderDeliveryUpdateInput"]},ValueTypes["OrderDeliveryUpdateResult"]],
upsertOrderDelivery?: [{	by: ValueTypes["OrderDeliveryUniqueWhere"],	filter?: ValueTypes["OrderDeliveryWhere"] | undefined | null,	update: ValueTypes["OrderDeliveryUpdateInput"],	create: ValueTypes["OrderDeliveryCreateInput"]},ValueTypes["OrderDeliveryUpsertResult"]],
createOrderItem?: [{	data: ValueTypes["OrderItemCreateInput"]},ValueTypes["OrderItemCreateResult"]],
deleteOrderItem?: [{	by: ValueTypes["OrderItemUniqueWhere"],	filter?: ValueTypes["OrderItemWhere"] | undefined | null},ValueTypes["OrderItemDeleteResult"]],
updateOrderItem?: [{	by: ValueTypes["OrderItemUniqueWhere"],	filter?: ValueTypes["OrderItemWhere"] | undefined | null,	data: ValueTypes["OrderItemUpdateInput"]},ValueTypes["OrderItemUpdateResult"]],
upsertOrderItem?: [{	by: ValueTypes["OrderItemUniqueWhere"],	filter?: ValueTypes["OrderItemWhere"] | undefined | null,	update: ValueTypes["OrderItemUpdateInput"],	create: ValueTypes["OrderItemCreateInput"]},ValueTypes["OrderItemUpsertResult"]],
createPaymentMethod?: [{	data: ValueTypes["PaymentMethodCreateInput"]},ValueTypes["PaymentMethodCreateResult"]],
deletePaymentMethod?: [{	by: ValueTypes["PaymentMethodUniqueWhere"],	filter?: ValueTypes["PaymentMethodWhere"] | undefined | null},ValueTypes["PaymentMethodDeleteResult"]],
updatePaymentMethod?: [{	by: ValueTypes["PaymentMethodUniqueWhere"],	filter?: ValueTypes["PaymentMethodWhere"] | undefined | null,	data: ValueTypes["PaymentMethodUpdateInput"]},ValueTypes["PaymentMethodUpdateResult"]],
upsertPaymentMethod?: [{	by: ValueTypes["PaymentMethodUniqueWhere"],	filter?: ValueTypes["PaymentMethodWhere"] | undefined | null,	update: ValueTypes["PaymentMethodUpdateInput"],	create: ValueTypes["PaymentMethodCreateInput"]},ValueTypes["PaymentMethodUpsertResult"]],
createVatRate?: [{	data: ValueTypes["VatRateCreateInput"]},ValueTypes["VatRateCreateResult"]],
deleteVatRate?: [{	by: ValueTypes["VatRateUniqueWhere"],	filter?: ValueTypes["VatRateWhere"] | undefined | null},ValueTypes["VatRateDeleteResult"]],
updateVatRate?: [{	by: ValueTypes["VatRateUniqueWhere"],	filter?: ValueTypes["VatRateWhere"] | undefined | null,	data: ValueTypes["VatRateUpdateInput"]},ValueTypes["VatRateUpdateResult"]],
upsertVatRate?: [{	by: ValueTypes["VatRateUniqueWhere"],	filter?: ValueTypes["VatRateWhere"] | undefined | null,	update: ValueTypes["VatRateUpdateInput"],	create: ValueTypes["VatRateCreateInput"]},ValueTypes["VatRateUpsertResult"]],
createProduct?: [{	data: ValueTypes["ProductCreateInput"]},ValueTypes["ProductCreateResult"]],
deleteProduct?: [{	by: ValueTypes["ProductUniqueWhere"],	filter?: ValueTypes["ProductWhere"] | undefined | null},ValueTypes["ProductDeleteResult"]],
updateProduct?: [{	by: ValueTypes["ProductUniqueWhere"],	filter?: ValueTypes["ProductWhere"] | undefined | null,	data: ValueTypes["ProductUpdateInput"]},ValueTypes["ProductUpdateResult"]],
upsertProduct?: [{	by: ValueTypes["ProductUniqueWhere"],	filter?: ValueTypes["ProductWhere"] | undefined | null,	update: ValueTypes["ProductUpdateInput"],	create: ValueTypes["ProductCreateInput"]},ValueTypes["ProductUpsertResult"]],
createProductStock?: [{	data: ValueTypes["ProductStockCreateInput"]},ValueTypes["ProductStockCreateResult"]],
deleteProductStock?: [{	by: ValueTypes["ProductStockUniqueWhere"],	filter?: ValueTypes["ProductStockWhere"] | undefined | null},ValueTypes["ProductStockDeleteResult"]],
updateProductStock?: [{	by: ValueTypes["ProductStockUniqueWhere"],	filter?: ValueTypes["ProductStockWhere"] | undefined | null,	data: ValueTypes["ProductStockUpdateInput"]},ValueTypes["ProductStockUpdateResult"]],
upsertProductStock?: [{	by: ValueTypes["ProductStockUniqueWhere"],	filter?: ValueTypes["ProductStockWhere"] | undefined | null,	update: ValueTypes["ProductStockUpdateInput"],	create: ValueTypes["ProductStockCreateInput"]},ValueTypes["ProductStockUpsertResult"]],
createProductPacking?: [{	data: ValueTypes["ProductPackingCreateInput"]},ValueTypes["ProductPackingCreateResult"]],
deleteProductPacking?: [{	by: ValueTypes["ProductPackingUniqueWhere"],	filter?: ValueTypes["ProductPackingWhere"] | undefined | null},ValueTypes["ProductPackingDeleteResult"]],
updateProductPacking?: [{	by: ValueTypes["ProductPackingUniqueWhere"],	filter?: ValueTypes["ProductPackingWhere"] | undefined | null,	data: ValueTypes["ProductPackingUpdateInput"]},ValueTypes["ProductPackingUpdateResult"]],
upsertProductPacking?: [{	by: ValueTypes["ProductPackingUniqueWhere"],	filter?: ValueTypes["ProductPackingWhere"] | undefined | null,	update: ValueTypes["ProductPackingUpdateInput"],	create: ValueTypes["ProductPackingCreateInput"]},ValueTypes["ProductPackingUpsertResult"]],
createProductGroupPrice?: [{	data: ValueTypes["ProductGroupPriceCreateInput"]},ValueTypes["ProductGroupPriceCreateResult"]],
deleteProductGroupPrice?: [{	by: ValueTypes["ProductGroupPriceUniqueWhere"],	filter?: ValueTypes["ProductGroupPriceWhere"] | undefined | null},ValueTypes["ProductGroupPriceDeleteResult"]],
updateProductGroupPrice?: [{	by: ValueTypes["ProductGroupPriceUniqueWhere"],	filter?: ValueTypes["ProductGroupPriceWhere"] | undefined | null,	data: ValueTypes["ProductGroupPriceUpdateInput"]},ValueTypes["ProductGroupPriceUpdateResult"]],
upsertProductGroupPrice?: [{	by: ValueTypes["ProductGroupPriceUniqueWhere"],	filter?: ValueTypes["ProductGroupPriceWhere"] | undefined | null,	update: ValueTypes["ProductGroupPriceUpdateInput"],	create: ValueTypes["ProductGroupPriceCreateInput"]},ValueTypes["ProductGroupPriceUpsertResult"]],
createProductRecipe?: [{	data: ValueTypes["ProductRecipeCreateInput"]},ValueTypes["ProductRecipeCreateResult"]],
deleteProductRecipe?: [{	by: ValueTypes["ProductRecipeUniqueWhere"],	filter?: ValueTypes["ProductRecipeWhere"] | undefined | null},ValueTypes["ProductRecipeDeleteResult"]],
updateProductRecipe?: [{	by: ValueTypes["ProductRecipeUniqueWhere"],	filter?: ValueTypes["ProductRecipeWhere"] | undefined | null,	data: ValueTypes["ProductRecipeUpdateInput"]},ValueTypes["ProductRecipeUpdateResult"]],
upsertProductRecipe?: [{	by: ValueTypes["ProductRecipeUniqueWhere"],	filter?: ValueTypes["ProductRecipeWhere"] | undefined | null,	update: ValueTypes["ProductRecipeUpdateInput"],	create: ValueTypes["ProductRecipeCreateInput"]},ValueTypes["ProductRecipeUpsertResult"]],
createProductCategory?: [{	data: ValueTypes["ProductCategoryCreateInput"]},ValueTypes["ProductCategoryCreateResult"]],
deleteProductCategory?: [{	by: ValueTypes["ProductCategoryUniqueWhere"],	filter?: ValueTypes["ProductCategoryWhere"] | undefined | null},ValueTypes["ProductCategoryDeleteResult"]],
updateProductCategory?: [{	by: ValueTypes["ProductCategoryUniqueWhere"],	filter?: ValueTypes["ProductCategoryWhere"] | undefined | null,	data: ValueTypes["ProductCategoryUpdateInput"]},ValueTypes["ProductCategoryUpdateResult"]],
upsertProductCategory?: [{	by: ValueTypes["ProductCategoryUniqueWhere"],	filter?: ValueTypes["ProductCategoryWhere"] | undefined | null,	update: ValueTypes["ProductCategoryUpdateInput"],	create: ValueTypes["ProductCategoryCreateInput"]},ValueTypes["ProductCategoryUpsertResult"]],
createStore?: [{	data: ValueTypes["StoreCreateInput"]},ValueTypes["StoreCreateResult"]],
deleteStore?: [{	by: ValueTypes["StoreUniqueWhere"],	filter?: ValueTypes["StoreWhere"] | undefined | null},ValueTypes["StoreDeleteResult"]],
updateStore?: [{	by: ValueTypes["StoreUniqueWhere"],	filter?: ValueTypes["StoreWhere"] | undefined | null,	data: ValueTypes["StoreUpdateInput"]},ValueTypes["StoreUpdateResult"]],
upsertStore?: [{	by: ValueTypes["StoreUniqueWhere"],	filter?: ValueTypes["StoreWhere"] | undefined | null,	update: ValueTypes["StoreUpdateInput"],	create: ValueTypes["StoreCreateInput"]},ValueTypes["StoreUpsertResult"]],
createTag?: [{	data: ValueTypes["TagCreateInput"]},ValueTypes["TagCreateResult"]],
deleteTag?: [{	by: ValueTypes["TagUniqueWhere"],	filter?: ValueTypes["TagWhere"] | undefined | null},ValueTypes["TagDeleteResult"]],
updateTag?: [{	by: ValueTypes["TagUniqueWhere"],	filter?: ValueTypes["TagWhere"] | undefined | null,	data: ValueTypes["TagUpdateInput"]},ValueTypes["TagUpdateResult"]],
upsertTag?: [{	by: ValueTypes["TagUniqueWhere"],	filter?: ValueTypes["TagWhere"] | undefined | null,	update: ValueTypes["TagUpdateInput"],	create: ValueTypes["TagCreateInput"]},ValueTypes["TagUpsertResult"]],
createImage?: [{	data: ValueTypes["ImageCreateInput"]},ValueTypes["ImageCreateResult"]],
deleteImage?: [{	by: ValueTypes["ImageUniqueWhere"],	filter?: ValueTypes["ImageWhere"] | undefined | null},ValueTypes["ImageDeleteResult"]],
updateImage?: [{	by: ValueTypes["ImageUniqueWhere"],	filter?: ValueTypes["ImageWhere"] | undefined | null,	data: ValueTypes["ImageUpdateInput"]},ValueTypes["ImageUpdateResult"]],
upsertImage?: [{	by: ValueTypes["ImageUniqueWhere"],	filter?: ValueTypes["ImageWhere"] | undefined | null,	update: ValueTypes["ImageUpdateInput"],	create: ValueTypes["ImageCreateInput"]},ValueTypes["ImageUpsertResult"]],
createBusinessCategory?: [{	data: ValueTypes["BusinessCategoryCreateInput"]},ValueTypes["BusinessCategoryCreateResult"]],
deleteBusinessCategory?: [{	by: ValueTypes["BusinessCategoryUniqueWhere"],	filter?: ValueTypes["BusinessCategoryWhere"] | undefined | null},ValueTypes["BusinessCategoryDeleteResult"]],
updateBusinessCategory?: [{	by: ValueTypes["BusinessCategoryUniqueWhere"],	filter?: ValueTypes["BusinessCategoryWhere"] | undefined | null,	data: ValueTypes["BusinessCategoryUpdateInput"]},ValueTypes["BusinessCategoryUpdateResult"]],
upsertBusinessCategory?: [{	by: ValueTypes["BusinessCategoryUniqueWhere"],	filter?: ValueTypes["BusinessCategoryWhere"] | undefined | null,	update: ValueTypes["BusinessCategoryUpdateInput"],	create: ValueTypes["BusinessCategoryCreateInput"]},ValueTypes["BusinessCategoryUpsertResult"]],
createProductList?: [{	data: ValueTypes["ProductListCreateInput"]},ValueTypes["ProductListCreateResult"]],
deleteProductList?: [{	by: ValueTypes["ProductListUniqueWhere"],	filter?: ValueTypes["ProductListWhere"] | undefined | null},ValueTypes["ProductListDeleteResult"]],
updateProductList?: [{	by: ValueTypes["ProductListUniqueWhere"],	filter?: ValueTypes["ProductListWhere"] | undefined | null,	data: ValueTypes["ProductListUpdateInput"]},ValueTypes["ProductListUpdateResult"]],
upsertProductList?: [{	by: ValueTypes["ProductListUniqueWhere"],	filter?: ValueTypes["ProductListWhere"] | undefined | null,	update: ValueTypes["ProductListUpdateInput"],	create: ValueTypes["ProductListCreateInput"]},ValueTypes["ProductListUpsertResult"]],
createProductListItem?: [{	data: ValueTypes["ProductListItemCreateInput"]},ValueTypes["ProductListItemCreateResult"]],
deleteProductListItem?: [{	by: ValueTypes["ProductListItemUniqueWhere"],	filter?: ValueTypes["ProductListItemWhere"] | undefined | null},ValueTypes["ProductListItemDeleteResult"]],
updateProductListItem?: [{	by: ValueTypes["ProductListItemUniqueWhere"],	filter?: ValueTypes["ProductListItemWhere"] | undefined | null,	data: ValueTypes["ProductListItemUpdateInput"]},ValueTypes["ProductListItemUpdateResult"]],
upsertProductListItem?: [{	by: ValueTypes["ProductListItemUniqueWhere"],	filter?: ValueTypes["ProductListItemWhere"] | undefined | null,	update: ValueTypes["ProductListItemUpdateInput"],	create: ValueTypes["ProductListItemCreateInput"]},ValueTypes["ProductListItemUpsertResult"]],
createProductCategoryList?: [{	data: ValueTypes["ProductCategoryListCreateInput"]},ValueTypes["ProductCategoryListCreateResult"]],
deleteProductCategoryList?: [{	by: ValueTypes["ProductCategoryListUniqueWhere"],	filter?: ValueTypes["ProductCategoryListWhere"] | undefined | null},ValueTypes["ProductCategoryListDeleteResult"]],
updateProductCategoryList?: [{	by: ValueTypes["ProductCategoryListUniqueWhere"],	filter?: ValueTypes["ProductCategoryListWhere"] | undefined | null,	data: ValueTypes["ProductCategoryListUpdateInput"]},ValueTypes["ProductCategoryListUpdateResult"]],
upsertProductCategoryList?: [{	by: ValueTypes["ProductCategoryListUniqueWhere"],	filter?: ValueTypes["ProductCategoryListWhere"] | undefined | null,	update: ValueTypes["ProductCategoryListUpdateInput"],	create: ValueTypes["ProductCategoryListCreateInput"]},ValueTypes["ProductCategoryListUpsertResult"]],
createProductCategoryListItem?: [{	data: ValueTypes["ProductCategoryListItemCreateInput"]},ValueTypes["ProductCategoryListItemCreateResult"]],
deleteProductCategoryListItem?: [{	by: ValueTypes["ProductCategoryListItemUniqueWhere"],	filter?: ValueTypes["ProductCategoryListItemWhere"] | undefined | null},ValueTypes["ProductCategoryListItemDeleteResult"]],
updateProductCategoryListItem?: [{	by: ValueTypes["ProductCategoryListItemUniqueWhere"],	filter?: ValueTypes["ProductCategoryListItemWhere"] | undefined | null,	data: ValueTypes["ProductCategoryListItemUpdateInput"]},ValueTypes["ProductCategoryListItemUpdateResult"]],
upsertProductCategoryListItem?: [{	by: ValueTypes["ProductCategoryListItemUniqueWhere"],	filter?: ValueTypes["ProductCategoryListItemWhere"] | undefined | null,	update: ValueTypes["ProductCategoryListItemUpdateInput"],	create: ValueTypes["ProductCategoryListItemCreateInput"]},ValueTypes["ProductCategoryListItemUpsertResult"]],
createBusinessCategoryLocale?: [{	data: ValueTypes["BusinessCategoryLocaleCreateInput"]},ValueTypes["BusinessCategoryLocaleCreateResult"]],
deleteBusinessCategoryLocale?: [{	by: ValueTypes["BusinessCategoryLocaleUniqueWhere"],	filter?: ValueTypes["BusinessCategoryLocaleWhere"] | undefined | null},ValueTypes["BusinessCategoryLocaleDeleteResult"]],
updateBusinessCategoryLocale?: [{	by: ValueTypes["BusinessCategoryLocaleUniqueWhere"],	filter?: ValueTypes["BusinessCategoryLocaleWhere"] | undefined | null,	data: ValueTypes["BusinessCategoryLocaleUpdateInput"]},ValueTypes["BusinessCategoryLocaleUpdateResult"]],
upsertBusinessCategoryLocale?: [{	by: ValueTypes["BusinessCategoryLocaleUniqueWhere"],	filter?: ValueTypes["BusinessCategoryLocaleWhere"] | undefined | null,	update: ValueTypes["BusinessCategoryLocaleUpdateInput"],	create: ValueTypes["BusinessCategoryLocaleCreateInput"]},ValueTypes["BusinessCategoryLocaleUpsertResult"]],
createLocale?: [{	data: ValueTypes["LocaleCreateInput"]},ValueTypes["LocaleCreateResult"]],
deleteLocale?: [{	by: ValueTypes["LocaleUniqueWhere"],	filter?: ValueTypes["LocaleWhere"] | undefined | null},ValueTypes["LocaleDeleteResult"]],
updateLocale?: [{	by: ValueTypes["LocaleUniqueWhere"],	filter?: ValueTypes["LocaleWhere"] | undefined | null,	data: ValueTypes["LocaleUpdateInput"]},ValueTypes["LocaleUpdateResult"]],
upsertLocale?: [{	by: ValueTypes["LocaleUniqueWhere"],	filter?: ValueTypes["LocaleWhere"] | undefined | null,	update: ValueTypes["LocaleUpdateInput"],	create: ValueTypes["LocaleCreateInput"]},ValueTypes["LocaleUpsertResult"]],
createProductCategoryListLocale?: [{	data: ValueTypes["ProductCategoryListLocaleCreateInput"]},ValueTypes["ProductCategoryListLocaleCreateResult"]],
deleteProductCategoryListLocale?: [{	by: ValueTypes["ProductCategoryListLocaleUniqueWhere"],	filter?: ValueTypes["ProductCategoryListLocaleWhere"] | undefined | null},ValueTypes["ProductCategoryListLocaleDeleteResult"]],
updateProductCategoryListLocale?: [{	by: ValueTypes["ProductCategoryListLocaleUniqueWhere"],	filter?: ValueTypes["ProductCategoryListLocaleWhere"] | undefined | null,	data: ValueTypes["ProductCategoryListLocaleUpdateInput"]},ValueTypes["ProductCategoryListLocaleUpdateResult"]],
upsertProductCategoryListLocale?: [{	by: ValueTypes["ProductCategoryListLocaleUniqueWhere"],	filter?: ValueTypes["ProductCategoryListLocaleWhere"] | undefined | null,	update: ValueTypes["ProductCategoryListLocaleUpdateInput"],	create: ValueTypes["ProductCategoryListLocaleCreateInput"]},ValueTypes["ProductCategoryListLocaleUpsertResult"]],
createCustomerName?: [{	data: ValueTypes["CustomerNameCreateInput"]},ValueTypes["CustomerNameCreateResult"]],
deleteCustomerName?: [{	by: ValueTypes["CustomerNameUniqueWhere"],	filter?: ValueTypes["CustomerNameWhere"] | undefined | null},ValueTypes["CustomerNameDeleteResult"]],
updateCustomerName?: [{	by: ValueTypes["CustomerNameUniqueWhere"],	filter?: ValueTypes["CustomerNameWhere"] | undefined | null,	data: ValueTypes["CustomerNameUpdateInput"]},ValueTypes["CustomerNameUpdateResult"]],
upsertCustomerName?: [{	by: ValueTypes["CustomerNameUniqueWhere"],	filter?: ValueTypes["CustomerNameWhere"] | undefined | null,	update: ValueTypes["CustomerNameUpdateInput"],	create: ValueTypes["CustomerNameCreateInput"]},ValueTypes["CustomerNameUpsertResult"]],
createCustomerAlias?: [{	data: ValueTypes["CustomerAliasCreateInput"]},ValueTypes["CustomerAliasCreateResult"]],
deleteCustomerAlias?: [{	by: ValueTypes["CustomerAliasUniqueWhere"],	filter?: ValueTypes["CustomerAliasWhere"] | undefined | null},ValueTypes["CustomerAliasDeleteResult"]],
updateCustomerAlias?: [{	by: ValueTypes["CustomerAliasUniqueWhere"],	filter?: ValueTypes["CustomerAliasWhere"] | undefined | null,	data: ValueTypes["CustomerAliasUpdateInput"]},ValueTypes["CustomerAliasUpdateResult"]],
upsertCustomerAlias?: [{	by: ValueTypes["CustomerAliasUniqueWhere"],	filter?: ValueTypes["CustomerAliasWhere"] | undefined | null,	update: ValueTypes["CustomerAliasUpdateInput"],	create: ValueTypes["CustomerAliasCreateInput"]},ValueTypes["CustomerAliasUpsertResult"]],
createProductIngredientItem?: [{	data: ValueTypes["ProductIngredientItemCreateInput"]},ValueTypes["ProductIngredientItemCreateResult"]],
deleteProductIngredientItem?: [{	by: ValueTypes["ProductIngredientItemUniqueWhere"],	filter?: ValueTypes["ProductIngredientItemWhere"] | undefined | null},ValueTypes["ProductIngredientItemDeleteResult"]],
updateProductIngredientItem?: [{	by: ValueTypes["ProductIngredientItemUniqueWhere"],	filter?: ValueTypes["ProductIngredientItemWhere"] | undefined | null,	data: ValueTypes["ProductIngredientItemUpdateInput"]},ValueTypes["ProductIngredientItemUpdateResult"]],
upsertProductIngredientItem?: [{	by: ValueTypes["ProductIngredientItemUniqueWhere"],	filter?: ValueTypes["ProductIngredientItemWhere"] | undefined | null,	update: ValueTypes["ProductIngredientItemUpdateInput"],	create: ValueTypes["ProductIngredientItemCreateInput"]},ValueTypes["ProductIngredientItemUpsertResult"]],
createProductIngredientItemQuantity?: [{	data: ValueTypes["ProductIngredientItemQuantityCreateInput"]},ValueTypes["ProductIngredientItemQuantityCreateResult"]],
deleteProductIngredientItemQuantity?: [{	by: ValueTypes["ProductIngredientItemQuantityUniqueWhere"],	filter?: ValueTypes["ProductIngredientItemQuantityWhere"] | undefined | null},ValueTypes["ProductIngredientItemQuantityDeleteResult"]],
updateProductIngredientItemQuantity?: [{	by: ValueTypes["ProductIngredientItemQuantityUniqueWhere"],	filter?: ValueTypes["ProductIngredientItemQuantityWhere"] | undefined | null,	data: ValueTypes["ProductIngredientItemQuantityUpdateInput"]},ValueTypes["ProductIngredientItemQuantityUpdateResult"]],
upsertProductIngredientItemQuantity?: [{	by: ValueTypes["ProductIngredientItemQuantityUniqueWhere"],	filter?: ValueTypes["ProductIngredientItemQuantityWhere"] | undefined | null,	update: ValueTypes["ProductIngredientItemQuantityUpdateInput"],	create: ValueTypes["ProductIngredientItemQuantityCreateInput"]},ValueTypes["ProductIngredientItemQuantityUpsertResult"]],
createProductIngredientItemQuantityUnit?: [{	data: ValueTypes["ProductIngredientItemQuantityUnitCreateInput"]},ValueTypes["ProductIngredientItemQuantityUnitCreateResult"]],
deleteProductIngredientItemQuantityUnit?: [{	by: ValueTypes["ProductIngredientItemQuantityUnitUniqueWhere"],	filter?: ValueTypes["ProductIngredientItemQuantityUnitWhere"] | undefined | null},ValueTypes["ProductIngredientItemQuantityUnitDeleteResult"]],
updateProductIngredientItemQuantityUnit?: [{	by: ValueTypes["ProductIngredientItemQuantityUnitUniqueWhere"],	filter?: ValueTypes["ProductIngredientItemQuantityUnitWhere"] | undefined | null,	data: ValueTypes["ProductIngredientItemQuantityUnitUpdateInput"]},ValueTypes["ProductIngredientItemQuantityUnitUpdateResult"]],
upsertProductIngredientItemQuantityUnit?: [{	by: ValueTypes["ProductIngredientItemQuantityUnitUniqueWhere"],	filter?: ValueTypes["ProductIngredientItemQuantityUnitWhere"] | undefined | null,	update: ValueTypes["ProductIngredientItemQuantityUnitUpdateInput"],	create: ValueTypes["ProductIngredientItemQuantityUnitCreateInput"]},ValueTypes["ProductIngredientItemQuantityUnitUpsertResult"]],
createProductIngredient?: [{	data: ValueTypes["ProductIngredientCreateInput"]},ValueTypes["ProductIngredientCreateResult"]],
deleteProductIngredient?: [{	by: ValueTypes["ProductIngredientUniqueWhere"],	filter?: ValueTypes["ProductIngredientWhere"] | undefined | null},ValueTypes["ProductIngredientDeleteResult"]],
updateProductIngredient?: [{	by: ValueTypes["ProductIngredientUniqueWhere"],	filter?: ValueTypes["ProductIngredientWhere"] | undefined | null,	data: ValueTypes["ProductIngredientUpdateInput"]},ValueTypes["ProductIngredientUpdateResult"]],
upsertProductIngredient?: [{	by: ValueTypes["ProductIngredientUniqueWhere"],	filter?: ValueTypes["ProductIngredientWhere"] | undefined | null,	update: ValueTypes["ProductIngredientUpdateInput"],	create: ValueTypes["ProductIngredientCreateInput"]},ValueTypes["ProductIngredientUpsertResult"]],
createCustomerIngredientRating?: [{	data: ValueTypes["CustomerIngredientRatingCreateInput"]},ValueTypes["CustomerIngredientRatingCreateResult"]],
deleteCustomerIngredientRating?: [{	by: ValueTypes["CustomerIngredientRatingUniqueWhere"],	filter?: ValueTypes["CustomerIngredientRatingWhere"] | undefined | null},ValueTypes["CustomerIngredientRatingDeleteResult"]],
updateCustomerIngredientRating?: [{	by: ValueTypes["CustomerIngredientRatingUniqueWhere"],	filter?: ValueTypes["CustomerIngredientRatingWhere"] | undefined | null,	data: ValueTypes["CustomerIngredientRatingUpdateInput"]},ValueTypes["CustomerIngredientRatingUpdateResult"]],
upsertCustomerIngredientRating?: [{	by: ValueTypes["CustomerIngredientRatingUniqueWhere"],	filter?: ValueTypes["CustomerIngredientRatingWhere"] | undefined | null,	update: ValueTypes["CustomerIngredientRatingUpdateInput"],	create: ValueTypes["CustomerIngredientRatingCreateInput"]},ValueTypes["CustomerIngredientRatingUpsertResult"]],
createProductIngredientRating?: [{	data: ValueTypes["ProductIngredientRatingCreateInput"]},ValueTypes["ProductIngredientRatingCreateResult"]],
deleteProductIngredientRating?: [{	by: ValueTypes["ProductIngredientRatingUniqueWhere"],	filter?: ValueTypes["ProductIngredientRatingWhere"] | undefined | null},ValueTypes["ProductIngredientRatingDeleteResult"]],
updateProductIngredientRating?: [{	by: ValueTypes["ProductIngredientRatingUniqueWhere"],	filter?: ValueTypes["ProductIngredientRatingWhere"] | undefined | null,	data: ValueTypes["ProductIngredientRatingUpdateInput"]},ValueTypes["ProductIngredientRatingUpdateResult"]],
upsertProductIngredientRating?: [{	by: ValueTypes["ProductIngredientRatingUniqueWhere"],	filter?: ValueTypes["ProductIngredientRatingWhere"] | undefined | null,	update: ValueTypes["ProductIngredientRatingUpdateInput"],	create: ValueTypes["ProductIngredientRatingCreateInput"]},ValueTypes["ProductIngredientRatingUpsertResult"]],
createProductIngredientLocale?: [{	data: ValueTypes["ProductIngredientLocaleCreateInput"]},ValueTypes["ProductIngredientLocaleCreateResult"]],
deleteProductIngredientLocale?: [{	by: ValueTypes["ProductIngredientLocaleUniqueWhere"],	filter?: ValueTypes["ProductIngredientLocaleWhere"] | undefined | null},ValueTypes["ProductIngredientLocaleDeleteResult"]],
updateProductIngredientLocale?: [{	by: ValueTypes["ProductIngredientLocaleUniqueWhere"],	filter?: ValueTypes["ProductIngredientLocaleWhere"] | undefined | null,	data: ValueTypes["ProductIngredientLocaleUpdateInput"]},ValueTypes["ProductIngredientLocaleUpdateResult"]],
upsertProductIngredientLocale?: [{	by: ValueTypes["ProductIngredientLocaleUniqueWhere"],	filter?: ValueTypes["ProductIngredientLocaleWhere"] | undefined | null,	update: ValueTypes["ProductIngredientLocaleUpdateInput"],	create: ValueTypes["ProductIngredientLocaleCreateInput"]},ValueTypes["ProductIngredientLocaleUpsertResult"]],
createOrderRecurrence?: [{	data: ValueTypes["OrderRecurrenceCreateInput"]},ValueTypes["OrderRecurrenceCreateResult"]],
deleteOrderRecurrence?: [{	by: ValueTypes["OrderRecurrenceUniqueWhere"],	filter?: ValueTypes["OrderRecurrenceWhere"] | undefined | null},ValueTypes["OrderRecurrenceDeleteResult"]],
updateOrderRecurrence?: [{	by: ValueTypes["OrderRecurrenceUniqueWhere"],	filter?: ValueTypes["OrderRecurrenceWhere"] | undefined | null,	data: ValueTypes["OrderRecurrenceUpdateInput"]},ValueTypes["OrderRecurrenceUpdateResult"]],
upsertOrderRecurrence?: [{	by: ValueTypes["OrderRecurrenceUniqueWhere"],	filter?: ValueTypes["OrderRecurrenceWhere"] | undefined | null,	update: ValueTypes["OrderRecurrenceUpdateInput"],	create: ValueTypes["OrderRecurrenceCreateInput"]},ValueTypes["OrderRecurrenceUpsertResult"]],
createOrderRecurrenceLocale?: [{	data: ValueTypes["OrderRecurrenceLocaleCreateInput"]},ValueTypes["OrderRecurrenceLocaleCreateResult"]],
deleteOrderRecurrenceLocale?: [{	by: ValueTypes["OrderRecurrenceLocaleUniqueWhere"],	filter?: ValueTypes["OrderRecurrenceLocaleWhere"] | undefined | null},ValueTypes["OrderRecurrenceLocaleDeleteResult"]],
updateOrderRecurrenceLocale?: [{	by: ValueTypes["OrderRecurrenceLocaleUniqueWhere"],	filter?: ValueTypes["OrderRecurrenceLocaleWhere"] | undefined | null,	data: ValueTypes["OrderRecurrenceLocaleUpdateInput"]},ValueTypes["OrderRecurrenceLocaleUpdateResult"]],
upsertOrderRecurrenceLocale?: [{	by: ValueTypes["OrderRecurrenceLocaleUniqueWhere"],	filter?: ValueTypes["OrderRecurrenceLocaleWhere"] | undefined | null,	update: ValueTypes["OrderRecurrenceLocaleUpdateInput"],	create: ValueTypes["OrderRecurrenceLocaleCreateInput"]},ValueTypes["OrderRecurrenceLocaleUpsertResult"]],
createBusinessCustomer?: [{	data: ValueTypes["BusinessCustomerCreateInput"]},ValueTypes["BusinessCustomerCreateResult"]],
deleteBusinessCustomer?: [{	by: ValueTypes["BusinessCustomerUniqueWhere"],	filter?: ValueTypes["BusinessCustomerWhere"] | undefined | null},ValueTypes["BusinessCustomerDeleteResult"]],
updateBusinessCustomer?: [{	by: ValueTypes["BusinessCustomerUniqueWhere"],	filter?: ValueTypes["BusinessCustomerWhere"] | undefined | null,	data: ValueTypes["BusinessCustomerUpdateInput"]},ValueTypes["BusinessCustomerUpdateResult"]],
upsertBusinessCustomer?: [{	by: ValueTypes["BusinessCustomerUniqueWhere"],	filter?: ValueTypes["BusinessCustomerWhere"] | undefined | null,	update: ValueTypes["BusinessCustomerUpdateInput"],	create: ValueTypes["BusinessCustomerCreateInput"]},ValueTypes["BusinessCustomerUpsertResult"]],
createPointOfSale?: [{	data: ValueTypes["PointOfSaleCreateInput"]},ValueTypes["PointOfSaleCreateResult"]],
deletePointOfSale?: [{	by: ValueTypes["PointOfSaleUniqueWhere"],	filter?: ValueTypes["PointOfSaleWhere"] | undefined | null},ValueTypes["PointOfSaleDeleteResult"]],
updatePointOfSale?: [{	by: ValueTypes["PointOfSaleUniqueWhere"],	filter?: ValueTypes["PointOfSaleWhere"] | undefined | null,	data: ValueTypes["PointOfSaleUpdateInput"]},ValueTypes["PointOfSaleUpdateResult"]],
upsertPointOfSale?: [{	by: ValueTypes["PointOfSaleUniqueWhere"],	filter?: ValueTypes["PointOfSaleWhere"] | undefined | null,	update: ValueTypes["PointOfSaleUpdateInput"],	create: ValueTypes["PointOfSaleCreateInput"]},ValueTypes["PointOfSaleUpsertResult"]],
createStaff?: [{	data: ValueTypes["StaffCreateInput"]},ValueTypes["StaffCreateResult"]],
deleteStaff?: [{	by: ValueTypes["StaffUniqueWhere"],	filter?: ValueTypes["StaffWhere"] | undefined | null},ValueTypes["StaffDeleteResult"]],
updateStaff?: [{	by: ValueTypes["StaffUniqueWhere"],	filter?: ValueTypes["StaffWhere"] | undefined | null,	data: ValueTypes["StaffUpdateInput"]},ValueTypes["StaffUpdateResult"]],
upsertStaff?: [{	by: ValueTypes["StaffUniqueWhere"],	filter?: ValueTypes["StaffWhere"] | undefined | null,	update: ValueTypes["StaffUpdateInput"],	create: ValueTypes["StaffCreateInput"]},ValueTypes["StaffUpsertResult"]],
createBlog?: [{	data: ValueTypes["BlogCreateInput"]},ValueTypes["BlogCreateResult"]],
deleteBlog?: [{	by: ValueTypes["BlogUniqueWhere"],	filter?: ValueTypes["BlogWhere"] | undefined | null},ValueTypes["BlogDeleteResult"]],
updateBlog?: [{	by: ValueTypes["BlogUniqueWhere"],	filter?: ValueTypes["BlogWhere"] | undefined | null,	data: ValueTypes["BlogUpdateInput"]},ValueTypes["BlogUpdateResult"]],
upsertBlog?: [{	by: ValueTypes["BlogUniqueWhere"],	filter?: ValueTypes["BlogWhere"] | undefined | null,	update: ValueTypes["BlogUpdateInput"],	create: ValueTypes["BlogCreateInput"]},ValueTypes["BlogUpsertResult"]],
createBlogLocale?: [{	data: ValueTypes["BlogLocaleCreateInput"]},ValueTypes["BlogLocaleCreateResult"]],
deleteBlogLocale?: [{	by: ValueTypes["BlogLocaleUniqueWhere"],	filter?: ValueTypes["BlogLocaleWhere"] | undefined | null},ValueTypes["BlogLocaleDeleteResult"]],
updateBlogLocale?: [{	by: ValueTypes["BlogLocaleUniqueWhere"],	filter?: ValueTypes["BlogLocaleWhere"] | undefined | null,	data: ValueTypes["BlogLocaleUpdateInput"]},ValueTypes["BlogLocaleUpdateResult"]],
upsertBlogLocale?: [{	by: ValueTypes["BlogLocaleUniqueWhere"],	filter?: ValueTypes["BlogLocaleWhere"] | undefined | null,	update: ValueTypes["BlogLocaleUpdateInput"],	create: ValueTypes["BlogLocaleCreateInput"]},ValueTypes["BlogLocaleUpsertResult"]],
createBlogPost?: [{	data: ValueTypes["BlogPostCreateInput"]},ValueTypes["BlogPostCreateResult"]],
deleteBlogPost?: [{	by: ValueTypes["BlogPostUniqueWhere"],	filter?: ValueTypes["BlogPostWhere"] | undefined | null},ValueTypes["BlogPostDeleteResult"]],
updateBlogPost?: [{	by: ValueTypes["BlogPostUniqueWhere"],	filter?: ValueTypes["BlogPostWhere"] | undefined | null,	data: ValueTypes["BlogPostUpdateInput"]},ValueTypes["BlogPostUpdateResult"]],
upsertBlogPost?: [{	by: ValueTypes["BlogPostUniqueWhere"],	filter?: ValueTypes["BlogPostWhere"] | undefined | null,	update: ValueTypes["BlogPostUpdateInput"],	create: ValueTypes["BlogPostCreateInput"]},ValueTypes["BlogPostUpsertResult"]],
createBlogPostLocale?: [{	data: ValueTypes["BlogPostLocaleCreateInput"]},ValueTypes["BlogPostLocaleCreateResult"]],
deleteBlogPostLocale?: [{	by: ValueTypes["BlogPostLocaleUniqueWhere"],	filter?: ValueTypes["BlogPostLocaleWhere"] | undefined | null},ValueTypes["BlogPostLocaleDeleteResult"]],
updateBlogPostLocale?: [{	by: ValueTypes["BlogPostLocaleUniqueWhere"],	filter?: ValueTypes["BlogPostLocaleWhere"] | undefined | null,	data: ValueTypes["BlogPostLocaleUpdateInput"]},ValueTypes["BlogPostLocaleUpdateResult"]],
upsertBlogPostLocale?: [{	by: ValueTypes["BlogPostLocaleUniqueWhere"],	filter?: ValueTypes["BlogPostLocaleWhere"] | undefined | null,	update: ValueTypes["BlogPostLocaleUpdateInput"],	create: ValueTypes["BlogPostLocaleCreateInput"]},ValueTypes["BlogPostLocaleUpsertResult"]],
createColorPallete?: [{	data: ValueTypes["ColorPalleteCreateInput"]},ValueTypes["ColorPalleteCreateResult"]],
deleteColorPallete?: [{	by: ValueTypes["ColorPalleteUniqueWhere"],	filter?: ValueTypes["ColorPalleteWhere"] | undefined | null},ValueTypes["ColorPalleteDeleteResult"]],
updateColorPallete?: [{	by: ValueTypes["ColorPalleteUniqueWhere"],	filter?: ValueTypes["ColorPalleteWhere"] | undefined | null,	data: ValueTypes["ColorPalleteUpdateInput"]},ValueTypes["ColorPalleteUpdateResult"]],
upsertColorPallete?: [{	by: ValueTypes["ColorPalleteUniqueWhere"],	filter?: ValueTypes["ColorPalleteWhere"] | undefined | null,	update: ValueTypes["ColorPalleteUpdateInput"],	create: ValueTypes["ColorPalleteCreateInput"]},ValueTypes["ColorPalleteUpsertResult"]],
createContent?: [{	data: ValueTypes["ContentCreateInput"]},ValueTypes["ContentCreateResult"]],
deleteContent?: [{	by: ValueTypes["ContentUniqueWhere"],	filter?: ValueTypes["ContentWhere"] | undefined | null},ValueTypes["ContentDeleteResult"]],
updateContent?: [{	by: ValueTypes["ContentUniqueWhere"],	filter?: ValueTypes["ContentWhere"] | undefined | null,	data: ValueTypes["ContentUpdateInput"]},ValueTypes["ContentUpdateResult"]],
upsertContent?: [{	by: ValueTypes["ContentUniqueWhere"],	filter?: ValueTypes["ContentWhere"] | undefined | null,	update: ValueTypes["ContentUpdateInput"],	create: ValueTypes["ContentCreateInput"]},ValueTypes["ContentUpsertResult"]],
createContentBlock?: [{	data: ValueTypes["ContentBlockCreateInput"]},ValueTypes["ContentBlockCreateResult"]],
deleteContentBlock?: [{	by: ValueTypes["ContentBlockUniqueWhere"],	filter?: ValueTypes["ContentBlockWhere"] | undefined | null},ValueTypes["ContentBlockDeleteResult"]],
updateContentBlock?: [{	by: ValueTypes["ContentBlockUniqueWhere"],	filter?: ValueTypes["ContentBlockWhere"] | undefined | null,	data: ValueTypes["ContentBlockUpdateInput"]},ValueTypes["ContentBlockUpdateResult"]],
upsertContentBlock?: [{	by: ValueTypes["ContentBlockUniqueWhere"],	filter?: ValueTypes["ContentBlockWhere"] | undefined | null,	update: ValueTypes["ContentBlockUpdateInput"],	create: ValueTypes["ContentBlockCreateInput"]},ValueTypes["ContentBlockUpsertResult"]],
createContentReference?: [{	data: ValueTypes["ContentReferenceCreateInput"]},ValueTypes["ContentReferenceCreateResult"]],
deleteContentReference?: [{	by: ValueTypes["ContentReferenceUniqueWhere"],	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null},ValueTypes["ContentReferenceDeleteResult"]],
updateContentReference?: [{	by: ValueTypes["ContentReferenceUniqueWhere"],	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null,	data: ValueTypes["ContentReferenceUpdateInput"]},ValueTypes["ContentReferenceUpdateResult"]],
upsertContentReference?: [{	by: ValueTypes["ContentReferenceUniqueWhere"],	filter?: ValueTypes["ContentReferenceWhere"] | undefined | null,	update: ValueTypes["ContentReferenceUpdateInput"],	create: ValueTypes["ContentReferenceCreateInput"]},ValueTypes["ContentReferenceUpsertResult"]],
createBlogPostList?: [{	data: ValueTypes["BlogPostListCreateInput"]},ValueTypes["BlogPostListCreateResult"]],
deleteBlogPostList?: [{	by: ValueTypes["BlogPostListUniqueWhere"],	filter?: ValueTypes["BlogPostListWhere"] | undefined | null},ValueTypes["BlogPostListDeleteResult"]],
updateBlogPostList?: [{	by: ValueTypes["BlogPostListUniqueWhere"],	filter?: ValueTypes["BlogPostListWhere"] | undefined | null,	data: ValueTypes["BlogPostListUpdateInput"]},ValueTypes["BlogPostListUpdateResult"]],
upsertBlogPostList?: [{	by: ValueTypes["BlogPostListUniqueWhere"],	filter?: ValueTypes["BlogPostListWhere"] | undefined | null,	update: ValueTypes["BlogPostListUpdateInput"],	create: ValueTypes["BlogPostListCreateInput"]},ValueTypes["BlogPostListUpsertResult"]],
createBlogPostListItem?: [{	data: ValueTypes["BlogPostListItemCreateInput"]},ValueTypes["BlogPostListItemCreateResult"]],
deleteBlogPostListItem?: [{	by: ValueTypes["BlogPostListItemUniqueWhere"],	filter?: ValueTypes["BlogPostListItemWhere"] | undefined | null},ValueTypes["BlogPostListItemDeleteResult"]],
updateBlogPostListItem?: [{	by: ValueTypes["BlogPostListItemUniqueWhere"],	filter?: ValueTypes["BlogPostListItemWhere"] | undefined | null,	data: ValueTypes["BlogPostListItemUpdateInput"]},ValueTypes["BlogPostListItemUpdateResult"]],
upsertBlogPostListItem?: [{	by: ValueTypes["BlogPostListItemUniqueWhere"],	filter?: ValueTypes["BlogPostListItemWhere"] | undefined | null,	update: ValueTypes["BlogPostListItemUpdateInput"],	create: ValueTypes["BlogPostListItemCreateInput"]},ValueTypes["BlogPostListItemUpsertResult"]],
createLinkList?: [{	data: ValueTypes["LinkListCreateInput"]},ValueTypes["LinkListCreateResult"]],
deleteLinkList?: [{	by: ValueTypes["LinkListUniqueWhere"],	filter?: ValueTypes["LinkListWhere"] | undefined | null},ValueTypes["LinkListDeleteResult"]],
updateLinkList?: [{	by: ValueTypes["LinkListUniqueWhere"],	filter?: ValueTypes["LinkListWhere"] | undefined | null,	data: ValueTypes["LinkListUpdateInput"]},ValueTypes["LinkListUpdateResult"]],
upsertLinkList?: [{	by: ValueTypes["LinkListUniqueWhere"],	filter?: ValueTypes["LinkListWhere"] | undefined | null,	update: ValueTypes["LinkListUpdateInput"],	create: ValueTypes["LinkListCreateInput"]},ValueTypes["LinkListUpsertResult"]],
createLinkListItem?: [{	data: ValueTypes["LinkListItemCreateInput"]},ValueTypes["LinkListItemCreateResult"]],
deleteLinkListItem?: [{	by: ValueTypes["LinkListItemUniqueWhere"],	filter?: ValueTypes["LinkListItemWhere"] | undefined | null},ValueTypes["LinkListItemDeleteResult"]],
updateLinkListItem?: [{	by: ValueTypes["LinkListItemUniqueWhere"],	filter?: ValueTypes["LinkListItemWhere"] | undefined | null,	data: ValueTypes["LinkListItemUpdateInput"]},ValueTypes["LinkListItemUpdateResult"]],
upsertLinkListItem?: [{	by: ValueTypes["LinkListItemUniqueWhere"],	filter?: ValueTypes["LinkListItemWhere"] | undefined | null,	update: ValueTypes["LinkListItemUpdateInput"],	create: ValueTypes["LinkListItemCreateInput"]},ValueTypes["LinkListItemUpsertResult"]],
createCover?: [{	data: ValueTypes["CoverCreateInput"]},ValueTypes["CoverCreateResult"]],
deleteCover?: [{	by: ValueTypes["CoverUniqueWhere"],	filter?: ValueTypes["CoverWhere"] | undefined | null},ValueTypes["CoverDeleteResult"]],
updateCover?: [{	by: ValueTypes["CoverUniqueWhere"],	filter?: ValueTypes["CoverWhere"] | undefined | null,	data: ValueTypes["CoverUpdateInput"]},ValueTypes["CoverUpdateResult"]],
upsertCover?: [{	by: ValueTypes["CoverUniqueWhere"],	filter?: ValueTypes["CoverWhere"] | undefined | null,	update: ValueTypes["CoverUpdateInput"],	create: ValueTypes["CoverCreateInput"]},ValueTypes["CoverUpsertResult"]],
createLink?: [{	data: ValueTypes["LinkCreateInput"]},ValueTypes["LinkCreateResult"]],
deleteLink?: [{	by: ValueTypes["LinkUniqueWhere"],	filter?: ValueTypes["LinkWhere"] | undefined | null},ValueTypes["LinkDeleteResult"]],
updateLink?: [{	by: ValueTypes["LinkUniqueWhere"],	filter?: ValueTypes["LinkWhere"] | undefined | null,	data: ValueTypes["LinkUpdateInput"]},ValueTypes["LinkUpdateResult"]],
upsertLink?: [{	by: ValueTypes["LinkUniqueWhere"],	filter?: ValueTypes["LinkWhere"] | undefined | null,	update: ValueTypes["LinkUpdateInput"],	create: ValueTypes["LinkCreateInput"]},ValueTypes["LinkUpsertResult"]],
createLinkable?: [{	data: ValueTypes["LinkableCreateInput"]},ValueTypes["LinkableCreateResult"]],
deleteLinkable?: [{	by: ValueTypes["LinkableUniqueWhere"],	filter?: ValueTypes["LinkableWhere"] | undefined | null},ValueTypes["LinkableDeleteResult"]],
updateLinkable?: [{	by: ValueTypes["LinkableUniqueWhere"],	filter?: ValueTypes["LinkableWhere"] | undefined | null,	data: ValueTypes["LinkableUpdateInput"]},ValueTypes["LinkableUpdateResult"]],
upsertLinkable?: [{	by: ValueTypes["LinkableUniqueWhere"],	filter?: ValueTypes["LinkableWhere"] | undefined | null,	update: ValueTypes["LinkableUpdateInput"],	create: ValueTypes["LinkableCreateInput"]},ValueTypes["LinkableUpsertResult"]],
createMedium?: [{	data: ValueTypes["MediumCreateInput"]},ValueTypes["MediumCreateResult"]],
deleteMedium?: [{	by: ValueTypes["MediumUniqueWhere"],	filter?: ValueTypes["MediumWhere"] | undefined | null},ValueTypes["MediumDeleteResult"]],
updateMedium?: [{	by: ValueTypes["MediumUniqueWhere"],	filter?: ValueTypes["MediumWhere"] | undefined | null,	data: ValueTypes["MediumUpdateInput"]},ValueTypes["MediumUpdateResult"]],
upsertMedium?: [{	by: ValueTypes["MediumUniqueWhere"],	filter?: ValueTypes["MediumWhere"] | undefined | null,	update: ValueTypes["MediumUpdateInput"],	create: ValueTypes["MediumCreateInput"]},ValueTypes["MediumUpsertResult"]],
createVideo?: [{	data: ValueTypes["VideoCreateInput"]},ValueTypes["VideoCreateResult"]],
deleteVideo?: [{	by: ValueTypes["VideoUniqueWhere"],	filter?: ValueTypes["VideoWhere"] | undefined | null},ValueTypes["VideoDeleteResult"]],
updateVideo?: [{	by: ValueTypes["VideoUniqueWhere"],	filter?: ValueTypes["VideoWhere"] | undefined | null,	data: ValueTypes["VideoUpdateInput"]},ValueTypes["VideoUpdateResult"]],
upsertVideo?: [{	by: ValueTypes["VideoUniqueWhere"],	filter?: ValueTypes["VideoWhere"] | undefined | null,	update: ValueTypes["VideoUpdateInput"],	create: ValueTypes["VideoCreateInput"]},ValueTypes["VideoUpsertResult"]],
createSeo?: [{	data: ValueTypes["SeoCreateInput"]},ValueTypes["SeoCreateResult"]],
deleteSeo?: [{	by: ValueTypes["SeoUniqueWhere"],	filter?: ValueTypes["SeoWhere"] | undefined | null},ValueTypes["SeoDeleteResult"]],
updateSeo?: [{	by: ValueTypes["SeoUniqueWhere"],	filter?: ValueTypes["SeoWhere"] | undefined | null,	data: ValueTypes["SeoUpdateInput"]},ValueTypes["SeoUpdateResult"]],
upsertSeo?: [{	by: ValueTypes["SeoUniqueWhere"],	filter?: ValueTypes["SeoWhere"] | undefined | null,	update: ValueTypes["SeoUpdateInput"],	create: ValueTypes["SeoCreateInput"]},ValueTypes["SeoUpsertResult"]],
createProtectedImage?: [{	data: ValueTypes["ProtectedImageCreateInput"]},ValueTypes["ProtectedImageCreateResult"]],
deleteProtectedImage?: [{	by: ValueTypes["ProtectedImageUniqueWhere"],	filter?: ValueTypes["ProtectedImageWhere"] | undefined | null},ValueTypes["ProtectedImageDeleteResult"]],
updateProtectedImage?: [{	by: ValueTypes["ProtectedImageUniqueWhere"],	filter?: ValueTypes["ProtectedImageWhere"] | undefined | null,	data: ValueTypes["ProtectedImageUpdateInput"]},ValueTypes["ProtectedImageUpdateResult"]],
upsertProtectedImage?: [{	by: ValueTypes["ProtectedImageUniqueWhere"],	filter?: ValueTypes["ProtectedImageWhere"] | undefined | null,	update: ValueTypes["ProtectedImageUpdateInput"],	create: ValueTypes["ProtectedImageCreateInput"]},ValueTypes["ProtectedImageUpsertResult"]],
createTranslationDomain?: [{	data: ValueTypes["TranslationDomainCreateInput"]},ValueTypes["TranslationDomainCreateResult"]],
deleteTranslationDomain?: [{	by: ValueTypes["TranslationDomainUniqueWhere"],	filter?: ValueTypes["TranslationDomainWhere"] | undefined | null},ValueTypes["TranslationDomainDeleteResult"]],
updateTranslationDomain?: [{	by: ValueTypes["TranslationDomainUniqueWhere"],	filter?: ValueTypes["TranslationDomainWhere"] | undefined | null,	data: ValueTypes["TranslationDomainUpdateInput"]},ValueTypes["TranslationDomainUpdateResult"]],
upsertTranslationDomain?: [{	by: ValueTypes["TranslationDomainUniqueWhere"],	filter?: ValueTypes["TranslationDomainWhere"] | undefined | null,	update: ValueTypes["TranslationDomainUpdateInput"],	create: ValueTypes["TranslationDomainCreateInput"]},ValueTypes["TranslationDomainUpsertResult"]],
createTranslationCatalogue?: [{	data: ValueTypes["TranslationCatalogueCreateInput"]},ValueTypes["TranslationCatalogueCreateResult"]],
deleteTranslationCatalogue?: [{	by: ValueTypes["TranslationCatalogueUniqueWhere"],	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null},ValueTypes["TranslationCatalogueDeleteResult"]],
updateTranslationCatalogue?: [{	by: ValueTypes["TranslationCatalogueUniqueWhere"],	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null,	data: ValueTypes["TranslationCatalogueUpdateInput"]},ValueTypes["TranslationCatalogueUpdateResult"]],
upsertTranslationCatalogue?: [{	by: ValueTypes["TranslationCatalogueUniqueWhere"],	filter?: ValueTypes["TranslationCatalogueWhere"] | undefined | null,	update: ValueTypes["TranslationCatalogueUpdateInput"],	create: ValueTypes["TranslationCatalogueCreateInput"]},ValueTypes["TranslationCatalogueUpsertResult"]],
createTranslationKey?: [{	data: ValueTypes["TranslationKeyCreateInput"]},ValueTypes["TranslationKeyCreateResult"]],
deleteTranslationKey?: [{	by: ValueTypes["TranslationKeyUniqueWhere"],	filter?: ValueTypes["TranslationKeyWhere"] | undefined | null},ValueTypes["TranslationKeyDeleteResult"]],
updateTranslationKey?: [{	by: ValueTypes["TranslationKeyUniqueWhere"],	filter?: ValueTypes["TranslationKeyWhere"] | undefined | null,	data: ValueTypes["TranslationKeyUpdateInput"]},ValueTypes["TranslationKeyUpdateResult"]],
upsertTranslationKey?: [{	by: ValueTypes["TranslationKeyUniqueWhere"],	filter?: ValueTypes["TranslationKeyWhere"] | undefined | null,	update: ValueTypes["TranslationKeyUpdateInput"],	create: ValueTypes["TranslationKeyCreateInput"]},ValueTypes["TranslationKeyUpsertResult"]],
createTranslationValue?: [{	data: ValueTypes["TranslationValueCreateInput"]},ValueTypes["TranslationValueCreateResult"]],
deleteTranslationValue?: [{	by: ValueTypes["TranslationValueUniqueWhere"],	filter?: ValueTypes["TranslationValueWhere"] | undefined | null},ValueTypes["TranslationValueDeleteResult"]],
updateTranslationValue?: [{	by: ValueTypes["TranslationValueUniqueWhere"],	filter?: ValueTypes["TranslationValueWhere"] | undefined | null,	data: ValueTypes["TranslationValueUpdateInput"]},ValueTypes["TranslationValueUpdateResult"]],
upsertTranslationValue?: [{	by: ValueTypes["TranslationValueUniqueWhere"],	filter?: ValueTypes["TranslationValueWhere"] | undefined | null,	update: ValueTypes["TranslationValueUpdateInput"],	create: ValueTypes["TranslationValueCreateInput"]},ValueTypes["TranslationValueUpsertResult"]],
createTranslationCataloguesIdentifier?: [{	data: ValueTypes["TranslationCataloguesIdentifierCreateInput"]},ValueTypes["TranslationCataloguesIdentifierCreateResult"]],
deleteTranslationCataloguesIdentifier?: [{	by: ValueTypes["TranslationCataloguesIdentifierUniqueWhere"],	filter?: ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null},ValueTypes["TranslationCataloguesIdentifierDeleteResult"]],
updateTranslationCataloguesIdentifier?: [{	by: ValueTypes["TranslationCataloguesIdentifierUniqueWhere"],	filter?: ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null,	data: ValueTypes["TranslationCataloguesIdentifierUpdateInput"]},ValueTypes["TranslationCataloguesIdentifierUpdateResult"]],
upsertTranslationCataloguesIdentifier?: [{	by: ValueTypes["TranslationCataloguesIdentifierUniqueWhere"],	filter?: ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null,	update: ValueTypes["TranslationCataloguesIdentifierUpdateInput"],	create: ValueTypes["TranslationCataloguesIdentifierCreateInput"]},ValueTypes["TranslationCataloguesIdentifierUpsertResult"]],
createSocialsAndApps?: [{	data: ValueTypes["SocialsAndAppsCreateInput"]},ValueTypes["SocialsAndAppsCreateResult"]],
deleteSocialsAndApps?: [{	by: ValueTypes["SocialsAndAppsUniqueWhere"],	filter?: ValueTypes["SocialsAndAppsWhere"] | undefined | null},ValueTypes["SocialsAndAppsDeleteResult"]],
updateSocialsAndApps?: [{	by: ValueTypes["SocialsAndAppsUniqueWhere"],	filter?: ValueTypes["SocialsAndAppsWhere"] | undefined | null,	data: ValueTypes["SocialsAndAppsUpdateInput"]},ValueTypes["SocialsAndAppsUpdateResult"]],
upsertSocialsAndApps?: [{	by: ValueTypes["SocialsAndAppsUniqueWhere"],	filter?: ValueTypes["SocialsAndAppsWhere"] | undefined | null,	update: ValueTypes["SocialsAndAppsUpdateInput"],	create: ValueTypes["SocialsAndAppsCreateInput"]},ValueTypes["SocialsAndAppsUpsertResult"]],
createProductGrid?: [{	data: ValueTypes["ProductGridCreateInput"]},ValueTypes["ProductGridCreateResult"]],
deleteProductGrid?: [{	by: ValueTypes["ProductGridUniqueWhere"],	filter?: ValueTypes["ProductGridWhere"] | undefined | null},ValueTypes["ProductGridDeleteResult"]],
updateProductGrid?: [{	by: ValueTypes["ProductGridUniqueWhere"],	filter?: ValueTypes["ProductGridWhere"] | undefined | null,	data: ValueTypes["ProductGridUpdateInput"]},ValueTypes["ProductGridUpdateResult"]],
upsertProductGrid?: [{	by: ValueTypes["ProductGridUniqueWhere"],	filter?: ValueTypes["ProductGridWhere"] | undefined | null,	update: ValueTypes["ProductGridUpdateInput"],	create: ValueTypes["ProductGridCreateInput"]},ValueTypes["ProductGridUpsertResult"]],
createProductGridItem?: [{	data: ValueTypes["ProductGridItemCreateInput"]},ValueTypes["ProductGridItemCreateResult"]],
deleteProductGridItem?: [{	by: ValueTypes["ProductGridItemUniqueWhere"],	filter?: ValueTypes["ProductGridItemWhere"] | undefined | null},ValueTypes["ProductGridItemDeleteResult"]],
updateProductGridItem?: [{	by: ValueTypes["ProductGridItemUniqueWhere"],	filter?: ValueTypes["ProductGridItemWhere"] | undefined | null,	data: ValueTypes["ProductGridItemUpdateInput"]},ValueTypes["ProductGridItemUpdateResult"]],
upsertProductGridItem?: [{	by: ValueTypes["ProductGridItemUniqueWhere"],	filter?: ValueTypes["ProductGridItemWhere"] | undefined | null,	update: ValueTypes["ProductGridItemUpdateInput"],	create: ValueTypes["ProductGridItemCreateInput"]},ValueTypes["ProductGridItemUpsertResult"]],
createGallery?: [{	data: ValueTypes["GalleryCreateInput"]},ValueTypes["GalleryCreateResult"]],
deleteGallery?: [{	by: ValueTypes["GalleryUniqueWhere"],	filter?: ValueTypes["GalleryWhere"] | undefined | null},ValueTypes["GalleryDeleteResult"]],
updateGallery?: [{	by: ValueTypes["GalleryUniqueWhere"],	filter?: ValueTypes["GalleryWhere"] | undefined | null,	data: ValueTypes["GalleryUpdateInput"]},ValueTypes["GalleryUpdateResult"]],
upsertGallery?: [{	by: ValueTypes["GalleryUniqueWhere"],	filter?: ValueTypes["GalleryWhere"] | undefined | null,	update: ValueTypes["GalleryUpdateInput"],	create: ValueTypes["GalleryCreateInput"]},ValueTypes["GalleryUpsertResult"]],
createGalleryItem?: [{	data: ValueTypes["GalleryItemCreateInput"]},ValueTypes["GalleryItemCreateResult"]],
deleteGalleryItem?: [{	by: ValueTypes["GalleryItemUniqueWhere"],	filter?: ValueTypes["GalleryItemWhere"] | undefined | null},ValueTypes["GalleryItemDeleteResult"]],
updateGalleryItem?: [{	by: ValueTypes["GalleryItemUniqueWhere"],	filter?: ValueTypes["GalleryItemWhere"] | undefined | null,	data: ValueTypes["GalleryItemUpdateInput"]},ValueTypes["GalleryItemUpdateResult"]],
upsertGalleryItem?: [{	by: ValueTypes["GalleryItemUniqueWhere"],	filter?: ValueTypes["GalleryItemWhere"] | undefined | null,	update: ValueTypes["GalleryItemUpdateInput"],	create: ValueTypes["GalleryItemCreateInput"]},ValueTypes["GalleryItemUpsertResult"]],
createHero?: [{	data: ValueTypes["HeroCreateInput"]},ValueTypes["HeroCreateResult"]],
deleteHero?: [{	by: ValueTypes["HeroUniqueWhere"],	filter?: ValueTypes["HeroWhere"] | undefined | null},ValueTypes["HeroDeleteResult"]],
updateHero?: [{	by: ValueTypes["HeroUniqueWhere"],	filter?: ValueTypes["HeroWhere"] | undefined | null,	data: ValueTypes["HeroUpdateInput"]},ValueTypes["HeroUpdateResult"]],
upsertHero?: [{	by: ValueTypes["HeroUniqueWhere"],	filter?: ValueTypes["HeroWhere"] | undefined | null,	update: ValueTypes["HeroUpdateInput"],	create: ValueTypes["HeroCreateInput"]},ValueTypes["HeroUpsertResult"]],
createSiteMenu?: [{	data: ValueTypes["SiteMenuCreateInput"]},ValueTypes["SiteMenuCreateResult"]],
deleteSiteMenu?: [{	by: ValueTypes["SiteMenuUniqueWhere"],	filter?: ValueTypes["SiteMenuWhere"] | undefined | null},ValueTypes["SiteMenuDeleteResult"]],
updateSiteMenu?: [{	by: ValueTypes["SiteMenuUniqueWhere"],	filter?: ValueTypes["SiteMenuWhere"] | undefined | null,	data: ValueTypes["SiteMenuUpdateInput"]},ValueTypes["SiteMenuUpdateResult"]],
upsertSiteMenu?: [{	by: ValueTypes["SiteMenuUniqueWhere"],	filter?: ValueTypes["SiteMenuWhere"] | undefined | null,	update: ValueTypes["SiteMenuUpdateInput"],	create: ValueTypes["SiteMenuCreateInput"]},ValueTypes["SiteMenuUpsertResult"]],
createMenuLocale?: [{	data: ValueTypes["MenuLocaleCreateInput"]},ValueTypes["MenuLocaleCreateResult"]],
deleteMenuLocale?: [{	by: ValueTypes["MenuLocaleUniqueWhere"],	filter?: ValueTypes["MenuLocaleWhere"] | undefined | null},ValueTypes["MenuLocaleDeleteResult"]],
updateMenuLocale?: [{	by: ValueTypes["MenuLocaleUniqueWhere"],	filter?: ValueTypes["MenuLocaleWhere"] | undefined | null,	data: ValueTypes["MenuLocaleUpdateInput"]},ValueTypes["MenuLocaleUpdateResult"]],
upsertMenuLocale?: [{	by: ValueTypes["MenuLocaleUniqueWhere"],	filter?: ValueTypes["MenuLocaleWhere"] | undefined | null,	update: ValueTypes["MenuLocaleUpdateInput"],	create: ValueTypes["MenuLocaleCreateInput"]},ValueTypes["MenuLocaleUpsertResult"]],
createMenuItem?: [{	data: ValueTypes["MenuItemCreateInput"]},ValueTypes["MenuItemCreateResult"]],
deleteMenuItem?: [{	by: ValueTypes["MenuItemUniqueWhere"],	filter?: ValueTypes["MenuItemWhere"] | undefined | null},ValueTypes["MenuItemDeleteResult"]],
updateMenuItem?: [{	by: ValueTypes["MenuItemUniqueWhere"],	filter?: ValueTypes["MenuItemWhere"] | undefined | null,	data: ValueTypes["MenuItemUpdateInput"]},ValueTypes["MenuItemUpdateResult"]],
upsertMenuItem?: [{	by: ValueTypes["MenuItemUniqueWhere"],	filter?: ValueTypes["MenuItemWhere"] | undefined | null,	update: ValueTypes["MenuItemUpdateInput"],	create: ValueTypes["MenuItemCreateInput"]},ValueTypes["MenuItemUpsertResult"]],
createPage?: [{	data: ValueTypes["PageCreateInput"]},ValueTypes["PageCreateResult"]],
deletePage?: [{	by: ValueTypes["PageUniqueWhere"],	filter?: ValueTypes["PageWhere"] | undefined | null},ValueTypes["PageDeleteResult"]],
updatePage?: [{	by: ValueTypes["PageUniqueWhere"],	filter?: ValueTypes["PageWhere"] | undefined | null,	data: ValueTypes["PageUpdateInput"]},ValueTypes["PageUpdateResult"]],
upsertPage?: [{	by: ValueTypes["PageUniqueWhere"],	filter?: ValueTypes["PageWhere"] | undefined | null,	update: ValueTypes["PageUpdateInput"],	create: ValueTypes["PageCreateInput"]},ValueTypes["PageUpsertResult"]],
createPageLocale?: [{	data: ValueTypes["PageLocaleCreateInput"]},ValueTypes["PageLocaleCreateResult"]],
deletePageLocale?: [{	by: ValueTypes["PageLocaleUniqueWhere"],	filter?: ValueTypes["PageLocaleWhere"] | undefined | null},ValueTypes["PageLocaleDeleteResult"]],
updatePageLocale?: [{	by: ValueTypes["PageLocaleUniqueWhere"],	filter?: ValueTypes["PageLocaleWhere"] | undefined | null,	data: ValueTypes["PageLocaleUpdateInput"]},ValueTypes["PageLocaleUpdateResult"]],
upsertPageLocale?: [{	by: ValueTypes["PageLocaleUniqueWhere"],	filter?: ValueTypes["PageLocaleWhere"] | undefined | null,	update: ValueTypes["PageLocaleUpdateInput"],	create: ValueTypes["PageLocaleCreateInput"]},ValueTypes["PageLocaleUpsertResult"]],
createWikiPage?: [{	data: ValueTypes["WikiPageCreateInput"]},ValueTypes["WikiPageCreateResult"]],
deleteWikiPage?: [{	by: ValueTypes["WikiPageUniqueWhere"],	filter?: ValueTypes["WikiPageWhere"] | undefined | null},ValueTypes["WikiPageDeleteResult"]],
updateWikiPage?: [{	by: ValueTypes["WikiPageUniqueWhere"],	filter?: ValueTypes["WikiPageWhere"] | undefined | null,	data: ValueTypes["WikiPageUpdateInput"]},ValueTypes["WikiPageUpdateResult"]],
upsertWikiPage?: [{	by: ValueTypes["WikiPageUniqueWhere"],	filter?: ValueTypes["WikiPageWhere"] | undefined | null,	update: ValueTypes["WikiPageUpdateInput"],	create: ValueTypes["WikiPageCreateInput"]},ValueTypes["WikiPageUpsertResult"]],
createMenuSubitem?: [{	data: ValueTypes["MenuSubitemCreateInput"]},ValueTypes["MenuSubitemCreateResult"]],
deleteMenuSubitem?: [{	by: ValueTypes["MenuSubitemUniqueWhere"],	filter?: ValueTypes["MenuSubitemWhere"] | undefined | null},ValueTypes["MenuSubitemDeleteResult"]],
updateMenuSubitem?: [{	by: ValueTypes["MenuSubitemUniqueWhere"],	filter?: ValueTypes["MenuSubitemWhere"] | undefined | null,	data: ValueTypes["MenuSubitemUpdateInput"]},ValueTypes["MenuSubitemUpdateResult"]],
upsertMenuSubitem?: [{	by: ValueTypes["MenuSubitemUniqueWhere"],	filter?: ValueTypes["MenuSubitemWhere"] | undefined | null,	update: ValueTypes["MenuSubitemUpdateInput"],	create: ValueTypes["MenuSubitemCreateInput"]},ValueTypes["MenuSubitemUpsertResult"]],
createMenuLinkList?: [{	data: ValueTypes["MenuLinkListCreateInput"]},ValueTypes["MenuLinkListCreateResult"]],
deleteMenuLinkList?: [{	by: ValueTypes["MenuLinkListUniqueWhere"],	filter?: ValueTypes["MenuLinkListWhere"] | undefined | null},ValueTypes["MenuLinkListDeleteResult"]],
updateMenuLinkList?: [{	by: ValueTypes["MenuLinkListUniqueWhere"],	filter?: ValueTypes["MenuLinkListWhere"] | undefined | null,	data: ValueTypes["MenuLinkListUpdateInput"]},ValueTypes["MenuLinkListUpdateResult"]],
upsertMenuLinkList?: [{	by: ValueTypes["MenuLinkListUniqueWhere"],	filter?: ValueTypes["MenuLinkListWhere"] | undefined | null,	update: ValueTypes["MenuLinkListUpdateInput"],	create: ValueTypes["MenuLinkListCreateInput"]},ValueTypes["MenuLinkListUpsertResult"]],
createMenuLinkItem?: [{	data: ValueTypes["MenuLinkItemCreateInput"]},ValueTypes["MenuLinkItemCreateResult"]],
deleteMenuLinkItem?: [{	by: ValueTypes["MenuLinkItemUniqueWhere"],	filter?: ValueTypes["MenuLinkItemWhere"] | undefined | null},ValueTypes["MenuLinkItemDeleteResult"]],
updateMenuLinkItem?: [{	by: ValueTypes["MenuLinkItemUniqueWhere"],	filter?: ValueTypes["MenuLinkItemWhere"] | undefined | null,	data: ValueTypes["MenuLinkItemUpdateInput"]},ValueTypes["MenuLinkItemUpdateResult"]],
upsertMenuLinkItem?: [{	by: ValueTypes["MenuLinkItemUniqueWhere"],	filter?: ValueTypes["MenuLinkItemWhere"] | undefined | null,	update: ValueTypes["MenuLinkItemUpdateInput"],	create: ValueTypes["MenuLinkItemCreateInput"]},ValueTypes["MenuLinkItemUpsertResult"]],
createMenuProducts?: [{	data: ValueTypes["MenuProductsCreateInput"]},ValueTypes["MenuProductsCreateResult"]],
deleteMenuProducts?: [{	by: ValueTypes["MenuProductsUniqueWhere"],	filter?: ValueTypes["MenuProductsWhere"] | undefined | null},ValueTypes["MenuProductsDeleteResult"]],
updateMenuProducts?: [{	by: ValueTypes["MenuProductsUniqueWhere"],	filter?: ValueTypes["MenuProductsWhere"] | undefined | null,	data: ValueTypes["MenuProductsUpdateInput"]},ValueTypes["MenuProductsUpdateResult"]],
upsertMenuProducts?: [{	by: ValueTypes["MenuProductsUniqueWhere"],	filter?: ValueTypes["MenuProductsWhere"] | undefined | null,	update: ValueTypes["MenuProductsUpdateInput"],	create: ValueTypes["MenuProductsCreateInput"]},ValueTypes["MenuProductsUpsertResult"]],
createMenuDelivery?: [{	data: ValueTypes["MenuDeliveryCreateInput"]},ValueTypes["MenuDeliveryCreateResult"]],
deleteMenuDelivery?: [{	by: ValueTypes["MenuDeliveryUniqueWhere"],	filter?: ValueTypes["MenuDeliveryWhere"] | undefined | null},ValueTypes["MenuDeliveryDeleteResult"]],
updateMenuDelivery?: [{	by: ValueTypes["MenuDeliveryUniqueWhere"],	filter?: ValueTypes["MenuDeliveryWhere"] | undefined | null,	data: ValueTypes["MenuDeliveryUpdateInput"]},ValueTypes["MenuDeliveryUpdateResult"]],
upsertMenuDelivery?: [{	by: ValueTypes["MenuDeliveryUniqueWhere"],	filter?: ValueTypes["MenuDeliveryWhere"] | undefined | null,	update: ValueTypes["MenuDeliveryUpdateInput"],	create: ValueTypes["MenuDeliveryCreateInput"]},ValueTypes["MenuDeliveryUpsertResult"]],
createMenuContact?: [{	data: ValueTypes["MenuContactCreateInput"]},ValueTypes["MenuContactCreateResult"]],
deleteMenuContact?: [{	by: ValueTypes["MenuContactUniqueWhere"],	filter?: ValueTypes["MenuContactWhere"] | undefined | null},ValueTypes["MenuContactDeleteResult"]],
updateMenuContact?: [{	by: ValueTypes["MenuContactUniqueWhere"],	filter?: ValueTypes["MenuContactWhere"] | undefined | null,	data: ValueTypes["MenuContactUpdateInput"]},ValueTypes["MenuContactUpdateResult"]],
upsertMenuContact?: [{	by: ValueTypes["MenuContactUniqueWhere"],	filter?: ValueTypes["MenuContactWhere"] | undefined | null,	update: ValueTypes["MenuContactUpdateInput"],	create: ValueTypes["MenuContactCreateInput"]},ValueTypes["MenuContactUpsertResult"]],
createDeadlineTemplate?: [{	data: ValueTypes["DeadlineTemplateCreateInput"]},ValueTypes["DeadlineTemplateCreateResult"]],
deleteDeadlineTemplate?: [{	by: ValueTypes["DeadlineTemplateUniqueWhere"],	filter?: ValueTypes["DeadlineTemplateWhere"] | undefined | null},ValueTypes["DeadlineTemplateDeleteResult"]],
updateDeadlineTemplate?: [{	by: ValueTypes["DeadlineTemplateUniqueWhere"],	filter?: ValueTypes["DeadlineTemplateWhere"] | undefined | null,	data: ValueTypes["DeadlineTemplateUpdateInput"]},ValueTypes["DeadlineTemplateUpdateResult"]],
upsertDeadlineTemplate?: [{	by: ValueTypes["DeadlineTemplateUniqueWhere"],	filter?: ValueTypes["DeadlineTemplateWhere"] | undefined | null,	update: ValueTypes["DeadlineTemplateUpdateInput"],	create: ValueTypes["DeadlineTemplateCreateInput"]},ValueTypes["DeadlineTemplateUpsertResult"]],
createEmployeeQueue?: [{	data: ValueTypes["EmployeeQueueCreateInput"]},ValueTypes["EmployeeQueueCreateResult"]],
deleteEmployeeQueue?: [{	by: ValueTypes["EmployeeQueueUniqueWhere"],	filter?: ValueTypes["EmployeeQueueWhere"] | undefined | null},ValueTypes["EmployeeQueueDeleteResult"]],
updateEmployeeQueue?: [{	by: ValueTypes["EmployeeQueueUniqueWhere"],	filter?: ValueTypes["EmployeeQueueWhere"] | undefined | null,	data: ValueTypes["EmployeeQueueUpdateInput"]},ValueTypes["EmployeeQueueUpdateResult"]],
upsertEmployeeQueue?: [{	by: ValueTypes["EmployeeQueueUniqueWhere"],	filter?: ValueTypes["EmployeeQueueWhere"] | undefined | null,	update: ValueTypes["EmployeeQueueUpdateInput"],	create: ValueTypes["EmployeeQueueCreateInput"]},ValueTypes["EmployeeQueueUpsertResult"]],
createTimetableDay?: [{	data: ValueTypes["TimetableDayCreateInput"]},ValueTypes["TimetableDayCreateResult"]],
deleteTimetableDay?: [{	by: ValueTypes["TimetableDayUniqueWhere"],	filter?: ValueTypes["TimetableDayWhere"] | undefined | null},ValueTypes["TimetableDayDeleteResult"]],
updateTimetableDay?: [{	by: ValueTypes["TimetableDayUniqueWhere"],	filter?: ValueTypes["TimetableDayWhere"] | undefined | null,	data: ValueTypes["TimetableDayUpdateInput"]},ValueTypes["TimetableDayUpdateResult"]],
upsertTimetableDay?: [{	by: ValueTypes["TimetableDayUniqueWhere"],	filter?: ValueTypes["TimetableDayWhere"] | undefined | null,	update: ValueTypes["TimetableDayUpdateInput"],	create: ValueTypes["TimetableDayCreateInput"]},ValueTypes["TimetableDayUpsertResult"]],
createTimetableEmployeeRole?: [{	data: ValueTypes["TimetableEmployeeRoleCreateInput"]},ValueTypes["TimetableEmployeeRoleCreateResult"]],
deleteTimetableEmployeeRole?: [{	by: ValueTypes["TimetableEmployeeRoleUniqueWhere"],	filter?: ValueTypes["TimetableEmployeeRoleWhere"] | undefined | null},ValueTypes["TimetableEmployeeRoleDeleteResult"]],
updateTimetableEmployeeRole?: [{	by: ValueTypes["TimetableEmployeeRoleUniqueWhere"],	filter?: ValueTypes["TimetableEmployeeRoleWhere"] | undefined | null,	data: ValueTypes["TimetableEmployeeRoleUpdateInput"]},ValueTypes["TimetableEmployeeRoleUpdateResult"]],
upsertTimetableEmployeeRole?: [{	by: ValueTypes["TimetableEmployeeRoleUniqueWhere"],	filter?: ValueTypes["TimetableEmployeeRoleWhere"] | undefined | null,	update: ValueTypes["TimetableEmployeeRoleUpdateInput"],	create: ValueTypes["TimetableEmployeeRoleCreateInput"]},ValueTypes["TimetableEmployeeRoleUpsertResult"]],
createTimetableShift?: [{	data: ValueTypes["TimetableShiftCreateInput"]},ValueTypes["TimetableShiftCreateResult"]],
deleteTimetableShift?: [{	by: ValueTypes["TimetableShiftUniqueWhere"],	filter?: ValueTypes["TimetableShiftWhere"] | undefined | null},ValueTypes["TimetableShiftDeleteResult"]],
updateTimetableShift?: [{	by: ValueTypes["TimetableShiftUniqueWhere"],	filter?: ValueTypes["TimetableShiftWhere"] | undefined | null,	data: ValueTypes["TimetableShiftUpdateInput"]},ValueTypes["TimetableShiftUpdateResult"]],
upsertTimetableShift?: [{	by: ValueTypes["TimetableShiftUniqueWhere"],	filter?: ValueTypes["TimetableShiftWhere"] | undefined | null,	update: ValueTypes["TimetableShiftUpdateInput"],	create: ValueTypes["TimetableShiftCreateInput"]},ValueTypes["TimetableShiftUpsertResult"]],
createTimetableShiftGroup?: [{	data: ValueTypes["TimetableShiftGroupCreateInput"]},ValueTypes["TimetableShiftGroupCreateResult"]],
deleteTimetableShiftGroup?: [{	by: ValueTypes["TimetableShiftGroupUniqueWhere"],	filter?: ValueTypes["TimetableShiftGroupWhere"] | undefined | null},ValueTypes["TimetableShiftGroupDeleteResult"]],
updateTimetableShiftGroup?: [{	by: ValueTypes["TimetableShiftGroupUniqueWhere"],	filter?: ValueTypes["TimetableShiftGroupWhere"] | undefined | null,	data: ValueTypes["TimetableShiftGroupUpdateInput"]},ValueTypes["TimetableShiftGroupUpdateResult"]],
upsertTimetableShiftGroup?: [{	by: ValueTypes["TimetableShiftGroupUniqueWhere"],	filter?: ValueTypes["TimetableShiftGroupWhere"] | undefined | null,	update: ValueTypes["TimetableShiftGroupUpdateInput"],	create: ValueTypes["TimetableShiftGroupCreateInput"]},ValueTypes["TimetableShiftGroupUpsertResult"]],
createTimetableShiftPosition?: [{	data: ValueTypes["TimetableShiftPositionCreateInput"]},ValueTypes["TimetableShiftPositionCreateResult"]],
deleteTimetableShiftPosition?: [{	by: ValueTypes["TimetableShiftPositionUniqueWhere"],	filter?: ValueTypes["TimetableShiftPositionWhere"] | undefined | null},ValueTypes["TimetableShiftPositionDeleteResult"]],
updateTimetableShiftPosition?: [{	by: ValueTypes["TimetableShiftPositionUniqueWhere"],	filter?: ValueTypes["TimetableShiftPositionWhere"] | undefined | null,	data: ValueTypes["TimetableShiftPositionUpdateInput"]},ValueTypes["TimetableShiftPositionUpdateResult"]],
upsertTimetableShiftPosition?: [{	by: ValueTypes["TimetableShiftPositionUniqueWhere"],	filter?: ValueTypes["TimetableShiftPositionWhere"] | undefined | null,	update: ValueTypes["TimetableShiftPositionUpdateInput"],	create: ValueTypes["TimetableShiftPositionCreateInput"]},ValueTypes["TimetableShiftPositionUpsertResult"]],
createTimetableTemplate?: [{	data: ValueTypes["TimetableTemplateCreateInput"]},ValueTypes["TimetableTemplateCreateResult"]],
deleteTimetableTemplate?: [{	by: ValueTypes["TimetableTemplateUniqueWhere"],	filter?: ValueTypes["TimetableTemplateWhere"] | undefined | null},ValueTypes["TimetableTemplateDeleteResult"]],
updateTimetableTemplate?: [{	by: ValueTypes["TimetableTemplateUniqueWhere"],	filter?: ValueTypes["TimetableTemplateWhere"] | undefined | null,	data: ValueTypes["TimetableTemplateUpdateInput"]},ValueTypes["TimetableTemplateUpdateResult"]],
upsertTimetableTemplate?: [{	by: ValueTypes["TimetableTemplateUniqueWhere"],	filter?: ValueTypes["TimetableTemplateWhere"] | undefined | null,	update: ValueTypes["TimetableTemplateUpdateInput"],	create: ValueTypes["TimetableTemplateCreateInput"]},ValueTypes["TimetableTemplateUpsertResult"]],
createCart?: [{	data: ValueTypes["CartCreateInput"]},ValueTypes["CartCreateResult"]],
deleteCart?: [{	by: ValueTypes["CartUniqueWhere"],	filter?: ValueTypes["CartWhere"] | undefined | null},ValueTypes["CartDeleteResult"]],
updateCart?: [{	by: ValueTypes["CartUniqueWhere"],	filter?: ValueTypes["CartWhere"] | undefined | null,	data: ValueTypes["CartUpdateInput"]},ValueTypes["CartUpdateResult"]],
upsertCart?: [{	by: ValueTypes["CartUniqueWhere"],	filter?: ValueTypes["CartWhere"] | undefined | null,	update: ValueTypes["CartUpdateInput"],	create: ValueTypes["CartCreateInput"]},ValueTypes["CartUpsertResult"]],
createCartItem?: [{	data: ValueTypes["CartItemCreateInput"]},ValueTypes["CartItemCreateResult"]],
deleteCartItem?: [{	by: ValueTypes["CartItemUniqueWhere"],	filter?: ValueTypes["CartItemWhere"] | undefined | null},ValueTypes["CartItemDeleteResult"]],
updateCartItem?: [{	by: ValueTypes["CartItemUniqueWhere"],	filter?: ValueTypes["CartItemWhere"] | undefined | null,	data: ValueTypes["CartItemUpdateInput"]},ValueTypes["CartItemUpdateResult"]],
upsertCartItem?: [{	by: ValueTypes["CartItemUniqueWhere"],	filter?: ValueTypes["CartItemWhere"] | undefined | null,	update: ValueTypes["CartItemUpdateInput"],	create: ValueTypes["CartItemCreateInput"]},ValueTypes["CartItemUpsertResult"]],
createEmployeeQueueItem?: [{	data: ValueTypes["EmployeeQueueItemCreateInput"]},ValueTypes["EmployeeQueueItemCreateResult"]],
deleteEmployeeQueueItem?: [{	by: ValueTypes["EmployeeQueueItemUniqueWhere"],	filter?: ValueTypes["EmployeeQueueItemWhere"] | undefined | null},ValueTypes["EmployeeQueueItemDeleteResult"]],
updateEmployeeQueueItem?: [{	by: ValueTypes["EmployeeQueueItemUniqueWhere"],	filter?: ValueTypes["EmployeeQueueItemWhere"] | undefined | null,	data: ValueTypes["EmployeeQueueItemUpdateInput"]},ValueTypes["EmployeeQueueItemUpdateResult"]],
upsertEmployeeQueueItem?: [{	by: ValueTypes["EmployeeQueueItemUniqueWhere"],	filter?: ValueTypes["EmployeeQueueItemWhere"] | undefined | null,	update: ValueTypes["EmployeeQueueItemUpdateInput"],	create: ValueTypes["EmployeeQueueItemCreateInput"]},ValueTypes["EmployeeQueueItemUpsertResult"]],
createApplication?: [{	data: ValueTypes["ApplicationCreateInput"]},ValueTypes["ApplicationCreateResult"]],
deleteApplication?: [{	by: ValueTypes["ApplicationUniqueWhere"],	filter?: ValueTypes["ApplicationWhere"] | undefined | null},ValueTypes["ApplicationDeleteResult"]],
updateApplication?: [{	by: ValueTypes["ApplicationUniqueWhere"],	filter?: ValueTypes["ApplicationWhere"] | undefined | null,	data: ValueTypes["ApplicationUpdateInput"]},ValueTypes["ApplicationUpdateResult"]],
upsertApplication?: [{	by: ValueTypes["ApplicationUniqueWhere"],	filter?: ValueTypes["ApplicationWhere"] | undefined | null,	update: ValueTypes["ApplicationUpdateInput"],	create: ValueTypes["ApplicationCreateInput"]},ValueTypes["ApplicationUpsertResult"]],
createApplicationShortcutList?: [{	data: ValueTypes["ApplicationShortcutListCreateInput"]},ValueTypes["ApplicationShortcutListCreateResult"]],
deleteApplicationShortcutList?: [{	by: ValueTypes["ApplicationShortcutListUniqueWhere"],	filter?: ValueTypes["ApplicationShortcutListWhere"] | undefined | null},ValueTypes["ApplicationShortcutListDeleteResult"]],
updateApplicationShortcutList?: [{	by: ValueTypes["ApplicationShortcutListUniqueWhere"],	filter?: ValueTypes["ApplicationShortcutListWhere"] | undefined | null,	data: ValueTypes["ApplicationShortcutListUpdateInput"]},ValueTypes["ApplicationShortcutListUpdateResult"]],
upsertApplicationShortcutList?: [{	by: ValueTypes["ApplicationShortcutListUniqueWhere"],	filter?: ValueTypes["ApplicationShortcutListWhere"] | undefined | null,	update: ValueTypes["ApplicationShortcutListUpdateInput"],	create: ValueTypes["ApplicationShortcutListCreateInput"]},ValueTypes["ApplicationShortcutListUpsertResult"]],
createApplicationShortcutListItem?: [{	data: ValueTypes["ApplicationShortcutListItemCreateInput"]},ValueTypes["ApplicationShortcutListItemCreateResult"]],
deleteApplicationShortcutListItem?: [{	by: ValueTypes["ApplicationShortcutListItemUniqueWhere"],	filter?: ValueTypes["ApplicationShortcutListItemWhere"] | undefined | null},ValueTypes["ApplicationShortcutListItemDeleteResult"]],
updateApplicationShortcutListItem?: [{	by: ValueTypes["ApplicationShortcutListItemUniqueWhere"],	filter?: ValueTypes["ApplicationShortcutListItemWhere"] | undefined | null,	data: ValueTypes["ApplicationShortcutListItemUpdateInput"]},ValueTypes["ApplicationShortcutListItemUpdateResult"]],
upsertApplicationShortcutListItem?: [{	by: ValueTypes["ApplicationShortcutListItemUniqueWhere"],	filter?: ValueTypes["ApplicationShortcutListItemWhere"] | undefined | null,	update: ValueTypes["ApplicationShortcutListItemUpdateInput"],	create: ValueTypes["ApplicationShortcutListItemCreateInput"]},ValueTypes["ApplicationShortcutListItemUpsertResult"]],
createProductBanner?: [{	data: ValueTypes["ProductBannerCreateInput"]},ValueTypes["ProductBannerCreateResult"]],
deleteProductBanner?: [{	by: ValueTypes["ProductBannerUniqueWhere"],	filter?: ValueTypes["ProductBannerWhere"] | undefined | null},ValueTypes["ProductBannerDeleteResult"]],
updateProductBanner?: [{	by: ValueTypes["ProductBannerUniqueWhere"],	filter?: ValueTypes["ProductBannerWhere"] | undefined | null,	data: ValueTypes["ProductBannerUpdateInput"]},ValueTypes["ProductBannerUpdateResult"]],
upsertProductBanner?: [{	by: ValueTypes["ProductBannerUniqueWhere"],	filter?: ValueTypes["ProductBannerWhere"] | undefined | null,	update: ValueTypes["ProductBannerUpdateInput"],	create: ValueTypes["ProductBannerCreateInput"]},ValueTypes["ProductBannerUpsertResult"]],
createProductBannerItem?: [{	data: ValueTypes["ProductBannerItemCreateInput"]},ValueTypes["ProductBannerItemCreateResult"]],
deleteProductBannerItem?: [{	by: ValueTypes["ProductBannerItemUniqueWhere"],	filter?: ValueTypes["ProductBannerItemWhere"] | undefined | null},ValueTypes["ProductBannerItemDeleteResult"]],
updateProductBannerItem?: [{	by: ValueTypes["ProductBannerItemUniqueWhere"],	filter?: ValueTypes["ProductBannerItemWhere"] | undefined | null,	data: ValueTypes["ProductBannerItemUpdateInput"]},ValueTypes["ProductBannerItemUpdateResult"]],
upsertProductBannerItem?: [{	by: ValueTypes["ProductBannerItemUniqueWhere"],	filter?: ValueTypes["ProductBannerItemWhere"] | undefined | null,	update: ValueTypes["ProductBannerItemUpdateInput"],	create: ValueTypes["ProductBannerItemCreateInput"]},ValueTypes["ProductBannerItemUpsertResult"]],
createProductBannerList?: [{	data: ValueTypes["ProductBannerListCreateInput"]},ValueTypes["ProductBannerListCreateResult"]],
deleteProductBannerList?: [{	by: ValueTypes["ProductBannerListUniqueWhere"],	filter?: ValueTypes["ProductBannerListWhere"] | undefined | null},ValueTypes["ProductBannerListDeleteResult"]],
updateProductBannerList?: [{	by: ValueTypes["ProductBannerListUniqueWhere"],	filter?: ValueTypes["ProductBannerListWhere"] | undefined | null,	data: ValueTypes["ProductBannerListUpdateInput"]},ValueTypes["ProductBannerListUpdateResult"]],
upsertProductBannerList?: [{	by: ValueTypes["ProductBannerListUniqueWhere"],	filter?: ValueTypes["ProductBannerListWhere"] | undefined | null,	update: ValueTypes["ProductBannerListUpdateInput"],	create: ValueTypes["ProductBannerListCreateInput"]},ValueTypes["ProductBannerListUpsertResult"]],
createBartender?: [{	data: ValueTypes["BartenderCreateInput"]},ValueTypes["BartenderCreateResult"]],
deleteBartender?: [{	by: ValueTypes["BartenderUniqueWhere"],	filter?: ValueTypes["BartenderWhere"] | undefined | null},ValueTypes["BartenderDeleteResult"]],
updateBartender?: [{	by: ValueTypes["BartenderUniqueWhere"],	filter?: ValueTypes["BartenderWhere"] | undefined | null,	data: ValueTypes["BartenderUpdateInput"]},ValueTypes["BartenderUpdateResult"]],
upsertBartender?: [{	by: ValueTypes["BartenderUniqueWhere"],	filter?: ValueTypes["BartenderWhere"] | undefined | null,	update: ValueTypes["BartenderUpdateInput"],	create: ValueTypes["BartenderCreateInput"]},ValueTypes["BartenderUpsertResult"]],
createBusinessToBusinessManager?: [{	data: ValueTypes["BusinessToBusinessManagerCreateInput"]},ValueTypes["BusinessToBusinessManagerCreateResult"]],
deleteBusinessToBusinessManager?: [{	by: ValueTypes["BusinessToBusinessManagerUniqueWhere"],	filter?: ValueTypes["BusinessToBusinessManagerWhere"] | undefined | null},ValueTypes["BusinessToBusinessManagerDeleteResult"]],
updateBusinessToBusinessManager?: [{	by: ValueTypes["BusinessToBusinessManagerUniqueWhere"],	filter?: ValueTypes["BusinessToBusinessManagerWhere"] | undefined | null,	data: ValueTypes["BusinessToBusinessManagerUpdateInput"]},ValueTypes["BusinessToBusinessManagerUpdateResult"]],
upsertBusinessToBusinessManager?: [{	by: ValueTypes["BusinessToBusinessManagerUniqueWhere"],	filter?: ValueTypes["BusinessToBusinessManagerWhere"] | undefined | null,	update: ValueTypes["BusinessToBusinessManagerUpdateInput"],	create: ValueTypes["BusinessToBusinessManagerCreateInput"]},ValueTypes["BusinessToBusinessManagerUpsertResult"]],
createCleaner?: [{	data: ValueTypes["CleanerCreateInput"]},ValueTypes["CleanerCreateResult"]],
deleteCleaner?: [{	by: ValueTypes["CleanerUniqueWhere"],	filter?: ValueTypes["CleanerWhere"] | undefined | null},ValueTypes["CleanerDeleteResult"]],
updateCleaner?: [{	by: ValueTypes["CleanerUniqueWhere"],	filter?: ValueTypes["CleanerWhere"] | undefined | null,	data: ValueTypes["CleanerUpdateInput"]},ValueTypes["CleanerUpdateResult"]],
upsertCleaner?: [{	by: ValueTypes["CleanerUniqueWhere"],	filter?: ValueTypes["CleanerWhere"] | undefined | null,	update: ValueTypes["CleanerUpdateInput"],	create: ValueTypes["CleanerCreateInput"]},ValueTypes["CleanerUpsertResult"]],
createCourier?: [{	data: ValueTypes["CourierCreateInput"]},ValueTypes["CourierCreateResult"]],
deleteCourier?: [{	by: ValueTypes["CourierUniqueWhere"],	filter?: ValueTypes["CourierWhere"] | undefined | null},ValueTypes["CourierDeleteResult"]],
updateCourier?: [{	by: ValueTypes["CourierUniqueWhere"],	filter?: ValueTypes["CourierWhere"] | undefined | null,	data: ValueTypes["CourierUpdateInput"]},ValueTypes["CourierUpdateResult"]],
upsertCourier?: [{	by: ValueTypes["CourierUniqueWhere"],	filter?: ValueTypes["CourierWhere"] | undefined | null,	update: ValueTypes["CourierUpdateInput"],	create: ValueTypes["CourierCreateInput"]},ValueTypes["CourierUpsertResult"]],
createShiftsManager?: [{	data: ValueTypes["ShiftsManagerCreateInput"]},ValueTypes["ShiftsManagerCreateResult"]],
deleteShiftsManager?: [{	by: ValueTypes["ShiftsManagerUniqueWhere"],	filter?: ValueTypes["ShiftsManagerWhere"] | undefined | null},ValueTypes["ShiftsManagerDeleteResult"]],
updateShiftsManager?: [{	by: ValueTypes["ShiftsManagerUniqueWhere"],	filter?: ValueTypes["ShiftsManagerWhere"] | undefined | null,	data: ValueTypes["ShiftsManagerUpdateInput"]},ValueTypes["ShiftsManagerUpdateResult"]],
upsertShiftsManager?: [{	by: ValueTypes["ShiftsManagerUniqueWhere"],	filter?: ValueTypes["ShiftsManagerWhere"] | undefined | null,	update: ValueTypes["ShiftsManagerUpdateInput"],	create: ValueTypes["ShiftsManagerCreateInput"]},ValueTypes["ShiftsManagerUpsertResult"]],
createUser?: [{	data: ValueTypes["UserCreateInput"]},ValueTypes["UserCreateResult"]],
deleteUser?: [{	by: ValueTypes["UserUniqueWhere"],	filter?: ValueTypes["UserWhere"] | undefined | null},ValueTypes["UserDeleteResult"]],
updateUser?: [{	by: ValueTypes["UserUniqueWhere"],	filter?: ValueTypes["UserWhere"] | undefined | null,	data: ValueTypes["UserUpdateInput"]},ValueTypes["UserUpdateResult"]],
upsertUser?: [{	by: ValueTypes["UserUniqueWhere"],	filter?: ValueTypes["UserWhere"] | undefined | null,	update: ValueTypes["UserUpdateInput"],	create: ValueTypes["UserCreateInput"]},ValueTypes["UserUpsertResult"]],
createShiftsProfile?: [{	data: ValueTypes["ShiftsProfileCreateInput"]},ValueTypes["ShiftsProfileCreateResult"]],
deleteShiftsProfile?: [{	by: ValueTypes["ShiftsProfileUniqueWhere"],	filter?: ValueTypes["ShiftsProfileWhere"] | undefined | null},ValueTypes["ShiftsProfileDeleteResult"]],
updateShiftsProfile?: [{	by: ValueTypes["ShiftsProfileUniqueWhere"],	filter?: ValueTypes["ShiftsProfileWhere"] | undefined | null,	data: ValueTypes["ShiftsProfileUpdateInput"]},ValueTypes["ShiftsProfileUpdateResult"]],
upsertShiftsProfile?: [{	by: ValueTypes["ShiftsProfileUniqueWhere"],	filter?: ValueTypes["ShiftsProfileWhere"] | undefined | null,	update: ValueTypes["ShiftsProfileUpdateInput"],	create: ValueTypes["ShiftsProfileCreateInput"]},ValueTypes["ShiftsProfileUpsertResult"]],
createProductIngredientCategory?: [{	data: ValueTypes["ProductIngredientCategoryCreateInput"]},ValueTypes["ProductIngredientCategoryCreateResult"]],
deleteProductIngredientCategory?: [{	by: ValueTypes["ProductIngredientCategoryUniqueWhere"],	filter?: ValueTypes["ProductIngredientCategoryWhere"] | undefined | null},ValueTypes["ProductIngredientCategoryDeleteResult"]],
updateProductIngredientCategory?: [{	by: ValueTypes["ProductIngredientCategoryUniqueWhere"],	filter?: ValueTypes["ProductIngredientCategoryWhere"] | undefined | null,	data: ValueTypes["ProductIngredientCategoryUpdateInput"]},ValueTypes["ProductIngredientCategoryUpdateResult"]],
upsertProductIngredientCategory?: [{	by: ValueTypes["ProductIngredientCategoryUniqueWhere"],	filter?: ValueTypes["ProductIngredientCategoryWhere"] | undefined | null,	update: ValueTypes["ProductIngredientCategoryUpdateInput"],	create: ValueTypes["ProductIngredientCategoryCreateInput"]},ValueTypes["ProductIngredientCategoryUpsertResult"]],
createProductIngredientCategoryLocale?: [{	data: ValueTypes["ProductIngredientCategoryLocaleCreateInput"]},ValueTypes["ProductIngredientCategoryLocaleCreateResult"]],
deleteProductIngredientCategoryLocale?: [{	by: ValueTypes["ProductIngredientCategoryLocaleUniqueWhere"],	filter?: ValueTypes["ProductIngredientCategoryLocaleWhere"] | undefined | null},ValueTypes["ProductIngredientCategoryLocaleDeleteResult"]],
updateProductIngredientCategoryLocale?: [{	by: ValueTypes["ProductIngredientCategoryLocaleUniqueWhere"],	filter?: ValueTypes["ProductIngredientCategoryLocaleWhere"] | undefined | null,	data: ValueTypes["ProductIngredientCategoryLocaleUpdateInput"]},ValueTypes["ProductIngredientCategoryLocaleUpdateResult"]],
upsertProductIngredientCategoryLocale?: [{	by: ValueTypes["ProductIngredientCategoryLocaleUniqueWhere"],	filter?: ValueTypes["ProductIngredientCategoryLocaleWhere"] | undefined | null,	update: ValueTypes["ProductIngredientCategoryLocaleUpdateInput"],	create: ValueTypes["ProductIngredientCategoryLocaleCreateInput"]},ValueTypes["ProductIngredientCategoryLocaleUpsertResult"]],
createStocksManager?: [{	data: ValueTypes["StocksManagerCreateInput"]},ValueTypes["StocksManagerCreateResult"]],
deleteStocksManager?: [{	by: ValueTypes["StocksManagerUniqueWhere"],	filter?: ValueTypes["StocksManagerWhere"] | undefined | null},ValueTypes["StocksManagerDeleteResult"]],
updateStocksManager?: [{	by: ValueTypes["StocksManagerUniqueWhere"],	filter?: ValueTypes["StocksManagerWhere"] | undefined | null,	data: ValueTypes["StocksManagerUpdateInput"]},ValueTypes["StocksManagerUpdateResult"]],
upsertStocksManager?: [{	by: ValueTypes["StocksManagerUniqueWhere"],	filter?: ValueTypes["StocksManagerWhere"] | undefined | null,	update: ValueTypes["StocksManagerUpdateInput"],	create: ValueTypes["StocksManagerCreateInput"]},ValueTypes["StocksManagerUpsertResult"]],
createDeliveryRoute?: [{	data: ValueTypes["DeliveryRouteCreateInput"]},ValueTypes["DeliveryRouteCreateResult"]],
deleteDeliveryRoute?: [{	by: ValueTypes["DeliveryRouteUniqueWhere"],	filter?: ValueTypes["DeliveryRouteWhere"] | undefined | null},ValueTypes["DeliveryRouteDeleteResult"]],
updateDeliveryRoute?: [{	by: ValueTypes["DeliveryRouteUniqueWhere"],	filter?: ValueTypes["DeliveryRouteWhere"] | undefined | null,	data: ValueTypes["DeliveryRouteUpdateInput"]},ValueTypes["DeliveryRouteUpdateResult"]],
upsertDeliveryRoute?: [{	by: ValueTypes["DeliveryRouteUniqueWhere"],	filter?: ValueTypes["DeliveryRouteWhere"] | undefined | null,	update: ValueTypes["DeliveryRouteUpdateInput"],	create: ValueTypes["DeliveryRouteCreateInput"]},ValueTypes["DeliveryRouteUpsertResult"]],
createDeliveryWaypoint?: [{	data: ValueTypes["DeliveryWaypointCreateInput"]},ValueTypes["DeliveryWaypointCreateResult"]],
deleteDeliveryWaypoint?: [{	by: ValueTypes["DeliveryWaypointUniqueWhere"],	filter?: ValueTypes["DeliveryWaypointWhere"] | undefined | null},ValueTypes["DeliveryWaypointDeleteResult"]],
updateDeliveryWaypoint?: [{	by: ValueTypes["DeliveryWaypointUniqueWhere"],	filter?: ValueTypes["DeliveryWaypointWhere"] | undefined | null,	data: ValueTypes["DeliveryWaypointUpdateInput"]},ValueTypes["DeliveryWaypointUpdateResult"]],
upsertDeliveryWaypoint?: [{	by: ValueTypes["DeliveryWaypointUniqueWhere"],	filter?: ValueTypes["DeliveryWaypointWhere"] | undefined | null,	update: ValueTypes["DeliveryWaypointUpdateInput"],	create: ValueTypes["DeliveryWaypointCreateInput"]},ValueTypes["DeliveryWaypointUpsertResult"]],
createAllergen?: [{	data: ValueTypes["AllergenCreateInput"]},ValueTypes["AllergenCreateResult"]],
deleteAllergen?: [{	by: ValueTypes["AllergenUniqueWhere"],	filter?: ValueTypes["AllergenWhere"] | undefined | null},ValueTypes["AllergenDeleteResult"]],
updateAllergen?: [{	by: ValueTypes["AllergenUniqueWhere"],	filter?: ValueTypes["AllergenWhere"] | undefined | null,	data: ValueTypes["AllergenUpdateInput"]},ValueTypes["AllergenUpdateResult"]],
upsertAllergen?: [{	by: ValueTypes["AllergenUniqueWhere"],	filter?: ValueTypes["AllergenWhere"] | undefined | null,	update: ValueTypes["AllergenUpdateInput"],	create: ValueTypes["AllergenCreateInput"]},ValueTypes["AllergenUpsertResult"]],
createAllergenLocale?: [{	data: ValueTypes["AllergenLocaleCreateInput"]},ValueTypes["AllergenLocaleCreateResult"]],
deleteAllergenLocale?: [{	by: ValueTypes["AllergenLocaleUniqueWhere"],	filter?: ValueTypes["AllergenLocaleWhere"] | undefined | null},ValueTypes["AllergenLocaleDeleteResult"]],
updateAllergenLocale?: [{	by: ValueTypes["AllergenLocaleUniqueWhere"],	filter?: ValueTypes["AllergenLocaleWhere"] | undefined | null,	data: ValueTypes["AllergenLocaleUpdateInput"]},ValueTypes["AllergenLocaleUpdateResult"]],
upsertAllergenLocale?: [{	by: ValueTypes["AllergenLocaleUniqueWhere"],	filter?: ValueTypes["AllergenLocaleWhere"] | undefined | null,	update: ValueTypes["AllergenLocaleUpdateInput"],	create: ValueTypes["AllergenLocaleCreateInput"]},ValueTypes["AllergenLocaleUpsertResult"]],
createGps?: [{	data: ValueTypes["GpsCreateInput"]},ValueTypes["GpsCreateResult"]],
deleteGps?: [{	by: ValueTypes["GpsUniqueWhere"],	filter?: ValueTypes["GpsWhere"] | undefined | null},ValueTypes["GpsDeleteResult"]],
updateGps?: [{	by: ValueTypes["GpsUniqueWhere"],	filter?: ValueTypes["GpsWhere"] | undefined | null,	data: ValueTypes["GpsUpdateInput"]},ValueTypes["GpsUpdateResult"]],
upsertGps?: [{	by: ValueTypes["GpsUniqueWhere"],	filter?: ValueTypes["GpsWhere"] | undefined | null,	update: ValueTypes["GpsUpdateInput"],	create: ValueTypes["GpsCreateInput"]},ValueTypes["GpsUpsertResult"]],
createWeekHours?: [{	data: ValueTypes["WeekHoursCreateInput"]},ValueTypes["WeekHoursCreateResult"]],
deleteWeekHours?: [{	by: ValueTypes["WeekHoursUniqueWhere"],	filter?: ValueTypes["WeekHoursWhere"] | undefined | null},ValueTypes["WeekHoursDeleteResult"]],
updateWeekHours?: [{	by: ValueTypes["WeekHoursUniqueWhere"],	filter?: ValueTypes["WeekHoursWhere"] | undefined | null,	data: ValueTypes["WeekHoursUpdateInput"]},ValueTypes["WeekHoursUpdateResult"]],
upsertWeekHours?: [{	by: ValueTypes["WeekHoursUniqueWhere"],	filter?: ValueTypes["WeekHoursWhere"] | undefined | null,	update: ValueTypes["WeekHoursUpdateInput"],	create: ValueTypes["WeekHoursCreateInput"]},ValueTypes["WeekHoursUpsertResult"]],
createPreparedIngredientQuantity?: [{	data: ValueTypes["PreparedIngredientQuantityCreateInput"]},ValueTypes["PreparedIngredientQuantityCreateResult"]],
deletePreparedIngredientQuantity?: [{	by: ValueTypes["PreparedIngredientQuantityUniqueWhere"],	filter?: ValueTypes["PreparedIngredientQuantityWhere"] | undefined | null},ValueTypes["PreparedIngredientQuantityDeleteResult"]],
updatePreparedIngredientQuantity?: [{	by: ValueTypes["PreparedIngredientQuantityUniqueWhere"],	filter?: ValueTypes["PreparedIngredientQuantityWhere"] | undefined | null,	data: ValueTypes["PreparedIngredientQuantityUpdateInput"]},ValueTypes["PreparedIngredientQuantityUpdateResult"]],
upsertPreparedIngredientQuantity?: [{	by: ValueTypes["PreparedIngredientQuantityUniqueWhere"],	filter?: ValueTypes["PreparedIngredientQuantityWhere"] | undefined | null,	update: ValueTypes["PreparedIngredientQuantityUpdateInput"],	create: ValueTypes["PreparedIngredientQuantityCreateInput"]},ValueTypes["PreparedIngredientQuantityUpsertResult"]],
createPreparedRecipeQuantity?: [{	data: ValueTypes["PreparedRecipeQuantityCreateInput"]},ValueTypes["PreparedRecipeQuantityCreateResult"]],
deletePreparedRecipeQuantity?: [{	by: ValueTypes["PreparedRecipeQuantityUniqueWhere"],	filter?: ValueTypes["PreparedRecipeQuantityWhere"] | undefined | null},ValueTypes["PreparedRecipeQuantityDeleteResult"]],
updatePreparedRecipeQuantity?: [{	by: ValueTypes["PreparedRecipeQuantityUniqueWhere"],	filter?: ValueTypes["PreparedRecipeQuantityWhere"] | undefined | null,	data: ValueTypes["PreparedRecipeQuantityUpdateInput"]},ValueTypes["PreparedRecipeQuantityUpdateResult"]],
upsertPreparedRecipeQuantity?: [{	by: ValueTypes["PreparedRecipeQuantityUniqueWhere"],	filter?: ValueTypes["PreparedRecipeQuantityWhere"] | undefined | null,	update: ValueTypes["PreparedRecipeQuantityUpdateInput"],	create: ValueTypes["PreparedRecipeQuantityCreateInput"]},ValueTypes["PreparedRecipeQuantityUpsertResult"]],
createInternalOrder?: [{	data: ValueTypes["InternalOrderCreateInput"]},ValueTypes["InternalOrderCreateResult"]],
deleteInternalOrder?: [{	by: ValueTypes["InternalOrderUniqueWhere"],	filter?: ValueTypes["InternalOrderWhere"] | undefined | null},ValueTypes["InternalOrderDeleteResult"]],
updateInternalOrder?: [{	by: ValueTypes["InternalOrderUniqueWhere"],	filter?: ValueTypes["InternalOrderWhere"] | undefined | null,	data: ValueTypes["InternalOrderUpdateInput"]},ValueTypes["InternalOrderUpdateResult"]],
upsertInternalOrder?: [{	by: ValueTypes["InternalOrderUniqueWhere"],	filter?: ValueTypes["InternalOrderWhere"] | undefined | null,	update: ValueTypes["InternalOrderUpdateInput"],	create: ValueTypes["InternalOrderCreateInput"]},ValueTypes["InternalOrderUpsertResult"]],
createInternalOrderItem?: [{	data: ValueTypes["InternalOrderItemCreateInput"]},ValueTypes["InternalOrderItemCreateResult"]],
deleteInternalOrderItem?: [{	by: ValueTypes["InternalOrderItemUniqueWhere"],	filter?: ValueTypes["InternalOrderItemWhere"] | undefined | null},ValueTypes["InternalOrderItemDeleteResult"]],
updateInternalOrderItem?: [{	by: ValueTypes["InternalOrderItemUniqueWhere"],	filter?: ValueTypes["InternalOrderItemWhere"] | undefined | null,	data: ValueTypes["InternalOrderItemUpdateInput"]},ValueTypes["InternalOrderItemUpdateResult"]],
upsertInternalOrderItem?: [{	by: ValueTypes["InternalOrderItemUniqueWhere"],	filter?: ValueTypes["InternalOrderItemWhere"] | undefined | null,	update: ValueTypes["InternalOrderItemUpdateInput"],	create: ValueTypes["InternalOrderItemCreateInput"]},ValueTypes["InternalOrderItemUpsertResult"]],
createPreparedPackingQuantity?: [{	data: ValueTypes["PreparedPackingQuantityCreateInput"]},ValueTypes["PreparedPackingQuantityCreateResult"]],
deletePreparedPackingQuantity?: [{	by: ValueTypes["PreparedPackingQuantityUniqueWhere"],	filter?: ValueTypes["PreparedPackingQuantityWhere"] | undefined | null},ValueTypes["PreparedPackingQuantityDeleteResult"]],
updatePreparedPackingQuantity?: [{	by: ValueTypes["PreparedPackingQuantityUniqueWhere"],	filter?: ValueTypes["PreparedPackingQuantityWhere"] | undefined | null,	data: ValueTypes["PreparedPackingQuantityUpdateInput"]},ValueTypes["PreparedPackingQuantityUpdateResult"]],
upsertPreparedPackingQuantity?: [{	by: ValueTypes["PreparedPackingQuantityUniqueWhere"],	filter?: ValueTypes["PreparedPackingQuantityWhere"] | undefined | null,	update: ValueTypes["PreparedPackingQuantityUpdateInput"],	create: ValueTypes["PreparedPackingQuantityCreateInput"]},ValueTypes["PreparedPackingQuantityUpsertResult"]],
createCourierManager?: [{	data: ValueTypes["CourierManagerCreateInput"]},ValueTypes["CourierManagerCreateResult"]],
deleteCourierManager?: [{	by: ValueTypes["CourierManagerUniqueWhere"],	filter?: ValueTypes["CourierManagerWhere"] | undefined | null},ValueTypes["CourierManagerDeleteResult"]],
updateCourierManager?: [{	by: ValueTypes["CourierManagerUniqueWhere"],	filter?: ValueTypes["CourierManagerWhere"] | undefined | null,	data: ValueTypes["CourierManagerUpdateInput"]},ValueTypes["CourierManagerUpdateResult"]],
upsertCourierManager?: [{	by: ValueTypes["CourierManagerUniqueWhere"],	filter?: ValueTypes["CourierManagerWhere"] | undefined | null,	update: ValueTypes["CourierManagerUpdateInput"],	create: ValueTypes["CourierManagerCreateInput"]},ValueTypes["CourierManagerUpsertResult"]],
createDeliveryZone?: [{	data: ValueTypes["DeliveryZoneCreateInput"]},ValueTypes["DeliveryZoneCreateResult"]],
deleteDeliveryZone?: [{	by: ValueTypes["DeliveryZoneUniqueWhere"],	filter?: ValueTypes["DeliveryZoneWhere"] | undefined | null},ValueTypes["DeliveryZoneDeleteResult"]],
updateDeliveryZone?: [{	by: ValueTypes["DeliveryZoneUniqueWhere"],	filter?: ValueTypes["DeliveryZoneWhere"] | undefined | null,	data: ValueTypes["DeliveryZoneUpdateInput"]},ValueTypes["DeliveryZoneUpdateResult"]],
upsertDeliveryZone?: [{	by: ValueTypes["DeliveryZoneUniqueWhere"],	filter?: ValueTypes["DeliveryZoneWhere"] | undefined | null,	update: ValueTypes["DeliveryZoneUpdateInput"],	create: ValueTypes["DeliveryZoneCreateInput"]},ValueTypes["DeliveryZoneUpsertResult"]],
createDeliveryTimelinePreset?: [{	data: ValueTypes["DeliveryTimelinePresetCreateInput"]},ValueTypes["DeliveryTimelinePresetCreateResult"]],
deleteDeliveryTimelinePreset?: [{	by: ValueTypes["DeliveryTimelinePresetUniqueWhere"],	filter?: ValueTypes["DeliveryTimelinePresetWhere"] | undefined | null},ValueTypes["DeliveryTimelinePresetDeleteResult"]],
updateDeliveryTimelinePreset?: [{	by: ValueTypes["DeliveryTimelinePresetUniqueWhere"],	filter?: ValueTypes["DeliveryTimelinePresetWhere"] | undefined | null,	data: ValueTypes["DeliveryTimelinePresetUpdateInput"]},ValueTypes["DeliveryTimelinePresetUpdateResult"]],
upsertDeliveryTimelinePreset?: [{	by: ValueTypes["DeliveryTimelinePresetUniqueWhere"],	filter?: ValueTypes["DeliveryTimelinePresetWhere"] | undefined | null,	update: ValueTypes["DeliveryTimelinePresetUpdateInput"],	create: ValueTypes["DeliveryTimelinePresetCreateInput"]},ValueTypes["DeliveryTimelinePresetUpsertResult"]],
createOrderDeliveryTimeline?: [{	data: ValueTypes["OrderDeliveryTimelineCreateInput"]},ValueTypes["OrderDeliveryTimelineCreateResult"]],
deleteOrderDeliveryTimeline?: [{	by: ValueTypes["OrderDeliveryTimelineUniqueWhere"],	filter?: ValueTypes["OrderDeliveryTimelineWhere"] | undefined | null},ValueTypes["OrderDeliveryTimelineDeleteResult"]],
updateOrderDeliveryTimeline?: [{	by: ValueTypes["OrderDeliveryTimelineUniqueWhere"],	filter?: ValueTypes["OrderDeliveryTimelineWhere"] | undefined | null,	data: ValueTypes["OrderDeliveryTimelineUpdateInput"]},ValueTypes["OrderDeliveryTimelineUpdateResult"]],
upsertOrderDeliveryTimeline?: [{	by: ValueTypes["OrderDeliveryTimelineUniqueWhere"],	filter?: ValueTypes["OrderDeliveryTimelineWhere"] | undefined | null,	update: ValueTypes["OrderDeliveryTimelineUpdateInput"],	create: ValueTypes["OrderDeliveryTimelineCreateInput"]},ValueTypes["OrderDeliveryTimelineUpsertResult"]],
createOrderEvent?: [{	data: ValueTypes["OrderEventCreateInput"]},ValueTypes["OrderEventCreateResult"]],
deleteOrderEvent?: [{	by: ValueTypes["OrderEventUniqueWhere"],	filter?: ValueTypes["OrderEventWhere"] | undefined | null},ValueTypes["OrderEventDeleteResult"]],
updateOrderEvent?: [{	by: ValueTypes["OrderEventUniqueWhere"],	filter?: ValueTypes["OrderEventWhere"] | undefined | null,	data: ValueTypes["OrderEventUpdateInput"]},ValueTypes["OrderEventUpdateResult"]],
upsertOrderEvent?: [{	by: ValueTypes["OrderEventUniqueWhere"],	filter?: ValueTypes["OrderEventWhere"] | undefined | null,	update: ValueTypes["OrderEventUpdateInput"],	create: ValueTypes["OrderEventCreateInput"]},ValueTypes["OrderEventUpsertResult"]],
createLiftagoRide?: [{	data: ValueTypes["LiftagoRideCreateInput"]},ValueTypes["LiftagoRideCreateResult"]],
deleteLiftagoRide?: [{	by: ValueTypes["LiftagoRideUniqueWhere"],	filter?: ValueTypes["LiftagoRideWhere"] | undefined | null},ValueTypes["LiftagoRideDeleteResult"]],
updateLiftagoRide?: [{	by: ValueTypes["LiftagoRideUniqueWhere"],	filter?: ValueTypes["LiftagoRideWhere"] | undefined | null,	data: ValueTypes["LiftagoRideUpdateInput"]},ValueTypes["LiftagoRideUpdateResult"]],
upsertLiftagoRide?: [{	by: ValueTypes["LiftagoRideUniqueWhere"],	filter?: ValueTypes["LiftagoRideWhere"] | undefined | null,	update: ValueTypes["LiftagoRideUpdateInput"],	create: ValueTypes["LiftagoRideCreateInput"]},ValueTypes["LiftagoRideUpsertResult"]],
createInvoice?: [{	data: ValueTypes["InvoiceCreateInput"]},ValueTypes["InvoiceCreateResult"]],
deleteInvoice?: [{	by: ValueTypes["InvoiceUniqueWhere"],	filter?: ValueTypes["InvoiceWhere"] | undefined | null},ValueTypes["InvoiceDeleteResult"]],
updateInvoice?: [{	by: ValueTypes["InvoiceUniqueWhere"],	filter?: ValueTypes["InvoiceWhere"] | undefined | null,	data: ValueTypes["InvoiceUpdateInput"]},ValueTypes["InvoiceUpdateResult"]],
upsertInvoice?: [{	by: ValueTypes["InvoiceUniqueWhere"],	filter?: ValueTypes["InvoiceWhere"] | undefined | null,	update: ValueTypes["InvoiceUpdateInput"],	create: ValueTypes["InvoiceCreateInput"]},ValueTypes["InvoiceUpsertResult"]],
createInvoicingPlan?: [{	data: ValueTypes["InvoicingPlanCreateInput"]},ValueTypes["InvoicingPlanCreateResult"]],
deleteInvoicingPlan?: [{	by: ValueTypes["InvoicingPlanUniqueWhere"],	filter?: ValueTypes["InvoicingPlanWhere"] | undefined | null},ValueTypes["InvoicingPlanDeleteResult"]],
updateInvoicingPlan?: [{	by: ValueTypes["InvoicingPlanUniqueWhere"],	filter?: ValueTypes["InvoicingPlanWhere"] | undefined | null,	data: ValueTypes["InvoicingPlanUpdateInput"]},ValueTypes["InvoicingPlanUpdateResult"]],
upsertInvoicingPlan?: [{	by: ValueTypes["InvoicingPlanUniqueWhere"],	filter?: ValueTypes["InvoicingPlanWhere"] | undefined | null,	update: ValueTypes["InvoicingPlanUpdateInput"],	create: ValueTypes["InvoicingPlanCreateInput"]},ValueTypes["InvoicingPlanUpsertResult"]],
createProductPackingLocale?: [{	data: ValueTypes["ProductPackingLocaleCreateInput"]},ValueTypes["ProductPackingLocaleCreateResult"]],
deleteProductPackingLocale?: [{	by: ValueTypes["ProductPackingLocaleUniqueWhere"],	filter?: ValueTypes["ProductPackingLocaleWhere"] | undefined | null},ValueTypes["ProductPackingLocaleDeleteResult"]],
updateProductPackingLocale?: [{	by: ValueTypes["ProductPackingLocaleUniqueWhere"],	filter?: ValueTypes["ProductPackingLocaleWhere"] | undefined | null,	data: ValueTypes["ProductPackingLocaleUpdateInput"]},ValueTypes["ProductPackingLocaleUpdateResult"]],
upsertProductPackingLocale?: [{	by: ValueTypes["ProductPackingLocaleUniqueWhere"],	filter?: ValueTypes["ProductPackingLocaleWhere"] | undefined | null,	update: ValueTypes["ProductPackingLocaleUpdateInput"],	create: ValueTypes["ProductPackingLocaleCreateInput"]},ValueTypes["ProductPackingLocaleUpsertResult"]],
createProductLocale?: [{	data: ValueTypes["ProductLocaleCreateInput"]},ValueTypes["ProductLocaleCreateResult"]],
deleteProductLocale?: [{	by: ValueTypes["ProductLocaleUniqueWhere"],	filter?: ValueTypes["ProductLocaleWhere"] | undefined | null},ValueTypes["ProductLocaleDeleteResult"]],
updateProductLocale?: [{	by: ValueTypes["ProductLocaleUniqueWhere"],	filter?: ValueTypes["ProductLocaleWhere"] | undefined | null,	data: ValueTypes["ProductLocaleUpdateInput"]},ValueTypes["ProductLocaleUpdateResult"]],
upsertProductLocale?: [{	by: ValueTypes["ProductLocaleUniqueWhere"],	filter?: ValueTypes["ProductLocaleWhere"] | undefined | null,	update: ValueTypes["ProductLocaleUpdateInput"],	create: ValueTypes["ProductLocaleCreateInput"]},ValueTypes["ProductLocaleUpsertResult"]],
createProductRecipeLocale?: [{	data: ValueTypes["ProductRecipeLocaleCreateInput"]},ValueTypes["ProductRecipeLocaleCreateResult"]],
deleteProductRecipeLocale?: [{	by: ValueTypes["ProductRecipeLocaleUniqueWhere"],	filter?: ValueTypes["ProductRecipeLocaleWhere"] | undefined | null},ValueTypes["ProductRecipeLocaleDeleteResult"]],
updateProductRecipeLocale?: [{	by: ValueTypes["ProductRecipeLocaleUniqueWhere"],	filter?: ValueTypes["ProductRecipeLocaleWhere"] | undefined | null,	data: ValueTypes["ProductRecipeLocaleUpdateInput"]},ValueTypes["ProductRecipeLocaleUpdateResult"]],
upsertProductRecipeLocale?: [{	by: ValueTypes["ProductRecipeLocaleUniqueWhere"],	filter?: ValueTypes["ProductRecipeLocaleWhere"] | undefined | null,	update: ValueTypes["ProductRecipeLocaleUpdateInput"],	create: ValueTypes["ProductRecipeLocaleCreateInput"]},ValueTypes["ProductRecipeLocaleUpsertResult"]],
createUserDevice?: [{	data: ValueTypes["UserDeviceCreateInput"]},ValueTypes["UserDeviceCreateResult"]],
deleteUserDevice?: [{	by: ValueTypes["UserDeviceUniqueWhere"],	filter?: ValueTypes["UserDeviceWhere"] | undefined | null},ValueTypes["UserDeviceDeleteResult"]],
updateUserDevice?: [{	by: ValueTypes["UserDeviceUniqueWhere"],	filter?: ValueTypes["UserDeviceWhere"] | undefined | null,	data: ValueTypes["UserDeviceUpdateInput"]},ValueTypes["UserDeviceUpdateResult"]],
upsertUserDevice?: [{	by: ValueTypes["UserDeviceUniqueWhere"],	filter?: ValueTypes["UserDeviceWhere"] | undefined | null,	update: ValueTypes["UserDeviceUpdateInput"],	create: ValueTypes["UserDeviceCreateInput"]},ValueTypes["UserDeviceUpsertResult"]],
createProtectedAction?: [{	data: ValueTypes["ProtectedActionCreateInput"]},ValueTypes["ProtectedActionCreateResult"]],
deleteProtectedAction?: [{	by: ValueTypes["ProtectedActionUniqueWhere"],	filter?: ValueTypes["ProtectedActionWhere"] | undefined | null},ValueTypes["ProtectedActionDeleteResult"]],
updateProtectedAction?: [{	by: ValueTypes["ProtectedActionUniqueWhere"],	filter?: ValueTypes["ProtectedActionWhere"] | undefined | null,	data: ValueTypes["ProtectedActionUpdateInput"]},ValueTypes["ProtectedActionUpdateResult"]],
upsertProtectedAction?: [{	by: ValueTypes["ProtectedActionUniqueWhere"],	filter?: ValueTypes["ProtectedActionWhere"] | undefined | null,	update: ValueTypes["ProtectedActionUpdateInput"],	create: ValueTypes["ProtectedActionCreateInput"]},ValueTypes["ProtectedActionUpsertResult"]],
createPicker?: [{	data: ValueTypes["PickerCreateInput"]},ValueTypes["PickerCreateResult"]],
deletePicker?: [{	by: ValueTypes["PickerUniqueWhere"],	filter?: ValueTypes["PickerWhere"] | undefined | null},ValueTypes["PickerDeleteResult"]],
updatePicker?: [{	by: ValueTypes["PickerUniqueWhere"],	filter?: ValueTypes["PickerWhere"] | undefined | null,	data: ValueTypes["PickerUpdateInput"]},ValueTypes["PickerUpdateResult"]],
upsertPicker?: [{	by: ValueTypes["PickerUniqueWhere"],	filter?: ValueTypes["PickerWhere"] | undefined | null,	update: ValueTypes["PickerUpdateInput"],	create: ValueTypes["PickerCreateInput"]},ValueTypes["PickerUpsertResult"]],
createTimetableTemplateStaffOptions?: [{	data: ValueTypes["TimetableTemplateStaffOptionsCreateInput"]},ValueTypes["TimetableTemplateStaffOptionsCreateResult"]],
deleteTimetableTemplateStaffOptions?: [{	by: ValueTypes["TimetableTemplateStaffOptionsUniqueWhere"],	filter?: ValueTypes["TimetableTemplateStaffOptionsWhere"] | undefined | null},ValueTypes["TimetableTemplateStaffOptionsDeleteResult"]],
updateTimetableTemplateStaffOptions?: [{	by: ValueTypes["TimetableTemplateStaffOptionsUniqueWhere"],	filter?: ValueTypes["TimetableTemplateStaffOptionsWhere"] | undefined | null,	data: ValueTypes["TimetableTemplateStaffOptionsUpdateInput"]},ValueTypes["TimetableTemplateStaffOptionsUpdateResult"]],
upsertTimetableTemplateStaffOptions?: [{	by: ValueTypes["TimetableTemplateStaffOptionsUniqueWhere"],	filter?: ValueTypes["TimetableTemplateStaffOptionsWhere"] | undefined | null,	update: ValueTypes["TimetableTemplateStaffOptionsUpdateInput"],	create: ValueTypes["TimetableTemplateStaffOptionsCreateInput"]},ValueTypes["TimetableTemplateStaffOptionsUpsertResult"]],
createShoppingList?: [{	data: ValueTypes["ShoppingListCreateInput"]},ValueTypes["ShoppingListCreateResult"]],
deleteShoppingList?: [{	by: ValueTypes["ShoppingListUniqueWhere"],	filter?: ValueTypes["ShoppingListWhere"] | undefined | null},ValueTypes["ShoppingListDeleteResult"]],
updateShoppingList?: [{	by: ValueTypes["ShoppingListUniqueWhere"],	filter?: ValueTypes["ShoppingListWhere"] | undefined | null,	data: ValueTypes["ShoppingListUpdateInput"]},ValueTypes["ShoppingListUpdateResult"]],
upsertShoppingList?: [{	by: ValueTypes["ShoppingListUniqueWhere"],	filter?: ValueTypes["ShoppingListWhere"] | undefined | null,	update: ValueTypes["ShoppingListUpdateInput"],	create: ValueTypes["ShoppingListCreateInput"]},ValueTypes["ShoppingListUpsertResult"]],
createSuppliesPurchase?: [{	data: ValueTypes["SuppliesPurchaseCreateInput"]},ValueTypes["SuppliesPurchaseCreateResult"]],
deleteSuppliesPurchase?: [{	by: ValueTypes["SuppliesPurchaseUniqueWhere"],	filter?: ValueTypes["SuppliesPurchaseWhere"] | undefined | null},ValueTypes["SuppliesPurchaseDeleteResult"]],
updateSuppliesPurchase?: [{	by: ValueTypes["SuppliesPurchaseUniqueWhere"],	filter?: ValueTypes["SuppliesPurchaseWhere"] | undefined | null,	data: ValueTypes["SuppliesPurchaseUpdateInput"]},ValueTypes["SuppliesPurchaseUpdateResult"]],
upsertSuppliesPurchase?: [{	by: ValueTypes["SuppliesPurchaseUniqueWhere"],	filter?: ValueTypes["SuppliesPurchaseWhere"] | undefined | null,	update: ValueTypes["SuppliesPurchaseUpdateInput"],	create: ValueTypes["SuppliesPurchaseCreateInput"]},ValueTypes["SuppliesPurchaseUpsertResult"]],
createInvoicingPreset?: [{	data: ValueTypes["InvoicingPresetCreateInput"]},ValueTypes["InvoicingPresetCreateResult"]],
deleteInvoicingPreset?: [{	by: ValueTypes["InvoicingPresetUniqueWhere"],	filter?: ValueTypes["InvoicingPresetWhere"] | undefined | null},ValueTypes["InvoicingPresetDeleteResult"]],
updateInvoicingPreset?: [{	by: ValueTypes["InvoicingPresetUniqueWhere"],	filter?: ValueTypes["InvoicingPresetWhere"] | undefined | null,	data: ValueTypes["InvoicingPresetUpdateInput"]},ValueTypes["InvoicingPresetUpdateResult"]],
upsertInvoicingPreset?: [{	by: ValueTypes["InvoicingPresetUniqueWhere"],	filter?: ValueTypes["InvoicingPresetWhere"] | undefined | null,	update: ValueTypes["InvoicingPresetUpdateInput"],	create: ValueTypes["InvoicingPresetCreateInput"]},ValueTypes["InvoicingPresetUpsertResult"]],
createLogRecord?: [{	data: ValueTypes["LogRecordCreateInput"]},ValueTypes["LogRecordCreateResult"]],
deleteLogRecord?: [{	by: ValueTypes["LogRecordUniqueWhere"],	filter?: ValueTypes["LogRecordWhere"] | undefined | null},ValueTypes["LogRecordDeleteResult"]],
updateLogRecord?: [{	by: ValueTypes["LogRecordUniqueWhere"],	filter?: ValueTypes["LogRecordWhere"] | undefined | null,	data: ValueTypes["LogRecordUpdateInput"]},ValueTypes["LogRecordUpdateResult"]],
upsertLogRecord?: [{	by: ValueTypes["LogRecordUniqueWhere"],	filter?: ValueTypes["LogRecordWhere"] | undefined | null,	update: ValueTypes["LogRecordUpdateInput"],	create: ValueTypes["LogRecordCreateInput"]},ValueTypes["LogRecordUpsertResult"]],
createBillingSubject?: [{	data: ValueTypes["BillingSubjectCreateInput"]},ValueTypes["BillingSubjectCreateResult"]],
deleteBillingSubject?: [{	by: ValueTypes["BillingSubjectUniqueWhere"],	filter?: ValueTypes["BillingSubjectWhere"] | undefined | null},ValueTypes["BillingSubjectDeleteResult"]],
updateBillingSubject?: [{	by: ValueTypes["BillingSubjectUniqueWhere"],	filter?: ValueTypes["BillingSubjectWhere"] | undefined | null,	data: ValueTypes["BillingSubjectUpdateInput"]},ValueTypes["BillingSubjectUpdateResult"]],
upsertBillingSubject?: [{	by: ValueTypes["BillingSubjectUniqueWhere"],	filter?: ValueTypes["BillingSubjectWhere"] | undefined | null,	update: ValueTypes["BillingSubjectUpdateInput"],	create: ValueTypes["BillingSubjectCreateInput"]},ValueTypes["BillingSubjectUpsertResult"]],
createShoppingListItem?: [{	data: ValueTypes["ShoppingListItemCreateInput"]},ValueTypes["ShoppingListItemCreateResult"]],
deleteShoppingListItem?: [{	by: ValueTypes["ShoppingListItemUniqueWhere"],	filter?: ValueTypes["ShoppingListItemWhere"] | undefined | null},ValueTypes["ShoppingListItemDeleteResult"]],
updateShoppingListItem?: [{	by: ValueTypes["ShoppingListItemUniqueWhere"],	filter?: ValueTypes["ShoppingListItemWhere"] | undefined | null,	data: ValueTypes["ShoppingListItemUpdateInput"]},ValueTypes["ShoppingListItemUpdateResult"]],
upsertShoppingListItem?: [{	by: ValueTypes["ShoppingListItemUniqueWhere"],	filter?: ValueTypes["ShoppingListItemWhere"] | undefined | null,	update: ValueTypes["ShoppingListItemUpdateInput"],	create: ValueTypes["ShoppingListItemCreateInput"]},ValueTypes["ShoppingListItemUpsertResult"]],
createSuppliesPurchaseItem?: [{	data: ValueTypes["SuppliesPurchaseItemCreateInput"]},ValueTypes["SuppliesPurchaseItemCreateResult"]],
deleteSuppliesPurchaseItem?: [{	by: ValueTypes["SuppliesPurchaseItemUniqueWhere"],	filter?: ValueTypes["SuppliesPurchaseItemWhere"] | undefined | null},ValueTypes["SuppliesPurchaseItemDeleteResult"]],
updateSuppliesPurchaseItem?: [{	by: ValueTypes["SuppliesPurchaseItemUniqueWhere"],	filter?: ValueTypes["SuppliesPurchaseItemWhere"] | undefined | null,	data: ValueTypes["SuppliesPurchaseItemUpdateInput"]},ValueTypes["SuppliesPurchaseItemUpdateResult"]],
upsertSuppliesPurchaseItem?: [{	by: ValueTypes["SuppliesPurchaseItemUniqueWhere"],	filter?: ValueTypes["SuppliesPurchaseItemWhere"] | undefined | null,	update: ValueTypes["SuppliesPurchaseItemUpdateInput"],	create: ValueTypes["SuppliesPurchaseItemCreateInput"]},ValueTypes["SuppliesPurchaseItemUpsertResult"]],
createCustomerCreditTransaction?: [{	data: ValueTypes["CustomerCreditTransactionCreateInput"]},ValueTypes["CustomerCreditTransactionCreateResult"]],
deleteCustomerCreditTransaction?: [{	by: ValueTypes["CustomerCreditTransactionUniqueWhere"],	filter?: ValueTypes["CustomerCreditTransactionWhere"] | undefined | null},ValueTypes["CustomerCreditTransactionDeleteResult"]],
updateCustomerCreditTransaction?: [{	by: ValueTypes["CustomerCreditTransactionUniqueWhere"],	filter?: ValueTypes["CustomerCreditTransactionWhere"] | undefined | null,	data: ValueTypes["CustomerCreditTransactionUpdateInput"]},ValueTypes["CustomerCreditTransactionUpdateResult"]],
upsertCustomerCreditTransaction?: [{	by: ValueTypes["CustomerCreditTransactionUniqueWhere"],	filter?: ValueTypes["CustomerCreditTransactionWhere"] | undefined | null,	update: ValueTypes["CustomerCreditTransactionUpdateInput"],	create: ValueTypes["CustomerCreditTransactionCreateInput"]},ValueTypes["CustomerCreditTransactionUpsertResult"]],
createVirtualProduct?: [{	data: ValueTypes["VirtualProductCreateInput"]},ValueTypes["VirtualProductCreateResult"]],
deleteVirtualProduct?: [{	by: ValueTypes["VirtualProductUniqueWhere"],	filter?: ValueTypes["VirtualProductWhere"] | undefined | null},ValueTypes["VirtualProductDeleteResult"]],
updateVirtualProduct?: [{	by: ValueTypes["VirtualProductUniqueWhere"],	filter?: ValueTypes["VirtualProductWhere"] | undefined | null,	data: ValueTypes["VirtualProductUpdateInput"]},ValueTypes["VirtualProductUpdateResult"]],
upsertVirtualProduct?: [{	by: ValueTypes["VirtualProductUniqueWhere"],	filter?: ValueTypes["VirtualProductWhere"] | undefined | null,	update: ValueTypes["VirtualProductUpdateInput"],	create: ValueTypes["VirtualProductCreateInput"]},ValueTypes["VirtualProductUpsertResult"]],
createVirtualProductEffect?: [{	data: ValueTypes["VirtualProductEffectCreateInput"]},ValueTypes["VirtualProductEffectCreateResult"]],
deleteVirtualProductEffect?: [{	by: ValueTypes["VirtualProductEffectUniqueWhere"],	filter?: ValueTypes["VirtualProductEffectWhere"] | undefined | null},ValueTypes["VirtualProductEffectDeleteResult"]],
updateVirtualProductEffect?: [{	by: ValueTypes["VirtualProductEffectUniqueWhere"],	filter?: ValueTypes["VirtualProductEffectWhere"] | undefined | null,	data: ValueTypes["VirtualProductEffectUpdateInput"]},ValueTypes["VirtualProductEffectUpdateResult"]],
upsertVirtualProductEffect?: [{	by: ValueTypes["VirtualProductEffectUniqueWhere"],	filter?: ValueTypes["VirtualProductEffectWhere"] | undefined | null,	update: ValueTypes["VirtualProductEffectUpdateInput"],	create: ValueTypes["VirtualProductEffectCreateInput"]},ValueTypes["VirtualProductEffectUpsertResult"]],
createEmploymentInformation?: [{	data: ValueTypes["EmploymentInformationCreateInput"]},ValueTypes["EmploymentInformationCreateResult"]],
deleteEmploymentInformation?: [{	by: ValueTypes["EmploymentInformationUniqueWhere"],	filter?: ValueTypes["EmploymentInformationWhere"] | undefined | null},ValueTypes["EmploymentInformationDeleteResult"]],
updateEmploymentInformation?: [{	by: ValueTypes["EmploymentInformationUniqueWhere"],	filter?: ValueTypes["EmploymentInformationWhere"] | undefined | null,	data: ValueTypes["EmploymentInformationUpdateInput"]},ValueTypes["EmploymentInformationUpdateResult"]],
upsertEmploymentInformation?: [{	by: ValueTypes["EmploymentInformationUniqueWhere"],	filter?: ValueTypes["EmploymentInformationWhere"] | undefined | null,	update: ValueTypes["EmploymentInformationUpdateInput"],	create: ValueTypes["EmploymentInformationCreateInput"]},ValueTypes["EmploymentInformationUpsertResult"]],
createRemunerationProfile?: [{	data: ValueTypes["RemunerationProfileCreateInput"]},ValueTypes["RemunerationProfileCreateResult"]],
deleteRemunerationProfile?: [{	by: ValueTypes["RemunerationProfileUniqueWhere"],	filter?: ValueTypes["RemunerationProfileWhere"] | undefined | null},ValueTypes["RemunerationProfileDeleteResult"]],
updateRemunerationProfile?: [{	by: ValueTypes["RemunerationProfileUniqueWhere"],	filter?: ValueTypes["RemunerationProfileWhere"] | undefined | null,	data: ValueTypes["RemunerationProfileUpdateInput"]},ValueTypes["RemunerationProfileUpdateResult"]],
upsertRemunerationProfile?: [{	by: ValueTypes["RemunerationProfileUniqueWhere"],	filter?: ValueTypes["RemunerationProfileWhere"] | undefined | null,	update: ValueTypes["RemunerationProfileUpdateInput"],	create: ValueTypes["RemunerationProfileCreateInput"]},ValueTypes["RemunerationProfileUpsertResult"]],
createWorkMonth?: [{	data: ValueTypes["WorkMonthCreateInput"]},ValueTypes["WorkMonthCreateResult"]],
deleteWorkMonth?: [{	by: ValueTypes["WorkMonthUniqueWhere"],	filter?: ValueTypes["WorkMonthWhere"] | undefined | null},ValueTypes["WorkMonthDeleteResult"]],
updateWorkMonth?: [{	by: ValueTypes["WorkMonthUniqueWhere"],	filter?: ValueTypes["WorkMonthWhere"] | undefined | null,	data: ValueTypes["WorkMonthUpdateInput"]},ValueTypes["WorkMonthUpdateResult"]],
upsertWorkMonth?: [{	by: ValueTypes["WorkMonthUniqueWhere"],	filter?: ValueTypes["WorkMonthWhere"] | undefined | null,	update: ValueTypes["WorkMonthUpdateInput"],	create: ValueTypes["WorkMonthCreateInput"]},ValueTypes["WorkMonthUpsertResult"]],
createSalaryOptions?: [{	data: ValueTypes["SalaryOptionsCreateInput"]},ValueTypes["SalaryOptionsCreateResult"]],
deleteSalaryOptions?: [{	by: ValueTypes["SalaryOptionsUniqueWhere"],	filter?: ValueTypes["SalaryOptionsWhere"] | undefined | null},ValueTypes["SalaryOptionsDeleteResult"]],
updateSalaryOptions?: [{	by: ValueTypes["SalaryOptionsUniqueWhere"],	filter?: ValueTypes["SalaryOptionsWhere"] | undefined | null,	data: ValueTypes["SalaryOptionsUpdateInput"]},ValueTypes["SalaryOptionsUpdateResult"]],
upsertSalaryOptions?: [{	by: ValueTypes["SalaryOptionsUniqueWhere"],	filter?: ValueTypes["SalaryOptionsWhere"] | undefined | null,	update: ValueTypes["SalaryOptionsUpdateInput"],	create: ValueTypes["SalaryOptionsCreateInput"]},ValueTypes["SalaryOptionsUpsertResult"]],
createTimetableShiftSwapInfo?: [{	data: ValueTypes["TimetableShiftSwapInfoCreateInput"]},ValueTypes["TimetableShiftSwapInfoCreateResult"]],
deleteTimetableShiftSwapInfo?: [{	by: ValueTypes["TimetableShiftSwapInfoUniqueWhere"],	filter?: ValueTypes["TimetableShiftSwapInfoWhere"] | undefined | null},ValueTypes["TimetableShiftSwapInfoDeleteResult"]],
updateTimetableShiftSwapInfo?: [{	by: ValueTypes["TimetableShiftSwapInfoUniqueWhere"],	filter?: ValueTypes["TimetableShiftSwapInfoWhere"] | undefined | null,	data: ValueTypes["TimetableShiftSwapInfoUpdateInput"]},ValueTypes["TimetableShiftSwapInfoUpdateResult"]],
upsertTimetableShiftSwapInfo?: [{	by: ValueTypes["TimetableShiftSwapInfoUniqueWhere"],	filter?: ValueTypes["TimetableShiftSwapInfoWhere"] | undefined | null,	update: ValueTypes["TimetableShiftSwapInfoUpdateInput"],	create: ValueTypes["TimetableShiftSwapInfoCreateInput"]},ValueTypes["TimetableShiftSwapInfoUpsertResult"]],
createProductGridCategory?: [{	data: ValueTypes["ProductGridCategoryCreateInput"]},ValueTypes["ProductGridCategoryCreateResult"]],
deleteProductGridCategory?: [{	by: ValueTypes["ProductGridCategoryUniqueWhere"],	filter?: ValueTypes["ProductGridCategoryWhere"] | undefined | null},ValueTypes["ProductGridCategoryDeleteResult"]],
updateProductGridCategory?: [{	by: ValueTypes["ProductGridCategoryUniqueWhere"],	filter?: ValueTypes["ProductGridCategoryWhere"] | undefined | null,	data: ValueTypes["ProductGridCategoryUpdateInput"]},ValueTypes["ProductGridCategoryUpdateResult"]],
upsertProductGridCategory?: [{	by: ValueTypes["ProductGridCategoryUniqueWhere"],	filter?: ValueTypes["ProductGridCategoryWhere"] | undefined | null,	update: ValueTypes["ProductGridCategoryUpdateInput"],	create: ValueTypes["ProductGridCategoryCreateInput"]},ValueTypes["ProductGridCategoryUpsertResult"]],
createCashier?: [{	data: ValueTypes["CashierCreateInput"]},ValueTypes["CashierCreateResult"]],
deleteCashier?: [{	by: ValueTypes["CashierUniqueWhere"],	filter?: ValueTypes["CashierWhere"] | undefined | null},ValueTypes["CashierDeleteResult"]],
updateCashier?: [{	by: ValueTypes["CashierUniqueWhere"],	filter?: ValueTypes["CashierWhere"] | undefined | null,	data: ValueTypes["CashierUpdateInput"]},ValueTypes["CashierUpdateResult"]],
upsertCashier?: [{	by: ValueTypes["CashierUniqueWhere"],	filter?: ValueTypes["CashierWhere"] | undefined | null,	update: ValueTypes["CashierUpdateInput"],	create: ValueTypes["CashierCreateInput"]},ValueTypes["CashierUpsertResult"]],
createPointOfSaleCategory?: [{	data: ValueTypes["PointOfSaleCategoryCreateInput"]},ValueTypes["PointOfSaleCategoryCreateResult"]],
deletePointOfSaleCategory?: [{	by: ValueTypes["PointOfSaleCategoryUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryWhere"] | undefined | null},ValueTypes["PointOfSaleCategoryDeleteResult"]],
updatePointOfSaleCategory?: [{	by: ValueTypes["PointOfSaleCategoryUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryWhere"] | undefined | null,	data: ValueTypes["PointOfSaleCategoryUpdateInput"]},ValueTypes["PointOfSaleCategoryUpdateResult"]],
upsertPointOfSaleCategory?: [{	by: ValueTypes["PointOfSaleCategoryUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryWhere"] | undefined | null,	update: ValueTypes["PointOfSaleCategoryUpdateInput"],	create: ValueTypes["PointOfSaleCategoryCreateInput"]},ValueTypes["PointOfSaleCategoryUpsertResult"]],
createPointOfSaleCategoryLocale?: [{	data: ValueTypes["PointOfSaleCategoryLocaleCreateInput"]},ValueTypes["PointOfSaleCategoryLocaleCreateResult"]],
deletePointOfSaleCategoryLocale?: [{	by: ValueTypes["PointOfSaleCategoryLocaleUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryLocaleWhere"] | undefined | null},ValueTypes["PointOfSaleCategoryLocaleDeleteResult"]],
updatePointOfSaleCategoryLocale?: [{	by: ValueTypes["PointOfSaleCategoryLocaleUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryLocaleWhere"] | undefined | null,	data: ValueTypes["PointOfSaleCategoryLocaleUpdateInput"]},ValueTypes["PointOfSaleCategoryLocaleUpdateResult"]],
upsertPointOfSaleCategoryLocale?: [{	by: ValueTypes["PointOfSaleCategoryLocaleUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryLocaleWhere"] | undefined | null,	update: ValueTypes["PointOfSaleCategoryLocaleUpdateInput"],	create: ValueTypes["PointOfSaleCategoryLocaleCreateInput"]},ValueTypes["PointOfSaleCategoryLocaleUpsertResult"]],
createPointOfSaleCategoryProduct?: [{	data: ValueTypes["PointOfSaleCategoryProductCreateInput"]},ValueTypes["PointOfSaleCategoryProductCreateResult"]],
deletePointOfSaleCategoryProduct?: [{	by: ValueTypes["PointOfSaleCategoryProductUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryProductWhere"] | undefined | null},ValueTypes["PointOfSaleCategoryProductDeleteResult"]],
updatePointOfSaleCategoryProduct?: [{	by: ValueTypes["PointOfSaleCategoryProductUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryProductWhere"] | undefined | null,	data: ValueTypes["PointOfSaleCategoryProductUpdateInput"]},ValueTypes["PointOfSaleCategoryProductUpdateResult"]],
upsertPointOfSaleCategoryProduct?: [{	by: ValueTypes["PointOfSaleCategoryProductUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryProductWhere"] | undefined | null,	update: ValueTypes["PointOfSaleCategoryProductUpdateInput"],	create: ValueTypes["PointOfSaleCategoryProductCreateInput"]},ValueTypes["PointOfSaleCategoryProductUpsertResult"]],
createPointOfSaleCategoryProductLocale?: [{	data: ValueTypes["PointOfSaleCategoryProductLocaleCreateInput"]},ValueTypes["PointOfSaleCategoryProductLocaleCreateResult"]],
deletePointOfSaleCategoryProductLocale?: [{	by: ValueTypes["PointOfSaleCategoryProductLocaleUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryProductLocaleWhere"] | undefined | null},ValueTypes["PointOfSaleCategoryProductLocaleDeleteResult"]],
updatePointOfSaleCategoryProductLocale?: [{	by: ValueTypes["PointOfSaleCategoryProductLocaleUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryProductLocaleWhere"] | undefined | null,	data: ValueTypes["PointOfSaleCategoryProductLocaleUpdateInput"]},ValueTypes["PointOfSaleCategoryProductLocaleUpdateResult"]],
upsertPointOfSaleCategoryProductLocale?: [{	by: ValueTypes["PointOfSaleCategoryProductLocaleUniqueWhere"],	filter?: ValueTypes["PointOfSaleCategoryProductLocaleWhere"] | undefined | null,	update: ValueTypes["PointOfSaleCategoryProductLocaleUpdateInput"],	create: ValueTypes["PointOfSaleCategoryProductLocaleCreateInput"]},ValueTypes["PointOfSaleCategoryProductLocaleUpsertResult"]],
createCustomerTab?: [{	data: ValueTypes["CustomerTabCreateInput"]},ValueTypes["CustomerTabCreateResult"]],
deleteCustomerTab?: [{	by: ValueTypes["CustomerTabUniqueWhere"],	filter?: ValueTypes["CustomerTabWhere"] | undefined | null},ValueTypes["CustomerTabDeleteResult"]],
updateCustomerTab?: [{	by: ValueTypes["CustomerTabUniqueWhere"],	filter?: ValueTypes["CustomerTabWhere"] | undefined | null,	data: ValueTypes["CustomerTabUpdateInput"]},ValueTypes["CustomerTabUpdateResult"]],
upsertCustomerTab?: [{	by: ValueTypes["CustomerTabUniqueWhere"],	filter?: ValueTypes["CustomerTabWhere"] | undefined | null,	update: ValueTypes["CustomerTabUpdateInput"],	create: ValueTypes["CustomerTabCreateInput"]},ValueTypes["CustomerTabUpsertResult"]],
createCustomerTabItem?: [{	data: ValueTypes["CustomerTabItemCreateInput"]},ValueTypes["CustomerTabItemCreateResult"]],
deleteCustomerTabItem?: [{	by: ValueTypes["CustomerTabItemUniqueWhere"],	filter?: ValueTypes["CustomerTabItemWhere"] | undefined | null},ValueTypes["CustomerTabItemDeleteResult"]],
updateCustomerTabItem?: [{	by: ValueTypes["CustomerTabItemUniqueWhere"],	filter?: ValueTypes["CustomerTabItemWhere"] | undefined | null,	data: ValueTypes["CustomerTabItemUpdateInput"]},ValueTypes["CustomerTabItemUpdateResult"]],
upsertCustomerTabItem?: [{	by: ValueTypes["CustomerTabItemUniqueWhere"],	filter?: ValueTypes["CustomerTabItemWhere"] | undefined | null,	update: ValueTypes["CustomerTabItemUpdateInput"],	create: ValueTypes["CustomerTabItemCreateInput"]},ValueTypes["CustomerTabItemUpsertResult"]],
createAnonymousSession?: [{	data: ValueTypes["AnonymousSessionCreateInput"]},ValueTypes["AnonymousSessionCreateResult"]],
deleteAnonymousSession?: [{	by: ValueTypes["AnonymousSessionUniqueWhere"],	filter?: ValueTypes["AnonymousSessionWhere"] | undefined | null},ValueTypes["AnonymousSessionDeleteResult"]],
updateAnonymousSession?: [{	by: ValueTypes["AnonymousSessionUniqueWhere"],	filter?: ValueTypes["AnonymousSessionWhere"] | undefined | null,	data: ValueTypes["AnonymousSessionUpdateInput"]},ValueTypes["AnonymousSessionUpdateResult"]],
upsertAnonymousSession?: [{	by: ValueTypes["AnonymousSessionUniqueWhere"],	filter?: ValueTypes["AnonymousSessionWhere"] | undefined | null,	update: ValueTypes["AnonymousSessionUpdateInput"],	create: ValueTypes["AnonymousSessionCreateInput"]},ValueTypes["AnonymousSessionUpsertResult"]],
createVoucher?: [{	data: ValueTypes["VoucherCreateInput"]},ValueTypes["VoucherCreateResult"]],
deleteVoucher?: [{	by: ValueTypes["VoucherUniqueWhere"],	filter?: ValueTypes["VoucherWhere"] | undefined | null},ValueTypes["VoucherDeleteResult"]],
updateVoucher?: [{	by: ValueTypes["VoucherUniqueWhere"],	filter?: ValueTypes["VoucherWhere"] | undefined | null,	data: ValueTypes["VoucherUpdateInput"]},ValueTypes["VoucherUpdateResult"]],
upsertVoucher?: [{	by: ValueTypes["VoucherUniqueWhere"],	filter?: ValueTypes["VoucherWhere"] | undefined | null,	update: ValueTypes["VoucherUpdateInput"],	create: ValueTypes["VoucherCreateInput"]},ValueTypes["VoucherUpsertResult"]],
createVoucherRedemption?: [{	data: ValueTypes["VoucherRedemptionCreateInput"]},ValueTypes["VoucherRedemptionCreateResult"]],
deleteVoucherRedemption?: [{	by: ValueTypes["VoucherRedemptionUniqueWhere"],	filter?: ValueTypes["VoucherRedemptionWhere"] | undefined | null},ValueTypes["VoucherRedemptionDeleteResult"]],
updateVoucherRedemption?: [{	by: ValueTypes["VoucherRedemptionUniqueWhere"],	filter?: ValueTypes["VoucherRedemptionWhere"] | undefined | null,	data: ValueTypes["VoucherRedemptionUpdateInput"]},ValueTypes["VoucherRedemptionUpdateResult"]],
upsertVoucherRedemption?: [{	by: ValueTypes["VoucherRedemptionUniqueWhere"],	filter?: ValueTypes["VoucherRedemptionWhere"] | undefined | null,	update: ValueTypes["VoucherRedemptionUpdateInput"],	create: ValueTypes["VoucherRedemptionCreateInput"]},ValueTypes["VoucherRedemptionUpsertResult"]],
createUnassignedShiftInfo?: [{	data: ValueTypes["UnassignedShiftInfoCreateInput"]},ValueTypes["UnassignedShiftInfoCreateResult"]],
deleteUnassignedShiftInfo?: [{	by: ValueTypes["UnassignedShiftInfoUniqueWhere"],	filter?: ValueTypes["UnassignedShiftInfoWhere"] | undefined | null},ValueTypes["UnassignedShiftInfoDeleteResult"]],
updateUnassignedShiftInfo?: [{	by: ValueTypes["UnassignedShiftInfoUniqueWhere"],	filter?: ValueTypes["UnassignedShiftInfoWhere"] | undefined | null,	data: ValueTypes["UnassignedShiftInfoUpdateInput"]},ValueTypes["UnassignedShiftInfoUpdateResult"]],
upsertUnassignedShiftInfo?: [{	by: ValueTypes["UnassignedShiftInfoUniqueWhere"],	filter?: ValueTypes["UnassignedShiftInfoWhere"] | undefined | null,	update: ValueTypes["UnassignedShiftInfoUpdateInput"],	create: ValueTypes["UnassignedShiftInfoCreateInput"]},ValueTypes["UnassignedShiftInfoUpsertResult"]],
createFreshingContainer?: [{	data: ValueTypes["FreshingContainerCreateInput"]},ValueTypes["FreshingContainerCreateResult"]],
deleteFreshingContainer?: [{	by: ValueTypes["FreshingContainerUniqueWhere"],	filter?: ValueTypes["FreshingContainerWhere"] | undefined | null},ValueTypes["FreshingContainerDeleteResult"]],
updateFreshingContainer?: [{	by: ValueTypes["FreshingContainerUniqueWhere"],	filter?: ValueTypes["FreshingContainerWhere"] | undefined | null,	data: ValueTypes["FreshingContainerUpdateInput"]},ValueTypes["FreshingContainerUpdateResult"]],
upsertFreshingContainer?: [{	by: ValueTypes["FreshingContainerUniqueWhere"],	filter?: ValueTypes["FreshingContainerWhere"] | undefined | null,	update: ValueTypes["FreshingContainerUpdateInput"],	create: ValueTypes["FreshingContainerCreateInput"]},ValueTypes["FreshingContainerUpsertResult"]],
createTextItem?: [{	data: ValueTypes["TextItemCreateInput"]},ValueTypes["TextItemCreateResult"]],
deleteTextItem?: [{	by: ValueTypes["TextItemUniqueWhere"],	filter?: ValueTypes["TextItemWhere"] | undefined | null},ValueTypes["TextItemDeleteResult"]],
updateTextItem?: [{	by: ValueTypes["TextItemUniqueWhere"],	filter?: ValueTypes["TextItemWhere"] | undefined | null,	data: ValueTypes["TextItemUpdateInput"]},ValueTypes["TextItemUpdateResult"]],
upsertTextItem?: [{	by: ValueTypes["TextItemUniqueWhere"],	filter?: ValueTypes["TextItemWhere"] | undefined | null,	update: ValueTypes["TextItemUpdateInput"],	create: ValueTypes["TextItemCreateInput"]},ValueTypes["TextItemUpsertResult"]],
createTextList?: [{	data: ValueTypes["TextListCreateInput"]},ValueTypes["TextListCreateResult"]],
deleteTextList?: [{	by: ValueTypes["TextListUniqueWhere"],	filter?: ValueTypes["TextListWhere"] | undefined | null},ValueTypes["TextListDeleteResult"]],
updateTextList?: [{	by: ValueTypes["TextListUniqueWhere"],	filter?: ValueTypes["TextListWhere"] | undefined | null,	data: ValueTypes["TextListUpdateInput"]},ValueTypes["TextListUpdateResult"]],
upsertTextList?: [{	by: ValueTypes["TextListUniqueWhere"],	filter?: ValueTypes["TextListWhere"] | undefined | null,	update: ValueTypes["TextListUpdateInput"],	create: ValueTypes["TextListCreateInput"]},ValueTypes["TextListUpsertResult"]],
createDeliveryRegions?: [{	data: ValueTypes["DeliveryRegionsCreateInput"]},ValueTypes["DeliveryRegionsCreateResult"]],
deleteDeliveryRegions?: [{	by: ValueTypes["DeliveryRegionsUniqueWhere"],	filter?: ValueTypes["DeliveryRegionsWhere"] | undefined | null},ValueTypes["DeliveryRegionsDeleteResult"]],
updateDeliveryRegions?: [{	by: ValueTypes["DeliveryRegionsUniqueWhere"],	filter?: ValueTypes["DeliveryRegionsWhere"] | undefined | null,	data: ValueTypes["DeliveryRegionsUpdateInput"]},ValueTypes["DeliveryRegionsUpdateResult"]],
upsertDeliveryRegions?: [{	by: ValueTypes["DeliveryRegionsUniqueWhere"],	filter?: ValueTypes["DeliveryRegionsWhere"] | undefined | null,	update: ValueTypes["DeliveryRegionsUpdateInput"],	create: ValueTypes["DeliveryRegionsCreateInput"]},ValueTypes["DeliveryRegionsUpsertResult"]],
createDeliveryRegionsItem?: [{	data: ValueTypes["DeliveryRegionsItemCreateInput"]},ValueTypes["DeliveryRegionsItemCreateResult"]],
deleteDeliveryRegionsItem?: [{	by: ValueTypes["DeliveryRegionsItemUniqueWhere"],	filter?: ValueTypes["DeliveryRegionsItemWhere"] | undefined | null},ValueTypes["DeliveryRegionsItemDeleteResult"]],
updateDeliveryRegionsItem?: [{	by: ValueTypes["DeliveryRegionsItemUniqueWhere"],	filter?: ValueTypes["DeliveryRegionsItemWhere"] | undefined | null,	data: ValueTypes["DeliveryRegionsItemUpdateInput"]},ValueTypes["DeliveryRegionsItemUpdateResult"]],
upsertDeliveryRegionsItem?: [{	by: ValueTypes["DeliveryRegionsItemUniqueWhere"],	filter?: ValueTypes["DeliveryRegionsItemWhere"] | undefined | null,	update: ValueTypes["DeliveryRegionsItemUpdateInput"],	create: ValueTypes["DeliveryRegionsItemCreateInput"]},ValueTypes["DeliveryRegionsItemUpsertResult"]],
createImageList?: [{	data: ValueTypes["ImageListCreateInput"]},ValueTypes["ImageListCreateResult"]],
deleteImageList?: [{	by: ValueTypes["ImageListUniqueWhere"],	filter?: ValueTypes["ImageListWhere"] | undefined | null},ValueTypes["ImageListDeleteResult"]],
updateImageList?: [{	by: ValueTypes["ImageListUniqueWhere"],	filter?: ValueTypes["ImageListWhere"] | undefined | null,	data: ValueTypes["ImageListUpdateInput"]},ValueTypes["ImageListUpdateResult"]],
upsertImageList?: [{	by: ValueTypes["ImageListUniqueWhere"],	filter?: ValueTypes["ImageListWhere"] | undefined | null,	update: ValueTypes["ImageListUpdateInput"],	create: ValueTypes["ImageListCreateInput"]},ValueTypes["ImageListUpsertResult"]],
createImageListItem?: [{	data: ValueTypes["ImageListItemCreateInput"]},ValueTypes["ImageListItemCreateResult"]],
deleteImageListItem?: [{	by: ValueTypes["ImageListItemUniqueWhere"],	filter?: ValueTypes["ImageListItemWhere"] | undefined | null},ValueTypes["ImageListItemDeleteResult"]],
updateImageListItem?: [{	by: ValueTypes["ImageListItemUniqueWhere"],	filter?: ValueTypes["ImageListItemWhere"] | undefined | null,	data: ValueTypes["ImageListItemUpdateInput"]},ValueTypes["ImageListItemUpdateResult"]],
upsertImageListItem?: [{	by: ValueTypes["ImageListItemUniqueWhere"],	filter?: ValueTypes["ImageListItemWhere"] | undefined | null,	update: ValueTypes["ImageListItemUpdateInput"],	create: ValueTypes["ImageListItemCreateInput"]},ValueTypes["ImageListItemUpsertResult"]],
createTimetablesEmployeePrivileges?: [{	data: ValueTypes["TimetablesEmployeePrivilegesCreateInput"]},ValueTypes["TimetablesEmployeePrivilegesCreateResult"]],
deleteTimetablesEmployeePrivileges?: [{	by: ValueTypes["TimetablesEmployeePrivilegesUniqueWhere"],	filter?: ValueTypes["TimetablesEmployeePrivilegesWhere"] | undefined | null},ValueTypes["TimetablesEmployeePrivilegesDeleteResult"]],
updateTimetablesEmployeePrivileges?: [{	by: ValueTypes["TimetablesEmployeePrivilegesUniqueWhere"],	filter?: ValueTypes["TimetablesEmployeePrivilegesWhere"] | undefined | null,	data: ValueTypes["TimetablesEmployeePrivilegesUpdateInput"]},ValueTypes["TimetablesEmployeePrivilegesUpdateResult"]],
upsertTimetablesEmployeePrivileges?: [{	by: ValueTypes["TimetablesEmployeePrivilegesUniqueWhere"],	filter?: ValueTypes["TimetablesEmployeePrivilegesWhere"] | undefined | null,	update: ValueTypes["TimetablesEmployeePrivilegesUpdateInput"],	create: ValueTypes["TimetablesEmployeePrivilegesCreateInput"]},ValueTypes["TimetablesEmployeePrivilegesUpsertResult"]],
createTimetableDayNote?: [{	data: ValueTypes["TimetableDayNoteCreateInput"]},ValueTypes["TimetableDayNoteCreateResult"]],
deleteTimetableDayNote?: [{	by: ValueTypes["TimetableDayNoteUniqueWhere"],	filter?: ValueTypes["TimetableDayNoteWhere"] | undefined | null},ValueTypes["TimetableDayNoteDeleteResult"]],
updateTimetableDayNote?: [{	by: ValueTypes["TimetableDayNoteUniqueWhere"],	filter?: ValueTypes["TimetableDayNoteWhere"] | undefined | null,	data: ValueTypes["TimetableDayNoteUpdateInput"]},ValueTypes["TimetableDayNoteUpdateResult"]],
upsertTimetableDayNote?: [{	by: ValueTypes["TimetableDayNoteUniqueWhere"],	filter?: ValueTypes["TimetableDayNoteWhere"] | undefined | null,	update: ValueTypes["TimetableDayNoteUpdateInput"],	create: ValueTypes["TimetableDayNoteCreateInput"]},ValueTypes["TimetableDayNoteUpsertResult"]],
createDeliveryMethodLocale?: [{	data: ValueTypes["DeliveryMethodLocaleCreateInput"]},ValueTypes["DeliveryMethodLocaleCreateResult"]],
deleteDeliveryMethodLocale?: [{	by: ValueTypes["DeliveryMethodLocaleUniqueWhere"],	filter?: ValueTypes["DeliveryMethodLocaleWhere"] | undefined | null},ValueTypes["DeliveryMethodLocaleDeleteResult"]],
updateDeliveryMethodLocale?: [{	by: ValueTypes["DeliveryMethodLocaleUniqueWhere"],	filter?: ValueTypes["DeliveryMethodLocaleWhere"] | undefined | null,	data: ValueTypes["DeliveryMethodLocaleUpdateInput"]},ValueTypes["DeliveryMethodLocaleUpdateResult"]],
upsertDeliveryMethodLocale?: [{	by: ValueTypes["DeliveryMethodLocaleUniqueWhere"],	filter?: ValueTypes["DeliveryMethodLocaleWhere"] | undefined | null,	update: ValueTypes["DeliveryMethodLocaleUpdateInput"],	create: ValueTypes["DeliveryMethodLocaleCreateInput"]},ValueTypes["DeliveryMethodLocaleUpsertResult"]],
createIngredientSupplier?: [{	data: ValueTypes["IngredientSupplierCreateInput"]},ValueTypes["IngredientSupplierCreateResult"]],
deleteIngredientSupplier?: [{	by: ValueTypes["IngredientSupplierUniqueWhere"],	filter?: ValueTypes["IngredientSupplierWhere"] | undefined | null},ValueTypes["IngredientSupplierDeleteResult"]],
updateIngredientSupplier?: [{	by: ValueTypes["IngredientSupplierUniqueWhere"],	filter?: ValueTypes["IngredientSupplierWhere"] | undefined | null,	data: ValueTypes["IngredientSupplierUpdateInput"]},ValueTypes["IngredientSupplierUpdateResult"]],
upsertIngredientSupplier?: [{	by: ValueTypes["IngredientSupplierUniqueWhere"],	filter?: ValueTypes["IngredientSupplierWhere"] | undefined | null,	update: ValueTypes["IngredientSupplierUpdateInput"],	create: ValueTypes["IngredientSupplierCreateInput"]},ValueTypes["IngredientSupplierUpsertResult"]],
createIngredientSupplierItem?: [{	data: ValueTypes["IngredientSupplierItemCreateInput"]},ValueTypes["IngredientSupplierItemCreateResult"]],
deleteIngredientSupplierItem?: [{	by: ValueTypes["IngredientSupplierItemUniqueWhere"],	filter?: ValueTypes["IngredientSupplierItemWhere"] | undefined | null},ValueTypes["IngredientSupplierItemDeleteResult"]],
updateIngredientSupplierItem?: [{	by: ValueTypes["IngredientSupplierItemUniqueWhere"],	filter?: ValueTypes["IngredientSupplierItemWhere"] | undefined | null,	data: ValueTypes["IngredientSupplierItemUpdateInput"]},ValueTypes["IngredientSupplierItemUpdateResult"]],
upsertIngredientSupplierItem?: [{	by: ValueTypes["IngredientSupplierItemUniqueWhere"],	filter?: ValueTypes["IngredientSupplierItemWhere"] | undefined | null,	update: ValueTypes["IngredientSupplierItemUpdateInput"],	create: ValueTypes["IngredientSupplierItemCreateInput"]},ValueTypes["IngredientSupplierItemUpsertResult"]],
createIngredientSupplierList?: [{	data: ValueTypes["IngredientSupplierListCreateInput"]},ValueTypes["IngredientSupplierListCreateResult"]],
deleteIngredientSupplierList?: [{	by: ValueTypes["IngredientSupplierListUniqueWhere"],	filter?: ValueTypes["IngredientSupplierListWhere"] | undefined | null},ValueTypes["IngredientSupplierListDeleteResult"]],
updateIngredientSupplierList?: [{	by: ValueTypes["IngredientSupplierListUniqueWhere"],	filter?: ValueTypes["IngredientSupplierListWhere"] | undefined | null,	data: ValueTypes["IngredientSupplierListUpdateInput"]},ValueTypes["IngredientSupplierListUpdateResult"]],
upsertIngredientSupplierList?: [{	by: ValueTypes["IngredientSupplierListUniqueWhere"],	filter?: ValueTypes["IngredientSupplierListWhere"] | undefined | null,	update: ValueTypes["IngredientSupplierListUpdateInput"],	create: ValueTypes["IngredientSupplierListCreateInput"]},ValueTypes["IngredientSupplierListUpsertResult"]],
createIngredientSupplierLocale?: [{	data: ValueTypes["IngredientSupplierLocaleCreateInput"]},ValueTypes["IngredientSupplierLocaleCreateResult"]],
deleteIngredientSupplierLocale?: [{	by: ValueTypes["IngredientSupplierLocaleUniqueWhere"],	filter?: ValueTypes["IngredientSupplierLocaleWhere"] | undefined | null},ValueTypes["IngredientSupplierLocaleDeleteResult"]],
updateIngredientSupplierLocale?: [{	by: ValueTypes["IngredientSupplierLocaleUniqueWhere"],	filter?: ValueTypes["IngredientSupplierLocaleWhere"] | undefined | null,	data: ValueTypes["IngredientSupplierLocaleUpdateInput"]},ValueTypes["IngredientSupplierLocaleUpdateResult"]],
upsertIngredientSupplierLocale?: [{	by: ValueTypes["IngredientSupplierLocaleUniqueWhere"],	filter?: ValueTypes["IngredientSupplierLocaleWhere"] | undefined | null,	update: ValueTypes["IngredientSupplierLocaleUpdateInput"],	create: ValueTypes["IngredientSupplierLocaleCreateInput"]},ValueTypes["IngredientSupplierLocaleUpsertResult"]],
createRedirect?: [{	data: ValueTypes["RedirectCreateInput"]},ValueTypes["RedirectCreateResult"]],
deleteRedirect?: [{	by: ValueTypes["RedirectUniqueWhere"],	filter?: ValueTypes["RedirectWhere"] | undefined | null},ValueTypes["RedirectDeleteResult"]],
updateRedirect?: [{	by: ValueTypes["RedirectUniqueWhere"],	filter?: ValueTypes["RedirectWhere"] | undefined | null,	data: ValueTypes["RedirectUpdateInput"]},ValueTypes["RedirectUpdateResult"]],
upsertRedirect?: [{	by: ValueTypes["RedirectUniqueWhere"],	filter?: ValueTypes["RedirectWhere"] | undefined | null,	update: ValueTypes["RedirectUpdateInput"],	create: ValueTypes["RedirectCreateInput"]},ValueTypes["RedirectUpsertResult"]],
createNutritionFacts?: [{	data: ValueTypes["NutritionFactsCreateInput"]},ValueTypes["NutritionFactsCreateResult"]],
deleteNutritionFacts?: [{	by: ValueTypes["NutritionFactsUniqueWhere"],	filter?: ValueTypes["NutritionFactsWhere"] | undefined | null},ValueTypes["NutritionFactsDeleteResult"]],
updateNutritionFacts?: [{	by: ValueTypes["NutritionFactsUniqueWhere"],	filter?: ValueTypes["NutritionFactsWhere"] | undefined | null,	data: ValueTypes["NutritionFactsUpdateInput"]},ValueTypes["NutritionFactsUpdateResult"]],
upsertNutritionFacts?: [{	by: ValueTypes["NutritionFactsUniqueWhere"],	filter?: ValueTypes["NutritionFactsWhere"] | undefined | null,	update: ValueTypes["NutritionFactsUpdateInput"],	create: ValueTypes["NutritionFactsCreateInput"]},ValueTypes["NutritionFactsUpsertResult"]],
createVenue?: [{	data: ValueTypes["VenueCreateInput"]},ValueTypes["VenueCreateResult"]],
deleteVenue?: [{	by: ValueTypes["VenueUniqueWhere"],	filter?: ValueTypes["VenueWhere"] | undefined | null},ValueTypes["VenueDeleteResult"]],
updateVenue?: [{	by: ValueTypes["VenueUniqueWhere"],	filter?: ValueTypes["VenueWhere"] | undefined | null,	data: ValueTypes["VenueUpdateInput"]},ValueTypes["VenueUpdateResult"]],
upsertVenue?: [{	by: ValueTypes["VenueUniqueWhere"],	filter?: ValueTypes["VenueWhere"] | undefined | null,	update: ValueTypes["VenueUpdateInput"],	create: ValueTypes["VenueCreateInput"]},ValueTypes["VenueUpsertResult"]],
createWorkspace?: [{	data: ValueTypes["WorkspaceCreateInput"]},ValueTypes["WorkspaceCreateResult"]],
deleteWorkspace?: [{	by: ValueTypes["WorkspaceUniqueWhere"],	filter?: ValueTypes["WorkspaceWhere"] | undefined | null},ValueTypes["WorkspaceDeleteResult"]],
updateWorkspace?: [{	by: ValueTypes["WorkspaceUniqueWhere"],	filter?: ValueTypes["WorkspaceWhere"] | undefined | null,	data: ValueTypes["WorkspaceUpdateInput"]},ValueTypes["WorkspaceUpdateResult"]],
upsertWorkspace?: [{	by: ValueTypes["WorkspaceUniqueWhere"],	filter?: ValueTypes["WorkspaceWhere"] | undefined | null,	update: ValueTypes["WorkspaceUpdateInput"],	create: ValueTypes["WorkspaceCreateInput"]},ValueTypes["WorkspaceUpsertResult"]],
createInternalBuyer?: [{	data: ValueTypes["InternalBuyerCreateInput"]},ValueTypes["InternalBuyerCreateResult"]],
deleteInternalBuyer?: [{	by: ValueTypes["InternalBuyerUniqueWhere"],	filter?: ValueTypes["InternalBuyerWhere"] | undefined | null},ValueTypes["InternalBuyerDeleteResult"]],
updateInternalBuyer?: [{	by: ValueTypes["InternalBuyerUniqueWhere"],	filter?: ValueTypes["InternalBuyerWhere"] | undefined | null,	data: ValueTypes["InternalBuyerUpdateInput"]},ValueTypes["InternalBuyerUpdateResult"]],
upsertInternalBuyer?: [{	by: ValueTypes["InternalBuyerUniqueWhere"],	filter?: ValueTypes["InternalBuyerWhere"] | undefined | null,	update: ValueTypes["InternalBuyerUpdateInput"],	create: ValueTypes["InternalBuyerCreateInput"]},ValueTypes["InternalBuyerUpsertResult"]],
createVenueEmployeeRole?: [{	data: ValueTypes["VenueEmployeeRoleCreateInput"]},ValueTypes["VenueEmployeeRoleCreateResult"]],
deleteVenueEmployeeRole?: [{	by: ValueTypes["VenueEmployeeRoleUniqueWhere"],	filter?: ValueTypes["VenueEmployeeRoleWhere"] | undefined | null},ValueTypes["VenueEmployeeRoleDeleteResult"]],
updateVenueEmployeeRole?: [{	by: ValueTypes["VenueEmployeeRoleUniqueWhere"],	filter?: ValueTypes["VenueEmployeeRoleWhere"] | undefined | null,	data: ValueTypes["VenueEmployeeRoleUpdateInput"]},ValueTypes["VenueEmployeeRoleUpdateResult"]],
upsertVenueEmployeeRole?: [{	by: ValueTypes["VenueEmployeeRoleUniqueWhere"],	filter?: ValueTypes["VenueEmployeeRoleWhere"] | undefined | null,	update: ValueTypes["VenueEmployeeRoleUpdateInput"],	create: ValueTypes["VenueEmployeeRoleCreateInput"]},ValueTypes["VenueEmployeeRoleUpsertResult"]],
createIdentificationAttempt?: [{	data: ValueTypes["IdentificationAttemptCreateInput"]},ValueTypes["IdentificationAttemptCreateResult"]],
deleteIdentificationAttempt?: [{	by: ValueTypes["IdentificationAttemptUniqueWhere"],	filter?: ValueTypes["IdentificationAttemptWhere"] | undefined | null},ValueTypes["IdentificationAttemptDeleteResult"]],
updateIdentificationAttempt?: [{	by: ValueTypes["IdentificationAttemptUniqueWhere"],	filter?: ValueTypes["IdentificationAttemptWhere"] | undefined | null,	data: ValueTypes["IdentificationAttemptUpdateInput"]},ValueTypes["IdentificationAttemptUpdateResult"]],
upsertIdentificationAttempt?: [{	by: ValueTypes["IdentificationAttemptUniqueWhere"],	filter?: ValueTypes["IdentificationAttemptWhere"] | undefined | null,	update: ValueTypes["IdentificationAttemptUpdateInput"],	create: ValueTypes["IdentificationAttemptCreateInput"]},ValueTypes["IdentificationAttemptUpsertResult"]],
createIdentificationCode?: [{	data: ValueTypes["IdentificationCodeCreateInput"]},ValueTypes["IdentificationCodeCreateResult"]],
deleteIdentificationCode?: [{	by: ValueTypes["IdentificationCodeUniqueWhere"],	filter?: ValueTypes["IdentificationCodeWhere"] | undefined | null},ValueTypes["IdentificationCodeDeleteResult"]],
updateIdentificationCode?: [{	by: ValueTypes["IdentificationCodeUniqueWhere"],	filter?: ValueTypes["IdentificationCodeWhere"] | undefined | null,	data: ValueTypes["IdentificationCodeUpdateInput"]},ValueTypes["IdentificationCodeUpdateResult"]],
upsertIdentificationCode?: [{	by: ValueTypes["IdentificationCodeUniqueWhere"],	filter?: ValueTypes["IdentificationCodeWhere"] | undefined | null,	update: ValueTypes["IdentificationCodeUpdateInput"],	create: ValueTypes["IdentificationCodeCreateInput"]},ValueTypes["IdentificationCodeUpsertResult"]],
createIdentificationCodeLocale?: [{	data: ValueTypes["IdentificationCodeLocaleCreateInput"]},ValueTypes["IdentificationCodeLocaleCreateResult"]],
deleteIdentificationCodeLocale?: [{	by: ValueTypes["IdentificationCodeLocaleUniqueWhere"],	filter?: ValueTypes["IdentificationCodeLocaleWhere"] | undefined | null},ValueTypes["IdentificationCodeLocaleDeleteResult"]],
updateIdentificationCodeLocale?: [{	by: ValueTypes["IdentificationCodeLocaleUniqueWhere"],	filter?: ValueTypes["IdentificationCodeLocaleWhere"] | undefined | null,	data: ValueTypes["IdentificationCodeLocaleUpdateInput"]},ValueTypes["IdentificationCodeLocaleUpdateResult"]],
upsertIdentificationCodeLocale?: [{	by: ValueTypes["IdentificationCodeLocaleUniqueWhere"],	filter?: ValueTypes["IdentificationCodeLocaleWhere"] | undefined | null,	update: ValueTypes["IdentificationCodeLocaleUpdateInput"],	create: ValueTypes["IdentificationCodeLocaleCreateInput"]},ValueTypes["IdentificationCodeLocaleUpsertResult"]],
createPipeline?: [{	data: ValueTypes["PipelineCreateInput"]},ValueTypes["PipelineCreateResult"]],
deletePipeline?: [{	by: ValueTypes["PipelineUniqueWhere"],	filter?: ValueTypes["PipelineWhere"] | undefined | null},ValueTypes["PipelineDeleteResult"]],
updatePipeline?: [{	by: ValueTypes["PipelineUniqueWhere"],	filter?: ValueTypes["PipelineWhere"] | undefined | null,	data: ValueTypes["PipelineUpdateInput"]},ValueTypes["PipelineUpdateResult"]],
upsertPipeline?: [{	by: ValueTypes["PipelineUniqueWhere"],	filter?: ValueTypes["PipelineWhere"] | undefined | null,	update: ValueTypes["PipelineUpdateInput"],	create: ValueTypes["PipelineCreateInput"]},ValueTypes["PipelineUpsertResult"]],
createPipelineLead?: [{	data: ValueTypes["PipelineLeadCreateInput"]},ValueTypes["PipelineLeadCreateResult"]],
deletePipelineLead?: [{	by: ValueTypes["PipelineLeadUniqueWhere"],	filter?: ValueTypes["PipelineLeadWhere"] | undefined | null},ValueTypes["PipelineLeadDeleteResult"]],
updatePipelineLead?: [{	by: ValueTypes["PipelineLeadUniqueWhere"],	filter?: ValueTypes["PipelineLeadWhere"] | undefined | null,	data: ValueTypes["PipelineLeadUpdateInput"]},ValueTypes["PipelineLeadUpdateResult"]],
upsertPipelineLead?: [{	by: ValueTypes["PipelineLeadUniqueWhere"],	filter?: ValueTypes["PipelineLeadWhere"] | undefined | null,	update: ValueTypes["PipelineLeadUpdateInput"],	create: ValueTypes["PipelineLeadCreateInput"]},ValueTypes["PipelineLeadUpsertResult"]],
createPipelineStage?: [{	data: ValueTypes["PipelineStageCreateInput"]},ValueTypes["PipelineStageCreateResult"]],
deletePipelineStage?: [{	by: ValueTypes["PipelineStageUniqueWhere"],	filter?: ValueTypes["PipelineStageWhere"] | undefined | null},ValueTypes["PipelineStageDeleteResult"]],
updatePipelineStage?: [{	by: ValueTypes["PipelineStageUniqueWhere"],	filter?: ValueTypes["PipelineStageWhere"] | undefined | null,	data: ValueTypes["PipelineStageUpdateInput"]},ValueTypes["PipelineStageUpdateResult"]],
upsertPipelineStage?: [{	by: ValueTypes["PipelineStageUniqueWhere"],	filter?: ValueTypes["PipelineStageWhere"] | undefined | null,	update: ValueTypes["PipelineStageUpdateInput"],	create: ValueTypes["PipelineStageCreateInput"]},ValueTypes["PipelineStageUpsertResult"]],
createPipelineStageItem?: [{	data: ValueTypes["PipelineStageItemCreateInput"]},ValueTypes["PipelineStageItemCreateResult"]],
deletePipelineStageItem?: [{	by: ValueTypes["PipelineStageItemUniqueWhere"],	filter?: ValueTypes["PipelineStageItemWhere"] | undefined | null},ValueTypes["PipelineStageItemDeleteResult"]],
updatePipelineStageItem?: [{	by: ValueTypes["PipelineStageItemUniqueWhere"],	filter?: ValueTypes["PipelineStageItemWhere"] | undefined | null,	data: ValueTypes["PipelineStageItemUpdateInput"]},ValueTypes["PipelineStageItemUpdateResult"]],
upsertPipelineStageItem?: [{	by: ValueTypes["PipelineStageItemUniqueWhere"],	filter?: ValueTypes["PipelineStageItemWhere"] | undefined | null,	update: ValueTypes["PipelineStageItemUpdateInput"],	create: ValueTypes["PipelineStageItemCreateInput"]},ValueTypes["PipelineStageItemUpsertResult"]],
createPipelineStageLocale?: [{	data: ValueTypes["PipelineStageLocaleCreateInput"]},ValueTypes["PipelineStageLocaleCreateResult"]],
deletePipelineStageLocale?: [{	by: ValueTypes["PipelineStageLocaleUniqueWhere"],	filter?: ValueTypes["PipelineStageLocaleWhere"] | undefined | null},ValueTypes["PipelineStageLocaleDeleteResult"]],
updatePipelineStageLocale?: [{	by: ValueTypes["PipelineStageLocaleUniqueWhere"],	filter?: ValueTypes["PipelineStageLocaleWhere"] | undefined | null,	data: ValueTypes["PipelineStageLocaleUpdateInput"]},ValueTypes["PipelineStageLocaleUpdateResult"]],
upsertPipelineStageLocale?: [{	by: ValueTypes["PipelineStageLocaleUniqueWhere"],	filter?: ValueTypes["PipelineStageLocaleWhere"] | undefined | null,	update: ValueTypes["PipelineStageLocaleUpdateInput"],	create: ValueTypes["PipelineStageLocaleCreateInput"]},ValueTypes["PipelineStageLocaleUpsertResult"]],
createSalesManager?: [{	data: ValueTypes["SalesManagerCreateInput"]},ValueTypes["SalesManagerCreateResult"]],
deleteSalesManager?: [{	by: ValueTypes["SalesManagerUniqueWhere"],	filter?: ValueTypes["SalesManagerWhere"] | undefined | null},ValueTypes["SalesManagerDeleteResult"]],
updateSalesManager?: [{	by: ValueTypes["SalesManagerUniqueWhere"],	filter?: ValueTypes["SalesManagerWhere"] | undefined | null,	data: ValueTypes["SalesManagerUpdateInput"]},ValueTypes["SalesManagerUpdateResult"]],
upsertSalesManager?: [{	by: ValueTypes["SalesManagerUniqueWhere"],	filter?: ValueTypes["SalesManagerWhere"] | undefined | null,	update: ValueTypes["SalesManagerUpdateInput"],	create: ValueTypes["SalesManagerCreateInput"]},ValueTypes["SalesManagerUpsertResult"]],
createCashierManager?: [{	data: ValueTypes["CashierManagerCreateInput"]},ValueTypes["CashierManagerCreateResult"]],
deleteCashierManager?: [{	by: ValueTypes["CashierManagerUniqueWhere"],	filter?: ValueTypes["CashierManagerWhere"] | undefined | null},ValueTypes["CashierManagerDeleteResult"]],
updateCashierManager?: [{	by: ValueTypes["CashierManagerUniqueWhere"],	filter?: ValueTypes["CashierManagerWhere"] | undefined | null,	data: ValueTypes["CashierManagerUpdateInput"]},ValueTypes["CashierManagerUpdateResult"]],
upsertCashierManager?: [{	by: ValueTypes["CashierManagerUniqueWhere"],	filter?: ValueTypes["CashierManagerWhere"] | undefined | null,	update: ValueTypes["CashierManagerUpdateInput"],	create: ValueTypes["CashierManagerCreateInput"]},ValueTypes["CashierManagerUpsertResult"]],
createPointOfSaleApplicationDevice?: [{	data: ValueTypes["PointOfSaleApplicationDeviceCreateInput"]},ValueTypes["PointOfSaleApplicationDeviceCreateResult"]],
deletePointOfSaleApplicationDevice?: [{	by: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"],	filter?: ValueTypes["PointOfSaleApplicationDeviceWhere"] | undefined | null},ValueTypes["PointOfSaleApplicationDeviceDeleteResult"]],
updatePointOfSaleApplicationDevice?: [{	by: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"],	filter?: ValueTypes["PointOfSaleApplicationDeviceWhere"] | undefined | null,	data: ValueTypes["PointOfSaleApplicationDeviceUpdateInput"]},ValueTypes["PointOfSaleApplicationDeviceUpdateResult"]],
upsertPointOfSaleApplicationDevice?: [{	by: ValueTypes["PointOfSaleApplicationDeviceUniqueWhere"],	filter?: ValueTypes["PointOfSaleApplicationDeviceWhere"] | undefined | null,	update: ValueTypes["PointOfSaleApplicationDeviceUpdateInput"],	create: ValueTypes["PointOfSaleApplicationDeviceCreateInput"]},ValueTypes["PointOfSaleApplicationDeviceUpsertResult"]],
createPointOfSaleTerminal?: [{	data: ValueTypes["PointOfSaleTerminalCreateInput"]},ValueTypes["PointOfSaleTerminalCreateResult"]],
deletePointOfSaleTerminal?: [{	by: ValueTypes["PointOfSaleTerminalUniqueWhere"],	filter?: ValueTypes["PointOfSaleTerminalWhere"] | undefined | null},ValueTypes["PointOfSaleTerminalDeleteResult"]],
updatePointOfSaleTerminal?: [{	by: ValueTypes["PointOfSaleTerminalUniqueWhere"],	filter?: ValueTypes["PointOfSaleTerminalWhere"] | undefined | null,	data: ValueTypes["PointOfSaleTerminalUpdateInput"]},ValueTypes["PointOfSaleTerminalUpdateResult"]],
upsertPointOfSaleTerminal?: [{	by: ValueTypes["PointOfSaleTerminalUniqueWhere"],	filter?: ValueTypes["PointOfSaleTerminalWhere"] | undefined | null,	update: ValueTypes["PointOfSaleTerminalUpdateInput"],	create: ValueTypes["PointOfSaleTerminalCreateInput"]},ValueTypes["PointOfSaleTerminalUpsertResult"]],
createPipelineStageSentiment?: [{	data: ValueTypes["PipelineStageSentimentCreateInput"]},ValueTypes["PipelineStageSentimentCreateResult"]],
deletePipelineStageSentiment?: [{	by: ValueTypes["PipelineStageSentimentUniqueWhere"],	filter?: ValueTypes["PipelineStageSentimentWhere"] | undefined | null},ValueTypes["PipelineStageSentimentDeleteResult"]],
updatePipelineStageSentiment?: [{	by: ValueTypes["PipelineStageSentimentUniqueWhere"],	filter?: ValueTypes["PipelineStageSentimentWhere"] | undefined | null,	data: ValueTypes["PipelineStageSentimentUpdateInput"]},ValueTypes["PipelineStageSentimentUpdateResult"]],
upsertPipelineStageSentiment?: [{	by: ValueTypes["PipelineStageSentimentUniqueWhere"],	filter?: ValueTypes["PipelineStageSentimentWhere"] | undefined | null,	update: ValueTypes["PipelineStageSentimentUpdateInput"],	create: ValueTypes["PipelineStageSentimentCreateInput"]},ValueTypes["PipelineStageSentimentUpsertResult"]],
createDeviceIdentifier?: [{	data: ValueTypes["DeviceIdentifierCreateInput"]},ValueTypes["DeviceIdentifierCreateResult"]],
deleteDeviceIdentifier?: [{	by: ValueTypes["DeviceIdentifierUniqueWhere"],	filter?: ValueTypes["DeviceIdentifierWhere"] | undefined | null},ValueTypes["DeviceIdentifierDeleteResult"]],
updateDeviceIdentifier?: [{	by: ValueTypes["DeviceIdentifierUniqueWhere"],	filter?: ValueTypes["DeviceIdentifierWhere"] | undefined | null,	data: ValueTypes["DeviceIdentifierUpdateInput"]},ValueTypes["DeviceIdentifierUpdateResult"]],
upsertDeviceIdentifier?: [{	by: ValueTypes["DeviceIdentifierUniqueWhere"],	filter?: ValueTypes["DeviceIdentifierWhere"] | undefined | null,	update: ValueTypes["DeviceIdentifierUpdateInput"],	create: ValueTypes["DeviceIdentifierCreateInput"]},ValueTypes["DeviceIdentifierUpsertResult"]],
createPointOfSalePrinter?: [{	data: ValueTypes["PointOfSalePrinterCreateInput"]},ValueTypes["PointOfSalePrinterCreateResult"]],
deletePointOfSalePrinter?: [{	by: ValueTypes["PointOfSalePrinterUniqueWhere"],	filter?: ValueTypes["PointOfSalePrinterWhere"] | undefined | null},ValueTypes["PointOfSalePrinterDeleteResult"]],
updatePointOfSalePrinter?: [{	by: ValueTypes["PointOfSalePrinterUniqueWhere"],	filter?: ValueTypes["PointOfSalePrinterWhere"] | undefined | null,	data: ValueTypes["PointOfSalePrinterUpdateInput"]},ValueTypes["PointOfSalePrinterUpdateResult"]],
upsertPointOfSalePrinter?: [{	by: ValueTypes["PointOfSalePrinterUniqueWhere"],	filter?: ValueTypes["PointOfSalePrinterWhere"] | undefined | null,	update: ValueTypes["PointOfSalePrinterUpdateInput"],	create: ValueTypes["PointOfSalePrinterCreateInput"]},ValueTypes["PointOfSalePrinterUpsertResult"]],
createGratuity?: [{	data: ValueTypes["GratuityCreateInput"]},ValueTypes["GratuityCreateResult"]],
deleteGratuity?: [{	by: ValueTypes["GratuityUniqueWhere"],	filter?: ValueTypes["GratuityWhere"] | undefined | null},ValueTypes["GratuityDeleteResult"]],
updateGratuity?: [{	by: ValueTypes["GratuityUniqueWhere"],	filter?: ValueTypes["GratuityWhere"] | undefined | null,	data: ValueTypes["GratuityUpdateInput"]},ValueTypes["GratuityUpdateResult"]],
upsertGratuity?: [{	by: ValueTypes["GratuityUniqueWhere"],	filter?: ValueTypes["GratuityWhere"] | undefined | null,	update: ValueTypes["GratuityUpdateInput"],	create: ValueTypes["GratuityCreateInput"]},ValueTypes["GratuityUpsertResult"]],
createFulfillmentNote?: [{	data: ValueTypes["FulfillmentNoteCreateInput"]},ValueTypes["FulfillmentNoteCreateResult"]],
deleteFulfillmentNote?: [{	by: ValueTypes["FulfillmentNoteUniqueWhere"],	filter?: ValueTypes["FulfillmentNoteWhere"] | undefined | null},ValueTypes["FulfillmentNoteDeleteResult"]],
updateFulfillmentNote?: [{	by: ValueTypes["FulfillmentNoteUniqueWhere"],	filter?: ValueTypes["FulfillmentNoteWhere"] | undefined | null,	data: ValueTypes["FulfillmentNoteUpdateInput"]},ValueTypes["FulfillmentNoteUpdateResult"]],
upsertFulfillmentNote?: [{	by: ValueTypes["FulfillmentNoteUniqueWhere"],	filter?: ValueTypes["FulfillmentNoteWhere"] | undefined | null,	update: ValueTypes["FulfillmentNoteUpdateInput"],	create: ValueTypes["FulfillmentNoteCreateInput"]},ValueTypes["FulfillmentNoteUpsertResult"]],
createLeadForm?: [{	data: ValueTypes["LeadFormCreateInput"]},ValueTypes["LeadFormCreateResult"]],
deleteLeadForm?: [{	by: ValueTypes["LeadFormUniqueWhere"],	filter?: ValueTypes["LeadFormWhere"] | undefined | null},ValueTypes["LeadFormDeleteResult"]],
updateLeadForm?: [{	by: ValueTypes["LeadFormUniqueWhere"],	filter?: ValueTypes["LeadFormWhere"] | undefined | null,	data: ValueTypes["LeadFormUpdateInput"]},ValueTypes["LeadFormUpdateResult"]],
upsertLeadForm?: [{	by: ValueTypes["LeadFormUniqueWhere"],	filter?: ValueTypes["LeadFormWhere"] | undefined | null,	update: ValueTypes["LeadFormUpdateInput"],	create: ValueTypes["LeadFormCreateInput"]},ValueTypes["LeadFormUpsertResult"]],
createSubscriptionBox?: [{	data: ValueTypes["SubscriptionBoxCreateInput"]},ValueTypes["SubscriptionBoxCreateResult"]],
deleteSubscriptionBox?: [{	by: ValueTypes["SubscriptionBoxUniqueWhere"],	filter?: ValueTypes["SubscriptionBoxWhere"] | undefined | null},ValueTypes["SubscriptionBoxDeleteResult"]],
updateSubscriptionBox?: [{	by: ValueTypes["SubscriptionBoxUniqueWhere"],	filter?: ValueTypes["SubscriptionBoxWhere"] | undefined | null,	data: ValueTypes["SubscriptionBoxUpdateInput"]},ValueTypes["SubscriptionBoxUpdateResult"]],
upsertSubscriptionBox?: [{	by: ValueTypes["SubscriptionBoxUniqueWhere"],	filter?: ValueTypes["SubscriptionBoxWhere"] | undefined | null,	update: ValueTypes["SubscriptionBoxUpdateInput"],	create: ValueTypes["SubscriptionBoxCreateInput"]},ValueTypes["SubscriptionBoxUpsertResult"]],
createSubscriptionBoxLocale?: [{	data: ValueTypes["SubscriptionBoxLocaleCreateInput"]},ValueTypes["SubscriptionBoxLocaleCreateResult"]],
deleteSubscriptionBoxLocale?: [{	by: ValueTypes["SubscriptionBoxLocaleUniqueWhere"],	filter?: ValueTypes["SubscriptionBoxLocaleWhere"] | undefined | null},ValueTypes["SubscriptionBoxLocaleDeleteResult"]],
updateSubscriptionBoxLocale?: [{	by: ValueTypes["SubscriptionBoxLocaleUniqueWhere"],	filter?: ValueTypes["SubscriptionBoxLocaleWhere"] | undefined | null,	data: ValueTypes["SubscriptionBoxLocaleUpdateInput"]},ValueTypes["SubscriptionBoxLocaleUpdateResult"]],
upsertSubscriptionBoxLocale?: [{	by: ValueTypes["SubscriptionBoxLocaleUniqueWhere"],	filter?: ValueTypes["SubscriptionBoxLocaleWhere"] | undefined | null,	update: ValueTypes["SubscriptionBoxLocaleUpdateInput"],	create: ValueTypes["SubscriptionBoxLocaleCreateInput"]},ValueTypes["SubscriptionBoxLocaleUpsertResult"]],
createBusinessService?: [{	data: ValueTypes["BusinessServiceCreateInput"]},ValueTypes["BusinessServiceCreateResult"]],
deleteBusinessService?: [{	by: ValueTypes["BusinessServiceUniqueWhere"],	filter?: ValueTypes["BusinessServiceWhere"] | undefined | null},ValueTypes["BusinessServiceDeleteResult"]],
updateBusinessService?: [{	by: ValueTypes["BusinessServiceUniqueWhere"],	filter?: ValueTypes["BusinessServiceWhere"] | undefined | null,	data: ValueTypes["BusinessServiceUpdateInput"]},ValueTypes["BusinessServiceUpdateResult"]],
upsertBusinessService?: [{	by: ValueTypes["BusinessServiceUniqueWhere"],	filter?: ValueTypes["BusinessServiceWhere"] | undefined | null,	update: ValueTypes["BusinessServiceUpdateInput"],	create: ValueTypes["BusinessServiceCreateInput"]},ValueTypes["BusinessServiceUpsertResult"]],
createBusinessServiceEvent?: [{	data: ValueTypes["BusinessServiceEventCreateInput"]},ValueTypes["BusinessServiceEventCreateResult"]],
deleteBusinessServiceEvent?: [{	by: ValueTypes["BusinessServiceEventUniqueWhere"],	filter?: ValueTypes["BusinessServiceEventWhere"] | undefined | null},ValueTypes["BusinessServiceEventDeleteResult"]],
updateBusinessServiceEvent?: [{	by: ValueTypes["BusinessServiceEventUniqueWhere"],	filter?: ValueTypes["BusinessServiceEventWhere"] | undefined | null,	data: ValueTypes["BusinessServiceEventUpdateInput"]},ValueTypes["BusinessServiceEventUpdateResult"]],
upsertBusinessServiceEvent?: [{	by: ValueTypes["BusinessServiceEventUniqueWhere"],	filter?: ValueTypes["BusinessServiceEventWhere"] | undefined | null,	update: ValueTypes["BusinessServiceEventUpdateInput"],	create: ValueTypes["BusinessServiceEventCreateInput"]},ValueTypes["BusinessServiceEventUpsertResult"]],
createBusinessServiceLocale?: [{	data: ValueTypes["BusinessServiceLocaleCreateInput"]},ValueTypes["BusinessServiceLocaleCreateResult"]],
deleteBusinessServiceLocale?: [{	by: ValueTypes["BusinessServiceLocaleUniqueWhere"],	filter?: ValueTypes["BusinessServiceLocaleWhere"] | undefined | null},ValueTypes["BusinessServiceLocaleDeleteResult"]],
updateBusinessServiceLocale?: [{	by: ValueTypes["BusinessServiceLocaleUniqueWhere"],	filter?: ValueTypes["BusinessServiceLocaleWhere"] | undefined | null,	data: ValueTypes["BusinessServiceLocaleUpdateInput"]},ValueTypes["BusinessServiceLocaleUpdateResult"]],
upsertBusinessServiceLocale?: [{	by: ValueTypes["BusinessServiceLocaleUniqueWhere"],	filter?: ValueTypes["BusinessServiceLocaleWhere"] | undefined | null,	update: ValueTypes["BusinessServiceLocaleUpdateInput"],	create: ValueTypes["BusinessServiceLocaleCreateInput"]},ValueTypes["BusinessServiceLocaleUpsertResult"]],
createGridTileItem?: [{	data: ValueTypes["GridTileItemCreateInput"]},ValueTypes["GridTileItemCreateResult"]],
deleteGridTileItem?: [{	by: ValueTypes["GridTileItemUniqueWhere"],	filter?: ValueTypes["GridTileItemWhere"] | undefined | null},ValueTypes["GridTileItemDeleteResult"]],
updateGridTileItem?: [{	by: ValueTypes["GridTileItemUniqueWhere"],	filter?: ValueTypes["GridTileItemWhere"] | undefined | null,	data: ValueTypes["GridTileItemUpdateInput"]},ValueTypes["GridTileItemUpdateResult"]],
upsertGridTileItem?: [{	by: ValueTypes["GridTileItemUniqueWhere"],	filter?: ValueTypes["GridTileItemWhere"] | undefined | null,	update: ValueTypes["GridTileItemUpdateInput"],	create: ValueTypes["GridTileItemCreateInput"]},ValueTypes["GridTileItemUpsertResult"]],
createGridTiles?: [{	data: ValueTypes["GridTilesCreateInput"]},ValueTypes["GridTilesCreateResult"]],
deleteGridTiles?: [{	by: ValueTypes["GridTilesUniqueWhere"],	filter?: ValueTypes["GridTilesWhere"] | undefined | null},ValueTypes["GridTilesDeleteResult"]],
updateGridTiles?: [{	by: ValueTypes["GridTilesUniqueWhere"],	filter?: ValueTypes["GridTilesWhere"] | undefined | null,	data: ValueTypes["GridTilesUpdateInput"]},ValueTypes["GridTilesUpdateResult"]],
upsertGridTiles?: [{	by: ValueTypes["GridTilesUniqueWhere"],	filter?: ValueTypes["GridTilesWhere"] | undefined | null,	update: ValueTypes["GridTilesUpdateInput"],	create: ValueTypes["GridTilesCreateInput"]},ValueTypes["GridTilesUpsertResult"]],
createArea?: [{	data: ValueTypes["AreaCreateInput"]},ValueTypes["AreaCreateResult"]],
deleteArea?: [{	by: ValueTypes["AreaUniqueWhere"],	filter?: ValueTypes["AreaWhere"] | undefined | null},ValueTypes["AreaDeleteResult"]],
updateArea?: [{	by: ValueTypes["AreaUniqueWhere"],	filter?: ValueTypes["AreaWhere"] | undefined | null,	data: ValueTypes["AreaUpdateInput"]},ValueTypes["AreaUpdateResult"]],
upsertArea?: [{	by: ValueTypes["AreaUniqueWhere"],	filter?: ValueTypes["AreaWhere"] | undefined | null,	update: ValueTypes["AreaUpdateInput"],	create: ValueTypes["AreaCreateInput"]},ValueTypes["AreaUpsertResult"]],
createPosition?: [{	data: ValueTypes["PositionCreateInput"]},ValueTypes["PositionCreateResult"]],
deletePosition?: [{	by: ValueTypes["PositionUniqueWhere"],	filter?: ValueTypes["PositionWhere"] | undefined | null},ValueTypes["PositionDeleteResult"]],
updatePosition?: [{	by: ValueTypes["PositionUniqueWhere"],	filter?: ValueTypes["PositionWhere"] | undefined | null,	data: ValueTypes["PositionUpdateInput"]},ValueTypes["PositionUpdateResult"]],
upsertPosition?: [{	by: ValueTypes["PositionUniqueWhere"],	filter?: ValueTypes["PositionWhere"] | undefined | null,	update: ValueTypes["PositionUpdateInput"],	create: ValueTypes["PositionCreateInput"]},ValueTypes["PositionUpsertResult"]],
createStatsEnabledWidgetType?: [{	data: ValueTypes["StatsEnabledWidgetTypeCreateInput"]},ValueTypes["StatsEnabledWidgetTypeCreateResult"]],
deleteStatsEnabledWidgetType?: [{	by: ValueTypes["StatsEnabledWidgetTypeUniqueWhere"],	filter?: ValueTypes["StatsEnabledWidgetTypeWhere"] | undefined | null},ValueTypes["StatsEnabledWidgetTypeDeleteResult"]],
updateStatsEnabledWidgetType?: [{	by: ValueTypes["StatsEnabledWidgetTypeUniqueWhere"],	filter?: ValueTypes["StatsEnabledWidgetTypeWhere"] | undefined | null,	data: ValueTypes["StatsEnabledWidgetTypeUpdateInput"]},ValueTypes["StatsEnabledWidgetTypeUpdateResult"]],
upsertStatsEnabledWidgetType?: [{	by: ValueTypes["StatsEnabledWidgetTypeUniqueWhere"],	filter?: ValueTypes["StatsEnabledWidgetTypeWhere"] | undefined | null,	update: ValueTypes["StatsEnabledWidgetTypeUpdateInput"],	create: ValueTypes["StatsEnabledWidgetTypeCreateInput"]},ValueTypes["StatsEnabledWidgetTypeUpsertResult"]],
createStatsWidget?: [{	data: ValueTypes["StatsWidgetCreateInput"]},ValueTypes["StatsWidgetCreateResult"]],
deleteStatsWidget?: [{	by: ValueTypes["StatsWidgetUniqueWhere"],	filter?: ValueTypes["StatsWidgetWhere"] | undefined | null},ValueTypes["StatsWidgetDeleteResult"]],
updateStatsWidget?: [{	by: ValueTypes["StatsWidgetUniqueWhere"],	filter?: ValueTypes["StatsWidgetWhere"] | undefined | null,	data: ValueTypes["StatsWidgetUpdateInput"]},ValueTypes["StatsWidgetUpdateResult"]],
upsertStatsWidget?: [{	by: ValueTypes["StatsWidgetUniqueWhere"],	filter?: ValueTypes["StatsWidgetWhere"] | undefined | null,	update: ValueTypes["StatsWidgetUpdateInput"],	create: ValueTypes["StatsWidgetCreateInput"]},ValueTypes["StatsWidgetUpsertResult"]],
createStatsWidgetsLayout?: [{	data: ValueTypes["StatsWidgetsLayoutCreateInput"]},ValueTypes["StatsWidgetsLayoutCreateResult"]],
deleteStatsWidgetsLayout?: [{	by: ValueTypes["StatsWidgetsLayoutUniqueWhere"],	filter?: ValueTypes["StatsWidgetsLayoutWhere"] | undefined | null},ValueTypes["StatsWidgetsLayoutDeleteResult"]],
updateStatsWidgetsLayout?: [{	by: ValueTypes["StatsWidgetsLayoutUniqueWhere"],	filter?: ValueTypes["StatsWidgetsLayoutWhere"] | undefined | null,	data: ValueTypes["StatsWidgetsLayoutUpdateInput"]},ValueTypes["StatsWidgetsLayoutUpdateResult"]],
upsertStatsWidgetsLayout?: [{	by: ValueTypes["StatsWidgetsLayoutUniqueWhere"],	filter?: ValueTypes["StatsWidgetsLayoutWhere"] | undefined | null,	update: ValueTypes["StatsWidgetsLayoutUpdateInput"],	create: ValueTypes["StatsWidgetsLayoutCreateInput"]},ValueTypes["StatsWidgetsLayoutUpsertResult"]],
createSeat?: [{	data: ValueTypes["SeatCreateInput"]},ValueTypes["SeatCreateResult"]],
deleteSeat?: [{	by: ValueTypes["SeatUniqueWhere"],	filter?: ValueTypes["SeatWhere"] | undefined | null},ValueTypes["SeatDeleteResult"]],
updateSeat?: [{	by: ValueTypes["SeatUniqueWhere"],	filter?: ValueTypes["SeatWhere"] | undefined | null,	data: ValueTypes["SeatUpdateInput"]},ValueTypes["SeatUpdateResult"]],
upsertSeat?: [{	by: ValueTypes["SeatUniqueWhere"],	filter?: ValueTypes["SeatWhere"] | undefined | null,	update: ValueTypes["SeatUpdateInput"],	create: ValueTypes["SeatCreateInput"]},ValueTypes["SeatUpsertResult"]],
createTable?: [{	data: ValueTypes["TableCreateInput"]},ValueTypes["TableCreateResult"]],
deleteTable?: [{	by: ValueTypes["TableUniqueWhere"],	filter?: ValueTypes["TableWhere"] | undefined | null},ValueTypes["TableDeleteResult"]],
updateTable?: [{	by: ValueTypes["TableUniqueWhere"],	filter?: ValueTypes["TableWhere"] | undefined | null,	data: ValueTypes["TableUpdateInput"]},ValueTypes["TableUpdateResult"]],
upsertTable?: [{	by: ValueTypes["TableUniqueWhere"],	filter?: ValueTypes["TableWhere"] | undefined | null,	update: ValueTypes["TableUpdateInput"],	create: ValueTypes["TableCreateInput"]},ValueTypes["TableUpsertResult"]],
createStatsPage?: [{	data: ValueTypes["StatsPageCreateInput"]},ValueTypes["StatsPageCreateResult"]],
deleteStatsPage?: [{	by: ValueTypes["StatsPageUniqueWhere"],	filter?: ValueTypes["StatsPageWhere"] | undefined | null},ValueTypes["StatsPageDeleteResult"]],
updateStatsPage?: [{	by: ValueTypes["StatsPageUniqueWhere"],	filter?: ValueTypes["StatsPageWhere"] | undefined | null,	data: ValueTypes["StatsPageUpdateInput"]},ValueTypes["StatsPageUpdateResult"]],
upsertStatsPage?: [{	by: ValueTypes["StatsPageUniqueWhere"],	filter?: ValueTypes["StatsPageWhere"] | undefined | null,	update: ValueTypes["StatsPageUpdateInput"],	create: ValueTypes["StatsPageCreateInput"]},ValueTypes["StatsPageUpsertResult"]],
createUnassignReason?: [{	data: ValueTypes["UnassignReasonCreateInput"]},ValueTypes["UnassignReasonCreateResult"]],
deleteUnassignReason?: [{	by: ValueTypes["UnassignReasonUniqueWhere"],	filter?: ValueTypes["UnassignReasonWhere"] | undefined | null},ValueTypes["UnassignReasonDeleteResult"]],
updateUnassignReason?: [{	by: ValueTypes["UnassignReasonUniqueWhere"],	filter?: ValueTypes["UnassignReasonWhere"] | undefined | null,	data: ValueTypes["UnassignReasonUpdateInput"]},ValueTypes["UnassignReasonUpdateResult"]],
upsertUnassignReason?: [{	by: ValueTypes["UnassignReasonUniqueWhere"],	filter?: ValueTypes["UnassignReasonWhere"] | undefined | null,	update: ValueTypes["UnassignReasonUpdateInput"],	create: ValueTypes["UnassignReasonCreateInput"]},ValueTypes["UnassignReasonUpsertResult"]],
createDoubleshotCoffeeEquipment?: [{	data: ValueTypes["DoubleshotCoffeeEquipmentCreateInput"]},ValueTypes["DoubleshotCoffeeEquipmentCreateResult"]],
deleteDoubleshotCoffeeEquipment?: [{	by: ValueTypes["DoubleshotCoffeeEquipmentUniqueWhere"],	filter?: ValueTypes["DoubleshotCoffeeEquipmentWhere"] | undefined | null},ValueTypes["DoubleshotCoffeeEquipmentDeleteResult"]],
updateDoubleshotCoffeeEquipment?: [{	by: ValueTypes["DoubleshotCoffeeEquipmentUniqueWhere"],	filter?: ValueTypes["DoubleshotCoffeeEquipmentWhere"] | undefined | null,	data: ValueTypes["DoubleshotCoffeeEquipmentUpdateInput"]},ValueTypes["DoubleshotCoffeeEquipmentUpdateResult"]],
upsertDoubleshotCoffeeEquipment?: [{	by: ValueTypes["DoubleshotCoffeeEquipmentUniqueWhere"],	filter?: ValueTypes["DoubleshotCoffeeEquipmentWhere"] | undefined | null,	update: ValueTypes["DoubleshotCoffeeEquipmentUpdateInput"],	create: ValueTypes["DoubleshotCoffeeEquipmentCreateInput"]},ValueTypes["DoubleshotCoffeeEquipmentUpsertResult"]],
createExpense?: [{	data: ValueTypes["ExpenseCreateInput"]},ValueTypes["ExpenseCreateResult"]],
deleteExpense?: [{	by: ValueTypes["ExpenseUniqueWhere"],	filter?: ValueTypes["ExpenseWhere"] | undefined | null},ValueTypes["ExpenseDeleteResult"]],
updateExpense?: [{	by: ValueTypes["ExpenseUniqueWhere"],	filter?: ValueTypes["ExpenseWhere"] | undefined | null,	data: ValueTypes["ExpenseUpdateInput"]},ValueTypes["ExpenseUpdateResult"]],
upsertExpense?: [{	by: ValueTypes["ExpenseUniqueWhere"],	filter?: ValueTypes["ExpenseWhere"] | undefined | null,	update: ValueTypes["ExpenseUpdateInput"],	create: ValueTypes["ExpenseCreateInput"]},ValueTypes["ExpenseUpsertResult"]],
createExpenseCategory?: [{	data: ValueTypes["ExpenseCategoryCreateInput"]},ValueTypes["ExpenseCategoryCreateResult"]],
deleteExpenseCategory?: [{	by: ValueTypes["ExpenseCategoryUniqueWhere"],	filter?: ValueTypes["ExpenseCategoryWhere"] | undefined | null},ValueTypes["ExpenseCategoryDeleteResult"]],
updateExpenseCategory?: [{	by: ValueTypes["ExpenseCategoryUniqueWhere"],	filter?: ValueTypes["ExpenseCategoryWhere"] | undefined | null,	data: ValueTypes["ExpenseCategoryUpdateInput"]},ValueTypes["ExpenseCategoryUpdateResult"]],
upsertExpenseCategory?: [{	by: ValueTypes["ExpenseCategoryUniqueWhere"],	filter?: ValueTypes["ExpenseCategoryWhere"] | undefined | null,	update: ValueTypes["ExpenseCategoryUpdateInput"],	create: ValueTypes["ExpenseCategoryCreateInput"]},ValueTypes["ExpenseCategoryUpsertResult"]],
createExpenseChange?: [{	data: ValueTypes["ExpenseChangeCreateInput"]},ValueTypes["ExpenseChangeCreateResult"]],
deleteExpenseChange?: [{	by: ValueTypes["ExpenseChangeUniqueWhere"],	filter?: ValueTypes["ExpenseChangeWhere"] | undefined | null},ValueTypes["ExpenseChangeDeleteResult"]],
updateExpenseChange?: [{	by: ValueTypes["ExpenseChangeUniqueWhere"],	filter?: ValueTypes["ExpenseChangeWhere"] | undefined | null,	data: ValueTypes["ExpenseChangeUpdateInput"]},ValueTypes["ExpenseChangeUpdateResult"]],
upsertExpenseChange?: [{	by: ValueTypes["ExpenseChangeUniqueWhere"],	filter?: ValueTypes["ExpenseChangeWhere"] | undefined | null,	update: ValueTypes["ExpenseChangeUpdateInput"],	create: ValueTypes["ExpenseChangeCreateInput"]},ValueTypes["ExpenseChangeUpsertResult"]],
createExpenseDocument?: [{	data: ValueTypes["ExpenseDocumentCreateInput"]},ValueTypes["ExpenseDocumentCreateResult"]],
deleteExpenseDocument?: [{	by: ValueTypes["ExpenseDocumentUniqueWhere"],	filter?: ValueTypes["ExpenseDocumentWhere"] | undefined | null},ValueTypes["ExpenseDocumentDeleteResult"]],
updateExpenseDocument?: [{	by: ValueTypes["ExpenseDocumentUniqueWhere"],	filter?: ValueTypes["ExpenseDocumentWhere"] | undefined | null,	data: ValueTypes["ExpenseDocumentUpdateInput"]},ValueTypes["ExpenseDocumentUpdateResult"]],
upsertExpenseDocument?: [{	by: ValueTypes["ExpenseDocumentUniqueWhere"],	filter?: ValueTypes["ExpenseDocumentWhere"] | undefined | null,	update: ValueTypes["ExpenseDocumentUpdateInput"],	create: ValueTypes["ExpenseDocumentCreateInput"]},ValueTypes["ExpenseDocumentUpsertResult"]],
createRevenuePrediction?: [{	data: ValueTypes["RevenuePredictionCreateInput"]},ValueTypes["RevenuePredictionCreateResult"]],
deleteRevenuePrediction?: [{	by: ValueTypes["RevenuePredictionUniqueWhere"],	filter?: ValueTypes["RevenuePredictionWhere"] | undefined | null},ValueTypes["RevenuePredictionDeleteResult"]],
updateRevenuePrediction?: [{	by: ValueTypes["RevenuePredictionUniqueWhere"],	filter?: ValueTypes["RevenuePredictionWhere"] | undefined | null,	data: ValueTypes["RevenuePredictionUpdateInput"]},ValueTypes["RevenuePredictionUpdateResult"]],
upsertRevenuePrediction?: [{	by: ValueTypes["RevenuePredictionUniqueWhere"],	filter?: ValueTypes["RevenuePredictionWhere"] | undefined | null,	update: ValueTypes["RevenuePredictionUpdateInput"],	create: ValueTypes["RevenuePredictionCreateInput"]},ValueTypes["RevenuePredictionUpsertResult"]],
createRevenuePredictionChange?: [{	data: ValueTypes["RevenuePredictionChangeCreateInput"]},ValueTypes["RevenuePredictionChangeCreateResult"]],
deleteRevenuePredictionChange?: [{	by: ValueTypes["RevenuePredictionChangeUniqueWhere"],	filter?: ValueTypes["RevenuePredictionChangeWhere"] | undefined | null},ValueTypes["RevenuePredictionChangeDeleteResult"]],
updateRevenuePredictionChange?: [{	by: ValueTypes["RevenuePredictionChangeUniqueWhere"],	filter?: ValueTypes["RevenuePredictionChangeWhere"] | undefined | null,	data: ValueTypes["RevenuePredictionChangeUpdateInput"]},ValueTypes["RevenuePredictionChangeUpdateResult"]],
upsertRevenuePredictionChange?: [{	by: ValueTypes["RevenuePredictionChangeUniqueWhere"],	filter?: ValueTypes["RevenuePredictionChangeWhere"] | undefined | null,	update: ValueTypes["RevenuePredictionChangeUpdateInput"],	create: ValueTypes["RevenuePredictionChangeCreateInput"]},ValueTypes["RevenuePredictionChangeUpsertResult"]],
createFile?: [{	data: ValueTypes["FileCreateInput"]},ValueTypes["FileCreateResult"]],
deleteFile?: [{	by: ValueTypes["FileUniqueWhere"],	filter?: ValueTypes["FileWhere"] | undefined | null},ValueTypes["FileDeleteResult"]],
updateFile?: [{	by: ValueTypes["FileUniqueWhere"],	filter?: ValueTypes["FileWhere"] | undefined | null,	data: ValueTypes["FileUpdateInput"]},ValueTypes["FileUpdateResult"]],
upsertFile?: [{	by: ValueTypes["FileUniqueWhere"],	filter?: ValueTypes["FileWhere"] | undefined | null,	update: ValueTypes["FileUpdateInput"],	create: ValueTypes["FileCreateInput"]},ValueTypes["FileUpsertResult"]],
createLine?: [{	data: ValueTypes["LineCreateInput"]},ValueTypes["LineCreateResult"]],
deleteLine?: [{	by: ValueTypes["LineUniqueWhere"],	filter?: ValueTypes["LineWhere"] | undefined | null},ValueTypes["LineDeleteResult"]],
updateLine?: [{	by: ValueTypes["LineUniqueWhere"],	filter?: ValueTypes["LineWhere"] | undefined | null,	data: ValueTypes["LineUpdateInput"]},ValueTypes["LineUpdateResult"]],
upsertLine?: [{	by: ValueTypes["LineUniqueWhere"],	filter?: ValueTypes["LineWhere"] | undefined | null,	update: ValueTypes["LineUpdateInput"],	create: ValueTypes["LineCreateInput"]},ValueTypes["LineUpsertResult"]],
createFinancesBalanceItem?: [{	data: ValueTypes["FinancesBalanceItemCreateInput"]},ValueTypes["FinancesBalanceItemCreateResult"]],
deleteFinancesBalanceItem?: [{	by: ValueTypes["FinancesBalanceItemUniqueWhere"],	filter?: ValueTypes["FinancesBalanceItemWhere"] | undefined | null},ValueTypes["FinancesBalanceItemDeleteResult"]],
updateFinancesBalanceItem?: [{	by: ValueTypes["FinancesBalanceItemUniqueWhere"],	filter?: ValueTypes["FinancesBalanceItemWhere"] | undefined | null,	data: ValueTypes["FinancesBalanceItemUpdateInput"]},ValueTypes["FinancesBalanceItemUpdateResult"]],
upsertFinancesBalanceItem?: [{	by: ValueTypes["FinancesBalanceItemUniqueWhere"],	filter?: ValueTypes["FinancesBalanceItemWhere"] | undefined | null,	update: ValueTypes["FinancesBalanceItemUpdateInput"],	create: ValueTypes["FinancesBalanceItemCreateInput"]},ValueTypes["FinancesBalanceItemUpsertResult"]],
createWoltDriveDelivery?: [{	data: ValueTypes["WoltDriveDeliveryCreateInput"]},ValueTypes["WoltDriveDeliveryCreateResult"]],
deleteWoltDriveDelivery?: [{	by: ValueTypes["WoltDriveDeliveryUniqueWhere"],	filter?: ValueTypes["WoltDriveDeliveryWhere"] | undefined | null},ValueTypes["WoltDriveDeliveryDeleteResult"]],
updateWoltDriveDelivery?: [{	by: ValueTypes["WoltDriveDeliveryUniqueWhere"],	filter?: ValueTypes["WoltDriveDeliveryWhere"] | undefined | null,	data: ValueTypes["WoltDriveDeliveryUpdateInput"]},ValueTypes["WoltDriveDeliveryUpdateResult"]],
upsertWoltDriveDelivery?: [{	by: ValueTypes["WoltDriveDeliveryUniqueWhere"],	filter?: ValueTypes["WoltDriveDeliveryWhere"] | undefined | null,	update: ValueTypes["WoltDriveDeliveryUpdateInput"],	create: ValueTypes["WoltDriveDeliveryCreateInput"]},ValueTypes["WoltDriveDeliveryUpsertResult"]],
	query?:ValueTypes["Query"],
		__typename?: boolean | `@${string}`
}>;
	["MutationTransactionOptions"]: {
	deferForeignKeyConstraints?: boolean | undefined | null
};
	["_Schema"]: AliasType<{
	enums?:ValueTypes["_Enum"],
	entities?:ValueTypes["_Entity"],
		__typename?: boolean | `@${string}`
}>;
	["_Entity"]: AliasType<{
	name?:boolean | `@${string}`,
	customPrimaryAllowed?:boolean | `@${string}`,
	fields?:ValueTypes["_Field"],
	unique?:ValueTypes["_UniqueConstraint"],
		__typename?: boolean | `@${string}`
}>;
	["_UniqueConstraint"]: AliasType<{
	fields?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_Field"]:AliasType<{
		name?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	nullable?:boolean | `@${string}`,
	rules?:ValueTypes["_Rule"],
	validators?:ValueTypes["_Validator"];
		['...on _Column']?: Omit<ValueTypes["_Column"],keyof ValueTypes["_Field"]>;
		['...on _Relation']?: Omit<ValueTypes["_Relation"],keyof ValueTypes["_Field"]>;
		__typename?: boolean | `@${string}`
}>;
	["_Column"]: AliasType<{
	name?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	enumName?:boolean | `@${string}`,
	defaultValue?:boolean | `@${string}`,
	nullable?:boolean | `@${string}`,
	rules?:ValueTypes["_Rule"],
	validators?:ValueTypes["_Validator"],
		__typename?: boolean | `@${string}`
}>;
	["_OnDeleteBehaviour"]:_OnDeleteBehaviour;
	["_RelationSide"]:_RelationSide;
	["_OrderByDirection"]:_OrderByDirection;
	["_OrderBy"]: AliasType<{
	path?:boolean | `@${string}`,
	direction?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_Relation"]: AliasType<{
	name?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	side?:boolean | `@${string}`,
	targetEntity?:boolean | `@${string}`,
	ownedBy?:boolean | `@${string}`,
	inversedBy?:boolean | `@${string}`,
	nullable?:boolean | `@${string}`,
	onDelete?:boolean | `@${string}`,
	orphanRemoval?:boolean | `@${string}`,
	orderBy?:ValueTypes["_OrderBy"],
	rules?:ValueTypes["_Rule"],
	validators?:ValueTypes["_Validator"],
		__typename?: boolean | `@${string}`
}>;
	["_Rule"]: AliasType<{
	message?:ValueTypes["_RuleMessage"],
	validator?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_Validator"]: AliasType<{
	operation?:boolean | `@${string}`,
	arguments?:ValueTypes["_Argument"],
		__typename?: boolean | `@${string}`
}>;
	["_Argument"]: AliasType<{		["...on _ValidatorArgument"] : ValueTypes["_ValidatorArgument"],
		["...on _PathArgument"] : ValueTypes["_PathArgument"],
		["...on _LiteralArgument"] : ValueTypes["_LiteralArgument"]
		__typename?: boolean | `@${string}`
}>;
	["_ValidatorArgument"]: AliasType<{
	validator?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_PathArgument"]: AliasType<{
	path?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_LiteralArgument"]: AliasType<{
	value?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_RuleMessage"]: AliasType<{
	text?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["_Enum"]: AliasType<{
	name?:boolean | `@${string}`,
	values?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["S3SignedUpload"]: AliasType<{
	url?:boolean | `@${string}`,
	headers?:ValueTypes["S3Header"],
	method?:boolean | `@${string}`,
	/** Allowed patterns:
** */
	objectKey?:boolean | `@${string}`,
	bucket?:boolean | `@${string}`,
	publicUrl?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["S3Header"]: AliasType<{
	key?:boolean | `@${string}`,
	value?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["S3SignedRead"]: AliasType<{
	url?:boolean | `@${string}`,
	headers?:ValueTypes["S3Header"],
	method?:boolean | `@${string}`,
	/** Allowed patterns:
** */
	objectKey?:boolean | `@${string}`,
	bucket?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>
  }

export type ModelTypes = {
    ["Query"]: {
		getAddress?: GraphQLTypes["Address"] | undefined,
	listAddress: Array<GraphQLTypes["Address"]>,
	paginateAddress: GraphQLTypes["AddressConnection"],
	validateCreateAddress: GraphQLTypes["_ValidationResult"],
	validateUpdateAddress: GraphQLTypes["_ValidationResult"],
	getCountry?: GraphQLTypes["Country"] | undefined,
	listCountry: Array<GraphQLTypes["Country"]>,
	paginateCountry: GraphQLTypes["CountryConnection"],
	validateCreateCountry: GraphQLTypes["_ValidationResult"],
	validateUpdateCountry: GraphQLTypes["_ValidationResult"],
	getChannel?: GraphQLTypes["Channel"] | undefined,
	listChannel: Array<GraphQLTypes["Channel"]>,
	paginateChannel: GraphQLTypes["ChannelConnection"],
	validateCreateChannel: GraphQLTypes["_ValidationResult"],
	validateUpdateChannel: GraphQLTypes["_ValidationResult"],
	getChannelPayment?: GraphQLTypes["ChannelPayment"] | undefined,
	listChannelPayment: Array<GraphQLTypes["ChannelPayment"]>,
	paginateChannelPayment: GraphQLTypes["ChannelPaymentConnection"],
	validateCreateChannelPayment: GraphQLTypes["_ValidationResult"],
	validateUpdateChannelPayment: GraphQLTypes["_ValidationResult"],
	getChannelDelivery?: GraphQLTypes["ChannelDelivery"] | undefined,
	listChannelDelivery: Array<GraphQLTypes["ChannelDelivery"]>,
	paginateChannelDelivery: GraphQLTypes["ChannelDeliveryConnection"],
	validateCreateChannelDelivery: GraphQLTypes["_ValidationResult"],
	validateUpdateChannelDelivery: GraphQLTypes["_ValidationResult"],
	getCustomer?: GraphQLTypes["Customer"] | undefined,
	listCustomer: Array<GraphQLTypes["Customer"]>,
	paginateCustomer: GraphQLTypes["CustomerConnection"],
	validateCreateCustomer: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomer: GraphQLTypes["_ValidationResult"],
	getCustomerCredit?: GraphQLTypes["CustomerCredit"] | undefined,
	listCustomerCredit: Array<GraphQLTypes["CustomerCredit"]>,
	paginateCustomerCredit: GraphQLTypes["CustomerCreditConnection"],
	validateCreateCustomerCredit: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomerCredit: GraphQLTypes["_ValidationResult"],
	getCustomerGroup?: GraphQLTypes["CustomerGroup"] | undefined,
	listCustomerGroup: Array<GraphQLTypes["CustomerGroup"]>,
	paginateCustomerGroup: GraphQLTypes["CustomerGroupConnection"],
	validateCreateCustomerGroup: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomerGroup: GraphQLTypes["_ValidationResult"],
	getCustomerPaymentMethod?: GraphQLTypes["CustomerPaymentMethod"] | undefined,
	listCustomerPaymentMethod: Array<GraphQLTypes["CustomerPaymentMethod"]>,
	paginateCustomerPaymentMethod: GraphQLTypes["CustomerPaymentMethodConnection"],
	validateCreateCustomerPaymentMethod: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomerPaymentMethod: GraphQLTypes["_ValidationResult"],
	getDeliveryMethod?: GraphQLTypes["DeliveryMethod"] | undefined,
	listDeliveryMethod: Array<GraphQLTypes["DeliveryMethod"]>,
	paginateDeliveryMethod: GraphQLTypes["DeliveryMethodConnection"],
	validateCreateDeliveryMethod: GraphQLTypes["_ValidationResult"],
	validateUpdateDeliveryMethod: GraphQLTypes["_ValidationResult"],
	getOrder?: GraphQLTypes["Order"] | undefined,
	listOrder: Array<GraphQLTypes["Order"]>,
	paginateOrder: GraphQLTypes["OrderConnection"],
	validateCreateOrder: GraphQLTypes["_ValidationResult"],
	validateUpdateOrder: GraphQLTypes["_ValidationResult"],
	getOrderDiscount?: GraphQLTypes["OrderDiscount"] | undefined,
	listOrderDiscount: Array<GraphQLTypes["OrderDiscount"]>,
	paginateOrderDiscount: GraphQLTypes["OrderDiscountConnection"],
	validateCreateOrderDiscount: GraphQLTypes["_ValidationResult"],
	validateUpdateOrderDiscount: GraphQLTypes["_ValidationResult"],
	getOrderPayment?: GraphQLTypes["OrderPayment"] | undefined,
	listOrderPayment: Array<GraphQLTypes["OrderPayment"]>,
	paginateOrderPayment: GraphQLTypes["OrderPaymentConnection"],
	validateCreateOrderPayment: GraphQLTypes["_ValidationResult"],
	validateUpdateOrderPayment: GraphQLTypes["_ValidationResult"],
	getOrderDelivery?: GraphQLTypes["OrderDelivery"] | undefined,
	listOrderDelivery: Array<GraphQLTypes["OrderDelivery"]>,
	paginateOrderDelivery: GraphQLTypes["OrderDeliveryConnection"],
	validateCreateOrderDelivery: GraphQLTypes["_ValidationResult"],
	validateUpdateOrderDelivery: GraphQLTypes["_ValidationResult"],
	getOrderItem?: GraphQLTypes["OrderItem"] | undefined,
	listOrderItem: Array<GraphQLTypes["OrderItem"]>,
	paginateOrderItem: GraphQLTypes["OrderItemConnection"],
	validateCreateOrderItem: GraphQLTypes["_ValidationResult"],
	validateUpdateOrderItem: GraphQLTypes["_ValidationResult"],
	getPaymentMethod?: GraphQLTypes["PaymentMethod"] | undefined,
	listPaymentMethod: Array<GraphQLTypes["PaymentMethod"]>,
	paginatePaymentMethod: GraphQLTypes["PaymentMethodConnection"],
	validateCreatePaymentMethod: GraphQLTypes["_ValidationResult"],
	validateUpdatePaymentMethod: GraphQLTypes["_ValidationResult"],
	getVatRate?: GraphQLTypes["VatRate"] | undefined,
	listVatRate: Array<GraphQLTypes["VatRate"]>,
	paginateVatRate: GraphQLTypes["VatRateConnection"],
	validateCreateVatRate: GraphQLTypes["_ValidationResult"],
	validateUpdateVatRate: GraphQLTypes["_ValidationResult"],
	getProduct?: GraphQLTypes["Product"] | undefined,
	listProduct: Array<GraphQLTypes["Product"]>,
	paginateProduct: GraphQLTypes["ProductConnection"],
	validateCreateProduct: GraphQLTypes["_ValidationResult"],
	validateUpdateProduct: GraphQLTypes["_ValidationResult"],
	getProductStock?: GraphQLTypes["ProductStock"] | undefined,
	listProductStock: Array<GraphQLTypes["ProductStock"]>,
	paginateProductStock: GraphQLTypes["ProductStockConnection"],
	validateCreateProductStock: GraphQLTypes["_ValidationResult"],
	validateUpdateProductStock: GraphQLTypes["_ValidationResult"],
	getProductPacking?: GraphQLTypes["ProductPacking"] | undefined,
	listProductPacking: Array<GraphQLTypes["ProductPacking"]>,
	paginateProductPacking: GraphQLTypes["ProductPackingConnection"],
	validateCreateProductPacking: GraphQLTypes["_ValidationResult"],
	validateUpdateProductPacking: GraphQLTypes["_ValidationResult"],
	getProductGroupPrice?: GraphQLTypes["ProductGroupPrice"] | undefined,
	listProductGroupPrice: Array<GraphQLTypes["ProductGroupPrice"]>,
	paginateProductGroupPrice: GraphQLTypes["ProductGroupPriceConnection"],
	validateCreateProductGroupPrice: GraphQLTypes["_ValidationResult"],
	validateUpdateProductGroupPrice: GraphQLTypes["_ValidationResult"],
	getProductRecipe?: GraphQLTypes["ProductRecipe"] | undefined,
	listProductRecipe: Array<GraphQLTypes["ProductRecipe"]>,
	paginateProductRecipe: GraphQLTypes["ProductRecipeConnection"],
	validateCreateProductRecipe: GraphQLTypes["_ValidationResult"],
	validateUpdateProductRecipe: GraphQLTypes["_ValidationResult"],
	getProductCategory?: GraphQLTypes["ProductCategory"] | undefined,
	listProductCategory: Array<GraphQLTypes["ProductCategory"]>,
	paginateProductCategory: GraphQLTypes["ProductCategoryConnection"],
	validateCreateProductCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateProductCategory: GraphQLTypes["_ValidationResult"],
	getStore?: GraphQLTypes["Store"] | undefined,
	listStore: Array<GraphQLTypes["Store"]>,
	paginateStore: GraphQLTypes["StoreConnection"],
	validateCreateStore: GraphQLTypes["_ValidationResult"],
	validateUpdateStore: GraphQLTypes["_ValidationResult"],
	getTag?: GraphQLTypes["Tag"] | undefined,
	listTag: Array<GraphQLTypes["Tag"]>,
	paginateTag: GraphQLTypes["TagConnection"],
	validateCreateTag: GraphQLTypes["_ValidationResult"],
	validateUpdateTag: GraphQLTypes["_ValidationResult"],
	getCustomerPermissions?: GraphQLTypes["CustomerPermissions"] | undefined,
	listCustomerPermissions: Array<GraphQLTypes["CustomerPermissions"]>,
	paginateCustomerPermissions: GraphQLTypes["CustomerPermissionsConnection"],
	getImage?: GraphQLTypes["Image"] | undefined,
	listImage: Array<GraphQLTypes["Image"]>,
	paginateImage: GraphQLTypes["ImageConnection"],
	validateCreateImage: GraphQLTypes["_ValidationResult"],
	validateUpdateImage: GraphQLTypes["_ValidationResult"],
	getBusinessCategory?: GraphQLTypes["BusinessCategory"] | undefined,
	listBusinessCategory: Array<GraphQLTypes["BusinessCategory"]>,
	paginateBusinessCategory: GraphQLTypes["BusinessCategoryConnection"],
	validateCreateBusinessCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateBusinessCategory: GraphQLTypes["_ValidationResult"],
	getProductList?: GraphQLTypes["ProductList"] | undefined,
	listProductList: Array<GraphQLTypes["ProductList"]>,
	paginateProductList: GraphQLTypes["ProductListConnection"],
	validateCreateProductList: GraphQLTypes["_ValidationResult"],
	validateUpdateProductList: GraphQLTypes["_ValidationResult"],
	getProductListItem?: GraphQLTypes["ProductListItem"] | undefined,
	listProductListItem: Array<GraphQLTypes["ProductListItem"]>,
	paginateProductListItem: GraphQLTypes["ProductListItemConnection"],
	validateCreateProductListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateProductListItem: GraphQLTypes["_ValidationResult"],
	getProductCategoryList?: GraphQLTypes["ProductCategoryList"] | undefined,
	listProductCategoryList: Array<GraphQLTypes["ProductCategoryList"]>,
	paginateProductCategoryList: GraphQLTypes["ProductCategoryListConnection"],
	validateCreateProductCategoryList: GraphQLTypes["_ValidationResult"],
	validateUpdateProductCategoryList: GraphQLTypes["_ValidationResult"],
	getProductCategoryListItem?: GraphQLTypes["ProductCategoryListItem"] | undefined,
	listProductCategoryListItem: Array<GraphQLTypes["ProductCategoryListItem"]>,
	paginateProductCategoryListItem: GraphQLTypes["ProductCategoryListItemConnection"],
	validateCreateProductCategoryListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateProductCategoryListItem: GraphQLTypes["_ValidationResult"],
	getBusinessCategoryLocale?: GraphQLTypes["BusinessCategoryLocale"] | undefined,
	listBusinessCategoryLocale: Array<GraphQLTypes["BusinessCategoryLocale"]>,
	paginateBusinessCategoryLocale: GraphQLTypes["BusinessCategoryLocaleConnection"],
	validateCreateBusinessCategoryLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateBusinessCategoryLocale: GraphQLTypes["_ValidationResult"],
	getLocale?: GraphQLTypes["Locale"] | undefined,
	listLocale: Array<GraphQLTypes["Locale"]>,
	paginateLocale: GraphQLTypes["LocaleConnection"],
	validateCreateLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateLocale: GraphQLTypes["_ValidationResult"],
	getProductCategoryListLocale?: GraphQLTypes["ProductCategoryListLocale"] | undefined,
	listProductCategoryListLocale: Array<GraphQLTypes["ProductCategoryListLocale"]>,
	paginateProductCategoryListLocale: GraphQLTypes["ProductCategoryListLocaleConnection"],
	validateCreateProductCategoryListLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateProductCategoryListLocale: GraphQLTypes["_ValidationResult"],
	getCustomerName?: GraphQLTypes["CustomerName"] | undefined,
	listCustomerName: Array<GraphQLTypes["CustomerName"]>,
	paginateCustomerName: GraphQLTypes["CustomerNameConnection"],
	validateCreateCustomerName: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomerName: GraphQLTypes["_ValidationResult"],
	getCustomerAlias?: GraphQLTypes["CustomerAlias"] | undefined,
	listCustomerAlias: Array<GraphQLTypes["CustomerAlias"]>,
	paginateCustomerAlias: GraphQLTypes["CustomerAliasConnection"],
	validateCreateCustomerAlias: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomerAlias: GraphQLTypes["_ValidationResult"],
	getProductIngredientItem?: GraphQLTypes["ProductIngredientItem"] | undefined,
	listProductIngredientItem: Array<GraphQLTypes["ProductIngredientItem"]>,
	paginateProductIngredientItem: GraphQLTypes["ProductIngredientItemConnection"],
	validateCreateProductIngredientItem: GraphQLTypes["_ValidationResult"],
	validateUpdateProductIngredientItem: GraphQLTypes["_ValidationResult"],
	getProductIngredientItemQuantity?: GraphQLTypes["ProductIngredientItemQuantity"] | undefined,
	listProductIngredientItemQuantity: Array<GraphQLTypes["ProductIngredientItemQuantity"]>,
	paginateProductIngredientItemQuantity: GraphQLTypes["ProductIngredientItemQuantityConnection"],
	validateCreateProductIngredientItemQuantity: GraphQLTypes["_ValidationResult"],
	validateUpdateProductIngredientItemQuantity: GraphQLTypes["_ValidationResult"],
	getProductIngredientItemQuantityUnit?: GraphQLTypes["ProductIngredientItemQuantityUnit"] | undefined,
	listProductIngredientItemQuantityUnit: Array<GraphQLTypes["ProductIngredientItemQuantityUnit"]>,
	paginateProductIngredientItemQuantityUnit: GraphQLTypes["ProductIngredientItemQuantityUnitConnection"],
	validateCreateProductIngredientItemQuantityUnit: GraphQLTypes["_ValidationResult"],
	validateUpdateProductIngredientItemQuantityUnit: GraphQLTypes["_ValidationResult"],
	getProductIngredient?: GraphQLTypes["ProductIngredient"] | undefined,
	listProductIngredient: Array<GraphQLTypes["ProductIngredient"]>,
	paginateProductIngredient: GraphQLTypes["ProductIngredientConnection"],
	validateCreateProductIngredient: GraphQLTypes["_ValidationResult"],
	validateUpdateProductIngredient: GraphQLTypes["_ValidationResult"],
	getCustomerIngredientRating?: GraphQLTypes["CustomerIngredientRating"] | undefined,
	listCustomerIngredientRating: Array<GraphQLTypes["CustomerIngredientRating"]>,
	paginateCustomerIngredientRating: GraphQLTypes["CustomerIngredientRatingConnection"],
	validateCreateCustomerIngredientRating: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomerIngredientRating: GraphQLTypes["_ValidationResult"],
	getProductIngredientRating?: GraphQLTypes["ProductIngredientRating"] | undefined,
	listProductIngredientRating: Array<GraphQLTypes["ProductIngredientRating"]>,
	paginateProductIngredientRating: GraphQLTypes["ProductIngredientRatingConnection"],
	validateCreateProductIngredientRating: GraphQLTypes["_ValidationResult"],
	validateUpdateProductIngredientRating: GraphQLTypes["_ValidationResult"],
	getProductIngredientLocale?: GraphQLTypes["ProductIngredientLocale"] | undefined,
	listProductIngredientLocale: Array<GraphQLTypes["ProductIngredientLocale"]>,
	paginateProductIngredientLocale: GraphQLTypes["ProductIngredientLocaleConnection"],
	validateCreateProductIngredientLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateProductIngredientLocale: GraphQLTypes["_ValidationResult"],
	getOrderRecurrence?: GraphQLTypes["OrderRecurrence"] | undefined,
	listOrderRecurrence: Array<GraphQLTypes["OrderRecurrence"]>,
	paginateOrderRecurrence: GraphQLTypes["OrderRecurrenceConnection"],
	validateCreateOrderRecurrence: GraphQLTypes["_ValidationResult"],
	validateUpdateOrderRecurrence: GraphQLTypes["_ValidationResult"],
	getOrderRecurrenceLocale?: GraphQLTypes["OrderRecurrenceLocale"] | undefined,
	listOrderRecurrenceLocale: Array<GraphQLTypes["OrderRecurrenceLocale"]>,
	paginateOrderRecurrenceLocale: GraphQLTypes["OrderRecurrenceLocaleConnection"],
	validateCreateOrderRecurrenceLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateOrderRecurrenceLocale: GraphQLTypes["_ValidationResult"],
	getBusinessCustomer?: GraphQLTypes["BusinessCustomer"] | undefined,
	listBusinessCustomer: Array<GraphQLTypes["BusinessCustomer"]>,
	paginateBusinessCustomer: GraphQLTypes["BusinessCustomerConnection"],
	validateCreateBusinessCustomer: GraphQLTypes["_ValidationResult"],
	validateUpdateBusinessCustomer: GraphQLTypes["_ValidationResult"],
	getPointOfSale?: GraphQLTypes["PointOfSale"] | undefined,
	listPointOfSale: Array<GraphQLTypes["PointOfSale"]>,
	paginatePointOfSale: GraphQLTypes["PointOfSaleConnection"],
	validateCreatePointOfSale: GraphQLTypes["_ValidationResult"],
	validateUpdatePointOfSale: GraphQLTypes["_ValidationResult"],
	getStaff?: GraphQLTypes["Staff"] | undefined,
	listStaff: Array<GraphQLTypes["Staff"]>,
	paginateStaff: GraphQLTypes["StaffConnection"],
	validateCreateStaff: GraphQLTypes["_ValidationResult"],
	validateUpdateStaff: GraphQLTypes["_ValidationResult"],
	getPointOfSalePermissions?: GraphQLTypes["PointOfSalePermissions"] | undefined,
	listPointOfSalePermissions: Array<GraphQLTypes["PointOfSalePermissions"]>,
	paginatePointOfSalePermissions: GraphQLTypes["PointOfSalePermissionsConnection"],
	getBlog?: GraphQLTypes["Blog"] | undefined,
	listBlog: Array<GraphQLTypes["Blog"]>,
	paginateBlog: GraphQLTypes["BlogConnection"],
	validateCreateBlog: GraphQLTypes["_ValidationResult"],
	validateUpdateBlog: GraphQLTypes["_ValidationResult"],
	getBlogLocale?: GraphQLTypes["BlogLocale"] | undefined,
	listBlogLocale: Array<GraphQLTypes["BlogLocale"]>,
	paginateBlogLocale: GraphQLTypes["BlogLocaleConnection"],
	validateCreateBlogLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateBlogLocale: GraphQLTypes["_ValidationResult"],
	getBlogPost?: GraphQLTypes["BlogPost"] | undefined,
	listBlogPost: Array<GraphQLTypes["BlogPost"]>,
	paginateBlogPost: GraphQLTypes["BlogPostConnection"],
	validateCreateBlogPost: GraphQLTypes["_ValidationResult"],
	validateUpdateBlogPost: GraphQLTypes["_ValidationResult"],
	getBlogPostLocale?: GraphQLTypes["BlogPostLocale"] | undefined,
	listBlogPostLocale: Array<GraphQLTypes["BlogPostLocale"]>,
	paginateBlogPostLocale: GraphQLTypes["BlogPostLocaleConnection"],
	validateCreateBlogPostLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateBlogPostLocale: GraphQLTypes["_ValidationResult"],
	getColorPallete?: GraphQLTypes["ColorPallete"] | undefined,
	listColorPallete: Array<GraphQLTypes["ColorPallete"]>,
	paginateColorPallete: GraphQLTypes["ColorPalleteConnection"],
	validateCreateColorPallete: GraphQLTypes["_ValidationResult"],
	validateUpdateColorPallete: GraphQLTypes["_ValidationResult"],
	getContent?: GraphQLTypes["Content"] | undefined,
	listContent: Array<GraphQLTypes["Content"]>,
	paginateContent: GraphQLTypes["ContentConnection"],
	validateCreateContent: GraphQLTypes["_ValidationResult"],
	validateUpdateContent: GraphQLTypes["_ValidationResult"],
	getContentBlock?: GraphQLTypes["ContentBlock"] | undefined,
	listContentBlock: Array<GraphQLTypes["ContentBlock"]>,
	paginateContentBlock: GraphQLTypes["ContentBlockConnection"],
	validateCreateContentBlock: GraphQLTypes["_ValidationResult"],
	validateUpdateContentBlock: GraphQLTypes["_ValidationResult"],
	getContentReference?: GraphQLTypes["ContentReference"] | undefined,
	listContentReference: Array<GraphQLTypes["ContentReference"]>,
	paginateContentReference: GraphQLTypes["ContentReferenceConnection"],
	validateCreateContentReference: GraphQLTypes["_ValidationResult"],
	validateUpdateContentReference: GraphQLTypes["_ValidationResult"],
	getBlogPostList?: GraphQLTypes["BlogPostList"] | undefined,
	listBlogPostList: Array<GraphQLTypes["BlogPostList"]>,
	paginateBlogPostList: GraphQLTypes["BlogPostListConnection"],
	validateCreateBlogPostList: GraphQLTypes["_ValidationResult"],
	validateUpdateBlogPostList: GraphQLTypes["_ValidationResult"],
	getBlogPostListItem?: GraphQLTypes["BlogPostListItem"] | undefined,
	listBlogPostListItem: Array<GraphQLTypes["BlogPostListItem"]>,
	paginateBlogPostListItem: GraphQLTypes["BlogPostListItemConnection"],
	validateCreateBlogPostListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateBlogPostListItem: GraphQLTypes["_ValidationResult"],
	getLinkList?: GraphQLTypes["LinkList"] | undefined,
	listLinkList: Array<GraphQLTypes["LinkList"]>,
	paginateLinkList: GraphQLTypes["LinkListConnection"],
	validateCreateLinkList: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkList: GraphQLTypes["_ValidationResult"],
	getLinkListItem?: GraphQLTypes["LinkListItem"] | undefined,
	listLinkListItem: Array<GraphQLTypes["LinkListItem"]>,
	paginateLinkListItem: GraphQLTypes["LinkListItemConnection"],
	validateCreateLinkListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkListItem: GraphQLTypes["_ValidationResult"],
	getCover?: GraphQLTypes["Cover"] | undefined,
	listCover: Array<GraphQLTypes["Cover"]>,
	paginateCover: GraphQLTypes["CoverConnection"],
	validateCreateCover: GraphQLTypes["_ValidationResult"],
	validateUpdateCover: GraphQLTypes["_ValidationResult"],
	getLink?: GraphQLTypes["Link"] | undefined,
	listLink: Array<GraphQLTypes["Link"]>,
	paginateLink: GraphQLTypes["LinkConnection"],
	validateCreateLink: GraphQLTypes["_ValidationResult"],
	validateUpdateLink: GraphQLTypes["_ValidationResult"],
	getLinkable?: GraphQLTypes["Linkable"] | undefined,
	listLinkable: Array<GraphQLTypes["Linkable"]>,
	paginateLinkable: GraphQLTypes["LinkableConnection"],
	validateCreateLinkable: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkable: GraphQLTypes["_ValidationResult"],
	getMedium?: GraphQLTypes["Medium"] | undefined,
	listMedium: Array<GraphQLTypes["Medium"]>,
	paginateMedium: GraphQLTypes["MediumConnection"],
	validateCreateMedium: GraphQLTypes["_ValidationResult"],
	validateUpdateMedium: GraphQLTypes["_ValidationResult"],
	getVideo?: GraphQLTypes["Video"] | undefined,
	listVideo: Array<GraphQLTypes["Video"]>,
	paginateVideo: GraphQLTypes["VideoConnection"],
	validateCreateVideo: GraphQLTypes["_ValidationResult"],
	validateUpdateVideo: GraphQLTypes["_ValidationResult"],
	getSeo?: GraphQLTypes["Seo"] | undefined,
	listSeo: Array<GraphQLTypes["Seo"]>,
	paginateSeo: GraphQLTypes["SeoConnection"],
	validateCreateSeo: GraphQLTypes["_ValidationResult"],
	validateUpdateSeo: GraphQLTypes["_ValidationResult"],
	getProtectedImage?: GraphQLTypes["ProtectedImage"] | undefined,
	listProtectedImage: Array<GraphQLTypes["ProtectedImage"]>,
	paginateProtectedImage: GraphQLTypes["ProtectedImageConnection"],
	validateCreateProtectedImage: GraphQLTypes["_ValidationResult"],
	validateUpdateProtectedImage: GraphQLTypes["_ValidationResult"],
	getTranslationDomain?: GraphQLTypes["TranslationDomain"] | undefined,
	listTranslationDomain: Array<GraphQLTypes["TranslationDomain"]>,
	paginateTranslationDomain: GraphQLTypes["TranslationDomainConnection"],
	validateCreateTranslationDomain: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationDomain: GraphQLTypes["_ValidationResult"],
	getTranslationCatalogue?: GraphQLTypes["TranslationCatalogue"] | undefined,
	listTranslationCatalogue: Array<GraphQLTypes["TranslationCatalogue"]>,
	paginateTranslationCatalogue: GraphQLTypes["TranslationCatalogueConnection"],
	validateCreateTranslationCatalogue: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationCatalogue: GraphQLTypes["_ValidationResult"],
	getTranslationKey?: GraphQLTypes["TranslationKey"] | undefined,
	listTranslationKey: Array<GraphQLTypes["TranslationKey"]>,
	paginateTranslationKey: GraphQLTypes["TranslationKeyConnection"],
	validateCreateTranslationKey: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationKey: GraphQLTypes["_ValidationResult"],
	getTranslationValue?: GraphQLTypes["TranslationValue"] | undefined,
	listTranslationValue: Array<GraphQLTypes["TranslationValue"]>,
	paginateTranslationValue: GraphQLTypes["TranslationValueConnection"],
	validateCreateTranslationValue: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationValue: GraphQLTypes["_ValidationResult"],
	getTranslationCataloguesIdentifier?: GraphQLTypes["TranslationCataloguesIdentifier"] | undefined,
	listTranslationCataloguesIdentifier: Array<GraphQLTypes["TranslationCataloguesIdentifier"]>,
	paginateTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierConnection"],
	validateCreateTranslationCataloguesIdentifier: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationCataloguesIdentifier: GraphQLTypes["_ValidationResult"],
	getSocialsAndApps?: GraphQLTypes["SocialsAndApps"] | undefined,
	listSocialsAndApps: Array<GraphQLTypes["SocialsAndApps"]>,
	paginateSocialsAndApps: GraphQLTypes["SocialsAndAppsConnection"],
	validateCreateSocialsAndApps: GraphQLTypes["_ValidationResult"],
	validateUpdateSocialsAndApps: GraphQLTypes["_ValidationResult"],
	getProductGrid?: GraphQLTypes["ProductGrid"] | undefined,
	listProductGrid: Array<GraphQLTypes["ProductGrid"]>,
	paginateProductGrid: GraphQLTypes["ProductGridConnection"],
	validateCreateProductGrid: GraphQLTypes["_ValidationResult"],
	validateUpdateProductGrid: GraphQLTypes["_ValidationResult"],
	getProductGridItem?: GraphQLTypes["ProductGridItem"] | undefined,
	listProductGridItem: Array<GraphQLTypes["ProductGridItem"]>,
	paginateProductGridItem: GraphQLTypes["ProductGridItemConnection"],
	validateCreateProductGridItem: GraphQLTypes["_ValidationResult"],
	validateUpdateProductGridItem: GraphQLTypes["_ValidationResult"],
	getGallery?: GraphQLTypes["Gallery"] | undefined,
	listGallery: Array<GraphQLTypes["Gallery"]>,
	paginateGallery: GraphQLTypes["GalleryConnection"],
	validateCreateGallery: GraphQLTypes["_ValidationResult"],
	validateUpdateGallery: GraphQLTypes["_ValidationResult"],
	getGalleryItem?: GraphQLTypes["GalleryItem"] | undefined,
	listGalleryItem: Array<GraphQLTypes["GalleryItem"]>,
	paginateGalleryItem: GraphQLTypes["GalleryItemConnection"],
	validateCreateGalleryItem: GraphQLTypes["_ValidationResult"],
	validateUpdateGalleryItem: GraphQLTypes["_ValidationResult"],
	getHero?: GraphQLTypes["Hero"] | undefined,
	listHero: Array<GraphQLTypes["Hero"]>,
	paginateHero: GraphQLTypes["HeroConnection"],
	validateCreateHero: GraphQLTypes["_ValidationResult"],
	validateUpdateHero: GraphQLTypes["_ValidationResult"],
	getSiteMenu?: GraphQLTypes["SiteMenu"] | undefined,
	listSiteMenu: Array<GraphQLTypes["SiteMenu"]>,
	paginateSiteMenu: GraphQLTypes["SiteMenuConnection"],
	validateCreateSiteMenu: GraphQLTypes["_ValidationResult"],
	validateUpdateSiteMenu: GraphQLTypes["_ValidationResult"],
	getMenuLocale?: GraphQLTypes["MenuLocale"] | undefined,
	listMenuLocale: Array<GraphQLTypes["MenuLocale"]>,
	paginateMenuLocale: GraphQLTypes["MenuLocaleConnection"],
	validateCreateMenuLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateMenuLocale: GraphQLTypes["_ValidationResult"],
	getMenuItem?: GraphQLTypes["MenuItem"] | undefined,
	listMenuItem: Array<GraphQLTypes["MenuItem"]>,
	paginateMenuItem: GraphQLTypes["MenuItemConnection"],
	validateCreateMenuItem: GraphQLTypes["_ValidationResult"],
	validateUpdateMenuItem: GraphQLTypes["_ValidationResult"],
	getPage?: GraphQLTypes["Page"] | undefined,
	listPage: Array<GraphQLTypes["Page"]>,
	paginatePage: GraphQLTypes["PageConnection"],
	validateCreatePage: GraphQLTypes["_ValidationResult"],
	validateUpdatePage: GraphQLTypes["_ValidationResult"],
	getPageLocale?: GraphQLTypes["PageLocale"] | undefined,
	listPageLocale: Array<GraphQLTypes["PageLocale"]>,
	paginatePageLocale: GraphQLTypes["PageLocaleConnection"],
	validateCreatePageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdatePageLocale: GraphQLTypes["_ValidationResult"],
	getWikiPage?: GraphQLTypes["WikiPage"] | undefined,
	listWikiPage: Array<GraphQLTypes["WikiPage"]>,
	paginateWikiPage: GraphQLTypes["WikiPageConnection"],
	validateCreateWikiPage: GraphQLTypes["_ValidationResult"],
	validateUpdateWikiPage: GraphQLTypes["_ValidationResult"],
	getMenuSubitem?: GraphQLTypes["MenuSubitem"] | undefined,
	listMenuSubitem: Array<GraphQLTypes["MenuSubitem"]>,
	paginateMenuSubitem: GraphQLTypes["MenuSubitemConnection"],
	validateCreateMenuSubitem: GraphQLTypes["_ValidationResult"],
	validateUpdateMenuSubitem: GraphQLTypes["_ValidationResult"],
	getMenuLinkList?: GraphQLTypes["MenuLinkList"] | undefined,
	listMenuLinkList: Array<GraphQLTypes["MenuLinkList"]>,
	paginateMenuLinkList: GraphQLTypes["MenuLinkListConnection"],
	validateCreateMenuLinkList: GraphQLTypes["_ValidationResult"],
	validateUpdateMenuLinkList: GraphQLTypes["_ValidationResult"],
	getMenuLinkItem?: GraphQLTypes["MenuLinkItem"] | undefined,
	listMenuLinkItem: Array<GraphQLTypes["MenuLinkItem"]>,
	paginateMenuLinkItem: GraphQLTypes["MenuLinkItemConnection"],
	validateCreateMenuLinkItem: GraphQLTypes["_ValidationResult"],
	validateUpdateMenuLinkItem: GraphQLTypes["_ValidationResult"],
	getMenuProducts?: GraphQLTypes["MenuProducts"] | undefined,
	listMenuProducts: Array<GraphQLTypes["MenuProducts"]>,
	paginateMenuProducts: GraphQLTypes["MenuProductsConnection"],
	validateCreateMenuProducts: GraphQLTypes["_ValidationResult"],
	validateUpdateMenuProducts: GraphQLTypes["_ValidationResult"],
	getMenuDelivery?: GraphQLTypes["MenuDelivery"] | undefined,
	listMenuDelivery: Array<GraphQLTypes["MenuDelivery"]>,
	paginateMenuDelivery: GraphQLTypes["MenuDeliveryConnection"],
	validateCreateMenuDelivery: GraphQLTypes["_ValidationResult"],
	validateUpdateMenuDelivery: GraphQLTypes["_ValidationResult"],
	getMenuContact?: GraphQLTypes["MenuContact"] | undefined,
	listMenuContact: Array<GraphQLTypes["MenuContact"]>,
	paginateMenuContact: GraphQLTypes["MenuContactConnection"],
	validateCreateMenuContact: GraphQLTypes["_ValidationResult"],
	validateUpdateMenuContact: GraphQLTypes["_ValidationResult"],
	getDeadlineTemplate?: GraphQLTypes["DeadlineTemplate"] | undefined,
	listDeadlineTemplate: Array<GraphQLTypes["DeadlineTemplate"]>,
	paginateDeadlineTemplate: GraphQLTypes["DeadlineTemplateConnection"],
	validateCreateDeadlineTemplate: GraphQLTypes["_ValidationResult"],
	validateUpdateDeadlineTemplate: GraphQLTypes["_ValidationResult"],
	getEmployeeQueue?: GraphQLTypes["EmployeeQueue"] | undefined,
	listEmployeeQueue: Array<GraphQLTypes["EmployeeQueue"]>,
	paginateEmployeeQueue: GraphQLTypes["EmployeeQueueConnection"],
	validateCreateEmployeeQueue: GraphQLTypes["_ValidationResult"],
	validateUpdateEmployeeQueue: GraphQLTypes["_ValidationResult"],
	getTimetableDay?: GraphQLTypes["TimetableDay"] | undefined,
	listTimetableDay: Array<GraphQLTypes["TimetableDay"]>,
	paginateTimetableDay: GraphQLTypes["TimetableDayConnection"],
	validateCreateTimetableDay: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetableDay: GraphQLTypes["_ValidationResult"],
	getTimetableEmployeeRole?: GraphQLTypes["TimetableEmployeeRole"] | undefined,
	listTimetableEmployeeRole: Array<GraphQLTypes["TimetableEmployeeRole"]>,
	paginateTimetableEmployeeRole: GraphQLTypes["TimetableEmployeeRoleConnection"],
	validateCreateTimetableEmployeeRole: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetableEmployeeRole: GraphQLTypes["_ValidationResult"],
	getTimetableShift?: GraphQLTypes["TimetableShift"] | undefined,
	listTimetableShift: Array<GraphQLTypes["TimetableShift"]>,
	paginateTimetableShift: GraphQLTypes["TimetableShiftConnection"],
	validateCreateTimetableShift: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetableShift: GraphQLTypes["_ValidationResult"],
	getTimetableShiftGroup?: GraphQLTypes["TimetableShiftGroup"] | undefined,
	listTimetableShiftGroup: Array<GraphQLTypes["TimetableShiftGroup"]>,
	paginateTimetableShiftGroup: GraphQLTypes["TimetableShiftGroupConnection"],
	validateCreateTimetableShiftGroup: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetableShiftGroup: GraphQLTypes["_ValidationResult"],
	getTimetableShiftPosition?: GraphQLTypes["TimetableShiftPosition"] | undefined,
	listTimetableShiftPosition: Array<GraphQLTypes["TimetableShiftPosition"]>,
	paginateTimetableShiftPosition: GraphQLTypes["TimetableShiftPositionConnection"],
	validateCreateTimetableShiftPosition: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetableShiftPosition: GraphQLTypes["_ValidationResult"],
	getTimetableTemplate?: GraphQLTypes["TimetableTemplate"] | undefined,
	listTimetableTemplate: Array<GraphQLTypes["TimetableTemplate"]>,
	paginateTimetableTemplate: GraphQLTypes["TimetableTemplateConnection"],
	validateCreateTimetableTemplate: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetableTemplate: GraphQLTypes["_ValidationResult"],
	getCart?: GraphQLTypes["Cart"] | undefined,
	listCart: Array<GraphQLTypes["Cart"]>,
	paginateCart: GraphQLTypes["CartConnection"],
	validateCreateCart: GraphQLTypes["_ValidationResult"],
	validateUpdateCart: GraphQLTypes["_ValidationResult"],
	getCartItem?: GraphQLTypes["CartItem"] | undefined,
	listCartItem: Array<GraphQLTypes["CartItem"]>,
	paginateCartItem: GraphQLTypes["CartItemConnection"],
	validateCreateCartItem: GraphQLTypes["_ValidationResult"],
	validateUpdateCartItem: GraphQLTypes["_ValidationResult"],
	getEmployeeQueueItem?: GraphQLTypes["EmployeeQueueItem"] | undefined,
	listEmployeeQueueItem: Array<GraphQLTypes["EmployeeQueueItem"]>,
	paginateEmployeeQueueItem: GraphQLTypes["EmployeeQueueItemConnection"],
	validateCreateEmployeeQueueItem: GraphQLTypes["_ValidationResult"],
	validateUpdateEmployeeQueueItem: GraphQLTypes["_ValidationResult"],
	getApplication?: GraphQLTypes["Application"] | undefined,
	listApplication: Array<GraphQLTypes["Application"]>,
	paginateApplication: GraphQLTypes["ApplicationConnection"],
	validateCreateApplication: GraphQLTypes["_ValidationResult"],
	validateUpdateApplication: GraphQLTypes["_ValidationResult"],
	getApplicationShortcutList?: GraphQLTypes["ApplicationShortcutList"] | undefined,
	listApplicationShortcutList: Array<GraphQLTypes["ApplicationShortcutList"]>,
	paginateApplicationShortcutList: GraphQLTypes["ApplicationShortcutListConnection"],
	validateCreateApplicationShortcutList: GraphQLTypes["_ValidationResult"],
	validateUpdateApplicationShortcutList: GraphQLTypes["_ValidationResult"],
	getApplicationShortcutListItem?: GraphQLTypes["ApplicationShortcutListItem"] | undefined,
	listApplicationShortcutListItem: Array<GraphQLTypes["ApplicationShortcutListItem"]>,
	paginateApplicationShortcutListItem: GraphQLTypes["ApplicationShortcutListItemConnection"],
	validateCreateApplicationShortcutListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateApplicationShortcutListItem: GraphQLTypes["_ValidationResult"],
	getProductBanner?: GraphQLTypes["ProductBanner"] | undefined,
	listProductBanner: Array<GraphQLTypes["ProductBanner"]>,
	paginateProductBanner: GraphQLTypes["ProductBannerConnection"],
	validateCreateProductBanner: GraphQLTypes["_ValidationResult"],
	validateUpdateProductBanner: GraphQLTypes["_ValidationResult"],
	getProductBannerItem?: GraphQLTypes["ProductBannerItem"] | undefined,
	listProductBannerItem: Array<GraphQLTypes["ProductBannerItem"]>,
	paginateProductBannerItem: GraphQLTypes["ProductBannerItemConnection"],
	validateCreateProductBannerItem: GraphQLTypes["_ValidationResult"],
	validateUpdateProductBannerItem: GraphQLTypes["_ValidationResult"],
	getProductBannerList?: GraphQLTypes["ProductBannerList"] | undefined,
	listProductBannerList: Array<GraphQLTypes["ProductBannerList"]>,
	paginateProductBannerList: GraphQLTypes["ProductBannerListConnection"],
	validateCreateProductBannerList: GraphQLTypes["_ValidationResult"],
	validateUpdateProductBannerList: GraphQLTypes["_ValidationResult"],
	getBartender?: GraphQLTypes["Bartender"] | undefined,
	listBartender: Array<GraphQLTypes["Bartender"]>,
	paginateBartender: GraphQLTypes["BartenderConnection"],
	validateCreateBartender: GraphQLTypes["_ValidationResult"],
	validateUpdateBartender: GraphQLTypes["_ValidationResult"],
	getBusinessToBusinessManager?: GraphQLTypes["BusinessToBusinessManager"] | undefined,
	listBusinessToBusinessManager: Array<GraphQLTypes["BusinessToBusinessManager"]>,
	paginateBusinessToBusinessManager: GraphQLTypes["BusinessToBusinessManagerConnection"],
	validateCreateBusinessToBusinessManager: GraphQLTypes["_ValidationResult"],
	validateUpdateBusinessToBusinessManager: GraphQLTypes["_ValidationResult"],
	getCleaner?: GraphQLTypes["Cleaner"] | undefined,
	listCleaner: Array<GraphQLTypes["Cleaner"]>,
	paginateCleaner: GraphQLTypes["CleanerConnection"],
	validateCreateCleaner: GraphQLTypes["_ValidationResult"],
	validateUpdateCleaner: GraphQLTypes["_ValidationResult"],
	getCourier?: GraphQLTypes["Courier"] | undefined,
	listCourier: Array<GraphQLTypes["Courier"]>,
	paginateCourier: GraphQLTypes["CourierConnection"],
	validateCreateCourier: GraphQLTypes["_ValidationResult"],
	validateUpdateCourier: GraphQLTypes["_ValidationResult"],
	getShiftsManager?: GraphQLTypes["ShiftsManager"] | undefined,
	listShiftsManager: Array<GraphQLTypes["ShiftsManager"]>,
	paginateShiftsManager: GraphQLTypes["ShiftsManagerConnection"],
	validateCreateShiftsManager: GraphQLTypes["_ValidationResult"],
	validateUpdateShiftsManager: GraphQLTypes["_ValidationResult"],
	getUser?: GraphQLTypes["User"] | undefined,
	listUser: Array<GraphQLTypes["User"]>,
	paginateUser: GraphQLTypes["UserConnection"],
	validateCreateUser: GraphQLTypes["_ValidationResult"],
	validateUpdateUser: GraphQLTypes["_ValidationResult"],
	getShiftsProfile?: GraphQLTypes["ShiftsProfile"] | undefined,
	listShiftsProfile: Array<GraphQLTypes["ShiftsProfile"]>,
	paginateShiftsProfile: GraphQLTypes["ShiftsProfileConnection"],
	validateCreateShiftsProfile: GraphQLTypes["_ValidationResult"],
	validateUpdateShiftsProfile: GraphQLTypes["_ValidationResult"],
	getProductIngredientCategory?: GraphQLTypes["ProductIngredientCategory"] | undefined,
	listProductIngredientCategory: Array<GraphQLTypes["ProductIngredientCategory"]>,
	paginateProductIngredientCategory: GraphQLTypes["ProductIngredientCategoryConnection"],
	validateCreateProductIngredientCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateProductIngredientCategory: GraphQLTypes["_ValidationResult"],
	getProductIngredientCategoryLocale?: GraphQLTypes["ProductIngredientCategoryLocale"] | undefined,
	listProductIngredientCategoryLocale: Array<GraphQLTypes["ProductIngredientCategoryLocale"]>,
	paginateProductIngredientCategoryLocale: GraphQLTypes["ProductIngredientCategoryLocaleConnection"],
	validateCreateProductIngredientCategoryLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateProductIngredientCategoryLocale: GraphQLTypes["_ValidationResult"],
	getStocksManager?: GraphQLTypes["StocksManager"] | undefined,
	listStocksManager: Array<GraphQLTypes["StocksManager"]>,
	paginateStocksManager: GraphQLTypes["StocksManagerConnection"],
	validateCreateStocksManager: GraphQLTypes["_ValidationResult"],
	validateUpdateStocksManager: GraphQLTypes["_ValidationResult"],
	getDeliveryRoute?: GraphQLTypes["DeliveryRoute"] | undefined,
	listDeliveryRoute: Array<GraphQLTypes["DeliveryRoute"]>,
	paginateDeliveryRoute: GraphQLTypes["DeliveryRouteConnection"],
	validateCreateDeliveryRoute: GraphQLTypes["_ValidationResult"],
	validateUpdateDeliveryRoute: GraphQLTypes["_ValidationResult"],
	getDeliveryWaypoint?: GraphQLTypes["DeliveryWaypoint"] | undefined,
	listDeliveryWaypoint: Array<GraphQLTypes["DeliveryWaypoint"]>,
	paginateDeliveryWaypoint: GraphQLTypes["DeliveryWaypointConnection"],
	validateCreateDeliveryWaypoint: GraphQLTypes["_ValidationResult"],
	validateUpdateDeliveryWaypoint: GraphQLTypes["_ValidationResult"],
	getAllergen?: GraphQLTypes["Allergen"] | undefined,
	listAllergen: Array<GraphQLTypes["Allergen"]>,
	paginateAllergen: GraphQLTypes["AllergenConnection"],
	validateCreateAllergen: GraphQLTypes["_ValidationResult"],
	validateUpdateAllergen: GraphQLTypes["_ValidationResult"],
	getAllergenLocale?: GraphQLTypes["AllergenLocale"] | undefined,
	listAllergenLocale: Array<GraphQLTypes["AllergenLocale"]>,
	paginateAllergenLocale: GraphQLTypes["AllergenLocaleConnection"],
	validateCreateAllergenLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateAllergenLocale: GraphQLTypes["_ValidationResult"],
	getGps?: GraphQLTypes["Gps"] | undefined,
	listGps: Array<GraphQLTypes["Gps"]>,
	paginateGps: GraphQLTypes["GpsConnection"],
	validateCreateGps: GraphQLTypes["_ValidationResult"],
	validateUpdateGps: GraphQLTypes["_ValidationResult"],
	getProductCategoryTree?: GraphQLTypes["ProductCategoryTree"] | undefined,
	listProductCategoryTree: Array<GraphQLTypes["ProductCategoryTree"]>,
	paginateProductCategoryTree: GraphQLTypes["ProductCategoryTreeConnection"],
	getInheritedProductCategoryTag?: GraphQLTypes["InheritedProductCategoryTag"] | undefined,
	listInheritedProductCategoryTag: Array<GraphQLTypes["InheritedProductCategoryTag"]>,
	paginateInheritedProductCategoryTag: GraphQLTypes["InheritedProductCategoryTagConnection"],
	getNestedProductCategoryProduct?: GraphQLTypes["NestedProductCategoryProduct"] | undefined,
	listNestedProductCategoryProduct: Array<GraphQLTypes["NestedProductCategoryProduct"]>,
	paginateNestedProductCategoryProduct: GraphQLTypes["NestedProductCategoryProductConnection"],
	getWeekHours?: GraphQLTypes["WeekHours"] | undefined,
	listWeekHours: Array<GraphQLTypes["WeekHours"]>,
	paginateWeekHours: GraphQLTypes["WeekHoursConnection"],
	validateCreateWeekHours: GraphQLTypes["_ValidationResult"],
	validateUpdateWeekHours: GraphQLTypes["_ValidationResult"],
	getPreparedIngredientQuantity?: GraphQLTypes["PreparedIngredientQuantity"] | undefined,
	listPreparedIngredientQuantity: Array<GraphQLTypes["PreparedIngredientQuantity"]>,
	paginatePreparedIngredientQuantity: GraphQLTypes["PreparedIngredientQuantityConnection"],
	validateCreatePreparedIngredientQuantity: GraphQLTypes["_ValidationResult"],
	validateUpdatePreparedIngredientQuantity: GraphQLTypes["_ValidationResult"],
	getPreparedRecipeQuantity?: GraphQLTypes["PreparedRecipeQuantity"] | undefined,
	listPreparedRecipeQuantity: Array<GraphQLTypes["PreparedRecipeQuantity"]>,
	paginatePreparedRecipeQuantity: GraphQLTypes["PreparedRecipeQuantityConnection"],
	validateCreatePreparedRecipeQuantity: GraphQLTypes["_ValidationResult"],
	validateUpdatePreparedRecipeQuantity: GraphQLTypes["_ValidationResult"],
	getInternalOrder?: GraphQLTypes["InternalOrder"] | undefined,
	listInternalOrder: Array<GraphQLTypes["InternalOrder"]>,
	paginateInternalOrder: GraphQLTypes["InternalOrderConnection"],
	validateCreateInternalOrder: GraphQLTypes["_ValidationResult"],
	validateUpdateInternalOrder: GraphQLTypes["_ValidationResult"],
	getInternalOrderItem?: GraphQLTypes["InternalOrderItem"] | undefined,
	listInternalOrderItem: Array<GraphQLTypes["InternalOrderItem"]>,
	paginateInternalOrderItem: GraphQLTypes["InternalOrderItemConnection"],
	validateCreateInternalOrderItem: GraphQLTypes["_ValidationResult"],
	validateUpdateInternalOrderItem: GraphQLTypes["_ValidationResult"],
	getPreparedPackingQuantity?: GraphQLTypes["PreparedPackingQuantity"] | undefined,
	listPreparedPackingQuantity: Array<GraphQLTypes["PreparedPackingQuantity"]>,
	paginatePreparedPackingQuantity: GraphQLTypes["PreparedPackingQuantityConnection"],
	validateCreatePreparedPackingQuantity: GraphQLTypes["_ValidationResult"],
	validateUpdatePreparedPackingQuantity: GraphQLTypes["_ValidationResult"],
	getCourierManager?: GraphQLTypes["CourierManager"] | undefined,
	listCourierManager: Array<GraphQLTypes["CourierManager"]>,
	paginateCourierManager: GraphQLTypes["CourierManagerConnection"],
	validateCreateCourierManager: GraphQLTypes["_ValidationResult"],
	validateUpdateCourierManager: GraphQLTypes["_ValidationResult"],
	getDeliveryZone?: GraphQLTypes["DeliveryZone"] | undefined,
	listDeliveryZone: Array<GraphQLTypes["DeliveryZone"]>,
	paginateDeliveryZone: GraphQLTypes["DeliveryZoneConnection"],
	validateCreateDeliveryZone: GraphQLTypes["_ValidationResult"],
	validateUpdateDeliveryZone: GraphQLTypes["_ValidationResult"],
	getAddressMetadata?: GraphQLTypes["AddressMetadata"] | undefined,
	listAddressMetadata: Array<GraphQLTypes["AddressMetadata"]>,
	paginateAddressMetadata: GraphQLTypes["AddressMetadataConnection"],
	getDeliveryTimelinePreset?: GraphQLTypes["DeliveryTimelinePreset"] | undefined,
	listDeliveryTimelinePreset: Array<GraphQLTypes["DeliveryTimelinePreset"]>,
	paginateDeliveryTimelinePreset: GraphQLTypes["DeliveryTimelinePresetConnection"],
	validateCreateDeliveryTimelinePreset: GraphQLTypes["_ValidationResult"],
	validateUpdateDeliveryTimelinePreset: GraphQLTypes["_ValidationResult"],
	getOrderDeliveryTimeline?: GraphQLTypes["OrderDeliveryTimeline"] | undefined,
	listOrderDeliveryTimeline: Array<GraphQLTypes["OrderDeliveryTimeline"]>,
	paginateOrderDeliveryTimeline: GraphQLTypes["OrderDeliveryTimelineConnection"],
	validateCreateOrderDeliveryTimeline: GraphQLTypes["_ValidationResult"],
	validateUpdateOrderDeliveryTimeline: GraphQLTypes["_ValidationResult"],
	getOrderEvent?: GraphQLTypes["OrderEvent"] | undefined,
	listOrderEvent: Array<GraphQLTypes["OrderEvent"]>,
	paginateOrderEvent: GraphQLTypes["OrderEventConnection"],
	validateCreateOrderEvent: GraphQLTypes["_ValidationResult"],
	validateUpdateOrderEvent: GraphQLTypes["_ValidationResult"],
	getLiftagoRide?: GraphQLTypes["LiftagoRide"] | undefined,
	listLiftagoRide: Array<GraphQLTypes["LiftagoRide"]>,
	paginateLiftagoRide: GraphQLTypes["LiftagoRideConnection"],
	validateCreateLiftagoRide: GraphQLTypes["_ValidationResult"],
	validateUpdateLiftagoRide: GraphQLTypes["_ValidationResult"],
	getInvoice?: GraphQLTypes["Invoice"] | undefined,
	listInvoice: Array<GraphQLTypes["Invoice"]>,
	paginateInvoice: GraphQLTypes["InvoiceConnection"],
	validateCreateInvoice: GraphQLTypes["_ValidationResult"],
	validateUpdateInvoice: GraphQLTypes["_ValidationResult"],
	getInvoicingPlan?: GraphQLTypes["InvoicingPlan"] | undefined,
	listInvoicingPlan: Array<GraphQLTypes["InvoicingPlan"]>,
	paginateInvoicingPlan: GraphQLTypes["InvoicingPlanConnection"],
	validateCreateInvoicingPlan: GraphQLTypes["_ValidationResult"],
	validateUpdateInvoicingPlan: GraphQLTypes["_ValidationResult"],
	getProductPackingLocale?: GraphQLTypes["ProductPackingLocale"] | undefined,
	listProductPackingLocale: Array<GraphQLTypes["ProductPackingLocale"]>,
	paginateProductPackingLocale: GraphQLTypes["ProductPackingLocaleConnection"],
	validateCreateProductPackingLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateProductPackingLocale: GraphQLTypes["_ValidationResult"],
	getProductLocale?: GraphQLTypes["ProductLocale"] | undefined,
	listProductLocale: Array<GraphQLTypes["ProductLocale"]>,
	paginateProductLocale: GraphQLTypes["ProductLocaleConnection"],
	validateCreateProductLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateProductLocale: GraphQLTypes["_ValidationResult"],
	getProductRecipeLocale?: GraphQLTypes["ProductRecipeLocale"] | undefined,
	listProductRecipeLocale: Array<GraphQLTypes["ProductRecipeLocale"]>,
	paginateProductRecipeLocale: GraphQLTypes["ProductRecipeLocaleConnection"],
	validateCreateProductRecipeLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateProductRecipeLocale: GraphQLTypes["_ValidationResult"],
	getUserDevice?: GraphQLTypes["UserDevice"] | undefined,
	listUserDevice: Array<GraphQLTypes["UserDevice"]>,
	paginateUserDevice: GraphQLTypes["UserDeviceConnection"],
	validateCreateUserDevice: GraphQLTypes["_ValidationResult"],
	validateUpdateUserDevice: GraphQLTypes["_ValidationResult"],
	getProtectedAction?: GraphQLTypes["ProtectedAction"] | undefined,
	listProtectedAction: Array<GraphQLTypes["ProtectedAction"]>,
	paginateProtectedAction: GraphQLTypes["ProtectedActionConnection"],
	validateCreateProtectedAction: GraphQLTypes["_ValidationResult"],
	validateUpdateProtectedAction: GraphQLTypes["_ValidationResult"],
	getPicker?: GraphQLTypes["Picker"] | undefined,
	listPicker: Array<GraphQLTypes["Picker"]>,
	paginatePicker: GraphQLTypes["PickerConnection"],
	validateCreatePicker: GraphQLTypes["_ValidationResult"],
	validateUpdatePicker: GraphQLTypes["_ValidationResult"],
	getTenantPerson?: GraphQLTypes["TenantPerson"] | undefined,
	listTenantPerson: Array<GraphQLTypes["TenantPerson"]>,
	paginateTenantPerson: GraphQLTypes["TenantPersonConnection"],
	getTimetableTemplateStaffOptions?: GraphQLTypes["TimetableTemplateStaffOptions"] | undefined,
	listTimetableTemplateStaffOptions: Array<GraphQLTypes["TimetableTemplateStaffOptions"]>,
	paginateTimetableTemplateStaffOptions: GraphQLTypes["TimetableTemplateStaffOptionsConnection"],
	validateCreateTimetableTemplateStaffOptions: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetableTemplateStaffOptions: GraphQLTypes["_ValidationResult"],
	getShoppingList?: GraphQLTypes["ShoppingList"] | undefined,
	listShoppingList: Array<GraphQLTypes["ShoppingList"]>,
	paginateShoppingList: GraphQLTypes["ShoppingListConnection"],
	validateCreateShoppingList: GraphQLTypes["_ValidationResult"],
	validateUpdateShoppingList: GraphQLTypes["_ValidationResult"],
	getSuppliesPurchase?: GraphQLTypes["SuppliesPurchase"] | undefined,
	listSuppliesPurchase: Array<GraphQLTypes["SuppliesPurchase"]>,
	paginateSuppliesPurchase: GraphQLTypes["SuppliesPurchaseConnection"],
	validateCreateSuppliesPurchase: GraphQLTypes["_ValidationResult"],
	validateUpdateSuppliesPurchase: GraphQLTypes["_ValidationResult"],
	getInvoicingPreset?: GraphQLTypes["InvoicingPreset"] | undefined,
	listInvoicingPreset: Array<GraphQLTypes["InvoicingPreset"]>,
	paginateInvoicingPreset: GraphQLTypes["InvoicingPresetConnection"],
	validateCreateInvoicingPreset: GraphQLTypes["_ValidationResult"],
	validateUpdateInvoicingPreset: GraphQLTypes["_ValidationResult"],
	getLogRecord?: GraphQLTypes["LogRecord"] | undefined,
	listLogRecord: Array<GraphQLTypes["LogRecord"]>,
	paginateLogRecord: GraphQLTypes["LogRecordConnection"],
	validateCreateLogRecord: GraphQLTypes["_ValidationResult"],
	validateUpdateLogRecord: GraphQLTypes["_ValidationResult"],
	getBillingSubject?: GraphQLTypes["BillingSubject"] | undefined,
	listBillingSubject: Array<GraphQLTypes["BillingSubject"]>,
	paginateBillingSubject: GraphQLTypes["BillingSubjectConnection"],
	validateCreateBillingSubject: GraphQLTypes["_ValidationResult"],
	validateUpdateBillingSubject: GraphQLTypes["_ValidationResult"],
	getProductCustomerPrice?: GraphQLTypes["ProductCustomerPrice"] | undefined,
	listProductCustomerPrice: Array<GraphQLTypes["ProductCustomerPrice"]>,
	paginateProductCustomerPrice: GraphQLTypes["ProductCustomerPriceConnection"],
	getCartPriceLine?: GraphQLTypes["CartPriceLine"] | undefined,
	listCartPriceLine: Array<GraphQLTypes["CartPriceLine"]>,
	paginateCartPriceLine: GraphQLTypes["CartPriceLineConnection"],
	getShoppingListItem?: GraphQLTypes["ShoppingListItem"] | undefined,
	listShoppingListItem: Array<GraphQLTypes["ShoppingListItem"]>,
	paginateShoppingListItem: GraphQLTypes["ShoppingListItemConnection"],
	validateCreateShoppingListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateShoppingListItem: GraphQLTypes["_ValidationResult"],
	getSuppliesPurchaseItem?: GraphQLTypes["SuppliesPurchaseItem"] | undefined,
	listSuppliesPurchaseItem: Array<GraphQLTypes["SuppliesPurchaseItem"]>,
	paginateSuppliesPurchaseItem: GraphQLTypes["SuppliesPurchaseItemConnection"],
	validateCreateSuppliesPurchaseItem: GraphQLTypes["_ValidationResult"],
	validateUpdateSuppliesPurchaseItem: GraphQLTypes["_ValidationResult"],
	getCustomerCreditTransaction?: GraphQLTypes["CustomerCreditTransaction"] | undefined,
	listCustomerCreditTransaction: Array<GraphQLTypes["CustomerCreditTransaction"]>,
	paginateCustomerCreditTransaction: GraphQLTypes["CustomerCreditTransactionConnection"],
	validateCreateCustomerCreditTransaction: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomerCreditTransaction: GraphQLTypes["_ValidationResult"],
	getVirtualProduct?: GraphQLTypes["VirtualProduct"] | undefined,
	listVirtualProduct: Array<GraphQLTypes["VirtualProduct"]>,
	paginateVirtualProduct: GraphQLTypes["VirtualProductConnection"],
	validateCreateVirtualProduct: GraphQLTypes["_ValidationResult"],
	validateUpdateVirtualProduct: GraphQLTypes["_ValidationResult"],
	getVirtualProductEffect?: GraphQLTypes["VirtualProductEffect"] | undefined,
	listVirtualProductEffect: Array<GraphQLTypes["VirtualProductEffect"]>,
	paginateVirtualProductEffect: GraphQLTypes["VirtualProductEffectConnection"],
	validateCreateVirtualProductEffect: GraphQLTypes["_ValidationResult"],
	validateUpdateVirtualProductEffect: GraphQLTypes["_ValidationResult"],
	getOrderPriceLine?: GraphQLTypes["OrderPriceLine"] | undefined,
	listOrderPriceLine: Array<GraphQLTypes["OrderPriceLine"]>,
	paginateOrderPriceLine: GraphQLTypes["OrderPriceLineConnection"],
	getProductMetadata?: GraphQLTypes["ProductMetadata"] | undefined,
	listProductMetadata: Array<GraphQLTypes["ProductMetadata"]>,
	paginateProductMetadata: GraphQLTypes["ProductMetadataConnection"],
	getEmploymentInformation?: GraphQLTypes["EmploymentInformation"] | undefined,
	listEmploymentInformation: Array<GraphQLTypes["EmploymentInformation"]>,
	paginateEmploymentInformation: GraphQLTypes["EmploymentInformationConnection"],
	validateCreateEmploymentInformation: GraphQLTypes["_ValidationResult"],
	validateUpdateEmploymentInformation: GraphQLTypes["_ValidationResult"],
	getRemunerationProfile?: GraphQLTypes["RemunerationProfile"] | undefined,
	listRemunerationProfile: Array<GraphQLTypes["RemunerationProfile"]>,
	paginateRemunerationProfile: GraphQLTypes["RemunerationProfileConnection"],
	validateCreateRemunerationProfile: GraphQLTypes["_ValidationResult"],
	validateUpdateRemunerationProfile: GraphQLTypes["_ValidationResult"],
	getWorkMonth?: GraphQLTypes["WorkMonth"] | undefined,
	listWorkMonth: Array<GraphQLTypes["WorkMonth"]>,
	paginateWorkMonth: GraphQLTypes["WorkMonthConnection"],
	validateCreateWorkMonth: GraphQLTypes["_ValidationResult"],
	validateUpdateWorkMonth: GraphQLTypes["_ValidationResult"],
	getSalaryOptions?: GraphQLTypes["SalaryOptions"] | undefined,
	listSalaryOptions: Array<GraphQLTypes["SalaryOptions"]>,
	paginateSalaryOptions: GraphQLTypes["SalaryOptionsConnection"],
	validateCreateSalaryOptions: GraphQLTypes["_ValidationResult"],
	validateUpdateSalaryOptions: GraphQLTypes["_ValidationResult"],
	getTimetableShiftSwapInfo?: GraphQLTypes["TimetableShiftSwapInfo"] | undefined,
	listTimetableShiftSwapInfo: Array<GraphQLTypes["TimetableShiftSwapInfo"]>,
	paginateTimetableShiftSwapInfo: GraphQLTypes["TimetableShiftSwapInfoConnection"],
	validateCreateTimetableShiftSwapInfo: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetableShiftSwapInfo: GraphQLTypes["_ValidationResult"],
	getProductGridCategory?: GraphQLTypes["ProductGridCategory"] | undefined,
	listProductGridCategory: Array<GraphQLTypes["ProductGridCategory"]>,
	paginateProductGridCategory: GraphQLTypes["ProductGridCategoryConnection"],
	validateCreateProductGridCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateProductGridCategory: GraphQLTypes["_ValidationResult"],
	getCashier?: GraphQLTypes["Cashier"] | undefined,
	listCashier: Array<GraphQLTypes["Cashier"]>,
	paginateCashier: GraphQLTypes["CashierConnection"],
	validateCreateCashier: GraphQLTypes["_ValidationResult"],
	validateUpdateCashier: GraphQLTypes["_ValidationResult"],
	getPointOfSaleCategory?: GraphQLTypes["PointOfSaleCategory"] | undefined,
	listPointOfSaleCategory: Array<GraphQLTypes["PointOfSaleCategory"]>,
	paginatePointOfSaleCategory: GraphQLTypes["PointOfSaleCategoryConnection"],
	validateCreatePointOfSaleCategory: GraphQLTypes["_ValidationResult"],
	validateUpdatePointOfSaleCategory: GraphQLTypes["_ValidationResult"],
	getPointOfSaleCategoryLocale?: GraphQLTypes["PointOfSaleCategoryLocale"] | undefined,
	listPointOfSaleCategoryLocale: Array<GraphQLTypes["PointOfSaleCategoryLocale"]>,
	paginatePointOfSaleCategoryLocale: GraphQLTypes["PointOfSaleCategoryLocaleConnection"],
	validateCreatePointOfSaleCategoryLocale: GraphQLTypes["_ValidationResult"],
	validateUpdatePointOfSaleCategoryLocale: GraphQLTypes["_ValidationResult"],
	getPointOfSaleCategoryProduct?: GraphQLTypes["PointOfSaleCategoryProduct"] | undefined,
	listPointOfSaleCategoryProduct: Array<GraphQLTypes["PointOfSaleCategoryProduct"]>,
	paginatePointOfSaleCategoryProduct: GraphQLTypes["PointOfSaleCategoryProductConnection"],
	validateCreatePointOfSaleCategoryProduct: GraphQLTypes["_ValidationResult"],
	validateUpdatePointOfSaleCategoryProduct: GraphQLTypes["_ValidationResult"],
	getPointOfSaleCategoryProductLocale?: GraphQLTypes["PointOfSaleCategoryProductLocale"] | undefined,
	listPointOfSaleCategoryProductLocale: Array<GraphQLTypes["PointOfSaleCategoryProductLocale"]>,
	paginatePointOfSaleCategoryProductLocale: GraphQLTypes["PointOfSaleCategoryProductLocaleConnection"],
	validateCreatePointOfSaleCategoryProductLocale: GraphQLTypes["_ValidationResult"],
	validateUpdatePointOfSaleCategoryProductLocale: GraphQLTypes["_ValidationResult"],
	getCustomerTab?: GraphQLTypes["CustomerTab"] | undefined,
	listCustomerTab: Array<GraphQLTypes["CustomerTab"]>,
	paginateCustomerTab: GraphQLTypes["CustomerTabConnection"],
	validateCreateCustomerTab: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomerTab: GraphQLTypes["_ValidationResult"],
	getCustomerTabItem?: GraphQLTypes["CustomerTabItem"] | undefined,
	listCustomerTabItem: Array<GraphQLTypes["CustomerTabItem"]>,
	paginateCustomerTabItem: GraphQLTypes["CustomerTabItemConnection"],
	validateCreateCustomerTabItem: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomerTabItem: GraphQLTypes["_ValidationResult"],
	getAnonymousSession?: GraphQLTypes["AnonymousSession"] | undefined,
	listAnonymousSession: Array<GraphQLTypes["AnonymousSession"]>,
	paginateAnonymousSession: GraphQLTypes["AnonymousSessionConnection"],
	validateCreateAnonymousSession: GraphQLTypes["_ValidationResult"],
	validateUpdateAnonymousSession: GraphQLTypes["_ValidationResult"],
	getVoucher?: GraphQLTypes["Voucher"] | undefined,
	listVoucher: Array<GraphQLTypes["Voucher"]>,
	paginateVoucher: GraphQLTypes["VoucherConnection"],
	validateCreateVoucher: GraphQLTypes["_ValidationResult"],
	validateUpdateVoucher: GraphQLTypes["_ValidationResult"],
	getVoucherRedemption?: GraphQLTypes["VoucherRedemption"] | undefined,
	listVoucherRedemption: Array<GraphQLTypes["VoucherRedemption"]>,
	paginateVoucherRedemption: GraphQLTypes["VoucherRedemptionConnection"],
	validateCreateVoucherRedemption: GraphQLTypes["_ValidationResult"],
	validateUpdateVoucherRedemption: GraphQLTypes["_ValidationResult"],
	getUnassignedShiftInfo?: GraphQLTypes["UnassignedShiftInfo"] | undefined,
	listUnassignedShiftInfo: Array<GraphQLTypes["UnassignedShiftInfo"]>,
	paginateUnassignedShiftInfo: GraphQLTypes["UnassignedShiftInfoConnection"],
	validateCreateUnassignedShiftInfo: GraphQLTypes["_ValidationResult"],
	validateUpdateUnassignedShiftInfo: GraphQLTypes["_ValidationResult"],
	getFreshingContainer?: GraphQLTypes["FreshingContainer"] | undefined,
	listFreshingContainer: Array<GraphQLTypes["FreshingContainer"]>,
	paginateFreshingContainer: GraphQLTypes["FreshingContainerConnection"],
	validateCreateFreshingContainer: GraphQLTypes["_ValidationResult"],
	validateUpdateFreshingContainer: GraphQLTypes["_ValidationResult"],
	getTextItem?: GraphQLTypes["TextItem"] | undefined,
	listTextItem: Array<GraphQLTypes["TextItem"]>,
	paginateTextItem: GraphQLTypes["TextItemConnection"],
	validateCreateTextItem: GraphQLTypes["_ValidationResult"],
	validateUpdateTextItem: GraphQLTypes["_ValidationResult"],
	getTextList?: GraphQLTypes["TextList"] | undefined,
	listTextList: Array<GraphQLTypes["TextList"]>,
	paginateTextList: GraphQLTypes["TextListConnection"],
	validateCreateTextList: GraphQLTypes["_ValidationResult"],
	validateUpdateTextList: GraphQLTypes["_ValidationResult"],
	getEmployeeQueueItemMetadata?: GraphQLTypes["EmployeeQueueItemMetadata"] | undefined,
	listEmployeeQueueItemMetadata: Array<GraphQLTypes["EmployeeQueueItemMetadata"]>,
	paginateEmployeeQueueItemMetadata: GraphQLTypes["EmployeeQueueItemMetadataConnection"],
	getDeliveryRegions?: GraphQLTypes["DeliveryRegions"] | undefined,
	listDeliveryRegions: Array<GraphQLTypes["DeliveryRegions"]>,
	paginateDeliveryRegions: GraphQLTypes["DeliveryRegionsConnection"],
	validateCreateDeliveryRegions: GraphQLTypes["_ValidationResult"],
	validateUpdateDeliveryRegions: GraphQLTypes["_ValidationResult"],
	getDeliveryRegionsItem?: GraphQLTypes["DeliveryRegionsItem"] | undefined,
	listDeliveryRegionsItem: Array<GraphQLTypes["DeliveryRegionsItem"]>,
	paginateDeliveryRegionsItem: GraphQLTypes["DeliveryRegionsItemConnection"],
	validateCreateDeliveryRegionsItem: GraphQLTypes["_ValidationResult"],
	validateUpdateDeliveryRegionsItem: GraphQLTypes["_ValidationResult"],
	getImageList?: GraphQLTypes["ImageList"] | undefined,
	listImageList: Array<GraphQLTypes["ImageList"]>,
	paginateImageList: GraphQLTypes["ImageListConnection"],
	validateCreateImageList: GraphQLTypes["_ValidationResult"],
	validateUpdateImageList: GraphQLTypes["_ValidationResult"],
	getImageListItem?: GraphQLTypes["ImageListItem"] | undefined,
	listImageListItem: Array<GraphQLTypes["ImageListItem"]>,
	paginateImageListItem: GraphQLTypes["ImageListItemConnection"],
	validateCreateImageListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateImageListItem: GraphQLTypes["_ValidationResult"],
	getProductSalesDay?: GraphQLTypes["ProductSalesDay"] | undefined,
	listProductSalesDay: Array<GraphQLTypes["ProductSalesDay"]>,
	paginateProductSalesDay: GraphQLTypes["ProductSalesDayConnection"],
	getProductSalesMonth?: GraphQLTypes["ProductSalesMonth"] | undefined,
	listProductSalesMonth: Array<GraphQLTypes["ProductSalesMonth"]>,
	paginateProductSalesMonth: GraphQLTypes["ProductSalesMonthConnection"],
	getProductSalesWeek?: GraphQLTypes["ProductSalesWeek"] | undefined,
	listProductSalesWeek: Array<GraphQLTypes["ProductSalesWeek"]>,
	paginateProductSalesWeek: GraphQLTypes["ProductSalesWeekConnection"],
	getTimetablesEmployeePrivileges?: GraphQLTypes["TimetablesEmployeePrivileges"] | undefined,
	listTimetablesEmployeePrivileges: Array<GraphQLTypes["TimetablesEmployeePrivileges"]>,
	paginateTimetablesEmployeePrivileges: GraphQLTypes["TimetablesEmployeePrivilegesConnection"],
	validateCreateTimetablesEmployeePrivileges: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetablesEmployeePrivileges: GraphQLTypes["_ValidationResult"],
	getTimetableDayNote?: GraphQLTypes["TimetableDayNote"] | undefined,
	listTimetableDayNote: Array<GraphQLTypes["TimetableDayNote"]>,
	paginateTimetableDayNote: GraphQLTypes["TimetableDayNoteConnection"],
	validateCreateTimetableDayNote: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetableDayNote: GraphQLTypes["_ValidationResult"],
	getDeliveryMethodLocale?: GraphQLTypes["DeliveryMethodLocale"] | undefined,
	listDeliveryMethodLocale: Array<GraphQLTypes["DeliveryMethodLocale"]>,
	paginateDeliveryMethodLocale: GraphQLTypes["DeliveryMethodLocaleConnection"],
	validateCreateDeliveryMethodLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateDeliveryMethodLocale: GraphQLTypes["_ValidationResult"],
	getIngredientSupplier?: GraphQLTypes["IngredientSupplier"] | undefined,
	listIngredientSupplier: Array<GraphQLTypes["IngredientSupplier"]>,
	paginateIngredientSupplier: GraphQLTypes["IngredientSupplierConnection"],
	validateCreateIngredientSupplier: GraphQLTypes["_ValidationResult"],
	validateUpdateIngredientSupplier: GraphQLTypes["_ValidationResult"],
	getIngredientSupplierItem?: GraphQLTypes["IngredientSupplierItem"] | undefined,
	listIngredientSupplierItem: Array<GraphQLTypes["IngredientSupplierItem"]>,
	paginateIngredientSupplierItem: GraphQLTypes["IngredientSupplierItemConnection"],
	validateCreateIngredientSupplierItem: GraphQLTypes["_ValidationResult"],
	validateUpdateIngredientSupplierItem: GraphQLTypes["_ValidationResult"],
	getIngredientSupplierList?: GraphQLTypes["IngredientSupplierList"] | undefined,
	listIngredientSupplierList: Array<GraphQLTypes["IngredientSupplierList"]>,
	paginateIngredientSupplierList: GraphQLTypes["IngredientSupplierListConnection"],
	validateCreateIngredientSupplierList: GraphQLTypes["_ValidationResult"],
	validateUpdateIngredientSupplierList: GraphQLTypes["_ValidationResult"],
	getIngredientSupplierLocale?: GraphQLTypes["IngredientSupplierLocale"] | undefined,
	listIngredientSupplierLocale: Array<GraphQLTypes["IngredientSupplierLocale"]>,
	paginateIngredientSupplierLocale: GraphQLTypes["IngredientSupplierLocaleConnection"],
	validateCreateIngredientSupplierLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateIngredientSupplierLocale: GraphQLTypes["_ValidationResult"],
	getRedirect?: GraphQLTypes["Redirect"] | undefined,
	listRedirect: Array<GraphQLTypes["Redirect"]>,
	paginateRedirect: GraphQLTypes["RedirectConnection"],
	validateCreateRedirect: GraphQLTypes["_ValidationResult"],
	validateUpdateRedirect: GraphQLTypes["_ValidationResult"],
	getNutritionFacts?: GraphQLTypes["NutritionFacts"] | undefined,
	listNutritionFacts: Array<GraphQLTypes["NutritionFacts"]>,
	paginateNutritionFacts: GraphQLTypes["NutritionFactsConnection"],
	validateCreateNutritionFacts: GraphQLTypes["_ValidationResult"],
	validateUpdateNutritionFacts: GraphQLTypes["_ValidationResult"],
	getVenue?: GraphQLTypes["Venue"] | undefined,
	listVenue: Array<GraphQLTypes["Venue"]>,
	paginateVenue: GraphQLTypes["VenueConnection"],
	validateCreateVenue: GraphQLTypes["_ValidationResult"],
	validateUpdateVenue: GraphQLTypes["_ValidationResult"],
	getWorkspace?: GraphQLTypes["Workspace"] | undefined,
	listWorkspace: Array<GraphQLTypes["Workspace"]>,
	paginateWorkspace: GraphQLTypes["WorkspaceConnection"],
	validateCreateWorkspace: GraphQLTypes["_ValidationResult"],
	validateUpdateWorkspace: GraphQLTypes["_ValidationResult"],
	getInternalBuyer?: GraphQLTypes["InternalBuyer"] | undefined,
	listInternalBuyer: Array<GraphQLTypes["InternalBuyer"]>,
	paginateInternalBuyer: GraphQLTypes["InternalBuyerConnection"],
	validateCreateInternalBuyer: GraphQLTypes["_ValidationResult"],
	validateUpdateInternalBuyer: GraphQLTypes["_ValidationResult"],
	getCartSummary?: GraphQLTypes["CartSummary"] | undefined,
	listCartSummary: Array<GraphQLTypes["CartSummary"]>,
	paginateCartSummary: GraphQLTypes["CartSummaryConnection"],
	getOrderSummary?: GraphQLTypes["OrderSummary"] | undefined,
	listOrderSummary: Array<GraphQLTypes["OrderSummary"]>,
	paginateOrderSummary: GraphQLTypes["OrderSummaryConnection"],
	getCustomerSpending?: GraphQLTypes["CustomerSpending"] | undefined,
	listCustomerSpending: Array<GraphQLTypes["CustomerSpending"]>,
	paginateCustomerSpending: GraphQLTypes["CustomerSpendingConnection"],
	getOrderPaymentMetadata?: GraphQLTypes["OrderPaymentMetadata"] | undefined,
	listOrderPaymentMetadata: Array<GraphQLTypes["OrderPaymentMetadata"]>,
	paginateOrderPaymentMetadata: GraphQLTypes["OrderPaymentMetadataConnection"],
	getUserMetadata?: GraphQLTypes["UserMetadata"] | undefined,
	listUserMetadata: Array<GraphQLTypes["UserMetadata"]>,
	paginateUserMetadata: GraphQLTypes["UserMetadataConnection"],
	getCustomerTabMetadata?: GraphQLTypes["CustomerTabMetadata"] | undefined,
	listCustomerTabMetadata: Array<GraphQLTypes["CustomerTabMetadata"]>,
	paginateCustomerTabMetadata: GraphQLTypes["CustomerTabMetadataConnection"],
	getVenueEmployeeRole?: GraphQLTypes["VenueEmployeeRole"] | undefined,
	listVenueEmployeeRole: Array<GraphQLTypes["VenueEmployeeRole"]>,
	paginateVenueEmployeeRole: GraphQLTypes["VenueEmployeeRoleConnection"],
	validateCreateVenueEmployeeRole: GraphQLTypes["_ValidationResult"],
	validateUpdateVenueEmployeeRole: GraphQLTypes["_ValidationResult"],
	getIdentificationAttempt?: GraphQLTypes["IdentificationAttempt"] | undefined,
	listIdentificationAttempt: Array<GraphQLTypes["IdentificationAttempt"]>,
	paginateIdentificationAttempt: GraphQLTypes["IdentificationAttemptConnection"],
	validateCreateIdentificationAttempt: GraphQLTypes["_ValidationResult"],
	validateUpdateIdentificationAttempt: GraphQLTypes["_ValidationResult"],
	getIdentificationCode?: GraphQLTypes["IdentificationCode"] | undefined,
	listIdentificationCode: Array<GraphQLTypes["IdentificationCode"]>,
	paginateIdentificationCode: GraphQLTypes["IdentificationCodeConnection"],
	validateCreateIdentificationCode: GraphQLTypes["_ValidationResult"],
	validateUpdateIdentificationCode: GraphQLTypes["_ValidationResult"],
	getIdentificationCodeLocale?: GraphQLTypes["IdentificationCodeLocale"] | undefined,
	listIdentificationCodeLocale: Array<GraphQLTypes["IdentificationCodeLocale"]>,
	paginateIdentificationCodeLocale: GraphQLTypes["IdentificationCodeLocaleConnection"],
	validateCreateIdentificationCodeLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateIdentificationCodeLocale: GraphQLTypes["_ValidationResult"],
	getPipeline?: GraphQLTypes["Pipeline"] | undefined,
	listPipeline: Array<GraphQLTypes["Pipeline"]>,
	paginatePipeline: GraphQLTypes["PipelineConnection"],
	validateCreatePipeline: GraphQLTypes["_ValidationResult"],
	validateUpdatePipeline: GraphQLTypes["_ValidationResult"],
	getPipelineLead?: GraphQLTypes["PipelineLead"] | undefined,
	listPipelineLead: Array<GraphQLTypes["PipelineLead"]>,
	paginatePipelineLead: GraphQLTypes["PipelineLeadConnection"],
	validateCreatePipelineLead: GraphQLTypes["_ValidationResult"],
	validateUpdatePipelineLead: GraphQLTypes["_ValidationResult"],
	getPipelineStage?: GraphQLTypes["PipelineStage"] | undefined,
	listPipelineStage: Array<GraphQLTypes["PipelineStage"]>,
	paginatePipelineStage: GraphQLTypes["PipelineStageConnection"],
	validateCreatePipelineStage: GraphQLTypes["_ValidationResult"],
	validateUpdatePipelineStage: GraphQLTypes["_ValidationResult"],
	getPipelineStageItem?: GraphQLTypes["PipelineStageItem"] | undefined,
	listPipelineStageItem: Array<GraphQLTypes["PipelineStageItem"]>,
	paginatePipelineStageItem: GraphQLTypes["PipelineStageItemConnection"],
	validateCreatePipelineStageItem: GraphQLTypes["_ValidationResult"],
	validateUpdatePipelineStageItem: GraphQLTypes["_ValidationResult"],
	getPipelineStageLocale?: GraphQLTypes["PipelineStageLocale"] | undefined,
	listPipelineStageLocale: Array<GraphQLTypes["PipelineStageLocale"]>,
	paginatePipelineStageLocale: GraphQLTypes["PipelineStageLocaleConnection"],
	validateCreatePipelineStageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdatePipelineStageLocale: GraphQLTypes["_ValidationResult"],
	getSalesManager?: GraphQLTypes["SalesManager"] | undefined,
	listSalesManager: Array<GraphQLTypes["SalesManager"]>,
	paginateSalesManager: GraphQLTypes["SalesManagerConnection"],
	validateCreateSalesManager: GraphQLTypes["_ValidationResult"],
	validateUpdateSalesManager: GraphQLTypes["_ValidationResult"],
	getCashierManager?: GraphQLTypes["CashierManager"] | undefined,
	listCashierManager: Array<GraphQLTypes["CashierManager"]>,
	paginateCashierManager: GraphQLTypes["CashierManagerConnection"],
	validateCreateCashierManager: GraphQLTypes["_ValidationResult"],
	validateUpdateCashierManager: GraphQLTypes["_ValidationResult"],
	getUserRoles?: GraphQLTypes["UserRoles"] | undefined,
	listUserRoles: Array<GraphQLTypes["UserRoles"]>,
	paginateUserRoles: GraphQLTypes["UserRolesConnection"],
	getPointOfSaleApplicationDevice?: GraphQLTypes["PointOfSaleApplicationDevice"] | undefined,
	listPointOfSaleApplicationDevice: Array<GraphQLTypes["PointOfSaleApplicationDevice"]>,
	paginatePointOfSaleApplicationDevice: GraphQLTypes["PointOfSaleApplicationDeviceConnection"],
	validateCreatePointOfSaleApplicationDevice: GraphQLTypes["_ValidationResult"],
	validateUpdatePointOfSaleApplicationDevice: GraphQLTypes["_ValidationResult"],
	getPointOfSaleTerminal?: GraphQLTypes["PointOfSaleTerminal"] | undefined,
	listPointOfSaleTerminal: Array<GraphQLTypes["PointOfSaleTerminal"]>,
	paginatePointOfSaleTerminal: GraphQLTypes["PointOfSaleTerminalConnection"],
	validateCreatePointOfSaleTerminal: GraphQLTypes["_ValidationResult"],
	validateUpdatePointOfSaleTerminal: GraphQLTypes["_ValidationResult"],
	getPipelineStageSentiment?: GraphQLTypes["PipelineStageSentiment"] | undefined,
	listPipelineStageSentiment: Array<GraphQLTypes["PipelineStageSentiment"]>,
	paginatePipelineStageSentiment: GraphQLTypes["PipelineStageSentimentConnection"],
	validateCreatePipelineStageSentiment: GraphQLTypes["_ValidationResult"],
	validateUpdatePipelineStageSentiment: GraphQLTypes["_ValidationResult"],
	getDeviceIdentifier?: GraphQLTypes["DeviceIdentifier"] | undefined,
	listDeviceIdentifier: Array<GraphQLTypes["DeviceIdentifier"]>,
	paginateDeviceIdentifier: GraphQLTypes["DeviceIdentifierConnection"],
	validateCreateDeviceIdentifier: GraphQLTypes["_ValidationResult"],
	validateUpdateDeviceIdentifier: GraphQLTypes["_ValidationResult"],
	getDeviceIdentifierMetadata?: GraphQLTypes["DeviceIdentifierMetadata"] | undefined,
	listDeviceIdentifierMetadata: Array<GraphQLTypes["DeviceIdentifierMetadata"]>,
	paginateDeviceIdentifierMetadata: GraphQLTypes["DeviceIdentifierMetadataConnection"],
	getPointOfSalePrinter?: GraphQLTypes["PointOfSalePrinter"] | undefined,
	listPointOfSalePrinter: Array<GraphQLTypes["PointOfSalePrinter"]>,
	paginatePointOfSalePrinter: GraphQLTypes["PointOfSalePrinterConnection"],
	validateCreatePointOfSalePrinter: GraphQLTypes["_ValidationResult"],
	validateUpdatePointOfSalePrinter: GraphQLTypes["_ValidationResult"],
	getGratuity?: GraphQLTypes["Gratuity"] | undefined,
	listGratuity: Array<GraphQLTypes["Gratuity"]>,
	paginateGratuity: GraphQLTypes["GratuityConnection"],
	validateCreateGratuity: GraphQLTypes["_ValidationResult"],
	validateUpdateGratuity: GraphQLTypes["_ValidationResult"],
	getFulfillmentNote?: GraphQLTypes["FulfillmentNote"] | undefined,
	listFulfillmentNote: Array<GraphQLTypes["FulfillmentNote"]>,
	paginateFulfillmentNote: GraphQLTypes["FulfillmentNoteConnection"],
	validateCreateFulfillmentNote: GraphQLTypes["_ValidationResult"],
	validateUpdateFulfillmentNote: GraphQLTypes["_ValidationResult"],
	getCustomerMetadata?: GraphQLTypes["CustomerMetadata"] | undefined,
	listCustomerMetadata: Array<GraphQLTypes["CustomerMetadata"]>,
	paginateCustomerMetadata: GraphQLTypes["CustomerMetadataConnection"],
	getLeadForm?: GraphQLTypes["LeadForm"] | undefined,
	listLeadForm: Array<GraphQLTypes["LeadForm"]>,
	paginateLeadForm: GraphQLTypes["LeadFormConnection"],
	validateCreateLeadForm: GraphQLTypes["_ValidationResult"],
	validateUpdateLeadForm: GraphQLTypes["_ValidationResult"],
	getSubscriptionBox?: GraphQLTypes["SubscriptionBox"] | undefined,
	listSubscriptionBox: Array<GraphQLTypes["SubscriptionBox"]>,
	paginateSubscriptionBox: GraphQLTypes["SubscriptionBoxConnection"],
	validateCreateSubscriptionBox: GraphQLTypes["_ValidationResult"],
	validateUpdateSubscriptionBox: GraphQLTypes["_ValidationResult"],
	getSubscriptionBoxLocale?: GraphQLTypes["SubscriptionBoxLocale"] | undefined,
	listSubscriptionBoxLocale: Array<GraphQLTypes["SubscriptionBoxLocale"]>,
	paginateSubscriptionBoxLocale: GraphQLTypes["SubscriptionBoxLocaleConnection"],
	validateCreateSubscriptionBoxLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateSubscriptionBoxLocale: GraphQLTypes["_ValidationResult"],
	getTimetableDayMetadata?: GraphQLTypes["TimetableDayMetadata"] | undefined,
	listTimetableDayMetadata: Array<GraphQLTypes["TimetableDayMetadata"]>,
	paginateTimetableDayMetadata: GraphQLTypes["TimetableDayMetadataConnection"],
	getBusinessService?: GraphQLTypes["BusinessService"] | undefined,
	listBusinessService: Array<GraphQLTypes["BusinessService"]>,
	paginateBusinessService: GraphQLTypes["BusinessServiceConnection"],
	validateCreateBusinessService: GraphQLTypes["_ValidationResult"],
	validateUpdateBusinessService: GraphQLTypes["_ValidationResult"],
	getBusinessServiceEvent?: GraphQLTypes["BusinessServiceEvent"] | undefined,
	listBusinessServiceEvent: Array<GraphQLTypes["BusinessServiceEvent"]>,
	paginateBusinessServiceEvent: GraphQLTypes["BusinessServiceEventConnection"],
	validateCreateBusinessServiceEvent: GraphQLTypes["_ValidationResult"],
	validateUpdateBusinessServiceEvent: GraphQLTypes["_ValidationResult"],
	getBusinessServiceLocale?: GraphQLTypes["BusinessServiceLocale"] | undefined,
	listBusinessServiceLocale: Array<GraphQLTypes["BusinessServiceLocale"]>,
	paginateBusinessServiceLocale: GraphQLTypes["BusinessServiceLocaleConnection"],
	validateCreateBusinessServiceLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateBusinessServiceLocale: GraphQLTypes["_ValidationResult"],
	getGridTileItem?: GraphQLTypes["GridTileItem"] | undefined,
	listGridTileItem: Array<GraphQLTypes["GridTileItem"]>,
	paginateGridTileItem: GraphQLTypes["GridTileItemConnection"],
	validateCreateGridTileItem: GraphQLTypes["_ValidationResult"],
	validateUpdateGridTileItem: GraphQLTypes["_ValidationResult"],
	getGridTiles?: GraphQLTypes["GridTiles"] | undefined,
	listGridTiles: Array<GraphQLTypes["GridTiles"]>,
	paginateGridTiles: GraphQLTypes["GridTilesConnection"],
	validateCreateGridTiles: GraphQLTypes["_ValidationResult"],
	validateUpdateGridTiles: GraphQLTypes["_ValidationResult"],
	getArea?: GraphQLTypes["Area"] | undefined,
	listArea: Array<GraphQLTypes["Area"]>,
	paginateArea: GraphQLTypes["AreaConnection"],
	validateCreateArea: GraphQLTypes["_ValidationResult"],
	validateUpdateArea: GraphQLTypes["_ValidationResult"],
	getPosition?: GraphQLTypes["Position"] | undefined,
	listPosition: Array<GraphQLTypes["Position"]>,
	paginatePosition: GraphQLTypes["PositionConnection"],
	validateCreatePosition: GraphQLTypes["_ValidationResult"],
	validateUpdatePosition: GraphQLTypes["_ValidationResult"],
	getStatsEnabledWidgetType?: GraphQLTypes["StatsEnabledWidgetType"] | undefined,
	listStatsEnabledWidgetType: Array<GraphQLTypes["StatsEnabledWidgetType"]>,
	paginateStatsEnabledWidgetType: GraphQLTypes["StatsEnabledWidgetTypeConnection"],
	validateCreateStatsEnabledWidgetType: GraphQLTypes["_ValidationResult"],
	validateUpdateStatsEnabledWidgetType: GraphQLTypes["_ValidationResult"],
	getStatsWidget?: GraphQLTypes["StatsWidget"] | undefined,
	listStatsWidget: Array<GraphQLTypes["StatsWidget"]>,
	paginateStatsWidget: GraphQLTypes["StatsWidgetConnection"],
	validateCreateStatsWidget: GraphQLTypes["_ValidationResult"],
	validateUpdateStatsWidget: GraphQLTypes["_ValidationResult"],
	getStatsWidgetsLayout?: GraphQLTypes["StatsWidgetsLayout"] | undefined,
	listStatsWidgetsLayout: Array<GraphQLTypes["StatsWidgetsLayout"]>,
	paginateStatsWidgetsLayout: GraphQLTypes["StatsWidgetsLayoutConnection"],
	validateCreateStatsWidgetsLayout: GraphQLTypes["_ValidationResult"],
	validateUpdateStatsWidgetsLayout: GraphQLTypes["_ValidationResult"],
	getSeat?: GraphQLTypes["Seat"] | undefined,
	listSeat: Array<GraphQLTypes["Seat"]>,
	paginateSeat: GraphQLTypes["SeatConnection"],
	validateCreateSeat: GraphQLTypes["_ValidationResult"],
	validateUpdateSeat: GraphQLTypes["_ValidationResult"],
	getTable?: GraphQLTypes["Table"] | undefined,
	listTable: Array<GraphQLTypes["Table"]>,
	paginateTable: GraphQLTypes["TableConnection"],
	validateCreateTable: GraphQLTypes["_ValidationResult"],
	validateUpdateTable: GraphQLTypes["_ValidationResult"],
	getStatsPage?: GraphQLTypes["StatsPage"] | undefined,
	listStatsPage: Array<GraphQLTypes["StatsPage"]>,
	paginateStatsPage: GraphQLTypes["StatsPageConnection"],
	validateCreateStatsPage: GraphQLTypes["_ValidationResult"],
	validateUpdateStatsPage: GraphQLTypes["_ValidationResult"],
	getUnassignReason?: GraphQLTypes["UnassignReason"] | undefined,
	listUnassignReason: Array<GraphQLTypes["UnassignReason"]>,
	paginateUnassignReason: GraphQLTypes["UnassignReasonConnection"],
	validateCreateUnassignReason: GraphQLTypes["_ValidationResult"],
	validateUpdateUnassignReason: GraphQLTypes["_ValidationResult"],
	getDoubleshotCoffeeEquipment?: GraphQLTypes["DoubleshotCoffeeEquipment"] | undefined,
	listDoubleshotCoffeeEquipment: Array<GraphQLTypes["DoubleshotCoffeeEquipment"]>,
	paginateDoubleshotCoffeeEquipment: GraphQLTypes["DoubleshotCoffeeEquipmentConnection"],
	validateCreateDoubleshotCoffeeEquipment: GraphQLTypes["_ValidationResult"],
	validateUpdateDoubleshotCoffeeEquipment: GraphQLTypes["_ValidationResult"],
	getExpense?: GraphQLTypes["Expense"] | undefined,
	listExpense: Array<GraphQLTypes["Expense"]>,
	paginateExpense: GraphQLTypes["ExpenseConnection"],
	validateCreateExpense: GraphQLTypes["_ValidationResult"],
	validateUpdateExpense: GraphQLTypes["_ValidationResult"],
	getExpenseCategory?: GraphQLTypes["ExpenseCategory"] | undefined,
	listExpenseCategory: Array<GraphQLTypes["ExpenseCategory"]>,
	paginateExpenseCategory: GraphQLTypes["ExpenseCategoryConnection"],
	validateCreateExpenseCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateExpenseCategory: GraphQLTypes["_ValidationResult"],
	getExpenseChange?: GraphQLTypes["ExpenseChange"] | undefined,
	listExpenseChange: Array<GraphQLTypes["ExpenseChange"]>,
	paginateExpenseChange: GraphQLTypes["ExpenseChangeConnection"],
	validateCreateExpenseChange: GraphQLTypes["_ValidationResult"],
	validateUpdateExpenseChange: GraphQLTypes["_ValidationResult"],
	getExpenseDocument?: GraphQLTypes["ExpenseDocument"] | undefined,
	listExpenseDocument: Array<GraphQLTypes["ExpenseDocument"]>,
	paginateExpenseDocument: GraphQLTypes["ExpenseDocumentConnection"],
	validateCreateExpenseDocument: GraphQLTypes["_ValidationResult"],
	validateUpdateExpenseDocument: GraphQLTypes["_ValidationResult"],
	getRevenuePrediction?: GraphQLTypes["RevenuePrediction"] | undefined,
	listRevenuePrediction: Array<GraphQLTypes["RevenuePrediction"]>,
	paginateRevenuePrediction: GraphQLTypes["RevenuePredictionConnection"],
	validateCreateRevenuePrediction: GraphQLTypes["_ValidationResult"],
	validateUpdateRevenuePrediction: GraphQLTypes["_ValidationResult"],
	getRevenuePredictionChange?: GraphQLTypes["RevenuePredictionChange"] | undefined,
	listRevenuePredictionChange: Array<GraphQLTypes["RevenuePredictionChange"]>,
	paginateRevenuePredictionChange: GraphQLTypes["RevenuePredictionChangeConnection"],
	validateCreateRevenuePredictionChange: GraphQLTypes["_ValidationResult"],
	validateUpdateRevenuePredictionChange: GraphQLTypes["_ValidationResult"],
	getFile?: GraphQLTypes["File"] | undefined,
	listFile: Array<GraphQLTypes["File"]>,
	paginateFile: GraphQLTypes["FileConnection"],
	validateCreateFile: GraphQLTypes["_ValidationResult"],
	validateUpdateFile: GraphQLTypes["_ValidationResult"],
	getExpenseTerm?: GraphQLTypes["ExpenseTerm"] | undefined,
	listExpenseTerm: Array<GraphQLTypes["ExpenseTerm"]>,
	paginateExpenseTerm: GraphQLTypes["ExpenseTermConnection"],
	getLine?: GraphQLTypes["Line"] | undefined,
	listLine: Array<GraphQLTypes["Line"]>,
	paginateLine: GraphQLTypes["LineConnection"],
	validateCreateLine: GraphQLTypes["_ValidationResult"],
	validateUpdateLine: GraphQLTypes["_ValidationResult"],
	getFinancesBalanceItem?: GraphQLTypes["FinancesBalanceItem"] | undefined,
	listFinancesBalanceItem: Array<GraphQLTypes["FinancesBalanceItem"]>,
	paginateFinancesBalanceItem: GraphQLTypes["FinancesBalanceItemConnection"],
	validateCreateFinancesBalanceItem: GraphQLTypes["_ValidationResult"],
	validateUpdateFinancesBalanceItem: GraphQLTypes["_ValidationResult"],
	getRevenuePredictionTerm?: GraphQLTypes["RevenuePredictionTerm"] | undefined,
	listRevenuePredictionTerm: Array<GraphQLTypes["RevenuePredictionTerm"]>,
	paginateRevenuePredictionTerm: GraphQLTypes["RevenuePredictionTermConnection"],
	getOrderPaymentStatsByDay?: GraphQLTypes["OrderPaymentStatsByDay"] | undefined,
	listOrderPaymentStatsByDay: Array<GraphQLTypes["OrderPaymentStatsByDay"]>,
	paginateOrderPaymentStatsByDay: GraphQLTypes["OrderPaymentStatsByDayConnection"],
	getWoltDriveDelivery?: GraphQLTypes["WoltDriveDelivery"] | undefined,
	listWoltDriveDelivery: Array<GraphQLTypes["WoltDriveDelivery"]>,
	paginateWoltDriveDelivery: GraphQLTypes["WoltDriveDeliveryConnection"],
	validateCreateWoltDriveDelivery: GraphQLTypes["_ValidationResult"],
	validateUpdateWoltDriveDelivery: GraphQLTypes["_ValidationResult"],
	transaction?: GraphQLTypes["QueryTransaction"] | undefined,
	_info?: GraphQLTypes["Info"] | undefined,
	schema?: GraphQLTypes["_Schema"] | undefined,
	s3DummyQuery?: string | undefined
};
	["Address"]: {
		_meta?: GraphQLTypes["AddressMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name?: string | undefined,
	firstName?: string | undefined,
	lastName?: string | undefined,
	addressLine2?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	companyName?: string | undefined,
	companyIdentifier?: string | undefined,
	vatIdentifier?: string | undefined,
	externalIdentifier?: string | undefined,
	hidden: boolean,
	customer?: GraphQLTypes["Customer"] | undefined,
	internalNote?: string | undefined,
	country?: GraphQLTypes["Country"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	googlePlaceId?: string | undefined,
	raw?: string | undefined,
	formatted?: string | undefined,
	geocodeGeneratedAt?: GraphQLTypes["DateTime"] | undefined,
	geocodeResponse?: string | undefined,
	deliveryZone?: GraphQLTypes["DeliveryZone"] | undefined,
	meta?: GraphQLTypes["AddressMetadata"] | undefined,
	gps?: GraphQLTypes["Gps"] | undefined,
	geocodeValid?: boolean | undefined,
	fullName?: string | undefined,
	fakturoidSubjectId?: string | undefined,
	invoices: Array<GraphQLTypes["Invoice"]>,
	addressLine1?: string | undefined,
	city?: string | undefined,
	postalCode?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddressOfOrders: Array<GraphQLTypes["Order"]>,
	deliveryAddressOfOrderDeliveries: Array<GraphQLTypes["OrderDelivery"]>,
	defaultDeliveryAddressOfCustomer?: GraphQLTypes["Customer"] | undefined,
	invoicesByPublicKey?: GraphQLTypes["Invoice"] | undefined,
	invoicesByFakturoidId?: GraphQLTypes["Invoice"] | undefined,
	invoicesByOrderPayments?: GraphQLTypes["Invoice"] | undefined,
	billingAddressOfOrdersBySeq?: GraphQLTypes["Order"] | undefined,
	billingAddressOfOrdersByDoubleshotLegacyId?: GraphQLTypes["Order"] | undefined,
	billingAddressOfOrdersByDoubleShotLegacyNumber?: GraphQLTypes["Order"] | undefined,
	billingAddressOfOrdersByDiscounts?: GraphQLTypes["Order"] | undefined,
	billingAddressOfOrdersByDelivery?: GraphQLTypes["Order"] | undefined,
	billingAddressOfOrdersByItems?: GraphQLTypes["Order"] | undefined,
	billingAddressOfOrdersByCart?: GraphQLTypes["Order"] | undefined,
	billingAddressOfOrdersByEvents?: GraphQLTypes["Order"] | undefined,
	billingAddressOfOrdersByPriceLines?: GraphQLTypes["Order"] | undefined,
	billingAddressOfOrdersByPayments?: GraphQLTypes["Order"] | undefined,
	billingAddressOfOrdersBySummary?: GraphQLTypes["Order"] | undefined,
	billingAddressOfOrdersByGratuity?: GraphQLTypes["Order"] | undefined,
	deliveryAddressOfOrderDeliveriesByTrackingCode?: GraphQLTypes["OrderDelivery"] | undefined,
	deliveryAddressOfOrderDeliveriesByOrder?: GraphQLTypes["OrderDelivery"] | undefined,
	deliveryAddressOfOrderDeliveriesByDeliveryWaypoint?: GraphQLTypes["OrderDelivery"] | undefined,
	deliveryAddressOfOrderDeliveriesByEvents?: GraphQLTypes["OrderDelivery"] | undefined,
	deliveryAddressOfOrderDeliveriesByLiftagoRide?: GraphQLTypes["OrderDelivery"] | undefined,
	deliveryAddressOfOrderDeliveriesByWoltDriveDelivery?: GraphQLTypes["OrderDelivery"] | undefined,
	paginateInvoices: GraphQLTypes["InvoiceConnection"],
	paginateBillingAddressOfOrders: GraphQLTypes["OrderConnection"],
	paginateDeliveryAddressOfOrderDeliveries: GraphQLTypes["OrderDeliveryConnection"]
};
	["AddressMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	firstName?: GraphQLTypes["FieldMeta"] | undefined,
	lastName?: GraphQLTypes["FieldMeta"] | undefined,
	addressLine2?: GraphQLTypes["FieldMeta"] | undefined,
	email?: GraphQLTypes["FieldMeta"] | undefined,
	phone?: GraphQLTypes["FieldMeta"] | undefined,
	companyName?: GraphQLTypes["FieldMeta"] | undefined,
	companyIdentifier?: GraphQLTypes["FieldMeta"] | undefined,
	vatIdentifier?: GraphQLTypes["FieldMeta"] | undefined,
	externalIdentifier?: GraphQLTypes["FieldMeta"] | undefined,
	hidden?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	country?: GraphQLTypes["FieldMeta"] | undefined,
	deletedAt?: GraphQLTypes["FieldMeta"] | undefined,
	note?: GraphQLTypes["FieldMeta"] | undefined,
	googlePlaceId?: GraphQLTypes["FieldMeta"] | undefined,
	raw?: GraphQLTypes["FieldMeta"] | undefined,
	formatted?: GraphQLTypes["FieldMeta"] | undefined,
	geocodeGeneratedAt?: GraphQLTypes["FieldMeta"] | undefined,
	geocodeResponse?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryZone?: GraphQLTypes["FieldMeta"] | undefined,
	meta?: GraphQLTypes["FieldMeta"] | undefined,
	gps?: GraphQLTypes["FieldMeta"] | undefined,
	geocodeValid?: GraphQLTypes["FieldMeta"] | undefined,
	fullName?: GraphQLTypes["FieldMeta"] | undefined,
	fakturoidSubjectId?: GraphQLTypes["FieldMeta"] | undefined,
	invoices?: GraphQLTypes["FieldMeta"] | undefined,
	addressLine1?: GraphQLTypes["FieldMeta"] | undefined,
	city?: GraphQLTypes["FieldMeta"] | undefined,
	postalCode?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	billingAddressOfOrders?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryAddressOfOrderDeliveries?: GraphQLTypes["FieldMeta"] | undefined,
	defaultDeliveryAddressOfCustomer?: GraphQLTypes["FieldMeta"] | undefined
};
	["FieldMeta"]: {
		readable?: boolean | undefined,
	updatable?: boolean | undefined
};
	["UUID"]:string;
	["Customer"]: {
		_meta?: GraphQLTypes["CustomerMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	addresses: Array<GraphQLTypes["Address"]>,
	defaultBillingAddress?: GraphQLTypes["Address"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerPaymentMethod"] | undefined,
	tags: Array<GraphQLTypes["Tag"]>,
	credits: Array<GraphQLTypes["CustomerCredit"]>,
	paymentMethods: Array<GraphQLTypes["CustomerPaymentMethod"]>,
	orders: Array<GraphQLTypes["Order"]>,
	permissions?: GraphQLTypes["CustomerPermissions"] | undefined,
	group?: GraphQLTypes["CustomerGroup"] | undefined,
	photo?: GraphQLTypes["Image"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerName"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings: Array<GraphQLTypes["CustomerIngredientRating"]>,
	business?: GraphQLTypes["BusinessCustomer"] | undefined,
	ownerOfBusinesses: Array<GraphQLTypes["BusinessCustomer"]>,
	memberOfBusinesses: Array<GraphQLTypes["BusinessCustomer"]>,
	carts: Array<GraphQLTypes["Cart"]>,
	shortcutList?: GraphQLTypes["ApplicationShortcutList"] | undefined,
	user?: GraphQLTypes["User"] | undefined,
	channels: Array<GraphQLTypes["Channel"]>,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices: Array<GraphQLTypes["Invoice"]>,
	invoicingPlan?: GraphQLTypes["InvoicingPlan"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects: Array<GraphQLTypes["BillingSubject"]>,
	offeredProducts: Array<GraphQLTypes["ProductCustomerPrice"]>,
	defaultDeliveryAddress?: GraphQLTypes["Address"] | undefined,
	defaultBillingSubject?: GraphQLTypes["BillingSubject"] | undefined,
	prefersPackingsWithoutCardboard: boolean,
	anonymousSession?: GraphQLTypes["AnonymousSession"] | undefined,
	boughtVouchers: Array<GraphQLTypes["Voucher"]>,
	ownsVouchers: Array<GraphQLTypes["Voucher"]>,
	redeemedVouchers: Array<GraphQLTypes["VoucherRedemption"]>,
	spending?: GraphQLTypes["CustomerSpending"] | undefined,
	customerTabs: Array<GraphQLTypes["CustomerTab"]>,
	lead: Array<GraphQLTypes["PipelineLead"]>,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerMetadata"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	addressesByMeta?: GraphQLTypes["Address"] | undefined,
	addressesByGps?: GraphQLTypes["Address"] | undefined,
	addressesByInvoices?: GraphQLTypes["Address"] | undefined,
	addressesByBillingAddressOfOrders?: GraphQLTypes["Address"] | undefined,
	addressesByDeliveryAddressOfOrderDeliveries?: GraphQLTypes["Address"] | undefined,
	addressesByDefaultDeliveryAddressOfCustomer?: GraphQLTypes["Address"] | undefined,
	creditsByTransactions?: GraphQLTypes["CustomerCredit"] | undefined,
	creditsByVoucherRedemption?: GraphQLTypes["CustomerCredit"] | undefined,
	ordersBySeq?: GraphQLTypes["Order"] | undefined,
	ordersByDoubleshotLegacyId?: GraphQLTypes["Order"] | undefined,
	ordersByDoubleShotLegacyNumber?: GraphQLTypes["Order"] | undefined,
	ordersByDiscounts?: GraphQLTypes["Order"] | undefined,
	ordersByDelivery?: GraphQLTypes["Order"] | undefined,
	ordersByItems?: GraphQLTypes["Order"] | undefined,
	ordersByCart?: GraphQLTypes["Order"] | undefined,
	ordersByEvents?: GraphQLTypes["Order"] | undefined,
	ordersByPriceLines?: GraphQLTypes["Order"] | undefined,
	ordersByPayments?: GraphQLTypes["Order"] | undefined,
	ordersBySummary?: GraphQLTypes["Order"] | undefined,
	ordersByGratuity?: GraphQLTypes["Order"] | undefined,
	ingredientRatingsByIngredient?: GraphQLTypes["CustomerIngredientRating"] | undefined,
	cartsByItems?: GraphQLTypes["Cart"] | undefined,
	cartsByOrder?: GraphQLTypes["Cart"] | undefined,
	cartsByPriceLines?: GraphQLTypes["Cart"] | undefined,
	cartsBySummary?: GraphQLTypes["Cart"] | undefined,
	invoicesByPublicKey?: GraphQLTypes["Invoice"] | undefined,
	invoicesByFakturoidId?: GraphQLTypes["Invoice"] | undefined,
	invoicesByOrderPayments?: GraphQLTypes["Invoice"] | undefined,
	billingSubjectsByInvoices?: GraphQLTypes["BillingSubject"] | undefined,
	billingSubjectsByDefaultBillingSubjectOfCustomer?: GraphQLTypes["BillingSubject"] | undefined,
	billingSubjectsByOrders?: GraphQLTypes["BillingSubject"] | undefined,
	offeredProductsByProduct?: GraphQLTypes["ProductCustomerPrice"] | undefined,
	boughtVouchersByCode?: GraphQLTypes["Voucher"] | undefined,
	boughtVouchersByRedemption?: GraphQLTypes["Voucher"] | undefined,
	ownsVouchersByCode?: GraphQLTypes["Voucher"] | undefined,
	ownsVouchersByRedemption?: GraphQLTypes["Voucher"] | undefined,
	redeemedVouchersByCustomerCredit?: GraphQLTypes["VoucherRedemption"] | undefined,
	redeemedVouchersByOrderDiscount?: GraphQLTypes["VoucherRedemption"] | undefined,
	redeemedVouchersByVoucher?: GraphQLTypes["VoucherRedemption"] | undefined,
	customerTabsByItems?: GraphQLTypes["CustomerTab"] | undefined,
	customerTabsByMeta?: GraphQLTypes["CustomerTab"] | undefined,
	leadByStageItem?: GraphQLTypes["PipelineLead"] | undefined,
	paginateAddresses: GraphQLTypes["AddressConnection"],
	paginateTags: GraphQLTypes["TagConnection"],
	paginateCredits: GraphQLTypes["CustomerCreditConnection"],
	paginatePaymentMethods: GraphQLTypes["CustomerPaymentMethodConnection"],
	paginateOrders: GraphQLTypes["OrderConnection"],
	paginateIngredientRatings: GraphQLTypes["CustomerIngredientRatingConnection"],
	paginateOwnerOfBusinesses: GraphQLTypes["BusinessCustomerConnection"],
	paginateMemberOfBusinesses: GraphQLTypes["BusinessCustomerConnection"],
	paginateCarts: GraphQLTypes["CartConnection"],
	paginateChannels: GraphQLTypes["ChannelConnection"],
	paginateInvoices: GraphQLTypes["InvoiceConnection"],
	paginateBillingSubjects: GraphQLTypes["BillingSubjectConnection"],
	paginateOfferedProducts: GraphQLTypes["ProductCustomerPriceConnection"],
	paginateBoughtVouchers: GraphQLTypes["VoucherConnection"],
	paginateOwnsVouchers: GraphQLTypes["VoucherConnection"],
	paginateRedeemedVouchers: GraphQLTypes["VoucherRedemptionConnection"],
	paginateCustomerTabs: GraphQLTypes["CustomerTabConnection"],
	paginateLead: GraphQLTypes["PipelineLeadConnection"]
};
	["CustomerMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	addresses?: GraphQLTypes["FieldMeta"] | undefined,
	defaultBillingAddress?: GraphQLTypes["FieldMeta"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["FieldMeta"] | undefined,
	tags?: GraphQLTypes["FieldMeta"] | undefined,
	credits?: GraphQLTypes["FieldMeta"] | undefined,
	paymentMethods?: GraphQLTypes["FieldMeta"] | undefined,
	orders?: GraphQLTypes["FieldMeta"] | undefined,
	permissions?: GraphQLTypes["FieldMeta"] | undefined,
	group?: GraphQLTypes["FieldMeta"] | undefined,
	photo?: GraphQLTypes["FieldMeta"] | undefined,
	phone?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	welcomeMessage?: GraphQLTypes["FieldMeta"] | undefined,
	familiarity?: GraphQLTypes["FieldMeta"] | undefined,
	ingredientRatings?: GraphQLTypes["FieldMeta"] | undefined,
	business?: GraphQLTypes["FieldMeta"] | undefined,
	ownerOfBusinesses?: GraphQLTypes["FieldMeta"] | undefined,
	memberOfBusinesses?: GraphQLTypes["FieldMeta"] | undefined,
	carts?: GraphQLTypes["FieldMeta"] | undefined,
	shortcutList?: GraphQLTypes["FieldMeta"] | undefined,
	user?: GraphQLTypes["FieldMeta"] | undefined,
	channels?: GraphQLTypes["FieldMeta"] | undefined,
	disabledAt?: GraphQLTypes["FieldMeta"] | undefined,
	invoices?: GraphQLTypes["FieldMeta"] | undefined,
	invoicingPlan?: GraphQLTypes["FieldMeta"] | undefined,
	email?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	billingSubjects?: GraphQLTypes["FieldMeta"] | undefined,
	offeredProducts?: GraphQLTypes["FieldMeta"] | undefined,
	defaultDeliveryAddress?: GraphQLTypes["FieldMeta"] | undefined,
	defaultBillingSubject?: GraphQLTypes["FieldMeta"] | undefined,
	prefersPackingsWithoutCardboard?: GraphQLTypes["FieldMeta"] | undefined,
	anonymousSession?: GraphQLTypes["FieldMeta"] | undefined,
	boughtVouchers?: GraphQLTypes["FieldMeta"] | undefined,
	ownsVouchers?: GraphQLTypes["FieldMeta"] | undefined,
	redeemedVouchers?: GraphQLTypes["FieldMeta"] | undefined,
	spending?: GraphQLTypes["FieldMeta"] | undefined,
	customerTabs?: GraphQLTypes["FieldMeta"] | undefined,
	lead?: GraphQLTypes["FieldMeta"] | undefined,
	doubleshotLegacyId?: GraphQLTypes["FieldMeta"] | undefined,
	meta?: GraphQLTypes["FieldMeta"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["FieldMeta"] | undefined
};
	["AddressWhere"]: GraphQLTypes["AddressWhere"];
	["UUIDCondition"]: GraphQLTypes["UUIDCondition"];
	["StringCondition"]: GraphQLTypes["StringCondition"];
	["BooleanCondition"]: GraphQLTypes["BooleanCondition"];
	["CustomerWhere"]: GraphQLTypes["CustomerWhere"];
	["CustomerPaymentMethodWhere"]: GraphQLTypes["CustomerPaymentMethodWhere"];
	["JsonCondition"]: GraphQLTypes["JsonCondition"];
	["PaymentMethodWhere"]: GraphQLTypes["PaymentMethodWhere"];
	["DeliveryMethodWhere"]: GraphQLTypes["DeliveryMethodWhere"];
	["DeliveryZoneWhere"]: GraphQLTypes["DeliveryZoneWhere"];
	["DeliveryZoneTypeCondition"]: GraphQLTypes["DeliveryZoneTypeCondition"];
	["DeliveryZoneType"]: GraphQLTypes["DeliveryZoneType"];
	["TagWhere"]: GraphQLTypes["TagWhere"];
	["ProductWhere"]: GraphQLTypes["ProductWhere"];
	["IntCondition"]: GraphQLTypes["IntCondition"];
	["ProductPackingWhere"]: GraphQLTypes["ProductPackingWhere"];
	["ImageWhere"]: GraphQLTypes["ImageWhere"];
	["ProductPackingLocaleWhere"]: GraphQLTypes["ProductPackingLocaleWhere"];
	["LocaleWhere"]: GraphQLTypes["LocaleWhere"];
	["BusinessCategoryLocaleWhere"]: GraphQLTypes["BusinessCategoryLocaleWhere"];
	["BusinessCategoryWhere"]: GraphQLTypes["BusinessCategoryWhere"];
	["BusinessCustomerWhere"]: GraphQLTypes["BusinessCustomerWhere"];
	["BusinessToBusinessManagerWhere"]: GraphQLTypes["BusinessToBusinessManagerWhere"];
	["StaffWhere"]: GraphQLTypes["StaffWhere"];
	["BartenderWhere"]: GraphQLTypes["BartenderWhere"];
	["DateTimeCondition"]: GraphQLTypes["DateTimeCondition"];
	["DateTime"]:string;
	["CourierWhere"]: GraphQLTypes["CourierWhere"];
	["DeliveryRouteWhere"]: GraphQLTypes["DeliveryRouteWhere"];
	["DeliveryWaypointWhere"]: GraphQLTypes["DeliveryWaypointWhere"];
	["OrderDeliveryWhere"]: GraphQLTypes["OrderDeliveryWhere"];
	["VatRateWhere"]: GraphQLTypes["VatRateWhere"];
	["ChannelDeliveryWhere"]: GraphQLTypes["ChannelDeliveryWhere"];
	["ChannelWhere"]: GraphQLTypes["ChannelWhere"];
	["ChannelPaymentWhere"]: GraphQLTypes["ChannelPaymentWhere"];
	["PointOfSaleWhere"]: GraphQLTypes["PointOfSaleWhere"];
	["PointOfSalePermissionsWhere"]: GraphQLTypes["PointOfSalePermissionsWhere"];
	["CartWhere"]: GraphQLTypes["CartWhere"];
	["CartItemWhere"]: GraphQLTypes["CartItemWhere"];
	["FulfillmentNoteWhere"]: GraphQLTypes["FulfillmentNoteWhere"];
	["VenueWhere"]: GraphQLTypes["VenueWhere"];
	["DeadlineTemplateWhere"]: GraphQLTypes["DeadlineTemplateWhere"];
	["DateCondition"]: GraphQLTypes["DateCondition"];
	["Date"]:any;
	["TimetableDayWhere"]: GraphQLTypes["TimetableDayWhere"];
	["TimetableDayTypeCondition"]: GraphQLTypes["TimetableDayTypeCondition"];
	["TimetableDayType"]: GraphQLTypes["TimetableDayType"];
	["TimetableShiftGroupWhere"]: GraphQLTypes["TimetableShiftGroupWhere"];
	["TimetableShiftWhere"]: GraphQLTypes["TimetableShiftWhere"];
	["ShiftsProfileWhere"]: GraphQLTypes["ShiftsProfileWhere"];
	["EmployeeQueueItemWhere"]: GraphQLTypes["EmployeeQueueItemWhere"];
	["EmployeeQueueWhere"]: GraphQLTypes["EmployeeQueueWhere"];
	["UnassignedShiftInfoWhere"]: GraphQLTypes["UnassignedShiftInfoWhere"];
	["UnassignedInfoReasonCondition"]: GraphQLTypes["UnassignedInfoReasonCondition"];
	["UnassignedInfoReason"]: GraphQLTypes["UnassignedInfoReason"];
	["UnassignReasonWhere"]: GraphQLTypes["UnassignReasonWhere"];
	["EmployeeQueueItemMetadataWhere"]: GraphQLTypes["EmployeeQueueItemMetadataWhere"];
	["TimetableEmployeeRoleWhere"]: GraphQLTypes["TimetableEmployeeRoleWhere"];
	["ShiftsManagerWhere"]: GraphQLTypes["ShiftsManagerWhere"];
	["TimetableTemplateWhere"]: GraphQLTypes["TimetableTemplateWhere"];
	["TimetableShiftPositionWhere"]: GraphQLTypes["TimetableShiftPositionWhere"];
	["TimetableTemplateStaffOptionsWhere"]: GraphQLTypes["TimetableTemplateStaffOptionsWhere"];
	["TemplateTypeCondition"]: GraphQLTypes["TemplateTypeCondition"];
	["TemplateType"]: GraphQLTypes["TemplateType"];
	["TimetableShiftSwapInfoWhere"]: GraphQLTypes["TimetableShiftSwapInfoWhere"];
	["TimetableDayNoteWhere"]: GraphQLTypes["TimetableDayNoteWhere"];
	["TimetableDayMetadataWhere"]: GraphQLTypes["TimetableDayMetadataWhere"];
	["FloatCondition"]: GraphQLTypes["FloatCondition"];
	["VenueEmployeeRoleWhere"]: GraphQLTypes["VenueEmployeeRoleWhere"];
	["TimetablesEmployeePrivilegesWhere"]: GraphQLTypes["TimetablesEmployeePrivilegesWhere"];
	["PointOfSaleApplicationDeviceWhere"]: GraphQLTypes["PointOfSaleApplicationDeviceWhere"];
	["IdentificationCodeWhere"]: GraphQLTypes["IdentificationCodeWhere"];
	["IdentificationAttemptWhere"]: GraphQLTypes["IdentificationAttemptWhere"];
	["UserWhere"]: GraphQLTypes["UserWhere"];
	["UserDeviceWhere"]: GraphQLTypes["UserDeviceWhere"];
	["AnonymousSessionWhere"]: GraphQLTypes["AnonymousSessionWhere"];
	["UserMetadataWhere"]: GraphQLTypes["UserMetadataWhere"];
	["UserRolesWhere"]: GraphQLTypes["UserRolesWhere"];
	["IdentificationCodeLocaleWhere"]: GraphQLTypes["IdentificationCodeLocaleWhere"];
	["DeviceIdentifierWhere"]: GraphQLTypes["DeviceIdentifierWhere"];
	["DeviceIdentifierMetadataWhere"]: GraphQLTypes["DeviceIdentifierMetadataWhere"];
	["PointOfSaleTerminalWhere"]: GraphQLTypes["PointOfSaleTerminalWhere"];
	["PointOfSaleTerminalTypeCondition"]: GraphQLTypes["PointOfSaleTerminalTypeCondition"];
	["PointOfSaleTerminalType"]: GraphQLTypes["PointOfSaleTerminalType"];
	["PointOfSalePrinterWhere"]: GraphQLTypes["PointOfSalePrinterWhere"];
	["PointOfSaleCategoryWhere"]: GraphQLTypes["PointOfSaleCategoryWhere"];
	["PointOfSaleCategoryLocaleWhere"]: GraphQLTypes["PointOfSaleCategoryLocaleWhere"];
	["PointOfSaleCategoryProductWhere"]: GraphQLTypes["PointOfSaleCategoryProductWhere"];
	["PointOfSaleCategoryProductLocaleWhere"]: GraphQLTypes["PointOfSaleCategoryProductLocaleWhere"];
	["ProductCategoryWhere"]: GraphQLTypes["ProductCategoryWhere"];
	["ProductCategoryTreeWhere"]: GraphQLTypes["ProductCategoryTreeWhere"];
	["InheritedProductCategoryTagWhere"]: GraphQLTypes["InheritedProductCategoryTagWhere"];
	["NestedProductCategoryProductWhere"]: GraphQLTypes["NestedProductCategoryProductWhere"];
	["OrderWhere"]: GraphQLTypes["OrderWhere"];
	["OrderStateCondition"]: GraphQLTypes["OrderStateCondition"];
	["OrderState"]: GraphQLTypes["OrderState"];
	["OrderDiscountWhere"]: GraphQLTypes["OrderDiscountWhere"];
	["OrderDiscountTypeCondition"]: GraphQLTypes["OrderDiscountTypeCondition"];
	["OrderDiscountType"]: GraphQLTypes["OrderDiscountType"];
	["CustomerCreditTransactionWhere"]: GraphQLTypes["CustomerCreditTransactionWhere"];
	["CustomerCreditWhere"]: GraphQLTypes["CustomerCreditWhere"];
	["VoucherRedemptionWhere"]: GraphQLTypes["VoucherRedemptionWhere"];
	["VoucherWhere"]: GraphQLTypes["VoucherWhere"];
	["VoucherTypeCondition"]: GraphQLTypes["VoucherTypeCondition"];
	["VoucherType"]: GraphQLTypes["VoucherType"];
	["VirtualProductEffectWhere"]: GraphQLTypes["VirtualProductEffectWhere"];
	["OrderItemWhere"]: GraphQLTypes["OrderItemWhere"];
	["OrderEventWhere"]: GraphQLTypes["OrderEventWhere"];
	["OrderPaymentWhere"]: GraphQLTypes["OrderPaymentWhere"];
	["OrderPaymentStateCondition"]: GraphQLTypes["OrderPaymentStateCondition"];
	["OrderPaymentState"]: GraphQLTypes["OrderPaymentState"];
	["InvoiceWhere"]: GraphQLTypes["InvoiceWhere"];
	["BillingSubjectWhere"]: GraphQLTypes["BillingSubjectWhere"];
	["CountryWhere"]: GraphQLTypes["CountryWhere"];
	["OrderPaymentMetadataWhere"]: GraphQLTypes["OrderPaymentMetadataWhere"];
	["OrderPriceLineWhere"]: GraphQLTypes["OrderPriceLineWhere"];
	["OrderPriceLineTypeCondition"]: GraphQLTypes["OrderPriceLineTypeCondition"];
	["OrderPriceLineType"]: GraphQLTypes["OrderPriceLineType"];
	["OrderSummaryWhere"]: GraphQLTypes["OrderSummaryWhere"];
	["GratuityWhere"]: GraphQLTypes["GratuityWhere"];
	["AreaWhere"]: GraphQLTypes["AreaWhere"];
	["TableWhere"]: GraphQLTypes["TableWhere"];
	["TableShapeCondition"]: GraphQLTypes["TableShapeCondition"];
	["TableShape"]: GraphQLTypes["TableShape"];
	["CustomerTabWhere"]: GraphQLTypes["CustomerTabWhere"];
	["CustomerTabItemWhere"]: GraphQLTypes["CustomerTabItemWhere"];
	["CustomerTabMetadataWhere"]: GraphQLTypes["CustomerTabMetadataWhere"];
	["SeatWhere"]: GraphQLTypes["SeatWhere"];
	["LineWhere"]: GraphQLTypes["LineWhere"];
	["PointOfSaleInitialViewCondition"]: GraphQLTypes["PointOfSaleInitialViewCondition"];
	["PointOfSaleInitialView"]: GraphQLTypes["PointOfSaleInitialView"];
	["CartStateCondition"]: GraphQLTypes["CartStateCondition"];
	["CartState"]: GraphQLTypes["CartState"];
	["CartPriceLineWhere"]: GraphQLTypes["CartPriceLineWhere"];
	["CartPriceLineTypeCondition"]: GraphQLTypes["CartPriceLineTypeCondition"];
	["CartPriceLineType"]: GraphQLTypes["CartPriceLineType"];
	["CartSummaryWhere"]: GraphQLTypes["CartSummaryWhere"];
	["ChannelCodeCondition"]: GraphQLTypes["ChannelCodeCondition"];
	["ChannelCode"]: GraphQLTypes["ChannelCode"];
	["VatRatePresetCondition"]: GraphQLTypes["VatRatePresetCondition"];
	["VatRatePreset"]: GraphQLTypes["VatRatePreset"];
	["OrderDeliveryStateCondition"]: GraphQLTypes["OrderDeliveryStateCondition"];
	["OrderDeliveryState"]: GraphQLTypes["OrderDeliveryState"];
	["LiftagoRideWhere"]: GraphQLTypes["LiftagoRideWhere"];
	["WoltDriveDeliveryWhere"]: GraphQLTypes["WoltDriveDeliveryWhere"];
	["WoltDriveDeliveryStateCondition"]: GraphQLTypes["WoltDriveDeliveryStateCondition"];
	["WoltDriveDeliveryState"]: GraphQLTypes["WoltDriveDeliveryState"];
	["CleanerWhere"]: GraphQLTypes["CleanerWhere"];
	["StocksManagerWhere"]: GraphQLTypes["StocksManagerWhere"];
	["CourierManagerWhere"]: GraphQLTypes["CourierManagerWhere"];
	["PickerWhere"]: GraphQLTypes["PickerWhere"];
	["RemunerationProfileWhere"]: GraphQLTypes["RemunerationProfileWhere"];
	["EmploymentInformationWhere"]: GraphQLTypes["EmploymentInformationWhere"];
	["EmploymentTypeCondition"]: GraphQLTypes["EmploymentTypeCondition"];
	["EmploymentType"]: GraphQLTypes["EmploymentType"];
	["WorkMonthWhere"]: GraphQLTypes["WorkMonthWhere"];
	["CashierWhere"]: GraphQLTypes["CashierWhere"];
	["InternalBuyerWhere"]: GraphQLTypes["InternalBuyerWhere"];
	["SalesManagerWhere"]: GraphQLTypes["SalesManagerWhere"];
	["CashierManagerWhere"]: GraphQLTypes["CashierManagerWhere"];
	["BusinessServiceEventWhere"]: GraphQLTypes["BusinessServiceEventWhere"];
	["BusinessServiceWhere"]: GraphQLTypes["BusinessServiceWhere"];
	["BusinessServiceLocaleWhere"]: GraphQLTypes["BusinessServiceLocaleWhere"];
	["DoubleshotCoffeeEquipmentWhere"]: GraphQLTypes["DoubleshotCoffeeEquipmentWhere"];
	["OrderRecurrenceWhere"]: GraphQLTypes["OrderRecurrenceWhere"];
	["OrderRecurrenceLocaleWhere"]: GraphQLTypes["OrderRecurrenceLocaleWhere"];
	["ProductListWhere"]: GraphQLTypes["ProductListWhere"];
	["ProductListItemWhere"]: GraphQLTypes["ProductListItemWhere"];
	["ProductCategoryListWhere"]: GraphQLTypes["ProductCategoryListWhere"];
	["ProductCategoryListItemWhere"]: GraphQLTypes["ProductCategoryListItemWhere"];
	["ProductCategoryListLocaleWhere"]: GraphQLTypes["ProductCategoryListLocaleWhere"];
	["ProductIngredientLocaleWhere"]: GraphQLTypes["ProductIngredientLocaleWhere"];
	["ProductIngredientWhere"]: GraphQLTypes["ProductIngredientWhere"];
	["ProductIngredientCategoryWhere"]: GraphQLTypes["ProductIngredientCategoryWhere"];
	["ProductIngredientCategoryLocaleWhere"]: GraphQLTypes["ProductIngredientCategoryLocaleWhere"];
	["AllergenWhere"]: GraphQLTypes["AllergenWhere"];
	["AllergenLocaleWhere"]: GraphQLTypes["AllergenLocaleWhere"];
	["CustomerIngredientRatingWhere"]: GraphQLTypes["CustomerIngredientRatingWhere"];
	["ProductIngredientRatingWhere"]: GraphQLTypes["ProductIngredientRatingWhere"];
	["ProductIngredientItemQuantityUnitWhere"]: GraphQLTypes["ProductIngredientItemQuantityUnitWhere"];
	["FreshingContainerWhere"]: GraphQLTypes["FreshingContainerWhere"];
	["WorkspaceWhere"]: GraphQLTypes["WorkspaceWhere"];
	["OneCondition"]: GraphQLTypes["OneCondition"];
	["One"]: GraphQLTypes["One"];
	["WeekHoursWhere"]: GraphQLTypes["WeekHoursWhere"];
	["VirtualProductWhere"]: GraphQLTypes["VirtualProductWhere"];
	["VirtualProductTypeCondition"]: GraphQLTypes["VirtualProductTypeCondition"];
	["VirtualProductType"]: GraphQLTypes["VirtualProductType"];
	["VirtualProductPhysicalRepresentationTypeCondition"]: GraphQLTypes["VirtualProductPhysicalRepresentationTypeCondition"];
	["VirtualProductPhysicalRepresentationType"]: GraphQLTypes["VirtualProductPhysicalRepresentationType"];
	["IngredientSupplierListWhere"]: GraphQLTypes["IngredientSupplierListWhere"];
	["IngredientSupplierItemWhere"]: GraphQLTypes["IngredientSupplierItemWhere"];
	["IngredientSupplierWhere"]: GraphQLTypes["IngredientSupplierWhere"];
	["IngredientSupplierLocaleWhere"]: GraphQLTypes["IngredientSupplierLocaleWhere"];
	["BlogLocaleWhere"]: GraphQLTypes["BlogLocaleWhere"];
	["BlogWhere"]: GraphQLTypes["BlogWhere"];
	["BlogPostLocaleWhere"]: GraphQLTypes["BlogPostLocaleWhere"];
	["BlogPostWhere"]: GraphQLTypes["BlogPostWhere"];
	["CoverWhere"]: GraphQLTypes["CoverWhere"];
	["MediumWhere"]: GraphQLTypes["MediumWhere"];
	["MediumTypeCondition"]: GraphQLTypes["MediumTypeCondition"];
	["MediumType"]: GraphQLTypes["MediumType"];
	["ColorThemeCondition"]: GraphQLTypes["ColorThemeCondition"];
	["ColorTheme"]: GraphQLTypes["ColorTheme"];
	["VideoWhere"]: GraphQLTypes["VideoWhere"];
	["ColorPalleteWhere"]: GraphQLTypes["ColorPalleteWhere"];
	["ContentWhere"]: GraphQLTypes["ContentWhere"];
	["ContentBlockWhere"]: GraphQLTypes["ContentBlockWhere"];
	["ContentReferenceWhere"]: GraphQLTypes["ContentReferenceWhere"];
	["ContentReferenceTypeCondition"]: GraphQLTypes["ContentReferenceTypeCondition"];
	["ContentReferenceType"]: GraphQLTypes["ContentReferenceType"];
	["LinkWhere"]: GraphQLTypes["LinkWhere"];
	["LinkTypeCondition"]: GraphQLTypes["LinkTypeCondition"];
	["LinkType"]: GraphQLTypes["LinkType"];
	["LinkableWhere"]: GraphQLTypes["LinkableWhere"];
	["PageLocaleWhere"]: GraphQLTypes["PageLocaleWhere"];
	["PageWhere"]: GraphQLTypes["PageWhere"];
	["SeoWhere"]: GraphQLTypes["SeoWhere"];
	["PageThemeCondition"]: GraphQLTypes["PageThemeCondition"];
	["PageTheme"]: GraphQLTypes["PageTheme"];
	["WikiPageWhere"]: GraphQLTypes["WikiPageWhere"];
	["RedirectWhere"]: GraphQLTypes["RedirectWhere"];
	["BlogPostListWhere"]: GraphQLTypes["BlogPostListWhere"];
	["BlogPostListItemWhere"]: GraphQLTypes["BlogPostListItemWhere"];
	["LinkListWhere"]: GraphQLTypes["LinkListWhere"];
	["LinkListItemWhere"]: GraphQLTypes["LinkListItemWhere"];
	["ContentSizeCondition"]: GraphQLTypes["ContentSizeCondition"];
	["ContentSize"]: GraphQLTypes["ContentSize"];
	["HeroWhere"]: GraphQLTypes["HeroWhere"];
	["GalleryWhere"]: GraphQLTypes["GalleryWhere"];
	["GalleryItemWhere"]: GraphQLTypes["GalleryItemWhere"];
	["SocialsAndAppsWhere"]: GraphQLTypes["SocialsAndAppsWhere"];
	["ProductGridWhere"]: GraphQLTypes["ProductGridWhere"];
	["ProductGridCategoryWhere"]: GraphQLTypes["ProductGridCategoryWhere"];
	["ProductGridItemWhere"]: GraphQLTypes["ProductGridItemWhere"];
	["ImageListWhere"]: GraphQLTypes["ImageListWhere"];
	["ImageListItemWhere"]: GraphQLTypes["ImageListItemWhere"];
	["ProductGridTypeCondition"]: GraphQLTypes["ProductGridTypeCondition"];
	["ProductGridType"]: GraphQLTypes["ProductGridType"];
	["ProductBannerListWhere"]: GraphQLTypes["ProductBannerListWhere"];
	["ProductBannerItemWhere"]: GraphQLTypes["ProductBannerItemWhere"];
	["ProductBannerWhere"]: GraphQLTypes["ProductBannerWhere"];
	["ProductBannerItemSizeCondition"]: GraphQLTypes["ProductBannerItemSizeCondition"];
	["ProductBannerItemSize"]: GraphQLTypes["ProductBannerItemSize"];
	["DeliveryRegionsWhere"]: GraphQLTypes["DeliveryRegionsWhere"];
	["DeliveryRegionsItemWhere"]: GraphQLTypes["DeliveryRegionsItemWhere"];
	["TextListWhere"]: GraphQLTypes["TextListWhere"];
	["TextItemWhere"]: GraphQLTypes["TextItemWhere"];
	["GridTilesWhere"]: GraphQLTypes["GridTilesWhere"];
	["GridTileItemWhere"]: GraphQLTypes["GridTileItemWhere"];
	["TranslationCataloguesIdentifierWhere"]: GraphQLTypes["TranslationCataloguesIdentifierWhere"];
	["TranslationCatalogueWhere"]: GraphQLTypes["TranslationCatalogueWhere"];
	["TranslationDomainWhere"]: GraphQLTypes["TranslationDomainWhere"];
	["TranslationKeyWhere"]: GraphQLTypes["TranslationKeyWhere"];
	["TranslationContentTypeCondition"]: GraphQLTypes["TranslationContentTypeCondition"];
	["TranslationContentType"]: GraphQLTypes["TranslationContentType"];
	["TranslationValueWhere"]: GraphQLTypes["TranslationValueWhere"];
	["MenuLocaleWhere"]: GraphQLTypes["MenuLocaleWhere"];
	["SiteMenuWhere"]: GraphQLTypes["SiteMenuWhere"];
	["MenuItemWhere"]: GraphQLTypes["MenuItemWhere"];
	["MenuSubitemWhere"]: GraphQLTypes["MenuSubitemWhere"];
	["MenuSubitemTypeCondition"]: GraphQLTypes["MenuSubitemTypeCondition"];
	["MenuSubitemType"]: GraphQLTypes["MenuSubitemType"];
	["MenuLinkListWhere"]: GraphQLTypes["MenuLinkListWhere"];
	["MenuLinkItemWhere"]: GraphQLTypes["MenuLinkItemWhere"];
	["MenuProductsWhere"]: GraphQLTypes["MenuProductsWhere"];
	["MenuDeliveryWhere"]: GraphQLTypes["MenuDeliveryWhere"];
	["MenuContactWhere"]: GraphQLTypes["MenuContactWhere"];
	["ProductLocaleWhere"]: GraphQLTypes["ProductLocaleWhere"];
	["ProductRecipeLocaleWhere"]: GraphQLTypes["ProductRecipeLocaleWhere"];
	["ProductRecipeWhere"]: GraphQLTypes["ProductRecipeWhere"];
	["ProductIngredientItemWhere"]: GraphQLTypes["ProductIngredientItemWhere"];
	["ProductIngredientItemQuantityWhere"]: GraphQLTypes["ProductIngredientItemQuantityWhere"];
	["NutritionFactsWhere"]: GraphQLTypes["NutritionFactsWhere"];
	["DeliveryMethodLocaleWhere"]: GraphQLTypes["DeliveryMethodLocaleWhere"];
	["PipelineStageLocaleWhere"]: GraphQLTypes["PipelineStageLocaleWhere"];
	["PipelineStageWhere"]: GraphQLTypes["PipelineStageWhere"];
	["PipelineStageItemWhere"]: GraphQLTypes["PipelineStageItemWhere"];
	["PipelineLeadWhere"]: GraphQLTypes["PipelineLeadWhere"];
	["LeadFormWhere"]: GraphQLTypes["LeadFormWhere"];
	["PipelineWhere"]: GraphQLTypes["PipelineWhere"];
	["PipelineStageSentimentWhere"]: GraphQLTypes["PipelineStageSentimentWhere"];
	["PipelineStageTypeCondition"]: GraphQLTypes["PipelineStageTypeCondition"];
	["PipelineStageType"]: GraphQLTypes["PipelineStageType"];
	["SubscriptionBoxLocaleWhere"]: GraphQLTypes["SubscriptionBoxLocaleWhere"];
	["SubscriptionBoxWhere"]: GraphQLTypes["SubscriptionBoxWhere"];
	["PreparedPackingQuantityWhere"]: GraphQLTypes["PreparedPackingQuantityWhere"];
	["ProductStockWhere"]: GraphQLTypes["ProductStockWhere"];
	["StoreWhere"]: GraphQLTypes["StoreWhere"];
	["ProductGroupPriceWhere"]: GraphQLTypes["ProductGroupPriceWhere"];
	["CustomerGroupWhere"]: GraphQLTypes["CustomerGroupWhere"];
	["ProductAvailabilityCondition"]: GraphQLTypes["ProductAvailabilityCondition"];
	["ProductAvailability"]: GraphQLTypes["ProductAvailability"];
	["ProductCustomerPriceWhere"]: GraphQLTypes["ProductCustomerPriceWhere"];
	["ProductMetadataWhere"]: GraphQLTypes["ProductMetadataWhere"];
	["ProductSalesDayWhere"]: GraphQLTypes["ProductSalesDayWhere"];
	["ProductSalesWeekWhere"]: GraphQLTypes["ProductSalesWeekWhere"];
	["ProductSalesMonthWhere"]: GraphQLTypes["ProductSalesMonthWhere"];
	["AddressMetadataWhere"]: GraphQLTypes["AddressMetadataWhere"];
	["DeliveryTimelinePresetWhere"]: GraphQLTypes["DeliveryTimelinePresetWhere"];
	["DeliveryTimelineTypeCondition"]: GraphQLTypes["DeliveryTimelineTypeCondition"];
	["DeliveryTimelineType"]: GraphQLTypes["DeliveryTimelineType"];
	["PaymentMethodTypeCondition"]: GraphQLTypes["PaymentMethodTypeCondition"];
	["PaymentMethodType"]: GraphQLTypes["PaymentMethodType"];
	["CustomerPermissionsWhere"]: GraphQLTypes["CustomerPermissionsWhere"];
	["CustomerNameWhere"]: GraphQLTypes["CustomerNameWhere"];
	["CustomerAliasWhere"]: GraphQLTypes["CustomerAliasWhere"];
	["CustomerFamiliarityCondition"]: GraphQLTypes["CustomerFamiliarityCondition"];
	["CustomerFamiliarity"]: GraphQLTypes["CustomerFamiliarity"];
	["ApplicationShortcutListWhere"]: GraphQLTypes["ApplicationShortcutListWhere"];
	["ApplicationShortcutListItemWhere"]: GraphQLTypes["ApplicationShortcutListItemWhere"];
	["ApplicationWhere"]: GraphQLTypes["ApplicationWhere"];
	["InvoicingPlanWhere"]: GraphQLTypes["InvoicingPlanWhere"];
	["InvoicingPresetWhere"]: GraphQLTypes["InvoicingPresetWhere"];
	["InvoicingPresetTypeCondition"]: GraphQLTypes["InvoicingPresetTypeCondition"];
	["InvoicingPresetType"]: GraphQLTypes["InvoicingPresetType"];
	["CustomerSpendingWhere"]: GraphQLTypes["CustomerSpendingWhere"];
	["CustomerMetadataWhere"]: GraphQLTypes["CustomerMetadataWhere"];
	["GpsWhere"]: GraphQLTypes["GpsWhere"];
	["AddressOrderBy"]: GraphQLTypes["AddressOrderBy"];
	["OrderDirection"]: GraphQLTypes["OrderDirection"];
	["CustomerOrderBy"]: GraphQLTypes["CustomerOrderBy"];
	["CustomerPaymentMethodOrderBy"]: GraphQLTypes["CustomerPaymentMethodOrderBy"];
	["PaymentMethodOrderBy"]: GraphQLTypes["PaymentMethodOrderBy"];
	["CustomerPermissionsOrderBy"]: GraphQLTypes["CustomerPermissionsOrderBy"];
	["CustomerGroupOrderBy"]: GraphQLTypes["CustomerGroupOrderBy"];
	["ImageOrderBy"]: GraphQLTypes["ImageOrderBy"];
	["CustomerNameOrderBy"]: GraphQLTypes["CustomerNameOrderBy"];
	["BusinessCustomerOrderBy"]: GraphQLTypes["BusinessCustomerOrderBy"];
	["BusinessCategoryOrderBy"]: GraphQLTypes["BusinessCategoryOrderBy"];
	["ProductListOrderBy"]: GraphQLTypes["ProductListOrderBy"];
	["ProductCategoryListOrderBy"]: GraphQLTypes["ProductCategoryListOrderBy"];
	["BusinessToBusinessManagerOrderBy"]: GraphQLTypes["BusinessToBusinessManagerOrderBy"];
	["StaffOrderBy"]: GraphQLTypes["StaffOrderBy"];
	["BartenderOrderBy"]: GraphQLTypes["BartenderOrderBy"];
	["CourierOrderBy"]: GraphQLTypes["CourierOrderBy"];
	["CleanerOrderBy"]: GraphQLTypes["CleanerOrderBy"];
	["ShiftsManagerOrderBy"]: GraphQLTypes["ShiftsManagerOrderBy"];
	["UserOrderBy"]: GraphQLTypes["UserOrderBy"];
	["UserMetadataOrderBy"]: GraphQLTypes["UserMetadataOrderBy"];
	["UserRolesOrderBy"]: GraphQLTypes["UserRolesOrderBy"];
	["ShiftsProfileOrderBy"]: GraphQLTypes["ShiftsProfileOrderBy"];
	["StocksManagerOrderBy"]: GraphQLTypes["StocksManagerOrderBy"];
	["CourierManagerOrderBy"]: GraphQLTypes["CourierManagerOrderBy"];
	["PickerOrderBy"]: GraphQLTypes["PickerOrderBy"];
	["RemunerationProfileOrderBy"]: GraphQLTypes["RemunerationProfileOrderBy"];
	["WorkMonthOrderBy"]: GraphQLTypes["WorkMonthOrderBy"];
	["CashierOrderBy"]: GraphQLTypes["CashierOrderBy"];
	["InternalBuyerOrderBy"]: GraphQLTypes["InternalBuyerOrderBy"];
	["SalesManagerOrderBy"]: GraphQLTypes["SalesManagerOrderBy"];
	["CashierManagerOrderBy"]: GraphQLTypes["CashierManagerOrderBy"];
	["DoubleshotCoffeeEquipmentOrderBy"]: GraphQLTypes["DoubleshotCoffeeEquipmentOrderBy"];
	["ApplicationShortcutListOrderBy"]: GraphQLTypes["ApplicationShortcutListOrderBy"];
	["InvoicingPlanOrderBy"]: GraphQLTypes["InvoicingPlanOrderBy"];
	["InvoicingPresetOrderBy"]: GraphQLTypes["InvoicingPresetOrderBy"];
	["BillingSubjectOrderBy"]: GraphQLTypes["BillingSubjectOrderBy"];
	["CountryOrderBy"]: GraphQLTypes["CountryOrderBy"];
	["AnonymousSessionOrderBy"]: GraphQLTypes["AnonymousSessionOrderBy"];
	["CustomerSpendingOrderBy"]: GraphQLTypes["CustomerSpendingOrderBy"];
	["CustomerMetadataOrderBy"]: GraphQLTypes["CustomerMetadataOrderBy"];
	["DeliveryZoneOrderBy"]: GraphQLTypes["DeliveryZoneOrderBy"];
	["AddressMetadataOrderBy"]: GraphQLTypes["AddressMetadataOrderBy"];
	["GpsOrderBy"]: GraphQLTypes["GpsOrderBy"];
	["CustomerPaymentMethod"]: {
		_meta?: GraphQLTypes["CustomerPaymentMethodMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	caption: string,
	data?: GraphQLTypes["Json"] | undefined,
	customer?: GraphQLTypes["Customer"] | undefined,
	paymentMethod?: GraphQLTypes["PaymentMethod"] | undefined
};
	["CustomerPaymentMethodMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	caption?: GraphQLTypes["FieldMeta"] | undefined,
	data?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined,
	paymentMethod?: GraphQLTypes["FieldMeta"] | undefined
};
	["Json"]:any;
	["PaymentMethod"]: {
		_meta?: GraphQLTypes["PaymentMethodMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	code?: string | undefined,
	enabled: boolean,
	deliveryMethods: Array<GraphQLTypes["DeliveryMethod"]>,
	description?: string | undefined,
	internalNote?: string | undefined,
	blockingDispatch: boolean,
	type?: GraphQLTypes["PaymentMethodType"] | undefined,
	channels: Array<GraphQLTypes["ChannelPayment"]>,
	reduceGratuityByPercentage: number,
	paginateDeliveryMethods: GraphQLTypes["DeliveryMethodConnection"],
	paginateChannels: GraphQLTypes["ChannelPaymentConnection"]
};
	["PaymentMethodMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	code?: GraphQLTypes["FieldMeta"] | undefined,
	enabled?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryMethods?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	blockingDispatch?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	channels?: GraphQLTypes["FieldMeta"] | undefined,
	reduceGratuityByPercentage?: GraphQLTypes["FieldMeta"] | undefined
};
	["DeliveryMethod"]: {
		_meta?: GraphQLTypes["DeliveryMethodMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	code?: string | undefined,
	enabled: boolean,
	paymentMethods: Array<GraphQLTypes["PaymentMethod"]>,
	description?: string | undefined,
	internalNote?: string | undefined,
	requireDeliveryAddress: boolean,
	suitableForDeliveryZones: Array<GraphQLTypes["DeliveryZone"]>,
	channels: Array<GraphQLTypes["ChannelDelivery"]>,
	courierHandlers: Array<GraphQLTypes["Courier"]>,
	enableDeliveryTracking: boolean,
	locales: Array<GraphQLTypes["DeliveryMethodLocale"]>,
	timelinePreset?: GraphQLTypes["DeliveryTimelinePreset"] | undefined,
	woltDriveVenueId?: string | undefined,
	localesByLocale?: GraphQLTypes["DeliveryMethodLocale"] | undefined,
	paginatePaymentMethods: GraphQLTypes["PaymentMethodConnection"],
	paginateSuitableForDeliveryZones: GraphQLTypes["DeliveryZoneConnection"],
	paginateChannels: GraphQLTypes["ChannelDeliveryConnection"],
	paginateCourierHandlers: GraphQLTypes["CourierConnection"],
	paginateLocales: GraphQLTypes["DeliveryMethodLocaleConnection"]
};
	["DeliveryMethodMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	code?: GraphQLTypes["FieldMeta"] | undefined,
	enabled?: GraphQLTypes["FieldMeta"] | undefined,
	paymentMethods?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	requireDeliveryAddress?: GraphQLTypes["FieldMeta"] | undefined,
	suitableForDeliveryZones?: GraphQLTypes["FieldMeta"] | undefined,
	channels?: GraphQLTypes["FieldMeta"] | undefined,
	courierHandlers?: GraphQLTypes["FieldMeta"] | undefined,
	enableDeliveryTracking?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	timelinePreset?: GraphQLTypes["FieldMeta"] | undefined,
	woltDriveVenueId?: GraphQLTypes["FieldMeta"] | undefined
};
	["DeliveryZone"]: {
		_meta?: GraphQLTypes["DeliveryZoneMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	code?: string | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	type: GraphQLTypes["DeliveryZoneType"],
	addresses: Array<GraphQLTypes["Address"]>,
	suitableDeliveryMethods: Array<GraphQLTypes["DeliveryMethod"]>,
	deliveryZonesOfTags: Array<GraphQLTypes["Tag"]>,
	deliveryZonesOfProducts: Array<GraphQLTypes["Product"]>,
	addressesMetadata: Array<GraphQLTypes["AddressMetadata"]>,
	addressesByMeta?: GraphQLTypes["Address"] | undefined,
	addressesByGps?: GraphQLTypes["Address"] | undefined,
	addressesByInvoices?: GraphQLTypes["Address"] | undefined,
	addressesByBillingAddressOfOrders?: GraphQLTypes["Address"] | undefined,
	addressesByDeliveryAddressOfOrderDeliveries?: GraphQLTypes["Address"] | undefined,
	addressesByDefaultDeliveryAddressOfCustomer?: GraphQLTypes["Address"] | undefined,
	addressesMetadataByAddress?: GraphQLTypes["AddressMetadata"] | undefined,
	paginateAddresses: GraphQLTypes["AddressConnection"],
	paginateSuitableDeliveryMethods: GraphQLTypes["DeliveryMethodConnection"],
	paginateDeliveryZonesOfTags: GraphQLTypes["TagConnection"],
	paginateDeliveryZonesOfProducts: GraphQLTypes["ProductConnection"],
	paginateAddressesMetadata: GraphQLTypes["AddressMetadataConnection"]
};
	["DeliveryZoneMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	code?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	addresses?: GraphQLTypes["FieldMeta"] | undefined,
	suitableDeliveryMethods?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryZonesOfTags?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryZonesOfProducts?: GraphQLTypes["FieldMeta"] | undefined,
	addressesMetadata?: GraphQLTypes["FieldMeta"] | undefined
};
	["DeliveryMethodOrderBy"]: GraphQLTypes["DeliveryMethodOrderBy"];
	["DeliveryTimelinePresetOrderBy"]: GraphQLTypes["DeliveryTimelinePresetOrderBy"];
	["Tag"]: {
		_meta?: GraphQLTypes["TagMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	code?: string | undefined,
	customers: Array<GraphQLTypes["Customer"]>,
	products: Array<GraphQLTypes["Product"]>,
	categories: Array<GraphQLTypes["ProductCategory"]>,
	description?: string | undefined,
	internalNote?: string | undefined,
	addTagsOnRegistration: Array<GraphQLTypes["Channel"]>,
	nestedCategories: Array<GraphQLTypes["InheritedProductCategoryTag"]>,
	deliveryZones: Array<GraphQLTypes["DeliveryZone"]>,
	publicInChannels: Array<GraphQLTypes["Channel"]>,
	allowChannelPayments: Array<GraphQLTypes["ChannelPayment"]>,
	fulfillmentNotes: Array<GraphQLTypes["FulfillmentNote"]>,
	paginateCustomers: GraphQLTypes["CustomerConnection"],
	paginateProducts: GraphQLTypes["ProductConnection"],
	paginateCategories: GraphQLTypes["ProductCategoryConnection"],
	paginateAddTagsOnRegistration: GraphQLTypes["ChannelConnection"],
	paginateNestedCategories: GraphQLTypes["InheritedProductCategoryTagConnection"],
	paginateDeliveryZones: GraphQLTypes["DeliveryZoneConnection"],
	paginatePublicInChannels: GraphQLTypes["ChannelConnection"],
	paginateAllowChannelPayments: GraphQLTypes["ChannelPaymentConnection"],
	paginateFulfillmentNotes: GraphQLTypes["FulfillmentNoteConnection"]
};
	["TagMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	code?: GraphQLTypes["FieldMeta"] | undefined,
	customers?: GraphQLTypes["FieldMeta"] | undefined,
	products?: GraphQLTypes["FieldMeta"] | undefined,
	categories?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	addTagsOnRegistration?: GraphQLTypes["FieldMeta"] | undefined,
	nestedCategories?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryZones?: GraphQLTypes["FieldMeta"] | undefined,
	publicInChannels?: GraphQLTypes["FieldMeta"] | undefined,
	allowChannelPayments?: GraphQLTypes["FieldMeta"] | undefined,
	fulfillmentNotes?: GraphQLTypes["FieldMeta"] | undefined
};
	["Product"]: {
		_meta?: GraphQLTypes["ProductMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	code: string,
	priceCents: number,
	notDiscountable: boolean,
	packing?: GraphQLTypes["ProductPacking"] | undefined,
	recipe?: GraphQLTypes["ProductRecipe"] | undefined,
	tags: Array<GraphQLTypes["Tag"]>,
	categories: Array<GraphQLTypes["ProductCategory"]>,
	vatRate?: GraphQLTypes["VatRate"] | undefined,
	stocks: Array<GraphQLTypes["ProductStock"]>,
	groupPrices: Array<GraphQLTypes["ProductGroupPrice"]>,
	image?: GraphQLTypes["Image"] | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	cartItems: Array<GraphQLTypes["CartItem"]>,
	availability: GraphQLTypes["ProductAvailability"],
	order: number,
	manager?: GraphQLTypes["StocksManager"] | undefined,
	orderItems: Array<GraphQLTypes["OrderItem"]>,
	maximumQuantityPerOrder?: number | undefined,
	inheritedCategories: Array<GraphQLTypes["NestedProductCategoryProduct"]>,
	deliveryZones: Array<GraphQLTypes["DeliveryZone"]>,
	locales: Array<GraphQLTypes["ProductLocale"]>,
	archivedAt?: GraphQLTypes["DateTime"] | undefined,
	customerPrices: Array<GraphQLTypes["ProductCustomerPrice"]>,
	virtualProduct?: GraphQLTypes["VirtualProduct"] | undefined,
	meta?: GraphQLTypes["ProductMetadata"] | undefined,
	page?: GraphQLTypes["Page"] | undefined,
	salesDays: Array<GraphQLTypes["ProductSalesDay"]>,
	salesWeeks: Array<GraphQLTypes["ProductSalesWeek"]>,
	salesMonths: Array<GraphQLTypes["ProductSalesMonth"]>,
	fulfillmentNotes: Array<GraphQLTypes["FulfillmentNote"]>,
	hasSubscription: boolean,
	pointOfSaleTileColor?: string | undefined,
	stocksByStore?: GraphQLTypes["ProductStock"] | undefined,
	groupPricesByGroup?: GraphQLTypes["ProductGroupPrice"] | undefined,
	cartItemsByCart?: GraphQLTypes["CartItem"] | undefined,
	orderItemsByVirtualProductEffects?: GraphQLTypes["OrderItem"] | undefined,
	localesByLocale?: GraphQLTypes["ProductLocale"] | undefined,
	localesByFeatureList?: GraphQLTypes["ProductLocale"] | undefined,
	customerPricesByCustomer?: GraphQLTypes["ProductCustomerPrice"] | undefined,
	paginateTags: GraphQLTypes["TagConnection"],
	paginateCategories: GraphQLTypes["ProductCategoryConnection"],
	paginateStocks: GraphQLTypes["ProductStockConnection"],
	paginateGroupPrices: GraphQLTypes["ProductGroupPriceConnection"],
	paginateCartItems: GraphQLTypes["CartItemConnection"],
	paginateOrderItems: GraphQLTypes["OrderItemConnection"],
	paginateInheritedCategories: GraphQLTypes["NestedProductCategoryProductConnection"],
	paginateDeliveryZones: GraphQLTypes["DeliveryZoneConnection"],
	paginateLocales: GraphQLTypes["ProductLocaleConnection"],
	paginateCustomerPrices: GraphQLTypes["ProductCustomerPriceConnection"],
	paginateSalesDays: GraphQLTypes["ProductSalesDayConnection"],
	paginateSalesWeeks: GraphQLTypes["ProductSalesWeekConnection"],
	paginateSalesMonths: GraphQLTypes["ProductSalesMonthConnection"],
	paginateFulfillmentNotes: GraphQLTypes["FulfillmentNoteConnection"]
};
	["ProductMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	code?: GraphQLTypes["FieldMeta"] | undefined,
	priceCents?: GraphQLTypes["FieldMeta"] | undefined,
	notDiscountable?: GraphQLTypes["FieldMeta"] | undefined,
	packing?: GraphQLTypes["FieldMeta"] | undefined,
	recipe?: GraphQLTypes["FieldMeta"] | undefined,
	tags?: GraphQLTypes["FieldMeta"] | undefined,
	categories?: GraphQLTypes["FieldMeta"] | undefined,
	vatRate?: GraphQLTypes["FieldMeta"] | undefined,
	stocks?: GraphQLTypes["FieldMeta"] | undefined,
	groupPrices?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	cartItems?: GraphQLTypes["FieldMeta"] | undefined,
	availability?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	manager?: GraphQLTypes["FieldMeta"] | undefined,
	orderItems?: GraphQLTypes["FieldMeta"] | undefined,
	maximumQuantityPerOrder?: GraphQLTypes["FieldMeta"] | undefined,
	inheritedCategories?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryZones?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	archivedAt?: GraphQLTypes["FieldMeta"] | undefined,
	customerPrices?: GraphQLTypes["FieldMeta"] | undefined,
	virtualProduct?: GraphQLTypes["FieldMeta"] | undefined,
	meta?: GraphQLTypes["FieldMeta"] | undefined,
	page?: GraphQLTypes["FieldMeta"] | undefined,
	salesDays?: GraphQLTypes["FieldMeta"] | undefined,
	salesWeeks?: GraphQLTypes["FieldMeta"] | undefined,
	salesMonths?: GraphQLTypes["FieldMeta"] | undefined,
	fulfillmentNotes?: GraphQLTypes["FieldMeta"] | undefined,
	hasSubscription?: GraphQLTypes["FieldMeta"] | undefined,
	pointOfSaleTileColor?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductPacking"]: {
		_meta?: GraphQLTypes["ProductPackingMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	image?: GraphQLTypes["Image"] | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	volumeMl?: number | undefined,
	icon?: GraphQLTypes["Image"] | undefined,
	shortName?: string | undefined,
	locales: Array<GraphQLTypes["ProductPackingLocale"]>,
	preparedPackingQuantities: Array<GraphQLTypes["PreparedPackingQuantity"]>,
	isPackedInCardboard: boolean,
	localesByLocale?: GraphQLTypes["ProductPackingLocale"] | undefined,
	paginateLocales: GraphQLTypes["ProductPackingLocaleConnection"],
	paginatePreparedPackingQuantities: GraphQLTypes["PreparedPackingQuantityConnection"]
};
	["ProductPackingMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	volumeMl?: GraphQLTypes["FieldMeta"] | undefined,
	icon?: GraphQLTypes["FieldMeta"] | undefined,
	shortName?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	preparedPackingQuantities?: GraphQLTypes["FieldMeta"] | undefined,
	isPackedInCardboard?: GraphQLTypes["FieldMeta"] | undefined
};
	["Image"]: {
		_meta?: GraphQLTypes["ImageMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	url: string,
	width?: number | undefined,
	height?: number | undefined,
	size?: number | undefined,
	type?: string | undefined,
	alt?: string | undefined
};
	["ImageMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	url?: GraphQLTypes["FieldMeta"] | undefined,
	width?: GraphQLTypes["FieldMeta"] | undefined,
	height?: GraphQLTypes["FieldMeta"] | undefined,
	size?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	alt?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductPackingLocale"]: {
		_meta?: GraphQLTypes["ProductPackingLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	shortName?: string | undefined,
	description?: string | undefined,
	root?: GraphQLTypes["ProductPacking"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined
};
	["ProductPackingLocaleMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	shortName?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined
};
	["Locale"]: {
		_meta?: GraphQLTypes["LocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	businessCategories: Array<GraphQLTypes["BusinessCategoryLocale"]>,
	productCategoryLists: Array<GraphQLTypes["ProductCategoryListLocale"]>,
	productIngredients: Array<GraphQLTypes["ProductIngredientLocale"]>,
	orderRecurrences: Array<GraphQLTypes["OrderRecurrenceLocale"]>,
	blogs: Array<GraphQLTypes["BlogLocale"]>,
	blogPosts: Array<GraphQLTypes["BlogPostLocale"]>,
	identifier?: GraphQLTypes["TranslationCataloguesIdentifier"] | undefined,
	menus: Array<GraphQLTypes["MenuLocale"]>,
	pages: Array<GraphQLTypes["PageLocale"]>,
	productIngredientCategories: Array<GraphQLTypes["ProductIngredientCategoryLocale"]>,
	allergens: Array<GraphQLTypes["AllergenLocale"]>,
	productPackings: Array<GraphQLTypes["ProductPackingLocale"]>,
	products: Array<GraphQLTypes["ProductLocale"]>,
	productRecipes: Array<GraphQLTypes["ProductRecipeLocale"]>,
	pointOfSaleCategories: Array<GraphQLTypes["PointOfSaleCategoryLocale"]>,
	pointOfSaleCategoryProducts: Array<GraphQLTypes["PointOfSaleCategoryProductLocale"]>,
	deliveryMethods: Array<GraphQLTypes["DeliveryMethodLocale"]>,
	ingredientSuppliers: Array<GraphQLTypes["IngredientSupplierLocale"]>,
	identificationCodes: Array<GraphQLTypes["IdentificationCodeLocale"]>,
	pipelineStages: Array<GraphQLTypes["PipelineStageLocale"]>,
	subscriptionBoxes: Array<GraphQLTypes["SubscriptionBoxLocale"]>,
	businessServices: Array<GraphQLTypes["BusinessServiceLocale"]>,
	businessCategoriesByRoot?: GraphQLTypes["BusinessCategoryLocale"] | undefined,
	productCategoryListsByRoot?: GraphQLTypes["ProductCategoryListLocale"] | undefined,
	productIngredientsByRoot?: GraphQLTypes["ProductIngredientLocale"] | undefined,
	orderRecurrencesByRoot?: GraphQLTypes["OrderRecurrenceLocale"] | undefined,
	blogsByRoot?: GraphQLTypes["BlogLocale"] | undefined,
	blogPostsByRoot?: GraphQLTypes["BlogPostLocale"] | undefined,
	blogPostsByCover?: GraphQLTypes["BlogPostLocale"] | undefined,
	blogPostsByContent?: GraphQLTypes["BlogPostLocale"] | undefined,
	blogPostsByLink?: GraphQLTypes["BlogPostLocale"] | undefined,
	blogPostsBySeo?: GraphQLTypes["BlogPostLocale"] | undefined,
	menusByRoot?: GraphQLTypes["MenuLocale"] | undefined,
	menusByItems?: GraphQLTypes["MenuLocale"] | undefined,
	menusBySecondaryItems?: GraphQLTypes["MenuLocale"] | undefined,
	pagesByRoot?: GraphQLTypes["PageLocale"] | undefined,
	pagesByLink?: GraphQLTypes["PageLocale"] | undefined,
	pagesBySeo?: GraphQLTypes["PageLocale"] | undefined,
	pagesByContent?: GraphQLTypes["PageLocale"] | undefined,
	pagesByCover?: GraphQLTypes["PageLocale"] | undefined,
	productIngredientCategoriesByRoot?: GraphQLTypes["ProductIngredientCategoryLocale"] | undefined,
	allergensByRoot?: GraphQLTypes["AllergenLocale"] | undefined,
	productPackingsByRoot?: GraphQLTypes["ProductPackingLocale"] | undefined,
	productsByRoot?: GraphQLTypes["ProductLocale"] | undefined,
	productsByFeatureList?: GraphQLTypes["ProductLocale"] | undefined,
	productRecipesByRoot?: GraphQLTypes["ProductRecipeLocale"] | undefined,
	pointOfSaleCategoriesByRoot?: GraphQLTypes["PointOfSaleCategoryLocale"] | undefined,
	pointOfSaleCategoryProductsByRoot?: GraphQLTypes["PointOfSaleCategoryProductLocale"] | undefined,
	deliveryMethodsByRoot?: GraphQLTypes["DeliveryMethodLocale"] | undefined,
	ingredientSuppliersByRoot?: GraphQLTypes["IngredientSupplierLocale"] | undefined,
	identificationCodesByRoot?: GraphQLTypes["IdentificationCodeLocale"] | undefined,
	pipelineStagesByRoot?: GraphQLTypes["PipelineStageLocale"] | undefined,
	subscriptionBoxesByRoot?: GraphQLTypes["SubscriptionBoxLocale"] | undefined,
	subscriptionBoxesByTexts?: GraphQLTypes["SubscriptionBoxLocale"] | undefined,
	subscriptionBoxesBySecondaryTexts?: GraphQLTypes["SubscriptionBoxLocale"] | undefined,
	businessServicesByRoot?: GraphQLTypes["BusinessServiceLocale"] | undefined,
	paginateBusinessCategories: GraphQLTypes["BusinessCategoryLocaleConnection"],
	paginateProductCategoryLists: GraphQLTypes["ProductCategoryListLocaleConnection"],
	paginateProductIngredients: GraphQLTypes["ProductIngredientLocaleConnection"],
	paginateOrderRecurrences: GraphQLTypes["OrderRecurrenceLocaleConnection"],
	paginateBlogs: GraphQLTypes["BlogLocaleConnection"],
	paginateBlogPosts: GraphQLTypes["BlogPostLocaleConnection"],
	paginateMenus: GraphQLTypes["MenuLocaleConnection"],
	paginatePages: GraphQLTypes["PageLocaleConnection"],
	paginateProductIngredientCategories: GraphQLTypes["ProductIngredientCategoryLocaleConnection"],
	paginateAllergens: GraphQLTypes["AllergenLocaleConnection"],
	paginateProductPackings: GraphQLTypes["ProductPackingLocaleConnection"],
	paginateProducts: GraphQLTypes["ProductLocaleConnection"],
	paginateProductRecipes: GraphQLTypes["ProductRecipeLocaleConnection"],
	paginatePointOfSaleCategories: GraphQLTypes["PointOfSaleCategoryLocaleConnection"],
	paginatePointOfSaleCategoryProducts: GraphQLTypes["PointOfSaleCategoryProductLocaleConnection"],
	paginateDeliveryMethods: GraphQLTypes["DeliveryMethodLocaleConnection"],
	paginateIngredientSuppliers: GraphQLTypes["IngredientSupplierLocaleConnection"],
	paginateIdentificationCodes: GraphQLTypes["IdentificationCodeLocaleConnection"],
	paginatePipelineStages: GraphQLTypes["PipelineStageLocaleConnection"],
	paginateSubscriptionBoxes: GraphQLTypes["SubscriptionBoxLocaleConnection"],
	paginateBusinessServices: GraphQLTypes["BusinessServiceLocaleConnection"]
};
	["LocaleMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	businessCategories?: GraphQLTypes["FieldMeta"] | undefined,
	productCategoryLists?: GraphQLTypes["FieldMeta"] | undefined,
	productIngredients?: GraphQLTypes["FieldMeta"] | undefined,
	orderRecurrences?: GraphQLTypes["FieldMeta"] | undefined,
	blogs?: GraphQLTypes["FieldMeta"] | undefined,
	blogPosts?: GraphQLTypes["FieldMeta"] | undefined,
	identifier?: GraphQLTypes["FieldMeta"] | undefined,
	menus?: GraphQLTypes["FieldMeta"] | undefined,
	pages?: GraphQLTypes["FieldMeta"] | undefined,
	productIngredientCategories?: GraphQLTypes["FieldMeta"] | undefined,
	allergens?: GraphQLTypes["FieldMeta"] | undefined,
	productPackings?: GraphQLTypes["FieldMeta"] | undefined,
	products?: GraphQLTypes["FieldMeta"] | undefined,
	productRecipes?: GraphQLTypes["FieldMeta"] | undefined,
	pointOfSaleCategories?: GraphQLTypes["FieldMeta"] | undefined,
	pointOfSaleCategoryProducts?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryMethods?: GraphQLTypes["FieldMeta"] | undefined,
	ingredientSuppliers?: GraphQLTypes["FieldMeta"] | undefined,
	identificationCodes?: GraphQLTypes["FieldMeta"] | undefined,
	pipelineStages?: GraphQLTypes["FieldMeta"] | undefined,
	subscriptionBoxes?: GraphQLTypes["FieldMeta"] | undefined,
	businessServices?: GraphQLTypes["FieldMeta"] | undefined
};
	["BusinessCategoryLocale"]: {
		_meta?: GraphQLTypes["BusinessCategoryLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	root?: GraphQLTypes["BusinessCategory"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	title?: string | undefined
};
	["BusinessCategoryLocaleMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined
};
	["BusinessCategory"]: {
		_meta?: GraphQLTypes["BusinessCategoryMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	visibleToNewCustomers: boolean,
	locales: Array<GraphQLTypes["BusinessCategoryLocale"]>,
	internalName: string,
	businessCustomers: Array<GraphQLTypes["BusinessCustomer"]>,
	recurrences: Array<GraphQLTypes["OrderRecurrence"]>,
	specificProducts?: GraphQLTypes["ProductList"] | undefined,
	seasonalProductCategories?: GraphQLTypes["ProductCategoryList"] | undefined,
	specificProductsProductCategories?: GraphQLTypes["ProductCategoryList"] | undefined,
	slug: string,
	localesByLocale?: GraphQLTypes["BusinessCategoryLocale"] | undefined,
	businessCustomersByCustomer?: GraphQLTypes["BusinessCustomer"] | undefined,
	businessCustomersByBusinessServiceEvents?: GraphQLTypes["BusinessCustomer"] | undefined,
	businessCustomersByDoubleshotCoffeeEquipment?: GraphQLTypes["BusinessCustomer"] | undefined,
	paginateLocales: GraphQLTypes["BusinessCategoryLocaleConnection"],
	paginateBusinessCustomers: GraphQLTypes["BusinessCustomerConnection"],
	paginateRecurrences: GraphQLTypes["OrderRecurrenceConnection"]
};
	["BusinessCategoryMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	visibleToNewCustomers?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	internalName?: GraphQLTypes["FieldMeta"] | undefined,
	businessCustomers?: GraphQLTypes["FieldMeta"] | undefined,
	recurrences?: GraphQLTypes["FieldMeta"] | undefined,
	specificProducts?: GraphQLTypes["FieldMeta"] | undefined,
	seasonalProductCategories?: GraphQLTypes["FieldMeta"] | undefined,
	specificProductsProductCategories?: GraphQLTypes["FieldMeta"] | undefined,
	slug?: GraphQLTypes["FieldMeta"] | undefined
};
	["BusinessCategoryLocaleOrderBy"]: GraphQLTypes["BusinessCategoryLocaleOrderBy"];
	["LocaleOrderBy"]: GraphQLTypes["LocaleOrderBy"];
	["TranslationCataloguesIdentifierOrderBy"]: GraphQLTypes["TranslationCataloguesIdentifierOrderBy"];
	["BusinessCustomer"]: {
		_meta?: GraphQLTypes["BusinessCustomerMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	customer?: GraphQLTypes["Customer"] | undefined,
	owners: Array<GraphQLTypes["Customer"]>,
	members: Array<GraphQLTypes["Customer"]>,
	category?: GraphQLTypes["BusinessCategory"] | undefined,
	accountManager?: GraphQLTypes["BusinessToBusinessManager"] | undefined,
	logo?: GraphQLTypes["Image"] | undefined,
	note?: string | undefined,
	businessServiceEvents: Array<GraphQLTypes["BusinessServiceEvent"]>,
	doubleshotCoffeeEquipment?: GraphQLTypes["DoubleshotCoffeeEquipment"] | undefined,
	paginateOwners: GraphQLTypes["CustomerConnection"],
	paginateMembers: GraphQLTypes["CustomerConnection"],
	paginateBusinessServiceEvents: GraphQLTypes["BusinessServiceEventConnection"]
};
	["BusinessCustomerMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined,
	owners?: GraphQLTypes["FieldMeta"] | undefined,
	members?: GraphQLTypes["FieldMeta"] | undefined,
	category?: GraphQLTypes["FieldMeta"] | undefined,
	accountManager?: GraphQLTypes["FieldMeta"] | undefined,
	logo?: GraphQLTypes["FieldMeta"] | undefined,
	note?: GraphQLTypes["FieldMeta"] | undefined,
	businessServiceEvents?: GraphQLTypes["FieldMeta"] | undefined,
	doubleshotCoffeeEquipment?: GraphQLTypes["FieldMeta"] | undefined
};
	["BusinessToBusinessManager"]: {
		_meta?: GraphQLTypes["BusinessToBusinessManagerMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	staff?: GraphQLTypes["Staff"] | undefined,
	managedBusinesses: Array<GraphQLTypes["BusinessCustomer"]>,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	managedBusinessesByCustomer?: GraphQLTypes["BusinessCustomer"] | undefined,
	managedBusinessesByBusinessServiceEvents?: GraphQLTypes["BusinessCustomer"] | undefined,
	managedBusinessesByDoubleshotCoffeeEquipment?: GraphQLTypes["BusinessCustomer"] | undefined,
	paginateManagedBusinesses: GraphQLTypes["BusinessCustomerConnection"]
};
	["BusinessToBusinessManagerMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	staff?: GraphQLTypes["FieldMeta"] | undefined,
	managedBusinesses?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined
};
	["Staff"]: {
		_meta?: GraphQLTypes["StaffMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	bartender?: GraphQLTypes["Bartender"] | undefined,
	courier?: GraphQLTypes["Courier"] | undefined,
	cleaner?: GraphQLTypes["Cleaner"] | undefined,
	shiftsManager?: GraphQLTypes["ShiftsManager"] | undefined,
	businessToBusinessManager?: GraphQLTypes["BusinessToBusinessManager"] | undefined,
	user?: GraphQLTypes["User"] | undefined,
	shiftsProfile?: GraphQLTypes["ShiftsProfile"] | undefined,
	stocksManager?: GraphQLTypes["StocksManager"] | undefined,
	photo?: GraphQLTypes["Image"] | undefined,
	courierManager?: GraphQLTypes["CourierManager"] | undefined,
	picker?: GraphQLTypes["Picker"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	remunerationProfile?: GraphQLTypes["RemunerationProfile"] | undefined,
	cashier?: GraphQLTypes["Cashier"] | undefined,
	venues: Array<GraphQLTypes["Venue"]>,
	internalBuyer?: GraphQLTypes["InternalBuyer"] | undefined,
	salesManager?: GraphQLTypes["SalesManager"] | undefined,
	cashierManager?: GraphQLTypes["CashierManager"] | undefined,
	paginateVenues: GraphQLTypes["VenueConnection"]
};
	["StaffMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	bartender?: GraphQLTypes["FieldMeta"] | undefined,
	courier?: GraphQLTypes["FieldMeta"] | undefined,
	cleaner?: GraphQLTypes["FieldMeta"] | undefined,
	shiftsManager?: GraphQLTypes["FieldMeta"] | undefined,
	businessToBusinessManager?: GraphQLTypes["FieldMeta"] | undefined,
	user?: GraphQLTypes["FieldMeta"] | undefined,
	shiftsProfile?: GraphQLTypes["FieldMeta"] | undefined,
	stocksManager?: GraphQLTypes["FieldMeta"] | undefined,
	photo?: GraphQLTypes["FieldMeta"] | undefined,
	courierManager?: GraphQLTypes["FieldMeta"] | undefined,
	picker?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	remunerationProfile?: GraphQLTypes["FieldMeta"] | undefined,
	cashier?: GraphQLTypes["FieldMeta"] | undefined,
	venues?: GraphQLTypes["FieldMeta"] | undefined,
	internalBuyer?: GraphQLTypes["FieldMeta"] | undefined,
	salesManager?: GraphQLTypes["FieldMeta"] | undefined,
	cashierManager?: GraphQLTypes["FieldMeta"] | undefined
};
	["Bartender"]: {
		_meta?: GraphQLTypes["BartenderMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	staff?: GraphQLTypes["Staff"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined
};
	["BartenderMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	staff?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined
};
	["Courier"]: {
		_meta?: GraphQLTypes["CourierMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	staff?: GraphQLTypes["Staff"] | undefined,
	routes: Array<GraphQLTypes["DeliveryRoute"]>,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	deliveryMethods: Array<GraphQLTypes["DeliveryMethod"]>,
	showInPicker: boolean,
	routesByWaypoints?: GraphQLTypes["DeliveryRoute"] | undefined,
	paginateRoutes: GraphQLTypes["DeliveryRouteConnection"],
	paginateDeliveryMethods: GraphQLTypes["DeliveryMethodConnection"]
};
	["CourierMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	staff?: GraphQLTypes["FieldMeta"] | undefined,
	routes?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryMethods?: GraphQLTypes["FieldMeta"] | undefined,
	showInPicker?: GraphQLTypes["FieldMeta"] | undefined
};
	["DeliveryRoute"]: {
		_meta?: GraphQLTypes["DeliveryRouteMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	courier?: GraphQLTypes["Courier"] | undefined,
	createdAt: GraphQLTypes["DateTime"],
	waypoints: Array<GraphQLTypes["DeliveryWaypoint"]>,
	dispatchAt: string,
	waypointsByDelivery?: GraphQLTypes["DeliveryWaypoint"] | undefined,
	paginateWaypoints: GraphQLTypes["DeliveryWaypointConnection"]
};
	["DeliveryRouteMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	courier?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	waypoints?: GraphQLTypes["FieldMeta"] | undefined,
	dispatchAt?: GraphQLTypes["FieldMeta"] | undefined
};
	["DeliveryWaypoint"]: {
		_meta?: GraphQLTypes["DeliveryWaypointMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	estimatedArrival?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	route?: GraphQLTypes["DeliveryRoute"] | undefined,
	sortingOrder: number,
	delivery?: GraphQLTypes["OrderDelivery"] | undefined,
	estimatedDistance?: number | undefined,
	estimatedDuration?: number | undefined,
	originDeparture?: GraphQLTypes["DateTime"] | undefined,
	originAddress?: string | undefined,
	transitMode?: string | undefined
};
	["DeliveryWaypointMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	estimatedArrival?: GraphQLTypes["FieldMeta"] | undefined,
	note?: GraphQLTypes["FieldMeta"] | undefined,
	route?: GraphQLTypes["FieldMeta"] | undefined,
	sortingOrder?: GraphQLTypes["FieldMeta"] | undefined,
	delivery?: GraphQLTypes["FieldMeta"] | undefined,
	estimatedDistance?: GraphQLTypes["FieldMeta"] | undefined,
	estimatedDuration?: GraphQLTypes["FieldMeta"] | undefined,
	originDeparture?: GraphQLTypes["FieldMeta"] | undefined,
	originAddress?: GraphQLTypes["FieldMeta"] | undefined,
	transitMode?: GraphQLTypes["FieldMeta"] | undefined
};
	["OrderDelivery"]: {
		_meta?: GraphQLTypes["OrderDeliveryMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	priceCents: number,
	deliveredAt?: GraphQLTypes["DateTime"] | undefined,
	method?: GraphQLTypes["DeliveryMethod"] | undefined,
	vatRate?: GraphQLTypes["VatRate"] | undefined,
	order?: GraphQLTypes["Order"] | undefined,
	expectedAt?: GraphQLTypes["DateTime"] | undefined,
	state: GraphQLTypes["OrderDeliveryState"],
	loadingDurationHours?: number | undefined,
	dispatchAt?: GraphQLTypes["DateTime"] | undefined,
	duration?: string | undefined,
	window?: string | undefined,
	expectedEndAt?: GraphQLTypes["DateTime"] | undefined,
	processingAt?: GraphQLTypes["DateTime"] | undefined,
	deliveringAt?: GraphQLTypes["DateTime"] | undefined,
	failedAt?: GraphQLTypes["DateTime"] | undefined,
	internalNote?: string | undefined,
	deliveryWaypoint?: GraphQLTypes["DeliveryWaypoint"] | undefined,
	events: Array<GraphQLTypes["OrderEvent"]>,
	prepareAt?: GraphQLTypes["DateTime"] | undefined,
	liftagoRide?: GraphQLTypes["LiftagoRide"] | undefined,
	pickedAt?: GraphQLTypes["DateTime"] | undefined,
	address?: GraphQLTypes["Address"] | undefined,
	trackingCode?: string | undefined,
	woltDriveDelivery?: GraphQLTypes["WoltDriveDelivery"] | undefined,
	paginateEvents: GraphQLTypes["OrderEventConnection"]
};
	["OrderDeliveryMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	priceCents?: GraphQLTypes["FieldMeta"] | undefined,
	deliveredAt?: GraphQLTypes["FieldMeta"] | undefined,
	method?: GraphQLTypes["FieldMeta"] | undefined,
	vatRate?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	expectedAt?: GraphQLTypes["FieldMeta"] | undefined,
	state?: GraphQLTypes["FieldMeta"] | undefined,
	loadingDurationHours?: GraphQLTypes["FieldMeta"] | undefined,
	dispatchAt?: GraphQLTypes["FieldMeta"] | undefined,
	duration?: GraphQLTypes["FieldMeta"] | undefined,
	window?: GraphQLTypes["FieldMeta"] | undefined,
	expectedEndAt?: GraphQLTypes["FieldMeta"] | undefined,
	processingAt?: GraphQLTypes["FieldMeta"] | undefined,
	deliveringAt?: GraphQLTypes["FieldMeta"] | undefined,
	failedAt?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryWaypoint?: GraphQLTypes["FieldMeta"] | undefined,
	events?: GraphQLTypes["FieldMeta"] | undefined,
	prepareAt?: GraphQLTypes["FieldMeta"] | undefined,
	liftagoRide?: GraphQLTypes["FieldMeta"] | undefined,
	pickedAt?: GraphQLTypes["FieldMeta"] | undefined,
	address?: GraphQLTypes["FieldMeta"] | undefined,
	trackingCode?: GraphQLTypes["FieldMeta"] | undefined,
	woltDriveDelivery?: GraphQLTypes["FieldMeta"] | undefined
};
	["VatRate"]: {
		_meta?: GraphQLTypes["VatRateMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	ratePermille: number,
	description?: string | undefined,
	internalNote?: string | undefined,
	channelDeliveries: Array<GraphQLTypes["ChannelDelivery"]>,
	channelPayments: Array<GraphQLTypes["ChannelPayment"]>,
	preset?: GraphQLTypes["VatRatePreset"] | undefined,
	paginateChannelDeliveries: GraphQLTypes["ChannelDeliveryConnection"],
	paginateChannelPayments: GraphQLTypes["ChannelPaymentConnection"]
};
	["VatRateMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	ratePermille?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	channelDeliveries?: GraphQLTypes["FieldMeta"] | undefined,
	channelPayments?: GraphQLTypes["FieldMeta"] | undefined,
	preset?: GraphQLTypes["FieldMeta"] | undefined
};
	["ChannelDelivery"]: {
		_meta?: GraphQLTypes["ChannelDeliveryMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	priceCents: number,
	channel?: GraphQLTypes["Channel"] | undefined,
	method?: GraphQLTypes["DeliveryMethod"] | undefined,
	vatRate?: GraphQLTypes["VatRate"] | undefined,
	defaultVisible: boolean
};
	["ChannelDeliveryMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	priceCents?: GraphQLTypes["FieldMeta"] | undefined,
	channel?: GraphQLTypes["FieldMeta"] | undefined,
	method?: GraphQLTypes["FieldMeta"] | undefined,
	vatRate?: GraphQLTypes["FieldMeta"] | undefined,
	defaultVisible?: GraphQLTypes["FieldMeta"] | undefined
};
	["Channel"]: {
		_meta?: GraphQLTypes["ChannelMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	disabled: boolean,
	payments: Array<GraphQLTypes["ChannelPayment"]>,
	deliveries: Array<GraphQLTypes["ChannelDelivery"]>,
	pointOfSales: Array<GraphQLTypes["PointOfSale"]>,
	carts: Array<GraphQLTypes["Cart"]>,
	customers: Array<GraphQLTypes["Customer"]>,
	code?: GraphQLTypes["ChannelCode"] | undefined,
	addTagsOnRegistration: Array<GraphQLTypes["Tag"]>,
	publicTags: Array<GraphQLTypes["Tag"]>,
	venue?: GraphQLTypes["Venue"] | undefined,
	cartsByItems?: GraphQLTypes["Cart"] | undefined,
	cartsByOrder?: GraphQLTypes["Cart"] | undefined,
	cartsByPriceLines?: GraphQLTypes["Cart"] | undefined,
	cartsBySummary?: GraphQLTypes["Cart"] | undefined,
	paginatePayments: GraphQLTypes["ChannelPaymentConnection"],
	paginateDeliveries: GraphQLTypes["ChannelDeliveryConnection"],
	paginatePointOfSales: GraphQLTypes["PointOfSaleConnection"],
	paginateCarts: GraphQLTypes["CartConnection"],
	paginateCustomers: GraphQLTypes["CustomerConnection"],
	paginateAddTagsOnRegistration: GraphQLTypes["TagConnection"],
	paginatePublicTags: GraphQLTypes["TagConnection"]
};
	["ChannelMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	disabled?: GraphQLTypes["FieldMeta"] | undefined,
	payments?: GraphQLTypes["FieldMeta"] | undefined,
	deliveries?: GraphQLTypes["FieldMeta"] | undefined,
	pointOfSales?: GraphQLTypes["FieldMeta"] | undefined,
	carts?: GraphQLTypes["FieldMeta"] | undefined,
	customers?: GraphQLTypes["FieldMeta"] | undefined,
	code?: GraphQLTypes["FieldMeta"] | undefined,
	addTagsOnRegistration?: GraphQLTypes["FieldMeta"] | undefined,
	publicTags?: GraphQLTypes["FieldMeta"] | undefined,
	venue?: GraphQLTypes["FieldMeta"] | undefined
};
	["ChannelPayment"]: {
		_meta?: GraphQLTypes["ChannelPaymentMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	channel?: GraphQLTypes["Channel"] | undefined,
	method?: GraphQLTypes["PaymentMethod"] | undefined,
	vatRate?: GraphQLTypes["VatRate"] | undefined,
	requireBillingAddress?: boolean | undefined,
	provideReceipt?: boolean | undefined,
	requireBillingSubject?: boolean | undefined,
	allowOnlyForTags: Array<GraphQLTypes["Tag"]>,
	paginateAllowOnlyForTags: GraphQLTypes["TagConnection"]
};
	["ChannelPaymentMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	channel?: GraphQLTypes["FieldMeta"] | undefined,
	method?: GraphQLTypes["FieldMeta"] | undefined,
	vatRate?: GraphQLTypes["FieldMeta"] | undefined,
	requireBillingAddress?: GraphQLTypes["FieldMeta"] | undefined,
	provideReceipt?: GraphQLTypes["FieldMeta"] | undefined,
	requireBillingSubject?: GraphQLTypes["FieldMeta"] | undefined,
	allowOnlyForTags?: GraphQLTypes["FieldMeta"] | undefined
};
	["TagOrderBy"]: GraphQLTypes["TagOrderBy"];
	["TagConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TagEdge"]>
};
	["PageInfo"]: {
		totalCount: number
};
	["TagEdge"]: {
		node: GraphQLTypes["Tag"]
};
	["ChannelPaymentOrderBy"]: GraphQLTypes["ChannelPaymentOrderBy"];
	["ChannelOrderBy"]: GraphQLTypes["ChannelOrderBy"];
	["VenueOrderBy"]: GraphQLTypes["VenueOrderBy"];
	["DeadlineTemplateOrderBy"]: GraphQLTypes["DeadlineTemplateOrderBy"];
	["VatRateOrderBy"]: GraphQLTypes["VatRateOrderBy"];
	["ChannelDeliveryOrderBy"]: GraphQLTypes["ChannelDeliveryOrderBy"];
	["PointOfSale"]: {
		_meta?: GraphQLTypes["PointOfSaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name?: string | undefined,
	code: string,
	channels: Array<GraphQLTypes["Channel"]>,
	permissions?: GraphQLTypes["PointOfSalePermissions"] | undefined,
	tenantPersonId?: GraphQLTypes["UUID"] | undefined,
	paginateChannels: GraphQLTypes["ChannelConnection"]
};
	["PointOfSaleMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	code?: GraphQLTypes["FieldMeta"] | undefined,
	channels?: GraphQLTypes["FieldMeta"] | undefined,
	permissions?: GraphQLTypes["FieldMeta"] | undefined,
	tenantPersonId?: GraphQLTypes["FieldMeta"] | undefined
};
	["PointOfSalePermissions"]: {
		_meta?: GraphQLTypes["PointOfSalePermissionsMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	canPlaceOrder?: boolean | undefined,
	pointOfSale?: GraphQLTypes["PointOfSale"] | undefined
};
	["PointOfSalePermissionsMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	canPlaceOrder?: GraphQLTypes["FieldMeta"] | undefined,
	pointOfSale?: GraphQLTypes["FieldMeta"] | undefined
};
	["ChannelConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ChannelEdge"]>
};
	["ChannelEdge"]: {
		node: GraphQLTypes["Channel"]
};
	["PointOfSaleOrderBy"]: GraphQLTypes["PointOfSaleOrderBy"];
	["PointOfSalePermissionsOrderBy"]: GraphQLTypes["PointOfSalePermissionsOrderBy"];
	["Cart"]: {
		_meta?: GraphQLTypes["CartMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	confirmedAt?: GraphQLTypes["DateTime"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	items: Array<GraphQLTypes["CartItem"]>,
	handle?: string | undefined,
	state: GraphQLTypes["CartState"],
	createdAt: GraphQLTypes["DateTime"],
	channel?: GraphQLTypes["Channel"] | undefined,
	order?: GraphQLTypes["Order"] | undefined,
	customer?: GraphQLTypes["Customer"] | undefined,
	deliveryAddress?: GraphQLTypes["Address"] | undefined,
	billingAddress?: GraphQLTypes["Address"] | undefined,
	deliveryOption?: string | undefined,
	paymentOption?: string | undefined,
	delivery?: GraphQLTypes["ChannelDelivery"] | undefined,
	payment?: GraphQLTypes["ChannelPayment"] | undefined,
	billingSubject?: GraphQLTypes["BillingSubject"] | undefined,
	priceLines: Array<GraphQLTypes["CartPriceLine"]>,
	summary?: GraphQLTypes["CartSummary"] | undefined,
	itemsByProduct?: GraphQLTypes["CartItem"] | undefined,
	paginateItems: GraphQLTypes["CartItemConnection"],
	paginatePriceLines: GraphQLTypes["CartPriceLineConnection"]
};
	["CartMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	confirmedAt?: GraphQLTypes["FieldMeta"] | undefined,
	deletedAt?: GraphQLTypes["FieldMeta"] | undefined,
	note?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined,
	handle?: GraphQLTypes["FieldMeta"] | undefined,
	state?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	channel?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryAddress?: GraphQLTypes["FieldMeta"] | undefined,
	billingAddress?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryOption?: GraphQLTypes["FieldMeta"] | undefined,
	paymentOption?: GraphQLTypes["FieldMeta"] | undefined,
	delivery?: GraphQLTypes["FieldMeta"] | undefined,
	payment?: GraphQLTypes["FieldMeta"] | undefined,
	billingSubject?: GraphQLTypes["FieldMeta"] | undefined,
	priceLines?: GraphQLTypes["FieldMeta"] | undefined,
	summary?: GraphQLTypes["FieldMeta"] | undefined
};
	["CartItem"]: {
		_meta?: GraphQLTypes["CartItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	quantity: number,
	cart?: GraphQLTypes["Cart"] | undefined,
	product?: GraphQLTypes["Product"] | undefined,
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	fulfillmentNote?: string | undefined,
	fulfillmentNotes: Array<GraphQLTypes["FulfillmentNote"]>,
	paginateFulfillmentNotes: GraphQLTypes["FulfillmentNoteConnection"]
};
	["CartItemMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	quantity?: GraphQLTypes["FieldMeta"] | undefined,
	cart?: GraphQLTypes["FieldMeta"] | undefined,
	product?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	updatedAt?: GraphQLTypes["FieldMeta"] | undefined,
	fulfillmentNote?: GraphQLTypes["FieldMeta"] | undefined,
	fulfillmentNotes?: GraphQLTypes["FieldMeta"] | undefined
};
	["FulfillmentNote"]: {
		_meta?: GraphQLTypes["FulfillmentNoteMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	note: string,
	products: Array<GraphQLTypes["Product"]>,
	tags: Array<GraphQLTypes["Tag"]>,
	venues: Array<GraphQLTypes["Venue"]>,
	cartItems: Array<GraphQLTypes["CartItem"]>,
	orderItems: Array<GraphQLTypes["OrderItem"]>,
	orders: Array<GraphQLTypes["Order"]>,
	highlight: boolean,
	createdAt: GraphQLTypes["DateTime"],
	emoji?: string | undefined,
	paginateProducts: GraphQLTypes["ProductConnection"],
	paginateTags: GraphQLTypes["TagConnection"],
	paginateVenues: GraphQLTypes["VenueConnection"],
	paginateCartItems: GraphQLTypes["CartItemConnection"],
	paginateOrderItems: GraphQLTypes["OrderItemConnection"],
	paginateOrders: GraphQLTypes["OrderConnection"]
};
	["FulfillmentNoteMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	note?: GraphQLTypes["FieldMeta"] | undefined,
	products?: GraphQLTypes["FieldMeta"] | undefined,
	tags?: GraphQLTypes["FieldMeta"] | undefined,
	venues?: GraphQLTypes["FieldMeta"] | undefined,
	cartItems?: GraphQLTypes["FieldMeta"] | undefined,
	orderItems?: GraphQLTypes["FieldMeta"] | undefined,
	orders?: GraphQLTypes["FieldMeta"] | undefined,
	highlight?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	emoji?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductOrderBy"]: GraphQLTypes["ProductOrderBy"];
	["ProductPackingOrderBy"]: GraphQLTypes["ProductPackingOrderBy"];
	["ProductRecipeOrderBy"]: GraphQLTypes["ProductRecipeOrderBy"];
	["FreshingContainerOrderBy"]: GraphQLTypes["FreshingContainerOrderBy"];
	["WorkspaceOrderBy"]: GraphQLTypes["WorkspaceOrderBy"];
	["WeekHoursOrderBy"]: GraphQLTypes["WeekHoursOrderBy"];
	["VirtualProductOrderBy"]: GraphQLTypes["VirtualProductOrderBy"];
	["NutritionFactsOrderBy"]: GraphQLTypes["NutritionFactsOrderBy"];
	["ProductMetadataOrderBy"]: GraphQLTypes["ProductMetadataOrderBy"];
	["PageOrderBy"]: GraphQLTypes["PageOrderBy"];
	["Venue"]: {
		_meta?: GraphQLTypes["VenueMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	deadlineTemplate?: GraphQLTypes["DeadlineTemplate"] | undefined,
	timetableDays: Array<GraphQLTypes["TimetableDay"]>,
	timetableTemplates: Array<GraphQLTypes["TimetableTemplate"]>,
	staffMembers: Array<GraphQLTypes["Staff"]>,
	employeeRoles: Array<GraphQLTypes["VenueEmployeeRole"]>,
	pointOfSaleApplicationDevices: Array<GraphQLTypes["PointOfSaleApplicationDevice"]>,
	pointOfSaleTerminals: Array<GraphQLTypes["PointOfSaleTerminal"]>,
	pointOfSalePrinters: Array<GraphQLTypes["PointOfSalePrinter"]>,
	orders: Array<GraphQLTypes["Order"]>,
	fulfillmentNotes: Array<GraphQLTypes["FulfillmentNote"]>,
	areas: Array<GraphQLTypes["Area"]>,
	enabledUnassignReasons: Array<GraphQLTypes["UnassignReason"]>,
	categories: Array<GraphQLTypes["PointOfSaleCategory"]>,
	channels: Array<GraphQLTypes["Channel"]>,
	address?: string | undefined,
	pointOfSalePngBase64ReceiptLogo?: string | undefined,
	pointOfSaleInitialView: GraphQLTypes["PointOfSaleInitialView"],
	pointOfSalePreferPrintReceipt: boolean,
	timetableDaysByDate?: GraphQLTypes["TimetableDay"] | undefined,
	timetableDaysByShiftGroups?: GraphQLTypes["TimetableDay"] | undefined,
	timetableDaysByNotes?: GraphQLTypes["TimetableDay"] | undefined,
	timetableDaysByMeta?: GraphQLTypes["TimetableDay"] | undefined,
	timetableTemplatesByStaffOptions?: GraphQLTypes["TimetableTemplate"] | undefined,
	employeeRolesByRole?: GraphQLTypes["VenueEmployeeRole"] | undefined,
	employeeRolesByEmployeePrivileges?: GraphQLTypes["VenueEmployeeRole"] | undefined,
	pointOfSaleApplicationDevicesByIdentifier?: GraphQLTypes["PointOfSaleApplicationDevice"] | undefined,
	pointOfSaleTerminalsByApplicationDevices?: GraphQLTypes["PointOfSaleTerminal"] | undefined,
	pointOfSalePrintersByApplicationDevicesReceipt?: GraphQLTypes["PointOfSalePrinter"] | undefined,
	ordersBySeq?: GraphQLTypes["Order"] | undefined,
	ordersByDoubleshotLegacyId?: GraphQLTypes["Order"] | undefined,
	ordersByDoubleShotLegacyNumber?: GraphQLTypes["Order"] | undefined,
	ordersByDiscounts?: GraphQLTypes["Order"] | undefined,
	ordersByDelivery?: GraphQLTypes["Order"] | undefined,
	ordersByItems?: GraphQLTypes["Order"] | undefined,
	ordersByCart?: GraphQLTypes["Order"] | undefined,
	ordersByEvents?: GraphQLTypes["Order"] | undefined,
	ordersByPriceLines?: GraphQLTypes["Order"] | undefined,
	ordersByPayments?: GraphQLTypes["Order"] | undefined,
	ordersBySummary?: GraphQLTypes["Order"] | undefined,
	ordersByGratuity?: GraphQLTypes["Order"] | undefined,
	areasByTables?: GraphQLTypes["Area"] | undefined,
	areasByLines?: GraphQLTypes["Area"] | undefined,
	categoriesBySlug?: GraphQLTypes["PointOfSaleCategory"] | undefined,
	categoriesByLocales?: GraphQLTypes["PointOfSaleCategory"] | undefined,
	categoriesByProducts?: GraphQLTypes["PointOfSaleCategory"] | undefined,
	channelsByCode?: GraphQLTypes["Channel"] | undefined,
	channelsByPayments?: GraphQLTypes["Channel"] | undefined,
	channelsByDeliveries?: GraphQLTypes["Channel"] | undefined,
	channelsByCarts?: GraphQLTypes["Channel"] | undefined,
	paginateTimetableDays: GraphQLTypes["TimetableDayConnection"],
	paginateTimetableTemplates: GraphQLTypes["TimetableTemplateConnection"],
	paginateStaffMembers: GraphQLTypes["StaffConnection"],
	paginateEmployeeRoles: GraphQLTypes["VenueEmployeeRoleConnection"],
	paginatePointOfSaleApplicationDevices: GraphQLTypes["PointOfSaleApplicationDeviceConnection"],
	paginatePointOfSaleTerminals: GraphQLTypes["PointOfSaleTerminalConnection"],
	paginatePointOfSalePrinters: GraphQLTypes["PointOfSalePrinterConnection"],
	paginateOrders: GraphQLTypes["OrderConnection"],
	paginateFulfillmentNotes: GraphQLTypes["FulfillmentNoteConnection"],
	paginateAreas: GraphQLTypes["AreaConnection"],
	paginateEnabledUnassignReasons: GraphQLTypes["UnassignReasonConnection"],
	paginateCategories: GraphQLTypes["PointOfSaleCategoryConnection"],
	paginateChannels: GraphQLTypes["ChannelConnection"]
};
	["VenueMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	deadlineTemplate?: GraphQLTypes["FieldMeta"] | undefined,
	timetableDays?: GraphQLTypes["FieldMeta"] | undefined,
	timetableTemplates?: GraphQLTypes["FieldMeta"] | undefined,
	staffMembers?: GraphQLTypes["FieldMeta"] | undefined,
	employeeRoles?: GraphQLTypes["FieldMeta"] | undefined,
	pointOfSaleApplicationDevices?: GraphQLTypes["FieldMeta"] | undefined,
	pointOfSaleTerminals?: GraphQLTypes["FieldMeta"] | undefined,
	pointOfSalePrinters?: GraphQLTypes["FieldMeta"] | undefined,
	orders?: GraphQLTypes["FieldMeta"] | undefined,
	fulfillmentNotes?: GraphQLTypes["FieldMeta"] | undefined,
	areas?: GraphQLTypes["FieldMeta"] | undefined,
	enabledUnassignReasons?: GraphQLTypes["FieldMeta"] | undefined,
	categories?: GraphQLTypes["FieldMeta"] | undefined,
	channels?: GraphQLTypes["FieldMeta"] | undefined,
	address?: GraphQLTypes["FieldMeta"] | undefined,
	pointOfSalePngBase64ReceiptLogo?: GraphQLTypes["FieldMeta"] | undefined,
	pointOfSaleInitialView?: GraphQLTypes["FieldMeta"] | undefined,
	pointOfSalePreferPrintReceipt?: GraphQLTypes["FieldMeta"] | undefined
};
	["DeadlineTemplate"]: {
		_meta?: GraphQLTypes["DeadlineTemplateMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	startDate: GraphQLTypes["Date"],
	period: number,
	cutoff?: number | undefined,
	closed?: boolean | undefined,
	venue?: GraphQLTypes["Venue"] | undefined
};
	["DeadlineTemplateMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	startDate?: GraphQLTypes["FieldMeta"] | undefined,
	period?: GraphQLTypes["FieldMeta"] | undefined,
	cutoff?: GraphQLTypes["FieldMeta"] | undefined,
	closed?: GraphQLTypes["FieldMeta"] | undefined,
	venue?: GraphQLTypes["FieldMeta"] | undefined
};
	["TimetableDay"]: {
		_meta?: GraphQLTypes["TimetableDayMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	date: GraphQLTypes["Date"],
	type?: GraphQLTypes["TimetableDayType"] | undefined,
	shiftGroups: Array<GraphQLTypes["TimetableShiftGroup"]>,
	tipsCents?: number | undefined,
	notes: Array<GraphQLTypes["TimetableDayNote"]>,
	venue?: GraphQLTypes["Venue"] | undefined,
	meta?: GraphQLTypes["TimetableDayMetadata"] | undefined,
	shiftGroupsByShifts?: GraphQLTypes["TimetableShiftGroup"] | undefined,
	shiftGroupsByQueue?: GraphQLTypes["TimetableShiftGroup"] | undefined,
	paginateShiftGroups: GraphQLTypes["TimetableShiftGroupConnection"],
	paginateNotes: GraphQLTypes["TimetableDayNoteConnection"]
};
	["TimetableDayMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	date?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	shiftGroups?: GraphQLTypes["FieldMeta"] | undefined,
	tipsCents?: GraphQLTypes["FieldMeta"] | undefined,
	notes?: GraphQLTypes["FieldMeta"] | undefined,
	venue?: GraphQLTypes["FieldMeta"] | undefined,
	meta?: GraphQLTypes["FieldMeta"] | undefined
};
	["TimetableShiftGroup"]: {
		_meta?: GraphQLTypes["TimetableShiftGroupMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	shifts: Array<GraphQLTypes["TimetableShift"]>,
	day?: GraphQLTypes["TimetableDay"] | undefined,
	type?: GraphQLTypes["TimetableEmployeeRole"] | undefined,
	position?: GraphQLTypes["TimetableShiftPosition"] | undefined,
	queue?: GraphQLTypes["EmployeeQueue"] | undefined,
	generatedByTemplate?: GraphQLTypes["TimetableTemplate"] | undefined,
	shiftsByQueueItem?: GraphQLTypes["TimetableShift"] | undefined,
	shiftsBySwapInfo?: GraphQLTypes["TimetableShift"] | undefined,
	paginateShifts: GraphQLTypes["TimetableShiftConnection"]
};
	["TimetableShiftGroupMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	shifts?: GraphQLTypes["FieldMeta"] | undefined,
	day?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	position?: GraphQLTypes["FieldMeta"] | undefined,
	queue?: GraphQLTypes["FieldMeta"] | undefined,
	generatedByTemplate?: GraphQLTypes["FieldMeta"] | undefined
};
	["TimetableShift"]: {
		_meta?: GraphQLTypes["TimetableShiftMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	locked: boolean,
	order: number,
	assigned?: GraphQLTypes["Date"] | undefined,
	group?: GraphQLTypes["TimetableShiftGroup"] | undefined,
	shiftsProfile?: GraphQLTypes["ShiftsProfile"] | undefined,
	queueItem?: GraphQLTypes["EmployeeQueueItem"] | undefined,
	swapInfo?: GraphQLTypes["TimetableShiftSwapInfo"] | undefined,
	isOvertime: boolean
};
	["TimetableShiftMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	locked?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	assigned?: GraphQLTypes["FieldMeta"] | undefined,
	group?: GraphQLTypes["FieldMeta"] | undefined,
	shiftsProfile?: GraphQLTypes["FieldMeta"] | undefined,
	queueItem?: GraphQLTypes["FieldMeta"] | undefined,
	swapInfo?: GraphQLTypes["FieldMeta"] | undefined,
	isOvertime?: GraphQLTypes["FieldMeta"] | undefined
};
	["ShiftsProfile"]: {
		_meta?: GraphQLTypes["ShiftsProfileMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	queueItems: Array<GraphQLTypes["EmployeeQueueItem"]>,
	staff?: GraphQLTypes["Staff"] | undefined,
	roles: Array<GraphQLTypes["TimetableEmployeeRole"]>,
	shifts: Array<GraphQLTypes["TimetableShift"]>,
	allowSelfUnassigning?: boolean | undefined,
	queueItemsByQueue?: GraphQLTypes["EmployeeQueueItem"] | undefined,
	queueItemsByShift?: GraphQLTypes["EmployeeQueueItem"] | undefined,
	queueItemsByUnassignInfo?: GraphQLTypes["EmployeeQueueItem"] | undefined,
	queueItemsByMeta?: GraphQLTypes["EmployeeQueueItem"] | undefined,
	shiftsByQueueItem?: GraphQLTypes["TimetableShift"] | undefined,
	shiftsBySwapInfo?: GraphQLTypes["TimetableShift"] | undefined,
	paginateQueueItems: GraphQLTypes["EmployeeQueueItemConnection"],
	paginateRoles: GraphQLTypes["TimetableEmployeeRoleConnection"],
	paginateShifts: GraphQLTypes["TimetableShiftConnection"]
};
	["ShiftsProfileMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	queueItems?: GraphQLTypes["FieldMeta"] | undefined,
	staff?: GraphQLTypes["FieldMeta"] | undefined,
	roles?: GraphQLTypes["FieldMeta"] | undefined,
	shifts?: GraphQLTypes["FieldMeta"] | undefined,
	allowSelfUnassigning?: GraphQLTypes["FieldMeta"] | undefined
};
	["EmployeeQueueItem"]: {
		_meta?: GraphQLTypes["EmployeeQueueItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	start?: string | undefined,
	end?: string | undefined,
	queue?: GraphQLTypes["EmployeeQueue"] | undefined,
	shiftsProfile?: GraphQLTypes["ShiftsProfile"] | undefined,
	shift?: GraphQLTypes["TimetableShift"] | undefined,
	unassignInfo?: GraphQLTypes["UnassignedShiftInfo"] | undefined,
	meta?: GraphQLTypes["EmployeeQueueItemMetadata"] | undefined
};
	["EmployeeQueueItemMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	start?: GraphQLTypes["FieldMeta"] | undefined,
	end?: GraphQLTypes["FieldMeta"] | undefined,
	queue?: GraphQLTypes["FieldMeta"] | undefined,
	shiftsProfile?: GraphQLTypes["FieldMeta"] | undefined,
	shift?: GraphQLTypes["FieldMeta"] | undefined,
	unassignInfo?: GraphQLTypes["FieldMeta"] | undefined,
	meta?: GraphQLTypes["FieldMeta"] | undefined
};
	["EmployeeQueue"]: {
		_meta?: GraphQLTypes["EmployeeQueueMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	shiftGroup?: GraphQLTypes["TimetableShiftGroup"] | undefined,
	items: Array<GraphQLTypes["EmployeeQueueItem"]>,
	contemberBugFix?: boolean | undefined,
	itemsByShiftsProfile?: GraphQLTypes["EmployeeQueueItem"] | undefined,
	itemsByShift?: GraphQLTypes["EmployeeQueueItem"] | undefined,
	itemsByUnassignInfo?: GraphQLTypes["EmployeeQueueItem"] | undefined,
	itemsByMeta?: GraphQLTypes["EmployeeQueueItem"] | undefined,
	paginateItems: GraphQLTypes["EmployeeQueueItemConnection"]
};
	["EmployeeQueueMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	shiftGroup?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined,
	contemberBugFix?: GraphQLTypes["FieldMeta"] | undefined
};
	["EmployeeQueueItemOrderBy"]: GraphQLTypes["EmployeeQueueItemOrderBy"];
	["EmployeeQueueOrderBy"]: GraphQLTypes["EmployeeQueueOrderBy"];
	["TimetableShiftGroupOrderBy"]: GraphQLTypes["TimetableShiftGroupOrderBy"];
	["TimetableDayOrderBy"]: GraphQLTypes["TimetableDayOrderBy"];
	["TimetableDayMetadataOrderBy"]: GraphQLTypes["TimetableDayMetadataOrderBy"];
	["TimetableEmployeeRoleOrderBy"]: GraphQLTypes["TimetableEmployeeRoleOrderBy"];
	["TimetableShiftPositionOrderBy"]: GraphQLTypes["TimetableShiftPositionOrderBy"];
	["TimetableTemplateOrderBy"]: GraphQLTypes["TimetableTemplateOrderBy"];
	["TimetableShiftOrderBy"]: GraphQLTypes["TimetableShiftOrderBy"];
	["TimetableShiftSwapInfoOrderBy"]: GraphQLTypes["TimetableShiftSwapInfoOrderBy"];
	["UnassignedShiftInfoOrderBy"]: GraphQLTypes["UnassignedShiftInfoOrderBy"];
	["UnassignReasonOrderBy"]: GraphQLTypes["UnassignReasonOrderBy"];
	["EmployeeQueueItemMetadataOrderBy"]: GraphQLTypes["EmployeeQueueItemMetadataOrderBy"];
	["EmployeeQueueItemsByShiftsProfileUniqueWhere"]: GraphQLTypes["EmployeeQueueItemsByShiftsProfileUniqueWhere"];
	["ShiftsProfileUniqueWhere"]: GraphQLTypes["ShiftsProfileUniqueWhere"];
	["EmployeeQueueItemUniqueWhere"]: GraphQLTypes["EmployeeQueueItemUniqueWhere"];
	["EmployeeQueueUniqueWhere"]: GraphQLTypes["EmployeeQueueUniqueWhere"];
	["TimetableShiftGroupUniqueWhere"]: GraphQLTypes["TimetableShiftGroupUniqueWhere"];
	["TimetableShiftUniqueWhere"]: GraphQLTypes["TimetableShiftUniqueWhere"];
	["TimetableShiftSwapInfoUniqueWhere"]: GraphQLTypes["TimetableShiftSwapInfoUniqueWhere"];
	["UnassignedShiftInfoUniqueWhere"]: GraphQLTypes["UnassignedShiftInfoUniqueWhere"];
	["EmployeeQueueItemMetadataUniqueWhere"]: GraphQLTypes["EmployeeQueueItemMetadataUniqueWhere"];
	["StaffUniqueWhere"]: GraphQLTypes["StaffUniqueWhere"];
	["BartenderUniqueWhere"]: GraphQLTypes["BartenderUniqueWhere"];
	["CourierUniqueWhere"]: GraphQLTypes["CourierUniqueWhere"];
	["DeliveryRouteUniqueWhere"]: GraphQLTypes["DeliveryRouteUniqueWhere"];
	["DeliveryWaypointUniqueWhere"]: GraphQLTypes["DeliveryWaypointUniqueWhere"];
	["OrderDeliveryUniqueWhere"]: GraphQLTypes["OrderDeliveryUniqueWhere"];
	["OrderUniqueWhere"]: GraphQLTypes["OrderUniqueWhere"];
	["OrderDiscountUniqueWhere"]: GraphQLTypes["OrderDiscountUniqueWhere"];
	["CustomerCreditTransactionUniqueWhere"]: GraphQLTypes["CustomerCreditTransactionUniqueWhere"];
	["VirtualProductEffectUniqueWhere"]: GraphQLTypes["VirtualProductEffectUniqueWhere"];
	["VoucherUniqueWhere"]: GraphQLTypes["VoucherUniqueWhere"];
	["VoucherRedemptionUniqueWhere"]: GraphQLTypes["VoucherRedemptionUniqueWhere"];
	["CustomerCreditUniqueWhere"]: GraphQLTypes["CustomerCreditUniqueWhere"];
	["OrderItemUniqueWhere"]: GraphQLTypes["OrderItemUniqueWhere"];
	["CartUniqueWhere"]: GraphQLTypes["CartUniqueWhere"];
	["CartItemUniqueWhere"]: GraphQLTypes["CartItemUniqueWhere"];
	["ProductUniqueWhere"]: GraphQLTypes["ProductUniqueWhere"];
	["ProductStockUniqueWhere"]: GraphQLTypes["ProductStockUniqueWhere"];
	["StoreUniqueWhere"]: GraphQLTypes["StoreUniqueWhere"];
	["ProductGroupPriceUniqueWhere"]: GraphQLTypes["ProductGroupPriceUniqueWhere"];
	["CustomerGroupUniqueWhere"]: GraphQLTypes["CustomerGroupUniqueWhere"];
	["CustomerUniqueWhere"]: GraphQLTypes["CustomerUniqueWhere"];
	["AddressUniqueWhere"]: GraphQLTypes["AddressUniqueWhere"];
	["AddressMetadataUniqueWhere"]: GraphQLTypes["AddressMetadataUniqueWhere"];
	["GpsUniqueWhere"]: GraphQLTypes["GpsUniqueWhere"];
	["InvoiceUniqueWhere"]: GraphQLTypes["InvoiceUniqueWhere"];
	["OrderPaymentUniqueWhere"]: GraphQLTypes["OrderPaymentUniqueWhere"];
	["OrderEventUniqueWhere"]: GraphQLTypes["OrderEventUniqueWhere"];
	["OrderPaymentMetadataUniqueWhere"]: GraphQLTypes["OrderPaymentMetadataUniqueWhere"];
	["CustomerPaymentMethodUniqueWhere"]: GraphQLTypes["CustomerPaymentMethodUniqueWhere"];
	["CustomerPermissionsUniqueWhere"]: GraphQLTypes["CustomerPermissionsUniqueWhere"];
	["CustomerNameUniqueWhere"]: GraphQLTypes["CustomerNameUniqueWhere"];
	["CustomerIngredientRatingUniqueWhere"]: GraphQLTypes["CustomerIngredientRatingUniqueWhere"];
	["ProductIngredientUniqueWhere"]: GraphQLTypes["ProductIngredientUniqueWhere"];
	["ProductIngredientLocaleUniqueWhere"]: GraphQLTypes["ProductIngredientLocaleUniqueWhere"];
	["LocaleUniqueWhere"]: GraphQLTypes["LocaleUniqueWhere"];
	["BusinessCategoryLocaleUniqueWhere"]: GraphQLTypes["BusinessCategoryLocaleUniqueWhere"];
	["BusinessCategoryUniqueWhere"]: GraphQLTypes["BusinessCategoryUniqueWhere"];
	["BusinessCustomerUniqueWhere"]: GraphQLTypes["BusinessCustomerUniqueWhere"];
	["BusinessServiceEventUniqueWhere"]: GraphQLTypes["BusinessServiceEventUniqueWhere"];
	["DoubleshotCoffeeEquipmentUniqueWhere"]: GraphQLTypes["DoubleshotCoffeeEquipmentUniqueWhere"];
	["ProductListUniqueWhere"]: GraphQLTypes["ProductListUniqueWhere"];
	["ProductListItemUniqueWhere"]: GraphQLTypes["ProductListItemUniqueWhere"];
	["ProductCategoryListUniqueWhere"]: GraphQLTypes["ProductCategoryListUniqueWhere"];
	["ProductCategoryListItemUniqueWhere"]: GraphQLTypes["ProductCategoryListItemUniqueWhere"];
	["ProductCategoryListLocaleUniqueWhere"]: GraphQLTypes["ProductCategoryListLocaleUniqueWhere"];
	["OrderRecurrenceLocaleUniqueWhere"]: GraphQLTypes["OrderRecurrenceLocaleUniqueWhere"];
	["OrderRecurrenceUniqueWhere"]: GraphQLTypes["OrderRecurrenceUniqueWhere"];
	["BlogLocaleUniqueWhere"]: GraphQLTypes["BlogLocaleUniqueWhere"];
	["BlogUniqueWhere"]: GraphQLTypes["BlogUniqueWhere"];
	["BlogPostLocaleUniqueWhere"]: GraphQLTypes["BlogPostLocaleUniqueWhere"];
	["BlogPostUniqueWhere"]: GraphQLTypes["BlogPostUniqueWhere"];
	["CoverUniqueWhere"]: GraphQLTypes["CoverUniqueWhere"];
	["ContentUniqueWhere"]: GraphQLTypes["ContentUniqueWhere"];
	["ContentBlockUniqueWhere"]: GraphQLTypes["ContentBlockUniqueWhere"];
	["ContentReferenceUniqueWhere"]: GraphQLTypes["ContentReferenceUniqueWhere"];
	["ProductBannerListUniqueWhere"]: GraphQLTypes["ProductBannerListUniqueWhere"];
	["ProductBannerItemUniqueWhere"]: GraphQLTypes["ProductBannerItemUniqueWhere"];
	["DeliveryRegionsUniqueWhere"]: GraphQLTypes["DeliveryRegionsUniqueWhere"];
	["DeliveryRegionsItemUniqueWhere"]: GraphQLTypes["DeliveryRegionsItemUniqueWhere"];
	["ImageUniqueWhere"]: GraphQLTypes["ImageUniqueWhere"];
	["TextListUniqueWhere"]: GraphQLTypes["TextListUniqueWhere"];
	["TextItemUniqueWhere"]: GraphQLTypes["TextItemUniqueWhere"];
	["ImageListUniqueWhere"]: GraphQLTypes["ImageListUniqueWhere"];
	["ImageListItemUniqueWhere"]: GraphQLTypes["ImageListItemUniqueWhere"];
	["LinkableUniqueWhere"]: GraphQLTypes["LinkableUniqueWhere"];
	["PageLocaleUniqueWhere"]: GraphQLTypes["PageLocaleUniqueWhere"];
	["PageUniqueWhere"]: GraphQLTypes["PageUniqueWhere"];
	["SeoUniqueWhere"]: GraphQLTypes["SeoUniqueWhere"];
	["WikiPageUniqueWhere"]: GraphQLTypes["WikiPageUniqueWhere"];
	["RedirectUniqueWhere"]: GraphQLTypes["RedirectUniqueWhere"];
	["TranslationCataloguesIdentifierUniqueWhere"]: GraphQLTypes["TranslationCataloguesIdentifierUniqueWhere"];
	["TranslationCatalogueUniqueWhere"]: GraphQLTypes["TranslationCatalogueUniqueWhere"];
	["TranslationDomainUniqueWhere"]: GraphQLTypes["TranslationDomainUniqueWhere"];
	["TranslationKeyUniqueWhere"]: GraphQLTypes["TranslationKeyUniqueWhere"];
	["TranslationValueUniqueWhere"]: GraphQLTypes["TranslationValueUniqueWhere"];
	["MenuLocaleUniqueWhere"]: GraphQLTypes["MenuLocaleUniqueWhere"];
	["SiteMenuUniqueWhere"]: GraphQLTypes["SiteMenuUniqueWhere"];
	["MenuItemUniqueWhere"]: GraphQLTypes["MenuItemUniqueWhere"];
	["MenuSubitemUniqueWhere"]: GraphQLTypes["MenuSubitemUniqueWhere"];
	["LinkListUniqueWhere"]: GraphQLTypes["LinkListUniqueWhere"];
	["LinkListItemUniqueWhere"]: GraphQLTypes["LinkListItemUniqueWhere"];
	["ProductIngredientCategoryLocaleUniqueWhere"]: GraphQLTypes["ProductIngredientCategoryLocaleUniqueWhere"];
	["ProductIngredientCategoryUniqueWhere"]: GraphQLTypes["ProductIngredientCategoryUniqueWhere"];
	["AllergenLocaleUniqueWhere"]: GraphQLTypes["AllergenLocaleUniqueWhere"];
	["AllergenUniqueWhere"]: GraphQLTypes["AllergenUniqueWhere"];
	["ProductPackingLocaleUniqueWhere"]: GraphQLTypes["ProductPackingLocaleUniqueWhere"];
	["ProductPackingUniqueWhere"]: GraphQLTypes["ProductPackingUniqueWhere"];
	["PreparedPackingQuantityUniqueWhere"]: GraphQLTypes["PreparedPackingQuantityUniqueWhere"];
	["ProductRecipeUniqueWhere"]: GraphQLTypes["ProductRecipeUniqueWhere"];
	["ProductIngredientItemUniqueWhere"]: GraphQLTypes["ProductIngredientItemUniqueWhere"];
	["ProductIngredientItemQuantityUniqueWhere"]: GraphQLTypes["ProductIngredientItemQuantityUniqueWhere"];
	["ProductRecipeLocaleUniqueWhere"]: GraphQLTypes["ProductRecipeLocaleUniqueWhere"];
	["NutritionFactsUniqueWhere"]: GraphQLTypes["NutritionFactsUniqueWhere"];
	["ProductLocaleUniqueWhere"]: GraphQLTypes["ProductLocaleUniqueWhere"];
	["PointOfSaleCategoryLocaleUniqueWhere"]: GraphQLTypes["PointOfSaleCategoryLocaleUniqueWhere"];
	["PointOfSaleCategoryUniqueWhere"]: GraphQLTypes["PointOfSaleCategoryUniqueWhere"];
	["PointOfSaleCategoryProductUniqueWhere"]: GraphQLTypes["PointOfSaleCategoryProductUniqueWhere"];
	["PointOfSaleCategoryProductLocaleUniqueWhere"]: GraphQLTypes["PointOfSaleCategoryProductLocaleUniqueWhere"];
	["DeliveryMethodLocaleUniqueWhere"]: GraphQLTypes["DeliveryMethodLocaleUniqueWhere"];
	["DeliveryMethodUniqueWhere"]: GraphQLTypes["DeliveryMethodUniqueWhere"];
	["ChannelDeliveryUniqueWhere"]: GraphQLTypes["ChannelDeliveryUniqueWhere"];
	["DeliveryTimelinePresetUniqueWhere"]: GraphQLTypes["DeliveryTimelinePresetUniqueWhere"];
	["IngredientSupplierLocaleUniqueWhere"]: GraphQLTypes["IngredientSupplierLocaleUniqueWhere"];
	["IngredientSupplierUniqueWhere"]: GraphQLTypes["IngredientSupplierUniqueWhere"];
	["IdentificationCodeLocaleUniqueWhere"]: GraphQLTypes["IdentificationCodeLocaleUniqueWhere"];
	["IdentificationCodeUniqueWhere"]: GraphQLTypes["IdentificationCodeUniqueWhere"];
	["IdentificationAttemptUniqueWhere"]: GraphQLTypes["IdentificationAttemptUniqueWhere"];
	["PointOfSaleApplicationDeviceUniqueWhere"]: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"];
	["DeviceIdentifierUniqueWhere"]: GraphQLTypes["DeviceIdentifierUniqueWhere"];
	["DeviceIdentifierMetadataUniqueWhere"]: GraphQLTypes["DeviceIdentifierMetadataUniqueWhere"];
	["PipelineStageLocaleUniqueWhere"]: GraphQLTypes["PipelineStageLocaleUniqueWhere"];
	["PipelineStageUniqueWhere"]: GraphQLTypes["PipelineStageUniqueWhere"];
	["PipelineStageItemUniqueWhere"]: GraphQLTypes["PipelineStageItemUniqueWhere"];
	["PipelineLeadUniqueWhere"]: GraphQLTypes["PipelineLeadUniqueWhere"];
	["LeadFormUniqueWhere"]: GraphQLTypes["LeadFormUniqueWhere"];
	["SubscriptionBoxLocaleUniqueWhere"]: GraphQLTypes["SubscriptionBoxLocaleUniqueWhere"];
	["SubscriptionBoxUniqueWhere"]: GraphQLTypes["SubscriptionBoxUniqueWhere"];
	["BusinessServiceLocaleUniqueWhere"]: GraphQLTypes["BusinessServiceLocaleUniqueWhere"];
	["BusinessServiceUniqueWhere"]: GraphQLTypes["BusinessServiceUniqueWhere"];
	["IngredientSupplierListUniqueWhere"]: GraphQLTypes["IngredientSupplierListUniqueWhere"];
	["IngredientSupplierItemUniqueWhere"]: GraphQLTypes["IngredientSupplierItemUniqueWhere"];
	["ApplicationShortcutListUniqueWhere"]: GraphQLTypes["ApplicationShortcutListUniqueWhere"];
	["ApplicationShortcutListItemUniqueWhere"]: GraphQLTypes["ApplicationShortcutListItemUniqueWhere"];
	["UserUniqueWhere"]: GraphQLTypes["UserUniqueWhere"];
	["UserDeviceUniqueWhere"]: GraphQLTypes["UserDeviceUniqueWhere"];
	["UserMetadataUniqueWhere"]: GraphQLTypes["UserMetadataUniqueWhere"];
	["UserRolesUniqueWhere"]: GraphQLTypes["UserRolesUniqueWhere"];
	["InvoicingPlanUniqueWhere"]: GraphQLTypes["InvoicingPlanUniqueWhere"];
	["InvoicingPresetUniqueWhere"]: GraphQLTypes["InvoicingPresetUniqueWhere"];
	["BillingSubjectUniqueWhere"]: GraphQLTypes["BillingSubjectUniqueWhere"];
	["ProductCustomerPriceUniqueWhere"]: GraphQLTypes["ProductCustomerPriceUniqueWhere"];
	["AnonymousSessionUniqueWhere"]: GraphQLTypes["AnonymousSessionUniqueWhere"];
	["CustomerSpendingUniqueWhere"]: GraphQLTypes["CustomerSpendingUniqueWhere"];
	["CustomerTabUniqueWhere"]: GraphQLTypes["CustomerTabUniqueWhere"];
	["CustomerTabItemUniqueWhere"]: GraphQLTypes["CustomerTabItemUniqueWhere"];
	["CustomerTabMetadataUniqueWhere"]: GraphQLTypes["CustomerTabMetadataUniqueWhere"];
	["CustomerMetadataUniqueWhere"]: GraphQLTypes["CustomerMetadataUniqueWhere"];
	["NestedProductCategoryProductUniqueWhere"]: GraphQLTypes["NestedProductCategoryProductUniqueWhere"];
	["VirtualProductUniqueWhere"]: GraphQLTypes["VirtualProductUniqueWhere"];
	["ProductMetadataUniqueWhere"]: GraphQLTypes["ProductMetadataUniqueWhere"];
	["ProductSalesDayUniqueWhere"]: GraphQLTypes["ProductSalesDayUniqueWhere"];
	["ProductSalesWeekUniqueWhere"]: GraphQLTypes["ProductSalesWeekUniqueWhere"];
	["ProductSalesMonthUniqueWhere"]: GraphQLTypes["ProductSalesMonthUniqueWhere"];
	["CartPriceLineUniqueWhere"]: GraphQLTypes["CartPriceLineUniqueWhere"];
	["CartSummaryUniqueWhere"]: GraphQLTypes["CartSummaryUniqueWhere"];
	["OrderPriceLineUniqueWhere"]: GraphQLTypes["OrderPriceLineUniqueWhere"];
	["OrderSummaryUniqueWhere"]: GraphQLTypes["OrderSummaryUniqueWhere"];
	["GratuityUniqueWhere"]: GraphQLTypes["GratuityUniqueWhere"];
	["LiftagoRideUniqueWhere"]: GraphQLTypes["LiftagoRideUniqueWhere"];
	["WoltDriveDeliveryUniqueWhere"]: GraphQLTypes["WoltDriveDeliveryUniqueWhere"];
	["CleanerUniqueWhere"]: GraphQLTypes["CleanerUniqueWhere"];
	["ShiftsManagerUniqueWhere"]: GraphQLTypes["ShiftsManagerUniqueWhere"];
	["BusinessToBusinessManagerUniqueWhere"]: GraphQLTypes["BusinessToBusinessManagerUniqueWhere"];
	["StocksManagerUniqueWhere"]: GraphQLTypes["StocksManagerUniqueWhere"];
	["CourierManagerUniqueWhere"]: GraphQLTypes["CourierManagerUniqueWhere"];
	["PickerUniqueWhere"]: GraphQLTypes["PickerUniqueWhere"];
	["RemunerationProfileUniqueWhere"]: GraphQLTypes["RemunerationProfileUniqueWhere"];
	["EmploymentInformationUniqueWhere"]: GraphQLTypes["EmploymentInformationUniqueWhere"];
	["CashierUniqueWhere"]: GraphQLTypes["CashierUniqueWhere"];
	["InternalBuyerUniqueWhere"]: GraphQLTypes["InternalBuyerUniqueWhere"];
	["SalesManagerUniqueWhere"]: GraphQLTypes["SalesManagerUniqueWhere"];
	["CashierManagerUniqueWhere"]: GraphQLTypes["CashierManagerUniqueWhere"];
	["EmployeeQueueItemsByShiftUniqueWhere"]: GraphQLTypes["EmployeeQueueItemsByShiftUniqueWhere"];
	["EmployeeQueueItemsByUnassignInfoUniqueWhere"]: GraphQLTypes["EmployeeQueueItemsByUnassignInfoUniqueWhere"];
	["EmployeeQueueItemsByMetaUniqueWhere"]: GraphQLTypes["EmployeeQueueItemsByMetaUniqueWhere"];
	["EmployeeQueueItemConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["EmployeeQueueItemEdge"]>
};
	["EmployeeQueueItemEdge"]: {
		node: GraphQLTypes["EmployeeQueueItem"]
};
	["UnassignedShiftInfo"]: {
		_meta?: GraphQLTypes["UnassignedShiftInfoMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	hoursMissed?: number | undefined,
	queueItem?: GraphQLTypes["EmployeeQueueItem"] | undefined,
	legacyReason?: GraphQLTypes["UnassignedInfoReason"] | undefined,
	reason?: GraphQLTypes["UnassignReason"] | undefined
};
	["UnassignedShiftInfoMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	hoursMissed?: GraphQLTypes["FieldMeta"] | undefined,
	queueItem?: GraphQLTypes["FieldMeta"] | undefined,
	legacyReason?: GraphQLTypes["FieldMeta"] | undefined,
	reason?: GraphQLTypes["FieldMeta"] | undefined
};
	["UnassignReason"]: {
		_meta?: GraphQLTypes["UnassignReasonMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	name: string,
	venues: Array<GraphQLTypes["Venue"]>,
	paginateVenues: GraphQLTypes["VenueConnection"]
};
	["UnassignReasonMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	venues?: GraphQLTypes["FieldMeta"] | undefined
};
	["VenueConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["VenueEdge"]>
};
	["VenueEdge"]: {
		node: GraphQLTypes["Venue"]
};
	["EmployeeQueueItemMetadata"]: {
		_meta?: GraphQLTypes["EmployeeQueueItemMetadataMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	totalMinutes: number,
	queueItem?: GraphQLTypes["EmployeeQueueItem"] | undefined,
	includeInTipsCalculation: boolean
};
	["EmployeeQueueItemMetadataMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	totalMinutes?: GraphQLTypes["FieldMeta"] | undefined,
	queueItem?: GraphQLTypes["FieldMeta"] | undefined,
	includeInTipsCalculation?: GraphQLTypes["FieldMeta"] | undefined
};
	["TimetableEmployeeRole"]: {
		_meta?: GraphQLTypes["TimetableEmployeeRoleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	shiftGroups: Array<GraphQLTypes["TimetableShiftGroup"]>,
	shiftsProfiles: Array<GraphQLTypes["ShiftsProfile"]>,
	shiftsManagers: Array<GraphQLTypes["ShiftsManager"]>,
	name: string,
	timetableTemplates: Array<GraphQLTypes["TimetableTemplate"]>,
	color: string,
	shiftGroupsByShifts?: GraphQLTypes["TimetableShiftGroup"] | undefined,
	shiftGroupsByQueue?: GraphQLTypes["TimetableShiftGroup"] | undefined,
	timetableTemplatesByStaffOptions?: GraphQLTypes["TimetableTemplate"] | undefined,
	paginateShiftGroups: GraphQLTypes["TimetableShiftGroupConnection"],
	paginateShiftsProfiles: GraphQLTypes["ShiftsProfileConnection"],
	paginateShiftsManagers: GraphQLTypes["ShiftsManagerConnection"],
	paginateTimetableTemplates: GraphQLTypes["TimetableTemplateConnection"]
};
	["TimetableEmployeeRoleMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	shiftGroups?: GraphQLTypes["FieldMeta"] | undefined,
	shiftsProfiles?: GraphQLTypes["FieldMeta"] | undefined,
	shiftsManagers?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	timetableTemplates?: GraphQLTypes["FieldMeta"] | undefined,
	color?: GraphQLTypes["FieldMeta"] | undefined
};
	["ShiftsManager"]: {
		_meta?: GraphQLTypes["ShiftsManagerMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	staff?: GraphQLTypes["Staff"] | undefined,
	managedRoles: Array<GraphQLTypes["TimetableEmployeeRole"]>,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	paginateManagedRoles: GraphQLTypes["TimetableEmployeeRoleConnection"]
};
	["ShiftsManagerMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	staff?: GraphQLTypes["FieldMeta"] | undefined,
	managedRoles?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined
};
	["TimetableEmployeeRoleConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TimetableEmployeeRoleEdge"]>
};
	["TimetableEmployeeRoleEdge"]: {
		node: GraphQLTypes["TimetableEmployeeRole"]
};
	["TimetableTemplate"]: {
		_meta?: GraphQLTypes["TimetableTemplateMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	startDate: GraphQLTypes["Date"],
	period?: number | undefined,
	slots?: number | undefined,
	position?: GraphQLTypes["TimetableShiftPosition"] | undefined,
	staffOptions: Array<GraphQLTypes["TimetableTemplateStaffOptions"]>,
	internalName?: string | undefined,
	venue?: GraphQLTypes["Venue"] | undefined,
	employeeRole?: GraphQLTypes["TimetableEmployeeRole"] | undefined,
	workdaysOnly?: boolean | undefined,
	monday: boolean,
	tuesday: boolean,
	wednesday: boolean,
	thursday: boolean,
	friday: boolean,
	saturday: boolean,
	sunday: boolean,
	type: GraphQLTypes["TemplateType"],
	paginateStaffOptions: GraphQLTypes["TimetableTemplateStaffOptionsConnection"]
};
	["TimetableTemplateMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	startDate?: GraphQLTypes["FieldMeta"] | undefined,
	period?: GraphQLTypes["FieldMeta"] | undefined,
	slots?: GraphQLTypes["FieldMeta"] | undefined,
	position?: GraphQLTypes["FieldMeta"] | undefined,
	staffOptions?: GraphQLTypes["FieldMeta"] | undefined,
	internalName?: GraphQLTypes["FieldMeta"] | undefined,
	venue?: GraphQLTypes["FieldMeta"] | undefined,
	employeeRole?: GraphQLTypes["FieldMeta"] | undefined,
	workdaysOnly?: GraphQLTypes["FieldMeta"] | undefined,
	monday?: GraphQLTypes["FieldMeta"] | undefined,
	tuesday?: GraphQLTypes["FieldMeta"] | undefined,
	wednesday?: GraphQLTypes["FieldMeta"] | undefined,
	thursday?: GraphQLTypes["FieldMeta"] | undefined,
	friday?: GraphQLTypes["FieldMeta"] | undefined,
	saturday?: GraphQLTypes["FieldMeta"] | undefined,
	sunday?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined
};
	["TimetableShiftPosition"]: {
		_meta?: GraphQLTypes["TimetableShiftPositionMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name?: string | undefined,
	start?: string | undefined,
	end?: string | undefined,
	shiftGroups: Array<GraphQLTypes["TimetableShiftGroup"]>,
	timetableTemplates: Array<GraphQLTypes["TimetableTemplate"]>,
	isDynamic: boolean,
	shiftGroupsByShifts?: GraphQLTypes["TimetableShiftGroup"] | undefined,
	shiftGroupsByQueue?: GraphQLTypes["TimetableShiftGroup"] | undefined,
	timetableTemplatesByStaffOptions?: GraphQLTypes["TimetableTemplate"] | undefined,
	paginateShiftGroups: GraphQLTypes["TimetableShiftGroupConnection"],
	paginateTimetableTemplates: GraphQLTypes["TimetableTemplateConnection"]
};
	["TimetableShiftPositionMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	start?: GraphQLTypes["FieldMeta"] | undefined,
	end?: GraphQLTypes["FieldMeta"] | undefined,
	shiftGroups?: GraphQLTypes["FieldMeta"] | undefined,
	timetableTemplates?: GraphQLTypes["FieldMeta"] | undefined,
	isDynamic?: GraphQLTypes["FieldMeta"] | undefined
};
	["TimetableShiftPositionShiftGroupsByShiftsUniqueWhere"]: GraphQLTypes["TimetableShiftPositionShiftGroupsByShiftsUniqueWhere"];
	["TimetableShiftPositionShiftGroupsByQueueUniqueWhere"]: GraphQLTypes["TimetableShiftPositionShiftGroupsByQueueUniqueWhere"];
	["TimetableShiftPositionTimetableTemplatesByStaffOptionsUniqueWhere"]: GraphQLTypes["TimetableShiftPositionTimetableTemplatesByStaffOptionsUniqueWhere"];
	["TimetableTemplateStaffOptionsUniqueWhere"]: GraphQLTypes["TimetableTemplateStaffOptionsUniqueWhere"];
	["TimetableShiftGroupConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TimetableShiftGroupEdge"]>
};
	["TimetableShiftGroupEdge"]: {
		node: GraphQLTypes["TimetableShiftGroup"]
};
	["TimetableTemplateConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TimetableTemplateEdge"]>
};
	["TimetableTemplateEdge"]: {
		node: GraphQLTypes["TimetableTemplate"]
};
	["TimetableTemplateStaffOptions"]: {
		_meta?: GraphQLTypes["TimetableTemplateStaffOptionsMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	startTime: string,
	endTime: string,
	timetableTemplate?: GraphQLTypes["TimetableTemplate"] | undefined,
	autoAssignedEmployee?: GraphQLTypes["ShiftsProfile"] | undefined
};
	["TimetableTemplateStaffOptionsMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	startTime?: GraphQLTypes["FieldMeta"] | undefined,
	endTime?: GraphQLTypes["FieldMeta"] | undefined,
	timetableTemplate?: GraphQLTypes["FieldMeta"] | undefined,
	autoAssignedEmployee?: GraphQLTypes["FieldMeta"] | undefined
};
	["TimetableTemplateStaffOptionsOrderBy"]: GraphQLTypes["TimetableTemplateStaffOptionsOrderBy"];
	["TimetableTemplateStaffOptionsConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TimetableTemplateStaffOptionsEdge"]>
};
	["TimetableTemplateStaffOptionsEdge"]: {
		node: GraphQLTypes["TimetableTemplateStaffOptions"]
};
	["TimetableEmployeeRoleShiftGroupsByShiftsUniqueWhere"]: GraphQLTypes["TimetableEmployeeRoleShiftGroupsByShiftsUniqueWhere"];
	["TimetableEmployeeRoleShiftGroupsByQueueUniqueWhere"]: GraphQLTypes["TimetableEmployeeRoleShiftGroupsByQueueUniqueWhere"];
	["TimetableEmployeeRoleTimetableTemplatesByStaffOptionsUniqueWhere"]: GraphQLTypes["TimetableEmployeeRoleTimetableTemplatesByStaffOptionsUniqueWhere"];
	["ShiftsProfileConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ShiftsProfileEdge"]>
};
	["ShiftsProfileEdge"]: {
		node: GraphQLTypes["ShiftsProfile"]
};
	["ShiftsManagerConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ShiftsManagerEdge"]>
};
	["ShiftsManagerEdge"]: {
		node: GraphQLTypes["ShiftsManager"]
};
	["ShiftsProfileQueueItemsByQueueUniqueWhere"]: GraphQLTypes["ShiftsProfileQueueItemsByQueueUniqueWhere"];
	["ShiftsProfileQueueItemsByShiftUniqueWhere"]: GraphQLTypes["ShiftsProfileQueueItemsByShiftUniqueWhere"];
	["ShiftsProfileQueueItemsByUnassignInfoUniqueWhere"]: GraphQLTypes["ShiftsProfileQueueItemsByUnassignInfoUniqueWhere"];
	["ShiftsProfileQueueItemsByMetaUniqueWhere"]: GraphQLTypes["ShiftsProfileQueueItemsByMetaUniqueWhere"];
	["ShiftsProfileShiftsByQueueItemUniqueWhere"]: GraphQLTypes["ShiftsProfileShiftsByQueueItemUniqueWhere"];
	["ShiftsProfileShiftsBySwapInfoUniqueWhere"]: GraphQLTypes["ShiftsProfileShiftsBySwapInfoUniqueWhere"];
	["TimetableShiftConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TimetableShiftEdge"]>
};
	["TimetableShiftEdge"]: {
		node: GraphQLTypes["TimetableShift"]
};
	["TimetableShiftSwapInfo"]: {
		_meta?: GraphQLTypes["TimetableShiftSwapInfoMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	assigned?: GraphQLTypes["Date"] | undefined,
	requested?: boolean | undefined,
	confirmed?: boolean | undefined,
	swappedShiftsProfile?: GraphQLTypes["ShiftsProfile"] | undefined,
	shift?: GraphQLTypes["TimetableShift"] | undefined
};
	["TimetableShiftSwapInfoMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	assigned?: GraphQLTypes["FieldMeta"] | undefined,
	requested?: GraphQLTypes["FieldMeta"] | undefined,
	confirmed?: GraphQLTypes["FieldMeta"] | undefined,
	swappedShiftsProfile?: GraphQLTypes["FieldMeta"] | undefined,
	shift?: GraphQLTypes["FieldMeta"] | undefined
};
	["TimetableShiftGroupShiftsByQueueItemUniqueWhere"]: GraphQLTypes["TimetableShiftGroupShiftsByQueueItemUniqueWhere"];
	["TimetableShiftGroupShiftsBySwapInfoUniqueWhere"]: GraphQLTypes["TimetableShiftGroupShiftsBySwapInfoUniqueWhere"];
	["TimetableDayNote"]: {
		_meta?: GraphQLTypes["TimetableDayNoteMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	note: string,
	day?: GraphQLTypes["TimetableDay"] | undefined,
	role?: GraphQLTypes["TimetableEmployeeRole"] | undefined
};
	["TimetableDayNoteMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	note?: GraphQLTypes["FieldMeta"] | undefined,
	day?: GraphQLTypes["FieldMeta"] | undefined,
	role?: GraphQLTypes["FieldMeta"] | undefined
};
	["TimetableDayNoteOrderBy"]: GraphQLTypes["TimetableDayNoteOrderBy"];
	["TimetableDayMetadata"]: {
		_meta?: GraphQLTypes["TimetableDayMetadataMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	numberOfWorkers: number,
	tipsTotalCents: number,
	totalMinutes: number,
	tipsCentsPerMinute: number,
	day?: GraphQLTypes["TimetableDay"] | undefined
};
	["TimetableDayMetadataMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	numberOfWorkers?: GraphQLTypes["FieldMeta"] | undefined,
	tipsTotalCents?: GraphQLTypes["FieldMeta"] | undefined,
	totalMinutes?: GraphQLTypes["FieldMeta"] | undefined,
	tipsCentsPerMinute?: GraphQLTypes["FieldMeta"] | undefined,
	day?: GraphQLTypes["FieldMeta"] | undefined
};
	["TimetableDayShiftGroupsByShiftsUniqueWhere"]: GraphQLTypes["TimetableDayShiftGroupsByShiftsUniqueWhere"];
	["TimetableDayShiftGroupsByQueueUniqueWhere"]: GraphQLTypes["TimetableDayShiftGroupsByQueueUniqueWhere"];
	["TimetableDayNoteConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TimetableDayNoteEdge"]>
};
	["TimetableDayNoteEdge"]: {
		node: GraphQLTypes["TimetableDayNote"]
};
	["VenueEmployeeRole"]: {
		_meta?: GraphQLTypes["VenueEmployeeRoleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	employeePrivileges?: GraphQLTypes["TimetablesEmployeePrivileges"] | undefined,
	venue?: GraphQLTypes["Venue"] | undefined,
	role?: GraphQLTypes["TimetableEmployeeRole"] | undefined,
	getsTipsShare: boolean,
	notesEnabled: boolean
};
	["VenueEmployeeRoleMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	employeePrivileges?: GraphQLTypes["FieldMeta"] | undefined,
	venue?: GraphQLTypes["FieldMeta"] | undefined,
	role?: GraphQLTypes["FieldMeta"] | undefined,
	getsTipsShare?: GraphQLTypes["FieldMeta"] | undefined,
	notesEnabled?: GraphQLTypes["FieldMeta"] | undefined
};
	["TimetablesEmployeePrivileges"]: {
		_meta?: GraphQLTypes["TimetablesEmployeePrivilegesMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	venueEmployeeRole?: GraphQLTypes["VenueEmployeeRole"] | undefined,
	read: boolean,
	unassign: boolean,
	assign: boolean
};
	["TimetablesEmployeePrivilegesMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	venueEmployeeRole?: GraphQLTypes["FieldMeta"] | undefined,
	read?: GraphQLTypes["FieldMeta"] | undefined,
	unassign?: GraphQLTypes["FieldMeta"] | undefined,
	assign?: GraphQLTypes["FieldMeta"] | undefined
};
	["VenueEmployeeRoleOrderBy"]: GraphQLTypes["VenueEmployeeRoleOrderBy"];
	["TimetablesEmployeePrivilegesOrderBy"]: GraphQLTypes["TimetablesEmployeePrivilegesOrderBy"];
	["PointOfSaleApplicationDevice"]: {
		_meta?: GraphQLTypes["PointOfSaleApplicationDeviceMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	internalName?: string | undefined,
	note?: string | undefined,
	venue?: GraphQLTypes["Venue"] | undefined,
	identificationCode?: GraphQLTypes["IdentificationCode"] | undefined,
	identifier?: GraphQLTypes["DeviceIdentifier"] | undefined,
	terminal?: GraphQLTypes["PointOfSaleTerminal"] | undefined,
	receiptPrinter?: GraphQLTypes["PointOfSalePrinter"] | undefined,
	ticketPrinters: Array<GraphQLTypes["PointOfSalePrinter"]>,
	paginateTicketPrinters: GraphQLTypes["PointOfSalePrinterConnection"]
};
	["PointOfSaleApplicationDeviceMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	internalName?: GraphQLTypes["FieldMeta"] | undefined,
	note?: GraphQLTypes["FieldMeta"] | undefined,
	venue?: GraphQLTypes["FieldMeta"] | undefined,
	identificationCode?: GraphQLTypes["FieldMeta"] | undefined,
	identifier?: GraphQLTypes["FieldMeta"] | undefined,
	terminal?: GraphQLTypes["FieldMeta"] | undefined,
	receiptPrinter?: GraphQLTypes["FieldMeta"] | undefined,
	ticketPrinters?: GraphQLTypes["FieldMeta"] | undefined
};
	["IdentificationCode"]: {
		_meta?: GraphQLTypes["IdentificationCodeMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	code: string,
	createdAt: GraphQLTypes["DateTime"],
	attempts: Array<GraphQLTypes["IdentificationAttempt"]>,
	locales: Array<GraphQLTypes["IdentificationCodeLocale"]>,
	internalName?: string | undefined,
	applicationDevices: Array<GraphQLTypes["PointOfSaleApplicationDevice"]>,
	localesByLocale?: GraphQLTypes["IdentificationCodeLocale"] | undefined,
	applicationDevicesByIdentifier?: GraphQLTypes["PointOfSaleApplicationDevice"] | undefined,
	paginateAttempts: GraphQLTypes["IdentificationAttemptConnection"],
	paginateLocales: GraphQLTypes["IdentificationCodeLocaleConnection"],
	paginateApplicationDevices: GraphQLTypes["PointOfSaleApplicationDeviceConnection"]
};
	["IdentificationCodeMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	code?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	attempts?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	internalName?: GraphQLTypes["FieldMeta"] | undefined,
	applicationDevices?: GraphQLTypes["FieldMeta"] | undefined
};
	["IdentificationAttempt"]: {
		_meta?: GraphQLTypes["IdentificationAttemptMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt: GraphQLTypes["DateTime"],
	code?: GraphQLTypes["IdentificationCode"] | undefined,
	user?: GraphQLTypes["User"] | undefined
};
	["IdentificationAttemptMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	code?: GraphQLTypes["FieldMeta"] | undefined,
	user?: GraphQLTypes["FieldMeta"] | undefined
};
	["User"]: {
		_meta?: GraphQLTypes["UserMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name?: string | undefined,
	internalNote?: string | undefined,
	staff?: GraphQLTypes["Staff"] | undefined,
	customer?: GraphQLTypes["Customer"] | undefined,
	tenantPersonId: GraphQLTypes["UUID"],
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	devices: Array<GraphQLTypes["UserDevice"]>,
	verifiedAt?: GraphQLTypes["DateTime"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	deletionRequestedAt?: GraphQLTypes["DateTime"] | undefined,
	deletionExpectedAt?: GraphQLTypes["DateTime"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	meta?: GraphQLTypes["UserMetadata"] | undefined,
	identificationAttempts: Array<GraphQLTypes["IdentificationAttempt"]>,
	roles?: GraphQLTypes["UserRoles"] | undefined,
	devicesByDeviceId?: GraphQLTypes["UserDevice"] | undefined,
	paginateDevices: GraphQLTypes["UserDeviceConnection"],
	paginateIdentificationAttempts: GraphQLTypes["IdentificationAttemptConnection"]
};
	["UserMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	staff?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined,
	tenantPersonId?: GraphQLTypes["FieldMeta"] | undefined,
	disabledAt?: GraphQLTypes["FieldMeta"] | undefined,
	devices?: GraphQLTypes["FieldMeta"] | undefined,
	verifiedAt?: GraphQLTypes["FieldMeta"] | undefined,
	email?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	deletionRequestedAt?: GraphQLTypes["FieldMeta"] | undefined,
	deletionExpectedAt?: GraphQLTypes["FieldMeta"] | undefined,
	deletedAt?: GraphQLTypes["FieldMeta"] | undefined,
	meta?: GraphQLTypes["FieldMeta"] | undefined,
	identificationAttempts?: GraphQLTypes["FieldMeta"] | undefined,
	roles?: GraphQLTypes["FieldMeta"] | undefined
};
	["UserDevice"]: {
		_meta?: GraphQLTypes["UserDeviceMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt: GraphQLTypes["DateTime"],
	lastActiveAt: GraphQLTypes["DateTime"],
	platform?: string | undefined,
	deviceId?: string | undefined,
	notificationsEnabled: boolean,
	user?: GraphQLTypes["User"] | undefined,
	appVersion?: string | undefined,
	osVersion?: string | undefined,
	apiVersion?: string | undefined,
	anonymousSession?: GraphQLTypes["AnonymousSession"] | undefined
};
	["UserDeviceMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	lastActiveAt?: GraphQLTypes["FieldMeta"] | undefined,
	platform?: GraphQLTypes["FieldMeta"] | undefined,
	deviceId?: GraphQLTypes["FieldMeta"] | undefined,
	notificationsEnabled?: GraphQLTypes["FieldMeta"] | undefined,
	user?: GraphQLTypes["FieldMeta"] | undefined,
	appVersion?: GraphQLTypes["FieldMeta"] | undefined,
	osVersion?: GraphQLTypes["FieldMeta"] | undefined,
	apiVersion?: GraphQLTypes["FieldMeta"] | undefined,
	anonymousSession?: GraphQLTypes["FieldMeta"] | undefined
};
	["AnonymousSession"]: {
		_meta?: GraphQLTypes["AnonymousSessionMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	lastActiveAt?: GraphQLTypes["DateTime"] | undefined,
	anonymousSessionKey: string,
	email?: string | undefined,
	name?: string | undefined,
	internalNote?: string | undefined,
	customer?: GraphQLTypes["Customer"] | undefined,
	devices: Array<GraphQLTypes["UserDevice"]>,
	devicesByDeviceId?: GraphQLTypes["UserDevice"] | undefined,
	paginateDevices: GraphQLTypes["UserDeviceConnection"]
};
	["AnonymousSessionMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	lastActiveAt?: GraphQLTypes["FieldMeta"] | undefined,
	anonymousSessionKey?: GraphQLTypes["FieldMeta"] | undefined,
	email?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined,
	devices?: GraphQLTypes["FieldMeta"] | undefined
};
	["UserDeviceOrderBy"]: GraphQLTypes["UserDeviceOrderBy"];
	["AnonymousSessionDevicesByDeviceIdUniqueWhere"]: GraphQLTypes["AnonymousSessionDevicesByDeviceIdUniqueWhere"];
	["UserDeviceConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["UserDeviceEdge"]>
};
	["UserDeviceEdge"]: {
		node: GraphQLTypes["UserDevice"]
};
	["UserMetadata"]: {
		_meta?: GraphQLTypes["UserMetadataMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	userProfileUrl: string,
	tenantEmail?: string | undefined,
	tenantPersonId?: GraphQLTypes["UUID"] | undefined,
	tenantIdentityId?: GraphQLTypes["UUID"] | undefined,
	globalRoles?: GraphQLTypes["Json"] | undefined,
	projectRoles?: GraphQLTypes["Json"] | undefined,
	projectRolesString?: string | undefined,
	externalIdentifiers?: GraphQLTypes["Json"] | undefined,
	externalIdentifiersString?: string | undefined,
	idpSlugs?: GraphQLTypes["Json"] | undefined,
	idpSlugsString?: string | undefined,
	user?: GraphQLTypes["User"] | undefined
};
	["UserMetadataMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	userProfileUrl?: GraphQLTypes["FieldMeta"] | undefined,
	tenantEmail?: GraphQLTypes["FieldMeta"] | undefined,
	tenantPersonId?: GraphQLTypes["FieldMeta"] | undefined,
	tenantIdentityId?: GraphQLTypes["FieldMeta"] | undefined,
	globalRoles?: GraphQLTypes["FieldMeta"] | undefined,
	projectRoles?: GraphQLTypes["FieldMeta"] | undefined,
	projectRolesString?: GraphQLTypes["FieldMeta"] | undefined,
	externalIdentifiers?: GraphQLTypes["FieldMeta"] | undefined,
	externalIdentifiersString?: GraphQLTypes["FieldMeta"] | undefined,
	idpSlugs?: GraphQLTypes["FieldMeta"] | undefined,
	idpSlugsString?: GraphQLTypes["FieldMeta"] | undefined,
	user?: GraphQLTypes["FieldMeta"] | undefined
};
	["IdentificationAttemptOrderBy"]: GraphQLTypes["IdentificationAttemptOrderBy"];
	["IdentificationCodeOrderBy"]: GraphQLTypes["IdentificationCodeOrderBy"];
	["UserRoles"]: {
		_meta?: GraphQLTypes["UserRolesMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	isCustomer: boolean,
	isStaff: boolean,
	isBartender: boolean,
	isCashier: boolean,
	isCourier: boolean,
	isCleaner: boolean,
	isShiftsManager: boolean,
	isInternalBuyer: boolean,
	isStocksManager: boolean,
	isCourierManager: boolean,
	isCashierManager: boolean,
	isBusinessToBusinessManager: boolean,
	isPicker: boolean,
	user?: GraphQLTypes["User"] | undefined
};
	["UserRolesMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	isCustomer?: GraphQLTypes["FieldMeta"] | undefined,
	isStaff?: GraphQLTypes["FieldMeta"] | undefined,
	isBartender?: GraphQLTypes["FieldMeta"] | undefined,
	isCashier?: GraphQLTypes["FieldMeta"] | undefined,
	isCourier?: GraphQLTypes["FieldMeta"] | undefined,
	isCleaner?: GraphQLTypes["FieldMeta"] | undefined,
	isShiftsManager?: GraphQLTypes["FieldMeta"] | undefined,
	isInternalBuyer?: GraphQLTypes["FieldMeta"] | undefined,
	isStocksManager?: GraphQLTypes["FieldMeta"] | undefined,
	isCourierManager?: GraphQLTypes["FieldMeta"] | undefined,
	isCashierManager?: GraphQLTypes["FieldMeta"] | undefined,
	isBusinessToBusinessManager?: GraphQLTypes["FieldMeta"] | undefined,
	isPicker?: GraphQLTypes["FieldMeta"] | undefined,
	user?: GraphQLTypes["FieldMeta"] | undefined
};
	["UserDevicesByDeviceIdUniqueWhere"]: GraphQLTypes["UserDevicesByDeviceIdUniqueWhere"];
	["IdentificationAttemptConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["IdentificationAttemptEdge"]>
};
	["IdentificationAttemptEdge"]: {
		node: GraphQLTypes["IdentificationAttempt"]
};
	["IdentificationCodeLocale"]: {
		_meta?: GraphQLTypes["IdentificationCodeLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	successMessage?: string | undefined,
	root?: GraphQLTypes["IdentificationCode"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined
};
	["IdentificationCodeLocaleMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	successMessage?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined
};
	["IdentificationCodeLocaleOrderBy"]: GraphQLTypes["IdentificationCodeLocaleOrderBy"];
	["PointOfSaleApplicationDeviceOrderBy"]: GraphQLTypes["PointOfSaleApplicationDeviceOrderBy"];
	["DeviceIdentifierOrderBy"]: GraphQLTypes["DeviceIdentifierOrderBy"];
	["DeviceIdentifierMetadataOrderBy"]: GraphQLTypes["DeviceIdentifierMetadataOrderBy"];
	["PointOfSaleTerminalOrderBy"]: GraphQLTypes["PointOfSaleTerminalOrderBy"];
	["PointOfSalePrinterOrderBy"]: GraphQLTypes["PointOfSalePrinterOrderBy"];
	["IdentificationCodeLocalesByLocaleUniqueWhere"]: GraphQLTypes["IdentificationCodeLocalesByLocaleUniqueWhere"];
	["IdentificationCodeApplicationDevicesByIdentifierUniqueWhere"]: GraphQLTypes["IdentificationCodeApplicationDevicesByIdentifierUniqueWhere"];
	["IdentificationCodeLocaleConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["IdentificationCodeLocaleEdge"]>
};
	["IdentificationCodeLocaleEdge"]: {
		node: GraphQLTypes["IdentificationCodeLocale"]
};
	["PointOfSaleApplicationDeviceConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PointOfSaleApplicationDeviceEdge"]>
};
	["PointOfSaleApplicationDeviceEdge"]: {
		node: GraphQLTypes["PointOfSaleApplicationDevice"]
};
	["DeviceIdentifier"]: {
		_meta?: GraphQLTypes["DeviceIdentifierMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	internalName?: string | undefined,
	device?: GraphQLTypes["PointOfSaleApplicationDevice"] | undefined,
	updatedAt: GraphQLTypes["DateTime"],
	platform?: string | undefined,
	resolution?: string | undefined,
	devicePixelRatio?: number | undefined,
	updatedByUser?: GraphQLTypes["User"] | undefined,
	identifier: string,
	meta?: GraphQLTypes["DeviceIdentifierMetadata"] | undefined,
	applicationVersionIdentifier?: string | undefined,
	lastPointOfSaleSynchronizationErrorRawDetails?: string | undefined
};
	["DeviceIdentifierMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	internalName?: GraphQLTypes["FieldMeta"] | undefined,
	device?: GraphQLTypes["FieldMeta"] | undefined,
	updatedAt?: GraphQLTypes["FieldMeta"] | undefined,
	platform?: GraphQLTypes["FieldMeta"] | undefined,
	resolution?: GraphQLTypes["FieldMeta"] | undefined,
	devicePixelRatio?: GraphQLTypes["FieldMeta"] | undefined,
	updatedByUser?: GraphQLTypes["FieldMeta"] | undefined,
	identifier?: GraphQLTypes["FieldMeta"] | undefined,
	meta?: GraphQLTypes["FieldMeta"] | undefined,
	applicationVersionIdentifier?: GraphQLTypes["FieldMeta"] | undefined,
	lastPointOfSaleSynchronizationErrorRawDetails?: GraphQLTypes["FieldMeta"] | undefined
};
	["DeviceIdentifierMetadata"]: {
		_meta?: GraphQLTypes["DeviceIdentifierMetadataMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	prettyIdentifier: string,
	deviceIdentifier?: GraphQLTypes["DeviceIdentifier"] | undefined
};
	["DeviceIdentifierMetadataMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	prettyIdentifier?: GraphQLTypes["FieldMeta"] | undefined,
	deviceIdentifier?: GraphQLTypes["FieldMeta"] | undefined
};
	["PointOfSaleTerminal"]: {
		_meta?: GraphQLTypes["PointOfSaleTerminalMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	internalName?: string | undefined,
	note?: string | undefined,
	venue?: GraphQLTypes["Venue"] | undefined,
	applicationDevices: Array<GraphQLTypes["PointOfSaleApplicationDevice"]>,
	ipAddress?: string | undefined,
	port?: number | undefined,
	type: GraphQLTypes["PointOfSaleTerminalType"],
	applicationDevicesByIdentifier?: GraphQLTypes["PointOfSaleApplicationDevice"] | undefined,
	paginateApplicationDevices: GraphQLTypes["PointOfSaleApplicationDeviceConnection"]
};
	["PointOfSaleTerminalMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	internalName?: GraphQLTypes["FieldMeta"] | undefined,
	note?: GraphQLTypes["FieldMeta"] | undefined,
	venue?: GraphQLTypes["FieldMeta"] | undefined,
	applicationDevices?: GraphQLTypes["FieldMeta"] | undefined,
	ipAddress?: GraphQLTypes["FieldMeta"] | undefined,
	port?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined
};
	["PointOfSaleTerminalApplicationDevicesByIdentifierUniqueWhere"]: GraphQLTypes["PointOfSaleTerminalApplicationDevicesByIdentifierUniqueWhere"];
	["PointOfSalePrinter"]: {
		_meta?: GraphQLTypes["PointOfSalePrinterMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	internalName?: string | undefined,
	note?: string | undefined,
	ipAddress: string,
	applicationDevicesReceipt: Array<GraphQLTypes["PointOfSaleApplicationDevice"]>,
	applicationDevicesTicket: Array<GraphQLTypes["PointOfSaleApplicationDevice"]>,
	venue?: GraphQLTypes["Venue"] | undefined,
	ticketCategories: Array<GraphQLTypes["PointOfSaleCategory"]>,
	applicationDevicesReceiptByIdentifier?: GraphQLTypes["PointOfSaleApplicationDevice"] | undefined,
	paginateApplicationDevicesReceipt: GraphQLTypes["PointOfSaleApplicationDeviceConnection"],
	paginateApplicationDevicesTicket: GraphQLTypes["PointOfSaleApplicationDeviceConnection"],
	paginateTicketCategories: GraphQLTypes["PointOfSaleCategoryConnection"]
};
	["PointOfSalePrinterMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	internalName?: GraphQLTypes["FieldMeta"] | undefined,
	note?: GraphQLTypes["FieldMeta"] | undefined,
	ipAddress?: GraphQLTypes["FieldMeta"] | undefined,
	applicationDevicesReceipt?: GraphQLTypes["FieldMeta"] | undefined,
	applicationDevicesTicket?: GraphQLTypes["FieldMeta"] | undefined,
	venue?: GraphQLTypes["FieldMeta"] | undefined,
	ticketCategories?: GraphQLTypes["FieldMeta"] | undefined
};
	["PointOfSaleCategory"]: {
		_meta?: GraphQLTypes["PointOfSaleCategoryMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	slug: string,
	locales: Array<GraphQLTypes["PointOfSaleCategoryLocale"]>,
	products: Array<GraphQLTypes["PointOfSaleCategoryProduct"]>,
	category?: GraphQLTypes["ProductCategory"] | undefined,
	venue?: GraphQLTypes["Venue"] | undefined,
	ticketPrinters: Array<GraphQLTypes["PointOfSalePrinter"]>,
	localesByLocale?: GraphQLTypes["PointOfSaleCategoryLocale"] | undefined,
	productsByLocales?: GraphQLTypes["PointOfSaleCategoryProduct"] | undefined,
	paginateLocales: GraphQLTypes["PointOfSaleCategoryLocaleConnection"],
	paginateProducts: GraphQLTypes["PointOfSaleCategoryProductConnection"],
	paginateTicketPrinters: GraphQLTypes["PointOfSalePrinterConnection"]
};
	["PointOfSaleCategoryMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	slug?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	products?: GraphQLTypes["FieldMeta"] | undefined,
	category?: GraphQLTypes["FieldMeta"] | undefined,
	venue?: GraphQLTypes["FieldMeta"] | undefined,
	ticketPrinters?: GraphQLTypes["FieldMeta"] | undefined
};
	["PointOfSaleCategoryLocale"]: {
		_meta?: GraphQLTypes["PointOfSaleCategoryLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	title: string,
	root?: GraphQLTypes["PointOfSaleCategory"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined
};
	["PointOfSaleCategoryLocaleMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined
};
	["PointOfSaleCategoryLocaleOrderBy"]: GraphQLTypes["PointOfSaleCategoryLocaleOrderBy"];
	["PointOfSaleCategoryOrderBy"]: GraphQLTypes["PointOfSaleCategoryOrderBy"];
	["ProductCategoryOrderBy"]: GraphQLTypes["ProductCategoryOrderBy"];
	["PointOfSaleCategoryProduct"]: {
		_meta?: GraphQLTypes["PointOfSaleCategoryProductMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	category?: GraphQLTypes["PointOfSaleCategory"] | undefined,
	product?: GraphQLTypes["Product"] | undefined,
	locales: Array<GraphQLTypes["PointOfSaleCategoryProductLocale"]>,
	localesByLocale?: GraphQLTypes["PointOfSaleCategoryProductLocale"] | undefined,
	paginateLocales: GraphQLTypes["PointOfSaleCategoryProductLocaleConnection"]
};
	["PointOfSaleCategoryProductMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	category?: GraphQLTypes["FieldMeta"] | undefined,
	product?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined
};
	["PointOfSaleCategoryProductLocale"]: {
		_meta?: GraphQLTypes["PointOfSaleCategoryProductLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	title: string,
	root?: GraphQLTypes["PointOfSaleCategoryProduct"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined
};
	["PointOfSaleCategoryProductLocaleMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined
};
	["PointOfSaleCategoryProductLocaleOrderBy"]: GraphQLTypes["PointOfSaleCategoryProductLocaleOrderBy"];
	["PointOfSaleCategoryProductOrderBy"]: GraphQLTypes["PointOfSaleCategoryProductOrderBy"];
	["PointOfSaleCategoryProductLocalesByLocaleUniqueWhere"]: GraphQLTypes["PointOfSaleCategoryProductLocalesByLocaleUniqueWhere"];
	["PointOfSaleCategoryProductLocaleConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PointOfSaleCategoryProductLocaleEdge"]>
};
	["PointOfSaleCategoryProductLocaleEdge"]: {
		node: GraphQLTypes["PointOfSaleCategoryProductLocale"]
};
	["ProductCategory"]: {
		_meta?: GraphQLTypes["ProductCategoryMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	code?: string | undefined,
	products: Array<GraphQLTypes["Product"]>,
	tags: Array<GraphQLTypes["Tag"]>,
	parent?: GraphQLTypes["ProductCategory"] | undefined,
	children: Array<GraphQLTypes["ProductCategory"]>,
	description?: string | undefined,
	internalNote?: string | undefined,
	color?: string | undefined,
	image?: GraphQLTypes["Image"] | undefined,
	order: number,
	descendants: Array<GraphQLTypes["ProductCategoryTree"]>,
	ancestors: Array<GraphQLTypes["ProductCategoryTree"]>,
	inheritedTags: Array<GraphQLTypes["InheritedProductCategoryTag"]>,
	nestedProducts: Array<GraphQLTypes["NestedProductCategoryProduct"]>,
	childrenByCode?: GraphQLTypes["ProductCategory"] | undefined,
	childrenByChildren?: GraphQLTypes["ProductCategory"] | undefined,
	childrenByDescendants?: GraphQLTypes["ProductCategory"] | undefined,
	childrenByAncestors?: GraphQLTypes["ProductCategory"] | undefined,
	childrenByInheritedTags?: GraphQLTypes["ProductCategory"] | undefined,
	childrenByNestedProducts?: GraphQLTypes["ProductCategory"] | undefined,
	paginateProducts: GraphQLTypes["ProductConnection"],
	paginateTags: GraphQLTypes["TagConnection"],
	paginateChildren: GraphQLTypes["ProductCategoryConnection"],
	paginateDescendants: GraphQLTypes["ProductCategoryTreeConnection"],
	paginateAncestors: GraphQLTypes["ProductCategoryTreeConnection"],
	paginateInheritedTags: GraphQLTypes["InheritedProductCategoryTagConnection"],
	paginateNestedProducts: GraphQLTypes["NestedProductCategoryProductConnection"]
};
	["ProductCategoryMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	code?: GraphQLTypes["FieldMeta"] | undefined,
	products?: GraphQLTypes["FieldMeta"] | undefined,
	tags?: GraphQLTypes["FieldMeta"] | undefined,
	parent?: GraphQLTypes["FieldMeta"] | undefined,
	children?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	color?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	descendants?: GraphQLTypes["FieldMeta"] | undefined,
	ancestors?: GraphQLTypes["FieldMeta"] | undefined,
	inheritedTags?: GraphQLTypes["FieldMeta"] | undefined,
	nestedProducts?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductCategoryTree"]: {
		_meta?: GraphQLTypes["ProductCategoryTreeMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	depth: number,
	ancestor?: GraphQLTypes["ProductCategory"] | undefined,
	descendant?: GraphQLTypes["ProductCategory"] | undefined
};
	["ProductCategoryTreeMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	depth?: GraphQLTypes["FieldMeta"] | undefined,
	ancestor?: GraphQLTypes["FieldMeta"] | undefined,
	descendant?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductCategoryTreeOrderBy"]: GraphQLTypes["ProductCategoryTreeOrderBy"];
	["InheritedProductCategoryTag"]: {
		_meta?: GraphQLTypes["InheritedProductCategoryTagMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	depth: number,
	productCategory?: GraphQLTypes["ProductCategory"] | undefined,
	tag?: GraphQLTypes["Tag"] | undefined
};
	["InheritedProductCategoryTagMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	depth?: GraphQLTypes["FieldMeta"] | undefined,
	productCategory?: GraphQLTypes["FieldMeta"] | undefined,
	tag?: GraphQLTypes["FieldMeta"] | undefined
};
	["InheritedProductCategoryTagOrderBy"]: GraphQLTypes["InheritedProductCategoryTagOrderBy"];
	["NestedProductCategoryProduct"]: {
		_meta?: GraphQLTypes["NestedProductCategoryProductMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	depth: number,
	product?: GraphQLTypes["Product"] | undefined,
	productCategory?: GraphQLTypes["ProductCategory"] | undefined
};
	["NestedProductCategoryProductMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	depth?: GraphQLTypes["FieldMeta"] | undefined,
	product?: GraphQLTypes["FieldMeta"] | undefined,
	productCategory?: GraphQLTypes["FieldMeta"] | undefined
};
	["NestedProductCategoryProductOrderBy"]: GraphQLTypes["NestedProductCategoryProductOrderBy"];
	["ProductCategoryChildrenByCodeUniqueWhere"]: GraphQLTypes["ProductCategoryChildrenByCodeUniqueWhere"];
	["ProductCategoryChildrenByChildrenUniqueWhere"]: GraphQLTypes["ProductCategoryChildrenByChildrenUniqueWhere"];
	["ProductCategoryUniqueWhere"]: GraphQLTypes["ProductCategoryUniqueWhere"];
	["ProductCategoryTreeUniqueWhere"]: GraphQLTypes["ProductCategoryTreeUniqueWhere"];
	["InheritedProductCategoryTagUniqueWhere"]: GraphQLTypes["InheritedProductCategoryTagUniqueWhere"];
	["ProductCategoryChildrenByDescendantsUniqueWhere"]: GraphQLTypes["ProductCategoryChildrenByDescendantsUniqueWhere"];
	["ProductCategoryChildrenByAncestorsUniqueWhere"]: GraphQLTypes["ProductCategoryChildrenByAncestorsUniqueWhere"];
	["ProductCategoryChildrenByInheritedTagsUniqueWhere"]: GraphQLTypes["ProductCategoryChildrenByInheritedTagsUniqueWhere"];
	["ProductCategoryChildrenByNestedProductsUniqueWhere"]: GraphQLTypes["ProductCategoryChildrenByNestedProductsUniqueWhere"];
	["ProductConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductEdge"]>
};
	["ProductEdge"]: {
		node: GraphQLTypes["Product"]
};
	["ProductCategoryConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductCategoryEdge"]>
};
	["ProductCategoryEdge"]: {
		node: GraphQLTypes["ProductCategory"]
};
	["ProductCategoryTreeConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductCategoryTreeEdge"]>
};
	["ProductCategoryTreeEdge"]: {
		node: GraphQLTypes["ProductCategoryTree"]
};
	["InheritedProductCategoryTagConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["InheritedProductCategoryTagEdge"]>
};
	["InheritedProductCategoryTagEdge"]: {
		node: GraphQLTypes["InheritedProductCategoryTag"]
};
	["NestedProductCategoryProductConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["NestedProductCategoryProductEdge"]>
};
	["NestedProductCategoryProductEdge"]: {
		node: GraphQLTypes["NestedProductCategoryProduct"]
};
	["PointOfSaleCategoryLocalesByLocaleUniqueWhere"]: GraphQLTypes["PointOfSaleCategoryLocalesByLocaleUniqueWhere"];
	["PointOfSaleCategoryProductsByLocalesUniqueWhere"]: GraphQLTypes["PointOfSaleCategoryProductsByLocalesUniqueWhere"];
	["PointOfSaleCategoryLocaleConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PointOfSaleCategoryLocaleEdge"]>
};
	["PointOfSaleCategoryLocaleEdge"]: {
		node: GraphQLTypes["PointOfSaleCategoryLocale"]
};
	["PointOfSaleCategoryProductConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PointOfSaleCategoryProductEdge"]>
};
	["PointOfSaleCategoryProductEdge"]: {
		node: GraphQLTypes["PointOfSaleCategoryProduct"]
};
	["PointOfSalePrinterConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PointOfSalePrinterEdge"]>
};
	["PointOfSalePrinterEdge"]: {
		node: GraphQLTypes["PointOfSalePrinter"]
};
	["PointOfSalePrinterApplicationDevicesReceiptByIdentifierUniqueWhere"]: GraphQLTypes["PointOfSalePrinterApplicationDevicesReceiptByIdentifierUniqueWhere"];
	["PointOfSaleCategoryConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PointOfSaleCategoryEdge"]>
};
	["PointOfSaleCategoryEdge"]: {
		node: GraphQLTypes["PointOfSaleCategory"]
};
	["Order"]: {
		_meta?: GraphQLTypes["OrderMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	state: GraphQLTypes["OrderState"],
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	canceledAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	customer?: GraphQLTypes["Customer"] | undefined,
	channel?: GraphQLTypes["Channel"] | undefined,
	discounts: Array<GraphQLTypes["OrderDiscount"]>,
	delivery?: GraphQLTypes["OrderDelivery"] | undefined,
	items: Array<GraphQLTypes["OrderItem"]>,
	internalNote?: string | undefined,
	cart?: GraphQLTypes["Cart"] | undefined,
	events: Array<GraphQLTypes["OrderEvent"]>,
	createdAt: GraphQLTypes["DateTime"],
	billingAddress?: GraphQLTypes["Address"] | undefined,
	priceLines: Array<GraphQLTypes["OrderPriceLine"]>,
	payments: Array<GraphQLTypes["OrderPayment"]>,
	seq: number,
	billingSubject?: GraphQLTypes["BillingSubject"] | undefined,
	summary?: GraphQLTypes["OrderSummary"] | undefined,
	doubleshotLegacyId?: string | undefined,
	gratuity?: GraphQLTypes["Gratuity"] | undefined,
	venue?: GraphQLTypes["Venue"] | undefined,
	fulfillmentNote?: string | undefined,
	fulfillmentNotes: Array<GraphQLTypes["FulfillmentNote"]>,
	doubleshotTotalWeightGrams?: number | undefined,
	doubleShotLegacyNumber?: string | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	doubleshotAdminUrl?: string | undefined,
	discountsByCustomerCreditTransactions?: GraphQLTypes["OrderDiscount"] | undefined,
	discountsByVoucherRedemption?: GraphQLTypes["OrderDiscount"] | undefined,
	itemsByVirtualProductEffects?: GraphQLTypes["OrderItem"] | undefined,
	priceLinesByOrderItem?: GraphQLTypes["OrderPriceLine"] | undefined,
	priceLinesByOrderDiscount?: GraphQLTypes["OrderPriceLine"] | undefined,
	priceLinesByOrderPayment?: GraphQLTypes["OrderPriceLine"] | undefined,
	priceLinesByOrderDelivery?: GraphQLTypes["OrderPriceLine"] | undefined,
	paymentsByEvents?: GraphQLTypes["OrderPayment"] | undefined,
	paymentsByMeta?: GraphQLTypes["OrderPayment"] | undefined,
	paginateDiscounts: GraphQLTypes["OrderDiscountConnection"],
	paginateItems: GraphQLTypes["OrderItemConnection"],
	paginateEvents: GraphQLTypes["OrderEventConnection"],
	paginatePriceLines: GraphQLTypes["OrderPriceLineConnection"],
	paginatePayments: GraphQLTypes["OrderPaymentConnection"],
	paginateFulfillmentNotes: GraphQLTypes["FulfillmentNoteConnection"]
};
	["OrderMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	state?: GraphQLTypes["FieldMeta"] | undefined,
	fulfilledAt?: GraphQLTypes["FieldMeta"] | undefined,
	canceledAt?: GraphQLTypes["FieldMeta"] | undefined,
	note?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined,
	channel?: GraphQLTypes["FieldMeta"] | undefined,
	discounts?: GraphQLTypes["FieldMeta"] | undefined,
	delivery?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	cart?: GraphQLTypes["FieldMeta"] | undefined,
	events?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	billingAddress?: GraphQLTypes["FieldMeta"] | undefined,
	priceLines?: GraphQLTypes["FieldMeta"] | undefined,
	payments?: GraphQLTypes["FieldMeta"] | undefined,
	seq?: GraphQLTypes["FieldMeta"] | undefined,
	billingSubject?: GraphQLTypes["FieldMeta"] | undefined,
	summary?: GraphQLTypes["FieldMeta"] | undefined,
	doubleshotLegacyId?: GraphQLTypes["FieldMeta"] | undefined,
	gratuity?: GraphQLTypes["FieldMeta"] | undefined,
	venue?: GraphQLTypes["FieldMeta"] | undefined,
	fulfillmentNote?: GraphQLTypes["FieldMeta"] | undefined,
	fulfillmentNotes?: GraphQLTypes["FieldMeta"] | undefined,
	doubleshotTotalWeightGrams?: GraphQLTypes["FieldMeta"] | undefined,
	doubleShotLegacyNumber?: GraphQLTypes["FieldMeta"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["FieldMeta"] | undefined,
	doubleshotAdminUrl?: GraphQLTypes["FieldMeta"] | undefined
};
	["OrderDiscount"]: {
		_meta?: GraphQLTypes["OrderDiscountMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	discountCents: number,
	vatRate?: GraphQLTypes["VatRate"] | undefined,
	order?: GraphQLTypes["Order"] | undefined,
	description?: string | undefined,
	type: GraphQLTypes["OrderDiscountType"],
	customerCreditTransactions: Array<GraphQLTypes["CustomerCreditTransaction"]>,
	voucherRedemption?: GraphQLTypes["VoucherRedemption"] | undefined,
	customerCreditTransactionsByVirtualProductEffect?: GraphQLTypes["CustomerCreditTransaction"] | undefined,
	paginateCustomerCreditTransactions: GraphQLTypes["CustomerCreditTransactionConnection"]
};
	["OrderDiscountMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	discountCents?: GraphQLTypes["FieldMeta"] | undefined,
	vatRate?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	customerCreditTransactions?: GraphQLTypes["FieldMeta"] | undefined,
	voucherRedemption?: GraphQLTypes["FieldMeta"] | undefined
};
	["CustomerCreditTransaction"]: {
		_meta?: GraphQLTypes["CustomerCreditTransactionMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt: GraphQLTypes["DateTime"],
	amountCents: number,
	customerCredit?: GraphQLTypes["CustomerCredit"] | undefined,
	orderDiscount?: GraphQLTypes["OrderDiscount"] | undefined,
	virtualProductEffect?: GraphQLTypes["VirtualProductEffect"] | undefined
};
	["CustomerCreditTransactionMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	amountCents?: GraphQLTypes["FieldMeta"] | undefined,
	customerCredit?: GraphQLTypes["FieldMeta"] | undefined,
	orderDiscount?: GraphQLTypes["FieldMeta"] | undefined,
	virtualProductEffect?: GraphQLTypes["FieldMeta"] | undefined
};
	["CustomerCredit"]: {
		_meta?: GraphQLTypes["CustomerCreditMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	initialCreditCents: number,
	remainingCreditsCents: number,
	expiresAt?: GraphQLTypes["DateTime"] | undefined,
	reason?: string | undefined,
	customer?: GraphQLTypes["Customer"] | undefined,
	vatRate?: GraphQLTypes["VatRate"] | undefined,
	createdAt: GraphQLTypes["DateTime"],
	transactions: Array<GraphQLTypes["CustomerCreditTransaction"]>,
	voucherRedemption?: GraphQLTypes["VoucherRedemption"] | undefined,
	invoiceUrl?: string | undefined,
	transactionsByVirtualProductEffect?: GraphQLTypes["CustomerCreditTransaction"] | undefined,
	paginateTransactions: GraphQLTypes["CustomerCreditTransactionConnection"]
};
	["CustomerCreditMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	initialCreditCents?: GraphQLTypes["FieldMeta"] | undefined,
	remainingCreditsCents?: GraphQLTypes["FieldMeta"] | undefined,
	expiresAt?: GraphQLTypes["FieldMeta"] | undefined,
	reason?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined,
	vatRate?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	transactions?: GraphQLTypes["FieldMeta"] | undefined,
	voucherRedemption?: GraphQLTypes["FieldMeta"] | undefined,
	invoiceUrl?: GraphQLTypes["FieldMeta"] | undefined
};
	["CustomerCreditTransactionOrderBy"]: GraphQLTypes["CustomerCreditTransactionOrderBy"];
	["CustomerCreditOrderBy"]: GraphQLTypes["CustomerCreditOrderBy"];
	["VoucherRedemptionOrderBy"]: GraphQLTypes["VoucherRedemptionOrderBy"];
	["OrderDiscountOrderBy"]: GraphQLTypes["OrderDiscountOrderBy"];
	["OrderOrderBy"]: GraphQLTypes["OrderOrderBy"];
	["OrderDeliveryOrderBy"]: GraphQLTypes["OrderDeliveryOrderBy"];
	["DeliveryWaypointOrderBy"]: GraphQLTypes["DeliveryWaypointOrderBy"];
	["DeliveryRouteOrderBy"]: GraphQLTypes["DeliveryRouteOrderBy"];
	["LiftagoRideOrderBy"]: GraphQLTypes["LiftagoRideOrderBy"];
	["WoltDriveDeliveryOrderBy"]: GraphQLTypes["WoltDriveDeliveryOrderBy"];
	["CartOrderBy"]: GraphQLTypes["CartOrderBy"];
	["CartSummaryOrderBy"]: GraphQLTypes["CartSummaryOrderBy"];
	["OrderSummaryOrderBy"]: GraphQLTypes["OrderSummaryOrderBy"];
	["GratuityOrderBy"]: GraphQLTypes["GratuityOrderBy"];
	["VoucherOrderBy"]: GraphQLTypes["VoucherOrderBy"];
	["VirtualProductEffectOrderBy"]: GraphQLTypes["VirtualProductEffectOrderBy"];
	["OrderItemOrderBy"]: GraphQLTypes["OrderItemOrderBy"];
	["VoucherRedemption"]: {
		_meta?: GraphQLTypes["VoucherRedemptionMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt: GraphQLTypes["DateTime"],
	note?: string | undefined,
	manualRedemptionNote?: string | undefined,
	customerCredit?: GraphQLTypes["CustomerCredit"] | undefined,
	orderDiscount?: GraphQLTypes["OrderDiscount"] | undefined,
	voucher?: GraphQLTypes["Voucher"] | undefined,
	customer?: GraphQLTypes["Customer"] | undefined
};
	["VoucherRedemptionMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	note?: GraphQLTypes["FieldMeta"] | undefined,
	manualRedemptionNote?: GraphQLTypes["FieldMeta"] | undefined,
	customerCredit?: GraphQLTypes["FieldMeta"] | undefined,
	orderDiscount?: GraphQLTypes["FieldMeta"] | undefined,
	voucher?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined
};
	["Voucher"]: {
		_meta?: GraphQLTypes["VoucherMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt: GraphQLTypes["DateTime"],
	activatedAt?: GraphQLTypes["DateTime"] | undefined,
	expiresAt?: GraphQLTypes["DateTime"] | undefined,
	internalNote?: string | undefined,
	note?: string | undefined,
	code: string,
	type: GraphQLTypes["VoucherType"],
	creditCents?: number | undefined,
	buyer?: GraphQLTypes["Customer"] | undefined,
	owner?: GraphQLTypes["Customer"] | undefined,
	vatRate?: GraphQLTypes["VatRate"] | undefined,
	virtualProductEffect?: GraphQLTypes["VirtualProductEffect"] | undefined,
	redemption?: GraphQLTypes["VoucherRedemption"] | undefined
};
	["VoucherMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	activatedAt?: GraphQLTypes["FieldMeta"] | undefined,
	expiresAt?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	note?: GraphQLTypes["FieldMeta"] | undefined,
	code?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	creditCents?: GraphQLTypes["FieldMeta"] | undefined,
	buyer?: GraphQLTypes["FieldMeta"] | undefined,
	owner?: GraphQLTypes["FieldMeta"] | undefined,
	vatRate?: GraphQLTypes["FieldMeta"] | undefined,
	virtualProductEffect?: GraphQLTypes["FieldMeta"] | undefined,
	redemption?: GraphQLTypes["FieldMeta"] | undefined
};
	["VirtualProductEffect"]: {
		_meta?: GraphQLTypes["VirtualProductEffectMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt: GraphQLTypes["DateTime"],
	succeededAt?: GraphQLTypes["DateTime"] | undefined,
	orderItem?: GraphQLTypes["OrderItem"] | undefined,
	failedAt?: GraphQLTypes["DateTime"] | undefined,
	revertedAt?: GraphQLTypes["DateTime"] | undefined,
	resultCustomerCreditTransaction?: GraphQLTypes["CustomerCreditTransaction"] | undefined,
	resultVouchers: Array<GraphQLTypes["Voucher"]>,
	resultVouchersByCode?: GraphQLTypes["Voucher"] | undefined,
	resultVouchersByRedemption?: GraphQLTypes["Voucher"] | undefined,
	paginateResultVouchers: GraphQLTypes["VoucherConnection"]
};
	["VirtualProductEffectMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	succeededAt?: GraphQLTypes["FieldMeta"] | undefined,
	orderItem?: GraphQLTypes["FieldMeta"] | undefined,
	failedAt?: GraphQLTypes["FieldMeta"] | undefined,
	revertedAt?: GraphQLTypes["FieldMeta"] | undefined,
	resultCustomerCreditTransaction?: GraphQLTypes["FieldMeta"] | undefined,
	resultVouchers?: GraphQLTypes["FieldMeta"] | undefined
};
	["OrderItem"]: {
		_meta?: GraphQLTypes["OrderItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	unitPriceCents: number,
	quantity: number,
	vatRate?: GraphQLTypes["VatRate"] | undefined,
	order?: GraphQLTypes["Order"] | undefined,
	virtualProductEffects: Array<GraphQLTypes["VirtualProductEffect"]>,
	pickedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	fulfillmentNotes: Array<GraphQLTypes["FulfillmentNote"]>,
	product?: GraphQLTypes["Product"] | undefined,
	virtualProductEffectsByResultCustomerCreditTransaction?: GraphQLTypes["VirtualProductEffect"] | undefined,
	virtualProductEffectsByResultVouchers?: GraphQLTypes["VirtualProductEffect"] | undefined,
	paginateVirtualProductEffects: GraphQLTypes["VirtualProductEffectConnection"],
	paginateFulfillmentNotes: GraphQLTypes["FulfillmentNoteConnection"]
};
	["OrderItemMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	unitPriceCents?: GraphQLTypes["FieldMeta"] | undefined,
	quantity?: GraphQLTypes["FieldMeta"] | undefined,
	vatRate?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	virtualProductEffects?: GraphQLTypes["FieldMeta"] | undefined,
	pickedAt?: GraphQLTypes["FieldMeta"] | undefined,
	note?: GraphQLTypes["FieldMeta"] | undefined,
	fulfillmentNotes?: GraphQLTypes["FieldMeta"] | undefined,
	product?: GraphQLTypes["FieldMeta"] | undefined
};
	["FulfillmentNoteOrderBy"]: GraphQLTypes["FulfillmentNoteOrderBy"];
	["OrderItemVirtualProductEffectsByResultCustomerCreditTransactionUniqueWhere"]: GraphQLTypes["OrderItemVirtualProductEffectsByResultCustomerCreditTransactionUniqueWhere"];
	["OrderItemVirtualProductEffectsByResultVouchersUniqueWhere"]: GraphQLTypes["OrderItemVirtualProductEffectsByResultVouchersUniqueWhere"];
	["VirtualProductEffectConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["VirtualProductEffectEdge"]>
};
	["VirtualProductEffectEdge"]: {
		node: GraphQLTypes["VirtualProductEffect"]
};
	["FulfillmentNoteConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FulfillmentNoteEdge"]>
};
	["FulfillmentNoteEdge"]: {
		node: GraphQLTypes["FulfillmentNote"]
};
	["VirtualProductEffectResultVouchersByCodeUniqueWhere"]: GraphQLTypes["VirtualProductEffectResultVouchersByCodeUniqueWhere"];
	["VirtualProductEffectResultVouchersByRedemptionUniqueWhere"]: GraphQLTypes["VirtualProductEffectResultVouchersByRedemptionUniqueWhere"];
	["VoucherConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["VoucherEdge"]>
};
	["VoucherEdge"]: {
		node: GraphQLTypes["Voucher"]
};
	["CustomerCreditTransactionsByVirtualProductEffectUniqueWhere"]: GraphQLTypes["CustomerCreditTransactionsByVirtualProductEffectUniqueWhere"];
	["CustomerCreditTransactionConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CustomerCreditTransactionEdge"]>
};
	["CustomerCreditTransactionEdge"]: {
		node: GraphQLTypes["CustomerCreditTransaction"]
};
	["OrderDiscountCustomerCreditTransactionsByVirtualProductEffectUniqueWhere"]: GraphQLTypes["OrderDiscountCustomerCreditTransactionsByVirtualProductEffectUniqueWhere"];
	["OrderEvent"]: {
		_meta?: GraphQLTypes["OrderEventMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	type: string,
	data?: string | undefined,
	createdAt: GraphQLTypes["DateTime"],
	order?: GraphQLTypes["Order"] | undefined,
	payment?: GraphQLTypes["OrderPayment"] | undefined,
	delivery?: GraphQLTypes["OrderDelivery"] | undefined
};
	["OrderEventMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	data?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	payment?: GraphQLTypes["FieldMeta"] | undefined,
	delivery?: GraphQLTypes["FieldMeta"] | undefined
};
	["OrderPayment"]: {
		_meta?: GraphQLTypes["OrderPaymentMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	data?: GraphQLTypes["Json"] | undefined,
	paymentCents: number,
	method?: GraphQLTypes["PaymentMethod"] | undefined,
	failedAt?: GraphQLTypes["DateTime"] | undefined,
	state: GraphQLTypes["OrderPaymentState"],
	approvedAt?: GraphQLTypes["DateTime"] | undefined,
	events: Array<GraphQLTypes["OrderEvent"]>,
	order?: GraphQLTypes["Order"] | undefined,
	invoice?: GraphQLTypes["Invoice"] | undefined,
	walletType?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	publicReceiptUrl?: string | undefined,
	priceCents?: number | undefined,
	vatRate?: GraphQLTypes["VatRate"] | undefined,
	meta?: GraphQLTypes["OrderPaymentMetadata"] | undefined,
	otherCurrencyPriceCents?: string | undefined,
	paginateEvents: GraphQLTypes["OrderEventConnection"]
};
	["OrderPaymentMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	data?: GraphQLTypes["FieldMeta"] | undefined,
	paymentCents?: GraphQLTypes["FieldMeta"] | undefined,
	method?: GraphQLTypes["FieldMeta"] | undefined,
	failedAt?: GraphQLTypes["FieldMeta"] | undefined,
	state?: GraphQLTypes["FieldMeta"] | undefined,
	approvedAt?: GraphQLTypes["FieldMeta"] | undefined,
	events?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	invoice?: GraphQLTypes["FieldMeta"] | undefined,
	walletType?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	publicReceiptUrl?: GraphQLTypes["FieldMeta"] | undefined,
	priceCents?: GraphQLTypes["FieldMeta"] | undefined,
	vatRate?: GraphQLTypes["FieldMeta"] | undefined,
	meta?: GraphQLTypes["FieldMeta"] | undefined,
	otherCurrencyPriceCents?: GraphQLTypes["FieldMeta"] | undefined
};
	["OrderEventOrderBy"]: GraphQLTypes["OrderEventOrderBy"];
	["OrderPaymentOrderBy"]: GraphQLTypes["OrderPaymentOrderBy"];
	["InvoiceOrderBy"]: GraphQLTypes["InvoiceOrderBy"];
	["OrderPaymentMetadataOrderBy"]: GraphQLTypes["OrderPaymentMetadataOrderBy"];
	["Invoice"]: {
		_meta?: GraphQLTypes["InvoiceMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt: GraphQLTypes["DateTime"],
	publicKey: string,
	fakturoidId?: string | undefined,
	fakturoidData?: string | undefined,
	legacyUrl?: string | undefined,
	customer?: GraphQLTypes["Customer"] | undefined,
	orderPayments: Array<GraphQLTypes["OrderPayment"]>,
	address?: GraphQLTypes["Address"] | undefined,
	publicUrl?: string | undefined,
	billingSubject?: GraphQLTypes["BillingSubject"] | undefined,
	orderPaymentsByEvents?: GraphQLTypes["OrderPayment"] | undefined,
	orderPaymentsByMeta?: GraphQLTypes["OrderPayment"] | undefined,
	paginateOrderPayments: GraphQLTypes["OrderPaymentConnection"]
};
	["InvoiceMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	publicKey?: GraphQLTypes["FieldMeta"] | undefined,
	fakturoidId?: GraphQLTypes["FieldMeta"] | undefined,
	fakturoidData?: GraphQLTypes["FieldMeta"] | undefined,
	legacyUrl?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined,
	orderPayments?: GraphQLTypes["FieldMeta"] | undefined,
	address?: GraphQLTypes["FieldMeta"] | undefined,
	publicUrl?: GraphQLTypes["FieldMeta"] | undefined,
	billingSubject?: GraphQLTypes["FieldMeta"] | undefined
};
	["BillingSubject"]: {
		_meta?: GraphQLTypes["BillingSubjectMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name?: string | undefined,
	fullName?: string | undefined,
	addressLine1?: string | undefined,
	addressLine2?: string | undefined,
	city?: string | undefined,
	postalCode?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	companyName?: string | undefined,
	companyIdentifier?: string | undefined,
	vatIdentifier?: string | undefined,
	externalIdentifier?: string | undefined,
	hidden: boolean,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	internalNote?: string | undefined,
	fakturoidSubjectId?: string | undefined,
	country?: GraphQLTypes["Country"] | undefined,
	customer?: GraphQLTypes["Customer"] | undefined,
	invoices: Array<GraphQLTypes["Invoice"]>,
	defaultBillingSubjectOfCustomer?: GraphQLTypes["Customer"] | undefined,
	orders: Array<GraphQLTypes["Order"]>,
	invoicesByPublicKey?: GraphQLTypes["Invoice"] | undefined,
	invoicesByFakturoidId?: GraphQLTypes["Invoice"] | undefined,
	invoicesByOrderPayments?: GraphQLTypes["Invoice"] | undefined,
	ordersBySeq?: GraphQLTypes["Order"] | undefined,
	ordersByDoubleshotLegacyId?: GraphQLTypes["Order"] | undefined,
	ordersByDoubleShotLegacyNumber?: GraphQLTypes["Order"] | undefined,
	ordersByDiscounts?: GraphQLTypes["Order"] | undefined,
	ordersByDelivery?: GraphQLTypes["Order"] | undefined,
	ordersByItems?: GraphQLTypes["Order"] | undefined,
	ordersByCart?: GraphQLTypes["Order"] | undefined,
	ordersByEvents?: GraphQLTypes["Order"] | undefined,
	ordersByPriceLines?: GraphQLTypes["Order"] | undefined,
	ordersByPayments?: GraphQLTypes["Order"] | undefined,
	ordersBySummary?: GraphQLTypes["Order"] | undefined,
	ordersByGratuity?: GraphQLTypes["Order"] | undefined,
	paginateInvoices: GraphQLTypes["InvoiceConnection"],
	paginateOrders: GraphQLTypes["OrderConnection"]
};
	["BillingSubjectMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	fullName?: GraphQLTypes["FieldMeta"] | undefined,
	addressLine1?: GraphQLTypes["FieldMeta"] | undefined,
	addressLine2?: GraphQLTypes["FieldMeta"] | undefined,
	city?: GraphQLTypes["FieldMeta"] | undefined,
	postalCode?: GraphQLTypes["FieldMeta"] | undefined,
	email?: GraphQLTypes["FieldMeta"] | undefined,
	phone?: GraphQLTypes["FieldMeta"] | undefined,
	companyName?: GraphQLTypes["FieldMeta"] | undefined,
	companyIdentifier?: GraphQLTypes["FieldMeta"] | undefined,
	vatIdentifier?: GraphQLTypes["FieldMeta"] | undefined,
	externalIdentifier?: GraphQLTypes["FieldMeta"] | undefined,
	hidden?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	deletedAt?: GraphQLTypes["FieldMeta"] | undefined,
	note?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	fakturoidSubjectId?: GraphQLTypes["FieldMeta"] | undefined,
	country?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined,
	invoices?: GraphQLTypes["FieldMeta"] | undefined,
	defaultBillingSubjectOfCustomer?: GraphQLTypes["FieldMeta"] | undefined,
	orders?: GraphQLTypes["FieldMeta"] | undefined
};
	["Country"]: {
		_meta?: GraphQLTypes["CountryMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	code: string,
	order: number
};
	["CountryMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	code?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined
};
	["BillingSubjectInvoicesByPublicKeyUniqueWhere"]: GraphQLTypes["BillingSubjectInvoicesByPublicKeyUniqueWhere"];
	["BillingSubjectInvoicesByFakturoidIdUniqueWhere"]: GraphQLTypes["BillingSubjectInvoicesByFakturoidIdUniqueWhere"];
	["BillingSubjectInvoicesByOrderPaymentsUniqueWhere"]: GraphQLTypes["BillingSubjectInvoicesByOrderPaymentsUniqueWhere"];
	["BillingSubjectOrdersBySeqUniqueWhere"]: GraphQLTypes["BillingSubjectOrdersBySeqUniqueWhere"];
	["BillingSubjectOrdersByDoubleshotLegacyIdUniqueWhere"]: GraphQLTypes["BillingSubjectOrdersByDoubleshotLegacyIdUniqueWhere"];
	["BillingSubjectOrdersByDoubleShotLegacyNumberUniqueWhere"]: GraphQLTypes["BillingSubjectOrdersByDoubleShotLegacyNumberUniqueWhere"];
	["BillingSubjectOrdersByDiscountsUniqueWhere"]: GraphQLTypes["BillingSubjectOrdersByDiscountsUniqueWhere"];
	["BillingSubjectOrdersByDeliveryUniqueWhere"]: GraphQLTypes["BillingSubjectOrdersByDeliveryUniqueWhere"];
	["BillingSubjectOrdersByItemsUniqueWhere"]: GraphQLTypes["BillingSubjectOrdersByItemsUniqueWhere"];
	["BillingSubjectOrdersByCartUniqueWhere"]: GraphQLTypes["BillingSubjectOrdersByCartUniqueWhere"];
	["BillingSubjectOrdersByEventsUniqueWhere"]: GraphQLTypes["BillingSubjectOrdersByEventsUniqueWhere"];
	["BillingSubjectOrdersByPriceLinesUniqueWhere"]: GraphQLTypes["BillingSubjectOrdersByPriceLinesUniqueWhere"];
	["BillingSubjectOrdersByPaymentsUniqueWhere"]: GraphQLTypes["BillingSubjectOrdersByPaymentsUniqueWhere"];
	["BillingSubjectOrdersBySummaryUniqueWhere"]: GraphQLTypes["BillingSubjectOrdersBySummaryUniqueWhere"];
	["BillingSubjectOrdersByGratuityUniqueWhere"]: GraphQLTypes["BillingSubjectOrdersByGratuityUniqueWhere"];
	["InvoiceConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["InvoiceEdge"]>
};
	["InvoiceEdge"]: {
		node: GraphQLTypes["Invoice"]
};
	["OrderConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["OrderEdge"]>
};
	["OrderEdge"]: {
		node: GraphQLTypes["Order"]
};
	["InvoiceOrderPaymentsByEventsUniqueWhere"]: GraphQLTypes["InvoiceOrderPaymentsByEventsUniqueWhere"];
	["InvoiceOrderPaymentsByMetaUniqueWhere"]: GraphQLTypes["InvoiceOrderPaymentsByMetaUniqueWhere"];
	["OrderPaymentConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["OrderPaymentEdge"]>
};
	["OrderPaymentEdge"]: {
		node: GraphQLTypes["OrderPayment"]
};
	["OrderPaymentMetadata"]: {
		_meta?: GraphQLTypes["OrderPaymentMetadataMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	paymentUrl: string,
	orderPayment?: GraphQLTypes["OrderPayment"] | undefined
};
	["OrderPaymentMetadataMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	paymentUrl?: GraphQLTypes["FieldMeta"] | undefined,
	orderPayment?: GraphQLTypes["FieldMeta"] | undefined
};
	["OrderEventConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["OrderEventEdge"]>
};
	["OrderEventEdge"]: {
		node: GraphQLTypes["OrderEvent"]
};
	["OrderPriceLine"]: {
		_meta?: GraphQLTypes["OrderPriceLineMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	unitPriceCents: number,
	quantity: number,
	type?: GraphQLTypes["OrderPriceLineType"] | undefined,
	orderItem?: GraphQLTypes["OrderItem"] | undefined,
	orderDiscount?: GraphQLTypes["OrderDiscount"] | undefined,
	orderPayment?: GraphQLTypes["OrderPayment"] | undefined,
	orderDelivery?: GraphQLTypes["OrderDelivery"] | undefined,
	vatRatePermille: number,
	vatRate?: GraphQLTypes["VatRate"] | undefined,
	order?: GraphQLTypes["Order"] | undefined
};
	["OrderPriceLineMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	unitPriceCents?: GraphQLTypes["FieldMeta"] | undefined,
	quantity?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	orderItem?: GraphQLTypes["FieldMeta"] | undefined,
	orderDiscount?: GraphQLTypes["FieldMeta"] | undefined,
	orderPayment?: GraphQLTypes["FieldMeta"] | undefined,
	orderDelivery?: GraphQLTypes["FieldMeta"] | undefined,
	vatRatePermille?: GraphQLTypes["FieldMeta"] | undefined,
	vatRate?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined
};
	["OrderPriceLineOrderBy"]: GraphQLTypes["OrderPriceLineOrderBy"];
	["OrderSummary"]: {
		_meta?: GraphQLTypes["OrderSummaryMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	totalPriceCents: number,
	discountPriceCents: number,
	undiscountedPriceCents: number,
	itemsQuantity: number,
	orderUrl: string,
	orderNumber: string,
	order?: GraphQLTypes["Order"] | undefined
};
	["OrderSummaryMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	totalPriceCents?: GraphQLTypes["FieldMeta"] | undefined,
	discountPriceCents?: GraphQLTypes["FieldMeta"] | undefined,
	undiscountedPriceCents?: GraphQLTypes["FieldMeta"] | undefined,
	itemsQuantity?: GraphQLTypes["FieldMeta"] | undefined,
	orderUrl?: GraphQLTypes["FieldMeta"] | undefined,
	orderNumber?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined
};
	["Gratuity"]: {
		_meta?: GraphQLTypes["GratuityMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	amountCents: number,
	order?: GraphQLTypes["Order"] | undefined
};
	["GratuityMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	amountCents?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined
};
	["OrderDiscountsByCustomerCreditTransactionsUniqueWhere"]: GraphQLTypes["OrderDiscountsByCustomerCreditTransactionsUniqueWhere"];
	["OrderDiscountsByVoucherRedemptionUniqueWhere"]: GraphQLTypes["OrderDiscountsByVoucherRedemptionUniqueWhere"];
	["OrderItemsByVirtualProductEffectsUniqueWhere"]: GraphQLTypes["OrderItemsByVirtualProductEffectsUniqueWhere"];
	["OrderPriceLinesByOrderItemUniqueWhere"]: GraphQLTypes["OrderPriceLinesByOrderItemUniqueWhere"];
	["OrderPriceLinesByOrderDiscountUniqueWhere"]: GraphQLTypes["OrderPriceLinesByOrderDiscountUniqueWhere"];
	["OrderPriceLinesByOrderPaymentUniqueWhere"]: GraphQLTypes["OrderPriceLinesByOrderPaymentUniqueWhere"];
	["OrderPriceLinesByOrderDeliveryUniqueWhere"]: GraphQLTypes["OrderPriceLinesByOrderDeliveryUniqueWhere"];
	["OrderPaymentsByEventsUniqueWhere"]: GraphQLTypes["OrderPaymentsByEventsUniqueWhere"];
	["OrderPaymentsByMetaUniqueWhere"]: GraphQLTypes["OrderPaymentsByMetaUniqueWhere"];
	["OrderDiscountConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["OrderDiscountEdge"]>
};
	["OrderDiscountEdge"]: {
		node: GraphQLTypes["OrderDiscount"]
};
	["OrderItemConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["OrderItemEdge"]>
};
	["OrderItemEdge"]: {
		node: GraphQLTypes["OrderItem"]
};
	["OrderPriceLineConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["OrderPriceLineEdge"]>
};
	["OrderPriceLineEdge"]: {
		node: GraphQLTypes["OrderPriceLine"]
};
	["Area"]: {
		_meta?: GraphQLTypes["AreaMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	name?: string | undefined,
	venue?: GraphQLTypes["Venue"] | undefined,
	tables: Array<GraphQLTypes["Table"]>,
	lines: Array<GraphQLTypes["Line"]>,
	tablesByCustomerTabs?: GraphQLTypes["Table"] | undefined,
	tablesBySeats?: GraphQLTypes["Table"] | undefined,
	paginateTables: GraphQLTypes["TableConnection"],
	paginateLines: GraphQLTypes["LineConnection"]
};
	["AreaMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	venue?: GraphQLTypes["FieldMeta"] | undefined,
	tables?: GraphQLTypes["FieldMeta"] | undefined,
	lines?: GraphQLTypes["FieldMeta"] | undefined
};
	["Table"]: {
		_meta?: GraphQLTypes["TableMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	shape: GraphQLTypes["TableShape"],
	width: number,
	height: number,
	positionX: number,
	positionY: number,
	name?: string | undefined,
	color?: string | undefined,
	customerTabs: Array<GraphQLTypes["CustomerTab"]>,
	area?: GraphQLTypes["Area"] | undefined,
	seats: Array<GraphQLTypes["Seat"]>,
	customerTabsByItems?: GraphQLTypes["CustomerTab"] | undefined,
	customerTabsByMeta?: GraphQLTypes["CustomerTab"] | undefined,
	seatsByCustomerTabs?: GraphQLTypes["Seat"] | undefined,
	paginateCustomerTabs: GraphQLTypes["CustomerTabConnection"],
	paginateSeats: GraphQLTypes["SeatConnection"]
};
	["TableMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	shape?: GraphQLTypes["FieldMeta"] | undefined,
	width?: GraphQLTypes["FieldMeta"] | undefined,
	height?: GraphQLTypes["FieldMeta"] | undefined,
	positionX?: GraphQLTypes["FieldMeta"] | undefined,
	positionY?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	color?: GraphQLTypes["FieldMeta"] | undefined,
	customerTabs?: GraphQLTypes["FieldMeta"] | undefined,
	area?: GraphQLTypes["FieldMeta"] | undefined,
	seats?: GraphQLTypes["FieldMeta"] | undefined
};
	["CustomerTab"]: {
		_meta?: GraphQLTypes["CustomerTabMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt: GraphQLTypes["DateTime"],
	color?: string | undefined,
	items: Array<GraphQLTypes["CustomerTabItem"]>,
	name?: string | undefined,
	meta?: GraphQLTypes["CustomerTabMetadata"] | undefined,
	customer?: GraphQLTypes["Customer"] | undefined,
	table?: GraphQLTypes["Table"] | undefined,
	seat?: GraphQLTypes["Seat"] | undefined,
	paginateItems: GraphQLTypes["CustomerTabItemConnection"]
};
	["CustomerTabMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	color?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	meta?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined,
	table?: GraphQLTypes["FieldMeta"] | undefined,
	seat?: GraphQLTypes["FieldMeta"] | undefined
};
	["CustomerTabItem"]: {
		_meta?: GraphQLTypes["CustomerTabItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	addedAt: GraphQLTypes["DateTime"],
	tab?: GraphQLTypes["CustomerTab"] | undefined,
	product?: GraphQLTypes["Product"] | undefined,
	paidAt?: GraphQLTypes["DateTime"] | undefined
};
	["CustomerTabItemMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	addedAt?: GraphQLTypes["FieldMeta"] | undefined,
	tab?: GraphQLTypes["FieldMeta"] | undefined,
	product?: GraphQLTypes["FieldMeta"] | undefined,
	paidAt?: GraphQLTypes["FieldMeta"] | undefined
};
	["CustomerTabItemOrderBy"]: GraphQLTypes["CustomerTabItemOrderBy"];
	["CustomerTabOrderBy"]: GraphQLTypes["CustomerTabOrderBy"];
	["CustomerTabMetadataOrderBy"]: GraphQLTypes["CustomerTabMetadataOrderBy"];
	["TableOrderBy"]: GraphQLTypes["TableOrderBy"];
	["AreaOrderBy"]: GraphQLTypes["AreaOrderBy"];
	["SeatOrderBy"]: GraphQLTypes["SeatOrderBy"];
	["CustomerTabMetadata"]: {
		_meta?: GraphQLTypes["CustomerTabMetadataMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	totalPriceCents: number,
	totalSpentCents: number,
	unpaidCents: number,
	customerTab?: GraphQLTypes["CustomerTab"] | undefined
};
	["CustomerTabMetadataMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	totalPriceCents?: GraphQLTypes["FieldMeta"] | undefined,
	totalSpentCents?: GraphQLTypes["FieldMeta"] | undefined,
	unpaidCents?: GraphQLTypes["FieldMeta"] | undefined,
	customerTab?: GraphQLTypes["FieldMeta"] | undefined
};
	["Seat"]: {
		_meta?: GraphQLTypes["SeatMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	positionX: number,
	positionY: number,
	name?: string | undefined,
	color?: string | undefined,
	customerTabs: Array<GraphQLTypes["CustomerTab"]>,
	table?: GraphQLTypes["Table"] | undefined,
	customerTabsByItems?: GraphQLTypes["CustomerTab"] | undefined,
	customerTabsByMeta?: GraphQLTypes["CustomerTab"] | undefined,
	paginateCustomerTabs: GraphQLTypes["CustomerTabConnection"]
};
	["SeatMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	positionX?: GraphQLTypes["FieldMeta"] | undefined,
	positionY?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	color?: GraphQLTypes["FieldMeta"] | undefined,
	customerTabs?: GraphQLTypes["FieldMeta"] | undefined,
	table?: GraphQLTypes["FieldMeta"] | undefined
};
	["SeatCustomerTabsByItemsUniqueWhere"]: GraphQLTypes["SeatCustomerTabsByItemsUniqueWhere"];
	["SeatCustomerTabsByMetaUniqueWhere"]: GraphQLTypes["SeatCustomerTabsByMetaUniqueWhere"];
	["CustomerTabConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CustomerTabEdge"]>
};
	["CustomerTabEdge"]: {
		node: GraphQLTypes["CustomerTab"]
};
	["CustomerTabItemConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CustomerTabItemEdge"]>
};
	["CustomerTabItemEdge"]: {
		node: GraphQLTypes["CustomerTabItem"]
};
	["TableCustomerTabsByItemsUniqueWhere"]: GraphQLTypes["TableCustomerTabsByItemsUniqueWhere"];
	["TableCustomerTabsByMetaUniqueWhere"]: GraphQLTypes["TableCustomerTabsByMetaUniqueWhere"];
	["TableSeatsByCustomerTabsUniqueWhere"]: GraphQLTypes["TableSeatsByCustomerTabsUniqueWhere"];
	["SeatConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SeatEdge"]>
};
	["SeatEdge"]: {
		node: GraphQLTypes["Seat"]
};
	["Line"]: {
		_meta?: GraphQLTypes["LineMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	positionStartX: number,
	positionStartY: number,
	positionEndX: number,
	positionEndY: number,
	area?: GraphQLTypes["Area"] | undefined
};
	["LineMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	positionStartX?: GraphQLTypes["FieldMeta"] | undefined,
	positionStartY?: GraphQLTypes["FieldMeta"] | undefined,
	positionEndX?: GraphQLTypes["FieldMeta"] | undefined,
	positionEndY?: GraphQLTypes["FieldMeta"] | undefined,
	area?: GraphQLTypes["FieldMeta"] | undefined
};
	["LineOrderBy"]: GraphQLTypes["LineOrderBy"];
	["AreaTablesByCustomerTabsUniqueWhere"]: GraphQLTypes["AreaTablesByCustomerTabsUniqueWhere"];
	["AreaTablesBySeatsUniqueWhere"]: GraphQLTypes["AreaTablesBySeatsUniqueWhere"];
	["SeatUniqueWhere"]: GraphQLTypes["SeatUniqueWhere"];
	["TableConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TableEdge"]>
};
	["TableEdge"]: {
		node: GraphQLTypes["Table"]
};
	["LineConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LineEdge"]>
};
	["LineEdge"]: {
		node: GraphQLTypes["Line"]
};
	["VenueTimetableDaysByDateUniqueWhere"]: GraphQLTypes["VenueTimetableDaysByDateUniqueWhere"];
	["VenueTimetableDaysByShiftGroupsUniqueWhere"]: GraphQLTypes["VenueTimetableDaysByShiftGroupsUniqueWhere"];
	["VenueTimetableDaysByNotesUniqueWhere"]: GraphQLTypes["VenueTimetableDaysByNotesUniqueWhere"];
	["TimetableDayNoteUniqueWhere"]: GraphQLTypes["TimetableDayNoteUniqueWhere"];
	["VenueTimetableDaysByMetaUniqueWhere"]: GraphQLTypes["VenueTimetableDaysByMetaUniqueWhere"];
	["TimetableDayMetadataUniqueWhere"]: GraphQLTypes["TimetableDayMetadataUniqueWhere"];
	["TimetableDayUniqueWhere"]: GraphQLTypes["TimetableDayUniqueWhere"];
	["VenueUniqueWhere"]: GraphQLTypes["VenueUniqueWhere"];
	["DeadlineTemplateUniqueWhere"]: GraphQLTypes["DeadlineTemplateUniqueWhere"];
	["TimetableTemplateUniqueWhere"]: GraphQLTypes["TimetableTemplateUniqueWhere"];
	["VenueEmployeeRoleUniqueWhere"]: GraphQLTypes["VenueEmployeeRoleUniqueWhere"];
	["TimetableEmployeeRoleUniqueWhere"]: GraphQLTypes["TimetableEmployeeRoleUniqueWhere"];
	["TimetablesEmployeePrivilegesUniqueWhere"]: GraphQLTypes["TimetablesEmployeePrivilegesUniqueWhere"];
	["PointOfSaleTerminalUniqueWhere"]: GraphQLTypes["PointOfSaleTerminalUniqueWhere"];
	["PointOfSalePrinterUniqueWhere"]: GraphQLTypes["PointOfSalePrinterUniqueWhere"];
	["AreaUniqueWhere"]: GraphQLTypes["AreaUniqueWhere"];
	["TableUniqueWhere"]: GraphQLTypes["TableUniqueWhere"];
	["LineUniqueWhere"]: GraphQLTypes["LineUniqueWhere"];
	["ChannelUniqueWhere"]: GraphQLTypes["ChannelUniqueWhere"];
	["ChannelPaymentUniqueWhere"]: GraphQLTypes["ChannelPaymentUniqueWhere"];
	["VenueTimetableTemplatesByStaffOptionsUniqueWhere"]: GraphQLTypes["VenueTimetableTemplatesByStaffOptionsUniqueWhere"];
	["VenueEmployeeRolesByRoleUniqueWhere"]: GraphQLTypes["VenueEmployeeRolesByRoleUniqueWhere"];
	["VenueEmployeeRolesByEmployeePrivilegesUniqueWhere"]: GraphQLTypes["VenueEmployeeRolesByEmployeePrivilegesUniqueWhere"];
	["VenuePointOfSaleApplicationDevicesByIdentifierUniqueWhere"]: GraphQLTypes["VenuePointOfSaleApplicationDevicesByIdentifierUniqueWhere"];
	["VenuePointOfSaleTerminalsByApplicationDevicesUniqueWhere"]: GraphQLTypes["VenuePointOfSaleTerminalsByApplicationDevicesUniqueWhere"];
	["VenuePointOfSalePrintersByApplicationDevicesReceiptUniqueWhere"]: GraphQLTypes["VenuePointOfSalePrintersByApplicationDevicesReceiptUniqueWhere"];
	["VenueOrdersBySeqUniqueWhere"]: GraphQLTypes["VenueOrdersBySeqUniqueWhere"];
	["VenueOrdersByDoubleshotLegacyIdUniqueWhere"]: GraphQLTypes["VenueOrdersByDoubleshotLegacyIdUniqueWhere"];
	["VenueOrdersByDoubleShotLegacyNumberUniqueWhere"]: GraphQLTypes["VenueOrdersByDoubleShotLegacyNumberUniqueWhere"];
	["VenueOrdersByDiscountsUniqueWhere"]: GraphQLTypes["VenueOrdersByDiscountsUniqueWhere"];
	["VenueOrdersByDeliveryUniqueWhere"]: GraphQLTypes["VenueOrdersByDeliveryUniqueWhere"];
	["VenueOrdersByItemsUniqueWhere"]: GraphQLTypes["VenueOrdersByItemsUniqueWhere"];
	["VenueOrdersByCartUniqueWhere"]: GraphQLTypes["VenueOrdersByCartUniqueWhere"];
	["VenueOrdersByEventsUniqueWhere"]: GraphQLTypes["VenueOrdersByEventsUniqueWhere"];
	["VenueOrdersByPriceLinesUniqueWhere"]: GraphQLTypes["VenueOrdersByPriceLinesUniqueWhere"];
	["VenueOrdersByPaymentsUniqueWhere"]: GraphQLTypes["VenueOrdersByPaymentsUniqueWhere"];
	["VenueOrdersBySummaryUniqueWhere"]: GraphQLTypes["VenueOrdersBySummaryUniqueWhere"];
	["VenueOrdersByGratuityUniqueWhere"]: GraphQLTypes["VenueOrdersByGratuityUniqueWhere"];
	["VenueAreasByTablesUniqueWhere"]: GraphQLTypes["VenueAreasByTablesUniqueWhere"];
	["VenueAreasByLinesUniqueWhere"]: GraphQLTypes["VenueAreasByLinesUniqueWhere"];
	["VenueCategoriesBySlugUniqueWhere"]: GraphQLTypes["VenueCategoriesBySlugUniqueWhere"];
	["VenueCategoriesByLocalesUniqueWhere"]: GraphQLTypes["VenueCategoriesByLocalesUniqueWhere"];
	["VenueCategoriesByProductsUniqueWhere"]: GraphQLTypes["VenueCategoriesByProductsUniqueWhere"];
	["VenueChannelsByCodeUniqueWhere"]: GraphQLTypes["VenueChannelsByCodeUniqueWhere"];
	["VenueChannelsByPaymentsUniqueWhere"]: GraphQLTypes["VenueChannelsByPaymentsUniqueWhere"];
	["VenueChannelsByDeliveriesUniqueWhere"]: GraphQLTypes["VenueChannelsByDeliveriesUniqueWhere"];
	["VenueChannelsByCartsUniqueWhere"]: GraphQLTypes["VenueChannelsByCartsUniqueWhere"];
	["TimetableDayConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TimetableDayEdge"]>
};
	["TimetableDayEdge"]: {
		node: GraphQLTypes["TimetableDay"]
};
	["StaffConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["StaffEdge"]>
};
	["StaffEdge"]: {
		node: GraphQLTypes["Staff"]
};
	["VenueEmployeeRoleConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["VenueEmployeeRoleEdge"]>
};
	["VenueEmployeeRoleEdge"]: {
		node: GraphQLTypes["VenueEmployeeRole"]
};
	["PointOfSaleTerminalConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PointOfSaleTerminalEdge"]>
};
	["PointOfSaleTerminalEdge"]: {
		node: GraphQLTypes["PointOfSaleTerminal"]
};
	["AreaConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["AreaEdge"]>
};
	["AreaEdge"]: {
		node: GraphQLTypes["Area"]
};
	["UnassignReasonConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["UnassignReasonEdge"]>
};
	["UnassignReasonEdge"]: {
		node: GraphQLTypes["UnassignReason"]
};
	["CartItemOrderBy"]: GraphQLTypes["CartItemOrderBy"];
	["CartItemConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CartItemEdge"]>
};
	["CartItemEdge"]: {
		node: GraphQLTypes["CartItem"]
};
	["CartPriceLine"]: {
		_meta?: GraphQLTypes["CartPriceLineMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	type?: GraphQLTypes["CartPriceLineType"] | undefined,
	item?: GraphQLTypes["CartItem"] | undefined,
	product?: GraphQLTypes["Product"] | undefined,
	unitPriceCents: number,
	priceCents: number,
	quantity: number,
	vatRatePermille: number,
	vatRate?: GraphQLTypes["VatRate"] | undefined,
	cart?: GraphQLTypes["Cart"] | undefined
};
	["CartPriceLineMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	item?: GraphQLTypes["FieldMeta"] | undefined,
	product?: GraphQLTypes["FieldMeta"] | undefined,
	unitPriceCents?: GraphQLTypes["FieldMeta"] | undefined,
	priceCents?: GraphQLTypes["FieldMeta"] | undefined,
	quantity?: GraphQLTypes["FieldMeta"] | undefined,
	vatRatePermille?: GraphQLTypes["FieldMeta"] | undefined,
	vatRate?: GraphQLTypes["FieldMeta"] | undefined,
	cart?: GraphQLTypes["FieldMeta"] | undefined
};
	["CartPriceLineOrderBy"]: GraphQLTypes["CartPriceLineOrderBy"];
	["CartSummary"]: {
		_meta?: GraphQLTypes["CartSummaryMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	itemsPriceCents: number,
	deliveryPriceCents: number,
	totalPriceCents: number,
	itemsCount: number,
	itemsQuantity: number,
	checkoutUrl: string,
	cart?: GraphQLTypes["Cart"] | undefined
};
	["CartSummaryMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	itemsPriceCents?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryPriceCents?: GraphQLTypes["FieldMeta"] | undefined,
	totalPriceCents?: GraphQLTypes["FieldMeta"] | undefined,
	itemsCount?: GraphQLTypes["FieldMeta"] | undefined,
	itemsQuantity?: GraphQLTypes["FieldMeta"] | undefined,
	checkoutUrl?: GraphQLTypes["FieldMeta"] | undefined,
	cart?: GraphQLTypes["FieldMeta"] | undefined
};
	["CartItemsByProductUniqueWhere"]: GraphQLTypes["CartItemsByProductUniqueWhere"];
	["CartPriceLineConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CartPriceLineEdge"]>
};
	["CartPriceLineEdge"]: {
		node: GraphQLTypes["CartPriceLine"]
};
	["ChannelCartsByItemsUniqueWhere"]: GraphQLTypes["ChannelCartsByItemsUniqueWhere"];
	["ChannelCartsByOrderUniqueWhere"]: GraphQLTypes["ChannelCartsByOrderUniqueWhere"];
	["ChannelCartsByPriceLinesUniqueWhere"]: GraphQLTypes["ChannelCartsByPriceLinesUniqueWhere"];
	["ChannelCartsBySummaryUniqueWhere"]: GraphQLTypes["ChannelCartsBySummaryUniqueWhere"];
	["ChannelPaymentConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ChannelPaymentEdge"]>
};
	["ChannelPaymentEdge"]: {
		node: GraphQLTypes["ChannelPayment"]
};
	["ChannelDeliveryConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ChannelDeliveryEdge"]>
};
	["ChannelDeliveryEdge"]: {
		node: GraphQLTypes["ChannelDelivery"]
};
	["PointOfSaleConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PointOfSaleEdge"]>
};
	["PointOfSaleEdge"]: {
		node: GraphQLTypes["PointOfSale"]
};
	["CartConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CartEdge"]>
};
	["CartEdge"]: {
		node: GraphQLTypes["Cart"]
};
	["CustomerConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CustomerEdge"]>
};
	["CustomerEdge"]: {
		node: GraphQLTypes["Customer"]
};
	["LiftagoRide"]: {
		_meta?: GraphQLTypes["LiftagoRideMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	liftagoId?: string | undefined,
	data?: string | undefined,
	updatedAt?: GraphQLTypes["DateTime"] | undefined,
	delivery?: GraphQLTypes["OrderDelivery"] | undefined
};
	["LiftagoRideMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	liftagoId?: GraphQLTypes["FieldMeta"] | undefined,
	data?: GraphQLTypes["FieldMeta"] | undefined,
	updatedAt?: GraphQLTypes["FieldMeta"] | undefined,
	delivery?: GraphQLTypes["FieldMeta"] | undefined
};
	["WoltDriveDelivery"]: {
		_meta?: GraphQLTypes["WoltDriveDeliveryMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	state: GraphQLTypes["WoltDriveDeliveryState"],
	shipmentPromiseId: string,
	deliveryPrice: number,
	deliveryPriceCurrency: string,
	shipmentPromiseResponse?: string | undefined,
	deliveryOrderId?: string | undefined,
	trackingUrl?: string | undefined,
	deliverOrderResponse?: string | undefined,
	delivery?: GraphQLTypes["OrderDelivery"] | undefined
};
	["WoltDriveDeliveryMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	state?: GraphQLTypes["FieldMeta"] | undefined,
	shipmentPromiseId?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryPrice?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryPriceCurrency?: GraphQLTypes["FieldMeta"] | undefined,
	shipmentPromiseResponse?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryOrderId?: GraphQLTypes["FieldMeta"] | undefined,
	trackingUrl?: GraphQLTypes["FieldMeta"] | undefined,
	deliverOrderResponse?: GraphQLTypes["FieldMeta"] | undefined,
	delivery?: GraphQLTypes["FieldMeta"] | undefined
};
	["DeliveryRouteWaypointsByDeliveryUniqueWhere"]: GraphQLTypes["DeliveryRouteWaypointsByDeliveryUniqueWhere"];
	["DeliveryWaypointConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DeliveryWaypointEdge"]>
};
	["DeliveryWaypointEdge"]: {
		node: GraphQLTypes["DeliveryWaypoint"]
};
	["CourierRoutesByWaypointsUniqueWhere"]: GraphQLTypes["CourierRoutesByWaypointsUniqueWhere"];
	["DeliveryRouteConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DeliveryRouteEdge"]>
};
	["DeliveryRouteEdge"]: {
		node: GraphQLTypes["DeliveryRoute"]
};
	["DeliveryMethodConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DeliveryMethodEdge"]>
};
	["DeliveryMethodEdge"]: {
		node: GraphQLTypes["DeliveryMethod"]
};
	["Cleaner"]: {
		_meta?: GraphQLTypes["CleanerMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	staff?: GraphQLTypes["Staff"] | undefined,
	canReachTopShelf: boolean,
	createdAt?: GraphQLTypes["DateTime"] | undefined
};
	["CleanerMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	staff?: GraphQLTypes["FieldMeta"] | undefined,
	canReachTopShelf?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined
};
	["StocksManager"]: {
		_meta?: GraphQLTypes["StocksManagerMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	staff?: GraphQLTypes["Staff"] | undefined,
	managedProducts: Array<GraphQLTypes["Product"]>,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	managedProductsByCode?: GraphQLTypes["Product"] | undefined,
	managedProductsByStocks?: GraphQLTypes["Product"] | undefined,
	managedProductsByGroupPrices?: GraphQLTypes["Product"] | undefined,
	managedProductsByCartItems?: GraphQLTypes["Product"] | undefined,
	managedProductsByOrderItems?: GraphQLTypes["Product"] | undefined,
	managedProductsByInheritedCategories?: GraphQLTypes["Product"] | undefined,
	managedProductsByLocales?: GraphQLTypes["Product"] | undefined,
	managedProductsByCustomerPrices?: GraphQLTypes["Product"] | undefined,
	managedProductsByVirtualProduct?: GraphQLTypes["Product"] | undefined,
	managedProductsByMeta?: GraphQLTypes["Product"] | undefined,
	managedProductsByPage?: GraphQLTypes["Product"] | undefined,
	managedProductsBySalesDays?: GraphQLTypes["Product"] | undefined,
	managedProductsBySalesWeeks?: GraphQLTypes["Product"] | undefined,
	managedProductsBySalesMonths?: GraphQLTypes["Product"] | undefined,
	paginateManagedProducts: GraphQLTypes["ProductConnection"]
};
	["StocksManagerMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	staff?: GraphQLTypes["FieldMeta"] | undefined,
	managedProducts?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined
};
	["StocksManagerManagedProductsByCodeUniqueWhere"]: GraphQLTypes["StocksManagerManagedProductsByCodeUniqueWhere"];
	["StocksManagerManagedProductsByStocksUniqueWhere"]: GraphQLTypes["StocksManagerManagedProductsByStocksUniqueWhere"];
	["StocksManagerManagedProductsByGroupPricesUniqueWhere"]: GraphQLTypes["StocksManagerManagedProductsByGroupPricesUniqueWhere"];
	["StocksManagerManagedProductsByCartItemsUniqueWhere"]: GraphQLTypes["StocksManagerManagedProductsByCartItemsUniqueWhere"];
	["StocksManagerManagedProductsByOrderItemsUniqueWhere"]: GraphQLTypes["StocksManagerManagedProductsByOrderItemsUniqueWhere"];
	["StocksManagerManagedProductsByInheritedCategoriesUniqueWhere"]: GraphQLTypes["StocksManagerManagedProductsByInheritedCategoriesUniqueWhere"];
	["StocksManagerManagedProductsByLocalesUniqueWhere"]: GraphQLTypes["StocksManagerManagedProductsByLocalesUniqueWhere"];
	["StocksManagerManagedProductsByCustomerPricesUniqueWhere"]: GraphQLTypes["StocksManagerManagedProductsByCustomerPricesUniqueWhere"];
	["StocksManagerManagedProductsByVirtualProductUniqueWhere"]: GraphQLTypes["StocksManagerManagedProductsByVirtualProductUniqueWhere"];
	["StocksManagerManagedProductsByMetaUniqueWhere"]: GraphQLTypes["StocksManagerManagedProductsByMetaUniqueWhere"];
	["StocksManagerManagedProductsByPageUniqueWhere"]: GraphQLTypes["StocksManagerManagedProductsByPageUniqueWhere"];
	["StocksManagerManagedProductsBySalesDaysUniqueWhere"]: GraphQLTypes["StocksManagerManagedProductsBySalesDaysUniqueWhere"];
	["StocksManagerManagedProductsBySalesWeeksUniqueWhere"]: GraphQLTypes["StocksManagerManagedProductsBySalesWeeksUniqueWhere"];
	["StocksManagerManagedProductsBySalesMonthsUniqueWhere"]: GraphQLTypes["StocksManagerManagedProductsBySalesMonthsUniqueWhere"];
	["CourierManager"]: {
		_meta?: GraphQLTypes["CourierManagerMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	staff?: GraphQLTypes["Staff"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined
};
	["CourierManagerMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	staff?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined
};
	["Picker"]: {
		_meta?: GraphQLTypes["PickerMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	staff?: GraphQLTypes["Staff"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined
};
	["PickerMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	staff?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined
};
	["RemunerationProfile"]: {
		_meta?: GraphQLTypes["RemunerationProfileMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	employmentInformation: Array<GraphQLTypes["EmploymentInformation"]>,
	workMonths?: GraphQLTypes["WorkMonth"] | undefined,
	staff?: GraphQLTypes["Staff"] | undefined,
	paginateEmploymentInformation: GraphQLTypes["EmploymentInformationConnection"]
};
	["RemunerationProfileMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	employmentInformation?: GraphQLTypes["FieldMeta"] | undefined,
	workMonths?: GraphQLTypes["FieldMeta"] | undefined,
	staff?: GraphQLTypes["FieldMeta"] | undefined
};
	["EmploymentInformation"]: {
		_meta?: GraphQLTypes["EmploymentInformationMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	hourlyRate?: number | undefined,
	remunerationProfiles?: GraphQLTypes["RemunerationProfile"] | undefined,
	monthlySalary?: number | undefined,
	type: GraphQLTypes["EmploymentType"],
	name: string
};
	["EmploymentInformationMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	hourlyRate?: GraphQLTypes["FieldMeta"] | undefined,
	remunerationProfiles?: GraphQLTypes["FieldMeta"] | undefined,
	monthlySalary?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined
};
	["EmploymentInformationOrderBy"]: GraphQLTypes["EmploymentInformationOrderBy"];
	["WorkMonth"]: {
		_meta?: GraphQLTypes["WorkMonthMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	year?: number | undefined,
	month?: number | undefined,
	hoursWorked?: number | undefined,
	billableHours?: number | undefined,
	remunerationProfile: Array<GraphQLTypes["RemunerationProfile"]>,
	remunerationProfileByEmploymentInformation?: GraphQLTypes["RemunerationProfile"] | undefined,
	remunerationProfileByStaff?: GraphQLTypes["RemunerationProfile"] | undefined,
	paginateRemunerationProfile: GraphQLTypes["RemunerationProfileConnection"]
};
	["WorkMonthMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	year?: GraphQLTypes["FieldMeta"] | undefined,
	month?: GraphQLTypes["FieldMeta"] | undefined,
	hoursWorked?: GraphQLTypes["FieldMeta"] | undefined,
	billableHours?: GraphQLTypes["FieldMeta"] | undefined,
	remunerationProfile?: GraphQLTypes["FieldMeta"] | undefined
};
	["WorkMonthRemunerationProfileByEmploymentInformationUniqueWhere"]: GraphQLTypes["WorkMonthRemunerationProfileByEmploymentInformationUniqueWhere"];
	["WorkMonthRemunerationProfileByStaffUniqueWhere"]: GraphQLTypes["WorkMonthRemunerationProfileByStaffUniqueWhere"];
	["RemunerationProfileConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["RemunerationProfileEdge"]>
};
	["RemunerationProfileEdge"]: {
		node: GraphQLTypes["RemunerationProfile"]
};
	["EmploymentInformationConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["EmploymentInformationEdge"]>
};
	["EmploymentInformationEdge"]: {
		node: GraphQLTypes["EmploymentInformation"]
};
	["Cashier"]: {
		_meta?: GraphQLTypes["CashierMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	staff?: GraphQLTypes["Staff"] | undefined
};
	["CashierMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	staff?: GraphQLTypes["FieldMeta"] | undefined
};
	["InternalBuyer"]: {
		_meta?: GraphQLTypes["InternalBuyerMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	staff?: GraphQLTypes["Staff"] | undefined
};
	["InternalBuyerMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	staff?: GraphQLTypes["FieldMeta"] | undefined
};
	["SalesManager"]: {
		_meta?: GraphQLTypes["SalesManagerMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	staff?: GraphQLTypes["Staff"] | undefined,
	createdAt: GraphQLTypes["DateTime"],
	countries: Array<GraphQLTypes["Country"]>,
	paginateCountries: GraphQLTypes["CountryConnection"]
};
	["SalesManagerMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	staff?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	countries?: GraphQLTypes["FieldMeta"] | undefined
};
	["CountryConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CountryEdge"]>
};
	["CountryEdge"]: {
		node: GraphQLTypes["Country"]
};
	["CashierManager"]: {
		_meta?: GraphQLTypes["CashierManagerMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	staff?: GraphQLTypes["Staff"] | undefined
};
	["CashierManagerMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	staff?: GraphQLTypes["FieldMeta"] | undefined
};
	["BusinessToBusinessManagerManagedBusinessesByCustomerUniqueWhere"]: GraphQLTypes["BusinessToBusinessManagerManagedBusinessesByCustomerUniqueWhere"];
	["BusinessToBusinessManagerManagedBusinessesByBusinessServiceEventsUniqueWhere"]: GraphQLTypes["BusinessToBusinessManagerManagedBusinessesByBusinessServiceEventsUniqueWhere"];
	["BusinessToBusinessManagerManagedBusinessesByDoubleshotCoffeeEquipmentUniqueWhere"]: GraphQLTypes["BusinessToBusinessManagerManagedBusinessesByDoubleshotCoffeeEquipmentUniqueWhere"];
	["BusinessCustomerConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BusinessCustomerEdge"]>
};
	["BusinessCustomerEdge"]: {
		node: GraphQLTypes["BusinessCustomer"]
};
	["BusinessServiceEvent"]: {
		_meta?: GraphQLTypes["BusinessServiceEventMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt: GraphQLTypes["DateTime"],
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	businessCustomer?: GraphQLTypes["BusinessCustomer"] | undefined,
	businessService?: GraphQLTypes["BusinessService"] | undefined,
	filledNumberOfPeople?: number | undefined,
	filledInvoiced?: boolean | undefined,
	filledEquipment?: string | undefined,
	filledMillTamDem?: boolean | undefined,
	filledSOEspresso?: boolean | undefined,
	filledFilterCoffeeInMenu?: boolean | undefined,
	filledWaterMeterStatus?: string | undefined,
	filledServiceAction?: string | undefined,
	filledInvoiceIdentifier?: string | undefined,
	filledNote?: string | undefined,
	filledContact?: string | undefined,
	filledPhone?: boolean | undefined,
	filledEmail?: boolean | undefined,
	filledGrindingStonesCondition?: string | undefined,
	createdBy?: GraphQLTypes["Staff"] | undefined,
	filledSupervisor?: GraphQLTypes["Staff"] | undefined
};
	["BusinessServiceEventMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	fulfilledAt?: GraphQLTypes["FieldMeta"] | undefined,
	businessCustomer?: GraphQLTypes["FieldMeta"] | undefined,
	businessService?: GraphQLTypes["FieldMeta"] | undefined,
	filledNumberOfPeople?: GraphQLTypes["FieldMeta"] | undefined,
	filledInvoiced?: GraphQLTypes["FieldMeta"] | undefined,
	filledEquipment?: GraphQLTypes["FieldMeta"] | undefined,
	filledMillTamDem?: GraphQLTypes["FieldMeta"] | undefined,
	filledSOEspresso?: GraphQLTypes["FieldMeta"] | undefined,
	filledFilterCoffeeInMenu?: GraphQLTypes["FieldMeta"] | undefined,
	filledWaterMeterStatus?: GraphQLTypes["FieldMeta"] | undefined,
	filledServiceAction?: GraphQLTypes["FieldMeta"] | undefined,
	filledInvoiceIdentifier?: GraphQLTypes["FieldMeta"] | undefined,
	filledNote?: GraphQLTypes["FieldMeta"] | undefined,
	filledContact?: GraphQLTypes["FieldMeta"] | undefined,
	filledPhone?: GraphQLTypes["FieldMeta"] | undefined,
	filledEmail?: GraphQLTypes["FieldMeta"] | undefined,
	filledGrindingStonesCondition?: GraphQLTypes["FieldMeta"] | undefined,
	createdBy?: GraphQLTypes["FieldMeta"] | undefined,
	filledSupervisor?: GraphQLTypes["FieldMeta"] | undefined
};
	["BusinessService"]: {
		_meta?: GraphQLTypes["BusinessServiceMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	requireNote?: number | undefined,
	locales: Array<GraphQLTypes["BusinessServiceLocale"]>,
	requireNumberOfPeople?: number | undefined,
	requireInvoiced?: number | undefined,
	requireEquipment?: number | undefined,
	requireMillTamDem?: number | undefined,
	requireSOEspresso?: number | undefined,
	requireFilterCoffeeInMenu?: number | undefined,
	requireWaterMeterStatus?: number | undefined,
	requireServiceAction?: number | undefined,
	optionsEquipment?: string | undefined,
	optionsServiceAction?: string | undefined,
	requireInvoiceIdentifier?: number | undefined,
	requireSupervisor?: number | undefined,
	requireContact?: number | undefined,
	requirePhone?: number | undefined,
	requireEmail?: number | undefined,
	requireGrindingStonesCondition?: number | undefined,
	localesByLocale?: GraphQLTypes["BusinessServiceLocale"] | undefined,
	paginateLocales: GraphQLTypes["BusinessServiceLocaleConnection"]
};
	["BusinessServiceMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	requireNote?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	requireNumberOfPeople?: GraphQLTypes["FieldMeta"] | undefined,
	requireInvoiced?: GraphQLTypes["FieldMeta"] | undefined,
	requireEquipment?: GraphQLTypes["FieldMeta"] | undefined,
	requireMillTamDem?: GraphQLTypes["FieldMeta"] | undefined,
	requireSOEspresso?: GraphQLTypes["FieldMeta"] | undefined,
	requireFilterCoffeeInMenu?: GraphQLTypes["FieldMeta"] | undefined,
	requireWaterMeterStatus?: GraphQLTypes["FieldMeta"] | undefined,
	requireServiceAction?: GraphQLTypes["FieldMeta"] | undefined,
	optionsEquipment?: GraphQLTypes["FieldMeta"] | undefined,
	optionsServiceAction?: GraphQLTypes["FieldMeta"] | undefined,
	requireInvoiceIdentifier?: GraphQLTypes["FieldMeta"] | undefined,
	requireSupervisor?: GraphQLTypes["FieldMeta"] | undefined,
	requireContact?: GraphQLTypes["FieldMeta"] | undefined,
	requirePhone?: GraphQLTypes["FieldMeta"] | undefined,
	requireEmail?: GraphQLTypes["FieldMeta"] | undefined,
	requireGrindingStonesCondition?: GraphQLTypes["FieldMeta"] | undefined
};
	["BusinessServiceLocale"]: {
		_meta?: GraphQLTypes["BusinessServiceLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name?: string | undefined,
	labelNote?: string | undefined,
	root?: GraphQLTypes["BusinessService"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	labelNumberOfPeople?: string | undefined,
	labelInvoiced?: string | undefined,
	labelEquipment?: string | undefined,
	labelMillTamDem?: string | undefined,
	labelSOEspresso?: string | undefined,
	labelFilterCoffeeInMenu?: string | undefined,
	labelWaterMeterStatus?: string | undefined,
	labelServiceAction?: string | undefined,
	labelInvoiceIdentifier?: string | undefined,
	labelSupervisor?: string | undefined,
	labelContact?: string | undefined,
	labelPhone?: string | undefined,
	labelEmail?: string | undefined,
	labelGrindingStonesCondition?: string | undefined
};
	["BusinessServiceLocaleMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	labelNote?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	labelNumberOfPeople?: GraphQLTypes["FieldMeta"] | undefined,
	labelInvoiced?: GraphQLTypes["FieldMeta"] | undefined,
	labelEquipment?: GraphQLTypes["FieldMeta"] | undefined,
	labelMillTamDem?: GraphQLTypes["FieldMeta"] | undefined,
	labelSOEspresso?: GraphQLTypes["FieldMeta"] | undefined,
	labelFilterCoffeeInMenu?: GraphQLTypes["FieldMeta"] | undefined,
	labelWaterMeterStatus?: GraphQLTypes["FieldMeta"] | undefined,
	labelServiceAction?: GraphQLTypes["FieldMeta"] | undefined,
	labelInvoiceIdentifier?: GraphQLTypes["FieldMeta"] | undefined,
	labelSupervisor?: GraphQLTypes["FieldMeta"] | undefined,
	labelContact?: GraphQLTypes["FieldMeta"] | undefined,
	labelPhone?: GraphQLTypes["FieldMeta"] | undefined,
	labelEmail?: GraphQLTypes["FieldMeta"] | undefined,
	labelGrindingStonesCondition?: GraphQLTypes["FieldMeta"] | undefined
};
	["BusinessServiceLocaleOrderBy"]: GraphQLTypes["BusinessServiceLocaleOrderBy"];
	["BusinessServiceOrderBy"]: GraphQLTypes["BusinessServiceOrderBy"];
	["BusinessServiceLocalesByLocaleUniqueWhere"]: GraphQLTypes["BusinessServiceLocalesByLocaleUniqueWhere"];
	["BusinessServiceLocaleConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BusinessServiceLocaleEdge"]>
};
	["BusinessServiceLocaleEdge"]: {
		node: GraphQLTypes["BusinessServiceLocale"]
};
	["BusinessServiceEventOrderBy"]: GraphQLTypes["BusinessServiceEventOrderBy"];
	["DoubleshotCoffeeEquipment"]: {
		_meta?: GraphQLTypes["DoubleshotCoffeeEquipmentMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	espressoMachine?: string | undefined,
	espressoGrinder?: string | undefined,
	batchBrew?: string | undefined,
	batchGrinder?: string | undefined,
	waterFilter?: string | undefined,
	mechanicalFilter?: string | undefined
};
	["DoubleshotCoffeeEquipmentMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	espressoMachine?: GraphQLTypes["FieldMeta"] | undefined,
	espressoGrinder?: GraphQLTypes["FieldMeta"] | undefined,
	batchBrew?: GraphQLTypes["FieldMeta"] | undefined,
	batchGrinder?: GraphQLTypes["FieldMeta"] | undefined,
	waterFilter?: GraphQLTypes["FieldMeta"] | undefined,
	mechanicalFilter?: GraphQLTypes["FieldMeta"] | undefined
};
	["BusinessServiceEventConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BusinessServiceEventEdge"]>
};
	["BusinessServiceEventEdge"]: {
		node: GraphQLTypes["BusinessServiceEvent"]
};
	["OrderRecurrence"]: {
		_meta?: GraphQLTypes["OrderRecurrenceMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	internalName: string,
	locales: Array<GraphQLTypes["OrderRecurrenceLocale"]>,
	order: number,
	businessCategory: Array<GraphQLTypes["BusinessCategory"]>,
	localesByLocale?: GraphQLTypes["OrderRecurrenceLocale"] | undefined,
	paginateLocales: GraphQLTypes["OrderRecurrenceLocaleConnection"],
	paginateBusinessCategory: GraphQLTypes["BusinessCategoryConnection"]
};
	["OrderRecurrenceMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	internalName?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	businessCategory?: GraphQLTypes["FieldMeta"] | undefined
};
	["OrderRecurrenceLocale"]: {
		_meta?: GraphQLTypes["OrderRecurrenceLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	root?: GraphQLTypes["OrderRecurrence"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined
};
	["OrderRecurrenceLocaleMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined
};
	["OrderRecurrenceLocaleOrderBy"]: GraphQLTypes["OrderRecurrenceLocaleOrderBy"];
	["OrderRecurrenceOrderBy"]: GraphQLTypes["OrderRecurrenceOrderBy"];
	["OrderRecurrenceLocalesByLocaleUniqueWhere"]: GraphQLTypes["OrderRecurrenceLocalesByLocaleUniqueWhere"];
	["OrderRecurrenceLocaleConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["OrderRecurrenceLocaleEdge"]>
};
	["OrderRecurrenceLocaleEdge"]: {
		node: GraphQLTypes["OrderRecurrenceLocale"]
};
	["BusinessCategoryConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BusinessCategoryEdge"]>
};
	["BusinessCategoryEdge"]: {
		node: GraphQLTypes["BusinessCategory"]
};
	["ProductList"]: {
		_meta?: GraphQLTypes["ProductListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["ProductListItem"]>,
	businessCategory?: GraphQLTypes["BusinessCategory"] | undefined,
	paginateItems: GraphQLTypes["ProductListItemConnection"]
};
	["ProductListMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined,
	businessCategory?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductListItem"]: {
		_meta?: GraphQLTypes["ProductListItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["ProductList"] | undefined,
	product?: GraphQLTypes["Product"] | undefined,
	defaultQuantityForOrder?: number | undefined
};
	["ProductListItemMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	product?: GraphQLTypes["FieldMeta"] | undefined,
	defaultQuantityForOrder?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductListItemOrderBy"]: GraphQLTypes["ProductListItemOrderBy"];
	["ProductListItemConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductListItemEdge"]>
};
	["ProductListItemEdge"]: {
		node: GraphQLTypes["ProductListItem"]
};
	["ProductCategoryList"]: {
		_meta?: GraphQLTypes["ProductCategoryListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["ProductCategoryListItem"]>,
	locales: Array<GraphQLTypes["ProductCategoryListLocale"]>,
	seasonalProductCategoriesOfBusinessCategory?: GraphQLTypes["BusinessCategory"] | undefined,
	specificProductsProductCategoriesOfBusinessCategory?: GraphQLTypes["BusinessCategory"] | undefined,
	localesByLocale?: GraphQLTypes["ProductCategoryListLocale"] | undefined,
	paginateItems: GraphQLTypes["ProductCategoryListItemConnection"],
	paginateLocales: GraphQLTypes["ProductCategoryListLocaleConnection"]
};
	["ProductCategoryListMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	seasonalProductCategoriesOfBusinessCategory?: GraphQLTypes["FieldMeta"] | undefined,
	specificProductsProductCategoriesOfBusinessCategory?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductCategoryListItem"]: {
		_meta?: GraphQLTypes["ProductCategoryListItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["ProductCategoryList"] | undefined,
	productCategory?: GraphQLTypes["ProductCategory"] | undefined,
	showRecipeImages: boolean,
	showPackingImages: boolean,
	showAllAvailableProducts: boolean
};
	["ProductCategoryListItemMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	productCategory?: GraphQLTypes["FieldMeta"] | undefined,
	showRecipeImages?: GraphQLTypes["FieldMeta"] | undefined,
	showPackingImages?: GraphQLTypes["FieldMeta"] | undefined,
	showAllAvailableProducts?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductCategoryListItemOrderBy"]: GraphQLTypes["ProductCategoryListItemOrderBy"];
	["ProductCategoryListLocale"]: {
		_meta?: GraphQLTypes["ProductCategoryListLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	root?: GraphQLTypes["ProductCategoryList"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined
};
	["ProductCategoryListLocaleMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductCategoryListLocaleOrderBy"]: GraphQLTypes["ProductCategoryListLocaleOrderBy"];
	["ProductCategoryListLocalesByLocaleUniqueWhere"]: GraphQLTypes["ProductCategoryListLocalesByLocaleUniqueWhere"];
	["ProductCategoryListItemConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductCategoryListItemEdge"]>
};
	["ProductCategoryListItemEdge"]: {
		node: GraphQLTypes["ProductCategoryListItem"]
};
	["ProductCategoryListLocaleConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductCategoryListLocaleEdge"]>
};
	["ProductCategoryListLocaleEdge"]: {
		node: GraphQLTypes["ProductCategoryListLocale"]
};
	["BusinessCategoryLocalesByLocaleUniqueWhere"]: GraphQLTypes["BusinessCategoryLocalesByLocaleUniqueWhere"];
	["BusinessCategoryBusinessCustomersByCustomerUniqueWhere"]: GraphQLTypes["BusinessCategoryBusinessCustomersByCustomerUniqueWhere"];
	["BusinessCategoryBusinessCustomersByBusinessServiceEventsUniqueWhere"]: GraphQLTypes["BusinessCategoryBusinessCustomersByBusinessServiceEventsUniqueWhere"];
	["BusinessCategoryBusinessCustomersByDoubleshotCoffeeEquipmentUniqueWhere"]: GraphQLTypes["BusinessCategoryBusinessCustomersByDoubleshotCoffeeEquipmentUniqueWhere"];
	["BusinessCategoryLocaleConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BusinessCategoryLocaleEdge"]>
};
	["BusinessCategoryLocaleEdge"]: {
		node: GraphQLTypes["BusinessCategoryLocale"]
};
	["OrderRecurrenceConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["OrderRecurrenceEdge"]>
};
	["OrderRecurrenceEdge"]: {
		node: GraphQLTypes["OrderRecurrence"]
};
	["ProductIngredientLocale"]: {
		_meta?: GraphQLTypes["ProductIngredientLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	root?: GraphQLTypes["ProductIngredient"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined
};
	["ProductIngredientLocaleMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductIngredient"]: {
		_meta?: GraphQLTypes["ProductIngredientMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	internalNote?: string | undefined,
	locales: Array<GraphQLTypes["ProductIngredientLocale"]>,
	internalName: string,
	categories: Array<GraphQLTypes["ProductIngredientCategory"]>,
	allergens: Array<GraphQLTypes["Allergen"]>,
	needsPrepping: boolean,
	allowCustomerRating?: boolean | undefined,
	customerRatings: Array<GraphQLTypes["CustomerIngredientRating"]>,
	preferredQuantityUnit?: GraphQLTypes["ProductIngredientItemQuantityUnit"] | undefined,
	freshingContainer?: GraphQLTypes["FreshingContainer"] | undefined,
	image?: GraphQLTypes["Image"] | undefined,
	suppliers?: GraphQLTypes["IngredientSupplierList"] | undefined,
	incrementQuantityNumber: number,
	localesByLocale?: GraphQLTypes["ProductIngredientLocale"] | undefined,
	customerRatingsByCustomer?: GraphQLTypes["CustomerIngredientRating"] | undefined,
	paginateLocales: GraphQLTypes["ProductIngredientLocaleConnection"],
	paginateCategories: GraphQLTypes["ProductIngredientCategoryConnection"],
	paginateAllergens: GraphQLTypes["AllergenConnection"],
	paginateCustomerRatings: GraphQLTypes["CustomerIngredientRatingConnection"]
};
	["ProductIngredientMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	internalName?: GraphQLTypes["FieldMeta"] | undefined,
	categories?: GraphQLTypes["FieldMeta"] | undefined,
	allergens?: GraphQLTypes["FieldMeta"] | undefined,
	needsPrepping?: GraphQLTypes["FieldMeta"] | undefined,
	allowCustomerRating?: GraphQLTypes["FieldMeta"] | undefined,
	customerRatings?: GraphQLTypes["FieldMeta"] | undefined,
	preferredQuantityUnit?: GraphQLTypes["FieldMeta"] | undefined,
	freshingContainer?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined,
	suppliers?: GraphQLTypes["FieldMeta"] | undefined,
	incrementQuantityNumber?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductIngredientLocaleOrderBy"]: GraphQLTypes["ProductIngredientLocaleOrderBy"];
	["ProductIngredientOrderBy"]: GraphQLTypes["ProductIngredientOrderBy"];
	["ProductIngredientItemQuantityUnitOrderBy"]: GraphQLTypes["ProductIngredientItemQuantityUnitOrderBy"];
	["IngredientSupplierListOrderBy"]: GraphQLTypes["IngredientSupplierListOrderBy"];
	["ProductIngredientCategory"]: {
		_meta?: GraphQLTypes["ProductIngredientCategoryMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	internalName: string,
	internalNote?: string | undefined,
	ingredients: Array<GraphQLTypes["ProductIngredient"]>,
	locales: Array<GraphQLTypes["ProductIngredientCategoryLocale"]>,
	order: number,
	localesByLocale?: GraphQLTypes["ProductIngredientCategoryLocale"] | undefined,
	paginateIngredients: GraphQLTypes["ProductIngredientConnection"],
	paginateLocales: GraphQLTypes["ProductIngredientCategoryLocaleConnection"]
};
	["ProductIngredientCategoryMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	internalName?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	ingredients?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductIngredientCategoryLocale"]: {
		_meta?: GraphQLTypes["ProductIngredientCategoryLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	root?: GraphQLTypes["ProductIngredientCategory"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined
};
	["ProductIngredientCategoryLocaleMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductIngredientCategoryLocaleOrderBy"]: GraphQLTypes["ProductIngredientCategoryLocaleOrderBy"];
	["ProductIngredientCategoryOrderBy"]: GraphQLTypes["ProductIngredientCategoryOrderBy"];
	["ProductIngredientCategoryLocalesByLocaleUniqueWhere"]: GraphQLTypes["ProductIngredientCategoryLocalesByLocaleUniqueWhere"];
	["ProductIngredientConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductIngredientEdge"]>
};
	["ProductIngredientEdge"]: {
		node: GraphQLTypes["ProductIngredient"]
};
	["ProductIngredientCategoryLocaleConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductIngredientCategoryLocaleEdge"]>
};
	["ProductIngredientCategoryLocaleEdge"]: {
		node: GraphQLTypes["ProductIngredientCategoryLocale"]
};
	["Allergen"]: {
		_meta?: GraphQLTypes["AllergenMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	internalName: string,
	locales: Array<GraphQLTypes["AllergenLocale"]>,
	ingredients: Array<GraphQLTypes["ProductIngredient"]>,
	code: number,
	localesByLocale?: GraphQLTypes["AllergenLocale"] | undefined,
	paginateLocales: GraphQLTypes["AllergenLocaleConnection"],
	paginateIngredients: GraphQLTypes["ProductIngredientConnection"]
};
	["AllergenMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	internalName?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	ingredients?: GraphQLTypes["FieldMeta"] | undefined,
	code?: GraphQLTypes["FieldMeta"] | undefined
};
	["AllergenLocale"]: {
		_meta?: GraphQLTypes["AllergenLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name?: string | undefined,
	root?: GraphQLTypes["Allergen"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined
};
	["AllergenLocaleMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined
};
	["AllergenLocaleOrderBy"]: GraphQLTypes["AllergenLocaleOrderBy"];
	["AllergenOrderBy"]: GraphQLTypes["AllergenOrderBy"];
	["AllergenLocalesByLocaleUniqueWhere"]: GraphQLTypes["AllergenLocalesByLocaleUniqueWhere"];
	["AllergenLocaleConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["AllergenLocaleEdge"]>
};
	["AllergenLocaleEdge"]: {
		node: GraphQLTypes["AllergenLocale"]
};
	["CustomerIngredientRating"]: {
		_meta?: GraphQLTypes["CustomerIngredientRatingMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	customer?: GraphQLTypes["Customer"] | undefined,
	rating?: GraphQLTypes["ProductIngredientRating"] | undefined,
	ingredient?: GraphQLTypes["ProductIngredient"] | undefined
};
	["CustomerIngredientRatingMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined,
	rating?: GraphQLTypes["FieldMeta"] | undefined,
	ingredient?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductIngredientRating"]: {
		_meta?: GraphQLTypes["ProductIngredientRatingMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	name: string,
	icon?: GraphQLTypes["Image"] | undefined
};
	["ProductIngredientRatingMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	icon?: GraphQLTypes["FieldMeta"] | undefined
};
	["CustomerIngredientRatingOrderBy"]: GraphQLTypes["CustomerIngredientRatingOrderBy"];
	["ProductIngredientRatingOrderBy"]: GraphQLTypes["ProductIngredientRatingOrderBy"];
	["ProductIngredientItemQuantityUnit"]: {
		_meta?: GraphQLTypes["ProductIngredientItemQuantityUnitMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string
};
	["ProductIngredientItemQuantityUnitMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined
};
	["FreshingContainer"]: {
		_meta?: GraphQLTypes["FreshingContainerMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	volumeMl: number,
	workspace?: GraphQLTypes["Workspace"] | undefined
};
	["FreshingContainerMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	volumeMl?: GraphQLTypes["FieldMeta"] | undefined,
	workspace?: GraphQLTypes["FieldMeta"] | undefined
};
	["Workspace"]: {
		_meta?: GraphQLTypes["WorkspaceMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	orderDeadlineTime?: string | undefined,
	ordersLoadingDurationHours: number,
	freshingContainerVolumeMl: number,
	freshingPrepareOrderByOffsetMinutes: number,
	checkoutUrlTemplate?: string | undefined,
	orderUrlTemplate?: string | undefined,
	paymentUrlTemplate?: string | undefined,
	customerProfileUrlTemplate?: string | undefined,
	userProfileUrlTemplate?: string | undefined,
	messengerUrl?: string | undefined,
	messengerIosUrl?: string | undefined,
	messengerAndroidUrl?: string | undefined,
	freshingContainers: Array<GraphQLTypes["FreshingContainer"]>,
	openingHours?: GraphQLTypes["WeekHours"] | undefined,
	workingHours?: GraphQLTypes["WeekHours"] | undefined,
	defaultFreshingContainer?: GraphQLTypes["FreshingContainer"] | undefined,
	creditsProduct?: GraphQLTypes["VirtualProduct"] | undefined,
	discountVatRate?: GraphQLTypes["VatRate"] | undefined,
	name: string,
	businessAddress?: string | undefined,
	paginateFreshingContainers: GraphQLTypes["FreshingContainerConnection"]
};
	["WorkspaceMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	unique?: GraphQLTypes["FieldMeta"] | undefined,
	orderDeadlineTime?: GraphQLTypes["FieldMeta"] | undefined,
	ordersLoadingDurationHours?: GraphQLTypes["FieldMeta"] | undefined,
	freshingContainerVolumeMl?: GraphQLTypes["FieldMeta"] | undefined,
	freshingPrepareOrderByOffsetMinutes?: GraphQLTypes["FieldMeta"] | undefined,
	checkoutUrlTemplate?: GraphQLTypes["FieldMeta"] | undefined,
	orderUrlTemplate?: GraphQLTypes["FieldMeta"] | undefined,
	paymentUrlTemplate?: GraphQLTypes["FieldMeta"] | undefined,
	customerProfileUrlTemplate?: GraphQLTypes["FieldMeta"] | undefined,
	userProfileUrlTemplate?: GraphQLTypes["FieldMeta"] | undefined,
	messengerUrl?: GraphQLTypes["FieldMeta"] | undefined,
	messengerIosUrl?: GraphQLTypes["FieldMeta"] | undefined,
	messengerAndroidUrl?: GraphQLTypes["FieldMeta"] | undefined,
	freshingContainers?: GraphQLTypes["FieldMeta"] | undefined,
	openingHours?: GraphQLTypes["FieldMeta"] | undefined,
	workingHours?: GraphQLTypes["FieldMeta"] | undefined,
	defaultFreshingContainer?: GraphQLTypes["FieldMeta"] | undefined,
	creditsProduct?: GraphQLTypes["FieldMeta"] | undefined,
	discountVatRate?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	businessAddress?: GraphQLTypes["FieldMeta"] | undefined
};
	["WeekHours"]: {
		_meta?: GraphQLTypes["WeekHoursMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	mon?: string | undefined,
	tue?: string | undefined,
	wed?: string | undefined,
	thu?: string | undefined,
	fri?: string | undefined,
	sat?: string | undefined,
	sun?: string | undefined
};
	["WeekHoursMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	mon?: GraphQLTypes["FieldMeta"] | undefined,
	tue?: GraphQLTypes["FieldMeta"] | undefined,
	wed?: GraphQLTypes["FieldMeta"] | undefined,
	thu?: GraphQLTypes["FieldMeta"] | undefined,
	fri?: GraphQLTypes["FieldMeta"] | undefined,
	sat?: GraphQLTypes["FieldMeta"] | undefined,
	sun?: GraphQLTypes["FieldMeta"] | undefined
};
	["VirtualProduct"]: {
		_meta?: GraphQLTypes["VirtualProductMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["VirtualProductType"],
	product?: GraphQLTypes["Product"] | undefined,
	voucherCreditCents?: number | undefined,
	physicalRepresentation: GraphQLTypes["VirtualProductPhysicalRepresentationType"],
	recipientEmail?: boolean | undefined
};
	["VirtualProductMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	product?: GraphQLTypes["FieldMeta"] | undefined,
	voucherCreditCents?: GraphQLTypes["FieldMeta"] | undefined,
	physicalRepresentation?: GraphQLTypes["FieldMeta"] | undefined,
	recipientEmail?: GraphQLTypes["FieldMeta"] | undefined
};
	["FreshingContainerConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FreshingContainerEdge"]>
};
	["FreshingContainerEdge"]: {
		node: GraphQLTypes["FreshingContainer"]
};
	["IngredientSupplierList"]: {
		_meta?: GraphQLTypes["IngredientSupplierListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["IngredientSupplierItem"]>,
	paginateItems: GraphQLTypes["IngredientSupplierItemConnection"]
};
	["IngredientSupplierListMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["IngredientSupplierItem"]: {
		_meta?: GraphQLTypes["IngredientSupplierItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["IngredientSupplierList"] | undefined,
	supplier?: GraphQLTypes["IngredientSupplier"] | undefined
};
	["IngredientSupplierItemMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	supplier?: GraphQLTypes["FieldMeta"] | undefined
};
	["IngredientSupplier"]: {
		_meta?: GraphQLTypes["IngredientSupplierMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	internalName: string,
	internalNote?: string | undefined,
	locales: Array<GraphQLTypes["IngredientSupplierLocale"]>,
	localesByLocale?: GraphQLTypes["IngredientSupplierLocale"] | undefined,
	paginateLocales: GraphQLTypes["IngredientSupplierLocaleConnection"]
};
	["IngredientSupplierMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	internalName?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined
};
	["IngredientSupplierLocale"]: {
		_meta?: GraphQLTypes["IngredientSupplierLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	root?: GraphQLTypes["IngredientSupplier"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined
};
	["IngredientSupplierLocaleMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined
};
	["IngredientSupplierLocaleOrderBy"]: GraphQLTypes["IngredientSupplierLocaleOrderBy"];
	["IngredientSupplierOrderBy"]: GraphQLTypes["IngredientSupplierOrderBy"];
	["IngredientSupplierLocalesByLocaleUniqueWhere"]: GraphQLTypes["IngredientSupplierLocalesByLocaleUniqueWhere"];
	["IngredientSupplierLocaleConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["IngredientSupplierLocaleEdge"]>
};
	["IngredientSupplierLocaleEdge"]: {
		node: GraphQLTypes["IngredientSupplierLocale"]
};
	["IngredientSupplierItemOrderBy"]: GraphQLTypes["IngredientSupplierItemOrderBy"];
	["IngredientSupplierItemConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["IngredientSupplierItemEdge"]>
};
	["IngredientSupplierItemEdge"]: {
		node: GraphQLTypes["IngredientSupplierItem"]
};
	["ProductIngredientLocalesByLocaleUniqueWhere"]: GraphQLTypes["ProductIngredientLocalesByLocaleUniqueWhere"];
	["ProductIngredientCustomerRatingsByCustomerUniqueWhere"]: GraphQLTypes["ProductIngredientCustomerRatingsByCustomerUniqueWhere"];
	["ProductIngredientLocaleConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductIngredientLocaleEdge"]>
};
	["ProductIngredientLocaleEdge"]: {
		node: GraphQLTypes["ProductIngredientLocale"]
};
	["ProductIngredientCategoryConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductIngredientCategoryEdge"]>
};
	["ProductIngredientCategoryEdge"]: {
		node: GraphQLTypes["ProductIngredientCategory"]
};
	["AllergenConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["AllergenEdge"]>
};
	["AllergenEdge"]: {
		node: GraphQLTypes["Allergen"]
};
	["CustomerIngredientRatingConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CustomerIngredientRatingEdge"]>
};
	["CustomerIngredientRatingEdge"]: {
		node: GraphQLTypes["CustomerIngredientRating"]
};
	["BlogLocale"]: {
		_meta?: GraphQLTypes["BlogLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	pageName?: string | undefined,
	title?: string | undefined,
	lead?: string | undefined,
	root?: GraphQLTypes["Blog"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined
};
	["BlogLocaleMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	pageName?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	lead?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined
};
	["Blog"]: {
		_meta?: GraphQLTypes["BlogMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	locales: Array<GraphQLTypes["BlogLocale"]>,
	localesByLocale?: GraphQLTypes["BlogLocale"] | undefined,
	paginateLocales: GraphQLTypes["BlogLocaleConnection"]
};
	["BlogMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	unique?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined
};
	["BlogLocaleOrderBy"]: GraphQLTypes["BlogLocaleOrderBy"];
	["BlogOrderBy"]: GraphQLTypes["BlogOrderBy"];
	["BlogLocalesByLocaleUniqueWhere"]: GraphQLTypes["BlogLocalesByLocaleUniqueWhere"];
	["BlogLocaleConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BlogLocaleEdge"]>
};
	["BlogLocaleEdge"]: {
		node: GraphQLTypes["BlogLocale"]
};
	["BlogPostLocale"]: {
		_meta?: GraphQLTypes["BlogPostLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	title?: string | undefined,
	availableForWeb?: boolean | undefined,
	availableForMobile?: boolean | undefined,
	root?: GraphQLTypes["BlogPost"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	cover?: GraphQLTypes["Cover"] | undefined,
	content?: GraphQLTypes["Content"] | undefined,
	link?: GraphQLTypes["Linkable"] | undefined,
	seo?: GraphQLTypes["Seo"] | undefined,
	products: Array<GraphQLTypes["Product"]>,
	paginateProducts: GraphQLTypes["ProductConnection"]
};
	["BlogPostLocaleMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	availableForWeb?: GraphQLTypes["FieldMeta"] | undefined,
	availableForMobile?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	cover?: GraphQLTypes["FieldMeta"] | undefined,
	content?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined,
	seo?: GraphQLTypes["FieldMeta"] | undefined,
	products?: GraphQLTypes["FieldMeta"] | undefined
};
	["BlogPost"]: {
		_meta?: GraphQLTypes["BlogPostMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	locales: Array<GraphQLTypes["BlogPostLocale"]>,
	localesByLocale?: GraphQLTypes["BlogPostLocale"] | undefined,
	localesByCover?: GraphQLTypes["BlogPostLocale"] | undefined,
	localesByContent?: GraphQLTypes["BlogPostLocale"] | undefined,
	localesByLink?: GraphQLTypes["BlogPostLocale"] | undefined,
	localesBySeo?: GraphQLTypes["BlogPostLocale"] | undefined,
	paginateLocales: GraphQLTypes["BlogPostLocaleConnection"]
};
	["BlogPostMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined
};
	["BlogPostLocaleOrderBy"]: GraphQLTypes["BlogPostLocaleOrderBy"];
	["BlogPostOrderBy"]: GraphQLTypes["BlogPostOrderBy"];
	["CoverOrderBy"]: GraphQLTypes["CoverOrderBy"];
	["MediumOrderBy"]: GraphQLTypes["MediumOrderBy"];
	["VideoOrderBy"]: GraphQLTypes["VideoOrderBy"];
	["ColorPalleteOrderBy"]: GraphQLTypes["ColorPalleteOrderBy"];
	["ContentOrderBy"]: GraphQLTypes["ContentOrderBy"];
	["LinkableOrderBy"]: GraphQLTypes["LinkableOrderBy"];
	["PageLocaleOrderBy"]: GraphQLTypes["PageLocaleOrderBy"];
	["SeoOrderBy"]: GraphQLTypes["SeoOrderBy"];
	["WikiPageOrderBy"]: GraphQLTypes["WikiPageOrderBy"];
	["RedirectOrderBy"]: GraphQLTypes["RedirectOrderBy"];
	["LinkOrderBy"]: GraphQLTypes["LinkOrderBy"];
	["BlogPostLocalesByLocaleUniqueWhere"]: GraphQLTypes["BlogPostLocalesByLocaleUniqueWhere"];
	["BlogPostLocalesByCoverUniqueWhere"]: GraphQLTypes["BlogPostLocalesByCoverUniqueWhere"];
	["BlogPostLocalesByContentUniqueWhere"]: GraphQLTypes["BlogPostLocalesByContentUniqueWhere"];
	["BlogPostLocalesByLinkUniqueWhere"]: GraphQLTypes["BlogPostLocalesByLinkUniqueWhere"];
	["BlogPostLocalesBySeoUniqueWhere"]: GraphQLTypes["BlogPostLocalesBySeoUniqueWhere"];
	["BlogPostLocaleConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BlogPostLocaleEdge"]>
};
	["BlogPostLocaleEdge"]: {
		node: GraphQLTypes["BlogPostLocale"]
};
	["Cover"]: {
		_meta?: GraphQLTypes["CoverMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	primaryTitle?: string | undefined,
	secondaryTitle?: string | undefined,
	medium?: GraphQLTypes["Medium"] | undefined,
	buttonColors?: GraphQLTypes["ColorPallete"] | undefined
};
	["CoverMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	primaryTitle?: GraphQLTypes["FieldMeta"] | undefined,
	secondaryTitle?: GraphQLTypes["FieldMeta"] | undefined,
	medium?: GraphQLTypes["FieldMeta"] | undefined,
	buttonColors?: GraphQLTypes["FieldMeta"] | undefined
};
	["Medium"]: {
		_meta?: GraphQLTypes["MediumMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	type?: GraphQLTypes["MediumType"] | undefined,
	colorTheme?: GraphQLTypes["ColorTheme"] | undefined,
	image?: GraphQLTypes["Image"] | undefined,
	video?: GraphQLTypes["Video"] | undefined
};
	["MediumMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	colorTheme?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined,
	video?: GraphQLTypes["FieldMeta"] | undefined
};
	["Video"]: {
		_meta?: GraphQLTypes["VideoMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	src?: string | undefined,
	width?: number | undefined,
	height?: number | undefined,
	size?: number | undefined,
	type?: string | undefined,
	duration?: number | undefined,
	poster?: GraphQLTypes["Image"] | undefined
};
	["VideoMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	src?: GraphQLTypes["FieldMeta"] | undefined,
	width?: GraphQLTypes["FieldMeta"] | undefined,
	height?: GraphQLTypes["FieldMeta"] | undefined,
	size?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	duration?: GraphQLTypes["FieldMeta"] | undefined,
	poster?: GraphQLTypes["FieldMeta"] | undefined
};
	["ColorPallete"]: {
		_meta?: GraphQLTypes["ColorPalleteMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	background?: string | undefined,
	text?: string | undefined
};
	["ColorPalleteMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	background?: GraphQLTypes["FieldMeta"] | undefined,
	text?: GraphQLTypes["FieldMeta"] | undefined
};
	["Content"]: {
		_meta?: GraphQLTypes["ContentMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	blocks: Array<GraphQLTypes["ContentBlock"]>,
	blocksByReferences?: GraphQLTypes["ContentBlock"] | undefined,
	paginateBlocks: GraphQLTypes["ContentBlockConnection"]
};
	["ContentMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	blocks?: GraphQLTypes["FieldMeta"] | undefined
};
	["ContentBlock"]: {
		_meta?: GraphQLTypes["ContentBlockMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	json: string,
	content?: GraphQLTypes["Content"] | undefined,
	references: Array<GraphQLTypes["ContentReference"]>,
	referencesByProducts?: GraphQLTypes["ContentReference"] | undefined,
	referencesByProductBanners?: GraphQLTypes["ContentReference"] | undefined,
	referencesByDeliveryRegions?: GraphQLTypes["ContentReference"] | undefined,
	paginateReferences: GraphQLTypes["ContentReferenceConnection"]
};
	["ContentBlockMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	json?: GraphQLTypes["FieldMeta"] | undefined,
	content?: GraphQLTypes["FieldMeta"] | undefined,
	references?: GraphQLTypes["FieldMeta"] | undefined
};
	["ContentReference"]: {
		_meta?: GraphQLTypes["ContentReferenceMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["ContentReferenceType"],
	primaryText?: string | undefined,
	secondaryText?: string | undefined,
	jsonContent?: string | undefined,
	block?: GraphQLTypes["ContentBlock"] | undefined,
	colorPallete?: GraphQLTypes["ColorPallete"] | undefined,
	medium?: GraphQLTypes["Medium"] | undefined,
	link?: GraphQLTypes["Link"] | undefined,
	blogPosts?: GraphQLTypes["BlogPostList"] | undefined,
	links?: GraphQLTypes["LinkList"] | undefined,
	products?: GraphQLTypes["ProductList"] | undefined,
	contentSize?: GraphQLTypes["ContentSize"] | undefined,
	misc?: string | undefined,
	hero?: GraphQLTypes["Hero"] | undefined,
	gallery?: GraphQLTypes["Gallery"] | undefined,
	socialsAndApps?: GraphQLTypes["SocialsAndApps"] | undefined,
	productGrid?: GraphQLTypes["ProductGrid"] | undefined,
	productBanners?: GraphQLTypes["ProductBannerList"] | undefined,
	deliveryRegions?: GraphQLTypes["DeliveryRegions"] | undefined,
	textList?: GraphQLTypes["TextList"] | undefined,
	gridTiles?: GraphQLTypes["GridTiles"] | undefined
};
	["ContentReferenceMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	primaryText?: GraphQLTypes["FieldMeta"] | undefined,
	secondaryText?: GraphQLTypes["FieldMeta"] | undefined,
	jsonContent?: GraphQLTypes["FieldMeta"] | undefined,
	block?: GraphQLTypes["FieldMeta"] | undefined,
	colorPallete?: GraphQLTypes["FieldMeta"] | undefined,
	medium?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined,
	blogPosts?: GraphQLTypes["FieldMeta"] | undefined,
	links?: GraphQLTypes["FieldMeta"] | undefined,
	products?: GraphQLTypes["FieldMeta"] | undefined,
	contentSize?: GraphQLTypes["FieldMeta"] | undefined,
	misc?: GraphQLTypes["FieldMeta"] | undefined,
	hero?: GraphQLTypes["FieldMeta"] | undefined,
	gallery?: GraphQLTypes["FieldMeta"] | undefined,
	socialsAndApps?: GraphQLTypes["FieldMeta"] | undefined,
	productGrid?: GraphQLTypes["FieldMeta"] | undefined,
	productBanners?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryRegions?: GraphQLTypes["FieldMeta"] | undefined,
	textList?: GraphQLTypes["FieldMeta"] | undefined,
	gridTiles?: GraphQLTypes["FieldMeta"] | undefined
};
	["Link"]: {
		_meta?: GraphQLTypes["LinkMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["LinkType"],
	title?: string | undefined,
	externalLink?: string | undefined,
	internalLink?: GraphQLTypes["Linkable"] | undefined
};
	["LinkMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	externalLink?: GraphQLTypes["FieldMeta"] | undefined,
	internalLink?: GraphQLTypes["FieldMeta"] | undefined
};
	["Linkable"]: {
		_meta?: GraphQLTypes["LinkableMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	url: string,
	blogPost?: GraphQLTypes["BlogPostLocale"] | undefined,
	page?: GraphQLTypes["PageLocale"] | undefined,
	wikiPage?: GraphQLTypes["WikiPage"] | undefined,
	redirect?: GraphQLTypes["Redirect"] | undefined
};
	["LinkableMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	url?: GraphQLTypes["FieldMeta"] | undefined,
	blogPost?: GraphQLTypes["FieldMeta"] | undefined,
	page?: GraphQLTypes["FieldMeta"] | undefined,
	wikiPage?: GraphQLTypes["FieldMeta"] | undefined,
	redirect?: GraphQLTypes["FieldMeta"] | undefined
};
	["PageLocale"]: {
		_meta?: GraphQLTypes["PageLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	title?: string | undefined,
	link?: GraphQLTypes["Linkable"] | undefined,
	root?: GraphQLTypes["Page"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	seo?: GraphQLTypes["Seo"] | undefined,
	content?: GraphQLTypes["Content"] | undefined,
	cover?: GraphQLTypes["Cover"] | undefined,
	theme?: GraphQLTypes["PageTheme"] | undefined
};
	["PageLocaleMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	seo?: GraphQLTypes["FieldMeta"] | undefined,
	content?: GraphQLTypes["FieldMeta"] | undefined,
	cover?: GraphQLTypes["FieldMeta"] | undefined,
	theme?: GraphQLTypes["FieldMeta"] | undefined
};
	["Page"]: {
		_meta?: GraphQLTypes["PageMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	locales: Array<GraphQLTypes["PageLocale"]>,
	localesByLocale?: GraphQLTypes["PageLocale"] | undefined,
	localesByLink?: GraphQLTypes["PageLocale"] | undefined,
	localesBySeo?: GraphQLTypes["PageLocale"] | undefined,
	localesByContent?: GraphQLTypes["PageLocale"] | undefined,
	localesByCover?: GraphQLTypes["PageLocale"] | undefined,
	paginateLocales: GraphQLTypes["PageLocaleConnection"]
};
	["PageMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined
};
	["PageLocalesByLocaleUniqueWhere"]: GraphQLTypes["PageLocalesByLocaleUniqueWhere"];
	["PageLocalesByLinkUniqueWhere"]: GraphQLTypes["PageLocalesByLinkUniqueWhere"];
	["PageLocalesBySeoUniqueWhere"]: GraphQLTypes["PageLocalesBySeoUniqueWhere"];
	["PageLocalesByContentUniqueWhere"]: GraphQLTypes["PageLocalesByContentUniqueWhere"];
	["PageLocalesByCoverUniqueWhere"]: GraphQLTypes["PageLocalesByCoverUniqueWhere"];
	["PageLocaleConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PageLocaleEdge"]>
};
	["PageLocaleEdge"]: {
		node: GraphQLTypes["PageLocale"]
};
	["Seo"]: {
		_meta?: GraphQLTypes["SeoMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	title?: string | undefined,
	description?: string | undefined,
	ogTitle?: string | undefined,
	ogDescription?: string | undefined,
	ogImage?: GraphQLTypes["Image"] | undefined
};
	["SeoMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined,
	ogTitle?: GraphQLTypes["FieldMeta"] | undefined,
	ogDescription?: GraphQLTypes["FieldMeta"] | undefined,
	ogImage?: GraphQLTypes["FieldMeta"] | undefined
};
	["WikiPage"]: {
		_meta?: GraphQLTypes["WikiPageMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	title?: string | undefined,
	emoji?: string | undefined,
	link?: GraphQLTypes["Linkable"] | undefined,
	parent?: GraphQLTypes["WikiPage"] | undefined,
	children: Array<GraphQLTypes["WikiPage"]>,
	content?: GraphQLTypes["Content"] | undefined,
	childrenByLink?: GraphQLTypes["WikiPage"] | undefined,
	childrenByChildren?: GraphQLTypes["WikiPage"] | undefined,
	childrenByContent?: GraphQLTypes["WikiPage"] | undefined,
	paginateChildren: GraphQLTypes["WikiPageConnection"]
};
	["WikiPageMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	emoji?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined,
	parent?: GraphQLTypes["FieldMeta"] | undefined,
	children?: GraphQLTypes["FieldMeta"] | undefined,
	content?: GraphQLTypes["FieldMeta"] | undefined
};
	["WikiPageChildrenByLinkUniqueWhere"]: GraphQLTypes["WikiPageChildrenByLinkUniqueWhere"];
	["WikiPageChildrenByChildrenUniqueWhere"]: GraphQLTypes["WikiPageChildrenByChildrenUniqueWhere"];
	["WikiPageChildrenByContentUniqueWhere"]: GraphQLTypes["WikiPageChildrenByContentUniqueWhere"];
	["WikiPageConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["WikiPageEdge"]>
};
	["WikiPageEdge"]: {
		node: GraphQLTypes["WikiPage"]
};
	["Redirect"]: {
		_meta?: GraphQLTypes["RedirectMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	link?: GraphQLTypes["Linkable"] | undefined,
	target?: GraphQLTypes["Link"] | undefined
};
	["RedirectMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined,
	target?: GraphQLTypes["FieldMeta"] | undefined
};
	["BlogPostList"]: {
		_meta?: GraphQLTypes["BlogPostListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["BlogPostListItem"]>,
	paginateItems: GraphQLTypes["BlogPostListItemConnection"]
};
	["BlogPostListMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["BlogPostListItem"]: {
		_meta?: GraphQLTypes["BlogPostListItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	caption?: string | undefined,
	list?: GraphQLTypes["BlogPostList"] | undefined,
	blogPost?: GraphQLTypes["BlogPostLocale"] | undefined
};
	["BlogPostListItemMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	caption?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	blogPost?: GraphQLTypes["FieldMeta"] | undefined
};
	["BlogPostListItemOrderBy"]: GraphQLTypes["BlogPostListItemOrderBy"];
	["BlogPostListOrderBy"]: GraphQLTypes["BlogPostListOrderBy"];
	["BlogPostListItemConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BlogPostListItemEdge"]>
};
	["BlogPostListItemEdge"]: {
		node: GraphQLTypes["BlogPostListItem"]
};
	["LinkList"]: {
		_meta?: GraphQLTypes["LinkListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["LinkListItem"]>,
	paginateItems: GraphQLTypes["LinkListItemConnection"]
};
	["LinkListMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["LinkListItem"]: {
		_meta?: GraphQLTypes["LinkListItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	isPrimary?: boolean | undefined,
	list?: GraphQLTypes["LinkList"] | undefined,
	link?: GraphQLTypes["Link"] | undefined
};
	["LinkListItemMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	isPrimary?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined
};
	["LinkListItemOrderBy"]: GraphQLTypes["LinkListItemOrderBy"];
	["LinkListOrderBy"]: GraphQLTypes["LinkListOrderBy"];
	["LinkListItemConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkListItemEdge"]>
};
	["LinkListItemEdge"]: {
		node: GraphQLTypes["LinkListItem"]
};
	["Hero"]: {
		_meta?: GraphQLTypes["HeroMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	showLogo?: boolean | undefined,
	middleContent?: string | undefined,
	medium?: GraphQLTypes["Medium"] | undefined
};
	["HeroMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	showLogo?: GraphQLTypes["FieldMeta"] | undefined,
	middleContent?: GraphQLTypes["FieldMeta"] | undefined,
	medium?: GraphQLTypes["FieldMeta"] | undefined
};
	["Gallery"]: {
		_meta?: GraphQLTypes["GalleryMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["GalleryItem"]>,
	paginateItems: GraphQLTypes["GalleryItemConnection"]
};
	["GalleryMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["GalleryItem"]: {
		_meta?: GraphQLTypes["GalleryItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	caption?: string | undefined,
	list?: GraphQLTypes["Gallery"] | undefined,
	medium?: GraphQLTypes["Medium"] | undefined
};
	["GalleryItemMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	caption?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	medium?: GraphQLTypes["FieldMeta"] | undefined
};
	["GalleryItemOrderBy"]: GraphQLTypes["GalleryItemOrderBy"];
	["GalleryOrderBy"]: GraphQLTypes["GalleryOrderBy"];
	["GalleryItemConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GalleryItemEdge"]>
};
	["GalleryItemEdge"]: {
		node: GraphQLTypes["GalleryItem"]
};
	["SocialsAndApps"]: {
		_meta?: GraphQLTypes["SocialsAndAppsMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	instagram?: boolean | undefined,
	appStore?: boolean | undefined,
	googlePlay?: boolean | undefined
};
	["SocialsAndAppsMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	instagram?: GraphQLTypes["FieldMeta"] | undefined,
	appStore?: GraphQLTypes["FieldMeta"] | undefined,
	googlePlay?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductGrid"]: {
		_meta?: GraphQLTypes["ProductGridMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	isCarousel?: boolean | undefined,
	categories: Array<GraphQLTypes["ProductGridCategory"]>,
	type?: GraphQLTypes["ProductGridType"] | undefined,
	categoriesByItems?: GraphQLTypes["ProductGridCategory"] | undefined,
	categoriesByImages?: GraphQLTypes["ProductGridCategory"] | undefined,
	paginateCategories: GraphQLTypes["ProductGridCategoryConnection"]
};
	["ProductGridMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	isCarousel?: GraphQLTypes["FieldMeta"] | undefined,
	categories?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductGridCategory"]: {
		_meta?: GraphQLTypes["ProductGridCategoryMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	title?: string | undefined,
	root?: GraphQLTypes["ProductGrid"] | undefined,
	items: Array<GraphQLTypes["ProductGridItem"]>,
	images?: GraphQLTypes["ImageList"] | undefined,
	paginateItems: GraphQLTypes["ProductGridItemConnection"]
};
	["ProductGridCategoryMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined,
	images?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductGridItem"]: {
		_meta?: GraphQLTypes["ProductGridItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	title?: string | undefined,
	lead?: string | undefined,
	product?: GraphQLTypes["Product"] | undefined,
	medium?: GraphQLTypes["Medium"] | undefined,
	link?: GraphQLTypes["Link"] | undefined,
	category?: GraphQLTypes["ProductGridCategory"] | undefined,
	description?: string | undefined
};
	["ProductGridItemMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	lead?: GraphQLTypes["FieldMeta"] | undefined,
	product?: GraphQLTypes["FieldMeta"] | undefined,
	medium?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined,
	category?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductGridItemOrderBy"]: GraphQLTypes["ProductGridItemOrderBy"];
	["ProductGridCategoryOrderBy"]: GraphQLTypes["ProductGridCategoryOrderBy"];
	["ProductGridOrderBy"]: GraphQLTypes["ProductGridOrderBy"];
	["ImageListOrderBy"]: GraphQLTypes["ImageListOrderBy"];
	["ImageList"]: {
		_meta?: GraphQLTypes["ImageListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["ImageListItem"]>,
	itemsByImage?: GraphQLTypes["ImageListItem"] | undefined,
	paginateItems: GraphQLTypes["ImageListItemConnection"]
};
	["ImageListMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["ImageListItem"]: {
		_meta?: GraphQLTypes["ImageListItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["ImageList"] | undefined,
	image?: GraphQLTypes["Image"] | undefined
};
	["ImageListItemMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined
};
	["ImageListItemOrderBy"]: GraphQLTypes["ImageListItemOrderBy"];
	["ImageListItemsByImageUniqueWhere"]: GraphQLTypes["ImageListItemsByImageUniqueWhere"];
	["ImageListItemConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ImageListItemEdge"]>
};
	["ImageListItemEdge"]: {
		node: GraphQLTypes["ImageListItem"]
};
	["ProductGridItemConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductGridItemEdge"]>
};
	["ProductGridItemEdge"]: {
		node: GraphQLTypes["ProductGridItem"]
};
	["ProductGridCategoriesByItemsUniqueWhere"]: GraphQLTypes["ProductGridCategoriesByItemsUniqueWhere"];
	["ProductGridItemUniqueWhere"]: GraphQLTypes["ProductGridItemUniqueWhere"];
	["ProductGridCategoriesByImagesUniqueWhere"]: GraphQLTypes["ProductGridCategoriesByImagesUniqueWhere"];
	["ProductGridCategoryConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductGridCategoryEdge"]>
};
	["ProductGridCategoryEdge"]: {
		node: GraphQLTypes["ProductGridCategory"]
};
	["ProductBannerList"]: {
		_meta?: GraphQLTypes["ProductBannerListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["ProductBannerItem"]>,
	paginateItems: GraphQLTypes["ProductBannerItemConnection"]
};
	["ProductBannerListMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductBannerItem"]: {
		_meta?: GraphQLTypes["ProductBannerItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["ProductBannerList"] | undefined,
	banner?: GraphQLTypes["ProductBanner"] | undefined,
	size?: GraphQLTypes["ProductBannerItemSize"] | undefined
};
	["ProductBannerItemMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	banner?: GraphQLTypes["FieldMeta"] | undefined,
	size?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductBanner"]: {
		_meta?: GraphQLTypes["ProductBannerMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	beforeTitle?: string | undefined,
	title?: string | undefined,
	label?: string | undefined,
	button?: GraphQLTypes["Link"] | undefined,
	backgroundImage?: GraphQLTypes["Image"] | undefined,
	productImage?: GraphQLTypes["Image"] | undefined,
	product?: GraphQLTypes["Product"] | undefined
};
	["ProductBannerMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	beforeTitle?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	label?: GraphQLTypes["FieldMeta"] | undefined,
	button?: GraphQLTypes["FieldMeta"] | undefined,
	backgroundImage?: GraphQLTypes["FieldMeta"] | undefined,
	productImage?: GraphQLTypes["FieldMeta"] | undefined,
	product?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductBannerItemOrderBy"]: GraphQLTypes["ProductBannerItemOrderBy"];
	["ProductBannerListOrderBy"]: GraphQLTypes["ProductBannerListOrderBy"];
	["ProductBannerOrderBy"]: GraphQLTypes["ProductBannerOrderBy"];
	["ProductBannerItemConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductBannerItemEdge"]>
};
	["ProductBannerItemEdge"]: {
		node: GraphQLTypes["ProductBannerItem"]
};
	["DeliveryRegions"]: {
		_meta?: GraphQLTypes["DeliveryRegionsMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["DeliveryRegionsItem"]>,
	itemsByImage?: GraphQLTypes["DeliveryRegionsItem"] | undefined,
	itemsByTextList?: GraphQLTypes["DeliveryRegionsItem"] | undefined,
	itemsByGallery?: GraphQLTypes["DeliveryRegionsItem"] | undefined,
	paginateItems: GraphQLTypes["DeliveryRegionsItemConnection"]
};
	["DeliveryRegionsMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["DeliveryRegionsItem"]: {
		_meta?: GraphQLTypes["DeliveryRegionsItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	title?: string | undefined,
	offerLabel?: string | undefined,
	list?: GraphQLTypes["DeliveryRegions"] | undefined,
	image?: GraphQLTypes["Image"] | undefined,
	textList?: GraphQLTypes["TextList"] | undefined,
	gallery?: GraphQLTypes["ImageList"] | undefined
};
	["DeliveryRegionsItemMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	offerLabel?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined,
	textList?: GraphQLTypes["FieldMeta"] | undefined,
	gallery?: GraphQLTypes["FieldMeta"] | undefined
};
	["TextList"]: {
		_meta?: GraphQLTypes["TextListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["TextItem"]>,
	paginateItems: GraphQLTypes["TextItemConnection"]
};
	["TextListMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["TextItem"]: {
		_meta?: GraphQLTypes["TextItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	text?: string | undefined,
	list?: GraphQLTypes["TextList"] | undefined,
	title?: string | undefined
};
	["TextItemMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	text?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined
};
	["TextItemOrderBy"]: GraphQLTypes["TextItemOrderBy"];
	["TextListOrderBy"]: GraphQLTypes["TextListOrderBy"];
	["TextItemConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TextItemEdge"]>
};
	["TextItemEdge"]: {
		node: GraphQLTypes["TextItem"]
};
	["DeliveryRegionsItemOrderBy"]: GraphQLTypes["DeliveryRegionsItemOrderBy"];
	["DeliveryRegionsOrderBy"]: GraphQLTypes["DeliveryRegionsOrderBy"];
	["DeliveryRegionsItemsByImageUniqueWhere"]: GraphQLTypes["DeliveryRegionsItemsByImageUniqueWhere"];
	["DeliveryRegionsItemsByTextListUniqueWhere"]: GraphQLTypes["DeliveryRegionsItemsByTextListUniqueWhere"];
	["DeliveryRegionsItemsByGalleryUniqueWhere"]: GraphQLTypes["DeliveryRegionsItemsByGalleryUniqueWhere"];
	["DeliveryRegionsItemConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DeliveryRegionsItemEdge"]>
};
	["DeliveryRegionsItemEdge"]: {
		node: GraphQLTypes["DeliveryRegionsItem"]
};
	["GridTiles"]: {
		_meta?: GraphQLTypes["GridTilesMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["GridTileItem"]>,
	itemsByLink?: GraphQLTypes["GridTileItem"] | undefined,
	paginateItems: GraphQLTypes["GridTileItemConnection"]
};
	["GridTilesMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["GridTileItem"]: {
		_meta?: GraphQLTypes["GridTileItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	text?: string | undefined,
	list?: GraphQLTypes["GridTiles"] | undefined,
	medium?: GraphQLTypes["Medium"] | undefined,
	link?: GraphQLTypes["Link"] | undefined
};
	["GridTileItemMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	text?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	medium?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined
};
	["GridTileItemOrderBy"]: GraphQLTypes["GridTileItemOrderBy"];
	["GridTilesOrderBy"]: GraphQLTypes["GridTilesOrderBy"];
	["GridTilesItemsByLinkUniqueWhere"]: GraphQLTypes["GridTilesItemsByLinkUniqueWhere"];
	["LinkUniqueWhere"]: GraphQLTypes["LinkUniqueWhere"];
	["GridTileItemConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GridTileItemEdge"]>
};
	["GridTileItemEdge"]: {
		node: GraphQLTypes["GridTileItem"]
};
	["ContentReferenceOrderBy"]: GraphQLTypes["ContentReferenceOrderBy"];
	["ContentBlockOrderBy"]: GraphQLTypes["ContentBlockOrderBy"];
	["HeroOrderBy"]: GraphQLTypes["HeroOrderBy"];
	["SocialsAndAppsOrderBy"]: GraphQLTypes["SocialsAndAppsOrderBy"];
	["ContentBlockReferencesByProductsUniqueWhere"]: GraphQLTypes["ContentBlockReferencesByProductsUniqueWhere"];
	["ContentBlockReferencesByProductBannersUniqueWhere"]: GraphQLTypes["ContentBlockReferencesByProductBannersUniqueWhere"];
	["ContentBlockReferencesByDeliveryRegionsUniqueWhere"]: GraphQLTypes["ContentBlockReferencesByDeliveryRegionsUniqueWhere"];
	["ContentReferenceConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentReferenceEdge"]>
};
	["ContentReferenceEdge"]: {
		node: GraphQLTypes["ContentReference"]
};
	["ContentBlocksByReferencesUniqueWhere"]: GraphQLTypes["ContentBlocksByReferencesUniqueWhere"];
	["ContentBlockConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentBlockEdge"]>
};
	["ContentBlockEdge"]: {
		node: GraphQLTypes["ContentBlock"]
};
	["TranslationCataloguesIdentifier"]: {
		_meta?: GraphQLTypes["TranslationCataloguesIdentifierMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	code: string,
	catalogue: Array<GraphQLTypes["TranslationCatalogue"]>,
	catalogueByDomain?: GraphQLTypes["TranslationCatalogue"] | undefined,
	catalogueByValues?: GraphQLTypes["TranslationCatalogue"] | undefined,
	paginateCatalogue: GraphQLTypes["TranslationCatalogueConnection"]
};
	["TranslationCataloguesIdentifierMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	code?: GraphQLTypes["FieldMeta"] | undefined,
	catalogue?: GraphQLTypes["FieldMeta"] | undefined
};
	["TranslationCatalogue"]: {
		_meta?: GraphQLTypes["TranslationCatalogueMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	domain?: GraphQLTypes["TranslationDomain"] | undefined,
	fallback?: GraphQLTypes["TranslationCatalogue"] | undefined,
	values: Array<GraphQLTypes["TranslationValue"]>,
	identifier?: GraphQLTypes["TranslationCataloguesIdentifier"] | undefined,
	valuesByKey?: GraphQLTypes["TranslationValue"] | undefined,
	paginateValues: GraphQLTypes["TranslationValueConnection"]
};
	["TranslationCatalogueMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	domain?: GraphQLTypes["FieldMeta"] | undefined,
	fallback?: GraphQLTypes["FieldMeta"] | undefined,
	values?: GraphQLTypes["FieldMeta"] | undefined,
	identifier?: GraphQLTypes["FieldMeta"] | undefined
};
	["TranslationDomain"]: {
		_meta?: GraphQLTypes["TranslationDomainMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	identifier: string,
	name: string,
	catalogues: Array<GraphQLTypes["TranslationCatalogue"]>,
	keys: Array<GraphQLTypes["TranslationKey"]>,
	cataloguesByIdentifier?: GraphQLTypes["TranslationCatalogue"] | undefined,
	cataloguesByValues?: GraphQLTypes["TranslationCatalogue"] | undefined,
	keysByIdentifier?: GraphQLTypes["TranslationKey"] | undefined,
	keysByValues?: GraphQLTypes["TranslationKey"] | undefined,
	paginateCatalogues: GraphQLTypes["TranslationCatalogueConnection"],
	paginateKeys: GraphQLTypes["TranslationKeyConnection"]
};
	["TranslationDomainMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	identifier?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	catalogues?: GraphQLTypes["FieldMeta"] | undefined,
	keys?: GraphQLTypes["FieldMeta"] | undefined
};
	["TranslationCatalogueOrderBy"]: GraphQLTypes["TranslationCatalogueOrderBy"];
	["TranslationDomainOrderBy"]: GraphQLTypes["TranslationDomainOrderBy"];
	["TranslationKey"]: {
		_meta?: GraphQLTypes["TranslationKeyMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	identifier: string,
	contentType: GraphQLTypes["TranslationContentType"],
	note?: string | undefined,
	domain?: GraphQLTypes["TranslationDomain"] | undefined,
	values: Array<GraphQLTypes["TranslationValue"]>,
	valuesByCatalogue?: GraphQLTypes["TranslationValue"] | undefined,
	paginateValues: GraphQLTypes["TranslationValueConnection"]
};
	["TranslationKeyMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	identifier?: GraphQLTypes["FieldMeta"] | undefined,
	contentType?: GraphQLTypes["FieldMeta"] | undefined,
	note?: GraphQLTypes["FieldMeta"] | undefined,
	domain?: GraphQLTypes["FieldMeta"] | undefined,
	values?: GraphQLTypes["FieldMeta"] | undefined
};
	["TranslationValue"]: {
		_meta?: GraphQLTypes["TranslationValueMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	value: string,
	catalogue?: GraphQLTypes["TranslationCatalogue"] | undefined,
	key?: GraphQLTypes["TranslationKey"] | undefined
};
	["TranslationValueMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	value?: GraphQLTypes["FieldMeta"] | undefined,
	catalogue?: GraphQLTypes["FieldMeta"] | undefined,
	key?: GraphQLTypes["FieldMeta"] | undefined
};
	["TranslationValueOrderBy"]: GraphQLTypes["TranslationValueOrderBy"];
	["TranslationKeyOrderBy"]: GraphQLTypes["TranslationKeyOrderBy"];
	["TranslationKeyValuesByCatalogueUniqueWhere"]: GraphQLTypes["TranslationKeyValuesByCatalogueUniqueWhere"];
	["TranslationValueConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TranslationValueEdge"]>
};
	["TranslationValueEdge"]: {
		node: GraphQLTypes["TranslationValue"]
};
	["TranslationDomainCataloguesByIdentifierUniqueWhere"]: GraphQLTypes["TranslationDomainCataloguesByIdentifierUniqueWhere"];
	["TranslationDomainCataloguesByValuesUniqueWhere"]: GraphQLTypes["TranslationDomainCataloguesByValuesUniqueWhere"];
	["TranslationDomainKeysByIdentifierUniqueWhere"]: GraphQLTypes["TranslationDomainKeysByIdentifierUniqueWhere"];
	["TranslationDomainKeysByValuesUniqueWhere"]: GraphQLTypes["TranslationDomainKeysByValuesUniqueWhere"];
	["TranslationCatalogueConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TranslationCatalogueEdge"]>
};
	["TranslationCatalogueEdge"]: {
		node: GraphQLTypes["TranslationCatalogue"]
};
	["TranslationKeyConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TranslationKeyEdge"]>
};
	["TranslationKeyEdge"]: {
		node: GraphQLTypes["TranslationKey"]
};
	["TranslationCatalogueValuesByKeyUniqueWhere"]: GraphQLTypes["TranslationCatalogueValuesByKeyUniqueWhere"];
	["TranslationCataloguesIdentifierCatalogueByDomainUniqueWhere"]: GraphQLTypes["TranslationCataloguesIdentifierCatalogueByDomainUniqueWhere"];
	["TranslationCataloguesIdentifierCatalogueByValuesUniqueWhere"]: GraphQLTypes["TranslationCataloguesIdentifierCatalogueByValuesUniqueWhere"];
	["MenuLocale"]: {
		_meta?: GraphQLTypes["MenuLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	root?: GraphQLTypes["SiteMenu"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	items: Array<GraphQLTypes["MenuItem"]>,
	secondaryItems?: GraphQLTypes["LinkList"] | undefined,
	eshopLink?: GraphQLTypes["Link"] | undefined,
	itemsBySubitems?: GraphQLTypes["MenuItem"] | undefined,
	paginateItems: GraphQLTypes["MenuItemConnection"]
};
	["MenuLocaleMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined,
	secondaryItems?: GraphQLTypes["FieldMeta"] | undefined,
	eshopLink?: GraphQLTypes["FieldMeta"] | undefined
};
	["SiteMenu"]: {
		_meta?: GraphQLTypes["SiteMenuMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	locales: Array<GraphQLTypes["MenuLocale"]>,
	localesByLocale?: GraphQLTypes["MenuLocale"] | undefined,
	localesByItems?: GraphQLTypes["MenuLocale"] | undefined,
	localesBySecondaryItems?: GraphQLTypes["MenuLocale"] | undefined,
	paginateLocales: GraphQLTypes["MenuLocaleConnection"]
};
	["SiteMenuMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	unique?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined
};
	["MenuLocaleOrderBy"]: GraphQLTypes["MenuLocaleOrderBy"];
	["SiteMenuOrderBy"]: GraphQLTypes["SiteMenuOrderBy"];
	["SiteMenuLocalesByLocaleUniqueWhere"]: GraphQLTypes["SiteMenuLocalesByLocaleUniqueWhere"];
	["SiteMenuLocalesByItemsUniqueWhere"]: GraphQLTypes["SiteMenuLocalesByItemsUniqueWhere"];
	["SiteMenuLocalesBySecondaryItemsUniqueWhere"]: GraphQLTypes["SiteMenuLocalesBySecondaryItemsUniqueWhere"];
	["MenuLocaleConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MenuLocaleEdge"]>
};
	["MenuLocaleEdge"]: {
		node: GraphQLTypes["MenuLocale"]
};
	["MenuItem"]: {
		_meta?: GraphQLTypes["MenuItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	menu?: GraphQLTypes["MenuLocale"] | undefined,
	link?: GraphQLTypes["Link"] | undefined,
	subitems: Array<GraphQLTypes["MenuSubitem"]>,
	paginateSubitems: GraphQLTypes["MenuSubitemConnection"]
};
	["MenuItemMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	menu?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined,
	subitems?: GraphQLTypes["FieldMeta"] | undefined
};
	["MenuSubitem"]: {
		_meta?: GraphQLTypes["MenuSubitemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	type?: GraphQLTypes["MenuSubitemType"] | undefined,
	title?: string | undefined,
	item?: GraphQLTypes["MenuItem"] | undefined,
	links?: GraphQLTypes["MenuLinkList"] | undefined,
	products?: GraphQLTypes["MenuProducts"] | undefined,
	delivery?: GraphQLTypes["MenuDelivery"] | undefined,
	contact?: GraphQLTypes["MenuContact"] | undefined,
	order: number
};
	["MenuSubitemMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	item?: GraphQLTypes["FieldMeta"] | undefined,
	links?: GraphQLTypes["FieldMeta"] | undefined,
	products?: GraphQLTypes["FieldMeta"] | undefined,
	delivery?: GraphQLTypes["FieldMeta"] | undefined,
	contact?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined
};
	["MenuLinkList"]: {
		_meta?: GraphQLTypes["MenuLinkListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["MenuLinkItem"]>,
	paginateItems: GraphQLTypes["MenuLinkItemConnection"]
};
	["MenuLinkListMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["MenuLinkItem"]: {
		_meta?: GraphQLTypes["MenuLinkItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["MenuLinkList"] | undefined,
	link?: GraphQLTypes["Link"] | undefined,
	image?: GraphQLTypes["Image"] | undefined,
	description?: string | undefined
};
	["MenuLinkItemMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined
};
	["MenuLinkItemOrderBy"]: GraphQLTypes["MenuLinkItemOrderBy"];
	["MenuLinkListOrderBy"]: GraphQLTypes["MenuLinkListOrderBy"];
	["MenuLinkItemConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MenuLinkItemEdge"]>
};
	["MenuLinkItemEdge"]: {
		node: GraphQLTypes["MenuLinkItem"]
};
	["MenuProducts"]: {
		_meta?: GraphQLTypes["MenuProductsMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	links?: GraphQLTypes["MenuLinkList"] | undefined,
	buttons?: GraphQLTypes["LinkList"] | undefined
};
	["MenuProductsMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	links?: GraphQLTypes["FieldMeta"] | undefined,
	buttons?: GraphQLTypes["FieldMeta"] | undefined
};
	["MenuDelivery"]: {
		_meta?: GraphQLTypes["MenuDeliveryMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	deliveryRegions?: GraphQLTypes["DeliveryRegions"] | undefined,
	text?: string | undefined,
	socialsAndApps?: GraphQLTypes["SocialsAndApps"] | undefined
};
	["MenuDeliveryMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryRegions?: GraphQLTypes["FieldMeta"] | undefined,
	text?: GraphQLTypes["FieldMeta"] | undefined,
	socialsAndApps?: GraphQLTypes["FieldMeta"] | undefined
};
	["MenuContact"]: {
		_meta?: GraphQLTypes["MenuContactMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	text?: string | undefined,
	image?: GraphQLTypes["Image"] | undefined
};
	["MenuContactMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	text?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined
};
	["MenuSubitemOrderBy"]: GraphQLTypes["MenuSubitemOrderBy"];
	["MenuItemOrderBy"]: GraphQLTypes["MenuItemOrderBy"];
	["MenuProductsOrderBy"]: GraphQLTypes["MenuProductsOrderBy"];
	["MenuDeliveryOrderBy"]: GraphQLTypes["MenuDeliveryOrderBy"];
	["MenuContactOrderBy"]: GraphQLTypes["MenuContactOrderBy"];
	["MenuSubitemConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MenuSubitemEdge"]>
};
	["MenuSubitemEdge"]: {
		node: GraphQLTypes["MenuSubitem"]
};
	["MenuLocaleItemsBySubitemsUniqueWhere"]: GraphQLTypes["MenuLocaleItemsBySubitemsUniqueWhere"];
	["MenuItemConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MenuItemEdge"]>
};
	["MenuItemEdge"]: {
		node: GraphQLTypes["MenuItem"]
};
	["ProductPackingLocaleOrderBy"]: GraphQLTypes["ProductPackingLocaleOrderBy"];
	["ProductLocale"]: {
		_meta?: GraphQLTypes["ProductLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	description?: string | undefined,
	root?: GraphQLTypes["Product"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	featureList?: GraphQLTypes["TextList"] | undefined,
	printableName?: string | undefined,
	firstSticker?: string | undefined,
	secondSticker?: string | undefined
};
	["ProductLocaleMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	featureList?: GraphQLTypes["FieldMeta"] | undefined,
	printableName?: GraphQLTypes["FieldMeta"] | undefined,
	firstSticker?: GraphQLTypes["FieldMeta"] | undefined,
	secondSticker?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductLocaleOrderBy"]: GraphQLTypes["ProductLocaleOrderBy"];
	["ProductRecipeLocale"]: {
		_meta?: GraphQLTypes["ProductRecipeLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	root?: GraphQLTypes["ProductRecipe"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	description?: string | undefined
};
	["ProductRecipeLocaleMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductRecipe"]: {
		_meta?: GraphQLTypes["ProductRecipeMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	products: Array<GraphQLTypes["Product"]>,
	internalNote?: string | undefined,
	color?: string | undefined,
	image?: GraphQLTypes["Image"] | undefined,
	icon?: GraphQLTypes["Image"] | undefined,
	ingredients: Array<GraphQLTypes["ProductIngredientItem"]>,
	needsPrepping: boolean,
	locales: Array<GraphQLTypes["ProductRecipeLocale"]>,
	gutTuning?: number | undefined,
	freshingContainer?: GraphQLTypes["FreshingContainer"] | undefined,
	description?: string | undefined,
	nutritionFacts?: GraphQLTypes["NutritionFacts"] | undefined,
	productsByCode?: GraphQLTypes["Product"] | undefined,
	productsByStocks?: GraphQLTypes["Product"] | undefined,
	productsByGroupPrices?: GraphQLTypes["Product"] | undefined,
	productsByCartItems?: GraphQLTypes["Product"] | undefined,
	productsByOrderItems?: GraphQLTypes["Product"] | undefined,
	productsByInheritedCategories?: GraphQLTypes["Product"] | undefined,
	productsByLocales?: GraphQLTypes["Product"] | undefined,
	productsByCustomerPrices?: GraphQLTypes["Product"] | undefined,
	productsByVirtualProduct?: GraphQLTypes["Product"] | undefined,
	productsByMeta?: GraphQLTypes["Product"] | undefined,
	productsByPage?: GraphQLTypes["Product"] | undefined,
	productsBySalesDays?: GraphQLTypes["Product"] | undefined,
	productsBySalesWeeks?: GraphQLTypes["Product"] | undefined,
	productsBySalesMonths?: GraphQLTypes["Product"] | undefined,
	ingredientsByQuantity?: GraphQLTypes["ProductIngredientItem"] | undefined,
	localesByLocale?: GraphQLTypes["ProductRecipeLocale"] | undefined,
	paginateProducts: GraphQLTypes["ProductConnection"],
	paginateIngredients: GraphQLTypes["ProductIngredientItemConnection"],
	paginateLocales: GraphQLTypes["ProductRecipeLocaleConnection"]
};
	["ProductRecipeMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	products?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	color?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined,
	icon?: GraphQLTypes["FieldMeta"] | undefined,
	ingredients?: GraphQLTypes["FieldMeta"] | undefined,
	needsPrepping?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	gutTuning?: GraphQLTypes["FieldMeta"] | undefined,
	freshingContainer?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined,
	nutritionFacts?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductIngredientItem"]: {
		_meta?: GraphQLTypes["ProductIngredientItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	internalOrder: number,
	recipe?: GraphQLTypes["ProductRecipe"] | undefined,
	ingredient?: GraphQLTypes["ProductIngredient"] | undefined,
	quantity?: GraphQLTypes["ProductIngredientItemQuantity"] | undefined
};
	["ProductIngredientItemMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	internalOrder?: GraphQLTypes["FieldMeta"] | undefined,
	recipe?: GraphQLTypes["FieldMeta"] | undefined,
	ingredient?: GraphQLTypes["FieldMeta"] | undefined,
	quantity?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductIngredientItemQuantity"]: {
		_meta?: GraphQLTypes["ProductIngredientItemQuantityMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	unit?: GraphQLTypes["ProductIngredientItemQuantityUnit"] | undefined,
	value: number
};
	["ProductIngredientItemQuantityMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	unit?: GraphQLTypes["FieldMeta"] | undefined,
	value?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductIngredientItemOrderBy"]: GraphQLTypes["ProductIngredientItemOrderBy"];
	["ProductIngredientItemQuantityOrderBy"]: GraphQLTypes["ProductIngredientItemQuantityOrderBy"];
	["ProductRecipeLocaleOrderBy"]: GraphQLTypes["ProductRecipeLocaleOrderBy"];
	["NutritionFacts"]: {
		_meta?: GraphQLTypes["NutritionFactsMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	energyKiloJoule?: number | undefined,
	energyKiloCalorie?: number | undefined,
	fatsGrams?: number | undefined,
	fatsOfWhichSaturatedGrams?: number | undefined,
	carbohydrateGrams?: number | undefined,
	carbohydrateOfWhichSugarsGrams?: number | undefined,
	proteinGrams?: number | undefined,
	fibreGrams?: number | undefined,
	saltGrams?: number | undefined
};
	["NutritionFactsMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	energyKiloJoule?: GraphQLTypes["FieldMeta"] | undefined,
	energyKiloCalorie?: GraphQLTypes["FieldMeta"] | undefined,
	fatsGrams?: GraphQLTypes["FieldMeta"] | undefined,
	fatsOfWhichSaturatedGrams?: GraphQLTypes["FieldMeta"] | undefined,
	carbohydrateGrams?: GraphQLTypes["FieldMeta"] | undefined,
	carbohydrateOfWhichSugarsGrams?: GraphQLTypes["FieldMeta"] | undefined,
	proteinGrams?: GraphQLTypes["FieldMeta"] | undefined,
	fibreGrams?: GraphQLTypes["FieldMeta"] | undefined,
	saltGrams?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductRecipeProductsByCodeUniqueWhere"]: GraphQLTypes["ProductRecipeProductsByCodeUniqueWhere"];
	["ProductRecipeProductsByStocksUniqueWhere"]: GraphQLTypes["ProductRecipeProductsByStocksUniqueWhere"];
	["ProductRecipeProductsByGroupPricesUniqueWhere"]: GraphQLTypes["ProductRecipeProductsByGroupPricesUniqueWhere"];
	["ProductRecipeProductsByCartItemsUniqueWhere"]: GraphQLTypes["ProductRecipeProductsByCartItemsUniqueWhere"];
	["ProductRecipeProductsByOrderItemsUniqueWhere"]: GraphQLTypes["ProductRecipeProductsByOrderItemsUniqueWhere"];
	["ProductRecipeProductsByInheritedCategoriesUniqueWhere"]: GraphQLTypes["ProductRecipeProductsByInheritedCategoriesUniqueWhere"];
	["ProductRecipeProductsByLocalesUniqueWhere"]: GraphQLTypes["ProductRecipeProductsByLocalesUniqueWhere"];
	["ProductRecipeProductsByCustomerPricesUniqueWhere"]: GraphQLTypes["ProductRecipeProductsByCustomerPricesUniqueWhere"];
	["ProductRecipeProductsByVirtualProductUniqueWhere"]: GraphQLTypes["ProductRecipeProductsByVirtualProductUniqueWhere"];
	["ProductRecipeProductsByMetaUniqueWhere"]: GraphQLTypes["ProductRecipeProductsByMetaUniqueWhere"];
	["ProductRecipeProductsByPageUniqueWhere"]: GraphQLTypes["ProductRecipeProductsByPageUniqueWhere"];
	["ProductRecipeProductsBySalesDaysUniqueWhere"]: GraphQLTypes["ProductRecipeProductsBySalesDaysUniqueWhere"];
	["ProductRecipeProductsBySalesWeeksUniqueWhere"]: GraphQLTypes["ProductRecipeProductsBySalesWeeksUniqueWhere"];
	["ProductRecipeProductsBySalesMonthsUniqueWhere"]: GraphQLTypes["ProductRecipeProductsBySalesMonthsUniqueWhere"];
	["ProductRecipeIngredientsByQuantityUniqueWhere"]: GraphQLTypes["ProductRecipeIngredientsByQuantityUniqueWhere"];
	["ProductRecipeLocalesByLocaleUniqueWhere"]: GraphQLTypes["ProductRecipeLocalesByLocaleUniqueWhere"];
	["ProductIngredientItemConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductIngredientItemEdge"]>
};
	["ProductIngredientItemEdge"]: {
		node: GraphQLTypes["ProductIngredientItem"]
};
	["ProductRecipeLocaleConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductRecipeLocaleEdge"]>
};
	["ProductRecipeLocaleEdge"]: {
		node: GraphQLTypes["ProductRecipeLocale"]
};
	["DeliveryMethodLocale"]: {
		_meta?: GraphQLTypes["DeliveryMethodLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	description?: string | undefined,
	trackingCodeUrlTemplate?: string | undefined,
	processingTitle?: string | undefined,
	processingText?: string | undefined,
	processingIconUrl?: string | undefined,
	dispatchedTitle?: string | undefined,
	dispatchedText?: string | undefined,
	dispatchedIconUrl?: string | undefined,
	fulfilledTitle?: string | undefined,
	fulfilledText?: string | undefined,
	fulfilledIconUrl?: string | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	root?: GraphQLTypes["DeliveryMethod"] | undefined
};
	["DeliveryMethodLocaleMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined,
	trackingCodeUrlTemplate?: GraphQLTypes["FieldMeta"] | undefined,
	processingTitle?: GraphQLTypes["FieldMeta"] | undefined,
	processingText?: GraphQLTypes["FieldMeta"] | undefined,
	processingIconUrl?: GraphQLTypes["FieldMeta"] | undefined,
	dispatchedTitle?: GraphQLTypes["FieldMeta"] | undefined,
	dispatchedText?: GraphQLTypes["FieldMeta"] | undefined,
	dispatchedIconUrl?: GraphQLTypes["FieldMeta"] | undefined,
	fulfilledTitle?: GraphQLTypes["FieldMeta"] | undefined,
	fulfilledText?: GraphQLTypes["FieldMeta"] | undefined,
	fulfilledIconUrl?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined
};
	["DeliveryMethodLocaleOrderBy"]: GraphQLTypes["DeliveryMethodLocaleOrderBy"];
	["PipelineStageLocale"]: {
		_meta?: GraphQLTypes["PipelineStageLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	root?: GraphQLTypes["PipelineStage"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined
};
	["PipelineStageLocaleMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined
};
	["PipelineStage"]: {
		_meta?: GraphQLTypes["PipelineStageMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["PipelineStageItem"]>,
	pipeline?: GraphQLTypes["Pipeline"] | undefined,
	order: number,
	locales: Array<GraphQLTypes["PipelineStageLocale"]>,
	sentiment?: GraphQLTypes["PipelineStageSentiment"] | undefined,
	type: GraphQLTypes["PipelineStageType"],
	forms: Array<GraphQLTypes["LeadForm"]>,
	showItemsWeight: boolean,
	showItemsPrice: boolean,
	itemsByLead?: GraphQLTypes["PipelineStageItem"] | undefined,
	localesByLocale?: GraphQLTypes["PipelineStageLocale"] | undefined,
	formsByCode?: GraphQLTypes["LeadForm"] | undefined,
	formsByLeads?: GraphQLTypes["LeadForm"] | undefined,
	paginateItems: GraphQLTypes["PipelineStageItemConnection"],
	paginateLocales: GraphQLTypes["PipelineStageLocaleConnection"],
	paginateForms: GraphQLTypes["LeadFormConnection"]
};
	["PipelineStageMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined,
	pipeline?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	sentiment?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	forms?: GraphQLTypes["FieldMeta"] | undefined,
	showItemsWeight?: GraphQLTypes["FieldMeta"] | undefined,
	showItemsPrice?: GraphQLTypes["FieldMeta"] | undefined
};
	["PipelineStageItem"]: {
		_meta?: GraphQLTypes["PipelineStageItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	list?: GraphQLTypes["PipelineStage"] | undefined,
	lead?: GraphQLTypes["PipelineLead"] | undefined,
	order: number
};
	["PipelineStageItemMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	lead?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined
};
	["PipelineLead"]: {
		_meta?: GraphQLTypes["PipelineLeadMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt: GraphQLTypes["DateTime"],
	stageItem?: GraphQLTypes["PipelineStageItem"] | undefined,
	contactPerson?: string | undefined,
	customer?: GraphQLTypes["Customer"] | undefined,
	cafeType?: string | undefined,
	offerType?: string | undefined,
	ownMachine: boolean,
	customerCity?: string | undefined,
	companyId?: string | undefined,
	customerName?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	form?: GraphQLTypes["LeadForm"] | undefined,
	meta?: string | undefined,
	multiroasterType?: string | undefined
};
	["PipelineLeadMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	stageItem?: GraphQLTypes["FieldMeta"] | undefined,
	contactPerson?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined,
	cafeType?: GraphQLTypes["FieldMeta"] | undefined,
	offerType?: GraphQLTypes["FieldMeta"] | undefined,
	ownMachine?: GraphQLTypes["FieldMeta"] | undefined,
	customerCity?: GraphQLTypes["FieldMeta"] | undefined,
	companyId?: GraphQLTypes["FieldMeta"] | undefined,
	customerName?: GraphQLTypes["FieldMeta"] | undefined,
	email?: GraphQLTypes["FieldMeta"] | undefined,
	phone?: GraphQLTypes["FieldMeta"] | undefined,
	form?: GraphQLTypes["FieldMeta"] | undefined,
	meta?: GraphQLTypes["FieldMeta"] | undefined,
	multiroasterType?: GraphQLTypes["FieldMeta"] | undefined
};
	["LeadForm"]: {
		_meta?: GraphQLTypes["LeadFormMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	code: string,
	stage?: GraphQLTypes["PipelineStage"] | undefined,
	leads: Array<GraphQLTypes["PipelineLead"]>,
	leadsByStageItem?: GraphQLTypes["PipelineLead"] | undefined,
	paginateLeads: GraphQLTypes["PipelineLeadConnection"]
};
	["LeadFormMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	code?: GraphQLTypes["FieldMeta"] | undefined,
	stage?: GraphQLTypes["FieldMeta"] | undefined,
	leads?: GraphQLTypes["FieldMeta"] | undefined
};
	["PipelineLeadOrderBy"]: GraphQLTypes["PipelineLeadOrderBy"];
	["PipelineStageItemOrderBy"]: GraphQLTypes["PipelineStageItemOrderBy"];
	["PipelineStageOrderBy"]: GraphQLTypes["PipelineStageOrderBy"];
	["PipelineOrderBy"]: GraphQLTypes["PipelineOrderBy"];
	["PipelineStageSentimentOrderBy"]: GraphQLTypes["PipelineStageSentimentOrderBy"];
	["LeadFormOrderBy"]: GraphQLTypes["LeadFormOrderBy"];
	["LeadFormLeadsByStageItemUniqueWhere"]: GraphQLTypes["LeadFormLeadsByStageItemUniqueWhere"];
	["PipelineLeadConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PipelineLeadEdge"]>
};
	["PipelineLeadEdge"]: {
		node: GraphQLTypes["PipelineLead"]
};
	["Pipeline"]: {
		_meta?: GraphQLTypes["PipelineMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	stages: Array<GraphQLTypes["PipelineStage"]>,
	stagesByItems?: GraphQLTypes["PipelineStage"] | undefined,
	stagesByLocales?: GraphQLTypes["PipelineStage"] | undefined,
	stagesByForms?: GraphQLTypes["PipelineStage"] | undefined,
	paginateStages: GraphQLTypes["PipelineStageConnection"]
};
	["PipelineMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	unique?: GraphQLTypes["FieldMeta"] | undefined,
	stages?: GraphQLTypes["FieldMeta"] | undefined
};
	["PipelineStagesByItemsUniqueWhere"]: GraphQLTypes["PipelineStagesByItemsUniqueWhere"];
	["PipelineStagesByLocalesUniqueWhere"]: GraphQLTypes["PipelineStagesByLocalesUniqueWhere"];
	["PipelineStagesByFormsUniqueWhere"]: GraphQLTypes["PipelineStagesByFormsUniqueWhere"];
	["PipelineStageConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PipelineStageEdge"]>
};
	["PipelineStageEdge"]: {
		node: GraphQLTypes["PipelineStage"]
};
	["PipelineStageLocaleOrderBy"]: GraphQLTypes["PipelineStageLocaleOrderBy"];
	["PipelineStageSentiment"]: {
		_meta?: GraphQLTypes["PipelineStageSentimentMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	internalName: string,
	backgroundColor?: string | undefined,
	textColor?: string | undefined
};
	["PipelineStageSentimentMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	internalName?: GraphQLTypes["FieldMeta"] | undefined,
	backgroundColor?: GraphQLTypes["FieldMeta"] | undefined,
	textColor?: GraphQLTypes["FieldMeta"] | undefined
};
	["PipelineStageItemsByLeadUniqueWhere"]: GraphQLTypes["PipelineStageItemsByLeadUniqueWhere"];
	["PipelineStageLocalesByLocaleUniqueWhere"]: GraphQLTypes["PipelineStageLocalesByLocaleUniqueWhere"];
	["PipelineStageFormsByCodeUniqueWhere"]: GraphQLTypes["PipelineStageFormsByCodeUniqueWhere"];
	["PipelineStageFormsByLeadsUniqueWhere"]: GraphQLTypes["PipelineStageFormsByLeadsUniqueWhere"];
	["PipelineStageItemConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PipelineStageItemEdge"]>
};
	["PipelineStageItemEdge"]: {
		node: GraphQLTypes["PipelineStageItem"]
};
	["PipelineStageLocaleConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PipelineStageLocaleEdge"]>
};
	["PipelineStageLocaleEdge"]: {
		node: GraphQLTypes["PipelineStageLocale"]
};
	["LeadFormConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LeadFormEdge"]>
};
	["LeadFormEdge"]: {
		node: GraphQLTypes["LeadForm"]
};
	["SubscriptionBoxLocale"]: {
		_meta?: GraphQLTypes["SubscriptionBoxLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	title?: string | undefined,
	stickerText?: string | undefined,
	descriptionText?: string | undefined,
	root?: GraphQLTypes["SubscriptionBox"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	secondaryTitle?: string | undefined,
	texts?: GraphQLTypes["TextList"] | undefined,
	secondaryTexts?: GraphQLTypes["TextList"] | undefined
};
	["SubscriptionBoxLocaleMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	stickerText?: GraphQLTypes["FieldMeta"] | undefined,
	descriptionText?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	secondaryTitle?: GraphQLTypes["FieldMeta"] | undefined,
	texts?: GraphQLTypes["FieldMeta"] | undefined,
	secondaryTexts?: GraphQLTypes["FieldMeta"] | undefined
};
	["SubscriptionBox"]: {
		_meta?: GraphQLTypes["SubscriptionBoxMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	locales: Array<GraphQLTypes["SubscriptionBoxLocale"]>,
	unique: GraphQLTypes["One"],
	localesByLocale?: GraphQLTypes["SubscriptionBoxLocale"] | undefined,
	localesByTexts?: GraphQLTypes["SubscriptionBoxLocale"] | undefined,
	localesBySecondaryTexts?: GraphQLTypes["SubscriptionBoxLocale"] | undefined,
	paginateLocales: GraphQLTypes["SubscriptionBoxLocaleConnection"]
};
	["SubscriptionBoxMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	unique?: GraphQLTypes["FieldMeta"] | undefined
};
	["SubscriptionBoxLocaleOrderBy"]: GraphQLTypes["SubscriptionBoxLocaleOrderBy"];
	["SubscriptionBoxOrderBy"]: GraphQLTypes["SubscriptionBoxOrderBy"];
	["SubscriptionBoxLocalesByLocaleUniqueWhere"]: GraphQLTypes["SubscriptionBoxLocalesByLocaleUniqueWhere"];
	["SubscriptionBoxLocalesByTextsUniqueWhere"]: GraphQLTypes["SubscriptionBoxLocalesByTextsUniqueWhere"];
	["SubscriptionBoxLocalesBySecondaryTextsUniqueWhere"]: GraphQLTypes["SubscriptionBoxLocalesBySecondaryTextsUniqueWhere"];
	["SubscriptionBoxLocaleConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SubscriptionBoxLocaleEdge"]>
};
	["SubscriptionBoxLocaleEdge"]: {
		node: GraphQLTypes["SubscriptionBoxLocale"]
};
	["LocaleBusinessCategoriesByRootUniqueWhere"]: GraphQLTypes["LocaleBusinessCategoriesByRootUniqueWhere"];
	["LocaleProductCategoryListsByRootUniqueWhere"]: GraphQLTypes["LocaleProductCategoryListsByRootUniqueWhere"];
	["LocaleProductIngredientsByRootUniqueWhere"]: GraphQLTypes["LocaleProductIngredientsByRootUniqueWhere"];
	["LocaleOrderRecurrencesByRootUniqueWhere"]: GraphQLTypes["LocaleOrderRecurrencesByRootUniqueWhere"];
	["LocaleBlogsByRootUniqueWhere"]: GraphQLTypes["LocaleBlogsByRootUniqueWhere"];
	["LocaleBlogPostsByRootUniqueWhere"]: GraphQLTypes["LocaleBlogPostsByRootUniqueWhere"];
	["LocaleBlogPostsByCoverUniqueWhere"]: GraphQLTypes["LocaleBlogPostsByCoverUniqueWhere"];
	["LocaleBlogPostsByContentUniqueWhere"]: GraphQLTypes["LocaleBlogPostsByContentUniqueWhere"];
	["LocaleBlogPostsByLinkUniqueWhere"]: GraphQLTypes["LocaleBlogPostsByLinkUniqueWhere"];
	["LocaleBlogPostsBySeoUniqueWhere"]: GraphQLTypes["LocaleBlogPostsBySeoUniqueWhere"];
	["LocaleMenusByRootUniqueWhere"]: GraphQLTypes["LocaleMenusByRootUniqueWhere"];
	["LocaleMenusByItemsUniqueWhere"]: GraphQLTypes["LocaleMenusByItemsUniqueWhere"];
	["LocaleMenusBySecondaryItemsUniqueWhere"]: GraphQLTypes["LocaleMenusBySecondaryItemsUniqueWhere"];
	["LocalePagesByRootUniqueWhere"]: GraphQLTypes["LocalePagesByRootUniqueWhere"];
	["LocalePagesByLinkUniqueWhere"]: GraphQLTypes["LocalePagesByLinkUniqueWhere"];
	["LocalePagesBySeoUniqueWhere"]: GraphQLTypes["LocalePagesBySeoUniqueWhere"];
	["LocalePagesByContentUniqueWhere"]: GraphQLTypes["LocalePagesByContentUniqueWhere"];
	["LocalePagesByCoverUniqueWhere"]: GraphQLTypes["LocalePagesByCoverUniqueWhere"];
	["LocaleProductIngredientCategoriesByRootUniqueWhere"]: GraphQLTypes["LocaleProductIngredientCategoriesByRootUniqueWhere"];
	["LocaleAllergensByRootUniqueWhere"]: GraphQLTypes["LocaleAllergensByRootUniqueWhere"];
	["LocaleProductPackingsByRootUniqueWhere"]: GraphQLTypes["LocaleProductPackingsByRootUniqueWhere"];
	["LocaleProductsByRootUniqueWhere"]: GraphQLTypes["LocaleProductsByRootUniqueWhere"];
	["LocaleProductsByFeatureListUniqueWhere"]: GraphQLTypes["LocaleProductsByFeatureListUniqueWhere"];
	["LocaleProductRecipesByRootUniqueWhere"]: GraphQLTypes["LocaleProductRecipesByRootUniqueWhere"];
	["LocalePointOfSaleCategoriesByRootUniqueWhere"]: GraphQLTypes["LocalePointOfSaleCategoriesByRootUniqueWhere"];
	["LocalePointOfSaleCategoryProductsByRootUniqueWhere"]: GraphQLTypes["LocalePointOfSaleCategoryProductsByRootUniqueWhere"];
	["LocaleDeliveryMethodsByRootUniqueWhere"]: GraphQLTypes["LocaleDeliveryMethodsByRootUniqueWhere"];
	["LocaleIngredientSuppliersByRootUniqueWhere"]: GraphQLTypes["LocaleIngredientSuppliersByRootUniqueWhere"];
	["LocaleIdentificationCodesByRootUniqueWhere"]: GraphQLTypes["LocaleIdentificationCodesByRootUniqueWhere"];
	["LocalePipelineStagesByRootUniqueWhere"]: GraphQLTypes["LocalePipelineStagesByRootUniqueWhere"];
	["LocaleSubscriptionBoxesByRootUniqueWhere"]: GraphQLTypes["LocaleSubscriptionBoxesByRootUniqueWhere"];
	["LocaleSubscriptionBoxesByTextsUniqueWhere"]: GraphQLTypes["LocaleSubscriptionBoxesByTextsUniqueWhere"];
	["LocaleSubscriptionBoxesBySecondaryTextsUniqueWhere"]: GraphQLTypes["LocaleSubscriptionBoxesBySecondaryTextsUniqueWhere"];
	["LocaleBusinessServicesByRootUniqueWhere"]: GraphQLTypes["LocaleBusinessServicesByRootUniqueWhere"];
	["ProductPackingLocaleConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductPackingLocaleEdge"]>
};
	["ProductPackingLocaleEdge"]: {
		node: GraphQLTypes["ProductPackingLocale"]
};
	["ProductLocaleConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductLocaleEdge"]>
};
	["ProductLocaleEdge"]: {
		node: GraphQLTypes["ProductLocale"]
};
	["DeliveryMethodLocaleConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DeliveryMethodLocaleEdge"]>
};
	["DeliveryMethodLocaleEdge"]: {
		node: GraphQLTypes["DeliveryMethodLocale"]
};
	["PreparedPackingQuantity"]: {
		_meta?: GraphQLTypes["PreparedPackingQuantityMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	date: GraphQLTypes["Date"],
	quantity?: number | undefined,
	recipe?: GraphQLTypes["ProductRecipe"] | undefined,
	packing?: GraphQLTypes["ProductPacking"] | undefined,
	packedInCardboard: boolean
};
	["PreparedPackingQuantityMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	date?: GraphQLTypes["FieldMeta"] | undefined,
	quantity?: GraphQLTypes["FieldMeta"] | undefined,
	recipe?: GraphQLTypes["FieldMeta"] | undefined,
	packing?: GraphQLTypes["FieldMeta"] | undefined,
	packedInCardboard?: GraphQLTypes["FieldMeta"] | undefined
};
	["PreparedPackingQuantityOrderBy"]: GraphQLTypes["PreparedPackingQuantityOrderBy"];
	["ProductPackingLocalesByLocaleUniqueWhere"]: GraphQLTypes["ProductPackingLocalesByLocaleUniqueWhere"];
	["PreparedPackingQuantityConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PreparedPackingQuantityEdge"]>
};
	["PreparedPackingQuantityEdge"]: {
		node: GraphQLTypes["PreparedPackingQuantity"]
};
	["ProductStock"]: {
		_meta?: GraphQLTypes["ProductStockMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	quantity: number,
	product?: GraphQLTypes["Product"] | undefined,
	store?: GraphQLTypes["Store"] | undefined
};
	["ProductStockMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	quantity?: GraphQLTypes["FieldMeta"] | undefined,
	product?: GraphQLTypes["FieldMeta"] | undefined,
	store?: GraphQLTypes["FieldMeta"] | undefined
};
	["Store"]: {
		_meta?: GraphQLTypes["StoreMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	code: string,
	description?: string | undefined,
	internalNote?: string | undefined
};
	["StoreMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	code?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductStockOrderBy"]: GraphQLTypes["ProductStockOrderBy"];
	["StoreOrderBy"]: GraphQLTypes["StoreOrderBy"];
	["ProductGroupPrice"]: {
		_meta?: GraphQLTypes["ProductGroupPriceMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	priceCents: number,
	group?: GraphQLTypes["CustomerGroup"] | undefined,
	product?: GraphQLTypes["Product"] | undefined
};
	["ProductGroupPriceMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	priceCents?: GraphQLTypes["FieldMeta"] | undefined,
	group?: GraphQLTypes["FieldMeta"] | undefined,
	product?: GraphQLTypes["FieldMeta"] | undefined
};
	["CustomerGroup"]: {
		_meta?: GraphQLTypes["CustomerGroupMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	productPrices: Array<GraphQLTypes["ProductGroupPrice"]>,
	customers: Array<GraphQLTypes["Customer"]>,
	discountPermille?: number | undefined,
	code?: string | undefined,
	doubleshotLegacyId?: string | undefined,
	productPricesByProduct?: GraphQLTypes["ProductGroupPrice"] | undefined,
	customersByDoubleshotLegacyId?: GraphQLTypes["Customer"] | undefined,
	customersByAddresses?: GraphQLTypes["Customer"] | undefined,
	customersByDefaultBillingAddress?: GraphQLTypes["Customer"] | undefined,
	customersByDefaultPaymentMethod?: GraphQLTypes["Customer"] | undefined,
	customersByCredits?: GraphQLTypes["Customer"] | undefined,
	customersByPaymentMethods?: GraphQLTypes["Customer"] | undefined,
	customersByOrders?: GraphQLTypes["Customer"] | undefined,
	customersByPermissions?: GraphQLTypes["Customer"] | undefined,
	customersByName?: GraphQLTypes["Customer"] | undefined,
	customersByIngredientRatings?: GraphQLTypes["Customer"] | undefined,
	customersByBusiness?: GraphQLTypes["Customer"] | undefined,
	customersByCarts?: GraphQLTypes["Customer"] | undefined,
	customersByShortcutList?: GraphQLTypes["Customer"] | undefined,
	customersByUser?: GraphQLTypes["Customer"] | undefined,
	customersByInvoices?: GraphQLTypes["Customer"] | undefined,
	customersByInvoicingPlan?: GraphQLTypes["Customer"] | undefined,
	customersByBillingSubjects?: GraphQLTypes["Customer"] | undefined,
	customersByOfferedProducts?: GraphQLTypes["Customer"] | undefined,
	customersByDefaultDeliveryAddress?: GraphQLTypes["Customer"] | undefined,
	customersByDefaultBillingSubject?: GraphQLTypes["Customer"] | undefined,
	customersByAnonymousSession?: GraphQLTypes["Customer"] | undefined,
	customersByBoughtVouchers?: GraphQLTypes["Customer"] | undefined,
	customersByOwnsVouchers?: GraphQLTypes["Customer"] | undefined,
	customersByRedeemedVouchers?: GraphQLTypes["Customer"] | undefined,
	customersBySpending?: GraphQLTypes["Customer"] | undefined,
	customersByCustomerTabs?: GraphQLTypes["Customer"] | undefined,
	customersByLead?: GraphQLTypes["Customer"] | undefined,
	customersByMeta?: GraphQLTypes["Customer"] | undefined,
	paginateProductPrices: GraphQLTypes["ProductGroupPriceConnection"],
	paginateCustomers: GraphQLTypes["CustomerConnection"]
};
	["CustomerGroupMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	productPrices?: GraphQLTypes["FieldMeta"] | undefined,
	customers?: GraphQLTypes["FieldMeta"] | undefined,
	discountPermille?: GraphQLTypes["FieldMeta"] | undefined,
	code?: GraphQLTypes["FieldMeta"] | undefined,
	doubleshotLegacyId?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductGroupPriceOrderBy"]: GraphQLTypes["ProductGroupPriceOrderBy"];
	["CustomerGroupProductPricesByProductUniqueWhere"]: GraphQLTypes["CustomerGroupProductPricesByProductUniqueWhere"];
	["CustomerGroupCustomersByDoubleshotLegacyIdUniqueWhere"]: GraphQLTypes["CustomerGroupCustomersByDoubleshotLegacyIdUniqueWhere"];
	["CustomerGroupCustomersByAddressesUniqueWhere"]: GraphQLTypes["CustomerGroupCustomersByAddressesUniqueWhere"];
	["CustomerGroupCustomersByDefaultBillingAddressUniqueWhere"]: GraphQLTypes["CustomerGroupCustomersByDefaultBillingAddressUniqueWhere"];
	["CustomerGroupCustomersByDefaultPaymentMethodUniqueWhere"]: GraphQLTypes["CustomerGroupCustomersByDefaultPaymentMethodUniqueWhere"];
	["CustomerGroupCustomersByCreditsUniqueWhere"]: GraphQLTypes["CustomerGroupCustomersByCreditsUniqueWhere"];
	["CustomerGroupCustomersByPaymentMethodsUniqueWhere"]: GraphQLTypes["CustomerGroupCustomersByPaymentMethodsUniqueWhere"];
	["CustomerGroupCustomersByOrdersUniqueWhere"]: GraphQLTypes["CustomerGroupCustomersByOrdersUniqueWhere"];
	["CustomerGroupCustomersByPermissionsUniqueWhere"]: GraphQLTypes["CustomerGroupCustomersByPermissionsUniqueWhere"];
	["CustomerGroupCustomersByNameUniqueWhere"]: GraphQLTypes["CustomerGroupCustomersByNameUniqueWhere"];
	["CustomerGroupCustomersByIngredientRatingsUniqueWhere"]: GraphQLTypes["CustomerGroupCustomersByIngredientRatingsUniqueWhere"];
	["CustomerGroupCustomersByBusinessUniqueWhere"]: GraphQLTypes["CustomerGroupCustomersByBusinessUniqueWhere"];
	["CustomerGroupCustomersByCartsUniqueWhere"]: GraphQLTypes["CustomerGroupCustomersByCartsUniqueWhere"];
	["CustomerGroupCustomersByShortcutListUniqueWhere"]: GraphQLTypes["CustomerGroupCustomersByShortcutListUniqueWhere"];
	["CustomerGroupCustomersByUserUniqueWhere"]: GraphQLTypes["CustomerGroupCustomersByUserUniqueWhere"];
	["CustomerGroupCustomersByInvoicesUniqueWhere"]: GraphQLTypes["CustomerGroupCustomersByInvoicesUniqueWhere"];
	["CustomerGroupCustomersByInvoicingPlanUniqueWhere"]: GraphQLTypes["CustomerGroupCustomersByInvoicingPlanUniqueWhere"];
	["CustomerGroupCustomersByBillingSubjectsUniqueWhere"]: GraphQLTypes["CustomerGroupCustomersByBillingSubjectsUniqueWhere"];
	["CustomerGroupCustomersByOfferedProductsUniqueWhere"]: GraphQLTypes["CustomerGroupCustomersByOfferedProductsUniqueWhere"];
	["CustomerGroupCustomersByDefaultDeliveryAddressUniqueWhere"]: GraphQLTypes["CustomerGroupCustomersByDefaultDeliveryAddressUniqueWhere"];
	["CustomerGroupCustomersByDefaultBillingSubjectUniqueWhere"]: GraphQLTypes["CustomerGroupCustomersByDefaultBillingSubjectUniqueWhere"];
	["CustomerGroupCustomersByAnonymousSessionUniqueWhere"]: GraphQLTypes["CustomerGroupCustomersByAnonymousSessionUniqueWhere"];
	["CustomerGroupCustomersByBoughtVouchersUniqueWhere"]: GraphQLTypes["CustomerGroupCustomersByBoughtVouchersUniqueWhere"];
	["CustomerGroupCustomersByOwnsVouchersUniqueWhere"]: GraphQLTypes["CustomerGroupCustomersByOwnsVouchersUniqueWhere"];
	["CustomerGroupCustomersByRedeemedVouchersUniqueWhere"]: GraphQLTypes["CustomerGroupCustomersByRedeemedVouchersUniqueWhere"];
	["CustomerGroupCustomersBySpendingUniqueWhere"]: GraphQLTypes["CustomerGroupCustomersBySpendingUniqueWhere"];
	["CustomerGroupCustomersByCustomerTabsUniqueWhere"]: GraphQLTypes["CustomerGroupCustomersByCustomerTabsUniqueWhere"];
	["CustomerGroupCustomersByLeadUniqueWhere"]: GraphQLTypes["CustomerGroupCustomersByLeadUniqueWhere"];
	["CustomerGroupCustomersByMetaUniqueWhere"]: GraphQLTypes["CustomerGroupCustomersByMetaUniqueWhere"];
	["ProductGroupPriceConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductGroupPriceEdge"]>
};
	["ProductGroupPriceEdge"]: {
		node: GraphQLTypes["ProductGroupPrice"]
};
	["ProductCustomerPrice"]: {
		_meta?: GraphQLTypes["ProductCustomerPriceMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	groupDiscountPermille?: number | undefined,
	groupPriceCents?: number | undefined,
	fullPriceCents: number,
	discountedPriceCents?: number | undefined,
	priceCents: number,
	offered: boolean,
	notDiscountable: boolean,
	customer?: GraphQLTypes["Customer"] | undefined,
	product?: GraphQLTypes["Product"] | undefined
};
	["ProductCustomerPriceMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	groupDiscountPermille?: GraphQLTypes["FieldMeta"] | undefined,
	groupPriceCents?: GraphQLTypes["FieldMeta"] | undefined,
	fullPriceCents?: GraphQLTypes["FieldMeta"] | undefined,
	discountedPriceCents?: GraphQLTypes["FieldMeta"] | undefined,
	priceCents?: GraphQLTypes["FieldMeta"] | undefined,
	offered?: GraphQLTypes["FieldMeta"] | undefined,
	notDiscountable?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined,
	product?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductCustomerPriceOrderBy"]: GraphQLTypes["ProductCustomerPriceOrderBy"];
	["ProductMetadata"]: {
		_meta?: GraphQLTypes["ProductMetadataMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	archived: boolean,
	available: boolean,
	availableQuantity: number,
	product?: GraphQLTypes["Product"] | undefined
};
	["ProductMetadataMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	archived?: GraphQLTypes["FieldMeta"] | undefined,
	available?: GraphQLTypes["FieldMeta"] | undefined,
	availableQuantity?: GraphQLTypes["FieldMeta"] | undefined,
	product?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductSalesDay"]: {
		_meta?: GraphQLTypes["ProductSalesDayMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	productName: string,
	orderDate?: GraphQLTypes["Date"] | undefined,
	priceCentsSum: number,
	sum: number,
	product?: GraphQLTypes["Product"] | undefined
};
	["ProductSalesDayMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	productName?: GraphQLTypes["FieldMeta"] | undefined,
	orderDate?: GraphQLTypes["FieldMeta"] | undefined,
	priceCentsSum?: GraphQLTypes["FieldMeta"] | undefined,
	sum?: GraphQLTypes["FieldMeta"] | undefined,
	product?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductSalesDayOrderBy"]: GraphQLTypes["ProductSalesDayOrderBy"];
	["ProductSalesWeek"]: {
		_meta?: GraphQLTypes["ProductSalesWeekMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	productName: string,
	orderDate?: GraphQLTypes["Date"] | undefined,
	priceCentsSum: number,
	sum: number,
	product?: GraphQLTypes["Product"] | undefined
};
	["ProductSalesWeekMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	productName?: GraphQLTypes["FieldMeta"] | undefined,
	orderDate?: GraphQLTypes["FieldMeta"] | undefined,
	priceCentsSum?: GraphQLTypes["FieldMeta"] | undefined,
	sum?: GraphQLTypes["FieldMeta"] | undefined,
	product?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductSalesWeekOrderBy"]: GraphQLTypes["ProductSalesWeekOrderBy"];
	["ProductSalesMonth"]: {
		_meta?: GraphQLTypes["ProductSalesMonthMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	productName: string,
	orderDate?: GraphQLTypes["Date"] | undefined,
	priceCentsSum: number,
	sum: number,
	product?: GraphQLTypes["Product"] | undefined
};
	["ProductSalesMonthMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	productName?: GraphQLTypes["FieldMeta"] | undefined,
	orderDate?: GraphQLTypes["FieldMeta"] | undefined,
	priceCentsSum?: GraphQLTypes["FieldMeta"] | undefined,
	sum?: GraphQLTypes["FieldMeta"] | undefined,
	product?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductSalesMonthOrderBy"]: GraphQLTypes["ProductSalesMonthOrderBy"];
	["ProductStocksByStoreUniqueWhere"]: GraphQLTypes["ProductStocksByStoreUniqueWhere"];
	["ProductGroupPricesByGroupUniqueWhere"]: GraphQLTypes["ProductGroupPricesByGroupUniqueWhere"];
	["ProductCartItemsByCartUniqueWhere"]: GraphQLTypes["ProductCartItemsByCartUniqueWhere"];
	["ProductOrderItemsByVirtualProductEffectsUniqueWhere"]: GraphQLTypes["ProductOrderItemsByVirtualProductEffectsUniqueWhere"];
	["ProductLocalesByLocaleUniqueWhere"]: GraphQLTypes["ProductLocalesByLocaleUniqueWhere"];
	["ProductLocalesByFeatureListUniqueWhere"]: GraphQLTypes["ProductLocalesByFeatureListUniqueWhere"];
	["ProductCustomerPricesByCustomerUniqueWhere"]: GraphQLTypes["ProductCustomerPricesByCustomerUniqueWhere"];
	["ProductStockConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductStockEdge"]>
};
	["ProductStockEdge"]: {
		node: GraphQLTypes["ProductStock"]
};
	["DeliveryZoneConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DeliveryZoneEdge"]>
};
	["DeliveryZoneEdge"]: {
		node: GraphQLTypes["DeliveryZone"]
};
	["ProductCustomerPriceConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductCustomerPriceEdge"]>
};
	["ProductCustomerPriceEdge"]: {
		node: GraphQLTypes["ProductCustomerPrice"]
};
	["ProductSalesDayConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductSalesDayEdge"]>
};
	["ProductSalesDayEdge"]: {
		node: GraphQLTypes["ProductSalesDay"]
};
	["ProductSalesWeekConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductSalesWeekEdge"]>
};
	["ProductSalesWeekEdge"]: {
		node: GraphQLTypes["ProductSalesWeek"]
};
	["ProductSalesMonthConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductSalesMonthEdge"]>
};
	["ProductSalesMonthEdge"]: {
		node: GraphQLTypes["ProductSalesMonth"]
};
	["AddressMetadata"]: {
		_meta?: GraphQLTypes["AddressMetadataMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	deliveryZoneType?: GraphQLTypes["DeliveryZoneType"] | undefined,
	address?: GraphQLTypes["Address"] | undefined,
	deliveryZone?: GraphQLTypes["DeliveryZone"] | undefined
};
	["AddressMetadataMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryZoneType?: GraphQLTypes["FieldMeta"] | undefined,
	address?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryZone?: GraphQLTypes["FieldMeta"] | undefined
};
	["DeliveryZoneAddressesByMetaUniqueWhere"]: GraphQLTypes["DeliveryZoneAddressesByMetaUniqueWhere"];
	["DeliveryZoneAddressesByGpsUniqueWhere"]: GraphQLTypes["DeliveryZoneAddressesByGpsUniqueWhere"];
	["DeliveryZoneAddressesByInvoicesUniqueWhere"]: GraphQLTypes["DeliveryZoneAddressesByInvoicesUniqueWhere"];
	["DeliveryZoneAddressesByBillingAddressOfOrdersUniqueWhere"]: GraphQLTypes["DeliveryZoneAddressesByBillingAddressOfOrdersUniqueWhere"];
	["DeliveryZoneAddressesByDeliveryAddressOfOrderDeliveriesUniqueWhere"]: GraphQLTypes["DeliveryZoneAddressesByDeliveryAddressOfOrderDeliveriesUniqueWhere"];
	["DeliveryZoneAddressesByDefaultDeliveryAddressOfCustomerUniqueWhere"]: GraphQLTypes["DeliveryZoneAddressesByDefaultDeliveryAddressOfCustomerUniqueWhere"];
	["DeliveryZoneAddressesMetadataByAddressUniqueWhere"]: GraphQLTypes["DeliveryZoneAddressesMetadataByAddressUniqueWhere"];
	["AddressConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["AddressEdge"]>
};
	["AddressEdge"]: {
		node: GraphQLTypes["Address"]
};
	["AddressMetadataConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["AddressMetadataEdge"]>
};
	["AddressMetadataEdge"]: {
		node: GraphQLTypes["AddressMetadata"]
};
	["DeliveryTimelinePreset"]: {
		_meta?: GraphQLTypes["DeliveryTimelinePresetMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["DeliveryTimelineType"],
	duration?: string | undefined,
	window?: string | undefined,
	deliveryMethod?: GraphQLTypes["DeliveryMethod"] | undefined
};
	["DeliveryTimelinePresetMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	duration?: GraphQLTypes["FieldMeta"] | undefined,
	window?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryMethod?: GraphQLTypes["FieldMeta"] | undefined
};
	["DeliveryMethodLocalesByLocaleUniqueWhere"]: GraphQLTypes["DeliveryMethodLocalesByLocaleUniqueWhere"];
	["PaymentMethodConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PaymentMethodEdge"]>
};
	["PaymentMethodEdge"]: {
		node: GraphQLTypes["PaymentMethod"]
};
	["CourierConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CourierEdge"]>
};
	["CourierEdge"]: {
		node: GraphQLTypes["Courier"]
};
	["CustomerPermissions"]: {
		_meta?: GraphQLTypes["CustomerPermissionsMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	canPlaceOrder?: boolean | undefined,
	customer?: GraphQLTypes["Customer"] | undefined
};
	["CustomerPermissionsMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	canPlaceOrder?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined
};
	["CustomerName"]: {
		_meta?: GraphQLTypes["CustomerNameMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	nominative: string,
	vocative?: string | undefined,
	customer?: GraphQLTypes["Customer"] | undefined,
	aliases: Array<GraphQLTypes["CustomerAlias"]>,
	paginateAliases: GraphQLTypes["CustomerAliasConnection"]
};
	["CustomerNameMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	nominative?: GraphQLTypes["FieldMeta"] | undefined,
	vocative?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined,
	aliases?: GraphQLTypes["FieldMeta"] | undefined
};
	["CustomerAlias"]: {
		_meta?: GraphQLTypes["CustomerAliasMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name?: string | undefined,
	order: number
};
	["CustomerAliasMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined
};
	["CustomerAliasOrderBy"]: GraphQLTypes["CustomerAliasOrderBy"];
	["CustomerAliasConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CustomerAliasEdge"]>
};
	["CustomerAliasEdge"]: {
		node: GraphQLTypes["CustomerAlias"]
};
	["ApplicationShortcutList"]: {
		_meta?: GraphQLTypes["ApplicationShortcutListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["ApplicationShortcutListItem"]>,
	customer?: GraphQLTypes["Customer"] | undefined,
	paginateItems: GraphQLTypes["ApplicationShortcutListItemConnection"]
};
	["ApplicationShortcutListMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined
};
	["ApplicationShortcutListItem"]: {
		_meta?: GraphQLTypes["ApplicationShortcutListItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order?: number | undefined,
	application?: GraphQLTypes["Application"] | undefined,
	list?: GraphQLTypes["ApplicationShortcutList"] | undefined
};
	["ApplicationShortcutListItemMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	application?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined
};
	["Application"]: {
		_meta?: GraphQLTypes["ApplicationMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	handle?: string | undefined,
	url?: string | undefined,
	color?: string | undefined,
	icon?: GraphQLTypes["Image"] | undefined,
	name?: string | undefined,
	short?: string | undefined
};
	["ApplicationMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	handle?: GraphQLTypes["FieldMeta"] | undefined,
	url?: GraphQLTypes["FieldMeta"] | undefined,
	color?: GraphQLTypes["FieldMeta"] | undefined,
	icon?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	short?: GraphQLTypes["FieldMeta"] | undefined
};
	["ApplicationShortcutListItemOrderBy"]: GraphQLTypes["ApplicationShortcutListItemOrderBy"];
	["ApplicationOrderBy"]: GraphQLTypes["ApplicationOrderBy"];
	["ApplicationShortcutListItemConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ApplicationShortcutListItemEdge"]>
};
	["ApplicationShortcutListItemEdge"]: {
		node: GraphQLTypes["ApplicationShortcutListItem"]
};
	["InvoicingPlan"]: {
		_meta?: GraphQLTypes["InvoicingPlanMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	customer?: GraphQLTypes["Customer"] | undefined,
	preset?: GraphQLTypes["InvoicingPreset"] | undefined
};
	["InvoicingPlanMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined,
	preset?: GraphQLTypes["FieldMeta"] | undefined
};
	["InvoicingPreset"]: {
		_meta?: GraphQLTypes["InvoicingPresetMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	type?: GraphQLTypes["InvoicingPresetType"] | undefined,
	startsAt?: GraphQLTypes["DateTime"] | undefined,
	endsAt?: GraphQLTypes["DateTime"] | undefined,
	intervalOfDays?: number | undefined,
	invoicingPlan?: GraphQLTypes["InvoicingPlan"] | undefined
};
	["InvoicingPresetMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	startsAt?: GraphQLTypes["FieldMeta"] | undefined,
	endsAt?: GraphQLTypes["FieldMeta"] | undefined,
	intervalOfDays?: GraphQLTypes["FieldMeta"] | undefined,
	invoicingPlan?: GraphQLTypes["FieldMeta"] | undefined
};
	["CustomerSpending"]: {
		_meta?: GraphQLTypes["CustomerSpendingMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	totalCents: number,
	customer?: GraphQLTypes["Customer"] | undefined
};
	["CustomerSpendingMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	totalCents?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined
};
	["CustomerMetadata"]: {
		_meta?: GraphQLTypes["CustomerMetadataMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	isBusiness: boolean,
	name?: string | undefined,
	fallbackName: string,
	remainingCreditsCents: number,
	ordersTotalCents: number,
	customerProfileUrl: string,
	customer?: GraphQLTypes["Customer"] | undefined
};
	["CustomerMetadataMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	isBusiness?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	fallbackName?: GraphQLTypes["FieldMeta"] | undefined,
	remainingCreditsCents?: GraphQLTypes["FieldMeta"] | undefined,
	ordersTotalCents?: GraphQLTypes["FieldMeta"] | undefined,
	customerProfileUrl?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined
};
	["CustomerAddressesByMetaUniqueWhere"]: GraphQLTypes["CustomerAddressesByMetaUniqueWhere"];
	["CustomerAddressesByGpsUniqueWhere"]: GraphQLTypes["CustomerAddressesByGpsUniqueWhere"];
	["CustomerAddressesByInvoicesUniqueWhere"]: GraphQLTypes["CustomerAddressesByInvoicesUniqueWhere"];
	["CustomerAddressesByBillingAddressOfOrdersUniqueWhere"]: GraphQLTypes["CustomerAddressesByBillingAddressOfOrdersUniqueWhere"];
	["CustomerAddressesByDeliveryAddressOfOrderDeliveriesUniqueWhere"]: GraphQLTypes["CustomerAddressesByDeliveryAddressOfOrderDeliveriesUniqueWhere"];
	["CustomerAddressesByDefaultDeliveryAddressOfCustomerUniqueWhere"]: GraphQLTypes["CustomerAddressesByDefaultDeliveryAddressOfCustomerUniqueWhere"];
	["CustomerCreditsByTransactionsUniqueWhere"]: GraphQLTypes["CustomerCreditsByTransactionsUniqueWhere"];
	["CustomerCreditsByVoucherRedemptionUniqueWhere"]: GraphQLTypes["CustomerCreditsByVoucherRedemptionUniqueWhere"];
	["CustomerOrdersBySeqUniqueWhere"]: GraphQLTypes["CustomerOrdersBySeqUniqueWhere"];
	["CustomerOrdersByDoubleshotLegacyIdUniqueWhere"]: GraphQLTypes["CustomerOrdersByDoubleshotLegacyIdUniqueWhere"];
	["CustomerOrdersByDoubleShotLegacyNumberUniqueWhere"]: GraphQLTypes["CustomerOrdersByDoubleShotLegacyNumberUniqueWhere"];
	["CustomerOrdersByDiscountsUniqueWhere"]: GraphQLTypes["CustomerOrdersByDiscountsUniqueWhere"];
	["CustomerOrdersByDeliveryUniqueWhere"]: GraphQLTypes["CustomerOrdersByDeliveryUniqueWhere"];
	["CustomerOrdersByItemsUniqueWhere"]: GraphQLTypes["CustomerOrdersByItemsUniqueWhere"];
	["CustomerOrdersByCartUniqueWhere"]: GraphQLTypes["CustomerOrdersByCartUniqueWhere"];
	["CustomerOrdersByEventsUniqueWhere"]: GraphQLTypes["CustomerOrdersByEventsUniqueWhere"];
	["CustomerOrdersByPriceLinesUniqueWhere"]: GraphQLTypes["CustomerOrdersByPriceLinesUniqueWhere"];
	["CustomerOrdersByPaymentsUniqueWhere"]: GraphQLTypes["CustomerOrdersByPaymentsUniqueWhere"];
	["CustomerOrdersBySummaryUniqueWhere"]: GraphQLTypes["CustomerOrdersBySummaryUniqueWhere"];
	["CustomerOrdersByGratuityUniqueWhere"]: GraphQLTypes["CustomerOrdersByGratuityUniqueWhere"];
	["CustomerIngredientRatingsByIngredientUniqueWhere"]: GraphQLTypes["CustomerIngredientRatingsByIngredientUniqueWhere"];
	["CustomerCartsByItemsUniqueWhere"]: GraphQLTypes["CustomerCartsByItemsUniqueWhere"];
	["CustomerCartsByOrderUniqueWhere"]: GraphQLTypes["CustomerCartsByOrderUniqueWhere"];
	["CustomerCartsByPriceLinesUniqueWhere"]: GraphQLTypes["CustomerCartsByPriceLinesUniqueWhere"];
	["CustomerCartsBySummaryUniqueWhere"]: GraphQLTypes["CustomerCartsBySummaryUniqueWhere"];
	["CustomerInvoicesByPublicKeyUniqueWhere"]: GraphQLTypes["CustomerInvoicesByPublicKeyUniqueWhere"];
	["CustomerInvoicesByFakturoidIdUniqueWhere"]: GraphQLTypes["CustomerInvoicesByFakturoidIdUniqueWhere"];
	["CustomerInvoicesByOrderPaymentsUniqueWhere"]: GraphQLTypes["CustomerInvoicesByOrderPaymentsUniqueWhere"];
	["CustomerBillingSubjectsByInvoicesUniqueWhere"]: GraphQLTypes["CustomerBillingSubjectsByInvoicesUniqueWhere"];
	["CustomerBillingSubjectsByDefaultBillingSubjectOfCustomerUniqueWhere"]: GraphQLTypes["CustomerBillingSubjectsByDefaultBillingSubjectOfCustomerUniqueWhere"];
	["CustomerBillingSubjectsByOrdersUniqueWhere"]: GraphQLTypes["CustomerBillingSubjectsByOrdersUniqueWhere"];
	["CustomerOfferedProductsByProductUniqueWhere"]: GraphQLTypes["CustomerOfferedProductsByProductUniqueWhere"];
	["CustomerBoughtVouchersByCodeUniqueWhere"]: GraphQLTypes["CustomerBoughtVouchersByCodeUniqueWhere"];
	["CustomerBoughtVouchersByRedemptionUniqueWhere"]: GraphQLTypes["CustomerBoughtVouchersByRedemptionUniqueWhere"];
	["CustomerOwnsVouchersByCodeUniqueWhere"]: GraphQLTypes["CustomerOwnsVouchersByCodeUniqueWhere"];
	["CustomerOwnsVouchersByRedemptionUniqueWhere"]: GraphQLTypes["CustomerOwnsVouchersByRedemptionUniqueWhere"];
	["CustomerRedeemedVouchersByCustomerCreditUniqueWhere"]: GraphQLTypes["CustomerRedeemedVouchersByCustomerCreditUniqueWhere"];
	["CustomerRedeemedVouchersByOrderDiscountUniqueWhere"]: GraphQLTypes["CustomerRedeemedVouchersByOrderDiscountUniqueWhere"];
	["CustomerRedeemedVouchersByVoucherUniqueWhere"]: GraphQLTypes["CustomerRedeemedVouchersByVoucherUniqueWhere"];
	["CustomerCustomerTabsByItemsUniqueWhere"]: GraphQLTypes["CustomerCustomerTabsByItemsUniqueWhere"];
	["CustomerCustomerTabsByMetaUniqueWhere"]: GraphQLTypes["CustomerCustomerTabsByMetaUniqueWhere"];
	["CustomerLeadByStageItemUniqueWhere"]: GraphQLTypes["CustomerLeadByStageItemUniqueWhere"];
	["CustomerCreditConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CustomerCreditEdge"]>
};
	["CustomerCreditEdge"]: {
		node: GraphQLTypes["CustomerCredit"]
};
	["CustomerPaymentMethodConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CustomerPaymentMethodEdge"]>
};
	["CustomerPaymentMethodEdge"]: {
		node: GraphQLTypes["CustomerPaymentMethod"]
};
	["BillingSubjectConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BillingSubjectEdge"]>
};
	["BillingSubjectEdge"]: {
		node: GraphQLTypes["BillingSubject"]
};
	["VoucherRedemptionConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["VoucherRedemptionEdge"]>
};
	["VoucherRedemptionEdge"]: {
		node: GraphQLTypes["VoucherRedemption"]
};
	["Gps"]: {
		_meta?: GraphQLTypes["GpsMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	latitude: number,
	longitude: number,
	address?: GraphQLTypes["Address"] | undefined
};
	["GpsMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	latitude?: GraphQLTypes["FieldMeta"] | undefined,
	longitude?: GraphQLTypes["FieldMeta"] | undefined,
	address?: GraphQLTypes["FieldMeta"] | undefined
};
	["AddressInvoicesByPublicKeyUniqueWhere"]: GraphQLTypes["AddressInvoicesByPublicKeyUniqueWhere"];
	["AddressInvoicesByFakturoidIdUniqueWhere"]: GraphQLTypes["AddressInvoicesByFakturoidIdUniqueWhere"];
	["AddressInvoicesByOrderPaymentsUniqueWhere"]: GraphQLTypes["AddressInvoicesByOrderPaymentsUniqueWhere"];
	["AddressBillingAddressOfOrdersBySeqUniqueWhere"]: GraphQLTypes["AddressBillingAddressOfOrdersBySeqUniqueWhere"];
	["AddressBillingAddressOfOrdersByDoubleshotLegacyIdUniqueWhere"]: GraphQLTypes["AddressBillingAddressOfOrdersByDoubleshotLegacyIdUniqueWhere"];
	["AddressBillingAddressOfOrdersByDoubleShotLegacyNumberUniqueWhere"]: GraphQLTypes["AddressBillingAddressOfOrdersByDoubleShotLegacyNumberUniqueWhere"];
	["AddressBillingAddressOfOrdersByDiscountsUniqueWhere"]: GraphQLTypes["AddressBillingAddressOfOrdersByDiscountsUniqueWhere"];
	["AddressBillingAddressOfOrdersByDeliveryUniqueWhere"]: GraphQLTypes["AddressBillingAddressOfOrdersByDeliveryUniqueWhere"];
	["AddressBillingAddressOfOrdersByItemsUniqueWhere"]: GraphQLTypes["AddressBillingAddressOfOrdersByItemsUniqueWhere"];
	["AddressBillingAddressOfOrdersByCartUniqueWhere"]: GraphQLTypes["AddressBillingAddressOfOrdersByCartUniqueWhere"];
	["AddressBillingAddressOfOrdersByEventsUniqueWhere"]: GraphQLTypes["AddressBillingAddressOfOrdersByEventsUniqueWhere"];
	["AddressBillingAddressOfOrdersByPriceLinesUniqueWhere"]: GraphQLTypes["AddressBillingAddressOfOrdersByPriceLinesUniqueWhere"];
	["AddressBillingAddressOfOrdersByPaymentsUniqueWhere"]: GraphQLTypes["AddressBillingAddressOfOrdersByPaymentsUniqueWhere"];
	["AddressBillingAddressOfOrdersBySummaryUniqueWhere"]: GraphQLTypes["AddressBillingAddressOfOrdersBySummaryUniqueWhere"];
	["AddressBillingAddressOfOrdersByGratuityUniqueWhere"]: GraphQLTypes["AddressBillingAddressOfOrdersByGratuityUniqueWhere"];
	["AddressDeliveryAddressOfOrderDeliveriesByTrackingCodeUniqueWhere"]: GraphQLTypes["AddressDeliveryAddressOfOrderDeliveriesByTrackingCodeUniqueWhere"];
	["AddressDeliveryAddressOfOrderDeliveriesByOrderUniqueWhere"]: GraphQLTypes["AddressDeliveryAddressOfOrderDeliveriesByOrderUniqueWhere"];
	["AddressDeliveryAddressOfOrderDeliveriesByDeliveryWaypointUniqueWhere"]: GraphQLTypes["AddressDeliveryAddressOfOrderDeliveriesByDeliveryWaypointUniqueWhere"];
	["AddressDeliveryAddressOfOrderDeliveriesByEventsUniqueWhere"]: GraphQLTypes["AddressDeliveryAddressOfOrderDeliveriesByEventsUniqueWhere"];
	["AddressDeliveryAddressOfOrderDeliveriesByLiftagoRideUniqueWhere"]: GraphQLTypes["AddressDeliveryAddressOfOrderDeliveriesByLiftagoRideUniqueWhere"];
	["AddressDeliveryAddressOfOrderDeliveriesByWoltDriveDeliveryUniqueWhere"]: GraphQLTypes["AddressDeliveryAddressOfOrderDeliveriesByWoltDriveDeliveryUniqueWhere"];
	["OrderDeliveryConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["OrderDeliveryEdge"]>
};
	["OrderDeliveryEdge"]: {
		node: GraphQLTypes["OrderDelivery"]
};
	["_ValidationResult"]: {
		valid: boolean,
	errors: Array<GraphQLTypes["_ValidationError"]>
};
	["_ValidationError"]: {
		path: Array<GraphQLTypes["_PathFragment"]>,
	message: GraphQLTypes["_ValidationMessage"]
};
	["_PathFragment"]:ModelTypes["_FieldPathFragment"] | ModelTypes["_IndexPathFragment"];
	["_FieldPathFragment"]: {
		field: string
};
	["_IndexPathFragment"]: {
		index: number,
	alias?: string | undefined
};
	["_ValidationMessage"]: {
		text: string
};
	["AddressCreateInput"]: GraphQLTypes["AddressCreateInput"];
	["AddressCreateCustomerEntityRelationInput"]: GraphQLTypes["AddressCreateCustomerEntityRelationInput"];
	["CustomerWithoutAddressesCreateInput"]: GraphQLTypes["CustomerWithoutAddressesCreateInput"];
	["CustomerCreateDefaultBillingAddressEntityRelationInput"]: GraphQLTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"];
	["CustomerCreateDefaultPaymentMethodEntityRelationInput"]: GraphQLTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"];
	["CustomerPaymentMethodCreateInput"]: GraphQLTypes["CustomerPaymentMethodCreateInput"];
	["CustomerPaymentMethodCreateCustomerEntityRelationInput"]: GraphQLTypes["CustomerPaymentMethodCreateCustomerEntityRelationInput"];
	["CustomerWithoutPaymentMethodsCreateInput"]: GraphQLTypes["CustomerWithoutPaymentMethodsCreateInput"];
	["CustomerCreateAddressesEntityRelationInput"]: GraphQLTypes["CustomerCreateAddressesEntityRelationInput"];
	["AddressWithoutCustomerCreateInput"]: GraphQLTypes["AddressWithoutCustomerCreateInput"];
	["AddressCreateCountryEntityRelationInput"]: GraphQLTypes["AddressCreateCountryEntityRelationInput"];
	["CountryUniqueWhere"]: GraphQLTypes["CountryUniqueWhere"];
	["CountryCreateInput"]: GraphQLTypes["CountryCreateInput"];
	["AddressCreateDeliveryZoneEntityRelationInput"]: GraphQLTypes["AddressCreateDeliveryZoneEntityRelationInput"];
	["DeliveryZoneUniqueWhere"]: GraphQLTypes["DeliveryZoneUniqueWhere"];
	["DeliveryZoneWithoutAddressesCreateInput"]: GraphQLTypes["DeliveryZoneWithoutAddressesCreateInput"];
	["DeliveryZoneCreateSuitableDeliveryMethodsEntityRelationInput"]: GraphQLTypes["DeliveryZoneCreateSuitableDeliveryMethodsEntityRelationInput"];
	["DeliveryMethodWithoutSuitableForDeliveryZonesCreateInput"]: GraphQLTypes["DeliveryMethodWithoutSuitableForDeliveryZonesCreateInput"];
	["DeliveryMethodCreatePaymentMethodsEntityRelationInput"]: GraphQLTypes["DeliveryMethodCreatePaymentMethodsEntityRelationInput"];
	["PaymentMethodUniqueWhere"]: GraphQLTypes["PaymentMethodUniqueWhere"];
	["PaymentMethodWithoutDeliveryMethodsCreateInput"]: GraphQLTypes["PaymentMethodWithoutDeliveryMethodsCreateInput"];
	["PaymentMethodCreateChannelsEntityRelationInput"]: GraphQLTypes["PaymentMethodCreateChannelsEntityRelationInput"];
	["ChannelPaymentWithoutMethodCreateInput"]: GraphQLTypes["ChannelPaymentWithoutMethodCreateInput"];
	["ChannelPaymentCreateChannelEntityRelationInput"]: GraphQLTypes["ChannelPaymentCreateChannelEntityRelationInput"];
	["ChannelWithoutPaymentsCreateInput"]: GraphQLTypes["ChannelWithoutPaymentsCreateInput"];
	["ChannelCreateDeliveriesEntityRelationInput"]: GraphQLTypes["ChannelCreateDeliveriesEntityRelationInput"];
	["ChannelDeliveryWithoutChannelCreateInput"]: GraphQLTypes["ChannelDeliveryWithoutChannelCreateInput"];
	["ChannelDeliveryCreateMethodEntityRelationInput"]: GraphQLTypes["ChannelDeliveryCreateMethodEntityRelationInput"];
	["DeliveryMethodWithoutChannelsCreateInput"]: GraphQLTypes["DeliveryMethodWithoutChannelsCreateInput"];
	["DeliveryMethodCreateSuitableForDeliveryZonesEntityRelationInput"]: GraphQLTypes["DeliveryMethodCreateSuitableForDeliveryZonesEntityRelationInput"];
	["DeliveryZoneWithoutSuitableDeliveryMethodsCreateInput"]: GraphQLTypes["DeliveryZoneWithoutSuitableDeliveryMethodsCreateInput"];
	["DeliveryZoneCreateAddressesEntityRelationInput"]: GraphQLTypes["DeliveryZoneCreateAddressesEntityRelationInput"];
	["AddressWithoutDeliveryZoneCreateInput"]: GraphQLTypes["AddressWithoutDeliveryZoneCreateInput"];
	["AddressCreateMetaEntityRelationInput"]: GraphQLTypes["AddressCreateMetaEntityRelationInput"];
	["AddressCreateGpsEntityRelationInput"]: GraphQLTypes["AddressCreateGpsEntityRelationInput"];
	["GpsWithoutAddressCreateInput"]: GraphQLTypes["GpsWithoutAddressCreateInput"];
	["AddressCreateInvoicesEntityRelationInput"]: GraphQLTypes["AddressCreateInvoicesEntityRelationInput"];
	["InvoiceWithoutAddressCreateInput"]: GraphQLTypes["InvoiceWithoutAddressCreateInput"];
	["InvoiceCreateCustomerEntityRelationInput"]: GraphQLTypes["InvoiceCreateCustomerEntityRelationInput"];
	["CustomerWithoutInvoicesCreateInput"]: GraphQLTypes["CustomerWithoutInvoicesCreateInput"];
	["CustomerCreateTagsEntityRelationInput"]: GraphQLTypes["CustomerCreateTagsEntityRelationInput"];
	["TagUniqueWhere"]: GraphQLTypes["TagUniqueWhere"];
	["TagWithoutCustomersCreateInput"]: GraphQLTypes["TagWithoutCustomersCreateInput"];
	["TagCreateProductsEntityRelationInput"]: GraphQLTypes["TagCreateProductsEntityRelationInput"];
	["ProductWithoutTagsCreateInput"]: GraphQLTypes["ProductWithoutTagsCreateInput"];
	["ProductCreatePackingEntityRelationInput"]: GraphQLTypes["ProductCreatePackingEntityRelationInput"];
	["ProductPackingCreateInput"]: GraphQLTypes["ProductPackingCreateInput"];
	["ProductPackingCreateImageEntityRelationInput"]: GraphQLTypes["ProductPackingCreateImageEntityRelationInput"];
	["ImageCreateInput"]: GraphQLTypes["ImageCreateInput"];
	["ProductPackingCreateIconEntityRelationInput"]: GraphQLTypes["ProductPackingCreateIconEntityRelationInput"];
	["ProductPackingCreateLocalesEntityRelationInput"]: GraphQLTypes["ProductPackingCreateLocalesEntityRelationInput"];
	["ProductPackingLocaleWithoutRootCreateInput"]: GraphQLTypes["ProductPackingLocaleWithoutRootCreateInput"];
	["ProductPackingLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["ProductPackingLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutProductPackingsCreateInput"]: GraphQLTypes["LocaleWithoutProductPackingsCreateInput"];
	["LocaleCreateBusinessCategoriesEntityRelationInput"]: GraphQLTypes["LocaleCreateBusinessCategoriesEntityRelationInput"];
	["BusinessCategoryLocaleWithoutLocaleCreateInput"]: GraphQLTypes["BusinessCategoryLocaleWithoutLocaleCreateInput"];
	["BusinessCategoryLocaleCreateRootEntityRelationInput"]: GraphQLTypes["BusinessCategoryLocaleCreateRootEntityRelationInput"];
	["BusinessCategoryWithoutLocalesCreateInput"]: GraphQLTypes["BusinessCategoryWithoutLocalesCreateInput"];
	["BusinessCategoryCreateBusinessCustomersEntityRelationInput"]: GraphQLTypes["BusinessCategoryCreateBusinessCustomersEntityRelationInput"];
	["BusinessCustomerWithoutCategoryCreateInput"]: GraphQLTypes["BusinessCustomerWithoutCategoryCreateInput"];
	["BusinessCustomerCreateCustomerEntityRelationInput"]: GraphQLTypes["BusinessCustomerCreateCustomerEntityRelationInput"];
	["CustomerWithoutBusinessCreateInput"]: GraphQLTypes["CustomerWithoutBusinessCreateInput"];
	["CustomerCreateCreditsEntityRelationInput"]: GraphQLTypes["CustomerCreateCreditsEntityRelationInput"];
	["CustomerCreditWithoutCustomerCreateInput"]: GraphQLTypes["CustomerCreditWithoutCustomerCreateInput"];
	["CustomerCreditCreateVatRateEntityRelationInput"]: GraphQLTypes["CustomerCreditCreateVatRateEntityRelationInput"];
	["VatRateUniqueWhere"]: GraphQLTypes["VatRateUniqueWhere"];
	["VatRateCreateInput"]: GraphQLTypes["VatRateCreateInput"];
	["VatRateCreateChannelDeliveriesEntityRelationInput"]: GraphQLTypes["VatRateCreateChannelDeliveriesEntityRelationInput"];
	["ChannelDeliveryWithoutVatRateCreateInput"]: GraphQLTypes["ChannelDeliveryWithoutVatRateCreateInput"];
	["ChannelDeliveryCreateChannelEntityRelationInput"]: GraphQLTypes["ChannelDeliveryCreateChannelEntityRelationInput"];
	["ChannelWithoutDeliveriesCreateInput"]: GraphQLTypes["ChannelWithoutDeliveriesCreateInput"];
	["ChannelCreatePaymentsEntityRelationInput"]: GraphQLTypes["ChannelCreatePaymentsEntityRelationInput"];
	["ChannelPaymentWithoutChannelCreateInput"]: GraphQLTypes["ChannelPaymentWithoutChannelCreateInput"];
	["ChannelPaymentCreateMethodEntityRelationInput"]: GraphQLTypes["ChannelPaymentCreateMethodEntityRelationInput"];
	["PaymentMethodWithoutChannelsCreateInput"]: GraphQLTypes["PaymentMethodWithoutChannelsCreateInput"];
	["PaymentMethodCreateDeliveryMethodsEntityRelationInput"]: GraphQLTypes["PaymentMethodCreateDeliveryMethodsEntityRelationInput"];
	["DeliveryMethodWithoutPaymentMethodsCreateInput"]: GraphQLTypes["DeliveryMethodWithoutPaymentMethodsCreateInput"];
	["DeliveryMethodCreateChannelsEntityRelationInput"]: GraphQLTypes["DeliveryMethodCreateChannelsEntityRelationInput"];
	["ChannelDeliveryWithoutMethodCreateInput"]: GraphQLTypes["ChannelDeliveryWithoutMethodCreateInput"];
	["ChannelDeliveryCreateVatRateEntityRelationInput"]: GraphQLTypes["ChannelDeliveryCreateVatRateEntityRelationInput"];
	["VatRateWithoutChannelDeliveriesCreateInput"]: GraphQLTypes["VatRateWithoutChannelDeliveriesCreateInput"];
	["VatRateCreateChannelPaymentsEntityRelationInput"]: GraphQLTypes["VatRateCreateChannelPaymentsEntityRelationInput"];
	["ChannelPaymentWithoutVatRateCreateInput"]: GraphQLTypes["ChannelPaymentWithoutVatRateCreateInput"];
	["ChannelPaymentCreateAllowOnlyForTagsEntityRelationInput"]: GraphQLTypes["ChannelPaymentCreateAllowOnlyForTagsEntityRelationInput"];
	["TagWithoutAllowChannelPaymentsCreateInput"]: GraphQLTypes["TagWithoutAllowChannelPaymentsCreateInput"];
	["TagCreateCustomersEntityRelationInput"]: GraphQLTypes["TagCreateCustomersEntityRelationInput"];
	["CustomerWithoutTagsCreateInput"]: GraphQLTypes["CustomerWithoutTagsCreateInput"];
	["CustomerCreatePaymentMethodsEntityRelationInput"]: GraphQLTypes["CustomerCreatePaymentMethodsEntityRelationInput"];
	["CustomerPaymentMethodWithoutCustomerCreateInput"]: GraphQLTypes["CustomerPaymentMethodWithoutCustomerCreateInput"];
	["CustomerPaymentMethodCreatePaymentMethodEntityRelationInput"]: GraphQLTypes["CustomerPaymentMethodCreatePaymentMethodEntityRelationInput"];
	["PaymentMethodCreateInput"]: GraphQLTypes["PaymentMethodCreateInput"];
	["CustomerCreateOrdersEntityRelationInput"]: GraphQLTypes["CustomerCreateOrdersEntityRelationInput"];
	["OrderWithoutCustomerCreateInput"]: GraphQLTypes["OrderWithoutCustomerCreateInput"];
	["OrderCreateChannelEntityRelationInput"]: GraphQLTypes["OrderCreateChannelEntityRelationInput"];
	["ChannelCreateInput"]: GraphQLTypes["ChannelCreateInput"];
	["ChannelCreatePointOfSalesEntityRelationInput"]: GraphQLTypes["ChannelCreatePointOfSalesEntityRelationInput"];
	["PointOfSaleUniqueWhere"]: GraphQLTypes["PointOfSaleUniqueWhere"];
	["PointOfSalePermissionsUniqueWhere"]: GraphQLTypes["PointOfSalePermissionsUniqueWhere"];
	["PointOfSaleWithoutChannelsCreateInput"]: GraphQLTypes["PointOfSaleWithoutChannelsCreateInput"];
	["PointOfSaleCreatePermissionsEntityRelationInput"]: GraphQLTypes["PointOfSaleCreatePermissionsEntityRelationInput"];
	["ChannelCreateCartsEntityRelationInput"]: GraphQLTypes["ChannelCreateCartsEntityRelationInput"];
	["CartWithoutChannelCreateInput"]: GraphQLTypes["CartWithoutChannelCreateInput"];
	["CartCreateItemsEntityRelationInput"]: GraphQLTypes["CartCreateItemsEntityRelationInput"];
	["CartItemWithoutCartCreateInput"]: GraphQLTypes["CartItemWithoutCartCreateInput"];
	["CartItemCreateProductEntityRelationInput"]: GraphQLTypes["CartItemCreateProductEntityRelationInput"];
	["ProductWithoutCartItemsCreateInput"]: GraphQLTypes["ProductWithoutCartItemsCreateInput"];
	["ProductCreateRecipeEntityRelationInput"]: GraphQLTypes["ProductCreateRecipeEntityRelationInput"];
	["ProductRecipeWithoutProductsCreateInput"]: GraphQLTypes["ProductRecipeWithoutProductsCreateInput"];
	["ProductRecipeCreateImageEntityRelationInput"]: GraphQLTypes["ProductRecipeCreateImageEntityRelationInput"];
	["ProductRecipeCreateIconEntityRelationInput"]: GraphQLTypes["ProductRecipeCreateIconEntityRelationInput"];
	["ProductRecipeCreateIngredientsEntityRelationInput"]: GraphQLTypes["ProductRecipeCreateIngredientsEntityRelationInput"];
	["ProductIngredientItemWithoutRecipeCreateInput"]: GraphQLTypes["ProductIngredientItemWithoutRecipeCreateInput"];
	["ProductIngredientItemCreateIngredientEntityRelationInput"]: GraphQLTypes["ProductIngredientItemCreateIngredientEntityRelationInput"];
	["ProductIngredientCreateInput"]: GraphQLTypes["ProductIngredientCreateInput"];
	["ProductIngredientCreateLocalesEntityRelationInput"]: GraphQLTypes["ProductIngredientCreateLocalesEntityRelationInput"];
	["ProductIngredientLocaleWithoutRootCreateInput"]: GraphQLTypes["ProductIngredientLocaleWithoutRootCreateInput"];
	["ProductIngredientLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["ProductIngredientLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutProductIngredientsCreateInput"]: GraphQLTypes["LocaleWithoutProductIngredientsCreateInput"];
	["LocaleCreateProductCategoryListsEntityRelationInput"]: GraphQLTypes["LocaleCreateProductCategoryListsEntityRelationInput"];
	["ProductCategoryListLocaleWithoutLocaleCreateInput"]: GraphQLTypes["ProductCategoryListLocaleWithoutLocaleCreateInput"];
	["ProductCategoryListLocaleCreateRootEntityRelationInput"]: GraphQLTypes["ProductCategoryListLocaleCreateRootEntityRelationInput"];
	["ProductCategoryListWithoutLocalesCreateInput"]: GraphQLTypes["ProductCategoryListWithoutLocalesCreateInput"];
	["ProductCategoryListCreateItemsEntityRelationInput"]: GraphQLTypes["ProductCategoryListCreateItemsEntityRelationInput"];
	["ProductCategoryListItemWithoutListCreateInput"]: GraphQLTypes["ProductCategoryListItemWithoutListCreateInput"];
	["ProductCategoryListItemCreateProductCategoryEntityRelationInput"]: GraphQLTypes["ProductCategoryListItemCreateProductCategoryEntityRelationInput"];
	["ProductCategoryCreateInput"]: GraphQLTypes["ProductCategoryCreateInput"];
	["ProductCategoryCreateProductsEntityRelationInput"]: GraphQLTypes["ProductCategoryCreateProductsEntityRelationInput"];
	["ProductWithoutCategoriesCreateInput"]: GraphQLTypes["ProductWithoutCategoriesCreateInput"];
	["ProductCreateTagsEntityRelationInput"]: GraphQLTypes["ProductCreateTagsEntityRelationInput"];
	["TagWithoutProductsCreateInput"]: GraphQLTypes["TagWithoutProductsCreateInput"];
	["TagCreateCategoriesEntityRelationInput"]: GraphQLTypes["TagCreateCategoriesEntityRelationInput"];
	["ProductCategoryWithoutTagsCreateInput"]: GraphQLTypes["ProductCategoryWithoutTagsCreateInput"];
	["ProductCategoryCreateParentEntityRelationInput"]: GraphQLTypes["ProductCategoryCreateParentEntityRelationInput"];
	["ProductCategoryWithoutChildrenCreateInput"]: GraphQLTypes["ProductCategoryWithoutChildrenCreateInput"];
	["ProductCategoryCreateTagsEntityRelationInput"]: GraphQLTypes["ProductCategoryCreateTagsEntityRelationInput"];
	["TagWithoutCategoriesCreateInput"]: GraphQLTypes["TagWithoutCategoriesCreateInput"];
	["TagCreateAddTagsOnRegistrationEntityRelationInput"]: GraphQLTypes["TagCreateAddTagsOnRegistrationEntityRelationInput"];
	["ChannelWithoutAddTagsOnRegistrationCreateInput"]: GraphQLTypes["ChannelWithoutAddTagsOnRegistrationCreateInput"];
	["ChannelCreateCustomersEntityRelationInput"]: GraphQLTypes["ChannelCreateCustomersEntityRelationInput"];
	["CustomerWithoutChannelsCreateInput"]: GraphQLTypes["CustomerWithoutChannelsCreateInput"];
	["CustomerCreatePermissionsEntityRelationInput"]: GraphQLTypes["CustomerCreatePermissionsEntityRelationInput"];
	["CustomerCreateGroupEntityRelationInput"]: GraphQLTypes["CustomerCreateGroupEntityRelationInput"];
	["CustomerGroupWithoutCustomersCreateInput"]: GraphQLTypes["CustomerGroupWithoutCustomersCreateInput"];
	["CustomerGroupCreateProductPricesEntityRelationInput"]: GraphQLTypes["CustomerGroupCreateProductPricesEntityRelationInput"];
	["ProductGroupPriceWithoutGroupCreateInput"]: GraphQLTypes["ProductGroupPriceWithoutGroupCreateInput"];
	["ProductGroupPriceCreateProductEntityRelationInput"]: GraphQLTypes["ProductGroupPriceCreateProductEntityRelationInput"];
	["ProductWithoutGroupPricesCreateInput"]: GraphQLTypes["ProductWithoutGroupPricesCreateInput"];
	["ProductCreateCategoriesEntityRelationInput"]: GraphQLTypes["ProductCreateCategoriesEntityRelationInput"];
	["ProductCategoryWithoutProductsCreateInput"]: GraphQLTypes["ProductCategoryWithoutProductsCreateInput"];
	["ProductCategoryCreateChildrenEntityRelationInput"]: GraphQLTypes["ProductCategoryCreateChildrenEntityRelationInput"];
	["ProductCategoryWithoutParentCreateInput"]: GraphQLTypes["ProductCategoryWithoutParentCreateInput"];
	["ProductCategoryCreateImageEntityRelationInput"]: GraphQLTypes["ProductCategoryCreateImageEntityRelationInput"];
	["ProductCategoryCreateDescendantsEntityRelationInput"]: GraphQLTypes["ProductCategoryCreateDescendantsEntityRelationInput"];
	["ProductCategoryCreateAncestorsEntityRelationInput"]: GraphQLTypes["ProductCategoryCreateAncestorsEntityRelationInput"];
	["ProductCategoryCreateInheritedTagsEntityRelationInput"]: GraphQLTypes["ProductCategoryCreateInheritedTagsEntityRelationInput"];
	["ProductCategoryCreateNestedProductsEntityRelationInput"]: GraphQLTypes["ProductCategoryCreateNestedProductsEntityRelationInput"];
	["ProductCreateVatRateEntityRelationInput"]: GraphQLTypes["ProductCreateVatRateEntityRelationInput"];
	["ProductCreateStocksEntityRelationInput"]: GraphQLTypes["ProductCreateStocksEntityRelationInput"];
	["ProductStockWithoutProductCreateInput"]: GraphQLTypes["ProductStockWithoutProductCreateInput"];
	["ProductStockCreateStoreEntityRelationInput"]: GraphQLTypes["ProductStockCreateStoreEntityRelationInput"];
	["StoreCreateInput"]: GraphQLTypes["StoreCreateInput"];
	["ProductCreateImageEntityRelationInput"]: GraphQLTypes["ProductCreateImageEntityRelationInput"];
	["ProductCreateCartItemsEntityRelationInput"]: GraphQLTypes["ProductCreateCartItemsEntityRelationInput"];
	["CartItemWithoutProductCreateInput"]: GraphQLTypes["CartItemWithoutProductCreateInput"];
	["CartItemCreateCartEntityRelationInput"]: GraphQLTypes["CartItemCreateCartEntityRelationInput"];
	["CartWithoutItemsCreateInput"]: GraphQLTypes["CartWithoutItemsCreateInput"];
	["CartCreateChannelEntityRelationInput"]: GraphQLTypes["CartCreateChannelEntityRelationInput"];
	["ChannelWithoutCartsCreateInput"]: GraphQLTypes["ChannelWithoutCartsCreateInput"];
	["ChannelCreateAddTagsOnRegistrationEntityRelationInput"]: GraphQLTypes["ChannelCreateAddTagsOnRegistrationEntityRelationInput"];
	["TagWithoutAddTagsOnRegistrationCreateInput"]: GraphQLTypes["TagWithoutAddTagsOnRegistrationCreateInput"];
	["TagCreateNestedCategoriesEntityRelationInput"]: GraphQLTypes["TagCreateNestedCategoriesEntityRelationInput"];
	["TagCreateDeliveryZonesEntityRelationInput"]: GraphQLTypes["TagCreateDeliveryZonesEntityRelationInput"];
	["DeliveryZoneWithoutDeliveryZonesOfTagsCreateInput"]: GraphQLTypes["DeliveryZoneWithoutDeliveryZonesOfTagsCreateInput"];
	["DeliveryZoneCreateDeliveryZonesOfProductsEntityRelationInput"]: GraphQLTypes["DeliveryZoneCreateDeliveryZonesOfProductsEntityRelationInput"];
	["ProductWithoutDeliveryZonesCreateInput"]: GraphQLTypes["ProductWithoutDeliveryZonesCreateInput"];
	["ProductCreateGroupPricesEntityRelationInput"]: GraphQLTypes["ProductCreateGroupPricesEntityRelationInput"];
	["ProductGroupPriceWithoutProductCreateInput"]: GraphQLTypes["ProductGroupPriceWithoutProductCreateInput"];
	["ProductGroupPriceCreateGroupEntityRelationInput"]: GraphQLTypes["ProductGroupPriceCreateGroupEntityRelationInput"];
	["CustomerGroupWithoutProductPricesCreateInput"]: GraphQLTypes["CustomerGroupWithoutProductPricesCreateInput"];
	["CustomerGroupCreateCustomersEntityRelationInput"]: GraphQLTypes["CustomerGroupCreateCustomersEntityRelationInput"];
	["CustomerWithoutGroupCreateInput"]: GraphQLTypes["CustomerWithoutGroupCreateInput"];
	["CustomerCreatePhotoEntityRelationInput"]: GraphQLTypes["CustomerCreatePhotoEntityRelationInput"];
	["CustomerCreateNameEntityRelationInput"]: GraphQLTypes["CustomerCreateNameEntityRelationInput"];
	["CustomerNameWithoutCustomerCreateInput"]: GraphQLTypes["CustomerNameWithoutCustomerCreateInput"];
	["CustomerNameCreateAliasesEntityRelationInput"]: GraphQLTypes["CustomerNameCreateAliasesEntityRelationInput"];
	["CustomerAliasUniqueWhere"]: GraphQLTypes["CustomerAliasUniqueWhere"];
	["CustomerAliasCreateInput"]: GraphQLTypes["CustomerAliasCreateInput"];
	["CustomerCreateIngredientRatingsEntityRelationInput"]: GraphQLTypes["CustomerCreateIngredientRatingsEntityRelationInput"];
	["CustomerIngredientRatingWithoutCustomerCreateInput"]: GraphQLTypes["CustomerIngredientRatingWithoutCustomerCreateInput"];
	["CustomerIngredientRatingCreateRatingEntityRelationInput"]: GraphQLTypes["CustomerIngredientRatingCreateRatingEntityRelationInput"];
	["ProductIngredientRatingUniqueWhere"]: GraphQLTypes["ProductIngredientRatingUniqueWhere"];
	["ProductIngredientRatingCreateInput"]: GraphQLTypes["ProductIngredientRatingCreateInput"];
	["ProductIngredientRatingCreateIconEntityRelationInput"]: GraphQLTypes["ProductIngredientRatingCreateIconEntityRelationInput"];
	["CustomerIngredientRatingCreateIngredientEntityRelationInput"]: GraphQLTypes["CustomerIngredientRatingCreateIngredientEntityRelationInput"];
	["ProductIngredientWithoutCustomerRatingsCreateInput"]: GraphQLTypes["ProductIngredientWithoutCustomerRatingsCreateInput"];
	["ProductIngredientCreateCategoriesEntityRelationInput"]: GraphQLTypes["ProductIngredientCreateCategoriesEntityRelationInput"];
	["ProductIngredientCategoryWithoutIngredientsCreateInput"]: GraphQLTypes["ProductIngredientCategoryWithoutIngredientsCreateInput"];
	["ProductIngredientCategoryCreateLocalesEntityRelationInput"]: GraphQLTypes["ProductIngredientCategoryCreateLocalesEntityRelationInput"];
	["ProductIngredientCategoryLocaleWithoutRootCreateInput"]: GraphQLTypes["ProductIngredientCategoryLocaleWithoutRootCreateInput"];
	["ProductIngredientCategoryLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["ProductIngredientCategoryLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutProductIngredientCategoriesCreateInput"]: GraphQLTypes["LocaleWithoutProductIngredientCategoriesCreateInput"];
	["LocaleCreateProductIngredientsEntityRelationInput"]: GraphQLTypes["LocaleCreateProductIngredientsEntityRelationInput"];
	["ProductIngredientLocaleWithoutLocaleCreateInput"]: GraphQLTypes["ProductIngredientLocaleWithoutLocaleCreateInput"];
	["ProductIngredientLocaleCreateRootEntityRelationInput"]: GraphQLTypes["ProductIngredientLocaleCreateRootEntityRelationInput"];
	["ProductIngredientWithoutLocalesCreateInput"]: GraphQLTypes["ProductIngredientWithoutLocalesCreateInput"];
	["ProductIngredientCreateAllergensEntityRelationInput"]: GraphQLTypes["ProductIngredientCreateAllergensEntityRelationInput"];
	["AllergenWithoutIngredientsCreateInput"]: GraphQLTypes["AllergenWithoutIngredientsCreateInput"];
	["AllergenCreateLocalesEntityRelationInput"]: GraphQLTypes["AllergenCreateLocalesEntityRelationInput"];
	["AllergenLocaleWithoutRootCreateInput"]: GraphQLTypes["AllergenLocaleWithoutRootCreateInput"];
	["AllergenLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["AllergenLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutAllergensCreateInput"]: GraphQLTypes["LocaleWithoutAllergensCreateInput"];
	["LocaleCreateOrderRecurrencesEntityRelationInput"]: GraphQLTypes["LocaleCreateOrderRecurrencesEntityRelationInput"];
	["OrderRecurrenceLocaleWithoutLocaleCreateInput"]: GraphQLTypes["OrderRecurrenceLocaleWithoutLocaleCreateInput"];
	["OrderRecurrenceLocaleCreateRootEntityRelationInput"]: GraphQLTypes["OrderRecurrenceLocaleCreateRootEntityRelationInput"];
	["OrderRecurrenceWithoutLocalesCreateInput"]: GraphQLTypes["OrderRecurrenceWithoutLocalesCreateInput"];
	["OrderRecurrenceCreateBusinessCategoryEntityRelationInput"]: GraphQLTypes["OrderRecurrenceCreateBusinessCategoryEntityRelationInput"];
	["BusinessCategoryWithoutRecurrencesCreateInput"]: GraphQLTypes["BusinessCategoryWithoutRecurrencesCreateInput"];
	["BusinessCategoryCreateLocalesEntityRelationInput"]: GraphQLTypes["BusinessCategoryCreateLocalesEntityRelationInput"];
	["BusinessCategoryLocaleWithoutRootCreateInput"]: GraphQLTypes["BusinessCategoryLocaleWithoutRootCreateInput"];
	["BusinessCategoryLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["BusinessCategoryLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutBusinessCategoriesCreateInput"]: GraphQLTypes["LocaleWithoutBusinessCategoriesCreateInput"];
	["LocaleCreateBlogsEntityRelationInput"]: GraphQLTypes["LocaleCreateBlogsEntityRelationInput"];
	["BlogLocaleWithoutLocaleCreateInput"]: GraphQLTypes["BlogLocaleWithoutLocaleCreateInput"];
	["BlogLocaleCreateRootEntityRelationInput"]: GraphQLTypes["BlogLocaleCreateRootEntityRelationInput"];
	["BlogWithoutLocalesCreateInput"]: GraphQLTypes["BlogWithoutLocalesCreateInput"];
	["LocaleCreateBlogPostsEntityRelationInput"]: GraphQLTypes["LocaleCreateBlogPostsEntityRelationInput"];
	["BlogPostLocaleWithoutLocaleCreateInput"]: GraphQLTypes["BlogPostLocaleWithoutLocaleCreateInput"];
	["BlogPostLocaleCreateRootEntityRelationInput"]: GraphQLTypes["BlogPostLocaleCreateRootEntityRelationInput"];
	["BlogPostWithoutLocalesCreateInput"]: GraphQLTypes["BlogPostWithoutLocalesCreateInput"];
	["BlogPostLocaleCreateCoverEntityRelationInput"]: GraphQLTypes["BlogPostLocaleCreateCoverEntityRelationInput"];
	["CoverCreateInput"]: GraphQLTypes["CoverCreateInput"];
	["CoverCreateMediumEntityRelationInput"]: GraphQLTypes["CoverCreateMediumEntityRelationInput"];
	["MediumUniqueWhere"]: GraphQLTypes["MediumUniqueWhere"];
	["MediumCreateInput"]: GraphQLTypes["MediumCreateInput"];
	["MediumCreateImageEntityRelationInput"]: GraphQLTypes["MediumCreateImageEntityRelationInput"];
	["MediumCreateVideoEntityRelationInput"]: GraphQLTypes["MediumCreateVideoEntityRelationInput"];
	["VideoUniqueWhere"]: GraphQLTypes["VideoUniqueWhere"];
	["VideoCreateInput"]: GraphQLTypes["VideoCreateInput"];
	["VideoCreatePosterEntityRelationInput"]: GraphQLTypes["VideoCreatePosterEntityRelationInput"];
	["CoverCreateButtonColorsEntityRelationInput"]: GraphQLTypes["CoverCreateButtonColorsEntityRelationInput"];
	["ColorPalleteUniqueWhere"]: GraphQLTypes["ColorPalleteUniqueWhere"];
	["ColorPalleteCreateInput"]: GraphQLTypes["ColorPalleteCreateInput"];
	["BlogPostLocaleCreateContentEntityRelationInput"]: GraphQLTypes["BlogPostLocaleCreateContentEntityRelationInput"];
	["ContentCreateInput"]: GraphQLTypes["ContentCreateInput"];
	["ContentCreateBlocksEntityRelationInput"]: GraphQLTypes["ContentCreateBlocksEntityRelationInput"];
	["ContentBlockWithoutContentCreateInput"]: GraphQLTypes["ContentBlockWithoutContentCreateInput"];
	["ContentBlockCreateReferencesEntityRelationInput"]: GraphQLTypes["ContentBlockCreateReferencesEntityRelationInput"];
	["ContentReferenceWithoutBlockCreateInput"]: GraphQLTypes["ContentReferenceWithoutBlockCreateInput"];
	["ContentReferenceCreateColorPalleteEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateColorPalleteEntityRelationInput"];
	["ContentReferenceCreateMediumEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateMediumEntityRelationInput"];
	["ContentReferenceCreateLinkEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateLinkEntityRelationInput"];
	["LinkCreateInput"]: GraphQLTypes["LinkCreateInput"];
	["LinkCreateInternalLinkEntityRelationInput"]: GraphQLTypes["LinkCreateInternalLinkEntityRelationInput"];
	["LinkableCreateInput"]: GraphQLTypes["LinkableCreateInput"];
	["LinkableCreateBlogPostEntityRelationInput"]: GraphQLTypes["LinkableCreateBlogPostEntityRelationInput"];
	["BlogPostLocaleWithoutLinkCreateInput"]: GraphQLTypes["BlogPostLocaleWithoutLinkCreateInput"];
	["BlogPostLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["BlogPostLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutBlogPostsCreateInput"]: GraphQLTypes["LocaleWithoutBlogPostsCreateInput"];
	["LocaleCreateIdentifierEntityRelationInput"]: GraphQLTypes["LocaleCreateIdentifierEntityRelationInput"];
	["TranslationCataloguesIdentifierCreateInput"]: GraphQLTypes["TranslationCataloguesIdentifierCreateInput"];
	["TranslationCataloguesIdentifierCreateCatalogueEntityRelationInput"]: GraphQLTypes["TranslationCataloguesIdentifierCreateCatalogueEntityRelationInput"];
	["TranslationCatalogueWithoutIdentifierCreateInput"]: GraphQLTypes["TranslationCatalogueWithoutIdentifierCreateInput"];
	["TranslationCatalogueCreateDomainEntityRelationInput"]: GraphQLTypes["TranslationCatalogueCreateDomainEntityRelationInput"];
	["TranslationDomainWithoutCataloguesCreateInput"]: GraphQLTypes["TranslationDomainWithoutCataloguesCreateInput"];
	["TranslationDomainCreateKeysEntityRelationInput"]: GraphQLTypes["TranslationDomainCreateKeysEntityRelationInput"];
	["TranslationKeyWithoutDomainCreateInput"]: GraphQLTypes["TranslationKeyWithoutDomainCreateInput"];
	["TranslationKeyCreateValuesEntityRelationInput"]: GraphQLTypes["TranslationKeyCreateValuesEntityRelationInput"];
	["TranslationValueWithoutKeyCreateInput"]: GraphQLTypes["TranslationValueWithoutKeyCreateInput"];
	["TranslationValueCreateCatalogueEntityRelationInput"]: GraphQLTypes["TranslationValueCreateCatalogueEntityRelationInput"];
	["TranslationCatalogueWithoutValuesCreateInput"]: GraphQLTypes["TranslationCatalogueWithoutValuesCreateInput"];
	["TranslationCatalogueCreateFallbackEntityRelationInput"]: GraphQLTypes["TranslationCatalogueCreateFallbackEntityRelationInput"];
	["TranslationCatalogueCreateInput"]: GraphQLTypes["TranslationCatalogueCreateInput"];
	["TranslationCatalogueCreateValuesEntityRelationInput"]: GraphQLTypes["TranslationCatalogueCreateValuesEntityRelationInput"];
	["TranslationValueWithoutCatalogueCreateInput"]: GraphQLTypes["TranslationValueWithoutCatalogueCreateInput"];
	["TranslationValueCreateKeyEntityRelationInput"]: GraphQLTypes["TranslationValueCreateKeyEntityRelationInput"];
	["TranslationKeyWithoutValuesCreateInput"]: GraphQLTypes["TranslationKeyWithoutValuesCreateInput"];
	["TranslationKeyCreateDomainEntityRelationInput"]: GraphQLTypes["TranslationKeyCreateDomainEntityRelationInput"];
	["TranslationDomainWithoutKeysCreateInput"]: GraphQLTypes["TranslationDomainWithoutKeysCreateInput"];
	["TranslationDomainCreateCataloguesEntityRelationInput"]: GraphQLTypes["TranslationDomainCreateCataloguesEntityRelationInput"];
	["TranslationCatalogueWithoutDomainCreateInput"]: GraphQLTypes["TranslationCatalogueWithoutDomainCreateInput"];
	["TranslationCatalogueCreateIdentifierEntityRelationInput"]: GraphQLTypes["TranslationCatalogueCreateIdentifierEntityRelationInput"];
	["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"]: GraphQLTypes["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"];
	["LocaleCreateMenusEntityRelationInput"]: GraphQLTypes["LocaleCreateMenusEntityRelationInput"];
	["MenuLocaleWithoutLocaleCreateInput"]: GraphQLTypes["MenuLocaleWithoutLocaleCreateInput"];
	["MenuLocaleCreateRootEntityRelationInput"]: GraphQLTypes["MenuLocaleCreateRootEntityRelationInput"];
	["SiteMenuWithoutLocalesCreateInput"]: GraphQLTypes["SiteMenuWithoutLocalesCreateInput"];
	["MenuLocaleCreateItemsEntityRelationInput"]: GraphQLTypes["MenuLocaleCreateItemsEntityRelationInput"];
	["MenuItemWithoutMenuCreateInput"]: GraphQLTypes["MenuItemWithoutMenuCreateInput"];
	["MenuItemCreateLinkEntityRelationInput"]: GraphQLTypes["MenuItemCreateLinkEntityRelationInput"];
	["MenuItemCreateSubitemsEntityRelationInput"]: GraphQLTypes["MenuItemCreateSubitemsEntityRelationInput"];
	["MenuSubitemWithoutItemCreateInput"]: GraphQLTypes["MenuSubitemWithoutItemCreateInput"];
	["MenuSubitemCreateLinksEntityRelationInput"]: GraphQLTypes["MenuSubitemCreateLinksEntityRelationInput"];
	["MenuLinkListUniqueWhere"]: GraphQLTypes["MenuLinkListUniqueWhere"];
	["MenuLinkItemUniqueWhere"]: GraphQLTypes["MenuLinkItemUniqueWhere"];
	["MenuLinkListCreateInput"]: GraphQLTypes["MenuLinkListCreateInput"];
	["MenuLinkListCreateItemsEntityRelationInput"]: GraphQLTypes["MenuLinkListCreateItemsEntityRelationInput"];
	["MenuLinkItemWithoutListCreateInput"]: GraphQLTypes["MenuLinkItemWithoutListCreateInput"];
	["MenuLinkItemCreateLinkEntityRelationInput"]: GraphQLTypes["MenuLinkItemCreateLinkEntityRelationInput"];
	["MenuLinkItemCreateImageEntityRelationInput"]: GraphQLTypes["MenuLinkItemCreateImageEntityRelationInput"];
	["MenuSubitemCreateProductsEntityRelationInput"]: GraphQLTypes["MenuSubitemCreateProductsEntityRelationInput"];
	["MenuProductsUniqueWhere"]: GraphQLTypes["MenuProductsUniqueWhere"];
	["MenuProductsCreateInput"]: GraphQLTypes["MenuProductsCreateInput"];
	["MenuProductsCreateLinksEntityRelationInput"]: GraphQLTypes["MenuProductsCreateLinksEntityRelationInput"];
	["MenuProductsCreateButtonsEntityRelationInput"]: GraphQLTypes["MenuProductsCreateButtonsEntityRelationInput"];
	["LinkListCreateInput"]: GraphQLTypes["LinkListCreateInput"];
	["LinkListCreateItemsEntityRelationInput"]: GraphQLTypes["LinkListCreateItemsEntityRelationInput"];
	["LinkListItemWithoutListCreateInput"]: GraphQLTypes["LinkListItemWithoutListCreateInput"];
	["LinkListItemCreateLinkEntityRelationInput"]: GraphQLTypes["LinkListItemCreateLinkEntityRelationInput"];
	["MenuSubitemCreateDeliveryEntityRelationInput"]: GraphQLTypes["MenuSubitemCreateDeliveryEntityRelationInput"];
	["MenuDeliveryUniqueWhere"]: GraphQLTypes["MenuDeliveryUniqueWhere"];
	["MenuDeliveryCreateInput"]: GraphQLTypes["MenuDeliveryCreateInput"];
	["MenuDeliveryCreateDeliveryRegionsEntityRelationInput"]: GraphQLTypes["MenuDeliveryCreateDeliveryRegionsEntityRelationInput"];
	["DeliveryRegionsCreateInput"]: GraphQLTypes["DeliveryRegionsCreateInput"];
	["DeliveryRegionsCreateItemsEntityRelationInput"]: GraphQLTypes["DeliveryRegionsCreateItemsEntityRelationInput"];
	["DeliveryRegionsItemWithoutListCreateInput"]: GraphQLTypes["DeliveryRegionsItemWithoutListCreateInput"];
	["DeliveryRegionsItemCreateImageEntityRelationInput"]: GraphQLTypes["DeliveryRegionsItemCreateImageEntityRelationInput"];
	["DeliveryRegionsItemCreateTextListEntityRelationInput"]: GraphQLTypes["DeliveryRegionsItemCreateTextListEntityRelationInput"];
	["TextListCreateInput"]: GraphQLTypes["TextListCreateInput"];
	["TextListCreateItemsEntityRelationInput"]: GraphQLTypes["TextListCreateItemsEntityRelationInput"];
	["TextItemWithoutListCreateInput"]: GraphQLTypes["TextItemWithoutListCreateInput"];
	["DeliveryRegionsItemCreateGalleryEntityRelationInput"]: GraphQLTypes["DeliveryRegionsItemCreateGalleryEntityRelationInput"];
	["ImageListCreateInput"]: GraphQLTypes["ImageListCreateInput"];
	["ImageListCreateItemsEntityRelationInput"]: GraphQLTypes["ImageListCreateItemsEntityRelationInput"];
	["ImageListItemWithoutListCreateInput"]: GraphQLTypes["ImageListItemWithoutListCreateInput"];
	["ImageListItemCreateImageEntityRelationInput"]: GraphQLTypes["ImageListItemCreateImageEntityRelationInput"];
	["MenuDeliveryCreateSocialsAndAppsEntityRelationInput"]: GraphQLTypes["MenuDeliveryCreateSocialsAndAppsEntityRelationInput"];
	["SocialsAndAppsUniqueWhere"]: GraphQLTypes["SocialsAndAppsUniqueWhere"];
	["SocialsAndAppsCreateInput"]: GraphQLTypes["SocialsAndAppsCreateInput"];
	["MenuSubitemCreateContactEntityRelationInput"]: GraphQLTypes["MenuSubitemCreateContactEntityRelationInput"];
	["MenuContactUniqueWhere"]: GraphQLTypes["MenuContactUniqueWhere"];
	["MenuContactCreateInput"]: GraphQLTypes["MenuContactCreateInput"];
	["MenuContactCreateImageEntityRelationInput"]: GraphQLTypes["MenuContactCreateImageEntityRelationInput"];
	["MenuLocaleCreateSecondaryItemsEntityRelationInput"]: GraphQLTypes["MenuLocaleCreateSecondaryItemsEntityRelationInput"];
	["MenuLocaleCreateEshopLinkEntityRelationInput"]: GraphQLTypes["MenuLocaleCreateEshopLinkEntityRelationInput"];
	["LocaleCreatePagesEntityRelationInput"]: GraphQLTypes["LocaleCreatePagesEntityRelationInput"];
	["PageLocaleWithoutLocaleCreateInput"]: GraphQLTypes["PageLocaleWithoutLocaleCreateInput"];
	["PageLocaleCreateLinkEntityRelationInput"]: GraphQLTypes["PageLocaleCreateLinkEntityRelationInput"];
	["LinkableWithoutPageCreateInput"]: GraphQLTypes["LinkableWithoutPageCreateInput"];
	["LinkableCreateWikiPageEntityRelationInput"]: GraphQLTypes["LinkableCreateWikiPageEntityRelationInput"];
	["WikiPageWithoutLinkCreateInput"]: GraphQLTypes["WikiPageWithoutLinkCreateInput"];
	["WikiPageCreateParentEntityRelationInput"]: GraphQLTypes["WikiPageCreateParentEntityRelationInput"];
	["WikiPageWithoutChildrenCreateInput"]: GraphQLTypes["WikiPageWithoutChildrenCreateInput"];
	["WikiPageCreateLinkEntityRelationInput"]: GraphQLTypes["WikiPageCreateLinkEntityRelationInput"];
	["LinkableWithoutWikiPageCreateInput"]: GraphQLTypes["LinkableWithoutWikiPageCreateInput"];
	["LinkableCreatePageEntityRelationInput"]: GraphQLTypes["LinkableCreatePageEntityRelationInput"];
	["PageLocaleWithoutLinkCreateInput"]: GraphQLTypes["PageLocaleWithoutLinkCreateInput"];
	["PageLocaleCreateRootEntityRelationInput"]: GraphQLTypes["PageLocaleCreateRootEntityRelationInput"];
	["PageWithoutLocalesCreateInput"]: GraphQLTypes["PageWithoutLocalesCreateInput"];
	["PageLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["PageLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutPagesCreateInput"]: GraphQLTypes["LocaleWithoutPagesCreateInput"];
	["LocaleCreateProductIngredientCategoriesEntityRelationInput"]: GraphQLTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"];
	["ProductIngredientCategoryLocaleWithoutLocaleCreateInput"]: GraphQLTypes["ProductIngredientCategoryLocaleWithoutLocaleCreateInput"];
	["ProductIngredientCategoryLocaleCreateRootEntityRelationInput"]: GraphQLTypes["ProductIngredientCategoryLocaleCreateRootEntityRelationInput"];
	["ProductIngredientCategoryWithoutLocalesCreateInput"]: GraphQLTypes["ProductIngredientCategoryWithoutLocalesCreateInput"];
	["ProductIngredientCategoryCreateIngredientsEntityRelationInput"]: GraphQLTypes["ProductIngredientCategoryCreateIngredientsEntityRelationInput"];
	["ProductIngredientWithoutCategoriesCreateInput"]: GraphQLTypes["ProductIngredientWithoutCategoriesCreateInput"];
	["ProductIngredientCreateCustomerRatingsEntityRelationInput"]: GraphQLTypes["ProductIngredientCreateCustomerRatingsEntityRelationInput"];
	["CustomerIngredientRatingWithoutIngredientCreateInput"]: GraphQLTypes["CustomerIngredientRatingWithoutIngredientCreateInput"];
	["CustomerIngredientRatingCreateCustomerEntityRelationInput"]: GraphQLTypes["CustomerIngredientRatingCreateCustomerEntityRelationInput"];
	["CustomerWithoutIngredientRatingsCreateInput"]: GraphQLTypes["CustomerWithoutIngredientRatingsCreateInput"];
	["CustomerCreateBusinessEntityRelationInput"]: GraphQLTypes["CustomerCreateBusinessEntityRelationInput"];
	["BusinessCustomerWithoutCustomerCreateInput"]: GraphQLTypes["BusinessCustomerWithoutCustomerCreateInput"];
	["BusinessCustomerCreateOwnersEntityRelationInput"]: GraphQLTypes["BusinessCustomerCreateOwnersEntityRelationInput"];
	["CustomerWithoutOwnerOfBusinessesCreateInput"]: GraphQLTypes["CustomerWithoutOwnerOfBusinessesCreateInput"];
	["CustomerCreateMemberOfBusinessesEntityRelationInput"]: GraphQLTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"];
	["BusinessCustomerWithoutMembersCreateInput"]: GraphQLTypes["BusinessCustomerWithoutMembersCreateInput"];
	["BusinessCustomerCreateCategoryEntityRelationInput"]: GraphQLTypes["BusinessCustomerCreateCategoryEntityRelationInput"];
	["BusinessCategoryWithoutBusinessCustomersCreateInput"]: GraphQLTypes["BusinessCategoryWithoutBusinessCustomersCreateInput"];
	["BusinessCategoryCreateRecurrencesEntityRelationInput"]: GraphQLTypes["BusinessCategoryCreateRecurrencesEntityRelationInput"];
	["OrderRecurrenceWithoutBusinessCategoryCreateInput"]: GraphQLTypes["OrderRecurrenceWithoutBusinessCategoryCreateInput"];
	["OrderRecurrenceCreateLocalesEntityRelationInput"]: GraphQLTypes["OrderRecurrenceCreateLocalesEntityRelationInput"];
	["OrderRecurrenceLocaleWithoutRootCreateInput"]: GraphQLTypes["OrderRecurrenceLocaleWithoutRootCreateInput"];
	["OrderRecurrenceLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["OrderRecurrenceLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutOrderRecurrencesCreateInput"]: GraphQLTypes["LocaleWithoutOrderRecurrencesCreateInput"];
	["LocaleCreateAllergensEntityRelationInput"]: GraphQLTypes["LocaleCreateAllergensEntityRelationInput"];
	["AllergenLocaleWithoutLocaleCreateInput"]: GraphQLTypes["AllergenLocaleWithoutLocaleCreateInput"];
	["AllergenLocaleCreateRootEntityRelationInput"]: GraphQLTypes["AllergenLocaleCreateRootEntityRelationInput"];
	["AllergenWithoutLocalesCreateInput"]: GraphQLTypes["AllergenWithoutLocalesCreateInput"];
	["AllergenCreateIngredientsEntityRelationInput"]: GraphQLTypes["AllergenCreateIngredientsEntityRelationInput"];
	["ProductIngredientWithoutAllergensCreateInput"]: GraphQLTypes["ProductIngredientWithoutAllergensCreateInput"];
	["ProductIngredientCreatePreferredQuantityUnitEntityRelationInput"]: GraphQLTypes["ProductIngredientCreatePreferredQuantityUnitEntityRelationInput"];
	["ProductIngredientItemQuantityUnitUniqueWhere"]: GraphQLTypes["ProductIngredientItemQuantityUnitUniqueWhere"];
	["ProductIngredientItemQuantityUnitCreateInput"]: GraphQLTypes["ProductIngredientItemQuantityUnitCreateInput"];
	["ProductIngredientCreateFreshingContainerEntityRelationInput"]: GraphQLTypes["ProductIngredientCreateFreshingContainerEntityRelationInput"];
	["FreshingContainerUniqueWhere"]: GraphQLTypes["FreshingContainerUniqueWhere"];
	["FreshingContainerCreateInput"]: GraphQLTypes["FreshingContainerCreateInput"];
	["FreshingContainerCreateWorkspaceEntityRelationInput"]: GraphQLTypes["FreshingContainerCreateWorkspaceEntityRelationInput"];
	["WorkspaceUniqueWhere"]: GraphQLTypes["WorkspaceUniqueWhere"];
	["WeekHoursUniqueWhere"]: GraphQLTypes["WeekHoursUniqueWhere"];
	["WorkspaceWithoutFreshingContainersCreateInput"]: GraphQLTypes["WorkspaceWithoutFreshingContainersCreateInput"];
	["WorkspaceCreateOpeningHoursEntityRelationInput"]: GraphQLTypes["WorkspaceCreateOpeningHoursEntityRelationInput"];
	["WeekHoursCreateInput"]: GraphQLTypes["WeekHoursCreateInput"];
	["WorkspaceCreateWorkingHoursEntityRelationInput"]: GraphQLTypes["WorkspaceCreateWorkingHoursEntityRelationInput"];
	["WorkspaceCreateDefaultFreshingContainerEntityRelationInput"]: GraphQLTypes["WorkspaceCreateDefaultFreshingContainerEntityRelationInput"];
	["WorkspaceCreateCreditsProductEntityRelationInput"]: GraphQLTypes["WorkspaceCreateCreditsProductEntityRelationInput"];
	["VirtualProductCreateInput"]: GraphQLTypes["VirtualProductCreateInput"];
	["VirtualProductCreateProductEntityRelationInput"]: GraphQLTypes["VirtualProductCreateProductEntityRelationInput"];
	["ProductWithoutVirtualProductCreateInput"]: GraphQLTypes["ProductWithoutVirtualProductCreateInput"];
	["ProductCreateManagerEntityRelationInput"]: GraphQLTypes["ProductCreateManagerEntityRelationInput"];
	["StocksManagerWithoutManagedProductsCreateInput"]: GraphQLTypes["StocksManagerWithoutManagedProductsCreateInput"];
	["StocksManagerCreateStaffEntityRelationInput"]: GraphQLTypes["StocksManagerCreateStaffEntityRelationInput"];
	["StaffWithoutStocksManagerCreateInput"]: GraphQLTypes["StaffWithoutStocksManagerCreateInput"];
	["StaffCreateBartenderEntityRelationInput"]: GraphQLTypes["StaffCreateBartenderEntityRelationInput"];
	["BartenderWithoutStaffCreateInput"]: GraphQLTypes["BartenderWithoutStaffCreateInput"];
	["StaffCreateCourierEntityRelationInput"]: GraphQLTypes["StaffCreateCourierEntityRelationInput"];
	["CourierWithoutStaffCreateInput"]: GraphQLTypes["CourierWithoutStaffCreateInput"];
	["CourierCreateRoutesEntityRelationInput"]: GraphQLTypes["CourierCreateRoutesEntityRelationInput"];
	["DeliveryRouteWithoutCourierCreateInput"]: GraphQLTypes["DeliveryRouteWithoutCourierCreateInput"];
	["DeliveryRouteCreateWaypointsEntityRelationInput"]: GraphQLTypes["DeliveryRouteCreateWaypointsEntityRelationInput"];
	["DeliveryWaypointWithoutRouteCreateInput"]: GraphQLTypes["DeliveryWaypointWithoutRouteCreateInput"];
	["DeliveryWaypointCreateDeliveryEntityRelationInput"]: GraphQLTypes["DeliveryWaypointCreateDeliveryEntityRelationInput"];
	["OrderDeliveryWithoutDeliveryWaypointCreateInput"]: GraphQLTypes["OrderDeliveryWithoutDeliveryWaypointCreateInput"];
	["OrderDeliveryCreateMethodEntityRelationInput"]: GraphQLTypes["OrderDeliveryCreateMethodEntityRelationInput"];
	["DeliveryMethodCreateInput"]: GraphQLTypes["DeliveryMethodCreateInput"];
	["DeliveryMethodCreateCourierHandlersEntityRelationInput"]: GraphQLTypes["DeliveryMethodCreateCourierHandlersEntityRelationInput"];
	["CourierWithoutDeliveryMethodsCreateInput"]: GraphQLTypes["CourierWithoutDeliveryMethodsCreateInput"];
	["CourierCreateStaffEntityRelationInput"]: GraphQLTypes["CourierCreateStaffEntityRelationInput"];
	["StaffWithoutCourierCreateInput"]: GraphQLTypes["StaffWithoutCourierCreateInput"];
	["StaffCreateCleanerEntityRelationInput"]: GraphQLTypes["StaffCreateCleanerEntityRelationInput"];
	["CleanerWithoutStaffCreateInput"]: GraphQLTypes["CleanerWithoutStaffCreateInput"];
	["StaffCreateShiftsManagerEntityRelationInput"]: GraphQLTypes["StaffCreateShiftsManagerEntityRelationInput"];
	["ShiftsManagerWithoutStaffCreateInput"]: GraphQLTypes["ShiftsManagerWithoutStaffCreateInput"];
	["ShiftsManagerCreateManagedRolesEntityRelationInput"]: GraphQLTypes["ShiftsManagerCreateManagedRolesEntityRelationInput"];
	["TimetableEmployeeRoleWithoutShiftsManagersCreateInput"]: GraphQLTypes["TimetableEmployeeRoleWithoutShiftsManagersCreateInput"];
	["TimetableEmployeeRoleCreateShiftGroupsEntityRelationInput"]: GraphQLTypes["TimetableEmployeeRoleCreateShiftGroupsEntityRelationInput"];
	["TimetableShiftGroupWithoutTypeCreateInput"]: GraphQLTypes["TimetableShiftGroupWithoutTypeCreateInput"];
	["TimetableShiftGroupCreateShiftsEntityRelationInput"]: GraphQLTypes["TimetableShiftGroupCreateShiftsEntityRelationInput"];
	["TimetableShiftWithoutGroupCreateInput"]: GraphQLTypes["TimetableShiftWithoutGroupCreateInput"];
	["TimetableShiftCreateShiftsProfileEntityRelationInput"]: GraphQLTypes["TimetableShiftCreateShiftsProfileEntityRelationInput"];
	["ShiftsProfileWithoutShiftsCreateInput"]: GraphQLTypes["ShiftsProfileWithoutShiftsCreateInput"];
	["ShiftsProfileCreateQueueItemsEntityRelationInput"]: GraphQLTypes["ShiftsProfileCreateQueueItemsEntityRelationInput"];
	["EmployeeQueueItemWithoutShiftsProfileCreateInput"]: GraphQLTypes["EmployeeQueueItemWithoutShiftsProfileCreateInput"];
	["EmployeeQueueItemCreateQueueEntityRelationInput"]: GraphQLTypes["EmployeeQueueItemCreateQueueEntityRelationInput"];
	["EmployeeQueueWithoutItemsCreateInput"]: GraphQLTypes["EmployeeQueueWithoutItemsCreateInput"];
	["EmployeeQueueCreateShiftGroupEntityRelationInput"]: GraphQLTypes["EmployeeQueueCreateShiftGroupEntityRelationInput"];
	["TimetableShiftGroupWithoutQueueCreateInput"]: GraphQLTypes["TimetableShiftGroupWithoutQueueCreateInput"];
	["TimetableShiftGroupCreateDayEntityRelationInput"]: GraphQLTypes["TimetableShiftGroupCreateDayEntityRelationInput"];
	["TimetableDayWithoutShiftGroupsCreateInput"]: GraphQLTypes["TimetableDayWithoutShiftGroupsCreateInput"];
	["TimetableDayCreateNotesEntityRelationInput"]: GraphQLTypes["TimetableDayCreateNotesEntityRelationInput"];
	["TimetableDayNoteWithoutDayCreateInput"]: GraphQLTypes["TimetableDayNoteWithoutDayCreateInput"];
	["TimetableDayNoteCreateRoleEntityRelationInput"]: GraphQLTypes["TimetableDayNoteCreateRoleEntityRelationInput"];
	["TimetableEmployeeRoleCreateInput"]: GraphQLTypes["TimetableEmployeeRoleCreateInput"];
	["TimetableEmployeeRoleCreateShiftsProfilesEntityRelationInput"]: GraphQLTypes["TimetableEmployeeRoleCreateShiftsProfilesEntityRelationInput"];
	["ShiftsProfileWithoutRolesCreateInput"]: GraphQLTypes["ShiftsProfileWithoutRolesCreateInput"];
	["ShiftsProfileCreateStaffEntityRelationInput"]: GraphQLTypes["ShiftsProfileCreateStaffEntityRelationInput"];
	["StaffWithoutShiftsProfileCreateInput"]: GraphQLTypes["StaffWithoutShiftsProfileCreateInput"];
	["StaffCreateBusinessToBusinessManagerEntityRelationInput"]: GraphQLTypes["StaffCreateBusinessToBusinessManagerEntityRelationInput"];
	["BusinessToBusinessManagerWithoutStaffCreateInput"]: GraphQLTypes["BusinessToBusinessManagerWithoutStaffCreateInput"];
	["BusinessToBusinessManagerCreateManagedBusinessesEntityRelationInput"]: GraphQLTypes["BusinessToBusinessManagerCreateManagedBusinessesEntityRelationInput"];
	["BusinessCustomerWithoutAccountManagerCreateInput"]: GraphQLTypes["BusinessCustomerWithoutAccountManagerCreateInput"];
	["BusinessCustomerCreateMembersEntityRelationInput"]: GraphQLTypes["BusinessCustomerCreateMembersEntityRelationInput"];
	["CustomerWithoutMemberOfBusinessesCreateInput"]: GraphQLTypes["CustomerWithoutMemberOfBusinessesCreateInput"];
	["CustomerCreateOwnerOfBusinessesEntityRelationInput"]: GraphQLTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"];
	["BusinessCustomerWithoutOwnersCreateInput"]: GraphQLTypes["BusinessCustomerWithoutOwnersCreateInput"];
	["BusinessCustomerCreateAccountManagerEntityRelationInput"]: GraphQLTypes["BusinessCustomerCreateAccountManagerEntityRelationInput"];
	["BusinessToBusinessManagerWithoutManagedBusinessesCreateInput"]: GraphQLTypes["BusinessToBusinessManagerWithoutManagedBusinessesCreateInput"];
	["BusinessToBusinessManagerCreateStaffEntityRelationInput"]: GraphQLTypes["BusinessToBusinessManagerCreateStaffEntityRelationInput"];
	["StaffWithoutBusinessToBusinessManagerCreateInput"]: GraphQLTypes["StaffWithoutBusinessToBusinessManagerCreateInput"];
	["StaffCreateUserEntityRelationInput"]: GraphQLTypes["StaffCreateUserEntityRelationInput"];
	["UserWithoutStaffCreateInput"]: GraphQLTypes["UserWithoutStaffCreateInput"];
	["UserCreateCustomerEntityRelationInput"]: GraphQLTypes["UserCreateCustomerEntityRelationInput"];
	["CustomerWithoutUserCreateInput"]: GraphQLTypes["CustomerWithoutUserCreateInput"];
	["CustomerCreateCartsEntityRelationInput"]: GraphQLTypes["CustomerCreateCartsEntityRelationInput"];
	["CartWithoutCustomerCreateInput"]: GraphQLTypes["CartWithoutCustomerCreateInput"];
	["CartCreateOrderEntityRelationInput"]: GraphQLTypes["CartCreateOrderEntityRelationInput"];
	["OrderWithoutCartCreateInput"]: GraphQLTypes["OrderWithoutCartCreateInput"];
	["OrderCreateCustomerEntityRelationInput"]: GraphQLTypes["OrderCreateCustomerEntityRelationInput"];
	["CustomerWithoutOrdersCreateInput"]: GraphQLTypes["CustomerWithoutOrdersCreateInput"];
	["CustomerCreateShortcutListEntityRelationInput"]: GraphQLTypes["CustomerCreateShortcutListEntityRelationInput"];
	["ApplicationShortcutListWithoutCustomerCreateInput"]: GraphQLTypes["ApplicationShortcutListWithoutCustomerCreateInput"];
	["ApplicationShortcutListCreateItemsEntityRelationInput"]: GraphQLTypes["ApplicationShortcutListCreateItemsEntityRelationInput"];
	["ApplicationShortcutListItemWithoutListCreateInput"]: GraphQLTypes["ApplicationShortcutListItemWithoutListCreateInput"];
	["ApplicationShortcutListItemCreateApplicationEntityRelationInput"]: GraphQLTypes["ApplicationShortcutListItemCreateApplicationEntityRelationInput"];
	["ApplicationUniqueWhere"]: GraphQLTypes["ApplicationUniqueWhere"];
	["ApplicationCreateInput"]: GraphQLTypes["ApplicationCreateInput"];
	["ApplicationCreateIconEntityRelationInput"]: GraphQLTypes["ApplicationCreateIconEntityRelationInput"];
	["CustomerCreateUserEntityRelationInput"]: GraphQLTypes["CustomerCreateUserEntityRelationInput"];
	["UserWithoutCustomerCreateInput"]: GraphQLTypes["UserWithoutCustomerCreateInput"];
	["UserCreateStaffEntityRelationInput"]: GraphQLTypes["UserCreateStaffEntityRelationInput"];
	["StaffWithoutUserCreateInput"]: GraphQLTypes["StaffWithoutUserCreateInput"];
	["StaffCreateShiftsProfileEntityRelationInput"]: GraphQLTypes["StaffCreateShiftsProfileEntityRelationInput"];
	["ShiftsProfileWithoutStaffCreateInput"]: GraphQLTypes["ShiftsProfileWithoutStaffCreateInput"];
	["ShiftsProfileCreateRolesEntityRelationInput"]: GraphQLTypes["ShiftsProfileCreateRolesEntityRelationInput"];
	["TimetableEmployeeRoleWithoutShiftsProfilesCreateInput"]: GraphQLTypes["TimetableEmployeeRoleWithoutShiftsProfilesCreateInput"];
	["TimetableEmployeeRoleCreateShiftsManagersEntityRelationInput"]: GraphQLTypes["TimetableEmployeeRoleCreateShiftsManagersEntityRelationInput"];
	["ShiftsManagerWithoutManagedRolesCreateInput"]: GraphQLTypes["ShiftsManagerWithoutManagedRolesCreateInput"];
	["ShiftsManagerCreateStaffEntityRelationInput"]: GraphQLTypes["ShiftsManagerCreateStaffEntityRelationInput"];
	["StaffWithoutShiftsManagerCreateInput"]: GraphQLTypes["StaffWithoutShiftsManagerCreateInput"];
	["StaffCreateStocksManagerEntityRelationInput"]: GraphQLTypes["StaffCreateStocksManagerEntityRelationInput"];
	["StocksManagerWithoutStaffCreateInput"]: GraphQLTypes["StocksManagerWithoutStaffCreateInput"];
	["StocksManagerCreateManagedProductsEntityRelationInput"]: GraphQLTypes["StocksManagerCreateManagedProductsEntityRelationInput"];
	["ProductWithoutManagerCreateInput"]: GraphQLTypes["ProductWithoutManagerCreateInput"];
	["ProductCreateOrderItemsEntityRelationInput"]: GraphQLTypes["ProductCreateOrderItemsEntityRelationInput"];
	["OrderItemWithoutProductCreateInput"]: GraphQLTypes["OrderItemWithoutProductCreateInput"];
	["OrderItemCreateVatRateEntityRelationInput"]: GraphQLTypes["OrderItemCreateVatRateEntityRelationInput"];
	["OrderItemCreateOrderEntityRelationInput"]: GraphQLTypes["OrderItemCreateOrderEntityRelationInput"];
	["OrderWithoutItemsCreateInput"]: GraphQLTypes["OrderWithoutItemsCreateInput"];
	["OrderCreateDiscountsEntityRelationInput"]: GraphQLTypes["OrderCreateDiscountsEntityRelationInput"];
	["OrderDiscountWithoutOrderCreateInput"]: GraphQLTypes["OrderDiscountWithoutOrderCreateInput"];
	["OrderDiscountCreateVatRateEntityRelationInput"]: GraphQLTypes["OrderDiscountCreateVatRateEntityRelationInput"];
	["OrderDiscountCreateCustomerCreditTransactionsEntityRelationInput"]: GraphQLTypes["OrderDiscountCreateCustomerCreditTransactionsEntityRelationInput"];
	["CustomerCreditTransactionWithoutOrderDiscountCreateInput"]: GraphQLTypes["CustomerCreditTransactionWithoutOrderDiscountCreateInput"];
	["CustomerCreditTransactionCreateCustomerCreditEntityRelationInput"]: GraphQLTypes["CustomerCreditTransactionCreateCustomerCreditEntityRelationInput"];
	["CustomerCreditWithoutTransactionsCreateInput"]: GraphQLTypes["CustomerCreditWithoutTransactionsCreateInput"];
	["CustomerCreditCreateCustomerEntityRelationInput"]: GraphQLTypes["CustomerCreditCreateCustomerEntityRelationInput"];
	["CustomerWithoutCreditsCreateInput"]: GraphQLTypes["CustomerWithoutCreditsCreateInput"];
	["CustomerCreateChannelsEntityRelationInput"]: GraphQLTypes["CustomerCreateChannelsEntityRelationInput"];
	["ChannelWithoutCustomersCreateInput"]: GraphQLTypes["ChannelWithoutCustomersCreateInput"];
	["ChannelCreatePublicTagsEntityRelationInput"]: GraphQLTypes["ChannelCreatePublicTagsEntityRelationInput"];
	["TagWithoutPublicInChannelsCreateInput"]: GraphQLTypes["TagWithoutPublicInChannelsCreateInput"];
	["TagCreateAllowChannelPaymentsEntityRelationInput"]: GraphQLTypes["TagCreateAllowChannelPaymentsEntityRelationInput"];
	["ChannelPaymentWithoutAllowOnlyForTagsCreateInput"]: GraphQLTypes["ChannelPaymentWithoutAllowOnlyForTagsCreateInput"];
	["ChannelPaymentCreateVatRateEntityRelationInput"]: GraphQLTypes["ChannelPaymentCreateVatRateEntityRelationInput"];
	["VatRateWithoutChannelPaymentsCreateInput"]: GraphQLTypes["VatRateWithoutChannelPaymentsCreateInput"];
	["TagCreateFulfillmentNotesEntityRelationInput"]: GraphQLTypes["TagCreateFulfillmentNotesEntityRelationInput"];
	["FulfillmentNoteUniqueWhere"]: GraphQLTypes["FulfillmentNoteUniqueWhere"];
	["FulfillmentNoteWithoutTagsCreateInput"]: GraphQLTypes["FulfillmentNoteWithoutTagsCreateInput"];
	["FulfillmentNoteCreateProductsEntityRelationInput"]: GraphQLTypes["FulfillmentNoteCreateProductsEntityRelationInput"];
	["ProductWithoutFulfillmentNotesCreateInput"]: GraphQLTypes["ProductWithoutFulfillmentNotesCreateInput"];
	["ProductCreateInheritedCategoriesEntityRelationInput"]: GraphQLTypes["ProductCreateInheritedCategoriesEntityRelationInput"];
	["ProductCreateDeliveryZonesEntityRelationInput"]: GraphQLTypes["ProductCreateDeliveryZonesEntityRelationInput"];
	["DeliveryZoneWithoutDeliveryZonesOfProductsCreateInput"]: GraphQLTypes["DeliveryZoneWithoutDeliveryZonesOfProductsCreateInput"];
	["DeliveryZoneCreateDeliveryZonesOfTagsEntityRelationInput"]: GraphQLTypes["DeliveryZoneCreateDeliveryZonesOfTagsEntityRelationInput"];
	["TagWithoutDeliveryZonesCreateInput"]: GraphQLTypes["TagWithoutDeliveryZonesCreateInput"];
	["TagCreatePublicInChannelsEntityRelationInput"]: GraphQLTypes["TagCreatePublicInChannelsEntityRelationInput"];
	["ChannelWithoutPublicTagsCreateInput"]: GraphQLTypes["ChannelWithoutPublicTagsCreateInput"];
	["ChannelCreateVenueEntityRelationInput"]: GraphQLTypes["ChannelCreateVenueEntityRelationInput"];
	["VenueWithoutChannelsCreateInput"]: GraphQLTypes["VenueWithoutChannelsCreateInput"];
	["VenueCreateDeadlineTemplateEntityRelationInput"]: GraphQLTypes["VenueCreateDeadlineTemplateEntityRelationInput"];
	["DeadlineTemplateWithoutVenueCreateInput"]: GraphQLTypes["DeadlineTemplateWithoutVenueCreateInput"];
	["VenueCreateTimetableDaysEntityRelationInput"]: GraphQLTypes["VenueCreateTimetableDaysEntityRelationInput"];
	["TimetableDayWithoutVenueCreateInput"]: GraphQLTypes["TimetableDayWithoutVenueCreateInput"];
	["TimetableDayCreateShiftGroupsEntityRelationInput"]: GraphQLTypes["TimetableDayCreateShiftGroupsEntityRelationInput"];
	["TimetableShiftGroupWithoutDayCreateInput"]: GraphQLTypes["TimetableShiftGroupWithoutDayCreateInput"];
	["TimetableShiftGroupCreateTypeEntityRelationInput"]: GraphQLTypes["TimetableShiftGroupCreateTypeEntityRelationInput"];
	["TimetableEmployeeRoleWithoutShiftGroupsCreateInput"]: GraphQLTypes["TimetableEmployeeRoleWithoutShiftGroupsCreateInput"];
	["TimetableEmployeeRoleCreateTimetableTemplatesEntityRelationInput"]: GraphQLTypes["TimetableEmployeeRoleCreateTimetableTemplatesEntityRelationInput"];
	["TimetableTemplateWithoutEmployeeRoleCreateInput"]: GraphQLTypes["TimetableTemplateWithoutEmployeeRoleCreateInput"];
	["TimetableTemplateCreatePositionEntityRelationInput"]: GraphQLTypes["TimetableTemplateCreatePositionEntityRelationInput"];
	["TimetableShiftPositionUniqueWhere"]: GraphQLTypes["TimetableShiftPositionUniqueWhere"];
	["TimetableShiftPositionWithoutTimetableTemplatesCreateInput"]: GraphQLTypes["TimetableShiftPositionWithoutTimetableTemplatesCreateInput"];
	["TimetableShiftPositionCreateShiftGroupsEntityRelationInput"]: GraphQLTypes["TimetableShiftPositionCreateShiftGroupsEntityRelationInput"];
	["TimetableShiftGroupWithoutPositionCreateInput"]: GraphQLTypes["TimetableShiftGroupWithoutPositionCreateInput"];
	["TimetableShiftGroupCreateQueueEntityRelationInput"]: GraphQLTypes["TimetableShiftGroupCreateQueueEntityRelationInput"];
	["EmployeeQueueWithoutShiftGroupCreateInput"]: GraphQLTypes["EmployeeQueueWithoutShiftGroupCreateInput"];
	["EmployeeQueueCreateItemsEntityRelationInput"]: GraphQLTypes["EmployeeQueueCreateItemsEntityRelationInput"];
	["EmployeeQueueItemWithoutQueueCreateInput"]: GraphQLTypes["EmployeeQueueItemWithoutQueueCreateInput"];
	["EmployeeQueueItemCreateShiftsProfileEntityRelationInput"]: GraphQLTypes["EmployeeQueueItemCreateShiftsProfileEntityRelationInput"];
	["ShiftsProfileWithoutQueueItemsCreateInput"]: GraphQLTypes["ShiftsProfileWithoutQueueItemsCreateInput"];
	["ShiftsProfileCreateShiftsEntityRelationInput"]: GraphQLTypes["ShiftsProfileCreateShiftsEntityRelationInput"];
	["TimetableShiftWithoutShiftsProfileCreateInput"]: GraphQLTypes["TimetableShiftWithoutShiftsProfileCreateInput"];
	["TimetableShiftCreateGroupEntityRelationInput"]: GraphQLTypes["TimetableShiftCreateGroupEntityRelationInput"];
	["TimetableShiftGroupWithoutShiftsCreateInput"]: GraphQLTypes["TimetableShiftGroupWithoutShiftsCreateInput"];
	["TimetableShiftGroupCreatePositionEntityRelationInput"]: GraphQLTypes["TimetableShiftGroupCreatePositionEntityRelationInput"];
	["TimetableShiftPositionWithoutShiftGroupsCreateInput"]: GraphQLTypes["TimetableShiftPositionWithoutShiftGroupsCreateInput"];
	["TimetableShiftPositionCreateTimetableTemplatesEntityRelationInput"]: GraphQLTypes["TimetableShiftPositionCreateTimetableTemplatesEntityRelationInput"];
	["TimetableTemplateWithoutPositionCreateInput"]: GraphQLTypes["TimetableTemplateWithoutPositionCreateInput"];
	["TimetableTemplateCreateStaffOptionsEntityRelationInput"]: GraphQLTypes["TimetableTemplateCreateStaffOptionsEntityRelationInput"];
	["TimetableTemplateStaffOptionsWithoutTimetableTemplateCreateInput"]: GraphQLTypes["TimetableTemplateStaffOptionsWithoutTimetableTemplateCreateInput"];
	["TimetableTemplateStaffOptionsCreateAutoAssignedEmployeeEntityRelationInput"]: GraphQLTypes["TimetableTemplateStaffOptionsCreateAutoAssignedEmployeeEntityRelationInput"];
	["ShiftsProfileCreateInput"]: GraphQLTypes["ShiftsProfileCreateInput"];
	["TimetableTemplateCreateVenueEntityRelationInput"]: GraphQLTypes["TimetableTemplateCreateVenueEntityRelationInput"];
	["VenueWithoutTimetableTemplatesCreateInput"]: GraphQLTypes["VenueWithoutTimetableTemplatesCreateInput"];
	["VenueCreateStaffMembersEntityRelationInput"]: GraphQLTypes["VenueCreateStaffMembersEntityRelationInput"];
	["StaffWithoutVenuesCreateInput"]: GraphQLTypes["StaffWithoutVenuesCreateInput"];
	["StaffCreatePhotoEntityRelationInput"]: GraphQLTypes["StaffCreatePhotoEntityRelationInput"];
	["StaffCreateCourierManagerEntityRelationInput"]: GraphQLTypes["StaffCreateCourierManagerEntityRelationInput"];
	["CourierManagerWithoutStaffCreateInput"]: GraphQLTypes["CourierManagerWithoutStaffCreateInput"];
	["StaffCreatePickerEntityRelationInput"]: GraphQLTypes["StaffCreatePickerEntityRelationInput"];
	["PickerWithoutStaffCreateInput"]: GraphQLTypes["PickerWithoutStaffCreateInput"];
	["StaffCreateRemunerationProfileEntityRelationInput"]: GraphQLTypes["StaffCreateRemunerationProfileEntityRelationInput"];
	["RemunerationProfileWithoutStaffCreateInput"]: GraphQLTypes["RemunerationProfileWithoutStaffCreateInput"];
	["RemunerationProfileCreateEmploymentInformationEntityRelationInput"]: GraphQLTypes["RemunerationProfileCreateEmploymentInformationEntityRelationInput"];
	["EmploymentInformationWithoutRemunerationProfilesCreateInput"]: GraphQLTypes["EmploymentInformationWithoutRemunerationProfilesCreateInput"];
	["RemunerationProfileCreateWorkMonthsEntityRelationInput"]: GraphQLTypes["RemunerationProfileCreateWorkMonthsEntityRelationInput"];
	["WorkMonthUniqueWhere"]: GraphQLTypes["WorkMonthUniqueWhere"];
	["WorkMonthWithoutRemunerationProfileCreateInput"]: GraphQLTypes["WorkMonthWithoutRemunerationProfileCreateInput"];
	["StaffCreateCashierEntityRelationInput"]: GraphQLTypes["StaffCreateCashierEntityRelationInput"];
	["CashierWithoutStaffCreateInput"]: GraphQLTypes["CashierWithoutStaffCreateInput"];
	["StaffCreateInternalBuyerEntityRelationInput"]: GraphQLTypes["StaffCreateInternalBuyerEntityRelationInput"];
	["InternalBuyerWithoutStaffCreateInput"]: GraphQLTypes["InternalBuyerWithoutStaffCreateInput"];
	["StaffCreateSalesManagerEntityRelationInput"]: GraphQLTypes["StaffCreateSalesManagerEntityRelationInput"];
	["SalesManagerWithoutStaffCreateInput"]: GraphQLTypes["SalesManagerWithoutStaffCreateInput"];
	["SalesManagerCreateCountriesEntityRelationInput"]: GraphQLTypes["SalesManagerCreateCountriesEntityRelationInput"];
	["StaffCreateCashierManagerEntityRelationInput"]: GraphQLTypes["StaffCreateCashierManagerEntityRelationInput"];
	["CashierManagerWithoutStaffCreateInput"]: GraphQLTypes["CashierManagerWithoutStaffCreateInput"];
	["VenueCreateEmployeeRolesEntityRelationInput"]: GraphQLTypes["VenueCreateEmployeeRolesEntityRelationInput"];
	["VenueEmployeeRoleWithoutVenueCreateInput"]: GraphQLTypes["VenueEmployeeRoleWithoutVenueCreateInput"];
	["VenueEmployeeRoleCreateEmployeePrivilegesEntityRelationInput"]: GraphQLTypes["VenueEmployeeRoleCreateEmployeePrivilegesEntityRelationInput"];
	["TimetablesEmployeePrivilegesWithoutVenueEmployeeRoleCreateInput"]: GraphQLTypes["TimetablesEmployeePrivilegesWithoutVenueEmployeeRoleCreateInput"];
	["VenueEmployeeRoleCreateRoleEntityRelationInput"]: GraphQLTypes["VenueEmployeeRoleCreateRoleEntityRelationInput"];
	["VenueCreatePointOfSaleApplicationDevicesEntityRelationInput"]: GraphQLTypes["VenueCreatePointOfSaleApplicationDevicesEntityRelationInput"];
	["PointOfSaleApplicationDeviceWithoutVenueCreateInput"]: GraphQLTypes["PointOfSaleApplicationDeviceWithoutVenueCreateInput"];
	["PointOfSaleApplicationDeviceCreateIdentificationCodeEntityRelationInput"]: GraphQLTypes["PointOfSaleApplicationDeviceCreateIdentificationCodeEntityRelationInput"];
	["IdentificationCodeWithoutApplicationDevicesCreateInput"]: GraphQLTypes["IdentificationCodeWithoutApplicationDevicesCreateInput"];
	["IdentificationCodeCreateAttemptsEntityRelationInput"]: GraphQLTypes["IdentificationCodeCreateAttemptsEntityRelationInput"];
	["IdentificationAttemptWithoutCodeCreateInput"]: GraphQLTypes["IdentificationAttemptWithoutCodeCreateInput"];
	["IdentificationAttemptCreateUserEntityRelationInput"]: GraphQLTypes["IdentificationAttemptCreateUserEntityRelationInput"];
	["UserWithoutIdentificationAttemptsCreateInput"]: GraphQLTypes["UserWithoutIdentificationAttemptsCreateInput"];
	["UserCreateDevicesEntityRelationInput"]: GraphQLTypes["UserCreateDevicesEntityRelationInput"];
	["UserDeviceWithoutUserCreateInput"]: GraphQLTypes["UserDeviceWithoutUserCreateInput"];
	["UserDeviceCreateAnonymousSessionEntityRelationInput"]: GraphQLTypes["UserDeviceCreateAnonymousSessionEntityRelationInput"];
	["AnonymousSessionWithoutDevicesCreateInput"]: GraphQLTypes["AnonymousSessionWithoutDevicesCreateInput"];
	["AnonymousSessionCreateCustomerEntityRelationInput"]: GraphQLTypes["AnonymousSessionCreateCustomerEntityRelationInput"];
	["CustomerWithoutAnonymousSessionCreateInput"]: GraphQLTypes["CustomerWithoutAnonymousSessionCreateInput"];
	["CustomerCreateInvoicesEntityRelationInput"]: GraphQLTypes["CustomerCreateInvoicesEntityRelationInput"];
	["InvoiceWithoutCustomerCreateInput"]: GraphQLTypes["InvoiceWithoutCustomerCreateInput"];
	["InvoiceCreateOrderPaymentsEntityRelationInput"]: GraphQLTypes["InvoiceCreateOrderPaymentsEntityRelationInput"];
	["OrderPaymentWithoutInvoiceCreateInput"]: GraphQLTypes["OrderPaymentWithoutInvoiceCreateInput"];
	["OrderPaymentCreateMethodEntityRelationInput"]: GraphQLTypes["OrderPaymentCreateMethodEntityRelationInput"];
	["OrderPaymentCreateEventsEntityRelationInput"]: GraphQLTypes["OrderPaymentCreateEventsEntityRelationInput"];
	["OrderEventWithoutPaymentCreateInput"]: GraphQLTypes["OrderEventWithoutPaymentCreateInput"];
	["OrderEventCreateOrderEntityRelationInput"]: GraphQLTypes["OrderEventCreateOrderEntityRelationInput"];
	["OrderWithoutEventsCreateInput"]: GraphQLTypes["OrderWithoutEventsCreateInput"];
	["OrderCreateDeliveryEntityRelationInput"]: GraphQLTypes["OrderCreateDeliveryEntityRelationInput"];
	["OrderDeliveryWithoutOrderCreateInput"]: GraphQLTypes["OrderDeliveryWithoutOrderCreateInput"];
	["OrderDeliveryCreateVatRateEntityRelationInput"]: GraphQLTypes["OrderDeliveryCreateVatRateEntityRelationInput"];
	["OrderDeliveryCreateDeliveryWaypointEntityRelationInput"]: GraphQLTypes["OrderDeliveryCreateDeliveryWaypointEntityRelationInput"];
	["DeliveryWaypointWithoutDeliveryCreateInput"]: GraphQLTypes["DeliveryWaypointWithoutDeliveryCreateInput"];
	["DeliveryWaypointCreateRouteEntityRelationInput"]: GraphQLTypes["DeliveryWaypointCreateRouteEntityRelationInput"];
	["DeliveryRouteWithoutWaypointsCreateInput"]: GraphQLTypes["DeliveryRouteWithoutWaypointsCreateInput"];
	["DeliveryRouteCreateCourierEntityRelationInput"]: GraphQLTypes["DeliveryRouteCreateCourierEntityRelationInput"];
	["CourierWithoutRoutesCreateInput"]: GraphQLTypes["CourierWithoutRoutesCreateInput"];
	["CourierCreateDeliveryMethodsEntityRelationInput"]: GraphQLTypes["CourierCreateDeliveryMethodsEntityRelationInput"];
	["DeliveryMethodWithoutCourierHandlersCreateInput"]: GraphQLTypes["DeliveryMethodWithoutCourierHandlersCreateInput"];
	["DeliveryMethodCreateLocalesEntityRelationInput"]: GraphQLTypes["DeliveryMethodCreateLocalesEntityRelationInput"];
	["DeliveryMethodLocaleWithoutRootCreateInput"]: GraphQLTypes["DeliveryMethodLocaleWithoutRootCreateInput"];
	["DeliveryMethodLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["DeliveryMethodLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutDeliveryMethodsCreateInput"]: GraphQLTypes["LocaleWithoutDeliveryMethodsCreateInput"];
	["LocaleCreateProductPackingsEntityRelationInput"]: GraphQLTypes["LocaleCreateProductPackingsEntityRelationInput"];
	["ProductPackingLocaleWithoutLocaleCreateInput"]: GraphQLTypes["ProductPackingLocaleWithoutLocaleCreateInput"];
	["ProductPackingLocaleCreateRootEntityRelationInput"]: GraphQLTypes["ProductPackingLocaleCreateRootEntityRelationInput"];
	["ProductPackingWithoutLocalesCreateInput"]: GraphQLTypes["ProductPackingWithoutLocalesCreateInput"];
	["ProductPackingCreatePreparedPackingQuantitiesEntityRelationInput"]: GraphQLTypes["ProductPackingCreatePreparedPackingQuantitiesEntityRelationInput"];
	["PreparedPackingQuantityWithoutPackingCreateInput"]: GraphQLTypes["PreparedPackingQuantityWithoutPackingCreateInput"];
	["PreparedPackingQuantityCreateRecipeEntityRelationInput"]: GraphQLTypes["PreparedPackingQuantityCreateRecipeEntityRelationInput"];
	["ProductRecipeCreateInput"]: GraphQLTypes["ProductRecipeCreateInput"];
	["ProductRecipeCreateProductsEntityRelationInput"]: GraphQLTypes["ProductRecipeCreateProductsEntityRelationInput"];
	["ProductWithoutRecipeCreateInput"]: GraphQLTypes["ProductWithoutRecipeCreateInput"];
	["ProductCreateLocalesEntityRelationInput"]: GraphQLTypes["ProductCreateLocalesEntityRelationInput"];
	["ProductLocaleWithoutRootCreateInput"]: GraphQLTypes["ProductLocaleWithoutRootCreateInput"];
	["ProductLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["ProductLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutProductsCreateInput"]: GraphQLTypes["LocaleWithoutProductsCreateInput"];
	["LocaleCreateProductRecipesEntityRelationInput"]: GraphQLTypes["LocaleCreateProductRecipesEntityRelationInput"];
	["ProductRecipeLocaleWithoutLocaleCreateInput"]: GraphQLTypes["ProductRecipeLocaleWithoutLocaleCreateInput"];
	["ProductRecipeLocaleCreateRootEntityRelationInput"]: GraphQLTypes["ProductRecipeLocaleCreateRootEntityRelationInput"];
	["ProductRecipeWithoutLocalesCreateInput"]: GraphQLTypes["ProductRecipeWithoutLocalesCreateInput"];
	["ProductRecipeCreateFreshingContainerEntityRelationInput"]: GraphQLTypes["ProductRecipeCreateFreshingContainerEntityRelationInput"];
	["ProductRecipeCreateNutritionFactsEntityRelationInput"]: GraphQLTypes["ProductRecipeCreateNutritionFactsEntityRelationInput"];
	["NutritionFactsCreateInput"]: GraphQLTypes["NutritionFactsCreateInput"];
	["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]: GraphQLTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"];
	["PointOfSaleCategoryLocaleWithoutLocaleCreateInput"]: GraphQLTypes["PointOfSaleCategoryLocaleWithoutLocaleCreateInput"];
	["PointOfSaleCategoryLocaleCreateRootEntityRelationInput"]: GraphQLTypes["PointOfSaleCategoryLocaleCreateRootEntityRelationInput"];
	["PointOfSaleCategoryWithoutLocalesCreateInput"]: GraphQLTypes["PointOfSaleCategoryWithoutLocalesCreateInput"];
	["PointOfSaleCategoryCreateProductsEntityRelationInput"]: GraphQLTypes["PointOfSaleCategoryCreateProductsEntityRelationInput"];
	["PointOfSaleCategoryProductWithoutCategoryCreateInput"]: GraphQLTypes["PointOfSaleCategoryProductWithoutCategoryCreateInput"];
	["PointOfSaleCategoryProductCreateProductEntityRelationInput"]: GraphQLTypes["PointOfSaleCategoryProductCreateProductEntityRelationInput"];
	["ProductCreateInput"]: GraphQLTypes["ProductCreateInput"];
	["ProductCreateCustomerPricesEntityRelationInput"]: GraphQLTypes["ProductCreateCustomerPricesEntityRelationInput"];
	["ProductCreateVirtualProductEntityRelationInput"]: GraphQLTypes["ProductCreateVirtualProductEntityRelationInput"];
	["VirtualProductWithoutProductCreateInput"]: GraphQLTypes["VirtualProductWithoutProductCreateInput"];
	["ProductCreateMetaEntityRelationInput"]: GraphQLTypes["ProductCreateMetaEntityRelationInput"];
	["ProductCreatePageEntityRelationInput"]: GraphQLTypes["ProductCreatePageEntityRelationInput"];
	["PageCreateInput"]: GraphQLTypes["PageCreateInput"];
	["PageCreateLocalesEntityRelationInput"]: GraphQLTypes["PageCreateLocalesEntityRelationInput"];
	["PageLocaleWithoutRootCreateInput"]: GraphQLTypes["PageLocaleWithoutRootCreateInput"];
	["PageLocaleCreateSeoEntityRelationInput"]: GraphQLTypes["PageLocaleCreateSeoEntityRelationInput"];
	["SeoCreateInput"]: GraphQLTypes["SeoCreateInput"];
	["SeoCreateOgImageEntityRelationInput"]: GraphQLTypes["SeoCreateOgImageEntityRelationInput"];
	["PageLocaleCreateContentEntityRelationInput"]: GraphQLTypes["PageLocaleCreateContentEntityRelationInput"];
	["PageLocaleCreateCoverEntityRelationInput"]: GraphQLTypes["PageLocaleCreateCoverEntityRelationInput"];
	["ProductCreateSalesDaysEntityRelationInput"]: GraphQLTypes["ProductCreateSalesDaysEntityRelationInput"];
	["ProductCreateSalesWeeksEntityRelationInput"]: GraphQLTypes["ProductCreateSalesWeeksEntityRelationInput"];
	["ProductCreateSalesMonthsEntityRelationInput"]: GraphQLTypes["ProductCreateSalesMonthsEntityRelationInput"];
	["ProductCreateFulfillmentNotesEntityRelationInput"]: GraphQLTypes["ProductCreateFulfillmentNotesEntityRelationInput"];
	["FulfillmentNoteWithoutProductsCreateInput"]: GraphQLTypes["FulfillmentNoteWithoutProductsCreateInput"];
	["FulfillmentNoteCreateTagsEntityRelationInput"]: GraphQLTypes["FulfillmentNoteCreateTagsEntityRelationInput"];
	["TagWithoutFulfillmentNotesCreateInput"]: GraphQLTypes["TagWithoutFulfillmentNotesCreateInput"];
	["FulfillmentNoteCreateVenuesEntityRelationInput"]: GraphQLTypes["FulfillmentNoteCreateVenuesEntityRelationInput"];
	["VenueWithoutFulfillmentNotesCreateInput"]: GraphQLTypes["VenueWithoutFulfillmentNotesCreateInput"];
	["VenueCreateTimetableTemplatesEntityRelationInput"]: GraphQLTypes["VenueCreateTimetableTemplatesEntityRelationInput"];
	["TimetableTemplateWithoutVenueCreateInput"]: GraphQLTypes["TimetableTemplateWithoutVenueCreateInput"];
	["TimetableTemplateCreateEmployeeRoleEntityRelationInput"]: GraphQLTypes["TimetableTemplateCreateEmployeeRoleEntityRelationInput"];
	["TimetableEmployeeRoleWithoutTimetableTemplatesCreateInput"]: GraphQLTypes["TimetableEmployeeRoleWithoutTimetableTemplatesCreateInput"];
	["VenueCreatePointOfSaleTerminalsEntityRelationInput"]: GraphQLTypes["VenueCreatePointOfSaleTerminalsEntityRelationInput"];
	["PointOfSaleTerminalWithoutVenueCreateInput"]: GraphQLTypes["PointOfSaleTerminalWithoutVenueCreateInput"];
	["PointOfSaleTerminalCreateApplicationDevicesEntityRelationInput"]: GraphQLTypes["PointOfSaleTerminalCreateApplicationDevicesEntityRelationInput"];
	["PointOfSaleApplicationDeviceWithoutTerminalCreateInput"]: GraphQLTypes["PointOfSaleApplicationDeviceWithoutTerminalCreateInput"];
	["PointOfSaleApplicationDeviceCreateVenueEntityRelationInput"]: GraphQLTypes["PointOfSaleApplicationDeviceCreateVenueEntityRelationInput"];
	["VenueWithoutPointOfSaleApplicationDevicesCreateInput"]: GraphQLTypes["VenueWithoutPointOfSaleApplicationDevicesCreateInput"];
	["VenueCreatePointOfSalePrintersEntityRelationInput"]: GraphQLTypes["VenueCreatePointOfSalePrintersEntityRelationInput"];
	["PointOfSalePrinterWithoutVenueCreateInput"]: GraphQLTypes["PointOfSalePrinterWithoutVenueCreateInput"];
	["PointOfSalePrinterCreateApplicationDevicesReceiptEntityRelationInput"]: GraphQLTypes["PointOfSalePrinterCreateApplicationDevicesReceiptEntityRelationInput"];
	["PointOfSaleApplicationDeviceWithoutReceiptPrinterCreateInput"]: GraphQLTypes["PointOfSaleApplicationDeviceWithoutReceiptPrinterCreateInput"];
	["PointOfSaleApplicationDeviceCreateIdentifierEntityRelationInput"]: GraphQLTypes["PointOfSaleApplicationDeviceCreateIdentifierEntityRelationInput"];
	["DeviceIdentifierWithoutDeviceCreateInput"]: GraphQLTypes["DeviceIdentifierWithoutDeviceCreateInput"];
	["DeviceIdentifierCreateUpdatedByUserEntityRelationInput"]: GraphQLTypes["DeviceIdentifierCreateUpdatedByUserEntityRelationInput"];
	["UserCreateInput"]: GraphQLTypes["UserCreateInput"];
	["UserCreateMetaEntityRelationInput"]: GraphQLTypes["UserCreateMetaEntityRelationInput"];
	["UserCreateIdentificationAttemptsEntityRelationInput"]: GraphQLTypes["UserCreateIdentificationAttemptsEntityRelationInput"];
	["IdentificationAttemptWithoutUserCreateInput"]: GraphQLTypes["IdentificationAttemptWithoutUserCreateInput"];
	["IdentificationAttemptCreateCodeEntityRelationInput"]: GraphQLTypes["IdentificationAttemptCreateCodeEntityRelationInput"];
	["IdentificationCodeWithoutAttemptsCreateInput"]: GraphQLTypes["IdentificationCodeWithoutAttemptsCreateInput"];
	["IdentificationCodeCreateLocalesEntityRelationInput"]: GraphQLTypes["IdentificationCodeCreateLocalesEntityRelationInput"];
	["IdentificationCodeLocaleWithoutRootCreateInput"]: GraphQLTypes["IdentificationCodeLocaleWithoutRootCreateInput"];
	["IdentificationCodeLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["IdentificationCodeLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutIdentificationCodesCreateInput"]: GraphQLTypes["LocaleWithoutIdentificationCodesCreateInput"];
	["LocaleCreateProductsEntityRelationInput"]: GraphQLTypes["LocaleCreateProductsEntityRelationInput"];
	["ProductLocaleWithoutLocaleCreateInput"]: GraphQLTypes["ProductLocaleWithoutLocaleCreateInput"];
	["ProductLocaleCreateRootEntityRelationInput"]: GraphQLTypes["ProductLocaleCreateRootEntityRelationInput"];
	["ProductWithoutLocalesCreateInput"]: GraphQLTypes["ProductWithoutLocalesCreateInput"];
	["ProductLocaleCreateFeatureListEntityRelationInput"]: GraphQLTypes["ProductLocaleCreateFeatureListEntityRelationInput"];
	["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]: GraphQLTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"];
	["PointOfSaleCategoryProductLocaleWithoutLocaleCreateInput"]: GraphQLTypes["PointOfSaleCategoryProductLocaleWithoutLocaleCreateInput"];
	["PointOfSaleCategoryProductLocaleCreateRootEntityRelationInput"]: GraphQLTypes["PointOfSaleCategoryProductLocaleCreateRootEntityRelationInput"];
	["PointOfSaleCategoryProductWithoutLocalesCreateInput"]: GraphQLTypes["PointOfSaleCategoryProductWithoutLocalesCreateInput"];
	["PointOfSaleCategoryProductCreateCategoryEntityRelationInput"]: GraphQLTypes["PointOfSaleCategoryProductCreateCategoryEntityRelationInput"];
	["PointOfSaleCategoryWithoutProductsCreateInput"]: GraphQLTypes["PointOfSaleCategoryWithoutProductsCreateInput"];
	["PointOfSaleCategoryCreateLocalesEntityRelationInput"]: GraphQLTypes["PointOfSaleCategoryCreateLocalesEntityRelationInput"];
	["PointOfSaleCategoryLocaleWithoutRootCreateInput"]: GraphQLTypes["PointOfSaleCategoryLocaleWithoutRootCreateInput"];
	["PointOfSaleCategoryLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["PointOfSaleCategoryLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutPointOfSaleCategoriesCreateInput"]: GraphQLTypes["LocaleWithoutPointOfSaleCategoriesCreateInput"];
	["LocaleCreateDeliveryMethodsEntityRelationInput"]: GraphQLTypes["LocaleCreateDeliveryMethodsEntityRelationInput"];
	["DeliveryMethodLocaleWithoutLocaleCreateInput"]: GraphQLTypes["DeliveryMethodLocaleWithoutLocaleCreateInput"];
	["DeliveryMethodLocaleCreateRootEntityRelationInput"]: GraphQLTypes["DeliveryMethodLocaleCreateRootEntityRelationInput"];
	["DeliveryMethodWithoutLocalesCreateInput"]: GraphQLTypes["DeliveryMethodWithoutLocalesCreateInput"];
	["DeliveryMethodCreateTimelinePresetEntityRelationInput"]: GraphQLTypes["DeliveryMethodCreateTimelinePresetEntityRelationInput"];
	["DeliveryTimelinePresetWithoutDeliveryMethodCreateInput"]: GraphQLTypes["DeliveryTimelinePresetWithoutDeliveryMethodCreateInput"];
	["LocaleCreateIngredientSuppliersEntityRelationInput"]: GraphQLTypes["LocaleCreateIngredientSuppliersEntityRelationInput"];
	["IngredientSupplierLocaleWithoutLocaleCreateInput"]: GraphQLTypes["IngredientSupplierLocaleWithoutLocaleCreateInput"];
	["IngredientSupplierLocaleCreateRootEntityRelationInput"]: GraphQLTypes["IngredientSupplierLocaleCreateRootEntityRelationInput"];
	["IngredientSupplierWithoutLocalesCreateInput"]: GraphQLTypes["IngredientSupplierWithoutLocalesCreateInput"];
	["LocaleCreateIdentificationCodesEntityRelationInput"]: GraphQLTypes["LocaleCreateIdentificationCodesEntityRelationInput"];
	["IdentificationCodeLocaleWithoutLocaleCreateInput"]: GraphQLTypes["IdentificationCodeLocaleWithoutLocaleCreateInput"];
	["IdentificationCodeLocaleCreateRootEntityRelationInput"]: GraphQLTypes["IdentificationCodeLocaleCreateRootEntityRelationInput"];
	["IdentificationCodeWithoutLocalesCreateInput"]: GraphQLTypes["IdentificationCodeWithoutLocalesCreateInput"];
	["IdentificationCodeCreateApplicationDevicesEntityRelationInput"]: GraphQLTypes["IdentificationCodeCreateApplicationDevicesEntityRelationInput"];
	["PointOfSaleApplicationDeviceWithoutIdentificationCodeCreateInput"]: GraphQLTypes["PointOfSaleApplicationDeviceWithoutIdentificationCodeCreateInput"];
	["PointOfSaleApplicationDeviceCreateTerminalEntityRelationInput"]: GraphQLTypes["PointOfSaleApplicationDeviceCreateTerminalEntityRelationInput"];
	["PointOfSaleTerminalWithoutApplicationDevicesCreateInput"]: GraphQLTypes["PointOfSaleTerminalWithoutApplicationDevicesCreateInput"];
	["PointOfSaleTerminalCreateVenueEntityRelationInput"]: GraphQLTypes["PointOfSaleTerminalCreateVenueEntityRelationInput"];
	["VenueWithoutPointOfSaleTerminalsCreateInput"]: GraphQLTypes["VenueWithoutPointOfSaleTerminalsCreateInput"];
	["VenueCreateOrdersEntityRelationInput"]: GraphQLTypes["VenueCreateOrdersEntityRelationInput"];
	["OrderWithoutVenueCreateInput"]: GraphQLTypes["OrderWithoutVenueCreateInput"];
	["OrderCreateItemsEntityRelationInput"]: GraphQLTypes["OrderCreateItemsEntityRelationInput"];
	["OrderItemWithoutOrderCreateInput"]: GraphQLTypes["OrderItemWithoutOrderCreateInput"];
	["OrderItemCreateVirtualProductEffectsEntityRelationInput"]: GraphQLTypes["OrderItemCreateVirtualProductEffectsEntityRelationInput"];
	["VirtualProductEffectWithoutOrderItemCreateInput"]: GraphQLTypes["VirtualProductEffectWithoutOrderItemCreateInput"];
	["VirtualProductEffectCreateResultCustomerCreditTransactionEntityRelationInput"]: GraphQLTypes["VirtualProductEffectCreateResultCustomerCreditTransactionEntityRelationInput"];
	["CustomerCreditTransactionWithoutVirtualProductEffectCreateInput"]: GraphQLTypes["CustomerCreditTransactionWithoutVirtualProductEffectCreateInput"];
	["CustomerCreditTransactionCreateOrderDiscountEntityRelationInput"]: GraphQLTypes["CustomerCreditTransactionCreateOrderDiscountEntityRelationInput"];
	["OrderDiscountWithoutCustomerCreditTransactionsCreateInput"]: GraphQLTypes["OrderDiscountWithoutCustomerCreditTransactionsCreateInput"];
	["OrderDiscountCreateOrderEntityRelationInput"]: GraphQLTypes["OrderDiscountCreateOrderEntityRelationInput"];
	["OrderWithoutDiscountsCreateInput"]: GraphQLTypes["OrderWithoutDiscountsCreateInput"];
	["OrderCreateCartEntityRelationInput"]: GraphQLTypes["OrderCreateCartEntityRelationInput"];
	["CartWithoutOrderCreateInput"]: GraphQLTypes["CartWithoutOrderCreateInput"];
	["CartCreateCustomerEntityRelationInput"]: GraphQLTypes["CartCreateCustomerEntityRelationInput"];
	["CustomerWithoutCartsCreateInput"]: GraphQLTypes["CustomerWithoutCartsCreateInput"];
	["CustomerCreateInvoicingPlanEntityRelationInput"]: GraphQLTypes["CustomerCreateInvoicingPlanEntityRelationInput"];
	["InvoicingPlanWithoutCustomerCreateInput"]: GraphQLTypes["InvoicingPlanWithoutCustomerCreateInput"];
	["InvoicingPlanCreatePresetEntityRelationInput"]: GraphQLTypes["InvoicingPlanCreatePresetEntityRelationInput"];
	["InvoicingPresetWithoutInvoicingPlanCreateInput"]: GraphQLTypes["InvoicingPresetWithoutInvoicingPlanCreateInput"];
	["CustomerCreateBillingSubjectsEntityRelationInput"]: GraphQLTypes["CustomerCreateBillingSubjectsEntityRelationInput"];
	["BillingSubjectWithoutCustomerCreateInput"]: GraphQLTypes["BillingSubjectWithoutCustomerCreateInput"];
	["BillingSubjectCreateCountryEntityRelationInput"]: GraphQLTypes["BillingSubjectCreateCountryEntityRelationInput"];
	["BillingSubjectCreateInvoicesEntityRelationInput"]: GraphQLTypes["BillingSubjectCreateInvoicesEntityRelationInput"];
	["InvoiceWithoutBillingSubjectCreateInput"]: GraphQLTypes["InvoiceWithoutBillingSubjectCreateInput"];
	["InvoiceCreateAddressEntityRelationInput"]: GraphQLTypes["InvoiceCreateAddressEntityRelationInput"];
	["AddressWithoutInvoicesCreateInput"]: GraphQLTypes["AddressWithoutInvoicesCreateInput"];
	["AddressCreateBillingAddressOfOrdersEntityRelationInput"]: GraphQLTypes["AddressCreateBillingAddressOfOrdersEntityRelationInput"];
	["OrderWithoutBillingAddressCreateInput"]: GraphQLTypes["OrderWithoutBillingAddressCreateInput"];
	["OrderCreateEventsEntityRelationInput"]: GraphQLTypes["OrderCreateEventsEntityRelationInput"];
	["OrderEventWithoutOrderCreateInput"]: GraphQLTypes["OrderEventWithoutOrderCreateInput"];
	["OrderEventCreatePaymentEntityRelationInput"]: GraphQLTypes["OrderEventCreatePaymentEntityRelationInput"];
	["OrderPaymentWithoutEventsCreateInput"]: GraphQLTypes["OrderPaymentWithoutEventsCreateInput"];
	["OrderPaymentCreateOrderEntityRelationInput"]: GraphQLTypes["OrderPaymentCreateOrderEntityRelationInput"];
	["OrderWithoutPaymentsCreateInput"]: GraphQLTypes["OrderWithoutPaymentsCreateInput"];
	["OrderCreateBillingAddressEntityRelationInput"]: GraphQLTypes["OrderCreateBillingAddressEntityRelationInput"];
	["AddressWithoutBillingAddressOfOrdersCreateInput"]: GraphQLTypes["AddressWithoutBillingAddressOfOrdersCreateInput"];
	["AddressCreateDeliveryAddressOfOrderDeliveriesEntityRelationInput"]: GraphQLTypes["AddressCreateDeliveryAddressOfOrderDeliveriesEntityRelationInput"];
	["OrderDeliveryWithoutAddressCreateInput"]: GraphQLTypes["OrderDeliveryWithoutAddressCreateInput"];
	["OrderDeliveryCreateOrderEntityRelationInput"]: GraphQLTypes["OrderDeliveryCreateOrderEntityRelationInput"];
	["OrderWithoutDeliveryCreateInput"]: GraphQLTypes["OrderWithoutDeliveryCreateInput"];
	["OrderCreatePriceLinesEntityRelationInput"]: GraphQLTypes["OrderCreatePriceLinesEntityRelationInput"];
	["OrderCreatePaymentsEntityRelationInput"]: GraphQLTypes["OrderCreatePaymentsEntityRelationInput"];
	["OrderPaymentWithoutOrderCreateInput"]: GraphQLTypes["OrderPaymentWithoutOrderCreateInput"];
	["OrderPaymentCreateInvoiceEntityRelationInput"]: GraphQLTypes["OrderPaymentCreateInvoiceEntityRelationInput"];
	["InvoiceWithoutOrderPaymentsCreateInput"]: GraphQLTypes["InvoiceWithoutOrderPaymentsCreateInput"];
	["InvoiceCreateBillingSubjectEntityRelationInput"]: GraphQLTypes["InvoiceCreateBillingSubjectEntityRelationInput"];
	["BillingSubjectWithoutInvoicesCreateInput"]: GraphQLTypes["BillingSubjectWithoutInvoicesCreateInput"];
	["BillingSubjectCreateCustomerEntityRelationInput"]: GraphQLTypes["BillingSubjectCreateCustomerEntityRelationInput"];
	["CustomerWithoutBillingSubjectsCreateInput"]: GraphQLTypes["CustomerWithoutBillingSubjectsCreateInput"];
	["CustomerCreateOfferedProductsEntityRelationInput"]: GraphQLTypes["CustomerCreateOfferedProductsEntityRelationInput"];
	["CustomerCreateDefaultDeliveryAddressEntityRelationInput"]: GraphQLTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"];
	["AddressWithoutDefaultDeliveryAddressOfCustomerCreateInput"]: GraphQLTypes["AddressWithoutDefaultDeliveryAddressOfCustomerCreateInput"];
	["CustomerCreateDefaultBillingSubjectEntityRelationInput"]: GraphQLTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"];
	["BillingSubjectWithoutDefaultBillingSubjectOfCustomerCreateInput"]: GraphQLTypes["BillingSubjectWithoutDefaultBillingSubjectOfCustomerCreateInput"];
	["BillingSubjectCreateOrdersEntityRelationInput"]: GraphQLTypes["BillingSubjectCreateOrdersEntityRelationInput"];
	["OrderWithoutBillingSubjectCreateInput"]: GraphQLTypes["OrderWithoutBillingSubjectCreateInput"];
	["OrderCreateSummaryEntityRelationInput"]: GraphQLTypes["OrderCreateSummaryEntityRelationInput"];
	["OrderCreateGratuityEntityRelationInput"]: GraphQLTypes["OrderCreateGratuityEntityRelationInput"];
	["GratuityWithoutOrderCreateInput"]: GraphQLTypes["GratuityWithoutOrderCreateInput"];
	["OrderCreateVenueEntityRelationInput"]: GraphQLTypes["OrderCreateVenueEntityRelationInput"];
	["VenueWithoutOrdersCreateInput"]: GraphQLTypes["VenueWithoutOrdersCreateInput"];
	["VenueCreateFulfillmentNotesEntityRelationInput"]: GraphQLTypes["VenueCreateFulfillmentNotesEntityRelationInput"];
	["FulfillmentNoteWithoutVenuesCreateInput"]: GraphQLTypes["FulfillmentNoteWithoutVenuesCreateInput"];
	["FulfillmentNoteCreateCartItemsEntityRelationInput"]: GraphQLTypes["FulfillmentNoteCreateCartItemsEntityRelationInput"];
	["CartItemWithoutFulfillmentNotesCreateInput"]: GraphQLTypes["CartItemWithoutFulfillmentNotesCreateInput"];
	["FulfillmentNoteCreateOrderItemsEntityRelationInput"]: GraphQLTypes["FulfillmentNoteCreateOrderItemsEntityRelationInput"];
	["OrderItemWithoutFulfillmentNotesCreateInput"]: GraphQLTypes["OrderItemWithoutFulfillmentNotesCreateInput"];
	["OrderItemCreateProductEntityRelationInput"]: GraphQLTypes["OrderItemCreateProductEntityRelationInput"];
	["ProductWithoutOrderItemsCreateInput"]: GraphQLTypes["ProductWithoutOrderItemsCreateInput"];
	["FulfillmentNoteCreateOrdersEntityRelationInput"]: GraphQLTypes["FulfillmentNoteCreateOrdersEntityRelationInput"];
	["OrderWithoutFulfillmentNotesCreateInput"]: GraphQLTypes["OrderWithoutFulfillmentNotesCreateInput"];
	["OrderCreateBillingSubjectEntityRelationInput"]: GraphQLTypes["OrderCreateBillingSubjectEntityRelationInput"];
	["BillingSubjectWithoutOrdersCreateInput"]: GraphQLTypes["BillingSubjectWithoutOrdersCreateInput"];
	["BillingSubjectCreateDefaultBillingSubjectOfCustomerEntityRelationInput"]: GraphQLTypes["BillingSubjectCreateDefaultBillingSubjectOfCustomerEntityRelationInput"];
	["CustomerWithoutDefaultBillingSubjectCreateInput"]: GraphQLTypes["CustomerWithoutDefaultBillingSubjectCreateInput"];
	["CustomerCreateAnonymousSessionEntityRelationInput"]: GraphQLTypes["CustomerCreateAnonymousSessionEntityRelationInput"];
	["AnonymousSessionWithoutCustomerCreateInput"]: GraphQLTypes["AnonymousSessionWithoutCustomerCreateInput"];
	["AnonymousSessionCreateDevicesEntityRelationInput"]: GraphQLTypes["AnonymousSessionCreateDevicesEntityRelationInput"];
	["UserDeviceWithoutAnonymousSessionCreateInput"]: GraphQLTypes["UserDeviceWithoutAnonymousSessionCreateInput"];
	["UserDeviceCreateUserEntityRelationInput"]: GraphQLTypes["UserDeviceCreateUserEntityRelationInput"];
	["UserWithoutDevicesCreateInput"]: GraphQLTypes["UserWithoutDevicesCreateInput"];
	["UserCreateRolesEntityRelationInput"]: GraphQLTypes["UserCreateRolesEntityRelationInput"];
	["CustomerCreateBoughtVouchersEntityRelationInput"]: GraphQLTypes["CustomerCreateBoughtVouchersEntityRelationInput"];
	["VoucherWithoutBuyerCreateInput"]: GraphQLTypes["VoucherWithoutBuyerCreateInput"];
	["VoucherCreateOwnerEntityRelationInput"]: GraphQLTypes["VoucherCreateOwnerEntityRelationInput"];
	["CustomerWithoutOwnsVouchersCreateInput"]: GraphQLTypes["CustomerWithoutOwnsVouchersCreateInput"];
	["CustomerCreateRedeemedVouchersEntityRelationInput"]: GraphQLTypes["CustomerCreateRedeemedVouchersEntityRelationInput"];
	["VoucherRedemptionWithoutCustomerCreateInput"]: GraphQLTypes["VoucherRedemptionWithoutCustomerCreateInput"];
	["VoucherRedemptionCreateCustomerCreditEntityRelationInput"]: GraphQLTypes["VoucherRedemptionCreateCustomerCreditEntityRelationInput"];
	["CustomerCreditWithoutVoucherRedemptionCreateInput"]: GraphQLTypes["CustomerCreditWithoutVoucherRedemptionCreateInput"];
	["CustomerCreditCreateTransactionsEntityRelationInput"]: GraphQLTypes["CustomerCreditCreateTransactionsEntityRelationInput"];
	["CustomerCreditTransactionWithoutCustomerCreditCreateInput"]: GraphQLTypes["CustomerCreditTransactionWithoutCustomerCreditCreateInput"];
	["CustomerCreditTransactionCreateVirtualProductEffectEntityRelationInput"]: GraphQLTypes["CustomerCreditTransactionCreateVirtualProductEffectEntityRelationInput"];
	["VirtualProductEffectWithoutResultCustomerCreditTransactionCreateInput"]: GraphQLTypes["VirtualProductEffectWithoutResultCustomerCreditTransactionCreateInput"];
	["VirtualProductEffectCreateOrderItemEntityRelationInput"]: GraphQLTypes["VirtualProductEffectCreateOrderItemEntityRelationInput"];
	["OrderItemWithoutVirtualProductEffectsCreateInput"]: GraphQLTypes["OrderItemWithoutVirtualProductEffectsCreateInput"];
	["OrderItemCreateFulfillmentNotesEntityRelationInput"]: GraphQLTypes["OrderItemCreateFulfillmentNotesEntityRelationInput"];
	["FulfillmentNoteWithoutOrderItemsCreateInput"]: GraphQLTypes["FulfillmentNoteWithoutOrderItemsCreateInput"];
	["VirtualProductEffectCreateResultVouchersEntityRelationInput"]: GraphQLTypes["VirtualProductEffectCreateResultVouchersEntityRelationInput"];
	["VoucherWithoutVirtualProductEffectCreateInput"]: GraphQLTypes["VoucherWithoutVirtualProductEffectCreateInput"];
	["VoucherCreateBuyerEntityRelationInput"]: GraphQLTypes["VoucherCreateBuyerEntityRelationInput"];
	["CustomerWithoutBoughtVouchersCreateInput"]: GraphQLTypes["CustomerWithoutBoughtVouchersCreateInput"];
	["CustomerCreateOwnsVouchersEntityRelationInput"]: GraphQLTypes["CustomerCreateOwnsVouchersEntityRelationInput"];
	["VoucherWithoutOwnerCreateInput"]: GraphQLTypes["VoucherWithoutOwnerCreateInput"];
	["VoucherCreateVatRateEntityRelationInput"]: GraphQLTypes["VoucherCreateVatRateEntityRelationInput"];
	["VoucherCreateVirtualProductEffectEntityRelationInput"]: GraphQLTypes["VoucherCreateVirtualProductEffectEntityRelationInput"];
	["VirtualProductEffectWithoutResultVouchersCreateInput"]: GraphQLTypes["VirtualProductEffectWithoutResultVouchersCreateInput"];
	["VoucherCreateRedemptionEntityRelationInput"]: GraphQLTypes["VoucherCreateRedemptionEntityRelationInput"];
	["VoucherRedemptionWithoutVoucherCreateInput"]: GraphQLTypes["VoucherRedemptionWithoutVoucherCreateInput"];
	["VoucherRedemptionCreateOrderDiscountEntityRelationInput"]: GraphQLTypes["VoucherRedemptionCreateOrderDiscountEntityRelationInput"];
	["OrderDiscountWithoutVoucherRedemptionCreateInput"]: GraphQLTypes["OrderDiscountWithoutVoucherRedemptionCreateInput"];
	["VoucherRedemptionCreateCustomerEntityRelationInput"]: GraphQLTypes["VoucherRedemptionCreateCustomerEntityRelationInput"];
	["CustomerWithoutRedeemedVouchersCreateInput"]: GraphQLTypes["CustomerWithoutRedeemedVouchersCreateInput"];
	["CustomerCreateSpendingEntityRelationInput"]: GraphQLTypes["CustomerCreateSpendingEntityRelationInput"];
	["CustomerCreateCustomerTabsEntityRelationInput"]: GraphQLTypes["CustomerCreateCustomerTabsEntityRelationInput"];
	["CustomerTabWithoutCustomerCreateInput"]: GraphQLTypes["CustomerTabWithoutCustomerCreateInput"];
	["CustomerTabCreateItemsEntityRelationInput"]: GraphQLTypes["CustomerTabCreateItemsEntityRelationInput"];
	["CustomerTabItemWithoutTabCreateInput"]: GraphQLTypes["CustomerTabItemWithoutTabCreateInput"];
	["CustomerTabItemCreateProductEntityRelationInput"]: GraphQLTypes["CustomerTabItemCreateProductEntityRelationInput"];
	["CustomerTabCreateMetaEntityRelationInput"]: GraphQLTypes["CustomerTabCreateMetaEntityRelationInput"];
	["CustomerTabCreateTableEntityRelationInput"]: GraphQLTypes["CustomerTabCreateTableEntityRelationInput"];
	["TableWithoutCustomerTabsCreateInput"]: GraphQLTypes["TableWithoutCustomerTabsCreateInput"];
	["TableCreateAreaEntityRelationInput"]: GraphQLTypes["TableCreateAreaEntityRelationInput"];
	["AreaWithoutTablesCreateInput"]: GraphQLTypes["AreaWithoutTablesCreateInput"];
	["AreaCreateVenueEntityRelationInput"]: GraphQLTypes["AreaCreateVenueEntityRelationInput"];
	["VenueWithoutAreasCreateInput"]: GraphQLTypes["VenueWithoutAreasCreateInput"];
	["VenueCreateEnabledUnassignReasonsEntityRelationInput"]: GraphQLTypes["VenueCreateEnabledUnassignReasonsEntityRelationInput"];
	["UnassignReasonUniqueWhere"]: GraphQLTypes["UnassignReasonUniqueWhere"];
	["UnassignReasonWithoutVenuesCreateInput"]: GraphQLTypes["UnassignReasonWithoutVenuesCreateInput"];
	["VenueCreateCategoriesEntityRelationInput"]: GraphQLTypes["VenueCreateCategoriesEntityRelationInput"];
	["PointOfSaleCategoryWithoutVenueCreateInput"]: GraphQLTypes["PointOfSaleCategoryWithoutVenueCreateInput"];
	["PointOfSaleCategoryCreateCategoryEntityRelationInput"]: GraphQLTypes["PointOfSaleCategoryCreateCategoryEntityRelationInput"];
	["PointOfSaleCategoryCreateTicketPrintersEntityRelationInput"]: GraphQLTypes["PointOfSaleCategoryCreateTicketPrintersEntityRelationInput"];
	["PointOfSalePrinterWithoutTicketCategoriesCreateInput"]: GraphQLTypes["PointOfSalePrinterWithoutTicketCategoriesCreateInput"];
	["PointOfSalePrinterCreateApplicationDevicesTicketEntityRelationInput"]: GraphQLTypes["PointOfSalePrinterCreateApplicationDevicesTicketEntityRelationInput"];
	["PointOfSaleApplicationDeviceWithoutTicketPrintersCreateInput"]: GraphQLTypes["PointOfSaleApplicationDeviceWithoutTicketPrintersCreateInput"];
	["PointOfSaleApplicationDeviceCreateReceiptPrinterEntityRelationInput"]: GraphQLTypes["PointOfSaleApplicationDeviceCreateReceiptPrinterEntityRelationInput"];
	["PointOfSalePrinterWithoutApplicationDevicesReceiptCreateInput"]: GraphQLTypes["PointOfSalePrinterWithoutApplicationDevicesReceiptCreateInput"];
	["PointOfSalePrinterCreateVenueEntityRelationInput"]: GraphQLTypes["PointOfSalePrinterCreateVenueEntityRelationInput"];
	["VenueWithoutPointOfSalePrintersCreateInput"]: GraphQLTypes["VenueWithoutPointOfSalePrintersCreateInput"];
	["VenueCreateAreasEntityRelationInput"]: GraphQLTypes["VenueCreateAreasEntityRelationInput"];
	["AreaWithoutVenueCreateInput"]: GraphQLTypes["AreaWithoutVenueCreateInput"];
	["AreaCreateTablesEntityRelationInput"]: GraphQLTypes["AreaCreateTablesEntityRelationInput"];
	["TableWithoutAreaCreateInput"]: GraphQLTypes["TableWithoutAreaCreateInput"];
	["TableCreateCustomerTabsEntityRelationInput"]: GraphQLTypes["TableCreateCustomerTabsEntityRelationInput"];
	["CustomerTabWithoutTableCreateInput"]: GraphQLTypes["CustomerTabWithoutTableCreateInput"];
	["CustomerTabCreateCustomerEntityRelationInput"]: GraphQLTypes["CustomerTabCreateCustomerEntityRelationInput"];
	["CustomerWithoutCustomerTabsCreateInput"]: GraphQLTypes["CustomerWithoutCustomerTabsCreateInput"];
	["CustomerCreateLeadEntityRelationInput"]: GraphQLTypes["CustomerCreateLeadEntityRelationInput"];
	["PipelineLeadWithoutCustomerCreateInput"]: GraphQLTypes["PipelineLeadWithoutCustomerCreateInput"];
	["PipelineLeadCreateStageItemEntityRelationInput"]: GraphQLTypes["PipelineLeadCreateStageItemEntityRelationInput"];
	["PipelineStageItemWithoutLeadCreateInput"]: GraphQLTypes["PipelineStageItemWithoutLeadCreateInput"];
	["PipelineStageItemCreateListEntityRelationInput"]: GraphQLTypes["PipelineStageItemCreateListEntityRelationInput"];
	["PipelineStageWithoutItemsCreateInput"]: GraphQLTypes["PipelineStageWithoutItemsCreateInput"];
	["PipelineStageCreatePipelineEntityRelationInput"]: GraphQLTypes["PipelineStageCreatePipelineEntityRelationInput"];
	["PipelineUniqueWhere"]: GraphQLTypes["PipelineUniqueWhere"];
	["PipelineWithoutStagesCreateInput"]: GraphQLTypes["PipelineWithoutStagesCreateInput"];
	["PipelineStageCreateLocalesEntityRelationInput"]: GraphQLTypes["PipelineStageCreateLocalesEntityRelationInput"];
	["PipelineStageLocaleWithoutRootCreateInput"]: GraphQLTypes["PipelineStageLocaleWithoutRootCreateInput"];
	["PipelineStageLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["PipelineStageLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutPipelineStagesCreateInput"]: GraphQLTypes["LocaleWithoutPipelineStagesCreateInput"];
	["LocaleCreateSubscriptionBoxesEntityRelationInput"]: GraphQLTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"];
	["SubscriptionBoxLocaleWithoutLocaleCreateInput"]: GraphQLTypes["SubscriptionBoxLocaleWithoutLocaleCreateInput"];
	["SubscriptionBoxLocaleCreateRootEntityRelationInput"]: GraphQLTypes["SubscriptionBoxLocaleCreateRootEntityRelationInput"];
	["SubscriptionBoxWithoutLocalesCreateInput"]: GraphQLTypes["SubscriptionBoxWithoutLocalesCreateInput"];
	["SubscriptionBoxLocaleCreateTextsEntityRelationInput"]: GraphQLTypes["SubscriptionBoxLocaleCreateTextsEntityRelationInput"];
	["SubscriptionBoxLocaleCreateSecondaryTextsEntityRelationInput"]: GraphQLTypes["SubscriptionBoxLocaleCreateSecondaryTextsEntityRelationInput"];
	["LocaleCreateBusinessServicesEntityRelationInput"]: GraphQLTypes["LocaleCreateBusinessServicesEntityRelationInput"];
	["BusinessServiceLocaleWithoutLocaleCreateInput"]: GraphQLTypes["BusinessServiceLocaleWithoutLocaleCreateInput"];
	["BusinessServiceLocaleCreateRootEntityRelationInput"]: GraphQLTypes["BusinessServiceLocaleCreateRootEntityRelationInput"];
	["BusinessServiceWithoutLocalesCreateInput"]: GraphQLTypes["BusinessServiceWithoutLocalesCreateInput"];
	["PipelineStageCreateSentimentEntityRelationInput"]: GraphQLTypes["PipelineStageCreateSentimentEntityRelationInput"];
	["PipelineStageSentimentUniqueWhere"]: GraphQLTypes["PipelineStageSentimentUniqueWhere"];
	["PipelineStageSentimentCreateInput"]: GraphQLTypes["PipelineStageSentimentCreateInput"];
	["PipelineStageCreateFormsEntityRelationInput"]: GraphQLTypes["PipelineStageCreateFormsEntityRelationInput"];
	["LeadFormWithoutStageCreateInput"]: GraphQLTypes["LeadFormWithoutStageCreateInput"];
	["LeadFormCreateLeadsEntityRelationInput"]: GraphQLTypes["LeadFormCreateLeadsEntityRelationInput"];
	["PipelineLeadWithoutFormCreateInput"]: GraphQLTypes["PipelineLeadWithoutFormCreateInput"];
	["PipelineLeadCreateCustomerEntityRelationInput"]: GraphQLTypes["PipelineLeadCreateCustomerEntityRelationInput"];
	["CustomerWithoutLeadCreateInput"]: GraphQLTypes["CustomerWithoutLeadCreateInput"];
	["CustomerCreateMetaEntityRelationInput"]: GraphQLTypes["CustomerCreateMetaEntityRelationInput"];
	["PipelineLeadCreateFormEntityRelationInput"]: GraphQLTypes["PipelineLeadCreateFormEntityRelationInput"];
	["LeadFormWithoutLeadsCreateInput"]: GraphQLTypes["LeadFormWithoutLeadsCreateInput"];
	["LeadFormCreateStageEntityRelationInput"]: GraphQLTypes["LeadFormCreateStageEntityRelationInput"];
	["PipelineStageWithoutFormsCreateInput"]: GraphQLTypes["PipelineStageWithoutFormsCreateInput"];
	["PipelineStageCreateItemsEntityRelationInput"]: GraphQLTypes["PipelineStageCreateItemsEntityRelationInput"];
	["PipelineStageItemWithoutListCreateInput"]: GraphQLTypes["PipelineStageItemWithoutListCreateInput"];
	["PipelineStageItemCreateLeadEntityRelationInput"]: GraphQLTypes["PipelineStageItemCreateLeadEntityRelationInput"];
	["PipelineLeadWithoutStageItemCreateInput"]: GraphQLTypes["PipelineLeadWithoutStageItemCreateInput"];
	["CustomerTabCreateSeatEntityRelationInput"]: GraphQLTypes["CustomerTabCreateSeatEntityRelationInput"];
	["SeatWithoutCustomerTabsCreateInput"]: GraphQLTypes["SeatWithoutCustomerTabsCreateInput"];
	["SeatCreateTableEntityRelationInput"]: GraphQLTypes["SeatCreateTableEntityRelationInput"];
	["TableWithoutSeatsCreateInput"]: GraphQLTypes["TableWithoutSeatsCreateInput"];
	["TableCreateSeatsEntityRelationInput"]: GraphQLTypes["TableCreateSeatsEntityRelationInput"];
	["SeatWithoutTableCreateInput"]: GraphQLTypes["SeatWithoutTableCreateInput"];
	["SeatCreateCustomerTabsEntityRelationInput"]: GraphQLTypes["SeatCreateCustomerTabsEntityRelationInput"];
	["CustomerTabWithoutSeatCreateInput"]: GraphQLTypes["CustomerTabWithoutSeatCreateInput"];
	["AreaCreateLinesEntityRelationInput"]: GraphQLTypes["AreaCreateLinesEntityRelationInput"];
	["LineWithoutAreaCreateInput"]: GraphQLTypes["LineWithoutAreaCreateInput"];
	["VenueCreateChannelsEntityRelationInput"]: GraphQLTypes["VenueCreateChannelsEntityRelationInput"];
	["ChannelWithoutVenueCreateInput"]: GraphQLTypes["ChannelWithoutVenueCreateInput"];
	["PointOfSalePrinterCreateTicketCategoriesEntityRelationInput"]: GraphQLTypes["PointOfSalePrinterCreateTicketCategoriesEntityRelationInput"];
	["PointOfSaleCategoryWithoutTicketPrintersCreateInput"]: GraphQLTypes["PointOfSaleCategoryWithoutTicketPrintersCreateInput"];
	["PointOfSaleCategoryCreateVenueEntityRelationInput"]: GraphQLTypes["PointOfSaleCategoryCreateVenueEntityRelationInput"];
	["VenueWithoutCategoriesCreateInput"]: GraphQLTypes["VenueWithoutCategoriesCreateInput"];
	["VoucherRedemptionCreateVoucherEntityRelationInput"]: GraphQLTypes["VoucherRedemptionCreateVoucherEntityRelationInput"];
	["VoucherWithoutRedemptionCreateInput"]: GraphQLTypes["VoucherWithoutRedemptionCreateInput"];
	["OrderCreateFulfillmentNotesEntityRelationInput"]: GraphQLTypes["OrderCreateFulfillmentNotesEntityRelationInput"];
	["FulfillmentNoteWithoutOrdersCreateInput"]: GraphQLTypes["FulfillmentNoteWithoutOrdersCreateInput"];
	["OrderPaymentCreateVatRateEntityRelationInput"]: GraphQLTypes["OrderPaymentCreateVatRateEntityRelationInput"];
	["OrderPaymentCreateMetaEntityRelationInput"]: GraphQLTypes["OrderPaymentCreateMetaEntityRelationInput"];
	["OrderDeliveryCreateEventsEntityRelationInput"]: GraphQLTypes["OrderDeliveryCreateEventsEntityRelationInput"];
	["OrderEventWithoutDeliveryCreateInput"]: GraphQLTypes["OrderEventWithoutDeliveryCreateInput"];
	["OrderDeliveryCreateLiftagoRideEntityRelationInput"]: GraphQLTypes["OrderDeliveryCreateLiftagoRideEntityRelationInput"];
	["LiftagoRideWithoutDeliveryCreateInput"]: GraphQLTypes["LiftagoRideWithoutDeliveryCreateInput"];
	["OrderDeliveryCreateWoltDriveDeliveryEntityRelationInput"]: GraphQLTypes["OrderDeliveryCreateWoltDriveDeliveryEntityRelationInput"];
	["WoltDriveDeliveryWithoutDeliveryCreateInput"]: GraphQLTypes["WoltDriveDeliveryWithoutDeliveryCreateInput"];
	["AddressCreateDefaultDeliveryAddressOfCustomerEntityRelationInput"]: GraphQLTypes["AddressCreateDefaultDeliveryAddressOfCustomerEntityRelationInput"];
	["CustomerWithoutDefaultDeliveryAddressCreateInput"]: GraphQLTypes["CustomerWithoutDefaultDeliveryAddressCreateInput"];
	["OrderEventCreateDeliveryEntityRelationInput"]: GraphQLTypes["OrderEventCreateDeliveryEntityRelationInput"];
	["OrderDeliveryWithoutEventsCreateInput"]: GraphQLTypes["OrderDeliveryWithoutEventsCreateInput"];
	["OrderDeliveryCreateAddressEntityRelationInput"]: GraphQLTypes["OrderDeliveryCreateAddressEntityRelationInput"];
	["AddressWithoutDeliveryAddressOfOrderDeliveriesCreateInput"]: GraphQLTypes["AddressWithoutDeliveryAddressOfOrderDeliveriesCreateInput"];
	["CartCreateDeliveryAddressEntityRelationInput"]: GraphQLTypes["CartCreateDeliveryAddressEntityRelationInput"];
	["CartCreateBillingAddressEntityRelationInput"]: GraphQLTypes["CartCreateBillingAddressEntityRelationInput"];
	["CartCreateDeliveryEntityRelationInput"]: GraphQLTypes["CartCreateDeliveryEntityRelationInput"];
	["ChannelDeliveryCreateInput"]: GraphQLTypes["ChannelDeliveryCreateInput"];
	["CartCreatePaymentEntityRelationInput"]: GraphQLTypes["CartCreatePaymentEntityRelationInput"];
	["ChannelPaymentCreateInput"]: GraphQLTypes["ChannelPaymentCreateInput"];
	["CartCreateBillingSubjectEntityRelationInput"]: GraphQLTypes["CartCreateBillingSubjectEntityRelationInput"];
	["BillingSubjectCreateInput"]: GraphQLTypes["BillingSubjectCreateInput"];
	["CartCreatePriceLinesEntityRelationInput"]: GraphQLTypes["CartCreatePriceLinesEntityRelationInput"];
	["CartCreateSummaryEntityRelationInput"]: GraphQLTypes["CartCreateSummaryEntityRelationInput"];
	["OrderDiscountCreateVoucherRedemptionEntityRelationInput"]: GraphQLTypes["OrderDiscountCreateVoucherRedemptionEntityRelationInput"];
	["VoucherRedemptionWithoutOrderDiscountCreateInput"]: GraphQLTypes["VoucherRedemptionWithoutOrderDiscountCreateInput"];
	["PointOfSaleApplicationDeviceCreateTicketPrintersEntityRelationInput"]: GraphQLTypes["PointOfSaleApplicationDeviceCreateTicketPrintersEntityRelationInput"];
	["PointOfSalePrinterWithoutApplicationDevicesTicketCreateInput"]: GraphQLTypes["PointOfSalePrinterWithoutApplicationDevicesTicketCreateInput"];
	["LocaleCreatePipelineStagesEntityRelationInput"]: GraphQLTypes["LocaleCreatePipelineStagesEntityRelationInput"];
	["PipelineStageLocaleWithoutLocaleCreateInput"]: GraphQLTypes["PipelineStageLocaleWithoutLocaleCreateInput"];
	["PipelineStageLocaleCreateRootEntityRelationInput"]: GraphQLTypes["PipelineStageLocaleCreateRootEntityRelationInput"];
	["PipelineStageWithoutLocalesCreateInput"]: GraphQLTypes["PipelineStageWithoutLocalesCreateInput"];
	["PointOfSaleCategoryProductCreateLocalesEntityRelationInput"]: GraphQLTypes["PointOfSaleCategoryProductCreateLocalesEntityRelationInput"];
	["PointOfSaleCategoryProductLocaleWithoutRootCreateInput"]: GraphQLTypes["PointOfSaleCategoryProductLocaleWithoutRootCreateInput"];
	["PointOfSaleCategoryProductLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["PointOfSaleCategoryProductLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutPointOfSaleCategoryProductsCreateInput"]: GraphQLTypes["LocaleWithoutPointOfSaleCategoryProductsCreateInput"];
	["ProductRecipeCreateLocalesEntityRelationInput"]: GraphQLTypes["ProductRecipeCreateLocalesEntityRelationInput"];
	["ProductRecipeLocaleWithoutRootCreateInput"]: GraphQLTypes["ProductRecipeLocaleWithoutRootCreateInput"];
	["ProductRecipeLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["ProductRecipeLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutProductRecipesCreateInput"]: GraphQLTypes["LocaleWithoutProductRecipesCreateInput"];
	["TimetableShiftGroupCreateGeneratedByTemplateEntityRelationInput"]: GraphQLTypes["TimetableShiftGroupCreateGeneratedByTemplateEntityRelationInput"];
	["TimetableTemplateCreateInput"]: GraphQLTypes["TimetableTemplateCreateInput"];
	["TimetableShiftCreateQueueItemEntityRelationInput"]: GraphQLTypes["TimetableShiftCreateQueueItemEntityRelationInput"];
	["EmployeeQueueItemWithoutShiftCreateInput"]: GraphQLTypes["EmployeeQueueItemWithoutShiftCreateInput"];
	["EmployeeQueueItemCreateUnassignInfoEntityRelationInput"]: GraphQLTypes["EmployeeQueueItemCreateUnassignInfoEntityRelationInput"];
	["UnassignedShiftInfoWithoutQueueItemCreateInput"]: GraphQLTypes["UnassignedShiftInfoWithoutQueueItemCreateInput"];
	["UnassignedShiftInfoCreateReasonEntityRelationInput"]: GraphQLTypes["UnassignedShiftInfoCreateReasonEntityRelationInput"];
	["UnassignReasonCreateInput"]: GraphQLTypes["UnassignReasonCreateInput"];
	["UnassignReasonCreateVenuesEntityRelationInput"]: GraphQLTypes["UnassignReasonCreateVenuesEntityRelationInput"];
	["VenueWithoutEnabledUnassignReasonsCreateInput"]: GraphQLTypes["VenueWithoutEnabledUnassignReasonsCreateInput"];
	["EmployeeQueueItemCreateMetaEntityRelationInput"]: GraphQLTypes["EmployeeQueueItemCreateMetaEntityRelationInput"];
	["TimetableShiftCreateSwapInfoEntityRelationInput"]: GraphQLTypes["TimetableShiftCreateSwapInfoEntityRelationInput"];
	["TimetableShiftSwapInfoWithoutShiftCreateInput"]: GraphQLTypes["TimetableShiftSwapInfoWithoutShiftCreateInput"];
	["TimetableShiftSwapInfoCreateSwappedShiftsProfileEntityRelationInput"]: GraphQLTypes["TimetableShiftSwapInfoCreateSwappedShiftsProfileEntityRelationInput"];
	["EmployeeQueueItemCreateShiftEntityRelationInput"]: GraphQLTypes["EmployeeQueueItemCreateShiftEntityRelationInput"];
	["TimetableShiftWithoutQueueItemCreateInput"]: GraphQLTypes["TimetableShiftWithoutQueueItemCreateInput"];
	["TimetableDayCreateMetaEntityRelationInput"]: GraphQLTypes["TimetableDayCreateMetaEntityRelationInput"];
	["DeliveryZoneCreateAddressesMetadataEntityRelationInput"]: GraphQLTypes["DeliveryZoneCreateAddressesMetadataEntityRelationInput"];
	["CustomerCreditCreateVoucherRedemptionEntityRelationInput"]: GraphQLTypes["CustomerCreditCreateVoucherRedemptionEntityRelationInput"];
	["VoucherRedemptionWithoutCustomerCreditCreateInput"]: GraphQLTypes["VoucherRedemptionWithoutCustomerCreditCreateInput"];
	["StaffCreateVenuesEntityRelationInput"]: GraphQLTypes["StaffCreateVenuesEntityRelationInput"];
	["VenueWithoutStaffMembersCreateInput"]: GraphQLTypes["VenueWithoutStaffMembersCreateInput"];
	["BusinessCustomerCreateLogoEntityRelationInput"]: GraphQLTypes["BusinessCustomerCreateLogoEntityRelationInput"];
	["BusinessCustomerCreateBusinessServiceEventsEntityRelationInput"]: GraphQLTypes["BusinessCustomerCreateBusinessServiceEventsEntityRelationInput"];
	["BusinessServiceEventWithoutBusinessCustomerCreateInput"]: GraphQLTypes["BusinessServiceEventWithoutBusinessCustomerCreateInput"];
	["BusinessServiceEventCreateBusinessServiceEntityRelationInput"]: GraphQLTypes["BusinessServiceEventCreateBusinessServiceEntityRelationInput"];
	["BusinessServiceCreateInput"]: GraphQLTypes["BusinessServiceCreateInput"];
	["BusinessServiceCreateLocalesEntityRelationInput"]: GraphQLTypes["BusinessServiceCreateLocalesEntityRelationInput"];
	["BusinessServiceLocaleWithoutRootCreateInput"]: GraphQLTypes["BusinessServiceLocaleWithoutRootCreateInput"];
	["BusinessServiceLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["BusinessServiceLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutBusinessServicesCreateInput"]: GraphQLTypes["LocaleWithoutBusinessServicesCreateInput"];
	["BusinessServiceEventCreateCreatedByEntityRelationInput"]: GraphQLTypes["BusinessServiceEventCreateCreatedByEntityRelationInput"];
	["StaffCreateInput"]: GraphQLTypes["StaffCreateInput"];
	["BusinessServiceEventCreateFilledSupervisorEntityRelationInput"]: GraphQLTypes["BusinessServiceEventCreateFilledSupervisorEntityRelationInput"];
	["BusinessCustomerCreateDoubleshotCoffeeEquipmentEntityRelationInput"]: GraphQLTypes["BusinessCustomerCreateDoubleshotCoffeeEquipmentEntityRelationInput"];
	["DoubleshotCoffeeEquipmentCreateInput"]: GraphQLTypes["DoubleshotCoffeeEquipmentCreateInput"];
	["TimetableDayCreateVenueEntityRelationInput"]: GraphQLTypes["TimetableDayCreateVenueEntityRelationInput"];
	["VenueWithoutTimetableDaysCreateInput"]: GraphQLTypes["VenueWithoutTimetableDaysCreateInput"];
	["WorkspaceCreateDiscountVatRateEntityRelationInput"]: GraphQLTypes["WorkspaceCreateDiscountVatRateEntityRelationInput"];
	["ProductIngredientCreateImageEntityRelationInput"]: GraphQLTypes["ProductIngredientCreateImageEntityRelationInput"];
	["ProductIngredientCreateSuppliersEntityRelationInput"]: GraphQLTypes["ProductIngredientCreateSuppliersEntityRelationInput"];
	["IngredientSupplierListCreateInput"]: GraphQLTypes["IngredientSupplierListCreateInput"];
	["IngredientSupplierListCreateItemsEntityRelationInput"]: GraphQLTypes["IngredientSupplierListCreateItemsEntityRelationInput"];
	["IngredientSupplierItemWithoutListCreateInput"]: GraphQLTypes["IngredientSupplierItemWithoutListCreateInput"];
	["IngredientSupplierItemCreateSupplierEntityRelationInput"]: GraphQLTypes["IngredientSupplierItemCreateSupplierEntityRelationInput"];
	["IngredientSupplierCreateInput"]: GraphQLTypes["IngredientSupplierCreateInput"];
	["IngredientSupplierCreateLocalesEntityRelationInput"]: GraphQLTypes["IngredientSupplierCreateLocalesEntityRelationInput"];
	["IngredientSupplierLocaleWithoutRootCreateInput"]: GraphQLTypes["IngredientSupplierLocaleWithoutRootCreateInput"];
	["IngredientSupplierLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["IngredientSupplierLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutIngredientSuppliersCreateInput"]: GraphQLTypes["LocaleWithoutIngredientSuppliersCreateInput"];
	["BusinessCategoryCreateSpecificProductsEntityRelationInput"]: GraphQLTypes["BusinessCategoryCreateSpecificProductsEntityRelationInput"];
	["ProductListWithoutBusinessCategoryCreateInput"]: GraphQLTypes["ProductListWithoutBusinessCategoryCreateInput"];
	["ProductListCreateItemsEntityRelationInput"]: GraphQLTypes["ProductListCreateItemsEntityRelationInput"];
	["ProductListItemWithoutListCreateInput"]: GraphQLTypes["ProductListItemWithoutListCreateInput"];
	["ProductListItemCreateProductEntityRelationInput"]: GraphQLTypes["ProductListItemCreateProductEntityRelationInput"];
	["BusinessCategoryCreateSeasonalProductCategoriesEntityRelationInput"]: GraphQLTypes["BusinessCategoryCreateSeasonalProductCategoriesEntityRelationInput"];
	["ProductCategoryListWithoutSeasonalProductCategoriesOfBusinessCategoryCreateInput"]: GraphQLTypes["ProductCategoryListWithoutSeasonalProductCategoriesOfBusinessCategoryCreateInput"];
	["ProductCategoryListCreateLocalesEntityRelationInput"]: GraphQLTypes["ProductCategoryListCreateLocalesEntityRelationInput"];
	["ProductCategoryListLocaleWithoutRootCreateInput"]: GraphQLTypes["ProductCategoryListLocaleWithoutRootCreateInput"];
	["ProductCategoryListLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["ProductCategoryListLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutProductCategoryListsCreateInput"]: GraphQLTypes["LocaleWithoutProductCategoryListsCreateInput"];
	["ProductCategoryListCreateSpecificProductsProductCategoriesOfBusinessCategoryEntityRelationInput"]: GraphQLTypes["ProductCategoryListCreateSpecificProductsProductCategoriesOfBusinessCategoryEntityRelationInput"];
	["BusinessCategoryWithoutSpecificProductsProductCategoriesCreateInput"]: GraphQLTypes["BusinessCategoryWithoutSpecificProductsProductCategoriesCreateInput"];
	["BusinessCategoryCreateSpecificProductsProductCategoriesEntityRelationInput"]: GraphQLTypes["BusinessCategoryCreateSpecificProductsProductCategoriesEntityRelationInput"];
	["ProductCategoryListWithoutSpecificProductsProductCategoriesOfBusinessCategoryCreateInput"]: GraphQLTypes["ProductCategoryListWithoutSpecificProductsProductCategoriesOfBusinessCategoryCreateInput"];
	["ProductCategoryListCreateSeasonalProductCategoriesOfBusinessCategoryEntityRelationInput"]: GraphQLTypes["ProductCategoryListCreateSeasonalProductCategoriesOfBusinessCategoryEntityRelationInput"];
	["BusinessCategoryWithoutSeasonalProductCategoriesCreateInput"]: GraphQLTypes["BusinessCategoryWithoutSeasonalProductCategoriesCreateInput"];
	["LinkableCreateRedirectEntityRelationInput"]: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"];
	["RedirectWithoutLinkCreateInput"]: GraphQLTypes["RedirectWithoutLinkCreateInput"];
	["RedirectCreateTargetEntityRelationInput"]: GraphQLTypes["RedirectCreateTargetEntityRelationInput"];
	["WikiPageCreateContentEntityRelationInput"]: GraphQLTypes["WikiPageCreateContentEntityRelationInput"];
	["WikiPageCreateChildrenEntityRelationInput"]: GraphQLTypes["WikiPageCreateChildrenEntityRelationInput"];
	["WikiPageWithoutParentCreateInput"]: GraphQLTypes["WikiPageWithoutParentCreateInput"];
	["BlogPostLocaleCreateSeoEntityRelationInput"]: GraphQLTypes["BlogPostLocaleCreateSeoEntityRelationInput"];
	["BlogPostLocaleCreateProductsEntityRelationInput"]: GraphQLTypes["BlogPostLocaleCreateProductsEntityRelationInput"];
	["ContentReferenceCreateBlogPostsEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateBlogPostsEntityRelationInput"];
	["BlogPostListUniqueWhere"]: GraphQLTypes["BlogPostListUniqueWhere"];
	["BlogPostListItemUniqueWhere"]: GraphQLTypes["BlogPostListItemUniqueWhere"];
	["BlogPostListCreateInput"]: GraphQLTypes["BlogPostListCreateInput"];
	["BlogPostListCreateItemsEntityRelationInput"]: GraphQLTypes["BlogPostListCreateItemsEntityRelationInput"];
	["BlogPostListItemWithoutListCreateInput"]: GraphQLTypes["BlogPostListItemWithoutListCreateInput"];
	["BlogPostListItemCreateBlogPostEntityRelationInput"]: GraphQLTypes["BlogPostListItemCreateBlogPostEntityRelationInput"];
	["BlogPostLocaleCreateInput"]: GraphQLTypes["BlogPostLocaleCreateInput"];
	["BlogPostLocaleCreateLinkEntityRelationInput"]: GraphQLTypes["BlogPostLocaleCreateLinkEntityRelationInput"];
	["LinkableWithoutBlogPostCreateInput"]: GraphQLTypes["LinkableWithoutBlogPostCreateInput"];
	["ContentReferenceCreateLinksEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateLinksEntityRelationInput"];
	["ContentReferenceCreateProductsEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateProductsEntityRelationInput"];
	["ProductListCreateInput"]: GraphQLTypes["ProductListCreateInput"];
	["ProductListCreateBusinessCategoryEntityRelationInput"]: GraphQLTypes["ProductListCreateBusinessCategoryEntityRelationInput"];
	["BusinessCategoryWithoutSpecificProductsCreateInput"]: GraphQLTypes["BusinessCategoryWithoutSpecificProductsCreateInput"];
	["ContentReferenceCreateHeroEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateHeroEntityRelationInput"];
	["HeroUniqueWhere"]: GraphQLTypes["HeroUniqueWhere"];
	["HeroCreateInput"]: GraphQLTypes["HeroCreateInput"];
	["HeroCreateMediumEntityRelationInput"]: GraphQLTypes["HeroCreateMediumEntityRelationInput"];
	["ContentReferenceCreateGalleryEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateGalleryEntityRelationInput"];
	["GalleryUniqueWhere"]: GraphQLTypes["GalleryUniqueWhere"];
	["GalleryItemUniqueWhere"]: GraphQLTypes["GalleryItemUniqueWhere"];
	["GalleryCreateInput"]: GraphQLTypes["GalleryCreateInput"];
	["GalleryCreateItemsEntityRelationInput"]: GraphQLTypes["GalleryCreateItemsEntityRelationInput"];
	["GalleryItemWithoutListCreateInput"]: GraphQLTypes["GalleryItemWithoutListCreateInput"];
	["GalleryItemCreateMediumEntityRelationInput"]: GraphQLTypes["GalleryItemCreateMediumEntityRelationInput"];
	["ContentReferenceCreateSocialsAndAppsEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateSocialsAndAppsEntityRelationInput"];
	["ContentReferenceCreateProductGridEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateProductGridEntityRelationInput"];
	["ProductGridUniqueWhere"]: GraphQLTypes["ProductGridUniqueWhere"];
	["ProductGridCategoryUniqueWhere"]: GraphQLTypes["ProductGridCategoryUniqueWhere"];
	["ProductGridCreateInput"]: GraphQLTypes["ProductGridCreateInput"];
	["ProductGridCreateCategoriesEntityRelationInput"]: GraphQLTypes["ProductGridCreateCategoriesEntityRelationInput"];
	["ProductGridCategoryWithoutRootCreateInput"]: GraphQLTypes["ProductGridCategoryWithoutRootCreateInput"];
	["ProductGridCategoryCreateItemsEntityRelationInput"]: GraphQLTypes["ProductGridCategoryCreateItemsEntityRelationInput"];
	["ProductGridItemWithoutCategoryCreateInput"]: GraphQLTypes["ProductGridItemWithoutCategoryCreateInput"];
	["ProductGridItemCreateProductEntityRelationInput"]: GraphQLTypes["ProductGridItemCreateProductEntityRelationInput"];
	["ProductGridItemCreateMediumEntityRelationInput"]: GraphQLTypes["ProductGridItemCreateMediumEntityRelationInput"];
	["ProductGridItemCreateLinkEntityRelationInput"]: GraphQLTypes["ProductGridItemCreateLinkEntityRelationInput"];
	["ProductGridCategoryCreateImagesEntityRelationInput"]: GraphQLTypes["ProductGridCategoryCreateImagesEntityRelationInput"];
	["ContentReferenceCreateProductBannersEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateProductBannersEntityRelationInput"];
	["ProductBannerListCreateInput"]: GraphQLTypes["ProductBannerListCreateInput"];
	["ProductBannerListCreateItemsEntityRelationInput"]: GraphQLTypes["ProductBannerListCreateItemsEntityRelationInput"];
	["ProductBannerItemWithoutListCreateInput"]: GraphQLTypes["ProductBannerItemWithoutListCreateInput"];
	["ProductBannerItemCreateBannerEntityRelationInput"]: GraphQLTypes["ProductBannerItemCreateBannerEntityRelationInput"];
	["ProductBannerUniqueWhere"]: GraphQLTypes["ProductBannerUniqueWhere"];
	["ProductBannerCreateInput"]: GraphQLTypes["ProductBannerCreateInput"];
	["ProductBannerCreateButtonEntityRelationInput"]: GraphQLTypes["ProductBannerCreateButtonEntityRelationInput"];
	["ProductBannerCreateBackgroundImageEntityRelationInput"]: GraphQLTypes["ProductBannerCreateBackgroundImageEntityRelationInput"];
	["ProductBannerCreateProductImageEntityRelationInput"]: GraphQLTypes["ProductBannerCreateProductImageEntityRelationInput"];
	["ProductBannerCreateProductEntityRelationInput"]: GraphQLTypes["ProductBannerCreateProductEntityRelationInput"];
	["ContentReferenceCreateDeliveryRegionsEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateDeliveryRegionsEntityRelationInput"];
	["ContentReferenceCreateTextListEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateTextListEntityRelationInput"];
	["ContentReferenceCreateGridTilesEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateGridTilesEntityRelationInput"];
	["GridTilesUniqueWhere"]: GraphQLTypes["GridTilesUniqueWhere"];
	["GridTileItemUniqueWhere"]: GraphQLTypes["GridTileItemUniqueWhere"];
	["GridTilesCreateInput"]: GraphQLTypes["GridTilesCreateInput"];
	["GridTilesCreateItemsEntityRelationInput"]: GraphQLTypes["GridTilesCreateItemsEntityRelationInput"];
	["GridTileItemWithoutListCreateInput"]: GraphQLTypes["GridTileItemWithoutListCreateInput"];
	["GridTileItemCreateMediumEntityRelationInput"]: GraphQLTypes["GridTileItemCreateMediumEntityRelationInput"];
	["GridTileItemCreateLinkEntityRelationInput"]: GraphQLTypes["GridTileItemCreateLinkEntityRelationInput"];
	["CartItemCreateFulfillmentNotesEntityRelationInput"]: GraphQLTypes["CartItemCreateFulfillmentNotesEntityRelationInput"];
	["FulfillmentNoteWithoutCartItemsCreateInput"]: GraphQLTypes["FulfillmentNoteWithoutCartItemsCreateInput"];
	["ProductIngredientItemCreateQuantityEntityRelationInput"]: GraphQLTypes["ProductIngredientItemCreateQuantityEntityRelationInput"];
	["ProductIngredientItemQuantityCreateInput"]: GraphQLTypes["ProductIngredientItemQuantityCreateInput"];
	["ProductIngredientItemQuantityCreateUnitEntityRelationInput"]: GraphQLTypes["ProductIngredientItemQuantityCreateUnitEntityRelationInput"];
	["AddressUpdateInput"]: GraphQLTypes["AddressUpdateInput"];
	["AddressUpdateCustomerEntityRelationInput"]: GraphQLTypes["AddressUpdateCustomerEntityRelationInput"];
	["CustomerWithoutAddressesUpdateInput"]: GraphQLTypes["CustomerWithoutAddressesUpdateInput"];
	["CustomerUpdateDefaultBillingAddressEntityRelationInput"]: GraphQLTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"];
	["CustomerUpsertDefaultBillingAddressRelationInput"]: GraphQLTypes["CustomerUpsertDefaultBillingAddressRelationInput"];
	["CustomerUpdateDefaultPaymentMethodEntityRelationInput"]: GraphQLTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"];
	["CustomerPaymentMethodUpdateInput"]: GraphQLTypes["CustomerPaymentMethodUpdateInput"];
	["CustomerPaymentMethodUpdateCustomerEntityRelationInput"]: GraphQLTypes["CustomerPaymentMethodUpdateCustomerEntityRelationInput"];
	["CustomerWithoutPaymentMethodsUpdateInput"]: GraphQLTypes["CustomerWithoutPaymentMethodsUpdateInput"];
	["CustomerUpdateAddressesEntityRelationInput"]: GraphQLTypes["CustomerUpdateAddressesEntityRelationInput"];
	["CustomerUpdateAddressesRelationInput"]: GraphQLTypes["CustomerUpdateAddressesRelationInput"];
	["AddressWithoutCustomerUpdateInput"]: GraphQLTypes["AddressWithoutCustomerUpdateInput"];
	["AddressUpdateCountryEntityRelationInput"]: GraphQLTypes["AddressUpdateCountryEntityRelationInput"];
	["CountryUpdateInput"]: GraphQLTypes["CountryUpdateInput"];
	["AddressUpsertCountryRelationInput"]: GraphQLTypes["AddressUpsertCountryRelationInput"];
	["AddressUpdateDeliveryZoneEntityRelationInput"]: GraphQLTypes["AddressUpdateDeliveryZoneEntityRelationInput"];
	["DeliveryZoneWithoutAddressesUpdateInput"]: GraphQLTypes["DeliveryZoneWithoutAddressesUpdateInput"];
	["DeliveryZoneUpdateSuitableDeliveryMethodsEntityRelationInput"]: GraphQLTypes["DeliveryZoneUpdateSuitableDeliveryMethodsEntityRelationInput"];
	["DeliveryZoneUpdateSuitableDeliveryMethodsRelationInput"]: GraphQLTypes["DeliveryZoneUpdateSuitableDeliveryMethodsRelationInput"];
	["DeliveryMethodWithoutSuitableForDeliveryZonesUpdateInput"]: GraphQLTypes["DeliveryMethodWithoutSuitableForDeliveryZonesUpdateInput"];
	["DeliveryMethodUpdatePaymentMethodsEntityRelationInput"]: GraphQLTypes["DeliveryMethodUpdatePaymentMethodsEntityRelationInput"];
	["DeliveryMethodUpdatePaymentMethodsRelationInput"]: GraphQLTypes["DeliveryMethodUpdatePaymentMethodsRelationInput"];
	["PaymentMethodWithoutDeliveryMethodsUpdateInput"]: GraphQLTypes["PaymentMethodWithoutDeliveryMethodsUpdateInput"];
	["PaymentMethodUpdateChannelsEntityRelationInput"]: GraphQLTypes["PaymentMethodUpdateChannelsEntityRelationInput"];
	["PaymentMethodUpdateChannelsRelationInput"]: GraphQLTypes["PaymentMethodUpdateChannelsRelationInput"];
	["ChannelPaymentWithoutMethodUpdateInput"]: GraphQLTypes["ChannelPaymentWithoutMethodUpdateInput"];
	["ChannelPaymentUpdateChannelEntityRelationInput"]: GraphQLTypes["ChannelPaymentUpdateChannelEntityRelationInput"];
	["ChannelWithoutPaymentsUpdateInput"]: GraphQLTypes["ChannelWithoutPaymentsUpdateInput"];
	["ChannelUpdateDeliveriesEntityRelationInput"]: GraphQLTypes["ChannelUpdateDeliveriesEntityRelationInput"];
	["ChannelUpdateDeliveriesRelationInput"]: GraphQLTypes["ChannelUpdateDeliveriesRelationInput"];
	["ChannelDeliveryWithoutChannelUpdateInput"]: GraphQLTypes["ChannelDeliveryWithoutChannelUpdateInput"];
	["ChannelDeliveryUpdateMethodEntityRelationInput"]: GraphQLTypes["ChannelDeliveryUpdateMethodEntityRelationInput"];
	["DeliveryMethodWithoutChannelsUpdateInput"]: GraphQLTypes["DeliveryMethodWithoutChannelsUpdateInput"];
	["DeliveryMethodUpdateSuitableForDeliveryZonesEntityRelationInput"]: GraphQLTypes["DeliveryMethodUpdateSuitableForDeliveryZonesEntityRelationInput"];
	["DeliveryMethodUpdateSuitableForDeliveryZonesRelationInput"]: GraphQLTypes["DeliveryMethodUpdateSuitableForDeliveryZonesRelationInput"];
	["DeliveryZoneWithoutSuitableDeliveryMethodsUpdateInput"]: GraphQLTypes["DeliveryZoneWithoutSuitableDeliveryMethodsUpdateInput"];
	["DeliveryZoneUpdateAddressesEntityRelationInput"]: GraphQLTypes["DeliveryZoneUpdateAddressesEntityRelationInput"];
	["DeliveryZoneUpdateAddressesRelationInput"]: GraphQLTypes["DeliveryZoneUpdateAddressesRelationInput"];
	["AddressWithoutDeliveryZoneUpdateInput"]: GraphQLTypes["AddressWithoutDeliveryZoneUpdateInput"];
	["AddressUpdateMetaEntityRelationInput"]: GraphQLTypes["AddressUpdateMetaEntityRelationInput"];
	["AddressUpdateGpsEntityRelationInput"]: GraphQLTypes["AddressUpdateGpsEntityRelationInput"];
	["GpsWithoutAddressUpdateInput"]: GraphQLTypes["GpsWithoutAddressUpdateInput"];
	["AddressUpsertGpsRelationInput"]: GraphQLTypes["AddressUpsertGpsRelationInput"];
	["AddressUpdateInvoicesEntityRelationInput"]: GraphQLTypes["AddressUpdateInvoicesEntityRelationInput"];
	["AddressUpdateInvoicesRelationInput"]: GraphQLTypes["AddressUpdateInvoicesRelationInput"];
	["InvoiceWithoutAddressUpdateInput"]: GraphQLTypes["InvoiceWithoutAddressUpdateInput"];
	["InvoiceUpdateCustomerEntityRelationInput"]: GraphQLTypes["InvoiceUpdateCustomerEntityRelationInput"];
	["CustomerWithoutInvoicesUpdateInput"]: GraphQLTypes["CustomerWithoutInvoicesUpdateInput"];
	["CustomerUpdateTagsEntityRelationInput"]: GraphQLTypes["CustomerUpdateTagsEntityRelationInput"];
	["CustomerUpdateTagsRelationInput"]: GraphQLTypes["CustomerUpdateTagsRelationInput"];
	["TagWithoutCustomersUpdateInput"]: GraphQLTypes["TagWithoutCustomersUpdateInput"];
	["TagUpdateProductsEntityRelationInput"]: GraphQLTypes["TagUpdateProductsEntityRelationInput"];
	["TagUpdateProductsRelationInput"]: GraphQLTypes["TagUpdateProductsRelationInput"];
	["ProductWithoutTagsUpdateInput"]: GraphQLTypes["ProductWithoutTagsUpdateInput"];
	["ProductUpdatePackingEntityRelationInput"]: GraphQLTypes["ProductUpdatePackingEntityRelationInput"];
	["ProductPackingUpdateInput"]: GraphQLTypes["ProductPackingUpdateInput"];
	["ProductPackingUpdateImageEntityRelationInput"]: GraphQLTypes["ProductPackingUpdateImageEntityRelationInput"];
	["ImageUpdateInput"]: GraphQLTypes["ImageUpdateInput"];
	["ProductPackingUpsertImageRelationInput"]: GraphQLTypes["ProductPackingUpsertImageRelationInput"];
	["ProductPackingUpdateIconEntityRelationInput"]: GraphQLTypes["ProductPackingUpdateIconEntityRelationInput"];
	["ProductPackingUpsertIconRelationInput"]: GraphQLTypes["ProductPackingUpsertIconRelationInput"];
	["ProductPackingUpdateLocalesEntityRelationInput"]: GraphQLTypes["ProductPackingUpdateLocalesEntityRelationInput"];
	["ProductPackingUpdateLocalesRelationInput"]: GraphQLTypes["ProductPackingUpdateLocalesRelationInput"];
	["ProductPackingLocaleWithoutRootUpdateInput"]: GraphQLTypes["ProductPackingLocaleWithoutRootUpdateInput"];
	["ProductPackingLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["ProductPackingLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutProductPackingsUpdateInput"]: GraphQLTypes["LocaleWithoutProductPackingsUpdateInput"];
	["LocaleUpdateBusinessCategoriesEntityRelationInput"]: GraphQLTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"];
	["LocaleUpdateBusinessCategoriesRelationInput"]: GraphQLTypes["LocaleUpdateBusinessCategoriesRelationInput"];
	["BusinessCategoryLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["BusinessCategoryLocaleWithoutLocaleUpdateInput"];
	["BusinessCategoryLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["BusinessCategoryLocaleUpdateRootEntityRelationInput"];
	["BusinessCategoryWithoutLocalesUpdateInput"]: GraphQLTypes["BusinessCategoryWithoutLocalesUpdateInput"];
	["BusinessCategoryUpdateBusinessCustomersEntityRelationInput"]: GraphQLTypes["BusinessCategoryUpdateBusinessCustomersEntityRelationInput"];
	["BusinessCategoryUpdateBusinessCustomersRelationInput"]: GraphQLTypes["BusinessCategoryUpdateBusinessCustomersRelationInput"];
	["BusinessCustomerWithoutCategoryUpdateInput"]: GraphQLTypes["BusinessCustomerWithoutCategoryUpdateInput"];
	["BusinessCustomerUpdateCustomerEntityRelationInput"]: GraphQLTypes["BusinessCustomerUpdateCustomerEntityRelationInput"];
	["CustomerWithoutBusinessUpdateInput"]: GraphQLTypes["CustomerWithoutBusinessUpdateInput"];
	["CustomerUpdateCreditsEntityRelationInput"]: GraphQLTypes["CustomerUpdateCreditsEntityRelationInput"];
	["CustomerUpdateCreditsRelationInput"]: GraphQLTypes["CustomerUpdateCreditsRelationInput"];
	["CustomerCreditWithoutCustomerUpdateInput"]: GraphQLTypes["CustomerCreditWithoutCustomerUpdateInput"];
	["CustomerCreditUpdateVatRateEntityRelationInput"]: GraphQLTypes["CustomerCreditUpdateVatRateEntityRelationInput"];
	["VatRateUpdateInput"]: GraphQLTypes["VatRateUpdateInput"];
	["VatRateUpdateChannelDeliveriesEntityRelationInput"]: GraphQLTypes["VatRateUpdateChannelDeliveriesEntityRelationInput"];
	["VatRateUpdateChannelDeliveriesRelationInput"]: GraphQLTypes["VatRateUpdateChannelDeliveriesRelationInput"];
	["ChannelDeliveryWithoutVatRateUpdateInput"]: GraphQLTypes["ChannelDeliveryWithoutVatRateUpdateInput"];
	["ChannelDeliveryUpdateChannelEntityRelationInput"]: GraphQLTypes["ChannelDeliveryUpdateChannelEntityRelationInput"];
	["ChannelWithoutDeliveriesUpdateInput"]: GraphQLTypes["ChannelWithoutDeliveriesUpdateInput"];
	["ChannelUpdatePaymentsEntityRelationInput"]: GraphQLTypes["ChannelUpdatePaymentsEntityRelationInput"];
	["ChannelUpdatePaymentsRelationInput"]: GraphQLTypes["ChannelUpdatePaymentsRelationInput"];
	["ChannelPaymentWithoutChannelUpdateInput"]: GraphQLTypes["ChannelPaymentWithoutChannelUpdateInput"];
	["ChannelPaymentUpdateMethodEntityRelationInput"]: GraphQLTypes["ChannelPaymentUpdateMethodEntityRelationInput"];
	["PaymentMethodWithoutChannelsUpdateInput"]: GraphQLTypes["PaymentMethodWithoutChannelsUpdateInput"];
	["PaymentMethodUpdateDeliveryMethodsEntityRelationInput"]: GraphQLTypes["PaymentMethodUpdateDeliveryMethodsEntityRelationInput"];
	["PaymentMethodUpdateDeliveryMethodsRelationInput"]: GraphQLTypes["PaymentMethodUpdateDeliveryMethodsRelationInput"];
	["DeliveryMethodWithoutPaymentMethodsUpdateInput"]: GraphQLTypes["DeliveryMethodWithoutPaymentMethodsUpdateInput"];
	["DeliveryMethodUpdateChannelsEntityRelationInput"]: GraphQLTypes["DeliveryMethodUpdateChannelsEntityRelationInput"];
	["DeliveryMethodUpdateChannelsRelationInput"]: GraphQLTypes["DeliveryMethodUpdateChannelsRelationInput"];
	["ChannelDeliveryWithoutMethodUpdateInput"]: GraphQLTypes["ChannelDeliveryWithoutMethodUpdateInput"];
	["ChannelDeliveryUpdateVatRateEntityRelationInput"]: GraphQLTypes["ChannelDeliveryUpdateVatRateEntityRelationInput"];
	["VatRateWithoutChannelDeliveriesUpdateInput"]: GraphQLTypes["VatRateWithoutChannelDeliveriesUpdateInput"];
	["VatRateUpdateChannelPaymentsEntityRelationInput"]: GraphQLTypes["VatRateUpdateChannelPaymentsEntityRelationInput"];
	["VatRateUpdateChannelPaymentsRelationInput"]: GraphQLTypes["VatRateUpdateChannelPaymentsRelationInput"];
	["ChannelPaymentWithoutVatRateUpdateInput"]: GraphQLTypes["ChannelPaymentWithoutVatRateUpdateInput"];
	["ChannelPaymentUpdateAllowOnlyForTagsEntityRelationInput"]: GraphQLTypes["ChannelPaymentUpdateAllowOnlyForTagsEntityRelationInput"];
	["ChannelPaymentUpdateAllowOnlyForTagsRelationInput"]: GraphQLTypes["ChannelPaymentUpdateAllowOnlyForTagsRelationInput"];
	["TagWithoutAllowChannelPaymentsUpdateInput"]: GraphQLTypes["TagWithoutAllowChannelPaymentsUpdateInput"];
	["TagUpdateCustomersEntityRelationInput"]: GraphQLTypes["TagUpdateCustomersEntityRelationInput"];
	["TagUpdateCustomersRelationInput"]: GraphQLTypes["TagUpdateCustomersRelationInput"];
	["CustomerWithoutTagsUpdateInput"]: GraphQLTypes["CustomerWithoutTagsUpdateInput"];
	["CustomerUpdatePaymentMethodsEntityRelationInput"]: GraphQLTypes["CustomerUpdatePaymentMethodsEntityRelationInput"];
	["CustomerUpdatePaymentMethodsRelationInput"]: GraphQLTypes["CustomerUpdatePaymentMethodsRelationInput"];
	["CustomerPaymentMethodWithoutCustomerUpdateInput"]: GraphQLTypes["CustomerPaymentMethodWithoutCustomerUpdateInput"];
	["CustomerPaymentMethodUpdatePaymentMethodEntityRelationInput"]: GraphQLTypes["CustomerPaymentMethodUpdatePaymentMethodEntityRelationInput"];
	["PaymentMethodUpdateInput"]: GraphQLTypes["PaymentMethodUpdateInput"];
	["CustomerPaymentMethodUpsertPaymentMethodRelationInput"]: GraphQLTypes["CustomerPaymentMethodUpsertPaymentMethodRelationInput"];
	["CustomerUpsertPaymentMethodsRelationInput"]: GraphQLTypes["CustomerUpsertPaymentMethodsRelationInput"];
	["CustomerUpdateOrdersEntityRelationInput"]: GraphQLTypes["CustomerUpdateOrdersEntityRelationInput"];
	["CustomerUpdateOrdersRelationInput"]: GraphQLTypes["CustomerUpdateOrdersRelationInput"];
	["OrderWithoutCustomerUpdateInput"]: GraphQLTypes["OrderWithoutCustomerUpdateInput"];
	["OrderUpdateChannelEntityRelationInput"]: GraphQLTypes["OrderUpdateChannelEntityRelationInput"];
	["ChannelUpdateInput"]: GraphQLTypes["ChannelUpdateInput"];
	["ChannelUpdatePointOfSalesEntityRelationInput"]: GraphQLTypes["ChannelUpdatePointOfSalesEntityRelationInput"];
	["ChannelUpdatePointOfSalesRelationInput"]: GraphQLTypes["ChannelUpdatePointOfSalesRelationInput"];
	["PointOfSaleWithoutChannelsUpdateInput"]: GraphQLTypes["PointOfSaleWithoutChannelsUpdateInput"];
	["PointOfSaleUpdatePermissionsEntityRelationInput"]: GraphQLTypes["PointOfSaleUpdatePermissionsEntityRelationInput"];
	["ChannelUpsertPointOfSalesRelationInput"]: GraphQLTypes["ChannelUpsertPointOfSalesRelationInput"];
	["ChannelUpdateCartsEntityRelationInput"]: GraphQLTypes["ChannelUpdateCartsEntityRelationInput"];
	["ChannelUpdateCartsRelationInput"]: GraphQLTypes["ChannelUpdateCartsRelationInput"];
	["CartWithoutChannelUpdateInput"]: GraphQLTypes["CartWithoutChannelUpdateInput"];
	["CartUpdateItemsEntityRelationInput"]: GraphQLTypes["CartUpdateItemsEntityRelationInput"];
	["CartUpdateItemsRelationInput"]: GraphQLTypes["CartUpdateItemsRelationInput"];
	["CartItemWithoutCartUpdateInput"]: GraphQLTypes["CartItemWithoutCartUpdateInput"];
	["CartItemUpdateProductEntityRelationInput"]: GraphQLTypes["CartItemUpdateProductEntityRelationInput"];
	["ProductWithoutCartItemsUpdateInput"]: GraphQLTypes["ProductWithoutCartItemsUpdateInput"];
	["ProductUpdateRecipeEntityRelationInput"]: GraphQLTypes["ProductUpdateRecipeEntityRelationInput"];
	["ProductRecipeWithoutProductsUpdateInput"]: GraphQLTypes["ProductRecipeWithoutProductsUpdateInput"];
	["ProductRecipeUpdateImageEntityRelationInput"]: GraphQLTypes["ProductRecipeUpdateImageEntityRelationInput"];
	["ProductRecipeUpsertImageRelationInput"]: GraphQLTypes["ProductRecipeUpsertImageRelationInput"];
	["ProductRecipeUpdateIconEntityRelationInput"]: GraphQLTypes["ProductRecipeUpdateIconEntityRelationInput"];
	["ProductRecipeUpsertIconRelationInput"]: GraphQLTypes["ProductRecipeUpsertIconRelationInput"];
	["ProductRecipeUpdateIngredientsEntityRelationInput"]: GraphQLTypes["ProductRecipeUpdateIngredientsEntityRelationInput"];
	["ProductRecipeUpdateIngredientsRelationInput"]: GraphQLTypes["ProductRecipeUpdateIngredientsRelationInput"];
	["ProductIngredientItemWithoutRecipeUpdateInput"]: GraphQLTypes["ProductIngredientItemWithoutRecipeUpdateInput"];
	["ProductIngredientItemUpdateIngredientEntityRelationInput"]: GraphQLTypes["ProductIngredientItemUpdateIngredientEntityRelationInput"];
	["ProductIngredientUpdateInput"]: GraphQLTypes["ProductIngredientUpdateInput"];
	["ProductIngredientUpdateLocalesEntityRelationInput"]: GraphQLTypes["ProductIngredientUpdateLocalesEntityRelationInput"];
	["ProductIngredientUpdateLocalesRelationInput"]: GraphQLTypes["ProductIngredientUpdateLocalesRelationInput"];
	["ProductIngredientLocaleWithoutRootUpdateInput"]: GraphQLTypes["ProductIngredientLocaleWithoutRootUpdateInput"];
	["ProductIngredientLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["ProductIngredientLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutProductIngredientsUpdateInput"]: GraphQLTypes["LocaleWithoutProductIngredientsUpdateInput"];
	["LocaleUpdateProductCategoryListsEntityRelationInput"]: GraphQLTypes["LocaleUpdateProductCategoryListsEntityRelationInput"];
	["LocaleUpdateProductCategoryListsRelationInput"]: GraphQLTypes["LocaleUpdateProductCategoryListsRelationInput"];
	["ProductCategoryListLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["ProductCategoryListLocaleWithoutLocaleUpdateInput"];
	["ProductCategoryListLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["ProductCategoryListLocaleUpdateRootEntityRelationInput"];
	["ProductCategoryListWithoutLocalesUpdateInput"]: GraphQLTypes["ProductCategoryListWithoutLocalesUpdateInput"];
	["ProductCategoryListUpdateItemsEntityRelationInput"]: GraphQLTypes["ProductCategoryListUpdateItemsEntityRelationInput"];
	["ProductCategoryListUpdateItemsRelationInput"]: GraphQLTypes["ProductCategoryListUpdateItemsRelationInput"];
	["ProductCategoryListItemWithoutListUpdateInput"]: GraphQLTypes["ProductCategoryListItemWithoutListUpdateInput"];
	["ProductCategoryListItemUpdateProductCategoryEntityRelationInput"]: GraphQLTypes["ProductCategoryListItemUpdateProductCategoryEntityRelationInput"];
	["ProductCategoryUpdateInput"]: GraphQLTypes["ProductCategoryUpdateInput"];
	["ProductCategoryUpdateProductsEntityRelationInput"]: GraphQLTypes["ProductCategoryUpdateProductsEntityRelationInput"];
	["ProductCategoryUpdateProductsRelationInput"]: GraphQLTypes["ProductCategoryUpdateProductsRelationInput"];
	["ProductWithoutCategoriesUpdateInput"]: GraphQLTypes["ProductWithoutCategoriesUpdateInput"];
	["ProductUpdateTagsEntityRelationInput"]: GraphQLTypes["ProductUpdateTagsEntityRelationInput"];
	["ProductUpdateTagsRelationInput"]: GraphQLTypes["ProductUpdateTagsRelationInput"];
	["TagWithoutProductsUpdateInput"]: GraphQLTypes["TagWithoutProductsUpdateInput"];
	["TagUpdateCategoriesEntityRelationInput"]: GraphQLTypes["TagUpdateCategoriesEntityRelationInput"];
	["TagUpdateCategoriesRelationInput"]: GraphQLTypes["TagUpdateCategoriesRelationInput"];
	["ProductCategoryWithoutTagsUpdateInput"]: GraphQLTypes["ProductCategoryWithoutTagsUpdateInput"];
	["ProductCategoryUpdateParentEntityRelationInput"]: GraphQLTypes["ProductCategoryUpdateParentEntityRelationInput"];
	["ProductCategoryWithoutChildrenUpdateInput"]: GraphQLTypes["ProductCategoryWithoutChildrenUpdateInput"];
	["ProductCategoryUpdateTagsEntityRelationInput"]: GraphQLTypes["ProductCategoryUpdateTagsEntityRelationInput"];
	["ProductCategoryUpdateTagsRelationInput"]: GraphQLTypes["ProductCategoryUpdateTagsRelationInput"];
	["TagWithoutCategoriesUpdateInput"]: GraphQLTypes["TagWithoutCategoriesUpdateInput"];
	["TagUpdateAddTagsOnRegistrationEntityRelationInput"]: GraphQLTypes["TagUpdateAddTagsOnRegistrationEntityRelationInput"];
	["TagUpdateAddTagsOnRegistrationRelationInput"]: GraphQLTypes["TagUpdateAddTagsOnRegistrationRelationInput"];
	["ChannelWithoutAddTagsOnRegistrationUpdateInput"]: GraphQLTypes["ChannelWithoutAddTagsOnRegistrationUpdateInput"];
	["ChannelUpdateCustomersEntityRelationInput"]: GraphQLTypes["ChannelUpdateCustomersEntityRelationInput"];
	["ChannelUpdateCustomersRelationInput"]: GraphQLTypes["ChannelUpdateCustomersRelationInput"];
	["CustomerWithoutChannelsUpdateInput"]: GraphQLTypes["CustomerWithoutChannelsUpdateInput"];
	["CustomerUpdatePermissionsEntityRelationInput"]: GraphQLTypes["CustomerUpdatePermissionsEntityRelationInput"];
	["CustomerUpdateGroupEntityRelationInput"]: GraphQLTypes["CustomerUpdateGroupEntityRelationInput"];
	["CustomerGroupWithoutCustomersUpdateInput"]: GraphQLTypes["CustomerGroupWithoutCustomersUpdateInput"];
	["CustomerGroupUpdateProductPricesEntityRelationInput"]: GraphQLTypes["CustomerGroupUpdateProductPricesEntityRelationInput"];
	["CustomerGroupUpdateProductPricesRelationInput"]: GraphQLTypes["CustomerGroupUpdateProductPricesRelationInput"];
	["ProductGroupPriceWithoutGroupUpdateInput"]: GraphQLTypes["ProductGroupPriceWithoutGroupUpdateInput"];
	["ProductGroupPriceUpdateProductEntityRelationInput"]: GraphQLTypes["ProductGroupPriceUpdateProductEntityRelationInput"];
	["ProductWithoutGroupPricesUpdateInput"]: GraphQLTypes["ProductWithoutGroupPricesUpdateInput"];
	["ProductUpdateCategoriesEntityRelationInput"]: GraphQLTypes["ProductUpdateCategoriesEntityRelationInput"];
	["ProductUpdateCategoriesRelationInput"]: GraphQLTypes["ProductUpdateCategoriesRelationInput"];
	["ProductCategoryWithoutProductsUpdateInput"]: GraphQLTypes["ProductCategoryWithoutProductsUpdateInput"];
	["ProductCategoryUpdateChildrenEntityRelationInput"]: GraphQLTypes["ProductCategoryUpdateChildrenEntityRelationInput"];
	["ProductCategoryUpdateChildrenRelationInput"]: GraphQLTypes["ProductCategoryUpdateChildrenRelationInput"];
	["ProductCategoryWithoutParentUpdateInput"]: GraphQLTypes["ProductCategoryWithoutParentUpdateInput"];
	["ProductCategoryUpdateImageEntityRelationInput"]: GraphQLTypes["ProductCategoryUpdateImageEntityRelationInput"];
	["ProductCategoryUpsertImageRelationInput"]: GraphQLTypes["ProductCategoryUpsertImageRelationInput"];
	["ProductCategoryUpdateDescendantsEntityRelationInput"]: GraphQLTypes["ProductCategoryUpdateDescendantsEntityRelationInput"];
	["ProductCategoryUpdateAncestorsEntityRelationInput"]: GraphQLTypes["ProductCategoryUpdateAncestorsEntityRelationInput"];
	["ProductCategoryUpdateInheritedTagsEntityRelationInput"]: GraphQLTypes["ProductCategoryUpdateInheritedTagsEntityRelationInput"];
	["ProductCategoryUpdateNestedProductsEntityRelationInput"]: GraphQLTypes["ProductCategoryUpdateNestedProductsEntityRelationInput"];
	["ProductCategoryUpsertChildrenRelationInput"]: GraphQLTypes["ProductCategoryUpsertChildrenRelationInput"];
	["ProductUpsertCategoriesRelationInput"]: GraphQLTypes["ProductUpsertCategoriesRelationInput"];
	["ProductUpdateVatRateEntityRelationInput"]: GraphQLTypes["ProductUpdateVatRateEntityRelationInput"];
	["ProductUpsertVatRateRelationInput"]: GraphQLTypes["ProductUpsertVatRateRelationInput"];
	["ProductUpdateStocksEntityRelationInput"]: GraphQLTypes["ProductUpdateStocksEntityRelationInput"];
	["ProductUpdateStocksRelationInput"]: GraphQLTypes["ProductUpdateStocksRelationInput"];
	["ProductStockWithoutProductUpdateInput"]: GraphQLTypes["ProductStockWithoutProductUpdateInput"];
	["ProductStockUpdateStoreEntityRelationInput"]: GraphQLTypes["ProductStockUpdateStoreEntityRelationInput"];
	["StoreUpdateInput"]: GraphQLTypes["StoreUpdateInput"];
	["ProductStockUpsertStoreRelationInput"]: GraphQLTypes["ProductStockUpsertStoreRelationInput"];
	["ProductUpsertStocksRelationInput"]: GraphQLTypes["ProductUpsertStocksRelationInput"];
	["ProductUpdateImageEntityRelationInput"]: GraphQLTypes["ProductUpdateImageEntityRelationInput"];
	["ProductUpsertImageRelationInput"]: GraphQLTypes["ProductUpsertImageRelationInput"];
	["ProductUpdateCartItemsEntityRelationInput"]: GraphQLTypes["ProductUpdateCartItemsEntityRelationInput"];
	["ProductUpdateCartItemsRelationInput"]: GraphQLTypes["ProductUpdateCartItemsRelationInput"];
	["CartItemWithoutProductUpdateInput"]: GraphQLTypes["CartItemWithoutProductUpdateInput"];
	["CartItemUpdateCartEntityRelationInput"]: GraphQLTypes["CartItemUpdateCartEntityRelationInput"];
	["CartWithoutItemsUpdateInput"]: GraphQLTypes["CartWithoutItemsUpdateInput"];
	["CartUpdateChannelEntityRelationInput"]: GraphQLTypes["CartUpdateChannelEntityRelationInput"];
	["ChannelWithoutCartsUpdateInput"]: GraphQLTypes["ChannelWithoutCartsUpdateInput"];
	["ChannelUpdateAddTagsOnRegistrationEntityRelationInput"]: GraphQLTypes["ChannelUpdateAddTagsOnRegistrationEntityRelationInput"];
	["ChannelUpdateAddTagsOnRegistrationRelationInput"]: GraphQLTypes["ChannelUpdateAddTagsOnRegistrationRelationInput"];
	["TagWithoutAddTagsOnRegistrationUpdateInput"]: GraphQLTypes["TagWithoutAddTagsOnRegistrationUpdateInput"];
	["TagUpdateNestedCategoriesEntityRelationInput"]: GraphQLTypes["TagUpdateNestedCategoriesEntityRelationInput"];
	["TagUpdateDeliveryZonesEntityRelationInput"]: GraphQLTypes["TagUpdateDeliveryZonesEntityRelationInput"];
	["TagUpdateDeliveryZonesRelationInput"]: GraphQLTypes["TagUpdateDeliveryZonesRelationInput"];
	["DeliveryZoneWithoutDeliveryZonesOfTagsUpdateInput"]: GraphQLTypes["DeliveryZoneWithoutDeliveryZonesOfTagsUpdateInput"];
	["DeliveryZoneUpdateDeliveryZonesOfProductsEntityRelationInput"]: GraphQLTypes["DeliveryZoneUpdateDeliveryZonesOfProductsEntityRelationInput"];
	["DeliveryZoneUpdateDeliveryZonesOfProductsRelationInput"]: GraphQLTypes["DeliveryZoneUpdateDeliveryZonesOfProductsRelationInput"];
	["ProductWithoutDeliveryZonesUpdateInput"]: GraphQLTypes["ProductWithoutDeliveryZonesUpdateInput"];
	["ProductUpdateGroupPricesEntityRelationInput"]: GraphQLTypes["ProductUpdateGroupPricesEntityRelationInput"];
	["ProductUpdateGroupPricesRelationInput"]: GraphQLTypes["ProductUpdateGroupPricesRelationInput"];
	["ProductGroupPriceWithoutProductUpdateInput"]: GraphQLTypes["ProductGroupPriceWithoutProductUpdateInput"];
	["ProductGroupPriceUpdateGroupEntityRelationInput"]: GraphQLTypes["ProductGroupPriceUpdateGroupEntityRelationInput"];
	["CustomerGroupWithoutProductPricesUpdateInput"]: GraphQLTypes["CustomerGroupWithoutProductPricesUpdateInput"];
	["CustomerGroupUpdateCustomersEntityRelationInput"]: GraphQLTypes["CustomerGroupUpdateCustomersEntityRelationInput"];
	["CustomerGroupUpdateCustomersRelationInput"]: GraphQLTypes["CustomerGroupUpdateCustomersRelationInput"];
	["CustomerWithoutGroupUpdateInput"]: GraphQLTypes["CustomerWithoutGroupUpdateInput"];
	["CustomerUpdatePhotoEntityRelationInput"]: GraphQLTypes["CustomerUpdatePhotoEntityRelationInput"];
	["CustomerUpsertPhotoRelationInput"]: GraphQLTypes["CustomerUpsertPhotoRelationInput"];
	["CustomerUpdateNameEntityRelationInput"]: GraphQLTypes["CustomerUpdateNameEntityRelationInput"];
	["CustomerNameWithoutCustomerUpdateInput"]: GraphQLTypes["CustomerNameWithoutCustomerUpdateInput"];
	["CustomerNameUpdateAliasesEntityRelationInput"]: GraphQLTypes["CustomerNameUpdateAliasesEntityRelationInput"];
	["CustomerNameUpdateAliasesRelationInput"]: GraphQLTypes["CustomerNameUpdateAliasesRelationInput"];
	["CustomerAliasUpdateInput"]: GraphQLTypes["CustomerAliasUpdateInput"];
	["CustomerNameUpsertAliasesRelationInput"]: GraphQLTypes["CustomerNameUpsertAliasesRelationInput"];
	["CustomerUpsertNameRelationInput"]: GraphQLTypes["CustomerUpsertNameRelationInput"];
	["CustomerUpdateIngredientRatingsEntityRelationInput"]: GraphQLTypes["CustomerUpdateIngredientRatingsEntityRelationInput"];
	["CustomerUpdateIngredientRatingsRelationInput"]: GraphQLTypes["CustomerUpdateIngredientRatingsRelationInput"];
	["CustomerIngredientRatingWithoutCustomerUpdateInput"]: GraphQLTypes["CustomerIngredientRatingWithoutCustomerUpdateInput"];
	["CustomerIngredientRatingUpdateRatingEntityRelationInput"]: GraphQLTypes["CustomerIngredientRatingUpdateRatingEntityRelationInput"];
	["ProductIngredientRatingUpdateInput"]: GraphQLTypes["ProductIngredientRatingUpdateInput"];
	["ProductIngredientRatingUpdateIconEntityRelationInput"]: GraphQLTypes["ProductIngredientRatingUpdateIconEntityRelationInput"];
	["ProductIngredientRatingUpsertIconRelationInput"]: GraphQLTypes["ProductIngredientRatingUpsertIconRelationInput"];
	["CustomerIngredientRatingUpsertRatingRelationInput"]: GraphQLTypes["CustomerIngredientRatingUpsertRatingRelationInput"];
	["CustomerIngredientRatingUpdateIngredientEntityRelationInput"]: GraphQLTypes["CustomerIngredientRatingUpdateIngredientEntityRelationInput"];
	["ProductIngredientWithoutCustomerRatingsUpdateInput"]: GraphQLTypes["ProductIngredientWithoutCustomerRatingsUpdateInput"];
	["ProductIngredientUpdateCategoriesEntityRelationInput"]: GraphQLTypes["ProductIngredientUpdateCategoriesEntityRelationInput"];
	["ProductIngredientUpdateCategoriesRelationInput"]: GraphQLTypes["ProductIngredientUpdateCategoriesRelationInput"];
	["ProductIngredientCategoryWithoutIngredientsUpdateInput"]: GraphQLTypes["ProductIngredientCategoryWithoutIngredientsUpdateInput"];
	["ProductIngredientCategoryUpdateLocalesEntityRelationInput"]: GraphQLTypes["ProductIngredientCategoryUpdateLocalesEntityRelationInput"];
	["ProductIngredientCategoryUpdateLocalesRelationInput"]: GraphQLTypes["ProductIngredientCategoryUpdateLocalesRelationInput"];
	["ProductIngredientCategoryLocaleWithoutRootUpdateInput"]: GraphQLTypes["ProductIngredientCategoryLocaleWithoutRootUpdateInput"];
	["ProductIngredientCategoryLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["ProductIngredientCategoryLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutProductIngredientCategoriesUpdateInput"]: GraphQLTypes["LocaleWithoutProductIngredientCategoriesUpdateInput"];
	["LocaleUpdateProductIngredientsEntityRelationInput"]: GraphQLTypes["LocaleUpdateProductIngredientsEntityRelationInput"];
	["LocaleUpdateProductIngredientsRelationInput"]: GraphQLTypes["LocaleUpdateProductIngredientsRelationInput"];
	["ProductIngredientLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["ProductIngredientLocaleWithoutLocaleUpdateInput"];
	["ProductIngredientLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["ProductIngredientLocaleUpdateRootEntityRelationInput"];
	["ProductIngredientWithoutLocalesUpdateInput"]: GraphQLTypes["ProductIngredientWithoutLocalesUpdateInput"];
	["ProductIngredientUpdateAllergensEntityRelationInput"]: GraphQLTypes["ProductIngredientUpdateAllergensEntityRelationInput"];
	["ProductIngredientUpdateAllergensRelationInput"]: GraphQLTypes["ProductIngredientUpdateAllergensRelationInput"];
	["AllergenWithoutIngredientsUpdateInput"]: GraphQLTypes["AllergenWithoutIngredientsUpdateInput"];
	["AllergenUpdateLocalesEntityRelationInput"]: GraphQLTypes["AllergenUpdateLocalesEntityRelationInput"];
	["AllergenUpdateLocalesRelationInput"]: GraphQLTypes["AllergenUpdateLocalesRelationInput"];
	["AllergenLocaleWithoutRootUpdateInput"]: GraphQLTypes["AllergenLocaleWithoutRootUpdateInput"];
	["AllergenLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["AllergenLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutAllergensUpdateInput"]: GraphQLTypes["LocaleWithoutAllergensUpdateInput"];
	["LocaleUpdateOrderRecurrencesEntityRelationInput"]: GraphQLTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"];
	["LocaleUpdateOrderRecurrencesRelationInput"]: GraphQLTypes["LocaleUpdateOrderRecurrencesRelationInput"];
	["OrderRecurrenceLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["OrderRecurrenceLocaleWithoutLocaleUpdateInput"];
	["OrderRecurrenceLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["OrderRecurrenceLocaleUpdateRootEntityRelationInput"];
	["OrderRecurrenceWithoutLocalesUpdateInput"]: GraphQLTypes["OrderRecurrenceWithoutLocalesUpdateInput"];
	["OrderRecurrenceUpdateBusinessCategoryEntityRelationInput"]: GraphQLTypes["OrderRecurrenceUpdateBusinessCategoryEntityRelationInput"];
	["OrderRecurrenceUpdateBusinessCategoryRelationInput"]: GraphQLTypes["OrderRecurrenceUpdateBusinessCategoryRelationInput"];
	["BusinessCategoryWithoutRecurrencesUpdateInput"]: GraphQLTypes["BusinessCategoryWithoutRecurrencesUpdateInput"];
	["BusinessCategoryUpdateLocalesEntityRelationInput"]: GraphQLTypes["BusinessCategoryUpdateLocalesEntityRelationInput"];
	["BusinessCategoryUpdateLocalesRelationInput"]: GraphQLTypes["BusinessCategoryUpdateLocalesRelationInput"];
	["BusinessCategoryLocaleWithoutRootUpdateInput"]: GraphQLTypes["BusinessCategoryLocaleWithoutRootUpdateInput"];
	["BusinessCategoryLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["BusinessCategoryLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutBusinessCategoriesUpdateInput"]: GraphQLTypes["LocaleWithoutBusinessCategoriesUpdateInput"];
	["LocaleUpdateBlogsEntityRelationInput"]: GraphQLTypes["LocaleUpdateBlogsEntityRelationInput"];
	["LocaleUpdateBlogsRelationInput"]: GraphQLTypes["LocaleUpdateBlogsRelationInput"];
	["BlogLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["BlogLocaleWithoutLocaleUpdateInput"];
	["BlogLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["BlogLocaleUpdateRootEntityRelationInput"];
	["BlogWithoutLocalesUpdateInput"]: GraphQLTypes["BlogWithoutLocalesUpdateInput"];
	["BlogLocaleUpsertRootRelationInput"]: GraphQLTypes["BlogLocaleUpsertRootRelationInput"];
	["LocaleUpsertBlogsRelationInput"]: GraphQLTypes["LocaleUpsertBlogsRelationInput"];
	["LocaleUpdateBlogPostsEntityRelationInput"]: GraphQLTypes["LocaleUpdateBlogPostsEntityRelationInput"];
	["LocaleUpdateBlogPostsRelationInput"]: GraphQLTypes["LocaleUpdateBlogPostsRelationInput"];
	["BlogPostLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["BlogPostLocaleWithoutLocaleUpdateInput"];
	["BlogPostLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["BlogPostLocaleUpdateRootEntityRelationInput"];
	["BlogPostWithoutLocalesUpdateInput"]: GraphQLTypes["BlogPostWithoutLocalesUpdateInput"];
	["BlogPostLocaleUpsertRootRelationInput"]: GraphQLTypes["BlogPostLocaleUpsertRootRelationInput"];
	["BlogPostLocaleUpdateCoverEntityRelationInput"]: GraphQLTypes["BlogPostLocaleUpdateCoverEntityRelationInput"];
	["CoverUpdateInput"]: GraphQLTypes["CoverUpdateInput"];
	["CoverUpdateMediumEntityRelationInput"]: GraphQLTypes["CoverUpdateMediumEntityRelationInput"];
	["MediumUpdateInput"]: GraphQLTypes["MediumUpdateInput"];
	["MediumUpdateImageEntityRelationInput"]: GraphQLTypes["MediumUpdateImageEntityRelationInput"];
	["MediumUpsertImageRelationInput"]: GraphQLTypes["MediumUpsertImageRelationInput"];
	["MediumUpdateVideoEntityRelationInput"]: GraphQLTypes["MediumUpdateVideoEntityRelationInput"];
	["VideoUpdateInput"]: GraphQLTypes["VideoUpdateInput"];
	["VideoUpdatePosterEntityRelationInput"]: GraphQLTypes["VideoUpdatePosterEntityRelationInput"];
	["VideoUpsertPosterRelationInput"]: GraphQLTypes["VideoUpsertPosterRelationInput"];
	["MediumUpsertVideoRelationInput"]: GraphQLTypes["MediumUpsertVideoRelationInput"];
	["CoverUpsertMediumRelationInput"]: GraphQLTypes["CoverUpsertMediumRelationInput"];
	["CoverUpdateButtonColorsEntityRelationInput"]: GraphQLTypes["CoverUpdateButtonColorsEntityRelationInput"];
	["ColorPalleteUpdateInput"]: GraphQLTypes["ColorPalleteUpdateInput"];
	["CoverUpsertButtonColorsRelationInput"]: GraphQLTypes["CoverUpsertButtonColorsRelationInput"];
	["BlogPostLocaleUpsertCoverRelationInput"]: GraphQLTypes["BlogPostLocaleUpsertCoverRelationInput"];
	["BlogPostLocaleUpdateContentEntityRelationInput"]: GraphQLTypes["BlogPostLocaleUpdateContentEntityRelationInput"];
	["ContentUpdateInput"]: GraphQLTypes["ContentUpdateInput"];
	["ContentUpdateBlocksEntityRelationInput"]: GraphQLTypes["ContentUpdateBlocksEntityRelationInput"];
	["ContentUpdateBlocksRelationInput"]: GraphQLTypes["ContentUpdateBlocksRelationInput"];
	["ContentBlockWithoutContentUpdateInput"]: GraphQLTypes["ContentBlockWithoutContentUpdateInput"];
	["ContentBlockUpdateReferencesEntityRelationInput"]: GraphQLTypes["ContentBlockUpdateReferencesEntityRelationInput"];
	["ContentBlockUpdateReferencesRelationInput"]: GraphQLTypes["ContentBlockUpdateReferencesRelationInput"];
	["ContentReferenceWithoutBlockUpdateInput"]: GraphQLTypes["ContentReferenceWithoutBlockUpdateInput"];
	["ContentReferenceUpdateColorPalleteEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateColorPalleteEntityRelationInput"];
	["ContentReferenceUpsertColorPalleteRelationInput"]: GraphQLTypes["ContentReferenceUpsertColorPalleteRelationInput"];
	["ContentReferenceUpdateMediumEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateMediumEntityRelationInput"];
	["ContentReferenceUpsertMediumRelationInput"]: GraphQLTypes["ContentReferenceUpsertMediumRelationInput"];
	["ContentReferenceUpdateLinkEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateLinkEntityRelationInput"];
	["LinkUpdateInput"]: GraphQLTypes["LinkUpdateInput"];
	["LinkUpdateInternalLinkEntityRelationInput"]: GraphQLTypes["LinkUpdateInternalLinkEntityRelationInput"];
	["LinkableUpdateInput"]: GraphQLTypes["LinkableUpdateInput"];
	["LinkableUpdateBlogPostEntityRelationInput"]: GraphQLTypes["LinkableUpdateBlogPostEntityRelationInput"];
	["BlogPostLocaleWithoutLinkUpdateInput"]: GraphQLTypes["BlogPostLocaleWithoutLinkUpdateInput"];
	["BlogPostLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["BlogPostLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutBlogPostsUpdateInput"]: GraphQLTypes["LocaleWithoutBlogPostsUpdateInput"];
	["LocaleUpdateIdentifierEntityRelationInput"]: GraphQLTypes["LocaleUpdateIdentifierEntityRelationInput"];
	["TranslationCataloguesIdentifierUpdateInput"]: GraphQLTypes["TranslationCataloguesIdentifierUpdateInput"];
	["TranslationCataloguesIdentifierUpdateCatalogueEntityRelationInput"]: GraphQLTypes["TranslationCataloguesIdentifierUpdateCatalogueEntityRelationInput"];
	["TranslationCataloguesIdentifierUpdateCatalogueRelationInput"]: GraphQLTypes["TranslationCataloguesIdentifierUpdateCatalogueRelationInput"];
	["TranslationCatalogueWithoutIdentifierUpdateInput"]: GraphQLTypes["TranslationCatalogueWithoutIdentifierUpdateInput"];
	["TranslationCatalogueUpdateDomainEntityRelationInput"]: GraphQLTypes["TranslationCatalogueUpdateDomainEntityRelationInput"];
	["TranslationDomainWithoutCataloguesUpdateInput"]: GraphQLTypes["TranslationDomainWithoutCataloguesUpdateInput"];
	["TranslationDomainUpdateKeysEntityRelationInput"]: GraphQLTypes["TranslationDomainUpdateKeysEntityRelationInput"];
	["TranslationDomainUpdateKeysRelationInput"]: GraphQLTypes["TranslationDomainUpdateKeysRelationInput"];
	["TranslationKeyWithoutDomainUpdateInput"]: GraphQLTypes["TranslationKeyWithoutDomainUpdateInput"];
	["TranslationKeyUpdateValuesEntityRelationInput"]: GraphQLTypes["TranslationKeyUpdateValuesEntityRelationInput"];
	["TranslationKeyUpdateValuesRelationInput"]: GraphQLTypes["TranslationKeyUpdateValuesRelationInput"];
	["TranslationValueWithoutKeyUpdateInput"]: GraphQLTypes["TranslationValueWithoutKeyUpdateInput"];
	["TranslationValueUpdateCatalogueEntityRelationInput"]: GraphQLTypes["TranslationValueUpdateCatalogueEntityRelationInput"];
	["TranslationCatalogueWithoutValuesUpdateInput"]: GraphQLTypes["TranslationCatalogueWithoutValuesUpdateInput"];
	["TranslationCatalogueUpdateFallbackEntityRelationInput"]: GraphQLTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"];
	["TranslationCatalogueUpdateInput"]: GraphQLTypes["TranslationCatalogueUpdateInput"];
	["TranslationCatalogueUpdateValuesEntityRelationInput"]: GraphQLTypes["TranslationCatalogueUpdateValuesEntityRelationInput"];
	["TranslationCatalogueUpdateValuesRelationInput"]: GraphQLTypes["TranslationCatalogueUpdateValuesRelationInput"];
	["TranslationValueWithoutCatalogueUpdateInput"]: GraphQLTypes["TranslationValueWithoutCatalogueUpdateInput"];
	["TranslationValueUpdateKeyEntityRelationInput"]: GraphQLTypes["TranslationValueUpdateKeyEntityRelationInput"];
	["TranslationKeyWithoutValuesUpdateInput"]: GraphQLTypes["TranslationKeyWithoutValuesUpdateInput"];
	["TranslationKeyUpdateDomainEntityRelationInput"]: GraphQLTypes["TranslationKeyUpdateDomainEntityRelationInput"];
	["TranslationDomainWithoutKeysUpdateInput"]: GraphQLTypes["TranslationDomainWithoutKeysUpdateInput"];
	["TranslationDomainUpdateCataloguesEntityRelationInput"]: GraphQLTypes["TranslationDomainUpdateCataloguesEntityRelationInput"];
	["TranslationDomainUpdateCataloguesRelationInput"]: GraphQLTypes["TranslationDomainUpdateCataloguesRelationInput"];
	["TranslationCatalogueWithoutDomainUpdateInput"]: GraphQLTypes["TranslationCatalogueWithoutDomainUpdateInput"];
	["TranslationCatalogueUpdateIdentifierEntityRelationInput"]: GraphQLTypes["TranslationCatalogueUpdateIdentifierEntityRelationInput"];
	["TranslationCataloguesIdentifierWithoutCatalogueUpdateInput"]: GraphQLTypes["TranslationCataloguesIdentifierWithoutCatalogueUpdateInput"];
	["TranslationCatalogueUpsertIdentifierRelationInput"]: GraphQLTypes["TranslationCatalogueUpsertIdentifierRelationInput"];
	["TranslationDomainUpsertCataloguesRelationInput"]: GraphQLTypes["TranslationDomainUpsertCataloguesRelationInput"];
	["TranslationKeyUpsertDomainRelationInput"]: GraphQLTypes["TranslationKeyUpsertDomainRelationInput"];
	["TranslationValueUpsertKeyRelationInput"]: GraphQLTypes["TranslationValueUpsertKeyRelationInput"];
	["TranslationCatalogueUpsertValuesRelationInput"]: GraphQLTypes["TranslationCatalogueUpsertValuesRelationInput"];
	["TranslationCatalogueUpsertFallbackRelationInput"]: GraphQLTypes["TranslationCatalogueUpsertFallbackRelationInput"];
	["TranslationValueUpsertCatalogueRelationInput"]: GraphQLTypes["TranslationValueUpsertCatalogueRelationInput"];
	["TranslationKeyUpsertValuesRelationInput"]: GraphQLTypes["TranslationKeyUpsertValuesRelationInput"];
	["TranslationDomainUpsertKeysRelationInput"]: GraphQLTypes["TranslationDomainUpsertKeysRelationInput"];
	["TranslationCatalogueUpsertDomainRelationInput"]: GraphQLTypes["TranslationCatalogueUpsertDomainRelationInput"];
	["TranslationCataloguesIdentifierUpsertCatalogueRelationInput"]: GraphQLTypes["TranslationCataloguesIdentifierUpsertCatalogueRelationInput"];
	["LocaleUpsertIdentifierRelationInput"]: GraphQLTypes["LocaleUpsertIdentifierRelationInput"];
	["LocaleUpdateMenusEntityRelationInput"]: GraphQLTypes["LocaleUpdateMenusEntityRelationInput"];
	["LocaleUpdateMenusRelationInput"]: GraphQLTypes["LocaleUpdateMenusRelationInput"];
	["MenuLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["MenuLocaleWithoutLocaleUpdateInput"];
	["MenuLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["MenuLocaleUpdateRootEntityRelationInput"];
	["SiteMenuWithoutLocalesUpdateInput"]: GraphQLTypes["SiteMenuWithoutLocalesUpdateInput"];
	["MenuLocaleUpsertRootRelationInput"]: GraphQLTypes["MenuLocaleUpsertRootRelationInput"];
	["MenuLocaleUpdateItemsEntityRelationInput"]: GraphQLTypes["MenuLocaleUpdateItemsEntityRelationInput"];
	["MenuLocaleUpdateItemsRelationInput"]: GraphQLTypes["MenuLocaleUpdateItemsRelationInput"];
	["MenuItemWithoutMenuUpdateInput"]: GraphQLTypes["MenuItemWithoutMenuUpdateInput"];
	["MenuItemUpdateLinkEntityRelationInput"]: GraphQLTypes["MenuItemUpdateLinkEntityRelationInput"];
	["MenuItemUpsertLinkRelationInput"]: GraphQLTypes["MenuItemUpsertLinkRelationInput"];
	["MenuItemUpdateSubitemsEntityRelationInput"]: GraphQLTypes["MenuItemUpdateSubitemsEntityRelationInput"];
	["MenuItemUpdateSubitemsRelationInput"]: GraphQLTypes["MenuItemUpdateSubitemsRelationInput"];
	["MenuSubitemWithoutItemUpdateInput"]: GraphQLTypes["MenuSubitemWithoutItemUpdateInput"];
	["MenuSubitemUpdateLinksEntityRelationInput"]: GraphQLTypes["MenuSubitemUpdateLinksEntityRelationInput"];
	["MenuLinkListUpdateInput"]: GraphQLTypes["MenuLinkListUpdateInput"];
	["MenuLinkListUpdateItemsEntityRelationInput"]: GraphQLTypes["MenuLinkListUpdateItemsEntityRelationInput"];
	["MenuLinkListUpdateItemsRelationInput"]: GraphQLTypes["MenuLinkListUpdateItemsRelationInput"];
	["MenuLinkItemWithoutListUpdateInput"]: GraphQLTypes["MenuLinkItemWithoutListUpdateInput"];
	["MenuLinkItemUpdateLinkEntityRelationInput"]: GraphQLTypes["MenuLinkItemUpdateLinkEntityRelationInput"];
	["MenuLinkItemUpsertLinkRelationInput"]: GraphQLTypes["MenuLinkItemUpsertLinkRelationInput"];
	["MenuLinkItemUpdateImageEntityRelationInput"]: GraphQLTypes["MenuLinkItemUpdateImageEntityRelationInput"];
	["MenuLinkItemUpsertImageRelationInput"]: GraphQLTypes["MenuLinkItemUpsertImageRelationInput"];
	["MenuLinkListUpsertItemsRelationInput"]: GraphQLTypes["MenuLinkListUpsertItemsRelationInput"];
	["MenuSubitemUpsertLinksRelationInput"]: GraphQLTypes["MenuSubitemUpsertLinksRelationInput"];
	["MenuSubitemUpdateProductsEntityRelationInput"]: GraphQLTypes["MenuSubitemUpdateProductsEntityRelationInput"];
	["MenuProductsUpdateInput"]: GraphQLTypes["MenuProductsUpdateInput"];
	["MenuProductsUpdateLinksEntityRelationInput"]: GraphQLTypes["MenuProductsUpdateLinksEntityRelationInput"];
	["MenuProductsUpsertLinksRelationInput"]: GraphQLTypes["MenuProductsUpsertLinksRelationInput"];
	["MenuProductsUpdateButtonsEntityRelationInput"]: GraphQLTypes["MenuProductsUpdateButtonsEntityRelationInput"];
	["LinkListUpdateInput"]: GraphQLTypes["LinkListUpdateInput"];
	["LinkListUpdateItemsEntityRelationInput"]: GraphQLTypes["LinkListUpdateItemsEntityRelationInput"];
	["LinkListUpdateItemsRelationInput"]: GraphQLTypes["LinkListUpdateItemsRelationInput"];
	["LinkListItemWithoutListUpdateInput"]: GraphQLTypes["LinkListItemWithoutListUpdateInput"];
	["LinkListItemUpdateLinkEntityRelationInput"]: GraphQLTypes["LinkListItemUpdateLinkEntityRelationInput"];
	["LinkListItemUpsertLinkRelationInput"]: GraphQLTypes["LinkListItemUpsertLinkRelationInput"];
	["LinkListUpsertItemsRelationInput"]: GraphQLTypes["LinkListUpsertItemsRelationInput"];
	["MenuProductsUpsertButtonsRelationInput"]: GraphQLTypes["MenuProductsUpsertButtonsRelationInput"];
	["MenuSubitemUpsertProductsRelationInput"]: GraphQLTypes["MenuSubitemUpsertProductsRelationInput"];
	["MenuSubitemUpdateDeliveryEntityRelationInput"]: GraphQLTypes["MenuSubitemUpdateDeliveryEntityRelationInput"];
	["MenuDeliveryUpdateInput"]: GraphQLTypes["MenuDeliveryUpdateInput"];
	["MenuDeliveryUpdateDeliveryRegionsEntityRelationInput"]: GraphQLTypes["MenuDeliveryUpdateDeliveryRegionsEntityRelationInput"];
	["DeliveryRegionsUpdateInput"]: GraphQLTypes["DeliveryRegionsUpdateInput"];
	["DeliveryRegionsUpdateItemsEntityRelationInput"]: GraphQLTypes["DeliveryRegionsUpdateItemsEntityRelationInput"];
	["DeliveryRegionsUpdateItemsRelationInput"]: GraphQLTypes["DeliveryRegionsUpdateItemsRelationInput"];
	["DeliveryRegionsItemWithoutListUpdateInput"]: GraphQLTypes["DeliveryRegionsItemWithoutListUpdateInput"];
	["DeliveryRegionsItemUpdateImageEntityRelationInput"]: GraphQLTypes["DeliveryRegionsItemUpdateImageEntityRelationInput"];
	["DeliveryRegionsItemUpsertImageRelationInput"]: GraphQLTypes["DeliveryRegionsItemUpsertImageRelationInput"];
	["DeliveryRegionsItemUpdateTextListEntityRelationInput"]: GraphQLTypes["DeliveryRegionsItemUpdateTextListEntityRelationInput"];
	["TextListUpdateInput"]: GraphQLTypes["TextListUpdateInput"];
	["TextListUpdateItemsEntityRelationInput"]: GraphQLTypes["TextListUpdateItemsEntityRelationInput"];
	["TextListUpdateItemsRelationInput"]: GraphQLTypes["TextListUpdateItemsRelationInput"];
	["TextItemWithoutListUpdateInput"]: GraphQLTypes["TextItemWithoutListUpdateInput"];
	["TextListUpsertItemsRelationInput"]: GraphQLTypes["TextListUpsertItemsRelationInput"];
	["DeliveryRegionsItemUpsertTextListRelationInput"]: GraphQLTypes["DeliveryRegionsItemUpsertTextListRelationInput"];
	["DeliveryRegionsItemUpdateGalleryEntityRelationInput"]: GraphQLTypes["DeliveryRegionsItemUpdateGalleryEntityRelationInput"];
	["ImageListUpdateInput"]: GraphQLTypes["ImageListUpdateInput"];
	["ImageListUpdateItemsEntityRelationInput"]: GraphQLTypes["ImageListUpdateItemsEntityRelationInput"];
	["ImageListUpdateItemsRelationInput"]: GraphQLTypes["ImageListUpdateItemsRelationInput"];
	["ImageListItemWithoutListUpdateInput"]: GraphQLTypes["ImageListItemWithoutListUpdateInput"];
	["ImageListItemUpdateImageEntityRelationInput"]: GraphQLTypes["ImageListItemUpdateImageEntityRelationInput"];
	["ImageListItemUpsertImageRelationInput"]: GraphQLTypes["ImageListItemUpsertImageRelationInput"];
	["ImageListUpsertItemsRelationInput"]: GraphQLTypes["ImageListUpsertItemsRelationInput"];
	["DeliveryRegionsItemUpsertGalleryRelationInput"]: GraphQLTypes["DeliveryRegionsItemUpsertGalleryRelationInput"];
	["DeliveryRegionsUpsertItemsRelationInput"]: GraphQLTypes["DeliveryRegionsUpsertItemsRelationInput"];
	["MenuDeliveryUpsertDeliveryRegionsRelationInput"]: GraphQLTypes["MenuDeliveryUpsertDeliveryRegionsRelationInput"];
	["MenuDeliveryUpdateSocialsAndAppsEntityRelationInput"]: GraphQLTypes["MenuDeliveryUpdateSocialsAndAppsEntityRelationInput"];
	["SocialsAndAppsUpdateInput"]: GraphQLTypes["SocialsAndAppsUpdateInput"];
	["MenuDeliveryUpsertSocialsAndAppsRelationInput"]: GraphQLTypes["MenuDeliveryUpsertSocialsAndAppsRelationInput"];
	["MenuSubitemUpsertDeliveryRelationInput"]: GraphQLTypes["MenuSubitemUpsertDeliveryRelationInput"];
	["MenuSubitemUpdateContactEntityRelationInput"]: GraphQLTypes["MenuSubitemUpdateContactEntityRelationInput"];
	["MenuContactUpdateInput"]: GraphQLTypes["MenuContactUpdateInput"];
	["MenuContactUpdateImageEntityRelationInput"]: GraphQLTypes["MenuContactUpdateImageEntityRelationInput"];
	["MenuContactUpsertImageRelationInput"]: GraphQLTypes["MenuContactUpsertImageRelationInput"];
	["MenuSubitemUpsertContactRelationInput"]: GraphQLTypes["MenuSubitemUpsertContactRelationInput"];
	["MenuItemUpsertSubitemsRelationInput"]: GraphQLTypes["MenuItemUpsertSubitemsRelationInput"];
	["MenuLocaleUpsertItemsRelationInput"]: GraphQLTypes["MenuLocaleUpsertItemsRelationInput"];
	["MenuLocaleUpdateSecondaryItemsEntityRelationInput"]: GraphQLTypes["MenuLocaleUpdateSecondaryItemsEntityRelationInput"];
	["MenuLocaleUpsertSecondaryItemsRelationInput"]: GraphQLTypes["MenuLocaleUpsertSecondaryItemsRelationInput"];
	["MenuLocaleUpdateEshopLinkEntityRelationInput"]: GraphQLTypes["MenuLocaleUpdateEshopLinkEntityRelationInput"];
	["MenuLocaleUpsertEshopLinkRelationInput"]: GraphQLTypes["MenuLocaleUpsertEshopLinkRelationInput"];
	["LocaleUpsertMenusRelationInput"]: GraphQLTypes["LocaleUpsertMenusRelationInput"];
	["LocaleUpdatePagesEntityRelationInput"]: GraphQLTypes["LocaleUpdatePagesEntityRelationInput"];
	["LocaleUpdatePagesRelationInput"]: GraphQLTypes["LocaleUpdatePagesRelationInput"];
	["PageLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["PageLocaleWithoutLocaleUpdateInput"];
	["PageLocaleUpdateLinkEntityRelationInput"]: GraphQLTypes["PageLocaleUpdateLinkEntityRelationInput"];
	["LinkableWithoutPageUpdateInput"]: GraphQLTypes["LinkableWithoutPageUpdateInput"];
	["LinkableUpdateWikiPageEntityRelationInput"]: GraphQLTypes["LinkableUpdateWikiPageEntityRelationInput"];
	["WikiPageWithoutLinkUpdateInput"]: GraphQLTypes["WikiPageWithoutLinkUpdateInput"];
	["WikiPageUpdateParentEntityRelationInput"]: GraphQLTypes["WikiPageUpdateParentEntityRelationInput"];
	["WikiPageWithoutChildrenUpdateInput"]: GraphQLTypes["WikiPageWithoutChildrenUpdateInput"];
	["WikiPageUpdateLinkEntityRelationInput"]: GraphQLTypes["WikiPageUpdateLinkEntityRelationInput"];
	["LinkableWithoutWikiPageUpdateInput"]: GraphQLTypes["LinkableWithoutWikiPageUpdateInput"];
	["LinkableUpdatePageEntityRelationInput"]: GraphQLTypes["LinkableUpdatePageEntityRelationInput"];
	["PageLocaleWithoutLinkUpdateInput"]: GraphQLTypes["PageLocaleWithoutLinkUpdateInput"];
	["PageLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["PageLocaleUpdateRootEntityRelationInput"];
	["PageWithoutLocalesUpdateInput"]: GraphQLTypes["PageWithoutLocalesUpdateInput"];
	["PageLocaleUpsertRootRelationInput"]: GraphQLTypes["PageLocaleUpsertRootRelationInput"];
	["PageLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["PageLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutPagesUpdateInput"]: GraphQLTypes["LocaleWithoutPagesUpdateInput"];
	["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]: GraphQLTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"];
	["LocaleUpdateProductIngredientCategoriesRelationInput"]: GraphQLTypes["LocaleUpdateProductIngredientCategoriesRelationInput"];
	["ProductIngredientCategoryLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["ProductIngredientCategoryLocaleWithoutLocaleUpdateInput"];
	["ProductIngredientCategoryLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["ProductIngredientCategoryLocaleUpdateRootEntityRelationInput"];
	["ProductIngredientCategoryWithoutLocalesUpdateInput"]: GraphQLTypes["ProductIngredientCategoryWithoutLocalesUpdateInput"];
	["ProductIngredientCategoryUpdateIngredientsEntityRelationInput"]: GraphQLTypes["ProductIngredientCategoryUpdateIngredientsEntityRelationInput"];
	["ProductIngredientCategoryUpdateIngredientsRelationInput"]: GraphQLTypes["ProductIngredientCategoryUpdateIngredientsRelationInput"];
	["ProductIngredientWithoutCategoriesUpdateInput"]: GraphQLTypes["ProductIngredientWithoutCategoriesUpdateInput"];
	["ProductIngredientUpdateCustomerRatingsEntityRelationInput"]: GraphQLTypes["ProductIngredientUpdateCustomerRatingsEntityRelationInput"];
	["ProductIngredientUpdateCustomerRatingsRelationInput"]: GraphQLTypes["ProductIngredientUpdateCustomerRatingsRelationInput"];
	["CustomerIngredientRatingWithoutIngredientUpdateInput"]: GraphQLTypes["CustomerIngredientRatingWithoutIngredientUpdateInput"];
	["CustomerIngredientRatingUpdateCustomerEntityRelationInput"]: GraphQLTypes["CustomerIngredientRatingUpdateCustomerEntityRelationInput"];
	["CustomerWithoutIngredientRatingsUpdateInput"]: GraphQLTypes["CustomerWithoutIngredientRatingsUpdateInput"];
	["CustomerUpdateBusinessEntityRelationInput"]: GraphQLTypes["CustomerUpdateBusinessEntityRelationInput"];
	["BusinessCustomerWithoutCustomerUpdateInput"]: GraphQLTypes["BusinessCustomerWithoutCustomerUpdateInput"];
	["BusinessCustomerUpdateOwnersEntityRelationInput"]: GraphQLTypes["BusinessCustomerUpdateOwnersEntityRelationInput"];
	["BusinessCustomerUpdateOwnersRelationInput"]: GraphQLTypes["BusinessCustomerUpdateOwnersRelationInput"];
	["CustomerWithoutOwnerOfBusinessesUpdateInput"]: GraphQLTypes["CustomerWithoutOwnerOfBusinessesUpdateInput"];
	["CustomerUpdateMemberOfBusinessesEntityRelationInput"]: GraphQLTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"];
	["CustomerUpdateMemberOfBusinessesRelationInput"]: GraphQLTypes["CustomerUpdateMemberOfBusinessesRelationInput"];
	["BusinessCustomerWithoutMembersUpdateInput"]: GraphQLTypes["BusinessCustomerWithoutMembersUpdateInput"];
	["BusinessCustomerUpdateCategoryEntityRelationInput"]: GraphQLTypes["BusinessCustomerUpdateCategoryEntityRelationInput"];
	["BusinessCategoryWithoutBusinessCustomersUpdateInput"]: GraphQLTypes["BusinessCategoryWithoutBusinessCustomersUpdateInput"];
	["BusinessCategoryUpdateRecurrencesEntityRelationInput"]: GraphQLTypes["BusinessCategoryUpdateRecurrencesEntityRelationInput"];
	["BusinessCategoryUpdateRecurrencesRelationInput"]: GraphQLTypes["BusinessCategoryUpdateRecurrencesRelationInput"];
	["OrderRecurrenceWithoutBusinessCategoryUpdateInput"]: GraphQLTypes["OrderRecurrenceWithoutBusinessCategoryUpdateInput"];
	["OrderRecurrenceUpdateLocalesEntityRelationInput"]: GraphQLTypes["OrderRecurrenceUpdateLocalesEntityRelationInput"];
	["OrderRecurrenceUpdateLocalesRelationInput"]: GraphQLTypes["OrderRecurrenceUpdateLocalesRelationInput"];
	["OrderRecurrenceLocaleWithoutRootUpdateInput"]: GraphQLTypes["OrderRecurrenceLocaleWithoutRootUpdateInput"];
	["OrderRecurrenceLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["OrderRecurrenceLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutOrderRecurrencesUpdateInput"]: GraphQLTypes["LocaleWithoutOrderRecurrencesUpdateInput"];
	["LocaleUpdateAllergensEntityRelationInput"]: GraphQLTypes["LocaleUpdateAllergensEntityRelationInput"];
	["LocaleUpdateAllergensRelationInput"]: GraphQLTypes["LocaleUpdateAllergensRelationInput"];
	["AllergenLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["AllergenLocaleWithoutLocaleUpdateInput"];
	["AllergenLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["AllergenLocaleUpdateRootEntityRelationInput"];
	["AllergenWithoutLocalesUpdateInput"]: GraphQLTypes["AllergenWithoutLocalesUpdateInput"];
	["AllergenUpdateIngredientsEntityRelationInput"]: GraphQLTypes["AllergenUpdateIngredientsEntityRelationInput"];
	["AllergenUpdateIngredientsRelationInput"]: GraphQLTypes["AllergenUpdateIngredientsRelationInput"];
	["ProductIngredientWithoutAllergensUpdateInput"]: GraphQLTypes["ProductIngredientWithoutAllergensUpdateInput"];
	["ProductIngredientUpdatePreferredQuantityUnitEntityRelationInput"]: GraphQLTypes["ProductIngredientUpdatePreferredQuantityUnitEntityRelationInput"];
	["ProductIngredientItemQuantityUnitUpdateInput"]: GraphQLTypes["ProductIngredientItemQuantityUnitUpdateInput"];
	["ProductIngredientUpsertPreferredQuantityUnitRelationInput"]: GraphQLTypes["ProductIngredientUpsertPreferredQuantityUnitRelationInput"];
	["ProductIngredientUpdateFreshingContainerEntityRelationInput"]: GraphQLTypes["ProductIngredientUpdateFreshingContainerEntityRelationInput"];
	["FreshingContainerUpdateInput"]: GraphQLTypes["FreshingContainerUpdateInput"];
	["FreshingContainerUpdateWorkspaceEntityRelationInput"]: GraphQLTypes["FreshingContainerUpdateWorkspaceEntityRelationInput"];
	["WorkspaceWithoutFreshingContainersUpdateInput"]: GraphQLTypes["WorkspaceWithoutFreshingContainersUpdateInput"];
	["WorkspaceUpdateOpeningHoursEntityRelationInput"]: GraphQLTypes["WorkspaceUpdateOpeningHoursEntityRelationInput"];
	["WeekHoursUpdateInput"]: GraphQLTypes["WeekHoursUpdateInput"];
	["WorkspaceUpsertOpeningHoursRelationInput"]: GraphQLTypes["WorkspaceUpsertOpeningHoursRelationInput"];
	["WorkspaceUpdateWorkingHoursEntityRelationInput"]: GraphQLTypes["WorkspaceUpdateWorkingHoursEntityRelationInput"];
	["WorkspaceUpsertWorkingHoursRelationInput"]: GraphQLTypes["WorkspaceUpsertWorkingHoursRelationInput"];
	["WorkspaceUpdateDefaultFreshingContainerEntityRelationInput"]: GraphQLTypes["WorkspaceUpdateDefaultFreshingContainerEntityRelationInput"];
	["WorkspaceUpsertDefaultFreshingContainerRelationInput"]: GraphQLTypes["WorkspaceUpsertDefaultFreshingContainerRelationInput"];
	["WorkspaceUpdateCreditsProductEntityRelationInput"]: GraphQLTypes["WorkspaceUpdateCreditsProductEntityRelationInput"];
	["VirtualProductUpdateInput"]: GraphQLTypes["VirtualProductUpdateInput"];
	["VirtualProductUpdateProductEntityRelationInput"]: GraphQLTypes["VirtualProductUpdateProductEntityRelationInput"];
	["ProductWithoutVirtualProductUpdateInput"]: GraphQLTypes["ProductWithoutVirtualProductUpdateInput"];
	["ProductUpdateManagerEntityRelationInput"]: GraphQLTypes["ProductUpdateManagerEntityRelationInput"];
	["StocksManagerWithoutManagedProductsUpdateInput"]: GraphQLTypes["StocksManagerWithoutManagedProductsUpdateInput"];
	["StocksManagerUpdateStaffEntityRelationInput"]: GraphQLTypes["StocksManagerUpdateStaffEntityRelationInput"];
	["StaffWithoutStocksManagerUpdateInput"]: GraphQLTypes["StaffWithoutStocksManagerUpdateInput"];
	["StaffUpdateBartenderEntityRelationInput"]: GraphQLTypes["StaffUpdateBartenderEntityRelationInput"];
	["BartenderWithoutStaffUpdateInput"]: GraphQLTypes["BartenderWithoutStaffUpdateInput"];
	["StaffUpsertBartenderRelationInput"]: GraphQLTypes["StaffUpsertBartenderRelationInput"];
	["StaffUpdateCourierEntityRelationInput"]: GraphQLTypes["StaffUpdateCourierEntityRelationInput"];
	["CourierWithoutStaffUpdateInput"]: GraphQLTypes["CourierWithoutStaffUpdateInput"];
	["CourierUpdateRoutesEntityRelationInput"]: GraphQLTypes["CourierUpdateRoutesEntityRelationInput"];
	["CourierUpdateRoutesRelationInput"]: GraphQLTypes["CourierUpdateRoutesRelationInput"];
	["DeliveryRouteWithoutCourierUpdateInput"]: GraphQLTypes["DeliveryRouteWithoutCourierUpdateInput"];
	["DeliveryRouteUpdateWaypointsEntityRelationInput"]: GraphQLTypes["DeliveryRouteUpdateWaypointsEntityRelationInput"];
	["DeliveryRouteUpdateWaypointsRelationInput"]: GraphQLTypes["DeliveryRouteUpdateWaypointsRelationInput"];
	["DeliveryWaypointWithoutRouteUpdateInput"]: GraphQLTypes["DeliveryWaypointWithoutRouteUpdateInput"];
	["DeliveryWaypointUpdateDeliveryEntityRelationInput"]: GraphQLTypes["DeliveryWaypointUpdateDeliveryEntityRelationInput"];
	["OrderDeliveryWithoutDeliveryWaypointUpdateInput"]: GraphQLTypes["OrderDeliveryWithoutDeliveryWaypointUpdateInput"];
	["OrderDeliveryUpdateMethodEntityRelationInput"]: GraphQLTypes["OrderDeliveryUpdateMethodEntityRelationInput"];
	["DeliveryMethodUpdateInput"]: GraphQLTypes["DeliveryMethodUpdateInput"];
	["DeliveryMethodUpdateCourierHandlersEntityRelationInput"]: GraphQLTypes["DeliveryMethodUpdateCourierHandlersEntityRelationInput"];
	["DeliveryMethodUpdateCourierHandlersRelationInput"]: GraphQLTypes["DeliveryMethodUpdateCourierHandlersRelationInput"];
	["CourierWithoutDeliveryMethodsUpdateInput"]: GraphQLTypes["CourierWithoutDeliveryMethodsUpdateInput"];
	["CourierUpdateStaffEntityRelationInput"]: GraphQLTypes["CourierUpdateStaffEntityRelationInput"];
	["StaffWithoutCourierUpdateInput"]: GraphQLTypes["StaffWithoutCourierUpdateInput"];
	["StaffUpdateCleanerEntityRelationInput"]: GraphQLTypes["StaffUpdateCleanerEntityRelationInput"];
	["CleanerWithoutStaffUpdateInput"]: GraphQLTypes["CleanerWithoutStaffUpdateInput"];
	["StaffUpsertCleanerRelationInput"]: GraphQLTypes["StaffUpsertCleanerRelationInput"];
	["StaffUpdateShiftsManagerEntityRelationInput"]: GraphQLTypes["StaffUpdateShiftsManagerEntityRelationInput"];
	["ShiftsManagerWithoutStaffUpdateInput"]: GraphQLTypes["ShiftsManagerWithoutStaffUpdateInput"];
	["ShiftsManagerUpdateManagedRolesEntityRelationInput"]: GraphQLTypes["ShiftsManagerUpdateManagedRolesEntityRelationInput"];
	["ShiftsManagerUpdateManagedRolesRelationInput"]: GraphQLTypes["ShiftsManagerUpdateManagedRolesRelationInput"];
	["TimetableEmployeeRoleWithoutShiftsManagersUpdateInput"]: GraphQLTypes["TimetableEmployeeRoleWithoutShiftsManagersUpdateInput"];
	["TimetableEmployeeRoleUpdateShiftGroupsEntityRelationInput"]: GraphQLTypes["TimetableEmployeeRoleUpdateShiftGroupsEntityRelationInput"];
	["TimetableEmployeeRoleUpdateShiftGroupsRelationInput"]: GraphQLTypes["TimetableEmployeeRoleUpdateShiftGroupsRelationInput"];
	["TimetableShiftGroupWithoutTypeUpdateInput"]: GraphQLTypes["TimetableShiftGroupWithoutTypeUpdateInput"];
	["TimetableShiftGroupUpdateShiftsEntityRelationInput"]: GraphQLTypes["TimetableShiftGroupUpdateShiftsEntityRelationInput"];
	["TimetableShiftGroupUpdateShiftsRelationInput"]: GraphQLTypes["TimetableShiftGroupUpdateShiftsRelationInput"];
	["TimetableShiftWithoutGroupUpdateInput"]: GraphQLTypes["TimetableShiftWithoutGroupUpdateInput"];
	["TimetableShiftUpdateShiftsProfileEntityRelationInput"]: GraphQLTypes["TimetableShiftUpdateShiftsProfileEntityRelationInput"];
	["ShiftsProfileWithoutShiftsUpdateInput"]: GraphQLTypes["ShiftsProfileWithoutShiftsUpdateInput"];
	["ShiftsProfileUpdateQueueItemsEntityRelationInput"]: GraphQLTypes["ShiftsProfileUpdateQueueItemsEntityRelationInput"];
	["ShiftsProfileUpdateQueueItemsRelationInput"]: GraphQLTypes["ShiftsProfileUpdateQueueItemsRelationInput"];
	["EmployeeQueueItemWithoutShiftsProfileUpdateInput"]: GraphQLTypes["EmployeeQueueItemWithoutShiftsProfileUpdateInput"];
	["EmployeeQueueItemUpdateQueueEntityRelationInput"]: GraphQLTypes["EmployeeQueueItemUpdateQueueEntityRelationInput"];
	["EmployeeQueueWithoutItemsUpdateInput"]: GraphQLTypes["EmployeeQueueWithoutItemsUpdateInput"];
	["EmployeeQueueUpdateShiftGroupEntityRelationInput"]: GraphQLTypes["EmployeeQueueUpdateShiftGroupEntityRelationInput"];
	["TimetableShiftGroupWithoutQueueUpdateInput"]: GraphQLTypes["TimetableShiftGroupWithoutQueueUpdateInput"];
	["TimetableShiftGroupUpdateDayEntityRelationInput"]: GraphQLTypes["TimetableShiftGroupUpdateDayEntityRelationInput"];
	["TimetableDayWithoutShiftGroupsUpdateInput"]: GraphQLTypes["TimetableDayWithoutShiftGroupsUpdateInput"];
	["TimetableDayUpdateNotesEntityRelationInput"]: GraphQLTypes["TimetableDayUpdateNotesEntityRelationInput"];
	["TimetableDayUpdateNotesRelationInput"]: GraphQLTypes["TimetableDayUpdateNotesRelationInput"];
	["TimetableDayNoteWithoutDayUpdateInput"]: GraphQLTypes["TimetableDayNoteWithoutDayUpdateInput"];
	["TimetableDayNoteUpdateRoleEntityRelationInput"]: GraphQLTypes["TimetableDayNoteUpdateRoleEntityRelationInput"];
	["TimetableEmployeeRoleUpdateInput"]: GraphQLTypes["TimetableEmployeeRoleUpdateInput"];
	["TimetableEmployeeRoleUpdateShiftsProfilesEntityRelationInput"]: GraphQLTypes["TimetableEmployeeRoleUpdateShiftsProfilesEntityRelationInput"];
	["TimetableEmployeeRoleUpdateShiftsProfilesRelationInput"]: GraphQLTypes["TimetableEmployeeRoleUpdateShiftsProfilesRelationInput"];
	["ShiftsProfileWithoutRolesUpdateInput"]: GraphQLTypes["ShiftsProfileWithoutRolesUpdateInput"];
	["ShiftsProfileUpdateStaffEntityRelationInput"]: GraphQLTypes["ShiftsProfileUpdateStaffEntityRelationInput"];
	["StaffWithoutShiftsProfileUpdateInput"]: GraphQLTypes["StaffWithoutShiftsProfileUpdateInput"];
	["StaffUpdateBusinessToBusinessManagerEntityRelationInput"]: GraphQLTypes["StaffUpdateBusinessToBusinessManagerEntityRelationInput"];
	["BusinessToBusinessManagerWithoutStaffUpdateInput"]: GraphQLTypes["BusinessToBusinessManagerWithoutStaffUpdateInput"];
	["BusinessToBusinessManagerUpdateManagedBusinessesEntityRelationInput"]: GraphQLTypes["BusinessToBusinessManagerUpdateManagedBusinessesEntityRelationInput"];
	["BusinessToBusinessManagerUpdateManagedBusinessesRelationInput"]: GraphQLTypes["BusinessToBusinessManagerUpdateManagedBusinessesRelationInput"];
	["BusinessCustomerWithoutAccountManagerUpdateInput"]: GraphQLTypes["BusinessCustomerWithoutAccountManagerUpdateInput"];
	["BusinessCustomerUpdateMembersEntityRelationInput"]: GraphQLTypes["BusinessCustomerUpdateMembersEntityRelationInput"];
	["BusinessCustomerUpdateMembersRelationInput"]: GraphQLTypes["BusinessCustomerUpdateMembersRelationInput"];
	["CustomerWithoutMemberOfBusinessesUpdateInput"]: GraphQLTypes["CustomerWithoutMemberOfBusinessesUpdateInput"];
	["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]: GraphQLTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"];
	["CustomerUpdateOwnerOfBusinessesRelationInput"]: GraphQLTypes["CustomerUpdateOwnerOfBusinessesRelationInput"];
	["BusinessCustomerWithoutOwnersUpdateInput"]: GraphQLTypes["BusinessCustomerWithoutOwnersUpdateInput"];
	["BusinessCustomerUpdateAccountManagerEntityRelationInput"]: GraphQLTypes["BusinessCustomerUpdateAccountManagerEntityRelationInput"];
	["BusinessToBusinessManagerWithoutManagedBusinessesUpdateInput"]: GraphQLTypes["BusinessToBusinessManagerWithoutManagedBusinessesUpdateInput"];
	["BusinessToBusinessManagerUpdateStaffEntityRelationInput"]: GraphQLTypes["BusinessToBusinessManagerUpdateStaffEntityRelationInput"];
	["StaffWithoutBusinessToBusinessManagerUpdateInput"]: GraphQLTypes["StaffWithoutBusinessToBusinessManagerUpdateInput"];
	["StaffUpdateUserEntityRelationInput"]: GraphQLTypes["StaffUpdateUserEntityRelationInput"];
	["UserWithoutStaffUpdateInput"]: GraphQLTypes["UserWithoutStaffUpdateInput"];
	["UserUpdateCustomerEntityRelationInput"]: GraphQLTypes["UserUpdateCustomerEntityRelationInput"];
	["CustomerWithoutUserUpdateInput"]: GraphQLTypes["CustomerWithoutUserUpdateInput"];
	["CustomerUpdateCartsEntityRelationInput"]: GraphQLTypes["CustomerUpdateCartsEntityRelationInput"];
	["CustomerUpdateCartsRelationInput"]: GraphQLTypes["CustomerUpdateCartsRelationInput"];
	["CartWithoutCustomerUpdateInput"]: GraphQLTypes["CartWithoutCustomerUpdateInput"];
	["CartUpdateOrderEntityRelationInput"]: GraphQLTypes["CartUpdateOrderEntityRelationInput"];
	["OrderWithoutCartUpdateInput"]: GraphQLTypes["OrderWithoutCartUpdateInput"];
	["OrderUpdateCustomerEntityRelationInput"]: GraphQLTypes["OrderUpdateCustomerEntityRelationInput"];
	["CustomerWithoutOrdersUpdateInput"]: GraphQLTypes["CustomerWithoutOrdersUpdateInput"];
	["CustomerUpdateShortcutListEntityRelationInput"]: GraphQLTypes["CustomerUpdateShortcutListEntityRelationInput"];
	["ApplicationShortcutListWithoutCustomerUpdateInput"]: GraphQLTypes["ApplicationShortcutListWithoutCustomerUpdateInput"];
	["ApplicationShortcutListUpdateItemsEntityRelationInput"]: GraphQLTypes["ApplicationShortcutListUpdateItemsEntityRelationInput"];
	["ApplicationShortcutListUpdateItemsRelationInput"]: GraphQLTypes["ApplicationShortcutListUpdateItemsRelationInput"];
	["ApplicationShortcutListItemWithoutListUpdateInput"]: GraphQLTypes["ApplicationShortcutListItemWithoutListUpdateInput"];
	["ApplicationShortcutListItemUpdateApplicationEntityRelationInput"]: GraphQLTypes["ApplicationShortcutListItemUpdateApplicationEntityRelationInput"];
	["ApplicationUpdateInput"]: GraphQLTypes["ApplicationUpdateInput"];
	["ApplicationUpdateIconEntityRelationInput"]: GraphQLTypes["ApplicationUpdateIconEntityRelationInput"];
	["ApplicationUpsertIconRelationInput"]: GraphQLTypes["ApplicationUpsertIconRelationInput"];
	["ApplicationShortcutListItemUpsertApplicationRelationInput"]: GraphQLTypes["ApplicationShortcutListItemUpsertApplicationRelationInput"];
	["ApplicationShortcutListUpsertItemsRelationInput"]: GraphQLTypes["ApplicationShortcutListUpsertItemsRelationInput"];
	["CustomerUpsertShortcutListRelationInput"]: GraphQLTypes["CustomerUpsertShortcutListRelationInput"];
	["CustomerUpdateUserEntityRelationInput"]: GraphQLTypes["CustomerUpdateUserEntityRelationInput"];
	["UserWithoutCustomerUpdateInput"]: GraphQLTypes["UserWithoutCustomerUpdateInput"];
	["UserUpdateStaffEntityRelationInput"]: GraphQLTypes["UserUpdateStaffEntityRelationInput"];
	["StaffWithoutUserUpdateInput"]: GraphQLTypes["StaffWithoutUserUpdateInput"];
	["StaffUpdateShiftsProfileEntityRelationInput"]: GraphQLTypes["StaffUpdateShiftsProfileEntityRelationInput"];
	["ShiftsProfileWithoutStaffUpdateInput"]: GraphQLTypes["ShiftsProfileWithoutStaffUpdateInput"];
	["ShiftsProfileUpdateRolesEntityRelationInput"]: GraphQLTypes["ShiftsProfileUpdateRolesEntityRelationInput"];
	["ShiftsProfileUpdateRolesRelationInput"]: GraphQLTypes["ShiftsProfileUpdateRolesRelationInput"];
	["TimetableEmployeeRoleWithoutShiftsProfilesUpdateInput"]: GraphQLTypes["TimetableEmployeeRoleWithoutShiftsProfilesUpdateInput"];
	["TimetableEmployeeRoleUpdateShiftsManagersEntityRelationInput"]: GraphQLTypes["TimetableEmployeeRoleUpdateShiftsManagersEntityRelationInput"];
	["TimetableEmployeeRoleUpdateShiftsManagersRelationInput"]: GraphQLTypes["TimetableEmployeeRoleUpdateShiftsManagersRelationInput"];
	["ShiftsManagerWithoutManagedRolesUpdateInput"]: GraphQLTypes["ShiftsManagerWithoutManagedRolesUpdateInput"];
	["ShiftsManagerUpdateStaffEntityRelationInput"]: GraphQLTypes["ShiftsManagerUpdateStaffEntityRelationInput"];
	["StaffWithoutShiftsManagerUpdateInput"]: GraphQLTypes["StaffWithoutShiftsManagerUpdateInput"];
	["StaffUpdateStocksManagerEntityRelationInput"]: GraphQLTypes["StaffUpdateStocksManagerEntityRelationInput"];
	["StocksManagerWithoutStaffUpdateInput"]: GraphQLTypes["StocksManagerWithoutStaffUpdateInput"];
	["StocksManagerUpdateManagedProductsEntityRelationInput"]: GraphQLTypes["StocksManagerUpdateManagedProductsEntityRelationInput"];
	["StocksManagerUpdateManagedProductsRelationInput"]: GraphQLTypes["StocksManagerUpdateManagedProductsRelationInput"];
	["ProductWithoutManagerUpdateInput"]: GraphQLTypes["ProductWithoutManagerUpdateInput"];
	["ProductUpdateOrderItemsEntityRelationInput"]: GraphQLTypes["ProductUpdateOrderItemsEntityRelationInput"];
	["ProductUpdateOrderItemsRelationInput"]: GraphQLTypes["ProductUpdateOrderItemsRelationInput"];
	["OrderItemWithoutProductUpdateInput"]: GraphQLTypes["OrderItemWithoutProductUpdateInput"];
	["OrderItemUpdateVatRateEntityRelationInput"]: GraphQLTypes["OrderItemUpdateVatRateEntityRelationInput"];
	["OrderItemUpsertVatRateRelationInput"]: GraphQLTypes["OrderItemUpsertVatRateRelationInput"];
	["OrderItemUpdateOrderEntityRelationInput"]: GraphQLTypes["OrderItemUpdateOrderEntityRelationInput"];
	["OrderWithoutItemsUpdateInput"]: GraphQLTypes["OrderWithoutItemsUpdateInput"];
	["OrderUpdateDiscountsEntityRelationInput"]: GraphQLTypes["OrderUpdateDiscountsEntityRelationInput"];
	["OrderUpdateDiscountsRelationInput"]: GraphQLTypes["OrderUpdateDiscountsRelationInput"];
	["OrderDiscountWithoutOrderUpdateInput"]: GraphQLTypes["OrderDiscountWithoutOrderUpdateInput"];
	["OrderDiscountUpdateVatRateEntityRelationInput"]: GraphQLTypes["OrderDiscountUpdateVatRateEntityRelationInput"];
	["OrderDiscountUpsertVatRateRelationInput"]: GraphQLTypes["OrderDiscountUpsertVatRateRelationInput"];
	["OrderDiscountUpdateCustomerCreditTransactionsEntityRelationInput"]: GraphQLTypes["OrderDiscountUpdateCustomerCreditTransactionsEntityRelationInput"];
	["OrderDiscountUpdateCustomerCreditTransactionsRelationInput"]: GraphQLTypes["OrderDiscountUpdateCustomerCreditTransactionsRelationInput"];
	["CustomerCreditTransactionWithoutOrderDiscountUpdateInput"]: GraphQLTypes["CustomerCreditTransactionWithoutOrderDiscountUpdateInput"];
	["CustomerCreditTransactionUpdateCustomerCreditEntityRelationInput"]: GraphQLTypes["CustomerCreditTransactionUpdateCustomerCreditEntityRelationInput"];
	["CustomerCreditWithoutTransactionsUpdateInput"]: GraphQLTypes["CustomerCreditWithoutTransactionsUpdateInput"];
	["CustomerCreditUpdateCustomerEntityRelationInput"]: GraphQLTypes["CustomerCreditUpdateCustomerEntityRelationInput"];
	["CustomerWithoutCreditsUpdateInput"]: GraphQLTypes["CustomerWithoutCreditsUpdateInput"];
	["CustomerUpdateChannelsEntityRelationInput"]: GraphQLTypes["CustomerUpdateChannelsEntityRelationInput"];
	["CustomerUpdateChannelsRelationInput"]: GraphQLTypes["CustomerUpdateChannelsRelationInput"];
	["ChannelWithoutCustomersUpdateInput"]: GraphQLTypes["ChannelWithoutCustomersUpdateInput"];
	["ChannelUpdatePublicTagsEntityRelationInput"]: GraphQLTypes["ChannelUpdatePublicTagsEntityRelationInput"];
	["ChannelUpdatePublicTagsRelationInput"]: GraphQLTypes["ChannelUpdatePublicTagsRelationInput"];
	["TagWithoutPublicInChannelsUpdateInput"]: GraphQLTypes["TagWithoutPublicInChannelsUpdateInput"];
	["TagUpdateAllowChannelPaymentsEntityRelationInput"]: GraphQLTypes["TagUpdateAllowChannelPaymentsEntityRelationInput"];
	["TagUpdateAllowChannelPaymentsRelationInput"]: GraphQLTypes["TagUpdateAllowChannelPaymentsRelationInput"];
	["ChannelPaymentWithoutAllowOnlyForTagsUpdateInput"]: GraphQLTypes["ChannelPaymentWithoutAllowOnlyForTagsUpdateInput"];
	["ChannelPaymentUpdateVatRateEntityRelationInput"]: GraphQLTypes["ChannelPaymentUpdateVatRateEntityRelationInput"];
	["VatRateWithoutChannelPaymentsUpdateInput"]: GraphQLTypes["VatRateWithoutChannelPaymentsUpdateInput"];
	["ChannelPaymentUpsertVatRateRelationInput"]: GraphQLTypes["ChannelPaymentUpsertVatRateRelationInput"];
	["TagUpsertAllowChannelPaymentsRelationInput"]: GraphQLTypes["TagUpsertAllowChannelPaymentsRelationInput"];
	["TagUpdateFulfillmentNotesEntityRelationInput"]: GraphQLTypes["TagUpdateFulfillmentNotesEntityRelationInput"];
	["TagUpdateFulfillmentNotesRelationInput"]: GraphQLTypes["TagUpdateFulfillmentNotesRelationInput"];
	["FulfillmentNoteWithoutTagsUpdateInput"]: GraphQLTypes["FulfillmentNoteWithoutTagsUpdateInput"];
	["FulfillmentNoteUpdateProductsEntityRelationInput"]: GraphQLTypes["FulfillmentNoteUpdateProductsEntityRelationInput"];
	["FulfillmentNoteUpdateProductsRelationInput"]: GraphQLTypes["FulfillmentNoteUpdateProductsRelationInput"];
	["ProductWithoutFulfillmentNotesUpdateInput"]: GraphQLTypes["ProductWithoutFulfillmentNotesUpdateInput"];
	["ProductUpdateInheritedCategoriesEntityRelationInput"]: GraphQLTypes["ProductUpdateInheritedCategoriesEntityRelationInput"];
	["ProductUpdateDeliveryZonesEntityRelationInput"]: GraphQLTypes["ProductUpdateDeliveryZonesEntityRelationInput"];
	["ProductUpdateDeliveryZonesRelationInput"]: GraphQLTypes["ProductUpdateDeliveryZonesRelationInput"];
	["DeliveryZoneWithoutDeliveryZonesOfProductsUpdateInput"]: GraphQLTypes["DeliveryZoneWithoutDeliveryZonesOfProductsUpdateInput"];
	["DeliveryZoneUpdateDeliveryZonesOfTagsEntityRelationInput"]: GraphQLTypes["DeliveryZoneUpdateDeliveryZonesOfTagsEntityRelationInput"];
	["DeliveryZoneUpdateDeliveryZonesOfTagsRelationInput"]: GraphQLTypes["DeliveryZoneUpdateDeliveryZonesOfTagsRelationInput"];
	["TagWithoutDeliveryZonesUpdateInput"]: GraphQLTypes["TagWithoutDeliveryZonesUpdateInput"];
	["TagUpdatePublicInChannelsEntityRelationInput"]: GraphQLTypes["TagUpdatePublicInChannelsEntityRelationInput"];
	["TagUpdatePublicInChannelsRelationInput"]: GraphQLTypes["TagUpdatePublicInChannelsRelationInput"];
	["ChannelWithoutPublicTagsUpdateInput"]: GraphQLTypes["ChannelWithoutPublicTagsUpdateInput"];
	["ChannelUpdateVenueEntityRelationInput"]: GraphQLTypes["ChannelUpdateVenueEntityRelationInput"];
	["VenueWithoutChannelsUpdateInput"]: GraphQLTypes["VenueWithoutChannelsUpdateInput"];
	["VenueUpdateDeadlineTemplateEntityRelationInput"]: GraphQLTypes["VenueUpdateDeadlineTemplateEntityRelationInput"];
	["DeadlineTemplateWithoutVenueUpdateInput"]: GraphQLTypes["DeadlineTemplateWithoutVenueUpdateInput"];
	["VenueUpsertDeadlineTemplateRelationInput"]: GraphQLTypes["VenueUpsertDeadlineTemplateRelationInput"];
	["VenueUpdateTimetableDaysEntityRelationInput"]: GraphQLTypes["VenueUpdateTimetableDaysEntityRelationInput"];
	["VenueUpdateTimetableDaysRelationInput"]: GraphQLTypes["VenueUpdateTimetableDaysRelationInput"];
	["TimetableDayWithoutVenueUpdateInput"]: GraphQLTypes["TimetableDayWithoutVenueUpdateInput"];
	["TimetableDayUpdateShiftGroupsEntityRelationInput"]: GraphQLTypes["TimetableDayUpdateShiftGroupsEntityRelationInput"];
	["TimetableDayUpdateShiftGroupsRelationInput"]: GraphQLTypes["TimetableDayUpdateShiftGroupsRelationInput"];
	["TimetableShiftGroupWithoutDayUpdateInput"]: GraphQLTypes["TimetableShiftGroupWithoutDayUpdateInput"];
	["TimetableShiftGroupUpdateTypeEntityRelationInput"]: GraphQLTypes["TimetableShiftGroupUpdateTypeEntityRelationInput"];
	["TimetableEmployeeRoleWithoutShiftGroupsUpdateInput"]: GraphQLTypes["TimetableEmployeeRoleWithoutShiftGroupsUpdateInput"];
	["TimetableEmployeeRoleUpdateTimetableTemplatesEntityRelationInput"]: GraphQLTypes["TimetableEmployeeRoleUpdateTimetableTemplatesEntityRelationInput"];
	["TimetableEmployeeRoleUpdateTimetableTemplatesRelationInput"]: GraphQLTypes["TimetableEmployeeRoleUpdateTimetableTemplatesRelationInput"];
	["TimetableTemplateWithoutEmployeeRoleUpdateInput"]: GraphQLTypes["TimetableTemplateWithoutEmployeeRoleUpdateInput"];
	["TimetableTemplateUpdatePositionEntityRelationInput"]: GraphQLTypes["TimetableTemplateUpdatePositionEntityRelationInput"];
	["TimetableShiftPositionWithoutTimetableTemplatesUpdateInput"]: GraphQLTypes["TimetableShiftPositionWithoutTimetableTemplatesUpdateInput"];
	["TimetableShiftPositionUpdateShiftGroupsEntityRelationInput"]: GraphQLTypes["TimetableShiftPositionUpdateShiftGroupsEntityRelationInput"];
	["TimetableShiftPositionUpdateShiftGroupsRelationInput"]: GraphQLTypes["TimetableShiftPositionUpdateShiftGroupsRelationInput"];
	["TimetableShiftGroupWithoutPositionUpdateInput"]: GraphQLTypes["TimetableShiftGroupWithoutPositionUpdateInput"];
	["TimetableShiftGroupUpdateQueueEntityRelationInput"]: GraphQLTypes["TimetableShiftGroupUpdateQueueEntityRelationInput"];
	["EmployeeQueueWithoutShiftGroupUpdateInput"]: GraphQLTypes["EmployeeQueueWithoutShiftGroupUpdateInput"];
	["EmployeeQueueUpdateItemsEntityRelationInput"]: GraphQLTypes["EmployeeQueueUpdateItemsEntityRelationInput"];
	["EmployeeQueueUpdateItemsRelationInput"]: GraphQLTypes["EmployeeQueueUpdateItemsRelationInput"];
	["EmployeeQueueItemWithoutQueueUpdateInput"]: GraphQLTypes["EmployeeQueueItemWithoutQueueUpdateInput"];
	["EmployeeQueueItemUpdateShiftsProfileEntityRelationInput"]: GraphQLTypes["EmployeeQueueItemUpdateShiftsProfileEntityRelationInput"];
	["ShiftsProfileWithoutQueueItemsUpdateInput"]: GraphQLTypes["ShiftsProfileWithoutQueueItemsUpdateInput"];
	["ShiftsProfileUpdateShiftsEntityRelationInput"]: GraphQLTypes["ShiftsProfileUpdateShiftsEntityRelationInput"];
	["ShiftsProfileUpdateShiftsRelationInput"]: GraphQLTypes["ShiftsProfileUpdateShiftsRelationInput"];
	["TimetableShiftWithoutShiftsProfileUpdateInput"]: GraphQLTypes["TimetableShiftWithoutShiftsProfileUpdateInput"];
	["TimetableShiftUpdateGroupEntityRelationInput"]: GraphQLTypes["TimetableShiftUpdateGroupEntityRelationInput"];
	["TimetableShiftGroupWithoutShiftsUpdateInput"]: GraphQLTypes["TimetableShiftGroupWithoutShiftsUpdateInput"];
	["TimetableShiftGroupUpdatePositionEntityRelationInput"]: GraphQLTypes["TimetableShiftGroupUpdatePositionEntityRelationInput"];
	["TimetableShiftPositionWithoutShiftGroupsUpdateInput"]: GraphQLTypes["TimetableShiftPositionWithoutShiftGroupsUpdateInput"];
	["TimetableShiftPositionUpdateTimetableTemplatesEntityRelationInput"]: GraphQLTypes["TimetableShiftPositionUpdateTimetableTemplatesEntityRelationInput"];
	["TimetableShiftPositionUpdateTimetableTemplatesRelationInput"]: GraphQLTypes["TimetableShiftPositionUpdateTimetableTemplatesRelationInput"];
	["TimetableTemplateWithoutPositionUpdateInput"]: GraphQLTypes["TimetableTemplateWithoutPositionUpdateInput"];
	["TimetableTemplateUpdateStaffOptionsEntityRelationInput"]: GraphQLTypes["TimetableTemplateUpdateStaffOptionsEntityRelationInput"];
	["TimetableTemplateUpdateStaffOptionsRelationInput"]: GraphQLTypes["TimetableTemplateUpdateStaffOptionsRelationInput"];
	["TimetableTemplateStaffOptionsWithoutTimetableTemplateUpdateInput"]: GraphQLTypes["TimetableTemplateStaffOptionsWithoutTimetableTemplateUpdateInput"];
	["TimetableTemplateStaffOptionsUpdateAutoAssignedEmployeeEntityRelationInput"]: GraphQLTypes["TimetableTemplateStaffOptionsUpdateAutoAssignedEmployeeEntityRelationInput"];
	["ShiftsProfileUpdateInput"]: GraphQLTypes["ShiftsProfileUpdateInput"];
	["TimetableTemplateStaffOptionsUpsertAutoAssignedEmployeeRelationInput"]: GraphQLTypes["TimetableTemplateStaffOptionsUpsertAutoAssignedEmployeeRelationInput"];
	["TimetableTemplateUpsertStaffOptionsRelationInput"]: GraphQLTypes["TimetableTemplateUpsertStaffOptionsRelationInput"];
	["TimetableTemplateUpdateVenueEntityRelationInput"]: GraphQLTypes["TimetableTemplateUpdateVenueEntityRelationInput"];
	["VenueWithoutTimetableTemplatesUpdateInput"]: GraphQLTypes["VenueWithoutTimetableTemplatesUpdateInput"];
	["VenueUpdateStaffMembersEntityRelationInput"]: GraphQLTypes["VenueUpdateStaffMembersEntityRelationInput"];
	["VenueUpdateStaffMembersRelationInput"]: GraphQLTypes["VenueUpdateStaffMembersRelationInput"];
	["StaffWithoutVenuesUpdateInput"]: GraphQLTypes["StaffWithoutVenuesUpdateInput"];
	["StaffUpdatePhotoEntityRelationInput"]: GraphQLTypes["StaffUpdatePhotoEntityRelationInput"];
	["StaffUpsertPhotoRelationInput"]: GraphQLTypes["StaffUpsertPhotoRelationInput"];
	["StaffUpdateCourierManagerEntityRelationInput"]: GraphQLTypes["StaffUpdateCourierManagerEntityRelationInput"];
	["CourierManagerWithoutStaffUpdateInput"]: GraphQLTypes["CourierManagerWithoutStaffUpdateInput"];
	["StaffUpsertCourierManagerRelationInput"]: GraphQLTypes["StaffUpsertCourierManagerRelationInput"];
	["StaffUpdatePickerEntityRelationInput"]: GraphQLTypes["StaffUpdatePickerEntityRelationInput"];
	["PickerWithoutStaffUpdateInput"]: GraphQLTypes["PickerWithoutStaffUpdateInput"];
	["StaffUpsertPickerRelationInput"]: GraphQLTypes["StaffUpsertPickerRelationInput"];
	["StaffUpdateRemunerationProfileEntityRelationInput"]: GraphQLTypes["StaffUpdateRemunerationProfileEntityRelationInput"];
	["RemunerationProfileWithoutStaffUpdateInput"]: GraphQLTypes["RemunerationProfileWithoutStaffUpdateInput"];
	["RemunerationProfileUpdateEmploymentInformationEntityRelationInput"]: GraphQLTypes["RemunerationProfileUpdateEmploymentInformationEntityRelationInput"];
	["RemunerationProfileUpdateEmploymentInformationRelationInput"]: GraphQLTypes["RemunerationProfileUpdateEmploymentInformationRelationInput"];
	["EmploymentInformationWithoutRemunerationProfilesUpdateInput"]: GraphQLTypes["EmploymentInformationWithoutRemunerationProfilesUpdateInput"];
	["RemunerationProfileUpsertEmploymentInformationRelationInput"]: GraphQLTypes["RemunerationProfileUpsertEmploymentInformationRelationInput"];
	["RemunerationProfileUpdateWorkMonthsEntityRelationInput"]: GraphQLTypes["RemunerationProfileUpdateWorkMonthsEntityRelationInput"];
	["WorkMonthWithoutRemunerationProfileUpdateInput"]: GraphQLTypes["WorkMonthWithoutRemunerationProfileUpdateInput"];
	["RemunerationProfileUpsertWorkMonthsRelationInput"]: GraphQLTypes["RemunerationProfileUpsertWorkMonthsRelationInput"];
	["StaffUpsertRemunerationProfileRelationInput"]: GraphQLTypes["StaffUpsertRemunerationProfileRelationInput"];
	["StaffUpdateCashierEntityRelationInput"]: GraphQLTypes["StaffUpdateCashierEntityRelationInput"];
	["CashierWithoutStaffUpdateInput"]: GraphQLTypes["CashierWithoutStaffUpdateInput"];
	["StaffUpsertCashierRelationInput"]: GraphQLTypes["StaffUpsertCashierRelationInput"];
	["StaffUpdateInternalBuyerEntityRelationInput"]: GraphQLTypes["StaffUpdateInternalBuyerEntityRelationInput"];
	["InternalBuyerWithoutStaffUpdateInput"]: GraphQLTypes["InternalBuyerWithoutStaffUpdateInput"];
	["StaffUpsertInternalBuyerRelationInput"]: GraphQLTypes["StaffUpsertInternalBuyerRelationInput"];
	["StaffUpdateSalesManagerEntityRelationInput"]: GraphQLTypes["StaffUpdateSalesManagerEntityRelationInput"];
	["SalesManagerWithoutStaffUpdateInput"]: GraphQLTypes["SalesManagerWithoutStaffUpdateInput"];
	["SalesManagerUpdateCountriesEntityRelationInput"]: GraphQLTypes["SalesManagerUpdateCountriesEntityRelationInput"];
	["SalesManagerUpdateCountriesRelationInput"]: GraphQLTypes["SalesManagerUpdateCountriesRelationInput"];
	["SalesManagerUpsertCountriesRelationInput"]: GraphQLTypes["SalesManagerUpsertCountriesRelationInput"];
	["StaffUpsertSalesManagerRelationInput"]: GraphQLTypes["StaffUpsertSalesManagerRelationInput"];
	["StaffUpdateCashierManagerEntityRelationInput"]: GraphQLTypes["StaffUpdateCashierManagerEntityRelationInput"];
	["CashierManagerWithoutStaffUpdateInput"]: GraphQLTypes["CashierManagerWithoutStaffUpdateInput"];
	["StaffUpsertCashierManagerRelationInput"]: GraphQLTypes["StaffUpsertCashierManagerRelationInput"];
	["VenueUpsertStaffMembersRelationInput"]: GraphQLTypes["VenueUpsertStaffMembersRelationInput"];
	["VenueUpdateEmployeeRolesEntityRelationInput"]: GraphQLTypes["VenueUpdateEmployeeRolesEntityRelationInput"];
	["VenueUpdateEmployeeRolesRelationInput"]: GraphQLTypes["VenueUpdateEmployeeRolesRelationInput"];
	["VenueEmployeeRoleWithoutVenueUpdateInput"]: GraphQLTypes["VenueEmployeeRoleWithoutVenueUpdateInput"];
	["VenueEmployeeRoleUpdateEmployeePrivilegesEntityRelationInput"]: GraphQLTypes["VenueEmployeeRoleUpdateEmployeePrivilegesEntityRelationInput"];
	["TimetablesEmployeePrivilegesWithoutVenueEmployeeRoleUpdateInput"]: GraphQLTypes["TimetablesEmployeePrivilegesWithoutVenueEmployeeRoleUpdateInput"];
	["VenueEmployeeRoleUpsertEmployeePrivilegesRelationInput"]: GraphQLTypes["VenueEmployeeRoleUpsertEmployeePrivilegesRelationInput"];
	["VenueEmployeeRoleUpdateRoleEntityRelationInput"]: GraphQLTypes["VenueEmployeeRoleUpdateRoleEntityRelationInput"];
	["VenueEmployeeRoleUpsertRoleRelationInput"]: GraphQLTypes["VenueEmployeeRoleUpsertRoleRelationInput"];
	["VenueUpsertEmployeeRolesRelationInput"]: GraphQLTypes["VenueUpsertEmployeeRolesRelationInput"];
	["VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput"]: GraphQLTypes["VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput"];
	["VenueUpdatePointOfSaleApplicationDevicesRelationInput"]: GraphQLTypes["VenueUpdatePointOfSaleApplicationDevicesRelationInput"];
	["PointOfSaleApplicationDeviceWithoutVenueUpdateInput"]: GraphQLTypes["PointOfSaleApplicationDeviceWithoutVenueUpdateInput"];
	["PointOfSaleApplicationDeviceUpdateIdentificationCodeEntityRelationInput"]: GraphQLTypes["PointOfSaleApplicationDeviceUpdateIdentificationCodeEntityRelationInput"];
	["IdentificationCodeWithoutApplicationDevicesUpdateInput"]: GraphQLTypes["IdentificationCodeWithoutApplicationDevicesUpdateInput"];
	["IdentificationCodeUpdateAttemptsEntityRelationInput"]: GraphQLTypes["IdentificationCodeUpdateAttemptsEntityRelationInput"];
	["IdentificationCodeUpdateAttemptsRelationInput"]: GraphQLTypes["IdentificationCodeUpdateAttemptsRelationInput"];
	["IdentificationAttemptWithoutCodeUpdateInput"]: GraphQLTypes["IdentificationAttemptWithoutCodeUpdateInput"];
	["IdentificationAttemptUpdateUserEntityRelationInput"]: GraphQLTypes["IdentificationAttemptUpdateUserEntityRelationInput"];
	["UserWithoutIdentificationAttemptsUpdateInput"]: GraphQLTypes["UserWithoutIdentificationAttemptsUpdateInput"];
	["UserUpdateDevicesEntityRelationInput"]: GraphQLTypes["UserUpdateDevicesEntityRelationInput"];
	["UserUpdateDevicesRelationInput"]: GraphQLTypes["UserUpdateDevicesRelationInput"];
	["UserDeviceWithoutUserUpdateInput"]: GraphQLTypes["UserDeviceWithoutUserUpdateInput"];
	["UserDeviceUpdateAnonymousSessionEntityRelationInput"]: GraphQLTypes["UserDeviceUpdateAnonymousSessionEntityRelationInput"];
	["AnonymousSessionWithoutDevicesUpdateInput"]: GraphQLTypes["AnonymousSessionWithoutDevicesUpdateInput"];
	["AnonymousSessionUpdateCustomerEntityRelationInput"]: GraphQLTypes["AnonymousSessionUpdateCustomerEntityRelationInput"];
	["CustomerWithoutAnonymousSessionUpdateInput"]: GraphQLTypes["CustomerWithoutAnonymousSessionUpdateInput"];
	["CustomerUpdateInvoicesEntityRelationInput"]: GraphQLTypes["CustomerUpdateInvoicesEntityRelationInput"];
	["CustomerUpdateInvoicesRelationInput"]: GraphQLTypes["CustomerUpdateInvoicesRelationInput"];
	["InvoiceWithoutCustomerUpdateInput"]: GraphQLTypes["InvoiceWithoutCustomerUpdateInput"];
	["InvoiceUpdateOrderPaymentsEntityRelationInput"]: GraphQLTypes["InvoiceUpdateOrderPaymentsEntityRelationInput"];
	["InvoiceUpdateOrderPaymentsRelationInput"]: GraphQLTypes["InvoiceUpdateOrderPaymentsRelationInput"];
	["OrderPaymentWithoutInvoiceUpdateInput"]: GraphQLTypes["OrderPaymentWithoutInvoiceUpdateInput"];
	["OrderPaymentUpdateMethodEntityRelationInput"]: GraphQLTypes["OrderPaymentUpdateMethodEntityRelationInput"];
	["OrderPaymentUpsertMethodRelationInput"]: GraphQLTypes["OrderPaymentUpsertMethodRelationInput"];
	["OrderPaymentUpdateEventsEntityRelationInput"]: GraphQLTypes["OrderPaymentUpdateEventsEntityRelationInput"];
	["OrderPaymentUpdateEventsRelationInput"]: GraphQLTypes["OrderPaymentUpdateEventsRelationInput"];
	["OrderEventWithoutPaymentUpdateInput"]: GraphQLTypes["OrderEventWithoutPaymentUpdateInput"];
	["OrderEventUpdateOrderEntityRelationInput"]: GraphQLTypes["OrderEventUpdateOrderEntityRelationInput"];
	["OrderWithoutEventsUpdateInput"]: GraphQLTypes["OrderWithoutEventsUpdateInput"];
	["OrderUpdateDeliveryEntityRelationInput"]: GraphQLTypes["OrderUpdateDeliveryEntityRelationInput"];
	["OrderDeliveryWithoutOrderUpdateInput"]: GraphQLTypes["OrderDeliveryWithoutOrderUpdateInput"];
	["OrderDeliveryUpdateVatRateEntityRelationInput"]: GraphQLTypes["OrderDeliveryUpdateVatRateEntityRelationInput"];
	["OrderDeliveryUpsertVatRateRelationInput"]: GraphQLTypes["OrderDeliveryUpsertVatRateRelationInput"];
	["OrderDeliveryUpdateDeliveryWaypointEntityRelationInput"]: GraphQLTypes["OrderDeliveryUpdateDeliveryWaypointEntityRelationInput"];
	["DeliveryWaypointWithoutDeliveryUpdateInput"]: GraphQLTypes["DeliveryWaypointWithoutDeliveryUpdateInput"];
	["DeliveryWaypointUpdateRouteEntityRelationInput"]: GraphQLTypes["DeliveryWaypointUpdateRouteEntityRelationInput"];
	["DeliveryRouteWithoutWaypointsUpdateInput"]: GraphQLTypes["DeliveryRouteWithoutWaypointsUpdateInput"];
	["DeliveryRouteUpdateCourierEntityRelationInput"]: GraphQLTypes["DeliveryRouteUpdateCourierEntityRelationInput"];
	["CourierWithoutRoutesUpdateInput"]: GraphQLTypes["CourierWithoutRoutesUpdateInput"];
	["CourierUpdateDeliveryMethodsEntityRelationInput"]: GraphQLTypes["CourierUpdateDeliveryMethodsEntityRelationInput"];
	["CourierUpdateDeliveryMethodsRelationInput"]: GraphQLTypes["CourierUpdateDeliveryMethodsRelationInput"];
	["DeliveryMethodWithoutCourierHandlersUpdateInput"]: GraphQLTypes["DeliveryMethodWithoutCourierHandlersUpdateInput"];
	["DeliveryMethodUpdateLocalesEntityRelationInput"]: GraphQLTypes["DeliveryMethodUpdateLocalesEntityRelationInput"];
	["DeliveryMethodUpdateLocalesRelationInput"]: GraphQLTypes["DeliveryMethodUpdateLocalesRelationInput"];
	["DeliveryMethodLocaleWithoutRootUpdateInput"]: GraphQLTypes["DeliveryMethodLocaleWithoutRootUpdateInput"];
	["DeliveryMethodLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["DeliveryMethodLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutDeliveryMethodsUpdateInput"]: GraphQLTypes["LocaleWithoutDeliveryMethodsUpdateInput"];
	["LocaleUpdateProductPackingsEntityRelationInput"]: GraphQLTypes["LocaleUpdateProductPackingsEntityRelationInput"];
	["LocaleUpdateProductPackingsRelationInput"]: GraphQLTypes["LocaleUpdateProductPackingsRelationInput"];
	["ProductPackingLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["ProductPackingLocaleWithoutLocaleUpdateInput"];
	["ProductPackingLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["ProductPackingLocaleUpdateRootEntityRelationInput"];
	["ProductPackingWithoutLocalesUpdateInput"]: GraphQLTypes["ProductPackingWithoutLocalesUpdateInput"];
	["ProductPackingUpdatePreparedPackingQuantitiesEntityRelationInput"]: GraphQLTypes["ProductPackingUpdatePreparedPackingQuantitiesEntityRelationInput"];
	["ProductPackingUpdatePreparedPackingQuantitiesRelationInput"]: GraphQLTypes["ProductPackingUpdatePreparedPackingQuantitiesRelationInput"];
	["PreparedPackingQuantityWithoutPackingUpdateInput"]: GraphQLTypes["PreparedPackingQuantityWithoutPackingUpdateInput"];
	["PreparedPackingQuantityUpdateRecipeEntityRelationInput"]: GraphQLTypes["PreparedPackingQuantityUpdateRecipeEntityRelationInput"];
	["ProductRecipeUpdateInput"]: GraphQLTypes["ProductRecipeUpdateInput"];
	["ProductRecipeUpdateProductsEntityRelationInput"]: GraphQLTypes["ProductRecipeUpdateProductsEntityRelationInput"];
	["ProductRecipeUpdateProductsRelationInput"]: GraphQLTypes["ProductRecipeUpdateProductsRelationInput"];
	["ProductWithoutRecipeUpdateInput"]: GraphQLTypes["ProductWithoutRecipeUpdateInput"];
	["ProductUpdateLocalesEntityRelationInput"]: GraphQLTypes["ProductUpdateLocalesEntityRelationInput"];
	["ProductUpdateLocalesRelationInput"]: GraphQLTypes["ProductUpdateLocalesRelationInput"];
	["ProductLocaleWithoutRootUpdateInput"]: GraphQLTypes["ProductLocaleWithoutRootUpdateInput"];
	["ProductLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["ProductLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutProductsUpdateInput"]: GraphQLTypes["LocaleWithoutProductsUpdateInput"];
	["LocaleUpdateProductRecipesEntityRelationInput"]: GraphQLTypes["LocaleUpdateProductRecipesEntityRelationInput"];
	["LocaleUpdateProductRecipesRelationInput"]: GraphQLTypes["LocaleUpdateProductRecipesRelationInput"];
	["ProductRecipeLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["ProductRecipeLocaleWithoutLocaleUpdateInput"];
	["ProductRecipeLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["ProductRecipeLocaleUpdateRootEntityRelationInput"];
	["ProductRecipeWithoutLocalesUpdateInput"]: GraphQLTypes["ProductRecipeWithoutLocalesUpdateInput"];
	["ProductRecipeUpdateFreshingContainerEntityRelationInput"]: GraphQLTypes["ProductRecipeUpdateFreshingContainerEntityRelationInput"];
	["ProductRecipeUpsertFreshingContainerRelationInput"]: GraphQLTypes["ProductRecipeUpsertFreshingContainerRelationInput"];
	["ProductRecipeUpdateNutritionFactsEntityRelationInput"]: GraphQLTypes["ProductRecipeUpdateNutritionFactsEntityRelationInput"];
	["NutritionFactsUpdateInput"]: GraphQLTypes["NutritionFactsUpdateInput"];
	["ProductRecipeUpsertNutritionFactsRelationInput"]: GraphQLTypes["ProductRecipeUpsertNutritionFactsRelationInput"];
	["ProductRecipeLocaleUpsertRootRelationInput"]: GraphQLTypes["ProductRecipeLocaleUpsertRootRelationInput"];
	["LocaleUpsertProductRecipesRelationInput"]: GraphQLTypes["LocaleUpsertProductRecipesRelationInput"];
	["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]: GraphQLTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"];
	["LocaleUpdatePointOfSaleCategoriesRelationInput"]: GraphQLTypes["LocaleUpdatePointOfSaleCategoriesRelationInput"];
	["PointOfSaleCategoryLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["PointOfSaleCategoryLocaleWithoutLocaleUpdateInput"];
	["PointOfSaleCategoryLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["PointOfSaleCategoryLocaleUpdateRootEntityRelationInput"];
	["PointOfSaleCategoryWithoutLocalesUpdateInput"]: GraphQLTypes["PointOfSaleCategoryWithoutLocalesUpdateInput"];
	["PointOfSaleCategoryUpdateProductsEntityRelationInput"]: GraphQLTypes["PointOfSaleCategoryUpdateProductsEntityRelationInput"];
	["PointOfSaleCategoryUpdateProductsRelationInput"]: GraphQLTypes["PointOfSaleCategoryUpdateProductsRelationInput"];
	["PointOfSaleCategoryProductWithoutCategoryUpdateInput"]: GraphQLTypes["PointOfSaleCategoryProductWithoutCategoryUpdateInput"];
	["PointOfSaleCategoryProductUpdateProductEntityRelationInput"]: GraphQLTypes["PointOfSaleCategoryProductUpdateProductEntityRelationInput"];
	["ProductUpdateInput"]: GraphQLTypes["ProductUpdateInput"];
	["ProductUpdateCustomerPricesEntityRelationInput"]: GraphQLTypes["ProductUpdateCustomerPricesEntityRelationInput"];
	["ProductUpdateVirtualProductEntityRelationInput"]: GraphQLTypes["ProductUpdateVirtualProductEntityRelationInput"];
	["VirtualProductWithoutProductUpdateInput"]: GraphQLTypes["VirtualProductWithoutProductUpdateInput"];
	["ProductUpsertVirtualProductRelationInput"]: GraphQLTypes["ProductUpsertVirtualProductRelationInput"];
	["ProductUpdateMetaEntityRelationInput"]: GraphQLTypes["ProductUpdateMetaEntityRelationInput"];
	["ProductUpdatePageEntityRelationInput"]: GraphQLTypes["ProductUpdatePageEntityRelationInput"];
	["PageUpdateInput"]: GraphQLTypes["PageUpdateInput"];
	["PageUpdateLocalesEntityRelationInput"]: GraphQLTypes["PageUpdateLocalesEntityRelationInput"];
	["PageUpdateLocalesRelationInput"]: GraphQLTypes["PageUpdateLocalesRelationInput"];
	["PageLocaleWithoutRootUpdateInput"]: GraphQLTypes["PageLocaleWithoutRootUpdateInput"];
	["PageLocaleUpdateSeoEntityRelationInput"]: GraphQLTypes["PageLocaleUpdateSeoEntityRelationInput"];
	["SeoUpdateInput"]: GraphQLTypes["SeoUpdateInput"];
	["SeoUpdateOgImageEntityRelationInput"]: GraphQLTypes["SeoUpdateOgImageEntityRelationInput"];
	["SeoUpsertOgImageRelationInput"]: GraphQLTypes["SeoUpsertOgImageRelationInput"];
	["PageLocaleUpsertSeoRelationInput"]: GraphQLTypes["PageLocaleUpsertSeoRelationInput"];
	["PageLocaleUpdateContentEntityRelationInput"]: GraphQLTypes["PageLocaleUpdateContentEntityRelationInput"];
	["PageLocaleUpsertContentRelationInput"]: GraphQLTypes["PageLocaleUpsertContentRelationInput"];
	["PageLocaleUpdateCoverEntityRelationInput"]: GraphQLTypes["PageLocaleUpdateCoverEntityRelationInput"];
	["PageLocaleUpsertCoverRelationInput"]: GraphQLTypes["PageLocaleUpsertCoverRelationInput"];
	["PageUpsertLocalesRelationInput"]: GraphQLTypes["PageUpsertLocalesRelationInput"];
	["ProductUpsertPageRelationInput"]: GraphQLTypes["ProductUpsertPageRelationInput"];
	["ProductUpdateSalesDaysEntityRelationInput"]: GraphQLTypes["ProductUpdateSalesDaysEntityRelationInput"];
	["ProductUpdateSalesWeeksEntityRelationInput"]: GraphQLTypes["ProductUpdateSalesWeeksEntityRelationInput"];
	["ProductUpdateSalesMonthsEntityRelationInput"]: GraphQLTypes["ProductUpdateSalesMonthsEntityRelationInput"];
	["ProductUpdateFulfillmentNotesEntityRelationInput"]: GraphQLTypes["ProductUpdateFulfillmentNotesEntityRelationInput"];
	["ProductUpdateFulfillmentNotesRelationInput"]: GraphQLTypes["ProductUpdateFulfillmentNotesRelationInput"];
	["FulfillmentNoteWithoutProductsUpdateInput"]: GraphQLTypes["FulfillmentNoteWithoutProductsUpdateInput"];
	["FulfillmentNoteUpdateTagsEntityRelationInput"]: GraphQLTypes["FulfillmentNoteUpdateTagsEntityRelationInput"];
	["FulfillmentNoteUpdateTagsRelationInput"]: GraphQLTypes["FulfillmentNoteUpdateTagsRelationInput"];
	["TagWithoutFulfillmentNotesUpdateInput"]: GraphQLTypes["TagWithoutFulfillmentNotesUpdateInput"];
	["FulfillmentNoteUpsertTagsRelationInput"]: GraphQLTypes["FulfillmentNoteUpsertTagsRelationInput"];
	["FulfillmentNoteUpdateVenuesEntityRelationInput"]: GraphQLTypes["FulfillmentNoteUpdateVenuesEntityRelationInput"];
	["FulfillmentNoteUpdateVenuesRelationInput"]: GraphQLTypes["FulfillmentNoteUpdateVenuesRelationInput"];
	["VenueWithoutFulfillmentNotesUpdateInput"]: GraphQLTypes["VenueWithoutFulfillmentNotesUpdateInput"];
	["VenueUpdateTimetableTemplatesEntityRelationInput"]: GraphQLTypes["VenueUpdateTimetableTemplatesEntityRelationInput"];
	["VenueUpdateTimetableTemplatesRelationInput"]: GraphQLTypes["VenueUpdateTimetableTemplatesRelationInput"];
	["TimetableTemplateWithoutVenueUpdateInput"]: GraphQLTypes["TimetableTemplateWithoutVenueUpdateInput"];
	["TimetableTemplateUpdateEmployeeRoleEntityRelationInput"]: GraphQLTypes["TimetableTemplateUpdateEmployeeRoleEntityRelationInput"];
	["TimetableEmployeeRoleWithoutTimetableTemplatesUpdateInput"]: GraphQLTypes["TimetableEmployeeRoleWithoutTimetableTemplatesUpdateInput"];
	["TimetableTemplateUpsertEmployeeRoleRelationInput"]: GraphQLTypes["TimetableTemplateUpsertEmployeeRoleRelationInput"];
	["VenueUpsertTimetableTemplatesRelationInput"]: GraphQLTypes["VenueUpsertTimetableTemplatesRelationInput"];
	["VenueUpdatePointOfSaleTerminalsEntityRelationInput"]: GraphQLTypes["VenueUpdatePointOfSaleTerminalsEntityRelationInput"];
	["VenueUpdatePointOfSaleTerminalsRelationInput"]: GraphQLTypes["VenueUpdatePointOfSaleTerminalsRelationInput"];
	["PointOfSaleTerminalWithoutVenueUpdateInput"]: GraphQLTypes["PointOfSaleTerminalWithoutVenueUpdateInput"];
	["PointOfSaleTerminalUpdateApplicationDevicesEntityRelationInput"]: GraphQLTypes["PointOfSaleTerminalUpdateApplicationDevicesEntityRelationInput"];
	["PointOfSaleTerminalUpdateApplicationDevicesRelationInput"]: GraphQLTypes["PointOfSaleTerminalUpdateApplicationDevicesRelationInput"];
	["PointOfSaleApplicationDeviceWithoutTerminalUpdateInput"]: GraphQLTypes["PointOfSaleApplicationDeviceWithoutTerminalUpdateInput"];
	["PointOfSaleApplicationDeviceUpdateVenueEntityRelationInput"]: GraphQLTypes["PointOfSaleApplicationDeviceUpdateVenueEntityRelationInput"];
	["VenueWithoutPointOfSaleApplicationDevicesUpdateInput"]: GraphQLTypes["VenueWithoutPointOfSaleApplicationDevicesUpdateInput"];
	["VenueUpdatePointOfSalePrintersEntityRelationInput"]: GraphQLTypes["VenueUpdatePointOfSalePrintersEntityRelationInput"];
	["VenueUpdatePointOfSalePrintersRelationInput"]: GraphQLTypes["VenueUpdatePointOfSalePrintersRelationInput"];
	["PointOfSalePrinterWithoutVenueUpdateInput"]: GraphQLTypes["PointOfSalePrinterWithoutVenueUpdateInput"];
	["PointOfSalePrinterUpdateApplicationDevicesReceiptEntityRelationInput"]: GraphQLTypes["PointOfSalePrinterUpdateApplicationDevicesReceiptEntityRelationInput"];
	["PointOfSalePrinterUpdateApplicationDevicesReceiptRelationInput"]: GraphQLTypes["PointOfSalePrinterUpdateApplicationDevicesReceiptRelationInput"];
	["PointOfSaleApplicationDeviceWithoutReceiptPrinterUpdateInput"]: GraphQLTypes["PointOfSaleApplicationDeviceWithoutReceiptPrinterUpdateInput"];
	["PointOfSaleApplicationDeviceUpdateIdentifierEntityRelationInput"]: GraphQLTypes["PointOfSaleApplicationDeviceUpdateIdentifierEntityRelationInput"];
	["DeviceIdentifierWithoutDeviceUpdateInput"]: GraphQLTypes["DeviceIdentifierWithoutDeviceUpdateInput"];
	["DeviceIdentifierUpdateUpdatedByUserEntityRelationInput"]: GraphQLTypes["DeviceIdentifierUpdateUpdatedByUserEntityRelationInput"];
	["UserUpdateInput"]: GraphQLTypes["UserUpdateInput"];
	["UserUpdateMetaEntityRelationInput"]: GraphQLTypes["UserUpdateMetaEntityRelationInput"];
	["UserUpdateIdentificationAttemptsEntityRelationInput"]: GraphQLTypes["UserUpdateIdentificationAttemptsEntityRelationInput"];
	["UserUpdateIdentificationAttemptsRelationInput"]: GraphQLTypes["UserUpdateIdentificationAttemptsRelationInput"];
	["IdentificationAttemptWithoutUserUpdateInput"]: GraphQLTypes["IdentificationAttemptWithoutUserUpdateInput"];
	["IdentificationAttemptUpdateCodeEntityRelationInput"]: GraphQLTypes["IdentificationAttemptUpdateCodeEntityRelationInput"];
	["IdentificationCodeWithoutAttemptsUpdateInput"]: GraphQLTypes["IdentificationCodeWithoutAttemptsUpdateInput"];
	["IdentificationCodeUpdateLocalesEntityRelationInput"]: GraphQLTypes["IdentificationCodeUpdateLocalesEntityRelationInput"];
	["IdentificationCodeUpdateLocalesRelationInput"]: GraphQLTypes["IdentificationCodeUpdateLocalesRelationInput"];
	["IdentificationCodeLocaleWithoutRootUpdateInput"]: GraphQLTypes["IdentificationCodeLocaleWithoutRootUpdateInput"];
	["IdentificationCodeLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["IdentificationCodeLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutIdentificationCodesUpdateInput"]: GraphQLTypes["LocaleWithoutIdentificationCodesUpdateInput"];
	["LocaleUpdateProductsEntityRelationInput"]: GraphQLTypes["LocaleUpdateProductsEntityRelationInput"];
	["LocaleUpdateProductsRelationInput"]: GraphQLTypes["LocaleUpdateProductsRelationInput"];
	["ProductLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["ProductLocaleWithoutLocaleUpdateInput"];
	["ProductLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["ProductLocaleUpdateRootEntityRelationInput"];
	["ProductWithoutLocalesUpdateInput"]: GraphQLTypes["ProductWithoutLocalesUpdateInput"];
	["ProductLocaleUpsertRootRelationInput"]: GraphQLTypes["ProductLocaleUpsertRootRelationInput"];
	["ProductLocaleUpdateFeatureListEntityRelationInput"]: GraphQLTypes["ProductLocaleUpdateFeatureListEntityRelationInput"];
	["ProductLocaleUpsertFeatureListRelationInput"]: GraphQLTypes["ProductLocaleUpsertFeatureListRelationInput"];
	["LocaleUpsertProductsRelationInput"]: GraphQLTypes["LocaleUpsertProductsRelationInput"];
	["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]: GraphQLTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"];
	["LocaleUpdatePointOfSaleCategoryProductsRelationInput"]: GraphQLTypes["LocaleUpdatePointOfSaleCategoryProductsRelationInput"];
	["PointOfSaleCategoryProductLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["PointOfSaleCategoryProductLocaleWithoutLocaleUpdateInput"];
	["PointOfSaleCategoryProductLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["PointOfSaleCategoryProductLocaleUpdateRootEntityRelationInput"];
	["PointOfSaleCategoryProductWithoutLocalesUpdateInput"]: GraphQLTypes["PointOfSaleCategoryProductWithoutLocalesUpdateInput"];
	["PointOfSaleCategoryProductUpdateCategoryEntityRelationInput"]: GraphQLTypes["PointOfSaleCategoryProductUpdateCategoryEntityRelationInput"];
	["PointOfSaleCategoryWithoutProductsUpdateInput"]: GraphQLTypes["PointOfSaleCategoryWithoutProductsUpdateInput"];
	["PointOfSaleCategoryUpdateLocalesEntityRelationInput"]: GraphQLTypes["PointOfSaleCategoryUpdateLocalesEntityRelationInput"];
	["PointOfSaleCategoryUpdateLocalesRelationInput"]: GraphQLTypes["PointOfSaleCategoryUpdateLocalesRelationInput"];
	["PointOfSaleCategoryLocaleWithoutRootUpdateInput"]: GraphQLTypes["PointOfSaleCategoryLocaleWithoutRootUpdateInput"];
	["PointOfSaleCategoryLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["PointOfSaleCategoryLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutPointOfSaleCategoriesUpdateInput"]: GraphQLTypes["LocaleWithoutPointOfSaleCategoriesUpdateInput"];
	["LocaleUpdateDeliveryMethodsEntityRelationInput"]: GraphQLTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"];
	["LocaleUpdateDeliveryMethodsRelationInput"]: GraphQLTypes["LocaleUpdateDeliveryMethodsRelationInput"];
	["DeliveryMethodLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["DeliveryMethodLocaleWithoutLocaleUpdateInput"];
	["DeliveryMethodLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["DeliveryMethodLocaleUpdateRootEntityRelationInput"];
	["DeliveryMethodWithoutLocalesUpdateInput"]: GraphQLTypes["DeliveryMethodWithoutLocalesUpdateInput"];
	["DeliveryMethodUpdateTimelinePresetEntityRelationInput"]: GraphQLTypes["DeliveryMethodUpdateTimelinePresetEntityRelationInput"];
	["DeliveryTimelinePresetWithoutDeliveryMethodUpdateInput"]: GraphQLTypes["DeliveryTimelinePresetWithoutDeliveryMethodUpdateInput"];
	["DeliveryMethodUpsertTimelinePresetRelationInput"]: GraphQLTypes["DeliveryMethodUpsertTimelinePresetRelationInput"];
	["DeliveryMethodLocaleUpsertRootRelationInput"]: GraphQLTypes["DeliveryMethodLocaleUpsertRootRelationInput"];
	["LocaleUpsertDeliveryMethodsRelationInput"]: GraphQLTypes["LocaleUpsertDeliveryMethodsRelationInput"];
	["LocaleUpdateIngredientSuppliersEntityRelationInput"]: GraphQLTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"];
	["LocaleUpdateIngredientSuppliersRelationInput"]: GraphQLTypes["LocaleUpdateIngredientSuppliersRelationInput"];
	["IngredientSupplierLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["IngredientSupplierLocaleWithoutLocaleUpdateInput"];
	["IngredientSupplierLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["IngredientSupplierLocaleUpdateRootEntityRelationInput"];
	["IngredientSupplierWithoutLocalesUpdateInput"]: GraphQLTypes["IngredientSupplierWithoutLocalesUpdateInput"];
	["IngredientSupplierLocaleUpsertRootRelationInput"]: GraphQLTypes["IngredientSupplierLocaleUpsertRootRelationInput"];
	["LocaleUpsertIngredientSuppliersRelationInput"]: GraphQLTypes["LocaleUpsertIngredientSuppliersRelationInput"];
	["LocaleUpdateIdentificationCodesEntityRelationInput"]: GraphQLTypes["LocaleUpdateIdentificationCodesEntityRelationInput"];
	["LocaleUpdateIdentificationCodesRelationInput"]: GraphQLTypes["LocaleUpdateIdentificationCodesRelationInput"];
	["IdentificationCodeLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["IdentificationCodeLocaleWithoutLocaleUpdateInput"];
	["IdentificationCodeLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["IdentificationCodeLocaleUpdateRootEntityRelationInput"];
	["IdentificationCodeWithoutLocalesUpdateInput"]: GraphQLTypes["IdentificationCodeWithoutLocalesUpdateInput"];
	["IdentificationCodeUpdateApplicationDevicesEntityRelationInput"]: GraphQLTypes["IdentificationCodeUpdateApplicationDevicesEntityRelationInput"];
	["IdentificationCodeUpdateApplicationDevicesRelationInput"]: GraphQLTypes["IdentificationCodeUpdateApplicationDevicesRelationInput"];
	["PointOfSaleApplicationDeviceWithoutIdentificationCodeUpdateInput"]: GraphQLTypes["PointOfSaleApplicationDeviceWithoutIdentificationCodeUpdateInput"];
	["PointOfSaleApplicationDeviceUpdateTerminalEntityRelationInput"]: GraphQLTypes["PointOfSaleApplicationDeviceUpdateTerminalEntityRelationInput"];
	["PointOfSaleTerminalWithoutApplicationDevicesUpdateInput"]: GraphQLTypes["PointOfSaleTerminalWithoutApplicationDevicesUpdateInput"];
	["PointOfSaleTerminalUpdateVenueEntityRelationInput"]: GraphQLTypes["PointOfSaleTerminalUpdateVenueEntityRelationInput"];
	["VenueWithoutPointOfSaleTerminalsUpdateInput"]: GraphQLTypes["VenueWithoutPointOfSaleTerminalsUpdateInput"];
	["VenueUpdateOrdersEntityRelationInput"]: GraphQLTypes["VenueUpdateOrdersEntityRelationInput"];
	["VenueUpdateOrdersRelationInput"]: GraphQLTypes["VenueUpdateOrdersRelationInput"];
	["OrderWithoutVenueUpdateInput"]: GraphQLTypes["OrderWithoutVenueUpdateInput"];
	["OrderUpdateItemsEntityRelationInput"]: GraphQLTypes["OrderUpdateItemsEntityRelationInput"];
	["OrderUpdateItemsRelationInput"]: GraphQLTypes["OrderUpdateItemsRelationInput"];
	["OrderItemWithoutOrderUpdateInput"]: GraphQLTypes["OrderItemWithoutOrderUpdateInput"];
	["OrderItemUpdateVirtualProductEffectsEntityRelationInput"]: GraphQLTypes["OrderItemUpdateVirtualProductEffectsEntityRelationInput"];
	["OrderItemUpdateVirtualProductEffectsRelationInput"]: GraphQLTypes["OrderItemUpdateVirtualProductEffectsRelationInput"];
	["VirtualProductEffectWithoutOrderItemUpdateInput"]: GraphQLTypes["VirtualProductEffectWithoutOrderItemUpdateInput"];
	["VirtualProductEffectUpdateResultCustomerCreditTransactionEntityRelationInput"]: GraphQLTypes["VirtualProductEffectUpdateResultCustomerCreditTransactionEntityRelationInput"];
	["CustomerCreditTransactionWithoutVirtualProductEffectUpdateInput"]: GraphQLTypes["CustomerCreditTransactionWithoutVirtualProductEffectUpdateInput"];
	["CustomerCreditTransactionUpdateOrderDiscountEntityRelationInput"]: GraphQLTypes["CustomerCreditTransactionUpdateOrderDiscountEntityRelationInput"];
	["OrderDiscountWithoutCustomerCreditTransactionsUpdateInput"]: GraphQLTypes["OrderDiscountWithoutCustomerCreditTransactionsUpdateInput"];
	["OrderDiscountUpdateOrderEntityRelationInput"]: GraphQLTypes["OrderDiscountUpdateOrderEntityRelationInput"];
	["OrderWithoutDiscountsUpdateInput"]: GraphQLTypes["OrderWithoutDiscountsUpdateInput"];
	["OrderUpdateCartEntityRelationInput"]: GraphQLTypes["OrderUpdateCartEntityRelationInput"];
	["CartWithoutOrderUpdateInput"]: GraphQLTypes["CartWithoutOrderUpdateInput"];
	["CartUpdateCustomerEntityRelationInput"]: GraphQLTypes["CartUpdateCustomerEntityRelationInput"];
	["CustomerWithoutCartsUpdateInput"]: GraphQLTypes["CustomerWithoutCartsUpdateInput"];
	["CustomerUpdateInvoicingPlanEntityRelationInput"]: GraphQLTypes["CustomerUpdateInvoicingPlanEntityRelationInput"];
	["InvoicingPlanWithoutCustomerUpdateInput"]: GraphQLTypes["InvoicingPlanWithoutCustomerUpdateInput"];
	["InvoicingPlanUpdatePresetEntityRelationInput"]: GraphQLTypes["InvoicingPlanUpdatePresetEntityRelationInput"];
	["InvoicingPresetWithoutInvoicingPlanUpdateInput"]: GraphQLTypes["InvoicingPresetWithoutInvoicingPlanUpdateInput"];
	["InvoicingPlanUpsertPresetRelationInput"]: GraphQLTypes["InvoicingPlanUpsertPresetRelationInput"];
	["CustomerUpsertInvoicingPlanRelationInput"]: GraphQLTypes["CustomerUpsertInvoicingPlanRelationInput"];
	["CustomerUpdateBillingSubjectsEntityRelationInput"]: GraphQLTypes["CustomerUpdateBillingSubjectsEntityRelationInput"];
	["CustomerUpdateBillingSubjectsRelationInput"]: GraphQLTypes["CustomerUpdateBillingSubjectsRelationInput"];
	["BillingSubjectWithoutCustomerUpdateInput"]: GraphQLTypes["BillingSubjectWithoutCustomerUpdateInput"];
	["BillingSubjectUpdateCountryEntityRelationInput"]: GraphQLTypes["BillingSubjectUpdateCountryEntityRelationInput"];
	["BillingSubjectUpsertCountryRelationInput"]: GraphQLTypes["BillingSubjectUpsertCountryRelationInput"];
	["BillingSubjectUpdateInvoicesEntityRelationInput"]: GraphQLTypes["BillingSubjectUpdateInvoicesEntityRelationInput"];
	["BillingSubjectUpdateInvoicesRelationInput"]: GraphQLTypes["BillingSubjectUpdateInvoicesRelationInput"];
	["InvoiceWithoutBillingSubjectUpdateInput"]: GraphQLTypes["InvoiceWithoutBillingSubjectUpdateInput"];
	["InvoiceUpdateAddressEntityRelationInput"]: GraphQLTypes["InvoiceUpdateAddressEntityRelationInput"];
	["AddressWithoutInvoicesUpdateInput"]: GraphQLTypes["AddressWithoutInvoicesUpdateInput"];
	["AddressUpdateBillingAddressOfOrdersEntityRelationInput"]: GraphQLTypes["AddressUpdateBillingAddressOfOrdersEntityRelationInput"];
	["AddressUpdateBillingAddressOfOrdersRelationInput"]: GraphQLTypes["AddressUpdateBillingAddressOfOrdersRelationInput"];
	["OrderWithoutBillingAddressUpdateInput"]: GraphQLTypes["OrderWithoutBillingAddressUpdateInput"];
	["OrderUpdateEventsEntityRelationInput"]: GraphQLTypes["OrderUpdateEventsEntityRelationInput"];
	["OrderUpdateEventsRelationInput"]: GraphQLTypes["OrderUpdateEventsRelationInput"];
	["OrderEventWithoutOrderUpdateInput"]: GraphQLTypes["OrderEventWithoutOrderUpdateInput"];
	["OrderEventUpdatePaymentEntityRelationInput"]: GraphQLTypes["OrderEventUpdatePaymentEntityRelationInput"];
	["OrderPaymentWithoutEventsUpdateInput"]: GraphQLTypes["OrderPaymentWithoutEventsUpdateInput"];
	["OrderPaymentUpdateOrderEntityRelationInput"]: GraphQLTypes["OrderPaymentUpdateOrderEntityRelationInput"];
	["OrderWithoutPaymentsUpdateInput"]: GraphQLTypes["OrderWithoutPaymentsUpdateInput"];
	["OrderUpdateBillingAddressEntityRelationInput"]: GraphQLTypes["OrderUpdateBillingAddressEntityRelationInput"];
	["AddressWithoutBillingAddressOfOrdersUpdateInput"]: GraphQLTypes["AddressWithoutBillingAddressOfOrdersUpdateInput"];
	["AddressUpdateDeliveryAddressOfOrderDeliveriesEntityRelationInput"]: GraphQLTypes["AddressUpdateDeliveryAddressOfOrderDeliveriesEntityRelationInput"];
	["AddressUpdateDeliveryAddressOfOrderDeliveriesRelationInput"]: GraphQLTypes["AddressUpdateDeliveryAddressOfOrderDeliveriesRelationInput"];
	["OrderDeliveryWithoutAddressUpdateInput"]: GraphQLTypes["OrderDeliveryWithoutAddressUpdateInput"];
	["OrderDeliveryUpdateOrderEntityRelationInput"]: GraphQLTypes["OrderDeliveryUpdateOrderEntityRelationInput"];
	["OrderWithoutDeliveryUpdateInput"]: GraphQLTypes["OrderWithoutDeliveryUpdateInput"];
	["OrderUpdatePriceLinesEntityRelationInput"]: GraphQLTypes["OrderUpdatePriceLinesEntityRelationInput"];
	["OrderUpdatePaymentsEntityRelationInput"]: GraphQLTypes["OrderUpdatePaymentsEntityRelationInput"];
	["OrderUpdatePaymentsRelationInput"]: GraphQLTypes["OrderUpdatePaymentsRelationInput"];
	["OrderPaymentWithoutOrderUpdateInput"]: GraphQLTypes["OrderPaymentWithoutOrderUpdateInput"];
	["OrderPaymentUpdateInvoiceEntityRelationInput"]: GraphQLTypes["OrderPaymentUpdateInvoiceEntityRelationInput"];
	["InvoiceWithoutOrderPaymentsUpdateInput"]: GraphQLTypes["InvoiceWithoutOrderPaymentsUpdateInput"];
	["InvoiceUpdateBillingSubjectEntityRelationInput"]: GraphQLTypes["InvoiceUpdateBillingSubjectEntityRelationInput"];
	["BillingSubjectWithoutInvoicesUpdateInput"]: GraphQLTypes["BillingSubjectWithoutInvoicesUpdateInput"];
	["BillingSubjectUpdateCustomerEntityRelationInput"]: GraphQLTypes["BillingSubjectUpdateCustomerEntityRelationInput"];
	["CustomerWithoutBillingSubjectsUpdateInput"]: GraphQLTypes["CustomerWithoutBillingSubjectsUpdateInput"];
	["CustomerUpdateOfferedProductsEntityRelationInput"]: GraphQLTypes["CustomerUpdateOfferedProductsEntityRelationInput"];
	["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"]: GraphQLTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"];
	["AddressWithoutDefaultDeliveryAddressOfCustomerUpdateInput"]: GraphQLTypes["AddressWithoutDefaultDeliveryAddressOfCustomerUpdateInput"];
	["CustomerUpsertDefaultDeliveryAddressRelationInput"]: GraphQLTypes["CustomerUpsertDefaultDeliveryAddressRelationInput"];
	["CustomerUpdateDefaultBillingSubjectEntityRelationInput"]: GraphQLTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"];
	["BillingSubjectWithoutDefaultBillingSubjectOfCustomerUpdateInput"]: GraphQLTypes["BillingSubjectWithoutDefaultBillingSubjectOfCustomerUpdateInput"];
	["BillingSubjectUpdateOrdersEntityRelationInput"]: GraphQLTypes["BillingSubjectUpdateOrdersEntityRelationInput"];
	["BillingSubjectUpdateOrdersRelationInput"]: GraphQLTypes["BillingSubjectUpdateOrdersRelationInput"];
	["OrderWithoutBillingSubjectUpdateInput"]: GraphQLTypes["OrderWithoutBillingSubjectUpdateInput"];
	["OrderUpdateSummaryEntityRelationInput"]: GraphQLTypes["OrderUpdateSummaryEntityRelationInput"];
	["OrderUpdateGratuityEntityRelationInput"]: GraphQLTypes["OrderUpdateGratuityEntityRelationInput"];
	["GratuityWithoutOrderUpdateInput"]: GraphQLTypes["GratuityWithoutOrderUpdateInput"];
	["OrderUpsertGratuityRelationInput"]: GraphQLTypes["OrderUpsertGratuityRelationInput"];
	["OrderUpdateVenueEntityRelationInput"]: GraphQLTypes["OrderUpdateVenueEntityRelationInput"];
	["VenueWithoutOrdersUpdateInput"]: GraphQLTypes["VenueWithoutOrdersUpdateInput"];
	["VenueUpdateFulfillmentNotesEntityRelationInput"]: GraphQLTypes["VenueUpdateFulfillmentNotesEntityRelationInput"];
	["VenueUpdateFulfillmentNotesRelationInput"]: GraphQLTypes["VenueUpdateFulfillmentNotesRelationInput"];
	["FulfillmentNoteWithoutVenuesUpdateInput"]: GraphQLTypes["FulfillmentNoteWithoutVenuesUpdateInput"];
	["FulfillmentNoteUpdateCartItemsEntityRelationInput"]: GraphQLTypes["FulfillmentNoteUpdateCartItemsEntityRelationInput"];
	["FulfillmentNoteUpdateCartItemsRelationInput"]: GraphQLTypes["FulfillmentNoteUpdateCartItemsRelationInput"];
	["CartItemWithoutFulfillmentNotesUpdateInput"]: GraphQLTypes["CartItemWithoutFulfillmentNotesUpdateInput"];
	["FulfillmentNoteUpsertCartItemsRelationInput"]: GraphQLTypes["FulfillmentNoteUpsertCartItemsRelationInput"];
	["FulfillmentNoteUpdateOrderItemsEntityRelationInput"]: GraphQLTypes["FulfillmentNoteUpdateOrderItemsEntityRelationInput"];
	["FulfillmentNoteUpdateOrderItemsRelationInput"]: GraphQLTypes["FulfillmentNoteUpdateOrderItemsRelationInput"];
	["OrderItemWithoutFulfillmentNotesUpdateInput"]: GraphQLTypes["OrderItemWithoutFulfillmentNotesUpdateInput"];
	["OrderItemUpdateProductEntityRelationInput"]: GraphQLTypes["OrderItemUpdateProductEntityRelationInput"];
	["ProductWithoutOrderItemsUpdateInput"]: GraphQLTypes["ProductWithoutOrderItemsUpdateInput"];
	["OrderItemUpsertProductRelationInput"]: GraphQLTypes["OrderItemUpsertProductRelationInput"];
	["FulfillmentNoteUpsertOrderItemsRelationInput"]: GraphQLTypes["FulfillmentNoteUpsertOrderItemsRelationInput"];
	["FulfillmentNoteUpdateOrdersEntityRelationInput"]: GraphQLTypes["FulfillmentNoteUpdateOrdersEntityRelationInput"];
	["FulfillmentNoteUpdateOrdersRelationInput"]: GraphQLTypes["FulfillmentNoteUpdateOrdersRelationInput"];
	["OrderWithoutFulfillmentNotesUpdateInput"]: GraphQLTypes["OrderWithoutFulfillmentNotesUpdateInput"];
	["OrderUpdateBillingSubjectEntityRelationInput"]: GraphQLTypes["OrderUpdateBillingSubjectEntityRelationInput"];
	["BillingSubjectWithoutOrdersUpdateInput"]: GraphQLTypes["BillingSubjectWithoutOrdersUpdateInput"];
	["BillingSubjectUpdateDefaultBillingSubjectOfCustomerEntityRelationInput"]: GraphQLTypes["BillingSubjectUpdateDefaultBillingSubjectOfCustomerEntityRelationInput"];
	["CustomerWithoutDefaultBillingSubjectUpdateInput"]: GraphQLTypes["CustomerWithoutDefaultBillingSubjectUpdateInput"];
	["CustomerUpdateAnonymousSessionEntityRelationInput"]: GraphQLTypes["CustomerUpdateAnonymousSessionEntityRelationInput"];
	["AnonymousSessionWithoutCustomerUpdateInput"]: GraphQLTypes["AnonymousSessionWithoutCustomerUpdateInput"];
	["AnonymousSessionUpdateDevicesEntityRelationInput"]: GraphQLTypes["AnonymousSessionUpdateDevicesEntityRelationInput"];
	["AnonymousSessionUpdateDevicesRelationInput"]: GraphQLTypes["AnonymousSessionUpdateDevicesRelationInput"];
	["UserDeviceWithoutAnonymousSessionUpdateInput"]: GraphQLTypes["UserDeviceWithoutAnonymousSessionUpdateInput"];
	["UserDeviceUpdateUserEntityRelationInput"]: GraphQLTypes["UserDeviceUpdateUserEntityRelationInput"];
	["UserWithoutDevicesUpdateInput"]: GraphQLTypes["UserWithoutDevicesUpdateInput"];
	["UserUpdateRolesEntityRelationInput"]: GraphQLTypes["UserUpdateRolesEntityRelationInput"];
	["UserDeviceUpsertUserRelationInput"]: GraphQLTypes["UserDeviceUpsertUserRelationInput"];
	["AnonymousSessionUpsertDevicesRelationInput"]: GraphQLTypes["AnonymousSessionUpsertDevicesRelationInput"];
	["CustomerUpsertAnonymousSessionRelationInput"]: GraphQLTypes["CustomerUpsertAnonymousSessionRelationInput"];
	["CustomerUpdateBoughtVouchersEntityRelationInput"]: GraphQLTypes["CustomerUpdateBoughtVouchersEntityRelationInput"];
	["CustomerUpdateBoughtVouchersRelationInput"]: GraphQLTypes["CustomerUpdateBoughtVouchersRelationInput"];
	["VoucherWithoutBuyerUpdateInput"]: GraphQLTypes["VoucherWithoutBuyerUpdateInput"];
	["VoucherUpdateOwnerEntityRelationInput"]: GraphQLTypes["VoucherUpdateOwnerEntityRelationInput"];
	["CustomerWithoutOwnsVouchersUpdateInput"]: GraphQLTypes["CustomerWithoutOwnsVouchersUpdateInput"];
	["CustomerUpdateRedeemedVouchersEntityRelationInput"]: GraphQLTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"];
	["CustomerUpdateRedeemedVouchersRelationInput"]: GraphQLTypes["CustomerUpdateRedeemedVouchersRelationInput"];
	["VoucherRedemptionWithoutCustomerUpdateInput"]: GraphQLTypes["VoucherRedemptionWithoutCustomerUpdateInput"];
	["VoucherRedemptionUpdateCustomerCreditEntityRelationInput"]: GraphQLTypes["VoucherRedemptionUpdateCustomerCreditEntityRelationInput"];
	["CustomerCreditWithoutVoucherRedemptionUpdateInput"]: GraphQLTypes["CustomerCreditWithoutVoucherRedemptionUpdateInput"];
	["CustomerCreditUpdateTransactionsEntityRelationInput"]: GraphQLTypes["CustomerCreditUpdateTransactionsEntityRelationInput"];
	["CustomerCreditUpdateTransactionsRelationInput"]: GraphQLTypes["CustomerCreditUpdateTransactionsRelationInput"];
	["CustomerCreditTransactionWithoutCustomerCreditUpdateInput"]: GraphQLTypes["CustomerCreditTransactionWithoutCustomerCreditUpdateInput"];
	["CustomerCreditTransactionUpdateVirtualProductEffectEntityRelationInput"]: GraphQLTypes["CustomerCreditTransactionUpdateVirtualProductEffectEntityRelationInput"];
	["VirtualProductEffectWithoutResultCustomerCreditTransactionUpdateInput"]: GraphQLTypes["VirtualProductEffectWithoutResultCustomerCreditTransactionUpdateInput"];
	["VirtualProductEffectUpdateOrderItemEntityRelationInput"]: GraphQLTypes["VirtualProductEffectUpdateOrderItemEntityRelationInput"];
	["OrderItemWithoutVirtualProductEffectsUpdateInput"]: GraphQLTypes["OrderItemWithoutVirtualProductEffectsUpdateInput"];
	["OrderItemUpdateFulfillmentNotesEntityRelationInput"]: GraphQLTypes["OrderItemUpdateFulfillmentNotesEntityRelationInput"];
	["OrderItemUpdateFulfillmentNotesRelationInput"]: GraphQLTypes["OrderItemUpdateFulfillmentNotesRelationInput"];
	["FulfillmentNoteWithoutOrderItemsUpdateInput"]: GraphQLTypes["FulfillmentNoteWithoutOrderItemsUpdateInput"];
	["OrderItemUpsertFulfillmentNotesRelationInput"]: GraphQLTypes["OrderItemUpsertFulfillmentNotesRelationInput"];
	["VirtualProductEffectUpsertOrderItemRelationInput"]: GraphQLTypes["VirtualProductEffectUpsertOrderItemRelationInput"];
	["VirtualProductEffectUpdateResultVouchersEntityRelationInput"]: GraphQLTypes["VirtualProductEffectUpdateResultVouchersEntityRelationInput"];
	["VirtualProductEffectUpdateResultVouchersRelationInput"]: GraphQLTypes["VirtualProductEffectUpdateResultVouchersRelationInput"];
	["VoucherWithoutVirtualProductEffectUpdateInput"]: GraphQLTypes["VoucherWithoutVirtualProductEffectUpdateInput"];
	["VoucherUpdateBuyerEntityRelationInput"]: GraphQLTypes["VoucherUpdateBuyerEntityRelationInput"];
	["CustomerWithoutBoughtVouchersUpdateInput"]: GraphQLTypes["CustomerWithoutBoughtVouchersUpdateInput"];
	["CustomerUpdateOwnsVouchersEntityRelationInput"]: GraphQLTypes["CustomerUpdateOwnsVouchersEntityRelationInput"];
	["CustomerUpdateOwnsVouchersRelationInput"]: GraphQLTypes["CustomerUpdateOwnsVouchersRelationInput"];
	["VoucherWithoutOwnerUpdateInput"]: GraphQLTypes["VoucherWithoutOwnerUpdateInput"];
	["VoucherUpdateVatRateEntityRelationInput"]: GraphQLTypes["VoucherUpdateVatRateEntityRelationInput"];
	["VoucherUpsertVatRateRelationInput"]: GraphQLTypes["VoucherUpsertVatRateRelationInput"];
	["VoucherUpdateVirtualProductEffectEntityRelationInput"]: GraphQLTypes["VoucherUpdateVirtualProductEffectEntityRelationInput"];
	["VirtualProductEffectWithoutResultVouchersUpdateInput"]: GraphQLTypes["VirtualProductEffectWithoutResultVouchersUpdateInput"];
	["VoucherUpsertVirtualProductEffectRelationInput"]: GraphQLTypes["VoucherUpsertVirtualProductEffectRelationInput"];
	["VoucherUpdateRedemptionEntityRelationInput"]: GraphQLTypes["VoucherUpdateRedemptionEntityRelationInput"];
	["VoucherRedemptionWithoutVoucherUpdateInput"]: GraphQLTypes["VoucherRedemptionWithoutVoucherUpdateInput"];
	["VoucherRedemptionUpdateOrderDiscountEntityRelationInput"]: GraphQLTypes["VoucherRedemptionUpdateOrderDiscountEntityRelationInput"];
	["OrderDiscountWithoutVoucherRedemptionUpdateInput"]: GraphQLTypes["OrderDiscountWithoutVoucherRedemptionUpdateInput"];
	["VoucherRedemptionUpsertOrderDiscountRelationInput"]: GraphQLTypes["VoucherRedemptionUpsertOrderDiscountRelationInput"];
	["VoucherRedemptionUpdateCustomerEntityRelationInput"]: GraphQLTypes["VoucherRedemptionUpdateCustomerEntityRelationInput"];
	["CustomerWithoutRedeemedVouchersUpdateInput"]: GraphQLTypes["CustomerWithoutRedeemedVouchersUpdateInput"];
	["CustomerUpdateSpendingEntityRelationInput"]: GraphQLTypes["CustomerUpdateSpendingEntityRelationInput"];
	["CustomerUpdateCustomerTabsEntityRelationInput"]: GraphQLTypes["CustomerUpdateCustomerTabsEntityRelationInput"];
	["CustomerUpdateCustomerTabsRelationInput"]: GraphQLTypes["CustomerUpdateCustomerTabsRelationInput"];
	["CustomerTabWithoutCustomerUpdateInput"]: GraphQLTypes["CustomerTabWithoutCustomerUpdateInput"];
	["CustomerTabUpdateItemsEntityRelationInput"]: GraphQLTypes["CustomerTabUpdateItemsEntityRelationInput"];
	["CustomerTabUpdateItemsRelationInput"]: GraphQLTypes["CustomerTabUpdateItemsRelationInput"];
	["CustomerTabItemWithoutTabUpdateInput"]: GraphQLTypes["CustomerTabItemWithoutTabUpdateInput"];
	["CustomerTabItemUpdateProductEntityRelationInput"]: GraphQLTypes["CustomerTabItemUpdateProductEntityRelationInput"];
	["CustomerTabItemUpsertProductRelationInput"]: GraphQLTypes["CustomerTabItemUpsertProductRelationInput"];
	["CustomerTabUpsertItemsRelationInput"]: GraphQLTypes["CustomerTabUpsertItemsRelationInput"];
	["CustomerTabUpdateMetaEntityRelationInput"]: GraphQLTypes["CustomerTabUpdateMetaEntityRelationInput"];
	["CustomerTabUpdateTableEntityRelationInput"]: GraphQLTypes["CustomerTabUpdateTableEntityRelationInput"];
	["TableWithoutCustomerTabsUpdateInput"]: GraphQLTypes["TableWithoutCustomerTabsUpdateInput"];
	["TableUpdateAreaEntityRelationInput"]: GraphQLTypes["TableUpdateAreaEntityRelationInput"];
	["AreaWithoutTablesUpdateInput"]: GraphQLTypes["AreaWithoutTablesUpdateInput"];
	["AreaUpdateVenueEntityRelationInput"]: GraphQLTypes["AreaUpdateVenueEntityRelationInput"];
	["VenueWithoutAreasUpdateInput"]: GraphQLTypes["VenueWithoutAreasUpdateInput"];
	["VenueUpdateEnabledUnassignReasonsEntityRelationInput"]: GraphQLTypes["VenueUpdateEnabledUnassignReasonsEntityRelationInput"];
	["VenueUpdateEnabledUnassignReasonsRelationInput"]: GraphQLTypes["VenueUpdateEnabledUnassignReasonsRelationInput"];
	["UnassignReasonWithoutVenuesUpdateInput"]: GraphQLTypes["UnassignReasonWithoutVenuesUpdateInput"];
	["VenueUpsertEnabledUnassignReasonsRelationInput"]: GraphQLTypes["VenueUpsertEnabledUnassignReasonsRelationInput"];
	["VenueUpdateCategoriesEntityRelationInput"]: GraphQLTypes["VenueUpdateCategoriesEntityRelationInput"];
	["VenueUpdateCategoriesRelationInput"]: GraphQLTypes["VenueUpdateCategoriesRelationInput"];
	["PointOfSaleCategoryWithoutVenueUpdateInput"]: GraphQLTypes["PointOfSaleCategoryWithoutVenueUpdateInput"];
	["PointOfSaleCategoryUpdateCategoryEntityRelationInput"]: GraphQLTypes["PointOfSaleCategoryUpdateCategoryEntityRelationInput"];
	["PointOfSaleCategoryUpsertCategoryRelationInput"]: GraphQLTypes["PointOfSaleCategoryUpsertCategoryRelationInput"];
	["PointOfSaleCategoryUpdateTicketPrintersEntityRelationInput"]: GraphQLTypes["PointOfSaleCategoryUpdateTicketPrintersEntityRelationInput"];
	["PointOfSaleCategoryUpdateTicketPrintersRelationInput"]: GraphQLTypes["PointOfSaleCategoryUpdateTicketPrintersRelationInput"];
	["PointOfSalePrinterWithoutTicketCategoriesUpdateInput"]: GraphQLTypes["PointOfSalePrinterWithoutTicketCategoriesUpdateInput"];
	["PointOfSalePrinterUpdateApplicationDevicesTicketEntityRelationInput"]: GraphQLTypes["PointOfSalePrinterUpdateApplicationDevicesTicketEntityRelationInput"];
	["PointOfSalePrinterUpdateApplicationDevicesTicketRelationInput"]: GraphQLTypes["PointOfSalePrinterUpdateApplicationDevicesTicketRelationInput"];
	["PointOfSaleApplicationDeviceWithoutTicketPrintersUpdateInput"]: GraphQLTypes["PointOfSaleApplicationDeviceWithoutTicketPrintersUpdateInput"];
	["PointOfSaleApplicationDeviceUpdateReceiptPrinterEntityRelationInput"]: GraphQLTypes["PointOfSaleApplicationDeviceUpdateReceiptPrinterEntityRelationInput"];
	["PointOfSalePrinterWithoutApplicationDevicesReceiptUpdateInput"]: GraphQLTypes["PointOfSalePrinterWithoutApplicationDevicesReceiptUpdateInput"];
	["PointOfSalePrinterUpdateVenueEntityRelationInput"]: GraphQLTypes["PointOfSalePrinterUpdateVenueEntityRelationInput"];
	["VenueWithoutPointOfSalePrintersUpdateInput"]: GraphQLTypes["VenueWithoutPointOfSalePrintersUpdateInput"];
	["VenueUpdateAreasEntityRelationInput"]: GraphQLTypes["VenueUpdateAreasEntityRelationInput"];
	["VenueUpdateAreasRelationInput"]: GraphQLTypes["VenueUpdateAreasRelationInput"];
	["AreaWithoutVenueUpdateInput"]: GraphQLTypes["AreaWithoutVenueUpdateInput"];
	["AreaUpdateTablesEntityRelationInput"]: GraphQLTypes["AreaUpdateTablesEntityRelationInput"];
	["AreaUpdateTablesRelationInput"]: GraphQLTypes["AreaUpdateTablesRelationInput"];
	["TableWithoutAreaUpdateInput"]: GraphQLTypes["TableWithoutAreaUpdateInput"];
	["TableUpdateCustomerTabsEntityRelationInput"]: GraphQLTypes["TableUpdateCustomerTabsEntityRelationInput"];
	["TableUpdateCustomerTabsRelationInput"]: GraphQLTypes["TableUpdateCustomerTabsRelationInput"];
	["CustomerTabWithoutTableUpdateInput"]: GraphQLTypes["CustomerTabWithoutTableUpdateInput"];
	["CustomerTabUpdateCustomerEntityRelationInput"]: GraphQLTypes["CustomerTabUpdateCustomerEntityRelationInput"];
	["CustomerWithoutCustomerTabsUpdateInput"]: GraphQLTypes["CustomerWithoutCustomerTabsUpdateInput"];
	["CustomerUpdateLeadEntityRelationInput"]: GraphQLTypes["CustomerUpdateLeadEntityRelationInput"];
	["CustomerUpdateLeadRelationInput"]: GraphQLTypes["CustomerUpdateLeadRelationInput"];
	["PipelineLeadWithoutCustomerUpdateInput"]: GraphQLTypes["PipelineLeadWithoutCustomerUpdateInput"];
	["PipelineLeadUpdateStageItemEntityRelationInput"]: GraphQLTypes["PipelineLeadUpdateStageItemEntityRelationInput"];
	["PipelineStageItemWithoutLeadUpdateInput"]: GraphQLTypes["PipelineStageItemWithoutLeadUpdateInput"];
	["PipelineStageItemUpdateListEntityRelationInput"]: GraphQLTypes["PipelineStageItemUpdateListEntityRelationInput"];
	["PipelineStageWithoutItemsUpdateInput"]: GraphQLTypes["PipelineStageWithoutItemsUpdateInput"];
	["PipelineStageUpdatePipelineEntityRelationInput"]: GraphQLTypes["PipelineStageUpdatePipelineEntityRelationInput"];
	["PipelineWithoutStagesUpdateInput"]: GraphQLTypes["PipelineWithoutStagesUpdateInput"];
	["PipelineStageUpsertPipelineRelationInput"]: GraphQLTypes["PipelineStageUpsertPipelineRelationInput"];
	["PipelineStageUpdateLocalesEntityRelationInput"]: GraphQLTypes["PipelineStageUpdateLocalesEntityRelationInput"];
	["PipelineStageUpdateLocalesRelationInput"]: GraphQLTypes["PipelineStageUpdateLocalesRelationInput"];
	["PipelineStageLocaleWithoutRootUpdateInput"]: GraphQLTypes["PipelineStageLocaleWithoutRootUpdateInput"];
	["PipelineStageLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["PipelineStageLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutPipelineStagesUpdateInput"]: GraphQLTypes["LocaleWithoutPipelineStagesUpdateInput"];
	["LocaleUpdateSubscriptionBoxesEntityRelationInput"]: GraphQLTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"];
	["LocaleUpdateSubscriptionBoxesRelationInput"]: GraphQLTypes["LocaleUpdateSubscriptionBoxesRelationInput"];
	["SubscriptionBoxLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["SubscriptionBoxLocaleWithoutLocaleUpdateInput"];
	["SubscriptionBoxLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["SubscriptionBoxLocaleUpdateRootEntityRelationInput"];
	["SubscriptionBoxWithoutLocalesUpdateInput"]: GraphQLTypes["SubscriptionBoxWithoutLocalesUpdateInput"];
	["SubscriptionBoxLocaleUpsertRootRelationInput"]: GraphQLTypes["SubscriptionBoxLocaleUpsertRootRelationInput"];
	["SubscriptionBoxLocaleUpdateTextsEntityRelationInput"]: GraphQLTypes["SubscriptionBoxLocaleUpdateTextsEntityRelationInput"];
	["SubscriptionBoxLocaleUpsertTextsRelationInput"]: GraphQLTypes["SubscriptionBoxLocaleUpsertTextsRelationInput"];
	["SubscriptionBoxLocaleUpdateSecondaryTextsEntityRelationInput"]: GraphQLTypes["SubscriptionBoxLocaleUpdateSecondaryTextsEntityRelationInput"];
	["SubscriptionBoxLocaleUpsertSecondaryTextsRelationInput"]: GraphQLTypes["SubscriptionBoxLocaleUpsertSecondaryTextsRelationInput"];
	["LocaleUpsertSubscriptionBoxesRelationInput"]: GraphQLTypes["LocaleUpsertSubscriptionBoxesRelationInput"];
	["LocaleUpdateBusinessServicesEntityRelationInput"]: GraphQLTypes["LocaleUpdateBusinessServicesEntityRelationInput"];
	["LocaleUpdateBusinessServicesRelationInput"]: GraphQLTypes["LocaleUpdateBusinessServicesRelationInput"];
	["BusinessServiceLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["BusinessServiceLocaleWithoutLocaleUpdateInput"];
	["BusinessServiceLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["BusinessServiceLocaleUpdateRootEntityRelationInput"];
	["BusinessServiceWithoutLocalesUpdateInput"]: GraphQLTypes["BusinessServiceWithoutLocalesUpdateInput"];
	["BusinessServiceLocaleUpsertRootRelationInput"]: GraphQLTypes["BusinessServiceLocaleUpsertRootRelationInput"];
	["LocaleUpsertBusinessServicesRelationInput"]: GraphQLTypes["LocaleUpsertBusinessServicesRelationInput"];
	["PipelineStageLocaleUpsertLocaleRelationInput"]: GraphQLTypes["PipelineStageLocaleUpsertLocaleRelationInput"];
	["PipelineStageUpsertLocalesRelationInput"]: GraphQLTypes["PipelineStageUpsertLocalesRelationInput"];
	["PipelineStageUpdateSentimentEntityRelationInput"]: GraphQLTypes["PipelineStageUpdateSentimentEntityRelationInput"];
	["PipelineStageSentimentUpdateInput"]: GraphQLTypes["PipelineStageSentimentUpdateInput"];
	["PipelineStageUpsertSentimentRelationInput"]: GraphQLTypes["PipelineStageUpsertSentimentRelationInput"];
	["PipelineStageUpdateFormsEntityRelationInput"]: GraphQLTypes["PipelineStageUpdateFormsEntityRelationInput"];
	["PipelineStageUpdateFormsRelationInput"]: GraphQLTypes["PipelineStageUpdateFormsRelationInput"];
	["LeadFormWithoutStageUpdateInput"]: GraphQLTypes["LeadFormWithoutStageUpdateInput"];
	["LeadFormUpdateLeadsEntityRelationInput"]: GraphQLTypes["LeadFormUpdateLeadsEntityRelationInput"];
	["LeadFormUpdateLeadsRelationInput"]: GraphQLTypes["LeadFormUpdateLeadsRelationInput"];
	["PipelineLeadWithoutFormUpdateInput"]: GraphQLTypes["PipelineLeadWithoutFormUpdateInput"];
	["PipelineLeadUpdateCustomerEntityRelationInput"]: GraphQLTypes["PipelineLeadUpdateCustomerEntityRelationInput"];
	["CustomerWithoutLeadUpdateInput"]: GraphQLTypes["CustomerWithoutLeadUpdateInput"];
	["CustomerUpdateMetaEntityRelationInput"]: GraphQLTypes["CustomerUpdateMetaEntityRelationInput"];
	["PipelineLeadUpsertCustomerRelationInput"]: GraphQLTypes["PipelineLeadUpsertCustomerRelationInput"];
	["LeadFormUpsertLeadsRelationInput"]: GraphQLTypes["LeadFormUpsertLeadsRelationInput"];
	["PipelineStageUpsertFormsRelationInput"]: GraphQLTypes["PipelineStageUpsertFormsRelationInput"];
	["PipelineStageItemUpsertListRelationInput"]: GraphQLTypes["PipelineStageItemUpsertListRelationInput"];
	["PipelineLeadUpsertStageItemRelationInput"]: GraphQLTypes["PipelineLeadUpsertStageItemRelationInput"];
	["PipelineLeadUpdateFormEntityRelationInput"]: GraphQLTypes["PipelineLeadUpdateFormEntityRelationInput"];
	["LeadFormWithoutLeadsUpdateInput"]: GraphQLTypes["LeadFormWithoutLeadsUpdateInput"];
	["LeadFormUpdateStageEntityRelationInput"]: GraphQLTypes["LeadFormUpdateStageEntityRelationInput"];
	["PipelineStageWithoutFormsUpdateInput"]: GraphQLTypes["PipelineStageWithoutFormsUpdateInput"];
	["PipelineStageUpdateItemsEntityRelationInput"]: GraphQLTypes["PipelineStageUpdateItemsEntityRelationInput"];
	["PipelineStageUpdateItemsRelationInput"]: GraphQLTypes["PipelineStageUpdateItemsRelationInput"];
	["PipelineStageItemWithoutListUpdateInput"]: GraphQLTypes["PipelineStageItemWithoutListUpdateInput"];
	["PipelineStageItemUpdateLeadEntityRelationInput"]: GraphQLTypes["PipelineStageItemUpdateLeadEntityRelationInput"];
	["PipelineLeadWithoutStageItemUpdateInput"]: GraphQLTypes["PipelineLeadWithoutStageItemUpdateInput"];
	["PipelineStageItemUpsertLeadRelationInput"]: GraphQLTypes["PipelineStageItemUpsertLeadRelationInput"];
	["PipelineStageUpsertItemsRelationInput"]: GraphQLTypes["PipelineStageUpsertItemsRelationInput"];
	["LeadFormUpsertStageRelationInput"]: GraphQLTypes["LeadFormUpsertStageRelationInput"];
	["PipelineLeadUpsertFormRelationInput"]: GraphQLTypes["PipelineLeadUpsertFormRelationInput"];
	["CustomerUpsertLeadRelationInput"]: GraphQLTypes["CustomerUpsertLeadRelationInput"];
	["CustomerTabUpsertCustomerRelationInput"]: GraphQLTypes["CustomerTabUpsertCustomerRelationInput"];
	["CustomerTabUpdateSeatEntityRelationInput"]: GraphQLTypes["CustomerTabUpdateSeatEntityRelationInput"];
	["SeatWithoutCustomerTabsUpdateInput"]: GraphQLTypes["SeatWithoutCustomerTabsUpdateInput"];
	["SeatUpdateTableEntityRelationInput"]: GraphQLTypes["SeatUpdateTableEntityRelationInput"];
	["TableWithoutSeatsUpdateInput"]: GraphQLTypes["TableWithoutSeatsUpdateInput"];
	["SeatUpsertTableRelationInput"]: GraphQLTypes["SeatUpsertTableRelationInput"];
	["CustomerTabUpsertSeatRelationInput"]: GraphQLTypes["CustomerTabUpsertSeatRelationInput"];
	["TableUpsertCustomerTabsRelationInput"]: GraphQLTypes["TableUpsertCustomerTabsRelationInput"];
	["TableUpdateSeatsEntityRelationInput"]: GraphQLTypes["TableUpdateSeatsEntityRelationInput"];
	["TableUpdateSeatsRelationInput"]: GraphQLTypes["TableUpdateSeatsRelationInput"];
	["SeatWithoutTableUpdateInput"]: GraphQLTypes["SeatWithoutTableUpdateInput"];
	["SeatUpdateCustomerTabsEntityRelationInput"]: GraphQLTypes["SeatUpdateCustomerTabsEntityRelationInput"];
	["SeatUpdateCustomerTabsRelationInput"]: GraphQLTypes["SeatUpdateCustomerTabsRelationInput"];
	["CustomerTabWithoutSeatUpdateInput"]: GraphQLTypes["CustomerTabWithoutSeatUpdateInput"];
	["SeatUpsertCustomerTabsRelationInput"]: GraphQLTypes["SeatUpsertCustomerTabsRelationInput"];
	["TableUpsertSeatsRelationInput"]: GraphQLTypes["TableUpsertSeatsRelationInput"];
	["AreaUpsertTablesRelationInput"]: GraphQLTypes["AreaUpsertTablesRelationInput"];
	["AreaUpdateLinesEntityRelationInput"]: GraphQLTypes["AreaUpdateLinesEntityRelationInput"];
	["AreaUpdateLinesRelationInput"]: GraphQLTypes["AreaUpdateLinesRelationInput"];
	["LineWithoutAreaUpdateInput"]: GraphQLTypes["LineWithoutAreaUpdateInput"];
	["AreaUpsertLinesRelationInput"]: GraphQLTypes["AreaUpsertLinesRelationInput"];
	["VenueUpsertAreasRelationInput"]: GraphQLTypes["VenueUpsertAreasRelationInput"];
	["VenueUpdateChannelsEntityRelationInput"]: GraphQLTypes["VenueUpdateChannelsEntityRelationInput"];
	["VenueUpdateChannelsRelationInput"]: GraphQLTypes["VenueUpdateChannelsRelationInput"];
	["ChannelWithoutVenueUpdateInput"]: GraphQLTypes["ChannelWithoutVenueUpdateInput"];
	["VenueUpsertChannelsRelationInput"]: GraphQLTypes["VenueUpsertChannelsRelationInput"];
	["PointOfSalePrinterUpsertVenueRelationInput"]: GraphQLTypes["PointOfSalePrinterUpsertVenueRelationInput"];
	["PointOfSalePrinterUpdateTicketCategoriesEntityRelationInput"]: GraphQLTypes["PointOfSalePrinterUpdateTicketCategoriesEntityRelationInput"];
	["PointOfSalePrinterUpdateTicketCategoriesRelationInput"]: GraphQLTypes["PointOfSalePrinterUpdateTicketCategoriesRelationInput"];
	["PointOfSaleCategoryWithoutTicketPrintersUpdateInput"]: GraphQLTypes["PointOfSaleCategoryWithoutTicketPrintersUpdateInput"];
	["PointOfSaleCategoryUpdateVenueEntityRelationInput"]: GraphQLTypes["PointOfSaleCategoryUpdateVenueEntityRelationInput"];
	["VenueWithoutCategoriesUpdateInput"]: GraphQLTypes["VenueWithoutCategoriesUpdateInput"];
	["PointOfSaleCategoryUpsertVenueRelationInput"]: GraphQLTypes["PointOfSaleCategoryUpsertVenueRelationInput"];
	["PointOfSalePrinterUpsertTicketCategoriesRelationInput"]: GraphQLTypes["PointOfSalePrinterUpsertTicketCategoriesRelationInput"];
	["PointOfSaleApplicationDeviceUpsertReceiptPrinterRelationInput"]: GraphQLTypes["PointOfSaleApplicationDeviceUpsertReceiptPrinterRelationInput"];
	["PointOfSalePrinterUpsertApplicationDevicesTicketRelationInput"]: GraphQLTypes["PointOfSalePrinterUpsertApplicationDevicesTicketRelationInput"];
	["PointOfSaleCategoryUpsertTicketPrintersRelationInput"]: GraphQLTypes["PointOfSaleCategoryUpsertTicketPrintersRelationInput"];
	["VenueUpsertCategoriesRelationInput"]: GraphQLTypes["VenueUpsertCategoriesRelationInput"];
	["AreaUpsertVenueRelationInput"]: GraphQLTypes["AreaUpsertVenueRelationInput"];
	["TableUpsertAreaRelationInput"]: GraphQLTypes["TableUpsertAreaRelationInput"];
	["CustomerTabUpsertTableRelationInput"]: GraphQLTypes["CustomerTabUpsertTableRelationInput"];
	["CustomerUpsertCustomerTabsRelationInput"]: GraphQLTypes["CustomerUpsertCustomerTabsRelationInput"];
	["VoucherRedemptionUpsertCustomerRelationInput"]: GraphQLTypes["VoucherRedemptionUpsertCustomerRelationInput"];
	["VoucherUpsertRedemptionRelationInput"]: GraphQLTypes["VoucherUpsertRedemptionRelationInput"];
	["CustomerUpsertOwnsVouchersRelationInput"]: GraphQLTypes["CustomerUpsertOwnsVouchersRelationInput"];
	["VoucherUpsertBuyerRelationInput"]: GraphQLTypes["VoucherUpsertBuyerRelationInput"];
	["VirtualProductEffectUpsertResultVouchersRelationInput"]: GraphQLTypes["VirtualProductEffectUpsertResultVouchersRelationInput"];
	["CustomerCreditTransactionUpsertVirtualProductEffectRelationInput"]: GraphQLTypes["CustomerCreditTransactionUpsertVirtualProductEffectRelationInput"];
	["CustomerCreditUpsertTransactionsRelationInput"]: GraphQLTypes["CustomerCreditUpsertTransactionsRelationInput"];
	["VoucherRedemptionUpsertCustomerCreditRelationInput"]: GraphQLTypes["VoucherRedemptionUpsertCustomerCreditRelationInput"];
	["VoucherRedemptionUpdateVoucherEntityRelationInput"]: GraphQLTypes["VoucherRedemptionUpdateVoucherEntityRelationInput"];
	["VoucherWithoutRedemptionUpdateInput"]: GraphQLTypes["VoucherWithoutRedemptionUpdateInput"];
	["VoucherRedemptionUpsertVoucherRelationInput"]: GraphQLTypes["VoucherRedemptionUpsertVoucherRelationInput"];
	["CustomerUpsertRedeemedVouchersRelationInput"]: GraphQLTypes["CustomerUpsertRedeemedVouchersRelationInput"];
	["VoucherUpsertOwnerRelationInput"]: GraphQLTypes["VoucherUpsertOwnerRelationInput"];
	["CustomerUpsertBoughtVouchersRelationInput"]: GraphQLTypes["CustomerUpsertBoughtVouchersRelationInput"];
	["BillingSubjectUpsertDefaultBillingSubjectOfCustomerRelationInput"]: GraphQLTypes["BillingSubjectUpsertDefaultBillingSubjectOfCustomerRelationInput"];
	["OrderUpsertBillingSubjectRelationInput"]: GraphQLTypes["OrderUpsertBillingSubjectRelationInput"];
	["FulfillmentNoteUpsertOrdersRelationInput"]: GraphQLTypes["FulfillmentNoteUpsertOrdersRelationInput"];
	["VenueUpsertFulfillmentNotesRelationInput"]: GraphQLTypes["VenueUpsertFulfillmentNotesRelationInput"];
	["OrderUpsertVenueRelationInput"]: GraphQLTypes["OrderUpsertVenueRelationInput"];
	["OrderUpdateFulfillmentNotesEntityRelationInput"]: GraphQLTypes["OrderUpdateFulfillmentNotesEntityRelationInput"];
	["OrderUpdateFulfillmentNotesRelationInput"]: GraphQLTypes["OrderUpdateFulfillmentNotesRelationInput"];
	["FulfillmentNoteWithoutOrdersUpdateInput"]: GraphQLTypes["FulfillmentNoteWithoutOrdersUpdateInput"];
	["OrderUpsertFulfillmentNotesRelationInput"]: GraphQLTypes["OrderUpsertFulfillmentNotesRelationInput"];
	["BillingSubjectUpsertOrdersRelationInput"]: GraphQLTypes["BillingSubjectUpsertOrdersRelationInput"];
	["CustomerUpsertDefaultBillingSubjectRelationInput"]: GraphQLTypes["CustomerUpsertDefaultBillingSubjectRelationInput"];
	["BillingSubjectUpsertCustomerRelationInput"]: GraphQLTypes["BillingSubjectUpsertCustomerRelationInput"];
	["InvoiceUpsertBillingSubjectRelationInput"]: GraphQLTypes["InvoiceUpsertBillingSubjectRelationInput"];
	["OrderPaymentUpsertInvoiceRelationInput"]: GraphQLTypes["OrderPaymentUpsertInvoiceRelationInput"];
	["OrderPaymentUpdateVatRateEntityRelationInput"]: GraphQLTypes["OrderPaymentUpdateVatRateEntityRelationInput"];
	["OrderPaymentUpsertVatRateRelationInput"]: GraphQLTypes["OrderPaymentUpsertVatRateRelationInput"];
	["OrderPaymentUpdateMetaEntityRelationInput"]: GraphQLTypes["OrderPaymentUpdateMetaEntityRelationInput"];
	["OrderUpsertPaymentsRelationInput"]: GraphQLTypes["OrderUpsertPaymentsRelationInput"];
	["OrderDeliveryUpsertOrderRelationInput"]: GraphQLTypes["OrderDeliveryUpsertOrderRelationInput"];
	["OrderDeliveryUpdateEventsEntityRelationInput"]: GraphQLTypes["OrderDeliveryUpdateEventsEntityRelationInput"];
	["OrderDeliveryUpdateEventsRelationInput"]: GraphQLTypes["OrderDeliveryUpdateEventsRelationInput"];
	["OrderEventWithoutDeliveryUpdateInput"]: GraphQLTypes["OrderEventWithoutDeliveryUpdateInput"];
	["OrderDeliveryUpsertEventsRelationInput"]: GraphQLTypes["OrderDeliveryUpsertEventsRelationInput"];
	["OrderDeliveryUpdateLiftagoRideEntityRelationInput"]: GraphQLTypes["OrderDeliveryUpdateLiftagoRideEntityRelationInput"];
	["LiftagoRideWithoutDeliveryUpdateInput"]: GraphQLTypes["LiftagoRideWithoutDeliveryUpdateInput"];
	["OrderDeliveryUpsertLiftagoRideRelationInput"]: GraphQLTypes["OrderDeliveryUpsertLiftagoRideRelationInput"];
	["OrderDeliveryUpdateWoltDriveDeliveryEntityRelationInput"]: GraphQLTypes["OrderDeliveryUpdateWoltDriveDeliveryEntityRelationInput"];
	["WoltDriveDeliveryWithoutDeliveryUpdateInput"]: GraphQLTypes["WoltDriveDeliveryWithoutDeliveryUpdateInput"];
	["OrderDeliveryUpsertWoltDriveDeliveryRelationInput"]: GraphQLTypes["OrderDeliveryUpsertWoltDriveDeliveryRelationInput"];
	["AddressUpsertDeliveryAddressOfOrderDeliveriesRelationInput"]: GraphQLTypes["AddressUpsertDeliveryAddressOfOrderDeliveriesRelationInput"];
	["AddressUpdateDefaultDeliveryAddressOfCustomerEntityRelationInput"]: GraphQLTypes["AddressUpdateDefaultDeliveryAddressOfCustomerEntityRelationInput"];
	["CustomerWithoutDefaultDeliveryAddressUpdateInput"]: GraphQLTypes["CustomerWithoutDefaultDeliveryAddressUpdateInput"];
	["AddressUpsertDefaultDeliveryAddressOfCustomerRelationInput"]: GraphQLTypes["AddressUpsertDefaultDeliveryAddressOfCustomerRelationInput"];
	["OrderUpsertBillingAddressRelationInput"]: GraphQLTypes["OrderUpsertBillingAddressRelationInput"];
	["OrderPaymentUpsertOrderRelationInput"]: GraphQLTypes["OrderPaymentUpsertOrderRelationInput"];
	["OrderEventUpsertPaymentRelationInput"]: GraphQLTypes["OrderEventUpsertPaymentRelationInput"];
	["OrderEventUpdateDeliveryEntityRelationInput"]: GraphQLTypes["OrderEventUpdateDeliveryEntityRelationInput"];
	["OrderDeliveryWithoutEventsUpdateInput"]: GraphQLTypes["OrderDeliveryWithoutEventsUpdateInput"];
	["OrderDeliveryUpdateAddressEntityRelationInput"]: GraphQLTypes["OrderDeliveryUpdateAddressEntityRelationInput"];
	["AddressWithoutDeliveryAddressOfOrderDeliveriesUpdateInput"]: GraphQLTypes["AddressWithoutDeliveryAddressOfOrderDeliveriesUpdateInput"];
	["OrderDeliveryUpsertAddressRelationInput"]: GraphQLTypes["OrderDeliveryUpsertAddressRelationInput"];
	["OrderEventUpsertDeliveryRelationInput"]: GraphQLTypes["OrderEventUpsertDeliveryRelationInput"];
	["OrderUpsertEventsRelationInput"]: GraphQLTypes["OrderUpsertEventsRelationInput"];
	["AddressUpsertBillingAddressOfOrdersRelationInput"]: GraphQLTypes["AddressUpsertBillingAddressOfOrdersRelationInput"];
	["InvoiceUpsertAddressRelationInput"]: GraphQLTypes["InvoiceUpsertAddressRelationInput"];
	["BillingSubjectUpsertInvoicesRelationInput"]: GraphQLTypes["BillingSubjectUpsertInvoicesRelationInput"];
	["CustomerUpsertBillingSubjectsRelationInput"]: GraphQLTypes["CustomerUpsertBillingSubjectsRelationInput"];
	["CartUpsertCustomerRelationInput"]: GraphQLTypes["CartUpsertCustomerRelationInput"];
	["CartUpdateDeliveryAddressEntityRelationInput"]: GraphQLTypes["CartUpdateDeliveryAddressEntityRelationInput"];
	["CartUpsertDeliveryAddressRelationInput"]: GraphQLTypes["CartUpsertDeliveryAddressRelationInput"];
	["CartUpdateBillingAddressEntityRelationInput"]: GraphQLTypes["CartUpdateBillingAddressEntityRelationInput"];
	["CartUpsertBillingAddressRelationInput"]: GraphQLTypes["CartUpsertBillingAddressRelationInput"];
	["CartUpdateDeliveryEntityRelationInput"]: GraphQLTypes["CartUpdateDeliveryEntityRelationInput"];
	["ChannelDeliveryUpdateInput"]: GraphQLTypes["ChannelDeliveryUpdateInput"];
	["CartUpsertDeliveryRelationInput"]: GraphQLTypes["CartUpsertDeliveryRelationInput"];
	["CartUpdatePaymentEntityRelationInput"]: GraphQLTypes["CartUpdatePaymentEntityRelationInput"];
	["ChannelPaymentUpdateInput"]: GraphQLTypes["ChannelPaymentUpdateInput"];
	["CartUpsertPaymentRelationInput"]: GraphQLTypes["CartUpsertPaymentRelationInput"];
	["CartUpdateBillingSubjectEntityRelationInput"]: GraphQLTypes["CartUpdateBillingSubjectEntityRelationInput"];
	["BillingSubjectUpdateInput"]: GraphQLTypes["BillingSubjectUpdateInput"];
	["CartUpsertBillingSubjectRelationInput"]: GraphQLTypes["CartUpsertBillingSubjectRelationInput"];
	["CartUpdatePriceLinesEntityRelationInput"]: GraphQLTypes["CartUpdatePriceLinesEntityRelationInput"];
	["CartUpdateSummaryEntityRelationInput"]: GraphQLTypes["CartUpdateSummaryEntityRelationInput"];
	["OrderUpsertCartRelationInput"]: GraphQLTypes["OrderUpsertCartRelationInput"];
	["OrderDiscountUpsertOrderRelationInput"]: GraphQLTypes["OrderDiscountUpsertOrderRelationInput"];
	["OrderDiscountUpdateVoucherRedemptionEntityRelationInput"]: GraphQLTypes["OrderDiscountUpdateVoucherRedemptionEntityRelationInput"];
	["VoucherRedemptionWithoutOrderDiscountUpdateInput"]: GraphQLTypes["VoucherRedemptionWithoutOrderDiscountUpdateInput"];
	["OrderDiscountUpsertVoucherRedemptionRelationInput"]: GraphQLTypes["OrderDiscountUpsertVoucherRedemptionRelationInput"];
	["CustomerCreditTransactionUpsertOrderDiscountRelationInput"]: GraphQLTypes["CustomerCreditTransactionUpsertOrderDiscountRelationInput"];
	["VirtualProductEffectUpsertResultCustomerCreditTransactionRelationInput"]: GraphQLTypes["VirtualProductEffectUpsertResultCustomerCreditTransactionRelationInput"];
	["OrderItemUpsertVirtualProductEffectsRelationInput"]: GraphQLTypes["OrderItemUpsertVirtualProductEffectsRelationInput"];
	["OrderUpsertItemsRelationInput"]: GraphQLTypes["OrderUpsertItemsRelationInput"];
	["VenueUpsertOrdersRelationInput"]: GraphQLTypes["VenueUpsertOrdersRelationInput"];
	["PointOfSaleTerminalUpsertVenueRelationInput"]: GraphQLTypes["PointOfSaleTerminalUpsertVenueRelationInput"];
	["PointOfSaleApplicationDeviceUpsertTerminalRelationInput"]: GraphQLTypes["PointOfSaleApplicationDeviceUpsertTerminalRelationInput"];
	["PointOfSaleApplicationDeviceUpdateTicketPrintersEntityRelationInput"]: GraphQLTypes["PointOfSaleApplicationDeviceUpdateTicketPrintersEntityRelationInput"];
	["PointOfSaleApplicationDeviceUpdateTicketPrintersRelationInput"]: GraphQLTypes["PointOfSaleApplicationDeviceUpdateTicketPrintersRelationInput"];
	["PointOfSalePrinterWithoutApplicationDevicesTicketUpdateInput"]: GraphQLTypes["PointOfSalePrinterWithoutApplicationDevicesTicketUpdateInput"];
	["PointOfSaleApplicationDeviceUpsertTicketPrintersRelationInput"]: GraphQLTypes["PointOfSaleApplicationDeviceUpsertTicketPrintersRelationInput"];
	["IdentificationCodeUpsertApplicationDevicesRelationInput"]: GraphQLTypes["IdentificationCodeUpsertApplicationDevicesRelationInput"];
	["IdentificationCodeLocaleUpsertRootRelationInput"]: GraphQLTypes["IdentificationCodeLocaleUpsertRootRelationInput"];
	["LocaleUpsertIdentificationCodesRelationInput"]: GraphQLTypes["LocaleUpsertIdentificationCodesRelationInput"];
	["LocaleUpdatePipelineStagesEntityRelationInput"]: GraphQLTypes["LocaleUpdatePipelineStagesEntityRelationInput"];
	["LocaleUpdatePipelineStagesRelationInput"]: GraphQLTypes["LocaleUpdatePipelineStagesRelationInput"];
	["PipelineStageLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["PipelineStageLocaleWithoutLocaleUpdateInput"];
	["PipelineStageLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["PipelineStageLocaleUpdateRootEntityRelationInput"];
	["PipelineStageWithoutLocalesUpdateInput"]: GraphQLTypes["PipelineStageWithoutLocalesUpdateInput"];
	["PipelineStageLocaleUpsertRootRelationInput"]: GraphQLTypes["PipelineStageLocaleUpsertRootRelationInput"];
	["LocaleUpsertPipelineStagesRelationInput"]: GraphQLTypes["LocaleUpsertPipelineStagesRelationInput"];
	["PointOfSaleCategoryLocaleUpsertLocaleRelationInput"]: GraphQLTypes["PointOfSaleCategoryLocaleUpsertLocaleRelationInput"];
	["PointOfSaleCategoryUpsertLocalesRelationInput"]: GraphQLTypes["PointOfSaleCategoryUpsertLocalesRelationInput"];
	["PointOfSaleCategoryProductUpsertCategoryRelationInput"]: GraphQLTypes["PointOfSaleCategoryProductUpsertCategoryRelationInput"];
	["PointOfSaleCategoryProductLocaleUpsertRootRelationInput"]: GraphQLTypes["PointOfSaleCategoryProductLocaleUpsertRootRelationInput"];
	["LocaleUpsertPointOfSaleCategoryProductsRelationInput"]: GraphQLTypes["LocaleUpsertPointOfSaleCategoryProductsRelationInput"];
	["IdentificationCodeLocaleUpsertLocaleRelationInput"]: GraphQLTypes["IdentificationCodeLocaleUpsertLocaleRelationInput"];
	["IdentificationCodeUpsertLocalesRelationInput"]: GraphQLTypes["IdentificationCodeUpsertLocalesRelationInput"];
	["IdentificationAttemptUpsertCodeRelationInput"]: GraphQLTypes["IdentificationAttemptUpsertCodeRelationInput"];
	["UserUpsertIdentificationAttemptsRelationInput"]: GraphQLTypes["UserUpsertIdentificationAttemptsRelationInput"];
	["DeviceIdentifierUpsertUpdatedByUserRelationInput"]: GraphQLTypes["DeviceIdentifierUpsertUpdatedByUserRelationInput"];
	["PointOfSaleApplicationDeviceUpsertIdentifierRelationInput"]: GraphQLTypes["PointOfSaleApplicationDeviceUpsertIdentifierRelationInput"];
	["PointOfSalePrinterUpsertApplicationDevicesReceiptRelationInput"]: GraphQLTypes["PointOfSalePrinterUpsertApplicationDevicesReceiptRelationInput"];
	["VenueUpsertPointOfSalePrintersRelationInput"]: GraphQLTypes["VenueUpsertPointOfSalePrintersRelationInput"];
	["PointOfSaleApplicationDeviceUpsertVenueRelationInput"]: GraphQLTypes["PointOfSaleApplicationDeviceUpsertVenueRelationInput"];
	["PointOfSaleTerminalUpsertApplicationDevicesRelationInput"]: GraphQLTypes["PointOfSaleTerminalUpsertApplicationDevicesRelationInput"];
	["VenueUpsertPointOfSaleTerminalsRelationInput"]: GraphQLTypes["VenueUpsertPointOfSaleTerminalsRelationInput"];
	["FulfillmentNoteUpsertVenuesRelationInput"]: GraphQLTypes["FulfillmentNoteUpsertVenuesRelationInput"];
	["ProductUpsertFulfillmentNotesRelationInput"]: GraphQLTypes["ProductUpsertFulfillmentNotesRelationInput"];
	["PointOfSaleCategoryProductUpsertProductRelationInput"]: GraphQLTypes["PointOfSaleCategoryProductUpsertProductRelationInput"];
	["PointOfSaleCategoryProductUpdateLocalesEntityRelationInput"]: GraphQLTypes["PointOfSaleCategoryProductUpdateLocalesEntityRelationInput"];
	["PointOfSaleCategoryProductUpdateLocalesRelationInput"]: GraphQLTypes["PointOfSaleCategoryProductUpdateLocalesRelationInput"];
	["PointOfSaleCategoryProductLocaleWithoutRootUpdateInput"]: GraphQLTypes["PointOfSaleCategoryProductLocaleWithoutRootUpdateInput"];
	["PointOfSaleCategoryProductLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["PointOfSaleCategoryProductLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutPointOfSaleCategoryProductsUpdateInput"]: GraphQLTypes["LocaleWithoutPointOfSaleCategoryProductsUpdateInput"];
	["PointOfSaleCategoryProductLocaleUpsertLocaleRelationInput"]: GraphQLTypes["PointOfSaleCategoryProductLocaleUpsertLocaleRelationInput"];
	["PointOfSaleCategoryProductUpsertLocalesRelationInput"]: GraphQLTypes["PointOfSaleCategoryProductUpsertLocalesRelationInput"];
	["PointOfSaleCategoryUpsertProductsRelationInput"]: GraphQLTypes["PointOfSaleCategoryUpsertProductsRelationInput"];
	["PointOfSaleCategoryLocaleUpsertRootRelationInput"]: GraphQLTypes["PointOfSaleCategoryLocaleUpsertRootRelationInput"];
	["LocaleUpsertPointOfSaleCategoriesRelationInput"]: GraphQLTypes["LocaleUpsertPointOfSaleCategoriesRelationInput"];
	["ProductLocaleUpsertLocaleRelationInput"]: GraphQLTypes["ProductLocaleUpsertLocaleRelationInput"];
	["ProductUpsertLocalesRelationInput"]: GraphQLTypes["ProductUpsertLocalesRelationInput"];
	["ProductRecipeUpsertProductsRelationInput"]: GraphQLTypes["ProductRecipeUpsertProductsRelationInput"];
	["ProductRecipeUpdateLocalesEntityRelationInput"]: GraphQLTypes["ProductRecipeUpdateLocalesEntityRelationInput"];
	["ProductRecipeUpdateLocalesRelationInput"]: GraphQLTypes["ProductRecipeUpdateLocalesRelationInput"];
	["ProductRecipeLocaleWithoutRootUpdateInput"]: GraphQLTypes["ProductRecipeLocaleWithoutRootUpdateInput"];
	["ProductRecipeLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["ProductRecipeLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutProductRecipesUpdateInput"]: GraphQLTypes["LocaleWithoutProductRecipesUpdateInput"];
	["ProductRecipeLocaleUpsertLocaleRelationInput"]: GraphQLTypes["ProductRecipeLocaleUpsertLocaleRelationInput"];
	["ProductRecipeUpsertLocalesRelationInput"]: GraphQLTypes["ProductRecipeUpsertLocalesRelationInput"];
	["PreparedPackingQuantityUpsertRecipeRelationInput"]: GraphQLTypes["PreparedPackingQuantityUpsertRecipeRelationInput"];
	["ProductPackingUpsertPreparedPackingQuantitiesRelationInput"]: GraphQLTypes["ProductPackingUpsertPreparedPackingQuantitiesRelationInput"];
	["ProductPackingLocaleUpsertRootRelationInput"]: GraphQLTypes["ProductPackingLocaleUpsertRootRelationInput"];
	["LocaleUpsertProductPackingsRelationInput"]: GraphQLTypes["LocaleUpsertProductPackingsRelationInput"];
	["DeliveryMethodLocaleUpsertLocaleRelationInput"]: GraphQLTypes["DeliveryMethodLocaleUpsertLocaleRelationInput"];
	["DeliveryMethodUpsertLocalesRelationInput"]: GraphQLTypes["DeliveryMethodUpsertLocalesRelationInput"];
	["CourierUpsertDeliveryMethodsRelationInput"]: GraphQLTypes["CourierUpsertDeliveryMethodsRelationInput"];
	["DeliveryRouteUpsertCourierRelationInput"]: GraphQLTypes["DeliveryRouteUpsertCourierRelationInput"];
	["DeliveryWaypointUpsertRouteRelationInput"]: GraphQLTypes["DeliveryWaypointUpsertRouteRelationInput"];
	["OrderDeliveryUpsertDeliveryWaypointRelationInput"]: GraphQLTypes["OrderDeliveryUpsertDeliveryWaypointRelationInput"];
	["OrderUpsertDeliveryRelationInput"]: GraphQLTypes["OrderUpsertDeliveryRelationInput"];
	["OrderEventUpsertOrderRelationInput"]: GraphQLTypes["OrderEventUpsertOrderRelationInput"];
	["OrderPaymentUpsertEventsRelationInput"]: GraphQLTypes["OrderPaymentUpsertEventsRelationInput"];
	["InvoiceUpsertOrderPaymentsRelationInput"]: GraphQLTypes["InvoiceUpsertOrderPaymentsRelationInput"];
	["CustomerUpsertInvoicesRelationInput"]: GraphQLTypes["CustomerUpsertInvoicesRelationInput"];
	["AnonymousSessionUpsertCustomerRelationInput"]: GraphQLTypes["AnonymousSessionUpsertCustomerRelationInput"];
	["UserDeviceUpsertAnonymousSessionRelationInput"]: GraphQLTypes["UserDeviceUpsertAnonymousSessionRelationInput"];
	["UserUpsertDevicesRelationInput"]: GraphQLTypes["UserUpsertDevicesRelationInput"];
	["IdentificationAttemptUpsertUserRelationInput"]: GraphQLTypes["IdentificationAttemptUpsertUserRelationInput"];
	["IdentificationCodeUpsertAttemptsRelationInput"]: GraphQLTypes["IdentificationCodeUpsertAttemptsRelationInput"];
	["PointOfSaleApplicationDeviceUpsertIdentificationCodeRelationInput"]: GraphQLTypes["PointOfSaleApplicationDeviceUpsertIdentificationCodeRelationInput"];
	["VenueUpsertPointOfSaleApplicationDevicesRelationInput"]: GraphQLTypes["VenueUpsertPointOfSaleApplicationDevicesRelationInput"];
	["TimetableTemplateUpsertVenueRelationInput"]: GraphQLTypes["TimetableTemplateUpsertVenueRelationInput"];
	["TimetableShiftPositionUpsertTimetableTemplatesRelationInput"]: GraphQLTypes["TimetableShiftPositionUpsertTimetableTemplatesRelationInput"];
	["TimetableShiftGroupUpsertPositionRelationInput"]: GraphQLTypes["TimetableShiftGroupUpsertPositionRelationInput"];
	["TimetableShiftGroupUpdateGeneratedByTemplateEntityRelationInput"]: GraphQLTypes["TimetableShiftGroupUpdateGeneratedByTemplateEntityRelationInput"];
	["TimetableTemplateUpdateInput"]: GraphQLTypes["TimetableTemplateUpdateInput"];
	["TimetableShiftGroupUpsertGeneratedByTemplateRelationInput"]: GraphQLTypes["TimetableShiftGroupUpsertGeneratedByTemplateRelationInput"];
	["TimetableShiftUpsertGroupRelationInput"]: GraphQLTypes["TimetableShiftUpsertGroupRelationInput"];
	["TimetableShiftUpdateQueueItemEntityRelationInput"]: GraphQLTypes["TimetableShiftUpdateQueueItemEntityRelationInput"];
	["EmployeeQueueItemWithoutShiftUpdateInput"]: GraphQLTypes["EmployeeQueueItemWithoutShiftUpdateInput"];
	["EmployeeQueueItemUpdateUnassignInfoEntityRelationInput"]: GraphQLTypes["EmployeeQueueItemUpdateUnassignInfoEntityRelationInput"];
	["UnassignedShiftInfoWithoutQueueItemUpdateInput"]: GraphQLTypes["UnassignedShiftInfoWithoutQueueItemUpdateInput"];
	["UnassignedShiftInfoUpdateReasonEntityRelationInput"]: GraphQLTypes["UnassignedShiftInfoUpdateReasonEntityRelationInput"];
	["UnassignReasonUpdateInput"]: GraphQLTypes["UnassignReasonUpdateInput"];
	["UnassignReasonUpdateVenuesEntityRelationInput"]: GraphQLTypes["UnassignReasonUpdateVenuesEntityRelationInput"];
	["UnassignReasonUpdateVenuesRelationInput"]: GraphQLTypes["UnassignReasonUpdateVenuesRelationInput"];
	["VenueWithoutEnabledUnassignReasonsUpdateInput"]: GraphQLTypes["VenueWithoutEnabledUnassignReasonsUpdateInput"];
	["UnassignReasonUpsertVenuesRelationInput"]: GraphQLTypes["UnassignReasonUpsertVenuesRelationInput"];
	["UnassignedShiftInfoUpsertReasonRelationInput"]: GraphQLTypes["UnassignedShiftInfoUpsertReasonRelationInput"];
	["EmployeeQueueItemUpsertUnassignInfoRelationInput"]: GraphQLTypes["EmployeeQueueItemUpsertUnassignInfoRelationInput"];
	["EmployeeQueueItemUpdateMetaEntityRelationInput"]: GraphQLTypes["EmployeeQueueItemUpdateMetaEntityRelationInput"];
	["TimetableShiftUpsertQueueItemRelationInput"]: GraphQLTypes["TimetableShiftUpsertQueueItemRelationInput"];
	["TimetableShiftUpdateSwapInfoEntityRelationInput"]: GraphQLTypes["TimetableShiftUpdateSwapInfoEntityRelationInput"];
	["TimetableShiftSwapInfoWithoutShiftUpdateInput"]: GraphQLTypes["TimetableShiftSwapInfoWithoutShiftUpdateInput"];
	["TimetableShiftSwapInfoUpdateSwappedShiftsProfileEntityRelationInput"]: GraphQLTypes["TimetableShiftSwapInfoUpdateSwappedShiftsProfileEntityRelationInput"];
	["TimetableShiftSwapInfoUpsertSwappedShiftsProfileRelationInput"]: GraphQLTypes["TimetableShiftSwapInfoUpsertSwappedShiftsProfileRelationInput"];
	["TimetableShiftUpsertSwapInfoRelationInput"]: GraphQLTypes["TimetableShiftUpsertSwapInfoRelationInput"];
	["ShiftsProfileUpsertShiftsRelationInput"]: GraphQLTypes["ShiftsProfileUpsertShiftsRelationInput"];
	["EmployeeQueueItemUpsertShiftsProfileRelationInput"]: GraphQLTypes["EmployeeQueueItemUpsertShiftsProfileRelationInput"];
	["EmployeeQueueItemUpdateShiftEntityRelationInput"]: GraphQLTypes["EmployeeQueueItemUpdateShiftEntityRelationInput"];
	["TimetableShiftWithoutQueueItemUpdateInput"]: GraphQLTypes["TimetableShiftWithoutQueueItemUpdateInput"];
	["EmployeeQueueItemUpsertShiftRelationInput"]: GraphQLTypes["EmployeeQueueItemUpsertShiftRelationInput"];
	["EmployeeQueueUpsertItemsRelationInput"]: GraphQLTypes["EmployeeQueueUpsertItemsRelationInput"];
	["TimetableShiftGroupUpsertQueueRelationInput"]: GraphQLTypes["TimetableShiftGroupUpsertQueueRelationInput"];
	["TimetableShiftPositionUpsertShiftGroupsRelationInput"]: GraphQLTypes["TimetableShiftPositionUpsertShiftGroupsRelationInput"];
	["TimetableTemplateUpsertPositionRelationInput"]: GraphQLTypes["TimetableTemplateUpsertPositionRelationInput"];
	["TimetableEmployeeRoleUpsertTimetableTemplatesRelationInput"]: GraphQLTypes["TimetableEmployeeRoleUpsertTimetableTemplatesRelationInput"];
	["TimetableShiftGroupUpsertTypeRelationInput"]: GraphQLTypes["TimetableShiftGroupUpsertTypeRelationInput"];
	["TimetableDayUpsertShiftGroupsRelationInput"]: GraphQLTypes["TimetableDayUpsertShiftGroupsRelationInput"];
	["TimetableDayUpdateMetaEntityRelationInput"]: GraphQLTypes["TimetableDayUpdateMetaEntityRelationInput"];
	["VenueUpsertTimetableDaysRelationInput"]: GraphQLTypes["VenueUpsertTimetableDaysRelationInput"];
	["ChannelUpsertVenueRelationInput"]: GraphQLTypes["ChannelUpsertVenueRelationInput"];
	["TagUpsertPublicInChannelsRelationInput"]: GraphQLTypes["TagUpsertPublicInChannelsRelationInput"];
	["DeliveryZoneUpsertDeliveryZonesOfTagsRelationInput"]: GraphQLTypes["DeliveryZoneUpsertDeliveryZonesOfTagsRelationInput"];
	["DeliveryZoneUpdateAddressesMetadataEntityRelationInput"]: GraphQLTypes["DeliveryZoneUpdateAddressesMetadataEntityRelationInput"];
	["ProductUpsertDeliveryZonesRelationInput"]: GraphQLTypes["ProductUpsertDeliveryZonesRelationInput"];
	["FulfillmentNoteUpsertProductsRelationInput"]: GraphQLTypes["FulfillmentNoteUpsertProductsRelationInput"];
	["TagUpsertFulfillmentNotesRelationInput"]: GraphQLTypes["TagUpsertFulfillmentNotesRelationInput"];
	["ChannelUpsertPublicTagsRelationInput"]: GraphQLTypes["ChannelUpsertPublicTagsRelationInput"];
	["CustomerUpsertChannelsRelationInput"]: GraphQLTypes["CustomerUpsertChannelsRelationInput"];
	["CustomerCreditUpsertCustomerRelationInput"]: GraphQLTypes["CustomerCreditUpsertCustomerRelationInput"];
	["CustomerCreditUpdateVoucherRedemptionEntityRelationInput"]: GraphQLTypes["CustomerCreditUpdateVoucherRedemptionEntityRelationInput"];
	["VoucherRedemptionWithoutCustomerCreditUpdateInput"]: GraphQLTypes["VoucherRedemptionWithoutCustomerCreditUpdateInput"];
	["CustomerCreditUpsertVoucherRedemptionRelationInput"]: GraphQLTypes["CustomerCreditUpsertVoucherRedemptionRelationInput"];
	["CustomerCreditTransactionUpsertCustomerCreditRelationInput"]: GraphQLTypes["CustomerCreditTransactionUpsertCustomerCreditRelationInput"];
	["OrderDiscountUpsertCustomerCreditTransactionsRelationInput"]: GraphQLTypes["OrderDiscountUpsertCustomerCreditTransactionsRelationInput"];
	["OrderUpsertDiscountsRelationInput"]: GraphQLTypes["OrderUpsertDiscountsRelationInput"];
	["OrderItemUpsertOrderRelationInput"]: GraphQLTypes["OrderItemUpsertOrderRelationInput"];
	["ProductUpsertOrderItemsRelationInput"]: GraphQLTypes["ProductUpsertOrderItemsRelationInput"];
	["StocksManagerUpsertManagedProductsRelationInput"]: GraphQLTypes["StocksManagerUpsertManagedProductsRelationInput"];
	["StaffUpsertStocksManagerRelationInput"]: GraphQLTypes["StaffUpsertStocksManagerRelationInput"];
	["StaffUpdateVenuesEntityRelationInput"]: GraphQLTypes["StaffUpdateVenuesEntityRelationInput"];
	["StaffUpdateVenuesRelationInput"]: GraphQLTypes["StaffUpdateVenuesRelationInput"];
	["VenueWithoutStaffMembersUpdateInput"]: GraphQLTypes["VenueWithoutStaffMembersUpdateInput"];
	["StaffUpsertVenuesRelationInput"]: GraphQLTypes["StaffUpsertVenuesRelationInput"];
	["ShiftsManagerUpsertStaffRelationInput"]: GraphQLTypes["ShiftsManagerUpsertStaffRelationInput"];
	["TimetableEmployeeRoleUpsertShiftsManagersRelationInput"]: GraphQLTypes["TimetableEmployeeRoleUpsertShiftsManagersRelationInput"];
	["ShiftsProfileUpsertRolesRelationInput"]: GraphQLTypes["ShiftsProfileUpsertRolesRelationInput"];
	["StaffUpsertShiftsProfileRelationInput"]: GraphQLTypes["StaffUpsertShiftsProfileRelationInput"];
	["UserUpsertStaffRelationInput"]: GraphQLTypes["UserUpsertStaffRelationInput"];
	["CustomerUpsertUserRelationInput"]: GraphQLTypes["CustomerUpsertUserRelationInput"];
	["OrderUpsertCustomerRelationInput"]: GraphQLTypes["OrderUpsertCustomerRelationInput"];
	["CartUpsertOrderRelationInput"]: GraphQLTypes["CartUpsertOrderRelationInput"];
	["CustomerUpsertCartsRelationInput"]: GraphQLTypes["CustomerUpsertCartsRelationInput"];
	["UserUpsertCustomerRelationInput"]: GraphQLTypes["UserUpsertCustomerRelationInput"];
	["StaffUpsertUserRelationInput"]: GraphQLTypes["StaffUpsertUserRelationInput"];
	["BusinessToBusinessManagerUpsertStaffRelationInput"]: GraphQLTypes["BusinessToBusinessManagerUpsertStaffRelationInput"];
	["BusinessCustomerUpsertAccountManagerRelationInput"]: GraphQLTypes["BusinessCustomerUpsertAccountManagerRelationInput"];
	["BusinessCustomerUpdateLogoEntityRelationInput"]: GraphQLTypes["BusinessCustomerUpdateLogoEntityRelationInput"];
	["BusinessCustomerUpsertLogoRelationInput"]: GraphQLTypes["BusinessCustomerUpsertLogoRelationInput"];
	["BusinessCustomerUpdateBusinessServiceEventsEntityRelationInput"]: GraphQLTypes["BusinessCustomerUpdateBusinessServiceEventsEntityRelationInput"];
	["BusinessCustomerUpdateBusinessServiceEventsRelationInput"]: GraphQLTypes["BusinessCustomerUpdateBusinessServiceEventsRelationInput"];
	["BusinessServiceEventWithoutBusinessCustomerUpdateInput"]: GraphQLTypes["BusinessServiceEventWithoutBusinessCustomerUpdateInput"];
	["BusinessServiceEventUpdateBusinessServiceEntityRelationInput"]: GraphQLTypes["BusinessServiceEventUpdateBusinessServiceEntityRelationInput"];
	["BusinessServiceUpdateInput"]: GraphQLTypes["BusinessServiceUpdateInput"];
	["BusinessServiceUpdateLocalesEntityRelationInput"]: GraphQLTypes["BusinessServiceUpdateLocalesEntityRelationInput"];
	["BusinessServiceUpdateLocalesRelationInput"]: GraphQLTypes["BusinessServiceUpdateLocalesRelationInput"];
	["BusinessServiceLocaleWithoutRootUpdateInput"]: GraphQLTypes["BusinessServiceLocaleWithoutRootUpdateInput"];
	["BusinessServiceLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["BusinessServiceLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutBusinessServicesUpdateInput"]: GraphQLTypes["LocaleWithoutBusinessServicesUpdateInput"];
	["BusinessServiceLocaleUpsertLocaleRelationInput"]: GraphQLTypes["BusinessServiceLocaleUpsertLocaleRelationInput"];
	["BusinessServiceUpsertLocalesRelationInput"]: GraphQLTypes["BusinessServiceUpsertLocalesRelationInput"];
	["BusinessServiceEventUpsertBusinessServiceRelationInput"]: GraphQLTypes["BusinessServiceEventUpsertBusinessServiceRelationInput"];
	["BusinessServiceEventUpdateCreatedByEntityRelationInput"]: GraphQLTypes["BusinessServiceEventUpdateCreatedByEntityRelationInput"];
	["StaffUpdateInput"]: GraphQLTypes["StaffUpdateInput"];
	["BusinessServiceEventUpsertCreatedByRelationInput"]: GraphQLTypes["BusinessServiceEventUpsertCreatedByRelationInput"];
	["BusinessServiceEventUpdateFilledSupervisorEntityRelationInput"]: GraphQLTypes["BusinessServiceEventUpdateFilledSupervisorEntityRelationInput"];
	["BusinessServiceEventUpsertFilledSupervisorRelationInput"]: GraphQLTypes["BusinessServiceEventUpsertFilledSupervisorRelationInput"];
	["BusinessCustomerUpsertBusinessServiceEventsRelationInput"]: GraphQLTypes["BusinessCustomerUpsertBusinessServiceEventsRelationInput"];
	["BusinessCustomerUpdateDoubleshotCoffeeEquipmentEntityRelationInput"]: GraphQLTypes["BusinessCustomerUpdateDoubleshotCoffeeEquipmentEntityRelationInput"];
	["DoubleshotCoffeeEquipmentUpdateInput"]: GraphQLTypes["DoubleshotCoffeeEquipmentUpdateInput"];
	["BusinessCustomerUpsertDoubleshotCoffeeEquipmentRelationInput"]: GraphQLTypes["BusinessCustomerUpsertDoubleshotCoffeeEquipmentRelationInput"];
	["CustomerUpsertOwnerOfBusinessesRelationInput"]: GraphQLTypes["CustomerUpsertOwnerOfBusinessesRelationInput"];
	["BusinessCustomerUpsertMembersRelationInput"]: GraphQLTypes["BusinessCustomerUpsertMembersRelationInput"];
	["BusinessToBusinessManagerUpsertManagedBusinessesRelationInput"]: GraphQLTypes["BusinessToBusinessManagerUpsertManagedBusinessesRelationInput"];
	["StaffUpsertBusinessToBusinessManagerRelationInput"]: GraphQLTypes["StaffUpsertBusinessToBusinessManagerRelationInput"];
	["ShiftsProfileUpsertStaffRelationInput"]: GraphQLTypes["ShiftsProfileUpsertStaffRelationInput"];
	["TimetableEmployeeRoleUpsertShiftsProfilesRelationInput"]: GraphQLTypes["TimetableEmployeeRoleUpsertShiftsProfilesRelationInput"];
	["TimetableDayNoteUpsertRoleRelationInput"]: GraphQLTypes["TimetableDayNoteUpsertRoleRelationInput"];
	["TimetableDayUpsertNotesRelationInput"]: GraphQLTypes["TimetableDayUpsertNotesRelationInput"];
	["TimetableDayUpdateVenueEntityRelationInput"]: GraphQLTypes["TimetableDayUpdateVenueEntityRelationInput"];
	["VenueWithoutTimetableDaysUpdateInput"]: GraphQLTypes["VenueWithoutTimetableDaysUpdateInput"];
	["TimetableDayUpsertVenueRelationInput"]: GraphQLTypes["TimetableDayUpsertVenueRelationInput"];
	["TimetableShiftGroupUpsertDayRelationInput"]: GraphQLTypes["TimetableShiftGroupUpsertDayRelationInput"];
	["EmployeeQueueUpsertShiftGroupRelationInput"]: GraphQLTypes["EmployeeQueueUpsertShiftGroupRelationInput"];
	["EmployeeQueueItemUpsertQueueRelationInput"]: GraphQLTypes["EmployeeQueueItemUpsertQueueRelationInput"];
	["ShiftsProfileUpsertQueueItemsRelationInput"]: GraphQLTypes["ShiftsProfileUpsertQueueItemsRelationInput"];
	["TimetableShiftUpsertShiftsProfileRelationInput"]: GraphQLTypes["TimetableShiftUpsertShiftsProfileRelationInput"];
	["TimetableShiftGroupUpsertShiftsRelationInput"]: GraphQLTypes["TimetableShiftGroupUpsertShiftsRelationInput"];
	["TimetableEmployeeRoleUpsertShiftGroupsRelationInput"]: GraphQLTypes["TimetableEmployeeRoleUpsertShiftGroupsRelationInput"];
	["ShiftsManagerUpsertManagedRolesRelationInput"]: GraphQLTypes["ShiftsManagerUpsertManagedRolesRelationInput"];
	["StaffUpsertShiftsManagerRelationInput"]: GraphQLTypes["StaffUpsertShiftsManagerRelationInput"];
	["CourierUpsertStaffRelationInput"]: GraphQLTypes["CourierUpsertStaffRelationInput"];
	["DeliveryMethodUpsertCourierHandlersRelationInput"]: GraphQLTypes["DeliveryMethodUpsertCourierHandlersRelationInput"];
	["OrderDeliveryUpsertMethodRelationInput"]: GraphQLTypes["OrderDeliveryUpsertMethodRelationInput"];
	["DeliveryWaypointUpsertDeliveryRelationInput"]: GraphQLTypes["DeliveryWaypointUpsertDeliveryRelationInput"];
	["DeliveryRouteUpsertWaypointsRelationInput"]: GraphQLTypes["DeliveryRouteUpsertWaypointsRelationInput"];
	["CourierUpsertRoutesRelationInput"]: GraphQLTypes["CourierUpsertRoutesRelationInput"];
	["StaffUpsertCourierRelationInput"]: GraphQLTypes["StaffUpsertCourierRelationInput"];
	["StocksManagerUpsertStaffRelationInput"]: GraphQLTypes["StocksManagerUpsertStaffRelationInput"];
	["ProductUpsertManagerRelationInput"]: GraphQLTypes["ProductUpsertManagerRelationInput"];
	["VirtualProductUpsertProductRelationInput"]: GraphQLTypes["VirtualProductUpsertProductRelationInput"];
	["WorkspaceUpsertCreditsProductRelationInput"]: GraphQLTypes["WorkspaceUpsertCreditsProductRelationInput"];
	["WorkspaceUpdateDiscountVatRateEntityRelationInput"]: GraphQLTypes["WorkspaceUpdateDiscountVatRateEntityRelationInput"];
	["WorkspaceUpsertDiscountVatRateRelationInput"]: GraphQLTypes["WorkspaceUpsertDiscountVatRateRelationInput"];
	["FreshingContainerUpsertWorkspaceRelationInput"]: GraphQLTypes["FreshingContainerUpsertWorkspaceRelationInput"];
	["ProductIngredientUpsertFreshingContainerRelationInput"]: GraphQLTypes["ProductIngredientUpsertFreshingContainerRelationInput"];
	["ProductIngredientUpdateImageEntityRelationInput"]: GraphQLTypes["ProductIngredientUpdateImageEntityRelationInput"];
	["ProductIngredientUpsertImageRelationInput"]: GraphQLTypes["ProductIngredientUpsertImageRelationInput"];
	["ProductIngredientUpdateSuppliersEntityRelationInput"]: GraphQLTypes["ProductIngredientUpdateSuppliersEntityRelationInput"];
	["IngredientSupplierListUpdateInput"]: GraphQLTypes["IngredientSupplierListUpdateInput"];
	["IngredientSupplierListUpdateItemsEntityRelationInput"]: GraphQLTypes["IngredientSupplierListUpdateItemsEntityRelationInput"];
	["IngredientSupplierListUpdateItemsRelationInput"]: GraphQLTypes["IngredientSupplierListUpdateItemsRelationInput"];
	["IngredientSupplierItemWithoutListUpdateInput"]: GraphQLTypes["IngredientSupplierItemWithoutListUpdateInput"];
	["IngredientSupplierItemUpdateSupplierEntityRelationInput"]: GraphQLTypes["IngredientSupplierItemUpdateSupplierEntityRelationInput"];
	["IngredientSupplierUpdateInput"]: GraphQLTypes["IngredientSupplierUpdateInput"];
	["IngredientSupplierUpdateLocalesEntityRelationInput"]: GraphQLTypes["IngredientSupplierUpdateLocalesEntityRelationInput"];
	["IngredientSupplierUpdateLocalesRelationInput"]: GraphQLTypes["IngredientSupplierUpdateLocalesRelationInput"];
	["IngredientSupplierLocaleWithoutRootUpdateInput"]: GraphQLTypes["IngredientSupplierLocaleWithoutRootUpdateInput"];
	["IngredientSupplierLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["IngredientSupplierLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutIngredientSuppliersUpdateInput"]: GraphQLTypes["LocaleWithoutIngredientSuppliersUpdateInput"];
	["IngredientSupplierLocaleUpsertLocaleRelationInput"]: GraphQLTypes["IngredientSupplierLocaleUpsertLocaleRelationInput"];
	["IngredientSupplierUpsertLocalesRelationInput"]: GraphQLTypes["IngredientSupplierUpsertLocalesRelationInput"];
	["IngredientSupplierItemUpsertSupplierRelationInput"]: GraphQLTypes["IngredientSupplierItemUpsertSupplierRelationInput"];
	["IngredientSupplierListUpsertItemsRelationInput"]: GraphQLTypes["IngredientSupplierListUpsertItemsRelationInput"];
	["ProductIngredientUpsertSuppliersRelationInput"]: GraphQLTypes["ProductIngredientUpsertSuppliersRelationInput"];
	["AllergenUpsertIngredientsRelationInput"]: GraphQLTypes["AllergenUpsertIngredientsRelationInput"];
	["AllergenLocaleUpsertRootRelationInput"]: GraphQLTypes["AllergenLocaleUpsertRootRelationInput"];
	["LocaleUpsertAllergensRelationInput"]: GraphQLTypes["LocaleUpsertAllergensRelationInput"];
	["OrderRecurrenceLocaleUpsertLocaleRelationInput"]: GraphQLTypes["OrderRecurrenceLocaleUpsertLocaleRelationInput"];
	["OrderRecurrenceUpsertLocalesRelationInput"]: GraphQLTypes["OrderRecurrenceUpsertLocalesRelationInput"];
	["BusinessCategoryUpsertRecurrencesRelationInput"]: GraphQLTypes["BusinessCategoryUpsertRecurrencesRelationInput"];
	["BusinessCategoryUpdateSpecificProductsEntityRelationInput"]: GraphQLTypes["BusinessCategoryUpdateSpecificProductsEntityRelationInput"];
	["ProductListWithoutBusinessCategoryUpdateInput"]: GraphQLTypes["ProductListWithoutBusinessCategoryUpdateInput"];
	["ProductListUpdateItemsEntityRelationInput"]: GraphQLTypes["ProductListUpdateItemsEntityRelationInput"];
	["ProductListUpdateItemsRelationInput"]: GraphQLTypes["ProductListUpdateItemsRelationInput"];
	["ProductListItemWithoutListUpdateInput"]: GraphQLTypes["ProductListItemWithoutListUpdateInput"];
	["ProductListItemUpdateProductEntityRelationInput"]: GraphQLTypes["ProductListItemUpdateProductEntityRelationInput"];
	["ProductListItemUpsertProductRelationInput"]: GraphQLTypes["ProductListItemUpsertProductRelationInput"];
	["ProductListUpsertItemsRelationInput"]: GraphQLTypes["ProductListUpsertItemsRelationInput"];
	["BusinessCategoryUpsertSpecificProductsRelationInput"]: GraphQLTypes["BusinessCategoryUpsertSpecificProductsRelationInput"];
	["BusinessCategoryUpdateSeasonalProductCategoriesEntityRelationInput"]: GraphQLTypes["BusinessCategoryUpdateSeasonalProductCategoriesEntityRelationInput"];
	["ProductCategoryListWithoutSeasonalProductCategoriesOfBusinessCategoryUpdateInput"]: GraphQLTypes["ProductCategoryListWithoutSeasonalProductCategoriesOfBusinessCategoryUpdateInput"];
	["ProductCategoryListUpdateLocalesEntityRelationInput"]: GraphQLTypes["ProductCategoryListUpdateLocalesEntityRelationInput"];
	["ProductCategoryListUpdateLocalesRelationInput"]: GraphQLTypes["ProductCategoryListUpdateLocalesRelationInput"];
	["ProductCategoryListLocaleWithoutRootUpdateInput"]: GraphQLTypes["ProductCategoryListLocaleWithoutRootUpdateInput"];
	["ProductCategoryListLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["ProductCategoryListLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutProductCategoryListsUpdateInput"]: GraphQLTypes["LocaleWithoutProductCategoryListsUpdateInput"];
	["ProductCategoryListLocaleUpsertLocaleRelationInput"]: GraphQLTypes["ProductCategoryListLocaleUpsertLocaleRelationInput"];
	["ProductCategoryListUpsertLocalesRelationInput"]: GraphQLTypes["ProductCategoryListUpsertLocalesRelationInput"];
	["ProductCategoryListUpdateSpecificProductsProductCategoriesOfBusinessCategoryEntityRelationInput"]: GraphQLTypes["ProductCategoryListUpdateSpecificProductsProductCategoriesOfBusinessCategoryEntityRelationInput"];
	["BusinessCategoryWithoutSpecificProductsProductCategoriesUpdateInput"]: GraphQLTypes["BusinessCategoryWithoutSpecificProductsProductCategoriesUpdateInput"];
	["ProductCategoryListUpsertSpecificProductsProductCategoriesOfBusinessCategoryRelationInput"]: GraphQLTypes["ProductCategoryListUpsertSpecificProductsProductCategoriesOfBusinessCategoryRelationInput"];
	["BusinessCategoryUpsertSeasonalProductCategoriesRelationInput"]: GraphQLTypes["BusinessCategoryUpsertSeasonalProductCategoriesRelationInput"];
	["BusinessCategoryUpdateSpecificProductsProductCategoriesEntityRelationInput"]: GraphQLTypes["BusinessCategoryUpdateSpecificProductsProductCategoriesEntityRelationInput"];
	["ProductCategoryListWithoutSpecificProductsProductCategoriesOfBusinessCategoryUpdateInput"]: GraphQLTypes["ProductCategoryListWithoutSpecificProductsProductCategoriesOfBusinessCategoryUpdateInput"];
	["ProductCategoryListUpdateSeasonalProductCategoriesOfBusinessCategoryEntityRelationInput"]: GraphQLTypes["ProductCategoryListUpdateSeasonalProductCategoriesOfBusinessCategoryEntityRelationInput"];
	["BusinessCategoryWithoutSeasonalProductCategoriesUpdateInput"]: GraphQLTypes["BusinessCategoryWithoutSeasonalProductCategoriesUpdateInput"];
	["ProductCategoryListUpsertSeasonalProductCategoriesOfBusinessCategoryRelationInput"]: GraphQLTypes["ProductCategoryListUpsertSeasonalProductCategoriesOfBusinessCategoryRelationInput"];
	["BusinessCategoryUpsertSpecificProductsProductCategoriesRelationInput"]: GraphQLTypes["BusinessCategoryUpsertSpecificProductsProductCategoriesRelationInput"];
	["BusinessCustomerUpsertCategoryRelationInput"]: GraphQLTypes["BusinessCustomerUpsertCategoryRelationInput"];
	["CustomerUpsertMemberOfBusinessesRelationInput"]: GraphQLTypes["CustomerUpsertMemberOfBusinessesRelationInput"];
	["BusinessCustomerUpsertOwnersRelationInput"]: GraphQLTypes["BusinessCustomerUpsertOwnersRelationInput"];
	["CustomerUpsertBusinessRelationInput"]: GraphQLTypes["CustomerUpsertBusinessRelationInput"];
	["CustomerIngredientRatingUpsertCustomerRelationInput"]: GraphQLTypes["CustomerIngredientRatingUpsertCustomerRelationInput"];
	["ProductIngredientUpsertCustomerRatingsRelationInput"]: GraphQLTypes["ProductIngredientUpsertCustomerRatingsRelationInput"];
	["ProductIngredientCategoryUpsertIngredientsRelationInput"]: GraphQLTypes["ProductIngredientCategoryUpsertIngredientsRelationInput"];
	["ProductIngredientCategoryLocaleUpsertRootRelationInput"]: GraphQLTypes["ProductIngredientCategoryLocaleUpsertRootRelationInput"];
	["LocaleUpsertProductIngredientCategoriesRelationInput"]: GraphQLTypes["LocaleUpsertProductIngredientCategoriesRelationInput"];
	["PageLocaleUpsertLocaleRelationInput"]: GraphQLTypes["PageLocaleUpsertLocaleRelationInput"];
	["LinkableUpsertPageRelationInput"]: GraphQLTypes["LinkableUpsertPageRelationInput"];
	["LinkableUpdateRedirectEntityRelationInput"]: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"];
	["RedirectWithoutLinkUpdateInput"]: GraphQLTypes["RedirectWithoutLinkUpdateInput"];
	["RedirectUpdateTargetEntityRelationInput"]: GraphQLTypes["RedirectUpdateTargetEntityRelationInput"];
	["RedirectUpsertTargetRelationInput"]: GraphQLTypes["RedirectUpsertTargetRelationInput"];
	["LinkableUpsertRedirectRelationInput"]: GraphQLTypes["LinkableUpsertRedirectRelationInput"];
	["WikiPageUpsertLinkRelationInput"]: GraphQLTypes["WikiPageUpsertLinkRelationInput"];
	["WikiPageUpdateContentEntityRelationInput"]: GraphQLTypes["WikiPageUpdateContentEntityRelationInput"];
	["WikiPageUpsertContentRelationInput"]: GraphQLTypes["WikiPageUpsertContentRelationInput"];
	["WikiPageUpsertParentRelationInput"]: GraphQLTypes["WikiPageUpsertParentRelationInput"];
	["WikiPageUpdateChildrenEntityRelationInput"]: GraphQLTypes["WikiPageUpdateChildrenEntityRelationInput"];
	["WikiPageUpdateChildrenRelationInput"]: GraphQLTypes["WikiPageUpdateChildrenRelationInput"];
	["WikiPageWithoutParentUpdateInput"]: GraphQLTypes["WikiPageWithoutParentUpdateInput"];
	["WikiPageUpsertChildrenRelationInput"]: GraphQLTypes["WikiPageUpsertChildrenRelationInput"];
	["LinkableUpsertWikiPageRelationInput"]: GraphQLTypes["LinkableUpsertWikiPageRelationInput"];
	["PageLocaleUpsertLinkRelationInput"]: GraphQLTypes["PageLocaleUpsertLinkRelationInput"];
	["LocaleUpsertPagesRelationInput"]: GraphQLTypes["LocaleUpsertPagesRelationInput"];
	["BlogPostLocaleUpsertLocaleRelationInput"]: GraphQLTypes["BlogPostLocaleUpsertLocaleRelationInput"];
	["BlogPostLocaleUpdateSeoEntityRelationInput"]: GraphQLTypes["BlogPostLocaleUpdateSeoEntityRelationInput"];
	["BlogPostLocaleUpsertSeoRelationInput"]: GraphQLTypes["BlogPostLocaleUpsertSeoRelationInput"];
	["BlogPostLocaleUpdateProductsEntityRelationInput"]: GraphQLTypes["BlogPostLocaleUpdateProductsEntityRelationInput"];
	["BlogPostLocaleUpdateProductsRelationInput"]: GraphQLTypes["BlogPostLocaleUpdateProductsRelationInput"];
	["BlogPostLocaleUpsertProductsRelationInput"]: GraphQLTypes["BlogPostLocaleUpsertProductsRelationInput"];
	["LinkableUpsertBlogPostRelationInput"]: GraphQLTypes["LinkableUpsertBlogPostRelationInput"];
	["LinkUpsertInternalLinkRelationInput"]: GraphQLTypes["LinkUpsertInternalLinkRelationInput"];
	["ContentReferenceUpsertLinkRelationInput"]: GraphQLTypes["ContentReferenceUpsertLinkRelationInput"];
	["ContentReferenceUpdateBlogPostsEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateBlogPostsEntityRelationInput"];
	["BlogPostListUpdateInput"]: GraphQLTypes["BlogPostListUpdateInput"];
	["BlogPostListUpdateItemsEntityRelationInput"]: GraphQLTypes["BlogPostListUpdateItemsEntityRelationInput"];
	["BlogPostListUpdateItemsRelationInput"]: GraphQLTypes["BlogPostListUpdateItemsRelationInput"];
	["BlogPostListItemWithoutListUpdateInput"]: GraphQLTypes["BlogPostListItemWithoutListUpdateInput"];
	["BlogPostListItemUpdateBlogPostEntityRelationInput"]: GraphQLTypes["BlogPostListItemUpdateBlogPostEntityRelationInput"];
	["BlogPostLocaleUpdateInput"]: GraphQLTypes["BlogPostLocaleUpdateInput"];
	["BlogPostLocaleUpdateLinkEntityRelationInput"]: GraphQLTypes["BlogPostLocaleUpdateLinkEntityRelationInput"];
	["LinkableWithoutBlogPostUpdateInput"]: GraphQLTypes["LinkableWithoutBlogPostUpdateInput"];
	["BlogPostLocaleUpsertLinkRelationInput"]: GraphQLTypes["BlogPostLocaleUpsertLinkRelationInput"];
	["BlogPostListItemUpsertBlogPostRelationInput"]: GraphQLTypes["BlogPostListItemUpsertBlogPostRelationInput"];
	["BlogPostListUpsertItemsRelationInput"]: GraphQLTypes["BlogPostListUpsertItemsRelationInput"];
	["ContentReferenceUpsertBlogPostsRelationInput"]: GraphQLTypes["ContentReferenceUpsertBlogPostsRelationInput"];
	["ContentReferenceUpdateLinksEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateLinksEntityRelationInput"];
	["ContentReferenceUpsertLinksRelationInput"]: GraphQLTypes["ContentReferenceUpsertLinksRelationInput"];
	["ContentReferenceUpdateProductsEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateProductsEntityRelationInput"];
	["ProductListUpdateInput"]: GraphQLTypes["ProductListUpdateInput"];
	["ProductListUpdateBusinessCategoryEntityRelationInput"]: GraphQLTypes["ProductListUpdateBusinessCategoryEntityRelationInput"];
	["BusinessCategoryWithoutSpecificProductsUpdateInput"]: GraphQLTypes["BusinessCategoryWithoutSpecificProductsUpdateInput"];
	["ProductListUpsertBusinessCategoryRelationInput"]: GraphQLTypes["ProductListUpsertBusinessCategoryRelationInput"];
	["ContentReferenceUpsertProductsRelationInput"]: GraphQLTypes["ContentReferenceUpsertProductsRelationInput"];
	["ContentReferenceUpdateHeroEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateHeroEntityRelationInput"];
	["HeroUpdateInput"]: GraphQLTypes["HeroUpdateInput"];
	["HeroUpdateMediumEntityRelationInput"]: GraphQLTypes["HeroUpdateMediumEntityRelationInput"];
	["HeroUpsertMediumRelationInput"]: GraphQLTypes["HeroUpsertMediumRelationInput"];
	["ContentReferenceUpsertHeroRelationInput"]: GraphQLTypes["ContentReferenceUpsertHeroRelationInput"];
	["ContentReferenceUpdateGalleryEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateGalleryEntityRelationInput"];
	["GalleryUpdateInput"]: GraphQLTypes["GalleryUpdateInput"];
	["GalleryUpdateItemsEntityRelationInput"]: GraphQLTypes["GalleryUpdateItemsEntityRelationInput"];
	["GalleryUpdateItemsRelationInput"]: GraphQLTypes["GalleryUpdateItemsRelationInput"];
	["GalleryItemWithoutListUpdateInput"]: GraphQLTypes["GalleryItemWithoutListUpdateInput"];
	["GalleryItemUpdateMediumEntityRelationInput"]: GraphQLTypes["GalleryItemUpdateMediumEntityRelationInput"];
	["GalleryItemUpsertMediumRelationInput"]: GraphQLTypes["GalleryItemUpsertMediumRelationInput"];
	["GalleryUpsertItemsRelationInput"]: GraphQLTypes["GalleryUpsertItemsRelationInput"];
	["ContentReferenceUpsertGalleryRelationInput"]: GraphQLTypes["ContentReferenceUpsertGalleryRelationInput"];
	["ContentReferenceUpdateSocialsAndAppsEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateSocialsAndAppsEntityRelationInput"];
	["ContentReferenceUpsertSocialsAndAppsRelationInput"]: GraphQLTypes["ContentReferenceUpsertSocialsAndAppsRelationInput"];
	["ContentReferenceUpdateProductGridEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateProductGridEntityRelationInput"];
	["ProductGridUpdateInput"]: GraphQLTypes["ProductGridUpdateInput"];
	["ProductGridUpdateCategoriesEntityRelationInput"]: GraphQLTypes["ProductGridUpdateCategoriesEntityRelationInput"];
	["ProductGridUpdateCategoriesRelationInput"]: GraphQLTypes["ProductGridUpdateCategoriesRelationInput"];
	["ProductGridCategoryWithoutRootUpdateInput"]: GraphQLTypes["ProductGridCategoryWithoutRootUpdateInput"];
	["ProductGridCategoryUpdateItemsEntityRelationInput"]: GraphQLTypes["ProductGridCategoryUpdateItemsEntityRelationInput"];
	["ProductGridCategoryUpdateItemsRelationInput"]: GraphQLTypes["ProductGridCategoryUpdateItemsRelationInput"];
	["ProductGridItemWithoutCategoryUpdateInput"]: GraphQLTypes["ProductGridItemWithoutCategoryUpdateInput"];
	["ProductGridItemUpdateProductEntityRelationInput"]: GraphQLTypes["ProductGridItemUpdateProductEntityRelationInput"];
	["ProductGridItemUpsertProductRelationInput"]: GraphQLTypes["ProductGridItemUpsertProductRelationInput"];
	["ProductGridItemUpdateMediumEntityRelationInput"]: GraphQLTypes["ProductGridItemUpdateMediumEntityRelationInput"];
	["ProductGridItemUpsertMediumRelationInput"]: GraphQLTypes["ProductGridItemUpsertMediumRelationInput"];
	["ProductGridItemUpdateLinkEntityRelationInput"]: GraphQLTypes["ProductGridItemUpdateLinkEntityRelationInput"];
	["ProductGridItemUpsertLinkRelationInput"]: GraphQLTypes["ProductGridItemUpsertLinkRelationInput"];
	["ProductGridCategoryUpsertItemsRelationInput"]: GraphQLTypes["ProductGridCategoryUpsertItemsRelationInput"];
	["ProductGridCategoryUpdateImagesEntityRelationInput"]: GraphQLTypes["ProductGridCategoryUpdateImagesEntityRelationInput"];
	["ProductGridCategoryUpsertImagesRelationInput"]: GraphQLTypes["ProductGridCategoryUpsertImagesRelationInput"];
	["ProductGridUpsertCategoriesRelationInput"]: GraphQLTypes["ProductGridUpsertCategoriesRelationInput"];
	["ContentReferenceUpsertProductGridRelationInput"]: GraphQLTypes["ContentReferenceUpsertProductGridRelationInput"];
	["ContentReferenceUpdateProductBannersEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateProductBannersEntityRelationInput"];
	["ProductBannerListUpdateInput"]: GraphQLTypes["ProductBannerListUpdateInput"];
	["ProductBannerListUpdateItemsEntityRelationInput"]: GraphQLTypes["ProductBannerListUpdateItemsEntityRelationInput"];
	["ProductBannerListUpdateItemsRelationInput"]: GraphQLTypes["ProductBannerListUpdateItemsRelationInput"];
	["ProductBannerItemWithoutListUpdateInput"]: GraphQLTypes["ProductBannerItemWithoutListUpdateInput"];
	["ProductBannerItemUpdateBannerEntityRelationInput"]: GraphQLTypes["ProductBannerItemUpdateBannerEntityRelationInput"];
	["ProductBannerUpdateInput"]: GraphQLTypes["ProductBannerUpdateInput"];
	["ProductBannerUpdateButtonEntityRelationInput"]: GraphQLTypes["ProductBannerUpdateButtonEntityRelationInput"];
	["ProductBannerUpsertButtonRelationInput"]: GraphQLTypes["ProductBannerUpsertButtonRelationInput"];
	["ProductBannerUpdateBackgroundImageEntityRelationInput"]: GraphQLTypes["ProductBannerUpdateBackgroundImageEntityRelationInput"];
	["ProductBannerUpsertBackgroundImageRelationInput"]: GraphQLTypes["ProductBannerUpsertBackgroundImageRelationInput"];
	["ProductBannerUpdateProductImageEntityRelationInput"]: GraphQLTypes["ProductBannerUpdateProductImageEntityRelationInput"];
	["ProductBannerUpsertProductImageRelationInput"]: GraphQLTypes["ProductBannerUpsertProductImageRelationInput"];
	["ProductBannerUpdateProductEntityRelationInput"]: GraphQLTypes["ProductBannerUpdateProductEntityRelationInput"];
	["ProductBannerUpsertProductRelationInput"]: GraphQLTypes["ProductBannerUpsertProductRelationInput"];
	["ProductBannerItemUpsertBannerRelationInput"]: GraphQLTypes["ProductBannerItemUpsertBannerRelationInput"];
	["ProductBannerListUpsertItemsRelationInput"]: GraphQLTypes["ProductBannerListUpsertItemsRelationInput"];
	["ContentReferenceUpsertProductBannersRelationInput"]: GraphQLTypes["ContentReferenceUpsertProductBannersRelationInput"];
	["ContentReferenceUpdateDeliveryRegionsEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateDeliveryRegionsEntityRelationInput"];
	["ContentReferenceUpsertDeliveryRegionsRelationInput"]: GraphQLTypes["ContentReferenceUpsertDeliveryRegionsRelationInput"];
	["ContentReferenceUpdateTextListEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateTextListEntityRelationInput"];
	["ContentReferenceUpsertTextListRelationInput"]: GraphQLTypes["ContentReferenceUpsertTextListRelationInput"];
	["ContentReferenceUpdateGridTilesEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateGridTilesEntityRelationInput"];
	["GridTilesUpdateInput"]: GraphQLTypes["GridTilesUpdateInput"];
	["GridTilesUpdateItemsEntityRelationInput"]: GraphQLTypes["GridTilesUpdateItemsEntityRelationInput"];
	["GridTilesUpdateItemsRelationInput"]: GraphQLTypes["GridTilesUpdateItemsRelationInput"];
	["GridTileItemWithoutListUpdateInput"]: GraphQLTypes["GridTileItemWithoutListUpdateInput"];
	["GridTileItemUpdateMediumEntityRelationInput"]: GraphQLTypes["GridTileItemUpdateMediumEntityRelationInput"];
	["GridTileItemUpsertMediumRelationInput"]: GraphQLTypes["GridTileItemUpsertMediumRelationInput"];
	["GridTileItemUpdateLinkEntityRelationInput"]: GraphQLTypes["GridTileItemUpdateLinkEntityRelationInput"];
	["GridTileItemUpsertLinkRelationInput"]: GraphQLTypes["GridTileItemUpsertLinkRelationInput"];
	["GridTilesUpsertItemsRelationInput"]: GraphQLTypes["GridTilesUpsertItemsRelationInput"];
	["ContentReferenceUpsertGridTilesRelationInput"]: GraphQLTypes["ContentReferenceUpsertGridTilesRelationInput"];
	["ContentBlockUpsertReferencesRelationInput"]: GraphQLTypes["ContentBlockUpsertReferencesRelationInput"];
	["ContentUpsertBlocksRelationInput"]: GraphQLTypes["ContentUpsertBlocksRelationInput"];
	["BlogPostLocaleUpsertContentRelationInput"]: GraphQLTypes["BlogPostLocaleUpsertContentRelationInput"];
	["LocaleUpsertBlogPostsRelationInput"]: GraphQLTypes["LocaleUpsertBlogPostsRelationInput"];
	["BusinessCategoryLocaleUpsertLocaleRelationInput"]: GraphQLTypes["BusinessCategoryLocaleUpsertLocaleRelationInput"];
	["BusinessCategoryUpsertLocalesRelationInput"]: GraphQLTypes["BusinessCategoryUpsertLocalesRelationInput"];
	["OrderRecurrenceUpsertBusinessCategoryRelationInput"]: GraphQLTypes["OrderRecurrenceUpsertBusinessCategoryRelationInput"];
	["OrderRecurrenceLocaleUpsertRootRelationInput"]: GraphQLTypes["OrderRecurrenceLocaleUpsertRootRelationInput"];
	["LocaleUpsertOrderRecurrencesRelationInput"]: GraphQLTypes["LocaleUpsertOrderRecurrencesRelationInput"];
	["AllergenLocaleUpsertLocaleRelationInput"]: GraphQLTypes["AllergenLocaleUpsertLocaleRelationInput"];
	["AllergenUpsertLocalesRelationInput"]: GraphQLTypes["AllergenUpsertLocalesRelationInput"];
	["ProductIngredientUpsertAllergensRelationInput"]: GraphQLTypes["ProductIngredientUpsertAllergensRelationInput"];
	["ProductIngredientLocaleUpsertRootRelationInput"]: GraphQLTypes["ProductIngredientLocaleUpsertRootRelationInput"];
	["LocaleUpsertProductIngredientsRelationInput"]: GraphQLTypes["LocaleUpsertProductIngredientsRelationInput"];
	["ProductIngredientCategoryLocaleUpsertLocaleRelationInput"]: GraphQLTypes["ProductIngredientCategoryLocaleUpsertLocaleRelationInput"];
	["ProductIngredientCategoryUpsertLocalesRelationInput"]: GraphQLTypes["ProductIngredientCategoryUpsertLocalesRelationInput"];
	["ProductIngredientUpsertCategoriesRelationInput"]: GraphQLTypes["ProductIngredientUpsertCategoriesRelationInput"];
	["CustomerIngredientRatingUpsertIngredientRelationInput"]: GraphQLTypes["CustomerIngredientRatingUpsertIngredientRelationInput"];
	["CustomerUpsertIngredientRatingsRelationInput"]: GraphQLTypes["CustomerUpsertIngredientRatingsRelationInput"];
	["CustomerGroupUpsertCustomersRelationInput"]: GraphQLTypes["CustomerGroupUpsertCustomersRelationInput"];
	["ProductGroupPriceUpsertGroupRelationInput"]: GraphQLTypes["ProductGroupPriceUpsertGroupRelationInput"];
	["ProductUpsertGroupPricesRelationInput"]: GraphQLTypes["ProductUpsertGroupPricesRelationInput"];
	["DeliveryZoneUpsertDeliveryZonesOfProductsRelationInput"]: GraphQLTypes["DeliveryZoneUpsertDeliveryZonesOfProductsRelationInput"];
	["TagUpsertDeliveryZonesRelationInput"]: GraphQLTypes["TagUpsertDeliveryZonesRelationInput"];
	["ChannelUpsertAddTagsOnRegistrationRelationInput"]: GraphQLTypes["ChannelUpsertAddTagsOnRegistrationRelationInput"];
	["CartUpsertChannelRelationInput"]: GraphQLTypes["CartUpsertChannelRelationInput"];
	["CartItemUpsertCartRelationInput"]: GraphQLTypes["CartItemUpsertCartRelationInput"];
	["CartItemUpdateFulfillmentNotesEntityRelationInput"]: GraphQLTypes["CartItemUpdateFulfillmentNotesEntityRelationInput"];
	["CartItemUpdateFulfillmentNotesRelationInput"]: GraphQLTypes["CartItemUpdateFulfillmentNotesRelationInput"];
	["FulfillmentNoteWithoutCartItemsUpdateInput"]: GraphQLTypes["FulfillmentNoteWithoutCartItemsUpdateInput"];
	["CartItemUpsertFulfillmentNotesRelationInput"]: GraphQLTypes["CartItemUpsertFulfillmentNotesRelationInput"];
	["ProductUpsertCartItemsRelationInput"]: GraphQLTypes["ProductUpsertCartItemsRelationInput"];
	["ProductGroupPriceUpsertProductRelationInput"]: GraphQLTypes["ProductGroupPriceUpsertProductRelationInput"];
	["CustomerGroupUpsertProductPricesRelationInput"]: GraphQLTypes["CustomerGroupUpsertProductPricesRelationInput"];
	["CustomerUpsertGroupRelationInput"]: GraphQLTypes["CustomerUpsertGroupRelationInput"];
	["ChannelUpsertCustomersRelationInput"]: GraphQLTypes["ChannelUpsertCustomersRelationInput"];
	["TagUpsertAddTagsOnRegistrationRelationInput"]: GraphQLTypes["TagUpsertAddTagsOnRegistrationRelationInput"];
	["ProductCategoryUpsertTagsRelationInput"]: GraphQLTypes["ProductCategoryUpsertTagsRelationInput"];
	["ProductCategoryUpsertParentRelationInput"]: GraphQLTypes["ProductCategoryUpsertParentRelationInput"];
	["TagUpsertCategoriesRelationInput"]: GraphQLTypes["TagUpsertCategoriesRelationInput"];
	["ProductUpsertTagsRelationInput"]: GraphQLTypes["ProductUpsertTagsRelationInput"];
	["ProductCategoryUpsertProductsRelationInput"]: GraphQLTypes["ProductCategoryUpsertProductsRelationInput"];
	["ProductCategoryListItemUpsertProductCategoryRelationInput"]: GraphQLTypes["ProductCategoryListItemUpsertProductCategoryRelationInput"];
	["ProductCategoryListUpsertItemsRelationInput"]: GraphQLTypes["ProductCategoryListUpsertItemsRelationInput"];
	["ProductCategoryListLocaleUpsertRootRelationInput"]: GraphQLTypes["ProductCategoryListLocaleUpsertRootRelationInput"];
	["LocaleUpsertProductCategoryListsRelationInput"]: GraphQLTypes["LocaleUpsertProductCategoryListsRelationInput"];
	["ProductIngredientLocaleUpsertLocaleRelationInput"]: GraphQLTypes["ProductIngredientLocaleUpsertLocaleRelationInput"];
	["ProductIngredientUpsertLocalesRelationInput"]: GraphQLTypes["ProductIngredientUpsertLocalesRelationInput"];
	["ProductIngredientItemUpsertIngredientRelationInput"]: GraphQLTypes["ProductIngredientItemUpsertIngredientRelationInput"];
	["ProductIngredientItemUpdateQuantityEntityRelationInput"]: GraphQLTypes["ProductIngredientItemUpdateQuantityEntityRelationInput"];
	["ProductIngredientItemQuantityUpdateInput"]: GraphQLTypes["ProductIngredientItemQuantityUpdateInput"];
	["ProductIngredientItemQuantityUpdateUnitEntityRelationInput"]: GraphQLTypes["ProductIngredientItemQuantityUpdateUnitEntityRelationInput"];
	["ProductIngredientItemQuantityUpsertUnitRelationInput"]: GraphQLTypes["ProductIngredientItemQuantityUpsertUnitRelationInput"];
	["ProductIngredientItemUpsertQuantityRelationInput"]: GraphQLTypes["ProductIngredientItemUpsertQuantityRelationInput"];
	["ProductRecipeUpsertIngredientsRelationInput"]: GraphQLTypes["ProductRecipeUpsertIngredientsRelationInput"];
	["ProductUpsertRecipeRelationInput"]: GraphQLTypes["ProductUpsertRecipeRelationInput"];
	["CartItemUpsertProductRelationInput"]: GraphQLTypes["CartItemUpsertProductRelationInput"];
	["CartUpsertItemsRelationInput"]: GraphQLTypes["CartUpsertItemsRelationInput"];
	["ChannelUpsertCartsRelationInput"]: GraphQLTypes["ChannelUpsertCartsRelationInput"];
	["OrderUpsertChannelRelationInput"]: GraphQLTypes["OrderUpsertChannelRelationInput"];
	["CustomerUpsertOrdersRelationInput"]: GraphQLTypes["CustomerUpsertOrdersRelationInput"];
	["TagUpsertCustomersRelationInput"]: GraphQLTypes["TagUpsertCustomersRelationInput"];
	["ChannelPaymentUpsertAllowOnlyForTagsRelationInput"]: GraphQLTypes["ChannelPaymentUpsertAllowOnlyForTagsRelationInput"];
	["VatRateUpsertChannelPaymentsRelationInput"]: GraphQLTypes["VatRateUpsertChannelPaymentsRelationInput"];
	["ChannelDeliveryUpsertVatRateRelationInput"]: GraphQLTypes["ChannelDeliveryUpsertVatRateRelationInput"];
	["DeliveryMethodUpsertChannelsRelationInput"]: GraphQLTypes["DeliveryMethodUpsertChannelsRelationInput"];
	["PaymentMethodUpsertDeliveryMethodsRelationInput"]: GraphQLTypes["PaymentMethodUpsertDeliveryMethodsRelationInput"];
	["ChannelPaymentUpsertMethodRelationInput"]: GraphQLTypes["ChannelPaymentUpsertMethodRelationInput"];
	["ChannelUpsertPaymentsRelationInput"]: GraphQLTypes["ChannelUpsertPaymentsRelationInput"];
	["ChannelDeliveryUpsertChannelRelationInput"]: GraphQLTypes["ChannelDeliveryUpsertChannelRelationInput"];
	["VatRateUpsertChannelDeliveriesRelationInput"]: GraphQLTypes["VatRateUpsertChannelDeliveriesRelationInput"];
	["CustomerCreditUpsertVatRateRelationInput"]: GraphQLTypes["CustomerCreditUpsertVatRateRelationInput"];
	["CustomerUpsertCreditsRelationInput"]: GraphQLTypes["CustomerUpsertCreditsRelationInput"];
	["BusinessCustomerUpsertCustomerRelationInput"]: GraphQLTypes["BusinessCustomerUpsertCustomerRelationInput"];
	["BusinessCategoryUpsertBusinessCustomersRelationInput"]: GraphQLTypes["BusinessCategoryUpsertBusinessCustomersRelationInput"];
	["BusinessCategoryLocaleUpsertRootRelationInput"]: GraphQLTypes["BusinessCategoryLocaleUpsertRootRelationInput"];
	["LocaleUpsertBusinessCategoriesRelationInput"]: GraphQLTypes["LocaleUpsertBusinessCategoriesRelationInput"];
	["ProductPackingLocaleUpsertLocaleRelationInput"]: GraphQLTypes["ProductPackingLocaleUpsertLocaleRelationInput"];
	["ProductPackingUpsertLocalesRelationInput"]: GraphQLTypes["ProductPackingUpsertLocalesRelationInput"];
	["ProductUpsertPackingRelationInput"]: GraphQLTypes["ProductUpsertPackingRelationInput"];
	["TagUpsertProductsRelationInput"]: GraphQLTypes["TagUpsertProductsRelationInput"];
	["CustomerUpsertTagsRelationInput"]: GraphQLTypes["CustomerUpsertTagsRelationInput"];
	["InvoiceUpsertCustomerRelationInput"]: GraphQLTypes["InvoiceUpsertCustomerRelationInput"];
	["AddressUpsertInvoicesRelationInput"]: GraphQLTypes["AddressUpsertInvoicesRelationInput"];
	["DeliveryZoneUpsertAddressesRelationInput"]: GraphQLTypes["DeliveryZoneUpsertAddressesRelationInput"];
	["DeliveryMethodUpsertSuitableForDeliveryZonesRelationInput"]: GraphQLTypes["DeliveryMethodUpsertSuitableForDeliveryZonesRelationInput"];
	["ChannelDeliveryUpsertMethodRelationInput"]: GraphQLTypes["ChannelDeliveryUpsertMethodRelationInput"];
	["ChannelUpsertDeliveriesRelationInput"]: GraphQLTypes["ChannelUpsertDeliveriesRelationInput"];
	["ChannelPaymentUpsertChannelRelationInput"]: GraphQLTypes["ChannelPaymentUpsertChannelRelationInput"];
	["PaymentMethodUpsertChannelsRelationInput"]: GraphQLTypes["PaymentMethodUpsertChannelsRelationInput"];
	["DeliveryMethodUpsertPaymentMethodsRelationInput"]: GraphQLTypes["DeliveryMethodUpsertPaymentMethodsRelationInput"];
	["DeliveryZoneUpsertSuitableDeliveryMethodsRelationInput"]: GraphQLTypes["DeliveryZoneUpsertSuitableDeliveryMethodsRelationInput"];
	["AddressUpsertDeliveryZoneRelationInput"]: GraphQLTypes["AddressUpsertDeliveryZoneRelationInput"];
	["CustomerUpsertAddressesRelationInput"]: GraphQLTypes["CustomerUpsertAddressesRelationInput"];
	["CustomerPaymentMethodUpsertCustomerRelationInput"]: GraphQLTypes["CustomerPaymentMethodUpsertCustomerRelationInput"];
	["CustomerUpsertDefaultPaymentMethodRelationInput"]: GraphQLTypes["CustomerUpsertDefaultPaymentMethodRelationInput"];
	["AddressUpsertCustomerRelationInput"]: GraphQLTypes["AddressUpsertCustomerRelationInput"];
	["CustomerCreateInput"]: GraphQLTypes["CustomerCreateInput"];
	["CustomerUpdateInput"]: GraphQLTypes["CustomerUpdateInput"];
	["CustomerCreditCreateInput"]: GraphQLTypes["CustomerCreditCreateInput"];
	["CustomerCreditUpdateInput"]: GraphQLTypes["CustomerCreditUpdateInput"];
	["CustomerGroupConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CustomerGroupEdge"]>
};
	["CustomerGroupEdge"]: {
		node: GraphQLTypes["CustomerGroup"]
};
	["CustomerGroupCreateInput"]: GraphQLTypes["CustomerGroupCreateInput"];
	["CustomerGroupUpdateInput"]: GraphQLTypes["CustomerGroupUpdateInput"];
	["OrderCreateInput"]: GraphQLTypes["OrderCreateInput"];
	["OrderUpdateInput"]: GraphQLTypes["OrderUpdateInput"];
	["OrderDiscountCreateInput"]: GraphQLTypes["OrderDiscountCreateInput"];
	["OrderDiscountUpdateInput"]: GraphQLTypes["OrderDiscountUpdateInput"];
	["OrderPaymentCreateInput"]: GraphQLTypes["OrderPaymentCreateInput"];
	["OrderPaymentUpdateInput"]: GraphQLTypes["OrderPaymentUpdateInput"];
	["OrderDeliveryCreateInput"]: GraphQLTypes["OrderDeliveryCreateInput"];
	["OrderDeliveryUpdateInput"]: GraphQLTypes["OrderDeliveryUpdateInput"];
	["OrderItemCreateInput"]: GraphQLTypes["OrderItemCreateInput"];
	["OrderItemUpdateInput"]: GraphQLTypes["OrderItemUpdateInput"];
	["VatRateConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["VatRateEdge"]>
};
	["VatRateEdge"]: {
		node: GraphQLTypes["VatRate"]
};
	["ProductStockCreateInput"]: GraphQLTypes["ProductStockCreateInput"];
	["ProductStockCreateProductEntityRelationInput"]: GraphQLTypes["ProductStockCreateProductEntityRelationInput"];
	["ProductWithoutStocksCreateInput"]: GraphQLTypes["ProductWithoutStocksCreateInput"];
	["ProductStockUpdateInput"]: GraphQLTypes["ProductStockUpdateInput"];
	["ProductStockUpdateProductEntityRelationInput"]: GraphQLTypes["ProductStockUpdateProductEntityRelationInput"];
	["ProductWithoutStocksUpdateInput"]: GraphQLTypes["ProductWithoutStocksUpdateInput"];
	["ProductStockUpsertProductRelationInput"]: GraphQLTypes["ProductStockUpsertProductRelationInput"];
	["ProductPackingConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductPackingEdge"]>
};
	["ProductPackingEdge"]: {
		node: GraphQLTypes["ProductPacking"]
};
	["ProductGroupPriceCreateInput"]: GraphQLTypes["ProductGroupPriceCreateInput"];
	["ProductGroupPriceUpdateInput"]: GraphQLTypes["ProductGroupPriceUpdateInput"];
	["ProductRecipeConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductRecipeEdge"]>
};
	["ProductRecipeEdge"]: {
		node: GraphQLTypes["ProductRecipe"]
};
	["StoreConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["StoreEdge"]>
};
	["StoreEdge"]: {
		node: GraphQLTypes["Store"]
};
	["TagCreateInput"]: GraphQLTypes["TagCreateInput"];
	["TagUpdateInput"]: GraphQLTypes["TagUpdateInput"];
	["CustomerPermissionsConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CustomerPermissionsEdge"]>
};
	["CustomerPermissionsEdge"]: {
		node: GraphQLTypes["CustomerPermissions"]
};
	["ImageConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ImageEdge"]>
};
	["ImageEdge"]: {
		node: GraphQLTypes["Image"]
};
	["BusinessCategoryCreateInput"]: GraphQLTypes["BusinessCategoryCreateInput"];
	["BusinessCategoryUpdateInput"]: GraphQLTypes["BusinessCategoryUpdateInput"];
	["ProductListConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductListEdge"]>
};
	["ProductListEdge"]: {
		node: GraphQLTypes["ProductList"]
};
	["ProductListItemCreateInput"]: GraphQLTypes["ProductListItemCreateInput"];
	["ProductListItemCreateListEntityRelationInput"]: GraphQLTypes["ProductListItemCreateListEntityRelationInput"];
	["ProductListWithoutItemsCreateInput"]: GraphQLTypes["ProductListWithoutItemsCreateInput"];
	["ProductListItemUpdateInput"]: GraphQLTypes["ProductListItemUpdateInput"];
	["ProductListItemUpdateListEntityRelationInput"]: GraphQLTypes["ProductListItemUpdateListEntityRelationInput"];
	["ProductListWithoutItemsUpdateInput"]: GraphQLTypes["ProductListWithoutItemsUpdateInput"];
	["ProductListItemUpsertListRelationInput"]: GraphQLTypes["ProductListItemUpsertListRelationInput"];
	["ProductCategoryListConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductCategoryListEdge"]>
};
	["ProductCategoryListEdge"]: {
		node: GraphQLTypes["ProductCategoryList"]
};
	["ProductCategoryListCreateInput"]: GraphQLTypes["ProductCategoryListCreateInput"];
	["ProductCategoryListUpdateInput"]: GraphQLTypes["ProductCategoryListUpdateInput"];
	["ProductCategoryListItemCreateInput"]: GraphQLTypes["ProductCategoryListItemCreateInput"];
	["ProductCategoryListItemCreateListEntityRelationInput"]: GraphQLTypes["ProductCategoryListItemCreateListEntityRelationInput"];
	["ProductCategoryListWithoutItemsCreateInput"]: GraphQLTypes["ProductCategoryListWithoutItemsCreateInput"];
	["ProductCategoryListItemUpdateInput"]: GraphQLTypes["ProductCategoryListItemUpdateInput"];
	["ProductCategoryListItemUpdateListEntityRelationInput"]: GraphQLTypes["ProductCategoryListItemUpdateListEntityRelationInput"];
	["ProductCategoryListWithoutItemsUpdateInput"]: GraphQLTypes["ProductCategoryListWithoutItemsUpdateInput"];
	["ProductCategoryListItemUpsertListRelationInput"]: GraphQLTypes["ProductCategoryListItemUpsertListRelationInput"];
	["BusinessCategoryLocaleCreateInput"]: GraphQLTypes["BusinessCategoryLocaleCreateInput"];
	["BusinessCategoryLocaleUpdateInput"]: GraphQLTypes["BusinessCategoryLocaleUpdateInput"];
	["LocaleConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LocaleEdge"]>
};
	["LocaleEdge"]: {
		node: GraphQLTypes["Locale"]
};
	["LocaleCreateInput"]: GraphQLTypes["LocaleCreateInput"];
	["LocaleUpdateInput"]: GraphQLTypes["LocaleUpdateInput"];
	["ProductCategoryListLocaleCreateInput"]: GraphQLTypes["ProductCategoryListLocaleCreateInput"];
	["ProductCategoryListLocaleUpdateInput"]: GraphQLTypes["ProductCategoryListLocaleUpdateInput"];
	["CustomerNameConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CustomerNameEdge"]>
};
	["CustomerNameEdge"]: {
		node: GraphQLTypes["CustomerName"]
};
	["CustomerNameCreateInput"]: GraphQLTypes["CustomerNameCreateInput"];
	["CustomerNameCreateCustomerEntityRelationInput"]: GraphQLTypes["CustomerNameCreateCustomerEntityRelationInput"];
	["CustomerWithoutNameCreateInput"]: GraphQLTypes["CustomerWithoutNameCreateInput"];
	["CustomerNameUpdateInput"]: GraphQLTypes["CustomerNameUpdateInput"];
	["CustomerNameUpdateCustomerEntityRelationInput"]: GraphQLTypes["CustomerNameUpdateCustomerEntityRelationInput"];
	["CustomerWithoutNameUpdateInput"]: GraphQLTypes["CustomerWithoutNameUpdateInput"];
	["CustomerNameUpsertCustomerRelationInput"]: GraphQLTypes["CustomerNameUpsertCustomerRelationInput"];
	["ProductIngredientItemCreateInput"]: GraphQLTypes["ProductIngredientItemCreateInput"];
	["ProductIngredientItemCreateRecipeEntityRelationInput"]: GraphQLTypes["ProductIngredientItemCreateRecipeEntityRelationInput"];
	["ProductRecipeWithoutIngredientsCreateInput"]: GraphQLTypes["ProductRecipeWithoutIngredientsCreateInput"];
	["ProductIngredientItemUpdateInput"]: GraphQLTypes["ProductIngredientItemUpdateInput"];
	["ProductIngredientItemUpdateRecipeEntityRelationInput"]: GraphQLTypes["ProductIngredientItemUpdateRecipeEntityRelationInput"];
	["ProductRecipeWithoutIngredientsUpdateInput"]: GraphQLTypes["ProductRecipeWithoutIngredientsUpdateInput"];
	["ProductIngredientItemUpsertRecipeRelationInput"]: GraphQLTypes["ProductIngredientItemUpsertRecipeRelationInput"];
	["ProductIngredientItemQuantityConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductIngredientItemQuantityEdge"]>
};
	["ProductIngredientItemQuantityEdge"]: {
		node: GraphQLTypes["ProductIngredientItemQuantity"]
};
	["ProductIngredientItemQuantityUnitConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductIngredientItemQuantityUnitEdge"]>
};
	["ProductIngredientItemQuantityUnitEdge"]: {
		node: GraphQLTypes["ProductIngredientItemQuantityUnit"]
};
	["CustomerIngredientRatingCreateInput"]: GraphQLTypes["CustomerIngredientRatingCreateInput"];
	["CustomerIngredientRatingUpdateInput"]: GraphQLTypes["CustomerIngredientRatingUpdateInput"];
	["ProductIngredientRatingConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductIngredientRatingEdge"]>
};
	["ProductIngredientRatingEdge"]: {
		node: GraphQLTypes["ProductIngredientRating"]
};
	["ProductIngredientLocaleCreateInput"]: GraphQLTypes["ProductIngredientLocaleCreateInput"];
	["ProductIngredientLocaleUpdateInput"]: GraphQLTypes["ProductIngredientLocaleUpdateInput"];
	["OrderRecurrenceCreateInput"]: GraphQLTypes["OrderRecurrenceCreateInput"];
	["OrderRecurrenceUpdateInput"]: GraphQLTypes["OrderRecurrenceUpdateInput"];
	["OrderRecurrenceLocaleCreateInput"]: GraphQLTypes["OrderRecurrenceLocaleCreateInput"];
	["OrderRecurrenceLocaleUpdateInput"]: GraphQLTypes["OrderRecurrenceLocaleUpdateInput"];
	["BusinessCustomerCreateInput"]: GraphQLTypes["BusinessCustomerCreateInput"];
	["BusinessCustomerUpdateInput"]: GraphQLTypes["BusinessCustomerUpdateInput"];
	["PointOfSaleCreateInput"]: GraphQLTypes["PointOfSaleCreateInput"];
	["PointOfSaleCreateChannelsEntityRelationInput"]: GraphQLTypes["PointOfSaleCreateChannelsEntityRelationInput"];
	["ChannelWithoutPointOfSalesCreateInput"]: GraphQLTypes["ChannelWithoutPointOfSalesCreateInput"];
	["PointOfSaleUpdateInput"]: GraphQLTypes["PointOfSaleUpdateInput"];
	["PointOfSaleUpdateChannelsEntityRelationInput"]: GraphQLTypes["PointOfSaleUpdateChannelsEntityRelationInput"];
	["PointOfSaleUpdateChannelsRelationInput"]: GraphQLTypes["PointOfSaleUpdateChannelsRelationInput"];
	["ChannelWithoutPointOfSalesUpdateInput"]: GraphQLTypes["ChannelWithoutPointOfSalesUpdateInput"];
	["PointOfSaleUpsertChannelsRelationInput"]: GraphQLTypes["PointOfSaleUpsertChannelsRelationInput"];
	["PointOfSalePermissionsConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PointOfSalePermissionsEdge"]>
};
	["PointOfSalePermissionsEdge"]: {
		node: GraphQLTypes["PointOfSalePermissions"]
};
	["BlogConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BlogEdge"]>
};
	["BlogEdge"]: {
		node: GraphQLTypes["Blog"]
};
	["BlogCreateInput"]: GraphQLTypes["BlogCreateInput"];
	["BlogCreateLocalesEntityRelationInput"]: GraphQLTypes["BlogCreateLocalesEntityRelationInput"];
	["BlogLocaleWithoutRootCreateInput"]: GraphQLTypes["BlogLocaleWithoutRootCreateInput"];
	["BlogLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["BlogLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutBlogsCreateInput"]: GraphQLTypes["LocaleWithoutBlogsCreateInput"];
	["BlogUpdateInput"]: GraphQLTypes["BlogUpdateInput"];
	["BlogUpdateLocalesEntityRelationInput"]: GraphQLTypes["BlogUpdateLocalesEntityRelationInput"];
	["BlogUpdateLocalesRelationInput"]: GraphQLTypes["BlogUpdateLocalesRelationInput"];
	["BlogLocaleWithoutRootUpdateInput"]: GraphQLTypes["BlogLocaleWithoutRootUpdateInput"];
	["BlogLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["BlogLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutBlogsUpdateInput"]: GraphQLTypes["LocaleWithoutBlogsUpdateInput"];
	["BlogLocaleUpsertLocaleRelationInput"]: GraphQLTypes["BlogLocaleUpsertLocaleRelationInput"];
	["BlogUpsertLocalesRelationInput"]: GraphQLTypes["BlogUpsertLocalesRelationInput"];
	["BlogLocaleCreateInput"]: GraphQLTypes["BlogLocaleCreateInput"];
	["BlogLocaleUpdateInput"]: GraphQLTypes["BlogLocaleUpdateInput"];
	["BlogPostConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BlogPostEdge"]>
};
	["BlogPostEdge"]: {
		node: GraphQLTypes["BlogPost"]
};
	["BlogPostCreateInput"]: GraphQLTypes["BlogPostCreateInput"];
	["BlogPostCreateLocalesEntityRelationInput"]: GraphQLTypes["BlogPostCreateLocalesEntityRelationInput"];
	["BlogPostLocaleWithoutRootCreateInput"]: GraphQLTypes["BlogPostLocaleWithoutRootCreateInput"];
	["BlogPostUpdateInput"]: GraphQLTypes["BlogPostUpdateInput"];
	["BlogPostUpdateLocalesEntityRelationInput"]: GraphQLTypes["BlogPostUpdateLocalesEntityRelationInput"];
	["BlogPostUpdateLocalesRelationInput"]: GraphQLTypes["BlogPostUpdateLocalesRelationInput"];
	["BlogPostLocaleWithoutRootUpdateInput"]: GraphQLTypes["BlogPostLocaleWithoutRootUpdateInput"];
	["BlogPostUpsertLocalesRelationInput"]: GraphQLTypes["BlogPostUpsertLocalesRelationInput"];
	["ColorPalleteConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ColorPalleteEdge"]>
};
	["ColorPalleteEdge"]: {
		node: GraphQLTypes["ColorPallete"]
};
	["ContentConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentEdge"]>
};
	["ContentEdge"]: {
		node: GraphQLTypes["Content"]
};
	["ContentBlockCreateInput"]: GraphQLTypes["ContentBlockCreateInput"];
	["ContentBlockCreateContentEntityRelationInput"]: GraphQLTypes["ContentBlockCreateContentEntityRelationInput"];
	["ContentWithoutBlocksCreateInput"]: GraphQLTypes["ContentWithoutBlocksCreateInput"];
	["ContentBlockUpdateInput"]: GraphQLTypes["ContentBlockUpdateInput"];
	["ContentBlockUpdateContentEntityRelationInput"]: GraphQLTypes["ContentBlockUpdateContentEntityRelationInput"];
	["ContentWithoutBlocksUpdateInput"]: GraphQLTypes["ContentWithoutBlocksUpdateInput"];
	["ContentBlockUpsertContentRelationInput"]: GraphQLTypes["ContentBlockUpsertContentRelationInput"];
	["ContentReferenceCreateInput"]: GraphQLTypes["ContentReferenceCreateInput"];
	["ContentReferenceCreateBlockEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateBlockEntityRelationInput"];
	["ContentBlockWithoutReferencesCreateInput"]: GraphQLTypes["ContentBlockWithoutReferencesCreateInput"];
	["ContentReferenceUpdateInput"]: GraphQLTypes["ContentReferenceUpdateInput"];
	["ContentReferenceUpdateBlockEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateBlockEntityRelationInput"];
	["ContentBlockWithoutReferencesUpdateInput"]: GraphQLTypes["ContentBlockWithoutReferencesUpdateInput"];
	["ContentReferenceUpsertBlockRelationInput"]: GraphQLTypes["ContentReferenceUpsertBlockRelationInput"];
	["BlogPostListConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BlogPostListEdge"]>
};
	["BlogPostListEdge"]: {
		node: GraphQLTypes["BlogPostList"]
};
	["BlogPostListItemCreateInput"]: GraphQLTypes["BlogPostListItemCreateInput"];
	["BlogPostListItemCreateListEntityRelationInput"]: GraphQLTypes["BlogPostListItemCreateListEntityRelationInput"];
	["BlogPostListWithoutItemsCreateInput"]: GraphQLTypes["BlogPostListWithoutItemsCreateInput"];
	["BlogPostListItemUpdateInput"]: GraphQLTypes["BlogPostListItemUpdateInput"];
	["BlogPostListItemUpdateListEntityRelationInput"]: GraphQLTypes["BlogPostListItemUpdateListEntityRelationInput"];
	["BlogPostListWithoutItemsUpdateInput"]: GraphQLTypes["BlogPostListWithoutItemsUpdateInput"];
	["BlogPostListItemUpsertListRelationInput"]: GraphQLTypes["BlogPostListItemUpsertListRelationInput"];
	["LinkListConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkListEdge"]>
};
	["LinkListEdge"]: {
		node: GraphQLTypes["LinkList"]
};
	["LinkListItemCreateInput"]: GraphQLTypes["LinkListItemCreateInput"];
	["LinkListItemCreateListEntityRelationInput"]: GraphQLTypes["LinkListItemCreateListEntityRelationInput"];
	["LinkListWithoutItemsCreateInput"]: GraphQLTypes["LinkListWithoutItemsCreateInput"];
	["LinkListItemUpdateInput"]: GraphQLTypes["LinkListItemUpdateInput"];
	["LinkListItemUpdateListEntityRelationInput"]: GraphQLTypes["LinkListItemUpdateListEntityRelationInput"];
	["LinkListWithoutItemsUpdateInput"]: GraphQLTypes["LinkListWithoutItemsUpdateInput"];
	["LinkListItemUpsertListRelationInput"]: GraphQLTypes["LinkListItemUpsertListRelationInput"];
	["CoverConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CoverEdge"]>
};
	["CoverEdge"]: {
		node: GraphQLTypes["Cover"]
};
	["LinkConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkEdge"]>
};
	["LinkEdge"]: {
		node: GraphQLTypes["Link"]
};
	["LinkableConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkableEdge"]>
};
	["LinkableEdge"]: {
		node: GraphQLTypes["Linkable"]
};
	["MediumConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MediumEdge"]>
};
	["MediumEdge"]: {
		node: GraphQLTypes["Medium"]
};
	["VideoConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["VideoEdge"]>
};
	["VideoEdge"]: {
		node: GraphQLTypes["Video"]
};
	["SeoConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SeoEdge"]>
};
	["SeoEdge"]: {
		node: GraphQLTypes["Seo"]
};
	["ProtectedImage"]: {
		_meta?: GraphQLTypes["ProtectedImageMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	url: string,
	width?: number | undefined,
	height?: number | undefined,
	size?: number | undefined,
	type?: string | undefined,
	alt?: string | undefined
};
	["ProtectedImageMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	url?: GraphQLTypes["FieldMeta"] | undefined,
	width?: GraphQLTypes["FieldMeta"] | undefined,
	height?: GraphQLTypes["FieldMeta"] | undefined,
	size?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	alt?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProtectedImageUniqueWhere"]: GraphQLTypes["ProtectedImageUniqueWhere"];
	["ProtectedImageWhere"]: GraphQLTypes["ProtectedImageWhere"];
	["ProtectedImageOrderBy"]: GraphQLTypes["ProtectedImageOrderBy"];
	["ProtectedImageConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProtectedImageEdge"]>
};
	["ProtectedImageEdge"]: {
		node: GraphQLTypes["ProtectedImage"]
};
	["ProtectedImageCreateInput"]: GraphQLTypes["ProtectedImageCreateInput"];
	["ProtectedImageUpdateInput"]: GraphQLTypes["ProtectedImageUpdateInput"];
	["TranslationDomainConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TranslationDomainEdge"]>
};
	["TranslationDomainEdge"]: {
		node: GraphQLTypes["TranslationDomain"]
};
	["TranslationDomainCreateInput"]: GraphQLTypes["TranslationDomainCreateInput"];
	["TranslationDomainUpdateInput"]: GraphQLTypes["TranslationDomainUpdateInput"];
	["TranslationKeyCreateInput"]: GraphQLTypes["TranslationKeyCreateInput"];
	["TranslationKeyUpdateInput"]: GraphQLTypes["TranslationKeyUpdateInput"];
	["TranslationValueCreateInput"]: GraphQLTypes["TranslationValueCreateInput"];
	["TranslationValueUpdateInput"]: GraphQLTypes["TranslationValueUpdateInput"];
	["TranslationCataloguesIdentifierConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TranslationCataloguesIdentifierEdge"]>
};
	["TranslationCataloguesIdentifierEdge"]: {
		node: GraphQLTypes["TranslationCataloguesIdentifier"]
};
	["SocialsAndAppsConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SocialsAndAppsEdge"]>
};
	["SocialsAndAppsEdge"]: {
		node: GraphQLTypes["SocialsAndApps"]
};
	["ProductGridConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductGridEdge"]>
};
	["ProductGridEdge"]: {
		node: GraphQLTypes["ProductGrid"]
};
	["ProductGridItemCreateInput"]: GraphQLTypes["ProductGridItemCreateInput"];
	["ProductGridItemCreateCategoryEntityRelationInput"]: GraphQLTypes["ProductGridItemCreateCategoryEntityRelationInput"];
	["ProductGridCategoryWithoutItemsCreateInput"]: GraphQLTypes["ProductGridCategoryWithoutItemsCreateInput"];
	["ProductGridCategoryCreateRootEntityRelationInput"]: GraphQLTypes["ProductGridCategoryCreateRootEntityRelationInput"];
	["ProductGridWithoutCategoriesCreateInput"]: GraphQLTypes["ProductGridWithoutCategoriesCreateInput"];
	["ProductGridItemUpdateInput"]: GraphQLTypes["ProductGridItemUpdateInput"];
	["ProductGridItemUpdateCategoryEntityRelationInput"]: GraphQLTypes["ProductGridItemUpdateCategoryEntityRelationInput"];
	["ProductGridCategoryWithoutItemsUpdateInput"]: GraphQLTypes["ProductGridCategoryWithoutItemsUpdateInput"];
	["ProductGridCategoryUpdateRootEntityRelationInput"]: GraphQLTypes["ProductGridCategoryUpdateRootEntityRelationInput"];
	["ProductGridWithoutCategoriesUpdateInput"]: GraphQLTypes["ProductGridWithoutCategoriesUpdateInput"];
	["ProductGridCategoryUpsertRootRelationInput"]: GraphQLTypes["ProductGridCategoryUpsertRootRelationInput"];
	["ProductGridItemUpsertCategoryRelationInput"]: GraphQLTypes["ProductGridItemUpsertCategoryRelationInput"];
	["GalleryConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GalleryEdge"]>
};
	["GalleryEdge"]: {
		node: GraphQLTypes["Gallery"]
};
	["GalleryItemCreateInput"]: GraphQLTypes["GalleryItemCreateInput"];
	["GalleryItemCreateListEntityRelationInput"]: GraphQLTypes["GalleryItemCreateListEntityRelationInput"];
	["GalleryWithoutItemsCreateInput"]: GraphQLTypes["GalleryWithoutItemsCreateInput"];
	["GalleryItemUpdateInput"]: GraphQLTypes["GalleryItemUpdateInput"];
	["GalleryItemUpdateListEntityRelationInput"]: GraphQLTypes["GalleryItemUpdateListEntityRelationInput"];
	["GalleryWithoutItemsUpdateInput"]: GraphQLTypes["GalleryWithoutItemsUpdateInput"];
	["GalleryItemUpsertListRelationInput"]: GraphQLTypes["GalleryItemUpsertListRelationInput"];
	["HeroConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["HeroEdge"]>
};
	["HeroEdge"]: {
		node: GraphQLTypes["Hero"]
};
	["SiteMenuConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SiteMenuEdge"]>
};
	["SiteMenuEdge"]: {
		node: GraphQLTypes["SiteMenu"]
};
	["SiteMenuCreateInput"]: GraphQLTypes["SiteMenuCreateInput"];
	["SiteMenuCreateLocalesEntityRelationInput"]: GraphQLTypes["SiteMenuCreateLocalesEntityRelationInput"];
	["MenuLocaleWithoutRootCreateInput"]: GraphQLTypes["MenuLocaleWithoutRootCreateInput"];
	["MenuLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["MenuLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutMenusCreateInput"]: GraphQLTypes["LocaleWithoutMenusCreateInput"];
	["SiteMenuUpdateInput"]: GraphQLTypes["SiteMenuUpdateInput"];
	["SiteMenuUpdateLocalesEntityRelationInput"]: GraphQLTypes["SiteMenuUpdateLocalesEntityRelationInput"];
	["SiteMenuUpdateLocalesRelationInput"]: GraphQLTypes["SiteMenuUpdateLocalesRelationInput"];
	["MenuLocaleWithoutRootUpdateInput"]: GraphQLTypes["MenuLocaleWithoutRootUpdateInput"];
	["MenuLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["MenuLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutMenusUpdateInput"]: GraphQLTypes["LocaleWithoutMenusUpdateInput"];
	["MenuLocaleUpsertLocaleRelationInput"]: GraphQLTypes["MenuLocaleUpsertLocaleRelationInput"];
	["SiteMenuUpsertLocalesRelationInput"]: GraphQLTypes["SiteMenuUpsertLocalesRelationInput"];
	["MenuLocaleCreateInput"]: GraphQLTypes["MenuLocaleCreateInput"];
	["MenuLocaleUpdateInput"]: GraphQLTypes["MenuLocaleUpdateInput"];
	["MenuItemCreateInput"]: GraphQLTypes["MenuItemCreateInput"];
	["MenuItemCreateMenuEntityRelationInput"]: GraphQLTypes["MenuItemCreateMenuEntityRelationInput"];
	["MenuLocaleWithoutItemsCreateInput"]: GraphQLTypes["MenuLocaleWithoutItemsCreateInput"];
	["MenuItemUpdateInput"]: GraphQLTypes["MenuItemUpdateInput"];
	["MenuItemUpdateMenuEntityRelationInput"]: GraphQLTypes["MenuItemUpdateMenuEntityRelationInput"];
	["MenuLocaleWithoutItemsUpdateInput"]: GraphQLTypes["MenuLocaleWithoutItemsUpdateInput"];
	["MenuItemUpsertMenuRelationInput"]: GraphQLTypes["MenuItemUpsertMenuRelationInput"];
	["PageConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PageEdge"]>
};
	["PageEdge"]: {
		node: GraphQLTypes["Page"]
};
	["PageLocaleCreateInput"]: GraphQLTypes["PageLocaleCreateInput"];
	["PageLocaleUpdateInput"]: GraphQLTypes["PageLocaleUpdateInput"];
	["WikiPageCreateInput"]: GraphQLTypes["WikiPageCreateInput"];
	["WikiPageUpdateInput"]: GraphQLTypes["WikiPageUpdateInput"];
	["MenuSubitemCreateInput"]: GraphQLTypes["MenuSubitemCreateInput"];
	["MenuSubitemCreateItemEntityRelationInput"]: GraphQLTypes["MenuSubitemCreateItemEntityRelationInput"];
	["MenuItemWithoutSubitemsCreateInput"]: GraphQLTypes["MenuItemWithoutSubitemsCreateInput"];
	["MenuSubitemUpdateInput"]: GraphQLTypes["MenuSubitemUpdateInput"];
	["MenuSubitemUpdateItemEntityRelationInput"]: GraphQLTypes["MenuSubitemUpdateItemEntityRelationInput"];
	["MenuItemWithoutSubitemsUpdateInput"]: GraphQLTypes["MenuItemWithoutSubitemsUpdateInput"];
	["MenuSubitemUpsertItemRelationInput"]: GraphQLTypes["MenuSubitemUpsertItemRelationInput"];
	["MenuLinkListConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MenuLinkListEdge"]>
};
	["MenuLinkListEdge"]: {
		node: GraphQLTypes["MenuLinkList"]
};
	["MenuLinkItemCreateInput"]: GraphQLTypes["MenuLinkItemCreateInput"];
	["MenuLinkItemCreateListEntityRelationInput"]: GraphQLTypes["MenuLinkItemCreateListEntityRelationInput"];
	["MenuLinkListWithoutItemsCreateInput"]: GraphQLTypes["MenuLinkListWithoutItemsCreateInput"];
	["MenuLinkItemUpdateInput"]: GraphQLTypes["MenuLinkItemUpdateInput"];
	["MenuLinkItemUpdateListEntityRelationInput"]: GraphQLTypes["MenuLinkItemUpdateListEntityRelationInput"];
	["MenuLinkListWithoutItemsUpdateInput"]: GraphQLTypes["MenuLinkListWithoutItemsUpdateInput"];
	["MenuLinkItemUpsertListRelationInput"]: GraphQLTypes["MenuLinkItemUpsertListRelationInput"];
	["MenuProductsConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MenuProductsEdge"]>
};
	["MenuProductsEdge"]: {
		node: GraphQLTypes["MenuProducts"]
};
	["MenuDeliveryConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MenuDeliveryEdge"]>
};
	["MenuDeliveryEdge"]: {
		node: GraphQLTypes["MenuDelivery"]
};
	["MenuContactConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MenuContactEdge"]>
};
	["MenuContactEdge"]: {
		node: GraphQLTypes["MenuContact"]
};
	["DeadlineTemplateConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DeadlineTemplateEdge"]>
};
	["DeadlineTemplateEdge"]: {
		node: GraphQLTypes["DeadlineTemplate"]
};
	["DeadlineTemplateCreateInput"]: GraphQLTypes["DeadlineTemplateCreateInput"];
	["DeadlineTemplateCreateVenueEntityRelationInput"]: GraphQLTypes["DeadlineTemplateCreateVenueEntityRelationInput"];
	["VenueWithoutDeadlineTemplateCreateInput"]: GraphQLTypes["VenueWithoutDeadlineTemplateCreateInput"];
	["DeadlineTemplateUpdateInput"]: GraphQLTypes["DeadlineTemplateUpdateInput"];
	["DeadlineTemplateUpdateVenueEntityRelationInput"]: GraphQLTypes["DeadlineTemplateUpdateVenueEntityRelationInput"];
	["VenueWithoutDeadlineTemplateUpdateInput"]: GraphQLTypes["VenueWithoutDeadlineTemplateUpdateInput"];
	["DeadlineTemplateUpsertVenueRelationInput"]: GraphQLTypes["DeadlineTemplateUpsertVenueRelationInput"];
	["EmployeeQueueConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["EmployeeQueueEdge"]>
};
	["EmployeeQueueEdge"]: {
		node: GraphQLTypes["EmployeeQueue"]
};
	["EmployeeQueueCreateInput"]: GraphQLTypes["EmployeeQueueCreateInput"];
	["EmployeeQueueUpdateInput"]: GraphQLTypes["EmployeeQueueUpdateInput"];
	["TimetableDayCreateInput"]: GraphQLTypes["TimetableDayCreateInput"];
	["TimetableDayUpdateInput"]: GraphQLTypes["TimetableDayUpdateInput"];
	["TimetableShiftCreateInput"]: GraphQLTypes["TimetableShiftCreateInput"];
	["TimetableShiftUpdateInput"]: GraphQLTypes["TimetableShiftUpdateInput"];
	["TimetableShiftGroupCreateInput"]: GraphQLTypes["TimetableShiftGroupCreateInput"];
	["TimetableShiftGroupUpdateInput"]: GraphQLTypes["TimetableShiftGroupUpdateInput"];
	["TimetableShiftPositionConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TimetableShiftPositionEdge"]>
};
	["TimetableShiftPositionEdge"]: {
		node: GraphQLTypes["TimetableShiftPosition"]
};
	["TimetableShiftPositionCreateInput"]: GraphQLTypes["TimetableShiftPositionCreateInput"];
	["TimetableShiftPositionUpdateInput"]: GraphQLTypes["TimetableShiftPositionUpdateInput"];
	["CartCreateInput"]: GraphQLTypes["CartCreateInput"];
	["CartUpdateInput"]: GraphQLTypes["CartUpdateInput"];
	["CartItemCreateInput"]: GraphQLTypes["CartItemCreateInput"];
	["CartItemUpdateInput"]: GraphQLTypes["CartItemUpdateInput"];
	["EmployeeQueueItemCreateInput"]: GraphQLTypes["EmployeeQueueItemCreateInput"];
	["EmployeeQueueItemUpdateInput"]: GraphQLTypes["EmployeeQueueItemUpdateInput"];
	["ApplicationConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ApplicationEdge"]>
};
	["ApplicationEdge"]: {
		node: GraphQLTypes["Application"]
};
	["ApplicationShortcutListConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ApplicationShortcutListEdge"]>
};
	["ApplicationShortcutListEdge"]: {
		node: GraphQLTypes["ApplicationShortcutList"]
};
	["ApplicationShortcutListCreateInput"]: GraphQLTypes["ApplicationShortcutListCreateInput"];
	["ApplicationShortcutListCreateCustomerEntityRelationInput"]: GraphQLTypes["ApplicationShortcutListCreateCustomerEntityRelationInput"];
	["CustomerWithoutShortcutListCreateInput"]: GraphQLTypes["CustomerWithoutShortcutListCreateInput"];
	["ApplicationShortcutListUpdateInput"]: GraphQLTypes["ApplicationShortcutListUpdateInput"];
	["ApplicationShortcutListUpdateCustomerEntityRelationInput"]: GraphQLTypes["ApplicationShortcutListUpdateCustomerEntityRelationInput"];
	["CustomerWithoutShortcutListUpdateInput"]: GraphQLTypes["CustomerWithoutShortcutListUpdateInput"];
	["ApplicationShortcutListUpsertCustomerRelationInput"]: GraphQLTypes["ApplicationShortcutListUpsertCustomerRelationInput"];
	["ApplicationShortcutListItemCreateInput"]: GraphQLTypes["ApplicationShortcutListItemCreateInput"];
	["ApplicationShortcutListItemCreateListEntityRelationInput"]: GraphQLTypes["ApplicationShortcutListItemCreateListEntityRelationInput"];
	["ApplicationShortcutListWithoutItemsCreateInput"]: GraphQLTypes["ApplicationShortcutListWithoutItemsCreateInput"];
	["ApplicationShortcutListItemUpdateInput"]: GraphQLTypes["ApplicationShortcutListItemUpdateInput"];
	["ApplicationShortcutListItemUpdateListEntityRelationInput"]: GraphQLTypes["ApplicationShortcutListItemUpdateListEntityRelationInput"];
	["ApplicationShortcutListWithoutItemsUpdateInput"]: GraphQLTypes["ApplicationShortcutListWithoutItemsUpdateInput"];
	["ApplicationShortcutListItemUpsertListRelationInput"]: GraphQLTypes["ApplicationShortcutListItemUpsertListRelationInput"];
	["ProductBannerConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductBannerEdge"]>
};
	["ProductBannerEdge"]: {
		node: GraphQLTypes["ProductBanner"]
};
	["ProductBannerItemCreateInput"]: GraphQLTypes["ProductBannerItemCreateInput"];
	["ProductBannerItemCreateListEntityRelationInput"]: GraphQLTypes["ProductBannerItemCreateListEntityRelationInput"];
	["ProductBannerListWithoutItemsCreateInput"]: GraphQLTypes["ProductBannerListWithoutItemsCreateInput"];
	["ProductBannerItemUpdateInput"]: GraphQLTypes["ProductBannerItemUpdateInput"];
	["ProductBannerItemUpdateListEntityRelationInput"]: GraphQLTypes["ProductBannerItemUpdateListEntityRelationInput"];
	["ProductBannerListWithoutItemsUpdateInput"]: GraphQLTypes["ProductBannerListWithoutItemsUpdateInput"];
	["ProductBannerItemUpsertListRelationInput"]: GraphQLTypes["ProductBannerItemUpsertListRelationInput"];
	["ProductBannerListConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductBannerListEdge"]>
};
	["ProductBannerListEdge"]: {
		node: GraphQLTypes["ProductBannerList"]
};
	["BartenderConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BartenderEdge"]>
};
	["BartenderEdge"]: {
		node: GraphQLTypes["Bartender"]
};
	["BartenderCreateInput"]: GraphQLTypes["BartenderCreateInput"];
	["BartenderCreateStaffEntityRelationInput"]: GraphQLTypes["BartenderCreateStaffEntityRelationInput"];
	["StaffWithoutBartenderCreateInput"]: GraphQLTypes["StaffWithoutBartenderCreateInput"];
	["BartenderUpdateInput"]: GraphQLTypes["BartenderUpdateInput"];
	["BartenderUpdateStaffEntityRelationInput"]: GraphQLTypes["BartenderUpdateStaffEntityRelationInput"];
	["StaffWithoutBartenderUpdateInput"]: GraphQLTypes["StaffWithoutBartenderUpdateInput"];
	["BartenderUpsertStaffRelationInput"]: GraphQLTypes["BartenderUpsertStaffRelationInput"];
	["BusinessToBusinessManagerConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BusinessToBusinessManagerEdge"]>
};
	["BusinessToBusinessManagerEdge"]: {
		node: GraphQLTypes["BusinessToBusinessManager"]
};
	["BusinessToBusinessManagerCreateInput"]: GraphQLTypes["BusinessToBusinessManagerCreateInput"];
	["BusinessToBusinessManagerUpdateInput"]: GraphQLTypes["BusinessToBusinessManagerUpdateInput"];
	["CleanerConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CleanerEdge"]>
};
	["CleanerEdge"]: {
		node: GraphQLTypes["Cleaner"]
};
	["CleanerCreateInput"]: GraphQLTypes["CleanerCreateInput"];
	["CleanerCreateStaffEntityRelationInput"]: GraphQLTypes["CleanerCreateStaffEntityRelationInput"];
	["StaffWithoutCleanerCreateInput"]: GraphQLTypes["StaffWithoutCleanerCreateInput"];
	["CleanerUpdateInput"]: GraphQLTypes["CleanerUpdateInput"];
	["CleanerUpdateStaffEntityRelationInput"]: GraphQLTypes["CleanerUpdateStaffEntityRelationInput"];
	["StaffWithoutCleanerUpdateInput"]: GraphQLTypes["StaffWithoutCleanerUpdateInput"];
	["CleanerUpsertStaffRelationInput"]: GraphQLTypes["CleanerUpsertStaffRelationInput"];
	["CourierCreateInput"]: GraphQLTypes["CourierCreateInput"];
	["CourierUpdateInput"]: GraphQLTypes["CourierUpdateInput"];
	["ShiftsManagerCreateInput"]: GraphQLTypes["ShiftsManagerCreateInput"];
	["ShiftsManagerUpdateInput"]: GraphQLTypes["ShiftsManagerUpdateInput"];
	["UserConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["UserEdge"]>
};
	["UserEdge"]: {
		node: GraphQLTypes["User"]
};
	["ProductIngredientCategoryCreateInput"]: GraphQLTypes["ProductIngredientCategoryCreateInput"];
	["ProductIngredientCategoryUpdateInput"]: GraphQLTypes["ProductIngredientCategoryUpdateInput"];
	["ProductIngredientCategoryLocaleCreateInput"]: GraphQLTypes["ProductIngredientCategoryLocaleCreateInput"];
	["ProductIngredientCategoryLocaleUpdateInput"]: GraphQLTypes["ProductIngredientCategoryLocaleUpdateInput"];
	["StocksManagerConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["StocksManagerEdge"]>
};
	["StocksManagerEdge"]: {
		node: GraphQLTypes["StocksManager"]
};
	["StocksManagerCreateInput"]: GraphQLTypes["StocksManagerCreateInput"];
	["StocksManagerUpdateInput"]: GraphQLTypes["StocksManagerUpdateInput"];
	["DeliveryRouteCreateInput"]: GraphQLTypes["DeliveryRouteCreateInput"];
	["DeliveryRouteUpdateInput"]: GraphQLTypes["DeliveryRouteUpdateInput"];
	["DeliveryWaypointCreateInput"]: GraphQLTypes["DeliveryWaypointCreateInput"];
	["DeliveryWaypointUpdateInput"]: GraphQLTypes["DeliveryWaypointUpdateInput"];
	["AllergenCreateInput"]: GraphQLTypes["AllergenCreateInput"];
	["AllergenUpdateInput"]: GraphQLTypes["AllergenUpdateInput"];
	["AllergenLocaleCreateInput"]: GraphQLTypes["AllergenLocaleCreateInput"];
	["AllergenLocaleUpdateInput"]: GraphQLTypes["AllergenLocaleUpdateInput"];
	["GpsConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GpsEdge"]>
};
	["GpsEdge"]: {
		node: GraphQLTypes["Gps"]
};
	["GpsCreateInput"]: GraphQLTypes["GpsCreateInput"];
	["GpsCreateAddressEntityRelationInput"]: GraphQLTypes["GpsCreateAddressEntityRelationInput"];
	["AddressWithoutGpsCreateInput"]: GraphQLTypes["AddressWithoutGpsCreateInput"];
	["GpsUpdateInput"]: GraphQLTypes["GpsUpdateInput"];
	["GpsUpdateAddressEntityRelationInput"]: GraphQLTypes["GpsUpdateAddressEntityRelationInput"];
	["AddressWithoutGpsUpdateInput"]: GraphQLTypes["AddressWithoutGpsUpdateInput"];
	["GpsUpsertAddressRelationInput"]: GraphQLTypes["GpsUpsertAddressRelationInput"];
	["WeekHoursConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["WeekHoursEdge"]>
};
	["WeekHoursEdge"]: {
		node: GraphQLTypes["WeekHours"]
};
	["PreparedIngredientQuantity"]: {
		_meta?: GraphQLTypes["PreparedIngredientQuantityMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	date: GraphQLTypes["Date"],
	quantity?: number | undefined,
	usedQuantity?: number | undefined,
	ingredient?: GraphQLTypes["ProductIngredient"] | undefined,
	unit?: GraphQLTypes["ProductIngredientItemQuantityUnit"] | undefined
};
	["PreparedIngredientQuantityMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	date?: GraphQLTypes["FieldMeta"] | undefined,
	quantity?: GraphQLTypes["FieldMeta"] | undefined,
	usedQuantity?: GraphQLTypes["FieldMeta"] | undefined,
	ingredient?: GraphQLTypes["FieldMeta"] | undefined,
	unit?: GraphQLTypes["FieldMeta"] | undefined
};
	["PreparedIngredientQuantityUniqueWhere"]: GraphQLTypes["PreparedIngredientQuantityUniqueWhere"];
	["PreparedIngredientQuantityWhere"]: GraphQLTypes["PreparedIngredientQuantityWhere"];
	["PreparedIngredientQuantityOrderBy"]: GraphQLTypes["PreparedIngredientQuantityOrderBy"];
	["PreparedIngredientQuantityConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PreparedIngredientQuantityEdge"]>
};
	["PreparedIngredientQuantityEdge"]: {
		node: GraphQLTypes["PreparedIngredientQuantity"]
};
	["PreparedIngredientQuantityCreateInput"]: GraphQLTypes["PreparedIngredientQuantityCreateInput"];
	["PreparedIngredientQuantityCreateIngredientEntityRelationInput"]: GraphQLTypes["PreparedIngredientQuantityCreateIngredientEntityRelationInput"];
	["PreparedIngredientQuantityCreateUnitEntityRelationInput"]: GraphQLTypes["PreparedIngredientQuantityCreateUnitEntityRelationInput"];
	["PreparedIngredientQuantityUpdateInput"]: GraphQLTypes["PreparedIngredientQuantityUpdateInput"];
	["PreparedIngredientQuantityUpdateIngredientEntityRelationInput"]: GraphQLTypes["PreparedIngredientQuantityUpdateIngredientEntityRelationInput"];
	["PreparedIngredientQuantityUpsertIngredientRelationInput"]: GraphQLTypes["PreparedIngredientQuantityUpsertIngredientRelationInput"];
	["PreparedIngredientQuantityUpdateUnitEntityRelationInput"]: GraphQLTypes["PreparedIngredientQuantityUpdateUnitEntityRelationInput"];
	["PreparedIngredientQuantityUpsertUnitRelationInput"]: GraphQLTypes["PreparedIngredientQuantityUpsertUnitRelationInput"];
	["PreparedRecipeQuantity"]: {
		_meta?: GraphQLTypes["PreparedRecipeQuantityMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	date: GraphQLTypes["Date"],
	quantity?: number | undefined,
	recipe?: GraphQLTypes["ProductRecipe"] | undefined,
	usedQuantity?: number | undefined
};
	["PreparedRecipeQuantityMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	date?: GraphQLTypes["FieldMeta"] | undefined,
	quantity?: GraphQLTypes["FieldMeta"] | undefined,
	recipe?: GraphQLTypes["FieldMeta"] | undefined,
	usedQuantity?: GraphQLTypes["FieldMeta"] | undefined
};
	["PreparedRecipeQuantityUniqueWhere"]: GraphQLTypes["PreparedRecipeQuantityUniqueWhere"];
	["PreparedRecipeQuantityWhere"]: GraphQLTypes["PreparedRecipeQuantityWhere"];
	["PreparedRecipeQuantityOrderBy"]: GraphQLTypes["PreparedRecipeQuantityOrderBy"];
	["PreparedRecipeQuantityConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PreparedRecipeQuantityEdge"]>
};
	["PreparedRecipeQuantityEdge"]: {
		node: GraphQLTypes["PreparedRecipeQuantity"]
};
	["PreparedRecipeQuantityCreateInput"]: GraphQLTypes["PreparedRecipeQuantityCreateInput"];
	["PreparedRecipeQuantityCreateRecipeEntityRelationInput"]: GraphQLTypes["PreparedRecipeQuantityCreateRecipeEntityRelationInput"];
	["PreparedRecipeQuantityUpdateInput"]: GraphQLTypes["PreparedRecipeQuantityUpdateInput"];
	["PreparedRecipeQuantityUpdateRecipeEntityRelationInput"]: GraphQLTypes["PreparedRecipeQuantityUpdateRecipeEntityRelationInput"];
	["PreparedRecipeQuantityUpsertRecipeRelationInput"]: GraphQLTypes["PreparedRecipeQuantityUpsertRecipeRelationInput"];
	["InternalOrder"]: {
		_meta?: GraphQLTypes["InternalOrderMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	state?: GraphQLTypes["InternalOrderState"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	canceledAt?: GraphQLTypes["DateTime"] | undefined,
	targetPlace?: string | undefined,
	note?: string | undefined,
	internalNote?: string | undefined,
	items: Array<GraphQLTypes["InternalOrderItem"]>,
	createdAt: GraphQLTypes["DateTime"],
	paginateItems: GraphQLTypes["InternalOrderItemConnection"]
};
	["InternalOrderMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	state?: GraphQLTypes["FieldMeta"] | undefined,
	fulfilledAt?: GraphQLTypes["FieldMeta"] | undefined,
	canceledAt?: GraphQLTypes["FieldMeta"] | undefined,
	targetPlace?: GraphQLTypes["FieldMeta"] | undefined,
	note?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined
};
	["InternalOrderState"]: GraphQLTypes["InternalOrderState"];
	["InternalOrderItem"]: {
		_meta?: GraphQLTypes["InternalOrderItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	quantity: number,
	internalOrder?: GraphQLTypes["InternalOrder"] | undefined,
	product?: GraphQLTypes["Product"] | undefined
};
	["InternalOrderItemMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	quantity?: GraphQLTypes["FieldMeta"] | undefined,
	internalOrder?: GraphQLTypes["FieldMeta"] | undefined,
	product?: GraphQLTypes["FieldMeta"] | undefined
};
	["InternalOrderWhere"]: GraphQLTypes["InternalOrderWhere"];
	["InternalOrderStateCondition"]: GraphQLTypes["InternalOrderStateCondition"];
	["InternalOrderItemWhere"]: GraphQLTypes["InternalOrderItemWhere"];
	["InternalOrderItemOrderBy"]: GraphQLTypes["InternalOrderItemOrderBy"];
	["InternalOrderOrderBy"]: GraphQLTypes["InternalOrderOrderBy"];
	["InternalOrderItemConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["InternalOrderItemEdge"]>
};
	["InternalOrderItemEdge"]: {
		node: GraphQLTypes["InternalOrderItem"]
};
	["InternalOrderUniqueWhere"]: GraphQLTypes["InternalOrderUniqueWhere"];
	["InternalOrderItemUniqueWhere"]: GraphQLTypes["InternalOrderItemUniqueWhere"];
	["InternalOrderConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["InternalOrderEdge"]>
};
	["InternalOrderEdge"]: {
		node: GraphQLTypes["InternalOrder"]
};
	["InternalOrderCreateInput"]: GraphQLTypes["InternalOrderCreateInput"];
	["InternalOrderCreateItemsEntityRelationInput"]: GraphQLTypes["InternalOrderCreateItemsEntityRelationInput"];
	["InternalOrderItemWithoutInternalOrderCreateInput"]: GraphQLTypes["InternalOrderItemWithoutInternalOrderCreateInput"];
	["InternalOrderItemCreateProductEntityRelationInput"]: GraphQLTypes["InternalOrderItemCreateProductEntityRelationInput"];
	["InternalOrderUpdateInput"]: GraphQLTypes["InternalOrderUpdateInput"];
	["InternalOrderUpdateItemsEntityRelationInput"]: GraphQLTypes["InternalOrderUpdateItemsEntityRelationInput"];
	["InternalOrderUpdateItemsRelationInput"]: GraphQLTypes["InternalOrderUpdateItemsRelationInput"];
	["InternalOrderItemWithoutInternalOrderUpdateInput"]: GraphQLTypes["InternalOrderItemWithoutInternalOrderUpdateInput"];
	["InternalOrderItemUpdateProductEntityRelationInput"]: GraphQLTypes["InternalOrderItemUpdateProductEntityRelationInput"];
	["InternalOrderItemUpsertProductRelationInput"]: GraphQLTypes["InternalOrderItemUpsertProductRelationInput"];
	["InternalOrderUpsertItemsRelationInput"]: GraphQLTypes["InternalOrderUpsertItemsRelationInput"];
	["InternalOrderItemCreateInput"]: GraphQLTypes["InternalOrderItemCreateInput"];
	["InternalOrderItemCreateInternalOrderEntityRelationInput"]: GraphQLTypes["InternalOrderItemCreateInternalOrderEntityRelationInput"];
	["InternalOrderWithoutItemsCreateInput"]: GraphQLTypes["InternalOrderWithoutItemsCreateInput"];
	["InternalOrderItemUpdateInput"]: GraphQLTypes["InternalOrderItemUpdateInput"];
	["InternalOrderItemUpdateInternalOrderEntityRelationInput"]: GraphQLTypes["InternalOrderItemUpdateInternalOrderEntityRelationInput"];
	["InternalOrderWithoutItemsUpdateInput"]: GraphQLTypes["InternalOrderWithoutItemsUpdateInput"];
	["InternalOrderItemUpsertInternalOrderRelationInput"]: GraphQLTypes["InternalOrderItemUpsertInternalOrderRelationInput"];
	["PreparedPackingQuantityCreateInput"]: GraphQLTypes["PreparedPackingQuantityCreateInput"];
	["PreparedPackingQuantityCreatePackingEntityRelationInput"]: GraphQLTypes["PreparedPackingQuantityCreatePackingEntityRelationInput"];
	["ProductPackingWithoutPreparedPackingQuantitiesCreateInput"]: GraphQLTypes["ProductPackingWithoutPreparedPackingQuantitiesCreateInput"];
	["PreparedPackingQuantityUpdateInput"]: GraphQLTypes["PreparedPackingQuantityUpdateInput"];
	["PreparedPackingQuantityUpdatePackingEntityRelationInput"]: GraphQLTypes["PreparedPackingQuantityUpdatePackingEntityRelationInput"];
	["ProductPackingWithoutPreparedPackingQuantitiesUpdateInput"]: GraphQLTypes["ProductPackingWithoutPreparedPackingQuantitiesUpdateInput"];
	["PreparedPackingQuantityUpsertPackingRelationInput"]: GraphQLTypes["PreparedPackingQuantityUpsertPackingRelationInput"];
	["CourierManagerConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CourierManagerEdge"]>
};
	["CourierManagerEdge"]: {
		node: GraphQLTypes["CourierManager"]
};
	["CourierManagerCreateInput"]: GraphQLTypes["CourierManagerCreateInput"];
	["CourierManagerCreateStaffEntityRelationInput"]: GraphQLTypes["CourierManagerCreateStaffEntityRelationInput"];
	["StaffWithoutCourierManagerCreateInput"]: GraphQLTypes["StaffWithoutCourierManagerCreateInput"];
	["CourierManagerUpdateInput"]: GraphQLTypes["CourierManagerUpdateInput"];
	["CourierManagerUpdateStaffEntityRelationInput"]: GraphQLTypes["CourierManagerUpdateStaffEntityRelationInput"];
	["StaffWithoutCourierManagerUpdateInput"]: GraphQLTypes["StaffWithoutCourierManagerUpdateInput"];
	["CourierManagerUpsertStaffRelationInput"]: GraphQLTypes["CourierManagerUpsertStaffRelationInput"];
	["DeliveryZoneCreateInput"]: GraphQLTypes["DeliveryZoneCreateInput"];
	["DeliveryZoneUpdateInput"]: GraphQLTypes["DeliveryZoneUpdateInput"];
	["DeliveryTimelinePresetConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DeliveryTimelinePresetEdge"]>
};
	["DeliveryTimelinePresetEdge"]: {
		node: GraphQLTypes["DeliveryTimelinePreset"]
};
	["DeliveryTimelinePresetCreateInput"]: GraphQLTypes["DeliveryTimelinePresetCreateInput"];
	["DeliveryTimelinePresetCreateDeliveryMethodEntityRelationInput"]: GraphQLTypes["DeliveryTimelinePresetCreateDeliveryMethodEntityRelationInput"];
	["DeliveryMethodWithoutTimelinePresetCreateInput"]: GraphQLTypes["DeliveryMethodWithoutTimelinePresetCreateInput"];
	["DeliveryTimelinePresetUpdateInput"]: GraphQLTypes["DeliveryTimelinePresetUpdateInput"];
	["DeliveryTimelinePresetUpdateDeliveryMethodEntityRelationInput"]: GraphQLTypes["DeliveryTimelinePresetUpdateDeliveryMethodEntityRelationInput"];
	["DeliveryMethodWithoutTimelinePresetUpdateInput"]: GraphQLTypes["DeliveryMethodWithoutTimelinePresetUpdateInput"];
	["DeliveryTimelinePresetUpsertDeliveryMethodRelationInput"]: GraphQLTypes["DeliveryTimelinePresetUpsertDeliveryMethodRelationInput"];
	["OrderDeliveryTimeline"]: {
		_meta?: GraphQLTypes["OrderDeliveryTimelineMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["DeliveryTimelineType"],
	prepareAt: GraphQLTypes["DateTime"],
	loadingHours?: number | undefined,
	dispatchAt: GraphQLTypes["DateTime"],
	duration?: string | undefined,
	window?: string | undefined,
	expectedEndAt?: GraphQLTypes["DateTime"] | undefined,
	expectedAt: GraphQLTypes["DateTime"]
};
	["OrderDeliveryTimelineMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	prepareAt?: GraphQLTypes["FieldMeta"] | undefined,
	loadingHours?: GraphQLTypes["FieldMeta"] | undefined,
	dispatchAt?: GraphQLTypes["FieldMeta"] | undefined,
	duration?: GraphQLTypes["FieldMeta"] | undefined,
	window?: GraphQLTypes["FieldMeta"] | undefined,
	expectedEndAt?: GraphQLTypes["FieldMeta"] | undefined,
	expectedAt?: GraphQLTypes["FieldMeta"] | undefined
};
	["OrderDeliveryTimelineUniqueWhere"]: GraphQLTypes["OrderDeliveryTimelineUniqueWhere"];
	["OrderDeliveryTimelineWhere"]: GraphQLTypes["OrderDeliveryTimelineWhere"];
	["OrderDeliveryTimelineOrderBy"]: GraphQLTypes["OrderDeliveryTimelineOrderBy"];
	["OrderDeliveryTimelineConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["OrderDeliveryTimelineEdge"]>
};
	["OrderDeliveryTimelineEdge"]: {
		node: GraphQLTypes["OrderDeliveryTimeline"]
};
	["OrderDeliveryTimelineCreateInput"]: GraphQLTypes["OrderDeliveryTimelineCreateInput"];
	["OrderDeliveryTimelineUpdateInput"]: GraphQLTypes["OrderDeliveryTimelineUpdateInput"];
	["OrderEventCreateInput"]: GraphQLTypes["OrderEventCreateInput"];
	["OrderEventUpdateInput"]: GraphQLTypes["OrderEventUpdateInput"];
	["LiftagoRideConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LiftagoRideEdge"]>
};
	["LiftagoRideEdge"]: {
		node: GraphQLTypes["LiftagoRide"]
};
	["LiftagoRideCreateInput"]: GraphQLTypes["LiftagoRideCreateInput"];
	["LiftagoRideCreateDeliveryEntityRelationInput"]: GraphQLTypes["LiftagoRideCreateDeliveryEntityRelationInput"];
	["OrderDeliveryWithoutLiftagoRideCreateInput"]: GraphQLTypes["OrderDeliveryWithoutLiftagoRideCreateInput"];
	["LiftagoRideUpdateInput"]: GraphQLTypes["LiftagoRideUpdateInput"];
	["LiftagoRideUpdateDeliveryEntityRelationInput"]: GraphQLTypes["LiftagoRideUpdateDeliveryEntityRelationInput"];
	["OrderDeliveryWithoutLiftagoRideUpdateInput"]: GraphQLTypes["OrderDeliveryWithoutLiftagoRideUpdateInput"];
	["LiftagoRideUpsertDeliveryRelationInput"]: GraphQLTypes["LiftagoRideUpsertDeliveryRelationInput"];
	["InvoiceCreateInput"]: GraphQLTypes["InvoiceCreateInput"];
	["InvoiceUpdateInput"]: GraphQLTypes["InvoiceUpdateInput"];
	["InvoicingPlanConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["InvoicingPlanEdge"]>
};
	["InvoicingPlanEdge"]: {
		node: GraphQLTypes["InvoicingPlan"]
};
	["InvoicingPlanCreateInput"]: GraphQLTypes["InvoicingPlanCreateInput"];
	["InvoicingPlanCreateCustomerEntityRelationInput"]: GraphQLTypes["InvoicingPlanCreateCustomerEntityRelationInput"];
	["CustomerWithoutInvoicingPlanCreateInput"]: GraphQLTypes["CustomerWithoutInvoicingPlanCreateInput"];
	["InvoicingPlanUpdateInput"]: GraphQLTypes["InvoicingPlanUpdateInput"];
	["InvoicingPlanUpdateCustomerEntityRelationInput"]: GraphQLTypes["InvoicingPlanUpdateCustomerEntityRelationInput"];
	["CustomerWithoutInvoicingPlanUpdateInput"]: GraphQLTypes["CustomerWithoutInvoicingPlanUpdateInput"];
	["InvoicingPlanUpsertCustomerRelationInput"]: GraphQLTypes["InvoicingPlanUpsertCustomerRelationInput"];
	["ProductPackingLocaleCreateInput"]: GraphQLTypes["ProductPackingLocaleCreateInput"];
	["ProductPackingLocaleUpdateInput"]: GraphQLTypes["ProductPackingLocaleUpdateInput"];
	["ProductLocaleCreateInput"]: GraphQLTypes["ProductLocaleCreateInput"];
	["ProductLocaleUpdateInput"]: GraphQLTypes["ProductLocaleUpdateInput"];
	["ProductRecipeLocaleCreateInput"]: GraphQLTypes["ProductRecipeLocaleCreateInput"];
	["ProductRecipeLocaleUpdateInput"]: GraphQLTypes["ProductRecipeLocaleUpdateInput"];
	["UserDeviceCreateInput"]: GraphQLTypes["UserDeviceCreateInput"];
	["UserDeviceUpdateInput"]: GraphQLTypes["UserDeviceUpdateInput"];
	["ProtectedAction"]: {
		_meta?: GraphQLTypes["ProtectedActionMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["ProtectedActionType"],
	data?: GraphQLTypes["Json"] | undefined,
	publicKey: string,
	secretKeyHash: string,
	confirmKeyHash?: string | undefined,
	url?: string | undefined,
	createdAt: GraphQLTypes["DateTime"],
	expiresAt?: GraphQLTypes["DateTime"] | undefined,
	usedAt?: GraphQLTypes["DateTime"] | undefined,
	service?: string | undefined
};
	["ProtectedActionMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	data?: GraphQLTypes["FieldMeta"] | undefined,
	publicKey?: GraphQLTypes["FieldMeta"] | undefined,
	secretKeyHash?: GraphQLTypes["FieldMeta"] | undefined,
	confirmKeyHash?: GraphQLTypes["FieldMeta"] | undefined,
	url?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	expiresAt?: GraphQLTypes["FieldMeta"] | undefined,
	usedAt?: GraphQLTypes["FieldMeta"] | undefined,
	service?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProtectedActionType"]: GraphQLTypes["ProtectedActionType"];
	["ProtectedActionUniqueWhere"]: GraphQLTypes["ProtectedActionUniqueWhere"];
	["ProtectedActionWhere"]: GraphQLTypes["ProtectedActionWhere"];
	["ProtectedActionTypeCondition"]: GraphQLTypes["ProtectedActionTypeCondition"];
	["ProtectedActionOrderBy"]: GraphQLTypes["ProtectedActionOrderBy"];
	["ProtectedActionConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProtectedActionEdge"]>
};
	["ProtectedActionEdge"]: {
		node: GraphQLTypes["ProtectedAction"]
};
	["ProtectedActionCreateInput"]: GraphQLTypes["ProtectedActionCreateInput"];
	["ProtectedActionUpdateInput"]: GraphQLTypes["ProtectedActionUpdateInput"];
	["PickerConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PickerEdge"]>
};
	["PickerEdge"]: {
		node: GraphQLTypes["Picker"]
};
	["PickerCreateInput"]: GraphQLTypes["PickerCreateInput"];
	["PickerCreateStaffEntityRelationInput"]: GraphQLTypes["PickerCreateStaffEntityRelationInput"];
	["StaffWithoutPickerCreateInput"]: GraphQLTypes["StaffWithoutPickerCreateInput"];
	["PickerUpdateInput"]: GraphQLTypes["PickerUpdateInput"];
	["PickerUpdateStaffEntityRelationInput"]: GraphQLTypes["PickerUpdateStaffEntityRelationInput"];
	["StaffWithoutPickerUpdateInput"]: GraphQLTypes["StaffWithoutPickerUpdateInput"];
	["PickerUpsertStaffRelationInput"]: GraphQLTypes["PickerUpsertStaffRelationInput"];
	["TenantPerson"]: {
		_meta?: GraphQLTypes["TenantPersonMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	email?: string | undefined,
	externalIdentifier?: string | undefined,
	personId: GraphQLTypes["UUID"],
	identityId: GraphQLTypes["UUID"],
	globalRoles?: GraphQLTypes["Json"] | undefined,
	projectRoles?: GraphQLTypes["Json"] | undefined,
	projectRolesString?: string | undefined,
	externalIdentifiers?: GraphQLTypes["Json"] | undefined,
	externalIdentifiersString?: string | undefined
};
	["TenantPersonMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	email?: GraphQLTypes["FieldMeta"] | undefined,
	externalIdentifier?: GraphQLTypes["FieldMeta"] | undefined,
	personId?: GraphQLTypes["FieldMeta"] | undefined,
	identityId?: GraphQLTypes["FieldMeta"] | undefined,
	globalRoles?: GraphQLTypes["FieldMeta"] | undefined,
	projectRoles?: GraphQLTypes["FieldMeta"] | undefined,
	projectRolesString?: GraphQLTypes["FieldMeta"] | undefined,
	externalIdentifiers?: GraphQLTypes["FieldMeta"] | undefined,
	externalIdentifiersString?: GraphQLTypes["FieldMeta"] | undefined
};
	["TenantPersonUniqueWhere"]: GraphQLTypes["TenantPersonUniqueWhere"];
	["TenantPersonWhere"]: GraphQLTypes["TenantPersonWhere"];
	["TenantPersonOrderBy"]: GraphQLTypes["TenantPersonOrderBy"];
	["TenantPersonConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TenantPersonEdge"]>
};
	["TenantPersonEdge"]: {
		node: GraphQLTypes["TenantPerson"]
};
	["TimetableTemplateStaffOptionsCreateInput"]: GraphQLTypes["TimetableTemplateStaffOptionsCreateInput"];
	["TimetableTemplateStaffOptionsCreateTimetableTemplateEntityRelationInput"]: GraphQLTypes["TimetableTemplateStaffOptionsCreateTimetableTemplateEntityRelationInput"];
	["TimetableTemplateWithoutStaffOptionsCreateInput"]: GraphQLTypes["TimetableTemplateWithoutStaffOptionsCreateInput"];
	["TimetableTemplateStaffOptionsUpdateInput"]: GraphQLTypes["TimetableTemplateStaffOptionsUpdateInput"];
	["TimetableTemplateStaffOptionsUpdateTimetableTemplateEntityRelationInput"]: GraphQLTypes["TimetableTemplateStaffOptionsUpdateTimetableTemplateEntityRelationInput"];
	["TimetableTemplateWithoutStaffOptionsUpdateInput"]: GraphQLTypes["TimetableTemplateWithoutStaffOptionsUpdateInput"];
	["TimetableTemplateStaffOptionsUpsertTimetableTemplateRelationInput"]: GraphQLTypes["TimetableTemplateStaffOptionsUpsertTimetableTemplateRelationInput"];
	["ShoppingList"]: {
		_meta?: GraphQLTypes["ShoppingListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt: GraphQLTypes["DateTime"],
	items: Array<GraphQLTypes["ShoppingListItem"]>,
	supplier?: GraphQLTypes["IngredientSupplier"] | undefined,
	paginateItems: GraphQLTypes["ShoppingListItemConnection"]
};
	["ShoppingListMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined,
	supplier?: GraphQLTypes["FieldMeta"] | undefined
};
	["ShoppingListItem"]: {
		_meta?: GraphQLTypes["ShoppingListItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	amount?: number | undefined,
	list?: GraphQLTypes["ShoppingList"] | undefined,
	ingredient?: GraphQLTypes["ProductIngredient"] | undefined,
	preferredUnit?: GraphQLTypes["ProductIngredientItemQuantityUnit"] | undefined,
	wasPurcahsed?: boolean | undefined,
	wasTransferred?: boolean | undefined
};
	["ShoppingListItemMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	amount?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	ingredient?: GraphQLTypes["FieldMeta"] | undefined,
	preferredUnit?: GraphQLTypes["FieldMeta"] | undefined,
	wasPurcahsed?: GraphQLTypes["FieldMeta"] | undefined,
	wasTransferred?: GraphQLTypes["FieldMeta"] | undefined
};
	["ShoppingListWhere"]: GraphQLTypes["ShoppingListWhere"];
	["ShoppingListItemWhere"]: GraphQLTypes["ShoppingListItemWhere"];
	["ShoppingListItemOrderBy"]: GraphQLTypes["ShoppingListItemOrderBy"];
	["ShoppingListOrderBy"]: GraphQLTypes["ShoppingListOrderBy"];
	["ShoppingListItemConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ShoppingListItemEdge"]>
};
	["ShoppingListItemEdge"]: {
		node: GraphQLTypes["ShoppingListItem"]
};
	["ShoppingListUniqueWhere"]: GraphQLTypes["ShoppingListUniqueWhere"];
	["ShoppingListItemUniqueWhere"]: GraphQLTypes["ShoppingListItemUniqueWhere"];
	["ShoppingListConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ShoppingListEdge"]>
};
	["ShoppingListEdge"]: {
		node: GraphQLTypes["ShoppingList"]
};
	["ShoppingListCreateInput"]: GraphQLTypes["ShoppingListCreateInput"];
	["ShoppingListCreateItemsEntityRelationInput"]: GraphQLTypes["ShoppingListCreateItemsEntityRelationInput"];
	["ShoppingListItemWithoutListCreateInput"]: GraphQLTypes["ShoppingListItemWithoutListCreateInput"];
	["ShoppingListItemCreateIngredientEntityRelationInput"]: GraphQLTypes["ShoppingListItemCreateIngredientEntityRelationInput"];
	["ShoppingListItemCreatePreferredUnitEntityRelationInput"]: GraphQLTypes["ShoppingListItemCreatePreferredUnitEntityRelationInput"];
	["ShoppingListCreateSupplierEntityRelationInput"]: GraphQLTypes["ShoppingListCreateSupplierEntityRelationInput"];
	["ShoppingListUpdateInput"]: GraphQLTypes["ShoppingListUpdateInput"];
	["ShoppingListUpdateItemsEntityRelationInput"]: GraphQLTypes["ShoppingListUpdateItemsEntityRelationInput"];
	["ShoppingListUpdateItemsRelationInput"]: GraphQLTypes["ShoppingListUpdateItemsRelationInput"];
	["ShoppingListItemWithoutListUpdateInput"]: GraphQLTypes["ShoppingListItemWithoutListUpdateInput"];
	["ShoppingListItemUpdateIngredientEntityRelationInput"]: GraphQLTypes["ShoppingListItemUpdateIngredientEntityRelationInput"];
	["ShoppingListItemUpsertIngredientRelationInput"]: GraphQLTypes["ShoppingListItemUpsertIngredientRelationInput"];
	["ShoppingListItemUpdatePreferredUnitEntityRelationInput"]: GraphQLTypes["ShoppingListItemUpdatePreferredUnitEntityRelationInput"];
	["ShoppingListItemUpsertPreferredUnitRelationInput"]: GraphQLTypes["ShoppingListItemUpsertPreferredUnitRelationInput"];
	["ShoppingListUpsertItemsRelationInput"]: GraphQLTypes["ShoppingListUpsertItemsRelationInput"];
	["ShoppingListUpdateSupplierEntityRelationInput"]: GraphQLTypes["ShoppingListUpdateSupplierEntityRelationInput"];
	["ShoppingListUpsertSupplierRelationInput"]: GraphQLTypes["ShoppingListUpsertSupplierRelationInput"];
	["SuppliesPurchase"]: {
		_meta?: GraphQLTypes["SuppliesPurchaseMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt: GraphQLTypes["DateTime"],
	items: Array<GraphQLTypes["SuppliesPurchaseItem"]>,
	supplier?: GraphQLTypes["IngredientSupplier"] | undefined,
	requestedDeliveryDate?: GraphQLTypes["Date"] | undefined,
	paginateItems: GraphQLTypes["SuppliesPurchaseItemConnection"]
};
	["SuppliesPurchaseMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined,
	supplier?: GraphQLTypes["FieldMeta"] | undefined,
	requestedDeliveryDate?: GraphQLTypes["FieldMeta"] | undefined
};
	["SuppliesPurchaseItem"]: {
		_meta?: GraphQLTypes["SuppliesPurchaseItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	amount?: number | undefined,
	list?: GraphQLTypes["SuppliesPurchase"] | undefined,
	ingredient?: GraphQLTypes["ProductIngredient"] | undefined,
	pricePaidCents?: number | undefined,
	preferredUnit?: GraphQLTypes["ProductIngredientItemQuantityUnit"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	purchasedAt?: GraphQLTypes["DateTime"] | undefined,
	purchasedBy?: GraphQLTypes["Staff"] | undefined
};
	["SuppliesPurchaseItemMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	amount?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	ingredient?: GraphQLTypes["FieldMeta"] | undefined,
	pricePaidCents?: GraphQLTypes["FieldMeta"] | undefined,
	preferredUnit?: GraphQLTypes["FieldMeta"] | undefined,
	deletedAt?: GraphQLTypes["FieldMeta"] | undefined,
	purchasedAt?: GraphQLTypes["FieldMeta"] | undefined,
	purchasedBy?: GraphQLTypes["FieldMeta"] | undefined
};
	["SuppliesPurchaseWhere"]: GraphQLTypes["SuppliesPurchaseWhere"];
	["SuppliesPurchaseItemWhere"]: GraphQLTypes["SuppliesPurchaseItemWhere"];
	["SuppliesPurchaseItemOrderBy"]: GraphQLTypes["SuppliesPurchaseItemOrderBy"];
	["SuppliesPurchaseOrderBy"]: GraphQLTypes["SuppliesPurchaseOrderBy"];
	["SuppliesPurchaseItemConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SuppliesPurchaseItemEdge"]>
};
	["SuppliesPurchaseItemEdge"]: {
		node: GraphQLTypes["SuppliesPurchaseItem"]
};
	["SuppliesPurchaseUniqueWhere"]: GraphQLTypes["SuppliesPurchaseUniqueWhere"];
	["SuppliesPurchaseItemUniqueWhere"]: GraphQLTypes["SuppliesPurchaseItemUniqueWhere"];
	["SuppliesPurchaseConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SuppliesPurchaseEdge"]>
};
	["SuppliesPurchaseEdge"]: {
		node: GraphQLTypes["SuppliesPurchase"]
};
	["SuppliesPurchaseCreateInput"]: GraphQLTypes["SuppliesPurchaseCreateInput"];
	["SuppliesPurchaseCreateItemsEntityRelationInput"]: GraphQLTypes["SuppliesPurchaseCreateItemsEntityRelationInput"];
	["SuppliesPurchaseItemWithoutListCreateInput"]: GraphQLTypes["SuppliesPurchaseItemWithoutListCreateInput"];
	["SuppliesPurchaseItemCreateIngredientEntityRelationInput"]: GraphQLTypes["SuppliesPurchaseItemCreateIngredientEntityRelationInput"];
	["SuppliesPurchaseItemCreatePreferredUnitEntityRelationInput"]: GraphQLTypes["SuppliesPurchaseItemCreatePreferredUnitEntityRelationInput"];
	["SuppliesPurchaseItemCreatePurchasedByEntityRelationInput"]: GraphQLTypes["SuppliesPurchaseItemCreatePurchasedByEntityRelationInput"];
	["SuppliesPurchaseCreateSupplierEntityRelationInput"]: GraphQLTypes["SuppliesPurchaseCreateSupplierEntityRelationInput"];
	["SuppliesPurchaseUpdateInput"]: GraphQLTypes["SuppliesPurchaseUpdateInput"];
	["SuppliesPurchaseUpdateItemsEntityRelationInput"]: GraphQLTypes["SuppliesPurchaseUpdateItemsEntityRelationInput"];
	["SuppliesPurchaseUpdateItemsRelationInput"]: GraphQLTypes["SuppliesPurchaseUpdateItemsRelationInput"];
	["SuppliesPurchaseItemWithoutListUpdateInput"]: GraphQLTypes["SuppliesPurchaseItemWithoutListUpdateInput"];
	["SuppliesPurchaseItemUpdateIngredientEntityRelationInput"]: GraphQLTypes["SuppliesPurchaseItemUpdateIngredientEntityRelationInput"];
	["SuppliesPurchaseItemUpsertIngredientRelationInput"]: GraphQLTypes["SuppliesPurchaseItemUpsertIngredientRelationInput"];
	["SuppliesPurchaseItemUpdatePreferredUnitEntityRelationInput"]: GraphQLTypes["SuppliesPurchaseItemUpdatePreferredUnitEntityRelationInput"];
	["SuppliesPurchaseItemUpsertPreferredUnitRelationInput"]: GraphQLTypes["SuppliesPurchaseItemUpsertPreferredUnitRelationInput"];
	["SuppliesPurchaseItemUpdatePurchasedByEntityRelationInput"]: GraphQLTypes["SuppliesPurchaseItemUpdatePurchasedByEntityRelationInput"];
	["SuppliesPurchaseItemUpsertPurchasedByRelationInput"]: GraphQLTypes["SuppliesPurchaseItemUpsertPurchasedByRelationInput"];
	["SuppliesPurchaseUpsertItemsRelationInput"]: GraphQLTypes["SuppliesPurchaseUpsertItemsRelationInput"];
	["SuppliesPurchaseUpdateSupplierEntityRelationInput"]: GraphQLTypes["SuppliesPurchaseUpdateSupplierEntityRelationInput"];
	["SuppliesPurchaseUpsertSupplierRelationInput"]: GraphQLTypes["SuppliesPurchaseUpsertSupplierRelationInput"];
	["InvoicingPresetConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["InvoicingPresetEdge"]>
};
	["InvoicingPresetEdge"]: {
		node: GraphQLTypes["InvoicingPreset"]
};
	["InvoicingPresetCreateInput"]: GraphQLTypes["InvoicingPresetCreateInput"];
	["InvoicingPresetCreateInvoicingPlanEntityRelationInput"]: GraphQLTypes["InvoicingPresetCreateInvoicingPlanEntityRelationInput"];
	["InvoicingPlanWithoutPresetCreateInput"]: GraphQLTypes["InvoicingPlanWithoutPresetCreateInput"];
	["InvoicingPresetUpdateInput"]: GraphQLTypes["InvoicingPresetUpdateInput"];
	["InvoicingPresetUpdateInvoicingPlanEntityRelationInput"]: GraphQLTypes["InvoicingPresetUpdateInvoicingPlanEntityRelationInput"];
	["InvoicingPlanWithoutPresetUpdateInput"]: GraphQLTypes["InvoicingPlanWithoutPresetUpdateInput"];
	["InvoicingPresetUpsertInvoicingPlanRelationInput"]: GraphQLTypes["InvoicingPresetUpsertInvoicingPlanRelationInput"];
	["LogRecord"]: {
		_meta?: GraphQLTypes["LogRecordMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	level: number,
	type: string,
	message?: string | undefined,
	data?: GraphQLTypes["Json"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	shouldBeResolved?: boolean | undefined,
	resolvedAt?: GraphQLTypes["DateTime"] | undefined,
	resolvedBy?: GraphQLTypes["User"] | undefined
};
	["LogRecordMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	level?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	message?: GraphQLTypes["FieldMeta"] | undefined,
	data?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	shouldBeResolved?: GraphQLTypes["FieldMeta"] | undefined,
	resolvedAt?: GraphQLTypes["FieldMeta"] | undefined,
	resolvedBy?: GraphQLTypes["FieldMeta"] | undefined
};
	["LogRecordUniqueWhere"]: GraphQLTypes["LogRecordUniqueWhere"];
	["LogRecordWhere"]: GraphQLTypes["LogRecordWhere"];
	["LogRecordOrderBy"]: GraphQLTypes["LogRecordOrderBy"];
	["LogRecordConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LogRecordEdge"]>
};
	["LogRecordEdge"]: {
		node: GraphQLTypes["LogRecord"]
};
	["LogRecordCreateInput"]: GraphQLTypes["LogRecordCreateInput"];
	["LogRecordCreateResolvedByEntityRelationInput"]: GraphQLTypes["LogRecordCreateResolvedByEntityRelationInput"];
	["LogRecordUpdateInput"]: GraphQLTypes["LogRecordUpdateInput"];
	["LogRecordUpdateResolvedByEntityRelationInput"]: GraphQLTypes["LogRecordUpdateResolvedByEntityRelationInput"];
	["LogRecordUpsertResolvedByRelationInput"]: GraphQLTypes["LogRecordUpsertResolvedByRelationInput"];
	["ShoppingListItemCreateInput"]: GraphQLTypes["ShoppingListItemCreateInput"];
	["ShoppingListItemCreateListEntityRelationInput"]: GraphQLTypes["ShoppingListItemCreateListEntityRelationInput"];
	["ShoppingListWithoutItemsCreateInput"]: GraphQLTypes["ShoppingListWithoutItemsCreateInput"];
	["ShoppingListItemUpdateInput"]: GraphQLTypes["ShoppingListItemUpdateInput"];
	["ShoppingListItemUpdateListEntityRelationInput"]: GraphQLTypes["ShoppingListItemUpdateListEntityRelationInput"];
	["ShoppingListWithoutItemsUpdateInput"]: GraphQLTypes["ShoppingListWithoutItemsUpdateInput"];
	["ShoppingListItemUpsertListRelationInput"]: GraphQLTypes["ShoppingListItemUpsertListRelationInput"];
	["SuppliesPurchaseItemCreateInput"]: GraphQLTypes["SuppliesPurchaseItemCreateInput"];
	["SuppliesPurchaseItemCreateListEntityRelationInput"]: GraphQLTypes["SuppliesPurchaseItemCreateListEntityRelationInput"];
	["SuppliesPurchaseWithoutItemsCreateInput"]: GraphQLTypes["SuppliesPurchaseWithoutItemsCreateInput"];
	["SuppliesPurchaseItemUpdateInput"]: GraphQLTypes["SuppliesPurchaseItemUpdateInput"];
	["SuppliesPurchaseItemUpdateListEntityRelationInput"]: GraphQLTypes["SuppliesPurchaseItemUpdateListEntityRelationInput"];
	["SuppliesPurchaseWithoutItemsUpdateInput"]: GraphQLTypes["SuppliesPurchaseWithoutItemsUpdateInput"];
	["SuppliesPurchaseItemUpsertListRelationInput"]: GraphQLTypes["SuppliesPurchaseItemUpsertListRelationInput"];
	["CustomerCreditTransactionCreateInput"]: GraphQLTypes["CustomerCreditTransactionCreateInput"];
	["CustomerCreditTransactionUpdateInput"]: GraphQLTypes["CustomerCreditTransactionUpdateInput"];
	["VirtualProductConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["VirtualProductEdge"]>
};
	["VirtualProductEdge"]: {
		node: GraphQLTypes["VirtualProduct"]
};
	["VirtualProductEffectCreateInput"]: GraphQLTypes["VirtualProductEffectCreateInput"];
	["VirtualProductEffectUpdateInput"]: GraphQLTypes["VirtualProductEffectUpdateInput"];
	["ProductMetadataConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductMetadataEdge"]>
};
	["ProductMetadataEdge"]: {
		node: GraphQLTypes["ProductMetadata"]
};
	["EmploymentInformationCreateInput"]: GraphQLTypes["EmploymentInformationCreateInput"];
	["EmploymentInformationCreateRemunerationProfilesEntityRelationInput"]: GraphQLTypes["EmploymentInformationCreateRemunerationProfilesEntityRelationInput"];
	["RemunerationProfileWithoutEmploymentInformationCreateInput"]: GraphQLTypes["RemunerationProfileWithoutEmploymentInformationCreateInput"];
	["RemunerationProfileCreateStaffEntityRelationInput"]: GraphQLTypes["RemunerationProfileCreateStaffEntityRelationInput"];
	["StaffWithoutRemunerationProfileCreateInput"]: GraphQLTypes["StaffWithoutRemunerationProfileCreateInput"];
	["EmploymentInformationUpdateInput"]: GraphQLTypes["EmploymentInformationUpdateInput"];
	["EmploymentInformationUpdateRemunerationProfilesEntityRelationInput"]: GraphQLTypes["EmploymentInformationUpdateRemunerationProfilesEntityRelationInput"];
	["RemunerationProfileWithoutEmploymentInformationUpdateInput"]: GraphQLTypes["RemunerationProfileWithoutEmploymentInformationUpdateInput"];
	["RemunerationProfileUpdateStaffEntityRelationInput"]: GraphQLTypes["RemunerationProfileUpdateStaffEntityRelationInput"];
	["StaffWithoutRemunerationProfileUpdateInput"]: GraphQLTypes["StaffWithoutRemunerationProfileUpdateInput"];
	["RemunerationProfileUpsertStaffRelationInput"]: GraphQLTypes["RemunerationProfileUpsertStaffRelationInput"];
	["EmploymentInformationUpsertRemunerationProfilesRelationInput"]: GraphQLTypes["EmploymentInformationUpsertRemunerationProfilesRelationInput"];
	["RemunerationProfileCreateInput"]: GraphQLTypes["RemunerationProfileCreateInput"];
	["RemunerationProfileUpdateInput"]: GraphQLTypes["RemunerationProfileUpdateInput"];
	["WorkMonthConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["WorkMonthEdge"]>
};
	["WorkMonthEdge"]: {
		node: GraphQLTypes["WorkMonth"]
};
	["WorkMonthCreateInput"]: GraphQLTypes["WorkMonthCreateInput"];
	["WorkMonthCreateRemunerationProfileEntityRelationInput"]: GraphQLTypes["WorkMonthCreateRemunerationProfileEntityRelationInput"];
	["RemunerationProfileWithoutWorkMonthsCreateInput"]: GraphQLTypes["RemunerationProfileWithoutWorkMonthsCreateInput"];
	["WorkMonthUpdateInput"]: GraphQLTypes["WorkMonthUpdateInput"];
	["WorkMonthUpdateRemunerationProfileEntityRelationInput"]: GraphQLTypes["WorkMonthUpdateRemunerationProfileEntityRelationInput"];
	["WorkMonthUpdateRemunerationProfileRelationInput"]: GraphQLTypes["WorkMonthUpdateRemunerationProfileRelationInput"];
	["RemunerationProfileWithoutWorkMonthsUpdateInput"]: GraphQLTypes["RemunerationProfileWithoutWorkMonthsUpdateInput"];
	["WorkMonthUpsertRemunerationProfileRelationInput"]: GraphQLTypes["WorkMonthUpsertRemunerationProfileRelationInput"];
	["SalaryOptions"]: {
		_meta?: GraphQLTypes["SalaryOptionsMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	overtimeMultiplier?: number | undefined,
	publicHolidayMultiplier?: number | undefined,
	weekendMultiplier?: number | undefined,
	unique: GraphQLTypes["One"],
	partTimeMonthlySalaryLimit?: number | undefined
};
	["SalaryOptionsMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	overtimeMultiplier?: GraphQLTypes["FieldMeta"] | undefined,
	publicHolidayMultiplier?: GraphQLTypes["FieldMeta"] | undefined,
	weekendMultiplier?: GraphQLTypes["FieldMeta"] | undefined,
	unique?: GraphQLTypes["FieldMeta"] | undefined,
	partTimeMonthlySalaryLimit?: GraphQLTypes["FieldMeta"] | undefined
};
	["SalaryOptionsUniqueWhere"]: GraphQLTypes["SalaryOptionsUniqueWhere"];
	["SalaryOptionsWhere"]: GraphQLTypes["SalaryOptionsWhere"];
	["SalaryOptionsOrderBy"]: GraphQLTypes["SalaryOptionsOrderBy"];
	["SalaryOptionsConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SalaryOptionsEdge"]>
};
	["SalaryOptionsEdge"]: {
		node: GraphQLTypes["SalaryOptions"]
};
	["SalaryOptionsCreateInput"]: GraphQLTypes["SalaryOptionsCreateInput"];
	["SalaryOptionsUpdateInput"]: GraphQLTypes["SalaryOptionsUpdateInput"];
	["TimetableShiftSwapInfoConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TimetableShiftSwapInfoEdge"]>
};
	["TimetableShiftSwapInfoEdge"]: {
		node: GraphQLTypes["TimetableShiftSwapInfo"]
};
	["TimetableShiftSwapInfoCreateInput"]: GraphQLTypes["TimetableShiftSwapInfoCreateInput"];
	["TimetableShiftSwapInfoCreateShiftEntityRelationInput"]: GraphQLTypes["TimetableShiftSwapInfoCreateShiftEntityRelationInput"];
	["TimetableShiftWithoutSwapInfoCreateInput"]: GraphQLTypes["TimetableShiftWithoutSwapInfoCreateInput"];
	["TimetableShiftSwapInfoUpdateInput"]: GraphQLTypes["TimetableShiftSwapInfoUpdateInput"];
	["TimetableShiftSwapInfoUpdateShiftEntityRelationInput"]: GraphQLTypes["TimetableShiftSwapInfoUpdateShiftEntityRelationInput"];
	["TimetableShiftWithoutSwapInfoUpdateInput"]: GraphQLTypes["TimetableShiftWithoutSwapInfoUpdateInput"];
	["TimetableShiftSwapInfoUpsertShiftRelationInput"]: GraphQLTypes["TimetableShiftSwapInfoUpsertShiftRelationInput"];
	["ProductGridCategoryCreateInput"]: GraphQLTypes["ProductGridCategoryCreateInput"];
	["ProductGridCategoryUpdateInput"]: GraphQLTypes["ProductGridCategoryUpdateInput"];
	["CashierConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CashierEdge"]>
};
	["CashierEdge"]: {
		node: GraphQLTypes["Cashier"]
};
	["CashierCreateInput"]: GraphQLTypes["CashierCreateInput"];
	["CashierCreateStaffEntityRelationInput"]: GraphQLTypes["CashierCreateStaffEntityRelationInput"];
	["StaffWithoutCashierCreateInput"]: GraphQLTypes["StaffWithoutCashierCreateInput"];
	["CashierUpdateInput"]: GraphQLTypes["CashierUpdateInput"];
	["CashierUpdateStaffEntityRelationInput"]: GraphQLTypes["CashierUpdateStaffEntityRelationInput"];
	["StaffWithoutCashierUpdateInput"]: GraphQLTypes["StaffWithoutCashierUpdateInput"];
	["CashierUpsertStaffRelationInput"]: GraphQLTypes["CashierUpsertStaffRelationInput"];
	["PointOfSaleCategoryCreateInput"]: GraphQLTypes["PointOfSaleCategoryCreateInput"];
	["PointOfSaleCategoryUpdateInput"]: GraphQLTypes["PointOfSaleCategoryUpdateInput"];
	["PointOfSaleCategoryLocaleCreateInput"]: GraphQLTypes["PointOfSaleCategoryLocaleCreateInput"];
	["PointOfSaleCategoryLocaleUpdateInput"]: GraphQLTypes["PointOfSaleCategoryLocaleUpdateInput"];
	["PointOfSaleCategoryProductCreateInput"]: GraphQLTypes["PointOfSaleCategoryProductCreateInput"];
	["PointOfSaleCategoryProductUpdateInput"]: GraphQLTypes["PointOfSaleCategoryProductUpdateInput"];
	["PointOfSaleCategoryProductLocaleCreateInput"]: GraphQLTypes["PointOfSaleCategoryProductLocaleCreateInput"];
	["PointOfSaleCategoryProductLocaleUpdateInput"]: GraphQLTypes["PointOfSaleCategoryProductLocaleUpdateInput"];
	["CustomerTabCreateInput"]: GraphQLTypes["CustomerTabCreateInput"];
	["CustomerTabUpdateInput"]: GraphQLTypes["CustomerTabUpdateInput"];
	["CustomerTabItemCreateInput"]: GraphQLTypes["CustomerTabItemCreateInput"];
	["CustomerTabItemCreateTabEntityRelationInput"]: GraphQLTypes["CustomerTabItemCreateTabEntityRelationInput"];
	["CustomerTabWithoutItemsCreateInput"]: GraphQLTypes["CustomerTabWithoutItemsCreateInput"];
	["CustomerTabItemUpdateInput"]: GraphQLTypes["CustomerTabItemUpdateInput"];
	["CustomerTabItemUpdateTabEntityRelationInput"]: GraphQLTypes["CustomerTabItemUpdateTabEntityRelationInput"];
	["CustomerTabWithoutItemsUpdateInput"]: GraphQLTypes["CustomerTabWithoutItemsUpdateInput"];
	["CustomerTabItemUpsertTabRelationInput"]: GraphQLTypes["CustomerTabItemUpsertTabRelationInput"];
	["AnonymousSessionConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["AnonymousSessionEdge"]>
};
	["AnonymousSessionEdge"]: {
		node: GraphQLTypes["AnonymousSession"]
};
	["AnonymousSessionCreateInput"]: GraphQLTypes["AnonymousSessionCreateInput"];
	["AnonymousSessionUpdateInput"]: GraphQLTypes["AnonymousSessionUpdateInput"];
	["VoucherCreateInput"]: GraphQLTypes["VoucherCreateInput"];
	["VoucherUpdateInput"]: GraphQLTypes["VoucherUpdateInput"];
	["VoucherRedemptionCreateInput"]: GraphQLTypes["VoucherRedemptionCreateInput"];
	["VoucherRedemptionUpdateInput"]: GraphQLTypes["VoucherRedemptionUpdateInput"];
	["UnassignedShiftInfoConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["UnassignedShiftInfoEdge"]>
};
	["UnassignedShiftInfoEdge"]: {
		node: GraphQLTypes["UnassignedShiftInfo"]
};
	["UnassignedShiftInfoCreateInput"]: GraphQLTypes["UnassignedShiftInfoCreateInput"];
	["UnassignedShiftInfoCreateQueueItemEntityRelationInput"]: GraphQLTypes["UnassignedShiftInfoCreateQueueItemEntityRelationInput"];
	["EmployeeQueueItemWithoutUnassignInfoCreateInput"]: GraphQLTypes["EmployeeQueueItemWithoutUnassignInfoCreateInput"];
	["UnassignedShiftInfoUpdateInput"]: GraphQLTypes["UnassignedShiftInfoUpdateInput"];
	["UnassignedShiftInfoUpdateQueueItemEntityRelationInput"]: GraphQLTypes["UnassignedShiftInfoUpdateQueueItemEntityRelationInput"];
	["EmployeeQueueItemWithoutUnassignInfoUpdateInput"]: GraphQLTypes["EmployeeQueueItemWithoutUnassignInfoUpdateInput"];
	["UnassignedShiftInfoUpsertQueueItemRelationInput"]: GraphQLTypes["UnassignedShiftInfoUpsertQueueItemRelationInput"];
	["TextItemCreateInput"]: GraphQLTypes["TextItemCreateInput"];
	["TextItemCreateListEntityRelationInput"]: GraphQLTypes["TextItemCreateListEntityRelationInput"];
	["TextListWithoutItemsCreateInput"]: GraphQLTypes["TextListWithoutItemsCreateInput"];
	["TextItemUpdateInput"]: GraphQLTypes["TextItemUpdateInput"];
	["TextItemUpdateListEntityRelationInput"]: GraphQLTypes["TextItemUpdateListEntityRelationInput"];
	["TextListWithoutItemsUpdateInput"]: GraphQLTypes["TextListWithoutItemsUpdateInput"];
	["TextItemUpsertListRelationInput"]: GraphQLTypes["TextItemUpsertListRelationInput"];
	["TextListConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TextListEdge"]>
};
	["TextListEdge"]: {
		node: GraphQLTypes["TextList"]
};
	["EmployeeQueueItemMetadataConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["EmployeeQueueItemMetadataEdge"]>
};
	["EmployeeQueueItemMetadataEdge"]: {
		node: GraphQLTypes["EmployeeQueueItemMetadata"]
};
	["DeliveryRegionsConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DeliveryRegionsEdge"]>
};
	["DeliveryRegionsEdge"]: {
		node: GraphQLTypes["DeliveryRegions"]
};
	["DeliveryRegionsItemCreateInput"]: GraphQLTypes["DeliveryRegionsItemCreateInput"];
	["DeliveryRegionsItemCreateListEntityRelationInput"]: GraphQLTypes["DeliveryRegionsItemCreateListEntityRelationInput"];
	["DeliveryRegionsWithoutItemsCreateInput"]: GraphQLTypes["DeliveryRegionsWithoutItemsCreateInput"];
	["DeliveryRegionsItemUpdateInput"]: GraphQLTypes["DeliveryRegionsItemUpdateInput"];
	["DeliveryRegionsItemUpdateListEntityRelationInput"]: GraphQLTypes["DeliveryRegionsItemUpdateListEntityRelationInput"];
	["DeliveryRegionsWithoutItemsUpdateInput"]: GraphQLTypes["DeliveryRegionsWithoutItemsUpdateInput"];
	["DeliveryRegionsItemUpsertListRelationInput"]: GraphQLTypes["DeliveryRegionsItemUpsertListRelationInput"];
	["ImageListConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ImageListEdge"]>
};
	["ImageListEdge"]: {
		node: GraphQLTypes["ImageList"]
};
	["ImageListItemCreateInput"]: GraphQLTypes["ImageListItemCreateInput"];
	["ImageListItemCreateListEntityRelationInput"]: GraphQLTypes["ImageListItemCreateListEntityRelationInput"];
	["ImageListWithoutItemsCreateInput"]: GraphQLTypes["ImageListWithoutItemsCreateInput"];
	["ImageListItemUpdateInput"]: GraphQLTypes["ImageListItemUpdateInput"];
	["ImageListItemUpdateListEntityRelationInput"]: GraphQLTypes["ImageListItemUpdateListEntityRelationInput"];
	["ImageListWithoutItemsUpdateInput"]: GraphQLTypes["ImageListWithoutItemsUpdateInput"];
	["ImageListItemUpsertListRelationInput"]: GraphQLTypes["ImageListItemUpsertListRelationInput"];
	["TimetablesEmployeePrivilegesConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TimetablesEmployeePrivilegesEdge"]>
};
	["TimetablesEmployeePrivilegesEdge"]: {
		node: GraphQLTypes["TimetablesEmployeePrivileges"]
};
	["TimetablesEmployeePrivilegesCreateInput"]: GraphQLTypes["TimetablesEmployeePrivilegesCreateInput"];
	["TimetablesEmployeePrivilegesCreateVenueEmployeeRoleEntityRelationInput"]: GraphQLTypes["TimetablesEmployeePrivilegesCreateVenueEmployeeRoleEntityRelationInput"];
	["VenueEmployeeRoleWithoutEmployeePrivilegesCreateInput"]: GraphQLTypes["VenueEmployeeRoleWithoutEmployeePrivilegesCreateInput"];
	["VenueEmployeeRoleCreateVenueEntityRelationInput"]: GraphQLTypes["VenueEmployeeRoleCreateVenueEntityRelationInput"];
	["VenueWithoutEmployeeRolesCreateInput"]: GraphQLTypes["VenueWithoutEmployeeRolesCreateInput"];
	["TimetablesEmployeePrivilegesUpdateInput"]: GraphQLTypes["TimetablesEmployeePrivilegesUpdateInput"];
	["TimetablesEmployeePrivilegesUpdateVenueEmployeeRoleEntityRelationInput"]: GraphQLTypes["TimetablesEmployeePrivilegesUpdateVenueEmployeeRoleEntityRelationInput"];
	["VenueEmployeeRoleWithoutEmployeePrivilegesUpdateInput"]: GraphQLTypes["VenueEmployeeRoleWithoutEmployeePrivilegesUpdateInput"];
	["VenueEmployeeRoleUpdateVenueEntityRelationInput"]: GraphQLTypes["VenueEmployeeRoleUpdateVenueEntityRelationInput"];
	["VenueWithoutEmployeeRolesUpdateInput"]: GraphQLTypes["VenueWithoutEmployeeRolesUpdateInput"];
	["VenueEmployeeRoleUpsertVenueRelationInput"]: GraphQLTypes["VenueEmployeeRoleUpsertVenueRelationInput"];
	["TimetablesEmployeePrivilegesUpsertVenueEmployeeRoleRelationInput"]: GraphQLTypes["TimetablesEmployeePrivilegesUpsertVenueEmployeeRoleRelationInput"];
	["TimetableDayNoteCreateInput"]: GraphQLTypes["TimetableDayNoteCreateInput"];
	["TimetableDayNoteCreateDayEntityRelationInput"]: GraphQLTypes["TimetableDayNoteCreateDayEntityRelationInput"];
	["TimetableDayWithoutNotesCreateInput"]: GraphQLTypes["TimetableDayWithoutNotesCreateInput"];
	["TimetableDayNoteUpdateInput"]: GraphQLTypes["TimetableDayNoteUpdateInput"];
	["TimetableDayNoteUpdateDayEntityRelationInput"]: GraphQLTypes["TimetableDayNoteUpdateDayEntityRelationInput"];
	["TimetableDayWithoutNotesUpdateInput"]: GraphQLTypes["TimetableDayWithoutNotesUpdateInput"];
	["TimetableDayNoteUpsertDayRelationInput"]: GraphQLTypes["TimetableDayNoteUpsertDayRelationInput"];
	["DeliveryMethodLocaleCreateInput"]: GraphQLTypes["DeliveryMethodLocaleCreateInput"];
	["DeliveryMethodLocaleUpdateInput"]: GraphQLTypes["DeliveryMethodLocaleUpdateInput"];
	["IngredientSupplierConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["IngredientSupplierEdge"]>
};
	["IngredientSupplierEdge"]: {
		node: GraphQLTypes["IngredientSupplier"]
};
	["IngredientSupplierItemCreateInput"]: GraphQLTypes["IngredientSupplierItemCreateInput"];
	["IngredientSupplierItemCreateListEntityRelationInput"]: GraphQLTypes["IngredientSupplierItemCreateListEntityRelationInput"];
	["IngredientSupplierListWithoutItemsCreateInput"]: GraphQLTypes["IngredientSupplierListWithoutItemsCreateInput"];
	["IngredientSupplierItemUpdateInput"]: GraphQLTypes["IngredientSupplierItemUpdateInput"];
	["IngredientSupplierItemUpdateListEntityRelationInput"]: GraphQLTypes["IngredientSupplierItemUpdateListEntityRelationInput"];
	["IngredientSupplierListWithoutItemsUpdateInput"]: GraphQLTypes["IngredientSupplierListWithoutItemsUpdateInput"];
	["IngredientSupplierItemUpsertListRelationInput"]: GraphQLTypes["IngredientSupplierItemUpsertListRelationInput"];
	["IngredientSupplierListConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["IngredientSupplierListEdge"]>
};
	["IngredientSupplierListEdge"]: {
		node: GraphQLTypes["IngredientSupplierList"]
};
	["IngredientSupplierLocaleCreateInput"]: GraphQLTypes["IngredientSupplierLocaleCreateInput"];
	["IngredientSupplierLocaleUpdateInput"]: GraphQLTypes["IngredientSupplierLocaleUpdateInput"];
	["RedirectConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["RedirectEdge"]>
};
	["RedirectEdge"]: {
		node: GraphQLTypes["Redirect"]
};
	["RedirectCreateInput"]: GraphQLTypes["RedirectCreateInput"];
	["RedirectCreateLinkEntityRelationInput"]: GraphQLTypes["RedirectCreateLinkEntityRelationInput"];
	["LinkableWithoutRedirectCreateInput"]: GraphQLTypes["LinkableWithoutRedirectCreateInput"];
	["RedirectUpdateInput"]: GraphQLTypes["RedirectUpdateInput"];
	["RedirectUpdateLinkEntityRelationInput"]: GraphQLTypes["RedirectUpdateLinkEntityRelationInput"];
	["LinkableWithoutRedirectUpdateInput"]: GraphQLTypes["LinkableWithoutRedirectUpdateInput"];
	["RedirectUpsertLinkRelationInput"]: GraphQLTypes["RedirectUpsertLinkRelationInput"];
	["NutritionFactsConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["NutritionFactsEdge"]>
};
	["NutritionFactsEdge"]: {
		node: GraphQLTypes["NutritionFacts"]
};
	["VenueCreateInput"]: GraphQLTypes["VenueCreateInput"];
	["VenueUpdateInput"]: GraphQLTypes["VenueUpdateInput"];
	["WorkspaceConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["WorkspaceEdge"]>
};
	["WorkspaceEdge"]: {
		node: GraphQLTypes["Workspace"]
};
	["WorkspaceCreateInput"]: GraphQLTypes["WorkspaceCreateInput"];
	["WorkspaceCreateFreshingContainersEntityRelationInput"]: GraphQLTypes["WorkspaceCreateFreshingContainersEntityRelationInput"];
	["FreshingContainerWithoutWorkspaceCreateInput"]: GraphQLTypes["FreshingContainerWithoutWorkspaceCreateInput"];
	["WorkspaceUpdateInput"]: GraphQLTypes["WorkspaceUpdateInput"];
	["WorkspaceUpdateFreshingContainersEntityRelationInput"]: GraphQLTypes["WorkspaceUpdateFreshingContainersEntityRelationInput"];
	["WorkspaceUpdateFreshingContainersRelationInput"]: GraphQLTypes["WorkspaceUpdateFreshingContainersRelationInput"];
	["FreshingContainerWithoutWorkspaceUpdateInput"]: GraphQLTypes["FreshingContainerWithoutWorkspaceUpdateInput"];
	["WorkspaceUpsertFreshingContainersRelationInput"]: GraphQLTypes["WorkspaceUpsertFreshingContainersRelationInput"];
	["InternalBuyerConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["InternalBuyerEdge"]>
};
	["InternalBuyerEdge"]: {
		node: GraphQLTypes["InternalBuyer"]
};
	["InternalBuyerCreateInput"]: GraphQLTypes["InternalBuyerCreateInput"];
	["InternalBuyerCreateStaffEntityRelationInput"]: GraphQLTypes["InternalBuyerCreateStaffEntityRelationInput"];
	["StaffWithoutInternalBuyerCreateInput"]: GraphQLTypes["StaffWithoutInternalBuyerCreateInput"];
	["InternalBuyerUpdateInput"]: GraphQLTypes["InternalBuyerUpdateInput"];
	["InternalBuyerUpdateStaffEntityRelationInput"]: GraphQLTypes["InternalBuyerUpdateStaffEntityRelationInput"];
	["StaffWithoutInternalBuyerUpdateInput"]: GraphQLTypes["StaffWithoutInternalBuyerUpdateInput"];
	["InternalBuyerUpsertStaffRelationInput"]: GraphQLTypes["InternalBuyerUpsertStaffRelationInput"];
	["CartSummaryConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CartSummaryEdge"]>
};
	["CartSummaryEdge"]: {
		node: GraphQLTypes["CartSummary"]
};
	["OrderSummaryConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["OrderSummaryEdge"]>
};
	["OrderSummaryEdge"]: {
		node: GraphQLTypes["OrderSummary"]
};
	["CustomerSpendingConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CustomerSpendingEdge"]>
};
	["CustomerSpendingEdge"]: {
		node: GraphQLTypes["CustomerSpending"]
};
	["OrderPaymentMetadataConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["OrderPaymentMetadataEdge"]>
};
	["OrderPaymentMetadataEdge"]: {
		node: GraphQLTypes["OrderPaymentMetadata"]
};
	["UserMetadataConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["UserMetadataEdge"]>
};
	["UserMetadataEdge"]: {
		node: GraphQLTypes["UserMetadata"]
};
	["CustomerTabMetadataConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CustomerTabMetadataEdge"]>
};
	["CustomerTabMetadataEdge"]: {
		node: GraphQLTypes["CustomerTabMetadata"]
};
	["VenueEmployeeRoleCreateInput"]: GraphQLTypes["VenueEmployeeRoleCreateInput"];
	["VenueEmployeeRoleUpdateInput"]: GraphQLTypes["VenueEmployeeRoleUpdateInput"];
	["IdentificationAttemptCreateInput"]: GraphQLTypes["IdentificationAttemptCreateInput"];
	["IdentificationAttemptUpdateInput"]: GraphQLTypes["IdentificationAttemptUpdateInput"];
	["IdentificationCodeConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["IdentificationCodeEdge"]>
};
	["IdentificationCodeEdge"]: {
		node: GraphQLTypes["IdentificationCode"]
};
	["IdentificationCodeCreateInput"]: GraphQLTypes["IdentificationCodeCreateInput"];
	["IdentificationCodeUpdateInput"]: GraphQLTypes["IdentificationCodeUpdateInput"];
	["IdentificationCodeLocaleCreateInput"]: GraphQLTypes["IdentificationCodeLocaleCreateInput"];
	["IdentificationCodeLocaleUpdateInput"]: GraphQLTypes["IdentificationCodeLocaleUpdateInput"];
	["PipelineConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PipelineEdge"]>
};
	["PipelineEdge"]: {
		node: GraphQLTypes["Pipeline"]
};
	["PipelineCreateInput"]: GraphQLTypes["PipelineCreateInput"];
	["PipelineCreateStagesEntityRelationInput"]: GraphQLTypes["PipelineCreateStagesEntityRelationInput"];
	["PipelineStageWithoutPipelineCreateInput"]: GraphQLTypes["PipelineStageWithoutPipelineCreateInput"];
	["PipelineUpdateInput"]: GraphQLTypes["PipelineUpdateInput"];
	["PipelineUpdateStagesEntityRelationInput"]: GraphQLTypes["PipelineUpdateStagesEntityRelationInput"];
	["PipelineUpdateStagesRelationInput"]: GraphQLTypes["PipelineUpdateStagesRelationInput"];
	["PipelineStageWithoutPipelineUpdateInput"]: GraphQLTypes["PipelineStageWithoutPipelineUpdateInput"];
	["PipelineUpsertStagesRelationInput"]: GraphQLTypes["PipelineUpsertStagesRelationInput"];
	["PipelineLeadCreateInput"]: GraphQLTypes["PipelineLeadCreateInput"];
	["PipelineLeadUpdateInput"]: GraphQLTypes["PipelineLeadUpdateInput"];
	["PipelineStageCreateInput"]: GraphQLTypes["PipelineStageCreateInput"];
	["PipelineStageUpdateInput"]: GraphQLTypes["PipelineStageUpdateInput"];
	["PipelineStageItemCreateInput"]: GraphQLTypes["PipelineStageItemCreateInput"];
	["PipelineStageItemUpdateInput"]: GraphQLTypes["PipelineStageItemUpdateInput"];
	["PipelineStageLocaleCreateInput"]: GraphQLTypes["PipelineStageLocaleCreateInput"];
	["PipelineStageLocaleUpdateInput"]: GraphQLTypes["PipelineStageLocaleUpdateInput"];
	["SalesManagerConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SalesManagerEdge"]>
};
	["SalesManagerEdge"]: {
		node: GraphQLTypes["SalesManager"]
};
	["SalesManagerCreateInput"]: GraphQLTypes["SalesManagerCreateInput"];
	["SalesManagerCreateStaffEntityRelationInput"]: GraphQLTypes["SalesManagerCreateStaffEntityRelationInput"];
	["StaffWithoutSalesManagerCreateInput"]: GraphQLTypes["StaffWithoutSalesManagerCreateInput"];
	["SalesManagerUpdateInput"]: GraphQLTypes["SalesManagerUpdateInput"];
	["SalesManagerUpdateStaffEntityRelationInput"]: GraphQLTypes["SalesManagerUpdateStaffEntityRelationInput"];
	["StaffWithoutSalesManagerUpdateInput"]: GraphQLTypes["StaffWithoutSalesManagerUpdateInput"];
	["SalesManagerUpsertStaffRelationInput"]: GraphQLTypes["SalesManagerUpsertStaffRelationInput"];
	["CashierManagerConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CashierManagerEdge"]>
};
	["CashierManagerEdge"]: {
		node: GraphQLTypes["CashierManager"]
};
	["CashierManagerCreateInput"]: GraphQLTypes["CashierManagerCreateInput"];
	["CashierManagerCreateStaffEntityRelationInput"]: GraphQLTypes["CashierManagerCreateStaffEntityRelationInput"];
	["StaffWithoutCashierManagerCreateInput"]: GraphQLTypes["StaffWithoutCashierManagerCreateInput"];
	["CashierManagerUpdateInput"]: GraphQLTypes["CashierManagerUpdateInput"];
	["CashierManagerUpdateStaffEntityRelationInput"]: GraphQLTypes["CashierManagerUpdateStaffEntityRelationInput"];
	["StaffWithoutCashierManagerUpdateInput"]: GraphQLTypes["StaffWithoutCashierManagerUpdateInput"];
	["CashierManagerUpsertStaffRelationInput"]: GraphQLTypes["CashierManagerUpsertStaffRelationInput"];
	["UserRolesConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["UserRolesEdge"]>
};
	["UserRolesEdge"]: {
		node: GraphQLTypes["UserRoles"]
};
	["PointOfSaleApplicationDeviceCreateInput"]: GraphQLTypes["PointOfSaleApplicationDeviceCreateInput"];
	["PointOfSaleApplicationDeviceUpdateInput"]: GraphQLTypes["PointOfSaleApplicationDeviceUpdateInput"];
	["PointOfSaleTerminalCreateInput"]: GraphQLTypes["PointOfSaleTerminalCreateInput"];
	["PointOfSaleTerminalUpdateInput"]: GraphQLTypes["PointOfSaleTerminalUpdateInput"];
	["PipelineStageSentimentConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PipelineStageSentimentEdge"]>
};
	["PipelineStageSentimentEdge"]: {
		node: GraphQLTypes["PipelineStageSentiment"]
};
	["DeviceIdentifierConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DeviceIdentifierEdge"]>
};
	["DeviceIdentifierEdge"]: {
		node: GraphQLTypes["DeviceIdentifier"]
};
	["DeviceIdentifierCreateInput"]: GraphQLTypes["DeviceIdentifierCreateInput"];
	["DeviceIdentifierCreateDeviceEntityRelationInput"]: GraphQLTypes["DeviceIdentifierCreateDeviceEntityRelationInput"];
	["PointOfSaleApplicationDeviceWithoutIdentifierCreateInput"]: GraphQLTypes["PointOfSaleApplicationDeviceWithoutIdentifierCreateInput"];
	["DeviceIdentifierUpdateInput"]: GraphQLTypes["DeviceIdentifierUpdateInput"];
	["DeviceIdentifierUpdateDeviceEntityRelationInput"]: GraphQLTypes["DeviceIdentifierUpdateDeviceEntityRelationInput"];
	["PointOfSaleApplicationDeviceWithoutIdentifierUpdateInput"]: GraphQLTypes["PointOfSaleApplicationDeviceWithoutIdentifierUpdateInput"];
	["DeviceIdentifierUpsertDeviceRelationInput"]: GraphQLTypes["DeviceIdentifierUpsertDeviceRelationInput"];
	["DeviceIdentifierMetadataConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DeviceIdentifierMetadataEdge"]>
};
	["DeviceIdentifierMetadataEdge"]: {
		node: GraphQLTypes["DeviceIdentifierMetadata"]
};
	["PointOfSalePrinterCreateInput"]: GraphQLTypes["PointOfSalePrinterCreateInput"];
	["PointOfSalePrinterUpdateInput"]: GraphQLTypes["PointOfSalePrinterUpdateInput"];
	["GratuityConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GratuityEdge"]>
};
	["GratuityEdge"]: {
		node: GraphQLTypes["Gratuity"]
};
	["GratuityCreateInput"]: GraphQLTypes["GratuityCreateInput"];
	["GratuityCreateOrderEntityRelationInput"]: GraphQLTypes["GratuityCreateOrderEntityRelationInput"];
	["OrderWithoutGratuityCreateInput"]: GraphQLTypes["OrderWithoutGratuityCreateInput"];
	["GratuityUpdateInput"]: GraphQLTypes["GratuityUpdateInput"];
	["GratuityUpdateOrderEntityRelationInput"]: GraphQLTypes["GratuityUpdateOrderEntityRelationInput"];
	["OrderWithoutGratuityUpdateInput"]: GraphQLTypes["OrderWithoutGratuityUpdateInput"];
	["GratuityUpsertOrderRelationInput"]: GraphQLTypes["GratuityUpsertOrderRelationInput"];
	["FulfillmentNoteCreateInput"]: GraphQLTypes["FulfillmentNoteCreateInput"];
	["FulfillmentNoteUpdateInput"]: GraphQLTypes["FulfillmentNoteUpdateInput"];
	["CustomerMetadataConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CustomerMetadataEdge"]>
};
	["CustomerMetadataEdge"]: {
		node: GraphQLTypes["CustomerMetadata"]
};
	["LeadFormCreateInput"]: GraphQLTypes["LeadFormCreateInput"];
	["LeadFormUpdateInput"]: GraphQLTypes["LeadFormUpdateInput"];
	["SubscriptionBoxConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SubscriptionBoxEdge"]>
};
	["SubscriptionBoxEdge"]: {
		node: GraphQLTypes["SubscriptionBox"]
};
	["SubscriptionBoxCreateInput"]: GraphQLTypes["SubscriptionBoxCreateInput"];
	["SubscriptionBoxCreateLocalesEntityRelationInput"]: GraphQLTypes["SubscriptionBoxCreateLocalesEntityRelationInput"];
	["SubscriptionBoxLocaleWithoutRootCreateInput"]: GraphQLTypes["SubscriptionBoxLocaleWithoutRootCreateInput"];
	["SubscriptionBoxLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["SubscriptionBoxLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutSubscriptionBoxesCreateInput"]: GraphQLTypes["LocaleWithoutSubscriptionBoxesCreateInput"];
	["SubscriptionBoxUpdateInput"]: GraphQLTypes["SubscriptionBoxUpdateInput"];
	["SubscriptionBoxUpdateLocalesEntityRelationInput"]: GraphQLTypes["SubscriptionBoxUpdateLocalesEntityRelationInput"];
	["SubscriptionBoxUpdateLocalesRelationInput"]: GraphQLTypes["SubscriptionBoxUpdateLocalesRelationInput"];
	["SubscriptionBoxLocaleWithoutRootUpdateInput"]: GraphQLTypes["SubscriptionBoxLocaleWithoutRootUpdateInput"];
	["SubscriptionBoxLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["SubscriptionBoxLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutSubscriptionBoxesUpdateInput"]: GraphQLTypes["LocaleWithoutSubscriptionBoxesUpdateInput"];
	["SubscriptionBoxLocaleUpsertLocaleRelationInput"]: GraphQLTypes["SubscriptionBoxLocaleUpsertLocaleRelationInput"];
	["SubscriptionBoxUpsertLocalesRelationInput"]: GraphQLTypes["SubscriptionBoxUpsertLocalesRelationInput"];
	["SubscriptionBoxLocaleCreateInput"]: GraphQLTypes["SubscriptionBoxLocaleCreateInput"];
	["SubscriptionBoxLocaleUpdateInput"]: GraphQLTypes["SubscriptionBoxLocaleUpdateInput"];
	["TimetableDayMetadataConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TimetableDayMetadataEdge"]>
};
	["TimetableDayMetadataEdge"]: {
		node: GraphQLTypes["TimetableDayMetadata"]
};
	["BusinessServiceConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BusinessServiceEdge"]>
};
	["BusinessServiceEdge"]: {
		node: GraphQLTypes["BusinessService"]
};
	["BusinessServiceEventCreateInput"]: GraphQLTypes["BusinessServiceEventCreateInput"];
	["BusinessServiceEventCreateBusinessCustomerEntityRelationInput"]: GraphQLTypes["BusinessServiceEventCreateBusinessCustomerEntityRelationInput"];
	["BusinessCustomerWithoutBusinessServiceEventsCreateInput"]: GraphQLTypes["BusinessCustomerWithoutBusinessServiceEventsCreateInput"];
	["BusinessServiceEventUpdateInput"]: GraphQLTypes["BusinessServiceEventUpdateInput"];
	["BusinessServiceEventUpdateBusinessCustomerEntityRelationInput"]: GraphQLTypes["BusinessServiceEventUpdateBusinessCustomerEntityRelationInput"];
	["BusinessCustomerWithoutBusinessServiceEventsUpdateInput"]: GraphQLTypes["BusinessCustomerWithoutBusinessServiceEventsUpdateInput"];
	["BusinessServiceEventUpsertBusinessCustomerRelationInput"]: GraphQLTypes["BusinessServiceEventUpsertBusinessCustomerRelationInput"];
	["BusinessServiceLocaleCreateInput"]: GraphQLTypes["BusinessServiceLocaleCreateInput"];
	["BusinessServiceLocaleUpdateInput"]: GraphQLTypes["BusinessServiceLocaleUpdateInput"];
	["GridTileItemCreateInput"]: GraphQLTypes["GridTileItemCreateInput"];
	["GridTileItemCreateListEntityRelationInput"]: GraphQLTypes["GridTileItemCreateListEntityRelationInput"];
	["GridTilesWithoutItemsCreateInput"]: GraphQLTypes["GridTilesWithoutItemsCreateInput"];
	["GridTileItemUpdateInput"]: GraphQLTypes["GridTileItemUpdateInput"];
	["GridTileItemUpdateListEntityRelationInput"]: GraphQLTypes["GridTileItemUpdateListEntityRelationInput"];
	["GridTilesWithoutItemsUpdateInput"]: GraphQLTypes["GridTilesWithoutItemsUpdateInput"];
	["GridTileItemUpsertListRelationInput"]: GraphQLTypes["GridTileItemUpsertListRelationInput"];
	["GridTilesConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GridTilesEdge"]>
};
	["GridTilesEdge"]: {
		node: GraphQLTypes["GridTiles"]
};
	["AreaCreateInput"]: GraphQLTypes["AreaCreateInput"];
	["AreaUpdateInput"]: GraphQLTypes["AreaUpdateInput"];
	["Position"]: {
		_meta?: GraphQLTypes["PositionMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	x: number,
	y: number
};
	["PositionMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	x?: GraphQLTypes["FieldMeta"] | undefined,
	y?: GraphQLTypes["FieldMeta"] | undefined
};
	["PositionUniqueWhere"]: GraphQLTypes["PositionUniqueWhere"];
	["PositionWhere"]: GraphQLTypes["PositionWhere"];
	["PositionOrderBy"]: GraphQLTypes["PositionOrderBy"];
	["PositionConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PositionEdge"]>
};
	["PositionEdge"]: {
		node: GraphQLTypes["Position"]
};
	["PositionCreateInput"]: GraphQLTypes["PositionCreateInput"];
	["PositionUpdateInput"]: GraphQLTypes["PositionUpdateInput"];
	["StatsEnabledWidgetType"]: {
		_meta?: GraphQLTypes["StatsEnabledWidgetTypeMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["StatsEnabledWidgetTypeType"],
	layout?: GraphQLTypes["StatsWidgetsLayout"] | undefined
};
	["StatsEnabledWidgetTypeMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	layout?: GraphQLTypes["FieldMeta"] | undefined
};
	["StatsEnabledWidgetTypeType"]: GraphQLTypes["StatsEnabledWidgetTypeType"];
	["StatsWidgetsLayout"]: {
		_meta?: GraphQLTypes["StatsWidgetsLayoutMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	enabledWidgetTypes: Array<GraphQLTypes["StatsEnabledWidgetType"]>,
	items: Array<GraphQLTypes["StatsWidget"]>,
	enabledWidgetTypesByType?: GraphQLTypes["StatsEnabledWidgetType"] | undefined,
	paginateEnabledWidgetTypes: GraphQLTypes["StatsEnabledWidgetTypeConnection"],
	paginateItems: GraphQLTypes["StatsWidgetConnection"]
};
	["StatsWidgetsLayoutMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	enabledWidgetTypes?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["StatsEnabledWidgetTypeWhere"]: GraphQLTypes["StatsEnabledWidgetTypeWhere"];
	["StatsEnabledWidgetTypeTypeCondition"]: GraphQLTypes["StatsEnabledWidgetTypeTypeCondition"];
	["StatsWidgetsLayoutWhere"]: GraphQLTypes["StatsWidgetsLayoutWhere"];
	["StatsWidgetWhere"]: GraphQLTypes["StatsWidgetWhere"];
	["StatsWidgetTimeFrameCondition"]: GraphQLTypes["StatsWidgetTimeFrameCondition"];
	["StatsWidgetTimeFrame"]: GraphQLTypes["StatsWidgetTimeFrame"];
	["StatsEnabledWidgetTypeOrderBy"]: GraphQLTypes["StatsEnabledWidgetTypeOrderBy"];
	["StatsWidgetsLayoutOrderBy"]: GraphQLTypes["StatsWidgetsLayoutOrderBy"];
	["StatsWidget"]: {
		_meta?: GraphQLTypes["StatsWidgetMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	size: number,
	type: GraphQLTypes["StatsEnabledWidgetTypeType"],
	link?: string | undefined,
	title?: string | undefined,
	timeFrame: GraphQLTypes["StatsWidgetTimeFrame"],
	layout?: GraphQLTypes["StatsWidgetsLayout"] | undefined,
	icon?: GraphQLTypes["Image"] | undefined,
	channels: Array<GraphQLTypes["Channel"]>,
	productCategory?: GraphQLTypes["ProductCategory"] | undefined,
	paymentMethods: Array<GraphQLTypes["PaymentMethod"]>,
	hoursFrom?: string | undefined,
	hoursTo?: string | undefined,
	paginateChannels: GraphQLTypes["ChannelConnection"],
	paginatePaymentMethods: GraphQLTypes["PaymentMethodConnection"]
};
	["StatsWidgetMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	size?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	timeFrame?: GraphQLTypes["FieldMeta"] | undefined,
	layout?: GraphQLTypes["FieldMeta"] | undefined,
	icon?: GraphQLTypes["FieldMeta"] | undefined,
	channels?: GraphQLTypes["FieldMeta"] | undefined,
	productCategory?: GraphQLTypes["FieldMeta"] | undefined,
	paymentMethods?: GraphQLTypes["FieldMeta"] | undefined,
	hoursFrom?: GraphQLTypes["FieldMeta"] | undefined,
	hoursTo?: GraphQLTypes["FieldMeta"] | undefined
};
	["StatsWidgetOrderBy"]: GraphQLTypes["StatsWidgetOrderBy"];
	["StatsWidgetsLayoutEnabledWidgetTypesByTypeUniqueWhere"]: GraphQLTypes["StatsWidgetsLayoutEnabledWidgetTypesByTypeUniqueWhere"];
	["StatsEnabledWidgetTypeConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["StatsEnabledWidgetTypeEdge"]>
};
	["StatsEnabledWidgetTypeEdge"]: {
		node: GraphQLTypes["StatsEnabledWidgetType"]
};
	["StatsWidgetConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["StatsWidgetEdge"]>
};
	["StatsWidgetEdge"]: {
		node: GraphQLTypes["StatsWidget"]
};
	["StatsEnabledWidgetTypeUniqueWhere"]: GraphQLTypes["StatsEnabledWidgetTypeUniqueWhere"];
	["StatsWidgetsLayoutUniqueWhere"]: GraphQLTypes["StatsWidgetsLayoutUniqueWhere"];
	["StatsWidgetUniqueWhere"]: GraphQLTypes["StatsWidgetUniqueWhere"];
	["StatsEnabledWidgetTypeCreateInput"]: GraphQLTypes["StatsEnabledWidgetTypeCreateInput"];
	["StatsEnabledWidgetTypeCreateLayoutEntityRelationInput"]: GraphQLTypes["StatsEnabledWidgetTypeCreateLayoutEntityRelationInput"];
	["StatsWidgetsLayoutWithoutEnabledWidgetTypesCreateInput"]: GraphQLTypes["StatsWidgetsLayoutWithoutEnabledWidgetTypesCreateInput"];
	["StatsWidgetsLayoutCreateItemsEntityRelationInput"]: GraphQLTypes["StatsWidgetsLayoutCreateItemsEntityRelationInput"];
	["StatsWidgetWithoutLayoutCreateInput"]: GraphQLTypes["StatsWidgetWithoutLayoutCreateInput"];
	["StatsWidgetCreateIconEntityRelationInput"]: GraphQLTypes["StatsWidgetCreateIconEntityRelationInput"];
	["StatsWidgetCreateChannelsEntityRelationInput"]: GraphQLTypes["StatsWidgetCreateChannelsEntityRelationInput"];
	["StatsWidgetCreateProductCategoryEntityRelationInput"]: GraphQLTypes["StatsWidgetCreateProductCategoryEntityRelationInput"];
	["StatsWidgetCreatePaymentMethodsEntityRelationInput"]: GraphQLTypes["StatsWidgetCreatePaymentMethodsEntityRelationInput"];
	["StatsEnabledWidgetTypeUpdateInput"]: GraphQLTypes["StatsEnabledWidgetTypeUpdateInput"];
	["StatsEnabledWidgetTypeUpdateLayoutEntityRelationInput"]: GraphQLTypes["StatsEnabledWidgetTypeUpdateLayoutEntityRelationInput"];
	["StatsWidgetsLayoutWithoutEnabledWidgetTypesUpdateInput"]: GraphQLTypes["StatsWidgetsLayoutWithoutEnabledWidgetTypesUpdateInput"];
	["StatsWidgetsLayoutUpdateItemsEntityRelationInput"]: GraphQLTypes["StatsWidgetsLayoutUpdateItemsEntityRelationInput"];
	["StatsWidgetsLayoutUpdateItemsRelationInput"]: GraphQLTypes["StatsWidgetsLayoutUpdateItemsRelationInput"];
	["StatsWidgetWithoutLayoutUpdateInput"]: GraphQLTypes["StatsWidgetWithoutLayoutUpdateInput"];
	["StatsWidgetUpdateIconEntityRelationInput"]: GraphQLTypes["StatsWidgetUpdateIconEntityRelationInput"];
	["StatsWidgetUpsertIconRelationInput"]: GraphQLTypes["StatsWidgetUpsertIconRelationInput"];
	["StatsWidgetUpdateChannelsEntityRelationInput"]: GraphQLTypes["StatsWidgetUpdateChannelsEntityRelationInput"];
	["StatsWidgetUpdateChannelsRelationInput"]: GraphQLTypes["StatsWidgetUpdateChannelsRelationInput"];
	["StatsWidgetUpsertChannelsRelationInput"]: GraphQLTypes["StatsWidgetUpsertChannelsRelationInput"];
	["StatsWidgetUpdateProductCategoryEntityRelationInput"]: GraphQLTypes["StatsWidgetUpdateProductCategoryEntityRelationInput"];
	["StatsWidgetUpsertProductCategoryRelationInput"]: GraphQLTypes["StatsWidgetUpsertProductCategoryRelationInput"];
	["StatsWidgetUpdatePaymentMethodsEntityRelationInput"]: GraphQLTypes["StatsWidgetUpdatePaymentMethodsEntityRelationInput"];
	["StatsWidgetUpdatePaymentMethodsRelationInput"]: GraphQLTypes["StatsWidgetUpdatePaymentMethodsRelationInput"];
	["StatsWidgetUpsertPaymentMethodsRelationInput"]: GraphQLTypes["StatsWidgetUpsertPaymentMethodsRelationInput"];
	["StatsWidgetsLayoutUpsertItemsRelationInput"]: GraphQLTypes["StatsWidgetsLayoutUpsertItemsRelationInput"];
	["StatsEnabledWidgetTypeUpsertLayoutRelationInput"]: GraphQLTypes["StatsEnabledWidgetTypeUpsertLayoutRelationInput"];
	["StatsWidgetCreateInput"]: GraphQLTypes["StatsWidgetCreateInput"];
	["StatsWidgetCreateLayoutEntityRelationInput"]: GraphQLTypes["StatsWidgetCreateLayoutEntityRelationInput"];
	["StatsWidgetsLayoutWithoutItemsCreateInput"]: GraphQLTypes["StatsWidgetsLayoutWithoutItemsCreateInput"];
	["StatsWidgetsLayoutCreateEnabledWidgetTypesEntityRelationInput"]: GraphQLTypes["StatsWidgetsLayoutCreateEnabledWidgetTypesEntityRelationInput"];
	["StatsEnabledWidgetTypeWithoutLayoutCreateInput"]: GraphQLTypes["StatsEnabledWidgetTypeWithoutLayoutCreateInput"];
	["StatsWidgetUpdateInput"]: GraphQLTypes["StatsWidgetUpdateInput"];
	["StatsWidgetUpdateLayoutEntityRelationInput"]: GraphQLTypes["StatsWidgetUpdateLayoutEntityRelationInput"];
	["StatsWidgetsLayoutWithoutItemsUpdateInput"]: GraphQLTypes["StatsWidgetsLayoutWithoutItemsUpdateInput"];
	["StatsWidgetsLayoutUpdateEnabledWidgetTypesEntityRelationInput"]: GraphQLTypes["StatsWidgetsLayoutUpdateEnabledWidgetTypesEntityRelationInput"];
	["StatsWidgetsLayoutUpdateEnabledWidgetTypesRelationInput"]: GraphQLTypes["StatsWidgetsLayoutUpdateEnabledWidgetTypesRelationInput"];
	["StatsEnabledWidgetTypeWithoutLayoutUpdateInput"]: GraphQLTypes["StatsEnabledWidgetTypeWithoutLayoutUpdateInput"];
	["StatsWidgetsLayoutUpsertEnabledWidgetTypesRelationInput"]: GraphQLTypes["StatsWidgetsLayoutUpsertEnabledWidgetTypesRelationInput"];
	["StatsWidgetUpsertLayoutRelationInput"]: GraphQLTypes["StatsWidgetUpsertLayoutRelationInput"];
	["StatsWidgetsLayoutConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["StatsWidgetsLayoutEdge"]>
};
	["StatsWidgetsLayoutEdge"]: {
		node: GraphQLTypes["StatsWidgetsLayout"]
};
	["StatsWidgetsLayoutCreateInput"]: GraphQLTypes["StatsWidgetsLayoutCreateInput"];
	["StatsWidgetsLayoutUpdateInput"]: GraphQLTypes["StatsWidgetsLayoutUpdateInput"];
	["SeatCreateInput"]: GraphQLTypes["SeatCreateInput"];
	["SeatUpdateInput"]: GraphQLTypes["SeatUpdateInput"];
	["TableCreateInput"]: GraphQLTypes["TableCreateInput"];
	["TableUpdateInput"]: GraphQLTypes["TableUpdateInput"];
	["StatsPage"]: {
		_meta?: GraphQLTypes["StatsPageMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["StatsPageType"],
	enabled: boolean,
	widgets?: GraphQLTypes["StatsWidgetsLayout"] | undefined
};
	["StatsPageMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	enabled?: GraphQLTypes["FieldMeta"] | undefined,
	widgets?: GraphQLTypes["FieldMeta"] | undefined
};
	["StatsPageType"]: GraphQLTypes["StatsPageType"];
	["StatsPageUniqueWhere"]: GraphQLTypes["StatsPageUniqueWhere"];
	["StatsPageWhere"]: GraphQLTypes["StatsPageWhere"];
	["StatsPageTypeCondition"]: GraphQLTypes["StatsPageTypeCondition"];
	["StatsPageOrderBy"]: GraphQLTypes["StatsPageOrderBy"];
	["StatsPageConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["StatsPageEdge"]>
};
	["StatsPageEdge"]: {
		node: GraphQLTypes["StatsPage"]
};
	["StatsPageCreateInput"]: GraphQLTypes["StatsPageCreateInput"];
	["StatsPageCreateWidgetsEntityRelationInput"]: GraphQLTypes["StatsPageCreateWidgetsEntityRelationInput"];
	["StatsPageUpdateInput"]: GraphQLTypes["StatsPageUpdateInput"];
	["StatsPageUpdateWidgetsEntityRelationInput"]: GraphQLTypes["StatsPageUpdateWidgetsEntityRelationInput"];
	["StatsPageUpsertWidgetsRelationInput"]: GraphQLTypes["StatsPageUpsertWidgetsRelationInput"];
	["DoubleshotCoffeeEquipmentConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DoubleshotCoffeeEquipmentEdge"]>
};
	["DoubleshotCoffeeEquipmentEdge"]: {
		node: GraphQLTypes["DoubleshotCoffeeEquipment"]
};
	["Expense"]: {
		_meta?: GraphQLTypes["ExpenseMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	type: GraphQLTypes["ExpenseType"],
	category?: GraphQLTypes["ExpenseCategory"] | undefined,
	supplier?: GraphQLTypes["IngredientSupplier"] | undefined,
	changes: Array<GraphQLTypes["ExpenseChange"]>,
	documents: Array<GraphQLTypes["ExpenseDocument"]>,
	terms: Array<GraphQLTypes["ExpenseTerm"]>,
	venue?: GraphQLTypes["Venue"] | undefined,
	paidByCash: boolean,
	changesByDate?: GraphQLTypes["ExpenseChange"] | undefined,
	documentsByFile?: GraphQLTypes["ExpenseDocument"] | undefined,
	paginateChanges: GraphQLTypes["ExpenseChangeConnection"],
	paginateDocuments: GraphQLTypes["ExpenseDocumentConnection"],
	paginateTerms: GraphQLTypes["ExpenseTermConnection"]
};
	["ExpenseMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	category?: GraphQLTypes["FieldMeta"] | undefined,
	supplier?: GraphQLTypes["FieldMeta"] | undefined,
	changes?: GraphQLTypes["FieldMeta"] | undefined,
	documents?: GraphQLTypes["FieldMeta"] | undefined,
	terms?: GraphQLTypes["FieldMeta"] | undefined,
	venue?: GraphQLTypes["FieldMeta"] | undefined,
	paidByCash?: GraphQLTypes["FieldMeta"] | undefined
};
	["ExpenseType"]: GraphQLTypes["ExpenseType"];
	["ExpenseCategory"]: {
		_meta?: GraphQLTypes["ExpenseCategoryMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	items: Array<GraphQLTypes["Expense"]>,
	order: number,
	itemsByChanges?: GraphQLTypes["Expense"] | undefined,
	itemsByDocuments?: GraphQLTypes["Expense"] | undefined,
	itemsByTerms?: GraphQLTypes["Expense"] | undefined,
	paginateItems: GraphQLTypes["ExpenseConnection"]
};
	["ExpenseCategoryMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined
};
	["ExpenseWhere"]: GraphQLTypes["ExpenseWhere"];
	["ExpenseTypeCondition"]: GraphQLTypes["ExpenseTypeCondition"];
	["ExpenseCategoryWhere"]: GraphQLTypes["ExpenseCategoryWhere"];
	["ExpenseChangeWhere"]: GraphQLTypes["ExpenseChangeWhere"];
	["ExpenseDocumentWhere"]: GraphQLTypes["ExpenseDocumentWhere"];
	["FileWhere"]: GraphQLTypes["FileWhere"];
	["ExpenseTermWhere"]: GraphQLTypes["ExpenseTermWhere"];
	["ExpenseOrderBy"]: GraphQLTypes["ExpenseOrderBy"];
	["ExpenseCategoryOrderBy"]: GraphQLTypes["ExpenseCategoryOrderBy"];
	["ExpenseCategoryItemsByChangesUniqueWhere"]: GraphQLTypes["ExpenseCategoryItemsByChangesUniqueWhere"];
	["ExpenseChangeUniqueWhere"]: GraphQLTypes["ExpenseChangeUniqueWhere"];
	["ExpenseUniqueWhere"]: GraphQLTypes["ExpenseUniqueWhere"];
	["ExpenseDocumentUniqueWhere"]: GraphQLTypes["ExpenseDocumentUniqueWhere"];
	["FileUniqueWhere"]: GraphQLTypes["FileUniqueWhere"];
	["ExpenseTermUniqueWhere"]: GraphQLTypes["ExpenseTermUniqueWhere"];
	["ExpenseCategoryItemsByDocumentsUniqueWhere"]: GraphQLTypes["ExpenseCategoryItemsByDocumentsUniqueWhere"];
	["ExpenseCategoryItemsByTermsUniqueWhere"]: GraphQLTypes["ExpenseCategoryItemsByTermsUniqueWhere"];
	["ExpenseConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ExpenseEdge"]>
};
	["ExpenseEdge"]: {
		node: GraphQLTypes["Expense"]
};
	["ExpenseChange"]: {
		_meta?: GraphQLTypes["ExpenseChangeMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	date: GraphQLTypes["Date"],
	amountCents: number,
	expense?: GraphQLTypes["Expense"] | undefined
};
	["ExpenseChangeMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	date?: GraphQLTypes["FieldMeta"] | undefined,
	amountCents?: GraphQLTypes["FieldMeta"] | undefined,
	expense?: GraphQLTypes["FieldMeta"] | undefined
};
	["ExpenseChangeOrderBy"]: GraphQLTypes["ExpenseChangeOrderBy"];
	["ExpenseDocument"]: {
		_meta?: GraphQLTypes["ExpenseDocumentMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	expense?: GraphQLTypes["Expense"] | undefined,
	amountCents: number,
	file?: GraphQLTypes["File"] | undefined,
	date: GraphQLTypes["Date"],
	termDate: GraphQLTypes["Date"]
};
	["ExpenseDocumentMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	expense?: GraphQLTypes["FieldMeta"] | undefined,
	amountCents?: GraphQLTypes["FieldMeta"] | undefined,
	file?: GraphQLTypes["FieldMeta"] | undefined,
	date?: GraphQLTypes["FieldMeta"] | undefined,
	termDate?: GraphQLTypes["FieldMeta"] | undefined
};
	["File"]: {
		_meta?: GraphQLTypes["FileMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	url: string,
	size?: number | undefined,
	type?: string | undefined,
	name?: string | undefined
};
	["FileMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	url?: GraphQLTypes["FieldMeta"] | undefined,
	size?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined
};
	["ExpenseDocumentOrderBy"]: GraphQLTypes["ExpenseDocumentOrderBy"];
	["FileOrderBy"]: GraphQLTypes["FileOrderBy"];
	["ExpenseTerm"]: {
		_meta?: GraphQLTypes["ExpenseTermMeta"] | undefined,
	id: string,
	date: GraphQLTypes["Date"],
	amountCents: number,
	expense?: GraphQLTypes["Expense"] | undefined
};
	["ExpenseTermMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	date?: GraphQLTypes["FieldMeta"] | undefined,
	amountCents?: GraphQLTypes["FieldMeta"] | undefined,
	expense?: GraphQLTypes["FieldMeta"] | undefined
};
	["ExpenseTermOrderBy"]: GraphQLTypes["ExpenseTermOrderBy"];
	["ExpenseChangesByDateUniqueWhere"]: GraphQLTypes["ExpenseChangesByDateUniqueWhere"];
	["ExpenseDocumentsByFileUniqueWhere"]: GraphQLTypes["ExpenseDocumentsByFileUniqueWhere"];
	["ExpenseChangeConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ExpenseChangeEdge"]>
};
	["ExpenseChangeEdge"]: {
		node: GraphQLTypes["ExpenseChange"]
};
	["ExpenseDocumentConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ExpenseDocumentEdge"]>
};
	["ExpenseDocumentEdge"]: {
		node: GraphQLTypes["ExpenseDocument"]
};
	["ExpenseTermConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ExpenseTermEdge"]>
};
	["ExpenseTermEdge"]: {
		node: GraphQLTypes["ExpenseTerm"]
};
	["ExpenseCreateInput"]: GraphQLTypes["ExpenseCreateInput"];
	["ExpenseCreateCategoryEntityRelationInput"]: GraphQLTypes["ExpenseCreateCategoryEntityRelationInput"];
	["ExpenseCategoryUniqueWhere"]: GraphQLTypes["ExpenseCategoryUniqueWhere"];
	["ExpenseCategoryWithoutItemsCreateInput"]: GraphQLTypes["ExpenseCategoryWithoutItemsCreateInput"];
	["ExpenseCreateSupplierEntityRelationInput"]: GraphQLTypes["ExpenseCreateSupplierEntityRelationInput"];
	["ExpenseCreateChangesEntityRelationInput"]: GraphQLTypes["ExpenseCreateChangesEntityRelationInput"];
	["ExpenseChangeWithoutExpenseCreateInput"]: GraphQLTypes["ExpenseChangeWithoutExpenseCreateInput"];
	["ExpenseCreateDocumentsEntityRelationInput"]: GraphQLTypes["ExpenseCreateDocumentsEntityRelationInput"];
	["ExpenseDocumentWithoutExpenseCreateInput"]: GraphQLTypes["ExpenseDocumentWithoutExpenseCreateInput"];
	["ExpenseDocumentCreateFileEntityRelationInput"]: GraphQLTypes["ExpenseDocumentCreateFileEntityRelationInput"];
	["FileCreateInput"]: GraphQLTypes["FileCreateInput"];
	["ExpenseCreateTermsEntityRelationInput"]: GraphQLTypes["ExpenseCreateTermsEntityRelationInput"];
	["ExpenseCreateVenueEntityRelationInput"]: GraphQLTypes["ExpenseCreateVenueEntityRelationInput"];
	["ExpenseUpdateInput"]: GraphQLTypes["ExpenseUpdateInput"];
	["ExpenseUpdateCategoryEntityRelationInput"]: GraphQLTypes["ExpenseUpdateCategoryEntityRelationInput"];
	["ExpenseCategoryWithoutItemsUpdateInput"]: GraphQLTypes["ExpenseCategoryWithoutItemsUpdateInput"];
	["ExpenseUpsertCategoryRelationInput"]: GraphQLTypes["ExpenseUpsertCategoryRelationInput"];
	["ExpenseUpdateSupplierEntityRelationInput"]: GraphQLTypes["ExpenseUpdateSupplierEntityRelationInput"];
	["ExpenseUpsertSupplierRelationInput"]: GraphQLTypes["ExpenseUpsertSupplierRelationInput"];
	["ExpenseUpdateChangesEntityRelationInput"]: GraphQLTypes["ExpenseUpdateChangesEntityRelationInput"];
	["ExpenseUpdateChangesRelationInput"]: GraphQLTypes["ExpenseUpdateChangesRelationInput"];
	["ExpenseChangeWithoutExpenseUpdateInput"]: GraphQLTypes["ExpenseChangeWithoutExpenseUpdateInput"];
	["ExpenseUpsertChangesRelationInput"]: GraphQLTypes["ExpenseUpsertChangesRelationInput"];
	["ExpenseUpdateDocumentsEntityRelationInput"]: GraphQLTypes["ExpenseUpdateDocumentsEntityRelationInput"];
	["ExpenseUpdateDocumentsRelationInput"]: GraphQLTypes["ExpenseUpdateDocumentsRelationInput"];
	["ExpenseDocumentWithoutExpenseUpdateInput"]: GraphQLTypes["ExpenseDocumentWithoutExpenseUpdateInput"];
	["ExpenseDocumentUpdateFileEntityRelationInput"]: GraphQLTypes["ExpenseDocumentUpdateFileEntityRelationInput"];
	["FileUpdateInput"]: GraphQLTypes["FileUpdateInput"];
	["ExpenseDocumentUpsertFileRelationInput"]: GraphQLTypes["ExpenseDocumentUpsertFileRelationInput"];
	["ExpenseUpsertDocumentsRelationInput"]: GraphQLTypes["ExpenseUpsertDocumentsRelationInput"];
	["ExpenseUpdateTermsEntityRelationInput"]: GraphQLTypes["ExpenseUpdateTermsEntityRelationInput"];
	["ExpenseUpdateVenueEntityRelationInput"]: GraphQLTypes["ExpenseUpdateVenueEntityRelationInput"];
	["ExpenseUpsertVenueRelationInput"]: GraphQLTypes["ExpenseUpsertVenueRelationInput"];
	["ExpenseCategoryConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ExpenseCategoryEdge"]>
};
	["ExpenseCategoryEdge"]: {
		node: GraphQLTypes["ExpenseCategory"]
};
	["ExpenseCategoryCreateInput"]: GraphQLTypes["ExpenseCategoryCreateInput"];
	["ExpenseCategoryCreateItemsEntityRelationInput"]: GraphQLTypes["ExpenseCategoryCreateItemsEntityRelationInput"];
	["ExpenseWithoutCategoryCreateInput"]: GraphQLTypes["ExpenseWithoutCategoryCreateInput"];
	["ExpenseCategoryUpdateInput"]: GraphQLTypes["ExpenseCategoryUpdateInput"];
	["ExpenseCategoryUpdateItemsEntityRelationInput"]: GraphQLTypes["ExpenseCategoryUpdateItemsEntityRelationInput"];
	["ExpenseCategoryUpdateItemsRelationInput"]: GraphQLTypes["ExpenseCategoryUpdateItemsRelationInput"];
	["ExpenseWithoutCategoryUpdateInput"]: GraphQLTypes["ExpenseWithoutCategoryUpdateInput"];
	["ExpenseCategoryUpsertItemsRelationInput"]: GraphQLTypes["ExpenseCategoryUpsertItemsRelationInput"];
	["ExpenseChangeCreateInput"]: GraphQLTypes["ExpenseChangeCreateInput"];
	["ExpenseChangeCreateExpenseEntityRelationInput"]: GraphQLTypes["ExpenseChangeCreateExpenseEntityRelationInput"];
	["ExpenseWithoutChangesCreateInput"]: GraphQLTypes["ExpenseWithoutChangesCreateInput"];
	["ExpenseChangeUpdateInput"]: GraphQLTypes["ExpenseChangeUpdateInput"];
	["ExpenseChangeUpdateExpenseEntityRelationInput"]: GraphQLTypes["ExpenseChangeUpdateExpenseEntityRelationInput"];
	["ExpenseWithoutChangesUpdateInput"]: GraphQLTypes["ExpenseWithoutChangesUpdateInput"];
	["ExpenseChangeUpsertExpenseRelationInput"]: GraphQLTypes["ExpenseChangeUpsertExpenseRelationInput"];
	["ExpenseDocumentCreateInput"]: GraphQLTypes["ExpenseDocumentCreateInput"];
	["ExpenseDocumentCreateExpenseEntityRelationInput"]: GraphQLTypes["ExpenseDocumentCreateExpenseEntityRelationInput"];
	["ExpenseWithoutDocumentsCreateInput"]: GraphQLTypes["ExpenseWithoutDocumentsCreateInput"];
	["ExpenseDocumentUpdateInput"]: GraphQLTypes["ExpenseDocumentUpdateInput"];
	["ExpenseDocumentUpdateExpenseEntityRelationInput"]: GraphQLTypes["ExpenseDocumentUpdateExpenseEntityRelationInput"];
	["ExpenseWithoutDocumentsUpdateInput"]: GraphQLTypes["ExpenseWithoutDocumentsUpdateInput"];
	["ExpenseDocumentUpsertExpenseRelationInput"]: GraphQLTypes["ExpenseDocumentUpsertExpenseRelationInput"];
	["RevenuePrediction"]: {
		_meta?: GraphQLTypes["RevenuePredictionMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	type: GraphQLTypes["RevenuePredictionType"],
	channel?: GraphQLTypes["Channel"] | undefined,
	changes: Array<GraphQLTypes["RevenuePredictionChange"]>,
	alwaysIncludeInTotalRevenue: boolean,
	recurrencePeriod: GraphQLTypes["RecurrencePeriod"],
	monday: boolean,
	tuesday: boolean,
	wednesday: boolean,
	thursday: boolean,
	friday: boolean,
	saturday: boolean,
	sunday: boolean,
	terms: Array<GraphQLTypes["RevenuePredictionTerm"]>,
	paymentMethod?: GraphQLTypes["PaymentMethod"] | undefined,
	changesByDate?: GraphQLTypes["RevenuePredictionChange"] | undefined,
	paginateChanges: GraphQLTypes["RevenuePredictionChangeConnection"],
	paginateTerms: GraphQLTypes["RevenuePredictionTermConnection"]
};
	["RevenuePredictionMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	channel?: GraphQLTypes["FieldMeta"] | undefined,
	changes?: GraphQLTypes["FieldMeta"] | undefined,
	alwaysIncludeInTotalRevenue?: GraphQLTypes["FieldMeta"] | undefined,
	recurrencePeriod?: GraphQLTypes["FieldMeta"] | undefined,
	monday?: GraphQLTypes["FieldMeta"] | undefined,
	tuesday?: GraphQLTypes["FieldMeta"] | undefined,
	wednesday?: GraphQLTypes["FieldMeta"] | undefined,
	thursday?: GraphQLTypes["FieldMeta"] | undefined,
	friday?: GraphQLTypes["FieldMeta"] | undefined,
	saturday?: GraphQLTypes["FieldMeta"] | undefined,
	sunday?: GraphQLTypes["FieldMeta"] | undefined,
	terms?: GraphQLTypes["FieldMeta"] | undefined,
	paymentMethod?: GraphQLTypes["FieldMeta"] | undefined
};
	["RevenuePredictionType"]: GraphQLTypes["RevenuePredictionType"];
	["RevenuePredictionChange"]: {
		_meta?: GraphQLTypes["RevenuePredictionChangeMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	date: GraphQLTypes["Date"],
	amountCents: number,
	prediction?: GraphQLTypes["RevenuePrediction"] | undefined
};
	["RevenuePredictionChangeMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	date?: GraphQLTypes["FieldMeta"] | undefined,
	amountCents?: GraphQLTypes["FieldMeta"] | undefined,
	prediction?: GraphQLTypes["FieldMeta"] | undefined
};
	["RevenuePredictionWhere"]: GraphQLTypes["RevenuePredictionWhere"];
	["RevenuePredictionTypeCondition"]: GraphQLTypes["RevenuePredictionTypeCondition"];
	["RevenuePredictionChangeWhere"]: GraphQLTypes["RevenuePredictionChangeWhere"];
	["RecurrencePeriodCondition"]: GraphQLTypes["RecurrencePeriodCondition"];
	["RecurrencePeriod"]: GraphQLTypes["RecurrencePeriod"];
	["RevenuePredictionTermWhere"]: GraphQLTypes["RevenuePredictionTermWhere"];
	["RevenuePredictionChangeOrderBy"]: GraphQLTypes["RevenuePredictionChangeOrderBy"];
	["RevenuePredictionOrderBy"]: GraphQLTypes["RevenuePredictionOrderBy"];
	["RevenuePredictionTerm"]: {
		_meta?: GraphQLTypes["RevenuePredictionTermMeta"] | undefined,
	id: string,
	date: GraphQLTypes["Date"],
	amountCents: number,
	prediction?: GraphQLTypes["RevenuePrediction"] | undefined
};
	["RevenuePredictionTermMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	date?: GraphQLTypes["FieldMeta"] | undefined,
	amountCents?: GraphQLTypes["FieldMeta"] | undefined,
	prediction?: GraphQLTypes["FieldMeta"] | undefined
};
	["RevenuePredictionTermOrderBy"]: GraphQLTypes["RevenuePredictionTermOrderBy"];
	["RevenuePredictionChangesByDateUniqueWhere"]: GraphQLTypes["RevenuePredictionChangesByDateUniqueWhere"];
	["RevenuePredictionChangeConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["RevenuePredictionChangeEdge"]>
};
	["RevenuePredictionChangeEdge"]: {
		node: GraphQLTypes["RevenuePredictionChange"]
};
	["RevenuePredictionTermConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["RevenuePredictionTermEdge"]>
};
	["RevenuePredictionTermEdge"]: {
		node: GraphQLTypes["RevenuePredictionTerm"]
};
	["RevenuePredictionUniqueWhere"]: GraphQLTypes["RevenuePredictionUniqueWhere"];
	["RevenuePredictionChangeUniqueWhere"]: GraphQLTypes["RevenuePredictionChangeUniqueWhere"];
	["RevenuePredictionTermUniqueWhere"]: GraphQLTypes["RevenuePredictionTermUniqueWhere"];
	["RevenuePredictionConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["RevenuePredictionEdge"]>
};
	["RevenuePredictionEdge"]: {
		node: GraphQLTypes["RevenuePrediction"]
};
	["RevenuePredictionCreateInput"]: GraphQLTypes["RevenuePredictionCreateInput"];
	["RevenuePredictionCreateChannelEntityRelationInput"]: GraphQLTypes["RevenuePredictionCreateChannelEntityRelationInput"];
	["RevenuePredictionCreateChangesEntityRelationInput"]: GraphQLTypes["RevenuePredictionCreateChangesEntityRelationInput"];
	["RevenuePredictionChangeWithoutPredictionCreateInput"]: GraphQLTypes["RevenuePredictionChangeWithoutPredictionCreateInput"];
	["RevenuePredictionCreateTermsEntityRelationInput"]: GraphQLTypes["RevenuePredictionCreateTermsEntityRelationInput"];
	["RevenuePredictionCreatePaymentMethodEntityRelationInput"]: GraphQLTypes["RevenuePredictionCreatePaymentMethodEntityRelationInput"];
	["RevenuePredictionUpdateInput"]: GraphQLTypes["RevenuePredictionUpdateInput"];
	["RevenuePredictionUpdateChannelEntityRelationInput"]: GraphQLTypes["RevenuePredictionUpdateChannelEntityRelationInput"];
	["RevenuePredictionUpsertChannelRelationInput"]: GraphQLTypes["RevenuePredictionUpsertChannelRelationInput"];
	["RevenuePredictionUpdateChangesEntityRelationInput"]: GraphQLTypes["RevenuePredictionUpdateChangesEntityRelationInput"];
	["RevenuePredictionUpdateChangesRelationInput"]: GraphQLTypes["RevenuePredictionUpdateChangesRelationInput"];
	["RevenuePredictionChangeWithoutPredictionUpdateInput"]: GraphQLTypes["RevenuePredictionChangeWithoutPredictionUpdateInput"];
	["RevenuePredictionUpsertChangesRelationInput"]: GraphQLTypes["RevenuePredictionUpsertChangesRelationInput"];
	["RevenuePredictionUpdateTermsEntityRelationInput"]: GraphQLTypes["RevenuePredictionUpdateTermsEntityRelationInput"];
	["RevenuePredictionUpdatePaymentMethodEntityRelationInput"]: GraphQLTypes["RevenuePredictionUpdatePaymentMethodEntityRelationInput"];
	["RevenuePredictionUpsertPaymentMethodRelationInput"]: GraphQLTypes["RevenuePredictionUpsertPaymentMethodRelationInput"];
	["RevenuePredictionChangeCreateInput"]: GraphQLTypes["RevenuePredictionChangeCreateInput"];
	["RevenuePredictionChangeCreatePredictionEntityRelationInput"]: GraphQLTypes["RevenuePredictionChangeCreatePredictionEntityRelationInput"];
	["RevenuePredictionWithoutChangesCreateInput"]: GraphQLTypes["RevenuePredictionWithoutChangesCreateInput"];
	["RevenuePredictionChangeUpdateInput"]: GraphQLTypes["RevenuePredictionChangeUpdateInput"];
	["RevenuePredictionChangeUpdatePredictionEntityRelationInput"]: GraphQLTypes["RevenuePredictionChangeUpdatePredictionEntityRelationInput"];
	["RevenuePredictionWithoutChangesUpdateInput"]: GraphQLTypes["RevenuePredictionWithoutChangesUpdateInput"];
	["RevenuePredictionChangeUpsertPredictionRelationInput"]: GraphQLTypes["RevenuePredictionChangeUpsertPredictionRelationInput"];
	["FileConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FileEdge"]>
};
	["FileEdge"]: {
		node: GraphQLTypes["File"]
};
	["LineCreateInput"]: GraphQLTypes["LineCreateInput"];
	["LineCreateAreaEntityRelationInput"]: GraphQLTypes["LineCreateAreaEntityRelationInput"];
	["AreaWithoutLinesCreateInput"]: GraphQLTypes["AreaWithoutLinesCreateInput"];
	["LineUpdateInput"]: GraphQLTypes["LineUpdateInput"];
	["LineUpdateAreaEntityRelationInput"]: GraphQLTypes["LineUpdateAreaEntityRelationInput"];
	["AreaWithoutLinesUpdateInput"]: GraphQLTypes["AreaWithoutLinesUpdateInput"];
	["LineUpsertAreaRelationInput"]: GraphQLTypes["LineUpsertAreaRelationInput"];
	["FinancesBalanceItem"]: {
		_meta?: GraphQLTypes["FinancesBalanceItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	amountCents: number,
	date: GraphQLTypes["Date"],
	venue?: GraphQLTypes["Venue"] | undefined,
	paidByCash: boolean
};
	["FinancesBalanceItemMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	amountCents?: GraphQLTypes["FieldMeta"] | undefined,
	date?: GraphQLTypes["FieldMeta"] | undefined,
	venue?: GraphQLTypes["FieldMeta"] | undefined,
	paidByCash?: GraphQLTypes["FieldMeta"] | undefined
};
	["FinancesBalanceItemUniqueWhere"]: GraphQLTypes["FinancesBalanceItemUniqueWhere"];
	["FinancesBalanceItemWhere"]: GraphQLTypes["FinancesBalanceItemWhere"];
	["FinancesBalanceItemOrderBy"]: GraphQLTypes["FinancesBalanceItemOrderBy"];
	["FinancesBalanceItemConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FinancesBalanceItemEdge"]>
};
	["FinancesBalanceItemEdge"]: {
		node: GraphQLTypes["FinancesBalanceItem"]
};
	["FinancesBalanceItemCreateInput"]: GraphQLTypes["FinancesBalanceItemCreateInput"];
	["FinancesBalanceItemCreateVenueEntityRelationInput"]: GraphQLTypes["FinancesBalanceItemCreateVenueEntityRelationInput"];
	["FinancesBalanceItemUpdateInput"]: GraphQLTypes["FinancesBalanceItemUpdateInput"];
	["FinancesBalanceItemUpdateVenueEntityRelationInput"]: GraphQLTypes["FinancesBalanceItemUpdateVenueEntityRelationInput"];
	["FinancesBalanceItemUpsertVenueRelationInput"]: GraphQLTypes["FinancesBalanceItemUpsertVenueRelationInput"];
	["OrderPaymentStatsByDay"]: {
		_meta?: GraphQLTypes["OrderPaymentStatsByDayMeta"] | undefined,
	id: string,
	day: GraphQLTypes["Date"],
	totalGratuityCents: number,
	reducedGratuityCents: number,
	channel?: GraphQLTypes["Channel"] | undefined,
	paymentMethod?: GraphQLTypes["PaymentMethod"] | undefined
};
	["OrderPaymentStatsByDayMeta"]: {
		id?: GraphQLTypes["FieldMeta"] | undefined,
	day?: GraphQLTypes["FieldMeta"] | undefined,
	totalGratuityCents?: GraphQLTypes["FieldMeta"] | undefined,
	reducedGratuityCents?: GraphQLTypes["FieldMeta"] | undefined,
	channel?: GraphQLTypes["FieldMeta"] | undefined,
	paymentMethod?: GraphQLTypes["FieldMeta"] | undefined
};
	["OrderPaymentStatsByDayUniqueWhere"]: GraphQLTypes["OrderPaymentStatsByDayUniqueWhere"];
	["OrderPaymentStatsByDayWhere"]: GraphQLTypes["OrderPaymentStatsByDayWhere"];
	["OrderPaymentStatsByDayOrderBy"]: GraphQLTypes["OrderPaymentStatsByDayOrderBy"];
	["OrderPaymentStatsByDayConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["OrderPaymentStatsByDayEdge"]>
};
	["OrderPaymentStatsByDayEdge"]: {
		node: GraphQLTypes["OrderPaymentStatsByDay"]
};
	["WoltDriveDeliveryConnection"]: {
		pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["WoltDriveDeliveryEdge"]>
};
	["WoltDriveDeliveryEdge"]: {
		node: GraphQLTypes["WoltDriveDelivery"]
};
	["WoltDriveDeliveryCreateInput"]: GraphQLTypes["WoltDriveDeliveryCreateInput"];
	["WoltDriveDeliveryCreateDeliveryEntityRelationInput"]: GraphQLTypes["WoltDriveDeliveryCreateDeliveryEntityRelationInput"];
	["OrderDeliveryWithoutWoltDriveDeliveryCreateInput"]: GraphQLTypes["OrderDeliveryWithoutWoltDriveDeliveryCreateInput"];
	["WoltDriveDeliveryUpdateInput"]: GraphQLTypes["WoltDriveDeliveryUpdateInput"];
	["WoltDriveDeliveryUpdateDeliveryEntityRelationInput"]: GraphQLTypes["WoltDriveDeliveryUpdateDeliveryEntityRelationInput"];
	["OrderDeliveryWithoutWoltDriveDeliveryUpdateInput"]: GraphQLTypes["OrderDeliveryWithoutWoltDriveDeliveryUpdateInput"];
	["WoltDriveDeliveryUpsertDeliveryRelationInput"]: GraphQLTypes["WoltDriveDeliveryUpsertDeliveryRelationInput"];
	["QueryTransaction"]: {
		getAddress?: GraphQLTypes["Address"] | undefined,
	listAddress: Array<GraphQLTypes["Address"]>,
	paginateAddress: GraphQLTypes["AddressConnection"],
	validateCreateAddress: GraphQLTypes["_ValidationResult"],
	validateUpdateAddress: GraphQLTypes["_ValidationResult"],
	getCountry?: GraphQLTypes["Country"] | undefined,
	listCountry: Array<GraphQLTypes["Country"]>,
	paginateCountry: GraphQLTypes["CountryConnection"],
	validateCreateCountry: GraphQLTypes["_ValidationResult"],
	validateUpdateCountry: GraphQLTypes["_ValidationResult"],
	getChannel?: GraphQLTypes["Channel"] | undefined,
	listChannel: Array<GraphQLTypes["Channel"]>,
	paginateChannel: GraphQLTypes["ChannelConnection"],
	validateCreateChannel: GraphQLTypes["_ValidationResult"],
	validateUpdateChannel: GraphQLTypes["_ValidationResult"],
	getChannelPayment?: GraphQLTypes["ChannelPayment"] | undefined,
	listChannelPayment: Array<GraphQLTypes["ChannelPayment"]>,
	paginateChannelPayment: GraphQLTypes["ChannelPaymentConnection"],
	validateCreateChannelPayment: GraphQLTypes["_ValidationResult"],
	validateUpdateChannelPayment: GraphQLTypes["_ValidationResult"],
	getChannelDelivery?: GraphQLTypes["ChannelDelivery"] | undefined,
	listChannelDelivery: Array<GraphQLTypes["ChannelDelivery"]>,
	paginateChannelDelivery: GraphQLTypes["ChannelDeliveryConnection"],
	validateCreateChannelDelivery: GraphQLTypes["_ValidationResult"],
	validateUpdateChannelDelivery: GraphQLTypes["_ValidationResult"],
	getCustomer?: GraphQLTypes["Customer"] | undefined,
	listCustomer: Array<GraphQLTypes["Customer"]>,
	paginateCustomer: GraphQLTypes["CustomerConnection"],
	validateCreateCustomer: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomer: GraphQLTypes["_ValidationResult"],
	getCustomerCredit?: GraphQLTypes["CustomerCredit"] | undefined,
	listCustomerCredit: Array<GraphQLTypes["CustomerCredit"]>,
	paginateCustomerCredit: GraphQLTypes["CustomerCreditConnection"],
	validateCreateCustomerCredit: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomerCredit: GraphQLTypes["_ValidationResult"],
	getCustomerGroup?: GraphQLTypes["CustomerGroup"] | undefined,
	listCustomerGroup: Array<GraphQLTypes["CustomerGroup"]>,
	paginateCustomerGroup: GraphQLTypes["CustomerGroupConnection"],
	validateCreateCustomerGroup: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomerGroup: GraphQLTypes["_ValidationResult"],
	getCustomerPaymentMethod?: GraphQLTypes["CustomerPaymentMethod"] | undefined,
	listCustomerPaymentMethod: Array<GraphQLTypes["CustomerPaymentMethod"]>,
	paginateCustomerPaymentMethod: GraphQLTypes["CustomerPaymentMethodConnection"],
	validateCreateCustomerPaymentMethod: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomerPaymentMethod: GraphQLTypes["_ValidationResult"],
	getDeliveryMethod?: GraphQLTypes["DeliveryMethod"] | undefined,
	listDeliveryMethod: Array<GraphQLTypes["DeliveryMethod"]>,
	paginateDeliveryMethod: GraphQLTypes["DeliveryMethodConnection"],
	validateCreateDeliveryMethod: GraphQLTypes["_ValidationResult"],
	validateUpdateDeliveryMethod: GraphQLTypes["_ValidationResult"],
	getOrder?: GraphQLTypes["Order"] | undefined,
	listOrder: Array<GraphQLTypes["Order"]>,
	paginateOrder: GraphQLTypes["OrderConnection"],
	validateCreateOrder: GraphQLTypes["_ValidationResult"],
	validateUpdateOrder: GraphQLTypes["_ValidationResult"],
	getOrderDiscount?: GraphQLTypes["OrderDiscount"] | undefined,
	listOrderDiscount: Array<GraphQLTypes["OrderDiscount"]>,
	paginateOrderDiscount: GraphQLTypes["OrderDiscountConnection"],
	validateCreateOrderDiscount: GraphQLTypes["_ValidationResult"],
	validateUpdateOrderDiscount: GraphQLTypes["_ValidationResult"],
	getOrderPayment?: GraphQLTypes["OrderPayment"] | undefined,
	listOrderPayment: Array<GraphQLTypes["OrderPayment"]>,
	paginateOrderPayment: GraphQLTypes["OrderPaymentConnection"],
	validateCreateOrderPayment: GraphQLTypes["_ValidationResult"],
	validateUpdateOrderPayment: GraphQLTypes["_ValidationResult"],
	getOrderDelivery?: GraphQLTypes["OrderDelivery"] | undefined,
	listOrderDelivery: Array<GraphQLTypes["OrderDelivery"]>,
	paginateOrderDelivery: GraphQLTypes["OrderDeliveryConnection"],
	validateCreateOrderDelivery: GraphQLTypes["_ValidationResult"],
	validateUpdateOrderDelivery: GraphQLTypes["_ValidationResult"],
	getOrderItem?: GraphQLTypes["OrderItem"] | undefined,
	listOrderItem: Array<GraphQLTypes["OrderItem"]>,
	paginateOrderItem: GraphQLTypes["OrderItemConnection"],
	validateCreateOrderItem: GraphQLTypes["_ValidationResult"],
	validateUpdateOrderItem: GraphQLTypes["_ValidationResult"],
	getPaymentMethod?: GraphQLTypes["PaymentMethod"] | undefined,
	listPaymentMethod: Array<GraphQLTypes["PaymentMethod"]>,
	paginatePaymentMethod: GraphQLTypes["PaymentMethodConnection"],
	validateCreatePaymentMethod: GraphQLTypes["_ValidationResult"],
	validateUpdatePaymentMethod: GraphQLTypes["_ValidationResult"],
	getVatRate?: GraphQLTypes["VatRate"] | undefined,
	listVatRate: Array<GraphQLTypes["VatRate"]>,
	paginateVatRate: GraphQLTypes["VatRateConnection"],
	validateCreateVatRate: GraphQLTypes["_ValidationResult"],
	validateUpdateVatRate: GraphQLTypes["_ValidationResult"],
	getProduct?: GraphQLTypes["Product"] | undefined,
	listProduct: Array<GraphQLTypes["Product"]>,
	paginateProduct: GraphQLTypes["ProductConnection"],
	validateCreateProduct: GraphQLTypes["_ValidationResult"],
	validateUpdateProduct: GraphQLTypes["_ValidationResult"],
	getProductStock?: GraphQLTypes["ProductStock"] | undefined,
	listProductStock: Array<GraphQLTypes["ProductStock"]>,
	paginateProductStock: GraphQLTypes["ProductStockConnection"],
	validateCreateProductStock: GraphQLTypes["_ValidationResult"],
	validateUpdateProductStock: GraphQLTypes["_ValidationResult"],
	getProductPacking?: GraphQLTypes["ProductPacking"] | undefined,
	listProductPacking: Array<GraphQLTypes["ProductPacking"]>,
	paginateProductPacking: GraphQLTypes["ProductPackingConnection"],
	validateCreateProductPacking: GraphQLTypes["_ValidationResult"],
	validateUpdateProductPacking: GraphQLTypes["_ValidationResult"],
	getProductGroupPrice?: GraphQLTypes["ProductGroupPrice"] | undefined,
	listProductGroupPrice: Array<GraphQLTypes["ProductGroupPrice"]>,
	paginateProductGroupPrice: GraphQLTypes["ProductGroupPriceConnection"],
	validateCreateProductGroupPrice: GraphQLTypes["_ValidationResult"],
	validateUpdateProductGroupPrice: GraphQLTypes["_ValidationResult"],
	getProductRecipe?: GraphQLTypes["ProductRecipe"] | undefined,
	listProductRecipe: Array<GraphQLTypes["ProductRecipe"]>,
	paginateProductRecipe: GraphQLTypes["ProductRecipeConnection"],
	validateCreateProductRecipe: GraphQLTypes["_ValidationResult"],
	validateUpdateProductRecipe: GraphQLTypes["_ValidationResult"],
	getProductCategory?: GraphQLTypes["ProductCategory"] | undefined,
	listProductCategory: Array<GraphQLTypes["ProductCategory"]>,
	paginateProductCategory: GraphQLTypes["ProductCategoryConnection"],
	validateCreateProductCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateProductCategory: GraphQLTypes["_ValidationResult"],
	getStore?: GraphQLTypes["Store"] | undefined,
	listStore: Array<GraphQLTypes["Store"]>,
	paginateStore: GraphQLTypes["StoreConnection"],
	validateCreateStore: GraphQLTypes["_ValidationResult"],
	validateUpdateStore: GraphQLTypes["_ValidationResult"],
	getTag?: GraphQLTypes["Tag"] | undefined,
	listTag: Array<GraphQLTypes["Tag"]>,
	paginateTag: GraphQLTypes["TagConnection"],
	validateCreateTag: GraphQLTypes["_ValidationResult"],
	validateUpdateTag: GraphQLTypes["_ValidationResult"],
	getCustomerPermissions?: GraphQLTypes["CustomerPermissions"] | undefined,
	listCustomerPermissions: Array<GraphQLTypes["CustomerPermissions"]>,
	paginateCustomerPermissions: GraphQLTypes["CustomerPermissionsConnection"],
	getImage?: GraphQLTypes["Image"] | undefined,
	listImage: Array<GraphQLTypes["Image"]>,
	paginateImage: GraphQLTypes["ImageConnection"],
	validateCreateImage: GraphQLTypes["_ValidationResult"],
	validateUpdateImage: GraphQLTypes["_ValidationResult"],
	getBusinessCategory?: GraphQLTypes["BusinessCategory"] | undefined,
	listBusinessCategory: Array<GraphQLTypes["BusinessCategory"]>,
	paginateBusinessCategory: GraphQLTypes["BusinessCategoryConnection"],
	validateCreateBusinessCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateBusinessCategory: GraphQLTypes["_ValidationResult"],
	getProductList?: GraphQLTypes["ProductList"] | undefined,
	listProductList: Array<GraphQLTypes["ProductList"]>,
	paginateProductList: GraphQLTypes["ProductListConnection"],
	validateCreateProductList: GraphQLTypes["_ValidationResult"],
	validateUpdateProductList: GraphQLTypes["_ValidationResult"],
	getProductListItem?: GraphQLTypes["ProductListItem"] | undefined,
	listProductListItem: Array<GraphQLTypes["ProductListItem"]>,
	paginateProductListItem: GraphQLTypes["ProductListItemConnection"],
	validateCreateProductListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateProductListItem: GraphQLTypes["_ValidationResult"],
	getProductCategoryList?: GraphQLTypes["ProductCategoryList"] | undefined,
	listProductCategoryList: Array<GraphQLTypes["ProductCategoryList"]>,
	paginateProductCategoryList: GraphQLTypes["ProductCategoryListConnection"],
	validateCreateProductCategoryList: GraphQLTypes["_ValidationResult"],
	validateUpdateProductCategoryList: GraphQLTypes["_ValidationResult"],
	getProductCategoryListItem?: GraphQLTypes["ProductCategoryListItem"] | undefined,
	listProductCategoryListItem: Array<GraphQLTypes["ProductCategoryListItem"]>,
	paginateProductCategoryListItem: GraphQLTypes["ProductCategoryListItemConnection"],
	validateCreateProductCategoryListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateProductCategoryListItem: GraphQLTypes["_ValidationResult"],
	getBusinessCategoryLocale?: GraphQLTypes["BusinessCategoryLocale"] | undefined,
	listBusinessCategoryLocale: Array<GraphQLTypes["BusinessCategoryLocale"]>,
	paginateBusinessCategoryLocale: GraphQLTypes["BusinessCategoryLocaleConnection"],
	validateCreateBusinessCategoryLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateBusinessCategoryLocale: GraphQLTypes["_ValidationResult"],
	getLocale?: GraphQLTypes["Locale"] | undefined,
	listLocale: Array<GraphQLTypes["Locale"]>,
	paginateLocale: GraphQLTypes["LocaleConnection"],
	validateCreateLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateLocale: GraphQLTypes["_ValidationResult"],
	getProductCategoryListLocale?: GraphQLTypes["ProductCategoryListLocale"] | undefined,
	listProductCategoryListLocale: Array<GraphQLTypes["ProductCategoryListLocale"]>,
	paginateProductCategoryListLocale: GraphQLTypes["ProductCategoryListLocaleConnection"],
	validateCreateProductCategoryListLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateProductCategoryListLocale: GraphQLTypes["_ValidationResult"],
	getCustomerName?: GraphQLTypes["CustomerName"] | undefined,
	listCustomerName: Array<GraphQLTypes["CustomerName"]>,
	paginateCustomerName: GraphQLTypes["CustomerNameConnection"],
	validateCreateCustomerName: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomerName: GraphQLTypes["_ValidationResult"],
	getCustomerAlias?: GraphQLTypes["CustomerAlias"] | undefined,
	listCustomerAlias: Array<GraphQLTypes["CustomerAlias"]>,
	paginateCustomerAlias: GraphQLTypes["CustomerAliasConnection"],
	validateCreateCustomerAlias: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomerAlias: GraphQLTypes["_ValidationResult"],
	getProductIngredientItem?: GraphQLTypes["ProductIngredientItem"] | undefined,
	listProductIngredientItem: Array<GraphQLTypes["ProductIngredientItem"]>,
	paginateProductIngredientItem: GraphQLTypes["ProductIngredientItemConnection"],
	validateCreateProductIngredientItem: GraphQLTypes["_ValidationResult"],
	validateUpdateProductIngredientItem: GraphQLTypes["_ValidationResult"],
	getProductIngredientItemQuantity?: GraphQLTypes["ProductIngredientItemQuantity"] | undefined,
	listProductIngredientItemQuantity: Array<GraphQLTypes["ProductIngredientItemQuantity"]>,
	paginateProductIngredientItemQuantity: GraphQLTypes["ProductIngredientItemQuantityConnection"],
	validateCreateProductIngredientItemQuantity: GraphQLTypes["_ValidationResult"],
	validateUpdateProductIngredientItemQuantity: GraphQLTypes["_ValidationResult"],
	getProductIngredientItemQuantityUnit?: GraphQLTypes["ProductIngredientItemQuantityUnit"] | undefined,
	listProductIngredientItemQuantityUnit: Array<GraphQLTypes["ProductIngredientItemQuantityUnit"]>,
	paginateProductIngredientItemQuantityUnit: GraphQLTypes["ProductIngredientItemQuantityUnitConnection"],
	validateCreateProductIngredientItemQuantityUnit: GraphQLTypes["_ValidationResult"],
	validateUpdateProductIngredientItemQuantityUnit: GraphQLTypes["_ValidationResult"],
	getProductIngredient?: GraphQLTypes["ProductIngredient"] | undefined,
	listProductIngredient: Array<GraphQLTypes["ProductIngredient"]>,
	paginateProductIngredient: GraphQLTypes["ProductIngredientConnection"],
	validateCreateProductIngredient: GraphQLTypes["_ValidationResult"],
	validateUpdateProductIngredient: GraphQLTypes["_ValidationResult"],
	getCustomerIngredientRating?: GraphQLTypes["CustomerIngredientRating"] | undefined,
	listCustomerIngredientRating: Array<GraphQLTypes["CustomerIngredientRating"]>,
	paginateCustomerIngredientRating: GraphQLTypes["CustomerIngredientRatingConnection"],
	validateCreateCustomerIngredientRating: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomerIngredientRating: GraphQLTypes["_ValidationResult"],
	getProductIngredientRating?: GraphQLTypes["ProductIngredientRating"] | undefined,
	listProductIngredientRating: Array<GraphQLTypes["ProductIngredientRating"]>,
	paginateProductIngredientRating: GraphQLTypes["ProductIngredientRatingConnection"],
	validateCreateProductIngredientRating: GraphQLTypes["_ValidationResult"],
	validateUpdateProductIngredientRating: GraphQLTypes["_ValidationResult"],
	getProductIngredientLocale?: GraphQLTypes["ProductIngredientLocale"] | undefined,
	listProductIngredientLocale: Array<GraphQLTypes["ProductIngredientLocale"]>,
	paginateProductIngredientLocale: GraphQLTypes["ProductIngredientLocaleConnection"],
	validateCreateProductIngredientLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateProductIngredientLocale: GraphQLTypes["_ValidationResult"],
	getOrderRecurrence?: GraphQLTypes["OrderRecurrence"] | undefined,
	listOrderRecurrence: Array<GraphQLTypes["OrderRecurrence"]>,
	paginateOrderRecurrence: GraphQLTypes["OrderRecurrenceConnection"],
	validateCreateOrderRecurrence: GraphQLTypes["_ValidationResult"],
	validateUpdateOrderRecurrence: GraphQLTypes["_ValidationResult"],
	getOrderRecurrenceLocale?: GraphQLTypes["OrderRecurrenceLocale"] | undefined,
	listOrderRecurrenceLocale: Array<GraphQLTypes["OrderRecurrenceLocale"]>,
	paginateOrderRecurrenceLocale: GraphQLTypes["OrderRecurrenceLocaleConnection"],
	validateCreateOrderRecurrenceLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateOrderRecurrenceLocale: GraphQLTypes["_ValidationResult"],
	getBusinessCustomer?: GraphQLTypes["BusinessCustomer"] | undefined,
	listBusinessCustomer: Array<GraphQLTypes["BusinessCustomer"]>,
	paginateBusinessCustomer: GraphQLTypes["BusinessCustomerConnection"],
	validateCreateBusinessCustomer: GraphQLTypes["_ValidationResult"],
	validateUpdateBusinessCustomer: GraphQLTypes["_ValidationResult"],
	getPointOfSale?: GraphQLTypes["PointOfSale"] | undefined,
	listPointOfSale: Array<GraphQLTypes["PointOfSale"]>,
	paginatePointOfSale: GraphQLTypes["PointOfSaleConnection"],
	validateCreatePointOfSale: GraphQLTypes["_ValidationResult"],
	validateUpdatePointOfSale: GraphQLTypes["_ValidationResult"],
	getStaff?: GraphQLTypes["Staff"] | undefined,
	listStaff: Array<GraphQLTypes["Staff"]>,
	paginateStaff: GraphQLTypes["StaffConnection"],
	validateCreateStaff: GraphQLTypes["_ValidationResult"],
	validateUpdateStaff: GraphQLTypes["_ValidationResult"],
	getPointOfSalePermissions?: GraphQLTypes["PointOfSalePermissions"] | undefined,
	listPointOfSalePermissions: Array<GraphQLTypes["PointOfSalePermissions"]>,
	paginatePointOfSalePermissions: GraphQLTypes["PointOfSalePermissionsConnection"],
	getBlog?: GraphQLTypes["Blog"] | undefined,
	listBlog: Array<GraphQLTypes["Blog"]>,
	paginateBlog: GraphQLTypes["BlogConnection"],
	validateCreateBlog: GraphQLTypes["_ValidationResult"],
	validateUpdateBlog: GraphQLTypes["_ValidationResult"],
	getBlogLocale?: GraphQLTypes["BlogLocale"] | undefined,
	listBlogLocale: Array<GraphQLTypes["BlogLocale"]>,
	paginateBlogLocale: GraphQLTypes["BlogLocaleConnection"],
	validateCreateBlogLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateBlogLocale: GraphQLTypes["_ValidationResult"],
	getBlogPost?: GraphQLTypes["BlogPost"] | undefined,
	listBlogPost: Array<GraphQLTypes["BlogPost"]>,
	paginateBlogPost: GraphQLTypes["BlogPostConnection"],
	validateCreateBlogPost: GraphQLTypes["_ValidationResult"],
	validateUpdateBlogPost: GraphQLTypes["_ValidationResult"],
	getBlogPostLocale?: GraphQLTypes["BlogPostLocale"] | undefined,
	listBlogPostLocale: Array<GraphQLTypes["BlogPostLocale"]>,
	paginateBlogPostLocale: GraphQLTypes["BlogPostLocaleConnection"],
	validateCreateBlogPostLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateBlogPostLocale: GraphQLTypes["_ValidationResult"],
	getColorPallete?: GraphQLTypes["ColorPallete"] | undefined,
	listColorPallete: Array<GraphQLTypes["ColorPallete"]>,
	paginateColorPallete: GraphQLTypes["ColorPalleteConnection"],
	validateCreateColorPallete: GraphQLTypes["_ValidationResult"],
	validateUpdateColorPallete: GraphQLTypes["_ValidationResult"],
	getContent?: GraphQLTypes["Content"] | undefined,
	listContent: Array<GraphQLTypes["Content"]>,
	paginateContent: GraphQLTypes["ContentConnection"],
	validateCreateContent: GraphQLTypes["_ValidationResult"],
	validateUpdateContent: GraphQLTypes["_ValidationResult"],
	getContentBlock?: GraphQLTypes["ContentBlock"] | undefined,
	listContentBlock: Array<GraphQLTypes["ContentBlock"]>,
	paginateContentBlock: GraphQLTypes["ContentBlockConnection"],
	validateCreateContentBlock: GraphQLTypes["_ValidationResult"],
	validateUpdateContentBlock: GraphQLTypes["_ValidationResult"],
	getContentReference?: GraphQLTypes["ContentReference"] | undefined,
	listContentReference: Array<GraphQLTypes["ContentReference"]>,
	paginateContentReference: GraphQLTypes["ContentReferenceConnection"],
	validateCreateContentReference: GraphQLTypes["_ValidationResult"],
	validateUpdateContentReference: GraphQLTypes["_ValidationResult"],
	getBlogPostList?: GraphQLTypes["BlogPostList"] | undefined,
	listBlogPostList: Array<GraphQLTypes["BlogPostList"]>,
	paginateBlogPostList: GraphQLTypes["BlogPostListConnection"],
	validateCreateBlogPostList: GraphQLTypes["_ValidationResult"],
	validateUpdateBlogPostList: GraphQLTypes["_ValidationResult"],
	getBlogPostListItem?: GraphQLTypes["BlogPostListItem"] | undefined,
	listBlogPostListItem: Array<GraphQLTypes["BlogPostListItem"]>,
	paginateBlogPostListItem: GraphQLTypes["BlogPostListItemConnection"],
	validateCreateBlogPostListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateBlogPostListItem: GraphQLTypes["_ValidationResult"],
	getLinkList?: GraphQLTypes["LinkList"] | undefined,
	listLinkList: Array<GraphQLTypes["LinkList"]>,
	paginateLinkList: GraphQLTypes["LinkListConnection"],
	validateCreateLinkList: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkList: GraphQLTypes["_ValidationResult"],
	getLinkListItem?: GraphQLTypes["LinkListItem"] | undefined,
	listLinkListItem: Array<GraphQLTypes["LinkListItem"]>,
	paginateLinkListItem: GraphQLTypes["LinkListItemConnection"],
	validateCreateLinkListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkListItem: GraphQLTypes["_ValidationResult"],
	getCover?: GraphQLTypes["Cover"] | undefined,
	listCover: Array<GraphQLTypes["Cover"]>,
	paginateCover: GraphQLTypes["CoverConnection"],
	validateCreateCover: GraphQLTypes["_ValidationResult"],
	validateUpdateCover: GraphQLTypes["_ValidationResult"],
	getLink?: GraphQLTypes["Link"] | undefined,
	listLink: Array<GraphQLTypes["Link"]>,
	paginateLink: GraphQLTypes["LinkConnection"],
	validateCreateLink: GraphQLTypes["_ValidationResult"],
	validateUpdateLink: GraphQLTypes["_ValidationResult"],
	getLinkable?: GraphQLTypes["Linkable"] | undefined,
	listLinkable: Array<GraphQLTypes["Linkable"]>,
	paginateLinkable: GraphQLTypes["LinkableConnection"],
	validateCreateLinkable: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkable: GraphQLTypes["_ValidationResult"],
	getMedium?: GraphQLTypes["Medium"] | undefined,
	listMedium: Array<GraphQLTypes["Medium"]>,
	paginateMedium: GraphQLTypes["MediumConnection"],
	validateCreateMedium: GraphQLTypes["_ValidationResult"],
	validateUpdateMedium: GraphQLTypes["_ValidationResult"],
	getVideo?: GraphQLTypes["Video"] | undefined,
	listVideo: Array<GraphQLTypes["Video"]>,
	paginateVideo: GraphQLTypes["VideoConnection"],
	validateCreateVideo: GraphQLTypes["_ValidationResult"],
	validateUpdateVideo: GraphQLTypes["_ValidationResult"],
	getSeo?: GraphQLTypes["Seo"] | undefined,
	listSeo: Array<GraphQLTypes["Seo"]>,
	paginateSeo: GraphQLTypes["SeoConnection"],
	validateCreateSeo: GraphQLTypes["_ValidationResult"],
	validateUpdateSeo: GraphQLTypes["_ValidationResult"],
	getProtectedImage?: GraphQLTypes["ProtectedImage"] | undefined,
	listProtectedImage: Array<GraphQLTypes["ProtectedImage"]>,
	paginateProtectedImage: GraphQLTypes["ProtectedImageConnection"],
	validateCreateProtectedImage: GraphQLTypes["_ValidationResult"],
	validateUpdateProtectedImage: GraphQLTypes["_ValidationResult"],
	getTranslationDomain?: GraphQLTypes["TranslationDomain"] | undefined,
	listTranslationDomain: Array<GraphQLTypes["TranslationDomain"]>,
	paginateTranslationDomain: GraphQLTypes["TranslationDomainConnection"],
	validateCreateTranslationDomain: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationDomain: GraphQLTypes["_ValidationResult"],
	getTranslationCatalogue?: GraphQLTypes["TranslationCatalogue"] | undefined,
	listTranslationCatalogue: Array<GraphQLTypes["TranslationCatalogue"]>,
	paginateTranslationCatalogue: GraphQLTypes["TranslationCatalogueConnection"],
	validateCreateTranslationCatalogue: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationCatalogue: GraphQLTypes["_ValidationResult"],
	getTranslationKey?: GraphQLTypes["TranslationKey"] | undefined,
	listTranslationKey: Array<GraphQLTypes["TranslationKey"]>,
	paginateTranslationKey: GraphQLTypes["TranslationKeyConnection"],
	validateCreateTranslationKey: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationKey: GraphQLTypes["_ValidationResult"],
	getTranslationValue?: GraphQLTypes["TranslationValue"] | undefined,
	listTranslationValue: Array<GraphQLTypes["TranslationValue"]>,
	paginateTranslationValue: GraphQLTypes["TranslationValueConnection"],
	validateCreateTranslationValue: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationValue: GraphQLTypes["_ValidationResult"],
	getTranslationCataloguesIdentifier?: GraphQLTypes["TranslationCataloguesIdentifier"] | undefined,
	listTranslationCataloguesIdentifier: Array<GraphQLTypes["TranslationCataloguesIdentifier"]>,
	paginateTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierConnection"],
	validateCreateTranslationCataloguesIdentifier: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationCataloguesIdentifier: GraphQLTypes["_ValidationResult"],
	getSocialsAndApps?: GraphQLTypes["SocialsAndApps"] | undefined,
	listSocialsAndApps: Array<GraphQLTypes["SocialsAndApps"]>,
	paginateSocialsAndApps: GraphQLTypes["SocialsAndAppsConnection"],
	validateCreateSocialsAndApps: GraphQLTypes["_ValidationResult"],
	validateUpdateSocialsAndApps: GraphQLTypes["_ValidationResult"],
	getProductGrid?: GraphQLTypes["ProductGrid"] | undefined,
	listProductGrid: Array<GraphQLTypes["ProductGrid"]>,
	paginateProductGrid: GraphQLTypes["ProductGridConnection"],
	validateCreateProductGrid: GraphQLTypes["_ValidationResult"],
	validateUpdateProductGrid: GraphQLTypes["_ValidationResult"],
	getProductGridItem?: GraphQLTypes["ProductGridItem"] | undefined,
	listProductGridItem: Array<GraphQLTypes["ProductGridItem"]>,
	paginateProductGridItem: GraphQLTypes["ProductGridItemConnection"],
	validateCreateProductGridItem: GraphQLTypes["_ValidationResult"],
	validateUpdateProductGridItem: GraphQLTypes["_ValidationResult"],
	getGallery?: GraphQLTypes["Gallery"] | undefined,
	listGallery: Array<GraphQLTypes["Gallery"]>,
	paginateGallery: GraphQLTypes["GalleryConnection"],
	validateCreateGallery: GraphQLTypes["_ValidationResult"],
	validateUpdateGallery: GraphQLTypes["_ValidationResult"],
	getGalleryItem?: GraphQLTypes["GalleryItem"] | undefined,
	listGalleryItem: Array<GraphQLTypes["GalleryItem"]>,
	paginateGalleryItem: GraphQLTypes["GalleryItemConnection"],
	validateCreateGalleryItem: GraphQLTypes["_ValidationResult"],
	validateUpdateGalleryItem: GraphQLTypes["_ValidationResult"],
	getHero?: GraphQLTypes["Hero"] | undefined,
	listHero: Array<GraphQLTypes["Hero"]>,
	paginateHero: GraphQLTypes["HeroConnection"],
	validateCreateHero: GraphQLTypes["_ValidationResult"],
	validateUpdateHero: GraphQLTypes["_ValidationResult"],
	getSiteMenu?: GraphQLTypes["SiteMenu"] | undefined,
	listSiteMenu: Array<GraphQLTypes["SiteMenu"]>,
	paginateSiteMenu: GraphQLTypes["SiteMenuConnection"],
	validateCreateSiteMenu: GraphQLTypes["_ValidationResult"],
	validateUpdateSiteMenu: GraphQLTypes["_ValidationResult"],
	getMenuLocale?: GraphQLTypes["MenuLocale"] | undefined,
	listMenuLocale: Array<GraphQLTypes["MenuLocale"]>,
	paginateMenuLocale: GraphQLTypes["MenuLocaleConnection"],
	validateCreateMenuLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateMenuLocale: GraphQLTypes["_ValidationResult"],
	getMenuItem?: GraphQLTypes["MenuItem"] | undefined,
	listMenuItem: Array<GraphQLTypes["MenuItem"]>,
	paginateMenuItem: GraphQLTypes["MenuItemConnection"],
	validateCreateMenuItem: GraphQLTypes["_ValidationResult"],
	validateUpdateMenuItem: GraphQLTypes["_ValidationResult"],
	getPage?: GraphQLTypes["Page"] | undefined,
	listPage: Array<GraphQLTypes["Page"]>,
	paginatePage: GraphQLTypes["PageConnection"],
	validateCreatePage: GraphQLTypes["_ValidationResult"],
	validateUpdatePage: GraphQLTypes["_ValidationResult"],
	getPageLocale?: GraphQLTypes["PageLocale"] | undefined,
	listPageLocale: Array<GraphQLTypes["PageLocale"]>,
	paginatePageLocale: GraphQLTypes["PageLocaleConnection"],
	validateCreatePageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdatePageLocale: GraphQLTypes["_ValidationResult"],
	getWikiPage?: GraphQLTypes["WikiPage"] | undefined,
	listWikiPage: Array<GraphQLTypes["WikiPage"]>,
	paginateWikiPage: GraphQLTypes["WikiPageConnection"],
	validateCreateWikiPage: GraphQLTypes["_ValidationResult"],
	validateUpdateWikiPage: GraphQLTypes["_ValidationResult"],
	getMenuSubitem?: GraphQLTypes["MenuSubitem"] | undefined,
	listMenuSubitem: Array<GraphQLTypes["MenuSubitem"]>,
	paginateMenuSubitem: GraphQLTypes["MenuSubitemConnection"],
	validateCreateMenuSubitem: GraphQLTypes["_ValidationResult"],
	validateUpdateMenuSubitem: GraphQLTypes["_ValidationResult"],
	getMenuLinkList?: GraphQLTypes["MenuLinkList"] | undefined,
	listMenuLinkList: Array<GraphQLTypes["MenuLinkList"]>,
	paginateMenuLinkList: GraphQLTypes["MenuLinkListConnection"],
	validateCreateMenuLinkList: GraphQLTypes["_ValidationResult"],
	validateUpdateMenuLinkList: GraphQLTypes["_ValidationResult"],
	getMenuLinkItem?: GraphQLTypes["MenuLinkItem"] | undefined,
	listMenuLinkItem: Array<GraphQLTypes["MenuLinkItem"]>,
	paginateMenuLinkItem: GraphQLTypes["MenuLinkItemConnection"],
	validateCreateMenuLinkItem: GraphQLTypes["_ValidationResult"],
	validateUpdateMenuLinkItem: GraphQLTypes["_ValidationResult"],
	getMenuProducts?: GraphQLTypes["MenuProducts"] | undefined,
	listMenuProducts: Array<GraphQLTypes["MenuProducts"]>,
	paginateMenuProducts: GraphQLTypes["MenuProductsConnection"],
	validateCreateMenuProducts: GraphQLTypes["_ValidationResult"],
	validateUpdateMenuProducts: GraphQLTypes["_ValidationResult"],
	getMenuDelivery?: GraphQLTypes["MenuDelivery"] | undefined,
	listMenuDelivery: Array<GraphQLTypes["MenuDelivery"]>,
	paginateMenuDelivery: GraphQLTypes["MenuDeliveryConnection"],
	validateCreateMenuDelivery: GraphQLTypes["_ValidationResult"],
	validateUpdateMenuDelivery: GraphQLTypes["_ValidationResult"],
	getMenuContact?: GraphQLTypes["MenuContact"] | undefined,
	listMenuContact: Array<GraphQLTypes["MenuContact"]>,
	paginateMenuContact: GraphQLTypes["MenuContactConnection"],
	validateCreateMenuContact: GraphQLTypes["_ValidationResult"],
	validateUpdateMenuContact: GraphQLTypes["_ValidationResult"],
	getDeadlineTemplate?: GraphQLTypes["DeadlineTemplate"] | undefined,
	listDeadlineTemplate: Array<GraphQLTypes["DeadlineTemplate"]>,
	paginateDeadlineTemplate: GraphQLTypes["DeadlineTemplateConnection"],
	validateCreateDeadlineTemplate: GraphQLTypes["_ValidationResult"],
	validateUpdateDeadlineTemplate: GraphQLTypes["_ValidationResult"],
	getEmployeeQueue?: GraphQLTypes["EmployeeQueue"] | undefined,
	listEmployeeQueue: Array<GraphQLTypes["EmployeeQueue"]>,
	paginateEmployeeQueue: GraphQLTypes["EmployeeQueueConnection"],
	validateCreateEmployeeQueue: GraphQLTypes["_ValidationResult"],
	validateUpdateEmployeeQueue: GraphQLTypes["_ValidationResult"],
	getTimetableDay?: GraphQLTypes["TimetableDay"] | undefined,
	listTimetableDay: Array<GraphQLTypes["TimetableDay"]>,
	paginateTimetableDay: GraphQLTypes["TimetableDayConnection"],
	validateCreateTimetableDay: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetableDay: GraphQLTypes["_ValidationResult"],
	getTimetableEmployeeRole?: GraphQLTypes["TimetableEmployeeRole"] | undefined,
	listTimetableEmployeeRole: Array<GraphQLTypes["TimetableEmployeeRole"]>,
	paginateTimetableEmployeeRole: GraphQLTypes["TimetableEmployeeRoleConnection"],
	validateCreateTimetableEmployeeRole: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetableEmployeeRole: GraphQLTypes["_ValidationResult"],
	getTimetableShift?: GraphQLTypes["TimetableShift"] | undefined,
	listTimetableShift: Array<GraphQLTypes["TimetableShift"]>,
	paginateTimetableShift: GraphQLTypes["TimetableShiftConnection"],
	validateCreateTimetableShift: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetableShift: GraphQLTypes["_ValidationResult"],
	getTimetableShiftGroup?: GraphQLTypes["TimetableShiftGroup"] | undefined,
	listTimetableShiftGroup: Array<GraphQLTypes["TimetableShiftGroup"]>,
	paginateTimetableShiftGroup: GraphQLTypes["TimetableShiftGroupConnection"],
	validateCreateTimetableShiftGroup: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetableShiftGroup: GraphQLTypes["_ValidationResult"],
	getTimetableShiftPosition?: GraphQLTypes["TimetableShiftPosition"] | undefined,
	listTimetableShiftPosition: Array<GraphQLTypes["TimetableShiftPosition"]>,
	paginateTimetableShiftPosition: GraphQLTypes["TimetableShiftPositionConnection"],
	validateCreateTimetableShiftPosition: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetableShiftPosition: GraphQLTypes["_ValidationResult"],
	getTimetableTemplate?: GraphQLTypes["TimetableTemplate"] | undefined,
	listTimetableTemplate: Array<GraphQLTypes["TimetableTemplate"]>,
	paginateTimetableTemplate: GraphQLTypes["TimetableTemplateConnection"],
	validateCreateTimetableTemplate: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetableTemplate: GraphQLTypes["_ValidationResult"],
	getCart?: GraphQLTypes["Cart"] | undefined,
	listCart: Array<GraphQLTypes["Cart"]>,
	paginateCart: GraphQLTypes["CartConnection"],
	validateCreateCart: GraphQLTypes["_ValidationResult"],
	validateUpdateCart: GraphQLTypes["_ValidationResult"],
	getCartItem?: GraphQLTypes["CartItem"] | undefined,
	listCartItem: Array<GraphQLTypes["CartItem"]>,
	paginateCartItem: GraphQLTypes["CartItemConnection"],
	validateCreateCartItem: GraphQLTypes["_ValidationResult"],
	validateUpdateCartItem: GraphQLTypes["_ValidationResult"],
	getEmployeeQueueItem?: GraphQLTypes["EmployeeQueueItem"] | undefined,
	listEmployeeQueueItem: Array<GraphQLTypes["EmployeeQueueItem"]>,
	paginateEmployeeQueueItem: GraphQLTypes["EmployeeQueueItemConnection"],
	validateCreateEmployeeQueueItem: GraphQLTypes["_ValidationResult"],
	validateUpdateEmployeeQueueItem: GraphQLTypes["_ValidationResult"],
	getApplication?: GraphQLTypes["Application"] | undefined,
	listApplication: Array<GraphQLTypes["Application"]>,
	paginateApplication: GraphQLTypes["ApplicationConnection"],
	validateCreateApplication: GraphQLTypes["_ValidationResult"],
	validateUpdateApplication: GraphQLTypes["_ValidationResult"],
	getApplicationShortcutList?: GraphQLTypes["ApplicationShortcutList"] | undefined,
	listApplicationShortcutList: Array<GraphQLTypes["ApplicationShortcutList"]>,
	paginateApplicationShortcutList: GraphQLTypes["ApplicationShortcutListConnection"],
	validateCreateApplicationShortcutList: GraphQLTypes["_ValidationResult"],
	validateUpdateApplicationShortcutList: GraphQLTypes["_ValidationResult"],
	getApplicationShortcutListItem?: GraphQLTypes["ApplicationShortcutListItem"] | undefined,
	listApplicationShortcutListItem: Array<GraphQLTypes["ApplicationShortcutListItem"]>,
	paginateApplicationShortcutListItem: GraphQLTypes["ApplicationShortcutListItemConnection"],
	validateCreateApplicationShortcutListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateApplicationShortcutListItem: GraphQLTypes["_ValidationResult"],
	getProductBanner?: GraphQLTypes["ProductBanner"] | undefined,
	listProductBanner: Array<GraphQLTypes["ProductBanner"]>,
	paginateProductBanner: GraphQLTypes["ProductBannerConnection"],
	validateCreateProductBanner: GraphQLTypes["_ValidationResult"],
	validateUpdateProductBanner: GraphQLTypes["_ValidationResult"],
	getProductBannerItem?: GraphQLTypes["ProductBannerItem"] | undefined,
	listProductBannerItem: Array<GraphQLTypes["ProductBannerItem"]>,
	paginateProductBannerItem: GraphQLTypes["ProductBannerItemConnection"],
	validateCreateProductBannerItem: GraphQLTypes["_ValidationResult"],
	validateUpdateProductBannerItem: GraphQLTypes["_ValidationResult"],
	getProductBannerList?: GraphQLTypes["ProductBannerList"] | undefined,
	listProductBannerList: Array<GraphQLTypes["ProductBannerList"]>,
	paginateProductBannerList: GraphQLTypes["ProductBannerListConnection"],
	validateCreateProductBannerList: GraphQLTypes["_ValidationResult"],
	validateUpdateProductBannerList: GraphQLTypes["_ValidationResult"],
	getBartender?: GraphQLTypes["Bartender"] | undefined,
	listBartender: Array<GraphQLTypes["Bartender"]>,
	paginateBartender: GraphQLTypes["BartenderConnection"],
	validateCreateBartender: GraphQLTypes["_ValidationResult"],
	validateUpdateBartender: GraphQLTypes["_ValidationResult"],
	getBusinessToBusinessManager?: GraphQLTypes["BusinessToBusinessManager"] | undefined,
	listBusinessToBusinessManager: Array<GraphQLTypes["BusinessToBusinessManager"]>,
	paginateBusinessToBusinessManager: GraphQLTypes["BusinessToBusinessManagerConnection"],
	validateCreateBusinessToBusinessManager: GraphQLTypes["_ValidationResult"],
	validateUpdateBusinessToBusinessManager: GraphQLTypes["_ValidationResult"],
	getCleaner?: GraphQLTypes["Cleaner"] | undefined,
	listCleaner: Array<GraphQLTypes["Cleaner"]>,
	paginateCleaner: GraphQLTypes["CleanerConnection"],
	validateCreateCleaner: GraphQLTypes["_ValidationResult"],
	validateUpdateCleaner: GraphQLTypes["_ValidationResult"],
	getCourier?: GraphQLTypes["Courier"] | undefined,
	listCourier: Array<GraphQLTypes["Courier"]>,
	paginateCourier: GraphQLTypes["CourierConnection"],
	validateCreateCourier: GraphQLTypes["_ValidationResult"],
	validateUpdateCourier: GraphQLTypes["_ValidationResult"],
	getShiftsManager?: GraphQLTypes["ShiftsManager"] | undefined,
	listShiftsManager: Array<GraphQLTypes["ShiftsManager"]>,
	paginateShiftsManager: GraphQLTypes["ShiftsManagerConnection"],
	validateCreateShiftsManager: GraphQLTypes["_ValidationResult"],
	validateUpdateShiftsManager: GraphQLTypes["_ValidationResult"],
	getUser?: GraphQLTypes["User"] | undefined,
	listUser: Array<GraphQLTypes["User"]>,
	paginateUser: GraphQLTypes["UserConnection"],
	validateCreateUser: GraphQLTypes["_ValidationResult"],
	validateUpdateUser: GraphQLTypes["_ValidationResult"],
	getShiftsProfile?: GraphQLTypes["ShiftsProfile"] | undefined,
	listShiftsProfile: Array<GraphQLTypes["ShiftsProfile"]>,
	paginateShiftsProfile: GraphQLTypes["ShiftsProfileConnection"],
	validateCreateShiftsProfile: GraphQLTypes["_ValidationResult"],
	validateUpdateShiftsProfile: GraphQLTypes["_ValidationResult"],
	getProductIngredientCategory?: GraphQLTypes["ProductIngredientCategory"] | undefined,
	listProductIngredientCategory: Array<GraphQLTypes["ProductIngredientCategory"]>,
	paginateProductIngredientCategory: GraphQLTypes["ProductIngredientCategoryConnection"],
	validateCreateProductIngredientCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateProductIngredientCategory: GraphQLTypes["_ValidationResult"],
	getProductIngredientCategoryLocale?: GraphQLTypes["ProductIngredientCategoryLocale"] | undefined,
	listProductIngredientCategoryLocale: Array<GraphQLTypes["ProductIngredientCategoryLocale"]>,
	paginateProductIngredientCategoryLocale: GraphQLTypes["ProductIngredientCategoryLocaleConnection"],
	validateCreateProductIngredientCategoryLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateProductIngredientCategoryLocale: GraphQLTypes["_ValidationResult"],
	getStocksManager?: GraphQLTypes["StocksManager"] | undefined,
	listStocksManager: Array<GraphQLTypes["StocksManager"]>,
	paginateStocksManager: GraphQLTypes["StocksManagerConnection"],
	validateCreateStocksManager: GraphQLTypes["_ValidationResult"],
	validateUpdateStocksManager: GraphQLTypes["_ValidationResult"],
	getDeliveryRoute?: GraphQLTypes["DeliveryRoute"] | undefined,
	listDeliveryRoute: Array<GraphQLTypes["DeliveryRoute"]>,
	paginateDeliveryRoute: GraphQLTypes["DeliveryRouteConnection"],
	validateCreateDeliveryRoute: GraphQLTypes["_ValidationResult"],
	validateUpdateDeliveryRoute: GraphQLTypes["_ValidationResult"],
	getDeliveryWaypoint?: GraphQLTypes["DeliveryWaypoint"] | undefined,
	listDeliveryWaypoint: Array<GraphQLTypes["DeliveryWaypoint"]>,
	paginateDeliveryWaypoint: GraphQLTypes["DeliveryWaypointConnection"],
	validateCreateDeliveryWaypoint: GraphQLTypes["_ValidationResult"],
	validateUpdateDeliveryWaypoint: GraphQLTypes["_ValidationResult"],
	getAllergen?: GraphQLTypes["Allergen"] | undefined,
	listAllergen: Array<GraphQLTypes["Allergen"]>,
	paginateAllergen: GraphQLTypes["AllergenConnection"],
	validateCreateAllergen: GraphQLTypes["_ValidationResult"],
	validateUpdateAllergen: GraphQLTypes["_ValidationResult"],
	getAllergenLocale?: GraphQLTypes["AllergenLocale"] | undefined,
	listAllergenLocale: Array<GraphQLTypes["AllergenLocale"]>,
	paginateAllergenLocale: GraphQLTypes["AllergenLocaleConnection"],
	validateCreateAllergenLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateAllergenLocale: GraphQLTypes["_ValidationResult"],
	getGps?: GraphQLTypes["Gps"] | undefined,
	listGps: Array<GraphQLTypes["Gps"]>,
	paginateGps: GraphQLTypes["GpsConnection"],
	validateCreateGps: GraphQLTypes["_ValidationResult"],
	validateUpdateGps: GraphQLTypes["_ValidationResult"],
	getProductCategoryTree?: GraphQLTypes["ProductCategoryTree"] | undefined,
	listProductCategoryTree: Array<GraphQLTypes["ProductCategoryTree"]>,
	paginateProductCategoryTree: GraphQLTypes["ProductCategoryTreeConnection"],
	getInheritedProductCategoryTag?: GraphQLTypes["InheritedProductCategoryTag"] | undefined,
	listInheritedProductCategoryTag: Array<GraphQLTypes["InheritedProductCategoryTag"]>,
	paginateInheritedProductCategoryTag: GraphQLTypes["InheritedProductCategoryTagConnection"],
	getNestedProductCategoryProduct?: GraphQLTypes["NestedProductCategoryProduct"] | undefined,
	listNestedProductCategoryProduct: Array<GraphQLTypes["NestedProductCategoryProduct"]>,
	paginateNestedProductCategoryProduct: GraphQLTypes["NestedProductCategoryProductConnection"],
	getWeekHours?: GraphQLTypes["WeekHours"] | undefined,
	listWeekHours: Array<GraphQLTypes["WeekHours"]>,
	paginateWeekHours: GraphQLTypes["WeekHoursConnection"],
	validateCreateWeekHours: GraphQLTypes["_ValidationResult"],
	validateUpdateWeekHours: GraphQLTypes["_ValidationResult"],
	getPreparedIngredientQuantity?: GraphQLTypes["PreparedIngredientQuantity"] | undefined,
	listPreparedIngredientQuantity: Array<GraphQLTypes["PreparedIngredientQuantity"]>,
	paginatePreparedIngredientQuantity: GraphQLTypes["PreparedIngredientQuantityConnection"],
	validateCreatePreparedIngredientQuantity: GraphQLTypes["_ValidationResult"],
	validateUpdatePreparedIngredientQuantity: GraphQLTypes["_ValidationResult"],
	getPreparedRecipeQuantity?: GraphQLTypes["PreparedRecipeQuantity"] | undefined,
	listPreparedRecipeQuantity: Array<GraphQLTypes["PreparedRecipeQuantity"]>,
	paginatePreparedRecipeQuantity: GraphQLTypes["PreparedRecipeQuantityConnection"],
	validateCreatePreparedRecipeQuantity: GraphQLTypes["_ValidationResult"],
	validateUpdatePreparedRecipeQuantity: GraphQLTypes["_ValidationResult"],
	getInternalOrder?: GraphQLTypes["InternalOrder"] | undefined,
	listInternalOrder: Array<GraphQLTypes["InternalOrder"]>,
	paginateInternalOrder: GraphQLTypes["InternalOrderConnection"],
	validateCreateInternalOrder: GraphQLTypes["_ValidationResult"],
	validateUpdateInternalOrder: GraphQLTypes["_ValidationResult"],
	getInternalOrderItem?: GraphQLTypes["InternalOrderItem"] | undefined,
	listInternalOrderItem: Array<GraphQLTypes["InternalOrderItem"]>,
	paginateInternalOrderItem: GraphQLTypes["InternalOrderItemConnection"],
	validateCreateInternalOrderItem: GraphQLTypes["_ValidationResult"],
	validateUpdateInternalOrderItem: GraphQLTypes["_ValidationResult"],
	getPreparedPackingQuantity?: GraphQLTypes["PreparedPackingQuantity"] | undefined,
	listPreparedPackingQuantity: Array<GraphQLTypes["PreparedPackingQuantity"]>,
	paginatePreparedPackingQuantity: GraphQLTypes["PreparedPackingQuantityConnection"],
	validateCreatePreparedPackingQuantity: GraphQLTypes["_ValidationResult"],
	validateUpdatePreparedPackingQuantity: GraphQLTypes["_ValidationResult"],
	getCourierManager?: GraphQLTypes["CourierManager"] | undefined,
	listCourierManager: Array<GraphQLTypes["CourierManager"]>,
	paginateCourierManager: GraphQLTypes["CourierManagerConnection"],
	validateCreateCourierManager: GraphQLTypes["_ValidationResult"],
	validateUpdateCourierManager: GraphQLTypes["_ValidationResult"],
	getDeliveryZone?: GraphQLTypes["DeliveryZone"] | undefined,
	listDeliveryZone: Array<GraphQLTypes["DeliveryZone"]>,
	paginateDeliveryZone: GraphQLTypes["DeliveryZoneConnection"],
	validateCreateDeliveryZone: GraphQLTypes["_ValidationResult"],
	validateUpdateDeliveryZone: GraphQLTypes["_ValidationResult"],
	getAddressMetadata?: GraphQLTypes["AddressMetadata"] | undefined,
	listAddressMetadata: Array<GraphQLTypes["AddressMetadata"]>,
	paginateAddressMetadata: GraphQLTypes["AddressMetadataConnection"],
	getDeliveryTimelinePreset?: GraphQLTypes["DeliveryTimelinePreset"] | undefined,
	listDeliveryTimelinePreset: Array<GraphQLTypes["DeliveryTimelinePreset"]>,
	paginateDeliveryTimelinePreset: GraphQLTypes["DeliveryTimelinePresetConnection"],
	validateCreateDeliveryTimelinePreset: GraphQLTypes["_ValidationResult"],
	validateUpdateDeliveryTimelinePreset: GraphQLTypes["_ValidationResult"],
	getOrderDeliveryTimeline?: GraphQLTypes["OrderDeliveryTimeline"] | undefined,
	listOrderDeliveryTimeline: Array<GraphQLTypes["OrderDeliveryTimeline"]>,
	paginateOrderDeliveryTimeline: GraphQLTypes["OrderDeliveryTimelineConnection"],
	validateCreateOrderDeliveryTimeline: GraphQLTypes["_ValidationResult"],
	validateUpdateOrderDeliveryTimeline: GraphQLTypes["_ValidationResult"],
	getOrderEvent?: GraphQLTypes["OrderEvent"] | undefined,
	listOrderEvent: Array<GraphQLTypes["OrderEvent"]>,
	paginateOrderEvent: GraphQLTypes["OrderEventConnection"],
	validateCreateOrderEvent: GraphQLTypes["_ValidationResult"],
	validateUpdateOrderEvent: GraphQLTypes["_ValidationResult"],
	getLiftagoRide?: GraphQLTypes["LiftagoRide"] | undefined,
	listLiftagoRide: Array<GraphQLTypes["LiftagoRide"]>,
	paginateLiftagoRide: GraphQLTypes["LiftagoRideConnection"],
	validateCreateLiftagoRide: GraphQLTypes["_ValidationResult"],
	validateUpdateLiftagoRide: GraphQLTypes["_ValidationResult"],
	getInvoice?: GraphQLTypes["Invoice"] | undefined,
	listInvoice: Array<GraphQLTypes["Invoice"]>,
	paginateInvoice: GraphQLTypes["InvoiceConnection"],
	validateCreateInvoice: GraphQLTypes["_ValidationResult"],
	validateUpdateInvoice: GraphQLTypes["_ValidationResult"],
	getInvoicingPlan?: GraphQLTypes["InvoicingPlan"] | undefined,
	listInvoicingPlan: Array<GraphQLTypes["InvoicingPlan"]>,
	paginateInvoicingPlan: GraphQLTypes["InvoicingPlanConnection"],
	validateCreateInvoicingPlan: GraphQLTypes["_ValidationResult"],
	validateUpdateInvoicingPlan: GraphQLTypes["_ValidationResult"],
	getProductPackingLocale?: GraphQLTypes["ProductPackingLocale"] | undefined,
	listProductPackingLocale: Array<GraphQLTypes["ProductPackingLocale"]>,
	paginateProductPackingLocale: GraphQLTypes["ProductPackingLocaleConnection"],
	validateCreateProductPackingLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateProductPackingLocale: GraphQLTypes["_ValidationResult"],
	getProductLocale?: GraphQLTypes["ProductLocale"] | undefined,
	listProductLocale: Array<GraphQLTypes["ProductLocale"]>,
	paginateProductLocale: GraphQLTypes["ProductLocaleConnection"],
	validateCreateProductLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateProductLocale: GraphQLTypes["_ValidationResult"],
	getProductRecipeLocale?: GraphQLTypes["ProductRecipeLocale"] | undefined,
	listProductRecipeLocale: Array<GraphQLTypes["ProductRecipeLocale"]>,
	paginateProductRecipeLocale: GraphQLTypes["ProductRecipeLocaleConnection"],
	validateCreateProductRecipeLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateProductRecipeLocale: GraphQLTypes["_ValidationResult"],
	getUserDevice?: GraphQLTypes["UserDevice"] | undefined,
	listUserDevice: Array<GraphQLTypes["UserDevice"]>,
	paginateUserDevice: GraphQLTypes["UserDeviceConnection"],
	validateCreateUserDevice: GraphQLTypes["_ValidationResult"],
	validateUpdateUserDevice: GraphQLTypes["_ValidationResult"],
	getProtectedAction?: GraphQLTypes["ProtectedAction"] | undefined,
	listProtectedAction: Array<GraphQLTypes["ProtectedAction"]>,
	paginateProtectedAction: GraphQLTypes["ProtectedActionConnection"],
	validateCreateProtectedAction: GraphQLTypes["_ValidationResult"],
	validateUpdateProtectedAction: GraphQLTypes["_ValidationResult"],
	getPicker?: GraphQLTypes["Picker"] | undefined,
	listPicker: Array<GraphQLTypes["Picker"]>,
	paginatePicker: GraphQLTypes["PickerConnection"],
	validateCreatePicker: GraphQLTypes["_ValidationResult"],
	validateUpdatePicker: GraphQLTypes["_ValidationResult"],
	getTenantPerson?: GraphQLTypes["TenantPerson"] | undefined,
	listTenantPerson: Array<GraphQLTypes["TenantPerson"]>,
	paginateTenantPerson: GraphQLTypes["TenantPersonConnection"],
	getTimetableTemplateStaffOptions?: GraphQLTypes["TimetableTemplateStaffOptions"] | undefined,
	listTimetableTemplateStaffOptions: Array<GraphQLTypes["TimetableTemplateStaffOptions"]>,
	paginateTimetableTemplateStaffOptions: GraphQLTypes["TimetableTemplateStaffOptionsConnection"],
	validateCreateTimetableTemplateStaffOptions: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetableTemplateStaffOptions: GraphQLTypes["_ValidationResult"],
	getShoppingList?: GraphQLTypes["ShoppingList"] | undefined,
	listShoppingList: Array<GraphQLTypes["ShoppingList"]>,
	paginateShoppingList: GraphQLTypes["ShoppingListConnection"],
	validateCreateShoppingList: GraphQLTypes["_ValidationResult"],
	validateUpdateShoppingList: GraphQLTypes["_ValidationResult"],
	getSuppliesPurchase?: GraphQLTypes["SuppliesPurchase"] | undefined,
	listSuppliesPurchase: Array<GraphQLTypes["SuppliesPurchase"]>,
	paginateSuppliesPurchase: GraphQLTypes["SuppliesPurchaseConnection"],
	validateCreateSuppliesPurchase: GraphQLTypes["_ValidationResult"],
	validateUpdateSuppliesPurchase: GraphQLTypes["_ValidationResult"],
	getInvoicingPreset?: GraphQLTypes["InvoicingPreset"] | undefined,
	listInvoicingPreset: Array<GraphQLTypes["InvoicingPreset"]>,
	paginateInvoicingPreset: GraphQLTypes["InvoicingPresetConnection"],
	validateCreateInvoicingPreset: GraphQLTypes["_ValidationResult"],
	validateUpdateInvoicingPreset: GraphQLTypes["_ValidationResult"],
	getLogRecord?: GraphQLTypes["LogRecord"] | undefined,
	listLogRecord: Array<GraphQLTypes["LogRecord"]>,
	paginateLogRecord: GraphQLTypes["LogRecordConnection"],
	validateCreateLogRecord: GraphQLTypes["_ValidationResult"],
	validateUpdateLogRecord: GraphQLTypes["_ValidationResult"],
	getBillingSubject?: GraphQLTypes["BillingSubject"] | undefined,
	listBillingSubject: Array<GraphQLTypes["BillingSubject"]>,
	paginateBillingSubject: GraphQLTypes["BillingSubjectConnection"],
	validateCreateBillingSubject: GraphQLTypes["_ValidationResult"],
	validateUpdateBillingSubject: GraphQLTypes["_ValidationResult"],
	getProductCustomerPrice?: GraphQLTypes["ProductCustomerPrice"] | undefined,
	listProductCustomerPrice: Array<GraphQLTypes["ProductCustomerPrice"]>,
	paginateProductCustomerPrice: GraphQLTypes["ProductCustomerPriceConnection"],
	getCartPriceLine?: GraphQLTypes["CartPriceLine"] | undefined,
	listCartPriceLine: Array<GraphQLTypes["CartPriceLine"]>,
	paginateCartPriceLine: GraphQLTypes["CartPriceLineConnection"],
	getShoppingListItem?: GraphQLTypes["ShoppingListItem"] | undefined,
	listShoppingListItem: Array<GraphQLTypes["ShoppingListItem"]>,
	paginateShoppingListItem: GraphQLTypes["ShoppingListItemConnection"],
	validateCreateShoppingListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateShoppingListItem: GraphQLTypes["_ValidationResult"],
	getSuppliesPurchaseItem?: GraphQLTypes["SuppliesPurchaseItem"] | undefined,
	listSuppliesPurchaseItem: Array<GraphQLTypes["SuppliesPurchaseItem"]>,
	paginateSuppliesPurchaseItem: GraphQLTypes["SuppliesPurchaseItemConnection"],
	validateCreateSuppliesPurchaseItem: GraphQLTypes["_ValidationResult"],
	validateUpdateSuppliesPurchaseItem: GraphQLTypes["_ValidationResult"],
	getCustomerCreditTransaction?: GraphQLTypes["CustomerCreditTransaction"] | undefined,
	listCustomerCreditTransaction: Array<GraphQLTypes["CustomerCreditTransaction"]>,
	paginateCustomerCreditTransaction: GraphQLTypes["CustomerCreditTransactionConnection"],
	validateCreateCustomerCreditTransaction: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomerCreditTransaction: GraphQLTypes["_ValidationResult"],
	getVirtualProduct?: GraphQLTypes["VirtualProduct"] | undefined,
	listVirtualProduct: Array<GraphQLTypes["VirtualProduct"]>,
	paginateVirtualProduct: GraphQLTypes["VirtualProductConnection"],
	validateCreateVirtualProduct: GraphQLTypes["_ValidationResult"],
	validateUpdateVirtualProduct: GraphQLTypes["_ValidationResult"],
	getVirtualProductEffect?: GraphQLTypes["VirtualProductEffect"] | undefined,
	listVirtualProductEffect: Array<GraphQLTypes["VirtualProductEffect"]>,
	paginateVirtualProductEffect: GraphQLTypes["VirtualProductEffectConnection"],
	validateCreateVirtualProductEffect: GraphQLTypes["_ValidationResult"],
	validateUpdateVirtualProductEffect: GraphQLTypes["_ValidationResult"],
	getOrderPriceLine?: GraphQLTypes["OrderPriceLine"] | undefined,
	listOrderPriceLine: Array<GraphQLTypes["OrderPriceLine"]>,
	paginateOrderPriceLine: GraphQLTypes["OrderPriceLineConnection"],
	getProductMetadata?: GraphQLTypes["ProductMetadata"] | undefined,
	listProductMetadata: Array<GraphQLTypes["ProductMetadata"]>,
	paginateProductMetadata: GraphQLTypes["ProductMetadataConnection"],
	getEmploymentInformation?: GraphQLTypes["EmploymentInformation"] | undefined,
	listEmploymentInformation: Array<GraphQLTypes["EmploymentInformation"]>,
	paginateEmploymentInformation: GraphQLTypes["EmploymentInformationConnection"],
	validateCreateEmploymentInformation: GraphQLTypes["_ValidationResult"],
	validateUpdateEmploymentInformation: GraphQLTypes["_ValidationResult"],
	getRemunerationProfile?: GraphQLTypes["RemunerationProfile"] | undefined,
	listRemunerationProfile: Array<GraphQLTypes["RemunerationProfile"]>,
	paginateRemunerationProfile: GraphQLTypes["RemunerationProfileConnection"],
	validateCreateRemunerationProfile: GraphQLTypes["_ValidationResult"],
	validateUpdateRemunerationProfile: GraphQLTypes["_ValidationResult"],
	getWorkMonth?: GraphQLTypes["WorkMonth"] | undefined,
	listWorkMonth: Array<GraphQLTypes["WorkMonth"]>,
	paginateWorkMonth: GraphQLTypes["WorkMonthConnection"],
	validateCreateWorkMonth: GraphQLTypes["_ValidationResult"],
	validateUpdateWorkMonth: GraphQLTypes["_ValidationResult"],
	getSalaryOptions?: GraphQLTypes["SalaryOptions"] | undefined,
	listSalaryOptions: Array<GraphQLTypes["SalaryOptions"]>,
	paginateSalaryOptions: GraphQLTypes["SalaryOptionsConnection"],
	validateCreateSalaryOptions: GraphQLTypes["_ValidationResult"],
	validateUpdateSalaryOptions: GraphQLTypes["_ValidationResult"],
	getTimetableShiftSwapInfo?: GraphQLTypes["TimetableShiftSwapInfo"] | undefined,
	listTimetableShiftSwapInfo: Array<GraphQLTypes["TimetableShiftSwapInfo"]>,
	paginateTimetableShiftSwapInfo: GraphQLTypes["TimetableShiftSwapInfoConnection"],
	validateCreateTimetableShiftSwapInfo: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetableShiftSwapInfo: GraphQLTypes["_ValidationResult"],
	getProductGridCategory?: GraphQLTypes["ProductGridCategory"] | undefined,
	listProductGridCategory: Array<GraphQLTypes["ProductGridCategory"]>,
	paginateProductGridCategory: GraphQLTypes["ProductGridCategoryConnection"],
	validateCreateProductGridCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateProductGridCategory: GraphQLTypes["_ValidationResult"],
	getCashier?: GraphQLTypes["Cashier"] | undefined,
	listCashier: Array<GraphQLTypes["Cashier"]>,
	paginateCashier: GraphQLTypes["CashierConnection"],
	validateCreateCashier: GraphQLTypes["_ValidationResult"],
	validateUpdateCashier: GraphQLTypes["_ValidationResult"],
	getPointOfSaleCategory?: GraphQLTypes["PointOfSaleCategory"] | undefined,
	listPointOfSaleCategory: Array<GraphQLTypes["PointOfSaleCategory"]>,
	paginatePointOfSaleCategory: GraphQLTypes["PointOfSaleCategoryConnection"],
	validateCreatePointOfSaleCategory: GraphQLTypes["_ValidationResult"],
	validateUpdatePointOfSaleCategory: GraphQLTypes["_ValidationResult"],
	getPointOfSaleCategoryLocale?: GraphQLTypes["PointOfSaleCategoryLocale"] | undefined,
	listPointOfSaleCategoryLocale: Array<GraphQLTypes["PointOfSaleCategoryLocale"]>,
	paginatePointOfSaleCategoryLocale: GraphQLTypes["PointOfSaleCategoryLocaleConnection"],
	validateCreatePointOfSaleCategoryLocale: GraphQLTypes["_ValidationResult"],
	validateUpdatePointOfSaleCategoryLocale: GraphQLTypes["_ValidationResult"],
	getPointOfSaleCategoryProduct?: GraphQLTypes["PointOfSaleCategoryProduct"] | undefined,
	listPointOfSaleCategoryProduct: Array<GraphQLTypes["PointOfSaleCategoryProduct"]>,
	paginatePointOfSaleCategoryProduct: GraphQLTypes["PointOfSaleCategoryProductConnection"],
	validateCreatePointOfSaleCategoryProduct: GraphQLTypes["_ValidationResult"],
	validateUpdatePointOfSaleCategoryProduct: GraphQLTypes["_ValidationResult"],
	getPointOfSaleCategoryProductLocale?: GraphQLTypes["PointOfSaleCategoryProductLocale"] | undefined,
	listPointOfSaleCategoryProductLocale: Array<GraphQLTypes["PointOfSaleCategoryProductLocale"]>,
	paginatePointOfSaleCategoryProductLocale: GraphQLTypes["PointOfSaleCategoryProductLocaleConnection"],
	validateCreatePointOfSaleCategoryProductLocale: GraphQLTypes["_ValidationResult"],
	validateUpdatePointOfSaleCategoryProductLocale: GraphQLTypes["_ValidationResult"],
	getCustomerTab?: GraphQLTypes["CustomerTab"] | undefined,
	listCustomerTab: Array<GraphQLTypes["CustomerTab"]>,
	paginateCustomerTab: GraphQLTypes["CustomerTabConnection"],
	validateCreateCustomerTab: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomerTab: GraphQLTypes["_ValidationResult"],
	getCustomerTabItem?: GraphQLTypes["CustomerTabItem"] | undefined,
	listCustomerTabItem: Array<GraphQLTypes["CustomerTabItem"]>,
	paginateCustomerTabItem: GraphQLTypes["CustomerTabItemConnection"],
	validateCreateCustomerTabItem: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomerTabItem: GraphQLTypes["_ValidationResult"],
	getAnonymousSession?: GraphQLTypes["AnonymousSession"] | undefined,
	listAnonymousSession: Array<GraphQLTypes["AnonymousSession"]>,
	paginateAnonymousSession: GraphQLTypes["AnonymousSessionConnection"],
	validateCreateAnonymousSession: GraphQLTypes["_ValidationResult"],
	validateUpdateAnonymousSession: GraphQLTypes["_ValidationResult"],
	getVoucher?: GraphQLTypes["Voucher"] | undefined,
	listVoucher: Array<GraphQLTypes["Voucher"]>,
	paginateVoucher: GraphQLTypes["VoucherConnection"],
	validateCreateVoucher: GraphQLTypes["_ValidationResult"],
	validateUpdateVoucher: GraphQLTypes["_ValidationResult"],
	getVoucherRedemption?: GraphQLTypes["VoucherRedemption"] | undefined,
	listVoucherRedemption: Array<GraphQLTypes["VoucherRedemption"]>,
	paginateVoucherRedemption: GraphQLTypes["VoucherRedemptionConnection"],
	validateCreateVoucherRedemption: GraphQLTypes["_ValidationResult"],
	validateUpdateVoucherRedemption: GraphQLTypes["_ValidationResult"],
	getUnassignedShiftInfo?: GraphQLTypes["UnassignedShiftInfo"] | undefined,
	listUnassignedShiftInfo: Array<GraphQLTypes["UnassignedShiftInfo"]>,
	paginateUnassignedShiftInfo: GraphQLTypes["UnassignedShiftInfoConnection"],
	validateCreateUnassignedShiftInfo: GraphQLTypes["_ValidationResult"],
	validateUpdateUnassignedShiftInfo: GraphQLTypes["_ValidationResult"],
	getFreshingContainer?: GraphQLTypes["FreshingContainer"] | undefined,
	listFreshingContainer: Array<GraphQLTypes["FreshingContainer"]>,
	paginateFreshingContainer: GraphQLTypes["FreshingContainerConnection"],
	validateCreateFreshingContainer: GraphQLTypes["_ValidationResult"],
	validateUpdateFreshingContainer: GraphQLTypes["_ValidationResult"],
	getTextItem?: GraphQLTypes["TextItem"] | undefined,
	listTextItem: Array<GraphQLTypes["TextItem"]>,
	paginateTextItem: GraphQLTypes["TextItemConnection"],
	validateCreateTextItem: GraphQLTypes["_ValidationResult"],
	validateUpdateTextItem: GraphQLTypes["_ValidationResult"],
	getTextList?: GraphQLTypes["TextList"] | undefined,
	listTextList: Array<GraphQLTypes["TextList"]>,
	paginateTextList: GraphQLTypes["TextListConnection"],
	validateCreateTextList: GraphQLTypes["_ValidationResult"],
	validateUpdateTextList: GraphQLTypes["_ValidationResult"],
	getEmployeeQueueItemMetadata?: GraphQLTypes["EmployeeQueueItemMetadata"] | undefined,
	listEmployeeQueueItemMetadata: Array<GraphQLTypes["EmployeeQueueItemMetadata"]>,
	paginateEmployeeQueueItemMetadata: GraphQLTypes["EmployeeQueueItemMetadataConnection"],
	getDeliveryRegions?: GraphQLTypes["DeliveryRegions"] | undefined,
	listDeliveryRegions: Array<GraphQLTypes["DeliveryRegions"]>,
	paginateDeliveryRegions: GraphQLTypes["DeliveryRegionsConnection"],
	validateCreateDeliveryRegions: GraphQLTypes["_ValidationResult"],
	validateUpdateDeliveryRegions: GraphQLTypes["_ValidationResult"],
	getDeliveryRegionsItem?: GraphQLTypes["DeliveryRegionsItem"] | undefined,
	listDeliveryRegionsItem: Array<GraphQLTypes["DeliveryRegionsItem"]>,
	paginateDeliveryRegionsItem: GraphQLTypes["DeliveryRegionsItemConnection"],
	validateCreateDeliveryRegionsItem: GraphQLTypes["_ValidationResult"],
	validateUpdateDeliveryRegionsItem: GraphQLTypes["_ValidationResult"],
	getImageList?: GraphQLTypes["ImageList"] | undefined,
	listImageList: Array<GraphQLTypes["ImageList"]>,
	paginateImageList: GraphQLTypes["ImageListConnection"],
	validateCreateImageList: GraphQLTypes["_ValidationResult"],
	validateUpdateImageList: GraphQLTypes["_ValidationResult"],
	getImageListItem?: GraphQLTypes["ImageListItem"] | undefined,
	listImageListItem: Array<GraphQLTypes["ImageListItem"]>,
	paginateImageListItem: GraphQLTypes["ImageListItemConnection"],
	validateCreateImageListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateImageListItem: GraphQLTypes["_ValidationResult"],
	getProductSalesDay?: GraphQLTypes["ProductSalesDay"] | undefined,
	listProductSalesDay: Array<GraphQLTypes["ProductSalesDay"]>,
	paginateProductSalesDay: GraphQLTypes["ProductSalesDayConnection"],
	getProductSalesMonth?: GraphQLTypes["ProductSalesMonth"] | undefined,
	listProductSalesMonth: Array<GraphQLTypes["ProductSalesMonth"]>,
	paginateProductSalesMonth: GraphQLTypes["ProductSalesMonthConnection"],
	getProductSalesWeek?: GraphQLTypes["ProductSalesWeek"] | undefined,
	listProductSalesWeek: Array<GraphQLTypes["ProductSalesWeek"]>,
	paginateProductSalesWeek: GraphQLTypes["ProductSalesWeekConnection"],
	getTimetablesEmployeePrivileges?: GraphQLTypes["TimetablesEmployeePrivileges"] | undefined,
	listTimetablesEmployeePrivileges: Array<GraphQLTypes["TimetablesEmployeePrivileges"]>,
	paginateTimetablesEmployeePrivileges: GraphQLTypes["TimetablesEmployeePrivilegesConnection"],
	validateCreateTimetablesEmployeePrivileges: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetablesEmployeePrivileges: GraphQLTypes["_ValidationResult"],
	getTimetableDayNote?: GraphQLTypes["TimetableDayNote"] | undefined,
	listTimetableDayNote: Array<GraphQLTypes["TimetableDayNote"]>,
	paginateTimetableDayNote: GraphQLTypes["TimetableDayNoteConnection"],
	validateCreateTimetableDayNote: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetableDayNote: GraphQLTypes["_ValidationResult"],
	getDeliveryMethodLocale?: GraphQLTypes["DeliveryMethodLocale"] | undefined,
	listDeliveryMethodLocale: Array<GraphQLTypes["DeliveryMethodLocale"]>,
	paginateDeliveryMethodLocale: GraphQLTypes["DeliveryMethodLocaleConnection"],
	validateCreateDeliveryMethodLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateDeliveryMethodLocale: GraphQLTypes["_ValidationResult"],
	getIngredientSupplier?: GraphQLTypes["IngredientSupplier"] | undefined,
	listIngredientSupplier: Array<GraphQLTypes["IngredientSupplier"]>,
	paginateIngredientSupplier: GraphQLTypes["IngredientSupplierConnection"],
	validateCreateIngredientSupplier: GraphQLTypes["_ValidationResult"],
	validateUpdateIngredientSupplier: GraphQLTypes["_ValidationResult"],
	getIngredientSupplierItem?: GraphQLTypes["IngredientSupplierItem"] | undefined,
	listIngredientSupplierItem: Array<GraphQLTypes["IngredientSupplierItem"]>,
	paginateIngredientSupplierItem: GraphQLTypes["IngredientSupplierItemConnection"],
	validateCreateIngredientSupplierItem: GraphQLTypes["_ValidationResult"],
	validateUpdateIngredientSupplierItem: GraphQLTypes["_ValidationResult"],
	getIngredientSupplierList?: GraphQLTypes["IngredientSupplierList"] | undefined,
	listIngredientSupplierList: Array<GraphQLTypes["IngredientSupplierList"]>,
	paginateIngredientSupplierList: GraphQLTypes["IngredientSupplierListConnection"],
	validateCreateIngredientSupplierList: GraphQLTypes["_ValidationResult"],
	validateUpdateIngredientSupplierList: GraphQLTypes["_ValidationResult"],
	getIngredientSupplierLocale?: GraphQLTypes["IngredientSupplierLocale"] | undefined,
	listIngredientSupplierLocale: Array<GraphQLTypes["IngredientSupplierLocale"]>,
	paginateIngredientSupplierLocale: GraphQLTypes["IngredientSupplierLocaleConnection"],
	validateCreateIngredientSupplierLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateIngredientSupplierLocale: GraphQLTypes["_ValidationResult"],
	getRedirect?: GraphQLTypes["Redirect"] | undefined,
	listRedirect: Array<GraphQLTypes["Redirect"]>,
	paginateRedirect: GraphQLTypes["RedirectConnection"],
	validateCreateRedirect: GraphQLTypes["_ValidationResult"],
	validateUpdateRedirect: GraphQLTypes["_ValidationResult"],
	getNutritionFacts?: GraphQLTypes["NutritionFacts"] | undefined,
	listNutritionFacts: Array<GraphQLTypes["NutritionFacts"]>,
	paginateNutritionFacts: GraphQLTypes["NutritionFactsConnection"],
	validateCreateNutritionFacts: GraphQLTypes["_ValidationResult"],
	validateUpdateNutritionFacts: GraphQLTypes["_ValidationResult"],
	getVenue?: GraphQLTypes["Venue"] | undefined,
	listVenue: Array<GraphQLTypes["Venue"]>,
	paginateVenue: GraphQLTypes["VenueConnection"],
	validateCreateVenue: GraphQLTypes["_ValidationResult"],
	validateUpdateVenue: GraphQLTypes["_ValidationResult"],
	getWorkspace?: GraphQLTypes["Workspace"] | undefined,
	listWorkspace: Array<GraphQLTypes["Workspace"]>,
	paginateWorkspace: GraphQLTypes["WorkspaceConnection"],
	validateCreateWorkspace: GraphQLTypes["_ValidationResult"],
	validateUpdateWorkspace: GraphQLTypes["_ValidationResult"],
	getInternalBuyer?: GraphQLTypes["InternalBuyer"] | undefined,
	listInternalBuyer: Array<GraphQLTypes["InternalBuyer"]>,
	paginateInternalBuyer: GraphQLTypes["InternalBuyerConnection"],
	validateCreateInternalBuyer: GraphQLTypes["_ValidationResult"],
	validateUpdateInternalBuyer: GraphQLTypes["_ValidationResult"],
	getCartSummary?: GraphQLTypes["CartSummary"] | undefined,
	listCartSummary: Array<GraphQLTypes["CartSummary"]>,
	paginateCartSummary: GraphQLTypes["CartSummaryConnection"],
	getOrderSummary?: GraphQLTypes["OrderSummary"] | undefined,
	listOrderSummary: Array<GraphQLTypes["OrderSummary"]>,
	paginateOrderSummary: GraphQLTypes["OrderSummaryConnection"],
	getCustomerSpending?: GraphQLTypes["CustomerSpending"] | undefined,
	listCustomerSpending: Array<GraphQLTypes["CustomerSpending"]>,
	paginateCustomerSpending: GraphQLTypes["CustomerSpendingConnection"],
	getOrderPaymentMetadata?: GraphQLTypes["OrderPaymentMetadata"] | undefined,
	listOrderPaymentMetadata: Array<GraphQLTypes["OrderPaymentMetadata"]>,
	paginateOrderPaymentMetadata: GraphQLTypes["OrderPaymentMetadataConnection"],
	getUserMetadata?: GraphQLTypes["UserMetadata"] | undefined,
	listUserMetadata: Array<GraphQLTypes["UserMetadata"]>,
	paginateUserMetadata: GraphQLTypes["UserMetadataConnection"],
	getCustomerTabMetadata?: GraphQLTypes["CustomerTabMetadata"] | undefined,
	listCustomerTabMetadata: Array<GraphQLTypes["CustomerTabMetadata"]>,
	paginateCustomerTabMetadata: GraphQLTypes["CustomerTabMetadataConnection"],
	getVenueEmployeeRole?: GraphQLTypes["VenueEmployeeRole"] | undefined,
	listVenueEmployeeRole: Array<GraphQLTypes["VenueEmployeeRole"]>,
	paginateVenueEmployeeRole: GraphQLTypes["VenueEmployeeRoleConnection"],
	validateCreateVenueEmployeeRole: GraphQLTypes["_ValidationResult"],
	validateUpdateVenueEmployeeRole: GraphQLTypes["_ValidationResult"],
	getIdentificationAttempt?: GraphQLTypes["IdentificationAttempt"] | undefined,
	listIdentificationAttempt: Array<GraphQLTypes["IdentificationAttempt"]>,
	paginateIdentificationAttempt: GraphQLTypes["IdentificationAttemptConnection"],
	validateCreateIdentificationAttempt: GraphQLTypes["_ValidationResult"],
	validateUpdateIdentificationAttempt: GraphQLTypes["_ValidationResult"],
	getIdentificationCode?: GraphQLTypes["IdentificationCode"] | undefined,
	listIdentificationCode: Array<GraphQLTypes["IdentificationCode"]>,
	paginateIdentificationCode: GraphQLTypes["IdentificationCodeConnection"],
	validateCreateIdentificationCode: GraphQLTypes["_ValidationResult"],
	validateUpdateIdentificationCode: GraphQLTypes["_ValidationResult"],
	getIdentificationCodeLocale?: GraphQLTypes["IdentificationCodeLocale"] | undefined,
	listIdentificationCodeLocale: Array<GraphQLTypes["IdentificationCodeLocale"]>,
	paginateIdentificationCodeLocale: GraphQLTypes["IdentificationCodeLocaleConnection"],
	validateCreateIdentificationCodeLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateIdentificationCodeLocale: GraphQLTypes["_ValidationResult"],
	getPipeline?: GraphQLTypes["Pipeline"] | undefined,
	listPipeline: Array<GraphQLTypes["Pipeline"]>,
	paginatePipeline: GraphQLTypes["PipelineConnection"],
	validateCreatePipeline: GraphQLTypes["_ValidationResult"],
	validateUpdatePipeline: GraphQLTypes["_ValidationResult"],
	getPipelineLead?: GraphQLTypes["PipelineLead"] | undefined,
	listPipelineLead: Array<GraphQLTypes["PipelineLead"]>,
	paginatePipelineLead: GraphQLTypes["PipelineLeadConnection"],
	validateCreatePipelineLead: GraphQLTypes["_ValidationResult"],
	validateUpdatePipelineLead: GraphQLTypes["_ValidationResult"],
	getPipelineStage?: GraphQLTypes["PipelineStage"] | undefined,
	listPipelineStage: Array<GraphQLTypes["PipelineStage"]>,
	paginatePipelineStage: GraphQLTypes["PipelineStageConnection"],
	validateCreatePipelineStage: GraphQLTypes["_ValidationResult"],
	validateUpdatePipelineStage: GraphQLTypes["_ValidationResult"],
	getPipelineStageItem?: GraphQLTypes["PipelineStageItem"] | undefined,
	listPipelineStageItem: Array<GraphQLTypes["PipelineStageItem"]>,
	paginatePipelineStageItem: GraphQLTypes["PipelineStageItemConnection"],
	validateCreatePipelineStageItem: GraphQLTypes["_ValidationResult"],
	validateUpdatePipelineStageItem: GraphQLTypes["_ValidationResult"],
	getPipelineStageLocale?: GraphQLTypes["PipelineStageLocale"] | undefined,
	listPipelineStageLocale: Array<GraphQLTypes["PipelineStageLocale"]>,
	paginatePipelineStageLocale: GraphQLTypes["PipelineStageLocaleConnection"],
	validateCreatePipelineStageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdatePipelineStageLocale: GraphQLTypes["_ValidationResult"],
	getSalesManager?: GraphQLTypes["SalesManager"] | undefined,
	listSalesManager: Array<GraphQLTypes["SalesManager"]>,
	paginateSalesManager: GraphQLTypes["SalesManagerConnection"],
	validateCreateSalesManager: GraphQLTypes["_ValidationResult"],
	validateUpdateSalesManager: GraphQLTypes["_ValidationResult"],
	getCashierManager?: GraphQLTypes["CashierManager"] | undefined,
	listCashierManager: Array<GraphQLTypes["CashierManager"]>,
	paginateCashierManager: GraphQLTypes["CashierManagerConnection"],
	validateCreateCashierManager: GraphQLTypes["_ValidationResult"],
	validateUpdateCashierManager: GraphQLTypes["_ValidationResult"],
	getUserRoles?: GraphQLTypes["UserRoles"] | undefined,
	listUserRoles: Array<GraphQLTypes["UserRoles"]>,
	paginateUserRoles: GraphQLTypes["UserRolesConnection"],
	getPointOfSaleApplicationDevice?: GraphQLTypes["PointOfSaleApplicationDevice"] | undefined,
	listPointOfSaleApplicationDevice: Array<GraphQLTypes["PointOfSaleApplicationDevice"]>,
	paginatePointOfSaleApplicationDevice: GraphQLTypes["PointOfSaleApplicationDeviceConnection"],
	validateCreatePointOfSaleApplicationDevice: GraphQLTypes["_ValidationResult"],
	validateUpdatePointOfSaleApplicationDevice: GraphQLTypes["_ValidationResult"],
	getPointOfSaleTerminal?: GraphQLTypes["PointOfSaleTerminal"] | undefined,
	listPointOfSaleTerminal: Array<GraphQLTypes["PointOfSaleTerminal"]>,
	paginatePointOfSaleTerminal: GraphQLTypes["PointOfSaleTerminalConnection"],
	validateCreatePointOfSaleTerminal: GraphQLTypes["_ValidationResult"],
	validateUpdatePointOfSaleTerminal: GraphQLTypes["_ValidationResult"],
	getPipelineStageSentiment?: GraphQLTypes["PipelineStageSentiment"] | undefined,
	listPipelineStageSentiment: Array<GraphQLTypes["PipelineStageSentiment"]>,
	paginatePipelineStageSentiment: GraphQLTypes["PipelineStageSentimentConnection"],
	validateCreatePipelineStageSentiment: GraphQLTypes["_ValidationResult"],
	validateUpdatePipelineStageSentiment: GraphQLTypes["_ValidationResult"],
	getDeviceIdentifier?: GraphQLTypes["DeviceIdentifier"] | undefined,
	listDeviceIdentifier: Array<GraphQLTypes["DeviceIdentifier"]>,
	paginateDeviceIdentifier: GraphQLTypes["DeviceIdentifierConnection"],
	validateCreateDeviceIdentifier: GraphQLTypes["_ValidationResult"],
	validateUpdateDeviceIdentifier: GraphQLTypes["_ValidationResult"],
	getDeviceIdentifierMetadata?: GraphQLTypes["DeviceIdentifierMetadata"] | undefined,
	listDeviceIdentifierMetadata: Array<GraphQLTypes["DeviceIdentifierMetadata"]>,
	paginateDeviceIdentifierMetadata: GraphQLTypes["DeviceIdentifierMetadataConnection"],
	getPointOfSalePrinter?: GraphQLTypes["PointOfSalePrinter"] | undefined,
	listPointOfSalePrinter: Array<GraphQLTypes["PointOfSalePrinter"]>,
	paginatePointOfSalePrinter: GraphQLTypes["PointOfSalePrinterConnection"],
	validateCreatePointOfSalePrinter: GraphQLTypes["_ValidationResult"],
	validateUpdatePointOfSalePrinter: GraphQLTypes["_ValidationResult"],
	getGratuity?: GraphQLTypes["Gratuity"] | undefined,
	listGratuity: Array<GraphQLTypes["Gratuity"]>,
	paginateGratuity: GraphQLTypes["GratuityConnection"],
	validateCreateGratuity: GraphQLTypes["_ValidationResult"],
	validateUpdateGratuity: GraphQLTypes["_ValidationResult"],
	getFulfillmentNote?: GraphQLTypes["FulfillmentNote"] | undefined,
	listFulfillmentNote: Array<GraphQLTypes["FulfillmentNote"]>,
	paginateFulfillmentNote: GraphQLTypes["FulfillmentNoteConnection"],
	validateCreateFulfillmentNote: GraphQLTypes["_ValidationResult"],
	validateUpdateFulfillmentNote: GraphQLTypes["_ValidationResult"],
	getCustomerMetadata?: GraphQLTypes["CustomerMetadata"] | undefined,
	listCustomerMetadata: Array<GraphQLTypes["CustomerMetadata"]>,
	paginateCustomerMetadata: GraphQLTypes["CustomerMetadataConnection"],
	getLeadForm?: GraphQLTypes["LeadForm"] | undefined,
	listLeadForm: Array<GraphQLTypes["LeadForm"]>,
	paginateLeadForm: GraphQLTypes["LeadFormConnection"],
	validateCreateLeadForm: GraphQLTypes["_ValidationResult"],
	validateUpdateLeadForm: GraphQLTypes["_ValidationResult"],
	getSubscriptionBox?: GraphQLTypes["SubscriptionBox"] | undefined,
	listSubscriptionBox: Array<GraphQLTypes["SubscriptionBox"]>,
	paginateSubscriptionBox: GraphQLTypes["SubscriptionBoxConnection"],
	validateCreateSubscriptionBox: GraphQLTypes["_ValidationResult"],
	validateUpdateSubscriptionBox: GraphQLTypes["_ValidationResult"],
	getSubscriptionBoxLocale?: GraphQLTypes["SubscriptionBoxLocale"] | undefined,
	listSubscriptionBoxLocale: Array<GraphQLTypes["SubscriptionBoxLocale"]>,
	paginateSubscriptionBoxLocale: GraphQLTypes["SubscriptionBoxLocaleConnection"],
	validateCreateSubscriptionBoxLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateSubscriptionBoxLocale: GraphQLTypes["_ValidationResult"],
	getTimetableDayMetadata?: GraphQLTypes["TimetableDayMetadata"] | undefined,
	listTimetableDayMetadata: Array<GraphQLTypes["TimetableDayMetadata"]>,
	paginateTimetableDayMetadata: GraphQLTypes["TimetableDayMetadataConnection"],
	getBusinessService?: GraphQLTypes["BusinessService"] | undefined,
	listBusinessService: Array<GraphQLTypes["BusinessService"]>,
	paginateBusinessService: GraphQLTypes["BusinessServiceConnection"],
	validateCreateBusinessService: GraphQLTypes["_ValidationResult"],
	validateUpdateBusinessService: GraphQLTypes["_ValidationResult"],
	getBusinessServiceEvent?: GraphQLTypes["BusinessServiceEvent"] | undefined,
	listBusinessServiceEvent: Array<GraphQLTypes["BusinessServiceEvent"]>,
	paginateBusinessServiceEvent: GraphQLTypes["BusinessServiceEventConnection"],
	validateCreateBusinessServiceEvent: GraphQLTypes["_ValidationResult"],
	validateUpdateBusinessServiceEvent: GraphQLTypes["_ValidationResult"],
	getBusinessServiceLocale?: GraphQLTypes["BusinessServiceLocale"] | undefined,
	listBusinessServiceLocale: Array<GraphQLTypes["BusinessServiceLocale"]>,
	paginateBusinessServiceLocale: GraphQLTypes["BusinessServiceLocaleConnection"],
	validateCreateBusinessServiceLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateBusinessServiceLocale: GraphQLTypes["_ValidationResult"],
	getGridTileItem?: GraphQLTypes["GridTileItem"] | undefined,
	listGridTileItem: Array<GraphQLTypes["GridTileItem"]>,
	paginateGridTileItem: GraphQLTypes["GridTileItemConnection"],
	validateCreateGridTileItem: GraphQLTypes["_ValidationResult"],
	validateUpdateGridTileItem: GraphQLTypes["_ValidationResult"],
	getGridTiles?: GraphQLTypes["GridTiles"] | undefined,
	listGridTiles: Array<GraphQLTypes["GridTiles"]>,
	paginateGridTiles: GraphQLTypes["GridTilesConnection"],
	validateCreateGridTiles: GraphQLTypes["_ValidationResult"],
	validateUpdateGridTiles: GraphQLTypes["_ValidationResult"],
	getArea?: GraphQLTypes["Area"] | undefined,
	listArea: Array<GraphQLTypes["Area"]>,
	paginateArea: GraphQLTypes["AreaConnection"],
	validateCreateArea: GraphQLTypes["_ValidationResult"],
	validateUpdateArea: GraphQLTypes["_ValidationResult"],
	getPosition?: GraphQLTypes["Position"] | undefined,
	listPosition: Array<GraphQLTypes["Position"]>,
	paginatePosition: GraphQLTypes["PositionConnection"],
	validateCreatePosition: GraphQLTypes["_ValidationResult"],
	validateUpdatePosition: GraphQLTypes["_ValidationResult"],
	getStatsEnabledWidgetType?: GraphQLTypes["StatsEnabledWidgetType"] | undefined,
	listStatsEnabledWidgetType: Array<GraphQLTypes["StatsEnabledWidgetType"]>,
	paginateStatsEnabledWidgetType: GraphQLTypes["StatsEnabledWidgetTypeConnection"],
	validateCreateStatsEnabledWidgetType: GraphQLTypes["_ValidationResult"],
	validateUpdateStatsEnabledWidgetType: GraphQLTypes["_ValidationResult"],
	getStatsWidget?: GraphQLTypes["StatsWidget"] | undefined,
	listStatsWidget: Array<GraphQLTypes["StatsWidget"]>,
	paginateStatsWidget: GraphQLTypes["StatsWidgetConnection"],
	validateCreateStatsWidget: GraphQLTypes["_ValidationResult"],
	validateUpdateStatsWidget: GraphQLTypes["_ValidationResult"],
	getStatsWidgetsLayout?: GraphQLTypes["StatsWidgetsLayout"] | undefined,
	listStatsWidgetsLayout: Array<GraphQLTypes["StatsWidgetsLayout"]>,
	paginateStatsWidgetsLayout: GraphQLTypes["StatsWidgetsLayoutConnection"],
	validateCreateStatsWidgetsLayout: GraphQLTypes["_ValidationResult"],
	validateUpdateStatsWidgetsLayout: GraphQLTypes["_ValidationResult"],
	getSeat?: GraphQLTypes["Seat"] | undefined,
	listSeat: Array<GraphQLTypes["Seat"]>,
	paginateSeat: GraphQLTypes["SeatConnection"],
	validateCreateSeat: GraphQLTypes["_ValidationResult"],
	validateUpdateSeat: GraphQLTypes["_ValidationResult"],
	getTable?: GraphQLTypes["Table"] | undefined,
	listTable: Array<GraphQLTypes["Table"]>,
	paginateTable: GraphQLTypes["TableConnection"],
	validateCreateTable: GraphQLTypes["_ValidationResult"],
	validateUpdateTable: GraphQLTypes["_ValidationResult"],
	getStatsPage?: GraphQLTypes["StatsPage"] | undefined,
	listStatsPage: Array<GraphQLTypes["StatsPage"]>,
	paginateStatsPage: GraphQLTypes["StatsPageConnection"],
	validateCreateStatsPage: GraphQLTypes["_ValidationResult"],
	validateUpdateStatsPage: GraphQLTypes["_ValidationResult"],
	getUnassignReason?: GraphQLTypes["UnassignReason"] | undefined,
	listUnassignReason: Array<GraphQLTypes["UnassignReason"]>,
	paginateUnassignReason: GraphQLTypes["UnassignReasonConnection"],
	validateCreateUnassignReason: GraphQLTypes["_ValidationResult"],
	validateUpdateUnassignReason: GraphQLTypes["_ValidationResult"],
	getDoubleshotCoffeeEquipment?: GraphQLTypes["DoubleshotCoffeeEquipment"] | undefined,
	listDoubleshotCoffeeEquipment: Array<GraphQLTypes["DoubleshotCoffeeEquipment"]>,
	paginateDoubleshotCoffeeEquipment: GraphQLTypes["DoubleshotCoffeeEquipmentConnection"],
	validateCreateDoubleshotCoffeeEquipment: GraphQLTypes["_ValidationResult"],
	validateUpdateDoubleshotCoffeeEquipment: GraphQLTypes["_ValidationResult"],
	getExpense?: GraphQLTypes["Expense"] | undefined,
	listExpense: Array<GraphQLTypes["Expense"]>,
	paginateExpense: GraphQLTypes["ExpenseConnection"],
	validateCreateExpense: GraphQLTypes["_ValidationResult"],
	validateUpdateExpense: GraphQLTypes["_ValidationResult"],
	getExpenseCategory?: GraphQLTypes["ExpenseCategory"] | undefined,
	listExpenseCategory: Array<GraphQLTypes["ExpenseCategory"]>,
	paginateExpenseCategory: GraphQLTypes["ExpenseCategoryConnection"],
	validateCreateExpenseCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateExpenseCategory: GraphQLTypes["_ValidationResult"],
	getExpenseChange?: GraphQLTypes["ExpenseChange"] | undefined,
	listExpenseChange: Array<GraphQLTypes["ExpenseChange"]>,
	paginateExpenseChange: GraphQLTypes["ExpenseChangeConnection"],
	validateCreateExpenseChange: GraphQLTypes["_ValidationResult"],
	validateUpdateExpenseChange: GraphQLTypes["_ValidationResult"],
	getExpenseDocument?: GraphQLTypes["ExpenseDocument"] | undefined,
	listExpenseDocument: Array<GraphQLTypes["ExpenseDocument"]>,
	paginateExpenseDocument: GraphQLTypes["ExpenseDocumentConnection"],
	validateCreateExpenseDocument: GraphQLTypes["_ValidationResult"],
	validateUpdateExpenseDocument: GraphQLTypes["_ValidationResult"],
	getRevenuePrediction?: GraphQLTypes["RevenuePrediction"] | undefined,
	listRevenuePrediction: Array<GraphQLTypes["RevenuePrediction"]>,
	paginateRevenuePrediction: GraphQLTypes["RevenuePredictionConnection"],
	validateCreateRevenuePrediction: GraphQLTypes["_ValidationResult"],
	validateUpdateRevenuePrediction: GraphQLTypes["_ValidationResult"],
	getRevenuePredictionChange?: GraphQLTypes["RevenuePredictionChange"] | undefined,
	listRevenuePredictionChange: Array<GraphQLTypes["RevenuePredictionChange"]>,
	paginateRevenuePredictionChange: GraphQLTypes["RevenuePredictionChangeConnection"],
	validateCreateRevenuePredictionChange: GraphQLTypes["_ValidationResult"],
	validateUpdateRevenuePredictionChange: GraphQLTypes["_ValidationResult"],
	getFile?: GraphQLTypes["File"] | undefined,
	listFile: Array<GraphQLTypes["File"]>,
	paginateFile: GraphQLTypes["FileConnection"],
	validateCreateFile: GraphQLTypes["_ValidationResult"],
	validateUpdateFile: GraphQLTypes["_ValidationResult"],
	getExpenseTerm?: GraphQLTypes["ExpenseTerm"] | undefined,
	listExpenseTerm: Array<GraphQLTypes["ExpenseTerm"]>,
	paginateExpenseTerm: GraphQLTypes["ExpenseTermConnection"],
	getLine?: GraphQLTypes["Line"] | undefined,
	listLine: Array<GraphQLTypes["Line"]>,
	paginateLine: GraphQLTypes["LineConnection"],
	validateCreateLine: GraphQLTypes["_ValidationResult"],
	validateUpdateLine: GraphQLTypes["_ValidationResult"],
	getFinancesBalanceItem?: GraphQLTypes["FinancesBalanceItem"] | undefined,
	listFinancesBalanceItem: Array<GraphQLTypes["FinancesBalanceItem"]>,
	paginateFinancesBalanceItem: GraphQLTypes["FinancesBalanceItemConnection"],
	validateCreateFinancesBalanceItem: GraphQLTypes["_ValidationResult"],
	validateUpdateFinancesBalanceItem: GraphQLTypes["_ValidationResult"],
	getRevenuePredictionTerm?: GraphQLTypes["RevenuePredictionTerm"] | undefined,
	listRevenuePredictionTerm: Array<GraphQLTypes["RevenuePredictionTerm"]>,
	paginateRevenuePredictionTerm: GraphQLTypes["RevenuePredictionTermConnection"],
	getOrderPaymentStatsByDay?: GraphQLTypes["OrderPaymentStatsByDay"] | undefined,
	listOrderPaymentStatsByDay: Array<GraphQLTypes["OrderPaymentStatsByDay"]>,
	paginateOrderPaymentStatsByDay: GraphQLTypes["OrderPaymentStatsByDayConnection"],
	getWoltDriveDelivery?: GraphQLTypes["WoltDriveDelivery"] | undefined,
	listWoltDriveDelivery: Array<GraphQLTypes["WoltDriveDelivery"]>,
	paginateWoltDriveDelivery: GraphQLTypes["WoltDriveDeliveryConnection"],
	validateCreateWoltDriveDelivery: GraphQLTypes["_ValidationResult"],
	validateUpdateWoltDriveDelivery: GraphQLTypes["_ValidationResult"]
};
	["Info"]: {
		description?: string | undefined
};
	["Mutation"]: {
		createAddress: GraphQLTypes["AddressCreateResult"],
	deleteAddress: GraphQLTypes["AddressDeleteResult"],
	updateAddress: GraphQLTypes["AddressUpdateResult"],
	upsertAddress: GraphQLTypes["AddressUpsertResult"],
	createCountry: GraphQLTypes["CountryCreateResult"],
	deleteCountry: GraphQLTypes["CountryDeleteResult"],
	updateCountry: GraphQLTypes["CountryUpdateResult"],
	upsertCountry: GraphQLTypes["CountryUpsertResult"],
	createChannel: GraphQLTypes["ChannelCreateResult"],
	deleteChannel: GraphQLTypes["ChannelDeleteResult"],
	updateChannel: GraphQLTypes["ChannelUpdateResult"],
	upsertChannel: GraphQLTypes["ChannelUpsertResult"],
	createChannelPayment: GraphQLTypes["ChannelPaymentCreateResult"],
	deleteChannelPayment: GraphQLTypes["ChannelPaymentDeleteResult"],
	updateChannelPayment: GraphQLTypes["ChannelPaymentUpdateResult"],
	upsertChannelPayment: GraphQLTypes["ChannelPaymentUpsertResult"],
	createChannelDelivery: GraphQLTypes["ChannelDeliveryCreateResult"],
	deleteChannelDelivery: GraphQLTypes["ChannelDeliveryDeleteResult"],
	updateChannelDelivery: GraphQLTypes["ChannelDeliveryUpdateResult"],
	upsertChannelDelivery: GraphQLTypes["ChannelDeliveryUpsertResult"],
	createCustomer: GraphQLTypes["CustomerCreateResult"],
	deleteCustomer: GraphQLTypes["CustomerDeleteResult"],
	updateCustomer: GraphQLTypes["CustomerUpdateResult"],
	upsertCustomer: GraphQLTypes["CustomerUpsertResult"],
	createCustomerCredit: GraphQLTypes["CustomerCreditCreateResult"],
	deleteCustomerCredit: GraphQLTypes["CustomerCreditDeleteResult"],
	updateCustomerCredit: GraphQLTypes["CustomerCreditUpdateResult"],
	upsertCustomerCredit: GraphQLTypes["CustomerCreditUpsertResult"],
	createCustomerGroup: GraphQLTypes["CustomerGroupCreateResult"],
	deleteCustomerGroup: GraphQLTypes["CustomerGroupDeleteResult"],
	updateCustomerGroup: GraphQLTypes["CustomerGroupUpdateResult"],
	upsertCustomerGroup: GraphQLTypes["CustomerGroupUpsertResult"],
	createCustomerPaymentMethod: GraphQLTypes["CustomerPaymentMethodCreateResult"],
	deleteCustomerPaymentMethod: GraphQLTypes["CustomerPaymentMethodDeleteResult"],
	updateCustomerPaymentMethod: GraphQLTypes["CustomerPaymentMethodUpdateResult"],
	upsertCustomerPaymentMethod: GraphQLTypes["CustomerPaymentMethodUpsertResult"],
	createDeliveryMethod: GraphQLTypes["DeliveryMethodCreateResult"],
	deleteDeliveryMethod: GraphQLTypes["DeliveryMethodDeleteResult"],
	updateDeliveryMethod: GraphQLTypes["DeliveryMethodUpdateResult"],
	upsertDeliveryMethod: GraphQLTypes["DeliveryMethodUpsertResult"],
	createOrder: GraphQLTypes["OrderCreateResult"],
	deleteOrder: GraphQLTypes["OrderDeleteResult"],
	updateOrder: GraphQLTypes["OrderUpdateResult"],
	upsertOrder: GraphQLTypes["OrderUpsertResult"],
	createOrderDiscount: GraphQLTypes["OrderDiscountCreateResult"],
	deleteOrderDiscount: GraphQLTypes["OrderDiscountDeleteResult"],
	updateOrderDiscount: GraphQLTypes["OrderDiscountUpdateResult"],
	upsertOrderDiscount: GraphQLTypes["OrderDiscountUpsertResult"],
	createOrderPayment: GraphQLTypes["OrderPaymentCreateResult"],
	deleteOrderPayment: GraphQLTypes["OrderPaymentDeleteResult"],
	updateOrderPayment: GraphQLTypes["OrderPaymentUpdateResult"],
	upsertOrderPayment: GraphQLTypes["OrderPaymentUpsertResult"],
	createOrderDelivery: GraphQLTypes["OrderDeliveryCreateResult"],
	deleteOrderDelivery: GraphQLTypes["OrderDeliveryDeleteResult"],
	updateOrderDelivery: GraphQLTypes["OrderDeliveryUpdateResult"],
	upsertOrderDelivery: GraphQLTypes["OrderDeliveryUpsertResult"],
	createOrderItem: GraphQLTypes["OrderItemCreateResult"],
	deleteOrderItem: GraphQLTypes["OrderItemDeleteResult"],
	updateOrderItem: GraphQLTypes["OrderItemUpdateResult"],
	upsertOrderItem: GraphQLTypes["OrderItemUpsertResult"],
	createPaymentMethod: GraphQLTypes["PaymentMethodCreateResult"],
	deletePaymentMethod: GraphQLTypes["PaymentMethodDeleteResult"],
	updatePaymentMethod: GraphQLTypes["PaymentMethodUpdateResult"],
	upsertPaymentMethod: GraphQLTypes["PaymentMethodUpsertResult"],
	createVatRate: GraphQLTypes["VatRateCreateResult"],
	deleteVatRate: GraphQLTypes["VatRateDeleteResult"],
	updateVatRate: GraphQLTypes["VatRateUpdateResult"],
	upsertVatRate: GraphQLTypes["VatRateUpsertResult"],
	createProduct: GraphQLTypes["ProductCreateResult"],
	deleteProduct: GraphQLTypes["ProductDeleteResult"],
	updateProduct: GraphQLTypes["ProductUpdateResult"],
	upsertProduct: GraphQLTypes["ProductUpsertResult"],
	createProductStock: GraphQLTypes["ProductStockCreateResult"],
	deleteProductStock: GraphQLTypes["ProductStockDeleteResult"],
	updateProductStock: GraphQLTypes["ProductStockUpdateResult"],
	upsertProductStock: GraphQLTypes["ProductStockUpsertResult"],
	createProductPacking: GraphQLTypes["ProductPackingCreateResult"],
	deleteProductPacking: GraphQLTypes["ProductPackingDeleteResult"],
	updateProductPacking: GraphQLTypes["ProductPackingUpdateResult"],
	upsertProductPacking: GraphQLTypes["ProductPackingUpsertResult"],
	createProductGroupPrice: GraphQLTypes["ProductGroupPriceCreateResult"],
	deleteProductGroupPrice: GraphQLTypes["ProductGroupPriceDeleteResult"],
	updateProductGroupPrice: GraphQLTypes["ProductGroupPriceUpdateResult"],
	upsertProductGroupPrice: GraphQLTypes["ProductGroupPriceUpsertResult"],
	createProductRecipe: GraphQLTypes["ProductRecipeCreateResult"],
	deleteProductRecipe: GraphQLTypes["ProductRecipeDeleteResult"],
	updateProductRecipe: GraphQLTypes["ProductRecipeUpdateResult"],
	upsertProductRecipe: GraphQLTypes["ProductRecipeUpsertResult"],
	createProductCategory: GraphQLTypes["ProductCategoryCreateResult"],
	deleteProductCategory: GraphQLTypes["ProductCategoryDeleteResult"],
	updateProductCategory: GraphQLTypes["ProductCategoryUpdateResult"],
	upsertProductCategory: GraphQLTypes["ProductCategoryUpsertResult"],
	createStore: GraphQLTypes["StoreCreateResult"],
	deleteStore: GraphQLTypes["StoreDeleteResult"],
	updateStore: GraphQLTypes["StoreUpdateResult"],
	upsertStore: GraphQLTypes["StoreUpsertResult"],
	createTag: GraphQLTypes["TagCreateResult"],
	deleteTag: GraphQLTypes["TagDeleteResult"],
	updateTag: GraphQLTypes["TagUpdateResult"],
	upsertTag: GraphQLTypes["TagUpsertResult"],
	createImage: GraphQLTypes["ImageCreateResult"],
	deleteImage: GraphQLTypes["ImageDeleteResult"],
	updateImage: GraphQLTypes["ImageUpdateResult"],
	upsertImage: GraphQLTypes["ImageUpsertResult"],
	createBusinessCategory: GraphQLTypes["BusinessCategoryCreateResult"],
	deleteBusinessCategory: GraphQLTypes["BusinessCategoryDeleteResult"],
	updateBusinessCategory: GraphQLTypes["BusinessCategoryUpdateResult"],
	upsertBusinessCategory: GraphQLTypes["BusinessCategoryUpsertResult"],
	createProductList: GraphQLTypes["ProductListCreateResult"],
	deleteProductList: GraphQLTypes["ProductListDeleteResult"],
	updateProductList: GraphQLTypes["ProductListUpdateResult"],
	upsertProductList: GraphQLTypes["ProductListUpsertResult"],
	createProductListItem: GraphQLTypes["ProductListItemCreateResult"],
	deleteProductListItem: GraphQLTypes["ProductListItemDeleteResult"],
	updateProductListItem: GraphQLTypes["ProductListItemUpdateResult"],
	upsertProductListItem: GraphQLTypes["ProductListItemUpsertResult"],
	createProductCategoryList: GraphQLTypes["ProductCategoryListCreateResult"],
	deleteProductCategoryList: GraphQLTypes["ProductCategoryListDeleteResult"],
	updateProductCategoryList: GraphQLTypes["ProductCategoryListUpdateResult"],
	upsertProductCategoryList: GraphQLTypes["ProductCategoryListUpsertResult"],
	createProductCategoryListItem: GraphQLTypes["ProductCategoryListItemCreateResult"],
	deleteProductCategoryListItem: GraphQLTypes["ProductCategoryListItemDeleteResult"],
	updateProductCategoryListItem: GraphQLTypes["ProductCategoryListItemUpdateResult"],
	upsertProductCategoryListItem: GraphQLTypes["ProductCategoryListItemUpsertResult"],
	createBusinessCategoryLocale: GraphQLTypes["BusinessCategoryLocaleCreateResult"],
	deleteBusinessCategoryLocale: GraphQLTypes["BusinessCategoryLocaleDeleteResult"],
	updateBusinessCategoryLocale: GraphQLTypes["BusinessCategoryLocaleUpdateResult"],
	upsertBusinessCategoryLocale: GraphQLTypes["BusinessCategoryLocaleUpsertResult"],
	createLocale: GraphQLTypes["LocaleCreateResult"],
	deleteLocale: GraphQLTypes["LocaleDeleteResult"],
	updateLocale: GraphQLTypes["LocaleUpdateResult"],
	upsertLocale: GraphQLTypes["LocaleUpsertResult"],
	createProductCategoryListLocale: GraphQLTypes["ProductCategoryListLocaleCreateResult"],
	deleteProductCategoryListLocale: GraphQLTypes["ProductCategoryListLocaleDeleteResult"],
	updateProductCategoryListLocale: GraphQLTypes["ProductCategoryListLocaleUpdateResult"],
	upsertProductCategoryListLocale: GraphQLTypes["ProductCategoryListLocaleUpsertResult"],
	createCustomerName: GraphQLTypes["CustomerNameCreateResult"],
	deleteCustomerName: GraphQLTypes["CustomerNameDeleteResult"],
	updateCustomerName: GraphQLTypes["CustomerNameUpdateResult"],
	upsertCustomerName: GraphQLTypes["CustomerNameUpsertResult"],
	createCustomerAlias: GraphQLTypes["CustomerAliasCreateResult"],
	deleteCustomerAlias: GraphQLTypes["CustomerAliasDeleteResult"],
	updateCustomerAlias: GraphQLTypes["CustomerAliasUpdateResult"],
	upsertCustomerAlias: GraphQLTypes["CustomerAliasUpsertResult"],
	createProductIngredientItem: GraphQLTypes["ProductIngredientItemCreateResult"],
	deleteProductIngredientItem: GraphQLTypes["ProductIngredientItemDeleteResult"],
	updateProductIngredientItem: GraphQLTypes["ProductIngredientItemUpdateResult"],
	upsertProductIngredientItem: GraphQLTypes["ProductIngredientItemUpsertResult"],
	createProductIngredientItemQuantity: GraphQLTypes["ProductIngredientItemQuantityCreateResult"],
	deleteProductIngredientItemQuantity: GraphQLTypes["ProductIngredientItemQuantityDeleteResult"],
	updateProductIngredientItemQuantity: GraphQLTypes["ProductIngredientItemQuantityUpdateResult"],
	upsertProductIngredientItemQuantity: GraphQLTypes["ProductIngredientItemQuantityUpsertResult"],
	createProductIngredientItemQuantityUnit: GraphQLTypes["ProductIngredientItemQuantityUnitCreateResult"],
	deleteProductIngredientItemQuantityUnit: GraphQLTypes["ProductIngredientItemQuantityUnitDeleteResult"],
	updateProductIngredientItemQuantityUnit: GraphQLTypes["ProductIngredientItemQuantityUnitUpdateResult"],
	upsertProductIngredientItemQuantityUnit: GraphQLTypes["ProductIngredientItemQuantityUnitUpsertResult"],
	createProductIngredient: GraphQLTypes["ProductIngredientCreateResult"],
	deleteProductIngredient: GraphQLTypes["ProductIngredientDeleteResult"],
	updateProductIngredient: GraphQLTypes["ProductIngredientUpdateResult"],
	upsertProductIngredient: GraphQLTypes["ProductIngredientUpsertResult"],
	createCustomerIngredientRating: GraphQLTypes["CustomerIngredientRatingCreateResult"],
	deleteCustomerIngredientRating: GraphQLTypes["CustomerIngredientRatingDeleteResult"],
	updateCustomerIngredientRating: GraphQLTypes["CustomerIngredientRatingUpdateResult"],
	upsertCustomerIngredientRating: GraphQLTypes["CustomerIngredientRatingUpsertResult"],
	createProductIngredientRating: GraphQLTypes["ProductIngredientRatingCreateResult"],
	deleteProductIngredientRating: GraphQLTypes["ProductIngredientRatingDeleteResult"],
	updateProductIngredientRating: GraphQLTypes["ProductIngredientRatingUpdateResult"],
	upsertProductIngredientRating: GraphQLTypes["ProductIngredientRatingUpsertResult"],
	createProductIngredientLocale: GraphQLTypes["ProductIngredientLocaleCreateResult"],
	deleteProductIngredientLocale: GraphQLTypes["ProductIngredientLocaleDeleteResult"],
	updateProductIngredientLocale: GraphQLTypes["ProductIngredientLocaleUpdateResult"],
	upsertProductIngredientLocale: GraphQLTypes["ProductIngredientLocaleUpsertResult"],
	createOrderRecurrence: GraphQLTypes["OrderRecurrenceCreateResult"],
	deleteOrderRecurrence: GraphQLTypes["OrderRecurrenceDeleteResult"],
	updateOrderRecurrence: GraphQLTypes["OrderRecurrenceUpdateResult"],
	upsertOrderRecurrence: GraphQLTypes["OrderRecurrenceUpsertResult"],
	createOrderRecurrenceLocale: GraphQLTypes["OrderRecurrenceLocaleCreateResult"],
	deleteOrderRecurrenceLocale: GraphQLTypes["OrderRecurrenceLocaleDeleteResult"],
	updateOrderRecurrenceLocale: GraphQLTypes["OrderRecurrenceLocaleUpdateResult"],
	upsertOrderRecurrenceLocale: GraphQLTypes["OrderRecurrenceLocaleUpsertResult"],
	createBusinessCustomer: GraphQLTypes["BusinessCustomerCreateResult"],
	deleteBusinessCustomer: GraphQLTypes["BusinessCustomerDeleteResult"],
	updateBusinessCustomer: GraphQLTypes["BusinessCustomerUpdateResult"],
	upsertBusinessCustomer: GraphQLTypes["BusinessCustomerUpsertResult"],
	createPointOfSale: GraphQLTypes["PointOfSaleCreateResult"],
	deletePointOfSale: GraphQLTypes["PointOfSaleDeleteResult"],
	updatePointOfSale: GraphQLTypes["PointOfSaleUpdateResult"],
	upsertPointOfSale: GraphQLTypes["PointOfSaleUpsertResult"],
	createStaff: GraphQLTypes["StaffCreateResult"],
	deleteStaff: GraphQLTypes["StaffDeleteResult"],
	updateStaff: GraphQLTypes["StaffUpdateResult"],
	upsertStaff: GraphQLTypes["StaffUpsertResult"],
	createBlog: GraphQLTypes["BlogCreateResult"],
	deleteBlog: GraphQLTypes["BlogDeleteResult"],
	updateBlog: GraphQLTypes["BlogUpdateResult"],
	upsertBlog: GraphQLTypes["BlogUpsertResult"],
	createBlogLocale: GraphQLTypes["BlogLocaleCreateResult"],
	deleteBlogLocale: GraphQLTypes["BlogLocaleDeleteResult"],
	updateBlogLocale: GraphQLTypes["BlogLocaleUpdateResult"],
	upsertBlogLocale: GraphQLTypes["BlogLocaleUpsertResult"],
	createBlogPost: GraphQLTypes["BlogPostCreateResult"],
	deleteBlogPost: GraphQLTypes["BlogPostDeleteResult"],
	updateBlogPost: GraphQLTypes["BlogPostUpdateResult"],
	upsertBlogPost: GraphQLTypes["BlogPostUpsertResult"],
	createBlogPostLocale: GraphQLTypes["BlogPostLocaleCreateResult"],
	deleteBlogPostLocale: GraphQLTypes["BlogPostLocaleDeleteResult"],
	updateBlogPostLocale: GraphQLTypes["BlogPostLocaleUpdateResult"],
	upsertBlogPostLocale: GraphQLTypes["BlogPostLocaleUpsertResult"],
	createColorPallete: GraphQLTypes["ColorPalleteCreateResult"],
	deleteColorPallete: GraphQLTypes["ColorPalleteDeleteResult"],
	updateColorPallete: GraphQLTypes["ColorPalleteUpdateResult"],
	upsertColorPallete: GraphQLTypes["ColorPalleteUpsertResult"],
	createContent: GraphQLTypes["ContentCreateResult"],
	deleteContent: GraphQLTypes["ContentDeleteResult"],
	updateContent: GraphQLTypes["ContentUpdateResult"],
	upsertContent: GraphQLTypes["ContentUpsertResult"],
	createContentBlock: GraphQLTypes["ContentBlockCreateResult"],
	deleteContentBlock: GraphQLTypes["ContentBlockDeleteResult"],
	updateContentBlock: GraphQLTypes["ContentBlockUpdateResult"],
	upsertContentBlock: GraphQLTypes["ContentBlockUpsertResult"],
	createContentReference: GraphQLTypes["ContentReferenceCreateResult"],
	deleteContentReference: GraphQLTypes["ContentReferenceDeleteResult"],
	updateContentReference: GraphQLTypes["ContentReferenceUpdateResult"],
	upsertContentReference: GraphQLTypes["ContentReferenceUpsertResult"],
	createBlogPostList: GraphQLTypes["BlogPostListCreateResult"],
	deleteBlogPostList: GraphQLTypes["BlogPostListDeleteResult"],
	updateBlogPostList: GraphQLTypes["BlogPostListUpdateResult"],
	upsertBlogPostList: GraphQLTypes["BlogPostListUpsertResult"],
	createBlogPostListItem: GraphQLTypes["BlogPostListItemCreateResult"],
	deleteBlogPostListItem: GraphQLTypes["BlogPostListItemDeleteResult"],
	updateBlogPostListItem: GraphQLTypes["BlogPostListItemUpdateResult"],
	upsertBlogPostListItem: GraphQLTypes["BlogPostListItemUpsertResult"],
	createLinkList: GraphQLTypes["LinkListCreateResult"],
	deleteLinkList: GraphQLTypes["LinkListDeleteResult"],
	updateLinkList: GraphQLTypes["LinkListUpdateResult"],
	upsertLinkList: GraphQLTypes["LinkListUpsertResult"],
	createLinkListItem: GraphQLTypes["LinkListItemCreateResult"],
	deleteLinkListItem: GraphQLTypes["LinkListItemDeleteResult"],
	updateLinkListItem: GraphQLTypes["LinkListItemUpdateResult"],
	upsertLinkListItem: GraphQLTypes["LinkListItemUpsertResult"],
	createCover: GraphQLTypes["CoverCreateResult"],
	deleteCover: GraphQLTypes["CoverDeleteResult"],
	updateCover: GraphQLTypes["CoverUpdateResult"],
	upsertCover: GraphQLTypes["CoverUpsertResult"],
	createLink: GraphQLTypes["LinkCreateResult"],
	deleteLink: GraphQLTypes["LinkDeleteResult"],
	updateLink: GraphQLTypes["LinkUpdateResult"],
	upsertLink: GraphQLTypes["LinkUpsertResult"],
	createLinkable: GraphQLTypes["LinkableCreateResult"],
	deleteLinkable: GraphQLTypes["LinkableDeleteResult"],
	updateLinkable: GraphQLTypes["LinkableUpdateResult"],
	upsertLinkable: GraphQLTypes["LinkableUpsertResult"],
	createMedium: GraphQLTypes["MediumCreateResult"],
	deleteMedium: GraphQLTypes["MediumDeleteResult"],
	updateMedium: GraphQLTypes["MediumUpdateResult"],
	upsertMedium: GraphQLTypes["MediumUpsertResult"],
	createVideo: GraphQLTypes["VideoCreateResult"],
	deleteVideo: GraphQLTypes["VideoDeleteResult"],
	updateVideo: GraphQLTypes["VideoUpdateResult"],
	upsertVideo: GraphQLTypes["VideoUpsertResult"],
	createSeo: GraphQLTypes["SeoCreateResult"],
	deleteSeo: GraphQLTypes["SeoDeleteResult"],
	updateSeo: GraphQLTypes["SeoUpdateResult"],
	upsertSeo: GraphQLTypes["SeoUpsertResult"],
	createProtectedImage: GraphQLTypes["ProtectedImageCreateResult"],
	deleteProtectedImage: GraphQLTypes["ProtectedImageDeleteResult"],
	updateProtectedImage: GraphQLTypes["ProtectedImageUpdateResult"],
	upsertProtectedImage: GraphQLTypes["ProtectedImageUpsertResult"],
	createTranslationDomain: GraphQLTypes["TranslationDomainCreateResult"],
	deleteTranslationDomain: GraphQLTypes["TranslationDomainDeleteResult"],
	updateTranslationDomain: GraphQLTypes["TranslationDomainUpdateResult"],
	upsertTranslationDomain: GraphQLTypes["TranslationDomainUpsertResult"],
	createTranslationCatalogue: GraphQLTypes["TranslationCatalogueCreateResult"],
	deleteTranslationCatalogue: GraphQLTypes["TranslationCatalogueDeleteResult"],
	updateTranslationCatalogue: GraphQLTypes["TranslationCatalogueUpdateResult"],
	upsertTranslationCatalogue: GraphQLTypes["TranslationCatalogueUpsertResult"],
	createTranslationKey: GraphQLTypes["TranslationKeyCreateResult"],
	deleteTranslationKey: GraphQLTypes["TranslationKeyDeleteResult"],
	updateTranslationKey: GraphQLTypes["TranslationKeyUpdateResult"],
	upsertTranslationKey: GraphQLTypes["TranslationKeyUpsertResult"],
	createTranslationValue: GraphQLTypes["TranslationValueCreateResult"],
	deleteTranslationValue: GraphQLTypes["TranslationValueDeleteResult"],
	updateTranslationValue: GraphQLTypes["TranslationValueUpdateResult"],
	upsertTranslationValue: GraphQLTypes["TranslationValueUpsertResult"],
	createTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierCreateResult"],
	deleteTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierDeleteResult"],
	updateTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierUpdateResult"],
	upsertTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierUpsertResult"],
	createSocialsAndApps: GraphQLTypes["SocialsAndAppsCreateResult"],
	deleteSocialsAndApps: GraphQLTypes["SocialsAndAppsDeleteResult"],
	updateSocialsAndApps: GraphQLTypes["SocialsAndAppsUpdateResult"],
	upsertSocialsAndApps: GraphQLTypes["SocialsAndAppsUpsertResult"],
	createProductGrid: GraphQLTypes["ProductGridCreateResult"],
	deleteProductGrid: GraphQLTypes["ProductGridDeleteResult"],
	updateProductGrid: GraphQLTypes["ProductGridUpdateResult"],
	upsertProductGrid: GraphQLTypes["ProductGridUpsertResult"],
	createProductGridItem: GraphQLTypes["ProductGridItemCreateResult"],
	deleteProductGridItem: GraphQLTypes["ProductGridItemDeleteResult"],
	updateProductGridItem: GraphQLTypes["ProductGridItemUpdateResult"],
	upsertProductGridItem: GraphQLTypes["ProductGridItemUpsertResult"],
	createGallery: GraphQLTypes["GalleryCreateResult"],
	deleteGallery: GraphQLTypes["GalleryDeleteResult"],
	updateGallery: GraphQLTypes["GalleryUpdateResult"],
	upsertGallery: GraphQLTypes["GalleryUpsertResult"],
	createGalleryItem: GraphQLTypes["GalleryItemCreateResult"],
	deleteGalleryItem: GraphQLTypes["GalleryItemDeleteResult"],
	updateGalleryItem: GraphQLTypes["GalleryItemUpdateResult"],
	upsertGalleryItem: GraphQLTypes["GalleryItemUpsertResult"],
	createHero: GraphQLTypes["HeroCreateResult"],
	deleteHero: GraphQLTypes["HeroDeleteResult"],
	updateHero: GraphQLTypes["HeroUpdateResult"],
	upsertHero: GraphQLTypes["HeroUpsertResult"],
	createSiteMenu: GraphQLTypes["SiteMenuCreateResult"],
	deleteSiteMenu: GraphQLTypes["SiteMenuDeleteResult"],
	updateSiteMenu: GraphQLTypes["SiteMenuUpdateResult"],
	upsertSiteMenu: GraphQLTypes["SiteMenuUpsertResult"],
	createMenuLocale: GraphQLTypes["MenuLocaleCreateResult"],
	deleteMenuLocale: GraphQLTypes["MenuLocaleDeleteResult"],
	updateMenuLocale: GraphQLTypes["MenuLocaleUpdateResult"],
	upsertMenuLocale: GraphQLTypes["MenuLocaleUpsertResult"],
	createMenuItem: GraphQLTypes["MenuItemCreateResult"],
	deleteMenuItem: GraphQLTypes["MenuItemDeleteResult"],
	updateMenuItem: GraphQLTypes["MenuItemUpdateResult"],
	upsertMenuItem: GraphQLTypes["MenuItemUpsertResult"],
	createPage: GraphQLTypes["PageCreateResult"],
	deletePage: GraphQLTypes["PageDeleteResult"],
	updatePage: GraphQLTypes["PageUpdateResult"],
	upsertPage: GraphQLTypes["PageUpsertResult"],
	createPageLocale: GraphQLTypes["PageLocaleCreateResult"],
	deletePageLocale: GraphQLTypes["PageLocaleDeleteResult"],
	updatePageLocale: GraphQLTypes["PageLocaleUpdateResult"],
	upsertPageLocale: GraphQLTypes["PageLocaleUpsertResult"],
	createWikiPage: GraphQLTypes["WikiPageCreateResult"],
	deleteWikiPage: GraphQLTypes["WikiPageDeleteResult"],
	updateWikiPage: GraphQLTypes["WikiPageUpdateResult"],
	upsertWikiPage: GraphQLTypes["WikiPageUpsertResult"],
	createMenuSubitem: GraphQLTypes["MenuSubitemCreateResult"],
	deleteMenuSubitem: GraphQLTypes["MenuSubitemDeleteResult"],
	updateMenuSubitem: GraphQLTypes["MenuSubitemUpdateResult"],
	upsertMenuSubitem: GraphQLTypes["MenuSubitemUpsertResult"],
	createMenuLinkList: GraphQLTypes["MenuLinkListCreateResult"],
	deleteMenuLinkList: GraphQLTypes["MenuLinkListDeleteResult"],
	updateMenuLinkList: GraphQLTypes["MenuLinkListUpdateResult"],
	upsertMenuLinkList: GraphQLTypes["MenuLinkListUpsertResult"],
	createMenuLinkItem: GraphQLTypes["MenuLinkItemCreateResult"],
	deleteMenuLinkItem: GraphQLTypes["MenuLinkItemDeleteResult"],
	updateMenuLinkItem: GraphQLTypes["MenuLinkItemUpdateResult"],
	upsertMenuLinkItem: GraphQLTypes["MenuLinkItemUpsertResult"],
	createMenuProducts: GraphQLTypes["MenuProductsCreateResult"],
	deleteMenuProducts: GraphQLTypes["MenuProductsDeleteResult"],
	updateMenuProducts: GraphQLTypes["MenuProductsUpdateResult"],
	upsertMenuProducts: GraphQLTypes["MenuProductsUpsertResult"],
	createMenuDelivery: GraphQLTypes["MenuDeliveryCreateResult"],
	deleteMenuDelivery: GraphQLTypes["MenuDeliveryDeleteResult"],
	updateMenuDelivery: GraphQLTypes["MenuDeliveryUpdateResult"],
	upsertMenuDelivery: GraphQLTypes["MenuDeliveryUpsertResult"],
	createMenuContact: GraphQLTypes["MenuContactCreateResult"],
	deleteMenuContact: GraphQLTypes["MenuContactDeleteResult"],
	updateMenuContact: GraphQLTypes["MenuContactUpdateResult"],
	upsertMenuContact: GraphQLTypes["MenuContactUpsertResult"],
	createDeadlineTemplate: GraphQLTypes["DeadlineTemplateCreateResult"],
	deleteDeadlineTemplate: GraphQLTypes["DeadlineTemplateDeleteResult"],
	updateDeadlineTemplate: GraphQLTypes["DeadlineTemplateUpdateResult"],
	upsertDeadlineTemplate: GraphQLTypes["DeadlineTemplateUpsertResult"],
	createEmployeeQueue: GraphQLTypes["EmployeeQueueCreateResult"],
	deleteEmployeeQueue: GraphQLTypes["EmployeeQueueDeleteResult"],
	updateEmployeeQueue: GraphQLTypes["EmployeeQueueUpdateResult"],
	upsertEmployeeQueue: GraphQLTypes["EmployeeQueueUpsertResult"],
	createTimetableDay: GraphQLTypes["TimetableDayCreateResult"],
	deleteTimetableDay: GraphQLTypes["TimetableDayDeleteResult"],
	updateTimetableDay: GraphQLTypes["TimetableDayUpdateResult"],
	upsertTimetableDay: GraphQLTypes["TimetableDayUpsertResult"],
	createTimetableEmployeeRole: GraphQLTypes["TimetableEmployeeRoleCreateResult"],
	deleteTimetableEmployeeRole: GraphQLTypes["TimetableEmployeeRoleDeleteResult"],
	updateTimetableEmployeeRole: GraphQLTypes["TimetableEmployeeRoleUpdateResult"],
	upsertTimetableEmployeeRole: GraphQLTypes["TimetableEmployeeRoleUpsertResult"],
	createTimetableShift: GraphQLTypes["TimetableShiftCreateResult"],
	deleteTimetableShift: GraphQLTypes["TimetableShiftDeleteResult"],
	updateTimetableShift: GraphQLTypes["TimetableShiftUpdateResult"],
	upsertTimetableShift: GraphQLTypes["TimetableShiftUpsertResult"],
	createTimetableShiftGroup: GraphQLTypes["TimetableShiftGroupCreateResult"],
	deleteTimetableShiftGroup: GraphQLTypes["TimetableShiftGroupDeleteResult"],
	updateTimetableShiftGroup: GraphQLTypes["TimetableShiftGroupUpdateResult"],
	upsertTimetableShiftGroup: GraphQLTypes["TimetableShiftGroupUpsertResult"],
	createTimetableShiftPosition: GraphQLTypes["TimetableShiftPositionCreateResult"],
	deleteTimetableShiftPosition: GraphQLTypes["TimetableShiftPositionDeleteResult"],
	updateTimetableShiftPosition: GraphQLTypes["TimetableShiftPositionUpdateResult"],
	upsertTimetableShiftPosition: GraphQLTypes["TimetableShiftPositionUpsertResult"],
	createTimetableTemplate: GraphQLTypes["TimetableTemplateCreateResult"],
	deleteTimetableTemplate: GraphQLTypes["TimetableTemplateDeleteResult"],
	updateTimetableTemplate: GraphQLTypes["TimetableTemplateUpdateResult"],
	upsertTimetableTemplate: GraphQLTypes["TimetableTemplateUpsertResult"],
	createCart: GraphQLTypes["CartCreateResult"],
	deleteCart: GraphQLTypes["CartDeleteResult"],
	updateCart: GraphQLTypes["CartUpdateResult"],
	upsertCart: GraphQLTypes["CartUpsertResult"],
	createCartItem: GraphQLTypes["CartItemCreateResult"],
	deleteCartItem: GraphQLTypes["CartItemDeleteResult"],
	updateCartItem: GraphQLTypes["CartItemUpdateResult"],
	upsertCartItem: GraphQLTypes["CartItemUpsertResult"],
	createEmployeeQueueItem: GraphQLTypes["EmployeeQueueItemCreateResult"],
	deleteEmployeeQueueItem: GraphQLTypes["EmployeeQueueItemDeleteResult"],
	updateEmployeeQueueItem: GraphQLTypes["EmployeeQueueItemUpdateResult"],
	upsertEmployeeQueueItem: GraphQLTypes["EmployeeQueueItemUpsertResult"],
	createApplication: GraphQLTypes["ApplicationCreateResult"],
	deleteApplication: GraphQLTypes["ApplicationDeleteResult"],
	updateApplication: GraphQLTypes["ApplicationUpdateResult"],
	upsertApplication: GraphQLTypes["ApplicationUpsertResult"],
	createApplicationShortcutList: GraphQLTypes["ApplicationShortcutListCreateResult"],
	deleteApplicationShortcutList: GraphQLTypes["ApplicationShortcutListDeleteResult"],
	updateApplicationShortcutList: GraphQLTypes["ApplicationShortcutListUpdateResult"],
	upsertApplicationShortcutList: GraphQLTypes["ApplicationShortcutListUpsertResult"],
	createApplicationShortcutListItem: GraphQLTypes["ApplicationShortcutListItemCreateResult"],
	deleteApplicationShortcutListItem: GraphQLTypes["ApplicationShortcutListItemDeleteResult"],
	updateApplicationShortcutListItem: GraphQLTypes["ApplicationShortcutListItemUpdateResult"],
	upsertApplicationShortcutListItem: GraphQLTypes["ApplicationShortcutListItemUpsertResult"],
	createProductBanner: GraphQLTypes["ProductBannerCreateResult"],
	deleteProductBanner: GraphQLTypes["ProductBannerDeleteResult"],
	updateProductBanner: GraphQLTypes["ProductBannerUpdateResult"],
	upsertProductBanner: GraphQLTypes["ProductBannerUpsertResult"],
	createProductBannerItem: GraphQLTypes["ProductBannerItemCreateResult"],
	deleteProductBannerItem: GraphQLTypes["ProductBannerItemDeleteResult"],
	updateProductBannerItem: GraphQLTypes["ProductBannerItemUpdateResult"],
	upsertProductBannerItem: GraphQLTypes["ProductBannerItemUpsertResult"],
	createProductBannerList: GraphQLTypes["ProductBannerListCreateResult"],
	deleteProductBannerList: GraphQLTypes["ProductBannerListDeleteResult"],
	updateProductBannerList: GraphQLTypes["ProductBannerListUpdateResult"],
	upsertProductBannerList: GraphQLTypes["ProductBannerListUpsertResult"],
	createBartender: GraphQLTypes["BartenderCreateResult"],
	deleteBartender: GraphQLTypes["BartenderDeleteResult"],
	updateBartender: GraphQLTypes["BartenderUpdateResult"],
	upsertBartender: GraphQLTypes["BartenderUpsertResult"],
	createBusinessToBusinessManager: GraphQLTypes["BusinessToBusinessManagerCreateResult"],
	deleteBusinessToBusinessManager: GraphQLTypes["BusinessToBusinessManagerDeleteResult"],
	updateBusinessToBusinessManager: GraphQLTypes["BusinessToBusinessManagerUpdateResult"],
	upsertBusinessToBusinessManager: GraphQLTypes["BusinessToBusinessManagerUpsertResult"],
	createCleaner: GraphQLTypes["CleanerCreateResult"],
	deleteCleaner: GraphQLTypes["CleanerDeleteResult"],
	updateCleaner: GraphQLTypes["CleanerUpdateResult"],
	upsertCleaner: GraphQLTypes["CleanerUpsertResult"],
	createCourier: GraphQLTypes["CourierCreateResult"],
	deleteCourier: GraphQLTypes["CourierDeleteResult"],
	updateCourier: GraphQLTypes["CourierUpdateResult"],
	upsertCourier: GraphQLTypes["CourierUpsertResult"],
	createShiftsManager: GraphQLTypes["ShiftsManagerCreateResult"],
	deleteShiftsManager: GraphQLTypes["ShiftsManagerDeleteResult"],
	updateShiftsManager: GraphQLTypes["ShiftsManagerUpdateResult"],
	upsertShiftsManager: GraphQLTypes["ShiftsManagerUpsertResult"],
	createUser: GraphQLTypes["UserCreateResult"],
	deleteUser: GraphQLTypes["UserDeleteResult"],
	updateUser: GraphQLTypes["UserUpdateResult"],
	upsertUser: GraphQLTypes["UserUpsertResult"],
	createShiftsProfile: GraphQLTypes["ShiftsProfileCreateResult"],
	deleteShiftsProfile: GraphQLTypes["ShiftsProfileDeleteResult"],
	updateShiftsProfile: GraphQLTypes["ShiftsProfileUpdateResult"],
	upsertShiftsProfile: GraphQLTypes["ShiftsProfileUpsertResult"],
	createProductIngredientCategory: GraphQLTypes["ProductIngredientCategoryCreateResult"],
	deleteProductIngredientCategory: GraphQLTypes["ProductIngredientCategoryDeleteResult"],
	updateProductIngredientCategory: GraphQLTypes["ProductIngredientCategoryUpdateResult"],
	upsertProductIngredientCategory: GraphQLTypes["ProductIngredientCategoryUpsertResult"],
	createProductIngredientCategoryLocale: GraphQLTypes["ProductIngredientCategoryLocaleCreateResult"],
	deleteProductIngredientCategoryLocale: GraphQLTypes["ProductIngredientCategoryLocaleDeleteResult"],
	updateProductIngredientCategoryLocale: GraphQLTypes["ProductIngredientCategoryLocaleUpdateResult"],
	upsertProductIngredientCategoryLocale: GraphQLTypes["ProductIngredientCategoryLocaleUpsertResult"],
	createStocksManager: GraphQLTypes["StocksManagerCreateResult"],
	deleteStocksManager: GraphQLTypes["StocksManagerDeleteResult"],
	updateStocksManager: GraphQLTypes["StocksManagerUpdateResult"],
	upsertStocksManager: GraphQLTypes["StocksManagerUpsertResult"],
	createDeliveryRoute: GraphQLTypes["DeliveryRouteCreateResult"],
	deleteDeliveryRoute: GraphQLTypes["DeliveryRouteDeleteResult"],
	updateDeliveryRoute: GraphQLTypes["DeliveryRouteUpdateResult"],
	upsertDeliveryRoute: GraphQLTypes["DeliveryRouteUpsertResult"],
	createDeliveryWaypoint: GraphQLTypes["DeliveryWaypointCreateResult"],
	deleteDeliveryWaypoint: GraphQLTypes["DeliveryWaypointDeleteResult"],
	updateDeliveryWaypoint: GraphQLTypes["DeliveryWaypointUpdateResult"],
	upsertDeliveryWaypoint: GraphQLTypes["DeliveryWaypointUpsertResult"],
	createAllergen: GraphQLTypes["AllergenCreateResult"],
	deleteAllergen: GraphQLTypes["AllergenDeleteResult"],
	updateAllergen: GraphQLTypes["AllergenUpdateResult"],
	upsertAllergen: GraphQLTypes["AllergenUpsertResult"],
	createAllergenLocale: GraphQLTypes["AllergenLocaleCreateResult"],
	deleteAllergenLocale: GraphQLTypes["AllergenLocaleDeleteResult"],
	updateAllergenLocale: GraphQLTypes["AllergenLocaleUpdateResult"],
	upsertAllergenLocale: GraphQLTypes["AllergenLocaleUpsertResult"],
	createGps: GraphQLTypes["GpsCreateResult"],
	deleteGps: GraphQLTypes["GpsDeleteResult"],
	updateGps: GraphQLTypes["GpsUpdateResult"],
	upsertGps: GraphQLTypes["GpsUpsertResult"],
	createWeekHours: GraphQLTypes["WeekHoursCreateResult"],
	deleteWeekHours: GraphQLTypes["WeekHoursDeleteResult"],
	updateWeekHours: GraphQLTypes["WeekHoursUpdateResult"],
	upsertWeekHours: GraphQLTypes["WeekHoursUpsertResult"],
	createPreparedIngredientQuantity: GraphQLTypes["PreparedIngredientQuantityCreateResult"],
	deletePreparedIngredientQuantity: GraphQLTypes["PreparedIngredientQuantityDeleteResult"],
	updatePreparedIngredientQuantity: GraphQLTypes["PreparedIngredientQuantityUpdateResult"],
	upsertPreparedIngredientQuantity: GraphQLTypes["PreparedIngredientQuantityUpsertResult"],
	createPreparedRecipeQuantity: GraphQLTypes["PreparedRecipeQuantityCreateResult"],
	deletePreparedRecipeQuantity: GraphQLTypes["PreparedRecipeQuantityDeleteResult"],
	updatePreparedRecipeQuantity: GraphQLTypes["PreparedRecipeQuantityUpdateResult"],
	upsertPreparedRecipeQuantity: GraphQLTypes["PreparedRecipeQuantityUpsertResult"],
	createInternalOrder: GraphQLTypes["InternalOrderCreateResult"],
	deleteInternalOrder: GraphQLTypes["InternalOrderDeleteResult"],
	updateInternalOrder: GraphQLTypes["InternalOrderUpdateResult"],
	upsertInternalOrder: GraphQLTypes["InternalOrderUpsertResult"],
	createInternalOrderItem: GraphQLTypes["InternalOrderItemCreateResult"],
	deleteInternalOrderItem: GraphQLTypes["InternalOrderItemDeleteResult"],
	updateInternalOrderItem: GraphQLTypes["InternalOrderItemUpdateResult"],
	upsertInternalOrderItem: GraphQLTypes["InternalOrderItemUpsertResult"],
	createPreparedPackingQuantity: GraphQLTypes["PreparedPackingQuantityCreateResult"],
	deletePreparedPackingQuantity: GraphQLTypes["PreparedPackingQuantityDeleteResult"],
	updatePreparedPackingQuantity: GraphQLTypes["PreparedPackingQuantityUpdateResult"],
	upsertPreparedPackingQuantity: GraphQLTypes["PreparedPackingQuantityUpsertResult"],
	createCourierManager: GraphQLTypes["CourierManagerCreateResult"],
	deleteCourierManager: GraphQLTypes["CourierManagerDeleteResult"],
	updateCourierManager: GraphQLTypes["CourierManagerUpdateResult"],
	upsertCourierManager: GraphQLTypes["CourierManagerUpsertResult"],
	createDeliveryZone: GraphQLTypes["DeliveryZoneCreateResult"],
	deleteDeliveryZone: GraphQLTypes["DeliveryZoneDeleteResult"],
	updateDeliveryZone: GraphQLTypes["DeliveryZoneUpdateResult"],
	upsertDeliveryZone: GraphQLTypes["DeliveryZoneUpsertResult"],
	createDeliveryTimelinePreset: GraphQLTypes["DeliveryTimelinePresetCreateResult"],
	deleteDeliveryTimelinePreset: GraphQLTypes["DeliveryTimelinePresetDeleteResult"],
	updateDeliveryTimelinePreset: GraphQLTypes["DeliveryTimelinePresetUpdateResult"],
	upsertDeliveryTimelinePreset: GraphQLTypes["DeliveryTimelinePresetUpsertResult"],
	createOrderDeliveryTimeline: GraphQLTypes["OrderDeliveryTimelineCreateResult"],
	deleteOrderDeliveryTimeline: GraphQLTypes["OrderDeliveryTimelineDeleteResult"],
	updateOrderDeliveryTimeline: GraphQLTypes["OrderDeliveryTimelineUpdateResult"],
	upsertOrderDeliveryTimeline: GraphQLTypes["OrderDeliveryTimelineUpsertResult"],
	createOrderEvent: GraphQLTypes["OrderEventCreateResult"],
	deleteOrderEvent: GraphQLTypes["OrderEventDeleteResult"],
	updateOrderEvent: GraphQLTypes["OrderEventUpdateResult"],
	upsertOrderEvent: GraphQLTypes["OrderEventUpsertResult"],
	createLiftagoRide: GraphQLTypes["LiftagoRideCreateResult"],
	deleteLiftagoRide: GraphQLTypes["LiftagoRideDeleteResult"],
	updateLiftagoRide: GraphQLTypes["LiftagoRideUpdateResult"],
	upsertLiftagoRide: GraphQLTypes["LiftagoRideUpsertResult"],
	createInvoice: GraphQLTypes["InvoiceCreateResult"],
	deleteInvoice: GraphQLTypes["InvoiceDeleteResult"],
	updateInvoice: GraphQLTypes["InvoiceUpdateResult"],
	upsertInvoice: GraphQLTypes["InvoiceUpsertResult"],
	createInvoicingPlan: GraphQLTypes["InvoicingPlanCreateResult"],
	deleteInvoicingPlan: GraphQLTypes["InvoicingPlanDeleteResult"],
	updateInvoicingPlan: GraphQLTypes["InvoicingPlanUpdateResult"],
	upsertInvoicingPlan: GraphQLTypes["InvoicingPlanUpsertResult"],
	createProductPackingLocale: GraphQLTypes["ProductPackingLocaleCreateResult"],
	deleteProductPackingLocale: GraphQLTypes["ProductPackingLocaleDeleteResult"],
	updateProductPackingLocale: GraphQLTypes["ProductPackingLocaleUpdateResult"],
	upsertProductPackingLocale: GraphQLTypes["ProductPackingLocaleUpsertResult"],
	createProductLocale: GraphQLTypes["ProductLocaleCreateResult"],
	deleteProductLocale: GraphQLTypes["ProductLocaleDeleteResult"],
	updateProductLocale: GraphQLTypes["ProductLocaleUpdateResult"],
	upsertProductLocale: GraphQLTypes["ProductLocaleUpsertResult"],
	createProductRecipeLocale: GraphQLTypes["ProductRecipeLocaleCreateResult"],
	deleteProductRecipeLocale: GraphQLTypes["ProductRecipeLocaleDeleteResult"],
	updateProductRecipeLocale: GraphQLTypes["ProductRecipeLocaleUpdateResult"],
	upsertProductRecipeLocale: GraphQLTypes["ProductRecipeLocaleUpsertResult"],
	createUserDevice: GraphQLTypes["UserDeviceCreateResult"],
	deleteUserDevice: GraphQLTypes["UserDeviceDeleteResult"],
	updateUserDevice: GraphQLTypes["UserDeviceUpdateResult"],
	upsertUserDevice: GraphQLTypes["UserDeviceUpsertResult"],
	createProtectedAction: GraphQLTypes["ProtectedActionCreateResult"],
	deleteProtectedAction: GraphQLTypes["ProtectedActionDeleteResult"],
	updateProtectedAction: GraphQLTypes["ProtectedActionUpdateResult"],
	upsertProtectedAction: GraphQLTypes["ProtectedActionUpsertResult"],
	createPicker: GraphQLTypes["PickerCreateResult"],
	deletePicker: GraphQLTypes["PickerDeleteResult"],
	updatePicker: GraphQLTypes["PickerUpdateResult"],
	upsertPicker: GraphQLTypes["PickerUpsertResult"],
	createTimetableTemplateStaffOptions: GraphQLTypes["TimetableTemplateStaffOptionsCreateResult"],
	deleteTimetableTemplateStaffOptions: GraphQLTypes["TimetableTemplateStaffOptionsDeleteResult"],
	updateTimetableTemplateStaffOptions: GraphQLTypes["TimetableTemplateStaffOptionsUpdateResult"],
	upsertTimetableTemplateStaffOptions: GraphQLTypes["TimetableTemplateStaffOptionsUpsertResult"],
	createShoppingList: GraphQLTypes["ShoppingListCreateResult"],
	deleteShoppingList: GraphQLTypes["ShoppingListDeleteResult"],
	updateShoppingList: GraphQLTypes["ShoppingListUpdateResult"],
	upsertShoppingList: GraphQLTypes["ShoppingListUpsertResult"],
	createSuppliesPurchase: GraphQLTypes["SuppliesPurchaseCreateResult"],
	deleteSuppliesPurchase: GraphQLTypes["SuppliesPurchaseDeleteResult"],
	updateSuppliesPurchase: GraphQLTypes["SuppliesPurchaseUpdateResult"],
	upsertSuppliesPurchase: GraphQLTypes["SuppliesPurchaseUpsertResult"],
	createInvoicingPreset: GraphQLTypes["InvoicingPresetCreateResult"],
	deleteInvoicingPreset: GraphQLTypes["InvoicingPresetDeleteResult"],
	updateInvoicingPreset: GraphQLTypes["InvoicingPresetUpdateResult"],
	upsertInvoicingPreset: GraphQLTypes["InvoicingPresetUpsertResult"],
	createLogRecord: GraphQLTypes["LogRecordCreateResult"],
	deleteLogRecord: GraphQLTypes["LogRecordDeleteResult"],
	updateLogRecord: GraphQLTypes["LogRecordUpdateResult"],
	upsertLogRecord: GraphQLTypes["LogRecordUpsertResult"],
	createBillingSubject: GraphQLTypes["BillingSubjectCreateResult"],
	deleteBillingSubject: GraphQLTypes["BillingSubjectDeleteResult"],
	updateBillingSubject: GraphQLTypes["BillingSubjectUpdateResult"],
	upsertBillingSubject: GraphQLTypes["BillingSubjectUpsertResult"],
	createShoppingListItem: GraphQLTypes["ShoppingListItemCreateResult"],
	deleteShoppingListItem: GraphQLTypes["ShoppingListItemDeleteResult"],
	updateShoppingListItem: GraphQLTypes["ShoppingListItemUpdateResult"],
	upsertShoppingListItem: GraphQLTypes["ShoppingListItemUpsertResult"],
	createSuppliesPurchaseItem: GraphQLTypes["SuppliesPurchaseItemCreateResult"],
	deleteSuppliesPurchaseItem: GraphQLTypes["SuppliesPurchaseItemDeleteResult"],
	updateSuppliesPurchaseItem: GraphQLTypes["SuppliesPurchaseItemUpdateResult"],
	upsertSuppliesPurchaseItem: GraphQLTypes["SuppliesPurchaseItemUpsertResult"],
	createCustomerCreditTransaction: GraphQLTypes["CustomerCreditTransactionCreateResult"],
	deleteCustomerCreditTransaction: GraphQLTypes["CustomerCreditTransactionDeleteResult"],
	updateCustomerCreditTransaction: GraphQLTypes["CustomerCreditTransactionUpdateResult"],
	upsertCustomerCreditTransaction: GraphQLTypes["CustomerCreditTransactionUpsertResult"],
	createVirtualProduct: GraphQLTypes["VirtualProductCreateResult"],
	deleteVirtualProduct: GraphQLTypes["VirtualProductDeleteResult"],
	updateVirtualProduct: GraphQLTypes["VirtualProductUpdateResult"],
	upsertVirtualProduct: GraphQLTypes["VirtualProductUpsertResult"],
	createVirtualProductEffect: GraphQLTypes["VirtualProductEffectCreateResult"],
	deleteVirtualProductEffect: GraphQLTypes["VirtualProductEffectDeleteResult"],
	updateVirtualProductEffect: GraphQLTypes["VirtualProductEffectUpdateResult"],
	upsertVirtualProductEffect: GraphQLTypes["VirtualProductEffectUpsertResult"],
	createEmploymentInformation: GraphQLTypes["EmploymentInformationCreateResult"],
	deleteEmploymentInformation: GraphQLTypes["EmploymentInformationDeleteResult"],
	updateEmploymentInformation: GraphQLTypes["EmploymentInformationUpdateResult"],
	upsertEmploymentInformation: GraphQLTypes["EmploymentInformationUpsertResult"],
	createRemunerationProfile: GraphQLTypes["RemunerationProfileCreateResult"],
	deleteRemunerationProfile: GraphQLTypes["RemunerationProfileDeleteResult"],
	updateRemunerationProfile: GraphQLTypes["RemunerationProfileUpdateResult"],
	upsertRemunerationProfile: GraphQLTypes["RemunerationProfileUpsertResult"],
	createWorkMonth: GraphQLTypes["WorkMonthCreateResult"],
	deleteWorkMonth: GraphQLTypes["WorkMonthDeleteResult"],
	updateWorkMonth: GraphQLTypes["WorkMonthUpdateResult"],
	upsertWorkMonth: GraphQLTypes["WorkMonthUpsertResult"],
	createSalaryOptions: GraphQLTypes["SalaryOptionsCreateResult"],
	deleteSalaryOptions: GraphQLTypes["SalaryOptionsDeleteResult"],
	updateSalaryOptions: GraphQLTypes["SalaryOptionsUpdateResult"],
	upsertSalaryOptions: GraphQLTypes["SalaryOptionsUpsertResult"],
	createTimetableShiftSwapInfo: GraphQLTypes["TimetableShiftSwapInfoCreateResult"],
	deleteTimetableShiftSwapInfo: GraphQLTypes["TimetableShiftSwapInfoDeleteResult"],
	updateTimetableShiftSwapInfo: GraphQLTypes["TimetableShiftSwapInfoUpdateResult"],
	upsertTimetableShiftSwapInfo: GraphQLTypes["TimetableShiftSwapInfoUpsertResult"],
	createProductGridCategory: GraphQLTypes["ProductGridCategoryCreateResult"],
	deleteProductGridCategory: GraphQLTypes["ProductGridCategoryDeleteResult"],
	updateProductGridCategory: GraphQLTypes["ProductGridCategoryUpdateResult"],
	upsertProductGridCategory: GraphQLTypes["ProductGridCategoryUpsertResult"],
	createCashier: GraphQLTypes["CashierCreateResult"],
	deleteCashier: GraphQLTypes["CashierDeleteResult"],
	updateCashier: GraphQLTypes["CashierUpdateResult"],
	upsertCashier: GraphQLTypes["CashierUpsertResult"],
	createPointOfSaleCategory: GraphQLTypes["PointOfSaleCategoryCreateResult"],
	deletePointOfSaleCategory: GraphQLTypes["PointOfSaleCategoryDeleteResult"],
	updatePointOfSaleCategory: GraphQLTypes["PointOfSaleCategoryUpdateResult"],
	upsertPointOfSaleCategory: GraphQLTypes["PointOfSaleCategoryUpsertResult"],
	createPointOfSaleCategoryLocale: GraphQLTypes["PointOfSaleCategoryLocaleCreateResult"],
	deletePointOfSaleCategoryLocale: GraphQLTypes["PointOfSaleCategoryLocaleDeleteResult"],
	updatePointOfSaleCategoryLocale: GraphQLTypes["PointOfSaleCategoryLocaleUpdateResult"],
	upsertPointOfSaleCategoryLocale: GraphQLTypes["PointOfSaleCategoryLocaleUpsertResult"],
	createPointOfSaleCategoryProduct: GraphQLTypes["PointOfSaleCategoryProductCreateResult"],
	deletePointOfSaleCategoryProduct: GraphQLTypes["PointOfSaleCategoryProductDeleteResult"],
	updatePointOfSaleCategoryProduct: GraphQLTypes["PointOfSaleCategoryProductUpdateResult"],
	upsertPointOfSaleCategoryProduct: GraphQLTypes["PointOfSaleCategoryProductUpsertResult"],
	createPointOfSaleCategoryProductLocale: GraphQLTypes["PointOfSaleCategoryProductLocaleCreateResult"],
	deletePointOfSaleCategoryProductLocale: GraphQLTypes["PointOfSaleCategoryProductLocaleDeleteResult"],
	updatePointOfSaleCategoryProductLocale: GraphQLTypes["PointOfSaleCategoryProductLocaleUpdateResult"],
	upsertPointOfSaleCategoryProductLocale: GraphQLTypes["PointOfSaleCategoryProductLocaleUpsertResult"],
	createCustomerTab: GraphQLTypes["CustomerTabCreateResult"],
	deleteCustomerTab: GraphQLTypes["CustomerTabDeleteResult"],
	updateCustomerTab: GraphQLTypes["CustomerTabUpdateResult"],
	upsertCustomerTab: GraphQLTypes["CustomerTabUpsertResult"],
	createCustomerTabItem: GraphQLTypes["CustomerTabItemCreateResult"],
	deleteCustomerTabItem: GraphQLTypes["CustomerTabItemDeleteResult"],
	updateCustomerTabItem: GraphQLTypes["CustomerTabItemUpdateResult"],
	upsertCustomerTabItem: GraphQLTypes["CustomerTabItemUpsertResult"],
	createAnonymousSession: GraphQLTypes["AnonymousSessionCreateResult"],
	deleteAnonymousSession: GraphQLTypes["AnonymousSessionDeleteResult"],
	updateAnonymousSession: GraphQLTypes["AnonymousSessionUpdateResult"],
	upsertAnonymousSession: GraphQLTypes["AnonymousSessionUpsertResult"],
	createVoucher: GraphQLTypes["VoucherCreateResult"],
	deleteVoucher: GraphQLTypes["VoucherDeleteResult"],
	updateVoucher: GraphQLTypes["VoucherUpdateResult"],
	upsertVoucher: GraphQLTypes["VoucherUpsertResult"],
	createVoucherRedemption: GraphQLTypes["VoucherRedemptionCreateResult"],
	deleteVoucherRedemption: GraphQLTypes["VoucherRedemptionDeleteResult"],
	updateVoucherRedemption: GraphQLTypes["VoucherRedemptionUpdateResult"],
	upsertVoucherRedemption: GraphQLTypes["VoucherRedemptionUpsertResult"],
	createUnassignedShiftInfo: GraphQLTypes["UnassignedShiftInfoCreateResult"],
	deleteUnassignedShiftInfo: GraphQLTypes["UnassignedShiftInfoDeleteResult"],
	updateUnassignedShiftInfo: GraphQLTypes["UnassignedShiftInfoUpdateResult"],
	upsertUnassignedShiftInfo: GraphQLTypes["UnassignedShiftInfoUpsertResult"],
	createFreshingContainer: GraphQLTypes["FreshingContainerCreateResult"],
	deleteFreshingContainer: GraphQLTypes["FreshingContainerDeleteResult"],
	updateFreshingContainer: GraphQLTypes["FreshingContainerUpdateResult"],
	upsertFreshingContainer: GraphQLTypes["FreshingContainerUpsertResult"],
	createTextItem: GraphQLTypes["TextItemCreateResult"],
	deleteTextItem: GraphQLTypes["TextItemDeleteResult"],
	updateTextItem: GraphQLTypes["TextItemUpdateResult"],
	upsertTextItem: GraphQLTypes["TextItemUpsertResult"],
	createTextList: GraphQLTypes["TextListCreateResult"],
	deleteTextList: GraphQLTypes["TextListDeleteResult"],
	updateTextList: GraphQLTypes["TextListUpdateResult"],
	upsertTextList: GraphQLTypes["TextListUpsertResult"],
	createDeliveryRegions: GraphQLTypes["DeliveryRegionsCreateResult"],
	deleteDeliveryRegions: GraphQLTypes["DeliveryRegionsDeleteResult"],
	updateDeliveryRegions: GraphQLTypes["DeliveryRegionsUpdateResult"],
	upsertDeliveryRegions: GraphQLTypes["DeliveryRegionsUpsertResult"],
	createDeliveryRegionsItem: GraphQLTypes["DeliveryRegionsItemCreateResult"],
	deleteDeliveryRegionsItem: GraphQLTypes["DeliveryRegionsItemDeleteResult"],
	updateDeliveryRegionsItem: GraphQLTypes["DeliveryRegionsItemUpdateResult"],
	upsertDeliveryRegionsItem: GraphQLTypes["DeliveryRegionsItemUpsertResult"],
	createImageList: GraphQLTypes["ImageListCreateResult"],
	deleteImageList: GraphQLTypes["ImageListDeleteResult"],
	updateImageList: GraphQLTypes["ImageListUpdateResult"],
	upsertImageList: GraphQLTypes["ImageListUpsertResult"],
	createImageListItem: GraphQLTypes["ImageListItemCreateResult"],
	deleteImageListItem: GraphQLTypes["ImageListItemDeleteResult"],
	updateImageListItem: GraphQLTypes["ImageListItemUpdateResult"],
	upsertImageListItem: GraphQLTypes["ImageListItemUpsertResult"],
	createTimetablesEmployeePrivileges: GraphQLTypes["TimetablesEmployeePrivilegesCreateResult"],
	deleteTimetablesEmployeePrivileges: GraphQLTypes["TimetablesEmployeePrivilegesDeleteResult"],
	updateTimetablesEmployeePrivileges: GraphQLTypes["TimetablesEmployeePrivilegesUpdateResult"],
	upsertTimetablesEmployeePrivileges: GraphQLTypes["TimetablesEmployeePrivilegesUpsertResult"],
	createTimetableDayNote: GraphQLTypes["TimetableDayNoteCreateResult"],
	deleteTimetableDayNote: GraphQLTypes["TimetableDayNoteDeleteResult"],
	updateTimetableDayNote: GraphQLTypes["TimetableDayNoteUpdateResult"],
	upsertTimetableDayNote: GraphQLTypes["TimetableDayNoteUpsertResult"],
	createDeliveryMethodLocale: GraphQLTypes["DeliveryMethodLocaleCreateResult"],
	deleteDeliveryMethodLocale: GraphQLTypes["DeliveryMethodLocaleDeleteResult"],
	updateDeliveryMethodLocale: GraphQLTypes["DeliveryMethodLocaleUpdateResult"],
	upsertDeliveryMethodLocale: GraphQLTypes["DeliveryMethodLocaleUpsertResult"],
	createIngredientSupplier: GraphQLTypes["IngredientSupplierCreateResult"],
	deleteIngredientSupplier: GraphQLTypes["IngredientSupplierDeleteResult"],
	updateIngredientSupplier: GraphQLTypes["IngredientSupplierUpdateResult"],
	upsertIngredientSupplier: GraphQLTypes["IngredientSupplierUpsertResult"],
	createIngredientSupplierItem: GraphQLTypes["IngredientSupplierItemCreateResult"],
	deleteIngredientSupplierItem: GraphQLTypes["IngredientSupplierItemDeleteResult"],
	updateIngredientSupplierItem: GraphQLTypes["IngredientSupplierItemUpdateResult"],
	upsertIngredientSupplierItem: GraphQLTypes["IngredientSupplierItemUpsertResult"],
	createIngredientSupplierList: GraphQLTypes["IngredientSupplierListCreateResult"],
	deleteIngredientSupplierList: GraphQLTypes["IngredientSupplierListDeleteResult"],
	updateIngredientSupplierList: GraphQLTypes["IngredientSupplierListUpdateResult"],
	upsertIngredientSupplierList: GraphQLTypes["IngredientSupplierListUpsertResult"],
	createIngredientSupplierLocale: GraphQLTypes["IngredientSupplierLocaleCreateResult"],
	deleteIngredientSupplierLocale: GraphQLTypes["IngredientSupplierLocaleDeleteResult"],
	updateIngredientSupplierLocale: GraphQLTypes["IngredientSupplierLocaleUpdateResult"],
	upsertIngredientSupplierLocale: GraphQLTypes["IngredientSupplierLocaleUpsertResult"],
	createRedirect: GraphQLTypes["RedirectCreateResult"],
	deleteRedirect: GraphQLTypes["RedirectDeleteResult"],
	updateRedirect: GraphQLTypes["RedirectUpdateResult"],
	upsertRedirect: GraphQLTypes["RedirectUpsertResult"],
	createNutritionFacts: GraphQLTypes["NutritionFactsCreateResult"],
	deleteNutritionFacts: GraphQLTypes["NutritionFactsDeleteResult"],
	updateNutritionFacts: GraphQLTypes["NutritionFactsUpdateResult"],
	upsertNutritionFacts: GraphQLTypes["NutritionFactsUpsertResult"],
	createVenue: GraphQLTypes["VenueCreateResult"],
	deleteVenue: GraphQLTypes["VenueDeleteResult"],
	updateVenue: GraphQLTypes["VenueUpdateResult"],
	upsertVenue: GraphQLTypes["VenueUpsertResult"],
	createWorkspace: GraphQLTypes["WorkspaceCreateResult"],
	deleteWorkspace: GraphQLTypes["WorkspaceDeleteResult"],
	updateWorkspace: GraphQLTypes["WorkspaceUpdateResult"],
	upsertWorkspace: GraphQLTypes["WorkspaceUpsertResult"],
	createInternalBuyer: GraphQLTypes["InternalBuyerCreateResult"],
	deleteInternalBuyer: GraphQLTypes["InternalBuyerDeleteResult"],
	updateInternalBuyer: GraphQLTypes["InternalBuyerUpdateResult"],
	upsertInternalBuyer: GraphQLTypes["InternalBuyerUpsertResult"],
	createVenueEmployeeRole: GraphQLTypes["VenueEmployeeRoleCreateResult"],
	deleteVenueEmployeeRole: GraphQLTypes["VenueEmployeeRoleDeleteResult"],
	updateVenueEmployeeRole: GraphQLTypes["VenueEmployeeRoleUpdateResult"],
	upsertVenueEmployeeRole: GraphQLTypes["VenueEmployeeRoleUpsertResult"],
	createIdentificationAttempt: GraphQLTypes["IdentificationAttemptCreateResult"],
	deleteIdentificationAttempt: GraphQLTypes["IdentificationAttemptDeleteResult"],
	updateIdentificationAttempt: GraphQLTypes["IdentificationAttemptUpdateResult"],
	upsertIdentificationAttempt: GraphQLTypes["IdentificationAttemptUpsertResult"],
	createIdentificationCode: GraphQLTypes["IdentificationCodeCreateResult"],
	deleteIdentificationCode: GraphQLTypes["IdentificationCodeDeleteResult"],
	updateIdentificationCode: GraphQLTypes["IdentificationCodeUpdateResult"],
	upsertIdentificationCode: GraphQLTypes["IdentificationCodeUpsertResult"],
	createIdentificationCodeLocale: GraphQLTypes["IdentificationCodeLocaleCreateResult"],
	deleteIdentificationCodeLocale: GraphQLTypes["IdentificationCodeLocaleDeleteResult"],
	updateIdentificationCodeLocale: GraphQLTypes["IdentificationCodeLocaleUpdateResult"],
	upsertIdentificationCodeLocale: GraphQLTypes["IdentificationCodeLocaleUpsertResult"],
	createPipeline: GraphQLTypes["PipelineCreateResult"],
	deletePipeline: GraphQLTypes["PipelineDeleteResult"],
	updatePipeline: GraphQLTypes["PipelineUpdateResult"],
	upsertPipeline: GraphQLTypes["PipelineUpsertResult"],
	createPipelineLead: GraphQLTypes["PipelineLeadCreateResult"],
	deletePipelineLead: GraphQLTypes["PipelineLeadDeleteResult"],
	updatePipelineLead: GraphQLTypes["PipelineLeadUpdateResult"],
	upsertPipelineLead: GraphQLTypes["PipelineLeadUpsertResult"],
	createPipelineStage: GraphQLTypes["PipelineStageCreateResult"],
	deletePipelineStage: GraphQLTypes["PipelineStageDeleteResult"],
	updatePipelineStage: GraphQLTypes["PipelineStageUpdateResult"],
	upsertPipelineStage: GraphQLTypes["PipelineStageUpsertResult"],
	createPipelineStageItem: GraphQLTypes["PipelineStageItemCreateResult"],
	deletePipelineStageItem: GraphQLTypes["PipelineStageItemDeleteResult"],
	updatePipelineStageItem: GraphQLTypes["PipelineStageItemUpdateResult"],
	upsertPipelineStageItem: GraphQLTypes["PipelineStageItemUpsertResult"],
	createPipelineStageLocale: GraphQLTypes["PipelineStageLocaleCreateResult"],
	deletePipelineStageLocale: GraphQLTypes["PipelineStageLocaleDeleteResult"],
	updatePipelineStageLocale: GraphQLTypes["PipelineStageLocaleUpdateResult"],
	upsertPipelineStageLocale: GraphQLTypes["PipelineStageLocaleUpsertResult"],
	createSalesManager: GraphQLTypes["SalesManagerCreateResult"],
	deleteSalesManager: GraphQLTypes["SalesManagerDeleteResult"],
	updateSalesManager: GraphQLTypes["SalesManagerUpdateResult"],
	upsertSalesManager: GraphQLTypes["SalesManagerUpsertResult"],
	createCashierManager: GraphQLTypes["CashierManagerCreateResult"],
	deleteCashierManager: GraphQLTypes["CashierManagerDeleteResult"],
	updateCashierManager: GraphQLTypes["CashierManagerUpdateResult"],
	upsertCashierManager: GraphQLTypes["CashierManagerUpsertResult"],
	createPointOfSaleApplicationDevice: GraphQLTypes["PointOfSaleApplicationDeviceCreateResult"],
	deletePointOfSaleApplicationDevice: GraphQLTypes["PointOfSaleApplicationDeviceDeleteResult"],
	updatePointOfSaleApplicationDevice: GraphQLTypes["PointOfSaleApplicationDeviceUpdateResult"],
	upsertPointOfSaleApplicationDevice: GraphQLTypes["PointOfSaleApplicationDeviceUpsertResult"],
	createPointOfSaleTerminal: GraphQLTypes["PointOfSaleTerminalCreateResult"],
	deletePointOfSaleTerminal: GraphQLTypes["PointOfSaleTerminalDeleteResult"],
	updatePointOfSaleTerminal: GraphQLTypes["PointOfSaleTerminalUpdateResult"],
	upsertPointOfSaleTerminal: GraphQLTypes["PointOfSaleTerminalUpsertResult"],
	createPipelineStageSentiment: GraphQLTypes["PipelineStageSentimentCreateResult"],
	deletePipelineStageSentiment: GraphQLTypes["PipelineStageSentimentDeleteResult"],
	updatePipelineStageSentiment: GraphQLTypes["PipelineStageSentimentUpdateResult"],
	upsertPipelineStageSentiment: GraphQLTypes["PipelineStageSentimentUpsertResult"],
	createDeviceIdentifier: GraphQLTypes["DeviceIdentifierCreateResult"],
	deleteDeviceIdentifier: GraphQLTypes["DeviceIdentifierDeleteResult"],
	updateDeviceIdentifier: GraphQLTypes["DeviceIdentifierUpdateResult"],
	upsertDeviceIdentifier: GraphQLTypes["DeviceIdentifierUpsertResult"],
	createPointOfSalePrinter: GraphQLTypes["PointOfSalePrinterCreateResult"],
	deletePointOfSalePrinter: GraphQLTypes["PointOfSalePrinterDeleteResult"],
	updatePointOfSalePrinter: GraphQLTypes["PointOfSalePrinterUpdateResult"],
	upsertPointOfSalePrinter: GraphQLTypes["PointOfSalePrinterUpsertResult"],
	createGratuity: GraphQLTypes["GratuityCreateResult"],
	deleteGratuity: GraphQLTypes["GratuityDeleteResult"],
	updateGratuity: GraphQLTypes["GratuityUpdateResult"],
	upsertGratuity: GraphQLTypes["GratuityUpsertResult"],
	createFulfillmentNote: GraphQLTypes["FulfillmentNoteCreateResult"],
	deleteFulfillmentNote: GraphQLTypes["FulfillmentNoteDeleteResult"],
	updateFulfillmentNote: GraphQLTypes["FulfillmentNoteUpdateResult"],
	upsertFulfillmentNote: GraphQLTypes["FulfillmentNoteUpsertResult"],
	createLeadForm: GraphQLTypes["LeadFormCreateResult"],
	deleteLeadForm: GraphQLTypes["LeadFormDeleteResult"],
	updateLeadForm: GraphQLTypes["LeadFormUpdateResult"],
	upsertLeadForm: GraphQLTypes["LeadFormUpsertResult"],
	createSubscriptionBox: GraphQLTypes["SubscriptionBoxCreateResult"],
	deleteSubscriptionBox: GraphQLTypes["SubscriptionBoxDeleteResult"],
	updateSubscriptionBox: GraphQLTypes["SubscriptionBoxUpdateResult"],
	upsertSubscriptionBox: GraphQLTypes["SubscriptionBoxUpsertResult"],
	createSubscriptionBoxLocale: GraphQLTypes["SubscriptionBoxLocaleCreateResult"],
	deleteSubscriptionBoxLocale: GraphQLTypes["SubscriptionBoxLocaleDeleteResult"],
	updateSubscriptionBoxLocale: GraphQLTypes["SubscriptionBoxLocaleUpdateResult"],
	upsertSubscriptionBoxLocale: GraphQLTypes["SubscriptionBoxLocaleUpsertResult"],
	createBusinessService: GraphQLTypes["BusinessServiceCreateResult"],
	deleteBusinessService: GraphQLTypes["BusinessServiceDeleteResult"],
	updateBusinessService: GraphQLTypes["BusinessServiceUpdateResult"],
	upsertBusinessService: GraphQLTypes["BusinessServiceUpsertResult"],
	createBusinessServiceEvent: GraphQLTypes["BusinessServiceEventCreateResult"],
	deleteBusinessServiceEvent: GraphQLTypes["BusinessServiceEventDeleteResult"],
	updateBusinessServiceEvent: GraphQLTypes["BusinessServiceEventUpdateResult"],
	upsertBusinessServiceEvent: GraphQLTypes["BusinessServiceEventUpsertResult"],
	createBusinessServiceLocale: GraphQLTypes["BusinessServiceLocaleCreateResult"],
	deleteBusinessServiceLocale: GraphQLTypes["BusinessServiceLocaleDeleteResult"],
	updateBusinessServiceLocale: GraphQLTypes["BusinessServiceLocaleUpdateResult"],
	upsertBusinessServiceLocale: GraphQLTypes["BusinessServiceLocaleUpsertResult"],
	createGridTileItem: GraphQLTypes["GridTileItemCreateResult"],
	deleteGridTileItem: GraphQLTypes["GridTileItemDeleteResult"],
	updateGridTileItem: GraphQLTypes["GridTileItemUpdateResult"],
	upsertGridTileItem: GraphQLTypes["GridTileItemUpsertResult"],
	createGridTiles: GraphQLTypes["GridTilesCreateResult"],
	deleteGridTiles: GraphQLTypes["GridTilesDeleteResult"],
	updateGridTiles: GraphQLTypes["GridTilesUpdateResult"],
	upsertGridTiles: GraphQLTypes["GridTilesUpsertResult"],
	createArea: GraphQLTypes["AreaCreateResult"],
	deleteArea: GraphQLTypes["AreaDeleteResult"],
	updateArea: GraphQLTypes["AreaUpdateResult"],
	upsertArea: GraphQLTypes["AreaUpsertResult"],
	createPosition: GraphQLTypes["PositionCreateResult"],
	deletePosition: GraphQLTypes["PositionDeleteResult"],
	updatePosition: GraphQLTypes["PositionUpdateResult"],
	upsertPosition: GraphQLTypes["PositionUpsertResult"],
	createStatsEnabledWidgetType: GraphQLTypes["StatsEnabledWidgetTypeCreateResult"],
	deleteStatsEnabledWidgetType: GraphQLTypes["StatsEnabledWidgetTypeDeleteResult"],
	updateStatsEnabledWidgetType: GraphQLTypes["StatsEnabledWidgetTypeUpdateResult"],
	upsertStatsEnabledWidgetType: GraphQLTypes["StatsEnabledWidgetTypeUpsertResult"],
	createStatsWidget: GraphQLTypes["StatsWidgetCreateResult"],
	deleteStatsWidget: GraphQLTypes["StatsWidgetDeleteResult"],
	updateStatsWidget: GraphQLTypes["StatsWidgetUpdateResult"],
	upsertStatsWidget: GraphQLTypes["StatsWidgetUpsertResult"],
	createStatsWidgetsLayout: GraphQLTypes["StatsWidgetsLayoutCreateResult"],
	deleteStatsWidgetsLayout: GraphQLTypes["StatsWidgetsLayoutDeleteResult"],
	updateStatsWidgetsLayout: GraphQLTypes["StatsWidgetsLayoutUpdateResult"],
	upsertStatsWidgetsLayout: GraphQLTypes["StatsWidgetsLayoutUpsertResult"],
	createSeat: GraphQLTypes["SeatCreateResult"],
	deleteSeat: GraphQLTypes["SeatDeleteResult"],
	updateSeat: GraphQLTypes["SeatUpdateResult"],
	upsertSeat: GraphQLTypes["SeatUpsertResult"],
	createTable: GraphQLTypes["TableCreateResult"],
	deleteTable: GraphQLTypes["TableDeleteResult"],
	updateTable: GraphQLTypes["TableUpdateResult"],
	upsertTable: GraphQLTypes["TableUpsertResult"],
	createStatsPage: GraphQLTypes["StatsPageCreateResult"],
	deleteStatsPage: GraphQLTypes["StatsPageDeleteResult"],
	updateStatsPage: GraphQLTypes["StatsPageUpdateResult"],
	upsertStatsPage: GraphQLTypes["StatsPageUpsertResult"],
	createUnassignReason: GraphQLTypes["UnassignReasonCreateResult"],
	deleteUnassignReason: GraphQLTypes["UnassignReasonDeleteResult"],
	updateUnassignReason: GraphQLTypes["UnassignReasonUpdateResult"],
	upsertUnassignReason: GraphQLTypes["UnassignReasonUpsertResult"],
	createDoubleshotCoffeeEquipment: GraphQLTypes["DoubleshotCoffeeEquipmentCreateResult"],
	deleteDoubleshotCoffeeEquipment: GraphQLTypes["DoubleshotCoffeeEquipmentDeleteResult"],
	updateDoubleshotCoffeeEquipment: GraphQLTypes["DoubleshotCoffeeEquipmentUpdateResult"],
	upsertDoubleshotCoffeeEquipment: GraphQLTypes["DoubleshotCoffeeEquipmentUpsertResult"],
	createExpense: GraphQLTypes["ExpenseCreateResult"],
	deleteExpense: GraphQLTypes["ExpenseDeleteResult"],
	updateExpense: GraphQLTypes["ExpenseUpdateResult"],
	upsertExpense: GraphQLTypes["ExpenseUpsertResult"],
	createExpenseCategory: GraphQLTypes["ExpenseCategoryCreateResult"],
	deleteExpenseCategory: GraphQLTypes["ExpenseCategoryDeleteResult"],
	updateExpenseCategory: GraphQLTypes["ExpenseCategoryUpdateResult"],
	upsertExpenseCategory: GraphQLTypes["ExpenseCategoryUpsertResult"],
	createExpenseChange: GraphQLTypes["ExpenseChangeCreateResult"],
	deleteExpenseChange: GraphQLTypes["ExpenseChangeDeleteResult"],
	updateExpenseChange: GraphQLTypes["ExpenseChangeUpdateResult"],
	upsertExpenseChange: GraphQLTypes["ExpenseChangeUpsertResult"],
	createExpenseDocument: GraphQLTypes["ExpenseDocumentCreateResult"],
	deleteExpenseDocument: GraphQLTypes["ExpenseDocumentDeleteResult"],
	updateExpenseDocument: GraphQLTypes["ExpenseDocumentUpdateResult"],
	upsertExpenseDocument: GraphQLTypes["ExpenseDocumentUpsertResult"],
	createRevenuePrediction: GraphQLTypes["RevenuePredictionCreateResult"],
	deleteRevenuePrediction: GraphQLTypes["RevenuePredictionDeleteResult"],
	updateRevenuePrediction: GraphQLTypes["RevenuePredictionUpdateResult"],
	upsertRevenuePrediction: GraphQLTypes["RevenuePredictionUpsertResult"],
	createRevenuePredictionChange: GraphQLTypes["RevenuePredictionChangeCreateResult"],
	deleteRevenuePredictionChange: GraphQLTypes["RevenuePredictionChangeDeleteResult"],
	updateRevenuePredictionChange: GraphQLTypes["RevenuePredictionChangeUpdateResult"],
	upsertRevenuePredictionChange: GraphQLTypes["RevenuePredictionChangeUpsertResult"],
	createFile: GraphQLTypes["FileCreateResult"],
	deleteFile: GraphQLTypes["FileDeleteResult"],
	updateFile: GraphQLTypes["FileUpdateResult"],
	upsertFile: GraphQLTypes["FileUpsertResult"],
	createLine: GraphQLTypes["LineCreateResult"],
	deleteLine: GraphQLTypes["LineDeleteResult"],
	updateLine: GraphQLTypes["LineUpdateResult"],
	upsertLine: GraphQLTypes["LineUpsertResult"],
	createFinancesBalanceItem: GraphQLTypes["FinancesBalanceItemCreateResult"],
	deleteFinancesBalanceItem: GraphQLTypes["FinancesBalanceItemDeleteResult"],
	updateFinancesBalanceItem: GraphQLTypes["FinancesBalanceItemUpdateResult"],
	upsertFinancesBalanceItem: GraphQLTypes["FinancesBalanceItemUpsertResult"],
	createWoltDriveDelivery: GraphQLTypes["WoltDriveDeliveryCreateResult"],
	deleteWoltDriveDelivery: GraphQLTypes["WoltDriveDeliveryDeleteResult"],
	updateWoltDriveDelivery: GraphQLTypes["WoltDriveDeliveryUpdateResult"],
	upsertWoltDriveDelivery: GraphQLTypes["WoltDriveDeliveryUpsertResult"],
	transaction: GraphQLTypes["MutationTransaction"],
	query: GraphQLTypes["Query"],
	generateUploadUrl: GraphQLTypes["S3SignedUpload"],
	generateReadUrl: GraphQLTypes["S3SignedRead"]
};
	["AddressCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Address"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MutationResult"]: ModelTypes["AddressCreateResult"] | ModelTypes["AddressDeleteResult"] | ModelTypes["AddressUpdateResult"] | ModelTypes["AddressUpsertResult"] | ModelTypes["CountryCreateResult"] | ModelTypes["CountryDeleteResult"] | ModelTypes["CountryUpdateResult"] | ModelTypes["CountryUpsertResult"] | ModelTypes["ChannelCreateResult"] | ModelTypes["ChannelDeleteResult"] | ModelTypes["ChannelUpdateResult"] | ModelTypes["ChannelUpsertResult"] | ModelTypes["ChannelPaymentCreateResult"] | ModelTypes["ChannelPaymentDeleteResult"] | ModelTypes["ChannelPaymentUpdateResult"] | ModelTypes["ChannelPaymentUpsertResult"] | ModelTypes["ChannelDeliveryCreateResult"] | ModelTypes["ChannelDeliveryDeleteResult"] | ModelTypes["ChannelDeliveryUpdateResult"] | ModelTypes["ChannelDeliveryUpsertResult"] | ModelTypes["CustomerCreateResult"] | ModelTypes["CustomerDeleteResult"] | ModelTypes["CustomerUpdateResult"] | ModelTypes["CustomerUpsertResult"] | ModelTypes["CustomerCreditCreateResult"] | ModelTypes["CustomerCreditDeleteResult"] | ModelTypes["CustomerCreditUpdateResult"] | ModelTypes["CustomerCreditUpsertResult"] | ModelTypes["CustomerGroupCreateResult"] | ModelTypes["CustomerGroupDeleteResult"] | ModelTypes["CustomerGroupUpdateResult"] | ModelTypes["CustomerGroupUpsertResult"] | ModelTypes["CustomerPaymentMethodCreateResult"] | ModelTypes["CustomerPaymentMethodDeleteResult"] | ModelTypes["CustomerPaymentMethodUpdateResult"] | ModelTypes["CustomerPaymentMethodUpsertResult"] | ModelTypes["DeliveryMethodCreateResult"] | ModelTypes["DeliveryMethodDeleteResult"] | ModelTypes["DeliveryMethodUpdateResult"] | ModelTypes["DeliveryMethodUpsertResult"] | ModelTypes["OrderCreateResult"] | ModelTypes["OrderDeleteResult"] | ModelTypes["OrderUpdateResult"] | ModelTypes["OrderUpsertResult"] | ModelTypes["OrderDiscountCreateResult"] | ModelTypes["OrderDiscountDeleteResult"] | ModelTypes["OrderDiscountUpdateResult"] | ModelTypes["OrderDiscountUpsertResult"] | ModelTypes["OrderPaymentCreateResult"] | ModelTypes["OrderPaymentDeleteResult"] | ModelTypes["OrderPaymentUpdateResult"] | ModelTypes["OrderPaymentUpsertResult"] | ModelTypes["OrderDeliveryCreateResult"] | ModelTypes["OrderDeliveryDeleteResult"] | ModelTypes["OrderDeliveryUpdateResult"] | ModelTypes["OrderDeliveryUpsertResult"] | ModelTypes["OrderItemCreateResult"] | ModelTypes["OrderItemDeleteResult"] | ModelTypes["OrderItemUpdateResult"] | ModelTypes["OrderItemUpsertResult"] | ModelTypes["PaymentMethodCreateResult"] | ModelTypes["PaymentMethodDeleteResult"] | ModelTypes["PaymentMethodUpdateResult"] | ModelTypes["PaymentMethodUpsertResult"] | ModelTypes["VatRateCreateResult"] | ModelTypes["VatRateDeleteResult"] | ModelTypes["VatRateUpdateResult"] | ModelTypes["VatRateUpsertResult"] | ModelTypes["ProductCreateResult"] | ModelTypes["ProductDeleteResult"] | ModelTypes["ProductUpdateResult"] | ModelTypes["ProductUpsertResult"] | ModelTypes["ProductStockCreateResult"] | ModelTypes["ProductStockDeleteResult"] | ModelTypes["ProductStockUpdateResult"] | ModelTypes["ProductStockUpsertResult"] | ModelTypes["ProductPackingCreateResult"] | ModelTypes["ProductPackingDeleteResult"] | ModelTypes["ProductPackingUpdateResult"] | ModelTypes["ProductPackingUpsertResult"] | ModelTypes["ProductGroupPriceCreateResult"] | ModelTypes["ProductGroupPriceDeleteResult"] | ModelTypes["ProductGroupPriceUpdateResult"] | ModelTypes["ProductGroupPriceUpsertResult"] | ModelTypes["ProductRecipeCreateResult"] | ModelTypes["ProductRecipeDeleteResult"] | ModelTypes["ProductRecipeUpdateResult"] | ModelTypes["ProductRecipeUpsertResult"] | ModelTypes["ProductCategoryCreateResult"] | ModelTypes["ProductCategoryDeleteResult"] | ModelTypes["ProductCategoryUpdateResult"] | ModelTypes["ProductCategoryUpsertResult"] | ModelTypes["StoreCreateResult"] | ModelTypes["StoreDeleteResult"] | ModelTypes["StoreUpdateResult"] | ModelTypes["StoreUpsertResult"] | ModelTypes["TagCreateResult"] | ModelTypes["TagDeleteResult"] | ModelTypes["TagUpdateResult"] | ModelTypes["TagUpsertResult"] | ModelTypes["ImageCreateResult"] | ModelTypes["ImageDeleteResult"] | ModelTypes["ImageUpdateResult"] | ModelTypes["ImageUpsertResult"] | ModelTypes["BusinessCategoryCreateResult"] | ModelTypes["BusinessCategoryDeleteResult"] | ModelTypes["BusinessCategoryUpdateResult"] | ModelTypes["BusinessCategoryUpsertResult"] | ModelTypes["ProductListCreateResult"] | ModelTypes["ProductListDeleteResult"] | ModelTypes["ProductListUpdateResult"] | ModelTypes["ProductListUpsertResult"] | ModelTypes["ProductListItemCreateResult"] | ModelTypes["ProductListItemDeleteResult"] | ModelTypes["ProductListItemUpdateResult"] | ModelTypes["ProductListItemUpsertResult"] | ModelTypes["ProductCategoryListCreateResult"] | ModelTypes["ProductCategoryListDeleteResult"] | ModelTypes["ProductCategoryListUpdateResult"] | ModelTypes["ProductCategoryListUpsertResult"] | ModelTypes["ProductCategoryListItemCreateResult"] | ModelTypes["ProductCategoryListItemDeleteResult"] | ModelTypes["ProductCategoryListItemUpdateResult"] | ModelTypes["ProductCategoryListItemUpsertResult"] | ModelTypes["BusinessCategoryLocaleCreateResult"] | ModelTypes["BusinessCategoryLocaleDeleteResult"] | ModelTypes["BusinessCategoryLocaleUpdateResult"] | ModelTypes["BusinessCategoryLocaleUpsertResult"] | ModelTypes["LocaleCreateResult"] | ModelTypes["LocaleDeleteResult"] | ModelTypes["LocaleUpdateResult"] | ModelTypes["LocaleUpsertResult"] | ModelTypes["ProductCategoryListLocaleCreateResult"] | ModelTypes["ProductCategoryListLocaleDeleteResult"] | ModelTypes["ProductCategoryListLocaleUpdateResult"] | ModelTypes["ProductCategoryListLocaleUpsertResult"] | ModelTypes["CustomerNameCreateResult"] | ModelTypes["CustomerNameDeleteResult"] | ModelTypes["CustomerNameUpdateResult"] | ModelTypes["CustomerNameUpsertResult"] | ModelTypes["CustomerAliasCreateResult"] | ModelTypes["CustomerAliasDeleteResult"] | ModelTypes["CustomerAliasUpdateResult"] | ModelTypes["CustomerAliasUpsertResult"] | ModelTypes["ProductIngredientItemCreateResult"] | ModelTypes["ProductIngredientItemDeleteResult"] | ModelTypes["ProductIngredientItemUpdateResult"] | ModelTypes["ProductIngredientItemUpsertResult"] | ModelTypes["ProductIngredientItemQuantityCreateResult"] | ModelTypes["ProductIngredientItemQuantityDeleteResult"] | ModelTypes["ProductIngredientItemQuantityUpdateResult"] | ModelTypes["ProductIngredientItemQuantityUpsertResult"] | ModelTypes["ProductIngredientItemQuantityUnitCreateResult"] | ModelTypes["ProductIngredientItemQuantityUnitDeleteResult"] | ModelTypes["ProductIngredientItemQuantityUnitUpdateResult"] | ModelTypes["ProductIngredientItemQuantityUnitUpsertResult"] | ModelTypes["ProductIngredientCreateResult"] | ModelTypes["ProductIngredientDeleteResult"] | ModelTypes["ProductIngredientUpdateResult"] | ModelTypes["ProductIngredientUpsertResult"] | ModelTypes["CustomerIngredientRatingCreateResult"] | ModelTypes["CustomerIngredientRatingDeleteResult"] | ModelTypes["CustomerIngredientRatingUpdateResult"] | ModelTypes["CustomerIngredientRatingUpsertResult"] | ModelTypes["ProductIngredientRatingCreateResult"] | ModelTypes["ProductIngredientRatingDeleteResult"] | ModelTypes["ProductIngredientRatingUpdateResult"] | ModelTypes["ProductIngredientRatingUpsertResult"] | ModelTypes["ProductIngredientLocaleCreateResult"] | ModelTypes["ProductIngredientLocaleDeleteResult"] | ModelTypes["ProductIngredientLocaleUpdateResult"] | ModelTypes["ProductIngredientLocaleUpsertResult"] | ModelTypes["OrderRecurrenceCreateResult"] | ModelTypes["OrderRecurrenceDeleteResult"] | ModelTypes["OrderRecurrenceUpdateResult"] | ModelTypes["OrderRecurrenceUpsertResult"] | ModelTypes["OrderRecurrenceLocaleCreateResult"] | ModelTypes["OrderRecurrenceLocaleDeleteResult"] | ModelTypes["OrderRecurrenceLocaleUpdateResult"] | ModelTypes["OrderRecurrenceLocaleUpsertResult"] | ModelTypes["BusinessCustomerCreateResult"] | ModelTypes["BusinessCustomerDeleteResult"] | ModelTypes["BusinessCustomerUpdateResult"] | ModelTypes["BusinessCustomerUpsertResult"] | ModelTypes["PointOfSaleCreateResult"] | ModelTypes["PointOfSaleDeleteResult"] | ModelTypes["PointOfSaleUpdateResult"] | ModelTypes["PointOfSaleUpsertResult"] | ModelTypes["StaffCreateResult"] | ModelTypes["StaffDeleteResult"] | ModelTypes["StaffUpdateResult"] | ModelTypes["StaffUpsertResult"] | ModelTypes["BlogCreateResult"] | ModelTypes["BlogDeleteResult"] | ModelTypes["BlogUpdateResult"] | ModelTypes["BlogUpsertResult"] | ModelTypes["BlogLocaleCreateResult"] | ModelTypes["BlogLocaleDeleteResult"] | ModelTypes["BlogLocaleUpdateResult"] | ModelTypes["BlogLocaleUpsertResult"] | ModelTypes["BlogPostCreateResult"] | ModelTypes["BlogPostDeleteResult"] | ModelTypes["BlogPostUpdateResult"] | ModelTypes["BlogPostUpsertResult"] | ModelTypes["BlogPostLocaleCreateResult"] | ModelTypes["BlogPostLocaleDeleteResult"] | ModelTypes["BlogPostLocaleUpdateResult"] | ModelTypes["BlogPostLocaleUpsertResult"] | ModelTypes["ColorPalleteCreateResult"] | ModelTypes["ColorPalleteDeleteResult"] | ModelTypes["ColorPalleteUpdateResult"] | ModelTypes["ColorPalleteUpsertResult"] | ModelTypes["ContentCreateResult"] | ModelTypes["ContentDeleteResult"] | ModelTypes["ContentUpdateResult"] | ModelTypes["ContentUpsertResult"] | ModelTypes["ContentBlockCreateResult"] | ModelTypes["ContentBlockDeleteResult"] | ModelTypes["ContentBlockUpdateResult"] | ModelTypes["ContentBlockUpsertResult"] | ModelTypes["ContentReferenceCreateResult"] | ModelTypes["ContentReferenceDeleteResult"] | ModelTypes["ContentReferenceUpdateResult"] | ModelTypes["ContentReferenceUpsertResult"] | ModelTypes["BlogPostListCreateResult"] | ModelTypes["BlogPostListDeleteResult"] | ModelTypes["BlogPostListUpdateResult"] | ModelTypes["BlogPostListUpsertResult"] | ModelTypes["BlogPostListItemCreateResult"] | ModelTypes["BlogPostListItemDeleteResult"] | ModelTypes["BlogPostListItemUpdateResult"] | ModelTypes["BlogPostListItemUpsertResult"] | ModelTypes["LinkListCreateResult"] | ModelTypes["LinkListDeleteResult"] | ModelTypes["LinkListUpdateResult"] | ModelTypes["LinkListUpsertResult"] | ModelTypes["LinkListItemCreateResult"] | ModelTypes["LinkListItemDeleteResult"] | ModelTypes["LinkListItemUpdateResult"] | ModelTypes["LinkListItemUpsertResult"] | ModelTypes["CoverCreateResult"] | ModelTypes["CoverDeleteResult"] | ModelTypes["CoverUpdateResult"] | ModelTypes["CoverUpsertResult"] | ModelTypes["LinkCreateResult"] | ModelTypes["LinkDeleteResult"] | ModelTypes["LinkUpdateResult"] | ModelTypes["LinkUpsertResult"] | ModelTypes["LinkableCreateResult"] | ModelTypes["LinkableDeleteResult"] | ModelTypes["LinkableUpdateResult"] | ModelTypes["LinkableUpsertResult"] | ModelTypes["MediumCreateResult"] | ModelTypes["MediumDeleteResult"] | ModelTypes["MediumUpdateResult"] | ModelTypes["MediumUpsertResult"] | ModelTypes["VideoCreateResult"] | ModelTypes["VideoDeleteResult"] | ModelTypes["VideoUpdateResult"] | ModelTypes["VideoUpsertResult"] | ModelTypes["SeoCreateResult"] | ModelTypes["SeoDeleteResult"] | ModelTypes["SeoUpdateResult"] | ModelTypes["SeoUpsertResult"] | ModelTypes["ProtectedImageCreateResult"] | ModelTypes["ProtectedImageDeleteResult"] | ModelTypes["ProtectedImageUpdateResult"] | ModelTypes["ProtectedImageUpsertResult"] | ModelTypes["TranslationDomainCreateResult"] | ModelTypes["TranslationDomainDeleteResult"] | ModelTypes["TranslationDomainUpdateResult"] | ModelTypes["TranslationDomainUpsertResult"] | ModelTypes["TranslationCatalogueCreateResult"] | ModelTypes["TranslationCatalogueDeleteResult"] | ModelTypes["TranslationCatalogueUpdateResult"] | ModelTypes["TranslationCatalogueUpsertResult"] | ModelTypes["TranslationKeyCreateResult"] | ModelTypes["TranslationKeyDeleteResult"] | ModelTypes["TranslationKeyUpdateResult"] | ModelTypes["TranslationKeyUpsertResult"] | ModelTypes["TranslationValueCreateResult"] | ModelTypes["TranslationValueDeleteResult"] | ModelTypes["TranslationValueUpdateResult"] | ModelTypes["TranslationValueUpsertResult"] | ModelTypes["TranslationCataloguesIdentifierCreateResult"] | ModelTypes["TranslationCataloguesIdentifierDeleteResult"] | ModelTypes["TranslationCataloguesIdentifierUpdateResult"] | ModelTypes["TranslationCataloguesIdentifierUpsertResult"] | ModelTypes["SocialsAndAppsCreateResult"] | ModelTypes["SocialsAndAppsDeleteResult"] | ModelTypes["SocialsAndAppsUpdateResult"] | ModelTypes["SocialsAndAppsUpsertResult"] | ModelTypes["ProductGridCreateResult"] | ModelTypes["ProductGridDeleteResult"] | ModelTypes["ProductGridUpdateResult"] | ModelTypes["ProductGridUpsertResult"] | ModelTypes["ProductGridItemCreateResult"] | ModelTypes["ProductGridItemDeleteResult"] | ModelTypes["ProductGridItemUpdateResult"] | ModelTypes["ProductGridItemUpsertResult"] | ModelTypes["GalleryCreateResult"] | ModelTypes["GalleryDeleteResult"] | ModelTypes["GalleryUpdateResult"] | ModelTypes["GalleryUpsertResult"] | ModelTypes["GalleryItemCreateResult"] | ModelTypes["GalleryItemDeleteResult"] | ModelTypes["GalleryItemUpdateResult"] | ModelTypes["GalleryItemUpsertResult"] | ModelTypes["HeroCreateResult"] | ModelTypes["HeroDeleteResult"] | ModelTypes["HeroUpdateResult"] | ModelTypes["HeroUpsertResult"] | ModelTypes["SiteMenuCreateResult"] | ModelTypes["SiteMenuDeleteResult"] | ModelTypes["SiteMenuUpdateResult"] | ModelTypes["SiteMenuUpsertResult"] | ModelTypes["MenuLocaleCreateResult"] | ModelTypes["MenuLocaleDeleteResult"] | ModelTypes["MenuLocaleUpdateResult"] | ModelTypes["MenuLocaleUpsertResult"] | ModelTypes["MenuItemCreateResult"] | ModelTypes["MenuItemDeleteResult"] | ModelTypes["MenuItemUpdateResult"] | ModelTypes["MenuItemUpsertResult"] | ModelTypes["PageCreateResult"] | ModelTypes["PageDeleteResult"] | ModelTypes["PageUpdateResult"] | ModelTypes["PageUpsertResult"] | ModelTypes["PageLocaleCreateResult"] | ModelTypes["PageLocaleDeleteResult"] | ModelTypes["PageLocaleUpdateResult"] | ModelTypes["PageLocaleUpsertResult"] | ModelTypes["WikiPageCreateResult"] | ModelTypes["WikiPageDeleteResult"] | ModelTypes["WikiPageUpdateResult"] | ModelTypes["WikiPageUpsertResult"] | ModelTypes["MenuSubitemCreateResult"] | ModelTypes["MenuSubitemDeleteResult"] | ModelTypes["MenuSubitemUpdateResult"] | ModelTypes["MenuSubitemUpsertResult"] | ModelTypes["MenuLinkListCreateResult"] | ModelTypes["MenuLinkListDeleteResult"] | ModelTypes["MenuLinkListUpdateResult"] | ModelTypes["MenuLinkListUpsertResult"] | ModelTypes["MenuLinkItemCreateResult"] | ModelTypes["MenuLinkItemDeleteResult"] | ModelTypes["MenuLinkItemUpdateResult"] | ModelTypes["MenuLinkItemUpsertResult"] | ModelTypes["MenuProductsCreateResult"] | ModelTypes["MenuProductsDeleteResult"] | ModelTypes["MenuProductsUpdateResult"] | ModelTypes["MenuProductsUpsertResult"] | ModelTypes["MenuDeliveryCreateResult"] | ModelTypes["MenuDeliveryDeleteResult"] | ModelTypes["MenuDeliveryUpdateResult"] | ModelTypes["MenuDeliveryUpsertResult"] | ModelTypes["MenuContactCreateResult"] | ModelTypes["MenuContactDeleteResult"] | ModelTypes["MenuContactUpdateResult"] | ModelTypes["MenuContactUpsertResult"] | ModelTypes["DeadlineTemplateCreateResult"] | ModelTypes["DeadlineTemplateDeleteResult"] | ModelTypes["DeadlineTemplateUpdateResult"] | ModelTypes["DeadlineTemplateUpsertResult"] | ModelTypes["EmployeeQueueCreateResult"] | ModelTypes["EmployeeQueueDeleteResult"] | ModelTypes["EmployeeQueueUpdateResult"] | ModelTypes["EmployeeQueueUpsertResult"] | ModelTypes["TimetableDayCreateResult"] | ModelTypes["TimetableDayDeleteResult"] | ModelTypes["TimetableDayUpdateResult"] | ModelTypes["TimetableDayUpsertResult"] | ModelTypes["TimetableEmployeeRoleCreateResult"] | ModelTypes["TimetableEmployeeRoleDeleteResult"] | ModelTypes["TimetableEmployeeRoleUpdateResult"] | ModelTypes["TimetableEmployeeRoleUpsertResult"] | ModelTypes["TimetableShiftCreateResult"] | ModelTypes["TimetableShiftDeleteResult"] | ModelTypes["TimetableShiftUpdateResult"] | ModelTypes["TimetableShiftUpsertResult"] | ModelTypes["TimetableShiftGroupCreateResult"] | ModelTypes["TimetableShiftGroupDeleteResult"] | ModelTypes["TimetableShiftGroupUpdateResult"] | ModelTypes["TimetableShiftGroupUpsertResult"] | ModelTypes["TimetableShiftPositionCreateResult"] | ModelTypes["TimetableShiftPositionDeleteResult"] | ModelTypes["TimetableShiftPositionUpdateResult"] | ModelTypes["TimetableShiftPositionUpsertResult"] | ModelTypes["TimetableTemplateCreateResult"] | ModelTypes["TimetableTemplateDeleteResult"] | ModelTypes["TimetableTemplateUpdateResult"] | ModelTypes["TimetableTemplateUpsertResult"] | ModelTypes["CartCreateResult"] | ModelTypes["CartDeleteResult"] | ModelTypes["CartUpdateResult"] | ModelTypes["CartUpsertResult"] | ModelTypes["CartItemCreateResult"] | ModelTypes["CartItemDeleteResult"] | ModelTypes["CartItemUpdateResult"] | ModelTypes["CartItemUpsertResult"] | ModelTypes["EmployeeQueueItemCreateResult"] | ModelTypes["EmployeeQueueItemDeleteResult"] | ModelTypes["EmployeeQueueItemUpdateResult"] | ModelTypes["EmployeeQueueItemUpsertResult"] | ModelTypes["ApplicationCreateResult"] | ModelTypes["ApplicationDeleteResult"] | ModelTypes["ApplicationUpdateResult"] | ModelTypes["ApplicationUpsertResult"] | ModelTypes["ApplicationShortcutListCreateResult"] | ModelTypes["ApplicationShortcutListDeleteResult"] | ModelTypes["ApplicationShortcutListUpdateResult"] | ModelTypes["ApplicationShortcutListUpsertResult"] | ModelTypes["ApplicationShortcutListItemCreateResult"] | ModelTypes["ApplicationShortcutListItemDeleteResult"] | ModelTypes["ApplicationShortcutListItemUpdateResult"] | ModelTypes["ApplicationShortcutListItemUpsertResult"] | ModelTypes["ProductBannerCreateResult"] | ModelTypes["ProductBannerDeleteResult"] | ModelTypes["ProductBannerUpdateResult"] | ModelTypes["ProductBannerUpsertResult"] | ModelTypes["ProductBannerItemCreateResult"] | ModelTypes["ProductBannerItemDeleteResult"] | ModelTypes["ProductBannerItemUpdateResult"] | ModelTypes["ProductBannerItemUpsertResult"] | ModelTypes["ProductBannerListCreateResult"] | ModelTypes["ProductBannerListDeleteResult"] | ModelTypes["ProductBannerListUpdateResult"] | ModelTypes["ProductBannerListUpsertResult"] | ModelTypes["BartenderCreateResult"] | ModelTypes["BartenderDeleteResult"] | ModelTypes["BartenderUpdateResult"] | ModelTypes["BartenderUpsertResult"] | ModelTypes["BusinessToBusinessManagerCreateResult"] | ModelTypes["BusinessToBusinessManagerDeleteResult"] | ModelTypes["BusinessToBusinessManagerUpdateResult"] | ModelTypes["BusinessToBusinessManagerUpsertResult"] | ModelTypes["CleanerCreateResult"] | ModelTypes["CleanerDeleteResult"] | ModelTypes["CleanerUpdateResult"] | ModelTypes["CleanerUpsertResult"] | ModelTypes["CourierCreateResult"] | ModelTypes["CourierDeleteResult"] | ModelTypes["CourierUpdateResult"] | ModelTypes["CourierUpsertResult"] | ModelTypes["ShiftsManagerCreateResult"] | ModelTypes["ShiftsManagerDeleteResult"] | ModelTypes["ShiftsManagerUpdateResult"] | ModelTypes["ShiftsManagerUpsertResult"] | ModelTypes["UserCreateResult"] | ModelTypes["UserDeleteResult"] | ModelTypes["UserUpdateResult"] | ModelTypes["UserUpsertResult"] | ModelTypes["ShiftsProfileCreateResult"] | ModelTypes["ShiftsProfileDeleteResult"] | ModelTypes["ShiftsProfileUpdateResult"] | ModelTypes["ShiftsProfileUpsertResult"] | ModelTypes["ProductIngredientCategoryCreateResult"] | ModelTypes["ProductIngredientCategoryDeleteResult"] | ModelTypes["ProductIngredientCategoryUpdateResult"] | ModelTypes["ProductIngredientCategoryUpsertResult"] | ModelTypes["ProductIngredientCategoryLocaleCreateResult"] | ModelTypes["ProductIngredientCategoryLocaleDeleteResult"] | ModelTypes["ProductIngredientCategoryLocaleUpdateResult"] | ModelTypes["ProductIngredientCategoryLocaleUpsertResult"] | ModelTypes["StocksManagerCreateResult"] | ModelTypes["StocksManagerDeleteResult"] | ModelTypes["StocksManagerUpdateResult"] | ModelTypes["StocksManagerUpsertResult"] | ModelTypes["DeliveryRouteCreateResult"] | ModelTypes["DeliveryRouteDeleteResult"] | ModelTypes["DeliveryRouteUpdateResult"] | ModelTypes["DeliveryRouteUpsertResult"] | ModelTypes["DeliveryWaypointCreateResult"] | ModelTypes["DeliveryWaypointDeleteResult"] | ModelTypes["DeliveryWaypointUpdateResult"] | ModelTypes["DeliveryWaypointUpsertResult"] | ModelTypes["AllergenCreateResult"] | ModelTypes["AllergenDeleteResult"] | ModelTypes["AllergenUpdateResult"] | ModelTypes["AllergenUpsertResult"] | ModelTypes["AllergenLocaleCreateResult"] | ModelTypes["AllergenLocaleDeleteResult"] | ModelTypes["AllergenLocaleUpdateResult"] | ModelTypes["AllergenLocaleUpsertResult"] | ModelTypes["GpsCreateResult"] | ModelTypes["GpsDeleteResult"] | ModelTypes["GpsUpdateResult"] | ModelTypes["GpsUpsertResult"] | ModelTypes["WeekHoursCreateResult"] | ModelTypes["WeekHoursDeleteResult"] | ModelTypes["WeekHoursUpdateResult"] | ModelTypes["WeekHoursUpsertResult"] | ModelTypes["PreparedIngredientQuantityCreateResult"] | ModelTypes["PreparedIngredientQuantityDeleteResult"] | ModelTypes["PreparedIngredientQuantityUpdateResult"] | ModelTypes["PreparedIngredientQuantityUpsertResult"] | ModelTypes["PreparedRecipeQuantityCreateResult"] | ModelTypes["PreparedRecipeQuantityDeleteResult"] | ModelTypes["PreparedRecipeQuantityUpdateResult"] | ModelTypes["PreparedRecipeQuantityUpsertResult"] | ModelTypes["InternalOrderCreateResult"] | ModelTypes["InternalOrderDeleteResult"] | ModelTypes["InternalOrderUpdateResult"] | ModelTypes["InternalOrderUpsertResult"] | ModelTypes["InternalOrderItemCreateResult"] | ModelTypes["InternalOrderItemDeleteResult"] | ModelTypes["InternalOrderItemUpdateResult"] | ModelTypes["InternalOrderItemUpsertResult"] | ModelTypes["PreparedPackingQuantityCreateResult"] | ModelTypes["PreparedPackingQuantityDeleteResult"] | ModelTypes["PreparedPackingQuantityUpdateResult"] | ModelTypes["PreparedPackingQuantityUpsertResult"] | ModelTypes["CourierManagerCreateResult"] | ModelTypes["CourierManagerDeleteResult"] | ModelTypes["CourierManagerUpdateResult"] | ModelTypes["CourierManagerUpsertResult"] | ModelTypes["DeliveryZoneCreateResult"] | ModelTypes["DeliveryZoneDeleteResult"] | ModelTypes["DeliveryZoneUpdateResult"] | ModelTypes["DeliveryZoneUpsertResult"] | ModelTypes["DeliveryTimelinePresetCreateResult"] | ModelTypes["DeliveryTimelinePresetDeleteResult"] | ModelTypes["DeliveryTimelinePresetUpdateResult"] | ModelTypes["DeliveryTimelinePresetUpsertResult"] | ModelTypes["OrderDeliveryTimelineCreateResult"] | ModelTypes["OrderDeliveryTimelineDeleteResult"] | ModelTypes["OrderDeliveryTimelineUpdateResult"] | ModelTypes["OrderDeliveryTimelineUpsertResult"] | ModelTypes["OrderEventCreateResult"] | ModelTypes["OrderEventDeleteResult"] | ModelTypes["OrderEventUpdateResult"] | ModelTypes["OrderEventUpsertResult"] | ModelTypes["LiftagoRideCreateResult"] | ModelTypes["LiftagoRideDeleteResult"] | ModelTypes["LiftagoRideUpdateResult"] | ModelTypes["LiftagoRideUpsertResult"] | ModelTypes["InvoiceCreateResult"] | ModelTypes["InvoiceDeleteResult"] | ModelTypes["InvoiceUpdateResult"] | ModelTypes["InvoiceUpsertResult"] | ModelTypes["InvoicingPlanCreateResult"] | ModelTypes["InvoicingPlanDeleteResult"] | ModelTypes["InvoicingPlanUpdateResult"] | ModelTypes["InvoicingPlanUpsertResult"] | ModelTypes["ProductPackingLocaleCreateResult"] | ModelTypes["ProductPackingLocaleDeleteResult"] | ModelTypes["ProductPackingLocaleUpdateResult"] | ModelTypes["ProductPackingLocaleUpsertResult"] | ModelTypes["ProductLocaleCreateResult"] | ModelTypes["ProductLocaleDeleteResult"] | ModelTypes["ProductLocaleUpdateResult"] | ModelTypes["ProductLocaleUpsertResult"] | ModelTypes["ProductRecipeLocaleCreateResult"] | ModelTypes["ProductRecipeLocaleDeleteResult"] | ModelTypes["ProductRecipeLocaleUpdateResult"] | ModelTypes["ProductRecipeLocaleUpsertResult"] | ModelTypes["UserDeviceCreateResult"] | ModelTypes["UserDeviceDeleteResult"] | ModelTypes["UserDeviceUpdateResult"] | ModelTypes["UserDeviceUpsertResult"] | ModelTypes["ProtectedActionCreateResult"] | ModelTypes["ProtectedActionDeleteResult"] | ModelTypes["ProtectedActionUpdateResult"] | ModelTypes["ProtectedActionUpsertResult"] | ModelTypes["PickerCreateResult"] | ModelTypes["PickerDeleteResult"] | ModelTypes["PickerUpdateResult"] | ModelTypes["PickerUpsertResult"] | ModelTypes["TimetableTemplateStaffOptionsCreateResult"] | ModelTypes["TimetableTemplateStaffOptionsDeleteResult"] | ModelTypes["TimetableTemplateStaffOptionsUpdateResult"] | ModelTypes["TimetableTemplateStaffOptionsUpsertResult"] | ModelTypes["ShoppingListCreateResult"] | ModelTypes["ShoppingListDeleteResult"] | ModelTypes["ShoppingListUpdateResult"] | ModelTypes["ShoppingListUpsertResult"] | ModelTypes["SuppliesPurchaseCreateResult"] | ModelTypes["SuppliesPurchaseDeleteResult"] | ModelTypes["SuppliesPurchaseUpdateResult"] | ModelTypes["SuppliesPurchaseUpsertResult"] | ModelTypes["InvoicingPresetCreateResult"] | ModelTypes["InvoicingPresetDeleteResult"] | ModelTypes["InvoicingPresetUpdateResult"] | ModelTypes["InvoicingPresetUpsertResult"] | ModelTypes["LogRecordCreateResult"] | ModelTypes["LogRecordDeleteResult"] | ModelTypes["LogRecordUpdateResult"] | ModelTypes["LogRecordUpsertResult"] | ModelTypes["BillingSubjectCreateResult"] | ModelTypes["BillingSubjectDeleteResult"] | ModelTypes["BillingSubjectUpdateResult"] | ModelTypes["BillingSubjectUpsertResult"] | ModelTypes["ShoppingListItemCreateResult"] | ModelTypes["ShoppingListItemDeleteResult"] | ModelTypes["ShoppingListItemUpdateResult"] | ModelTypes["ShoppingListItemUpsertResult"] | ModelTypes["SuppliesPurchaseItemCreateResult"] | ModelTypes["SuppliesPurchaseItemDeleteResult"] | ModelTypes["SuppliesPurchaseItemUpdateResult"] | ModelTypes["SuppliesPurchaseItemUpsertResult"] | ModelTypes["CustomerCreditTransactionCreateResult"] | ModelTypes["CustomerCreditTransactionDeleteResult"] | ModelTypes["CustomerCreditTransactionUpdateResult"] | ModelTypes["CustomerCreditTransactionUpsertResult"] | ModelTypes["VirtualProductCreateResult"] | ModelTypes["VirtualProductDeleteResult"] | ModelTypes["VirtualProductUpdateResult"] | ModelTypes["VirtualProductUpsertResult"] | ModelTypes["VirtualProductEffectCreateResult"] | ModelTypes["VirtualProductEffectDeleteResult"] | ModelTypes["VirtualProductEffectUpdateResult"] | ModelTypes["VirtualProductEffectUpsertResult"] | ModelTypes["EmploymentInformationCreateResult"] | ModelTypes["EmploymentInformationDeleteResult"] | ModelTypes["EmploymentInformationUpdateResult"] | ModelTypes["EmploymentInformationUpsertResult"] | ModelTypes["RemunerationProfileCreateResult"] | ModelTypes["RemunerationProfileDeleteResult"] | ModelTypes["RemunerationProfileUpdateResult"] | ModelTypes["RemunerationProfileUpsertResult"] | ModelTypes["WorkMonthCreateResult"] | ModelTypes["WorkMonthDeleteResult"] | ModelTypes["WorkMonthUpdateResult"] | ModelTypes["WorkMonthUpsertResult"] | ModelTypes["SalaryOptionsCreateResult"] | ModelTypes["SalaryOptionsDeleteResult"] | ModelTypes["SalaryOptionsUpdateResult"] | ModelTypes["SalaryOptionsUpsertResult"] | ModelTypes["TimetableShiftSwapInfoCreateResult"] | ModelTypes["TimetableShiftSwapInfoDeleteResult"] | ModelTypes["TimetableShiftSwapInfoUpdateResult"] | ModelTypes["TimetableShiftSwapInfoUpsertResult"] | ModelTypes["ProductGridCategoryCreateResult"] | ModelTypes["ProductGridCategoryDeleteResult"] | ModelTypes["ProductGridCategoryUpdateResult"] | ModelTypes["ProductGridCategoryUpsertResult"] | ModelTypes["CashierCreateResult"] | ModelTypes["CashierDeleteResult"] | ModelTypes["CashierUpdateResult"] | ModelTypes["CashierUpsertResult"] | ModelTypes["PointOfSaleCategoryCreateResult"] | ModelTypes["PointOfSaleCategoryDeleteResult"] | ModelTypes["PointOfSaleCategoryUpdateResult"] | ModelTypes["PointOfSaleCategoryUpsertResult"] | ModelTypes["PointOfSaleCategoryLocaleCreateResult"] | ModelTypes["PointOfSaleCategoryLocaleDeleteResult"] | ModelTypes["PointOfSaleCategoryLocaleUpdateResult"] | ModelTypes["PointOfSaleCategoryLocaleUpsertResult"] | ModelTypes["PointOfSaleCategoryProductCreateResult"] | ModelTypes["PointOfSaleCategoryProductDeleteResult"] | ModelTypes["PointOfSaleCategoryProductUpdateResult"] | ModelTypes["PointOfSaleCategoryProductUpsertResult"] | ModelTypes["PointOfSaleCategoryProductLocaleCreateResult"] | ModelTypes["PointOfSaleCategoryProductLocaleDeleteResult"] | ModelTypes["PointOfSaleCategoryProductLocaleUpdateResult"] | ModelTypes["PointOfSaleCategoryProductLocaleUpsertResult"] | ModelTypes["CustomerTabCreateResult"] | ModelTypes["CustomerTabDeleteResult"] | ModelTypes["CustomerTabUpdateResult"] | ModelTypes["CustomerTabUpsertResult"] | ModelTypes["CustomerTabItemCreateResult"] | ModelTypes["CustomerTabItemDeleteResult"] | ModelTypes["CustomerTabItemUpdateResult"] | ModelTypes["CustomerTabItemUpsertResult"] | ModelTypes["AnonymousSessionCreateResult"] | ModelTypes["AnonymousSessionDeleteResult"] | ModelTypes["AnonymousSessionUpdateResult"] | ModelTypes["AnonymousSessionUpsertResult"] | ModelTypes["VoucherCreateResult"] | ModelTypes["VoucherDeleteResult"] | ModelTypes["VoucherUpdateResult"] | ModelTypes["VoucherUpsertResult"] | ModelTypes["VoucherRedemptionCreateResult"] | ModelTypes["VoucherRedemptionDeleteResult"] | ModelTypes["VoucherRedemptionUpdateResult"] | ModelTypes["VoucherRedemptionUpsertResult"] | ModelTypes["UnassignedShiftInfoCreateResult"] | ModelTypes["UnassignedShiftInfoDeleteResult"] | ModelTypes["UnassignedShiftInfoUpdateResult"] | ModelTypes["UnassignedShiftInfoUpsertResult"] | ModelTypes["FreshingContainerCreateResult"] | ModelTypes["FreshingContainerDeleteResult"] | ModelTypes["FreshingContainerUpdateResult"] | ModelTypes["FreshingContainerUpsertResult"] | ModelTypes["TextItemCreateResult"] | ModelTypes["TextItemDeleteResult"] | ModelTypes["TextItemUpdateResult"] | ModelTypes["TextItemUpsertResult"] | ModelTypes["TextListCreateResult"] | ModelTypes["TextListDeleteResult"] | ModelTypes["TextListUpdateResult"] | ModelTypes["TextListUpsertResult"] | ModelTypes["DeliveryRegionsCreateResult"] | ModelTypes["DeliveryRegionsDeleteResult"] | ModelTypes["DeliveryRegionsUpdateResult"] | ModelTypes["DeliveryRegionsUpsertResult"] | ModelTypes["DeliveryRegionsItemCreateResult"] | ModelTypes["DeliveryRegionsItemDeleteResult"] | ModelTypes["DeliveryRegionsItemUpdateResult"] | ModelTypes["DeliveryRegionsItemUpsertResult"] | ModelTypes["ImageListCreateResult"] | ModelTypes["ImageListDeleteResult"] | ModelTypes["ImageListUpdateResult"] | ModelTypes["ImageListUpsertResult"] | ModelTypes["ImageListItemCreateResult"] | ModelTypes["ImageListItemDeleteResult"] | ModelTypes["ImageListItemUpdateResult"] | ModelTypes["ImageListItemUpsertResult"] | ModelTypes["TimetablesEmployeePrivilegesCreateResult"] | ModelTypes["TimetablesEmployeePrivilegesDeleteResult"] | ModelTypes["TimetablesEmployeePrivilegesUpdateResult"] | ModelTypes["TimetablesEmployeePrivilegesUpsertResult"] | ModelTypes["TimetableDayNoteCreateResult"] | ModelTypes["TimetableDayNoteDeleteResult"] | ModelTypes["TimetableDayNoteUpdateResult"] | ModelTypes["TimetableDayNoteUpsertResult"] | ModelTypes["DeliveryMethodLocaleCreateResult"] | ModelTypes["DeliveryMethodLocaleDeleteResult"] | ModelTypes["DeliveryMethodLocaleUpdateResult"] | ModelTypes["DeliveryMethodLocaleUpsertResult"] | ModelTypes["IngredientSupplierCreateResult"] | ModelTypes["IngredientSupplierDeleteResult"] | ModelTypes["IngredientSupplierUpdateResult"] | ModelTypes["IngredientSupplierUpsertResult"] | ModelTypes["IngredientSupplierItemCreateResult"] | ModelTypes["IngredientSupplierItemDeleteResult"] | ModelTypes["IngredientSupplierItemUpdateResult"] | ModelTypes["IngredientSupplierItemUpsertResult"] | ModelTypes["IngredientSupplierListCreateResult"] | ModelTypes["IngredientSupplierListDeleteResult"] | ModelTypes["IngredientSupplierListUpdateResult"] | ModelTypes["IngredientSupplierListUpsertResult"] | ModelTypes["IngredientSupplierLocaleCreateResult"] | ModelTypes["IngredientSupplierLocaleDeleteResult"] | ModelTypes["IngredientSupplierLocaleUpdateResult"] | ModelTypes["IngredientSupplierLocaleUpsertResult"] | ModelTypes["RedirectCreateResult"] | ModelTypes["RedirectDeleteResult"] | ModelTypes["RedirectUpdateResult"] | ModelTypes["RedirectUpsertResult"] | ModelTypes["NutritionFactsCreateResult"] | ModelTypes["NutritionFactsDeleteResult"] | ModelTypes["NutritionFactsUpdateResult"] | ModelTypes["NutritionFactsUpsertResult"] | ModelTypes["VenueCreateResult"] | ModelTypes["VenueDeleteResult"] | ModelTypes["VenueUpdateResult"] | ModelTypes["VenueUpsertResult"] | ModelTypes["WorkspaceCreateResult"] | ModelTypes["WorkspaceDeleteResult"] | ModelTypes["WorkspaceUpdateResult"] | ModelTypes["WorkspaceUpsertResult"] | ModelTypes["InternalBuyerCreateResult"] | ModelTypes["InternalBuyerDeleteResult"] | ModelTypes["InternalBuyerUpdateResult"] | ModelTypes["InternalBuyerUpsertResult"] | ModelTypes["VenueEmployeeRoleCreateResult"] | ModelTypes["VenueEmployeeRoleDeleteResult"] | ModelTypes["VenueEmployeeRoleUpdateResult"] | ModelTypes["VenueEmployeeRoleUpsertResult"] | ModelTypes["IdentificationAttemptCreateResult"] | ModelTypes["IdentificationAttemptDeleteResult"] | ModelTypes["IdentificationAttemptUpdateResult"] | ModelTypes["IdentificationAttemptUpsertResult"] | ModelTypes["IdentificationCodeCreateResult"] | ModelTypes["IdentificationCodeDeleteResult"] | ModelTypes["IdentificationCodeUpdateResult"] | ModelTypes["IdentificationCodeUpsertResult"] | ModelTypes["IdentificationCodeLocaleCreateResult"] | ModelTypes["IdentificationCodeLocaleDeleteResult"] | ModelTypes["IdentificationCodeLocaleUpdateResult"] | ModelTypes["IdentificationCodeLocaleUpsertResult"] | ModelTypes["PipelineCreateResult"] | ModelTypes["PipelineDeleteResult"] | ModelTypes["PipelineUpdateResult"] | ModelTypes["PipelineUpsertResult"] | ModelTypes["PipelineLeadCreateResult"] | ModelTypes["PipelineLeadDeleteResult"] | ModelTypes["PipelineLeadUpdateResult"] | ModelTypes["PipelineLeadUpsertResult"] | ModelTypes["PipelineStageCreateResult"] | ModelTypes["PipelineStageDeleteResult"] | ModelTypes["PipelineStageUpdateResult"] | ModelTypes["PipelineStageUpsertResult"] | ModelTypes["PipelineStageItemCreateResult"] | ModelTypes["PipelineStageItemDeleteResult"] | ModelTypes["PipelineStageItemUpdateResult"] | ModelTypes["PipelineStageItemUpsertResult"] | ModelTypes["PipelineStageLocaleCreateResult"] | ModelTypes["PipelineStageLocaleDeleteResult"] | ModelTypes["PipelineStageLocaleUpdateResult"] | ModelTypes["PipelineStageLocaleUpsertResult"] | ModelTypes["SalesManagerCreateResult"] | ModelTypes["SalesManagerDeleteResult"] | ModelTypes["SalesManagerUpdateResult"] | ModelTypes["SalesManagerUpsertResult"] | ModelTypes["CashierManagerCreateResult"] | ModelTypes["CashierManagerDeleteResult"] | ModelTypes["CashierManagerUpdateResult"] | ModelTypes["CashierManagerUpsertResult"] | ModelTypes["PointOfSaleApplicationDeviceCreateResult"] | ModelTypes["PointOfSaleApplicationDeviceDeleteResult"] | ModelTypes["PointOfSaleApplicationDeviceUpdateResult"] | ModelTypes["PointOfSaleApplicationDeviceUpsertResult"] | ModelTypes["PointOfSaleTerminalCreateResult"] | ModelTypes["PointOfSaleTerminalDeleteResult"] | ModelTypes["PointOfSaleTerminalUpdateResult"] | ModelTypes["PointOfSaleTerminalUpsertResult"] | ModelTypes["PipelineStageSentimentCreateResult"] | ModelTypes["PipelineStageSentimentDeleteResult"] | ModelTypes["PipelineStageSentimentUpdateResult"] | ModelTypes["PipelineStageSentimentUpsertResult"] | ModelTypes["DeviceIdentifierCreateResult"] | ModelTypes["DeviceIdentifierDeleteResult"] | ModelTypes["DeviceIdentifierUpdateResult"] | ModelTypes["DeviceIdentifierUpsertResult"] | ModelTypes["PointOfSalePrinterCreateResult"] | ModelTypes["PointOfSalePrinterDeleteResult"] | ModelTypes["PointOfSalePrinterUpdateResult"] | ModelTypes["PointOfSalePrinterUpsertResult"] | ModelTypes["GratuityCreateResult"] | ModelTypes["GratuityDeleteResult"] | ModelTypes["GratuityUpdateResult"] | ModelTypes["GratuityUpsertResult"] | ModelTypes["FulfillmentNoteCreateResult"] | ModelTypes["FulfillmentNoteDeleteResult"] | ModelTypes["FulfillmentNoteUpdateResult"] | ModelTypes["FulfillmentNoteUpsertResult"] | ModelTypes["LeadFormCreateResult"] | ModelTypes["LeadFormDeleteResult"] | ModelTypes["LeadFormUpdateResult"] | ModelTypes["LeadFormUpsertResult"] | ModelTypes["SubscriptionBoxCreateResult"] | ModelTypes["SubscriptionBoxDeleteResult"] | ModelTypes["SubscriptionBoxUpdateResult"] | ModelTypes["SubscriptionBoxUpsertResult"] | ModelTypes["SubscriptionBoxLocaleCreateResult"] | ModelTypes["SubscriptionBoxLocaleDeleteResult"] | ModelTypes["SubscriptionBoxLocaleUpdateResult"] | ModelTypes["SubscriptionBoxLocaleUpsertResult"] | ModelTypes["BusinessServiceCreateResult"] | ModelTypes["BusinessServiceDeleteResult"] | ModelTypes["BusinessServiceUpdateResult"] | ModelTypes["BusinessServiceUpsertResult"] | ModelTypes["BusinessServiceEventCreateResult"] | ModelTypes["BusinessServiceEventDeleteResult"] | ModelTypes["BusinessServiceEventUpdateResult"] | ModelTypes["BusinessServiceEventUpsertResult"] | ModelTypes["BusinessServiceLocaleCreateResult"] | ModelTypes["BusinessServiceLocaleDeleteResult"] | ModelTypes["BusinessServiceLocaleUpdateResult"] | ModelTypes["BusinessServiceLocaleUpsertResult"] | ModelTypes["GridTileItemCreateResult"] | ModelTypes["GridTileItemDeleteResult"] | ModelTypes["GridTileItemUpdateResult"] | ModelTypes["GridTileItemUpsertResult"] | ModelTypes["GridTilesCreateResult"] | ModelTypes["GridTilesDeleteResult"] | ModelTypes["GridTilesUpdateResult"] | ModelTypes["GridTilesUpsertResult"] | ModelTypes["AreaCreateResult"] | ModelTypes["AreaDeleteResult"] | ModelTypes["AreaUpdateResult"] | ModelTypes["AreaUpsertResult"] | ModelTypes["PositionCreateResult"] | ModelTypes["PositionDeleteResult"] | ModelTypes["PositionUpdateResult"] | ModelTypes["PositionUpsertResult"] | ModelTypes["StatsEnabledWidgetTypeCreateResult"] | ModelTypes["StatsEnabledWidgetTypeDeleteResult"] | ModelTypes["StatsEnabledWidgetTypeUpdateResult"] | ModelTypes["StatsEnabledWidgetTypeUpsertResult"] | ModelTypes["StatsWidgetCreateResult"] | ModelTypes["StatsWidgetDeleteResult"] | ModelTypes["StatsWidgetUpdateResult"] | ModelTypes["StatsWidgetUpsertResult"] | ModelTypes["StatsWidgetsLayoutCreateResult"] | ModelTypes["StatsWidgetsLayoutDeleteResult"] | ModelTypes["StatsWidgetsLayoutUpdateResult"] | ModelTypes["StatsWidgetsLayoutUpsertResult"] | ModelTypes["SeatCreateResult"] | ModelTypes["SeatDeleteResult"] | ModelTypes["SeatUpdateResult"] | ModelTypes["SeatUpsertResult"] | ModelTypes["TableCreateResult"] | ModelTypes["TableDeleteResult"] | ModelTypes["TableUpdateResult"] | ModelTypes["TableUpsertResult"] | ModelTypes["StatsPageCreateResult"] | ModelTypes["StatsPageDeleteResult"] | ModelTypes["StatsPageUpdateResult"] | ModelTypes["StatsPageUpsertResult"] | ModelTypes["UnassignReasonCreateResult"] | ModelTypes["UnassignReasonDeleteResult"] | ModelTypes["UnassignReasonUpdateResult"] | ModelTypes["UnassignReasonUpsertResult"] | ModelTypes["DoubleshotCoffeeEquipmentCreateResult"] | ModelTypes["DoubleshotCoffeeEquipmentDeleteResult"] | ModelTypes["DoubleshotCoffeeEquipmentUpdateResult"] | ModelTypes["DoubleshotCoffeeEquipmentUpsertResult"] | ModelTypes["ExpenseCreateResult"] | ModelTypes["ExpenseDeleteResult"] | ModelTypes["ExpenseUpdateResult"] | ModelTypes["ExpenseUpsertResult"] | ModelTypes["ExpenseCategoryCreateResult"] | ModelTypes["ExpenseCategoryDeleteResult"] | ModelTypes["ExpenseCategoryUpdateResult"] | ModelTypes["ExpenseCategoryUpsertResult"] | ModelTypes["ExpenseChangeCreateResult"] | ModelTypes["ExpenseChangeDeleteResult"] | ModelTypes["ExpenseChangeUpdateResult"] | ModelTypes["ExpenseChangeUpsertResult"] | ModelTypes["ExpenseDocumentCreateResult"] | ModelTypes["ExpenseDocumentDeleteResult"] | ModelTypes["ExpenseDocumentUpdateResult"] | ModelTypes["ExpenseDocumentUpsertResult"] | ModelTypes["RevenuePredictionCreateResult"] | ModelTypes["RevenuePredictionDeleteResult"] | ModelTypes["RevenuePredictionUpdateResult"] | ModelTypes["RevenuePredictionUpsertResult"] | ModelTypes["RevenuePredictionChangeCreateResult"] | ModelTypes["RevenuePredictionChangeDeleteResult"] | ModelTypes["RevenuePredictionChangeUpdateResult"] | ModelTypes["RevenuePredictionChangeUpsertResult"] | ModelTypes["FileCreateResult"] | ModelTypes["FileDeleteResult"] | ModelTypes["FileUpdateResult"] | ModelTypes["FileUpsertResult"] | ModelTypes["LineCreateResult"] | ModelTypes["LineDeleteResult"] | ModelTypes["LineUpdateResult"] | ModelTypes["LineUpsertResult"] | ModelTypes["FinancesBalanceItemCreateResult"] | ModelTypes["FinancesBalanceItemDeleteResult"] | ModelTypes["FinancesBalanceItemUpdateResult"] | ModelTypes["FinancesBalanceItemUpsertResult"] | ModelTypes["WoltDriveDeliveryCreateResult"] | ModelTypes["WoltDriveDeliveryDeleteResult"] | ModelTypes["WoltDriveDeliveryUpdateResult"] | ModelTypes["WoltDriveDeliveryUpsertResult"];
	["_MutationError"]: {
		path: Array<GraphQLTypes["_PathFragment"]>,
	paths: Array<Array<GraphQLTypes["_PathFragment"]>>,
	type: GraphQLTypes["_MutationErrorType"],
	message?: string | undefined
};
	["_MutationErrorType"]: GraphQLTypes["_MutationErrorType"];
	["AddressDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Address"] | undefined
};
	["AddressUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Address"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["AddressUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Address"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CountryCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Country"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CountryDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Country"] | undefined
};
	["CountryUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Country"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CountryUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Country"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ChannelCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Channel"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ChannelDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Channel"] | undefined
};
	["ChannelUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Channel"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ChannelUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Channel"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ChannelPaymentCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ChannelPayment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ChannelPaymentDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ChannelPayment"] | undefined
};
	["ChannelPaymentUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ChannelPayment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ChannelPaymentUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ChannelPayment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ChannelDeliveryCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ChannelDelivery"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ChannelDeliveryDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ChannelDelivery"] | undefined
};
	["ChannelDeliveryUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ChannelDelivery"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ChannelDeliveryUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ChannelDelivery"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Customer"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Customer"] | undefined
};
	["CustomerUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Customer"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Customer"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerCreditCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerCredit"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerCreditDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerCredit"] | undefined
};
	["CustomerCreditUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerCredit"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerCreditUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerCredit"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerGroupCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerGroup"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerGroupDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerGroup"] | undefined
};
	["CustomerGroupUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerGroup"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerGroupUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerGroup"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerPaymentMethodCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerPaymentMethod"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerPaymentMethodDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerPaymentMethod"] | undefined
};
	["CustomerPaymentMethodUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerPaymentMethod"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerPaymentMethodUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerPaymentMethod"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryMethodCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryMethod"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryMethodDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryMethod"] | undefined
};
	["DeliveryMethodUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryMethod"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryMethodUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryMethod"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Order"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Order"] | undefined
};
	["OrderUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Order"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Order"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderDiscountCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderDiscount"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderDiscountDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderDiscount"] | undefined
};
	["OrderDiscountUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderDiscount"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderDiscountUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderDiscount"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderPaymentCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderPayment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderPaymentDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderPayment"] | undefined
};
	["OrderPaymentUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderPayment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderPaymentUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderPayment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderDeliveryCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderDelivery"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderDeliveryDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderDelivery"] | undefined
};
	["OrderDeliveryUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderDelivery"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderDeliveryUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderDelivery"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderItem"] | undefined
};
	["OrderItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PaymentMethodCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PaymentMethod"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PaymentMethodDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PaymentMethod"] | undefined
};
	["PaymentMethodUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PaymentMethod"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PaymentMethodUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PaymentMethod"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VatRateCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VatRate"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VatRateDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VatRate"] | undefined
};
	["VatRateUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VatRate"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VatRateUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VatRate"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Product"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Product"] | undefined
};
	["ProductUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Product"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Product"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductStockCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductStock"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductStockDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductStock"] | undefined
};
	["ProductStockUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductStock"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductStockUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductStock"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductPackingCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductPacking"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductPackingDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductPacking"] | undefined
};
	["ProductPackingUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductPacking"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductPackingUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductPacking"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductGroupPriceCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGroupPrice"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductGroupPriceDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGroupPrice"] | undefined
};
	["ProductGroupPriceUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGroupPrice"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductGroupPriceUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGroupPrice"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductRecipeCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductRecipe"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductRecipeDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductRecipe"] | undefined
};
	["ProductRecipeUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductRecipe"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductRecipeUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductRecipe"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductCategoryCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductCategory"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductCategoryDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductCategory"] | undefined
};
	["ProductCategoryUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductCategory"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductCategoryUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductCategory"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StoreCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Store"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StoreDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Store"] | undefined
};
	["StoreUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Store"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StoreUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Store"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TagCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Tag"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TagDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Tag"] | undefined
};
	["TagUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Tag"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TagUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Tag"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"] | undefined
};
	["ImageUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessCategoryCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessCategory"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessCategoryDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessCategory"] | undefined
};
	["BusinessCategoryUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessCategory"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessCategoryUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessCategory"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductListCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductListDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductList"] | undefined
};
	["ProductListUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductListUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductListItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductListItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductListItem"] | undefined
};
	["ProductListItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductListItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductCategoryListCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductCategoryList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductCategoryListDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductCategoryList"] | undefined
};
	["ProductCategoryListUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductCategoryList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductCategoryListUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductCategoryList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductCategoryListItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductCategoryListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductCategoryListItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductCategoryListItem"] | undefined
};
	["ProductCategoryListItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductCategoryListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductCategoryListItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductCategoryListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessCategoryLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessCategoryLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessCategoryLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessCategoryLocale"] | undefined
};
	["BusinessCategoryLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessCategoryLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessCategoryLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessCategoryLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Locale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Locale"] | undefined
};
	["LocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Locale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Locale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductCategoryListLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductCategoryListLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductCategoryListLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductCategoryListLocale"] | undefined
};
	["ProductCategoryListLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductCategoryListLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductCategoryListLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductCategoryListLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerNameCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerName"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerNameDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerName"] | undefined
};
	["CustomerNameUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerName"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerNameUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerName"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerAliasCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerAlias"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerAliasDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerAlias"] | undefined
};
	["CustomerAliasUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerAlias"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerAliasUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerAlias"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientItem"] | undefined
};
	["ProductIngredientItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientItemQuantityCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientItemQuantity"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientItemQuantityDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientItemQuantity"] | undefined
};
	["ProductIngredientItemQuantityUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientItemQuantity"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientItemQuantityUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientItemQuantity"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientItemQuantityUnitCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientItemQuantityUnit"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientItemQuantityUnitDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientItemQuantityUnit"] | undefined
};
	["ProductIngredientItemQuantityUnitUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientItemQuantityUnit"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientItemQuantityUnitUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientItemQuantityUnit"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredient"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredient"] | undefined
};
	["ProductIngredientUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredient"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredient"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerIngredientRatingCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerIngredientRating"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerIngredientRatingDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerIngredientRating"] | undefined
};
	["CustomerIngredientRatingUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerIngredientRating"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerIngredientRatingUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerIngredientRating"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientRatingCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientRating"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientRatingDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientRating"] | undefined
};
	["ProductIngredientRatingUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientRating"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientRatingUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientRating"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientLocale"] | undefined
};
	["ProductIngredientLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderRecurrenceCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderRecurrence"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderRecurrenceDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderRecurrence"] | undefined
};
	["OrderRecurrenceUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderRecurrence"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderRecurrenceUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderRecurrence"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderRecurrenceLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderRecurrenceLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderRecurrenceLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderRecurrenceLocale"] | undefined
};
	["OrderRecurrenceLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderRecurrenceLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderRecurrenceLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderRecurrenceLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessCustomerCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessCustomer"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessCustomerDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessCustomer"] | undefined
};
	["BusinessCustomerUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessCustomer"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessCustomerUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessCustomer"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSale"] | undefined
};
	["PointOfSaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StaffCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Staff"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StaffDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Staff"] | undefined
};
	["StaffUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Staff"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StaffUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Staff"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Blog"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Blog"] | undefined
};
	["BlogUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Blog"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Blog"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogLocale"] | undefined
};
	["BlogLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPost"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPost"] | undefined
};
	["BlogPostUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPost"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPost"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostLocale"] | undefined
};
	["BlogPostLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ColorPalleteCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ColorPallete"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ColorPalleteDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ColorPallete"] | undefined
};
	["ColorPalleteUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ColorPallete"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ColorPalleteUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ColorPallete"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"] | undefined
};
	["ContentUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentBlockCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentBlockDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"] | undefined
};
	["ContentBlockUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentBlockUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"] | undefined
};
	["ContentReferenceUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostListCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostListDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostList"] | undefined
};
	["BlogPostListUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostListUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostListItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostListItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostListItem"] | undefined
};
	["BlogPostListItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostListItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkListCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkListDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkList"] | undefined
};
	["LinkListUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkListUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkListItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkListItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkListItem"] | undefined
};
	["LinkListItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkListItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CoverCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Cover"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CoverDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Cover"] | undefined
};
	["CoverUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Cover"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CoverUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Cover"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"] | undefined
};
	["LinkUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkableCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkableDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"] | undefined
};
	["LinkableUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkableUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Medium"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Medium"] | undefined
};
	["MediumUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Medium"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Medium"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VideoCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Video"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VideoDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Video"] | undefined
};
	["VideoUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Video"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VideoUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Video"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"] | undefined
};
	["SeoUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProtectedImageCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProtectedImage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProtectedImageDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProtectedImage"] | undefined
};
	["ProtectedImageUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProtectedImage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProtectedImageUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProtectedImage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationDomainCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationDomain"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationDomainDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationDomain"] | undefined
};
	["TranslationDomainUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationDomain"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationDomainUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationDomain"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationCatalogueCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCatalogue"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationCatalogueDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCatalogue"] | undefined
};
	["TranslationCatalogueUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCatalogue"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationCatalogueUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCatalogue"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationKeyCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationKey"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationKeyDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationKey"] | undefined
};
	["TranslationKeyUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationKey"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationKeyUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationKey"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationValueCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationValue"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationValueDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationValue"] | undefined
};
	["TranslationValueUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationValue"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationValueUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationValue"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationCataloguesIdentifierCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCataloguesIdentifier"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationCataloguesIdentifierDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCataloguesIdentifier"] | undefined
};
	["TranslationCataloguesIdentifierUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCataloguesIdentifier"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationCataloguesIdentifierUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCataloguesIdentifier"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialsAndAppsCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialsAndApps"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialsAndAppsDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialsAndApps"] | undefined
};
	["SocialsAndAppsUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialsAndApps"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialsAndAppsUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialsAndApps"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductGridCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGrid"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductGridDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGrid"] | undefined
};
	["ProductGridUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGrid"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductGridUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGrid"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductGridItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGridItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductGridItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGridItem"] | undefined
};
	["ProductGridItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGridItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductGridItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGridItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gallery"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gallery"] | undefined
};
	["GalleryUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gallery"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gallery"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GalleryItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GalleryItem"] | undefined
};
	["GalleryItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GalleryItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GalleryItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeroCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Hero"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeroDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Hero"] | undefined
};
	["HeroUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Hero"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeroUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Hero"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SiteMenuCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SiteMenu"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SiteMenuDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SiteMenu"] | undefined
};
	["SiteMenuUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SiteMenu"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SiteMenuUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SiteMenu"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuLocale"] | undefined
};
	["MenuLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuItem"] | undefined
};
	["MenuItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PageCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Page"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PageDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Page"] | undefined
};
	["PageUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Page"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PageUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Page"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PageLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PageLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PageLocale"] | undefined
};
	["PageLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PageLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["WikiPageCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["WikiPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["WikiPageDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["WikiPage"] | undefined
};
	["WikiPageUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["WikiPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["WikiPageUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["WikiPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuSubitemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuSubitem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuSubitemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuSubitem"] | undefined
};
	["MenuSubitemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuSubitem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuSubitemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuSubitem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuLinkListCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuLinkList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuLinkListDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuLinkList"] | undefined
};
	["MenuLinkListUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuLinkList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuLinkListUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuLinkList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuLinkItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuLinkItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuLinkItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuLinkItem"] | undefined
};
	["MenuLinkItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuLinkItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuLinkItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuLinkItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuProductsCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuProducts"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuProductsDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuProducts"] | undefined
};
	["MenuProductsUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuProducts"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuProductsUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuProducts"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuDeliveryCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuDelivery"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuDeliveryDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuDelivery"] | undefined
};
	["MenuDeliveryUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuDelivery"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuDeliveryUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuDelivery"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuContactCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuContact"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuContactDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuContact"] | undefined
};
	["MenuContactUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuContact"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuContactUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuContact"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeadlineTemplateCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeadlineTemplate"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeadlineTemplateDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeadlineTemplate"] | undefined
};
	["DeadlineTemplateUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeadlineTemplate"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeadlineTemplateUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeadlineTemplate"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["EmployeeQueueCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EmployeeQueue"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["EmployeeQueueDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EmployeeQueue"] | undefined
};
	["EmployeeQueueUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EmployeeQueue"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["EmployeeQueueUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EmployeeQueue"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableDayCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableDay"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableDayDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableDay"] | undefined
};
	["TimetableDayUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableDay"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableDayUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableDay"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableEmployeeRoleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableEmployeeRole"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableEmployeeRoleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableEmployeeRole"] | undefined
};
	["TimetableEmployeeRoleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableEmployeeRole"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableEmployeeRoleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableEmployeeRole"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableShiftCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableShift"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableShiftDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableShift"] | undefined
};
	["TimetableShiftUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableShift"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableShiftUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableShift"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableShiftGroupCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableShiftGroup"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableShiftGroupDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableShiftGroup"] | undefined
};
	["TimetableShiftGroupUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableShiftGroup"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableShiftGroupUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableShiftGroup"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableShiftPositionCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableShiftPosition"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableShiftPositionDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableShiftPosition"] | undefined
};
	["TimetableShiftPositionUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableShiftPosition"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableShiftPositionUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableShiftPosition"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableTemplateCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableTemplate"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableTemplateDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableTemplate"] | undefined
};
	["TimetableTemplateUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableTemplate"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableTemplateUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableTemplate"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CartCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Cart"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CartDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Cart"] | undefined
};
	["CartUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Cart"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CartUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Cart"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CartItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CartItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CartItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CartItem"] | undefined
};
	["CartItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CartItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CartItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CartItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["EmployeeQueueItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EmployeeQueueItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["EmployeeQueueItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EmployeeQueueItem"] | undefined
};
	["EmployeeQueueItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EmployeeQueueItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["EmployeeQueueItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EmployeeQueueItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ApplicationCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Application"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ApplicationDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Application"] | undefined
};
	["ApplicationUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Application"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ApplicationUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Application"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ApplicationShortcutListCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ApplicationShortcutList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ApplicationShortcutListDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ApplicationShortcutList"] | undefined
};
	["ApplicationShortcutListUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ApplicationShortcutList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ApplicationShortcutListUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ApplicationShortcutList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ApplicationShortcutListItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ApplicationShortcutListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ApplicationShortcutListItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ApplicationShortcutListItem"] | undefined
};
	["ApplicationShortcutListItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ApplicationShortcutListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ApplicationShortcutListItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ApplicationShortcutListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductBannerCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductBanner"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductBannerDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductBanner"] | undefined
};
	["ProductBannerUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductBanner"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductBannerUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductBanner"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductBannerItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductBannerItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductBannerItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductBannerItem"] | undefined
};
	["ProductBannerItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductBannerItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductBannerItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductBannerItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductBannerListCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductBannerList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductBannerListDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductBannerList"] | undefined
};
	["ProductBannerListUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductBannerList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductBannerListUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductBannerList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BartenderCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Bartender"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BartenderDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Bartender"] | undefined
};
	["BartenderUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Bartender"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BartenderUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Bartender"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessToBusinessManagerCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessToBusinessManager"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessToBusinessManagerDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessToBusinessManager"] | undefined
};
	["BusinessToBusinessManagerUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessToBusinessManager"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessToBusinessManagerUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessToBusinessManager"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CleanerCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Cleaner"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CleanerDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Cleaner"] | undefined
};
	["CleanerUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Cleaner"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CleanerUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Cleaner"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CourierCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Courier"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CourierDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Courier"] | undefined
};
	["CourierUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Courier"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CourierUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Courier"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShiftsManagerCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShiftsManager"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShiftsManagerDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShiftsManager"] | undefined
};
	["ShiftsManagerUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShiftsManager"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShiftsManagerUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShiftsManager"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UserCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["User"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UserDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["User"] | undefined
};
	["UserUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["User"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UserUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["User"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShiftsProfileCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShiftsProfile"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShiftsProfileDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShiftsProfile"] | undefined
};
	["ShiftsProfileUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShiftsProfile"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShiftsProfileUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShiftsProfile"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientCategoryCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientCategory"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientCategoryDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientCategory"] | undefined
};
	["ProductIngredientCategoryUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientCategory"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientCategoryUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientCategory"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientCategoryLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientCategoryLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientCategoryLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientCategoryLocale"] | undefined
};
	["ProductIngredientCategoryLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientCategoryLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientCategoryLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientCategoryLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StocksManagerCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StocksManager"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StocksManagerDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StocksManager"] | undefined
};
	["StocksManagerUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StocksManager"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StocksManagerUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StocksManager"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryRouteCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryRoute"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryRouteDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryRoute"] | undefined
};
	["DeliveryRouteUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryRoute"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryRouteUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryRoute"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryWaypointCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryWaypoint"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryWaypointDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryWaypoint"] | undefined
};
	["DeliveryWaypointUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryWaypoint"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryWaypointUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryWaypoint"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["AllergenCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Allergen"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["AllergenDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Allergen"] | undefined
};
	["AllergenUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Allergen"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["AllergenUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Allergen"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["AllergenLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AllergenLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["AllergenLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AllergenLocale"] | undefined
};
	["AllergenLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AllergenLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["AllergenLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AllergenLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GpsCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gps"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GpsDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gps"] | undefined
};
	["GpsUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gps"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GpsUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gps"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["WeekHoursCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["WeekHours"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["WeekHoursDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["WeekHours"] | undefined
};
	["WeekHoursUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["WeekHours"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["WeekHoursUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["WeekHours"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PreparedIngredientQuantityCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PreparedIngredientQuantity"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PreparedIngredientQuantityDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PreparedIngredientQuantity"] | undefined
};
	["PreparedIngredientQuantityUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PreparedIngredientQuantity"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PreparedIngredientQuantityUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PreparedIngredientQuantity"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PreparedRecipeQuantityCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PreparedRecipeQuantity"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PreparedRecipeQuantityDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PreparedRecipeQuantity"] | undefined
};
	["PreparedRecipeQuantityUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PreparedRecipeQuantity"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PreparedRecipeQuantityUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PreparedRecipeQuantity"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InternalOrderCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InternalOrder"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InternalOrderDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InternalOrder"] | undefined
};
	["InternalOrderUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InternalOrder"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InternalOrderUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InternalOrder"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InternalOrderItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InternalOrderItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InternalOrderItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InternalOrderItem"] | undefined
};
	["InternalOrderItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InternalOrderItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InternalOrderItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InternalOrderItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PreparedPackingQuantityCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PreparedPackingQuantity"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PreparedPackingQuantityDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PreparedPackingQuantity"] | undefined
};
	["PreparedPackingQuantityUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PreparedPackingQuantity"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PreparedPackingQuantityUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PreparedPackingQuantity"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CourierManagerCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CourierManager"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CourierManagerDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CourierManager"] | undefined
};
	["CourierManagerUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CourierManager"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CourierManagerUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CourierManager"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryZoneCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryZone"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryZoneDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryZone"] | undefined
};
	["DeliveryZoneUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryZone"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryZoneUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryZone"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryTimelinePresetCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryTimelinePreset"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryTimelinePresetDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryTimelinePreset"] | undefined
};
	["DeliveryTimelinePresetUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryTimelinePreset"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryTimelinePresetUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryTimelinePreset"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderDeliveryTimelineCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderDeliveryTimeline"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderDeliveryTimelineDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderDeliveryTimeline"] | undefined
};
	["OrderDeliveryTimelineUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderDeliveryTimeline"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderDeliveryTimelineUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderDeliveryTimeline"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderEventCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderEvent"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderEventDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderEvent"] | undefined
};
	["OrderEventUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderEvent"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderEventUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderEvent"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LiftagoRideCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LiftagoRide"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LiftagoRideDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LiftagoRide"] | undefined
};
	["LiftagoRideUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LiftagoRide"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LiftagoRideUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LiftagoRide"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InvoiceCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Invoice"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InvoiceDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Invoice"] | undefined
};
	["InvoiceUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Invoice"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InvoiceUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Invoice"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InvoicingPlanCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InvoicingPlan"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InvoicingPlanDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InvoicingPlan"] | undefined
};
	["InvoicingPlanUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InvoicingPlan"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InvoicingPlanUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InvoicingPlan"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductPackingLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductPackingLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductPackingLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductPackingLocale"] | undefined
};
	["ProductPackingLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductPackingLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductPackingLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductPackingLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductLocale"] | undefined
};
	["ProductLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductRecipeLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductRecipeLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductRecipeLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductRecipeLocale"] | undefined
};
	["ProductRecipeLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductRecipeLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductRecipeLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductRecipeLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UserDeviceCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UserDevice"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UserDeviceDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UserDevice"] | undefined
};
	["UserDeviceUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UserDevice"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UserDeviceUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UserDevice"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProtectedActionCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProtectedAction"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProtectedActionDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProtectedAction"] | undefined
};
	["ProtectedActionUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProtectedAction"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProtectedActionUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProtectedAction"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PickerCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Picker"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PickerDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Picker"] | undefined
};
	["PickerUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Picker"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PickerUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Picker"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableTemplateStaffOptionsCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableTemplateStaffOptions"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableTemplateStaffOptionsDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableTemplateStaffOptions"] | undefined
};
	["TimetableTemplateStaffOptionsUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableTemplateStaffOptions"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableTemplateStaffOptionsUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableTemplateStaffOptions"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShoppingListCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShoppingList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShoppingListDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShoppingList"] | undefined
};
	["ShoppingListUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShoppingList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShoppingListUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShoppingList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SuppliesPurchaseCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SuppliesPurchase"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SuppliesPurchaseDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SuppliesPurchase"] | undefined
};
	["SuppliesPurchaseUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SuppliesPurchase"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SuppliesPurchaseUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SuppliesPurchase"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InvoicingPresetCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InvoicingPreset"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InvoicingPresetDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InvoicingPreset"] | undefined
};
	["InvoicingPresetUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InvoicingPreset"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InvoicingPresetUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InvoicingPreset"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LogRecordCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LogRecord"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LogRecordDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LogRecord"] | undefined
};
	["LogRecordUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LogRecord"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LogRecordUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LogRecord"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BillingSubjectCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BillingSubject"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BillingSubjectDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BillingSubject"] | undefined
};
	["BillingSubjectUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BillingSubject"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BillingSubjectUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BillingSubject"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShoppingListItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShoppingListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShoppingListItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShoppingListItem"] | undefined
};
	["ShoppingListItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShoppingListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShoppingListItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShoppingListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SuppliesPurchaseItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SuppliesPurchaseItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SuppliesPurchaseItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SuppliesPurchaseItem"] | undefined
};
	["SuppliesPurchaseItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SuppliesPurchaseItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SuppliesPurchaseItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SuppliesPurchaseItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerCreditTransactionCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerCreditTransaction"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerCreditTransactionDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerCreditTransaction"] | undefined
};
	["CustomerCreditTransactionUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerCreditTransaction"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerCreditTransactionUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerCreditTransaction"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VirtualProductCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VirtualProduct"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VirtualProductDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VirtualProduct"] | undefined
};
	["VirtualProductUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VirtualProduct"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VirtualProductUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VirtualProduct"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VirtualProductEffectCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VirtualProductEffect"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VirtualProductEffectDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VirtualProductEffect"] | undefined
};
	["VirtualProductEffectUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VirtualProductEffect"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VirtualProductEffectUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VirtualProductEffect"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["EmploymentInformationCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EmploymentInformation"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["EmploymentInformationDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EmploymentInformation"] | undefined
};
	["EmploymentInformationUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EmploymentInformation"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["EmploymentInformationUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EmploymentInformation"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RemunerationProfileCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RemunerationProfile"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RemunerationProfileDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RemunerationProfile"] | undefined
};
	["RemunerationProfileUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RemunerationProfile"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RemunerationProfileUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RemunerationProfile"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["WorkMonthCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["WorkMonth"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["WorkMonthDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["WorkMonth"] | undefined
};
	["WorkMonthUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["WorkMonth"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["WorkMonthUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["WorkMonth"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SalaryOptionsCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SalaryOptions"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SalaryOptionsDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SalaryOptions"] | undefined
};
	["SalaryOptionsUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SalaryOptions"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SalaryOptionsUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SalaryOptions"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableShiftSwapInfoCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableShiftSwapInfo"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableShiftSwapInfoDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableShiftSwapInfo"] | undefined
};
	["TimetableShiftSwapInfoUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableShiftSwapInfo"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableShiftSwapInfoUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableShiftSwapInfo"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductGridCategoryCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGridCategory"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductGridCategoryDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGridCategory"] | undefined
};
	["ProductGridCategoryUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGridCategory"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductGridCategoryUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGridCategory"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CashierCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Cashier"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CashierDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Cashier"] | undefined
};
	["CashierUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Cashier"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CashierUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Cashier"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleCategoryCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleCategory"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleCategoryDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleCategory"] | undefined
};
	["PointOfSaleCategoryUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleCategory"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleCategoryUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleCategory"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleCategoryLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleCategoryLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleCategoryLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleCategoryLocale"] | undefined
};
	["PointOfSaleCategoryLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleCategoryLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleCategoryLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleCategoryLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleCategoryProductCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleCategoryProduct"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleCategoryProductDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleCategoryProduct"] | undefined
};
	["PointOfSaleCategoryProductUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleCategoryProduct"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleCategoryProductUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleCategoryProduct"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleCategoryProductLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleCategoryProductLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleCategoryProductLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleCategoryProductLocale"] | undefined
};
	["PointOfSaleCategoryProductLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleCategoryProductLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleCategoryProductLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleCategoryProductLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerTabCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerTab"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerTabDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerTab"] | undefined
};
	["CustomerTabUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerTab"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerTabUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerTab"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerTabItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerTabItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerTabItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerTabItem"] | undefined
};
	["CustomerTabItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerTabItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerTabItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerTabItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["AnonymousSessionCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AnonymousSession"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["AnonymousSessionDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AnonymousSession"] | undefined
};
	["AnonymousSessionUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AnonymousSession"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["AnonymousSessionUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AnonymousSession"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VoucherCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Voucher"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VoucherDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Voucher"] | undefined
};
	["VoucherUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Voucher"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VoucherUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Voucher"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VoucherRedemptionCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VoucherRedemption"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VoucherRedemptionDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VoucherRedemption"] | undefined
};
	["VoucherRedemptionUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VoucherRedemption"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VoucherRedemptionUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VoucherRedemption"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UnassignedShiftInfoCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UnassignedShiftInfo"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UnassignedShiftInfoDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UnassignedShiftInfo"] | undefined
};
	["UnassignedShiftInfoUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UnassignedShiftInfo"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UnassignedShiftInfoUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UnassignedShiftInfo"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FreshingContainerCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FreshingContainer"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FreshingContainerDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FreshingContainer"] | undefined
};
	["FreshingContainerUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FreshingContainer"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FreshingContainerUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FreshingContainer"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextItem"] | undefined
};
	["TextItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextListCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextListDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextList"] | undefined
};
	["TextListUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextListUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryRegionsCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryRegions"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryRegionsDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryRegions"] | undefined
};
	["DeliveryRegionsUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryRegions"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryRegionsUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryRegions"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryRegionsItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryRegionsItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryRegionsItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryRegionsItem"] | undefined
};
	["DeliveryRegionsItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryRegionsItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryRegionsItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryRegionsItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageListCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageListDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageList"] | undefined
};
	["ImageListUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageListUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageListItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageListItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageListItem"] | undefined
};
	["ImageListItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageListItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetablesEmployeePrivilegesCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetablesEmployeePrivileges"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetablesEmployeePrivilegesDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetablesEmployeePrivileges"] | undefined
};
	["TimetablesEmployeePrivilegesUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetablesEmployeePrivileges"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetablesEmployeePrivilegesUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetablesEmployeePrivileges"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableDayNoteCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableDayNote"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableDayNoteDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableDayNote"] | undefined
};
	["TimetableDayNoteUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableDayNote"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableDayNoteUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableDayNote"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryMethodLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryMethodLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryMethodLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryMethodLocale"] | undefined
};
	["DeliveryMethodLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryMethodLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryMethodLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryMethodLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IngredientSupplierCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IngredientSupplier"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IngredientSupplierDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IngredientSupplier"] | undefined
};
	["IngredientSupplierUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IngredientSupplier"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IngredientSupplierUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IngredientSupplier"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IngredientSupplierItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IngredientSupplierItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IngredientSupplierItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IngredientSupplierItem"] | undefined
};
	["IngredientSupplierItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IngredientSupplierItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IngredientSupplierItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IngredientSupplierItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IngredientSupplierListCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IngredientSupplierList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IngredientSupplierListDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IngredientSupplierList"] | undefined
};
	["IngredientSupplierListUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IngredientSupplierList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IngredientSupplierListUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IngredientSupplierList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IngredientSupplierLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IngredientSupplierLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IngredientSupplierLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IngredientSupplierLocale"] | undefined
};
	["IngredientSupplierLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IngredientSupplierLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IngredientSupplierLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IngredientSupplierLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RedirectCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Redirect"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RedirectDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Redirect"] | undefined
};
	["RedirectUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Redirect"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RedirectUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Redirect"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["NutritionFactsCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NutritionFacts"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["NutritionFactsDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NutritionFacts"] | undefined
};
	["NutritionFactsUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NutritionFacts"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["NutritionFactsUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NutritionFacts"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VenueCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Venue"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VenueDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Venue"] | undefined
};
	["VenueUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Venue"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VenueUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Venue"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["WorkspaceCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Workspace"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["WorkspaceDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Workspace"] | undefined
};
	["WorkspaceUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Workspace"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["WorkspaceUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Workspace"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InternalBuyerCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InternalBuyer"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InternalBuyerDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InternalBuyer"] | undefined
};
	["InternalBuyerUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InternalBuyer"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InternalBuyerUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InternalBuyer"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VenueEmployeeRoleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VenueEmployeeRole"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VenueEmployeeRoleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VenueEmployeeRole"] | undefined
};
	["VenueEmployeeRoleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VenueEmployeeRole"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VenueEmployeeRoleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VenueEmployeeRole"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IdentificationAttemptCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IdentificationAttempt"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IdentificationAttemptDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IdentificationAttempt"] | undefined
};
	["IdentificationAttemptUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IdentificationAttempt"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IdentificationAttemptUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IdentificationAttempt"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IdentificationCodeCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IdentificationCode"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IdentificationCodeDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IdentificationCode"] | undefined
};
	["IdentificationCodeUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IdentificationCode"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IdentificationCodeUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IdentificationCode"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IdentificationCodeLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IdentificationCodeLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IdentificationCodeLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IdentificationCodeLocale"] | undefined
};
	["IdentificationCodeLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IdentificationCodeLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IdentificationCodeLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IdentificationCodeLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PipelineCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Pipeline"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PipelineDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Pipeline"] | undefined
};
	["PipelineUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Pipeline"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PipelineUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Pipeline"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PipelineLeadCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineLead"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PipelineLeadDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineLead"] | undefined
};
	["PipelineLeadUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineLead"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PipelineLeadUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineLead"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PipelineStageCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineStage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PipelineStageDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineStage"] | undefined
};
	["PipelineStageUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineStage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PipelineStageUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineStage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PipelineStageItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineStageItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PipelineStageItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineStageItem"] | undefined
};
	["PipelineStageItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineStageItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PipelineStageItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineStageItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PipelineStageLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineStageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PipelineStageLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineStageLocale"] | undefined
};
	["PipelineStageLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineStageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PipelineStageLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineStageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SalesManagerCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SalesManager"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SalesManagerDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SalesManager"] | undefined
};
	["SalesManagerUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SalesManager"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SalesManagerUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SalesManager"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CashierManagerCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CashierManager"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CashierManagerDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CashierManager"] | undefined
};
	["CashierManagerUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CashierManager"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CashierManagerUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CashierManager"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleApplicationDeviceCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleApplicationDevice"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleApplicationDeviceDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleApplicationDevice"] | undefined
};
	["PointOfSaleApplicationDeviceUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleApplicationDevice"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleApplicationDeviceUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleApplicationDevice"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleTerminalCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleTerminal"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleTerminalDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleTerminal"] | undefined
};
	["PointOfSaleTerminalUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleTerminal"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleTerminalUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleTerminal"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PipelineStageSentimentCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineStageSentiment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PipelineStageSentimentDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineStageSentiment"] | undefined
};
	["PipelineStageSentimentUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineStageSentiment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PipelineStageSentimentUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineStageSentiment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeviceIdentifierCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeviceIdentifier"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeviceIdentifierDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeviceIdentifier"] | undefined
};
	["DeviceIdentifierUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeviceIdentifier"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeviceIdentifierUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeviceIdentifier"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSalePrinterCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSalePrinter"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSalePrinterDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSalePrinter"] | undefined
};
	["PointOfSalePrinterUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSalePrinter"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSalePrinterUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSalePrinter"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GratuityCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gratuity"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GratuityDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gratuity"] | undefined
};
	["GratuityUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gratuity"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GratuityUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gratuity"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FulfillmentNoteCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FulfillmentNote"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FulfillmentNoteDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FulfillmentNote"] | undefined
};
	["FulfillmentNoteUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FulfillmentNote"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FulfillmentNoteUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FulfillmentNote"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LeadFormCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LeadForm"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LeadFormDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LeadForm"] | undefined
};
	["LeadFormUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LeadForm"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LeadFormUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LeadForm"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SubscriptionBoxCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubscriptionBox"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SubscriptionBoxDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubscriptionBox"] | undefined
};
	["SubscriptionBoxUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubscriptionBox"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SubscriptionBoxUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubscriptionBox"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SubscriptionBoxLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubscriptionBoxLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SubscriptionBoxLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubscriptionBoxLocale"] | undefined
};
	["SubscriptionBoxLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubscriptionBoxLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SubscriptionBoxLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubscriptionBoxLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessServiceCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessService"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessServiceDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessService"] | undefined
};
	["BusinessServiceUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessService"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessServiceUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessService"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessServiceEventCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessServiceEvent"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessServiceEventDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessServiceEvent"] | undefined
};
	["BusinessServiceEventUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessServiceEvent"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessServiceEventUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessServiceEvent"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessServiceLocaleCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessServiceLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessServiceLocaleDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessServiceLocale"] | undefined
};
	["BusinessServiceLocaleUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessServiceLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessServiceLocaleUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessServiceLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GridTileItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GridTileItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GridTileItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GridTileItem"] | undefined
};
	["GridTileItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GridTileItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GridTileItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GridTileItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GridTilesCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GridTiles"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GridTilesDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GridTiles"] | undefined
};
	["GridTilesUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GridTiles"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GridTilesUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GridTiles"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["AreaCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Area"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["AreaDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Area"] | undefined
};
	["AreaUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Area"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["AreaUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Area"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PositionCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Position"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PositionDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Position"] | undefined
};
	["PositionUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Position"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PositionUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Position"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StatsEnabledWidgetTypeCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StatsEnabledWidgetType"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StatsEnabledWidgetTypeDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StatsEnabledWidgetType"] | undefined
};
	["StatsEnabledWidgetTypeUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StatsEnabledWidgetType"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StatsEnabledWidgetTypeUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StatsEnabledWidgetType"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StatsWidgetCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StatsWidget"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StatsWidgetDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StatsWidget"] | undefined
};
	["StatsWidgetUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StatsWidget"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StatsWidgetUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StatsWidget"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StatsWidgetsLayoutCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StatsWidgetsLayout"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StatsWidgetsLayoutDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StatsWidgetsLayout"] | undefined
};
	["StatsWidgetsLayoutUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StatsWidgetsLayout"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StatsWidgetsLayoutUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StatsWidgetsLayout"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeatCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seat"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeatDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seat"] | undefined
};
	["SeatUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seat"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeatUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seat"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TableCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Table"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TableDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Table"] | undefined
};
	["TableUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Table"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TableUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Table"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StatsPageCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StatsPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StatsPageDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StatsPage"] | undefined
};
	["StatsPageUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StatsPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StatsPageUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StatsPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UnassignReasonCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UnassignReason"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UnassignReasonDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UnassignReason"] | undefined
};
	["UnassignReasonUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UnassignReason"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UnassignReasonUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UnassignReason"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DoubleshotCoffeeEquipmentCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DoubleshotCoffeeEquipment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DoubleshotCoffeeEquipmentDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DoubleshotCoffeeEquipment"] | undefined
};
	["DoubleshotCoffeeEquipmentUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DoubleshotCoffeeEquipment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DoubleshotCoffeeEquipmentUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DoubleshotCoffeeEquipment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ExpenseCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Expense"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ExpenseDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Expense"] | undefined
};
	["ExpenseUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Expense"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ExpenseUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Expense"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ExpenseCategoryCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ExpenseCategory"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ExpenseCategoryDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ExpenseCategory"] | undefined
};
	["ExpenseCategoryUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ExpenseCategory"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ExpenseCategoryUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ExpenseCategory"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ExpenseChangeCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ExpenseChange"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ExpenseChangeDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ExpenseChange"] | undefined
};
	["ExpenseChangeUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ExpenseChange"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ExpenseChangeUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ExpenseChange"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ExpenseDocumentCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ExpenseDocument"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ExpenseDocumentDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ExpenseDocument"] | undefined
};
	["ExpenseDocumentUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ExpenseDocument"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ExpenseDocumentUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ExpenseDocument"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RevenuePredictionCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RevenuePrediction"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RevenuePredictionDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RevenuePrediction"] | undefined
};
	["RevenuePredictionUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RevenuePrediction"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RevenuePredictionUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RevenuePrediction"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RevenuePredictionChangeCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RevenuePredictionChange"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RevenuePredictionChangeDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RevenuePredictionChange"] | undefined
};
	["RevenuePredictionChangeUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RevenuePredictionChange"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RevenuePredictionChangeUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RevenuePredictionChange"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FileCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["File"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FileDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["File"] | undefined
};
	["FileUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["File"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FileUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["File"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LineCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Line"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LineDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Line"] | undefined
};
	["LineUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Line"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LineUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Line"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FinancesBalanceItemCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FinancesBalanceItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FinancesBalanceItemDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FinancesBalanceItem"] | undefined
};
	["FinancesBalanceItemUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FinancesBalanceItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FinancesBalanceItemUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FinancesBalanceItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["WoltDriveDeliveryCreateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["WoltDriveDelivery"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["WoltDriveDeliveryDeleteResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["WoltDriveDelivery"] | undefined
};
	["WoltDriveDeliveryUpdateResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["WoltDriveDelivery"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["WoltDriveDeliveryUpsertResult"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["WoltDriveDelivery"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MutationTransaction"]: {
		ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	validation: GraphQLTypes["_ValidationResult"],
	createAddress: GraphQLTypes["AddressCreateResult"],
	deleteAddress: GraphQLTypes["AddressDeleteResult"],
	updateAddress: GraphQLTypes["AddressUpdateResult"],
	upsertAddress: GraphQLTypes["AddressUpsertResult"],
	createCountry: GraphQLTypes["CountryCreateResult"],
	deleteCountry: GraphQLTypes["CountryDeleteResult"],
	updateCountry: GraphQLTypes["CountryUpdateResult"],
	upsertCountry: GraphQLTypes["CountryUpsertResult"],
	createChannel: GraphQLTypes["ChannelCreateResult"],
	deleteChannel: GraphQLTypes["ChannelDeleteResult"],
	updateChannel: GraphQLTypes["ChannelUpdateResult"],
	upsertChannel: GraphQLTypes["ChannelUpsertResult"],
	createChannelPayment: GraphQLTypes["ChannelPaymentCreateResult"],
	deleteChannelPayment: GraphQLTypes["ChannelPaymentDeleteResult"],
	updateChannelPayment: GraphQLTypes["ChannelPaymentUpdateResult"],
	upsertChannelPayment: GraphQLTypes["ChannelPaymentUpsertResult"],
	createChannelDelivery: GraphQLTypes["ChannelDeliveryCreateResult"],
	deleteChannelDelivery: GraphQLTypes["ChannelDeliveryDeleteResult"],
	updateChannelDelivery: GraphQLTypes["ChannelDeliveryUpdateResult"],
	upsertChannelDelivery: GraphQLTypes["ChannelDeliveryUpsertResult"],
	createCustomer: GraphQLTypes["CustomerCreateResult"],
	deleteCustomer: GraphQLTypes["CustomerDeleteResult"],
	updateCustomer: GraphQLTypes["CustomerUpdateResult"],
	upsertCustomer: GraphQLTypes["CustomerUpsertResult"],
	createCustomerCredit: GraphQLTypes["CustomerCreditCreateResult"],
	deleteCustomerCredit: GraphQLTypes["CustomerCreditDeleteResult"],
	updateCustomerCredit: GraphQLTypes["CustomerCreditUpdateResult"],
	upsertCustomerCredit: GraphQLTypes["CustomerCreditUpsertResult"],
	createCustomerGroup: GraphQLTypes["CustomerGroupCreateResult"],
	deleteCustomerGroup: GraphQLTypes["CustomerGroupDeleteResult"],
	updateCustomerGroup: GraphQLTypes["CustomerGroupUpdateResult"],
	upsertCustomerGroup: GraphQLTypes["CustomerGroupUpsertResult"],
	createCustomerPaymentMethod: GraphQLTypes["CustomerPaymentMethodCreateResult"],
	deleteCustomerPaymentMethod: GraphQLTypes["CustomerPaymentMethodDeleteResult"],
	updateCustomerPaymentMethod: GraphQLTypes["CustomerPaymentMethodUpdateResult"],
	upsertCustomerPaymentMethod: GraphQLTypes["CustomerPaymentMethodUpsertResult"],
	createDeliveryMethod: GraphQLTypes["DeliveryMethodCreateResult"],
	deleteDeliveryMethod: GraphQLTypes["DeliveryMethodDeleteResult"],
	updateDeliveryMethod: GraphQLTypes["DeliveryMethodUpdateResult"],
	upsertDeliveryMethod: GraphQLTypes["DeliveryMethodUpsertResult"],
	createOrder: GraphQLTypes["OrderCreateResult"],
	deleteOrder: GraphQLTypes["OrderDeleteResult"],
	updateOrder: GraphQLTypes["OrderUpdateResult"],
	upsertOrder: GraphQLTypes["OrderUpsertResult"],
	createOrderDiscount: GraphQLTypes["OrderDiscountCreateResult"],
	deleteOrderDiscount: GraphQLTypes["OrderDiscountDeleteResult"],
	updateOrderDiscount: GraphQLTypes["OrderDiscountUpdateResult"],
	upsertOrderDiscount: GraphQLTypes["OrderDiscountUpsertResult"],
	createOrderPayment: GraphQLTypes["OrderPaymentCreateResult"],
	deleteOrderPayment: GraphQLTypes["OrderPaymentDeleteResult"],
	updateOrderPayment: GraphQLTypes["OrderPaymentUpdateResult"],
	upsertOrderPayment: GraphQLTypes["OrderPaymentUpsertResult"],
	createOrderDelivery: GraphQLTypes["OrderDeliveryCreateResult"],
	deleteOrderDelivery: GraphQLTypes["OrderDeliveryDeleteResult"],
	updateOrderDelivery: GraphQLTypes["OrderDeliveryUpdateResult"],
	upsertOrderDelivery: GraphQLTypes["OrderDeliveryUpsertResult"],
	createOrderItem: GraphQLTypes["OrderItemCreateResult"],
	deleteOrderItem: GraphQLTypes["OrderItemDeleteResult"],
	updateOrderItem: GraphQLTypes["OrderItemUpdateResult"],
	upsertOrderItem: GraphQLTypes["OrderItemUpsertResult"],
	createPaymentMethod: GraphQLTypes["PaymentMethodCreateResult"],
	deletePaymentMethod: GraphQLTypes["PaymentMethodDeleteResult"],
	updatePaymentMethod: GraphQLTypes["PaymentMethodUpdateResult"],
	upsertPaymentMethod: GraphQLTypes["PaymentMethodUpsertResult"],
	createVatRate: GraphQLTypes["VatRateCreateResult"],
	deleteVatRate: GraphQLTypes["VatRateDeleteResult"],
	updateVatRate: GraphQLTypes["VatRateUpdateResult"],
	upsertVatRate: GraphQLTypes["VatRateUpsertResult"],
	createProduct: GraphQLTypes["ProductCreateResult"],
	deleteProduct: GraphQLTypes["ProductDeleteResult"],
	updateProduct: GraphQLTypes["ProductUpdateResult"],
	upsertProduct: GraphQLTypes["ProductUpsertResult"],
	createProductStock: GraphQLTypes["ProductStockCreateResult"],
	deleteProductStock: GraphQLTypes["ProductStockDeleteResult"],
	updateProductStock: GraphQLTypes["ProductStockUpdateResult"],
	upsertProductStock: GraphQLTypes["ProductStockUpsertResult"],
	createProductPacking: GraphQLTypes["ProductPackingCreateResult"],
	deleteProductPacking: GraphQLTypes["ProductPackingDeleteResult"],
	updateProductPacking: GraphQLTypes["ProductPackingUpdateResult"],
	upsertProductPacking: GraphQLTypes["ProductPackingUpsertResult"],
	createProductGroupPrice: GraphQLTypes["ProductGroupPriceCreateResult"],
	deleteProductGroupPrice: GraphQLTypes["ProductGroupPriceDeleteResult"],
	updateProductGroupPrice: GraphQLTypes["ProductGroupPriceUpdateResult"],
	upsertProductGroupPrice: GraphQLTypes["ProductGroupPriceUpsertResult"],
	createProductRecipe: GraphQLTypes["ProductRecipeCreateResult"],
	deleteProductRecipe: GraphQLTypes["ProductRecipeDeleteResult"],
	updateProductRecipe: GraphQLTypes["ProductRecipeUpdateResult"],
	upsertProductRecipe: GraphQLTypes["ProductRecipeUpsertResult"],
	createProductCategory: GraphQLTypes["ProductCategoryCreateResult"],
	deleteProductCategory: GraphQLTypes["ProductCategoryDeleteResult"],
	updateProductCategory: GraphQLTypes["ProductCategoryUpdateResult"],
	upsertProductCategory: GraphQLTypes["ProductCategoryUpsertResult"],
	createStore: GraphQLTypes["StoreCreateResult"],
	deleteStore: GraphQLTypes["StoreDeleteResult"],
	updateStore: GraphQLTypes["StoreUpdateResult"],
	upsertStore: GraphQLTypes["StoreUpsertResult"],
	createTag: GraphQLTypes["TagCreateResult"],
	deleteTag: GraphQLTypes["TagDeleteResult"],
	updateTag: GraphQLTypes["TagUpdateResult"],
	upsertTag: GraphQLTypes["TagUpsertResult"],
	createImage: GraphQLTypes["ImageCreateResult"],
	deleteImage: GraphQLTypes["ImageDeleteResult"],
	updateImage: GraphQLTypes["ImageUpdateResult"],
	upsertImage: GraphQLTypes["ImageUpsertResult"],
	createBusinessCategory: GraphQLTypes["BusinessCategoryCreateResult"],
	deleteBusinessCategory: GraphQLTypes["BusinessCategoryDeleteResult"],
	updateBusinessCategory: GraphQLTypes["BusinessCategoryUpdateResult"],
	upsertBusinessCategory: GraphQLTypes["BusinessCategoryUpsertResult"],
	createProductList: GraphQLTypes["ProductListCreateResult"],
	deleteProductList: GraphQLTypes["ProductListDeleteResult"],
	updateProductList: GraphQLTypes["ProductListUpdateResult"],
	upsertProductList: GraphQLTypes["ProductListUpsertResult"],
	createProductListItem: GraphQLTypes["ProductListItemCreateResult"],
	deleteProductListItem: GraphQLTypes["ProductListItemDeleteResult"],
	updateProductListItem: GraphQLTypes["ProductListItemUpdateResult"],
	upsertProductListItem: GraphQLTypes["ProductListItemUpsertResult"],
	createProductCategoryList: GraphQLTypes["ProductCategoryListCreateResult"],
	deleteProductCategoryList: GraphQLTypes["ProductCategoryListDeleteResult"],
	updateProductCategoryList: GraphQLTypes["ProductCategoryListUpdateResult"],
	upsertProductCategoryList: GraphQLTypes["ProductCategoryListUpsertResult"],
	createProductCategoryListItem: GraphQLTypes["ProductCategoryListItemCreateResult"],
	deleteProductCategoryListItem: GraphQLTypes["ProductCategoryListItemDeleteResult"],
	updateProductCategoryListItem: GraphQLTypes["ProductCategoryListItemUpdateResult"],
	upsertProductCategoryListItem: GraphQLTypes["ProductCategoryListItemUpsertResult"],
	createBusinessCategoryLocale: GraphQLTypes["BusinessCategoryLocaleCreateResult"],
	deleteBusinessCategoryLocale: GraphQLTypes["BusinessCategoryLocaleDeleteResult"],
	updateBusinessCategoryLocale: GraphQLTypes["BusinessCategoryLocaleUpdateResult"],
	upsertBusinessCategoryLocale: GraphQLTypes["BusinessCategoryLocaleUpsertResult"],
	createLocale: GraphQLTypes["LocaleCreateResult"],
	deleteLocale: GraphQLTypes["LocaleDeleteResult"],
	updateLocale: GraphQLTypes["LocaleUpdateResult"],
	upsertLocale: GraphQLTypes["LocaleUpsertResult"],
	createProductCategoryListLocale: GraphQLTypes["ProductCategoryListLocaleCreateResult"],
	deleteProductCategoryListLocale: GraphQLTypes["ProductCategoryListLocaleDeleteResult"],
	updateProductCategoryListLocale: GraphQLTypes["ProductCategoryListLocaleUpdateResult"],
	upsertProductCategoryListLocale: GraphQLTypes["ProductCategoryListLocaleUpsertResult"],
	createCustomerName: GraphQLTypes["CustomerNameCreateResult"],
	deleteCustomerName: GraphQLTypes["CustomerNameDeleteResult"],
	updateCustomerName: GraphQLTypes["CustomerNameUpdateResult"],
	upsertCustomerName: GraphQLTypes["CustomerNameUpsertResult"],
	createCustomerAlias: GraphQLTypes["CustomerAliasCreateResult"],
	deleteCustomerAlias: GraphQLTypes["CustomerAliasDeleteResult"],
	updateCustomerAlias: GraphQLTypes["CustomerAliasUpdateResult"],
	upsertCustomerAlias: GraphQLTypes["CustomerAliasUpsertResult"],
	createProductIngredientItem: GraphQLTypes["ProductIngredientItemCreateResult"],
	deleteProductIngredientItem: GraphQLTypes["ProductIngredientItemDeleteResult"],
	updateProductIngredientItem: GraphQLTypes["ProductIngredientItemUpdateResult"],
	upsertProductIngredientItem: GraphQLTypes["ProductIngredientItemUpsertResult"],
	createProductIngredientItemQuantity: GraphQLTypes["ProductIngredientItemQuantityCreateResult"],
	deleteProductIngredientItemQuantity: GraphQLTypes["ProductIngredientItemQuantityDeleteResult"],
	updateProductIngredientItemQuantity: GraphQLTypes["ProductIngredientItemQuantityUpdateResult"],
	upsertProductIngredientItemQuantity: GraphQLTypes["ProductIngredientItemQuantityUpsertResult"],
	createProductIngredientItemQuantityUnit: GraphQLTypes["ProductIngredientItemQuantityUnitCreateResult"],
	deleteProductIngredientItemQuantityUnit: GraphQLTypes["ProductIngredientItemQuantityUnitDeleteResult"],
	updateProductIngredientItemQuantityUnit: GraphQLTypes["ProductIngredientItemQuantityUnitUpdateResult"],
	upsertProductIngredientItemQuantityUnit: GraphQLTypes["ProductIngredientItemQuantityUnitUpsertResult"],
	createProductIngredient: GraphQLTypes["ProductIngredientCreateResult"],
	deleteProductIngredient: GraphQLTypes["ProductIngredientDeleteResult"],
	updateProductIngredient: GraphQLTypes["ProductIngredientUpdateResult"],
	upsertProductIngredient: GraphQLTypes["ProductIngredientUpsertResult"],
	createCustomerIngredientRating: GraphQLTypes["CustomerIngredientRatingCreateResult"],
	deleteCustomerIngredientRating: GraphQLTypes["CustomerIngredientRatingDeleteResult"],
	updateCustomerIngredientRating: GraphQLTypes["CustomerIngredientRatingUpdateResult"],
	upsertCustomerIngredientRating: GraphQLTypes["CustomerIngredientRatingUpsertResult"],
	createProductIngredientRating: GraphQLTypes["ProductIngredientRatingCreateResult"],
	deleteProductIngredientRating: GraphQLTypes["ProductIngredientRatingDeleteResult"],
	updateProductIngredientRating: GraphQLTypes["ProductIngredientRatingUpdateResult"],
	upsertProductIngredientRating: GraphQLTypes["ProductIngredientRatingUpsertResult"],
	createProductIngredientLocale: GraphQLTypes["ProductIngredientLocaleCreateResult"],
	deleteProductIngredientLocale: GraphQLTypes["ProductIngredientLocaleDeleteResult"],
	updateProductIngredientLocale: GraphQLTypes["ProductIngredientLocaleUpdateResult"],
	upsertProductIngredientLocale: GraphQLTypes["ProductIngredientLocaleUpsertResult"],
	createOrderRecurrence: GraphQLTypes["OrderRecurrenceCreateResult"],
	deleteOrderRecurrence: GraphQLTypes["OrderRecurrenceDeleteResult"],
	updateOrderRecurrence: GraphQLTypes["OrderRecurrenceUpdateResult"],
	upsertOrderRecurrence: GraphQLTypes["OrderRecurrenceUpsertResult"],
	createOrderRecurrenceLocale: GraphQLTypes["OrderRecurrenceLocaleCreateResult"],
	deleteOrderRecurrenceLocale: GraphQLTypes["OrderRecurrenceLocaleDeleteResult"],
	updateOrderRecurrenceLocale: GraphQLTypes["OrderRecurrenceLocaleUpdateResult"],
	upsertOrderRecurrenceLocale: GraphQLTypes["OrderRecurrenceLocaleUpsertResult"],
	createBusinessCustomer: GraphQLTypes["BusinessCustomerCreateResult"],
	deleteBusinessCustomer: GraphQLTypes["BusinessCustomerDeleteResult"],
	updateBusinessCustomer: GraphQLTypes["BusinessCustomerUpdateResult"],
	upsertBusinessCustomer: GraphQLTypes["BusinessCustomerUpsertResult"],
	createPointOfSale: GraphQLTypes["PointOfSaleCreateResult"],
	deletePointOfSale: GraphQLTypes["PointOfSaleDeleteResult"],
	updatePointOfSale: GraphQLTypes["PointOfSaleUpdateResult"],
	upsertPointOfSale: GraphQLTypes["PointOfSaleUpsertResult"],
	createStaff: GraphQLTypes["StaffCreateResult"],
	deleteStaff: GraphQLTypes["StaffDeleteResult"],
	updateStaff: GraphQLTypes["StaffUpdateResult"],
	upsertStaff: GraphQLTypes["StaffUpsertResult"],
	createBlog: GraphQLTypes["BlogCreateResult"],
	deleteBlog: GraphQLTypes["BlogDeleteResult"],
	updateBlog: GraphQLTypes["BlogUpdateResult"],
	upsertBlog: GraphQLTypes["BlogUpsertResult"],
	createBlogLocale: GraphQLTypes["BlogLocaleCreateResult"],
	deleteBlogLocale: GraphQLTypes["BlogLocaleDeleteResult"],
	updateBlogLocale: GraphQLTypes["BlogLocaleUpdateResult"],
	upsertBlogLocale: GraphQLTypes["BlogLocaleUpsertResult"],
	createBlogPost: GraphQLTypes["BlogPostCreateResult"],
	deleteBlogPost: GraphQLTypes["BlogPostDeleteResult"],
	updateBlogPost: GraphQLTypes["BlogPostUpdateResult"],
	upsertBlogPost: GraphQLTypes["BlogPostUpsertResult"],
	createBlogPostLocale: GraphQLTypes["BlogPostLocaleCreateResult"],
	deleteBlogPostLocale: GraphQLTypes["BlogPostLocaleDeleteResult"],
	updateBlogPostLocale: GraphQLTypes["BlogPostLocaleUpdateResult"],
	upsertBlogPostLocale: GraphQLTypes["BlogPostLocaleUpsertResult"],
	createColorPallete: GraphQLTypes["ColorPalleteCreateResult"],
	deleteColorPallete: GraphQLTypes["ColorPalleteDeleteResult"],
	updateColorPallete: GraphQLTypes["ColorPalleteUpdateResult"],
	upsertColorPallete: GraphQLTypes["ColorPalleteUpsertResult"],
	createContent: GraphQLTypes["ContentCreateResult"],
	deleteContent: GraphQLTypes["ContentDeleteResult"],
	updateContent: GraphQLTypes["ContentUpdateResult"],
	upsertContent: GraphQLTypes["ContentUpsertResult"],
	createContentBlock: GraphQLTypes["ContentBlockCreateResult"],
	deleteContentBlock: GraphQLTypes["ContentBlockDeleteResult"],
	updateContentBlock: GraphQLTypes["ContentBlockUpdateResult"],
	upsertContentBlock: GraphQLTypes["ContentBlockUpsertResult"],
	createContentReference: GraphQLTypes["ContentReferenceCreateResult"],
	deleteContentReference: GraphQLTypes["ContentReferenceDeleteResult"],
	updateContentReference: GraphQLTypes["ContentReferenceUpdateResult"],
	upsertContentReference: GraphQLTypes["ContentReferenceUpsertResult"],
	createBlogPostList: GraphQLTypes["BlogPostListCreateResult"],
	deleteBlogPostList: GraphQLTypes["BlogPostListDeleteResult"],
	updateBlogPostList: GraphQLTypes["BlogPostListUpdateResult"],
	upsertBlogPostList: GraphQLTypes["BlogPostListUpsertResult"],
	createBlogPostListItem: GraphQLTypes["BlogPostListItemCreateResult"],
	deleteBlogPostListItem: GraphQLTypes["BlogPostListItemDeleteResult"],
	updateBlogPostListItem: GraphQLTypes["BlogPostListItemUpdateResult"],
	upsertBlogPostListItem: GraphQLTypes["BlogPostListItemUpsertResult"],
	createLinkList: GraphQLTypes["LinkListCreateResult"],
	deleteLinkList: GraphQLTypes["LinkListDeleteResult"],
	updateLinkList: GraphQLTypes["LinkListUpdateResult"],
	upsertLinkList: GraphQLTypes["LinkListUpsertResult"],
	createLinkListItem: GraphQLTypes["LinkListItemCreateResult"],
	deleteLinkListItem: GraphQLTypes["LinkListItemDeleteResult"],
	updateLinkListItem: GraphQLTypes["LinkListItemUpdateResult"],
	upsertLinkListItem: GraphQLTypes["LinkListItemUpsertResult"],
	createCover: GraphQLTypes["CoverCreateResult"],
	deleteCover: GraphQLTypes["CoverDeleteResult"],
	updateCover: GraphQLTypes["CoverUpdateResult"],
	upsertCover: GraphQLTypes["CoverUpsertResult"],
	createLink: GraphQLTypes["LinkCreateResult"],
	deleteLink: GraphQLTypes["LinkDeleteResult"],
	updateLink: GraphQLTypes["LinkUpdateResult"],
	upsertLink: GraphQLTypes["LinkUpsertResult"],
	createLinkable: GraphQLTypes["LinkableCreateResult"],
	deleteLinkable: GraphQLTypes["LinkableDeleteResult"],
	updateLinkable: GraphQLTypes["LinkableUpdateResult"],
	upsertLinkable: GraphQLTypes["LinkableUpsertResult"],
	createMedium: GraphQLTypes["MediumCreateResult"],
	deleteMedium: GraphQLTypes["MediumDeleteResult"],
	updateMedium: GraphQLTypes["MediumUpdateResult"],
	upsertMedium: GraphQLTypes["MediumUpsertResult"],
	createVideo: GraphQLTypes["VideoCreateResult"],
	deleteVideo: GraphQLTypes["VideoDeleteResult"],
	updateVideo: GraphQLTypes["VideoUpdateResult"],
	upsertVideo: GraphQLTypes["VideoUpsertResult"],
	createSeo: GraphQLTypes["SeoCreateResult"],
	deleteSeo: GraphQLTypes["SeoDeleteResult"],
	updateSeo: GraphQLTypes["SeoUpdateResult"],
	upsertSeo: GraphQLTypes["SeoUpsertResult"],
	createProtectedImage: GraphQLTypes["ProtectedImageCreateResult"],
	deleteProtectedImage: GraphQLTypes["ProtectedImageDeleteResult"],
	updateProtectedImage: GraphQLTypes["ProtectedImageUpdateResult"],
	upsertProtectedImage: GraphQLTypes["ProtectedImageUpsertResult"],
	createTranslationDomain: GraphQLTypes["TranslationDomainCreateResult"],
	deleteTranslationDomain: GraphQLTypes["TranslationDomainDeleteResult"],
	updateTranslationDomain: GraphQLTypes["TranslationDomainUpdateResult"],
	upsertTranslationDomain: GraphQLTypes["TranslationDomainUpsertResult"],
	createTranslationCatalogue: GraphQLTypes["TranslationCatalogueCreateResult"],
	deleteTranslationCatalogue: GraphQLTypes["TranslationCatalogueDeleteResult"],
	updateTranslationCatalogue: GraphQLTypes["TranslationCatalogueUpdateResult"],
	upsertTranslationCatalogue: GraphQLTypes["TranslationCatalogueUpsertResult"],
	createTranslationKey: GraphQLTypes["TranslationKeyCreateResult"],
	deleteTranslationKey: GraphQLTypes["TranslationKeyDeleteResult"],
	updateTranslationKey: GraphQLTypes["TranslationKeyUpdateResult"],
	upsertTranslationKey: GraphQLTypes["TranslationKeyUpsertResult"],
	createTranslationValue: GraphQLTypes["TranslationValueCreateResult"],
	deleteTranslationValue: GraphQLTypes["TranslationValueDeleteResult"],
	updateTranslationValue: GraphQLTypes["TranslationValueUpdateResult"],
	upsertTranslationValue: GraphQLTypes["TranslationValueUpsertResult"],
	createTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierCreateResult"],
	deleteTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierDeleteResult"],
	updateTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierUpdateResult"],
	upsertTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierUpsertResult"],
	createSocialsAndApps: GraphQLTypes["SocialsAndAppsCreateResult"],
	deleteSocialsAndApps: GraphQLTypes["SocialsAndAppsDeleteResult"],
	updateSocialsAndApps: GraphQLTypes["SocialsAndAppsUpdateResult"],
	upsertSocialsAndApps: GraphQLTypes["SocialsAndAppsUpsertResult"],
	createProductGrid: GraphQLTypes["ProductGridCreateResult"],
	deleteProductGrid: GraphQLTypes["ProductGridDeleteResult"],
	updateProductGrid: GraphQLTypes["ProductGridUpdateResult"],
	upsertProductGrid: GraphQLTypes["ProductGridUpsertResult"],
	createProductGridItem: GraphQLTypes["ProductGridItemCreateResult"],
	deleteProductGridItem: GraphQLTypes["ProductGridItemDeleteResult"],
	updateProductGridItem: GraphQLTypes["ProductGridItemUpdateResult"],
	upsertProductGridItem: GraphQLTypes["ProductGridItemUpsertResult"],
	createGallery: GraphQLTypes["GalleryCreateResult"],
	deleteGallery: GraphQLTypes["GalleryDeleteResult"],
	updateGallery: GraphQLTypes["GalleryUpdateResult"],
	upsertGallery: GraphQLTypes["GalleryUpsertResult"],
	createGalleryItem: GraphQLTypes["GalleryItemCreateResult"],
	deleteGalleryItem: GraphQLTypes["GalleryItemDeleteResult"],
	updateGalleryItem: GraphQLTypes["GalleryItemUpdateResult"],
	upsertGalleryItem: GraphQLTypes["GalleryItemUpsertResult"],
	createHero: GraphQLTypes["HeroCreateResult"],
	deleteHero: GraphQLTypes["HeroDeleteResult"],
	updateHero: GraphQLTypes["HeroUpdateResult"],
	upsertHero: GraphQLTypes["HeroUpsertResult"],
	createSiteMenu: GraphQLTypes["SiteMenuCreateResult"],
	deleteSiteMenu: GraphQLTypes["SiteMenuDeleteResult"],
	updateSiteMenu: GraphQLTypes["SiteMenuUpdateResult"],
	upsertSiteMenu: GraphQLTypes["SiteMenuUpsertResult"],
	createMenuLocale: GraphQLTypes["MenuLocaleCreateResult"],
	deleteMenuLocale: GraphQLTypes["MenuLocaleDeleteResult"],
	updateMenuLocale: GraphQLTypes["MenuLocaleUpdateResult"],
	upsertMenuLocale: GraphQLTypes["MenuLocaleUpsertResult"],
	createMenuItem: GraphQLTypes["MenuItemCreateResult"],
	deleteMenuItem: GraphQLTypes["MenuItemDeleteResult"],
	updateMenuItem: GraphQLTypes["MenuItemUpdateResult"],
	upsertMenuItem: GraphQLTypes["MenuItemUpsertResult"],
	createPage: GraphQLTypes["PageCreateResult"],
	deletePage: GraphQLTypes["PageDeleteResult"],
	updatePage: GraphQLTypes["PageUpdateResult"],
	upsertPage: GraphQLTypes["PageUpsertResult"],
	createPageLocale: GraphQLTypes["PageLocaleCreateResult"],
	deletePageLocale: GraphQLTypes["PageLocaleDeleteResult"],
	updatePageLocale: GraphQLTypes["PageLocaleUpdateResult"],
	upsertPageLocale: GraphQLTypes["PageLocaleUpsertResult"],
	createWikiPage: GraphQLTypes["WikiPageCreateResult"],
	deleteWikiPage: GraphQLTypes["WikiPageDeleteResult"],
	updateWikiPage: GraphQLTypes["WikiPageUpdateResult"],
	upsertWikiPage: GraphQLTypes["WikiPageUpsertResult"],
	createMenuSubitem: GraphQLTypes["MenuSubitemCreateResult"],
	deleteMenuSubitem: GraphQLTypes["MenuSubitemDeleteResult"],
	updateMenuSubitem: GraphQLTypes["MenuSubitemUpdateResult"],
	upsertMenuSubitem: GraphQLTypes["MenuSubitemUpsertResult"],
	createMenuLinkList: GraphQLTypes["MenuLinkListCreateResult"],
	deleteMenuLinkList: GraphQLTypes["MenuLinkListDeleteResult"],
	updateMenuLinkList: GraphQLTypes["MenuLinkListUpdateResult"],
	upsertMenuLinkList: GraphQLTypes["MenuLinkListUpsertResult"],
	createMenuLinkItem: GraphQLTypes["MenuLinkItemCreateResult"],
	deleteMenuLinkItem: GraphQLTypes["MenuLinkItemDeleteResult"],
	updateMenuLinkItem: GraphQLTypes["MenuLinkItemUpdateResult"],
	upsertMenuLinkItem: GraphQLTypes["MenuLinkItemUpsertResult"],
	createMenuProducts: GraphQLTypes["MenuProductsCreateResult"],
	deleteMenuProducts: GraphQLTypes["MenuProductsDeleteResult"],
	updateMenuProducts: GraphQLTypes["MenuProductsUpdateResult"],
	upsertMenuProducts: GraphQLTypes["MenuProductsUpsertResult"],
	createMenuDelivery: GraphQLTypes["MenuDeliveryCreateResult"],
	deleteMenuDelivery: GraphQLTypes["MenuDeliveryDeleteResult"],
	updateMenuDelivery: GraphQLTypes["MenuDeliveryUpdateResult"],
	upsertMenuDelivery: GraphQLTypes["MenuDeliveryUpsertResult"],
	createMenuContact: GraphQLTypes["MenuContactCreateResult"],
	deleteMenuContact: GraphQLTypes["MenuContactDeleteResult"],
	updateMenuContact: GraphQLTypes["MenuContactUpdateResult"],
	upsertMenuContact: GraphQLTypes["MenuContactUpsertResult"],
	createDeadlineTemplate: GraphQLTypes["DeadlineTemplateCreateResult"],
	deleteDeadlineTemplate: GraphQLTypes["DeadlineTemplateDeleteResult"],
	updateDeadlineTemplate: GraphQLTypes["DeadlineTemplateUpdateResult"],
	upsertDeadlineTemplate: GraphQLTypes["DeadlineTemplateUpsertResult"],
	createEmployeeQueue: GraphQLTypes["EmployeeQueueCreateResult"],
	deleteEmployeeQueue: GraphQLTypes["EmployeeQueueDeleteResult"],
	updateEmployeeQueue: GraphQLTypes["EmployeeQueueUpdateResult"],
	upsertEmployeeQueue: GraphQLTypes["EmployeeQueueUpsertResult"],
	createTimetableDay: GraphQLTypes["TimetableDayCreateResult"],
	deleteTimetableDay: GraphQLTypes["TimetableDayDeleteResult"],
	updateTimetableDay: GraphQLTypes["TimetableDayUpdateResult"],
	upsertTimetableDay: GraphQLTypes["TimetableDayUpsertResult"],
	createTimetableEmployeeRole: GraphQLTypes["TimetableEmployeeRoleCreateResult"],
	deleteTimetableEmployeeRole: GraphQLTypes["TimetableEmployeeRoleDeleteResult"],
	updateTimetableEmployeeRole: GraphQLTypes["TimetableEmployeeRoleUpdateResult"],
	upsertTimetableEmployeeRole: GraphQLTypes["TimetableEmployeeRoleUpsertResult"],
	createTimetableShift: GraphQLTypes["TimetableShiftCreateResult"],
	deleteTimetableShift: GraphQLTypes["TimetableShiftDeleteResult"],
	updateTimetableShift: GraphQLTypes["TimetableShiftUpdateResult"],
	upsertTimetableShift: GraphQLTypes["TimetableShiftUpsertResult"],
	createTimetableShiftGroup: GraphQLTypes["TimetableShiftGroupCreateResult"],
	deleteTimetableShiftGroup: GraphQLTypes["TimetableShiftGroupDeleteResult"],
	updateTimetableShiftGroup: GraphQLTypes["TimetableShiftGroupUpdateResult"],
	upsertTimetableShiftGroup: GraphQLTypes["TimetableShiftGroupUpsertResult"],
	createTimetableShiftPosition: GraphQLTypes["TimetableShiftPositionCreateResult"],
	deleteTimetableShiftPosition: GraphQLTypes["TimetableShiftPositionDeleteResult"],
	updateTimetableShiftPosition: GraphQLTypes["TimetableShiftPositionUpdateResult"],
	upsertTimetableShiftPosition: GraphQLTypes["TimetableShiftPositionUpsertResult"],
	createTimetableTemplate: GraphQLTypes["TimetableTemplateCreateResult"],
	deleteTimetableTemplate: GraphQLTypes["TimetableTemplateDeleteResult"],
	updateTimetableTemplate: GraphQLTypes["TimetableTemplateUpdateResult"],
	upsertTimetableTemplate: GraphQLTypes["TimetableTemplateUpsertResult"],
	createCart: GraphQLTypes["CartCreateResult"],
	deleteCart: GraphQLTypes["CartDeleteResult"],
	updateCart: GraphQLTypes["CartUpdateResult"],
	upsertCart: GraphQLTypes["CartUpsertResult"],
	createCartItem: GraphQLTypes["CartItemCreateResult"],
	deleteCartItem: GraphQLTypes["CartItemDeleteResult"],
	updateCartItem: GraphQLTypes["CartItemUpdateResult"],
	upsertCartItem: GraphQLTypes["CartItemUpsertResult"],
	createEmployeeQueueItem: GraphQLTypes["EmployeeQueueItemCreateResult"],
	deleteEmployeeQueueItem: GraphQLTypes["EmployeeQueueItemDeleteResult"],
	updateEmployeeQueueItem: GraphQLTypes["EmployeeQueueItemUpdateResult"],
	upsertEmployeeQueueItem: GraphQLTypes["EmployeeQueueItemUpsertResult"],
	createApplication: GraphQLTypes["ApplicationCreateResult"],
	deleteApplication: GraphQLTypes["ApplicationDeleteResult"],
	updateApplication: GraphQLTypes["ApplicationUpdateResult"],
	upsertApplication: GraphQLTypes["ApplicationUpsertResult"],
	createApplicationShortcutList: GraphQLTypes["ApplicationShortcutListCreateResult"],
	deleteApplicationShortcutList: GraphQLTypes["ApplicationShortcutListDeleteResult"],
	updateApplicationShortcutList: GraphQLTypes["ApplicationShortcutListUpdateResult"],
	upsertApplicationShortcutList: GraphQLTypes["ApplicationShortcutListUpsertResult"],
	createApplicationShortcutListItem: GraphQLTypes["ApplicationShortcutListItemCreateResult"],
	deleteApplicationShortcutListItem: GraphQLTypes["ApplicationShortcutListItemDeleteResult"],
	updateApplicationShortcutListItem: GraphQLTypes["ApplicationShortcutListItemUpdateResult"],
	upsertApplicationShortcutListItem: GraphQLTypes["ApplicationShortcutListItemUpsertResult"],
	createProductBanner: GraphQLTypes["ProductBannerCreateResult"],
	deleteProductBanner: GraphQLTypes["ProductBannerDeleteResult"],
	updateProductBanner: GraphQLTypes["ProductBannerUpdateResult"],
	upsertProductBanner: GraphQLTypes["ProductBannerUpsertResult"],
	createProductBannerItem: GraphQLTypes["ProductBannerItemCreateResult"],
	deleteProductBannerItem: GraphQLTypes["ProductBannerItemDeleteResult"],
	updateProductBannerItem: GraphQLTypes["ProductBannerItemUpdateResult"],
	upsertProductBannerItem: GraphQLTypes["ProductBannerItemUpsertResult"],
	createProductBannerList: GraphQLTypes["ProductBannerListCreateResult"],
	deleteProductBannerList: GraphQLTypes["ProductBannerListDeleteResult"],
	updateProductBannerList: GraphQLTypes["ProductBannerListUpdateResult"],
	upsertProductBannerList: GraphQLTypes["ProductBannerListUpsertResult"],
	createBartender: GraphQLTypes["BartenderCreateResult"],
	deleteBartender: GraphQLTypes["BartenderDeleteResult"],
	updateBartender: GraphQLTypes["BartenderUpdateResult"],
	upsertBartender: GraphQLTypes["BartenderUpsertResult"],
	createBusinessToBusinessManager: GraphQLTypes["BusinessToBusinessManagerCreateResult"],
	deleteBusinessToBusinessManager: GraphQLTypes["BusinessToBusinessManagerDeleteResult"],
	updateBusinessToBusinessManager: GraphQLTypes["BusinessToBusinessManagerUpdateResult"],
	upsertBusinessToBusinessManager: GraphQLTypes["BusinessToBusinessManagerUpsertResult"],
	createCleaner: GraphQLTypes["CleanerCreateResult"],
	deleteCleaner: GraphQLTypes["CleanerDeleteResult"],
	updateCleaner: GraphQLTypes["CleanerUpdateResult"],
	upsertCleaner: GraphQLTypes["CleanerUpsertResult"],
	createCourier: GraphQLTypes["CourierCreateResult"],
	deleteCourier: GraphQLTypes["CourierDeleteResult"],
	updateCourier: GraphQLTypes["CourierUpdateResult"],
	upsertCourier: GraphQLTypes["CourierUpsertResult"],
	createShiftsManager: GraphQLTypes["ShiftsManagerCreateResult"],
	deleteShiftsManager: GraphQLTypes["ShiftsManagerDeleteResult"],
	updateShiftsManager: GraphQLTypes["ShiftsManagerUpdateResult"],
	upsertShiftsManager: GraphQLTypes["ShiftsManagerUpsertResult"],
	createUser: GraphQLTypes["UserCreateResult"],
	deleteUser: GraphQLTypes["UserDeleteResult"],
	updateUser: GraphQLTypes["UserUpdateResult"],
	upsertUser: GraphQLTypes["UserUpsertResult"],
	createShiftsProfile: GraphQLTypes["ShiftsProfileCreateResult"],
	deleteShiftsProfile: GraphQLTypes["ShiftsProfileDeleteResult"],
	updateShiftsProfile: GraphQLTypes["ShiftsProfileUpdateResult"],
	upsertShiftsProfile: GraphQLTypes["ShiftsProfileUpsertResult"],
	createProductIngredientCategory: GraphQLTypes["ProductIngredientCategoryCreateResult"],
	deleteProductIngredientCategory: GraphQLTypes["ProductIngredientCategoryDeleteResult"],
	updateProductIngredientCategory: GraphQLTypes["ProductIngredientCategoryUpdateResult"],
	upsertProductIngredientCategory: GraphQLTypes["ProductIngredientCategoryUpsertResult"],
	createProductIngredientCategoryLocale: GraphQLTypes["ProductIngredientCategoryLocaleCreateResult"],
	deleteProductIngredientCategoryLocale: GraphQLTypes["ProductIngredientCategoryLocaleDeleteResult"],
	updateProductIngredientCategoryLocale: GraphQLTypes["ProductIngredientCategoryLocaleUpdateResult"],
	upsertProductIngredientCategoryLocale: GraphQLTypes["ProductIngredientCategoryLocaleUpsertResult"],
	createStocksManager: GraphQLTypes["StocksManagerCreateResult"],
	deleteStocksManager: GraphQLTypes["StocksManagerDeleteResult"],
	updateStocksManager: GraphQLTypes["StocksManagerUpdateResult"],
	upsertStocksManager: GraphQLTypes["StocksManagerUpsertResult"],
	createDeliveryRoute: GraphQLTypes["DeliveryRouteCreateResult"],
	deleteDeliveryRoute: GraphQLTypes["DeliveryRouteDeleteResult"],
	updateDeliveryRoute: GraphQLTypes["DeliveryRouteUpdateResult"],
	upsertDeliveryRoute: GraphQLTypes["DeliveryRouteUpsertResult"],
	createDeliveryWaypoint: GraphQLTypes["DeliveryWaypointCreateResult"],
	deleteDeliveryWaypoint: GraphQLTypes["DeliveryWaypointDeleteResult"],
	updateDeliveryWaypoint: GraphQLTypes["DeliveryWaypointUpdateResult"],
	upsertDeliveryWaypoint: GraphQLTypes["DeliveryWaypointUpsertResult"],
	createAllergen: GraphQLTypes["AllergenCreateResult"],
	deleteAllergen: GraphQLTypes["AllergenDeleteResult"],
	updateAllergen: GraphQLTypes["AllergenUpdateResult"],
	upsertAllergen: GraphQLTypes["AllergenUpsertResult"],
	createAllergenLocale: GraphQLTypes["AllergenLocaleCreateResult"],
	deleteAllergenLocale: GraphQLTypes["AllergenLocaleDeleteResult"],
	updateAllergenLocale: GraphQLTypes["AllergenLocaleUpdateResult"],
	upsertAllergenLocale: GraphQLTypes["AllergenLocaleUpsertResult"],
	createGps: GraphQLTypes["GpsCreateResult"],
	deleteGps: GraphQLTypes["GpsDeleteResult"],
	updateGps: GraphQLTypes["GpsUpdateResult"],
	upsertGps: GraphQLTypes["GpsUpsertResult"],
	createWeekHours: GraphQLTypes["WeekHoursCreateResult"],
	deleteWeekHours: GraphQLTypes["WeekHoursDeleteResult"],
	updateWeekHours: GraphQLTypes["WeekHoursUpdateResult"],
	upsertWeekHours: GraphQLTypes["WeekHoursUpsertResult"],
	createPreparedIngredientQuantity: GraphQLTypes["PreparedIngredientQuantityCreateResult"],
	deletePreparedIngredientQuantity: GraphQLTypes["PreparedIngredientQuantityDeleteResult"],
	updatePreparedIngredientQuantity: GraphQLTypes["PreparedIngredientQuantityUpdateResult"],
	upsertPreparedIngredientQuantity: GraphQLTypes["PreparedIngredientQuantityUpsertResult"],
	createPreparedRecipeQuantity: GraphQLTypes["PreparedRecipeQuantityCreateResult"],
	deletePreparedRecipeQuantity: GraphQLTypes["PreparedRecipeQuantityDeleteResult"],
	updatePreparedRecipeQuantity: GraphQLTypes["PreparedRecipeQuantityUpdateResult"],
	upsertPreparedRecipeQuantity: GraphQLTypes["PreparedRecipeQuantityUpsertResult"],
	createInternalOrder: GraphQLTypes["InternalOrderCreateResult"],
	deleteInternalOrder: GraphQLTypes["InternalOrderDeleteResult"],
	updateInternalOrder: GraphQLTypes["InternalOrderUpdateResult"],
	upsertInternalOrder: GraphQLTypes["InternalOrderUpsertResult"],
	createInternalOrderItem: GraphQLTypes["InternalOrderItemCreateResult"],
	deleteInternalOrderItem: GraphQLTypes["InternalOrderItemDeleteResult"],
	updateInternalOrderItem: GraphQLTypes["InternalOrderItemUpdateResult"],
	upsertInternalOrderItem: GraphQLTypes["InternalOrderItemUpsertResult"],
	createPreparedPackingQuantity: GraphQLTypes["PreparedPackingQuantityCreateResult"],
	deletePreparedPackingQuantity: GraphQLTypes["PreparedPackingQuantityDeleteResult"],
	updatePreparedPackingQuantity: GraphQLTypes["PreparedPackingQuantityUpdateResult"],
	upsertPreparedPackingQuantity: GraphQLTypes["PreparedPackingQuantityUpsertResult"],
	createCourierManager: GraphQLTypes["CourierManagerCreateResult"],
	deleteCourierManager: GraphQLTypes["CourierManagerDeleteResult"],
	updateCourierManager: GraphQLTypes["CourierManagerUpdateResult"],
	upsertCourierManager: GraphQLTypes["CourierManagerUpsertResult"],
	createDeliveryZone: GraphQLTypes["DeliveryZoneCreateResult"],
	deleteDeliveryZone: GraphQLTypes["DeliveryZoneDeleteResult"],
	updateDeliveryZone: GraphQLTypes["DeliveryZoneUpdateResult"],
	upsertDeliveryZone: GraphQLTypes["DeliveryZoneUpsertResult"],
	createDeliveryTimelinePreset: GraphQLTypes["DeliveryTimelinePresetCreateResult"],
	deleteDeliveryTimelinePreset: GraphQLTypes["DeliveryTimelinePresetDeleteResult"],
	updateDeliveryTimelinePreset: GraphQLTypes["DeliveryTimelinePresetUpdateResult"],
	upsertDeliveryTimelinePreset: GraphQLTypes["DeliveryTimelinePresetUpsertResult"],
	createOrderDeliveryTimeline: GraphQLTypes["OrderDeliveryTimelineCreateResult"],
	deleteOrderDeliveryTimeline: GraphQLTypes["OrderDeliveryTimelineDeleteResult"],
	updateOrderDeliveryTimeline: GraphQLTypes["OrderDeliveryTimelineUpdateResult"],
	upsertOrderDeliveryTimeline: GraphQLTypes["OrderDeliveryTimelineUpsertResult"],
	createOrderEvent: GraphQLTypes["OrderEventCreateResult"],
	deleteOrderEvent: GraphQLTypes["OrderEventDeleteResult"],
	updateOrderEvent: GraphQLTypes["OrderEventUpdateResult"],
	upsertOrderEvent: GraphQLTypes["OrderEventUpsertResult"],
	createLiftagoRide: GraphQLTypes["LiftagoRideCreateResult"],
	deleteLiftagoRide: GraphQLTypes["LiftagoRideDeleteResult"],
	updateLiftagoRide: GraphQLTypes["LiftagoRideUpdateResult"],
	upsertLiftagoRide: GraphQLTypes["LiftagoRideUpsertResult"],
	createInvoice: GraphQLTypes["InvoiceCreateResult"],
	deleteInvoice: GraphQLTypes["InvoiceDeleteResult"],
	updateInvoice: GraphQLTypes["InvoiceUpdateResult"],
	upsertInvoice: GraphQLTypes["InvoiceUpsertResult"],
	createInvoicingPlan: GraphQLTypes["InvoicingPlanCreateResult"],
	deleteInvoicingPlan: GraphQLTypes["InvoicingPlanDeleteResult"],
	updateInvoicingPlan: GraphQLTypes["InvoicingPlanUpdateResult"],
	upsertInvoicingPlan: GraphQLTypes["InvoicingPlanUpsertResult"],
	createProductPackingLocale: GraphQLTypes["ProductPackingLocaleCreateResult"],
	deleteProductPackingLocale: GraphQLTypes["ProductPackingLocaleDeleteResult"],
	updateProductPackingLocale: GraphQLTypes["ProductPackingLocaleUpdateResult"],
	upsertProductPackingLocale: GraphQLTypes["ProductPackingLocaleUpsertResult"],
	createProductLocale: GraphQLTypes["ProductLocaleCreateResult"],
	deleteProductLocale: GraphQLTypes["ProductLocaleDeleteResult"],
	updateProductLocale: GraphQLTypes["ProductLocaleUpdateResult"],
	upsertProductLocale: GraphQLTypes["ProductLocaleUpsertResult"],
	createProductRecipeLocale: GraphQLTypes["ProductRecipeLocaleCreateResult"],
	deleteProductRecipeLocale: GraphQLTypes["ProductRecipeLocaleDeleteResult"],
	updateProductRecipeLocale: GraphQLTypes["ProductRecipeLocaleUpdateResult"],
	upsertProductRecipeLocale: GraphQLTypes["ProductRecipeLocaleUpsertResult"],
	createUserDevice: GraphQLTypes["UserDeviceCreateResult"],
	deleteUserDevice: GraphQLTypes["UserDeviceDeleteResult"],
	updateUserDevice: GraphQLTypes["UserDeviceUpdateResult"],
	upsertUserDevice: GraphQLTypes["UserDeviceUpsertResult"],
	createProtectedAction: GraphQLTypes["ProtectedActionCreateResult"],
	deleteProtectedAction: GraphQLTypes["ProtectedActionDeleteResult"],
	updateProtectedAction: GraphQLTypes["ProtectedActionUpdateResult"],
	upsertProtectedAction: GraphQLTypes["ProtectedActionUpsertResult"],
	createPicker: GraphQLTypes["PickerCreateResult"],
	deletePicker: GraphQLTypes["PickerDeleteResult"],
	updatePicker: GraphQLTypes["PickerUpdateResult"],
	upsertPicker: GraphQLTypes["PickerUpsertResult"],
	createTimetableTemplateStaffOptions: GraphQLTypes["TimetableTemplateStaffOptionsCreateResult"],
	deleteTimetableTemplateStaffOptions: GraphQLTypes["TimetableTemplateStaffOptionsDeleteResult"],
	updateTimetableTemplateStaffOptions: GraphQLTypes["TimetableTemplateStaffOptionsUpdateResult"],
	upsertTimetableTemplateStaffOptions: GraphQLTypes["TimetableTemplateStaffOptionsUpsertResult"],
	createShoppingList: GraphQLTypes["ShoppingListCreateResult"],
	deleteShoppingList: GraphQLTypes["ShoppingListDeleteResult"],
	updateShoppingList: GraphQLTypes["ShoppingListUpdateResult"],
	upsertShoppingList: GraphQLTypes["ShoppingListUpsertResult"],
	createSuppliesPurchase: GraphQLTypes["SuppliesPurchaseCreateResult"],
	deleteSuppliesPurchase: GraphQLTypes["SuppliesPurchaseDeleteResult"],
	updateSuppliesPurchase: GraphQLTypes["SuppliesPurchaseUpdateResult"],
	upsertSuppliesPurchase: GraphQLTypes["SuppliesPurchaseUpsertResult"],
	createInvoicingPreset: GraphQLTypes["InvoicingPresetCreateResult"],
	deleteInvoicingPreset: GraphQLTypes["InvoicingPresetDeleteResult"],
	updateInvoicingPreset: GraphQLTypes["InvoicingPresetUpdateResult"],
	upsertInvoicingPreset: GraphQLTypes["InvoicingPresetUpsertResult"],
	createLogRecord: GraphQLTypes["LogRecordCreateResult"],
	deleteLogRecord: GraphQLTypes["LogRecordDeleteResult"],
	updateLogRecord: GraphQLTypes["LogRecordUpdateResult"],
	upsertLogRecord: GraphQLTypes["LogRecordUpsertResult"],
	createBillingSubject: GraphQLTypes["BillingSubjectCreateResult"],
	deleteBillingSubject: GraphQLTypes["BillingSubjectDeleteResult"],
	updateBillingSubject: GraphQLTypes["BillingSubjectUpdateResult"],
	upsertBillingSubject: GraphQLTypes["BillingSubjectUpsertResult"],
	createShoppingListItem: GraphQLTypes["ShoppingListItemCreateResult"],
	deleteShoppingListItem: GraphQLTypes["ShoppingListItemDeleteResult"],
	updateShoppingListItem: GraphQLTypes["ShoppingListItemUpdateResult"],
	upsertShoppingListItem: GraphQLTypes["ShoppingListItemUpsertResult"],
	createSuppliesPurchaseItem: GraphQLTypes["SuppliesPurchaseItemCreateResult"],
	deleteSuppliesPurchaseItem: GraphQLTypes["SuppliesPurchaseItemDeleteResult"],
	updateSuppliesPurchaseItem: GraphQLTypes["SuppliesPurchaseItemUpdateResult"],
	upsertSuppliesPurchaseItem: GraphQLTypes["SuppliesPurchaseItemUpsertResult"],
	createCustomerCreditTransaction: GraphQLTypes["CustomerCreditTransactionCreateResult"],
	deleteCustomerCreditTransaction: GraphQLTypes["CustomerCreditTransactionDeleteResult"],
	updateCustomerCreditTransaction: GraphQLTypes["CustomerCreditTransactionUpdateResult"],
	upsertCustomerCreditTransaction: GraphQLTypes["CustomerCreditTransactionUpsertResult"],
	createVirtualProduct: GraphQLTypes["VirtualProductCreateResult"],
	deleteVirtualProduct: GraphQLTypes["VirtualProductDeleteResult"],
	updateVirtualProduct: GraphQLTypes["VirtualProductUpdateResult"],
	upsertVirtualProduct: GraphQLTypes["VirtualProductUpsertResult"],
	createVirtualProductEffect: GraphQLTypes["VirtualProductEffectCreateResult"],
	deleteVirtualProductEffect: GraphQLTypes["VirtualProductEffectDeleteResult"],
	updateVirtualProductEffect: GraphQLTypes["VirtualProductEffectUpdateResult"],
	upsertVirtualProductEffect: GraphQLTypes["VirtualProductEffectUpsertResult"],
	createEmploymentInformation: GraphQLTypes["EmploymentInformationCreateResult"],
	deleteEmploymentInformation: GraphQLTypes["EmploymentInformationDeleteResult"],
	updateEmploymentInformation: GraphQLTypes["EmploymentInformationUpdateResult"],
	upsertEmploymentInformation: GraphQLTypes["EmploymentInformationUpsertResult"],
	createRemunerationProfile: GraphQLTypes["RemunerationProfileCreateResult"],
	deleteRemunerationProfile: GraphQLTypes["RemunerationProfileDeleteResult"],
	updateRemunerationProfile: GraphQLTypes["RemunerationProfileUpdateResult"],
	upsertRemunerationProfile: GraphQLTypes["RemunerationProfileUpsertResult"],
	createWorkMonth: GraphQLTypes["WorkMonthCreateResult"],
	deleteWorkMonth: GraphQLTypes["WorkMonthDeleteResult"],
	updateWorkMonth: GraphQLTypes["WorkMonthUpdateResult"],
	upsertWorkMonth: GraphQLTypes["WorkMonthUpsertResult"],
	createSalaryOptions: GraphQLTypes["SalaryOptionsCreateResult"],
	deleteSalaryOptions: GraphQLTypes["SalaryOptionsDeleteResult"],
	updateSalaryOptions: GraphQLTypes["SalaryOptionsUpdateResult"],
	upsertSalaryOptions: GraphQLTypes["SalaryOptionsUpsertResult"],
	createTimetableShiftSwapInfo: GraphQLTypes["TimetableShiftSwapInfoCreateResult"],
	deleteTimetableShiftSwapInfo: GraphQLTypes["TimetableShiftSwapInfoDeleteResult"],
	updateTimetableShiftSwapInfo: GraphQLTypes["TimetableShiftSwapInfoUpdateResult"],
	upsertTimetableShiftSwapInfo: GraphQLTypes["TimetableShiftSwapInfoUpsertResult"],
	createProductGridCategory: GraphQLTypes["ProductGridCategoryCreateResult"],
	deleteProductGridCategory: GraphQLTypes["ProductGridCategoryDeleteResult"],
	updateProductGridCategory: GraphQLTypes["ProductGridCategoryUpdateResult"],
	upsertProductGridCategory: GraphQLTypes["ProductGridCategoryUpsertResult"],
	createCashier: GraphQLTypes["CashierCreateResult"],
	deleteCashier: GraphQLTypes["CashierDeleteResult"],
	updateCashier: GraphQLTypes["CashierUpdateResult"],
	upsertCashier: GraphQLTypes["CashierUpsertResult"],
	createPointOfSaleCategory: GraphQLTypes["PointOfSaleCategoryCreateResult"],
	deletePointOfSaleCategory: GraphQLTypes["PointOfSaleCategoryDeleteResult"],
	updatePointOfSaleCategory: GraphQLTypes["PointOfSaleCategoryUpdateResult"],
	upsertPointOfSaleCategory: GraphQLTypes["PointOfSaleCategoryUpsertResult"],
	createPointOfSaleCategoryLocale: GraphQLTypes["PointOfSaleCategoryLocaleCreateResult"],
	deletePointOfSaleCategoryLocale: GraphQLTypes["PointOfSaleCategoryLocaleDeleteResult"],
	updatePointOfSaleCategoryLocale: GraphQLTypes["PointOfSaleCategoryLocaleUpdateResult"],
	upsertPointOfSaleCategoryLocale: GraphQLTypes["PointOfSaleCategoryLocaleUpsertResult"],
	createPointOfSaleCategoryProduct: GraphQLTypes["PointOfSaleCategoryProductCreateResult"],
	deletePointOfSaleCategoryProduct: GraphQLTypes["PointOfSaleCategoryProductDeleteResult"],
	updatePointOfSaleCategoryProduct: GraphQLTypes["PointOfSaleCategoryProductUpdateResult"],
	upsertPointOfSaleCategoryProduct: GraphQLTypes["PointOfSaleCategoryProductUpsertResult"],
	createPointOfSaleCategoryProductLocale: GraphQLTypes["PointOfSaleCategoryProductLocaleCreateResult"],
	deletePointOfSaleCategoryProductLocale: GraphQLTypes["PointOfSaleCategoryProductLocaleDeleteResult"],
	updatePointOfSaleCategoryProductLocale: GraphQLTypes["PointOfSaleCategoryProductLocaleUpdateResult"],
	upsertPointOfSaleCategoryProductLocale: GraphQLTypes["PointOfSaleCategoryProductLocaleUpsertResult"],
	createCustomerTab: GraphQLTypes["CustomerTabCreateResult"],
	deleteCustomerTab: GraphQLTypes["CustomerTabDeleteResult"],
	updateCustomerTab: GraphQLTypes["CustomerTabUpdateResult"],
	upsertCustomerTab: GraphQLTypes["CustomerTabUpsertResult"],
	createCustomerTabItem: GraphQLTypes["CustomerTabItemCreateResult"],
	deleteCustomerTabItem: GraphQLTypes["CustomerTabItemDeleteResult"],
	updateCustomerTabItem: GraphQLTypes["CustomerTabItemUpdateResult"],
	upsertCustomerTabItem: GraphQLTypes["CustomerTabItemUpsertResult"],
	createAnonymousSession: GraphQLTypes["AnonymousSessionCreateResult"],
	deleteAnonymousSession: GraphQLTypes["AnonymousSessionDeleteResult"],
	updateAnonymousSession: GraphQLTypes["AnonymousSessionUpdateResult"],
	upsertAnonymousSession: GraphQLTypes["AnonymousSessionUpsertResult"],
	createVoucher: GraphQLTypes["VoucherCreateResult"],
	deleteVoucher: GraphQLTypes["VoucherDeleteResult"],
	updateVoucher: GraphQLTypes["VoucherUpdateResult"],
	upsertVoucher: GraphQLTypes["VoucherUpsertResult"],
	createVoucherRedemption: GraphQLTypes["VoucherRedemptionCreateResult"],
	deleteVoucherRedemption: GraphQLTypes["VoucherRedemptionDeleteResult"],
	updateVoucherRedemption: GraphQLTypes["VoucherRedemptionUpdateResult"],
	upsertVoucherRedemption: GraphQLTypes["VoucherRedemptionUpsertResult"],
	createUnassignedShiftInfo: GraphQLTypes["UnassignedShiftInfoCreateResult"],
	deleteUnassignedShiftInfo: GraphQLTypes["UnassignedShiftInfoDeleteResult"],
	updateUnassignedShiftInfo: GraphQLTypes["UnassignedShiftInfoUpdateResult"],
	upsertUnassignedShiftInfo: GraphQLTypes["UnassignedShiftInfoUpsertResult"],
	createFreshingContainer: GraphQLTypes["FreshingContainerCreateResult"],
	deleteFreshingContainer: GraphQLTypes["FreshingContainerDeleteResult"],
	updateFreshingContainer: GraphQLTypes["FreshingContainerUpdateResult"],
	upsertFreshingContainer: GraphQLTypes["FreshingContainerUpsertResult"],
	createTextItem: GraphQLTypes["TextItemCreateResult"],
	deleteTextItem: GraphQLTypes["TextItemDeleteResult"],
	updateTextItem: GraphQLTypes["TextItemUpdateResult"],
	upsertTextItem: GraphQLTypes["TextItemUpsertResult"],
	createTextList: GraphQLTypes["TextListCreateResult"],
	deleteTextList: GraphQLTypes["TextListDeleteResult"],
	updateTextList: GraphQLTypes["TextListUpdateResult"],
	upsertTextList: GraphQLTypes["TextListUpsertResult"],
	createDeliveryRegions: GraphQLTypes["DeliveryRegionsCreateResult"],
	deleteDeliveryRegions: GraphQLTypes["DeliveryRegionsDeleteResult"],
	updateDeliveryRegions: GraphQLTypes["DeliveryRegionsUpdateResult"],
	upsertDeliveryRegions: GraphQLTypes["DeliveryRegionsUpsertResult"],
	createDeliveryRegionsItem: GraphQLTypes["DeliveryRegionsItemCreateResult"],
	deleteDeliveryRegionsItem: GraphQLTypes["DeliveryRegionsItemDeleteResult"],
	updateDeliveryRegionsItem: GraphQLTypes["DeliveryRegionsItemUpdateResult"],
	upsertDeliveryRegionsItem: GraphQLTypes["DeliveryRegionsItemUpsertResult"],
	createImageList: GraphQLTypes["ImageListCreateResult"],
	deleteImageList: GraphQLTypes["ImageListDeleteResult"],
	updateImageList: GraphQLTypes["ImageListUpdateResult"],
	upsertImageList: GraphQLTypes["ImageListUpsertResult"],
	createImageListItem: GraphQLTypes["ImageListItemCreateResult"],
	deleteImageListItem: GraphQLTypes["ImageListItemDeleteResult"],
	updateImageListItem: GraphQLTypes["ImageListItemUpdateResult"],
	upsertImageListItem: GraphQLTypes["ImageListItemUpsertResult"],
	createTimetablesEmployeePrivileges: GraphQLTypes["TimetablesEmployeePrivilegesCreateResult"],
	deleteTimetablesEmployeePrivileges: GraphQLTypes["TimetablesEmployeePrivilegesDeleteResult"],
	updateTimetablesEmployeePrivileges: GraphQLTypes["TimetablesEmployeePrivilegesUpdateResult"],
	upsertTimetablesEmployeePrivileges: GraphQLTypes["TimetablesEmployeePrivilegesUpsertResult"],
	createTimetableDayNote: GraphQLTypes["TimetableDayNoteCreateResult"],
	deleteTimetableDayNote: GraphQLTypes["TimetableDayNoteDeleteResult"],
	updateTimetableDayNote: GraphQLTypes["TimetableDayNoteUpdateResult"],
	upsertTimetableDayNote: GraphQLTypes["TimetableDayNoteUpsertResult"],
	createDeliveryMethodLocale: GraphQLTypes["DeliveryMethodLocaleCreateResult"],
	deleteDeliveryMethodLocale: GraphQLTypes["DeliveryMethodLocaleDeleteResult"],
	updateDeliveryMethodLocale: GraphQLTypes["DeliveryMethodLocaleUpdateResult"],
	upsertDeliveryMethodLocale: GraphQLTypes["DeliveryMethodLocaleUpsertResult"],
	createIngredientSupplier: GraphQLTypes["IngredientSupplierCreateResult"],
	deleteIngredientSupplier: GraphQLTypes["IngredientSupplierDeleteResult"],
	updateIngredientSupplier: GraphQLTypes["IngredientSupplierUpdateResult"],
	upsertIngredientSupplier: GraphQLTypes["IngredientSupplierUpsertResult"],
	createIngredientSupplierItem: GraphQLTypes["IngredientSupplierItemCreateResult"],
	deleteIngredientSupplierItem: GraphQLTypes["IngredientSupplierItemDeleteResult"],
	updateIngredientSupplierItem: GraphQLTypes["IngredientSupplierItemUpdateResult"],
	upsertIngredientSupplierItem: GraphQLTypes["IngredientSupplierItemUpsertResult"],
	createIngredientSupplierList: GraphQLTypes["IngredientSupplierListCreateResult"],
	deleteIngredientSupplierList: GraphQLTypes["IngredientSupplierListDeleteResult"],
	updateIngredientSupplierList: GraphQLTypes["IngredientSupplierListUpdateResult"],
	upsertIngredientSupplierList: GraphQLTypes["IngredientSupplierListUpsertResult"],
	createIngredientSupplierLocale: GraphQLTypes["IngredientSupplierLocaleCreateResult"],
	deleteIngredientSupplierLocale: GraphQLTypes["IngredientSupplierLocaleDeleteResult"],
	updateIngredientSupplierLocale: GraphQLTypes["IngredientSupplierLocaleUpdateResult"],
	upsertIngredientSupplierLocale: GraphQLTypes["IngredientSupplierLocaleUpsertResult"],
	createRedirect: GraphQLTypes["RedirectCreateResult"],
	deleteRedirect: GraphQLTypes["RedirectDeleteResult"],
	updateRedirect: GraphQLTypes["RedirectUpdateResult"],
	upsertRedirect: GraphQLTypes["RedirectUpsertResult"],
	createNutritionFacts: GraphQLTypes["NutritionFactsCreateResult"],
	deleteNutritionFacts: GraphQLTypes["NutritionFactsDeleteResult"],
	updateNutritionFacts: GraphQLTypes["NutritionFactsUpdateResult"],
	upsertNutritionFacts: GraphQLTypes["NutritionFactsUpsertResult"],
	createVenue: GraphQLTypes["VenueCreateResult"],
	deleteVenue: GraphQLTypes["VenueDeleteResult"],
	updateVenue: GraphQLTypes["VenueUpdateResult"],
	upsertVenue: GraphQLTypes["VenueUpsertResult"],
	createWorkspace: GraphQLTypes["WorkspaceCreateResult"],
	deleteWorkspace: GraphQLTypes["WorkspaceDeleteResult"],
	updateWorkspace: GraphQLTypes["WorkspaceUpdateResult"],
	upsertWorkspace: GraphQLTypes["WorkspaceUpsertResult"],
	createInternalBuyer: GraphQLTypes["InternalBuyerCreateResult"],
	deleteInternalBuyer: GraphQLTypes["InternalBuyerDeleteResult"],
	updateInternalBuyer: GraphQLTypes["InternalBuyerUpdateResult"],
	upsertInternalBuyer: GraphQLTypes["InternalBuyerUpsertResult"],
	createVenueEmployeeRole: GraphQLTypes["VenueEmployeeRoleCreateResult"],
	deleteVenueEmployeeRole: GraphQLTypes["VenueEmployeeRoleDeleteResult"],
	updateVenueEmployeeRole: GraphQLTypes["VenueEmployeeRoleUpdateResult"],
	upsertVenueEmployeeRole: GraphQLTypes["VenueEmployeeRoleUpsertResult"],
	createIdentificationAttempt: GraphQLTypes["IdentificationAttemptCreateResult"],
	deleteIdentificationAttempt: GraphQLTypes["IdentificationAttemptDeleteResult"],
	updateIdentificationAttempt: GraphQLTypes["IdentificationAttemptUpdateResult"],
	upsertIdentificationAttempt: GraphQLTypes["IdentificationAttemptUpsertResult"],
	createIdentificationCode: GraphQLTypes["IdentificationCodeCreateResult"],
	deleteIdentificationCode: GraphQLTypes["IdentificationCodeDeleteResult"],
	updateIdentificationCode: GraphQLTypes["IdentificationCodeUpdateResult"],
	upsertIdentificationCode: GraphQLTypes["IdentificationCodeUpsertResult"],
	createIdentificationCodeLocale: GraphQLTypes["IdentificationCodeLocaleCreateResult"],
	deleteIdentificationCodeLocale: GraphQLTypes["IdentificationCodeLocaleDeleteResult"],
	updateIdentificationCodeLocale: GraphQLTypes["IdentificationCodeLocaleUpdateResult"],
	upsertIdentificationCodeLocale: GraphQLTypes["IdentificationCodeLocaleUpsertResult"],
	createPipeline: GraphQLTypes["PipelineCreateResult"],
	deletePipeline: GraphQLTypes["PipelineDeleteResult"],
	updatePipeline: GraphQLTypes["PipelineUpdateResult"],
	upsertPipeline: GraphQLTypes["PipelineUpsertResult"],
	createPipelineLead: GraphQLTypes["PipelineLeadCreateResult"],
	deletePipelineLead: GraphQLTypes["PipelineLeadDeleteResult"],
	updatePipelineLead: GraphQLTypes["PipelineLeadUpdateResult"],
	upsertPipelineLead: GraphQLTypes["PipelineLeadUpsertResult"],
	createPipelineStage: GraphQLTypes["PipelineStageCreateResult"],
	deletePipelineStage: GraphQLTypes["PipelineStageDeleteResult"],
	updatePipelineStage: GraphQLTypes["PipelineStageUpdateResult"],
	upsertPipelineStage: GraphQLTypes["PipelineStageUpsertResult"],
	createPipelineStageItem: GraphQLTypes["PipelineStageItemCreateResult"],
	deletePipelineStageItem: GraphQLTypes["PipelineStageItemDeleteResult"],
	updatePipelineStageItem: GraphQLTypes["PipelineStageItemUpdateResult"],
	upsertPipelineStageItem: GraphQLTypes["PipelineStageItemUpsertResult"],
	createPipelineStageLocale: GraphQLTypes["PipelineStageLocaleCreateResult"],
	deletePipelineStageLocale: GraphQLTypes["PipelineStageLocaleDeleteResult"],
	updatePipelineStageLocale: GraphQLTypes["PipelineStageLocaleUpdateResult"],
	upsertPipelineStageLocale: GraphQLTypes["PipelineStageLocaleUpsertResult"],
	createSalesManager: GraphQLTypes["SalesManagerCreateResult"],
	deleteSalesManager: GraphQLTypes["SalesManagerDeleteResult"],
	updateSalesManager: GraphQLTypes["SalesManagerUpdateResult"],
	upsertSalesManager: GraphQLTypes["SalesManagerUpsertResult"],
	createCashierManager: GraphQLTypes["CashierManagerCreateResult"],
	deleteCashierManager: GraphQLTypes["CashierManagerDeleteResult"],
	updateCashierManager: GraphQLTypes["CashierManagerUpdateResult"],
	upsertCashierManager: GraphQLTypes["CashierManagerUpsertResult"],
	createPointOfSaleApplicationDevice: GraphQLTypes["PointOfSaleApplicationDeviceCreateResult"],
	deletePointOfSaleApplicationDevice: GraphQLTypes["PointOfSaleApplicationDeviceDeleteResult"],
	updatePointOfSaleApplicationDevice: GraphQLTypes["PointOfSaleApplicationDeviceUpdateResult"],
	upsertPointOfSaleApplicationDevice: GraphQLTypes["PointOfSaleApplicationDeviceUpsertResult"],
	createPointOfSaleTerminal: GraphQLTypes["PointOfSaleTerminalCreateResult"],
	deletePointOfSaleTerminal: GraphQLTypes["PointOfSaleTerminalDeleteResult"],
	updatePointOfSaleTerminal: GraphQLTypes["PointOfSaleTerminalUpdateResult"],
	upsertPointOfSaleTerminal: GraphQLTypes["PointOfSaleTerminalUpsertResult"],
	createPipelineStageSentiment: GraphQLTypes["PipelineStageSentimentCreateResult"],
	deletePipelineStageSentiment: GraphQLTypes["PipelineStageSentimentDeleteResult"],
	updatePipelineStageSentiment: GraphQLTypes["PipelineStageSentimentUpdateResult"],
	upsertPipelineStageSentiment: GraphQLTypes["PipelineStageSentimentUpsertResult"],
	createDeviceIdentifier: GraphQLTypes["DeviceIdentifierCreateResult"],
	deleteDeviceIdentifier: GraphQLTypes["DeviceIdentifierDeleteResult"],
	updateDeviceIdentifier: GraphQLTypes["DeviceIdentifierUpdateResult"],
	upsertDeviceIdentifier: GraphQLTypes["DeviceIdentifierUpsertResult"],
	createPointOfSalePrinter: GraphQLTypes["PointOfSalePrinterCreateResult"],
	deletePointOfSalePrinter: GraphQLTypes["PointOfSalePrinterDeleteResult"],
	updatePointOfSalePrinter: GraphQLTypes["PointOfSalePrinterUpdateResult"],
	upsertPointOfSalePrinter: GraphQLTypes["PointOfSalePrinterUpsertResult"],
	createGratuity: GraphQLTypes["GratuityCreateResult"],
	deleteGratuity: GraphQLTypes["GratuityDeleteResult"],
	updateGratuity: GraphQLTypes["GratuityUpdateResult"],
	upsertGratuity: GraphQLTypes["GratuityUpsertResult"],
	createFulfillmentNote: GraphQLTypes["FulfillmentNoteCreateResult"],
	deleteFulfillmentNote: GraphQLTypes["FulfillmentNoteDeleteResult"],
	updateFulfillmentNote: GraphQLTypes["FulfillmentNoteUpdateResult"],
	upsertFulfillmentNote: GraphQLTypes["FulfillmentNoteUpsertResult"],
	createLeadForm: GraphQLTypes["LeadFormCreateResult"],
	deleteLeadForm: GraphQLTypes["LeadFormDeleteResult"],
	updateLeadForm: GraphQLTypes["LeadFormUpdateResult"],
	upsertLeadForm: GraphQLTypes["LeadFormUpsertResult"],
	createSubscriptionBox: GraphQLTypes["SubscriptionBoxCreateResult"],
	deleteSubscriptionBox: GraphQLTypes["SubscriptionBoxDeleteResult"],
	updateSubscriptionBox: GraphQLTypes["SubscriptionBoxUpdateResult"],
	upsertSubscriptionBox: GraphQLTypes["SubscriptionBoxUpsertResult"],
	createSubscriptionBoxLocale: GraphQLTypes["SubscriptionBoxLocaleCreateResult"],
	deleteSubscriptionBoxLocale: GraphQLTypes["SubscriptionBoxLocaleDeleteResult"],
	updateSubscriptionBoxLocale: GraphQLTypes["SubscriptionBoxLocaleUpdateResult"],
	upsertSubscriptionBoxLocale: GraphQLTypes["SubscriptionBoxLocaleUpsertResult"],
	createBusinessService: GraphQLTypes["BusinessServiceCreateResult"],
	deleteBusinessService: GraphQLTypes["BusinessServiceDeleteResult"],
	updateBusinessService: GraphQLTypes["BusinessServiceUpdateResult"],
	upsertBusinessService: GraphQLTypes["BusinessServiceUpsertResult"],
	createBusinessServiceEvent: GraphQLTypes["BusinessServiceEventCreateResult"],
	deleteBusinessServiceEvent: GraphQLTypes["BusinessServiceEventDeleteResult"],
	updateBusinessServiceEvent: GraphQLTypes["BusinessServiceEventUpdateResult"],
	upsertBusinessServiceEvent: GraphQLTypes["BusinessServiceEventUpsertResult"],
	createBusinessServiceLocale: GraphQLTypes["BusinessServiceLocaleCreateResult"],
	deleteBusinessServiceLocale: GraphQLTypes["BusinessServiceLocaleDeleteResult"],
	updateBusinessServiceLocale: GraphQLTypes["BusinessServiceLocaleUpdateResult"],
	upsertBusinessServiceLocale: GraphQLTypes["BusinessServiceLocaleUpsertResult"],
	createGridTileItem: GraphQLTypes["GridTileItemCreateResult"],
	deleteGridTileItem: GraphQLTypes["GridTileItemDeleteResult"],
	updateGridTileItem: GraphQLTypes["GridTileItemUpdateResult"],
	upsertGridTileItem: GraphQLTypes["GridTileItemUpsertResult"],
	createGridTiles: GraphQLTypes["GridTilesCreateResult"],
	deleteGridTiles: GraphQLTypes["GridTilesDeleteResult"],
	updateGridTiles: GraphQLTypes["GridTilesUpdateResult"],
	upsertGridTiles: GraphQLTypes["GridTilesUpsertResult"],
	createArea: GraphQLTypes["AreaCreateResult"],
	deleteArea: GraphQLTypes["AreaDeleteResult"],
	updateArea: GraphQLTypes["AreaUpdateResult"],
	upsertArea: GraphQLTypes["AreaUpsertResult"],
	createPosition: GraphQLTypes["PositionCreateResult"],
	deletePosition: GraphQLTypes["PositionDeleteResult"],
	updatePosition: GraphQLTypes["PositionUpdateResult"],
	upsertPosition: GraphQLTypes["PositionUpsertResult"],
	createStatsEnabledWidgetType: GraphQLTypes["StatsEnabledWidgetTypeCreateResult"],
	deleteStatsEnabledWidgetType: GraphQLTypes["StatsEnabledWidgetTypeDeleteResult"],
	updateStatsEnabledWidgetType: GraphQLTypes["StatsEnabledWidgetTypeUpdateResult"],
	upsertStatsEnabledWidgetType: GraphQLTypes["StatsEnabledWidgetTypeUpsertResult"],
	createStatsWidget: GraphQLTypes["StatsWidgetCreateResult"],
	deleteStatsWidget: GraphQLTypes["StatsWidgetDeleteResult"],
	updateStatsWidget: GraphQLTypes["StatsWidgetUpdateResult"],
	upsertStatsWidget: GraphQLTypes["StatsWidgetUpsertResult"],
	createStatsWidgetsLayout: GraphQLTypes["StatsWidgetsLayoutCreateResult"],
	deleteStatsWidgetsLayout: GraphQLTypes["StatsWidgetsLayoutDeleteResult"],
	updateStatsWidgetsLayout: GraphQLTypes["StatsWidgetsLayoutUpdateResult"],
	upsertStatsWidgetsLayout: GraphQLTypes["StatsWidgetsLayoutUpsertResult"],
	createSeat: GraphQLTypes["SeatCreateResult"],
	deleteSeat: GraphQLTypes["SeatDeleteResult"],
	updateSeat: GraphQLTypes["SeatUpdateResult"],
	upsertSeat: GraphQLTypes["SeatUpsertResult"],
	createTable: GraphQLTypes["TableCreateResult"],
	deleteTable: GraphQLTypes["TableDeleteResult"],
	updateTable: GraphQLTypes["TableUpdateResult"],
	upsertTable: GraphQLTypes["TableUpsertResult"],
	createStatsPage: GraphQLTypes["StatsPageCreateResult"],
	deleteStatsPage: GraphQLTypes["StatsPageDeleteResult"],
	updateStatsPage: GraphQLTypes["StatsPageUpdateResult"],
	upsertStatsPage: GraphQLTypes["StatsPageUpsertResult"],
	createUnassignReason: GraphQLTypes["UnassignReasonCreateResult"],
	deleteUnassignReason: GraphQLTypes["UnassignReasonDeleteResult"],
	updateUnassignReason: GraphQLTypes["UnassignReasonUpdateResult"],
	upsertUnassignReason: GraphQLTypes["UnassignReasonUpsertResult"],
	createDoubleshotCoffeeEquipment: GraphQLTypes["DoubleshotCoffeeEquipmentCreateResult"],
	deleteDoubleshotCoffeeEquipment: GraphQLTypes["DoubleshotCoffeeEquipmentDeleteResult"],
	updateDoubleshotCoffeeEquipment: GraphQLTypes["DoubleshotCoffeeEquipmentUpdateResult"],
	upsertDoubleshotCoffeeEquipment: GraphQLTypes["DoubleshotCoffeeEquipmentUpsertResult"],
	createExpense: GraphQLTypes["ExpenseCreateResult"],
	deleteExpense: GraphQLTypes["ExpenseDeleteResult"],
	updateExpense: GraphQLTypes["ExpenseUpdateResult"],
	upsertExpense: GraphQLTypes["ExpenseUpsertResult"],
	createExpenseCategory: GraphQLTypes["ExpenseCategoryCreateResult"],
	deleteExpenseCategory: GraphQLTypes["ExpenseCategoryDeleteResult"],
	updateExpenseCategory: GraphQLTypes["ExpenseCategoryUpdateResult"],
	upsertExpenseCategory: GraphQLTypes["ExpenseCategoryUpsertResult"],
	createExpenseChange: GraphQLTypes["ExpenseChangeCreateResult"],
	deleteExpenseChange: GraphQLTypes["ExpenseChangeDeleteResult"],
	updateExpenseChange: GraphQLTypes["ExpenseChangeUpdateResult"],
	upsertExpenseChange: GraphQLTypes["ExpenseChangeUpsertResult"],
	createExpenseDocument: GraphQLTypes["ExpenseDocumentCreateResult"],
	deleteExpenseDocument: GraphQLTypes["ExpenseDocumentDeleteResult"],
	updateExpenseDocument: GraphQLTypes["ExpenseDocumentUpdateResult"],
	upsertExpenseDocument: GraphQLTypes["ExpenseDocumentUpsertResult"],
	createRevenuePrediction: GraphQLTypes["RevenuePredictionCreateResult"],
	deleteRevenuePrediction: GraphQLTypes["RevenuePredictionDeleteResult"],
	updateRevenuePrediction: GraphQLTypes["RevenuePredictionUpdateResult"],
	upsertRevenuePrediction: GraphQLTypes["RevenuePredictionUpsertResult"],
	createRevenuePredictionChange: GraphQLTypes["RevenuePredictionChangeCreateResult"],
	deleteRevenuePredictionChange: GraphQLTypes["RevenuePredictionChangeDeleteResult"],
	updateRevenuePredictionChange: GraphQLTypes["RevenuePredictionChangeUpdateResult"],
	upsertRevenuePredictionChange: GraphQLTypes["RevenuePredictionChangeUpsertResult"],
	createFile: GraphQLTypes["FileCreateResult"],
	deleteFile: GraphQLTypes["FileDeleteResult"],
	updateFile: GraphQLTypes["FileUpdateResult"],
	upsertFile: GraphQLTypes["FileUpsertResult"],
	createLine: GraphQLTypes["LineCreateResult"],
	deleteLine: GraphQLTypes["LineDeleteResult"],
	updateLine: GraphQLTypes["LineUpdateResult"],
	upsertLine: GraphQLTypes["LineUpsertResult"],
	createFinancesBalanceItem: GraphQLTypes["FinancesBalanceItemCreateResult"],
	deleteFinancesBalanceItem: GraphQLTypes["FinancesBalanceItemDeleteResult"],
	updateFinancesBalanceItem: GraphQLTypes["FinancesBalanceItemUpdateResult"],
	upsertFinancesBalanceItem: GraphQLTypes["FinancesBalanceItemUpsertResult"],
	createWoltDriveDelivery: GraphQLTypes["WoltDriveDeliveryCreateResult"],
	deleteWoltDriveDelivery: GraphQLTypes["WoltDriveDeliveryDeleteResult"],
	updateWoltDriveDelivery: GraphQLTypes["WoltDriveDeliveryUpdateResult"],
	upsertWoltDriveDelivery: GraphQLTypes["WoltDriveDeliveryUpsertResult"],
	query?: GraphQLTypes["Query"] | undefined
};
	["MutationTransactionOptions"]: GraphQLTypes["MutationTransactionOptions"];
	["_Schema"]: {
		enums: Array<GraphQLTypes["_Enum"]>,
	entities: Array<GraphQLTypes["_Entity"]>
};
	["_Entity"]: {
		name: string,
	customPrimaryAllowed: boolean,
	fields: Array<GraphQLTypes["_Field"]>,
	unique: Array<GraphQLTypes["_UniqueConstraint"]>
};
	["_UniqueConstraint"]: {
		fields: Array<string>
};
	["_Field"]: ModelTypes["_Column"] | ModelTypes["_Relation"];
	["_Column"]: {
		name: string,
	type: string,
	enumName?: string | undefined,
	defaultValue?: GraphQLTypes["Json"] | undefined,
	nullable: boolean,
	rules: Array<GraphQLTypes["_Rule"]>,
	validators: Array<GraphQLTypes["_Validator"]>
};
	["_OnDeleteBehaviour"]: GraphQLTypes["_OnDeleteBehaviour"];
	["_RelationSide"]: GraphQLTypes["_RelationSide"];
	["_OrderByDirection"]: GraphQLTypes["_OrderByDirection"];
	["_OrderBy"]: {
		path: Array<string>,
	direction: GraphQLTypes["_OrderByDirection"]
};
	["_Relation"]: {
		name: string,
	type: string,
	side: GraphQLTypes["_RelationSide"],
	targetEntity: string,
	ownedBy?: string | undefined,
	inversedBy?: string | undefined,
	nullable?: boolean | undefined,
	onDelete?: GraphQLTypes["_OnDeleteBehaviour"] | undefined,
	orphanRemoval?: boolean | undefined,
	orderBy?: Array<GraphQLTypes["_OrderBy"]> | undefined,
	rules: Array<GraphQLTypes["_Rule"]>,
	validators: Array<GraphQLTypes["_Validator"]>
};
	["_Rule"]: {
		message?: GraphQLTypes["_RuleMessage"] | undefined,
	validator: number
};
	["_Validator"]: {
		operation: string,
	arguments: Array<GraphQLTypes["_Argument"]>
};
	["_Argument"]:ModelTypes["_ValidatorArgument"] | ModelTypes["_PathArgument"] | ModelTypes["_LiteralArgument"];
	["_ValidatorArgument"]: {
		validator: number
};
	["_PathArgument"]: {
		path: Array<string>
};
	["_LiteralArgument"]: {
		value?: GraphQLTypes["Json"] | undefined
};
	["_RuleMessage"]: {
		text?: string | undefined
};
	["_Enum"]: {
		name: string,
	values: Array<string>
};
	["S3SignedUpload"]: {
		url: string,
	headers: Array<GraphQLTypes["S3Header"]>,
	method: string,
	/** Allowed patterns:
** */
	objectKey: string,
	bucket: string,
	publicUrl: string
};
	["S3Header"]: {
		key: string,
	value: string
};
	["S3SignedRead"]: {
		url: string,
	headers: Array<GraphQLTypes["S3Header"]>,
	method: string,
	/** Allowed patterns:
** */
	objectKey: string,
	bucket: string
}
    }

export type GraphQLTypes = {
    ["Query"]: {
	__typename: "Query",
	getAddress?: GraphQLTypes["Address"] | undefined,
	listAddress: Array<GraphQLTypes["Address"]>,
	paginateAddress: GraphQLTypes["AddressConnection"],
	validateCreateAddress: GraphQLTypes["_ValidationResult"],
	validateUpdateAddress: GraphQLTypes["_ValidationResult"],
	getCountry?: GraphQLTypes["Country"] | undefined,
	listCountry: Array<GraphQLTypes["Country"]>,
	paginateCountry: GraphQLTypes["CountryConnection"],
	validateCreateCountry: GraphQLTypes["_ValidationResult"],
	validateUpdateCountry: GraphQLTypes["_ValidationResult"],
	getChannel?: GraphQLTypes["Channel"] | undefined,
	listChannel: Array<GraphQLTypes["Channel"]>,
	paginateChannel: GraphQLTypes["ChannelConnection"],
	validateCreateChannel: GraphQLTypes["_ValidationResult"],
	validateUpdateChannel: GraphQLTypes["_ValidationResult"],
	getChannelPayment?: GraphQLTypes["ChannelPayment"] | undefined,
	listChannelPayment: Array<GraphQLTypes["ChannelPayment"]>,
	paginateChannelPayment: GraphQLTypes["ChannelPaymentConnection"],
	validateCreateChannelPayment: GraphQLTypes["_ValidationResult"],
	validateUpdateChannelPayment: GraphQLTypes["_ValidationResult"],
	getChannelDelivery?: GraphQLTypes["ChannelDelivery"] | undefined,
	listChannelDelivery: Array<GraphQLTypes["ChannelDelivery"]>,
	paginateChannelDelivery: GraphQLTypes["ChannelDeliveryConnection"],
	validateCreateChannelDelivery: GraphQLTypes["_ValidationResult"],
	validateUpdateChannelDelivery: GraphQLTypes["_ValidationResult"],
	getCustomer?: GraphQLTypes["Customer"] | undefined,
	listCustomer: Array<GraphQLTypes["Customer"]>,
	paginateCustomer: GraphQLTypes["CustomerConnection"],
	validateCreateCustomer: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomer: GraphQLTypes["_ValidationResult"],
	getCustomerCredit?: GraphQLTypes["CustomerCredit"] | undefined,
	listCustomerCredit: Array<GraphQLTypes["CustomerCredit"]>,
	paginateCustomerCredit: GraphQLTypes["CustomerCreditConnection"],
	validateCreateCustomerCredit: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomerCredit: GraphQLTypes["_ValidationResult"],
	getCustomerGroup?: GraphQLTypes["CustomerGroup"] | undefined,
	listCustomerGroup: Array<GraphQLTypes["CustomerGroup"]>,
	paginateCustomerGroup: GraphQLTypes["CustomerGroupConnection"],
	validateCreateCustomerGroup: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomerGroup: GraphQLTypes["_ValidationResult"],
	getCustomerPaymentMethod?: GraphQLTypes["CustomerPaymentMethod"] | undefined,
	listCustomerPaymentMethod: Array<GraphQLTypes["CustomerPaymentMethod"]>,
	paginateCustomerPaymentMethod: GraphQLTypes["CustomerPaymentMethodConnection"],
	validateCreateCustomerPaymentMethod: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomerPaymentMethod: GraphQLTypes["_ValidationResult"],
	getDeliveryMethod?: GraphQLTypes["DeliveryMethod"] | undefined,
	listDeliveryMethod: Array<GraphQLTypes["DeliveryMethod"]>,
	paginateDeliveryMethod: GraphQLTypes["DeliveryMethodConnection"],
	validateCreateDeliveryMethod: GraphQLTypes["_ValidationResult"],
	validateUpdateDeliveryMethod: GraphQLTypes["_ValidationResult"],
	getOrder?: GraphQLTypes["Order"] | undefined,
	listOrder: Array<GraphQLTypes["Order"]>,
	paginateOrder: GraphQLTypes["OrderConnection"],
	validateCreateOrder: GraphQLTypes["_ValidationResult"],
	validateUpdateOrder: GraphQLTypes["_ValidationResult"],
	getOrderDiscount?: GraphQLTypes["OrderDiscount"] | undefined,
	listOrderDiscount: Array<GraphQLTypes["OrderDiscount"]>,
	paginateOrderDiscount: GraphQLTypes["OrderDiscountConnection"],
	validateCreateOrderDiscount: GraphQLTypes["_ValidationResult"],
	validateUpdateOrderDiscount: GraphQLTypes["_ValidationResult"],
	getOrderPayment?: GraphQLTypes["OrderPayment"] | undefined,
	listOrderPayment: Array<GraphQLTypes["OrderPayment"]>,
	paginateOrderPayment: GraphQLTypes["OrderPaymentConnection"],
	validateCreateOrderPayment: GraphQLTypes["_ValidationResult"],
	validateUpdateOrderPayment: GraphQLTypes["_ValidationResult"],
	getOrderDelivery?: GraphQLTypes["OrderDelivery"] | undefined,
	listOrderDelivery: Array<GraphQLTypes["OrderDelivery"]>,
	paginateOrderDelivery: GraphQLTypes["OrderDeliveryConnection"],
	validateCreateOrderDelivery: GraphQLTypes["_ValidationResult"],
	validateUpdateOrderDelivery: GraphQLTypes["_ValidationResult"],
	getOrderItem?: GraphQLTypes["OrderItem"] | undefined,
	listOrderItem: Array<GraphQLTypes["OrderItem"]>,
	paginateOrderItem: GraphQLTypes["OrderItemConnection"],
	validateCreateOrderItem: GraphQLTypes["_ValidationResult"],
	validateUpdateOrderItem: GraphQLTypes["_ValidationResult"],
	getPaymentMethod?: GraphQLTypes["PaymentMethod"] | undefined,
	listPaymentMethod: Array<GraphQLTypes["PaymentMethod"]>,
	paginatePaymentMethod: GraphQLTypes["PaymentMethodConnection"],
	validateCreatePaymentMethod: GraphQLTypes["_ValidationResult"],
	validateUpdatePaymentMethod: GraphQLTypes["_ValidationResult"],
	getVatRate?: GraphQLTypes["VatRate"] | undefined,
	listVatRate: Array<GraphQLTypes["VatRate"]>,
	paginateVatRate: GraphQLTypes["VatRateConnection"],
	validateCreateVatRate: GraphQLTypes["_ValidationResult"],
	validateUpdateVatRate: GraphQLTypes["_ValidationResult"],
	getProduct?: GraphQLTypes["Product"] | undefined,
	listProduct: Array<GraphQLTypes["Product"]>,
	paginateProduct: GraphQLTypes["ProductConnection"],
	validateCreateProduct: GraphQLTypes["_ValidationResult"],
	validateUpdateProduct: GraphQLTypes["_ValidationResult"],
	getProductStock?: GraphQLTypes["ProductStock"] | undefined,
	listProductStock: Array<GraphQLTypes["ProductStock"]>,
	paginateProductStock: GraphQLTypes["ProductStockConnection"],
	validateCreateProductStock: GraphQLTypes["_ValidationResult"],
	validateUpdateProductStock: GraphQLTypes["_ValidationResult"],
	getProductPacking?: GraphQLTypes["ProductPacking"] | undefined,
	listProductPacking: Array<GraphQLTypes["ProductPacking"]>,
	paginateProductPacking: GraphQLTypes["ProductPackingConnection"],
	validateCreateProductPacking: GraphQLTypes["_ValidationResult"],
	validateUpdateProductPacking: GraphQLTypes["_ValidationResult"],
	getProductGroupPrice?: GraphQLTypes["ProductGroupPrice"] | undefined,
	listProductGroupPrice: Array<GraphQLTypes["ProductGroupPrice"]>,
	paginateProductGroupPrice: GraphQLTypes["ProductGroupPriceConnection"],
	validateCreateProductGroupPrice: GraphQLTypes["_ValidationResult"],
	validateUpdateProductGroupPrice: GraphQLTypes["_ValidationResult"],
	getProductRecipe?: GraphQLTypes["ProductRecipe"] | undefined,
	listProductRecipe: Array<GraphQLTypes["ProductRecipe"]>,
	paginateProductRecipe: GraphQLTypes["ProductRecipeConnection"],
	validateCreateProductRecipe: GraphQLTypes["_ValidationResult"],
	validateUpdateProductRecipe: GraphQLTypes["_ValidationResult"],
	getProductCategory?: GraphQLTypes["ProductCategory"] | undefined,
	listProductCategory: Array<GraphQLTypes["ProductCategory"]>,
	paginateProductCategory: GraphQLTypes["ProductCategoryConnection"],
	validateCreateProductCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateProductCategory: GraphQLTypes["_ValidationResult"],
	getStore?: GraphQLTypes["Store"] | undefined,
	listStore: Array<GraphQLTypes["Store"]>,
	paginateStore: GraphQLTypes["StoreConnection"],
	validateCreateStore: GraphQLTypes["_ValidationResult"],
	validateUpdateStore: GraphQLTypes["_ValidationResult"],
	getTag?: GraphQLTypes["Tag"] | undefined,
	listTag: Array<GraphQLTypes["Tag"]>,
	paginateTag: GraphQLTypes["TagConnection"],
	validateCreateTag: GraphQLTypes["_ValidationResult"],
	validateUpdateTag: GraphQLTypes["_ValidationResult"],
	getCustomerPermissions?: GraphQLTypes["CustomerPermissions"] | undefined,
	listCustomerPermissions: Array<GraphQLTypes["CustomerPermissions"]>,
	paginateCustomerPermissions: GraphQLTypes["CustomerPermissionsConnection"],
	getImage?: GraphQLTypes["Image"] | undefined,
	listImage: Array<GraphQLTypes["Image"]>,
	paginateImage: GraphQLTypes["ImageConnection"],
	validateCreateImage: GraphQLTypes["_ValidationResult"],
	validateUpdateImage: GraphQLTypes["_ValidationResult"],
	getBusinessCategory?: GraphQLTypes["BusinessCategory"] | undefined,
	listBusinessCategory: Array<GraphQLTypes["BusinessCategory"]>,
	paginateBusinessCategory: GraphQLTypes["BusinessCategoryConnection"],
	validateCreateBusinessCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateBusinessCategory: GraphQLTypes["_ValidationResult"],
	getProductList?: GraphQLTypes["ProductList"] | undefined,
	listProductList: Array<GraphQLTypes["ProductList"]>,
	paginateProductList: GraphQLTypes["ProductListConnection"],
	validateCreateProductList: GraphQLTypes["_ValidationResult"],
	validateUpdateProductList: GraphQLTypes["_ValidationResult"],
	getProductListItem?: GraphQLTypes["ProductListItem"] | undefined,
	listProductListItem: Array<GraphQLTypes["ProductListItem"]>,
	paginateProductListItem: GraphQLTypes["ProductListItemConnection"],
	validateCreateProductListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateProductListItem: GraphQLTypes["_ValidationResult"],
	getProductCategoryList?: GraphQLTypes["ProductCategoryList"] | undefined,
	listProductCategoryList: Array<GraphQLTypes["ProductCategoryList"]>,
	paginateProductCategoryList: GraphQLTypes["ProductCategoryListConnection"],
	validateCreateProductCategoryList: GraphQLTypes["_ValidationResult"],
	validateUpdateProductCategoryList: GraphQLTypes["_ValidationResult"],
	getProductCategoryListItem?: GraphQLTypes["ProductCategoryListItem"] | undefined,
	listProductCategoryListItem: Array<GraphQLTypes["ProductCategoryListItem"]>,
	paginateProductCategoryListItem: GraphQLTypes["ProductCategoryListItemConnection"],
	validateCreateProductCategoryListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateProductCategoryListItem: GraphQLTypes["_ValidationResult"],
	getBusinessCategoryLocale?: GraphQLTypes["BusinessCategoryLocale"] | undefined,
	listBusinessCategoryLocale: Array<GraphQLTypes["BusinessCategoryLocale"]>,
	paginateBusinessCategoryLocale: GraphQLTypes["BusinessCategoryLocaleConnection"],
	validateCreateBusinessCategoryLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateBusinessCategoryLocale: GraphQLTypes["_ValidationResult"],
	getLocale?: GraphQLTypes["Locale"] | undefined,
	listLocale: Array<GraphQLTypes["Locale"]>,
	paginateLocale: GraphQLTypes["LocaleConnection"],
	validateCreateLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateLocale: GraphQLTypes["_ValidationResult"],
	getProductCategoryListLocale?: GraphQLTypes["ProductCategoryListLocale"] | undefined,
	listProductCategoryListLocale: Array<GraphQLTypes["ProductCategoryListLocale"]>,
	paginateProductCategoryListLocale: GraphQLTypes["ProductCategoryListLocaleConnection"],
	validateCreateProductCategoryListLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateProductCategoryListLocale: GraphQLTypes["_ValidationResult"],
	getCustomerName?: GraphQLTypes["CustomerName"] | undefined,
	listCustomerName: Array<GraphQLTypes["CustomerName"]>,
	paginateCustomerName: GraphQLTypes["CustomerNameConnection"],
	validateCreateCustomerName: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomerName: GraphQLTypes["_ValidationResult"],
	getCustomerAlias?: GraphQLTypes["CustomerAlias"] | undefined,
	listCustomerAlias: Array<GraphQLTypes["CustomerAlias"]>,
	paginateCustomerAlias: GraphQLTypes["CustomerAliasConnection"],
	validateCreateCustomerAlias: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomerAlias: GraphQLTypes["_ValidationResult"],
	getProductIngredientItem?: GraphQLTypes["ProductIngredientItem"] | undefined,
	listProductIngredientItem: Array<GraphQLTypes["ProductIngredientItem"]>,
	paginateProductIngredientItem: GraphQLTypes["ProductIngredientItemConnection"],
	validateCreateProductIngredientItem: GraphQLTypes["_ValidationResult"],
	validateUpdateProductIngredientItem: GraphQLTypes["_ValidationResult"],
	getProductIngredientItemQuantity?: GraphQLTypes["ProductIngredientItemQuantity"] | undefined,
	listProductIngredientItemQuantity: Array<GraphQLTypes["ProductIngredientItemQuantity"]>,
	paginateProductIngredientItemQuantity: GraphQLTypes["ProductIngredientItemQuantityConnection"],
	validateCreateProductIngredientItemQuantity: GraphQLTypes["_ValidationResult"],
	validateUpdateProductIngredientItemQuantity: GraphQLTypes["_ValidationResult"],
	getProductIngredientItemQuantityUnit?: GraphQLTypes["ProductIngredientItemQuantityUnit"] | undefined,
	listProductIngredientItemQuantityUnit: Array<GraphQLTypes["ProductIngredientItemQuantityUnit"]>,
	paginateProductIngredientItemQuantityUnit: GraphQLTypes["ProductIngredientItemQuantityUnitConnection"],
	validateCreateProductIngredientItemQuantityUnit: GraphQLTypes["_ValidationResult"],
	validateUpdateProductIngredientItemQuantityUnit: GraphQLTypes["_ValidationResult"],
	getProductIngredient?: GraphQLTypes["ProductIngredient"] | undefined,
	listProductIngredient: Array<GraphQLTypes["ProductIngredient"]>,
	paginateProductIngredient: GraphQLTypes["ProductIngredientConnection"],
	validateCreateProductIngredient: GraphQLTypes["_ValidationResult"],
	validateUpdateProductIngredient: GraphQLTypes["_ValidationResult"],
	getCustomerIngredientRating?: GraphQLTypes["CustomerIngredientRating"] | undefined,
	listCustomerIngredientRating: Array<GraphQLTypes["CustomerIngredientRating"]>,
	paginateCustomerIngredientRating: GraphQLTypes["CustomerIngredientRatingConnection"],
	validateCreateCustomerIngredientRating: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomerIngredientRating: GraphQLTypes["_ValidationResult"],
	getProductIngredientRating?: GraphQLTypes["ProductIngredientRating"] | undefined,
	listProductIngredientRating: Array<GraphQLTypes["ProductIngredientRating"]>,
	paginateProductIngredientRating: GraphQLTypes["ProductIngredientRatingConnection"],
	validateCreateProductIngredientRating: GraphQLTypes["_ValidationResult"],
	validateUpdateProductIngredientRating: GraphQLTypes["_ValidationResult"],
	getProductIngredientLocale?: GraphQLTypes["ProductIngredientLocale"] | undefined,
	listProductIngredientLocale: Array<GraphQLTypes["ProductIngredientLocale"]>,
	paginateProductIngredientLocale: GraphQLTypes["ProductIngredientLocaleConnection"],
	validateCreateProductIngredientLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateProductIngredientLocale: GraphQLTypes["_ValidationResult"],
	getOrderRecurrence?: GraphQLTypes["OrderRecurrence"] | undefined,
	listOrderRecurrence: Array<GraphQLTypes["OrderRecurrence"]>,
	paginateOrderRecurrence: GraphQLTypes["OrderRecurrenceConnection"],
	validateCreateOrderRecurrence: GraphQLTypes["_ValidationResult"],
	validateUpdateOrderRecurrence: GraphQLTypes["_ValidationResult"],
	getOrderRecurrenceLocale?: GraphQLTypes["OrderRecurrenceLocale"] | undefined,
	listOrderRecurrenceLocale: Array<GraphQLTypes["OrderRecurrenceLocale"]>,
	paginateOrderRecurrenceLocale: GraphQLTypes["OrderRecurrenceLocaleConnection"],
	validateCreateOrderRecurrenceLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateOrderRecurrenceLocale: GraphQLTypes["_ValidationResult"],
	getBusinessCustomer?: GraphQLTypes["BusinessCustomer"] | undefined,
	listBusinessCustomer: Array<GraphQLTypes["BusinessCustomer"]>,
	paginateBusinessCustomer: GraphQLTypes["BusinessCustomerConnection"],
	validateCreateBusinessCustomer: GraphQLTypes["_ValidationResult"],
	validateUpdateBusinessCustomer: GraphQLTypes["_ValidationResult"],
	getPointOfSale?: GraphQLTypes["PointOfSale"] | undefined,
	listPointOfSale: Array<GraphQLTypes["PointOfSale"]>,
	paginatePointOfSale: GraphQLTypes["PointOfSaleConnection"],
	validateCreatePointOfSale: GraphQLTypes["_ValidationResult"],
	validateUpdatePointOfSale: GraphQLTypes["_ValidationResult"],
	getStaff?: GraphQLTypes["Staff"] | undefined,
	listStaff: Array<GraphQLTypes["Staff"]>,
	paginateStaff: GraphQLTypes["StaffConnection"],
	validateCreateStaff: GraphQLTypes["_ValidationResult"],
	validateUpdateStaff: GraphQLTypes["_ValidationResult"],
	getPointOfSalePermissions?: GraphQLTypes["PointOfSalePermissions"] | undefined,
	listPointOfSalePermissions: Array<GraphQLTypes["PointOfSalePermissions"]>,
	paginatePointOfSalePermissions: GraphQLTypes["PointOfSalePermissionsConnection"],
	getBlog?: GraphQLTypes["Blog"] | undefined,
	listBlog: Array<GraphQLTypes["Blog"]>,
	paginateBlog: GraphQLTypes["BlogConnection"],
	validateCreateBlog: GraphQLTypes["_ValidationResult"],
	validateUpdateBlog: GraphQLTypes["_ValidationResult"],
	getBlogLocale?: GraphQLTypes["BlogLocale"] | undefined,
	listBlogLocale: Array<GraphQLTypes["BlogLocale"]>,
	paginateBlogLocale: GraphQLTypes["BlogLocaleConnection"],
	validateCreateBlogLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateBlogLocale: GraphQLTypes["_ValidationResult"],
	getBlogPost?: GraphQLTypes["BlogPost"] | undefined,
	listBlogPost: Array<GraphQLTypes["BlogPost"]>,
	paginateBlogPost: GraphQLTypes["BlogPostConnection"],
	validateCreateBlogPost: GraphQLTypes["_ValidationResult"],
	validateUpdateBlogPost: GraphQLTypes["_ValidationResult"],
	getBlogPostLocale?: GraphQLTypes["BlogPostLocale"] | undefined,
	listBlogPostLocale: Array<GraphQLTypes["BlogPostLocale"]>,
	paginateBlogPostLocale: GraphQLTypes["BlogPostLocaleConnection"],
	validateCreateBlogPostLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateBlogPostLocale: GraphQLTypes["_ValidationResult"],
	getColorPallete?: GraphQLTypes["ColorPallete"] | undefined,
	listColorPallete: Array<GraphQLTypes["ColorPallete"]>,
	paginateColorPallete: GraphQLTypes["ColorPalleteConnection"],
	validateCreateColorPallete: GraphQLTypes["_ValidationResult"],
	validateUpdateColorPallete: GraphQLTypes["_ValidationResult"],
	getContent?: GraphQLTypes["Content"] | undefined,
	listContent: Array<GraphQLTypes["Content"]>,
	paginateContent: GraphQLTypes["ContentConnection"],
	validateCreateContent: GraphQLTypes["_ValidationResult"],
	validateUpdateContent: GraphQLTypes["_ValidationResult"],
	getContentBlock?: GraphQLTypes["ContentBlock"] | undefined,
	listContentBlock: Array<GraphQLTypes["ContentBlock"]>,
	paginateContentBlock: GraphQLTypes["ContentBlockConnection"],
	validateCreateContentBlock: GraphQLTypes["_ValidationResult"],
	validateUpdateContentBlock: GraphQLTypes["_ValidationResult"],
	getContentReference?: GraphQLTypes["ContentReference"] | undefined,
	listContentReference: Array<GraphQLTypes["ContentReference"]>,
	paginateContentReference: GraphQLTypes["ContentReferenceConnection"],
	validateCreateContentReference: GraphQLTypes["_ValidationResult"],
	validateUpdateContentReference: GraphQLTypes["_ValidationResult"],
	getBlogPostList?: GraphQLTypes["BlogPostList"] | undefined,
	listBlogPostList: Array<GraphQLTypes["BlogPostList"]>,
	paginateBlogPostList: GraphQLTypes["BlogPostListConnection"],
	validateCreateBlogPostList: GraphQLTypes["_ValidationResult"],
	validateUpdateBlogPostList: GraphQLTypes["_ValidationResult"],
	getBlogPostListItem?: GraphQLTypes["BlogPostListItem"] | undefined,
	listBlogPostListItem: Array<GraphQLTypes["BlogPostListItem"]>,
	paginateBlogPostListItem: GraphQLTypes["BlogPostListItemConnection"],
	validateCreateBlogPostListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateBlogPostListItem: GraphQLTypes["_ValidationResult"],
	getLinkList?: GraphQLTypes["LinkList"] | undefined,
	listLinkList: Array<GraphQLTypes["LinkList"]>,
	paginateLinkList: GraphQLTypes["LinkListConnection"],
	validateCreateLinkList: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkList: GraphQLTypes["_ValidationResult"],
	getLinkListItem?: GraphQLTypes["LinkListItem"] | undefined,
	listLinkListItem: Array<GraphQLTypes["LinkListItem"]>,
	paginateLinkListItem: GraphQLTypes["LinkListItemConnection"],
	validateCreateLinkListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkListItem: GraphQLTypes["_ValidationResult"],
	getCover?: GraphQLTypes["Cover"] | undefined,
	listCover: Array<GraphQLTypes["Cover"]>,
	paginateCover: GraphQLTypes["CoverConnection"],
	validateCreateCover: GraphQLTypes["_ValidationResult"],
	validateUpdateCover: GraphQLTypes["_ValidationResult"],
	getLink?: GraphQLTypes["Link"] | undefined,
	listLink: Array<GraphQLTypes["Link"]>,
	paginateLink: GraphQLTypes["LinkConnection"],
	validateCreateLink: GraphQLTypes["_ValidationResult"],
	validateUpdateLink: GraphQLTypes["_ValidationResult"],
	getLinkable?: GraphQLTypes["Linkable"] | undefined,
	listLinkable: Array<GraphQLTypes["Linkable"]>,
	paginateLinkable: GraphQLTypes["LinkableConnection"],
	validateCreateLinkable: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkable: GraphQLTypes["_ValidationResult"],
	getMedium?: GraphQLTypes["Medium"] | undefined,
	listMedium: Array<GraphQLTypes["Medium"]>,
	paginateMedium: GraphQLTypes["MediumConnection"],
	validateCreateMedium: GraphQLTypes["_ValidationResult"],
	validateUpdateMedium: GraphQLTypes["_ValidationResult"],
	getVideo?: GraphQLTypes["Video"] | undefined,
	listVideo: Array<GraphQLTypes["Video"]>,
	paginateVideo: GraphQLTypes["VideoConnection"],
	validateCreateVideo: GraphQLTypes["_ValidationResult"],
	validateUpdateVideo: GraphQLTypes["_ValidationResult"],
	getSeo?: GraphQLTypes["Seo"] | undefined,
	listSeo: Array<GraphQLTypes["Seo"]>,
	paginateSeo: GraphQLTypes["SeoConnection"],
	validateCreateSeo: GraphQLTypes["_ValidationResult"],
	validateUpdateSeo: GraphQLTypes["_ValidationResult"],
	getProtectedImage?: GraphQLTypes["ProtectedImage"] | undefined,
	listProtectedImage: Array<GraphQLTypes["ProtectedImage"]>,
	paginateProtectedImage: GraphQLTypes["ProtectedImageConnection"],
	validateCreateProtectedImage: GraphQLTypes["_ValidationResult"],
	validateUpdateProtectedImage: GraphQLTypes["_ValidationResult"],
	getTranslationDomain?: GraphQLTypes["TranslationDomain"] | undefined,
	listTranslationDomain: Array<GraphQLTypes["TranslationDomain"]>,
	paginateTranslationDomain: GraphQLTypes["TranslationDomainConnection"],
	validateCreateTranslationDomain: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationDomain: GraphQLTypes["_ValidationResult"],
	getTranslationCatalogue?: GraphQLTypes["TranslationCatalogue"] | undefined,
	listTranslationCatalogue: Array<GraphQLTypes["TranslationCatalogue"]>,
	paginateTranslationCatalogue: GraphQLTypes["TranslationCatalogueConnection"],
	validateCreateTranslationCatalogue: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationCatalogue: GraphQLTypes["_ValidationResult"],
	getTranslationKey?: GraphQLTypes["TranslationKey"] | undefined,
	listTranslationKey: Array<GraphQLTypes["TranslationKey"]>,
	paginateTranslationKey: GraphQLTypes["TranslationKeyConnection"],
	validateCreateTranslationKey: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationKey: GraphQLTypes["_ValidationResult"],
	getTranslationValue?: GraphQLTypes["TranslationValue"] | undefined,
	listTranslationValue: Array<GraphQLTypes["TranslationValue"]>,
	paginateTranslationValue: GraphQLTypes["TranslationValueConnection"],
	validateCreateTranslationValue: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationValue: GraphQLTypes["_ValidationResult"],
	getTranslationCataloguesIdentifier?: GraphQLTypes["TranslationCataloguesIdentifier"] | undefined,
	listTranslationCataloguesIdentifier: Array<GraphQLTypes["TranslationCataloguesIdentifier"]>,
	paginateTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierConnection"],
	validateCreateTranslationCataloguesIdentifier: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationCataloguesIdentifier: GraphQLTypes["_ValidationResult"],
	getSocialsAndApps?: GraphQLTypes["SocialsAndApps"] | undefined,
	listSocialsAndApps: Array<GraphQLTypes["SocialsAndApps"]>,
	paginateSocialsAndApps: GraphQLTypes["SocialsAndAppsConnection"],
	validateCreateSocialsAndApps: GraphQLTypes["_ValidationResult"],
	validateUpdateSocialsAndApps: GraphQLTypes["_ValidationResult"],
	getProductGrid?: GraphQLTypes["ProductGrid"] | undefined,
	listProductGrid: Array<GraphQLTypes["ProductGrid"]>,
	paginateProductGrid: GraphQLTypes["ProductGridConnection"],
	validateCreateProductGrid: GraphQLTypes["_ValidationResult"],
	validateUpdateProductGrid: GraphQLTypes["_ValidationResult"],
	getProductGridItem?: GraphQLTypes["ProductGridItem"] | undefined,
	listProductGridItem: Array<GraphQLTypes["ProductGridItem"]>,
	paginateProductGridItem: GraphQLTypes["ProductGridItemConnection"],
	validateCreateProductGridItem: GraphQLTypes["_ValidationResult"],
	validateUpdateProductGridItem: GraphQLTypes["_ValidationResult"],
	getGallery?: GraphQLTypes["Gallery"] | undefined,
	listGallery: Array<GraphQLTypes["Gallery"]>,
	paginateGallery: GraphQLTypes["GalleryConnection"],
	validateCreateGallery: GraphQLTypes["_ValidationResult"],
	validateUpdateGallery: GraphQLTypes["_ValidationResult"],
	getGalleryItem?: GraphQLTypes["GalleryItem"] | undefined,
	listGalleryItem: Array<GraphQLTypes["GalleryItem"]>,
	paginateGalleryItem: GraphQLTypes["GalleryItemConnection"],
	validateCreateGalleryItem: GraphQLTypes["_ValidationResult"],
	validateUpdateGalleryItem: GraphQLTypes["_ValidationResult"],
	getHero?: GraphQLTypes["Hero"] | undefined,
	listHero: Array<GraphQLTypes["Hero"]>,
	paginateHero: GraphQLTypes["HeroConnection"],
	validateCreateHero: GraphQLTypes["_ValidationResult"],
	validateUpdateHero: GraphQLTypes["_ValidationResult"],
	getSiteMenu?: GraphQLTypes["SiteMenu"] | undefined,
	listSiteMenu: Array<GraphQLTypes["SiteMenu"]>,
	paginateSiteMenu: GraphQLTypes["SiteMenuConnection"],
	validateCreateSiteMenu: GraphQLTypes["_ValidationResult"],
	validateUpdateSiteMenu: GraphQLTypes["_ValidationResult"],
	getMenuLocale?: GraphQLTypes["MenuLocale"] | undefined,
	listMenuLocale: Array<GraphQLTypes["MenuLocale"]>,
	paginateMenuLocale: GraphQLTypes["MenuLocaleConnection"],
	validateCreateMenuLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateMenuLocale: GraphQLTypes["_ValidationResult"],
	getMenuItem?: GraphQLTypes["MenuItem"] | undefined,
	listMenuItem: Array<GraphQLTypes["MenuItem"]>,
	paginateMenuItem: GraphQLTypes["MenuItemConnection"],
	validateCreateMenuItem: GraphQLTypes["_ValidationResult"],
	validateUpdateMenuItem: GraphQLTypes["_ValidationResult"],
	getPage?: GraphQLTypes["Page"] | undefined,
	listPage: Array<GraphQLTypes["Page"]>,
	paginatePage: GraphQLTypes["PageConnection"],
	validateCreatePage: GraphQLTypes["_ValidationResult"],
	validateUpdatePage: GraphQLTypes["_ValidationResult"],
	getPageLocale?: GraphQLTypes["PageLocale"] | undefined,
	listPageLocale: Array<GraphQLTypes["PageLocale"]>,
	paginatePageLocale: GraphQLTypes["PageLocaleConnection"],
	validateCreatePageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdatePageLocale: GraphQLTypes["_ValidationResult"],
	getWikiPage?: GraphQLTypes["WikiPage"] | undefined,
	listWikiPage: Array<GraphQLTypes["WikiPage"]>,
	paginateWikiPage: GraphQLTypes["WikiPageConnection"],
	validateCreateWikiPage: GraphQLTypes["_ValidationResult"],
	validateUpdateWikiPage: GraphQLTypes["_ValidationResult"],
	getMenuSubitem?: GraphQLTypes["MenuSubitem"] | undefined,
	listMenuSubitem: Array<GraphQLTypes["MenuSubitem"]>,
	paginateMenuSubitem: GraphQLTypes["MenuSubitemConnection"],
	validateCreateMenuSubitem: GraphQLTypes["_ValidationResult"],
	validateUpdateMenuSubitem: GraphQLTypes["_ValidationResult"],
	getMenuLinkList?: GraphQLTypes["MenuLinkList"] | undefined,
	listMenuLinkList: Array<GraphQLTypes["MenuLinkList"]>,
	paginateMenuLinkList: GraphQLTypes["MenuLinkListConnection"],
	validateCreateMenuLinkList: GraphQLTypes["_ValidationResult"],
	validateUpdateMenuLinkList: GraphQLTypes["_ValidationResult"],
	getMenuLinkItem?: GraphQLTypes["MenuLinkItem"] | undefined,
	listMenuLinkItem: Array<GraphQLTypes["MenuLinkItem"]>,
	paginateMenuLinkItem: GraphQLTypes["MenuLinkItemConnection"],
	validateCreateMenuLinkItem: GraphQLTypes["_ValidationResult"],
	validateUpdateMenuLinkItem: GraphQLTypes["_ValidationResult"],
	getMenuProducts?: GraphQLTypes["MenuProducts"] | undefined,
	listMenuProducts: Array<GraphQLTypes["MenuProducts"]>,
	paginateMenuProducts: GraphQLTypes["MenuProductsConnection"],
	validateCreateMenuProducts: GraphQLTypes["_ValidationResult"],
	validateUpdateMenuProducts: GraphQLTypes["_ValidationResult"],
	getMenuDelivery?: GraphQLTypes["MenuDelivery"] | undefined,
	listMenuDelivery: Array<GraphQLTypes["MenuDelivery"]>,
	paginateMenuDelivery: GraphQLTypes["MenuDeliveryConnection"],
	validateCreateMenuDelivery: GraphQLTypes["_ValidationResult"],
	validateUpdateMenuDelivery: GraphQLTypes["_ValidationResult"],
	getMenuContact?: GraphQLTypes["MenuContact"] | undefined,
	listMenuContact: Array<GraphQLTypes["MenuContact"]>,
	paginateMenuContact: GraphQLTypes["MenuContactConnection"],
	validateCreateMenuContact: GraphQLTypes["_ValidationResult"],
	validateUpdateMenuContact: GraphQLTypes["_ValidationResult"],
	getDeadlineTemplate?: GraphQLTypes["DeadlineTemplate"] | undefined,
	listDeadlineTemplate: Array<GraphQLTypes["DeadlineTemplate"]>,
	paginateDeadlineTemplate: GraphQLTypes["DeadlineTemplateConnection"],
	validateCreateDeadlineTemplate: GraphQLTypes["_ValidationResult"],
	validateUpdateDeadlineTemplate: GraphQLTypes["_ValidationResult"],
	getEmployeeQueue?: GraphQLTypes["EmployeeQueue"] | undefined,
	listEmployeeQueue: Array<GraphQLTypes["EmployeeQueue"]>,
	paginateEmployeeQueue: GraphQLTypes["EmployeeQueueConnection"],
	validateCreateEmployeeQueue: GraphQLTypes["_ValidationResult"],
	validateUpdateEmployeeQueue: GraphQLTypes["_ValidationResult"],
	getTimetableDay?: GraphQLTypes["TimetableDay"] | undefined,
	listTimetableDay: Array<GraphQLTypes["TimetableDay"]>,
	paginateTimetableDay: GraphQLTypes["TimetableDayConnection"],
	validateCreateTimetableDay: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetableDay: GraphQLTypes["_ValidationResult"],
	getTimetableEmployeeRole?: GraphQLTypes["TimetableEmployeeRole"] | undefined,
	listTimetableEmployeeRole: Array<GraphQLTypes["TimetableEmployeeRole"]>,
	paginateTimetableEmployeeRole: GraphQLTypes["TimetableEmployeeRoleConnection"],
	validateCreateTimetableEmployeeRole: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetableEmployeeRole: GraphQLTypes["_ValidationResult"],
	getTimetableShift?: GraphQLTypes["TimetableShift"] | undefined,
	listTimetableShift: Array<GraphQLTypes["TimetableShift"]>,
	paginateTimetableShift: GraphQLTypes["TimetableShiftConnection"],
	validateCreateTimetableShift: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetableShift: GraphQLTypes["_ValidationResult"],
	getTimetableShiftGroup?: GraphQLTypes["TimetableShiftGroup"] | undefined,
	listTimetableShiftGroup: Array<GraphQLTypes["TimetableShiftGroup"]>,
	paginateTimetableShiftGroup: GraphQLTypes["TimetableShiftGroupConnection"],
	validateCreateTimetableShiftGroup: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetableShiftGroup: GraphQLTypes["_ValidationResult"],
	getTimetableShiftPosition?: GraphQLTypes["TimetableShiftPosition"] | undefined,
	listTimetableShiftPosition: Array<GraphQLTypes["TimetableShiftPosition"]>,
	paginateTimetableShiftPosition: GraphQLTypes["TimetableShiftPositionConnection"],
	validateCreateTimetableShiftPosition: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetableShiftPosition: GraphQLTypes["_ValidationResult"],
	getTimetableTemplate?: GraphQLTypes["TimetableTemplate"] | undefined,
	listTimetableTemplate: Array<GraphQLTypes["TimetableTemplate"]>,
	paginateTimetableTemplate: GraphQLTypes["TimetableTemplateConnection"],
	validateCreateTimetableTemplate: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetableTemplate: GraphQLTypes["_ValidationResult"],
	getCart?: GraphQLTypes["Cart"] | undefined,
	listCart: Array<GraphQLTypes["Cart"]>,
	paginateCart: GraphQLTypes["CartConnection"],
	validateCreateCart: GraphQLTypes["_ValidationResult"],
	validateUpdateCart: GraphQLTypes["_ValidationResult"],
	getCartItem?: GraphQLTypes["CartItem"] | undefined,
	listCartItem: Array<GraphQLTypes["CartItem"]>,
	paginateCartItem: GraphQLTypes["CartItemConnection"],
	validateCreateCartItem: GraphQLTypes["_ValidationResult"],
	validateUpdateCartItem: GraphQLTypes["_ValidationResult"],
	getEmployeeQueueItem?: GraphQLTypes["EmployeeQueueItem"] | undefined,
	listEmployeeQueueItem: Array<GraphQLTypes["EmployeeQueueItem"]>,
	paginateEmployeeQueueItem: GraphQLTypes["EmployeeQueueItemConnection"],
	validateCreateEmployeeQueueItem: GraphQLTypes["_ValidationResult"],
	validateUpdateEmployeeQueueItem: GraphQLTypes["_ValidationResult"],
	getApplication?: GraphQLTypes["Application"] | undefined,
	listApplication: Array<GraphQLTypes["Application"]>,
	paginateApplication: GraphQLTypes["ApplicationConnection"],
	validateCreateApplication: GraphQLTypes["_ValidationResult"],
	validateUpdateApplication: GraphQLTypes["_ValidationResult"],
	getApplicationShortcutList?: GraphQLTypes["ApplicationShortcutList"] | undefined,
	listApplicationShortcutList: Array<GraphQLTypes["ApplicationShortcutList"]>,
	paginateApplicationShortcutList: GraphQLTypes["ApplicationShortcutListConnection"],
	validateCreateApplicationShortcutList: GraphQLTypes["_ValidationResult"],
	validateUpdateApplicationShortcutList: GraphQLTypes["_ValidationResult"],
	getApplicationShortcutListItem?: GraphQLTypes["ApplicationShortcutListItem"] | undefined,
	listApplicationShortcutListItem: Array<GraphQLTypes["ApplicationShortcutListItem"]>,
	paginateApplicationShortcutListItem: GraphQLTypes["ApplicationShortcutListItemConnection"],
	validateCreateApplicationShortcutListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateApplicationShortcutListItem: GraphQLTypes["_ValidationResult"],
	getProductBanner?: GraphQLTypes["ProductBanner"] | undefined,
	listProductBanner: Array<GraphQLTypes["ProductBanner"]>,
	paginateProductBanner: GraphQLTypes["ProductBannerConnection"],
	validateCreateProductBanner: GraphQLTypes["_ValidationResult"],
	validateUpdateProductBanner: GraphQLTypes["_ValidationResult"],
	getProductBannerItem?: GraphQLTypes["ProductBannerItem"] | undefined,
	listProductBannerItem: Array<GraphQLTypes["ProductBannerItem"]>,
	paginateProductBannerItem: GraphQLTypes["ProductBannerItemConnection"],
	validateCreateProductBannerItem: GraphQLTypes["_ValidationResult"],
	validateUpdateProductBannerItem: GraphQLTypes["_ValidationResult"],
	getProductBannerList?: GraphQLTypes["ProductBannerList"] | undefined,
	listProductBannerList: Array<GraphQLTypes["ProductBannerList"]>,
	paginateProductBannerList: GraphQLTypes["ProductBannerListConnection"],
	validateCreateProductBannerList: GraphQLTypes["_ValidationResult"],
	validateUpdateProductBannerList: GraphQLTypes["_ValidationResult"],
	getBartender?: GraphQLTypes["Bartender"] | undefined,
	listBartender: Array<GraphQLTypes["Bartender"]>,
	paginateBartender: GraphQLTypes["BartenderConnection"],
	validateCreateBartender: GraphQLTypes["_ValidationResult"],
	validateUpdateBartender: GraphQLTypes["_ValidationResult"],
	getBusinessToBusinessManager?: GraphQLTypes["BusinessToBusinessManager"] | undefined,
	listBusinessToBusinessManager: Array<GraphQLTypes["BusinessToBusinessManager"]>,
	paginateBusinessToBusinessManager: GraphQLTypes["BusinessToBusinessManagerConnection"],
	validateCreateBusinessToBusinessManager: GraphQLTypes["_ValidationResult"],
	validateUpdateBusinessToBusinessManager: GraphQLTypes["_ValidationResult"],
	getCleaner?: GraphQLTypes["Cleaner"] | undefined,
	listCleaner: Array<GraphQLTypes["Cleaner"]>,
	paginateCleaner: GraphQLTypes["CleanerConnection"],
	validateCreateCleaner: GraphQLTypes["_ValidationResult"],
	validateUpdateCleaner: GraphQLTypes["_ValidationResult"],
	getCourier?: GraphQLTypes["Courier"] | undefined,
	listCourier: Array<GraphQLTypes["Courier"]>,
	paginateCourier: GraphQLTypes["CourierConnection"],
	validateCreateCourier: GraphQLTypes["_ValidationResult"],
	validateUpdateCourier: GraphQLTypes["_ValidationResult"],
	getShiftsManager?: GraphQLTypes["ShiftsManager"] | undefined,
	listShiftsManager: Array<GraphQLTypes["ShiftsManager"]>,
	paginateShiftsManager: GraphQLTypes["ShiftsManagerConnection"],
	validateCreateShiftsManager: GraphQLTypes["_ValidationResult"],
	validateUpdateShiftsManager: GraphQLTypes["_ValidationResult"],
	getUser?: GraphQLTypes["User"] | undefined,
	listUser: Array<GraphQLTypes["User"]>,
	paginateUser: GraphQLTypes["UserConnection"],
	validateCreateUser: GraphQLTypes["_ValidationResult"],
	validateUpdateUser: GraphQLTypes["_ValidationResult"],
	getShiftsProfile?: GraphQLTypes["ShiftsProfile"] | undefined,
	listShiftsProfile: Array<GraphQLTypes["ShiftsProfile"]>,
	paginateShiftsProfile: GraphQLTypes["ShiftsProfileConnection"],
	validateCreateShiftsProfile: GraphQLTypes["_ValidationResult"],
	validateUpdateShiftsProfile: GraphQLTypes["_ValidationResult"],
	getProductIngredientCategory?: GraphQLTypes["ProductIngredientCategory"] | undefined,
	listProductIngredientCategory: Array<GraphQLTypes["ProductIngredientCategory"]>,
	paginateProductIngredientCategory: GraphQLTypes["ProductIngredientCategoryConnection"],
	validateCreateProductIngredientCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateProductIngredientCategory: GraphQLTypes["_ValidationResult"],
	getProductIngredientCategoryLocale?: GraphQLTypes["ProductIngredientCategoryLocale"] | undefined,
	listProductIngredientCategoryLocale: Array<GraphQLTypes["ProductIngredientCategoryLocale"]>,
	paginateProductIngredientCategoryLocale: GraphQLTypes["ProductIngredientCategoryLocaleConnection"],
	validateCreateProductIngredientCategoryLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateProductIngredientCategoryLocale: GraphQLTypes["_ValidationResult"],
	getStocksManager?: GraphQLTypes["StocksManager"] | undefined,
	listStocksManager: Array<GraphQLTypes["StocksManager"]>,
	paginateStocksManager: GraphQLTypes["StocksManagerConnection"],
	validateCreateStocksManager: GraphQLTypes["_ValidationResult"],
	validateUpdateStocksManager: GraphQLTypes["_ValidationResult"],
	getDeliveryRoute?: GraphQLTypes["DeliveryRoute"] | undefined,
	listDeliveryRoute: Array<GraphQLTypes["DeliveryRoute"]>,
	paginateDeliveryRoute: GraphQLTypes["DeliveryRouteConnection"],
	validateCreateDeliveryRoute: GraphQLTypes["_ValidationResult"],
	validateUpdateDeliveryRoute: GraphQLTypes["_ValidationResult"],
	getDeliveryWaypoint?: GraphQLTypes["DeliveryWaypoint"] | undefined,
	listDeliveryWaypoint: Array<GraphQLTypes["DeliveryWaypoint"]>,
	paginateDeliveryWaypoint: GraphQLTypes["DeliveryWaypointConnection"],
	validateCreateDeliveryWaypoint: GraphQLTypes["_ValidationResult"],
	validateUpdateDeliveryWaypoint: GraphQLTypes["_ValidationResult"],
	getAllergen?: GraphQLTypes["Allergen"] | undefined,
	listAllergen: Array<GraphQLTypes["Allergen"]>,
	paginateAllergen: GraphQLTypes["AllergenConnection"],
	validateCreateAllergen: GraphQLTypes["_ValidationResult"],
	validateUpdateAllergen: GraphQLTypes["_ValidationResult"],
	getAllergenLocale?: GraphQLTypes["AllergenLocale"] | undefined,
	listAllergenLocale: Array<GraphQLTypes["AllergenLocale"]>,
	paginateAllergenLocale: GraphQLTypes["AllergenLocaleConnection"],
	validateCreateAllergenLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateAllergenLocale: GraphQLTypes["_ValidationResult"],
	getGps?: GraphQLTypes["Gps"] | undefined,
	listGps: Array<GraphQLTypes["Gps"]>,
	paginateGps: GraphQLTypes["GpsConnection"],
	validateCreateGps: GraphQLTypes["_ValidationResult"],
	validateUpdateGps: GraphQLTypes["_ValidationResult"],
	getProductCategoryTree?: GraphQLTypes["ProductCategoryTree"] | undefined,
	listProductCategoryTree: Array<GraphQLTypes["ProductCategoryTree"]>,
	paginateProductCategoryTree: GraphQLTypes["ProductCategoryTreeConnection"],
	getInheritedProductCategoryTag?: GraphQLTypes["InheritedProductCategoryTag"] | undefined,
	listInheritedProductCategoryTag: Array<GraphQLTypes["InheritedProductCategoryTag"]>,
	paginateInheritedProductCategoryTag: GraphQLTypes["InheritedProductCategoryTagConnection"],
	getNestedProductCategoryProduct?: GraphQLTypes["NestedProductCategoryProduct"] | undefined,
	listNestedProductCategoryProduct: Array<GraphQLTypes["NestedProductCategoryProduct"]>,
	paginateNestedProductCategoryProduct: GraphQLTypes["NestedProductCategoryProductConnection"],
	getWeekHours?: GraphQLTypes["WeekHours"] | undefined,
	listWeekHours: Array<GraphQLTypes["WeekHours"]>,
	paginateWeekHours: GraphQLTypes["WeekHoursConnection"],
	validateCreateWeekHours: GraphQLTypes["_ValidationResult"],
	validateUpdateWeekHours: GraphQLTypes["_ValidationResult"],
	getPreparedIngredientQuantity?: GraphQLTypes["PreparedIngredientQuantity"] | undefined,
	listPreparedIngredientQuantity: Array<GraphQLTypes["PreparedIngredientQuantity"]>,
	paginatePreparedIngredientQuantity: GraphQLTypes["PreparedIngredientQuantityConnection"],
	validateCreatePreparedIngredientQuantity: GraphQLTypes["_ValidationResult"],
	validateUpdatePreparedIngredientQuantity: GraphQLTypes["_ValidationResult"],
	getPreparedRecipeQuantity?: GraphQLTypes["PreparedRecipeQuantity"] | undefined,
	listPreparedRecipeQuantity: Array<GraphQLTypes["PreparedRecipeQuantity"]>,
	paginatePreparedRecipeQuantity: GraphQLTypes["PreparedRecipeQuantityConnection"],
	validateCreatePreparedRecipeQuantity: GraphQLTypes["_ValidationResult"],
	validateUpdatePreparedRecipeQuantity: GraphQLTypes["_ValidationResult"],
	getInternalOrder?: GraphQLTypes["InternalOrder"] | undefined,
	listInternalOrder: Array<GraphQLTypes["InternalOrder"]>,
	paginateInternalOrder: GraphQLTypes["InternalOrderConnection"],
	validateCreateInternalOrder: GraphQLTypes["_ValidationResult"],
	validateUpdateInternalOrder: GraphQLTypes["_ValidationResult"],
	getInternalOrderItem?: GraphQLTypes["InternalOrderItem"] | undefined,
	listInternalOrderItem: Array<GraphQLTypes["InternalOrderItem"]>,
	paginateInternalOrderItem: GraphQLTypes["InternalOrderItemConnection"],
	validateCreateInternalOrderItem: GraphQLTypes["_ValidationResult"],
	validateUpdateInternalOrderItem: GraphQLTypes["_ValidationResult"],
	getPreparedPackingQuantity?: GraphQLTypes["PreparedPackingQuantity"] | undefined,
	listPreparedPackingQuantity: Array<GraphQLTypes["PreparedPackingQuantity"]>,
	paginatePreparedPackingQuantity: GraphQLTypes["PreparedPackingQuantityConnection"],
	validateCreatePreparedPackingQuantity: GraphQLTypes["_ValidationResult"],
	validateUpdatePreparedPackingQuantity: GraphQLTypes["_ValidationResult"],
	getCourierManager?: GraphQLTypes["CourierManager"] | undefined,
	listCourierManager: Array<GraphQLTypes["CourierManager"]>,
	paginateCourierManager: GraphQLTypes["CourierManagerConnection"],
	validateCreateCourierManager: GraphQLTypes["_ValidationResult"],
	validateUpdateCourierManager: GraphQLTypes["_ValidationResult"],
	getDeliveryZone?: GraphQLTypes["DeliveryZone"] | undefined,
	listDeliveryZone: Array<GraphQLTypes["DeliveryZone"]>,
	paginateDeliveryZone: GraphQLTypes["DeliveryZoneConnection"],
	validateCreateDeliveryZone: GraphQLTypes["_ValidationResult"],
	validateUpdateDeliveryZone: GraphQLTypes["_ValidationResult"],
	getAddressMetadata?: GraphQLTypes["AddressMetadata"] | undefined,
	listAddressMetadata: Array<GraphQLTypes["AddressMetadata"]>,
	paginateAddressMetadata: GraphQLTypes["AddressMetadataConnection"],
	getDeliveryTimelinePreset?: GraphQLTypes["DeliveryTimelinePreset"] | undefined,
	listDeliveryTimelinePreset: Array<GraphQLTypes["DeliveryTimelinePreset"]>,
	paginateDeliveryTimelinePreset: GraphQLTypes["DeliveryTimelinePresetConnection"],
	validateCreateDeliveryTimelinePreset: GraphQLTypes["_ValidationResult"],
	validateUpdateDeliveryTimelinePreset: GraphQLTypes["_ValidationResult"],
	getOrderDeliveryTimeline?: GraphQLTypes["OrderDeliveryTimeline"] | undefined,
	listOrderDeliveryTimeline: Array<GraphQLTypes["OrderDeliveryTimeline"]>,
	paginateOrderDeliveryTimeline: GraphQLTypes["OrderDeliveryTimelineConnection"],
	validateCreateOrderDeliveryTimeline: GraphQLTypes["_ValidationResult"],
	validateUpdateOrderDeliveryTimeline: GraphQLTypes["_ValidationResult"],
	getOrderEvent?: GraphQLTypes["OrderEvent"] | undefined,
	listOrderEvent: Array<GraphQLTypes["OrderEvent"]>,
	paginateOrderEvent: GraphQLTypes["OrderEventConnection"],
	validateCreateOrderEvent: GraphQLTypes["_ValidationResult"],
	validateUpdateOrderEvent: GraphQLTypes["_ValidationResult"],
	getLiftagoRide?: GraphQLTypes["LiftagoRide"] | undefined,
	listLiftagoRide: Array<GraphQLTypes["LiftagoRide"]>,
	paginateLiftagoRide: GraphQLTypes["LiftagoRideConnection"],
	validateCreateLiftagoRide: GraphQLTypes["_ValidationResult"],
	validateUpdateLiftagoRide: GraphQLTypes["_ValidationResult"],
	getInvoice?: GraphQLTypes["Invoice"] | undefined,
	listInvoice: Array<GraphQLTypes["Invoice"]>,
	paginateInvoice: GraphQLTypes["InvoiceConnection"],
	validateCreateInvoice: GraphQLTypes["_ValidationResult"],
	validateUpdateInvoice: GraphQLTypes["_ValidationResult"],
	getInvoicingPlan?: GraphQLTypes["InvoicingPlan"] | undefined,
	listInvoicingPlan: Array<GraphQLTypes["InvoicingPlan"]>,
	paginateInvoicingPlan: GraphQLTypes["InvoicingPlanConnection"],
	validateCreateInvoicingPlan: GraphQLTypes["_ValidationResult"],
	validateUpdateInvoicingPlan: GraphQLTypes["_ValidationResult"],
	getProductPackingLocale?: GraphQLTypes["ProductPackingLocale"] | undefined,
	listProductPackingLocale: Array<GraphQLTypes["ProductPackingLocale"]>,
	paginateProductPackingLocale: GraphQLTypes["ProductPackingLocaleConnection"],
	validateCreateProductPackingLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateProductPackingLocale: GraphQLTypes["_ValidationResult"],
	getProductLocale?: GraphQLTypes["ProductLocale"] | undefined,
	listProductLocale: Array<GraphQLTypes["ProductLocale"]>,
	paginateProductLocale: GraphQLTypes["ProductLocaleConnection"],
	validateCreateProductLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateProductLocale: GraphQLTypes["_ValidationResult"],
	getProductRecipeLocale?: GraphQLTypes["ProductRecipeLocale"] | undefined,
	listProductRecipeLocale: Array<GraphQLTypes["ProductRecipeLocale"]>,
	paginateProductRecipeLocale: GraphQLTypes["ProductRecipeLocaleConnection"],
	validateCreateProductRecipeLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateProductRecipeLocale: GraphQLTypes["_ValidationResult"],
	getUserDevice?: GraphQLTypes["UserDevice"] | undefined,
	listUserDevice: Array<GraphQLTypes["UserDevice"]>,
	paginateUserDevice: GraphQLTypes["UserDeviceConnection"],
	validateCreateUserDevice: GraphQLTypes["_ValidationResult"],
	validateUpdateUserDevice: GraphQLTypes["_ValidationResult"],
	getProtectedAction?: GraphQLTypes["ProtectedAction"] | undefined,
	listProtectedAction: Array<GraphQLTypes["ProtectedAction"]>,
	paginateProtectedAction: GraphQLTypes["ProtectedActionConnection"],
	validateCreateProtectedAction: GraphQLTypes["_ValidationResult"],
	validateUpdateProtectedAction: GraphQLTypes["_ValidationResult"],
	getPicker?: GraphQLTypes["Picker"] | undefined,
	listPicker: Array<GraphQLTypes["Picker"]>,
	paginatePicker: GraphQLTypes["PickerConnection"],
	validateCreatePicker: GraphQLTypes["_ValidationResult"],
	validateUpdatePicker: GraphQLTypes["_ValidationResult"],
	getTenantPerson?: GraphQLTypes["TenantPerson"] | undefined,
	listTenantPerson: Array<GraphQLTypes["TenantPerson"]>,
	paginateTenantPerson: GraphQLTypes["TenantPersonConnection"],
	getTimetableTemplateStaffOptions?: GraphQLTypes["TimetableTemplateStaffOptions"] | undefined,
	listTimetableTemplateStaffOptions: Array<GraphQLTypes["TimetableTemplateStaffOptions"]>,
	paginateTimetableTemplateStaffOptions: GraphQLTypes["TimetableTemplateStaffOptionsConnection"],
	validateCreateTimetableTemplateStaffOptions: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetableTemplateStaffOptions: GraphQLTypes["_ValidationResult"],
	getShoppingList?: GraphQLTypes["ShoppingList"] | undefined,
	listShoppingList: Array<GraphQLTypes["ShoppingList"]>,
	paginateShoppingList: GraphQLTypes["ShoppingListConnection"],
	validateCreateShoppingList: GraphQLTypes["_ValidationResult"],
	validateUpdateShoppingList: GraphQLTypes["_ValidationResult"],
	getSuppliesPurchase?: GraphQLTypes["SuppliesPurchase"] | undefined,
	listSuppliesPurchase: Array<GraphQLTypes["SuppliesPurchase"]>,
	paginateSuppliesPurchase: GraphQLTypes["SuppliesPurchaseConnection"],
	validateCreateSuppliesPurchase: GraphQLTypes["_ValidationResult"],
	validateUpdateSuppliesPurchase: GraphQLTypes["_ValidationResult"],
	getInvoicingPreset?: GraphQLTypes["InvoicingPreset"] | undefined,
	listInvoicingPreset: Array<GraphQLTypes["InvoicingPreset"]>,
	paginateInvoicingPreset: GraphQLTypes["InvoicingPresetConnection"],
	validateCreateInvoicingPreset: GraphQLTypes["_ValidationResult"],
	validateUpdateInvoicingPreset: GraphQLTypes["_ValidationResult"],
	getLogRecord?: GraphQLTypes["LogRecord"] | undefined,
	listLogRecord: Array<GraphQLTypes["LogRecord"]>,
	paginateLogRecord: GraphQLTypes["LogRecordConnection"],
	validateCreateLogRecord: GraphQLTypes["_ValidationResult"],
	validateUpdateLogRecord: GraphQLTypes["_ValidationResult"],
	getBillingSubject?: GraphQLTypes["BillingSubject"] | undefined,
	listBillingSubject: Array<GraphQLTypes["BillingSubject"]>,
	paginateBillingSubject: GraphQLTypes["BillingSubjectConnection"],
	validateCreateBillingSubject: GraphQLTypes["_ValidationResult"],
	validateUpdateBillingSubject: GraphQLTypes["_ValidationResult"],
	getProductCustomerPrice?: GraphQLTypes["ProductCustomerPrice"] | undefined,
	listProductCustomerPrice: Array<GraphQLTypes["ProductCustomerPrice"]>,
	paginateProductCustomerPrice: GraphQLTypes["ProductCustomerPriceConnection"],
	getCartPriceLine?: GraphQLTypes["CartPriceLine"] | undefined,
	listCartPriceLine: Array<GraphQLTypes["CartPriceLine"]>,
	paginateCartPriceLine: GraphQLTypes["CartPriceLineConnection"],
	getShoppingListItem?: GraphQLTypes["ShoppingListItem"] | undefined,
	listShoppingListItem: Array<GraphQLTypes["ShoppingListItem"]>,
	paginateShoppingListItem: GraphQLTypes["ShoppingListItemConnection"],
	validateCreateShoppingListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateShoppingListItem: GraphQLTypes["_ValidationResult"],
	getSuppliesPurchaseItem?: GraphQLTypes["SuppliesPurchaseItem"] | undefined,
	listSuppliesPurchaseItem: Array<GraphQLTypes["SuppliesPurchaseItem"]>,
	paginateSuppliesPurchaseItem: GraphQLTypes["SuppliesPurchaseItemConnection"],
	validateCreateSuppliesPurchaseItem: GraphQLTypes["_ValidationResult"],
	validateUpdateSuppliesPurchaseItem: GraphQLTypes["_ValidationResult"],
	getCustomerCreditTransaction?: GraphQLTypes["CustomerCreditTransaction"] | undefined,
	listCustomerCreditTransaction: Array<GraphQLTypes["CustomerCreditTransaction"]>,
	paginateCustomerCreditTransaction: GraphQLTypes["CustomerCreditTransactionConnection"],
	validateCreateCustomerCreditTransaction: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomerCreditTransaction: GraphQLTypes["_ValidationResult"],
	getVirtualProduct?: GraphQLTypes["VirtualProduct"] | undefined,
	listVirtualProduct: Array<GraphQLTypes["VirtualProduct"]>,
	paginateVirtualProduct: GraphQLTypes["VirtualProductConnection"],
	validateCreateVirtualProduct: GraphQLTypes["_ValidationResult"],
	validateUpdateVirtualProduct: GraphQLTypes["_ValidationResult"],
	getVirtualProductEffect?: GraphQLTypes["VirtualProductEffect"] | undefined,
	listVirtualProductEffect: Array<GraphQLTypes["VirtualProductEffect"]>,
	paginateVirtualProductEffect: GraphQLTypes["VirtualProductEffectConnection"],
	validateCreateVirtualProductEffect: GraphQLTypes["_ValidationResult"],
	validateUpdateVirtualProductEffect: GraphQLTypes["_ValidationResult"],
	getOrderPriceLine?: GraphQLTypes["OrderPriceLine"] | undefined,
	listOrderPriceLine: Array<GraphQLTypes["OrderPriceLine"]>,
	paginateOrderPriceLine: GraphQLTypes["OrderPriceLineConnection"],
	getProductMetadata?: GraphQLTypes["ProductMetadata"] | undefined,
	listProductMetadata: Array<GraphQLTypes["ProductMetadata"]>,
	paginateProductMetadata: GraphQLTypes["ProductMetadataConnection"],
	getEmploymentInformation?: GraphQLTypes["EmploymentInformation"] | undefined,
	listEmploymentInformation: Array<GraphQLTypes["EmploymentInformation"]>,
	paginateEmploymentInformation: GraphQLTypes["EmploymentInformationConnection"],
	validateCreateEmploymentInformation: GraphQLTypes["_ValidationResult"],
	validateUpdateEmploymentInformation: GraphQLTypes["_ValidationResult"],
	getRemunerationProfile?: GraphQLTypes["RemunerationProfile"] | undefined,
	listRemunerationProfile: Array<GraphQLTypes["RemunerationProfile"]>,
	paginateRemunerationProfile: GraphQLTypes["RemunerationProfileConnection"],
	validateCreateRemunerationProfile: GraphQLTypes["_ValidationResult"],
	validateUpdateRemunerationProfile: GraphQLTypes["_ValidationResult"],
	getWorkMonth?: GraphQLTypes["WorkMonth"] | undefined,
	listWorkMonth: Array<GraphQLTypes["WorkMonth"]>,
	paginateWorkMonth: GraphQLTypes["WorkMonthConnection"],
	validateCreateWorkMonth: GraphQLTypes["_ValidationResult"],
	validateUpdateWorkMonth: GraphQLTypes["_ValidationResult"],
	getSalaryOptions?: GraphQLTypes["SalaryOptions"] | undefined,
	listSalaryOptions: Array<GraphQLTypes["SalaryOptions"]>,
	paginateSalaryOptions: GraphQLTypes["SalaryOptionsConnection"],
	validateCreateSalaryOptions: GraphQLTypes["_ValidationResult"],
	validateUpdateSalaryOptions: GraphQLTypes["_ValidationResult"],
	getTimetableShiftSwapInfo?: GraphQLTypes["TimetableShiftSwapInfo"] | undefined,
	listTimetableShiftSwapInfo: Array<GraphQLTypes["TimetableShiftSwapInfo"]>,
	paginateTimetableShiftSwapInfo: GraphQLTypes["TimetableShiftSwapInfoConnection"],
	validateCreateTimetableShiftSwapInfo: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetableShiftSwapInfo: GraphQLTypes["_ValidationResult"],
	getProductGridCategory?: GraphQLTypes["ProductGridCategory"] | undefined,
	listProductGridCategory: Array<GraphQLTypes["ProductGridCategory"]>,
	paginateProductGridCategory: GraphQLTypes["ProductGridCategoryConnection"],
	validateCreateProductGridCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateProductGridCategory: GraphQLTypes["_ValidationResult"],
	getCashier?: GraphQLTypes["Cashier"] | undefined,
	listCashier: Array<GraphQLTypes["Cashier"]>,
	paginateCashier: GraphQLTypes["CashierConnection"],
	validateCreateCashier: GraphQLTypes["_ValidationResult"],
	validateUpdateCashier: GraphQLTypes["_ValidationResult"],
	getPointOfSaleCategory?: GraphQLTypes["PointOfSaleCategory"] | undefined,
	listPointOfSaleCategory: Array<GraphQLTypes["PointOfSaleCategory"]>,
	paginatePointOfSaleCategory: GraphQLTypes["PointOfSaleCategoryConnection"],
	validateCreatePointOfSaleCategory: GraphQLTypes["_ValidationResult"],
	validateUpdatePointOfSaleCategory: GraphQLTypes["_ValidationResult"],
	getPointOfSaleCategoryLocale?: GraphQLTypes["PointOfSaleCategoryLocale"] | undefined,
	listPointOfSaleCategoryLocale: Array<GraphQLTypes["PointOfSaleCategoryLocale"]>,
	paginatePointOfSaleCategoryLocale: GraphQLTypes["PointOfSaleCategoryLocaleConnection"],
	validateCreatePointOfSaleCategoryLocale: GraphQLTypes["_ValidationResult"],
	validateUpdatePointOfSaleCategoryLocale: GraphQLTypes["_ValidationResult"],
	getPointOfSaleCategoryProduct?: GraphQLTypes["PointOfSaleCategoryProduct"] | undefined,
	listPointOfSaleCategoryProduct: Array<GraphQLTypes["PointOfSaleCategoryProduct"]>,
	paginatePointOfSaleCategoryProduct: GraphQLTypes["PointOfSaleCategoryProductConnection"],
	validateCreatePointOfSaleCategoryProduct: GraphQLTypes["_ValidationResult"],
	validateUpdatePointOfSaleCategoryProduct: GraphQLTypes["_ValidationResult"],
	getPointOfSaleCategoryProductLocale?: GraphQLTypes["PointOfSaleCategoryProductLocale"] | undefined,
	listPointOfSaleCategoryProductLocale: Array<GraphQLTypes["PointOfSaleCategoryProductLocale"]>,
	paginatePointOfSaleCategoryProductLocale: GraphQLTypes["PointOfSaleCategoryProductLocaleConnection"],
	validateCreatePointOfSaleCategoryProductLocale: GraphQLTypes["_ValidationResult"],
	validateUpdatePointOfSaleCategoryProductLocale: GraphQLTypes["_ValidationResult"],
	getCustomerTab?: GraphQLTypes["CustomerTab"] | undefined,
	listCustomerTab: Array<GraphQLTypes["CustomerTab"]>,
	paginateCustomerTab: GraphQLTypes["CustomerTabConnection"],
	validateCreateCustomerTab: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomerTab: GraphQLTypes["_ValidationResult"],
	getCustomerTabItem?: GraphQLTypes["CustomerTabItem"] | undefined,
	listCustomerTabItem: Array<GraphQLTypes["CustomerTabItem"]>,
	paginateCustomerTabItem: GraphQLTypes["CustomerTabItemConnection"],
	validateCreateCustomerTabItem: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomerTabItem: GraphQLTypes["_ValidationResult"],
	getAnonymousSession?: GraphQLTypes["AnonymousSession"] | undefined,
	listAnonymousSession: Array<GraphQLTypes["AnonymousSession"]>,
	paginateAnonymousSession: GraphQLTypes["AnonymousSessionConnection"],
	validateCreateAnonymousSession: GraphQLTypes["_ValidationResult"],
	validateUpdateAnonymousSession: GraphQLTypes["_ValidationResult"],
	getVoucher?: GraphQLTypes["Voucher"] | undefined,
	listVoucher: Array<GraphQLTypes["Voucher"]>,
	paginateVoucher: GraphQLTypes["VoucherConnection"],
	validateCreateVoucher: GraphQLTypes["_ValidationResult"],
	validateUpdateVoucher: GraphQLTypes["_ValidationResult"],
	getVoucherRedemption?: GraphQLTypes["VoucherRedemption"] | undefined,
	listVoucherRedemption: Array<GraphQLTypes["VoucherRedemption"]>,
	paginateVoucherRedemption: GraphQLTypes["VoucherRedemptionConnection"],
	validateCreateVoucherRedemption: GraphQLTypes["_ValidationResult"],
	validateUpdateVoucherRedemption: GraphQLTypes["_ValidationResult"],
	getUnassignedShiftInfo?: GraphQLTypes["UnassignedShiftInfo"] | undefined,
	listUnassignedShiftInfo: Array<GraphQLTypes["UnassignedShiftInfo"]>,
	paginateUnassignedShiftInfo: GraphQLTypes["UnassignedShiftInfoConnection"],
	validateCreateUnassignedShiftInfo: GraphQLTypes["_ValidationResult"],
	validateUpdateUnassignedShiftInfo: GraphQLTypes["_ValidationResult"],
	getFreshingContainer?: GraphQLTypes["FreshingContainer"] | undefined,
	listFreshingContainer: Array<GraphQLTypes["FreshingContainer"]>,
	paginateFreshingContainer: GraphQLTypes["FreshingContainerConnection"],
	validateCreateFreshingContainer: GraphQLTypes["_ValidationResult"],
	validateUpdateFreshingContainer: GraphQLTypes["_ValidationResult"],
	getTextItem?: GraphQLTypes["TextItem"] | undefined,
	listTextItem: Array<GraphQLTypes["TextItem"]>,
	paginateTextItem: GraphQLTypes["TextItemConnection"],
	validateCreateTextItem: GraphQLTypes["_ValidationResult"],
	validateUpdateTextItem: GraphQLTypes["_ValidationResult"],
	getTextList?: GraphQLTypes["TextList"] | undefined,
	listTextList: Array<GraphQLTypes["TextList"]>,
	paginateTextList: GraphQLTypes["TextListConnection"],
	validateCreateTextList: GraphQLTypes["_ValidationResult"],
	validateUpdateTextList: GraphQLTypes["_ValidationResult"],
	getEmployeeQueueItemMetadata?: GraphQLTypes["EmployeeQueueItemMetadata"] | undefined,
	listEmployeeQueueItemMetadata: Array<GraphQLTypes["EmployeeQueueItemMetadata"]>,
	paginateEmployeeQueueItemMetadata: GraphQLTypes["EmployeeQueueItemMetadataConnection"],
	getDeliveryRegions?: GraphQLTypes["DeliveryRegions"] | undefined,
	listDeliveryRegions: Array<GraphQLTypes["DeliveryRegions"]>,
	paginateDeliveryRegions: GraphQLTypes["DeliveryRegionsConnection"],
	validateCreateDeliveryRegions: GraphQLTypes["_ValidationResult"],
	validateUpdateDeliveryRegions: GraphQLTypes["_ValidationResult"],
	getDeliveryRegionsItem?: GraphQLTypes["DeliveryRegionsItem"] | undefined,
	listDeliveryRegionsItem: Array<GraphQLTypes["DeliveryRegionsItem"]>,
	paginateDeliveryRegionsItem: GraphQLTypes["DeliveryRegionsItemConnection"],
	validateCreateDeliveryRegionsItem: GraphQLTypes["_ValidationResult"],
	validateUpdateDeliveryRegionsItem: GraphQLTypes["_ValidationResult"],
	getImageList?: GraphQLTypes["ImageList"] | undefined,
	listImageList: Array<GraphQLTypes["ImageList"]>,
	paginateImageList: GraphQLTypes["ImageListConnection"],
	validateCreateImageList: GraphQLTypes["_ValidationResult"],
	validateUpdateImageList: GraphQLTypes["_ValidationResult"],
	getImageListItem?: GraphQLTypes["ImageListItem"] | undefined,
	listImageListItem: Array<GraphQLTypes["ImageListItem"]>,
	paginateImageListItem: GraphQLTypes["ImageListItemConnection"],
	validateCreateImageListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateImageListItem: GraphQLTypes["_ValidationResult"],
	getProductSalesDay?: GraphQLTypes["ProductSalesDay"] | undefined,
	listProductSalesDay: Array<GraphQLTypes["ProductSalesDay"]>,
	paginateProductSalesDay: GraphQLTypes["ProductSalesDayConnection"],
	getProductSalesMonth?: GraphQLTypes["ProductSalesMonth"] | undefined,
	listProductSalesMonth: Array<GraphQLTypes["ProductSalesMonth"]>,
	paginateProductSalesMonth: GraphQLTypes["ProductSalesMonthConnection"],
	getProductSalesWeek?: GraphQLTypes["ProductSalesWeek"] | undefined,
	listProductSalesWeek: Array<GraphQLTypes["ProductSalesWeek"]>,
	paginateProductSalesWeek: GraphQLTypes["ProductSalesWeekConnection"],
	getTimetablesEmployeePrivileges?: GraphQLTypes["TimetablesEmployeePrivileges"] | undefined,
	listTimetablesEmployeePrivileges: Array<GraphQLTypes["TimetablesEmployeePrivileges"]>,
	paginateTimetablesEmployeePrivileges: GraphQLTypes["TimetablesEmployeePrivilegesConnection"],
	validateCreateTimetablesEmployeePrivileges: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetablesEmployeePrivileges: GraphQLTypes["_ValidationResult"],
	getTimetableDayNote?: GraphQLTypes["TimetableDayNote"] | undefined,
	listTimetableDayNote: Array<GraphQLTypes["TimetableDayNote"]>,
	paginateTimetableDayNote: GraphQLTypes["TimetableDayNoteConnection"],
	validateCreateTimetableDayNote: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetableDayNote: GraphQLTypes["_ValidationResult"],
	getDeliveryMethodLocale?: GraphQLTypes["DeliveryMethodLocale"] | undefined,
	listDeliveryMethodLocale: Array<GraphQLTypes["DeliveryMethodLocale"]>,
	paginateDeliveryMethodLocale: GraphQLTypes["DeliveryMethodLocaleConnection"],
	validateCreateDeliveryMethodLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateDeliveryMethodLocale: GraphQLTypes["_ValidationResult"],
	getIngredientSupplier?: GraphQLTypes["IngredientSupplier"] | undefined,
	listIngredientSupplier: Array<GraphQLTypes["IngredientSupplier"]>,
	paginateIngredientSupplier: GraphQLTypes["IngredientSupplierConnection"],
	validateCreateIngredientSupplier: GraphQLTypes["_ValidationResult"],
	validateUpdateIngredientSupplier: GraphQLTypes["_ValidationResult"],
	getIngredientSupplierItem?: GraphQLTypes["IngredientSupplierItem"] | undefined,
	listIngredientSupplierItem: Array<GraphQLTypes["IngredientSupplierItem"]>,
	paginateIngredientSupplierItem: GraphQLTypes["IngredientSupplierItemConnection"],
	validateCreateIngredientSupplierItem: GraphQLTypes["_ValidationResult"],
	validateUpdateIngredientSupplierItem: GraphQLTypes["_ValidationResult"],
	getIngredientSupplierList?: GraphQLTypes["IngredientSupplierList"] | undefined,
	listIngredientSupplierList: Array<GraphQLTypes["IngredientSupplierList"]>,
	paginateIngredientSupplierList: GraphQLTypes["IngredientSupplierListConnection"],
	validateCreateIngredientSupplierList: GraphQLTypes["_ValidationResult"],
	validateUpdateIngredientSupplierList: GraphQLTypes["_ValidationResult"],
	getIngredientSupplierLocale?: GraphQLTypes["IngredientSupplierLocale"] | undefined,
	listIngredientSupplierLocale: Array<GraphQLTypes["IngredientSupplierLocale"]>,
	paginateIngredientSupplierLocale: GraphQLTypes["IngredientSupplierLocaleConnection"],
	validateCreateIngredientSupplierLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateIngredientSupplierLocale: GraphQLTypes["_ValidationResult"],
	getRedirect?: GraphQLTypes["Redirect"] | undefined,
	listRedirect: Array<GraphQLTypes["Redirect"]>,
	paginateRedirect: GraphQLTypes["RedirectConnection"],
	validateCreateRedirect: GraphQLTypes["_ValidationResult"],
	validateUpdateRedirect: GraphQLTypes["_ValidationResult"],
	getNutritionFacts?: GraphQLTypes["NutritionFacts"] | undefined,
	listNutritionFacts: Array<GraphQLTypes["NutritionFacts"]>,
	paginateNutritionFacts: GraphQLTypes["NutritionFactsConnection"],
	validateCreateNutritionFacts: GraphQLTypes["_ValidationResult"],
	validateUpdateNutritionFacts: GraphQLTypes["_ValidationResult"],
	getVenue?: GraphQLTypes["Venue"] | undefined,
	listVenue: Array<GraphQLTypes["Venue"]>,
	paginateVenue: GraphQLTypes["VenueConnection"],
	validateCreateVenue: GraphQLTypes["_ValidationResult"],
	validateUpdateVenue: GraphQLTypes["_ValidationResult"],
	getWorkspace?: GraphQLTypes["Workspace"] | undefined,
	listWorkspace: Array<GraphQLTypes["Workspace"]>,
	paginateWorkspace: GraphQLTypes["WorkspaceConnection"],
	validateCreateWorkspace: GraphQLTypes["_ValidationResult"],
	validateUpdateWorkspace: GraphQLTypes["_ValidationResult"],
	getInternalBuyer?: GraphQLTypes["InternalBuyer"] | undefined,
	listInternalBuyer: Array<GraphQLTypes["InternalBuyer"]>,
	paginateInternalBuyer: GraphQLTypes["InternalBuyerConnection"],
	validateCreateInternalBuyer: GraphQLTypes["_ValidationResult"],
	validateUpdateInternalBuyer: GraphQLTypes["_ValidationResult"],
	getCartSummary?: GraphQLTypes["CartSummary"] | undefined,
	listCartSummary: Array<GraphQLTypes["CartSummary"]>,
	paginateCartSummary: GraphQLTypes["CartSummaryConnection"],
	getOrderSummary?: GraphQLTypes["OrderSummary"] | undefined,
	listOrderSummary: Array<GraphQLTypes["OrderSummary"]>,
	paginateOrderSummary: GraphQLTypes["OrderSummaryConnection"],
	getCustomerSpending?: GraphQLTypes["CustomerSpending"] | undefined,
	listCustomerSpending: Array<GraphQLTypes["CustomerSpending"]>,
	paginateCustomerSpending: GraphQLTypes["CustomerSpendingConnection"],
	getOrderPaymentMetadata?: GraphQLTypes["OrderPaymentMetadata"] | undefined,
	listOrderPaymentMetadata: Array<GraphQLTypes["OrderPaymentMetadata"]>,
	paginateOrderPaymentMetadata: GraphQLTypes["OrderPaymentMetadataConnection"],
	getUserMetadata?: GraphQLTypes["UserMetadata"] | undefined,
	listUserMetadata: Array<GraphQLTypes["UserMetadata"]>,
	paginateUserMetadata: GraphQLTypes["UserMetadataConnection"],
	getCustomerTabMetadata?: GraphQLTypes["CustomerTabMetadata"] | undefined,
	listCustomerTabMetadata: Array<GraphQLTypes["CustomerTabMetadata"]>,
	paginateCustomerTabMetadata: GraphQLTypes["CustomerTabMetadataConnection"],
	getVenueEmployeeRole?: GraphQLTypes["VenueEmployeeRole"] | undefined,
	listVenueEmployeeRole: Array<GraphQLTypes["VenueEmployeeRole"]>,
	paginateVenueEmployeeRole: GraphQLTypes["VenueEmployeeRoleConnection"],
	validateCreateVenueEmployeeRole: GraphQLTypes["_ValidationResult"],
	validateUpdateVenueEmployeeRole: GraphQLTypes["_ValidationResult"],
	getIdentificationAttempt?: GraphQLTypes["IdentificationAttempt"] | undefined,
	listIdentificationAttempt: Array<GraphQLTypes["IdentificationAttempt"]>,
	paginateIdentificationAttempt: GraphQLTypes["IdentificationAttemptConnection"],
	validateCreateIdentificationAttempt: GraphQLTypes["_ValidationResult"],
	validateUpdateIdentificationAttempt: GraphQLTypes["_ValidationResult"],
	getIdentificationCode?: GraphQLTypes["IdentificationCode"] | undefined,
	listIdentificationCode: Array<GraphQLTypes["IdentificationCode"]>,
	paginateIdentificationCode: GraphQLTypes["IdentificationCodeConnection"],
	validateCreateIdentificationCode: GraphQLTypes["_ValidationResult"],
	validateUpdateIdentificationCode: GraphQLTypes["_ValidationResult"],
	getIdentificationCodeLocale?: GraphQLTypes["IdentificationCodeLocale"] | undefined,
	listIdentificationCodeLocale: Array<GraphQLTypes["IdentificationCodeLocale"]>,
	paginateIdentificationCodeLocale: GraphQLTypes["IdentificationCodeLocaleConnection"],
	validateCreateIdentificationCodeLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateIdentificationCodeLocale: GraphQLTypes["_ValidationResult"],
	getPipeline?: GraphQLTypes["Pipeline"] | undefined,
	listPipeline: Array<GraphQLTypes["Pipeline"]>,
	paginatePipeline: GraphQLTypes["PipelineConnection"],
	validateCreatePipeline: GraphQLTypes["_ValidationResult"],
	validateUpdatePipeline: GraphQLTypes["_ValidationResult"],
	getPipelineLead?: GraphQLTypes["PipelineLead"] | undefined,
	listPipelineLead: Array<GraphQLTypes["PipelineLead"]>,
	paginatePipelineLead: GraphQLTypes["PipelineLeadConnection"],
	validateCreatePipelineLead: GraphQLTypes["_ValidationResult"],
	validateUpdatePipelineLead: GraphQLTypes["_ValidationResult"],
	getPipelineStage?: GraphQLTypes["PipelineStage"] | undefined,
	listPipelineStage: Array<GraphQLTypes["PipelineStage"]>,
	paginatePipelineStage: GraphQLTypes["PipelineStageConnection"],
	validateCreatePipelineStage: GraphQLTypes["_ValidationResult"],
	validateUpdatePipelineStage: GraphQLTypes["_ValidationResult"],
	getPipelineStageItem?: GraphQLTypes["PipelineStageItem"] | undefined,
	listPipelineStageItem: Array<GraphQLTypes["PipelineStageItem"]>,
	paginatePipelineStageItem: GraphQLTypes["PipelineStageItemConnection"],
	validateCreatePipelineStageItem: GraphQLTypes["_ValidationResult"],
	validateUpdatePipelineStageItem: GraphQLTypes["_ValidationResult"],
	getPipelineStageLocale?: GraphQLTypes["PipelineStageLocale"] | undefined,
	listPipelineStageLocale: Array<GraphQLTypes["PipelineStageLocale"]>,
	paginatePipelineStageLocale: GraphQLTypes["PipelineStageLocaleConnection"],
	validateCreatePipelineStageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdatePipelineStageLocale: GraphQLTypes["_ValidationResult"],
	getSalesManager?: GraphQLTypes["SalesManager"] | undefined,
	listSalesManager: Array<GraphQLTypes["SalesManager"]>,
	paginateSalesManager: GraphQLTypes["SalesManagerConnection"],
	validateCreateSalesManager: GraphQLTypes["_ValidationResult"],
	validateUpdateSalesManager: GraphQLTypes["_ValidationResult"],
	getCashierManager?: GraphQLTypes["CashierManager"] | undefined,
	listCashierManager: Array<GraphQLTypes["CashierManager"]>,
	paginateCashierManager: GraphQLTypes["CashierManagerConnection"],
	validateCreateCashierManager: GraphQLTypes["_ValidationResult"],
	validateUpdateCashierManager: GraphQLTypes["_ValidationResult"],
	getUserRoles?: GraphQLTypes["UserRoles"] | undefined,
	listUserRoles: Array<GraphQLTypes["UserRoles"]>,
	paginateUserRoles: GraphQLTypes["UserRolesConnection"],
	getPointOfSaleApplicationDevice?: GraphQLTypes["PointOfSaleApplicationDevice"] | undefined,
	listPointOfSaleApplicationDevice: Array<GraphQLTypes["PointOfSaleApplicationDevice"]>,
	paginatePointOfSaleApplicationDevice: GraphQLTypes["PointOfSaleApplicationDeviceConnection"],
	validateCreatePointOfSaleApplicationDevice: GraphQLTypes["_ValidationResult"],
	validateUpdatePointOfSaleApplicationDevice: GraphQLTypes["_ValidationResult"],
	getPointOfSaleTerminal?: GraphQLTypes["PointOfSaleTerminal"] | undefined,
	listPointOfSaleTerminal: Array<GraphQLTypes["PointOfSaleTerminal"]>,
	paginatePointOfSaleTerminal: GraphQLTypes["PointOfSaleTerminalConnection"],
	validateCreatePointOfSaleTerminal: GraphQLTypes["_ValidationResult"],
	validateUpdatePointOfSaleTerminal: GraphQLTypes["_ValidationResult"],
	getPipelineStageSentiment?: GraphQLTypes["PipelineStageSentiment"] | undefined,
	listPipelineStageSentiment: Array<GraphQLTypes["PipelineStageSentiment"]>,
	paginatePipelineStageSentiment: GraphQLTypes["PipelineStageSentimentConnection"],
	validateCreatePipelineStageSentiment: GraphQLTypes["_ValidationResult"],
	validateUpdatePipelineStageSentiment: GraphQLTypes["_ValidationResult"],
	getDeviceIdentifier?: GraphQLTypes["DeviceIdentifier"] | undefined,
	listDeviceIdentifier: Array<GraphQLTypes["DeviceIdentifier"]>,
	paginateDeviceIdentifier: GraphQLTypes["DeviceIdentifierConnection"],
	validateCreateDeviceIdentifier: GraphQLTypes["_ValidationResult"],
	validateUpdateDeviceIdentifier: GraphQLTypes["_ValidationResult"],
	getDeviceIdentifierMetadata?: GraphQLTypes["DeviceIdentifierMetadata"] | undefined,
	listDeviceIdentifierMetadata: Array<GraphQLTypes["DeviceIdentifierMetadata"]>,
	paginateDeviceIdentifierMetadata: GraphQLTypes["DeviceIdentifierMetadataConnection"],
	getPointOfSalePrinter?: GraphQLTypes["PointOfSalePrinter"] | undefined,
	listPointOfSalePrinter: Array<GraphQLTypes["PointOfSalePrinter"]>,
	paginatePointOfSalePrinter: GraphQLTypes["PointOfSalePrinterConnection"],
	validateCreatePointOfSalePrinter: GraphQLTypes["_ValidationResult"],
	validateUpdatePointOfSalePrinter: GraphQLTypes["_ValidationResult"],
	getGratuity?: GraphQLTypes["Gratuity"] | undefined,
	listGratuity: Array<GraphQLTypes["Gratuity"]>,
	paginateGratuity: GraphQLTypes["GratuityConnection"],
	validateCreateGratuity: GraphQLTypes["_ValidationResult"],
	validateUpdateGratuity: GraphQLTypes["_ValidationResult"],
	getFulfillmentNote?: GraphQLTypes["FulfillmentNote"] | undefined,
	listFulfillmentNote: Array<GraphQLTypes["FulfillmentNote"]>,
	paginateFulfillmentNote: GraphQLTypes["FulfillmentNoteConnection"],
	validateCreateFulfillmentNote: GraphQLTypes["_ValidationResult"],
	validateUpdateFulfillmentNote: GraphQLTypes["_ValidationResult"],
	getCustomerMetadata?: GraphQLTypes["CustomerMetadata"] | undefined,
	listCustomerMetadata: Array<GraphQLTypes["CustomerMetadata"]>,
	paginateCustomerMetadata: GraphQLTypes["CustomerMetadataConnection"],
	getLeadForm?: GraphQLTypes["LeadForm"] | undefined,
	listLeadForm: Array<GraphQLTypes["LeadForm"]>,
	paginateLeadForm: GraphQLTypes["LeadFormConnection"],
	validateCreateLeadForm: GraphQLTypes["_ValidationResult"],
	validateUpdateLeadForm: GraphQLTypes["_ValidationResult"],
	getSubscriptionBox?: GraphQLTypes["SubscriptionBox"] | undefined,
	listSubscriptionBox: Array<GraphQLTypes["SubscriptionBox"]>,
	paginateSubscriptionBox: GraphQLTypes["SubscriptionBoxConnection"],
	validateCreateSubscriptionBox: GraphQLTypes["_ValidationResult"],
	validateUpdateSubscriptionBox: GraphQLTypes["_ValidationResult"],
	getSubscriptionBoxLocale?: GraphQLTypes["SubscriptionBoxLocale"] | undefined,
	listSubscriptionBoxLocale: Array<GraphQLTypes["SubscriptionBoxLocale"]>,
	paginateSubscriptionBoxLocale: GraphQLTypes["SubscriptionBoxLocaleConnection"],
	validateCreateSubscriptionBoxLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateSubscriptionBoxLocale: GraphQLTypes["_ValidationResult"],
	getTimetableDayMetadata?: GraphQLTypes["TimetableDayMetadata"] | undefined,
	listTimetableDayMetadata: Array<GraphQLTypes["TimetableDayMetadata"]>,
	paginateTimetableDayMetadata: GraphQLTypes["TimetableDayMetadataConnection"],
	getBusinessService?: GraphQLTypes["BusinessService"] | undefined,
	listBusinessService: Array<GraphQLTypes["BusinessService"]>,
	paginateBusinessService: GraphQLTypes["BusinessServiceConnection"],
	validateCreateBusinessService: GraphQLTypes["_ValidationResult"],
	validateUpdateBusinessService: GraphQLTypes["_ValidationResult"],
	getBusinessServiceEvent?: GraphQLTypes["BusinessServiceEvent"] | undefined,
	listBusinessServiceEvent: Array<GraphQLTypes["BusinessServiceEvent"]>,
	paginateBusinessServiceEvent: GraphQLTypes["BusinessServiceEventConnection"],
	validateCreateBusinessServiceEvent: GraphQLTypes["_ValidationResult"],
	validateUpdateBusinessServiceEvent: GraphQLTypes["_ValidationResult"],
	getBusinessServiceLocale?: GraphQLTypes["BusinessServiceLocale"] | undefined,
	listBusinessServiceLocale: Array<GraphQLTypes["BusinessServiceLocale"]>,
	paginateBusinessServiceLocale: GraphQLTypes["BusinessServiceLocaleConnection"],
	validateCreateBusinessServiceLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateBusinessServiceLocale: GraphQLTypes["_ValidationResult"],
	getGridTileItem?: GraphQLTypes["GridTileItem"] | undefined,
	listGridTileItem: Array<GraphQLTypes["GridTileItem"]>,
	paginateGridTileItem: GraphQLTypes["GridTileItemConnection"],
	validateCreateGridTileItem: GraphQLTypes["_ValidationResult"],
	validateUpdateGridTileItem: GraphQLTypes["_ValidationResult"],
	getGridTiles?: GraphQLTypes["GridTiles"] | undefined,
	listGridTiles: Array<GraphQLTypes["GridTiles"]>,
	paginateGridTiles: GraphQLTypes["GridTilesConnection"],
	validateCreateGridTiles: GraphQLTypes["_ValidationResult"],
	validateUpdateGridTiles: GraphQLTypes["_ValidationResult"],
	getArea?: GraphQLTypes["Area"] | undefined,
	listArea: Array<GraphQLTypes["Area"]>,
	paginateArea: GraphQLTypes["AreaConnection"],
	validateCreateArea: GraphQLTypes["_ValidationResult"],
	validateUpdateArea: GraphQLTypes["_ValidationResult"],
	getPosition?: GraphQLTypes["Position"] | undefined,
	listPosition: Array<GraphQLTypes["Position"]>,
	paginatePosition: GraphQLTypes["PositionConnection"],
	validateCreatePosition: GraphQLTypes["_ValidationResult"],
	validateUpdatePosition: GraphQLTypes["_ValidationResult"],
	getStatsEnabledWidgetType?: GraphQLTypes["StatsEnabledWidgetType"] | undefined,
	listStatsEnabledWidgetType: Array<GraphQLTypes["StatsEnabledWidgetType"]>,
	paginateStatsEnabledWidgetType: GraphQLTypes["StatsEnabledWidgetTypeConnection"],
	validateCreateStatsEnabledWidgetType: GraphQLTypes["_ValidationResult"],
	validateUpdateStatsEnabledWidgetType: GraphQLTypes["_ValidationResult"],
	getStatsWidget?: GraphQLTypes["StatsWidget"] | undefined,
	listStatsWidget: Array<GraphQLTypes["StatsWidget"]>,
	paginateStatsWidget: GraphQLTypes["StatsWidgetConnection"],
	validateCreateStatsWidget: GraphQLTypes["_ValidationResult"],
	validateUpdateStatsWidget: GraphQLTypes["_ValidationResult"],
	getStatsWidgetsLayout?: GraphQLTypes["StatsWidgetsLayout"] | undefined,
	listStatsWidgetsLayout: Array<GraphQLTypes["StatsWidgetsLayout"]>,
	paginateStatsWidgetsLayout: GraphQLTypes["StatsWidgetsLayoutConnection"],
	validateCreateStatsWidgetsLayout: GraphQLTypes["_ValidationResult"],
	validateUpdateStatsWidgetsLayout: GraphQLTypes["_ValidationResult"],
	getSeat?: GraphQLTypes["Seat"] | undefined,
	listSeat: Array<GraphQLTypes["Seat"]>,
	paginateSeat: GraphQLTypes["SeatConnection"],
	validateCreateSeat: GraphQLTypes["_ValidationResult"],
	validateUpdateSeat: GraphQLTypes["_ValidationResult"],
	getTable?: GraphQLTypes["Table"] | undefined,
	listTable: Array<GraphQLTypes["Table"]>,
	paginateTable: GraphQLTypes["TableConnection"],
	validateCreateTable: GraphQLTypes["_ValidationResult"],
	validateUpdateTable: GraphQLTypes["_ValidationResult"],
	getStatsPage?: GraphQLTypes["StatsPage"] | undefined,
	listStatsPage: Array<GraphQLTypes["StatsPage"]>,
	paginateStatsPage: GraphQLTypes["StatsPageConnection"],
	validateCreateStatsPage: GraphQLTypes["_ValidationResult"],
	validateUpdateStatsPage: GraphQLTypes["_ValidationResult"],
	getUnassignReason?: GraphQLTypes["UnassignReason"] | undefined,
	listUnassignReason: Array<GraphQLTypes["UnassignReason"]>,
	paginateUnassignReason: GraphQLTypes["UnassignReasonConnection"],
	validateCreateUnassignReason: GraphQLTypes["_ValidationResult"],
	validateUpdateUnassignReason: GraphQLTypes["_ValidationResult"],
	getDoubleshotCoffeeEquipment?: GraphQLTypes["DoubleshotCoffeeEquipment"] | undefined,
	listDoubleshotCoffeeEquipment: Array<GraphQLTypes["DoubleshotCoffeeEquipment"]>,
	paginateDoubleshotCoffeeEquipment: GraphQLTypes["DoubleshotCoffeeEquipmentConnection"],
	validateCreateDoubleshotCoffeeEquipment: GraphQLTypes["_ValidationResult"],
	validateUpdateDoubleshotCoffeeEquipment: GraphQLTypes["_ValidationResult"],
	getExpense?: GraphQLTypes["Expense"] | undefined,
	listExpense: Array<GraphQLTypes["Expense"]>,
	paginateExpense: GraphQLTypes["ExpenseConnection"],
	validateCreateExpense: GraphQLTypes["_ValidationResult"],
	validateUpdateExpense: GraphQLTypes["_ValidationResult"],
	getExpenseCategory?: GraphQLTypes["ExpenseCategory"] | undefined,
	listExpenseCategory: Array<GraphQLTypes["ExpenseCategory"]>,
	paginateExpenseCategory: GraphQLTypes["ExpenseCategoryConnection"],
	validateCreateExpenseCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateExpenseCategory: GraphQLTypes["_ValidationResult"],
	getExpenseChange?: GraphQLTypes["ExpenseChange"] | undefined,
	listExpenseChange: Array<GraphQLTypes["ExpenseChange"]>,
	paginateExpenseChange: GraphQLTypes["ExpenseChangeConnection"],
	validateCreateExpenseChange: GraphQLTypes["_ValidationResult"],
	validateUpdateExpenseChange: GraphQLTypes["_ValidationResult"],
	getExpenseDocument?: GraphQLTypes["ExpenseDocument"] | undefined,
	listExpenseDocument: Array<GraphQLTypes["ExpenseDocument"]>,
	paginateExpenseDocument: GraphQLTypes["ExpenseDocumentConnection"],
	validateCreateExpenseDocument: GraphQLTypes["_ValidationResult"],
	validateUpdateExpenseDocument: GraphQLTypes["_ValidationResult"],
	getRevenuePrediction?: GraphQLTypes["RevenuePrediction"] | undefined,
	listRevenuePrediction: Array<GraphQLTypes["RevenuePrediction"]>,
	paginateRevenuePrediction: GraphQLTypes["RevenuePredictionConnection"],
	validateCreateRevenuePrediction: GraphQLTypes["_ValidationResult"],
	validateUpdateRevenuePrediction: GraphQLTypes["_ValidationResult"],
	getRevenuePredictionChange?: GraphQLTypes["RevenuePredictionChange"] | undefined,
	listRevenuePredictionChange: Array<GraphQLTypes["RevenuePredictionChange"]>,
	paginateRevenuePredictionChange: GraphQLTypes["RevenuePredictionChangeConnection"],
	validateCreateRevenuePredictionChange: GraphQLTypes["_ValidationResult"],
	validateUpdateRevenuePredictionChange: GraphQLTypes["_ValidationResult"],
	getFile?: GraphQLTypes["File"] | undefined,
	listFile: Array<GraphQLTypes["File"]>,
	paginateFile: GraphQLTypes["FileConnection"],
	validateCreateFile: GraphQLTypes["_ValidationResult"],
	validateUpdateFile: GraphQLTypes["_ValidationResult"],
	getExpenseTerm?: GraphQLTypes["ExpenseTerm"] | undefined,
	listExpenseTerm: Array<GraphQLTypes["ExpenseTerm"]>,
	paginateExpenseTerm: GraphQLTypes["ExpenseTermConnection"],
	getLine?: GraphQLTypes["Line"] | undefined,
	listLine: Array<GraphQLTypes["Line"]>,
	paginateLine: GraphQLTypes["LineConnection"],
	validateCreateLine: GraphQLTypes["_ValidationResult"],
	validateUpdateLine: GraphQLTypes["_ValidationResult"],
	getFinancesBalanceItem?: GraphQLTypes["FinancesBalanceItem"] | undefined,
	listFinancesBalanceItem: Array<GraphQLTypes["FinancesBalanceItem"]>,
	paginateFinancesBalanceItem: GraphQLTypes["FinancesBalanceItemConnection"],
	validateCreateFinancesBalanceItem: GraphQLTypes["_ValidationResult"],
	validateUpdateFinancesBalanceItem: GraphQLTypes["_ValidationResult"],
	getRevenuePredictionTerm?: GraphQLTypes["RevenuePredictionTerm"] | undefined,
	listRevenuePredictionTerm: Array<GraphQLTypes["RevenuePredictionTerm"]>,
	paginateRevenuePredictionTerm: GraphQLTypes["RevenuePredictionTermConnection"],
	getOrderPaymentStatsByDay?: GraphQLTypes["OrderPaymentStatsByDay"] | undefined,
	listOrderPaymentStatsByDay: Array<GraphQLTypes["OrderPaymentStatsByDay"]>,
	paginateOrderPaymentStatsByDay: GraphQLTypes["OrderPaymentStatsByDayConnection"],
	getWoltDriveDelivery?: GraphQLTypes["WoltDriveDelivery"] | undefined,
	listWoltDriveDelivery: Array<GraphQLTypes["WoltDriveDelivery"]>,
	paginateWoltDriveDelivery: GraphQLTypes["WoltDriveDeliveryConnection"],
	validateCreateWoltDriveDelivery: GraphQLTypes["_ValidationResult"],
	validateUpdateWoltDriveDelivery: GraphQLTypes["_ValidationResult"],
	transaction?: GraphQLTypes["QueryTransaction"] | undefined,
	_info?: GraphQLTypes["Info"] | undefined,
	schema?: GraphQLTypes["_Schema"] | undefined,
	s3DummyQuery?: string | undefined
};
	["Address"]: {
	__typename: "Address",
	_meta?: GraphQLTypes["AddressMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name?: string | undefined,
	firstName?: string | undefined,
	lastName?: string | undefined,
	addressLine2?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	companyName?: string | undefined,
	companyIdentifier?: string | undefined,
	vatIdentifier?: string | undefined,
	externalIdentifier?: string | undefined,
	hidden: boolean,
	customer?: GraphQLTypes["Customer"] | undefined,
	internalNote?: string | undefined,
	country?: GraphQLTypes["Country"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	googlePlaceId?: string | undefined,
	raw?: string | undefined,
	formatted?: string | undefined,
	geocodeGeneratedAt?: GraphQLTypes["DateTime"] | undefined,
	geocodeResponse?: string | undefined,
	deliveryZone?: GraphQLTypes["DeliveryZone"] | undefined,
	meta?: GraphQLTypes["AddressMetadata"] | undefined,
	gps?: GraphQLTypes["Gps"] | undefined,
	geocodeValid?: boolean | undefined,
	fullName?: string | undefined,
	fakturoidSubjectId?: string | undefined,
	invoices: Array<GraphQLTypes["Invoice"]>,
	addressLine1?: string | undefined,
	city?: string | undefined,
	postalCode?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddressOfOrders: Array<GraphQLTypes["Order"]>,
	deliveryAddressOfOrderDeliveries: Array<GraphQLTypes["OrderDelivery"]>,
	defaultDeliveryAddressOfCustomer?: GraphQLTypes["Customer"] | undefined,
	invoicesByPublicKey?: GraphQLTypes["Invoice"] | undefined,
	invoicesByFakturoidId?: GraphQLTypes["Invoice"] | undefined,
	invoicesByOrderPayments?: GraphQLTypes["Invoice"] | undefined,
	billingAddressOfOrdersBySeq?: GraphQLTypes["Order"] | undefined,
	billingAddressOfOrdersByDoubleshotLegacyId?: GraphQLTypes["Order"] | undefined,
	billingAddressOfOrdersByDoubleShotLegacyNumber?: GraphQLTypes["Order"] | undefined,
	billingAddressOfOrdersByDiscounts?: GraphQLTypes["Order"] | undefined,
	billingAddressOfOrdersByDelivery?: GraphQLTypes["Order"] | undefined,
	billingAddressOfOrdersByItems?: GraphQLTypes["Order"] | undefined,
	billingAddressOfOrdersByCart?: GraphQLTypes["Order"] | undefined,
	billingAddressOfOrdersByEvents?: GraphQLTypes["Order"] | undefined,
	billingAddressOfOrdersByPriceLines?: GraphQLTypes["Order"] | undefined,
	billingAddressOfOrdersByPayments?: GraphQLTypes["Order"] | undefined,
	billingAddressOfOrdersBySummary?: GraphQLTypes["Order"] | undefined,
	billingAddressOfOrdersByGratuity?: GraphQLTypes["Order"] | undefined,
	deliveryAddressOfOrderDeliveriesByTrackingCode?: GraphQLTypes["OrderDelivery"] | undefined,
	deliveryAddressOfOrderDeliveriesByOrder?: GraphQLTypes["OrderDelivery"] | undefined,
	deliveryAddressOfOrderDeliveriesByDeliveryWaypoint?: GraphQLTypes["OrderDelivery"] | undefined,
	deliveryAddressOfOrderDeliveriesByEvents?: GraphQLTypes["OrderDelivery"] | undefined,
	deliveryAddressOfOrderDeliveriesByLiftagoRide?: GraphQLTypes["OrderDelivery"] | undefined,
	deliveryAddressOfOrderDeliveriesByWoltDriveDelivery?: GraphQLTypes["OrderDelivery"] | undefined,
	paginateInvoices: GraphQLTypes["InvoiceConnection"],
	paginateBillingAddressOfOrders: GraphQLTypes["OrderConnection"],
	paginateDeliveryAddressOfOrderDeliveries: GraphQLTypes["OrderDeliveryConnection"]
};
	["AddressMeta"]: {
	__typename: "AddressMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	firstName?: GraphQLTypes["FieldMeta"] | undefined,
	lastName?: GraphQLTypes["FieldMeta"] | undefined,
	addressLine2?: GraphQLTypes["FieldMeta"] | undefined,
	email?: GraphQLTypes["FieldMeta"] | undefined,
	phone?: GraphQLTypes["FieldMeta"] | undefined,
	companyName?: GraphQLTypes["FieldMeta"] | undefined,
	companyIdentifier?: GraphQLTypes["FieldMeta"] | undefined,
	vatIdentifier?: GraphQLTypes["FieldMeta"] | undefined,
	externalIdentifier?: GraphQLTypes["FieldMeta"] | undefined,
	hidden?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	country?: GraphQLTypes["FieldMeta"] | undefined,
	deletedAt?: GraphQLTypes["FieldMeta"] | undefined,
	note?: GraphQLTypes["FieldMeta"] | undefined,
	googlePlaceId?: GraphQLTypes["FieldMeta"] | undefined,
	raw?: GraphQLTypes["FieldMeta"] | undefined,
	formatted?: GraphQLTypes["FieldMeta"] | undefined,
	geocodeGeneratedAt?: GraphQLTypes["FieldMeta"] | undefined,
	geocodeResponse?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryZone?: GraphQLTypes["FieldMeta"] | undefined,
	meta?: GraphQLTypes["FieldMeta"] | undefined,
	gps?: GraphQLTypes["FieldMeta"] | undefined,
	geocodeValid?: GraphQLTypes["FieldMeta"] | undefined,
	fullName?: GraphQLTypes["FieldMeta"] | undefined,
	fakturoidSubjectId?: GraphQLTypes["FieldMeta"] | undefined,
	invoices?: GraphQLTypes["FieldMeta"] | undefined,
	addressLine1?: GraphQLTypes["FieldMeta"] | undefined,
	city?: GraphQLTypes["FieldMeta"] | undefined,
	postalCode?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	billingAddressOfOrders?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryAddressOfOrderDeliveries?: GraphQLTypes["FieldMeta"] | undefined,
	defaultDeliveryAddressOfCustomer?: GraphQLTypes["FieldMeta"] | undefined
};
	["FieldMeta"]: {
	__typename: "FieldMeta",
	readable?: boolean | undefined,
	updatable?: boolean | undefined
};
	["UUID"]: string;
	["Customer"]: {
	__typename: "Customer",
	_meta?: GraphQLTypes["CustomerMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	addresses: Array<GraphQLTypes["Address"]>,
	defaultBillingAddress?: GraphQLTypes["Address"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerPaymentMethod"] | undefined,
	tags: Array<GraphQLTypes["Tag"]>,
	credits: Array<GraphQLTypes["CustomerCredit"]>,
	paymentMethods: Array<GraphQLTypes["CustomerPaymentMethod"]>,
	orders: Array<GraphQLTypes["Order"]>,
	permissions?: GraphQLTypes["CustomerPermissions"] | undefined,
	group?: GraphQLTypes["CustomerGroup"] | undefined,
	photo?: GraphQLTypes["Image"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerName"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings: Array<GraphQLTypes["CustomerIngredientRating"]>,
	business?: GraphQLTypes["BusinessCustomer"] | undefined,
	ownerOfBusinesses: Array<GraphQLTypes["BusinessCustomer"]>,
	memberOfBusinesses: Array<GraphQLTypes["BusinessCustomer"]>,
	carts: Array<GraphQLTypes["Cart"]>,
	shortcutList?: GraphQLTypes["ApplicationShortcutList"] | undefined,
	user?: GraphQLTypes["User"] | undefined,
	channels: Array<GraphQLTypes["Channel"]>,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices: Array<GraphQLTypes["Invoice"]>,
	invoicingPlan?: GraphQLTypes["InvoicingPlan"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects: Array<GraphQLTypes["BillingSubject"]>,
	offeredProducts: Array<GraphQLTypes["ProductCustomerPrice"]>,
	defaultDeliveryAddress?: GraphQLTypes["Address"] | undefined,
	defaultBillingSubject?: GraphQLTypes["BillingSubject"] | undefined,
	prefersPackingsWithoutCardboard: boolean,
	anonymousSession?: GraphQLTypes["AnonymousSession"] | undefined,
	boughtVouchers: Array<GraphQLTypes["Voucher"]>,
	ownsVouchers: Array<GraphQLTypes["Voucher"]>,
	redeemedVouchers: Array<GraphQLTypes["VoucherRedemption"]>,
	spending?: GraphQLTypes["CustomerSpending"] | undefined,
	customerTabs: Array<GraphQLTypes["CustomerTab"]>,
	lead: Array<GraphQLTypes["PipelineLead"]>,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerMetadata"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	addressesByMeta?: GraphQLTypes["Address"] | undefined,
	addressesByGps?: GraphQLTypes["Address"] | undefined,
	addressesByInvoices?: GraphQLTypes["Address"] | undefined,
	addressesByBillingAddressOfOrders?: GraphQLTypes["Address"] | undefined,
	addressesByDeliveryAddressOfOrderDeliveries?: GraphQLTypes["Address"] | undefined,
	addressesByDefaultDeliveryAddressOfCustomer?: GraphQLTypes["Address"] | undefined,
	creditsByTransactions?: GraphQLTypes["CustomerCredit"] | undefined,
	creditsByVoucherRedemption?: GraphQLTypes["CustomerCredit"] | undefined,
	ordersBySeq?: GraphQLTypes["Order"] | undefined,
	ordersByDoubleshotLegacyId?: GraphQLTypes["Order"] | undefined,
	ordersByDoubleShotLegacyNumber?: GraphQLTypes["Order"] | undefined,
	ordersByDiscounts?: GraphQLTypes["Order"] | undefined,
	ordersByDelivery?: GraphQLTypes["Order"] | undefined,
	ordersByItems?: GraphQLTypes["Order"] | undefined,
	ordersByCart?: GraphQLTypes["Order"] | undefined,
	ordersByEvents?: GraphQLTypes["Order"] | undefined,
	ordersByPriceLines?: GraphQLTypes["Order"] | undefined,
	ordersByPayments?: GraphQLTypes["Order"] | undefined,
	ordersBySummary?: GraphQLTypes["Order"] | undefined,
	ordersByGratuity?: GraphQLTypes["Order"] | undefined,
	ingredientRatingsByIngredient?: GraphQLTypes["CustomerIngredientRating"] | undefined,
	cartsByItems?: GraphQLTypes["Cart"] | undefined,
	cartsByOrder?: GraphQLTypes["Cart"] | undefined,
	cartsByPriceLines?: GraphQLTypes["Cart"] | undefined,
	cartsBySummary?: GraphQLTypes["Cart"] | undefined,
	invoicesByPublicKey?: GraphQLTypes["Invoice"] | undefined,
	invoicesByFakturoidId?: GraphQLTypes["Invoice"] | undefined,
	invoicesByOrderPayments?: GraphQLTypes["Invoice"] | undefined,
	billingSubjectsByInvoices?: GraphQLTypes["BillingSubject"] | undefined,
	billingSubjectsByDefaultBillingSubjectOfCustomer?: GraphQLTypes["BillingSubject"] | undefined,
	billingSubjectsByOrders?: GraphQLTypes["BillingSubject"] | undefined,
	offeredProductsByProduct?: GraphQLTypes["ProductCustomerPrice"] | undefined,
	boughtVouchersByCode?: GraphQLTypes["Voucher"] | undefined,
	boughtVouchersByRedemption?: GraphQLTypes["Voucher"] | undefined,
	ownsVouchersByCode?: GraphQLTypes["Voucher"] | undefined,
	ownsVouchersByRedemption?: GraphQLTypes["Voucher"] | undefined,
	redeemedVouchersByCustomerCredit?: GraphQLTypes["VoucherRedemption"] | undefined,
	redeemedVouchersByOrderDiscount?: GraphQLTypes["VoucherRedemption"] | undefined,
	redeemedVouchersByVoucher?: GraphQLTypes["VoucherRedemption"] | undefined,
	customerTabsByItems?: GraphQLTypes["CustomerTab"] | undefined,
	customerTabsByMeta?: GraphQLTypes["CustomerTab"] | undefined,
	leadByStageItem?: GraphQLTypes["PipelineLead"] | undefined,
	paginateAddresses: GraphQLTypes["AddressConnection"],
	paginateTags: GraphQLTypes["TagConnection"],
	paginateCredits: GraphQLTypes["CustomerCreditConnection"],
	paginatePaymentMethods: GraphQLTypes["CustomerPaymentMethodConnection"],
	paginateOrders: GraphQLTypes["OrderConnection"],
	paginateIngredientRatings: GraphQLTypes["CustomerIngredientRatingConnection"],
	paginateOwnerOfBusinesses: GraphQLTypes["BusinessCustomerConnection"],
	paginateMemberOfBusinesses: GraphQLTypes["BusinessCustomerConnection"],
	paginateCarts: GraphQLTypes["CartConnection"],
	paginateChannels: GraphQLTypes["ChannelConnection"],
	paginateInvoices: GraphQLTypes["InvoiceConnection"],
	paginateBillingSubjects: GraphQLTypes["BillingSubjectConnection"],
	paginateOfferedProducts: GraphQLTypes["ProductCustomerPriceConnection"],
	paginateBoughtVouchers: GraphQLTypes["VoucherConnection"],
	paginateOwnsVouchers: GraphQLTypes["VoucherConnection"],
	paginateRedeemedVouchers: GraphQLTypes["VoucherRedemptionConnection"],
	paginateCustomerTabs: GraphQLTypes["CustomerTabConnection"],
	paginateLead: GraphQLTypes["PipelineLeadConnection"]
};
	["CustomerMeta"]: {
	__typename: "CustomerMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	addresses?: GraphQLTypes["FieldMeta"] | undefined,
	defaultBillingAddress?: GraphQLTypes["FieldMeta"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["FieldMeta"] | undefined,
	tags?: GraphQLTypes["FieldMeta"] | undefined,
	credits?: GraphQLTypes["FieldMeta"] | undefined,
	paymentMethods?: GraphQLTypes["FieldMeta"] | undefined,
	orders?: GraphQLTypes["FieldMeta"] | undefined,
	permissions?: GraphQLTypes["FieldMeta"] | undefined,
	group?: GraphQLTypes["FieldMeta"] | undefined,
	photo?: GraphQLTypes["FieldMeta"] | undefined,
	phone?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	welcomeMessage?: GraphQLTypes["FieldMeta"] | undefined,
	familiarity?: GraphQLTypes["FieldMeta"] | undefined,
	ingredientRatings?: GraphQLTypes["FieldMeta"] | undefined,
	business?: GraphQLTypes["FieldMeta"] | undefined,
	ownerOfBusinesses?: GraphQLTypes["FieldMeta"] | undefined,
	memberOfBusinesses?: GraphQLTypes["FieldMeta"] | undefined,
	carts?: GraphQLTypes["FieldMeta"] | undefined,
	shortcutList?: GraphQLTypes["FieldMeta"] | undefined,
	user?: GraphQLTypes["FieldMeta"] | undefined,
	channels?: GraphQLTypes["FieldMeta"] | undefined,
	disabledAt?: GraphQLTypes["FieldMeta"] | undefined,
	invoices?: GraphQLTypes["FieldMeta"] | undefined,
	invoicingPlan?: GraphQLTypes["FieldMeta"] | undefined,
	email?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	billingSubjects?: GraphQLTypes["FieldMeta"] | undefined,
	offeredProducts?: GraphQLTypes["FieldMeta"] | undefined,
	defaultDeliveryAddress?: GraphQLTypes["FieldMeta"] | undefined,
	defaultBillingSubject?: GraphQLTypes["FieldMeta"] | undefined,
	prefersPackingsWithoutCardboard?: GraphQLTypes["FieldMeta"] | undefined,
	anonymousSession?: GraphQLTypes["FieldMeta"] | undefined,
	boughtVouchers?: GraphQLTypes["FieldMeta"] | undefined,
	ownsVouchers?: GraphQLTypes["FieldMeta"] | undefined,
	redeemedVouchers?: GraphQLTypes["FieldMeta"] | undefined,
	spending?: GraphQLTypes["FieldMeta"] | undefined,
	customerTabs?: GraphQLTypes["FieldMeta"] | undefined,
	lead?: GraphQLTypes["FieldMeta"] | undefined,
	doubleshotLegacyId?: GraphQLTypes["FieldMeta"] | undefined,
	meta?: GraphQLTypes["FieldMeta"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["FieldMeta"] | undefined
};
	["AddressWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	firstName?: GraphQLTypes["StringCondition"] | undefined,
	lastName?: GraphQLTypes["StringCondition"] | undefined,
	addressLine2?: GraphQLTypes["StringCondition"] | undefined,
	email?: GraphQLTypes["StringCondition"] | undefined,
	phone?: GraphQLTypes["StringCondition"] | undefined,
	companyName?: GraphQLTypes["StringCondition"] | undefined,
	companyIdentifier?: GraphQLTypes["StringCondition"] | undefined,
	vatIdentifier?: GraphQLTypes["StringCondition"] | undefined,
	externalIdentifier?: GraphQLTypes["StringCondition"] | undefined,
	hidden?: GraphQLTypes["BooleanCondition"] | undefined,
	customer?: GraphQLTypes["CustomerWhere"] | undefined,
	internalNote?: GraphQLTypes["StringCondition"] | undefined,
	country?: GraphQLTypes["CountryWhere"] | undefined,
	deletedAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	note?: GraphQLTypes["StringCondition"] | undefined,
	googlePlaceId?: GraphQLTypes["StringCondition"] | undefined,
	raw?: GraphQLTypes["StringCondition"] | undefined,
	formatted?: GraphQLTypes["StringCondition"] | undefined,
	geocodeGeneratedAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	geocodeResponse?: GraphQLTypes["StringCondition"] | undefined,
	deliveryZone?: GraphQLTypes["DeliveryZoneWhere"] | undefined,
	meta?: GraphQLTypes["AddressMetadataWhere"] | undefined,
	gps?: GraphQLTypes["GpsWhere"] | undefined,
	geocodeValid?: GraphQLTypes["BooleanCondition"] | undefined,
	fullName?: GraphQLTypes["StringCondition"] | undefined,
	fakturoidSubjectId?: GraphQLTypes["StringCondition"] | undefined,
	invoices?: GraphQLTypes["InvoiceWhere"] | undefined,
	addressLine1?: GraphQLTypes["StringCondition"] | undefined,
	city?: GraphQLTypes["StringCondition"] | undefined,
	postalCode?: GraphQLTypes["StringCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	billingAddressOfOrders?: GraphQLTypes["OrderWhere"] | undefined,
	deliveryAddressOfOrderDeliveries?: GraphQLTypes["OrderDeliveryWhere"] | undefined,
	defaultDeliveryAddressOfCustomer?: GraphQLTypes["CustomerWhere"] | undefined,
	and?: Array<GraphQLTypes["AddressWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["AddressWhere"] | undefined> | undefined,
	not?: GraphQLTypes["AddressWhere"] | undefined
};
	["UUIDCondition"]: {
		and?: Array<GraphQLTypes["UUIDCondition"]> | undefined,
	or?: Array<GraphQLTypes["UUIDCondition"]> | undefined,
	not?: GraphQLTypes["UUIDCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["UUID"] | undefined,
	notEq?: GraphQLTypes["UUID"] | undefined,
	in?: Array<GraphQLTypes["UUID"]> | undefined,
	notIn?: Array<GraphQLTypes["UUID"]> | undefined,
	lt?: GraphQLTypes["UUID"] | undefined,
	lte?: GraphQLTypes["UUID"] | undefined,
	gt?: GraphQLTypes["UUID"] | undefined,
	gte?: GraphQLTypes["UUID"] | undefined
};
	["StringCondition"]: {
		and?: Array<GraphQLTypes["StringCondition"]> | undefined,
	or?: Array<GraphQLTypes["StringCondition"]> | undefined,
	not?: GraphQLTypes["StringCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: string | undefined,
	notEq?: string | undefined,
	in?: Array<string> | undefined,
	notIn?: Array<string> | undefined,
	lt?: string | undefined,
	lte?: string | undefined,
	gt?: string | undefined,
	gte?: string | undefined,
	contains?: string | undefined,
	startsWith?: string | undefined,
	endsWith?: string | undefined,
	containsCI?: string | undefined,
	startsWithCI?: string | undefined,
	endsWithCI?: string | undefined
};
	["BooleanCondition"]: {
		and?: Array<GraphQLTypes["BooleanCondition"]> | undefined,
	or?: Array<GraphQLTypes["BooleanCondition"]> | undefined,
	not?: GraphQLTypes["BooleanCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: boolean | undefined,
	notEq?: boolean | undefined,
	in?: Array<boolean> | undefined,
	notIn?: Array<boolean> | undefined,
	lt?: boolean | undefined,
	lte?: boolean | undefined,
	gt?: boolean | undefined,
	gte?: boolean | undefined
};
	["CustomerWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	addresses?: GraphQLTypes["AddressWhere"] | undefined,
	defaultBillingAddress?: GraphQLTypes["AddressWhere"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerPaymentMethodWhere"] | undefined,
	tags?: GraphQLTypes["TagWhere"] | undefined,
	credits?: GraphQLTypes["CustomerCreditWhere"] | undefined,
	paymentMethods?: GraphQLTypes["CustomerPaymentMethodWhere"] | undefined,
	orders?: GraphQLTypes["OrderWhere"] | undefined,
	permissions?: GraphQLTypes["CustomerPermissionsWhere"] | undefined,
	group?: GraphQLTypes["CustomerGroupWhere"] | undefined,
	photo?: GraphQLTypes["ImageWhere"] | undefined,
	phone?: GraphQLTypes["StringCondition"] | undefined,
	name?: GraphQLTypes["CustomerNameWhere"] | undefined,
	internalNote?: GraphQLTypes["StringCondition"] | undefined,
	welcomeMessage?: GraphQLTypes["StringCondition"] | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarityCondition"] | undefined,
	ingredientRatings?: GraphQLTypes["CustomerIngredientRatingWhere"] | undefined,
	business?: GraphQLTypes["BusinessCustomerWhere"] | undefined,
	ownerOfBusinesses?: GraphQLTypes["BusinessCustomerWhere"] | undefined,
	memberOfBusinesses?: GraphQLTypes["BusinessCustomerWhere"] | undefined,
	carts?: GraphQLTypes["CartWhere"] | undefined,
	shortcutList?: GraphQLTypes["ApplicationShortcutListWhere"] | undefined,
	user?: GraphQLTypes["UserWhere"] | undefined,
	channels?: GraphQLTypes["ChannelWhere"] | undefined,
	disabledAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	invoices?: GraphQLTypes["InvoiceWhere"] | undefined,
	invoicingPlan?: GraphQLTypes["InvoicingPlanWhere"] | undefined,
	email?: GraphQLTypes["StringCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	billingSubjects?: GraphQLTypes["BillingSubjectWhere"] | undefined,
	offeredProducts?: GraphQLTypes["ProductCustomerPriceWhere"] | undefined,
	defaultDeliveryAddress?: GraphQLTypes["AddressWhere"] | undefined,
	defaultBillingSubject?: GraphQLTypes["BillingSubjectWhere"] | undefined,
	prefersPackingsWithoutCardboard?: GraphQLTypes["BooleanCondition"] | undefined,
	anonymousSession?: GraphQLTypes["AnonymousSessionWhere"] | undefined,
	boughtVouchers?: GraphQLTypes["VoucherWhere"] | undefined,
	ownsVouchers?: GraphQLTypes["VoucherWhere"] | undefined,
	redeemedVouchers?: GraphQLTypes["VoucherRedemptionWhere"] | undefined,
	spending?: GraphQLTypes["CustomerSpendingWhere"] | undefined,
	customerTabs?: GraphQLTypes["CustomerTabWhere"] | undefined,
	lead?: GraphQLTypes["PipelineLeadWhere"] | undefined,
	doubleshotLegacyId?: GraphQLTypes["StringCondition"] | undefined,
	meta?: GraphQLTypes["CustomerMetadataWhere"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	and?: Array<GraphQLTypes["CustomerWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["CustomerWhere"] | undefined> | undefined,
	not?: GraphQLTypes["CustomerWhere"] | undefined
};
	["CustomerPaymentMethodWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	caption?: GraphQLTypes["StringCondition"] | undefined,
	data?: GraphQLTypes["JsonCondition"] | undefined,
	customer?: GraphQLTypes["CustomerWhere"] | undefined,
	paymentMethod?: GraphQLTypes["PaymentMethodWhere"] | undefined,
	and?: Array<GraphQLTypes["CustomerPaymentMethodWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["CustomerPaymentMethodWhere"] | undefined> | undefined,
	not?: GraphQLTypes["CustomerPaymentMethodWhere"] | undefined
};
	["JsonCondition"]: {
		and?: Array<GraphQLTypes["JsonCondition"]> | undefined,
	or?: Array<GraphQLTypes["JsonCondition"]> | undefined,
	not?: GraphQLTypes["JsonCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined
};
	["PaymentMethodWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	code?: GraphQLTypes["StringCondition"] | undefined,
	enabled?: GraphQLTypes["BooleanCondition"] | undefined,
	deliveryMethods?: GraphQLTypes["DeliveryMethodWhere"] | undefined,
	description?: GraphQLTypes["StringCondition"] | undefined,
	internalNote?: GraphQLTypes["StringCondition"] | undefined,
	blockingDispatch?: GraphQLTypes["BooleanCondition"] | undefined,
	type?: GraphQLTypes["PaymentMethodTypeCondition"] | undefined,
	channels?: GraphQLTypes["ChannelPaymentWhere"] | undefined,
	reduceGratuityByPercentage?: GraphQLTypes["IntCondition"] | undefined,
	and?: Array<GraphQLTypes["PaymentMethodWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PaymentMethodWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PaymentMethodWhere"] | undefined
};
	["DeliveryMethodWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	code?: GraphQLTypes["StringCondition"] | undefined,
	enabled?: GraphQLTypes["BooleanCondition"] | undefined,
	paymentMethods?: GraphQLTypes["PaymentMethodWhere"] | undefined,
	description?: GraphQLTypes["StringCondition"] | undefined,
	internalNote?: GraphQLTypes["StringCondition"] | undefined,
	requireDeliveryAddress?: GraphQLTypes["BooleanCondition"] | undefined,
	suitableForDeliveryZones?: GraphQLTypes["DeliveryZoneWhere"] | undefined,
	channels?: GraphQLTypes["ChannelDeliveryWhere"] | undefined,
	courierHandlers?: GraphQLTypes["CourierWhere"] | undefined,
	enableDeliveryTracking?: GraphQLTypes["BooleanCondition"] | undefined,
	locales?: GraphQLTypes["DeliveryMethodLocaleWhere"] | undefined,
	timelinePreset?: GraphQLTypes["DeliveryTimelinePresetWhere"] | undefined,
	woltDriveVenueId?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["DeliveryMethodWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["DeliveryMethodWhere"] | undefined> | undefined,
	not?: GraphQLTypes["DeliveryMethodWhere"] | undefined
};
	["DeliveryZoneWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	code?: GraphQLTypes["StringCondition"] | undefined,
	description?: GraphQLTypes["StringCondition"] | undefined,
	internalNote?: GraphQLTypes["StringCondition"] | undefined,
	type?: GraphQLTypes["DeliveryZoneTypeCondition"] | undefined,
	addresses?: GraphQLTypes["AddressWhere"] | undefined,
	suitableDeliveryMethods?: GraphQLTypes["DeliveryMethodWhere"] | undefined,
	deliveryZonesOfTags?: GraphQLTypes["TagWhere"] | undefined,
	deliveryZonesOfProducts?: GraphQLTypes["ProductWhere"] | undefined,
	addressesMetadata?: GraphQLTypes["AddressMetadataWhere"] | undefined,
	and?: Array<GraphQLTypes["DeliveryZoneWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["DeliveryZoneWhere"] | undefined> | undefined,
	not?: GraphQLTypes["DeliveryZoneWhere"] | undefined
};
	["DeliveryZoneTypeCondition"]: {
		and?: Array<GraphQLTypes["DeliveryZoneTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["DeliveryZoneTypeCondition"]> | undefined,
	not?: GraphQLTypes["DeliveryZoneTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["DeliveryZoneType"] | undefined,
	notEq?: GraphQLTypes["DeliveryZoneType"] | undefined,
	in?: Array<GraphQLTypes["DeliveryZoneType"]> | undefined,
	notIn?: Array<GraphQLTypes["DeliveryZoneType"]> | undefined,
	lt?: GraphQLTypes["DeliveryZoneType"] | undefined,
	lte?: GraphQLTypes["DeliveryZoneType"] | undefined,
	gt?: GraphQLTypes["DeliveryZoneType"] | undefined,
	gte?: GraphQLTypes["DeliveryZoneType"] | undefined
};
	["DeliveryZoneType"]: DeliveryZoneType;
	["TagWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	code?: GraphQLTypes["StringCondition"] | undefined,
	customers?: GraphQLTypes["CustomerWhere"] | undefined,
	products?: GraphQLTypes["ProductWhere"] | undefined,
	categories?: GraphQLTypes["ProductCategoryWhere"] | undefined,
	description?: GraphQLTypes["StringCondition"] | undefined,
	internalNote?: GraphQLTypes["StringCondition"] | undefined,
	addTagsOnRegistration?: GraphQLTypes["ChannelWhere"] | undefined,
	nestedCategories?: GraphQLTypes["InheritedProductCategoryTagWhere"] | undefined,
	deliveryZones?: GraphQLTypes["DeliveryZoneWhere"] | undefined,
	publicInChannels?: GraphQLTypes["ChannelWhere"] | undefined,
	allowChannelPayments?: GraphQLTypes["ChannelPaymentWhere"] | undefined,
	fulfillmentNotes?: GraphQLTypes["FulfillmentNoteWhere"] | undefined,
	and?: Array<GraphQLTypes["TagWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["TagWhere"] | undefined> | undefined,
	not?: GraphQLTypes["TagWhere"] | undefined
};
	["ProductWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	code?: GraphQLTypes["StringCondition"] | undefined,
	priceCents?: GraphQLTypes["IntCondition"] | undefined,
	notDiscountable?: GraphQLTypes["BooleanCondition"] | undefined,
	packing?: GraphQLTypes["ProductPackingWhere"] | undefined,
	recipe?: GraphQLTypes["ProductRecipeWhere"] | undefined,
	tags?: GraphQLTypes["TagWhere"] | undefined,
	categories?: GraphQLTypes["ProductCategoryWhere"] | undefined,
	vatRate?: GraphQLTypes["VatRateWhere"] | undefined,
	stocks?: GraphQLTypes["ProductStockWhere"] | undefined,
	groupPrices?: GraphQLTypes["ProductGroupPriceWhere"] | undefined,
	image?: GraphQLTypes["ImageWhere"] | undefined,
	description?: GraphQLTypes["StringCondition"] | undefined,
	internalNote?: GraphQLTypes["StringCondition"] | undefined,
	cartItems?: GraphQLTypes["CartItemWhere"] | undefined,
	availability?: GraphQLTypes["ProductAvailabilityCondition"] | undefined,
	order?: GraphQLTypes["FloatCondition"] | undefined,
	manager?: GraphQLTypes["StocksManagerWhere"] | undefined,
	orderItems?: GraphQLTypes["OrderItemWhere"] | undefined,
	maximumQuantityPerOrder?: GraphQLTypes["IntCondition"] | undefined,
	inheritedCategories?: GraphQLTypes["NestedProductCategoryProductWhere"] | undefined,
	deliveryZones?: GraphQLTypes["DeliveryZoneWhere"] | undefined,
	locales?: GraphQLTypes["ProductLocaleWhere"] | undefined,
	archivedAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	customerPrices?: GraphQLTypes["ProductCustomerPriceWhere"] | undefined,
	virtualProduct?: GraphQLTypes["VirtualProductWhere"] | undefined,
	meta?: GraphQLTypes["ProductMetadataWhere"] | undefined,
	page?: GraphQLTypes["PageWhere"] | undefined,
	salesDays?: GraphQLTypes["ProductSalesDayWhere"] | undefined,
	salesWeeks?: GraphQLTypes["ProductSalesWeekWhere"] | undefined,
	salesMonths?: GraphQLTypes["ProductSalesMonthWhere"] | undefined,
	fulfillmentNotes?: GraphQLTypes["FulfillmentNoteWhere"] | undefined,
	hasSubscription?: GraphQLTypes["BooleanCondition"] | undefined,
	pointOfSaleTileColor?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["ProductWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ProductWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ProductWhere"] | undefined
};
	["IntCondition"]: {
		and?: Array<GraphQLTypes["IntCondition"]> | undefined,
	or?: Array<GraphQLTypes["IntCondition"]> | undefined,
	not?: GraphQLTypes["IntCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: number | undefined,
	notEq?: number | undefined,
	in?: Array<number> | undefined,
	notIn?: Array<number> | undefined,
	lt?: number | undefined,
	lte?: number | undefined,
	gt?: number | undefined,
	gte?: number | undefined
};
	["ProductPackingWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	image?: GraphQLTypes["ImageWhere"] | undefined,
	description?: GraphQLTypes["StringCondition"] | undefined,
	internalNote?: GraphQLTypes["StringCondition"] | undefined,
	volumeMl?: GraphQLTypes["IntCondition"] | undefined,
	icon?: GraphQLTypes["ImageWhere"] | undefined,
	shortName?: GraphQLTypes["StringCondition"] | undefined,
	locales?: GraphQLTypes["ProductPackingLocaleWhere"] | undefined,
	preparedPackingQuantities?: GraphQLTypes["PreparedPackingQuantityWhere"] | undefined,
	isPackedInCardboard?: GraphQLTypes["BooleanCondition"] | undefined,
	and?: Array<GraphQLTypes["ProductPackingWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ProductPackingWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ProductPackingWhere"] | undefined
};
	["ImageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	url?: GraphQLTypes["StringCondition"] | undefined,
	width?: GraphQLTypes["IntCondition"] | undefined,
	height?: GraphQLTypes["IntCondition"] | undefined,
	size?: GraphQLTypes["IntCondition"] | undefined,
	type?: GraphQLTypes["StringCondition"] | undefined,
	alt?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["ImageWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ImageWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ImageWhere"] | undefined
};
	["ProductPackingLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	shortName?: GraphQLTypes["StringCondition"] | undefined,
	description?: GraphQLTypes["StringCondition"] | undefined,
	root?: GraphQLTypes["ProductPackingWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["ProductPackingLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ProductPackingLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ProductPackingLocaleWhere"] | undefined
};
	["LocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	businessCategories?: GraphQLTypes["BusinessCategoryLocaleWhere"] | undefined,
	productCategoryLists?: GraphQLTypes["ProductCategoryListLocaleWhere"] | undefined,
	productIngredients?: GraphQLTypes["ProductIngredientLocaleWhere"] | undefined,
	orderRecurrences?: GraphQLTypes["OrderRecurrenceLocaleWhere"] | undefined,
	blogs?: GraphQLTypes["BlogLocaleWhere"] | undefined,
	blogPosts?: GraphQLTypes["BlogPostLocaleWhere"] | undefined,
	identifier?: GraphQLTypes["TranslationCataloguesIdentifierWhere"] | undefined,
	menus?: GraphQLTypes["MenuLocaleWhere"] | undefined,
	pages?: GraphQLTypes["PageLocaleWhere"] | undefined,
	productIngredientCategories?: GraphQLTypes["ProductIngredientCategoryLocaleWhere"] | undefined,
	allergens?: GraphQLTypes["AllergenLocaleWhere"] | undefined,
	productPackings?: GraphQLTypes["ProductPackingLocaleWhere"] | undefined,
	products?: GraphQLTypes["ProductLocaleWhere"] | undefined,
	productRecipes?: GraphQLTypes["ProductRecipeLocaleWhere"] | undefined,
	pointOfSaleCategories?: GraphQLTypes["PointOfSaleCategoryLocaleWhere"] | undefined,
	pointOfSaleCategoryProducts?: GraphQLTypes["PointOfSaleCategoryProductLocaleWhere"] | undefined,
	deliveryMethods?: GraphQLTypes["DeliveryMethodLocaleWhere"] | undefined,
	ingredientSuppliers?: GraphQLTypes["IngredientSupplierLocaleWhere"] | undefined,
	identificationCodes?: GraphQLTypes["IdentificationCodeLocaleWhere"] | undefined,
	pipelineStages?: GraphQLTypes["PipelineStageLocaleWhere"] | undefined,
	subscriptionBoxes?: GraphQLTypes["SubscriptionBoxLocaleWhere"] | undefined,
	businessServices?: GraphQLTypes["BusinessServiceLocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["LocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["LocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["LocaleWhere"] | undefined
};
	["BusinessCategoryLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	root?: GraphQLTypes["BusinessCategoryWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["BusinessCategoryLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["BusinessCategoryLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["BusinessCategoryLocaleWhere"] | undefined
};
	["BusinessCategoryWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	visibleToNewCustomers?: GraphQLTypes["BooleanCondition"] | undefined,
	locales?: GraphQLTypes["BusinessCategoryLocaleWhere"] | undefined,
	internalName?: GraphQLTypes["StringCondition"] | undefined,
	businessCustomers?: GraphQLTypes["BusinessCustomerWhere"] | undefined,
	recurrences?: GraphQLTypes["OrderRecurrenceWhere"] | undefined,
	specificProducts?: GraphQLTypes["ProductListWhere"] | undefined,
	seasonalProductCategories?: GraphQLTypes["ProductCategoryListWhere"] | undefined,
	specificProductsProductCategories?: GraphQLTypes["ProductCategoryListWhere"] | undefined,
	slug?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["BusinessCategoryWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["BusinessCategoryWhere"] | undefined> | undefined,
	not?: GraphQLTypes["BusinessCategoryWhere"] | undefined
};
	["BusinessCustomerWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	customer?: GraphQLTypes["CustomerWhere"] | undefined,
	owners?: GraphQLTypes["CustomerWhere"] | undefined,
	members?: GraphQLTypes["CustomerWhere"] | undefined,
	category?: GraphQLTypes["BusinessCategoryWhere"] | undefined,
	accountManager?: GraphQLTypes["BusinessToBusinessManagerWhere"] | undefined,
	logo?: GraphQLTypes["ImageWhere"] | undefined,
	note?: GraphQLTypes["StringCondition"] | undefined,
	businessServiceEvents?: GraphQLTypes["BusinessServiceEventWhere"] | undefined,
	doubleshotCoffeeEquipment?: GraphQLTypes["DoubleshotCoffeeEquipmentWhere"] | undefined,
	and?: Array<GraphQLTypes["BusinessCustomerWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["BusinessCustomerWhere"] | undefined> | undefined,
	not?: GraphQLTypes["BusinessCustomerWhere"] | undefined
};
	["BusinessToBusinessManagerWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	staff?: GraphQLTypes["StaffWhere"] | undefined,
	managedBusinesses?: GraphQLTypes["BusinessCustomerWhere"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	and?: Array<GraphQLTypes["BusinessToBusinessManagerWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["BusinessToBusinessManagerWhere"] | undefined> | undefined,
	not?: GraphQLTypes["BusinessToBusinessManagerWhere"] | undefined
};
	["StaffWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	bartender?: GraphQLTypes["BartenderWhere"] | undefined,
	courier?: GraphQLTypes["CourierWhere"] | undefined,
	cleaner?: GraphQLTypes["CleanerWhere"] | undefined,
	shiftsManager?: GraphQLTypes["ShiftsManagerWhere"] | undefined,
	businessToBusinessManager?: GraphQLTypes["BusinessToBusinessManagerWhere"] | undefined,
	user?: GraphQLTypes["UserWhere"] | undefined,
	shiftsProfile?: GraphQLTypes["ShiftsProfileWhere"] | undefined,
	stocksManager?: GraphQLTypes["StocksManagerWhere"] | undefined,
	photo?: GraphQLTypes["ImageWhere"] | undefined,
	courierManager?: GraphQLTypes["CourierManagerWhere"] | undefined,
	picker?: GraphQLTypes["PickerWhere"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	remunerationProfile?: GraphQLTypes["RemunerationProfileWhere"] | undefined,
	cashier?: GraphQLTypes["CashierWhere"] | undefined,
	venues?: GraphQLTypes["VenueWhere"] | undefined,
	internalBuyer?: GraphQLTypes["InternalBuyerWhere"] | undefined,
	salesManager?: GraphQLTypes["SalesManagerWhere"] | undefined,
	cashierManager?: GraphQLTypes["CashierManagerWhere"] | undefined,
	and?: Array<GraphQLTypes["StaffWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["StaffWhere"] | undefined> | undefined,
	not?: GraphQLTypes["StaffWhere"] | undefined
};
	["BartenderWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	staff?: GraphQLTypes["StaffWhere"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	and?: Array<GraphQLTypes["BartenderWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["BartenderWhere"] | undefined> | undefined,
	not?: GraphQLTypes["BartenderWhere"] | undefined
};
	["DateTimeCondition"]: {
		and?: Array<GraphQLTypes["DateTimeCondition"]> | undefined,
	or?: Array<GraphQLTypes["DateTimeCondition"]> | undefined,
	not?: GraphQLTypes["DateTimeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["DateTime"] | undefined,
	notEq?: GraphQLTypes["DateTime"] | undefined,
	in?: Array<GraphQLTypes["DateTime"]> | undefined,
	notIn?: Array<GraphQLTypes["DateTime"]> | undefined,
	lt?: GraphQLTypes["DateTime"] | undefined,
	lte?: GraphQLTypes["DateTime"] | undefined,
	gt?: GraphQLTypes["DateTime"] | undefined,
	gte?: GraphQLTypes["DateTime"] | undefined
};
	["DateTime"]: string;
	["CourierWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	staff?: GraphQLTypes["StaffWhere"] | undefined,
	routes?: GraphQLTypes["DeliveryRouteWhere"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	deliveryMethods?: GraphQLTypes["DeliveryMethodWhere"] | undefined,
	showInPicker?: GraphQLTypes["BooleanCondition"] | undefined,
	and?: Array<GraphQLTypes["CourierWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["CourierWhere"] | undefined> | undefined,
	not?: GraphQLTypes["CourierWhere"] | undefined
};
	["DeliveryRouteWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	courier?: GraphQLTypes["CourierWhere"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	waypoints?: GraphQLTypes["DeliveryWaypointWhere"] | undefined,
	dispatchAt?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["DeliveryRouteWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["DeliveryRouteWhere"] | undefined> | undefined,
	not?: GraphQLTypes["DeliveryRouteWhere"] | undefined
};
	["DeliveryWaypointWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	estimatedArrival?: GraphQLTypes["DateTimeCondition"] | undefined,
	note?: GraphQLTypes["StringCondition"] | undefined,
	route?: GraphQLTypes["DeliveryRouteWhere"] | undefined,
	sortingOrder?: GraphQLTypes["IntCondition"] | undefined,
	delivery?: GraphQLTypes["OrderDeliveryWhere"] | undefined,
	estimatedDistance?: GraphQLTypes["IntCondition"] | undefined,
	estimatedDuration?: GraphQLTypes["IntCondition"] | undefined,
	originDeparture?: GraphQLTypes["DateTimeCondition"] | undefined,
	originAddress?: GraphQLTypes["StringCondition"] | undefined,
	transitMode?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["DeliveryWaypointWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["DeliveryWaypointWhere"] | undefined> | undefined,
	not?: GraphQLTypes["DeliveryWaypointWhere"] | undefined
};
	["OrderDeliveryWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	priceCents?: GraphQLTypes["IntCondition"] | undefined,
	deliveredAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	method?: GraphQLTypes["DeliveryMethodWhere"] | undefined,
	vatRate?: GraphQLTypes["VatRateWhere"] | undefined,
	order?: GraphQLTypes["OrderWhere"] | undefined,
	expectedAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	state?: GraphQLTypes["OrderDeliveryStateCondition"] | undefined,
	loadingDurationHours?: GraphQLTypes["IntCondition"] | undefined,
	dispatchAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	duration?: GraphQLTypes["StringCondition"] | undefined,
	window?: GraphQLTypes["StringCondition"] | undefined,
	expectedEndAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	processingAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	deliveringAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	failedAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	internalNote?: GraphQLTypes["StringCondition"] | undefined,
	deliveryWaypoint?: GraphQLTypes["DeliveryWaypointWhere"] | undefined,
	events?: GraphQLTypes["OrderEventWhere"] | undefined,
	prepareAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	liftagoRide?: GraphQLTypes["LiftagoRideWhere"] | undefined,
	pickedAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	address?: GraphQLTypes["AddressWhere"] | undefined,
	trackingCode?: GraphQLTypes["StringCondition"] | undefined,
	woltDriveDelivery?: GraphQLTypes["WoltDriveDeliveryWhere"] | undefined,
	and?: Array<GraphQLTypes["OrderDeliveryWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["OrderDeliveryWhere"] | undefined> | undefined,
	not?: GraphQLTypes["OrderDeliveryWhere"] | undefined
};
	["VatRateWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	ratePermille?: GraphQLTypes["IntCondition"] | undefined,
	description?: GraphQLTypes["StringCondition"] | undefined,
	internalNote?: GraphQLTypes["StringCondition"] | undefined,
	channelDeliveries?: GraphQLTypes["ChannelDeliveryWhere"] | undefined,
	channelPayments?: GraphQLTypes["ChannelPaymentWhere"] | undefined,
	preset?: GraphQLTypes["VatRatePresetCondition"] | undefined,
	and?: Array<GraphQLTypes["VatRateWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["VatRateWhere"] | undefined> | undefined,
	not?: GraphQLTypes["VatRateWhere"] | undefined
};
	["ChannelDeliveryWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	priceCents?: GraphQLTypes["IntCondition"] | undefined,
	channel?: GraphQLTypes["ChannelWhere"] | undefined,
	method?: GraphQLTypes["DeliveryMethodWhere"] | undefined,
	vatRate?: GraphQLTypes["VatRateWhere"] | undefined,
	defaultVisible?: GraphQLTypes["BooleanCondition"] | undefined,
	and?: Array<GraphQLTypes["ChannelDeliveryWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ChannelDeliveryWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ChannelDeliveryWhere"] | undefined
};
	["ChannelWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	disabled?: GraphQLTypes["BooleanCondition"] | undefined,
	payments?: GraphQLTypes["ChannelPaymentWhere"] | undefined,
	deliveries?: GraphQLTypes["ChannelDeliveryWhere"] | undefined,
	pointOfSales?: GraphQLTypes["PointOfSaleWhere"] | undefined,
	carts?: GraphQLTypes["CartWhere"] | undefined,
	customers?: GraphQLTypes["CustomerWhere"] | undefined,
	code?: GraphQLTypes["ChannelCodeCondition"] | undefined,
	addTagsOnRegistration?: GraphQLTypes["TagWhere"] | undefined,
	publicTags?: GraphQLTypes["TagWhere"] | undefined,
	venue?: GraphQLTypes["VenueWhere"] | undefined,
	and?: Array<GraphQLTypes["ChannelWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ChannelWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ChannelWhere"] | undefined
};
	["ChannelPaymentWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	channel?: GraphQLTypes["ChannelWhere"] | undefined,
	method?: GraphQLTypes["PaymentMethodWhere"] | undefined,
	vatRate?: GraphQLTypes["VatRateWhere"] | undefined,
	requireBillingAddress?: GraphQLTypes["BooleanCondition"] | undefined,
	provideReceipt?: GraphQLTypes["BooleanCondition"] | undefined,
	requireBillingSubject?: GraphQLTypes["BooleanCondition"] | undefined,
	allowOnlyForTags?: GraphQLTypes["TagWhere"] | undefined,
	and?: Array<GraphQLTypes["ChannelPaymentWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ChannelPaymentWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ChannelPaymentWhere"] | undefined
};
	["PointOfSaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	code?: GraphQLTypes["StringCondition"] | undefined,
	channels?: GraphQLTypes["ChannelWhere"] | undefined,
	permissions?: GraphQLTypes["PointOfSalePermissionsWhere"] | undefined,
	tenantPersonId?: GraphQLTypes["UUIDCondition"] | undefined,
	and?: Array<GraphQLTypes["PointOfSaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PointOfSaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PointOfSaleWhere"] | undefined
};
	["PointOfSalePermissionsWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	canPlaceOrder?: GraphQLTypes["BooleanCondition"] | undefined,
	pointOfSale?: GraphQLTypes["PointOfSaleWhere"] | undefined,
	and?: Array<GraphQLTypes["PointOfSalePermissionsWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PointOfSalePermissionsWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PointOfSalePermissionsWhere"] | undefined
};
	["CartWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	confirmedAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	deletedAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	note?: GraphQLTypes["StringCondition"] | undefined,
	items?: GraphQLTypes["CartItemWhere"] | undefined,
	handle?: GraphQLTypes["StringCondition"] | undefined,
	state?: GraphQLTypes["CartStateCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	channel?: GraphQLTypes["ChannelWhere"] | undefined,
	order?: GraphQLTypes["OrderWhere"] | undefined,
	customer?: GraphQLTypes["CustomerWhere"] | undefined,
	deliveryAddress?: GraphQLTypes["AddressWhere"] | undefined,
	billingAddress?: GraphQLTypes["AddressWhere"] | undefined,
	deliveryOption?: GraphQLTypes["StringCondition"] | undefined,
	paymentOption?: GraphQLTypes["StringCondition"] | undefined,
	delivery?: GraphQLTypes["ChannelDeliveryWhere"] | undefined,
	payment?: GraphQLTypes["ChannelPaymentWhere"] | undefined,
	billingSubject?: GraphQLTypes["BillingSubjectWhere"] | undefined,
	priceLines?: GraphQLTypes["CartPriceLineWhere"] | undefined,
	summary?: GraphQLTypes["CartSummaryWhere"] | undefined,
	and?: Array<GraphQLTypes["CartWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["CartWhere"] | undefined> | undefined,
	not?: GraphQLTypes["CartWhere"] | undefined
};
	["CartItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	quantity?: GraphQLTypes["IntCondition"] | undefined,
	cart?: GraphQLTypes["CartWhere"] | undefined,
	product?: GraphQLTypes["ProductWhere"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	updatedAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	fulfillmentNote?: GraphQLTypes["StringCondition"] | undefined,
	fulfillmentNotes?: GraphQLTypes["FulfillmentNoteWhere"] | undefined,
	and?: Array<GraphQLTypes["CartItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["CartItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["CartItemWhere"] | undefined
};
	["FulfillmentNoteWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	note?: GraphQLTypes["StringCondition"] | undefined,
	products?: GraphQLTypes["ProductWhere"] | undefined,
	tags?: GraphQLTypes["TagWhere"] | undefined,
	venues?: GraphQLTypes["VenueWhere"] | undefined,
	cartItems?: GraphQLTypes["CartItemWhere"] | undefined,
	orderItems?: GraphQLTypes["OrderItemWhere"] | undefined,
	orders?: GraphQLTypes["OrderWhere"] | undefined,
	highlight?: GraphQLTypes["BooleanCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	emoji?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["FulfillmentNoteWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["FulfillmentNoteWhere"] | undefined> | undefined,
	not?: GraphQLTypes["FulfillmentNoteWhere"] | undefined
};
	["VenueWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	deadlineTemplate?: GraphQLTypes["DeadlineTemplateWhere"] | undefined,
	timetableDays?: GraphQLTypes["TimetableDayWhere"] | undefined,
	timetableTemplates?: GraphQLTypes["TimetableTemplateWhere"] | undefined,
	staffMembers?: GraphQLTypes["StaffWhere"] | undefined,
	employeeRoles?: GraphQLTypes["VenueEmployeeRoleWhere"] | undefined,
	pointOfSaleApplicationDevices?: GraphQLTypes["PointOfSaleApplicationDeviceWhere"] | undefined,
	pointOfSaleTerminals?: GraphQLTypes["PointOfSaleTerminalWhere"] | undefined,
	pointOfSalePrinters?: GraphQLTypes["PointOfSalePrinterWhere"] | undefined,
	orders?: GraphQLTypes["OrderWhere"] | undefined,
	fulfillmentNotes?: GraphQLTypes["FulfillmentNoteWhere"] | undefined,
	areas?: GraphQLTypes["AreaWhere"] | undefined,
	enabledUnassignReasons?: GraphQLTypes["UnassignReasonWhere"] | undefined,
	categories?: GraphQLTypes["PointOfSaleCategoryWhere"] | undefined,
	channels?: GraphQLTypes["ChannelWhere"] | undefined,
	address?: GraphQLTypes["StringCondition"] | undefined,
	pointOfSalePngBase64ReceiptLogo?: GraphQLTypes["StringCondition"] | undefined,
	pointOfSaleInitialView?: GraphQLTypes["PointOfSaleInitialViewCondition"] | undefined,
	pointOfSalePreferPrintReceipt?: GraphQLTypes["BooleanCondition"] | undefined,
	and?: Array<GraphQLTypes["VenueWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["VenueWhere"] | undefined> | undefined,
	not?: GraphQLTypes["VenueWhere"] | undefined
};
	["DeadlineTemplateWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	startDate?: GraphQLTypes["DateCondition"] | undefined,
	period?: GraphQLTypes["IntCondition"] | undefined,
	cutoff?: GraphQLTypes["IntCondition"] | undefined,
	closed?: GraphQLTypes["BooleanCondition"] | undefined,
	venue?: GraphQLTypes["VenueWhere"] | undefined,
	and?: Array<GraphQLTypes["DeadlineTemplateWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["DeadlineTemplateWhere"] | undefined> | undefined,
	not?: GraphQLTypes["DeadlineTemplateWhere"] | undefined
};
	["DateCondition"]: {
		and?: Array<GraphQLTypes["DateCondition"]> | undefined,
	or?: Array<GraphQLTypes["DateCondition"]> | undefined,
	not?: GraphQLTypes["DateCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["Date"] | undefined,
	notEq?: GraphQLTypes["Date"] | undefined,
	in?: Array<GraphQLTypes["Date"]> | undefined,
	notIn?: Array<GraphQLTypes["Date"]> | undefined,
	lt?: GraphQLTypes["Date"] | undefined,
	lte?: GraphQLTypes["Date"] | undefined,
	gt?: GraphQLTypes["Date"] | undefined,
	gte?: GraphQLTypes["Date"] | undefined
};
	["Date"]: any;
	["TimetableDayWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	date?: GraphQLTypes["DateCondition"] | undefined,
	type?: GraphQLTypes["TimetableDayTypeCondition"] | undefined,
	shiftGroups?: GraphQLTypes["TimetableShiftGroupWhere"] | undefined,
	tipsCents?: GraphQLTypes["IntCondition"] | undefined,
	notes?: GraphQLTypes["TimetableDayNoteWhere"] | undefined,
	venue?: GraphQLTypes["VenueWhere"] | undefined,
	meta?: GraphQLTypes["TimetableDayMetadataWhere"] | undefined,
	and?: Array<GraphQLTypes["TimetableDayWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["TimetableDayWhere"] | undefined> | undefined,
	not?: GraphQLTypes["TimetableDayWhere"] | undefined
};
	["TimetableDayTypeCondition"]: {
		and?: Array<GraphQLTypes["TimetableDayTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["TimetableDayTypeCondition"]> | undefined,
	not?: GraphQLTypes["TimetableDayTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["TimetableDayType"] | undefined,
	notEq?: GraphQLTypes["TimetableDayType"] | undefined,
	in?: Array<GraphQLTypes["TimetableDayType"]> | undefined,
	notIn?: Array<GraphQLTypes["TimetableDayType"]> | undefined,
	lt?: GraphQLTypes["TimetableDayType"] | undefined,
	lte?: GraphQLTypes["TimetableDayType"] | undefined,
	gt?: GraphQLTypes["TimetableDayType"] | undefined,
	gte?: GraphQLTypes["TimetableDayType"] | undefined
};
	["TimetableDayType"]: TimetableDayType;
	["TimetableShiftGroupWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	shifts?: GraphQLTypes["TimetableShiftWhere"] | undefined,
	day?: GraphQLTypes["TimetableDayWhere"] | undefined,
	type?: GraphQLTypes["TimetableEmployeeRoleWhere"] | undefined,
	position?: GraphQLTypes["TimetableShiftPositionWhere"] | undefined,
	queue?: GraphQLTypes["EmployeeQueueWhere"] | undefined,
	generatedByTemplate?: GraphQLTypes["TimetableTemplateWhere"] | undefined,
	and?: Array<GraphQLTypes["TimetableShiftGroupWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["TimetableShiftGroupWhere"] | undefined> | undefined,
	not?: GraphQLTypes["TimetableShiftGroupWhere"] | undefined
};
	["TimetableShiftWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	locked?: GraphQLTypes["BooleanCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	assigned?: GraphQLTypes["DateCondition"] | undefined,
	group?: GraphQLTypes["TimetableShiftGroupWhere"] | undefined,
	shiftsProfile?: GraphQLTypes["ShiftsProfileWhere"] | undefined,
	queueItem?: GraphQLTypes["EmployeeQueueItemWhere"] | undefined,
	swapInfo?: GraphQLTypes["TimetableShiftSwapInfoWhere"] | undefined,
	isOvertime?: GraphQLTypes["BooleanCondition"] | undefined,
	and?: Array<GraphQLTypes["TimetableShiftWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["TimetableShiftWhere"] | undefined> | undefined,
	not?: GraphQLTypes["TimetableShiftWhere"] | undefined
};
	["ShiftsProfileWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	queueItems?: GraphQLTypes["EmployeeQueueItemWhere"] | undefined,
	staff?: GraphQLTypes["StaffWhere"] | undefined,
	roles?: GraphQLTypes["TimetableEmployeeRoleWhere"] | undefined,
	shifts?: GraphQLTypes["TimetableShiftWhere"] | undefined,
	allowSelfUnassigning?: GraphQLTypes["BooleanCondition"] | undefined,
	and?: Array<GraphQLTypes["ShiftsProfileWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ShiftsProfileWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ShiftsProfileWhere"] | undefined
};
	["EmployeeQueueItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	start?: GraphQLTypes["StringCondition"] | undefined,
	end?: GraphQLTypes["StringCondition"] | undefined,
	queue?: GraphQLTypes["EmployeeQueueWhere"] | undefined,
	shiftsProfile?: GraphQLTypes["ShiftsProfileWhere"] | undefined,
	shift?: GraphQLTypes["TimetableShiftWhere"] | undefined,
	unassignInfo?: GraphQLTypes["UnassignedShiftInfoWhere"] | undefined,
	meta?: GraphQLTypes["EmployeeQueueItemMetadataWhere"] | undefined,
	and?: Array<GraphQLTypes["EmployeeQueueItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["EmployeeQueueItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["EmployeeQueueItemWhere"] | undefined
};
	["EmployeeQueueWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	shiftGroup?: GraphQLTypes["TimetableShiftGroupWhere"] | undefined,
	items?: GraphQLTypes["EmployeeQueueItemWhere"] | undefined,
	contemberBugFix?: GraphQLTypes["BooleanCondition"] | undefined,
	and?: Array<GraphQLTypes["EmployeeQueueWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["EmployeeQueueWhere"] | undefined> | undefined,
	not?: GraphQLTypes["EmployeeQueueWhere"] | undefined
};
	["UnassignedShiftInfoWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	hoursMissed?: GraphQLTypes["IntCondition"] | undefined,
	queueItem?: GraphQLTypes["EmployeeQueueItemWhere"] | undefined,
	legacyReason?: GraphQLTypes["UnassignedInfoReasonCondition"] | undefined,
	reason?: GraphQLTypes["UnassignReasonWhere"] | undefined,
	and?: Array<GraphQLTypes["UnassignedShiftInfoWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["UnassignedShiftInfoWhere"] | undefined> | undefined,
	not?: GraphQLTypes["UnassignedShiftInfoWhere"] | undefined
};
	["UnassignedInfoReasonCondition"]: {
		and?: Array<GraphQLTypes["UnassignedInfoReasonCondition"]> | undefined,
	or?: Array<GraphQLTypes["UnassignedInfoReasonCondition"]> | undefined,
	not?: GraphQLTypes["UnassignedInfoReasonCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["UnassignedInfoReason"] | undefined,
	notEq?: GraphQLTypes["UnassignedInfoReason"] | undefined,
	in?: Array<GraphQLTypes["UnassignedInfoReason"]> | undefined,
	notIn?: Array<GraphQLTypes["UnassignedInfoReason"]> | undefined,
	lt?: GraphQLTypes["UnassignedInfoReason"] | undefined,
	lte?: GraphQLTypes["UnassignedInfoReason"] | undefined,
	gt?: GraphQLTypes["UnassignedInfoReason"] | undefined,
	gte?: GraphQLTypes["UnassignedInfoReason"] | undefined
};
	["UnassignedInfoReason"]: UnassignedInfoReason;
	["UnassignReasonWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	venues?: GraphQLTypes["VenueWhere"] | undefined,
	and?: Array<GraphQLTypes["UnassignReasonWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["UnassignReasonWhere"] | undefined> | undefined,
	not?: GraphQLTypes["UnassignReasonWhere"] | undefined
};
	["EmployeeQueueItemMetadataWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	totalMinutes?: GraphQLTypes["IntCondition"] | undefined,
	queueItem?: GraphQLTypes["EmployeeQueueItemWhere"] | undefined,
	includeInTipsCalculation?: GraphQLTypes["BooleanCondition"] | undefined,
	and?: Array<GraphQLTypes["EmployeeQueueItemMetadataWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["EmployeeQueueItemMetadataWhere"] | undefined> | undefined,
	not?: GraphQLTypes["EmployeeQueueItemMetadataWhere"] | undefined
};
	["TimetableEmployeeRoleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	shiftGroups?: GraphQLTypes["TimetableShiftGroupWhere"] | undefined,
	shiftsProfiles?: GraphQLTypes["ShiftsProfileWhere"] | undefined,
	shiftsManagers?: GraphQLTypes["ShiftsManagerWhere"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	timetableTemplates?: GraphQLTypes["TimetableTemplateWhere"] | undefined,
	color?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["TimetableEmployeeRoleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["TimetableEmployeeRoleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["TimetableEmployeeRoleWhere"] | undefined
};
	["ShiftsManagerWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	staff?: GraphQLTypes["StaffWhere"] | undefined,
	managedRoles?: GraphQLTypes["TimetableEmployeeRoleWhere"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	and?: Array<GraphQLTypes["ShiftsManagerWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ShiftsManagerWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ShiftsManagerWhere"] | undefined
};
	["TimetableTemplateWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	startDate?: GraphQLTypes["DateCondition"] | undefined,
	period?: GraphQLTypes["IntCondition"] | undefined,
	slots?: GraphQLTypes["IntCondition"] | undefined,
	position?: GraphQLTypes["TimetableShiftPositionWhere"] | undefined,
	staffOptions?: GraphQLTypes["TimetableTemplateStaffOptionsWhere"] | undefined,
	internalName?: GraphQLTypes["StringCondition"] | undefined,
	venue?: GraphQLTypes["VenueWhere"] | undefined,
	employeeRole?: GraphQLTypes["TimetableEmployeeRoleWhere"] | undefined,
	workdaysOnly?: GraphQLTypes["BooleanCondition"] | undefined,
	monday?: GraphQLTypes["BooleanCondition"] | undefined,
	tuesday?: GraphQLTypes["BooleanCondition"] | undefined,
	wednesday?: GraphQLTypes["BooleanCondition"] | undefined,
	thursday?: GraphQLTypes["BooleanCondition"] | undefined,
	friday?: GraphQLTypes["BooleanCondition"] | undefined,
	saturday?: GraphQLTypes["BooleanCondition"] | undefined,
	sunday?: GraphQLTypes["BooleanCondition"] | undefined,
	type?: GraphQLTypes["TemplateTypeCondition"] | undefined,
	and?: Array<GraphQLTypes["TimetableTemplateWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["TimetableTemplateWhere"] | undefined> | undefined,
	not?: GraphQLTypes["TimetableTemplateWhere"] | undefined
};
	["TimetableShiftPositionWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	start?: GraphQLTypes["StringCondition"] | undefined,
	end?: GraphQLTypes["StringCondition"] | undefined,
	shiftGroups?: GraphQLTypes["TimetableShiftGroupWhere"] | undefined,
	timetableTemplates?: GraphQLTypes["TimetableTemplateWhere"] | undefined,
	isDynamic?: GraphQLTypes["BooleanCondition"] | undefined,
	and?: Array<GraphQLTypes["TimetableShiftPositionWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["TimetableShiftPositionWhere"] | undefined> | undefined,
	not?: GraphQLTypes["TimetableShiftPositionWhere"] | undefined
};
	["TimetableTemplateStaffOptionsWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	startTime?: GraphQLTypes["StringCondition"] | undefined,
	endTime?: GraphQLTypes["StringCondition"] | undefined,
	timetableTemplate?: GraphQLTypes["TimetableTemplateWhere"] | undefined,
	autoAssignedEmployee?: GraphQLTypes["ShiftsProfileWhere"] | undefined,
	and?: Array<GraphQLTypes["TimetableTemplateStaffOptionsWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["TimetableTemplateStaffOptionsWhere"] | undefined> | undefined,
	not?: GraphQLTypes["TimetableTemplateStaffOptionsWhere"] | undefined
};
	["TemplateTypeCondition"]: {
		and?: Array<GraphQLTypes["TemplateTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["TemplateTypeCondition"]> | undefined,
	not?: GraphQLTypes["TemplateTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["TemplateType"] | undefined,
	notEq?: GraphQLTypes["TemplateType"] | undefined,
	in?: Array<GraphQLTypes["TemplateType"]> | undefined,
	notIn?: Array<GraphQLTypes["TemplateType"]> | undefined,
	lt?: GraphQLTypes["TemplateType"] | undefined,
	lte?: GraphQLTypes["TemplateType"] | undefined,
	gt?: GraphQLTypes["TemplateType"] | undefined,
	gte?: GraphQLTypes["TemplateType"] | undefined
};
	["TemplateType"]: TemplateType;
	["TimetableShiftSwapInfoWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	assigned?: GraphQLTypes["DateCondition"] | undefined,
	requested?: GraphQLTypes["BooleanCondition"] | undefined,
	confirmed?: GraphQLTypes["BooleanCondition"] | undefined,
	swappedShiftsProfile?: GraphQLTypes["ShiftsProfileWhere"] | undefined,
	shift?: GraphQLTypes["TimetableShiftWhere"] | undefined,
	and?: Array<GraphQLTypes["TimetableShiftSwapInfoWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["TimetableShiftSwapInfoWhere"] | undefined> | undefined,
	not?: GraphQLTypes["TimetableShiftSwapInfoWhere"] | undefined
};
	["TimetableDayNoteWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	note?: GraphQLTypes["StringCondition"] | undefined,
	day?: GraphQLTypes["TimetableDayWhere"] | undefined,
	role?: GraphQLTypes["TimetableEmployeeRoleWhere"] | undefined,
	and?: Array<GraphQLTypes["TimetableDayNoteWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["TimetableDayNoteWhere"] | undefined> | undefined,
	not?: GraphQLTypes["TimetableDayNoteWhere"] | undefined
};
	["TimetableDayMetadataWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	numberOfWorkers?: GraphQLTypes["IntCondition"] | undefined,
	tipsTotalCents?: GraphQLTypes["IntCondition"] | undefined,
	totalMinutes?: GraphQLTypes["IntCondition"] | undefined,
	tipsCentsPerMinute?: GraphQLTypes["FloatCondition"] | undefined,
	day?: GraphQLTypes["TimetableDayWhere"] | undefined,
	and?: Array<GraphQLTypes["TimetableDayMetadataWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["TimetableDayMetadataWhere"] | undefined> | undefined,
	not?: GraphQLTypes["TimetableDayMetadataWhere"] | undefined
};
	["FloatCondition"]: {
		and?: Array<GraphQLTypes["FloatCondition"]> | undefined,
	or?: Array<GraphQLTypes["FloatCondition"]> | undefined,
	not?: GraphQLTypes["FloatCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: number | undefined,
	notEq?: number | undefined,
	in?: Array<number> | undefined,
	notIn?: Array<number> | undefined,
	lt?: number | undefined,
	lte?: number | undefined,
	gt?: number | undefined,
	gte?: number | undefined
};
	["VenueEmployeeRoleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	employeePrivileges?: GraphQLTypes["TimetablesEmployeePrivilegesWhere"] | undefined,
	venue?: GraphQLTypes["VenueWhere"] | undefined,
	role?: GraphQLTypes["TimetableEmployeeRoleWhere"] | undefined,
	getsTipsShare?: GraphQLTypes["BooleanCondition"] | undefined,
	notesEnabled?: GraphQLTypes["BooleanCondition"] | undefined,
	and?: Array<GraphQLTypes["VenueEmployeeRoleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["VenueEmployeeRoleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["VenueEmployeeRoleWhere"] | undefined
};
	["TimetablesEmployeePrivilegesWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	venueEmployeeRole?: GraphQLTypes["VenueEmployeeRoleWhere"] | undefined,
	read?: GraphQLTypes["BooleanCondition"] | undefined,
	unassign?: GraphQLTypes["BooleanCondition"] | undefined,
	assign?: GraphQLTypes["BooleanCondition"] | undefined,
	and?: Array<GraphQLTypes["TimetablesEmployeePrivilegesWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["TimetablesEmployeePrivilegesWhere"] | undefined> | undefined,
	not?: GraphQLTypes["TimetablesEmployeePrivilegesWhere"] | undefined
};
	["PointOfSaleApplicationDeviceWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	internalName?: GraphQLTypes["StringCondition"] | undefined,
	note?: GraphQLTypes["StringCondition"] | undefined,
	venue?: GraphQLTypes["VenueWhere"] | undefined,
	identificationCode?: GraphQLTypes["IdentificationCodeWhere"] | undefined,
	identifier?: GraphQLTypes["DeviceIdentifierWhere"] | undefined,
	terminal?: GraphQLTypes["PointOfSaleTerminalWhere"] | undefined,
	receiptPrinter?: GraphQLTypes["PointOfSalePrinterWhere"] | undefined,
	ticketPrinters?: GraphQLTypes["PointOfSalePrinterWhere"] | undefined,
	and?: Array<GraphQLTypes["PointOfSaleApplicationDeviceWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PointOfSaleApplicationDeviceWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PointOfSaleApplicationDeviceWhere"] | undefined
};
	["IdentificationCodeWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	code?: GraphQLTypes["StringCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	attempts?: GraphQLTypes["IdentificationAttemptWhere"] | undefined,
	locales?: GraphQLTypes["IdentificationCodeLocaleWhere"] | undefined,
	internalName?: GraphQLTypes["StringCondition"] | undefined,
	applicationDevices?: GraphQLTypes["PointOfSaleApplicationDeviceWhere"] | undefined,
	and?: Array<GraphQLTypes["IdentificationCodeWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["IdentificationCodeWhere"] | undefined> | undefined,
	not?: GraphQLTypes["IdentificationCodeWhere"] | undefined
};
	["IdentificationAttemptWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	code?: GraphQLTypes["IdentificationCodeWhere"] | undefined,
	user?: GraphQLTypes["UserWhere"] | undefined,
	and?: Array<GraphQLTypes["IdentificationAttemptWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["IdentificationAttemptWhere"] | undefined> | undefined,
	not?: GraphQLTypes["IdentificationAttemptWhere"] | undefined
};
	["UserWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	internalNote?: GraphQLTypes["StringCondition"] | undefined,
	staff?: GraphQLTypes["StaffWhere"] | undefined,
	customer?: GraphQLTypes["CustomerWhere"] | undefined,
	tenantPersonId?: GraphQLTypes["UUIDCondition"] | undefined,
	disabledAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	devices?: GraphQLTypes["UserDeviceWhere"] | undefined,
	verifiedAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	email?: GraphQLTypes["StringCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	deletionRequestedAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	deletionExpectedAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	deletedAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	meta?: GraphQLTypes["UserMetadataWhere"] | undefined,
	identificationAttempts?: GraphQLTypes["IdentificationAttemptWhere"] | undefined,
	roles?: GraphQLTypes["UserRolesWhere"] | undefined,
	and?: Array<GraphQLTypes["UserWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["UserWhere"] | undefined> | undefined,
	not?: GraphQLTypes["UserWhere"] | undefined
};
	["UserDeviceWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	lastActiveAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	platform?: GraphQLTypes["StringCondition"] | undefined,
	deviceId?: GraphQLTypes["StringCondition"] | undefined,
	notificationsEnabled?: GraphQLTypes["BooleanCondition"] | undefined,
	user?: GraphQLTypes["UserWhere"] | undefined,
	appVersion?: GraphQLTypes["StringCondition"] | undefined,
	osVersion?: GraphQLTypes["StringCondition"] | undefined,
	apiVersion?: GraphQLTypes["StringCondition"] | undefined,
	anonymousSession?: GraphQLTypes["AnonymousSessionWhere"] | undefined,
	and?: Array<GraphQLTypes["UserDeviceWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["UserDeviceWhere"] | undefined> | undefined,
	not?: GraphQLTypes["UserDeviceWhere"] | undefined
};
	["AnonymousSessionWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	lastActiveAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	anonymousSessionKey?: GraphQLTypes["StringCondition"] | undefined,
	email?: GraphQLTypes["StringCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	internalNote?: GraphQLTypes["StringCondition"] | undefined,
	customer?: GraphQLTypes["CustomerWhere"] | undefined,
	devices?: GraphQLTypes["UserDeviceWhere"] | undefined,
	and?: Array<GraphQLTypes["AnonymousSessionWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["AnonymousSessionWhere"] | undefined> | undefined,
	not?: GraphQLTypes["AnonymousSessionWhere"] | undefined
};
	["UserMetadataWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	userProfileUrl?: GraphQLTypes["StringCondition"] | undefined,
	tenantEmail?: GraphQLTypes["StringCondition"] | undefined,
	tenantPersonId?: GraphQLTypes["UUIDCondition"] | undefined,
	tenantIdentityId?: GraphQLTypes["UUIDCondition"] | undefined,
	globalRoles?: GraphQLTypes["JsonCondition"] | undefined,
	projectRoles?: GraphQLTypes["JsonCondition"] | undefined,
	projectRolesString?: GraphQLTypes["StringCondition"] | undefined,
	externalIdentifiers?: GraphQLTypes["JsonCondition"] | undefined,
	externalIdentifiersString?: GraphQLTypes["StringCondition"] | undefined,
	idpSlugs?: GraphQLTypes["JsonCondition"] | undefined,
	idpSlugsString?: GraphQLTypes["StringCondition"] | undefined,
	user?: GraphQLTypes["UserWhere"] | undefined,
	and?: Array<GraphQLTypes["UserMetadataWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["UserMetadataWhere"] | undefined> | undefined,
	not?: GraphQLTypes["UserMetadataWhere"] | undefined
};
	["UserRolesWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	isCustomer?: GraphQLTypes["BooleanCondition"] | undefined,
	isStaff?: GraphQLTypes["BooleanCondition"] | undefined,
	isBartender?: GraphQLTypes["BooleanCondition"] | undefined,
	isCashier?: GraphQLTypes["BooleanCondition"] | undefined,
	isCourier?: GraphQLTypes["BooleanCondition"] | undefined,
	isCleaner?: GraphQLTypes["BooleanCondition"] | undefined,
	isShiftsManager?: GraphQLTypes["BooleanCondition"] | undefined,
	isInternalBuyer?: GraphQLTypes["BooleanCondition"] | undefined,
	isStocksManager?: GraphQLTypes["BooleanCondition"] | undefined,
	isCourierManager?: GraphQLTypes["BooleanCondition"] | undefined,
	isCashierManager?: GraphQLTypes["BooleanCondition"] | undefined,
	isBusinessToBusinessManager?: GraphQLTypes["BooleanCondition"] | undefined,
	isPicker?: GraphQLTypes["BooleanCondition"] | undefined,
	user?: GraphQLTypes["UserWhere"] | undefined,
	and?: Array<GraphQLTypes["UserRolesWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["UserRolesWhere"] | undefined> | undefined,
	not?: GraphQLTypes["UserRolesWhere"] | undefined
};
	["IdentificationCodeLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	successMessage?: GraphQLTypes["StringCondition"] | undefined,
	root?: GraphQLTypes["IdentificationCodeWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["IdentificationCodeLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["IdentificationCodeLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["IdentificationCodeLocaleWhere"] | undefined
};
	["DeviceIdentifierWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	internalName?: GraphQLTypes["StringCondition"] | undefined,
	device?: GraphQLTypes["PointOfSaleApplicationDeviceWhere"] | undefined,
	updatedAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	platform?: GraphQLTypes["StringCondition"] | undefined,
	resolution?: GraphQLTypes["StringCondition"] | undefined,
	devicePixelRatio?: GraphQLTypes["FloatCondition"] | undefined,
	updatedByUser?: GraphQLTypes["UserWhere"] | undefined,
	identifier?: GraphQLTypes["StringCondition"] | undefined,
	meta?: GraphQLTypes["DeviceIdentifierMetadataWhere"] | undefined,
	applicationVersionIdentifier?: GraphQLTypes["StringCondition"] | undefined,
	lastPointOfSaleSynchronizationErrorRawDetails?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["DeviceIdentifierWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["DeviceIdentifierWhere"] | undefined> | undefined,
	not?: GraphQLTypes["DeviceIdentifierWhere"] | undefined
};
	["DeviceIdentifierMetadataWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	prettyIdentifier?: GraphQLTypes["StringCondition"] | undefined,
	deviceIdentifier?: GraphQLTypes["DeviceIdentifierWhere"] | undefined,
	and?: Array<GraphQLTypes["DeviceIdentifierMetadataWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["DeviceIdentifierMetadataWhere"] | undefined> | undefined,
	not?: GraphQLTypes["DeviceIdentifierMetadataWhere"] | undefined
};
	["PointOfSaleTerminalWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	internalName?: GraphQLTypes["StringCondition"] | undefined,
	note?: GraphQLTypes["StringCondition"] | undefined,
	venue?: GraphQLTypes["VenueWhere"] | undefined,
	applicationDevices?: GraphQLTypes["PointOfSaleApplicationDeviceWhere"] | undefined,
	ipAddress?: GraphQLTypes["StringCondition"] | undefined,
	port?: GraphQLTypes["IntCondition"] | undefined,
	type?: GraphQLTypes["PointOfSaleTerminalTypeCondition"] | undefined,
	and?: Array<GraphQLTypes["PointOfSaleTerminalWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PointOfSaleTerminalWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PointOfSaleTerminalWhere"] | undefined
};
	["PointOfSaleTerminalTypeCondition"]: {
		and?: Array<GraphQLTypes["PointOfSaleTerminalTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["PointOfSaleTerminalTypeCondition"]> | undefined,
	not?: GraphQLTypes["PointOfSaleTerminalTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["PointOfSaleTerminalType"] | undefined,
	notEq?: GraphQLTypes["PointOfSaleTerminalType"] | undefined,
	in?: Array<GraphQLTypes["PointOfSaleTerminalType"]> | undefined,
	notIn?: Array<GraphQLTypes["PointOfSaleTerminalType"]> | undefined,
	lt?: GraphQLTypes["PointOfSaleTerminalType"] | undefined,
	lte?: GraphQLTypes["PointOfSaleTerminalType"] | undefined,
	gt?: GraphQLTypes["PointOfSaleTerminalType"] | undefined,
	gte?: GraphQLTypes["PointOfSaleTerminalType"] | undefined
};
	["PointOfSaleTerminalType"]: PointOfSaleTerminalType;
	["PointOfSalePrinterWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	internalName?: GraphQLTypes["StringCondition"] | undefined,
	note?: GraphQLTypes["StringCondition"] | undefined,
	ipAddress?: GraphQLTypes["StringCondition"] | undefined,
	applicationDevicesReceipt?: GraphQLTypes["PointOfSaleApplicationDeviceWhere"] | undefined,
	applicationDevicesTicket?: GraphQLTypes["PointOfSaleApplicationDeviceWhere"] | undefined,
	venue?: GraphQLTypes["VenueWhere"] | undefined,
	ticketCategories?: GraphQLTypes["PointOfSaleCategoryWhere"] | undefined,
	and?: Array<GraphQLTypes["PointOfSalePrinterWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PointOfSalePrinterWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PointOfSalePrinterWhere"] | undefined
};
	["PointOfSaleCategoryWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	slug?: GraphQLTypes["StringCondition"] | undefined,
	locales?: GraphQLTypes["PointOfSaleCategoryLocaleWhere"] | undefined,
	products?: GraphQLTypes["PointOfSaleCategoryProductWhere"] | undefined,
	category?: GraphQLTypes["ProductCategoryWhere"] | undefined,
	venue?: GraphQLTypes["VenueWhere"] | undefined,
	ticketPrinters?: GraphQLTypes["PointOfSalePrinterWhere"] | undefined,
	and?: Array<GraphQLTypes["PointOfSaleCategoryWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PointOfSaleCategoryWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PointOfSaleCategoryWhere"] | undefined
};
	["PointOfSaleCategoryLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	root?: GraphQLTypes["PointOfSaleCategoryWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["PointOfSaleCategoryLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PointOfSaleCategoryLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PointOfSaleCategoryLocaleWhere"] | undefined
};
	["PointOfSaleCategoryProductWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	category?: GraphQLTypes["PointOfSaleCategoryWhere"] | undefined,
	product?: GraphQLTypes["ProductWhere"] | undefined,
	locales?: GraphQLTypes["PointOfSaleCategoryProductLocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["PointOfSaleCategoryProductWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PointOfSaleCategoryProductWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PointOfSaleCategoryProductWhere"] | undefined
};
	["PointOfSaleCategoryProductLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	root?: GraphQLTypes["PointOfSaleCategoryProductWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["PointOfSaleCategoryProductLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PointOfSaleCategoryProductLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PointOfSaleCategoryProductLocaleWhere"] | undefined
};
	["ProductCategoryWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	code?: GraphQLTypes["StringCondition"] | undefined,
	products?: GraphQLTypes["ProductWhere"] | undefined,
	tags?: GraphQLTypes["TagWhere"] | undefined,
	parent?: GraphQLTypes["ProductCategoryWhere"] | undefined,
	children?: GraphQLTypes["ProductCategoryWhere"] | undefined,
	description?: GraphQLTypes["StringCondition"] | undefined,
	internalNote?: GraphQLTypes["StringCondition"] | undefined,
	color?: GraphQLTypes["StringCondition"] | undefined,
	image?: GraphQLTypes["ImageWhere"] | undefined,
	order?: GraphQLTypes["FloatCondition"] | undefined,
	descendants?: GraphQLTypes["ProductCategoryTreeWhere"] | undefined,
	ancestors?: GraphQLTypes["ProductCategoryTreeWhere"] | undefined,
	inheritedTags?: GraphQLTypes["InheritedProductCategoryTagWhere"] | undefined,
	nestedProducts?: GraphQLTypes["NestedProductCategoryProductWhere"] | undefined,
	and?: Array<GraphQLTypes["ProductCategoryWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ProductCategoryWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ProductCategoryWhere"] | undefined
};
	["ProductCategoryTreeWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	depth?: GraphQLTypes["IntCondition"] | undefined,
	ancestor?: GraphQLTypes["ProductCategoryWhere"] | undefined,
	descendant?: GraphQLTypes["ProductCategoryWhere"] | undefined,
	and?: Array<GraphQLTypes["ProductCategoryTreeWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ProductCategoryTreeWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ProductCategoryTreeWhere"] | undefined
};
	["InheritedProductCategoryTagWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	depth?: GraphQLTypes["IntCondition"] | undefined,
	productCategory?: GraphQLTypes["ProductCategoryWhere"] | undefined,
	tag?: GraphQLTypes["TagWhere"] | undefined,
	and?: Array<GraphQLTypes["InheritedProductCategoryTagWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["InheritedProductCategoryTagWhere"] | undefined> | undefined,
	not?: GraphQLTypes["InheritedProductCategoryTagWhere"] | undefined
};
	["NestedProductCategoryProductWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	depth?: GraphQLTypes["IntCondition"] | undefined,
	product?: GraphQLTypes["ProductWhere"] | undefined,
	productCategory?: GraphQLTypes["ProductCategoryWhere"] | undefined,
	and?: Array<GraphQLTypes["NestedProductCategoryProductWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["NestedProductCategoryProductWhere"] | undefined> | undefined,
	not?: GraphQLTypes["NestedProductCategoryProductWhere"] | undefined
};
	["OrderWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	state?: GraphQLTypes["OrderStateCondition"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	canceledAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	note?: GraphQLTypes["StringCondition"] | undefined,
	customer?: GraphQLTypes["CustomerWhere"] | undefined,
	channel?: GraphQLTypes["ChannelWhere"] | undefined,
	discounts?: GraphQLTypes["OrderDiscountWhere"] | undefined,
	delivery?: GraphQLTypes["OrderDeliveryWhere"] | undefined,
	items?: GraphQLTypes["OrderItemWhere"] | undefined,
	internalNote?: GraphQLTypes["StringCondition"] | undefined,
	cart?: GraphQLTypes["CartWhere"] | undefined,
	events?: GraphQLTypes["OrderEventWhere"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	billingAddress?: GraphQLTypes["AddressWhere"] | undefined,
	priceLines?: GraphQLTypes["OrderPriceLineWhere"] | undefined,
	payments?: GraphQLTypes["OrderPaymentWhere"] | undefined,
	seq?: GraphQLTypes["IntCondition"] | undefined,
	billingSubject?: GraphQLTypes["BillingSubjectWhere"] | undefined,
	summary?: GraphQLTypes["OrderSummaryWhere"] | undefined,
	doubleshotLegacyId?: GraphQLTypes["StringCondition"] | undefined,
	gratuity?: GraphQLTypes["GratuityWhere"] | undefined,
	venue?: GraphQLTypes["VenueWhere"] | undefined,
	fulfillmentNote?: GraphQLTypes["StringCondition"] | undefined,
	fulfillmentNotes?: GraphQLTypes["FulfillmentNoteWhere"] | undefined,
	doubleshotTotalWeightGrams?: GraphQLTypes["IntCondition"] | undefined,
	doubleShotLegacyNumber?: GraphQLTypes["StringCondition"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	doubleshotAdminUrl?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["OrderWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["OrderWhere"] | undefined> | undefined,
	not?: GraphQLTypes["OrderWhere"] | undefined
};
	["OrderStateCondition"]: {
		and?: Array<GraphQLTypes["OrderStateCondition"]> | undefined,
	or?: Array<GraphQLTypes["OrderStateCondition"]> | undefined,
	not?: GraphQLTypes["OrderStateCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["OrderState"] | undefined,
	notEq?: GraphQLTypes["OrderState"] | undefined,
	in?: Array<GraphQLTypes["OrderState"]> | undefined,
	notIn?: Array<GraphQLTypes["OrderState"]> | undefined,
	lt?: GraphQLTypes["OrderState"] | undefined,
	lte?: GraphQLTypes["OrderState"] | undefined,
	gt?: GraphQLTypes["OrderState"] | undefined,
	gte?: GraphQLTypes["OrderState"] | undefined
};
	["OrderState"]: OrderState;
	["OrderDiscountWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	discountCents?: GraphQLTypes["IntCondition"] | undefined,
	vatRate?: GraphQLTypes["VatRateWhere"] | undefined,
	order?: GraphQLTypes["OrderWhere"] | undefined,
	description?: GraphQLTypes["StringCondition"] | undefined,
	type?: GraphQLTypes["OrderDiscountTypeCondition"] | undefined,
	customerCreditTransactions?: GraphQLTypes["CustomerCreditTransactionWhere"] | undefined,
	voucherRedemption?: GraphQLTypes["VoucherRedemptionWhere"] | undefined,
	and?: Array<GraphQLTypes["OrderDiscountWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["OrderDiscountWhere"] | undefined> | undefined,
	not?: GraphQLTypes["OrderDiscountWhere"] | undefined
};
	["OrderDiscountTypeCondition"]: {
		and?: Array<GraphQLTypes["OrderDiscountTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["OrderDiscountTypeCondition"]> | undefined,
	not?: GraphQLTypes["OrderDiscountTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["OrderDiscountType"] | undefined,
	notEq?: GraphQLTypes["OrderDiscountType"] | undefined,
	in?: Array<GraphQLTypes["OrderDiscountType"]> | undefined,
	notIn?: Array<GraphQLTypes["OrderDiscountType"]> | undefined,
	lt?: GraphQLTypes["OrderDiscountType"] | undefined,
	lte?: GraphQLTypes["OrderDiscountType"] | undefined,
	gt?: GraphQLTypes["OrderDiscountType"] | undefined,
	gte?: GraphQLTypes["OrderDiscountType"] | undefined
};
	["OrderDiscountType"]: OrderDiscountType;
	["CustomerCreditTransactionWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	amountCents?: GraphQLTypes["IntCondition"] | undefined,
	customerCredit?: GraphQLTypes["CustomerCreditWhere"] | undefined,
	orderDiscount?: GraphQLTypes["OrderDiscountWhere"] | undefined,
	virtualProductEffect?: GraphQLTypes["VirtualProductEffectWhere"] | undefined,
	and?: Array<GraphQLTypes["CustomerCreditTransactionWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["CustomerCreditTransactionWhere"] | undefined> | undefined,
	not?: GraphQLTypes["CustomerCreditTransactionWhere"] | undefined
};
	["CustomerCreditWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	initialCreditCents?: GraphQLTypes["IntCondition"] | undefined,
	remainingCreditsCents?: GraphQLTypes["IntCondition"] | undefined,
	expiresAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	reason?: GraphQLTypes["StringCondition"] | undefined,
	customer?: GraphQLTypes["CustomerWhere"] | undefined,
	vatRate?: GraphQLTypes["VatRateWhere"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	transactions?: GraphQLTypes["CustomerCreditTransactionWhere"] | undefined,
	voucherRedemption?: GraphQLTypes["VoucherRedemptionWhere"] | undefined,
	invoiceUrl?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["CustomerCreditWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["CustomerCreditWhere"] | undefined> | undefined,
	not?: GraphQLTypes["CustomerCreditWhere"] | undefined
};
	["VoucherRedemptionWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	note?: GraphQLTypes["StringCondition"] | undefined,
	manualRedemptionNote?: GraphQLTypes["StringCondition"] | undefined,
	customerCredit?: GraphQLTypes["CustomerCreditWhere"] | undefined,
	orderDiscount?: GraphQLTypes["OrderDiscountWhere"] | undefined,
	voucher?: GraphQLTypes["VoucherWhere"] | undefined,
	customer?: GraphQLTypes["CustomerWhere"] | undefined,
	and?: Array<GraphQLTypes["VoucherRedemptionWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["VoucherRedemptionWhere"] | undefined> | undefined,
	not?: GraphQLTypes["VoucherRedemptionWhere"] | undefined
};
	["VoucherWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	activatedAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	expiresAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	internalNote?: GraphQLTypes["StringCondition"] | undefined,
	note?: GraphQLTypes["StringCondition"] | undefined,
	code?: GraphQLTypes["StringCondition"] | undefined,
	type?: GraphQLTypes["VoucherTypeCondition"] | undefined,
	creditCents?: GraphQLTypes["IntCondition"] | undefined,
	buyer?: GraphQLTypes["CustomerWhere"] | undefined,
	owner?: GraphQLTypes["CustomerWhere"] | undefined,
	vatRate?: GraphQLTypes["VatRateWhere"] | undefined,
	virtualProductEffect?: GraphQLTypes["VirtualProductEffectWhere"] | undefined,
	redemption?: GraphQLTypes["VoucherRedemptionWhere"] | undefined,
	and?: Array<GraphQLTypes["VoucherWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["VoucherWhere"] | undefined> | undefined,
	not?: GraphQLTypes["VoucherWhere"] | undefined
};
	["VoucherTypeCondition"]: {
		and?: Array<GraphQLTypes["VoucherTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["VoucherTypeCondition"]> | undefined,
	not?: GraphQLTypes["VoucherTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["VoucherType"] | undefined,
	notEq?: GraphQLTypes["VoucherType"] | undefined,
	in?: Array<GraphQLTypes["VoucherType"]> | undefined,
	notIn?: Array<GraphQLTypes["VoucherType"]> | undefined,
	lt?: GraphQLTypes["VoucherType"] | undefined,
	lte?: GraphQLTypes["VoucherType"] | undefined,
	gt?: GraphQLTypes["VoucherType"] | undefined,
	gte?: GraphQLTypes["VoucherType"] | undefined
};
	["VoucherType"]: VoucherType;
	["VirtualProductEffectWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	succeededAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	orderItem?: GraphQLTypes["OrderItemWhere"] | undefined,
	failedAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	revertedAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	resultCustomerCreditTransaction?: GraphQLTypes["CustomerCreditTransactionWhere"] | undefined,
	resultVouchers?: GraphQLTypes["VoucherWhere"] | undefined,
	and?: Array<GraphQLTypes["VirtualProductEffectWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["VirtualProductEffectWhere"] | undefined> | undefined,
	not?: GraphQLTypes["VirtualProductEffectWhere"] | undefined
};
	["OrderItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	unitPriceCents?: GraphQLTypes["IntCondition"] | undefined,
	quantity?: GraphQLTypes["IntCondition"] | undefined,
	vatRate?: GraphQLTypes["VatRateWhere"] | undefined,
	order?: GraphQLTypes["OrderWhere"] | undefined,
	virtualProductEffects?: GraphQLTypes["VirtualProductEffectWhere"] | undefined,
	pickedAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	note?: GraphQLTypes["StringCondition"] | undefined,
	fulfillmentNotes?: GraphQLTypes["FulfillmentNoteWhere"] | undefined,
	product?: GraphQLTypes["ProductWhere"] | undefined,
	and?: Array<GraphQLTypes["OrderItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["OrderItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["OrderItemWhere"] | undefined
};
	["OrderEventWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	type?: GraphQLTypes["StringCondition"] | undefined,
	data?: GraphQLTypes["StringCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	order?: GraphQLTypes["OrderWhere"] | undefined,
	payment?: GraphQLTypes["OrderPaymentWhere"] | undefined,
	delivery?: GraphQLTypes["OrderDeliveryWhere"] | undefined,
	and?: Array<GraphQLTypes["OrderEventWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["OrderEventWhere"] | undefined> | undefined,
	not?: GraphQLTypes["OrderEventWhere"] | undefined
};
	["OrderPaymentWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	data?: GraphQLTypes["JsonCondition"] | undefined,
	paymentCents?: GraphQLTypes["IntCondition"] | undefined,
	method?: GraphQLTypes["PaymentMethodWhere"] | undefined,
	failedAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	state?: GraphQLTypes["OrderPaymentStateCondition"] | undefined,
	approvedAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	events?: GraphQLTypes["OrderEventWhere"] | undefined,
	order?: GraphQLTypes["OrderWhere"] | undefined,
	invoice?: GraphQLTypes["InvoiceWhere"] | undefined,
	walletType?: GraphQLTypes["StringCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	publicReceiptUrl?: GraphQLTypes["StringCondition"] | undefined,
	priceCents?: GraphQLTypes["IntCondition"] | undefined,
	vatRate?: GraphQLTypes["VatRateWhere"] | undefined,
	meta?: GraphQLTypes["OrderPaymentMetadataWhere"] | undefined,
	otherCurrencyPriceCents?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["OrderPaymentWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["OrderPaymentWhere"] | undefined> | undefined,
	not?: GraphQLTypes["OrderPaymentWhere"] | undefined
};
	["OrderPaymentStateCondition"]: {
		and?: Array<GraphQLTypes["OrderPaymentStateCondition"]> | undefined,
	or?: Array<GraphQLTypes["OrderPaymentStateCondition"]> | undefined,
	not?: GraphQLTypes["OrderPaymentStateCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["OrderPaymentState"] | undefined,
	notEq?: GraphQLTypes["OrderPaymentState"] | undefined,
	in?: Array<GraphQLTypes["OrderPaymentState"]> | undefined,
	notIn?: Array<GraphQLTypes["OrderPaymentState"]> | undefined,
	lt?: GraphQLTypes["OrderPaymentState"] | undefined,
	lte?: GraphQLTypes["OrderPaymentState"] | undefined,
	gt?: GraphQLTypes["OrderPaymentState"] | undefined,
	gte?: GraphQLTypes["OrderPaymentState"] | undefined
};
	["OrderPaymentState"]: OrderPaymentState;
	["InvoiceWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	publicKey?: GraphQLTypes["StringCondition"] | undefined,
	fakturoidId?: GraphQLTypes["StringCondition"] | undefined,
	fakturoidData?: GraphQLTypes["StringCondition"] | undefined,
	legacyUrl?: GraphQLTypes["StringCondition"] | undefined,
	customer?: GraphQLTypes["CustomerWhere"] | undefined,
	orderPayments?: GraphQLTypes["OrderPaymentWhere"] | undefined,
	address?: GraphQLTypes["AddressWhere"] | undefined,
	publicUrl?: GraphQLTypes["StringCondition"] | undefined,
	billingSubject?: GraphQLTypes["BillingSubjectWhere"] | undefined,
	and?: Array<GraphQLTypes["InvoiceWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["InvoiceWhere"] | undefined> | undefined,
	not?: GraphQLTypes["InvoiceWhere"] | undefined
};
	["BillingSubjectWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	fullName?: GraphQLTypes["StringCondition"] | undefined,
	addressLine1?: GraphQLTypes["StringCondition"] | undefined,
	addressLine2?: GraphQLTypes["StringCondition"] | undefined,
	city?: GraphQLTypes["StringCondition"] | undefined,
	postalCode?: GraphQLTypes["StringCondition"] | undefined,
	email?: GraphQLTypes["StringCondition"] | undefined,
	phone?: GraphQLTypes["StringCondition"] | undefined,
	companyName?: GraphQLTypes["StringCondition"] | undefined,
	companyIdentifier?: GraphQLTypes["StringCondition"] | undefined,
	vatIdentifier?: GraphQLTypes["StringCondition"] | undefined,
	externalIdentifier?: GraphQLTypes["StringCondition"] | undefined,
	hidden?: GraphQLTypes["BooleanCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	deletedAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	note?: GraphQLTypes["StringCondition"] | undefined,
	internalNote?: GraphQLTypes["StringCondition"] | undefined,
	fakturoidSubjectId?: GraphQLTypes["StringCondition"] | undefined,
	country?: GraphQLTypes["CountryWhere"] | undefined,
	customer?: GraphQLTypes["CustomerWhere"] | undefined,
	invoices?: GraphQLTypes["InvoiceWhere"] | undefined,
	defaultBillingSubjectOfCustomer?: GraphQLTypes["CustomerWhere"] | undefined,
	orders?: GraphQLTypes["OrderWhere"] | undefined,
	and?: Array<GraphQLTypes["BillingSubjectWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["BillingSubjectWhere"] | undefined> | undefined,
	not?: GraphQLTypes["BillingSubjectWhere"] | undefined
};
	["CountryWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	code?: GraphQLTypes["StringCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	and?: Array<GraphQLTypes["CountryWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["CountryWhere"] | undefined> | undefined,
	not?: GraphQLTypes["CountryWhere"] | undefined
};
	["OrderPaymentMetadataWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	paymentUrl?: GraphQLTypes["StringCondition"] | undefined,
	orderPayment?: GraphQLTypes["OrderPaymentWhere"] | undefined,
	and?: Array<GraphQLTypes["OrderPaymentMetadataWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["OrderPaymentMetadataWhere"] | undefined> | undefined,
	not?: GraphQLTypes["OrderPaymentMetadataWhere"] | undefined
};
	["OrderPriceLineWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	unitPriceCents?: GraphQLTypes["IntCondition"] | undefined,
	quantity?: GraphQLTypes["IntCondition"] | undefined,
	type?: GraphQLTypes["OrderPriceLineTypeCondition"] | undefined,
	orderItem?: GraphQLTypes["OrderItemWhere"] | undefined,
	orderDiscount?: GraphQLTypes["OrderDiscountWhere"] | undefined,
	orderPayment?: GraphQLTypes["OrderPaymentWhere"] | undefined,
	orderDelivery?: GraphQLTypes["OrderDeliveryWhere"] | undefined,
	vatRatePermille?: GraphQLTypes["IntCondition"] | undefined,
	vatRate?: GraphQLTypes["VatRateWhere"] | undefined,
	order?: GraphQLTypes["OrderWhere"] | undefined,
	and?: Array<GraphQLTypes["OrderPriceLineWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["OrderPriceLineWhere"] | undefined> | undefined,
	not?: GraphQLTypes["OrderPriceLineWhere"] | undefined
};
	["OrderPriceLineTypeCondition"]: {
		and?: Array<GraphQLTypes["OrderPriceLineTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["OrderPriceLineTypeCondition"]> | undefined,
	not?: GraphQLTypes["OrderPriceLineTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["OrderPriceLineType"] | undefined,
	notEq?: GraphQLTypes["OrderPriceLineType"] | undefined,
	in?: Array<GraphQLTypes["OrderPriceLineType"]> | undefined,
	notIn?: Array<GraphQLTypes["OrderPriceLineType"]> | undefined,
	lt?: GraphQLTypes["OrderPriceLineType"] | undefined,
	lte?: GraphQLTypes["OrderPriceLineType"] | undefined,
	gt?: GraphQLTypes["OrderPriceLineType"] | undefined,
	gte?: GraphQLTypes["OrderPriceLineType"] | undefined
};
	["OrderPriceLineType"]: OrderPriceLineType;
	["OrderSummaryWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	totalPriceCents?: GraphQLTypes["IntCondition"] | undefined,
	discountPriceCents?: GraphQLTypes["IntCondition"] | undefined,
	undiscountedPriceCents?: GraphQLTypes["IntCondition"] | undefined,
	itemsQuantity?: GraphQLTypes["IntCondition"] | undefined,
	orderUrl?: GraphQLTypes["StringCondition"] | undefined,
	orderNumber?: GraphQLTypes["StringCondition"] | undefined,
	order?: GraphQLTypes["OrderWhere"] | undefined,
	and?: Array<GraphQLTypes["OrderSummaryWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["OrderSummaryWhere"] | undefined> | undefined,
	not?: GraphQLTypes["OrderSummaryWhere"] | undefined
};
	["GratuityWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	amountCents?: GraphQLTypes["IntCondition"] | undefined,
	order?: GraphQLTypes["OrderWhere"] | undefined,
	and?: Array<GraphQLTypes["GratuityWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["GratuityWhere"] | undefined> | undefined,
	not?: GraphQLTypes["GratuityWhere"] | undefined
};
	["AreaWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	venue?: GraphQLTypes["VenueWhere"] | undefined,
	tables?: GraphQLTypes["TableWhere"] | undefined,
	lines?: GraphQLTypes["LineWhere"] | undefined,
	and?: Array<GraphQLTypes["AreaWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["AreaWhere"] | undefined> | undefined,
	not?: GraphQLTypes["AreaWhere"] | undefined
};
	["TableWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	shape?: GraphQLTypes["TableShapeCondition"] | undefined,
	width?: GraphQLTypes["IntCondition"] | undefined,
	height?: GraphQLTypes["IntCondition"] | undefined,
	positionX?: GraphQLTypes["IntCondition"] | undefined,
	positionY?: GraphQLTypes["IntCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	color?: GraphQLTypes["StringCondition"] | undefined,
	customerTabs?: GraphQLTypes["CustomerTabWhere"] | undefined,
	area?: GraphQLTypes["AreaWhere"] | undefined,
	seats?: GraphQLTypes["SeatWhere"] | undefined,
	and?: Array<GraphQLTypes["TableWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["TableWhere"] | undefined> | undefined,
	not?: GraphQLTypes["TableWhere"] | undefined
};
	["TableShapeCondition"]: {
		and?: Array<GraphQLTypes["TableShapeCondition"]> | undefined,
	or?: Array<GraphQLTypes["TableShapeCondition"]> | undefined,
	not?: GraphQLTypes["TableShapeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["TableShape"] | undefined,
	notEq?: GraphQLTypes["TableShape"] | undefined,
	in?: Array<GraphQLTypes["TableShape"]> | undefined,
	notIn?: Array<GraphQLTypes["TableShape"]> | undefined,
	lt?: GraphQLTypes["TableShape"] | undefined,
	lte?: GraphQLTypes["TableShape"] | undefined,
	gt?: GraphQLTypes["TableShape"] | undefined,
	gte?: GraphQLTypes["TableShape"] | undefined
};
	["TableShape"]: TableShape;
	["CustomerTabWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	color?: GraphQLTypes["StringCondition"] | undefined,
	items?: GraphQLTypes["CustomerTabItemWhere"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	meta?: GraphQLTypes["CustomerTabMetadataWhere"] | undefined,
	customer?: GraphQLTypes["CustomerWhere"] | undefined,
	table?: GraphQLTypes["TableWhere"] | undefined,
	seat?: GraphQLTypes["SeatWhere"] | undefined,
	and?: Array<GraphQLTypes["CustomerTabWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["CustomerTabWhere"] | undefined> | undefined,
	not?: GraphQLTypes["CustomerTabWhere"] | undefined
};
	["CustomerTabItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	addedAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	tab?: GraphQLTypes["CustomerTabWhere"] | undefined,
	product?: GraphQLTypes["ProductWhere"] | undefined,
	paidAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	and?: Array<GraphQLTypes["CustomerTabItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["CustomerTabItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["CustomerTabItemWhere"] | undefined
};
	["CustomerTabMetadataWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	totalPriceCents?: GraphQLTypes["IntCondition"] | undefined,
	totalSpentCents?: GraphQLTypes["IntCondition"] | undefined,
	unpaidCents?: GraphQLTypes["IntCondition"] | undefined,
	customerTab?: GraphQLTypes["CustomerTabWhere"] | undefined,
	and?: Array<GraphQLTypes["CustomerTabMetadataWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["CustomerTabMetadataWhere"] | undefined> | undefined,
	not?: GraphQLTypes["CustomerTabMetadataWhere"] | undefined
};
	["SeatWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	positionX?: GraphQLTypes["IntCondition"] | undefined,
	positionY?: GraphQLTypes["IntCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	color?: GraphQLTypes["StringCondition"] | undefined,
	customerTabs?: GraphQLTypes["CustomerTabWhere"] | undefined,
	table?: GraphQLTypes["TableWhere"] | undefined,
	and?: Array<GraphQLTypes["SeatWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["SeatWhere"] | undefined> | undefined,
	not?: GraphQLTypes["SeatWhere"] | undefined
};
	["LineWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	positionStartX?: GraphQLTypes["IntCondition"] | undefined,
	positionStartY?: GraphQLTypes["IntCondition"] | undefined,
	positionEndX?: GraphQLTypes["IntCondition"] | undefined,
	positionEndY?: GraphQLTypes["IntCondition"] | undefined,
	area?: GraphQLTypes["AreaWhere"] | undefined,
	and?: Array<GraphQLTypes["LineWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["LineWhere"] | undefined> | undefined,
	not?: GraphQLTypes["LineWhere"] | undefined
};
	["PointOfSaleInitialViewCondition"]: {
		and?: Array<GraphQLTypes["PointOfSaleInitialViewCondition"]> | undefined,
	or?: Array<GraphQLTypes["PointOfSaleInitialViewCondition"]> | undefined,
	not?: GraphQLTypes["PointOfSaleInitialViewCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["PointOfSaleInitialView"] | undefined,
	notEq?: GraphQLTypes["PointOfSaleInitialView"] | undefined,
	in?: Array<GraphQLTypes["PointOfSaleInitialView"]> | undefined,
	notIn?: Array<GraphQLTypes["PointOfSaleInitialView"]> | undefined,
	lt?: GraphQLTypes["PointOfSaleInitialView"] | undefined,
	lte?: GraphQLTypes["PointOfSaleInitialView"] | undefined,
	gt?: GraphQLTypes["PointOfSaleInitialView"] | undefined,
	gte?: GraphQLTypes["PointOfSaleInitialView"] | undefined
};
	["PointOfSaleInitialView"]: PointOfSaleInitialView;
	["CartStateCondition"]: {
		and?: Array<GraphQLTypes["CartStateCondition"]> | undefined,
	or?: Array<GraphQLTypes["CartStateCondition"]> | undefined,
	not?: GraphQLTypes["CartStateCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["CartState"] | undefined,
	notEq?: GraphQLTypes["CartState"] | undefined,
	in?: Array<GraphQLTypes["CartState"]> | undefined,
	notIn?: Array<GraphQLTypes["CartState"]> | undefined,
	lt?: GraphQLTypes["CartState"] | undefined,
	lte?: GraphQLTypes["CartState"] | undefined,
	gt?: GraphQLTypes["CartState"] | undefined,
	gte?: GraphQLTypes["CartState"] | undefined
};
	["CartState"]: CartState;
	["CartPriceLineWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	type?: GraphQLTypes["CartPriceLineTypeCondition"] | undefined,
	item?: GraphQLTypes["CartItemWhere"] | undefined,
	product?: GraphQLTypes["ProductWhere"] | undefined,
	unitPriceCents?: GraphQLTypes["IntCondition"] | undefined,
	priceCents?: GraphQLTypes["IntCondition"] | undefined,
	quantity?: GraphQLTypes["IntCondition"] | undefined,
	vatRatePermille?: GraphQLTypes["IntCondition"] | undefined,
	vatRate?: GraphQLTypes["VatRateWhere"] | undefined,
	cart?: GraphQLTypes["CartWhere"] | undefined,
	and?: Array<GraphQLTypes["CartPriceLineWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["CartPriceLineWhere"] | undefined> | undefined,
	not?: GraphQLTypes["CartPriceLineWhere"] | undefined
};
	["CartPriceLineTypeCondition"]: {
		and?: Array<GraphQLTypes["CartPriceLineTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["CartPriceLineTypeCondition"]> | undefined,
	not?: GraphQLTypes["CartPriceLineTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["CartPriceLineType"] | undefined,
	notEq?: GraphQLTypes["CartPriceLineType"] | undefined,
	in?: Array<GraphQLTypes["CartPriceLineType"]> | undefined,
	notIn?: Array<GraphQLTypes["CartPriceLineType"]> | undefined,
	lt?: GraphQLTypes["CartPriceLineType"] | undefined,
	lte?: GraphQLTypes["CartPriceLineType"] | undefined,
	gt?: GraphQLTypes["CartPriceLineType"] | undefined,
	gte?: GraphQLTypes["CartPriceLineType"] | undefined
};
	["CartPriceLineType"]: CartPriceLineType;
	["CartSummaryWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	itemsPriceCents?: GraphQLTypes["IntCondition"] | undefined,
	deliveryPriceCents?: GraphQLTypes["IntCondition"] | undefined,
	totalPriceCents?: GraphQLTypes["IntCondition"] | undefined,
	itemsCount?: GraphQLTypes["IntCondition"] | undefined,
	itemsQuantity?: GraphQLTypes["IntCondition"] | undefined,
	checkoutUrl?: GraphQLTypes["StringCondition"] | undefined,
	cart?: GraphQLTypes["CartWhere"] | undefined,
	and?: Array<GraphQLTypes["CartSummaryWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["CartSummaryWhere"] | undefined> | undefined,
	not?: GraphQLTypes["CartSummaryWhere"] | undefined
};
	["ChannelCodeCondition"]: {
		and?: Array<GraphQLTypes["ChannelCodeCondition"]> | undefined,
	or?: Array<GraphQLTypes["ChannelCodeCondition"]> | undefined,
	not?: GraphQLTypes["ChannelCodeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["ChannelCode"] | undefined,
	notEq?: GraphQLTypes["ChannelCode"] | undefined,
	in?: Array<GraphQLTypes["ChannelCode"]> | undefined,
	notIn?: Array<GraphQLTypes["ChannelCode"]> | undefined,
	lt?: GraphQLTypes["ChannelCode"] | undefined,
	lte?: GraphQLTypes["ChannelCode"] | undefined,
	gt?: GraphQLTypes["ChannelCode"] | undefined,
	gte?: GraphQLTypes["ChannelCode"] | undefined
};
	["ChannelCode"]: ChannelCode;
	["VatRatePresetCondition"]: {
		and?: Array<GraphQLTypes["VatRatePresetCondition"]> | undefined,
	or?: Array<GraphQLTypes["VatRatePresetCondition"]> | undefined,
	not?: GraphQLTypes["VatRatePresetCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["VatRatePreset"] | undefined,
	notEq?: GraphQLTypes["VatRatePreset"] | undefined,
	in?: Array<GraphQLTypes["VatRatePreset"]> | undefined,
	notIn?: Array<GraphQLTypes["VatRatePreset"]> | undefined,
	lt?: GraphQLTypes["VatRatePreset"] | undefined,
	lte?: GraphQLTypes["VatRatePreset"] | undefined,
	gt?: GraphQLTypes["VatRatePreset"] | undefined,
	gte?: GraphQLTypes["VatRatePreset"] | undefined
};
	["VatRatePreset"]: VatRatePreset;
	["OrderDeliveryStateCondition"]: {
		and?: Array<GraphQLTypes["OrderDeliveryStateCondition"]> | undefined,
	or?: Array<GraphQLTypes["OrderDeliveryStateCondition"]> | undefined,
	not?: GraphQLTypes["OrderDeliveryStateCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["OrderDeliveryState"] | undefined,
	notEq?: GraphQLTypes["OrderDeliveryState"] | undefined,
	in?: Array<GraphQLTypes["OrderDeliveryState"]> | undefined,
	notIn?: Array<GraphQLTypes["OrderDeliveryState"]> | undefined,
	lt?: GraphQLTypes["OrderDeliveryState"] | undefined,
	lte?: GraphQLTypes["OrderDeliveryState"] | undefined,
	gt?: GraphQLTypes["OrderDeliveryState"] | undefined,
	gte?: GraphQLTypes["OrderDeliveryState"] | undefined
};
	["OrderDeliveryState"]: OrderDeliveryState;
	["LiftagoRideWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	liftagoId?: GraphQLTypes["StringCondition"] | undefined,
	data?: GraphQLTypes["StringCondition"] | undefined,
	updatedAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	delivery?: GraphQLTypes["OrderDeliveryWhere"] | undefined,
	and?: Array<GraphQLTypes["LiftagoRideWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["LiftagoRideWhere"] | undefined> | undefined,
	not?: GraphQLTypes["LiftagoRideWhere"] | undefined
};
	["WoltDriveDeliveryWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	state?: GraphQLTypes["WoltDriveDeliveryStateCondition"] | undefined,
	shipmentPromiseId?: GraphQLTypes["StringCondition"] | undefined,
	deliveryPrice?: GraphQLTypes["IntCondition"] | undefined,
	deliveryPriceCurrency?: GraphQLTypes["StringCondition"] | undefined,
	shipmentPromiseResponse?: GraphQLTypes["StringCondition"] | undefined,
	deliveryOrderId?: GraphQLTypes["StringCondition"] | undefined,
	trackingUrl?: GraphQLTypes["StringCondition"] | undefined,
	deliverOrderResponse?: GraphQLTypes["StringCondition"] | undefined,
	delivery?: GraphQLTypes["OrderDeliveryWhere"] | undefined,
	and?: Array<GraphQLTypes["WoltDriveDeliveryWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["WoltDriveDeliveryWhere"] | undefined> | undefined,
	not?: GraphQLTypes["WoltDriveDeliveryWhere"] | undefined
};
	["WoltDriveDeliveryStateCondition"]: {
		and?: Array<GraphQLTypes["WoltDriveDeliveryStateCondition"]> | undefined,
	or?: Array<GraphQLTypes["WoltDriveDeliveryStateCondition"]> | undefined,
	not?: GraphQLTypes["WoltDriveDeliveryStateCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["WoltDriveDeliveryState"] | undefined,
	notEq?: GraphQLTypes["WoltDriveDeliveryState"] | undefined,
	in?: Array<GraphQLTypes["WoltDriveDeliveryState"]> | undefined,
	notIn?: Array<GraphQLTypes["WoltDriveDeliveryState"]> | undefined,
	lt?: GraphQLTypes["WoltDriveDeliveryState"] | undefined,
	lte?: GraphQLTypes["WoltDriveDeliveryState"] | undefined,
	gt?: GraphQLTypes["WoltDriveDeliveryState"] | undefined,
	gte?: GraphQLTypes["WoltDriveDeliveryState"] | undefined
};
	["WoltDriveDeliveryState"]: WoltDriveDeliveryState;
	["CleanerWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	staff?: GraphQLTypes["StaffWhere"] | undefined,
	canReachTopShelf?: GraphQLTypes["BooleanCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	and?: Array<GraphQLTypes["CleanerWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["CleanerWhere"] | undefined> | undefined,
	not?: GraphQLTypes["CleanerWhere"] | undefined
};
	["StocksManagerWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	staff?: GraphQLTypes["StaffWhere"] | undefined,
	managedProducts?: GraphQLTypes["ProductWhere"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	and?: Array<GraphQLTypes["StocksManagerWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["StocksManagerWhere"] | undefined> | undefined,
	not?: GraphQLTypes["StocksManagerWhere"] | undefined
};
	["CourierManagerWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	staff?: GraphQLTypes["StaffWhere"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	and?: Array<GraphQLTypes["CourierManagerWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["CourierManagerWhere"] | undefined> | undefined,
	not?: GraphQLTypes["CourierManagerWhere"] | undefined
};
	["PickerWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	staff?: GraphQLTypes["StaffWhere"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	and?: Array<GraphQLTypes["PickerWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PickerWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PickerWhere"] | undefined
};
	["RemunerationProfileWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	employmentInformation?: GraphQLTypes["EmploymentInformationWhere"] | undefined,
	workMonths?: GraphQLTypes["WorkMonthWhere"] | undefined,
	staff?: GraphQLTypes["StaffWhere"] | undefined,
	and?: Array<GraphQLTypes["RemunerationProfileWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["RemunerationProfileWhere"] | undefined> | undefined,
	not?: GraphQLTypes["RemunerationProfileWhere"] | undefined
};
	["EmploymentInformationWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	hourlyRate?: GraphQLTypes["IntCondition"] | undefined,
	remunerationProfiles?: GraphQLTypes["RemunerationProfileWhere"] | undefined,
	monthlySalary?: GraphQLTypes["IntCondition"] | undefined,
	type?: GraphQLTypes["EmploymentTypeCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["EmploymentInformationWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["EmploymentInformationWhere"] | undefined> | undefined,
	not?: GraphQLTypes["EmploymentInformationWhere"] | undefined
};
	["EmploymentTypeCondition"]: {
		and?: Array<GraphQLTypes["EmploymentTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["EmploymentTypeCondition"]> | undefined,
	not?: GraphQLTypes["EmploymentTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["EmploymentType"] | undefined,
	notEq?: GraphQLTypes["EmploymentType"] | undefined,
	in?: Array<GraphQLTypes["EmploymentType"]> | undefined,
	notIn?: Array<GraphQLTypes["EmploymentType"]> | undefined,
	lt?: GraphQLTypes["EmploymentType"] | undefined,
	lte?: GraphQLTypes["EmploymentType"] | undefined,
	gt?: GraphQLTypes["EmploymentType"] | undefined,
	gte?: GraphQLTypes["EmploymentType"] | undefined
};
	["EmploymentType"]: EmploymentType;
	["WorkMonthWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	year?: GraphQLTypes["IntCondition"] | undefined,
	month?: GraphQLTypes["IntCondition"] | undefined,
	hoursWorked?: GraphQLTypes["FloatCondition"] | undefined,
	billableHours?: GraphQLTypes["FloatCondition"] | undefined,
	remunerationProfile?: GraphQLTypes["RemunerationProfileWhere"] | undefined,
	and?: Array<GraphQLTypes["WorkMonthWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["WorkMonthWhere"] | undefined> | undefined,
	not?: GraphQLTypes["WorkMonthWhere"] | undefined
};
	["CashierWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	staff?: GraphQLTypes["StaffWhere"] | undefined,
	and?: Array<GraphQLTypes["CashierWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["CashierWhere"] | undefined> | undefined,
	not?: GraphQLTypes["CashierWhere"] | undefined
};
	["InternalBuyerWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	staff?: GraphQLTypes["StaffWhere"] | undefined,
	and?: Array<GraphQLTypes["InternalBuyerWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["InternalBuyerWhere"] | undefined> | undefined,
	not?: GraphQLTypes["InternalBuyerWhere"] | undefined
};
	["SalesManagerWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	staff?: GraphQLTypes["StaffWhere"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	countries?: GraphQLTypes["CountryWhere"] | undefined,
	and?: Array<GraphQLTypes["SalesManagerWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["SalesManagerWhere"] | undefined> | undefined,
	not?: GraphQLTypes["SalesManagerWhere"] | undefined
};
	["CashierManagerWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	staff?: GraphQLTypes["StaffWhere"] | undefined,
	and?: Array<GraphQLTypes["CashierManagerWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["CashierManagerWhere"] | undefined> | undefined,
	not?: GraphQLTypes["CashierManagerWhere"] | undefined
};
	["BusinessServiceEventWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	businessCustomer?: GraphQLTypes["BusinessCustomerWhere"] | undefined,
	businessService?: GraphQLTypes["BusinessServiceWhere"] | undefined,
	filledNumberOfPeople?: GraphQLTypes["IntCondition"] | undefined,
	filledInvoiced?: GraphQLTypes["BooleanCondition"] | undefined,
	filledEquipment?: GraphQLTypes["StringCondition"] | undefined,
	filledMillTamDem?: GraphQLTypes["BooleanCondition"] | undefined,
	filledSOEspresso?: GraphQLTypes["BooleanCondition"] | undefined,
	filledFilterCoffeeInMenu?: GraphQLTypes["BooleanCondition"] | undefined,
	filledWaterMeterStatus?: GraphQLTypes["StringCondition"] | undefined,
	filledServiceAction?: GraphQLTypes["StringCondition"] | undefined,
	filledInvoiceIdentifier?: GraphQLTypes["StringCondition"] | undefined,
	filledNote?: GraphQLTypes["StringCondition"] | undefined,
	filledContact?: GraphQLTypes["StringCondition"] | undefined,
	filledPhone?: GraphQLTypes["BooleanCondition"] | undefined,
	filledEmail?: GraphQLTypes["BooleanCondition"] | undefined,
	filledGrindingStonesCondition?: GraphQLTypes["StringCondition"] | undefined,
	createdBy?: GraphQLTypes["StaffWhere"] | undefined,
	filledSupervisor?: GraphQLTypes["StaffWhere"] | undefined,
	and?: Array<GraphQLTypes["BusinessServiceEventWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["BusinessServiceEventWhere"] | undefined> | undefined,
	not?: GraphQLTypes["BusinessServiceEventWhere"] | undefined
};
	["BusinessServiceWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	requireNote?: GraphQLTypes["IntCondition"] | undefined,
	locales?: GraphQLTypes["BusinessServiceLocaleWhere"] | undefined,
	requireNumberOfPeople?: GraphQLTypes["IntCondition"] | undefined,
	requireInvoiced?: GraphQLTypes["IntCondition"] | undefined,
	requireEquipment?: GraphQLTypes["IntCondition"] | undefined,
	requireMillTamDem?: GraphQLTypes["IntCondition"] | undefined,
	requireSOEspresso?: GraphQLTypes["IntCondition"] | undefined,
	requireFilterCoffeeInMenu?: GraphQLTypes["IntCondition"] | undefined,
	requireWaterMeterStatus?: GraphQLTypes["IntCondition"] | undefined,
	requireServiceAction?: GraphQLTypes["IntCondition"] | undefined,
	optionsEquipment?: GraphQLTypes["StringCondition"] | undefined,
	optionsServiceAction?: GraphQLTypes["StringCondition"] | undefined,
	requireInvoiceIdentifier?: GraphQLTypes["IntCondition"] | undefined,
	requireSupervisor?: GraphQLTypes["IntCondition"] | undefined,
	requireContact?: GraphQLTypes["IntCondition"] | undefined,
	requirePhone?: GraphQLTypes["IntCondition"] | undefined,
	requireEmail?: GraphQLTypes["IntCondition"] | undefined,
	requireGrindingStonesCondition?: GraphQLTypes["IntCondition"] | undefined,
	and?: Array<GraphQLTypes["BusinessServiceWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["BusinessServiceWhere"] | undefined> | undefined,
	not?: GraphQLTypes["BusinessServiceWhere"] | undefined
};
	["BusinessServiceLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	labelNote?: GraphQLTypes["StringCondition"] | undefined,
	root?: GraphQLTypes["BusinessServiceWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	labelNumberOfPeople?: GraphQLTypes["StringCondition"] | undefined,
	labelInvoiced?: GraphQLTypes["StringCondition"] | undefined,
	labelEquipment?: GraphQLTypes["StringCondition"] | undefined,
	labelMillTamDem?: GraphQLTypes["StringCondition"] | undefined,
	labelSOEspresso?: GraphQLTypes["StringCondition"] | undefined,
	labelFilterCoffeeInMenu?: GraphQLTypes["StringCondition"] | undefined,
	labelWaterMeterStatus?: GraphQLTypes["StringCondition"] | undefined,
	labelServiceAction?: GraphQLTypes["StringCondition"] | undefined,
	labelInvoiceIdentifier?: GraphQLTypes["StringCondition"] | undefined,
	labelSupervisor?: GraphQLTypes["StringCondition"] | undefined,
	labelContact?: GraphQLTypes["StringCondition"] | undefined,
	labelPhone?: GraphQLTypes["StringCondition"] | undefined,
	labelEmail?: GraphQLTypes["StringCondition"] | undefined,
	labelGrindingStonesCondition?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["BusinessServiceLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["BusinessServiceLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["BusinessServiceLocaleWhere"] | undefined
};
	["DoubleshotCoffeeEquipmentWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	espressoMachine?: GraphQLTypes["StringCondition"] | undefined,
	espressoGrinder?: GraphQLTypes["StringCondition"] | undefined,
	batchBrew?: GraphQLTypes["StringCondition"] | undefined,
	batchGrinder?: GraphQLTypes["StringCondition"] | undefined,
	waterFilter?: GraphQLTypes["StringCondition"] | undefined,
	mechanicalFilter?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["DoubleshotCoffeeEquipmentWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["DoubleshotCoffeeEquipmentWhere"] | undefined> | undefined,
	not?: GraphQLTypes["DoubleshotCoffeeEquipmentWhere"] | undefined
};
	["OrderRecurrenceWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	internalName?: GraphQLTypes["StringCondition"] | undefined,
	locales?: GraphQLTypes["OrderRecurrenceLocaleWhere"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	businessCategory?: GraphQLTypes["BusinessCategoryWhere"] | undefined,
	and?: Array<GraphQLTypes["OrderRecurrenceWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["OrderRecurrenceWhere"] | undefined> | undefined,
	not?: GraphQLTypes["OrderRecurrenceWhere"] | undefined
};
	["OrderRecurrenceLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	root?: GraphQLTypes["OrderRecurrenceWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["OrderRecurrenceLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["OrderRecurrenceLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["OrderRecurrenceLocaleWhere"] | undefined
};
	["ProductListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	items?: GraphQLTypes["ProductListItemWhere"] | undefined,
	businessCategory?: GraphQLTypes["BusinessCategoryWhere"] | undefined,
	and?: Array<GraphQLTypes["ProductListWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ProductListWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ProductListWhere"] | undefined
};
	["ProductListItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	list?: GraphQLTypes["ProductListWhere"] | undefined,
	product?: GraphQLTypes["ProductWhere"] | undefined,
	defaultQuantityForOrder?: GraphQLTypes["IntCondition"] | undefined,
	and?: Array<GraphQLTypes["ProductListItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ProductListItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ProductListItemWhere"] | undefined
};
	["ProductCategoryListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	items?: GraphQLTypes["ProductCategoryListItemWhere"] | undefined,
	locales?: GraphQLTypes["ProductCategoryListLocaleWhere"] | undefined,
	seasonalProductCategoriesOfBusinessCategory?: GraphQLTypes["BusinessCategoryWhere"] | undefined,
	specificProductsProductCategoriesOfBusinessCategory?: GraphQLTypes["BusinessCategoryWhere"] | undefined,
	and?: Array<GraphQLTypes["ProductCategoryListWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ProductCategoryListWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ProductCategoryListWhere"] | undefined
};
	["ProductCategoryListItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	list?: GraphQLTypes["ProductCategoryListWhere"] | undefined,
	productCategory?: GraphQLTypes["ProductCategoryWhere"] | undefined,
	showRecipeImages?: GraphQLTypes["BooleanCondition"] | undefined,
	showPackingImages?: GraphQLTypes["BooleanCondition"] | undefined,
	showAllAvailableProducts?: GraphQLTypes["BooleanCondition"] | undefined,
	and?: Array<GraphQLTypes["ProductCategoryListItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ProductCategoryListItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ProductCategoryListItemWhere"] | undefined
};
	["ProductCategoryListLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	root?: GraphQLTypes["ProductCategoryListWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["ProductCategoryListLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ProductCategoryListLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ProductCategoryListLocaleWhere"] | undefined
};
	["ProductIngredientLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	root?: GraphQLTypes["ProductIngredientWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["ProductIngredientLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ProductIngredientLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ProductIngredientLocaleWhere"] | undefined
};
	["ProductIngredientWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	internalNote?: GraphQLTypes["StringCondition"] | undefined,
	locales?: GraphQLTypes["ProductIngredientLocaleWhere"] | undefined,
	internalName?: GraphQLTypes["StringCondition"] | undefined,
	categories?: GraphQLTypes["ProductIngredientCategoryWhere"] | undefined,
	allergens?: GraphQLTypes["AllergenWhere"] | undefined,
	needsPrepping?: GraphQLTypes["BooleanCondition"] | undefined,
	allowCustomerRating?: GraphQLTypes["BooleanCondition"] | undefined,
	customerRatings?: GraphQLTypes["CustomerIngredientRatingWhere"] | undefined,
	preferredQuantityUnit?: GraphQLTypes["ProductIngredientItemQuantityUnitWhere"] | undefined,
	freshingContainer?: GraphQLTypes["FreshingContainerWhere"] | undefined,
	image?: GraphQLTypes["ImageWhere"] | undefined,
	suppliers?: GraphQLTypes["IngredientSupplierListWhere"] | undefined,
	incrementQuantityNumber?: GraphQLTypes["FloatCondition"] | undefined,
	and?: Array<GraphQLTypes["ProductIngredientWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ProductIngredientWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ProductIngredientWhere"] | undefined
};
	["ProductIngredientCategoryWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	internalName?: GraphQLTypes["StringCondition"] | undefined,
	internalNote?: GraphQLTypes["StringCondition"] | undefined,
	ingredients?: GraphQLTypes["ProductIngredientWhere"] | undefined,
	locales?: GraphQLTypes["ProductIngredientCategoryLocaleWhere"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	and?: Array<GraphQLTypes["ProductIngredientCategoryWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ProductIngredientCategoryWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ProductIngredientCategoryWhere"] | undefined
};
	["ProductIngredientCategoryLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	root?: GraphQLTypes["ProductIngredientCategoryWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["ProductIngredientCategoryLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ProductIngredientCategoryLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ProductIngredientCategoryLocaleWhere"] | undefined
};
	["AllergenWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	internalName?: GraphQLTypes["StringCondition"] | undefined,
	locales?: GraphQLTypes["AllergenLocaleWhere"] | undefined,
	ingredients?: GraphQLTypes["ProductIngredientWhere"] | undefined,
	code?: GraphQLTypes["IntCondition"] | undefined,
	and?: Array<GraphQLTypes["AllergenWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["AllergenWhere"] | undefined> | undefined,
	not?: GraphQLTypes["AllergenWhere"] | undefined
};
	["AllergenLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	root?: GraphQLTypes["AllergenWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["AllergenLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["AllergenLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["AllergenLocaleWhere"] | undefined
};
	["CustomerIngredientRatingWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	customer?: GraphQLTypes["CustomerWhere"] | undefined,
	rating?: GraphQLTypes["ProductIngredientRatingWhere"] | undefined,
	ingredient?: GraphQLTypes["ProductIngredientWhere"] | undefined,
	and?: Array<GraphQLTypes["CustomerIngredientRatingWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["CustomerIngredientRatingWhere"] | undefined> | undefined,
	not?: GraphQLTypes["CustomerIngredientRatingWhere"] | undefined
};
	["ProductIngredientRatingWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	icon?: GraphQLTypes["ImageWhere"] | undefined,
	and?: Array<GraphQLTypes["ProductIngredientRatingWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ProductIngredientRatingWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ProductIngredientRatingWhere"] | undefined
};
	["ProductIngredientItemQuantityUnitWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["ProductIngredientItemQuantityUnitWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ProductIngredientItemQuantityUnitWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ProductIngredientItemQuantityUnitWhere"] | undefined
};
	["FreshingContainerWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	volumeMl?: GraphQLTypes["IntCondition"] | undefined,
	workspace?: GraphQLTypes["WorkspaceWhere"] | undefined,
	and?: Array<GraphQLTypes["FreshingContainerWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["FreshingContainerWhere"] | undefined> | undefined,
	not?: GraphQLTypes["FreshingContainerWhere"] | undefined
};
	["WorkspaceWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	unique?: GraphQLTypes["OneCondition"] | undefined,
	orderDeadlineTime?: GraphQLTypes["StringCondition"] | undefined,
	ordersLoadingDurationHours?: GraphQLTypes["IntCondition"] | undefined,
	freshingContainerVolumeMl?: GraphQLTypes["IntCondition"] | undefined,
	freshingPrepareOrderByOffsetMinutes?: GraphQLTypes["IntCondition"] | undefined,
	checkoutUrlTemplate?: GraphQLTypes["StringCondition"] | undefined,
	orderUrlTemplate?: GraphQLTypes["StringCondition"] | undefined,
	paymentUrlTemplate?: GraphQLTypes["StringCondition"] | undefined,
	customerProfileUrlTemplate?: GraphQLTypes["StringCondition"] | undefined,
	userProfileUrlTemplate?: GraphQLTypes["StringCondition"] | undefined,
	messengerUrl?: GraphQLTypes["StringCondition"] | undefined,
	messengerIosUrl?: GraphQLTypes["StringCondition"] | undefined,
	messengerAndroidUrl?: GraphQLTypes["StringCondition"] | undefined,
	freshingContainers?: GraphQLTypes["FreshingContainerWhere"] | undefined,
	openingHours?: GraphQLTypes["WeekHoursWhere"] | undefined,
	workingHours?: GraphQLTypes["WeekHoursWhere"] | undefined,
	defaultFreshingContainer?: GraphQLTypes["FreshingContainerWhere"] | undefined,
	creditsProduct?: GraphQLTypes["VirtualProductWhere"] | undefined,
	discountVatRate?: GraphQLTypes["VatRateWhere"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	businessAddress?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["WorkspaceWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["WorkspaceWhere"] | undefined> | undefined,
	not?: GraphQLTypes["WorkspaceWhere"] | undefined
};
	["OneCondition"]: {
		and?: Array<GraphQLTypes["OneCondition"]> | undefined,
	or?: Array<GraphQLTypes["OneCondition"]> | undefined,
	not?: GraphQLTypes["OneCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["One"] | undefined,
	notEq?: GraphQLTypes["One"] | undefined,
	in?: Array<GraphQLTypes["One"]> | undefined,
	notIn?: Array<GraphQLTypes["One"]> | undefined,
	lt?: GraphQLTypes["One"] | undefined,
	lte?: GraphQLTypes["One"] | undefined,
	gt?: GraphQLTypes["One"] | undefined,
	gte?: GraphQLTypes["One"] | undefined
};
	["One"]: One;
	["WeekHoursWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	mon?: GraphQLTypes["StringCondition"] | undefined,
	tue?: GraphQLTypes["StringCondition"] | undefined,
	wed?: GraphQLTypes["StringCondition"] | undefined,
	thu?: GraphQLTypes["StringCondition"] | undefined,
	fri?: GraphQLTypes["StringCondition"] | undefined,
	sat?: GraphQLTypes["StringCondition"] | undefined,
	sun?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["WeekHoursWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["WeekHoursWhere"] | undefined> | undefined,
	not?: GraphQLTypes["WeekHoursWhere"] | undefined
};
	["VirtualProductWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	type?: GraphQLTypes["VirtualProductTypeCondition"] | undefined,
	product?: GraphQLTypes["ProductWhere"] | undefined,
	voucherCreditCents?: GraphQLTypes["IntCondition"] | undefined,
	physicalRepresentation?: GraphQLTypes["VirtualProductPhysicalRepresentationTypeCondition"] | undefined,
	recipientEmail?: GraphQLTypes["BooleanCondition"] | undefined,
	and?: Array<GraphQLTypes["VirtualProductWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["VirtualProductWhere"] | undefined> | undefined,
	not?: GraphQLTypes["VirtualProductWhere"] | undefined
};
	["VirtualProductTypeCondition"]: {
		and?: Array<GraphQLTypes["VirtualProductTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["VirtualProductTypeCondition"]> | undefined,
	not?: GraphQLTypes["VirtualProductTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["VirtualProductType"] | undefined,
	notEq?: GraphQLTypes["VirtualProductType"] | undefined,
	in?: Array<GraphQLTypes["VirtualProductType"]> | undefined,
	notIn?: Array<GraphQLTypes["VirtualProductType"]> | undefined,
	lt?: GraphQLTypes["VirtualProductType"] | undefined,
	lte?: GraphQLTypes["VirtualProductType"] | undefined,
	gt?: GraphQLTypes["VirtualProductType"] | undefined,
	gte?: GraphQLTypes["VirtualProductType"] | undefined
};
	["VirtualProductType"]: VirtualProductType;
	["VirtualProductPhysicalRepresentationTypeCondition"]: {
		and?: Array<GraphQLTypes["VirtualProductPhysicalRepresentationTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["VirtualProductPhysicalRepresentationTypeCondition"]> | undefined,
	not?: GraphQLTypes["VirtualProductPhysicalRepresentationTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["VirtualProductPhysicalRepresentationType"] | undefined,
	notEq?: GraphQLTypes["VirtualProductPhysicalRepresentationType"] | undefined,
	in?: Array<GraphQLTypes["VirtualProductPhysicalRepresentationType"]> | undefined,
	notIn?: Array<GraphQLTypes["VirtualProductPhysicalRepresentationType"]> | undefined,
	lt?: GraphQLTypes["VirtualProductPhysicalRepresentationType"] | undefined,
	lte?: GraphQLTypes["VirtualProductPhysicalRepresentationType"] | undefined,
	gt?: GraphQLTypes["VirtualProductPhysicalRepresentationType"] | undefined,
	gte?: GraphQLTypes["VirtualProductPhysicalRepresentationType"] | undefined
};
	["VirtualProductPhysicalRepresentationType"]: VirtualProductPhysicalRepresentationType;
	["IngredientSupplierListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	items?: GraphQLTypes["IngredientSupplierItemWhere"] | undefined,
	and?: Array<GraphQLTypes["IngredientSupplierListWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["IngredientSupplierListWhere"] | undefined> | undefined,
	not?: GraphQLTypes["IngredientSupplierListWhere"] | undefined
};
	["IngredientSupplierItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	list?: GraphQLTypes["IngredientSupplierListWhere"] | undefined,
	supplier?: GraphQLTypes["IngredientSupplierWhere"] | undefined,
	and?: Array<GraphQLTypes["IngredientSupplierItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["IngredientSupplierItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["IngredientSupplierItemWhere"] | undefined
};
	["IngredientSupplierWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	internalName?: GraphQLTypes["StringCondition"] | undefined,
	internalNote?: GraphQLTypes["StringCondition"] | undefined,
	locales?: GraphQLTypes["IngredientSupplierLocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["IngredientSupplierWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["IngredientSupplierWhere"] | undefined> | undefined,
	not?: GraphQLTypes["IngredientSupplierWhere"] | undefined
};
	["IngredientSupplierLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	root?: GraphQLTypes["IngredientSupplierWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["IngredientSupplierLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["IngredientSupplierLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["IngredientSupplierLocaleWhere"] | undefined
};
	["BlogLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	pageName?: GraphQLTypes["StringCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	lead?: GraphQLTypes["StringCondition"] | undefined,
	root?: GraphQLTypes["BlogWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["BlogLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["BlogLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["BlogLocaleWhere"] | undefined
};
	["BlogWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	unique?: GraphQLTypes["OneCondition"] | undefined,
	locales?: GraphQLTypes["BlogLocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["BlogWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["BlogWhere"] | undefined> | undefined,
	not?: GraphQLTypes["BlogWhere"] | undefined
};
	["BlogPostLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	availableForWeb?: GraphQLTypes["BooleanCondition"] | undefined,
	availableForMobile?: GraphQLTypes["BooleanCondition"] | undefined,
	root?: GraphQLTypes["BlogPostWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	cover?: GraphQLTypes["CoverWhere"] | undefined,
	content?: GraphQLTypes["ContentWhere"] | undefined,
	link?: GraphQLTypes["LinkableWhere"] | undefined,
	seo?: GraphQLTypes["SeoWhere"] | undefined,
	products?: GraphQLTypes["ProductWhere"] | undefined,
	and?: Array<GraphQLTypes["BlogPostLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["BlogPostLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["BlogPostLocaleWhere"] | undefined
};
	["BlogPostWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	locales?: GraphQLTypes["BlogPostLocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["BlogPostWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["BlogPostWhere"] | undefined> | undefined,
	not?: GraphQLTypes["BlogPostWhere"] | undefined
};
	["CoverWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	primaryTitle?: GraphQLTypes["StringCondition"] | undefined,
	secondaryTitle?: GraphQLTypes["StringCondition"] | undefined,
	medium?: GraphQLTypes["MediumWhere"] | undefined,
	buttonColors?: GraphQLTypes["ColorPalleteWhere"] | undefined,
	and?: Array<GraphQLTypes["CoverWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["CoverWhere"] | undefined> | undefined,
	not?: GraphQLTypes["CoverWhere"] | undefined
};
	["MediumWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	type?: GraphQLTypes["MediumTypeCondition"] | undefined,
	colorTheme?: GraphQLTypes["ColorThemeCondition"] | undefined,
	image?: GraphQLTypes["ImageWhere"] | undefined,
	video?: GraphQLTypes["VideoWhere"] | undefined,
	and?: Array<GraphQLTypes["MediumWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["MediumWhere"] | undefined> | undefined,
	not?: GraphQLTypes["MediumWhere"] | undefined
};
	["MediumTypeCondition"]: {
		and?: Array<GraphQLTypes["MediumTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["MediumTypeCondition"]> | undefined,
	not?: GraphQLTypes["MediumTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["MediumType"] | undefined,
	notEq?: GraphQLTypes["MediumType"] | undefined,
	in?: Array<GraphQLTypes["MediumType"]> | undefined,
	notIn?: Array<GraphQLTypes["MediumType"]> | undefined,
	lt?: GraphQLTypes["MediumType"] | undefined,
	lte?: GraphQLTypes["MediumType"] | undefined,
	gt?: GraphQLTypes["MediumType"] | undefined,
	gte?: GraphQLTypes["MediumType"] | undefined
};
	["MediumType"]: MediumType;
	["ColorThemeCondition"]: {
		and?: Array<GraphQLTypes["ColorThemeCondition"]> | undefined,
	or?: Array<GraphQLTypes["ColorThemeCondition"]> | undefined,
	not?: GraphQLTypes["ColorThemeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["ColorTheme"] | undefined,
	notEq?: GraphQLTypes["ColorTheme"] | undefined,
	in?: Array<GraphQLTypes["ColorTheme"]> | undefined,
	notIn?: Array<GraphQLTypes["ColorTheme"]> | undefined,
	lt?: GraphQLTypes["ColorTheme"] | undefined,
	lte?: GraphQLTypes["ColorTheme"] | undefined,
	gt?: GraphQLTypes["ColorTheme"] | undefined,
	gte?: GraphQLTypes["ColorTheme"] | undefined
};
	["ColorTheme"]: ColorTheme;
	["VideoWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	src?: GraphQLTypes["StringCondition"] | undefined,
	width?: GraphQLTypes["IntCondition"] | undefined,
	height?: GraphQLTypes["IntCondition"] | undefined,
	size?: GraphQLTypes["IntCondition"] | undefined,
	type?: GraphQLTypes["StringCondition"] | undefined,
	duration?: GraphQLTypes["FloatCondition"] | undefined,
	poster?: GraphQLTypes["ImageWhere"] | undefined,
	and?: Array<GraphQLTypes["VideoWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["VideoWhere"] | undefined> | undefined,
	not?: GraphQLTypes["VideoWhere"] | undefined
};
	["ColorPalleteWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	background?: GraphQLTypes["StringCondition"] | undefined,
	text?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["ColorPalleteWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ColorPalleteWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ColorPalleteWhere"] | undefined
};
	["ContentWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	blocks?: GraphQLTypes["ContentBlockWhere"] | undefined,
	and?: Array<GraphQLTypes["ContentWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ContentWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ContentWhere"] | undefined
};
	["ContentBlockWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	json?: GraphQLTypes["StringCondition"] | undefined,
	content?: GraphQLTypes["ContentWhere"] | undefined,
	references?: GraphQLTypes["ContentReferenceWhere"] | undefined,
	and?: Array<GraphQLTypes["ContentBlockWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ContentBlockWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ContentBlockWhere"] | undefined
};
	["ContentReferenceWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	type?: GraphQLTypes["ContentReferenceTypeCondition"] | undefined,
	primaryText?: GraphQLTypes["StringCondition"] | undefined,
	secondaryText?: GraphQLTypes["StringCondition"] | undefined,
	jsonContent?: GraphQLTypes["StringCondition"] | undefined,
	block?: GraphQLTypes["ContentBlockWhere"] | undefined,
	colorPallete?: GraphQLTypes["ColorPalleteWhere"] | undefined,
	medium?: GraphQLTypes["MediumWhere"] | undefined,
	link?: GraphQLTypes["LinkWhere"] | undefined,
	blogPosts?: GraphQLTypes["BlogPostListWhere"] | undefined,
	links?: GraphQLTypes["LinkListWhere"] | undefined,
	products?: GraphQLTypes["ProductListWhere"] | undefined,
	contentSize?: GraphQLTypes["ContentSizeCondition"] | undefined,
	misc?: GraphQLTypes["StringCondition"] | undefined,
	hero?: GraphQLTypes["HeroWhere"] | undefined,
	gallery?: GraphQLTypes["GalleryWhere"] | undefined,
	socialsAndApps?: GraphQLTypes["SocialsAndAppsWhere"] | undefined,
	productGrid?: GraphQLTypes["ProductGridWhere"] | undefined,
	productBanners?: GraphQLTypes["ProductBannerListWhere"] | undefined,
	deliveryRegions?: GraphQLTypes["DeliveryRegionsWhere"] | undefined,
	textList?: GraphQLTypes["TextListWhere"] | undefined,
	gridTiles?: GraphQLTypes["GridTilesWhere"] | undefined,
	and?: Array<GraphQLTypes["ContentReferenceWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ContentReferenceWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ContentReferenceWhere"] | undefined
};
	["ContentReferenceTypeCondition"]: {
		and?: Array<GraphQLTypes["ContentReferenceTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["ContentReferenceTypeCondition"]> | undefined,
	not?: GraphQLTypes["ContentReferenceTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["ContentReferenceType"] | undefined,
	notEq?: GraphQLTypes["ContentReferenceType"] | undefined,
	in?: Array<GraphQLTypes["ContentReferenceType"]> | undefined,
	notIn?: Array<GraphQLTypes["ContentReferenceType"]> | undefined,
	lt?: GraphQLTypes["ContentReferenceType"] | undefined,
	lte?: GraphQLTypes["ContentReferenceType"] | undefined,
	gt?: GraphQLTypes["ContentReferenceType"] | undefined,
	gte?: GraphQLTypes["ContentReferenceType"] | undefined
};
	["ContentReferenceType"]: ContentReferenceType;
	["LinkWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	type?: GraphQLTypes["LinkTypeCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	externalLink?: GraphQLTypes["StringCondition"] | undefined,
	internalLink?: GraphQLTypes["LinkableWhere"] | undefined,
	and?: Array<GraphQLTypes["LinkWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["LinkWhere"] | undefined> | undefined,
	not?: GraphQLTypes["LinkWhere"] | undefined
};
	["LinkTypeCondition"]: {
		and?: Array<GraphQLTypes["LinkTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["LinkTypeCondition"]> | undefined,
	not?: GraphQLTypes["LinkTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["LinkType"] | undefined,
	notEq?: GraphQLTypes["LinkType"] | undefined,
	in?: Array<GraphQLTypes["LinkType"]> | undefined,
	notIn?: Array<GraphQLTypes["LinkType"]> | undefined,
	lt?: GraphQLTypes["LinkType"] | undefined,
	lte?: GraphQLTypes["LinkType"] | undefined,
	gt?: GraphQLTypes["LinkType"] | undefined,
	gte?: GraphQLTypes["LinkType"] | undefined
};
	["LinkType"]: LinkType;
	["LinkableWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	url?: GraphQLTypes["StringCondition"] | undefined,
	blogPost?: GraphQLTypes["BlogPostLocaleWhere"] | undefined,
	page?: GraphQLTypes["PageLocaleWhere"] | undefined,
	wikiPage?: GraphQLTypes["WikiPageWhere"] | undefined,
	redirect?: GraphQLTypes["RedirectWhere"] | undefined,
	and?: Array<GraphQLTypes["LinkableWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["LinkableWhere"] | undefined> | undefined,
	not?: GraphQLTypes["LinkableWhere"] | undefined
};
	["PageLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	link?: GraphQLTypes["LinkableWhere"] | undefined,
	root?: GraphQLTypes["PageWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	seo?: GraphQLTypes["SeoWhere"] | undefined,
	content?: GraphQLTypes["ContentWhere"] | undefined,
	cover?: GraphQLTypes["CoverWhere"] | undefined,
	theme?: GraphQLTypes["PageThemeCondition"] | undefined,
	and?: Array<GraphQLTypes["PageLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PageLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PageLocaleWhere"] | undefined
};
	["PageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	locales?: GraphQLTypes["PageLocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["PageWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PageWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PageWhere"] | undefined
};
	["SeoWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	description?: GraphQLTypes["StringCondition"] | undefined,
	ogTitle?: GraphQLTypes["StringCondition"] | undefined,
	ogDescription?: GraphQLTypes["StringCondition"] | undefined,
	ogImage?: GraphQLTypes["ImageWhere"] | undefined,
	and?: Array<GraphQLTypes["SeoWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["SeoWhere"] | undefined> | undefined,
	not?: GraphQLTypes["SeoWhere"] | undefined
};
	["PageThemeCondition"]: {
		and?: Array<GraphQLTypes["PageThemeCondition"]> | undefined,
	or?: Array<GraphQLTypes["PageThemeCondition"]> | undefined,
	not?: GraphQLTypes["PageThemeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["PageTheme"] | undefined,
	notEq?: GraphQLTypes["PageTheme"] | undefined,
	in?: Array<GraphQLTypes["PageTheme"]> | undefined,
	notIn?: Array<GraphQLTypes["PageTheme"]> | undefined,
	lt?: GraphQLTypes["PageTheme"] | undefined,
	lte?: GraphQLTypes["PageTheme"] | undefined,
	gt?: GraphQLTypes["PageTheme"] | undefined,
	gte?: GraphQLTypes["PageTheme"] | undefined
};
	["PageTheme"]: PageTheme;
	["WikiPageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	emoji?: GraphQLTypes["StringCondition"] | undefined,
	link?: GraphQLTypes["LinkableWhere"] | undefined,
	parent?: GraphQLTypes["WikiPageWhere"] | undefined,
	children?: GraphQLTypes["WikiPageWhere"] | undefined,
	content?: GraphQLTypes["ContentWhere"] | undefined,
	and?: Array<GraphQLTypes["WikiPageWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["WikiPageWhere"] | undefined> | undefined,
	not?: GraphQLTypes["WikiPageWhere"] | undefined
};
	["RedirectWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	link?: GraphQLTypes["LinkableWhere"] | undefined,
	target?: GraphQLTypes["LinkWhere"] | undefined,
	and?: Array<GraphQLTypes["RedirectWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["RedirectWhere"] | undefined> | undefined,
	not?: GraphQLTypes["RedirectWhere"] | undefined
};
	["BlogPostListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	items?: GraphQLTypes["BlogPostListItemWhere"] | undefined,
	and?: Array<GraphQLTypes["BlogPostListWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["BlogPostListWhere"] | undefined> | undefined,
	not?: GraphQLTypes["BlogPostListWhere"] | undefined
};
	["BlogPostListItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	caption?: GraphQLTypes["StringCondition"] | undefined,
	list?: GraphQLTypes["BlogPostListWhere"] | undefined,
	blogPost?: GraphQLTypes["BlogPostLocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["BlogPostListItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["BlogPostListItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["BlogPostListItemWhere"] | undefined
};
	["LinkListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	items?: GraphQLTypes["LinkListItemWhere"] | undefined,
	and?: Array<GraphQLTypes["LinkListWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["LinkListWhere"] | undefined> | undefined,
	not?: GraphQLTypes["LinkListWhere"] | undefined
};
	["LinkListItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	isPrimary?: GraphQLTypes["BooleanCondition"] | undefined,
	list?: GraphQLTypes["LinkListWhere"] | undefined,
	link?: GraphQLTypes["LinkWhere"] | undefined,
	and?: Array<GraphQLTypes["LinkListItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["LinkListItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["LinkListItemWhere"] | undefined
};
	["ContentSizeCondition"]: {
		and?: Array<GraphQLTypes["ContentSizeCondition"]> | undefined,
	or?: Array<GraphQLTypes["ContentSizeCondition"]> | undefined,
	not?: GraphQLTypes["ContentSizeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["ContentSize"] | undefined,
	notEq?: GraphQLTypes["ContentSize"] | undefined,
	in?: Array<GraphQLTypes["ContentSize"]> | undefined,
	notIn?: Array<GraphQLTypes["ContentSize"]> | undefined,
	lt?: GraphQLTypes["ContentSize"] | undefined,
	lte?: GraphQLTypes["ContentSize"] | undefined,
	gt?: GraphQLTypes["ContentSize"] | undefined,
	gte?: GraphQLTypes["ContentSize"] | undefined
};
	["ContentSize"]: ContentSize;
	["HeroWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	showLogo?: GraphQLTypes["BooleanCondition"] | undefined,
	middleContent?: GraphQLTypes["StringCondition"] | undefined,
	medium?: GraphQLTypes["MediumWhere"] | undefined,
	and?: Array<GraphQLTypes["HeroWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["HeroWhere"] | undefined> | undefined,
	not?: GraphQLTypes["HeroWhere"] | undefined
};
	["GalleryWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	items?: GraphQLTypes["GalleryItemWhere"] | undefined,
	and?: Array<GraphQLTypes["GalleryWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["GalleryWhere"] | undefined> | undefined,
	not?: GraphQLTypes["GalleryWhere"] | undefined
};
	["GalleryItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	caption?: GraphQLTypes["StringCondition"] | undefined,
	list?: GraphQLTypes["GalleryWhere"] | undefined,
	medium?: GraphQLTypes["MediumWhere"] | undefined,
	and?: Array<GraphQLTypes["GalleryItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["GalleryItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["GalleryItemWhere"] | undefined
};
	["SocialsAndAppsWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	instagram?: GraphQLTypes["BooleanCondition"] | undefined,
	appStore?: GraphQLTypes["BooleanCondition"] | undefined,
	googlePlay?: GraphQLTypes["BooleanCondition"] | undefined,
	and?: Array<GraphQLTypes["SocialsAndAppsWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["SocialsAndAppsWhere"] | undefined> | undefined,
	not?: GraphQLTypes["SocialsAndAppsWhere"] | undefined
};
	["ProductGridWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	isCarousel?: GraphQLTypes["BooleanCondition"] | undefined,
	categories?: GraphQLTypes["ProductGridCategoryWhere"] | undefined,
	type?: GraphQLTypes["ProductGridTypeCondition"] | undefined,
	and?: Array<GraphQLTypes["ProductGridWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ProductGridWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ProductGridWhere"] | undefined
};
	["ProductGridCategoryWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	root?: GraphQLTypes["ProductGridWhere"] | undefined,
	items?: GraphQLTypes["ProductGridItemWhere"] | undefined,
	images?: GraphQLTypes["ImageListWhere"] | undefined,
	and?: Array<GraphQLTypes["ProductGridCategoryWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ProductGridCategoryWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ProductGridCategoryWhere"] | undefined
};
	["ProductGridItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	lead?: GraphQLTypes["StringCondition"] | undefined,
	product?: GraphQLTypes["ProductWhere"] | undefined,
	medium?: GraphQLTypes["MediumWhere"] | undefined,
	link?: GraphQLTypes["LinkWhere"] | undefined,
	category?: GraphQLTypes["ProductGridCategoryWhere"] | undefined,
	description?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["ProductGridItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ProductGridItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ProductGridItemWhere"] | undefined
};
	["ImageListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	items?: GraphQLTypes["ImageListItemWhere"] | undefined,
	and?: Array<GraphQLTypes["ImageListWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ImageListWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ImageListWhere"] | undefined
};
	["ImageListItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	list?: GraphQLTypes["ImageListWhere"] | undefined,
	image?: GraphQLTypes["ImageWhere"] | undefined,
	and?: Array<GraphQLTypes["ImageListItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ImageListItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ImageListItemWhere"] | undefined
};
	["ProductGridTypeCondition"]: {
		and?: Array<GraphQLTypes["ProductGridTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["ProductGridTypeCondition"]> | undefined,
	not?: GraphQLTypes["ProductGridTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["ProductGridType"] | undefined,
	notEq?: GraphQLTypes["ProductGridType"] | undefined,
	in?: Array<GraphQLTypes["ProductGridType"]> | undefined,
	notIn?: Array<GraphQLTypes["ProductGridType"]> | undefined,
	lt?: GraphQLTypes["ProductGridType"] | undefined,
	lte?: GraphQLTypes["ProductGridType"] | undefined,
	gt?: GraphQLTypes["ProductGridType"] | undefined,
	gte?: GraphQLTypes["ProductGridType"] | undefined
};
	["ProductGridType"]: ProductGridType;
	["ProductBannerListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	items?: GraphQLTypes["ProductBannerItemWhere"] | undefined,
	and?: Array<GraphQLTypes["ProductBannerListWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ProductBannerListWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ProductBannerListWhere"] | undefined
};
	["ProductBannerItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	list?: GraphQLTypes["ProductBannerListWhere"] | undefined,
	banner?: GraphQLTypes["ProductBannerWhere"] | undefined,
	size?: GraphQLTypes["ProductBannerItemSizeCondition"] | undefined,
	and?: Array<GraphQLTypes["ProductBannerItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ProductBannerItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ProductBannerItemWhere"] | undefined
};
	["ProductBannerWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	beforeTitle?: GraphQLTypes["StringCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	label?: GraphQLTypes["StringCondition"] | undefined,
	button?: GraphQLTypes["LinkWhere"] | undefined,
	backgroundImage?: GraphQLTypes["ImageWhere"] | undefined,
	productImage?: GraphQLTypes["ImageWhere"] | undefined,
	product?: GraphQLTypes["ProductWhere"] | undefined,
	and?: Array<GraphQLTypes["ProductBannerWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ProductBannerWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ProductBannerWhere"] | undefined
};
	["ProductBannerItemSizeCondition"]: {
		and?: Array<GraphQLTypes["ProductBannerItemSizeCondition"]> | undefined,
	or?: Array<GraphQLTypes["ProductBannerItemSizeCondition"]> | undefined,
	not?: GraphQLTypes["ProductBannerItemSizeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["ProductBannerItemSize"] | undefined,
	notEq?: GraphQLTypes["ProductBannerItemSize"] | undefined,
	in?: Array<GraphQLTypes["ProductBannerItemSize"]> | undefined,
	notIn?: Array<GraphQLTypes["ProductBannerItemSize"]> | undefined,
	lt?: GraphQLTypes["ProductBannerItemSize"] | undefined,
	lte?: GraphQLTypes["ProductBannerItemSize"] | undefined,
	gt?: GraphQLTypes["ProductBannerItemSize"] | undefined,
	gte?: GraphQLTypes["ProductBannerItemSize"] | undefined
};
	["ProductBannerItemSize"]: ProductBannerItemSize;
	["DeliveryRegionsWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	items?: GraphQLTypes["DeliveryRegionsItemWhere"] | undefined,
	and?: Array<GraphQLTypes["DeliveryRegionsWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["DeliveryRegionsWhere"] | undefined> | undefined,
	not?: GraphQLTypes["DeliveryRegionsWhere"] | undefined
};
	["DeliveryRegionsItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	offerLabel?: GraphQLTypes["StringCondition"] | undefined,
	list?: GraphQLTypes["DeliveryRegionsWhere"] | undefined,
	image?: GraphQLTypes["ImageWhere"] | undefined,
	textList?: GraphQLTypes["TextListWhere"] | undefined,
	gallery?: GraphQLTypes["ImageListWhere"] | undefined,
	and?: Array<GraphQLTypes["DeliveryRegionsItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["DeliveryRegionsItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["DeliveryRegionsItemWhere"] | undefined
};
	["TextListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	items?: GraphQLTypes["TextItemWhere"] | undefined,
	and?: Array<GraphQLTypes["TextListWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["TextListWhere"] | undefined> | undefined,
	not?: GraphQLTypes["TextListWhere"] | undefined
};
	["TextItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	text?: GraphQLTypes["StringCondition"] | undefined,
	list?: GraphQLTypes["TextListWhere"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["TextItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["TextItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["TextItemWhere"] | undefined
};
	["GridTilesWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	items?: GraphQLTypes["GridTileItemWhere"] | undefined,
	and?: Array<GraphQLTypes["GridTilesWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["GridTilesWhere"] | undefined> | undefined,
	not?: GraphQLTypes["GridTilesWhere"] | undefined
};
	["GridTileItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	text?: GraphQLTypes["StringCondition"] | undefined,
	list?: GraphQLTypes["GridTilesWhere"] | undefined,
	medium?: GraphQLTypes["MediumWhere"] | undefined,
	link?: GraphQLTypes["LinkWhere"] | undefined,
	and?: Array<GraphQLTypes["GridTileItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["GridTileItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["GridTileItemWhere"] | undefined
};
	["TranslationCataloguesIdentifierWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	code?: GraphQLTypes["StringCondition"] | undefined,
	catalogue?: GraphQLTypes["TranslationCatalogueWhere"] | undefined,
	and?: Array<GraphQLTypes["TranslationCataloguesIdentifierWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["TranslationCataloguesIdentifierWhere"] | undefined> | undefined,
	not?: GraphQLTypes["TranslationCataloguesIdentifierWhere"] | undefined
};
	["TranslationCatalogueWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	domain?: GraphQLTypes["TranslationDomainWhere"] | undefined,
	fallback?: GraphQLTypes["TranslationCatalogueWhere"] | undefined,
	values?: GraphQLTypes["TranslationValueWhere"] | undefined,
	identifier?: GraphQLTypes["TranslationCataloguesIdentifierWhere"] | undefined,
	and?: Array<GraphQLTypes["TranslationCatalogueWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["TranslationCatalogueWhere"] | undefined> | undefined,
	not?: GraphQLTypes["TranslationCatalogueWhere"] | undefined
};
	["TranslationDomainWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	identifier?: GraphQLTypes["StringCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	catalogues?: GraphQLTypes["TranslationCatalogueWhere"] | undefined,
	keys?: GraphQLTypes["TranslationKeyWhere"] | undefined,
	and?: Array<GraphQLTypes["TranslationDomainWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["TranslationDomainWhere"] | undefined> | undefined,
	not?: GraphQLTypes["TranslationDomainWhere"] | undefined
};
	["TranslationKeyWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	identifier?: GraphQLTypes["StringCondition"] | undefined,
	contentType?: GraphQLTypes["TranslationContentTypeCondition"] | undefined,
	note?: GraphQLTypes["StringCondition"] | undefined,
	domain?: GraphQLTypes["TranslationDomainWhere"] | undefined,
	values?: GraphQLTypes["TranslationValueWhere"] | undefined,
	and?: Array<GraphQLTypes["TranslationKeyWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["TranslationKeyWhere"] | undefined> | undefined,
	not?: GraphQLTypes["TranslationKeyWhere"] | undefined
};
	["TranslationContentTypeCondition"]: {
		and?: Array<GraphQLTypes["TranslationContentTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["TranslationContentTypeCondition"]> | undefined,
	not?: GraphQLTypes["TranslationContentTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["TranslationContentType"] | undefined,
	notEq?: GraphQLTypes["TranslationContentType"] | undefined,
	in?: Array<GraphQLTypes["TranslationContentType"]> | undefined,
	notIn?: Array<GraphQLTypes["TranslationContentType"]> | undefined,
	lt?: GraphQLTypes["TranslationContentType"] | undefined,
	lte?: GraphQLTypes["TranslationContentType"] | undefined,
	gt?: GraphQLTypes["TranslationContentType"] | undefined,
	gte?: GraphQLTypes["TranslationContentType"] | undefined
};
	["TranslationContentType"]: TranslationContentType;
	["TranslationValueWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	value?: GraphQLTypes["StringCondition"] | undefined,
	catalogue?: GraphQLTypes["TranslationCatalogueWhere"] | undefined,
	key?: GraphQLTypes["TranslationKeyWhere"] | undefined,
	and?: Array<GraphQLTypes["TranslationValueWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["TranslationValueWhere"] | undefined> | undefined,
	not?: GraphQLTypes["TranslationValueWhere"] | undefined
};
	["MenuLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	root?: GraphQLTypes["SiteMenuWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	items?: GraphQLTypes["MenuItemWhere"] | undefined,
	secondaryItems?: GraphQLTypes["LinkListWhere"] | undefined,
	eshopLink?: GraphQLTypes["LinkWhere"] | undefined,
	and?: Array<GraphQLTypes["MenuLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["MenuLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["MenuLocaleWhere"] | undefined
};
	["SiteMenuWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	unique?: GraphQLTypes["OneCondition"] | undefined,
	locales?: GraphQLTypes["MenuLocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["SiteMenuWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["SiteMenuWhere"] | undefined> | undefined,
	not?: GraphQLTypes["SiteMenuWhere"] | undefined
};
	["MenuItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	menu?: GraphQLTypes["MenuLocaleWhere"] | undefined,
	link?: GraphQLTypes["LinkWhere"] | undefined,
	subitems?: GraphQLTypes["MenuSubitemWhere"] | undefined,
	and?: Array<GraphQLTypes["MenuItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["MenuItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["MenuItemWhere"] | undefined
};
	["MenuSubitemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	type?: GraphQLTypes["MenuSubitemTypeCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	item?: GraphQLTypes["MenuItemWhere"] | undefined,
	links?: GraphQLTypes["MenuLinkListWhere"] | undefined,
	products?: GraphQLTypes["MenuProductsWhere"] | undefined,
	delivery?: GraphQLTypes["MenuDeliveryWhere"] | undefined,
	contact?: GraphQLTypes["MenuContactWhere"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	and?: Array<GraphQLTypes["MenuSubitemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["MenuSubitemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["MenuSubitemWhere"] | undefined
};
	["MenuSubitemTypeCondition"]: {
		and?: Array<GraphQLTypes["MenuSubitemTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["MenuSubitemTypeCondition"]> | undefined,
	not?: GraphQLTypes["MenuSubitemTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["MenuSubitemType"] | undefined,
	notEq?: GraphQLTypes["MenuSubitemType"] | undefined,
	in?: Array<GraphQLTypes["MenuSubitemType"]> | undefined,
	notIn?: Array<GraphQLTypes["MenuSubitemType"]> | undefined,
	lt?: GraphQLTypes["MenuSubitemType"] | undefined,
	lte?: GraphQLTypes["MenuSubitemType"] | undefined,
	gt?: GraphQLTypes["MenuSubitemType"] | undefined,
	gte?: GraphQLTypes["MenuSubitemType"] | undefined
};
	["MenuSubitemType"]: MenuSubitemType;
	["MenuLinkListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	items?: GraphQLTypes["MenuLinkItemWhere"] | undefined,
	and?: Array<GraphQLTypes["MenuLinkListWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["MenuLinkListWhere"] | undefined> | undefined,
	not?: GraphQLTypes["MenuLinkListWhere"] | undefined
};
	["MenuLinkItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	list?: GraphQLTypes["MenuLinkListWhere"] | undefined,
	link?: GraphQLTypes["LinkWhere"] | undefined,
	image?: GraphQLTypes["ImageWhere"] | undefined,
	description?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["MenuLinkItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["MenuLinkItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["MenuLinkItemWhere"] | undefined
};
	["MenuProductsWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	links?: GraphQLTypes["MenuLinkListWhere"] | undefined,
	buttons?: GraphQLTypes["LinkListWhere"] | undefined,
	and?: Array<GraphQLTypes["MenuProductsWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["MenuProductsWhere"] | undefined> | undefined,
	not?: GraphQLTypes["MenuProductsWhere"] | undefined
};
	["MenuDeliveryWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	deliveryRegions?: GraphQLTypes["DeliveryRegionsWhere"] | undefined,
	text?: GraphQLTypes["StringCondition"] | undefined,
	socialsAndApps?: GraphQLTypes["SocialsAndAppsWhere"] | undefined,
	and?: Array<GraphQLTypes["MenuDeliveryWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["MenuDeliveryWhere"] | undefined> | undefined,
	not?: GraphQLTypes["MenuDeliveryWhere"] | undefined
};
	["MenuContactWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	text?: GraphQLTypes["StringCondition"] | undefined,
	image?: GraphQLTypes["ImageWhere"] | undefined,
	and?: Array<GraphQLTypes["MenuContactWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["MenuContactWhere"] | undefined> | undefined,
	not?: GraphQLTypes["MenuContactWhere"] | undefined
};
	["ProductLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	description?: GraphQLTypes["StringCondition"] | undefined,
	root?: GraphQLTypes["ProductWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	featureList?: GraphQLTypes["TextListWhere"] | undefined,
	printableName?: GraphQLTypes["StringCondition"] | undefined,
	firstSticker?: GraphQLTypes["StringCondition"] | undefined,
	secondSticker?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["ProductLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ProductLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ProductLocaleWhere"] | undefined
};
	["ProductRecipeLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	root?: GraphQLTypes["ProductRecipeWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	description?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["ProductRecipeLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ProductRecipeLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ProductRecipeLocaleWhere"] | undefined
};
	["ProductRecipeWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	products?: GraphQLTypes["ProductWhere"] | undefined,
	internalNote?: GraphQLTypes["StringCondition"] | undefined,
	color?: GraphQLTypes["StringCondition"] | undefined,
	image?: GraphQLTypes["ImageWhere"] | undefined,
	icon?: GraphQLTypes["ImageWhere"] | undefined,
	ingredients?: GraphQLTypes["ProductIngredientItemWhere"] | undefined,
	needsPrepping?: GraphQLTypes["BooleanCondition"] | undefined,
	locales?: GraphQLTypes["ProductRecipeLocaleWhere"] | undefined,
	gutTuning?: GraphQLTypes["FloatCondition"] | undefined,
	freshingContainer?: GraphQLTypes["FreshingContainerWhere"] | undefined,
	description?: GraphQLTypes["StringCondition"] | undefined,
	nutritionFacts?: GraphQLTypes["NutritionFactsWhere"] | undefined,
	and?: Array<GraphQLTypes["ProductRecipeWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ProductRecipeWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ProductRecipeWhere"] | undefined
};
	["ProductIngredientItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	internalOrder?: GraphQLTypes["IntCondition"] | undefined,
	recipe?: GraphQLTypes["ProductRecipeWhere"] | undefined,
	ingredient?: GraphQLTypes["ProductIngredientWhere"] | undefined,
	quantity?: GraphQLTypes["ProductIngredientItemQuantityWhere"] | undefined,
	and?: Array<GraphQLTypes["ProductIngredientItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ProductIngredientItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ProductIngredientItemWhere"] | undefined
};
	["ProductIngredientItemQuantityWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	unit?: GraphQLTypes["ProductIngredientItemQuantityUnitWhere"] | undefined,
	value?: GraphQLTypes["FloatCondition"] | undefined,
	and?: Array<GraphQLTypes["ProductIngredientItemQuantityWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ProductIngredientItemQuantityWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ProductIngredientItemQuantityWhere"] | undefined
};
	["NutritionFactsWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	energyKiloJoule?: GraphQLTypes["FloatCondition"] | undefined,
	energyKiloCalorie?: GraphQLTypes["FloatCondition"] | undefined,
	fatsGrams?: GraphQLTypes["FloatCondition"] | undefined,
	fatsOfWhichSaturatedGrams?: GraphQLTypes["FloatCondition"] | undefined,
	carbohydrateGrams?: GraphQLTypes["FloatCondition"] | undefined,
	carbohydrateOfWhichSugarsGrams?: GraphQLTypes["FloatCondition"] | undefined,
	proteinGrams?: GraphQLTypes["FloatCondition"] | undefined,
	fibreGrams?: GraphQLTypes["FloatCondition"] | undefined,
	saltGrams?: GraphQLTypes["FloatCondition"] | undefined,
	and?: Array<GraphQLTypes["NutritionFactsWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["NutritionFactsWhere"] | undefined> | undefined,
	not?: GraphQLTypes["NutritionFactsWhere"] | undefined
};
	["DeliveryMethodLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	description?: GraphQLTypes["StringCondition"] | undefined,
	trackingCodeUrlTemplate?: GraphQLTypes["StringCondition"] | undefined,
	processingTitle?: GraphQLTypes["StringCondition"] | undefined,
	processingText?: GraphQLTypes["StringCondition"] | undefined,
	processingIconUrl?: GraphQLTypes["StringCondition"] | undefined,
	dispatchedTitle?: GraphQLTypes["StringCondition"] | undefined,
	dispatchedText?: GraphQLTypes["StringCondition"] | undefined,
	dispatchedIconUrl?: GraphQLTypes["StringCondition"] | undefined,
	fulfilledTitle?: GraphQLTypes["StringCondition"] | undefined,
	fulfilledText?: GraphQLTypes["StringCondition"] | undefined,
	fulfilledIconUrl?: GraphQLTypes["StringCondition"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	root?: GraphQLTypes["DeliveryMethodWhere"] | undefined,
	and?: Array<GraphQLTypes["DeliveryMethodLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["DeliveryMethodLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["DeliveryMethodLocaleWhere"] | undefined
};
	["PipelineStageLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	root?: GraphQLTypes["PipelineStageWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	and?: Array<GraphQLTypes["PipelineStageLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PipelineStageLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PipelineStageLocaleWhere"] | undefined
};
	["PipelineStageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	items?: GraphQLTypes["PipelineStageItemWhere"] | undefined,
	pipeline?: GraphQLTypes["PipelineWhere"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	locales?: GraphQLTypes["PipelineStageLocaleWhere"] | undefined,
	sentiment?: GraphQLTypes["PipelineStageSentimentWhere"] | undefined,
	type?: GraphQLTypes["PipelineStageTypeCondition"] | undefined,
	forms?: GraphQLTypes["LeadFormWhere"] | undefined,
	showItemsWeight?: GraphQLTypes["BooleanCondition"] | undefined,
	showItemsPrice?: GraphQLTypes["BooleanCondition"] | undefined,
	and?: Array<GraphQLTypes["PipelineStageWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PipelineStageWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PipelineStageWhere"] | undefined
};
	["PipelineStageItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	list?: GraphQLTypes["PipelineStageWhere"] | undefined,
	lead?: GraphQLTypes["PipelineLeadWhere"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	and?: Array<GraphQLTypes["PipelineStageItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PipelineStageItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PipelineStageItemWhere"] | undefined
};
	["PipelineLeadWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	stageItem?: GraphQLTypes["PipelineStageItemWhere"] | undefined,
	contactPerson?: GraphQLTypes["StringCondition"] | undefined,
	customer?: GraphQLTypes["CustomerWhere"] | undefined,
	cafeType?: GraphQLTypes["StringCondition"] | undefined,
	offerType?: GraphQLTypes["StringCondition"] | undefined,
	ownMachine?: GraphQLTypes["BooleanCondition"] | undefined,
	customerCity?: GraphQLTypes["StringCondition"] | undefined,
	companyId?: GraphQLTypes["StringCondition"] | undefined,
	customerName?: GraphQLTypes["StringCondition"] | undefined,
	email?: GraphQLTypes["StringCondition"] | undefined,
	phone?: GraphQLTypes["StringCondition"] | undefined,
	form?: GraphQLTypes["LeadFormWhere"] | undefined,
	meta?: GraphQLTypes["StringCondition"] | undefined,
	multiroasterType?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["PipelineLeadWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PipelineLeadWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PipelineLeadWhere"] | undefined
};
	["LeadFormWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	code?: GraphQLTypes["StringCondition"] | undefined,
	stage?: GraphQLTypes["PipelineStageWhere"] | undefined,
	leads?: GraphQLTypes["PipelineLeadWhere"] | undefined,
	and?: Array<GraphQLTypes["LeadFormWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["LeadFormWhere"] | undefined> | undefined,
	not?: GraphQLTypes["LeadFormWhere"] | undefined
};
	["PipelineWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	unique?: GraphQLTypes["OneCondition"] | undefined,
	stages?: GraphQLTypes["PipelineStageWhere"] | undefined,
	and?: Array<GraphQLTypes["PipelineWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PipelineWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PipelineWhere"] | undefined
};
	["PipelineStageSentimentWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	internalName?: GraphQLTypes["StringCondition"] | undefined,
	backgroundColor?: GraphQLTypes["StringCondition"] | undefined,
	textColor?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["PipelineStageSentimentWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PipelineStageSentimentWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PipelineStageSentimentWhere"] | undefined
};
	["PipelineStageTypeCondition"]: {
		and?: Array<GraphQLTypes["PipelineStageTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["PipelineStageTypeCondition"]> | undefined,
	not?: GraphQLTypes["PipelineStageTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["PipelineStageType"] | undefined,
	notEq?: GraphQLTypes["PipelineStageType"] | undefined,
	in?: Array<GraphQLTypes["PipelineStageType"]> | undefined,
	notIn?: Array<GraphQLTypes["PipelineStageType"]> | undefined,
	lt?: GraphQLTypes["PipelineStageType"] | undefined,
	lte?: GraphQLTypes["PipelineStageType"] | undefined,
	gt?: GraphQLTypes["PipelineStageType"] | undefined,
	gte?: GraphQLTypes["PipelineStageType"] | undefined
};
	["PipelineStageType"]: PipelineStageType;
	["SubscriptionBoxLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	stickerText?: GraphQLTypes["StringCondition"] | undefined,
	descriptionText?: GraphQLTypes["StringCondition"] | undefined,
	root?: GraphQLTypes["SubscriptionBoxWhere"] | undefined,
	locale?: GraphQLTypes["LocaleWhere"] | undefined,
	secondaryTitle?: GraphQLTypes["StringCondition"] | undefined,
	texts?: GraphQLTypes["TextListWhere"] | undefined,
	secondaryTexts?: GraphQLTypes["TextListWhere"] | undefined,
	and?: Array<GraphQLTypes["SubscriptionBoxLocaleWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["SubscriptionBoxLocaleWhere"] | undefined> | undefined,
	not?: GraphQLTypes["SubscriptionBoxLocaleWhere"] | undefined
};
	["SubscriptionBoxWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	locales?: GraphQLTypes["SubscriptionBoxLocaleWhere"] | undefined,
	unique?: GraphQLTypes["OneCondition"] | undefined,
	and?: Array<GraphQLTypes["SubscriptionBoxWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["SubscriptionBoxWhere"] | undefined> | undefined,
	not?: GraphQLTypes["SubscriptionBoxWhere"] | undefined
};
	["PreparedPackingQuantityWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	date?: GraphQLTypes["DateCondition"] | undefined,
	quantity?: GraphQLTypes["FloatCondition"] | undefined,
	recipe?: GraphQLTypes["ProductRecipeWhere"] | undefined,
	packing?: GraphQLTypes["ProductPackingWhere"] | undefined,
	packedInCardboard?: GraphQLTypes["BooleanCondition"] | undefined,
	and?: Array<GraphQLTypes["PreparedPackingQuantityWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PreparedPackingQuantityWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PreparedPackingQuantityWhere"] | undefined
};
	["ProductStockWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	quantity?: GraphQLTypes["IntCondition"] | undefined,
	product?: GraphQLTypes["ProductWhere"] | undefined,
	store?: GraphQLTypes["StoreWhere"] | undefined,
	and?: Array<GraphQLTypes["ProductStockWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ProductStockWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ProductStockWhere"] | undefined
};
	["StoreWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	code?: GraphQLTypes["StringCondition"] | undefined,
	description?: GraphQLTypes["StringCondition"] | undefined,
	internalNote?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["StoreWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["StoreWhere"] | undefined> | undefined,
	not?: GraphQLTypes["StoreWhere"] | undefined
};
	["ProductGroupPriceWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	priceCents?: GraphQLTypes["IntCondition"] | undefined,
	group?: GraphQLTypes["CustomerGroupWhere"] | undefined,
	product?: GraphQLTypes["ProductWhere"] | undefined,
	and?: Array<GraphQLTypes["ProductGroupPriceWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ProductGroupPriceWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ProductGroupPriceWhere"] | undefined
};
	["CustomerGroupWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	productPrices?: GraphQLTypes["ProductGroupPriceWhere"] | undefined,
	customers?: GraphQLTypes["CustomerWhere"] | undefined,
	discountPermille?: GraphQLTypes["IntCondition"] | undefined,
	code?: GraphQLTypes["StringCondition"] | undefined,
	doubleshotLegacyId?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["CustomerGroupWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["CustomerGroupWhere"] | undefined> | undefined,
	not?: GraphQLTypes["CustomerGroupWhere"] | undefined
};
	["ProductAvailabilityCondition"]: {
		and?: Array<GraphQLTypes["ProductAvailabilityCondition"]> | undefined,
	or?: Array<GraphQLTypes["ProductAvailabilityCondition"]> | undefined,
	not?: GraphQLTypes["ProductAvailabilityCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["ProductAvailability"] | undefined,
	notEq?: GraphQLTypes["ProductAvailability"] | undefined,
	in?: Array<GraphQLTypes["ProductAvailability"]> | undefined,
	notIn?: Array<GraphQLTypes["ProductAvailability"]> | undefined,
	lt?: GraphQLTypes["ProductAvailability"] | undefined,
	lte?: GraphQLTypes["ProductAvailability"] | undefined,
	gt?: GraphQLTypes["ProductAvailability"] | undefined,
	gte?: GraphQLTypes["ProductAvailability"] | undefined
};
	["ProductAvailability"]: ProductAvailability;
	["ProductCustomerPriceWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	groupDiscountPermille?: GraphQLTypes["IntCondition"] | undefined,
	groupPriceCents?: GraphQLTypes["IntCondition"] | undefined,
	fullPriceCents?: GraphQLTypes["IntCondition"] | undefined,
	discountedPriceCents?: GraphQLTypes["IntCondition"] | undefined,
	priceCents?: GraphQLTypes["IntCondition"] | undefined,
	offered?: GraphQLTypes["BooleanCondition"] | undefined,
	notDiscountable?: GraphQLTypes["BooleanCondition"] | undefined,
	customer?: GraphQLTypes["CustomerWhere"] | undefined,
	product?: GraphQLTypes["ProductWhere"] | undefined,
	and?: Array<GraphQLTypes["ProductCustomerPriceWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ProductCustomerPriceWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ProductCustomerPriceWhere"] | undefined
};
	["ProductMetadataWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	archived?: GraphQLTypes["BooleanCondition"] | undefined,
	available?: GraphQLTypes["BooleanCondition"] | undefined,
	availableQuantity?: GraphQLTypes["IntCondition"] | undefined,
	product?: GraphQLTypes["ProductWhere"] | undefined,
	and?: Array<GraphQLTypes["ProductMetadataWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ProductMetadataWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ProductMetadataWhere"] | undefined
};
	["ProductSalesDayWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	productName?: GraphQLTypes["StringCondition"] | undefined,
	orderDate?: GraphQLTypes["DateCondition"] | undefined,
	priceCentsSum?: GraphQLTypes["IntCondition"] | undefined,
	sum?: GraphQLTypes["IntCondition"] | undefined,
	product?: GraphQLTypes["ProductWhere"] | undefined,
	and?: Array<GraphQLTypes["ProductSalesDayWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ProductSalesDayWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ProductSalesDayWhere"] | undefined
};
	["ProductSalesWeekWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	productName?: GraphQLTypes["StringCondition"] | undefined,
	orderDate?: GraphQLTypes["DateCondition"] | undefined,
	priceCentsSum?: GraphQLTypes["IntCondition"] | undefined,
	sum?: GraphQLTypes["IntCondition"] | undefined,
	product?: GraphQLTypes["ProductWhere"] | undefined,
	and?: Array<GraphQLTypes["ProductSalesWeekWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ProductSalesWeekWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ProductSalesWeekWhere"] | undefined
};
	["ProductSalesMonthWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	productName?: GraphQLTypes["StringCondition"] | undefined,
	orderDate?: GraphQLTypes["DateCondition"] | undefined,
	priceCentsSum?: GraphQLTypes["IntCondition"] | undefined,
	sum?: GraphQLTypes["IntCondition"] | undefined,
	product?: GraphQLTypes["ProductWhere"] | undefined,
	and?: Array<GraphQLTypes["ProductSalesMonthWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ProductSalesMonthWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ProductSalesMonthWhere"] | undefined
};
	["AddressMetadataWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	deliveryZoneType?: GraphQLTypes["DeliveryZoneTypeCondition"] | undefined,
	address?: GraphQLTypes["AddressWhere"] | undefined,
	deliveryZone?: GraphQLTypes["DeliveryZoneWhere"] | undefined,
	and?: Array<GraphQLTypes["AddressMetadataWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["AddressMetadataWhere"] | undefined> | undefined,
	not?: GraphQLTypes["AddressMetadataWhere"] | undefined
};
	["DeliveryTimelinePresetWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	type?: GraphQLTypes["DeliveryTimelineTypeCondition"] | undefined,
	duration?: GraphQLTypes["StringCondition"] | undefined,
	window?: GraphQLTypes["StringCondition"] | undefined,
	deliveryMethod?: GraphQLTypes["DeliveryMethodWhere"] | undefined,
	and?: Array<GraphQLTypes["DeliveryTimelinePresetWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["DeliveryTimelinePresetWhere"] | undefined> | undefined,
	not?: GraphQLTypes["DeliveryTimelinePresetWhere"] | undefined
};
	["DeliveryTimelineTypeCondition"]: {
		and?: Array<GraphQLTypes["DeliveryTimelineTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["DeliveryTimelineTypeCondition"]> | undefined,
	not?: GraphQLTypes["DeliveryTimelineTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["DeliveryTimelineType"] | undefined,
	notEq?: GraphQLTypes["DeliveryTimelineType"] | undefined,
	in?: Array<GraphQLTypes["DeliveryTimelineType"]> | undefined,
	notIn?: Array<GraphQLTypes["DeliveryTimelineType"]> | undefined,
	lt?: GraphQLTypes["DeliveryTimelineType"] | undefined,
	lte?: GraphQLTypes["DeliveryTimelineType"] | undefined,
	gt?: GraphQLTypes["DeliveryTimelineType"] | undefined,
	gte?: GraphQLTypes["DeliveryTimelineType"] | undefined
};
	["DeliveryTimelineType"]: DeliveryTimelineType;
	["PaymentMethodTypeCondition"]: {
		and?: Array<GraphQLTypes["PaymentMethodTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["PaymentMethodTypeCondition"]> | undefined,
	not?: GraphQLTypes["PaymentMethodTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["PaymentMethodType"] | undefined,
	notEq?: GraphQLTypes["PaymentMethodType"] | undefined,
	in?: Array<GraphQLTypes["PaymentMethodType"]> | undefined,
	notIn?: Array<GraphQLTypes["PaymentMethodType"]> | undefined,
	lt?: GraphQLTypes["PaymentMethodType"] | undefined,
	lte?: GraphQLTypes["PaymentMethodType"] | undefined,
	gt?: GraphQLTypes["PaymentMethodType"] | undefined,
	gte?: GraphQLTypes["PaymentMethodType"] | undefined
};
	["PaymentMethodType"]: PaymentMethodType;
	["CustomerPermissionsWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	canPlaceOrder?: GraphQLTypes["BooleanCondition"] | undefined,
	customer?: GraphQLTypes["CustomerWhere"] | undefined,
	and?: Array<GraphQLTypes["CustomerPermissionsWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["CustomerPermissionsWhere"] | undefined> | undefined,
	not?: GraphQLTypes["CustomerPermissionsWhere"] | undefined
};
	["CustomerNameWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	nominative?: GraphQLTypes["StringCondition"] | undefined,
	vocative?: GraphQLTypes["StringCondition"] | undefined,
	customer?: GraphQLTypes["CustomerWhere"] | undefined,
	aliases?: GraphQLTypes["CustomerAliasWhere"] | undefined,
	and?: Array<GraphQLTypes["CustomerNameWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["CustomerNameWhere"] | undefined> | undefined,
	not?: GraphQLTypes["CustomerNameWhere"] | undefined
};
	["CustomerAliasWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	and?: Array<GraphQLTypes["CustomerAliasWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["CustomerAliasWhere"] | undefined> | undefined,
	not?: GraphQLTypes["CustomerAliasWhere"] | undefined
};
	["CustomerFamiliarityCondition"]: {
		and?: Array<GraphQLTypes["CustomerFamiliarityCondition"]> | undefined,
	or?: Array<GraphQLTypes["CustomerFamiliarityCondition"]> | undefined,
	not?: GraphQLTypes["CustomerFamiliarityCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	notEq?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	in?: Array<GraphQLTypes["CustomerFamiliarity"]> | undefined,
	notIn?: Array<GraphQLTypes["CustomerFamiliarity"]> | undefined,
	lt?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	lte?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	gt?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	gte?: GraphQLTypes["CustomerFamiliarity"] | undefined
};
	["CustomerFamiliarity"]: CustomerFamiliarity;
	["ApplicationShortcutListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	items?: GraphQLTypes["ApplicationShortcutListItemWhere"] | undefined,
	customer?: GraphQLTypes["CustomerWhere"] | undefined,
	and?: Array<GraphQLTypes["ApplicationShortcutListWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ApplicationShortcutListWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ApplicationShortcutListWhere"] | undefined
};
	["ApplicationShortcutListItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	application?: GraphQLTypes["ApplicationWhere"] | undefined,
	list?: GraphQLTypes["ApplicationShortcutListWhere"] | undefined,
	and?: Array<GraphQLTypes["ApplicationShortcutListItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ApplicationShortcutListItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ApplicationShortcutListItemWhere"] | undefined
};
	["ApplicationWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	handle?: GraphQLTypes["StringCondition"] | undefined,
	url?: GraphQLTypes["StringCondition"] | undefined,
	color?: GraphQLTypes["StringCondition"] | undefined,
	icon?: GraphQLTypes["ImageWhere"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	short?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["ApplicationWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ApplicationWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ApplicationWhere"] | undefined
};
	["InvoicingPlanWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	customer?: GraphQLTypes["CustomerWhere"] | undefined,
	preset?: GraphQLTypes["InvoicingPresetWhere"] | undefined,
	and?: Array<GraphQLTypes["InvoicingPlanWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["InvoicingPlanWhere"] | undefined> | undefined,
	not?: GraphQLTypes["InvoicingPlanWhere"] | undefined
};
	["InvoicingPresetWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	type?: GraphQLTypes["InvoicingPresetTypeCondition"] | undefined,
	startsAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	endsAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	intervalOfDays?: GraphQLTypes["IntCondition"] | undefined,
	invoicingPlan?: GraphQLTypes["InvoicingPlanWhere"] | undefined,
	and?: Array<GraphQLTypes["InvoicingPresetWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["InvoicingPresetWhere"] | undefined> | undefined,
	not?: GraphQLTypes["InvoicingPresetWhere"] | undefined
};
	["InvoicingPresetTypeCondition"]: {
		and?: Array<GraphQLTypes["InvoicingPresetTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["InvoicingPresetTypeCondition"]> | undefined,
	not?: GraphQLTypes["InvoicingPresetTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["InvoicingPresetType"] | undefined,
	notEq?: GraphQLTypes["InvoicingPresetType"] | undefined,
	in?: Array<GraphQLTypes["InvoicingPresetType"]> | undefined,
	notIn?: Array<GraphQLTypes["InvoicingPresetType"]> | undefined,
	lt?: GraphQLTypes["InvoicingPresetType"] | undefined,
	lte?: GraphQLTypes["InvoicingPresetType"] | undefined,
	gt?: GraphQLTypes["InvoicingPresetType"] | undefined,
	gte?: GraphQLTypes["InvoicingPresetType"] | undefined
};
	["InvoicingPresetType"]: InvoicingPresetType;
	["CustomerSpendingWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	totalCents?: GraphQLTypes["IntCondition"] | undefined,
	customer?: GraphQLTypes["CustomerWhere"] | undefined,
	and?: Array<GraphQLTypes["CustomerSpendingWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["CustomerSpendingWhere"] | undefined> | undefined,
	not?: GraphQLTypes["CustomerSpendingWhere"] | undefined
};
	["CustomerMetadataWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	isBusiness?: GraphQLTypes["BooleanCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	fallbackName?: GraphQLTypes["StringCondition"] | undefined,
	remainingCreditsCents?: GraphQLTypes["IntCondition"] | undefined,
	ordersTotalCents?: GraphQLTypes["IntCondition"] | undefined,
	customerProfileUrl?: GraphQLTypes["StringCondition"] | undefined,
	customer?: GraphQLTypes["CustomerWhere"] | undefined,
	and?: Array<GraphQLTypes["CustomerMetadataWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["CustomerMetadataWhere"] | undefined> | undefined,
	not?: GraphQLTypes["CustomerMetadataWhere"] | undefined
};
	["GpsWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	latitude?: GraphQLTypes["FloatCondition"] | undefined,
	longitude?: GraphQLTypes["FloatCondition"] | undefined,
	address?: GraphQLTypes["AddressWhere"] | undefined,
	and?: Array<GraphQLTypes["GpsWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["GpsWhere"] | undefined> | undefined,
	not?: GraphQLTypes["GpsWhere"] | undefined
};
	["AddressOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	firstName?: GraphQLTypes["OrderDirection"] | undefined,
	lastName?: GraphQLTypes["OrderDirection"] | undefined,
	addressLine2?: GraphQLTypes["OrderDirection"] | undefined,
	email?: GraphQLTypes["OrderDirection"] | undefined,
	phone?: GraphQLTypes["OrderDirection"] | undefined,
	companyName?: GraphQLTypes["OrderDirection"] | undefined,
	companyIdentifier?: GraphQLTypes["OrderDirection"] | undefined,
	vatIdentifier?: GraphQLTypes["OrderDirection"] | undefined,
	externalIdentifier?: GraphQLTypes["OrderDirection"] | undefined,
	hidden?: GraphQLTypes["OrderDirection"] | undefined,
	customer?: GraphQLTypes["CustomerOrderBy"] | undefined,
	internalNote?: GraphQLTypes["OrderDirection"] | undefined,
	country?: GraphQLTypes["CountryOrderBy"] | undefined,
	deletedAt?: GraphQLTypes["OrderDirection"] | undefined,
	note?: GraphQLTypes["OrderDirection"] | undefined,
	googlePlaceId?: GraphQLTypes["OrderDirection"] | undefined,
	raw?: GraphQLTypes["OrderDirection"] | undefined,
	formatted?: GraphQLTypes["OrderDirection"] | undefined,
	geocodeGeneratedAt?: GraphQLTypes["OrderDirection"] | undefined,
	geocodeResponse?: GraphQLTypes["OrderDirection"] | undefined,
	deliveryZone?: GraphQLTypes["DeliveryZoneOrderBy"] | undefined,
	meta?: GraphQLTypes["AddressMetadataOrderBy"] | undefined,
	gps?: GraphQLTypes["GpsOrderBy"] | undefined,
	geocodeValid?: GraphQLTypes["OrderDirection"] | undefined,
	fullName?: GraphQLTypes["OrderDirection"] | undefined,
	fakturoidSubjectId?: GraphQLTypes["OrderDirection"] | undefined,
	addressLine1?: GraphQLTypes["OrderDirection"] | undefined,
	city?: GraphQLTypes["OrderDirection"] | undefined,
	postalCode?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	defaultDeliveryAddressOfCustomer?: GraphQLTypes["CustomerOrderBy"] | undefined
};
	["OrderDirection"]: OrderDirection;
	["CustomerOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	defaultBillingAddress?: GraphQLTypes["AddressOrderBy"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerPaymentMethodOrderBy"] | undefined,
	permissions?: GraphQLTypes["CustomerPermissionsOrderBy"] | undefined,
	group?: GraphQLTypes["CustomerGroupOrderBy"] | undefined,
	photo?: GraphQLTypes["ImageOrderBy"] | undefined,
	phone?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["CustomerNameOrderBy"] | undefined,
	internalNote?: GraphQLTypes["OrderDirection"] | undefined,
	welcomeMessage?: GraphQLTypes["OrderDirection"] | undefined,
	familiarity?: GraphQLTypes["OrderDirection"] | undefined,
	business?: GraphQLTypes["BusinessCustomerOrderBy"] | undefined,
	shortcutList?: GraphQLTypes["ApplicationShortcutListOrderBy"] | undefined,
	user?: GraphQLTypes["UserOrderBy"] | undefined,
	disabledAt?: GraphQLTypes["OrderDirection"] | undefined,
	invoicingPlan?: GraphQLTypes["InvoicingPlanOrderBy"] | undefined,
	email?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	defaultDeliveryAddress?: GraphQLTypes["AddressOrderBy"] | undefined,
	defaultBillingSubject?: GraphQLTypes["BillingSubjectOrderBy"] | undefined,
	prefersPackingsWithoutCardboard?: GraphQLTypes["OrderDirection"] | undefined,
	anonymousSession?: GraphQLTypes["AnonymousSessionOrderBy"] | undefined,
	spending?: GraphQLTypes["CustomerSpendingOrderBy"] | undefined,
	doubleshotLegacyId?: GraphQLTypes["OrderDirection"] | undefined,
	meta?: GraphQLTypes["CustomerMetadataOrderBy"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["OrderDirection"] | undefined
};
	["CustomerPaymentMethodOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	caption?: GraphQLTypes["OrderDirection"] | undefined,
	data?: GraphQLTypes["OrderDirection"] | undefined,
	customer?: GraphQLTypes["CustomerOrderBy"] | undefined,
	paymentMethod?: GraphQLTypes["PaymentMethodOrderBy"] | undefined
};
	["PaymentMethodOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	code?: GraphQLTypes["OrderDirection"] | undefined,
	enabled?: GraphQLTypes["OrderDirection"] | undefined,
	description?: GraphQLTypes["OrderDirection"] | undefined,
	internalNote?: GraphQLTypes["OrderDirection"] | undefined,
	blockingDispatch?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	reduceGratuityByPercentage?: GraphQLTypes["OrderDirection"] | undefined
};
	["CustomerPermissionsOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	canPlaceOrder?: GraphQLTypes["OrderDirection"] | undefined,
	customer?: GraphQLTypes["CustomerOrderBy"] | undefined
};
	["CustomerGroupOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	discountPermille?: GraphQLTypes["OrderDirection"] | undefined,
	code?: GraphQLTypes["OrderDirection"] | undefined,
	doubleshotLegacyId?: GraphQLTypes["OrderDirection"] | undefined
};
	["ImageOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	url?: GraphQLTypes["OrderDirection"] | undefined,
	width?: GraphQLTypes["OrderDirection"] | undefined,
	height?: GraphQLTypes["OrderDirection"] | undefined,
	size?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	alt?: GraphQLTypes["OrderDirection"] | undefined
};
	["CustomerNameOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	nominative?: GraphQLTypes["OrderDirection"] | undefined,
	vocative?: GraphQLTypes["OrderDirection"] | undefined,
	customer?: GraphQLTypes["CustomerOrderBy"] | undefined
};
	["BusinessCustomerOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	customer?: GraphQLTypes["CustomerOrderBy"] | undefined,
	category?: GraphQLTypes["BusinessCategoryOrderBy"] | undefined,
	accountManager?: GraphQLTypes["BusinessToBusinessManagerOrderBy"] | undefined,
	logo?: GraphQLTypes["ImageOrderBy"] | undefined,
	note?: GraphQLTypes["OrderDirection"] | undefined,
	doubleshotCoffeeEquipment?: GraphQLTypes["DoubleshotCoffeeEquipmentOrderBy"] | undefined
};
	["BusinessCategoryOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	visibleToNewCustomers?: GraphQLTypes["OrderDirection"] | undefined,
	internalName?: GraphQLTypes["OrderDirection"] | undefined,
	specificProducts?: GraphQLTypes["ProductListOrderBy"] | undefined,
	seasonalProductCategories?: GraphQLTypes["ProductCategoryListOrderBy"] | undefined,
	specificProductsProductCategories?: GraphQLTypes["ProductCategoryListOrderBy"] | undefined,
	slug?: GraphQLTypes["OrderDirection"] | undefined
};
	["ProductListOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	businessCategory?: GraphQLTypes["BusinessCategoryOrderBy"] | undefined
};
	["ProductCategoryListOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	seasonalProductCategoriesOfBusinessCategory?: GraphQLTypes["BusinessCategoryOrderBy"] | undefined,
	specificProductsProductCategoriesOfBusinessCategory?: GraphQLTypes["BusinessCategoryOrderBy"] | undefined
};
	["BusinessToBusinessManagerOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	staff?: GraphQLTypes["StaffOrderBy"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined
};
	["StaffOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	bartender?: GraphQLTypes["BartenderOrderBy"] | undefined,
	courier?: GraphQLTypes["CourierOrderBy"] | undefined,
	cleaner?: GraphQLTypes["CleanerOrderBy"] | undefined,
	shiftsManager?: GraphQLTypes["ShiftsManagerOrderBy"] | undefined,
	businessToBusinessManager?: GraphQLTypes["BusinessToBusinessManagerOrderBy"] | undefined,
	user?: GraphQLTypes["UserOrderBy"] | undefined,
	shiftsProfile?: GraphQLTypes["ShiftsProfileOrderBy"] | undefined,
	stocksManager?: GraphQLTypes["StocksManagerOrderBy"] | undefined,
	photo?: GraphQLTypes["ImageOrderBy"] | undefined,
	courierManager?: GraphQLTypes["CourierManagerOrderBy"] | undefined,
	picker?: GraphQLTypes["PickerOrderBy"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	remunerationProfile?: GraphQLTypes["RemunerationProfileOrderBy"] | undefined,
	cashier?: GraphQLTypes["CashierOrderBy"] | undefined,
	internalBuyer?: GraphQLTypes["InternalBuyerOrderBy"] | undefined,
	salesManager?: GraphQLTypes["SalesManagerOrderBy"] | undefined,
	cashierManager?: GraphQLTypes["CashierManagerOrderBy"] | undefined
};
	["BartenderOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	staff?: GraphQLTypes["StaffOrderBy"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined
};
	["CourierOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	staff?: GraphQLTypes["StaffOrderBy"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	showInPicker?: GraphQLTypes["OrderDirection"] | undefined
};
	["CleanerOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	staff?: GraphQLTypes["StaffOrderBy"] | undefined,
	canReachTopShelf?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined
};
	["ShiftsManagerOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	staff?: GraphQLTypes["StaffOrderBy"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined
};
	["UserOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	internalNote?: GraphQLTypes["OrderDirection"] | undefined,
	staff?: GraphQLTypes["StaffOrderBy"] | undefined,
	customer?: GraphQLTypes["CustomerOrderBy"] | undefined,
	tenantPersonId?: GraphQLTypes["OrderDirection"] | undefined,
	disabledAt?: GraphQLTypes["OrderDirection"] | undefined,
	verifiedAt?: GraphQLTypes["OrderDirection"] | undefined,
	email?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	deletionRequestedAt?: GraphQLTypes["OrderDirection"] | undefined,
	deletionExpectedAt?: GraphQLTypes["OrderDirection"] | undefined,
	deletedAt?: GraphQLTypes["OrderDirection"] | undefined,
	meta?: GraphQLTypes["UserMetadataOrderBy"] | undefined,
	roles?: GraphQLTypes["UserRolesOrderBy"] | undefined
};
	["UserMetadataOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	userProfileUrl?: GraphQLTypes["OrderDirection"] | undefined,
	tenantEmail?: GraphQLTypes["OrderDirection"] | undefined,
	tenantPersonId?: GraphQLTypes["OrderDirection"] | undefined,
	tenantIdentityId?: GraphQLTypes["OrderDirection"] | undefined,
	globalRoles?: GraphQLTypes["OrderDirection"] | undefined,
	projectRoles?: GraphQLTypes["OrderDirection"] | undefined,
	projectRolesString?: GraphQLTypes["OrderDirection"] | undefined,
	externalIdentifiers?: GraphQLTypes["OrderDirection"] | undefined,
	externalIdentifiersString?: GraphQLTypes["OrderDirection"] | undefined,
	idpSlugs?: GraphQLTypes["OrderDirection"] | undefined,
	idpSlugsString?: GraphQLTypes["OrderDirection"] | undefined,
	user?: GraphQLTypes["UserOrderBy"] | undefined
};
	["UserRolesOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	isCustomer?: GraphQLTypes["OrderDirection"] | undefined,
	isStaff?: GraphQLTypes["OrderDirection"] | undefined,
	isBartender?: GraphQLTypes["OrderDirection"] | undefined,
	isCashier?: GraphQLTypes["OrderDirection"] | undefined,
	isCourier?: GraphQLTypes["OrderDirection"] | undefined,
	isCleaner?: GraphQLTypes["OrderDirection"] | undefined,
	isShiftsManager?: GraphQLTypes["OrderDirection"] | undefined,
	isInternalBuyer?: GraphQLTypes["OrderDirection"] | undefined,
	isStocksManager?: GraphQLTypes["OrderDirection"] | undefined,
	isCourierManager?: GraphQLTypes["OrderDirection"] | undefined,
	isCashierManager?: GraphQLTypes["OrderDirection"] | undefined,
	isBusinessToBusinessManager?: GraphQLTypes["OrderDirection"] | undefined,
	isPicker?: GraphQLTypes["OrderDirection"] | undefined,
	user?: GraphQLTypes["UserOrderBy"] | undefined
};
	["ShiftsProfileOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	staff?: GraphQLTypes["StaffOrderBy"] | undefined,
	allowSelfUnassigning?: GraphQLTypes["OrderDirection"] | undefined
};
	["StocksManagerOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	staff?: GraphQLTypes["StaffOrderBy"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined
};
	["CourierManagerOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	staff?: GraphQLTypes["StaffOrderBy"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined
};
	["PickerOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	staff?: GraphQLTypes["StaffOrderBy"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined
};
	["RemunerationProfileOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	workMonths?: GraphQLTypes["WorkMonthOrderBy"] | undefined,
	staff?: GraphQLTypes["StaffOrderBy"] | undefined
};
	["WorkMonthOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	year?: GraphQLTypes["OrderDirection"] | undefined,
	month?: GraphQLTypes["OrderDirection"] | undefined,
	hoursWorked?: GraphQLTypes["OrderDirection"] | undefined,
	billableHours?: GraphQLTypes["OrderDirection"] | undefined
};
	["CashierOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	staff?: GraphQLTypes["StaffOrderBy"] | undefined
};
	["InternalBuyerOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	staff?: GraphQLTypes["StaffOrderBy"] | undefined
};
	["SalesManagerOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	staff?: GraphQLTypes["StaffOrderBy"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined
};
	["CashierManagerOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	staff?: GraphQLTypes["StaffOrderBy"] | undefined
};
	["DoubleshotCoffeeEquipmentOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	espressoMachine?: GraphQLTypes["OrderDirection"] | undefined,
	espressoGrinder?: GraphQLTypes["OrderDirection"] | undefined,
	batchBrew?: GraphQLTypes["OrderDirection"] | undefined,
	batchGrinder?: GraphQLTypes["OrderDirection"] | undefined,
	waterFilter?: GraphQLTypes["OrderDirection"] | undefined,
	mechanicalFilter?: GraphQLTypes["OrderDirection"] | undefined
};
	["ApplicationShortcutListOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	customer?: GraphQLTypes["CustomerOrderBy"] | undefined
};
	["InvoicingPlanOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	customer?: GraphQLTypes["CustomerOrderBy"] | undefined,
	preset?: GraphQLTypes["InvoicingPresetOrderBy"] | undefined
};
	["InvoicingPresetOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	startsAt?: GraphQLTypes["OrderDirection"] | undefined,
	endsAt?: GraphQLTypes["OrderDirection"] | undefined,
	intervalOfDays?: GraphQLTypes["OrderDirection"] | undefined,
	invoicingPlan?: GraphQLTypes["InvoicingPlanOrderBy"] | undefined
};
	["BillingSubjectOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	fullName?: GraphQLTypes["OrderDirection"] | undefined,
	addressLine1?: GraphQLTypes["OrderDirection"] | undefined,
	addressLine2?: GraphQLTypes["OrderDirection"] | undefined,
	city?: GraphQLTypes["OrderDirection"] | undefined,
	postalCode?: GraphQLTypes["OrderDirection"] | undefined,
	email?: GraphQLTypes["OrderDirection"] | undefined,
	phone?: GraphQLTypes["OrderDirection"] | undefined,
	companyName?: GraphQLTypes["OrderDirection"] | undefined,
	companyIdentifier?: GraphQLTypes["OrderDirection"] | undefined,
	vatIdentifier?: GraphQLTypes["OrderDirection"] | undefined,
	externalIdentifier?: GraphQLTypes["OrderDirection"] | undefined,
	hidden?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	deletedAt?: GraphQLTypes["OrderDirection"] | undefined,
	note?: GraphQLTypes["OrderDirection"] | undefined,
	internalNote?: GraphQLTypes["OrderDirection"] | undefined,
	fakturoidSubjectId?: GraphQLTypes["OrderDirection"] | undefined,
	country?: GraphQLTypes["CountryOrderBy"] | undefined,
	customer?: GraphQLTypes["CustomerOrderBy"] | undefined,
	defaultBillingSubjectOfCustomer?: GraphQLTypes["CustomerOrderBy"] | undefined
};
	["CountryOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	code?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined
};
	["AnonymousSessionOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	lastActiveAt?: GraphQLTypes["OrderDirection"] | undefined,
	anonymousSessionKey?: GraphQLTypes["OrderDirection"] | undefined,
	email?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	internalNote?: GraphQLTypes["OrderDirection"] | undefined,
	customer?: GraphQLTypes["CustomerOrderBy"] | undefined
};
	["CustomerSpendingOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	totalCents?: GraphQLTypes["OrderDirection"] | undefined,
	customer?: GraphQLTypes["CustomerOrderBy"] | undefined
};
	["CustomerMetadataOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	isBusiness?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	fallbackName?: GraphQLTypes["OrderDirection"] | undefined,
	remainingCreditsCents?: GraphQLTypes["OrderDirection"] | undefined,
	ordersTotalCents?: GraphQLTypes["OrderDirection"] | undefined,
	customerProfileUrl?: GraphQLTypes["OrderDirection"] | undefined,
	customer?: GraphQLTypes["CustomerOrderBy"] | undefined
};
	["DeliveryZoneOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	code?: GraphQLTypes["OrderDirection"] | undefined,
	description?: GraphQLTypes["OrderDirection"] | undefined,
	internalNote?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined
};
	["AddressMetadataOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	deliveryZoneType?: GraphQLTypes["OrderDirection"] | undefined,
	address?: GraphQLTypes["AddressOrderBy"] | undefined,
	deliveryZone?: GraphQLTypes["DeliveryZoneOrderBy"] | undefined
};
	["GpsOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	latitude?: GraphQLTypes["OrderDirection"] | undefined,
	longitude?: GraphQLTypes["OrderDirection"] | undefined,
	address?: GraphQLTypes["AddressOrderBy"] | undefined
};
	["CustomerPaymentMethod"]: {
	__typename: "CustomerPaymentMethod",
	_meta?: GraphQLTypes["CustomerPaymentMethodMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	caption: string,
	data?: GraphQLTypes["Json"] | undefined,
	customer?: GraphQLTypes["Customer"] | undefined,
	paymentMethod?: GraphQLTypes["PaymentMethod"] | undefined
};
	["CustomerPaymentMethodMeta"]: {
	__typename: "CustomerPaymentMethodMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	caption?: GraphQLTypes["FieldMeta"] | undefined,
	data?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined,
	paymentMethod?: GraphQLTypes["FieldMeta"] | undefined
};
	["Json"]: any;
	["PaymentMethod"]: {
	__typename: "PaymentMethod",
	_meta?: GraphQLTypes["PaymentMethodMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	code?: string | undefined,
	enabled: boolean,
	deliveryMethods: Array<GraphQLTypes["DeliveryMethod"]>,
	description?: string | undefined,
	internalNote?: string | undefined,
	blockingDispatch: boolean,
	type?: GraphQLTypes["PaymentMethodType"] | undefined,
	channels: Array<GraphQLTypes["ChannelPayment"]>,
	reduceGratuityByPercentage: number,
	paginateDeliveryMethods: GraphQLTypes["DeliveryMethodConnection"],
	paginateChannels: GraphQLTypes["ChannelPaymentConnection"]
};
	["PaymentMethodMeta"]: {
	__typename: "PaymentMethodMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	code?: GraphQLTypes["FieldMeta"] | undefined,
	enabled?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryMethods?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	blockingDispatch?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	channels?: GraphQLTypes["FieldMeta"] | undefined,
	reduceGratuityByPercentage?: GraphQLTypes["FieldMeta"] | undefined
};
	["DeliveryMethod"]: {
	__typename: "DeliveryMethod",
	_meta?: GraphQLTypes["DeliveryMethodMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	code?: string | undefined,
	enabled: boolean,
	paymentMethods: Array<GraphQLTypes["PaymentMethod"]>,
	description?: string | undefined,
	internalNote?: string | undefined,
	requireDeliveryAddress: boolean,
	suitableForDeliveryZones: Array<GraphQLTypes["DeliveryZone"]>,
	channels: Array<GraphQLTypes["ChannelDelivery"]>,
	courierHandlers: Array<GraphQLTypes["Courier"]>,
	enableDeliveryTracking: boolean,
	locales: Array<GraphQLTypes["DeliveryMethodLocale"]>,
	timelinePreset?: GraphQLTypes["DeliveryTimelinePreset"] | undefined,
	woltDriveVenueId?: string | undefined,
	localesByLocale?: GraphQLTypes["DeliveryMethodLocale"] | undefined,
	paginatePaymentMethods: GraphQLTypes["PaymentMethodConnection"],
	paginateSuitableForDeliveryZones: GraphQLTypes["DeliveryZoneConnection"],
	paginateChannels: GraphQLTypes["ChannelDeliveryConnection"],
	paginateCourierHandlers: GraphQLTypes["CourierConnection"],
	paginateLocales: GraphQLTypes["DeliveryMethodLocaleConnection"]
};
	["DeliveryMethodMeta"]: {
	__typename: "DeliveryMethodMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	code?: GraphQLTypes["FieldMeta"] | undefined,
	enabled?: GraphQLTypes["FieldMeta"] | undefined,
	paymentMethods?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	requireDeliveryAddress?: GraphQLTypes["FieldMeta"] | undefined,
	suitableForDeliveryZones?: GraphQLTypes["FieldMeta"] | undefined,
	channels?: GraphQLTypes["FieldMeta"] | undefined,
	courierHandlers?: GraphQLTypes["FieldMeta"] | undefined,
	enableDeliveryTracking?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	timelinePreset?: GraphQLTypes["FieldMeta"] | undefined,
	woltDriveVenueId?: GraphQLTypes["FieldMeta"] | undefined
};
	["DeliveryZone"]: {
	__typename: "DeliveryZone",
	_meta?: GraphQLTypes["DeliveryZoneMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	code?: string | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	type: GraphQLTypes["DeliveryZoneType"],
	addresses: Array<GraphQLTypes["Address"]>,
	suitableDeliveryMethods: Array<GraphQLTypes["DeliveryMethod"]>,
	deliveryZonesOfTags: Array<GraphQLTypes["Tag"]>,
	deliveryZonesOfProducts: Array<GraphQLTypes["Product"]>,
	addressesMetadata: Array<GraphQLTypes["AddressMetadata"]>,
	addressesByMeta?: GraphQLTypes["Address"] | undefined,
	addressesByGps?: GraphQLTypes["Address"] | undefined,
	addressesByInvoices?: GraphQLTypes["Address"] | undefined,
	addressesByBillingAddressOfOrders?: GraphQLTypes["Address"] | undefined,
	addressesByDeliveryAddressOfOrderDeliveries?: GraphQLTypes["Address"] | undefined,
	addressesByDefaultDeliveryAddressOfCustomer?: GraphQLTypes["Address"] | undefined,
	addressesMetadataByAddress?: GraphQLTypes["AddressMetadata"] | undefined,
	paginateAddresses: GraphQLTypes["AddressConnection"],
	paginateSuitableDeliveryMethods: GraphQLTypes["DeliveryMethodConnection"],
	paginateDeliveryZonesOfTags: GraphQLTypes["TagConnection"],
	paginateDeliveryZonesOfProducts: GraphQLTypes["ProductConnection"],
	paginateAddressesMetadata: GraphQLTypes["AddressMetadataConnection"]
};
	["DeliveryZoneMeta"]: {
	__typename: "DeliveryZoneMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	code?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	addresses?: GraphQLTypes["FieldMeta"] | undefined,
	suitableDeliveryMethods?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryZonesOfTags?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryZonesOfProducts?: GraphQLTypes["FieldMeta"] | undefined,
	addressesMetadata?: GraphQLTypes["FieldMeta"] | undefined
};
	["DeliveryMethodOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	code?: GraphQLTypes["OrderDirection"] | undefined,
	enabled?: GraphQLTypes["OrderDirection"] | undefined,
	description?: GraphQLTypes["OrderDirection"] | undefined,
	internalNote?: GraphQLTypes["OrderDirection"] | undefined,
	requireDeliveryAddress?: GraphQLTypes["OrderDirection"] | undefined,
	enableDeliveryTracking?: GraphQLTypes["OrderDirection"] | undefined,
	timelinePreset?: GraphQLTypes["DeliveryTimelinePresetOrderBy"] | undefined,
	woltDriveVenueId?: GraphQLTypes["OrderDirection"] | undefined
};
	["DeliveryTimelinePresetOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	duration?: GraphQLTypes["OrderDirection"] | undefined,
	window?: GraphQLTypes["OrderDirection"] | undefined,
	deliveryMethod?: GraphQLTypes["DeliveryMethodOrderBy"] | undefined
};
	["Tag"]: {
	__typename: "Tag",
	_meta?: GraphQLTypes["TagMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	code?: string | undefined,
	customers: Array<GraphQLTypes["Customer"]>,
	products: Array<GraphQLTypes["Product"]>,
	categories: Array<GraphQLTypes["ProductCategory"]>,
	description?: string | undefined,
	internalNote?: string | undefined,
	addTagsOnRegistration: Array<GraphQLTypes["Channel"]>,
	nestedCategories: Array<GraphQLTypes["InheritedProductCategoryTag"]>,
	deliveryZones: Array<GraphQLTypes["DeliveryZone"]>,
	publicInChannels: Array<GraphQLTypes["Channel"]>,
	allowChannelPayments: Array<GraphQLTypes["ChannelPayment"]>,
	fulfillmentNotes: Array<GraphQLTypes["FulfillmentNote"]>,
	paginateCustomers: GraphQLTypes["CustomerConnection"],
	paginateProducts: GraphQLTypes["ProductConnection"],
	paginateCategories: GraphQLTypes["ProductCategoryConnection"],
	paginateAddTagsOnRegistration: GraphQLTypes["ChannelConnection"],
	paginateNestedCategories: GraphQLTypes["InheritedProductCategoryTagConnection"],
	paginateDeliveryZones: GraphQLTypes["DeliveryZoneConnection"],
	paginatePublicInChannels: GraphQLTypes["ChannelConnection"],
	paginateAllowChannelPayments: GraphQLTypes["ChannelPaymentConnection"],
	paginateFulfillmentNotes: GraphQLTypes["FulfillmentNoteConnection"]
};
	["TagMeta"]: {
	__typename: "TagMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	code?: GraphQLTypes["FieldMeta"] | undefined,
	customers?: GraphQLTypes["FieldMeta"] | undefined,
	products?: GraphQLTypes["FieldMeta"] | undefined,
	categories?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	addTagsOnRegistration?: GraphQLTypes["FieldMeta"] | undefined,
	nestedCategories?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryZones?: GraphQLTypes["FieldMeta"] | undefined,
	publicInChannels?: GraphQLTypes["FieldMeta"] | undefined,
	allowChannelPayments?: GraphQLTypes["FieldMeta"] | undefined,
	fulfillmentNotes?: GraphQLTypes["FieldMeta"] | undefined
};
	["Product"]: {
	__typename: "Product",
	_meta?: GraphQLTypes["ProductMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	code: string,
	priceCents: number,
	notDiscountable: boolean,
	packing?: GraphQLTypes["ProductPacking"] | undefined,
	recipe?: GraphQLTypes["ProductRecipe"] | undefined,
	tags: Array<GraphQLTypes["Tag"]>,
	categories: Array<GraphQLTypes["ProductCategory"]>,
	vatRate?: GraphQLTypes["VatRate"] | undefined,
	stocks: Array<GraphQLTypes["ProductStock"]>,
	groupPrices: Array<GraphQLTypes["ProductGroupPrice"]>,
	image?: GraphQLTypes["Image"] | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	cartItems: Array<GraphQLTypes["CartItem"]>,
	availability: GraphQLTypes["ProductAvailability"],
	order: number,
	manager?: GraphQLTypes["StocksManager"] | undefined,
	orderItems: Array<GraphQLTypes["OrderItem"]>,
	maximumQuantityPerOrder?: number | undefined,
	inheritedCategories: Array<GraphQLTypes["NestedProductCategoryProduct"]>,
	deliveryZones: Array<GraphQLTypes["DeliveryZone"]>,
	locales: Array<GraphQLTypes["ProductLocale"]>,
	archivedAt?: GraphQLTypes["DateTime"] | undefined,
	customerPrices: Array<GraphQLTypes["ProductCustomerPrice"]>,
	virtualProduct?: GraphQLTypes["VirtualProduct"] | undefined,
	meta?: GraphQLTypes["ProductMetadata"] | undefined,
	page?: GraphQLTypes["Page"] | undefined,
	salesDays: Array<GraphQLTypes["ProductSalesDay"]>,
	salesWeeks: Array<GraphQLTypes["ProductSalesWeek"]>,
	salesMonths: Array<GraphQLTypes["ProductSalesMonth"]>,
	fulfillmentNotes: Array<GraphQLTypes["FulfillmentNote"]>,
	hasSubscription: boolean,
	pointOfSaleTileColor?: string | undefined,
	stocksByStore?: GraphQLTypes["ProductStock"] | undefined,
	groupPricesByGroup?: GraphQLTypes["ProductGroupPrice"] | undefined,
	cartItemsByCart?: GraphQLTypes["CartItem"] | undefined,
	orderItemsByVirtualProductEffects?: GraphQLTypes["OrderItem"] | undefined,
	localesByLocale?: GraphQLTypes["ProductLocale"] | undefined,
	localesByFeatureList?: GraphQLTypes["ProductLocale"] | undefined,
	customerPricesByCustomer?: GraphQLTypes["ProductCustomerPrice"] | undefined,
	paginateTags: GraphQLTypes["TagConnection"],
	paginateCategories: GraphQLTypes["ProductCategoryConnection"],
	paginateStocks: GraphQLTypes["ProductStockConnection"],
	paginateGroupPrices: GraphQLTypes["ProductGroupPriceConnection"],
	paginateCartItems: GraphQLTypes["CartItemConnection"],
	paginateOrderItems: GraphQLTypes["OrderItemConnection"],
	paginateInheritedCategories: GraphQLTypes["NestedProductCategoryProductConnection"],
	paginateDeliveryZones: GraphQLTypes["DeliveryZoneConnection"],
	paginateLocales: GraphQLTypes["ProductLocaleConnection"],
	paginateCustomerPrices: GraphQLTypes["ProductCustomerPriceConnection"],
	paginateSalesDays: GraphQLTypes["ProductSalesDayConnection"],
	paginateSalesWeeks: GraphQLTypes["ProductSalesWeekConnection"],
	paginateSalesMonths: GraphQLTypes["ProductSalesMonthConnection"],
	paginateFulfillmentNotes: GraphQLTypes["FulfillmentNoteConnection"]
};
	["ProductMeta"]: {
	__typename: "ProductMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	code?: GraphQLTypes["FieldMeta"] | undefined,
	priceCents?: GraphQLTypes["FieldMeta"] | undefined,
	notDiscountable?: GraphQLTypes["FieldMeta"] | undefined,
	packing?: GraphQLTypes["FieldMeta"] | undefined,
	recipe?: GraphQLTypes["FieldMeta"] | undefined,
	tags?: GraphQLTypes["FieldMeta"] | undefined,
	categories?: GraphQLTypes["FieldMeta"] | undefined,
	vatRate?: GraphQLTypes["FieldMeta"] | undefined,
	stocks?: GraphQLTypes["FieldMeta"] | undefined,
	groupPrices?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	cartItems?: GraphQLTypes["FieldMeta"] | undefined,
	availability?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	manager?: GraphQLTypes["FieldMeta"] | undefined,
	orderItems?: GraphQLTypes["FieldMeta"] | undefined,
	maximumQuantityPerOrder?: GraphQLTypes["FieldMeta"] | undefined,
	inheritedCategories?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryZones?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	archivedAt?: GraphQLTypes["FieldMeta"] | undefined,
	customerPrices?: GraphQLTypes["FieldMeta"] | undefined,
	virtualProduct?: GraphQLTypes["FieldMeta"] | undefined,
	meta?: GraphQLTypes["FieldMeta"] | undefined,
	page?: GraphQLTypes["FieldMeta"] | undefined,
	salesDays?: GraphQLTypes["FieldMeta"] | undefined,
	salesWeeks?: GraphQLTypes["FieldMeta"] | undefined,
	salesMonths?: GraphQLTypes["FieldMeta"] | undefined,
	fulfillmentNotes?: GraphQLTypes["FieldMeta"] | undefined,
	hasSubscription?: GraphQLTypes["FieldMeta"] | undefined,
	pointOfSaleTileColor?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductPacking"]: {
	__typename: "ProductPacking",
	_meta?: GraphQLTypes["ProductPackingMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	image?: GraphQLTypes["Image"] | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	volumeMl?: number | undefined,
	icon?: GraphQLTypes["Image"] | undefined,
	shortName?: string | undefined,
	locales: Array<GraphQLTypes["ProductPackingLocale"]>,
	preparedPackingQuantities: Array<GraphQLTypes["PreparedPackingQuantity"]>,
	isPackedInCardboard: boolean,
	localesByLocale?: GraphQLTypes["ProductPackingLocale"] | undefined,
	paginateLocales: GraphQLTypes["ProductPackingLocaleConnection"],
	paginatePreparedPackingQuantities: GraphQLTypes["PreparedPackingQuantityConnection"]
};
	["ProductPackingMeta"]: {
	__typename: "ProductPackingMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	volumeMl?: GraphQLTypes["FieldMeta"] | undefined,
	icon?: GraphQLTypes["FieldMeta"] | undefined,
	shortName?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	preparedPackingQuantities?: GraphQLTypes["FieldMeta"] | undefined,
	isPackedInCardboard?: GraphQLTypes["FieldMeta"] | undefined
};
	["Image"]: {
	__typename: "Image",
	_meta?: GraphQLTypes["ImageMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	url: string,
	width?: number | undefined,
	height?: number | undefined,
	size?: number | undefined,
	type?: string | undefined,
	alt?: string | undefined
};
	["ImageMeta"]: {
	__typename: "ImageMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	url?: GraphQLTypes["FieldMeta"] | undefined,
	width?: GraphQLTypes["FieldMeta"] | undefined,
	height?: GraphQLTypes["FieldMeta"] | undefined,
	size?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	alt?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductPackingLocale"]: {
	__typename: "ProductPackingLocale",
	_meta?: GraphQLTypes["ProductPackingLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	shortName?: string | undefined,
	description?: string | undefined,
	root?: GraphQLTypes["ProductPacking"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined
};
	["ProductPackingLocaleMeta"]: {
	__typename: "ProductPackingLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	shortName?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined
};
	["Locale"]: {
	__typename: "Locale",
	_meta?: GraphQLTypes["LocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	businessCategories: Array<GraphQLTypes["BusinessCategoryLocale"]>,
	productCategoryLists: Array<GraphQLTypes["ProductCategoryListLocale"]>,
	productIngredients: Array<GraphQLTypes["ProductIngredientLocale"]>,
	orderRecurrences: Array<GraphQLTypes["OrderRecurrenceLocale"]>,
	blogs: Array<GraphQLTypes["BlogLocale"]>,
	blogPosts: Array<GraphQLTypes["BlogPostLocale"]>,
	identifier?: GraphQLTypes["TranslationCataloguesIdentifier"] | undefined,
	menus: Array<GraphQLTypes["MenuLocale"]>,
	pages: Array<GraphQLTypes["PageLocale"]>,
	productIngredientCategories: Array<GraphQLTypes["ProductIngredientCategoryLocale"]>,
	allergens: Array<GraphQLTypes["AllergenLocale"]>,
	productPackings: Array<GraphQLTypes["ProductPackingLocale"]>,
	products: Array<GraphQLTypes["ProductLocale"]>,
	productRecipes: Array<GraphQLTypes["ProductRecipeLocale"]>,
	pointOfSaleCategories: Array<GraphQLTypes["PointOfSaleCategoryLocale"]>,
	pointOfSaleCategoryProducts: Array<GraphQLTypes["PointOfSaleCategoryProductLocale"]>,
	deliveryMethods: Array<GraphQLTypes["DeliveryMethodLocale"]>,
	ingredientSuppliers: Array<GraphQLTypes["IngredientSupplierLocale"]>,
	identificationCodes: Array<GraphQLTypes["IdentificationCodeLocale"]>,
	pipelineStages: Array<GraphQLTypes["PipelineStageLocale"]>,
	subscriptionBoxes: Array<GraphQLTypes["SubscriptionBoxLocale"]>,
	businessServices: Array<GraphQLTypes["BusinessServiceLocale"]>,
	businessCategoriesByRoot?: GraphQLTypes["BusinessCategoryLocale"] | undefined,
	productCategoryListsByRoot?: GraphQLTypes["ProductCategoryListLocale"] | undefined,
	productIngredientsByRoot?: GraphQLTypes["ProductIngredientLocale"] | undefined,
	orderRecurrencesByRoot?: GraphQLTypes["OrderRecurrenceLocale"] | undefined,
	blogsByRoot?: GraphQLTypes["BlogLocale"] | undefined,
	blogPostsByRoot?: GraphQLTypes["BlogPostLocale"] | undefined,
	blogPostsByCover?: GraphQLTypes["BlogPostLocale"] | undefined,
	blogPostsByContent?: GraphQLTypes["BlogPostLocale"] | undefined,
	blogPostsByLink?: GraphQLTypes["BlogPostLocale"] | undefined,
	blogPostsBySeo?: GraphQLTypes["BlogPostLocale"] | undefined,
	menusByRoot?: GraphQLTypes["MenuLocale"] | undefined,
	menusByItems?: GraphQLTypes["MenuLocale"] | undefined,
	menusBySecondaryItems?: GraphQLTypes["MenuLocale"] | undefined,
	pagesByRoot?: GraphQLTypes["PageLocale"] | undefined,
	pagesByLink?: GraphQLTypes["PageLocale"] | undefined,
	pagesBySeo?: GraphQLTypes["PageLocale"] | undefined,
	pagesByContent?: GraphQLTypes["PageLocale"] | undefined,
	pagesByCover?: GraphQLTypes["PageLocale"] | undefined,
	productIngredientCategoriesByRoot?: GraphQLTypes["ProductIngredientCategoryLocale"] | undefined,
	allergensByRoot?: GraphQLTypes["AllergenLocale"] | undefined,
	productPackingsByRoot?: GraphQLTypes["ProductPackingLocale"] | undefined,
	productsByRoot?: GraphQLTypes["ProductLocale"] | undefined,
	productsByFeatureList?: GraphQLTypes["ProductLocale"] | undefined,
	productRecipesByRoot?: GraphQLTypes["ProductRecipeLocale"] | undefined,
	pointOfSaleCategoriesByRoot?: GraphQLTypes["PointOfSaleCategoryLocale"] | undefined,
	pointOfSaleCategoryProductsByRoot?: GraphQLTypes["PointOfSaleCategoryProductLocale"] | undefined,
	deliveryMethodsByRoot?: GraphQLTypes["DeliveryMethodLocale"] | undefined,
	ingredientSuppliersByRoot?: GraphQLTypes["IngredientSupplierLocale"] | undefined,
	identificationCodesByRoot?: GraphQLTypes["IdentificationCodeLocale"] | undefined,
	pipelineStagesByRoot?: GraphQLTypes["PipelineStageLocale"] | undefined,
	subscriptionBoxesByRoot?: GraphQLTypes["SubscriptionBoxLocale"] | undefined,
	subscriptionBoxesByTexts?: GraphQLTypes["SubscriptionBoxLocale"] | undefined,
	subscriptionBoxesBySecondaryTexts?: GraphQLTypes["SubscriptionBoxLocale"] | undefined,
	businessServicesByRoot?: GraphQLTypes["BusinessServiceLocale"] | undefined,
	paginateBusinessCategories: GraphQLTypes["BusinessCategoryLocaleConnection"],
	paginateProductCategoryLists: GraphQLTypes["ProductCategoryListLocaleConnection"],
	paginateProductIngredients: GraphQLTypes["ProductIngredientLocaleConnection"],
	paginateOrderRecurrences: GraphQLTypes["OrderRecurrenceLocaleConnection"],
	paginateBlogs: GraphQLTypes["BlogLocaleConnection"],
	paginateBlogPosts: GraphQLTypes["BlogPostLocaleConnection"],
	paginateMenus: GraphQLTypes["MenuLocaleConnection"],
	paginatePages: GraphQLTypes["PageLocaleConnection"],
	paginateProductIngredientCategories: GraphQLTypes["ProductIngredientCategoryLocaleConnection"],
	paginateAllergens: GraphQLTypes["AllergenLocaleConnection"],
	paginateProductPackings: GraphQLTypes["ProductPackingLocaleConnection"],
	paginateProducts: GraphQLTypes["ProductLocaleConnection"],
	paginateProductRecipes: GraphQLTypes["ProductRecipeLocaleConnection"],
	paginatePointOfSaleCategories: GraphQLTypes["PointOfSaleCategoryLocaleConnection"],
	paginatePointOfSaleCategoryProducts: GraphQLTypes["PointOfSaleCategoryProductLocaleConnection"],
	paginateDeliveryMethods: GraphQLTypes["DeliveryMethodLocaleConnection"],
	paginateIngredientSuppliers: GraphQLTypes["IngredientSupplierLocaleConnection"],
	paginateIdentificationCodes: GraphQLTypes["IdentificationCodeLocaleConnection"],
	paginatePipelineStages: GraphQLTypes["PipelineStageLocaleConnection"],
	paginateSubscriptionBoxes: GraphQLTypes["SubscriptionBoxLocaleConnection"],
	paginateBusinessServices: GraphQLTypes["BusinessServiceLocaleConnection"]
};
	["LocaleMeta"]: {
	__typename: "LocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	businessCategories?: GraphQLTypes["FieldMeta"] | undefined,
	productCategoryLists?: GraphQLTypes["FieldMeta"] | undefined,
	productIngredients?: GraphQLTypes["FieldMeta"] | undefined,
	orderRecurrences?: GraphQLTypes["FieldMeta"] | undefined,
	blogs?: GraphQLTypes["FieldMeta"] | undefined,
	blogPosts?: GraphQLTypes["FieldMeta"] | undefined,
	identifier?: GraphQLTypes["FieldMeta"] | undefined,
	menus?: GraphQLTypes["FieldMeta"] | undefined,
	pages?: GraphQLTypes["FieldMeta"] | undefined,
	productIngredientCategories?: GraphQLTypes["FieldMeta"] | undefined,
	allergens?: GraphQLTypes["FieldMeta"] | undefined,
	productPackings?: GraphQLTypes["FieldMeta"] | undefined,
	products?: GraphQLTypes["FieldMeta"] | undefined,
	productRecipes?: GraphQLTypes["FieldMeta"] | undefined,
	pointOfSaleCategories?: GraphQLTypes["FieldMeta"] | undefined,
	pointOfSaleCategoryProducts?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryMethods?: GraphQLTypes["FieldMeta"] | undefined,
	ingredientSuppliers?: GraphQLTypes["FieldMeta"] | undefined,
	identificationCodes?: GraphQLTypes["FieldMeta"] | undefined,
	pipelineStages?: GraphQLTypes["FieldMeta"] | undefined,
	subscriptionBoxes?: GraphQLTypes["FieldMeta"] | undefined,
	businessServices?: GraphQLTypes["FieldMeta"] | undefined
};
	["BusinessCategoryLocale"]: {
	__typename: "BusinessCategoryLocale",
	_meta?: GraphQLTypes["BusinessCategoryLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	root?: GraphQLTypes["BusinessCategory"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	title?: string | undefined
};
	["BusinessCategoryLocaleMeta"]: {
	__typename: "BusinessCategoryLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined
};
	["BusinessCategory"]: {
	__typename: "BusinessCategory",
	_meta?: GraphQLTypes["BusinessCategoryMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	visibleToNewCustomers: boolean,
	locales: Array<GraphQLTypes["BusinessCategoryLocale"]>,
	internalName: string,
	businessCustomers: Array<GraphQLTypes["BusinessCustomer"]>,
	recurrences: Array<GraphQLTypes["OrderRecurrence"]>,
	specificProducts?: GraphQLTypes["ProductList"] | undefined,
	seasonalProductCategories?: GraphQLTypes["ProductCategoryList"] | undefined,
	specificProductsProductCategories?: GraphQLTypes["ProductCategoryList"] | undefined,
	slug: string,
	localesByLocale?: GraphQLTypes["BusinessCategoryLocale"] | undefined,
	businessCustomersByCustomer?: GraphQLTypes["BusinessCustomer"] | undefined,
	businessCustomersByBusinessServiceEvents?: GraphQLTypes["BusinessCustomer"] | undefined,
	businessCustomersByDoubleshotCoffeeEquipment?: GraphQLTypes["BusinessCustomer"] | undefined,
	paginateLocales: GraphQLTypes["BusinessCategoryLocaleConnection"],
	paginateBusinessCustomers: GraphQLTypes["BusinessCustomerConnection"],
	paginateRecurrences: GraphQLTypes["OrderRecurrenceConnection"]
};
	["BusinessCategoryMeta"]: {
	__typename: "BusinessCategoryMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	visibleToNewCustomers?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	internalName?: GraphQLTypes["FieldMeta"] | undefined,
	businessCustomers?: GraphQLTypes["FieldMeta"] | undefined,
	recurrences?: GraphQLTypes["FieldMeta"] | undefined,
	specificProducts?: GraphQLTypes["FieldMeta"] | undefined,
	seasonalProductCategories?: GraphQLTypes["FieldMeta"] | undefined,
	specificProductsProductCategories?: GraphQLTypes["FieldMeta"] | undefined,
	slug?: GraphQLTypes["FieldMeta"] | undefined
};
	["BusinessCategoryLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["BusinessCategoryOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined
};
	["LocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	identifier?: GraphQLTypes["TranslationCataloguesIdentifierOrderBy"] | undefined
};
	["TranslationCataloguesIdentifierOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	code?: GraphQLTypes["OrderDirection"] | undefined
};
	["BusinessCustomer"]: {
	__typename: "BusinessCustomer",
	_meta?: GraphQLTypes["BusinessCustomerMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	customer?: GraphQLTypes["Customer"] | undefined,
	owners: Array<GraphQLTypes["Customer"]>,
	members: Array<GraphQLTypes["Customer"]>,
	category?: GraphQLTypes["BusinessCategory"] | undefined,
	accountManager?: GraphQLTypes["BusinessToBusinessManager"] | undefined,
	logo?: GraphQLTypes["Image"] | undefined,
	note?: string | undefined,
	businessServiceEvents: Array<GraphQLTypes["BusinessServiceEvent"]>,
	doubleshotCoffeeEquipment?: GraphQLTypes["DoubleshotCoffeeEquipment"] | undefined,
	paginateOwners: GraphQLTypes["CustomerConnection"],
	paginateMembers: GraphQLTypes["CustomerConnection"],
	paginateBusinessServiceEvents: GraphQLTypes["BusinessServiceEventConnection"]
};
	["BusinessCustomerMeta"]: {
	__typename: "BusinessCustomerMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined,
	owners?: GraphQLTypes["FieldMeta"] | undefined,
	members?: GraphQLTypes["FieldMeta"] | undefined,
	category?: GraphQLTypes["FieldMeta"] | undefined,
	accountManager?: GraphQLTypes["FieldMeta"] | undefined,
	logo?: GraphQLTypes["FieldMeta"] | undefined,
	note?: GraphQLTypes["FieldMeta"] | undefined,
	businessServiceEvents?: GraphQLTypes["FieldMeta"] | undefined,
	doubleshotCoffeeEquipment?: GraphQLTypes["FieldMeta"] | undefined
};
	["BusinessToBusinessManager"]: {
	__typename: "BusinessToBusinessManager",
	_meta?: GraphQLTypes["BusinessToBusinessManagerMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	staff?: GraphQLTypes["Staff"] | undefined,
	managedBusinesses: Array<GraphQLTypes["BusinessCustomer"]>,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	managedBusinessesByCustomer?: GraphQLTypes["BusinessCustomer"] | undefined,
	managedBusinessesByBusinessServiceEvents?: GraphQLTypes["BusinessCustomer"] | undefined,
	managedBusinessesByDoubleshotCoffeeEquipment?: GraphQLTypes["BusinessCustomer"] | undefined,
	paginateManagedBusinesses: GraphQLTypes["BusinessCustomerConnection"]
};
	["BusinessToBusinessManagerMeta"]: {
	__typename: "BusinessToBusinessManagerMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	staff?: GraphQLTypes["FieldMeta"] | undefined,
	managedBusinesses?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined
};
	["Staff"]: {
	__typename: "Staff",
	_meta?: GraphQLTypes["StaffMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	bartender?: GraphQLTypes["Bartender"] | undefined,
	courier?: GraphQLTypes["Courier"] | undefined,
	cleaner?: GraphQLTypes["Cleaner"] | undefined,
	shiftsManager?: GraphQLTypes["ShiftsManager"] | undefined,
	businessToBusinessManager?: GraphQLTypes["BusinessToBusinessManager"] | undefined,
	user?: GraphQLTypes["User"] | undefined,
	shiftsProfile?: GraphQLTypes["ShiftsProfile"] | undefined,
	stocksManager?: GraphQLTypes["StocksManager"] | undefined,
	photo?: GraphQLTypes["Image"] | undefined,
	courierManager?: GraphQLTypes["CourierManager"] | undefined,
	picker?: GraphQLTypes["Picker"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	remunerationProfile?: GraphQLTypes["RemunerationProfile"] | undefined,
	cashier?: GraphQLTypes["Cashier"] | undefined,
	venues: Array<GraphQLTypes["Venue"]>,
	internalBuyer?: GraphQLTypes["InternalBuyer"] | undefined,
	salesManager?: GraphQLTypes["SalesManager"] | undefined,
	cashierManager?: GraphQLTypes["CashierManager"] | undefined,
	paginateVenues: GraphQLTypes["VenueConnection"]
};
	["StaffMeta"]: {
	__typename: "StaffMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	bartender?: GraphQLTypes["FieldMeta"] | undefined,
	courier?: GraphQLTypes["FieldMeta"] | undefined,
	cleaner?: GraphQLTypes["FieldMeta"] | undefined,
	shiftsManager?: GraphQLTypes["FieldMeta"] | undefined,
	businessToBusinessManager?: GraphQLTypes["FieldMeta"] | undefined,
	user?: GraphQLTypes["FieldMeta"] | undefined,
	shiftsProfile?: GraphQLTypes["FieldMeta"] | undefined,
	stocksManager?: GraphQLTypes["FieldMeta"] | undefined,
	photo?: GraphQLTypes["FieldMeta"] | undefined,
	courierManager?: GraphQLTypes["FieldMeta"] | undefined,
	picker?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	remunerationProfile?: GraphQLTypes["FieldMeta"] | undefined,
	cashier?: GraphQLTypes["FieldMeta"] | undefined,
	venues?: GraphQLTypes["FieldMeta"] | undefined,
	internalBuyer?: GraphQLTypes["FieldMeta"] | undefined,
	salesManager?: GraphQLTypes["FieldMeta"] | undefined,
	cashierManager?: GraphQLTypes["FieldMeta"] | undefined
};
	["Bartender"]: {
	__typename: "Bartender",
	_meta?: GraphQLTypes["BartenderMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	staff?: GraphQLTypes["Staff"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined
};
	["BartenderMeta"]: {
	__typename: "BartenderMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	staff?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined
};
	["Courier"]: {
	__typename: "Courier",
	_meta?: GraphQLTypes["CourierMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	staff?: GraphQLTypes["Staff"] | undefined,
	routes: Array<GraphQLTypes["DeliveryRoute"]>,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	deliveryMethods: Array<GraphQLTypes["DeliveryMethod"]>,
	showInPicker: boolean,
	routesByWaypoints?: GraphQLTypes["DeliveryRoute"] | undefined,
	paginateRoutes: GraphQLTypes["DeliveryRouteConnection"],
	paginateDeliveryMethods: GraphQLTypes["DeliveryMethodConnection"]
};
	["CourierMeta"]: {
	__typename: "CourierMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	staff?: GraphQLTypes["FieldMeta"] | undefined,
	routes?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryMethods?: GraphQLTypes["FieldMeta"] | undefined,
	showInPicker?: GraphQLTypes["FieldMeta"] | undefined
};
	["DeliveryRoute"]: {
	__typename: "DeliveryRoute",
	_meta?: GraphQLTypes["DeliveryRouteMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	courier?: GraphQLTypes["Courier"] | undefined,
	createdAt: GraphQLTypes["DateTime"],
	waypoints: Array<GraphQLTypes["DeliveryWaypoint"]>,
	dispatchAt: string,
	waypointsByDelivery?: GraphQLTypes["DeliveryWaypoint"] | undefined,
	paginateWaypoints: GraphQLTypes["DeliveryWaypointConnection"]
};
	["DeliveryRouteMeta"]: {
	__typename: "DeliveryRouteMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	courier?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	waypoints?: GraphQLTypes["FieldMeta"] | undefined,
	dispatchAt?: GraphQLTypes["FieldMeta"] | undefined
};
	["DeliveryWaypoint"]: {
	__typename: "DeliveryWaypoint",
	_meta?: GraphQLTypes["DeliveryWaypointMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	estimatedArrival?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	route?: GraphQLTypes["DeliveryRoute"] | undefined,
	sortingOrder: number,
	delivery?: GraphQLTypes["OrderDelivery"] | undefined,
	estimatedDistance?: number | undefined,
	estimatedDuration?: number | undefined,
	originDeparture?: GraphQLTypes["DateTime"] | undefined,
	originAddress?: string | undefined,
	transitMode?: string | undefined
};
	["DeliveryWaypointMeta"]: {
	__typename: "DeliveryWaypointMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	estimatedArrival?: GraphQLTypes["FieldMeta"] | undefined,
	note?: GraphQLTypes["FieldMeta"] | undefined,
	route?: GraphQLTypes["FieldMeta"] | undefined,
	sortingOrder?: GraphQLTypes["FieldMeta"] | undefined,
	delivery?: GraphQLTypes["FieldMeta"] | undefined,
	estimatedDistance?: GraphQLTypes["FieldMeta"] | undefined,
	estimatedDuration?: GraphQLTypes["FieldMeta"] | undefined,
	originDeparture?: GraphQLTypes["FieldMeta"] | undefined,
	originAddress?: GraphQLTypes["FieldMeta"] | undefined,
	transitMode?: GraphQLTypes["FieldMeta"] | undefined
};
	["OrderDelivery"]: {
	__typename: "OrderDelivery",
	_meta?: GraphQLTypes["OrderDeliveryMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	priceCents: number,
	deliveredAt?: GraphQLTypes["DateTime"] | undefined,
	method?: GraphQLTypes["DeliveryMethod"] | undefined,
	vatRate?: GraphQLTypes["VatRate"] | undefined,
	order?: GraphQLTypes["Order"] | undefined,
	expectedAt?: GraphQLTypes["DateTime"] | undefined,
	state: GraphQLTypes["OrderDeliveryState"],
	loadingDurationHours?: number | undefined,
	dispatchAt?: GraphQLTypes["DateTime"] | undefined,
	duration?: string | undefined,
	window?: string | undefined,
	expectedEndAt?: GraphQLTypes["DateTime"] | undefined,
	processingAt?: GraphQLTypes["DateTime"] | undefined,
	deliveringAt?: GraphQLTypes["DateTime"] | undefined,
	failedAt?: GraphQLTypes["DateTime"] | undefined,
	internalNote?: string | undefined,
	deliveryWaypoint?: GraphQLTypes["DeliveryWaypoint"] | undefined,
	events: Array<GraphQLTypes["OrderEvent"]>,
	prepareAt?: GraphQLTypes["DateTime"] | undefined,
	liftagoRide?: GraphQLTypes["LiftagoRide"] | undefined,
	pickedAt?: GraphQLTypes["DateTime"] | undefined,
	address?: GraphQLTypes["Address"] | undefined,
	trackingCode?: string | undefined,
	woltDriveDelivery?: GraphQLTypes["WoltDriveDelivery"] | undefined,
	paginateEvents: GraphQLTypes["OrderEventConnection"]
};
	["OrderDeliveryMeta"]: {
	__typename: "OrderDeliveryMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	priceCents?: GraphQLTypes["FieldMeta"] | undefined,
	deliveredAt?: GraphQLTypes["FieldMeta"] | undefined,
	method?: GraphQLTypes["FieldMeta"] | undefined,
	vatRate?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	expectedAt?: GraphQLTypes["FieldMeta"] | undefined,
	state?: GraphQLTypes["FieldMeta"] | undefined,
	loadingDurationHours?: GraphQLTypes["FieldMeta"] | undefined,
	dispatchAt?: GraphQLTypes["FieldMeta"] | undefined,
	duration?: GraphQLTypes["FieldMeta"] | undefined,
	window?: GraphQLTypes["FieldMeta"] | undefined,
	expectedEndAt?: GraphQLTypes["FieldMeta"] | undefined,
	processingAt?: GraphQLTypes["FieldMeta"] | undefined,
	deliveringAt?: GraphQLTypes["FieldMeta"] | undefined,
	failedAt?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryWaypoint?: GraphQLTypes["FieldMeta"] | undefined,
	events?: GraphQLTypes["FieldMeta"] | undefined,
	prepareAt?: GraphQLTypes["FieldMeta"] | undefined,
	liftagoRide?: GraphQLTypes["FieldMeta"] | undefined,
	pickedAt?: GraphQLTypes["FieldMeta"] | undefined,
	address?: GraphQLTypes["FieldMeta"] | undefined,
	trackingCode?: GraphQLTypes["FieldMeta"] | undefined,
	woltDriveDelivery?: GraphQLTypes["FieldMeta"] | undefined
};
	["VatRate"]: {
	__typename: "VatRate",
	_meta?: GraphQLTypes["VatRateMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	ratePermille: number,
	description?: string | undefined,
	internalNote?: string | undefined,
	channelDeliveries: Array<GraphQLTypes["ChannelDelivery"]>,
	channelPayments: Array<GraphQLTypes["ChannelPayment"]>,
	preset?: GraphQLTypes["VatRatePreset"] | undefined,
	paginateChannelDeliveries: GraphQLTypes["ChannelDeliveryConnection"],
	paginateChannelPayments: GraphQLTypes["ChannelPaymentConnection"]
};
	["VatRateMeta"]: {
	__typename: "VatRateMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	ratePermille?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	channelDeliveries?: GraphQLTypes["FieldMeta"] | undefined,
	channelPayments?: GraphQLTypes["FieldMeta"] | undefined,
	preset?: GraphQLTypes["FieldMeta"] | undefined
};
	["ChannelDelivery"]: {
	__typename: "ChannelDelivery",
	_meta?: GraphQLTypes["ChannelDeliveryMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	priceCents: number,
	channel?: GraphQLTypes["Channel"] | undefined,
	method?: GraphQLTypes["DeliveryMethod"] | undefined,
	vatRate?: GraphQLTypes["VatRate"] | undefined,
	defaultVisible: boolean
};
	["ChannelDeliveryMeta"]: {
	__typename: "ChannelDeliveryMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	priceCents?: GraphQLTypes["FieldMeta"] | undefined,
	channel?: GraphQLTypes["FieldMeta"] | undefined,
	method?: GraphQLTypes["FieldMeta"] | undefined,
	vatRate?: GraphQLTypes["FieldMeta"] | undefined,
	defaultVisible?: GraphQLTypes["FieldMeta"] | undefined
};
	["Channel"]: {
	__typename: "Channel",
	_meta?: GraphQLTypes["ChannelMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	disabled: boolean,
	payments: Array<GraphQLTypes["ChannelPayment"]>,
	deliveries: Array<GraphQLTypes["ChannelDelivery"]>,
	pointOfSales: Array<GraphQLTypes["PointOfSale"]>,
	carts: Array<GraphQLTypes["Cart"]>,
	customers: Array<GraphQLTypes["Customer"]>,
	code?: GraphQLTypes["ChannelCode"] | undefined,
	addTagsOnRegistration: Array<GraphQLTypes["Tag"]>,
	publicTags: Array<GraphQLTypes["Tag"]>,
	venue?: GraphQLTypes["Venue"] | undefined,
	cartsByItems?: GraphQLTypes["Cart"] | undefined,
	cartsByOrder?: GraphQLTypes["Cart"] | undefined,
	cartsByPriceLines?: GraphQLTypes["Cart"] | undefined,
	cartsBySummary?: GraphQLTypes["Cart"] | undefined,
	paginatePayments: GraphQLTypes["ChannelPaymentConnection"],
	paginateDeliveries: GraphQLTypes["ChannelDeliveryConnection"],
	paginatePointOfSales: GraphQLTypes["PointOfSaleConnection"],
	paginateCarts: GraphQLTypes["CartConnection"],
	paginateCustomers: GraphQLTypes["CustomerConnection"],
	paginateAddTagsOnRegistration: GraphQLTypes["TagConnection"],
	paginatePublicTags: GraphQLTypes["TagConnection"]
};
	["ChannelMeta"]: {
	__typename: "ChannelMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	disabled?: GraphQLTypes["FieldMeta"] | undefined,
	payments?: GraphQLTypes["FieldMeta"] | undefined,
	deliveries?: GraphQLTypes["FieldMeta"] | undefined,
	pointOfSales?: GraphQLTypes["FieldMeta"] | undefined,
	carts?: GraphQLTypes["FieldMeta"] | undefined,
	customers?: GraphQLTypes["FieldMeta"] | undefined,
	code?: GraphQLTypes["FieldMeta"] | undefined,
	addTagsOnRegistration?: GraphQLTypes["FieldMeta"] | undefined,
	publicTags?: GraphQLTypes["FieldMeta"] | undefined,
	venue?: GraphQLTypes["FieldMeta"] | undefined
};
	["ChannelPayment"]: {
	__typename: "ChannelPayment",
	_meta?: GraphQLTypes["ChannelPaymentMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	channel?: GraphQLTypes["Channel"] | undefined,
	method?: GraphQLTypes["PaymentMethod"] | undefined,
	vatRate?: GraphQLTypes["VatRate"] | undefined,
	requireBillingAddress?: boolean | undefined,
	provideReceipt?: boolean | undefined,
	requireBillingSubject?: boolean | undefined,
	allowOnlyForTags: Array<GraphQLTypes["Tag"]>,
	paginateAllowOnlyForTags: GraphQLTypes["TagConnection"]
};
	["ChannelPaymentMeta"]: {
	__typename: "ChannelPaymentMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	channel?: GraphQLTypes["FieldMeta"] | undefined,
	method?: GraphQLTypes["FieldMeta"] | undefined,
	vatRate?: GraphQLTypes["FieldMeta"] | undefined,
	requireBillingAddress?: GraphQLTypes["FieldMeta"] | undefined,
	provideReceipt?: GraphQLTypes["FieldMeta"] | undefined,
	requireBillingSubject?: GraphQLTypes["FieldMeta"] | undefined,
	allowOnlyForTags?: GraphQLTypes["FieldMeta"] | undefined
};
	["TagOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	code?: GraphQLTypes["OrderDirection"] | undefined,
	description?: GraphQLTypes["OrderDirection"] | undefined,
	internalNote?: GraphQLTypes["OrderDirection"] | undefined
};
	["TagConnection"]: {
	__typename: "TagConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TagEdge"]>
};
	["PageInfo"]: {
	__typename: "PageInfo",
	totalCount: number
};
	["TagEdge"]: {
	__typename: "TagEdge",
	node: GraphQLTypes["Tag"]
};
	["ChannelPaymentOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	channel?: GraphQLTypes["ChannelOrderBy"] | undefined,
	method?: GraphQLTypes["PaymentMethodOrderBy"] | undefined,
	vatRate?: GraphQLTypes["VatRateOrderBy"] | undefined,
	requireBillingAddress?: GraphQLTypes["OrderDirection"] | undefined,
	provideReceipt?: GraphQLTypes["OrderDirection"] | undefined,
	requireBillingSubject?: GraphQLTypes["OrderDirection"] | undefined
};
	["ChannelOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	disabled?: GraphQLTypes["OrderDirection"] | undefined,
	code?: GraphQLTypes["OrderDirection"] | undefined,
	venue?: GraphQLTypes["VenueOrderBy"] | undefined
};
	["VenueOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	deadlineTemplate?: GraphQLTypes["DeadlineTemplateOrderBy"] | undefined,
	address?: GraphQLTypes["OrderDirection"] | undefined,
	pointOfSalePngBase64ReceiptLogo?: GraphQLTypes["OrderDirection"] | undefined,
	pointOfSaleInitialView?: GraphQLTypes["OrderDirection"] | undefined,
	pointOfSalePreferPrintReceipt?: GraphQLTypes["OrderDirection"] | undefined
};
	["DeadlineTemplateOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	startDate?: GraphQLTypes["OrderDirection"] | undefined,
	period?: GraphQLTypes["OrderDirection"] | undefined,
	cutoff?: GraphQLTypes["OrderDirection"] | undefined,
	closed?: GraphQLTypes["OrderDirection"] | undefined,
	venue?: GraphQLTypes["VenueOrderBy"] | undefined
};
	["VatRateOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	ratePermille?: GraphQLTypes["OrderDirection"] | undefined,
	description?: GraphQLTypes["OrderDirection"] | undefined,
	internalNote?: GraphQLTypes["OrderDirection"] | undefined,
	preset?: GraphQLTypes["OrderDirection"] | undefined
};
	["ChannelDeliveryOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	priceCents?: GraphQLTypes["OrderDirection"] | undefined,
	channel?: GraphQLTypes["ChannelOrderBy"] | undefined,
	method?: GraphQLTypes["DeliveryMethodOrderBy"] | undefined,
	vatRate?: GraphQLTypes["VatRateOrderBy"] | undefined,
	defaultVisible?: GraphQLTypes["OrderDirection"] | undefined
};
	["PointOfSale"]: {
	__typename: "PointOfSale",
	_meta?: GraphQLTypes["PointOfSaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name?: string | undefined,
	code: string,
	channels: Array<GraphQLTypes["Channel"]>,
	permissions?: GraphQLTypes["PointOfSalePermissions"] | undefined,
	tenantPersonId?: GraphQLTypes["UUID"] | undefined,
	paginateChannels: GraphQLTypes["ChannelConnection"]
};
	["PointOfSaleMeta"]: {
	__typename: "PointOfSaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	code?: GraphQLTypes["FieldMeta"] | undefined,
	channels?: GraphQLTypes["FieldMeta"] | undefined,
	permissions?: GraphQLTypes["FieldMeta"] | undefined,
	tenantPersonId?: GraphQLTypes["FieldMeta"] | undefined
};
	["PointOfSalePermissions"]: {
	__typename: "PointOfSalePermissions",
	_meta?: GraphQLTypes["PointOfSalePermissionsMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	canPlaceOrder?: boolean | undefined,
	pointOfSale?: GraphQLTypes["PointOfSale"] | undefined
};
	["PointOfSalePermissionsMeta"]: {
	__typename: "PointOfSalePermissionsMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	canPlaceOrder?: GraphQLTypes["FieldMeta"] | undefined,
	pointOfSale?: GraphQLTypes["FieldMeta"] | undefined
};
	["ChannelConnection"]: {
	__typename: "ChannelConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ChannelEdge"]>
};
	["ChannelEdge"]: {
	__typename: "ChannelEdge",
	node: GraphQLTypes["Channel"]
};
	["PointOfSaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	code?: GraphQLTypes["OrderDirection"] | undefined,
	permissions?: GraphQLTypes["PointOfSalePermissionsOrderBy"] | undefined,
	tenantPersonId?: GraphQLTypes["OrderDirection"] | undefined
};
	["PointOfSalePermissionsOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	canPlaceOrder?: GraphQLTypes["OrderDirection"] | undefined,
	pointOfSale?: GraphQLTypes["PointOfSaleOrderBy"] | undefined
};
	["Cart"]: {
	__typename: "Cart",
	_meta?: GraphQLTypes["CartMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	confirmedAt?: GraphQLTypes["DateTime"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	items: Array<GraphQLTypes["CartItem"]>,
	handle?: string | undefined,
	state: GraphQLTypes["CartState"],
	createdAt: GraphQLTypes["DateTime"],
	channel?: GraphQLTypes["Channel"] | undefined,
	order?: GraphQLTypes["Order"] | undefined,
	customer?: GraphQLTypes["Customer"] | undefined,
	deliveryAddress?: GraphQLTypes["Address"] | undefined,
	billingAddress?: GraphQLTypes["Address"] | undefined,
	deliveryOption?: string | undefined,
	paymentOption?: string | undefined,
	delivery?: GraphQLTypes["ChannelDelivery"] | undefined,
	payment?: GraphQLTypes["ChannelPayment"] | undefined,
	billingSubject?: GraphQLTypes["BillingSubject"] | undefined,
	priceLines: Array<GraphQLTypes["CartPriceLine"]>,
	summary?: GraphQLTypes["CartSummary"] | undefined,
	itemsByProduct?: GraphQLTypes["CartItem"] | undefined,
	paginateItems: GraphQLTypes["CartItemConnection"],
	paginatePriceLines: GraphQLTypes["CartPriceLineConnection"]
};
	["CartMeta"]: {
	__typename: "CartMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	confirmedAt?: GraphQLTypes["FieldMeta"] | undefined,
	deletedAt?: GraphQLTypes["FieldMeta"] | undefined,
	note?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined,
	handle?: GraphQLTypes["FieldMeta"] | undefined,
	state?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	channel?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryAddress?: GraphQLTypes["FieldMeta"] | undefined,
	billingAddress?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryOption?: GraphQLTypes["FieldMeta"] | undefined,
	paymentOption?: GraphQLTypes["FieldMeta"] | undefined,
	delivery?: GraphQLTypes["FieldMeta"] | undefined,
	payment?: GraphQLTypes["FieldMeta"] | undefined,
	billingSubject?: GraphQLTypes["FieldMeta"] | undefined,
	priceLines?: GraphQLTypes["FieldMeta"] | undefined,
	summary?: GraphQLTypes["FieldMeta"] | undefined
};
	["CartItem"]: {
	__typename: "CartItem",
	_meta?: GraphQLTypes["CartItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	quantity: number,
	cart?: GraphQLTypes["Cart"] | undefined,
	product?: GraphQLTypes["Product"] | undefined,
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	fulfillmentNote?: string | undefined,
	fulfillmentNotes: Array<GraphQLTypes["FulfillmentNote"]>,
	paginateFulfillmentNotes: GraphQLTypes["FulfillmentNoteConnection"]
};
	["CartItemMeta"]: {
	__typename: "CartItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	quantity?: GraphQLTypes["FieldMeta"] | undefined,
	cart?: GraphQLTypes["FieldMeta"] | undefined,
	product?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	updatedAt?: GraphQLTypes["FieldMeta"] | undefined,
	fulfillmentNote?: GraphQLTypes["FieldMeta"] | undefined,
	fulfillmentNotes?: GraphQLTypes["FieldMeta"] | undefined
};
	["FulfillmentNote"]: {
	__typename: "FulfillmentNote",
	_meta?: GraphQLTypes["FulfillmentNoteMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	note: string,
	products: Array<GraphQLTypes["Product"]>,
	tags: Array<GraphQLTypes["Tag"]>,
	venues: Array<GraphQLTypes["Venue"]>,
	cartItems: Array<GraphQLTypes["CartItem"]>,
	orderItems: Array<GraphQLTypes["OrderItem"]>,
	orders: Array<GraphQLTypes["Order"]>,
	highlight: boolean,
	createdAt: GraphQLTypes["DateTime"],
	emoji?: string | undefined,
	paginateProducts: GraphQLTypes["ProductConnection"],
	paginateTags: GraphQLTypes["TagConnection"],
	paginateVenues: GraphQLTypes["VenueConnection"],
	paginateCartItems: GraphQLTypes["CartItemConnection"],
	paginateOrderItems: GraphQLTypes["OrderItemConnection"],
	paginateOrders: GraphQLTypes["OrderConnection"]
};
	["FulfillmentNoteMeta"]: {
	__typename: "FulfillmentNoteMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	note?: GraphQLTypes["FieldMeta"] | undefined,
	products?: GraphQLTypes["FieldMeta"] | undefined,
	tags?: GraphQLTypes["FieldMeta"] | undefined,
	venues?: GraphQLTypes["FieldMeta"] | undefined,
	cartItems?: GraphQLTypes["FieldMeta"] | undefined,
	orderItems?: GraphQLTypes["FieldMeta"] | undefined,
	orders?: GraphQLTypes["FieldMeta"] | undefined,
	highlight?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	emoji?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	code?: GraphQLTypes["OrderDirection"] | undefined,
	priceCents?: GraphQLTypes["OrderDirection"] | undefined,
	notDiscountable?: GraphQLTypes["OrderDirection"] | undefined,
	packing?: GraphQLTypes["ProductPackingOrderBy"] | undefined,
	recipe?: GraphQLTypes["ProductRecipeOrderBy"] | undefined,
	vatRate?: GraphQLTypes["VatRateOrderBy"] | undefined,
	image?: GraphQLTypes["ImageOrderBy"] | undefined,
	description?: GraphQLTypes["OrderDirection"] | undefined,
	internalNote?: GraphQLTypes["OrderDirection"] | undefined,
	availability?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	manager?: GraphQLTypes["StocksManagerOrderBy"] | undefined,
	maximumQuantityPerOrder?: GraphQLTypes["OrderDirection"] | undefined,
	archivedAt?: GraphQLTypes["OrderDirection"] | undefined,
	virtualProduct?: GraphQLTypes["VirtualProductOrderBy"] | undefined,
	meta?: GraphQLTypes["ProductMetadataOrderBy"] | undefined,
	page?: GraphQLTypes["PageOrderBy"] | undefined,
	hasSubscription?: GraphQLTypes["OrderDirection"] | undefined,
	pointOfSaleTileColor?: GraphQLTypes["OrderDirection"] | undefined
};
	["ProductPackingOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	image?: GraphQLTypes["ImageOrderBy"] | undefined,
	description?: GraphQLTypes["OrderDirection"] | undefined,
	internalNote?: GraphQLTypes["OrderDirection"] | undefined,
	volumeMl?: GraphQLTypes["OrderDirection"] | undefined,
	icon?: GraphQLTypes["ImageOrderBy"] | undefined,
	shortName?: GraphQLTypes["OrderDirection"] | undefined,
	isPackedInCardboard?: GraphQLTypes["OrderDirection"] | undefined
};
	["ProductRecipeOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	internalNote?: GraphQLTypes["OrderDirection"] | undefined,
	color?: GraphQLTypes["OrderDirection"] | undefined,
	image?: GraphQLTypes["ImageOrderBy"] | undefined,
	icon?: GraphQLTypes["ImageOrderBy"] | undefined,
	needsPrepping?: GraphQLTypes["OrderDirection"] | undefined,
	gutTuning?: GraphQLTypes["OrderDirection"] | undefined,
	freshingContainer?: GraphQLTypes["FreshingContainerOrderBy"] | undefined,
	description?: GraphQLTypes["OrderDirection"] | undefined,
	nutritionFacts?: GraphQLTypes["NutritionFactsOrderBy"] | undefined
};
	["FreshingContainerOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	volumeMl?: GraphQLTypes["OrderDirection"] | undefined,
	workspace?: GraphQLTypes["WorkspaceOrderBy"] | undefined
};
	["WorkspaceOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	unique?: GraphQLTypes["OrderDirection"] | undefined,
	orderDeadlineTime?: GraphQLTypes["OrderDirection"] | undefined,
	ordersLoadingDurationHours?: GraphQLTypes["OrderDirection"] | undefined,
	freshingContainerVolumeMl?: GraphQLTypes["OrderDirection"] | undefined,
	freshingPrepareOrderByOffsetMinutes?: GraphQLTypes["OrderDirection"] | undefined,
	checkoutUrlTemplate?: GraphQLTypes["OrderDirection"] | undefined,
	orderUrlTemplate?: GraphQLTypes["OrderDirection"] | undefined,
	paymentUrlTemplate?: GraphQLTypes["OrderDirection"] | undefined,
	customerProfileUrlTemplate?: GraphQLTypes["OrderDirection"] | undefined,
	userProfileUrlTemplate?: GraphQLTypes["OrderDirection"] | undefined,
	messengerUrl?: GraphQLTypes["OrderDirection"] | undefined,
	messengerIosUrl?: GraphQLTypes["OrderDirection"] | undefined,
	messengerAndroidUrl?: GraphQLTypes["OrderDirection"] | undefined,
	openingHours?: GraphQLTypes["WeekHoursOrderBy"] | undefined,
	workingHours?: GraphQLTypes["WeekHoursOrderBy"] | undefined,
	defaultFreshingContainer?: GraphQLTypes["FreshingContainerOrderBy"] | undefined,
	creditsProduct?: GraphQLTypes["VirtualProductOrderBy"] | undefined,
	discountVatRate?: GraphQLTypes["VatRateOrderBy"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	businessAddress?: GraphQLTypes["OrderDirection"] | undefined
};
	["WeekHoursOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	mon?: GraphQLTypes["OrderDirection"] | undefined,
	tue?: GraphQLTypes["OrderDirection"] | undefined,
	wed?: GraphQLTypes["OrderDirection"] | undefined,
	thu?: GraphQLTypes["OrderDirection"] | undefined,
	fri?: GraphQLTypes["OrderDirection"] | undefined,
	sat?: GraphQLTypes["OrderDirection"] | undefined,
	sun?: GraphQLTypes["OrderDirection"] | undefined
};
	["VirtualProductOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	product?: GraphQLTypes["ProductOrderBy"] | undefined,
	voucherCreditCents?: GraphQLTypes["OrderDirection"] | undefined,
	physicalRepresentation?: GraphQLTypes["OrderDirection"] | undefined,
	recipientEmail?: GraphQLTypes["OrderDirection"] | undefined
};
	["NutritionFactsOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	energyKiloJoule?: GraphQLTypes["OrderDirection"] | undefined,
	energyKiloCalorie?: GraphQLTypes["OrderDirection"] | undefined,
	fatsGrams?: GraphQLTypes["OrderDirection"] | undefined,
	fatsOfWhichSaturatedGrams?: GraphQLTypes["OrderDirection"] | undefined,
	carbohydrateGrams?: GraphQLTypes["OrderDirection"] | undefined,
	carbohydrateOfWhichSugarsGrams?: GraphQLTypes["OrderDirection"] | undefined,
	proteinGrams?: GraphQLTypes["OrderDirection"] | undefined,
	fibreGrams?: GraphQLTypes["OrderDirection"] | undefined,
	saltGrams?: GraphQLTypes["OrderDirection"] | undefined
};
	["ProductMetadataOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	archived?: GraphQLTypes["OrderDirection"] | undefined,
	available?: GraphQLTypes["OrderDirection"] | undefined,
	availableQuantity?: GraphQLTypes["OrderDirection"] | undefined,
	product?: GraphQLTypes["ProductOrderBy"] | undefined
};
	["PageOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined
};
	["Venue"]: {
	__typename: "Venue",
	_meta?: GraphQLTypes["VenueMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	deadlineTemplate?: GraphQLTypes["DeadlineTemplate"] | undefined,
	timetableDays: Array<GraphQLTypes["TimetableDay"]>,
	timetableTemplates: Array<GraphQLTypes["TimetableTemplate"]>,
	staffMembers: Array<GraphQLTypes["Staff"]>,
	employeeRoles: Array<GraphQLTypes["VenueEmployeeRole"]>,
	pointOfSaleApplicationDevices: Array<GraphQLTypes["PointOfSaleApplicationDevice"]>,
	pointOfSaleTerminals: Array<GraphQLTypes["PointOfSaleTerminal"]>,
	pointOfSalePrinters: Array<GraphQLTypes["PointOfSalePrinter"]>,
	orders: Array<GraphQLTypes["Order"]>,
	fulfillmentNotes: Array<GraphQLTypes["FulfillmentNote"]>,
	areas: Array<GraphQLTypes["Area"]>,
	enabledUnassignReasons: Array<GraphQLTypes["UnassignReason"]>,
	categories: Array<GraphQLTypes["PointOfSaleCategory"]>,
	channels: Array<GraphQLTypes["Channel"]>,
	address?: string | undefined,
	pointOfSalePngBase64ReceiptLogo?: string | undefined,
	pointOfSaleInitialView: GraphQLTypes["PointOfSaleInitialView"],
	pointOfSalePreferPrintReceipt: boolean,
	timetableDaysByDate?: GraphQLTypes["TimetableDay"] | undefined,
	timetableDaysByShiftGroups?: GraphQLTypes["TimetableDay"] | undefined,
	timetableDaysByNotes?: GraphQLTypes["TimetableDay"] | undefined,
	timetableDaysByMeta?: GraphQLTypes["TimetableDay"] | undefined,
	timetableTemplatesByStaffOptions?: GraphQLTypes["TimetableTemplate"] | undefined,
	employeeRolesByRole?: GraphQLTypes["VenueEmployeeRole"] | undefined,
	employeeRolesByEmployeePrivileges?: GraphQLTypes["VenueEmployeeRole"] | undefined,
	pointOfSaleApplicationDevicesByIdentifier?: GraphQLTypes["PointOfSaleApplicationDevice"] | undefined,
	pointOfSaleTerminalsByApplicationDevices?: GraphQLTypes["PointOfSaleTerminal"] | undefined,
	pointOfSalePrintersByApplicationDevicesReceipt?: GraphQLTypes["PointOfSalePrinter"] | undefined,
	ordersBySeq?: GraphQLTypes["Order"] | undefined,
	ordersByDoubleshotLegacyId?: GraphQLTypes["Order"] | undefined,
	ordersByDoubleShotLegacyNumber?: GraphQLTypes["Order"] | undefined,
	ordersByDiscounts?: GraphQLTypes["Order"] | undefined,
	ordersByDelivery?: GraphQLTypes["Order"] | undefined,
	ordersByItems?: GraphQLTypes["Order"] | undefined,
	ordersByCart?: GraphQLTypes["Order"] | undefined,
	ordersByEvents?: GraphQLTypes["Order"] | undefined,
	ordersByPriceLines?: GraphQLTypes["Order"] | undefined,
	ordersByPayments?: GraphQLTypes["Order"] | undefined,
	ordersBySummary?: GraphQLTypes["Order"] | undefined,
	ordersByGratuity?: GraphQLTypes["Order"] | undefined,
	areasByTables?: GraphQLTypes["Area"] | undefined,
	areasByLines?: GraphQLTypes["Area"] | undefined,
	categoriesBySlug?: GraphQLTypes["PointOfSaleCategory"] | undefined,
	categoriesByLocales?: GraphQLTypes["PointOfSaleCategory"] | undefined,
	categoriesByProducts?: GraphQLTypes["PointOfSaleCategory"] | undefined,
	channelsByCode?: GraphQLTypes["Channel"] | undefined,
	channelsByPayments?: GraphQLTypes["Channel"] | undefined,
	channelsByDeliveries?: GraphQLTypes["Channel"] | undefined,
	channelsByCarts?: GraphQLTypes["Channel"] | undefined,
	paginateTimetableDays: GraphQLTypes["TimetableDayConnection"],
	paginateTimetableTemplates: GraphQLTypes["TimetableTemplateConnection"],
	paginateStaffMembers: GraphQLTypes["StaffConnection"],
	paginateEmployeeRoles: GraphQLTypes["VenueEmployeeRoleConnection"],
	paginatePointOfSaleApplicationDevices: GraphQLTypes["PointOfSaleApplicationDeviceConnection"],
	paginatePointOfSaleTerminals: GraphQLTypes["PointOfSaleTerminalConnection"],
	paginatePointOfSalePrinters: GraphQLTypes["PointOfSalePrinterConnection"],
	paginateOrders: GraphQLTypes["OrderConnection"],
	paginateFulfillmentNotes: GraphQLTypes["FulfillmentNoteConnection"],
	paginateAreas: GraphQLTypes["AreaConnection"],
	paginateEnabledUnassignReasons: GraphQLTypes["UnassignReasonConnection"],
	paginateCategories: GraphQLTypes["PointOfSaleCategoryConnection"],
	paginateChannels: GraphQLTypes["ChannelConnection"]
};
	["VenueMeta"]: {
	__typename: "VenueMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	deadlineTemplate?: GraphQLTypes["FieldMeta"] | undefined,
	timetableDays?: GraphQLTypes["FieldMeta"] | undefined,
	timetableTemplates?: GraphQLTypes["FieldMeta"] | undefined,
	staffMembers?: GraphQLTypes["FieldMeta"] | undefined,
	employeeRoles?: GraphQLTypes["FieldMeta"] | undefined,
	pointOfSaleApplicationDevices?: GraphQLTypes["FieldMeta"] | undefined,
	pointOfSaleTerminals?: GraphQLTypes["FieldMeta"] | undefined,
	pointOfSalePrinters?: GraphQLTypes["FieldMeta"] | undefined,
	orders?: GraphQLTypes["FieldMeta"] | undefined,
	fulfillmentNotes?: GraphQLTypes["FieldMeta"] | undefined,
	areas?: GraphQLTypes["FieldMeta"] | undefined,
	enabledUnassignReasons?: GraphQLTypes["FieldMeta"] | undefined,
	categories?: GraphQLTypes["FieldMeta"] | undefined,
	channels?: GraphQLTypes["FieldMeta"] | undefined,
	address?: GraphQLTypes["FieldMeta"] | undefined,
	pointOfSalePngBase64ReceiptLogo?: GraphQLTypes["FieldMeta"] | undefined,
	pointOfSaleInitialView?: GraphQLTypes["FieldMeta"] | undefined,
	pointOfSalePreferPrintReceipt?: GraphQLTypes["FieldMeta"] | undefined
};
	["DeadlineTemplate"]: {
	__typename: "DeadlineTemplate",
	_meta?: GraphQLTypes["DeadlineTemplateMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	startDate: GraphQLTypes["Date"],
	period: number,
	cutoff?: number | undefined,
	closed?: boolean | undefined,
	venue?: GraphQLTypes["Venue"] | undefined
};
	["DeadlineTemplateMeta"]: {
	__typename: "DeadlineTemplateMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	startDate?: GraphQLTypes["FieldMeta"] | undefined,
	period?: GraphQLTypes["FieldMeta"] | undefined,
	cutoff?: GraphQLTypes["FieldMeta"] | undefined,
	closed?: GraphQLTypes["FieldMeta"] | undefined,
	venue?: GraphQLTypes["FieldMeta"] | undefined
};
	["TimetableDay"]: {
	__typename: "TimetableDay",
	_meta?: GraphQLTypes["TimetableDayMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	date: GraphQLTypes["Date"],
	type?: GraphQLTypes["TimetableDayType"] | undefined,
	shiftGroups: Array<GraphQLTypes["TimetableShiftGroup"]>,
	tipsCents?: number | undefined,
	notes: Array<GraphQLTypes["TimetableDayNote"]>,
	venue?: GraphQLTypes["Venue"] | undefined,
	meta?: GraphQLTypes["TimetableDayMetadata"] | undefined,
	shiftGroupsByShifts?: GraphQLTypes["TimetableShiftGroup"] | undefined,
	shiftGroupsByQueue?: GraphQLTypes["TimetableShiftGroup"] | undefined,
	paginateShiftGroups: GraphQLTypes["TimetableShiftGroupConnection"],
	paginateNotes: GraphQLTypes["TimetableDayNoteConnection"]
};
	["TimetableDayMeta"]: {
	__typename: "TimetableDayMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	date?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	shiftGroups?: GraphQLTypes["FieldMeta"] | undefined,
	tipsCents?: GraphQLTypes["FieldMeta"] | undefined,
	notes?: GraphQLTypes["FieldMeta"] | undefined,
	venue?: GraphQLTypes["FieldMeta"] | undefined,
	meta?: GraphQLTypes["FieldMeta"] | undefined
};
	["TimetableShiftGroup"]: {
	__typename: "TimetableShiftGroup",
	_meta?: GraphQLTypes["TimetableShiftGroupMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	shifts: Array<GraphQLTypes["TimetableShift"]>,
	day?: GraphQLTypes["TimetableDay"] | undefined,
	type?: GraphQLTypes["TimetableEmployeeRole"] | undefined,
	position?: GraphQLTypes["TimetableShiftPosition"] | undefined,
	queue?: GraphQLTypes["EmployeeQueue"] | undefined,
	generatedByTemplate?: GraphQLTypes["TimetableTemplate"] | undefined,
	shiftsByQueueItem?: GraphQLTypes["TimetableShift"] | undefined,
	shiftsBySwapInfo?: GraphQLTypes["TimetableShift"] | undefined,
	paginateShifts: GraphQLTypes["TimetableShiftConnection"]
};
	["TimetableShiftGroupMeta"]: {
	__typename: "TimetableShiftGroupMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	shifts?: GraphQLTypes["FieldMeta"] | undefined,
	day?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	position?: GraphQLTypes["FieldMeta"] | undefined,
	queue?: GraphQLTypes["FieldMeta"] | undefined,
	generatedByTemplate?: GraphQLTypes["FieldMeta"] | undefined
};
	["TimetableShift"]: {
	__typename: "TimetableShift",
	_meta?: GraphQLTypes["TimetableShiftMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	locked: boolean,
	order: number,
	assigned?: GraphQLTypes["Date"] | undefined,
	group?: GraphQLTypes["TimetableShiftGroup"] | undefined,
	shiftsProfile?: GraphQLTypes["ShiftsProfile"] | undefined,
	queueItem?: GraphQLTypes["EmployeeQueueItem"] | undefined,
	swapInfo?: GraphQLTypes["TimetableShiftSwapInfo"] | undefined,
	isOvertime: boolean
};
	["TimetableShiftMeta"]: {
	__typename: "TimetableShiftMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	locked?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	assigned?: GraphQLTypes["FieldMeta"] | undefined,
	group?: GraphQLTypes["FieldMeta"] | undefined,
	shiftsProfile?: GraphQLTypes["FieldMeta"] | undefined,
	queueItem?: GraphQLTypes["FieldMeta"] | undefined,
	swapInfo?: GraphQLTypes["FieldMeta"] | undefined,
	isOvertime?: GraphQLTypes["FieldMeta"] | undefined
};
	["ShiftsProfile"]: {
	__typename: "ShiftsProfile",
	_meta?: GraphQLTypes["ShiftsProfileMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	queueItems: Array<GraphQLTypes["EmployeeQueueItem"]>,
	staff?: GraphQLTypes["Staff"] | undefined,
	roles: Array<GraphQLTypes["TimetableEmployeeRole"]>,
	shifts: Array<GraphQLTypes["TimetableShift"]>,
	allowSelfUnassigning?: boolean | undefined,
	queueItemsByQueue?: GraphQLTypes["EmployeeQueueItem"] | undefined,
	queueItemsByShift?: GraphQLTypes["EmployeeQueueItem"] | undefined,
	queueItemsByUnassignInfo?: GraphQLTypes["EmployeeQueueItem"] | undefined,
	queueItemsByMeta?: GraphQLTypes["EmployeeQueueItem"] | undefined,
	shiftsByQueueItem?: GraphQLTypes["TimetableShift"] | undefined,
	shiftsBySwapInfo?: GraphQLTypes["TimetableShift"] | undefined,
	paginateQueueItems: GraphQLTypes["EmployeeQueueItemConnection"],
	paginateRoles: GraphQLTypes["TimetableEmployeeRoleConnection"],
	paginateShifts: GraphQLTypes["TimetableShiftConnection"]
};
	["ShiftsProfileMeta"]: {
	__typename: "ShiftsProfileMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	queueItems?: GraphQLTypes["FieldMeta"] | undefined,
	staff?: GraphQLTypes["FieldMeta"] | undefined,
	roles?: GraphQLTypes["FieldMeta"] | undefined,
	shifts?: GraphQLTypes["FieldMeta"] | undefined,
	allowSelfUnassigning?: GraphQLTypes["FieldMeta"] | undefined
};
	["EmployeeQueueItem"]: {
	__typename: "EmployeeQueueItem",
	_meta?: GraphQLTypes["EmployeeQueueItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	start?: string | undefined,
	end?: string | undefined,
	queue?: GraphQLTypes["EmployeeQueue"] | undefined,
	shiftsProfile?: GraphQLTypes["ShiftsProfile"] | undefined,
	shift?: GraphQLTypes["TimetableShift"] | undefined,
	unassignInfo?: GraphQLTypes["UnassignedShiftInfo"] | undefined,
	meta?: GraphQLTypes["EmployeeQueueItemMetadata"] | undefined
};
	["EmployeeQueueItemMeta"]: {
	__typename: "EmployeeQueueItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	start?: GraphQLTypes["FieldMeta"] | undefined,
	end?: GraphQLTypes["FieldMeta"] | undefined,
	queue?: GraphQLTypes["FieldMeta"] | undefined,
	shiftsProfile?: GraphQLTypes["FieldMeta"] | undefined,
	shift?: GraphQLTypes["FieldMeta"] | undefined,
	unassignInfo?: GraphQLTypes["FieldMeta"] | undefined,
	meta?: GraphQLTypes["FieldMeta"] | undefined
};
	["EmployeeQueue"]: {
	__typename: "EmployeeQueue",
	_meta?: GraphQLTypes["EmployeeQueueMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	shiftGroup?: GraphQLTypes["TimetableShiftGroup"] | undefined,
	items: Array<GraphQLTypes["EmployeeQueueItem"]>,
	contemberBugFix?: boolean | undefined,
	itemsByShiftsProfile?: GraphQLTypes["EmployeeQueueItem"] | undefined,
	itemsByShift?: GraphQLTypes["EmployeeQueueItem"] | undefined,
	itemsByUnassignInfo?: GraphQLTypes["EmployeeQueueItem"] | undefined,
	itemsByMeta?: GraphQLTypes["EmployeeQueueItem"] | undefined,
	paginateItems: GraphQLTypes["EmployeeQueueItemConnection"]
};
	["EmployeeQueueMeta"]: {
	__typename: "EmployeeQueueMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	shiftGroup?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined,
	contemberBugFix?: GraphQLTypes["FieldMeta"] | undefined
};
	["EmployeeQueueItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	start?: GraphQLTypes["OrderDirection"] | undefined,
	end?: GraphQLTypes["OrderDirection"] | undefined,
	queue?: GraphQLTypes["EmployeeQueueOrderBy"] | undefined,
	shiftsProfile?: GraphQLTypes["ShiftsProfileOrderBy"] | undefined,
	shift?: GraphQLTypes["TimetableShiftOrderBy"] | undefined,
	unassignInfo?: GraphQLTypes["UnassignedShiftInfoOrderBy"] | undefined,
	meta?: GraphQLTypes["EmployeeQueueItemMetadataOrderBy"] | undefined
};
	["EmployeeQueueOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	shiftGroup?: GraphQLTypes["TimetableShiftGroupOrderBy"] | undefined,
	contemberBugFix?: GraphQLTypes["OrderDirection"] | undefined
};
	["TimetableShiftGroupOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	day?: GraphQLTypes["TimetableDayOrderBy"] | undefined,
	type?: GraphQLTypes["TimetableEmployeeRoleOrderBy"] | undefined,
	position?: GraphQLTypes["TimetableShiftPositionOrderBy"] | undefined,
	queue?: GraphQLTypes["EmployeeQueueOrderBy"] | undefined,
	generatedByTemplate?: GraphQLTypes["TimetableTemplateOrderBy"] | undefined
};
	["TimetableDayOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	date?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	tipsCents?: GraphQLTypes["OrderDirection"] | undefined,
	venue?: GraphQLTypes["VenueOrderBy"] | undefined,
	meta?: GraphQLTypes["TimetableDayMetadataOrderBy"] | undefined
};
	["TimetableDayMetadataOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	numberOfWorkers?: GraphQLTypes["OrderDirection"] | undefined,
	tipsTotalCents?: GraphQLTypes["OrderDirection"] | undefined,
	totalMinutes?: GraphQLTypes["OrderDirection"] | undefined,
	tipsCentsPerMinute?: GraphQLTypes["OrderDirection"] | undefined,
	day?: GraphQLTypes["TimetableDayOrderBy"] | undefined
};
	["TimetableEmployeeRoleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	color?: GraphQLTypes["OrderDirection"] | undefined
};
	["TimetableShiftPositionOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	start?: GraphQLTypes["OrderDirection"] | undefined,
	end?: GraphQLTypes["OrderDirection"] | undefined,
	isDynamic?: GraphQLTypes["OrderDirection"] | undefined
};
	["TimetableTemplateOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	startDate?: GraphQLTypes["OrderDirection"] | undefined,
	period?: GraphQLTypes["OrderDirection"] | undefined,
	slots?: GraphQLTypes["OrderDirection"] | undefined,
	position?: GraphQLTypes["TimetableShiftPositionOrderBy"] | undefined,
	internalName?: GraphQLTypes["OrderDirection"] | undefined,
	venue?: GraphQLTypes["VenueOrderBy"] | undefined,
	employeeRole?: GraphQLTypes["TimetableEmployeeRoleOrderBy"] | undefined,
	workdaysOnly?: GraphQLTypes["OrderDirection"] | undefined,
	monday?: GraphQLTypes["OrderDirection"] | undefined,
	tuesday?: GraphQLTypes["OrderDirection"] | undefined,
	wednesday?: GraphQLTypes["OrderDirection"] | undefined,
	thursday?: GraphQLTypes["OrderDirection"] | undefined,
	friday?: GraphQLTypes["OrderDirection"] | undefined,
	saturday?: GraphQLTypes["OrderDirection"] | undefined,
	sunday?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined
};
	["TimetableShiftOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	locked?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	assigned?: GraphQLTypes["OrderDirection"] | undefined,
	group?: GraphQLTypes["TimetableShiftGroupOrderBy"] | undefined,
	shiftsProfile?: GraphQLTypes["ShiftsProfileOrderBy"] | undefined,
	queueItem?: GraphQLTypes["EmployeeQueueItemOrderBy"] | undefined,
	swapInfo?: GraphQLTypes["TimetableShiftSwapInfoOrderBy"] | undefined,
	isOvertime?: GraphQLTypes["OrderDirection"] | undefined
};
	["TimetableShiftSwapInfoOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	assigned?: GraphQLTypes["OrderDirection"] | undefined,
	requested?: GraphQLTypes["OrderDirection"] | undefined,
	confirmed?: GraphQLTypes["OrderDirection"] | undefined,
	swappedShiftsProfile?: GraphQLTypes["ShiftsProfileOrderBy"] | undefined,
	shift?: GraphQLTypes["TimetableShiftOrderBy"] | undefined
};
	["UnassignedShiftInfoOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	hoursMissed?: GraphQLTypes["OrderDirection"] | undefined,
	queueItem?: GraphQLTypes["EmployeeQueueItemOrderBy"] | undefined,
	legacyReason?: GraphQLTypes["OrderDirection"] | undefined,
	reason?: GraphQLTypes["UnassignReasonOrderBy"] | undefined
};
	["UnassignReasonOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined
};
	["EmployeeQueueItemMetadataOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	totalMinutes?: GraphQLTypes["OrderDirection"] | undefined,
	queueItem?: GraphQLTypes["EmployeeQueueItemOrderBy"] | undefined,
	includeInTipsCalculation?: GraphQLTypes["OrderDirection"] | undefined
};
	["EmployeeQueueItemsByShiftsProfileUniqueWhere"]: {
		shiftsProfile?: GraphQLTypes["ShiftsProfileUniqueWhere"] | undefined
};
	["ShiftsProfileUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	queueItems?: GraphQLTypes["EmployeeQueueItemUniqueWhere"] | undefined,
	staff?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	shifts?: GraphQLTypes["TimetableShiftUniqueWhere"] | undefined
};
	["EmployeeQueueItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	shiftsProfile?: GraphQLTypes["ShiftsProfileUniqueWhere"] | undefined,
	queue?: GraphQLTypes["EmployeeQueueUniqueWhere"] | undefined,
	shift?: GraphQLTypes["TimetableShiftUniqueWhere"] | undefined,
	unassignInfo?: GraphQLTypes["UnassignedShiftInfoUniqueWhere"] | undefined,
	meta?: GraphQLTypes["EmployeeQueueItemMetadataUniqueWhere"] | undefined
};
	["EmployeeQueueUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	shiftGroup?: GraphQLTypes["TimetableShiftGroupUniqueWhere"] | undefined,
	items?: GraphQLTypes["EmployeeQueueItemUniqueWhere"] | undefined
};
	["TimetableShiftGroupUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	shifts?: GraphQLTypes["TimetableShiftUniqueWhere"] | undefined,
	queue?: GraphQLTypes["EmployeeQueueUniqueWhere"] | undefined
};
	["TimetableShiftUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	queueItem?: GraphQLTypes["EmployeeQueueItemUniqueWhere"] | undefined,
	swapInfo?: GraphQLTypes["TimetableShiftSwapInfoUniqueWhere"] | undefined
};
	["TimetableShiftSwapInfoUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	swappedShiftsProfile?: GraphQLTypes["ShiftsProfileUniqueWhere"] | undefined,
	shift?: GraphQLTypes["TimetableShiftUniqueWhere"] | undefined
};
	["UnassignedShiftInfoUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	queueItem?: GraphQLTypes["EmployeeQueueItemUniqueWhere"] | undefined
};
	["EmployeeQueueItemMetadataUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	queueItem?: GraphQLTypes["EmployeeQueueItemUniqueWhere"] | undefined
};
	["StaffUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	bartender?: GraphQLTypes["BartenderUniqueWhere"] | undefined,
	courier?: GraphQLTypes["CourierUniqueWhere"] | undefined,
	cleaner?: GraphQLTypes["CleanerUniqueWhere"] | undefined,
	shiftsManager?: GraphQLTypes["ShiftsManagerUniqueWhere"] | undefined,
	businessToBusinessManager?: GraphQLTypes["BusinessToBusinessManagerUniqueWhere"] | undefined,
	user?: GraphQLTypes["UserUniqueWhere"] | undefined,
	shiftsProfile?: GraphQLTypes["ShiftsProfileUniqueWhere"] | undefined,
	stocksManager?: GraphQLTypes["StocksManagerUniqueWhere"] | undefined,
	courierManager?: GraphQLTypes["CourierManagerUniqueWhere"] | undefined,
	picker?: GraphQLTypes["PickerUniqueWhere"] | undefined,
	remunerationProfile?: GraphQLTypes["RemunerationProfileUniqueWhere"] | undefined,
	cashier?: GraphQLTypes["CashierUniqueWhere"] | undefined,
	internalBuyer?: GraphQLTypes["InternalBuyerUniqueWhere"] | undefined,
	salesManager?: GraphQLTypes["SalesManagerUniqueWhere"] | undefined,
	cashierManager?: GraphQLTypes["CashierManagerUniqueWhere"] | undefined
};
	["BartenderUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	staff?: GraphQLTypes["StaffUniqueWhere"] | undefined
};
	["CourierUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	staff?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	routes?: GraphQLTypes["DeliveryRouteUniqueWhere"] | undefined
};
	["DeliveryRouteUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	waypoints?: GraphQLTypes["DeliveryWaypointUniqueWhere"] | undefined
};
	["DeliveryWaypointUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	delivery?: GraphQLTypes["OrderDeliveryUniqueWhere"] | undefined
};
	["OrderDeliveryUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	trackingCode?: string | undefined,
	order?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	deliveryWaypoint?: GraphQLTypes["DeliveryWaypointUniqueWhere"] | undefined,
	events?: GraphQLTypes["OrderEventUniqueWhere"] | undefined,
	liftagoRide?: GraphQLTypes["LiftagoRideUniqueWhere"] | undefined,
	woltDriveDelivery?: GraphQLTypes["WoltDriveDeliveryUniqueWhere"] | undefined
};
	["OrderUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	seq?: number | undefined,
	doubleshotLegacyId?: string | undefined,
	doubleShotLegacyNumber?: string | undefined,
	discounts?: GraphQLTypes["OrderDiscountUniqueWhere"] | undefined,
	delivery?: GraphQLTypes["OrderDeliveryUniqueWhere"] | undefined,
	items?: GraphQLTypes["OrderItemUniqueWhere"] | undefined,
	cart?: GraphQLTypes["CartUniqueWhere"] | undefined,
	events?: GraphQLTypes["OrderEventUniqueWhere"] | undefined,
	priceLines?: GraphQLTypes["OrderPriceLineUniqueWhere"] | undefined,
	payments?: GraphQLTypes["OrderPaymentUniqueWhere"] | undefined,
	summary?: GraphQLTypes["OrderSummaryUniqueWhere"] | undefined,
	gratuity?: GraphQLTypes["GratuityUniqueWhere"] | undefined
};
	["OrderDiscountUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	customerCreditTransactions?: GraphQLTypes["CustomerCreditTransactionUniqueWhere"] | undefined,
	voucherRedemption?: GraphQLTypes["VoucherRedemptionUniqueWhere"] | undefined
};
	["CustomerCreditTransactionUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	virtualProductEffect?: GraphQLTypes["VirtualProductEffectUniqueWhere"] | undefined
};
	["VirtualProductEffectUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	resultCustomerCreditTransaction?: GraphQLTypes["CustomerCreditTransactionUniqueWhere"] | undefined,
	resultVouchers?: GraphQLTypes["VoucherUniqueWhere"] | undefined
};
	["VoucherUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	redemption?: GraphQLTypes["VoucherRedemptionUniqueWhere"] | undefined
};
	["VoucherRedemptionUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	customerCredit?: GraphQLTypes["CustomerCreditUniqueWhere"] | undefined,
	orderDiscount?: GraphQLTypes["OrderDiscountUniqueWhere"] | undefined,
	voucher?: GraphQLTypes["VoucherUniqueWhere"] | undefined
};
	["CustomerCreditUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	transactions?: GraphQLTypes["CustomerCreditTransactionUniqueWhere"] | undefined,
	voucherRedemption?: GraphQLTypes["VoucherRedemptionUniqueWhere"] | undefined
};
	["OrderItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	virtualProductEffects?: GraphQLTypes["VirtualProductEffectUniqueWhere"] | undefined
};
	["CartUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["CartItemUniqueWhere"] | undefined,
	order?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	priceLines?: GraphQLTypes["CartPriceLineUniqueWhere"] | undefined,
	summary?: GraphQLTypes["CartSummaryUniqueWhere"] | undefined
};
	["CartItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	cart?: GraphQLTypes["CartUniqueWhere"] | undefined,
	product?: GraphQLTypes["ProductUniqueWhere"] | undefined
};
	["ProductUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	stocks?: GraphQLTypes["ProductStockUniqueWhere"] | undefined,
	groupPrices?: GraphQLTypes["ProductGroupPriceUniqueWhere"] | undefined,
	cartItems?: GraphQLTypes["CartItemUniqueWhere"] | undefined,
	orderItems?: GraphQLTypes["OrderItemUniqueWhere"] | undefined,
	inheritedCategories?: GraphQLTypes["NestedProductCategoryProductUniqueWhere"] | undefined,
	locales?: GraphQLTypes["ProductLocaleUniqueWhere"] | undefined,
	customerPrices?: GraphQLTypes["ProductCustomerPriceUniqueWhere"] | undefined,
	virtualProduct?: GraphQLTypes["VirtualProductUniqueWhere"] | undefined,
	meta?: GraphQLTypes["ProductMetadataUniqueWhere"] | undefined,
	page?: GraphQLTypes["PageUniqueWhere"] | undefined,
	salesDays?: GraphQLTypes["ProductSalesDayUniqueWhere"] | undefined,
	salesWeeks?: GraphQLTypes["ProductSalesWeekUniqueWhere"] | undefined,
	salesMonths?: GraphQLTypes["ProductSalesMonthUniqueWhere"] | undefined
};
	["ProductStockUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	product?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	store?: GraphQLTypes["StoreUniqueWhere"] | undefined
};
	["StoreUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined
};
	["ProductGroupPriceUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	group?: GraphQLTypes["CustomerGroupUniqueWhere"] | undefined,
	product?: GraphQLTypes["ProductUniqueWhere"] | undefined
};
	["CustomerGroupUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	doubleshotLegacyId?: string | undefined,
	productPrices?: GraphQLTypes["ProductGroupPriceUniqueWhere"] | undefined,
	customers?: GraphQLTypes["CustomerUniqueWhere"] | undefined
};
	["CustomerUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	doubleshotLegacyId?: string | undefined,
	addresses?: GraphQLTypes["AddressUniqueWhere"] | undefined,
	defaultBillingAddress?: GraphQLTypes["AddressUniqueWhere"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerPaymentMethodUniqueWhere"] | undefined,
	credits?: GraphQLTypes["CustomerCreditUniqueWhere"] | undefined,
	paymentMethods?: GraphQLTypes["CustomerPaymentMethodUniqueWhere"] | undefined,
	orders?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	permissions?: GraphQLTypes["CustomerPermissionsUniqueWhere"] | undefined,
	name?: GraphQLTypes["CustomerNameUniqueWhere"] | undefined,
	ingredientRatings?: GraphQLTypes["CustomerIngredientRatingUniqueWhere"] | undefined,
	business?: GraphQLTypes["BusinessCustomerUniqueWhere"] | undefined,
	carts?: GraphQLTypes["CartUniqueWhere"] | undefined,
	shortcutList?: GraphQLTypes["ApplicationShortcutListUniqueWhere"] | undefined,
	user?: GraphQLTypes["UserUniqueWhere"] | undefined,
	invoices?: GraphQLTypes["InvoiceUniqueWhere"] | undefined,
	invoicingPlan?: GraphQLTypes["InvoicingPlanUniqueWhere"] | undefined,
	billingSubjects?: GraphQLTypes["BillingSubjectUniqueWhere"] | undefined,
	offeredProducts?: GraphQLTypes["ProductCustomerPriceUniqueWhere"] | undefined,
	defaultDeliveryAddress?: GraphQLTypes["AddressUniqueWhere"] | undefined,
	defaultBillingSubject?: GraphQLTypes["BillingSubjectUniqueWhere"] | undefined,
	anonymousSession?: GraphQLTypes["AnonymousSessionUniqueWhere"] | undefined,
	boughtVouchers?: GraphQLTypes["VoucherUniqueWhere"] | undefined,
	ownsVouchers?: GraphQLTypes["VoucherUniqueWhere"] | undefined,
	redeemedVouchers?: GraphQLTypes["VoucherRedemptionUniqueWhere"] | undefined,
	spending?: GraphQLTypes["CustomerSpendingUniqueWhere"] | undefined,
	customerTabs?: GraphQLTypes["CustomerTabUniqueWhere"] | undefined,
	lead?: GraphQLTypes["PipelineLeadUniqueWhere"] | undefined,
	meta?: GraphQLTypes["CustomerMetadataUniqueWhere"] | undefined
};
	["AddressUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	meta?: GraphQLTypes["AddressMetadataUniqueWhere"] | undefined,
	gps?: GraphQLTypes["GpsUniqueWhere"] | undefined,
	invoices?: GraphQLTypes["InvoiceUniqueWhere"] | undefined,
	billingAddressOfOrders?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	deliveryAddressOfOrderDeliveries?: GraphQLTypes["OrderDeliveryUniqueWhere"] | undefined,
	defaultDeliveryAddressOfCustomer?: GraphQLTypes["CustomerUniqueWhere"] | undefined
};
	["AddressMetadataUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	address?: GraphQLTypes["AddressUniqueWhere"] | undefined
};
	["GpsUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	address?: GraphQLTypes["AddressUniqueWhere"] | undefined
};
	["InvoiceUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	publicKey?: string | undefined,
	fakturoidId?: string | undefined,
	orderPayments?: GraphQLTypes["OrderPaymentUniqueWhere"] | undefined
};
	["OrderPaymentUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	events?: GraphQLTypes["OrderEventUniqueWhere"] | undefined,
	meta?: GraphQLTypes["OrderPaymentMetadataUniqueWhere"] | undefined
};
	["OrderEventUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["OrderPaymentMetadataUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	orderPayment?: GraphQLTypes["OrderPaymentUniqueWhere"] | undefined
};
	["CustomerPaymentMethodUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["CustomerPermissionsUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	customer?: GraphQLTypes["CustomerUniqueWhere"] | undefined
};
	["CustomerNameUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	customer?: GraphQLTypes["CustomerUniqueWhere"] | undefined
};
	["CustomerIngredientRatingUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	customer?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	ingredient?: GraphQLTypes["ProductIngredientUniqueWhere"] | undefined
};
	["ProductIngredientUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locales?: GraphQLTypes["ProductIngredientLocaleUniqueWhere"] | undefined,
	customerRatings?: GraphQLTypes["CustomerIngredientRatingUniqueWhere"] | undefined,
	suppliers?: GraphQLTypes["IngredientSupplierListUniqueWhere"] | undefined
};
	["ProductIngredientLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["ProductIngredientUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["LocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	businessCategories?: GraphQLTypes["BusinessCategoryLocaleUniqueWhere"] | undefined,
	productCategoryLists?: GraphQLTypes["ProductCategoryListLocaleUniqueWhere"] | undefined,
	productIngredients?: GraphQLTypes["ProductIngredientLocaleUniqueWhere"] | undefined,
	orderRecurrences?: GraphQLTypes["OrderRecurrenceLocaleUniqueWhere"] | undefined,
	blogs?: GraphQLTypes["BlogLocaleUniqueWhere"] | undefined,
	blogPosts?: GraphQLTypes["BlogPostLocaleUniqueWhere"] | undefined,
	identifier?: GraphQLTypes["TranslationCataloguesIdentifierUniqueWhere"] | undefined,
	menus?: GraphQLTypes["MenuLocaleUniqueWhere"] | undefined,
	pages?: GraphQLTypes["PageLocaleUniqueWhere"] | undefined,
	productIngredientCategories?: GraphQLTypes["ProductIngredientCategoryLocaleUniqueWhere"] | undefined,
	allergens?: GraphQLTypes["AllergenLocaleUniqueWhere"] | undefined,
	productPackings?: GraphQLTypes["ProductPackingLocaleUniqueWhere"] | undefined,
	products?: GraphQLTypes["ProductLocaleUniqueWhere"] | undefined,
	productRecipes?: GraphQLTypes["ProductRecipeLocaleUniqueWhere"] | undefined,
	pointOfSaleCategories?: GraphQLTypes["PointOfSaleCategoryLocaleUniqueWhere"] | undefined,
	pointOfSaleCategoryProducts?: GraphQLTypes["PointOfSaleCategoryProductLocaleUniqueWhere"] | undefined,
	deliveryMethods?: GraphQLTypes["DeliveryMethodLocaleUniqueWhere"] | undefined,
	ingredientSuppliers?: GraphQLTypes["IngredientSupplierLocaleUniqueWhere"] | undefined,
	identificationCodes?: GraphQLTypes["IdentificationCodeLocaleUniqueWhere"] | undefined,
	pipelineStages?: GraphQLTypes["PipelineStageLocaleUniqueWhere"] | undefined,
	subscriptionBoxes?: GraphQLTypes["SubscriptionBoxLocaleUniqueWhere"] | undefined,
	businessServices?: GraphQLTypes["BusinessServiceLocaleUniqueWhere"] | undefined
};
	["BusinessCategoryLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["BusinessCategoryUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["BusinessCategoryUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	slug?: string | undefined,
	locales?: GraphQLTypes["BusinessCategoryLocaleUniqueWhere"] | undefined,
	businessCustomers?: GraphQLTypes["BusinessCustomerUniqueWhere"] | undefined,
	specificProducts?: GraphQLTypes["ProductListUniqueWhere"] | undefined,
	seasonalProductCategories?: GraphQLTypes["ProductCategoryListUniqueWhere"] | undefined,
	specificProductsProductCategories?: GraphQLTypes["ProductCategoryListUniqueWhere"] | undefined
};
	["BusinessCustomerUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	customer?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	businessServiceEvents?: GraphQLTypes["BusinessServiceEventUniqueWhere"] | undefined,
	doubleshotCoffeeEquipment?: GraphQLTypes["DoubleshotCoffeeEquipmentUniqueWhere"] | undefined
};
	["BusinessServiceEventUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["DoubleshotCoffeeEquipmentUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["ProductListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["ProductListItemUniqueWhere"] | undefined,
	businessCategory?: GraphQLTypes["BusinessCategoryUniqueWhere"] | undefined
};
	["ProductListItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["ProductCategoryListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["ProductCategoryListItemUniqueWhere"] | undefined,
	locales?: GraphQLTypes["ProductCategoryListLocaleUniqueWhere"] | undefined,
	seasonalProductCategoriesOfBusinessCategory?: GraphQLTypes["BusinessCategoryUniqueWhere"] | undefined,
	specificProductsProductCategoriesOfBusinessCategory?: GraphQLTypes["BusinessCategoryUniqueWhere"] | undefined
};
	["ProductCategoryListItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["ProductCategoryListLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["ProductCategoryListUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["OrderRecurrenceLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["OrderRecurrenceUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["OrderRecurrenceUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locales?: GraphQLTypes["OrderRecurrenceLocaleUniqueWhere"] | undefined
};
	["BlogLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["BlogUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["BlogUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: GraphQLTypes["BlogLocaleUniqueWhere"] | undefined
};
	["BlogPostLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["BlogPostUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	cover?: GraphQLTypes["CoverUniqueWhere"] | undefined,
	content?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	link?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["BlogPostUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locales?: GraphQLTypes["BlogPostLocaleUniqueWhere"] | undefined
};
	["CoverUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["ContentUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	blocks?: GraphQLTypes["ContentBlockUniqueWhere"] | undefined
};
	["ContentBlockUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	references?: GraphQLTypes["ContentReferenceUniqueWhere"] | undefined
};
	["ContentReferenceUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	products?: GraphQLTypes["ProductListUniqueWhere"] | undefined,
	productBanners?: GraphQLTypes["ProductBannerListUniqueWhere"] | undefined,
	deliveryRegions?: GraphQLTypes["DeliveryRegionsUniqueWhere"] | undefined
};
	["ProductBannerListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["ProductBannerItemUniqueWhere"] | undefined
};
	["ProductBannerItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["DeliveryRegionsUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["DeliveryRegionsItemUniqueWhere"] | undefined
};
	["DeliveryRegionsItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	image?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	textList?: GraphQLTypes["TextListUniqueWhere"] | undefined,
	gallery?: GraphQLTypes["ImageListUniqueWhere"] | undefined
};
	["ImageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["TextListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["TextItemUniqueWhere"] | undefined
};
	["TextItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["ImageListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["ImageListItemUniqueWhere"] | undefined
};
	["ImageListItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	image?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["LinkableUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	url?: string | undefined,
	blogPost?: GraphQLTypes["BlogPostLocaleUniqueWhere"] | undefined,
	page?: GraphQLTypes["PageLocaleUniqueWhere"] | undefined,
	wikiPage?: GraphQLTypes["WikiPageUniqueWhere"] | undefined,
	redirect?: GraphQLTypes["RedirectUniqueWhere"] | undefined
};
	["PageLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["PageUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	link?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	seo?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	content?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	cover?: GraphQLTypes["CoverUniqueWhere"] | undefined
};
	["PageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locales?: GraphQLTypes["PageLocaleUniqueWhere"] | undefined
};
	["SeoUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	ogImage?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["WikiPageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	link?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	children?: GraphQLTypes["WikiPageUniqueWhere"] | undefined,
	content?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["RedirectUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	link?: GraphQLTypes["LinkableUniqueWhere"] | undefined
};
	["TranslationCataloguesIdentifierUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	catalogue?: GraphQLTypes["TranslationCatalogueUniqueWhere"] | undefined
};
	["TranslationCatalogueUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	domain?: GraphQLTypes["TranslationDomainUniqueWhere"] | undefined,
	identifier?: GraphQLTypes["TranslationCataloguesIdentifierUniqueWhere"] | undefined,
	values?: GraphQLTypes["TranslationValueUniqueWhere"] | undefined
};
	["TranslationDomainUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	identifier?: string | undefined,
	catalogues?: GraphQLTypes["TranslationCatalogueUniqueWhere"] | undefined,
	keys?: GraphQLTypes["TranslationKeyUniqueWhere"] | undefined
};
	["TranslationKeyUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	domain?: GraphQLTypes["TranslationDomainUniqueWhere"] | undefined,
	identifier?: string | undefined,
	values?: GraphQLTypes["TranslationValueUniqueWhere"] | undefined
};
	["TranslationValueUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	catalogue?: GraphQLTypes["TranslationCatalogueUniqueWhere"] | undefined,
	key?: GraphQLTypes["TranslationKeyUniqueWhere"] | undefined
};
	["MenuLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["SiteMenuUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	items?: GraphQLTypes["MenuItemUniqueWhere"] | undefined,
	secondaryItems?: GraphQLTypes["LinkListUniqueWhere"] | undefined
};
	["SiteMenuUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: GraphQLTypes["MenuLocaleUniqueWhere"] | undefined
};
	["MenuItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	subitems?: GraphQLTypes["MenuSubitemUniqueWhere"] | undefined
};
	["MenuSubitemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["LinkListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["LinkListItemUniqueWhere"] | undefined
};
	["LinkListItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["ProductIngredientCategoryLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["ProductIngredientCategoryUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["ProductIngredientCategoryUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locales?: GraphQLTypes["ProductIngredientCategoryLocaleUniqueWhere"] | undefined
};
	["AllergenLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["AllergenUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["AllergenUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: number | undefined,
	locales?: GraphQLTypes["AllergenLocaleUniqueWhere"] | undefined
};
	["ProductPackingLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["ProductPackingUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["ProductPackingUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locales?: GraphQLTypes["ProductPackingLocaleUniqueWhere"] | undefined,
	preparedPackingQuantities?: GraphQLTypes["PreparedPackingQuantityUniqueWhere"] | undefined
};
	["PreparedPackingQuantityUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	date?: GraphQLTypes["Date"] | undefined,
	recipe?: GraphQLTypes["ProductRecipeUniqueWhere"] | undefined,
	packing?: GraphQLTypes["ProductPackingUniqueWhere"] | undefined,
	packedInCardboard?: boolean | undefined
};
	["ProductRecipeUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	products?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	ingredients?: GraphQLTypes["ProductIngredientItemUniqueWhere"] | undefined,
	locales?: GraphQLTypes["ProductRecipeLocaleUniqueWhere"] | undefined,
	nutritionFacts?: GraphQLTypes["NutritionFactsUniqueWhere"] | undefined
};
	["ProductIngredientItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	quantity?: GraphQLTypes["ProductIngredientItemQuantityUniqueWhere"] | undefined
};
	["ProductIngredientItemQuantityUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["ProductRecipeLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["ProductRecipeUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["NutritionFactsUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["ProductLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	featureList?: GraphQLTypes["TextListUniqueWhere"] | undefined
};
	["PointOfSaleCategoryLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["PointOfSaleCategoryUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["PointOfSaleCategoryUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	slug?: string | undefined,
	locales?: GraphQLTypes["PointOfSaleCategoryLocaleUniqueWhere"] | undefined,
	products?: GraphQLTypes["PointOfSaleCategoryProductUniqueWhere"] | undefined
};
	["PointOfSaleCategoryProductUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locales?: GraphQLTypes["PointOfSaleCategoryProductLocaleUniqueWhere"] | undefined
};
	["PointOfSaleCategoryProductLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["PointOfSaleCategoryProductUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["DeliveryMethodLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	root?: GraphQLTypes["DeliveryMethodUniqueWhere"] | undefined
};
	["DeliveryMethodUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	channels?: GraphQLTypes["ChannelDeliveryUniqueWhere"] | undefined,
	locales?: GraphQLTypes["DeliveryMethodLocaleUniqueWhere"] | undefined,
	timelinePreset?: GraphQLTypes["DeliveryTimelinePresetUniqueWhere"] | undefined
};
	["ChannelDeliveryUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["DeliveryTimelinePresetUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	deliveryMethod?: GraphQLTypes["DeliveryMethodUniqueWhere"] | undefined
};
	["IngredientSupplierLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["IngredientSupplierUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["IngredientSupplierUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locales?: GraphQLTypes["IngredientSupplierLocaleUniqueWhere"] | undefined
};
	["IdentificationCodeLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["IdentificationCodeUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["IdentificationCodeUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	attempts?: GraphQLTypes["IdentificationAttemptUniqueWhere"] | undefined,
	locales?: GraphQLTypes["IdentificationCodeLocaleUniqueWhere"] | undefined,
	applicationDevices?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined
};
	["IdentificationAttemptUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["PointOfSaleApplicationDeviceUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	identifier?: GraphQLTypes["DeviceIdentifierUniqueWhere"] | undefined
};
	["DeviceIdentifierUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	identifier?: string | undefined,
	device?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined,
	meta?: GraphQLTypes["DeviceIdentifierMetadataUniqueWhere"] | undefined
};
	["DeviceIdentifierMetadataUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	deviceIdentifier?: GraphQLTypes["DeviceIdentifierUniqueWhere"] | undefined
};
	["PipelineStageLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["PipelineStageUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["PipelineStageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["PipelineStageItemUniqueWhere"] | undefined,
	locales?: GraphQLTypes["PipelineStageLocaleUniqueWhere"] | undefined,
	forms?: GraphQLTypes["LeadFormUniqueWhere"] | undefined
};
	["PipelineStageItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	lead?: GraphQLTypes["PipelineLeadUniqueWhere"] | undefined
};
	["PipelineLeadUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	stageItem?: GraphQLTypes["PipelineStageItemUniqueWhere"] | undefined
};
	["LeadFormUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	leads?: GraphQLTypes["PipelineLeadUniqueWhere"] | undefined
};
	["SubscriptionBoxLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["SubscriptionBoxUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	texts?: GraphQLTypes["TextListUniqueWhere"] | undefined,
	secondaryTexts?: GraphQLTypes["TextListUniqueWhere"] | undefined
};
	["SubscriptionBoxUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: GraphQLTypes["SubscriptionBoxLocaleUniqueWhere"] | undefined
};
	["BusinessServiceLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["BusinessServiceUniqueWhere"] | undefined,
	locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["BusinessServiceUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locales?: GraphQLTypes["BusinessServiceLocaleUniqueWhere"] | undefined
};
	["IngredientSupplierListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["IngredientSupplierItemUniqueWhere"] | undefined
};
	["IngredientSupplierItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["ApplicationShortcutListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["ApplicationShortcutListItemUniqueWhere"] | undefined,
	customer?: GraphQLTypes["CustomerUniqueWhere"] | undefined
};
	["ApplicationShortcutListItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["UserUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	tenantPersonId?: GraphQLTypes["UUID"] | undefined,
	staff?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	customer?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	devices?: GraphQLTypes["UserDeviceUniqueWhere"] | undefined,
	meta?: GraphQLTypes["UserMetadataUniqueWhere"] | undefined,
	identificationAttempts?: GraphQLTypes["IdentificationAttemptUniqueWhere"] | undefined,
	roles?: GraphQLTypes["UserRolesUniqueWhere"] | undefined
};
	["UserDeviceUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	deviceId?: string | undefined
};
	["UserMetadataUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	tenantEmail?: string | undefined,
	tenantPersonId?: GraphQLTypes["UUID"] | undefined,
	tenantIdentityId?: GraphQLTypes["UUID"] | undefined,
	user?: GraphQLTypes["UserUniqueWhere"] | undefined
};
	["UserRolesUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	user?: GraphQLTypes["UserUniqueWhere"] | undefined
};
	["InvoicingPlanUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	customer?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	preset?: GraphQLTypes["InvoicingPresetUniqueWhere"] | undefined
};
	["InvoicingPresetUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	invoicingPlan?: GraphQLTypes["InvoicingPlanUniqueWhere"] | undefined
};
	["BillingSubjectUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	invoices?: GraphQLTypes["InvoiceUniqueWhere"] | undefined,
	defaultBillingSubjectOfCustomer?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	orders?: GraphQLTypes["OrderUniqueWhere"] | undefined
};
	["ProductCustomerPriceUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	product?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	customer?: GraphQLTypes["CustomerUniqueWhere"] | undefined
};
	["AnonymousSessionUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	anonymousSessionKey?: string | undefined,
	customer?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	devices?: GraphQLTypes["UserDeviceUniqueWhere"] | undefined
};
	["CustomerSpendingUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	customer?: GraphQLTypes["CustomerUniqueWhere"] | undefined
};
	["CustomerTabUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["CustomerTabItemUniqueWhere"] | undefined,
	meta?: GraphQLTypes["CustomerTabMetadataUniqueWhere"] | undefined
};
	["CustomerTabItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["CustomerTabMetadataUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	customerTab?: GraphQLTypes["CustomerTabUniqueWhere"] | undefined
};
	["CustomerMetadataUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	customer?: GraphQLTypes["CustomerUniqueWhere"] | undefined
};
	["NestedProductCategoryProductUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["VirtualProductUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	product?: GraphQLTypes["ProductUniqueWhere"] | undefined
};
	["ProductMetadataUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	product?: GraphQLTypes["ProductUniqueWhere"] | undefined
};
	["ProductSalesDayUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["ProductSalesWeekUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["ProductSalesMonthUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["CartPriceLineUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["CartSummaryUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	cart?: GraphQLTypes["CartUniqueWhere"] | undefined
};
	["OrderPriceLineUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	orderItem?: GraphQLTypes["OrderItemUniqueWhere"] | undefined,
	orderDiscount?: GraphQLTypes["OrderDiscountUniqueWhere"] | undefined,
	orderPayment?: GraphQLTypes["OrderPaymentUniqueWhere"] | undefined,
	orderDelivery?: GraphQLTypes["OrderDeliveryUniqueWhere"] | undefined
};
	["OrderSummaryUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: GraphQLTypes["OrderUniqueWhere"] | undefined
};
	["GratuityUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: GraphQLTypes["OrderUniqueWhere"] | undefined
};
	["LiftagoRideUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	delivery?: GraphQLTypes["OrderDeliveryUniqueWhere"] | undefined
};
	["WoltDriveDeliveryUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	shipmentPromiseId?: string | undefined,
	deliveryOrderId?: string | undefined,
	delivery?: GraphQLTypes["OrderDeliveryUniqueWhere"] | undefined
};
	["CleanerUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	staff?: GraphQLTypes["StaffUniqueWhere"] | undefined
};
	["ShiftsManagerUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	staff?: GraphQLTypes["StaffUniqueWhere"] | undefined
};
	["BusinessToBusinessManagerUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	staff?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	managedBusinesses?: GraphQLTypes["BusinessCustomerUniqueWhere"] | undefined
};
	["StocksManagerUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	staff?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	managedProducts?: GraphQLTypes["ProductUniqueWhere"] | undefined
};
	["CourierManagerUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	staff?: GraphQLTypes["StaffUniqueWhere"] | undefined
};
	["PickerUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	staff?: GraphQLTypes["StaffUniqueWhere"] | undefined
};
	["RemunerationProfileUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	employmentInformation?: GraphQLTypes["EmploymentInformationUniqueWhere"] | undefined,
	staff?: GraphQLTypes["StaffUniqueWhere"] | undefined
};
	["EmploymentInformationUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["CashierUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	staff?: GraphQLTypes["StaffUniqueWhere"] | undefined
};
	["InternalBuyerUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	staff?: GraphQLTypes["StaffUniqueWhere"] | undefined
};
	["SalesManagerUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	staff?: GraphQLTypes["StaffUniqueWhere"] | undefined
};
	["CashierManagerUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	staff?: GraphQLTypes["StaffUniqueWhere"] | undefined
};
	["EmployeeQueueItemsByShiftUniqueWhere"]: {
		shift?: GraphQLTypes["TimetableShiftUniqueWhere"] | undefined
};
	["EmployeeQueueItemsByUnassignInfoUniqueWhere"]: {
		unassignInfo?: GraphQLTypes["UnassignedShiftInfoUniqueWhere"] | undefined
};
	["EmployeeQueueItemsByMetaUniqueWhere"]: {
		meta?: GraphQLTypes["EmployeeQueueItemMetadataUniqueWhere"] | undefined
};
	["EmployeeQueueItemConnection"]: {
	__typename: "EmployeeQueueItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["EmployeeQueueItemEdge"]>
};
	["EmployeeQueueItemEdge"]: {
	__typename: "EmployeeQueueItemEdge",
	node: GraphQLTypes["EmployeeQueueItem"]
};
	["UnassignedShiftInfo"]: {
	__typename: "UnassignedShiftInfo",
	_meta?: GraphQLTypes["UnassignedShiftInfoMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	hoursMissed?: number | undefined,
	queueItem?: GraphQLTypes["EmployeeQueueItem"] | undefined,
	legacyReason?: GraphQLTypes["UnassignedInfoReason"] | undefined,
	reason?: GraphQLTypes["UnassignReason"] | undefined
};
	["UnassignedShiftInfoMeta"]: {
	__typename: "UnassignedShiftInfoMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	hoursMissed?: GraphQLTypes["FieldMeta"] | undefined,
	queueItem?: GraphQLTypes["FieldMeta"] | undefined,
	legacyReason?: GraphQLTypes["FieldMeta"] | undefined,
	reason?: GraphQLTypes["FieldMeta"] | undefined
};
	["UnassignReason"]: {
	__typename: "UnassignReason",
	_meta?: GraphQLTypes["UnassignReasonMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	name: string,
	venues: Array<GraphQLTypes["Venue"]>,
	paginateVenues: GraphQLTypes["VenueConnection"]
};
	["UnassignReasonMeta"]: {
	__typename: "UnassignReasonMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	venues?: GraphQLTypes["FieldMeta"] | undefined
};
	["VenueConnection"]: {
	__typename: "VenueConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["VenueEdge"]>
};
	["VenueEdge"]: {
	__typename: "VenueEdge",
	node: GraphQLTypes["Venue"]
};
	["EmployeeQueueItemMetadata"]: {
	__typename: "EmployeeQueueItemMetadata",
	_meta?: GraphQLTypes["EmployeeQueueItemMetadataMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	totalMinutes: number,
	queueItem?: GraphQLTypes["EmployeeQueueItem"] | undefined,
	includeInTipsCalculation: boolean
};
	["EmployeeQueueItemMetadataMeta"]: {
	__typename: "EmployeeQueueItemMetadataMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	totalMinutes?: GraphQLTypes["FieldMeta"] | undefined,
	queueItem?: GraphQLTypes["FieldMeta"] | undefined,
	includeInTipsCalculation?: GraphQLTypes["FieldMeta"] | undefined
};
	["TimetableEmployeeRole"]: {
	__typename: "TimetableEmployeeRole",
	_meta?: GraphQLTypes["TimetableEmployeeRoleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	shiftGroups: Array<GraphQLTypes["TimetableShiftGroup"]>,
	shiftsProfiles: Array<GraphQLTypes["ShiftsProfile"]>,
	shiftsManagers: Array<GraphQLTypes["ShiftsManager"]>,
	name: string,
	timetableTemplates: Array<GraphQLTypes["TimetableTemplate"]>,
	color: string,
	shiftGroupsByShifts?: GraphQLTypes["TimetableShiftGroup"] | undefined,
	shiftGroupsByQueue?: GraphQLTypes["TimetableShiftGroup"] | undefined,
	timetableTemplatesByStaffOptions?: GraphQLTypes["TimetableTemplate"] | undefined,
	paginateShiftGroups: GraphQLTypes["TimetableShiftGroupConnection"],
	paginateShiftsProfiles: GraphQLTypes["ShiftsProfileConnection"],
	paginateShiftsManagers: GraphQLTypes["ShiftsManagerConnection"],
	paginateTimetableTemplates: GraphQLTypes["TimetableTemplateConnection"]
};
	["TimetableEmployeeRoleMeta"]: {
	__typename: "TimetableEmployeeRoleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	shiftGroups?: GraphQLTypes["FieldMeta"] | undefined,
	shiftsProfiles?: GraphQLTypes["FieldMeta"] | undefined,
	shiftsManagers?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	timetableTemplates?: GraphQLTypes["FieldMeta"] | undefined,
	color?: GraphQLTypes["FieldMeta"] | undefined
};
	["ShiftsManager"]: {
	__typename: "ShiftsManager",
	_meta?: GraphQLTypes["ShiftsManagerMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	staff?: GraphQLTypes["Staff"] | undefined,
	managedRoles: Array<GraphQLTypes["TimetableEmployeeRole"]>,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	paginateManagedRoles: GraphQLTypes["TimetableEmployeeRoleConnection"]
};
	["ShiftsManagerMeta"]: {
	__typename: "ShiftsManagerMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	staff?: GraphQLTypes["FieldMeta"] | undefined,
	managedRoles?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined
};
	["TimetableEmployeeRoleConnection"]: {
	__typename: "TimetableEmployeeRoleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TimetableEmployeeRoleEdge"]>
};
	["TimetableEmployeeRoleEdge"]: {
	__typename: "TimetableEmployeeRoleEdge",
	node: GraphQLTypes["TimetableEmployeeRole"]
};
	["TimetableTemplate"]: {
	__typename: "TimetableTemplate",
	_meta?: GraphQLTypes["TimetableTemplateMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	startDate: GraphQLTypes["Date"],
	period?: number | undefined,
	slots?: number | undefined,
	position?: GraphQLTypes["TimetableShiftPosition"] | undefined,
	staffOptions: Array<GraphQLTypes["TimetableTemplateStaffOptions"]>,
	internalName?: string | undefined,
	venue?: GraphQLTypes["Venue"] | undefined,
	employeeRole?: GraphQLTypes["TimetableEmployeeRole"] | undefined,
	workdaysOnly?: boolean | undefined,
	monday: boolean,
	tuesday: boolean,
	wednesday: boolean,
	thursday: boolean,
	friday: boolean,
	saturday: boolean,
	sunday: boolean,
	type: GraphQLTypes["TemplateType"],
	paginateStaffOptions: GraphQLTypes["TimetableTemplateStaffOptionsConnection"]
};
	["TimetableTemplateMeta"]: {
	__typename: "TimetableTemplateMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	startDate?: GraphQLTypes["FieldMeta"] | undefined,
	period?: GraphQLTypes["FieldMeta"] | undefined,
	slots?: GraphQLTypes["FieldMeta"] | undefined,
	position?: GraphQLTypes["FieldMeta"] | undefined,
	staffOptions?: GraphQLTypes["FieldMeta"] | undefined,
	internalName?: GraphQLTypes["FieldMeta"] | undefined,
	venue?: GraphQLTypes["FieldMeta"] | undefined,
	employeeRole?: GraphQLTypes["FieldMeta"] | undefined,
	workdaysOnly?: GraphQLTypes["FieldMeta"] | undefined,
	monday?: GraphQLTypes["FieldMeta"] | undefined,
	tuesday?: GraphQLTypes["FieldMeta"] | undefined,
	wednesday?: GraphQLTypes["FieldMeta"] | undefined,
	thursday?: GraphQLTypes["FieldMeta"] | undefined,
	friday?: GraphQLTypes["FieldMeta"] | undefined,
	saturday?: GraphQLTypes["FieldMeta"] | undefined,
	sunday?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined
};
	["TimetableShiftPosition"]: {
	__typename: "TimetableShiftPosition",
	_meta?: GraphQLTypes["TimetableShiftPositionMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name?: string | undefined,
	start?: string | undefined,
	end?: string | undefined,
	shiftGroups: Array<GraphQLTypes["TimetableShiftGroup"]>,
	timetableTemplates: Array<GraphQLTypes["TimetableTemplate"]>,
	isDynamic: boolean,
	shiftGroupsByShifts?: GraphQLTypes["TimetableShiftGroup"] | undefined,
	shiftGroupsByQueue?: GraphQLTypes["TimetableShiftGroup"] | undefined,
	timetableTemplatesByStaffOptions?: GraphQLTypes["TimetableTemplate"] | undefined,
	paginateShiftGroups: GraphQLTypes["TimetableShiftGroupConnection"],
	paginateTimetableTemplates: GraphQLTypes["TimetableTemplateConnection"]
};
	["TimetableShiftPositionMeta"]: {
	__typename: "TimetableShiftPositionMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	start?: GraphQLTypes["FieldMeta"] | undefined,
	end?: GraphQLTypes["FieldMeta"] | undefined,
	shiftGroups?: GraphQLTypes["FieldMeta"] | undefined,
	timetableTemplates?: GraphQLTypes["FieldMeta"] | undefined,
	isDynamic?: GraphQLTypes["FieldMeta"] | undefined
};
	["TimetableShiftPositionShiftGroupsByShiftsUniqueWhere"]: {
		shifts?: GraphQLTypes["TimetableShiftUniqueWhere"] | undefined
};
	["TimetableShiftPositionShiftGroupsByQueueUniqueWhere"]: {
		queue?: GraphQLTypes["EmployeeQueueUniqueWhere"] | undefined
};
	["TimetableShiftPositionTimetableTemplatesByStaffOptionsUniqueWhere"]: {
		staffOptions?: GraphQLTypes["TimetableTemplateStaffOptionsUniqueWhere"] | undefined
};
	["TimetableTemplateStaffOptionsUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["TimetableShiftGroupConnection"]: {
	__typename: "TimetableShiftGroupConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TimetableShiftGroupEdge"]>
};
	["TimetableShiftGroupEdge"]: {
	__typename: "TimetableShiftGroupEdge",
	node: GraphQLTypes["TimetableShiftGroup"]
};
	["TimetableTemplateConnection"]: {
	__typename: "TimetableTemplateConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TimetableTemplateEdge"]>
};
	["TimetableTemplateEdge"]: {
	__typename: "TimetableTemplateEdge",
	node: GraphQLTypes["TimetableTemplate"]
};
	["TimetableTemplateStaffOptions"]: {
	__typename: "TimetableTemplateStaffOptions",
	_meta?: GraphQLTypes["TimetableTemplateStaffOptionsMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	startTime: string,
	endTime: string,
	timetableTemplate?: GraphQLTypes["TimetableTemplate"] | undefined,
	autoAssignedEmployee?: GraphQLTypes["ShiftsProfile"] | undefined
};
	["TimetableTemplateStaffOptionsMeta"]: {
	__typename: "TimetableTemplateStaffOptionsMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	startTime?: GraphQLTypes["FieldMeta"] | undefined,
	endTime?: GraphQLTypes["FieldMeta"] | undefined,
	timetableTemplate?: GraphQLTypes["FieldMeta"] | undefined,
	autoAssignedEmployee?: GraphQLTypes["FieldMeta"] | undefined
};
	["TimetableTemplateStaffOptionsOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	startTime?: GraphQLTypes["OrderDirection"] | undefined,
	endTime?: GraphQLTypes["OrderDirection"] | undefined,
	timetableTemplate?: GraphQLTypes["TimetableTemplateOrderBy"] | undefined,
	autoAssignedEmployee?: GraphQLTypes["ShiftsProfileOrderBy"] | undefined
};
	["TimetableTemplateStaffOptionsConnection"]: {
	__typename: "TimetableTemplateStaffOptionsConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TimetableTemplateStaffOptionsEdge"]>
};
	["TimetableTemplateStaffOptionsEdge"]: {
	__typename: "TimetableTemplateStaffOptionsEdge",
	node: GraphQLTypes["TimetableTemplateStaffOptions"]
};
	["TimetableEmployeeRoleShiftGroupsByShiftsUniqueWhere"]: {
		shifts?: GraphQLTypes["TimetableShiftUniqueWhere"] | undefined
};
	["TimetableEmployeeRoleShiftGroupsByQueueUniqueWhere"]: {
		queue?: GraphQLTypes["EmployeeQueueUniqueWhere"] | undefined
};
	["TimetableEmployeeRoleTimetableTemplatesByStaffOptionsUniqueWhere"]: {
		staffOptions?: GraphQLTypes["TimetableTemplateStaffOptionsUniqueWhere"] | undefined
};
	["ShiftsProfileConnection"]: {
	__typename: "ShiftsProfileConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ShiftsProfileEdge"]>
};
	["ShiftsProfileEdge"]: {
	__typename: "ShiftsProfileEdge",
	node: GraphQLTypes["ShiftsProfile"]
};
	["ShiftsManagerConnection"]: {
	__typename: "ShiftsManagerConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ShiftsManagerEdge"]>
};
	["ShiftsManagerEdge"]: {
	__typename: "ShiftsManagerEdge",
	node: GraphQLTypes["ShiftsManager"]
};
	["ShiftsProfileQueueItemsByQueueUniqueWhere"]: {
		queue?: GraphQLTypes["EmployeeQueueUniqueWhere"] | undefined
};
	["ShiftsProfileQueueItemsByShiftUniqueWhere"]: {
		shift?: GraphQLTypes["TimetableShiftUniqueWhere"] | undefined
};
	["ShiftsProfileQueueItemsByUnassignInfoUniqueWhere"]: {
		unassignInfo?: GraphQLTypes["UnassignedShiftInfoUniqueWhere"] | undefined
};
	["ShiftsProfileQueueItemsByMetaUniqueWhere"]: {
		meta?: GraphQLTypes["EmployeeQueueItemMetadataUniqueWhere"] | undefined
};
	["ShiftsProfileShiftsByQueueItemUniqueWhere"]: {
		queueItem?: GraphQLTypes["EmployeeQueueItemUniqueWhere"] | undefined
};
	["ShiftsProfileShiftsBySwapInfoUniqueWhere"]: {
		swapInfo?: GraphQLTypes["TimetableShiftSwapInfoUniqueWhere"] | undefined
};
	["TimetableShiftConnection"]: {
	__typename: "TimetableShiftConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TimetableShiftEdge"]>
};
	["TimetableShiftEdge"]: {
	__typename: "TimetableShiftEdge",
	node: GraphQLTypes["TimetableShift"]
};
	["TimetableShiftSwapInfo"]: {
	__typename: "TimetableShiftSwapInfo",
	_meta?: GraphQLTypes["TimetableShiftSwapInfoMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	assigned?: GraphQLTypes["Date"] | undefined,
	requested?: boolean | undefined,
	confirmed?: boolean | undefined,
	swappedShiftsProfile?: GraphQLTypes["ShiftsProfile"] | undefined,
	shift?: GraphQLTypes["TimetableShift"] | undefined
};
	["TimetableShiftSwapInfoMeta"]: {
	__typename: "TimetableShiftSwapInfoMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	assigned?: GraphQLTypes["FieldMeta"] | undefined,
	requested?: GraphQLTypes["FieldMeta"] | undefined,
	confirmed?: GraphQLTypes["FieldMeta"] | undefined,
	swappedShiftsProfile?: GraphQLTypes["FieldMeta"] | undefined,
	shift?: GraphQLTypes["FieldMeta"] | undefined
};
	["TimetableShiftGroupShiftsByQueueItemUniqueWhere"]: {
		queueItem?: GraphQLTypes["EmployeeQueueItemUniqueWhere"] | undefined
};
	["TimetableShiftGroupShiftsBySwapInfoUniqueWhere"]: {
		swapInfo?: GraphQLTypes["TimetableShiftSwapInfoUniqueWhere"] | undefined
};
	["TimetableDayNote"]: {
	__typename: "TimetableDayNote",
	_meta?: GraphQLTypes["TimetableDayNoteMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	note: string,
	day?: GraphQLTypes["TimetableDay"] | undefined,
	role?: GraphQLTypes["TimetableEmployeeRole"] | undefined
};
	["TimetableDayNoteMeta"]: {
	__typename: "TimetableDayNoteMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	note?: GraphQLTypes["FieldMeta"] | undefined,
	day?: GraphQLTypes["FieldMeta"] | undefined,
	role?: GraphQLTypes["FieldMeta"] | undefined
};
	["TimetableDayNoteOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	note?: GraphQLTypes["OrderDirection"] | undefined,
	day?: GraphQLTypes["TimetableDayOrderBy"] | undefined,
	role?: GraphQLTypes["TimetableEmployeeRoleOrderBy"] | undefined
};
	["TimetableDayMetadata"]: {
	__typename: "TimetableDayMetadata",
	_meta?: GraphQLTypes["TimetableDayMetadataMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	numberOfWorkers: number,
	tipsTotalCents: number,
	totalMinutes: number,
	tipsCentsPerMinute: number,
	day?: GraphQLTypes["TimetableDay"] | undefined
};
	["TimetableDayMetadataMeta"]: {
	__typename: "TimetableDayMetadataMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	numberOfWorkers?: GraphQLTypes["FieldMeta"] | undefined,
	tipsTotalCents?: GraphQLTypes["FieldMeta"] | undefined,
	totalMinutes?: GraphQLTypes["FieldMeta"] | undefined,
	tipsCentsPerMinute?: GraphQLTypes["FieldMeta"] | undefined,
	day?: GraphQLTypes["FieldMeta"] | undefined
};
	["TimetableDayShiftGroupsByShiftsUniqueWhere"]: {
		shifts?: GraphQLTypes["TimetableShiftUniqueWhere"] | undefined
};
	["TimetableDayShiftGroupsByQueueUniqueWhere"]: {
		queue?: GraphQLTypes["EmployeeQueueUniqueWhere"] | undefined
};
	["TimetableDayNoteConnection"]: {
	__typename: "TimetableDayNoteConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TimetableDayNoteEdge"]>
};
	["TimetableDayNoteEdge"]: {
	__typename: "TimetableDayNoteEdge",
	node: GraphQLTypes["TimetableDayNote"]
};
	["VenueEmployeeRole"]: {
	__typename: "VenueEmployeeRole",
	_meta?: GraphQLTypes["VenueEmployeeRoleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	employeePrivileges?: GraphQLTypes["TimetablesEmployeePrivileges"] | undefined,
	venue?: GraphQLTypes["Venue"] | undefined,
	role?: GraphQLTypes["TimetableEmployeeRole"] | undefined,
	getsTipsShare: boolean,
	notesEnabled: boolean
};
	["VenueEmployeeRoleMeta"]: {
	__typename: "VenueEmployeeRoleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	employeePrivileges?: GraphQLTypes["FieldMeta"] | undefined,
	venue?: GraphQLTypes["FieldMeta"] | undefined,
	role?: GraphQLTypes["FieldMeta"] | undefined,
	getsTipsShare?: GraphQLTypes["FieldMeta"] | undefined,
	notesEnabled?: GraphQLTypes["FieldMeta"] | undefined
};
	["TimetablesEmployeePrivileges"]: {
	__typename: "TimetablesEmployeePrivileges",
	_meta?: GraphQLTypes["TimetablesEmployeePrivilegesMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	venueEmployeeRole?: GraphQLTypes["VenueEmployeeRole"] | undefined,
	read: boolean,
	unassign: boolean,
	assign: boolean
};
	["TimetablesEmployeePrivilegesMeta"]: {
	__typename: "TimetablesEmployeePrivilegesMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	venueEmployeeRole?: GraphQLTypes["FieldMeta"] | undefined,
	read?: GraphQLTypes["FieldMeta"] | undefined,
	unassign?: GraphQLTypes["FieldMeta"] | undefined,
	assign?: GraphQLTypes["FieldMeta"] | undefined
};
	["VenueEmployeeRoleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	employeePrivileges?: GraphQLTypes["TimetablesEmployeePrivilegesOrderBy"] | undefined,
	venue?: GraphQLTypes["VenueOrderBy"] | undefined,
	role?: GraphQLTypes["TimetableEmployeeRoleOrderBy"] | undefined,
	getsTipsShare?: GraphQLTypes["OrderDirection"] | undefined,
	notesEnabled?: GraphQLTypes["OrderDirection"] | undefined
};
	["TimetablesEmployeePrivilegesOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	venueEmployeeRole?: GraphQLTypes["VenueEmployeeRoleOrderBy"] | undefined,
	read?: GraphQLTypes["OrderDirection"] | undefined,
	unassign?: GraphQLTypes["OrderDirection"] | undefined,
	assign?: GraphQLTypes["OrderDirection"] | undefined
};
	["PointOfSaleApplicationDevice"]: {
	__typename: "PointOfSaleApplicationDevice",
	_meta?: GraphQLTypes["PointOfSaleApplicationDeviceMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	internalName?: string | undefined,
	note?: string | undefined,
	venue?: GraphQLTypes["Venue"] | undefined,
	identificationCode?: GraphQLTypes["IdentificationCode"] | undefined,
	identifier?: GraphQLTypes["DeviceIdentifier"] | undefined,
	terminal?: GraphQLTypes["PointOfSaleTerminal"] | undefined,
	receiptPrinter?: GraphQLTypes["PointOfSalePrinter"] | undefined,
	ticketPrinters: Array<GraphQLTypes["PointOfSalePrinter"]>,
	paginateTicketPrinters: GraphQLTypes["PointOfSalePrinterConnection"]
};
	["PointOfSaleApplicationDeviceMeta"]: {
	__typename: "PointOfSaleApplicationDeviceMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	internalName?: GraphQLTypes["FieldMeta"] | undefined,
	note?: GraphQLTypes["FieldMeta"] | undefined,
	venue?: GraphQLTypes["FieldMeta"] | undefined,
	identificationCode?: GraphQLTypes["FieldMeta"] | undefined,
	identifier?: GraphQLTypes["FieldMeta"] | undefined,
	terminal?: GraphQLTypes["FieldMeta"] | undefined,
	receiptPrinter?: GraphQLTypes["FieldMeta"] | undefined,
	ticketPrinters?: GraphQLTypes["FieldMeta"] | undefined
};
	["IdentificationCode"]: {
	__typename: "IdentificationCode",
	_meta?: GraphQLTypes["IdentificationCodeMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	code: string,
	createdAt: GraphQLTypes["DateTime"],
	attempts: Array<GraphQLTypes["IdentificationAttempt"]>,
	locales: Array<GraphQLTypes["IdentificationCodeLocale"]>,
	internalName?: string | undefined,
	applicationDevices: Array<GraphQLTypes["PointOfSaleApplicationDevice"]>,
	localesByLocale?: GraphQLTypes["IdentificationCodeLocale"] | undefined,
	applicationDevicesByIdentifier?: GraphQLTypes["PointOfSaleApplicationDevice"] | undefined,
	paginateAttempts: GraphQLTypes["IdentificationAttemptConnection"],
	paginateLocales: GraphQLTypes["IdentificationCodeLocaleConnection"],
	paginateApplicationDevices: GraphQLTypes["PointOfSaleApplicationDeviceConnection"]
};
	["IdentificationCodeMeta"]: {
	__typename: "IdentificationCodeMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	code?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	attempts?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	internalName?: GraphQLTypes["FieldMeta"] | undefined,
	applicationDevices?: GraphQLTypes["FieldMeta"] | undefined
};
	["IdentificationAttempt"]: {
	__typename: "IdentificationAttempt",
	_meta?: GraphQLTypes["IdentificationAttemptMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt: GraphQLTypes["DateTime"],
	code?: GraphQLTypes["IdentificationCode"] | undefined,
	user?: GraphQLTypes["User"] | undefined
};
	["IdentificationAttemptMeta"]: {
	__typename: "IdentificationAttemptMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	code?: GraphQLTypes["FieldMeta"] | undefined,
	user?: GraphQLTypes["FieldMeta"] | undefined
};
	["User"]: {
	__typename: "User",
	_meta?: GraphQLTypes["UserMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name?: string | undefined,
	internalNote?: string | undefined,
	staff?: GraphQLTypes["Staff"] | undefined,
	customer?: GraphQLTypes["Customer"] | undefined,
	tenantPersonId: GraphQLTypes["UUID"],
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	devices: Array<GraphQLTypes["UserDevice"]>,
	verifiedAt?: GraphQLTypes["DateTime"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	deletionRequestedAt?: GraphQLTypes["DateTime"] | undefined,
	deletionExpectedAt?: GraphQLTypes["DateTime"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	meta?: GraphQLTypes["UserMetadata"] | undefined,
	identificationAttempts: Array<GraphQLTypes["IdentificationAttempt"]>,
	roles?: GraphQLTypes["UserRoles"] | undefined,
	devicesByDeviceId?: GraphQLTypes["UserDevice"] | undefined,
	paginateDevices: GraphQLTypes["UserDeviceConnection"],
	paginateIdentificationAttempts: GraphQLTypes["IdentificationAttemptConnection"]
};
	["UserMeta"]: {
	__typename: "UserMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	staff?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined,
	tenantPersonId?: GraphQLTypes["FieldMeta"] | undefined,
	disabledAt?: GraphQLTypes["FieldMeta"] | undefined,
	devices?: GraphQLTypes["FieldMeta"] | undefined,
	verifiedAt?: GraphQLTypes["FieldMeta"] | undefined,
	email?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	deletionRequestedAt?: GraphQLTypes["FieldMeta"] | undefined,
	deletionExpectedAt?: GraphQLTypes["FieldMeta"] | undefined,
	deletedAt?: GraphQLTypes["FieldMeta"] | undefined,
	meta?: GraphQLTypes["FieldMeta"] | undefined,
	identificationAttempts?: GraphQLTypes["FieldMeta"] | undefined,
	roles?: GraphQLTypes["FieldMeta"] | undefined
};
	["UserDevice"]: {
	__typename: "UserDevice",
	_meta?: GraphQLTypes["UserDeviceMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt: GraphQLTypes["DateTime"],
	lastActiveAt: GraphQLTypes["DateTime"],
	platform?: string | undefined,
	deviceId?: string | undefined,
	notificationsEnabled: boolean,
	user?: GraphQLTypes["User"] | undefined,
	appVersion?: string | undefined,
	osVersion?: string | undefined,
	apiVersion?: string | undefined,
	anonymousSession?: GraphQLTypes["AnonymousSession"] | undefined
};
	["UserDeviceMeta"]: {
	__typename: "UserDeviceMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	lastActiveAt?: GraphQLTypes["FieldMeta"] | undefined,
	platform?: GraphQLTypes["FieldMeta"] | undefined,
	deviceId?: GraphQLTypes["FieldMeta"] | undefined,
	notificationsEnabled?: GraphQLTypes["FieldMeta"] | undefined,
	user?: GraphQLTypes["FieldMeta"] | undefined,
	appVersion?: GraphQLTypes["FieldMeta"] | undefined,
	osVersion?: GraphQLTypes["FieldMeta"] | undefined,
	apiVersion?: GraphQLTypes["FieldMeta"] | undefined,
	anonymousSession?: GraphQLTypes["FieldMeta"] | undefined
};
	["AnonymousSession"]: {
	__typename: "AnonymousSession",
	_meta?: GraphQLTypes["AnonymousSessionMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	lastActiveAt?: GraphQLTypes["DateTime"] | undefined,
	anonymousSessionKey: string,
	email?: string | undefined,
	name?: string | undefined,
	internalNote?: string | undefined,
	customer?: GraphQLTypes["Customer"] | undefined,
	devices: Array<GraphQLTypes["UserDevice"]>,
	devicesByDeviceId?: GraphQLTypes["UserDevice"] | undefined,
	paginateDevices: GraphQLTypes["UserDeviceConnection"]
};
	["AnonymousSessionMeta"]: {
	__typename: "AnonymousSessionMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	lastActiveAt?: GraphQLTypes["FieldMeta"] | undefined,
	anonymousSessionKey?: GraphQLTypes["FieldMeta"] | undefined,
	email?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined,
	devices?: GraphQLTypes["FieldMeta"] | undefined
};
	["UserDeviceOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	lastActiveAt?: GraphQLTypes["OrderDirection"] | undefined,
	platform?: GraphQLTypes["OrderDirection"] | undefined,
	deviceId?: GraphQLTypes["OrderDirection"] | undefined,
	notificationsEnabled?: GraphQLTypes["OrderDirection"] | undefined,
	user?: GraphQLTypes["UserOrderBy"] | undefined,
	appVersion?: GraphQLTypes["OrderDirection"] | undefined,
	osVersion?: GraphQLTypes["OrderDirection"] | undefined,
	apiVersion?: GraphQLTypes["OrderDirection"] | undefined,
	anonymousSession?: GraphQLTypes["AnonymousSessionOrderBy"] | undefined
};
	["AnonymousSessionDevicesByDeviceIdUniqueWhere"]: {
		deviceId?: string | undefined
};
	["UserDeviceConnection"]: {
	__typename: "UserDeviceConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["UserDeviceEdge"]>
};
	["UserDeviceEdge"]: {
	__typename: "UserDeviceEdge",
	node: GraphQLTypes["UserDevice"]
};
	["UserMetadata"]: {
	__typename: "UserMetadata",
	_meta?: GraphQLTypes["UserMetadataMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	userProfileUrl: string,
	tenantEmail?: string | undefined,
	tenantPersonId?: GraphQLTypes["UUID"] | undefined,
	tenantIdentityId?: GraphQLTypes["UUID"] | undefined,
	globalRoles?: GraphQLTypes["Json"] | undefined,
	projectRoles?: GraphQLTypes["Json"] | undefined,
	projectRolesString?: string | undefined,
	externalIdentifiers?: GraphQLTypes["Json"] | undefined,
	externalIdentifiersString?: string | undefined,
	idpSlugs?: GraphQLTypes["Json"] | undefined,
	idpSlugsString?: string | undefined,
	user?: GraphQLTypes["User"] | undefined
};
	["UserMetadataMeta"]: {
	__typename: "UserMetadataMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	userProfileUrl?: GraphQLTypes["FieldMeta"] | undefined,
	tenantEmail?: GraphQLTypes["FieldMeta"] | undefined,
	tenantPersonId?: GraphQLTypes["FieldMeta"] | undefined,
	tenantIdentityId?: GraphQLTypes["FieldMeta"] | undefined,
	globalRoles?: GraphQLTypes["FieldMeta"] | undefined,
	projectRoles?: GraphQLTypes["FieldMeta"] | undefined,
	projectRolesString?: GraphQLTypes["FieldMeta"] | undefined,
	externalIdentifiers?: GraphQLTypes["FieldMeta"] | undefined,
	externalIdentifiersString?: GraphQLTypes["FieldMeta"] | undefined,
	idpSlugs?: GraphQLTypes["FieldMeta"] | undefined,
	idpSlugsString?: GraphQLTypes["FieldMeta"] | undefined,
	user?: GraphQLTypes["FieldMeta"] | undefined
};
	["IdentificationAttemptOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	code?: GraphQLTypes["IdentificationCodeOrderBy"] | undefined,
	user?: GraphQLTypes["UserOrderBy"] | undefined
};
	["IdentificationCodeOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	code?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	internalName?: GraphQLTypes["OrderDirection"] | undefined
};
	["UserRoles"]: {
	__typename: "UserRoles",
	_meta?: GraphQLTypes["UserRolesMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	isCustomer: boolean,
	isStaff: boolean,
	isBartender: boolean,
	isCashier: boolean,
	isCourier: boolean,
	isCleaner: boolean,
	isShiftsManager: boolean,
	isInternalBuyer: boolean,
	isStocksManager: boolean,
	isCourierManager: boolean,
	isCashierManager: boolean,
	isBusinessToBusinessManager: boolean,
	isPicker: boolean,
	user?: GraphQLTypes["User"] | undefined
};
	["UserRolesMeta"]: {
	__typename: "UserRolesMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	isCustomer?: GraphQLTypes["FieldMeta"] | undefined,
	isStaff?: GraphQLTypes["FieldMeta"] | undefined,
	isBartender?: GraphQLTypes["FieldMeta"] | undefined,
	isCashier?: GraphQLTypes["FieldMeta"] | undefined,
	isCourier?: GraphQLTypes["FieldMeta"] | undefined,
	isCleaner?: GraphQLTypes["FieldMeta"] | undefined,
	isShiftsManager?: GraphQLTypes["FieldMeta"] | undefined,
	isInternalBuyer?: GraphQLTypes["FieldMeta"] | undefined,
	isStocksManager?: GraphQLTypes["FieldMeta"] | undefined,
	isCourierManager?: GraphQLTypes["FieldMeta"] | undefined,
	isCashierManager?: GraphQLTypes["FieldMeta"] | undefined,
	isBusinessToBusinessManager?: GraphQLTypes["FieldMeta"] | undefined,
	isPicker?: GraphQLTypes["FieldMeta"] | undefined,
	user?: GraphQLTypes["FieldMeta"] | undefined
};
	["UserDevicesByDeviceIdUniqueWhere"]: {
		deviceId?: string | undefined
};
	["IdentificationAttemptConnection"]: {
	__typename: "IdentificationAttemptConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["IdentificationAttemptEdge"]>
};
	["IdentificationAttemptEdge"]: {
	__typename: "IdentificationAttemptEdge",
	node: GraphQLTypes["IdentificationAttempt"]
};
	["IdentificationCodeLocale"]: {
	__typename: "IdentificationCodeLocale",
	_meta?: GraphQLTypes["IdentificationCodeLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	successMessage?: string | undefined,
	root?: GraphQLTypes["IdentificationCode"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined
};
	["IdentificationCodeLocaleMeta"]: {
	__typename: "IdentificationCodeLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	successMessage?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined
};
	["IdentificationCodeLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	successMessage?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["IdentificationCodeOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined
};
	["PointOfSaleApplicationDeviceOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	internalName?: GraphQLTypes["OrderDirection"] | undefined,
	note?: GraphQLTypes["OrderDirection"] | undefined,
	venue?: GraphQLTypes["VenueOrderBy"] | undefined,
	identificationCode?: GraphQLTypes["IdentificationCodeOrderBy"] | undefined,
	identifier?: GraphQLTypes["DeviceIdentifierOrderBy"] | undefined,
	terminal?: GraphQLTypes["PointOfSaleTerminalOrderBy"] | undefined,
	receiptPrinter?: GraphQLTypes["PointOfSalePrinterOrderBy"] | undefined
};
	["DeviceIdentifierOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	internalName?: GraphQLTypes["OrderDirection"] | undefined,
	device?: GraphQLTypes["PointOfSaleApplicationDeviceOrderBy"] | undefined,
	updatedAt?: GraphQLTypes["OrderDirection"] | undefined,
	platform?: GraphQLTypes["OrderDirection"] | undefined,
	resolution?: GraphQLTypes["OrderDirection"] | undefined,
	devicePixelRatio?: GraphQLTypes["OrderDirection"] | undefined,
	updatedByUser?: GraphQLTypes["UserOrderBy"] | undefined,
	identifier?: GraphQLTypes["OrderDirection"] | undefined,
	meta?: GraphQLTypes["DeviceIdentifierMetadataOrderBy"] | undefined,
	applicationVersionIdentifier?: GraphQLTypes["OrderDirection"] | undefined,
	lastPointOfSaleSynchronizationErrorRawDetails?: GraphQLTypes["OrderDirection"] | undefined
};
	["DeviceIdentifierMetadataOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	prettyIdentifier?: GraphQLTypes["OrderDirection"] | undefined,
	deviceIdentifier?: GraphQLTypes["DeviceIdentifierOrderBy"] | undefined
};
	["PointOfSaleTerminalOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	internalName?: GraphQLTypes["OrderDirection"] | undefined,
	note?: GraphQLTypes["OrderDirection"] | undefined,
	venue?: GraphQLTypes["VenueOrderBy"] | undefined,
	ipAddress?: GraphQLTypes["OrderDirection"] | undefined,
	port?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined
};
	["PointOfSalePrinterOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	internalName?: GraphQLTypes["OrderDirection"] | undefined,
	note?: GraphQLTypes["OrderDirection"] | undefined,
	ipAddress?: GraphQLTypes["OrderDirection"] | undefined,
	venue?: GraphQLTypes["VenueOrderBy"] | undefined
};
	["IdentificationCodeLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["IdentificationCodeApplicationDevicesByIdentifierUniqueWhere"]: {
		identifier?: GraphQLTypes["DeviceIdentifierUniqueWhere"] | undefined
};
	["IdentificationCodeLocaleConnection"]: {
	__typename: "IdentificationCodeLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["IdentificationCodeLocaleEdge"]>
};
	["IdentificationCodeLocaleEdge"]: {
	__typename: "IdentificationCodeLocaleEdge",
	node: GraphQLTypes["IdentificationCodeLocale"]
};
	["PointOfSaleApplicationDeviceConnection"]: {
	__typename: "PointOfSaleApplicationDeviceConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PointOfSaleApplicationDeviceEdge"]>
};
	["PointOfSaleApplicationDeviceEdge"]: {
	__typename: "PointOfSaleApplicationDeviceEdge",
	node: GraphQLTypes["PointOfSaleApplicationDevice"]
};
	["DeviceIdentifier"]: {
	__typename: "DeviceIdentifier",
	_meta?: GraphQLTypes["DeviceIdentifierMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	internalName?: string | undefined,
	device?: GraphQLTypes["PointOfSaleApplicationDevice"] | undefined,
	updatedAt: GraphQLTypes["DateTime"],
	platform?: string | undefined,
	resolution?: string | undefined,
	devicePixelRatio?: number | undefined,
	updatedByUser?: GraphQLTypes["User"] | undefined,
	identifier: string,
	meta?: GraphQLTypes["DeviceIdentifierMetadata"] | undefined,
	applicationVersionIdentifier?: string | undefined,
	lastPointOfSaleSynchronizationErrorRawDetails?: string | undefined
};
	["DeviceIdentifierMeta"]: {
	__typename: "DeviceIdentifierMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	internalName?: GraphQLTypes["FieldMeta"] | undefined,
	device?: GraphQLTypes["FieldMeta"] | undefined,
	updatedAt?: GraphQLTypes["FieldMeta"] | undefined,
	platform?: GraphQLTypes["FieldMeta"] | undefined,
	resolution?: GraphQLTypes["FieldMeta"] | undefined,
	devicePixelRatio?: GraphQLTypes["FieldMeta"] | undefined,
	updatedByUser?: GraphQLTypes["FieldMeta"] | undefined,
	identifier?: GraphQLTypes["FieldMeta"] | undefined,
	meta?: GraphQLTypes["FieldMeta"] | undefined,
	applicationVersionIdentifier?: GraphQLTypes["FieldMeta"] | undefined,
	lastPointOfSaleSynchronizationErrorRawDetails?: GraphQLTypes["FieldMeta"] | undefined
};
	["DeviceIdentifierMetadata"]: {
	__typename: "DeviceIdentifierMetadata",
	_meta?: GraphQLTypes["DeviceIdentifierMetadataMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	prettyIdentifier: string,
	deviceIdentifier?: GraphQLTypes["DeviceIdentifier"] | undefined
};
	["DeviceIdentifierMetadataMeta"]: {
	__typename: "DeviceIdentifierMetadataMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	prettyIdentifier?: GraphQLTypes["FieldMeta"] | undefined,
	deviceIdentifier?: GraphQLTypes["FieldMeta"] | undefined
};
	["PointOfSaleTerminal"]: {
	__typename: "PointOfSaleTerminal",
	_meta?: GraphQLTypes["PointOfSaleTerminalMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	internalName?: string | undefined,
	note?: string | undefined,
	venue?: GraphQLTypes["Venue"] | undefined,
	applicationDevices: Array<GraphQLTypes["PointOfSaleApplicationDevice"]>,
	ipAddress?: string | undefined,
	port?: number | undefined,
	type: GraphQLTypes["PointOfSaleTerminalType"],
	applicationDevicesByIdentifier?: GraphQLTypes["PointOfSaleApplicationDevice"] | undefined,
	paginateApplicationDevices: GraphQLTypes["PointOfSaleApplicationDeviceConnection"]
};
	["PointOfSaleTerminalMeta"]: {
	__typename: "PointOfSaleTerminalMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	internalName?: GraphQLTypes["FieldMeta"] | undefined,
	note?: GraphQLTypes["FieldMeta"] | undefined,
	venue?: GraphQLTypes["FieldMeta"] | undefined,
	applicationDevices?: GraphQLTypes["FieldMeta"] | undefined,
	ipAddress?: GraphQLTypes["FieldMeta"] | undefined,
	port?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined
};
	["PointOfSaleTerminalApplicationDevicesByIdentifierUniqueWhere"]: {
		identifier?: GraphQLTypes["DeviceIdentifierUniqueWhere"] | undefined
};
	["PointOfSalePrinter"]: {
	__typename: "PointOfSalePrinter",
	_meta?: GraphQLTypes["PointOfSalePrinterMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	internalName?: string | undefined,
	note?: string | undefined,
	ipAddress: string,
	applicationDevicesReceipt: Array<GraphQLTypes["PointOfSaleApplicationDevice"]>,
	applicationDevicesTicket: Array<GraphQLTypes["PointOfSaleApplicationDevice"]>,
	venue?: GraphQLTypes["Venue"] | undefined,
	ticketCategories: Array<GraphQLTypes["PointOfSaleCategory"]>,
	applicationDevicesReceiptByIdentifier?: GraphQLTypes["PointOfSaleApplicationDevice"] | undefined,
	paginateApplicationDevicesReceipt: GraphQLTypes["PointOfSaleApplicationDeviceConnection"],
	paginateApplicationDevicesTicket: GraphQLTypes["PointOfSaleApplicationDeviceConnection"],
	paginateTicketCategories: GraphQLTypes["PointOfSaleCategoryConnection"]
};
	["PointOfSalePrinterMeta"]: {
	__typename: "PointOfSalePrinterMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	internalName?: GraphQLTypes["FieldMeta"] | undefined,
	note?: GraphQLTypes["FieldMeta"] | undefined,
	ipAddress?: GraphQLTypes["FieldMeta"] | undefined,
	applicationDevicesReceipt?: GraphQLTypes["FieldMeta"] | undefined,
	applicationDevicesTicket?: GraphQLTypes["FieldMeta"] | undefined,
	venue?: GraphQLTypes["FieldMeta"] | undefined,
	ticketCategories?: GraphQLTypes["FieldMeta"] | undefined
};
	["PointOfSaleCategory"]: {
	__typename: "PointOfSaleCategory",
	_meta?: GraphQLTypes["PointOfSaleCategoryMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	slug: string,
	locales: Array<GraphQLTypes["PointOfSaleCategoryLocale"]>,
	products: Array<GraphQLTypes["PointOfSaleCategoryProduct"]>,
	category?: GraphQLTypes["ProductCategory"] | undefined,
	venue?: GraphQLTypes["Venue"] | undefined,
	ticketPrinters: Array<GraphQLTypes["PointOfSalePrinter"]>,
	localesByLocale?: GraphQLTypes["PointOfSaleCategoryLocale"] | undefined,
	productsByLocales?: GraphQLTypes["PointOfSaleCategoryProduct"] | undefined,
	paginateLocales: GraphQLTypes["PointOfSaleCategoryLocaleConnection"],
	paginateProducts: GraphQLTypes["PointOfSaleCategoryProductConnection"],
	paginateTicketPrinters: GraphQLTypes["PointOfSalePrinterConnection"]
};
	["PointOfSaleCategoryMeta"]: {
	__typename: "PointOfSaleCategoryMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	slug?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	products?: GraphQLTypes["FieldMeta"] | undefined,
	category?: GraphQLTypes["FieldMeta"] | undefined,
	venue?: GraphQLTypes["FieldMeta"] | undefined,
	ticketPrinters?: GraphQLTypes["FieldMeta"] | undefined
};
	["PointOfSaleCategoryLocale"]: {
	__typename: "PointOfSaleCategoryLocale",
	_meta?: GraphQLTypes["PointOfSaleCategoryLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	title: string,
	root?: GraphQLTypes["PointOfSaleCategory"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined
};
	["PointOfSaleCategoryLocaleMeta"]: {
	__typename: "PointOfSaleCategoryLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined
};
	["PointOfSaleCategoryLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["PointOfSaleCategoryOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined
};
	["PointOfSaleCategoryOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	slug?: GraphQLTypes["OrderDirection"] | undefined,
	category?: GraphQLTypes["ProductCategoryOrderBy"] | undefined,
	venue?: GraphQLTypes["VenueOrderBy"] | undefined
};
	["ProductCategoryOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	code?: GraphQLTypes["OrderDirection"] | undefined,
	parent?: GraphQLTypes["ProductCategoryOrderBy"] | undefined,
	description?: GraphQLTypes["OrderDirection"] | undefined,
	internalNote?: GraphQLTypes["OrderDirection"] | undefined,
	color?: GraphQLTypes["OrderDirection"] | undefined,
	image?: GraphQLTypes["ImageOrderBy"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined
};
	["PointOfSaleCategoryProduct"]: {
	__typename: "PointOfSaleCategoryProduct",
	_meta?: GraphQLTypes["PointOfSaleCategoryProductMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	category?: GraphQLTypes["PointOfSaleCategory"] | undefined,
	product?: GraphQLTypes["Product"] | undefined,
	locales: Array<GraphQLTypes["PointOfSaleCategoryProductLocale"]>,
	localesByLocale?: GraphQLTypes["PointOfSaleCategoryProductLocale"] | undefined,
	paginateLocales: GraphQLTypes["PointOfSaleCategoryProductLocaleConnection"]
};
	["PointOfSaleCategoryProductMeta"]: {
	__typename: "PointOfSaleCategoryProductMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	category?: GraphQLTypes["FieldMeta"] | undefined,
	product?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined
};
	["PointOfSaleCategoryProductLocale"]: {
	__typename: "PointOfSaleCategoryProductLocale",
	_meta?: GraphQLTypes["PointOfSaleCategoryProductLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	title: string,
	root?: GraphQLTypes["PointOfSaleCategoryProduct"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined
};
	["PointOfSaleCategoryProductLocaleMeta"]: {
	__typename: "PointOfSaleCategoryProductLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined
};
	["PointOfSaleCategoryProductLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["PointOfSaleCategoryProductOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined
};
	["PointOfSaleCategoryProductOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	category?: GraphQLTypes["PointOfSaleCategoryOrderBy"] | undefined,
	product?: GraphQLTypes["ProductOrderBy"] | undefined
};
	["PointOfSaleCategoryProductLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["PointOfSaleCategoryProductLocaleConnection"]: {
	__typename: "PointOfSaleCategoryProductLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PointOfSaleCategoryProductLocaleEdge"]>
};
	["PointOfSaleCategoryProductLocaleEdge"]: {
	__typename: "PointOfSaleCategoryProductLocaleEdge",
	node: GraphQLTypes["PointOfSaleCategoryProductLocale"]
};
	["ProductCategory"]: {
	__typename: "ProductCategory",
	_meta?: GraphQLTypes["ProductCategoryMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	code?: string | undefined,
	products: Array<GraphQLTypes["Product"]>,
	tags: Array<GraphQLTypes["Tag"]>,
	parent?: GraphQLTypes["ProductCategory"] | undefined,
	children: Array<GraphQLTypes["ProductCategory"]>,
	description?: string | undefined,
	internalNote?: string | undefined,
	color?: string | undefined,
	image?: GraphQLTypes["Image"] | undefined,
	order: number,
	descendants: Array<GraphQLTypes["ProductCategoryTree"]>,
	ancestors: Array<GraphQLTypes["ProductCategoryTree"]>,
	inheritedTags: Array<GraphQLTypes["InheritedProductCategoryTag"]>,
	nestedProducts: Array<GraphQLTypes["NestedProductCategoryProduct"]>,
	childrenByCode?: GraphQLTypes["ProductCategory"] | undefined,
	childrenByChildren?: GraphQLTypes["ProductCategory"] | undefined,
	childrenByDescendants?: GraphQLTypes["ProductCategory"] | undefined,
	childrenByAncestors?: GraphQLTypes["ProductCategory"] | undefined,
	childrenByInheritedTags?: GraphQLTypes["ProductCategory"] | undefined,
	childrenByNestedProducts?: GraphQLTypes["ProductCategory"] | undefined,
	paginateProducts: GraphQLTypes["ProductConnection"],
	paginateTags: GraphQLTypes["TagConnection"],
	paginateChildren: GraphQLTypes["ProductCategoryConnection"],
	paginateDescendants: GraphQLTypes["ProductCategoryTreeConnection"],
	paginateAncestors: GraphQLTypes["ProductCategoryTreeConnection"],
	paginateInheritedTags: GraphQLTypes["InheritedProductCategoryTagConnection"],
	paginateNestedProducts: GraphQLTypes["NestedProductCategoryProductConnection"]
};
	["ProductCategoryMeta"]: {
	__typename: "ProductCategoryMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	code?: GraphQLTypes["FieldMeta"] | undefined,
	products?: GraphQLTypes["FieldMeta"] | undefined,
	tags?: GraphQLTypes["FieldMeta"] | undefined,
	parent?: GraphQLTypes["FieldMeta"] | undefined,
	children?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	color?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	descendants?: GraphQLTypes["FieldMeta"] | undefined,
	ancestors?: GraphQLTypes["FieldMeta"] | undefined,
	inheritedTags?: GraphQLTypes["FieldMeta"] | undefined,
	nestedProducts?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductCategoryTree"]: {
	__typename: "ProductCategoryTree",
	_meta?: GraphQLTypes["ProductCategoryTreeMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	depth: number,
	ancestor?: GraphQLTypes["ProductCategory"] | undefined,
	descendant?: GraphQLTypes["ProductCategory"] | undefined
};
	["ProductCategoryTreeMeta"]: {
	__typename: "ProductCategoryTreeMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	depth?: GraphQLTypes["FieldMeta"] | undefined,
	ancestor?: GraphQLTypes["FieldMeta"] | undefined,
	descendant?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductCategoryTreeOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	depth?: GraphQLTypes["OrderDirection"] | undefined,
	ancestor?: GraphQLTypes["ProductCategoryOrderBy"] | undefined,
	descendant?: GraphQLTypes["ProductCategoryOrderBy"] | undefined
};
	["InheritedProductCategoryTag"]: {
	__typename: "InheritedProductCategoryTag",
	_meta?: GraphQLTypes["InheritedProductCategoryTagMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	depth: number,
	productCategory?: GraphQLTypes["ProductCategory"] | undefined,
	tag?: GraphQLTypes["Tag"] | undefined
};
	["InheritedProductCategoryTagMeta"]: {
	__typename: "InheritedProductCategoryTagMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	depth?: GraphQLTypes["FieldMeta"] | undefined,
	productCategory?: GraphQLTypes["FieldMeta"] | undefined,
	tag?: GraphQLTypes["FieldMeta"] | undefined
};
	["InheritedProductCategoryTagOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	depth?: GraphQLTypes["OrderDirection"] | undefined,
	productCategory?: GraphQLTypes["ProductCategoryOrderBy"] | undefined,
	tag?: GraphQLTypes["TagOrderBy"] | undefined
};
	["NestedProductCategoryProduct"]: {
	__typename: "NestedProductCategoryProduct",
	_meta?: GraphQLTypes["NestedProductCategoryProductMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	depth: number,
	product?: GraphQLTypes["Product"] | undefined,
	productCategory?: GraphQLTypes["ProductCategory"] | undefined
};
	["NestedProductCategoryProductMeta"]: {
	__typename: "NestedProductCategoryProductMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	depth?: GraphQLTypes["FieldMeta"] | undefined,
	product?: GraphQLTypes["FieldMeta"] | undefined,
	productCategory?: GraphQLTypes["FieldMeta"] | undefined
};
	["NestedProductCategoryProductOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	depth?: GraphQLTypes["OrderDirection"] | undefined,
	product?: GraphQLTypes["ProductOrderBy"] | undefined,
	productCategory?: GraphQLTypes["ProductCategoryOrderBy"] | undefined
};
	["ProductCategoryChildrenByCodeUniqueWhere"]: {
		code?: string | undefined
};
	["ProductCategoryChildrenByChildrenUniqueWhere"]: {
		children?: GraphQLTypes["ProductCategoryUniqueWhere"] | undefined
};
	["ProductCategoryUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	children?: GraphQLTypes["ProductCategoryUniqueWhere"] | undefined,
	descendants?: GraphQLTypes["ProductCategoryTreeUniqueWhere"] | undefined,
	ancestors?: GraphQLTypes["ProductCategoryTreeUniqueWhere"] | undefined,
	inheritedTags?: GraphQLTypes["InheritedProductCategoryTagUniqueWhere"] | undefined,
	nestedProducts?: GraphQLTypes["NestedProductCategoryProductUniqueWhere"] | undefined
};
	["ProductCategoryTreeUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["InheritedProductCategoryTagUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["ProductCategoryChildrenByDescendantsUniqueWhere"]: {
		descendants?: GraphQLTypes["ProductCategoryTreeUniqueWhere"] | undefined
};
	["ProductCategoryChildrenByAncestorsUniqueWhere"]: {
		ancestors?: GraphQLTypes["ProductCategoryTreeUniqueWhere"] | undefined
};
	["ProductCategoryChildrenByInheritedTagsUniqueWhere"]: {
		inheritedTags?: GraphQLTypes["InheritedProductCategoryTagUniqueWhere"] | undefined
};
	["ProductCategoryChildrenByNestedProductsUniqueWhere"]: {
		nestedProducts?: GraphQLTypes["NestedProductCategoryProductUniqueWhere"] | undefined
};
	["ProductConnection"]: {
	__typename: "ProductConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductEdge"]>
};
	["ProductEdge"]: {
	__typename: "ProductEdge",
	node: GraphQLTypes["Product"]
};
	["ProductCategoryConnection"]: {
	__typename: "ProductCategoryConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductCategoryEdge"]>
};
	["ProductCategoryEdge"]: {
	__typename: "ProductCategoryEdge",
	node: GraphQLTypes["ProductCategory"]
};
	["ProductCategoryTreeConnection"]: {
	__typename: "ProductCategoryTreeConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductCategoryTreeEdge"]>
};
	["ProductCategoryTreeEdge"]: {
	__typename: "ProductCategoryTreeEdge",
	node: GraphQLTypes["ProductCategoryTree"]
};
	["InheritedProductCategoryTagConnection"]: {
	__typename: "InheritedProductCategoryTagConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["InheritedProductCategoryTagEdge"]>
};
	["InheritedProductCategoryTagEdge"]: {
	__typename: "InheritedProductCategoryTagEdge",
	node: GraphQLTypes["InheritedProductCategoryTag"]
};
	["NestedProductCategoryProductConnection"]: {
	__typename: "NestedProductCategoryProductConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["NestedProductCategoryProductEdge"]>
};
	["NestedProductCategoryProductEdge"]: {
	__typename: "NestedProductCategoryProductEdge",
	node: GraphQLTypes["NestedProductCategoryProduct"]
};
	["PointOfSaleCategoryLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["PointOfSaleCategoryProductsByLocalesUniqueWhere"]: {
		locales?: GraphQLTypes["PointOfSaleCategoryProductLocaleUniqueWhere"] | undefined
};
	["PointOfSaleCategoryLocaleConnection"]: {
	__typename: "PointOfSaleCategoryLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PointOfSaleCategoryLocaleEdge"]>
};
	["PointOfSaleCategoryLocaleEdge"]: {
	__typename: "PointOfSaleCategoryLocaleEdge",
	node: GraphQLTypes["PointOfSaleCategoryLocale"]
};
	["PointOfSaleCategoryProductConnection"]: {
	__typename: "PointOfSaleCategoryProductConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PointOfSaleCategoryProductEdge"]>
};
	["PointOfSaleCategoryProductEdge"]: {
	__typename: "PointOfSaleCategoryProductEdge",
	node: GraphQLTypes["PointOfSaleCategoryProduct"]
};
	["PointOfSalePrinterConnection"]: {
	__typename: "PointOfSalePrinterConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PointOfSalePrinterEdge"]>
};
	["PointOfSalePrinterEdge"]: {
	__typename: "PointOfSalePrinterEdge",
	node: GraphQLTypes["PointOfSalePrinter"]
};
	["PointOfSalePrinterApplicationDevicesReceiptByIdentifierUniqueWhere"]: {
		identifier?: GraphQLTypes["DeviceIdentifierUniqueWhere"] | undefined
};
	["PointOfSaleCategoryConnection"]: {
	__typename: "PointOfSaleCategoryConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PointOfSaleCategoryEdge"]>
};
	["PointOfSaleCategoryEdge"]: {
	__typename: "PointOfSaleCategoryEdge",
	node: GraphQLTypes["PointOfSaleCategory"]
};
	["Order"]: {
	__typename: "Order",
	_meta?: GraphQLTypes["OrderMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	state: GraphQLTypes["OrderState"],
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	canceledAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	customer?: GraphQLTypes["Customer"] | undefined,
	channel?: GraphQLTypes["Channel"] | undefined,
	discounts: Array<GraphQLTypes["OrderDiscount"]>,
	delivery?: GraphQLTypes["OrderDelivery"] | undefined,
	items: Array<GraphQLTypes["OrderItem"]>,
	internalNote?: string | undefined,
	cart?: GraphQLTypes["Cart"] | undefined,
	events: Array<GraphQLTypes["OrderEvent"]>,
	createdAt: GraphQLTypes["DateTime"],
	billingAddress?: GraphQLTypes["Address"] | undefined,
	priceLines: Array<GraphQLTypes["OrderPriceLine"]>,
	payments: Array<GraphQLTypes["OrderPayment"]>,
	seq: number,
	billingSubject?: GraphQLTypes["BillingSubject"] | undefined,
	summary?: GraphQLTypes["OrderSummary"] | undefined,
	doubleshotLegacyId?: string | undefined,
	gratuity?: GraphQLTypes["Gratuity"] | undefined,
	venue?: GraphQLTypes["Venue"] | undefined,
	fulfillmentNote?: string | undefined,
	fulfillmentNotes: Array<GraphQLTypes["FulfillmentNote"]>,
	doubleshotTotalWeightGrams?: number | undefined,
	doubleShotLegacyNumber?: string | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	doubleshotAdminUrl?: string | undefined,
	discountsByCustomerCreditTransactions?: GraphQLTypes["OrderDiscount"] | undefined,
	discountsByVoucherRedemption?: GraphQLTypes["OrderDiscount"] | undefined,
	itemsByVirtualProductEffects?: GraphQLTypes["OrderItem"] | undefined,
	priceLinesByOrderItem?: GraphQLTypes["OrderPriceLine"] | undefined,
	priceLinesByOrderDiscount?: GraphQLTypes["OrderPriceLine"] | undefined,
	priceLinesByOrderPayment?: GraphQLTypes["OrderPriceLine"] | undefined,
	priceLinesByOrderDelivery?: GraphQLTypes["OrderPriceLine"] | undefined,
	paymentsByEvents?: GraphQLTypes["OrderPayment"] | undefined,
	paymentsByMeta?: GraphQLTypes["OrderPayment"] | undefined,
	paginateDiscounts: GraphQLTypes["OrderDiscountConnection"],
	paginateItems: GraphQLTypes["OrderItemConnection"],
	paginateEvents: GraphQLTypes["OrderEventConnection"],
	paginatePriceLines: GraphQLTypes["OrderPriceLineConnection"],
	paginatePayments: GraphQLTypes["OrderPaymentConnection"],
	paginateFulfillmentNotes: GraphQLTypes["FulfillmentNoteConnection"]
};
	["OrderMeta"]: {
	__typename: "OrderMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	state?: GraphQLTypes["FieldMeta"] | undefined,
	fulfilledAt?: GraphQLTypes["FieldMeta"] | undefined,
	canceledAt?: GraphQLTypes["FieldMeta"] | undefined,
	note?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined,
	channel?: GraphQLTypes["FieldMeta"] | undefined,
	discounts?: GraphQLTypes["FieldMeta"] | undefined,
	delivery?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	cart?: GraphQLTypes["FieldMeta"] | undefined,
	events?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	billingAddress?: GraphQLTypes["FieldMeta"] | undefined,
	priceLines?: GraphQLTypes["FieldMeta"] | undefined,
	payments?: GraphQLTypes["FieldMeta"] | undefined,
	seq?: GraphQLTypes["FieldMeta"] | undefined,
	billingSubject?: GraphQLTypes["FieldMeta"] | undefined,
	summary?: GraphQLTypes["FieldMeta"] | undefined,
	doubleshotLegacyId?: GraphQLTypes["FieldMeta"] | undefined,
	gratuity?: GraphQLTypes["FieldMeta"] | undefined,
	venue?: GraphQLTypes["FieldMeta"] | undefined,
	fulfillmentNote?: GraphQLTypes["FieldMeta"] | undefined,
	fulfillmentNotes?: GraphQLTypes["FieldMeta"] | undefined,
	doubleshotTotalWeightGrams?: GraphQLTypes["FieldMeta"] | undefined,
	doubleShotLegacyNumber?: GraphQLTypes["FieldMeta"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["FieldMeta"] | undefined,
	doubleshotAdminUrl?: GraphQLTypes["FieldMeta"] | undefined
};
	["OrderDiscount"]: {
	__typename: "OrderDiscount",
	_meta?: GraphQLTypes["OrderDiscountMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	discountCents: number,
	vatRate?: GraphQLTypes["VatRate"] | undefined,
	order?: GraphQLTypes["Order"] | undefined,
	description?: string | undefined,
	type: GraphQLTypes["OrderDiscountType"],
	customerCreditTransactions: Array<GraphQLTypes["CustomerCreditTransaction"]>,
	voucherRedemption?: GraphQLTypes["VoucherRedemption"] | undefined,
	customerCreditTransactionsByVirtualProductEffect?: GraphQLTypes["CustomerCreditTransaction"] | undefined,
	paginateCustomerCreditTransactions: GraphQLTypes["CustomerCreditTransactionConnection"]
};
	["OrderDiscountMeta"]: {
	__typename: "OrderDiscountMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	discountCents?: GraphQLTypes["FieldMeta"] | undefined,
	vatRate?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	customerCreditTransactions?: GraphQLTypes["FieldMeta"] | undefined,
	voucherRedemption?: GraphQLTypes["FieldMeta"] | undefined
};
	["CustomerCreditTransaction"]: {
	__typename: "CustomerCreditTransaction",
	_meta?: GraphQLTypes["CustomerCreditTransactionMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt: GraphQLTypes["DateTime"],
	amountCents: number,
	customerCredit?: GraphQLTypes["CustomerCredit"] | undefined,
	orderDiscount?: GraphQLTypes["OrderDiscount"] | undefined,
	virtualProductEffect?: GraphQLTypes["VirtualProductEffect"] | undefined
};
	["CustomerCreditTransactionMeta"]: {
	__typename: "CustomerCreditTransactionMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	amountCents?: GraphQLTypes["FieldMeta"] | undefined,
	customerCredit?: GraphQLTypes["FieldMeta"] | undefined,
	orderDiscount?: GraphQLTypes["FieldMeta"] | undefined,
	virtualProductEffect?: GraphQLTypes["FieldMeta"] | undefined
};
	["CustomerCredit"]: {
	__typename: "CustomerCredit",
	_meta?: GraphQLTypes["CustomerCreditMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	initialCreditCents: number,
	remainingCreditsCents: number,
	expiresAt?: GraphQLTypes["DateTime"] | undefined,
	reason?: string | undefined,
	customer?: GraphQLTypes["Customer"] | undefined,
	vatRate?: GraphQLTypes["VatRate"] | undefined,
	createdAt: GraphQLTypes["DateTime"],
	transactions: Array<GraphQLTypes["CustomerCreditTransaction"]>,
	voucherRedemption?: GraphQLTypes["VoucherRedemption"] | undefined,
	invoiceUrl?: string | undefined,
	transactionsByVirtualProductEffect?: GraphQLTypes["CustomerCreditTransaction"] | undefined,
	paginateTransactions: GraphQLTypes["CustomerCreditTransactionConnection"]
};
	["CustomerCreditMeta"]: {
	__typename: "CustomerCreditMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	initialCreditCents?: GraphQLTypes["FieldMeta"] | undefined,
	remainingCreditsCents?: GraphQLTypes["FieldMeta"] | undefined,
	expiresAt?: GraphQLTypes["FieldMeta"] | undefined,
	reason?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined,
	vatRate?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	transactions?: GraphQLTypes["FieldMeta"] | undefined,
	voucherRedemption?: GraphQLTypes["FieldMeta"] | undefined,
	invoiceUrl?: GraphQLTypes["FieldMeta"] | undefined
};
	["CustomerCreditTransactionOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	amountCents?: GraphQLTypes["OrderDirection"] | undefined,
	customerCredit?: GraphQLTypes["CustomerCreditOrderBy"] | undefined,
	orderDiscount?: GraphQLTypes["OrderDiscountOrderBy"] | undefined,
	virtualProductEffect?: GraphQLTypes["VirtualProductEffectOrderBy"] | undefined
};
	["CustomerCreditOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	initialCreditCents?: GraphQLTypes["OrderDirection"] | undefined,
	remainingCreditsCents?: GraphQLTypes["OrderDirection"] | undefined,
	expiresAt?: GraphQLTypes["OrderDirection"] | undefined,
	reason?: GraphQLTypes["OrderDirection"] | undefined,
	customer?: GraphQLTypes["CustomerOrderBy"] | undefined,
	vatRate?: GraphQLTypes["VatRateOrderBy"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	voucherRedemption?: GraphQLTypes["VoucherRedemptionOrderBy"] | undefined,
	invoiceUrl?: GraphQLTypes["OrderDirection"] | undefined
};
	["VoucherRedemptionOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	note?: GraphQLTypes["OrderDirection"] | undefined,
	manualRedemptionNote?: GraphQLTypes["OrderDirection"] | undefined,
	customerCredit?: GraphQLTypes["CustomerCreditOrderBy"] | undefined,
	orderDiscount?: GraphQLTypes["OrderDiscountOrderBy"] | undefined,
	voucher?: GraphQLTypes["VoucherOrderBy"] | undefined,
	customer?: GraphQLTypes["CustomerOrderBy"] | undefined
};
	["OrderDiscountOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	discountCents?: GraphQLTypes["OrderDirection"] | undefined,
	vatRate?: GraphQLTypes["VatRateOrderBy"] | undefined,
	order?: GraphQLTypes["OrderOrderBy"] | undefined,
	description?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	voucherRedemption?: GraphQLTypes["VoucherRedemptionOrderBy"] | undefined
};
	["OrderOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	state?: GraphQLTypes["OrderDirection"] | undefined,
	fulfilledAt?: GraphQLTypes["OrderDirection"] | undefined,
	canceledAt?: GraphQLTypes["OrderDirection"] | undefined,
	note?: GraphQLTypes["OrderDirection"] | undefined,
	customer?: GraphQLTypes["CustomerOrderBy"] | undefined,
	channel?: GraphQLTypes["ChannelOrderBy"] | undefined,
	delivery?: GraphQLTypes["OrderDeliveryOrderBy"] | undefined,
	internalNote?: GraphQLTypes["OrderDirection"] | undefined,
	cart?: GraphQLTypes["CartOrderBy"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	billingAddress?: GraphQLTypes["AddressOrderBy"] | undefined,
	seq?: GraphQLTypes["OrderDirection"] | undefined,
	billingSubject?: GraphQLTypes["BillingSubjectOrderBy"] | undefined,
	summary?: GraphQLTypes["OrderSummaryOrderBy"] | undefined,
	doubleshotLegacyId?: GraphQLTypes["OrderDirection"] | undefined,
	gratuity?: GraphQLTypes["GratuityOrderBy"] | undefined,
	venue?: GraphQLTypes["VenueOrderBy"] | undefined,
	fulfillmentNote?: GraphQLTypes["OrderDirection"] | undefined,
	doubleshotTotalWeightGrams?: GraphQLTypes["OrderDirection"] | undefined,
	doubleShotLegacyNumber?: GraphQLTypes["OrderDirection"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["OrderDirection"] | undefined,
	doubleshotAdminUrl?: GraphQLTypes["OrderDirection"] | undefined
};
	["OrderDeliveryOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	priceCents?: GraphQLTypes["OrderDirection"] | undefined,
	deliveredAt?: GraphQLTypes["OrderDirection"] | undefined,
	method?: GraphQLTypes["DeliveryMethodOrderBy"] | undefined,
	vatRate?: GraphQLTypes["VatRateOrderBy"] | undefined,
	order?: GraphQLTypes["OrderOrderBy"] | undefined,
	expectedAt?: GraphQLTypes["OrderDirection"] | undefined,
	state?: GraphQLTypes["OrderDirection"] | undefined,
	loadingDurationHours?: GraphQLTypes["OrderDirection"] | undefined,
	dispatchAt?: GraphQLTypes["OrderDirection"] | undefined,
	duration?: GraphQLTypes["OrderDirection"] | undefined,
	window?: GraphQLTypes["OrderDirection"] | undefined,
	expectedEndAt?: GraphQLTypes["OrderDirection"] | undefined,
	processingAt?: GraphQLTypes["OrderDirection"] | undefined,
	deliveringAt?: GraphQLTypes["OrderDirection"] | undefined,
	failedAt?: GraphQLTypes["OrderDirection"] | undefined,
	internalNote?: GraphQLTypes["OrderDirection"] | undefined,
	deliveryWaypoint?: GraphQLTypes["DeliveryWaypointOrderBy"] | undefined,
	prepareAt?: GraphQLTypes["OrderDirection"] | undefined,
	liftagoRide?: GraphQLTypes["LiftagoRideOrderBy"] | undefined,
	pickedAt?: GraphQLTypes["OrderDirection"] | undefined,
	address?: GraphQLTypes["AddressOrderBy"] | undefined,
	trackingCode?: GraphQLTypes["OrderDirection"] | undefined,
	woltDriveDelivery?: GraphQLTypes["WoltDriveDeliveryOrderBy"] | undefined
};
	["DeliveryWaypointOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	estimatedArrival?: GraphQLTypes["OrderDirection"] | undefined,
	note?: GraphQLTypes["OrderDirection"] | undefined,
	route?: GraphQLTypes["DeliveryRouteOrderBy"] | undefined,
	sortingOrder?: GraphQLTypes["OrderDirection"] | undefined,
	delivery?: GraphQLTypes["OrderDeliveryOrderBy"] | undefined,
	estimatedDistance?: GraphQLTypes["OrderDirection"] | undefined,
	estimatedDuration?: GraphQLTypes["OrderDirection"] | undefined,
	originDeparture?: GraphQLTypes["OrderDirection"] | undefined,
	originAddress?: GraphQLTypes["OrderDirection"] | undefined,
	transitMode?: GraphQLTypes["OrderDirection"] | undefined
};
	["DeliveryRouteOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	courier?: GraphQLTypes["CourierOrderBy"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	dispatchAt?: GraphQLTypes["OrderDirection"] | undefined
};
	["LiftagoRideOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	liftagoId?: GraphQLTypes["OrderDirection"] | undefined,
	data?: GraphQLTypes["OrderDirection"] | undefined,
	updatedAt?: GraphQLTypes["OrderDirection"] | undefined,
	delivery?: GraphQLTypes["OrderDeliveryOrderBy"] | undefined
};
	["WoltDriveDeliveryOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	state?: GraphQLTypes["OrderDirection"] | undefined,
	shipmentPromiseId?: GraphQLTypes["OrderDirection"] | undefined,
	deliveryPrice?: GraphQLTypes["OrderDirection"] | undefined,
	deliveryPriceCurrency?: GraphQLTypes["OrderDirection"] | undefined,
	shipmentPromiseResponse?: GraphQLTypes["OrderDirection"] | undefined,
	deliveryOrderId?: GraphQLTypes["OrderDirection"] | undefined,
	trackingUrl?: GraphQLTypes["OrderDirection"] | undefined,
	deliverOrderResponse?: GraphQLTypes["OrderDirection"] | undefined,
	delivery?: GraphQLTypes["OrderDeliveryOrderBy"] | undefined
};
	["CartOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	confirmedAt?: GraphQLTypes["OrderDirection"] | undefined,
	deletedAt?: GraphQLTypes["OrderDirection"] | undefined,
	note?: GraphQLTypes["OrderDirection"] | undefined,
	handle?: GraphQLTypes["OrderDirection"] | undefined,
	state?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	channel?: GraphQLTypes["ChannelOrderBy"] | undefined,
	order?: GraphQLTypes["OrderOrderBy"] | undefined,
	customer?: GraphQLTypes["CustomerOrderBy"] | undefined,
	deliveryAddress?: GraphQLTypes["AddressOrderBy"] | undefined,
	billingAddress?: GraphQLTypes["AddressOrderBy"] | undefined,
	deliveryOption?: GraphQLTypes["OrderDirection"] | undefined,
	paymentOption?: GraphQLTypes["OrderDirection"] | undefined,
	delivery?: GraphQLTypes["ChannelDeliveryOrderBy"] | undefined,
	payment?: GraphQLTypes["ChannelPaymentOrderBy"] | undefined,
	billingSubject?: GraphQLTypes["BillingSubjectOrderBy"] | undefined,
	summary?: GraphQLTypes["CartSummaryOrderBy"] | undefined
};
	["CartSummaryOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	itemsPriceCents?: GraphQLTypes["OrderDirection"] | undefined,
	deliveryPriceCents?: GraphQLTypes["OrderDirection"] | undefined,
	totalPriceCents?: GraphQLTypes["OrderDirection"] | undefined,
	itemsCount?: GraphQLTypes["OrderDirection"] | undefined,
	itemsQuantity?: GraphQLTypes["OrderDirection"] | undefined,
	checkoutUrl?: GraphQLTypes["OrderDirection"] | undefined,
	cart?: GraphQLTypes["CartOrderBy"] | undefined
};
	["OrderSummaryOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	totalPriceCents?: GraphQLTypes["OrderDirection"] | undefined,
	discountPriceCents?: GraphQLTypes["OrderDirection"] | undefined,
	undiscountedPriceCents?: GraphQLTypes["OrderDirection"] | undefined,
	itemsQuantity?: GraphQLTypes["OrderDirection"] | undefined,
	orderUrl?: GraphQLTypes["OrderDirection"] | undefined,
	orderNumber?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderOrderBy"] | undefined
};
	["GratuityOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	amountCents?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderOrderBy"] | undefined
};
	["VoucherOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	activatedAt?: GraphQLTypes["OrderDirection"] | undefined,
	expiresAt?: GraphQLTypes["OrderDirection"] | undefined,
	internalNote?: GraphQLTypes["OrderDirection"] | undefined,
	note?: GraphQLTypes["OrderDirection"] | undefined,
	code?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	creditCents?: GraphQLTypes["OrderDirection"] | undefined,
	buyer?: GraphQLTypes["CustomerOrderBy"] | undefined,
	owner?: GraphQLTypes["CustomerOrderBy"] | undefined,
	vatRate?: GraphQLTypes["VatRateOrderBy"] | undefined,
	virtualProductEffect?: GraphQLTypes["VirtualProductEffectOrderBy"] | undefined,
	redemption?: GraphQLTypes["VoucherRedemptionOrderBy"] | undefined
};
	["VirtualProductEffectOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	succeededAt?: GraphQLTypes["OrderDirection"] | undefined,
	orderItem?: GraphQLTypes["OrderItemOrderBy"] | undefined,
	failedAt?: GraphQLTypes["OrderDirection"] | undefined,
	revertedAt?: GraphQLTypes["OrderDirection"] | undefined,
	resultCustomerCreditTransaction?: GraphQLTypes["CustomerCreditTransactionOrderBy"] | undefined
};
	["OrderItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	unitPriceCents?: GraphQLTypes["OrderDirection"] | undefined,
	quantity?: GraphQLTypes["OrderDirection"] | undefined,
	vatRate?: GraphQLTypes["VatRateOrderBy"] | undefined,
	order?: GraphQLTypes["OrderOrderBy"] | undefined,
	pickedAt?: GraphQLTypes["OrderDirection"] | undefined,
	note?: GraphQLTypes["OrderDirection"] | undefined,
	product?: GraphQLTypes["ProductOrderBy"] | undefined
};
	["VoucherRedemption"]: {
	__typename: "VoucherRedemption",
	_meta?: GraphQLTypes["VoucherRedemptionMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt: GraphQLTypes["DateTime"],
	note?: string | undefined,
	manualRedemptionNote?: string | undefined,
	customerCredit?: GraphQLTypes["CustomerCredit"] | undefined,
	orderDiscount?: GraphQLTypes["OrderDiscount"] | undefined,
	voucher?: GraphQLTypes["Voucher"] | undefined,
	customer?: GraphQLTypes["Customer"] | undefined
};
	["VoucherRedemptionMeta"]: {
	__typename: "VoucherRedemptionMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	note?: GraphQLTypes["FieldMeta"] | undefined,
	manualRedemptionNote?: GraphQLTypes["FieldMeta"] | undefined,
	customerCredit?: GraphQLTypes["FieldMeta"] | undefined,
	orderDiscount?: GraphQLTypes["FieldMeta"] | undefined,
	voucher?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined
};
	["Voucher"]: {
	__typename: "Voucher",
	_meta?: GraphQLTypes["VoucherMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt: GraphQLTypes["DateTime"],
	activatedAt?: GraphQLTypes["DateTime"] | undefined,
	expiresAt?: GraphQLTypes["DateTime"] | undefined,
	internalNote?: string | undefined,
	note?: string | undefined,
	code: string,
	type: GraphQLTypes["VoucherType"],
	creditCents?: number | undefined,
	buyer?: GraphQLTypes["Customer"] | undefined,
	owner?: GraphQLTypes["Customer"] | undefined,
	vatRate?: GraphQLTypes["VatRate"] | undefined,
	virtualProductEffect?: GraphQLTypes["VirtualProductEffect"] | undefined,
	redemption?: GraphQLTypes["VoucherRedemption"] | undefined
};
	["VoucherMeta"]: {
	__typename: "VoucherMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	activatedAt?: GraphQLTypes["FieldMeta"] | undefined,
	expiresAt?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	note?: GraphQLTypes["FieldMeta"] | undefined,
	code?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	creditCents?: GraphQLTypes["FieldMeta"] | undefined,
	buyer?: GraphQLTypes["FieldMeta"] | undefined,
	owner?: GraphQLTypes["FieldMeta"] | undefined,
	vatRate?: GraphQLTypes["FieldMeta"] | undefined,
	virtualProductEffect?: GraphQLTypes["FieldMeta"] | undefined,
	redemption?: GraphQLTypes["FieldMeta"] | undefined
};
	["VirtualProductEffect"]: {
	__typename: "VirtualProductEffect",
	_meta?: GraphQLTypes["VirtualProductEffectMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt: GraphQLTypes["DateTime"],
	succeededAt?: GraphQLTypes["DateTime"] | undefined,
	orderItem?: GraphQLTypes["OrderItem"] | undefined,
	failedAt?: GraphQLTypes["DateTime"] | undefined,
	revertedAt?: GraphQLTypes["DateTime"] | undefined,
	resultCustomerCreditTransaction?: GraphQLTypes["CustomerCreditTransaction"] | undefined,
	resultVouchers: Array<GraphQLTypes["Voucher"]>,
	resultVouchersByCode?: GraphQLTypes["Voucher"] | undefined,
	resultVouchersByRedemption?: GraphQLTypes["Voucher"] | undefined,
	paginateResultVouchers: GraphQLTypes["VoucherConnection"]
};
	["VirtualProductEffectMeta"]: {
	__typename: "VirtualProductEffectMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	succeededAt?: GraphQLTypes["FieldMeta"] | undefined,
	orderItem?: GraphQLTypes["FieldMeta"] | undefined,
	failedAt?: GraphQLTypes["FieldMeta"] | undefined,
	revertedAt?: GraphQLTypes["FieldMeta"] | undefined,
	resultCustomerCreditTransaction?: GraphQLTypes["FieldMeta"] | undefined,
	resultVouchers?: GraphQLTypes["FieldMeta"] | undefined
};
	["OrderItem"]: {
	__typename: "OrderItem",
	_meta?: GraphQLTypes["OrderItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	unitPriceCents: number,
	quantity: number,
	vatRate?: GraphQLTypes["VatRate"] | undefined,
	order?: GraphQLTypes["Order"] | undefined,
	virtualProductEffects: Array<GraphQLTypes["VirtualProductEffect"]>,
	pickedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	fulfillmentNotes: Array<GraphQLTypes["FulfillmentNote"]>,
	product?: GraphQLTypes["Product"] | undefined,
	virtualProductEffectsByResultCustomerCreditTransaction?: GraphQLTypes["VirtualProductEffect"] | undefined,
	virtualProductEffectsByResultVouchers?: GraphQLTypes["VirtualProductEffect"] | undefined,
	paginateVirtualProductEffects: GraphQLTypes["VirtualProductEffectConnection"],
	paginateFulfillmentNotes: GraphQLTypes["FulfillmentNoteConnection"]
};
	["OrderItemMeta"]: {
	__typename: "OrderItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	unitPriceCents?: GraphQLTypes["FieldMeta"] | undefined,
	quantity?: GraphQLTypes["FieldMeta"] | undefined,
	vatRate?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	virtualProductEffects?: GraphQLTypes["FieldMeta"] | undefined,
	pickedAt?: GraphQLTypes["FieldMeta"] | undefined,
	note?: GraphQLTypes["FieldMeta"] | undefined,
	fulfillmentNotes?: GraphQLTypes["FieldMeta"] | undefined,
	product?: GraphQLTypes["FieldMeta"] | undefined
};
	["FulfillmentNoteOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	note?: GraphQLTypes["OrderDirection"] | undefined,
	highlight?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	emoji?: GraphQLTypes["OrderDirection"] | undefined
};
	["OrderItemVirtualProductEffectsByResultCustomerCreditTransactionUniqueWhere"]: {
		resultCustomerCreditTransaction?: GraphQLTypes["CustomerCreditTransactionUniqueWhere"] | undefined
};
	["OrderItemVirtualProductEffectsByResultVouchersUniqueWhere"]: {
		resultVouchers?: GraphQLTypes["VoucherUniqueWhere"] | undefined
};
	["VirtualProductEffectConnection"]: {
	__typename: "VirtualProductEffectConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["VirtualProductEffectEdge"]>
};
	["VirtualProductEffectEdge"]: {
	__typename: "VirtualProductEffectEdge",
	node: GraphQLTypes["VirtualProductEffect"]
};
	["FulfillmentNoteConnection"]: {
	__typename: "FulfillmentNoteConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FulfillmentNoteEdge"]>
};
	["FulfillmentNoteEdge"]: {
	__typename: "FulfillmentNoteEdge",
	node: GraphQLTypes["FulfillmentNote"]
};
	["VirtualProductEffectResultVouchersByCodeUniqueWhere"]: {
		code?: string | undefined
};
	["VirtualProductEffectResultVouchersByRedemptionUniqueWhere"]: {
		redemption?: GraphQLTypes["VoucherRedemptionUniqueWhere"] | undefined
};
	["VoucherConnection"]: {
	__typename: "VoucherConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["VoucherEdge"]>
};
	["VoucherEdge"]: {
	__typename: "VoucherEdge",
	node: GraphQLTypes["Voucher"]
};
	["CustomerCreditTransactionsByVirtualProductEffectUniqueWhere"]: {
		virtualProductEffect?: GraphQLTypes["VirtualProductEffectUniqueWhere"] | undefined
};
	["CustomerCreditTransactionConnection"]: {
	__typename: "CustomerCreditTransactionConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CustomerCreditTransactionEdge"]>
};
	["CustomerCreditTransactionEdge"]: {
	__typename: "CustomerCreditTransactionEdge",
	node: GraphQLTypes["CustomerCreditTransaction"]
};
	["OrderDiscountCustomerCreditTransactionsByVirtualProductEffectUniqueWhere"]: {
		virtualProductEffect?: GraphQLTypes["VirtualProductEffectUniqueWhere"] | undefined
};
	["OrderEvent"]: {
	__typename: "OrderEvent",
	_meta?: GraphQLTypes["OrderEventMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	type: string,
	data?: string | undefined,
	createdAt: GraphQLTypes["DateTime"],
	order?: GraphQLTypes["Order"] | undefined,
	payment?: GraphQLTypes["OrderPayment"] | undefined,
	delivery?: GraphQLTypes["OrderDelivery"] | undefined
};
	["OrderEventMeta"]: {
	__typename: "OrderEventMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	data?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	payment?: GraphQLTypes["FieldMeta"] | undefined,
	delivery?: GraphQLTypes["FieldMeta"] | undefined
};
	["OrderPayment"]: {
	__typename: "OrderPayment",
	_meta?: GraphQLTypes["OrderPaymentMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	data?: GraphQLTypes["Json"] | undefined,
	paymentCents: number,
	method?: GraphQLTypes["PaymentMethod"] | undefined,
	failedAt?: GraphQLTypes["DateTime"] | undefined,
	state: GraphQLTypes["OrderPaymentState"],
	approvedAt?: GraphQLTypes["DateTime"] | undefined,
	events: Array<GraphQLTypes["OrderEvent"]>,
	order?: GraphQLTypes["Order"] | undefined,
	invoice?: GraphQLTypes["Invoice"] | undefined,
	walletType?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	publicReceiptUrl?: string | undefined,
	priceCents?: number | undefined,
	vatRate?: GraphQLTypes["VatRate"] | undefined,
	meta?: GraphQLTypes["OrderPaymentMetadata"] | undefined,
	otherCurrencyPriceCents?: string | undefined,
	paginateEvents: GraphQLTypes["OrderEventConnection"]
};
	["OrderPaymentMeta"]: {
	__typename: "OrderPaymentMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	data?: GraphQLTypes["FieldMeta"] | undefined,
	paymentCents?: GraphQLTypes["FieldMeta"] | undefined,
	method?: GraphQLTypes["FieldMeta"] | undefined,
	failedAt?: GraphQLTypes["FieldMeta"] | undefined,
	state?: GraphQLTypes["FieldMeta"] | undefined,
	approvedAt?: GraphQLTypes["FieldMeta"] | undefined,
	events?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	invoice?: GraphQLTypes["FieldMeta"] | undefined,
	walletType?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	publicReceiptUrl?: GraphQLTypes["FieldMeta"] | undefined,
	priceCents?: GraphQLTypes["FieldMeta"] | undefined,
	vatRate?: GraphQLTypes["FieldMeta"] | undefined,
	meta?: GraphQLTypes["FieldMeta"] | undefined,
	otherCurrencyPriceCents?: GraphQLTypes["FieldMeta"] | undefined
};
	["OrderEventOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	data?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderOrderBy"] | undefined,
	payment?: GraphQLTypes["OrderPaymentOrderBy"] | undefined,
	delivery?: GraphQLTypes["OrderDeliveryOrderBy"] | undefined
};
	["OrderPaymentOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	data?: GraphQLTypes["OrderDirection"] | undefined,
	paymentCents?: GraphQLTypes["OrderDirection"] | undefined,
	method?: GraphQLTypes["PaymentMethodOrderBy"] | undefined,
	failedAt?: GraphQLTypes["OrderDirection"] | undefined,
	state?: GraphQLTypes["OrderDirection"] | undefined,
	approvedAt?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderOrderBy"] | undefined,
	invoice?: GraphQLTypes["InvoiceOrderBy"] | undefined,
	walletType?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	publicReceiptUrl?: GraphQLTypes["OrderDirection"] | undefined,
	priceCents?: GraphQLTypes["OrderDirection"] | undefined,
	vatRate?: GraphQLTypes["VatRateOrderBy"] | undefined,
	meta?: GraphQLTypes["OrderPaymentMetadataOrderBy"] | undefined,
	otherCurrencyPriceCents?: GraphQLTypes["OrderDirection"] | undefined
};
	["InvoiceOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	publicKey?: GraphQLTypes["OrderDirection"] | undefined,
	fakturoidId?: GraphQLTypes["OrderDirection"] | undefined,
	fakturoidData?: GraphQLTypes["OrderDirection"] | undefined,
	legacyUrl?: GraphQLTypes["OrderDirection"] | undefined,
	customer?: GraphQLTypes["CustomerOrderBy"] | undefined,
	address?: GraphQLTypes["AddressOrderBy"] | undefined,
	publicUrl?: GraphQLTypes["OrderDirection"] | undefined,
	billingSubject?: GraphQLTypes["BillingSubjectOrderBy"] | undefined
};
	["OrderPaymentMetadataOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	paymentUrl?: GraphQLTypes["OrderDirection"] | undefined,
	orderPayment?: GraphQLTypes["OrderPaymentOrderBy"] | undefined
};
	["Invoice"]: {
	__typename: "Invoice",
	_meta?: GraphQLTypes["InvoiceMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt: GraphQLTypes["DateTime"],
	publicKey: string,
	fakturoidId?: string | undefined,
	fakturoidData?: string | undefined,
	legacyUrl?: string | undefined,
	customer?: GraphQLTypes["Customer"] | undefined,
	orderPayments: Array<GraphQLTypes["OrderPayment"]>,
	address?: GraphQLTypes["Address"] | undefined,
	publicUrl?: string | undefined,
	billingSubject?: GraphQLTypes["BillingSubject"] | undefined,
	orderPaymentsByEvents?: GraphQLTypes["OrderPayment"] | undefined,
	orderPaymentsByMeta?: GraphQLTypes["OrderPayment"] | undefined,
	paginateOrderPayments: GraphQLTypes["OrderPaymentConnection"]
};
	["InvoiceMeta"]: {
	__typename: "InvoiceMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	publicKey?: GraphQLTypes["FieldMeta"] | undefined,
	fakturoidId?: GraphQLTypes["FieldMeta"] | undefined,
	fakturoidData?: GraphQLTypes["FieldMeta"] | undefined,
	legacyUrl?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined,
	orderPayments?: GraphQLTypes["FieldMeta"] | undefined,
	address?: GraphQLTypes["FieldMeta"] | undefined,
	publicUrl?: GraphQLTypes["FieldMeta"] | undefined,
	billingSubject?: GraphQLTypes["FieldMeta"] | undefined
};
	["BillingSubject"]: {
	__typename: "BillingSubject",
	_meta?: GraphQLTypes["BillingSubjectMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name?: string | undefined,
	fullName?: string | undefined,
	addressLine1?: string | undefined,
	addressLine2?: string | undefined,
	city?: string | undefined,
	postalCode?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	companyName?: string | undefined,
	companyIdentifier?: string | undefined,
	vatIdentifier?: string | undefined,
	externalIdentifier?: string | undefined,
	hidden: boolean,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	internalNote?: string | undefined,
	fakturoidSubjectId?: string | undefined,
	country?: GraphQLTypes["Country"] | undefined,
	customer?: GraphQLTypes["Customer"] | undefined,
	invoices: Array<GraphQLTypes["Invoice"]>,
	defaultBillingSubjectOfCustomer?: GraphQLTypes["Customer"] | undefined,
	orders: Array<GraphQLTypes["Order"]>,
	invoicesByPublicKey?: GraphQLTypes["Invoice"] | undefined,
	invoicesByFakturoidId?: GraphQLTypes["Invoice"] | undefined,
	invoicesByOrderPayments?: GraphQLTypes["Invoice"] | undefined,
	ordersBySeq?: GraphQLTypes["Order"] | undefined,
	ordersByDoubleshotLegacyId?: GraphQLTypes["Order"] | undefined,
	ordersByDoubleShotLegacyNumber?: GraphQLTypes["Order"] | undefined,
	ordersByDiscounts?: GraphQLTypes["Order"] | undefined,
	ordersByDelivery?: GraphQLTypes["Order"] | undefined,
	ordersByItems?: GraphQLTypes["Order"] | undefined,
	ordersByCart?: GraphQLTypes["Order"] | undefined,
	ordersByEvents?: GraphQLTypes["Order"] | undefined,
	ordersByPriceLines?: GraphQLTypes["Order"] | undefined,
	ordersByPayments?: GraphQLTypes["Order"] | undefined,
	ordersBySummary?: GraphQLTypes["Order"] | undefined,
	ordersByGratuity?: GraphQLTypes["Order"] | undefined,
	paginateInvoices: GraphQLTypes["InvoiceConnection"],
	paginateOrders: GraphQLTypes["OrderConnection"]
};
	["BillingSubjectMeta"]: {
	__typename: "BillingSubjectMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	fullName?: GraphQLTypes["FieldMeta"] | undefined,
	addressLine1?: GraphQLTypes["FieldMeta"] | undefined,
	addressLine2?: GraphQLTypes["FieldMeta"] | undefined,
	city?: GraphQLTypes["FieldMeta"] | undefined,
	postalCode?: GraphQLTypes["FieldMeta"] | undefined,
	email?: GraphQLTypes["FieldMeta"] | undefined,
	phone?: GraphQLTypes["FieldMeta"] | undefined,
	companyName?: GraphQLTypes["FieldMeta"] | undefined,
	companyIdentifier?: GraphQLTypes["FieldMeta"] | undefined,
	vatIdentifier?: GraphQLTypes["FieldMeta"] | undefined,
	externalIdentifier?: GraphQLTypes["FieldMeta"] | undefined,
	hidden?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	deletedAt?: GraphQLTypes["FieldMeta"] | undefined,
	note?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	fakturoidSubjectId?: GraphQLTypes["FieldMeta"] | undefined,
	country?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined,
	invoices?: GraphQLTypes["FieldMeta"] | undefined,
	defaultBillingSubjectOfCustomer?: GraphQLTypes["FieldMeta"] | undefined,
	orders?: GraphQLTypes["FieldMeta"] | undefined
};
	["Country"]: {
	__typename: "Country",
	_meta?: GraphQLTypes["CountryMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	code: string,
	order: number
};
	["CountryMeta"]: {
	__typename: "CountryMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	code?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined
};
	["BillingSubjectInvoicesByPublicKeyUniqueWhere"]: {
		publicKey?: string | undefined
};
	["BillingSubjectInvoicesByFakturoidIdUniqueWhere"]: {
		fakturoidId?: string | undefined
};
	["BillingSubjectInvoicesByOrderPaymentsUniqueWhere"]: {
		orderPayments?: GraphQLTypes["OrderPaymentUniqueWhere"] | undefined
};
	["BillingSubjectOrdersBySeqUniqueWhere"]: {
		seq?: number | undefined
};
	["BillingSubjectOrdersByDoubleshotLegacyIdUniqueWhere"]: {
		doubleshotLegacyId?: string | undefined
};
	["BillingSubjectOrdersByDoubleShotLegacyNumberUniqueWhere"]: {
		doubleShotLegacyNumber?: string | undefined
};
	["BillingSubjectOrdersByDiscountsUniqueWhere"]: {
		discounts?: GraphQLTypes["OrderDiscountUniqueWhere"] | undefined
};
	["BillingSubjectOrdersByDeliveryUniqueWhere"]: {
		delivery?: GraphQLTypes["OrderDeliveryUniqueWhere"] | undefined
};
	["BillingSubjectOrdersByItemsUniqueWhere"]: {
		items?: GraphQLTypes["OrderItemUniqueWhere"] | undefined
};
	["BillingSubjectOrdersByCartUniqueWhere"]: {
		cart?: GraphQLTypes["CartUniqueWhere"] | undefined
};
	["BillingSubjectOrdersByEventsUniqueWhere"]: {
		events?: GraphQLTypes["OrderEventUniqueWhere"] | undefined
};
	["BillingSubjectOrdersByPriceLinesUniqueWhere"]: {
		priceLines?: GraphQLTypes["OrderPriceLineUniqueWhere"] | undefined
};
	["BillingSubjectOrdersByPaymentsUniqueWhere"]: {
		payments?: GraphQLTypes["OrderPaymentUniqueWhere"] | undefined
};
	["BillingSubjectOrdersBySummaryUniqueWhere"]: {
		summary?: GraphQLTypes["OrderSummaryUniqueWhere"] | undefined
};
	["BillingSubjectOrdersByGratuityUniqueWhere"]: {
		gratuity?: GraphQLTypes["GratuityUniqueWhere"] | undefined
};
	["InvoiceConnection"]: {
	__typename: "InvoiceConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["InvoiceEdge"]>
};
	["InvoiceEdge"]: {
	__typename: "InvoiceEdge",
	node: GraphQLTypes["Invoice"]
};
	["OrderConnection"]: {
	__typename: "OrderConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["OrderEdge"]>
};
	["OrderEdge"]: {
	__typename: "OrderEdge",
	node: GraphQLTypes["Order"]
};
	["InvoiceOrderPaymentsByEventsUniqueWhere"]: {
		events?: GraphQLTypes["OrderEventUniqueWhere"] | undefined
};
	["InvoiceOrderPaymentsByMetaUniqueWhere"]: {
		meta?: GraphQLTypes["OrderPaymentMetadataUniqueWhere"] | undefined
};
	["OrderPaymentConnection"]: {
	__typename: "OrderPaymentConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["OrderPaymentEdge"]>
};
	["OrderPaymentEdge"]: {
	__typename: "OrderPaymentEdge",
	node: GraphQLTypes["OrderPayment"]
};
	["OrderPaymentMetadata"]: {
	__typename: "OrderPaymentMetadata",
	_meta?: GraphQLTypes["OrderPaymentMetadataMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	paymentUrl: string,
	orderPayment?: GraphQLTypes["OrderPayment"] | undefined
};
	["OrderPaymentMetadataMeta"]: {
	__typename: "OrderPaymentMetadataMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	paymentUrl?: GraphQLTypes["FieldMeta"] | undefined,
	orderPayment?: GraphQLTypes["FieldMeta"] | undefined
};
	["OrderEventConnection"]: {
	__typename: "OrderEventConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["OrderEventEdge"]>
};
	["OrderEventEdge"]: {
	__typename: "OrderEventEdge",
	node: GraphQLTypes["OrderEvent"]
};
	["OrderPriceLine"]: {
	__typename: "OrderPriceLine",
	_meta?: GraphQLTypes["OrderPriceLineMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	unitPriceCents: number,
	quantity: number,
	type?: GraphQLTypes["OrderPriceLineType"] | undefined,
	orderItem?: GraphQLTypes["OrderItem"] | undefined,
	orderDiscount?: GraphQLTypes["OrderDiscount"] | undefined,
	orderPayment?: GraphQLTypes["OrderPayment"] | undefined,
	orderDelivery?: GraphQLTypes["OrderDelivery"] | undefined,
	vatRatePermille: number,
	vatRate?: GraphQLTypes["VatRate"] | undefined,
	order?: GraphQLTypes["Order"] | undefined
};
	["OrderPriceLineMeta"]: {
	__typename: "OrderPriceLineMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	unitPriceCents?: GraphQLTypes["FieldMeta"] | undefined,
	quantity?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	orderItem?: GraphQLTypes["FieldMeta"] | undefined,
	orderDiscount?: GraphQLTypes["FieldMeta"] | undefined,
	orderPayment?: GraphQLTypes["FieldMeta"] | undefined,
	orderDelivery?: GraphQLTypes["FieldMeta"] | undefined,
	vatRatePermille?: GraphQLTypes["FieldMeta"] | undefined,
	vatRate?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined
};
	["OrderPriceLineOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	unitPriceCents?: GraphQLTypes["OrderDirection"] | undefined,
	quantity?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	orderItem?: GraphQLTypes["OrderItemOrderBy"] | undefined,
	orderDiscount?: GraphQLTypes["OrderDiscountOrderBy"] | undefined,
	orderPayment?: GraphQLTypes["OrderPaymentOrderBy"] | undefined,
	orderDelivery?: GraphQLTypes["OrderDeliveryOrderBy"] | undefined,
	vatRatePermille?: GraphQLTypes["OrderDirection"] | undefined,
	vatRate?: GraphQLTypes["VatRateOrderBy"] | undefined,
	order?: GraphQLTypes["OrderOrderBy"] | undefined
};
	["OrderSummary"]: {
	__typename: "OrderSummary",
	_meta?: GraphQLTypes["OrderSummaryMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	totalPriceCents: number,
	discountPriceCents: number,
	undiscountedPriceCents: number,
	itemsQuantity: number,
	orderUrl: string,
	orderNumber: string,
	order?: GraphQLTypes["Order"] | undefined
};
	["OrderSummaryMeta"]: {
	__typename: "OrderSummaryMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	totalPriceCents?: GraphQLTypes["FieldMeta"] | undefined,
	discountPriceCents?: GraphQLTypes["FieldMeta"] | undefined,
	undiscountedPriceCents?: GraphQLTypes["FieldMeta"] | undefined,
	itemsQuantity?: GraphQLTypes["FieldMeta"] | undefined,
	orderUrl?: GraphQLTypes["FieldMeta"] | undefined,
	orderNumber?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined
};
	["Gratuity"]: {
	__typename: "Gratuity",
	_meta?: GraphQLTypes["GratuityMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	amountCents: number,
	order?: GraphQLTypes["Order"] | undefined
};
	["GratuityMeta"]: {
	__typename: "GratuityMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	amountCents?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined
};
	["OrderDiscountsByCustomerCreditTransactionsUniqueWhere"]: {
		customerCreditTransactions?: GraphQLTypes["CustomerCreditTransactionUniqueWhere"] | undefined
};
	["OrderDiscountsByVoucherRedemptionUniqueWhere"]: {
		voucherRedemption?: GraphQLTypes["VoucherRedemptionUniqueWhere"] | undefined
};
	["OrderItemsByVirtualProductEffectsUniqueWhere"]: {
		virtualProductEffects?: GraphQLTypes["VirtualProductEffectUniqueWhere"] | undefined
};
	["OrderPriceLinesByOrderItemUniqueWhere"]: {
		orderItem?: GraphQLTypes["OrderItemUniqueWhere"] | undefined
};
	["OrderPriceLinesByOrderDiscountUniqueWhere"]: {
		orderDiscount?: GraphQLTypes["OrderDiscountUniqueWhere"] | undefined
};
	["OrderPriceLinesByOrderPaymentUniqueWhere"]: {
		orderPayment?: GraphQLTypes["OrderPaymentUniqueWhere"] | undefined
};
	["OrderPriceLinesByOrderDeliveryUniqueWhere"]: {
		orderDelivery?: GraphQLTypes["OrderDeliveryUniqueWhere"] | undefined
};
	["OrderPaymentsByEventsUniqueWhere"]: {
		events?: GraphQLTypes["OrderEventUniqueWhere"] | undefined
};
	["OrderPaymentsByMetaUniqueWhere"]: {
		meta?: GraphQLTypes["OrderPaymentMetadataUniqueWhere"] | undefined
};
	["OrderDiscountConnection"]: {
	__typename: "OrderDiscountConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["OrderDiscountEdge"]>
};
	["OrderDiscountEdge"]: {
	__typename: "OrderDiscountEdge",
	node: GraphQLTypes["OrderDiscount"]
};
	["OrderItemConnection"]: {
	__typename: "OrderItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["OrderItemEdge"]>
};
	["OrderItemEdge"]: {
	__typename: "OrderItemEdge",
	node: GraphQLTypes["OrderItem"]
};
	["OrderPriceLineConnection"]: {
	__typename: "OrderPriceLineConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["OrderPriceLineEdge"]>
};
	["OrderPriceLineEdge"]: {
	__typename: "OrderPriceLineEdge",
	node: GraphQLTypes["OrderPriceLine"]
};
	["Area"]: {
	__typename: "Area",
	_meta?: GraphQLTypes["AreaMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	name?: string | undefined,
	venue?: GraphQLTypes["Venue"] | undefined,
	tables: Array<GraphQLTypes["Table"]>,
	lines: Array<GraphQLTypes["Line"]>,
	tablesByCustomerTabs?: GraphQLTypes["Table"] | undefined,
	tablesBySeats?: GraphQLTypes["Table"] | undefined,
	paginateTables: GraphQLTypes["TableConnection"],
	paginateLines: GraphQLTypes["LineConnection"]
};
	["AreaMeta"]: {
	__typename: "AreaMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	venue?: GraphQLTypes["FieldMeta"] | undefined,
	tables?: GraphQLTypes["FieldMeta"] | undefined,
	lines?: GraphQLTypes["FieldMeta"] | undefined
};
	["Table"]: {
	__typename: "Table",
	_meta?: GraphQLTypes["TableMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	shape: GraphQLTypes["TableShape"],
	width: number,
	height: number,
	positionX: number,
	positionY: number,
	name?: string | undefined,
	color?: string | undefined,
	customerTabs: Array<GraphQLTypes["CustomerTab"]>,
	area?: GraphQLTypes["Area"] | undefined,
	seats: Array<GraphQLTypes["Seat"]>,
	customerTabsByItems?: GraphQLTypes["CustomerTab"] | undefined,
	customerTabsByMeta?: GraphQLTypes["CustomerTab"] | undefined,
	seatsByCustomerTabs?: GraphQLTypes["Seat"] | undefined,
	paginateCustomerTabs: GraphQLTypes["CustomerTabConnection"],
	paginateSeats: GraphQLTypes["SeatConnection"]
};
	["TableMeta"]: {
	__typename: "TableMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	shape?: GraphQLTypes["FieldMeta"] | undefined,
	width?: GraphQLTypes["FieldMeta"] | undefined,
	height?: GraphQLTypes["FieldMeta"] | undefined,
	positionX?: GraphQLTypes["FieldMeta"] | undefined,
	positionY?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	color?: GraphQLTypes["FieldMeta"] | undefined,
	customerTabs?: GraphQLTypes["FieldMeta"] | undefined,
	area?: GraphQLTypes["FieldMeta"] | undefined,
	seats?: GraphQLTypes["FieldMeta"] | undefined
};
	["CustomerTab"]: {
	__typename: "CustomerTab",
	_meta?: GraphQLTypes["CustomerTabMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt: GraphQLTypes["DateTime"],
	color?: string | undefined,
	items: Array<GraphQLTypes["CustomerTabItem"]>,
	name?: string | undefined,
	meta?: GraphQLTypes["CustomerTabMetadata"] | undefined,
	customer?: GraphQLTypes["Customer"] | undefined,
	table?: GraphQLTypes["Table"] | undefined,
	seat?: GraphQLTypes["Seat"] | undefined,
	paginateItems: GraphQLTypes["CustomerTabItemConnection"]
};
	["CustomerTabMeta"]: {
	__typename: "CustomerTabMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	color?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	meta?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined,
	table?: GraphQLTypes["FieldMeta"] | undefined,
	seat?: GraphQLTypes["FieldMeta"] | undefined
};
	["CustomerTabItem"]: {
	__typename: "CustomerTabItem",
	_meta?: GraphQLTypes["CustomerTabItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	addedAt: GraphQLTypes["DateTime"],
	tab?: GraphQLTypes["CustomerTab"] | undefined,
	product?: GraphQLTypes["Product"] | undefined,
	paidAt?: GraphQLTypes["DateTime"] | undefined
};
	["CustomerTabItemMeta"]: {
	__typename: "CustomerTabItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	addedAt?: GraphQLTypes["FieldMeta"] | undefined,
	tab?: GraphQLTypes["FieldMeta"] | undefined,
	product?: GraphQLTypes["FieldMeta"] | undefined,
	paidAt?: GraphQLTypes["FieldMeta"] | undefined
};
	["CustomerTabItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	addedAt?: GraphQLTypes["OrderDirection"] | undefined,
	tab?: GraphQLTypes["CustomerTabOrderBy"] | undefined,
	product?: GraphQLTypes["ProductOrderBy"] | undefined,
	paidAt?: GraphQLTypes["OrderDirection"] | undefined
};
	["CustomerTabOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	color?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	meta?: GraphQLTypes["CustomerTabMetadataOrderBy"] | undefined,
	customer?: GraphQLTypes["CustomerOrderBy"] | undefined,
	table?: GraphQLTypes["TableOrderBy"] | undefined,
	seat?: GraphQLTypes["SeatOrderBy"] | undefined
};
	["CustomerTabMetadataOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	totalPriceCents?: GraphQLTypes["OrderDirection"] | undefined,
	totalSpentCents?: GraphQLTypes["OrderDirection"] | undefined,
	unpaidCents?: GraphQLTypes["OrderDirection"] | undefined,
	customerTab?: GraphQLTypes["CustomerTabOrderBy"] | undefined
};
	["TableOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	shape?: GraphQLTypes["OrderDirection"] | undefined,
	width?: GraphQLTypes["OrderDirection"] | undefined,
	height?: GraphQLTypes["OrderDirection"] | undefined,
	positionX?: GraphQLTypes["OrderDirection"] | undefined,
	positionY?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	color?: GraphQLTypes["OrderDirection"] | undefined,
	area?: GraphQLTypes["AreaOrderBy"] | undefined
};
	["AreaOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	venue?: GraphQLTypes["VenueOrderBy"] | undefined
};
	["SeatOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	positionX?: GraphQLTypes["OrderDirection"] | undefined,
	positionY?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	color?: GraphQLTypes["OrderDirection"] | undefined,
	table?: GraphQLTypes["TableOrderBy"] | undefined
};
	["CustomerTabMetadata"]: {
	__typename: "CustomerTabMetadata",
	_meta?: GraphQLTypes["CustomerTabMetadataMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	totalPriceCents: number,
	totalSpentCents: number,
	unpaidCents: number,
	customerTab?: GraphQLTypes["CustomerTab"] | undefined
};
	["CustomerTabMetadataMeta"]: {
	__typename: "CustomerTabMetadataMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	totalPriceCents?: GraphQLTypes["FieldMeta"] | undefined,
	totalSpentCents?: GraphQLTypes["FieldMeta"] | undefined,
	unpaidCents?: GraphQLTypes["FieldMeta"] | undefined,
	customerTab?: GraphQLTypes["FieldMeta"] | undefined
};
	["Seat"]: {
	__typename: "Seat",
	_meta?: GraphQLTypes["SeatMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	positionX: number,
	positionY: number,
	name?: string | undefined,
	color?: string | undefined,
	customerTabs: Array<GraphQLTypes["CustomerTab"]>,
	table?: GraphQLTypes["Table"] | undefined,
	customerTabsByItems?: GraphQLTypes["CustomerTab"] | undefined,
	customerTabsByMeta?: GraphQLTypes["CustomerTab"] | undefined,
	paginateCustomerTabs: GraphQLTypes["CustomerTabConnection"]
};
	["SeatMeta"]: {
	__typename: "SeatMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	positionX?: GraphQLTypes["FieldMeta"] | undefined,
	positionY?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	color?: GraphQLTypes["FieldMeta"] | undefined,
	customerTabs?: GraphQLTypes["FieldMeta"] | undefined,
	table?: GraphQLTypes["FieldMeta"] | undefined
};
	["SeatCustomerTabsByItemsUniqueWhere"]: {
		items?: GraphQLTypes["CustomerTabItemUniqueWhere"] | undefined
};
	["SeatCustomerTabsByMetaUniqueWhere"]: {
		meta?: GraphQLTypes["CustomerTabMetadataUniqueWhere"] | undefined
};
	["CustomerTabConnection"]: {
	__typename: "CustomerTabConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CustomerTabEdge"]>
};
	["CustomerTabEdge"]: {
	__typename: "CustomerTabEdge",
	node: GraphQLTypes["CustomerTab"]
};
	["CustomerTabItemConnection"]: {
	__typename: "CustomerTabItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CustomerTabItemEdge"]>
};
	["CustomerTabItemEdge"]: {
	__typename: "CustomerTabItemEdge",
	node: GraphQLTypes["CustomerTabItem"]
};
	["TableCustomerTabsByItemsUniqueWhere"]: {
		items?: GraphQLTypes["CustomerTabItemUniqueWhere"] | undefined
};
	["TableCustomerTabsByMetaUniqueWhere"]: {
		meta?: GraphQLTypes["CustomerTabMetadataUniqueWhere"] | undefined
};
	["TableSeatsByCustomerTabsUniqueWhere"]: {
		customerTabs?: GraphQLTypes["CustomerTabUniqueWhere"] | undefined
};
	["SeatConnection"]: {
	__typename: "SeatConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SeatEdge"]>
};
	["SeatEdge"]: {
	__typename: "SeatEdge",
	node: GraphQLTypes["Seat"]
};
	["Line"]: {
	__typename: "Line",
	_meta?: GraphQLTypes["LineMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	positionStartX: number,
	positionStartY: number,
	positionEndX: number,
	positionEndY: number,
	area?: GraphQLTypes["Area"] | undefined
};
	["LineMeta"]: {
	__typename: "LineMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	positionStartX?: GraphQLTypes["FieldMeta"] | undefined,
	positionStartY?: GraphQLTypes["FieldMeta"] | undefined,
	positionEndX?: GraphQLTypes["FieldMeta"] | undefined,
	positionEndY?: GraphQLTypes["FieldMeta"] | undefined,
	area?: GraphQLTypes["FieldMeta"] | undefined
};
	["LineOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	positionStartX?: GraphQLTypes["OrderDirection"] | undefined,
	positionStartY?: GraphQLTypes["OrderDirection"] | undefined,
	positionEndX?: GraphQLTypes["OrderDirection"] | undefined,
	positionEndY?: GraphQLTypes["OrderDirection"] | undefined,
	area?: GraphQLTypes["AreaOrderBy"] | undefined
};
	["AreaTablesByCustomerTabsUniqueWhere"]: {
		customerTabs?: GraphQLTypes["CustomerTabUniqueWhere"] | undefined
};
	["AreaTablesBySeatsUniqueWhere"]: {
		seats?: GraphQLTypes["SeatUniqueWhere"] | undefined
};
	["SeatUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	customerTabs?: GraphQLTypes["CustomerTabUniqueWhere"] | undefined
};
	["TableConnection"]: {
	__typename: "TableConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TableEdge"]>
};
	["TableEdge"]: {
	__typename: "TableEdge",
	node: GraphQLTypes["Table"]
};
	["LineConnection"]: {
	__typename: "LineConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LineEdge"]>
};
	["LineEdge"]: {
	__typename: "LineEdge",
	node: GraphQLTypes["Line"]
};
	["VenueTimetableDaysByDateUniqueWhere"]: {
		date?: GraphQLTypes["Date"] | undefined
};
	["VenueTimetableDaysByShiftGroupsUniqueWhere"]: {
		shiftGroups?: GraphQLTypes["TimetableShiftGroupUniqueWhere"] | undefined
};
	["VenueTimetableDaysByNotesUniqueWhere"]: {
		notes?: GraphQLTypes["TimetableDayNoteUniqueWhere"] | undefined
};
	["TimetableDayNoteUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["VenueTimetableDaysByMetaUniqueWhere"]: {
		meta?: GraphQLTypes["TimetableDayMetadataUniqueWhere"] | undefined
};
	["TimetableDayMetadataUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	day?: GraphQLTypes["TimetableDayUniqueWhere"] | undefined
};
	["TimetableDayUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	venue?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	date?: GraphQLTypes["Date"] | undefined,
	shiftGroups?: GraphQLTypes["TimetableShiftGroupUniqueWhere"] | undefined,
	notes?: GraphQLTypes["TimetableDayNoteUniqueWhere"] | undefined,
	meta?: GraphQLTypes["TimetableDayMetadataUniqueWhere"] | undefined
};
	["VenueUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	deadlineTemplate?: GraphQLTypes["DeadlineTemplateUniqueWhere"] | undefined,
	timetableDays?: GraphQLTypes["TimetableDayUniqueWhere"] | undefined,
	timetableTemplates?: GraphQLTypes["TimetableTemplateUniqueWhere"] | undefined,
	employeeRoles?: GraphQLTypes["VenueEmployeeRoleUniqueWhere"] | undefined,
	pointOfSaleApplicationDevices?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined,
	pointOfSaleTerminals?: GraphQLTypes["PointOfSaleTerminalUniqueWhere"] | undefined,
	pointOfSalePrinters?: GraphQLTypes["PointOfSalePrinterUniqueWhere"] | undefined,
	orders?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	areas?: GraphQLTypes["AreaUniqueWhere"] | undefined,
	categories?: GraphQLTypes["PointOfSaleCategoryUniqueWhere"] | undefined,
	channels?: GraphQLTypes["ChannelUniqueWhere"] | undefined
};
	["DeadlineTemplateUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	venue?: GraphQLTypes["VenueUniqueWhere"] | undefined
};
	["TimetableTemplateUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	staffOptions?: GraphQLTypes["TimetableTemplateStaffOptionsUniqueWhere"] | undefined
};
	["VenueEmployeeRoleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	venue?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	role?: GraphQLTypes["TimetableEmployeeRoleUniqueWhere"] | undefined,
	employeePrivileges?: GraphQLTypes["TimetablesEmployeePrivilegesUniqueWhere"] | undefined
};
	["TimetableEmployeeRoleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	shiftGroups?: GraphQLTypes["TimetableShiftGroupUniqueWhere"] | undefined,
	timetableTemplates?: GraphQLTypes["TimetableTemplateUniqueWhere"] | undefined
};
	["TimetablesEmployeePrivilegesUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	venueEmployeeRole?: GraphQLTypes["VenueEmployeeRoleUniqueWhere"] | undefined
};
	["PointOfSaleTerminalUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	applicationDevices?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined
};
	["PointOfSalePrinterUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	applicationDevicesReceipt?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined
};
	["AreaUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	tables?: GraphQLTypes["TableUniqueWhere"] | undefined,
	lines?: GraphQLTypes["LineUniqueWhere"] | undefined
};
	["TableUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	customerTabs?: GraphQLTypes["CustomerTabUniqueWhere"] | undefined,
	seats?: GraphQLTypes["SeatUniqueWhere"] | undefined
};
	["LineUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["ChannelUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: GraphQLTypes["ChannelCode"] | undefined,
	payments?: GraphQLTypes["ChannelPaymentUniqueWhere"] | undefined,
	deliveries?: GraphQLTypes["ChannelDeliveryUniqueWhere"] | undefined,
	carts?: GraphQLTypes["CartUniqueWhere"] | undefined
};
	["ChannelPaymentUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["VenueTimetableTemplatesByStaffOptionsUniqueWhere"]: {
		staffOptions?: GraphQLTypes["TimetableTemplateStaffOptionsUniqueWhere"] | undefined
};
	["VenueEmployeeRolesByRoleUniqueWhere"]: {
		role?: GraphQLTypes["TimetableEmployeeRoleUniqueWhere"] | undefined
};
	["VenueEmployeeRolesByEmployeePrivilegesUniqueWhere"]: {
		employeePrivileges?: GraphQLTypes["TimetablesEmployeePrivilegesUniqueWhere"] | undefined
};
	["VenuePointOfSaleApplicationDevicesByIdentifierUniqueWhere"]: {
		identifier?: GraphQLTypes["DeviceIdentifierUniqueWhere"] | undefined
};
	["VenuePointOfSaleTerminalsByApplicationDevicesUniqueWhere"]: {
		applicationDevices?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined
};
	["VenuePointOfSalePrintersByApplicationDevicesReceiptUniqueWhere"]: {
		applicationDevicesReceipt?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined
};
	["VenueOrdersBySeqUniqueWhere"]: {
		seq?: number | undefined
};
	["VenueOrdersByDoubleshotLegacyIdUniqueWhere"]: {
		doubleshotLegacyId?: string | undefined
};
	["VenueOrdersByDoubleShotLegacyNumberUniqueWhere"]: {
		doubleShotLegacyNumber?: string | undefined
};
	["VenueOrdersByDiscountsUniqueWhere"]: {
		discounts?: GraphQLTypes["OrderDiscountUniqueWhere"] | undefined
};
	["VenueOrdersByDeliveryUniqueWhere"]: {
		delivery?: GraphQLTypes["OrderDeliveryUniqueWhere"] | undefined
};
	["VenueOrdersByItemsUniqueWhere"]: {
		items?: GraphQLTypes["OrderItemUniqueWhere"] | undefined
};
	["VenueOrdersByCartUniqueWhere"]: {
		cart?: GraphQLTypes["CartUniqueWhere"] | undefined
};
	["VenueOrdersByEventsUniqueWhere"]: {
		events?: GraphQLTypes["OrderEventUniqueWhere"] | undefined
};
	["VenueOrdersByPriceLinesUniqueWhere"]: {
		priceLines?: GraphQLTypes["OrderPriceLineUniqueWhere"] | undefined
};
	["VenueOrdersByPaymentsUniqueWhere"]: {
		payments?: GraphQLTypes["OrderPaymentUniqueWhere"] | undefined
};
	["VenueOrdersBySummaryUniqueWhere"]: {
		summary?: GraphQLTypes["OrderSummaryUniqueWhere"] | undefined
};
	["VenueOrdersByGratuityUniqueWhere"]: {
		gratuity?: GraphQLTypes["GratuityUniqueWhere"] | undefined
};
	["VenueAreasByTablesUniqueWhere"]: {
		tables?: GraphQLTypes["TableUniqueWhere"] | undefined
};
	["VenueAreasByLinesUniqueWhere"]: {
		lines?: GraphQLTypes["LineUniqueWhere"] | undefined
};
	["VenueCategoriesBySlugUniqueWhere"]: {
		slug?: string | undefined
};
	["VenueCategoriesByLocalesUniqueWhere"]: {
		locales?: GraphQLTypes["PointOfSaleCategoryLocaleUniqueWhere"] | undefined
};
	["VenueCategoriesByProductsUniqueWhere"]: {
		products?: GraphQLTypes["PointOfSaleCategoryProductUniqueWhere"] | undefined
};
	["VenueChannelsByCodeUniqueWhere"]: {
		code?: GraphQLTypes["ChannelCode"] | undefined
};
	["VenueChannelsByPaymentsUniqueWhere"]: {
		payments?: GraphQLTypes["ChannelPaymentUniqueWhere"] | undefined
};
	["VenueChannelsByDeliveriesUniqueWhere"]: {
		deliveries?: GraphQLTypes["ChannelDeliveryUniqueWhere"] | undefined
};
	["VenueChannelsByCartsUniqueWhere"]: {
		carts?: GraphQLTypes["CartUniqueWhere"] | undefined
};
	["TimetableDayConnection"]: {
	__typename: "TimetableDayConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TimetableDayEdge"]>
};
	["TimetableDayEdge"]: {
	__typename: "TimetableDayEdge",
	node: GraphQLTypes["TimetableDay"]
};
	["StaffConnection"]: {
	__typename: "StaffConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["StaffEdge"]>
};
	["StaffEdge"]: {
	__typename: "StaffEdge",
	node: GraphQLTypes["Staff"]
};
	["VenueEmployeeRoleConnection"]: {
	__typename: "VenueEmployeeRoleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["VenueEmployeeRoleEdge"]>
};
	["VenueEmployeeRoleEdge"]: {
	__typename: "VenueEmployeeRoleEdge",
	node: GraphQLTypes["VenueEmployeeRole"]
};
	["PointOfSaleTerminalConnection"]: {
	__typename: "PointOfSaleTerminalConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PointOfSaleTerminalEdge"]>
};
	["PointOfSaleTerminalEdge"]: {
	__typename: "PointOfSaleTerminalEdge",
	node: GraphQLTypes["PointOfSaleTerminal"]
};
	["AreaConnection"]: {
	__typename: "AreaConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["AreaEdge"]>
};
	["AreaEdge"]: {
	__typename: "AreaEdge",
	node: GraphQLTypes["Area"]
};
	["UnassignReasonConnection"]: {
	__typename: "UnassignReasonConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["UnassignReasonEdge"]>
};
	["UnassignReasonEdge"]: {
	__typename: "UnassignReasonEdge",
	node: GraphQLTypes["UnassignReason"]
};
	["CartItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	quantity?: GraphQLTypes["OrderDirection"] | undefined,
	cart?: GraphQLTypes["CartOrderBy"] | undefined,
	product?: GraphQLTypes["ProductOrderBy"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	updatedAt?: GraphQLTypes["OrderDirection"] | undefined,
	fulfillmentNote?: GraphQLTypes["OrderDirection"] | undefined
};
	["CartItemConnection"]: {
	__typename: "CartItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CartItemEdge"]>
};
	["CartItemEdge"]: {
	__typename: "CartItemEdge",
	node: GraphQLTypes["CartItem"]
};
	["CartPriceLine"]: {
	__typename: "CartPriceLine",
	_meta?: GraphQLTypes["CartPriceLineMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	type?: GraphQLTypes["CartPriceLineType"] | undefined,
	item?: GraphQLTypes["CartItem"] | undefined,
	product?: GraphQLTypes["Product"] | undefined,
	unitPriceCents: number,
	priceCents: number,
	quantity: number,
	vatRatePermille: number,
	vatRate?: GraphQLTypes["VatRate"] | undefined,
	cart?: GraphQLTypes["Cart"] | undefined
};
	["CartPriceLineMeta"]: {
	__typename: "CartPriceLineMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	item?: GraphQLTypes["FieldMeta"] | undefined,
	product?: GraphQLTypes["FieldMeta"] | undefined,
	unitPriceCents?: GraphQLTypes["FieldMeta"] | undefined,
	priceCents?: GraphQLTypes["FieldMeta"] | undefined,
	quantity?: GraphQLTypes["FieldMeta"] | undefined,
	vatRatePermille?: GraphQLTypes["FieldMeta"] | undefined,
	vatRate?: GraphQLTypes["FieldMeta"] | undefined,
	cart?: GraphQLTypes["FieldMeta"] | undefined
};
	["CartPriceLineOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	item?: GraphQLTypes["CartItemOrderBy"] | undefined,
	product?: GraphQLTypes["ProductOrderBy"] | undefined,
	unitPriceCents?: GraphQLTypes["OrderDirection"] | undefined,
	priceCents?: GraphQLTypes["OrderDirection"] | undefined,
	quantity?: GraphQLTypes["OrderDirection"] | undefined,
	vatRatePermille?: GraphQLTypes["OrderDirection"] | undefined,
	vatRate?: GraphQLTypes["VatRateOrderBy"] | undefined,
	cart?: GraphQLTypes["CartOrderBy"] | undefined
};
	["CartSummary"]: {
	__typename: "CartSummary",
	_meta?: GraphQLTypes["CartSummaryMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	itemsPriceCents: number,
	deliveryPriceCents: number,
	totalPriceCents: number,
	itemsCount: number,
	itemsQuantity: number,
	checkoutUrl: string,
	cart?: GraphQLTypes["Cart"] | undefined
};
	["CartSummaryMeta"]: {
	__typename: "CartSummaryMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	itemsPriceCents?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryPriceCents?: GraphQLTypes["FieldMeta"] | undefined,
	totalPriceCents?: GraphQLTypes["FieldMeta"] | undefined,
	itemsCount?: GraphQLTypes["FieldMeta"] | undefined,
	itemsQuantity?: GraphQLTypes["FieldMeta"] | undefined,
	checkoutUrl?: GraphQLTypes["FieldMeta"] | undefined,
	cart?: GraphQLTypes["FieldMeta"] | undefined
};
	["CartItemsByProductUniqueWhere"]: {
		product?: GraphQLTypes["ProductUniqueWhere"] | undefined
};
	["CartPriceLineConnection"]: {
	__typename: "CartPriceLineConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CartPriceLineEdge"]>
};
	["CartPriceLineEdge"]: {
	__typename: "CartPriceLineEdge",
	node: GraphQLTypes["CartPriceLine"]
};
	["ChannelCartsByItemsUniqueWhere"]: {
		items?: GraphQLTypes["CartItemUniqueWhere"] | undefined
};
	["ChannelCartsByOrderUniqueWhere"]: {
		order?: GraphQLTypes["OrderUniqueWhere"] | undefined
};
	["ChannelCartsByPriceLinesUniqueWhere"]: {
		priceLines?: GraphQLTypes["CartPriceLineUniqueWhere"] | undefined
};
	["ChannelCartsBySummaryUniqueWhere"]: {
		summary?: GraphQLTypes["CartSummaryUniqueWhere"] | undefined
};
	["ChannelPaymentConnection"]: {
	__typename: "ChannelPaymentConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ChannelPaymentEdge"]>
};
	["ChannelPaymentEdge"]: {
	__typename: "ChannelPaymentEdge",
	node: GraphQLTypes["ChannelPayment"]
};
	["ChannelDeliveryConnection"]: {
	__typename: "ChannelDeliveryConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ChannelDeliveryEdge"]>
};
	["ChannelDeliveryEdge"]: {
	__typename: "ChannelDeliveryEdge",
	node: GraphQLTypes["ChannelDelivery"]
};
	["PointOfSaleConnection"]: {
	__typename: "PointOfSaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PointOfSaleEdge"]>
};
	["PointOfSaleEdge"]: {
	__typename: "PointOfSaleEdge",
	node: GraphQLTypes["PointOfSale"]
};
	["CartConnection"]: {
	__typename: "CartConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CartEdge"]>
};
	["CartEdge"]: {
	__typename: "CartEdge",
	node: GraphQLTypes["Cart"]
};
	["CustomerConnection"]: {
	__typename: "CustomerConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CustomerEdge"]>
};
	["CustomerEdge"]: {
	__typename: "CustomerEdge",
	node: GraphQLTypes["Customer"]
};
	["LiftagoRide"]: {
	__typename: "LiftagoRide",
	_meta?: GraphQLTypes["LiftagoRideMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	liftagoId?: string | undefined,
	data?: string | undefined,
	updatedAt?: GraphQLTypes["DateTime"] | undefined,
	delivery?: GraphQLTypes["OrderDelivery"] | undefined
};
	["LiftagoRideMeta"]: {
	__typename: "LiftagoRideMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	liftagoId?: GraphQLTypes["FieldMeta"] | undefined,
	data?: GraphQLTypes["FieldMeta"] | undefined,
	updatedAt?: GraphQLTypes["FieldMeta"] | undefined,
	delivery?: GraphQLTypes["FieldMeta"] | undefined
};
	["WoltDriveDelivery"]: {
	__typename: "WoltDriveDelivery",
	_meta?: GraphQLTypes["WoltDriveDeliveryMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	state: GraphQLTypes["WoltDriveDeliveryState"],
	shipmentPromiseId: string,
	deliveryPrice: number,
	deliveryPriceCurrency: string,
	shipmentPromiseResponse?: string | undefined,
	deliveryOrderId?: string | undefined,
	trackingUrl?: string | undefined,
	deliverOrderResponse?: string | undefined,
	delivery?: GraphQLTypes["OrderDelivery"] | undefined
};
	["WoltDriveDeliveryMeta"]: {
	__typename: "WoltDriveDeliveryMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	state?: GraphQLTypes["FieldMeta"] | undefined,
	shipmentPromiseId?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryPrice?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryPriceCurrency?: GraphQLTypes["FieldMeta"] | undefined,
	shipmentPromiseResponse?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryOrderId?: GraphQLTypes["FieldMeta"] | undefined,
	trackingUrl?: GraphQLTypes["FieldMeta"] | undefined,
	deliverOrderResponse?: GraphQLTypes["FieldMeta"] | undefined,
	delivery?: GraphQLTypes["FieldMeta"] | undefined
};
	["DeliveryRouteWaypointsByDeliveryUniqueWhere"]: {
		delivery?: GraphQLTypes["OrderDeliveryUniqueWhere"] | undefined
};
	["DeliveryWaypointConnection"]: {
	__typename: "DeliveryWaypointConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DeliveryWaypointEdge"]>
};
	["DeliveryWaypointEdge"]: {
	__typename: "DeliveryWaypointEdge",
	node: GraphQLTypes["DeliveryWaypoint"]
};
	["CourierRoutesByWaypointsUniqueWhere"]: {
		waypoints?: GraphQLTypes["DeliveryWaypointUniqueWhere"] | undefined
};
	["DeliveryRouteConnection"]: {
	__typename: "DeliveryRouteConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DeliveryRouteEdge"]>
};
	["DeliveryRouteEdge"]: {
	__typename: "DeliveryRouteEdge",
	node: GraphQLTypes["DeliveryRoute"]
};
	["DeliveryMethodConnection"]: {
	__typename: "DeliveryMethodConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DeliveryMethodEdge"]>
};
	["DeliveryMethodEdge"]: {
	__typename: "DeliveryMethodEdge",
	node: GraphQLTypes["DeliveryMethod"]
};
	["Cleaner"]: {
	__typename: "Cleaner",
	_meta?: GraphQLTypes["CleanerMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	staff?: GraphQLTypes["Staff"] | undefined,
	canReachTopShelf: boolean,
	createdAt?: GraphQLTypes["DateTime"] | undefined
};
	["CleanerMeta"]: {
	__typename: "CleanerMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	staff?: GraphQLTypes["FieldMeta"] | undefined,
	canReachTopShelf?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined
};
	["StocksManager"]: {
	__typename: "StocksManager",
	_meta?: GraphQLTypes["StocksManagerMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	staff?: GraphQLTypes["Staff"] | undefined,
	managedProducts: Array<GraphQLTypes["Product"]>,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	managedProductsByCode?: GraphQLTypes["Product"] | undefined,
	managedProductsByStocks?: GraphQLTypes["Product"] | undefined,
	managedProductsByGroupPrices?: GraphQLTypes["Product"] | undefined,
	managedProductsByCartItems?: GraphQLTypes["Product"] | undefined,
	managedProductsByOrderItems?: GraphQLTypes["Product"] | undefined,
	managedProductsByInheritedCategories?: GraphQLTypes["Product"] | undefined,
	managedProductsByLocales?: GraphQLTypes["Product"] | undefined,
	managedProductsByCustomerPrices?: GraphQLTypes["Product"] | undefined,
	managedProductsByVirtualProduct?: GraphQLTypes["Product"] | undefined,
	managedProductsByMeta?: GraphQLTypes["Product"] | undefined,
	managedProductsByPage?: GraphQLTypes["Product"] | undefined,
	managedProductsBySalesDays?: GraphQLTypes["Product"] | undefined,
	managedProductsBySalesWeeks?: GraphQLTypes["Product"] | undefined,
	managedProductsBySalesMonths?: GraphQLTypes["Product"] | undefined,
	paginateManagedProducts: GraphQLTypes["ProductConnection"]
};
	["StocksManagerMeta"]: {
	__typename: "StocksManagerMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	staff?: GraphQLTypes["FieldMeta"] | undefined,
	managedProducts?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined
};
	["StocksManagerManagedProductsByCodeUniqueWhere"]: {
		code?: string | undefined
};
	["StocksManagerManagedProductsByStocksUniqueWhere"]: {
		stocks?: GraphQLTypes["ProductStockUniqueWhere"] | undefined
};
	["StocksManagerManagedProductsByGroupPricesUniqueWhere"]: {
		groupPrices?: GraphQLTypes["ProductGroupPriceUniqueWhere"] | undefined
};
	["StocksManagerManagedProductsByCartItemsUniqueWhere"]: {
		cartItems?: GraphQLTypes["CartItemUniqueWhere"] | undefined
};
	["StocksManagerManagedProductsByOrderItemsUniqueWhere"]: {
		orderItems?: GraphQLTypes["OrderItemUniqueWhere"] | undefined
};
	["StocksManagerManagedProductsByInheritedCategoriesUniqueWhere"]: {
		inheritedCategories?: GraphQLTypes["NestedProductCategoryProductUniqueWhere"] | undefined
};
	["StocksManagerManagedProductsByLocalesUniqueWhere"]: {
		locales?: GraphQLTypes["ProductLocaleUniqueWhere"] | undefined
};
	["StocksManagerManagedProductsByCustomerPricesUniqueWhere"]: {
		customerPrices?: GraphQLTypes["ProductCustomerPriceUniqueWhere"] | undefined
};
	["StocksManagerManagedProductsByVirtualProductUniqueWhere"]: {
		virtualProduct?: GraphQLTypes["VirtualProductUniqueWhere"] | undefined
};
	["StocksManagerManagedProductsByMetaUniqueWhere"]: {
		meta?: GraphQLTypes["ProductMetadataUniqueWhere"] | undefined
};
	["StocksManagerManagedProductsByPageUniqueWhere"]: {
		page?: GraphQLTypes["PageUniqueWhere"] | undefined
};
	["StocksManagerManagedProductsBySalesDaysUniqueWhere"]: {
		salesDays?: GraphQLTypes["ProductSalesDayUniqueWhere"] | undefined
};
	["StocksManagerManagedProductsBySalesWeeksUniqueWhere"]: {
		salesWeeks?: GraphQLTypes["ProductSalesWeekUniqueWhere"] | undefined
};
	["StocksManagerManagedProductsBySalesMonthsUniqueWhere"]: {
		salesMonths?: GraphQLTypes["ProductSalesMonthUniqueWhere"] | undefined
};
	["CourierManager"]: {
	__typename: "CourierManager",
	_meta?: GraphQLTypes["CourierManagerMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	staff?: GraphQLTypes["Staff"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined
};
	["CourierManagerMeta"]: {
	__typename: "CourierManagerMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	staff?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined
};
	["Picker"]: {
	__typename: "Picker",
	_meta?: GraphQLTypes["PickerMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	staff?: GraphQLTypes["Staff"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined
};
	["PickerMeta"]: {
	__typename: "PickerMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	staff?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined
};
	["RemunerationProfile"]: {
	__typename: "RemunerationProfile",
	_meta?: GraphQLTypes["RemunerationProfileMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	employmentInformation: Array<GraphQLTypes["EmploymentInformation"]>,
	workMonths?: GraphQLTypes["WorkMonth"] | undefined,
	staff?: GraphQLTypes["Staff"] | undefined,
	paginateEmploymentInformation: GraphQLTypes["EmploymentInformationConnection"]
};
	["RemunerationProfileMeta"]: {
	__typename: "RemunerationProfileMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	employmentInformation?: GraphQLTypes["FieldMeta"] | undefined,
	workMonths?: GraphQLTypes["FieldMeta"] | undefined,
	staff?: GraphQLTypes["FieldMeta"] | undefined
};
	["EmploymentInformation"]: {
	__typename: "EmploymentInformation",
	_meta?: GraphQLTypes["EmploymentInformationMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	hourlyRate?: number | undefined,
	remunerationProfiles?: GraphQLTypes["RemunerationProfile"] | undefined,
	monthlySalary?: number | undefined,
	type: GraphQLTypes["EmploymentType"],
	name: string
};
	["EmploymentInformationMeta"]: {
	__typename: "EmploymentInformationMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	hourlyRate?: GraphQLTypes["FieldMeta"] | undefined,
	remunerationProfiles?: GraphQLTypes["FieldMeta"] | undefined,
	monthlySalary?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined
};
	["EmploymentInformationOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	hourlyRate?: GraphQLTypes["OrderDirection"] | undefined,
	remunerationProfiles?: GraphQLTypes["RemunerationProfileOrderBy"] | undefined,
	monthlySalary?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined
};
	["WorkMonth"]: {
	__typename: "WorkMonth",
	_meta?: GraphQLTypes["WorkMonthMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	year?: number | undefined,
	month?: number | undefined,
	hoursWorked?: number | undefined,
	billableHours?: number | undefined,
	remunerationProfile: Array<GraphQLTypes["RemunerationProfile"]>,
	remunerationProfileByEmploymentInformation?: GraphQLTypes["RemunerationProfile"] | undefined,
	remunerationProfileByStaff?: GraphQLTypes["RemunerationProfile"] | undefined,
	paginateRemunerationProfile: GraphQLTypes["RemunerationProfileConnection"]
};
	["WorkMonthMeta"]: {
	__typename: "WorkMonthMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	year?: GraphQLTypes["FieldMeta"] | undefined,
	month?: GraphQLTypes["FieldMeta"] | undefined,
	hoursWorked?: GraphQLTypes["FieldMeta"] | undefined,
	billableHours?: GraphQLTypes["FieldMeta"] | undefined,
	remunerationProfile?: GraphQLTypes["FieldMeta"] | undefined
};
	["WorkMonthRemunerationProfileByEmploymentInformationUniqueWhere"]: {
		employmentInformation?: GraphQLTypes["EmploymentInformationUniqueWhere"] | undefined
};
	["WorkMonthRemunerationProfileByStaffUniqueWhere"]: {
		staff?: GraphQLTypes["StaffUniqueWhere"] | undefined
};
	["RemunerationProfileConnection"]: {
	__typename: "RemunerationProfileConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["RemunerationProfileEdge"]>
};
	["RemunerationProfileEdge"]: {
	__typename: "RemunerationProfileEdge",
	node: GraphQLTypes["RemunerationProfile"]
};
	["EmploymentInformationConnection"]: {
	__typename: "EmploymentInformationConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["EmploymentInformationEdge"]>
};
	["EmploymentInformationEdge"]: {
	__typename: "EmploymentInformationEdge",
	node: GraphQLTypes["EmploymentInformation"]
};
	["Cashier"]: {
	__typename: "Cashier",
	_meta?: GraphQLTypes["CashierMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	staff?: GraphQLTypes["Staff"] | undefined
};
	["CashierMeta"]: {
	__typename: "CashierMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	staff?: GraphQLTypes["FieldMeta"] | undefined
};
	["InternalBuyer"]: {
	__typename: "InternalBuyer",
	_meta?: GraphQLTypes["InternalBuyerMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	staff?: GraphQLTypes["Staff"] | undefined
};
	["InternalBuyerMeta"]: {
	__typename: "InternalBuyerMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	staff?: GraphQLTypes["FieldMeta"] | undefined
};
	["SalesManager"]: {
	__typename: "SalesManager",
	_meta?: GraphQLTypes["SalesManagerMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	staff?: GraphQLTypes["Staff"] | undefined,
	createdAt: GraphQLTypes["DateTime"],
	countries: Array<GraphQLTypes["Country"]>,
	paginateCountries: GraphQLTypes["CountryConnection"]
};
	["SalesManagerMeta"]: {
	__typename: "SalesManagerMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	staff?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	countries?: GraphQLTypes["FieldMeta"] | undefined
};
	["CountryConnection"]: {
	__typename: "CountryConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CountryEdge"]>
};
	["CountryEdge"]: {
	__typename: "CountryEdge",
	node: GraphQLTypes["Country"]
};
	["CashierManager"]: {
	__typename: "CashierManager",
	_meta?: GraphQLTypes["CashierManagerMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	staff?: GraphQLTypes["Staff"] | undefined
};
	["CashierManagerMeta"]: {
	__typename: "CashierManagerMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	staff?: GraphQLTypes["FieldMeta"] | undefined
};
	["BusinessToBusinessManagerManagedBusinessesByCustomerUniqueWhere"]: {
		customer?: GraphQLTypes["CustomerUniqueWhere"] | undefined
};
	["BusinessToBusinessManagerManagedBusinessesByBusinessServiceEventsUniqueWhere"]: {
		businessServiceEvents?: GraphQLTypes["BusinessServiceEventUniqueWhere"] | undefined
};
	["BusinessToBusinessManagerManagedBusinessesByDoubleshotCoffeeEquipmentUniqueWhere"]: {
		doubleshotCoffeeEquipment?: GraphQLTypes["DoubleshotCoffeeEquipmentUniqueWhere"] | undefined
};
	["BusinessCustomerConnection"]: {
	__typename: "BusinessCustomerConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BusinessCustomerEdge"]>
};
	["BusinessCustomerEdge"]: {
	__typename: "BusinessCustomerEdge",
	node: GraphQLTypes["BusinessCustomer"]
};
	["BusinessServiceEvent"]: {
	__typename: "BusinessServiceEvent",
	_meta?: GraphQLTypes["BusinessServiceEventMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt: GraphQLTypes["DateTime"],
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	businessCustomer?: GraphQLTypes["BusinessCustomer"] | undefined,
	businessService?: GraphQLTypes["BusinessService"] | undefined,
	filledNumberOfPeople?: number | undefined,
	filledInvoiced?: boolean | undefined,
	filledEquipment?: string | undefined,
	filledMillTamDem?: boolean | undefined,
	filledSOEspresso?: boolean | undefined,
	filledFilterCoffeeInMenu?: boolean | undefined,
	filledWaterMeterStatus?: string | undefined,
	filledServiceAction?: string | undefined,
	filledInvoiceIdentifier?: string | undefined,
	filledNote?: string | undefined,
	filledContact?: string | undefined,
	filledPhone?: boolean | undefined,
	filledEmail?: boolean | undefined,
	filledGrindingStonesCondition?: string | undefined,
	createdBy?: GraphQLTypes["Staff"] | undefined,
	filledSupervisor?: GraphQLTypes["Staff"] | undefined
};
	["BusinessServiceEventMeta"]: {
	__typename: "BusinessServiceEventMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	fulfilledAt?: GraphQLTypes["FieldMeta"] | undefined,
	businessCustomer?: GraphQLTypes["FieldMeta"] | undefined,
	businessService?: GraphQLTypes["FieldMeta"] | undefined,
	filledNumberOfPeople?: GraphQLTypes["FieldMeta"] | undefined,
	filledInvoiced?: GraphQLTypes["FieldMeta"] | undefined,
	filledEquipment?: GraphQLTypes["FieldMeta"] | undefined,
	filledMillTamDem?: GraphQLTypes["FieldMeta"] | undefined,
	filledSOEspresso?: GraphQLTypes["FieldMeta"] | undefined,
	filledFilterCoffeeInMenu?: GraphQLTypes["FieldMeta"] | undefined,
	filledWaterMeterStatus?: GraphQLTypes["FieldMeta"] | undefined,
	filledServiceAction?: GraphQLTypes["FieldMeta"] | undefined,
	filledInvoiceIdentifier?: GraphQLTypes["FieldMeta"] | undefined,
	filledNote?: GraphQLTypes["FieldMeta"] | undefined,
	filledContact?: GraphQLTypes["FieldMeta"] | undefined,
	filledPhone?: GraphQLTypes["FieldMeta"] | undefined,
	filledEmail?: GraphQLTypes["FieldMeta"] | undefined,
	filledGrindingStonesCondition?: GraphQLTypes["FieldMeta"] | undefined,
	createdBy?: GraphQLTypes["FieldMeta"] | undefined,
	filledSupervisor?: GraphQLTypes["FieldMeta"] | undefined
};
	["BusinessService"]: {
	__typename: "BusinessService",
	_meta?: GraphQLTypes["BusinessServiceMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	requireNote?: number | undefined,
	locales: Array<GraphQLTypes["BusinessServiceLocale"]>,
	requireNumberOfPeople?: number | undefined,
	requireInvoiced?: number | undefined,
	requireEquipment?: number | undefined,
	requireMillTamDem?: number | undefined,
	requireSOEspresso?: number | undefined,
	requireFilterCoffeeInMenu?: number | undefined,
	requireWaterMeterStatus?: number | undefined,
	requireServiceAction?: number | undefined,
	optionsEquipment?: string | undefined,
	optionsServiceAction?: string | undefined,
	requireInvoiceIdentifier?: number | undefined,
	requireSupervisor?: number | undefined,
	requireContact?: number | undefined,
	requirePhone?: number | undefined,
	requireEmail?: number | undefined,
	requireGrindingStonesCondition?: number | undefined,
	localesByLocale?: GraphQLTypes["BusinessServiceLocale"] | undefined,
	paginateLocales: GraphQLTypes["BusinessServiceLocaleConnection"]
};
	["BusinessServiceMeta"]: {
	__typename: "BusinessServiceMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	requireNote?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	requireNumberOfPeople?: GraphQLTypes["FieldMeta"] | undefined,
	requireInvoiced?: GraphQLTypes["FieldMeta"] | undefined,
	requireEquipment?: GraphQLTypes["FieldMeta"] | undefined,
	requireMillTamDem?: GraphQLTypes["FieldMeta"] | undefined,
	requireSOEspresso?: GraphQLTypes["FieldMeta"] | undefined,
	requireFilterCoffeeInMenu?: GraphQLTypes["FieldMeta"] | undefined,
	requireWaterMeterStatus?: GraphQLTypes["FieldMeta"] | undefined,
	requireServiceAction?: GraphQLTypes["FieldMeta"] | undefined,
	optionsEquipment?: GraphQLTypes["FieldMeta"] | undefined,
	optionsServiceAction?: GraphQLTypes["FieldMeta"] | undefined,
	requireInvoiceIdentifier?: GraphQLTypes["FieldMeta"] | undefined,
	requireSupervisor?: GraphQLTypes["FieldMeta"] | undefined,
	requireContact?: GraphQLTypes["FieldMeta"] | undefined,
	requirePhone?: GraphQLTypes["FieldMeta"] | undefined,
	requireEmail?: GraphQLTypes["FieldMeta"] | undefined,
	requireGrindingStonesCondition?: GraphQLTypes["FieldMeta"] | undefined
};
	["BusinessServiceLocale"]: {
	__typename: "BusinessServiceLocale",
	_meta?: GraphQLTypes["BusinessServiceLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name?: string | undefined,
	labelNote?: string | undefined,
	root?: GraphQLTypes["BusinessService"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	labelNumberOfPeople?: string | undefined,
	labelInvoiced?: string | undefined,
	labelEquipment?: string | undefined,
	labelMillTamDem?: string | undefined,
	labelSOEspresso?: string | undefined,
	labelFilterCoffeeInMenu?: string | undefined,
	labelWaterMeterStatus?: string | undefined,
	labelServiceAction?: string | undefined,
	labelInvoiceIdentifier?: string | undefined,
	labelSupervisor?: string | undefined,
	labelContact?: string | undefined,
	labelPhone?: string | undefined,
	labelEmail?: string | undefined,
	labelGrindingStonesCondition?: string | undefined
};
	["BusinessServiceLocaleMeta"]: {
	__typename: "BusinessServiceLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	labelNote?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	labelNumberOfPeople?: GraphQLTypes["FieldMeta"] | undefined,
	labelInvoiced?: GraphQLTypes["FieldMeta"] | undefined,
	labelEquipment?: GraphQLTypes["FieldMeta"] | undefined,
	labelMillTamDem?: GraphQLTypes["FieldMeta"] | undefined,
	labelSOEspresso?: GraphQLTypes["FieldMeta"] | undefined,
	labelFilterCoffeeInMenu?: GraphQLTypes["FieldMeta"] | undefined,
	labelWaterMeterStatus?: GraphQLTypes["FieldMeta"] | undefined,
	labelServiceAction?: GraphQLTypes["FieldMeta"] | undefined,
	labelInvoiceIdentifier?: GraphQLTypes["FieldMeta"] | undefined,
	labelSupervisor?: GraphQLTypes["FieldMeta"] | undefined,
	labelContact?: GraphQLTypes["FieldMeta"] | undefined,
	labelPhone?: GraphQLTypes["FieldMeta"] | undefined,
	labelEmail?: GraphQLTypes["FieldMeta"] | undefined,
	labelGrindingStonesCondition?: GraphQLTypes["FieldMeta"] | undefined
};
	["BusinessServiceLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	labelNote?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["BusinessServiceOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	labelNumberOfPeople?: GraphQLTypes["OrderDirection"] | undefined,
	labelInvoiced?: GraphQLTypes["OrderDirection"] | undefined,
	labelEquipment?: GraphQLTypes["OrderDirection"] | undefined,
	labelMillTamDem?: GraphQLTypes["OrderDirection"] | undefined,
	labelSOEspresso?: GraphQLTypes["OrderDirection"] | undefined,
	labelFilterCoffeeInMenu?: GraphQLTypes["OrderDirection"] | undefined,
	labelWaterMeterStatus?: GraphQLTypes["OrderDirection"] | undefined,
	labelServiceAction?: GraphQLTypes["OrderDirection"] | undefined,
	labelInvoiceIdentifier?: GraphQLTypes["OrderDirection"] | undefined,
	labelSupervisor?: GraphQLTypes["OrderDirection"] | undefined,
	labelContact?: GraphQLTypes["OrderDirection"] | undefined,
	labelPhone?: GraphQLTypes["OrderDirection"] | undefined,
	labelEmail?: GraphQLTypes["OrderDirection"] | undefined,
	labelGrindingStonesCondition?: GraphQLTypes["OrderDirection"] | undefined
};
	["BusinessServiceOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	requireNote?: GraphQLTypes["OrderDirection"] | undefined,
	requireNumberOfPeople?: GraphQLTypes["OrderDirection"] | undefined,
	requireInvoiced?: GraphQLTypes["OrderDirection"] | undefined,
	requireEquipment?: GraphQLTypes["OrderDirection"] | undefined,
	requireMillTamDem?: GraphQLTypes["OrderDirection"] | undefined,
	requireSOEspresso?: GraphQLTypes["OrderDirection"] | undefined,
	requireFilterCoffeeInMenu?: GraphQLTypes["OrderDirection"] | undefined,
	requireWaterMeterStatus?: GraphQLTypes["OrderDirection"] | undefined,
	requireServiceAction?: GraphQLTypes["OrderDirection"] | undefined,
	optionsEquipment?: GraphQLTypes["OrderDirection"] | undefined,
	optionsServiceAction?: GraphQLTypes["OrderDirection"] | undefined,
	requireInvoiceIdentifier?: GraphQLTypes["OrderDirection"] | undefined,
	requireSupervisor?: GraphQLTypes["OrderDirection"] | undefined,
	requireContact?: GraphQLTypes["OrderDirection"] | undefined,
	requirePhone?: GraphQLTypes["OrderDirection"] | undefined,
	requireEmail?: GraphQLTypes["OrderDirection"] | undefined,
	requireGrindingStonesCondition?: GraphQLTypes["OrderDirection"] | undefined
};
	["BusinessServiceLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["BusinessServiceLocaleConnection"]: {
	__typename: "BusinessServiceLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BusinessServiceLocaleEdge"]>
};
	["BusinessServiceLocaleEdge"]: {
	__typename: "BusinessServiceLocaleEdge",
	node: GraphQLTypes["BusinessServiceLocale"]
};
	["BusinessServiceEventOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	fulfilledAt?: GraphQLTypes["OrderDirection"] | undefined,
	businessCustomer?: GraphQLTypes["BusinessCustomerOrderBy"] | undefined,
	businessService?: GraphQLTypes["BusinessServiceOrderBy"] | undefined,
	filledNumberOfPeople?: GraphQLTypes["OrderDirection"] | undefined,
	filledInvoiced?: GraphQLTypes["OrderDirection"] | undefined,
	filledEquipment?: GraphQLTypes["OrderDirection"] | undefined,
	filledMillTamDem?: GraphQLTypes["OrderDirection"] | undefined,
	filledSOEspresso?: GraphQLTypes["OrderDirection"] | undefined,
	filledFilterCoffeeInMenu?: GraphQLTypes["OrderDirection"] | undefined,
	filledWaterMeterStatus?: GraphQLTypes["OrderDirection"] | undefined,
	filledServiceAction?: GraphQLTypes["OrderDirection"] | undefined,
	filledInvoiceIdentifier?: GraphQLTypes["OrderDirection"] | undefined,
	filledNote?: GraphQLTypes["OrderDirection"] | undefined,
	filledContact?: GraphQLTypes["OrderDirection"] | undefined,
	filledPhone?: GraphQLTypes["OrderDirection"] | undefined,
	filledEmail?: GraphQLTypes["OrderDirection"] | undefined,
	filledGrindingStonesCondition?: GraphQLTypes["OrderDirection"] | undefined,
	createdBy?: GraphQLTypes["StaffOrderBy"] | undefined,
	filledSupervisor?: GraphQLTypes["StaffOrderBy"] | undefined
};
	["DoubleshotCoffeeEquipment"]: {
	__typename: "DoubleshotCoffeeEquipment",
	_meta?: GraphQLTypes["DoubleshotCoffeeEquipmentMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	espressoMachine?: string | undefined,
	espressoGrinder?: string | undefined,
	batchBrew?: string | undefined,
	batchGrinder?: string | undefined,
	waterFilter?: string | undefined,
	mechanicalFilter?: string | undefined
};
	["DoubleshotCoffeeEquipmentMeta"]: {
	__typename: "DoubleshotCoffeeEquipmentMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	espressoMachine?: GraphQLTypes["FieldMeta"] | undefined,
	espressoGrinder?: GraphQLTypes["FieldMeta"] | undefined,
	batchBrew?: GraphQLTypes["FieldMeta"] | undefined,
	batchGrinder?: GraphQLTypes["FieldMeta"] | undefined,
	waterFilter?: GraphQLTypes["FieldMeta"] | undefined,
	mechanicalFilter?: GraphQLTypes["FieldMeta"] | undefined
};
	["BusinessServiceEventConnection"]: {
	__typename: "BusinessServiceEventConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BusinessServiceEventEdge"]>
};
	["BusinessServiceEventEdge"]: {
	__typename: "BusinessServiceEventEdge",
	node: GraphQLTypes["BusinessServiceEvent"]
};
	["OrderRecurrence"]: {
	__typename: "OrderRecurrence",
	_meta?: GraphQLTypes["OrderRecurrenceMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	internalName: string,
	locales: Array<GraphQLTypes["OrderRecurrenceLocale"]>,
	order: number,
	businessCategory: Array<GraphQLTypes["BusinessCategory"]>,
	localesByLocale?: GraphQLTypes["OrderRecurrenceLocale"] | undefined,
	paginateLocales: GraphQLTypes["OrderRecurrenceLocaleConnection"],
	paginateBusinessCategory: GraphQLTypes["BusinessCategoryConnection"]
};
	["OrderRecurrenceMeta"]: {
	__typename: "OrderRecurrenceMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	internalName?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	businessCategory?: GraphQLTypes["FieldMeta"] | undefined
};
	["OrderRecurrenceLocale"]: {
	__typename: "OrderRecurrenceLocale",
	_meta?: GraphQLTypes["OrderRecurrenceLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	root?: GraphQLTypes["OrderRecurrence"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined
};
	["OrderRecurrenceLocaleMeta"]: {
	__typename: "OrderRecurrenceLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined
};
	["OrderRecurrenceLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["OrderRecurrenceOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined
};
	["OrderRecurrenceOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	internalName?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined
};
	["OrderRecurrenceLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["OrderRecurrenceLocaleConnection"]: {
	__typename: "OrderRecurrenceLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["OrderRecurrenceLocaleEdge"]>
};
	["OrderRecurrenceLocaleEdge"]: {
	__typename: "OrderRecurrenceLocaleEdge",
	node: GraphQLTypes["OrderRecurrenceLocale"]
};
	["BusinessCategoryConnection"]: {
	__typename: "BusinessCategoryConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BusinessCategoryEdge"]>
};
	["BusinessCategoryEdge"]: {
	__typename: "BusinessCategoryEdge",
	node: GraphQLTypes["BusinessCategory"]
};
	["ProductList"]: {
	__typename: "ProductList",
	_meta?: GraphQLTypes["ProductListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["ProductListItem"]>,
	businessCategory?: GraphQLTypes["BusinessCategory"] | undefined,
	paginateItems: GraphQLTypes["ProductListItemConnection"]
};
	["ProductListMeta"]: {
	__typename: "ProductListMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined,
	businessCategory?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductListItem"]: {
	__typename: "ProductListItem",
	_meta?: GraphQLTypes["ProductListItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["ProductList"] | undefined,
	product?: GraphQLTypes["Product"] | undefined,
	defaultQuantityForOrder?: number | undefined
};
	["ProductListItemMeta"]: {
	__typename: "ProductListItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	product?: GraphQLTypes["FieldMeta"] | undefined,
	defaultQuantityForOrder?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductListItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	list?: GraphQLTypes["ProductListOrderBy"] | undefined,
	product?: GraphQLTypes["ProductOrderBy"] | undefined,
	defaultQuantityForOrder?: GraphQLTypes["OrderDirection"] | undefined
};
	["ProductListItemConnection"]: {
	__typename: "ProductListItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductListItemEdge"]>
};
	["ProductListItemEdge"]: {
	__typename: "ProductListItemEdge",
	node: GraphQLTypes["ProductListItem"]
};
	["ProductCategoryList"]: {
	__typename: "ProductCategoryList",
	_meta?: GraphQLTypes["ProductCategoryListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["ProductCategoryListItem"]>,
	locales: Array<GraphQLTypes["ProductCategoryListLocale"]>,
	seasonalProductCategoriesOfBusinessCategory?: GraphQLTypes["BusinessCategory"] | undefined,
	specificProductsProductCategoriesOfBusinessCategory?: GraphQLTypes["BusinessCategory"] | undefined,
	localesByLocale?: GraphQLTypes["ProductCategoryListLocale"] | undefined,
	paginateItems: GraphQLTypes["ProductCategoryListItemConnection"],
	paginateLocales: GraphQLTypes["ProductCategoryListLocaleConnection"]
};
	["ProductCategoryListMeta"]: {
	__typename: "ProductCategoryListMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	seasonalProductCategoriesOfBusinessCategory?: GraphQLTypes["FieldMeta"] | undefined,
	specificProductsProductCategoriesOfBusinessCategory?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductCategoryListItem"]: {
	__typename: "ProductCategoryListItem",
	_meta?: GraphQLTypes["ProductCategoryListItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["ProductCategoryList"] | undefined,
	productCategory?: GraphQLTypes["ProductCategory"] | undefined,
	showRecipeImages: boolean,
	showPackingImages: boolean,
	showAllAvailableProducts: boolean
};
	["ProductCategoryListItemMeta"]: {
	__typename: "ProductCategoryListItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	productCategory?: GraphQLTypes["FieldMeta"] | undefined,
	showRecipeImages?: GraphQLTypes["FieldMeta"] | undefined,
	showPackingImages?: GraphQLTypes["FieldMeta"] | undefined,
	showAllAvailableProducts?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductCategoryListItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	list?: GraphQLTypes["ProductCategoryListOrderBy"] | undefined,
	productCategory?: GraphQLTypes["ProductCategoryOrderBy"] | undefined,
	showRecipeImages?: GraphQLTypes["OrderDirection"] | undefined,
	showPackingImages?: GraphQLTypes["OrderDirection"] | undefined,
	showAllAvailableProducts?: GraphQLTypes["OrderDirection"] | undefined
};
	["ProductCategoryListLocale"]: {
	__typename: "ProductCategoryListLocale",
	_meta?: GraphQLTypes["ProductCategoryListLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	root?: GraphQLTypes["ProductCategoryList"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined
};
	["ProductCategoryListLocaleMeta"]: {
	__typename: "ProductCategoryListLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductCategoryListLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["ProductCategoryListOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined
};
	["ProductCategoryListLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["ProductCategoryListItemConnection"]: {
	__typename: "ProductCategoryListItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductCategoryListItemEdge"]>
};
	["ProductCategoryListItemEdge"]: {
	__typename: "ProductCategoryListItemEdge",
	node: GraphQLTypes["ProductCategoryListItem"]
};
	["ProductCategoryListLocaleConnection"]: {
	__typename: "ProductCategoryListLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductCategoryListLocaleEdge"]>
};
	["ProductCategoryListLocaleEdge"]: {
	__typename: "ProductCategoryListLocaleEdge",
	node: GraphQLTypes["ProductCategoryListLocale"]
};
	["BusinessCategoryLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["BusinessCategoryBusinessCustomersByCustomerUniqueWhere"]: {
		customer?: GraphQLTypes["CustomerUniqueWhere"] | undefined
};
	["BusinessCategoryBusinessCustomersByBusinessServiceEventsUniqueWhere"]: {
		businessServiceEvents?: GraphQLTypes["BusinessServiceEventUniqueWhere"] | undefined
};
	["BusinessCategoryBusinessCustomersByDoubleshotCoffeeEquipmentUniqueWhere"]: {
		doubleshotCoffeeEquipment?: GraphQLTypes["DoubleshotCoffeeEquipmentUniqueWhere"] | undefined
};
	["BusinessCategoryLocaleConnection"]: {
	__typename: "BusinessCategoryLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BusinessCategoryLocaleEdge"]>
};
	["BusinessCategoryLocaleEdge"]: {
	__typename: "BusinessCategoryLocaleEdge",
	node: GraphQLTypes["BusinessCategoryLocale"]
};
	["OrderRecurrenceConnection"]: {
	__typename: "OrderRecurrenceConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["OrderRecurrenceEdge"]>
};
	["OrderRecurrenceEdge"]: {
	__typename: "OrderRecurrenceEdge",
	node: GraphQLTypes["OrderRecurrence"]
};
	["ProductIngredientLocale"]: {
	__typename: "ProductIngredientLocale",
	_meta?: GraphQLTypes["ProductIngredientLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	root?: GraphQLTypes["ProductIngredient"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined
};
	["ProductIngredientLocaleMeta"]: {
	__typename: "ProductIngredientLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductIngredient"]: {
	__typename: "ProductIngredient",
	_meta?: GraphQLTypes["ProductIngredientMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	internalNote?: string | undefined,
	locales: Array<GraphQLTypes["ProductIngredientLocale"]>,
	internalName: string,
	categories: Array<GraphQLTypes["ProductIngredientCategory"]>,
	allergens: Array<GraphQLTypes["Allergen"]>,
	needsPrepping: boolean,
	allowCustomerRating?: boolean | undefined,
	customerRatings: Array<GraphQLTypes["CustomerIngredientRating"]>,
	preferredQuantityUnit?: GraphQLTypes["ProductIngredientItemQuantityUnit"] | undefined,
	freshingContainer?: GraphQLTypes["FreshingContainer"] | undefined,
	image?: GraphQLTypes["Image"] | undefined,
	suppliers?: GraphQLTypes["IngredientSupplierList"] | undefined,
	incrementQuantityNumber: number,
	localesByLocale?: GraphQLTypes["ProductIngredientLocale"] | undefined,
	customerRatingsByCustomer?: GraphQLTypes["CustomerIngredientRating"] | undefined,
	paginateLocales: GraphQLTypes["ProductIngredientLocaleConnection"],
	paginateCategories: GraphQLTypes["ProductIngredientCategoryConnection"],
	paginateAllergens: GraphQLTypes["AllergenConnection"],
	paginateCustomerRatings: GraphQLTypes["CustomerIngredientRatingConnection"]
};
	["ProductIngredientMeta"]: {
	__typename: "ProductIngredientMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	internalName?: GraphQLTypes["FieldMeta"] | undefined,
	categories?: GraphQLTypes["FieldMeta"] | undefined,
	allergens?: GraphQLTypes["FieldMeta"] | undefined,
	needsPrepping?: GraphQLTypes["FieldMeta"] | undefined,
	allowCustomerRating?: GraphQLTypes["FieldMeta"] | undefined,
	customerRatings?: GraphQLTypes["FieldMeta"] | undefined,
	preferredQuantityUnit?: GraphQLTypes["FieldMeta"] | undefined,
	freshingContainer?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined,
	suppliers?: GraphQLTypes["FieldMeta"] | undefined,
	incrementQuantityNumber?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductIngredientLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["ProductIngredientOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined
};
	["ProductIngredientOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	internalNote?: GraphQLTypes["OrderDirection"] | undefined,
	internalName?: GraphQLTypes["OrderDirection"] | undefined,
	needsPrepping?: GraphQLTypes["OrderDirection"] | undefined,
	allowCustomerRating?: GraphQLTypes["OrderDirection"] | undefined,
	preferredQuantityUnit?: GraphQLTypes["ProductIngredientItemQuantityUnitOrderBy"] | undefined,
	freshingContainer?: GraphQLTypes["FreshingContainerOrderBy"] | undefined,
	image?: GraphQLTypes["ImageOrderBy"] | undefined,
	suppliers?: GraphQLTypes["IngredientSupplierListOrderBy"] | undefined,
	incrementQuantityNumber?: GraphQLTypes["OrderDirection"] | undefined
};
	["ProductIngredientItemQuantityUnitOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined
};
	["IngredientSupplierListOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined
};
	["ProductIngredientCategory"]: {
	__typename: "ProductIngredientCategory",
	_meta?: GraphQLTypes["ProductIngredientCategoryMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	internalName: string,
	internalNote?: string | undefined,
	ingredients: Array<GraphQLTypes["ProductIngredient"]>,
	locales: Array<GraphQLTypes["ProductIngredientCategoryLocale"]>,
	order: number,
	localesByLocale?: GraphQLTypes["ProductIngredientCategoryLocale"] | undefined,
	paginateIngredients: GraphQLTypes["ProductIngredientConnection"],
	paginateLocales: GraphQLTypes["ProductIngredientCategoryLocaleConnection"]
};
	["ProductIngredientCategoryMeta"]: {
	__typename: "ProductIngredientCategoryMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	internalName?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	ingredients?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductIngredientCategoryLocale"]: {
	__typename: "ProductIngredientCategoryLocale",
	_meta?: GraphQLTypes["ProductIngredientCategoryLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	root?: GraphQLTypes["ProductIngredientCategory"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined
};
	["ProductIngredientCategoryLocaleMeta"]: {
	__typename: "ProductIngredientCategoryLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductIngredientCategoryLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["ProductIngredientCategoryOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined
};
	["ProductIngredientCategoryOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	internalName?: GraphQLTypes["OrderDirection"] | undefined,
	internalNote?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined
};
	["ProductIngredientCategoryLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["ProductIngredientConnection"]: {
	__typename: "ProductIngredientConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductIngredientEdge"]>
};
	["ProductIngredientEdge"]: {
	__typename: "ProductIngredientEdge",
	node: GraphQLTypes["ProductIngredient"]
};
	["ProductIngredientCategoryLocaleConnection"]: {
	__typename: "ProductIngredientCategoryLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductIngredientCategoryLocaleEdge"]>
};
	["ProductIngredientCategoryLocaleEdge"]: {
	__typename: "ProductIngredientCategoryLocaleEdge",
	node: GraphQLTypes["ProductIngredientCategoryLocale"]
};
	["Allergen"]: {
	__typename: "Allergen",
	_meta?: GraphQLTypes["AllergenMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	internalName: string,
	locales: Array<GraphQLTypes["AllergenLocale"]>,
	ingredients: Array<GraphQLTypes["ProductIngredient"]>,
	code: number,
	localesByLocale?: GraphQLTypes["AllergenLocale"] | undefined,
	paginateLocales: GraphQLTypes["AllergenLocaleConnection"],
	paginateIngredients: GraphQLTypes["ProductIngredientConnection"]
};
	["AllergenMeta"]: {
	__typename: "AllergenMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	internalName?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	ingredients?: GraphQLTypes["FieldMeta"] | undefined,
	code?: GraphQLTypes["FieldMeta"] | undefined
};
	["AllergenLocale"]: {
	__typename: "AllergenLocale",
	_meta?: GraphQLTypes["AllergenLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name?: string | undefined,
	root?: GraphQLTypes["Allergen"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined
};
	["AllergenLocaleMeta"]: {
	__typename: "AllergenLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined
};
	["AllergenLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["AllergenOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined
};
	["AllergenOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	internalName?: GraphQLTypes["OrderDirection"] | undefined,
	code?: GraphQLTypes["OrderDirection"] | undefined
};
	["AllergenLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["AllergenLocaleConnection"]: {
	__typename: "AllergenLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["AllergenLocaleEdge"]>
};
	["AllergenLocaleEdge"]: {
	__typename: "AllergenLocaleEdge",
	node: GraphQLTypes["AllergenLocale"]
};
	["CustomerIngredientRating"]: {
	__typename: "CustomerIngredientRating",
	_meta?: GraphQLTypes["CustomerIngredientRatingMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	customer?: GraphQLTypes["Customer"] | undefined,
	rating?: GraphQLTypes["ProductIngredientRating"] | undefined,
	ingredient?: GraphQLTypes["ProductIngredient"] | undefined
};
	["CustomerIngredientRatingMeta"]: {
	__typename: "CustomerIngredientRatingMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined,
	rating?: GraphQLTypes["FieldMeta"] | undefined,
	ingredient?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductIngredientRating"]: {
	__typename: "ProductIngredientRating",
	_meta?: GraphQLTypes["ProductIngredientRatingMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	name: string,
	icon?: GraphQLTypes["Image"] | undefined
};
	["ProductIngredientRatingMeta"]: {
	__typename: "ProductIngredientRatingMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	icon?: GraphQLTypes["FieldMeta"] | undefined
};
	["CustomerIngredientRatingOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	customer?: GraphQLTypes["CustomerOrderBy"] | undefined,
	rating?: GraphQLTypes["ProductIngredientRatingOrderBy"] | undefined,
	ingredient?: GraphQLTypes["ProductIngredientOrderBy"] | undefined
};
	["ProductIngredientRatingOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	icon?: GraphQLTypes["ImageOrderBy"] | undefined
};
	["ProductIngredientItemQuantityUnit"]: {
	__typename: "ProductIngredientItemQuantityUnit",
	_meta?: GraphQLTypes["ProductIngredientItemQuantityUnitMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string
};
	["ProductIngredientItemQuantityUnitMeta"]: {
	__typename: "ProductIngredientItemQuantityUnitMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined
};
	["FreshingContainer"]: {
	__typename: "FreshingContainer",
	_meta?: GraphQLTypes["FreshingContainerMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	volumeMl: number,
	workspace?: GraphQLTypes["Workspace"] | undefined
};
	["FreshingContainerMeta"]: {
	__typename: "FreshingContainerMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	volumeMl?: GraphQLTypes["FieldMeta"] | undefined,
	workspace?: GraphQLTypes["FieldMeta"] | undefined
};
	["Workspace"]: {
	__typename: "Workspace",
	_meta?: GraphQLTypes["WorkspaceMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	orderDeadlineTime?: string | undefined,
	ordersLoadingDurationHours: number,
	freshingContainerVolumeMl: number,
	freshingPrepareOrderByOffsetMinutes: number,
	checkoutUrlTemplate?: string | undefined,
	orderUrlTemplate?: string | undefined,
	paymentUrlTemplate?: string | undefined,
	customerProfileUrlTemplate?: string | undefined,
	userProfileUrlTemplate?: string | undefined,
	messengerUrl?: string | undefined,
	messengerIosUrl?: string | undefined,
	messengerAndroidUrl?: string | undefined,
	freshingContainers: Array<GraphQLTypes["FreshingContainer"]>,
	openingHours?: GraphQLTypes["WeekHours"] | undefined,
	workingHours?: GraphQLTypes["WeekHours"] | undefined,
	defaultFreshingContainer?: GraphQLTypes["FreshingContainer"] | undefined,
	creditsProduct?: GraphQLTypes["VirtualProduct"] | undefined,
	discountVatRate?: GraphQLTypes["VatRate"] | undefined,
	name: string,
	businessAddress?: string | undefined,
	paginateFreshingContainers: GraphQLTypes["FreshingContainerConnection"]
};
	["WorkspaceMeta"]: {
	__typename: "WorkspaceMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	unique?: GraphQLTypes["FieldMeta"] | undefined,
	orderDeadlineTime?: GraphQLTypes["FieldMeta"] | undefined,
	ordersLoadingDurationHours?: GraphQLTypes["FieldMeta"] | undefined,
	freshingContainerVolumeMl?: GraphQLTypes["FieldMeta"] | undefined,
	freshingPrepareOrderByOffsetMinutes?: GraphQLTypes["FieldMeta"] | undefined,
	checkoutUrlTemplate?: GraphQLTypes["FieldMeta"] | undefined,
	orderUrlTemplate?: GraphQLTypes["FieldMeta"] | undefined,
	paymentUrlTemplate?: GraphQLTypes["FieldMeta"] | undefined,
	customerProfileUrlTemplate?: GraphQLTypes["FieldMeta"] | undefined,
	userProfileUrlTemplate?: GraphQLTypes["FieldMeta"] | undefined,
	messengerUrl?: GraphQLTypes["FieldMeta"] | undefined,
	messengerIosUrl?: GraphQLTypes["FieldMeta"] | undefined,
	messengerAndroidUrl?: GraphQLTypes["FieldMeta"] | undefined,
	freshingContainers?: GraphQLTypes["FieldMeta"] | undefined,
	openingHours?: GraphQLTypes["FieldMeta"] | undefined,
	workingHours?: GraphQLTypes["FieldMeta"] | undefined,
	defaultFreshingContainer?: GraphQLTypes["FieldMeta"] | undefined,
	creditsProduct?: GraphQLTypes["FieldMeta"] | undefined,
	discountVatRate?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	businessAddress?: GraphQLTypes["FieldMeta"] | undefined
};
	["WeekHours"]: {
	__typename: "WeekHours",
	_meta?: GraphQLTypes["WeekHoursMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	mon?: string | undefined,
	tue?: string | undefined,
	wed?: string | undefined,
	thu?: string | undefined,
	fri?: string | undefined,
	sat?: string | undefined,
	sun?: string | undefined
};
	["WeekHoursMeta"]: {
	__typename: "WeekHoursMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	mon?: GraphQLTypes["FieldMeta"] | undefined,
	tue?: GraphQLTypes["FieldMeta"] | undefined,
	wed?: GraphQLTypes["FieldMeta"] | undefined,
	thu?: GraphQLTypes["FieldMeta"] | undefined,
	fri?: GraphQLTypes["FieldMeta"] | undefined,
	sat?: GraphQLTypes["FieldMeta"] | undefined,
	sun?: GraphQLTypes["FieldMeta"] | undefined
};
	["VirtualProduct"]: {
	__typename: "VirtualProduct",
	_meta?: GraphQLTypes["VirtualProductMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["VirtualProductType"],
	product?: GraphQLTypes["Product"] | undefined,
	voucherCreditCents?: number | undefined,
	physicalRepresentation: GraphQLTypes["VirtualProductPhysicalRepresentationType"],
	recipientEmail?: boolean | undefined
};
	["VirtualProductMeta"]: {
	__typename: "VirtualProductMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	product?: GraphQLTypes["FieldMeta"] | undefined,
	voucherCreditCents?: GraphQLTypes["FieldMeta"] | undefined,
	physicalRepresentation?: GraphQLTypes["FieldMeta"] | undefined,
	recipientEmail?: GraphQLTypes["FieldMeta"] | undefined
};
	["FreshingContainerConnection"]: {
	__typename: "FreshingContainerConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FreshingContainerEdge"]>
};
	["FreshingContainerEdge"]: {
	__typename: "FreshingContainerEdge",
	node: GraphQLTypes["FreshingContainer"]
};
	["IngredientSupplierList"]: {
	__typename: "IngredientSupplierList",
	_meta?: GraphQLTypes["IngredientSupplierListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["IngredientSupplierItem"]>,
	paginateItems: GraphQLTypes["IngredientSupplierItemConnection"]
};
	["IngredientSupplierListMeta"]: {
	__typename: "IngredientSupplierListMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["IngredientSupplierItem"]: {
	__typename: "IngredientSupplierItem",
	_meta?: GraphQLTypes["IngredientSupplierItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["IngredientSupplierList"] | undefined,
	supplier?: GraphQLTypes["IngredientSupplier"] | undefined
};
	["IngredientSupplierItemMeta"]: {
	__typename: "IngredientSupplierItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	supplier?: GraphQLTypes["FieldMeta"] | undefined
};
	["IngredientSupplier"]: {
	__typename: "IngredientSupplier",
	_meta?: GraphQLTypes["IngredientSupplierMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	internalName: string,
	internalNote?: string | undefined,
	locales: Array<GraphQLTypes["IngredientSupplierLocale"]>,
	localesByLocale?: GraphQLTypes["IngredientSupplierLocale"] | undefined,
	paginateLocales: GraphQLTypes["IngredientSupplierLocaleConnection"]
};
	["IngredientSupplierMeta"]: {
	__typename: "IngredientSupplierMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	internalName?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined
};
	["IngredientSupplierLocale"]: {
	__typename: "IngredientSupplierLocale",
	_meta?: GraphQLTypes["IngredientSupplierLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	root?: GraphQLTypes["IngredientSupplier"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined
};
	["IngredientSupplierLocaleMeta"]: {
	__typename: "IngredientSupplierLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined
};
	["IngredientSupplierLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["IngredientSupplierOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined
};
	["IngredientSupplierOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	internalName?: GraphQLTypes["OrderDirection"] | undefined,
	internalNote?: GraphQLTypes["OrderDirection"] | undefined
};
	["IngredientSupplierLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["IngredientSupplierLocaleConnection"]: {
	__typename: "IngredientSupplierLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["IngredientSupplierLocaleEdge"]>
};
	["IngredientSupplierLocaleEdge"]: {
	__typename: "IngredientSupplierLocaleEdge",
	node: GraphQLTypes["IngredientSupplierLocale"]
};
	["IngredientSupplierItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	list?: GraphQLTypes["IngredientSupplierListOrderBy"] | undefined,
	supplier?: GraphQLTypes["IngredientSupplierOrderBy"] | undefined
};
	["IngredientSupplierItemConnection"]: {
	__typename: "IngredientSupplierItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["IngredientSupplierItemEdge"]>
};
	["IngredientSupplierItemEdge"]: {
	__typename: "IngredientSupplierItemEdge",
	node: GraphQLTypes["IngredientSupplierItem"]
};
	["ProductIngredientLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["ProductIngredientCustomerRatingsByCustomerUniqueWhere"]: {
		customer?: GraphQLTypes["CustomerUniqueWhere"] | undefined
};
	["ProductIngredientLocaleConnection"]: {
	__typename: "ProductIngredientLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductIngredientLocaleEdge"]>
};
	["ProductIngredientLocaleEdge"]: {
	__typename: "ProductIngredientLocaleEdge",
	node: GraphQLTypes["ProductIngredientLocale"]
};
	["ProductIngredientCategoryConnection"]: {
	__typename: "ProductIngredientCategoryConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductIngredientCategoryEdge"]>
};
	["ProductIngredientCategoryEdge"]: {
	__typename: "ProductIngredientCategoryEdge",
	node: GraphQLTypes["ProductIngredientCategory"]
};
	["AllergenConnection"]: {
	__typename: "AllergenConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["AllergenEdge"]>
};
	["AllergenEdge"]: {
	__typename: "AllergenEdge",
	node: GraphQLTypes["Allergen"]
};
	["CustomerIngredientRatingConnection"]: {
	__typename: "CustomerIngredientRatingConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CustomerIngredientRatingEdge"]>
};
	["CustomerIngredientRatingEdge"]: {
	__typename: "CustomerIngredientRatingEdge",
	node: GraphQLTypes["CustomerIngredientRating"]
};
	["BlogLocale"]: {
	__typename: "BlogLocale",
	_meta?: GraphQLTypes["BlogLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	pageName?: string | undefined,
	title?: string | undefined,
	lead?: string | undefined,
	root?: GraphQLTypes["Blog"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined
};
	["BlogLocaleMeta"]: {
	__typename: "BlogLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	pageName?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	lead?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined
};
	["Blog"]: {
	__typename: "Blog",
	_meta?: GraphQLTypes["BlogMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	locales: Array<GraphQLTypes["BlogLocale"]>,
	localesByLocale?: GraphQLTypes["BlogLocale"] | undefined,
	paginateLocales: GraphQLTypes["BlogLocaleConnection"]
};
	["BlogMeta"]: {
	__typename: "BlogMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	unique?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined
};
	["BlogLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	pageName?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	lead?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["BlogOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined
};
	["BlogOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	unique?: GraphQLTypes["OrderDirection"] | undefined
};
	["BlogLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["BlogLocaleConnection"]: {
	__typename: "BlogLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BlogLocaleEdge"]>
};
	["BlogLocaleEdge"]: {
	__typename: "BlogLocaleEdge",
	node: GraphQLTypes["BlogLocale"]
};
	["BlogPostLocale"]: {
	__typename: "BlogPostLocale",
	_meta?: GraphQLTypes["BlogPostLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	title?: string | undefined,
	availableForWeb?: boolean | undefined,
	availableForMobile?: boolean | undefined,
	root?: GraphQLTypes["BlogPost"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	cover?: GraphQLTypes["Cover"] | undefined,
	content?: GraphQLTypes["Content"] | undefined,
	link?: GraphQLTypes["Linkable"] | undefined,
	seo?: GraphQLTypes["Seo"] | undefined,
	products: Array<GraphQLTypes["Product"]>,
	paginateProducts: GraphQLTypes["ProductConnection"]
};
	["BlogPostLocaleMeta"]: {
	__typename: "BlogPostLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	availableForWeb?: GraphQLTypes["FieldMeta"] | undefined,
	availableForMobile?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	cover?: GraphQLTypes["FieldMeta"] | undefined,
	content?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined,
	seo?: GraphQLTypes["FieldMeta"] | undefined,
	products?: GraphQLTypes["FieldMeta"] | undefined
};
	["BlogPost"]: {
	__typename: "BlogPost",
	_meta?: GraphQLTypes["BlogPostMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	locales: Array<GraphQLTypes["BlogPostLocale"]>,
	localesByLocale?: GraphQLTypes["BlogPostLocale"] | undefined,
	localesByCover?: GraphQLTypes["BlogPostLocale"] | undefined,
	localesByContent?: GraphQLTypes["BlogPostLocale"] | undefined,
	localesByLink?: GraphQLTypes["BlogPostLocale"] | undefined,
	localesBySeo?: GraphQLTypes["BlogPostLocale"] | undefined,
	paginateLocales: GraphQLTypes["BlogPostLocaleConnection"]
};
	["BlogPostMeta"]: {
	__typename: "BlogPostMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined
};
	["BlogPostLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	availableForWeb?: GraphQLTypes["OrderDirection"] | undefined,
	availableForMobile?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["BlogPostOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	cover?: GraphQLTypes["CoverOrderBy"] | undefined,
	content?: GraphQLTypes["ContentOrderBy"] | undefined,
	link?: GraphQLTypes["LinkableOrderBy"] | undefined,
	seo?: GraphQLTypes["SeoOrderBy"] | undefined
};
	["BlogPostOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined
};
	["CoverOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	primaryTitle?: GraphQLTypes["OrderDirection"] | undefined,
	secondaryTitle?: GraphQLTypes["OrderDirection"] | undefined,
	medium?: GraphQLTypes["MediumOrderBy"] | undefined,
	buttonColors?: GraphQLTypes["ColorPalleteOrderBy"] | undefined
};
	["MediumOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	colorTheme?: GraphQLTypes["OrderDirection"] | undefined,
	image?: GraphQLTypes["ImageOrderBy"] | undefined,
	video?: GraphQLTypes["VideoOrderBy"] | undefined
};
	["VideoOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	src?: GraphQLTypes["OrderDirection"] | undefined,
	width?: GraphQLTypes["OrderDirection"] | undefined,
	height?: GraphQLTypes["OrderDirection"] | undefined,
	size?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	duration?: GraphQLTypes["OrderDirection"] | undefined,
	poster?: GraphQLTypes["ImageOrderBy"] | undefined
};
	["ColorPalleteOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	background?: GraphQLTypes["OrderDirection"] | undefined,
	text?: GraphQLTypes["OrderDirection"] | undefined
};
	["ContentOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined
};
	["LinkableOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	url?: GraphQLTypes["OrderDirection"] | undefined,
	blogPost?: GraphQLTypes["BlogPostLocaleOrderBy"] | undefined,
	page?: GraphQLTypes["PageLocaleOrderBy"] | undefined,
	wikiPage?: GraphQLTypes["WikiPageOrderBy"] | undefined,
	redirect?: GraphQLTypes["RedirectOrderBy"] | undefined
};
	["PageLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	link?: GraphQLTypes["LinkableOrderBy"] | undefined,
	root?: GraphQLTypes["PageOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	seo?: GraphQLTypes["SeoOrderBy"] | undefined,
	content?: GraphQLTypes["ContentOrderBy"] | undefined,
	cover?: GraphQLTypes["CoverOrderBy"] | undefined,
	theme?: GraphQLTypes["OrderDirection"] | undefined
};
	["SeoOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	description?: GraphQLTypes["OrderDirection"] | undefined,
	ogTitle?: GraphQLTypes["OrderDirection"] | undefined,
	ogDescription?: GraphQLTypes["OrderDirection"] | undefined,
	ogImage?: GraphQLTypes["ImageOrderBy"] | undefined
};
	["WikiPageOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	emoji?: GraphQLTypes["OrderDirection"] | undefined,
	link?: GraphQLTypes["LinkableOrderBy"] | undefined,
	parent?: GraphQLTypes["WikiPageOrderBy"] | undefined,
	content?: GraphQLTypes["ContentOrderBy"] | undefined
};
	["RedirectOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	link?: GraphQLTypes["LinkableOrderBy"] | undefined,
	target?: GraphQLTypes["LinkOrderBy"] | undefined
};
	["LinkOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	externalLink?: GraphQLTypes["OrderDirection"] | undefined,
	internalLink?: GraphQLTypes["LinkableOrderBy"] | undefined
};
	["BlogPostLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["BlogPostLocalesByCoverUniqueWhere"]: {
		cover?: GraphQLTypes["CoverUniqueWhere"] | undefined
};
	["BlogPostLocalesByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["BlogPostLocalesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"] | undefined
};
	["BlogPostLocalesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["BlogPostLocaleConnection"]: {
	__typename: "BlogPostLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BlogPostLocaleEdge"]>
};
	["BlogPostLocaleEdge"]: {
	__typename: "BlogPostLocaleEdge",
	node: GraphQLTypes["BlogPostLocale"]
};
	["Cover"]: {
	__typename: "Cover",
	_meta?: GraphQLTypes["CoverMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	primaryTitle?: string | undefined,
	secondaryTitle?: string | undefined,
	medium?: GraphQLTypes["Medium"] | undefined,
	buttonColors?: GraphQLTypes["ColorPallete"] | undefined
};
	["CoverMeta"]: {
	__typename: "CoverMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	primaryTitle?: GraphQLTypes["FieldMeta"] | undefined,
	secondaryTitle?: GraphQLTypes["FieldMeta"] | undefined,
	medium?: GraphQLTypes["FieldMeta"] | undefined,
	buttonColors?: GraphQLTypes["FieldMeta"] | undefined
};
	["Medium"]: {
	__typename: "Medium",
	_meta?: GraphQLTypes["MediumMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	type?: GraphQLTypes["MediumType"] | undefined,
	colorTheme?: GraphQLTypes["ColorTheme"] | undefined,
	image?: GraphQLTypes["Image"] | undefined,
	video?: GraphQLTypes["Video"] | undefined
};
	["MediumMeta"]: {
	__typename: "MediumMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	colorTheme?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined,
	video?: GraphQLTypes["FieldMeta"] | undefined
};
	["Video"]: {
	__typename: "Video",
	_meta?: GraphQLTypes["VideoMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	src?: string | undefined,
	width?: number | undefined,
	height?: number | undefined,
	size?: number | undefined,
	type?: string | undefined,
	duration?: number | undefined,
	poster?: GraphQLTypes["Image"] | undefined
};
	["VideoMeta"]: {
	__typename: "VideoMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	src?: GraphQLTypes["FieldMeta"] | undefined,
	width?: GraphQLTypes["FieldMeta"] | undefined,
	height?: GraphQLTypes["FieldMeta"] | undefined,
	size?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	duration?: GraphQLTypes["FieldMeta"] | undefined,
	poster?: GraphQLTypes["FieldMeta"] | undefined
};
	["ColorPallete"]: {
	__typename: "ColorPallete",
	_meta?: GraphQLTypes["ColorPalleteMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	background?: string | undefined,
	text?: string | undefined
};
	["ColorPalleteMeta"]: {
	__typename: "ColorPalleteMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	background?: GraphQLTypes["FieldMeta"] | undefined,
	text?: GraphQLTypes["FieldMeta"] | undefined
};
	["Content"]: {
	__typename: "Content",
	_meta?: GraphQLTypes["ContentMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	blocks: Array<GraphQLTypes["ContentBlock"]>,
	blocksByReferences?: GraphQLTypes["ContentBlock"] | undefined,
	paginateBlocks: GraphQLTypes["ContentBlockConnection"]
};
	["ContentMeta"]: {
	__typename: "ContentMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	blocks?: GraphQLTypes["FieldMeta"] | undefined
};
	["ContentBlock"]: {
	__typename: "ContentBlock",
	_meta?: GraphQLTypes["ContentBlockMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	json: string,
	content?: GraphQLTypes["Content"] | undefined,
	references: Array<GraphQLTypes["ContentReference"]>,
	referencesByProducts?: GraphQLTypes["ContentReference"] | undefined,
	referencesByProductBanners?: GraphQLTypes["ContentReference"] | undefined,
	referencesByDeliveryRegions?: GraphQLTypes["ContentReference"] | undefined,
	paginateReferences: GraphQLTypes["ContentReferenceConnection"]
};
	["ContentBlockMeta"]: {
	__typename: "ContentBlockMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	json?: GraphQLTypes["FieldMeta"] | undefined,
	content?: GraphQLTypes["FieldMeta"] | undefined,
	references?: GraphQLTypes["FieldMeta"] | undefined
};
	["ContentReference"]: {
	__typename: "ContentReference",
	_meta?: GraphQLTypes["ContentReferenceMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["ContentReferenceType"],
	primaryText?: string | undefined,
	secondaryText?: string | undefined,
	jsonContent?: string | undefined,
	block?: GraphQLTypes["ContentBlock"] | undefined,
	colorPallete?: GraphQLTypes["ColorPallete"] | undefined,
	medium?: GraphQLTypes["Medium"] | undefined,
	link?: GraphQLTypes["Link"] | undefined,
	blogPosts?: GraphQLTypes["BlogPostList"] | undefined,
	links?: GraphQLTypes["LinkList"] | undefined,
	products?: GraphQLTypes["ProductList"] | undefined,
	contentSize?: GraphQLTypes["ContentSize"] | undefined,
	misc?: string | undefined,
	hero?: GraphQLTypes["Hero"] | undefined,
	gallery?: GraphQLTypes["Gallery"] | undefined,
	socialsAndApps?: GraphQLTypes["SocialsAndApps"] | undefined,
	productGrid?: GraphQLTypes["ProductGrid"] | undefined,
	productBanners?: GraphQLTypes["ProductBannerList"] | undefined,
	deliveryRegions?: GraphQLTypes["DeliveryRegions"] | undefined,
	textList?: GraphQLTypes["TextList"] | undefined,
	gridTiles?: GraphQLTypes["GridTiles"] | undefined
};
	["ContentReferenceMeta"]: {
	__typename: "ContentReferenceMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	primaryText?: GraphQLTypes["FieldMeta"] | undefined,
	secondaryText?: GraphQLTypes["FieldMeta"] | undefined,
	jsonContent?: GraphQLTypes["FieldMeta"] | undefined,
	block?: GraphQLTypes["FieldMeta"] | undefined,
	colorPallete?: GraphQLTypes["FieldMeta"] | undefined,
	medium?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined,
	blogPosts?: GraphQLTypes["FieldMeta"] | undefined,
	links?: GraphQLTypes["FieldMeta"] | undefined,
	products?: GraphQLTypes["FieldMeta"] | undefined,
	contentSize?: GraphQLTypes["FieldMeta"] | undefined,
	misc?: GraphQLTypes["FieldMeta"] | undefined,
	hero?: GraphQLTypes["FieldMeta"] | undefined,
	gallery?: GraphQLTypes["FieldMeta"] | undefined,
	socialsAndApps?: GraphQLTypes["FieldMeta"] | undefined,
	productGrid?: GraphQLTypes["FieldMeta"] | undefined,
	productBanners?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryRegions?: GraphQLTypes["FieldMeta"] | undefined,
	textList?: GraphQLTypes["FieldMeta"] | undefined,
	gridTiles?: GraphQLTypes["FieldMeta"] | undefined
};
	["Link"]: {
	__typename: "Link",
	_meta?: GraphQLTypes["LinkMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["LinkType"],
	title?: string | undefined,
	externalLink?: string | undefined,
	internalLink?: GraphQLTypes["Linkable"] | undefined
};
	["LinkMeta"]: {
	__typename: "LinkMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	externalLink?: GraphQLTypes["FieldMeta"] | undefined,
	internalLink?: GraphQLTypes["FieldMeta"] | undefined
};
	["Linkable"]: {
	__typename: "Linkable",
	_meta?: GraphQLTypes["LinkableMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	url: string,
	blogPost?: GraphQLTypes["BlogPostLocale"] | undefined,
	page?: GraphQLTypes["PageLocale"] | undefined,
	wikiPage?: GraphQLTypes["WikiPage"] | undefined,
	redirect?: GraphQLTypes["Redirect"] | undefined
};
	["LinkableMeta"]: {
	__typename: "LinkableMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	url?: GraphQLTypes["FieldMeta"] | undefined,
	blogPost?: GraphQLTypes["FieldMeta"] | undefined,
	page?: GraphQLTypes["FieldMeta"] | undefined,
	wikiPage?: GraphQLTypes["FieldMeta"] | undefined,
	redirect?: GraphQLTypes["FieldMeta"] | undefined
};
	["PageLocale"]: {
	__typename: "PageLocale",
	_meta?: GraphQLTypes["PageLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	title?: string | undefined,
	link?: GraphQLTypes["Linkable"] | undefined,
	root?: GraphQLTypes["Page"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	seo?: GraphQLTypes["Seo"] | undefined,
	content?: GraphQLTypes["Content"] | undefined,
	cover?: GraphQLTypes["Cover"] | undefined,
	theme?: GraphQLTypes["PageTheme"] | undefined
};
	["PageLocaleMeta"]: {
	__typename: "PageLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	seo?: GraphQLTypes["FieldMeta"] | undefined,
	content?: GraphQLTypes["FieldMeta"] | undefined,
	cover?: GraphQLTypes["FieldMeta"] | undefined,
	theme?: GraphQLTypes["FieldMeta"] | undefined
};
	["Page"]: {
	__typename: "Page",
	_meta?: GraphQLTypes["PageMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	locales: Array<GraphQLTypes["PageLocale"]>,
	localesByLocale?: GraphQLTypes["PageLocale"] | undefined,
	localesByLink?: GraphQLTypes["PageLocale"] | undefined,
	localesBySeo?: GraphQLTypes["PageLocale"] | undefined,
	localesByContent?: GraphQLTypes["PageLocale"] | undefined,
	localesByCover?: GraphQLTypes["PageLocale"] | undefined,
	paginateLocales: GraphQLTypes["PageLocaleConnection"]
};
	["PageMeta"]: {
	__typename: "PageMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined
};
	["PageLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["PageLocalesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"] | undefined
};
	["PageLocalesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["PageLocalesByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["PageLocalesByCoverUniqueWhere"]: {
		cover?: GraphQLTypes["CoverUniqueWhere"] | undefined
};
	["PageLocaleConnection"]: {
	__typename: "PageLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PageLocaleEdge"]>
};
	["PageLocaleEdge"]: {
	__typename: "PageLocaleEdge",
	node: GraphQLTypes["PageLocale"]
};
	["Seo"]: {
	__typename: "Seo",
	_meta?: GraphQLTypes["SeoMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	title?: string | undefined,
	description?: string | undefined,
	ogTitle?: string | undefined,
	ogDescription?: string | undefined,
	ogImage?: GraphQLTypes["Image"] | undefined
};
	["SeoMeta"]: {
	__typename: "SeoMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined,
	ogTitle?: GraphQLTypes["FieldMeta"] | undefined,
	ogDescription?: GraphQLTypes["FieldMeta"] | undefined,
	ogImage?: GraphQLTypes["FieldMeta"] | undefined
};
	["WikiPage"]: {
	__typename: "WikiPage",
	_meta?: GraphQLTypes["WikiPageMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	title?: string | undefined,
	emoji?: string | undefined,
	link?: GraphQLTypes["Linkable"] | undefined,
	parent?: GraphQLTypes["WikiPage"] | undefined,
	children: Array<GraphQLTypes["WikiPage"]>,
	content?: GraphQLTypes["Content"] | undefined,
	childrenByLink?: GraphQLTypes["WikiPage"] | undefined,
	childrenByChildren?: GraphQLTypes["WikiPage"] | undefined,
	childrenByContent?: GraphQLTypes["WikiPage"] | undefined,
	paginateChildren: GraphQLTypes["WikiPageConnection"]
};
	["WikiPageMeta"]: {
	__typename: "WikiPageMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	emoji?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined,
	parent?: GraphQLTypes["FieldMeta"] | undefined,
	children?: GraphQLTypes["FieldMeta"] | undefined,
	content?: GraphQLTypes["FieldMeta"] | undefined
};
	["WikiPageChildrenByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"] | undefined
};
	["WikiPageChildrenByChildrenUniqueWhere"]: {
		children?: GraphQLTypes["WikiPageUniqueWhere"] | undefined
};
	["WikiPageChildrenByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["WikiPageConnection"]: {
	__typename: "WikiPageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["WikiPageEdge"]>
};
	["WikiPageEdge"]: {
	__typename: "WikiPageEdge",
	node: GraphQLTypes["WikiPage"]
};
	["Redirect"]: {
	__typename: "Redirect",
	_meta?: GraphQLTypes["RedirectMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	link?: GraphQLTypes["Linkable"] | undefined,
	target?: GraphQLTypes["Link"] | undefined
};
	["RedirectMeta"]: {
	__typename: "RedirectMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined,
	target?: GraphQLTypes["FieldMeta"] | undefined
};
	["BlogPostList"]: {
	__typename: "BlogPostList",
	_meta?: GraphQLTypes["BlogPostListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["BlogPostListItem"]>,
	paginateItems: GraphQLTypes["BlogPostListItemConnection"]
};
	["BlogPostListMeta"]: {
	__typename: "BlogPostListMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["BlogPostListItem"]: {
	__typename: "BlogPostListItem",
	_meta?: GraphQLTypes["BlogPostListItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	caption?: string | undefined,
	list?: GraphQLTypes["BlogPostList"] | undefined,
	blogPost?: GraphQLTypes["BlogPostLocale"] | undefined
};
	["BlogPostListItemMeta"]: {
	__typename: "BlogPostListItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	caption?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	blogPost?: GraphQLTypes["FieldMeta"] | undefined
};
	["BlogPostListItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	caption?: GraphQLTypes["OrderDirection"] | undefined,
	list?: GraphQLTypes["BlogPostListOrderBy"] | undefined,
	blogPost?: GraphQLTypes["BlogPostLocaleOrderBy"] | undefined
};
	["BlogPostListOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined
};
	["BlogPostListItemConnection"]: {
	__typename: "BlogPostListItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BlogPostListItemEdge"]>
};
	["BlogPostListItemEdge"]: {
	__typename: "BlogPostListItemEdge",
	node: GraphQLTypes["BlogPostListItem"]
};
	["LinkList"]: {
	__typename: "LinkList",
	_meta?: GraphQLTypes["LinkListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["LinkListItem"]>,
	paginateItems: GraphQLTypes["LinkListItemConnection"]
};
	["LinkListMeta"]: {
	__typename: "LinkListMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["LinkListItem"]: {
	__typename: "LinkListItem",
	_meta?: GraphQLTypes["LinkListItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	isPrimary?: boolean | undefined,
	list?: GraphQLTypes["LinkList"] | undefined,
	link?: GraphQLTypes["Link"] | undefined
};
	["LinkListItemMeta"]: {
	__typename: "LinkListItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	isPrimary?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined
};
	["LinkListItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	isPrimary?: GraphQLTypes["OrderDirection"] | undefined,
	list?: GraphQLTypes["LinkListOrderBy"] | undefined,
	link?: GraphQLTypes["LinkOrderBy"] | undefined
};
	["LinkListOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined
};
	["LinkListItemConnection"]: {
	__typename: "LinkListItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkListItemEdge"]>
};
	["LinkListItemEdge"]: {
	__typename: "LinkListItemEdge",
	node: GraphQLTypes["LinkListItem"]
};
	["Hero"]: {
	__typename: "Hero",
	_meta?: GraphQLTypes["HeroMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	showLogo?: boolean | undefined,
	middleContent?: string | undefined,
	medium?: GraphQLTypes["Medium"] | undefined
};
	["HeroMeta"]: {
	__typename: "HeroMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	showLogo?: GraphQLTypes["FieldMeta"] | undefined,
	middleContent?: GraphQLTypes["FieldMeta"] | undefined,
	medium?: GraphQLTypes["FieldMeta"] | undefined
};
	["Gallery"]: {
	__typename: "Gallery",
	_meta?: GraphQLTypes["GalleryMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["GalleryItem"]>,
	paginateItems: GraphQLTypes["GalleryItemConnection"]
};
	["GalleryMeta"]: {
	__typename: "GalleryMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["GalleryItem"]: {
	__typename: "GalleryItem",
	_meta?: GraphQLTypes["GalleryItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	caption?: string | undefined,
	list?: GraphQLTypes["Gallery"] | undefined,
	medium?: GraphQLTypes["Medium"] | undefined
};
	["GalleryItemMeta"]: {
	__typename: "GalleryItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	caption?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	medium?: GraphQLTypes["FieldMeta"] | undefined
};
	["GalleryItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	caption?: GraphQLTypes["OrderDirection"] | undefined,
	list?: GraphQLTypes["GalleryOrderBy"] | undefined,
	medium?: GraphQLTypes["MediumOrderBy"] | undefined
};
	["GalleryOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined
};
	["GalleryItemConnection"]: {
	__typename: "GalleryItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GalleryItemEdge"]>
};
	["GalleryItemEdge"]: {
	__typename: "GalleryItemEdge",
	node: GraphQLTypes["GalleryItem"]
};
	["SocialsAndApps"]: {
	__typename: "SocialsAndApps",
	_meta?: GraphQLTypes["SocialsAndAppsMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	instagram?: boolean | undefined,
	appStore?: boolean | undefined,
	googlePlay?: boolean | undefined
};
	["SocialsAndAppsMeta"]: {
	__typename: "SocialsAndAppsMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	instagram?: GraphQLTypes["FieldMeta"] | undefined,
	appStore?: GraphQLTypes["FieldMeta"] | undefined,
	googlePlay?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductGrid"]: {
	__typename: "ProductGrid",
	_meta?: GraphQLTypes["ProductGridMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	isCarousel?: boolean | undefined,
	categories: Array<GraphQLTypes["ProductGridCategory"]>,
	type?: GraphQLTypes["ProductGridType"] | undefined,
	categoriesByItems?: GraphQLTypes["ProductGridCategory"] | undefined,
	categoriesByImages?: GraphQLTypes["ProductGridCategory"] | undefined,
	paginateCategories: GraphQLTypes["ProductGridCategoryConnection"]
};
	["ProductGridMeta"]: {
	__typename: "ProductGridMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	isCarousel?: GraphQLTypes["FieldMeta"] | undefined,
	categories?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductGridCategory"]: {
	__typename: "ProductGridCategory",
	_meta?: GraphQLTypes["ProductGridCategoryMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	title?: string | undefined,
	root?: GraphQLTypes["ProductGrid"] | undefined,
	items: Array<GraphQLTypes["ProductGridItem"]>,
	images?: GraphQLTypes["ImageList"] | undefined,
	paginateItems: GraphQLTypes["ProductGridItemConnection"]
};
	["ProductGridCategoryMeta"]: {
	__typename: "ProductGridCategoryMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined,
	images?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductGridItem"]: {
	__typename: "ProductGridItem",
	_meta?: GraphQLTypes["ProductGridItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	title?: string | undefined,
	lead?: string | undefined,
	product?: GraphQLTypes["Product"] | undefined,
	medium?: GraphQLTypes["Medium"] | undefined,
	link?: GraphQLTypes["Link"] | undefined,
	category?: GraphQLTypes["ProductGridCategory"] | undefined,
	description?: string | undefined
};
	["ProductGridItemMeta"]: {
	__typename: "ProductGridItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	lead?: GraphQLTypes["FieldMeta"] | undefined,
	product?: GraphQLTypes["FieldMeta"] | undefined,
	medium?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined,
	category?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductGridItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	lead?: GraphQLTypes["OrderDirection"] | undefined,
	product?: GraphQLTypes["ProductOrderBy"] | undefined,
	medium?: GraphQLTypes["MediumOrderBy"] | undefined,
	link?: GraphQLTypes["LinkOrderBy"] | undefined,
	category?: GraphQLTypes["ProductGridCategoryOrderBy"] | undefined,
	description?: GraphQLTypes["OrderDirection"] | undefined
};
	["ProductGridCategoryOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["ProductGridOrderBy"] | undefined,
	images?: GraphQLTypes["ImageListOrderBy"] | undefined
};
	["ProductGridOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	isCarousel?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined
};
	["ImageListOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined
};
	["ImageList"]: {
	__typename: "ImageList",
	_meta?: GraphQLTypes["ImageListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["ImageListItem"]>,
	itemsByImage?: GraphQLTypes["ImageListItem"] | undefined,
	paginateItems: GraphQLTypes["ImageListItemConnection"]
};
	["ImageListMeta"]: {
	__typename: "ImageListMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["ImageListItem"]: {
	__typename: "ImageListItem",
	_meta?: GraphQLTypes["ImageListItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["ImageList"] | undefined,
	image?: GraphQLTypes["Image"] | undefined
};
	["ImageListItemMeta"]: {
	__typename: "ImageListItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined
};
	["ImageListItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	list?: GraphQLTypes["ImageListOrderBy"] | undefined,
	image?: GraphQLTypes["ImageOrderBy"] | undefined
};
	["ImageListItemsByImageUniqueWhere"]: {
		image?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["ImageListItemConnection"]: {
	__typename: "ImageListItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ImageListItemEdge"]>
};
	["ImageListItemEdge"]: {
	__typename: "ImageListItemEdge",
	node: GraphQLTypes["ImageListItem"]
};
	["ProductGridItemConnection"]: {
	__typename: "ProductGridItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductGridItemEdge"]>
};
	["ProductGridItemEdge"]: {
	__typename: "ProductGridItemEdge",
	node: GraphQLTypes["ProductGridItem"]
};
	["ProductGridCategoriesByItemsUniqueWhere"]: {
		items?: GraphQLTypes["ProductGridItemUniqueWhere"] | undefined
};
	["ProductGridItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["ProductGridCategoriesByImagesUniqueWhere"]: {
		images?: GraphQLTypes["ImageListUniqueWhere"] | undefined
};
	["ProductGridCategoryConnection"]: {
	__typename: "ProductGridCategoryConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductGridCategoryEdge"]>
};
	["ProductGridCategoryEdge"]: {
	__typename: "ProductGridCategoryEdge",
	node: GraphQLTypes["ProductGridCategory"]
};
	["ProductBannerList"]: {
	__typename: "ProductBannerList",
	_meta?: GraphQLTypes["ProductBannerListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["ProductBannerItem"]>,
	paginateItems: GraphQLTypes["ProductBannerItemConnection"]
};
	["ProductBannerListMeta"]: {
	__typename: "ProductBannerListMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductBannerItem"]: {
	__typename: "ProductBannerItem",
	_meta?: GraphQLTypes["ProductBannerItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["ProductBannerList"] | undefined,
	banner?: GraphQLTypes["ProductBanner"] | undefined,
	size?: GraphQLTypes["ProductBannerItemSize"] | undefined
};
	["ProductBannerItemMeta"]: {
	__typename: "ProductBannerItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	banner?: GraphQLTypes["FieldMeta"] | undefined,
	size?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductBanner"]: {
	__typename: "ProductBanner",
	_meta?: GraphQLTypes["ProductBannerMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	beforeTitle?: string | undefined,
	title?: string | undefined,
	label?: string | undefined,
	button?: GraphQLTypes["Link"] | undefined,
	backgroundImage?: GraphQLTypes["Image"] | undefined,
	productImage?: GraphQLTypes["Image"] | undefined,
	product?: GraphQLTypes["Product"] | undefined
};
	["ProductBannerMeta"]: {
	__typename: "ProductBannerMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	beforeTitle?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	label?: GraphQLTypes["FieldMeta"] | undefined,
	button?: GraphQLTypes["FieldMeta"] | undefined,
	backgroundImage?: GraphQLTypes["FieldMeta"] | undefined,
	productImage?: GraphQLTypes["FieldMeta"] | undefined,
	product?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductBannerItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	list?: GraphQLTypes["ProductBannerListOrderBy"] | undefined,
	banner?: GraphQLTypes["ProductBannerOrderBy"] | undefined,
	size?: GraphQLTypes["OrderDirection"] | undefined
};
	["ProductBannerListOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined
};
	["ProductBannerOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	beforeTitle?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	label?: GraphQLTypes["OrderDirection"] | undefined,
	button?: GraphQLTypes["LinkOrderBy"] | undefined,
	backgroundImage?: GraphQLTypes["ImageOrderBy"] | undefined,
	productImage?: GraphQLTypes["ImageOrderBy"] | undefined,
	product?: GraphQLTypes["ProductOrderBy"] | undefined
};
	["ProductBannerItemConnection"]: {
	__typename: "ProductBannerItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductBannerItemEdge"]>
};
	["ProductBannerItemEdge"]: {
	__typename: "ProductBannerItemEdge",
	node: GraphQLTypes["ProductBannerItem"]
};
	["DeliveryRegions"]: {
	__typename: "DeliveryRegions",
	_meta?: GraphQLTypes["DeliveryRegionsMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["DeliveryRegionsItem"]>,
	itemsByImage?: GraphQLTypes["DeliveryRegionsItem"] | undefined,
	itemsByTextList?: GraphQLTypes["DeliveryRegionsItem"] | undefined,
	itemsByGallery?: GraphQLTypes["DeliveryRegionsItem"] | undefined,
	paginateItems: GraphQLTypes["DeliveryRegionsItemConnection"]
};
	["DeliveryRegionsMeta"]: {
	__typename: "DeliveryRegionsMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["DeliveryRegionsItem"]: {
	__typename: "DeliveryRegionsItem",
	_meta?: GraphQLTypes["DeliveryRegionsItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	title?: string | undefined,
	offerLabel?: string | undefined,
	list?: GraphQLTypes["DeliveryRegions"] | undefined,
	image?: GraphQLTypes["Image"] | undefined,
	textList?: GraphQLTypes["TextList"] | undefined,
	gallery?: GraphQLTypes["ImageList"] | undefined
};
	["DeliveryRegionsItemMeta"]: {
	__typename: "DeliveryRegionsItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	offerLabel?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined,
	textList?: GraphQLTypes["FieldMeta"] | undefined,
	gallery?: GraphQLTypes["FieldMeta"] | undefined
};
	["TextList"]: {
	__typename: "TextList",
	_meta?: GraphQLTypes["TextListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["TextItem"]>,
	paginateItems: GraphQLTypes["TextItemConnection"]
};
	["TextListMeta"]: {
	__typename: "TextListMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["TextItem"]: {
	__typename: "TextItem",
	_meta?: GraphQLTypes["TextItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	text?: string | undefined,
	list?: GraphQLTypes["TextList"] | undefined,
	title?: string | undefined
};
	["TextItemMeta"]: {
	__typename: "TextItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	text?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined
};
	["TextItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	text?: GraphQLTypes["OrderDirection"] | undefined,
	list?: GraphQLTypes["TextListOrderBy"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined
};
	["TextListOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined
};
	["TextItemConnection"]: {
	__typename: "TextItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TextItemEdge"]>
};
	["TextItemEdge"]: {
	__typename: "TextItemEdge",
	node: GraphQLTypes["TextItem"]
};
	["DeliveryRegionsItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	offerLabel?: GraphQLTypes["OrderDirection"] | undefined,
	list?: GraphQLTypes["DeliveryRegionsOrderBy"] | undefined,
	image?: GraphQLTypes["ImageOrderBy"] | undefined,
	textList?: GraphQLTypes["TextListOrderBy"] | undefined,
	gallery?: GraphQLTypes["ImageListOrderBy"] | undefined
};
	["DeliveryRegionsOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined
};
	["DeliveryRegionsItemsByImageUniqueWhere"]: {
		image?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["DeliveryRegionsItemsByTextListUniqueWhere"]: {
		textList?: GraphQLTypes["TextListUniqueWhere"] | undefined
};
	["DeliveryRegionsItemsByGalleryUniqueWhere"]: {
		gallery?: GraphQLTypes["ImageListUniqueWhere"] | undefined
};
	["DeliveryRegionsItemConnection"]: {
	__typename: "DeliveryRegionsItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DeliveryRegionsItemEdge"]>
};
	["DeliveryRegionsItemEdge"]: {
	__typename: "DeliveryRegionsItemEdge",
	node: GraphQLTypes["DeliveryRegionsItem"]
};
	["GridTiles"]: {
	__typename: "GridTiles",
	_meta?: GraphQLTypes["GridTilesMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["GridTileItem"]>,
	itemsByLink?: GraphQLTypes["GridTileItem"] | undefined,
	paginateItems: GraphQLTypes["GridTileItemConnection"]
};
	["GridTilesMeta"]: {
	__typename: "GridTilesMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["GridTileItem"]: {
	__typename: "GridTileItem",
	_meta?: GraphQLTypes["GridTileItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	text?: string | undefined,
	list?: GraphQLTypes["GridTiles"] | undefined,
	medium?: GraphQLTypes["Medium"] | undefined,
	link?: GraphQLTypes["Link"] | undefined
};
	["GridTileItemMeta"]: {
	__typename: "GridTileItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	text?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	medium?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined
};
	["GridTileItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	text?: GraphQLTypes["OrderDirection"] | undefined,
	list?: GraphQLTypes["GridTilesOrderBy"] | undefined,
	medium?: GraphQLTypes["MediumOrderBy"] | undefined,
	link?: GraphQLTypes["LinkOrderBy"] | undefined
};
	["GridTilesOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined
};
	["GridTilesItemsByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["LinkUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["GridTileItemConnection"]: {
	__typename: "GridTileItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GridTileItemEdge"]>
};
	["GridTileItemEdge"]: {
	__typename: "GridTileItemEdge",
	node: GraphQLTypes["GridTileItem"]
};
	["ContentReferenceOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	primaryText?: GraphQLTypes["OrderDirection"] | undefined,
	secondaryText?: GraphQLTypes["OrderDirection"] | undefined,
	jsonContent?: GraphQLTypes["OrderDirection"] | undefined,
	block?: GraphQLTypes["ContentBlockOrderBy"] | undefined,
	colorPallete?: GraphQLTypes["ColorPalleteOrderBy"] | undefined,
	medium?: GraphQLTypes["MediumOrderBy"] | undefined,
	link?: GraphQLTypes["LinkOrderBy"] | undefined,
	blogPosts?: GraphQLTypes["BlogPostListOrderBy"] | undefined,
	links?: GraphQLTypes["LinkListOrderBy"] | undefined,
	products?: GraphQLTypes["ProductListOrderBy"] | undefined,
	contentSize?: GraphQLTypes["OrderDirection"] | undefined,
	misc?: GraphQLTypes["OrderDirection"] | undefined,
	hero?: GraphQLTypes["HeroOrderBy"] | undefined,
	gallery?: GraphQLTypes["GalleryOrderBy"] | undefined,
	socialsAndApps?: GraphQLTypes["SocialsAndAppsOrderBy"] | undefined,
	productGrid?: GraphQLTypes["ProductGridOrderBy"] | undefined,
	productBanners?: GraphQLTypes["ProductBannerListOrderBy"] | undefined,
	deliveryRegions?: GraphQLTypes["DeliveryRegionsOrderBy"] | undefined,
	textList?: GraphQLTypes["TextListOrderBy"] | undefined,
	gridTiles?: GraphQLTypes["GridTilesOrderBy"] | undefined
};
	["ContentBlockOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	json?: GraphQLTypes["OrderDirection"] | undefined,
	content?: GraphQLTypes["ContentOrderBy"] | undefined
};
	["HeroOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	showLogo?: GraphQLTypes["OrderDirection"] | undefined,
	middleContent?: GraphQLTypes["OrderDirection"] | undefined,
	medium?: GraphQLTypes["MediumOrderBy"] | undefined
};
	["SocialsAndAppsOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	instagram?: GraphQLTypes["OrderDirection"] | undefined,
	appStore?: GraphQLTypes["OrderDirection"] | undefined,
	googlePlay?: GraphQLTypes["OrderDirection"] | undefined
};
	["ContentBlockReferencesByProductsUniqueWhere"]: {
		products?: GraphQLTypes["ProductListUniqueWhere"] | undefined
};
	["ContentBlockReferencesByProductBannersUniqueWhere"]: {
		productBanners?: GraphQLTypes["ProductBannerListUniqueWhere"] | undefined
};
	["ContentBlockReferencesByDeliveryRegionsUniqueWhere"]: {
		deliveryRegions?: GraphQLTypes["DeliveryRegionsUniqueWhere"] | undefined
};
	["ContentReferenceConnection"]: {
	__typename: "ContentReferenceConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentReferenceEdge"]>
};
	["ContentReferenceEdge"]: {
	__typename: "ContentReferenceEdge",
	node: GraphQLTypes["ContentReference"]
};
	["ContentBlocksByReferencesUniqueWhere"]: {
		references?: GraphQLTypes["ContentReferenceUniqueWhere"] | undefined
};
	["ContentBlockConnection"]: {
	__typename: "ContentBlockConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentBlockEdge"]>
};
	["ContentBlockEdge"]: {
	__typename: "ContentBlockEdge",
	node: GraphQLTypes["ContentBlock"]
};
	["TranslationCataloguesIdentifier"]: {
	__typename: "TranslationCataloguesIdentifier",
	_meta?: GraphQLTypes["TranslationCataloguesIdentifierMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	code: string,
	catalogue: Array<GraphQLTypes["TranslationCatalogue"]>,
	catalogueByDomain?: GraphQLTypes["TranslationCatalogue"] | undefined,
	catalogueByValues?: GraphQLTypes["TranslationCatalogue"] | undefined,
	paginateCatalogue: GraphQLTypes["TranslationCatalogueConnection"]
};
	["TranslationCataloguesIdentifierMeta"]: {
	__typename: "TranslationCataloguesIdentifierMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	code?: GraphQLTypes["FieldMeta"] | undefined,
	catalogue?: GraphQLTypes["FieldMeta"] | undefined
};
	["TranslationCatalogue"]: {
	__typename: "TranslationCatalogue",
	_meta?: GraphQLTypes["TranslationCatalogueMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	domain?: GraphQLTypes["TranslationDomain"] | undefined,
	fallback?: GraphQLTypes["TranslationCatalogue"] | undefined,
	values: Array<GraphQLTypes["TranslationValue"]>,
	identifier?: GraphQLTypes["TranslationCataloguesIdentifier"] | undefined,
	valuesByKey?: GraphQLTypes["TranslationValue"] | undefined,
	paginateValues: GraphQLTypes["TranslationValueConnection"]
};
	["TranslationCatalogueMeta"]: {
	__typename: "TranslationCatalogueMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	domain?: GraphQLTypes["FieldMeta"] | undefined,
	fallback?: GraphQLTypes["FieldMeta"] | undefined,
	values?: GraphQLTypes["FieldMeta"] | undefined,
	identifier?: GraphQLTypes["FieldMeta"] | undefined
};
	["TranslationDomain"]: {
	__typename: "TranslationDomain",
	_meta?: GraphQLTypes["TranslationDomainMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	identifier: string,
	name: string,
	catalogues: Array<GraphQLTypes["TranslationCatalogue"]>,
	keys: Array<GraphQLTypes["TranslationKey"]>,
	cataloguesByIdentifier?: GraphQLTypes["TranslationCatalogue"] | undefined,
	cataloguesByValues?: GraphQLTypes["TranslationCatalogue"] | undefined,
	keysByIdentifier?: GraphQLTypes["TranslationKey"] | undefined,
	keysByValues?: GraphQLTypes["TranslationKey"] | undefined,
	paginateCatalogues: GraphQLTypes["TranslationCatalogueConnection"],
	paginateKeys: GraphQLTypes["TranslationKeyConnection"]
};
	["TranslationDomainMeta"]: {
	__typename: "TranslationDomainMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	identifier?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	catalogues?: GraphQLTypes["FieldMeta"] | undefined,
	keys?: GraphQLTypes["FieldMeta"] | undefined
};
	["TranslationCatalogueOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	domain?: GraphQLTypes["TranslationDomainOrderBy"] | undefined,
	fallback?: GraphQLTypes["TranslationCatalogueOrderBy"] | undefined,
	identifier?: GraphQLTypes["TranslationCataloguesIdentifierOrderBy"] | undefined
};
	["TranslationDomainOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	identifier?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined
};
	["TranslationKey"]: {
	__typename: "TranslationKey",
	_meta?: GraphQLTypes["TranslationKeyMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	identifier: string,
	contentType: GraphQLTypes["TranslationContentType"],
	note?: string | undefined,
	domain?: GraphQLTypes["TranslationDomain"] | undefined,
	values: Array<GraphQLTypes["TranslationValue"]>,
	valuesByCatalogue?: GraphQLTypes["TranslationValue"] | undefined,
	paginateValues: GraphQLTypes["TranslationValueConnection"]
};
	["TranslationKeyMeta"]: {
	__typename: "TranslationKeyMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	identifier?: GraphQLTypes["FieldMeta"] | undefined,
	contentType?: GraphQLTypes["FieldMeta"] | undefined,
	note?: GraphQLTypes["FieldMeta"] | undefined,
	domain?: GraphQLTypes["FieldMeta"] | undefined,
	values?: GraphQLTypes["FieldMeta"] | undefined
};
	["TranslationValue"]: {
	__typename: "TranslationValue",
	_meta?: GraphQLTypes["TranslationValueMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	value: string,
	catalogue?: GraphQLTypes["TranslationCatalogue"] | undefined,
	key?: GraphQLTypes["TranslationKey"] | undefined
};
	["TranslationValueMeta"]: {
	__typename: "TranslationValueMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	value?: GraphQLTypes["FieldMeta"] | undefined,
	catalogue?: GraphQLTypes["FieldMeta"] | undefined,
	key?: GraphQLTypes["FieldMeta"] | undefined
};
	["TranslationValueOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	value?: GraphQLTypes["OrderDirection"] | undefined,
	catalogue?: GraphQLTypes["TranslationCatalogueOrderBy"] | undefined,
	key?: GraphQLTypes["TranslationKeyOrderBy"] | undefined
};
	["TranslationKeyOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	identifier?: GraphQLTypes["OrderDirection"] | undefined,
	contentType?: GraphQLTypes["OrderDirection"] | undefined,
	note?: GraphQLTypes["OrderDirection"] | undefined,
	domain?: GraphQLTypes["TranslationDomainOrderBy"] | undefined
};
	["TranslationKeyValuesByCatalogueUniqueWhere"]: {
		catalogue?: GraphQLTypes["TranslationCatalogueUniqueWhere"] | undefined
};
	["TranslationValueConnection"]: {
	__typename: "TranslationValueConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TranslationValueEdge"]>
};
	["TranslationValueEdge"]: {
	__typename: "TranslationValueEdge",
	node: GraphQLTypes["TranslationValue"]
};
	["TranslationDomainCataloguesByIdentifierUniqueWhere"]: {
		identifier?: GraphQLTypes["TranslationCataloguesIdentifierUniqueWhere"] | undefined
};
	["TranslationDomainCataloguesByValuesUniqueWhere"]: {
		values?: GraphQLTypes["TranslationValueUniqueWhere"] | undefined
};
	["TranslationDomainKeysByIdentifierUniqueWhere"]: {
		identifier?: string | undefined
};
	["TranslationDomainKeysByValuesUniqueWhere"]: {
		values?: GraphQLTypes["TranslationValueUniqueWhere"] | undefined
};
	["TranslationCatalogueConnection"]: {
	__typename: "TranslationCatalogueConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TranslationCatalogueEdge"]>
};
	["TranslationCatalogueEdge"]: {
	__typename: "TranslationCatalogueEdge",
	node: GraphQLTypes["TranslationCatalogue"]
};
	["TranslationKeyConnection"]: {
	__typename: "TranslationKeyConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TranslationKeyEdge"]>
};
	["TranslationKeyEdge"]: {
	__typename: "TranslationKeyEdge",
	node: GraphQLTypes["TranslationKey"]
};
	["TranslationCatalogueValuesByKeyUniqueWhere"]: {
		key?: GraphQLTypes["TranslationKeyUniqueWhere"] | undefined
};
	["TranslationCataloguesIdentifierCatalogueByDomainUniqueWhere"]: {
		domain?: GraphQLTypes["TranslationDomainUniqueWhere"] | undefined
};
	["TranslationCataloguesIdentifierCatalogueByValuesUniqueWhere"]: {
		values?: GraphQLTypes["TranslationValueUniqueWhere"] | undefined
};
	["MenuLocale"]: {
	__typename: "MenuLocale",
	_meta?: GraphQLTypes["MenuLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	root?: GraphQLTypes["SiteMenu"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	items: Array<GraphQLTypes["MenuItem"]>,
	secondaryItems?: GraphQLTypes["LinkList"] | undefined,
	eshopLink?: GraphQLTypes["Link"] | undefined,
	itemsBySubitems?: GraphQLTypes["MenuItem"] | undefined,
	paginateItems: GraphQLTypes["MenuItemConnection"]
};
	["MenuLocaleMeta"]: {
	__typename: "MenuLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined,
	secondaryItems?: GraphQLTypes["FieldMeta"] | undefined,
	eshopLink?: GraphQLTypes["FieldMeta"] | undefined
};
	["SiteMenu"]: {
	__typename: "SiteMenu",
	_meta?: GraphQLTypes["SiteMenuMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	locales: Array<GraphQLTypes["MenuLocale"]>,
	localesByLocale?: GraphQLTypes["MenuLocale"] | undefined,
	localesByItems?: GraphQLTypes["MenuLocale"] | undefined,
	localesBySecondaryItems?: GraphQLTypes["MenuLocale"] | undefined,
	paginateLocales: GraphQLTypes["MenuLocaleConnection"]
};
	["SiteMenuMeta"]: {
	__typename: "SiteMenuMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	unique?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined
};
	["MenuLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["SiteMenuOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	secondaryItems?: GraphQLTypes["LinkListOrderBy"] | undefined,
	eshopLink?: GraphQLTypes["LinkOrderBy"] | undefined
};
	["SiteMenuOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	unique?: GraphQLTypes["OrderDirection"] | undefined
};
	["SiteMenuLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["SiteMenuLocalesByItemsUniqueWhere"]: {
		items?: GraphQLTypes["MenuItemUniqueWhere"] | undefined
};
	["SiteMenuLocalesBySecondaryItemsUniqueWhere"]: {
		secondaryItems?: GraphQLTypes["LinkListUniqueWhere"] | undefined
};
	["MenuLocaleConnection"]: {
	__typename: "MenuLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MenuLocaleEdge"]>
};
	["MenuLocaleEdge"]: {
	__typename: "MenuLocaleEdge",
	node: GraphQLTypes["MenuLocale"]
};
	["MenuItem"]: {
	__typename: "MenuItem",
	_meta?: GraphQLTypes["MenuItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	menu?: GraphQLTypes["MenuLocale"] | undefined,
	link?: GraphQLTypes["Link"] | undefined,
	subitems: Array<GraphQLTypes["MenuSubitem"]>,
	paginateSubitems: GraphQLTypes["MenuSubitemConnection"]
};
	["MenuItemMeta"]: {
	__typename: "MenuItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	menu?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined,
	subitems?: GraphQLTypes["FieldMeta"] | undefined
};
	["MenuSubitem"]: {
	__typename: "MenuSubitem",
	_meta?: GraphQLTypes["MenuSubitemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	type?: GraphQLTypes["MenuSubitemType"] | undefined,
	title?: string | undefined,
	item?: GraphQLTypes["MenuItem"] | undefined,
	links?: GraphQLTypes["MenuLinkList"] | undefined,
	products?: GraphQLTypes["MenuProducts"] | undefined,
	delivery?: GraphQLTypes["MenuDelivery"] | undefined,
	contact?: GraphQLTypes["MenuContact"] | undefined,
	order: number
};
	["MenuSubitemMeta"]: {
	__typename: "MenuSubitemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	item?: GraphQLTypes["FieldMeta"] | undefined,
	links?: GraphQLTypes["FieldMeta"] | undefined,
	products?: GraphQLTypes["FieldMeta"] | undefined,
	delivery?: GraphQLTypes["FieldMeta"] | undefined,
	contact?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined
};
	["MenuLinkList"]: {
	__typename: "MenuLinkList",
	_meta?: GraphQLTypes["MenuLinkListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["MenuLinkItem"]>,
	paginateItems: GraphQLTypes["MenuLinkItemConnection"]
};
	["MenuLinkListMeta"]: {
	__typename: "MenuLinkListMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["MenuLinkItem"]: {
	__typename: "MenuLinkItem",
	_meta?: GraphQLTypes["MenuLinkItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["MenuLinkList"] | undefined,
	link?: GraphQLTypes["Link"] | undefined,
	image?: GraphQLTypes["Image"] | undefined,
	description?: string | undefined
};
	["MenuLinkItemMeta"]: {
	__typename: "MenuLinkItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined
};
	["MenuLinkItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	list?: GraphQLTypes["MenuLinkListOrderBy"] | undefined,
	link?: GraphQLTypes["LinkOrderBy"] | undefined,
	image?: GraphQLTypes["ImageOrderBy"] | undefined,
	description?: GraphQLTypes["OrderDirection"] | undefined
};
	["MenuLinkListOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined
};
	["MenuLinkItemConnection"]: {
	__typename: "MenuLinkItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MenuLinkItemEdge"]>
};
	["MenuLinkItemEdge"]: {
	__typename: "MenuLinkItemEdge",
	node: GraphQLTypes["MenuLinkItem"]
};
	["MenuProducts"]: {
	__typename: "MenuProducts",
	_meta?: GraphQLTypes["MenuProductsMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	links?: GraphQLTypes["MenuLinkList"] | undefined,
	buttons?: GraphQLTypes["LinkList"] | undefined
};
	["MenuProductsMeta"]: {
	__typename: "MenuProductsMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	links?: GraphQLTypes["FieldMeta"] | undefined,
	buttons?: GraphQLTypes["FieldMeta"] | undefined
};
	["MenuDelivery"]: {
	__typename: "MenuDelivery",
	_meta?: GraphQLTypes["MenuDeliveryMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	deliveryRegions?: GraphQLTypes["DeliveryRegions"] | undefined,
	text?: string | undefined,
	socialsAndApps?: GraphQLTypes["SocialsAndApps"] | undefined
};
	["MenuDeliveryMeta"]: {
	__typename: "MenuDeliveryMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryRegions?: GraphQLTypes["FieldMeta"] | undefined,
	text?: GraphQLTypes["FieldMeta"] | undefined,
	socialsAndApps?: GraphQLTypes["FieldMeta"] | undefined
};
	["MenuContact"]: {
	__typename: "MenuContact",
	_meta?: GraphQLTypes["MenuContactMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	text?: string | undefined,
	image?: GraphQLTypes["Image"] | undefined
};
	["MenuContactMeta"]: {
	__typename: "MenuContactMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	text?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined
};
	["MenuSubitemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	item?: GraphQLTypes["MenuItemOrderBy"] | undefined,
	links?: GraphQLTypes["MenuLinkListOrderBy"] | undefined,
	products?: GraphQLTypes["MenuProductsOrderBy"] | undefined,
	delivery?: GraphQLTypes["MenuDeliveryOrderBy"] | undefined,
	contact?: GraphQLTypes["MenuContactOrderBy"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined
};
	["MenuItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	menu?: GraphQLTypes["MenuLocaleOrderBy"] | undefined,
	link?: GraphQLTypes["LinkOrderBy"] | undefined
};
	["MenuProductsOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	links?: GraphQLTypes["MenuLinkListOrderBy"] | undefined,
	buttons?: GraphQLTypes["LinkListOrderBy"] | undefined
};
	["MenuDeliveryOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	deliveryRegions?: GraphQLTypes["DeliveryRegionsOrderBy"] | undefined,
	text?: GraphQLTypes["OrderDirection"] | undefined,
	socialsAndApps?: GraphQLTypes["SocialsAndAppsOrderBy"] | undefined
};
	["MenuContactOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	text?: GraphQLTypes["OrderDirection"] | undefined,
	image?: GraphQLTypes["ImageOrderBy"] | undefined
};
	["MenuSubitemConnection"]: {
	__typename: "MenuSubitemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MenuSubitemEdge"]>
};
	["MenuSubitemEdge"]: {
	__typename: "MenuSubitemEdge",
	node: GraphQLTypes["MenuSubitem"]
};
	["MenuLocaleItemsBySubitemsUniqueWhere"]: {
		subitems?: GraphQLTypes["MenuSubitemUniqueWhere"] | undefined
};
	["MenuItemConnection"]: {
	__typename: "MenuItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MenuItemEdge"]>
};
	["MenuItemEdge"]: {
	__typename: "MenuItemEdge",
	node: GraphQLTypes["MenuItem"]
};
	["ProductPackingLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	shortName?: GraphQLTypes["OrderDirection"] | undefined,
	description?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["ProductPackingOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined
};
	["ProductLocale"]: {
	__typename: "ProductLocale",
	_meta?: GraphQLTypes["ProductLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	description?: string | undefined,
	root?: GraphQLTypes["Product"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	featureList?: GraphQLTypes["TextList"] | undefined,
	printableName?: string | undefined,
	firstSticker?: string | undefined,
	secondSticker?: string | undefined
};
	["ProductLocaleMeta"]: {
	__typename: "ProductLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	featureList?: GraphQLTypes["FieldMeta"] | undefined,
	printableName?: GraphQLTypes["FieldMeta"] | undefined,
	firstSticker?: GraphQLTypes["FieldMeta"] | undefined,
	secondSticker?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	description?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["ProductOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	featureList?: GraphQLTypes["TextListOrderBy"] | undefined,
	printableName?: GraphQLTypes["OrderDirection"] | undefined,
	firstSticker?: GraphQLTypes["OrderDirection"] | undefined,
	secondSticker?: GraphQLTypes["OrderDirection"] | undefined
};
	["ProductRecipeLocale"]: {
	__typename: "ProductRecipeLocale",
	_meta?: GraphQLTypes["ProductRecipeLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	root?: GraphQLTypes["ProductRecipe"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	description?: string | undefined
};
	["ProductRecipeLocaleMeta"]: {
	__typename: "ProductRecipeLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductRecipe"]: {
	__typename: "ProductRecipe",
	_meta?: GraphQLTypes["ProductRecipeMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	products: Array<GraphQLTypes["Product"]>,
	internalNote?: string | undefined,
	color?: string | undefined,
	image?: GraphQLTypes["Image"] | undefined,
	icon?: GraphQLTypes["Image"] | undefined,
	ingredients: Array<GraphQLTypes["ProductIngredientItem"]>,
	needsPrepping: boolean,
	locales: Array<GraphQLTypes["ProductRecipeLocale"]>,
	gutTuning?: number | undefined,
	freshingContainer?: GraphQLTypes["FreshingContainer"] | undefined,
	description?: string | undefined,
	nutritionFacts?: GraphQLTypes["NutritionFacts"] | undefined,
	productsByCode?: GraphQLTypes["Product"] | undefined,
	productsByStocks?: GraphQLTypes["Product"] | undefined,
	productsByGroupPrices?: GraphQLTypes["Product"] | undefined,
	productsByCartItems?: GraphQLTypes["Product"] | undefined,
	productsByOrderItems?: GraphQLTypes["Product"] | undefined,
	productsByInheritedCategories?: GraphQLTypes["Product"] | undefined,
	productsByLocales?: GraphQLTypes["Product"] | undefined,
	productsByCustomerPrices?: GraphQLTypes["Product"] | undefined,
	productsByVirtualProduct?: GraphQLTypes["Product"] | undefined,
	productsByMeta?: GraphQLTypes["Product"] | undefined,
	productsByPage?: GraphQLTypes["Product"] | undefined,
	productsBySalesDays?: GraphQLTypes["Product"] | undefined,
	productsBySalesWeeks?: GraphQLTypes["Product"] | undefined,
	productsBySalesMonths?: GraphQLTypes["Product"] | undefined,
	ingredientsByQuantity?: GraphQLTypes["ProductIngredientItem"] | undefined,
	localesByLocale?: GraphQLTypes["ProductRecipeLocale"] | undefined,
	paginateProducts: GraphQLTypes["ProductConnection"],
	paginateIngredients: GraphQLTypes["ProductIngredientItemConnection"],
	paginateLocales: GraphQLTypes["ProductRecipeLocaleConnection"]
};
	["ProductRecipeMeta"]: {
	__typename: "ProductRecipeMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	products?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	color?: GraphQLTypes["FieldMeta"] | undefined,
	image?: GraphQLTypes["FieldMeta"] | undefined,
	icon?: GraphQLTypes["FieldMeta"] | undefined,
	ingredients?: GraphQLTypes["FieldMeta"] | undefined,
	needsPrepping?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	gutTuning?: GraphQLTypes["FieldMeta"] | undefined,
	freshingContainer?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined,
	nutritionFacts?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductIngredientItem"]: {
	__typename: "ProductIngredientItem",
	_meta?: GraphQLTypes["ProductIngredientItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	internalOrder: number,
	recipe?: GraphQLTypes["ProductRecipe"] | undefined,
	ingredient?: GraphQLTypes["ProductIngredient"] | undefined,
	quantity?: GraphQLTypes["ProductIngredientItemQuantity"] | undefined
};
	["ProductIngredientItemMeta"]: {
	__typename: "ProductIngredientItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	internalOrder?: GraphQLTypes["FieldMeta"] | undefined,
	recipe?: GraphQLTypes["FieldMeta"] | undefined,
	ingredient?: GraphQLTypes["FieldMeta"] | undefined,
	quantity?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductIngredientItemQuantity"]: {
	__typename: "ProductIngredientItemQuantity",
	_meta?: GraphQLTypes["ProductIngredientItemQuantityMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	unit?: GraphQLTypes["ProductIngredientItemQuantityUnit"] | undefined,
	value: number
};
	["ProductIngredientItemQuantityMeta"]: {
	__typename: "ProductIngredientItemQuantityMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	unit?: GraphQLTypes["FieldMeta"] | undefined,
	value?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductIngredientItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	internalOrder?: GraphQLTypes["OrderDirection"] | undefined,
	recipe?: GraphQLTypes["ProductRecipeOrderBy"] | undefined,
	ingredient?: GraphQLTypes["ProductIngredientOrderBy"] | undefined,
	quantity?: GraphQLTypes["ProductIngredientItemQuantityOrderBy"] | undefined
};
	["ProductIngredientItemQuantityOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	unit?: GraphQLTypes["ProductIngredientItemQuantityUnitOrderBy"] | undefined,
	value?: GraphQLTypes["OrderDirection"] | undefined
};
	["ProductRecipeLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["ProductRecipeOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	description?: GraphQLTypes["OrderDirection"] | undefined
};
	["NutritionFacts"]: {
	__typename: "NutritionFacts",
	_meta?: GraphQLTypes["NutritionFactsMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	energyKiloJoule?: number | undefined,
	energyKiloCalorie?: number | undefined,
	fatsGrams?: number | undefined,
	fatsOfWhichSaturatedGrams?: number | undefined,
	carbohydrateGrams?: number | undefined,
	carbohydrateOfWhichSugarsGrams?: number | undefined,
	proteinGrams?: number | undefined,
	fibreGrams?: number | undefined,
	saltGrams?: number | undefined
};
	["NutritionFactsMeta"]: {
	__typename: "NutritionFactsMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	energyKiloJoule?: GraphQLTypes["FieldMeta"] | undefined,
	energyKiloCalorie?: GraphQLTypes["FieldMeta"] | undefined,
	fatsGrams?: GraphQLTypes["FieldMeta"] | undefined,
	fatsOfWhichSaturatedGrams?: GraphQLTypes["FieldMeta"] | undefined,
	carbohydrateGrams?: GraphQLTypes["FieldMeta"] | undefined,
	carbohydrateOfWhichSugarsGrams?: GraphQLTypes["FieldMeta"] | undefined,
	proteinGrams?: GraphQLTypes["FieldMeta"] | undefined,
	fibreGrams?: GraphQLTypes["FieldMeta"] | undefined,
	saltGrams?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductRecipeProductsByCodeUniqueWhere"]: {
		code?: string | undefined
};
	["ProductRecipeProductsByStocksUniqueWhere"]: {
		stocks?: GraphQLTypes["ProductStockUniqueWhere"] | undefined
};
	["ProductRecipeProductsByGroupPricesUniqueWhere"]: {
		groupPrices?: GraphQLTypes["ProductGroupPriceUniqueWhere"] | undefined
};
	["ProductRecipeProductsByCartItemsUniqueWhere"]: {
		cartItems?: GraphQLTypes["CartItemUniqueWhere"] | undefined
};
	["ProductRecipeProductsByOrderItemsUniqueWhere"]: {
		orderItems?: GraphQLTypes["OrderItemUniqueWhere"] | undefined
};
	["ProductRecipeProductsByInheritedCategoriesUniqueWhere"]: {
		inheritedCategories?: GraphQLTypes["NestedProductCategoryProductUniqueWhere"] | undefined
};
	["ProductRecipeProductsByLocalesUniqueWhere"]: {
		locales?: GraphQLTypes["ProductLocaleUniqueWhere"] | undefined
};
	["ProductRecipeProductsByCustomerPricesUniqueWhere"]: {
		customerPrices?: GraphQLTypes["ProductCustomerPriceUniqueWhere"] | undefined
};
	["ProductRecipeProductsByVirtualProductUniqueWhere"]: {
		virtualProduct?: GraphQLTypes["VirtualProductUniqueWhere"] | undefined
};
	["ProductRecipeProductsByMetaUniqueWhere"]: {
		meta?: GraphQLTypes["ProductMetadataUniqueWhere"] | undefined
};
	["ProductRecipeProductsByPageUniqueWhere"]: {
		page?: GraphQLTypes["PageUniqueWhere"] | undefined
};
	["ProductRecipeProductsBySalesDaysUniqueWhere"]: {
		salesDays?: GraphQLTypes["ProductSalesDayUniqueWhere"] | undefined
};
	["ProductRecipeProductsBySalesWeeksUniqueWhere"]: {
		salesWeeks?: GraphQLTypes["ProductSalesWeekUniqueWhere"] | undefined
};
	["ProductRecipeProductsBySalesMonthsUniqueWhere"]: {
		salesMonths?: GraphQLTypes["ProductSalesMonthUniqueWhere"] | undefined
};
	["ProductRecipeIngredientsByQuantityUniqueWhere"]: {
		quantity?: GraphQLTypes["ProductIngredientItemQuantityUniqueWhere"] | undefined
};
	["ProductRecipeLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["ProductIngredientItemConnection"]: {
	__typename: "ProductIngredientItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductIngredientItemEdge"]>
};
	["ProductIngredientItemEdge"]: {
	__typename: "ProductIngredientItemEdge",
	node: GraphQLTypes["ProductIngredientItem"]
};
	["ProductRecipeLocaleConnection"]: {
	__typename: "ProductRecipeLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductRecipeLocaleEdge"]>
};
	["ProductRecipeLocaleEdge"]: {
	__typename: "ProductRecipeLocaleEdge",
	node: GraphQLTypes["ProductRecipeLocale"]
};
	["DeliveryMethodLocale"]: {
	__typename: "DeliveryMethodLocale",
	_meta?: GraphQLTypes["DeliveryMethodLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	description?: string | undefined,
	trackingCodeUrlTemplate?: string | undefined,
	processingTitle?: string | undefined,
	processingText?: string | undefined,
	processingIconUrl?: string | undefined,
	dispatchedTitle?: string | undefined,
	dispatchedText?: string | undefined,
	dispatchedIconUrl?: string | undefined,
	fulfilledTitle?: string | undefined,
	fulfilledText?: string | undefined,
	fulfilledIconUrl?: string | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	root?: GraphQLTypes["DeliveryMethod"] | undefined
};
	["DeliveryMethodLocaleMeta"]: {
	__typename: "DeliveryMethodLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined,
	trackingCodeUrlTemplate?: GraphQLTypes["FieldMeta"] | undefined,
	processingTitle?: GraphQLTypes["FieldMeta"] | undefined,
	processingText?: GraphQLTypes["FieldMeta"] | undefined,
	processingIconUrl?: GraphQLTypes["FieldMeta"] | undefined,
	dispatchedTitle?: GraphQLTypes["FieldMeta"] | undefined,
	dispatchedText?: GraphQLTypes["FieldMeta"] | undefined,
	dispatchedIconUrl?: GraphQLTypes["FieldMeta"] | undefined,
	fulfilledTitle?: GraphQLTypes["FieldMeta"] | undefined,
	fulfilledText?: GraphQLTypes["FieldMeta"] | undefined,
	fulfilledIconUrl?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined
};
	["DeliveryMethodLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	description?: GraphQLTypes["OrderDirection"] | undefined,
	trackingCodeUrlTemplate?: GraphQLTypes["OrderDirection"] | undefined,
	processingTitle?: GraphQLTypes["OrderDirection"] | undefined,
	processingText?: GraphQLTypes["OrderDirection"] | undefined,
	processingIconUrl?: GraphQLTypes["OrderDirection"] | undefined,
	dispatchedTitle?: GraphQLTypes["OrderDirection"] | undefined,
	dispatchedText?: GraphQLTypes["OrderDirection"] | undefined,
	dispatchedIconUrl?: GraphQLTypes["OrderDirection"] | undefined,
	fulfilledTitle?: GraphQLTypes["OrderDirection"] | undefined,
	fulfilledText?: GraphQLTypes["OrderDirection"] | undefined,
	fulfilledIconUrl?: GraphQLTypes["OrderDirection"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	root?: GraphQLTypes["DeliveryMethodOrderBy"] | undefined
};
	["PipelineStageLocale"]: {
	__typename: "PipelineStageLocale",
	_meta?: GraphQLTypes["PipelineStageLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	root?: GraphQLTypes["PipelineStage"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined
};
	["PipelineStageLocaleMeta"]: {
	__typename: "PipelineStageLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined
};
	["PipelineStage"]: {
	__typename: "PipelineStage",
	_meta?: GraphQLTypes["PipelineStageMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["PipelineStageItem"]>,
	pipeline?: GraphQLTypes["Pipeline"] | undefined,
	order: number,
	locales: Array<GraphQLTypes["PipelineStageLocale"]>,
	sentiment?: GraphQLTypes["PipelineStageSentiment"] | undefined,
	type: GraphQLTypes["PipelineStageType"],
	forms: Array<GraphQLTypes["LeadForm"]>,
	showItemsWeight: boolean,
	showItemsPrice: boolean,
	itemsByLead?: GraphQLTypes["PipelineStageItem"] | undefined,
	localesByLocale?: GraphQLTypes["PipelineStageLocale"] | undefined,
	formsByCode?: GraphQLTypes["LeadForm"] | undefined,
	formsByLeads?: GraphQLTypes["LeadForm"] | undefined,
	paginateItems: GraphQLTypes["PipelineStageItemConnection"],
	paginateLocales: GraphQLTypes["PipelineStageLocaleConnection"],
	paginateForms: GraphQLTypes["LeadFormConnection"]
};
	["PipelineStageMeta"]: {
	__typename: "PipelineStageMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined,
	pipeline?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	sentiment?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	forms?: GraphQLTypes["FieldMeta"] | undefined,
	showItemsWeight?: GraphQLTypes["FieldMeta"] | undefined,
	showItemsPrice?: GraphQLTypes["FieldMeta"] | undefined
};
	["PipelineStageItem"]: {
	__typename: "PipelineStageItem",
	_meta?: GraphQLTypes["PipelineStageItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	list?: GraphQLTypes["PipelineStage"] | undefined,
	lead?: GraphQLTypes["PipelineLead"] | undefined,
	order: number
};
	["PipelineStageItemMeta"]: {
	__typename: "PipelineStageItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	lead?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined
};
	["PipelineLead"]: {
	__typename: "PipelineLead",
	_meta?: GraphQLTypes["PipelineLeadMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt: GraphQLTypes["DateTime"],
	stageItem?: GraphQLTypes["PipelineStageItem"] | undefined,
	contactPerson?: string | undefined,
	customer?: GraphQLTypes["Customer"] | undefined,
	cafeType?: string | undefined,
	offerType?: string | undefined,
	ownMachine: boolean,
	customerCity?: string | undefined,
	companyId?: string | undefined,
	customerName?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	form?: GraphQLTypes["LeadForm"] | undefined,
	meta?: string | undefined,
	multiroasterType?: string | undefined
};
	["PipelineLeadMeta"]: {
	__typename: "PipelineLeadMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	stageItem?: GraphQLTypes["FieldMeta"] | undefined,
	contactPerson?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined,
	cafeType?: GraphQLTypes["FieldMeta"] | undefined,
	offerType?: GraphQLTypes["FieldMeta"] | undefined,
	ownMachine?: GraphQLTypes["FieldMeta"] | undefined,
	customerCity?: GraphQLTypes["FieldMeta"] | undefined,
	companyId?: GraphQLTypes["FieldMeta"] | undefined,
	customerName?: GraphQLTypes["FieldMeta"] | undefined,
	email?: GraphQLTypes["FieldMeta"] | undefined,
	phone?: GraphQLTypes["FieldMeta"] | undefined,
	form?: GraphQLTypes["FieldMeta"] | undefined,
	meta?: GraphQLTypes["FieldMeta"] | undefined,
	multiroasterType?: GraphQLTypes["FieldMeta"] | undefined
};
	["LeadForm"]: {
	__typename: "LeadForm",
	_meta?: GraphQLTypes["LeadFormMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	code: string,
	stage?: GraphQLTypes["PipelineStage"] | undefined,
	leads: Array<GraphQLTypes["PipelineLead"]>,
	leadsByStageItem?: GraphQLTypes["PipelineLead"] | undefined,
	paginateLeads: GraphQLTypes["PipelineLeadConnection"]
};
	["LeadFormMeta"]: {
	__typename: "LeadFormMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	code?: GraphQLTypes["FieldMeta"] | undefined,
	stage?: GraphQLTypes["FieldMeta"] | undefined,
	leads?: GraphQLTypes["FieldMeta"] | undefined
};
	["PipelineLeadOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	stageItem?: GraphQLTypes["PipelineStageItemOrderBy"] | undefined,
	contactPerson?: GraphQLTypes["OrderDirection"] | undefined,
	customer?: GraphQLTypes["CustomerOrderBy"] | undefined,
	cafeType?: GraphQLTypes["OrderDirection"] | undefined,
	offerType?: GraphQLTypes["OrderDirection"] | undefined,
	ownMachine?: GraphQLTypes["OrderDirection"] | undefined,
	customerCity?: GraphQLTypes["OrderDirection"] | undefined,
	companyId?: GraphQLTypes["OrderDirection"] | undefined,
	customerName?: GraphQLTypes["OrderDirection"] | undefined,
	email?: GraphQLTypes["OrderDirection"] | undefined,
	phone?: GraphQLTypes["OrderDirection"] | undefined,
	form?: GraphQLTypes["LeadFormOrderBy"] | undefined,
	meta?: GraphQLTypes["OrderDirection"] | undefined,
	multiroasterType?: GraphQLTypes["OrderDirection"] | undefined
};
	["PipelineStageItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	list?: GraphQLTypes["PipelineStageOrderBy"] | undefined,
	lead?: GraphQLTypes["PipelineLeadOrderBy"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined
};
	["PipelineStageOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	pipeline?: GraphQLTypes["PipelineOrderBy"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	sentiment?: GraphQLTypes["PipelineStageSentimentOrderBy"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	showItemsWeight?: GraphQLTypes["OrderDirection"] | undefined,
	showItemsPrice?: GraphQLTypes["OrderDirection"] | undefined
};
	["PipelineOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	unique?: GraphQLTypes["OrderDirection"] | undefined
};
	["PipelineStageSentimentOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	internalName?: GraphQLTypes["OrderDirection"] | undefined,
	backgroundColor?: GraphQLTypes["OrderDirection"] | undefined,
	textColor?: GraphQLTypes["OrderDirection"] | undefined
};
	["LeadFormOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	code?: GraphQLTypes["OrderDirection"] | undefined,
	stage?: GraphQLTypes["PipelineStageOrderBy"] | undefined
};
	["LeadFormLeadsByStageItemUniqueWhere"]: {
		stageItem?: GraphQLTypes["PipelineStageItemUniqueWhere"] | undefined
};
	["PipelineLeadConnection"]: {
	__typename: "PipelineLeadConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PipelineLeadEdge"]>
};
	["PipelineLeadEdge"]: {
	__typename: "PipelineLeadEdge",
	node: GraphQLTypes["PipelineLead"]
};
	["Pipeline"]: {
	__typename: "Pipeline",
	_meta?: GraphQLTypes["PipelineMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	stages: Array<GraphQLTypes["PipelineStage"]>,
	stagesByItems?: GraphQLTypes["PipelineStage"] | undefined,
	stagesByLocales?: GraphQLTypes["PipelineStage"] | undefined,
	stagesByForms?: GraphQLTypes["PipelineStage"] | undefined,
	paginateStages: GraphQLTypes["PipelineStageConnection"]
};
	["PipelineMeta"]: {
	__typename: "PipelineMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	unique?: GraphQLTypes["FieldMeta"] | undefined,
	stages?: GraphQLTypes["FieldMeta"] | undefined
};
	["PipelineStagesByItemsUniqueWhere"]: {
		items?: GraphQLTypes["PipelineStageItemUniqueWhere"] | undefined
};
	["PipelineStagesByLocalesUniqueWhere"]: {
		locales?: GraphQLTypes["PipelineStageLocaleUniqueWhere"] | undefined
};
	["PipelineStagesByFormsUniqueWhere"]: {
		forms?: GraphQLTypes["LeadFormUniqueWhere"] | undefined
};
	["PipelineStageConnection"]: {
	__typename: "PipelineStageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PipelineStageEdge"]>
};
	["PipelineStageEdge"]: {
	__typename: "PipelineStageEdge",
	node: GraphQLTypes["PipelineStage"]
};
	["PipelineStageLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["PipelineStageOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined
};
	["PipelineStageSentiment"]: {
	__typename: "PipelineStageSentiment",
	_meta?: GraphQLTypes["PipelineStageSentimentMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	internalName: string,
	backgroundColor?: string | undefined,
	textColor?: string | undefined
};
	["PipelineStageSentimentMeta"]: {
	__typename: "PipelineStageSentimentMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	internalName?: GraphQLTypes["FieldMeta"] | undefined,
	backgroundColor?: GraphQLTypes["FieldMeta"] | undefined,
	textColor?: GraphQLTypes["FieldMeta"] | undefined
};
	["PipelineStageItemsByLeadUniqueWhere"]: {
		lead?: GraphQLTypes["PipelineLeadUniqueWhere"] | undefined
};
	["PipelineStageLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["PipelineStageFormsByCodeUniqueWhere"]: {
		code?: string | undefined
};
	["PipelineStageFormsByLeadsUniqueWhere"]: {
		leads?: GraphQLTypes["PipelineLeadUniqueWhere"] | undefined
};
	["PipelineStageItemConnection"]: {
	__typename: "PipelineStageItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PipelineStageItemEdge"]>
};
	["PipelineStageItemEdge"]: {
	__typename: "PipelineStageItemEdge",
	node: GraphQLTypes["PipelineStageItem"]
};
	["PipelineStageLocaleConnection"]: {
	__typename: "PipelineStageLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PipelineStageLocaleEdge"]>
};
	["PipelineStageLocaleEdge"]: {
	__typename: "PipelineStageLocaleEdge",
	node: GraphQLTypes["PipelineStageLocale"]
};
	["LeadFormConnection"]: {
	__typename: "LeadFormConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LeadFormEdge"]>
};
	["LeadFormEdge"]: {
	__typename: "LeadFormEdge",
	node: GraphQLTypes["LeadForm"]
};
	["SubscriptionBoxLocale"]: {
	__typename: "SubscriptionBoxLocale",
	_meta?: GraphQLTypes["SubscriptionBoxLocaleMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	title?: string | undefined,
	stickerText?: string | undefined,
	descriptionText?: string | undefined,
	root?: GraphQLTypes["SubscriptionBox"] | undefined,
	locale?: GraphQLTypes["Locale"] | undefined,
	secondaryTitle?: string | undefined,
	texts?: GraphQLTypes["TextList"] | undefined,
	secondaryTexts?: GraphQLTypes["TextList"] | undefined
};
	["SubscriptionBoxLocaleMeta"]: {
	__typename: "SubscriptionBoxLocaleMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	stickerText?: GraphQLTypes["FieldMeta"] | undefined,
	descriptionText?: GraphQLTypes["FieldMeta"] | undefined,
	root?: GraphQLTypes["FieldMeta"] | undefined,
	locale?: GraphQLTypes["FieldMeta"] | undefined,
	secondaryTitle?: GraphQLTypes["FieldMeta"] | undefined,
	texts?: GraphQLTypes["FieldMeta"] | undefined,
	secondaryTexts?: GraphQLTypes["FieldMeta"] | undefined
};
	["SubscriptionBox"]: {
	__typename: "SubscriptionBox",
	_meta?: GraphQLTypes["SubscriptionBoxMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	locales: Array<GraphQLTypes["SubscriptionBoxLocale"]>,
	unique: GraphQLTypes["One"],
	localesByLocale?: GraphQLTypes["SubscriptionBoxLocale"] | undefined,
	localesByTexts?: GraphQLTypes["SubscriptionBoxLocale"] | undefined,
	localesBySecondaryTexts?: GraphQLTypes["SubscriptionBoxLocale"] | undefined,
	paginateLocales: GraphQLTypes["SubscriptionBoxLocaleConnection"]
};
	["SubscriptionBoxMeta"]: {
	__typename: "SubscriptionBoxMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	locales?: GraphQLTypes["FieldMeta"] | undefined,
	unique?: GraphQLTypes["FieldMeta"] | undefined
};
	["SubscriptionBoxLocaleOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	stickerText?: GraphQLTypes["OrderDirection"] | undefined,
	descriptionText?: GraphQLTypes["OrderDirection"] | undefined,
	root?: GraphQLTypes["SubscriptionBoxOrderBy"] | undefined,
	locale?: GraphQLTypes["LocaleOrderBy"] | undefined,
	secondaryTitle?: GraphQLTypes["OrderDirection"] | undefined,
	texts?: GraphQLTypes["TextListOrderBy"] | undefined,
	secondaryTexts?: GraphQLTypes["TextListOrderBy"] | undefined
};
	["SubscriptionBoxOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	unique?: GraphQLTypes["OrderDirection"] | undefined
};
	["SubscriptionBoxLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["SubscriptionBoxLocalesByTextsUniqueWhere"]: {
		texts?: GraphQLTypes["TextListUniqueWhere"] | undefined
};
	["SubscriptionBoxLocalesBySecondaryTextsUniqueWhere"]: {
		secondaryTexts?: GraphQLTypes["TextListUniqueWhere"] | undefined
};
	["SubscriptionBoxLocaleConnection"]: {
	__typename: "SubscriptionBoxLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SubscriptionBoxLocaleEdge"]>
};
	["SubscriptionBoxLocaleEdge"]: {
	__typename: "SubscriptionBoxLocaleEdge",
	node: GraphQLTypes["SubscriptionBoxLocale"]
};
	["LocaleBusinessCategoriesByRootUniqueWhere"]: {
		root?: GraphQLTypes["BusinessCategoryUniqueWhere"] | undefined
};
	["LocaleProductCategoryListsByRootUniqueWhere"]: {
		root?: GraphQLTypes["ProductCategoryListUniqueWhere"] | undefined
};
	["LocaleProductIngredientsByRootUniqueWhere"]: {
		root?: GraphQLTypes["ProductIngredientUniqueWhere"] | undefined
};
	["LocaleOrderRecurrencesByRootUniqueWhere"]: {
		root?: GraphQLTypes["OrderRecurrenceUniqueWhere"] | undefined
};
	["LocaleBlogsByRootUniqueWhere"]: {
		root?: GraphQLTypes["BlogUniqueWhere"] | undefined
};
	["LocaleBlogPostsByRootUniqueWhere"]: {
		root?: GraphQLTypes["BlogPostUniqueWhere"] | undefined
};
	["LocaleBlogPostsByCoverUniqueWhere"]: {
		cover?: GraphQLTypes["CoverUniqueWhere"] | undefined
};
	["LocaleBlogPostsByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["LocaleBlogPostsByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"] | undefined
};
	["LocaleBlogPostsBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["LocaleMenusByRootUniqueWhere"]: {
		root?: GraphQLTypes["SiteMenuUniqueWhere"] | undefined
};
	["LocaleMenusByItemsUniqueWhere"]: {
		items?: GraphQLTypes["MenuItemUniqueWhere"] | undefined
};
	["LocaleMenusBySecondaryItemsUniqueWhere"]: {
		secondaryItems?: GraphQLTypes["LinkListUniqueWhere"] | undefined
};
	["LocalePagesByRootUniqueWhere"]: {
		root?: GraphQLTypes["PageUniqueWhere"] | undefined
};
	["LocalePagesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"] | undefined
};
	["LocalePagesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"] | undefined
};
	["LocalePagesByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"] | undefined
};
	["LocalePagesByCoverUniqueWhere"]: {
		cover?: GraphQLTypes["CoverUniqueWhere"] | undefined
};
	["LocaleProductIngredientCategoriesByRootUniqueWhere"]: {
		root?: GraphQLTypes["ProductIngredientCategoryUniqueWhere"] | undefined
};
	["LocaleAllergensByRootUniqueWhere"]: {
		root?: GraphQLTypes["AllergenUniqueWhere"] | undefined
};
	["LocaleProductPackingsByRootUniqueWhere"]: {
		root?: GraphQLTypes["ProductPackingUniqueWhere"] | undefined
};
	["LocaleProductsByRootUniqueWhere"]: {
		root?: GraphQLTypes["ProductUniqueWhere"] | undefined
};
	["LocaleProductsByFeatureListUniqueWhere"]: {
		featureList?: GraphQLTypes["TextListUniqueWhere"] | undefined
};
	["LocaleProductRecipesByRootUniqueWhere"]: {
		root?: GraphQLTypes["ProductRecipeUniqueWhere"] | undefined
};
	["LocalePointOfSaleCategoriesByRootUniqueWhere"]: {
		root?: GraphQLTypes["PointOfSaleCategoryUniqueWhere"] | undefined
};
	["LocalePointOfSaleCategoryProductsByRootUniqueWhere"]: {
		root?: GraphQLTypes["PointOfSaleCategoryProductUniqueWhere"] | undefined
};
	["LocaleDeliveryMethodsByRootUniqueWhere"]: {
		root?: GraphQLTypes["DeliveryMethodUniqueWhere"] | undefined
};
	["LocaleIngredientSuppliersByRootUniqueWhere"]: {
		root?: GraphQLTypes["IngredientSupplierUniqueWhere"] | undefined
};
	["LocaleIdentificationCodesByRootUniqueWhere"]: {
		root?: GraphQLTypes["IdentificationCodeUniqueWhere"] | undefined
};
	["LocalePipelineStagesByRootUniqueWhere"]: {
		root?: GraphQLTypes["PipelineStageUniqueWhere"] | undefined
};
	["LocaleSubscriptionBoxesByRootUniqueWhere"]: {
		root?: GraphQLTypes["SubscriptionBoxUniqueWhere"] | undefined
};
	["LocaleSubscriptionBoxesByTextsUniqueWhere"]: {
		texts?: GraphQLTypes["TextListUniqueWhere"] | undefined
};
	["LocaleSubscriptionBoxesBySecondaryTextsUniqueWhere"]: {
		secondaryTexts?: GraphQLTypes["TextListUniqueWhere"] | undefined
};
	["LocaleBusinessServicesByRootUniqueWhere"]: {
		root?: GraphQLTypes["BusinessServiceUniqueWhere"] | undefined
};
	["ProductPackingLocaleConnection"]: {
	__typename: "ProductPackingLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductPackingLocaleEdge"]>
};
	["ProductPackingLocaleEdge"]: {
	__typename: "ProductPackingLocaleEdge",
	node: GraphQLTypes["ProductPackingLocale"]
};
	["ProductLocaleConnection"]: {
	__typename: "ProductLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductLocaleEdge"]>
};
	["ProductLocaleEdge"]: {
	__typename: "ProductLocaleEdge",
	node: GraphQLTypes["ProductLocale"]
};
	["DeliveryMethodLocaleConnection"]: {
	__typename: "DeliveryMethodLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DeliveryMethodLocaleEdge"]>
};
	["DeliveryMethodLocaleEdge"]: {
	__typename: "DeliveryMethodLocaleEdge",
	node: GraphQLTypes["DeliveryMethodLocale"]
};
	["PreparedPackingQuantity"]: {
	__typename: "PreparedPackingQuantity",
	_meta?: GraphQLTypes["PreparedPackingQuantityMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	date: GraphQLTypes["Date"],
	quantity?: number | undefined,
	recipe?: GraphQLTypes["ProductRecipe"] | undefined,
	packing?: GraphQLTypes["ProductPacking"] | undefined,
	packedInCardboard: boolean
};
	["PreparedPackingQuantityMeta"]: {
	__typename: "PreparedPackingQuantityMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	date?: GraphQLTypes["FieldMeta"] | undefined,
	quantity?: GraphQLTypes["FieldMeta"] | undefined,
	recipe?: GraphQLTypes["FieldMeta"] | undefined,
	packing?: GraphQLTypes["FieldMeta"] | undefined,
	packedInCardboard?: GraphQLTypes["FieldMeta"] | undefined
};
	["PreparedPackingQuantityOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	date?: GraphQLTypes["OrderDirection"] | undefined,
	quantity?: GraphQLTypes["OrderDirection"] | undefined,
	recipe?: GraphQLTypes["ProductRecipeOrderBy"] | undefined,
	packing?: GraphQLTypes["ProductPackingOrderBy"] | undefined,
	packedInCardboard?: GraphQLTypes["OrderDirection"] | undefined
};
	["ProductPackingLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["PreparedPackingQuantityConnection"]: {
	__typename: "PreparedPackingQuantityConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PreparedPackingQuantityEdge"]>
};
	["PreparedPackingQuantityEdge"]: {
	__typename: "PreparedPackingQuantityEdge",
	node: GraphQLTypes["PreparedPackingQuantity"]
};
	["ProductStock"]: {
	__typename: "ProductStock",
	_meta?: GraphQLTypes["ProductStockMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	quantity: number,
	product?: GraphQLTypes["Product"] | undefined,
	store?: GraphQLTypes["Store"] | undefined
};
	["ProductStockMeta"]: {
	__typename: "ProductStockMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	quantity?: GraphQLTypes["FieldMeta"] | undefined,
	product?: GraphQLTypes["FieldMeta"] | undefined,
	store?: GraphQLTypes["FieldMeta"] | undefined
};
	["Store"]: {
	__typename: "Store",
	_meta?: GraphQLTypes["StoreMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	code: string,
	description?: string | undefined,
	internalNote?: string | undefined
};
	["StoreMeta"]: {
	__typename: "StoreMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	code?: GraphQLTypes["FieldMeta"] | undefined,
	description?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductStockOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	quantity?: GraphQLTypes["OrderDirection"] | undefined,
	product?: GraphQLTypes["ProductOrderBy"] | undefined,
	store?: GraphQLTypes["StoreOrderBy"] | undefined
};
	["StoreOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	code?: GraphQLTypes["OrderDirection"] | undefined,
	description?: GraphQLTypes["OrderDirection"] | undefined,
	internalNote?: GraphQLTypes["OrderDirection"] | undefined
};
	["ProductGroupPrice"]: {
	__typename: "ProductGroupPrice",
	_meta?: GraphQLTypes["ProductGroupPriceMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	priceCents: number,
	group?: GraphQLTypes["CustomerGroup"] | undefined,
	product?: GraphQLTypes["Product"] | undefined
};
	["ProductGroupPriceMeta"]: {
	__typename: "ProductGroupPriceMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	priceCents?: GraphQLTypes["FieldMeta"] | undefined,
	group?: GraphQLTypes["FieldMeta"] | undefined,
	product?: GraphQLTypes["FieldMeta"] | undefined
};
	["CustomerGroup"]: {
	__typename: "CustomerGroup",
	_meta?: GraphQLTypes["CustomerGroupMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	productPrices: Array<GraphQLTypes["ProductGroupPrice"]>,
	customers: Array<GraphQLTypes["Customer"]>,
	discountPermille?: number | undefined,
	code?: string | undefined,
	doubleshotLegacyId?: string | undefined,
	productPricesByProduct?: GraphQLTypes["ProductGroupPrice"] | undefined,
	customersByDoubleshotLegacyId?: GraphQLTypes["Customer"] | undefined,
	customersByAddresses?: GraphQLTypes["Customer"] | undefined,
	customersByDefaultBillingAddress?: GraphQLTypes["Customer"] | undefined,
	customersByDefaultPaymentMethod?: GraphQLTypes["Customer"] | undefined,
	customersByCredits?: GraphQLTypes["Customer"] | undefined,
	customersByPaymentMethods?: GraphQLTypes["Customer"] | undefined,
	customersByOrders?: GraphQLTypes["Customer"] | undefined,
	customersByPermissions?: GraphQLTypes["Customer"] | undefined,
	customersByName?: GraphQLTypes["Customer"] | undefined,
	customersByIngredientRatings?: GraphQLTypes["Customer"] | undefined,
	customersByBusiness?: GraphQLTypes["Customer"] | undefined,
	customersByCarts?: GraphQLTypes["Customer"] | undefined,
	customersByShortcutList?: GraphQLTypes["Customer"] | undefined,
	customersByUser?: GraphQLTypes["Customer"] | undefined,
	customersByInvoices?: GraphQLTypes["Customer"] | undefined,
	customersByInvoicingPlan?: GraphQLTypes["Customer"] | undefined,
	customersByBillingSubjects?: GraphQLTypes["Customer"] | undefined,
	customersByOfferedProducts?: GraphQLTypes["Customer"] | undefined,
	customersByDefaultDeliveryAddress?: GraphQLTypes["Customer"] | undefined,
	customersByDefaultBillingSubject?: GraphQLTypes["Customer"] | undefined,
	customersByAnonymousSession?: GraphQLTypes["Customer"] | undefined,
	customersByBoughtVouchers?: GraphQLTypes["Customer"] | undefined,
	customersByOwnsVouchers?: GraphQLTypes["Customer"] | undefined,
	customersByRedeemedVouchers?: GraphQLTypes["Customer"] | undefined,
	customersBySpending?: GraphQLTypes["Customer"] | undefined,
	customersByCustomerTabs?: GraphQLTypes["Customer"] | undefined,
	customersByLead?: GraphQLTypes["Customer"] | undefined,
	customersByMeta?: GraphQLTypes["Customer"] | undefined,
	paginateProductPrices: GraphQLTypes["ProductGroupPriceConnection"],
	paginateCustomers: GraphQLTypes["CustomerConnection"]
};
	["CustomerGroupMeta"]: {
	__typename: "CustomerGroupMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	productPrices?: GraphQLTypes["FieldMeta"] | undefined,
	customers?: GraphQLTypes["FieldMeta"] | undefined,
	discountPermille?: GraphQLTypes["FieldMeta"] | undefined,
	code?: GraphQLTypes["FieldMeta"] | undefined,
	doubleshotLegacyId?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductGroupPriceOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	priceCents?: GraphQLTypes["OrderDirection"] | undefined,
	group?: GraphQLTypes["CustomerGroupOrderBy"] | undefined,
	product?: GraphQLTypes["ProductOrderBy"] | undefined
};
	["CustomerGroupProductPricesByProductUniqueWhere"]: {
		product?: GraphQLTypes["ProductUniqueWhere"] | undefined
};
	["CustomerGroupCustomersByDoubleshotLegacyIdUniqueWhere"]: {
		doubleshotLegacyId?: string | undefined
};
	["CustomerGroupCustomersByAddressesUniqueWhere"]: {
		addresses?: GraphQLTypes["AddressUniqueWhere"] | undefined
};
	["CustomerGroupCustomersByDefaultBillingAddressUniqueWhere"]: {
		defaultBillingAddress?: GraphQLTypes["AddressUniqueWhere"] | undefined
};
	["CustomerGroupCustomersByDefaultPaymentMethodUniqueWhere"]: {
		defaultPaymentMethod?: GraphQLTypes["CustomerPaymentMethodUniqueWhere"] | undefined
};
	["CustomerGroupCustomersByCreditsUniqueWhere"]: {
		credits?: GraphQLTypes["CustomerCreditUniqueWhere"] | undefined
};
	["CustomerGroupCustomersByPaymentMethodsUniqueWhere"]: {
		paymentMethods?: GraphQLTypes["CustomerPaymentMethodUniqueWhere"] | undefined
};
	["CustomerGroupCustomersByOrdersUniqueWhere"]: {
		orders?: GraphQLTypes["OrderUniqueWhere"] | undefined
};
	["CustomerGroupCustomersByPermissionsUniqueWhere"]: {
		permissions?: GraphQLTypes["CustomerPermissionsUniqueWhere"] | undefined
};
	["CustomerGroupCustomersByNameUniqueWhere"]: {
		name?: GraphQLTypes["CustomerNameUniqueWhere"] | undefined
};
	["CustomerGroupCustomersByIngredientRatingsUniqueWhere"]: {
		ingredientRatings?: GraphQLTypes["CustomerIngredientRatingUniqueWhere"] | undefined
};
	["CustomerGroupCustomersByBusinessUniqueWhere"]: {
		business?: GraphQLTypes["BusinessCustomerUniqueWhere"] | undefined
};
	["CustomerGroupCustomersByCartsUniqueWhere"]: {
		carts?: GraphQLTypes["CartUniqueWhere"] | undefined
};
	["CustomerGroupCustomersByShortcutListUniqueWhere"]: {
		shortcutList?: GraphQLTypes["ApplicationShortcutListUniqueWhere"] | undefined
};
	["CustomerGroupCustomersByUserUniqueWhere"]: {
		user?: GraphQLTypes["UserUniqueWhere"] | undefined
};
	["CustomerGroupCustomersByInvoicesUniqueWhere"]: {
		invoices?: GraphQLTypes["InvoiceUniqueWhere"] | undefined
};
	["CustomerGroupCustomersByInvoicingPlanUniqueWhere"]: {
		invoicingPlan?: GraphQLTypes["InvoicingPlanUniqueWhere"] | undefined
};
	["CustomerGroupCustomersByBillingSubjectsUniqueWhere"]: {
		billingSubjects?: GraphQLTypes["BillingSubjectUniqueWhere"] | undefined
};
	["CustomerGroupCustomersByOfferedProductsUniqueWhere"]: {
		offeredProducts?: GraphQLTypes["ProductCustomerPriceUniqueWhere"] | undefined
};
	["CustomerGroupCustomersByDefaultDeliveryAddressUniqueWhere"]: {
		defaultDeliveryAddress?: GraphQLTypes["AddressUniqueWhere"] | undefined
};
	["CustomerGroupCustomersByDefaultBillingSubjectUniqueWhere"]: {
		defaultBillingSubject?: GraphQLTypes["BillingSubjectUniqueWhere"] | undefined
};
	["CustomerGroupCustomersByAnonymousSessionUniqueWhere"]: {
		anonymousSession?: GraphQLTypes["AnonymousSessionUniqueWhere"] | undefined
};
	["CustomerGroupCustomersByBoughtVouchersUniqueWhere"]: {
		boughtVouchers?: GraphQLTypes["VoucherUniqueWhere"] | undefined
};
	["CustomerGroupCustomersByOwnsVouchersUniqueWhere"]: {
		ownsVouchers?: GraphQLTypes["VoucherUniqueWhere"] | undefined
};
	["CustomerGroupCustomersByRedeemedVouchersUniqueWhere"]: {
		redeemedVouchers?: GraphQLTypes["VoucherRedemptionUniqueWhere"] | undefined
};
	["CustomerGroupCustomersBySpendingUniqueWhere"]: {
		spending?: GraphQLTypes["CustomerSpendingUniqueWhere"] | undefined
};
	["CustomerGroupCustomersByCustomerTabsUniqueWhere"]: {
		customerTabs?: GraphQLTypes["CustomerTabUniqueWhere"] | undefined
};
	["CustomerGroupCustomersByLeadUniqueWhere"]: {
		lead?: GraphQLTypes["PipelineLeadUniqueWhere"] | undefined
};
	["CustomerGroupCustomersByMetaUniqueWhere"]: {
		meta?: GraphQLTypes["CustomerMetadataUniqueWhere"] | undefined
};
	["ProductGroupPriceConnection"]: {
	__typename: "ProductGroupPriceConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductGroupPriceEdge"]>
};
	["ProductGroupPriceEdge"]: {
	__typename: "ProductGroupPriceEdge",
	node: GraphQLTypes["ProductGroupPrice"]
};
	["ProductCustomerPrice"]: {
	__typename: "ProductCustomerPrice",
	_meta?: GraphQLTypes["ProductCustomerPriceMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	groupDiscountPermille?: number | undefined,
	groupPriceCents?: number | undefined,
	fullPriceCents: number,
	discountedPriceCents?: number | undefined,
	priceCents: number,
	offered: boolean,
	notDiscountable: boolean,
	customer?: GraphQLTypes["Customer"] | undefined,
	product?: GraphQLTypes["Product"] | undefined
};
	["ProductCustomerPriceMeta"]: {
	__typename: "ProductCustomerPriceMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	groupDiscountPermille?: GraphQLTypes["FieldMeta"] | undefined,
	groupPriceCents?: GraphQLTypes["FieldMeta"] | undefined,
	fullPriceCents?: GraphQLTypes["FieldMeta"] | undefined,
	discountedPriceCents?: GraphQLTypes["FieldMeta"] | undefined,
	priceCents?: GraphQLTypes["FieldMeta"] | undefined,
	offered?: GraphQLTypes["FieldMeta"] | undefined,
	notDiscountable?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined,
	product?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductCustomerPriceOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	groupDiscountPermille?: GraphQLTypes["OrderDirection"] | undefined,
	groupPriceCents?: GraphQLTypes["OrderDirection"] | undefined,
	fullPriceCents?: GraphQLTypes["OrderDirection"] | undefined,
	discountedPriceCents?: GraphQLTypes["OrderDirection"] | undefined,
	priceCents?: GraphQLTypes["OrderDirection"] | undefined,
	offered?: GraphQLTypes["OrderDirection"] | undefined,
	notDiscountable?: GraphQLTypes["OrderDirection"] | undefined,
	customer?: GraphQLTypes["CustomerOrderBy"] | undefined,
	product?: GraphQLTypes["ProductOrderBy"] | undefined
};
	["ProductMetadata"]: {
	__typename: "ProductMetadata",
	_meta?: GraphQLTypes["ProductMetadataMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	archived: boolean,
	available: boolean,
	availableQuantity: number,
	product?: GraphQLTypes["Product"] | undefined
};
	["ProductMetadataMeta"]: {
	__typename: "ProductMetadataMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	archived?: GraphQLTypes["FieldMeta"] | undefined,
	available?: GraphQLTypes["FieldMeta"] | undefined,
	availableQuantity?: GraphQLTypes["FieldMeta"] | undefined,
	product?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductSalesDay"]: {
	__typename: "ProductSalesDay",
	_meta?: GraphQLTypes["ProductSalesDayMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	productName: string,
	orderDate?: GraphQLTypes["Date"] | undefined,
	priceCentsSum: number,
	sum: number,
	product?: GraphQLTypes["Product"] | undefined
};
	["ProductSalesDayMeta"]: {
	__typename: "ProductSalesDayMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	productName?: GraphQLTypes["FieldMeta"] | undefined,
	orderDate?: GraphQLTypes["FieldMeta"] | undefined,
	priceCentsSum?: GraphQLTypes["FieldMeta"] | undefined,
	sum?: GraphQLTypes["FieldMeta"] | undefined,
	product?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductSalesDayOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	productName?: GraphQLTypes["OrderDirection"] | undefined,
	orderDate?: GraphQLTypes["OrderDirection"] | undefined,
	priceCentsSum?: GraphQLTypes["OrderDirection"] | undefined,
	sum?: GraphQLTypes["OrderDirection"] | undefined,
	product?: GraphQLTypes["ProductOrderBy"] | undefined
};
	["ProductSalesWeek"]: {
	__typename: "ProductSalesWeek",
	_meta?: GraphQLTypes["ProductSalesWeekMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	productName: string,
	orderDate?: GraphQLTypes["Date"] | undefined,
	priceCentsSum: number,
	sum: number,
	product?: GraphQLTypes["Product"] | undefined
};
	["ProductSalesWeekMeta"]: {
	__typename: "ProductSalesWeekMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	productName?: GraphQLTypes["FieldMeta"] | undefined,
	orderDate?: GraphQLTypes["FieldMeta"] | undefined,
	priceCentsSum?: GraphQLTypes["FieldMeta"] | undefined,
	sum?: GraphQLTypes["FieldMeta"] | undefined,
	product?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductSalesWeekOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	productName?: GraphQLTypes["OrderDirection"] | undefined,
	orderDate?: GraphQLTypes["OrderDirection"] | undefined,
	priceCentsSum?: GraphQLTypes["OrderDirection"] | undefined,
	sum?: GraphQLTypes["OrderDirection"] | undefined,
	product?: GraphQLTypes["ProductOrderBy"] | undefined
};
	["ProductSalesMonth"]: {
	__typename: "ProductSalesMonth",
	_meta?: GraphQLTypes["ProductSalesMonthMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	productName: string,
	orderDate?: GraphQLTypes["Date"] | undefined,
	priceCentsSum: number,
	sum: number,
	product?: GraphQLTypes["Product"] | undefined
};
	["ProductSalesMonthMeta"]: {
	__typename: "ProductSalesMonthMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	productName?: GraphQLTypes["FieldMeta"] | undefined,
	orderDate?: GraphQLTypes["FieldMeta"] | undefined,
	priceCentsSum?: GraphQLTypes["FieldMeta"] | undefined,
	sum?: GraphQLTypes["FieldMeta"] | undefined,
	product?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProductSalesMonthOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	productName?: GraphQLTypes["OrderDirection"] | undefined,
	orderDate?: GraphQLTypes["OrderDirection"] | undefined,
	priceCentsSum?: GraphQLTypes["OrderDirection"] | undefined,
	sum?: GraphQLTypes["OrderDirection"] | undefined,
	product?: GraphQLTypes["ProductOrderBy"] | undefined
};
	["ProductStocksByStoreUniqueWhere"]: {
		store?: GraphQLTypes["StoreUniqueWhere"] | undefined
};
	["ProductGroupPricesByGroupUniqueWhere"]: {
		group?: GraphQLTypes["CustomerGroupUniqueWhere"] | undefined
};
	["ProductCartItemsByCartUniqueWhere"]: {
		cart?: GraphQLTypes["CartUniqueWhere"] | undefined
};
	["ProductOrderItemsByVirtualProductEffectsUniqueWhere"]: {
		virtualProductEffects?: GraphQLTypes["VirtualProductEffectUniqueWhere"] | undefined
};
	["ProductLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["ProductLocalesByFeatureListUniqueWhere"]: {
		featureList?: GraphQLTypes["TextListUniqueWhere"] | undefined
};
	["ProductCustomerPricesByCustomerUniqueWhere"]: {
		customer?: GraphQLTypes["CustomerUniqueWhere"] | undefined
};
	["ProductStockConnection"]: {
	__typename: "ProductStockConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductStockEdge"]>
};
	["ProductStockEdge"]: {
	__typename: "ProductStockEdge",
	node: GraphQLTypes["ProductStock"]
};
	["DeliveryZoneConnection"]: {
	__typename: "DeliveryZoneConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DeliveryZoneEdge"]>
};
	["DeliveryZoneEdge"]: {
	__typename: "DeliveryZoneEdge",
	node: GraphQLTypes["DeliveryZone"]
};
	["ProductCustomerPriceConnection"]: {
	__typename: "ProductCustomerPriceConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductCustomerPriceEdge"]>
};
	["ProductCustomerPriceEdge"]: {
	__typename: "ProductCustomerPriceEdge",
	node: GraphQLTypes["ProductCustomerPrice"]
};
	["ProductSalesDayConnection"]: {
	__typename: "ProductSalesDayConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductSalesDayEdge"]>
};
	["ProductSalesDayEdge"]: {
	__typename: "ProductSalesDayEdge",
	node: GraphQLTypes["ProductSalesDay"]
};
	["ProductSalesWeekConnection"]: {
	__typename: "ProductSalesWeekConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductSalesWeekEdge"]>
};
	["ProductSalesWeekEdge"]: {
	__typename: "ProductSalesWeekEdge",
	node: GraphQLTypes["ProductSalesWeek"]
};
	["ProductSalesMonthConnection"]: {
	__typename: "ProductSalesMonthConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductSalesMonthEdge"]>
};
	["ProductSalesMonthEdge"]: {
	__typename: "ProductSalesMonthEdge",
	node: GraphQLTypes["ProductSalesMonth"]
};
	["AddressMetadata"]: {
	__typename: "AddressMetadata",
	_meta?: GraphQLTypes["AddressMetadataMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	deliveryZoneType?: GraphQLTypes["DeliveryZoneType"] | undefined,
	address?: GraphQLTypes["Address"] | undefined,
	deliveryZone?: GraphQLTypes["DeliveryZone"] | undefined
};
	["AddressMetadataMeta"]: {
	__typename: "AddressMetadataMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryZoneType?: GraphQLTypes["FieldMeta"] | undefined,
	address?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryZone?: GraphQLTypes["FieldMeta"] | undefined
};
	["DeliveryZoneAddressesByMetaUniqueWhere"]: {
		meta?: GraphQLTypes["AddressMetadataUniqueWhere"] | undefined
};
	["DeliveryZoneAddressesByGpsUniqueWhere"]: {
		gps?: GraphQLTypes["GpsUniqueWhere"] | undefined
};
	["DeliveryZoneAddressesByInvoicesUniqueWhere"]: {
		invoices?: GraphQLTypes["InvoiceUniqueWhere"] | undefined
};
	["DeliveryZoneAddressesByBillingAddressOfOrdersUniqueWhere"]: {
		billingAddressOfOrders?: GraphQLTypes["OrderUniqueWhere"] | undefined
};
	["DeliveryZoneAddressesByDeliveryAddressOfOrderDeliveriesUniqueWhere"]: {
		deliveryAddressOfOrderDeliveries?: GraphQLTypes["OrderDeliveryUniqueWhere"] | undefined
};
	["DeliveryZoneAddressesByDefaultDeliveryAddressOfCustomerUniqueWhere"]: {
		defaultDeliveryAddressOfCustomer?: GraphQLTypes["CustomerUniqueWhere"] | undefined
};
	["DeliveryZoneAddressesMetadataByAddressUniqueWhere"]: {
		address?: GraphQLTypes["AddressUniqueWhere"] | undefined
};
	["AddressConnection"]: {
	__typename: "AddressConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["AddressEdge"]>
};
	["AddressEdge"]: {
	__typename: "AddressEdge",
	node: GraphQLTypes["Address"]
};
	["AddressMetadataConnection"]: {
	__typename: "AddressMetadataConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["AddressMetadataEdge"]>
};
	["AddressMetadataEdge"]: {
	__typename: "AddressMetadataEdge",
	node: GraphQLTypes["AddressMetadata"]
};
	["DeliveryTimelinePreset"]: {
	__typename: "DeliveryTimelinePreset",
	_meta?: GraphQLTypes["DeliveryTimelinePresetMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["DeliveryTimelineType"],
	duration?: string | undefined,
	window?: string | undefined,
	deliveryMethod?: GraphQLTypes["DeliveryMethod"] | undefined
};
	["DeliveryTimelinePresetMeta"]: {
	__typename: "DeliveryTimelinePresetMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	duration?: GraphQLTypes["FieldMeta"] | undefined,
	window?: GraphQLTypes["FieldMeta"] | undefined,
	deliveryMethod?: GraphQLTypes["FieldMeta"] | undefined
};
	["DeliveryMethodLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"] | undefined
};
	["PaymentMethodConnection"]: {
	__typename: "PaymentMethodConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PaymentMethodEdge"]>
};
	["PaymentMethodEdge"]: {
	__typename: "PaymentMethodEdge",
	node: GraphQLTypes["PaymentMethod"]
};
	["CourierConnection"]: {
	__typename: "CourierConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CourierEdge"]>
};
	["CourierEdge"]: {
	__typename: "CourierEdge",
	node: GraphQLTypes["Courier"]
};
	["CustomerPermissions"]: {
	__typename: "CustomerPermissions",
	_meta?: GraphQLTypes["CustomerPermissionsMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	canPlaceOrder?: boolean | undefined,
	customer?: GraphQLTypes["Customer"] | undefined
};
	["CustomerPermissionsMeta"]: {
	__typename: "CustomerPermissionsMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	canPlaceOrder?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined
};
	["CustomerName"]: {
	__typename: "CustomerName",
	_meta?: GraphQLTypes["CustomerNameMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	nominative: string,
	vocative?: string | undefined,
	customer?: GraphQLTypes["Customer"] | undefined,
	aliases: Array<GraphQLTypes["CustomerAlias"]>,
	paginateAliases: GraphQLTypes["CustomerAliasConnection"]
};
	["CustomerNameMeta"]: {
	__typename: "CustomerNameMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	nominative?: GraphQLTypes["FieldMeta"] | undefined,
	vocative?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined,
	aliases?: GraphQLTypes["FieldMeta"] | undefined
};
	["CustomerAlias"]: {
	__typename: "CustomerAlias",
	_meta?: GraphQLTypes["CustomerAliasMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name?: string | undefined,
	order: number
};
	["CustomerAliasMeta"]: {
	__typename: "CustomerAliasMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined
};
	["CustomerAliasOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined
};
	["CustomerAliasConnection"]: {
	__typename: "CustomerAliasConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CustomerAliasEdge"]>
};
	["CustomerAliasEdge"]: {
	__typename: "CustomerAliasEdge",
	node: GraphQLTypes["CustomerAlias"]
};
	["ApplicationShortcutList"]: {
	__typename: "ApplicationShortcutList",
	_meta?: GraphQLTypes["ApplicationShortcutListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["ApplicationShortcutListItem"]>,
	customer?: GraphQLTypes["Customer"] | undefined,
	paginateItems: GraphQLTypes["ApplicationShortcutListItemConnection"]
};
	["ApplicationShortcutListMeta"]: {
	__typename: "ApplicationShortcutListMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined
};
	["ApplicationShortcutListItem"]: {
	__typename: "ApplicationShortcutListItem",
	_meta?: GraphQLTypes["ApplicationShortcutListItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order?: number | undefined,
	application?: GraphQLTypes["Application"] | undefined,
	list?: GraphQLTypes["ApplicationShortcutList"] | undefined
};
	["ApplicationShortcutListItemMeta"]: {
	__typename: "ApplicationShortcutListItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	application?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined
};
	["Application"]: {
	__typename: "Application",
	_meta?: GraphQLTypes["ApplicationMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	handle?: string | undefined,
	url?: string | undefined,
	color?: string | undefined,
	icon?: GraphQLTypes["Image"] | undefined,
	name?: string | undefined,
	short?: string | undefined
};
	["ApplicationMeta"]: {
	__typename: "ApplicationMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	handle?: GraphQLTypes["FieldMeta"] | undefined,
	url?: GraphQLTypes["FieldMeta"] | undefined,
	color?: GraphQLTypes["FieldMeta"] | undefined,
	icon?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	short?: GraphQLTypes["FieldMeta"] | undefined
};
	["ApplicationShortcutListItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	application?: GraphQLTypes["ApplicationOrderBy"] | undefined,
	list?: GraphQLTypes["ApplicationShortcutListOrderBy"] | undefined
};
	["ApplicationOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	handle?: GraphQLTypes["OrderDirection"] | undefined,
	url?: GraphQLTypes["OrderDirection"] | undefined,
	color?: GraphQLTypes["OrderDirection"] | undefined,
	icon?: GraphQLTypes["ImageOrderBy"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	short?: GraphQLTypes["OrderDirection"] | undefined
};
	["ApplicationShortcutListItemConnection"]: {
	__typename: "ApplicationShortcutListItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ApplicationShortcutListItemEdge"]>
};
	["ApplicationShortcutListItemEdge"]: {
	__typename: "ApplicationShortcutListItemEdge",
	node: GraphQLTypes["ApplicationShortcutListItem"]
};
	["InvoicingPlan"]: {
	__typename: "InvoicingPlan",
	_meta?: GraphQLTypes["InvoicingPlanMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	customer?: GraphQLTypes["Customer"] | undefined,
	preset?: GraphQLTypes["InvoicingPreset"] | undefined
};
	["InvoicingPlanMeta"]: {
	__typename: "InvoicingPlanMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined,
	preset?: GraphQLTypes["FieldMeta"] | undefined
};
	["InvoicingPreset"]: {
	__typename: "InvoicingPreset",
	_meta?: GraphQLTypes["InvoicingPresetMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	type?: GraphQLTypes["InvoicingPresetType"] | undefined,
	startsAt?: GraphQLTypes["DateTime"] | undefined,
	endsAt?: GraphQLTypes["DateTime"] | undefined,
	intervalOfDays?: number | undefined,
	invoicingPlan?: GraphQLTypes["InvoicingPlan"] | undefined
};
	["InvoicingPresetMeta"]: {
	__typename: "InvoicingPresetMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	startsAt?: GraphQLTypes["FieldMeta"] | undefined,
	endsAt?: GraphQLTypes["FieldMeta"] | undefined,
	intervalOfDays?: GraphQLTypes["FieldMeta"] | undefined,
	invoicingPlan?: GraphQLTypes["FieldMeta"] | undefined
};
	["CustomerSpending"]: {
	__typename: "CustomerSpending",
	_meta?: GraphQLTypes["CustomerSpendingMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	totalCents: number,
	customer?: GraphQLTypes["Customer"] | undefined
};
	["CustomerSpendingMeta"]: {
	__typename: "CustomerSpendingMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	totalCents?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined
};
	["CustomerMetadata"]: {
	__typename: "CustomerMetadata",
	_meta?: GraphQLTypes["CustomerMetadataMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	isBusiness: boolean,
	name?: string | undefined,
	fallbackName: string,
	remainingCreditsCents: number,
	ordersTotalCents: number,
	customerProfileUrl: string,
	customer?: GraphQLTypes["Customer"] | undefined
};
	["CustomerMetadataMeta"]: {
	__typename: "CustomerMetadataMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	isBusiness?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	fallbackName?: GraphQLTypes["FieldMeta"] | undefined,
	remainingCreditsCents?: GraphQLTypes["FieldMeta"] | undefined,
	ordersTotalCents?: GraphQLTypes["FieldMeta"] | undefined,
	customerProfileUrl?: GraphQLTypes["FieldMeta"] | undefined,
	customer?: GraphQLTypes["FieldMeta"] | undefined
};
	["CustomerAddressesByMetaUniqueWhere"]: {
		meta?: GraphQLTypes["AddressMetadataUniqueWhere"] | undefined
};
	["CustomerAddressesByGpsUniqueWhere"]: {
		gps?: GraphQLTypes["GpsUniqueWhere"] | undefined
};
	["CustomerAddressesByInvoicesUniqueWhere"]: {
		invoices?: GraphQLTypes["InvoiceUniqueWhere"] | undefined
};
	["CustomerAddressesByBillingAddressOfOrdersUniqueWhere"]: {
		billingAddressOfOrders?: GraphQLTypes["OrderUniqueWhere"] | undefined
};
	["CustomerAddressesByDeliveryAddressOfOrderDeliveriesUniqueWhere"]: {
		deliveryAddressOfOrderDeliveries?: GraphQLTypes["OrderDeliveryUniqueWhere"] | undefined
};
	["CustomerAddressesByDefaultDeliveryAddressOfCustomerUniqueWhere"]: {
		defaultDeliveryAddressOfCustomer?: GraphQLTypes["CustomerUniqueWhere"] | undefined
};
	["CustomerCreditsByTransactionsUniqueWhere"]: {
		transactions?: GraphQLTypes["CustomerCreditTransactionUniqueWhere"] | undefined
};
	["CustomerCreditsByVoucherRedemptionUniqueWhere"]: {
		voucherRedemption?: GraphQLTypes["VoucherRedemptionUniqueWhere"] | undefined
};
	["CustomerOrdersBySeqUniqueWhere"]: {
		seq?: number | undefined
};
	["CustomerOrdersByDoubleshotLegacyIdUniqueWhere"]: {
		doubleshotLegacyId?: string | undefined
};
	["CustomerOrdersByDoubleShotLegacyNumberUniqueWhere"]: {
		doubleShotLegacyNumber?: string | undefined
};
	["CustomerOrdersByDiscountsUniqueWhere"]: {
		discounts?: GraphQLTypes["OrderDiscountUniqueWhere"] | undefined
};
	["CustomerOrdersByDeliveryUniqueWhere"]: {
		delivery?: GraphQLTypes["OrderDeliveryUniqueWhere"] | undefined
};
	["CustomerOrdersByItemsUniqueWhere"]: {
		items?: GraphQLTypes["OrderItemUniqueWhere"] | undefined
};
	["CustomerOrdersByCartUniqueWhere"]: {
		cart?: GraphQLTypes["CartUniqueWhere"] | undefined
};
	["CustomerOrdersByEventsUniqueWhere"]: {
		events?: GraphQLTypes["OrderEventUniqueWhere"] | undefined
};
	["CustomerOrdersByPriceLinesUniqueWhere"]: {
		priceLines?: GraphQLTypes["OrderPriceLineUniqueWhere"] | undefined
};
	["CustomerOrdersByPaymentsUniqueWhere"]: {
		payments?: GraphQLTypes["OrderPaymentUniqueWhere"] | undefined
};
	["CustomerOrdersBySummaryUniqueWhere"]: {
		summary?: GraphQLTypes["OrderSummaryUniqueWhere"] | undefined
};
	["CustomerOrdersByGratuityUniqueWhere"]: {
		gratuity?: GraphQLTypes["GratuityUniqueWhere"] | undefined
};
	["CustomerIngredientRatingsByIngredientUniqueWhere"]: {
		ingredient?: GraphQLTypes["ProductIngredientUniqueWhere"] | undefined
};
	["CustomerCartsByItemsUniqueWhere"]: {
		items?: GraphQLTypes["CartItemUniqueWhere"] | undefined
};
	["CustomerCartsByOrderUniqueWhere"]: {
		order?: GraphQLTypes["OrderUniqueWhere"] | undefined
};
	["CustomerCartsByPriceLinesUniqueWhere"]: {
		priceLines?: GraphQLTypes["CartPriceLineUniqueWhere"] | undefined
};
	["CustomerCartsBySummaryUniqueWhere"]: {
		summary?: GraphQLTypes["CartSummaryUniqueWhere"] | undefined
};
	["CustomerInvoicesByPublicKeyUniqueWhere"]: {
		publicKey?: string | undefined
};
	["CustomerInvoicesByFakturoidIdUniqueWhere"]: {
		fakturoidId?: string | undefined
};
	["CustomerInvoicesByOrderPaymentsUniqueWhere"]: {
		orderPayments?: GraphQLTypes["OrderPaymentUniqueWhere"] | undefined
};
	["CustomerBillingSubjectsByInvoicesUniqueWhere"]: {
		invoices?: GraphQLTypes["InvoiceUniqueWhere"] | undefined
};
	["CustomerBillingSubjectsByDefaultBillingSubjectOfCustomerUniqueWhere"]: {
		defaultBillingSubjectOfCustomer?: GraphQLTypes["CustomerUniqueWhere"] | undefined
};
	["CustomerBillingSubjectsByOrdersUniqueWhere"]: {
		orders?: GraphQLTypes["OrderUniqueWhere"] | undefined
};
	["CustomerOfferedProductsByProductUniqueWhere"]: {
		product?: GraphQLTypes["ProductUniqueWhere"] | undefined
};
	["CustomerBoughtVouchersByCodeUniqueWhere"]: {
		code?: string | undefined
};
	["CustomerBoughtVouchersByRedemptionUniqueWhere"]: {
		redemption?: GraphQLTypes["VoucherRedemptionUniqueWhere"] | undefined
};
	["CustomerOwnsVouchersByCodeUniqueWhere"]: {
		code?: string | undefined
};
	["CustomerOwnsVouchersByRedemptionUniqueWhere"]: {
		redemption?: GraphQLTypes["VoucherRedemptionUniqueWhere"] | undefined
};
	["CustomerRedeemedVouchersByCustomerCreditUniqueWhere"]: {
		customerCredit?: GraphQLTypes["CustomerCreditUniqueWhere"] | undefined
};
	["CustomerRedeemedVouchersByOrderDiscountUniqueWhere"]: {
		orderDiscount?: GraphQLTypes["OrderDiscountUniqueWhere"] | undefined
};
	["CustomerRedeemedVouchersByVoucherUniqueWhere"]: {
		voucher?: GraphQLTypes["VoucherUniqueWhere"] | undefined
};
	["CustomerCustomerTabsByItemsUniqueWhere"]: {
		items?: GraphQLTypes["CustomerTabItemUniqueWhere"] | undefined
};
	["CustomerCustomerTabsByMetaUniqueWhere"]: {
		meta?: GraphQLTypes["CustomerTabMetadataUniqueWhere"] | undefined
};
	["CustomerLeadByStageItemUniqueWhere"]: {
		stageItem?: GraphQLTypes["PipelineStageItemUniqueWhere"] | undefined
};
	["CustomerCreditConnection"]: {
	__typename: "CustomerCreditConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CustomerCreditEdge"]>
};
	["CustomerCreditEdge"]: {
	__typename: "CustomerCreditEdge",
	node: GraphQLTypes["CustomerCredit"]
};
	["CustomerPaymentMethodConnection"]: {
	__typename: "CustomerPaymentMethodConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CustomerPaymentMethodEdge"]>
};
	["CustomerPaymentMethodEdge"]: {
	__typename: "CustomerPaymentMethodEdge",
	node: GraphQLTypes["CustomerPaymentMethod"]
};
	["BillingSubjectConnection"]: {
	__typename: "BillingSubjectConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BillingSubjectEdge"]>
};
	["BillingSubjectEdge"]: {
	__typename: "BillingSubjectEdge",
	node: GraphQLTypes["BillingSubject"]
};
	["VoucherRedemptionConnection"]: {
	__typename: "VoucherRedemptionConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["VoucherRedemptionEdge"]>
};
	["VoucherRedemptionEdge"]: {
	__typename: "VoucherRedemptionEdge",
	node: GraphQLTypes["VoucherRedemption"]
};
	["Gps"]: {
	__typename: "Gps",
	_meta?: GraphQLTypes["GpsMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	latitude: number,
	longitude: number,
	address?: GraphQLTypes["Address"] | undefined
};
	["GpsMeta"]: {
	__typename: "GpsMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	latitude?: GraphQLTypes["FieldMeta"] | undefined,
	longitude?: GraphQLTypes["FieldMeta"] | undefined,
	address?: GraphQLTypes["FieldMeta"] | undefined
};
	["AddressInvoicesByPublicKeyUniqueWhere"]: {
		publicKey?: string | undefined
};
	["AddressInvoicesByFakturoidIdUniqueWhere"]: {
		fakturoidId?: string | undefined
};
	["AddressInvoicesByOrderPaymentsUniqueWhere"]: {
		orderPayments?: GraphQLTypes["OrderPaymentUniqueWhere"] | undefined
};
	["AddressBillingAddressOfOrdersBySeqUniqueWhere"]: {
		seq?: number | undefined
};
	["AddressBillingAddressOfOrdersByDoubleshotLegacyIdUniqueWhere"]: {
		doubleshotLegacyId?: string | undefined
};
	["AddressBillingAddressOfOrdersByDoubleShotLegacyNumberUniqueWhere"]: {
		doubleShotLegacyNumber?: string | undefined
};
	["AddressBillingAddressOfOrdersByDiscountsUniqueWhere"]: {
		discounts?: GraphQLTypes["OrderDiscountUniqueWhere"] | undefined
};
	["AddressBillingAddressOfOrdersByDeliveryUniqueWhere"]: {
		delivery?: GraphQLTypes["OrderDeliveryUniqueWhere"] | undefined
};
	["AddressBillingAddressOfOrdersByItemsUniqueWhere"]: {
		items?: GraphQLTypes["OrderItemUniqueWhere"] | undefined
};
	["AddressBillingAddressOfOrdersByCartUniqueWhere"]: {
		cart?: GraphQLTypes["CartUniqueWhere"] | undefined
};
	["AddressBillingAddressOfOrdersByEventsUniqueWhere"]: {
		events?: GraphQLTypes["OrderEventUniqueWhere"] | undefined
};
	["AddressBillingAddressOfOrdersByPriceLinesUniqueWhere"]: {
		priceLines?: GraphQLTypes["OrderPriceLineUniqueWhere"] | undefined
};
	["AddressBillingAddressOfOrdersByPaymentsUniqueWhere"]: {
		payments?: GraphQLTypes["OrderPaymentUniqueWhere"] | undefined
};
	["AddressBillingAddressOfOrdersBySummaryUniqueWhere"]: {
		summary?: GraphQLTypes["OrderSummaryUniqueWhere"] | undefined
};
	["AddressBillingAddressOfOrdersByGratuityUniqueWhere"]: {
		gratuity?: GraphQLTypes["GratuityUniqueWhere"] | undefined
};
	["AddressDeliveryAddressOfOrderDeliveriesByTrackingCodeUniqueWhere"]: {
		trackingCode?: string | undefined
};
	["AddressDeliveryAddressOfOrderDeliveriesByOrderUniqueWhere"]: {
		order?: GraphQLTypes["OrderUniqueWhere"] | undefined
};
	["AddressDeliveryAddressOfOrderDeliveriesByDeliveryWaypointUniqueWhere"]: {
		deliveryWaypoint?: GraphQLTypes["DeliveryWaypointUniqueWhere"] | undefined
};
	["AddressDeliveryAddressOfOrderDeliveriesByEventsUniqueWhere"]: {
		events?: GraphQLTypes["OrderEventUniqueWhere"] | undefined
};
	["AddressDeliveryAddressOfOrderDeliveriesByLiftagoRideUniqueWhere"]: {
		liftagoRide?: GraphQLTypes["LiftagoRideUniqueWhere"] | undefined
};
	["AddressDeliveryAddressOfOrderDeliveriesByWoltDriveDeliveryUniqueWhere"]: {
		woltDriveDelivery?: GraphQLTypes["WoltDriveDeliveryUniqueWhere"] | undefined
};
	["OrderDeliveryConnection"]: {
	__typename: "OrderDeliveryConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["OrderDeliveryEdge"]>
};
	["OrderDeliveryEdge"]: {
	__typename: "OrderDeliveryEdge",
	node: GraphQLTypes["OrderDelivery"]
};
	["_ValidationResult"]: {
	__typename: "_ValidationResult",
	valid: boolean,
	errors: Array<GraphQLTypes["_ValidationError"]>
};
	["_ValidationError"]: {
	__typename: "_ValidationError",
	path: Array<GraphQLTypes["_PathFragment"]>,
	message: GraphQLTypes["_ValidationMessage"]
};
	["_PathFragment"]:{
        	__typename:"_FieldPathFragment" | "_IndexPathFragment"
        	['...on _FieldPathFragment']: '__union' & GraphQLTypes["_FieldPathFragment"];
	['...on _IndexPathFragment']: '__union' & GraphQLTypes["_IndexPathFragment"];
};
	["_FieldPathFragment"]: {
	__typename: "_FieldPathFragment",
	field: string
};
	["_IndexPathFragment"]: {
	__typename: "_IndexPathFragment",
	index: number,
	alias?: string | undefined
};
	["_ValidationMessage"]: {
	__typename: "_ValidationMessage",
	text: string
};
	["AddressCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	firstName?: string | undefined,
	lastName?: string | undefined,
	addressLine2?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	companyName?: string | undefined,
	companyIdentifier?: string | undefined,
	vatIdentifier?: string | undefined,
	externalIdentifier?: string | undefined,
	hidden?: boolean | undefined,
	customer?: GraphQLTypes["AddressCreateCustomerEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	country?: GraphQLTypes["AddressCreateCountryEntityRelationInput"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	googlePlaceId?: string | undefined,
	raw?: string | undefined,
	formatted?: string | undefined,
	geocodeGeneratedAt?: GraphQLTypes["DateTime"] | undefined,
	geocodeResponse?: string | undefined,
	deliveryZone?: GraphQLTypes["AddressCreateDeliveryZoneEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["AddressCreateMetaEntityRelationInput"] | undefined,
	gps?: GraphQLTypes["AddressCreateGpsEntityRelationInput"] | undefined,
	geocodeValid?: boolean | undefined,
	fullName?: string | undefined,
	fakturoidSubjectId?: string | undefined,
	invoices?: Array<GraphQLTypes["AddressCreateInvoicesEntityRelationInput"]> | undefined,
	addressLine1?: string | undefined,
	city?: string | undefined,
	postalCode?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddressOfOrders?: Array<GraphQLTypes["AddressCreateBillingAddressOfOrdersEntityRelationInput"]> | undefined,
	deliveryAddressOfOrderDeliveries?: Array<GraphQLTypes["AddressCreateDeliveryAddressOfOrderDeliveriesEntityRelationInput"]> | undefined,
	defaultDeliveryAddressOfCustomer?: GraphQLTypes["AddressCreateDefaultDeliveryAddressOfCustomerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["AddressCreateCustomerEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerWithoutAddressesCreateInput"] | undefined
};
	["CustomerWithoutAddressesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerCreateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerCreateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerCreatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerCreateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerCreateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerCreateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerCreateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerCreateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerCreateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerCreateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreateDefaultBillingAddressEntityRelationInput"]: {
		connect?: GraphQLTypes["AddressUniqueWhere"] | undefined,
	create?: GraphQLTypes["AddressCreateInput"] | undefined
};
	["CustomerCreateDefaultPaymentMethodEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerPaymentMethodUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerPaymentMethodCreateInput"] | undefined
};
	["CustomerPaymentMethodCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	caption?: string | undefined,
	data?: GraphQLTypes["Json"] | undefined,
	customer?: GraphQLTypes["CustomerPaymentMethodCreateCustomerEntityRelationInput"] | undefined,
	paymentMethod?: GraphQLTypes["CustomerPaymentMethodCreatePaymentMethodEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerPaymentMethodCreateCustomerEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerWithoutPaymentMethodsCreateInput"] | undefined
};
	["CustomerWithoutPaymentMethodsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	addresses?: Array<GraphQLTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerCreateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerCreateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerCreatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerCreateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerCreateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerCreateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerCreateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerCreateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerCreateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerCreateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreateAddressesEntityRelationInput"]: {
		connect?: GraphQLTypes["AddressUniqueWhere"] | undefined,
	create?: GraphQLTypes["AddressWithoutCustomerCreateInput"] | undefined,
	alias?: string | undefined
};
	["AddressWithoutCustomerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	firstName?: string | undefined,
	lastName?: string | undefined,
	addressLine2?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	companyName?: string | undefined,
	companyIdentifier?: string | undefined,
	vatIdentifier?: string | undefined,
	externalIdentifier?: string | undefined,
	hidden?: boolean | undefined,
	internalNote?: string | undefined,
	country?: GraphQLTypes["AddressCreateCountryEntityRelationInput"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	googlePlaceId?: string | undefined,
	raw?: string | undefined,
	formatted?: string | undefined,
	geocodeGeneratedAt?: GraphQLTypes["DateTime"] | undefined,
	geocodeResponse?: string | undefined,
	deliveryZone?: GraphQLTypes["AddressCreateDeliveryZoneEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["AddressCreateMetaEntityRelationInput"] | undefined,
	gps?: GraphQLTypes["AddressCreateGpsEntityRelationInput"] | undefined,
	geocodeValid?: boolean | undefined,
	fullName?: string | undefined,
	fakturoidSubjectId?: string | undefined,
	invoices?: Array<GraphQLTypes["AddressCreateInvoicesEntityRelationInput"]> | undefined,
	addressLine1?: string | undefined,
	city?: string | undefined,
	postalCode?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddressOfOrders?: Array<GraphQLTypes["AddressCreateBillingAddressOfOrdersEntityRelationInput"]> | undefined,
	deliveryAddressOfOrderDeliveries?: Array<GraphQLTypes["AddressCreateDeliveryAddressOfOrderDeliveriesEntityRelationInput"]> | undefined,
	defaultDeliveryAddressOfCustomer?: GraphQLTypes["AddressCreateDefaultDeliveryAddressOfCustomerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["AddressCreateCountryEntityRelationInput"]: {
		connect?: GraphQLTypes["CountryUniqueWhere"] | undefined,
	create?: GraphQLTypes["CountryCreateInput"] | undefined
};
	["CountryUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined
};
	["CountryCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["AddressCreateDeliveryZoneEntityRelationInput"]: {
		connect?: GraphQLTypes["DeliveryZoneUniqueWhere"] | undefined,
	create?: GraphQLTypes["DeliveryZoneWithoutAddressesCreateInput"] | undefined
};
	["DeliveryZoneUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	addresses?: GraphQLTypes["AddressUniqueWhere"] | undefined,
	addressesMetadata?: GraphQLTypes["AddressMetadataUniqueWhere"] | undefined
};
	["DeliveryZoneWithoutAddressesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	type?: GraphQLTypes["DeliveryZoneType"] | undefined,
	suitableDeliveryMethods?: Array<GraphQLTypes["DeliveryZoneCreateSuitableDeliveryMethodsEntityRelationInput"]> | undefined,
	deliveryZonesOfTags?: Array<GraphQLTypes["DeliveryZoneCreateDeliveryZonesOfTagsEntityRelationInput"]> | undefined,
	deliveryZonesOfProducts?: Array<GraphQLTypes["DeliveryZoneCreateDeliveryZonesOfProductsEntityRelationInput"]> | undefined,
	addressesMetadata?: Array<GraphQLTypes["DeliveryZoneCreateAddressesMetadataEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryZoneCreateSuitableDeliveryMethodsEntityRelationInput"]: {
		connect?: GraphQLTypes["DeliveryMethodUniqueWhere"] | undefined,
	create?: GraphQLTypes["DeliveryMethodWithoutSuitableForDeliveryZonesCreateInput"] | undefined,
	alias?: string | undefined
};
	["DeliveryMethodWithoutSuitableForDeliveryZonesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	enabled?: boolean | undefined,
	paymentMethods?: Array<GraphQLTypes["DeliveryMethodCreatePaymentMethodsEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	requireDeliveryAddress?: boolean | undefined,
	channels?: Array<GraphQLTypes["DeliveryMethodCreateChannelsEntityRelationInput"]> | undefined,
	courierHandlers?: Array<GraphQLTypes["DeliveryMethodCreateCourierHandlersEntityRelationInput"]> | undefined,
	enableDeliveryTracking?: boolean | undefined,
	locales?: Array<GraphQLTypes["DeliveryMethodCreateLocalesEntityRelationInput"]> | undefined,
	timelinePreset?: GraphQLTypes["DeliveryMethodCreateTimelinePresetEntityRelationInput"] | undefined,
	woltDriveVenueId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryMethodCreatePaymentMethodsEntityRelationInput"]: {
		connect?: GraphQLTypes["PaymentMethodUniqueWhere"] | undefined,
	create?: GraphQLTypes["PaymentMethodWithoutDeliveryMethodsCreateInput"] | undefined,
	alias?: string | undefined
};
	["PaymentMethodUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	channels?: GraphQLTypes["ChannelPaymentUniqueWhere"] | undefined
};
	["PaymentMethodWithoutDeliveryMethodsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	enabled?: boolean | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	blockingDispatch?: boolean | undefined,
	type?: GraphQLTypes["PaymentMethodType"] | undefined,
	channels?: Array<GraphQLTypes["PaymentMethodCreateChannelsEntityRelationInput"]> | undefined,
	reduceGratuityByPercentage?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["PaymentMethodCreateChannelsEntityRelationInput"]: {
		connect?: GraphQLTypes["ChannelPaymentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ChannelPaymentWithoutMethodCreateInput"] | undefined,
	alias?: string | undefined
};
	["ChannelPaymentWithoutMethodCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	channel?: GraphQLTypes["ChannelPaymentCreateChannelEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["ChannelPaymentCreateVatRateEntityRelationInput"] | undefined,
	requireBillingAddress?: boolean | undefined,
	provideReceipt?: boolean | undefined,
	requireBillingSubject?: boolean | undefined,
	allowOnlyForTags?: Array<GraphQLTypes["ChannelPaymentCreateAllowOnlyForTagsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ChannelPaymentCreateChannelEntityRelationInput"]: {
		connect?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	create?: GraphQLTypes["ChannelWithoutPaymentsCreateInput"] | undefined
};
	["ChannelWithoutPaymentsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	disabled?: boolean | undefined,
	deliveries?: Array<GraphQLTypes["ChannelCreateDeliveriesEntityRelationInput"]> | undefined,
	pointOfSales?: Array<GraphQLTypes["ChannelCreatePointOfSalesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["ChannelCreateCartsEntityRelationInput"]> | undefined,
	customers?: Array<GraphQLTypes["ChannelCreateCustomersEntityRelationInput"]> | undefined,
	code?: GraphQLTypes["ChannelCode"] | undefined,
	addTagsOnRegistration?: Array<GraphQLTypes["ChannelCreateAddTagsOnRegistrationEntityRelationInput"]> | undefined,
	publicTags?: Array<GraphQLTypes["ChannelCreatePublicTagsEntityRelationInput"]> | undefined,
	venue?: GraphQLTypes["ChannelCreateVenueEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ChannelCreateDeliveriesEntityRelationInput"]: {
		connect?: GraphQLTypes["ChannelDeliveryUniqueWhere"] | undefined,
	create?: GraphQLTypes["ChannelDeliveryWithoutChannelCreateInput"] | undefined,
	alias?: string | undefined
};
	["ChannelDeliveryWithoutChannelCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	priceCents?: number | undefined,
	method?: GraphQLTypes["ChannelDeliveryCreateMethodEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["ChannelDeliveryCreateVatRateEntityRelationInput"] | undefined,
	defaultVisible?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ChannelDeliveryCreateMethodEntityRelationInput"]: {
		connect?: GraphQLTypes["DeliveryMethodUniqueWhere"] | undefined,
	create?: GraphQLTypes["DeliveryMethodWithoutChannelsCreateInput"] | undefined
};
	["DeliveryMethodWithoutChannelsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	enabled?: boolean | undefined,
	paymentMethods?: Array<GraphQLTypes["DeliveryMethodCreatePaymentMethodsEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	requireDeliveryAddress?: boolean | undefined,
	suitableForDeliveryZones?: Array<GraphQLTypes["DeliveryMethodCreateSuitableForDeliveryZonesEntityRelationInput"]> | undefined,
	courierHandlers?: Array<GraphQLTypes["DeliveryMethodCreateCourierHandlersEntityRelationInput"]> | undefined,
	enableDeliveryTracking?: boolean | undefined,
	locales?: Array<GraphQLTypes["DeliveryMethodCreateLocalesEntityRelationInput"]> | undefined,
	timelinePreset?: GraphQLTypes["DeliveryMethodCreateTimelinePresetEntityRelationInput"] | undefined,
	woltDriveVenueId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryMethodCreateSuitableForDeliveryZonesEntityRelationInput"]: {
		connect?: GraphQLTypes["DeliveryZoneUniqueWhere"] | undefined,
	create?: GraphQLTypes["DeliveryZoneWithoutSuitableDeliveryMethodsCreateInput"] | undefined,
	alias?: string | undefined
};
	["DeliveryZoneWithoutSuitableDeliveryMethodsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	type?: GraphQLTypes["DeliveryZoneType"] | undefined,
	addresses?: Array<GraphQLTypes["DeliveryZoneCreateAddressesEntityRelationInput"]> | undefined,
	deliveryZonesOfTags?: Array<GraphQLTypes["DeliveryZoneCreateDeliveryZonesOfTagsEntityRelationInput"]> | undefined,
	deliveryZonesOfProducts?: Array<GraphQLTypes["DeliveryZoneCreateDeliveryZonesOfProductsEntityRelationInput"]> | undefined,
	addressesMetadata?: Array<GraphQLTypes["DeliveryZoneCreateAddressesMetadataEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryZoneCreateAddressesEntityRelationInput"]: {
		connect?: GraphQLTypes["AddressUniqueWhere"] | undefined,
	create?: GraphQLTypes["AddressWithoutDeliveryZoneCreateInput"] | undefined,
	alias?: string | undefined
};
	["AddressWithoutDeliveryZoneCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	firstName?: string | undefined,
	lastName?: string | undefined,
	addressLine2?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	companyName?: string | undefined,
	companyIdentifier?: string | undefined,
	vatIdentifier?: string | undefined,
	externalIdentifier?: string | undefined,
	hidden?: boolean | undefined,
	customer?: GraphQLTypes["AddressCreateCustomerEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	country?: GraphQLTypes["AddressCreateCountryEntityRelationInput"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	googlePlaceId?: string | undefined,
	raw?: string | undefined,
	formatted?: string | undefined,
	geocodeGeneratedAt?: GraphQLTypes["DateTime"] | undefined,
	geocodeResponse?: string | undefined,
	meta?: GraphQLTypes["AddressCreateMetaEntityRelationInput"] | undefined,
	gps?: GraphQLTypes["AddressCreateGpsEntityRelationInput"] | undefined,
	geocodeValid?: boolean | undefined,
	fullName?: string | undefined,
	fakturoidSubjectId?: string | undefined,
	invoices?: Array<GraphQLTypes["AddressCreateInvoicesEntityRelationInput"]> | undefined,
	addressLine1?: string | undefined,
	city?: string | undefined,
	postalCode?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddressOfOrders?: Array<GraphQLTypes["AddressCreateBillingAddressOfOrdersEntityRelationInput"]> | undefined,
	deliveryAddressOfOrderDeliveries?: Array<GraphQLTypes["AddressCreateDeliveryAddressOfOrderDeliveriesEntityRelationInput"]> | undefined,
	defaultDeliveryAddressOfCustomer?: GraphQLTypes["AddressCreateDefaultDeliveryAddressOfCustomerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["AddressCreateMetaEntityRelationInput"]: {
		connect?: GraphQLTypes["AddressMetadataUniqueWhere"] | undefined
};
	["AddressCreateGpsEntityRelationInput"]: {
		connect?: GraphQLTypes["GpsUniqueWhere"] | undefined,
	create?: GraphQLTypes["GpsWithoutAddressCreateInput"] | undefined
};
	["GpsWithoutAddressCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	latitude?: number | undefined,
	longitude?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["AddressCreateInvoicesEntityRelationInput"]: {
		connect?: GraphQLTypes["InvoiceUniqueWhere"] | undefined,
	create?: GraphQLTypes["InvoiceWithoutAddressCreateInput"] | undefined,
	alias?: string | undefined
};
	["InvoiceWithoutAddressCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	publicKey?: string | undefined,
	fakturoidId?: string | undefined,
	fakturoidData?: string | undefined,
	legacyUrl?: string | undefined,
	customer?: GraphQLTypes["InvoiceCreateCustomerEntityRelationInput"] | undefined,
	orderPayments?: Array<GraphQLTypes["InvoiceCreateOrderPaymentsEntityRelationInput"]> | undefined,
	publicUrl?: string | undefined,
	billingSubject?: GraphQLTypes["InvoiceCreateBillingSubjectEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InvoiceCreateCustomerEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerWithoutInvoicesCreateInput"] | undefined
};
	["CustomerWithoutInvoicesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	addresses?: Array<GraphQLTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerCreateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerCreateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerCreatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerCreateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerCreateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerCreateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerCreateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoicingPlan?: GraphQLTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerCreateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerCreateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerCreateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreateTagsEntityRelationInput"]: {
		connect?: GraphQLTypes["TagUniqueWhere"] | undefined,
	create?: GraphQLTypes["TagWithoutCustomersCreateInput"] | undefined,
	alias?: string | undefined
};
	["TagUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	nestedCategories?: GraphQLTypes["InheritedProductCategoryTagUniqueWhere"] | undefined
};
	["TagWithoutCustomersCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	products?: Array<GraphQLTypes["TagCreateProductsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["TagCreateCategoriesEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	addTagsOnRegistration?: Array<GraphQLTypes["TagCreateAddTagsOnRegistrationEntityRelationInput"]> | undefined,
	nestedCategories?: Array<GraphQLTypes["TagCreateNestedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["TagCreateDeliveryZonesEntityRelationInput"]> | undefined,
	publicInChannels?: Array<GraphQLTypes["TagCreatePublicInChannelsEntityRelationInput"]> | undefined,
	allowChannelPayments?: Array<GraphQLTypes["TagCreateAllowChannelPaymentsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["TagCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TagCreateProductsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductWithoutTagsCreateInput"] | undefined,
	alias?: string | undefined
};
	["ProductWithoutTagsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	priceCents?: number | undefined,
	notDiscountable?: boolean | undefined,
	packing?: GraphQLTypes["ProductCreatePackingEntityRelationInput"] | undefined,
	recipe?: GraphQLTypes["ProductCreateRecipeEntityRelationInput"] | undefined,
	categories?: Array<GraphQLTypes["ProductCreateCategoriesEntityRelationInput"]> | undefined,
	vatRate?: GraphQLTypes["ProductCreateVatRateEntityRelationInput"] | undefined,
	stocks?: Array<GraphQLTypes["ProductCreateStocksEntityRelationInput"]> | undefined,
	groupPrices?: Array<GraphQLTypes["ProductCreateGroupPricesEntityRelationInput"]> | undefined,
	image?: GraphQLTypes["ProductCreateImageEntityRelationInput"] | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	cartItems?: Array<GraphQLTypes["ProductCreateCartItemsEntityRelationInput"]> | undefined,
	availability?: GraphQLTypes["ProductAvailability"] | undefined,
	order?: number | undefined,
	manager?: GraphQLTypes["ProductCreateManagerEntityRelationInput"] | undefined,
	orderItems?: Array<GraphQLTypes["ProductCreateOrderItemsEntityRelationInput"]> | undefined,
	maximumQuantityPerOrder?: number | undefined,
	inheritedCategories?: Array<GraphQLTypes["ProductCreateInheritedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["ProductCreateDeliveryZonesEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["ProductCreateLocalesEntityRelationInput"]> | undefined,
	archivedAt?: GraphQLTypes["DateTime"] | undefined,
	customerPrices?: Array<GraphQLTypes["ProductCreateCustomerPricesEntityRelationInput"]> | undefined,
	virtualProduct?: GraphQLTypes["ProductCreateVirtualProductEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["ProductCreateMetaEntityRelationInput"] | undefined,
	page?: GraphQLTypes["ProductCreatePageEntityRelationInput"] | undefined,
	salesDays?: Array<GraphQLTypes["ProductCreateSalesDaysEntityRelationInput"]> | undefined,
	salesWeeks?: Array<GraphQLTypes["ProductCreateSalesWeeksEntityRelationInput"]> | undefined,
	salesMonths?: Array<GraphQLTypes["ProductCreateSalesMonthsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["ProductCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	hasSubscription?: boolean | undefined,
	pointOfSaleTileColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCreatePackingEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductPackingUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductPackingCreateInput"] | undefined
};
	["ProductPackingCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	image?: GraphQLTypes["ProductPackingCreateImageEntityRelationInput"] | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	volumeMl?: number | undefined,
	icon?: GraphQLTypes["ProductPackingCreateIconEntityRelationInput"] | undefined,
	shortName?: string | undefined,
	locales?: Array<GraphQLTypes["ProductPackingCreateLocalesEntityRelationInput"]> | undefined,
	preparedPackingQuantities?: Array<GraphQLTypes["ProductPackingCreatePreparedPackingQuantitiesEntityRelationInput"]> | undefined,
	isPackedInCardboard?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductPackingCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["ImageCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	url?: string | undefined,
	width?: number | undefined,
	height?: number | undefined,
	size?: number | undefined,
	type?: string | undefined,
	alt?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductPackingCreateIconEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["ProductPackingCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductPackingLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductPackingLocaleWithoutRootCreateInput"] | undefined,
	alias?: string | undefined
};
	["ProductPackingLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	shortName?: string | undefined,
	description?: string | undefined,
	locale?: GraphQLTypes["ProductPackingLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductPackingLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutProductPackingsCreateInput"] | undefined
};
	["LocaleWithoutProductPackingsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	businessCategories?: Array<GraphQLTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleCreateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleCreateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateBusinessCategoriesEntityRelationInput"]: {
		connect?: GraphQLTypes["BusinessCategoryLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["BusinessCategoryLocaleWithoutLocaleCreateInput"] | undefined,
	alias?: string | undefined
};
	["BusinessCategoryLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	root?: GraphQLTypes["BusinessCategoryLocaleCreateRootEntityRelationInput"] | undefined,
	title?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessCategoryLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["BusinessCategoryUniqueWhere"] | undefined,
	create?: GraphQLTypes["BusinessCategoryWithoutLocalesCreateInput"] | undefined
};
	["BusinessCategoryWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	visibleToNewCustomers?: boolean | undefined,
	internalName?: string | undefined,
	businessCustomers?: Array<GraphQLTypes["BusinessCategoryCreateBusinessCustomersEntityRelationInput"]> | undefined,
	recurrences?: Array<GraphQLTypes["BusinessCategoryCreateRecurrencesEntityRelationInput"]> | undefined,
	specificProducts?: GraphQLTypes["BusinessCategoryCreateSpecificProductsEntityRelationInput"] | undefined,
	seasonalProductCategories?: GraphQLTypes["BusinessCategoryCreateSeasonalProductCategoriesEntityRelationInput"] | undefined,
	specificProductsProductCategories?: GraphQLTypes["BusinessCategoryCreateSpecificProductsProductCategoriesEntityRelationInput"] | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessCategoryCreateBusinessCustomersEntityRelationInput"]: {
		connect?: GraphQLTypes["BusinessCustomerUniqueWhere"] | undefined,
	create?: GraphQLTypes["BusinessCustomerWithoutCategoryCreateInput"] | undefined,
	alias?: string | undefined
};
	["BusinessCustomerWithoutCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	customer?: GraphQLTypes["BusinessCustomerCreateCustomerEntityRelationInput"] | undefined,
	owners?: Array<GraphQLTypes["BusinessCustomerCreateOwnersEntityRelationInput"]> | undefined,
	members?: Array<GraphQLTypes["BusinessCustomerCreateMembersEntityRelationInput"]> | undefined,
	accountManager?: GraphQLTypes["BusinessCustomerCreateAccountManagerEntityRelationInput"] | undefined,
	logo?: GraphQLTypes["BusinessCustomerCreateLogoEntityRelationInput"] | undefined,
	note?: string | undefined,
	businessServiceEvents?: Array<GraphQLTypes["BusinessCustomerCreateBusinessServiceEventsEntityRelationInput"]> | undefined,
	doubleshotCoffeeEquipment?: GraphQLTypes["BusinessCustomerCreateDoubleshotCoffeeEquipmentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessCustomerCreateCustomerEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerWithoutBusinessCreateInput"] | undefined
};
	["CustomerWithoutBusinessCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	addresses?: Array<GraphQLTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerCreateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerCreateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerCreatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerCreateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerCreateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerCreateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerCreateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerCreateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerCreateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreateCreditsEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerCreditUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerCreditWithoutCustomerCreateInput"] | undefined,
	alias?: string | undefined
};
	["CustomerCreditWithoutCustomerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	initialCreditCents?: number | undefined,
	remainingCreditsCents?: number | undefined,
	expiresAt?: GraphQLTypes["DateTime"] | undefined,
	reason?: string | undefined,
	vatRate?: GraphQLTypes["CustomerCreditCreateVatRateEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	transactions?: Array<GraphQLTypes["CustomerCreditCreateTransactionsEntityRelationInput"]> | undefined,
	voucherRedemption?: GraphQLTypes["CustomerCreditCreateVoucherRedemptionEntityRelationInput"] | undefined,
	invoiceUrl?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreditCreateVatRateEntityRelationInput"]: {
		connect?: GraphQLTypes["VatRateUniqueWhere"] | undefined,
	create?: GraphQLTypes["VatRateCreateInput"] | undefined
};
	["VatRateUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	preset?: GraphQLTypes["VatRatePreset"] | undefined,
	channelDeliveries?: GraphQLTypes["ChannelDeliveryUniqueWhere"] | undefined,
	channelPayments?: GraphQLTypes["ChannelPaymentUniqueWhere"] | undefined
};
	["VatRateCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	ratePermille?: number | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	channelDeliveries?: Array<GraphQLTypes["VatRateCreateChannelDeliveriesEntityRelationInput"]> | undefined,
	channelPayments?: Array<GraphQLTypes["VatRateCreateChannelPaymentsEntityRelationInput"]> | undefined,
	preset?: GraphQLTypes["VatRatePreset"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["VatRateCreateChannelDeliveriesEntityRelationInput"]: {
		connect?: GraphQLTypes["ChannelDeliveryUniqueWhere"] | undefined,
	create?: GraphQLTypes["ChannelDeliveryWithoutVatRateCreateInput"] | undefined,
	alias?: string | undefined
};
	["ChannelDeliveryWithoutVatRateCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	priceCents?: number | undefined,
	channel?: GraphQLTypes["ChannelDeliveryCreateChannelEntityRelationInput"] | undefined,
	method?: GraphQLTypes["ChannelDeliveryCreateMethodEntityRelationInput"] | undefined,
	defaultVisible?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ChannelDeliveryCreateChannelEntityRelationInput"]: {
		connect?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	create?: GraphQLTypes["ChannelWithoutDeliveriesCreateInput"] | undefined
};
	["ChannelWithoutDeliveriesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	disabled?: boolean | undefined,
	payments?: Array<GraphQLTypes["ChannelCreatePaymentsEntityRelationInput"]> | undefined,
	pointOfSales?: Array<GraphQLTypes["ChannelCreatePointOfSalesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["ChannelCreateCartsEntityRelationInput"]> | undefined,
	customers?: Array<GraphQLTypes["ChannelCreateCustomersEntityRelationInput"]> | undefined,
	code?: GraphQLTypes["ChannelCode"] | undefined,
	addTagsOnRegistration?: Array<GraphQLTypes["ChannelCreateAddTagsOnRegistrationEntityRelationInput"]> | undefined,
	publicTags?: Array<GraphQLTypes["ChannelCreatePublicTagsEntityRelationInput"]> | undefined,
	venue?: GraphQLTypes["ChannelCreateVenueEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ChannelCreatePaymentsEntityRelationInput"]: {
		connect?: GraphQLTypes["ChannelPaymentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ChannelPaymentWithoutChannelCreateInput"] | undefined,
	alias?: string | undefined
};
	["ChannelPaymentWithoutChannelCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	method?: GraphQLTypes["ChannelPaymentCreateMethodEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["ChannelPaymentCreateVatRateEntityRelationInput"] | undefined,
	requireBillingAddress?: boolean | undefined,
	provideReceipt?: boolean | undefined,
	requireBillingSubject?: boolean | undefined,
	allowOnlyForTags?: Array<GraphQLTypes["ChannelPaymentCreateAllowOnlyForTagsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ChannelPaymentCreateMethodEntityRelationInput"]: {
		connect?: GraphQLTypes["PaymentMethodUniqueWhere"] | undefined,
	create?: GraphQLTypes["PaymentMethodWithoutChannelsCreateInput"] | undefined
};
	["PaymentMethodWithoutChannelsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	enabled?: boolean | undefined,
	deliveryMethods?: Array<GraphQLTypes["PaymentMethodCreateDeliveryMethodsEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	blockingDispatch?: boolean | undefined,
	type?: GraphQLTypes["PaymentMethodType"] | undefined,
	reduceGratuityByPercentage?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["PaymentMethodCreateDeliveryMethodsEntityRelationInput"]: {
		connect?: GraphQLTypes["DeliveryMethodUniqueWhere"] | undefined,
	create?: GraphQLTypes["DeliveryMethodWithoutPaymentMethodsCreateInput"] | undefined,
	alias?: string | undefined
};
	["DeliveryMethodWithoutPaymentMethodsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	enabled?: boolean | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	requireDeliveryAddress?: boolean | undefined,
	suitableForDeliveryZones?: Array<GraphQLTypes["DeliveryMethodCreateSuitableForDeliveryZonesEntityRelationInput"]> | undefined,
	channels?: Array<GraphQLTypes["DeliveryMethodCreateChannelsEntityRelationInput"]> | undefined,
	courierHandlers?: Array<GraphQLTypes["DeliveryMethodCreateCourierHandlersEntityRelationInput"]> | undefined,
	enableDeliveryTracking?: boolean | undefined,
	locales?: Array<GraphQLTypes["DeliveryMethodCreateLocalesEntityRelationInput"]> | undefined,
	timelinePreset?: GraphQLTypes["DeliveryMethodCreateTimelinePresetEntityRelationInput"] | undefined,
	woltDriveVenueId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryMethodCreateChannelsEntityRelationInput"]: {
		connect?: GraphQLTypes["ChannelDeliveryUniqueWhere"] | undefined,
	create?: GraphQLTypes["ChannelDeliveryWithoutMethodCreateInput"] | undefined,
	alias?: string | undefined
};
	["ChannelDeliveryWithoutMethodCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	priceCents?: number | undefined,
	channel?: GraphQLTypes["ChannelDeliveryCreateChannelEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["ChannelDeliveryCreateVatRateEntityRelationInput"] | undefined,
	defaultVisible?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ChannelDeliveryCreateVatRateEntityRelationInput"]: {
		connect?: GraphQLTypes["VatRateUniqueWhere"] | undefined,
	create?: GraphQLTypes["VatRateWithoutChannelDeliveriesCreateInput"] | undefined
};
	["VatRateWithoutChannelDeliveriesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	ratePermille?: number | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	channelPayments?: Array<GraphQLTypes["VatRateCreateChannelPaymentsEntityRelationInput"]> | undefined,
	preset?: GraphQLTypes["VatRatePreset"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["VatRateCreateChannelPaymentsEntityRelationInput"]: {
		connect?: GraphQLTypes["ChannelPaymentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ChannelPaymentWithoutVatRateCreateInput"] | undefined,
	alias?: string | undefined
};
	["ChannelPaymentWithoutVatRateCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	channel?: GraphQLTypes["ChannelPaymentCreateChannelEntityRelationInput"] | undefined,
	method?: GraphQLTypes["ChannelPaymentCreateMethodEntityRelationInput"] | undefined,
	requireBillingAddress?: boolean | undefined,
	provideReceipt?: boolean | undefined,
	requireBillingSubject?: boolean | undefined,
	allowOnlyForTags?: Array<GraphQLTypes["ChannelPaymentCreateAllowOnlyForTagsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ChannelPaymentCreateAllowOnlyForTagsEntityRelationInput"]: {
		connect?: GraphQLTypes["TagUniqueWhere"] | undefined,
	create?: GraphQLTypes["TagWithoutAllowChannelPaymentsCreateInput"] | undefined,
	alias?: string | undefined
};
	["TagWithoutAllowChannelPaymentsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	customers?: Array<GraphQLTypes["TagCreateCustomersEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["TagCreateProductsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["TagCreateCategoriesEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	addTagsOnRegistration?: Array<GraphQLTypes["TagCreateAddTagsOnRegistrationEntityRelationInput"]> | undefined,
	nestedCategories?: Array<GraphQLTypes["TagCreateNestedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["TagCreateDeliveryZonesEntityRelationInput"]> | undefined,
	publicInChannels?: Array<GraphQLTypes["TagCreatePublicInChannelsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["TagCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TagCreateCustomersEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerWithoutTagsCreateInput"] | undefined,
	alias?: string | undefined
};
	["CustomerWithoutTagsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	addresses?: Array<GraphQLTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined,
	credits?: Array<GraphQLTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerCreateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerCreatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerCreateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerCreateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerCreateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerCreateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerCreateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerCreateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerCreateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreatePaymentMethodsEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerPaymentMethodUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerPaymentMethodWithoutCustomerCreateInput"] | undefined,
	alias?: string | undefined
};
	["CustomerPaymentMethodWithoutCustomerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	caption?: string | undefined,
	data?: GraphQLTypes["Json"] | undefined,
	paymentMethod?: GraphQLTypes["CustomerPaymentMethodCreatePaymentMethodEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerPaymentMethodCreatePaymentMethodEntityRelationInput"]: {
		connect?: GraphQLTypes["PaymentMethodUniqueWhere"] | undefined,
	create?: GraphQLTypes["PaymentMethodCreateInput"] | undefined
};
	["PaymentMethodCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	enabled?: boolean | undefined,
	deliveryMethods?: Array<GraphQLTypes["PaymentMethodCreateDeliveryMethodsEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	blockingDispatch?: boolean | undefined,
	type?: GraphQLTypes["PaymentMethodType"] | undefined,
	channels?: Array<GraphQLTypes["PaymentMethodCreateChannelsEntityRelationInput"]> | undefined,
	reduceGratuityByPercentage?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreateOrdersEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	create?: GraphQLTypes["OrderWithoutCustomerCreateInput"] | undefined,
	alias?: string | undefined
};
	["OrderWithoutCustomerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	state?: GraphQLTypes["OrderState"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	canceledAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	channel?: GraphQLTypes["OrderCreateChannelEntityRelationInput"] | undefined,
	discounts?: Array<GraphQLTypes["OrderCreateDiscountsEntityRelationInput"]> | undefined,
	delivery?: GraphQLTypes["OrderCreateDeliveryEntityRelationInput"] | undefined,
	items?: Array<GraphQLTypes["OrderCreateItemsEntityRelationInput"]> | undefined,
	internalNote?: string | undefined,
	cart?: GraphQLTypes["OrderCreateCartEntityRelationInput"] | undefined,
	events?: Array<GraphQLTypes["OrderCreateEventsEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddress?: GraphQLTypes["OrderCreateBillingAddressEntityRelationInput"] | undefined,
	priceLines?: Array<GraphQLTypes["OrderCreatePriceLinesEntityRelationInput"]> | undefined,
	payments?: Array<GraphQLTypes["OrderCreatePaymentsEntityRelationInput"]> | undefined,
	seq?: number | undefined,
	billingSubject?: GraphQLTypes["OrderCreateBillingSubjectEntityRelationInput"] | undefined,
	summary?: GraphQLTypes["OrderCreateSummaryEntityRelationInput"] | undefined,
	doubleshotLegacyId?: string | undefined,
	gratuity?: GraphQLTypes["OrderCreateGratuityEntityRelationInput"] | undefined,
	venue?: GraphQLTypes["OrderCreateVenueEntityRelationInput"] | undefined,
	fulfillmentNote?: string | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["OrderCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	doubleshotTotalWeightGrams?: number | undefined,
	doubleShotLegacyNumber?: string | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	doubleshotAdminUrl?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderCreateChannelEntityRelationInput"]: {
		connect?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	create?: GraphQLTypes["ChannelCreateInput"] | undefined
};
	["ChannelCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	disabled?: boolean | undefined,
	payments?: Array<GraphQLTypes["ChannelCreatePaymentsEntityRelationInput"]> | undefined,
	deliveries?: Array<GraphQLTypes["ChannelCreateDeliveriesEntityRelationInput"]> | undefined,
	pointOfSales?: Array<GraphQLTypes["ChannelCreatePointOfSalesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["ChannelCreateCartsEntityRelationInput"]> | undefined,
	customers?: Array<GraphQLTypes["ChannelCreateCustomersEntityRelationInput"]> | undefined,
	code?: GraphQLTypes["ChannelCode"] | undefined,
	addTagsOnRegistration?: Array<GraphQLTypes["ChannelCreateAddTagsOnRegistrationEntityRelationInput"]> | undefined,
	publicTags?: Array<GraphQLTypes["ChannelCreatePublicTagsEntityRelationInput"]> | undefined,
	venue?: GraphQLTypes["ChannelCreateVenueEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ChannelCreatePointOfSalesEntityRelationInput"]: {
		connect?: GraphQLTypes["PointOfSaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["PointOfSaleWithoutChannelsCreateInput"] | undefined,
	alias?: string | undefined
};
	["PointOfSaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	tenantPersonId?: GraphQLTypes["UUID"] | undefined,
	permissions?: GraphQLTypes["PointOfSalePermissionsUniqueWhere"] | undefined
};
	["PointOfSalePermissionsUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	pointOfSale?: GraphQLTypes["PointOfSaleUniqueWhere"] | undefined
};
	["PointOfSaleWithoutChannelsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	permissions?: GraphQLTypes["PointOfSaleCreatePermissionsEntityRelationInput"] | undefined,
	tenantPersonId?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleCreatePermissionsEntityRelationInput"]: {
		connect?: GraphQLTypes["PointOfSalePermissionsUniqueWhere"] | undefined
};
	["ChannelCreateCartsEntityRelationInput"]: {
		connect?: GraphQLTypes["CartUniqueWhere"] | undefined,
	create?: GraphQLTypes["CartWithoutChannelCreateInput"] | undefined,
	alias?: string | undefined
};
	["CartWithoutChannelCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	confirmedAt?: GraphQLTypes["DateTime"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	items?: Array<GraphQLTypes["CartCreateItemsEntityRelationInput"]> | undefined,
	handle?: string | undefined,
	state?: GraphQLTypes["CartState"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	order?: GraphQLTypes["CartCreateOrderEntityRelationInput"] | undefined,
	customer?: GraphQLTypes["CartCreateCustomerEntityRelationInput"] | undefined,
	deliveryAddress?: GraphQLTypes["CartCreateDeliveryAddressEntityRelationInput"] | undefined,
	billingAddress?: GraphQLTypes["CartCreateBillingAddressEntityRelationInput"] | undefined,
	deliveryOption?: string | undefined,
	paymentOption?: string | undefined,
	delivery?: GraphQLTypes["CartCreateDeliveryEntityRelationInput"] | undefined,
	payment?: GraphQLTypes["CartCreatePaymentEntityRelationInput"] | undefined,
	billingSubject?: GraphQLTypes["CartCreateBillingSubjectEntityRelationInput"] | undefined,
	priceLines?: Array<GraphQLTypes["CartCreatePriceLinesEntityRelationInput"]> | undefined,
	summary?: GraphQLTypes["CartCreateSummaryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CartCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["CartItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["CartItemWithoutCartCreateInput"] | undefined,
	alias?: string | undefined
};
	["CartItemWithoutCartCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	quantity?: number | undefined,
	product?: GraphQLTypes["CartItemCreateProductEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	updatedAt?: GraphQLTypes["DateTime"] | undefined,
	fulfillmentNote?: string | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["CartItemCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["CartItemCreateProductEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductWithoutCartItemsCreateInput"] | undefined
};
	["ProductWithoutCartItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	priceCents?: number | undefined,
	notDiscountable?: boolean | undefined,
	packing?: GraphQLTypes["ProductCreatePackingEntityRelationInput"] | undefined,
	recipe?: GraphQLTypes["ProductCreateRecipeEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["ProductCreateTagsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["ProductCreateCategoriesEntityRelationInput"]> | undefined,
	vatRate?: GraphQLTypes["ProductCreateVatRateEntityRelationInput"] | undefined,
	stocks?: Array<GraphQLTypes["ProductCreateStocksEntityRelationInput"]> | undefined,
	groupPrices?: Array<GraphQLTypes["ProductCreateGroupPricesEntityRelationInput"]> | undefined,
	image?: GraphQLTypes["ProductCreateImageEntityRelationInput"] | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	availability?: GraphQLTypes["ProductAvailability"] | undefined,
	order?: number | undefined,
	manager?: GraphQLTypes["ProductCreateManagerEntityRelationInput"] | undefined,
	orderItems?: Array<GraphQLTypes["ProductCreateOrderItemsEntityRelationInput"]> | undefined,
	maximumQuantityPerOrder?: number | undefined,
	inheritedCategories?: Array<GraphQLTypes["ProductCreateInheritedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["ProductCreateDeliveryZonesEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["ProductCreateLocalesEntityRelationInput"]> | undefined,
	archivedAt?: GraphQLTypes["DateTime"] | undefined,
	customerPrices?: Array<GraphQLTypes["ProductCreateCustomerPricesEntityRelationInput"]> | undefined,
	virtualProduct?: GraphQLTypes["ProductCreateVirtualProductEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["ProductCreateMetaEntityRelationInput"] | undefined,
	page?: GraphQLTypes["ProductCreatePageEntityRelationInput"] | undefined,
	salesDays?: Array<GraphQLTypes["ProductCreateSalesDaysEntityRelationInput"]> | undefined,
	salesWeeks?: Array<GraphQLTypes["ProductCreateSalesWeeksEntityRelationInput"]> | undefined,
	salesMonths?: Array<GraphQLTypes["ProductCreateSalesMonthsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["ProductCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	hasSubscription?: boolean | undefined,
	pointOfSaleTileColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCreateRecipeEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductRecipeUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductRecipeWithoutProductsCreateInput"] | undefined
};
	["ProductRecipeWithoutProductsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	internalNote?: string | undefined,
	color?: string | undefined,
	image?: GraphQLTypes["ProductRecipeCreateImageEntityRelationInput"] | undefined,
	icon?: GraphQLTypes["ProductRecipeCreateIconEntityRelationInput"] | undefined,
	ingredients?: Array<GraphQLTypes["ProductRecipeCreateIngredientsEntityRelationInput"]> | undefined,
	needsPrepping?: boolean | undefined,
	locales?: Array<GraphQLTypes["ProductRecipeCreateLocalesEntityRelationInput"]> | undefined,
	gutTuning?: number | undefined,
	freshingContainer?: GraphQLTypes["ProductRecipeCreateFreshingContainerEntityRelationInput"] | undefined,
	description?: string | undefined,
	nutritionFacts?: GraphQLTypes["ProductRecipeCreateNutritionFactsEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductRecipeCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["ProductRecipeCreateIconEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["ProductRecipeCreateIngredientsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductIngredientItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductIngredientItemWithoutRecipeCreateInput"] | undefined,
	alias?: string | undefined
};
	["ProductIngredientItemWithoutRecipeCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	internalOrder?: number | undefined,
	ingredient?: GraphQLTypes["ProductIngredientItemCreateIngredientEntityRelationInput"] | undefined,
	quantity?: GraphQLTypes["ProductIngredientItemCreateQuantityEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientItemCreateIngredientEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductIngredientUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductIngredientCreateInput"] | undefined
};
	["ProductIngredientCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	internalNote?: string | undefined,
	locales?: Array<GraphQLTypes["ProductIngredientCreateLocalesEntityRelationInput"]> | undefined,
	internalName?: string | undefined,
	categories?: Array<GraphQLTypes["ProductIngredientCreateCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["ProductIngredientCreateAllergensEntityRelationInput"]> | undefined,
	needsPrepping?: boolean | undefined,
	allowCustomerRating?: boolean | undefined,
	customerRatings?: Array<GraphQLTypes["ProductIngredientCreateCustomerRatingsEntityRelationInput"]> | undefined,
	preferredQuantityUnit?: GraphQLTypes["ProductIngredientCreatePreferredQuantityUnitEntityRelationInput"] | undefined,
	freshingContainer?: GraphQLTypes["ProductIngredientCreateFreshingContainerEntityRelationInput"] | undefined,
	image?: GraphQLTypes["ProductIngredientCreateImageEntityRelationInput"] | undefined,
	suppliers?: GraphQLTypes["ProductIngredientCreateSuppliersEntityRelationInput"] | undefined,
	incrementQuantityNumber?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductIngredientLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductIngredientLocaleWithoutRootCreateInput"] | undefined,
	alias?: string | undefined
};
	["ProductIngredientLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	locale?: GraphQLTypes["ProductIngredientLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutProductIngredientsCreateInput"] | undefined
};
	["LocaleWithoutProductIngredientsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	businessCategories?: Array<GraphQLTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleCreateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleCreateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateProductCategoryListsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductCategoryListLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductCategoryListLocaleWithoutLocaleCreateInput"] | undefined,
	alias?: string | undefined
};
	["ProductCategoryListLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	root?: GraphQLTypes["ProductCategoryListLocaleCreateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCategoryListLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductCategoryListUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductCategoryListWithoutLocalesCreateInput"] | undefined
};
	["ProductCategoryListWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["ProductCategoryListCreateItemsEntityRelationInput"]> | undefined,
	seasonalProductCategoriesOfBusinessCategory?: GraphQLTypes["ProductCategoryListCreateSeasonalProductCategoriesOfBusinessCategoryEntityRelationInput"] | undefined,
	specificProductsProductCategoriesOfBusinessCategory?: GraphQLTypes["ProductCategoryListCreateSpecificProductsProductCategoriesOfBusinessCategoryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCategoryListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductCategoryListItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductCategoryListItemWithoutListCreateInput"] | undefined,
	alias?: string | undefined
};
	["ProductCategoryListItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	productCategory?: GraphQLTypes["ProductCategoryListItemCreateProductCategoryEntityRelationInput"] | undefined,
	showRecipeImages?: boolean | undefined,
	showPackingImages?: boolean | undefined,
	showAllAvailableProducts?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCategoryListItemCreateProductCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductCategoryUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductCategoryCreateInput"] | undefined
};
	["ProductCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	products?: Array<GraphQLTypes["ProductCategoryCreateProductsEntityRelationInput"]> | undefined,
	tags?: Array<GraphQLTypes["ProductCategoryCreateTagsEntityRelationInput"]> | undefined,
	parent?: GraphQLTypes["ProductCategoryCreateParentEntityRelationInput"] | undefined,
	children?: Array<GraphQLTypes["ProductCategoryCreateChildrenEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	color?: string | undefined,
	image?: GraphQLTypes["ProductCategoryCreateImageEntityRelationInput"] | undefined,
	order?: number | undefined,
	descendants?: Array<GraphQLTypes["ProductCategoryCreateDescendantsEntityRelationInput"]> | undefined,
	ancestors?: Array<GraphQLTypes["ProductCategoryCreateAncestorsEntityRelationInput"]> | undefined,
	inheritedTags?: Array<GraphQLTypes["ProductCategoryCreateInheritedTagsEntityRelationInput"]> | undefined,
	nestedProducts?: Array<GraphQLTypes["ProductCategoryCreateNestedProductsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCategoryCreateProductsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductWithoutCategoriesCreateInput"] | undefined,
	alias?: string | undefined
};
	["ProductWithoutCategoriesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	priceCents?: number | undefined,
	notDiscountable?: boolean | undefined,
	packing?: GraphQLTypes["ProductCreatePackingEntityRelationInput"] | undefined,
	recipe?: GraphQLTypes["ProductCreateRecipeEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["ProductCreateTagsEntityRelationInput"]> | undefined,
	vatRate?: GraphQLTypes["ProductCreateVatRateEntityRelationInput"] | undefined,
	stocks?: Array<GraphQLTypes["ProductCreateStocksEntityRelationInput"]> | undefined,
	groupPrices?: Array<GraphQLTypes["ProductCreateGroupPricesEntityRelationInput"]> | undefined,
	image?: GraphQLTypes["ProductCreateImageEntityRelationInput"] | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	cartItems?: Array<GraphQLTypes["ProductCreateCartItemsEntityRelationInput"]> | undefined,
	availability?: GraphQLTypes["ProductAvailability"] | undefined,
	order?: number | undefined,
	manager?: GraphQLTypes["ProductCreateManagerEntityRelationInput"] | undefined,
	orderItems?: Array<GraphQLTypes["ProductCreateOrderItemsEntityRelationInput"]> | undefined,
	maximumQuantityPerOrder?: number | undefined,
	inheritedCategories?: Array<GraphQLTypes["ProductCreateInheritedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["ProductCreateDeliveryZonesEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["ProductCreateLocalesEntityRelationInput"]> | undefined,
	archivedAt?: GraphQLTypes["DateTime"] | undefined,
	customerPrices?: Array<GraphQLTypes["ProductCreateCustomerPricesEntityRelationInput"]> | undefined,
	virtualProduct?: GraphQLTypes["ProductCreateVirtualProductEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["ProductCreateMetaEntityRelationInput"] | undefined,
	page?: GraphQLTypes["ProductCreatePageEntityRelationInput"] | undefined,
	salesDays?: Array<GraphQLTypes["ProductCreateSalesDaysEntityRelationInput"]> | undefined,
	salesWeeks?: Array<GraphQLTypes["ProductCreateSalesWeeksEntityRelationInput"]> | undefined,
	salesMonths?: Array<GraphQLTypes["ProductCreateSalesMonthsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["ProductCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	hasSubscription?: boolean | undefined,
	pointOfSaleTileColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCreateTagsEntityRelationInput"]: {
		connect?: GraphQLTypes["TagUniqueWhere"] | undefined,
	create?: GraphQLTypes["TagWithoutProductsCreateInput"] | undefined,
	alias?: string | undefined
};
	["TagWithoutProductsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	customers?: Array<GraphQLTypes["TagCreateCustomersEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["TagCreateCategoriesEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	addTagsOnRegistration?: Array<GraphQLTypes["TagCreateAddTagsOnRegistrationEntityRelationInput"]> | undefined,
	nestedCategories?: Array<GraphQLTypes["TagCreateNestedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["TagCreateDeliveryZonesEntityRelationInput"]> | undefined,
	publicInChannels?: Array<GraphQLTypes["TagCreatePublicInChannelsEntityRelationInput"]> | undefined,
	allowChannelPayments?: Array<GraphQLTypes["TagCreateAllowChannelPaymentsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["TagCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TagCreateCategoriesEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductCategoryUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductCategoryWithoutTagsCreateInput"] | undefined,
	alias?: string | undefined
};
	["ProductCategoryWithoutTagsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	products?: Array<GraphQLTypes["ProductCategoryCreateProductsEntityRelationInput"]> | undefined,
	parent?: GraphQLTypes["ProductCategoryCreateParentEntityRelationInput"] | undefined,
	children?: Array<GraphQLTypes["ProductCategoryCreateChildrenEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	color?: string | undefined,
	image?: GraphQLTypes["ProductCategoryCreateImageEntityRelationInput"] | undefined,
	order?: number | undefined,
	descendants?: Array<GraphQLTypes["ProductCategoryCreateDescendantsEntityRelationInput"]> | undefined,
	ancestors?: Array<GraphQLTypes["ProductCategoryCreateAncestorsEntityRelationInput"]> | undefined,
	inheritedTags?: Array<GraphQLTypes["ProductCategoryCreateInheritedTagsEntityRelationInput"]> | undefined,
	nestedProducts?: Array<GraphQLTypes["ProductCategoryCreateNestedProductsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCategoryCreateParentEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductCategoryUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductCategoryWithoutChildrenCreateInput"] | undefined
};
	["ProductCategoryWithoutChildrenCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	products?: Array<GraphQLTypes["ProductCategoryCreateProductsEntityRelationInput"]> | undefined,
	tags?: Array<GraphQLTypes["ProductCategoryCreateTagsEntityRelationInput"]> | undefined,
	parent?: GraphQLTypes["ProductCategoryCreateParentEntityRelationInput"] | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	color?: string | undefined,
	image?: GraphQLTypes["ProductCategoryCreateImageEntityRelationInput"] | undefined,
	order?: number | undefined,
	descendants?: Array<GraphQLTypes["ProductCategoryCreateDescendantsEntityRelationInput"]> | undefined,
	ancestors?: Array<GraphQLTypes["ProductCategoryCreateAncestorsEntityRelationInput"]> | undefined,
	inheritedTags?: Array<GraphQLTypes["ProductCategoryCreateInheritedTagsEntityRelationInput"]> | undefined,
	nestedProducts?: Array<GraphQLTypes["ProductCategoryCreateNestedProductsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCategoryCreateTagsEntityRelationInput"]: {
		connect?: GraphQLTypes["TagUniqueWhere"] | undefined,
	create?: GraphQLTypes["TagWithoutCategoriesCreateInput"] | undefined,
	alias?: string | undefined
};
	["TagWithoutCategoriesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	customers?: Array<GraphQLTypes["TagCreateCustomersEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["TagCreateProductsEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	addTagsOnRegistration?: Array<GraphQLTypes["TagCreateAddTagsOnRegistrationEntityRelationInput"]> | undefined,
	nestedCategories?: Array<GraphQLTypes["TagCreateNestedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["TagCreateDeliveryZonesEntityRelationInput"]> | undefined,
	publicInChannels?: Array<GraphQLTypes["TagCreatePublicInChannelsEntityRelationInput"]> | undefined,
	allowChannelPayments?: Array<GraphQLTypes["TagCreateAllowChannelPaymentsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["TagCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TagCreateAddTagsOnRegistrationEntityRelationInput"]: {
		connect?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	create?: GraphQLTypes["ChannelWithoutAddTagsOnRegistrationCreateInput"] | undefined,
	alias?: string | undefined
};
	["ChannelWithoutAddTagsOnRegistrationCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	disabled?: boolean | undefined,
	payments?: Array<GraphQLTypes["ChannelCreatePaymentsEntityRelationInput"]> | undefined,
	deliveries?: Array<GraphQLTypes["ChannelCreateDeliveriesEntityRelationInput"]> | undefined,
	pointOfSales?: Array<GraphQLTypes["ChannelCreatePointOfSalesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["ChannelCreateCartsEntityRelationInput"]> | undefined,
	customers?: Array<GraphQLTypes["ChannelCreateCustomersEntityRelationInput"]> | undefined,
	code?: GraphQLTypes["ChannelCode"] | undefined,
	publicTags?: Array<GraphQLTypes["ChannelCreatePublicTagsEntityRelationInput"]> | undefined,
	venue?: GraphQLTypes["ChannelCreateVenueEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ChannelCreateCustomersEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerWithoutChannelsCreateInput"] | undefined,
	alias?: string | undefined
};
	["CustomerWithoutChannelsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	addresses?: Array<GraphQLTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerCreateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerCreateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerCreatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerCreateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerCreateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerCreateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerCreateUserEntityRelationInput"] | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerCreateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerCreateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerCreateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreatePermissionsEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerPermissionsUniqueWhere"] | undefined
};
	["CustomerCreateGroupEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerGroupUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerGroupWithoutCustomersCreateInput"] | undefined
};
	["CustomerGroupWithoutCustomersCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	productPrices?: Array<GraphQLTypes["CustomerGroupCreateProductPricesEntityRelationInput"]> | undefined,
	discountPermille?: number | undefined,
	code?: string | undefined,
	doubleshotLegacyId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerGroupCreateProductPricesEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductGroupPriceUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductGroupPriceWithoutGroupCreateInput"] | undefined,
	alias?: string | undefined
};
	["ProductGroupPriceWithoutGroupCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	priceCents?: number | undefined,
	product?: GraphQLTypes["ProductGroupPriceCreateProductEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductGroupPriceCreateProductEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductWithoutGroupPricesCreateInput"] | undefined
};
	["ProductWithoutGroupPricesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	priceCents?: number | undefined,
	notDiscountable?: boolean | undefined,
	packing?: GraphQLTypes["ProductCreatePackingEntityRelationInput"] | undefined,
	recipe?: GraphQLTypes["ProductCreateRecipeEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["ProductCreateTagsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["ProductCreateCategoriesEntityRelationInput"]> | undefined,
	vatRate?: GraphQLTypes["ProductCreateVatRateEntityRelationInput"] | undefined,
	stocks?: Array<GraphQLTypes["ProductCreateStocksEntityRelationInput"]> | undefined,
	image?: GraphQLTypes["ProductCreateImageEntityRelationInput"] | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	cartItems?: Array<GraphQLTypes["ProductCreateCartItemsEntityRelationInput"]> | undefined,
	availability?: GraphQLTypes["ProductAvailability"] | undefined,
	order?: number | undefined,
	manager?: GraphQLTypes["ProductCreateManagerEntityRelationInput"] | undefined,
	orderItems?: Array<GraphQLTypes["ProductCreateOrderItemsEntityRelationInput"]> | undefined,
	maximumQuantityPerOrder?: number | undefined,
	inheritedCategories?: Array<GraphQLTypes["ProductCreateInheritedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["ProductCreateDeliveryZonesEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["ProductCreateLocalesEntityRelationInput"]> | undefined,
	archivedAt?: GraphQLTypes["DateTime"] | undefined,
	customerPrices?: Array<GraphQLTypes["ProductCreateCustomerPricesEntityRelationInput"]> | undefined,
	virtualProduct?: GraphQLTypes["ProductCreateVirtualProductEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["ProductCreateMetaEntityRelationInput"] | undefined,
	page?: GraphQLTypes["ProductCreatePageEntityRelationInput"] | undefined,
	salesDays?: Array<GraphQLTypes["ProductCreateSalesDaysEntityRelationInput"]> | undefined,
	salesWeeks?: Array<GraphQLTypes["ProductCreateSalesWeeksEntityRelationInput"]> | undefined,
	salesMonths?: Array<GraphQLTypes["ProductCreateSalesMonthsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["ProductCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	hasSubscription?: boolean | undefined,
	pointOfSaleTileColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCreateCategoriesEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductCategoryUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductCategoryWithoutProductsCreateInput"] | undefined,
	alias?: string | undefined
};
	["ProductCategoryWithoutProductsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	tags?: Array<GraphQLTypes["ProductCategoryCreateTagsEntityRelationInput"]> | undefined,
	parent?: GraphQLTypes["ProductCategoryCreateParentEntityRelationInput"] | undefined,
	children?: Array<GraphQLTypes["ProductCategoryCreateChildrenEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	color?: string | undefined,
	image?: GraphQLTypes["ProductCategoryCreateImageEntityRelationInput"] | undefined,
	order?: number | undefined,
	descendants?: Array<GraphQLTypes["ProductCategoryCreateDescendantsEntityRelationInput"]> | undefined,
	ancestors?: Array<GraphQLTypes["ProductCategoryCreateAncestorsEntityRelationInput"]> | undefined,
	inheritedTags?: Array<GraphQLTypes["ProductCategoryCreateInheritedTagsEntityRelationInput"]> | undefined,
	nestedProducts?: Array<GraphQLTypes["ProductCategoryCreateNestedProductsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCategoryCreateChildrenEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductCategoryUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductCategoryWithoutParentCreateInput"] | undefined,
	alias?: string | undefined
};
	["ProductCategoryWithoutParentCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	products?: Array<GraphQLTypes["ProductCategoryCreateProductsEntityRelationInput"]> | undefined,
	tags?: Array<GraphQLTypes["ProductCategoryCreateTagsEntityRelationInput"]> | undefined,
	children?: Array<GraphQLTypes["ProductCategoryCreateChildrenEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	color?: string | undefined,
	image?: GraphQLTypes["ProductCategoryCreateImageEntityRelationInput"] | undefined,
	order?: number | undefined,
	descendants?: Array<GraphQLTypes["ProductCategoryCreateDescendantsEntityRelationInput"]> | undefined,
	ancestors?: Array<GraphQLTypes["ProductCategoryCreateAncestorsEntityRelationInput"]> | undefined,
	inheritedTags?: Array<GraphQLTypes["ProductCategoryCreateInheritedTagsEntityRelationInput"]> | undefined,
	nestedProducts?: Array<GraphQLTypes["ProductCategoryCreateNestedProductsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCategoryCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["ProductCategoryCreateDescendantsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductCategoryTreeUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductCategoryCreateAncestorsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductCategoryTreeUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductCategoryCreateInheritedTagsEntityRelationInput"]: {
		connect?: GraphQLTypes["InheritedProductCategoryTagUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductCategoryCreateNestedProductsEntityRelationInput"]: {
		connect?: GraphQLTypes["NestedProductCategoryProductUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductCreateVatRateEntityRelationInput"]: {
		connect?: GraphQLTypes["VatRateUniqueWhere"] | undefined,
	create?: GraphQLTypes["VatRateCreateInput"] | undefined
};
	["ProductCreateStocksEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductStockUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductStockWithoutProductCreateInput"] | undefined,
	alias?: string | undefined
};
	["ProductStockWithoutProductCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	quantity?: number | undefined,
	store?: GraphQLTypes["ProductStockCreateStoreEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductStockCreateStoreEntityRelationInput"]: {
		connect?: GraphQLTypes["StoreUniqueWhere"] | undefined,
	create?: GraphQLTypes["StoreCreateInput"] | undefined
};
	["StoreCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["ProductCreateCartItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["CartItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["CartItemWithoutProductCreateInput"] | undefined,
	alias?: string | undefined
};
	["CartItemWithoutProductCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	quantity?: number | undefined,
	cart?: GraphQLTypes["CartItemCreateCartEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	updatedAt?: GraphQLTypes["DateTime"] | undefined,
	fulfillmentNote?: string | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["CartItemCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["CartItemCreateCartEntityRelationInput"]: {
		connect?: GraphQLTypes["CartUniqueWhere"] | undefined,
	create?: GraphQLTypes["CartWithoutItemsCreateInput"] | undefined
};
	["CartWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	confirmedAt?: GraphQLTypes["DateTime"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	handle?: string | undefined,
	state?: GraphQLTypes["CartState"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	channel?: GraphQLTypes["CartCreateChannelEntityRelationInput"] | undefined,
	order?: GraphQLTypes["CartCreateOrderEntityRelationInput"] | undefined,
	customer?: GraphQLTypes["CartCreateCustomerEntityRelationInput"] | undefined,
	deliveryAddress?: GraphQLTypes["CartCreateDeliveryAddressEntityRelationInput"] | undefined,
	billingAddress?: GraphQLTypes["CartCreateBillingAddressEntityRelationInput"] | undefined,
	deliveryOption?: string | undefined,
	paymentOption?: string | undefined,
	delivery?: GraphQLTypes["CartCreateDeliveryEntityRelationInput"] | undefined,
	payment?: GraphQLTypes["CartCreatePaymentEntityRelationInput"] | undefined,
	billingSubject?: GraphQLTypes["CartCreateBillingSubjectEntityRelationInput"] | undefined,
	priceLines?: Array<GraphQLTypes["CartCreatePriceLinesEntityRelationInput"]> | undefined,
	summary?: GraphQLTypes["CartCreateSummaryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CartCreateChannelEntityRelationInput"]: {
		connect?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	create?: GraphQLTypes["ChannelWithoutCartsCreateInput"] | undefined
};
	["ChannelWithoutCartsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	disabled?: boolean | undefined,
	payments?: Array<GraphQLTypes["ChannelCreatePaymentsEntityRelationInput"]> | undefined,
	deliveries?: Array<GraphQLTypes["ChannelCreateDeliveriesEntityRelationInput"]> | undefined,
	pointOfSales?: Array<GraphQLTypes["ChannelCreatePointOfSalesEntityRelationInput"]> | undefined,
	customers?: Array<GraphQLTypes["ChannelCreateCustomersEntityRelationInput"]> | undefined,
	code?: GraphQLTypes["ChannelCode"] | undefined,
	addTagsOnRegistration?: Array<GraphQLTypes["ChannelCreateAddTagsOnRegistrationEntityRelationInput"]> | undefined,
	publicTags?: Array<GraphQLTypes["ChannelCreatePublicTagsEntityRelationInput"]> | undefined,
	venue?: GraphQLTypes["ChannelCreateVenueEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ChannelCreateAddTagsOnRegistrationEntityRelationInput"]: {
		connect?: GraphQLTypes["TagUniqueWhere"] | undefined,
	create?: GraphQLTypes["TagWithoutAddTagsOnRegistrationCreateInput"] | undefined,
	alias?: string | undefined
};
	["TagWithoutAddTagsOnRegistrationCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	customers?: Array<GraphQLTypes["TagCreateCustomersEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["TagCreateProductsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["TagCreateCategoriesEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	nestedCategories?: Array<GraphQLTypes["TagCreateNestedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["TagCreateDeliveryZonesEntityRelationInput"]> | undefined,
	publicInChannels?: Array<GraphQLTypes["TagCreatePublicInChannelsEntityRelationInput"]> | undefined,
	allowChannelPayments?: Array<GraphQLTypes["TagCreateAllowChannelPaymentsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["TagCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TagCreateNestedCategoriesEntityRelationInput"]: {
		connect?: GraphQLTypes["InheritedProductCategoryTagUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TagCreateDeliveryZonesEntityRelationInput"]: {
		connect?: GraphQLTypes["DeliveryZoneUniqueWhere"] | undefined,
	create?: GraphQLTypes["DeliveryZoneWithoutDeliveryZonesOfTagsCreateInput"] | undefined,
	alias?: string | undefined
};
	["DeliveryZoneWithoutDeliveryZonesOfTagsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	type?: GraphQLTypes["DeliveryZoneType"] | undefined,
	addresses?: Array<GraphQLTypes["DeliveryZoneCreateAddressesEntityRelationInput"]> | undefined,
	suitableDeliveryMethods?: Array<GraphQLTypes["DeliveryZoneCreateSuitableDeliveryMethodsEntityRelationInput"]> | undefined,
	deliveryZonesOfProducts?: Array<GraphQLTypes["DeliveryZoneCreateDeliveryZonesOfProductsEntityRelationInput"]> | undefined,
	addressesMetadata?: Array<GraphQLTypes["DeliveryZoneCreateAddressesMetadataEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryZoneCreateDeliveryZonesOfProductsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductWithoutDeliveryZonesCreateInput"] | undefined,
	alias?: string | undefined
};
	["ProductWithoutDeliveryZonesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	priceCents?: number | undefined,
	notDiscountable?: boolean | undefined,
	packing?: GraphQLTypes["ProductCreatePackingEntityRelationInput"] | undefined,
	recipe?: GraphQLTypes["ProductCreateRecipeEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["ProductCreateTagsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["ProductCreateCategoriesEntityRelationInput"]> | undefined,
	vatRate?: GraphQLTypes["ProductCreateVatRateEntityRelationInput"] | undefined,
	stocks?: Array<GraphQLTypes["ProductCreateStocksEntityRelationInput"]> | undefined,
	groupPrices?: Array<GraphQLTypes["ProductCreateGroupPricesEntityRelationInput"]> | undefined,
	image?: GraphQLTypes["ProductCreateImageEntityRelationInput"] | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	cartItems?: Array<GraphQLTypes["ProductCreateCartItemsEntityRelationInput"]> | undefined,
	availability?: GraphQLTypes["ProductAvailability"] | undefined,
	order?: number | undefined,
	manager?: GraphQLTypes["ProductCreateManagerEntityRelationInput"] | undefined,
	orderItems?: Array<GraphQLTypes["ProductCreateOrderItemsEntityRelationInput"]> | undefined,
	maximumQuantityPerOrder?: number | undefined,
	inheritedCategories?: Array<GraphQLTypes["ProductCreateInheritedCategoriesEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["ProductCreateLocalesEntityRelationInput"]> | undefined,
	archivedAt?: GraphQLTypes["DateTime"] | undefined,
	customerPrices?: Array<GraphQLTypes["ProductCreateCustomerPricesEntityRelationInput"]> | undefined,
	virtualProduct?: GraphQLTypes["ProductCreateVirtualProductEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["ProductCreateMetaEntityRelationInput"] | undefined,
	page?: GraphQLTypes["ProductCreatePageEntityRelationInput"] | undefined,
	salesDays?: Array<GraphQLTypes["ProductCreateSalesDaysEntityRelationInput"]> | undefined,
	salesWeeks?: Array<GraphQLTypes["ProductCreateSalesWeeksEntityRelationInput"]> | undefined,
	salesMonths?: Array<GraphQLTypes["ProductCreateSalesMonthsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["ProductCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	hasSubscription?: boolean | undefined,
	pointOfSaleTileColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCreateGroupPricesEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductGroupPriceUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductGroupPriceWithoutProductCreateInput"] | undefined,
	alias?: string | undefined
};
	["ProductGroupPriceWithoutProductCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	priceCents?: number | undefined,
	group?: GraphQLTypes["ProductGroupPriceCreateGroupEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductGroupPriceCreateGroupEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerGroupUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerGroupWithoutProductPricesCreateInput"] | undefined
};
	["CustomerGroupWithoutProductPricesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	customers?: Array<GraphQLTypes["CustomerGroupCreateCustomersEntityRelationInput"]> | undefined,
	discountPermille?: number | undefined,
	code?: string | undefined,
	doubleshotLegacyId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerGroupCreateCustomersEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerWithoutGroupCreateInput"] | undefined,
	alias?: string | undefined
};
	["CustomerWithoutGroupCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	addresses?: Array<GraphQLTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerCreateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerCreatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerCreateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerCreateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerCreateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerCreateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerCreateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerCreateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerCreateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreatePhotoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["CustomerCreateNameEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerNameUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerNameWithoutCustomerCreateInput"] | undefined
};
	["CustomerNameWithoutCustomerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	nominative?: string | undefined,
	vocative?: string | undefined,
	aliases?: Array<GraphQLTypes["CustomerNameCreateAliasesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerNameCreateAliasesEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerAliasUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerAliasCreateInput"] | undefined,
	alias?: string | undefined
};
	["CustomerAliasUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["CustomerAliasCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreateIngredientRatingsEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerIngredientRatingUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerIngredientRatingWithoutCustomerCreateInput"] | undefined,
	alias?: string | undefined
};
	["CustomerIngredientRatingWithoutCustomerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	rating?: GraphQLTypes["CustomerIngredientRatingCreateRatingEntityRelationInput"] | undefined,
	ingredient?: GraphQLTypes["CustomerIngredientRatingCreateIngredientEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerIngredientRatingCreateRatingEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductIngredientRatingUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductIngredientRatingCreateInput"] | undefined
};
	["ProductIngredientRatingUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["ProductIngredientRatingCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	name?: string | undefined,
	icon?: GraphQLTypes["ProductIngredientRatingCreateIconEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientRatingCreateIconEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["CustomerIngredientRatingCreateIngredientEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductIngredientUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductIngredientWithoutCustomerRatingsCreateInput"] | undefined
};
	["ProductIngredientWithoutCustomerRatingsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	internalNote?: string | undefined,
	locales?: Array<GraphQLTypes["ProductIngredientCreateLocalesEntityRelationInput"]> | undefined,
	internalName?: string | undefined,
	categories?: Array<GraphQLTypes["ProductIngredientCreateCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["ProductIngredientCreateAllergensEntityRelationInput"]> | undefined,
	needsPrepping?: boolean | undefined,
	allowCustomerRating?: boolean | undefined,
	preferredQuantityUnit?: GraphQLTypes["ProductIngredientCreatePreferredQuantityUnitEntityRelationInput"] | undefined,
	freshingContainer?: GraphQLTypes["ProductIngredientCreateFreshingContainerEntityRelationInput"] | undefined,
	image?: GraphQLTypes["ProductIngredientCreateImageEntityRelationInput"] | undefined,
	suppliers?: GraphQLTypes["ProductIngredientCreateSuppliersEntityRelationInput"] | undefined,
	incrementQuantityNumber?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientCreateCategoriesEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductIngredientCategoryUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductIngredientCategoryWithoutIngredientsCreateInput"] | undefined,
	alias?: string | undefined
};
	["ProductIngredientCategoryWithoutIngredientsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	internalName?: string | undefined,
	internalNote?: string | undefined,
	locales?: Array<GraphQLTypes["ProductIngredientCategoryCreateLocalesEntityRelationInput"]> | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientCategoryCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductIngredientCategoryLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductIngredientCategoryLocaleWithoutRootCreateInput"] | undefined,
	alias?: string | undefined
};
	["ProductIngredientCategoryLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	locale?: GraphQLTypes["ProductIngredientCategoryLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientCategoryLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutProductIngredientCategoriesCreateInput"] | undefined
};
	["LocaleWithoutProductIngredientCategoriesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	businessCategories?: Array<GraphQLTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleCreateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleCreateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateProductIngredientsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductIngredientLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductIngredientLocaleWithoutLocaleCreateInput"] | undefined,
	alias?: string | undefined
};
	["ProductIngredientLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	root?: GraphQLTypes["ProductIngredientLocaleCreateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductIngredientUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductIngredientWithoutLocalesCreateInput"] | undefined
};
	["ProductIngredientWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	internalNote?: string | undefined,
	internalName?: string | undefined,
	categories?: Array<GraphQLTypes["ProductIngredientCreateCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["ProductIngredientCreateAllergensEntityRelationInput"]> | undefined,
	needsPrepping?: boolean | undefined,
	allowCustomerRating?: boolean | undefined,
	customerRatings?: Array<GraphQLTypes["ProductIngredientCreateCustomerRatingsEntityRelationInput"]> | undefined,
	preferredQuantityUnit?: GraphQLTypes["ProductIngredientCreatePreferredQuantityUnitEntityRelationInput"] | undefined,
	freshingContainer?: GraphQLTypes["ProductIngredientCreateFreshingContainerEntityRelationInput"] | undefined,
	image?: GraphQLTypes["ProductIngredientCreateImageEntityRelationInput"] | undefined,
	suppliers?: GraphQLTypes["ProductIngredientCreateSuppliersEntityRelationInput"] | undefined,
	incrementQuantityNumber?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientCreateAllergensEntityRelationInput"]: {
		connect?: GraphQLTypes["AllergenUniqueWhere"] | undefined,
	create?: GraphQLTypes["AllergenWithoutIngredientsCreateInput"] | undefined,
	alias?: string | undefined
};
	["AllergenWithoutIngredientsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	internalName?: string | undefined,
	locales?: Array<GraphQLTypes["AllergenCreateLocalesEntityRelationInput"]> | undefined,
	code?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["AllergenCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["AllergenLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["AllergenLocaleWithoutRootCreateInput"] | undefined,
	alias?: string | undefined
};
	["AllergenLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	locale?: GraphQLTypes["AllergenLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["AllergenLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutAllergensCreateInput"] | undefined
};
	["LocaleWithoutAllergensCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	businessCategories?: Array<GraphQLTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleCreateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleCreateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateOrderRecurrencesEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderRecurrenceLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["OrderRecurrenceLocaleWithoutLocaleCreateInput"] | undefined,
	alias?: string | undefined
};
	["OrderRecurrenceLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	root?: GraphQLTypes["OrderRecurrenceLocaleCreateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderRecurrenceLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderRecurrenceUniqueWhere"] | undefined,
	create?: GraphQLTypes["OrderRecurrenceWithoutLocalesCreateInput"] | undefined
};
	["OrderRecurrenceWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	internalName?: string | undefined,
	order?: number | undefined,
	businessCategory?: Array<GraphQLTypes["OrderRecurrenceCreateBusinessCategoryEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderRecurrenceCreateBusinessCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["BusinessCategoryUniqueWhere"] | undefined,
	create?: GraphQLTypes["BusinessCategoryWithoutRecurrencesCreateInput"] | undefined,
	alias?: string | undefined
};
	["BusinessCategoryWithoutRecurrencesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	visibleToNewCustomers?: boolean | undefined,
	locales?: Array<GraphQLTypes["BusinessCategoryCreateLocalesEntityRelationInput"]> | undefined,
	internalName?: string | undefined,
	businessCustomers?: Array<GraphQLTypes["BusinessCategoryCreateBusinessCustomersEntityRelationInput"]> | undefined,
	specificProducts?: GraphQLTypes["BusinessCategoryCreateSpecificProductsEntityRelationInput"] | undefined,
	seasonalProductCategories?: GraphQLTypes["BusinessCategoryCreateSeasonalProductCategoriesEntityRelationInput"] | undefined,
	specificProductsProductCategories?: GraphQLTypes["BusinessCategoryCreateSpecificProductsProductCategoriesEntityRelationInput"] | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessCategoryCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["BusinessCategoryLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["BusinessCategoryLocaleWithoutRootCreateInput"] | undefined,
	alias?: string | undefined
};
	["BusinessCategoryLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	locale?: GraphQLTypes["BusinessCategoryLocaleCreateLocaleEntityRelationInput"] | undefined,
	title?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessCategoryLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutBusinessCategoriesCreateInput"] | undefined
};
	["LocaleWithoutBusinessCategoriesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleCreateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleCreateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateBlogsEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["BlogLocaleWithoutLocaleCreateInput"] | undefined,
	alias?: string | undefined
};
	["BlogLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	pageName?: string | undefined,
	title?: string | undefined,
	lead?: string | undefined,
	root?: GraphQLTypes["BlogLocaleCreateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BlogLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogUniqueWhere"] | undefined,
	create?: GraphQLTypes["BlogWithoutLocalesCreateInput"] | undefined
};
	["BlogWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateBlogPostsEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPostLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["BlogPostLocaleWithoutLocaleCreateInput"] | undefined,
	alias?: string | undefined
};
	["BlogPostLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	availableForWeb?: boolean | undefined,
	availableForMobile?: boolean | undefined,
	root?: GraphQLTypes["BlogPostLocaleCreateRootEntityRelationInput"] | undefined,
	cover?: GraphQLTypes["BlogPostLocaleCreateCoverEntityRelationInput"] | undefined,
	content?: GraphQLTypes["BlogPostLocaleCreateContentEntityRelationInput"] | undefined,
	link?: GraphQLTypes["BlogPostLocaleCreateLinkEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["BlogPostLocaleCreateSeoEntityRelationInput"] | undefined,
	products?: Array<GraphQLTypes["BlogPostLocaleCreateProductsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["BlogPostLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPostUniqueWhere"] | undefined,
	create?: GraphQLTypes["BlogPostWithoutLocalesCreateInput"] | undefined
};
	["BlogPostWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["BlogPostLocaleCreateCoverEntityRelationInput"]: {
		connect?: GraphQLTypes["CoverUniqueWhere"] | undefined,
	create?: GraphQLTypes["CoverCreateInput"] | undefined
};
	["CoverCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	primaryTitle?: string | undefined,
	secondaryTitle?: string | undefined,
	medium?: GraphQLTypes["CoverCreateMediumEntityRelationInput"] | undefined,
	buttonColors?: GraphQLTypes["CoverCreateButtonColorsEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CoverCreateMediumEntityRelationInput"]: {
		connect?: GraphQLTypes["MediumUniqueWhere"] | undefined,
	create?: GraphQLTypes["MediumCreateInput"] | undefined
};
	["MediumUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["MediumCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["MediumType"] | undefined,
	colorTheme?: GraphQLTypes["ColorTheme"] | undefined,
	image?: GraphQLTypes["MediumCreateImageEntityRelationInput"] | undefined,
	video?: GraphQLTypes["MediumCreateVideoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["MediumCreateVideoEntityRelationInput"]: {
		connect?: GraphQLTypes["VideoUniqueWhere"] | undefined,
	create?: GraphQLTypes["VideoCreateInput"] | undefined
};
	["VideoUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["VideoCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	src?: string | undefined,
	width?: number | undefined,
	height?: number | undefined,
	size?: number | undefined,
	type?: string | undefined,
	duration?: number | undefined,
	poster?: GraphQLTypes["VideoCreatePosterEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["VideoCreatePosterEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["CoverCreateButtonColorsEntityRelationInput"]: {
		connect?: GraphQLTypes["ColorPalleteUniqueWhere"] | undefined,
	create?: GraphQLTypes["ColorPalleteCreateInput"] | undefined
};
	["ColorPalleteUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["ColorPalleteCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	background?: string | undefined,
	text?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BlogPostLocaleCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined
};
	["ContentCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	blocks?: Array<GraphQLTypes["ContentCreateBlocksEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentCreateBlocksEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentBlockUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentBlockWithoutContentCreateInput"] | undefined,
	alias?: string | undefined
};
	["ContentBlockWithoutContentCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	json?: string | undefined,
	references?: Array<GraphQLTypes["ContentBlockCreateReferencesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentBlockCreateReferencesEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentReferenceUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentReferenceWithoutBlockCreateInput"] | undefined,
	alias?: string | undefined
};
	["ContentReferenceWithoutBlockCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["ContentReferenceType"] | undefined,
	primaryText?: string | undefined,
	secondaryText?: string | undefined,
	jsonContent?: string | undefined,
	colorPallete?: GraphQLTypes["ContentReferenceCreateColorPalleteEntityRelationInput"] | undefined,
	medium?: GraphQLTypes["ContentReferenceCreateMediumEntityRelationInput"] | undefined,
	link?: GraphQLTypes["ContentReferenceCreateLinkEntityRelationInput"] | undefined,
	blogPosts?: GraphQLTypes["ContentReferenceCreateBlogPostsEntityRelationInput"] | undefined,
	links?: GraphQLTypes["ContentReferenceCreateLinksEntityRelationInput"] | undefined,
	products?: GraphQLTypes["ContentReferenceCreateProductsEntityRelationInput"] | undefined,
	contentSize?: GraphQLTypes["ContentSize"] | undefined,
	misc?: string | undefined,
	hero?: GraphQLTypes["ContentReferenceCreateHeroEntityRelationInput"] | undefined,
	gallery?: GraphQLTypes["ContentReferenceCreateGalleryEntityRelationInput"] | undefined,
	socialsAndApps?: GraphQLTypes["ContentReferenceCreateSocialsAndAppsEntityRelationInput"] | undefined,
	productGrid?: GraphQLTypes["ContentReferenceCreateProductGridEntityRelationInput"] | undefined,
	productBanners?: GraphQLTypes["ContentReferenceCreateProductBannersEntityRelationInput"] | undefined,
	deliveryRegions?: GraphQLTypes["ContentReferenceCreateDeliveryRegionsEntityRelationInput"] | undefined,
	textList?: GraphQLTypes["ContentReferenceCreateTextListEntityRelationInput"] | undefined,
	gridTiles?: GraphQLTypes["ContentReferenceCreateGridTilesEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentReferenceCreateColorPalleteEntityRelationInput"]: {
		connect?: GraphQLTypes["ColorPalleteUniqueWhere"] | undefined,
	create?: GraphQLTypes["ColorPalleteCreateInput"] | undefined
};
	["ContentReferenceCreateMediumEntityRelationInput"]: {
		connect?: GraphQLTypes["MediumUniqueWhere"] | undefined,
	create?: GraphQLTypes["MediumCreateInput"] | undefined
};
	["ContentReferenceCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined
};
	["LinkCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["LinkType"] | undefined,
	title?: string | undefined,
	externalLink?: string | undefined,
	internalLink?: GraphQLTypes["LinkCreateInternalLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkCreateInternalLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkableCreateInput"] | undefined
};
	["LinkableCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	url?: string | undefined,
	blogPost?: GraphQLTypes["LinkableCreateBlogPostEntityRelationInput"] | undefined,
	page?: GraphQLTypes["LinkableCreatePageEntityRelationInput"] | undefined,
	wikiPage?: GraphQLTypes["LinkableCreateWikiPageEntityRelationInput"] | undefined,
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableCreateBlogPostEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPostLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["BlogPostLocaleWithoutLinkCreateInput"] | undefined
};
	["BlogPostLocaleWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	availableForWeb?: boolean | undefined,
	availableForMobile?: boolean | undefined,
	root?: GraphQLTypes["BlogPostLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["BlogPostLocaleCreateLocaleEntityRelationInput"] | undefined,
	cover?: GraphQLTypes["BlogPostLocaleCreateCoverEntityRelationInput"] | undefined,
	content?: GraphQLTypes["BlogPostLocaleCreateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["BlogPostLocaleCreateSeoEntityRelationInput"] | undefined,
	products?: Array<GraphQLTypes["BlogPostLocaleCreateProductsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["BlogPostLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutBlogPostsCreateInput"] | undefined
};
	["LocaleWithoutBlogPostsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	businessCategories?: Array<GraphQLTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleCreateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleCreateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateIdentifierEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationCataloguesIdentifierUniqueWhere"] | undefined,
	create?: GraphQLTypes["TranslationCataloguesIdentifierCreateInput"] | undefined
};
	["TranslationCataloguesIdentifierCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	catalogue?: Array<GraphQLTypes["TranslationCataloguesIdentifierCreateCatalogueEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationCataloguesIdentifierCreateCatalogueEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationCatalogueUniqueWhere"] | undefined,
	create?: GraphQLTypes["TranslationCatalogueWithoutIdentifierCreateInput"] | undefined,
	alias?: string | undefined
};
	["TranslationCatalogueWithoutIdentifierCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	domain?: GraphQLTypes["TranslationCatalogueCreateDomainEntityRelationInput"] | undefined,
	fallback?: GraphQLTypes["TranslationCatalogueCreateFallbackEntityRelationInput"] | undefined,
	values?: Array<GraphQLTypes["TranslationCatalogueCreateValuesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationCatalogueCreateDomainEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationDomainUniqueWhere"] | undefined,
	create?: GraphQLTypes["TranslationDomainWithoutCataloguesCreateInput"] | undefined
};
	["TranslationDomainWithoutCataloguesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	identifier?: string | undefined,
	name?: string | undefined,
	keys?: Array<GraphQLTypes["TranslationDomainCreateKeysEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationDomainCreateKeysEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationKeyUniqueWhere"] | undefined,
	create?: GraphQLTypes["TranslationKeyWithoutDomainCreateInput"] | undefined,
	alias?: string | undefined
};
	["TranslationKeyWithoutDomainCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	identifier?: string | undefined,
	contentType?: GraphQLTypes["TranslationContentType"] | undefined,
	note?: string | undefined,
	values?: Array<GraphQLTypes["TranslationKeyCreateValuesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationKeyCreateValuesEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationValueUniqueWhere"] | undefined,
	create?: GraphQLTypes["TranslationValueWithoutKeyCreateInput"] | undefined,
	alias?: string | undefined
};
	["TranslationValueWithoutKeyCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	value?: string | undefined,
	catalogue?: GraphQLTypes["TranslationValueCreateCatalogueEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationValueCreateCatalogueEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationCatalogueUniqueWhere"] | undefined,
	create?: GraphQLTypes["TranslationCatalogueWithoutValuesCreateInput"] | undefined
};
	["TranslationCatalogueWithoutValuesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	domain?: GraphQLTypes["TranslationCatalogueCreateDomainEntityRelationInput"] | undefined,
	fallback?: GraphQLTypes["TranslationCatalogueCreateFallbackEntityRelationInput"] | undefined,
	identifier?: GraphQLTypes["TranslationCatalogueCreateIdentifierEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationCatalogueCreateFallbackEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationCatalogueUniqueWhere"] | undefined,
	create?: GraphQLTypes["TranslationCatalogueCreateInput"] | undefined
};
	["TranslationCatalogueCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	domain?: GraphQLTypes["TranslationCatalogueCreateDomainEntityRelationInput"] | undefined,
	fallback?: GraphQLTypes["TranslationCatalogueCreateFallbackEntityRelationInput"] | undefined,
	values?: Array<GraphQLTypes["TranslationCatalogueCreateValuesEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["TranslationCatalogueCreateIdentifierEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationCatalogueCreateValuesEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationValueUniqueWhere"] | undefined,
	create?: GraphQLTypes["TranslationValueWithoutCatalogueCreateInput"] | undefined,
	alias?: string | undefined
};
	["TranslationValueWithoutCatalogueCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	value?: string | undefined,
	key?: GraphQLTypes["TranslationValueCreateKeyEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationValueCreateKeyEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationKeyUniqueWhere"] | undefined,
	create?: GraphQLTypes["TranslationKeyWithoutValuesCreateInput"] | undefined
};
	["TranslationKeyWithoutValuesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	identifier?: string | undefined,
	contentType?: GraphQLTypes["TranslationContentType"] | undefined,
	note?: string | undefined,
	domain?: GraphQLTypes["TranslationKeyCreateDomainEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationKeyCreateDomainEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationDomainUniqueWhere"] | undefined,
	create?: GraphQLTypes["TranslationDomainWithoutKeysCreateInput"] | undefined
};
	["TranslationDomainWithoutKeysCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	identifier?: string | undefined,
	name?: string | undefined,
	catalogues?: Array<GraphQLTypes["TranslationDomainCreateCataloguesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationDomainCreateCataloguesEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationCatalogueUniqueWhere"] | undefined,
	create?: GraphQLTypes["TranslationCatalogueWithoutDomainCreateInput"] | undefined,
	alias?: string | undefined
};
	["TranslationCatalogueWithoutDomainCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	fallback?: GraphQLTypes["TranslationCatalogueCreateFallbackEntityRelationInput"] | undefined,
	values?: Array<GraphQLTypes["TranslationCatalogueCreateValuesEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["TranslationCatalogueCreateIdentifierEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationCatalogueCreateIdentifierEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationCataloguesIdentifierUniqueWhere"] | undefined,
	create?: GraphQLTypes["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"] | undefined
};
	["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateMenusEntityRelationInput"]: {
		connect?: GraphQLTypes["MenuLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["MenuLocaleWithoutLocaleCreateInput"] | undefined,
	alias?: string | undefined
};
	["MenuLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["MenuLocaleCreateRootEntityRelationInput"] | undefined,
	items?: Array<GraphQLTypes["MenuLocaleCreateItemsEntityRelationInput"]> | undefined,
	secondaryItems?: GraphQLTypes["MenuLocaleCreateSecondaryItemsEntityRelationInput"] | undefined,
	eshopLink?: GraphQLTypes["MenuLocaleCreateEshopLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MenuLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["SiteMenuUniqueWhere"] | undefined,
	create?: GraphQLTypes["SiteMenuWithoutLocalesCreateInput"] | undefined
};
	["SiteMenuWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MenuLocaleCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["MenuItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["MenuItemWithoutMenuCreateInput"] | undefined,
	alias?: string | undefined
};
	["MenuItemWithoutMenuCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	link?: GraphQLTypes["MenuItemCreateLinkEntityRelationInput"] | undefined,
	subitems?: Array<GraphQLTypes["MenuItemCreateSubitemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["MenuItemCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined
};
	["MenuItemCreateSubitemsEntityRelationInput"]: {
		connect?: GraphQLTypes["MenuSubitemUniqueWhere"] | undefined,
	create?: GraphQLTypes["MenuSubitemWithoutItemCreateInput"] | undefined,
	alias?: string | undefined
};
	["MenuSubitemWithoutItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["MenuSubitemType"] | undefined,
	title?: string | undefined,
	links?: GraphQLTypes["MenuSubitemCreateLinksEntityRelationInput"] | undefined,
	products?: GraphQLTypes["MenuSubitemCreateProductsEntityRelationInput"] | undefined,
	delivery?: GraphQLTypes["MenuSubitemCreateDeliveryEntityRelationInput"] | undefined,
	contact?: GraphQLTypes["MenuSubitemCreateContactEntityRelationInput"] | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["MenuSubitemCreateLinksEntityRelationInput"]: {
		connect?: GraphQLTypes["MenuLinkListUniqueWhere"] | undefined,
	create?: GraphQLTypes["MenuLinkListCreateInput"] | undefined
};
	["MenuLinkListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["MenuLinkItemUniqueWhere"] | undefined
};
	["MenuLinkItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["MenuLinkListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["MenuLinkListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["MenuLinkListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["MenuLinkItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["MenuLinkItemWithoutListCreateInput"] | undefined,
	alias?: string | undefined
};
	["MenuLinkItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	link?: GraphQLTypes["MenuLinkItemCreateLinkEntityRelationInput"] | undefined,
	image?: GraphQLTypes["MenuLinkItemCreateImageEntityRelationInput"] | undefined,
	description?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["MenuLinkItemCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined
};
	["MenuLinkItemCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["MenuSubitemCreateProductsEntityRelationInput"]: {
		connect?: GraphQLTypes["MenuProductsUniqueWhere"] | undefined,
	create?: GraphQLTypes["MenuProductsCreateInput"] | undefined
};
	["MenuProductsUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	buttons?: GraphQLTypes["LinkListUniqueWhere"] | undefined
};
	["MenuProductsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	links?: GraphQLTypes["MenuProductsCreateLinksEntityRelationInput"] | undefined,
	buttons?: GraphQLTypes["MenuProductsCreateButtonsEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MenuProductsCreateLinksEntityRelationInput"]: {
		connect?: GraphQLTypes["MenuLinkListUniqueWhere"] | undefined,
	create?: GraphQLTypes["MenuLinkListCreateInput"] | undefined
};
	["MenuProductsCreateButtonsEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkListUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkListCreateInput"] | undefined
};
	["LinkListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["LinkListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkListItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkListItemWithoutListCreateInput"] | undefined,
	alias?: string | undefined
};
	["LinkListItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	isPrimary?: boolean | undefined,
	link?: GraphQLTypes["LinkListItemCreateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkListItemCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined
};
	["MenuSubitemCreateDeliveryEntityRelationInput"]: {
		connect?: GraphQLTypes["MenuDeliveryUniqueWhere"] | undefined,
	create?: GraphQLTypes["MenuDeliveryCreateInput"] | undefined
};
	["MenuDeliveryUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	deliveryRegions?: GraphQLTypes["DeliveryRegionsUniqueWhere"] | undefined
};
	["MenuDeliveryCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	deliveryRegions?: GraphQLTypes["MenuDeliveryCreateDeliveryRegionsEntityRelationInput"] | undefined,
	text?: string | undefined,
	socialsAndApps?: GraphQLTypes["MenuDeliveryCreateSocialsAndAppsEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MenuDeliveryCreateDeliveryRegionsEntityRelationInput"]: {
		connect?: GraphQLTypes["DeliveryRegionsUniqueWhere"] | undefined,
	create?: GraphQLTypes["DeliveryRegionsCreateInput"] | undefined
};
	["DeliveryRegionsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["DeliveryRegionsCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryRegionsCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["DeliveryRegionsItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["DeliveryRegionsItemWithoutListCreateInput"] | undefined,
	alias?: string | undefined
};
	["DeliveryRegionsItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	title?: string | undefined,
	offerLabel?: string | undefined,
	image?: GraphQLTypes["DeliveryRegionsItemCreateImageEntityRelationInput"] | undefined,
	textList?: GraphQLTypes["DeliveryRegionsItemCreateTextListEntityRelationInput"] | undefined,
	gallery?: GraphQLTypes["DeliveryRegionsItemCreateGalleryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryRegionsItemCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["DeliveryRegionsItemCreateTextListEntityRelationInput"]: {
		connect?: GraphQLTypes["TextListUniqueWhere"] | undefined,
	create?: GraphQLTypes["TextListCreateInput"] | undefined
};
	["TextListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["TextListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TextListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["TextItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["TextItemWithoutListCreateInput"] | undefined,
	alias?: string | undefined
};
	["TextItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	text?: string | undefined,
	title?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryRegionsItemCreateGalleryEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageListUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageListCreateInput"] | undefined
};
	["ImageListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["ImageListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageListItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageListItemWithoutListCreateInput"] | undefined,
	alias?: string | undefined
};
	["ImageListItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	image?: GraphQLTypes["ImageListItemCreateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageListItemCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["MenuDeliveryCreateSocialsAndAppsEntityRelationInput"]: {
		connect?: GraphQLTypes["SocialsAndAppsUniqueWhere"] | undefined,
	create?: GraphQLTypes["SocialsAndAppsCreateInput"] | undefined
};
	["SocialsAndAppsUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["SocialsAndAppsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	instagram?: boolean | undefined,
	appStore?: boolean | undefined,
	googlePlay?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["MenuSubitemCreateContactEntityRelationInput"]: {
		connect?: GraphQLTypes["MenuContactUniqueWhere"] | undefined,
	create?: GraphQLTypes["MenuContactCreateInput"] | undefined
};
	["MenuContactUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["MenuContactCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	text?: string | undefined,
	image?: GraphQLTypes["MenuContactCreateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MenuContactCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["MenuLocaleCreateSecondaryItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkListUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkListCreateInput"] | undefined
};
	["MenuLocaleCreateEshopLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined
};
	["LocaleCreatePagesEntityRelationInput"]: {
		connect?: GraphQLTypes["PageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["PageLocaleWithoutLocaleCreateInput"] | undefined,
	alias?: string | undefined
};
	["PageLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	link?: GraphQLTypes["PageLocaleCreateLinkEntityRelationInput"] | undefined,
	root?: GraphQLTypes["PageLocaleCreateRootEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["PageLocaleCreateSeoEntityRelationInput"] | undefined,
	content?: GraphQLTypes["PageLocaleCreateContentEntityRelationInput"] | undefined,
	cover?: GraphQLTypes["PageLocaleCreateCoverEntityRelationInput"] | undefined,
	theme?: GraphQLTypes["PageTheme"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PageLocaleCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkableWithoutPageCreateInput"] | undefined
};
	["LinkableWithoutPageCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	url?: string | undefined,
	blogPost?: GraphQLTypes["LinkableCreateBlogPostEntityRelationInput"] | undefined,
	wikiPage?: GraphQLTypes["LinkableCreateWikiPageEntityRelationInput"] | undefined,
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableCreateWikiPageEntityRelationInput"]: {
		connect?: GraphQLTypes["WikiPageUniqueWhere"] | undefined,
	create?: GraphQLTypes["WikiPageWithoutLinkCreateInput"] | undefined
};
	["WikiPageWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	title?: string | undefined,
	emoji?: string | undefined,
	parent?: GraphQLTypes["WikiPageCreateParentEntityRelationInput"] | undefined,
	children?: Array<GraphQLTypes["WikiPageCreateChildrenEntityRelationInput"]> | undefined,
	content?: GraphQLTypes["WikiPageCreateContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["WikiPageCreateParentEntityRelationInput"]: {
		connect?: GraphQLTypes["WikiPageUniqueWhere"] | undefined,
	create?: GraphQLTypes["WikiPageWithoutChildrenCreateInput"] | undefined
};
	["WikiPageWithoutChildrenCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	title?: string | undefined,
	emoji?: string | undefined,
	link?: GraphQLTypes["WikiPageCreateLinkEntityRelationInput"] | undefined,
	parent?: GraphQLTypes["WikiPageCreateParentEntityRelationInput"] | undefined,
	content?: GraphQLTypes["WikiPageCreateContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["WikiPageCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkableWithoutWikiPageCreateInput"] | undefined
};
	["LinkableWithoutWikiPageCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	url?: string | undefined,
	blogPost?: GraphQLTypes["LinkableCreateBlogPostEntityRelationInput"] | undefined,
	page?: GraphQLTypes["LinkableCreatePageEntityRelationInput"] | undefined,
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableCreatePageEntityRelationInput"]: {
		connect?: GraphQLTypes["PageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["PageLocaleWithoutLinkCreateInput"] | undefined
};
	["PageLocaleWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	root?: GraphQLTypes["PageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["PageLocaleCreateLocaleEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["PageLocaleCreateSeoEntityRelationInput"] | undefined,
	content?: GraphQLTypes["PageLocaleCreateContentEntityRelationInput"] | undefined,
	cover?: GraphQLTypes["PageLocaleCreateCoverEntityRelationInput"] | undefined,
	theme?: GraphQLTypes["PageTheme"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PageLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["PageUniqueWhere"] | undefined,
	create?: GraphQLTypes["PageWithoutLocalesCreateInput"] | undefined
};
	["PageWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PageLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutPagesCreateInput"] | undefined
};
	["LocaleWithoutPagesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	businessCategories?: Array<GraphQLTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleCreateMenusEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleCreateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateProductIngredientCategoriesEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductIngredientCategoryLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductIngredientCategoryLocaleWithoutLocaleCreateInput"] | undefined,
	alias?: string | undefined
};
	["ProductIngredientCategoryLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	root?: GraphQLTypes["ProductIngredientCategoryLocaleCreateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientCategoryLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductIngredientCategoryUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductIngredientCategoryWithoutLocalesCreateInput"] | undefined
};
	["ProductIngredientCategoryWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	internalName?: string | undefined,
	internalNote?: string | undefined,
	ingredients?: Array<GraphQLTypes["ProductIngredientCategoryCreateIngredientsEntityRelationInput"]> | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientCategoryCreateIngredientsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductIngredientUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductIngredientWithoutCategoriesCreateInput"] | undefined,
	alias?: string | undefined
};
	["ProductIngredientWithoutCategoriesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	internalNote?: string | undefined,
	locales?: Array<GraphQLTypes["ProductIngredientCreateLocalesEntityRelationInput"]> | undefined,
	internalName?: string | undefined,
	allergens?: Array<GraphQLTypes["ProductIngredientCreateAllergensEntityRelationInput"]> | undefined,
	needsPrepping?: boolean | undefined,
	allowCustomerRating?: boolean | undefined,
	customerRatings?: Array<GraphQLTypes["ProductIngredientCreateCustomerRatingsEntityRelationInput"]> | undefined,
	preferredQuantityUnit?: GraphQLTypes["ProductIngredientCreatePreferredQuantityUnitEntityRelationInput"] | undefined,
	freshingContainer?: GraphQLTypes["ProductIngredientCreateFreshingContainerEntityRelationInput"] | undefined,
	image?: GraphQLTypes["ProductIngredientCreateImageEntityRelationInput"] | undefined,
	suppliers?: GraphQLTypes["ProductIngredientCreateSuppliersEntityRelationInput"] | undefined,
	incrementQuantityNumber?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientCreateCustomerRatingsEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerIngredientRatingUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerIngredientRatingWithoutIngredientCreateInput"] | undefined,
	alias?: string | undefined
};
	["CustomerIngredientRatingWithoutIngredientCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	customer?: GraphQLTypes["CustomerIngredientRatingCreateCustomerEntityRelationInput"] | undefined,
	rating?: GraphQLTypes["CustomerIngredientRatingCreateRatingEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerIngredientRatingCreateCustomerEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerWithoutIngredientRatingsCreateInput"] | undefined
};
	["CustomerWithoutIngredientRatingsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	addresses?: Array<GraphQLTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerCreateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerCreateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerCreatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerCreateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	business?: GraphQLTypes["CustomerCreateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerCreateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerCreateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerCreateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerCreateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerCreateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreateBusinessEntityRelationInput"]: {
		connect?: GraphQLTypes["BusinessCustomerUniqueWhere"] | undefined,
	create?: GraphQLTypes["BusinessCustomerWithoutCustomerCreateInput"] | undefined
};
	["BusinessCustomerWithoutCustomerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	owners?: Array<GraphQLTypes["BusinessCustomerCreateOwnersEntityRelationInput"]> | undefined,
	members?: Array<GraphQLTypes["BusinessCustomerCreateMembersEntityRelationInput"]> | undefined,
	category?: GraphQLTypes["BusinessCustomerCreateCategoryEntityRelationInput"] | undefined,
	accountManager?: GraphQLTypes["BusinessCustomerCreateAccountManagerEntityRelationInput"] | undefined,
	logo?: GraphQLTypes["BusinessCustomerCreateLogoEntityRelationInput"] | undefined,
	note?: string | undefined,
	businessServiceEvents?: Array<GraphQLTypes["BusinessCustomerCreateBusinessServiceEventsEntityRelationInput"]> | undefined,
	doubleshotCoffeeEquipment?: GraphQLTypes["BusinessCustomerCreateDoubleshotCoffeeEquipmentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessCustomerCreateOwnersEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerWithoutOwnerOfBusinessesCreateInput"] | undefined,
	alias?: string | undefined
};
	["CustomerWithoutOwnerOfBusinessesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	addresses?: Array<GraphQLTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerCreateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerCreateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerCreatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerCreateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerCreateBusinessEntityRelationInput"] | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerCreateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerCreateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerCreateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerCreateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerCreateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreateMemberOfBusinessesEntityRelationInput"]: {
		connect?: GraphQLTypes["BusinessCustomerUniqueWhere"] | undefined,
	create?: GraphQLTypes["BusinessCustomerWithoutMembersCreateInput"] | undefined,
	alias?: string | undefined
};
	["BusinessCustomerWithoutMembersCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	customer?: GraphQLTypes["BusinessCustomerCreateCustomerEntityRelationInput"] | undefined,
	owners?: Array<GraphQLTypes["BusinessCustomerCreateOwnersEntityRelationInput"]> | undefined,
	category?: GraphQLTypes["BusinessCustomerCreateCategoryEntityRelationInput"] | undefined,
	accountManager?: GraphQLTypes["BusinessCustomerCreateAccountManagerEntityRelationInput"] | undefined,
	logo?: GraphQLTypes["BusinessCustomerCreateLogoEntityRelationInput"] | undefined,
	note?: string | undefined,
	businessServiceEvents?: Array<GraphQLTypes["BusinessCustomerCreateBusinessServiceEventsEntityRelationInput"]> | undefined,
	doubleshotCoffeeEquipment?: GraphQLTypes["BusinessCustomerCreateDoubleshotCoffeeEquipmentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessCustomerCreateCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["BusinessCategoryUniqueWhere"] | undefined,
	create?: GraphQLTypes["BusinessCategoryWithoutBusinessCustomersCreateInput"] | undefined
};
	["BusinessCategoryWithoutBusinessCustomersCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	visibleToNewCustomers?: boolean | undefined,
	locales?: Array<GraphQLTypes["BusinessCategoryCreateLocalesEntityRelationInput"]> | undefined,
	internalName?: string | undefined,
	recurrences?: Array<GraphQLTypes["BusinessCategoryCreateRecurrencesEntityRelationInput"]> | undefined,
	specificProducts?: GraphQLTypes["BusinessCategoryCreateSpecificProductsEntityRelationInput"] | undefined,
	seasonalProductCategories?: GraphQLTypes["BusinessCategoryCreateSeasonalProductCategoriesEntityRelationInput"] | undefined,
	specificProductsProductCategories?: GraphQLTypes["BusinessCategoryCreateSpecificProductsProductCategoriesEntityRelationInput"] | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessCategoryCreateRecurrencesEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderRecurrenceUniqueWhere"] | undefined,
	create?: GraphQLTypes["OrderRecurrenceWithoutBusinessCategoryCreateInput"] | undefined,
	alias?: string | undefined
};
	["OrderRecurrenceWithoutBusinessCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	internalName?: string | undefined,
	locales?: Array<GraphQLTypes["OrderRecurrenceCreateLocalesEntityRelationInput"]> | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderRecurrenceCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderRecurrenceLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["OrderRecurrenceLocaleWithoutRootCreateInput"] | undefined,
	alias?: string | undefined
};
	["OrderRecurrenceLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	locale?: GraphQLTypes["OrderRecurrenceLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderRecurrenceLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutOrderRecurrencesCreateInput"] | undefined
};
	["LocaleWithoutOrderRecurrencesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	businessCategories?: Array<GraphQLTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleCreateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleCreateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateAllergensEntityRelationInput"]: {
		connect?: GraphQLTypes["AllergenLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["AllergenLocaleWithoutLocaleCreateInput"] | undefined,
	alias?: string | undefined
};
	["AllergenLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	root?: GraphQLTypes["AllergenLocaleCreateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["AllergenLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["AllergenUniqueWhere"] | undefined,
	create?: GraphQLTypes["AllergenWithoutLocalesCreateInput"] | undefined
};
	["AllergenWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	internalName?: string | undefined,
	ingredients?: Array<GraphQLTypes["AllergenCreateIngredientsEntityRelationInput"]> | undefined,
	code?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["AllergenCreateIngredientsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductIngredientUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductIngredientWithoutAllergensCreateInput"] | undefined,
	alias?: string | undefined
};
	["ProductIngredientWithoutAllergensCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	internalNote?: string | undefined,
	locales?: Array<GraphQLTypes["ProductIngredientCreateLocalesEntityRelationInput"]> | undefined,
	internalName?: string | undefined,
	categories?: Array<GraphQLTypes["ProductIngredientCreateCategoriesEntityRelationInput"]> | undefined,
	needsPrepping?: boolean | undefined,
	allowCustomerRating?: boolean | undefined,
	customerRatings?: Array<GraphQLTypes["ProductIngredientCreateCustomerRatingsEntityRelationInput"]> | undefined,
	preferredQuantityUnit?: GraphQLTypes["ProductIngredientCreatePreferredQuantityUnitEntityRelationInput"] | undefined,
	freshingContainer?: GraphQLTypes["ProductIngredientCreateFreshingContainerEntityRelationInput"] | undefined,
	image?: GraphQLTypes["ProductIngredientCreateImageEntityRelationInput"] | undefined,
	suppliers?: GraphQLTypes["ProductIngredientCreateSuppliersEntityRelationInput"] | undefined,
	incrementQuantityNumber?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientCreatePreferredQuantityUnitEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductIngredientItemQuantityUnitUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductIngredientItemQuantityUnitCreateInput"] | undefined
};
	["ProductIngredientItemQuantityUnitUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined
};
	["ProductIngredientItemQuantityUnitCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientCreateFreshingContainerEntityRelationInput"]: {
		connect?: GraphQLTypes["FreshingContainerUniqueWhere"] | undefined,
	create?: GraphQLTypes["FreshingContainerCreateInput"] | undefined
};
	["FreshingContainerUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["FreshingContainerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	volumeMl?: number | undefined,
	workspace?: GraphQLTypes["FreshingContainerCreateWorkspaceEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FreshingContainerCreateWorkspaceEntityRelationInput"]: {
		connect?: GraphQLTypes["WorkspaceUniqueWhere"] | undefined,
	create?: GraphQLTypes["WorkspaceWithoutFreshingContainersCreateInput"] | undefined
};
	["WorkspaceUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	freshingContainers?: GraphQLTypes["FreshingContainerUniqueWhere"] | undefined,
	openingHours?: GraphQLTypes["WeekHoursUniqueWhere"] | undefined,
	workingHours?: GraphQLTypes["WeekHoursUniqueWhere"] | undefined,
	creditsProduct?: GraphQLTypes["VirtualProductUniqueWhere"] | undefined,
	discountVatRate?: GraphQLTypes["VatRateUniqueWhere"] | undefined
};
	["WeekHoursUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["WorkspaceWithoutFreshingContainersCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	orderDeadlineTime?: string | undefined,
	ordersLoadingDurationHours?: number | undefined,
	freshingContainerVolumeMl?: number | undefined,
	freshingPrepareOrderByOffsetMinutes?: number | undefined,
	checkoutUrlTemplate?: string | undefined,
	orderUrlTemplate?: string | undefined,
	paymentUrlTemplate?: string | undefined,
	customerProfileUrlTemplate?: string | undefined,
	userProfileUrlTemplate?: string | undefined,
	messengerUrl?: string | undefined,
	messengerIosUrl?: string | undefined,
	messengerAndroidUrl?: string | undefined,
	openingHours?: GraphQLTypes["WorkspaceCreateOpeningHoursEntityRelationInput"] | undefined,
	workingHours?: GraphQLTypes["WorkspaceCreateWorkingHoursEntityRelationInput"] | undefined,
	defaultFreshingContainer?: GraphQLTypes["WorkspaceCreateDefaultFreshingContainerEntityRelationInput"] | undefined,
	creditsProduct?: GraphQLTypes["WorkspaceCreateCreditsProductEntityRelationInput"] | undefined,
	discountVatRate?: GraphQLTypes["WorkspaceCreateDiscountVatRateEntityRelationInput"] | undefined,
	name?: string | undefined,
	businessAddress?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["WorkspaceCreateOpeningHoursEntityRelationInput"]: {
		connect?: GraphQLTypes["WeekHoursUniqueWhere"] | undefined,
	create?: GraphQLTypes["WeekHoursCreateInput"] | undefined
};
	["WeekHoursCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	mon?: string | undefined,
	tue?: string | undefined,
	wed?: string | undefined,
	thu?: string | undefined,
	fri?: string | undefined,
	sat?: string | undefined,
	sun?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["WorkspaceCreateWorkingHoursEntityRelationInput"]: {
		connect?: GraphQLTypes["WeekHoursUniqueWhere"] | undefined,
	create?: GraphQLTypes["WeekHoursCreateInput"] | undefined
};
	["WorkspaceCreateDefaultFreshingContainerEntityRelationInput"]: {
		connect?: GraphQLTypes["FreshingContainerUniqueWhere"] | undefined,
	create?: GraphQLTypes["FreshingContainerCreateInput"] | undefined
};
	["WorkspaceCreateCreditsProductEntityRelationInput"]: {
		connect?: GraphQLTypes["VirtualProductUniqueWhere"] | undefined,
	create?: GraphQLTypes["VirtualProductCreateInput"] | undefined
};
	["VirtualProductCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["VirtualProductType"] | undefined,
	product?: GraphQLTypes["VirtualProductCreateProductEntityRelationInput"] | undefined,
	voucherCreditCents?: number | undefined,
	physicalRepresentation?: GraphQLTypes["VirtualProductPhysicalRepresentationType"] | undefined,
	recipientEmail?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["VirtualProductCreateProductEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductWithoutVirtualProductCreateInput"] | undefined
};
	["ProductWithoutVirtualProductCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	priceCents?: number | undefined,
	notDiscountable?: boolean | undefined,
	packing?: GraphQLTypes["ProductCreatePackingEntityRelationInput"] | undefined,
	recipe?: GraphQLTypes["ProductCreateRecipeEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["ProductCreateTagsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["ProductCreateCategoriesEntityRelationInput"]> | undefined,
	vatRate?: GraphQLTypes["ProductCreateVatRateEntityRelationInput"] | undefined,
	stocks?: Array<GraphQLTypes["ProductCreateStocksEntityRelationInput"]> | undefined,
	groupPrices?: Array<GraphQLTypes["ProductCreateGroupPricesEntityRelationInput"]> | undefined,
	image?: GraphQLTypes["ProductCreateImageEntityRelationInput"] | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	cartItems?: Array<GraphQLTypes["ProductCreateCartItemsEntityRelationInput"]> | undefined,
	availability?: GraphQLTypes["ProductAvailability"] | undefined,
	order?: number | undefined,
	manager?: GraphQLTypes["ProductCreateManagerEntityRelationInput"] | undefined,
	orderItems?: Array<GraphQLTypes["ProductCreateOrderItemsEntityRelationInput"]> | undefined,
	maximumQuantityPerOrder?: number | undefined,
	inheritedCategories?: Array<GraphQLTypes["ProductCreateInheritedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["ProductCreateDeliveryZonesEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["ProductCreateLocalesEntityRelationInput"]> | undefined,
	archivedAt?: GraphQLTypes["DateTime"] | undefined,
	customerPrices?: Array<GraphQLTypes["ProductCreateCustomerPricesEntityRelationInput"]> | undefined,
	meta?: GraphQLTypes["ProductCreateMetaEntityRelationInput"] | undefined,
	page?: GraphQLTypes["ProductCreatePageEntityRelationInput"] | undefined,
	salesDays?: Array<GraphQLTypes["ProductCreateSalesDaysEntityRelationInput"]> | undefined,
	salesWeeks?: Array<GraphQLTypes["ProductCreateSalesWeeksEntityRelationInput"]> | undefined,
	salesMonths?: Array<GraphQLTypes["ProductCreateSalesMonthsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["ProductCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	hasSubscription?: boolean | undefined,
	pointOfSaleTileColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCreateManagerEntityRelationInput"]: {
		connect?: GraphQLTypes["StocksManagerUniqueWhere"] | undefined,
	create?: GraphQLTypes["StocksManagerWithoutManagedProductsCreateInput"] | undefined
};
	["StocksManagerWithoutManagedProductsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	staff?: GraphQLTypes["StocksManagerCreateStaffEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StocksManagerCreateStaffEntityRelationInput"]: {
		connect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	create?: GraphQLTypes["StaffWithoutStocksManagerCreateInput"] | undefined
};
	["StaffWithoutStocksManagerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	bartender?: GraphQLTypes["StaffCreateBartenderEntityRelationInput"] | undefined,
	courier?: GraphQLTypes["StaffCreateCourierEntityRelationInput"] | undefined,
	cleaner?: GraphQLTypes["StaffCreateCleanerEntityRelationInput"] | undefined,
	shiftsManager?: GraphQLTypes["StaffCreateShiftsManagerEntityRelationInput"] | undefined,
	businessToBusinessManager?: GraphQLTypes["StaffCreateBusinessToBusinessManagerEntityRelationInput"] | undefined,
	user?: GraphQLTypes["StaffCreateUserEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["StaffCreateShiftsProfileEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["StaffCreatePhotoEntityRelationInput"] | undefined,
	courierManager?: GraphQLTypes["StaffCreateCourierManagerEntityRelationInput"] | undefined,
	picker?: GraphQLTypes["StaffCreatePickerEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	remunerationProfile?: GraphQLTypes["StaffCreateRemunerationProfileEntityRelationInput"] | undefined,
	cashier?: GraphQLTypes["StaffCreateCashierEntityRelationInput"] | undefined,
	venues?: Array<GraphQLTypes["StaffCreateVenuesEntityRelationInput"]> | undefined,
	internalBuyer?: GraphQLTypes["StaffCreateInternalBuyerEntityRelationInput"] | undefined,
	salesManager?: GraphQLTypes["StaffCreateSalesManagerEntityRelationInput"] | undefined,
	cashierManager?: GraphQLTypes["StaffCreateCashierManagerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StaffCreateBartenderEntityRelationInput"]: {
		connect?: GraphQLTypes["BartenderUniqueWhere"] | undefined,
	create?: GraphQLTypes["BartenderWithoutStaffCreateInput"] | undefined
};
	["BartenderWithoutStaffCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StaffCreateCourierEntityRelationInput"]: {
		connect?: GraphQLTypes["CourierUniqueWhere"] | undefined,
	create?: GraphQLTypes["CourierWithoutStaffCreateInput"] | undefined
};
	["CourierWithoutStaffCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	routes?: Array<GraphQLTypes["CourierCreateRoutesEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	deliveryMethods?: Array<GraphQLTypes["CourierCreateDeliveryMethodsEntityRelationInput"]> | undefined,
	showInPicker?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["CourierCreateRoutesEntityRelationInput"]: {
		connect?: GraphQLTypes["DeliveryRouteUniqueWhere"] | undefined,
	create?: GraphQLTypes["DeliveryRouteWithoutCourierCreateInput"] | undefined,
	alias?: string | undefined
};
	["DeliveryRouteWithoutCourierCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	waypoints?: Array<GraphQLTypes["DeliveryRouteCreateWaypointsEntityRelationInput"]> | undefined,
	dispatchAt?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryRouteCreateWaypointsEntityRelationInput"]: {
		connect?: GraphQLTypes["DeliveryWaypointUniqueWhere"] | undefined,
	create?: GraphQLTypes["DeliveryWaypointWithoutRouteCreateInput"] | undefined,
	alias?: string | undefined
};
	["DeliveryWaypointWithoutRouteCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	estimatedArrival?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	sortingOrder?: number | undefined,
	delivery?: GraphQLTypes["DeliveryWaypointCreateDeliveryEntityRelationInput"] | undefined,
	estimatedDistance?: number | undefined,
	estimatedDuration?: number | undefined,
	originDeparture?: GraphQLTypes["DateTime"] | undefined,
	originAddress?: string | undefined,
	transitMode?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryWaypointCreateDeliveryEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderDeliveryUniqueWhere"] | undefined,
	create?: GraphQLTypes["OrderDeliveryWithoutDeliveryWaypointCreateInput"] | undefined
};
	["OrderDeliveryWithoutDeliveryWaypointCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	priceCents?: number | undefined,
	deliveredAt?: GraphQLTypes["DateTime"] | undefined,
	method?: GraphQLTypes["OrderDeliveryCreateMethodEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["OrderDeliveryCreateVatRateEntityRelationInput"] | undefined,
	order?: GraphQLTypes["OrderDeliveryCreateOrderEntityRelationInput"] | undefined,
	expectedAt?: GraphQLTypes["DateTime"] | undefined,
	state?: GraphQLTypes["OrderDeliveryState"] | undefined,
	loadingDurationHours?: number | undefined,
	dispatchAt?: GraphQLTypes["DateTime"] | undefined,
	duration?: string | undefined,
	window?: string | undefined,
	expectedEndAt?: GraphQLTypes["DateTime"] | undefined,
	processingAt?: GraphQLTypes["DateTime"] | undefined,
	deliveringAt?: GraphQLTypes["DateTime"] | undefined,
	failedAt?: GraphQLTypes["DateTime"] | undefined,
	internalNote?: string | undefined,
	events?: Array<GraphQLTypes["OrderDeliveryCreateEventsEntityRelationInput"]> | undefined,
	prepareAt?: GraphQLTypes["DateTime"] | undefined,
	liftagoRide?: GraphQLTypes["OrderDeliveryCreateLiftagoRideEntityRelationInput"] | undefined,
	pickedAt?: GraphQLTypes["DateTime"] | undefined,
	address?: GraphQLTypes["OrderDeliveryCreateAddressEntityRelationInput"] | undefined,
	trackingCode?: string | undefined,
	woltDriveDelivery?: GraphQLTypes["OrderDeliveryCreateWoltDriveDeliveryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderDeliveryCreateMethodEntityRelationInput"]: {
		connect?: GraphQLTypes["DeliveryMethodUniqueWhere"] | undefined,
	create?: GraphQLTypes["DeliveryMethodCreateInput"] | undefined
};
	["DeliveryMethodCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	enabled?: boolean | undefined,
	paymentMethods?: Array<GraphQLTypes["DeliveryMethodCreatePaymentMethodsEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	requireDeliveryAddress?: boolean | undefined,
	suitableForDeliveryZones?: Array<GraphQLTypes["DeliveryMethodCreateSuitableForDeliveryZonesEntityRelationInput"]> | undefined,
	channels?: Array<GraphQLTypes["DeliveryMethodCreateChannelsEntityRelationInput"]> | undefined,
	courierHandlers?: Array<GraphQLTypes["DeliveryMethodCreateCourierHandlersEntityRelationInput"]> | undefined,
	enableDeliveryTracking?: boolean | undefined,
	locales?: Array<GraphQLTypes["DeliveryMethodCreateLocalesEntityRelationInput"]> | undefined,
	timelinePreset?: GraphQLTypes["DeliveryMethodCreateTimelinePresetEntityRelationInput"] | undefined,
	woltDriveVenueId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryMethodCreateCourierHandlersEntityRelationInput"]: {
		connect?: GraphQLTypes["CourierUniqueWhere"] | undefined,
	create?: GraphQLTypes["CourierWithoutDeliveryMethodsCreateInput"] | undefined,
	alias?: string | undefined
};
	["CourierWithoutDeliveryMethodsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	staff?: GraphQLTypes["CourierCreateStaffEntityRelationInput"] | undefined,
	routes?: Array<GraphQLTypes["CourierCreateRoutesEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	showInPicker?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["CourierCreateStaffEntityRelationInput"]: {
		connect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	create?: GraphQLTypes["StaffWithoutCourierCreateInput"] | undefined
};
	["StaffWithoutCourierCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	bartender?: GraphQLTypes["StaffCreateBartenderEntityRelationInput"] | undefined,
	cleaner?: GraphQLTypes["StaffCreateCleanerEntityRelationInput"] | undefined,
	shiftsManager?: GraphQLTypes["StaffCreateShiftsManagerEntityRelationInput"] | undefined,
	businessToBusinessManager?: GraphQLTypes["StaffCreateBusinessToBusinessManagerEntityRelationInput"] | undefined,
	user?: GraphQLTypes["StaffCreateUserEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["StaffCreateShiftsProfileEntityRelationInput"] | undefined,
	stocksManager?: GraphQLTypes["StaffCreateStocksManagerEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["StaffCreatePhotoEntityRelationInput"] | undefined,
	courierManager?: GraphQLTypes["StaffCreateCourierManagerEntityRelationInput"] | undefined,
	picker?: GraphQLTypes["StaffCreatePickerEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	remunerationProfile?: GraphQLTypes["StaffCreateRemunerationProfileEntityRelationInput"] | undefined,
	cashier?: GraphQLTypes["StaffCreateCashierEntityRelationInput"] | undefined,
	venues?: Array<GraphQLTypes["StaffCreateVenuesEntityRelationInput"]> | undefined,
	internalBuyer?: GraphQLTypes["StaffCreateInternalBuyerEntityRelationInput"] | undefined,
	salesManager?: GraphQLTypes["StaffCreateSalesManagerEntityRelationInput"] | undefined,
	cashierManager?: GraphQLTypes["StaffCreateCashierManagerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StaffCreateCleanerEntityRelationInput"]: {
		connect?: GraphQLTypes["CleanerUniqueWhere"] | undefined,
	create?: GraphQLTypes["CleanerWithoutStaffCreateInput"] | undefined
};
	["CleanerWithoutStaffCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	canReachTopShelf?: boolean | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StaffCreateShiftsManagerEntityRelationInput"]: {
		connect?: GraphQLTypes["ShiftsManagerUniqueWhere"] | undefined,
	create?: GraphQLTypes["ShiftsManagerWithoutStaffCreateInput"] | undefined
};
	["ShiftsManagerWithoutStaffCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	managedRoles?: Array<GraphQLTypes["ShiftsManagerCreateManagedRolesEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ShiftsManagerCreateManagedRolesEntityRelationInput"]: {
		connect?: GraphQLTypes["TimetableEmployeeRoleUniqueWhere"] | undefined,
	create?: GraphQLTypes["TimetableEmployeeRoleWithoutShiftsManagersCreateInput"] | undefined,
	alias?: string | undefined
};
	["TimetableEmployeeRoleWithoutShiftsManagersCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	shiftGroups?: Array<GraphQLTypes["TimetableEmployeeRoleCreateShiftGroupsEntityRelationInput"]> | undefined,
	shiftsProfiles?: Array<GraphQLTypes["TimetableEmployeeRoleCreateShiftsProfilesEntityRelationInput"]> | undefined,
	name?: string | undefined,
	timetableTemplates?: Array<GraphQLTypes["TimetableEmployeeRoleCreateTimetableTemplatesEntityRelationInput"]> | undefined,
	color?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableEmployeeRoleCreateShiftGroupsEntityRelationInput"]: {
		connect?: GraphQLTypes["TimetableShiftGroupUniqueWhere"] | undefined,
	create?: GraphQLTypes["TimetableShiftGroupWithoutTypeCreateInput"] | undefined,
	alias?: string | undefined
};
	["TimetableShiftGroupWithoutTypeCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	shifts?: Array<GraphQLTypes["TimetableShiftGroupCreateShiftsEntityRelationInput"]> | undefined,
	day?: GraphQLTypes["TimetableShiftGroupCreateDayEntityRelationInput"] | undefined,
	position?: GraphQLTypes["TimetableShiftGroupCreatePositionEntityRelationInput"] | undefined,
	queue?: GraphQLTypes["TimetableShiftGroupCreateQueueEntityRelationInput"] | undefined,
	generatedByTemplate?: GraphQLTypes["TimetableShiftGroupCreateGeneratedByTemplateEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableShiftGroupCreateShiftsEntityRelationInput"]: {
		connect?: GraphQLTypes["TimetableShiftUniqueWhere"] | undefined,
	create?: GraphQLTypes["TimetableShiftWithoutGroupCreateInput"] | undefined,
	alias?: string | undefined
};
	["TimetableShiftWithoutGroupCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locked?: boolean | undefined,
	order?: number | undefined,
	assigned?: GraphQLTypes["Date"] | undefined,
	shiftsProfile?: GraphQLTypes["TimetableShiftCreateShiftsProfileEntityRelationInput"] | undefined,
	queueItem?: GraphQLTypes["TimetableShiftCreateQueueItemEntityRelationInput"] | undefined,
	swapInfo?: GraphQLTypes["TimetableShiftCreateSwapInfoEntityRelationInput"] | undefined,
	isOvertime?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableShiftCreateShiftsProfileEntityRelationInput"]: {
		connect?: GraphQLTypes["ShiftsProfileUniqueWhere"] | undefined,
	create?: GraphQLTypes["ShiftsProfileWithoutShiftsCreateInput"] | undefined
};
	["ShiftsProfileWithoutShiftsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	queueItems?: Array<GraphQLTypes["ShiftsProfileCreateQueueItemsEntityRelationInput"]> | undefined,
	staff?: GraphQLTypes["ShiftsProfileCreateStaffEntityRelationInput"] | undefined,
	roles?: Array<GraphQLTypes["ShiftsProfileCreateRolesEntityRelationInput"]> | undefined,
	allowSelfUnassigning?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ShiftsProfileCreateQueueItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["EmployeeQueueItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["EmployeeQueueItemWithoutShiftsProfileCreateInput"] | undefined,
	alias?: string | undefined
};
	["EmployeeQueueItemWithoutShiftsProfileCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	start?: string | undefined,
	end?: string | undefined,
	queue?: GraphQLTypes["EmployeeQueueItemCreateQueueEntityRelationInput"] | undefined,
	shift?: GraphQLTypes["EmployeeQueueItemCreateShiftEntityRelationInput"] | undefined,
	unassignInfo?: GraphQLTypes["EmployeeQueueItemCreateUnassignInfoEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["EmployeeQueueItemCreateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["EmployeeQueueItemCreateQueueEntityRelationInput"]: {
		connect?: GraphQLTypes["EmployeeQueueUniqueWhere"] | undefined,
	create?: GraphQLTypes["EmployeeQueueWithoutItemsCreateInput"] | undefined
};
	["EmployeeQueueWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	shiftGroup?: GraphQLTypes["EmployeeQueueCreateShiftGroupEntityRelationInput"] | undefined,
	contemberBugFix?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["EmployeeQueueCreateShiftGroupEntityRelationInput"]: {
		connect?: GraphQLTypes["TimetableShiftGroupUniqueWhere"] | undefined,
	create?: GraphQLTypes["TimetableShiftGroupWithoutQueueCreateInput"] | undefined
};
	["TimetableShiftGroupWithoutQueueCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	shifts?: Array<GraphQLTypes["TimetableShiftGroupCreateShiftsEntityRelationInput"]> | undefined,
	day?: GraphQLTypes["TimetableShiftGroupCreateDayEntityRelationInput"] | undefined,
	type?: GraphQLTypes["TimetableShiftGroupCreateTypeEntityRelationInput"] | undefined,
	position?: GraphQLTypes["TimetableShiftGroupCreatePositionEntityRelationInput"] | undefined,
	generatedByTemplate?: GraphQLTypes["TimetableShiftGroupCreateGeneratedByTemplateEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableShiftGroupCreateDayEntityRelationInput"]: {
		connect?: GraphQLTypes["TimetableDayUniqueWhere"] | undefined,
	create?: GraphQLTypes["TimetableDayWithoutShiftGroupsCreateInput"] | undefined
};
	["TimetableDayWithoutShiftGroupsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	date?: GraphQLTypes["Date"] | undefined,
	type?: GraphQLTypes["TimetableDayType"] | undefined,
	tipsCents?: number | undefined,
	notes?: Array<GraphQLTypes["TimetableDayCreateNotesEntityRelationInput"]> | undefined,
	venue?: GraphQLTypes["TimetableDayCreateVenueEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["TimetableDayCreateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableDayCreateNotesEntityRelationInput"]: {
		connect?: GraphQLTypes["TimetableDayNoteUniqueWhere"] | undefined,
	create?: GraphQLTypes["TimetableDayNoteWithoutDayCreateInput"] | undefined,
	alias?: string | undefined
};
	["TimetableDayNoteWithoutDayCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	note?: string | undefined,
	role?: GraphQLTypes["TimetableDayNoteCreateRoleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableDayNoteCreateRoleEntityRelationInput"]: {
		connect?: GraphQLTypes["TimetableEmployeeRoleUniqueWhere"] | undefined,
	create?: GraphQLTypes["TimetableEmployeeRoleCreateInput"] | undefined
};
	["TimetableEmployeeRoleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	shiftGroups?: Array<GraphQLTypes["TimetableEmployeeRoleCreateShiftGroupsEntityRelationInput"]> | undefined,
	shiftsProfiles?: Array<GraphQLTypes["TimetableEmployeeRoleCreateShiftsProfilesEntityRelationInput"]> | undefined,
	shiftsManagers?: Array<GraphQLTypes["TimetableEmployeeRoleCreateShiftsManagersEntityRelationInput"]> | undefined,
	name?: string | undefined,
	timetableTemplates?: Array<GraphQLTypes["TimetableEmployeeRoleCreateTimetableTemplatesEntityRelationInput"]> | undefined,
	color?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableEmployeeRoleCreateShiftsProfilesEntityRelationInput"]: {
		connect?: GraphQLTypes["ShiftsProfileUniqueWhere"] | undefined,
	create?: GraphQLTypes["ShiftsProfileWithoutRolesCreateInput"] | undefined,
	alias?: string | undefined
};
	["ShiftsProfileWithoutRolesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	queueItems?: Array<GraphQLTypes["ShiftsProfileCreateQueueItemsEntityRelationInput"]> | undefined,
	staff?: GraphQLTypes["ShiftsProfileCreateStaffEntityRelationInput"] | undefined,
	shifts?: Array<GraphQLTypes["ShiftsProfileCreateShiftsEntityRelationInput"]> | undefined,
	allowSelfUnassigning?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ShiftsProfileCreateStaffEntityRelationInput"]: {
		connect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	create?: GraphQLTypes["StaffWithoutShiftsProfileCreateInput"] | undefined
};
	["StaffWithoutShiftsProfileCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	bartender?: GraphQLTypes["StaffCreateBartenderEntityRelationInput"] | undefined,
	courier?: GraphQLTypes["StaffCreateCourierEntityRelationInput"] | undefined,
	cleaner?: GraphQLTypes["StaffCreateCleanerEntityRelationInput"] | undefined,
	shiftsManager?: GraphQLTypes["StaffCreateShiftsManagerEntityRelationInput"] | undefined,
	businessToBusinessManager?: GraphQLTypes["StaffCreateBusinessToBusinessManagerEntityRelationInput"] | undefined,
	user?: GraphQLTypes["StaffCreateUserEntityRelationInput"] | undefined,
	stocksManager?: GraphQLTypes["StaffCreateStocksManagerEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["StaffCreatePhotoEntityRelationInput"] | undefined,
	courierManager?: GraphQLTypes["StaffCreateCourierManagerEntityRelationInput"] | undefined,
	picker?: GraphQLTypes["StaffCreatePickerEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	remunerationProfile?: GraphQLTypes["StaffCreateRemunerationProfileEntityRelationInput"] | undefined,
	cashier?: GraphQLTypes["StaffCreateCashierEntityRelationInput"] | undefined,
	venues?: Array<GraphQLTypes["StaffCreateVenuesEntityRelationInput"]> | undefined,
	internalBuyer?: GraphQLTypes["StaffCreateInternalBuyerEntityRelationInput"] | undefined,
	salesManager?: GraphQLTypes["StaffCreateSalesManagerEntityRelationInput"] | undefined,
	cashierManager?: GraphQLTypes["StaffCreateCashierManagerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StaffCreateBusinessToBusinessManagerEntityRelationInput"]: {
		connect?: GraphQLTypes["BusinessToBusinessManagerUniqueWhere"] | undefined,
	create?: GraphQLTypes["BusinessToBusinessManagerWithoutStaffCreateInput"] | undefined
};
	["BusinessToBusinessManagerWithoutStaffCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	managedBusinesses?: Array<GraphQLTypes["BusinessToBusinessManagerCreateManagedBusinessesEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessToBusinessManagerCreateManagedBusinessesEntityRelationInput"]: {
		connect?: GraphQLTypes["BusinessCustomerUniqueWhere"] | undefined,
	create?: GraphQLTypes["BusinessCustomerWithoutAccountManagerCreateInput"] | undefined,
	alias?: string | undefined
};
	["BusinessCustomerWithoutAccountManagerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	customer?: GraphQLTypes["BusinessCustomerCreateCustomerEntityRelationInput"] | undefined,
	owners?: Array<GraphQLTypes["BusinessCustomerCreateOwnersEntityRelationInput"]> | undefined,
	members?: Array<GraphQLTypes["BusinessCustomerCreateMembersEntityRelationInput"]> | undefined,
	category?: GraphQLTypes["BusinessCustomerCreateCategoryEntityRelationInput"] | undefined,
	logo?: GraphQLTypes["BusinessCustomerCreateLogoEntityRelationInput"] | undefined,
	note?: string | undefined,
	businessServiceEvents?: Array<GraphQLTypes["BusinessCustomerCreateBusinessServiceEventsEntityRelationInput"]> | undefined,
	doubleshotCoffeeEquipment?: GraphQLTypes["BusinessCustomerCreateDoubleshotCoffeeEquipmentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessCustomerCreateMembersEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerWithoutMemberOfBusinessesCreateInput"] | undefined,
	alias?: string | undefined
};
	["CustomerWithoutMemberOfBusinessesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	addresses?: Array<GraphQLTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerCreateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerCreateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerCreatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerCreateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerCreateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerCreateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerCreateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerCreateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerCreateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerCreateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreateOwnerOfBusinessesEntityRelationInput"]: {
		connect?: GraphQLTypes["BusinessCustomerUniqueWhere"] | undefined,
	create?: GraphQLTypes["BusinessCustomerWithoutOwnersCreateInput"] | undefined,
	alias?: string | undefined
};
	["BusinessCustomerWithoutOwnersCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	customer?: GraphQLTypes["BusinessCustomerCreateCustomerEntityRelationInput"] | undefined,
	members?: Array<GraphQLTypes["BusinessCustomerCreateMembersEntityRelationInput"]> | undefined,
	category?: GraphQLTypes["BusinessCustomerCreateCategoryEntityRelationInput"] | undefined,
	accountManager?: GraphQLTypes["BusinessCustomerCreateAccountManagerEntityRelationInput"] | undefined,
	logo?: GraphQLTypes["BusinessCustomerCreateLogoEntityRelationInput"] | undefined,
	note?: string | undefined,
	businessServiceEvents?: Array<GraphQLTypes["BusinessCustomerCreateBusinessServiceEventsEntityRelationInput"]> | undefined,
	doubleshotCoffeeEquipment?: GraphQLTypes["BusinessCustomerCreateDoubleshotCoffeeEquipmentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessCustomerCreateAccountManagerEntityRelationInput"]: {
		connect?: GraphQLTypes["BusinessToBusinessManagerUniqueWhere"] | undefined,
	create?: GraphQLTypes["BusinessToBusinessManagerWithoutManagedBusinessesCreateInput"] | undefined
};
	["BusinessToBusinessManagerWithoutManagedBusinessesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	staff?: GraphQLTypes["BusinessToBusinessManagerCreateStaffEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessToBusinessManagerCreateStaffEntityRelationInput"]: {
		connect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	create?: GraphQLTypes["StaffWithoutBusinessToBusinessManagerCreateInput"] | undefined
};
	["StaffWithoutBusinessToBusinessManagerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	bartender?: GraphQLTypes["StaffCreateBartenderEntityRelationInput"] | undefined,
	courier?: GraphQLTypes["StaffCreateCourierEntityRelationInput"] | undefined,
	cleaner?: GraphQLTypes["StaffCreateCleanerEntityRelationInput"] | undefined,
	shiftsManager?: GraphQLTypes["StaffCreateShiftsManagerEntityRelationInput"] | undefined,
	user?: GraphQLTypes["StaffCreateUserEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["StaffCreateShiftsProfileEntityRelationInput"] | undefined,
	stocksManager?: GraphQLTypes["StaffCreateStocksManagerEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["StaffCreatePhotoEntityRelationInput"] | undefined,
	courierManager?: GraphQLTypes["StaffCreateCourierManagerEntityRelationInput"] | undefined,
	picker?: GraphQLTypes["StaffCreatePickerEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	remunerationProfile?: GraphQLTypes["StaffCreateRemunerationProfileEntityRelationInput"] | undefined,
	cashier?: GraphQLTypes["StaffCreateCashierEntityRelationInput"] | undefined,
	venues?: Array<GraphQLTypes["StaffCreateVenuesEntityRelationInput"]> | undefined,
	internalBuyer?: GraphQLTypes["StaffCreateInternalBuyerEntityRelationInput"] | undefined,
	salesManager?: GraphQLTypes["StaffCreateSalesManagerEntityRelationInput"] | undefined,
	cashierManager?: GraphQLTypes["StaffCreateCashierManagerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StaffCreateUserEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserWithoutStaffCreateInput"] | undefined
};
	["UserWithoutStaffCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	internalNote?: string | undefined,
	customer?: GraphQLTypes["UserCreateCustomerEntityRelationInput"] | undefined,
	tenantPersonId?: GraphQLTypes["UUID"] | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	devices?: Array<GraphQLTypes["UserCreateDevicesEntityRelationInput"]> | undefined,
	verifiedAt?: GraphQLTypes["DateTime"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	deletionRequestedAt?: GraphQLTypes["DateTime"] | undefined,
	deletionExpectedAt?: GraphQLTypes["DateTime"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	meta?: GraphQLTypes["UserCreateMetaEntityRelationInput"] | undefined,
	identificationAttempts?: Array<GraphQLTypes["UserCreateIdentificationAttemptsEntityRelationInput"]> | undefined,
	roles?: GraphQLTypes["UserCreateRolesEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserCreateCustomerEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerWithoutUserCreateInput"] | undefined
};
	["CustomerWithoutUserCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	addresses?: Array<GraphQLTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerCreateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerCreateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerCreatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerCreateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerCreateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerCreateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerCreateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerCreateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerCreateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreateCartsEntityRelationInput"]: {
		connect?: GraphQLTypes["CartUniqueWhere"] | undefined,
	create?: GraphQLTypes["CartWithoutCustomerCreateInput"] | undefined,
	alias?: string | undefined
};
	["CartWithoutCustomerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	confirmedAt?: GraphQLTypes["DateTime"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	items?: Array<GraphQLTypes["CartCreateItemsEntityRelationInput"]> | undefined,
	handle?: string | undefined,
	state?: GraphQLTypes["CartState"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	channel?: GraphQLTypes["CartCreateChannelEntityRelationInput"] | undefined,
	order?: GraphQLTypes["CartCreateOrderEntityRelationInput"] | undefined,
	deliveryAddress?: GraphQLTypes["CartCreateDeliveryAddressEntityRelationInput"] | undefined,
	billingAddress?: GraphQLTypes["CartCreateBillingAddressEntityRelationInput"] | undefined,
	deliveryOption?: string | undefined,
	paymentOption?: string | undefined,
	delivery?: GraphQLTypes["CartCreateDeliveryEntityRelationInput"] | undefined,
	payment?: GraphQLTypes["CartCreatePaymentEntityRelationInput"] | undefined,
	billingSubject?: GraphQLTypes["CartCreateBillingSubjectEntityRelationInput"] | undefined,
	priceLines?: Array<GraphQLTypes["CartCreatePriceLinesEntityRelationInput"]> | undefined,
	summary?: GraphQLTypes["CartCreateSummaryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CartCreateOrderEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	create?: GraphQLTypes["OrderWithoutCartCreateInput"] | undefined
};
	["OrderWithoutCartCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	state?: GraphQLTypes["OrderState"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	canceledAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	customer?: GraphQLTypes["OrderCreateCustomerEntityRelationInput"] | undefined,
	channel?: GraphQLTypes["OrderCreateChannelEntityRelationInput"] | undefined,
	discounts?: Array<GraphQLTypes["OrderCreateDiscountsEntityRelationInput"]> | undefined,
	delivery?: GraphQLTypes["OrderCreateDeliveryEntityRelationInput"] | undefined,
	items?: Array<GraphQLTypes["OrderCreateItemsEntityRelationInput"]> | undefined,
	internalNote?: string | undefined,
	events?: Array<GraphQLTypes["OrderCreateEventsEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddress?: GraphQLTypes["OrderCreateBillingAddressEntityRelationInput"] | undefined,
	priceLines?: Array<GraphQLTypes["OrderCreatePriceLinesEntityRelationInput"]> | undefined,
	payments?: Array<GraphQLTypes["OrderCreatePaymentsEntityRelationInput"]> | undefined,
	seq?: number | undefined,
	billingSubject?: GraphQLTypes["OrderCreateBillingSubjectEntityRelationInput"] | undefined,
	summary?: GraphQLTypes["OrderCreateSummaryEntityRelationInput"] | undefined,
	doubleshotLegacyId?: string | undefined,
	gratuity?: GraphQLTypes["OrderCreateGratuityEntityRelationInput"] | undefined,
	venue?: GraphQLTypes["OrderCreateVenueEntityRelationInput"] | undefined,
	fulfillmentNote?: string | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["OrderCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	doubleshotTotalWeightGrams?: number | undefined,
	doubleShotLegacyNumber?: string | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	doubleshotAdminUrl?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderCreateCustomerEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerWithoutOrdersCreateInput"] | undefined
};
	["CustomerWithoutOrdersCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	addresses?: Array<GraphQLTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerCreateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerCreateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerCreatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerCreateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerCreateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerCreateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerCreateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerCreateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerCreateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerCreateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreateShortcutListEntityRelationInput"]: {
		connect?: GraphQLTypes["ApplicationShortcutListUniqueWhere"] | undefined,
	create?: GraphQLTypes["ApplicationShortcutListWithoutCustomerCreateInput"] | undefined
};
	["ApplicationShortcutListWithoutCustomerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["ApplicationShortcutListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ApplicationShortcutListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["ApplicationShortcutListItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["ApplicationShortcutListItemWithoutListCreateInput"] | undefined,
	alias?: string | undefined
};
	["ApplicationShortcutListItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	application?: GraphQLTypes["ApplicationShortcutListItemCreateApplicationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ApplicationShortcutListItemCreateApplicationEntityRelationInput"]: {
		connect?: GraphQLTypes["ApplicationUniqueWhere"] | undefined,
	create?: GraphQLTypes["ApplicationCreateInput"] | undefined
};
	["ApplicationUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	handle?: string | undefined,
	icon?: GraphQLTypes["ImageUniqueWhere"] | undefined
};
	["ApplicationCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	handle?: string | undefined,
	url?: string | undefined,
	color?: string | undefined,
	icon?: GraphQLTypes["ApplicationCreateIconEntityRelationInput"] | undefined,
	name?: string | undefined,
	short?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ApplicationCreateIconEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["CustomerCreateUserEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserWithoutCustomerCreateInput"] | undefined
};
	["UserWithoutCustomerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	internalNote?: string | undefined,
	staff?: GraphQLTypes["UserCreateStaffEntityRelationInput"] | undefined,
	tenantPersonId?: GraphQLTypes["UUID"] | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	devices?: Array<GraphQLTypes["UserCreateDevicesEntityRelationInput"]> | undefined,
	verifiedAt?: GraphQLTypes["DateTime"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	deletionRequestedAt?: GraphQLTypes["DateTime"] | undefined,
	deletionExpectedAt?: GraphQLTypes["DateTime"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	meta?: GraphQLTypes["UserCreateMetaEntityRelationInput"] | undefined,
	identificationAttempts?: Array<GraphQLTypes["UserCreateIdentificationAttemptsEntityRelationInput"]> | undefined,
	roles?: GraphQLTypes["UserCreateRolesEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserCreateStaffEntityRelationInput"]: {
		connect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	create?: GraphQLTypes["StaffWithoutUserCreateInput"] | undefined
};
	["StaffWithoutUserCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	bartender?: GraphQLTypes["StaffCreateBartenderEntityRelationInput"] | undefined,
	courier?: GraphQLTypes["StaffCreateCourierEntityRelationInput"] | undefined,
	cleaner?: GraphQLTypes["StaffCreateCleanerEntityRelationInput"] | undefined,
	shiftsManager?: GraphQLTypes["StaffCreateShiftsManagerEntityRelationInput"] | undefined,
	businessToBusinessManager?: GraphQLTypes["StaffCreateBusinessToBusinessManagerEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["StaffCreateShiftsProfileEntityRelationInput"] | undefined,
	stocksManager?: GraphQLTypes["StaffCreateStocksManagerEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["StaffCreatePhotoEntityRelationInput"] | undefined,
	courierManager?: GraphQLTypes["StaffCreateCourierManagerEntityRelationInput"] | undefined,
	picker?: GraphQLTypes["StaffCreatePickerEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	remunerationProfile?: GraphQLTypes["StaffCreateRemunerationProfileEntityRelationInput"] | undefined,
	cashier?: GraphQLTypes["StaffCreateCashierEntityRelationInput"] | undefined,
	venues?: Array<GraphQLTypes["StaffCreateVenuesEntityRelationInput"]> | undefined,
	internalBuyer?: GraphQLTypes["StaffCreateInternalBuyerEntityRelationInput"] | undefined,
	salesManager?: GraphQLTypes["StaffCreateSalesManagerEntityRelationInput"] | undefined,
	cashierManager?: GraphQLTypes["StaffCreateCashierManagerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StaffCreateShiftsProfileEntityRelationInput"]: {
		connect?: GraphQLTypes["ShiftsProfileUniqueWhere"] | undefined,
	create?: GraphQLTypes["ShiftsProfileWithoutStaffCreateInput"] | undefined
};
	["ShiftsProfileWithoutStaffCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	queueItems?: Array<GraphQLTypes["ShiftsProfileCreateQueueItemsEntityRelationInput"]> | undefined,
	roles?: Array<GraphQLTypes["ShiftsProfileCreateRolesEntityRelationInput"]> | undefined,
	shifts?: Array<GraphQLTypes["ShiftsProfileCreateShiftsEntityRelationInput"]> | undefined,
	allowSelfUnassigning?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ShiftsProfileCreateRolesEntityRelationInput"]: {
		connect?: GraphQLTypes["TimetableEmployeeRoleUniqueWhere"] | undefined,
	create?: GraphQLTypes["TimetableEmployeeRoleWithoutShiftsProfilesCreateInput"] | undefined,
	alias?: string | undefined
};
	["TimetableEmployeeRoleWithoutShiftsProfilesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	shiftGroups?: Array<GraphQLTypes["TimetableEmployeeRoleCreateShiftGroupsEntityRelationInput"]> | undefined,
	shiftsManagers?: Array<GraphQLTypes["TimetableEmployeeRoleCreateShiftsManagersEntityRelationInput"]> | undefined,
	name?: string | undefined,
	timetableTemplates?: Array<GraphQLTypes["TimetableEmployeeRoleCreateTimetableTemplatesEntityRelationInput"]> | undefined,
	color?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableEmployeeRoleCreateShiftsManagersEntityRelationInput"]: {
		connect?: GraphQLTypes["ShiftsManagerUniqueWhere"] | undefined,
	create?: GraphQLTypes["ShiftsManagerWithoutManagedRolesCreateInput"] | undefined,
	alias?: string | undefined
};
	["ShiftsManagerWithoutManagedRolesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	staff?: GraphQLTypes["ShiftsManagerCreateStaffEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ShiftsManagerCreateStaffEntityRelationInput"]: {
		connect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	create?: GraphQLTypes["StaffWithoutShiftsManagerCreateInput"] | undefined
};
	["StaffWithoutShiftsManagerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	bartender?: GraphQLTypes["StaffCreateBartenderEntityRelationInput"] | undefined,
	courier?: GraphQLTypes["StaffCreateCourierEntityRelationInput"] | undefined,
	cleaner?: GraphQLTypes["StaffCreateCleanerEntityRelationInput"] | undefined,
	businessToBusinessManager?: GraphQLTypes["StaffCreateBusinessToBusinessManagerEntityRelationInput"] | undefined,
	user?: GraphQLTypes["StaffCreateUserEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["StaffCreateShiftsProfileEntityRelationInput"] | undefined,
	stocksManager?: GraphQLTypes["StaffCreateStocksManagerEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["StaffCreatePhotoEntityRelationInput"] | undefined,
	courierManager?: GraphQLTypes["StaffCreateCourierManagerEntityRelationInput"] | undefined,
	picker?: GraphQLTypes["StaffCreatePickerEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	remunerationProfile?: GraphQLTypes["StaffCreateRemunerationProfileEntityRelationInput"] | undefined,
	cashier?: GraphQLTypes["StaffCreateCashierEntityRelationInput"] | undefined,
	venues?: Array<GraphQLTypes["StaffCreateVenuesEntityRelationInput"]> | undefined,
	internalBuyer?: GraphQLTypes["StaffCreateInternalBuyerEntityRelationInput"] | undefined,
	salesManager?: GraphQLTypes["StaffCreateSalesManagerEntityRelationInput"] | undefined,
	cashierManager?: GraphQLTypes["StaffCreateCashierManagerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StaffCreateStocksManagerEntityRelationInput"]: {
		connect?: GraphQLTypes["StocksManagerUniqueWhere"] | undefined,
	create?: GraphQLTypes["StocksManagerWithoutStaffCreateInput"] | undefined
};
	["StocksManagerWithoutStaffCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	managedProducts?: Array<GraphQLTypes["StocksManagerCreateManagedProductsEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StocksManagerCreateManagedProductsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductWithoutManagerCreateInput"] | undefined,
	alias?: string | undefined
};
	["ProductWithoutManagerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	priceCents?: number | undefined,
	notDiscountable?: boolean | undefined,
	packing?: GraphQLTypes["ProductCreatePackingEntityRelationInput"] | undefined,
	recipe?: GraphQLTypes["ProductCreateRecipeEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["ProductCreateTagsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["ProductCreateCategoriesEntityRelationInput"]> | undefined,
	vatRate?: GraphQLTypes["ProductCreateVatRateEntityRelationInput"] | undefined,
	stocks?: Array<GraphQLTypes["ProductCreateStocksEntityRelationInput"]> | undefined,
	groupPrices?: Array<GraphQLTypes["ProductCreateGroupPricesEntityRelationInput"]> | undefined,
	image?: GraphQLTypes["ProductCreateImageEntityRelationInput"] | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	cartItems?: Array<GraphQLTypes["ProductCreateCartItemsEntityRelationInput"]> | undefined,
	availability?: GraphQLTypes["ProductAvailability"] | undefined,
	order?: number | undefined,
	orderItems?: Array<GraphQLTypes["ProductCreateOrderItemsEntityRelationInput"]> | undefined,
	maximumQuantityPerOrder?: number | undefined,
	inheritedCategories?: Array<GraphQLTypes["ProductCreateInheritedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["ProductCreateDeliveryZonesEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["ProductCreateLocalesEntityRelationInput"]> | undefined,
	archivedAt?: GraphQLTypes["DateTime"] | undefined,
	customerPrices?: Array<GraphQLTypes["ProductCreateCustomerPricesEntityRelationInput"]> | undefined,
	virtualProduct?: GraphQLTypes["ProductCreateVirtualProductEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["ProductCreateMetaEntityRelationInput"] | undefined,
	page?: GraphQLTypes["ProductCreatePageEntityRelationInput"] | undefined,
	salesDays?: Array<GraphQLTypes["ProductCreateSalesDaysEntityRelationInput"]> | undefined,
	salesWeeks?: Array<GraphQLTypes["ProductCreateSalesWeeksEntityRelationInput"]> | undefined,
	salesMonths?: Array<GraphQLTypes["ProductCreateSalesMonthsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["ProductCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	hasSubscription?: boolean | undefined,
	pointOfSaleTileColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCreateOrderItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["OrderItemWithoutProductCreateInput"] | undefined,
	alias?: string | undefined
};
	["OrderItemWithoutProductCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unitPriceCents?: number | undefined,
	quantity?: number | undefined,
	vatRate?: GraphQLTypes["OrderItemCreateVatRateEntityRelationInput"] | undefined,
	order?: GraphQLTypes["OrderItemCreateOrderEntityRelationInput"] | undefined,
	virtualProductEffects?: Array<GraphQLTypes["OrderItemCreateVirtualProductEffectsEntityRelationInput"]> | undefined,
	pickedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["OrderItemCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderItemCreateVatRateEntityRelationInput"]: {
		connect?: GraphQLTypes["VatRateUniqueWhere"] | undefined,
	create?: GraphQLTypes["VatRateCreateInput"] | undefined
};
	["OrderItemCreateOrderEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	create?: GraphQLTypes["OrderWithoutItemsCreateInput"] | undefined
};
	["OrderWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	state?: GraphQLTypes["OrderState"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	canceledAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	customer?: GraphQLTypes["OrderCreateCustomerEntityRelationInput"] | undefined,
	channel?: GraphQLTypes["OrderCreateChannelEntityRelationInput"] | undefined,
	discounts?: Array<GraphQLTypes["OrderCreateDiscountsEntityRelationInput"]> | undefined,
	delivery?: GraphQLTypes["OrderCreateDeliveryEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	cart?: GraphQLTypes["OrderCreateCartEntityRelationInput"] | undefined,
	events?: Array<GraphQLTypes["OrderCreateEventsEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddress?: GraphQLTypes["OrderCreateBillingAddressEntityRelationInput"] | undefined,
	priceLines?: Array<GraphQLTypes["OrderCreatePriceLinesEntityRelationInput"]> | undefined,
	payments?: Array<GraphQLTypes["OrderCreatePaymentsEntityRelationInput"]> | undefined,
	seq?: number | undefined,
	billingSubject?: GraphQLTypes["OrderCreateBillingSubjectEntityRelationInput"] | undefined,
	summary?: GraphQLTypes["OrderCreateSummaryEntityRelationInput"] | undefined,
	doubleshotLegacyId?: string | undefined,
	gratuity?: GraphQLTypes["OrderCreateGratuityEntityRelationInput"] | undefined,
	venue?: GraphQLTypes["OrderCreateVenueEntityRelationInput"] | undefined,
	fulfillmentNote?: string | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["OrderCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	doubleshotTotalWeightGrams?: number | undefined,
	doubleShotLegacyNumber?: string | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	doubleshotAdminUrl?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderCreateDiscountsEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderDiscountUniqueWhere"] | undefined,
	create?: GraphQLTypes["OrderDiscountWithoutOrderCreateInput"] | undefined,
	alias?: string | undefined
};
	["OrderDiscountWithoutOrderCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	discountCents?: number | undefined,
	vatRate?: GraphQLTypes["OrderDiscountCreateVatRateEntityRelationInput"] | undefined,
	description?: string | undefined,
	type?: GraphQLTypes["OrderDiscountType"] | undefined,
	customerCreditTransactions?: Array<GraphQLTypes["OrderDiscountCreateCustomerCreditTransactionsEntityRelationInput"]> | undefined,
	voucherRedemption?: GraphQLTypes["OrderDiscountCreateVoucherRedemptionEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderDiscountCreateVatRateEntityRelationInput"]: {
		connect?: GraphQLTypes["VatRateUniqueWhere"] | undefined,
	create?: GraphQLTypes["VatRateCreateInput"] | undefined
};
	["OrderDiscountCreateCustomerCreditTransactionsEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerCreditTransactionUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerCreditTransactionWithoutOrderDiscountCreateInput"] | undefined,
	alias?: string | undefined
};
	["CustomerCreditTransactionWithoutOrderDiscountCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	amountCents?: number | undefined,
	customerCredit?: GraphQLTypes["CustomerCreditTransactionCreateCustomerCreditEntityRelationInput"] | undefined,
	virtualProductEffect?: GraphQLTypes["CustomerCreditTransactionCreateVirtualProductEffectEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreditTransactionCreateCustomerCreditEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerCreditUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerCreditWithoutTransactionsCreateInput"] | undefined
};
	["CustomerCreditWithoutTransactionsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	initialCreditCents?: number | undefined,
	remainingCreditsCents?: number | undefined,
	expiresAt?: GraphQLTypes["DateTime"] | undefined,
	reason?: string | undefined,
	customer?: GraphQLTypes["CustomerCreditCreateCustomerEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["CustomerCreditCreateVatRateEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	voucherRedemption?: GraphQLTypes["CustomerCreditCreateVoucherRedemptionEntityRelationInput"] | undefined,
	invoiceUrl?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreditCreateCustomerEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerWithoutCreditsCreateInput"] | undefined
};
	["CustomerWithoutCreditsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	addresses?: Array<GraphQLTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerCreateTagsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerCreateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerCreatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerCreateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerCreateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerCreateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerCreateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerCreateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerCreateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerCreateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreateChannelsEntityRelationInput"]: {
		connect?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	create?: GraphQLTypes["ChannelWithoutCustomersCreateInput"] | undefined,
	alias?: string | undefined
};
	["ChannelWithoutCustomersCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	disabled?: boolean | undefined,
	payments?: Array<GraphQLTypes["ChannelCreatePaymentsEntityRelationInput"]> | undefined,
	deliveries?: Array<GraphQLTypes["ChannelCreateDeliveriesEntityRelationInput"]> | undefined,
	pointOfSales?: Array<GraphQLTypes["ChannelCreatePointOfSalesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["ChannelCreateCartsEntityRelationInput"]> | undefined,
	code?: GraphQLTypes["ChannelCode"] | undefined,
	addTagsOnRegistration?: Array<GraphQLTypes["ChannelCreateAddTagsOnRegistrationEntityRelationInput"]> | undefined,
	publicTags?: Array<GraphQLTypes["ChannelCreatePublicTagsEntityRelationInput"]> | undefined,
	venue?: GraphQLTypes["ChannelCreateVenueEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ChannelCreatePublicTagsEntityRelationInput"]: {
		connect?: GraphQLTypes["TagUniqueWhere"] | undefined,
	create?: GraphQLTypes["TagWithoutPublicInChannelsCreateInput"] | undefined,
	alias?: string | undefined
};
	["TagWithoutPublicInChannelsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	customers?: Array<GraphQLTypes["TagCreateCustomersEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["TagCreateProductsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["TagCreateCategoriesEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	addTagsOnRegistration?: Array<GraphQLTypes["TagCreateAddTagsOnRegistrationEntityRelationInput"]> | undefined,
	nestedCategories?: Array<GraphQLTypes["TagCreateNestedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["TagCreateDeliveryZonesEntityRelationInput"]> | undefined,
	allowChannelPayments?: Array<GraphQLTypes["TagCreateAllowChannelPaymentsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["TagCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TagCreateAllowChannelPaymentsEntityRelationInput"]: {
		connect?: GraphQLTypes["ChannelPaymentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ChannelPaymentWithoutAllowOnlyForTagsCreateInput"] | undefined,
	alias?: string | undefined
};
	["ChannelPaymentWithoutAllowOnlyForTagsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	channel?: GraphQLTypes["ChannelPaymentCreateChannelEntityRelationInput"] | undefined,
	method?: GraphQLTypes["ChannelPaymentCreateMethodEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["ChannelPaymentCreateVatRateEntityRelationInput"] | undefined,
	requireBillingAddress?: boolean | undefined,
	provideReceipt?: boolean | undefined,
	requireBillingSubject?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ChannelPaymentCreateVatRateEntityRelationInput"]: {
		connect?: GraphQLTypes["VatRateUniqueWhere"] | undefined,
	create?: GraphQLTypes["VatRateWithoutChannelPaymentsCreateInput"] | undefined
};
	["VatRateWithoutChannelPaymentsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	ratePermille?: number | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	channelDeliveries?: Array<GraphQLTypes["VatRateCreateChannelDeliveriesEntityRelationInput"]> | undefined,
	preset?: GraphQLTypes["VatRatePreset"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TagCreateFulfillmentNotesEntityRelationInput"]: {
		connect?: GraphQLTypes["FulfillmentNoteUniqueWhere"] | undefined,
	create?: GraphQLTypes["FulfillmentNoteWithoutTagsCreateInput"] | undefined,
	alias?: string | undefined
};
	["FulfillmentNoteUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["FulfillmentNoteWithoutTagsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	note?: string | undefined,
	products?: Array<GraphQLTypes["FulfillmentNoteCreateProductsEntityRelationInput"]> | undefined,
	venues?: Array<GraphQLTypes["FulfillmentNoteCreateVenuesEntityRelationInput"]> | undefined,
	cartItems?: Array<GraphQLTypes["FulfillmentNoteCreateCartItemsEntityRelationInput"]> | undefined,
	orderItems?: Array<GraphQLTypes["FulfillmentNoteCreateOrderItemsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["FulfillmentNoteCreateOrdersEntityRelationInput"]> | undefined,
	highlight?: boolean | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	emoji?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["FulfillmentNoteCreateProductsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductWithoutFulfillmentNotesCreateInput"] | undefined,
	alias?: string | undefined
};
	["ProductWithoutFulfillmentNotesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	priceCents?: number | undefined,
	notDiscountable?: boolean | undefined,
	packing?: GraphQLTypes["ProductCreatePackingEntityRelationInput"] | undefined,
	recipe?: GraphQLTypes["ProductCreateRecipeEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["ProductCreateTagsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["ProductCreateCategoriesEntityRelationInput"]> | undefined,
	vatRate?: GraphQLTypes["ProductCreateVatRateEntityRelationInput"] | undefined,
	stocks?: Array<GraphQLTypes["ProductCreateStocksEntityRelationInput"]> | undefined,
	groupPrices?: Array<GraphQLTypes["ProductCreateGroupPricesEntityRelationInput"]> | undefined,
	image?: GraphQLTypes["ProductCreateImageEntityRelationInput"] | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	cartItems?: Array<GraphQLTypes["ProductCreateCartItemsEntityRelationInput"]> | undefined,
	availability?: GraphQLTypes["ProductAvailability"] | undefined,
	order?: number | undefined,
	manager?: GraphQLTypes["ProductCreateManagerEntityRelationInput"] | undefined,
	orderItems?: Array<GraphQLTypes["ProductCreateOrderItemsEntityRelationInput"]> | undefined,
	maximumQuantityPerOrder?: number | undefined,
	inheritedCategories?: Array<GraphQLTypes["ProductCreateInheritedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["ProductCreateDeliveryZonesEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["ProductCreateLocalesEntityRelationInput"]> | undefined,
	archivedAt?: GraphQLTypes["DateTime"] | undefined,
	customerPrices?: Array<GraphQLTypes["ProductCreateCustomerPricesEntityRelationInput"]> | undefined,
	virtualProduct?: GraphQLTypes["ProductCreateVirtualProductEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["ProductCreateMetaEntityRelationInput"] | undefined,
	page?: GraphQLTypes["ProductCreatePageEntityRelationInput"] | undefined,
	salesDays?: Array<GraphQLTypes["ProductCreateSalesDaysEntityRelationInput"]> | undefined,
	salesWeeks?: Array<GraphQLTypes["ProductCreateSalesWeeksEntityRelationInput"]> | undefined,
	salesMonths?: Array<GraphQLTypes["ProductCreateSalesMonthsEntityRelationInput"]> | undefined,
	hasSubscription?: boolean | undefined,
	pointOfSaleTileColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCreateInheritedCategoriesEntityRelationInput"]: {
		connect?: GraphQLTypes["NestedProductCategoryProductUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductCreateDeliveryZonesEntityRelationInput"]: {
		connect?: GraphQLTypes["DeliveryZoneUniqueWhere"] | undefined,
	create?: GraphQLTypes["DeliveryZoneWithoutDeliveryZonesOfProductsCreateInput"] | undefined,
	alias?: string | undefined
};
	["DeliveryZoneWithoutDeliveryZonesOfProductsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	type?: GraphQLTypes["DeliveryZoneType"] | undefined,
	addresses?: Array<GraphQLTypes["DeliveryZoneCreateAddressesEntityRelationInput"]> | undefined,
	suitableDeliveryMethods?: Array<GraphQLTypes["DeliveryZoneCreateSuitableDeliveryMethodsEntityRelationInput"]> | undefined,
	deliveryZonesOfTags?: Array<GraphQLTypes["DeliveryZoneCreateDeliveryZonesOfTagsEntityRelationInput"]> | undefined,
	addressesMetadata?: Array<GraphQLTypes["DeliveryZoneCreateAddressesMetadataEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryZoneCreateDeliveryZonesOfTagsEntityRelationInput"]: {
		connect?: GraphQLTypes["TagUniqueWhere"] | undefined,
	create?: GraphQLTypes["TagWithoutDeliveryZonesCreateInput"] | undefined,
	alias?: string | undefined
};
	["TagWithoutDeliveryZonesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	customers?: Array<GraphQLTypes["TagCreateCustomersEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["TagCreateProductsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["TagCreateCategoriesEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	addTagsOnRegistration?: Array<GraphQLTypes["TagCreateAddTagsOnRegistrationEntityRelationInput"]> | undefined,
	nestedCategories?: Array<GraphQLTypes["TagCreateNestedCategoriesEntityRelationInput"]> | undefined,
	publicInChannels?: Array<GraphQLTypes["TagCreatePublicInChannelsEntityRelationInput"]> | undefined,
	allowChannelPayments?: Array<GraphQLTypes["TagCreateAllowChannelPaymentsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["TagCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TagCreatePublicInChannelsEntityRelationInput"]: {
		connect?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	create?: GraphQLTypes["ChannelWithoutPublicTagsCreateInput"] | undefined,
	alias?: string | undefined
};
	["ChannelWithoutPublicTagsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	disabled?: boolean | undefined,
	payments?: Array<GraphQLTypes["ChannelCreatePaymentsEntityRelationInput"]> | undefined,
	deliveries?: Array<GraphQLTypes["ChannelCreateDeliveriesEntityRelationInput"]> | undefined,
	pointOfSales?: Array<GraphQLTypes["ChannelCreatePointOfSalesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["ChannelCreateCartsEntityRelationInput"]> | undefined,
	customers?: Array<GraphQLTypes["ChannelCreateCustomersEntityRelationInput"]> | undefined,
	code?: GraphQLTypes["ChannelCode"] | undefined,
	addTagsOnRegistration?: Array<GraphQLTypes["ChannelCreateAddTagsOnRegistrationEntityRelationInput"]> | undefined,
	venue?: GraphQLTypes["ChannelCreateVenueEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ChannelCreateVenueEntityRelationInput"]: {
		connect?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	create?: GraphQLTypes["VenueWithoutChannelsCreateInput"] | undefined
};
	["VenueWithoutChannelsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	deadlineTemplate?: GraphQLTypes["VenueCreateDeadlineTemplateEntityRelationInput"] | undefined,
	timetableDays?: Array<GraphQLTypes["VenueCreateTimetableDaysEntityRelationInput"]> | undefined,
	timetableTemplates?: Array<GraphQLTypes["VenueCreateTimetableTemplatesEntityRelationInput"]> | undefined,
	staffMembers?: Array<GraphQLTypes["VenueCreateStaffMembersEntityRelationInput"]> | undefined,
	employeeRoles?: Array<GraphQLTypes["VenueCreateEmployeeRolesEntityRelationInput"]> | undefined,
	pointOfSaleApplicationDevices?: Array<GraphQLTypes["VenueCreatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined,
	pointOfSaleTerminals?: Array<GraphQLTypes["VenueCreatePointOfSaleTerminalsEntityRelationInput"]> | undefined,
	pointOfSalePrinters?: Array<GraphQLTypes["VenueCreatePointOfSalePrintersEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["VenueCreateOrdersEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["VenueCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	areas?: Array<GraphQLTypes["VenueCreateAreasEntityRelationInput"]> | undefined,
	enabledUnassignReasons?: Array<GraphQLTypes["VenueCreateEnabledUnassignReasonsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["VenueCreateCategoriesEntityRelationInput"]> | undefined,
	address?: string | undefined,
	pointOfSalePngBase64ReceiptLogo?: string | undefined,
	pointOfSaleInitialView?: GraphQLTypes["PointOfSaleInitialView"] | undefined,
	pointOfSalePreferPrintReceipt?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["VenueCreateDeadlineTemplateEntityRelationInput"]: {
		connect?: GraphQLTypes["DeadlineTemplateUniqueWhere"] | undefined,
	create?: GraphQLTypes["DeadlineTemplateWithoutVenueCreateInput"] | undefined
};
	["DeadlineTemplateWithoutVenueCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	startDate?: GraphQLTypes["Date"] | undefined,
	period?: number | undefined,
	cutoff?: number | undefined,
	closed?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["VenueCreateTimetableDaysEntityRelationInput"]: {
		connect?: GraphQLTypes["TimetableDayUniqueWhere"] | undefined,
	create?: GraphQLTypes["TimetableDayWithoutVenueCreateInput"] | undefined,
	alias?: string | undefined
};
	["TimetableDayWithoutVenueCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	date?: GraphQLTypes["Date"] | undefined,
	type?: GraphQLTypes["TimetableDayType"] | undefined,
	shiftGroups?: Array<GraphQLTypes["TimetableDayCreateShiftGroupsEntityRelationInput"]> | undefined,
	tipsCents?: number | undefined,
	notes?: Array<GraphQLTypes["TimetableDayCreateNotesEntityRelationInput"]> | undefined,
	meta?: GraphQLTypes["TimetableDayCreateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableDayCreateShiftGroupsEntityRelationInput"]: {
		connect?: GraphQLTypes["TimetableShiftGroupUniqueWhere"] | undefined,
	create?: GraphQLTypes["TimetableShiftGroupWithoutDayCreateInput"] | undefined,
	alias?: string | undefined
};
	["TimetableShiftGroupWithoutDayCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	shifts?: Array<GraphQLTypes["TimetableShiftGroupCreateShiftsEntityRelationInput"]> | undefined,
	type?: GraphQLTypes["TimetableShiftGroupCreateTypeEntityRelationInput"] | undefined,
	position?: GraphQLTypes["TimetableShiftGroupCreatePositionEntityRelationInput"] | undefined,
	queue?: GraphQLTypes["TimetableShiftGroupCreateQueueEntityRelationInput"] | undefined,
	generatedByTemplate?: GraphQLTypes["TimetableShiftGroupCreateGeneratedByTemplateEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableShiftGroupCreateTypeEntityRelationInput"]: {
		connect?: GraphQLTypes["TimetableEmployeeRoleUniqueWhere"] | undefined,
	create?: GraphQLTypes["TimetableEmployeeRoleWithoutShiftGroupsCreateInput"] | undefined
};
	["TimetableEmployeeRoleWithoutShiftGroupsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	shiftsProfiles?: Array<GraphQLTypes["TimetableEmployeeRoleCreateShiftsProfilesEntityRelationInput"]> | undefined,
	shiftsManagers?: Array<GraphQLTypes["TimetableEmployeeRoleCreateShiftsManagersEntityRelationInput"]> | undefined,
	name?: string | undefined,
	timetableTemplates?: Array<GraphQLTypes["TimetableEmployeeRoleCreateTimetableTemplatesEntityRelationInput"]> | undefined,
	color?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableEmployeeRoleCreateTimetableTemplatesEntityRelationInput"]: {
		connect?: GraphQLTypes["TimetableTemplateUniqueWhere"] | undefined,
	create?: GraphQLTypes["TimetableTemplateWithoutEmployeeRoleCreateInput"] | undefined,
	alias?: string | undefined
};
	["TimetableTemplateWithoutEmployeeRoleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	startDate?: GraphQLTypes["Date"] | undefined,
	period?: number | undefined,
	slots?: number | undefined,
	position?: GraphQLTypes["TimetableTemplateCreatePositionEntityRelationInput"] | undefined,
	staffOptions?: Array<GraphQLTypes["TimetableTemplateCreateStaffOptionsEntityRelationInput"]> | undefined,
	internalName?: string | undefined,
	venue?: GraphQLTypes["TimetableTemplateCreateVenueEntityRelationInput"] | undefined,
	workdaysOnly?: boolean | undefined,
	monday?: boolean | undefined,
	tuesday?: boolean | undefined,
	wednesday?: boolean | undefined,
	thursday?: boolean | undefined,
	friday?: boolean | undefined,
	saturday?: boolean | undefined,
	sunday?: boolean | undefined,
	type?: GraphQLTypes["TemplateType"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableTemplateCreatePositionEntityRelationInput"]: {
		connect?: GraphQLTypes["TimetableShiftPositionUniqueWhere"] | undefined,
	create?: GraphQLTypes["TimetableShiftPositionWithoutTimetableTemplatesCreateInput"] | undefined
};
	["TimetableShiftPositionUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	shiftGroups?: GraphQLTypes["TimetableShiftGroupUniqueWhere"] | undefined,
	timetableTemplates?: GraphQLTypes["TimetableTemplateUniqueWhere"] | undefined
};
	["TimetableShiftPositionWithoutTimetableTemplatesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	start?: string | undefined,
	end?: string | undefined,
	shiftGroups?: Array<GraphQLTypes["TimetableShiftPositionCreateShiftGroupsEntityRelationInput"]> | undefined,
	isDynamic?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableShiftPositionCreateShiftGroupsEntityRelationInput"]: {
		connect?: GraphQLTypes["TimetableShiftGroupUniqueWhere"] | undefined,
	create?: GraphQLTypes["TimetableShiftGroupWithoutPositionCreateInput"] | undefined,
	alias?: string | undefined
};
	["TimetableShiftGroupWithoutPositionCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	shifts?: Array<GraphQLTypes["TimetableShiftGroupCreateShiftsEntityRelationInput"]> | undefined,
	day?: GraphQLTypes["TimetableShiftGroupCreateDayEntityRelationInput"] | undefined,
	type?: GraphQLTypes["TimetableShiftGroupCreateTypeEntityRelationInput"] | undefined,
	queue?: GraphQLTypes["TimetableShiftGroupCreateQueueEntityRelationInput"] | undefined,
	generatedByTemplate?: GraphQLTypes["TimetableShiftGroupCreateGeneratedByTemplateEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableShiftGroupCreateQueueEntityRelationInput"]: {
		connect?: GraphQLTypes["EmployeeQueueUniqueWhere"] | undefined,
	create?: GraphQLTypes["EmployeeQueueWithoutShiftGroupCreateInput"] | undefined
};
	["EmployeeQueueWithoutShiftGroupCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["EmployeeQueueCreateItemsEntityRelationInput"]> | undefined,
	contemberBugFix?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["EmployeeQueueCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["EmployeeQueueItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["EmployeeQueueItemWithoutQueueCreateInput"] | undefined,
	alias?: string | undefined
};
	["EmployeeQueueItemWithoutQueueCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	start?: string | undefined,
	end?: string | undefined,
	shiftsProfile?: GraphQLTypes["EmployeeQueueItemCreateShiftsProfileEntityRelationInput"] | undefined,
	shift?: GraphQLTypes["EmployeeQueueItemCreateShiftEntityRelationInput"] | undefined,
	unassignInfo?: GraphQLTypes["EmployeeQueueItemCreateUnassignInfoEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["EmployeeQueueItemCreateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["EmployeeQueueItemCreateShiftsProfileEntityRelationInput"]: {
		connect?: GraphQLTypes["ShiftsProfileUniqueWhere"] | undefined,
	create?: GraphQLTypes["ShiftsProfileWithoutQueueItemsCreateInput"] | undefined
};
	["ShiftsProfileWithoutQueueItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	staff?: GraphQLTypes["ShiftsProfileCreateStaffEntityRelationInput"] | undefined,
	roles?: Array<GraphQLTypes["ShiftsProfileCreateRolesEntityRelationInput"]> | undefined,
	shifts?: Array<GraphQLTypes["ShiftsProfileCreateShiftsEntityRelationInput"]> | undefined,
	allowSelfUnassigning?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ShiftsProfileCreateShiftsEntityRelationInput"]: {
		connect?: GraphQLTypes["TimetableShiftUniqueWhere"] | undefined,
	create?: GraphQLTypes["TimetableShiftWithoutShiftsProfileCreateInput"] | undefined,
	alias?: string | undefined
};
	["TimetableShiftWithoutShiftsProfileCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locked?: boolean | undefined,
	order?: number | undefined,
	assigned?: GraphQLTypes["Date"] | undefined,
	group?: GraphQLTypes["TimetableShiftCreateGroupEntityRelationInput"] | undefined,
	queueItem?: GraphQLTypes["TimetableShiftCreateQueueItemEntityRelationInput"] | undefined,
	swapInfo?: GraphQLTypes["TimetableShiftCreateSwapInfoEntityRelationInput"] | undefined,
	isOvertime?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableShiftCreateGroupEntityRelationInput"]: {
		connect?: GraphQLTypes["TimetableShiftGroupUniqueWhere"] | undefined,
	create?: GraphQLTypes["TimetableShiftGroupWithoutShiftsCreateInput"] | undefined
};
	["TimetableShiftGroupWithoutShiftsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	day?: GraphQLTypes["TimetableShiftGroupCreateDayEntityRelationInput"] | undefined,
	type?: GraphQLTypes["TimetableShiftGroupCreateTypeEntityRelationInput"] | undefined,
	position?: GraphQLTypes["TimetableShiftGroupCreatePositionEntityRelationInput"] | undefined,
	queue?: GraphQLTypes["TimetableShiftGroupCreateQueueEntityRelationInput"] | undefined,
	generatedByTemplate?: GraphQLTypes["TimetableShiftGroupCreateGeneratedByTemplateEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableShiftGroupCreatePositionEntityRelationInput"]: {
		connect?: GraphQLTypes["TimetableShiftPositionUniqueWhere"] | undefined,
	create?: GraphQLTypes["TimetableShiftPositionWithoutShiftGroupsCreateInput"] | undefined
};
	["TimetableShiftPositionWithoutShiftGroupsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	start?: string | undefined,
	end?: string | undefined,
	timetableTemplates?: Array<GraphQLTypes["TimetableShiftPositionCreateTimetableTemplatesEntityRelationInput"]> | undefined,
	isDynamic?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableShiftPositionCreateTimetableTemplatesEntityRelationInput"]: {
		connect?: GraphQLTypes["TimetableTemplateUniqueWhere"] | undefined,
	create?: GraphQLTypes["TimetableTemplateWithoutPositionCreateInput"] | undefined,
	alias?: string | undefined
};
	["TimetableTemplateWithoutPositionCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	startDate?: GraphQLTypes["Date"] | undefined,
	period?: number | undefined,
	slots?: number | undefined,
	staffOptions?: Array<GraphQLTypes["TimetableTemplateCreateStaffOptionsEntityRelationInput"]> | undefined,
	internalName?: string | undefined,
	venue?: GraphQLTypes["TimetableTemplateCreateVenueEntityRelationInput"] | undefined,
	employeeRole?: GraphQLTypes["TimetableTemplateCreateEmployeeRoleEntityRelationInput"] | undefined,
	workdaysOnly?: boolean | undefined,
	monday?: boolean | undefined,
	tuesday?: boolean | undefined,
	wednesday?: boolean | undefined,
	thursday?: boolean | undefined,
	friday?: boolean | undefined,
	saturday?: boolean | undefined,
	sunday?: boolean | undefined,
	type?: GraphQLTypes["TemplateType"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableTemplateCreateStaffOptionsEntityRelationInput"]: {
		connect?: GraphQLTypes["TimetableTemplateStaffOptionsUniqueWhere"] | undefined,
	create?: GraphQLTypes["TimetableTemplateStaffOptionsWithoutTimetableTemplateCreateInput"] | undefined,
	alias?: string | undefined
};
	["TimetableTemplateStaffOptionsWithoutTimetableTemplateCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	startTime?: string | undefined,
	endTime?: string | undefined,
	autoAssignedEmployee?: GraphQLTypes["TimetableTemplateStaffOptionsCreateAutoAssignedEmployeeEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableTemplateStaffOptionsCreateAutoAssignedEmployeeEntityRelationInput"]: {
		connect?: GraphQLTypes["ShiftsProfileUniqueWhere"] | undefined,
	create?: GraphQLTypes["ShiftsProfileCreateInput"] | undefined
};
	["ShiftsProfileCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	queueItems?: Array<GraphQLTypes["ShiftsProfileCreateQueueItemsEntityRelationInput"]> | undefined,
	staff?: GraphQLTypes["ShiftsProfileCreateStaffEntityRelationInput"] | undefined,
	roles?: Array<GraphQLTypes["ShiftsProfileCreateRolesEntityRelationInput"]> | undefined,
	shifts?: Array<GraphQLTypes["ShiftsProfileCreateShiftsEntityRelationInput"]> | undefined,
	allowSelfUnassigning?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableTemplateCreateVenueEntityRelationInput"]: {
		connect?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	create?: GraphQLTypes["VenueWithoutTimetableTemplatesCreateInput"] | undefined
};
	["VenueWithoutTimetableTemplatesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	deadlineTemplate?: GraphQLTypes["VenueCreateDeadlineTemplateEntityRelationInput"] | undefined,
	timetableDays?: Array<GraphQLTypes["VenueCreateTimetableDaysEntityRelationInput"]> | undefined,
	staffMembers?: Array<GraphQLTypes["VenueCreateStaffMembersEntityRelationInput"]> | undefined,
	employeeRoles?: Array<GraphQLTypes["VenueCreateEmployeeRolesEntityRelationInput"]> | undefined,
	pointOfSaleApplicationDevices?: Array<GraphQLTypes["VenueCreatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined,
	pointOfSaleTerminals?: Array<GraphQLTypes["VenueCreatePointOfSaleTerminalsEntityRelationInput"]> | undefined,
	pointOfSalePrinters?: Array<GraphQLTypes["VenueCreatePointOfSalePrintersEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["VenueCreateOrdersEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["VenueCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	areas?: Array<GraphQLTypes["VenueCreateAreasEntityRelationInput"]> | undefined,
	enabledUnassignReasons?: Array<GraphQLTypes["VenueCreateEnabledUnassignReasonsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["VenueCreateCategoriesEntityRelationInput"]> | undefined,
	channels?: Array<GraphQLTypes["VenueCreateChannelsEntityRelationInput"]> | undefined,
	address?: string | undefined,
	pointOfSalePngBase64ReceiptLogo?: string | undefined,
	pointOfSaleInitialView?: GraphQLTypes["PointOfSaleInitialView"] | undefined,
	pointOfSalePreferPrintReceipt?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["VenueCreateStaffMembersEntityRelationInput"]: {
		connect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	create?: GraphQLTypes["StaffWithoutVenuesCreateInput"] | undefined,
	alias?: string | undefined
};
	["StaffWithoutVenuesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	bartender?: GraphQLTypes["StaffCreateBartenderEntityRelationInput"] | undefined,
	courier?: GraphQLTypes["StaffCreateCourierEntityRelationInput"] | undefined,
	cleaner?: GraphQLTypes["StaffCreateCleanerEntityRelationInput"] | undefined,
	shiftsManager?: GraphQLTypes["StaffCreateShiftsManagerEntityRelationInput"] | undefined,
	businessToBusinessManager?: GraphQLTypes["StaffCreateBusinessToBusinessManagerEntityRelationInput"] | undefined,
	user?: GraphQLTypes["StaffCreateUserEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["StaffCreateShiftsProfileEntityRelationInput"] | undefined,
	stocksManager?: GraphQLTypes["StaffCreateStocksManagerEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["StaffCreatePhotoEntityRelationInput"] | undefined,
	courierManager?: GraphQLTypes["StaffCreateCourierManagerEntityRelationInput"] | undefined,
	picker?: GraphQLTypes["StaffCreatePickerEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	remunerationProfile?: GraphQLTypes["StaffCreateRemunerationProfileEntityRelationInput"] | undefined,
	cashier?: GraphQLTypes["StaffCreateCashierEntityRelationInput"] | undefined,
	internalBuyer?: GraphQLTypes["StaffCreateInternalBuyerEntityRelationInput"] | undefined,
	salesManager?: GraphQLTypes["StaffCreateSalesManagerEntityRelationInput"] | undefined,
	cashierManager?: GraphQLTypes["StaffCreateCashierManagerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StaffCreatePhotoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["StaffCreateCourierManagerEntityRelationInput"]: {
		connect?: GraphQLTypes["CourierManagerUniqueWhere"] | undefined,
	create?: GraphQLTypes["CourierManagerWithoutStaffCreateInput"] | undefined
};
	["CourierManagerWithoutStaffCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StaffCreatePickerEntityRelationInput"]: {
		connect?: GraphQLTypes["PickerUniqueWhere"] | undefined,
	create?: GraphQLTypes["PickerWithoutStaffCreateInput"] | undefined
};
	["PickerWithoutStaffCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StaffCreateRemunerationProfileEntityRelationInput"]: {
		connect?: GraphQLTypes["RemunerationProfileUniqueWhere"] | undefined,
	create?: GraphQLTypes["RemunerationProfileWithoutStaffCreateInput"] | undefined
};
	["RemunerationProfileWithoutStaffCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	employmentInformation?: Array<GraphQLTypes["RemunerationProfileCreateEmploymentInformationEntityRelationInput"]> | undefined,
	workMonths?: GraphQLTypes["RemunerationProfileCreateWorkMonthsEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RemunerationProfileCreateEmploymentInformationEntityRelationInput"]: {
		connect?: GraphQLTypes["EmploymentInformationUniqueWhere"] | undefined,
	create?: GraphQLTypes["EmploymentInformationWithoutRemunerationProfilesCreateInput"] | undefined,
	alias?: string | undefined
};
	["EmploymentInformationWithoutRemunerationProfilesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	hourlyRate?: number | undefined,
	monthlySalary?: number | undefined,
	type?: GraphQLTypes["EmploymentType"] | undefined,
	name?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["RemunerationProfileCreateWorkMonthsEntityRelationInput"]: {
		connect?: GraphQLTypes["WorkMonthUniqueWhere"] | undefined,
	create?: GraphQLTypes["WorkMonthWithoutRemunerationProfileCreateInput"] | undefined
};
	["WorkMonthUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	remunerationProfile?: GraphQLTypes["RemunerationProfileUniqueWhere"] | undefined
};
	["WorkMonthWithoutRemunerationProfileCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	year?: number | undefined,
	month?: number | undefined,
	hoursWorked?: number | undefined,
	billableHours?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["StaffCreateCashierEntityRelationInput"]: {
		connect?: GraphQLTypes["CashierUniqueWhere"] | undefined,
	create?: GraphQLTypes["CashierWithoutStaffCreateInput"] | undefined
};
	["CashierWithoutStaffCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StaffCreateInternalBuyerEntityRelationInput"]: {
		connect?: GraphQLTypes["InternalBuyerUniqueWhere"] | undefined,
	create?: GraphQLTypes["InternalBuyerWithoutStaffCreateInput"] | undefined
};
	["InternalBuyerWithoutStaffCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StaffCreateSalesManagerEntityRelationInput"]: {
		connect?: GraphQLTypes["SalesManagerUniqueWhere"] | undefined,
	create?: GraphQLTypes["SalesManagerWithoutStaffCreateInput"] | undefined
};
	["SalesManagerWithoutStaffCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	countries?: Array<GraphQLTypes["SalesManagerCreateCountriesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["SalesManagerCreateCountriesEntityRelationInput"]: {
		connect?: GraphQLTypes["CountryUniqueWhere"] | undefined,
	create?: GraphQLTypes["CountryCreateInput"] | undefined,
	alias?: string | undefined
};
	["StaffCreateCashierManagerEntityRelationInput"]: {
		connect?: GraphQLTypes["CashierManagerUniqueWhere"] | undefined,
	create?: GraphQLTypes["CashierManagerWithoutStaffCreateInput"] | undefined
};
	["CashierManagerWithoutStaffCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["VenueCreateEmployeeRolesEntityRelationInput"]: {
		connect?: GraphQLTypes["VenueEmployeeRoleUniqueWhere"] | undefined,
	create?: GraphQLTypes["VenueEmployeeRoleWithoutVenueCreateInput"] | undefined,
	alias?: string | undefined
};
	["VenueEmployeeRoleWithoutVenueCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	employeePrivileges?: GraphQLTypes["VenueEmployeeRoleCreateEmployeePrivilegesEntityRelationInput"] | undefined,
	role?: GraphQLTypes["VenueEmployeeRoleCreateRoleEntityRelationInput"] | undefined,
	getsTipsShare?: boolean | undefined,
	notesEnabled?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["VenueEmployeeRoleCreateEmployeePrivilegesEntityRelationInput"]: {
		connect?: GraphQLTypes["TimetablesEmployeePrivilegesUniqueWhere"] | undefined,
	create?: GraphQLTypes["TimetablesEmployeePrivilegesWithoutVenueEmployeeRoleCreateInput"] | undefined
};
	["TimetablesEmployeePrivilegesWithoutVenueEmployeeRoleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	read?: boolean | undefined,
	unassign?: boolean | undefined,
	assign?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["VenueEmployeeRoleCreateRoleEntityRelationInput"]: {
		connect?: GraphQLTypes["TimetableEmployeeRoleUniqueWhere"] | undefined,
	create?: GraphQLTypes["TimetableEmployeeRoleCreateInput"] | undefined
};
	["VenueCreatePointOfSaleApplicationDevicesEntityRelationInput"]: {
		connect?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined,
	create?: GraphQLTypes["PointOfSaleApplicationDeviceWithoutVenueCreateInput"] | undefined,
	alias?: string | undefined
};
	["PointOfSaleApplicationDeviceWithoutVenueCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	internalName?: string | undefined,
	note?: string | undefined,
	identificationCode?: GraphQLTypes["PointOfSaleApplicationDeviceCreateIdentificationCodeEntityRelationInput"] | undefined,
	identifier?: GraphQLTypes["PointOfSaleApplicationDeviceCreateIdentifierEntityRelationInput"] | undefined,
	terminal?: GraphQLTypes["PointOfSaleApplicationDeviceCreateTerminalEntityRelationInput"] | undefined,
	receiptPrinter?: GraphQLTypes["PointOfSaleApplicationDeviceCreateReceiptPrinterEntityRelationInput"] | undefined,
	ticketPrinters?: Array<GraphQLTypes["PointOfSaleApplicationDeviceCreateTicketPrintersEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleApplicationDeviceCreateIdentificationCodeEntityRelationInput"]: {
		connect?: GraphQLTypes["IdentificationCodeUniqueWhere"] | undefined,
	create?: GraphQLTypes["IdentificationCodeWithoutApplicationDevicesCreateInput"] | undefined
};
	["IdentificationCodeWithoutApplicationDevicesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	attempts?: Array<GraphQLTypes["IdentificationCodeCreateAttemptsEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["IdentificationCodeCreateLocalesEntityRelationInput"]> | undefined,
	internalName?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["IdentificationCodeCreateAttemptsEntityRelationInput"]: {
		connect?: GraphQLTypes["IdentificationAttemptUniqueWhere"] | undefined,
	create?: GraphQLTypes["IdentificationAttemptWithoutCodeCreateInput"] | undefined,
	alias?: string | undefined
};
	["IdentificationAttemptWithoutCodeCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	user?: GraphQLTypes["IdentificationAttemptCreateUserEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["IdentificationAttemptCreateUserEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserWithoutIdentificationAttemptsCreateInput"] | undefined
};
	["UserWithoutIdentificationAttemptsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	internalNote?: string | undefined,
	staff?: GraphQLTypes["UserCreateStaffEntityRelationInput"] | undefined,
	customer?: GraphQLTypes["UserCreateCustomerEntityRelationInput"] | undefined,
	tenantPersonId?: GraphQLTypes["UUID"] | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	devices?: Array<GraphQLTypes["UserCreateDevicesEntityRelationInput"]> | undefined,
	verifiedAt?: GraphQLTypes["DateTime"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	deletionRequestedAt?: GraphQLTypes["DateTime"] | undefined,
	deletionExpectedAt?: GraphQLTypes["DateTime"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	meta?: GraphQLTypes["UserCreateMetaEntityRelationInput"] | undefined,
	roles?: GraphQLTypes["UserCreateRolesEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserCreateDevicesEntityRelationInput"]: {
		connect?: GraphQLTypes["UserDeviceUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserDeviceWithoutUserCreateInput"] | undefined,
	alias?: string | undefined
};
	["UserDeviceWithoutUserCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	lastActiveAt?: GraphQLTypes["DateTime"] | undefined,
	platform?: string | undefined,
	deviceId?: string | undefined,
	notificationsEnabled?: boolean | undefined,
	appVersion?: string | undefined,
	osVersion?: string | undefined,
	apiVersion?: string | undefined,
	anonymousSession?: GraphQLTypes["UserDeviceCreateAnonymousSessionEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserDeviceCreateAnonymousSessionEntityRelationInput"]: {
		connect?: GraphQLTypes["AnonymousSessionUniqueWhere"] | undefined,
	create?: GraphQLTypes["AnonymousSessionWithoutDevicesCreateInput"] | undefined
};
	["AnonymousSessionWithoutDevicesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	lastActiveAt?: GraphQLTypes["DateTime"] | undefined,
	anonymousSessionKey?: string | undefined,
	email?: string | undefined,
	name?: string | undefined,
	internalNote?: string | undefined,
	customer?: GraphQLTypes["AnonymousSessionCreateCustomerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["AnonymousSessionCreateCustomerEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerWithoutAnonymousSessionCreateInput"] | undefined
};
	["CustomerWithoutAnonymousSessionCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	addresses?: Array<GraphQLTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerCreateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerCreateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerCreatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerCreateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerCreateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerCreateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerCreateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerCreateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerCreateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerCreateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreateInvoicesEntityRelationInput"]: {
		connect?: GraphQLTypes["InvoiceUniqueWhere"] | undefined,
	create?: GraphQLTypes["InvoiceWithoutCustomerCreateInput"] | undefined,
	alias?: string | undefined
};
	["InvoiceWithoutCustomerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	publicKey?: string | undefined,
	fakturoidId?: string | undefined,
	fakturoidData?: string | undefined,
	legacyUrl?: string | undefined,
	orderPayments?: Array<GraphQLTypes["InvoiceCreateOrderPaymentsEntityRelationInput"]> | undefined,
	address?: GraphQLTypes["InvoiceCreateAddressEntityRelationInput"] | undefined,
	publicUrl?: string | undefined,
	billingSubject?: GraphQLTypes["InvoiceCreateBillingSubjectEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InvoiceCreateOrderPaymentsEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderPaymentUniqueWhere"] | undefined,
	create?: GraphQLTypes["OrderPaymentWithoutInvoiceCreateInput"] | undefined,
	alias?: string | undefined
};
	["OrderPaymentWithoutInvoiceCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	data?: GraphQLTypes["Json"] | undefined,
	paymentCents?: number | undefined,
	method?: GraphQLTypes["OrderPaymentCreateMethodEntityRelationInput"] | undefined,
	failedAt?: GraphQLTypes["DateTime"] | undefined,
	state?: GraphQLTypes["OrderPaymentState"] | undefined,
	approvedAt?: GraphQLTypes["DateTime"] | undefined,
	events?: Array<GraphQLTypes["OrderPaymentCreateEventsEntityRelationInput"]> | undefined,
	order?: GraphQLTypes["OrderPaymentCreateOrderEntityRelationInput"] | undefined,
	walletType?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	publicReceiptUrl?: string | undefined,
	priceCents?: number | undefined,
	vatRate?: GraphQLTypes["OrderPaymentCreateVatRateEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["OrderPaymentCreateMetaEntityRelationInput"] | undefined,
	otherCurrencyPriceCents?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderPaymentCreateMethodEntityRelationInput"]: {
		connect?: GraphQLTypes["PaymentMethodUniqueWhere"] | undefined,
	create?: GraphQLTypes["PaymentMethodCreateInput"] | undefined
};
	["OrderPaymentCreateEventsEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderEventUniqueWhere"] | undefined,
	create?: GraphQLTypes["OrderEventWithoutPaymentCreateInput"] | undefined,
	alias?: string | undefined
};
	["OrderEventWithoutPaymentCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: string | undefined,
	data?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	order?: GraphQLTypes["OrderEventCreateOrderEntityRelationInput"] | undefined,
	delivery?: GraphQLTypes["OrderEventCreateDeliveryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderEventCreateOrderEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	create?: GraphQLTypes["OrderWithoutEventsCreateInput"] | undefined
};
	["OrderWithoutEventsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	state?: GraphQLTypes["OrderState"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	canceledAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	customer?: GraphQLTypes["OrderCreateCustomerEntityRelationInput"] | undefined,
	channel?: GraphQLTypes["OrderCreateChannelEntityRelationInput"] | undefined,
	discounts?: Array<GraphQLTypes["OrderCreateDiscountsEntityRelationInput"]> | undefined,
	delivery?: GraphQLTypes["OrderCreateDeliveryEntityRelationInput"] | undefined,
	items?: Array<GraphQLTypes["OrderCreateItemsEntityRelationInput"]> | undefined,
	internalNote?: string | undefined,
	cart?: GraphQLTypes["OrderCreateCartEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddress?: GraphQLTypes["OrderCreateBillingAddressEntityRelationInput"] | undefined,
	priceLines?: Array<GraphQLTypes["OrderCreatePriceLinesEntityRelationInput"]> | undefined,
	payments?: Array<GraphQLTypes["OrderCreatePaymentsEntityRelationInput"]> | undefined,
	seq?: number | undefined,
	billingSubject?: GraphQLTypes["OrderCreateBillingSubjectEntityRelationInput"] | undefined,
	summary?: GraphQLTypes["OrderCreateSummaryEntityRelationInput"] | undefined,
	doubleshotLegacyId?: string | undefined,
	gratuity?: GraphQLTypes["OrderCreateGratuityEntityRelationInput"] | undefined,
	venue?: GraphQLTypes["OrderCreateVenueEntityRelationInput"] | undefined,
	fulfillmentNote?: string | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["OrderCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	doubleshotTotalWeightGrams?: number | undefined,
	doubleShotLegacyNumber?: string | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	doubleshotAdminUrl?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderCreateDeliveryEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderDeliveryUniqueWhere"] | undefined,
	create?: GraphQLTypes["OrderDeliveryWithoutOrderCreateInput"] | undefined
};
	["OrderDeliveryWithoutOrderCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	priceCents?: number | undefined,
	deliveredAt?: GraphQLTypes["DateTime"] | undefined,
	method?: GraphQLTypes["OrderDeliveryCreateMethodEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["OrderDeliveryCreateVatRateEntityRelationInput"] | undefined,
	expectedAt?: GraphQLTypes["DateTime"] | undefined,
	state?: GraphQLTypes["OrderDeliveryState"] | undefined,
	loadingDurationHours?: number | undefined,
	dispatchAt?: GraphQLTypes["DateTime"] | undefined,
	duration?: string | undefined,
	window?: string | undefined,
	expectedEndAt?: GraphQLTypes["DateTime"] | undefined,
	processingAt?: GraphQLTypes["DateTime"] | undefined,
	deliveringAt?: GraphQLTypes["DateTime"] | undefined,
	failedAt?: GraphQLTypes["DateTime"] | undefined,
	internalNote?: string | undefined,
	deliveryWaypoint?: GraphQLTypes["OrderDeliveryCreateDeliveryWaypointEntityRelationInput"] | undefined,
	events?: Array<GraphQLTypes["OrderDeliveryCreateEventsEntityRelationInput"]> | undefined,
	prepareAt?: GraphQLTypes["DateTime"] | undefined,
	liftagoRide?: GraphQLTypes["OrderDeliveryCreateLiftagoRideEntityRelationInput"] | undefined,
	pickedAt?: GraphQLTypes["DateTime"] | undefined,
	address?: GraphQLTypes["OrderDeliveryCreateAddressEntityRelationInput"] | undefined,
	trackingCode?: string | undefined,
	woltDriveDelivery?: GraphQLTypes["OrderDeliveryCreateWoltDriveDeliveryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderDeliveryCreateVatRateEntityRelationInput"]: {
		connect?: GraphQLTypes["VatRateUniqueWhere"] | undefined,
	create?: GraphQLTypes["VatRateCreateInput"] | undefined
};
	["OrderDeliveryCreateDeliveryWaypointEntityRelationInput"]: {
		connect?: GraphQLTypes["DeliveryWaypointUniqueWhere"] | undefined,
	create?: GraphQLTypes["DeliveryWaypointWithoutDeliveryCreateInput"] | undefined
};
	["DeliveryWaypointWithoutDeliveryCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	estimatedArrival?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	route?: GraphQLTypes["DeliveryWaypointCreateRouteEntityRelationInput"] | undefined,
	sortingOrder?: number | undefined,
	estimatedDistance?: number | undefined,
	estimatedDuration?: number | undefined,
	originDeparture?: GraphQLTypes["DateTime"] | undefined,
	originAddress?: string | undefined,
	transitMode?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryWaypointCreateRouteEntityRelationInput"]: {
		connect?: GraphQLTypes["DeliveryRouteUniqueWhere"] | undefined,
	create?: GraphQLTypes["DeliveryRouteWithoutWaypointsCreateInput"] | undefined
};
	["DeliveryRouteWithoutWaypointsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	courier?: GraphQLTypes["DeliveryRouteCreateCourierEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	dispatchAt?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryRouteCreateCourierEntityRelationInput"]: {
		connect?: GraphQLTypes["CourierUniqueWhere"] | undefined,
	create?: GraphQLTypes["CourierWithoutRoutesCreateInput"] | undefined
};
	["CourierWithoutRoutesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	staff?: GraphQLTypes["CourierCreateStaffEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	deliveryMethods?: Array<GraphQLTypes["CourierCreateDeliveryMethodsEntityRelationInput"]> | undefined,
	showInPicker?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["CourierCreateDeliveryMethodsEntityRelationInput"]: {
		connect?: GraphQLTypes["DeliveryMethodUniqueWhere"] | undefined,
	create?: GraphQLTypes["DeliveryMethodWithoutCourierHandlersCreateInput"] | undefined,
	alias?: string | undefined
};
	["DeliveryMethodWithoutCourierHandlersCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	enabled?: boolean | undefined,
	paymentMethods?: Array<GraphQLTypes["DeliveryMethodCreatePaymentMethodsEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	requireDeliveryAddress?: boolean | undefined,
	suitableForDeliveryZones?: Array<GraphQLTypes["DeliveryMethodCreateSuitableForDeliveryZonesEntityRelationInput"]> | undefined,
	channels?: Array<GraphQLTypes["DeliveryMethodCreateChannelsEntityRelationInput"]> | undefined,
	enableDeliveryTracking?: boolean | undefined,
	locales?: Array<GraphQLTypes["DeliveryMethodCreateLocalesEntityRelationInput"]> | undefined,
	timelinePreset?: GraphQLTypes["DeliveryMethodCreateTimelinePresetEntityRelationInput"] | undefined,
	woltDriveVenueId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryMethodCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["DeliveryMethodLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["DeliveryMethodLocaleWithoutRootCreateInput"] | undefined,
	alias?: string | undefined
};
	["DeliveryMethodLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	description?: string | undefined,
	trackingCodeUrlTemplate?: string | undefined,
	processingTitle?: string | undefined,
	processingText?: string | undefined,
	processingIconUrl?: string | undefined,
	dispatchedTitle?: string | undefined,
	dispatchedText?: string | undefined,
	dispatchedIconUrl?: string | undefined,
	fulfilledTitle?: string | undefined,
	fulfilledText?: string | undefined,
	fulfilledIconUrl?: string | undefined,
	locale?: GraphQLTypes["DeliveryMethodLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryMethodLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutDeliveryMethodsCreateInput"] | undefined
};
	["LocaleWithoutDeliveryMethodsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	businessCategories?: Array<GraphQLTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleCreateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleCreateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateProductPackingsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductPackingLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductPackingLocaleWithoutLocaleCreateInput"] | undefined,
	alias?: string | undefined
};
	["ProductPackingLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	shortName?: string | undefined,
	description?: string | undefined,
	root?: GraphQLTypes["ProductPackingLocaleCreateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductPackingLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductPackingUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductPackingWithoutLocalesCreateInput"] | undefined
};
	["ProductPackingWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	image?: GraphQLTypes["ProductPackingCreateImageEntityRelationInput"] | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	volumeMl?: number | undefined,
	icon?: GraphQLTypes["ProductPackingCreateIconEntityRelationInput"] | undefined,
	shortName?: string | undefined,
	preparedPackingQuantities?: Array<GraphQLTypes["ProductPackingCreatePreparedPackingQuantitiesEntityRelationInput"]> | undefined,
	isPackedInCardboard?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductPackingCreatePreparedPackingQuantitiesEntityRelationInput"]: {
		connect?: GraphQLTypes["PreparedPackingQuantityUniqueWhere"] | undefined,
	create?: GraphQLTypes["PreparedPackingQuantityWithoutPackingCreateInput"] | undefined,
	alias?: string | undefined
};
	["PreparedPackingQuantityWithoutPackingCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	date?: GraphQLTypes["Date"] | undefined,
	quantity?: number | undefined,
	recipe?: GraphQLTypes["PreparedPackingQuantityCreateRecipeEntityRelationInput"] | undefined,
	packedInCardboard?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PreparedPackingQuantityCreateRecipeEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductRecipeUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductRecipeCreateInput"] | undefined
};
	["ProductRecipeCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	products?: Array<GraphQLTypes["ProductRecipeCreateProductsEntityRelationInput"]> | undefined,
	internalNote?: string | undefined,
	color?: string | undefined,
	image?: GraphQLTypes["ProductRecipeCreateImageEntityRelationInput"] | undefined,
	icon?: GraphQLTypes["ProductRecipeCreateIconEntityRelationInput"] | undefined,
	ingredients?: Array<GraphQLTypes["ProductRecipeCreateIngredientsEntityRelationInput"]> | undefined,
	needsPrepping?: boolean | undefined,
	locales?: Array<GraphQLTypes["ProductRecipeCreateLocalesEntityRelationInput"]> | undefined,
	gutTuning?: number | undefined,
	freshingContainer?: GraphQLTypes["ProductRecipeCreateFreshingContainerEntityRelationInput"] | undefined,
	description?: string | undefined,
	nutritionFacts?: GraphQLTypes["ProductRecipeCreateNutritionFactsEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductRecipeCreateProductsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductWithoutRecipeCreateInput"] | undefined,
	alias?: string | undefined
};
	["ProductWithoutRecipeCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	priceCents?: number | undefined,
	notDiscountable?: boolean | undefined,
	packing?: GraphQLTypes["ProductCreatePackingEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["ProductCreateTagsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["ProductCreateCategoriesEntityRelationInput"]> | undefined,
	vatRate?: GraphQLTypes["ProductCreateVatRateEntityRelationInput"] | undefined,
	stocks?: Array<GraphQLTypes["ProductCreateStocksEntityRelationInput"]> | undefined,
	groupPrices?: Array<GraphQLTypes["ProductCreateGroupPricesEntityRelationInput"]> | undefined,
	image?: GraphQLTypes["ProductCreateImageEntityRelationInput"] | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	cartItems?: Array<GraphQLTypes["ProductCreateCartItemsEntityRelationInput"]> | undefined,
	availability?: GraphQLTypes["ProductAvailability"] | undefined,
	order?: number | undefined,
	manager?: GraphQLTypes["ProductCreateManagerEntityRelationInput"] | undefined,
	orderItems?: Array<GraphQLTypes["ProductCreateOrderItemsEntityRelationInput"]> | undefined,
	maximumQuantityPerOrder?: number | undefined,
	inheritedCategories?: Array<GraphQLTypes["ProductCreateInheritedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["ProductCreateDeliveryZonesEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["ProductCreateLocalesEntityRelationInput"]> | undefined,
	archivedAt?: GraphQLTypes["DateTime"] | undefined,
	customerPrices?: Array<GraphQLTypes["ProductCreateCustomerPricesEntityRelationInput"]> | undefined,
	virtualProduct?: GraphQLTypes["ProductCreateVirtualProductEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["ProductCreateMetaEntityRelationInput"] | undefined,
	page?: GraphQLTypes["ProductCreatePageEntityRelationInput"] | undefined,
	salesDays?: Array<GraphQLTypes["ProductCreateSalesDaysEntityRelationInput"]> | undefined,
	salesWeeks?: Array<GraphQLTypes["ProductCreateSalesWeeksEntityRelationInput"]> | undefined,
	salesMonths?: Array<GraphQLTypes["ProductCreateSalesMonthsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["ProductCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	hasSubscription?: boolean | undefined,
	pointOfSaleTileColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductLocaleWithoutRootCreateInput"] | undefined,
	alias?: string | undefined
};
	["ProductLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	description?: string | undefined,
	locale?: GraphQLTypes["ProductLocaleCreateLocaleEntityRelationInput"] | undefined,
	featureList?: GraphQLTypes["ProductLocaleCreateFeatureListEntityRelationInput"] | undefined,
	printableName?: string | undefined,
	firstSticker?: string | undefined,
	secondSticker?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutProductsCreateInput"] | undefined
};
	["LocaleWithoutProductsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	businessCategories?: Array<GraphQLTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleCreateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateProductRecipesEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductRecipeLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductRecipeLocaleWithoutLocaleCreateInput"] | undefined,
	alias?: string | undefined
};
	["ProductRecipeLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	root?: GraphQLTypes["ProductRecipeLocaleCreateRootEntityRelationInput"] | undefined,
	description?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductRecipeLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductRecipeUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductRecipeWithoutLocalesCreateInput"] | undefined
};
	["ProductRecipeWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	products?: Array<GraphQLTypes["ProductRecipeCreateProductsEntityRelationInput"]> | undefined,
	internalNote?: string | undefined,
	color?: string | undefined,
	image?: GraphQLTypes["ProductRecipeCreateImageEntityRelationInput"] | undefined,
	icon?: GraphQLTypes["ProductRecipeCreateIconEntityRelationInput"] | undefined,
	ingredients?: Array<GraphQLTypes["ProductRecipeCreateIngredientsEntityRelationInput"]> | undefined,
	needsPrepping?: boolean | undefined,
	gutTuning?: number | undefined,
	freshingContainer?: GraphQLTypes["ProductRecipeCreateFreshingContainerEntityRelationInput"] | undefined,
	description?: string | undefined,
	nutritionFacts?: GraphQLTypes["ProductRecipeCreateNutritionFactsEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductRecipeCreateFreshingContainerEntityRelationInput"]: {
		connect?: GraphQLTypes["FreshingContainerUniqueWhere"] | undefined,
	create?: GraphQLTypes["FreshingContainerCreateInput"] | undefined
};
	["ProductRecipeCreateNutritionFactsEntityRelationInput"]: {
		connect?: GraphQLTypes["NutritionFactsUniqueWhere"] | undefined,
	create?: GraphQLTypes["NutritionFactsCreateInput"] | undefined
};
	["NutritionFactsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	energyKiloJoule?: number | undefined,
	energyKiloCalorie?: number | undefined,
	fatsGrams?: number | undefined,
	fatsOfWhichSaturatedGrams?: number | undefined,
	carbohydrateGrams?: number | undefined,
	carbohydrateOfWhichSugarsGrams?: number | undefined,
	proteinGrams?: number | undefined,
	fibreGrams?: number | undefined,
	saltGrams?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]: {
		connect?: GraphQLTypes["PointOfSaleCategoryLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["PointOfSaleCategoryLocaleWithoutLocaleCreateInput"] | undefined,
	alias?: string | undefined
};
	["PointOfSaleCategoryLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	root?: GraphQLTypes["PointOfSaleCategoryLocaleCreateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleCategoryLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["PointOfSaleCategoryUniqueWhere"] | undefined,
	create?: GraphQLTypes["PointOfSaleCategoryWithoutLocalesCreateInput"] | undefined
};
	["PointOfSaleCategoryWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	slug?: string | undefined,
	products?: Array<GraphQLTypes["PointOfSaleCategoryCreateProductsEntityRelationInput"]> | undefined,
	category?: GraphQLTypes["PointOfSaleCategoryCreateCategoryEntityRelationInput"] | undefined,
	venue?: GraphQLTypes["PointOfSaleCategoryCreateVenueEntityRelationInput"] | undefined,
	ticketPrinters?: Array<GraphQLTypes["PointOfSaleCategoryCreateTicketPrintersEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleCategoryCreateProductsEntityRelationInput"]: {
		connect?: GraphQLTypes["PointOfSaleCategoryProductUniqueWhere"] | undefined,
	create?: GraphQLTypes["PointOfSaleCategoryProductWithoutCategoryCreateInput"] | undefined,
	alias?: string | undefined
};
	["PointOfSaleCategoryProductWithoutCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	product?: GraphQLTypes["PointOfSaleCategoryProductCreateProductEntityRelationInput"] | undefined,
	locales?: Array<GraphQLTypes["PointOfSaleCategoryProductCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleCategoryProductCreateProductEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductCreateInput"] | undefined
};
	["ProductCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	priceCents?: number | undefined,
	notDiscountable?: boolean | undefined,
	packing?: GraphQLTypes["ProductCreatePackingEntityRelationInput"] | undefined,
	recipe?: GraphQLTypes["ProductCreateRecipeEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["ProductCreateTagsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["ProductCreateCategoriesEntityRelationInput"]> | undefined,
	vatRate?: GraphQLTypes["ProductCreateVatRateEntityRelationInput"] | undefined,
	stocks?: Array<GraphQLTypes["ProductCreateStocksEntityRelationInput"]> | undefined,
	groupPrices?: Array<GraphQLTypes["ProductCreateGroupPricesEntityRelationInput"]> | undefined,
	image?: GraphQLTypes["ProductCreateImageEntityRelationInput"] | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	cartItems?: Array<GraphQLTypes["ProductCreateCartItemsEntityRelationInput"]> | undefined,
	availability?: GraphQLTypes["ProductAvailability"] | undefined,
	order?: number | undefined,
	manager?: GraphQLTypes["ProductCreateManagerEntityRelationInput"] | undefined,
	orderItems?: Array<GraphQLTypes["ProductCreateOrderItemsEntityRelationInput"]> | undefined,
	maximumQuantityPerOrder?: number | undefined,
	inheritedCategories?: Array<GraphQLTypes["ProductCreateInheritedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["ProductCreateDeliveryZonesEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["ProductCreateLocalesEntityRelationInput"]> | undefined,
	archivedAt?: GraphQLTypes["DateTime"] | undefined,
	customerPrices?: Array<GraphQLTypes["ProductCreateCustomerPricesEntityRelationInput"]> | undefined,
	virtualProduct?: GraphQLTypes["ProductCreateVirtualProductEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["ProductCreateMetaEntityRelationInput"] | undefined,
	page?: GraphQLTypes["ProductCreatePageEntityRelationInput"] | undefined,
	salesDays?: Array<GraphQLTypes["ProductCreateSalesDaysEntityRelationInput"]> | undefined,
	salesWeeks?: Array<GraphQLTypes["ProductCreateSalesWeeksEntityRelationInput"]> | undefined,
	salesMonths?: Array<GraphQLTypes["ProductCreateSalesMonthsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["ProductCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	hasSubscription?: boolean | undefined,
	pointOfSaleTileColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCreateCustomerPricesEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductCustomerPriceUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductCreateVirtualProductEntityRelationInput"]: {
		connect?: GraphQLTypes["VirtualProductUniqueWhere"] | undefined,
	create?: GraphQLTypes["VirtualProductWithoutProductCreateInput"] | undefined
};
	["VirtualProductWithoutProductCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["VirtualProductType"] | undefined,
	voucherCreditCents?: number | undefined,
	physicalRepresentation?: GraphQLTypes["VirtualProductPhysicalRepresentationType"] | undefined,
	recipientEmail?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCreateMetaEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductMetadataUniqueWhere"] | undefined
};
	["ProductCreatePageEntityRelationInput"]: {
		connect?: GraphQLTypes["PageUniqueWhere"] | undefined,
	create?: GraphQLTypes["PageCreateInput"] | undefined
};
	["PageCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locales?: Array<GraphQLTypes["PageCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PageCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["PageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["PageLocaleWithoutRootCreateInput"] | undefined,
	alias?: string | undefined
};
	["PageLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	link?: GraphQLTypes["PageLocaleCreateLinkEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["PageLocaleCreateLocaleEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["PageLocaleCreateSeoEntityRelationInput"] | undefined,
	content?: GraphQLTypes["PageLocaleCreateContentEntityRelationInput"] | undefined,
	cover?: GraphQLTypes["PageLocaleCreateCoverEntityRelationInput"] | undefined,
	theme?: GraphQLTypes["PageTheme"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PageLocaleCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeoCreateInput"] | undefined
};
	["SeoCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	description?: string | undefined,
	ogTitle?: string | undefined,
	ogDescription?: string | undefined,
	ogImage?: GraphQLTypes["SeoCreateOgImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeoCreateOgImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["PageLocaleCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined
};
	["PageLocaleCreateCoverEntityRelationInput"]: {
		connect?: GraphQLTypes["CoverUniqueWhere"] | undefined,
	create?: GraphQLTypes["CoverCreateInput"] | undefined
};
	["ProductCreateSalesDaysEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductSalesDayUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductCreateSalesWeeksEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductSalesWeekUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductCreateSalesMonthsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductSalesMonthUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductCreateFulfillmentNotesEntityRelationInput"]: {
		connect?: GraphQLTypes["FulfillmentNoteUniqueWhere"] | undefined,
	create?: GraphQLTypes["FulfillmentNoteWithoutProductsCreateInput"] | undefined,
	alias?: string | undefined
};
	["FulfillmentNoteWithoutProductsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	note?: string | undefined,
	tags?: Array<GraphQLTypes["FulfillmentNoteCreateTagsEntityRelationInput"]> | undefined,
	venues?: Array<GraphQLTypes["FulfillmentNoteCreateVenuesEntityRelationInput"]> | undefined,
	cartItems?: Array<GraphQLTypes["FulfillmentNoteCreateCartItemsEntityRelationInput"]> | undefined,
	orderItems?: Array<GraphQLTypes["FulfillmentNoteCreateOrderItemsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["FulfillmentNoteCreateOrdersEntityRelationInput"]> | undefined,
	highlight?: boolean | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	emoji?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["FulfillmentNoteCreateTagsEntityRelationInput"]: {
		connect?: GraphQLTypes["TagUniqueWhere"] | undefined,
	create?: GraphQLTypes["TagWithoutFulfillmentNotesCreateInput"] | undefined,
	alias?: string | undefined
};
	["TagWithoutFulfillmentNotesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	customers?: Array<GraphQLTypes["TagCreateCustomersEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["TagCreateProductsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["TagCreateCategoriesEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	addTagsOnRegistration?: Array<GraphQLTypes["TagCreateAddTagsOnRegistrationEntityRelationInput"]> | undefined,
	nestedCategories?: Array<GraphQLTypes["TagCreateNestedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["TagCreateDeliveryZonesEntityRelationInput"]> | undefined,
	publicInChannels?: Array<GraphQLTypes["TagCreatePublicInChannelsEntityRelationInput"]> | undefined,
	allowChannelPayments?: Array<GraphQLTypes["TagCreateAllowChannelPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["FulfillmentNoteCreateVenuesEntityRelationInput"]: {
		connect?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	create?: GraphQLTypes["VenueWithoutFulfillmentNotesCreateInput"] | undefined,
	alias?: string | undefined
};
	["VenueWithoutFulfillmentNotesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	deadlineTemplate?: GraphQLTypes["VenueCreateDeadlineTemplateEntityRelationInput"] | undefined,
	timetableDays?: Array<GraphQLTypes["VenueCreateTimetableDaysEntityRelationInput"]> | undefined,
	timetableTemplates?: Array<GraphQLTypes["VenueCreateTimetableTemplatesEntityRelationInput"]> | undefined,
	staffMembers?: Array<GraphQLTypes["VenueCreateStaffMembersEntityRelationInput"]> | undefined,
	employeeRoles?: Array<GraphQLTypes["VenueCreateEmployeeRolesEntityRelationInput"]> | undefined,
	pointOfSaleApplicationDevices?: Array<GraphQLTypes["VenueCreatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined,
	pointOfSaleTerminals?: Array<GraphQLTypes["VenueCreatePointOfSaleTerminalsEntityRelationInput"]> | undefined,
	pointOfSalePrinters?: Array<GraphQLTypes["VenueCreatePointOfSalePrintersEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["VenueCreateOrdersEntityRelationInput"]> | undefined,
	areas?: Array<GraphQLTypes["VenueCreateAreasEntityRelationInput"]> | undefined,
	enabledUnassignReasons?: Array<GraphQLTypes["VenueCreateEnabledUnassignReasonsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["VenueCreateCategoriesEntityRelationInput"]> | undefined,
	channels?: Array<GraphQLTypes["VenueCreateChannelsEntityRelationInput"]> | undefined,
	address?: string | undefined,
	pointOfSalePngBase64ReceiptLogo?: string | undefined,
	pointOfSaleInitialView?: GraphQLTypes["PointOfSaleInitialView"] | undefined,
	pointOfSalePreferPrintReceipt?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["VenueCreateTimetableTemplatesEntityRelationInput"]: {
		connect?: GraphQLTypes["TimetableTemplateUniqueWhere"] | undefined,
	create?: GraphQLTypes["TimetableTemplateWithoutVenueCreateInput"] | undefined,
	alias?: string | undefined
};
	["TimetableTemplateWithoutVenueCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	startDate?: GraphQLTypes["Date"] | undefined,
	period?: number | undefined,
	slots?: number | undefined,
	position?: GraphQLTypes["TimetableTemplateCreatePositionEntityRelationInput"] | undefined,
	staffOptions?: Array<GraphQLTypes["TimetableTemplateCreateStaffOptionsEntityRelationInput"]> | undefined,
	internalName?: string | undefined,
	employeeRole?: GraphQLTypes["TimetableTemplateCreateEmployeeRoleEntityRelationInput"] | undefined,
	workdaysOnly?: boolean | undefined,
	monday?: boolean | undefined,
	tuesday?: boolean | undefined,
	wednesday?: boolean | undefined,
	thursday?: boolean | undefined,
	friday?: boolean | undefined,
	saturday?: boolean | undefined,
	sunday?: boolean | undefined,
	type?: GraphQLTypes["TemplateType"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableTemplateCreateEmployeeRoleEntityRelationInput"]: {
		connect?: GraphQLTypes["TimetableEmployeeRoleUniqueWhere"] | undefined,
	create?: GraphQLTypes["TimetableEmployeeRoleWithoutTimetableTemplatesCreateInput"] | undefined
};
	["TimetableEmployeeRoleWithoutTimetableTemplatesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	shiftGroups?: Array<GraphQLTypes["TimetableEmployeeRoleCreateShiftGroupsEntityRelationInput"]> | undefined,
	shiftsProfiles?: Array<GraphQLTypes["TimetableEmployeeRoleCreateShiftsProfilesEntityRelationInput"]> | undefined,
	shiftsManagers?: Array<GraphQLTypes["TimetableEmployeeRoleCreateShiftsManagersEntityRelationInput"]> | undefined,
	name?: string | undefined,
	color?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["VenueCreatePointOfSaleTerminalsEntityRelationInput"]: {
		connect?: GraphQLTypes["PointOfSaleTerminalUniqueWhere"] | undefined,
	create?: GraphQLTypes["PointOfSaleTerminalWithoutVenueCreateInput"] | undefined,
	alias?: string | undefined
};
	["PointOfSaleTerminalWithoutVenueCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	internalName?: string | undefined,
	note?: string | undefined,
	applicationDevices?: Array<GraphQLTypes["PointOfSaleTerminalCreateApplicationDevicesEntityRelationInput"]> | undefined,
	ipAddress?: string | undefined,
	port?: number | undefined,
	type?: GraphQLTypes["PointOfSaleTerminalType"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleTerminalCreateApplicationDevicesEntityRelationInput"]: {
		connect?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined,
	create?: GraphQLTypes["PointOfSaleApplicationDeviceWithoutTerminalCreateInput"] | undefined,
	alias?: string | undefined
};
	["PointOfSaleApplicationDeviceWithoutTerminalCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	internalName?: string | undefined,
	note?: string | undefined,
	venue?: GraphQLTypes["PointOfSaleApplicationDeviceCreateVenueEntityRelationInput"] | undefined,
	identificationCode?: GraphQLTypes["PointOfSaleApplicationDeviceCreateIdentificationCodeEntityRelationInput"] | undefined,
	identifier?: GraphQLTypes["PointOfSaleApplicationDeviceCreateIdentifierEntityRelationInput"] | undefined,
	receiptPrinter?: GraphQLTypes["PointOfSaleApplicationDeviceCreateReceiptPrinterEntityRelationInput"] | undefined,
	ticketPrinters?: Array<GraphQLTypes["PointOfSaleApplicationDeviceCreateTicketPrintersEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleApplicationDeviceCreateVenueEntityRelationInput"]: {
		connect?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	create?: GraphQLTypes["VenueWithoutPointOfSaleApplicationDevicesCreateInput"] | undefined
};
	["VenueWithoutPointOfSaleApplicationDevicesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	deadlineTemplate?: GraphQLTypes["VenueCreateDeadlineTemplateEntityRelationInput"] | undefined,
	timetableDays?: Array<GraphQLTypes["VenueCreateTimetableDaysEntityRelationInput"]> | undefined,
	timetableTemplates?: Array<GraphQLTypes["VenueCreateTimetableTemplatesEntityRelationInput"]> | undefined,
	staffMembers?: Array<GraphQLTypes["VenueCreateStaffMembersEntityRelationInput"]> | undefined,
	employeeRoles?: Array<GraphQLTypes["VenueCreateEmployeeRolesEntityRelationInput"]> | undefined,
	pointOfSaleTerminals?: Array<GraphQLTypes["VenueCreatePointOfSaleTerminalsEntityRelationInput"]> | undefined,
	pointOfSalePrinters?: Array<GraphQLTypes["VenueCreatePointOfSalePrintersEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["VenueCreateOrdersEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["VenueCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	areas?: Array<GraphQLTypes["VenueCreateAreasEntityRelationInput"]> | undefined,
	enabledUnassignReasons?: Array<GraphQLTypes["VenueCreateEnabledUnassignReasonsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["VenueCreateCategoriesEntityRelationInput"]> | undefined,
	channels?: Array<GraphQLTypes["VenueCreateChannelsEntityRelationInput"]> | undefined,
	address?: string | undefined,
	pointOfSalePngBase64ReceiptLogo?: string | undefined,
	pointOfSaleInitialView?: GraphQLTypes["PointOfSaleInitialView"] | undefined,
	pointOfSalePreferPrintReceipt?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["VenueCreatePointOfSalePrintersEntityRelationInput"]: {
		connect?: GraphQLTypes["PointOfSalePrinterUniqueWhere"] | undefined,
	create?: GraphQLTypes["PointOfSalePrinterWithoutVenueCreateInput"] | undefined,
	alias?: string | undefined
};
	["PointOfSalePrinterWithoutVenueCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	internalName?: string | undefined,
	note?: string | undefined,
	ipAddress?: string | undefined,
	applicationDevicesReceipt?: Array<GraphQLTypes["PointOfSalePrinterCreateApplicationDevicesReceiptEntityRelationInput"]> | undefined,
	applicationDevicesTicket?: Array<GraphQLTypes["PointOfSalePrinterCreateApplicationDevicesTicketEntityRelationInput"]> | undefined,
	ticketCategories?: Array<GraphQLTypes["PointOfSalePrinterCreateTicketCategoriesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSalePrinterCreateApplicationDevicesReceiptEntityRelationInput"]: {
		connect?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined,
	create?: GraphQLTypes["PointOfSaleApplicationDeviceWithoutReceiptPrinterCreateInput"] | undefined,
	alias?: string | undefined
};
	["PointOfSaleApplicationDeviceWithoutReceiptPrinterCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	internalName?: string | undefined,
	note?: string | undefined,
	venue?: GraphQLTypes["PointOfSaleApplicationDeviceCreateVenueEntityRelationInput"] | undefined,
	identificationCode?: GraphQLTypes["PointOfSaleApplicationDeviceCreateIdentificationCodeEntityRelationInput"] | undefined,
	identifier?: GraphQLTypes["PointOfSaleApplicationDeviceCreateIdentifierEntityRelationInput"] | undefined,
	terminal?: GraphQLTypes["PointOfSaleApplicationDeviceCreateTerminalEntityRelationInput"] | undefined,
	ticketPrinters?: Array<GraphQLTypes["PointOfSaleApplicationDeviceCreateTicketPrintersEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleApplicationDeviceCreateIdentifierEntityRelationInput"]: {
		connect?: GraphQLTypes["DeviceIdentifierUniqueWhere"] | undefined,
	create?: GraphQLTypes["DeviceIdentifierWithoutDeviceCreateInput"] | undefined
};
	["DeviceIdentifierWithoutDeviceCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	internalName?: string | undefined,
	updatedAt?: GraphQLTypes["DateTime"] | undefined,
	platform?: string | undefined,
	resolution?: string | undefined,
	devicePixelRatio?: number | undefined,
	updatedByUser?: GraphQLTypes["DeviceIdentifierCreateUpdatedByUserEntityRelationInput"] | undefined,
	identifier?: string | undefined,
	applicationVersionIdentifier?: string | undefined,
	lastPointOfSaleSynchronizationErrorRawDetails?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeviceIdentifierCreateUpdatedByUserEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserCreateInput"] | undefined
};
	["UserCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	internalNote?: string | undefined,
	staff?: GraphQLTypes["UserCreateStaffEntityRelationInput"] | undefined,
	customer?: GraphQLTypes["UserCreateCustomerEntityRelationInput"] | undefined,
	tenantPersonId?: GraphQLTypes["UUID"] | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	devices?: Array<GraphQLTypes["UserCreateDevicesEntityRelationInput"]> | undefined,
	verifiedAt?: GraphQLTypes["DateTime"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	deletionRequestedAt?: GraphQLTypes["DateTime"] | undefined,
	deletionExpectedAt?: GraphQLTypes["DateTime"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	meta?: GraphQLTypes["UserCreateMetaEntityRelationInput"] | undefined,
	identificationAttempts?: Array<GraphQLTypes["UserCreateIdentificationAttemptsEntityRelationInput"]> | undefined,
	roles?: GraphQLTypes["UserCreateRolesEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserCreateMetaEntityRelationInput"]: {
		connect?: GraphQLTypes["UserMetadataUniqueWhere"] | undefined
};
	["UserCreateIdentificationAttemptsEntityRelationInput"]: {
		connect?: GraphQLTypes["IdentificationAttemptUniqueWhere"] | undefined,
	create?: GraphQLTypes["IdentificationAttemptWithoutUserCreateInput"] | undefined,
	alias?: string | undefined
};
	["IdentificationAttemptWithoutUserCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	code?: GraphQLTypes["IdentificationAttemptCreateCodeEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["IdentificationAttemptCreateCodeEntityRelationInput"]: {
		connect?: GraphQLTypes["IdentificationCodeUniqueWhere"] | undefined,
	create?: GraphQLTypes["IdentificationCodeWithoutAttemptsCreateInput"] | undefined
};
	["IdentificationCodeWithoutAttemptsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	locales?: Array<GraphQLTypes["IdentificationCodeCreateLocalesEntityRelationInput"]> | undefined,
	internalName?: string | undefined,
	applicationDevices?: Array<GraphQLTypes["IdentificationCodeCreateApplicationDevicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["IdentificationCodeCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["IdentificationCodeLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["IdentificationCodeLocaleWithoutRootCreateInput"] | undefined,
	alias?: string | undefined
};
	["IdentificationCodeLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	successMessage?: string | undefined,
	locale?: GraphQLTypes["IdentificationCodeLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["IdentificationCodeLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutIdentificationCodesCreateInput"] | undefined
};
	["LocaleWithoutIdentificationCodesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	businessCategories?: Array<GraphQLTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleCreateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleCreateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateProductsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductLocaleWithoutLocaleCreateInput"] | undefined,
	alias?: string | undefined
};
	["ProductLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	description?: string | undefined,
	root?: GraphQLTypes["ProductLocaleCreateRootEntityRelationInput"] | undefined,
	featureList?: GraphQLTypes["ProductLocaleCreateFeatureListEntityRelationInput"] | undefined,
	printableName?: string | undefined,
	firstSticker?: string | undefined,
	secondSticker?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductWithoutLocalesCreateInput"] | undefined
};
	["ProductWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	priceCents?: number | undefined,
	notDiscountable?: boolean | undefined,
	packing?: GraphQLTypes["ProductCreatePackingEntityRelationInput"] | undefined,
	recipe?: GraphQLTypes["ProductCreateRecipeEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["ProductCreateTagsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["ProductCreateCategoriesEntityRelationInput"]> | undefined,
	vatRate?: GraphQLTypes["ProductCreateVatRateEntityRelationInput"] | undefined,
	stocks?: Array<GraphQLTypes["ProductCreateStocksEntityRelationInput"]> | undefined,
	groupPrices?: Array<GraphQLTypes["ProductCreateGroupPricesEntityRelationInput"]> | undefined,
	image?: GraphQLTypes["ProductCreateImageEntityRelationInput"] | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	cartItems?: Array<GraphQLTypes["ProductCreateCartItemsEntityRelationInput"]> | undefined,
	availability?: GraphQLTypes["ProductAvailability"] | undefined,
	order?: number | undefined,
	manager?: GraphQLTypes["ProductCreateManagerEntityRelationInput"] | undefined,
	orderItems?: Array<GraphQLTypes["ProductCreateOrderItemsEntityRelationInput"]> | undefined,
	maximumQuantityPerOrder?: number | undefined,
	inheritedCategories?: Array<GraphQLTypes["ProductCreateInheritedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["ProductCreateDeliveryZonesEntityRelationInput"]> | undefined,
	archivedAt?: GraphQLTypes["DateTime"] | undefined,
	customerPrices?: Array<GraphQLTypes["ProductCreateCustomerPricesEntityRelationInput"]> | undefined,
	virtualProduct?: GraphQLTypes["ProductCreateVirtualProductEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["ProductCreateMetaEntityRelationInput"] | undefined,
	page?: GraphQLTypes["ProductCreatePageEntityRelationInput"] | undefined,
	salesDays?: Array<GraphQLTypes["ProductCreateSalesDaysEntityRelationInput"]> | undefined,
	salesWeeks?: Array<GraphQLTypes["ProductCreateSalesWeeksEntityRelationInput"]> | undefined,
	salesMonths?: Array<GraphQLTypes["ProductCreateSalesMonthsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["ProductCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	hasSubscription?: boolean | undefined,
	pointOfSaleTileColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductLocaleCreateFeatureListEntityRelationInput"]: {
		connect?: GraphQLTypes["TextListUniqueWhere"] | undefined,
	create?: GraphQLTypes["TextListCreateInput"] | undefined
};
	["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]: {
		connect?: GraphQLTypes["PointOfSaleCategoryProductLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["PointOfSaleCategoryProductLocaleWithoutLocaleCreateInput"] | undefined,
	alias?: string | undefined
};
	["PointOfSaleCategoryProductLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	root?: GraphQLTypes["PointOfSaleCategoryProductLocaleCreateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleCategoryProductLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["PointOfSaleCategoryProductUniqueWhere"] | undefined,
	create?: GraphQLTypes["PointOfSaleCategoryProductWithoutLocalesCreateInput"] | undefined
};
	["PointOfSaleCategoryProductWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	category?: GraphQLTypes["PointOfSaleCategoryProductCreateCategoryEntityRelationInput"] | undefined,
	product?: GraphQLTypes["PointOfSaleCategoryProductCreateProductEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleCategoryProductCreateCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["PointOfSaleCategoryUniqueWhere"] | undefined,
	create?: GraphQLTypes["PointOfSaleCategoryWithoutProductsCreateInput"] | undefined
};
	["PointOfSaleCategoryWithoutProductsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	slug?: string | undefined,
	locales?: Array<GraphQLTypes["PointOfSaleCategoryCreateLocalesEntityRelationInput"]> | undefined,
	category?: GraphQLTypes["PointOfSaleCategoryCreateCategoryEntityRelationInput"] | undefined,
	venue?: GraphQLTypes["PointOfSaleCategoryCreateVenueEntityRelationInput"] | undefined,
	ticketPrinters?: Array<GraphQLTypes["PointOfSaleCategoryCreateTicketPrintersEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleCategoryCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["PointOfSaleCategoryLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["PointOfSaleCategoryLocaleWithoutRootCreateInput"] | undefined,
	alias?: string | undefined
};
	["PointOfSaleCategoryLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	locale?: GraphQLTypes["PointOfSaleCategoryLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleCategoryLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutPointOfSaleCategoriesCreateInput"] | undefined
};
	["LocaleWithoutPointOfSaleCategoriesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	businessCategories?: Array<GraphQLTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleCreateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleCreateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateDeliveryMethodsEntityRelationInput"]: {
		connect?: GraphQLTypes["DeliveryMethodLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["DeliveryMethodLocaleWithoutLocaleCreateInput"] | undefined,
	alias?: string | undefined
};
	["DeliveryMethodLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	description?: string | undefined,
	trackingCodeUrlTemplate?: string | undefined,
	processingTitle?: string | undefined,
	processingText?: string | undefined,
	processingIconUrl?: string | undefined,
	dispatchedTitle?: string | undefined,
	dispatchedText?: string | undefined,
	dispatchedIconUrl?: string | undefined,
	fulfilledTitle?: string | undefined,
	fulfilledText?: string | undefined,
	fulfilledIconUrl?: string | undefined,
	root?: GraphQLTypes["DeliveryMethodLocaleCreateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryMethodLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["DeliveryMethodUniqueWhere"] | undefined,
	create?: GraphQLTypes["DeliveryMethodWithoutLocalesCreateInput"] | undefined
};
	["DeliveryMethodWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	enabled?: boolean | undefined,
	paymentMethods?: Array<GraphQLTypes["DeliveryMethodCreatePaymentMethodsEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	requireDeliveryAddress?: boolean | undefined,
	suitableForDeliveryZones?: Array<GraphQLTypes["DeliveryMethodCreateSuitableForDeliveryZonesEntityRelationInput"]> | undefined,
	channels?: Array<GraphQLTypes["DeliveryMethodCreateChannelsEntityRelationInput"]> | undefined,
	courierHandlers?: Array<GraphQLTypes["DeliveryMethodCreateCourierHandlersEntityRelationInput"]> | undefined,
	enableDeliveryTracking?: boolean | undefined,
	timelinePreset?: GraphQLTypes["DeliveryMethodCreateTimelinePresetEntityRelationInput"] | undefined,
	woltDriveVenueId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryMethodCreateTimelinePresetEntityRelationInput"]: {
		connect?: GraphQLTypes["DeliveryTimelinePresetUniqueWhere"] | undefined,
	create?: GraphQLTypes["DeliveryTimelinePresetWithoutDeliveryMethodCreateInput"] | undefined
};
	["DeliveryTimelinePresetWithoutDeliveryMethodCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["DeliveryTimelineType"] | undefined,
	duration?: string | undefined,
	window?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateIngredientSuppliersEntityRelationInput"]: {
		connect?: GraphQLTypes["IngredientSupplierLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["IngredientSupplierLocaleWithoutLocaleCreateInput"] | undefined,
	alias?: string | undefined
};
	["IngredientSupplierLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	root?: GraphQLTypes["IngredientSupplierLocaleCreateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["IngredientSupplierLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["IngredientSupplierUniqueWhere"] | undefined,
	create?: GraphQLTypes["IngredientSupplierWithoutLocalesCreateInput"] | undefined
};
	["IngredientSupplierWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	internalName?: string | undefined,
	internalNote?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateIdentificationCodesEntityRelationInput"]: {
		connect?: GraphQLTypes["IdentificationCodeLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["IdentificationCodeLocaleWithoutLocaleCreateInput"] | undefined,
	alias?: string | undefined
};
	["IdentificationCodeLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	successMessage?: string | undefined,
	root?: GraphQLTypes["IdentificationCodeLocaleCreateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["IdentificationCodeLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["IdentificationCodeUniqueWhere"] | undefined,
	create?: GraphQLTypes["IdentificationCodeWithoutLocalesCreateInput"] | undefined
};
	["IdentificationCodeWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	attempts?: Array<GraphQLTypes["IdentificationCodeCreateAttemptsEntityRelationInput"]> | undefined,
	internalName?: string | undefined,
	applicationDevices?: Array<GraphQLTypes["IdentificationCodeCreateApplicationDevicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["IdentificationCodeCreateApplicationDevicesEntityRelationInput"]: {
		connect?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined,
	create?: GraphQLTypes["PointOfSaleApplicationDeviceWithoutIdentificationCodeCreateInput"] | undefined,
	alias?: string | undefined
};
	["PointOfSaleApplicationDeviceWithoutIdentificationCodeCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	internalName?: string | undefined,
	note?: string | undefined,
	venue?: GraphQLTypes["PointOfSaleApplicationDeviceCreateVenueEntityRelationInput"] | undefined,
	identifier?: GraphQLTypes["PointOfSaleApplicationDeviceCreateIdentifierEntityRelationInput"] | undefined,
	terminal?: GraphQLTypes["PointOfSaleApplicationDeviceCreateTerminalEntityRelationInput"] | undefined,
	receiptPrinter?: GraphQLTypes["PointOfSaleApplicationDeviceCreateReceiptPrinterEntityRelationInput"] | undefined,
	ticketPrinters?: Array<GraphQLTypes["PointOfSaleApplicationDeviceCreateTicketPrintersEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleApplicationDeviceCreateTerminalEntityRelationInput"]: {
		connect?: GraphQLTypes["PointOfSaleTerminalUniqueWhere"] | undefined,
	create?: GraphQLTypes["PointOfSaleTerminalWithoutApplicationDevicesCreateInput"] | undefined
};
	["PointOfSaleTerminalWithoutApplicationDevicesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	internalName?: string | undefined,
	note?: string | undefined,
	venue?: GraphQLTypes["PointOfSaleTerminalCreateVenueEntityRelationInput"] | undefined,
	ipAddress?: string | undefined,
	port?: number | undefined,
	type?: GraphQLTypes["PointOfSaleTerminalType"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleTerminalCreateVenueEntityRelationInput"]: {
		connect?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	create?: GraphQLTypes["VenueWithoutPointOfSaleTerminalsCreateInput"] | undefined
};
	["VenueWithoutPointOfSaleTerminalsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	deadlineTemplate?: GraphQLTypes["VenueCreateDeadlineTemplateEntityRelationInput"] | undefined,
	timetableDays?: Array<GraphQLTypes["VenueCreateTimetableDaysEntityRelationInput"]> | undefined,
	timetableTemplates?: Array<GraphQLTypes["VenueCreateTimetableTemplatesEntityRelationInput"]> | undefined,
	staffMembers?: Array<GraphQLTypes["VenueCreateStaffMembersEntityRelationInput"]> | undefined,
	employeeRoles?: Array<GraphQLTypes["VenueCreateEmployeeRolesEntityRelationInput"]> | undefined,
	pointOfSaleApplicationDevices?: Array<GraphQLTypes["VenueCreatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined,
	pointOfSalePrinters?: Array<GraphQLTypes["VenueCreatePointOfSalePrintersEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["VenueCreateOrdersEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["VenueCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	areas?: Array<GraphQLTypes["VenueCreateAreasEntityRelationInput"]> | undefined,
	enabledUnassignReasons?: Array<GraphQLTypes["VenueCreateEnabledUnassignReasonsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["VenueCreateCategoriesEntityRelationInput"]> | undefined,
	channels?: Array<GraphQLTypes["VenueCreateChannelsEntityRelationInput"]> | undefined,
	address?: string | undefined,
	pointOfSalePngBase64ReceiptLogo?: string | undefined,
	pointOfSaleInitialView?: GraphQLTypes["PointOfSaleInitialView"] | undefined,
	pointOfSalePreferPrintReceipt?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["VenueCreateOrdersEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	create?: GraphQLTypes["OrderWithoutVenueCreateInput"] | undefined,
	alias?: string | undefined
};
	["OrderWithoutVenueCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	state?: GraphQLTypes["OrderState"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	canceledAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	customer?: GraphQLTypes["OrderCreateCustomerEntityRelationInput"] | undefined,
	channel?: GraphQLTypes["OrderCreateChannelEntityRelationInput"] | undefined,
	discounts?: Array<GraphQLTypes["OrderCreateDiscountsEntityRelationInput"]> | undefined,
	delivery?: GraphQLTypes["OrderCreateDeliveryEntityRelationInput"] | undefined,
	items?: Array<GraphQLTypes["OrderCreateItemsEntityRelationInput"]> | undefined,
	internalNote?: string | undefined,
	cart?: GraphQLTypes["OrderCreateCartEntityRelationInput"] | undefined,
	events?: Array<GraphQLTypes["OrderCreateEventsEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddress?: GraphQLTypes["OrderCreateBillingAddressEntityRelationInput"] | undefined,
	priceLines?: Array<GraphQLTypes["OrderCreatePriceLinesEntityRelationInput"]> | undefined,
	payments?: Array<GraphQLTypes["OrderCreatePaymentsEntityRelationInput"]> | undefined,
	seq?: number | undefined,
	billingSubject?: GraphQLTypes["OrderCreateBillingSubjectEntityRelationInput"] | undefined,
	summary?: GraphQLTypes["OrderCreateSummaryEntityRelationInput"] | undefined,
	doubleshotLegacyId?: string | undefined,
	gratuity?: GraphQLTypes["OrderCreateGratuityEntityRelationInput"] | undefined,
	fulfillmentNote?: string | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["OrderCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	doubleshotTotalWeightGrams?: number | undefined,
	doubleShotLegacyNumber?: string | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	doubleshotAdminUrl?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["OrderItemWithoutOrderCreateInput"] | undefined,
	alias?: string | undefined
};
	["OrderItemWithoutOrderCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unitPriceCents?: number | undefined,
	quantity?: number | undefined,
	vatRate?: GraphQLTypes["OrderItemCreateVatRateEntityRelationInput"] | undefined,
	virtualProductEffects?: Array<GraphQLTypes["OrderItemCreateVirtualProductEffectsEntityRelationInput"]> | undefined,
	pickedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["OrderItemCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	product?: GraphQLTypes["OrderItemCreateProductEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderItemCreateVirtualProductEffectsEntityRelationInput"]: {
		connect?: GraphQLTypes["VirtualProductEffectUniqueWhere"] | undefined,
	create?: GraphQLTypes["VirtualProductEffectWithoutOrderItemCreateInput"] | undefined,
	alias?: string | undefined
};
	["VirtualProductEffectWithoutOrderItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	succeededAt?: GraphQLTypes["DateTime"] | undefined,
	failedAt?: GraphQLTypes["DateTime"] | undefined,
	revertedAt?: GraphQLTypes["DateTime"] | undefined,
	resultCustomerCreditTransaction?: GraphQLTypes["VirtualProductEffectCreateResultCustomerCreditTransactionEntityRelationInput"] | undefined,
	resultVouchers?: Array<GraphQLTypes["VirtualProductEffectCreateResultVouchersEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["VirtualProductEffectCreateResultCustomerCreditTransactionEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerCreditTransactionUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerCreditTransactionWithoutVirtualProductEffectCreateInput"] | undefined
};
	["CustomerCreditTransactionWithoutVirtualProductEffectCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	amountCents?: number | undefined,
	customerCredit?: GraphQLTypes["CustomerCreditTransactionCreateCustomerCreditEntityRelationInput"] | undefined,
	orderDiscount?: GraphQLTypes["CustomerCreditTransactionCreateOrderDiscountEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreditTransactionCreateOrderDiscountEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderDiscountUniqueWhere"] | undefined,
	create?: GraphQLTypes["OrderDiscountWithoutCustomerCreditTransactionsCreateInput"] | undefined
};
	["OrderDiscountWithoutCustomerCreditTransactionsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	discountCents?: number | undefined,
	vatRate?: GraphQLTypes["OrderDiscountCreateVatRateEntityRelationInput"] | undefined,
	order?: GraphQLTypes["OrderDiscountCreateOrderEntityRelationInput"] | undefined,
	description?: string | undefined,
	type?: GraphQLTypes["OrderDiscountType"] | undefined,
	voucherRedemption?: GraphQLTypes["OrderDiscountCreateVoucherRedemptionEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderDiscountCreateOrderEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	create?: GraphQLTypes["OrderWithoutDiscountsCreateInput"] | undefined
};
	["OrderWithoutDiscountsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	state?: GraphQLTypes["OrderState"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	canceledAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	customer?: GraphQLTypes["OrderCreateCustomerEntityRelationInput"] | undefined,
	channel?: GraphQLTypes["OrderCreateChannelEntityRelationInput"] | undefined,
	delivery?: GraphQLTypes["OrderCreateDeliveryEntityRelationInput"] | undefined,
	items?: Array<GraphQLTypes["OrderCreateItemsEntityRelationInput"]> | undefined,
	internalNote?: string | undefined,
	cart?: GraphQLTypes["OrderCreateCartEntityRelationInput"] | undefined,
	events?: Array<GraphQLTypes["OrderCreateEventsEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddress?: GraphQLTypes["OrderCreateBillingAddressEntityRelationInput"] | undefined,
	priceLines?: Array<GraphQLTypes["OrderCreatePriceLinesEntityRelationInput"]> | undefined,
	payments?: Array<GraphQLTypes["OrderCreatePaymentsEntityRelationInput"]> | undefined,
	seq?: number | undefined,
	billingSubject?: GraphQLTypes["OrderCreateBillingSubjectEntityRelationInput"] | undefined,
	summary?: GraphQLTypes["OrderCreateSummaryEntityRelationInput"] | undefined,
	doubleshotLegacyId?: string | undefined,
	gratuity?: GraphQLTypes["OrderCreateGratuityEntityRelationInput"] | undefined,
	venue?: GraphQLTypes["OrderCreateVenueEntityRelationInput"] | undefined,
	fulfillmentNote?: string | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["OrderCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	doubleshotTotalWeightGrams?: number | undefined,
	doubleShotLegacyNumber?: string | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	doubleshotAdminUrl?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderCreateCartEntityRelationInput"]: {
		connect?: GraphQLTypes["CartUniqueWhere"] | undefined,
	create?: GraphQLTypes["CartWithoutOrderCreateInput"] | undefined
};
	["CartWithoutOrderCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	confirmedAt?: GraphQLTypes["DateTime"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	items?: Array<GraphQLTypes["CartCreateItemsEntityRelationInput"]> | undefined,
	handle?: string | undefined,
	state?: GraphQLTypes["CartState"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	channel?: GraphQLTypes["CartCreateChannelEntityRelationInput"] | undefined,
	customer?: GraphQLTypes["CartCreateCustomerEntityRelationInput"] | undefined,
	deliveryAddress?: GraphQLTypes["CartCreateDeliveryAddressEntityRelationInput"] | undefined,
	billingAddress?: GraphQLTypes["CartCreateBillingAddressEntityRelationInput"] | undefined,
	deliveryOption?: string | undefined,
	paymentOption?: string | undefined,
	delivery?: GraphQLTypes["CartCreateDeliveryEntityRelationInput"] | undefined,
	payment?: GraphQLTypes["CartCreatePaymentEntityRelationInput"] | undefined,
	billingSubject?: GraphQLTypes["CartCreateBillingSubjectEntityRelationInput"] | undefined,
	priceLines?: Array<GraphQLTypes["CartCreatePriceLinesEntityRelationInput"]> | undefined,
	summary?: GraphQLTypes["CartCreateSummaryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CartCreateCustomerEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerWithoutCartsCreateInput"] | undefined
};
	["CustomerWithoutCartsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	addresses?: Array<GraphQLTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerCreateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerCreateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerCreatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerCreateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerCreateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerCreateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerCreateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerCreateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerCreateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreateInvoicingPlanEntityRelationInput"]: {
		connect?: GraphQLTypes["InvoicingPlanUniqueWhere"] | undefined,
	create?: GraphQLTypes["InvoicingPlanWithoutCustomerCreateInput"] | undefined
};
	["InvoicingPlanWithoutCustomerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	preset?: GraphQLTypes["InvoicingPlanCreatePresetEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InvoicingPlanCreatePresetEntityRelationInput"]: {
		connect?: GraphQLTypes["InvoicingPresetUniqueWhere"] | undefined,
	create?: GraphQLTypes["InvoicingPresetWithoutInvoicingPlanCreateInput"] | undefined
};
	["InvoicingPresetWithoutInvoicingPlanCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["InvoicingPresetType"] | undefined,
	startsAt?: GraphQLTypes["DateTime"] | undefined,
	endsAt?: GraphQLTypes["DateTime"] | undefined,
	intervalOfDays?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreateBillingSubjectsEntityRelationInput"]: {
		connect?: GraphQLTypes["BillingSubjectUniqueWhere"] | undefined,
	create?: GraphQLTypes["BillingSubjectWithoutCustomerCreateInput"] | undefined,
	alias?: string | undefined
};
	["BillingSubjectWithoutCustomerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	fullName?: string | undefined,
	addressLine1?: string | undefined,
	addressLine2?: string | undefined,
	city?: string | undefined,
	postalCode?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	companyName?: string | undefined,
	companyIdentifier?: string | undefined,
	vatIdentifier?: string | undefined,
	externalIdentifier?: string | undefined,
	hidden?: boolean | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	internalNote?: string | undefined,
	fakturoidSubjectId?: string | undefined,
	country?: GraphQLTypes["BillingSubjectCreateCountryEntityRelationInput"] | undefined,
	invoices?: Array<GraphQLTypes["BillingSubjectCreateInvoicesEntityRelationInput"]> | undefined,
	defaultBillingSubjectOfCustomer?: GraphQLTypes["BillingSubjectCreateDefaultBillingSubjectOfCustomerEntityRelationInput"] | undefined,
	orders?: Array<GraphQLTypes["BillingSubjectCreateOrdersEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["BillingSubjectCreateCountryEntityRelationInput"]: {
		connect?: GraphQLTypes["CountryUniqueWhere"] | undefined,
	create?: GraphQLTypes["CountryCreateInput"] | undefined
};
	["BillingSubjectCreateInvoicesEntityRelationInput"]: {
		connect?: GraphQLTypes["InvoiceUniqueWhere"] | undefined,
	create?: GraphQLTypes["InvoiceWithoutBillingSubjectCreateInput"] | undefined,
	alias?: string | undefined
};
	["InvoiceWithoutBillingSubjectCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	publicKey?: string | undefined,
	fakturoidId?: string | undefined,
	fakturoidData?: string | undefined,
	legacyUrl?: string | undefined,
	customer?: GraphQLTypes["InvoiceCreateCustomerEntityRelationInput"] | undefined,
	orderPayments?: Array<GraphQLTypes["InvoiceCreateOrderPaymentsEntityRelationInput"]> | undefined,
	address?: GraphQLTypes["InvoiceCreateAddressEntityRelationInput"] | undefined,
	publicUrl?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["InvoiceCreateAddressEntityRelationInput"]: {
		connect?: GraphQLTypes["AddressUniqueWhere"] | undefined,
	create?: GraphQLTypes["AddressWithoutInvoicesCreateInput"] | undefined
};
	["AddressWithoutInvoicesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	firstName?: string | undefined,
	lastName?: string | undefined,
	addressLine2?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	companyName?: string | undefined,
	companyIdentifier?: string | undefined,
	vatIdentifier?: string | undefined,
	externalIdentifier?: string | undefined,
	hidden?: boolean | undefined,
	customer?: GraphQLTypes["AddressCreateCustomerEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	country?: GraphQLTypes["AddressCreateCountryEntityRelationInput"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	googlePlaceId?: string | undefined,
	raw?: string | undefined,
	formatted?: string | undefined,
	geocodeGeneratedAt?: GraphQLTypes["DateTime"] | undefined,
	geocodeResponse?: string | undefined,
	deliveryZone?: GraphQLTypes["AddressCreateDeliveryZoneEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["AddressCreateMetaEntityRelationInput"] | undefined,
	gps?: GraphQLTypes["AddressCreateGpsEntityRelationInput"] | undefined,
	geocodeValid?: boolean | undefined,
	fullName?: string | undefined,
	fakturoidSubjectId?: string | undefined,
	addressLine1?: string | undefined,
	city?: string | undefined,
	postalCode?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddressOfOrders?: Array<GraphQLTypes["AddressCreateBillingAddressOfOrdersEntityRelationInput"]> | undefined,
	deliveryAddressOfOrderDeliveries?: Array<GraphQLTypes["AddressCreateDeliveryAddressOfOrderDeliveriesEntityRelationInput"]> | undefined,
	defaultDeliveryAddressOfCustomer?: GraphQLTypes["AddressCreateDefaultDeliveryAddressOfCustomerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["AddressCreateBillingAddressOfOrdersEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	create?: GraphQLTypes["OrderWithoutBillingAddressCreateInput"] | undefined,
	alias?: string | undefined
};
	["OrderWithoutBillingAddressCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	state?: GraphQLTypes["OrderState"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	canceledAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	customer?: GraphQLTypes["OrderCreateCustomerEntityRelationInput"] | undefined,
	channel?: GraphQLTypes["OrderCreateChannelEntityRelationInput"] | undefined,
	discounts?: Array<GraphQLTypes["OrderCreateDiscountsEntityRelationInput"]> | undefined,
	delivery?: GraphQLTypes["OrderCreateDeliveryEntityRelationInput"] | undefined,
	items?: Array<GraphQLTypes["OrderCreateItemsEntityRelationInput"]> | undefined,
	internalNote?: string | undefined,
	cart?: GraphQLTypes["OrderCreateCartEntityRelationInput"] | undefined,
	events?: Array<GraphQLTypes["OrderCreateEventsEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	priceLines?: Array<GraphQLTypes["OrderCreatePriceLinesEntityRelationInput"]> | undefined,
	payments?: Array<GraphQLTypes["OrderCreatePaymentsEntityRelationInput"]> | undefined,
	seq?: number | undefined,
	billingSubject?: GraphQLTypes["OrderCreateBillingSubjectEntityRelationInput"] | undefined,
	summary?: GraphQLTypes["OrderCreateSummaryEntityRelationInput"] | undefined,
	doubleshotLegacyId?: string | undefined,
	gratuity?: GraphQLTypes["OrderCreateGratuityEntityRelationInput"] | undefined,
	venue?: GraphQLTypes["OrderCreateVenueEntityRelationInput"] | undefined,
	fulfillmentNote?: string | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["OrderCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	doubleshotTotalWeightGrams?: number | undefined,
	doubleShotLegacyNumber?: string | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	doubleshotAdminUrl?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderCreateEventsEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderEventUniqueWhere"] | undefined,
	create?: GraphQLTypes["OrderEventWithoutOrderCreateInput"] | undefined,
	alias?: string | undefined
};
	["OrderEventWithoutOrderCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: string | undefined,
	data?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	payment?: GraphQLTypes["OrderEventCreatePaymentEntityRelationInput"] | undefined,
	delivery?: GraphQLTypes["OrderEventCreateDeliveryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderEventCreatePaymentEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderPaymentUniqueWhere"] | undefined,
	create?: GraphQLTypes["OrderPaymentWithoutEventsCreateInput"] | undefined
};
	["OrderPaymentWithoutEventsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	data?: GraphQLTypes["Json"] | undefined,
	paymentCents?: number | undefined,
	method?: GraphQLTypes["OrderPaymentCreateMethodEntityRelationInput"] | undefined,
	failedAt?: GraphQLTypes["DateTime"] | undefined,
	state?: GraphQLTypes["OrderPaymentState"] | undefined,
	approvedAt?: GraphQLTypes["DateTime"] | undefined,
	order?: GraphQLTypes["OrderPaymentCreateOrderEntityRelationInput"] | undefined,
	invoice?: GraphQLTypes["OrderPaymentCreateInvoiceEntityRelationInput"] | undefined,
	walletType?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	publicReceiptUrl?: string | undefined,
	priceCents?: number | undefined,
	vatRate?: GraphQLTypes["OrderPaymentCreateVatRateEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["OrderPaymentCreateMetaEntityRelationInput"] | undefined,
	otherCurrencyPriceCents?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderPaymentCreateOrderEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	create?: GraphQLTypes["OrderWithoutPaymentsCreateInput"] | undefined
};
	["OrderWithoutPaymentsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	state?: GraphQLTypes["OrderState"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	canceledAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	customer?: GraphQLTypes["OrderCreateCustomerEntityRelationInput"] | undefined,
	channel?: GraphQLTypes["OrderCreateChannelEntityRelationInput"] | undefined,
	discounts?: Array<GraphQLTypes["OrderCreateDiscountsEntityRelationInput"]> | undefined,
	delivery?: GraphQLTypes["OrderCreateDeliveryEntityRelationInput"] | undefined,
	items?: Array<GraphQLTypes["OrderCreateItemsEntityRelationInput"]> | undefined,
	internalNote?: string | undefined,
	cart?: GraphQLTypes["OrderCreateCartEntityRelationInput"] | undefined,
	events?: Array<GraphQLTypes["OrderCreateEventsEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddress?: GraphQLTypes["OrderCreateBillingAddressEntityRelationInput"] | undefined,
	priceLines?: Array<GraphQLTypes["OrderCreatePriceLinesEntityRelationInput"]> | undefined,
	seq?: number | undefined,
	billingSubject?: GraphQLTypes["OrderCreateBillingSubjectEntityRelationInput"] | undefined,
	summary?: GraphQLTypes["OrderCreateSummaryEntityRelationInput"] | undefined,
	doubleshotLegacyId?: string | undefined,
	gratuity?: GraphQLTypes["OrderCreateGratuityEntityRelationInput"] | undefined,
	venue?: GraphQLTypes["OrderCreateVenueEntityRelationInput"] | undefined,
	fulfillmentNote?: string | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["OrderCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	doubleshotTotalWeightGrams?: number | undefined,
	doubleShotLegacyNumber?: string | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	doubleshotAdminUrl?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderCreateBillingAddressEntityRelationInput"]: {
		connect?: GraphQLTypes["AddressUniqueWhere"] | undefined,
	create?: GraphQLTypes["AddressWithoutBillingAddressOfOrdersCreateInput"] | undefined
};
	["AddressWithoutBillingAddressOfOrdersCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	firstName?: string | undefined,
	lastName?: string | undefined,
	addressLine2?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	companyName?: string | undefined,
	companyIdentifier?: string | undefined,
	vatIdentifier?: string | undefined,
	externalIdentifier?: string | undefined,
	hidden?: boolean | undefined,
	customer?: GraphQLTypes["AddressCreateCustomerEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	country?: GraphQLTypes["AddressCreateCountryEntityRelationInput"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	googlePlaceId?: string | undefined,
	raw?: string | undefined,
	formatted?: string | undefined,
	geocodeGeneratedAt?: GraphQLTypes["DateTime"] | undefined,
	geocodeResponse?: string | undefined,
	deliveryZone?: GraphQLTypes["AddressCreateDeliveryZoneEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["AddressCreateMetaEntityRelationInput"] | undefined,
	gps?: GraphQLTypes["AddressCreateGpsEntityRelationInput"] | undefined,
	geocodeValid?: boolean | undefined,
	fullName?: string | undefined,
	fakturoidSubjectId?: string | undefined,
	invoices?: Array<GraphQLTypes["AddressCreateInvoicesEntityRelationInput"]> | undefined,
	addressLine1?: string | undefined,
	city?: string | undefined,
	postalCode?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	deliveryAddressOfOrderDeliveries?: Array<GraphQLTypes["AddressCreateDeliveryAddressOfOrderDeliveriesEntityRelationInput"]> | undefined,
	defaultDeliveryAddressOfCustomer?: GraphQLTypes["AddressCreateDefaultDeliveryAddressOfCustomerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["AddressCreateDeliveryAddressOfOrderDeliveriesEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderDeliveryUniqueWhere"] | undefined,
	create?: GraphQLTypes["OrderDeliveryWithoutAddressCreateInput"] | undefined,
	alias?: string | undefined
};
	["OrderDeliveryWithoutAddressCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	priceCents?: number | undefined,
	deliveredAt?: GraphQLTypes["DateTime"] | undefined,
	method?: GraphQLTypes["OrderDeliveryCreateMethodEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["OrderDeliveryCreateVatRateEntityRelationInput"] | undefined,
	order?: GraphQLTypes["OrderDeliveryCreateOrderEntityRelationInput"] | undefined,
	expectedAt?: GraphQLTypes["DateTime"] | undefined,
	state?: GraphQLTypes["OrderDeliveryState"] | undefined,
	loadingDurationHours?: number | undefined,
	dispatchAt?: GraphQLTypes["DateTime"] | undefined,
	duration?: string | undefined,
	window?: string | undefined,
	expectedEndAt?: GraphQLTypes["DateTime"] | undefined,
	processingAt?: GraphQLTypes["DateTime"] | undefined,
	deliveringAt?: GraphQLTypes["DateTime"] | undefined,
	failedAt?: GraphQLTypes["DateTime"] | undefined,
	internalNote?: string | undefined,
	deliveryWaypoint?: GraphQLTypes["OrderDeliveryCreateDeliveryWaypointEntityRelationInput"] | undefined,
	events?: Array<GraphQLTypes["OrderDeliveryCreateEventsEntityRelationInput"]> | undefined,
	prepareAt?: GraphQLTypes["DateTime"] | undefined,
	liftagoRide?: GraphQLTypes["OrderDeliveryCreateLiftagoRideEntityRelationInput"] | undefined,
	pickedAt?: GraphQLTypes["DateTime"] | undefined,
	trackingCode?: string | undefined,
	woltDriveDelivery?: GraphQLTypes["OrderDeliveryCreateWoltDriveDeliveryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderDeliveryCreateOrderEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	create?: GraphQLTypes["OrderWithoutDeliveryCreateInput"] | undefined
};
	["OrderWithoutDeliveryCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	state?: GraphQLTypes["OrderState"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	canceledAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	customer?: GraphQLTypes["OrderCreateCustomerEntityRelationInput"] | undefined,
	channel?: GraphQLTypes["OrderCreateChannelEntityRelationInput"] | undefined,
	discounts?: Array<GraphQLTypes["OrderCreateDiscountsEntityRelationInput"]> | undefined,
	items?: Array<GraphQLTypes["OrderCreateItemsEntityRelationInput"]> | undefined,
	internalNote?: string | undefined,
	cart?: GraphQLTypes["OrderCreateCartEntityRelationInput"] | undefined,
	events?: Array<GraphQLTypes["OrderCreateEventsEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddress?: GraphQLTypes["OrderCreateBillingAddressEntityRelationInput"] | undefined,
	priceLines?: Array<GraphQLTypes["OrderCreatePriceLinesEntityRelationInput"]> | undefined,
	payments?: Array<GraphQLTypes["OrderCreatePaymentsEntityRelationInput"]> | undefined,
	seq?: number | undefined,
	billingSubject?: GraphQLTypes["OrderCreateBillingSubjectEntityRelationInput"] | undefined,
	summary?: GraphQLTypes["OrderCreateSummaryEntityRelationInput"] | undefined,
	doubleshotLegacyId?: string | undefined,
	gratuity?: GraphQLTypes["OrderCreateGratuityEntityRelationInput"] | undefined,
	venue?: GraphQLTypes["OrderCreateVenueEntityRelationInput"] | undefined,
	fulfillmentNote?: string | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["OrderCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	doubleshotTotalWeightGrams?: number | undefined,
	doubleShotLegacyNumber?: string | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	doubleshotAdminUrl?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderCreatePriceLinesEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderPriceLineUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["OrderCreatePaymentsEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderPaymentUniqueWhere"] | undefined,
	create?: GraphQLTypes["OrderPaymentWithoutOrderCreateInput"] | undefined,
	alias?: string | undefined
};
	["OrderPaymentWithoutOrderCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	data?: GraphQLTypes["Json"] | undefined,
	paymentCents?: number | undefined,
	method?: GraphQLTypes["OrderPaymentCreateMethodEntityRelationInput"] | undefined,
	failedAt?: GraphQLTypes["DateTime"] | undefined,
	state?: GraphQLTypes["OrderPaymentState"] | undefined,
	approvedAt?: GraphQLTypes["DateTime"] | undefined,
	events?: Array<GraphQLTypes["OrderPaymentCreateEventsEntityRelationInput"]> | undefined,
	invoice?: GraphQLTypes["OrderPaymentCreateInvoiceEntityRelationInput"] | undefined,
	walletType?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	publicReceiptUrl?: string | undefined,
	priceCents?: number | undefined,
	vatRate?: GraphQLTypes["OrderPaymentCreateVatRateEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["OrderPaymentCreateMetaEntityRelationInput"] | undefined,
	otherCurrencyPriceCents?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderPaymentCreateInvoiceEntityRelationInput"]: {
		connect?: GraphQLTypes["InvoiceUniqueWhere"] | undefined,
	create?: GraphQLTypes["InvoiceWithoutOrderPaymentsCreateInput"] | undefined
};
	["InvoiceWithoutOrderPaymentsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	publicKey?: string | undefined,
	fakturoidId?: string | undefined,
	fakturoidData?: string | undefined,
	legacyUrl?: string | undefined,
	customer?: GraphQLTypes["InvoiceCreateCustomerEntityRelationInput"] | undefined,
	address?: GraphQLTypes["InvoiceCreateAddressEntityRelationInput"] | undefined,
	publicUrl?: string | undefined,
	billingSubject?: GraphQLTypes["InvoiceCreateBillingSubjectEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InvoiceCreateBillingSubjectEntityRelationInput"]: {
		connect?: GraphQLTypes["BillingSubjectUniqueWhere"] | undefined,
	create?: GraphQLTypes["BillingSubjectWithoutInvoicesCreateInput"] | undefined
};
	["BillingSubjectWithoutInvoicesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	fullName?: string | undefined,
	addressLine1?: string | undefined,
	addressLine2?: string | undefined,
	city?: string | undefined,
	postalCode?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	companyName?: string | undefined,
	companyIdentifier?: string | undefined,
	vatIdentifier?: string | undefined,
	externalIdentifier?: string | undefined,
	hidden?: boolean | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	internalNote?: string | undefined,
	fakturoidSubjectId?: string | undefined,
	country?: GraphQLTypes["BillingSubjectCreateCountryEntityRelationInput"] | undefined,
	customer?: GraphQLTypes["BillingSubjectCreateCustomerEntityRelationInput"] | undefined,
	defaultBillingSubjectOfCustomer?: GraphQLTypes["BillingSubjectCreateDefaultBillingSubjectOfCustomerEntityRelationInput"] | undefined,
	orders?: Array<GraphQLTypes["BillingSubjectCreateOrdersEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["BillingSubjectCreateCustomerEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerWithoutBillingSubjectsCreateInput"] | undefined
};
	["CustomerWithoutBillingSubjectsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	addresses?: Array<GraphQLTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerCreateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerCreateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerCreatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerCreateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerCreateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerCreateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerCreateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerCreateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerCreateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerCreateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreateOfferedProductsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductCustomerPriceUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CustomerCreateDefaultDeliveryAddressEntityRelationInput"]: {
		connect?: GraphQLTypes["AddressUniqueWhere"] | undefined,
	create?: GraphQLTypes["AddressWithoutDefaultDeliveryAddressOfCustomerCreateInput"] | undefined
};
	["AddressWithoutDefaultDeliveryAddressOfCustomerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	firstName?: string | undefined,
	lastName?: string | undefined,
	addressLine2?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	companyName?: string | undefined,
	companyIdentifier?: string | undefined,
	vatIdentifier?: string | undefined,
	externalIdentifier?: string | undefined,
	hidden?: boolean | undefined,
	customer?: GraphQLTypes["AddressCreateCustomerEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	country?: GraphQLTypes["AddressCreateCountryEntityRelationInput"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	googlePlaceId?: string | undefined,
	raw?: string | undefined,
	formatted?: string | undefined,
	geocodeGeneratedAt?: GraphQLTypes["DateTime"] | undefined,
	geocodeResponse?: string | undefined,
	deliveryZone?: GraphQLTypes["AddressCreateDeliveryZoneEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["AddressCreateMetaEntityRelationInput"] | undefined,
	gps?: GraphQLTypes["AddressCreateGpsEntityRelationInput"] | undefined,
	geocodeValid?: boolean | undefined,
	fullName?: string | undefined,
	fakturoidSubjectId?: string | undefined,
	invoices?: Array<GraphQLTypes["AddressCreateInvoicesEntityRelationInput"]> | undefined,
	addressLine1?: string | undefined,
	city?: string | undefined,
	postalCode?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddressOfOrders?: Array<GraphQLTypes["AddressCreateBillingAddressOfOrdersEntityRelationInput"]> | undefined,
	deliveryAddressOfOrderDeliveries?: Array<GraphQLTypes["AddressCreateDeliveryAddressOfOrderDeliveriesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreateDefaultBillingSubjectEntityRelationInput"]: {
		connect?: GraphQLTypes["BillingSubjectUniqueWhere"] | undefined,
	create?: GraphQLTypes["BillingSubjectWithoutDefaultBillingSubjectOfCustomerCreateInput"] | undefined
};
	["BillingSubjectWithoutDefaultBillingSubjectOfCustomerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	fullName?: string | undefined,
	addressLine1?: string | undefined,
	addressLine2?: string | undefined,
	city?: string | undefined,
	postalCode?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	companyName?: string | undefined,
	companyIdentifier?: string | undefined,
	vatIdentifier?: string | undefined,
	externalIdentifier?: string | undefined,
	hidden?: boolean | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	internalNote?: string | undefined,
	fakturoidSubjectId?: string | undefined,
	country?: GraphQLTypes["BillingSubjectCreateCountryEntityRelationInput"] | undefined,
	customer?: GraphQLTypes["BillingSubjectCreateCustomerEntityRelationInput"] | undefined,
	invoices?: Array<GraphQLTypes["BillingSubjectCreateInvoicesEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["BillingSubjectCreateOrdersEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["BillingSubjectCreateOrdersEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	create?: GraphQLTypes["OrderWithoutBillingSubjectCreateInput"] | undefined,
	alias?: string | undefined
};
	["OrderWithoutBillingSubjectCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	state?: GraphQLTypes["OrderState"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	canceledAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	customer?: GraphQLTypes["OrderCreateCustomerEntityRelationInput"] | undefined,
	channel?: GraphQLTypes["OrderCreateChannelEntityRelationInput"] | undefined,
	discounts?: Array<GraphQLTypes["OrderCreateDiscountsEntityRelationInput"]> | undefined,
	delivery?: GraphQLTypes["OrderCreateDeliveryEntityRelationInput"] | undefined,
	items?: Array<GraphQLTypes["OrderCreateItemsEntityRelationInput"]> | undefined,
	internalNote?: string | undefined,
	cart?: GraphQLTypes["OrderCreateCartEntityRelationInput"] | undefined,
	events?: Array<GraphQLTypes["OrderCreateEventsEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddress?: GraphQLTypes["OrderCreateBillingAddressEntityRelationInput"] | undefined,
	priceLines?: Array<GraphQLTypes["OrderCreatePriceLinesEntityRelationInput"]> | undefined,
	payments?: Array<GraphQLTypes["OrderCreatePaymentsEntityRelationInput"]> | undefined,
	seq?: number | undefined,
	summary?: GraphQLTypes["OrderCreateSummaryEntityRelationInput"] | undefined,
	doubleshotLegacyId?: string | undefined,
	gratuity?: GraphQLTypes["OrderCreateGratuityEntityRelationInput"] | undefined,
	venue?: GraphQLTypes["OrderCreateVenueEntityRelationInput"] | undefined,
	fulfillmentNote?: string | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["OrderCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	doubleshotTotalWeightGrams?: number | undefined,
	doubleShotLegacyNumber?: string | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	doubleshotAdminUrl?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderCreateSummaryEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderSummaryUniqueWhere"] | undefined
};
	["OrderCreateGratuityEntityRelationInput"]: {
		connect?: GraphQLTypes["GratuityUniqueWhere"] | undefined,
	create?: GraphQLTypes["GratuityWithoutOrderCreateInput"] | undefined
};
	["GratuityWithoutOrderCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	amountCents?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderCreateVenueEntityRelationInput"]: {
		connect?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	create?: GraphQLTypes["VenueWithoutOrdersCreateInput"] | undefined
};
	["VenueWithoutOrdersCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	deadlineTemplate?: GraphQLTypes["VenueCreateDeadlineTemplateEntityRelationInput"] | undefined,
	timetableDays?: Array<GraphQLTypes["VenueCreateTimetableDaysEntityRelationInput"]> | undefined,
	timetableTemplates?: Array<GraphQLTypes["VenueCreateTimetableTemplatesEntityRelationInput"]> | undefined,
	staffMembers?: Array<GraphQLTypes["VenueCreateStaffMembersEntityRelationInput"]> | undefined,
	employeeRoles?: Array<GraphQLTypes["VenueCreateEmployeeRolesEntityRelationInput"]> | undefined,
	pointOfSaleApplicationDevices?: Array<GraphQLTypes["VenueCreatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined,
	pointOfSaleTerminals?: Array<GraphQLTypes["VenueCreatePointOfSaleTerminalsEntityRelationInput"]> | undefined,
	pointOfSalePrinters?: Array<GraphQLTypes["VenueCreatePointOfSalePrintersEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["VenueCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	areas?: Array<GraphQLTypes["VenueCreateAreasEntityRelationInput"]> | undefined,
	enabledUnassignReasons?: Array<GraphQLTypes["VenueCreateEnabledUnassignReasonsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["VenueCreateCategoriesEntityRelationInput"]> | undefined,
	channels?: Array<GraphQLTypes["VenueCreateChannelsEntityRelationInput"]> | undefined,
	address?: string | undefined,
	pointOfSalePngBase64ReceiptLogo?: string | undefined,
	pointOfSaleInitialView?: GraphQLTypes["PointOfSaleInitialView"] | undefined,
	pointOfSalePreferPrintReceipt?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["VenueCreateFulfillmentNotesEntityRelationInput"]: {
		connect?: GraphQLTypes["FulfillmentNoteUniqueWhere"] | undefined,
	create?: GraphQLTypes["FulfillmentNoteWithoutVenuesCreateInput"] | undefined,
	alias?: string | undefined
};
	["FulfillmentNoteWithoutVenuesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	note?: string | undefined,
	products?: Array<GraphQLTypes["FulfillmentNoteCreateProductsEntityRelationInput"]> | undefined,
	tags?: Array<GraphQLTypes["FulfillmentNoteCreateTagsEntityRelationInput"]> | undefined,
	cartItems?: Array<GraphQLTypes["FulfillmentNoteCreateCartItemsEntityRelationInput"]> | undefined,
	orderItems?: Array<GraphQLTypes["FulfillmentNoteCreateOrderItemsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["FulfillmentNoteCreateOrdersEntityRelationInput"]> | undefined,
	highlight?: boolean | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	emoji?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["FulfillmentNoteCreateCartItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["CartItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["CartItemWithoutFulfillmentNotesCreateInput"] | undefined,
	alias?: string | undefined
};
	["CartItemWithoutFulfillmentNotesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	quantity?: number | undefined,
	cart?: GraphQLTypes["CartItemCreateCartEntityRelationInput"] | undefined,
	product?: GraphQLTypes["CartItemCreateProductEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	updatedAt?: GraphQLTypes["DateTime"] | undefined,
	fulfillmentNote?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["FulfillmentNoteCreateOrderItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["OrderItemWithoutFulfillmentNotesCreateInput"] | undefined,
	alias?: string | undefined
};
	["OrderItemWithoutFulfillmentNotesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unitPriceCents?: number | undefined,
	quantity?: number | undefined,
	vatRate?: GraphQLTypes["OrderItemCreateVatRateEntityRelationInput"] | undefined,
	order?: GraphQLTypes["OrderItemCreateOrderEntityRelationInput"] | undefined,
	virtualProductEffects?: Array<GraphQLTypes["OrderItemCreateVirtualProductEffectsEntityRelationInput"]> | undefined,
	pickedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	product?: GraphQLTypes["OrderItemCreateProductEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderItemCreateProductEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductWithoutOrderItemsCreateInput"] | undefined
};
	["ProductWithoutOrderItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	priceCents?: number | undefined,
	notDiscountable?: boolean | undefined,
	packing?: GraphQLTypes["ProductCreatePackingEntityRelationInput"] | undefined,
	recipe?: GraphQLTypes["ProductCreateRecipeEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["ProductCreateTagsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["ProductCreateCategoriesEntityRelationInput"]> | undefined,
	vatRate?: GraphQLTypes["ProductCreateVatRateEntityRelationInput"] | undefined,
	stocks?: Array<GraphQLTypes["ProductCreateStocksEntityRelationInput"]> | undefined,
	groupPrices?: Array<GraphQLTypes["ProductCreateGroupPricesEntityRelationInput"]> | undefined,
	image?: GraphQLTypes["ProductCreateImageEntityRelationInput"] | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	cartItems?: Array<GraphQLTypes["ProductCreateCartItemsEntityRelationInput"]> | undefined,
	availability?: GraphQLTypes["ProductAvailability"] | undefined,
	order?: number | undefined,
	manager?: GraphQLTypes["ProductCreateManagerEntityRelationInput"] | undefined,
	maximumQuantityPerOrder?: number | undefined,
	inheritedCategories?: Array<GraphQLTypes["ProductCreateInheritedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["ProductCreateDeliveryZonesEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["ProductCreateLocalesEntityRelationInput"]> | undefined,
	archivedAt?: GraphQLTypes["DateTime"] | undefined,
	customerPrices?: Array<GraphQLTypes["ProductCreateCustomerPricesEntityRelationInput"]> | undefined,
	virtualProduct?: GraphQLTypes["ProductCreateVirtualProductEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["ProductCreateMetaEntityRelationInput"] | undefined,
	page?: GraphQLTypes["ProductCreatePageEntityRelationInput"] | undefined,
	salesDays?: Array<GraphQLTypes["ProductCreateSalesDaysEntityRelationInput"]> | undefined,
	salesWeeks?: Array<GraphQLTypes["ProductCreateSalesWeeksEntityRelationInput"]> | undefined,
	salesMonths?: Array<GraphQLTypes["ProductCreateSalesMonthsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["ProductCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	hasSubscription?: boolean | undefined,
	pointOfSaleTileColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["FulfillmentNoteCreateOrdersEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	create?: GraphQLTypes["OrderWithoutFulfillmentNotesCreateInput"] | undefined,
	alias?: string | undefined
};
	["OrderWithoutFulfillmentNotesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	state?: GraphQLTypes["OrderState"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	canceledAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	customer?: GraphQLTypes["OrderCreateCustomerEntityRelationInput"] | undefined,
	channel?: GraphQLTypes["OrderCreateChannelEntityRelationInput"] | undefined,
	discounts?: Array<GraphQLTypes["OrderCreateDiscountsEntityRelationInput"]> | undefined,
	delivery?: GraphQLTypes["OrderCreateDeliveryEntityRelationInput"] | undefined,
	items?: Array<GraphQLTypes["OrderCreateItemsEntityRelationInput"]> | undefined,
	internalNote?: string | undefined,
	cart?: GraphQLTypes["OrderCreateCartEntityRelationInput"] | undefined,
	events?: Array<GraphQLTypes["OrderCreateEventsEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddress?: GraphQLTypes["OrderCreateBillingAddressEntityRelationInput"] | undefined,
	priceLines?: Array<GraphQLTypes["OrderCreatePriceLinesEntityRelationInput"]> | undefined,
	payments?: Array<GraphQLTypes["OrderCreatePaymentsEntityRelationInput"]> | undefined,
	seq?: number | undefined,
	billingSubject?: GraphQLTypes["OrderCreateBillingSubjectEntityRelationInput"] | undefined,
	summary?: GraphQLTypes["OrderCreateSummaryEntityRelationInput"] | undefined,
	doubleshotLegacyId?: string | undefined,
	gratuity?: GraphQLTypes["OrderCreateGratuityEntityRelationInput"] | undefined,
	venue?: GraphQLTypes["OrderCreateVenueEntityRelationInput"] | undefined,
	fulfillmentNote?: string | undefined,
	doubleshotTotalWeightGrams?: number | undefined,
	doubleShotLegacyNumber?: string | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	doubleshotAdminUrl?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderCreateBillingSubjectEntityRelationInput"]: {
		connect?: GraphQLTypes["BillingSubjectUniqueWhere"] | undefined,
	create?: GraphQLTypes["BillingSubjectWithoutOrdersCreateInput"] | undefined
};
	["BillingSubjectWithoutOrdersCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	fullName?: string | undefined,
	addressLine1?: string | undefined,
	addressLine2?: string | undefined,
	city?: string | undefined,
	postalCode?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	companyName?: string | undefined,
	companyIdentifier?: string | undefined,
	vatIdentifier?: string | undefined,
	externalIdentifier?: string | undefined,
	hidden?: boolean | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	internalNote?: string | undefined,
	fakturoidSubjectId?: string | undefined,
	country?: GraphQLTypes["BillingSubjectCreateCountryEntityRelationInput"] | undefined,
	customer?: GraphQLTypes["BillingSubjectCreateCustomerEntityRelationInput"] | undefined,
	invoices?: Array<GraphQLTypes["BillingSubjectCreateInvoicesEntityRelationInput"]> | undefined,
	defaultBillingSubjectOfCustomer?: GraphQLTypes["BillingSubjectCreateDefaultBillingSubjectOfCustomerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BillingSubjectCreateDefaultBillingSubjectOfCustomerEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerWithoutDefaultBillingSubjectCreateInput"] | undefined
};
	["CustomerWithoutDefaultBillingSubjectCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	addresses?: Array<GraphQLTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerCreateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerCreateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerCreatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerCreateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerCreateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerCreateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerCreateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerCreateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerCreateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerCreateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreateAnonymousSessionEntityRelationInput"]: {
		connect?: GraphQLTypes["AnonymousSessionUniqueWhere"] | undefined,
	create?: GraphQLTypes["AnonymousSessionWithoutCustomerCreateInput"] | undefined
};
	["AnonymousSessionWithoutCustomerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	lastActiveAt?: GraphQLTypes["DateTime"] | undefined,
	anonymousSessionKey?: string | undefined,
	email?: string | undefined,
	name?: string | undefined,
	internalNote?: string | undefined,
	devices?: Array<GraphQLTypes["AnonymousSessionCreateDevicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["AnonymousSessionCreateDevicesEntityRelationInput"]: {
		connect?: GraphQLTypes["UserDeviceUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserDeviceWithoutAnonymousSessionCreateInput"] | undefined,
	alias?: string | undefined
};
	["UserDeviceWithoutAnonymousSessionCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	lastActiveAt?: GraphQLTypes["DateTime"] | undefined,
	platform?: string | undefined,
	deviceId?: string | undefined,
	notificationsEnabled?: boolean | undefined,
	user?: GraphQLTypes["UserDeviceCreateUserEntityRelationInput"] | undefined,
	appVersion?: string | undefined,
	osVersion?: string | undefined,
	apiVersion?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserDeviceCreateUserEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserWithoutDevicesCreateInput"] | undefined
};
	["UserWithoutDevicesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	internalNote?: string | undefined,
	staff?: GraphQLTypes["UserCreateStaffEntityRelationInput"] | undefined,
	customer?: GraphQLTypes["UserCreateCustomerEntityRelationInput"] | undefined,
	tenantPersonId?: GraphQLTypes["UUID"] | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	verifiedAt?: GraphQLTypes["DateTime"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	deletionRequestedAt?: GraphQLTypes["DateTime"] | undefined,
	deletionExpectedAt?: GraphQLTypes["DateTime"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	meta?: GraphQLTypes["UserCreateMetaEntityRelationInput"] | undefined,
	identificationAttempts?: Array<GraphQLTypes["UserCreateIdentificationAttemptsEntityRelationInput"]> | undefined,
	roles?: GraphQLTypes["UserCreateRolesEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserCreateRolesEntityRelationInput"]: {
		connect?: GraphQLTypes["UserRolesUniqueWhere"] | undefined
};
	["CustomerCreateBoughtVouchersEntityRelationInput"]: {
		connect?: GraphQLTypes["VoucherUniqueWhere"] | undefined,
	create?: GraphQLTypes["VoucherWithoutBuyerCreateInput"] | undefined,
	alias?: string | undefined
};
	["VoucherWithoutBuyerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	activatedAt?: GraphQLTypes["DateTime"] | undefined,
	expiresAt?: GraphQLTypes["DateTime"] | undefined,
	internalNote?: string | undefined,
	note?: string | undefined,
	code?: string | undefined,
	type?: GraphQLTypes["VoucherType"] | undefined,
	creditCents?: number | undefined,
	owner?: GraphQLTypes["VoucherCreateOwnerEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["VoucherCreateVatRateEntityRelationInput"] | undefined,
	virtualProductEffect?: GraphQLTypes["VoucherCreateVirtualProductEffectEntityRelationInput"] | undefined,
	redemption?: GraphQLTypes["VoucherCreateRedemptionEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["VoucherCreateOwnerEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerWithoutOwnsVouchersCreateInput"] | undefined
};
	["CustomerWithoutOwnsVouchersCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	addresses?: Array<GraphQLTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerCreateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerCreateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerCreatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerCreateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerCreateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerCreateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerCreateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerCreateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerCreateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerCreateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreateRedeemedVouchersEntityRelationInput"]: {
		connect?: GraphQLTypes["VoucherRedemptionUniqueWhere"] | undefined,
	create?: GraphQLTypes["VoucherRedemptionWithoutCustomerCreateInput"] | undefined,
	alias?: string | undefined
};
	["VoucherRedemptionWithoutCustomerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	manualRedemptionNote?: string | undefined,
	customerCredit?: GraphQLTypes["VoucherRedemptionCreateCustomerCreditEntityRelationInput"] | undefined,
	orderDiscount?: GraphQLTypes["VoucherRedemptionCreateOrderDiscountEntityRelationInput"] | undefined,
	voucher?: GraphQLTypes["VoucherRedemptionCreateVoucherEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["VoucherRedemptionCreateCustomerCreditEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerCreditUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerCreditWithoutVoucherRedemptionCreateInput"] | undefined
};
	["CustomerCreditWithoutVoucherRedemptionCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	initialCreditCents?: number | undefined,
	remainingCreditsCents?: number | undefined,
	expiresAt?: GraphQLTypes["DateTime"] | undefined,
	reason?: string | undefined,
	customer?: GraphQLTypes["CustomerCreditCreateCustomerEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["CustomerCreditCreateVatRateEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	transactions?: Array<GraphQLTypes["CustomerCreditCreateTransactionsEntityRelationInput"]> | undefined,
	invoiceUrl?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreditCreateTransactionsEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerCreditTransactionUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerCreditTransactionWithoutCustomerCreditCreateInput"] | undefined,
	alias?: string | undefined
};
	["CustomerCreditTransactionWithoutCustomerCreditCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	amountCents?: number | undefined,
	orderDiscount?: GraphQLTypes["CustomerCreditTransactionCreateOrderDiscountEntityRelationInput"] | undefined,
	virtualProductEffect?: GraphQLTypes["CustomerCreditTransactionCreateVirtualProductEffectEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreditTransactionCreateVirtualProductEffectEntityRelationInput"]: {
		connect?: GraphQLTypes["VirtualProductEffectUniqueWhere"] | undefined,
	create?: GraphQLTypes["VirtualProductEffectWithoutResultCustomerCreditTransactionCreateInput"] | undefined
};
	["VirtualProductEffectWithoutResultCustomerCreditTransactionCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	succeededAt?: GraphQLTypes["DateTime"] | undefined,
	orderItem?: GraphQLTypes["VirtualProductEffectCreateOrderItemEntityRelationInput"] | undefined,
	failedAt?: GraphQLTypes["DateTime"] | undefined,
	revertedAt?: GraphQLTypes["DateTime"] | undefined,
	resultVouchers?: Array<GraphQLTypes["VirtualProductEffectCreateResultVouchersEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["VirtualProductEffectCreateOrderItemEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["OrderItemWithoutVirtualProductEffectsCreateInput"] | undefined
};
	["OrderItemWithoutVirtualProductEffectsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unitPriceCents?: number | undefined,
	quantity?: number | undefined,
	vatRate?: GraphQLTypes["OrderItemCreateVatRateEntityRelationInput"] | undefined,
	order?: GraphQLTypes["OrderItemCreateOrderEntityRelationInput"] | undefined,
	pickedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["OrderItemCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	product?: GraphQLTypes["OrderItemCreateProductEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderItemCreateFulfillmentNotesEntityRelationInput"]: {
		connect?: GraphQLTypes["FulfillmentNoteUniqueWhere"] | undefined,
	create?: GraphQLTypes["FulfillmentNoteWithoutOrderItemsCreateInput"] | undefined,
	alias?: string | undefined
};
	["FulfillmentNoteWithoutOrderItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	note?: string | undefined,
	products?: Array<GraphQLTypes["FulfillmentNoteCreateProductsEntityRelationInput"]> | undefined,
	tags?: Array<GraphQLTypes["FulfillmentNoteCreateTagsEntityRelationInput"]> | undefined,
	venues?: Array<GraphQLTypes["FulfillmentNoteCreateVenuesEntityRelationInput"]> | undefined,
	cartItems?: Array<GraphQLTypes["FulfillmentNoteCreateCartItemsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["FulfillmentNoteCreateOrdersEntityRelationInput"]> | undefined,
	highlight?: boolean | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	emoji?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["VirtualProductEffectCreateResultVouchersEntityRelationInput"]: {
		connect?: GraphQLTypes["VoucherUniqueWhere"] | undefined,
	create?: GraphQLTypes["VoucherWithoutVirtualProductEffectCreateInput"] | undefined,
	alias?: string | undefined
};
	["VoucherWithoutVirtualProductEffectCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	activatedAt?: GraphQLTypes["DateTime"] | undefined,
	expiresAt?: GraphQLTypes["DateTime"] | undefined,
	internalNote?: string | undefined,
	note?: string | undefined,
	code?: string | undefined,
	type?: GraphQLTypes["VoucherType"] | undefined,
	creditCents?: number | undefined,
	buyer?: GraphQLTypes["VoucherCreateBuyerEntityRelationInput"] | undefined,
	owner?: GraphQLTypes["VoucherCreateOwnerEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["VoucherCreateVatRateEntityRelationInput"] | undefined,
	redemption?: GraphQLTypes["VoucherCreateRedemptionEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["VoucherCreateBuyerEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerWithoutBoughtVouchersCreateInput"] | undefined
};
	["CustomerWithoutBoughtVouchersCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	addresses?: Array<GraphQLTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerCreateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerCreateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerCreatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerCreateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerCreateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerCreateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerCreateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerCreateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerCreateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerCreateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreateOwnsVouchersEntityRelationInput"]: {
		connect?: GraphQLTypes["VoucherUniqueWhere"] | undefined,
	create?: GraphQLTypes["VoucherWithoutOwnerCreateInput"] | undefined,
	alias?: string | undefined
};
	["VoucherWithoutOwnerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	activatedAt?: GraphQLTypes["DateTime"] | undefined,
	expiresAt?: GraphQLTypes["DateTime"] | undefined,
	internalNote?: string | undefined,
	note?: string | undefined,
	code?: string | undefined,
	type?: GraphQLTypes["VoucherType"] | undefined,
	creditCents?: number | undefined,
	buyer?: GraphQLTypes["VoucherCreateBuyerEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["VoucherCreateVatRateEntityRelationInput"] | undefined,
	virtualProductEffect?: GraphQLTypes["VoucherCreateVirtualProductEffectEntityRelationInput"] | undefined,
	redemption?: GraphQLTypes["VoucherCreateRedemptionEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["VoucherCreateVatRateEntityRelationInput"]: {
		connect?: GraphQLTypes["VatRateUniqueWhere"] | undefined,
	create?: GraphQLTypes["VatRateCreateInput"] | undefined
};
	["VoucherCreateVirtualProductEffectEntityRelationInput"]: {
		connect?: GraphQLTypes["VirtualProductEffectUniqueWhere"] | undefined,
	create?: GraphQLTypes["VirtualProductEffectWithoutResultVouchersCreateInput"] | undefined
};
	["VirtualProductEffectWithoutResultVouchersCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	succeededAt?: GraphQLTypes["DateTime"] | undefined,
	orderItem?: GraphQLTypes["VirtualProductEffectCreateOrderItemEntityRelationInput"] | undefined,
	failedAt?: GraphQLTypes["DateTime"] | undefined,
	revertedAt?: GraphQLTypes["DateTime"] | undefined,
	resultCustomerCreditTransaction?: GraphQLTypes["VirtualProductEffectCreateResultCustomerCreditTransactionEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["VoucherCreateRedemptionEntityRelationInput"]: {
		connect?: GraphQLTypes["VoucherRedemptionUniqueWhere"] | undefined,
	create?: GraphQLTypes["VoucherRedemptionWithoutVoucherCreateInput"] | undefined
};
	["VoucherRedemptionWithoutVoucherCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	manualRedemptionNote?: string | undefined,
	customerCredit?: GraphQLTypes["VoucherRedemptionCreateCustomerCreditEntityRelationInput"] | undefined,
	orderDiscount?: GraphQLTypes["VoucherRedemptionCreateOrderDiscountEntityRelationInput"] | undefined,
	customer?: GraphQLTypes["VoucherRedemptionCreateCustomerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["VoucherRedemptionCreateOrderDiscountEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderDiscountUniqueWhere"] | undefined,
	create?: GraphQLTypes["OrderDiscountWithoutVoucherRedemptionCreateInput"] | undefined
};
	["OrderDiscountWithoutVoucherRedemptionCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	discountCents?: number | undefined,
	vatRate?: GraphQLTypes["OrderDiscountCreateVatRateEntityRelationInput"] | undefined,
	order?: GraphQLTypes["OrderDiscountCreateOrderEntityRelationInput"] | undefined,
	description?: string | undefined,
	type?: GraphQLTypes["OrderDiscountType"] | undefined,
	customerCreditTransactions?: Array<GraphQLTypes["OrderDiscountCreateCustomerCreditTransactionsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["VoucherRedemptionCreateCustomerEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerWithoutRedeemedVouchersCreateInput"] | undefined
};
	["CustomerWithoutRedeemedVouchersCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	addresses?: Array<GraphQLTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerCreateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerCreateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerCreatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerCreateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerCreateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerCreateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerCreateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerCreateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerCreateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerCreateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreateSpendingEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerSpendingUniqueWhere"] | undefined
};
	["CustomerCreateCustomerTabsEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerTabUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerTabWithoutCustomerCreateInput"] | undefined,
	alias?: string | undefined
};
	["CustomerTabWithoutCustomerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	color?: string | undefined,
	items?: Array<GraphQLTypes["CustomerTabCreateItemsEntityRelationInput"]> | undefined,
	name?: string | undefined,
	meta?: GraphQLTypes["CustomerTabCreateMetaEntityRelationInput"] | undefined,
	table?: GraphQLTypes["CustomerTabCreateTableEntityRelationInput"] | undefined,
	seat?: GraphQLTypes["CustomerTabCreateSeatEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerTabCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerTabItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerTabItemWithoutTabCreateInput"] | undefined,
	alias?: string | undefined
};
	["CustomerTabItemWithoutTabCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	addedAt?: GraphQLTypes["DateTime"] | undefined,
	product?: GraphQLTypes["CustomerTabItemCreateProductEntityRelationInput"] | undefined,
	paidAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerTabItemCreateProductEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductCreateInput"] | undefined
};
	["CustomerTabCreateMetaEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerTabMetadataUniqueWhere"] | undefined
};
	["CustomerTabCreateTableEntityRelationInput"]: {
		connect?: GraphQLTypes["TableUniqueWhere"] | undefined,
	create?: GraphQLTypes["TableWithoutCustomerTabsCreateInput"] | undefined
};
	["TableWithoutCustomerTabsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	shape?: GraphQLTypes["TableShape"] | undefined,
	width?: number | undefined,
	height?: number | undefined,
	positionX?: number | undefined,
	positionY?: number | undefined,
	name?: string | undefined,
	color?: string | undefined,
	area?: GraphQLTypes["TableCreateAreaEntityRelationInput"] | undefined,
	seats?: Array<GraphQLTypes["TableCreateSeatsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TableCreateAreaEntityRelationInput"]: {
		connect?: GraphQLTypes["AreaUniqueWhere"] | undefined,
	create?: GraphQLTypes["AreaWithoutTablesCreateInput"] | undefined
};
	["AreaWithoutTablesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	name?: string | undefined,
	venue?: GraphQLTypes["AreaCreateVenueEntityRelationInput"] | undefined,
	lines?: Array<GraphQLTypes["AreaCreateLinesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["AreaCreateVenueEntityRelationInput"]: {
		connect?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	create?: GraphQLTypes["VenueWithoutAreasCreateInput"] | undefined
};
	["VenueWithoutAreasCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	deadlineTemplate?: GraphQLTypes["VenueCreateDeadlineTemplateEntityRelationInput"] | undefined,
	timetableDays?: Array<GraphQLTypes["VenueCreateTimetableDaysEntityRelationInput"]> | undefined,
	timetableTemplates?: Array<GraphQLTypes["VenueCreateTimetableTemplatesEntityRelationInput"]> | undefined,
	staffMembers?: Array<GraphQLTypes["VenueCreateStaffMembersEntityRelationInput"]> | undefined,
	employeeRoles?: Array<GraphQLTypes["VenueCreateEmployeeRolesEntityRelationInput"]> | undefined,
	pointOfSaleApplicationDevices?: Array<GraphQLTypes["VenueCreatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined,
	pointOfSaleTerminals?: Array<GraphQLTypes["VenueCreatePointOfSaleTerminalsEntityRelationInput"]> | undefined,
	pointOfSalePrinters?: Array<GraphQLTypes["VenueCreatePointOfSalePrintersEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["VenueCreateOrdersEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["VenueCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	enabledUnassignReasons?: Array<GraphQLTypes["VenueCreateEnabledUnassignReasonsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["VenueCreateCategoriesEntityRelationInput"]> | undefined,
	channels?: Array<GraphQLTypes["VenueCreateChannelsEntityRelationInput"]> | undefined,
	address?: string | undefined,
	pointOfSalePngBase64ReceiptLogo?: string | undefined,
	pointOfSaleInitialView?: GraphQLTypes["PointOfSaleInitialView"] | undefined,
	pointOfSalePreferPrintReceipt?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["VenueCreateEnabledUnassignReasonsEntityRelationInput"]: {
		connect?: GraphQLTypes["UnassignReasonUniqueWhere"] | undefined,
	create?: GraphQLTypes["UnassignReasonWithoutVenuesCreateInput"] | undefined,
	alias?: string | undefined
};
	["UnassignReasonUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["UnassignReasonWithoutVenuesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	name?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["VenueCreateCategoriesEntityRelationInput"]: {
		connect?: GraphQLTypes["PointOfSaleCategoryUniqueWhere"] | undefined,
	create?: GraphQLTypes["PointOfSaleCategoryWithoutVenueCreateInput"] | undefined,
	alias?: string | undefined
};
	["PointOfSaleCategoryWithoutVenueCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	slug?: string | undefined,
	locales?: Array<GraphQLTypes["PointOfSaleCategoryCreateLocalesEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["PointOfSaleCategoryCreateProductsEntityRelationInput"]> | undefined,
	category?: GraphQLTypes["PointOfSaleCategoryCreateCategoryEntityRelationInput"] | undefined,
	ticketPrinters?: Array<GraphQLTypes["PointOfSaleCategoryCreateTicketPrintersEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleCategoryCreateCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductCategoryUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductCategoryCreateInput"] | undefined
};
	["PointOfSaleCategoryCreateTicketPrintersEntityRelationInput"]: {
		connect?: GraphQLTypes["PointOfSalePrinterUniqueWhere"] | undefined,
	create?: GraphQLTypes["PointOfSalePrinterWithoutTicketCategoriesCreateInput"] | undefined,
	alias?: string | undefined
};
	["PointOfSalePrinterWithoutTicketCategoriesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	internalName?: string | undefined,
	note?: string | undefined,
	ipAddress?: string | undefined,
	applicationDevicesReceipt?: Array<GraphQLTypes["PointOfSalePrinterCreateApplicationDevicesReceiptEntityRelationInput"]> | undefined,
	applicationDevicesTicket?: Array<GraphQLTypes["PointOfSalePrinterCreateApplicationDevicesTicketEntityRelationInput"]> | undefined,
	venue?: GraphQLTypes["PointOfSalePrinterCreateVenueEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSalePrinterCreateApplicationDevicesTicketEntityRelationInput"]: {
		connect?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined,
	create?: GraphQLTypes["PointOfSaleApplicationDeviceWithoutTicketPrintersCreateInput"] | undefined,
	alias?: string | undefined
};
	["PointOfSaleApplicationDeviceWithoutTicketPrintersCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	internalName?: string | undefined,
	note?: string | undefined,
	venue?: GraphQLTypes["PointOfSaleApplicationDeviceCreateVenueEntityRelationInput"] | undefined,
	identificationCode?: GraphQLTypes["PointOfSaleApplicationDeviceCreateIdentificationCodeEntityRelationInput"] | undefined,
	identifier?: GraphQLTypes["PointOfSaleApplicationDeviceCreateIdentifierEntityRelationInput"] | undefined,
	terminal?: GraphQLTypes["PointOfSaleApplicationDeviceCreateTerminalEntityRelationInput"] | undefined,
	receiptPrinter?: GraphQLTypes["PointOfSaleApplicationDeviceCreateReceiptPrinterEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleApplicationDeviceCreateReceiptPrinterEntityRelationInput"]: {
		connect?: GraphQLTypes["PointOfSalePrinterUniqueWhere"] | undefined,
	create?: GraphQLTypes["PointOfSalePrinterWithoutApplicationDevicesReceiptCreateInput"] | undefined
};
	["PointOfSalePrinterWithoutApplicationDevicesReceiptCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	internalName?: string | undefined,
	note?: string | undefined,
	ipAddress?: string | undefined,
	applicationDevicesTicket?: Array<GraphQLTypes["PointOfSalePrinterCreateApplicationDevicesTicketEntityRelationInput"]> | undefined,
	venue?: GraphQLTypes["PointOfSalePrinterCreateVenueEntityRelationInput"] | undefined,
	ticketCategories?: Array<GraphQLTypes["PointOfSalePrinterCreateTicketCategoriesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSalePrinterCreateVenueEntityRelationInput"]: {
		connect?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	create?: GraphQLTypes["VenueWithoutPointOfSalePrintersCreateInput"] | undefined
};
	["VenueWithoutPointOfSalePrintersCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	deadlineTemplate?: GraphQLTypes["VenueCreateDeadlineTemplateEntityRelationInput"] | undefined,
	timetableDays?: Array<GraphQLTypes["VenueCreateTimetableDaysEntityRelationInput"]> | undefined,
	timetableTemplates?: Array<GraphQLTypes["VenueCreateTimetableTemplatesEntityRelationInput"]> | undefined,
	staffMembers?: Array<GraphQLTypes["VenueCreateStaffMembersEntityRelationInput"]> | undefined,
	employeeRoles?: Array<GraphQLTypes["VenueCreateEmployeeRolesEntityRelationInput"]> | undefined,
	pointOfSaleApplicationDevices?: Array<GraphQLTypes["VenueCreatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined,
	pointOfSaleTerminals?: Array<GraphQLTypes["VenueCreatePointOfSaleTerminalsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["VenueCreateOrdersEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["VenueCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	areas?: Array<GraphQLTypes["VenueCreateAreasEntityRelationInput"]> | undefined,
	enabledUnassignReasons?: Array<GraphQLTypes["VenueCreateEnabledUnassignReasonsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["VenueCreateCategoriesEntityRelationInput"]> | undefined,
	channels?: Array<GraphQLTypes["VenueCreateChannelsEntityRelationInput"]> | undefined,
	address?: string | undefined,
	pointOfSalePngBase64ReceiptLogo?: string | undefined,
	pointOfSaleInitialView?: GraphQLTypes["PointOfSaleInitialView"] | undefined,
	pointOfSalePreferPrintReceipt?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["VenueCreateAreasEntityRelationInput"]: {
		connect?: GraphQLTypes["AreaUniqueWhere"] | undefined,
	create?: GraphQLTypes["AreaWithoutVenueCreateInput"] | undefined,
	alias?: string | undefined
};
	["AreaWithoutVenueCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	name?: string | undefined,
	tables?: Array<GraphQLTypes["AreaCreateTablesEntityRelationInput"]> | undefined,
	lines?: Array<GraphQLTypes["AreaCreateLinesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["AreaCreateTablesEntityRelationInput"]: {
		connect?: GraphQLTypes["TableUniqueWhere"] | undefined,
	create?: GraphQLTypes["TableWithoutAreaCreateInput"] | undefined,
	alias?: string | undefined
};
	["TableWithoutAreaCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	shape?: GraphQLTypes["TableShape"] | undefined,
	width?: number | undefined,
	height?: number | undefined,
	positionX?: number | undefined,
	positionY?: number | undefined,
	name?: string | undefined,
	color?: string | undefined,
	customerTabs?: Array<GraphQLTypes["TableCreateCustomerTabsEntityRelationInput"]> | undefined,
	seats?: Array<GraphQLTypes["TableCreateSeatsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TableCreateCustomerTabsEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerTabUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerTabWithoutTableCreateInput"] | undefined,
	alias?: string | undefined
};
	["CustomerTabWithoutTableCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	color?: string | undefined,
	items?: Array<GraphQLTypes["CustomerTabCreateItemsEntityRelationInput"]> | undefined,
	name?: string | undefined,
	meta?: GraphQLTypes["CustomerTabCreateMetaEntityRelationInput"] | undefined,
	customer?: GraphQLTypes["CustomerTabCreateCustomerEntityRelationInput"] | undefined,
	seat?: GraphQLTypes["CustomerTabCreateSeatEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerTabCreateCustomerEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerWithoutCustomerTabsCreateInput"] | undefined
};
	["CustomerWithoutCustomerTabsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	addresses?: Array<GraphQLTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerCreateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerCreateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerCreatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerCreateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerCreateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerCreateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerCreateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerCreateSpendingEntityRelationInput"] | undefined,
	lead?: Array<GraphQLTypes["CustomerCreateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerCreateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreateLeadEntityRelationInput"]: {
		connect?: GraphQLTypes["PipelineLeadUniqueWhere"] | undefined,
	create?: GraphQLTypes["PipelineLeadWithoutCustomerCreateInput"] | undefined,
	alias?: string | undefined
};
	["PipelineLeadWithoutCustomerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	stageItem?: GraphQLTypes["PipelineLeadCreateStageItemEntityRelationInput"] | undefined,
	contactPerson?: string | undefined,
	cafeType?: string | undefined,
	offerType?: string | undefined,
	ownMachine?: boolean | undefined,
	customerCity?: string | undefined,
	companyId?: string | undefined,
	customerName?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	form?: GraphQLTypes["PipelineLeadCreateFormEntityRelationInput"] | undefined,
	meta?: string | undefined,
	multiroasterType?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["PipelineLeadCreateStageItemEntityRelationInput"]: {
		connect?: GraphQLTypes["PipelineStageItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["PipelineStageItemWithoutLeadCreateInput"] | undefined
};
	["PipelineStageItemWithoutLeadCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	list?: GraphQLTypes["PipelineStageItemCreateListEntityRelationInput"] | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["PipelineStageItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["PipelineStageUniqueWhere"] | undefined,
	create?: GraphQLTypes["PipelineStageWithoutItemsCreateInput"] | undefined
};
	["PipelineStageWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	pipeline?: GraphQLTypes["PipelineStageCreatePipelineEntityRelationInput"] | undefined,
	order?: number | undefined,
	locales?: Array<GraphQLTypes["PipelineStageCreateLocalesEntityRelationInput"]> | undefined,
	sentiment?: GraphQLTypes["PipelineStageCreateSentimentEntityRelationInput"] | undefined,
	type?: GraphQLTypes["PipelineStageType"] | undefined,
	forms?: Array<GraphQLTypes["PipelineStageCreateFormsEntityRelationInput"]> | undefined,
	showItemsWeight?: boolean | undefined,
	showItemsPrice?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PipelineStageCreatePipelineEntityRelationInput"]: {
		connect?: GraphQLTypes["PipelineUniqueWhere"] | undefined,
	create?: GraphQLTypes["PipelineWithoutStagesCreateInput"] | undefined
};
	["PipelineUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	stages?: GraphQLTypes["PipelineStageUniqueWhere"] | undefined
};
	["PipelineWithoutStagesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PipelineStageCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["PipelineStageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["PipelineStageLocaleWithoutRootCreateInput"] | undefined,
	alias?: string | undefined
};
	["PipelineStageLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	locale?: GraphQLTypes["PipelineStageLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PipelineStageLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutPipelineStagesCreateInput"] | undefined
};
	["LocaleWithoutPipelineStagesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	businessCategories?: Array<GraphQLTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleCreateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleCreateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreateSubscriptionBoxesEntityRelationInput"]: {
		connect?: GraphQLTypes["SubscriptionBoxLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["SubscriptionBoxLocaleWithoutLocaleCreateInput"] | undefined,
	alias?: string | undefined
};
	["SubscriptionBoxLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	stickerText?: string | undefined,
	descriptionText?: string | undefined,
	root?: GraphQLTypes["SubscriptionBoxLocaleCreateRootEntityRelationInput"] | undefined,
	secondaryTitle?: string | undefined,
	texts?: GraphQLTypes["SubscriptionBoxLocaleCreateTextsEntityRelationInput"] | undefined,
	secondaryTexts?: GraphQLTypes["SubscriptionBoxLocaleCreateSecondaryTextsEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SubscriptionBoxLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["SubscriptionBoxUniqueWhere"] | undefined,
	create?: GraphQLTypes["SubscriptionBoxWithoutLocalesCreateInput"] | undefined
};
	["SubscriptionBoxWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SubscriptionBoxLocaleCreateTextsEntityRelationInput"]: {
		connect?: GraphQLTypes["TextListUniqueWhere"] | undefined,
	create?: GraphQLTypes["TextListCreateInput"] | undefined
};
	["SubscriptionBoxLocaleCreateSecondaryTextsEntityRelationInput"]: {
		connect?: GraphQLTypes["TextListUniqueWhere"] | undefined,
	create?: GraphQLTypes["TextListCreateInput"] | undefined
};
	["LocaleCreateBusinessServicesEntityRelationInput"]: {
		connect?: GraphQLTypes["BusinessServiceLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["BusinessServiceLocaleWithoutLocaleCreateInput"] | undefined,
	alias?: string | undefined
};
	["BusinessServiceLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	labelNote?: string | undefined,
	root?: GraphQLTypes["BusinessServiceLocaleCreateRootEntityRelationInput"] | undefined,
	labelNumberOfPeople?: string | undefined,
	labelInvoiced?: string | undefined,
	labelEquipment?: string | undefined,
	labelMillTamDem?: string | undefined,
	labelSOEspresso?: string | undefined,
	labelFilterCoffeeInMenu?: string | undefined,
	labelWaterMeterStatus?: string | undefined,
	labelServiceAction?: string | undefined,
	labelInvoiceIdentifier?: string | undefined,
	labelSupervisor?: string | undefined,
	labelContact?: string | undefined,
	labelPhone?: string | undefined,
	labelEmail?: string | undefined,
	labelGrindingStonesCondition?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessServiceLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["BusinessServiceUniqueWhere"] | undefined,
	create?: GraphQLTypes["BusinessServiceWithoutLocalesCreateInput"] | undefined
};
	["BusinessServiceWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	requireNote?: number | undefined,
	requireNumberOfPeople?: number | undefined,
	requireInvoiced?: number | undefined,
	requireEquipment?: number | undefined,
	requireMillTamDem?: number | undefined,
	requireSOEspresso?: number | undefined,
	requireFilterCoffeeInMenu?: number | undefined,
	requireWaterMeterStatus?: number | undefined,
	requireServiceAction?: number | undefined,
	optionsEquipment?: string | undefined,
	optionsServiceAction?: string | undefined,
	requireInvoiceIdentifier?: number | undefined,
	requireSupervisor?: number | undefined,
	requireContact?: number | undefined,
	requirePhone?: number | undefined,
	requireEmail?: number | undefined,
	requireGrindingStonesCondition?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["PipelineStageCreateSentimentEntityRelationInput"]: {
		connect?: GraphQLTypes["PipelineStageSentimentUniqueWhere"] | undefined,
	create?: GraphQLTypes["PipelineStageSentimentCreateInput"] | undefined
};
	["PipelineStageSentimentUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["PipelineStageSentimentCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	internalName?: string | undefined,
	backgroundColor?: string | undefined,
	textColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["PipelineStageCreateFormsEntityRelationInput"]: {
		connect?: GraphQLTypes["LeadFormUniqueWhere"] | undefined,
	create?: GraphQLTypes["LeadFormWithoutStageCreateInput"] | undefined,
	alias?: string | undefined
};
	["LeadFormWithoutStageCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	leads?: Array<GraphQLTypes["LeadFormCreateLeadsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LeadFormCreateLeadsEntityRelationInput"]: {
		connect?: GraphQLTypes["PipelineLeadUniqueWhere"] | undefined,
	create?: GraphQLTypes["PipelineLeadWithoutFormCreateInput"] | undefined,
	alias?: string | undefined
};
	["PipelineLeadWithoutFormCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	stageItem?: GraphQLTypes["PipelineLeadCreateStageItemEntityRelationInput"] | undefined,
	contactPerson?: string | undefined,
	customer?: GraphQLTypes["PipelineLeadCreateCustomerEntityRelationInput"] | undefined,
	cafeType?: string | undefined,
	offerType?: string | undefined,
	ownMachine?: boolean | undefined,
	customerCity?: string | undefined,
	companyId?: string | undefined,
	customerName?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	meta?: string | undefined,
	multiroasterType?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["PipelineLeadCreateCustomerEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerWithoutLeadCreateInput"] | undefined
};
	["CustomerWithoutLeadCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	addresses?: Array<GraphQLTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerCreateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerCreateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerCreatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerCreateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerCreateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerCreateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerCreateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerCreateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerCreateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreateMetaEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerMetadataUniqueWhere"] | undefined
};
	["PipelineLeadCreateFormEntityRelationInput"]: {
		connect?: GraphQLTypes["LeadFormUniqueWhere"] | undefined,
	create?: GraphQLTypes["LeadFormWithoutLeadsCreateInput"] | undefined
};
	["LeadFormWithoutLeadsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	stage?: GraphQLTypes["LeadFormCreateStageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LeadFormCreateStageEntityRelationInput"]: {
		connect?: GraphQLTypes["PipelineStageUniqueWhere"] | undefined,
	create?: GraphQLTypes["PipelineStageWithoutFormsCreateInput"] | undefined
};
	["PipelineStageWithoutFormsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["PipelineStageCreateItemsEntityRelationInput"]> | undefined,
	pipeline?: GraphQLTypes["PipelineStageCreatePipelineEntityRelationInput"] | undefined,
	order?: number | undefined,
	locales?: Array<GraphQLTypes["PipelineStageCreateLocalesEntityRelationInput"]> | undefined,
	sentiment?: GraphQLTypes["PipelineStageCreateSentimentEntityRelationInput"] | undefined,
	type?: GraphQLTypes["PipelineStageType"] | undefined,
	showItemsWeight?: boolean | undefined,
	showItemsPrice?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PipelineStageCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["PipelineStageItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["PipelineStageItemWithoutListCreateInput"] | undefined,
	alias?: string | undefined
};
	["PipelineStageItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	lead?: GraphQLTypes["PipelineStageItemCreateLeadEntityRelationInput"] | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["PipelineStageItemCreateLeadEntityRelationInput"]: {
		connect?: GraphQLTypes["PipelineLeadUniqueWhere"] | undefined,
	create?: GraphQLTypes["PipelineLeadWithoutStageItemCreateInput"] | undefined
};
	["PipelineLeadWithoutStageItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	contactPerson?: string | undefined,
	customer?: GraphQLTypes["PipelineLeadCreateCustomerEntityRelationInput"] | undefined,
	cafeType?: string | undefined,
	offerType?: string | undefined,
	ownMachine?: boolean | undefined,
	customerCity?: string | undefined,
	companyId?: string | undefined,
	customerName?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	form?: GraphQLTypes["PipelineLeadCreateFormEntityRelationInput"] | undefined,
	meta?: string | undefined,
	multiroasterType?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerTabCreateSeatEntityRelationInput"]: {
		connect?: GraphQLTypes["SeatUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeatWithoutCustomerTabsCreateInput"] | undefined
};
	["SeatWithoutCustomerTabsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	positionX?: number | undefined,
	positionY?: number | undefined,
	name?: string | undefined,
	color?: string | undefined,
	table?: GraphQLTypes["SeatCreateTableEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeatCreateTableEntityRelationInput"]: {
		connect?: GraphQLTypes["TableUniqueWhere"] | undefined,
	create?: GraphQLTypes["TableWithoutSeatsCreateInput"] | undefined
};
	["TableWithoutSeatsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	shape?: GraphQLTypes["TableShape"] | undefined,
	width?: number | undefined,
	height?: number | undefined,
	positionX?: number | undefined,
	positionY?: number | undefined,
	name?: string | undefined,
	color?: string | undefined,
	customerTabs?: Array<GraphQLTypes["TableCreateCustomerTabsEntityRelationInput"]> | undefined,
	area?: GraphQLTypes["TableCreateAreaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TableCreateSeatsEntityRelationInput"]: {
		connect?: GraphQLTypes["SeatUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeatWithoutTableCreateInput"] | undefined,
	alias?: string | undefined
};
	["SeatWithoutTableCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	positionX?: number | undefined,
	positionY?: number | undefined,
	name?: string | undefined,
	color?: string | undefined,
	customerTabs?: Array<GraphQLTypes["SeatCreateCustomerTabsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeatCreateCustomerTabsEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerTabUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerTabWithoutSeatCreateInput"] | undefined,
	alias?: string | undefined
};
	["CustomerTabWithoutSeatCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	color?: string | undefined,
	items?: Array<GraphQLTypes["CustomerTabCreateItemsEntityRelationInput"]> | undefined,
	name?: string | undefined,
	meta?: GraphQLTypes["CustomerTabCreateMetaEntityRelationInput"] | undefined,
	customer?: GraphQLTypes["CustomerTabCreateCustomerEntityRelationInput"] | undefined,
	table?: GraphQLTypes["CustomerTabCreateTableEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["AreaCreateLinesEntityRelationInput"]: {
		connect?: GraphQLTypes["LineUniqueWhere"] | undefined,
	create?: GraphQLTypes["LineWithoutAreaCreateInput"] | undefined,
	alias?: string | undefined
};
	["LineWithoutAreaCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	positionStartX?: number | undefined,
	positionStartY?: number | undefined,
	positionEndX?: number | undefined,
	positionEndY?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["VenueCreateChannelsEntityRelationInput"]: {
		connect?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	create?: GraphQLTypes["ChannelWithoutVenueCreateInput"] | undefined,
	alias?: string | undefined
};
	["ChannelWithoutVenueCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	disabled?: boolean | undefined,
	payments?: Array<GraphQLTypes["ChannelCreatePaymentsEntityRelationInput"]> | undefined,
	deliveries?: Array<GraphQLTypes["ChannelCreateDeliveriesEntityRelationInput"]> | undefined,
	pointOfSales?: Array<GraphQLTypes["ChannelCreatePointOfSalesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["ChannelCreateCartsEntityRelationInput"]> | undefined,
	customers?: Array<GraphQLTypes["ChannelCreateCustomersEntityRelationInput"]> | undefined,
	code?: GraphQLTypes["ChannelCode"] | undefined,
	addTagsOnRegistration?: Array<GraphQLTypes["ChannelCreateAddTagsOnRegistrationEntityRelationInput"]> | undefined,
	publicTags?: Array<GraphQLTypes["ChannelCreatePublicTagsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSalePrinterCreateTicketCategoriesEntityRelationInput"]: {
		connect?: GraphQLTypes["PointOfSaleCategoryUniqueWhere"] | undefined,
	create?: GraphQLTypes["PointOfSaleCategoryWithoutTicketPrintersCreateInput"] | undefined,
	alias?: string | undefined
};
	["PointOfSaleCategoryWithoutTicketPrintersCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	slug?: string | undefined,
	locales?: Array<GraphQLTypes["PointOfSaleCategoryCreateLocalesEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["PointOfSaleCategoryCreateProductsEntityRelationInput"]> | undefined,
	category?: GraphQLTypes["PointOfSaleCategoryCreateCategoryEntityRelationInput"] | undefined,
	venue?: GraphQLTypes["PointOfSaleCategoryCreateVenueEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleCategoryCreateVenueEntityRelationInput"]: {
		connect?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	create?: GraphQLTypes["VenueWithoutCategoriesCreateInput"] | undefined
};
	["VenueWithoutCategoriesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	deadlineTemplate?: GraphQLTypes["VenueCreateDeadlineTemplateEntityRelationInput"] | undefined,
	timetableDays?: Array<GraphQLTypes["VenueCreateTimetableDaysEntityRelationInput"]> | undefined,
	timetableTemplates?: Array<GraphQLTypes["VenueCreateTimetableTemplatesEntityRelationInput"]> | undefined,
	staffMembers?: Array<GraphQLTypes["VenueCreateStaffMembersEntityRelationInput"]> | undefined,
	employeeRoles?: Array<GraphQLTypes["VenueCreateEmployeeRolesEntityRelationInput"]> | undefined,
	pointOfSaleApplicationDevices?: Array<GraphQLTypes["VenueCreatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined,
	pointOfSaleTerminals?: Array<GraphQLTypes["VenueCreatePointOfSaleTerminalsEntityRelationInput"]> | undefined,
	pointOfSalePrinters?: Array<GraphQLTypes["VenueCreatePointOfSalePrintersEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["VenueCreateOrdersEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["VenueCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	areas?: Array<GraphQLTypes["VenueCreateAreasEntityRelationInput"]> | undefined,
	enabledUnassignReasons?: Array<GraphQLTypes["VenueCreateEnabledUnassignReasonsEntityRelationInput"]> | undefined,
	channels?: Array<GraphQLTypes["VenueCreateChannelsEntityRelationInput"]> | undefined,
	address?: string | undefined,
	pointOfSalePngBase64ReceiptLogo?: string | undefined,
	pointOfSaleInitialView?: GraphQLTypes["PointOfSaleInitialView"] | undefined,
	pointOfSalePreferPrintReceipt?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["VoucherRedemptionCreateVoucherEntityRelationInput"]: {
		connect?: GraphQLTypes["VoucherUniqueWhere"] | undefined,
	create?: GraphQLTypes["VoucherWithoutRedemptionCreateInput"] | undefined
};
	["VoucherWithoutRedemptionCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	activatedAt?: GraphQLTypes["DateTime"] | undefined,
	expiresAt?: GraphQLTypes["DateTime"] | undefined,
	internalNote?: string | undefined,
	note?: string | undefined,
	code?: string | undefined,
	type?: GraphQLTypes["VoucherType"] | undefined,
	creditCents?: number | undefined,
	buyer?: GraphQLTypes["VoucherCreateBuyerEntityRelationInput"] | undefined,
	owner?: GraphQLTypes["VoucherCreateOwnerEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["VoucherCreateVatRateEntityRelationInput"] | undefined,
	virtualProductEffect?: GraphQLTypes["VoucherCreateVirtualProductEffectEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderCreateFulfillmentNotesEntityRelationInput"]: {
		connect?: GraphQLTypes["FulfillmentNoteUniqueWhere"] | undefined,
	create?: GraphQLTypes["FulfillmentNoteWithoutOrdersCreateInput"] | undefined,
	alias?: string | undefined
};
	["FulfillmentNoteWithoutOrdersCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	note?: string | undefined,
	products?: Array<GraphQLTypes["FulfillmentNoteCreateProductsEntityRelationInput"]> | undefined,
	tags?: Array<GraphQLTypes["FulfillmentNoteCreateTagsEntityRelationInput"]> | undefined,
	venues?: Array<GraphQLTypes["FulfillmentNoteCreateVenuesEntityRelationInput"]> | undefined,
	cartItems?: Array<GraphQLTypes["FulfillmentNoteCreateCartItemsEntityRelationInput"]> | undefined,
	orderItems?: Array<GraphQLTypes["FulfillmentNoteCreateOrderItemsEntityRelationInput"]> | undefined,
	highlight?: boolean | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	emoji?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderPaymentCreateVatRateEntityRelationInput"]: {
		connect?: GraphQLTypes["VatRateUniqueWhere"] | undefined,
	create?: GraphQLTypes["VatRateCreateInput"] | undefined
};
	["OrderPaymentCreateMetaEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderPaymentMetadataUniqueWhere"] | undefined
};
	["OrderDeliveryCreateEventsEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderEventUniqueWhere"] | undefined,
	create?: GraphQLTypes["OrderEventWithoutDeliveryCreateInput"] | undefined,
	alias?: string | undefined
};
	["OrderEventWithoutDeliveryCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: string | undefined,
	data?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	order?: GraphQLTypes["OrderEventCreateOrderEntityRelationInput"] | undefined,
	payment?: GraphQLTypes["OrderEventCreatePaymentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderDeliveryCreateLiftagoRideEntityRelationInput"]: {
		connect?: GraphQLTypes["LiftagoRideUniqueWhere"] | undefined,
	create?: GraphQLTypes["LiftagoRideWithoutDeliveryCreateInput"] | undefined
};
	["LiftagoRideWithoutDeliveryCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	liftagoId?: string | undefined,
	data?: string | undefined,
	updatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderDeliveryCreateWoltDriveDeliveryEntityRelationInput"]: {
		connect?: GraphQLTypes["WoltDriveDeliveryUniqueWhere"] | undefined,
	create?: GraphQLTypes["WoltDriveDeliveryWithoutDeliveryCreateInput"] | undefined
};
	["WoltDriveDeliveryWithoutDeliveryCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	state?: GraphQLTypes["WoltDriveDeliveryState"] | undefined,
	shipmentPromiseId?: string | undefined,
	deliveryPrice?: number | undefined,
	deliveryPriceCurrency?: string | undefined,
	shipmentPromiseResponse?: string | undefined,
	deliveryOrderId?: string | undefined,
	trackingUrl?: string | undefined,
	deliverOrderResponse?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["AddressCreateDefaultDeliveryAddressOfCustomerEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerWithoutDefaultDeliveryAddressCreateInput"] | undefined
};
	["CustomerWithoutDefaultDeliveryAddressCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	addresses?: Array<GraphQLTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerCreateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerCreateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerCreatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerCreateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerCreateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerCreateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerCreateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerCreateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerCreateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerCreateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderEventCreateDeliveryEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderDeliveryUniqueWhere"] | undefined,
	create?: GraphQLTypes["OrderDeliveryWithoutEventsCreateInput"] | undefined
};
	["OrderDeliveryWithoutEventsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	priceCents?: number | undefined,
	deliveredAt?: GraphQLTypes["DateTime"] | undefined,
	method?: GraphQLTypes["OrderDeliveryCreateMethodEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["OrderDeliveryCreateVatRateEntityRelationInput"] | undefined,
	order?: GraphQLTypes["OrderDeliveryCreateOrderEntityRelationInput"] | undefined,
	expectedAt?: GraphQLTypes["DateTime"] | undefined,
	state?: GraphQLTypes["OrderDeliveryState"] | undefined,
	loadingDurationHours?: number | undefined,
	dispatchAt?: GraphQLTypes["DateTime"] | undefined,
	duration?: string | undefined,
	window?: string | undefined,
	expectedEndAt?: GraphQLTypes["DateTime"] | undefined,
	processingAt?: GraphQLTypes["DateTime"] | undefined,
	deliveringAt?: GraphQLTypes["DateTime"] | undefined,
	failedAt?: GraphQLTypes["DateTime"] | undefined,
	internalNote?: string | undefined,
	deliveryWaypoint?: GraphQLTypes["OrderDeliveryCreateDeliveryWaypointEntityRelationInput"] | undefined,
	prepareAt?: GraphQLTypes["DateTime"] | undefined,
	liftagoRide?: GraphQLTypes["OrderDeliveryCreateLiftagoRideEntityRelationInput"] | undefined,
	pickedAt?: GraphQLTypes["DateTime"] | undefined,
	address?: GraphQLTypes["OrderDeliveryCreateAddressEntityRelationInput"] | undefined,
	trackingCode?: string | undefined,
	woltDriveDelivery?: GraphQLTypes["OrderDeliveryCreateWoltDriveDeliveryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderDeliveryCreateAddressEntityRelationInput"]: {
		connect?: GraphQLTypes["AddressUniqueWhere"] | undefined,
	create?: GraphQLTypes["AddressWithoutDeliveryAddressOfOrderDeliveriesCreateInput"] | undefined
};
	["AddressWithoutDeliveryAddressOfOrderDeliveriesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	firstName?: string | undefined,
	lastName?: string | undefined,
	addressLine2?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	companyName?: string | undefined,
	companyIdentifier?: string | undefined,
	vatIdentifier?: string | undefined,
	externalIdentifier?: string | undefined,
	hidden?: boolean | undefined,
	customer?: GraphQLTypes["AddressCreateCustomerEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	country?: GraphQLTypes["AddressCreateCountryEntityRelationInput"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	googlePlaceId?: string | undefined,
	raw?: string | undefined,
	formatted?: string | undefined,
	geocodeGeneratedAt?: GraphQLTypes["DateTime"] | undefined,
	geocodeResponse?: string | undefined,
	deliveryZone?: GraphQLTypes["AddressCreateDeliveryZoneEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["AddressCreateMetaEntityRelationInput"] | undefined,
	gps?: GraphQLTypes["AddressCreateGpsEntityRelationInput"] | undefined,
	geocodeValid?: boolean | undefined,
	fullName?: string | undefined,
	fakturoidSubjectId?: string | undefined,
	invoices?: Array<GraphQLTypes["AddressCreateInvoicesEntityRelationInput"]> | undefined,
	addressLine1?: string | undefined,
	city?: string | undefined,
	postalCode?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddressOfOrders?: Array<GraphQLTypes["AddressCreateBillingAddressOfOrdersEntityRelationInput"]> | undefined,
	defaultDeliveryAddressOfCustomer?: GraphQLTypes["AddressCreateDefaultDeliveryAddressOfCustomerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CartCreateDeliveryAddressEntityRelationInput"]: {
		connect?: GraphQLTypes["AddressUniqueWhere"] | undefined,
	create?: GraphQLTypes["AddressCreateInput"] | undefined
};
	["CartCreateBillingAddressEntityRelationInput"]: {
		connect?: GraphQLTypes["AddressUniqueWhere"] | undefined,
	create?: GraphQLTypes["AddressCreateInput"] | undefined
};
	["CartCreateDeliveryEntityRelationInput"]: {
		connect?: GraphQLTypes["ChannelDeliveryUniqueWhere"] | undefined,
	create?: GraphQLTypes["ChannelDeliveryCreateInput"] | undefined
};
	["ChannelDeliveryCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	priceCents?: number | undefined,
	channel?: GraphQLTypes["ChannelDeliveryCreateChannelEntityRelationInput"] | undefined,
	method?: GraphQLTypes["ChannelDeliveryCreateMethodEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["ChannelDeliveryCreateVatRateEntityRelationInput"] | undefined,
	defaultVisible?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["CartCreatePaymentEntityRelationInput"]: {
		connect?: GraphQLTypes["ChannelPaymentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ChannelPaymentCreateInput"] | undefined
};
	["ChannelPaymentCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	channel?: GraphQLTypes["ChannelPaymentCreateChannelEntityRelationInput"] | undefined,
	method?: GraphQLTypes["ChannelPaymentCreateMethodEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["ChannelPaymentCreateVatRateEntityRelationInput"] | undefined,
	requireBillingAddress?: boolean | undefined,
	provideReceipt?: boolean | undefined,
	requireBillingSubject?: boolean | undefined,
	allowOnlyForTags?: Array<GraphQLTypes["ChannelPaymentCreateAllowOnlyForTagsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["CartCreateBillingSubjectEntityRelationInput"]: {
		connect?: GraphQLTypes["BillingSubjectUniqueWhere"] | undefined,
	create?: GraphQLTypes["BillingSubjectCreateInput"] | undefined
};
	["BillingSubjectCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	fullName?: string | undefined,
	addressLine1?: string | undefined,
	addressLine2?: string | undefined,
	city?: string | undefined,
	postalCode?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	companyName?: string | undefined,
	companyIdentifier?: string | undefined,
	vatIdentifier?: string | undefined,
	externalIdentifier?: string | undefined,
	hidden?: boolean | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	internalNote?: string | undefined,
	fakturoidSubjectId?: string | undefined,
	country?: GraphQLTypes["BillingSubjectCreateCountryEntityRelationInput"] | undefined,
	customer?: GraphQLTypes["BillingSubjectCreateCustomerEntityRelationInput"] | undefined,
	invoices?: Array<GraphQLTypes["BillingSubjectCreateInvoicesEntityRelationInput"]> | undefined,
	defaultBillingSubjectOfCustomer?: GraphQLTypes["BillingSubjectCreateDefaultBillingSubjectOfCustomerEntityRelationInput"] | undefined,
	orders?: Array<GraphQLTypes["BillingSubjectCreateOrdersEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["CartCreatePriceLinesEntityRelationInput"]: {
		connect?: GraphQLTypes["CartPriceLineUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CartCreateSummaryEntityRelationInput"]: {
		connect?: GraphQLTypes["CartSummaryUniqueWhere"] | undefined
};
	["OrderDiscountCreateVoucherRedemptionEntityRelationInput"]: {
		connect?: GraphQLTypes["VoucherRedemptionUniqueWhere"] | undefined,
	create?: GraphQLTypes["VoucherRedemptionWithoutOrderDiscountCreateInput"] | undefined
};
	["VoucherRedemptionWithoutOrderDiscountCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	manualRedemptionNote?: string | undefined,
	customerCredit?: GraphQLTypes["VoucherRedemptionCreateCustomerCreditEntityRelationInput"] | undefined,
	voucher?: GraphQLTypes["VoucherRedemptionCreateVoucherEntityRelationInput"] | undefined,
	customer?: GraphQLTypes["VoucherRedemptionCreateCustomerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleApplicationDeviceCreateTicketPrintersEntityRelationInput"]: {
		connect?: GraphQLTypes["PointOfSalePrinterUniqueWhere"] | undefined,
	create?: GraphQLTypes["PointOfSalePrinterWithoutApplicationDevicesTicketCreateInput"] | undefined,
	alias?: string | undefined
};
	["PointOfSalePrinterWithoutApplicationDevicesTicketCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	internalName?: string | undefined,
	note?: string | undefined,
	ipAddress?: string | undefined,
	applicationDevicesReceipt?: Array<GraphQLTypes["PointOfSalePrinterCreateApplicationDevicesReceiptEntityRelationInput"]> | undefined,
	venue?: GraphQLTypes["PointOfSalePrinterCreateVenueEntityRelationInput"] | undefined,
	ticketCategories?: Array<GraphQLTypes["PointOfSalePrinterCreateTicketCategoriesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleCreatePipelineStagesEntityRelationInput"]: {
		connect?: GraphQLTypes["PipelineStageLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["PipelineStageLocaleWithoutLocaleCreateInput"] | undefined,
	alias?: string | undefined
};
	["PipelineStageLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	root?: GraphQLTypes["PipelineStageLocaleCreateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PipelineStageLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["PipelineStageUniqueWhere"] | undefined,
	create?: GraphQLTypes["PipelineStageWithoutLocalesCreateInput"] | undefined
};
	["PipelineStageWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["PipelineStageCreateItemsEntityRelationInput"]> | undefined,
	pipeline?: GraphQLTypes["PipelineStageCreatePipelineEntityRelationInput"] | undefined,
	order?: number | undefined,
	sentiment?: GraphQLTypes["PipelineStageCreateSentimentEntityRelationInput"] | undefined,
	type?: GraphQLTypes["PipelineStageType"] | undefined,
	forms?: Array<GraphQLTypes["PipelineStageCreateFormsEntityRelationInput"]> | undefined,
	showItemsWeight?: boolean | undefined,
	showItemsPrice?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleCategoryProductCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["PointOfSaleCategoryProductLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["PointOfSaleCategoryProductLocaleWithoutRootCreateInput"] | undefined,
	alias?: string | undefined
};
	["PointOfSaleCategoryProductLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	locale?: GraphQLTypes["PointOfSaleCategoryProductLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleCategoryProductLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutPointOfSaleCategoryProductsCreateInput"] | undefined
};
	["LocaleWithoutPointOfSaleCategoryProductsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	businessCategories?: Array<GraphQLTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleCreateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleCreateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductRecipeCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductRecipeLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductRecipeLocaleWithoutRootCreateInput"] | undefined,
	alias?: string | undefined
};
	["ProductRecipeLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	locale?: GraphQLTypes["ProductRecipeLocaleCreateLocaleEntityRelationInput"] | undefined,
	description?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductRecipeLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutProductRecipesCreateInput"] | undefined
};
	["LocaleWithoutProductRecipesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	businessCategories?: Array<GraphQLTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleCreateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleCreateProductsEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableShiftGroupCreateGeneratedByTemplateEntityRelationInput"]: {
		connect?: GraphQLTypes["TimetableTemplateUniqueWhere"] | undefined,
	create?: GraphQLTypes["TimetableTemplateCreateInput"] | undefined
};
	["TimetableTemplateCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	startDate?: GraphQLTypes["Date"] | undefined,
	period?: number | undefined,
	slots?: number | undefined,
	position?: GraphQLTypes["TimetableTemplateCreatePositionEntityRelationInput"] | undefined,
	staffOptions?: Array<GraphQLTypes["TimetableTemplateCreateStaffOptionsEntityRelationInput"]> | undefined,
	internalName?: string | undefined,
	venue?: GraphQLTypes["TimetableTemplateCreateVenueEntityRelationInput"] | undefined,
	employeeRole?: GraphQLTypes["TimetableTemplateCreateEmployeeRoleEntityRelationInput"] | undefined,
	workdaysOnly?: boolean | undefined,
	monday?: boolean | undefined,
	tuesday?: boolean | undefined,
	wednesday?: boolean | undefined,
	thursday?: boolean | undefined,
	friday?: boolean | undefined,
	saturday?: boolean | undefined,
	sunday?: boolean | undefined,
	type?: GraphQLTypes["TemplateType"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableShiftCreateQueueItemEntityRelationInput"]: {
		connect?: GraphQLTypes["EmployeeQueueItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["EmployeeQueueItemWithoutShiftCreateInput"] | undefined
};
	["EmployeeQueueItemWithoutShiftCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	start?: string | undefined,
	end?: string | undefined,
	queue?: GraphQLTypes["EmployeeQueueItemCreateQueueEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["EmployeeQueueItemCreateShiftsProfileEntityRelationInput"] | undefined,
	unassignInfo?: GraphQLTypes["EmployeeQueueItemCreateUnassignInfoEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["EmployeeQueueItemCreateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["EmployeeQueueItemCreateUnassignInfoEntityRelationInput"]: {
		connect?: GraphQLTypes["UnassignedShiftInfoUniqueWhere"] | undefined,
	create?: GraphQLTypes["UnassignedShiftInfoWithoutQueueItemCreateInput"] | undefined
};
	["UnassignedShiftInfoWithoutQueueItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	hoursMissed?: number | undefined,
	legacyReason?: GraphQLTypes["UnassignedInfoReason"] | undefined,
	reason?: GraphQLTypes["UnassignedShiftInfoCreateReasonEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UnassignedShiftInfoCreateReasonEntityRelationInput"]: {
		connect?: GraphQLTypes["UnassignReasonUniqueWhere"] | undefined,
	create?: GraphQLTypes["UnassignReasonCreateInput"] | undefined
};
	["UnassignReasonCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	name?: string | undefined,
	venues?: Array<GraphQLTypes["UnassignReasonCreateVenuesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["UnassignReasonCreateVenuesEntityRelationInput"]: {
		connect?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	create?: GraphQLTypes["VenueWithoutEnabledUnassignReasonsCreateInput"] | undefined,
	alias?: string | undefined
};
	["VenueWithoutEnabledUnassignReasonsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	deadlineTemplate?: GraphQLTypes["VenueCreateDeadlineTemplateEntityRelationInput"] | undefined,
	timetableDays?: Array<GraphQLTypes["VenueCreateTimetableDaysEntityRelationInput"]> | undefined,
	timetableTemplates?: Array<GraphQLTypes["VenueCreateTimetableTemplatesEntityRelationInput"]> | undefined,
	staffMembers?: Array<GraphQLTypes["VenueCreateStaffMembersEntityRelationInput"]> | undefined,
	employeeRoles?: Array<GraphQLTypes["VenueCreateEmployeeRolesEntityRelationInput"]> | undefined,
	pointOfSaleApplicationDevices?: Array<GraphQLTypes["VenueCreatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined,
	pointOfSaleTerminals?: Array<GraphQLTypes["VenueCreatePointOfSaleTerminalsEntityRelationInput"]> | undefined,
	pointOfSalePrinters?: Array<GraphQLTypes["VenueCreatePointOfSalePrintersEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["VenueCreateOrdersEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["VenueCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	areas?: Array<GraphQLTypes["VenueCreateAreasEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["VenueCreateCategoriesEntityRelationInput"]> | undefined,
	channels?: Array<GraphQLTypes["VenueCreateChannelsEntityRelationInput"]> | undefined,
	address?: string | undefined,
	pointOfSalePngBase64ReceiptLogo?: string | undefined,
	pointOfSaleInitialView?: GraphQLTypes["PointOfSaleInitialView"] | undefined,
	pointOfSalePreferPrintReceipt?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["EmployeeQueueItemCreateMetaEntityRelationInput"]: {
		connect?: GraphQLTypes["EmployeeQueueItemMetadataUniqueWhere"] | undefined
};
	["TimetableShiftCreateSwapInfoEntityRelationInput"]: {
		connect?: GraphQLTypes["TimetableShiftSwapInfoUniqueWhere"] | undefined,
	create?: GraphQLTypes["TimetableShiftSwapInfoWithoutShiftCreateInput"] | undefined
};
	["TimetableShiftSwapInfoWithoutShiftCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	assigned?: GraphQLTypes["Date"] | undefined,
	requested?: boolean | undefined,
	confirmed?: boolean | undefined,
	swappedShiftsProfile?: GraphQLTypes["TimetableShiftSwapInfoCreateSwappedShiftsProfileEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableShiftSwapInfoCreateSwappedShiftsProfileEntityRelationInput"]: {
		connect?: GraphQLTypes["ShiftsProfileUniqueWhere"] | undefined,
	create?: GraphQLTypes["ShiftsProfileCreateInput"] | undefined
};
	["EmployeeQueueItemCreateShiftEntityRelationInput"]: {
		connect?: GraphQLTypes["TimetableShiftUniqueWhere"] | undefined,
	create?: GraphQLTypes["TimetableShiftWithoutQueueItemCreateInput"] | undefined
};
	["TimetableShiftWithoutQueueItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locked?: boolean | undefined,
	order?: number | undefined,
	assigned?: GraphQLTypes["Date"] | undefined,
	group?: GraphQLTypes["TimetableShiftCreateGroupEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["TimetableShiftCreateShiftsProfileEntityRelationInput"] | undefined,
	swapInfo?: GraphQLTypes["TimetableShiftCreateSwapInfoEntityRelationInput"] | undefined,
	isOvertime?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableDayCreateMetaEntityRelationInput"]: {
		connect?: GraphQLTypes["TimetableDayMetadataUniqueWhere"] | undefined
};
	["DeliveryZoneCreateAddressesMetadataEntityRelationInput"]: {
		connect?: GraphQLTypes["AddressMetadataUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CustomerCreditCreateVoucherRedemptionEntityRelationInput"]: {
		connect?: GraphQLTypes["VoucherRedemptionUniqueWhere"] | undefined,
	create?: GraphQLTypes["VoucherRedemptionWithoutCustomerCreditCreateInput"] | undefined
};
	["VoucherRedemptionWithoutCustomerCreditCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	manualRedemptionNote?: string | undefined,
	orderDiscount?: GraphQLTypes["VoucherRedemptionCreateOrderDiscountEntityRelationInput"] | undefined,
	voucher?: GraphQLTypes["VoucherRedemptionCreateVoucherEntityRelationInput"] | undefined,
	customer?: GraphQLTypes["VoucherRedemptionCreateCustomerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StaffCreateVenuesEntityRelationInput"]: {
		connect?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	create?: GraphQLTypes["VenueWithoutStaffMembersCreateInput"] | undefined,
	alias?: string | undefined
};
	["VenueWithoutStaffMembersCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	deadlineTemplate?: GraphQLTypes["VenueCreateDeadlineTemplateEntityRelationInput"] | undefined,
	timetableDays?: Array<GraphQLTypes["VenueCreateTimetableDaysEntityRelationInput"]> | undefined,
	timetableTemplates?: Array<GraphQLTypes["VenueCreateTimetableTemplatesEntityRelationInput"]> | undefined,
	employeeRoles?: Array<GraphQLTypes["VenueCreateEmployeeRolesEntityRelationInput"]> | undefined,
	pointOfSaleApplicationDevices?: Array<GraphQLTypes["VenueCreatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined,
	pointOfSaleTerminals?: Array<GraphQLTypes["VenueCreatePointOfSaleTerminalsEntityRelationInput"]> | undefined,
	pointOfSalePrinters?: Array<GraphQLTypes["VenueCreatePointOfSalePrintersEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["VenueCreateOrdersEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["VenueCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	areas?: Array<GraphQLTypes["VenueCreateAreasEntityRelationInput"]> | undefined,
	enabledUnassignReasons?: Array<GraphQLTypes["VenueCreateEnabledUnassignReasonsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["VenueCreateCategoriesEntityRelationInput"]> | undefined,
	channels?: Array<GraphQLTypes["VenueCreateChannelsEntityRelationInput"]> | undefined,
	address?: string | undefined,
	pointOfSalePngBase64ReceiptLogo?: string | undefined,
	pointOfSaleInitialView?: GraphQLTypes["PointOfSaleInitialView"] | undefined,
	pointOfSalePreferPrintReceipt?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessCustomerCreateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["BusinessCustomerCreateBusinessServiceEventsEntityRelationInput"]: {
		connect?: GraphQLTypes["BusinessServiceEventUniqueWhere"] | undefined,
	create?: GraphQLTypes["BusinessServiceEventWithoutBusinessCustomerCreateInput"] | undefined,
	alias?: string | undefined
};
	["BusinessServiceEventWithoutBusinessCustomerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	businessService?: GraphQLTypes["BusinessServiceEventCreateBusinessServiceEntityRelationInput"] | undefined,
	filledNumberOfPeople?: number | undefined,
	filledInvoiced?: boolean | undefined,
	filledEquipment?: string | undefined,
	filledMillTamDem?: boolean | undefined,
	filledSOEspresso?: boolean | undefined,
	filledFilterCoffeeInMenu?: boolean | undefined,
	filledWaterMeterStatus?: string | undefined,
	filledServiceAction?: string | undefined,
	filledInvoiceIdentifier?: string | undefined,
	filledNote?: string | undefined,
	filledContact?: string | undefined,
	filledPhone?: boolean | undefined,
	filledEmail?: boolean | undefined,
	filledGrindingStonesCondition?: string | undefined,
	createdBy?: GraphQLTypes["BusinessServiceEventCreateCreatedByEntityRelationInput"] | undefined,
	filledSupervisor?: GraphQLTypes["BusinessServiceEventCreateFilledSupervisorEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessServiceEventCreateBusinessServiceEntityRelationInput"]: {
		connect?: GraphQLTypes["BusinessServiceUniqueWhere"] | undefined,
	create?: GraphQLTypes["BusinessServiceCreateInput"] | undefined
};
	["BusinessServiceCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	requireNote?: number | undefined,
	locales?: Array<GraphQLTypes["BusinessServiceCreateLocalesEntityRelationInput"]> | undefined,
	requireNumberOfPeople?: number | undefined,
	requireInvoiced?: number | undefined,
	requireEquipment?: number | undefined,
	requireMillTamDem?: number | undefined,
	requireSOEspresso?: number | undefined,
	requireFilterCoffeeInMenu?: number | undefined,
	requireWaterMeterStatus?: number | undefined,
	requireServiceAction?: number | undefined,
	optionsEquipment?: string | undefined,
	optionsServiceAction?: string | undefined,
	requireInvoiceIdentifier?: number | undefined,
	requireSupervisor?: number | undefined,
	requireContact?: number | undefined,
	requirePhone?: number | undefined,
	requireEmail?: number | undefined,
	requireGrindingStonesCondition?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessServiceCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["BusinessServiceLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["BusinessServiceLocaleWithoutRootCreateInput"] | undefined,
	alias?: string | undefined
};
	["BusinessServiceLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	labelNote?: string | undefined,
	locale?: GraphQLTypes["BusinessServiceLocaleCreateLocaleEntityRelationInput"] | undefined,
	labelNumberOfPeople?: string | undefined,
	labelInvoiced?: string | undefined,
	labelEquipment?: string | undefined,
	labelMillTamDem?: string | undefined,
	labelSOEspresso?: string | undefined,
	labelFilterCoffeeInMenu?: string | undefined,
	labelWaterMeterStatus?: string | undefined,
	labelServiceAction?: string | undefined,
	labelInvoiceIdentifier?: string | undefined,
	labelSupervisor?: string | undefined,
	labelContact?: string | undefined,
	labelPhone?: string | undefined,
	labelEmail?: string | undefined,
	labelGrindingStonesCondition?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessServiceLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutBusinessServicesCreateInput"] | undefined
};
	["LocaleWithoutBusinessServicesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	businessCategories?: Array<GraphQLTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleCreateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleCreateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessServiceEventCreateCreatedByEntityRelationInput"]: {
		connect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	create?: GraphQLTypes["StaffCreateInput"] | undefined
};
	["StaffCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	bartender?: GraphQLTypes["StaffCreateBartenderEntityRelationInput"] | undefined,
	courier?: GraphQLTypes["StaffCreateCourierEntityRelationInput"] | undefined,
	cleaner?: GraphQLTypes["StaffCreateCleanerEntityRelationInput"] | undefined,
	shiftsManager?: GraphQLTypes["StaffCreateShiftsManagerEntityRelationInput"] | undefined,
	businessToBusinessManager?: GraphQLTypes["StaffCreateBusinessToBusinessManagerEntityRelationInput"] | undefined,
	user?: GraphQLTypes["StaffCreateUserEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["StaffCreateShiftsProfileEntityRelationInput"] | undefined,
	stocksManager?: GraphQLTypes["StaffCreateStocksManagerEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["StaffCreatePhotoEntityRelationInput"] | undefined,
	courierManager?: GraphQLTypes["StaffCreateCourierManagerEntityRelationInput"] | undefined,
	picker?: GraphQLTypes["StaffCreatePickerEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	remunerationProfile?: GraphQLTypes["StaffCreateRemunerationProfileEntityRelationInput"] | undefined,
	cashier?: GraphQLTypes["StaffCreateCashierEntityRelationInput"] | undefined,
	venues?: Array<GraphQLTypes["StaffCreateVenuesEntityRelationInput"]> | undefined,
	internalBuyer?: GraphQLTypes["StaffCreateInternalBuyerEntityRelationInput"] | undefined,
	salesManager?: GraphQLTypes["StaffCreateSalesManagerEntityRelationInput"] | undefined,
	cashierManager?: GraphQLTypes["StaffCreateCashierManagerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessServiceEventCreateFilledSupervisorEntityRelationInput"]: {
		connect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	create?: GraphQLTypes["StaffCreateInput"] | undefined
};
	["BusinessCustomerCreateDoubleshotCoffeeEquipmentEntityRelationInput"]: {
		connect?: GraphQLTypes["DoubleshotCoffeeEquipmentUniqueWhere"] | undefined,
	create?: GraphQLTypes["DoubleshotCoffeeEquipmentCreateInput"] | undefined
};
	["DoubleshotCoffeeEquipmentCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	espressoMachine?: string | undefined,
	espressoGrinder?: string | undefined,
	batchBrew?: string | undefined,
	batchGrinder?: string | undefined,
	waterFilter?: string | undefined,
	mechanicalFilter?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableDayCreateVenueEntityRelationInput"]: {
		connect?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	create?: GraphQLTypes["VenueWithoutTimetableDaysCreateInput"] | undefined
};
	["VenueWithoutTimetableDaysCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	deadlineTemplate?: GraphQLTypes["VenueCreateDeadlineTemplateEntityRelationInput"] | undefined,
	timetableTemplates?: Array<GraphQLTypes["VenueCreateTimetableTemplatesEntityRelationInput"]> | undefined,
	staffMembers?: Array<GraphQLTypes["VenueCreateStaffMembersEntityRelationInput"]> | undefined,
	employeeRoles?: Array<GraphQLTypes["VenueCreateEmployeeRolesEntityRelationInput"]> | undefined,
	pointOfSaleApplicationDevices?: Array<GraphQLTypes["VenueCreatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined,
	pointOfSaleTerminals?: Array<GraphQLTypes["VenueCreatePointOfSaleTerminalsEntityRelationInput"]> | undefined,
	pointOfSalePrinters?: Array<GraphQLTypes["VenueCreatePointOfSalePrintersEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["VenueCreateOrdersEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["VenueCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	areas?: Array<GraphQLTypes["VenueCreateAreasEntityRelationInput"]> | undefined,
	enabledUnassignReasons?: Array<GraphQLTypes["VenueCreateEnabledUnassignReasonsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["VenueCreateCategoriesEntityRelationInput"]> | undefined,
	channels?: Array<GraphQLTypes["VenueCreateChannelsEntityRelationInput"]> | undefined,
	address?: string | undefined,
	pointOfSalePngBase64ReceiptLogo?: string | undefined,
	pointOfSaleInitialView?: GraphQLTypes["PointOfSaleInitialView"] | undefined,
	pointOfSalePreferPrintReceipt?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["WorkspaceCreateDiscountVatRateEntityRelationInput"]: {
		connect?: GraphQLTypes["VatRateUniqueWhere"] | undefined,
	create?: GraphQLTypes["VatRateCreateInput"] | undefined
};
	["ProductIngredientCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["ProductIngredientCreateSuppliersEntityRelationInput"]: {
		connect?: GraphQLTypes["IngredientSupplierListUniqueWhere"] | undefined,
	create?: GraphQLTypes["IngredientSupplierListCreateInput"] | undefined
};
	["IngredientSupplierListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["IngredientSupplierListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["IngredientSupplierListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["IngredientSupplierItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["IngredientSupplierItemWithoutListCreateInput"] | undefined,
	alias?: string | undefined
};
	["IngredientSupplierItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	supplier?: GraphQLTypes["IngredientSupplierItemCreateSupplierEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["IngredientSupplierItemCreateSupplierEntityRelationInput"]: {
		connect?: GraphQLTypes["IngredientSupplierUniqueWhere"] | undefined,
	create?: GraphQLTypes["IngredientSupplierCreateInput"] | undefined
};
	["IngredientSupplierCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	internalName?: string | undefined,
	internalNote?: string | undefined,
	locales?: Array<GraphQLTypes["IngredientSupplierCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["IngredientSupplierCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["IngredientSupplierLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["IngredientSupplierLocaleWithoutRootCreateInput"] | undefined,
	alias?: string | undefined
};
	["IngredientSupplierLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	locale?: GraphQLTypes["IngredientSupplierLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["IngredientSupplierLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutIngredientSuppliersCreateInput"] | undefined
};
	["LocaleWithoutIngredientSuppliersCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	businessCategories?: Array<GraphQLTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleCreateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleCreateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessCategoryCreateSpecificProductsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductListUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductListWithoutBusinessCategoryCreateInput"] | undefined
};
	["ProductListWithoutBusinessCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["ProductListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductListItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductListItemWithoutListCreateInput"] | undefined,
	alias?: string | undefined
};
	["ProductListItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	product?: GraphQLTypes["ProductListItemCreateProductEntityRelationInput"] | undefined,
	defaultQuantityForOrder?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductListItemCreateProductEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductCreateInput"] | undefined
};
	["BusinessCategoryCreateSeasonalProductCategoriesEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductCategoryListUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductCategoryListWithoutSeasonalProductCategoriesOfBusinessCategoryCreateInput"] | undefined
};
	["ProductCategoryListWithoutSeasonalProductCategoriesOfBusinessCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["ProductCategoryListCreateItemsEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["ProductCategoryListCreateLocalesEntityRelationInput"]> | undefined,
	specificProductsProductCategoriesOfBusinessCategory?: GraphQLTypes["ProductCategoryListCreateSpecificProductsProductCategoriesOfBusinessCategoryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCategoryListCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductCategoryListLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductCategoryListLocaleWithoutRootCreateInput"] | undefined,
	alias?: string | undefined
};
	["ProductCategoryListLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	locale?: GraphQLTypes["ProductCategoryListLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCategoryListLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutProductCategoryListsCreateInput"] | undefined
};
	["LocaleWithoutProductCategoryListsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	businessCategories?: Array<GraphQLTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleCreateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleCreateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCategoryListCreateSpecificProductsProductCategoriesOfBusinessCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["BusinessCategoryUniqueWhere"] | undefined,
	create?: GraphQLTypes["BusinessCategoryWithoutSpecificProductsProductCategoriesCreateInput"] | undefined
};
	["BusinessCategoryWithoutSpecificProductsProductCategoriesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	visibleToNewCustomers?: boolean | undefined,
	locales?: Array<GraphQLTypes["BusinessCategoryCreateLocalesEntityRelationInput"]> | undefined,
	internalName?: string | undefined,
	businessCustomers?: Array<GraphQLTypes["BusinessCategoryCreateBusinessCustomersEntityRelationInput"]> | undefined,
	recurrences?: Array<GraphQLTypes["BusinessCategoryCreateRecurrencesEntityRelationInput"]> | undefined,
	specificProducts?: GraphQLTypes["BusinessCategoryCreateSpecificProductsEntityRelationInput"] | undefined,
	seasonalProductCategories?: GraphQLTypes["BusinessCategoryCreateSeasonalProductCategoriesEntityRelationInput"] | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessCategoryCreateSpecificProductsProductCategoriesEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductCategoryListUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductCategoryListWithoutSpecificProductsProductCategoriesOfBusinessCategoryCreateInput"] | undefined
};
	["ProductCategoryListWithoutSpecificProductsProductCategoriesOfBusinessCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["ProductCategoryListCreateItemsEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["ProductCategoryListCreateLocalesEntityRelationInput"]> | undefined,
	seasonalProductCategoriesOfBusinessCategory?: GraphQLTypes["ProductCategoryListCreateSeasonalProductCategoriesOfBusinessCategoryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCategoryListCreateSeasonalProductCategoriesOfBusinessCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["BusinessCategoryUniqueWhere"] | undefined,
	create?: GraphQLTypes["BusinessCategoryWithoutSeasonalProductCategoriesCreateInput"] | undefined
};
	["BusinessCategoryWithoutSeasonalProductCategoriesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	visibleToNewCustomers?: boolean | undefined,
	locales?: Array<GraphQLTypes["BusinessCategoryCreateLocalesEntityRelationInput"]> | undefined,
	internalName?: string | undefined,
	businessCustomers?: Array<GraphQLTypes["BusinessCategoryCreateBusinessCustomersEntityRelationInput"]> | undefined,
	recurrences?: Array<GraphQLTypes["BusinessCategoryCreateRecurrencesEntityRelationInput"]> | undefined,
	specificProducts?: GraphQLTypes["BusinessCategoryCreateSpecificProductsEntityRelationInput"] | undefined,
	specificProductsProductCategories?: GraphQLTypes["BusinessCategoryCreateSpecificProductsProductCategoriesEntityRelationInput"] | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableCreateRedirectEntityRelationInput"]: {
		connect?: GraphQLTypes["RedirectUniqueWhere"] | undefined,
	create?: GraphQLTypes["RedirectWithoutLinkCreateInput"] | undefined
};
	["RedirectWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	target?: GraphQLTypes["RedirectCreateTargetEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RedirectCreateTargetEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined
};
	["WikiPageCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined
};
	["WikiPageCreateChildrenEntityRelationInput"]: {
		connect?: GraphQLTypes["WikiPageUniqueWhere"] | undefined,
	create?: GraphQLTypes["WikiPageWithoutParentCreateInput"] | undefined,
	alias?: string | undefined
};
	["WikiPageWithoutParentCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	title?: string | undefined,
	emoji?: string | undefined,
	link?: GraphQLTypes["WikiPageCreateLinkEntityRelationInput"] | undefined,
	children?: Array<GraphQLTypes["WikiPageCreateChildrenEntityRelationInput"]> | undefined,
	content?: GraphQLTypes["WikiPageCreateContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BlogPostLocaleCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	create?: GraphQLTypes["SeoCreateInput"] | undefined
};
	["BlogPostLocaleCreateProductsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductCreateInput"] | undefined,
	alias?: string | undefined
};
	["ContentReferenceCreateBlogPostsEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPostListUniqueWhere"] | undefined,
	create?: GraphQLTypes["BlogPostListCreateInput"] | undefined
};
	["BlogPostListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["BlogPostListItemUniqueWhere"] | undefined
};
	["BlogPostListItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["BlogPostListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["BlogPostListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["BlogPostListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPostListItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["BlogPostListItemWithoutListCreateInput"] | undefined,
	alias?: string | undefined
};
	["BlogPostListItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	caption?: string | undefined,
	blogPost?: GraphQLTypes["BlogPostListItemCreateBlogPostEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BlogPostListItemCreateBlogPostEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPostLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["BlogPostLocaleCreateInput"] | undefined
};
	["BlogPostLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	availableForWeb?: boolean | undefined,
	availableForMobile?: boolean | undefined,
	root?: GraphQLTypes["BlogPostLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["BlogPostLocaleCreateLocaleEntityRelationInput"] | undefined,
	cover?: GraphQLTypes["BlogPostLocaleCreateCoverEntityRelationInput"] | undefined,
	content?: GraphQLTypes["BlogPostLocaleCreateContentEntityRelationInput"] | undefined,
	link?: GraphQLTypes["BlogPostLocaleCreateLinkEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["BlogPostLocaleCreateSeoEntityRelationInput"] | undefined,
	products?: Array<GraphQLTypes["BlogPostLocaleCreateProductsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["BlogPostLocaleCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkableWithoutBlogPostCreateInput"] | undefined
};
	["LinkableWithoutBlogPostCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	url?: string | undefined,
	page?: GraphQLTypes["LinkableCreatePageEntityRelationInput"] | undefined,
	wikiPage?: GraphQLTypes["LinkableCreateWikiPageEntityRelationInput"] | undefined,
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentReferenceCreateLinksEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkListUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkListCreateInput"] | undefined
};
	["ContentReferenceCreateProductsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductListUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductListCreateInput"] | undefined
};
	["ProductListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["ProductListCreateItemsEntityRelationInput"]> | undefined,
	businessCategory?: GraphQLTypes["ProductListCreateBusinessCategoryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductListCreateBusinessCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["BusinessCategoryUniqueWhere"] | undefined,
	create?: GraphQLTypes["BusinessCategoryWithoutSpecificProductsCreateInput"] | undefined
};
	["BusinessCategoryWithoutSpecificProductsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	visibleToNewCustomers?: boolean | undefined,
	locales?: Array<GraphQLTypes["BusinessCategoryCreateLocalesEntityRelationInput"]> | undefined,
	internalName?: string | undefined,
	businessCustomers?: Array<GraphQLTypes["BusinessCategoryCreateBusinessCustomersEntityRelationInput"]> | undefined,
	recurrences?: Array<GraphQLTypes["BusinessCategoryCreateRecurrencesEntityRelationInput"]> | undefined,
	seasonalProductCategories?: GraphQLTypes["BusinessCategoryCreateSeasonalProductCategoriesEntityRelationInput"] | undefined,
	specificProductsProductCategories?: GraphQLTypes["BusinessCategoryCreateSpecificProductsProductCategoriesEntityRelationInput"] | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentReferenceCreateHeroEntityRelationInput"]: {
		connect?: GraphQLTypes["HeroUniqueWhere"] | undefined,
	create?: GraphQLTypes["HeroCreateInput"] | undefined
};
	["HeroUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["HeroCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	showLogo?: boolean | undefined,
	middleContent?: string | undefined,
	medium?: GraphQLTypes["HeroCreateMediumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeroCreateMediumEntityRelationInput"]: {
		connect?: GraphQLTypes["MediumUniqueWhere"] | undefined,
	create?: GraphQLTypes["MediumCreateInput"] | undefined
};
	["ContentReferenceCreateGalleryEntityRelationInput"]: {
		connect?: GraphQLTypes["GalleryUniqueWhere"] | undefined,
	create?: GraphQLTypes["GalleryCreateInput"] | undefined
};
	["GalleryUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["GalleryItemUniqueWhere"] | undefined
};
	["GalleryItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["GalleryCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["GalleryCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GalleryCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["GalleryItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["GalleryItemWithoutListCreateInput"] | undefined,
	alias?: string | undefined
};
	["GalleryItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	caption?: string | undefined,
	medium?: GraphQLTypes["GalleryItemCreateMediumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GalleryItemCreateMediumEntityRelationInput"]: {
		connect?: GraphQLTypes["MediumUniqueWhere"] | undefined,
	create?: GraphQLTypes["MediumCreateInput"] | undefined
};
	["ContentReferenceCreateSocialsAndAppsEntityRelationInput"]: {
		connect?: GraphQLTypes["SocialsAndAppsUniqueWhere"] | undefined,
	create?: GraphQLTypes["SocialsAndAppsCreateInput"] | undefined
};
	["ContentReferenceCreateProductGridEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductGridUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductGridCreateInput"] | undefined
};
	["ProductGridUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	categories?: GraphQLTypes["ProductGridCategoryUniqueWhere"] | undefined
};
	["ProductGridCategoryUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["ProductGridItemUniqueWhere"] | undefined,
	images?: GraphQLTypes["ImageListUniqueWhere"] | undefined
};
	["ProductGridCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	isCarousel?: boolean | undefined,
	categories?: Array<GraphQLTypes["ProductGridCreateCategoriesEntityRelationInput"]> | undefined,
	type?: GraphQLTypes["ProductGridType"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductGridCreateCategoriesEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductGridCategoryUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductGridCategoryWithoutRootCreateInput"] | undefined,
	alias?: string | undefined
};
	["ProductGridCategoryWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	title?: string | undefined,
	items?: Array<GraphQLTypes["ProductGridCategoryCreateItemsEntityRelationInput"]> | undefined,
	images?: GraphQLTypes["ProductGridCategoryCreateImagesEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductGridCategoryCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductGridItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductGridItemWithoutCategoryCreateInput"] | undefined,
	alias?: string | undefined
};
	["ProductGridItemWithoutCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	title?: string | undefined,
	lead?: string | undefined,
	product?: GraphQLTypes["ProductGridItemCreateProductEntityRelationInput"] | undefined,
	medium?: GraphQLTypes["ProductGridItemCreateMediumEntityRelationInput"] | undefined,
	link?: GraphQLTypes["ProductGridItemCreateLinkEntityRelationInput"] | undefined,
	description?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductGridItemCreateProductEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductCreateInput"] | undefined
};
	["ProductGridItemCreateMediumEntityRelationInput"]: {
		connect?: GraphQLTypes["MediumUniqueWhere"] | undefined,
	create?: GraphQLTypes["MediumCreateInput"] | undefined
};
	["ProductGridItemCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined
};
	["ProductGridCategoryCreateImagesEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageListUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageListCreateInput"] | undefined
};
	["ContentReferenceCreateProductBannersEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductBannerListUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductBannerListCreateInput"] | undefined
};
	["ProductBannerListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["ProductBannerListCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductBannerListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductBannerItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductBannerItemWithoutListCreateInput"] | undefined,
	alias?: string | undefined
};
	["ProductBannerItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	banner?: GraphQLTypes["ProductBannerItemCreateBannerEntityRelationInput"] | undefined,
	size?: GraphQLTypes["ProductBannerItemSize"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductBannerItemCreateBannerEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductBannerUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductBannerCreateInput"] | undefined
};
	["ProductBannerUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	button?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["ProductBannerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	beforeTitle?: string | undefined,
	title?: string | undefined,
	label?: string | undefined,
	button?: GraphQLTypes["ProductBannerCreateButtonEntityRelationInput"] | undefined,
	backgroundImage?: GraphQLTypes["ProductBannerCreateBackgroundImageEntityRelationInput"] | undefined,
	productImage?: GraphQLTypes["ProductBannerCreateProductImageEntityRelationInput"] | undefined,
	product?: GraphQLTypes["ProductBannerCreateProductEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductBannerCreateButtonEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined
};
	["ProductBannerCreateBackgroundImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["ProductBannerCreateProductImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["ProductBannerCreateProductEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductCreateInput"] | undefined
};
	["ContentReferenceCreateDeliveryRegionsEntityRelationInput"]: {
		connect?: GraphQLTypes["DeliveryRegionsUniqueWhere"] | undefined,
	create?: GraphQLTypes["DeliveryRegionsCreateInput"] | undefined
};
	["ContentReferenceCreateTextListEntityRelationInput"]: {
		connect?: GraphQLTypes["TextListUniqueWhere"] | undefined,
	create?: GraphQLTypes["TextListCreateInput"] | undefined
};
	["ContentReferenceCreateGridTilesEntityRelationInput"]: {
		connect?: GraphQLTypes["GridTilesUniqueWhere"] | undefined,
	create?: GraphQLTypes["GridTilesCreateInput"] | undefined
};
	["GridTilesUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["GridTileItemUniqueWhere"] | undefined
};
	["GridTileItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	link?: GraphQLTypes["LinkUniqueWhere"] | undefined
};
	["GridTilesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["GridTilesCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GridTilesCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["GridTileItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["GridTileItemWithoutListCreateInput"] | undefined,
	alias?: string | undefined
};
	["GridTileItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	text?: string | undefined,
	medium?: GraphQLTypes["GridTileItemCreateMediumEntityRelationInput"] | undefined,
	link?: GraphQLTypes["GridTileItemCreateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GridTileItemCreateMediumEntityRelationInput"]: {
		connect?: GraphQLTypes["MediumUniqueWhere"] | undefined,
	create?: GraphQLTypes["MediumCreateInput"] | undefined
};
	["GridTileItemCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined
};
	["CartItemCreateFulfillmentNotesEntityRelationInput"]: {
		connect?: GraphQLTypes["FulfillmentNoteUniqueWhere"] | undefined,
	create?: GraphQLTypes["FulfillmentNoteWithoutCartItemsCreateInput"] | undefined,
	alias?: string | undefined
};
	["FulfillmentNoteWithoutCartItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	note?: string | undefined,
	products?: Array<GraphQLTypes["FulfillmentNoteCreateProductsEntityRelationInput"]> | undefined,
	tags?: Array<GraphQLTypes["FulfillmentNoteCreateTagsEntityRelationInput"]> | undefined,
	venues?: Array<GraphQLTypes["FulfillmentNoteCreateVenuesEntityRelationInput"]> | undefined,
	orderItems?: Array<GraphQLTypes["FulfillmentNoteCreateOrderItemsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["FulfillmentNoteCreateOrdersEntityRelationInput"]> | undefined,
	highlight?: boolean | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	emoji?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientItemCreateQuantityEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductIngredientItemQuantityUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductIngredientItemQuantityCreateInput"] | undefined
};
	["ProductIngredientItemQuantityCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unit?: GraphQLTypes["ProductIngredientItemQuantityCreateUnitEntityRelationInput"] | undefined,
	value?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientItemQuantityCreateUnitEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductIngredientItemQuantityUnitUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductIngredientItemQuantityUnitCreateInput"] | undefined
};
	["AddressUpdateInput"]: {
		name?: string | undefined,
	firstName?: string | undefined,
	lastName?: string | undefined,
	addressLine2?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	companyName?: string | undefined,
	companyIdentifier?: string | undefined,
	vatIdentifier?: string | undefined,
	externalIdentifier?: string | undefined,
	hidden?: boolean | undefined,
	customer?: GraphQLTypes["AddressUpdateCustomerEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	country?: GraphQLTypes["AddressUpdateCountryEntityRelationInput"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	googlePlaceId?: string | undefined,
	raw?: string | undefined,
	formatted?: string | undefined,
	geocodeGeneratedAt?: GraphQLTypes["DateTime"] | undefined,
	geocodeResponse?: string | undefined,
	deliveryZone?: GraphQLTypes["AddressUpdateDeliveryZoneEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["AddressUpdateMetaEntityRelationInput"] | undefined,
	gps?: GraphQLTypes["AddressUpdateGpsEntityRelationInput"] | undefined,
	geocodeValid?: boolean | undefined,
	fullName?: string | undefined,
	fakturoidSubjectId?: string | undefined,
	invoices?: Array<GraphQLTypes["AddressUpdateInvoicesEntityRelationInput"]> | undefined,
	addressLine1?: string | undefined,
	city?: string | undefined,
	postalCode?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddressOfOrders?: Array<GraphQLTypes["AddressUpdateBillingAddressOfOrdersEntityRelationInput"]> | undefined,
	deliveryAddressOfOrderDeliveries?: Array<GraphQLTypes["AddressUpdateDeliveryAddressOfOrderDeliveriesEntityRelationInput"]> | undefined,
	defaultDeliveryAddressOfCustomer?: GraphQLTypes["AddressUpdateDefaultDeliveryAddressOfCustomerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["AddressUpdateCustomerEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerWithoutAddressesCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerWithoutAddressesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["AddressUpsertCustomerRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CustomerWithoutAddressesUpdateInput"]: {
		defaultBillingAddress?: GraphQLTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerUpdateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerUpdateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerUpdateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerUpdateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerUpdateDefaultBillingAddressEntityRelationInput"]: {
		create?: GraphQLTypes["AddressCreateInput"] | undefined,
	update?: GraphQLTypes["AddressUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CustomerUpsertDefaultBillingAddressRelationInput"] | undefined,
	connect?: GraphQLTypes["AddressUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CustomerUpsertDefaultBillingAddressRelationInput"]: {
		update?: GraphQLTypes["AddressUpdateInput"] | undefined,
	create?: GraphQLTypes["AddressCreateInput"] | undefined
};
	["CustomerUpdateDefaultPaymentMethodEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerPaymentMethodCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerPaymentMethodUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CustomerUpsertDefaultPaymentMethodRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerPaymentMethodUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CustomerPaymentMethodUpdateInput"]: {
		caption?: string | undefined,
	data?: GraphQLTypes["Json"] | undefined,
	customer?: GraphQLTypes["CustomerPaymentMethodUpdateCustomerEntityRelationInput"] | undefined,
	paymentMethod?: GraphQLTypes["CustomerPaymentMethodUpdatePaymentMethodEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerPaymentMethodUpdateCustomerEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerWithoutPaymentMethodsCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerWithoutPaymentMethodsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CustomerPaymentMethodUpsertCustomerRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["CustomerWithoutPaymentMethodsUpdateInput"]: {
		addresses?: Array<GraphQLTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerUpdateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerUpdateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerUpdateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerUpdateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerUpdateAddressesEntityRelationInput"]: {
		create?: GraphQLTypes["AddressWithoutCustomerCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerUpdateAddressesRelationInput"] | undefined,
	upsert?: GraphQLTypes["CustomerUpsertAddressesRelationInput"] | undefined,
	connect?: GraphQLTypes["AddressUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["AddressUniqueWhere"] | undefined,
	delete?: GraphQLTypes["AddressUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CustomerUpdateAddressesRelationInput"]: {
		by?: GraphQLTypes["AddressUniqueWhere"] | undefined,
	data?: GraphQLTypes["AddressWithoutCustomerUpdateInput"] | undefined
};
	["AddressWithoutCustomerUpdateInput"]: {
		name?: string | undefined,
	firstName?: string | undefined,
	lastName?: string | undefined,
	addressLine2?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	companyName?: string | undefined,
	companyIdentifier?: string | undefined,
	vatIdentifier?: string | undefined,
	externalIdentifier?: string | undefined,
	hidden?: boolean | undefined,
	internalNote?: string | undefined,
	country?: GraphQLTypes["AddressUpdateCountryEntityRelationInput"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	googlePlaceId?: string | undefined,
	raw?: string | undefined,
	formatted?: string | undefined,
	geocodeGeneratedAt?: GraphQLTypes["DateTime"] | undefined,
	geocodeResponse?: string | undefined,
	deliveryZone?: GraphQLTypes["AddressUpdateDeliveryZoneEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["AddressUpdateMetaEntityRelationInput"] | undefined,
	gps?: GraphQLTypes["AddressUpdateGpsEntityRelationInput"] | undefined,
	geocodeValid?: boolean | undefined,
	fullName?: string | undefined,
	fakturoidSubjectId?: string | undefined,
	invoices?: Array<GraphQLTypes["AddressUpdateInvoicesEntityRelationInput"]> | undefined,
	addressLine1?: string | undefined,
	city?: string | undefined,
	postalCode?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddressOfOrders?: Array<GraphQLTypes["AddressUpdateBillingAddressOfOrdersEntityRelationInput"]> | undefined,
	deliveryAddressOfOrderDeliveries?: Array<GraphQLTypes["AddressUpdateDeliveryAddressOfOrderDeliveriesEntityRelationInput"]> | undefined,
	defaultDeliveryAddressOfCustomer?: GraphQLTypes["AddressUpdateDefaultDeliveryAddressOfCustomerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["AddressUpdateCountryEntityRelationInput"]: {
		create?: GraphQLTypes["CountryCreateInput"] | undefined,
	update?: GraphQLTypes["CountryUpdateInput"] | undefined,
	upsert?: GraphQLTypes["AddressUpsertCountryRelationInput"] | undefined,
	connect?: GraphQLTypes["CountryUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["CountryUpdateInput"]: {
		code?: string | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["AddressUpsertCountryRelationInput"]: {
		update?: GraphQLTypes["CountryUpdateInput"] | undefined,
	create?: GraphQLTypes["CountryCreateInput"] | undefined
};
	["AddressUpdateDeliveryZoneEntityRelationInput"]: {
		create?: GraphQLTypes["DeliveryZoneWithoutAddressesCreateInput"] | undefined,
	update?: GraphQLTypes["DeliveryZoneWithoutAddressesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["AddressUpsertDeliveryZoneRelationInput"] | undefined,
	connect?: GraphQLTypes["DeliveryZoneUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["DeliveryZoneWithoutAddressesUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	type?: GraphQLTypes["DeliveryZoneType"] | undefined,
	suitableDeliveryMethods?: Array<GraphQLTypes["DeliveryZoneUpdateSuitableDeliveryMethodsEntityRelationInput"]> | undefined,
	deliveryZonesOfTags?: Array<GraphQLTypes["DeliveryZoneUpdateDeliveryZonesOfTagsEntityRelationInput"]> | undefined,
	deliveryZonesOfProducts?: Array<GraphQLTypes["DeliveryZoneUpdateDeliveryZonesOfProductsEntityRelationInput"]> | undefined,
	addressesMetadata?: Array<GraphQLTypes["DeliveryZoneUpdateAddressesMetadataEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryZoneUpdateSuitableDeliveryMethodsEntityRelationInput"]: {
		create?: GraphQLTypes["DeliveryMethodWithoutSuitableForDeliveryZonesCreateInput"] | undefined,
	update?: GraphQLTypes["DeliveryZoneUpdateSuitableDeliveryMethodsRelationInput"] | undefined,
	upsert?: GraphQLTypes["DeliveryZoneUpsertSuitableDeliveryMethodsRelationInput"] | undefined,
	connect?: GraphQLTypes["DeliveryMethodUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["DeliveryMethodUniqueWhere"] | undefined,
	delete?: GraphQLTypes["DeliveryMethodUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["DeliveryZoneUpdateSuitableDeliveryMethodsRelationInput"]: {
		by?: GraphQLTypes["DeliveryMethodUniqueWhere"] | undefined,
	data?: GraphQLTypes["DeliveryMethodWithoutSuitableForDeliveryZonesUpdateInput"] | undefined
};
	["DeliveryMethodWithoutSuitableForDeliveryZonesUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	enabled?: boolean | undefined,
	paymentMethods?: Array<GraphQLTypes["DeliveryMethodUpdatePaymentMethodsEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	requireDeliveryAddress?: boolean | undefined,
	channels?: Array<GraphQLTypes["DeliveryMethodUpdateChannelsEntityRelationInput"]> | undefined,
	courierHandlers?: Array<GraphQLTypes["DeliveryMethodUpdateCourierHandlersEntityRelationInput"]> | undefined,
	enableDeliveryTracking?: boolean | undefined,
	locales?: Array<GraphQLTypes["DeliveryMethodUpdateLocalesEntityRelationInput"]> | undefined,
	timelinePreset?: GraphQLTypes["DeliveryMethodUpdateTimelinePresetEntityRelationInput"] | undefined,
	woltDriveVenueId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryMethodUpdatePaymentMethodsEntityRelationInput"]: {
		create?: GraphQLTypes["PaymentMethodWithoutDeliveryMethodsCreateInput"] | undefined,
	update?: GraphQLTypes["DeliveryMethodUpdatePaymentMethodsRelationInput"] | undefined,
	upsert?: GraphQLTypes["DeliveryMethodUpsertPaymentMethodsRelationInput"] | undefined,
	connect?: GraphQLTypes["PaymentMethodUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PaymentMethodUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PaymentMethodUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["DeliveryMethodUpdatePaymentMethodsRelationInput"]: {
		by?: GraphQLTypes["PaymentMethodUniqueWhere"] | undefined,
	data?: GraphQLTypes["PaymentMethodWithoutDeliveryMethodsUpdateInput"] | undefined
};
	["PaymentMethodWithoutDeliveryMethodsUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	enabled?: boolean | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	blockingDispatch?: boolean | undefined,
	type?: GraphQLTypes["PaymentMethodType"] | undefined,
	channels?: Array<GraphQLTypes["PaymentMethodUpdateChannelsEntityRelationInput"]> | undefined,
	reduceGratuityByPercentage?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["PaymentMethodUpdateChannelsEntityRelationInput"]: {
		create?: GraphQLTypes["ChannelPaymentWithoutMethodCreateInput"] | undefined,
	update?: GraphQLTypes["PaymentMethodUpdateChannelsRelationInput"] | undefined,
	upsert?: GraphQLTypes["PaymentMethodUpsertChannelsRelationInput"] | undefined,
	connect?: GraphQLTypes["ChannelPaymentUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ChannelPaymentUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ChannelPaymentUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PaymentMethodUpdateChannelsRelationInput"]: {
		by?: GraphQLTypes["ChannelPaymentUniqueWhere"] | undefined,
	data?: GraphQLTypes["ChannelPaymentWithoutMethodUpdateInput"] | undefined
};
	["ChannelPaymentWithoutMethodUpdateInput"]: {
		order?: number | undefined,
	channel?: GraphQLTypes["ChannelPaymentUpdateChannelEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["ChannelPaymentUpdateVatRateEntityRelationInput"] | undefined,
	requireBillingAddress?: boolean | undefined,
	provideReceipt?: boolean | undefined,
	requireBillingSubject?: boolean | undefined,
	allowOnlyForTags?: Array<GraphQLTypes["ChannelPaymentUpdateAllowOnlyForTagsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ChannelPaymentUpdateChannelEntityRelationInput"]: {
		create?: GraphQLTypes["ChannelWithoutPaymentsCreateInput"] | undefined,
	update?: GraphQLTypes["ChannelWithoutPaymentsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ChannelPaymentUpsertChannelRelationInput"] | undefined,
	connect?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["ChannelWithoutPaymentsUpdateInput"]: {
		name?: string | undefined,
	disabled?: boolean | undefined,
	deliveries?: Array<GraphQLTypes["ChannelUpdateDeliveriesEntityRelationInput"]> | undefined,
	pointOfSales?: Array<GraphQLTypes["ChannelUpdatePointOfSalesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["ChannelUpdateCartsEntityRelationInput"]> | undefined,
	customers?: Array<GraphQLTypes["ChannelUpdateCustomersEntityRelationInput"]> | undefined,
	code?: GraphQLTypes["ChannelCode"] | undefined,
	addTagsOnRegistration?: Array<GraphQLTypes["ChannelUpdateAddTagsOnRegistrationEntityRelationInput"]> | undefined,
	publicTags?: Array<GraphQLTypes["ChannelUpdatePublicTagsEntityRelationInput"]> | undefined,
	venue?: GraphQLTypes["ChannelUpdateVenueEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ChannelUpdateDeliveriesEntityRelationInput"]: {
		create?: GraphQLTypes["ChannelDeliveryWithoutChannelCreateInput"] | undefined,
	update?: GraphQLTypes["ChannelUpdateDeliveriesRelationInput"] | undefined,
	upsert?: GraphQLTypes["ChannelUpsertDeliveriesRelationInput"] | undefined,
	connect?: GraphQLTypes["ChannelDeliveryUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ChannelDeliveryUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ChannelDeliveryUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ChannelUpdateDeliveriesRelationInput"]: {
		by?: GraphQLTypes["ChannelDeliveryUniqueWhere"] | undefined,
	data?: GraphQLTypes["ChannelDeliveryWithoutChannelUpdateInput"] | undefined
};
	["ChannelDeliveryWithoutChannelUpdateInput"]: {
		order?: number | undefined,
	priceCents?: number | undefined,
	method?: GraphQLTypes["ChannelDeliveryUpdateMethodEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["ChannelDeliveryUpdateVatRateEntityRelationInput"] | undefined,
	defaultVisible?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ChannelDeliveryUpdateMethodEntityRelationInput"]: {
		create?: GraphQLTypes["DeliveryMethodWithoutChannelsCreateInput"] | undefined,
	update?: GraphQLTypes["DeliveryMethodWithoutChannelsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ChannelDeliveryUpsertMethodRelationInput"] | undefined,
	connect?: GraphQLTypes["DeliveryMethodUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["DeliveryMethodWithoutChannelsUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	enabled?: boolean | undefined,
	paymentMethods?: Array<GraphQLTypes["DeliveryMethodUpdatePaymentMethodsEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	requireDeliveryAddress?: boolean | undefined,
	suitableForDeliveryZones?: Array<GraphQLTypes["DeliveryMethodUpdateSuitableForDeliveryZonesEntityRelationInput"]> | undefined,
	courierHandlers?: Array<GraphQLTypes["DeliveryMethodUpdateCourierHandlersEntityRelationInput"]> | undefined,
	enableDeliveryTracking?: boolean | undefined,
	locales?: Array<GraphQLTypes["DeliveryMethodUpdateLocalesEntityRelationInput"]> | undefined,
	timelinePreset?: GraphQLTypes["DeliveryMethodUpdateTimelinePresetEntityRelationInput"] | undefined,
	woltDriveVenueId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryMethodUpdateSuitableForDeliveryZonesEntityRelationInput"]: {
		create?: GraphQLTypes["DeliveryZoneWithoutSuitableDeliveryMethodsCreateInput"] | undefined,
	update?: GraphQLTypes["DeliveryMethodUpdateSuitableForDeliveryZonesRelationInput"] | undefined,
	upsert?: GraphQLTypes["DeliveryMethodUpsertSuitableForDeliveryZonesRelationInput"] | undefined,
	connect?: GraphQLTypes["DeliveryZoneUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["DeliveryZoneUniqueWhere"] | undefined,
	delete?: GraphQLTypes["DeliveryZoneUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["DeliveryMethodUpdateSuitableForDeliveryZonesRelationInput"]: {
		by?: GraphQLTypes["DeliveryZoneUniqueWhere"] | undefined,
	data?: GraphQLTypes["DeliveryZoneWithoutSuitableDeliveryMethodsUpdateInput"] | undefined
};
	["DeliveryZoneWithoutSuitableDeliveryMethodsUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	type?: GraphQLTypes["DeliveryZoneType"] | undefined,
	addresses?: Array<GraphQLTypes["DeliveryZoneUpdateAddressesEntityRelationInput"]> | undefined,
	deliveryZonesOfTags?: Array<GraphQLTypes["DeliveryZoneUpdateDeliveryZonesOfTagsEntityRelationInput"]> | undefined,
	deliveryZonesOfProducts?: Array<GraphQLTypes["DeliveryZoneUpdateDeliveryZonesOfProductsEntityRelationInput"]> | undefined,
	addressesMetadata?: Array<GraphQLTypes["DeliveryZoneUpdateAddressesMetadataEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryZoneUpdateAddressesEntityRelationInput"]: {
		create?: GraphQLTypes["AddressWithoutDeliveryZoneCreateInput"] | undefined,
	update?: GraphQLTypes["DeliveryZoneUpdateAddressesRelationInput"] | undefined,
	upsert?: GraphQLTypes["DeliveryZoneUpsertAddressesRelationInput"] | undefined,
	connect?: GraphQLTypes["AddressUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["AddressUniqueWhere"] | undefined,
	delete?: GraphQLTypes["AddressUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["DeliveryZoneUpdateAddressesRelationInput"]: {
		by?: GraphQLTypes["AddressUniqueWhere"] | undefined,
	data?: GraphQLTypes["AddressWithoutDeliveryZoneUpdateInput"] | undefined
};
	["AddressWithoutDeliveryZoneUpdateInput"]: {
		name?: string | undefined,
	firstName?: string | undefined,
	lastName?: string | undefined,
	addressLine2?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	companyName?: string | undefined,
	companyIdentifier?: string | undefined,
	vatIdentifier?: string | undefined,
	externalIdentifier?: string | undefined,
	hidden?: boolean | undefined,
	customer?: GraphQLTypes["AddressUpdateCustomerEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	country?: GraphQLTypes["AddressUpdateCountryEntityRelationInput"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	googlePlaceId?: string | undefined,
	raw?: string | undefined,
	formatted?: string | undefined,
	geocodeGeneratedAt?: GraphQLTypes["DateTime"] | undefined,
	geocodeResponse?: string | undefined,
	meta?: GraphQLTypes["AddressUpdateMetaEntityRelationInput"] | undefined,
	gps?: GraphQLTypes["AddressUpdateGpsEntityRelationInput"] | undefined,
	geocodeValid?: boolean | undefined,
	fullName?: string | undefined,
	fakturoidSubjectId?: string | undefined,
	invoices?: Array<GraphQLTypes["AddressUpdateInvoicesEntityRelationInput"]> | undefined,
	addressLine1?: string | undefined,
	city?: string | undefined,
	postalCode?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddressOfOrders?: Array<GraphQLTypes["AddressUpdateBillingAddressOfOrdersEntityRelationInput"]> | undefined,
	deliveryAddressOfOrderDeliveries?: Array<GraphQLTypes["AddressUpdateDeliveryAddressOfOrderDeliveriesEntityRelationInput"]> | undefined,
	defaultDeliveryAddressOfCustomer?: GraphQLTypes["AddressUpdateDefaultDeliveryAddressOfCustomerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["AddressUpdateMetaEntityRelationInput"]: {
		connect?: GraphQLTypes["AddressMetadataUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["AddressUpdateGpsEntityRelationInput"]: {
		create?: GraphQLTypes["GpsWithoutAddressCreateInput"] | undefined,
	update?: GraphQLTypes["GpsWithoutAddressUpdateInput"] | undefined,
	upsert?: GraphQLTypes["AddressUpsertGpsRelationInput"] | undefined,
	connect?: GraphQLTypes["GpsUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GpsWithoutAddressUpdateInput"]: {
		latitude?: number | undefined,
	longitude?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["AddressUpsertGpsRelationInput"]: {
		update?: GraphQLTypes["GpsWithoutAddressUpdateInput"] | undefined,
	create?: GraphQLTypes["GpsWithoutAddressCreateInput"] | undefined
};
	["AddressUpdateInvoicesEntityRelationInput"]: {
		create?: GraphQLTypes["InvoiceWithoutAddressCreateInput"] | undefined,
	update?: GraphQLTypes["AddressUpdateInvoicesRelationInput"] | undefined,
	upsert?: GraphQLTypes["AddressUpsertInvoicesRelationInput"] | undefined,
	connect?: GraphQLTypes["InvoiceUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["InvoiceUniqueWhere"] | undefined,
	delete?: GraphQLTypes["InvoiceUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["AddressUpdateInvoicesRelationInput"]: {
		by?: GraphQLTypes["InvoiceUniqueWhere"] | undefined,
	data?: GraphQLTypes["InvoiceWithoutAddressUpdateInput"] | undefined
};
	["InvoiceWithoutAddressUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	publicKey?: string | undefined,
	fakturoidId?: string | undefined,
	fakturoidData?: string | undefined,
	legacyUrl?: string | undefined,
	customer?: GraphQLTypes["InvoiceUpdateCustomerEntityRelationInput"] | undefined,
	orderPayments?: Array<GraphQLTypes["InvoiceUpdateOrderPaymentsEntityRelationInput"]> | undefined,
	publicUrl?: string | undefined,
	billingSubject?: GraphQLTypes["InvoiceUpdateBillingSubjectEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InvoiceUpdateCustomerEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerWithoutInvoicesCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerWithoutInvoicesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["InvoiceUpsertCustomerRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CustomerWithoutInvoicesUpdateInput"]: {
		addresses?: Array<GraphQLTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerUpdateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerUpdateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerUpdateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoicingPlan?: GraphQLTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerUpdateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerUpdateTagsEntityRelationInput"]: {
		create?: GraphQLTypes["TagWithoutCustomersCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerUpdateTagsRelationInput"] | undefined,
	upsert?: GraphQLTypes["CustomerUpsertTagsRelationInput"] | undefined,
	connect?: GraphQLTypes["TagUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TagUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TagUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CustomerUpdateTagsRelationInput"]: {
		by?: GraphQLTypes["TagUniqueWhere"] | undefined,
	data?: GraphQLTypes["TagWithoutCustomersUpdateInput"] | undefined
};
	["TagWithoutCustomersUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	products?: Array<GraphQLTypes["TagUpdateProductsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["TagUpdateCategoriesEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	addTagsOnRegistration?: Array<GraphQLTypes["TagUpdateAddTagsOnRegistrationEntityRelationInput"]> | undefined,
	nestedCategories?: Array<GraphQLTypes["TagUpdateNestedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["TagUpdateDeliveryZonesEntityRelationInput"]> | undefined,
	publicInChannels?: Array<GraphQLTypes["TagUpdatePublicInChannelsEntityRelationInput"]> | undefined,
	allowChannelPayments?: Array<GraphQLTypes["TagUpdateAllowChannelPaymentsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["TagUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TagUpdateProductsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductWithoutTagsCreateInput"] | undefined,
	update?: GraphQLTypes["TagUpdateProductsRelationInput"] | undefined,
	upsert?: GraphQLTypes["TagUpsertProductsRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TagUpdateProductsRelationInput"]: {
		by?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	data?: GraphQLTypes["ProductWithoutTagsUpdateInput"] | undefined
};
	["ProductWithoutTagsUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	priceCents?: number | undefined,
	notDiscountable?: boolean | undefined,
	packing?: GraphQLTypes["ProductUpdatePackingEntityRelationInput"] | undefined,
	recipe?: GraphQLTypes["ProductUpdateRecipeEntityRelationInput"] | undefined,
	categories?: Array<GraphQLTypes["ProductUpdateCategoriesEntityRelationInput"]> | undefined,
	vatRate?: GraphQLTypes["ProductUpdateVatRateEntityRelationInput"] | undefined,
	stocks?: Array<GraphQLTypes["ProductUpdateStocksEntityRelationInput"]> | undefined,
	groupPrices?: Array<GraphQLTypes["ProductUpdateGroupPricesEntityRelationInput"]> | undefined,
	image?: GraphQLTypes["ProductUpdateImageEntityRelationInput"] | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	cartItems?: Array<GraphQLTypes["ProductUpdateCartItemsEntityRelationInput"]> | undefined,
	availability?: GraphQLTypes["ProductAvailability"] | undefined,
	order?: number | undefined,
	manager?: GraphQLTypes["ProductUpdateManagerEntityRelationInput"] | undefined,
	orderItems?: Array<GraphQLTypes["ProductUpdateOrderItemsEntityRelationInput"]> | undefined,
	maximumQuantityPerOrder?: number | undefined,
	inheritedCategories?: Array<GraphQLTypes["ProductUpdateInheritedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["ProductUpdateDeliveryZonesEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["ProductUpdateLocalesEntityRelationInput"]> | undefined,
	archivedAt?: GraphQLTypes["DateTime"] | undefined,
	customerPrices?: Array<GraphQLTypes["ProductUpdateCustomerPricesEntityRelationInput"]> | undefined,
	virtualProduct?: GraphQLTypes["ProductUpdateVirtualProductEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["ProductUpdateMetaEntityRelationInput"] | undefined,
	page?: GraphQLTypes["ProductUpdatePageEntityRelationInput"] | undefined,
	salesDays?: Array<GraphQLTypes["ProductUpdateSalesDaysEntityRelationInput"]> | undefined,
	salesWeeks?: Array<GraphQLTypes["ProductUpdateSalesWeeksEntityRelationInput"]> | undefined,
	salesMonths?: Array<GraphQLTypes["ProductUpdateSalesMonthsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["ProductUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	hasSubscription?: boolean | undefined,
	pointOfSaleTileColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductUpdatePackingEntityRelationInput"]: {
		create?: GraphQLTypes["ProductPackingCreateInput"] | undefined,
	update?: GraphQLTypes["ProductPackingUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductUpsertPackingRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductPackingUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProductPackingUpdateInput"]: {
		name?: string | undefined,
	image?: GraphQLTypes["ProductPackingUpdateImageEntityRelationInput"] | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	volumeMl?: number | undefined,
	icon?: GraphQLTypes["ProductPackingUpdateIconEntityRelationInput"] | undefined,
	shortName?: string | undefined,
	locales?: Array<GraphQLTypes["ProductPackingUpdateLocalesEntityRelationInput"]> | undefined,
	preparedPackingQuantities?: Array<GraphQLTypes["ProductPackingUpdatePreparedPackingQuantitiesEntityRelationInput"]> | undefined,
	isPackedInCardboard?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductPackingUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductPackingUpsertImageRelationInput"] | undefined,
	connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ImageUpdateInput"]: {
		url?: string | undefined,
	width?: number | undefined,
	height?: number | undefined,
	size?: number | undefined,
	type?: string | undefined,
	alt?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductPackingUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["ProductPackingUpdateIconEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductPackingUpsertIconRelationInput"] | undefined,
	connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProductPackingUpsertIconRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["ProductPackingUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["ProductPackingLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["ProductPackingUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["ProductPackingUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductPackingLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductPackingLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductPackingLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductPackingUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["ProductPackingLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["ProductPackingLocaleWithoutRootUpdateInput"] | undefined
};
	["ProductPackingLocaleWithoutRootUpdateInput"]: {
		name?: string | undefined,
	shortName?: string | undefined,
	description?: string | undefined,
	locale?: GraphQLTypes["ProductPackingLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductPackingLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutProductPackingsCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutProductPackingsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductPackingLocaleUpsertLocaleRelationInput"] | undefined,
	connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutProductPackingsUpdateInput"]: {
		businessCategories?: Array<GraphQLTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateBusinessCategoriesEntityRelationInput"]: {
		create?: GraphQLTypes["BusinessCategoryLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateBusinessCategoriesRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertBusinessCategoriesRelationInput"] | undefined,
	connect?: GraphQLTypes["BusinessCategoryLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["BusinessCategoryLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["BusinessCategoryLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateBusinessCategoriesRelationInput"]: {
		by?: GraphQLTypes["BusinessCategoryLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["BusinessCategoryLocaleWithoutLocaleUpdateInput"] | undefined
};
	["BusinessCategoryLocaleWithoutLocaleUpdateInput"]: {
		name?: string | undefined,
	root?: GraphQLTypes["BusinessCategoryLocaleUpdateRootEntityRelationInput"] | undefined,
	title?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessCategoryLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["BusinessCategoryWithoutLocalesCreateInput"] | undefined,
	update?: GraphQLTypes["BusinessCategoryWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BusinessCategoryLocaleUpsertRootRelationInput"] | undefined,
	connect?: GraphQLTypes["BusinessCategoryUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["BusinessCategoryWithoutLocalesUpdateInput"]: {
		order?: number | undefined,
	visibleToNewCustomers?: boolean | undefined,
	internalName?: string | undefined,
	businessCustomers?: Array<GraphQLTypes["BusinessCategoryUpdateBusinessCustomersEntityRelationInput"]> | undefined,
	recurrences?: Array<GraphQLTypes["BusinessCategoryUpdateRecurrencesEntityRelationInput"]> | undefined,
	specificProducts?: GraphQLTypes["BusinessCategoryUpdateSpecificProductsEntityRelationInput"] | undefined,
	seasonalProductCategories?: GraphQLTypes["BusinessCategoryUpdateSeasonalProductCategoriesEntityRelationInput"] | undefined,
	specificProductsProductCategories?: GraphQLTypes["BusinessCategoryUpdateSpecificProductsProductCategoriesEntityRelationInput"] | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessCategoryUpdateBusinessCustomersEntityRelationInput"]: {
		create?: GraphQLTypes["BusinessCustomerWithoutCategoryCreateInput"] | undefined,
	update?: GraphQLTypes["BusinessCategoryUpdateBusinessCustomersRelationInput"] | undefined,
	upsert?: GraphQLTypes["BusinessCategoryUpsertBusinessCustomersRelationInput"] | undefined,
	connect?: GraphQLTypes["BusinessCustomerUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["BusinessCustomerUniqueWhere"] | undefined,
	delete?: GraphQLTypes["BusinessCustomerUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["BusinessCategoryUpdateBusinessCustomersRelationInput"]: {
		by?: GraphQLTypes["BusinessCustomerUniqueWhere"] | undefined,
	data?: GraphQLTypes["BusinessCustomerWithoutCategoryUpdateInput"] | undefined
};
	["BusinessCustomerWithoutCategoryUpdateInput"]: {
		name?: string | undefined,
	customer?: GraphQLTypes["BusinessCustomerUpdateCustomerEntityRelationInput"] | undefined,
	owners?: Array<GraphQLTypes["BusinessCustomerUpdateOwnersEntityRelationInput"]> | undefined,
	members?: Array<GraphQLTypes["BusinessCustomerUpdateMembersEntityRelationInput"]> | undefined,
	accountManager?: GraphQLTypes["BusinessCustomerUpdateAccountManagerEntityRelationInput"] | undefined,
	logo?: GraphQLTypes["BusinessCustomerUpdateLogoEntityRelationInput"] | undefined,
	note?: string | undefined,
	businessServiceEvents?: Array<GraphQLTypes["BusinessCustomerUpdateBusinessServiceEventsEntityRelationInput"]> | undefined,
	doubleshotCoffeeEquipment?: GraphQLTypes["BusinessCustomerUpdateDoubleshotCoffeeEquipmentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessCustomerUpdateCustomerEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerWithoutBusinessCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerWithoutBusinessUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BusinessCustomerUpsertCustomerRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CustomerWithoutBusinessUpdateInput"]: {
		addresses?: Array<GraphQLTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerUpdateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerUpdateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerUpdateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerUpdateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerUpdateCreditsEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerCreditWithoutCustomerCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerUpdateCreditsRelationInput"] | undefined,
	upsert?: GraphQLTypes["CustomerUpsertCreditsRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerCreditUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["CustomerCreditUniqueWhere"] | undefined,
	delete?: GraphQLTypes["CustomerCreditUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CustomerUpdateCreditsRelationInput"]: {
		by?: GraphQLTypes["CustomerCreditUniqueWhere"] | undefined,
	data?: GraphQLTypes["CustomerCreditWithoutCustomerUpdateInput"] | undefined
};
	["CustomerCreditWithoutCustomerUpdateInput"]: {
		initialCreditCents?: number | undefined,
	remainingCreditsCents?: number | undefined,
	expiresAt?: GraphQLTypes["DateTime"] | undefined,
	reason?: string | undefined,
	vatRate?: GraphQLTypes["CustomerCreditUpdateVatRateEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	transactions?: Array<GraphQLTypes["CustomerCreditUpdateTransactionsEntityRelationInput"]> | undefined,
	voucherRedemption?: GraphQLTypes["CustomerCreditUpdateVoucherRedemptionEntityRelationInput"] | undefined,
	invoiceUrl?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreditUpdateVatRateEntityRelationInput"]: {
		create?: GraphQLTypes["VatRateCreateInput"] | undefined,
	update?: GraphQLTypes["VatRateUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CustomerCreditUpsertVatRateRelationInput"] | undefined,
	connect?: GraphQLTypes["VatRateUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["VatRateUpdateInput"]: {
		name?: string | undefined,
	ratePermille?: number | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	channelDeliveries?: Array<GraphQLTypes["VatRateUpdateChannelDeliveriesEntityRelationInput"]> | undefined,
	channelPayments?: Array<GraphQLTypes["VatRateUpdateChannelPaymentsEntityRelationInput"]> | undefined,
	preset?: GraphQLTypes["VatRatePreset"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["VatRateUpdateChannelDeliveriesEntityRelationInput"]: {
		create?: GraphQLTypes["ChannelDeliveryWithoutVatRateCreateInput"] | undefined,
	update?: GraphQLTypes["VatRateUpdateChannelDeliveriesRelationInput"] | undefined,
	upsert?: GraphQLTypes["VatRateUpsertChannelDeliveriesRelationInput"] | undefined,
	connect?: GraphQLTypes["ChannelDeliveryUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ChannelDeliveryUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ChannelDeliveryUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["VatRateUpdateChannelDeliveriesRelationInput"]: {
		by?: GraphQLTypes["ChannelDeliveryUniqueWhere"] | undefined,
	data?: GraphQLTypes["ChannelDeliveryWithoutVatRateUpdateInput"] | undefined
};
	["ChannelDeliveryWithoutVatRateUpdateInput"]: {
		order?: number | undefined,
	priceCents?: number | undefined,
	channel?: GraphQLTypes["ChannelDeliveryUpdateChannelEntityRelationInput"] | undefined,
	method?: GraphQLTypes["ChannelDeliveryUpdateMethodEntityRelationInput"] | undefined,
	defaultVisible?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ChannelDeliveryUpdateChannelEntityRelationInput"]: {
		create?: GraphQLTypes["ChannelWithoutDeliveriesCreateInput"] | undefined,
	update?: GraphQLTypes["ChannelWithoutDeliveriesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ChannelDeliveryUpsertChannelRelationInput"] | undefined,
	connect?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["ChannelWithoutDeliveriesUpdateInput"]: {
		name?: string | undefined,
	disabled?: boolean | undefined,
	payments?: Array<GraphQLTypes["ChannelUpdatePaymentsEntityRelationInput"]> | undefined,
	pointOfSales?: Array<GraphQLTypes["ChannelUpdatePointOfSalesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["ChannelUpdateCartsEntityRelationInput"]> | undefined,
	customers?: Array<GraphQLTypes["ChannelUpdateCustomersEntityRelationInput"]> | undefined,
	code?: GraphQLTypes["ChannelCode"] | undefined,
	addTagsOnRegistration?: Array<GraphQLTypes["ChannelUpdateAddTagsOnRegistrationEntityRelationInput"]> | undefined,
	publicTags?: Array<GraphQLTypes["ChannelUpdatePublicTagsEntityRelationInput"]> | undefined,
	venue?: GraphQLTypes["ChannelUpdateVenueEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ChannelUpdatePaymentsEntityRelationInput"]: {
		create?: GraphQLTypes["ChannelPaymentWithoutChannelCreateInput"] | undefined,
	update?: GraphQLTypes["ChannelUpdatePaymentsRelationInput"] | undefined,
	upsert?: GraphQLTypes["ChannelUpsertPaymentsRelationInput"] | undefined,
	connect?: GraphQLTypes["ChannelPaymentUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ChannelPaymentUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ChannelPaymentUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ChannelUpdatePaymentsRelationInput"]: {
		by?: GraphQLTypes["ChannelPaymentUniqueWhere"] | undefined,
	data?: GraphQLTypes["ChannelPaymentWithoutChannelUpdateInput"] | undefined
};
	["ChannelPaymentWithoutChannelUpdateInput"]: {
		order?: number | undefined,
	method?: GraphQLTypes["ChannelPaymentUpdateMethodEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["ChannelPaymentUpdateVatRateEntityRelationInput"] | undefined,
	requireBillingAddress?: boolean | undefined,
	provideReceipt?: boolean | undefined,
	requireBillingSubject?: boolean | undefined,
	allowOnlyForTags?: Array<GraphQLTypes["ChannelPaymentUpdateAllowOnlyForTagsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ChannelPaymentUpdateMethodEntityRelationInput"]: {
		create?: GraphQLTypes["PaymentMethodWithoutChannelsCreateInput"] | undefined,
	update?: GraphQLTypes["PaymentMethodWithoutChannelsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ChannelPaymentUpsertMethodRelationInput"] | undefined,
	connect?: GraphQLTypes["PaymentMethodUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["PaymentMethodWithoutChannelsUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	enabled?: boolean | undefined,
	deliveryMethods?: Array<GraphQLTypes["PaymentMethodUpdateDeliveryMethodsEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	blockingDispatch?: boolean | undefined,
	type?: GraphQLTypes["PaymentMethodType"] | undefined,
	reduceGratuityByPercentage?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["PaymentMethodUpdateDeliveryMethodsEntityRelationInput"]: {
		create?: GraphQLTypes["DeliveryMethodWithoutPaymentMethodsCreateInput"] | undefined,
	update?: GraphQLTypes["PaymentMethodUpdateDeliveryMethodsRelationInput"] | undefined,
	upsert?: GraphQLTypes["PaymentMethodUpsertDeliveryMethodsRelationInput"] | undefined,
	connect?: GraphQLTypes["DeliveryMethodUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["DeliveryMethodUniqueWhere"] | undefined,
	delete?: GraphQLTypes["DeliveryMethodUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PaymentMethodUpdateDeliveryMethodsRelationInput"]: {
		by?: GraphQLTypes["DeliveryMethodUniqueWhere"] | undefined,
	data?: GraphQLTypes["DeliveryMethodWithoutPaymentMethodsUpdateInput"] | undefined
};
	["DeliveryMethodWithoutPaymentMethodsUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	enabled?: boolean | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	requireDeliveryAddress?: boolean | undefined,
	suitableForDeliveryZones?: Array<GraphQLTypes["DeliveryMethodUpdateSuitableForDeliveryZonesEntityRelationInput"]> | undefined,
	channels?: Array<GraphQLTypes["DeliveryMethodUpdateChannelsEntityRelationInput"]> | undefined,
	courierHandlers?: Array<GraphQLTypes["DeliveryMethodUpdateCourierHandlersEntityRelationInput"]> | undefined,
	enableDeliveryTracking?: boolean | undefined,
	locales?: Array<GraphQLTypes["DeliveryMethodUpdateLocalesEntityRelationInput"]> | undefined,
	timelinePreset?: GraphQLTypes["DeliveryMethodUpdateTimelinePresetEntityRelationInput"] | undefined,
	woltDriveVenueId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryMethodUpdateChannelsEntityRelationInput"]: {
		create?: GraphQLTypes["ChannelDeliveryWithoutMethodCreateInput"] | undefined,
	update?: GraphQLTypes["DeliveryMethodUpdateChannelsRelationInput"] | undefined,
	upsert?: GraphQLTypes["DeliveryMethodUpsertChannelsRelationInput"] | undefined,
	connect?: GraphQLTypes["ChannelDeliveryUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ChannelDeliveryUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ChannelDeliveryUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["DeliveryMethodUpdateChannelsRelationInput"]: {
		by?: GraphQLTypes["ChannelDeliveryUniqueWhere"] | undefined,
	data?: GraphQLTypes["ChannelDeliveryWithoutMethodUpdateInput"] | undefined
};
	["ChannelDeliveryWithoutMethodUpdateInput"]: {
		order?: number | undefined,
	priceCents?: number | undefined,
	channel?: GraphQLTypes["ChannelDeliveryUpdateChannelEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["ChannelDeliveryUpdateVatRateEntityRelationInput"] | undefined,
	defaultVisible?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ChannelDeliveryUpdateVatRateEntityRelationInput"]: {
		create?: GraphQLTypes["VatRateWithoutChannelDeliveriesCreateInput"] | undefined,
	update?: GraphQLTypes["VatRateWithoutChannelDeliveriesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ChannelDeliveryUpsertVatRateRelationInput"] | undefined,
	connect?: GraphQLTypes["VatRateUniqueWhere"] | undefined
};
	["VatRateWithoutChannelDeliveriesUpdateInput"]: {
		name?: string | undefined,
	ratePermille?: number | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	channelPayments?: Array<GraphQLTypes["VatRateUpdateChannelPaymentsEntityRelationInput"]> | undefined,
	preset?: GraphQLTypes["VatRatePreset"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["VatRateUpdateChannelPaymentsEntityRelationInput"]: {
		create?: GraphQLTypes["ChannelPaymentWithoutVatRateCreateInput"] | undefined,
	update?: GraphQLTypes["VatRateUpdateChannelPaymentsRelationInput"] | undefined,
	upsert?: GraphQLTypes["VatRateUpsertChannelPaymentsRelationInput"] | undefined,
	connect?: GraphQLTypes["ChannelPaymentUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ChannelPaymentUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ChannelPaymentUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["VatRateUpdateChannelPaymentsRelationInput"]: {
		by?: GraphQLTypes["ChannelPaymentUniqueWhere"] | undefined,
	data?: GraphQLTypes["ChannelPaymentWithoutVatRateUpdateInput"] | undefined
};
	["ChannelPaymentWithoutVatRateUpdateInput"]: {
		order?: number | undefined,
	channel?: GraphQLTypes["ChannelPaymentUpdateChannelEntityRelationInput"] | undefined,
	method?: GraphQLTypes["ChannelPaymentUpdateMethodEntityRelationInput"] | undefined,
	requireBillingAddress?: boolean | undefined,
	provideReceipt?: boolean | undefined,
	requireBillingSubject?: boolean | undefined,
	allowOnlyForTags?: Array<GraphQLTypes["ChannelPaymentUpdateAllowOnlyForTagsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ChannelPaymentUpdateAllowOnlyForTagsEntityRelationInput"]: {
		create?: GraphQLTypes["TagWithoutAllowChannelPaymentsCreateInput"] | undefined,
	update?: GraphQLTypes["ChannelPaymentUpdateAllowOnlyForTagsRelationInput"] | undefined,
	upsert?: GraphQLTypes["ChannelPaymentUpsertAllowOnlyForTagsRelationInput"] | undefined,
	connect?: GraphQLTypes["TagUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TagUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TagUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ChannelPaymentUpdateAllowOnlyForTagsRelationInput"]: {
		by?: GraphQLTypes["TagUniqueWhere"] | undefined,
	data?: GraphQLTypes["TagWithoutAllowChannelPaymentsUpdateInput"] | undefined
};
	["TagWithoutAllowChannelPaymentsUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	customers?: Array<GraphQLTypes["TagUpdateCustomersEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["TagUpdateProductsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["TagUpdateCategoriesEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	addTagsOnRegistration?: Array<GraphQLTypes["TagUpdateAddTagsOnRegistrationEntityRelationInput"]> | undefined,
	nestedCategories?: Array<GraphQLTypes["TagUpdateNestedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["TagUpdateDeliveryZonesEntityRelationInput"]> | undefined,
	publicInChannels?: Array<GraphQLTypes["TagUpdatePublicInChannelsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["TagUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TagUpdateCustomersEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerWithoutTagsCreateInput"] | undefined,
	update?: GraphQLTypes["TagUpdateCustomersRelationInput"] | undefined,
	upsert?: GraphQLTypes["TagUpsertCustomersRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	delete?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TagUpdateCustomersRelationInput"]: {
		by?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	data?: GraphQLTypes["CustomerWithoutTagsUpdateInput"] | undefined
};
	["CustomerWithoutTagsUpdateInput"]: {
		addresses?: Array<GraphQLTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined,
	credits?: Array<GraphQLTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerUpdateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerUpdateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerUpdateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerUpdateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerUpdatePaymentMethodsEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerPaymentMethodWithoutCustomerCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerUpdatePaymentMethodsRelationInput"] | undefined,
	upsert?: GraphQLTypes["CustomerUpsertPaymentMethodsRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerPaymentMethodUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["CustomerPaymentMethodUniqueWhere"] | undefined,
	delete?: GraphQLTypes["CustomerPaymentMethodUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CustomerUpdatePaymentMethodsRelationInput"]: {
		by?: GraphQLTypes["CustomerPaymentMethodUniqueWhere"] | undefined,
	data?: GraphQLTypes["CustomerPaymentMethodWithoutCustomerUpdateInput"] | undefined
};
	["CustomerPaymentMethodWithoutCustomerUpdateInput"]: {
		caption?: string | undefined,
	data?: GraphQLTypes["Json"] | undefined,
	paymentMethod?: GraphQLTypes["CustomerPaymentMethodUpdatePaymentMethodEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerPaymentMethodUpdatePaymentMethodEntityRelationInput"]: {
		create?: GraphQLTypes["PaymentMethodCreateInput"] | undefined,
	update?: GraphQLTypes["PaymentMethodUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CustomerPaymentMethodUpsertPaymentMethodRelationInput"] | undefined,
	connect?: GraphQLTypes["PaymentMethodUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["PaymentMethodUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	enabled?: boolean | undefined,
	deliveryMethods?: Array<GraphQLTypes["PaymentMethodUpdateDeliveryMethodsEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	blockingDispatch?: boolean | undefined,
	type?: GraphQLTypes["PaymentMethodType"] | undefined,
	channels?: Array<GraphQLTypes["PaymentMethodUpdateChannelsEntityRelationInput"]> | undefined,
	reduceGratuityByPercentage?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerPaymentMethodUpsertPaymentMethodRelationInput"]: {
		update?: GraphQLTypes["PaymentMethodUpdateInput"] | undefined,
	create?: GraphQLTypes["PaymentMethodCreateInput"] | undefined
};
	["CustomerUpsertPaymentMethodsRelationInput"]: {
		by?: GraphQLTypes["CustomerPaymentMethodUniqueWhere"] | undefined,
	update?: GraphQLTypes["CustomerPaymentMethodWithoutCustomerUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerPaymentMethodWithoutCustomerCreateInput"] | undefined
};
	["CustomerUpdateOrdersEntityRelationInput"]: {
		create?: GraphQLTypes["OrderWithoutCustomerCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerUpdateOrdersRelationInput"] | undefined,
	upsert?: GraphQLTypes["CustomerUpsertOrdersRelationInput"] | undefined,
	connect?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	delete?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CustomerUpdateOrdersRelationInput"]: {
		by?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	data?: GraphQLTypes["OrderWithoutCustomerUpdateInput"] | undefined
};
	["OrderWithoutCustomerUpdateInput"]: {
		state?: GraphQLTypes["OrderState"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	canceledAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	channel?: GraphQLTypes["OrderUpdateChannelEntityRelationInput"] | undefined,
	discounts?: Array<GraphQLTypes["OrderUpdateDiscountsEntityRelationInput"]> | undefined,
	delivery?: GraphQLTypes["OrderUpdateDeliveryEntityRelationInput"] | undefined,
	items?: Array<GraphQLTypes["OrderUpdateItemsEntityRelationInput"]> | undefined,
	internalNote?: string | undefined,
	cart?: GraphQLTypes["OrderUpdateCartEntityRelationInput"] | undefined,
	events?: Array<GraphQLTypes["OrderUpdateEventsEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddress?: GraphQLTypes["OrderUpdateBillingAddressEntityRelationInput"] | undefined,
	priceLines?: Array<GraphQLTypes["OrderUpdatePriceLinesEntityRelationInput"]> | undefined,
	payments?: Array<GraphQLTypes["OrderUpdatePaymentsEntityRelationInput"]> | undefined,
	seq?: number | undefined,
	billingSubject?: GraphQLTypes["OrderUpdateBillingSubjectEntityRelationInput"] | undefined,
	summary?: GraphQLTypes["OrderUpdateSummaryEntityRelationInput"] | undefined,
	doubleshotLegacyId?: string | undefined,
	gratuity?: GraphQLTypes["OrderUpdateGratuityEntityRelationInput"] | undefined,
	venue?: GraphQLTypes["OrderUpdateVenueEntityRelationInput"] | undefined,
	fulfillmentNote?: string | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["OrderUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	doubleshotTotalWeightGrams?: number | undefined,
	doubleShotLegacyNumber?: string | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	doubleshotAdminUrl?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderUpdateChannelEntityRelationInput"]: {
		create?: GraphQLTypes["ChannelCreateInput"] | undefined,
	update?: GraphQLTypes["ChannelUpdateInput"] | undefined,
	upsert?: GraphQLTypes["OrderUpsertChannelRelationInput"] | undefined,
	connect?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["ChannelUpdateInput"]: {
		name?: string | undefined,
	disabled?: boolean | undefined,
	payments?: Array<GraphQLTypes["ChannelUpdatePaymentsEntityRelationInput"]> | undefined,
	deliveries?: Array<GraphQLTypes["ChannelUpdateDeliveriesEntityRelationInput"]> | undefined,
	pointOfSales?: Array<GraphQLTypes["ChannelUpdatePointOfSalesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["ChannelUpdateCartsEntityRelationInput"]> | undefined,
	customers?: Array<GraphQLTypes["ChannelUpdateCustomersEntityRelationInput"]> | undefined,
	code?: GraphQLTypes["ChannelCode"] | undefined,
	addTagsOnRegistration?: Array<GraphQLTypes["ChannelUpdateAddTagsOnRegistrationEntityRelationInput"]> | undefined,
	publicTags?: Array<GraphQLTypes["ChannelUpdatePublicTagsEntityRelationInput"]> | undefined,
	venue?: GraphQLTypes["ChannelUpdateVenueEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ChannelUpdatePointOfSalesEntityRelationInput"]: {
		create?: GraphQLTypes["PointOfSaleWithoutChannelsCreateInput"] | undefined,
	update?: GraphQLTypes["ChannelUpdatePointOfSalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["ChannelUpsertPointOfSalesRelationInput"] | undefined,
	connect?: GraphQLTypes["PointOfSaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PointOfSaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PointOfSaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ChannelUpdatePointOfSalesRelationInput"]: {
		by?: GraphQLTypes["PointOfSaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["PointOfSaleWithoutChannelsUpdateInput"] | undefined
};
	["PointOfSaleWithoutChannelsUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	permissions?: GraphQLTypes["PointOfSaleUpdatePermissionsEntityRelationInput"] | undefined,
	tenantPersonId?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleUpdatePermissionsEntityRelationInput"]: {
		connect?: GraphQLTypes["PointOfSalePermissionsUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ChannelUpsertPointOfSalesRelationInput"]: {
		by?: GraphQLTypes["PointOfSaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["PointOfSaleWithoutChannelsUpdateInput"] | undefined,
	create?: GraphQLTypes["PointOfSaleWithoutChannelsCreateInput"] | undefined
};
	["ChannelUpdateCartsEntityRelationInput"]: {
		create?: GraphQLTypes["CartWithoutChannelCreateInput"] | undefined,
	update?: GraphQLTypes["ChannelUpdateCartsRelationInput"] | undefined,
	upsert?: GraphQLTypes["ChannelUpsertCartsRelationInput"] | undefined,
	connect?: GraphQLTypes["CartUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["CartUniqueWhere"] | undefined,
	delete?: GraphQLTypes["CartUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ChannelUpdateCartsRelationInput"]: {
		by?: GraphQLTypes["CartUniqueWhere"] | undefined,
	data?: GraphQLTypes["CartWithoutChannelUpdateInput"] | undefined
};
	["CartWithoutChannelUpdateInput"]: {
		confirmedAt?: GraphQLTypes["DateTime"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	items?: Array<GraphQLTypes["CartUpdateItemsEntityRelationInput"]> | undefined,
	handle?: string | undefined,
	state?: GraphQLTypes["CartState"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	order?: GraphQLTypes["CartUpdateOrderEntityRelationInput"] | undefined,
	customer?: GraphQLTypes["CartUpdateCustomerEntityRelationInput"] | undefined,
	deliveryAddress?: GraphQLTypes["CartUpdateDeliveryAddressEntityRelationInput"] | undefined,
	billingAddress?: GraphQLTypes["CartUpdateBillingAddressEntityRelationInput"] | undefined,
	deliveryOption?: string | undefined,
	paymentOption?: string | undefined,
	delivery?: GraphQLTypes["CartUpdateDeliveryEntityRelationInput"] | undefined,
	payment?: GraphQLTypes["CartUpdatePaymentEntityRelationInput"] | undefined,
	billingSubject?: GraphQLTypes["CartUpdateBillingSubjectEntityRelationInput"] | undefined,
	priceLines?: Array<GraphQLTypes["CartUpdatePriceLinesEntityRelationInput"]> | undefined,
	summary?: GraphQLTypes["CartUpdateSummaryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CartUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["CartItemWithoutCartCreateInput"] | undefined,
	update?: GraphQLTypes["CartUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["CartUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["CartItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["CartItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["CartItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CartUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["CartItemUniqueWhere"] | undefined,
	data?: GraphQLTypes["CartItemWithoutCartUpdateInput"] | undefined
};
	["CartItemWithoutCartUpdateInput"]: {
		quantity?: number | undefined,
	product?: GraphQLTypes["CartItemUpdateProductEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	updatedAt?: GraphQLTypes["DateTime"] | undefined,
	fulfillmentNote?: string | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["CartItemUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["CartItemUpdateProductEntityRelationInput"]: {
		create?: GraphQLTypes["ProductWithoutCartItemsCreateInput"] | undefined,
	update?: GraphQLTypes["ProductWithoutCartItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CartItemUpsertProductRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProductWithoutCartItemsUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	priceCents?: number | undefined,
	notDiscountable?: boolean | undefined,
	packing?: GraphQLTypes["ProductUpdatePackingEntityRelationInput"] | undefined,
	recipe?: GraphQLTypes["ProductUpdateRecipeEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["ProductUpdateTagsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["ProductUpdateCategoriesEntityRelationInput"]> | undefined,
	vatRate?: GraphQLTypes["ProductUpdateVatRateEntityRelationInput"] | undefined,
	stocks?: Array<GraphQLTypes["ProductUpdateStocksEntityRelationInput"]> | undefined,
	groupPrices?: Array<GraphQLTypes["ProductUpdateGroupPricesEntityRelationInput"]> | undefined,
	image?: GraphQLTypes["ProductUpdateImageEntityRelationInput"] | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	availability?: GraphQLTypes["ProductAvailability"] | undefined,
	order?: number | undefined,
	manager?: GraphQLTypes["ProductUpdateManagerEntityRelationInput"] | undefined,
	orderItems?: Array<GraphQLTypes["ProductUpdateOrderItemsEntityRelationInput"]> | undefined,
	maximumQuantityPerOrder?: number | undefined,
	inheritedCategories?: Array<GraphQLTypes["ProductUpdateInheritedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["ProductUpdateDeliveryZonesEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["ProductUpdateLocalesEntityRelationInput"]> | undefined,
	archivedAt?: GraphQLTypes["DateTime"] | undefined,
	customerPrices?: Array<GraphQLTypes["ProductUpdateCustomerPricesEntityRelationInput"]> | undefined,
	virtualProduct?: GraphQLTypes["ProductUpdateVirtualProductEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["ProductUpdateMetaEntityRelationInput"] | undefined,
	page?: GraphQLTypes["ProductUpdatePageEntityRelationInput"] | undefined,
	salesDays?: Array<GraphQLTypes["ProductUpdateSalesDaysEntityRelationInput"]> | undefined,
	salesWeeks?: Array<GraphQLTypes["ProductUpdateSalesWeeksEntityRelationInput"]> | undefined,
	salesMonths?: Array<GraphQLTypes["ProductUpdateSalesMonthsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["ProductUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	hasSubscription?: boolean | undefined,
	pointOfSaleTileColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductUpdateRecipeEntityRelationInput"]: {
		create?: GraphQLTypes["ProductRecipeWithoutProductsCreateInput"] | undefined,
	update?: GraphQLTypes["ProductRecipeWithoutProductsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductUpsertRecipeRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductRecipeUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProductRecipeWithoutProductsUpdateInput"]: {
		name?: string | undefined,
	internalNote?: string | undefined,
	color?: string | undefined,
	image?: GraphQLTypes["ProductRecipeUpdateImageEntityRelationInput"] | undefined,
	icon?: GraphQLTypes["ProductRecipeUpdateIconEntityRelationInput"] | undefined,
	ingredients?: Array<GraphQLTypes["ProductRecipeUpdateIngredientsEntityRelationInput"]> | undefined,
	needsPrepping?: boolean | undefined,
	locales?: Array<GraphQLTypes["ProductRecipeUpdateLocalesEntityRelationInput"]> | undefined,
	gutTuning?: number | undefined,
	freshingContainer?: GraphQLTypes["ProductRecipeUpdateFreshingContainerEntityRelationInput"] | undefined,
	description?: string | undefined,
	nutritionFacts?: GraphQLTypes["ProductRecipeUpdateNutritionFactsEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductRecipeUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductRecipeUpsertImageRelationInput"] | undefined,
	connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProductRecipeUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["ProductRecipeUpdateIconEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductRecipeUpsertIconRelationInput"] | undefined,
	connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProductRecipeUpsertIconRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["ProductRecipeUpdateIngredientsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductIngredientItemWithoutRecipeCreateInput"] | undefined,
	update?: GraphQLTypes["ProductRecipeUpdateIngredientsRelationInput"] | undefined,
	upsert?: GraphQLTypes["ProductRecipeUpsertIngredientsRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductIngredientItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductIngredientItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductIngredientItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductRecipeUpdateIngredientsRelationInput"]: {
		by?: GraphQLTypes["ProductIngredientItemUniqueWhere"] | undefined,
	data?: GraphQLTypes["ProductIngredientItemWithoutRecipeUpdateInput"] | undefined
};
	["ProductIngredientItemWithoutRecipeUpdateInput"]: {
		order?: number | undefined,
	internalOrder?: number | undefined,
	ingredient?: GraphQLTypes["ProductIngredientItemUpdateIngredientEntityRelationInput"] | undefined,
	quantity?: GraphQLTypes["ProductIngredientItemUpdateQuantityEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientItemUpdateIngredientEntityRelationInput"]: {
		create?: GraphQLTypes["ProductIngredientCreateInput"] | undefined,
	update?: GraphQLTypes["ProductIngredientUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductIngredientItemUpsertIngredientRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductIngredientUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["ProductIngredientUpdateInput"]: {
		internalNote?: string | undefined,
	locales?: Array<GraphQLTypes["ProductIngredientUpdateLocalesEntityRelationInput"]> | undefined,
	internalName?: string | undefined,
	categories?: Array<GraphQLTypes["ProductIngredientUpdateCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["ProductIngredientUpdateAllergensEntityRelationInput"]> | undefined,
	needsPrepping?: boolean | undefined,
	allowCustomerRating?: boolean | undefined,
	customerRatings?: Array<GraphQLTypes["ProductIngredientUpdateCustomerRatingsEntityRelationInput"]> | undefined,
	preferredQuantityUnit?: GraphQLTypes["ProductIngredientUpdatePreferredQuantityUnitEntityRelationInput"] | undefined,
	freshingContainer?: GraphQLTypes["ProductIngredientUpdateFreshingContainerEntityRelationInput"] | undefined,
	image?: GraphQLTypes["ProductIngredientUpdateImageEntityRelationInput"] | undefined,
	suppliers?: GraphQLTypes["ProductIngredientUpdateSuppliersEntityRelationInput"] | undefined,
	incrementQuantityNumber?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["ProductIngredientLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["ProductIngredientUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["ProductIngredientUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductIngredientLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductIngredientLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductIngredientLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductIngredientUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["ProductIngredientLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["ProductIngredientLocaleWithoutRootUpdateInput"] | undefined
};
	["ProductIngredientLocaleWithoutRootUpdateInput"]: {
		name?: string | undefined,
	locale?: GraphQLTypes["ProductIngredientLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutProductIngredientsCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutProductIngredientsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductIngredientLocaleUpsertLocaleRelationInput"] | undefined,
	connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutProductIngredientsUpdateInput"]: {
		businessCategories?: Array<GraphQLTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateProductCategoryListsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductCategoryListLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateProductCategoryListsRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertProductCategoryListsRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductCategoryListLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductCategoryListLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductCategoryListLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateProductCategoryListsRelationInput"]: {
		by?: GraphQLTypes["ProductCategoryListLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["ProductCategoryListLocaleWithoutLocaleUpdateInput"] | undefined
};
	["ProductCategoryListLocaleWithoutLocaleUpdateInput"]: {
		name?: string | undefined,
	root?: GraphQLTypes["ProductCategoryListLocaleUpdateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCategoryListLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["ProductCategoryListWithoutLocalesCreateInput"] | undefined,
	update?: GraphQLTypes["ProductCategoryListWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductCategoryListLocaleUpsertRootRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductCategoryListUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["ProductCategoryListWithoutLocalesUpdateInput"]: {
		items?: Array<GraphQLTypes["ProductCategoryListUpdateItemsEntityRelationInput"]> | undefined,
	seasonalProductCategoriesOfBusinessCategory?: GraphQLTypes["ProductCategoryListUpdateSeasonalProductCategoriesOfBusinessCategoryEntityRelationInput"] | undefined,
	specificProductsProductCategoriesOfBusinessCategory?: GraphQLTypes["ProductCategoryListUpdateSpecificProductsProductCategoriesOfBusinessCategoryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCategoryListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductCategoryListItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["ProductCategoryListUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["ProductCategoryListUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductCategoryListItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductCategoryListItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductCategoryListItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductCategoryListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["ProductCategoryListItemUniqueWhere"] | undefined,
	data?: GraphQLTypes["ProductCategoryListItemWithoutListUpdateInput"] | undefined
};
	["ProductCategoryListItemWithoutListUpdateInput"]: {
		order?: number | undefined,
	productCategory?: GraphQLTypes["ProductCategoryListItemUpdateProductCategoryEntityRelationInput"] | undefined,
	showRecipeImages?: boolean | undefined,
	showPackingImages?: boolean | undefined,
	showAllAvailableProducts?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCategoryListItemUpdateProductCategoryEntityRelationInput"]: {
		create?: GraphQLTypes["ProductCategoryCreateInput"] | undefined,
	update?: GraphQLTypes["ProductCategoryUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductCategoryListItemUpsertProductCategoryRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductCategoryUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProductCategoryUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	products?: Array<GraphQLTypes["ProductCategoryUpdateProductsEntityRelationInput"]> | undefined,
	tags?: Array<GraphQLTypes["ProductCategoryUpdateTagsEntityRelationInput"]> | undefined,
	parent?: GraphQLTypes["ProductCategoryUpdateParentEntityRelationInput"] | undefined,
	children?: Array<GraphQLTypes["ProductCategoryUpdateChildrenEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	color?: string | undefined,
	image?: GraphQLTypes["ProductCategoryUpdateImageEntityRelationInput"] | undefined,
	order?: number | undefined,
	descendants?: Array<GraphQLTypes["ProductCategoryUpdateDescendantsEntityRelationInput"]> | undefined,
	ancestors?: Array<GraphQLTypes["ProductCategoryUpdateAncestorsEntityRelationInput"]> | undefined,
	inheritedTags?: Array<GraphQLTypes["ProductCategoryUpdateInheritedTagsEntityRelationInput"]> | undefined,
	nestedProducts?: Array<GraphQLTypes["ProductCategoryUpdateNestedProductsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCategoryUpdateProductsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductWithoutCategoriesCreateInput"] | undefined,
	update?: GraphQLTypes["ProductCategoryUpdateProductsRelationInput"] | undefined,
	upsert?: GraphQLTypes["ProductCategoryUpsertProductsRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductCategoryUpdateProductsRelationInput"]: {
		by?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	data?: GraphQLTypes["ProductWithoutCategoriesUpdateInput"] | undefined
};
	["ProductWithoutCategoriesUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	priceCents?: number | undefined,
	notDiscountable?: boolean | undefined,
	packing?: GraphQLTypes["ProductUpdatePackingEntityRelationInput"] | undefined,
	recipe?: GraphQLTypes["ProductUpdateRecipeEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["ProductUpdateTagsEntityRelationInput"]> | undefined,
	vatRate?: GraphQLTypes["ProductUpdateVatRateEntityRelationInput"] | undefined,
	stocks?: Array<GraphQLTypes["ProductUpdateStocksEntityRelationInput"]> | undefined,
	groupPrices?: Array<GraphQLTypes["ProductUpdateGroupPricesEntityRelationInput"]> | undefined,
	image?: GraphQLTypes["ProductUpdateImageEntityRelationInput"] | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	cartItems?: Array<GraphQLTypes["ProductUpdateCartItemsEntityRelationInput"]> | undefined,
	availability?: GraphQLTypes["ProductAvailability"] | undefined,
	order?: number | undefined,
	manager?: GraphQLTypes["ProductUpdateManagerEntityRelationInput"] | undefined,
	orderItems?: Array<GraphQLTypes["ProductUpdateOrderItemsEntityRelationInput"]> | undefined,
	maximumQuantityPerOrder?: number | undefined,
	inheritedCategories?: Array<GraphQLTypes["ProductUpdateInheritedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["ProductUpdateDeliveryZonesEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["ProductUpdateLocalesEntityRelationInput"]> | undefined,
	archivedAt?: GraphQLTypes["DateTime"] | undefined,
	customerPrices?: Array<GraphQLTypes["ProductUpdateCustomerPricesEntityRelationInput"]> | undefined,
	virtualProduct?: GraphQLTypes["ProductUpdateVirtualProductEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["ProductUpdateMetaEntityRelationInput"] | undefined,
	page?: GraphQLTypes["ProductUpdatePageEntityRelationInput"] | undefined,
	salesDays?: Array<GraphQLTypes["ProductUpdateSalesDaysEntityRelationInput"]> | undefined,
	salesWeeks?: Array<GraphQLTypes["ProductUpdateSalesWeeksEntityRelationInput"]> | undefined,
	salesMonths?: Array<GraphQLTypes["ProductUpdateSalesMonthsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["ProductUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	hasSubscription?: boolean | undefined,
	pointOfSaleTileColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductUpdateTagsEntityRelationInput"]: {
		create?: GraphQLTypes["TagWithoutProductsCreateInput"] | undefined,
	update?: GraphQLTypes["ProductUpdateTagsRelationInput"] | undefined,
	upsert?: GraphQLTypes["ProductUpsertTagsRelationInput"] | undefined,
	connect?: GraphQLTypes["TagUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TagUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TagUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductUpdateTagsRelationInput"]: {
		by?: GraphQLTypes["TagUniqueWhere"] | undefined,
	data?: GraphQLTypes["TagWithoutProductsUpdateInput"] | undefined
};
	["TagWithoutProductsUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	customers?: Array<GraphQLTypes["TagUpdateCustomersEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["TagUpdateCategoriesEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	addTagsOnRegistration?: Array<GraphQLTypes["TagUpdateAddTagsOnRegistrationEntityRelationInput"]> | undefined,
	nestedCategories?: Array<GraphQLTypes["TagUpdateNestedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["TagUpdateDeliveryZonesEntityRelationInput"]> | undefined,
	publicInChannels?: Array<GraphQLTypes["TagUpdatePublicInChannelsEntityRelationInput"]> | undefined,
	allowChannelPayments?: Array<GraphQLTypes["TagUpdateAllowChannelPaymentsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["TagUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TagUpdateCategoriesEntityRelationInput"]: {
		create?: GraphQLTypes["ProductCategoryWithoutTagsCreateInput"] | undefined,
	update?: GraphQLTypes["TagUpdateCategoriesRelationInput"] | undefined,
	upsert?: GraphQLTypes["TagUpsertCategoriesRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductCategoryUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductCategoryUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductCategoryUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TagUpdateCategoriesRelationInput"]: {
		by?: GraphQLTypes["ProductCategoryUniqueWhere"] | undefined,
	data?: GraphQLTypes["ProductCategoryWithoutTagsUpdateInput"] | undefined
};
	["ProductCategoryWithoutTagsUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	products?: Array<GraphQLTypes["ProductCategoryUpdateProductsEntityRelationInput"]> | undefined,
	parent?: GraphQLTypes["ProductCategoryUpdateParentEntityRelationInput"] | undefined,
	children?: Array<GraphQLTypes["ProductCategoryUpdateChildrenEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	color?: string | undefined,
	image?: GraphQLTypes["ProductCategoryUpdateImageEntityRelationInput"] | undefined,
	order?: number | undefined,
	descendants?: Array<GraphQLTypes["ProductCategoryUpdateDescendantsEntityRelationInput"]> | undefined,
	ancestors?: Array<GraphQLTypes["ProductCategoryUpdateAncestorsEntityRelationInput"]> | undefined,
	inheritedTags?: Array<GraphQLTypes["ProductCategoryUpdateInheritedTagsEntityRelationInput"]> | undefined,
	nestedProducts?: Array<GraphQLTypes["ProductCategoryUpdateNestedProductsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCategoryUpdateParentEntityRelationInput"]: {
		create?: GraphQLTypes["ProductCategoryWithoutChildrenCreateInput"] | undefined,
	update?: GraphQLTypes["ProductCategoryWithoutChildrenUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductCategoryUpsertParentRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductCategoryUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProductCategoryWithoutChildrenUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	products?: Array<GraphQLTypes["ProductCategoryUpdateProductsEntityRelationInput"]> | undefined,
	tags?: Array<GraphQLTypes["ProductCategoryUpdateTagsEntityRelationInput"]> | undefined,
	parent?: GraphQLTypes["ProductCategoryUpdateParentEntityRelationInput"] | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	color?: string | undefined,
	image?: GraphQLTypes["ProductCategoryUpdateImageEntityRelationInput"] | undefined,
	order?: number | undefined,
	descendants?: Array<GraphQLTypes["ProductCategoryUpdateDescendantsEntityRelationInput"]> | undefined,
	ancestors?: Array<GraphQLTypes["ProductCategoryUpdateAncestorsEntityRelationInput"]> | undefined,
	inheritedTags?: Array<GraphQLTypes["ProductCategoryUpdateInheritedTagsEntityRelationInput"]> | undefined,
	nestedProducts?: Array<GraphQLTypes["ProductCategoryUpdateNestedProductsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCategoryUpdateTagsEntityRelationInput"]: {
		create?: GraphQLTypes["TagWithoutCategoriesCreateInput"] | undefined,
	update?: GraphQLTypes["ProductCategoryUpdateTagsRelationInput"] | undefined,
	upsert?: GraphQLTypes["ProductCategoryUpsertTagsRelationInput"] | undefined,
	connect?: GraphQLTypes["TagUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TagUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TagUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductCategoryUpdateTagsRelationInput"]: {
		by?: GraphQLTypes["TagUniqueWhere"] | undefined,
	data?: GraphQLTypes["TagWithoutCategoriesUpdateInput"] | undefined
};
	["TagWithoutCategoriesUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	customers?: Array<GraphQLTypes["TagUpdateCustomersEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["TagUpdateProductsEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	addTagsOnRegistration?: Array<GraphQLTypes["TagUpdateAddTagsOnRegistrationEntityRelationInput"]> | undefined,
	nestedCategories?: Array<GraphQLTypes["TagUpdateNestedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["TagUpdateDeliveryZonesEntityRelationInput"]> | undefined,
	publicInChannels?: Array<GraphQLTypes["TagUpdatePublicInChannelsEntityRelationInput"]> | undefined,
	allowChannelPayments?: Array<GraphQLTypes["TagUpdateAllowChannelPaymentsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["TagUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TagUpdateAddTagsOnRegistrationEntityRelationInput"]: {
		create?: GraphQLTypes["ChannelWithoutAddTagsOnRegistrationCreateInput"] | undefined,
	update?: GraphQLTypes["TagUpdateAddTagsOnRegistrationRelationInput"] | undefined,
	upsert?: GraphQLTypes["TagUpsertAddTagsOnRegistrationRelationInput"] | undefined,
	connect?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TagUpdateAddTagsOnRegistrationRelationInput"]: {
		by?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	data?: GraphQLTypes["ChannelWithoutAddTagsOnRegistrationUpdateInput"] | undefined
};
	["ChannelWithoutAddTagsOnRegistrationUpdateInput"]: {
		name?: string | undefined,
	disabled?: boolean | undefined,
	payments?: Array<GraphQLTypes["ChannelUpdatePaymentsEntityRelationInput"]> | undefined,
	deliveries?: Array<GraphQLTypes["ChannelUpdateDeliveriesEntityRelationInput"]> | undefined,
	pointOfSales?: Array<GraphQLTypes["ChannelUpdatePointOfSalesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["ChannelUpdateCartsEntityRelationInput"]> | undefined,
	customers?: Array<GraphQLTypes["ChannelUpdateCustomersEntityRelationInput"]> | undefined,
	code?: GraphQLTypes["ChannelCode"] | undefined,
	publicTags?: Array<GraphQLTypes["ChannelUpdatePublicTagsEntityRelationInput"]> | undefined,
	venue?: GraphQLTypes["ChannelUpdateVenueEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ChannelUpdateCustomersEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerWithoutChannelsCreateInput"] | undefined,
	update?: GraphQLTypes["ChannelUpdateCustomersRelationInput"] | undefined,
	upsert?: GraphQLTypes["ChannelUpsertCustomersRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	delete?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ChannelUpdateCustomersRelationInput"]: {
		by?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	data?: GraphQLTypes["CustomerWithoutChannelsUpdateInput"] | undefined
};
	["CustomerWithoutChannelsUpdateInput"]: {
		addresses?: Array<GraphQLTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerUpdateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerUpdateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerUpdateUserEntityRelationInput"] | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerUpdateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerUpdatePermissionsEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerPermissionsUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CustomerUpdateGroupEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerGroupWithoutCustomersCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerGroupWithoutCustomersUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CustomerUpsertGroupRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerGroupUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CustomerGroupWithoutCustomersUpdateInput"]: {
		name?: string | undefined,
	productPrices?: Array<GraphQLTypes["CustomerGroupUpdateProductPricesEntityRelationInput"]> | undefined,
	discountPermille?: number | undefined,
	code?: string | undefined,
	doubleshotLegacyId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerGroupUpdateProductPricesEntityRelationInput"]: {
		create?: GraphQLTypes["ProductGroupPriceWithoutGroupCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerGroupUpdateProductPricesRelationInput"] | undefined,
	upsert?: GraphQLTypes["CustomerGroupUpsertProductPricesRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductGroupPriceUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductGroupPriceUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductGroupPriceUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CustomerGroupUpdateProductPricesRelationInput"]: {
		by?: GraphQLTypes["ProductGroupPriceUniqueWhere"] | undefined,
	data?: GraphQLTypes["ProductGroupPriceWithoutGroupUpdateInput"] | undefined
};
	["ProductGroupPriceWithoutGroupUpdateInput"]: {
		priceCents?: number | undefined,
	product?: GraphQLTypes["ProductGroupPriceUpdateProductEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductGroupPriceUpdateProductEntityRelationInput"]: {
		create?: GraphQLTypes["ProductWithoutGroupPricesCreateInput"] | undefined,
	update?: GraphQLTypes["ProductWithoutGroupPricesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductGroupPriceUpsertProductRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductUniqueWhere"] | undefined
};
	["ProductWithoutGroupPricesUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	priceCents?: number | undefined,
	notDiscountable?: boolean | undefined,
	packing?: GraphQLTypes["ProductUpdatePackingEntityRelationInput"] | undefined,
	recipe?: GraphQLTypes["ProductUpdateRecipeEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["ProductUpdateTagsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["ProductUpdateCategoriesEntityRelationInput"]> | undefined,
	vatRate?: GraphQLTypes["ProductUpdateVatRateEntityRelationInput"] | undefined,
	stocks?: Array<GraphQLTypes["ProductUpdateStocksEntityRelationInput"]> | undefined,
	image?: GraphQLTypes["ProductUpdateImageEntityRelationInput"] | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	cartItems?: Array<GraphQLTypes["ProductUpdateCartItemsEntityRelationInput"]> | undefined,
	availability?: GraphQLTypes["ProductAvailability"] | undefined,
	order?: number | undefined,
	manager?: GraphQLTypes["ProductUpdateManagerEntityRelationInput"] | undefined,
	orderItems?: Array<GraphQLTypes["ProductUpdateOrderItemsEntityRelationInput"]> | undefined,
	maximumQuantityPerOrder?: number | undefined,
	inheritedCategories?: Array<GraphQLTypes["ProductUpdateInheritedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["ProductUpdateDeliveryZonesEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["ProductUpdateLocalesEntityRelationInput"]> | undefined,
	archivedAt?: GraphQLTypes["DateTime"] | undefined,
	customerPrices?: Array<GraphQLTypes["ProductUpdateCustomerPricesEntityRelationInput"]> | undefined,
	virtualProduct?: GraphQLTypes["ProductUpdateVirtualProductEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["ProductUpdateMetaEntityRelationInput"] | undefined,
	page?: GraphQLTypes["ProductUpdatePageEntityRelationInput"] | undefined,
	salesDays?: Array<GraphQLTypes["ProductUpdateSalesDaysEntityRelationInput"]> | undefined,
	salesWeeks?: Array<GraphQLTypes["ProductUpdateSalesWeeksEntityRelationInput"]> | undefined,
	salesMonths?: Array<GraphQLTypes["ProductUpdateSalesMonthsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["ProductUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	hasSubscription?: boolean | undefined,
	pointOfSaleTileColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductUpdateCategoriesEntityRelationInput"]: {
		create?: GraphQLTypes["ProductCategoryWithoutProductsCreateInput"] | undefined,
	update?: GraphQLTypes["ProductUpdateCategoriesRelationInput"] | undefined,
	upsert?: GraphQLTypes["ProductUpsertCategoriesRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductCategoryUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductCategoryUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductCategoryUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductUpdateCategoriesRelationInput"]: {
		by?: GraphQLTypes["ProductCategoryUniqueWhere"] | undefined,
	data?: GraphQLTypes["ProductCategoryWithoutProductsUpdateInput"] | undefined
};
	["ProductCategoryWithoutProductsUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	tags?: Array<GraphQLTypes["ProductCategoryUpdateTagsEntityRelationInput"]> | undefined,
	parent?: GraphQLTypes["ProductCategoryUpdateParentEntityRelationInput"] | undefined,
	children?: Array<GraphQLTypes["ProductCategoryUpdateChildrenEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	color?: string | undefined,
	image?: GraphQLTypes["ProductCategoryUpdateImageEntityRelationInput"] | undefined,
	order?: number | undefined,
	descendants?: Array<GraphQLTypes["ProductCategoryUpdateDescendantsEntityRelationInput"]> | undefined,
	ancestors?: Array<GraphQLTypes["ProductCategoryUpdateAncestorsEntityRelationInput"]> | undefined,
	inheritedTags?: Array<GraphQLTypes["ProductCategoryUpdateInheritedTagsEntityRelationInput"]> | undefined,
	nestedProducts?: Array<GraphQLTypes["ProductCategoryUpdateNestedProductsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCategoryUpdateChildrenEntityRelationInput"]: {
		create?: GraphQLTypes["ProductCategoryWithoutParentCreateInput"] | undefined,
	update?: GraphQLTypes["ProductCategoryUpdateChildrenRelationInput"] | undefined,
	upsert?: GraphQLTypes["ProductCategoryUpsertChildrenRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductCategoryUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductCategoryUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductCategoryUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductCategoryUpdateChildrenRelationInput"]: {
		by?: GraphQLTypes["ProductCategoryUniqueWhere"] | undefined,
	data?: GraphQLTypes["ProductCategoryWithoutParentUpdateInput"] | undefined
};
	["ProductCategoryWithoutParentUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	products?: Array<GraphQLTypes["ProductCategoryUpdateProductsEntityRelationInput"]> | undefined,
	tags?: Array<GraphQLTypes["ProductCategoryUpdateTagsEntityRelationInput"]> | undefined,
	children?: Array<GraphQLTypes["ProductCategoryUpdateChildrenEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	color?: string | undefined,
	image?: GraphQLTypes["ProductCategoryUpdateImageEntityRelationInput"] | undefined,
	order?: number | undefined,
	descendants?: Array<GraphQLTypes["ProductCategoryUpdateDescendantsEntityRelationInput"]> | undefined,
	ancestors?: Array<GraphQLTypes["ProductCategoryUpdateAncestorsEntityRelationInput"]> | undefined,
	inheritedTags?: Array<GraphQLTypes["ProductCategoryUpdateInheritedTagsEntityRelationInput"]> | undefined,
	nestedProducts?: Array<GraphQLTypes["ProductCategoryUpdateNestedProductsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCategoryUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductCategoryUpsertImageRelationInput"] | undefined,
	connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProductCategoryUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["ProductCategoryUpdateDescendantsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductCategoryTreeUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductCategoryTreeUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductCategoryTreeUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductCategoryUpdateAncestorsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductCategoryTreeUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductCategoryTreeUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductCategoryTreeUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductCategoryUpdateInheritedTagsEntityRelationInput"]: {
		connect?: GraphQLTypes["InheritedProductCategoryTagUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["InheritedProductCategoryTagUniqueWhere"] | undefined,
	delete?: GraphQLTypes["InheritedProductCategoryTagUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductCategoryUpdateNestedProductsEntityRelationInput"]: {
		connect?: GraphQLTypes["NestedProductCategoryProductUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["NestedProductCategoryProductUniqueWhere"] | undefined,
	delete?: GraphQLTypes["NestedProductCategoryProductUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductCategoryUpsertChildrenRelationInput"]: {
		by?: GraphQLTypes["ProductCategoryUniqueWhere"] | undefined,
	update?: GraphQLTypes["ProductCategoryWithoutParentUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductCategoryWithoutParentCreateInput"] | undefined
};
	["ProductUpsertCategoriesRelationInput"]: {
		by?: GraphQLTypes["ProductCategoryUniqueWhere"] | undefined,
	update?: GraphQLTypes["ProductCategoryWithoutProductsUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductCategoryWithoutProductsCreateInput"] | undefined
};
	["ProductUpdateVatRateEntityRelationInput"]: {
		create?: GraphQLTypes["VatRateCreateInput"] | undefined,
	update?: GraphQLTypes["VatRateUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductUpsertVatRateRelationInput"] | undefined,
	connect?: GraphQLTypes["VatRateUniqueWhere"] | undefined
};
	["ProductUpsertVatRateRelationInput"]: {
		update?: GraphQLTypes["VatRateUpdateInput"] | undefined,
	create?: GraphQLTypes["VatRateCreateInput"] | undefined
};
	["ProductUpdateStocksEntityRelationInput"]: {
		create?: GraphQLTypes["ProductStockWithoutProductCreateInput"] | undefined,
	update?: GraphQLTypes["ProductUpdateStocksRelationInput"] | undefined,
	upsert?: GraphQLTypes["ProductUpsertStocksRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductStockUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductStockUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductStockUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductUpdateStocksRelationInput"]: {
		by?: GraphQLTypes["ProductStockUniqueWhere"] | undefined,
	data?: GraphQLTypes["ProductStockWithoutProductUpdateInput"] | undefined
};
	["ProductStockWithoutProductUpdateInput"]: {
		quantity?: number | undefined,
	store?: GraphQLTypes["ProductStockUpdateStoreEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductStockUpdateStoreEntityRelationInput"]: {
		create?: GraphQLTypes["StoreCreateInput"] | undefined,
	update?: GraphQLTypes["StoreUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductStockUpsertStoreRelationInput"] | undefined,
	connect?: GraphQLTypes["StoreUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["StoreUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductStockUpsertStoreRelationInput"]: {
		update?: GraphQLTypes["StoreUpdateInput"] | undefined,
	create?: GraphQLTypes["StoreCreateInput"] | undefined
};
	["ProductUpsertStocksRelationInput"]: {
		by?: GraphQLTypes["ProductStockUniqueWhere"] | undefined,
	update?: GraphQLTypes["ProductStockWithoutProductUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductStockWithoutProductCreateInput"] | undefined
};
	["ProductUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductUpsertImageRelationInput"] | undefined,
	connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProductUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["ProductUpdateCartItemsEntityRelationInput"]: {
		create?: GraphQLTypes["CartItemWithoutProductCreateInput"] | undefined,
	update?: GraphQLTypes["ProductUpdateCartItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["ProductUpsertCartItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["CartItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["CartItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["CartItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductUpdateCartItemsRelationInput"]: {
		by?: GraphQLTypes["CartItemUniqueWhere"] | undefined,
	data?: GraphQLTypes["CartItemWithoutProductUpdateInput"] | undefined
};
	["CartItemWithoutProductUpdateInput"]: {
		quantity?: number | undefined,
	cart?: GraphQLTypes["CartItemUpdateCartEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	updatedAt?: GraphQLTypes["DateTime"] | undefined,
	fulfillmentNote?: string | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["CartItemUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["CartItemUpdateCartEntityRelationInput"]: {
		create?: GraphQLTypes["CartWithoutItemsCreateInput"] | undefined,
	update?: GraphQLTypes["CartWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CartItemUpsertCartRelationInput"] | undefined,
	connect?: GraphQLTypes["CartUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CartWithoutItemsUpdateInput"]: {
		confirmedAt?: GraphQLTypes["DateTime"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	handle?: string | undefined,
	state?: GraphQLTypes["CartState"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	channel?: GraphQLTypes["CartUpdateChannelEntityRelationInput"] | undefined,
	order?: GraphQLTypes["CartUpdateOrderEntityRelationInput"] | undefined,
	customer?: GraphQLTypes["CartUpdateCustomerEntityRelationInput"] | undefined,
	deliveryAddress?: GraphQLTypes["CartUpdateDeliveryAddressEntityRelationInput"] | undefined,
	billingAddress?: GraphQLTypes["CartUpdateBillingAddressEntityRelationInput"] | undefined,
	deliveryOption?: string | undefined,
	paymentOption?: string | undefined,
	delivery?: GraphQLTypes["CartUpdateDeliveryEntityRelationInput"] | undefined,
	payment?: GraphQLTypes["CartUpdatePaymentEntityRelationInput"] | undefined,
	billingSubject?: GraphQLTypes["CartUpdateBillingSubjectEntityRelationInput"] | undefined,
	priceLines?: Array<GraphQLTypes["CartUpdatePriceLinesEntityRelationInput"]> | undefined,
	summary?: GraphQLTypes["CartUpdateSummaryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CartUpdateChannelEntityRelationInput"]: {
		create?: GraphQLTypes["ChannelWithoutCartsCreateInput"] | undefined,
	update?: GraphQLTypes["ChannelWithoutCartsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CartUpsertChannelRelationInput"] | undefined,
	connect?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ChannelWithoutCartsUpdateInput"]: {
		name?: string | undefined,
	disabled?: boolean | undefined,
	payments?: Array<GraphQLTypes["ChannelUpdatePaymentsEntityRelationInput"]> | undefined,
	deliveries?: Array<GraphQLTypes["ChannelUpdateDeliveriesEntityRelationInput"]> | undefined,
	pointOfSales?: Array<GraphQLTypes["ChannelUpdatePointOfSalesEntityRelationInput"]> | undefined,
	customers?: Array<GraphQLTypes["ChannelUpdateCustomersEntityRelationInput"]> | undefined,
	code?: GraphQLTypes["ChannelCode"] | undefined,
	addTagsOnRegistration?: Array<GraphQLTypes["ChannelUpdateAddTagsOnRegistrationEntityRelationInput"]> | undefined,
	publicTags?: Array<GraphQLTypes["ChannelUpdatePublicTagsEntityRelationInput"]> | undefined,
	venue?: GraphQLTypes["ChannelUpdateVenueEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ChannelUpdateAddTagsOnRegistrationEntityRelationInput"]: {
		create?: GraphQLTypes["TagWithoutAddTagsOnRegistrationCreateInput"] | undefined,
	update?: GraphQLTypes["ChannelUpdateAddTagsOnRegistrationRelationInput"] | undefined,
	upsert?: GraphQLTypes["ChannelUpsertAddTagsOnRegistrationRelationInput"] | undefined,
	connect?: GraphQLTypes["TagUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TagUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TagUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ChannelUpdateAddTagsOnRegistrationRelationInput"]: {
		by?: GraphQLTypes["TagUniqueWhere"] | undefined,
	data?: GraphQLTypes["TagWithoutAddTagsOnRegistrationUpdateInput"] | undefined
};
	["TagWithoutAddTagsOnRegistrationUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	customers?: Array<GraphQLTypes["TagUpdateCustomersEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["TagUpdateProductsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["TagUpdateCategoriesEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	nestedCategories?: Array<GraphQLTypes["TagUpdateNestedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["TagUpdateDeliveryZonesEntityRelationInput"]> | undefined,
	publicInChannels?: Array<GraphQLTypes["TagUpdatePublicInChannelsEntityRelationInput"]> | undefined,
	allowChannelPayments?: Array<GraphQLTypes["TagUpdateAllowChannelPaymentsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["TagUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TagUpdateNestedCategoriesEntityRelationInput"]: {
		connect?: GraphQLTypes["InheritedProductCategoryTagUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["InheritedProductCategoryTagUniqueWhere"] | undefined,
	delete?: GraphQLTypes["InheritedProductCategoryTagUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TagUpdateDeliveryZonesEntityRelationInput"]: {
		create?: GraphQLTypes["DeliveryZoneWithoutDeliveryZonesOfTagsCreateInput"] | undefined,
	update?: GraphQLTypes["TagUpdateDeliveryZonesRelationInput"] | undefined,
	upsert?: GraphQLTypes["TagUpsertDeliveryZonesRelationInput"] | undefined,
	connect?: GraphQLTypes["DeliveryZoneUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["DeliveryZoneUniqueWhere"] | undefined,
	delete?: GraphQLTypes["DeliveryZoneUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TagUpdateDeliveryZonesRelationInput"]: {
		by?: GraphQLTypes["DeliveryZoneUniqueWhere"] | undefined,
	data?: GraphQLTypes["DeliveryZoneWithoutDeliveryZonesOfTagsUpdateInput"] | undefined
};
	["DeliveryZoneWithoutDeliveryZonesOfTagsUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	type?: GraphQLTypes["DeliveryZoneType"] | undefined,
	addresses?: Array<GraphQLTypes["DeliveryZoneUpdateAddressesEntityRelationInput"]> | undefined,
	suitableDeliveryMethods?: Array<GraphQLTypes["DeliveryZoneUpdateSuitableDeliveryMethodsEntityRelationInput"]> | undefined,
	deliveryZonesOfProducts?: Array<GraphQLTypes["DeliveryZoneUpdateDeliveryZonesOfProductsEntityRelationInput"]> | undefined,
	addressesMetadata?: Array<GraphQLTypes["DeliveryZoneUpdateAddressesMetadataEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryZoneUpdateDeliveryZonesOfProductsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductWithoutDeliveryZonesCreateInput"] | undefined,
	update?: GraphQLTypes["DeliveryZoneUpdateDeliveryZonesOfProductsRelationInput"] | undefined,
	upsert?: GraphQLTypes["DeliveryZoneUpsertDeliveryZonesOfProductsRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["DeliveryZoneUpdateDeliveryZonesOfProductsRelationInput"]: {
		by?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	data?: GraphQLTypes["ProductWithoutDeliveryZonesUpdateInput"] | undefined
};
	["ProductWithoutDeliveryZonesUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	priceCents?: number | undefined,
	notDiscountable?: boolean | undefined,
	packing?: GraphQLTypes["ProductUpdatePackingEntityRelationInput"] | undefined,
	recipe?: GraphQLTypes["ProductUpdateRecipeEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["ProductUpdateTagsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["ProductUpdateCategoriesEntityRelationInput"]> | undefined,
	vatRate?: GraphQLTypes["ProductUpdateVatRateEntityRelationInput"] | undefined,
	stocks?: Array<GraphQLTypes["ProductUpdateStocksEntityRelationInput"]> | undefined,
	groupPrices?: Array<GraphQLTypes["ProductUpdateGroupPricesEntityRelationInput"]> | undefined,
	image?: GraphQLTypes["ProductUpdateImageEntityRelationInput"] | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	cartItems?: Array<GraphQLTypes["ProductUpdateCartItemsEntityRelationInput"]> | undefined,
	availability?: GraphQLTypes["ProductAvailability"] | undefined,
	order?: number | undefined,
	manager?: GraphQLTypes["ProductUpdateManagerEntityRelationInput"] | undefined,
	orderItems?: Array<GraphQLTypes["ProductUpdateOrderItemsEntityRelationInput"]> | undefined,
	maximumQuantityPerOrder?: number | undefined,
	inheritedCategories?: Array<GraphQLTypes["ProductUpdateInheritedCategoriesEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["ProductUpdateLocalesEntityRelationInput"]> | undefined,
	archivedAt?: GraphQLTypes["DateTime"] | undefined,
	customerPrices?: Array<GraphQLTypes["ProductUpdateCustomerPricesEntityRelationInput"]> | undefined,
	virtualProduct?: GraphQLTypes["ProductUpdateVirtualProductEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["ProductUpdateMetaEntityRelationInput"] | undefined,
	page?: GraphQLTypes["ProductUpdatePageEntityRelationInput"] | undefined,
	salesDays?: Array<GraphQLTypes["ProductUpdateSalesDaysEntityRelationInput"]> | undefined,
	salesWeeks?: Array<GraphQLTypes["ProductUpdateSalesWeeksEntityRelationInput"]> | undefined,
	salesMonths?: Array<GraphQLTypes["ProductUpdateSalesMonthsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["ProductUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	hasSubscription?: boolean | undefined,
	pointOfSaleTileColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductUpdateGroupPricesEntityRelationInput"]: {
		create?: GraphQLTypes["ProductGroupPriceWithoutProductCreateInput"] | undefined,
	update?: GraphQLTypes["ProductUpdateGroupPricesRelationInput"] | undefined,
	upsert?: GraphQLTypes["ProductUpsertGroupPricesRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductGroupPriceUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductGroupPriceUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductGroupPriceUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductUpdateGroupPricesRelationInput"]: {
		by?: GraphQLTypes["ProductGroupPriceUniqueWhere"] | undefined,
	data?: GraphQLTypes["ProductGroupPriceWithoutProductUpdateInput"] | undefined
};
	["ProductGroupPriceWithoutProductUpdateInput"]: {
		priceCents?: number | undefined,
	group?: GraphQLTypes["ProductGroupPriceUpdateGroupEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductGroupPriceUpdateGroupEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerGroupWithoutProductPricesCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerGroupWithoutProductPricesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductGroupPriceUpsertGroupRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerGroupUniqueWhere"] | undefined
};
	["CustomerGroupWithoutProductPricesUpdateInput"]: {
		name?: string | undefined,
	customers?: Array<GraphQLTypes["CustomerGroupUpdateCustomersEntityRelationInput"]> | undefined,
	discountPermille?: number | undefined,
	code?: string | undefined,
	doubleshotLegacyId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerGroupUpdateCustomersEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerWithoutGroupCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerGroupUpdateCustomersRelationInput"] | undefined,
	upsert?: GraphQLTypes["CustomerGroupUpsertCustomersRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	delete?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CustomerGroupUpdateCustomersRelationInput"]: {
		by?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	data?: GraphQLTypes["CustomerWithoutGroupUpdateInput"] | undefined
};
	["CustomerWithoutGroupUpdateInput"]: {
		addresses?: Array<GraphQLTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerUpdateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerUpdateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerUpdateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerUpdatePhotoEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CustomerUpsertPhotoRelationInput"] | undefined,
	connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CustomerUpsertPhotoRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["CustomerUpdateNameEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerNameWithoutCustomerCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerNameWithoutCustomerUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CustomerUpsertNameRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerNameUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CustomerNameWithoutCustomerUpdateInput"]: {
		nominative?: string | undefined,
	vocative?: string | undefined,
	aliases?: Array<GraphQLTypes["CustomerNameUpdateAliasesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerNameUpdateAliasesEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerAliasCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerNameUpdateAliasesRelationInput"] | undefined,
	upsert?: GraphQLTypes["CustomerNameUpsertAliasesRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerAliasUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["CustomerAliasUniqueWhere"] | undefined,
	delete?: GraphQLTypes["CustomerAliasUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CustomerNameUpdateAliasesRelationInput"]: {
		by?: GraphQLTypes["CustomerAliasUniqueWhere"] | undefined,
	data?: GraphQLTypes["CustomerAliasUpdateInput"] | undefined
};
	["CustomerAliasUpdateInput"]: {
		name?: string | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerNameUpsertAliasesRelationInput"]: {
		by?: GraphQLTypes["CustomerAliasUniqueWhere"] | undefined,
	update?: GraphQLTypes["CustomerAliasUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerAliasCreateInput"] | undefined
};
	["CustomerUpsertNameRelationInput"]: {
		update?: GraphQLTypes["CustomerNameWithoutCustomerUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerNameWithoutCustomerCreateInput"] | undefined
};
	["CustomerUpdateIngredientRatingsEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerIngredientRatingWithoutCustomerCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerUpdateIngredientRatingsRelationInput"] | undefined,
	upsert?: GraphQLTypes["CustomerUpsertIngredientRatingsRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerIngredientRatingUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["CustomerIngredientRatingUniqueWhere"] | undefined,
	delete?: GraphQLTypes["CustomerIngredientRatingUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CustomerUpdateIngredientRatingsRelationInput"]: {
		by?: GraphQLTypes["CustomerIngredientRatingUniqueWhere"] | undefined,
	data?: GraphQLTypes["CustomerIngredientRatingWithoutCustomerUpdateInput"] | undefined
};
	["CustomerIngredientRatingWithoutCustomerUpdateInput"]: {
		rating?: GraphQLTypes["CustomerIngredientRatingUpdateRatingEntityRelationInput"] | undefined,
	ingredient?: GraphQLTypes["CustomerIngredientRatingUpdateIngredientEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerIngredientRatingUpdateRatingEntityRelationInput"]: {
		create?: GraphQLTypes["ProductIngredientRatingCreateInput"] | undefined,
	update?: GraphQLTypes["ProductIngredientRatingUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CustomerIngredientRatingUpsertRatingRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductIngredientRatingUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["ProductIngredientRatingUpdateInput"]: {
		order?: number | undefined,
	name?: string | undefined,
	icon?: GraphQLTypes["ProductIngredientRatingUpdateIconEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientRatingUpdateIconEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductIngredientRatingUpsertIconRelationInput"] | undefined,
	connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProductIngredientRatingUpsertIconRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["CustomerIngredientRatingUpsertRatingRelationInput"]: {
		update?: GraphQLTypes["ProductIngredientRatingUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductIngredientRatingCreateInput"] | undefined
};
	["CustomerIngredientRatingUpdateIngredientEntityRelationInput"]: {
		create?: GraphQLTypes["ProductIngredientWithoutCustomerRatingsCreateInput"] | undefined,
	update?: GraphQLTypes["ProductIngredientWithoutCustomerRatingsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CustomerIngredientRatingUpsertIngredientRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductIngredientUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["ProductIngredientWithoutCustomerRatingsUpdateInput"]: {
		internalNote?: string | undefined,
	locales?: Array<GraphQLTypes["ProductIngredientUpdateLocalesEntityRelationInput"]> | undefined,
	internalName?: string | undefined,
	categories?: Array<GraphQLTypes["ProductIngredientUpdateCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["ProductIngredientUpdateAllergensEntityRelationInput"]> | undefined,
	needsPrepping?: boolean | undefined,
	allowCustomerRating?: boolean | undefined,
	preferredQuantityUnit?: GraphQLTypes["ProductIngredientUpdatePreferredQuantityUnitEntityRelationInput"] | undefined,
	freshingContainer?: GraphQLTypes["ProductIngredientUpdateFreshingContainerEntityRelationInput"] | undefined,
	image?: GraphQLTypes["ProductIngredientUpdateImageEntityRelationInput"] | undefined,
	suppliers?: GraphQLTypes["ProductIngredientUpdateSuppliersEntityRelationInput"] | undefined,
	incrementQuantityNumber?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientUpdateCategoriesEntityRelationInput"]: {
		create?: GraphQLTypes["ProductIngredientCategoryWithoutIngredientsCreateInput"] | undefined,
	update?: GraphQLTypes["ProductIngredientUpdateCategoriesRelationInput"] | undefined,
	upsert?: GraphQLTypes["ProductIngredientUpsertCategoriesRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductIngredientCategoryUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductIngredientCategoryUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductIngredientCategoryUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductIngredientUpdateCategoriesRelationInput"]: {
		by?: GraphQLTypes["ProductIngredientCategoryUniqueWhere"] | undefined,
	data?: GraphQLTypes["ProductIngredientCategoryWithoutIngredientsUpdateInput"] | undefined
};
	["ProductIngredientCategoryWithoutIngredientsUpdateInput"]: {
		internalName?: string | undefined,
	internalNote?: string | undefined,
	locales?: Array<GraphQLTypes["ProductIngredientCategoryUpdateLocalesEntityRelationInput"]> | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientCategoryUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["ProductIngredientCategoryLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["ProductIngredientCategoryUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["ProductIngredientCategoryUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductIngredientCategoryLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductIngredientCategoryLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductIngredientCategoryLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductIngredientCategoryUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["ProductIngredientCategoryLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["ProductIngredientCategoryLocaleWithoutRootUpdateInput"] | undefined
};
	["ProductIngredientCategoryLocaleWithoutRootUpdateInput"]: {
		name?: string | undefined,
	locale?: GraphQLTypes["ProductIngredientCategoryLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientCategoryLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutProductIngredientCategoriesCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutProductIngredientCategoriesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductIngredientCategoryLocaleUpsertLocaleRelationInput"] | undefined,
	connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutProductIngredientCategoriesUpdateInput"]: {
		businessCategories?: Array<GraphQLTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateProductIngredientsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductIngredientLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateProductIngredientsRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertProductIngredientsRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductIngredientLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductIngredientLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductIngredientLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateProductIngredientsRelationInput"]: {
		by?: GraphQLTypes["ProductIngredientLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["ProductIngredientLocaleWithoutLocaleUpdateInput"] | undefined
};
	["ProductIngredientLocaleWithoutLocaleUpdateInput"]: {
		name?: string | undefined,
	root?: GraphQLTypes["ProductIngredientLocaleUpdateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["ProductIngredientWithoutLocalesCreateInput"] | undefined,
	update?: GraphQLTypes["ProductIngredientWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductIngredientLocaleUpsertRootRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductIngredientUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["ProductIngredientWithoutLocalesUpdateInput"]: {
		internalNote?: string | undefined,
	internalName?: string | undefined,
	categories?: Array<GraphQLTypes["ProductIngredientUpdateCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["ProductIngredientUpdateAllergensEntityRelationInput"]> | undefined,
	needsPrepping?: boolean | undefined,
	allowCustomerRating?: boolean | undefined,
	customerRatings?: Array<GraphQLTypes["ProductIngredientUpdateCustomerRatingsEntityRelationInput"]> | undefined,
	preferredQuantityUnit?: GraphQLTypes["ProductIngredientUpdatePreferredQuantityUnitEntityRelationInput"] | undefined,
	freshingContainer?: GraphQLTypes["ProductIngredientUpdateFreshingContainerEntityRelationInput"] | undefined,
	image?: GraphQLTypes["ProductIngredientUpdateImageEntityRelationInput"] | undefined,
	suppliers?: GraphQLTypes["ProductIngredientUpdateSuppliersEntityRelationInput"] | undefined,
	incrementQuantityNumber?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientUpdateAllergensEntityRelationInput"]: {
		create?: GraphQLTypes["AllergenWithoutIngredientsCreateInput"] | undefined,
	update?: GraphQLTypes["ProductIngredientUpdateAllergensRelationInput"] | undefined,
	upsert?: GraphQLTypes["ProductIngredientUpsertAllergensRelationInput"] | undefined,
	connect?: GraphQLTypes["AllergenUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["AllergenUniqueWhere"] | undefined,
	delete?: GraphQLTypes["AllergenUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductIngredientUpdateAllergensRelationInput"]: {
		by?: GraphQLTypes["AllergenUniqueWhere"] | undefined,
	data?: GraphQLTypes["AllergenWithoutIngredientsUpdateInput"] | undefined
};
	["AllergenWithoutIngredientsUpdateInput"]: {
		internalName?: string | undefined,
	locales?: Array<GraphQLTypes["AllergenUpdateLocalesEntityRelationInput"]> | undefined,
	code?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["AllergenUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["AllergenLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["AllergenUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["AllergenUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["AllergenLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["AllergenLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["AllergenLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["AllergenUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["AllergenLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["AllergenLocaleWithoutRootUpdateInput"] | undefined
};
	["AllergenLocaleWithoutRootUpdateInput"]: {
		name?: string | undefined,
	locale?: GraphQLTypes["AllergenLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["AllergenLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutAllergensCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutAllergensUpdateInput"] | undefined,
	upsert?: GraphQLTypes["AllergenLocaleUpsertLocaleRelationInput"] | undefined,
	connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutAllergensUpdateInput"]: {
		businessCategories?: Array<GraphQLTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateOrderRecurrencesEntityRelationInput"]: {
		create?: GraphQLTypes["OrderRecurrenceLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateOrderRecurrencesRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertOrderRecurrencesRelationInput"] | undefined,
	connect?: GraphQLTypes["OrderRecurrenceLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["OrderRecurrenceLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["OrderRecurrenceLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateOrderRecurrencesRelationInput"]: {
		by?: GraphQLTypes["OrderRecurrenceLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["OrderRecurrenceLocaleWithoutLocaleUpdateInput"] | undefined
};
	["OrderRecurrenceLocaleWithoutLocaleUpdateInput"]: {
		name?: string | undefined,
	root?: GraphQLTypes["OrderRecurrenceLocaleUpdateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderRecurrenceLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["OrderRecurrenceWithoutLocalesCreateInput"] | undefined,
	update?: GraphQLTypes["OrderRecurrenceWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["OrderRecurrenceLocaleUpsertRootRelationInput"] | undefined,
	connect?: GraphQLTypes["OrderRecurrenceUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["OrderRecurrenceWithoutLocalesUpdateInput"]: {
		internalName?: string | undefined,
	order?: number | undefined,
	businessCategory?: Array<GraphQLTypes["OrderRecurrenceUpdateBusinessCategoryEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderRecurrenceUpdateBusinessCategoryEntityRelationInput"]: {
		create?: GraphQLTypes["BusinessCategoryWithoutRecurrencesCreateInput"] | undefined,
	update?: GraphQLTypes["OrderRecurrenceUpdateBusinessCategoryRelationInput"] | undefined,
	upsert?: GraphQLTypes["OrderRecurrenceUpsertBusinessCategoryRelationInput"] | undefined,
	connect?: GraphQLTypes["BusinessCategoryUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["BusinessCategoryUniqueWhere"] | undefined,
	delete?: GraphQLTypes["BusinessCategoryUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["OrderRecurrenceUpdateBusinessCategoryRelationInput"]: {
		by?: GraphQLTypes["BusinessCategoryUniqueWhere"] | undefined,
	data?: GraphQLTypes["BusinessCategoryWithoutRecurrencesUpdateInput"] | undefined
};
	["BusinessCategoryWithoutRecurrencesUpdateInput"]: {
		order?: number | undefined,
	visibleToNewCustomers?: boolean | undefined,
	locales?: Array<GraphQLTypes["BusinessCategoryUpdateLocalesEntityRelationInput"]> | undefined,
	internalName?: string | undefined,
	businessCustomers?: Array<GraphQLTypes["BusinessCategoryUpdateBusinessCustomersEntityRelationInput"]> | undefined,
	specificProducts?: GraphQLTypes["BusinessCategoryUpdateSpecificProductsEntityRelationInput"] | undefined,
	seasonalProductCategories?: GraphQLTypes["BusinessCategoryUpdateSeasonalProductCategoriesEntityRelationInput"] | undefined,
	specificProductsProductCategories?: GraphQLTypes["BusinessCategoryUpdateSpecificProductsProductCategoriesEntityRelationInput"] | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessCategoryUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["BusinessCategoryLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["BusinessCategoryUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["BusinessCategoryUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["BusinessCategoryLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["BusinessCategoryLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["BusinessCategoryLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["BusinessCategoryUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["BusinessCategoryLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["BusinessCategoryLocaleWithoutRootUpdateInput"] | undefined
};
	["BusinessCategoryLocaleWithoutRootUpdateInput"]: {
		name?: string | undefined,
	locale?: GraphQLTypes["BusinessCategoryLocaleUpdateLocaleEntityRelationInput"] | undefined,
	title?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessCategoryLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutBusinessCategoriesCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutBusinessCategoriesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BusinessCategoryLocaleUpsertLocaleRelationInput"] | undefined,
	connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutBusinessCategoriesUpdateInput"]: {
		productCategoryLists?: Array<GraphQLTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateBlogsEntityRelationInput"]: {
		create?: GraphQLTypes["BlogLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateBlogsRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertBlogsRelationInput"] | undefined,
	connect?: GraphQLTypes["BlogLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["BlogLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["BlogLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateBlogsRelationInput"]: {
		by?: GraphQLTypes["BlogLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["BlogLocaleWithoutLocaleUpdateInput"] | undefined
};
	["BlogLocaleWithoutLocaleUpdateInput"]: {
		pageName?: string | undefined,
	title?: string | undefined,
	lead?: string | undefined,
	root?: GraphQLTypes["BlogLocaleUpdateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BlogLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["BlogWithoutLocalesCreateInput"] | undefined,
	update?: GraphQLTypes["BlogWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BlogLocaleUpsertRootRelationInput"] | undefined,
	connect?: GraphQLTypes["BlogUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["BlogWithoutLocalesUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BlogLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["BlogWithoutLocalesUpdateInput"] | undefined,
	create?: GraphQLTypes["BlogWithoutLocalesCreateInput"] | undefined
};
	["LocaleUpsertBlogsRelationInput"]: {
		by?: GraphQLTypes["BlogLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["BlogLocaleWithoutLocaleUpdateInput"] | undefined,
	create?: GraphQLTypes["BlogLocaleWithoutLocaleCreateInput"] | undefined
};
	["LocaleUpdateBlogPostsEntityRelationInput"]: {
		create?: GraphQLTypes["BlogPostLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateBlogPostsRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertBlogPostsRelationInput"] | undefined,
	connect?: GraphQLTypes["BlogPostLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["BlogPostLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["BlogPostLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateBlogPostsRelationInput"]: {
		by?: GraphQLTypes["BlogPostLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["BlogPostLocaleWithoutLocaleUpdateInput"] | undefined
};
	["BlogPostLocaleWithoutLocaleUpdateInput"]: {
		title?: string | undefined,
	availableForWeb?: boolean | undefined,
	availableForMobile?: boolean | undefined,
	root?: GraphQLTypes["BlogPostLocaleUpdateRootEntityRelationInput"] | undefined,
	cover?: GraphQLTypes["BlogPostLocaleUpdateCoverEntityRelationInput"] | undefined,
	content?: GraphQLTypes["BlogPostLocaleUpdateContentEntityRelationInput"] | undefined,
	link?: GraphQLTypes["BlogPostLocaleUpdateLinkEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["BlogPostLocaleUpdateSeoEntityRelationInput"] | undefined,
	products?: Array<GraphQLTypes["BlogPostLocaleUpdateProductsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["BlogPostLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["BlogPostWithoutLocalesCreateInput"] | undefined,
	update?: GraphQLTypes["BlogPostWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BlogPostLocaleUpsertRootRelationInput"] | undefined,
	connect?: GraphQLTypes["BlogPostUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["BlogPostWithoutLocalesUpdateInput"]: {
		order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["BlogPostLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["BlogPostWithoutLocalesUpdateInput"] | undefined,
	create?: GraphQLTypes["BlogPostWithoutLocalesCreateInput"] | undefined
};
	["BlogPostLocaleUpdateCoverEntityRelationInput"]: {
		create?: GraphQLTypes["CoverCreateInput"] | undefined,
	update?: GraphQLTypes["CoverUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BlogPostLocaleUpsertCoverRelationInput"] | undefined,
	connect?: GraphQLTypes["CoverUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CoverUpdateInput"]: {
		primaryTitle?: string | undefined,
	secondaryTitle?: string | undefined,
	medium?: GraphQLTypes["CoverUpdateMediumEntityRelationInput"] | undefined,
	buttonColors?: GraphQLTypes["CoverUpdateButtonColorsEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CoverUpdateMediumEntityRelationInput"]: {
		create?: GraphQLTypes["MediumCreateInput"] | undefined,
	update?: GraphQLTypes["MediumUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CoverUpsertMediumRelationInput"] | undefined,
	connect?: GraphQLTypes["MediumUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["MediumUpdateInput"]: {
		type?: GraphQLTypes["MediumType"] | undefined,
	colorTheme?: GraphQLTypes["ColorTheme"] | undefined,
	image?: GraphQLTypes["MediumUpdateImageEntityRelationInput"] | undefined,
	video?: GraphQLTypes["MediumUpdateVideoEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MediumUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["MediumUpsertImageRelationInput"] | undefined,
	connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["MediumUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["MediumUpdateVideoEntityRelationInput"]: {
		create?: GraphQLTypes["VideoCreateInput"] | undefined,
	update?: GraphQLTypes["VideoUpdateInput"] | undefined,
	upsert?: GraphQLTypes["MediumUpsertVideoRelationInput"] | undefined,
	connect?: GraphQLTypes["VideoUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["VideoUpdateInput"]: {
		src?: string | undefined,
	width?: number | undefined,
	height?: number | undefined,
	size?: number | undefined,
	type?: string | undefined,
	duration?: number | undefined,
	poster?: GraphQLTypes["VideoUpdatePosterEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["VideoUpdatePosterEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["VideoUpsertPosterRelationInput"] | undefined,
	connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["VideoUpsertPosterRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["MediumUpsertVideoRelationInput"]: {
		update?: GraphQLTypes["VideoUpdateInput"] | undefined,
	create?: GraphQLTypes["VideoCreateInput"] | undefined
};
	["CoverUpsertMediumRelationInput"]: {
		update?: GraphQLTypes["MediumUpdateInput"] | undefined,
	create?: GraphQLTypes["MediumCreateInput"] | undefined
};
	["CoverUpdateButtonColorsEntityRelationInput"]: {
		create?: GraphQLTypes["ColorPalleteCreateInput"] | undefined,
	update?: GraphQLTypes["ColorPalleteUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CoverUpsertButtonColorsRelationInput"] | undefined,
	connect?: GraphQLTypes["ColorPalleteUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ColorPalleteUpdateInput"]: {
		background?: string | undefined,
	text?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["CoverUpsertButtonColorsRelationInput"]: {
		update?: GraphQLTypes["ColorPalleteUpdateInput"] | undefined,
	create?: GraphQLTypes["ColorPalleteCreateInput"] | undefined
};
	["BlogPostLocaleUpsertCoverRelationInput"]: {
		update?: GraphQLTypes["CoverUpdateInput"] | undefined,
	create?: GraphQLTypes["CoverCreateInput"] | undefined
};
	["BlogPostLocaleUpdateContentEntityRelationInput"]: {
		create?: GraphQLTypes["ContentCreateInput"] | undefined,
	update?: GraphQLTypes["ContentUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BlogPostLocaleUpsertContentRelationInput"] | undefined,
	connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ContentUpdateInput"]: {
		blocks?: Array<GraphQLTypes["ContentUpdateBlocksEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentUpdateBlocksEntityRelationInput"]: {
		create?: GraphQLTypes["ContentBlockWithoutContentCreateInput"] | undefined,
	update?: GraphQLTypes["ContentUpdateBlocksRelationInput"] | undefined,
	upsert?: GraphQLTypes["ContentUpsertBlocksRelationInput"] | undefined,
	connect?: GraphQLTypes["ContentBlockUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ContentBlockUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ContentBlockUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ContentUpdateBlocksRelationInput"]: {
		by?: GraphQLTypes["ContentBlockUniqueWhere"] | undefined,
	data?: GraphQLTypes["ContentBlockWithoutContentUpdateInput"] | undefined
};
	["ContentBlockWithoutContentUpdateInput"]: {
		order?: number | undefined,
	json?: string | undefined,
	references?: Array<GraphQLTypes["ContentBlockUpdateReferencesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentBlockUpdateReferencesEntityRelationInput"]: {
		create?: GraphQLTypes["ContentReferenceWithoutBlockCreateInput"] | undefined,
	update?: GraphQLTypes["ContentBlockUpdateReferencesRelationInput"] | undefined,
	upsert?: GraphQLTypes["ContentBlockUpsertReferencesRelationInput"] | undefined,
	connect?: GraphQLTypes["ContentReferenceUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ContentReferenceUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ContentReferenceUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ContentBlockUpdateReferencesRelationInput"]: {
		by?: GraphQLTypes["ContentReferenceUniqueWhere"] | undefined,
	data?: GraphQLTypes["ContentReferenceWithoutBlockUpdateInput"] | undefined
};
	["ContentReferenceWithoutBlockUpdateInput"]: {
		type?: GraphQLTypes["ContentReferenceType"] | undefined,
	primaryText?: string | undefined,
	secondaryText?: string | undefined,
	jsonContent?: string | undefined,
	colorPallete?: GraphQLTypes["ContentReferenceUpdateColorPalleteEntityRelationInput"] | undefined,
	medium?: GraphQLTypes["ContentReferenceUpdateMediumEntityRelationInput"] | undefined,
	link?: GraphQLTypes["ContentReferenceUpdateLinkEntityRelationInput"] | undefined,
	blogPosts?: GraphQLTypes["ContentReferenceUpdateBlogPostsEntityRelationInput"] | undefined,
	links?: GraphQLTypes["ContentReferenceUpdateLinksEntityRelationInput"] | undefined,
	products?: GraphQLTypes["ContentReferenceUpdateProductsEntityRelationInput"] | undefined,
	contentSize?: GraphQLTypes["ContentSize"] | undefined,
	misc?: string | undefined,
	hero?: GraphQLTypes["ContentReferenceUpdateHeroEntityRelationInput"] | undefined,
	gallery?: GraphQLTypes["ContentReferenceUpdateGalleryEntityRelationInput"] | undefined,
	socialsAndApps?: GraphQLTypes["ContentReferenceUpdateSocialsAndAppsEntityRelationInput"] | undefined,
	productGrid?: GraphQLTypes["ContentReferenceUpdateProductGridEntityRelationInput"] | undefined,
	productBanners?: GraphQLTypes["ContentReferenceUpdateProductBannersEntityRelationInput"] | undefined,
	deliveryRegions?: GraphQLTypes["ContentReferenceUpdateDeliveryRegionsEntityRelationInput"] | undefined,
	textList?: GraphQLTypes["ContentReferenceUpdateTextListEntityRelationInput"] | undefined,
	gridTiles?: GraphQLTypes["ContentReferenceUpdateGridTilesEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentReferenceUpdateColorPalleteEntityRelationInput"]: {
		create?: GraphQLTypes["ColorPalleteCreateInput"] | undefined,
	update?: GraphQLTypes["ColorPalleteUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertColorPalleteRelationInput"] | undefined,
	connect?: GraphQLTypes["ColorPalleteUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ContentReferenceUpsertColorPalleteRelationInput"]: {
		update?: GraphQLTypes["ColorPalleteUpdateInput"] | undefined,
	create?: GraphQLTypes["ColorPalleteCreateInput"] | undefined
};
	["ContentReferenceUpdateMediumEntityRelationInput"]: {
		create?: GraphQLTypes["MediumCreateInput"] | undefined,
	update?: GraphQLTypes["MediumUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertMediumRelationInput"] | undefined,
	connect?: GraphQLTypes["MediumUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ContentReferenceUpsertMediumRelationInput"]: {
		update?: GraphQLTypes["MediumUpdateInput"] | undefined,
	create?: GraphQLTypes["MediumCreateInput"] | undefined
};
	["ContentReferenceUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"] | undefined,
	update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertLinkRelationInput"] | undefined,
	connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkUpdateInput"]: {
		type?: GraphQLTypes["LinkType"] | undefined,
	title?: string | undefined,
	externalLink?: string | undefined,
	internalLink?: GraphQLTypes["LinkUpdateInternalLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkUpdateInternalLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableCreateInput"] | undefined,
	update?: GraphQLTypes["LinkableUpdateInput"] | undefined,
	upsert?: GraphQLTypes["LinkUpsertInternalLinkRelationInput"] | undefined,
	connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkableUpdateInput"]: {
		url?: string | undefined,
	blogPost?: GraphQLTypes["LinkableUpdateBlogPostEntityRelationInput"] | undefined,
	page?: GraphQLTypes["LinkableUpdatePageEntityRelationInput"] | undefined,
	wikiPage?: GraphQLTypes["LinkableUpdateWikiPageEntityRelationInput"] | undefined,
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableUpdateBlogPostEntityRelationInput"]: {
		create?: GraphQLTypes["BlogPostLocaleWithoutLinkCreateInput"] | undefined,
	update?: GraphQLTypes["BlogPostLocaleWithoutLinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["LinkableUpsertBlogPostRelationInput"] | undefined,
	connect?: GraphQLTypes["BlogPostLocaleUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["BlogPostLocaleWithoutLinkUpdateInput"]: {
		title?: string | undefined,
	availableForWeb?: boolean | undefined,
	availableForMobile?: boolean | undefined,
	root?: GraphQLTypes["BlogPostLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["BlogPostLocaleUpdateLocaleEntityRelationInput"] | undefined,
	cover?: GraphQLTypes["BlogPostLocaleUpdateCoverEntityRelationInput"] | undefined,
	content?: GraphQLTypes["BlogPostLocaleUpdateContentEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["BlogPostLocaleUpdateSeoEntityRelationInput"] | undefined,
	products?: Array<GraphQLTypes["BlogPostLocaleUpdateProductsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["BlogPostLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutBlogPostsCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutBlogPostsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BlogPostLocaleUpsertLocaleRelationInput"] | undefined,
	connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutBlogPostsUpdateInput"]: {
		businessCategories?: Array<GraphQLTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateIdentifierEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationCataloguesIdentifierCreateInput"] | undefined,
	update?: GraphQLTypes["TranslationCataloguesIdentifierUpdateInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertIdentifierRelationInput"] | undefined,
	connect?: GraphQLTypes["TranslationCataloguesIdentifierUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TranslationCataloguesIdentifierUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	catalogue?: Array<GraphQLTypes["TranslationCataloguesIdentifierUpdateCatalogueEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationCataloguesIdentifierUpdateCatalogueEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationCatalogueWithoutIdentifierCreateInput"] | undefined,
	update?: GraphQLTypes["TranslationCataloguesIdentifierUpdateCatalogueRelationInput"] | undefined,
	upsert?: GraphQLTypes["TranslationCataloguesIdentifierUpsertCatalogueRelationInput"] | undefined,
	connect?: GraphQLTypes["TranslationCatalogueUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TranslationCatalogueUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TranslationCatalogueUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TranslationCataloguesIdentifierUpdateCatalogueRelationInput"]: {
		by?: GraphQLTypes["TranslationCatalogueUniqueWhere"] | undefined,
	data?: GraphQLTypes["TranslationCatalogueWithoutIdentifierUpdateInput"] | undefined
};
	["TranslationCatalogueWithoutIdentifierUpdateInput"]: {
		domain?: GraphQLTypes["TranslationCatalogueUpdateDomainEntityRelationInput"] | undefined,
	fallback?: GraphQLTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"] | undefined,
	values?: Array<GraphQLTypes["TranslationCatalogueUpdateValuesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationCatalogueUpdateDomainEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationDomainWithoutCataloguesCreateInput"] | undefined,
	update?: GraphQLTypes["TranslationDomainWithoutCataloguesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TranslationCatalogueUpsertDomainRelationInput"] | undefined,
	connect?: GraphQLTypes["TranslationDomainUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["TranslationDomainWithoutCataloguesUpdateInput"]: {
		identifier?: string | undefined,
	name?: string | undefined,
	keys?: Array<GraphQLTypes["TranslationDomainUpdateKeysEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationDomainUpdateKeysEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationKeyWithoutDomainCreateInput"] | undefined,
	update?: GraphQLTypes["TranslationDomainUpdateKeysRelationInput"] | undefined,
	upsert?: GraphQLTypes["TranslationDomainUpsertKeysRelationInput"] | undefined,
	connect?: GraphQLTypes["TranslationKeyUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TranslationKeyUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TranslationKeyUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TranslationDomainUpdateKeysRelationInput"]: {
		by?: GraphQLTypes["TranslationKeyUniqueWhere"] | undefined,
	data?: GraphQLTypes["TranslationKeyWithoutDomainUpdateInput"] | undefined
};
	["TranslationKeyWithoutDomainUpdateInput"]: {
		identifier?: string | undefined,
	contentType?: GraphQLTypes["TranslationContentType"] | undefined,
	note?: string | undefined,
	values?: Array<GraphQLTypes["TranslationKeyUpdateValuesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationKeyUpdateValuesEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationValueWithoutKeyCreateInput"] | undefined,
	update?: GraphQLTypes["TranslationKeyUpdateValuesRelationInput"] | undefined,
	upsert?: GraphQLTypes["TranslationKeyUpsertValuesRelationInput"] | undefined,
	connect?: GraphQLTypes["TranslationValueUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TranslationValueUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TranslationValueUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TranslationKeyUpdateValuesRelationInput"]: {
		by?: GraphQLTypes["TranslationValueUniqueWhere"] | undefined,
	data?: GraphQLTypes["TranslationValueWithoutKeyUpdateInput"] | undefined
};
	["TranslationValueWithoutKeyUpdateInput"]: {
		value?: string | undefined,
	catalogue?: GraphQLTypes["TranslationValueUpdateCatalogueEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationValueUpdateCatalogueEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationCatalogueWithoutValuesCreateInput"] | undefined,
	update?: GraphQLTypes["TranslationCatalogueWithoutValuesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TranslationValueUpsertCatalogueRelationInput"] | undefined,
	connect?: GraphQLTypes["TranslationCatalogueUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["TranslationCatalogueWithoutValuesUpdateInput"]: {
		domain?: GraphQLTypes["TranslationCatalogueUpdateDomainEntityRelationInput"] | undefined,
	fallback?: GraphQLTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"] | undefined,
	identifier?: GraphQLTypes["TranslationCatalogueUpdateIdentifierEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationCatalogueUpdateFallbackEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationCatalogueCreateInput"] | undefined,
	update?: GraphQLTypes["TranslationCatalogueUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TranslationCatalogueUpsertFallbackRelationInput"] | undefined,
	connect?: GraphQLTypes["TranslationCatalogueUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TranslationCatalogueUpdateInput"]: {
		domain?: GraphQLTypes["TranslationCatalogueUpdateDomainEntityRelationInput"] | undefined,
	fallback?: GraphQLTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"] | undefined,
	values?: Array<GraphQLTypes["TranslationCatalogueUpdateValuesEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["TranslationCatalogueUpdateIdentifierEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationCatalogueUpdateValuesEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationValueWithoutCatalogueCreateInput"] | undefined,
	update?: GraphQLTypes["TranslationCatalogueUpdateValuesRelationInput"] | undefined,
	upsert?: GraphQLTypes["TranslationCatalogueUpsertValuesRelationInput"] | undefined,
	connect?: GraphQLTypes["TranslationValueUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TranslationValueUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TranslationValueUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TranslationCatalogueUpdateValuesRelationInput"]: {
		by?: GraphQLTypes["TranslationValueUniqueWhere"] | undefined,
	data?: GraphQLTypes["TranslationValueWithoutCatalogueUpdateInput"] | undefined
};
	["TranslationValueWithoutCatalogueUpdateInput"]: {
		value?: string | undefined,
	key?: GraphQLTypes["TranslationValueUpdateKeyEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationValueUpdateKeyEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationKeyWithoutValuesCreateInput"] | undefined,
	update?: GraphQLTypes["TranslationKeyWithoutValuesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TranslationValueUpsertKeyRelationInput"] | undefined,
	connect?: GraphQLTypes["TranslationKeyUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["TranslationKeyWithoutValuesUpdateInput"]: {
		identifier?: string | undefined,
	contentType?: GraphQLTypes["TranslationContentType"] | undefined,
	note?: string | undefined,
	domain?: GraphQLTypes["TranslationKeyUpdateDomainEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationKeyUpdateDomainEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationDomainWithoutKeysCreateInput"] | undefined,
	update?: GraphQLTypes["TranslationDomainWithoutKeysUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TranslationKeyUpsertDomainRelationInput"] | undefined,
	connect?: GraphQLTypes["TranslationDomainUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["TranslationDomainWithoutKeysUpdateInput"]: {
		identifier?: string | undefined,
	name?: string | undefined,
	catalogues?: Array<GraphQLTypes["TranslationDomainUpdateCataloguesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationDomainUpdateCataloguesEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationCatalogueWithoutDomainCreateInput"] | undefined,
	update?: GraphQLTypes["TranslationDomainUpdateCataloguesRelationInput"] | undefined,
	upsert?: GraphQLTypes["TranslationDomainUpsertCataloguesRelationInput"] | undefined,
	connect?: GraphQLTypes["TranslationCatalogueUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TranslationCatalogueUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TranslationCatalogueUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TranslationDomainUpdateCataloguesRelationInput"]: {
		by?: GraphQLTypes["TranslationCatalogueUniqueWhere"] | undefined,
	data?: GraphQLTypes["TranslationCatalogueWithoutDomainUpdateInput"] | undefined
};
	["TranslationCatalogueWithoutDomainUpdateInput"]: {
		fallback?: GraphQLTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"] | undefined,
	values?: Array<GraphQLTypes["TranslationCatalogueUpdateValuesEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["TranslationCatalogueUpdateIdentifierEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationCatalogueUpdateIdentifierEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"] | undefined,
	update?: GraphQLTypes["TranslationCataloguesIdentifierWithoutCatalogueUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TranslationCatalogueUpsertIdentifierRelationInput"] | undefined,
	connect?: GraphQLTypes["TranslationCataloguesIdentifierUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["TranslationCataloguesIdentifierWithoutCatalogueUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationCatalogueUpsertIdentifierRelationInput"]: {
		update?: GraphQLTypes["TranslationCataloguesIdentifierWithoutCatalogueUpdateInput"] | undefined,
	create?: GraphQLTypes["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"] | undefined
};
	["TranslationDomainUpsertCataloguesRelationInput"]: {
		by?: GraphQLTypes["TranslationCatalogueUniqueWhere"] | undefined,
	update?: GraphQLTypes["TranslationCatalogueWithoutDomainUpdateInput"] | undefined,
	create?: GraphQLTypes["TranslationCatalogueWithoutDomainCreateInput"] | undefined
};
	["TranslationKeyUpsertDomainRelationInput"]: {
		update?: GraphQLTypes["TranslationDomainWithoutKeysUpdateInput"] | undefined,
	create?: GraphQLTypes["TranslationDomainWithoutKeysCreateInput"] | undefined
};
	["TranslationValueUpsertKeyRelationInput"]: {
		update?: GraphQLTypes["TranslationKeyWithoutValuesUpdateInput"] | undefined,
	create?: GraphQLTypes["TranslationKeyWithoutValuesCreateInput"] | undefined
};
	["TranslationCatalogueUpsertValuesRelationInput"]: {
		by?: GraphQLTypes["TranslationValueUniqueWhere"] | undefined,
	update?: GraphQLTypes["TranslationValueWithoutCatalogueUpdateInput"] | undefined,
	create?: GraphQLTypes["TranslationValueWithoutCatalogueCreateInput"] | undefined
};
	["TranslationCatalogueUpsertFallbackRelationInput"]: {
		update?: GraphQLTypes["TranslationCatalogueUpdateInput"] | undefined,
	create?: GraphQLTypes["TranslationCatalogueCreateInput"] | undefined
};
	["TranslationValueUpsertCatalogueRelationInput"]: {
		update?: GraphQLTypes["TranslationCatalogueWithoutValuesUpdateInput"] | undefined,
	create?: GraphQLTypes["TranslationCatalogueWithoutValuesCreateInput"] | undefined
};
	["TranslationKeyUpsertValuesRelationInput"]: {
		by?: GraphQLTypes["TranslationValueUniqueWhere"] | undefined,
	update?: GraphQLTypes["TranslationValueWithoutKeyUpdateInput"] | undefined,
	create?: GraphQLTypes["TranslationValueWithoutKeyCreateInput"] | undefined
};
	["TranslationDomainUpsertKeysRelationInput"]: {
		by?: GraphQLTypes["TranslationKeyUniqueWhere"] | undefined,
	update?: GraphQLTypes["TranslationKeyWithoutDomainUpdateInput"] | undefined,
	create?: GraphQLTypes["TranslationKeyWithoutDomainCreateInput"] | undefined
};
	["TranslationCatalogueUpsertDomainRelationInput"]: {
		update?: GraphQLTypes["TranslationDomainWithoutCataloguesUpdateInput"] | undefined,
	create?: GraphQLTypes["TranslationDomainWithoutCataloguesCreateInput"] | undefined
};
	["TranslationCataloguesIdentifierUpsertCatalogueRelationInput"]: {
		by?: GraphQLTypes["TranslationCatalogueUniqueWhere"] | undefined,
	update?: GraphQLTypes["TranslationCatalogueWithoutIdentifierUpdateInput"] | undefined,
	create?: GraphQLTypes["TranslationCatalogueWithoutIdentifierCreateInput"] | undefined
};
	["LocaleUpsertIdentifierRelationInput"]: {
		update?: GraphQLTypes["TranslationCataloguesIdentifierUpdateInput"] | undefined,
	create?: GraphQLTypes["TranslationCataloguesIdentifierCreateInput"] | undefined
};
	["LocaleUpdateMenusEntityRelationInput"]: {
		create?: GraphQLTypes["MenuLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateMenusRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertMenusRelationInput"] | undefined,
	connect?: GraphQLTypes["MenuLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["MenuLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["MenuLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateMenusRelationInput"]: {
		by?: GraphQLTypes["MenuLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["MenuLocaleWithoutLocaleUpdateInput"] | undefined
};
	["MenuLocaleWithoutLocaleUpdateInput"]: {
		root?: GraphQLTypes["MenuLocaleUpdateRootEntityRelationInput"] | undefined,
	items?: Array<GraphQLTypes["MenuLocaleUpdateItemsEntityRelationInput"]> | undefined,
	secondaryItems?: GraphQLTypes["MenuLocaleUpdateSecondaryItemsEntityRelationInput"] | undefined,
	eshopLink?: GraphQLTypes["MenuLocaleUpdateEshopLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MenuLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["SiteMenuWithoutLocalesCreateInput"] | undefined,
	update?: GraphQLTypes["SiteMenuWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["MenuLocaleUpsertRootRelationInput"] | undefined,
	connect?: GraphQLTypes["SiteMenuUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["SiteMenuWithoutLocalesUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MenuLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["SiteMenuWithoutLocalesUpdateInput"] | undefined,
	create?: GraphQLTypes["SiteMenuWithoutLocalesCreateInput"] | undefined
};
	["MenuLocaleUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["MenuItemWithoutMenuCreateInput"] | undefined,
	update?: GraphQLTypes["MenuLocaleUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["MenuLocaleUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["MenuItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["MenuItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["MenuItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["MenuLocaleUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["MenuItemUniqueWhere"] | undefined,
	data?: GraphQLTypes["MenuItemWithoutMenuUpdateInput"] | undefined
};
	["MenuItemWithoutMenuUpdateInput"]: {
		order?: number | undefined,
	link?: GraphQLTypes["MenuItemUpdateLinkEntityRelationInput"] | undefined,
	subitems?: Array<GraphQLTypes["MenuItemUpdateSubitemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["MenuItemUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"] | undefined,
	update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["MenuItemUpsertLinkRelationInput"] | undefined,
	connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["MenuItemUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined
};
	["MenuItemUpdateSubitemsEntityRelationInput"]: {
		create?: GraphQLTypes["MenuSubitemWithoutItemCreateInput"] | undefined,
	update?: GraphQLTypes["MenuItemUpdateSubitemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["MenuItemUpsertSubitemsRelationInput"] | undefined,
	connect?: GraphQLTypes["MenuSubitemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["MenuSubitemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["MenuSubitemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["MenuItemUpdateSubitemsRelationInput"]: {
		by?: GraphQLTypes["MenuSubitemUniqueWhere"] | undefined,
	data?: GraphQLTypes["MenuSubitemWithoutItemUpdateInput"] | undefined
};
	["MenuSubitemWithoutItemUpdateInput"]: {
		type?: GraphQLTypes["MenuSubitemType"] | undefined,
	title?: string | undefined,
	links?: GraphQLTypes["MenuSubitemUpdateLinksEntityRelationInput"] | undefined,
	products?: GraphQLTypes["MenuSubitemUpdateProductsEntityRelationInput"] | undefined,
	delivery?: GraphQLTypes["MenuSubitemUpdateDeliveryEntityRelationInput"] | undefined,
	contact?: GraphQLTypes["MenuSubitemUpdateContactEntityRelationInput"] | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["MenuSubitemUpdateLinksEntityRelationInput"]: {
		create?: GraphQLTypes["MenuLinkListCreateInput"] | undefined,
	update?: GraphQLTypes["MenuLinkListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["MenuSubitemUpsertLinksRelationInput"] | undefined,
	connect?: GraphQLTypes["MenuLinkListUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["MenuLinkListUpdateInput"]: {
		items?: Array<GraphQLTypes["MenuLinkListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["MenuLinkListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["MenuLinkItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["MenuLinkListUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["MenuLinkListUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["MenuLinkItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["MenuLinkItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["MenuLinkItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["MenuLinkListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["MenuLinkItemUniqueWhere"] | undefined,
	data?: GraphQLTypes["MenuLinkItemWithoutListUpdateInput"] | undefined
};
	["MenuLinkItemWithoutListUpdateInput"]: {
		order?: number | undefined,
	link?: GraphQLTypes["MenuLinkItemUpdateLinkEntityRelationInput"] | undefined,
	image?: GraphQLTypes["MenuLinkItemUpdateImageEntityRelationInput"] | undefined,
	description?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["MenuLinkItemUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"] | undefined,
	update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["MenuLinkItemUpsertLinkRelationInput"] | undefined,
	connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["MenuLinkItemUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined
};
	["MenuLinkItemUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["MenuLinkItemUpsertImageRelationInput"] | undefined,
	connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["MenuLinkItemUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["MenuLinkListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["MenuLinkItemUniqueWhere"] | undefined,
	update?: GraphQLTypes["MenuLinkItemWithoutListUpdateInput"] | undefined,
	create?: GraphQLTypes["MenuLinkItemWithoutListCreateInput"] | undefined
};
	["MenuSubitemUpsertLinksRelationInput"]: {
		update?: GraphQLTypes["MenuLinkListUpdateInput"] | undefined,
	create?: GraphQLTypes["MenuLinkListCreateInput"] | undefined
};
	["MenuSubitemUpdateProductsEntityRelationInput"]: {
		create?: GraphQLTypes["MenuProductsCreateInput"] | undefined,
	update?: GraphQLTypes["MenuProductsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["MenuSubitemUpsertProductsRelationInput"] | undefined,
	connect?: GraphQLTypes["MenuProductsUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["MenuProductsUpdateInput"]: {
		links?: GraphQLTypes["MenuProductsUpdateLinksEntityRelationInput"] | undefined,
	buttons?: GraphQLTypes["MenuProductsUpdateButtonsEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MenuProductsUpdateLinksEntityRelationInput"]: {
		create?: GraphQLTypes["MenuLinkListCreateInput"] | undefined,
	update?: GraphQLTypes["MenuLinkListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["MenuProductsUpsertLinksRelationInput"] | undefined,
	connect?: GraphQLTypes["MenuLinkListUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["MenuProductsUpsertLinksRelationInput"]: {
		update?: GraphQLTypes["MenuLinkListUpdateInput"] | undefined,
	create?: GraphQLTypes["MenuLinkListCreateInput"] | undefined
};
	["MenuProductsUpdateButtonsEntityRelationInput"]: {
		create?: GraphQLTypes["LinkListCreateInput"] | undefined,
	update?: GraphQLTypes["LinkListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["MenuProductsUpsertButtonsRelationInput"] | undefined,
	connect?: GraphQLTypes["LinkListUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkListUpdateInput"]: {
		items?: Array<GraphQLTypes["LinkListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["LinkListItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["LinkListUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["LinkListUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["LinkListItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["LinkListItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["LinkListItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LinkListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["LinkListItemUniqueWhere"] | undefined,
	data?: GraphQLTypes["LinkListItemWithoutListUpdateInput"] | undefined
};
	["LinkListItemWithoutListUpdateInput"]: {
		order?: number | undefined,
	isPrimary?: boolean | undefined,
	link?: GraphQLTypes["LinkListItemUpdateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkListItemUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"] | undefined,
	update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["LinkListItemUpsertLinkRelationInput"] | undefined,
	connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkListItemUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined
};
	["LinkListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["LinkListItemUniqueWhere"] | undefined,
	update?: GraphQLTypes["LinkListItemWithoutListUpdateInput"] | undefined,
	create?: GraphQLTypes["LinkListItemWithoutListCreateInput"] | undefined
};
	["MenuProductsUpsertButtonsRelationInput"]: {
		update?: GraphQLTypes["LinkListUpdateInput"] | undefined,
	create?: GraphQLTypes["LinkListCreateInput"] | undefined
};
	["MenuSubitemUpsertProductsRelationInput"]: {
		update?: GraphQLTypes["MenuProductsUpdateInput"] | undefined,
	create?: GraphQLTypes["MenuProductsCreateInput"] | undefined
};
	["MenuSubitemUpdateDeliveryEntityRelationInput"]: {
		create?: GraphQLTypes["MenuDeliveryCreateInput"] | undefined,
	update?: GraphQLTypes["MenuDeliveryUpdateInput"] | undefined,
	upsert?: GraphQLTypes["MenuSubitemUpsertDeliveryRelationInput"] | undefined,
	connect?: GraphQLTypes["MenuDeliveryUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["MenuDeliveryUpdateInput"]: {
		deliveryRegions?: GraphQLTypes["MenuDeliveryUpdateDeliveryRegionsEntityRelationInput"] | undefined,
	text?: string | undefined,
	socialsAndApps?: GraphQLTypes["MenuDeliveryUpdateSocialsAndAppsEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MenuDeliveryUpdateDeliveryRegionsEntityRelationInput"]: {
		create?: GraphQLTypes["DeliveryRegionsCreateInput"] | undefined,
	update?: GraphQLTypes["DeliveryRegionsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["MenuDeliveryUpsertDeliveryRegionsRelationInput"] | undefined,
	connect?: GraphQLTypes["DeliveryRegionsUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["DeliveryRegionsUpdateInput"]: {
		items?: Array<GraphQLTypes["DeliveryRegionsUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryRegionsUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["DeliveryRegionsItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["DeliveryRegionsUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["DeliveryRegionsUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["DeliveryRegionsItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["DeliveryRegionsItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["DeliveryRegionsItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["DeliveryRegionsUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["DeliveryRegionsItemUniqueWhere"] | undefined,
	data?: GraphQLTypes["DeliveryRegionsItemWithoutListUpdateInput"] | undefined
};
	["DeliveryRegionsItemWithoutListUpdateInput"]: {
		order?: number | undefined,
	title?: string | undefined,
	offerLabel?: string | undefined,
	image?: GraphQLTypes["DeliveryRegionsItemUpdateImageEntityRelationInput"] | undefined,
	textList?: GraphQLTypes["DeliveryRegionsItemUpdateTextListEntityRelationInput"] | undefined,
	gallery?: GraphQLTypes["DeliveryRegionsItemUpdateGalleryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryRegionsItemUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["DeliveryRegionsItemUpsertImageRelationInput"] | undefined,
	connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["DeliveryRegionsItemUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["DeliveryRegionsItemUpdateTextListEntityRelationInput"]: {
		create?: GraphQLTypes["TextListCreateInput"] | undefined,
	update?: GraphQLTypes["TextListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["DeliveryRegionsItemUpsertTextListRelationInput"] | undefined,
	connect?: GraphQLTypes["TextListUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TextListUpdateInput"]: {
		items?: Array<GraphQLTypes["TextListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TextListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["TextItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["TextListUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["TextListUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["TextItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TextItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TextItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TextListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["TextItemUniqueWhere"] | undefined,
	data?: GraphQLTypes["TextItemWithoutListUpdateInput"] | undefined
};
	["TextItemWithoutListUpdateInput"]: {
		order?: number | undefined,
	text?: string | undefined,
	title?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["TextListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["TextItemUniqueWhere"] | undefined,
	update?: GraphQLTypes["TextItemWithoutListUpdateInput"] | undefined,
	create?: GraphQLTypes["TextItemWithoutListCreateInput"] | undefined
};
	["DeliveryRegionsItemUpsertTextListRelationInput"]: {
		update?: GraphQLTypes["TextListUpdateInput"] | undefined,
	create?: GraphQLTypes["TextListCreateInput"] | undefined
};
	["DeliveryRegionsItemUpdateGalleryEntityRelationInput"]: {
		create?: GraphQLTypes["ImageListCreateInput"] | undefined,
	update?: GraphQLTypes["ImageListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["DeliveryRegionsItemUpsertGalleryRelationInput"] | undefined,
	connect?: GraphQLTypes["ImageListUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ImageListUpdateInput"]: {
		items?: Array<GraphQLTypes["ImageListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["ImageListItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["ImageListUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["ImageListUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["ImageListItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ImageListItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ImageListItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ImageListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["ImageListItemUniqueWhere"] | undefined,
	data?: GraphQLTypes["ImageListItemWithoutListUpdateInput"] | undefined
};
	["ImageListItemWithoutListUpdateInput"]: {
		order?: number | undefined,
	image?: GraphQLTypes["ImageListItemUpdateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageListItemUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ImageListItemUpsertImageRelationInput"] | undefined,
	connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ImageListItemUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["ImageListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["ImageListItemUniqueWhere"] | undefined,
	update?: GraphQLTypes["ImageListItemWithoutListUpdateInput"] | undefined,
	create?: GraphQLTypes["ImageListItemWithoutListCreateInput"] | undefined
};
	["DeliveryRegionsItemUpsertGalleryRelationInput"]: {
		update?: GraphQLTypes["ImageListUpdateInput"] | undefined,
	create?: GraphQLTypes["ImageListCreateInput"] | undefined
};
	["DeliveryRegionsUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["DeliveryRegionsItemUniqueWhere"] | undefined,
	update?: GraphQLTypes["DeliveryRegionsItemWithoutListUpdateInput"] | undefined,
	create?: GraphQLTypes["DeliveryRegionsItemWithoutListCreateInput"] | undefined
};
	["MenuDeliveryUpsertDeliveryRegionsRelationInput"]: {
		update?: GraphQLTypes["DeliveryRegionsUpdateInput"] | undefined,
	create?: GraphQLTypes["DeliveryRegionsCreateInput"] | undefined
};
	["MenuDeliveryUpdateSocialsAndAppsEntityRelationInput"]: {
		create?: GraphQLTypes["SocialsAndAppsCreateInput"] | undefined,
	update?: GraphQLTypes["SocialsAndAppsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["MenuDeliveryUpsertSocialsAndAppsRelationInput"] | undefined,
	connect?: GraphQLTypes["SocialsAndAppsUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["SocialsAndAppsUpdateInput"]: {
		instagram?: boolean | undefined,
	appStore?: boolean | undefined,
	googlePlay?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["MenuDeliveryUpsertSocialsAndAppsRelationInput"]: {
		update?: GraphQLTypes["SocialsAndAppsUpdateInput"] | undefined,
	create?: GraphQLTypes["SocialsAndAppsCreateInput"] | undefined
};
	["MenuSubitemUpsertDeliveryRelationInput"]: {
		update?: GraphQLTypes["MenuDeliveryUpdateInput"] | undefined,
	create?: GraphQLTypes["MenuDeliveryCreateInput"] | undefined
};
	["MenuSubitemUpdateContactEntityRelationInput"]: {
		create?: GraphQLTypes["MenuContactCreateInput"] | undefined,
	update?: GraphQLTypes["MenuContactUpdateInput"] | undefined,
	upsert?: GraphQLTypes["MenuSubitemUpsertContactRelationInput"] | undefined,
	connect?: GraphQLTypes["MenuContactUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["MenuContactUpdateInput"]: {
		text?: string | undefined,
	image?: GraphQLTypes["MenuContactUpdateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MenuContactUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["MenuContactUpsertImageRelationInput"] | undefined,
	connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["MenuContactUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["MenuSubitemUpsertContactRelationInput"]: {
		update?: GraphQLTypes["MenuContactUpdateInput"] | undefined,
	create?: GraphQLTypes["MenuContactCreateInput"] | undefined
};
	["MenuItemUpsertSubitemsRelationInput"]: {
		by?: GraphQLTypes["MenuSubitemUniqueWhere"] | undefined,
	update?: GraphQLTypes["MenuSubitemWithoutItemUpdateInput"] | undefined,
	create?: GraphQLTypes["MenuSubitemWithoutItemCreateInput"] | undefined
};
	["MenuLocaleUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["MenuItemUniqueWhere"] | undefined,
	update?: GraphQLTypes["MenuItemWithoutMenuUpdateInput"] | undefined,
	create?: GraphQLTypes["MenuItemWithoutMenuCreateInput"] | undefined
};
	["MenuLocaleUpdateSecondaryItemsEntityRelationInput"]: {
		create?: GraphQLTypes["LinkListCreateInput"] | undefined,
	update?: GraphQLTypes["LinkListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["MenuLocaleUpsertSecondaryItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["LinkListUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["MenuLocaleUpsertSecondaryItemsRelationInput"]: {
		update?: GraphQLTypes["LinkListUpdateInput"] | undefined,
	create?: GraphQLTypes["LinkListCreateInput"] | undefined
};
	["MenuLocaleUpdateEshopLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"] | undefined,
	update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["MenuLocaleUpsertEshopLinkRelationInput"] | undefined,
	connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["MenuLocaleUpsertEshopLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined
};
	["LocaleUpsertMenusRelationInput"]: {
		by?: GraphQLTypes["MenuLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["MenuLocaleWithoutLocaleUpdateInput"] | undefined,
	create?: GraphQLTypes["MenuLocaleWithoutLocaleCreateInput"] | undefined
};
	["LocaleUpdatePagesEntityRelationInput"]: {
		create?: GraphQLTypes["PageLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdatePagesRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertPagesRelationInput"] | undefined,
	connect?: GraphQLTypes["PageLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PageLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdatePagesRelationInput"]: {
		by?: GraphQLTypes["PageLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["PageLocaleWithoutLocaleUpdateInput"] | undefined
};
	["PageLocaleWithoutLocaleUpdateInput"]: {
		title?: string | undefined,
	link?: GraphQLTypes["PageLocaleUpdateLinkEntityRelationInput"] | undefined,
	root?: GraphQLTypes["PageLocaleUpdateRootEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["PageLocaleUpdateSeoEntityRelationInput"] | undefined,
	content?: GraphQLTypes["PageLocaleUpdateContentEntityRelationInput"] | undefined,
	cover?: GraphQLTypes["PageLocaleUpdateCoverEntityRelationInput"] | undefined,
	theme?: GraphQLTypes["PageTheme"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PageLocaleUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutPageCreateInput"] | undefined,
	update?: GraphQLTypes["LinkableWithoutPageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PageLocaleUpsertLinkRelationInput"] | undefined,
	connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkableWithoutPageUpdateInput"]: {
		url?: string | undefined,
	blogPost?: GraphQLTypes["LinkableUpdateBlogPostEntityRelationInput"] | undefined,
	wikiPage?: GraphQLTypes["LinkableUpdateWikiPageEntityRelationInput"] | undefined,
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableUpdateWikiPageEntityRelationInput"]: {
		create?: GraphQLTypes["WikiPageWithoutLinkCreateInput"] | undefined,
	update?: GraphQLTypes["WikiPageWithoutLinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["LinkableUpsertWikiPageRelationInput"] | undefined,
	connect?: GraphQLTypes["WikiPageUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["WikiPageWithoutLinkUpdateInput"]: {
		order?: number | undefined,
	title?: string | undefined,
	emoji?: string | undefined,
	parent?: GraphQLTypes["WikiPageUpdateParentEntityRelationInput"] | undefined,
	children?: Array<GraphQLTypes["WikiPageUpdateChildrenEntityRelationInput"]> | undefined,
	content?: GraphQLTypes["WikiPageUpdateContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["WikiPageUpdateParentEntityRelationInput"]: {
		create?: GraphQLTypes["WikiPageWithoutChildrenCreateInput"] | undefined,
	update?: GraphQLTypes["WikiPageWithoutChildrenUpdateInput"] | undefined,
	upsert?: GraphQLTypes["WikiPageUpsertParentRelationInput"] | undefined,
	connect?: GraphQLTypes["WikiPageUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["WikiPageWithoutChildrenUpdateInput"]: {
		order?: number | undefined,
	title?: string | undefined,
	emoji?: string | undefined,
	link?: GraphQLTypes["WikiPageUpdateLinkEntityRelationInput"] | undefined,
	parent?: GraphQLTypes["WikiPageUpdateParentEntityRelationInput"] | undefined,
	content?: GraphQLTypes["WikiPageUpdateContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["WikiPageUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutWikiPageCreateInput"] | undefined,
	update?: GraphQLTypes["LinkableWithoutWikiPageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["WikiPageUpsertLinkRelationInput"] | undefined,
	connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkableWithoutWikiPageUpdateInput"]: {
		url?: string | undefined,
	blogPost?: GraphQLTypes["LinkableUpdateBlogPostEntityRelationInput"] | undefined,
	page?: GraphQLTypes["LinkableUpdatePageEntityRelationInput"] | undefined,
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkableUpdatePageEntityRelationInput"]: {
		create?: GraphQLTypes["PageLocaleWithoutLinkCreateInput"] | undefined,
	update?: GraphQLTypes["PageLocaleWithoutLinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["LinkableUpsertPageRelationInput"] | undefined,
	connect?: GraphQLTypes["PageLocaleUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PageLocaleWithoutLinkUpdateInput"]: {
		title?: string | undefined,
	root?: GraphQLTypes["PageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["PageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["PageLocaleUpdateSeoEntityRelationInput"] | undefined,
	content?: GraphQLTypes["PageLocaleUpdateContentEntityRelationInput"] | undefined,
	cover?: GraphQLTypes["PageLocaleUpdateCoverEntityRelationInput"] | undefined,
	theme?: GraphQLTypes["PageTheme"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PageLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["PageWithoutLocalesCreateInput"] | undefined,
	update?: GraphQLTypes["PageWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PageLocaleUpsertRootRelationInput"] | undefined,
	connect?: GraphQLTypes["PageUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["PageWithoutLocalesUpdateInput"]: {
		_dummy_field_?: boolean | undefined
};
	["PageLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["PageWithoutLocalesUpdateInput"] | undefined,
	create?: GraphQLTypes["PageWithoutLocalesCreateInput"] | undefined
};
	["PageLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutPagesCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutPagesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PageLocaleUpsertLocaleRelationInput"] | undefined,
	connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutPagesUpdateInput"]: {
		businessCategories?: Array<GraphQLTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]: {
		create?: GraphQLTypes["ProductIngredientCategoryLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateProductIngredientCategoriesRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertProductIngredientCategoriesRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductIngredientCategoryLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductIngredientCategoryLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductIngredientCategoryLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateProductIngredientCategoriesRelationInput"]: {
		by?: GraphQLTypes["ProductIngredientCategoryLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["ProductIngredientCategoryLocaleWithoutLocaleUpdateInput"] | undefined
};
	["ProductIngredientCategoryLocaleWithoutLocaleUpdateInput"]: {
		name?: string | undefined,
	root?: GraphQLTypes["ProductIngredientCategoryLocaleUpdateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientCategoryLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["ProductIngredientCategoryWithoutLocalesCreateInput"] | undefined,
	update?: GraphQLTypes["ProductIngredientCategoryWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductIngredientCategoryLocaleUpsertRootRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductIngredientCategoryUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["ProductIngredientCategoryWithoutLocalesUpdateInput"]: {
		internalName?: string | undefined,
	internalNote?: string | undefined,
	ingredients?: Array<GraphQLTypes["ProductIngredientCategoryUpdateIngredientsEntityRelationInput"]> | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientCategoryUpdateIngredientsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductIngredientWithoutCategoriesCreateInput"] | undefined,
	update?: GraphQLTypes["ProductIngredientCategoryUpdateIngredientsRelationInput"] | undefined,
	upsert?: GraphQLTypes["ProductIngredientCategoryUpsertIngredientsRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductIngredientUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductIngredientUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductIngredientUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductIngredientCategoryUpdateIngredientsRelationInput"]: {
		by?: GraphQLTypes["ProductIngredientUniqueWhere"] | undefined,
	data?: GraphQLTypes["ProductIngredientWithoutCategoriesUpdateInput"] | undefined
};
	["ProductIngredientWithoutCategoriesUpdateInput"]: {
		internalNote?: string | undefined,
	locales?: Array<GraphQLTypes["ProductIngredientUpdateLocalesEntityRelationInput"]> | undefined,
	internalName?: string | undefined,
	allergens?: Array<GraphQLTypes["ProductIngredientUpdateAllergensEntityRelationInput"]> | undefined,
	needsPrepping?: boolean | undefined,
	allowCustomerRating?: boolean | undefined,
	customerRatings?: Array<GraphQLTypes["ProductIngredientUpdateCustomerRatingsEntityRelationInput"]> | undefined,
	preferredQuantityUnit?: GraphQLTypes["ProductIngredientUpdatePreferredQuantityUnitEntityRelationInput"] | undefined,
	freshingContainer?: GraphQLTypes["ProductIngredientUpdateFreshingContainerEntityRelationInput"] | undefined,
	image?: GraphQLTypes["ProductIngredientUpdateImageEntityRelationInput"] | undefined,
	suppliers?: GraphQLTypes["ProductIngredientUpdateSuppliersEntityRelationInput"] | undefined,
	incrementQuantityNumber?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientUpdateCustomerRatingsEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerIngredientRatingWithoutIngredientCreateInput"] | undefined,
	update?: GraphQLTypes["ProductIngredientUpdateCustomerRatingsRelationInput"] | undefined,
	upsert?: GraphQLTypes["ProductIngredientUpsertCustomerRatingsRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerIngredientRatingUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["CustomerIngredientRatingUniqueWhere"] | undefined,
	delete?: GraphQLTypes["CustomerIngredientRatingUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductIngredientUpdateCustomerRatingsRelationInput"]: {
		by?: GraphQLTypes["CustomerIngredientRatingUniqueWhere"] | undefined,
	data?: GraphQLTypes["CustomerIngredientRatingWithoutIngredientUpdateInput"] | undefined
};
	["CustomerIngredientRatingWithoutIngredientUpdateInput"]: {
		customer?: GraphQLTypes["CustomerIngredientRatingUpdateCustomerEntityRelationInput"] | undefined,
	rating?: GraphQLTypes["CustomerIngredientRatingUpdateRatingEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerIngredientRatingUpdateCustomerEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerWithoutIngredientRatingsCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerWithoutIngredientRatingsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CustomerIngredientRatingUpsertCustomerRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["CustomerWithoutIngredientRatingsUpdateInput"]: {
		addresses?: Array<GraphQLTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerUpdateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerUpdateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	business?: GraphQLTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerUpdateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerUpdateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerUpdateBusinessEntityRelationInput"]: {
		create?: GraphQLTypes["BusinessCustomerWithoutCustomerCreateInput"] | undefined,
	update?: GraphQLTypes["BusinessCustomerWithoutCustomerUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CustomerUpsertBusinessRelationInput"] | undefined,
	connect?: GraphQLTypes["BusinessCustomerUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["BusinessCustomerWithoutCustomerUpdateInput"]: {
		name?: string | undefined,
	owners?: Array<GraphQLTypes["BusinessCustomerUpdateOwnersEntityRelationInput"]> | undefined,
	members?: Array<GraphQLTypes["BusinessCustomerUpdateMembersEntityRelationInput"]> | undefined,
	category?: GraphQLTypes["BusinessCustomerUpdateCategoryEntityRelationInput"] | undefined,
	accountManager?: GraphQLTypes["BusinessCustomerUpdateAccountManagerEntityRelationInput"] | undefined,
	logo?: GraphQLTypes["BusinessCustomerUpdateLogoEntityRelationInput"] | undefined,
	note?: string | undefined,
	businessServiceEvents?: Array<GraphQLTypes["BusinessCustomerUpdateBusinessServiceEventsEntityRelationInput"]> | undefined,
	doubleshotCoffeeEquipment?: GraphQLTypes["BusinessCustomerUpdateDoubleshotCoffeeEquipmentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessCustomerUpdateOwnersEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerWithoutOwnerOfBusinessesCreateInput"] | undefined,
	update?: GraphQLTypes["BusinessCustomerUpdateOwnersRelationInput"] | undefined,
	upsert?: GraphQLTypes["BusinessCustomerUpsertOwnersRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	delete?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["BusinessCustomerUpdateOwnersRelationInput"]: {
		by?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	data?: GraphQLTypes["CustomerWithoutOwnerOfBusinessesUpdateInput"] | undefined
};
	["CustomerWithoutOwnerOfBusinessesUpdateInput"]: {
		addresses?: Array<GraphQLTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerUpdateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerUpdateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerUpdateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerUpdateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerUpdateMemberOfBusinessesEntityRelationInput"]: {
		create?: GraphQLTypes["BusinessCustomerWithoutMembersCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerUpdateMemberOfBusinessesRelationInput"] | undefined,
	upsert?: GraphQLTypes["CustomerUpsertMemberOfBusinessesRelationInput"] | undefined,
	connect?: GraphQLTypes["BusinessCustomerUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["BusinessCustomerUniqueWhere"] | undefined,
	delete?: GraphQLTypes["BusinessCustomerUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CustomerUpdateMemberOfBusinessesRelationInput"]: {
		by?: GraphQLTypes["BusinessCustomerUniqueWhere"] | undefined,
	data?: GraphQLTypes["BusinessCustomerWithoutMembersUpdateInput"] | undefined
};
	["BusinessCustomerWithoutMembersUpdateInput"]: {
		name?: string | undefined,
	customer?: GraphQLTypes["BusinessCustomerUpdateCustomerEntityRelationInput"] | undefined,
	owners?: Array<GraphQLTypes["BusinessCustomerUpdateOwnersEntityRelationInput"]> | undefined,
	category?: GraphQLTypes["BusinessCustomerUpdateCategoryEntityRelationInput"] | undefined,
	accountManager?: GraphQLTypes["BusinessCustomerUpdateAccountManagerEntityRelationInput"] | undefined,
	logo?: GraphQLTypes["BusinessCustomerUpdateLogoEntityRelationInput"] | undefined,
	note?: string | undefined,
	businessServiceEvents?: Array<GraphQLTypes["BusinessCustomerUpdateBusinessServiceEventsEntityRelationInput"]> | undefined,
	doubleshotCoffeeEquipment?: GraphQLTypes["BusinessCustomerUpdateDoubleshotCoffeeEquipmentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessCustomerUpdateCategoryEntityRelationInput"]: {
		create?: GraphQLTypes["BusinessCategoryWithoutBusinessCustomersCreateInput"] | undefined,
	update?: GraphQLTypes["BusinessCategoryWithoutBusinessCustomersUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BusinessCustomerUpsertCategoryRelationInput"] | undefined,
	connect?: GraphQLTypes["BusinessCategoryUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["BusinessCategoryWithoutBusinessCustomersUpdateInput"]: {
		order?: number | undefined,
	visibleToNewCustomers?: boolean | undefined,
	locales?: Array<GraphQLTypes["BusinessCategoryUpdateLocalesEntityRelationInput"]> | undefined,
	internalName?: string | undefined,
	recurrences?: Array<GraphQLTypes["BusinessCategoryUpdateRecurrencesEntityRelationInput"]> | undefined,
	specificProducts?: GraphQLTypes["BusinessCategoryUpdateSpecificProductsEntityRelationInput"] | undefined,
	seasonalProductCategories?: GraphQLTypes["BusinessCategoryUpdateSeasonalProductCategoriesEntityRelationInput"] | undefined,
	specificProductsProductCategories?: GraphQLTypes["BusinessCategoryUpdateSpecificProductsProductCategoriesEntityRelationInput"] | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessCategoryUpdateRecurrencesEntityRelationInput"]: {
		create?: GraphQLTypes["OrderRecurrenceWithoutBusinessCategoryCreateInput"] | undefined,
	update?: GraphQLTypes["BusinessCategoryUpdateRecurrencesRelationInput"] | undefined,
	upsert?: GraphQLTypes["BusinessCategoryUpsertRecurrencesRelationInput"] | undefined,
	connect?: GraphQLTypes["OrderRecurrenceUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["OrderRecurrenceUniqueWhere"] | undefined,
	delete?: GraphQLTypes["OrderRecurrenceUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["BusinessCategoryUpdateRecurrencesRelationInput"]: {
		by?: GraphQLTypes["OrderRecurrenceUniqueWhere"] | undefined,
	data?: GraphQLTypes["OrderRecurrenceWithoutBusinessCategoryUpdateInput"] | undefined
};
	["OrderRecurrenceWithoutBusinessCategoryUpdateInput"]: {
		internalName?: string | undefined,
	locales?: Array<GraphQLTypes["OrderRecurrenceUpdateLocalesEntityRelationInput"]> | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderRecurrenceUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["OrderRecurrenceLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["OrderRecurrenceUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["OrderRecurrenceUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["OrderRecurrenceLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["OrderRecurrenceLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["OrderRecurrenceLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["OrderRecurrenceUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["OrderRecurrenceLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["OrderRecurrenceLocaleWithoutRootUpdateInput"] | undefined
};
	["OrderRecurrenceLocaleWithoutRootUpdateInput"]: {
		name?: string | undefined,
	locale?: GraphQLTypes["OrderRecurrenceLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderRecurrenceLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutOrderRecurrencesCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutOrderRecurrencesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["OrderRecurrenceLocaleUpsertLocaleRelationInput"] | undefined,
	connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutOrderRecurrencesUpdateInput"]: {
		businessCategories?: Array<GraphQLTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateAllergensEntityRelationInput"]: {
		create?: GraphQLTypes["AllergenLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateAllergensRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertAllergensRelationInput"] | undefined,
	connect?: GraphQLTypes["AllergenLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["AllergenLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["AllergenLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateAllergensRelationInput"]: {
		by?: GraphQLTypes["AllergenLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["AllergenLocaleWithoutLocaleUpdateInput"] | undefined
};
	["AllergenLocaleWithoutLocaleUpdateInput"]: {
		name?: string | undefined,
	root?: GraphQLTypes["AllergenLocaleUpdateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["AllergenLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["AllergenWithoutLocalesCreateInput"] | undefined,
	update?: GraphQLTypes["AllergenWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["AllergenLocaleUpsertRootRelationInput"] | undefined,
	connect?: GraphQLTypes["AllergenUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["AllergenWithoutLocalesUpdateInput"]: {
		internalName?: string | undefined,
	ingredients?: Array<GraphQLTypes["AllergenUpdateIngredientsEntityRelationInput"]> | undefined,
	code?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["AllergenUpdateIngredientsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductIngredientWithoutAllergensCreateInput"] | undefined,
	update?: GraphQLTypes["AllergenUpdateIngredientsRelationInput"] | undefined,
	upsert?: GraphQLTypes["AllergenUpsertIngredientsRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductIngredientUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductIngredientUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductIngredientUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["AllergenUpdateIngredientsRelationInput"]: {
		by?: GraphQLTypes["ProductIngredientUniqueWhere"] | undefined,
	data?: GraphQLTypes["ProductIngredientWithoutAllergensUpdateInput"] | undefined
};
	["ProductIngredientWithoutAllergensUpdateInput"]: {
		internalNote?: string | undefined,
	locales?: Array<GraphQLTypes["ProductIngredientUpdateLocalesEntityRelationInput"]> | undefined,
	internalName?: string | undefined,
	categories?: Array<GraphQLTypes["ProductIngredientUpdateCategoriesEntityRelationInput"]> | undefined,
	needsPrepping?: boolean | undefined,
	allowCustomerRating?: boolean | undefined,
	customerRatings?: Array<GraphQLTypes["ProductIngredientUpdateCustomerRatingsEntityRelationInput"]> | undefined,
	preferredQuantityUnit?: GraphQLTypes["ProductIngredientUpdatePreferredQuantityUnitEntityRelationInput"] | undefined,
	freshingContainer?: GraphQLTypes["ProductIngredientUpdateFreshingContainerEntityRelationInput"] | undefined,
	image?: GraphQLTypes["ProductIngredientUpdateImageEntityRelationInput"] | undefined,
	suppliers?: GraphQLTypes["ProductIngredientUpdateSuppliersEntityRelationInput"] | undefined,
	incrementQuantityNumber?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientUpdatePreferredQuantityUnitEntityRelationInput"]: {
		create?: GraphQLTypes["ProductIngredientItemQuantityUnitCreateInput"] | undefined,
	update?: GraphQLTypes["ProductIngredientItemQuantityUnitUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductIngredientUpsertPreferredQuantityUnitRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductIngredientItemQuantityUnitUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProductIngredientItemQuantityUnitUpdateInput"]: {
		name?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientUpsertPreferredQuantityUnitRelationInput"]: {
		update?: GraphQLTypes["ProductIngredientItemQuantityUnitUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductIngredientItemQuantityUnitCreateInput"] | undefined
};
	["ProductIngredientUpdateFreshingContainerEntityRelationInput"]: {
		create?: GraphQLTypes["FreshingContainerCreateInput"] | undefined,
	update?: GraphQLTypes["FreshingContainerUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductIngredientUpsertFreshingContainerRelationInput"] | undefined,
	connect?: GraphQLTypes["FreshingContainerUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["FreshingContainerUpdateInput"]: {
		order?: number | undefined,
	volumeMl?: number | undefined,
	workspace?: GraphQLTypes["FreshingContainerUpdateWorkspaceEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["FreshingContainerUpdateWorkspaceEntityRelationInput"]: {
		create?: GraphQLTypes["WorkspaceWithoutFreshingContainersCreateInput"] | undefined,
	update?: GraphQLTypes["WorkspaceWithoutFreshingContainersUpdateInput"] | undefined,
	upsert?: GraphQLTypes["FreshingContainerUpsertWorkspaceRelationInput"] | undefined,
	connect?: GraphQLTypes["WorkspaceUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["WorkspaceWithoutFreshingContainersUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	orderDeadlineTime?: string | undefined,
	ordersLoadingDurationHours?: number | undefined,
	freshingContainerVolumeMl?: number | undefined,
	freshingPrepareOrderByOffsetMinutes?: number | undefined,
	checkoutUrlTemplate?: string | undefined,
	orderUrlTemplate?: string | undefined,
	paymentUrlTemplate?: string | undefined,
	customerProfileUrlTemplate?: string | undefined,
	userProfileUrlTemplate?: string | undefined,
	messengerUrl?: string | undefined,
	messengerIosUrl?: string | undefined,
	messengerAndroidUrl?: string | undefined,
	openingHours?: GraphQLTypes["WorkspaceUpdateOpeningHoursEntityRelationInput"] | undefined,
	workingHours?: GraphQLTypes["WorkspaceUpdateWorkingHoursEntityRelationInput"] | undefined,
	defaultFreshingContainer?: GraphQLTypes["WorkspaceUpdateDefaultFreshingContainerEntityRelationInput"] | undefined,
	creditsProduct?: GraphQLTypes["WorkspaceUpdateCreditsProductEntityRelationInput"] | undefined,
	discountVatRate?: GraphQLTypes["WorkspaceUpdateDiscountVatRateEntityRelationInput"] | undefined,
	name?: string | undefined,
	businessAddress?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["WorkspaceUpdateOpeningHoursEntityRelationInput"]: {
		create?: GraphQLTypes["WeekHoursCreateInput"] | undefined,
	update?: GraphQLTypes["WeekHoursUpdateInput"] | undefined,
	upsert?: GraphQLTypes["WorkspaceUpsertOpeningHoursRelationInput"] | undefined,
	connect?: GraphQLTypes["WeekHoursUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["WeekHoursUpdateInput"]: {
		mon?: string | undefined,
	tue?: string | undefined,
	wed?: string | undefined,
	thu?: string | undefined,
	fri?: string | undefined,
	sat?: string | undefined,
	sun?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["WorkspaceUpsertOpeningHoursRelationInput"]: {
		update?: GraphQLTypes["WeekHoursUpdateInput"] | undefined,
	create?: GraphQLTypes["WeekHoursCreateInput"] | undefined
};
	["WorkspaceUpdateWorkingHoursEntityRelationInput"]: {
		create?: GraphQLTypes["WeekHoursCreateInput"] | undefined,
	update?: GraphQLTypes["WeekHoursUpdateInput"] | undefined,
	upsert?: GraphQLTypes["WorkspaceUpsertWorkingHoursRelationInput"] | undefined,
	connect?: GraphQLTypes["WeekHoursUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["WorkspaceUpsertWorkingHoursRelationInput"]: {
		update?: GraphQLTypes["WeekHoursUpdateInput"] | undefined,
	create?: GraphQLTypes["WeekHoursCreateInput"] | undefined
};
	["WorkspaceUpdateDefaultFreshingContainerEntityRelationInput"]: {
		create?: GraphQLTypes["FreshingContainerCreateInput"] | undefined,
	update?: GraphQLTypes["FreshingContainerUpdateInput"] | undefined,
	upsert?: GraphQLTypes["WorkspaceUpsertDefaultFreshingContainerRelationInput"] | undefined,
	connect?: GraphQLTypes["FreshingContainerUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["WorkspaceUpsertDefaultFreshingContainerRelationInput"]: {
		update?: GraphQLTypes["FreshingContainerUpdateInput"] | undefined,
	create?: GraphQLTypes["FreshingContainerCreateInput"] | undefined
};
	["WorkspaceUpdateCreditsProductEntityRelationInput"]: {
		create?: GraphQLTypes["VirtualProductCreateInput"] | undefined,
	update?: GraphQLTypes["VirtualProductUpdateInput"] | undefined,
	upsert?: GraphQLTypes["WorkspaceUpsertCreditsProductRelationInput"] | undefined,
	connect?: GraphQLTypes["VirtualProductUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["VirtualProductUpdateInput"]: {
		type?: GraphQLTypes["VirtualProductType"] | undefined,
	product?: GraphQLTypes["VirtualProductUpdateProductEntityRelationInput"] | undefined,
	voucherCreditCents?: number | undefined,
	physicalRepresentation?: GraphQLTypes["VirtualProductPhysicalRepresentationType"] | undefined,
	recipientEmail?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["VirtualProductUpdateProductEntityRelationInput"]: {
		create?: GraphQLTypes["ProductWithoutVirtualProductCreateInput"] | undefined,
	update?: GraphQLTypes["ProductWithoutVirtualProductUpdateInput"] | undefined,
	upsert?: GraphQLTypes["VirtualProductUpsertProductRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProductWithoutVirtualProductUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	priceCents?: number | undefined,
	notDiscountable?: boolean | undefined,
	packing?: GraphQLTypes["ProductUpdatePackingEntityRelationInput"] | undefined,
	recipe?: GraphQLTypes["ProductUpdateRecipeEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["ProductUpdateTagsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["ProductUpdateCategoriesEntityRelationInput"]> | undefined,
	vatRate?: GraphQLTypes["ProductUpdateVatRateEntityRelationInput"] | undefined,
	stocks?: Array<GraphQLTypes["ProductUpdateStocksEntityRelationInput"]> | undefined,
	groupPrices?: Array<GraphQLTypes["ProductUpdateGroupPricesEntityRelationInput"]> | undefined,
	image?: GraphQLTypes["ProductUpdateImageEntityRelationInput"] | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	cartItems?: Array<GraphQLTypes["ProductUpdateCartItemsEntityRelationInput"]> | undefined,
	availability?: GraphQLTypes["ProductAvailability"] | undefined,
	order?: number | undefined,
	manager?: GraphQLTypes["ProductUpdateManagerEntityRelationInput"] | undefined,
	orderItems?: Array<GraphQLTypes["ProductUpdateOrderItemsEntityRelationInput"]> | undefined,
	maximumQuantityPerOrder?: number | undefined,
	inheritedCategories?: Array<GraphQLTypes["ProductUpdateInheritedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["ProductUpdateDeliveryZonesEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["ProductUpdateLocalesEntityRelationInput"]> | undefined,
	archivedAt?: GraphQLTypes["DateTime"] | undefined,
	customerPrices?: Array<GraphQLTypes["ProductUpdateCustomerPricesEntityRelationInput"]> | undefined,
	meta?: GraphQLTypes["ProductUpdateMetaEntityRelationInput"] | undefined,
	page?: GraphQLTypes["ProductUpdatePageEntityRelationInput"] | undefined,
	salesDays?: Array<GraphQLTypes["ProductUpdateSalesDaysEntityRelationInput"]> | undefined,
	salesWeeks?: Array<GraphQLTypes["ProductUpdateSalesWeeksEntityRelationInput"]> | undefined,
	salesMonths?: Array<GraphQLTypes["ProductUpdateSalesMonthsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["ProductUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	hasSubscription?: boolean | undefined,
	pointOfSaleTileColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductUpdateManagerEntityRelationInput"]: {
		create?: GraphQLTypes["StocksManagerWithoutManagedProductsCreateInput"] | undefined,
	update?: GraphQLTypes["StocksManagerWithoutManagedProductsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductUpsertManagerRelationInput"] | undefined,
	connect?: GraphQLTypes["StocksManagerUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["StocksManagerWithoutManagedProductsUpdateInput"]: {
		staff?: GraphQLTypes["StocksManagerUpdateStaffEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StocksManagerUpdateStaffEntityRelationInput"]: {
		create?: GraphQLTypes["StaffWithoutStocksManagerCreateInput"] | undefined,
	update?: GraphQLTypes["StaffWithoutStocksManagerUpdateInput"] | undefined,
	upsert?: GraphQLTypes["StocksManagerUpsertStaffRelationInput"] | undefined,
	connect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["StaffWithoutStocksManagerUpdateInput"]: {
		bartender?: GraphQLTypes["StaffUpdateBartenderEntityRelationInput"] | undefined,
	courier?: GraphQLTypes["StaffUpdateCourierEntityRelationInput"] | undefined,
	cleaner?: GraphQLTypes["StaffUpdateCleanerEntityRelationInput"] | undefined,
	shiftsManager?: GraphQLTypes["StaffUpdateShiftsManagerEntityRelationInput"] | undefined,
	businessToBusinessManager?: GraphQLTypes["StaffUpdateBusinessToBusinessManagerEntityRelationInput"] | undefined,
	user?: GraphQLTypes["StaffUpdateUserEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["StaffUpdateShiftsProfileEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["StaffUpdatePhotoEntityRelationInput"] | undefined,
	courierManager?: GraphQLTypes["StaffUpdateCourierManagerEntityRelationInput"] | undefined,
	picker?: GraphQLTypes["StaffUpdatePickerEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	remunerationProfile?: GraphQLTypes["StaffUpdateRemunerationProfileEntityRelationInput"] | undefined,
	cashier?: GraphQLTypes["StaffUpdateCashierEntityRelationInput"] | undefined,
	venues?: Array<GraphQLTypes["StaffUpdateVenuesEntityRelationInput"]> | undefined,
	internalBuyer?: GraphQLTypes["StaffUpdateInternalBuyerEntityRelationInput"] | undefined,
	salesManager?: GraphQLTypes["StaffUpdateSalesManagerEntityRelationInput"] | undefined,
	cashierManager?: GraphQLTypes["StaffUpdateCashierManagerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StaffUpdateBartenderEntityRelationInput"]: {
		create?: GraphQLTypes["BartenderWithoutStaffCreateInput"] | undefined,
	update?: GraphQLTypes["BartenderWithoutStaffUpdateInput"] | undefined,
	upsert?: GraphQLTypes["StaffUpsertBartenderRelationInput"] | undefined,
	connect?: GraphQLTypes["BartenderUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["BartenderWithoutStaffUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StaffUpsertBartenderRelationInput"]: {
		update?: GraphQLTypes["BartenderWithoutStaffUpdateInput"] | undefined,
	create?: GraphQLTypes["BartenderWithoutStaffCreateInput"] | undefined
};
	["StaffUpdateCourierEntityRelationInput"]: {
		create?: GraphQLTypes["CourierWithoutStaffCreateInput"] | undefined,
	update?: GraphQLTypes["CourierWithoutStaffUpdateInput"] | undefined,
	upsert?: GraphQLTypes["StaffUpsertCourierRelationInput"] | undefined,
	connect?: GraphQLTypes["CourierUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CourierWithoutStaffUpdateInput"]: {
		routes?: Array<GraphQLTypes["CourierUpdateRoutesEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	deliveryMethods?: Array<GraphQLTypes["CourierUpdateDeliveryMethodsEntityRelationInput"]> | undefined,
	showInPicker?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["CourierUpdateRoutesEntityRelationInput"]: {
		create?: GraphQLTypes["DeliveryRouteWithoutCourierCreateInput"] | undefined,
	update?: GraphQLTypes["CourierUpdateRoutesRelationInput"] | undefined,
	upsert?: GraphQLTypes["CourierUpsertRoutesRelationInput"] | undefined,
	connect?: GraphQLTypes["DeliveryRouteUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["DeliveryRouteUniqueWhere"] | undefined,
	delete?: GraphQLTypes["DeliveryRouteUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CourierUpdateRoutesRelationInput"]: {
		by?: GraphQLTypes["DeliveryRouteUniqueWhere"] | undefined,
	data?: GraphQLTypes["DeliveryRouteWithoutCourierUpdateInput"] | undefined
};
	["DeliveryRouteWithoutCourierUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	waypoints?: Array<GraphQLTypes["DeliveryRouteUpdateWaypointsEntityRelationInput"]> | undefined,
	dispatchAt?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryRouteUpdateWaypointsEntityRelationInput"]: {
		create?: GraphQLTypes["DeliveryWaypointWithoutRouteCreateInput"] | undefined,
	update?: GraphQLTypes["DeliveryRouteUpdateWaypointsRelationInput"] | undefined,
	upsert?: GraphQLTypes["DeliveryRouteUpsertWaypointsRelationInput"] | undefined,
	connect?: GraphQLTypes["DeliveryWaypointUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["DeliveryWaypointUniqueWhere"] | undefined,
	delete?: GraphQLTypes["DeliveryWaypointUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["DeliveryRouteUpdateWaypointsRelationInput"]: {
		by?: GraphQLTypes["DeliveryWaypointUniqueWhere"] | undefined,
	data?: GraphQLTypes["DeliveryWaypointWithoutRouteUpdateInput"] | undefined
};
	["DeliveryWaypointWithoutRouteUpdateInput"]: {
		estimatedArrival?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	sortingOrder?: number | undefined,
	delivery?: GraphQLTypes["DeliveryWaypointUpdateDeliveryEntityRelationInput"] | undefined,
	estimatedDistance?: number | undefined,
	estimatedDuration?: number | undefined,
	originDeparture?: GraphQLTypes["DateTime"] | undefined,
	originAddress?: string | undefined,
	transitMode?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryWaypointUpdateDeliveryEntityRelationInput"]: {
		create?: GraphQLTypes["OrderDeliveryWithoutDeliveryWaypointCreateInput"] | undefined,
	update?: GraphQLTypes["OrderDeliveryWithoutDeliveryWaypointUpdateInput"] | undefined,
	upsert?: GraphQLTypes["DeliveryWaypointUpsertDeliveryRelationInput"] | undefined,
	connect?: GraphQLTypes["OrderDeliveryUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["OrderDeliveryWithoutDeliveryWaypointUpdateInput"]: {
		priceCents?: number | undefined,
	deliveredAt?: GraphQLTypes["DateTime"] | undefined,
	method?: GraphQLTypes["OrderDeliveryUpdateMethodEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["OrderDeliveryUpdateVatRateEntityRelationInput"] | undefined,
	order?: GraphQLTypes["OrderDeliveryUpdateOrderEntityRelationInput"] | undefined,
	expectedAt?: GraphQLTypes["DateTime"] | undefined,
	state?: GraphQLTypes["OrderDeliveryState"] | undefined,
	loadingDurationHours?: number | undefined,
	dispatchAt?: GraphQLTypes["DateTime"] | undefined,
	duration?: string | undefined,
	window?: string | undefined,
	expectedEndAt?: GraphQLTypes["DateTime"] | undefined,
	processingAt?: GraphQLTypes["DateTime"] | undefined,
	deliveringAt?: GraphQLTypes["DateTime"] | undefined,
	failedAt?: GraphQLTypes["DateTime"] | undefined,
	internalNote?: string | undefined,
	events?: Array<GraphQLTypes["OrderDeliveryUpdateEventsEntityRelationInput"]> | undefined,
	prepareAt?: GraphQLTypes["DateTime"] | undefined,
	liftagoRide?: GraphQLTypes["OrderDeliveryUpdateLiftagoRideEntityRelationInput"] | undefined,
	pickedAt?: GraphQLTypes["DateTime"] | undefined,
	address?: GraphQLTypes["OrderDeliveryUpdateAddressEntityRelationInput"] | undefined,
	trackingCode?: string | undefined,
	woltDriveDelivery?: GraphQLTypes["OrderDeliveryUpdateWoltDriveDeliveryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderDeliveryUpdateMethodEntityRelationInput"]: {
		create?: GraphQLTypes["DeliveryMethodCreateInput"] | undefined,
	update?: GraphQLTypes["DeliveryMethodUpdateInput"] | undefined,
	upsert?: GraphQLTypes["OrderDeliveryUpsertMethodRelationInput"] | undefined,
	connect?: GraphQLTypes["DeliveryMethodUniqueWhere"] | undefined
};
	["DeliveryMethodUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	enabled?: boolean | undefined,
	paymentMethods?: Array<GraphQLTypes["DeliveryMethodUpdatePaymentMethodsEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	requireDeliveryAddress?: boolean | undefined,
	suitableForDeliveryZones?: Array<GraphQLTypes["DeliveryMethodUpdateSuitableForDeliveryZonesEntityRelationInput"]> | undefined,
	channels?: Array<GraphQLTypes["DeliveryMethodUpdateChannelsEntityRelationInput"]> | undefined,
	courierHandlers?: Array<GraphQLTypes["DeliveryMethodUpdateCourierHandlersEntityRelationInput"]> | undefined,
	enableDeliveryTracking?: boolean | undefined,
	locales?: Array<GraphQLTypes["DeliveryMethodUpdateLocalesEntityRelationInput"]> | undefined,
	timelinePreset?: GraphQLTypes["DeliveryMethodUpdateTimelinePresetEntityRelationInput"] | undefined,
	woltDriveVenueId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryMethodUpdateCourierHandlersEntityRelationInput"]: {
		create?: GraphQLTypes["CourierWithoutDeliveryMethodsCreateInput"] | undefined,
	update?: GraphQLTypes["DeliveryMethodUpdateCourierHandlersRelationInput"] | undefined,
	upsert?: GraphQLTypes["DeliveryMethodUpsertCourierHandlersRelationInput"] | undefined,
	connect?: GraphQLTypes["CourierUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["CourierUniqueWhere"] | undefined,
	delete?: GraphQLTypes["CourierUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["DeliveryMethodUpdateCourierHandlersRelationInput"]: {
		by?: GraphQLTypes["CourierUniqueWhere"] | undefined,
	data?: GraphQLTypes["CourierWithoutDeliveryMethodsUpdateInput"] | undefined
};
	["CourierWithoutDeliveryMethodsUpdateInput"]: {
		staff?: GraphQLTypes["CourierUpdateStaffEntityRelationInput"] | undefined,
	routes?: Array<GraphQLTypes["CourierUpdateRoutesEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	showInPicker?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["CourierUpdateStaffEntityRelationInput"]: {
		create?: GraphQLTypes["StaffWithoutCourierCreateInput"] | undefined,
	update?: GraphQLTypes["StaffWithoutCourierUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CourierUpsertStaffRelationInput"] | undefined,
	connect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["StaffWithoutCourierUpdateInput"]: {
		bartender?: GraphQLTypes["StaffUpdateBartenderEntityRelationInput"] | undefined,
	cleaner?: GraphQLTypes["StaffUpdateCleanerEntityRelationInput"] | undefined,
	shiftsManager?: GraphQLTypes["StaffUpdateShiftsManagerEntityRelationInput"] | undefined,
	businessToBusinessManager?: GraphQLTypes["StaffUpdateBusinessToBusinessManagerEntityRelationInput"] | undefined,
	user?: GraphQLTypes["StaffUpdateUserEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["StaffUpdateShiftsProfileEntityRelationInput"] | undefined,
	stocksManager?: GraphQLTypes["StaffUpdateStocksManagerEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["StaffUpdatePhotoEntityRelationInput"] | undefined,
	courierManager?: GraphQLTypes["StaffUpdateCourierManagerEntityRelationInput"] | undefined,
	picker?: GraphQLTypes["StaffUpdatePickerEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	remunerationProfile?: GraphQLTypes["StaffUpdateRemunerationProfileEntityRelationInput"] | undefined,
	cashier?: GraphQLTypes["StaffUpdateCashierEntityRelationInput"] | undefined,
	venues?: Array<GraphQLTypes["StaffUpdateVenuesEntityRelationInput"]> | undefined,
	internalBuyer?: GraphQLTypes["StaffUpdateInternalBuyerEntityRelationInput"] | undefined,
	salesManager?: GraphQLTypes["StaffUpdateSalesManagerEntityRelationInput"] | undefined,
	cashierManager?: GraphQLTypes["StaffUpdateCashierManagerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StaffUpdateCleanerEntityRelationInput"]: {
		create?: GraphQLTypes["CleanerWithoutStaffCreateInput"] | undefined,
	update?: GraphQLTypes["CleanerWithoutStaffUpdateInput"] | undefined,
	upsert?: GraphQLTypes["StaffUpsertCleanerRelationInput"] | undefined,
	connect?: GraphQLTypes["CleanerUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CleanerWithoutStaffUpdateInput"]: {
		canReachTopShelf?: boolean | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StaffUpsertCleanerRelationInput"]: {
		update?: GraphQLTypes["CleanerWithoutStaffUpdateInput"] | undefined,
	create?: GraphQLTypes["CleanerWithoutStaffCreateInput"] | undefined
};
	["StaffUpdateShiftsManagerEntityRelationInput"]: {
		create?: GraphQLTypes["ShiftsManagerWithoutStaffCreateInput"] | undefined,
	update?: GraphQLTypes["ShiftsManagerWithoutStaffUpdateInput"] | undefined,
	upsert?: GraphQLTypes["StaffUpsertShiftsManagerRelationInput"] | undefined,
	connect?: GraphQLTypes["ShiftsManagerUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ShiftsManagerWithoutStaffUpdateInput"]: {
		managedRoles?: Array<GraphQLTypes["ShiftsManagerUpdateManagedRolesEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ShiftsManagerUpdateManagedRolesEntityRelationInput"]: {
		create?: GraphQLTypes["TimetableEmployeeRoleWithoutShiftsManagersCreateInput"] | undefined,
	update?: GraphQLTypes["ShiftsManagerUpdateManagedRolesRelationInput"] | undefined,
	upsert?: GraphQLTypes["ShiftsManagerUpsertManagedRolesRelationInput"] | undefined,
	connect?: GraphQLTypes["TimetableEmployeeRoleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TimetableEmployeeRoleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TimetableEmployeeRoleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ShiftsManagerUpdateManagedRolesRelationInput"]: {
		by?: GraphQLTypes["TimetableEmployeeRoleUniqueWhere"] | undefined,
	data?: GraphQLTypes["TimetableEmployeeRoleWithoutShiftsManagersUpdateInput"] | undefined
};
	["TimetableEmployeeRoleWithoutShiftsManagersUpdateInput"]: {
		shiftGroups?: Array<GraphQLTypes["TimetableEmployeeRoleUpdateShiftGroupsEntityRelationInput"]> | undefined,
	shiftsProfiles?: Array<GraphQLTypes["TimetableEmployeeRoleUpdateShiftsProfilesEntityRelationInput"]> | undefined,
	name?: string | undefined,
	timetableTemplates?: Array<GraphQLTypes["TimetableEmployeeRoleUpdateTimetableTemplatesEntityRelationInput"]> | undefined,
	color?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableEmployeeRoleUpdateShiftGroupsEntityRelationInput"]: {
		create?: GraphQLTypes["TimetableShiftGroupWithoutTypeCreateInput"] | undefined,
	update?: GraphQLTypes["TimetableEmployeeRoleUpdateShiftGroupsRelationInput"] | undefined,
	upsert?: GraphQLTypes["TimetableEmployeeRoleUpsertShiftGroupsRelationInput"] | undefined,
	connect?: GraphQLTypes["TimetableShiftGroupUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TimetableShiftGroupUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TimetableShiftGroupUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TimetableEmployeeRoleUpdateShiftGroupsRelationInput"]: {
		by?: GraphQLTypes["TimetableShiftGroupUniqueWhere"] | undefined,
	data?: GraphQLTypes["TimetableShiftGroupWithoutTypeUpdateInput"] | undefined
};
	["TimetableShiftGroupWithoutTypeUpdateInput"]: {
		order?: number | undefined,
	shifts?: Array<GraphQLTypes["TimetableShiftGroupUpdateShiftsEntityRelationInput"]> | undefined,
	day?: GraphQLTypes["TimetableShiftGroupUpdateDayEntityRelationInput"] | undefined,
	position?: GraphQLTypes["TimetableShiftGroupUpdatePositionEntityRelationInput"] | undefined,
	queue?: GraphQLTypes["TimetableShiftGroupUpdateQueueEntityRelationInput"] | undefined,
	generatedByTemplate?: GraphQLTypes["TimetableShiftGroupUpdateGeneratedByTemplateEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableShiftGroupUpdateShiftsEntityRelationInput"]: {
		create?: GraphQLTypes["TimetableShiftWithoutGroupCreateInput"] | undefined,
	update?: GraphQLTypes["TimetableShiftGroupUpdateShiftsRelationInput"] | undefined,
	upsert?: GraphQLTypes["TimetableShiftGroupUpsertShiftsRelationInput"] | undefined,
	connect?: GraphQLTypes["TimetableShiftUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TimetableShiftUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TimetableShiftUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TimetableShiftGroupUpdateShiftsRelationInput"]: {
		by?: GraphQLTypes["TimetableShiftUniqueWhere"] | undefined,
	data?: GraphQLTypes["TimetableShiftWithoutGroupUpdateInput"] | undefined
};
	["TimetableShiftWithoutGroupUpdateInput"]: {
		locked?: boolean | undefined,
	order?: number | undefined,
	assigned?: GraphQLTypes["Date"] | undefined,
	shiftsProfile?: GraphQLTypes["TimetableShiftUpdateShiftsProfileEntityRelationInput"] | undefined,
	queueItem?: GraphQLTypes["TimetableShiftUpdateQueueItemEntityRelationInput"] | undefined,
	swapInfo?: GraphQLTypes["TimetableShiftUpdateSwapInfoEntityRelationInput"] | undefined,
	isOvertime?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableShiftUpdateShiftsProfileEntityRelationInput"]: {
		create?: GraphQLTypes["ShiftsProfileWithoutShiftsCreateInput"] | undefined,
	update?: GraphQLTypes["ShiftsProfileWithoutShiftsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TimetableShiftUpsertShiftsProfileRelationInput"] | undefined,
	connect?: GraphQLTypes["ShiftsProfileUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ShiftsProfileWithoutShiftsUpdateInput"]: {
		queueItems?: Array<GraphQLTypes["ShiftsProfileUpdateQueueItemsEntityRelationInput"]> | undefined,
	staff?: GraphQLTypes["ShiftsProfileUpdateStaffEntityRelationInput"] | undefined,
	roles?: Array<GraphQLTypes["ShiftsProfileUpdateRolesEntityRelationInput"]> | undefined,
	allowSelfUnassigning?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ShiftsProfileUpdateQueueItemsEntityRelationInput"]: {
		create?: GraphQLTypes["EmployeeQueueItemWithoutShiftsProfileCreateInput"] | undefined,
	update?: GraphQLTypes["ShiftsProfileUpdateQueueItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["ShiftsProfileUpsertQueueItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["EmployeeQueueItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["EmployeeQueueItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["EmployeeQueueItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ShiftsProfileUpdateQueueItemsRelationInput"]: {
		by?: GraphQLTypes["EmployeeQueueItemUniqueWhere"] | undefined,
	data?: GraphQLTypes["EmployeeQueueItemWithoutShiftsProfileUpdateInput"] | undefined
};
	["EmployeeQueueItemWithoutShiftsProfileUpdateInput"]: {
		start?: string | undefined,
	end?: string | undefined,
	queue?: GraphQLTypes["EmployeeQueueItemUpdateQueueEntityRelationInput"] | undefined,
	shift?: GraphQLTypes["EmployeeQueueItemUpdateShiftEntityRelationInput"] | undefined,
	unassignInfo?: GraphQLTypes["EmployeeQueueItemUpdateUnassignInfoEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["EmployeeQueueItemUpdateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["EmployeeQueueItemUpdateQueueEntityRelationInput"]: {
		create?: GraphQLTypes["EmployeeQueueWithoutItemsCreateInput"] | undefined,
	update?: GraphQLTypes["EmployeeQueueWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["EmployeeQueueItemUpsertQueueRelationInput"] | undefined,
	connect?: GraphQLTypes["EmployeeQueueUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["EmployeeQueueWithoutItemsUpdateInput"]: {
		shiftGroup?: GraphQLTypes["EmployeeQueueUpdateShiftGroupEntityRelationInput"] | undefined,
	contemberBugFix?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["EmployeeQueueUpdateShiftGroupEntityRelationInput"]: {
		create?: GraphQLTypes["TimetableShiftGroupWithoutQueueCreateInput"] | undefined,
	update?: GraphQLTypes["TimetableShiftGroupWithoutQueueUpdateInput"] | undefined,
	upsert?: GraphQLTypes["EmployeeQueueUpsertShiftGroupRelationInput"] | undefined,
	connect?: GraphQLTypes["TimetableShiftGroupUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TimetableShiftGroupWithoutQueueUpdateInput"]: {
		order?: number | undefined,
	shifts?: Array<GraphQLTypes["TimetableShiftGroupUpdateShiftsEntityRelationInput"]> | undefined,
	day?: GraphQLTypes["TimetableShiftGroupUpdateDayEntityRelationInput"] | undefined,
	type?: GraphQLTypes["TimetableShiftGroupUpdateTypeEntityRelationInput"] | undefined,
	position?: GraphQLTypes["TimetableShiftGroupUpdatePositionEntityRelationInput"] | undefined,
	generatedByTemplate?: GraphQLTypes["TimetableShiftGroupUpdateGeneratedByTemplateEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableShiftGroupUpdateDayEntityRelationInput"]: {
		create?: GraphQLTypes["TimetableDayWithoutShiftGroupsCreateInput"] | undefined,
	update?: GraphQLTypes["TimetableDayWithoutShiftGroupsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TimetableShiftGroupUpsertDayRelationInput"] | undefined,
	connect?: GraphQLTypes["TimetableDayUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["TimetableDayWithoutShiftGroupsUpdateInput"]: {
		date?: GraphQLTypes["Date"] | undefined,
	type?: GraphQLTypes["TimetableDayType"] | undefined,
	tipsCents?: number | undefined,
	notes?: Array<GraphQLTypes["TimetableDayUpdateNotesEntityRelationInput"]> | undefined,
	venue?: GraphQLTypes["TimetableDayUpdateVenueEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["TimetableDayUpdateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableDayUpdateNotesEntityRelationInput"]: {
		create?: GraphQLTypes["TimetableDayNoteWithoutDayCreateInput"] | undefined,
	update?: GraphQLTypes["TimetableDayUpdateNotesRelationInput"] | undefined,
	upsert?: GraphQLTypes["TimetableDayUpsertNotesRelationInput"] | undefined,
	connect?: GraphQLTypes["TimetableDayNoteUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TimetableDayNoteUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TimetableDayNoteUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TimetableDayUpdateNotesRelationInput"]: {
		by?: GraphQLTypes["TimetableDayNoteUniqueWhere"] | undefined,
	data?: GraphQLTypes["TimetableDayNoteWithoutDayUpdateInput"] | undefined
};
	["TimetableDayNoteWithoutDayUpdateInput"]: {
		order?: number | undefined,
	note?: string | undefined,
	role?: GraphQLTypes["TimetableDayNoteUpdateRoleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableDayNoteUpdateRoleEntityRelationInput"]: {
		create?: GraphQLTypes["TimetableEmployeeRoleCreateInput"] | undefined,
	update?: GraphQLTypes["TimetableEmployeeRoleUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TimetableDayNoteUpsertRoleRelationInput"] | undefined,
	connect?: GraphQLTypes["TimetableEmployeeRoleUniqueWhere"] | undefined
};
	["TimetableEmployeeRoleUpdateInput"]: {
		shiftGroups?: Array<GraphQLTypes["TimetableEmployeeRoleUpdateShiftGroupsEntityRelationInput"]> | undefined,
	shiftsProfiles?: Array<GraphQLTypes["TimetableEmployeeRoleUpdateShiftsProfilesEntityRelationInput"]> | undefined,
	shiftsManagers?: Array<GraphQLTypes["TimetableEmployeeRoleUpdateShiftsManagersEntityRelationInput"]> | undefined,
	name?: string | undefined,
	timetableTemplates?: Array<GraphQLTypes["TimetableEmployeeRoleUpdateTimetableTemplatesEntityRelationInput"]> | undefined,
	color?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableEmployeeRoleUpdateShiftsProfilesEntityRelationInput"]: {
		create?: GraphQLTypes["ShiftsProfileWithoutRolesCreateInput"] | undefined,
	update?: GraphQLTypes["TimetableEmployeeRoleUpdateShiftsProfilesRelationInput"] | undefined,
	upsert?: GraphQLTypes["TimetableEmployeeRoleUpsertShiftsProfilesRelationInput"] | undefined,
	connect?: GraphQLTypes["ShiftsProfileUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ShiftsProfileUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ShiftsProfileUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TimetableEmployeeRoleUpdateShiftsProfilesRelationInput"]: {
		by?: GraphQLTypes["ShiftsProfileUniqueWhere"] | undefined,
	data?: GraphQLTypes["ShiftsProfileWithoutRolesUpdateInput"] | undefined
};
	["ShiftsProfileWithoutRolesUpdateInput"]: {
		queueItems?: Array<GraphQLTypes["ShiftsProfileUpdateQueueItemsEntityRelationInput"]> | undefined,
	staff?: GraphQLTypes["ShiftsProfileUpdateStaffEntityRelationInput"] | undefined,
	shifts?: Array<GraphQLTypes["ShiftsProfileUpdateShiftsEntityRelationInput"]> | undefined,
	allowSelfUnassigning?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ShiftsProfileUpdateStaffEntityRelationInput"]: {
		create?: GraphQLTypes["StaffWithoutShiftsProfileCreateInput"] | undefined,
	update?: GraphQLTypes["StaffWithoutShiftsProfileUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ShiftsProfileUpsertStaffRelationInput"] | undefined,
	connect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["StaffWithoutShiftsProfileUpdateInput"]: {
		bartender?: GraphQLTypes["StaffUpdateBartenderEntityRelationInput"] | undefined,
	courier?: GraphQLTypes["StaffUpdateCourierEntityRelationInput"] | undefined,
	cleaner?: GraphQLTypes["StaffUpdateCleanerEntityRelationInput"] | undefined,
	shiftsManager?: GraphQLTypes["StaffUpdateShiftsManagerEntityRelationInput"] | undefined,
	businessToBusinessManager?: GraphQLTypes["StaffUpdateBusinessToBusinessManagerEntityRelationInput"] | undefined,
	user?: GraphQLTypes["StaffUpdateUserEntityRelationInput"] | undefined,
	stocksManager?: GraphQLTypes["StaffUpdateStocksManagerEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["StaffUpdatePhotoEntityRelationInput"] | undefined,
	courierManager?: GraphQLTypes["StaffUpdateCourierManagerEntityRelationInput"] | undefined,
	picker?: GraphQLTypes["StaffUpdatePickerEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	remunerationProfile?: GraphQLTypes["StaffUpdateRemunerationProfileEntityRelationInput"] | undefined,
	cashier?: GraphQLTypes["StaffUpdateCashierEntityRelationInput"] | undefined,
	venues?: Array<GraphQLTypes["StaffUpdateVenuesEntityRelationInput"]> | undefined,
	internalBuyer?: GraphQLTypes["StaffUpdateInternalBuyerEntityRelationInput"] | undefined,
	salesManager?: GraphQLTypes["StaffUpdateSalesManagerEntityRelationInput"] | undefined,
	cashierManager?: GraphQLTypes["StaffUpdateCashierManagerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StaffUpdateBusinessToBusinessManagerEntityRelationInput"]: {
		create?: GraphQLTypes["BusinessToBusinessManagerWithoutStaffCreateInput"] | undefined,
	update?: GraphQLTypes["BusinessToBusinessManagerWithoutStaffUpdateInput"] | undefined,
	upsert?: GraphQLTypes["StaffUpsertBusinessToBusinessManagerRelationInput"] | undefined,
	connect?: GraphQLTypes["BusinessToBusinessManagerUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["BusinessToBusinessManagerWithoutStaffUpdateInput"]: {
		managedBusinesses?: Array<GraphQLTypes["BusinessToBusinessManagerUpdateManagedBusinessesEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessToBusinessManagerUpdateManagedBusinessesEntityRelationInput"]: {
		create?: GraphQLTypes["BusinessCustomerWithoutAccountManagerCreateInput"] | undefined,
	update?: GraphQLTypes["BusinessToBusinessManagerUpdateManagedBusinessesRelationInput"] | undefined,
	upsert?: GraphQLTypes["BusinessToBusinessManagerUpsertManagedBusinessesRelationInput"] | undefined,
	connect?: GraphQLTypes["BusinessCustomerUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["BusinessCustomerUniqueWhere"] | undefined,
	delete?: GraphQLTypes["BusinessCustomerUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["BusinessToBusinessManagerUpdateManagedBusinessesRelationInput"]: {
		by?: GraphQLTypes["BusinessCustomerUniqueWhere"] | undefined,
	data?: GraphQLTypes["BusinessCustomerWithoutAccountManagerUpdateInput"] | undefined
};
	["BusinessCustomerWithoutAccountManagerUpdateInput"]: {
		name?: string | undefined,
	customer?: GraphQLTypes["BusinessCustomerUpdateCustomerEntityRelationInput"] | undefined,
	owners?: Array<GraphQLTypes["BusinessCustomerUpdateOwnersEntityRelationInput"]> | undefined,
	members?: Array<GraphQLTypes["BusinessCustomerUpdateMembersEntityRelationInput"]> | undefined,
	category?: GraphQLTypes["BusinessCustomerUpdateCategoryEntityRelationInput"] | undefined,
	logo?: GraphQLTypes["BusinessCustomerUpdateLogoEntityRelationInput"] | undefined,
	note?: string | undefined,
	businessServiceEvents?: Array<GraphQLTypes["BusinessCustomerUpdateBusinessServiceEventsEntityRelationInput"]> | undefined,
	doubleshotCoffeeEquipment?: GraphQLTypes["BusinessCustomerUpdateDoubleshotCoffeeEquipmentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessCustomerUpdateMembersEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerWithoutMemberOfBusinessesCreateInput"] | undefined,
	update?: GraphQLTypes["BusinessCustomerUpdateMembersRelationInput"] | undefined,
	upsert?: GraphQLTypes["BusinessCustomerUpsertMembersRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	delete?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["BusinessCustomerUpdateMembersRelationInput"]: {
		by?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	data?: GraphQLTypes["CustomerWithoutMemberOfBusinessesUpdateInput"] | undefined
};
	["CustomerWithoutMemberOfBusinessesUpdateInput"]: {
		addresses?: Array<GraphQLTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerUpdateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerUpdateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerUpdateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerUpdateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]: {
		create?: GraphQLTypes["BusinessCustomerWithoutOwnersCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerUpdateOwnerOfBusinessesRelationInput"] | undefined,
	upsert?: GraphQLTypes["CustomerUpsertOwnerOfBusinessesRelationInput"] | undefined,
	connect?: GraphQLTypes["BusinessCustomerUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["BusinessCustomerUniqueWhere"] | undefined,
	delete?: GraphQLTypes["BusinessCustomerUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CustomerUpdateOwnerOfBusinessesRelationInput"]: {
		by?: GraphQLTypes["BusinessCustomerUniqueWhere"] | undefined,
	data?: GraphQLTypes["BusinessCustomerWithoutOwnersUpdateInput"] | undefined
};
	["BusinessCustomerWithoutOwnersUpdateInput"]: {
		name?: string | undefined,
	customer?: GraphQLTypes["BusinessCustomerUpdateCustomerEntityRelationInput"] | undefined,
	members?: Array<GraphQLTypes["BusinessCustomerUpdateMembersEntityRelationInput"]> | undefined,
	category?: GraphQLTypes["BusinessCustomerUpdateCategoryEntityRelationInput"] | undefined,
	accountManager?: GraphQLTypes["BusinessCustomerUpdateAccountManagerEntityRelationInput"] | undefined,
	logo?: GraphQLTypes["BusinessCustomerUpdateLogoEntityRelationInput"] | undefined,
	note?: string | undefined,
	businessServiceEvents?: Array<GraphQLTypes["BusinessCustomerUpdateBusinessServiceEventsEntityRelationInput"]> | undefined,
	doubleshotCoffeeEquipment?: GraphQLTypes["BusinessCustomerUpdateDoubleshotCoffeeEquipmentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessCustomerUpdateAccountManagerEntityRelationInput"]: {
		create?: GraphQLTypes["BusinessToBusinessManagerWithoutManagedBusinessesCreateInput"] | undefined,
	update?: GraphQLTypes["BusinessToBusinessManagerWithoutManagedBusinessesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BusinessCustomerUpsertAccountManagerRelationInput"] | undefined,
	connect?: GraphQLTypes["BusinessToBusinessManagerUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["BusinessToBusinessManagerWithoutManagedBusinessesUpdateInput"]: {
		staff?: GraphQLTypes["BusinessToBusinessManagerUpdateStaffEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessToBusinessManagerUpdateStaffEntityRelationInput"]: {
		create?: GraphQLTypes["StaffWithoutBusinessToBusinessManagerCreateInput"] | undefined,
	update?: GraphQLTypes["StaffWithoutBusinessToBusinessManagerUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BusinessToBusinessManagerUpsertStaffRelationInput"] | undefined,
	connect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["StaffWithoutBusinessToBusinessManagerUpdateInput"]: {
		bartender?: GraphQLTypes["StaffUpdateBartenderEntityRelationInput"] | undefined,
	courier?: GraphQLTypes["StaffUpdateCourierEntityRelationInput"] | undefined,
	cleaner?: GraphQLTypes["StaffUpdateCleanerEntityRelationInput"] | undefined,
	shiftsManager?: GraphQLTypes["StaffUpdateShiftsManagerEntityRelationInput"] | undefined,
	user?: GraphQLTypes["StaffUpdateUserEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["StaffUpdateShiftsProfileEntityRelationInput"] | undefined,
	stocksManager?: GraphQLTypes["StaffUpdateStocksManagerEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["StaffUpdatePhotoEntityRelationInput"] | undefined,
	courierManager?: GraphQLTypes["StaffUpdateCourierManagerEntityRelationInput"] | undefined,
	picker?: GraphQLTypes["StaffUpdatePickerEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	remunerationProfile?: GraphQLTypes["StaffUpdateRemunerationProfileEntityRelationInput"] | undefined,
	cashier?: GraphQLTypes["StaffUpdateCashierEntityRelationInput"] | undefined,
	venues?: Array<GraphQLTypes["StaffUpdateVenuesEntityRelationInput"]> | undefined,
	internalBuyer?: GraphQLTypes["StaffUpdateInternalBuyerEntityRelationInput"] | undefined,
	salesManager?: GraphQLTypes["StaffUpdateSalesManagerEntityRelationInput"] | undefined,
	cashierManager?: GraphQLTypes["StaffUpdateCashierManagerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StaffUpdateUserEntityRelationInput"]: {
		create?: GraphQLTypes["UserWithoutStaffCreateInput"] | undefined,
	update?: GraphQLTypes["UserWithoutStaffUpdateInput"] | undefined,
	upsert?: GraphQLTypes["StaffUpsertUserRelationInput"] | undefined,
	connect?: GraphQLTypes["UserUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserWithoutStaffUpdateInput"]: {
		name?: string | undefined,
	internalNote?: string | undefined,
	customer?: GraphQLTypes["UserUpdateCustomerEntityRelationInput"] | undefined,
	tenantPersonId?: GraphQLTypes["UUID"] | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	devices?: Array<GraphQLTypes["UserUpdateDevicesEntityRelationInput"]> | undefined,
	verifiedAt?: GraphQLTypes["DateTime"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	deletionRequestedAt?: GraphQLTypes["DateTime"] | undefined,
	deletionExpectedAt?: GraphQLTypes["DateTime"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	meta?: GraphQLTypes["UserUpdateMetaEntityRelationInput"] | undefined,
	identificationAttempts?: Array<GraphQLTypes["UserUpdateIdentificationAttemptsEntityRelationInput"]> | undefined,
	roles?: GraphQLTypes["UserUpdateRolesEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserUpdateCustomerEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerWithoutUserCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerWithoutUserUpdateInput"] | undefined,
	upsert?: GraphQLTypes["UserUpsertCustomerRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CustomerWithoutUserUpdateInput"]: {
		addresses?: Array<GraphQLTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerUpdateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerUpdateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerUpdateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerUpdateCartsEntityRelationInput"]: {
		create?: GraphQLTypes["CartWithoutCustomerCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerUpdateCartsRelationInput"] | undefined,
	upsert?: GraphQLTypes["CustomerUpsertCartsRelationInput"] | undefined,
	connect?: GraphQLTypes["CartUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["CartUniqueWhere"] | undefined,
	delete?: GraphQLTypes["CartUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CustomerUpdateCartsRelationInput"]: {
		by?: GraphQLTypes["CartUniqueWhere"] | undefined,
	data?: GraphQLTypes["CartWithoutCustomerUpdateInput"] | undefined
};
	["CartWithoutCustomerUpdateInput"]: {
		confirmedAt?: GraphQLTypes["DateTime"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	items?: Array<GraphQLTypes["CartUpdateItemsEntityRelationInput"]> | undefined,
	handle?: string | undefined,
	state?: GraphQLTypes["CartState"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	channel?: GraphQLTypes["CartUpdateChannelEntityRelationInput"] | undefined,
	order?: GraphQLTypes["CartUpdateOrderEntityRelationInput"] | undefined,
	deliveryAddress?: GraphQLTypes["CartUpdateDeliveryAddressEntityRelationInput"] | undefined,
	billingAddress?: GraphQLTypes["CartUpdateBillingAddressEntityRelationInput"] | undefined,
	deliveryOption?: string | undefined,
	paymentOption?: string | undefined,
	delivery?: GraphQLTypes["CartUpdateDeliveryEntityRelationInput"] | undefined,
	payment?: GraphQLTypes["CartUpdatePaymentEntityRelationInput"] | undefined,
	billingSubject?: GraphQLTypes["CartUpdateBillingSubjectEntityRelationInput"] | undefined,
	priceLines?: Array<GraphQLTypes["CartUpdatePriceLinesEntityRelationInput"]> | undefined,
	summary?: GraphQLTypes["CartUpdateSummaryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CartUpdateOrderEntityRelationInput"]: {
		create?: GraphQLTypes["OrderWithoutCartCreateInput"] | undefined,
	update?: GraphQLTypes["OrderWithoutCartUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CartUpsertOrderRelationInput"] | undefined,
	connect?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["OrderWithoutCartUpdateInput"]: {
		state?: GraphQLTypes["OrderState"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	canceledAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	customer?: GraphQLTypes["OrderUpdateCustomerEntityRelationInput"] | undefined,
	channel?: GraphQLTypes["OrderUpdateChannelEntityRelationInput"] | undefined,
	discounts?: Array<GraphQLTypes["OrderUpdateDiscountsEntityRelationInput"]> | undefined,
	delivery?: GraphQLTypes["OrderUpdateDeliveryEntityRelationInput"] | undefined,
	items?: Array<GraphQLTypes["OrderUpdateItemsEntityRelationInput"]> | undefined,
	internalNote?: string | undefined,
	events?: Array<GraphQLTypes["OrderUpdateEventsEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddress?: GraphQLTypes["OrderUpdateBillingAddressEntityRelationInput"] | undefined,
	priceLines?: Array<GraphQLTypes["OrderUpdatePriceLinesEntityRelationInput"]> | undefined,
	payments?: Array<GraphQLTypes["OrderUpdatePaymentsEntityRelationInput"]> | undefined,
	seq?: number | undefined,
	billingSubject?: GraphQLTypes["OrderUpdateBillingSubjectEntityRelationInput"] | undefined,
	summary?: GraphQLTypes["OrderUpdateSummaryEntityRelationInput"] | undefined,
	doubleshotLegacyId?: string | undefined,
	gratuity?: GraphQLTypes["OrderUpdateGratuityEntityRelationInput"] | undefined,
	venue?: GraphQLTypes["OrderUpdateVenueEntityRelationInput"] | undefined,
	fulfillmentNote?: string | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["OrderUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	doubleshotTotalWeightGrams?: number | undefined,
	doubleShotLegacyNumber?: string | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	doubleshotAdminUrl?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderUpdateCustomerEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerWithoutOrdersCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerWithoutOrdersUpdateInput"] | undefined,
	upsert?: GraphQLTypes["OrderUpsertCustomerRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CustomerWithoutOrdersUpdateInput"]: {
		addresses?: Array<GraphQLTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerUpdateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerUpdateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerUpdateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerUpdateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerUpdateShortcutListEntityRelationInput"]: {
		create?: GraphQLTypes["ApplicationShortcutListWithoutCustomerCreateInput"] | undefined,
	update?: GraphQLTypes["ApplicationShortcutListWithoutCustomerUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CustomerUpsertShortcutListRelationInput"] | undefined,
	connect?: GraphQLTypes["ApplicationShortcutListUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ApplicationShortcutListWithoutCustomerUpdateInput"]: {
		items?: Array<GraphQLTypes["ApplicationShortcutListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ApplicationShortcutListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["ApplicationShortcutListItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["ApplicationShortcutListUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["ApplicationShortcutListUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["ApplicationShortcutListItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ApplicationShortcutListItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ApplicationShortcutListItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ApplicationShortcutListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["ApplicationShortcutListItemUniqueWhere"] | undefined,
	data?: GraphQLTypes["ApplicationShortcutListItemWithoutListUpdateInput"] | undefined
};
	["ApplicationShortcutListItemWithoutListUpdateInput"]: {
		order?: number | undefined,
	application?: GraphQLTypes["ApplicationShortcutListItemUpdateApplicationEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ApplicationShortcutListItemUpdateApplicationEntityRelationInput"]: {
		create?: GraphQLTypes["ApplicationCreateInput"] | undefined,
	update?: GraphQLTypes["ApplicationUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ApplicationShortcutListItemUpsertApplicationRelationInput"] | undefined,
	connect?: GraphQLTypes["ApplicationUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ApplicationUpdateInput"]: {
		order?: number | undefined,
	handle?: string | undefined,
	url?: string | undefined,
	color?: string | undefined,
	icon?: GraphQLTypes["ApplicationUpdateIconEntityRelationInput"] | undefined,
	name?: string | undefined,
	short?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ApplicationUpdateIconEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ApplicationUpsertIconRelationInput"] | undefined,
	connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ApplicationUpsertIconRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["ApplicationShortcutListItemUpsertApplicationRelationInput"]: {
		update?: GraphQLTypes["ApplicationUpdateInput"] | undefined,
	create?: GraphQLTypes["ApplicationCreateInput"] | undefined
};
	["ApplicationShortcutListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["ApplicationShortcutListItemUniqueWhere"] | undefined,
	update?: GraphQLTypes["ApplicationShortcutListItemWithoutListUpdateInput"] | undefined,
	create?: GraphQLTypes["ApplicationShortcutListItemWithoutListCreateInput"] | undefined
};
	["CustomerUpsertShortcutListRelationInput"]: {
		update?: GraphQLTypes["ApplicationShortcutListWithoutCustomerUpdateInput"] | undefined,
	create?: GraphQLTypes["ApplicationShortcutListWithoutCustomerCreateInput"] | undefined
};
	["CustomerUpdateUserEntityRelationInput"]: {
		create?: GraphQLTypes["UserWithoutCustomerCreateInput"] | undefined,
	update?: GraphQLTypes["UserWithoutCustomerUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CustomerUpsertUserRelationInput"] | undefined,
	connect?: GraphQLTypes["UserUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserWithoutCustomerUpdateInput"]: {
		name?: string | undefined,
	internalNote?: string | undefined,
	staff?: GraphQLTypes["UserUpdateStaffEntityRelationInput"] | undefined,
	tenantPersonId?: GraphQLTypes["UUID"] | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	devices?: Array<GraphQLTypes["UserUpdateDevicesEntityRelationInput"]> | undefined,
	verifiedAt?: GraphQLTypes["DateTime"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	deletionRequestedAt?: GraphQLTypes["DateTime"] | undefined,
	deletionExpectedAt?: GraphQLTypes["DateTime"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	meta?: GraphQLTypes["UserUpdateMetaEntityRelationInput"] | undefined,
	identificationAttempts?: Array<GraphQLTypes["UserUpdateIdentificationAttemptsEntityRelationInput"]> | undefined,
	roles?: GraphQLTypes["UserUpdateRolesEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserUpdateStaffEntityRelationInput"]: {
		create?: GraphQLTypes["StaffWithoutUserCreateInput"] | undefined,
	update?: GraphQLTypes["StaffWithoutUserUpdateInput"] | undefined,
	upsert?: GraphQLTypes["UserUpsertStaffRelationInput"] | undefined,
	connect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["StaffWithoutUserUpdateInput"]: {
		bartender?: GraphQLTypes["StaffUpdateBartenderEntityRelationInput"] | undefined,
	courier?: GraphQLTypes["StaffUpdateCourierEntityRelationInput"] | undefined,
	cleaner?: GraphQLTypes["StaffUpdateCleanerEntityRelationInput"] | undefined,
	shiftsManager?: GraphQLTypes["StaffUpdateShiftsManagerEntityRelationInput"] | undefined,
	businessToBusinessManager?: GraphQLTypes["StaffUpdateBusinessToBusinessManagerEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["StaffUpdateShiftsProfileEntityRelationInput"] | undefined,
	stocksManager?: GraphQLTypes["StaffUpdateStocksManagerEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["StaffUpdatePhotoEntityRelationInput"] | undefined,
	courierManager?: GraphQLTypes["StaffUpdateCourierManagerEntityRelationInput"] | undefined,
	picker?: GraphQLTypes["StaffUpdatePickerEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	remunerationProfile?: GraphQLTypes["StaffUpdateRemunerationProfileEntityRelationInput"] | undefined,
	cashier?: GraphQLTypes["StaffUpdateCashierEntityRelationInput"] | undefined,
	venues?: Array<GraphQLTypes["StaffUpdateVenuesEntityRelationInput"]> | undefined,
	internalBuyer?: GraphQLTypes["StaffUpdateInternalBuyerEntityRelationInput"] | undefined,
	salesManager?: GraphQLTypes["StaffUpdateSalesManagerEntityRelationInput"] | undefined,
	cashierManager?: GraphQLTypes["StaffUpdateCashierManagerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StaffUpdateShiftsProfileEntityRelationInput"]: {
		create?: GraphQLTypes["ShiftsProfileWithoutStaffCreateInput"] | undefined,
	update?: GraphQLTypes["ShiftsProfileWithoutStaffUpdateInput"] | undefined,
	upsert?: GraphQLTypes["StaffUpsertShiftsProfileRelationInput"] | undefined,
	connect?: GraphQLTypes["ShiftsProfileUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ShiftsProfileWithoutStaffUpdateInput"]: {
		queueItems?: Array<GraphQLTypes["ShiftsProfileUpdateQueueItemsEntityRelationInput"]> | undefined,
	roles?: Array<GraphQLTypes["ShiftsProfileUpdateRolesEntityRelationInput"]> | undefined,
	shifts?: Array<GraphQLTypes["ShiftsProfileUpdateShiftsEntityRelationInput"]> | undefined,
	allowSelfUnassigning?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ShiftsProfileUpdateRolesEntityRelationInput"]: {
		create?: GraphQLTypes["TimetableEmployeeRoleWithoutShiftsProfilesCreateInput"] | undefined,
	update?: GraphQLTypes["ShiftsProfileUpdateRolesRelationInput"] | undefined,
	upsert?: GraphQLTypes["ShiftsProfileUpsertRolesRelationInput"] | undefined,
	connect?: GraphQLTypes["TimetableEmployeeRoleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TimetableEmployeeRoleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TimetableEmployeeRoleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ShiftsProfileUpdateRolesRelationInput"]: {
		by?: GraphQLTypes["TimetableEmployeeRoleUniqueWhere"] | undefined,
	data?: GraphQLTypes["TimetableEmployeeRoleWithoutShiftsProfilesUpdateInput"] | undefined
};
	["TimetableEmployeeRoleWithoutShiftsProfilesUpdateInput"]: {
		shiftGroups?: Array<GraphQLTypes["TimetableEmployeeRoleUpdateShiftGroupsEntityRelationInput"]> | undefined,
	shiftsManagers?: Array<GraphQLTypes["TimetableEmployeeRoleUpdateShiftsManagersEntityRelationInput"]> | undefined,
	name?: string | undefined,
	timetableTemplates?: Array<GraphQLTypes["TimetableEmployeeRoleUpdateTimetableTemplatesEntityRelationInput"]> | undefined,
	color?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableEmployeeRoleUpdateShiftsManagersEntityRelationInput"]: {
		create?: GraphQLTypes["ShiftsManagerWithoutManagedRolesCreateInput"] | undefined,
	update?: GraphQLTypes["TimetableEmployeeRoleUpdateShiftsManagersRelationInput"] | undefined,
	upsert?: GraphQLTypes["TimetableEmployeeRoleUpsertShiftsManagersRelationInput"] | undefined,
	connect?: GraphQLTypes["ShiftsManagerUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ShiftsManagerUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ShiftsManagerUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TimetableEmployeeRoleUpdateShiftsManagersRelationInput"]: {
		by?: GraphQLTypes["ShiftsManagerUniqueWhere"] | undefined,
	data?: GraphQLTypes["ShiftsManagerWithoutManagedRolesUpdateInput"] | undefined
};
	["ShiftsManagerWithoutManagedRolesUpdateInput"]: {
		staff?: GraphQLTypes["ShiftsManagerUpdateStaffEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ShiftsManagerUpdateStaffEntityRelationInput"]: {
		create?: GraphQLTypes["StaffWithoutShiftsManagerCreateInput"] | undefined,
	update?: GraphQLTypes["StaffWithoutShiftsManagerUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ShiftsManagerUpsertStaffRelationInput"] | undefined,
	connect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["StaffWithoutShiftsManagerUpdateInput"]: {
		bartender?: GraphQLTypes["StaffUpdateBartenderEntityRelationInput"] | undefined,
	courier?: GraphQLTypes["StaffUpdateCourierEntityRelationInput"] | undefined,
	cleaner?: GraphQLTypes["StaffUpdateCleanerEntityRelationInput"] | undefined,
	businessToBusinessManager?: GraphQLTypes["StaffUpdateBusinessToBusinessManagerEntityRelationInput"] | undefined,
	user?: GraphQLTypes["StaffUpdateUserEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["StaffUpdateShiftsProfileEntityRelationInput"] | undefined,
	stocksManager?: GraphQLTypes["StaffUpdateStocksManagerEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["StaffUpdatePhotoEntityRelationInput"] | undefined,
	courierManager?: GraphQLTypes["StaffUpdateCourierManagerEntityRelationInput"] | undefined,
	picker?: GraphQLTypes["StaffUpdatePickerEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	remunerationProfile?: GraphQLTypes["StaffUpdateRemunerationProfileEntityRelationInput"] | undefined,
	cashier?: GraphQLTypes["StaffUpdateCashierEntityRelationInput"] | undefined,
	venues?: Array<GraphQLTypes["StaffUpdateVenuesEntityRelationInput"]> | undefined,
	internalBuyer?: GraphQLTypes["StaffUpdateInternalBuyerEntityRelationInput"] | undefined,
	salesManager?: GraphQLTypes["StaffUpdateSalesManagerEntityRelationInput"] | undefined,
	cashierManager?: GraphQLTypes["StaffUpdateCashierManagerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StaffUpdateStocksManagerEntityRelationInput"]: {
		create?: GraphQLTypes["StocksManagerWithoutStaffCreateInput"] | undefined,
	update?: GraphQLTypes["StocksManagerWithoutStaffUpdateInput"] | undefined,
	upsert?: GraphQLTypes["StaffUpsertStocksManagerRelationInput"] | undefined,
	connect?: GraphQLTypes["StocksManagerUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["StocksManagerWithoutStaffUpdateInput"]: {
		managedProducts?: Array<GraphQLTypes["StocksManagerUpdateManagedProductsEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StocksManagerUpdateManagedProductsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductWithoutManagerCreateInput"] | undefined,
	update?: GraphQLTypes["StocksManagerUpdateManagedProductsRelationInput"] | undefined,
	upsert?: GraphQLTypes["StocksManagerUpsertManagedProductsRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["StocksManagerUpdateManagedProductsRelationInput"]: {
		by?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	data?: GraphQLTypes["ProductWithoutManagerUpdateInput"] | undefined
};
	["ProductWithoutManagerUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	priceCents?: number | undefined,
	notDiscountable?: boolean | undefined,
	packing?: GraphQLTypes["ProductUpdatePackingEntityRelationInput"] | undefined,
	recipe?: GraphQLTypes["ProductUpdateRecipeEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["ProductUpdateTagsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["ProductUpdateCategoriesEntityRelationInput"]> | undefined,
	vatRate?: GraphQLTypes["ProductUpdateVatRateEntityRelationInput"] | undefined,
	stocks?: Array<GraphQLTypes["ProductUpdateStocksEntityRelationInput"]> | undefined,
	groupPrices?: Array<GraphQLTypes["ProductUpdateGroupPricesEntityRelationInput"]> | undefined,
	image?: GraphQLTypes["ProductUpdateImageEntityRelationInput"] | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	cartItems?: Array<GraphQLTypes["ProductUpdateCartItemsEntityRelationInput"]> | undefined,
	availability?: GraphQLTypes["ProductAvailability"] | undefined,
	order?: number | undefined,
	orderItems?: Array<GraphQLTypes["ProductUpdateOrderItemsEntityRelationInput"]> | undefined,
	maximumQuantityPerOrder?: number | undefined,
	inheritedCategories?: Array<GraphQLTypes["ProductUpdateInheritedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["ProductUpdateDeliveryZonesEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["ProductUpdateLocalesEntityRelationInput"]> | undefined,
	archivedAt?: GraphQLTypes["DateTime"] | undefined,
	customerPrices?: Array<GraphQLTypes["ProductUpdateCustomerPricesEntityRelationInput"]> | undefined,
	virtualProduct?: GraphQLTypes["ProductUpdateVirtualProductEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["ProductUpdateMetaEntityRelationInput"] | undefined,
	page?: GraphQLTypes["ProductUpdatePageEntityRelationInput"] | undefined,
	salesDays?: Array<GraphQLTypes["ProductUpdateSalesDaysEntityRelationInput"]> | undefined,
	salesWeeks?: Array<GraphQLTypes["ProductUpdateSalesWeeksEntityRelationInput"]> | undefined,
	salesMonths?: Array<GraphQLTypes["ProductUpdateSalesMonthsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["ProductUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	hasSubscription?: boolean | undefined,
	pointOfSaleTileColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductUpdateOrderItemsEntityRelationInput"]: {
		create?: GraphQLTypes["OrderItemWithoutProductCreateInput"] | undefined,
	update?: GraphQLTypes["ProductUpdateOrderItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["ProductUpsertOrderItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["OrderItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["OrderItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["OrderItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductUpdateOrderItemsRelationInput"]: {
		by?: GraphQLTypes["OrderItemUniqueWhere"] | undefined,
	data?: GraphQLTypes["OrderItemWithoutProductUpdateInput"] | undefined
};
	["OrderItemWithoutProductUpdateInput"]: {
		unitPriceCents?: number | undefined,
	quantity?: number | undefined,
	vatRate?: GraphQLTypes["OrderItemUpdateVatRateEntityRelationInput"] | undefined,
	order?: GraphQLTypes["OrderItemUpdateOrderEntityRelationInput"] | undefined,
	virtualProductEffects?: Array<GraphQLTypes["OrderItemUpdateVirtualProductEffectsEntityRelationInput"]> | undefined,
	pickedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["OrderItemUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderItemUpdateVatRateEntityRelationInput"]: {
		create?: GraphQLTypes["VatRateCreateInput"] | undefined,
	update?: GraphQLTypes["VatRateUpdateInput"] | undefined,
	upsert?: GraphQLTypes["OrderItemUpsertVatRateRelationInput"] | undefined,
	connect?: GraphQLTypes["VatRateUniqueWhere"] | undefined
};
	["OrderItemUpsertVatRateRelationInput"]: {
		update?: GraphQLTypes["VatRateUpdateInput"] | undefined,
	create?: GraphQLTypes["VatRateCreateInput"] | undefined
};
	["OrderItemUpdateOrderEntityRelationInput"]: {
		create?: GraphQLTypes["OrderWithoutItemsCreateInput"] | undefined,
	update?: GraphQLTypes["OrderWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["OrderItemUpsertOrderRelationInput"] | undefined,
	connect?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["OrderWithoutItemsUpdateInput"]: {
		state?: GraphQLTypes["OrderState"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	canceledAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	customer?: GraphQLTypes["OrderUpdateCustomerEntityRelationInput"] | undefined,
	channel?: GraphQLTypes["OrderUpdateChannelEntityRelationInput"] | undefined,
	discounts?: Array<GraphQLTypes["OrderUpdateDiscountsEntityRelationInput"]> | undefined,
	delivery?: GraphQLTypes["OrderUpdateDeliveryEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	cart?: GraphQLTypes["OrderUpdateCartEntityRelationInput"] | undefined,
	events?: Array<GraphQLTypes["OrderUpdateEventsEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddress?: GraphQLTypes["OrderUpdateBillingAddressEntityRelationInput"] | undefined,
	priceLines?: Array<GraphQLTypes["OrderUpdatePriceLinesEntityRelationInput"]> | undefined,
	payments?: Array<GraphQLTypes["OrderUpdatePaymentsEntityRelationInput"]> | undefined,
	seq?: number | undefined,
	billingSubject?: GraphQLTypes["OrderUpdateBillingSubjectEntityRelationInput"] | undefined,
	summary?: GraphQLTypes["OrderUpdateSummaryEntityRelationInput"] | undefined,
	doubleshotLegacyId?: string | undefined,
	gratuity?: GraphQLTypes["OrderUpdateGratuityEntityRelationInput"] | undefined,
	venue?: GraphQLTypes["OrderUpdateVenueEntityRelationInput"] | undefined,
	fulfillmentNote?: string | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["OrderUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	doubleshotTotalWeightGrams?: number | undefined,
	doubleShotLegacyNumber?: string | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	doubleshotAdminUrl?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderUpdateDiscountsEntityRelationInput"]: {
		create?: GraphQLTypes["OrderDiscountWithoutOrderCreateInput"] | undefined,
	update?: GraphQLTypes["OrderUpdateDiscountsRelationInput"] | undefined,
	upsert?: GraphQLTypes["OrderUpsertDiscountsRelationInput"] | undefined,
	connect?: GraphQLTypes["OrderDiscountUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["OrderDiscountUniqueWhere"] | undefined,
	delete?: GraphQLTypes["OrderDiscountUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["OrderUpdateDiscountsRelationInput"]: {
		by?: GraphQLTypes["OrderDiscountUniqueWhere"] | undefined,
	data?: GraphQLTypes["OrderDiscountWithoutOrderUpdateInput"] | undefined
};
	["OrderDiscountWithoutOrderUpdateInput"]: {
		discountCents?: number | undefined,
	vatRate?: GraphQLTypes["OrderDiscountUpdateVatRateEntityRelationInput"] | undefined,
	description?: string | undefined,
	type?: GraphQLTypes["OrderDiscountType"] | undefined,
	customerCreditTransactions?: Array<GraphQLTypes["OrderDiscountUpdateCustomerCreditTransactionsEntityRelationInput"]> | undefined,
	voucherRedemption?: GraphQLTypes["OrderDiscountUpdateVoucherRedemptionEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderDiscountUpdateVatRateEntityRelationInput"]: {
		create?: GraphQLTypes["VatRateCreateInput"] | undefined,
	update?: GraphQLTypes["VatRateUpdateInput"] | undefined,
	upsert?: GraphQLTypes["OrderDiscountUpsertVatRateRelationInput"] | undefined,
	connect?: GraphQLTypes["VatRateUniqueWhere"] | undefined
};
	["OrderDiscountUpsertVatRateRelationInput"]: {
		update?: GraphQLTypes["VatRateUpdateInput"] | undefined,
	create?: GraphQLTypes["VatRateCreateInput"] | undefined
};
	["OrderDiscountUpdateCustomerCreditTransactionsEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerCreditTransactionWithoutOrderDiscountCreateInput"] | undefined,
	update?: GraphQLTypes["OrderDiscountUpdateCustomerCreditTransactionsRelationInput"] | undefined,
	upsert?: GraphQLTypes["OrderDiscountUpsertCustomerCreditTransactionsRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerCreditTransactionUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["CustomerCreditTransactionUniqueWhere"] | undefined,
	delete?: GraphQLTypes["CustomerCreditTransactionUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["OrderDiscountUpdateCustomerCreditTransactionsRelationInput"]: {
		by?: GraphQLTypes["CustomerCreditTransactionUniqueWhere"] | undefined,
	data?: GraphQLTypes["CustomerCreditTransactionWithoutOrderDiscountUpdateInput"] | undefined
};
	["CustomerCreditTransactionWithoutOrderDiscountUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	amountCents?: number | undefined,
	customerCredit?: GraphQLTypes["CustomerCreditTransactionUpdateCustomerCreditEntityRelationInput"] | undefined,
	virtualProductEffect?: GraphQLTypes["CustomerCreditTransactionUpdateVirtualProductEffectEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreditTransactionUpdateCustomerCreditEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerCreditWithoutTransactionsCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerCreditWithoutTransactionsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CustomerCreditTransactionUpsertCustomerCreditRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerCreditUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CustomerCreditWithoutTransactionsUpdateInput"]: {
		initialCreditCents?: number | undefined,
	remainingCreditsCents?: number | undefined,
	expiresAt?: GraphQLTypes["DateTime"] | undefined,
	reason?: string | undefined,
	customer?: GraphQLTypes["CustomerCreditUpdateCustomerEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["CustomerCreditUpdateVatRateEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	voucherRedemption?: GraphQLTypes["CustomerCreditUpdateVoucherRedemptionEntityRelationInput"] | undefined,
	invoiceUrl?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreditUpdateCustomerEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerWithoutCreditsCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerWithoutCreditsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CustomerCreditUpsertCustomerRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined
};
	["CustomerWithoutCreditsUpdateInput"]: {
		addresses?: Array<GraphQLTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerUpdateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerUpdateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerUpdateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerUpdateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerUpdateChannelsEntityRelationInput"]: {
		create?: GraphQLTypes["ChannelWithoutCustomersCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerUpdateChannelsRelationInput"] | undefined,
	upsert?: GraphQLTypes["CustomerUpsertChannelsRelationInput"] | undefined,
	connect?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CustomerUpdateChannelsRelationInput"]: {
		by?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	data?: GraphQLTypes["ChannelWithoutCustomersUpdateInput"] | undefined
};
	["ChannelWithoutCustomersUpdateInput"]: {
		name?: string | undefined,
	disabled?: boolean | undefined,
	payments?: Array<GraphQLTypes["ChannelUpdatePaymentsEntityRelationInput"]> | undefined,
	deliveries?: Array<GraphQLTypes["ChannelUpdateDeliveriesEntityRelationInput"]> | undefined,
	pointOfSales?: Array<GraphQLTypes["ChannelUpdatePointOfSalesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["ChannelUpdateCartsEntityRelationInput"]> | undefined,
	code?: GraphQLTypes["ChannelCode"] | undefined,
	addTagsOnRegistration?: Array<GraphQLTypes["ChannelUpdateAddTagsOnRegistrationEntityRelationInput"]> | undefined,
	publicTags?: Array<GraphQLTypes["ChannelUpdatePublicTagsEntityRelationInput"]> | undefined,
	venue?: GraphQLTypes["ChannelUpdateVenueEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ChannelUpdatePublicTagsEntityRelationInput"]: {
		create?: GraphQLTypes["TagWithoutPublicInChannelsCreateInput"] | undefined,
	update?: GraphQLTypes["ChannelUpdatePublicTagsRelationInput"] | undefined,
	upsert?: GraphQLTypes["ChannelUpsertPublicTagsRelationInput"] | undefined,
	connect?: GraphQLTypes["TagUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TagUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TagUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ChannelUpdatePublicTagsRelationInput"]: {
		by?: GraphQLTypes["TagUniqueWhere"] | undefined,
	data?: GraphQLTypes["TagWithoutPublicInChannelsUpdateInput"] | undefined
};
	["TagWithoutPublicInChannelsUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	customers?: Array<GraphQLTypes["TagUpdateCustomersEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["TagUpdateProductsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["TagUpdateCategoriesEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	addTagsOnRegistration?: Array<GraphQLTypes["TagUpdateAddTagsOnRegistrationEntityRelationInput"]> | undefined,
	nestedCategories?: Array<GraphQLTypes["TagUpdateNestedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["TagUpdateDeliveryZonesEntityRelationInput"]> | undefined,
	allowChannelPayments?: Array<GraphQLTypes["TagUpdateAllowChannelPaymentsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["TagUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TagUpdateAllowChannelPaymentsEntityRelationInput"]: {
		create?: GraphQLTypes["ChannelPaymentWithoutAllowOnlyForTagsCreateInput"] | undefined,
	update?: GraphQLTypes["TagUpdateAllowChannelPaymentsRelationInput"] | undefined,
	upsert?: GraphQLTypes["TagUpsertAllowChannelPaymentsRelationInput"] | undefined,
	connect?: GraphQLTypes["ChannelPaymentUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ChannelPaymentUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ChannelPaymentUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TagUpdateAllowChannelPaymentsRelationInput"]: {
		by?: GraphQLTypes["ChannelPaymentUniqueWhere"] | undefined,
	data?: GraphQLTypes["ChannelPaymentWithoutAllowOnlyForTagsUpdateInput"] | undefined
};
	["ChannelPaymentWithoutAllowOnlyForTagsUpdateInput"]: {
		order?: number | undefined,
	channel?: GraphQLTypes["ChannelPaymentUpdateChannelEntityRelationInput"] | undefined,
	method?: GraphQLTypes["ChannelPaymentUpdateMethodEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["ChannelPaymentUpdateVatRateEntityRelationInput"] | undefined,
	requireBillingAddress?: boolean | undefined,
	provideReceipt?: boolean | undefined,
	requireBillingSubject?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ChannelPaymentUpdateVatRateEntityRelationInput"]: {
		create?: GraphQLTypes["VatRateWithoutChannelPaymentsCreateInput"] | undefined,
	update?: GraphQLTypes["VatRateWithoutChannelPaymentsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ChannelPaymentUpsertVatRateRelationInput"] | undefined,
	connect?: GraphQLTypes["VatRateUniqueWhere"] | undefined
};
	["VatRateWithoutChannelPaymentsUpdateInput"]: {
		name?: string | undefined,
	ratePermille?: number | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	channelDeliveries?: Array<GraphQLTypes["VatRateUpdateChannelDeliveriesEntityRelationInput"]> | undefined,
	preset?: GraphQLTypes["VatRatePreset"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ChannelPaymentUpsertVatRateRelationInput"]: {
		update?: GraphQLTypes["VatRateWithoutChannelPaymentsUpdateInput"] | undefined,
	create?: GraphQLTypes["VatRateWithoutChannelPaymentsCreateInput"] | undefined
};
	["TagUpsertAllowChannelPaymentsRelationInput"]: {
		by?: GraphQLTypes["ChannelPaymentUniqueWhere"] | undefined,
	update?: GraphQLTypes["ChannelPaymentWithoutAllowOnlyForTagsUpdateInput"] | undefined,
	create?: GraphQLTypes["ChannelPaymentWithoutAllowOnlyForTagsCreateInput"] | undefined
};
	["TagUpdateFulfillmentNotesEntityRelationInput"]: {
		create?: GraphQLTypes["FulfillmentNoteWithoutTagsCreateInput"] | undefined,
	update?: GraphQLTypes["TagUpdateFulfillmentNotesRelationInput"] | undefined,
	upsert?: GraphQLTypes["TagUpsertFulfillmentNotesRelationInput"] | undefined,
	connect?: GraphQLTypes["FulfillmentNoteUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["FulfillmentNoteUniqueWhere"] | undefined,
	delete?: GraphQLTypes["FulfillmentNoteUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TagUpdateFulfillmentNotesRelationInput"]: {
		by?: GraphQLTypes["FulfillmentNoteUniqueWhere"] | undefined,
	data?: GraphQLTypes["FulfillmentNoteWithoutTagsUpdateInput"] | undefined
};
	["FulfillmentNoteWithoutTagsUpdateInput"]: {
		note?: string | undefined,
	products?: Array<GraphQLTypes["FulfillmentNoteUpdateProductsEntityRelationInput"]> | undefined,
	venues?: Array<GraphQLTypes["FulfillmentNoteUpdateVenuesEntityRelationInput"]> | undefined,
	cartItems?: Array<GraphQLTypes["FulfillmentNoteUpdateCartItemsEntityRelationInput"]> | undefined,
	orderItems?: Array<GraphQLTypes["FulfillmentNoteUpdateOrderItemsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["FulfillmentNoteUpdateOrdersEntityRelationInput"]> | undefined,
	highlight?: boolean | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	emoji?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["FulfillmentNoteUpdateProductsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductWithoutFulfillmentNotesCreateInput"] | undefined,
	update?: GraphQLTypes["FulfillmentNoteUpdateProductsRelationInput"] | undefined,
	upsert?: GraphQLTypes["FulfillmentNoteUpsertProductsRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["FulfillmentNoteUpdateProductsRelationInput"]: {
		by?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	data?: GraphQLTypes["ProductWithoutFulfillmentNotesUpdateInput"] | undefined
};
	["ProductWithoutFulfillmentNotesUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	priceCents?: number | undefined,
	notDiscountable?: boolean | undefined,
	packing?: GraphQLTypes["ProductUpdatePackingEntityRelationInput"] | undefined,
	recipe?: GraphQLTypes["ProductUpdateRecipeEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["ProductUpdateTagsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["ProductUpdateCategoriesEntityRelationInput"]> | undefined,
	vatRate?: GraphQLTypes["ProductUpdateVatRateEntityRelationInput"] | undefined,
	stocks?: Array<GraphQLTypes["ProductUpdateStocksEntityRelationInput"]> | undefined,
	groupPrices?: Array<GraphQLTypes["ProductUpdateGroupPricesEntityRelationInput"]> | undefined,
	image?: GraphQLTypes["ProductUpdateImageEntityRelationInput"] | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	cartItems?: Array<GraphQLTypes["ProductUpdateCartItemsEntityRelationInput"]> | undefined,
	availability?: GraphQLTypes["ProductAvailability"] | undefined,
	order?: number | undefined,
	manager?: GraphQLTypes["ProductUpdateManagerEntityRelationInput"] | undefined,
	orderItems?: Array<GraphQLTypes["ProductUpdateOrderItemsEntityRelationInput"]> | undefined,
	maximumQuantityPerOrder?: number | undefined,
	inheritedCategories?: Array<GraphQLTypes["ProductUpdateInheritedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["ProductUpdateDeliveryZonesEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["ProductUpdateLocalesEntityRelationInput"]> | undefined,
	archivedAt?: GraphQLTypes["DateTime"] | undefined,
	customerPrices?: Array<GraphQLTypes["ProductUpdateCustomerPricesEntityRelationInput"]> | undefined,
	virtualProduct?: GraphQLTypes["ProductUpdateVirtualProductEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["ProductUpdateMetaEntityRelationInput"] | undefined,
	page?: GraphQLTypes["ProductUpdatePageEntityRelationInput"] | undefined,
	salesDays?: Array<GraphQLTypes["ProductUpdateSalesDaysEntityRelationInput"]> | undefined,
	salesWeeks?: Array<GraphQLTypes["ProductUpdateSalesWeeksEntityRelationInput"]> | undefined,
	salesMonths?: Array<GraphQLTypes["ProductUpdateSalesMonthsEntityRelationInput"]> | undefined,
	hasSubscription?: boolean | undefined,
	pointOfSaleTileColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductUpdateInheritedCategoriesEntityRelationInput"]: {
		connect?: GraphQLTypes["NestedProductCategoryProductUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["NestedProductCategoryProductUniqueWhere"] | undefined,
	delete?: GraphQLTypes["NestedProductCategoryProductUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductUpdateDeliveryZonesEntityRelationInput"]: {
		create?: GraphQLTypes["DeliveryZoneWithoutDeliveryZonesOfProductsCreateInput"] | undefined,
	update?: GraphQLTypes["ProductUpdateDeliveryZonesRelationInput"] | undefined,
	upsert?: GraphQLTypes["ProductUpsertDeliveryZonesRelationInput"] | undefined,
	connect?: GraphQLTypes["DeliveryZoneUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["DeliveryZoneUniqueWhere"] | undefined,
	delete?: GraphQLTypes["DeliveryZoneUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductUpdateDeliveryZonesRelationInput"]: {
		by?: GraphQLTypes["DeliveryZoneUniqueWhere"] | undefined,
	data?: GraphQLTypes["DeliveryZoneWithoutDeliveryZonesOfProductsUpdateInput"] | undefined
};
	["DeliveryZoneWithoutDeliveryZonesOfProductsUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	type?: GraphQLTypes["DeliveryZoneType"] | undefined,
	addresses?: Array<GraphQLTypes["DeliveryZoneUpdateAddressesEntityRelationInput"]> | undefined,
	suitableDeliveryMethods?: Array<GraphQLTypes["DeliveryZoneUpdateSuitableDeliveryMethodsEntityRelationInput"]> | undefined,
	deliveryZonesOfTags?: Array<GraphQLTypes["DeliveryZoneUpdateDeliveryZonesOfTagsEntityRelationInput"]> | undefined,
	addressesMetadata?: Array<GraphQLTypes["DeliveryZoneUpdateAddressesMetadataEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryZoneUpdateDeliveryZonesOfTagsEntityRelationInput"]: {
		create?: GraphQLTypes["TagWithoutDeliveryZonesCreateInput"] | undefined,
	update?: GraphQLTypes["DeliveryZoneUpdateDeliveryZonesOfTagsRelationInput"] | undefined,
	upsert?: GraphQLTypes["DeliveryZoneUpsertDeliveryZonesOfTagsRelationInput"] | undefined,
	connect?: GraphQLTypes["TagUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TagUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TagUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["DeliveryZoneUpdateDeliveryZonesOfTagsRelationInput"]: {
		by?: GraphQLTypes["TagUniqueWhere"] | undefined,
	data?: GraphQLTypes["TagWithoutDeliveryZonesUpdateInput"] | undefined
};
	["TagWithoutDeliveryZonesUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	customers?: Array<GraphQLTypes["TagUpdateCustomersEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["TagUpdateProductsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["TagUpdateCategoriesEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	addTagsOnRegistration?: Array<GraphQLTypes["TagUpdateAddTagsOnRegistrationEntityRelationInput"]> | undefined,
	nestedCategories?: Array<GraphQLTypes["TagUpdateNestedCategoriesEntityRelationInput"]> | undefined,
	publicInChannels?: Array<GraphQLTypes["TagUpdatePublicInChannelsEntityRelationInput"]> | undefined,
	allowChannelPayments?: Array<GraphQLTypes["TagUpdateAllowChannelPaymentsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["TagUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TagUpdatePublicInChannelsEntityRelationInput"]: {
		create?: GraphQLTypes["ChannelWithoutPublicTagsCreateInput"] | undefined,
	update?: GraphQLTypes["TagUpdatePublicInChannelsRelationInput"] | undefined,
	upsert?: GraphQLTypes["TagUpsertPublicInChannelsRelationInput"] | undefined,
	connect?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TagUpdatePublicInChannelsRelationInput"]: {
		by?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	data?: GraphQLTypes["ChannelWithoutPublicTagsUpdateInput"] | undefined
};
	["ChannelWithoutPublicTagsUpdateInput"]: {
		name?: string | undefined,
	disabled?: boolean | undefined,
	payments?: Array<GraphQLTypes["ChannelUpdatePaymentsEntityRelationInput"]> | undefined,
	deliveries?: Array<GraphQLTypes["ChannelUpdateDeliveriesEntityRelationInput"]> | undefined,
	pointOfSales?: Array<GraphQLTypes["ChannelUpdatePointOfSalesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["ChannelUpdateCartsEntityRelationInput"]> | undefined,
	customers?: Array<GraphQLTypes["ChannelUpdateCustomersEntityRelationInput"]> | undefined,
	code?: GraphQLTypes["ChannelCode"] | undefined,
	addTagsOnRegistration?: Array<GraphQLTypes["ChannelUpdateAddTagsOnRegistrationEntityRelationInput"]> | undefined,
	venue?: GraphQLTypes["ChannelUpdateVenueEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ChannelUpdateVenueEntityRelationInput"]: {
		create?: GraphQLTypes["VenueWithoutChannelsCreateInput"] | undefined,
	update?: GraphQLTypes["VenueWithoutChannelsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ChannelUpsertVenueRelationInput"] | undefined,
	connect?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["VenueWithoutChannelsUpdateInput"]: {
		name?: string | undefined,
	deadlineTemplate?: GraphQLTypes["VenueUpdateDeadlineTemplateEntityRelationInput"] | undefined,
	timetableDays?: Array<GraphQLTypes["VenueUpdateTimetableDaysEntityRelationInput"]> | undefined,
	timetableTemplates?: Array<GraphQLTypes["VenueUpdateTimetableTemplatesEntityRelationInput"]> | undefined,
	staffMembers?: Array<GraphQLTypes["VenueUpdateStaffMembersEntityRelationInput"]> | undefined,
	employeeRoles?: Array<GraphQLTypes["VenueUpdateEmployeeRolesEntityRelationInput"]> | undefined,
	pointOfSaleApplicationDevices?: Array<GraphQLTypes["VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined,
	pointOfSaleTerminals?: Array<GraphQLTypes["VenueUpdatePointOfSaleTerminalsEntityRelationInput"]> | undefined,
	pointOfSalePrinters?: Array<GraphQLTypes["VenueUpdatePointOfSalePrintersEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["VenueUpdateOrdersEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["VenueUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	areas?: Array<GraphQLTypes["VenueUpdateAreasEntityRelationInput"]> | undefined,
	enabledUnassignReasons?: Array<GraphQLTypes["VenueUpdateEnabledUnassignReasonsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["VenueUpdateCategoriesEntityRelationInput"]> | undefined,
	address?: string | undefined,
	pointOfSalePngBase64ReceiptLogo?: string | undefined,
	pointOfSaleInitialView?: GraphQLTypes["PointOfSaleInitialView"] | undefined,
	pointOfSalePreferPrintReceipt?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["VenueUpdateDeadlineTemplateEntityRelationInput"]: {
		create?: GraphQLTypes["DeadlineTemplateWithoutVenueCreateInput"] | undefined,
	update?: GraphQLTypes["DeadlineTemplateWithoutVenueUpdateInput"] | undefined,
	upsert?: GraphQLTypes["VenueUpsertDeadlineTemplateRelationInput"] | undefined,
	connect?: GraphQLTypes["DeadlineTemplateUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["DeadlineTemplateWithoutVenueUpdateInput"]: {
		startDate?: GraphQLTypes["Date"] | undefined,
	period?: number | undefined,
	cutoff?: number | undefined,
	closed?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["VenueUpsertDeadlineTemplateRelationInput"]: {
		update?: GraphQLTypes["DeadlineTemplateWithoutVenueUpdateInput"] | undefined,
	create?: GraphQLTypes["DeadlineTemplateWithoutVenueCreateInput"] | undefined
};
	["VenueUpdateTimetableDaysEntityRelationInput"]: {
		create?: GraphQLTypes["TimetableDayWithoutVenueCreateInput"] | undefined,
	update?: GraphQLTypes["VenueUpdateTimetableDaysRelationInput"] | undefined,
	upsert?: GraphQLTypes["VenueUpsertTimetableDaysRelationInput"] | undefined,
	connect?: GraphQLTypes["TimetableDayUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TimetableDayUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TimetableDayUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["VenueUpdateTimetableDaysRelationInput"]: {
		by?: GraphQLTypes["TimetableDayUniqueWhere"] | undefined,
	data?: GraphQLTypes["TimetableDayWithoutVenueUpdateInput"] | undefined
};
	["TimetableDayWithoutVenueUpdateInput"]: {
		date?: GraphQLTypes["Date"] | undefined,
	type?: GraphQLTypes["TimetableDayType"] | undefined,
	shiftGroups?: Array<GraphQLTypes["TimetableDayUpdateShiftGroupsEntityRelationInput"]> | undefined,
	tipsCents?: number | undefined,
	notes?: Array<GraphQLTypes["TimetableDayUpdateNotesEntityRelationInput"]> | undefined,
	meta?: GraphQLTypes["TimetableDayUpdateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableDayUpdateShiftGroupsEntityRelationInput"]: {
		create?: GraphQLTypes["TimetableShiftGroupWithoutDayCreateInput"] | undefined,
	update?: GraphQLTypes["TimetableDayUpdateShiftGroupsRelationInput"] | undefined,
	upsert?: GraphQLTypes["TimetableDayUpsertShiftGroupsRelationInput"] | undefined,
	connect?: GraphQLTypes["TimetableShiftGroupUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TimetableShiftGroupUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TimetableShiftGroupUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TimetableDayUpdateShiftGroupsRelationInput"]: {
		by?: GraphQLTypes["TimetableShiftGroupUniqueWhere"] | undefined,
	data?: GraphQLTypes["TimetableShiftGroupWithoutDayUpdateInput"] | undefined
};
	["TimetableShiftGroupWithoutDayUpdateInput"]: {
		order?: number | undefined,
	shifts?: Array<GraphQLTypes["TimetableShiftGroupUpdateShiftsEntityRelationInput"]> | undefined,
	type?: GraphQLTypes["TimetableShiftGroupUpdateTypeEntityRelationInput"] | undefined,
	position?: GraphQLTypes["TimetableShiftGroupUpdatePositionEntityRelationInput"] | undefined,
	queue?: GraphQLTypes["TimetableShiftGroupUpdateQueueEntityRelationInput"] | undefined,
	generatedByTemplate?: GraphQLTypes["TimetableShiftGroupUpdateGeneratedByTemplateEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableShiftGroupUpdateTypeEntityRelationInput"]: {
		create?: GraphQLTypes["TimetableEmployeeRoleWithoutShiftGroupsCreateInput"] | undefined,
	update?: GraphQLTypes["TimetableEmployeeRoleWithoutShiftGroupsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TimetableShiftGroupUpsertTypeRelationInput"] | undefined,
	connect?: GraphQLTypes["TimetableEmployeeRoleUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TimetableEmployeeRoleWithoutShiftGroupsUpdateInput"]: {
		shiftsProfiles?: Array<GraphQLTypes["TimetableEmployeeRoleUpdateShiftsProfilesEntityRelationInput"]> | undefined,
	shiftsManagers?: Array<GraphQLTypes["TimetableEmployeeRoleUpdateShiftsManagersEntityRelationInput"]> | undefined,
	name?: string | undefined,
	timetableTemplates?: Array<GraphQLTypes["TimetableEmployeeRoleUpdateTimetableTemplatesEntityRelationInput"]> | undefined,
	color?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableEmployeeRoleUpdateTimetableTemplatesEntityRelationInput"]: {
		create?: GraphQLTypes["TimetableTemplateWithoutEmployeeRoleCreateInput"] | undefined,
	update?: GraphQLTypes["TimetableEmployeeRoleUpdateTimetableTemplatesRelationInput"] | undefined,
	upsert?: GraphQLTypes["TimetableEmployeeRoleUpsertTimetableTemplatesRelationInput"] | undefined,
	connect?: GraphQLTypes["TimetableTemplateUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TimetableTemplateUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TimetableTemplateUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TimetableEmployeeRoleUpdateTimetableTemplatesRelationInput"]: {
		by?: GraphQLTypes["TimetableTemplateUniqueWhere"] | undefined,
	data?: GraphQLTypes["TimetableTemplateWithoutEmployeeRoleUpdateInput"] | undefined
};
	["TimetableTemplateWithoutEmployeeRoleUpdateInput"]: {
		order?: number | undefined,
	startDate?: GraphQLTypes["Date"] | undefined,
	period?: number | undefined,
	slots?: number | undefined,
	position?: GraphQLTypes["TimetableTemplateUpdatePositionEntityRelationInput"] | undefined,
	staffOptions?: Array<GraphQLTypes["TimetableTemplateUpdateStaffOptionsEntityRelationInput"]> | undefined,
	internalName?: string | undefined,
	venue?: GraphQLTypes["TimetableTemplateUpdateVenueEntityRelationInput"] | undefined,
	workdaysOnly?: boolean | undefined,
	monday?: boolean | undefined,
	tuesday?: boolean | undefined,
	wednesday?: boolean | undefined,
	thursday?: boolean | undefined,
	friday?: boolean | undefined,
	saturday?: boolean | undefined,
	sunday?: boolean | undefined,
	type?: GraphQLTypes["TemplateType"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableTemplateUpdatePositionEntityRelationInput"]: {
		create?: GraphQLTypes["TimetableShiftPositionWithoutTimetableTemplatesCreateInput"] | undefined,
	update?: GraphQLTypes["TimetableShiftPositionWithoutTimetableTemplatesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TimetableTemplateUpsertPositionRelationInput"] | undefined,
	connect?: GraphQLTypes["TimetableShiftPositionUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TimetableShiftPositionWithoutTimetableTemplatesUpdateInput"]: {
		name?: string | undefined,
	start?: string | undefined,
	end?: string | undefined,
	shiftGroups?: Array<GraphQLTypes["TimetableShiftPositionUpdateShiftGroupsEntityRelationInput"]> | undefined,
	isDynamic?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableShiftPositionUpdateShiftGroupsEntityRelationInput"]: {
		create?: GraphQLTypes["TimetableShiftGroupWithoutPositionCreateInput"] | undefined,
	update?: GraphQLTypes["TimetableShiftPositionUpdateShiftGroupsRelationInput"] | undefined,
	upsert?: GraphQLTypes["TimetableShiftPositionUpsertShiftGroupsRelationInput"] | undefined,
	connect?: GraphQLTypes["TimetableShiftGroupUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TimetableShiftGroupUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TimetableShiftGroupUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TimetableShiftPositionUpdateShiftGroupsRelationInput"]: {
		by?: GraphQLTypes["TimetableShiftGroupUniqueWhere"] | undefined,
	data?: GraphQLTypes["TimetableShiftGroupWithoutPositionUpdateInput"] | undefined
};
	["TimetableShiftGroupWithoutPositionUpdateInput"]: {
		order?: number | undefined,
	shifts?: Array<GraphQLTypes["TimetableShiftGroupUpdateShiftsEntityRelationInput"]> | undefined,
	day?: GraphQLTypes["TimetableShiftGroupUpdateDayEntityRelationInput"] | undefined,
	type?: GraphQLTypes["TimetableShiftGroupUpdateTypeEntityRelationInput"] | undefined,
	queue?: GraphQLTypes["TimetableShiftGroupUpdateQueueEntityRelationInput"] | undefined,
	generatedByTemplate?: GraphQLTypes["TimetableShiftGroupUpdateGeneratedByTemplateEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableShiftGroupUpdateQueueEntityRelationInput"]: {
		create?: GraphQLTypes["EmployeeQueueWithoutShiftGroupCreateInput"] | undefined,
	update?: GraphQLTypes["EmployeeQueueWithoutShiftGroupUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TimetableShiftGroupUpsertQueueRelationInput"] | undefined,
	connect?: GraphQLTypes["EmployeeQueueUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["EmployeeQueueWithoutShiftGroupUpdateInput"]: {
		items?: Array<GraphQLTypes["EmployeeQueueUpdateItemsEntityRelationInput"]> | undefined,
	contemberBugFix?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["EmployeeQueueUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["EmployeeQueueItemWithoutQueueCreateInput"] | undefined,
	update?: GraphQLTypes["EmployeeQueueUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["EmployeeQueueUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["EmployeeQueueItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["EmployeeQueueItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["EmployeeQueueItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["EmployeeQueueUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["EmployeeQueueItemUniqueWhere"] | undefined,
	data?: GraphQLTypes["EmployeeQueueItemWithoutQueueUpdateInput"] | undefined
};
	["EmployeeQueueItemWithoutQueueUpdateInput"]: {
		start?: string | undefined,
	end?: string | undefined,
	shiftsProfile?: GraphQLTypes["EmployeeQueueItemUpdateShiftsProfileEntityRelationInput"] | undefined,
	shift?: GraphQLTypes["EmployeeQueueItemUpdateShiftEntityRelationInput"] | undefined,
	unassignInfo?: GraphQLTypes["EmployeeQueueItemUpdateUnassignInfoEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["EmployeeQueueItemUpdateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["EmployeeQueueItemUpdateShiftsProfileEntityRelationInput"]: {
		create?: GraphQLTypes["ShiftsProfileWithoutQueueItemsCreateInput"] | undefined,
	update?: GraphQLTypes["ShiftsProfileWithoutQueueItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["EmployeeQueueItemUpsertShiftsProfileRelationInput"] | undefined,
	connect?: GraphQLTypes["ShiftsProfileUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["ShiftsProfileWithoutQueueItemsUpdateInput"]: {
		staff?: GraphQLTypes["ShiftsProfileUpdateStaffEntityRelationInput"] | undefined,
	roles?: Array<GraphQLTypes["ShiftsProfileUpdateRolesEntityRelationInput"]> | undefined,
	shifts?: Array<GraphQLTypes["ShiftsProfileUpdateShiftsEntityRelationInput"]> | undefined,
	allowSelfUnassigning?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ShiftsProfileUpdateShiftsEntityRelationInput"]: {
		create?: GraphQLTypes["TimetableShiftWithoutShiftsProfileCreateInput"] | undefined,
	update?: GraphQLTypes["ShiftsProfileUpdateShiftsRelationInput"] | undefined,
	upsert?: GraphQLTypes["ShiftsProfileUpsertShiftsRelationInput"] | undefined,
	connect?: GraphQLTypes["TimetableShiftUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TimetableShiftUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TimetableShiftUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ShiftsProfileUpdateShiftsRelationInput"]: {
		by?: GraphQLTypes["TimetableShiftUniqueWhere"] | undefined,
	data?: GraphQLTypes["TimetableShiftWithoutShiftsProfileUpdateInput"] | undefined
};
	["TimetableShiftWithoutShiftsProfileUpdateInput"]: {
		locked?: boolean | undefined,
	order?: number | undefined,
	assigned?: GraphQLTypes["Date"] | undefined,
	group?: GraphQLTypes["TimetableShiftUpdateGroupEntityRelationInput"] | undefined,
	queueItem?: GraphQLTypes["TimetableShiftUpdateQueueItemEntityRelationInput"] | undefined,
	swapInfo?: GraphQLTypes["TimetableShiftUpdateSwapInfoEntityRelationInput"] | undefined,
	isOvertime?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableShiftUpdateGroupEntityRelationInput"]: {
		create?: GraphQLTypes["TimetableShiftGroupWithoutShiftsCreateInput"] | undefined,
	update?: GraphQLTypes["TimetableShiftGroupWithoutShiftsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TimetableShiftUpsertGroupRelationInput"] | undefined,
	connect?: GraphQLTypes["TimetableShiftGroupUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TimetableShiftGroupWithoutShiftsUpdateInput"]: {
		order?: number | undefined,
	day?: GraphQLTypes["TimetableShiftGroupUpdateDayEntityRelationInput"] | undefined,
	type?: GraphQLTypes["TimetableShiftGroupUpdateTypeEntityRelationInput"] | undefined,
	position?: GraphQLTypes["TimetableShiftGroupUpdatePositionEntityRelationInput"] | undefined,
	queue?: GraphQLTypes["TimetableShiftGroupUpdateQueueEntityRelationInput"] | undefined,
	generatedByTemplate?: GraphQLTypes["TimetableShiftGroupUpdateGeneratedByTemplateEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableShiftGroupUpdatePositionEntityRelationInput"]: {
		create?: GraphQLTypes["TimetableShiftPositionWithoutShiftGroupsCreateInput"] | undefined,
	update?: GraphQLTypes["TimetableShiftPositionWithoutShiftGroupsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TimetableShiftGroupUpsertPositionRelationInput"] | undefined,
	connect?: GraphQLTypes["TimetableShiftPositionUniqueWhere"] | undefined
};
	["TimetableShiftPositionWithoutShiftGroupsUpdateInput"]: {
		name?: string | undefined,
	start?: string | undefined,
	end?: string | undefined,
	timetableTemplates?: Array<GraphQLTypes["TimetableShiftPositionUpdateTimetableTemplatesEntityRelationInput"]> | undefined,
	isDynamic?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableShiftPositionUpdateTimetableTemplatesEntityRelationInput"]: {
		create?: GraphQLTypes["TimetableTemplateWithoutPositionCreateInput"] | undefined,
	update?: GraphQLTypes["TimetableShiftPositionUpdateTimetableTemplatesRelationInput"] | undefined,
	upsert?: GraphQLTypes["TimetableShiftPositionUpsertTimetableTemplatesRelationInput"] | undefined,
	connect?: GraphQLTypes["TimetableTemplateUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TimetableTemplateUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TimetableTemplateUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TimetableShiftPositionUpdateTimetableTemplatesRelationInput"]: {
		by?: GraphQLTypes["TimetableTemplateUniqueWhere"] | undefined,
	data?: GraphQLTypes["TimetableTemplateWithoutPositionUpdateInput"] | undefined
};
	["TimetableTemplateWithoutPositionUpdateInput"]: {
		order?: number | undefined,
	startDate?: GraphQLTypes["Date"] | undefined,
	period?: number | undefined,
	slots?: number | undefined,
	staffOptions?: Array<GraphQLTypes["TimetableTemplateUpdateStaffOptionsEntityRelationInput"]> | undefined,
	internalName?: string | undefined,
	venue?: GraphQLTypes["TimetableTemplateUpdateVenueEntityRelationInput"] | undefined,
	employeeRole?: GraphQLTypes["TimetableTemplateUpdateEmployeeRoleEntityRelationInput"] | undefined,
	workdaysOnly?: boolean | undefined,
	monday?: boolean | undefined,
	tuesday?: boolean | undefined,
	wednesday?: boolean | undefined,
	thursday?: boolean | undefined,
	friday?: boolean | undefined,
	saturday?: boolean | undefined,
	sunday?: boolean | undefined,
	type?: GraphQLTypes["TemplateType"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableTemplateUpdateStaffOptionsEntityRelationInput"]: {
		create?: GraphQLTypes["TimetableTemplateStaffOptionsWithoutTimetableTemplateCreateInput"] | undefined,
	update?: GraphQLTypes["TimetableTemplateUpdateStaffOptionsRelationInput"] | undefined,
	upsert?: GraphQLTypes["TimetableTemplateUpsertStaffOptionsRelationInput"] | undefined,
	connect?: GraphQLTypes["TimetableTemplateStaffOptionsUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TimetableTemplateStaffOptionsUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TimetableTemplateStaffOptionsUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TimetableTemplateUpdateStaffOptionsRelationInput"]: {
		by?: GraphQLTypes["TimetableTemplateStaffOptionsUniqueWhere"] | undefined,
	data?: GraphQLTypes["TimetableTemplateStaffOptionsWithoutTimetableTemplateUpdateInput"] | undefined
};
	["TimetableTemplateStaffOptionsWithoutTimetableTemplateUpdateInput"]: {
		startTime?: string | undefined,
	endTime?: string | undefined,
	autoAssignedEmployee?: GraphQLTypes["TimetableTemplateStaffOptionsUpdateAutoAssignedEmployeeEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableTemplateStaffOptionsUpdateAutoAssignedEmployeeEntityRelationInput"]: {
		create?: GraphQLTypes["ShiftsProfileCreateInput"] | undefined,
	update?: GraphQLTypes["ShiftsProfileUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TimetableTemplateStaffOptionsUpsertAutoAssignedEmployeeRelationInput"] | undefined,
	connect?: GraphQLTypes["ShiftsProfileUniqueWhere"] | undefined
};
	["ShiftsProfileUpdateInput"]: {
		queueItems?: Array<GraphQLTypes["ShiftsProfileUpdateQueueItemsEntityRelationInput"]> | undefined,
	staff?: GraphQLTypes["ShiftsProfileUpdateStaffEntityRelationInput"] | undefined,
	roles?: Array<GraphQLTypes["ShiftsProfileUpdateRolesEntityRelationInput"]> | undefined,
	shifts?: Array<GraphQLTypes["ShiftsProfileUpdateShiftsEntityRelationInput"]> | undefined,
	allowSelfUnassigning?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableTemplateStaffOptionsUpsertAutoAssignedEmployeeRelationInput"]: {
		update?: GraphQLTypes["ShiftsProfileUpdateInput"] | undefined,
	create?: GraphQLTypes["ShiftsProfileCreateInput"] | undefined
};
	["TimetableTemplateUpsertStaffOptionsRelationInput"]: {
		by?: GraphQLTypes["TimetableTemplateStaffOptionsUniqueWhere"] | undefined,
	update?: GraphQLTypes["TimetableTemplateStaffOptionsWithoutTimetableTemplateUpdateInput"] | undefined,
	create?: GraphQLTypes["TimetableTemplateStaffOptionsWithoutTimetableTemplateCreateInput"] | undefined
};
	["TimetableTemplateUpdateVenueEntityRelationInput"]: {
		create?: GraphQLTypes["VenueWithoutTimetableTemplatesCreateInput"] | undefined,
	update?: GraphQLTypes["VenueWithoutTimetableTemplatesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TimetableTemplateUpsertVenueRelationInput"] | undefined,
	connect?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["VenueWithoutTimetableTemplatesUpdateInput"]: {
		name?: string | undefined,
	deadlineTemplate?: GraphQLTypes["VenueUpdateDeadlineTemplateEntityRelationInput"] | undefined,
	timetableDays?: Array<GraphQLTypes["VenueUpdateTimetableDaysEntityRelationInput"]> | undefined,
	staffMembers?: Array<GraphQLTypes["VenueUpdateStaffMembersEntityRelationInput"]> | undefined,
	employeeRoles?: Array<GraphQLTypes["VenueUpdateEmployeeRolesEntityRelationInput"]> | undefined,
	pointOfSaleApplicationDevices?: Array<GraphQLTypes["VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined,
	pointOfSaleTerminals?: Array<GraphQLTypes["VenueUpdatePointOfSaleTerminalsEntityRelationInput"]> | undefined,
	pointOfSalePrinters?: Array<GraphQLTypes["VenueUpdatePointOfSalePrintersEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["VenueUpdateOrdersEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["VenueUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	areas?: Array<GraphQLTypes["VenueUpdateAreasEntityRelationInput"]> | undefined,
	enabledUnassignReasons?: Array<GraphQLTypes["VenueUpdateEnabledUnassignReasonsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["VenueUpdateCategoriesEntityRelationInput"]> | undefined,
	channels?: Array<GraphQLTypes["VenueUpdateChannelsEntityRelationInput"]> | undefined,
	address?: string | undefined,
	pointOfSalePngBase64ReceiptLogo?: string | undefined,
	pointOfSaleInitialView?: GraphQLTypes["PointOfSaleInitialView"] | undefined,
	pointOfSalePreferPrintReceipt?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["VenueUpdateStaffMembersEntityRelationInput"]: {
		create?: GraphQLTypes["StaffWithoutVenuesCreateInput"] | undefined,
	update?: GraphQLTypes["VenueUpdateStaffMembersRelationInput"] | undefined,
	upsert?: GraphQLTypes["VenueUpsertStaffMembersRelationInput"] | undefined,
	connect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	delete?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["VenueUpdateStaffMembersRelationInput"]: {
		by?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	data?: GraphQLTypes["StaffWithoutVenuesUpdateInput"] | undefined
};
	["StaffWithoutVenuesUpdateInput"]: {
		bartender?: GraphQLTypes["StaffUpdateBartenderEntityRelationInput"] | undefined,
	courier?: GraphQLTypes["StaffUpdateCourierEntityRelationInput"] | undefined,
	cleaner?: GraphQLTypes["StaffUpdateCleanerEntityRelationInput"] | undefined,
	shiftsManager?: GraphQLTypes["StaffUpdateShiftsManagerEntityRelationInput"] | undefined,
	businessToBusinessManager?: GraphQLTypes["StaffUpdateBusinessToBusinessManagerEntityRelationInput"] | undefined,
	user?: GraphQLTypes["StaffUpdateUserEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["StaffUpdateShiftsProfileEntityRelationInput"] | undefined,
	stocksManager?: GraphQLTypes["StaffUpdateStocksManagerEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["StaffUpdatePhotoEntityRelationInput"] | undefined,
	courierManager?: GraphQLTypes["StaffUpdateCourierManagerEntityRelationInput"] | undefined,
	picker?: GraphQLTypes["StaffUpdatePickerEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	remunerationProfile?: GraphQLTypes["StaffUpdateRemunerationProfileEntityRelationInput"] | undefined,
	cashier?: GraphQLTypes["StaffUpdateCashierEntityRelationInput"] | undefined,
	internalBuyer?: GraphQLTypes["StaffUpdateInternalBuyerEntityRelationInput"] | undefined,
	salesManager?: GraphQLTypes["StaffUpdateSalesManagerEntityRelationInput"] | undefined,
	cashierManager?: GraphQLTypes["StaffUpdateCashierManagerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StaffUpdatePhotoEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["StaffUpsertPhotoRelationInput"] | undefined,
	connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["StaffUpsertPhotoRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["StaffUpdateCourierManagerEntityRelationInput"]: {
		create?: GraphQLTypes["CourierManagerWithoutStaffCreateInput"] | undefined,
	update?: GraphQLTypes["CourierManagerWithoutStaffUpdateInput"] | undefined,
	upsert?: GraphQLTypes["StaffUpsertCourierManagerRelationInput"] | undefined,
	connect?: GraphQLTypes["CourierManagerUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CourierManagerWithoutStaffUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StaffUpsertCourierManagerRelationInput"]: {
		update?: GraphQLTypes["CourierManagerWithoutStaffUpdateInput"] | undefined,
	create?: GraphQLTypes["CourierManagerWithoutStaffCreateInput"] | undefined
};
	["StaffUpdatePickerEntityRelationInput"]: {
		create?: GraphQLTypes["PickerWithoutStaffCreateInput"] | undefined,
	update?: GraphQLTypes["PickerWithoutStaffUpdateInput"] | undefined,
	upsert?: GraphQLTypes["StaffUpsertPickerRelationInput"] | undefined,
	connect?: GraphQLTypes["PickerUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PickerWithoutStaffUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StaffUpsertPickerRelationInput"]: {
		update?: GraphQLTypes["PickerWithoutStaffUpdateInput"] | undefined,
	create?: GraphQLTypes["PickerWithoutStaffCreateInput"] | undefined
};
	["StaffUpdateRemunerationProfileEntityRelationInput"]: {
		create?: GraphQLTypes["RemunerationProfileWithoutStaffCreateInput"] | undefined,
	update?: GraphQLTypes["RemunerationProfileWithoutStaffUpdateInput"] | undefined,
	upsert?: GraphQLTypes["StaffUpsertRemunerationProfileRelationInput"] | undefined,
	connect?: GraphQLTypes["RemunerationProfileUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["RemunerationProfileWithoutStaffUpdateInput"]: {
		employmentInformation?: Array<GraphQLTypes["RemunerationProfileUpdateEmploymentInformationEntityRelationInput"]> | undefined,
	workMonths?: GraphQLTypes["RemunerationProfileUpdateWorkMonthsEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RemunerationProfileUpdateEmploymentInformationEntityRelationInput"]: {
		create?: GraphQLTypes["EmploymentInformationWithoutRemunerationProfilesCreateInput"] | undefined,
	update?: GraphQLTypes["RemunerationProfileUpdateEmploymentInformationRelationInput"] | undefined,
	upsert?: GraphQLTypes["RemunerationProfileUpsertEmploymentInformationRelationInput"] | undefined,
	connect?: GraphQLTypes["EmploymentInformationUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["EmploymentInformationUniqueWhere"] | undefined,
	delete?: GraphQLTypes["EmploymentInformationUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["RemunerationProfileUpdateEmploymentInformationRelationInput"]: {
		by?: GraphQLTypes["EmploymentInformationUniqueWhere"] | undefined,
	data?: GraphQLTypes["EmploymentInformationWithoutRemunerationProfilesUpdateInput"] | undefined
};
	["EmploymentInformationWithoutRemunerationProfilesUpdateInput"]: {
		hourlyRate?: number | undefined,
	monthlySalary?: number | undefined,
	type?: GraphQLTypes["EmploymentType"] | undefined,
	name?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["RemunerationProfileUpsertEmploymentInformationRelationInput"]: {
		by?: GraphQLTypes["EmploymentInformationUniqueWhere"] | undefined,
	update?: GraphQLTypes["EmploymentInformationWithoutRemunerationProfilesUpdateInput"] | undefined,
	create?: GraphQLTypes["EmploymentInformationWithoutRemunerationProfilesCreateInput"] | undefined
};
	["RemunerationProfileUpdateWorkMonthsEntityRelationInput"]: {
		create?: GraphQLTypes["WorkMonthWithoutRemunerationProfileCreateInput"] | undefined,
	update?: GraphQLTypes["WorkMonthWithoutRemunerationProfileUpdateInput"] | undefined,
	upsert?: GraphQLTypes["RemunerationProfileUpsertWorkMonthsRelationInput"] | undefined,
	connect?: GraphQLTypes["WorkMonthUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["WorkMonthWithoutRemunerationProfileUpdateInput"]: {
		year?: number | undefined,
	month?: number | undefined,
	hoursWorked?: number | undefined,
	billableHours?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["RemunerationProfileUpsertWorkMonthsRelationInput"]: {
		update?: GraphQLTypes["WorkMonthWithoutRemunerationProfileUpdateInput"] | undefined,
	create?: GraphQLTypes["WorkMonthWithoutRemunerationProfileCreateInput"] | undefined
};
	["StaffUpsertRemunerationProfileRelationInput"]: {
		update?: GraphQLTypes["RemunerationProfileWithoutStaffUpdateInput"] | undefined,
	create?: GraphQLTypes["RemunerationProfileWithoutStaffCreateInput"] | undefined
};
	["StaffUpdateCashierEntityRelationInput"]: {
		create?: GraphQLTypes["CashierWithoutStaffCreateInput"] | undefined,
	update?: GraphQLTypes["CashierWithoutStaffUpdateInput"] | undefined,
	upsert?: GraphQLTypes["StaffUpsertCashierRelationInput"] | undefined,
	connect?: GraphQLTypes["CashierUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CashierWithoutStaffUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StaffUpsertCashierRelationInput"]: {
		update?: GraphQLTypes["CashierWithoutStaffUpdateInput"] | undefined,
	create?: GraphQLTypes["CashierWithoutStaffCreateInput"] | undefined
};
	["StaffUpdateInternalBuyerEntityRelationInput"]: {
		create?: GraphQLTypes["InternalBuyerWithoutStaffCreateInput"] | undefined,
	update?: GraphQLTypes["InternalBuyerWithoutStaffUpdateInput"] | undefined,
	upsert?: GraphQLTypes["StaffUpsertInternalBuyerRelationInput"] | undefined,
	connect?: GraphQLTypes["InternalBuyerUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["InternalBuyerWithoutStaffUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StaffUpsertInternalBuyerRelationInput"]: {
		update?: GraphQLTypes["InternalBuyerWithoutStaffUpdateInput"] | undefined,
	create?: GraphQLTypes["InternalBuyerWithoutStaffCreateInput"] | undefined
};
	["StaffUpdateSalesManagerEntityRelationInput"]: {
		create?: GraphQLTypes["SalesManagerWithoutStaffCreateInput"] | undefined,
	update?: GraphQLTypes["SalesManagerWithoutStaffUpdateInput"] | undefined,
	upsert?: GraphQLTypes["StaffUpsertSalesManagerRelationInput"] | undefined,
	connect?: GraphQLTypes["SalesManagerUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["SalesManagerWithoutStaffUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	countries?: Array<GraphQLTypes["SalesManagerUpdateCountriesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["SalesManagerUpdateCountriesEntityRelationInput"]: {
		create?: GraphQLTypes["CountryCreateInput"] | undefined,
	update?: GraphQLTypes["SalesManagerUpdateCountriesRelationInput"] | undefined,
	upsert?: GraphQLTypes["SalesManagerUpsertCountriesRelationInput"] | undefined,
	connect?: GraphQLTypes["CountryUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["CountryUniqueWhere"] | undefined,
	delete?: GraphQLTypes["CountryUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["SalesManagerUpdateCountriesRelationInput"]: {
		by?: GraphQLTypes["CountryUniqueWhere"] | undefined,
	data?: GraphQLTypes["CountryUpdateInput"] | undefined
};
	["SalesManagerUpsertCountriesRelationInput"]: {
		by?: GraphQLTypes["CountryUniqueWhere"] | undefined,
	update?: GraphQLTypes["CountryUpdateInput"] | undefined,
	create?: GraphQLTypes["CountryCreateInput"] | undefined
};
	["StaffUpsertSalesManagerRelationInput"]: {
		update?: GraphQLTypes["SalesManagerWithoutStaffUpdateInput"] | undefined,
	create?: GraphQLTypes["SalesManagerWithoutStaffCreateInput"] | undefined
};
	["StaffUpdateCashierManagerEntityRelationInput"]: {
		create?: GraphQLTypes["CashierManagerWithoutStaffCreateInput"] | undefined,
	update?: GraphQLTypes["CashierManagerWithoutStaffUpdateInput"] | undefined,
	upsert?: GraphQLTypes["StaffUpsertCashierManagerRelationInput"] | undefined,
	connect?: GraphQLTypes["CashierManagerUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CashierManagerWithoutStaffUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StaffUpsertCashierManagerRelationInput"]: {
		update?: GraphQLTypes["CashierManagerWithoutStaffUpdateInput"] | undefined,
	create?: GraphQLTypes["CashierManagerWithoutStaffCreateInput"] | undefined
};
	["VenueUpsertStaffMembersRelationInput"]: {
		by?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	update?: GraphQLTypes["StaffWithoutVenuesUpdateInput"] | undefined,
	create?: GraphQLTypes["StaffWithoutVenuesCreateInput"] | undefined
};
	["VenueUpdateEmployeeRolesEntityRelationInput"]: {
		create?: GraphQLTypes["VenueEmployeeRoleWithoutVenueCreateInput"] | undefined,
	update?: GraphQLTypes["VenueUpdateEmployeeRolesRelationInput"] | undefined,
	upsert?: GraphQLTypes["VenueUpsertEmployeeRolesRelationInput"] | undefined,
	connect?: GraphQLTypes["VenueEmployeeRoleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["VenueEmployeeRoleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["VenueEmployeeRoleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["VenueUpdateEmployeeRolesRelationInput"]: {
		by?: GraphQLTypes["VenueEmployeeRoleUniqueWhere"] | undefined,
	data?: GraphQLTypes["VenueEmployeeRoleWithoutVenueUpdateInput"] | undefined
};
	["VenueEmployeeRoleWithoutVenueUpdateInput"]: {
		order?: number | undefined,
	employeePrivileges?: GraphQLTypes["VenueEmployeeRoleUpdateEmployeePrivilegesEntityRelationInput"] | undefined,
	role?: GraphQLTypes["VenueEmployeeRoleUpdateRoleEntityRelationInput"] | undefined,
	getsTipsShare?: boolean | undefined,
	notesEnabled?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["VenueEmployeeRoleUpdateEmployeePrivilegesEntityRelationInput"]: {
		create?: GraphQLTypes["TimetablesEmployeePrivilegesWithoutVenueEmployeeRoleCreateInput"] | undefined,
	update?: GraphQLTypes["TimetablesEmployeePrivilegesWithoutVenueEmployeeRoleUpdateInput"] | undefined,
	upsert?: GraphQLTypes["VenueEmployeeRoleUpsertEmployeePrivilegesRelationInput"] | undefined,
	connect?: GraphQLTypes["TimetablesEmployeePrivilegesUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TimetablesEmployeePrivilegesWithoutVenueEmployeeRoleUpdateInput"]: {
		read?: boolean | undefined,
	unassign?: boolean | undefined,
	assign?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["VenueEmployeeRoleUpsertEmployeePrivilegesRelationInput"]: {
		update?: GraphQLTypes["TimetablesEmployeePrivilegesWithoutVenueEmployeeRoleUpdateInput"] | undefined,
	create?: GraphQLTypes["TimetablesEmployeePrivilegesWithoutVenueEmployeeRoleCreateInput"] | undefined
};
	["VenueEmployeeRoleUpdateRoleEntityRelationInput"]: {
		create?: GraphQLTypes["TimetableEmployeeRoleCreateInput"] | undefined,
	update?: GraphQLTypes["TimetableEmployeeRoleUpdateInput"] | undefined,
	upsert?: GraphQLTypes["VenueEmployeeRoleUpsertRoleRelationInput"] | undefined,
	connect?: GraphQLTypes["TimetableEmployeeRoleUniqueWhere"] | undefined
};
	["VenueEmployeeRoleUpsertRoleRelationInput"]: {
		update?: GraphQLTypes["TimetableEmployeeRoleUpdateInput"] | undefined,
	create?: GraphQLTypes["TimetableEmployeeRoleCreateInput"] | undefined
};
	["VenueUpsertEmployeeRolesRelationInput"]: {
		by?: GraphQLTypes["VenueEmployeeRoleUniqueWhere"] | undefined,
	update?: GraphQLTypes["VenueEmployeeRoleWithoutVenueUpdateInput"] | undefined,
	create?: GraphQLTypes["VenueEmployeeRoleWithoutVenueCreateInput"] | undefined
};
	["VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput"]: {
		create?: GraphQLTypes["PointOfSaleApplicationDeviceWithoutVenueCreateInput"] | undefined,
	update?: GraphQLTypes["VenueUpdatePointOfSaleApplicationDevicesRelationInput"] | undefined,
	upsert?: GraphQLTypes["VenueUpsertPointOfSaleApplicationDevicesRelationInput"] | undefined,
	connect?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["VenueUpdatePointOfSaleApplicationDevicesRelationInput"]: {
		by?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined,
	data?: GraphQLTypes["PointOfSaleApplicationDeviceWithoutVenueUpdateInput"] | undefined
};
	["PointOfSaleApplicationDeviceWithoutVenueUpdateInput"]: {
		internalName?: string | undefined,
	note?: string | undefined,
	identificationCode?: GraphQLTypes["PointOfSaleApplicationDeviceUpdateIdentificationCodeEntityRelationInput"] | undefined,
	identifier?: GraphQLTypes["PointOfSaleApplicationDeviceUpdateIdentifierEntityRelationInput"] | undefined,
	terminal?: GraphQLTypes["PointOfSaleApplicationDeviceUpdateTerminalEntityRelationInput"] | undefined,
	receiptPrinter?: GraphQLTypes["PointOfSaleApplicationDeviceUpdateReceiptPrinterEntityRelationInput"] | undefined,
	ticketPrinters?: Array<GraphQLTypes["PointOfSaleApplicationDeviceUpdateTicketPrintersEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleApplicationDeviceUpdateIdentificationCodeEntityRelationInput"]: {
		create?: GraphQLTypes["IdentificationCodeWithoutApplicationDevicesCreateInput"] | undefined,
	update?: GraphQLTypes["IdentificationCodeWithoutApplicationDevicesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PointOfSaleApplicationDeviceUpsertIdentificationCodeRelationInput"] | undefined,
	connect?: GraphQLTypes["IdentificationCodeUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["IdentificationCodeWithoutApplicationDevicesUpdateInput"]: {
		code?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	attempts?: Array<GraphQLTypes["IdentificationCodeUpdateAttemptsEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["IdentificationCodeUpdateLocalesEntityRelationInput"]> | undefined,
	internalName?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["IdentificationCodeUpdateAttemptsEntityRelationInput"]: {
		create?: GraphQLTypes["IdentificationAttemptWithoutCodeCreateInput"] | undefined,
	update?: GraphQLTypes["IdentificationCodeUpdateAttemptsRelationInput"] | undefined,
	upsert?: GraphQLTypes["IdentificationCodeUpsertAttemptsRelationInput"] | undefined,
	connect?: GraphQLTypes["IdentificationAttemptUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["IdentificationAttemptUniqueWhere"] | undefined,
	delete?: GraphQLTypes["IdentificationAttemptUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["IdentificationCodeUpdateAttemptsRelationInput"]: {
		by?: GraphQLTypes["IdentificationAttemptUniqueWhere"] | undefined,
	data?: GraphQLTypes["IdentificationAttemptWithoutCodeUpdateInput"] | undefined
};
	["IdentificationAttemptWithoutCodeUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	user?: GraphQLTypes["IdentificationAttemptUpdateUserEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["IdentificationAttemptUpdateUserEntityRelationInput"]: {
		create?: GraphQLTypes["UserWithoutIdentificationAttemptsCreateInput"] | undefined,
	update?: GraphQLTypes["UserWithoutIdentificationAttemptsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["IdentificationAttemptUpsertUserRelationInput"] | undefined,
	connect?: GraphQLTypes["UserUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["UserWithoutIdentificationAttemptsUpdateInput"]: {
		name?: string | undefined,
	internalNote?: string | undefined,
	staff?: GraphQLTypes["UserUpdateStaffEntityRelationInput"] | undefined,
	customer?: GraphQLTypes["UserUpdateCustomerEntityRelationInput"] | undefined,
	tenantPersonId?: GraphQLTypes["UUID"] | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	devices?: Array<GraphQLTypes["UserUpdateDevicesEntityRelationInput"]> | undefined,
	verifiedAt?: GraphQLTypes["DateTime"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	deletionRequestedAt?: GraphQLTypes["DateTime"] | undefined,
	deletionExpectedAt?: GraphQLTypes["DateTime"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	meta?: GraphQLTypes["UserUpdateMetaEntityRelationInput"] | undefined,
	roles?: GraphQLTypes["UserUpdateRolesEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserUpdateDevicesEntityRelationInput"]: {
		create?: GraphQLTypes["UserDeviceWithoutUserCreateInput"] | undefined,
	update?: GraphQLTypes["UserUpdateDevicesRelationInput"] | undefined,
	upsert?: GraphQLTypes["UserUpsertDevicesRelationInput"] | undefined,
	connect?: GraphQLTypes["UserDeviceUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["UserDeviceUniqueWhere"] | undefined,
	delete?: GraphQLTypes["UserDeviceUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["UserUpdateDevicesRelationInput"]: {
		by?: GraphQLTypes["UserDeviceUniqueWhere"] | undefined,
	data?: GraphQLTypes["UserDeviceWithoutUserUpdateInput"] | undefined
};
	["UserDeviceWithoutUserUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	lastActiveAt?: GraphQLTypes["DateTime"] | undefined,
	platform?: string | undefined,
	deviceId?: string | undefined,
	notificationsEnabled?: boolean | undefined,
	appVersion?: string | undefined,
	osVersion?: string | undefined,
	apiVersion?: string | undefined,
	anonymousSession?: GraphQLTypes["UserDeviceUpdateAnonymousSessionEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserDeviceUpdateAnonymousSessionEntityRelationInput"]: {
		create?: GraphQLTypes["AnonymousSessionWithoutDevicesCreateInput"] | undefined,
	update?: GraphQLTypes["AnonymousSessionWithoutDevicesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["UserDeviceUpsertAnonymousSessionRelationInput"] | undefined,
	connect?: GraphQLTypes["AnonymousSessionUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["AnonymousSessionWithoutDevicesUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	lastActiveAt?: GraphQLTypes["DateTime"] | undefined,
	anonymousSessionKey?: string | undefined,
	email?: string | undefined,
	name?: string | undefined,
	internalNote?: string | undefined,
	customer?: GraphQLTypes["AnonymousSessionUpdateCustomerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["AnonymousSessionUpdateCustomerEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerWithoutAnonymousSessionCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerWithoutAnonymousSessionUpdateInput"] | undefined,
	upsert?: GraphQLTypes["AnonymousSessionUpsertCustomerRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CustomerWithoutAnonymousSessionUpdateInput"]: {
		addresses?: Array<GraphQLTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerUpdateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerUpdateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerUpdateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerUpdateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerUpdateInvoicesEntityRelationInput"]: {
		create?: GraphQLTypes["InvoiceWithoutCustomerCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerUpdateInvoicesRelationInput"] | undefined,
	upsert?: GraphQLTypes["CustomerUpsertInvoicesRelationInput"] | undefined,
	connect?: GraphQLTypes["InvoiceUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["InvoiceUniqueWhere"] | undefined,
	delete?: GraphQLTypes["InvoiceUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CustomerUpdateInvoicesRelationInput"]: {
		by?: GraphQLTypes["InvoiceUniqueWhere"] | undefined,
	data?: GraphQLTypes["InvoiceWithoutCustomerUpdateInput"] | undefined
};
	["InvoiceWithoutCustomerUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	publicKey?: string | undefined,
	fakturoidId?: string | undefined,
	fakturoidData?: string | undefined,
	legacyUrl?: string | undefined,
	orderPayments?: Array<GraphQLTypes["InvoiceUpdateOrderPaymentsEntityRelationInput"]> | undefined,
	address?: GraphQLTypes["InvoiceUpdateAddressEntityRelationInput"] | undefined,
	publicUrl?: string | undefined,
	billingSubject?: GraphQLTypes["InvoiceUpdateBillingSubjectEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InvoiceUpdateOrderPaymentsEntityRelationInput"]: {
		create?: GraphQLTypes["OrderPaymentWithoutInvoiceCreateInput"] | undefined,
	update?: GraphQLTypes["InvoiceUpdateOrderPaymentsRelationInput"] | undefined,
	upsert?: GraphQLTypes["InvoiceUpsertOrderPaymentsRelationInput"] | undefined,
	connect?: GraphQLTypes["OrderPaymentUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["OrderPaymentUniqueWhere"] | undefined,
	delete?: GraphQLTypes["OrderPaymentUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["InvoiceUpdateOrderPaymentsRelationInput"]: {
		by?: GraphQLTypes["OrderPaymentUniqueWhere"] | undefined,
	data?: GraphQLTypes["OrderPaymentWithoutInvoiceUpdateInput"] | undefined
};
	["OrderPaymentWithoutInvoiceUpdateInput"]: {
		data?: GraphQLTypes["Json"] | undefined,
	paymentCents?: number | undefined,
	method?: GraphQLTypes["OrderPaymentUpdateMethodEntityRelationInput"] | undefined,
	failedAt?: GraphQLTypes["DateTime"] | undefined,
	state?: GraphQLTypes["OrderPaymentState"] | undefined,
	approvedAt?: GraphQLTypes["DateTime"] | undefined,
	events?: Array<GraphQLTypes["OrderPaymentUpdateEventsEntityRelationInput"]> | undefined,
	order?: GraphQLTypes["OrderPaymentUpdateOrderEntityRelationInput"] | undefined,
	walletType?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	publicReceiptUrl?: string | undefined,
	priceCents?: number | undefined,
	vatRate?: GraphQLTypes["OrderPaymentUpdateVatRateEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["OrderPaymentUpdateMetaEntityRelationInput"] | undefined,
	otherCurrencyPriceCents?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderPaymentUpdateMethodEntityRelationInput"]: {
		create?: GraphQLTypes["PaymentMethodCreateInput"] | undefined,
	update?: GraphQLTypes["PaymentMethodUpdateInput"] | undefined,
	upsert?: GraphQLTypes["OrderPaymentUpsertMethodRelationInput"] | undefined,
	connect?: GraphQLTypes["PaymentMethodUniqueWhere"] | undefined
};
	["OrderPaymentUpsertMethodRelationInput"]: {
		update?: GraphQLTypes["PaymentMethodUpdateInput"] | undefined,
	create?: GraphQLTypes["PaymentMethodCreateInput"] | undefined
};
	["OrderPaymentUpdateEventsEntityRelationInput"]: {
		create?: GraphQLTypes["OrderEventWithoutPaymentCreateInput"] | undefined,
	update?: GraphQLTypes["OrderPaymentUpdateEventsRelationInput"] | undefined,
	upsert?: GraphQLTypes["OrderPaymentUpsertEventsRelationInput"] | undefined,
	connect?: GraphQLTypes["OrderEventUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["OrderEventUniqueWhere"] | undefined,
	delete?: GraphQLTypes["OrderEventUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["OrderPaymentUpdateEventsRelationInput"]: {
		by?: GraphQLTypes["OrderEventUniqueWhere"] | undefined,
	data?: GraphQLTypes["OrderEventWithoutPaymentUpdateInput"] | undefined
};
	["OrderEventWithoutPaymentUpdateInput"]: {
		type?: string | undefined,
	data?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	order?: GraphQLTypes["OrderEventUpdateOrderEntityRelationInput"] | undefined,
	delivery?: GraphQLTypes["OrderEventUpdateDeliveryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderEventUpdateOrderEntityRelationInput"]: {
		create?: GraphQLTypes["OrderWithoutEventsCreateInput"] | undefined,
	update?: GraphQLTypes["OrderWithoutEventsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["OrderEventUpsertOrderRelationInput"] | undefined,
	connect?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["OrderWithoutEventsUpdateInput"]: {
		state?: GraphQLTypes["OrderState"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	canceledAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	customer?: GraphQLTypes["OrderUpdateCustomerEntityRelationInput"] | undefined,
	channel?: GraphQLTypes["OrderUpdateChannelEntityRelationInput"] | undefined,
	discounts?: Array<GraphQLTypes["OrderUpdateDiscountsEntityRelationInput"]> | undefined,
	delivery?: GraphQLTypes["OrderUpdateDeliveryEntityRelationInput"] | undefined,
	items?: Array<GraphQLTypes["OrderUpdateItemsEntityRelationInput"]> | undefined,
	internalNote?: string | undefined,
	cart?: GraphQLTypes["OrderUpdateCartEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddress?: GraphQLTypes["OrderUpdateBillingAddressEntityRelationInput"] | undefined,
	priceLines?: Array<GraphQLTypes["OrderUpdatePriceLinesEntityRelationInput"]> | undefined,
	payments?: Array<GraphQLTypes["OrderUpdatePaymentsEntityRelationInput"]> | undefined,
	seq?: number | undefined,
	billingSubject?: GraphQLTypes["OrderUpdateBillingSubjectEntityRelationInput"] | undefined,
	summary?: GraphQLTypes["OrderUpdateSummaryEntityRelationInput"] | undefined,
	doubleshotLegacyId?: string | undefined,
	gratuity?: GraphQLTypes["OrderUpdateGratuityEntityRelationInput"] | undefined,
	venue?: GraphQLTypes["OrderUpdateVenueEntityRelationInput"] | undefined,
	fulfillmentNote?: string | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["OrderUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	doubleshotTotalWeightGrams?: number | undefined,
	doubleShotLegacyNumber?: string | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	doubleshotAdminUrl?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderUpdateDeliveryEntityRelationInput"]: {
		create?: GraphQLTypes["OrderDeliveryWithoutOrderCreateInput"] | undefined,
	update?: GraphQLTypes["OrderDeliveryWithoutOrderUpdateInput"] | undefined,
	upsert?: GraphQLTypes["OrderUpsertDeliveryRelationInput"] | undefined,
	connect?: GraphQLTypes["OrderDeliveryUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["OrderDeliveryWithoutOrderUpdateInput"]: {
		priceCents?: number | undefined,
	deliveredAt?: GraphQLTypes["DateTime"] | undefined,
	method?: GraphQLTypes["OrderDeliveryUpdateMethodEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["OrderDeliveryUpdateVatRateEntityRelationInput"] | undefined,
	expectedAt?: GraphQLTypes["DateTime"] | undefined,
	state?: GraphQLTypes["OrderDeliveryState"] | undefined,
	loadingDurationHours?: number | undefined,
	dispatchAt?: GraphQLTypes["DateTime"] | undefined,
	duration?: string | undefined,
	window?: string | undefined,
	expectedEndAt?: GraphQLTypes["DateTime"] | undefined,
	processingAt?: GraphQLTypes["DateTime"] | undefined,
	deliveringAt?: GraphQLTypes["DateTime"] | undefined,
	failedAt?: GraphQLTypes["DateTime"] | undefined,
	internalNote?: string | undefined,
	deliveryWaypoint?: GraphQLTypes["OrderDeliveryUpdateDeliveryWaypointEntityRelationInput"] | undefined,
	events?: Array<GraphQLTypes["OrderDeliveryUpdateEventsEntityRelationInput"]> | undefined,
	prepareAt?: GraphQLTypes["DateTime"] | undefined,
	liftagoRide?: GraphQLTypes["OrderDeliveryUpdateLiftagoRideEntityRelationInput"] | undefined,
	pickedAt?: GraphQLTypes["DateTime"] | undefined,
	address?: GraphQLTypes["OrderDeliveryUpdateAddressEntityRelationInput"] | undefined,
	trackingCode?: string | undefined,
	woltDriveDelivery?: GraphQLTypes["OrderDeliveryUpdateWoltDriveDeliveryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderDeliveryUpdateVatRateEntityRelationInput"]: {
		create?: GraphQLTypes["VatRateCreateInput"] | undefined,
	update?: GraphQLTypes["VatRateUpdateInput"] | undefined,
	upsert?: GraphQLTypes["OrderDeliveryUpsertVatRateRelationInput"] | undefined,
	connect?: GraphQLTypes["VatRateUniqueWhere"] | undefined
};
	["OrderDeliveryUpsertVatRateRelationInput"]: {
		update?: GraphQLTypes["VatRateUpdateInput"] | undefined,
	create?: GraphQLTypes["VatRateCreateInput"] | undefined
};
	["OrderDeliveryUpdateDeliveryWaypointEntityRelationInput"]: {
		create?: GraphQLTypes["DeliveryWaypointWithoutDeliveryCreateInput"] | undefined,
	update?: GraphQLTypes["DeliveryWaypointWithoutDeliveryUpdateInput"] | undefined,
	upsert?: GraphQLTypes["OrderDeliveryUpsertDeliveryWaypointRelationInput"] | undefined,
	connect?: GraphQLTypes["DeliveryWaypointUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["DeliveryWaypointWithoutDeliveryUpdateInput"]: {
		estimatedArrival?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	route?: GraphQLTypes["DeliveryWaypointUpdateRouteEntityRelationInput"] | undefined,
	sortingOrder?: number | undefined,
	estimatedDistance?: number | undefined,
	estimatedDuration?: number | undefined,
	originDeparture?: GraphQLTypes["DateTime"] | undefined,
	originAddress?: string | undefined,
	transitMode?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryWaypointUpdateRouteEntityRelationInput"]: {
		create?: GraphQLTypes["DeliveryRouteWithoutWaypointsCreateInput"] | undefined,
	update?: GraphQLTypes["DeliveryRouteWithoutWaypointsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["DeliveryWaypointUpsertRouteRelationInput"] | undefined,
	connect?: GraphQLTypes["DeliveryRouteUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["DeliveryRouteWithoutWaypointsUpdateInput"]: {
		courier?: GraphQLTypes["DeliveryRouteUpdateCourierEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	dispatchAt?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryRouteUpdateCourierEntityRelationInput"]: {
		create?: GraphQLTypes["CourierWithoutRoutesCreateInput"] | undefined,
	update?: GraphQLTypes["CourierWithoutRoutesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["DeliveryRouteUpsertCourierRelationInput"] | undefined,
	connect?: GraphQLTypes["CourierUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CourierWithoutRoutesUpdateInput"]: {
		staff?: GraphQLTypes["CourierUpdateStaffEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	deliveryMethods?: Array<GraphQLTypes["CourierUpdateDeliveryMethodsEntityRelationInput"]> | undefined,
	showInPicker?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["CourierUpdateDeliveryMethodsEntityRelationInput"]: {
		create?: GraphQLTypes["DeliveryMethodWithoutCourierHandlersCreateInput"] | undefined,
	update?: GraphQLTypes["CourierUpdateDeliveryMethodsRelationInput"] | undefined,
	upsert?: GraphQLTypes["CourierUpsertDeliveryMethodsRelationInput"] | undefined,
	connect?: GraphQLTypes["DeliveryMethodUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["DeliveryMethodUniqueWhere"] | undefined,
	delete?: GraphQLTypes["DeliveryMethodUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CourierUpdateDeliveryMethodsRelationInput"]: {
		by?: GraphQLTypes["DeliveryMethodUniqueWhere"] | undefined,
	data?: GraphQLTypes["DeliveryMethodWithoutCourierHandlersUpdateInput"] | undefined
};
	["DeliveryMethodWithoutCourierHandlersUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	enabled?: boolean | undefined,
	paymentMethods?: Array<GraphQLTypes["DeliveryMethodUpdatePaymentMethodsEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	requireDeliveryAddress?: boolean | undefined,
	suitableForDeliveryZones?: Array<GraphQLTypes["DeliveryMethodUpdateSuitableForDeliveryZonesEntityRelationInput"]> | undefined,
	channels?: Array<GraphQLTypes["DeliveryMethodUpdateChannelsEntityRelationInput"]> | undefined,
	enableDeliveryTracking?: boolean | undefined,
	locales?: Array<GraphQLTypes["DeliveryMethodUpdateLocalesEntityRelationInput"]> | undefined,
	timelinePreset?: GraphQLTypes["DeliveryMethodUpdateTimelinePresetEntityRelationInput"] | undefined,
	woltDriveVenueId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryMethodUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["DeliveryMethodLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["DeliveryMethodUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["DeliveryMethodUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["DeliveryMethodLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["DeliveryMethodLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["DeliveryMethodLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["DeliveryMethodUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["DeliveryMethodLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["DeliveryMethodLocaleWithoutRootUpdateInput"] | undefined
};
	["DeliveryMethodLocaleWithoutRootUpdateInput"]: {
		name?: string | undefined,
	description?: string | undefined,
	trackingCodeUrlTemplate?: string | undefined,
	processingTitle?: string | undefined,
	processingText?: string | undefined,
	processingIconUrl?: string | undefined,
	dispatchedTitle?: string | undefined,
	dispatchedText?: string | undefined,
	dispatchedIconUrl?: string | undefined,
	fulfilledTitle?: string | undefined,
	fulfilledText?: string | undefined,
	fulfilledIconUrl?: string | undefined,
	locale?: GraphQLTypes["DeliveryMethodLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryMethodLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutDeliveryMethodsCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutDeliveryMethodsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["DeliveryMethodLocaleUpsertLocaleRelationInput"] | undefined,
	connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutDeliveryMethodsUpdateInput"]: {
		businessCategories?: Array<GraphQLTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateProductPackingsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductPackingLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateProductPackingsRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertProductPackingsRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductPackingLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductPackingLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductPackingLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateProductPackingsRelationInput"]: {
		by?: GraphQLTypes["ProductPackingLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["ProductPackingLocaleWithoutLocaleUpdateInput"] | undefined
};
	["ProductPackingLocaleWithoutLocaleUpdateInput"]: {
		name?: string | undefined,
	shortName?: string | undefined,
	description?: string | undefined,
	root?: GraphQLTypes["ProductPackingLocaleUpdateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductPackingLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["ProductPackingWithoutLocalesCreateInput"] | undefined,
	update?: GraphQLTypes["ProductPackingWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductPackingLocaleUpsertRootRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductPackingUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["ProductPackingWithoutLocalesUpdateInput"]: {
		name?: string | undefined,
	image?: GraphQLTypes["ProductPackingUpdateImageEntityRelationInput"] | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	volumeMl?: number | undefined,
	icon?: GraphQLTypes["ProductPackingUpdateIconEntityRelationInput"] | undefined,
	shortName?: string | undefined,
	preparedPackingQuantities?: Array<GraphQLTypes["ProductPackingUpdatePreparedPackingQuantitiesEntityRelationInput"]> | undefined,
	isPackedInCardboard?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductPackingUpdatePreparedPackingQuantitiesEntityRelationInput"]: {
		create?: GraphQLTypes["PreparedPackingQuantityWithoutPackingCreateInput"] | undefined,
	update?: GraphQLTypes["ProductPackingUpdatePreparedPackingQuantitiesRelationInput"] | undefined,
	upsert?: GraphQLTypes["ProductPackingUpsertPreparedPackingQuantitiesRelationInput"] | undefined,
	connect?: GraphQLTypes["PreparedPackingQuantityUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PreparedPackingQuantityUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PreparedPackingQuantityUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductPackingUpdatePreparedPackingQuantitiesRelationInput"]: {
		by?: GraphQLTypes["PreparedPackingQuantityUniqueWhere"] | undefined,
	data?: GraphQLTypes["PreparedPackingQuantityWithoutPackingUpdateInput"] | undefined
};
	["PreparedPackingQuantityWithoutPackingUpdateInput"]: {
		date?: GraphQLTypes["Date"] | undefined,
	quantity?: number | undefined,
	recipe?: GraphQLTypes["PreparedPackingQuantityUpdateRecipeEntityRelationInput"] | undefined,
	packedInCardboard?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PreparedPackingQuantityUpdateRecipeEntityRelationInput"]: {
		create?: GraphQLTypes["ProductRecipeCreateInput"] | undefined,
	update?: GraphQLTypes["ProductRecipeUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PreparedPackingQuantityUpsertRecipeRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductRecipeUniqueWhere"] | undefined
};
	["ProductRecipeUpdateInput"]: {
		name?: string | undefined,
	products?: Array<GraphQLTypes["ProductRecipeUpdateProductsEntityRelationInput"]> | undefined,
	internalNote?: string | undefined,
	color?: string | undefined,
	image?: GraphQLTypes["ProductRecipeUpdateImageEntityRelationInput"] | undefined,
	icon?: GraphQLTypes["ProductRecipeUpdateIconEntityRelationInput"] | undefined,
	ingredients?: Array<GraphQLTypes["ProductRecipeUpdateIngredientsEntityRelationInput"]> | undefined,
	needsPrepping?: boolean | undefined,
	locales?: Array<GraphQLTypes["ProductRecipeUpdateLocalesEntityRelationInput"]> | undefined,
	gutTuning?: number | undefined,
	freshingContainer?: GraphQLTypes["ProductRecipeUpdateFreshingContainerEntityRelationInput"] | undefined,
	description?: string | undefined,
	nutritionFacts?: GraphQLTypes["ProductRecipeUpdateNutritionFactsEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductRecipeUpdateProductsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductWithoutRecipeCreateInput"] | undefined,
	update?: GraphQLTypes["ProductRecipeUpdateProductsRelationInput"] | undefined,
	upsert?: GraphQLTypes["ProductRecipeUpsertProductsRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductRecipeUpdateProductsRelationInput"]: {
		by?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	data?: GraphQLTypes["ProductWithoutRecipeUpdateInput"] | undefined
};
	["ProductWithoutRecipeUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	priceCents?: number | undefined,
	notDiscountable?: boolean | undefined,
	packing?: GraphQLTypes["ProductUpdatePackingEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["ProductUpdateTagsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["ProductUpdateCategoriesEntityRelationInput"]> | undefined,
	vatRate?: GraphQLTypes["ProductUpdateVatRateEntityRelationInput"] | undefined,
	stocks?: Array<GraphQLTypes["ProductUpdateStocksEntityRelationInput"]> | undefined,
	groupPrices?: Array<GraphQLTypes["ProductUpdateGroupPricesEntityRelationInput"]> | undefined,
	image?: GraphQLTypes["ProductUpdateImageEntityRelationInput"] | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	cartItems?: Array<GraphQLTypes["ProductUpdateCartItemsEntityRelationInput"]> | undefined,
	availability?: GraphQLTypes["ProductAvailability"] | undefined,
	order?: number | undefined,
	manager?: GraphQLTypes["ProductUpdateManagerEntityRelationInput"] | undefined,
	orderItems?: Array<GraphQLTypes["ProductUpdateOrderItemsEntityRelationInput"]> | undefined,
	maximumQuantityPerOrder?: number | undefined,
	inheritedCategories?: Array<GraphQLTypes["ProductUpdateInheritedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["ProductUpdateDeliveryZonesEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["ProductUpdateLocalesEntityRelationInput"]> | undefined,
	archivedAt?: GraphQLTypes["DateTime"] | undefined,
	customerPrices?: Array<GraphQLTypes["ProductUpdateCustomerPricesEntityRelationInput"]> | undefined,
	virtualProduct?: GraphQLTypes["ProductUpdateVirtualProductEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["ProductUpdateMetaEntityRelationInput"] | undefined,
	page?: GraphQLTypes["ProductUpdatePageEntityRelationInput"] | undefined,
	salesDays?: Array<GraphQLTypes["ProductUpdateSalesDaysEntityRelationInput"]> | undefined,
	salesWeeks?: Array<GraphQLTypes["ProductUpdateSalesWeeksEntityRelationInput"]> | undefined,
	salesMonths?: Array<GraphQLTypes["ProductUpdateSalesMonthsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["ProductUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	hasSubscription?: boolean | undefined,
	pointOfSaleTileColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["ProductLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["ProductUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["ProductUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["ProductLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["ProductLocaleWithoutRootUpdateInput"] | undefined
};
	["ProductLocaleWithoutRootUpdateInput"]: {
		name?: string | undefined,
	description?: string | undefined,
	locale?: GraphQLTypes["ProductLocaleUpdateLocaleEntityRelationInput"] | undefined,
	featureList?: GraphQLTypes["ProductLocaleUpdateFeatureListEntityRelationInput"] | undefined,
	printableName?: string | undefined,
	firstSticker?: string | undefined,
	secondSticker?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutProductsCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutProductsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductLocaleUpsertLocaleRelationInput"] | undefined,
	connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutProductsUpdateInput"]: {
		businessCategories?: Array<GraphQLTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateProductRecipesEntityRelationInput"]: {
		create?: GraphQLTypes["ProductRecipeLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateProductRecipesRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertProductRecipesRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductRecipeLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductRecipeLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductRecipeLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateProductRecipesRelationInput"]: {
		by?: GraphQLTypes["ProductRecipeLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["ProductRecipeLocaleWithoutLocaleUpdateInput"] | undefined
};
	["ProductRecipeLocaleWithoutLocaleUpdateInput"]: {
		name?: string | undefined,
	root?: GraphQLTypes["ProductRecipeLocaleUpdateRootEntityRelationInput"] | undefined,
	description?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductRecipeLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["ProductRecipeWithoutLocalesCreateInput"] | undefined,
	update?: GraphQLTypes["ProductRecipeWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductRecipeLocaleUpsertRootRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductRecipeUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["ProductRecipeWithoutLocalesUpdateInput"]: {
		name?: string | undefined,
	products?: Array<GraphQLTypes["ProductRecipeUpdateProductsEntityRelationInput"]> | undefined,
	internalNote?: string | undefined,
	color?: string | undefined,
	image?: GraphQLTypes["ProductRecipeUpdateImageEntityRelationInput"] | undefined,
	icon?: GraphQLTypes["ProductRecipeUpdateIconEntityRelationInput"] | undefined,
	ingredients?: Array<GraphQLTypes["ProductRecipeUpdateIngredientsEntityRelationInput"]> | undefined,
	needsPrepping?: boolean | undefined,
	gutTuning?: number | undefined,
	freshingContainer?: GraphQLTypes["ProductRecipeUpdateFreshingContainerEntityRelationInput"] | undefined,
	description?: string | undefined,
	nutritionFacts?: GraphQLTypes["ProductRecipeUpdateNutritionFactsEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductRecipeUpdateFreshingContainerEntityRelationInput"]: {
		create?: GraphQLTypes["FreshingContainerCreateInput"] | undefined,
	update?: GraphQLTypes["FreshingContainerUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductRecipeUpsertFreshingContainerRelationInput"] | undefined,
	connect?: GraphQLTypes["FreshingContainerUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProductRecipeUpsertFreshingContainerRelationInput"]: {
		update?: GraphQLTypes["FreshingContainerUpdateInput"] | undefined,
	create?: GraphQLTypes["FreshingContainerCreateInput"] | undefined
};
	["ProductRecipeUpdateNutritionFactsEntityRelationInput"]: {
		create?: GraphQLTypes["NutritionFactsCreateInput"] | undefined,
	update?: GraphQLTypes["NutritionFactsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductRecipeUpsertNutritionFactsRelationInput"] | undefined,
	connect?: GraphQLTypes["NutritionFactsUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["NutritionFactsUpdateInput"]: {
		energyKiloJoule?: number | undefined,
	energyKiloCalorie?: number | undefined,
	fatsGrams?: number | undefined,
	fatsOfWhichSaturatedGrams?: number | undefined,
	carbohydrateGrams?: number | undefined,
	carbohydrateOfWhichSugarsGrams?: number | undefined,
	proteinGrams?: number | undefined,
	fibreGrams?: number | undefined,
	saltGrams?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductRecipeUpsertNutritionFactsRelationInput"]: {
		update?: GraphQLTypes["NutritionFactsUpdateInput"] | undefined,
	create?: GraphQLTypes["NutritionFactsCreateInput"] | undefined
};
	["ProductRecipeLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["ProductRecipeWithoutLocalesUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductRecipeWithoutLocalesCreateInput"] | undefined
};
	["LocaleUpsertProductRecipesRelationInput"]: {
		by?: GraphQLTypes["ProductRecipeLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["ProductRecipeLocaleWithoutLocaleUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductRecipeLocaleWithoutLocaleCreateInput"] | undefined
};
	["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]: {
		create?: GraphQLTypes["PointOfSaleCategoryLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdatePointOfSaleCategoriesRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertPointOfSaleCategoriesRelationInput"] | undefined,
	connect?: GraphQLTypes["PointOfSaleCategoryLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PointOfSaleCategoryLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PointOfSaleCategoryLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdatePointOfSaleCategoriesRelationInput"]: {
		by?: GraphQLTypes["PointOfSaleCategoryLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["PointOfSaleCategoryLocaleWithoutLocaleUpdateInput"] | undefined
};
	["PointOfSaleCategoryLocaleWithoutLocaleUpdateInput"]: {
		title?: string | undefined,
	root?: GraphQLTypes["PointOfSaleCategoryLocaleUpdateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleCategoryLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["PointOfSaleCategoryWithoutLocalesCreateInput"] | undefined,
	update?: GraphQLTypes["PointOfSaleCategoryWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PointOfSaleCategoryLocaleUpsertRootRelationInput"] | undefined,
	connect?: GraphQLTypes["PointOfSaleCategoryUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["PointOfSaleCategoryWithoutLocalesUpdateInput"]: {
		order?: number | undefined,
	slug?: string | undefined,
	products?: Array<GraphQLTypes["PointOfSaleCategoryUpdateProductsEntityRelationInput"]> | undefined,
	category?: GraphQLTypes["PointOfSaleCategoryUpdateCategoryEntityRelationInput"] | undefined,
	venue?: GraphQLTypes["PointOfSaleCategoryUpdateVenueEntityRelationInput"] | undefined,
	ticketPrinters?: Array<GraphQLTypes["PointOfSaleCategoryUpdateTicketPrintersEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleCategoryUpdateProductsEntityRelationInput"]: {
		create?: GraphQLTypes["PointOfSaleCategoryProductWithoutCategoryCreateInput"] | undefined,
	update?: GraphQLTypes["PointOfSaleCategoryUpdateProductsRelationInput"] | undefined,
	upsert?: GraphQLTypes["PointOfSaleCategoryUpsertProductsRelationInput"] | undefined,
	connect?: GraphQLTypes["PointOfSaleCategoryProductUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PointOfSaleCategoryProductUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PointOfSaleCategoryProductUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PointOfSaleCategoryUpdateProductsRelationInput"]: {
		by?: GraphQLTypes["PointOfSaleCategoryProductUniqueWhere"] | undefined,
	data?: GraphQLTypes["PointOfSaleCategoryProductWithoutCategoryUpdateInput"] | undefined
};
	["PointOfSaleCategoryProductWithoutCategoryUpdateInput"]: {
		order?: number | undefined,
	product?: GraphQLTypes["PointOfSaleCategoryProductUpdateProductEntityRelationInput"] | undefined,
	locales?: Array<GraphQLTypes["PointOfSaleCategoryProductUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleCategoryProductUpdateProductEntityRelationInput"]: {
		create?: GraphQLTypes["ProductCreateInput"] | undefined,
	update?: GraphQLTypes["ProductUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PointOfSaleCategoryProductUpsertProductRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductUniqueWhere"] | undefined
};
	["ProductUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	priceCents?: number | undefined,
	notDiscountable?: boolean | undefined,
	packing?: GraphQLTypes["ProductUpdatePackingEntityRelationInput"] | undefined,
	recipe?: GraphQLTypes["ProductUpdateRecipeEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["ProductUpdateTagsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["ProductUpdateCategoriesEntityRelationInput"]> | undefined,
	vatRate?: GraphQLTypes["ProductUpdateVatRateEntityRelationInput"] | undefined,
	stocks?: Array<GraphQLTypes["ProductUpdateStocksEntityRelationInput"]> | undefined,
	groupPrices?: Array<GraphQLTypes["ProductUpdateGroupPricesEntityRelationInput"]> | undefined,
	image?: GraphQLTypes["ProductUpdateImageEntityRelationInput"] | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	cartItems?: Array<GraphQLTypes["ProductUpdateCartItemsEntityRelationInput"]> | undefined,
	availability?: GraphQLTypes["ProductAvailability"] | undefined,
	order?: number | undefined,
	manager?: GraphQLTypes["ProductUpdateManagerEntityRelationInput"] | undefined,
	orderItems?: Array<GraphQLTypes["ProductUpdateOrderItemsEntityRelationInput"]> | undefined,
	maximumQuantityPerOrder?: number | undefined,
	inheritedCategories?: Array<GraphQLTypes["ProductUpdateInheritedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["ProductUpdateDeliveryZonesEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["ProductUpdateLocalesEntityRelationInput"]> | undefined,
	archivedAt?: GraphQLTypes["DateTime"] | undefined,
	customerPrices?: Array<GraphQLTypes["ProductUpdateCustomerPricesEntityRelationInput"]> | undefined,
	virtualProduct?: GraphQLTypes["ProductUpdateVirtualProductEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["ProductUpdateMetaEntityRelationInput"] | undefined,
	page?: GraphQLTypes["ProductUpdatePageEntityRelationInput"] | undefined,
	salesDays?: Array<GraphQLTypes["ProductUpdateSalesDaysEntityRelationInput"]> | undefined,
	salesWeeks?: Array<GraphQLTypes["ProductUpdateSalesWeeksEntityRelationInput"]> | undefined,
	salesMonths?: Array<GraphQLTypes["ProductUpdateSalesMonthsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["ProductUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	hasSubscription?: boolean | undefined,
	pointOfSaleTileColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductUpdateCustomerPricesEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductCustomerPriceUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductCustomerPriceUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductCustomerPriceUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductUpdateVirtualProductEntityRelationInput"]: {
		create?: GraphQLTypes["VirtualProductWithoutProductCreateInput"] | undefined,
	update?: GraphQLTypes["VirtualProductWithoutProductUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductUpsertVirtualProductRelationInput"] | undefined,
	connect?: GraphQLTypes["VirtualProductUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["VirtualProductWithoutProductUpdateInput"]: {
		type?: GraphQLTypes["VirtualProductType"] | undefined,
	voucherCreditCents?: number | undefined,
	physicalRepresentation?: GraphQLTypes["VirtualProductPhysicalRepresentationType"] | undefined,
	recipientEmail?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductUpsertVirtualProductRelationInput"]: {
		update?: GraphQLTypes["VirtualProductWithoutProductUpdateInput"] | undefined,
	create?: GraphQLTypes["VirtualProductWithoutProductCreateInput"] | undefined
};
	["ProductUpdateMetaEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductMetadataUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProductUpdatePageEntityRelationInput"]: {
		create?: GraphQLTypes["PageCreateInput"] | undefined,
	update?: GraphQLTypes["PageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductUpsertPageRelationInput"] | undefined,
	connect?: GraphQLTypes["PageUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PageUpdateInput"]: {
		locales?: Array<GraphQLTypes["PageUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PageUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["PageLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["PageUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["PageUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["PageLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PageLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PageUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["PageLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["PageLocaleWithoutRootUpdateInput"] | undefined
};
	["PageLocaleWithoutRootUpdateInput"]: {
		title?: string | undefined,
	link?: GraphQLTypes["PageLocaleUpdateLinkEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["PageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["PageLocaleUpdateSeoEntityRelationInput"] | undefined,
	content?: GraphQLTypes["PageLocaleUpdateContentEntityRelationInput"] | undefined,
	cover?: GraphQLTypes["PageLocaleUpdateCoverEntityRelationInput"] | undefined,
	theme?: GraphQLTypes["PageTheme"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PageLocaleUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"] | undefined,
	update?: GraphQLTypes["SeoUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PageLocaleUpsertSeoRelationInput"] | undefined,
	connect?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["SeoUpdateInput"]: {
		title?: string | undefined,
	description?: string | undefined,
	ogTitle?: string | undefined,
	ogDescription?: string | undefined,
	ogImage?: GraphQLTypes["SeoUpdateOgImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeoUpdateOgImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["SeoUpsertOgImageRelationInput"] | undefined,
	connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["SeoUpsertOgImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["PageLocaleUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"] | undefined,
	create?: GraphQLTypes["SeoCreateInput"] | undefined
};
	["PageLocaleUpdateContentEntityRelationInput"]: {
		create?: GraphQLTypes["ContentCreateInput"] | undefined,
	update?: GraphQLTypes["ContentUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PageLocaleUpsertContentRelationInput"] | undefined,
	connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PageLocaleUpsertContentRelationInput"]: {
		update?: GraphQLTypes["ContentUpdateInput"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined
};
	["PageLocaleUpdateCoverEntityRelationInput"]: {
		create?: GraphQLTypes["CoverCreateInput"] | undefined,
	update?: GraphQLTypes["CoverUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PageLocaleUpsertCoverRelationInput"] | undefined,
	connect?: GraphQLTypes["CoverUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PageLocaleUpsertCoverRelationInput"]: {
		update?: GraphQLTypes["CoverUpdateInput"] | undefined,
	create?: GraphQLTypes["CoverCreateInput"] | undefined
};
	["PageUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["PageLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["PageLocaleWithoutRootUpdateInput"] | undefined,
	create?: GraphQLTypes["PageLocaleWithoutRootCreateInput"] | undefined
};
	["ProductUpsertPageRelationInput"]: {
		update?: GraphQLTypes["PageUpdateInput"] | undefined,
	create?: GraphQLTypes["PageCreateInput"] | undefined
};
	["ProductUpdateSalesDaysEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductSalesDayUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductSalesDayUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductSalesDayUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductUpdateSalesWeeksEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductSalesWeekUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductSalesWeekUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductSalesWeekUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductUpdateSalesMonthsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductSalesMonthUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductSalesMonthUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductSalesMonthUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductUpdateFulfillmentNotesEntityRelationInput"]: {
		create?: GraphQLTypes["FulfillmentNoteWithoutProductsCreateInput"] | undefined,
	update?: GraphQLTypes["ProductUpdateFulfillmentNotesRelationInput"] | undefined,
	upsert?: GraphQLTypes["ProductUpsertFulfillmentNotesRelationInput"] | undefined,
	connect?: GraphQLTypes["FulfillmentNoteUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["FulfillmentNoteUniqueWhere"] | undefined,
	delete?: GraphQLTypes["FulfillmentNoteUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductUpdateFulfillmentNotesRelationInput"]: {
		by?: GraphQLTypes["FulfillmentNoteUniqueWhere"] | undefined,
	data?: GraphQLTypes["FulfillmentNoteWithoutProductsUpdateInput"] | undefined
};
	["FulfillmentNoteWithoutProductsUpdateInput"]: {
		note?: string | undefined,
	tags?: Array<GraphQLTypes["FulfillmentNoteUpdateTagsEntityRelationInput"]> | undefined,
	venues?: Array<GraphQLTypes["FulfillmentNoteUpdateVenuesEntityRelationInput"]> | undefined,
	cartItems?: Array<GraphQLTypes["FulfillmentNoteUpdateCartItemsEntityRelationInput"]> | undefined,
	orderItems?: Array<GraphQLTypes["FulfillmentNoteUpdateOrderItemsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["FulfillmentNoteUpdateOrdersEntityRelationInput"]> | undefined,
	highlight?: boolean | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	emoji?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["FulfillmentNoteUpdateTagsEntityRelationInput"]: {
		create?: GraphQLTypes["TagWithoutFulfillmentNotesCreateInput"] | undefined,
	update?: GraphQLTypes["FulfillmentNoteUpdateTagsRelationInput"] | undefined,
	upsert?: GraphQLTypes["FulfillmentNoteUpsertTagsRelationInput"] | undefined,
	connect?: GraphQLTypes["TagUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TagUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TagUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["FulfillmentNoteUpdateTagsRelationInput"]: {
		by?: GraphQLTypes["TagUniqueWhere"] | undefined,
	data?: GraphQLTypes["TagWithoutFulfillmentNotesUpdateInput"] | undefined
};
	["TagWithoutFulfillmentNotesUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	customers?: Array<GraphQLTypes["TagUpdateCustomersEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["TagUpdateProductsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["TagUpdateCategoriesEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	addTagsOnRegistration?: Array<GraphQLTypes["TagUpdateAddTagsOnRegistrationEntityRelationInput"]> | undefined,
	nestedCategories?: Array<GraphQLTypes["TagUpdateNestedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["TagUpdateDeliveryZonesEntityRelationInput"]> | undefined,
	publicInChannels?: Array<GraphQLTypes["TagUpdatePublicInChannelsEntityRelationInput"]> | undefined,
	allowChannelPayments?: Array<GraphQLTypes["TagUpdateAllowChannelPaymentsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["FulfillmentNoteUpsertTagsRelationInput"]: {
		by?: GraphQLTypes["TagUniqueWhere"] | undefined,
	update?: GraphQLTypes["TagWithoutFulfillmentNotesUpdateInput"] | undefined,
	create?: GraphQLTypes["TagWithoutFulfillmentNotesCreateInput"] | undefined
};
	["FulfillmentNoteUpdateVenuesEntityRelationInput"]: {
		create?: GraphQLTypes["VenueWithoutFulfillmentNotesCreateInput"] | undefined,
	update?: GraphQLTypes["FulfillmentNoteUpdateVenuesRelationInput"] | undefined,
	upsert?: GraphQLTypes["FulfillmentNoteUpsertVenuesRelationInput"] | undefined,
	connect?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	delete?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["FulfillmentNoteUpdateVenuesRelationInput"]: {
		by?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	data?: GraphQLTypes["VenueWithoutFulfillmentNotesUpdateInput"] | undefined
};
	["VenueWithoutFulfillmentNotesUpdateInput"]: {
		name?: string | undefined,
	deadlineTemplate?: GraphQLTypes["VenueUpdateDeadlineTemplateEntityRelationInput"] | undefined,
	timetableDays?: Array<GraphQLTypes["VenueUpdateTimetableDaysEntityRelationInput"]> | undefined,
	timetableTemplates?: Array<GraphQLTypes["VenueUpdateTimetableTemplatesEntityRelationInput"]> | undefined,
	staffMembers?: Array<GraphQLTypes["VenueUpdateStaffMembersEntityRelationInput"]> | undefined,
	employeeRoles?: Array<GraphQLTypes["VenueUpdateEmployeeRolesEntityRelationInput"]> | undefined,
	pointOfSaleApplicationDevices?: Array<GraphQLTypes["VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined,
	pointOfSaleTerminals?: Array<GraphQLTypes["VenueUpdatePointOfSaleTerminalsEntityRelationInput"]> | undefined,
	pointOfSalePrinters?: Array<GraphQLTypes["VenueUpdatePointOfSalePrintersEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["VenueUpdateOrdersEntityRelationInput"]> | undefined,
	areas?: Array<GraphQLTypes["VenueUpdateAreasEntityRelationInput"]> | undefined,
	enabledUnassignReasons?: Array<GraphQLTypes["VenueUpdateEnabledUnassignReasonsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["VenueUpdateCategoriesEntityRelationInput"]> | undefined,
	channels?: Array<GraphQLTypes["VenueUpdateChannelsEntityRelationInput"]> | undefined,
	address?: string | undefined,
	pointOfSalePngBase64ReceiptLogo?: string | undefined,
	pointOfSaleInitialView?: GraphQLTypes["PointOfSaleInitialView"] | undefined,
	pointOfSalePreferPrintReceipt?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["VenueUpdateTimetableTemplatesEntityRelationInput"]: {
		create?: GraphQLTypes["TimetableTemplateWithoutVenueCreateInput"] | undefined,
	update?: GraphQLTypes["VenueUpdateTimetableTemplatesRelationInput"] | undefined,
	upsert?: GraphQLTypes["VenueUpsertTimetableTemplatesRelationInput"] | undefined,
	connect?: GraphQLTypes["TimetableTemplateUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TimetableTemplateUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TimetableTemplateUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["VenueUpdateTimetableTemplatesRelationInput"]: {
		by?: GraphQLTypes["TimetableTemplateUniqueWhere"] | undefined,
	data?: GraphQLTypes["TimetableTemplateWithoutVenueUpdateInput"] | undefined
};
	["TimetableTemplateWithoutVenueUpdateInput"]: {
		order?: number | undefined,
	startDate?: GraphQLTypes["Date"] | undefined,
	period?: number | undefined,
	slots?: number | undefined,
	position?: GraphQLTypes["TimetableTemplateUpdatePositionEntityRelationInput"] | undefined,
	staffOptions?: Array<GraphQLTypes["TimetableTemplateUpdateStaffOptionsEntityRelationInput"]> | undefined,
	internalName?: string | undefined,
	employeeRole?: GraphQLTypes["TimetableTemplateUpdateEmployeeRoleEntityRelationInput"] | undefined,
	workdaysOnly?: boolean | undefined,
	monday?: boolean | undefined,
	tuesday?: boolean | undefined,
	wednesday?: boolean | undefined,
	thursday?: boolean | undefined,
	friday?: boolean | undefined,
	saturday?: boolean | undefined,
	sunday?: boolean | undefined,
	type?: GraphQLTypes["TemplateType"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableTemplateUpdateEmployeeRoleEntityRelationInput"]: {
		create?: GraphQLTypes["TimetableEmployeeRoleWithoutTimetableTemplatesCreateInput"] | undefined,
	update?: GraphQLTypes["TimetableEmployeeRoleWithoutTimetableTemplatesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TimetableTemplateUpsertEmployeeRoleRelationInput"] | undefined,
	connect?: GraphQLTypes["TimetableEmployeeRoleUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TimetableEmployeeRoleWithoutTimetableTemplatesUpdateInput"]: {
		shiftGroups?: Array<GraphQLTypes["TimetableEmployeeRoleUpdateShiftGroupsEntityRelationInput"]> | undefined,
	shiftsProfiles?: Array<GraphQLTypes["TimetableEmployeeRoleUpdateShiftsProfilesEntityRelationInput"]> | undefined,
	shiftsManagers?: Array<GraphQLTypes["TimetableEmployeeRoleUpdateShiftsManagersEntityRelationInput"]> | undefined,
	name?: string | undefined,
	color?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableTemplateUpsertEmployeeRoleRelationInput"]: {
		update?: GraphQLTypes["TimetableEmployeeRoleWithoutTimetableTemplatesUpdateInput"] | undefined,
	create?: GraphQLTypes["TimetableEmployeeRoleWithoutTimetableTemplatesCreateInput"] | undefined
};
	["VenueUpsertTimetableTemplatesRelationInput"]: {
		by?: GraphQLTypes["TimetableTemplateUniqueWhere"] | undefined,
	update?: GraphQLTypes["TimetableTemplateWithoutVenueUpdateInput"] | undefined,
	create?: GraphQLTypes["TimetableTemplateWithoutVenueCreateInput"] | undefined
};
	["VenueUpdatePointOfSaleTerminalsEntityRelationInput"]: {
		create?: GraphQLTypes["PointOfSaleTerminalWithoutVenueCreateInput"] | undefined,
	update?: GraphQLTypes["VenueUpdatePointOfSaleTerminalsRelationInput"] | undefined,
	upsert?: GraphQLTypes["VenueUpsertPointOfSaleTerminalsRelationInput"] | undefined,
	connect?: GraphQLTypes["PointOfSaleTerminalUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PointOfSaleTerminalUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PointOfSaleTerminalUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["VenueUpdatePointOfSaleTerminalsRelationInput"]: {
		by?: GraphQLTypes["PointOfSaleTerminalUniqueWhere"] | undefined,
	data?: GraphQLTypes["PointOfSaleTerminalWithoutVenueUpdateInput"] | undefined
};
	["PointOfSaleTerminalWithoutVenueUpdateInput"]: {
		internalName?: string | undefined,
	note?: string | undefined,
	applicationDevices?: Array<GraphQLTypes["PointOfSaleTerminalUpdateApplicationDevicesEntityRelationInput"]> | undefined,
	ipAddress?: string | undefined,
	port?: number | undefined,
	type?: GraphQLTypes["PointOfSaleTerminalType"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleTerminalUpdateApplicationDevicesEntityRelationInput"]: {
		create?: GraphQLTypes["PointOfSaleApplicationDeviceWithoutTerminalCreateInput"] | undefined,
	update?: GraphQLTypes["PointOfSaleTerminalUpdateApplicationDevicesRelationInput"] | undefined,
	upsert?: GraphQLTypes["PointOfSaleTerminalUpsertApplicationDevicesRelationInput"] | undefined,
	connect?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PointOfSaleTerminalUpdateApplicationDevicesRelationInput"]: {
		by?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined,
	data?: GraphQLTypes["PointOfSaleApplicationDeviceWithoutTerminalUpdateInput"] | undefined
};
	["PointOfSaleApplicationDeviceWithoutTerminalUpdateInput"]: {
		internalName?: string | undefined,
	note?: string | undefined,
	venue?: GraphQLTypes["PointOfSaleApplicationDeviceUpdateVenueEntityRelationInput"] | undefined,
	identificationCode?: GraphQLTypes["PointOfSaleApplicationDeviceUpdateIdentificationCodeEntityRelationInput"] | undefined,
	identifier?: GraphQLTypes["PointOfSaleApplicationDeviceUpdateIdentifierEntityRelationInput"] | undefined,
	receiptPrinter?: GraphQLTypes["PointOfSaleApplicationDeviceUpdateReceiptPrinterEntityRelationInput"] | undefined,
	ticketPrinters?: Array<GraphQLTypes["PointOfSaleApplicationDeviceUpdateTicketPrintersEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleApplicationDeviceUpdateVenueEntityRelationInput"]: {
		create?: GraphQLTypes["VenueWithoutPointOfSaleApplicationDevicesCreateInput"] | undefined,
	update?: GraphQLTypes["VenueWithoutPointOfSaleApplicationDevicesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PointOfSaleApplicationDeviceUpsertVenueRelationInput"] | undefined,
	connect?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["VenueWithoutPointOfSaleApplicationDevicesUpdateInput"]: {
		name?: string | undefined,
	deadlineTemplate?: GraphQLTypes["VenueUpdateDeadlineTemplateEntityRelationInput"] | undefined,
	timetableDays?: Array<GraphQLTypes["VenueUpdateTimetableDaysEntityRelationInput"]> | undefined,
	timetableTemplates?: Array<GraphQLTypes["VenueUpdateTimetableTemplatesEntityRelationInput"]> | undefined,
	staffMembers?: Array<GraphQLTypes["VenueUpdateStaffMembersEntityRelationInput"]> | undefined,
	employeeRoles?: Array<GraphQLTypes["VenueUpdateEmployeeRolesEntityRelationInput"]> | undefined,
	pointOfSaleTerminals?: Array<GraphQLTypes["VenueUpdatePointOfSaleTerminalsEntityRelationInput"]> | undefined,
	pointOfSalePrinters?: Array<GraphQLTypes["VenueUpdatePointOfSalePrintersEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["VenueUpdateOrdersEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["VenueUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	areas?: Array<GraphQLTypes["VenueUpdateAreasEntityRelationInput"]> | undefined,
	enabledUnassignReasons?: Array<GraphQLTypes["VenueUpdateEnabledUnassignReasonsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["VenueUpdateCategoriesEntityRelationInput"]> | undefined,
	channels?: Array<GraphQLTypes["VenueUpdateChannelsEntityRelationInput"]> | undefined,
	address?: string | undefined,
	pointOfSalePngBase64ReceiptLogo?: string | undefined,
	pointOfSaleInitialView?: GraphQLTypes["PointOfSaleInitialView"] | undefined,
	pointOfSalePreferPrintReceipt?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["VenueUpdatePointOfSalePrintersEntityRelationInput"]: {
		create?: GraphQLTypes["PointOfSalePrinterWithoutVenueCreateInput"] | undefined,
	update?: GraphQLTypes["VenueUpdatePointOfSalePrintersRelationInput"] | undefined,
	upsert?: GraphQLTypes["VenueUpsertPointOfSalePrintersRelationInput"] | undefined,
	connect?: GraphQLTypes["PointOfSalePrinterUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PointOfSalePrinterUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PointOfSalePrinterUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["VenueUpdatePointOfSalePrintersRelationInput"]: {
		by?: GraphQLTypes["PointOfSalePrinterUniqueWhere"] | undefined,
	data?: GraphQLTypes["PointOfSalePrinterWithoutVenueUpdateInput"] | undefined
};
	["PointOfSalePrinterWithoutVenueUpdateInput"]: {
		internalName?: string | undefined,
	note?: string | undefined,
	ipAddress?: string | undefined,
	applicationDevicesReceipt?: Array<GraphQLTypes["PointOfSalePrinterUpdateApplicationDevicesReceiptEntityRelationInput"]> | undefined,
	applicationDevicesTicket?: Array<GraphQLTypes["PointOfSalePrinterUpdateApplicationDevicesTicketEntityRelationInput"]> | undefined,
	ticketCategories?: Array<GraphQLTypes["PointOfSalePrinterUpdateTicketCategoriesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSalePrinterUpdateApplicationDevicesReceiptEntityRelationInput"]: {
		create?: GraphQLTypes["PointOfSaleApplicationDeviceWithoutReceiptPrinterCreateInput"] | undefined,
	update?: GraphQLTypes["PointOfSalePrinterUpdateApplicationDevicesReceiptRelationInput"] | undefined,
	upsert?: GraphQLTypes["PointOfSalePrinterUpsertApplicationDevicesReceiptRelationInput"] | undefined,
	connect?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PointOfSalePrinterUpdateApplicationDevicesReceiptRelationInput"]: {
		by?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined,
	data?: GraphQLTypes["PointOfSaleApplicationDeviceWithoutReceiptPrinterUpdateInput"] | undefined
};
	["PointOfSaleApplicationDeviceWithoutReceiptPrinterUpdateInput"]: {
		internalName?: string | undefined,
	note?: string | undefined,
	venue?: GraphQLTypes["PointOfSaleApplicationDeviceUpdateVenueEntityRelationInput"] | undefined,
	identificationCode?: GraphQLTypes["PointOfSaleApplicationDeviceUpdateIdentificationCodeEntityRelationInput"] | undefined,
	identifier?: GraphQLTypes["PointOfSaleApplicationDeviceUpdateIdentifierEntityRelationInput"] | undefined,
	terminal?: GraphQLTypes["PointOfSaleApplicationDeviceUpdateTerminalEntityRelationInput"] | undefined,
	ticketPrinters?: Array<GraphQLTypes["PointOfSaleApplicationDeviceUpdateTicketPrintersEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleApplicationDeviceUpdateIdentifierEntityRelationInput"]: {
		create?: GraphQLTypes["DeviceIdentifierWithoutDeviceCreateInput"] | undefined,
	update?: GraphQLTypes["DeviceIdentifierWithoutDeviceUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PointOfSaleApplicationDeviceUpsertIdentifierRelationInput"] | undefined,
	connect?: GraphQLTypes["DeviceIdentifierUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["DeviceIdentifierWithoutDeviceUpdateInput"]: {
		internalName?: string | undefined,
	updatedAt?: GraphQLTypes["DateTime"] | undefined,
	platform?: string | undefined,
	resolution?: string | undefined,
	devicePixelRatio?: number | undefined,
	updatedByUser?: GraphQLTypes["DeviceIdentifierUpdateUpdatedByUserEntityRelationInput"] | undefined,
	identifier?: string | undefined,
	applicationVersionIdentifier?: string | undefined,
	lastPointOfSaleSynchronizationErrorRawDetails?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeviceIdentifierUpdateUpdatedByUserEntityRelationInput"]: {
		create?: GraphQLTypes["UserCreateInput"] | undefined,
	update?: GraphQLTypes["UserUpdateInput"] | undefined,
	upsert?: GraphQLTypes["DeviceIdentifierUpsertUpdatedByUserRelationInput"] | undefined,
	connect?: GraphQLTypes["UserUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserUpdateInput"]: {
		name?: string | undefined,
	internalNote?: string | undefined,
	staff?: GraphQLTypes["UserUpdateStaffEntityRelationInput"] | undefined,
	customer?: GraphQLTypes["UserUpdateCustomerEntityRelationInput"] | undefined,
	tenantPersonId?: GraphQLTypes["UUID"] | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	devices?: Array<GraphQLTypes["UserUpdateDevicesEntityRelationInput"]> | undefined,
	verifiedAt?: GraphQLTypes["DateTime"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	deletionRequestedAt?: GraphQLTypes["DateTime"] | undefined,
	deletionExpectedAt?: GraphQLTypes["DateTime"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	meta?: GraphQLTypes["UserUpdateMetaEntityRelationInput"] | undefined,
	identificationAttempts?: Array<GraphQLTypes["UserUpdateIdentificationAttemptsEntityRelationInput"]> | undefined,
	roles?: GraphQLTypes["UserUpdateRolesEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserUpdateMetaEntityRelationInput"]: {
		connect?: GraphQLTypes["UserMetadataUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserUpdateIdentificationAttemptsEntityRelationInput"]: {
		create?: GraphQLTypes["IdentificationAttemptWithoutUserCreateInput"] | undefined,
	update?: GraphQLTypes["UserUpdateIdentificationAttemptsRelationInput"] | undefined,
	upsert?: GraphQLTypes["UserUpsertIdentificationAttemptsRelationInput"] | undefined,
	connect?: GraphQLTypes["IdentificationAttemptUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["IdentificationAttemptUniqueWhere"] | undefined,
	delete?: GraphQLTypes["IdentificationAttemptUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["UserUpdateIdentificationAttemptsRelationInput"]: {
		by?: GraphQLTypes["IdentificationAttemptUniqueWhere"] | undefined,
	data?: GraphQLTypes["IdentificationAttemptWithoutUserUpdateInput"] | undefined
};
	["IdentificationAttemptWithoutUserUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	code?: GraphQLTypes["IdentificationAttemptUpdateCodeEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["IdentificationAttemptUpdateCodeEntityRelationInput"]: {
		create?: GraphQLTypes["IdentificationCodeWithoutAttemptsCreateInput"] | undefined,
	update?: GraphQLTypes["IdentificationCodeWithoutAttemptsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["IdentificationAttemptUpsertCodeRelationInput"] | undefined,
	connect?: GraphQLTypes["IdentificationCodeUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["IdentificationCodeWithoutAttemptsUpdateInput"]: {
		code?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	locales?: Array<GraphQLTypes["IdentificationCodeUpdateLocalesEntityRelationInput"]> | undefined,
	internalName?: string | undefined,
	applicationDevices?: Array<GraphQLTypes["IdentificationCodeUpdateApplicationDevicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["IdentificationCodeUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["IdentificationCodeLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["IdentificationCodeUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["IdentificationCodeUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["IdentificationCodeLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["IdentificationCodeLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["IdentificationCodeLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["IdentificationCodeUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["IdentificationCodeLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["IdentificationCodeLocaleWithoutRootUpdateInput"] | undefined
};
	["IdentificationCodeLocaleWithoutRootUpdateInput"]: {
		successMessage?: string | undefined,
	locale?: GraphQLTypes["IdentificationCodeLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["IdentificationCodeLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutIdentificationCodesCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutIdentificationCodesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["IdentificationCodeLocaleUpsertLocaleRelationInput"] | undefined,
	connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutIdentificationCodesUpdateInput"]: {
		businessCategories?: Array<GraphQLTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateProductsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateProductsRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertProductsRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateProductsRelationInput"]: {
		by?: GraphQLTypes["ProductLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["ProductLocaleWithoutLocaleUpdateInput"] | undefined
};
	["ProductLocaleWithoutLocaleUpdateInput"]: {
		name?: string | undefined,
	description?: string | undefined,
	root?: GraphQLTypes["ProductLocaleUpdateRootEntityRelationInput"] | undefined,
	featureList?: GraphQLTypes["ProductLocaleUpdateFeatureListEntityRelationInput"] | undefined,
	printableName?: string | undefined,
	firstSticker?: string | undefined,
	secondSticker?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["ProductWithoutLocalesCreateInput"] | undefined,
	update?: GraphQLTypes["ProductWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductLocaleUpsertRootRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["ProductWithoutLocalesUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	priceCents?: number | undefined,
	notDiscountable?: boolean | undefined,
	packing?: GraphQLTypes["ProductUpdatePackingEntityRelationInput"] | undefined,
	recipe?: GraphQLTypes["ProductUpdateRecipeEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["ProductUpdateTagsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["ProductUpdateCategoriesEntityRelationInput"]> | undefined,
	vatRate?: GraphQLTypes["ProductUpdateVatRateEntityRelationInput"] | undefined,
	stocks?: Array<GraphQLTypes["ProductUpdateStocksEntityRelationInput"]> | undefined,
	groupPrices?: Array<GraphQLTypes["ProductUpdateGroupPricesEntityRelationInput"]> | undefined,
	image?: GraphQLTypes["ProductUpdateImageEntityRelationInput"] | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	cartItems?: Array<GraphQLTypes["ProductUpdateCartItemsEntityRelationInput"]> | undefined,
	availability?: GraphQLTypes["ProductAvailability"] | undefined,
	order?: number | undefined,
	manager?: GraphQLTypes["ProductUpdateManagerEntityRelationInput"] | undefined,
	orderItems?: Array<GraphQLTypes["ProductUpdateOrderItemsEntityRelationInput"]> | undefined,
	maximumQuantityPerOrder?: number | undefined,
	inheritedCategories?: Array<GraphQLTypes["ProductUpdateInheritedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["ProductUpdateDeliveryZonesEntityRelationInput"]> | undefined,
	archivedAt?: GraphQLTypes["DateTime"] | undefined,
	customerPrices?: Array<GraphQLTypes["ProductUpdateCustomerPricesEntityRelationInput"]> | undefined,
	virtualProduct?: GraphQLTypes["ProductUpdateVirtualProductEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["ProductUpdateMetaEntityRelationInput"] | undefined,
	page?: GraphQLTypes["ProductUpdatePageEntityRelationInput"] | undefined,
	salesDays?: Array<GraphQLTypes["ProductUpdateSalesDaysEntityRelationInput"]> | undefined,
	salesWeeks?: Array<GraphQLTypes["ProductUpdateSalesWeeksEntityRelationInput"]> | undefined,
	salesMonths?: Array<GraphQLTypes["ProductUpdateSalesMonthsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["ProductUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	hasSubscription?: boolean | undefined,
	pointOfSaleTileColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["ProductWithoutLocalesUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductWithoutLocalesCreateInput"] | undefined
};
	["ProductLocaleUpdateFeatureListEntityRelationInput"]: {
		create?: GraphQLTypes["TextListCreateInput"] | undefined,
	update?: GraphQLTypes["TextListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductLocaleUpsertFeatureListRelationInput"] | undefined,
	connect?: GraphQLTypes["TextListUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProductLocaleUpsertFeatureListRelationInput"]: {
		update?: GraphQLTypes["TextListUpdateInput"] | undefined,
	create?: GraphQLTypes["TextListCreateInput"] | undefined
};
	["LocaleUpsertProductsRelationInput"]: {
		by?: GraphQLTypes["ProductLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["ProductLocaleWithoutLocaleUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductLocaleWithoutLocaleCreateInput"] | undefined
};
	["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]: {
		create?: GraphQLTypes["PointOfSaleCategoryProductLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdatePointOfSaleCategoryProductsRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertPointOfSaleCategoryProductsRelationInput"] | undefined,
	connect?: GraphQLTypes["PointOfSaleCategoryProductLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PointOfSaleCategoryProductLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PointOfSaleCategoryProductLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdatePointOfSaleCategoryProductsRelationInput"]: {
		by?: GraphQLTypes["PointOfSaleCategoryProductLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["PointOfSaleCategoryProductLocaleWithoutLocaleUpdateInput"] | undefined
};
	["PointOfSaleCategoryProductLocaleWithoutLocaleUpdateInput"]: {
		title?: string | undefined,
	root?: GraphQLTypes["PointOfSaleCategoryProductLocaleUpdateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleCategoryProductLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["PointOfSaleCategoryProductWithoutLocalesCreateInput"] | undefined,
	update?: GraphQLTypes["PointOfSaleCategoryProductWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PointOfSaleCategoryProductLocaleUpsertRootRelationInput"] | undefined,
	connect?: GraphQLTypes["PointOfSaleCategoryProductUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["PointOfSaleCategoryProductWithoutLocalesUpdateInput"]: {
		order?: number | undefined,
	category?: GraphQLTypes["PointOfSaleCategoryProductUpdateCategoryEntityRelationInput"] | undefined,
	product?: GraphQLTypes["PointOfSaleCategoryProductUpdateProductEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleCategoryProductUpdateCategoryEntityRelationInput"]: {
		create?: GraphQLTypes["PointOfSaleCategoryWithoutProductsCreateInput"] | undefined,
	update?: GraphQLTypes["PointOfSaleCategoryWithoutProductsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PointOfSaleCategoryProductUpsertCategoryRelationInput"] | undefined,
	connect?: GraphQLTypes["PointOfSaleCategoryUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["PointOfSaleCategoryWithoutProductsUpdateInput"]: {
		order?: number | undefined,
	slug?: string | undefined,
	locales?: Array<GraphQLTypes["PointOfSaleCategoryUpdateLocalesEntityRelationInput"]> | undefined,
	category?: GraphQLTypes["PointOfSaleCategoryUpdateCategoryEntityRelationInput"] | undefined,
	venue?: GraphQLTypes["PointOfSaleCategoryUpdateVenueEntityRelationInput"] | undefined,
	ticketPrinters?: Array<GraphQLTypes["PointOfSaleCategoryUpdateTicketPrintersEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleCategoryUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["PointOfSaleCategoryLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["PointOfSaleCategoryUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["PointOfSaleCategoryUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["PointOfSaleCategoryLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PointOfSaleCategoryLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PointOfSaleCategoryLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PointOfSaleCategoryUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["PointOfSaleCategoryLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["PointOfSaleCategoryLocaleWithoutRootUpdateInput"] | undefined
};
	["PointOfSaleCategoryLocaleWithoutRootUpdateInput"]: {
		title?: string | undefined,
	locale?: GraphQLTypes["PointOfSaleCategoryLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleCategoryLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutPointOfSaleCategoriesCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutPointOfSaleCategoriesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PointOfSaleCategoryLocaleUpsertLocaleRelationInput"] | undefined,
	connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutPointOfSaleCategoriesUpdateInput"]: {
		businessCategories?: Array<GraphQLTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateDeliveryMethodsEntityRelationInput"]: {
		create?: GraphQLTypes["DeliveryMethodLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateDeliveryMethodsRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertDeliveryMethodsRelationInput"] | undefined,
	connect?: GraphQLTypes["DeliveryMethodLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["DeliveryMethodLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["DeliveryMethodLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateDeliveryMethodsRelationInput"]: {
		by?: GraphQLTypes["DeliveryMethodLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["DeliveryMethodLocaleWithoutLocaleUpdateInput"] | undefined
};
	["DeliveryMethodLocaleWithoutLocaleUpdateInput"]: {
		name?: string | undefined,
	description?: string | undefined,
	trackingCodeUrlTemplate?: string | undefined,
	processingTitle?: string | undefined,
	processingText?: string | undefined,
	processingIconUrl?: string | undefined,
	dispatchedTitle?: string | undefined,
	dispatchedText?: string | undefined,
	dispatchedIconUrl?: string | undefined,
	fulfilledTitle?: string | undefined,
	fulfilledText?: string | undefined,
	fulfilledIconUrl?: string | undefined,
	root?: GraphQLTypes["DeliveryMethodLocaleUpdateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryMethodLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["DeliveryMethodWithoutLocalesCreateInput"] | undefined,
	update?: GraphQLTypes["DeliveryMethodWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["DeliveryMethodLocaleUpsertRootRelationInput"] | undefined,
	connect?: GraphQLTypes["DeliveryMethodUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["DeliveryMethodWithoutLocalesUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	enabled?: boolean | undefined,
	paymentMethods?: Array<GraphQLTypes["DeliveryMethodUpdatePaymentMethodsEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	requireDeliveryAddress?: boolean | undefined,
	suitableForDeliveryZones?: Array<GraphQLTypes["DeliveryMethodUpdateSuitableForDeliveryZonesEntityRelationInput"]> | undefined,
	channels?: Array<GraphQLTypes["DeliveryMethodUpdateChannelsEntityRelationInput"]> | undefined,
	courierHandlers?: Array<GraphQLTypes["DeliveryMethodUpdateCourierHandlersEntityRelationInput"]> | undefined,
	enableDeliveryTracking?: boolean | undefined,
	timelinePreset?: GraphQLTypes["DeliveryMethodUpdateTimelinePresetEntityRelationInput"] | undefined,
	woltDriveVenueId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryMethodUpdateTimelinePresetEntityRelationInput"]: {
		create?: GraphQLTypes["DeliveryTimelinePresetWithoutDeliveryMethodCreateInput"] | undefined,
	update?: GraphQLTypes["DeliveryTimelinePresetWithoutDeliveryMethodUpdateInput"] | undefined,
	upsert?: GraphQLTypes["DeliveryMethodUpsertTimelinePresetRelationInput"] | undefined,
	connect?: GraphQLTypes["DeliveryTimelinePresetUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["DeliveryTimelinePresetWithoutDeliveryMethodUpdateInput"]: {
		type?: GraphQLTypes["DeliveryTimelineType"] | undefined,
	duration?: string | undefined,
	window?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryMethodUpsertTimelinePresetRelationInput"]: {
		update?: GraphQLTypes["DeliveryTimelinePresetWithoutDeliveryMethodUpdateInput"] | undefined,
	create?: GraphQLTypes["DeliveryTimelinePresetWithoutDeliveryMethodCreateInput"] | undefined
};
	["DeliveryMethodLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["DeliveryMethodWithoutLocalesUpdateInput"] | undefined,
	create?: GraphQLTypes["DeliveryMethodWithoutLocalesCreateInput"] | undefined
};
	["LocaleUpsertDeliveryMethodsRelationInput"]: {
		by?: GraphQLTypes["DeliveryMethodLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["DeliveryMethodLocaleWithoutLocaleUpdateInput"] | undefined,
	create?: GraphQLTypes["DeliveryMethodLocaleWithoutLocaleCreateInput"] | undefined
};
	["LocaleUpdateIngredientSuppliersEntityRelationInput"]: {
		create?: GraphQLTypes["IngredientSupplierLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateIngredientSuppliersRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertIngredientSuppliersRelationInput"] | undefined,
	connect?: GraphQLTypes["IngredientSupplierLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["IngredientSupplierLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["IngredientSupplierLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateIngredientSuppliersRelationInput"]: {
		by?: GraphQLTypes["IngredientSupplierLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["IngredientSupplierLocaleWithoutLocaleUpdateInput"] | undefined
};
	["IngredientSupplierLocaleWithoutLocaleUpdateInput"]: {
		name?: string | undefined,
	root?: GraphQLTypes["IngredientSupplierLocaleUpdateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["IngredientSupplierLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["IngredientSupplierWithoutLocalesCreateInput"] | undefined,
	update?: GraphQLTypes["IngredientSupplierWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["IngredientSupplierLocaleUpsertRootRelationInput"] | undefined,
	connect?: GraphQLTypes["IngredientSupplierUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["IngredientSupplierWithoutLocalesUpdateInput"]: {
		internalName?: string | undefined,
	internalNote?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["IngredientSupplierLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["IngredientSupplierWithoutLocalesUpdateInput"] | undefined,
	create?: GraphQLTypes["IngredientSupplierWithoutLocalesCreateInput"] | undefined
};
	["LocaleUpsertIngredientSuppliersRelationInput"]: {
		by?: GraphQLTypes["IngredientSupplierLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["IngredientSupplierLocaleWithoutLocaleUpdateInput"] | undefined,
	create?: GraphQLTypes["IngredientSupplierLocaleWithoutLocaleCreateInput"] | undefined
};
	["LocaleUpdateIdentificationCodesEntityRelationInput"]: {
		create?: GraphQLTypes["IdentificationCodeLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateIdentificationCodesRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertIdentificationCodesRelationInput"] | undefined,
	connect?: GraphQLTypes["IdentificationCodeLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["IdentificationCodeLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["IdentificationCodeLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateIdentificationCodesRelationInput"]: {
		by?: GraphQLTypes["IdentificationCodeLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["IdentificationCodeLocaleWithoutLocaleUpdateInput"] | undefined
};
	["IdentificationCodeLocaleWithoutLocaleUpdateInput"]: {
		successMessage?: string | undefined,
	root?: GraphQLTypes["IdentificationCodeLocaleUpdateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["IdentificationCodeLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["IdentificationCodeWithoutLocalesCreateInput"] | undefined,
	update?: GraphQLTypes["IdentificationCodeWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["IdentificationCodeLocaleUpsertRootRelationInput"] | undefined,
	connect?: GraphQLTypes["IdentificationCodeUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["IdentificationCodeWithoutLocalesUpdateInput"]: {
		code?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	attempts?: Array<GraphQLTypes["IdentificationCodeUpdateAttemptsEntityRelationInput"]> | undefined,
	internalName?: string | undefined,
	applicationDevices?: Array<GraphQLTypes["IdentificationCodeUpdateApplicationDevicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["IdentificationCodeUpdateApplicationDevicesEntityRelationInput"]: {
		create?: GraphQLTypes["PointOfSaleApplicationDeviceWithoutIdentificationCodeCreateInput"] | undefined,
	update?: GraphQLTypes["IdentificationCodeUpdateApplicationDevicesRelationInput"] | undefined,
	upsert?: GraphQLTypes["IdentificationCodeUpsertApplicationDevicesRelationInput"] | undefined,
	connect?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["IdentificationCodeUpdateApplicationDevicesRelationInput"]: {
		by?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined,
	data?: GraphQLTypes["PointOfSaleApplicationDeviceWithoutIdentificationCodeUpdateInput"] | undefined
};
	["PointOfSaleApplicationDeviceWithoutIdentificationCodeUpdateInput"]: {
		internalName?: string | undefined,
	note?: string | undefined,
	venue?: GraphQLTypes["PointOfSaleApplicationDeviceUpdateVenueEntityRelationInput"] | undefined,
	identifier?: GraphQLTypes["PointOfSaleApplicationDeviceUpdateIdentifierEntityRelationInput"] | undefined,
	terminal?: GraphQLTypes["PointOfSaleApplicationDeviceUpdateTerminalEntityRelationInput"] | undefined,
	receiptPrinter?: GraphQLTypes["PointOfSaleApplicationDeviceUpdateReceiptPrinterEntityRelationInput"] | undefined,
	ticketPrinters?: Array<GraphQLTypes["PointOfSaleApplicationDeviceUpdateTicketPrintersEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleApplicationDeviceUpdateTerminalEntityRelationInput"]: {
		create?: GraphQLTypes["PointOfSaleTerminalWithoutApplicationDevicesCreateInput"] | undefined,
	update?: GraphQLTypes["PointOfSaleTerminalWithoutApplicationDevicesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PointOfSaleApplicationDeviceUpsertTerminalRelationInput"] | undefined,
	connect?: GraphQLTypes["PointOfSaleTerminalUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PointOfSaleTerminalWithoutApplicationDevicesUpdateInput"]: {
		internalName?: string | undefined,
	note?: string | undefined,
	venue?: GraphQLTypes["PointOfSaleTerminalUpdateVenueEntityRelationInput"] | undefined,
	ipAddress?: string | undefined,
	port?: number | undefined,
	type?: GraphQLTypes["PointOfSaleTerminalType"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleTerminalUpdateVenueEntityRelationInput"]: {
		create?: GraphQLTypes["VenueWithoutPointOfSaleTerminalsCreateInput"] | undefined,
	update?: GraphQLTypes["VenueWithoutPointOfSaleTerminalsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PointOfSaleTerminalUpsertVenueRelationInput"] | undefined,
	connect?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["VenueWithoutPointOfSaleTerminalsUpdateInput"]: {
		name?: string | undefined,
	deadlineTemplate?: GraphQLTypes["VenueUpdateDeadlineTemplateEntityRelationInput"] | undefined,
	timetableDays?: Array<GraphQLTypes["VenueUpdateTimetableDaysEntityRelationInput"]> | undefined,
	timetableTemplates?: Array<GraphQLTypes["VenueUpdateTimetableTemplatesEntityRelationInput"]> | undefined,
	staffMembers?: Array<GraphQLTypes["VenueUpdateStaffMembersEntityRelationInput"]> | undefined,
	employeeRoles?: Array<GraphQLTypes["VenueUpdateEmployeeRolesEntityRelationInput"]> | undefined,
	pointOfSaleApplicationDevices?: Array<GraphQLTypes["VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined,
	pointOfSalePrinters?: Array<GraphQLTypes["VenueUpdatePointOfSalePrintersEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["VenueUpdateOrdersEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["VenueUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	areas?: Array<GraphQLTypes["VenueUpdateAreasEntityRelationInput"]> | undefined,
	enabledUnassignReasons?: Array<GraphQLTypes["VenueUpdateEnabledUnassignReasonsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["VenueUpdateCategoriesEntityRelationInput"]> | undefined,
	channels?: Array<GraphQLTypes["VenueUpdateChannelsEntityRelationInput"]> | undefined,
	address?: string | undefined,
	pointOfSalePngBase64ReceiptLogo?: string | undefined,
	pointOfSaleInitialView?: GraphQLTypes["PointOfSaleInitialView"] | undefined,
	pointOfSalePreferPrintReceipt?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["VenueUpdateOrdersEntityRelationInput"]: {
		create?: GraphQLTypes["OrderWithoutVenueCreateInput"] | undefined,
	update?: GraphQLTypes["VenueUpdateOrdersRelationInput"] | undefined,
	upsert?: GraphQLTypes["VenueUpsertOrdersRelationInput"] | undefined,
	connect?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	delete?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["VenueUpdateOrdersRelationInput"]: {
		by?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	data?: GraphQLTypes["OrderWithoutVenueUpdateInput"] | undefined
};
	["OrderWithoutVenueUpdateInput"]: {
		state?: GraphQLTypes["OrderState"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	canceledAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	customer?: GraphQLTypes["OrderUpdateCustomerEntityRelationInput"] | undefined,
	channel?: GraphQLTypes["OrderUpdateChannelEntityRelationInput"] | undefined,
	discounts?: Array<GraphQLTypes["OrderUpdateDiscountsEntityRelationInput"]> | undefined,
	delivery?: GraphQLTypes["OrderUpdateDeliveryEntityRelationInput"] | undefined,
	items?: Array<GraphQLTypes["OrderUpdateItemsEntityRelationInput"]> | undefined,
	internalNote?: string | undefined,
	cart?: GraphQLTypes["OrderUpdateCartEntityRelationInput"] | undefined,
	events?: Array<GraphQLTypes["OrderUpdateEventsEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddress?: GraphQLTypes["OrderUpdateBillingAddressEntityRelationInput"] | undefined,
	priceLines?: Array<GraphQLTypes["OrderUpdatePriceLinesEntityRelationInput"]> | undefined,
	payments?: Array<GraphQLTypes["OrderUpdatePaymentsEntityRelationInput"]> | undefined,
	seq?: number | undefined,
	billingSubject?: GraphQLTypes["OrderUpdateBillingSubjectEntityRelationInput"] | undefined,
	summary?: GraphQLTypes["OrderUpdateSummaryEntityRelationInput"] | undefined,
	doubleshotLegacyId?: string | undefined,
	gratuity?: GraphQLTypes["OrderUpdateGratuityEntityRelationInput"] | undefined,
	fulfillmentNote?: string | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["OrderUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	doubleshotTotalWeightGrams?: number | undefined,
	doubleShotLegacyNumber?: string | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	doubleshotAdminUrl?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["OrderItemWithoutOrderCreateInput"] | undefined,
	update?: GraphQLTypes["OrderUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["OrderUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["OrderItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["OrderItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["OrderItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["OrderUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["OrderItemUniqueWhere"] | undefined,
	data?: GraphQLTypes["OrderItemWithoutOrderUpdateInput"] | undefined
};
	["OrderItemWithoutOrderUpdateInput"]: {
		unitPriceCents?: number | undefined,
	quantity?: number | undefined,
	vatRate?: GraphQLTypes["OrderItemUpdateVatRateEntityRelationInput"] | undefined,
	virtualProductEffects?: Array<GraphQLTypes["OrderItemUpdateVirtualProductEffectsEntityRelationInput"]> | undefined,
	pickedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["OrderItemUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	product?: GraphQLTypes["OrderItemUpdateProductEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderItemUpdateVirtualProductEffectsEntityRelationInput"]: {
		create?: GraphQLTypes["VirtualProductEffectWithoutOrderItemCreateInput"] | undefined,
	update?: GraphQLTypes["OrderItemUpdateVirtualProductEffectsRelationInput"] | undefined,
	upsert?: GraphQLTypes["OrderItemUpsertVirtualProductEffectsRelationInput"] | undefined,
	connect?: GraphQLTypes["VirtualProductEffectUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["VirtualProductEffectUniqueWhere"] | undefined,
	delete?: GraphQLTypes["VirtualProductEffectUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["OrderItemUpdateVirtualProductEffectsRelationInput"]: {
		by?: GraphQLTypes["VirtualProductEffectUniqueWhere"] | undefined,
	data?: GraphQLTypes["VirtualProductEffectWithoutOrderItemUpdateInput"] | undefined
};
	["VirtualProductEffectWithoutOrderItemUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	succeededAt?: GraphQLTypes["DateTime"] | undefined,
	failedAt?: GraphQLTypes["DateTime"] | undefined,
	revertedAt?: GraphQLTypes["DateTime"] | undefined,
	resultCustomerCreditTransaction?: GraphQLTypes["VirtualProductEffectUpdateResultCustomerCreditTransactionEntityRelationInput"] | undefined,
	resultVouchers?: Array<GraphQLTypes["VirtualProductEffectUpdateResultVouchersEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["VirtualProductEffectUpdateResultCustomerCreditTransactionEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerCreditTransactionWithoutVirtualProductEffectCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerCreditTransactionWithoutVirtualProductEffectUpdateInput"] | undefined,
	upsert?: GraphQLTypes["VirtualProductEffectUpsertResultCustomerCreditTransactionRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerCreditTransactionUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CustomerCreditTransactionWithoutVirtualProductEffectUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	amountCents?: number | undefined,
	customerCredit?: GraphQLTypes["CustomerCreditTransactionUpdateCustomerCreditEntityRelationInput"] | undefined,
	orderDiscount?: GraphQLTypes["CustomerCreditTransactionUpdateOrderDiscountEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreditTransactionUpdateOrderDiscountEntityRelationInput"]: {
		create?: GraphQLTypes["OrderDiscountWithoutCustomerCreditTransactionsCreateInput"] | undefined,
	update?: GraphQLTypes["OrderDiscountWithoutCustomerCreditTransactionsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CustomerCreditTransactionUpsertOrderDiscountRelationInput"] | undefined,
	connect?: GraphQLTypes["OrderDiscountUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["OrderDiscountWithoutCustomerCreditTransactionsUpdateInput"]: {
		discountCents?: number | undefined,
	vatRate?: GraphQLTypes["OrderDiscountUpdateVatRateEntityRelationInput"] | undefined,
	order?: GraphQLTypes["OrderDiscountUpdateOrderEntityRelationInput"] | undefined,
	description?: string | undefined,
	type?: GraphQLTypes["OrderDiscountType"] | undefined,
	voucherRedemption?: GraphQLTypes["OrderDiscountUpdateVoucherRedemptionEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderDiscountUpdateOrderEntityRelationInput"]: {
		create?: GraphQLTypes["OrderWithoutDiscountsCreateInput"] | undefined,
	update?: GraphQLTypes["OrderWithoutDiscountsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["OrderDiscountUpsertOrderRelationInput"] | undefined,
	connect?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["OrderWithoutDiscountsUpdateInput"]: {
		state?: GraphQLTypes["OrderState"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	canceledAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	customer?: GraphQLTypes["OrderUpdateCustomerEntityRelationInput"] | undefined,
	channel?: GraphQLTypes["OrderUpdateChannelEntityRelationInput"] | undefined,
	delivery?: GraphQLTypes["OrderUpdateDeliveryEntityRelationInput"] | undefined,
	items?: Array<GraphQLTypes["OrderUpdateItemsEntityRelationInput"]> | undefined,
	internalNote?: string | undefined,
	cart?: GraphQLTypes["OrderUpdateCartEntityRelationInput"] | undefined,
	events?: Array<GraphQLTypes["OrderUpdateEventsEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddress?: GraphQLTypes["OrderUpdateBillingAddressEntityRelationInput"] | undefined,
	priceLines?: Array<GraphQLTypes["OrderUpdatePriceLinesEntityRelationInput"]> | undefined,
	payments?: Array<GraphQLTypes["OrderUpdatePaymentsEntityRelationInput"]> | undefined,
	seq?: number | undefined,
	billingSubject?: GraphQLTypes["OrderUpdateBillingSubjectEntityRelationInput"] | undefined,
	summary?: GraphQLTypes["OrderUpdateSummaryEntityRelationInput"] | undefined,
	doubleshotLegacyId?: string | undefined,
	gratuity?: GraphQLTypes["OrderUpdateGratuityEntityRelationInput"] | undefined,
	venue?: GraphQLTypes["OrderUpdateVenueEntityRelationInput"] | undefined,
	fulfillmentNote?: string | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["OrderUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	doubleshotTotalWeightGrams?: number | undefined,
	doubleShotLegacyNumber?: string | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	doubleshotAdminUrl?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderUpdateCartEntityRelationInput"]: {
		create?: GraphQLTypes["CartWithoutOrderCreateInput"] | undefined,
	update?: GraphQLTypes["CartWithoutOrderUpdateInput"] | undefined,
	upsert?: GraphQLTypes["OrderUpsertCartRelationInput"] | undefined,
	connect?: GraphQLTypes["CartUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CartWithoutOrderUpdateInput"]: {
		confirmedAt?: GraphQLTypes["DateTime"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	items?: Array<GraphQLTypes["CartUpdateItemsEntityRelationInput"]> | undefined,
	handle?: string | undefined,
	state?: GraphQLTypes["CartState"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	channel?: GraphQLTypes["CartUpdateChannelEntityRelationInput"] | undefined,
	customer?: GraphQLTypes["CartUpdateCustomerEntityRelationInput"] | undefined,
	deliveryAddress?: GraphQLTypes["CartUpdateDeliveryAddressEntityRelationInput"] | undefined,
	billingAddress?: GraphQLTypes["CartUpdateBillingAddressEntityRelationInput"] | undefined,
	deliveryOption?: string | undefined,
	paymentOption?: string | undefined,
	delivery?: GraphQLTypes["CartUpdateDeliveryEntityRelationInput"] | undefined,
	payment?: GraphQLTypes["CartUpdatePaymentEntityRelationInput"] | undefined,
	billingSubject?: GraphQLTypes["CartUpdateBillingSubjectEntityRelationInput"] | undefined,
	priceLines?: Array<GraphQLTypes["CartUpdatePriceLinesEntityRelationInput"]> | undefined,
	summary?: GraphQLTypes["CartUpdateSummaryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CartUpdateCustomerEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerWithoutCartsCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerWithoutCartsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CartUpsertCustomerRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CustomerWithoutCartsUpdateInput"]: {
		addresses?: Array<GraphQLTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerUpdateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerUpdateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerUpdateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerUpdateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerUpdateInvoicingPlanEntityRelationInput"]: {
		create?: GraphQLTypes["InvoicingPlanWithoutCustomerCreateInput"] | undefined,
	update?: GraphQLTypes["InvoicingPlanWithoutCustomerUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CustomerUpsertInvoicingPlanRelationInput"] | undefined,
	connect?: GraphQLTypes["InvoicingPlanUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["InvoicingPlanWithoutCustomerUpdateInput"]: {
		preset?: GraphQLTypes["InvoicingPlanUpdatePresetEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InvoicingPlanUpdatePresetEntityRelationInput"]: {
		create?: GraphQLTypes["InvoicingPresetWithoutInvoicingPlanCreateInput"] | undefined,
	update?: GraphQLTypes["InvoicingPresetWithoutInvoicingPlanUpdateInput"] | undefined,
	upsert?: GraphQLTypes["InvoicingPlanUpsertPresetRelationInput"] | undefined,
	connect?: GraphQLTypes["InvoicingPresetUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["InvoicingPresetWithoutInvoicingPlanUpdateInput"]: {
		type?: GraphQLTypes["InvoicingPresetType"] | undefined,
	startsAt?: GraphQLTypes["DateTime"] | undefined,
	endsAt?: GraphQLTypes["DateTime"] | undefined,
	intervalOfDays?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["InvoicingPlanUpsertPresetRelationInput"]: {
		update?: GraphQLTypes["InvoicingPresetWithoutInvoicingPlanUpdateInput"] | undefined,
	create?: GraphQLTypes["InvoicingPresetWithoutInvoicingPlanCreateInput"] | undefined
};
	["CustomerUpsertInvoicingPlanRelationInput"]: {
		update?: GraphQLTypes["InvoicingPlanWithoutCustomerUpdateInput"] | undefined,
	create?: GraphQLTypes["InvoicingPlanWithoutCustomerCreateInput"] | undefined
};
	["CustomerUpdateBillingSubjectsEntityRelationInput"]: {
		create?: GraphQLTypes["BillingSubjectWithoutCustomerCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerUpdateBillingSubjectsRelationInput"] | undefined,
	upsert?: GraphQLTypes["CustomerUpsertBillingSubjectsRelationInput"] | undefined,
	connect?: GraphQLTypes["BillingSubjectUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["BillingSubjectUniqueWhere"] | undefined,
	delete?: GraphQLTypes["BillingSubjectUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CustomerUpdateBillingSubjectsRelationInput"]: {
		by?: GraphQLTypes["BillingSubjectUniqueWhere"] | undefined,
	data?: GraphQLTypes["BillingSubjectWithoutCustomerUpdateInput"] | undefined
};
	["BillingSubjectWithoutCustomerUpdateInput"]: {
		name?: string | undefined,
	fullName?: string | undefined,
	addressLine1?: string | undefined,
	addressLine2?: string | undefined,
	city?: string | undefined,
	postalCode?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	companyName?: string | undefined,
	companyIdentifier?: string | undefined,
	vatIdentifier?: string | undefined,
	externalIdentifier?: string | undefined,
	hidden?: boolean | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	internalNote?: string | undefined,
	fakturoidSubjectId?: string | undefined,
	country?: GraphQLTypes["BillingSubjectUpdateCountryEntityRelationInput"] | undefined,
	invoices?: Array<GraphQLTypes["BillingSubjectUpdateInvoicesEntityRelationInput"]> | undefined,
	defaultBillingSubjectOfCustomer?: GraphQLTypes["BillingSubjectUpdateDefaultBillingSubjectOfCustomerEntityRelationInput"] | undefined,
	orders?: Array<GraphQLTypes["BillingSubjectUpdateOrdersEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["BillingSubjectUpdateCountryEntityRelationInput"]: {
		create?: GraphQLTypes["CountryCreateInput"] | undefined,
	update?: GraphQLTypes["CountryUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BillingSubjectUpsertCountryRelationInput"] | undefined,
	connect?: GraphQLTypes["CountryUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["BillingSubjectUpsertCountryRelationInput"]: {
		update?: GraphQLTypes["CountryUpdateInput"] | undefined,
	create?: GraphQLTypes["CountryCreateInput"] | undefined
};
	["BillingSubjectUpdateInvoicesEntityRelationInput"]: {
		create?: GraphQLTypes["InvoiceWithoutBillingSubjectCreateInput"] | undefined,
	update?: GraphQLTypes["BillingSubjectUpdateInvoicesRelationInput"] | undefined,
	upsert?: GraphQLTypes["BillingSubjectUpsertInvoicesRelationInput"] | undefined,
	connect?: GraphQLTypes["InvoiceUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["InvoiceUniqueWhere"] | undefined,
	delete?: GraphQLTypes["InvoiceUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["BillingSubjectUpdateInvoicesRelationInput"]: {
		by?: GraphQLTypes["InvoiceUniqueWhere"] | undefined,
	data?: GraphQLTypes["InvoiceWithoutBillingSubjectUpdateInput"] | undefined
};
	["InvoiceWithoutBillingSubjectUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	publicKey?: string | undefined,
	fakturoidId?: string | undefined,
	fakturoidData?: string | undefined,
	legacyUrl?: string | undefined,
	customer?: GraphQLTypes["InvoiceUpdateCustomerEntityRelationInput"] | undefined,
	orderPayments?: Array<GraphQLTypes["InvoiceUpdateOrderPaymentsEntityRelationInput"]> | undefined,
	address?: GraphQLTypes["InvoiceUpdateAddressEntityRelationInput"] | undefined,
	publicUrl?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["InvoiceUpdateAddressEntityRelationInput"]: {
		create?: GraphQLTypes["AddressWithoutInvoicesCreateInput"] | undefined,
	update?: GraphQLTypes["AddressWithoutInvoicesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["InvoiceUpsertAddressRelationInput"] | undefined,
	connect?: GraphQLTypes["AddressUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["AddressWithoutInvoicesUpdateInput"]: {
		name?: string | undefined,
	firstName?: string | undefined,
	lastName?: string | undefined,
	addressLine2?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	companyName?: string | undefined,
	companyIdentifier?: string | undefined,
	vatIdentifier?: string | undefined,
	externalIdentifier?: string | undefined,
	hidden?: boolean | undefined,
	customer?: GraphQLTypes["AddressUpdateCustomerEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	country?: GraphQLTypes["AddressUpdateCountryEntityRelationInput"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	googlePlaceId?: string | undefined,
	raw?: string | undefined,
	formatted?: string | undefined,
	geocodeGeneratedAt?: GraphQLTypes["DateTime"] | undefined,
	geocodeResponse?: string | undefined,
	deliveryZone?: GraphQLTypes["AddressUpdateDeliveryZoneEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["AddressUpdateMetaEntityRelationInput"] | undefined,
	gps?: GraphQLTypes["AddressUpdateGpsEntityRelationInput"] | undefined,
	geocodeValid?: boolean | undefined,
	fullName?: string | undefined,
	fakturoidSubjectId?: string | undefined,
	addressLine1?: string | undefined,
	city?: string | undefined,
	postalCode?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddressOfOrders?: Array<GraphQLTypes["AddressUpdateBillingAddressOfOrdersEntityRelationInput"]> | undefined,
	deliveryAddressOfOrderDeliveries?: Array<GraphQLTypes["AddressUpdateDeliveryAddressOfOrderDeliveriesEntityRelationInput"]> | undefined,
	defaultDeliveryAddressOfCustomer?: GraphQLTypes["AddressUpdateDefaultDeliveryAddressOfCustomerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["AddressUpdateBillingAddressOfOrdersEntityRelationInput"]: {
		create?: GraphQLTypes["OrderWithoutBillingAddressCreateInput"] | undefined,
	update?: GraphQLTypes["AddressUpdateBillingAddressOfOrdersRelationInput"] | undefined,
	upsert?: GraphQLTypes["AddressUpsertBillingAddressOfOrdersRelationInput"] | undefined,
	connect?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	delete?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["AddressUpdateBillingAddressOfOrdersRelationInput"]: {
		by?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	data?: GraphQLTypes["OrderWithoutBillingAddressUpdateInput"] | undefined
};
	["OrderWithoutBillingAddressUpdateInput"]: {
		state?: GraphQLTypes["OrderState"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	canceledAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	customer?: GraphQLTypes["OrderUpdateCustomerEntityRelationInput"] | undefined,
	channel?: GraphQLTypes["OrderUpdateChannelEntityRelationInput"] | undefined,
	discounts?: Array<GraphQLTypes["OrderUpdateDiscountsEntityRelationInput"]> | undefined,
	delivery?: GraphQLTypes["OrderUpdateDeliveryEntityRelationInput"] | undefined,
	items?: Array<GraphQLTypes["OrderUpdateItemsEntityRelationInput"]> | undefined,
	internalNote?: string | undefined,
	cart?: GraphQLTypes["OrderUpdateCartEntityRelationInput"] | undefined,
	events?: Array<GraphQLTypes["OrderUpdateEventsEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	priceLines?: Array<GraphQLTypes["OrderUpdatePriceLinesEntityRelationInput"]> | undefined,
	payments?: Array<GraphQLTypes["OrderUpdatePaymentsEntityRelationInput"]> | undefined,
	seq?: number | undefined,
	billingSubject?: GraphQLTypes["OrderUpdateBillingSubjectEntityRelationInput"] | undefined,
	summary?: GraphQLTypes["OrderUpdateSummaryEntityRelationInput"] | undefined,
	doubleshotLegacyId?: string | undefined,
	gratuity?: GraphQLTypes["OrderUpdateGratuityEntityRelationInput"] | undefined,
	venue?: GraphQLTypes["OrderUpdateVenueEntityRelationInput"] | undefined,
	fulfillmentNote?: string | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["OrderUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	doubleshotTotalWeightGrams?: number | undefined,
	doubleShotLegacyNumber?: string | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	doubleshotAdminUrl?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderUpdateEventsEntityRelationInput"]: {
		create?: GraphQLTypes["OrderEventWithoutOrderCreateInput"] | undefined,
	update?: GraphQLTypes["OrderUpdateEventsRelationInput"] | undefined,
	upsert?: GraphQLTypes["OrderUpsertEventsRelationInput"] | undefined,
	connect?: GraphQLTypes["OrderEventUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["OrderEventUniqueWhere"] | undefined,
	delete?: GraphQLTypes["OrderEventUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["OrderUpdateEventsRelationInput"]: {
		by?: GraphQLTypes["OrderEventUniqueWhere"] | undefined,
	data?: GraphQLTypes["OrderEventWithoutOrderUpdateInput"] | undefined
};
	["OrderEventWithoutOrderUpdateInput"]: {
		type?: string | undefined,
	data?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	payment?: GraphQLTypes["OrderEventUpdatePaymentEntityRelationInput"] | undefined,
	delivery?: GraphQLTypes["OrderEventUpdateDeliveryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderEventUpdatePaymentEntityRelationInput"]: {
		create?: GraphQLTypes["OrderPaymentWithoutEventsCreateInput"] | undefined,
	update?: GraphQLTypes["OrderPaymentWithoutEventsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["OrderEventUpsertPaymentRelationInput"] | undefined,
	connect?: GraphQLTypes["OrderPaymentUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["OrderPaymentWithoutEventsUpdateInput"]: {
		data?: GraphQLTypes["Json"] | undefined,
	paymentCents?: number | undefined,
	method?: GraphQLTypes["OrderPaymentUpdateMethodEntityRelationInput"] | undefined,
	failedAt?: GraphQLTypes["DateTime"] | undefined,
	state?: GraphQLTypes["OrderPaymentState"] | undefined,
	approvedAt?: GraphQLTypes["DateTime"] | undefined,
	order?: GraphQLTypes["OrderPaymentUpdateOrderEntityRelationInput"] | undefined,
	invoice?: GraphQLTypes["OrderPaymentUpdateInvoiceEntityRelationInput"] | undefined,
	walletType?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	publicReceiptUrl?: string | undefined,
	priceCents?: number | undefined,
	vatRate?: GraphQLTypes["OrderPaymentUpdateVatRateEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["OrderPaymentUpdateMetaEntityRelationInput"] | undefined,
	otherCurrencyPriceCents?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderPaymentUpdateOrderEntityRelationInput"]: {
		create?: GraphQLTypes["OrderWithoutPaymentsCreateInput"] | undefined,
	update?: GraphQLTypes["OrderWithoutPaymentsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["OrderPaymentUpsertOrderRelationInput"] | undefined,
	connect?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["OrderWithoutPaymentsUpdateInput"]: {
		state?: GraphQLTypes["OrderState"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	canceledAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	customer?: GraphQLTypes["OrderUpdateCustomerEntityRelationInput"] | undefined,
	channel?: GraphQLTypes["OrderUpdateChannelEntityRelationInput"] | undefined,
	discounts?: Array<GraphQLTypes["OrderUpdateDiscountsEntityRelationInput"]> | undefined,
	delivery?: GraphQLTypes["OrderUpdateDeliveryEntityRelationInput"] | undefined,
	items?: Array<GraphQLTypes["OrderUpdateItemsEntityRelationInput"]> | undefined,
	internalNote?: string | undefined,
	cart?: GraphQLTypes["OrderUpdateCartEntityRelationInput"] | undefined,
	events?: Array<GraphQLTypes["OrderUpdateEventsEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddress?: GraphQLTypes["OrderUpdateBillingAddressEntityRelationInput"] | undefined,
	priceLines?: Array<GraphQLTypes["OrderUpdatePriceLinesEntityRelationInput"]> | undefined,
	seq?: number | undefined,
	billingSubject?: GraphQLTypes["OrderUpdateBillingSubjectEntityRelationInput"] | undefined,
	summary?: GraphQLTypes["OrderUpdateSummaryEntityRelationInput"] | undefined,
	doubleshotLegacyId?: string | undefined,
	gratuity?: GraphQLTypes["OrderUpdateGratuityEntityRelationInput"] | undefined,
	venue?: GraphQLTypes["OrderUpdateVenueEntityRelationInput"] | undefined,
	fulfillmentNote?: string | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["OrderUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	doubleshotTotalWeightGrams?: number | undefined,
	doubleShotLegacyNumber?: string | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	doubleshotAdminUrl?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderUpdateBillingAddressEntityRelationInput"]: {
		create?: GraphQLTypes["AddressWithoutBillingAddressOfOrdersCreateInput"] | undefined,
	update?: GraphQLTypes["AddressWithoutBillingAddressOfOrdersUpdateInput"] | undefined,
	upsert?: GraphQLTypes["OrderUpsertBillingAddressRelationInput"] | undefined,
	connect?: GraphQLTypes["AddressUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["AddressWithoutBillingAddressOfOrdersUpdateInput"]: {
		name?: string | undefined,
	firstName?: string | undefined,
	lastName?: string | undefined,
	addressLine2?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	companyName?: string | undefined,
	companyIdentifier?: string | undefined,
	vatIdentifier?: string | undefined,
	externalIdentifier?: string | undefined,
	hidden?: boolean | undefined,
	customer?: GraphQLTypes["AddressUpdateCustomerEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	country?: GraphQLTypes["AddressUpdateCountryEntityRelationInput"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	googlePlaceId?: string | undefined,
	raw?: string | undefined,
	formatted?: string | undefined,
	geocodeGeneratedAt?: GraphQLTypes["DateTime"] | undefined,
	geocodeResponse?: string | undefined,
	deliveryZone?: GraphQLTypes["AddressUpdateDeliveryZoneEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["AddressUpdateMetaEntityRelationInput"] | undefined,
	gps?: GraphQLTypes["AddressUpdateGpsEntityRelationInput"] | undefined,
	geocodeValid?: boolean | undefined,
	fullName?: string | undefined,
	fakturoidSubjectId?: string | undefined,
	invoices?: Array<GraphQLTypes["AddressUpdateInvoicesEntityRelationInput"]> | undefined,
	addressLine1?: string | undefined,
	city?: string | undefined,
	postalCode?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	deliveryAddressOfOrderDeliveries?: Array<GraphQLTypes["AddressUpdateDeliveryAddressOfOrderDeliveriesEntityRelationInput"]> | undefined,
	defaultDeliveryAddressOfCustomer?: GraphQLTypes["AddressUpdateDefaultDeliveryAddressOfCustomerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["AddressUpdateDeliveryAddressOfOrderDeliveriesEntityRelationInput"]: {
		create?: GraphQLTypes["OrderDeliveryWithoutAddressCreateInput"] | undefined,
	update?: GraphQLTypes["AddressUpdateDeliveryAddressOfOrderDeliveriesRelationInput"] | undefined,
	upsert?: GraphQLTypes["AddressUpsertDeliveryAddressOfOrderDeliveriesRelationInput"] | undefined,
	connect?: GraphQLTypes["OrderDeliveryUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["OrderDeliveryUniqueWhere"] | undefined,
	delete?: GraphQLTypes["OrderDeliveryUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["AddressUpdateDeliveryAddressOfOrderDeliveriesRelationInput"]: {
		by?: GraphQLTypes["OrderDeliveryUniqueWhere"] | undefined,
	data?: GraphQLTypes["OrderDeliveryWithoutAddressUpdateInput"] | undefined
};
	["OrderDeliveryWithoutAddressUpdateInput"]: {
		priceCents?: number | undefined,
	deliveredAt?: GraphQLTypes["DateTime"] | undefined,
	method?: GraphQLTypes["OrderDeliveryUpdateMethodEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["OrderDeliveryUpdateVatRateEntityRelationInput"] | undefined,
	order?: GraphQLTypes["OrderDeliveryUpdateOrderEntityRelationInput"] | undefined,
	expectedAt?: GraphQLTypes["DateTime"] | undefined,
	state?: GraphQLTypes["OrderDeliveryState"] | undefined,
	loadingDurationHours?: number | undefined,
	dispatchAt?: GraphQLTypes["DateTime"] | undefined,
	duration?: string | undefined,
	window?: string | undefined,
	expectedEndAt?: GraphQLTypes["DateTime"] | undefined,
	processingAt?: GraphQLTypes["DateTime"] | undefined,
	deliveringAt?: GraphQLTypes["DateTime"] | undefined,
	failedAt?: GraphQLTypes["DateTime"] | undefined,
	internalNote?: string | undefined,
	deliveryWaypoint?: GraphQLTypes["OrderDeliveryUpdateDeliveryWaypointEntityRelationInput"] | undefined,
	events?: Array<GraphQLTypes["OrderDeliveryUpdateEventsEntityRelationInput"]> | undefined,
	prepareAt?: GraphQLTypes["DateTime"] | undefined,
	liftagoRide?: GraphQLTypes["OrderDeliveryUpdateLiftagoRideEntityRelationInput"] | undefined,
	pickedAt?: GraphQLTypes["DateTime"] | undefined,
	trackingCode?: string | undefined,
	woltDriveDelivery?: GraphQLTypes["OrderDeliveryUpdateWoltDriveDeliveryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderDeliveryUpdateOrderEntityRelationInput"]: {
		create?: GraphQLTypes["OrderWithoutDeliveryCreateInput"] | undefined,
	update?: GraphQLTypes["OrderWithoutDeliveryUpdateInput"] | undefined,
	upsert?: GraphQLTypes["OrderDeliveryUpsertOrderRelationInput"] | undefined,
	connect?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["OrderWithoutDeliveryUpdateInput"]: {
		state?: GraphQLTypes["OrderState"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	canceledAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	customer?: GraphQLTypes["OrderUpdateCustomerEntityRelationInput"] | undefined,
	channel?: GraphQLTypes["OrderUpdateChannelEntityRelationInput"] | undefined,
	discounts?: Array<GraphQLTypes["OrderUpdateDiscountsEntityRelationInput"]> | undefined,
	items?: Array<GraphQLTypes["OrderUpdateItemsEntityRelationInput"]> | undefined,
	internalNote?: string | undefined,
	cart?: GraphQLTypes["OrderUpdateCartEntityRelationInput"] | undefined,
	events?: Array<GraphQLTypes["OrderUpdateEventsEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddress?: GraphQLTypes["OrderUpdateBillingAddressEntityRelationInput"] | undefined,
	priceLines?: Array<GraphQLTypes["OrderUpdatePriceLinesEntityRelationInput"]> | undefined,
	payments?: Array<GraphQLTypes["OrderUpdatePaymentsEntityRelationInput"]> | undefined,
	seq?: number | undefined,
	billingSubject?: GraphQLTypes["OrderUpdateBillingSubjectEntityRelationInput"] | undefined,
	summary?: GraphQLTypes["OrderUpdateSummaryEntityRelationInput"] | undefined,
	doubleshotLegacyId?: string | undefined,
	gratuity?: GraphQLTypes["OrderUpdateGratuityEntityRelationInput"] | undefined,
	venue?: GraphQLTypes["OrderUpdateVenueEntityRelationInput"] | undefined,
	fulfillmentNote?: string | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["OrderUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	doubleshotTotalWeightGrams?: number | undefined,
	doubleShotLegacyNumber?: string | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	doubleshotAdminUrl?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderUpdatePriceLinesEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderPriceLineUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["OrderPriceLineUniqueWhere"] | undefined,
	delete?: GraphQLTypes["OrderPriceLineUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["OrderUpdatePaymentsEntityRelationInput"]: {
		create?: GraphQLTypes["OrderPaymentWithoutOrderCreateInput"] | undefined,
	update?: GraphQLTypes["OrderUpdatePaymentsRelationInput"] | undefined,
	upsert?: GraphQLTypes["OrderUpsertPaymentsRelationInput"] | undefined,
	connect?: GraphQLTypes["OrderPaymentUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["OrderPaymentUniqueWhere"] | undefined,
	delete?: GraphQLTypes["OrderPaymentUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["OrderUpdatePaymentsRelationInput"]: {
		by?: GraphQLTypes["OrderPaymentUniqueWhere"] | undefined,
	data?: GraphQLTypes["OrderPaymentWithoutOrderUpdateInput"] | undefined
};
	["OrderPaymentWithoutOrderUpdateInput"]: {
		data?: GraphQLTypes["Json"] | undefined,
	paymentCents?: number | undefined,
	method?: GraphQLTypes["OrderPaymentUpdateMethodEntityRelationInput"] | undefined,
	failedAt?: GraphQLTypes["DateTime"] | undefined,
	state?: GraphQLTypes["OrderPaymentState"] | undefined,
	approvedAt?: GraphQLTypes["DateTime"] | undefined,
	events?: Array<GraphQLTypes["OrderPaymentUpdateEventsEntityRelationInput"]> | undefined,
	invoice?: GraphQLTypes["OrderPaymentUpdateInvoiceEntityRelationInput"] | undefined,
	walletType?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	publicReceiptUrl?: string | undefined,
	priceCents?: number | undefined,
	vatRate?: GraphQLTypes["OrderPaymentUpdateVatRateEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["OrderPaymentUpdateMetaEntityRelationInput"] | undefined,
	otherCurrencyPriceCents?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderPaymentUpdateInvoiceEntityRelationInput"]: {
		create?: GraphQLTypes["InvoiceWithoutOrderPaymentsCreateInput"] | undefined,
	update?: GraphQLTypes["InvoiceWithoutOrderPaymentsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["OrderPaymentUpsertInvoiceRelationInput"] | undefined,
	connect?: GraphQLTypes["InvoiceUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["InvoiceWithoutOrderPaymentsUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	publicKey?: string | undefined,
	fakturoidId?: string | undefined,
	fakturoidData?: string | undefined,
	legacyUrl?: string | undefined,
	customer?: GraphQLTypes["InvoiceUpdateCustomerEntityRelationInput"] | undefined,
	address?: GraphQLTypes["InvoiceUpdateAddressEntityRelationInput"] | undefined,
	publicUrl?: string | undefined,
	billingSubject?: GraphQLTypes["InvoiceUpdateBillingSubjectEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InvoiceUpdateBillingSubjectEntityRelationInput"]: {
		create?: GraphQLTypes["BillingSubjectWithoutInvoicesCreateInput"] | undefined,
	update?: GraphQLTypes["BillingSubjectWithoutInvoicesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["InvoiceUpsertBillingSubjectRelationInput"] | undefined,
	connect?: GraphQLTypes["BillingSubjectUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["BillingSubjectWithoutInvoicesUpdateInput"]: {
		name?: string | undefined,
	fullName?: string | undefined,
	addressLine1?: string | undefined,
	addressLine2?: string | undefined,
	city?: string | undefined,
	postalCode?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	companyName?: string | undefined,
	companyIdentifier?: string | undefined,
	vatIdentifier?: string | undefined,
	externalIdentifier?: string | undefined,
	hidden?: boolean | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	internalNote?: string | undefined,
	fakturoidSubjectId?: string | undefined,
	country?: GraphQLTypes["BillingSubjectUpdateCountryEntityRelationInput"] | undefined,
	customer?: GraphQLTypes["BillingSubjectUpdateCustomerEntityRelationInput"] | undefined,
	defaultBillingSubjectOfCustomer?: GraphQLTypes["BillingSubjectUpdateDefaultBillingSubjectOfCustomerEntityRelationInput"] | undefined,
	orders?: Array<GraphQLTypes["BillingSubjectUpdateOrdersEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["BillingSubjectUpdateCustomerEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerWithoutBillingSubjectsCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerWithoutBillingSubjectsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BillingSubjectUpsertCustomerRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CustomerWithoutBillingSubjectsUpdateInput"]: {
		addresses?: Array<GraphQLTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerUpdateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerUpdateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerUpdateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerUpdateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerUpdateOfferedProductsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductCustomerPriceUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductCustomerPriceUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductCustomerPriceUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"]: {
		create?: GraphQLTypes["AddressWithoutDefaultDeliveryAddressOfCustomerCreateInput"] | undefined,
	update?: GraphQLTypes["AddressWithoutDefaultDeliveryAddressOfCustomerUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CustomerUpsertDefaultDeliveryAddressRelationInput"] | undefined,
	connect?: GraphQLTypes["AddressUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["AddressWithoutDefaultDeliveryAddressOfCustomerUpdateInput"]: {
		name?: string | undefined,
	firstName?: string | undefined,
	lastName?: string | undefined,
	addressLine2?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	companyName?: string | undefined,
	companyIdentifier?: string | undefined,
	vatIdentifier?: string | undefined,
	externalIdentifier?: string | undefined,
	hidden?: boolean | undefined,
	customer?: GraphQLTypes["AddressUpdateCustomerEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	country?: GraphQLTypes["AddressUpdateCountryEntityRelationInput"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	googlePlaceId?: string | undefined,
	raw?: string | undefined,
	formatted?: string | undefined,
	geocodeGeneratedAt?: GraphQLTypes["DateTime"] | undefined,
	geocodeResponse?: string | undefined,
	deliveryZone?: GraphQLTypes["AddressUpdateDeliveryZoneEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["AddressUpdateMetaEntityRelationInput"] | undefined,
	gps?: GraphQLTypes["AddressUpdateGpsEntityRelationInput"] | undefined,
	geocodeValid?: boolean | undefined,
	fullName?: string | undefined,
	fakturoidSubjectId?: string | undefined,
	invoices?: Array<GraphQLTypes["AddressUpdateInvoicesEntityRelationInput"]> | undefined,
	addressLine1?: string | undefined,
	city?: string | undefined,
	postalCode?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddressOfOrders?: Array<GraphQLTypes["AddressUpdateBillingAddressOfOrdersEntityRelationInput"]> | undefined,
	deliveryAddressOfOrderDeliveries?: Array<GraphQLTypes["AddressUpdateDeliveryAddressOfOrderDeliveriesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerUpsertDefaultDeliveryAddressRelationInput"]: {
		update?: GraphQLTypes["AddressWithoutDefaultDeliveryAddressOfCustomerUpdateInput"] | undefined,
	create?: GraphQLTypes["AddressWithoutDefaultDeliveryAddressOfCustomerCreateInput"] | undefined
};
	["CustomerUpdateDefaultBillingSubjectEntityRelationInput"]: {
		create?: GraphQLTypes["BillingSubjectWithoutDefaultBillingSubjectOfCustomerCreateInput"] | undefined,
	update?: GraphQLTypes["BillingSubjectWithoutDefaultBillingSubjectOfCustomerUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CustomerUpsertDefaultBillingSubjectRelationInput"] | undefined,
	connect?: GraphQLTypes["BillingSubjectUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["BillingSubjectWithoutDefaultBillingSubjectOfCustomerUpdateInput"]: {
		name?: string | undefined,
	fullName?: string | undefined,
	addressLine1?: string | undefined,
	addressLine2?: string | undefined,
	city?: string | undefined,
	postalCode?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	companyName?: string | undefined,
	companyIdentifier?: string | undefined,
	vatIdentifier?: string | undefined,
	externalIdentifier?: string | undefined,
	hidden?: boolean | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	internalNote?: string | undefined,
	fakturoidSubjectId?: string | undefined,
	country?: GraphQLTypes["BillingSubjectUpdateCountryEntityRelationInput"] | undefined,
	customer?: GraphQLTypes["BillingSubjectUpdateCustomerEntityRelationInput"] | undefined,
	invoices?: Array<GraphQLTypes["BillingSubjectUpdateInvoicesEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["BillingSubjectUpdateOrdersEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["BillingSubjectUpdateOrdersEntityRelationInput"]: {
		create?: GraphQLTypes["OrderWithoutBillingSubjectCreateInput"] | undefined,
	update?: GraphQLTypes["BillingSubjectUpdateOrdersRelationInput"] | undefined,
	upsert?: GraphQLTypes["BillingSubjectUpsertOrdersRelationInput"] | undefined,
	connect?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	delete?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["BillingSubjectUpdateOrdersRelationInput"]: {
		by?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	data?: GraphQLTypes["OrderWithoutBillingSubjectUpdateInput"] | undefined
};
	["OrderWithoutBillingSubjectUpdateInput"]: {
		state?: GraphQLTypes["OrderState"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	canceledAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	customer?: GraphQLTypes["OrderUpdateCustomerEntityRelationInput"] | undefined,
	channel?: GraphQLTypes["OrderUpdateChannelEntityRelationInput"] | undefined,
	discounts?: Array<GraphQLTypes["OrderUpdateDiscountsEntityRelationInput"]> | undefined,
	delivery?: GraphQLTypes["OrderUpdateDeliveryEntityRelationInput"] | undefined,
	items?: Array<GraphQLTypes["OrderUpdateItemsEntityRelationInput"]> | undefined,
	internalNote?: string | undefined,
	cart?: GraphQLTypes["OrderUpdateCartEntityRelationInput"] | undefined,
	events?: Array<GraphQLTypes["OrderUpdateEventsEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddress?: GraphQLTypes["OrderUpdateBillingAddressEntityRelationInput"] | undefined,
	priceLines?: Array<GraphQLTypes["OrderUpdatePriceLinesEntityRelationInput"]> | undefined,
	payments?: Array<GraphQLTypes["OrderUpdatePaymentsEntityRelationInput"]> | undefined,
	seq?: number | undefined,
	summary?: GraphQLTypes["OrderUpdateSummaryEntityRelationInput"] | undefined,
	doubleshotLegacyId?: string | undefined,
	gratuity?: GraphQLTypes["OrderUpdateGratuityEntityRelationInput"] | undefined,
	venue?: GraphQLTypes["OrderUpdateVenueEntityRelationInput"] | undefined,
	fulfillmentNote?: string | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["OrderUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	doubleshotTotalWeightGrams?: number | undefined,
	doubleShotLegacyNumber?: string | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	doubleshotAdminUrl?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderUpdateSummaryEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderSummaryUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["OrderUpdateGratuityEntityRelationInput"]: {
		create?: GraphQLTypes["GratuityWithoutOrderCreateInput"] | undefined,
	update?: GraphQLTypes["GratuityWithoutOrderUpdateInput"] | undefined,
	upsert?: GraphQLTypes["OrderUpsertGratuityRelationInput"] | undefined,
	connect?: GraphQLTypes["GratuityUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GratuityWithoutOrderUpdateInput"]: {
		amountCents?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderUpsertGratuityRelationInput"]: {
		update?: GraphQLTypes["GratuityWithoutOrderUpdateInput"] | undefined,
	create?: GraphQLTypes["GratuityWithoutOrderCreateInput"] | undefined
};
	["OrderUpdateVenueEntityRelationInput"]: {
		create?: GraphQLTypes["VenueWithoutOrdersCreateInput"] | undefined,
	update?: GraphQLTypes["VenueWithoutOrdersUpdateInput"] | undefined,
	upsert?: GraphQLTypes["OrderUpsertVenueRelationInput"] | undefined,
	connect?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["VenueWithoutOrdersUpdateInput"]: {
		name?: string | undefined,
	deadlineTemplate?: GraphQLTypes["VenueUpdateDeadlineTemplateEntityRelationInput"] | undefined,
	timetableDays?: Array<GraphQLTypes["VenueUpdateTimetableDaysEntityRelationInput"]> | undefined,
	timetableTemplates?: Array<GraphQLTypes["VenueUpdateTimetableTemplatesEntityRelationInput"]> | undefined,
	staffMembers?: Array<GraphQLTypes["VenueUpdateStaffMembersEntityRelationInput"]> | undefined,
	employeeRoles?: Array<GraphQLTypes["VenueUpdateEmployeeRolesEntityRelationInput"]> | undefined,
	pointOfSaleApplicationDevices?: Array<GraphQLTypes["VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined,
	pointOfSaleTerminals?: Array<GraphQLTypes["VenueUpdatePointOfSaleTerminalsEntityRelationInput"]> | undefined,
	pointOfSalePrinters?: Array<GraphQLTypes["VenueUpdatePointOfSalePrintersEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["VenueUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	areas?: Array<GraphQLTypes["VenueUpdateAreasEntityRelationInput"]> | undefined,
	enabledUnassignReasons?: Array<GraphQLTypes["VenueUpdateEnabledUnassignReasonsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["VenueUpdateCategoriesEntityRelationInput"]> | undefined,
	channels?: Array<GraphQLTypes["VenueUpdateChannelsEntityRelationInput"]> | undefined,
	address?: string | undefined,
	pointOfSalePngBase64ReceiptLogo?: string | undefined,
	pointOfSaleInitialView?: GraphQLTypes["PointOfSaleInitialView"] | undefined,
	pointOfSalePreferPrintReceipt?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["VenueUpdateFulfillmentNotesEntityRelationInput"]: {
		create?: GraphQLTypes["FulfillmentNoteWithoutVenuesCreateInput"] | undefined,
	update?: GraphQLTypes["VenueUpdateFulfillmentNotesRelationInput"] | undefined,
	upsert?: GraphQLTypes["VenueUpsertFulfillmentNotesRelationInput"] | undefined,
	connect?: GraphQLTypes["FulfillmentNoteUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["FulfillmentNoteUniqueWhere"] | undefined,
	delete?: GraphQLTypes["FulfillmentNoteUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["VenueUpdateFulfillmentNotesRelationInput"]: {
		by?: GraphQLTypes["FulfillmentNoteUniqueWhere"] | undefined,
	data?: GraphQLTypes["FulfillmentNoteWithoutVenuesUpdateInput"] | undefined
};
	["FulfillmentNoteWithoutVenuesUpdateInput"]: {
		note?: string | undefined,
	products?: Array<GraphQLTypes["FulfillmentNoteUpdateProductsEntityRelationInput"]> | undefined,
	tags?: Array<GraphQLTypes["FulfillmentNoteUpdateTagsEntityRelationInput"]> | undefined,
	cartItems?: Array<GraphQLTypes["FulfillmentNoteUpdateCartItemsEntityRelationInput"]> | undefined,
	orderItems?: Array<GraphQLTypes["FulfillmentNoteUpdateOrderItemsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["FulfillmentNoteUpdateOrdersEntityRelationInput"]> | undefined,
	highlight?: boolean | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	emoji?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["FulfillmentNoteUpdateCartItemsEntityRelationInput"]: {
		create?: GraphQLTypes["CartItemWithoutFulfillmentNotesCreateInput"] | undefined,
	update?: GraphQLTypes["FulfillmentNoteUpdateCartItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["FulfillmentNoteUpsertCartItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["CartItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["CartItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["CartItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["FulfillmentNoteUpdateCartItemsRelationInput"]: {
		by?: GraphQLTypes["CartItemUniqueWhere"] | undefined,
	data?: GraphQLTypes["CartItemWithoutFulfillmentNotesUpdateInput"] | undefined
};
	["CartItemWithoutFulfillmentNotesUpdateInput"]: {
		quantity?: number | undefined,
	cart?: GraphQLTypes["CartItemUpdateCartEntityRelationInput"] | undefined,
	product?: GraphQLTypes["CartItemUpdateProductEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	updatedAt?: GraphQLTypes["DateTime"] | undefined,
	fulfillmentNote?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["FulfillmentNoteUpsertCartItemsRelationInput"]: {
		by?: GraphQLTypes["CartItemUniqueWhere"] | undefined,
	update?: GraphQLTypes["CartItemWithoutFulfillmentNotesUpdateInput"] | undefined,
	create?: GraphQLTypes["CartItemWithoutFulfillmentNotesCreateInput"] | undefined
};
	["FulfillmentNoteUpdateOrderItemsEntityRelationInput"]: {
		create?: GraphQLTypes["OrderItemWithoutFulfillmentNotesCreateInput"] | undefined,
	update?: GraphQLTypes["FulfillmentNoteUpdateOrderItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["FulfillmentNoteUpsertOrderItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["OrderItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["OrderItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["OrderItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["FulfillmentNoteUpdateOrderItemsRelationInput"]: {
		by?: GraphQLTypes["OrderItemUniqueWhere"] | undefined,
	data?: GraphQLTypes["OrderItemWithoutFulfillmentNotesUpdateInput"] | undefined
};
	["OrderItemWithoutFulfillmentNotesUpdateInput"]: {
		unitPriceCents?: number | undefined,
	quantity?: number | undefined,
	vatRate?: GraphQLTypes["OrderItemUpdateVatRateEntityRelationInput"] | undefined,
	order?: GraphQLTypes["OrderItemUpdateOrderEntityRelationInput"] | undefined,
	virtualProductEffects?: Array<GraphQLTypes["OrderItemUpdateVirtualProductEffectsEntityRelationInput"]> | undefined,
	pickedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	product?: GraphQLTypes["OrderItemUpdateProductEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderItemUpdateProductEntityRelationInput"]: {
		create?: GraphQLTypes["ProductWithoutOrderItemsCreateInput"] | undefined,
	update?: GraphQLTypes["ProductWithoutOrderItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["OrderItemUpsertProductRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProductWithoutOrderItemsUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	priceCents?: number | undefined,
	notDiscountable?: boolean | undefined,
	packing?: GraphQLTypes["ProductUpdatePackingEntityRelationInput"] | undefined,
	recipe?: GraphQLTypes["ProductUpdateRecipeEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["ProductUpdateTagsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["ProductUpdateCategoriesEntityRelationInput"]> | undefined,
	vatRate?: GraphQLTypes["ProductUpdateVatRateEntityRelationInput"] | undefined,
	stocks?: Array<GraphQLTypes["ProductUpdateStocksEntityRelationInput"]> | undefined,
	groupPrices?: Array<GraphQLTypes["ProductUpdateGroupPricesEntityRelationInput"]> | undefined,
	image?: GraphQLTypes["ProductUpdateImageEntityRelationInput"] | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	cartItems?: Array<GraphQLTypes["ProductUpdateCartItemsEntityRelationInput"]> | undefined,
	availability?: GraphQLTypes["ProductAvailability"] | undefined,
	order?: number | undefined,
	manager?: GraphQLTypes["ProductUpdateManagerEntityRelationInput"] | undefined,
	maximumQuantityPerOrder?: number | undefined,
	inheritedCategories?: Array<GraphQLTypes["ProductUpdateInheritedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["ProductUpdateDeliveryZonesEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["ProductUpdateLocalesEntityRelationInput"]> | undefined,
	archivedAt?: GraphQLTypes["DateTime"] | undefined,
	customerPrices?: Array<GraphQLTypes["ProductUpdateCustomerPricesEntityRelationInput"]> | undefined,
	virtualProduct?: GraphQLTypes["ProductUpdateVirtualProductEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["ProductUpdateMetaEntityRelationInput"] | undefined,
	page?: GraphQLTypes["ProductUpdatePageEntityRelationInput"] | undefined,
	salesDays?: Array<GraphQLTypes["ProductUpdateSalesDaysEntityRelationInput"]> | undefined,
	salesWeeks?: Array<GraphQLTypes["ProductUpdateSalesWeeksEntityRelationInput"]> | undefined,
	salesMonths?: Array<GraphQLTypes["ProductUpdateSalesMonthsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["ProductUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	hasSubscription?: boolean | undefined,
	pointOfSaleTileColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderItemUpsertProductRelationInput"]: {
		update?: GraphQLTypes["ProductWithoutOrderItemsUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductWithoutOrderItemsCreateInput"] | undefined
};
	["FulfillmentNoteUpsertOrderItemsRelationInput"]: {
		by?: GraphQLTypes["OrderItemUniqueWhere"] | undefined,
	update?: GraphQLTypes["OrderItemWithoutFulfillmentNotesUpdateInput"] | undefined,
	create?: GraphQLTypes["OrderItemWithoutFulfillmentNotesCreateInput"] | undefined
};
	["FulfillmentNoteUpdateOrdersEntityRelationInput"]: {
		create?: GraphQLTypes["OrderWithoutFulfillmentNotesCreateInput"] | undefined,
	update?: GraphQLTypes["FulfillmentNoteUpdateOrdersRelationInput"] | undefined,
	upsert?: GraphQLTypes["FulfillmentNoteUpsertOrdersRelationInput"] | undefined,
	connect?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	delete?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["FulfillmentNoteUpdateOrdersRelationInput"]: {
		by?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	data?: GraphQLTypes["OrderWithoutFulfillmentNotesUpdateInput"] | undefined
};
	["OrderWithoutFulfillmentNotesUpdateInput"]: {
		state?: GraphQLTypes["OrderState"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	canceledAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	customer?: GraphQLTypes["OrderUpdateCustomerEntityRelationInput"] | undefined,
	channel?: GraphQLTypes["OrderUpdateChannelEntityRelationInput"] | undefined,
	discounts?: Array<GraphQLTypes["OrderUpdateDiscountsEntityRelationInput"]> | undefined,
	delivery?: GraphQLTypes["OrderUpdateDeliveryEntityRelationInput"] | undefined,
	items?: Array<GraphQLTypes["OrderUpdateItemsEntityRelationInput"]> | undefined,
	internalNote?: string | undefined,
	cart?: GraphQLTypes["OrderUpdateCartEntityRelationInput"] | undefined,
	events?: Array<GraphQLTypes["OrderUpdateEventsEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddress?: GraphQLTypes["OrderUpdateBillingAddressEntityRelationInput"] | undefined,
	priceLines?: Array<GraphQLTypes["OrderUpdatePriceLinesEntityRelationInput"]> | undefined,
	payments?: Array<GraphQLTypes["OrderUpdatePaymentsEntityRelationInput"]> | undefined,
	seq?: number | undefined,
	billingSubject?: GraphQLTypes["OrderUpdateBillingSubjectEntityRelationInput"] | undefined,
	summary?: GraphQLTypes["OrderUpdateSummaryEntityRelationInput"] | undefined,
	doubleshotLegacyId?: string | undefined,
	gratuity?: GraphQLTypes["OrderUpdateGratuityEntityRelationInput"] | undefined,
	venue?: GraphQLTypes["OrderUpdateVenueEntityRelationInput"] | undefined,
	fulfillmentNote?: string | undefined,
	doubleshotTotalWeightGrams?: number | undefined,
	doubleShotLegacyNumber?: string | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	doubleshotAdminUrl?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderUpdateBillingSubjectEntityRelationInput"]: {
		create?: GraphQLTypes["BillingSubjectWithoutOrdersCreateInput"] | undefined,
	update?: GraphQLTypes["BillingSubjectWithoutOrdersUpdateInput"] | undefined,
	upsert?: GraphQLTypes["OrderUpsertBillingSubjectRelationInput"] | undefined,
	connect?: GraphQLTypes["BillingSubjectUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["BillingSubjectWithoutOrdersUpdateInput"]: {
		name?: string | undefined,
	fullName?: string | undefined,
	addressLine1?: string | undefined,
	addressLine2?: string | undefined,
	city?: string | undefined,
	postalCode?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	companyName?: string | undefined,
	companyIdentifier?: string | undefined,
	vatIdentifier?: string | undefined,
	externalIdentifier?: string | undefined,
	hidden?: boolean | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	internalNote?: string | undefined,
	fakturoidSubjectId?: string | undefined,
	country?: GraphQLTypes["BillingSubjectUpdateCountryEntityRelationInput"] | undefined,
	customer?: GraphQLTypes["BillingSubjectUpdateCustomerEntityRelationInput"] | undefined,
	invoices?: Array<GraphQLTypes["BillingSubjectUpdateInvoicesEntityRelationInput"]> | undefined,
	defaultBillingSubjectOfCustomer?: GraphQLTypes["BillingSubjectUpdateDefaultBillingSubjectOfCustomerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BillingSubjectUpdateDefaultBillingSubjectOfCustomerEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerWithoutDefaultBillingSubjectCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerWithoutDefaultBillingSubjectUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BillingSubjectUpsertDefaultBillingSubjectOfCustomerRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CustomerWithoutDefaultBillingSubjectUpdateInput"]: {
		addresses?: Array<GraphQLTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerUpdateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerUpdateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerUpdateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerUpdateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerUpdateAnonymousSessionEntityRelationInput"]: {
		create?: GraphQLTypes["AnonymousSessionWithoutCustomerCreateInput"] | undefined,
	update?: GraphQLTypes["AnonymousSessionWithoutCustomerUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CustomerUpsertAnonymousSessionRelationInput"] | undefined,
	connect?: GraphQLTypes["AnonymousSessionUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["AnonymousSessionWithoutCustomerUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	lastActiveAt?: GraphQLTypes["DateTime"] | undefined,
	anonymousSessionKey?: string | undefined,
	email?: string | undefined,
	name?: string | undefined,
	internalNote?: string | undefined,
	devices?: Array<GraphQLTypes["AnonymousSessionUpdateDevicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["AnonymousSessionUpdateDevicesEntityRelationInput"]: {
		create?: GraphQLTypes["UserDeviceWithoutAnonymousSessionCreateInput"] | undefined,
	update?: GraphQLTypes["AnonymousSessionUpdateDevicesRelationInput"] | undefined,
	upsert?: GraphQLTypes["AnonymousSessionUpsertDevicesRelationInput"] | undefined,
	connect?: GraphQLTypes["UserDeviceUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["UserDeviceUniqueWhere"] | undefined,
	delete?: GraphQLTypes["UserDeviceUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["AnonymousSessionUpdateDevicesRelationInput"]: {
		by?: GraphQLTypes["UserDeviceUniqueWhere"] | undefined,
	data?: GraphQLTypes["UserDeviceWithoutAnonymousSessionUpdateInput"] | undefined
};
	["UserDeviceWithoutAnonymousSessionUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	lastActiveAt?: GraphQLTypes["DateTime"] | undefined,
	platform?: string | undefined,
	deviceId?: string | undefined,
	notificationsEnabled?: boolean | undefined,
	user?: GraphQLTypes["UserDeviceUpdateUserEntityRelationInput"] | undefined,
	appVersion?: string | undefined,
	osVersion?: string | undefined,
	apiVersion?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserDeviceUpdateUserEntityRelationInput"]: {
		create?: GraphQLTypes["UserWithoutDevicesCreateInput"] | undefined,
	update?: GraphQLTypes["UserWithoutDevicesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["UserDeviceUpsertUserRelationInput"] | undefined,
	connect?: GraphQLTypes["UserUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserWithoutDevicesUpdateInput"]: {
		name?: string | undefined,
	internalNote?: string | undefined,
	staff?: GraphQLTypes["UserUpdateStaffEntityRelationInput"] | undefined,
	customer?: GraphQLTypes["UserUpdateCustomerEntityRelationInput"] | undefined,
	tenantPersonId?: GraphQLTypes["UUID"] | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	verifiedAt?: GraphQLTypes["DateTime"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	deletionRequestedAt?: GraphQLTypes["DateTime"] | undefined,
	deletionExpectedAt?: GraphQLTypes["DateTime"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	meta?: GraphQLTypes["UserUpdateMetaEntityRelationInput"] | undefined,
	identificationAttempts?: Array<GraphQLTypes["UserUpdateIdentificationAttemptsEntityRelationInput"]> | undefined,
	roles?: GraphQLTypes["UserUpdateRolesEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserUpdateRolesEntityRelationInput"]: {
		connect?: GraphQLTypes["UserRolesUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UserDeviceUpsertUserRelationInput"]: {
		update?: GraphQLTypes["UserWithoutDevicesUpdateInput"] | undefined,
	create?: GraphQLTypes["UserWithoutDevicesCreateInput"] | undefined
};
	["AnonymousSessionUpsertDevicesRelationInput"]: {
		by?: GraphQLTypes["UserDeviceUniqueWhere"] | undefined,
	update?: GraphQLTypes["UserDeviceWithoutAnonymousSessionUpdateInput"] | undefined,
	create?: GraphQLTypes["UserDeviceWithoutAnonymousSessionCreateInput"] | undefined
};
	["CustomerUpsertAnonymousSessionRelationInput"]: {
		update?: GraphQLTypes["AnonymousSessionWithoutCustomerUpdateInput"] | undefined,
	create?: GraphQLTypes["AnonymousSessionWithoutCustomerCreateInput"] | undefined
};
	["CustomerUpdateBoughtVouchersEntityRelationInput"]: {
		create?: GraphQLTypes["VoucherWithoutBuyerCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerUpdateBoughtVouchersRelationInput"] | undefined,
	upsert?: GraphQLTypes["CustomerUpsertBoughtVouchersRelationInput"] | undefined,
	connect?: GraphQLTypes["VoucherUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["VoucherUniqueWhere"] | undefined,
	delete?: GraphQLTypes["VoucherUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CustomerUpdateBoughtVouchersRelationInput"]: {
		by?: GraphQLTypes["VoucherUniqueWhere"] | undefined,
	data?: GraphQLTypes["VoucherWithoutBuyerUpdateInput"] | undefined
};
	["VoucherWithoutBuyerUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	activatedAt?: GraphQLTypes["DateTime"] | undefined,
	expiresAt?: GraphQLTypes["DateTime"] | undefined,
	internalNote?: string | undefined,
	note?: string | undefined,
	code?: string | undefined,
	type?: GraphQLTypes["VoucherType"] | undefined,
	creditCents?: number | undefined,
	owner?: GraphQLTypes["VoucherUpdateOwnerEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["VoucherUpdateVatRateEntityRelationInput"] | undefined,
	virtualProductEffect?: GraphQLTypes["VoucherUpdateVirtualProductEffectEntityRelationInput"] | undefined,
	redemption?: GraphQLTypes["VoucherUpdateRedemptionEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["VoucherUpdateOwnerEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerWithoutOwnsVouchersCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerWithoutOwnsVouchersUpdateInput"] | undefined,
	upsert?: GraphQLTypes["VoucherUpsertOwnerRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CustomerWithoutOwnsVouchersUpdateInput"]: {
		addresses?: Array<GraphQLTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerUpdateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerUpdateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerUpdateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerUpdateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerUpdateRedeemedVouchersEntityRelationInput"]: {
		create?: GraphQLTypes["VoucherRedemptionWithoutCustomerCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerUpdateRedeemedVouchersRelationInput"] | undefined,
	upsert?: GraphQLTypes["CustomerUpsertRedeemedVouchersRelationInput"] | undefined,
	connect?: GraphQLTypes["VoucherRedemptionUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["VoucherRedemptionUniqueWhere"] | undefined,
	delete?: GraphQLTypes["VoucherRedemptionUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CustomerUpdateRedeemedVouchersRelationInput"]: {
		by?: GraphQLTypes["VoucherRedemptionUniqueWhere"] | undefined,
	data?: GraphQLTypes["VoucherRedemptionWithoutCustomerUpdateInput"] | undefined
};
	["VoucherRedemptionWithoutCustomerUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	manualRedemptionNote?: string | undefined,
	customerCredit?: GraphQLTypes["VoucherRedemptionUpdateCustomerCreditEntityRelationInput"] | undefined,
	orderDiscount?: GraphQLTypes["VoucherRedemptionUpdateOrderDiscountEntityRelationInput"] | undefined,
	voucher?: GraphQLTypes["VoucherRedemptionUpdateVoucherEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["VoucherRedemptionUpdateCustomerCreditEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerCreditWithoutVoucherRedemptionCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerCreditWithoutVoucherRedemptionUpdateInput"] | undefined,
	upsert?: GraphQLTypes["VoucherRedemptionUpsertCustomerCreditRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerCreditUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CustomerCreditWithoutVoucherRedemptionUpdateInput"]: {
		initialCreditCents?: number | undefined,
	remainingCreditsCents?: number | undefined,
	expiresAt?: GraphQLTypes["DateTime"] | undefined,
	reason?: string | undefined,
	customer?: GraphQLTypes["CustomerCreditUpdateCustomerEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["CustomerCreditUpdateVatRateEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	transactions?: Array<GraphQLTypes["CustomerCreditUpdateTransactionsEntityRelationInput"]> | undefined,
	invoiceUrl?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreditUpdateTransactionsEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerCreditTransactionWithoutCustomerCreditCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerCreditUpdateTransactionsRelationInput"] | undefined,
	upsert?: GraphQLTypes["CustomerCreditUpsertTransactionsRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerCreditTransactionUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["CustomerCreditTransactionUniqueWhere"] | undefined,
	delete?: GraphQLTypes["CustomerCreditTransactionUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CustomerCreditUpdateTransactionsRelationInput"]: {
		by?: GraphQLTypes["CustomerCreditTransactionUniqueWhere"] | undefined,
	data?: GraphQLTypes["CustomerCreditTransactionWithoutCustomerCreditUpdateInput"] | undefined
};
	["CustomerCreditTransactionWithoutCustomerCreditUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	amountCents?: number | undefined,
	orderDiscount?: GraphQLTypes["CustomerCreditTransactionUpdateOrderDiscountEntityRelationInput"] | undefined,
	virtualProductEffect?: GraphQLTypes["CustomerCreditTransactionUpdateVirtualProductEffectEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreditTransactionUpdateVirtualProductEffectEntityRelationInput"]: {
		create?: GraphQLTypes["VirtualProductEffectWithoutResultCustomerCreditTransactionCreateInput"] | undefined,
	update?: GraphQLTypes["VirtualProductEffectWithoutResultCustomerCreditTransactionUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CustomerCreditTransactionUpsertVirtualProductEffectRelationInput"] | undefined,
	connect?: GraphQLTypes["VirtualProductEffectUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["VirtualProductEffectWithoutResultCustomerCreditTransactionUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	succeededAt?: GraphQLTypes["DateTime"] | undefined,
	orderItem?: GraphQLTypes["VirtualProductEffectUpdateOrderItemEntityRelationInput"] | undefined,
	failedAt?: GraphQLTypes["DateTime"] | undefined,
	revertedAt?: GraphQLTypes["DateTime"] | undefined,
	resultVouchers?: Array<GraphQLTypes["VirtualProductEffectUpdateResultVouchersEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["VirtualProductEffectUpdateOrderItemEntityRelationInput"]: {
		create?: GraphQLTypes["OrderItemWithoutVirtualProductEffectsCreateInput"] | undefined,
	update?: GraphQLTypes["OrderItemWithoutVirtualProductEffectsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["VirtualProductEffectUpsertOrderItemRelationInput"] | undefined,
	connect?: GraphQLTypes["OrderItemUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["OrderItemWithoutVirtualProductEffectsUpdateInput"]: {
		unitPriceCents?: number | undefined,
	quantity?: number | undefined,
	vatRate?: GraphQLTypes["OrderItemUpdateVatRateEntityRelationInput"] | undefined,
	order?: GraphQLTypes["OrderItemUpdateOrderEntityRelationInput"] | undefined,
	pickedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["OrderItemUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	product?: GraphQLTypes["OrderItemUpdateProductEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderItemUpdateFulfillmentNotesEntityRelationInput"]: {
		create?: GraphQLTypes["FulfillmentNoteWithoutOrderItemsCreateInput"] | undefined,
	update?: GraphQLTypes["OrderItemUpdateFulfillmentNotesRelationInput"] | undefined,
	upsert?: GraphQLTypes["OrderItemUpsertFulfillmentNotesRelationInput"] | undefined,
	connect?: GraphQLTypes["FulfillmentNoteUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["FulfillmentNoteUniqueWhere"] | undefined,
	delete?: GraphQLTypes["FulfillmentNoteUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["OrderItemUpdateFulfillmentNotesRelationInput"]: {
		by?: GraphQLTypes["FulfillmentNoteUniqueWhere"] | undefined,
	data?: GraphQLTypes["FulfillmentNoteWithoutOrderItemsUpdateInput"] | undefined
};
	["FulfillmentNoteWithoutOrderItemsUpdateInput"]: {
		note?: string | undefined,
	products?: Array<GraphQLTypes["FulfillmentNoteUpdateProductsEntityRelationInput"]> | undefined,
	tags?: Array<GraphQLTypes["FulfillmentNoteUpdateTagsEntityRelationInput"]> | undefined,
	venues?: Array<GraphQLTypes["FulfillmentNoteUpdateVenuesEntityRelationInput"]> | undefined,
	cartItems?: Array<GraphQLTypes["FulfillmentNoteUpdateCartItemsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["FulfillmentNoteUpdateOrdersEntityRelationInput"]> | undefined,
	highlight?: boolean | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	emoji?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderItemUpsertFulfillmentNotesRelationInput"]: {
		by?: GraphQLTypes["FulfillmentNoteUniqueWhere"] | undefined,
	update?: GraphQLTypes["FulfillmentNoteWithoutOrderItemsUpdateInput"] | undefined,
	create?: GraphQLTypes["FulfillmentNoteWithoutOrderItemsCreateInput"] | undefined
};
	["VirtualProductEffectUpsertOrderItemRelationInput"]: {
		update?: GraphQLTypes["OrderItemWithoutVirtualProductEffectsUpdateInput"] | undefined,
	create?: GraphQLTypes["OrderItemWithoutVirtualProductEffectsCreateInput"] | undefined
};
	["VirtualProductEffectUpdateResultVouchersEntityRelationInput"]: {
		create?: GraphQLTypes["VoucherWithoutVirtualProductEffectCreateInput"] | undefined,
	update?: GraphQLTypes["VirtualProductEffectUpdateResultVouchersRelationInput"] | undefined,
	upsert?: GraphQLTypes["VirtualProductEffectUpsertResultVouchersRelationInput"] | undefined,
	connect?: GraphQLTypes["VoucherUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["VoucherUniqueWhere"] | undefined,
	delete?: GraphQLTypes["VoucherUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["VirtualProductEffectUpdateResultVouchersRelationInput"]: {
		by?: GraphQLTypes["VoucherUniqueWhere"] | undefined,
	data?: GraphQLTypes["VoucherWithoutVirtualProductEffectUpdateInput"] | undefined
};
	["VoucherWithoutVirtualProductEffectUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	activatedAt?: GraphQLTypes["DateTime"] | undefined,
	expiresAt?: GraphQLTypes["DateTime"] | undefined,
	internalNote?: string | undefined,
	note?: string | undefined,
	code?: string | undefined,
	type?: GraphQLTypes["VoucherType"] | undefined,
	creditCents?: number | undefined,
	buyer?: GraphQLTypes["VoucherUpdateBuyerEntityRelationInput"] | undefined,
	owner?: GraphQLTypes["VoucherUpdateOwnerEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["VoucherUpdateVatRateEntityRelationInput"] | undefined,
	redemption?: GraphQLTypes["VoucherUpdateRedemptionEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["VoucherUpdateBuyerEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerWithoutBoughtVouchersCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerWithoutBoughtVouchersUpdateInput"] | undefined,
	upsert?: GraphQLTypes["VoucherUpsertBuyerRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CustomerWithoutBoughtVouchersUpdateInput"]: {
		addresses?: Array<GraphQLTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerUpdateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerUpdateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerUpdateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerUpdateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerUpdateOwnsVouchersEntityRelationInput"]: {
		create?: GraphQLTypes["VoucherWithoutOwnerCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerUpdateOwnsVouchersRelationInput"] | undefined,
	upsert?: GraphQLTypes["CustomerUpsertOwnsVouchersRelationInput"] | undefined,
	connect?: GraphQLTypes["VoucherUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["VoucherUniqueWhere"] | undefined,
	delete?: GraphQLTypes["VoucherUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CustomerUpdateOwnsVouchersRelationInput"]: {
		by?: GraphQLTypes["VoucherUniqueWhere"] | undefined,
	data?: GraphQLTypes["VoucherWithoutOwnerUpdateInput"] | undefined
};
	["VoucherWithoutOwnerUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	activatedAt?: GraphQLTypes["DateTime"] | undefined,
	expiresAt?: GraphQLTypes["DateTime"] | undefined,
	internalNote?: string | undefined,
	note?: string | undefined,
	code?: string | undefined,
	type?: GraphQLTypes["VoucherType"] | undefined,
	creditCents?: number | undefined,
	buyer?: GraphQLTypes["VoucherUpdateBuyerEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["VoucherUpdateVatRateEntityRelationInput"] | undefined,
	virtualProductEffect?: GraphQLTypes["VoucherUpdateVirtualProductEffectEntityRelationInput"] | undefined,
	redemption?: GraphQLTypes["VoucherUpdateRedemptionEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["VoucherUpdateVatRateEntityRelationInput"]: {
		create?: GraphQLTypes["VatRateCreateInput"] | undefined,
	update?: GraphQLTypes["VatRateUpdateInput"] | undefined,
	upsert?: GraphQLTypes["VoucherUpsertVatRateRelationInput"] | undefined,
	connect?: GraphQLTypes["VatRateUniqueWhere"] | undefined
};
	["VoucherUpsertVatRateRelationInput"]: {
		update?: GraphQLTypes["VatRateUpdateInput"] | undefined,
	create?: GraphQLTypes["VatRateCreateInput"] | undefined
};
	["VoucherUpdateVirtualProductEffectEntityRelationInput"]: {
		create?: GraphQLTypes["VirtualProductEffectWithoutResultVouchersCreateInput"] | undefined,
	update?: GraphQLTypes["VirtualProductEffectWithoutResultVouchersUpdateInput"] | undefined,
	upsert?: GraphQLTypes["VoucherUpsertVirtualProductEffectRelationInput"] | undefined,
	connect?: GraphQLTypes["VirtualProductEffectUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["VirtualProductEffectWithoutResultVouchersUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	succeededAt?: GraphQLTypes["DateTime"] | undefined,
	orderItem?: GraphQLTypes["VirtualProductEffectUpdateOrderItemEntityRelationInput"] | undefined,
	failedAt?: GraphQLTypes["DateTime"] | undefined,
	revertedAt?: GraphQLTypes["DateTime"] | undefined,
	resultCustomerCreditTransaction?: GraphQLTypes["VirtualProductEffectUpdateResultCustomerCreditTransactionEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["VoucherUpsertVirtualProductEffectRelationInput"]: {
		update?: GraphQLTypes["VirtualProductEffectWithoutResultVouchersUpdateInput"] | undefined,
	create?: GraphQLTypes["VirtualProductEffectWithoutResultVouchersCreateInput"] | undefined
};
	["VoucherUpdateRedemptionEntityRelationInput"]: {
		create?: GraphQLTypes["VoucherRedemptionWithoutVoucherCreateInput"] | undefined,
	update?: GraphQLTypes["VoucherRedemptionWithoutVoucherUpdateInput"] | undefined,
	upsert?: GraphQLTypes["VoucherUpsertRedemptionRelationInput"] | undefined,
	connect?: GraphQLTypes["VoucherRedemptionUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["VoucherRedemptionWithoutVoucherUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	manualRedemptionNote?: string | undefined,
	customerCredit?: GraphQLTypes["VoucherRedemptionUpdateCustomerCreditEntityRelationInput"] | undefined,
	orderDiscount?: GraphQLTypes["VoucherRedemptionUpdateOrderDiscountEntityRelationInput"] | undefined,
	customer?: GraphQLTypes["VoucherRedemptionUpdateCustomerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["VoucherRedemptionUpdateOrderDiscountEntityRelationInput"]: {
		create?: GraphQLTypes["OrderDiscountWithoutVoucherRedemptionCreateInput"] | undefined,
	update?: GraphQLTypes["OrderDiscountWithoutVoucherRedemptionUpdateInput"] | undefined,
	upsert?: GraphQLTypes["VoucherRedemptionUpsertOrderDiscountRelationInput"] | undefined,
	connect?: GraphQLTypes["OrderDiscountUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["OrderDiscountWithoutVoucherRedemptionUpdateInput"]: {
		discountCents?: number | undefined,
	vatRate?: GraphQLTypes["OrderDiscountUpdateVatRateEntityRelationInput"] | undefined,
	order?: GraphQLTypes["OrderDiscountUpdateOrderEntityRelationInput"] | undefined,
	description?: string | undefined,
	type?: GraphQLTypes["OrderDiscountType"] | undefined,
	customerCreditTransactions?: Array<GraphQLTypes["OrderDiscountUpdateCustomerCreditTransactionsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["VoucherRedemptionUpsertOrderDiscountRelationInput"]: {
		update?: GraphQLTypes["OrderDiscountWithoutVoucherRedemptionUpdateInput"] | undefined,
	create?: GraphQLTypes["OrderDiscountWithoutVoucherRedemptionCreateInput"] | undefined
};
	["VoucherRedemptionUpdateCustomerEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerWithoutRedeemedVouchersCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerWithoutRedeemedVouchersUpdateInput"] | undefined,
	upsert?: GraphQLTypes["VoucherRedemptionUpsertCustomerRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CustomerWithoutRedeemedVouchersUpdateInput"]: {
		addresses?: Array<GraphQLTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerUpdateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerUpdateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerUpdateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerUpdateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerUpdateSpendingEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerSpendingUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CustomerUpdateCustomerTabsEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerTabWithoutCustomerCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerUpdateCustomerTabsRelationInput"] | undefined,
	upsert?: GraphQLTypes["CustomerUpsertCustomerTabsRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerTabUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["CustomerTabUniqueWhere"] | undefined,
	delete?: GraphQLTypes["CustomerTabUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CustomerUpdateCustomerTabsRelationInput"]: {
		by?: GraphQLTypes["CustomerTabUniqueWhere"] | undefined,
	data?: GraphQLTypes["CustomerTabWithoutCustomerUpdateInput"] | undefined
};
	["CustomerTabWithoutCustomerUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	color?: string | undefined,
	items?: Array<GraphQLTypes["CustomerTabUpdateItemsEntityRelationInput"]> | undefined,
	name?: string | undefined,
	meta?: GraphQLTypes["CustomerTabUpdateMetaEntityRelationInput"] | undefined,
	table?: GraphQLTypes["CustomerTabUpdateTableEntityRelationInput"] | undefined,
	seat?: GraphQLTypes["CustomerTabUpdateSeatEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerTabUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerTabItemWithoutTabCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerTabUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["CustomerTabUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerTabItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["CustomerTabItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["CustomerTabItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CustomerTabUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["CustomerTabItemUniqueWhere"] | undefined,
	data?: GraphQLTypes["CustomerTabItemWithoutTabUpdateInput"] | undefined
};
	["CustomerTabItemWithoutTabUpdateInput"]: {
		addedAt?: GraphQLTypes["DateTime"] | undefined,
	product?: GraphQLTypes["CustomerTabItemUpdateProductEntityRelationInput"] | undefined,
	paidAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerTabItemUpdateProductEntityRelationInput"]: {
		create?: GraphQLTypes["ProductCreateInput"] | undefined,
	update?: GraphQLTypes["ProductUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CustomerTabItemUpsertProductRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CustomerTabItemUpsertProductRelationInput"]: {
		update?: GraphQLTypes["ProductUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductCreateInput"] | undefined
};
	["CustomerTabUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["CustomerTabItemUniqueWhere"] | undefined,
	update?: GraphQLTypes["CustomerTabItemWithoutTabUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerTabItemWithoutTabCreateInput"] | undefined
};
	["CustomerTabUpdateMetaEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerTabMetadataUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CustomerTabUpdateTableEntityRelationInput"]: {
		create?: GraphQLTypes["TableWithoutCustomerTabsCreateInput"] | undefined,
	update?: GraphQLTypes["TableWithoutCustomerTabsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CustomerTabUpsertTableRelationInput"] | undefined,
	connect?: GraphQLTypes["TableUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TableWithoutCustomerTabsUpdateInput"]: {
		shape?: GraphQLTypes["TableShape"] | undefined,
	width?: number | undefined,
	height?: number | undefined,
	positionX?: number | undefined,
	positionY?: number | undefined,
	name?: string | undefined,
	color?: string | undefined,
	area?: GraphQLTypes["TableUpdateAreaEntityRelationInput"] | undefined,
	seats?: Array<GraphQLTypes["TableUpdateSeatsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TableUpdateAreaEntityRelationInput"]: {
		create?: GraphQLTypes["AreaWithoutTablesCreateInput"] | undefined,
	update?: GraphQLTypes["AreaWithoutTablesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TableUpsertAreaRelationInput"] | undefined,
	connect?: GraphQLTypes["AreaUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["AreaWithoutTablesUpdateInput"]: {
		order?: number | undefined,
	name?: string | undefined,
	venue?: GraphQLTypes["AreaUpdateVenueEntityRelationInput"] | undefined,
	lines?: Array<GraphQLTypes["AreaUpdateLinesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["AreaUpdateVenueEntityRelationInput"]: {
		create?: GraphQLTypes["VenueWithoutAreasCreateInput"] | undefined,
	update?: GraphQLTypes["VenueWithoutAreasUpdateInput"] | undefined,
	upsert?: GraphQLTypes["AreaUpsertVenueRelationInput"] | undefined,
	connect?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["VenueWithoutAreasUpdateInput"]: {
		name?: string | undefined,
	deadlineTemplate?: GraphQLTypes["VenueUpdateDeadlineTemplateEntityRelationInput"] | undefined,
	timetableDays?: Array<GraphQLTypes["VenueUpdateTimetableDaysEntityRelationInput"]> | undefined,
	timetableTemplates?: Array<GraphQLTypes["VenueUpdateTimetableTemplatesEntityRelationInput"]> | undefined,
	staffMembers?: Array<GraphQLTypes["VenueUpdateStaffMembersEntityRelationInput"]> | undefined,
	employeeRoles?: Array<GraphQLTypes["VenueUpdateEmployeeRolesEntityRelationInput"]> | undefined,
	pointOfSaleApplicationDevices?: Array<GraphQLTypes["VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined,
	pointOfSaleTerminals?: Array<GraphQLTypes["VenueUpdatePointOfSaleTerminalsEntityRelationInput"]> | undefined,
	pointOfSalePrinters?: Array<GraphQLTypes["VenueUpdatePointOfSalePrintersEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["VenueUpdateOrdersEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["VenueUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	enabledUnassignReasons?: Array<GraphQLTypes["VenueUpdateEnabledUnassignReasonsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["VenueUpdateCategoriesEntityRelationInput"]> | undefined,
	channels?: Array<GraphQLTypes["VenueUpdateChannelsEntityRelationInput"]> | undefined,
	address?: string | undefined,
	pointOfSalePngBase64ReceiptLogo?: string | undefined,
	pointOfSaleInitialView?: GraphQLTypes["PointOfSaleInitialView"] | undefined,
	pointOfSalePreferPrintReceipt?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["VenueUpdateEnabledUnassignReasonsEntityRelationInput"]: {
		create?: GraphQLTypes["UnassignReasonWithoutVenuesCreateInput"] | undefined,
	update?: GraphQLTypes["VenueUpdateEnabledUnassignReasonsRelationInput"] | undefined,
	upsert?: GraphQLTypes["VenueUpsertEnabledUnassignReasonsRelationInput"] | undefined,
	connect?: GraphQLTypes["UnassignReasonUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["UnassignReasonUniqueWhere"] | undefined,
	delete?: GraphQLTypes["UnassignReasonUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["VenueUpdateEnabledUnassignReasonsRelationInput"]: {
		by?: GraphQLTypes["UnassignReasonUniqueWhere"] | undefined,
	data?: GraphQLTypes["UnassignReasonWithoutVenuesUpdateInput"] | undefined
};
	["UnassignReasonWithoutVenuesUpdateInput"]: {
		order?: number | undefined,
	name?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["VenueUpsertEnabledUnassignReasonsRelationInput"]: {
		by?: GraphQLTypes["UnassignReasonUniqueWhere"] | undefined,
	update?: GraphQLTypes["UnassignReasonWithoutVenuesUpdateInput"] | undefined,
	create?: GraphQLTypes["UnassignReasonWithoutVenuesCreateInput"] | undefined
};
	["VenueUpdateCategoriesEntityRelationInput"]: {
		create?: GraphQLTypes["PointOfSaleCategoryWithoutVenueCreateInput"] | undefined,
	update?: GraphQLTypes["VenueUpdateCategoriesRelationInput"] | undefined,
	upsert?: GraphQLTypes["VenueUpsertCategoriesRelationInput"] | undefined,
	connect?: GraphQLTypes["PointOfSaleCategoryUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PointOfSaleCategoryUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PointOfSaleCategoryUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["VenueUpdateCategoriesRelationInput"]: {
		by?: GraphQLTypes["PointOfSaleCategoryUniqueWhere"] | undefined,
	data?: GraphQLTypes["PointOfSaleCategoryWithoutVenueUpdateInput"] | undefined
};
	["PointOfSaleCategoryWithoutVenueUpdateInput"]: {
		order?: number | undefined,
	slug?: string | undefined,
	locales?: Array<GraphQLTypes["PointOfSaleCategoryUpdateLocalesEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["PointOfSaleCategoryUpdateProductsEntityRelationInput"]> | undefined,
	category?: GraphQLTypes["PointOfSaleCategoryUpdateCategoryEntityRelationInput"] | undefined,
	ticketPrinters?: Array<GraphQLTypes["PointOfSaleCategoryUpdateTicketPrintersEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleCategoryUpdateCategoryEntityRelationInput"]: {
		create?: GraphQLTypes["ProductCategoryCreateInput"] | undefined,
	update?: GraphQLTypes["ProductCategoryUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PointOfSaleCategoryUpsertCategoryRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductCategoryUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PointOfSaleCategoryUpsertCategoryRelationInput"]: {
		update?: GraphQLTypes["ProductCategoryUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductCategoryCreateInput"] | undefined
};
	["PointOfSaleCategoryUpdateTicketPrintersEntityRelationInput"]: {
		create?: GraphQLTypes["PointOfSalePrinterWithoutTicketCategoriesCreateInput"] | undefined,
	update?: GraphQLTypes["PointOfSaleCategoryUpdateTicketPrintersRelationInput"] | undefined,
	upsert?: GraphQLTypes["PointOfSaleCategoryUpsertTicketPrintersRelationInput"] | undefined,
	connect?: GraphQLTypes["PointOfSalePrinterUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PointOfSalePrinterUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PointOfSalePrinterUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PointOfSaleCategoryUpdateTicketPrintersRelationInput"]: {
		by?: GraphQLTypes["PointOfSalePrinterUniqueWhere"] | undefined,
	data?: GraphQLTypes["PointOfSalePrinterWithoutTicketCategoriesUpdateInput"] | undefined
};
	["PointOfSalePrinterWithoutTicketCategoriesUpdateInput"]: {
		internalName?: string | undefined,
	note?: string | undefined,
	ipAddress?: string | undefined,
	applicationDevicesReceipt?: Array<GraphQLTypes["PointOfSalePrinterUpdateApplicationDevicesReceiptEntityRelationInput"]> | undefined,
	applicationDevicesTicket?: Array<GraphQLTypes["PointOfSalePrinterUpdateApplicationDevicesTicketEntityRelationInput"]> | undefined,
	venue?: GraphQLTypes["PointOfSalePrinterUpdateVenueEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSalePrinterUpdateApplicationDevicesTicketEntityRelationInput"]: {
		create?: GraphQLTypes["PointOfSaleApplicationDeviceWithoutTicketPrintersCreateInput"] | undefined,
	update?: GraphQLTypes["PointOfSalePrinterUpdateApplicationDevicesTicketRelationInput"] | undefined,
	upsert?: GraphQLTypes["PointOfSalePrinterUpsertApplicationDevicesTicketRelationInput"] | undefined,
	connect?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PointOfSalePrinterUpdateApplicationDevicesTicketRelationInput"]: {
		by?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined,
	data?: GraphQLTypes["PointOfSaleApplicationDeviceWithoutTicketPrintersUpdateInput"] | undefined
};
	["PointOfSaleApplicationDeviceWithoutTicketPrintersUpdateInput"]: {
		internalName?: string | undefined,
	note?: string | undefined,
	venue?: GraphQLTypes["PointOfSaleApplicationDeviceUpdateVenueEntityRelationInput"] | undefined,
	identificationCode?: GraphQLTypes["PointOfSaleApplicationDeviceUpdateIdentificationCodeEntityRelationInput"] | undefined,
	identifier?: GraphQLTypes["PointOfSaleApplicationDeviceUpdateIdentifierEntityRelationInput"] | undefined,
	terminal?: GraphQLTypes["PointOfSaleApplicationDeviceUpdateTerminalEntityRelationInput"] | undefined,
	receiptPrinter?: GraphQLTypes["PointOfSaleApplicationDeviceUpdateReceiptPrinterEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleApplicationDeviceUpdateReceiptPrinterEntityRelationInput"]: {
		create?: GraphQLTypes["PointOfSalePrinterWithoutApplicationDevicesReceiptCreateInput"] | undefined,
	update?: GraphQLTypes["PointOfSalePrinterWithoutApplicationDevicesReceiptUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PointOfSaleApplicationDeviceUpsertReceiptPrinterRelationInput"] | undefined,
	connect?: GraphQLTypes["PointOfSalePrinterUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PointOfSalePrinterWithoutApplicationDevicesReceiptUpdateInput"]: {
		internalName?: string | undefined,
	note?: string | undefined,
	ipAddress?: string | undefined,
	applicationDevicesTicket?: Array<GraphQLTypes["PointOfSalePrinterUpdateApplicationDevicesTicketEntityRelationInput"]> | undefined,
	venue?: GraphQLTypes["PointOfSalePrinterUpdateVenueEntityRelationInput"] | undefined,
	ticketCategories?: Array<GraphQLTypes["PointOfSalePrinterUpdateTicketCategoriesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSalePrinterUpdateVenueEntityRelationInput"]: {
		create?: GraphQLTypes["VenueWithoutPointOfSalePrintersCreateInput"] | undefined,
	update?: GraphQLTypes["VenueWithoutPointOfSalePrintersUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PointOfSalePrinterUpsertVenueRelationInput"] | undefined,
	connect?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["VenueWithoutPointOfSalePrintersUpdateInput"]: {
		name?: string | undefined,
	deadlineTemplate?: GraphQLTypes["VenueUpdateDeadlineTemplateEntityRelationInput"] | undefined,
	timetableDays?: Array<GraphQLTypes["VenueUpdateTimetableDaysEntityRelationInput"]> | undefined,
	timetableTemplates?: Array<GraphQLTypes["VenueUpdateTimetableTemplatesEntityRelationInput"]> | undefined,
	staffMembers?: Array<GraphQLTypes["VenueUpdateStaffMembersEntityRelationInput"]> | undefined,
	employeeRoles?: Array<GraphQLTypes["VenueUpdateEmployeeRolesEntityRelationInput"]> | undefined,
	pointOfSaleApplicationDevices?: Array<GraphQLTypes["VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined,
	pointOfSaleTerminals?: Array<GraphQLTypes["VenueUpdatePointOfSaleTerminalsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["VenueUpdateOrdersEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["VenueUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	areas?: Array<GraphQLTypes["VenueUpdateAreasEntityRelationInput"]> | undefined,
	enabledUnassignReasons?: Array<GraphQLTypes["VenueUpdateEnabledUnassignReasonsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["VenueUpdateCategoriesEntityRelationInput"]> | undefined,
	channels?: Array<GraphQLTypes["VenueUpdateChannelsEntityRelationInput"]> | undefined,
	address?: string | undefined,
	pointOfSalePngBase64ReceiptLogo?: string | undefined,
	pointOfSaleInitialView?: GraphQLTypes["PointOfSaleInitialView"] | undefined,
	pointOfSalePreferPrintReceipt?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["VenueUpdateAreasEntityRelationInput"]: {
		create?: GraphQLTypes["AreaWithoutVenueCreateInput"] | undefined,
	update?: GraphQLTypes["VenueUpdateAreasRelationInput"] | undefined,
	upsert?: GraphQLTypes["VenueUpsertAreasRelationInput"] | undefined,
	connect?: GraphQLTypes["AreaUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["AreaUniqueWhere"] | undefined,
	delete?: GraphQLTypes["AreaUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["VenueUpdateAreasRelationInput"]: {
		by?: GraphQLTypes["AreaUniqueWhere"] | undefined,
	data?: GraphQLTypes["AreaWithoutVenueUpdateInput"] | undefined
};
	["AreaWithoutVenueUpdateInput"]: {
		order?: number | undefined,
	name?: string | undefined,
	tables?: Array<GraphQLTypes["AreaUpdateTablesEntityRelationInput"]> | undefined,
	lines?: Array<GraphQLTypes["AreaUpdateLinesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["AreaUpdateTablesEntityRelationInput"]: {
		create?: GraphQLTypes["TableWithoutAreaCreateInput"] | undefined,
	update?: GraphQLTypes["AreaUpdateTablesRelationInput"] | undefined,
	upsert?: GraphQLTypes["AreaUpsertTablesRelationInput"] | undefined,
	connect?: GraphQLTypes["TableUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["TableUniqueWhere"] | undefined,
	delete?: GraphQLTypes["TableUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["AreaUpdateTablesRelationInput"]: {
		by?: GraphQLTypes["TableUniqueWhere"] | undefined,
	data?: GraphQLTypes["TableWithoutAreaUpdateInput"] | undefined
};
	["TableWithoutAreaUpdateInput"]: {
		shape?: GraphQLTypes["TableShape"] | undefined,
	width?: number | undefined,
	height?: number | undefined,
	positionX?: number | undefined,
	positionY?: number | undefined,
	name?: string | undefined,
	color?: string | undefined,
	customerTabs?: Array<GraphQLTypes["TableUpdateCustomerTabsEntityRelationInput"]> | undefined,
	seats?: Array<GraphQLTypes["TableUpdateSeatsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TableUpdateCustomerTabsEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerTabWithoutTableCreateInput"] | undefined,
	update?: GraphQLTypes["TableUpdateCustomerTabsRelationInput"] | undefined,
	upsert?: GraphQLTypes["TableUpsertCustomerTabsRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerTabUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["CustomerTabUniqueWhere"] | undefined,
	delete?: GraphQLTypes["CustomerTabUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TableUpdateCustomerTabsRelationInput"]: {
		by?: GraphQLTypes["CustomerTabUniqueWhere"] | undefined,
	data?: GraphQLTypes["CustomerTabWithoutTableUpdateInput"] | undefined
};
	["CustomerTabWithoutTableUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	color?: string | undefined,
	items?: Array<GraphQLTypes["CustomerTabUpdateItemsEntityRelationInput"]> | undefined,
	name?: string | undefined,
	meta?: GraphQLTypes["CustomerTabUpdateMetaEntityRelationInput"] | undefined,
	customer?: GraphQLTypes["CustomerTabUpdateCustomerEntityRelationInput"] | undefined,
	seat?: GraphQLTypes["CustomerTabUpdateSeatEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerTabUpdateCustomerEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerWithoutCustomerTabsCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerWithoutCustomerTabsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CustomerTabUpsertCustomerRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CustomerWithoutCustomerTabsUpdateInput"]: {
		addresses?: Array<GraphQLTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerUpdateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerUpdateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerUpdateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined,
	lead?: Array<GraphQLTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerUpdateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerUpdateLeadEntityRelationInput"]: {
		create?: GraphQLTypes["PipelineLeadWithoutCustomerCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerUpdateLeadRelationInput"] | undefined,
	upsert?: GraphQLTypes["CustomerUpsertLeadRelationInput"] | undefined,
	connect?: GraphQLTypes["PipelineLeadUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PipelineLeadUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PipelineLeadUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CustomerUpdateLeadRelationInput"]: {
		by?: GraphQLTypes["PipelineLeadUniqueWhere"] | undefined,
	data?: GraphQLTypes["PipelineLeadWithoutCustomerUpdateInput"] | undefined
};
	["PipelineLeadWithoutCustomerUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	stageItem?: GraphQLTypes["PipelineLeadUpdateStageItemEntityRelationInput"] | undefined,
	contactPerson?: string | undefined,
	cafeType?: string | undefined,
	offerType?: string | undefined,
	ownMachine?: boolean | undefined,
	customerCity?: string | undefined,
	companyId?: string | undefined,
	customerName?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	form?: GraphQLTypes["PipelineLeadUpdateFormEntityRelationInput"] | undefined,
	meta?: string | undefined,
	multiroasterType?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["PipelineLeadUpdateStageItemEntityRelationInput"]: {
		create?: GraphQLTypes["PipelineStageItemWithoutLeadCreateInput"] | undefined,
	update?: GraphQLTypes["PipelineStageItemWithoutLeadUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PipelineLeadUpsertStageItemRelationInput"] | undefined,
	connect?: GraphQLTypes["PipelineStageItemUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PipelineStageItemWithoutLeadUpdateInput"]: {
		list?: GraphQLTypes["PipelineStageItemUpdateListEntityRelationInput"] | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["PipelineStageItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["PipelineStageWithoutItemsCreateInput"] | undefined,
	update?: GraphQLTypes["PipelineStageWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PipelineStageItemUpsertListRelationInput"] | undefined,
	connect?: GraphQLTypes["PipelineStageUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["PipelineStageWithoutItemsUpdateInput"]: {
		pipeline?: GraphQLTypes["PipelineStageUpdatePipelineEntityRelationInput"] | undefined,
	order?: number | undefined,
	locales?: Array<GraphQLTypes["PipelineStageUpdateLocalesEntityRelationInput"]> | undefined,
	sentiment?: GraphQLTypes["PipelineStageUpdateSentimentEntityRelationInput"] | undefined,
	type?: GraphQLTypes["PipelineStageType"] | undefined,
	forms?: Array<GraphQLTypes["PipelineStageUpdateFormsEntityRelationInput"]> | undefined,
	showItemsWeight?: boolean | undefined,
	showItemsPrice?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PipelineStageUpdatePipelineEntityRelationInput"]: {
		create?: GraphQLTypes["PipelineWithoutStagesCreateInput"] | undefined,
	update?: GraphQLTypes["PipelineWithoutStagesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PipelineStageUpsertPipelineRelationInput"] | undefined,
	connect?: GraphQLTypes["PipelineUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PipelineWithoutStagesUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PipelineStageUpsertPipelineRelationInput"]: {
		update?: GraphQLTypes["PipelineWithoutStagesUpdateInput"] | undefined,
	create?: GraphQLTypes["PipelineWithoutStagesCreateInput"] | undefined
};
	["PipelineStageUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["PipelineStageLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["PipelineStageUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["PipelineStageUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["PipelineStageLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PipelineStageLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PipelineStageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PipelineStageUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["PipelineStageLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["PipelineStageLocaleWithoutRootUpdateInput"] | undefined
};
	["PipelineStageLocaleWithoutRootUpdateInput"]: {
		name?: string | undefined,
	locale?: GraphQLTypes["PipelineStageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PipelineStageLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutPipelineStagesCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutPipelineStagesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PipelineStageLocaleUpsertLocaleRelationInput"] | undefined,
	connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutPipelineStagesUpdateInput"]: {
		businessCategories?: Array<GraphQLTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateSubscriptionBoxesEntityRelationInput"]: {
		create?: GraphQLTypes["SubscriptionBoxLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateSubscriptionBoxesRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertSubscriptionBoxesRelationInput"] | undefined,
	connect?: GraphQLTypes["SubscriptionBoxLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["SubscriptionBoxLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["SubscriptionBoxLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateSubscriptionBoxesRelationInput"]: {
		by?: GraphQLTypes["SubscriptionBoxLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["SubscriptionBoxLocaleWithoutLocaleUpdateInput"] | undefined
};
	["SubscriptionBoxLocaleWithoutLocaleUpdateInput"]: {
		title?: string | undefined,
	stickerText?: string | undefined,
	descriptionText?: string | undefined,
	root?: GraphQLTypes["SubscriptionBoxLocaleUpdateRootEntityRelationInput"] | undefined,
	secondaryTitle?: string | undefined,
	texts?: GraphQLTypes["SubscriptionBoxLocaleUpdateTextsEntityRelationInput"] | undefined,
	secondaryTexts?: GraphQLTypes["SubscriptionBoxLocaleUpdateSecondaryTextsEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SubscriptionBoxLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["SubscriptionBoxWithoutLocalesCreateInput"] | undefined,
	update?: GraphQLTypes["SubscriptionBoxWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["SubscriptionBoxLocaleUpsertRootRelationInput"] | undefined,
	connect?: GraphQLTypes["SubscriptionBoxUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["SubscriptionBoxWithoutLocalesUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SubscriptionBoxLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["SubscriptionBoxWithoutLocalesUpdateInput"] | undefined,
	create?: GraphQLTypes["SubscriptionBoxWithoutLocalesCreateInput"] | undefined
};
	["SubscriptionBoxLocaleUpdateTextsEntityRelationInput"]: {
		create?: GraphQLTypes["TextListCreateInput"] | undefined,
	update?: GraphQLTypes["TextListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["SubscriptionBoxLocaleUpsertTextsRelationInput"] | undefined,
	connect?: GraphQLTypes["TextListUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["SubscriptionBoxLocaleUpsertTextsRelationInput"]: {
		update?: GraphQLTypes["TextListUpdateInput"] | undefined,
	create?: GraphQLTypes["TextListCreateInput"] | undefined
};
	["SubscriptionBoxLocaleUpdateSecondaryTextsEntityRelationInput"]: {
		create?: GraphQLTypes["TextListCreateInput"] | undefined,
	update?: GraphQLTypes["TextListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["SubscriptionBoxLocaleUpsertSecondaryTextsRelationInput"] | undefined,
	connect?: GraphQLTypes["TextListUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["SubscriptionBoxLocaleUpsertSecondaryTextsRelationInput"]: {
		update?: GraphQLTypes["TextListUpdateInput"] | undefined,
	create?: GraphQLTypes["TextListCreateInput"] | undefined
};
	["LocaleUpsertSubscriptionBoxesRelationInput"]: {
		by?: GraphQLTypes["SubscriptionBoxLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["SubscriptionBoxLocaleWithoutLocaleUpdateInput"] | undefined,
	create?: GraphQLTypes["SubscriptionBoxLocaleWithoutLocaleCreateInput"] | undefined
};
	["LocaleUpdateBusinessServicesEntityRelationInput"]: {
		create?: GraphQLTypes["BusinessServiceLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdateBusinessServicesRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertBusinessServicesRelationInput"] | undefined,
	connect?: GraphQLTypes["BusinessServiceLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["BusinessServiceLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["BusinessServiceLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdateBusinessServicesRelationInput"]: {
		by?: GraphQLTypes["BusinessServiceLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["BusinessServiceLocaleWithoutLocaleUpdateInput"] | undefined
};
	["BusinessServiceLocaleWithoutLocaleUpdateInput"]: {
		name?: string | undefined,
	labelNote?: string | undefined,
	root?: GraphQLTypes["BusinessServiceLocaleUpdateRootEntityRelationInput"] | undefined,
	labelNumberOfPeople?: string | undefined,
	labelInvoiced?: string | undefined,
	labelEquipment?: string | undefined,
	labelMillTamDem?: string | undefined,
	labelSOEspresso?: string | undefined,
	labelFilterCoffeeInMenu?: string | undefined,
	labelWaterMeterStatus?: string | undefined,
	labelServiceAction?: string | undefined,
	labelInvoiceIdentifier?: string | undefined,
	labelSupervisor?: string | undefined,
	labelContact?: string | undefined,
	labelPhone?: string | undefined,
	labelEmail?: string | undefined,
	labelGrindingStonesCondition?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessServiceLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["BusinessServiceWithoutLocalesCreateInput"] | undefined,
	update?: GraphQLTypes["BusinessServiceWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BusinessServiceLocaleUpsertRootRelationInput"] | undefined,
	connect?: GraphQLTypes["BusinessServiceUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["BusinessServiceWithoutLocalesUpdateInput"]: {
		order?: number | undefined,
	requireNote?: number | undefined,
	requireNumberOfPeople?: number | undefined,
	requireInvoiced?: number | undefined,
	requireEquipment?: number | undefined,
	requireMillTamDem?: number | undefined,
	requireSOEspresso?: number | undefined,
	requireFilterCoffeeInMenu?: number | undefined,
	requireWaterMeterStatus?: number | undefined,
	requireServiceAction?: number | undefined,
	optionsEquipment?: string | undefined,
	optionsServiceAction?: string | undefined,
	requireInvoiceIdentifier?: number | undefined,
	requireSupervisor?: number | undefined,
	requireContact?: number | undefined,
	requirePhone?: number | undefined,
	requireEmail?: number | undefined,
	requireGrindingStonesCondition?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessServiceLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["BusinessServiceWithoutLocalesUpdateInput"] | undefined,
	create?: GraphQLTypes["BusinessServiceWithoutLocalesCreateInput"] | undefined
};
	["LocaleUpsertBusinessServicesRelationInput"]: {
		by?: GraphQLTypes["BusinessServiceLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["BusinessServiceLocaleWithoutLocaleUpdateInput"] | undefined,
	create?: GraphQLTypes["BusinessServiceLocaleWithoutLocaleCreateInput"] | undefined
};
	["PipelineStageLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutPipelineStagesUpdateInput"] | undefined,
	create?: GraphQLTypes["LocaleWithoutPipelineStagesCreateInput"] | undefined
};
	["PipelineStageUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["PipelineStageLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["PipelineStageLocaleWithoutRootUpdateInput"] | undefined,
	create?: GraphQLTypes["PipelineStageLocaleWithoutRootCreateInput"] | undefined
};
	["PipelineStageUpdateSentimentEntityRelationInput"]: {
		create?: GraphQLTypes["PipelineStageSentimentCreateInput"] | undefined,
	update?: GraphQLTypes["PipelineStageSentimentUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PipelineStageUpsertSentimentRelationInput"] | undefined,
	connect?: GraphQLTypes["PipelineStageSentimentUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PipelineStageSentimentUpdateInput"]: {
		internalName?: string | undefined,
	backgroundColor?: string | undefined,
	textColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["PipelineStageUpsertSentimentRelationInput"]: {
		update?: GraphQLTypes["PipelineStageSentimentUpdateInput"] | undefined,
	create?: GraphQLTypes["PipelineStageSentimentCreateInput"] | undefined
};
	["PipelineStageUpdateFormsEntityRelationInput"]: {
		create?: GraphQLTypes["LeadFormWithoutStageCreateInput"] | undefined,
	update?: GraphQLTypes["PipelineStageUpdateFormsRelationInput"] | undefined,
	upsert?: GraphQLTypes["PipelineStageUpsertFormsRelationInput"] | undefined,
	connect?: GraphQLTypes["LeadFormUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["LeadFormUniqueWhere"] | undefined,
	delete?: GraphQLTypes["LeadFormUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PipelineStageUpdateFormsRelationInput"]: {
		by?: GraphQLTypes["LeadFormUniqueWhere"] | undefined,
	data?: GraphQLTypes["LeadFormWithoutStageUpdateInput"] | undefined
};
	["LeadFormWithoutStageUpdateInput"]: {
		code?: string | undefined,
	leads?: Array<GraphQLTypes["LeadFormUpdateLeadsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LeadFormUpdateLeadsEntityRelationInput"]: {
		create?: GraphQLTypes["PipelineLeadWithoutFormCreateInput"] | undefined,
	update?: GraphQLTypes["LeadFormUpdateLeadsRelationInput"] | undefined,
	upsert?: GraphQLTypes["LeadFormUpsertLeadsRelationInput"] | undefined,
	connect?: GraphQLTypes["PipelineLeadUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PipelineLeadUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PipelineLeadUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LeadFormUpdateLeadsRelationInput"]: {
		by?: GraphQLTypes["PipelineLeadUniqueWhere"] | undefined,
	data?: GraphQLTypes["PipelineLeadWithoutFormUpdateInput"] | undefined
};
	["PipelineLeadWithoutFormUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	stageItem?: GraphQLTypes["PipelineLeadUpdateStageItemEntityRelationInput"] | undefined,
	contactPerson?: string | undefined,
	customer?: GraphQLTypes["PipelineLeadUpdateCustomerEntityRelationInput"] | undefined,
	cafeType?: string | undefined,
	offerType?: string | undefined,
	ownMachine?: boolean | undefined,
	customerCity?: string | undefined,
	companyId?: string | undefined,
	customerName?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	meta?: string | undefined,
	multiroasterType?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["PipelineLeadUpdateCustomerEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerWithoutLeadCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerWithoutLeadUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PipelineLeadUpsertCustomerRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CustomerWithoutLeadUpdateInput"]: {
		addresses?: Array<GraphQLTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerUpdateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerUpdateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerUpdateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerUpdateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerUpdateMetaEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerMetadataUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PipelineLeadUpsertCustomerRelationInput"]: {
		update?: GraphQLTypes["CustomerWithoutLeadUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerWithoutLeadCreateInput"] | undefined
};
	["LeadFormUpsertLeadsRelationInput"]: {
		by?: GraphQLTypes["PipelineLeadUniqueWhere"] | undefined,
	update?: GraphQLTypes["PipelineLeadWithoutFormUpdateInput"] | undefined,
	create?: GraphQLTypes["PipelineLeadWithoutFormCreateInput"] | undefined
};
	["PipelineStageUpsertFormsRelationInput"]: {
		by?: GraphQLTypes["LeadFormUniqueWhere"] | undefined,
	update?: GraphQLTypes["LeadFormWithoutStageUpdateInput"] | undefined,
	create?: GraphQLTypes["LeadFormWithoutStageCreateInput"] | undefined
};
	["PipelineStageItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["PipelineStageWithoutItemsUpdateInput"] | undefined,
	create?: GraphQLTypes["PipelineStageWithoutItemsCreateInput"] | undefined
};
	["PipelineLeadUpsertStageItemRelationInput"]: {
		update?: GraphQLTypes["PipelineStageItemWithoutLeadUpdateInput"] | undefined,
	create?: GraphQLTypes["PipelineStageItemWithoutLeadCreateInput"] | undefined
};
	["PipelineLeadUpdateFormEntityRelationInput"]: {
		create?: GraphQLTypes["LeadFormWithoutLeadsCreateInput"] | undefined,
	update?: GraphQLTypes["LeadFormWithoutLeadsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PipelineLeadUpsertFormRelationInput"] | undefined,
	connect?: GraphQLTypes["LeadFormUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LeadFormWithoutLeadsUpdateInput"]: {
		code?: string | undefined,
	stage?: GraphQLTypes["LeadFormUpdateStageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LeadFormUpdateStageEntityRelationInput"]: {
		create?: GraphQLTypes["PipelineStageWithoutFormsCreateInput"] | undefined,
	update?: GraphQLTypes["PipelineStageWithoutFormsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["LeadFormUpsertStageRelationInput"] | undefined,
	connect?: GraphQLTypes["PipelineStageUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PipelineStageWithoutFormsUpdateInput"]: {
		items?: Array<GraphQLTypes["PipelineStageUpdateItemsEntityRelationInput"]> | undefined,
	pipeline?: GraphQLTypes["PipelineStageUpdatePipelineEntityRelationInput"] | undefined,
	order?: number | undefined,
	locales?: Array<GraphQLTypes["PipelineStageUpdateLocalesEntityRelationInput"]> | undefined,
	sentiment?: GraphQLTypes["PipelineStageUpdateSentimentEntityRelationInput"] | undefined,
	type?: GraphQLTypes["PipelineStageType"] | undefined,
	showItemsWeight?: boolean | undefined,
	showItemsPrice?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PipelineStageUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["PipelineStageItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["PipelineStageUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["PipelineStageUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["PipelineStageItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PipelineStageItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PipelineStageItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PipelineStageUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["PipelineStageItemUniqueWhere"] | undefined,
	data?: GraphQLTypes["PipelineStageItemWithoutListUpdateInput"] | undefined
};
	["PipelineStageItemWithoutListUpdateInput"]: {
		lead?: GraphQLTypes["PipelineStageItemUpdateLeadEntityRelationInput"] | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["PipelineStageItemUpdateLeadEntityRelationInput"]: {
		create?: GraphQLTypes["PipelineLeadWithoutStageItemCreateInput"] | undefined,
	update?: GraphQLTypes["PipelineLeadWithoutStageItemUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PipelineStageItemUpsertLeadRelationInput"] | undefined,
	connect?: GraphQLTypes["PipelineLeadUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PipelineLeadWithoutStageItemUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	contactPerson?: string | undefined,
	customer?: GraphQLTypes["PipelineLeadUpdateCustomerEntityRelationInput"] | undefined,
	cafeType?: string | undefined,
	offerType?: string | undefined,
	ownMachine?: boolean | undefined,
	customerCity?: string | undefined,
	companyId?: string | undefined,
	customerName?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	form?: GraphQLTypes["PipelineLeadUpdateFormEntityRelationInput"] | undefined,
	meta?: string | undefined,
	multiroasterType?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["PipelineStageItemUpsertLeadRelationInput"]: {
		update?: GraphQLTypes["PipelineLeadWithoutStageItemUpdateInput"] | undefined,
	create?: GraphQLTypes["PipelineLeadWithoutStageItemCreateInput"] | undefined
};
	["PipelineStageUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["PipelineStageItemUniqueWhere"] | undefined,
	update?: GraphQLTypes["PipelineStageItemWithoutListUpdateInput"] | undefined,
	create?: GraphQLTypes["PipelineStageItemWithoutListCreateInput"] | undefined
};
	["LeadFormUpsertStageRelationInput"]: {
		update?: GraphQLTypes["PipelineStageWithoutFormsUpdateInput"] | undefined,
	create?: GraphQLTypes["PipelineStageWithoutFormsCreateInput"] | undefined
};
	["PipelineLeadUpsertFormRelationInput"]: {
		update?: GraphQLTypes["LeadFormWithoutLeadsUpdateInput"] | undefined,
	create?: GraphQLTypes["LeadFormWithoutLeadsCreateInput"] | undefined
};
	["CustomerUpsertLeadRelationInput"]: {
		by?: GraphQLTypes["PipelineLeadUniqueWhere"] | undefined,
	update?: GraphQLTypes["PipelineLeadWithoutCustomerUpdateInput"] | undefined,
	create?: GraphQLTypes["PipelineLeadWithoutCustomerCreateInput"] | undefined
};
	["CustomerTabUpsertCustomerRelationInput"]: {
		update?: GraphQLTypes["CustomerWithoutCustomerTabsUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerWithoutCustomerTabsCreateInput"] | undefined
};
	["CustomerTabUpdateSeatEntityRelationInput"]: {
		create?: GraphQLTypes["SeatWithoutCustomerTabsCreateInput"] | undefined,
	update?: GraphQLTypes["SeatWithoutCustomerTabsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CustomerTabUpsertSeatRelationInput"] | undefined,
	connect?: GraphQLTypes["SeatUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["SeatWithoutCustomerTabsUpdateInput"]: {
		positionX?: number | undefined,
	positionY?: number | undefined,
	name?: string | undefined,
	color?: string | undefined,
	table?: GraphQLTypes["SeatUpdateTableEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeatUpdateTableEntityRelationInput"]: {
		create?: GraphQLTypes["TableWithoutSeatsCreateInput"] | undefined,
	update?: GraphQLTypes["TableWithoutSeatsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["SeatUpsertTableRelationInput"] | undefined,
	connect?: GraphQLTypes["TableUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["TableWithoutSeatsUpdateInput"]: {
		shape?: GraphQLTypes["TableShape"] | undefined,
	width?: number | undefined,
	height?: number | undefined,
	positionX?: number | undefined,
	positionY?: number | undefined,
	name?: string | undefined,
	color?: string | undefined,
	customerTabs?: Array<GraphQLTypes["TableUpdateCustomerTabsEntityRelationInput"]> | undefined,
	area?: GraphQLTypes["TableUpdateAreaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeatUpsertTableRelationInput"]: {
		update?: GraphQLTypes["TableWithoutSeatsUpdateInput"] | undefined,
	create?: GraphQLTypes["TableWithoutSeatsCreateInput"] | undefined
};
	["CustomerTabUpsertSeatRelationInput"]: {
		update?: GraphQLTypes["SeatWithoutCustomerTabsUpdateInput"] | undefined,
	create?: GraphQLTypes["SeatWithoutCustomerTabsCreateInput"] | undefined
};
	["TableUpsertCustomerTabsRelationInput"]: {
		by?: GraphQLTypes["CustomerTabUniqueWhere"] | undefined,
	update?: GraphQLTypes["CustomerTabWithoutTableUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerTabWithoutTableCreateInput"] | undefined
};
	["TableUpdateSeatsEntityRelationInput"]: {
		create?: GraphQLTypes["SeatWithoutTableCreateInput"] | undefined,
	update?: GraphQLTypes["TableUpdateSeatsRelationInput"] | undefined,
	upsert?: GraphQLTypes["TableUpsertSeatsRelationInput"] | undefined,
	connect?: GraphQLTypes["SeatUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["SeatUniqueWhere"] | undefined,
	delete?: GraphQLTypes["SeatUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["TableUpdateSeatsRelationInput"]: {
		by?: GraphQLTypes["SeatUniqueWhere"] | undefined,
	data?: GraphQLTypes["SeatWithoutTableUpdateInput"] | undefined
};
	["SeatWithoutTableUpdateInput"]: {
		positionX?: number | undefined,
	positionY?: number | undefined,
	name?: string | undefined,
	color?: string | undefined,
	customerTabs?: Array<GraphQLTypes["SeatUpdateCustomerTabsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeatUpdateCustomerTabsEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerTabWithoutSeatCreateInput"] | undefined,
	update?: GraphQLTypes["SeatUpdateCustomerTabsRelationInput"] | undefined,
	upsert?: GraphQLTypes["SeatUpsertCustomerTabsRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerTabUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["CustomerTabUniqueWhere"] | undefined,
	delete?: GraphQLTypes["CustomerTabUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["SeatUpdateCustomerTabsRelationInput"]: {
		by?: GraphQLTypes["CustomerTabUniqueWhere"] | undefined,
	data?: GraphQLTypes["CustomerTabWithoutSeatUpdateInput"] | undefined
};
	["CustomerTabWithoutSeatUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	color?: string | undefined,
	items?: Array<GraphQLTypes["CustomerTabUpdateItemsEntityRelationInput"]> | undefined,
	name?: string | undefined,
	meta?: GraphQLTypes["CustomerTabUpdateMetaEntityRelationInput"] | undefined,
	customer?: GraphQLTypes["CustomerTabUpdateCustomerEntityRelationInput"] | undefined,
	table?: GraphQLTypes["CustomerTabUpdateTableEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeatUpsertCustomerTabsRelationInput"]: {
		by?: GraphQLTypes["CustomerTabUniqueWhere"] | undefined,
	update?: GraphQLTypes["CustomerTabWithoutSeatUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerTabWithoutSeatCreateInput"] | undefined
};
	["TableUpsertSeatsRelationInput"]: {
		by?: GraphQLTypes["SeatUniqueWhere"] | undefined,
	update?: GraphQLTypes["SeatWithoutTableUpdateInput"] | undefined,
	create?: GraphQLTypes["SeatWithoutTableCreateInput"] | undefined
};
	["AreaUpsertTablesRelationInput"]: {
		by?: GraphQLTypes["TableUniqueWhere"] | undefined,
	update?: GraphQLTypes["TableWithoutAreaUpdateInput"] | undefined,
	create?: GraphQLTypes["TableWithoutAreaCreateInput"] | undefined
};
	["AreaUpdateLinesEntityRelationInput"]: {
		create?: GraphQLTypes["LineWithoutAreaCreateInput"] | undefined,
	update?: GraphQLTypes["AreaUpdateLinesRelationInput"] | undefined,
	upsert?: GraphQLTypes["AreaUpsertLinesRelationInput"] | undefined,
	connect?: GraphQLTypes["LineUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["LineUniqueWhere"] | undefined,
	delete?: GraphQLTypes["LineUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["AreaUpdateLinesRelationInput"]: {
		by?: GraphQLTypes["LineUniqueWhere"] | undefined,
	data?: GraphQLTypes["LineWithoutAreaUpdateInput"] | undefined
};
	["LineWithoutAreaUpdateInput"]: {
		positionStartX?: number | undefined,
	positionStartY?: number | undefined,
	positionEndX?: number | undefined,
	positionEndY?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["AreaUpsertLinesRelationInput"]: {
		by?: GraphQLTypes["LineUniqueWhere"] | undefined,
	update?: GraphQLTypes["LineWithoutAreaUpdateInput"] | undefined,
	create?: GraphQLTypes["LineWithoutAreaCreateInput"] | undefined
};
	["VenueUpsertAreasRelationInput"]: {
		by?: GraphQLTypes["AreaUniqueWhere"] | undefined,
	update?: GraphQLTypes["AreaWithoutVenueUpdateInput"] | undefined,
	create?: GraphQLTypes["AreaWithoutVenueCreateInput"] | undefined
};
	["VenueUpdateChannelsEntityRelationInput"]: {
		create?: GraphQLTypes["ChannelWithoutVenueCreateInput"] | undefined,
	update?: GraphQLTypes["VenueUpdateChannelsRelationInput"] | undefined,
	upsert?: GraphQLTypes["VenueUpsertChannelsRelationInput"] | undefined,
	connect?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["VenueUpdateChannelsRelationInput"]: {
		by?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	data?: GraphQLTypes["ChannelWithoutVenueUpdateInput"] | undefined
};
	["ChannelWithoutVenueUpdateInput"]: {
		name?: string | undefined,
	disabled?: boolean | undefined,
	payments?: Array<GraphQLTypes["ChannelUpdatePaymentsEntityRelationInput"]> | undefined,
	deliveries?: Array<GraphQLTypes["ChannelUpdateDeliveriesEntityRelationInput"]> | undefined,
	pointOfSales?: Array<GraphQLTypes["ChannelUpdatePointOfSalesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["ChannelUpdateCartsEntityRelationInput"]> | undefined,
	customers?: Array<GraphQLTypes["ChannelUpdateCustomersEntityRelationInput"]> | undefined,
	code?: GraphQLTypes["ChannelCode"] | undefined,
	addTagsOnRegistration?: Array<GraphQLTypes["ChannelUpdateAddTagsOnRegistrationEntityRelationInput"]> | undefined,
	publicTags?: Array<GraphQLTypes["ChannelUpdatePublicTagsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["VenueUpsertChannelsRelationInput"]: {
		by?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	update?: GraphQLTypes["ChannelWithoutVenueUpdateInput"] | undefined,
	create?: GraphQLTypes["ChannelWithoutVenueCreateInput"] | undefined
};
	["PointOfSalePrinterUpsertVenueRelationInput"]: {
		update?: GraphQLTypes["VenueWithoutPointOfSalePrintersUpdateInput"] | undefined,
	create?: GraphQLTypes["VenueWithoutPointOfSalePrintersCreateInput"] | undefined
};
	["PointOfSalePrinterUpdateTicketCategoriesEntityRelationInput"]: {
		create?: GraphQLTypes["PointOfSaleCategoryWithoutTicketPrintersCreateInput"] | undefined,
	update?: GraphQLTypes["PointOfSalePrinterUpdateTicketCategoriesRelationInput"] | undefined,
	upsert?: GraphQLTypes["PointOfSalePrinterUpsertTicketCategoriesRelationInput"] | undefined,
	connect?: GraphQLTypes["PointOfSaleCategoryUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PointOfSaleCategoryUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PointOfSaleCategoryUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PointOfSalePrinterUpdateTicketCategoriesRelationInput"]: {
		by?: GraphQLTypes["PointOfSaleCategoryUniqueWhere"] | undefined,
	data?: GraphQLTypes["PointOfSaleCategoryWithoutTicketPrintersUpdateInput"] | undefined
};
	["PointOfSaleCategoryWithoutTicketPrintersUpdateInput"]: {
		order?: number | undefined,
	slug?: string | undefined,
	locales?: Array<GraphQLTypes["PointOfSaleCategoryUpdateLocalesEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["PointOfSaleCategoryUpdateProductsEntityRelationInput"]> | undefined,
	category?: GraphQLTypes["PointOfSaleCategoryUpdateCategoryEntityRelationInput"] | undefined,
	venue?: GraphQLTypes["PointOfSaleCategoryUpdateVenueEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleCategoryUpdateVenueEntityRelationInput"]: {
		create?: GraphQLTypes["VenueWithoutCategoriesCreateInput"] | undefined,
	update?: GraphQLTypes["VenueWithoutCategoriesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PointOfSaleCategoryUpsertVenueRelationInput"] | undefined,
	connect?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["VenueWithoutCategoriesUpdateInput"]: {
		name?: string | undefined,
	deadlineTemplate?: GraphQLTypes["VenueUpdateDeadlineTemplateEntityRelationInput"] | undefined,
	timetableDays?: Array<GraphQLTypes["VenueUpdateTimetableDaysEntityRelationInput"]> | undefined,
	timetableTemplates?: Array<GraphQLTypes["VenueUpdateTimetableTemplatesEntityRelationInput"]> | undefined,
	staffMembers?: Array<GraphQLTypes["VenueUpdateStaffMembersEntityRelationInput"]> | undefined,
	employeeRoles?: Array<GraphQLTypes["VenueUpdateEmployeeRolesEntityRelationInput"]> | undefined,
	pointOfSaleApplicationDevices?: Array<GraphQLTypes["VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined,
	pointOfSaleTerminals?: Array<GraphQLTypes["VenueUpdatePointOfSaleTerminalsEntityRelationInput"]> | undefined,
	pointOfSalePrinters?: Array<GraphQLTypes["VenueUpdatePointOfSalePrintersEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["VenueUpdateOrdersEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["VenueUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	areas?: Array<GraphQLTypes["VenueUpdateAreasEntityRelationInput"]> | undefined,
	enabledUnassignReasons?: Array<GraphQLTypes["VenueUpdateEnabledUnassignReasonsEntityRelationInput"]> | undefined,
	channels?: Array<GraphQLTypes["VenueUpdateChannelsEntityRelationInput"]> | undefined,
	address?: string | undefined,
	pointOfSalePngBase64ReceiptLogo?: string | undefined,
	pointOfSaleInitialView?: GraphQLTypes["PointOfSaleInitialView"] | undefined,
	pointOfSalePreferPrintReceipt?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleCategoryUpsertVenueRelationInput"]: {
		update?: GraphQLTypes["VenueWithoutCategoriesUpdateInput"] | undefined,
	create?: GraphQLTypes["VenueWithoutCategoriesCreateInput"] | undefined
};
	["PointOfSalePrinterUpsertTicketCategoriesRelationInput"]: {
		by?: GraphQLTypes["PointOfSaleCategoryUniqueWhere"] | undefined,
	update?: GraphQLTypes["PointOfSaleCategoryWithoutTicketPrintersUpdateInput"] | undefined,
	create?: GraphQLTypes["PointOfSaleCategoryWithoutTicketPrintersCreateInput"] | undefined
};
	["PointOfSaleApplicationDeviceUpsertReceiptPrinterRelationInput"]: {
		update?: GraphQLTypes["PointOfSalePrinterWithoutApplicationDevicesReceiptUpdateInput"] | undefined,
	create?: GraphQLTypes["PointOfSalePrinterWithoutApplicationDevicesReceiptCreateInput"] | undefined
};
	["PointOfSalePrinterUpsertApplicationDevicesTicketRelationInput"]: {
		by?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined,
	update?: GraphQLTypes["PointOfSaleApplicationDeviceWithoutTicketPrintersUpdateInput"] | undefined,
	create?: GraphQLTypes["PointOfSaleApplicationDeviceWithoutTicketPrintersCreateInput"] | undefined
};
	["PointOfSaleCategoryUpsertTicketPrintersRelationInput"]: {
		by?: GraphQLTypes["PointOfSalePrinterUniqueWhere"] | undefined,
	update?: GraphQLTypes["PointOfSalePrinterWithoutTicketCategoriesUpdateInput"] | undefined,
	create?: GraphQLTypes["PointOfSalePrinterWithoutTicketCategoriesCreateInput"] | undefined
};
	["VenueUpsertCategoriesRelationInput"]: {
		by?: GraphQLTypes["PointOfSaleCategoryUniqueWhere"] | undefined,
	update?: GraphQLTypes["PointOfSaleCategoryWithoutVenueUpdateInput"] | undefined,
	create?: GraphQLTypes["PointOfSaleCategoryWithoutVenueCreateInput"] | undefined
};
	["AreaUpsertVenueRelationInput"]: {
		update?: GraphQLTypes["VenueWithoutAreasUpdateInput"] | undefined,
	create?: GraphQLTypes["VenueWithoutAreasCreateInput"] | undefined
};
	["TableUpsertAreaRelationInput"]: {
		update?: GraphQLTypes["AreaWithoutTablesUpdateInput"] | undefined,
	create?: GraphQLTypes["AreaWithoutTablesCreateInput"] | undefined
};
	["CustomerTabUpsertTableRelationInput"]: {
		update?: GraphQLTypes["TableWithoutCustomerTabsUpdateInput"] | undefined,
	create?: GraphQLTypes["TableWithoutCustomerTabsCreateInput"] | undefined
};
	["CustomerUpsertCustomerTabsRelationInput"]: {
		by?: GraphQLTypes["CustomerTabUniqueWhere"] | undefined,
	update?: GraphQLTypes["CustomerTabWithoutCustomerUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerTabWithoutCustomerCreateInput"] | undefined
};
	["VoucherRedemptionUpsertCustomerRelationInput"]: {
		update?: GraphQLTypes["CustomerWithoutRedeemedVouchersUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerWithoutRedeemedVouchersCreateInput"] | undefined
};
	["VoucherUpsertRedemptionRelationInput"]: {
		update?: GraphQLTypes["VoucherRedemptionWithoutVoucherUpdateInput"] | undefined,
	create?: GraphQLTypes["VoucherRedemptionWithoutVoucherCreateInput"] | undefined
};
	["CustomerUpsertOwnsVouchersRelationInput"]: {
		by?: GraphQLTypes["VoucherUniqueWhere"] | undefined,
	update?: GraphQLTypes["VoucherWithoutOwnerUpdateInput"] | undefined,
	create?: GraphQLTypes["VoucherWithoutOwnerCreateInput"] | undefined
};
	["VoucherUpsertBuyerRelationInput"]: {
		update?: GraphQLTypes["CustomerWithoutBoughtVouchersUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerWithoutBoughtVouchersCreateInput"] | undefined
};
	["VirtualProductEffectUpsertResultVouchersRelationInput"]: {
		by?: GraphQLTypes["VoucherUniqueWhere"] | undefined,
	update?: GraphQLTypes["VoucherWithoutVirtualProductEffectUpdateInput"] | undefined,
	create?: GraphQLTypes["VoucherWithoutVirtualProductEffectCreateInput"] | undefined
};
	["CustomerCreditTransactionUpsertVirtualProductEffectRelationInput"]: {
		update?: GraphQLTypes["VirtualProductEffectWithoutResultCustomerCreditTransactionUpdateInput"] | undefined,
	create?: GraphQLTypes["VirtualProductEffectWithoutResultCustomerCreditTransactionCreateInput"] | undefined
};
	["CustomerCreditUpsertTransactionsRelationInput"]: {
		by?: GraphQLTypes["CustomerCreditTransactionUniqueWhere"] | undefined,
	update?: GraphQLTypes["CustomerCreditTransactionWithoutCustomerCreditUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerCreditTransactionWithoutCustomerCreditCreateInput"] | undefined
};
	["VoucherRedemptionUpsertCustomerCreditRelationInput"]: {
		update?: GraphQLTypes["CustomerCreditWithoutVoucherRedemptionUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerCreditWithoutVoucherRedemptionCreateInput"] | undefined
};
	["VoucherRedemptionUpdateVoucherEntityRelationInput"]: {
		create?: GraphQLTypes["VoucherWithoutRedemptionCreateInput"] | undefined,
	update?: GraphQLTypes["VoucherWithoutRedemptionUpdateInput"] | undefined,
	upsert?: GraphQLTypes["VoucherRedemptionUpsertVoucherRelationInput"] | undefined,
	connect?: GraphQLTypes["VoucherUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["VoucherWithoutRedemptionUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	activatedAt?: GraphQLTypes["DateTime"] | undefined,
	expiresAt?: GraphQLTypes["DateTime"] | undefined,
	internalNote?: string | undefined,
	note?: string | undefined,
	code?: string | undefined,
	type?: GraphQLTypes["VoucherType"] | undefined,
	creditCents?: number | undefined,
	buyer?: GraphQLTypes["VoucherUpdateBuyerEntityRelationInput"] | undefined,
	owner?: GraphQLTypes["VoucherUpdateOwnerEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["VoucherUpdateVatRateEntityRelationInput"] | undefined,
	virtualProductEffect?: GraphQLTypes["VoucherUpdateVirtualProductEffectEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["VoucherRedemptionUpsertVoucherRelationInput"]: {
		update?: GraphQLTypes["VoucherWithoutRedemptionUpdateInput"] | undefined,
	create?: GraphQLTypes["VoucherWithoutRedemptionCreateInput"] | undefined
};
	["CustomerUpsertRedeemedVouchersRelationInput"]: {
		by?: GraphQLTypes["VoucherRedemptionUniqueWhere"] | undefined,
	update?: GraphQLTypes["VoucherRedemptionWithoutCustomerUpdateInput"] | undefined,
	create?: GraphQLTypes["VoucherRedemptionWithoutCustomerCreateInput"] | undefined
};
	["VoucherUpsertOwnerRelationInput"]: {
		update?: GraphQLTypes["CustomerWithoutOwnsVouchersUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerWithoutOwnsVouchersCreateInput"] | undefined
};
	["CustomerUpsertBoughtVouchersRelationInput"]: {
		by?: GraphQLTypes["VoucherUniqueWhere"] | undefined,
	update?: GraphQLTypes["VoucherWithoutBuyerUpdateInput"] | undefined,
	create?: GraphQLTypes["VoucherWithoutBuyerCreateInput"] | undefined
};
	["BillingSubjectUpsertDefaultBillingSubjectOfCustomerRelationInput"]: {
		update?: GraphQLTypes["CustomerWithoutDefaultBillingSubjectUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerWithoutDefaultBillingSubjectCreateInput"] | undefined
};
	["OrderUpsertBillingSubjectRelationInput"]: {
		update?: GraphQLTypes["BillingSubjectWithoutOrdersUpdateInput"] | undefined,
	create?: GraphQLTypes["BillingSubjectWithoutOrdersCreateInput"] | undefined
};
	["FulfillmentNoteUpsertOrdersRelationInput"]: {
		by?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	update?: GraphQLTypes["OrderWithoutFulfillmentNotesUpdateInput"] | undefined,
	create?: GraphQLTypes["OrderWithoutFulfillmentNotesCreateInput"] | undefined
};
	["VenueUpsertFulfillmentNotesRelationInput"]: {
		by?: GraphQLTypes["FulfillmentNoteUniqueWhere"] | undefined,
	update?: GraphQLTypes["FulfillmentNoteWithoutVenuesUpdateInput"] | undefined,
	create?: GraphQLTypes["FulfillmentNoteWithoutVenuesCreateInput"] | undefined
};
	["OrderUpsertVenueRelationInput"]: {
		update?: GraphQLTypes["VenueWithoutOrdersUpdateInput"] | undefined,
	create?: GraphQLTypes["VenueWithoutOrdersCreateInput"] | undefined
};
	["OrderUpdateFulfillmentNotesEntityRelationInput"]: {
		create?: GraphQLTypes["FulfillmentNoteWithoutOrdersCreateInput"] | undefined,
	update?: GraphQLTypes["OrderUpdateFulfillmentNotesRelationInput"] | undefined,
	upsert?: GraphQLTypes["OrderUpsertFulfillmentNotesRelationInput"] | undefined,
	connect?: GraphQLTypes["FulfillmentNoteUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["FulfillmentNoteUniqueWhere"] | undefined,
	delete?: GraphQLTypes["FulfillmentNoteUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["OrderUpdateFulfillmentNotesRelationInput"]: {
		by?: GraphQLTypes["FulfillmentNoteUniqueWhere"] | undefined,
	data?: GraphQLTypes["FulfillmentNoteWithoutOrdersUpdateInput"] | undefined
};
	["FulfillmentNoteWithoutOrdersUpdateInput"]: {
		note?: string | undefined,
	products?: Array<GraphQLTypes["FulfillmentNoteUpdateProductsEntityRelationInput"]> | undefined,
	tags?: Array<GraphQLTypes["FulfillmentNoteUpdateTagsEntityRelationInput"]> | undefined,
	venues?: Array<GraphQLTypes["FulfillmentNoteUpdateVenuesEntityRelationInput"]> | undefined,
	cartItems?: Array<GraphQLTypes["FulfillmentNoteUpdateCartItemsEntityRelationInput"]> | undefined,
	orderItems?: Array<GraphQLTypes["FulfillmentNoteUpdateOrderItemsEntityRelationInput"]> | undefined,
	highlight?: boolean | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	emoji?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderUpsertFulfillmentNotesRelationInput"]: {
		by?: GraphQLTypes["FulfillmentNoteUniqueWhere"] | undefined,
	update?: GraphQLTypes["FulfillmentNoteWithoutOrdersUpdateInput"] | undefined,
	create?: GraphQLTypes["FulfillmentNoteWithoutOrdersCreateInput"] | undefined
};
	["BillingSubjectUpsertOrdersRelationInput"]: {
		by?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	update?: GraphQLTypes["OrderWithoutBillingSubjectUpdateInput"] | undefined,
	create?: GraphQLTypes["OrderWithoutBillingSubjectCreateInput"] | undefined
};
	["CustomerUpsertDefaultBillingSubjectRelationInput"]: {
		update?: GraphQLTypes["BillingSubjectWithoutDefaultBillingSubjectOfCustomerUpdateInput"] | undefined,
	create?: GraphQLTypes["BillingSubjectWithoutDefaultBillingSubjectOfCustomerCreateInput"] | undefined
};
	["BillingSubjectUpsertCustomerRelationInput"]: {
		update?: GraphQLTypes["CustomerWithoutBillingSubjectsUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerWithoutBillingSubjectsCreateInput"] | undefined
};
	["InvoiceUpsertBillingSubjectRelationInput"]: {
		update?: GraphQLTypes["BillingSubjectWithoutInvoicesUpdateInput"] | undefined,
	create?: GraphQLTypes["BillingSubjectWithoutInvoicesCreateInput"] | undefined
};
	["OrderPaymentUpsertInvoiceRelationInput"]: {
		update?: GraphQLTypes["InvoiceWithoutOrderPaymentsUpdateInput"] | undefined,
	create?: GraphQLTypes["InvoiceWithoutOrderPaymentsCreateInput"] | undefined
};
	["OrderPaymentUpdateVatRateEntityRelationInput"]: {
		create?: GraphQLTypes["VatRateCreateInput"] | undefined,
	update?: GraphQLTypes["VatRateUpdateInput"] | undefined,
	upsert?: GraphQLTypes["OrderPaymentUpsertVatRateRelationInput"] | undefined,
	connect?: GraphQLTypes["VatRateUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["OrderPaymentUpsertVatRateRelationInput"]: {
		update?: GraphQLTypes["VatRateUpdateInput"] | undefined,
	create?: GraphQLTypes["VatRateCreateInput"] | undefined
};
	["OrderPaymentUpdateMetaEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderPaymentMetadataUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["OrderUpsertPaymentsRelationInput"]: {
		by?: GraphQLTypes["OrderPaymentUniqueWhere"] | undefined,
	update?: GraphQLTypes["OrderPaymentWithoutOrderUpdateInput"] | undefined,
	create?: GraphQLTypes["OrderPaymentWithoutOrderCreateInput"] | undefined
};
	["OrderDeliveryUpsertOrderRelationInput"]: {
		update?: GraphQLTypes["OrderWithoutDeliveryUpdateInput"] | undefined,
	create?: GraphQLTypes["OrderWithoutDeliveryCreateInput"] | undefined
};
	["OrderDeliveryUpdateEventsEntityRelationInput"]: {
		create?: GraphQLTypes["OrderEventWithoutDeliveryCreateInput"] | undefined,
	update?: GraphQLTypes["OrderDeliveryUpdateEventsRelationInput"] | undefined,
	upsert?: GraphQLTypes["OrderDeliveryUpsertEventsRelationInput"] | undefined,
	connect?: GraphQLTypes["OrderEventUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["OrderEventUniqueWhere"] | undefined,
	delete?: GraphQLTypes["OrderEventUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["OrderDeliveryUpdateEventsRelationInput"]: {
		by?: GraphQLTypes["OrderEventUniqueWhere"] | undefined,
	data?: GraphQLTypes["OrderEventWithoutDeliveryUpdateInput"] | undefined
};
	["OrderEventWithoutDeliveryUpdateInput"]: {
		type?: string | undefined,
	data?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	order?: GraphQLTypes["OrderEventUpdateOrderEntityRelationInput"] | undefined,
	payment?: GraphQLTypes["OrderEventUpdatePaymentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderDeliveryUpsertEventsRelationInput"]: {
		by?: GraphQLTypes["OrderEventUniqueWhere"] | undefined,
	update?: GraphQLTypes["OrderEventWithoutDeliveryUpdateInput"] | undefined,
	create?: GraphQLTypes["OrderEventWithoutDeliveryCreateInput"] | undefined
};
	["OrderDeliveryUpdateLiftagoRideEntityRelationInput"]: {
		create?: GraphQLTypes["LiftagoRideWithoutDeliveryCreateInput"] | undefined,
	update?: GraphQLTypes["LiftagoRideWithoutDeliveryUpdateInput"] | undefined,
	upsert?: GraphQLTypes["OrderDeliveryUpsertLiftagoRideRelationInput"] | undefined,
	connect?: GraphQLTypes["LiftagoRideUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LiftagoRideWithoutDeliveryUpdateInput"]: {
		liftagoId?: string | undefined,
	data?: string | undefined,
	updatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderDeliveryUpsertLiftagoRideRelationInput"]: {
		update?: GraphQLTypes["LiftagoRideWithoutDeliveryUpdateInput"] | undefined,
	create?: GraphQLTypes["LiftagoRideWithoutDeliveryCreateInput"] | undefined
};
	["OrderDeliveryUpdateWoltDriveDeliveryEntityRelationInput"]: {
		create?: GraphQLTypes["WoltDriveDeliveryWithoutDeliveryCreateInput"] | undefined,
	update?: GraphQLTypes["WoltDriveDeliveryWithoutDeliveryUpdateInput"] | undefined,
	upsert?: GraphQLTypes["OrderDeliveryUpsertWoltDriveDeliveryRelationInput"] | undefined,
	connect?: GraphQLTypes["WoltDriveDeliveryUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["WoltDriveDeliveryWithoutDeliveryUpdateInput"]: {
		state?: GraphQLTypes["WoltDriveDeliveryState"] | undefined,
	shipmentPromiseId?: string | undefined,
	deliveryPrice?: number | undefined,
	deliveryPriceCurrency?: string | undefined,
	shipmentPromiseResponse?: string | undefined,
	deliveryOrderId?: string | undefined,
	trackingUrl?: string | undefined,
	deliverOrderResponse?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderDeliveryUpsertWoltDriveDeliveryRelationInput"]: {
		update?: GraphQLTypes["WoltDriveDeliveryWithoutDeliveryUpdateInput"] | undefined,
	create?: GraphQLTypes["WoltDriveDeliveryWithoutDeliveryCreateInput"] | undefined
};
	["AddressUpsertDeliveryAddressOfOrderDeliveriesRelationInput"]: {
		by?: GraphQLTypes["OrderDeliveryUniqueWhere"] | undefined,
	update?: GraphQLTypes["OrderDeliveryWithoutAddressUpdateInput"] | undefined,
	create?: GraphQLTypes["OrderDeliveryWithoutAddressCreateInput"] | undefined
};
	["AddressUpdateDefaultDeliveryAddressOfCustomerEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerWithoutDefaultDeliveryAddressCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerWithoutDefaultDeliveryAddressUpdateInput"] | undefined,
	upsert?: GraphQLTypes["AddressUpsertDefaultDeliveryAddressOfCustomerRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CustomerWithoutDefaultDeliveryAddressUpdateInput"]: {
		addresses?: Array<GraphQLTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerUpdateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerUpdateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerUpdateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerUpdateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["AddressUpsertDefaultDeliveryAddressOfCustomerRelationInput"]: {
		update?: GraphQLTypes["CustomerWithoutDefaultDeliveryAddressUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerWithoutDefaultDeliveryAddressCreateInput"] | undefined
};
	["OrderUpsertBillingAddressRelationInput"]: {
		update?: GraphQLTypes["AddressWithoutBillingAddressOfOrdersUpdateInput"] | undefined,
	create?: GraphQLTypes["AddressWithoutBillingAddressOfOrdersCreateInput"] | undefined
};
	["OrderPaymentUpsertOrderRelationInput"]: {
		update?: GraphQLTypes["OrderWithoutPaymentsUpdateInput"] | undefined,
	create?: GraphQLTypes["OrderWithoutPaymentsCreateInput"] | undefined
};
	["OrderEventUpsertPaymentRelationInput"]: {
		update?: GraphQLTypes["OrderPaymentWithoutEventsUpdateInput"] | undefined,
	create?: GraphQLTypes["OrderPaymentWithoutEventsCreateInput"] | undefined
};
	["OrderEventUpdateDeliveryEntityRelationInput"]: {
		create?: GraphQLTypes["OrderDeliveryWithoutEventsCreateInput"] | undefined,
	update?: GraphQLTypes["OrderDeliveryWithoutEventsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["OrderEventUpsertDeliveryRelationInput"] | undefined,
	connect?: GraphQLTypes["OrderDeliveryUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["OrderDeliveryWithoutEventsUpdateInput"]: {
		priceCents?: number | undefined,
	deliveredAt?: GraphQLTypes["DateTime"] | undefined,
	method?: GraphQLTypes["OrderDeliveryUpdateMethodEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["OrderDeliveryUpdateVatRateEntityRelationInput"] | undefined,
	order?: GraphQLTypes["OrderDeliveryUpdateOrderEntityRelationInput"] | undefined,
	expectedAt?: GraphQLTypes["DateTime"] | undefined,
	state?: GraphQLTypes["OrderDeliveryState"] | undefined,
	loadingDurationHours?: number | undefined,
	dispatchAt?: GraphQLTypes["DateTime"] | undefined,
	duration?: string | undefined,
	window?: string | undefined,
	expectedEndAt?: GraphQLTypes["DateTime"] | undefined,
	processingAt?: GraphQLTypes["DateTime"] | undefined,
	deliveringAt?: GraphQLTypes["DateTime"] | undefined,
	failedAt?: GraphQLTypes["DateTime"] | undefined,
	internalNote?: string | undefined,
	deliveryWaypoint?: GraphQLTypes["OrderDeliveryUpdateDeliveryWaypointEntityRelationInput"] | undefined,
	prepareAt?: GraphQLTypes["DateTime"] | undefined,
	liftagoRide?: GraphQLTypes["OrderDeliveryUpdateLiftagoRideEntityRelationInput"] | undefined,
	pickedAt?: GraphQLTypes["DateTime"] | undefined,
	address?: GraphQLTypes["OrderDeliveryUpdateAddressEntityRelationInput"] | undefined,
	trackingCode?: string | undefined,
	woltDriveDelivery?: GraphQLTypes["OrderDeliveryUpdateWoltDriveDeliveryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderDeliveryUpdateAddressEntityRelationInput"]: {
		create?: GraphQLTypes["AddressWithoutDeliveryAddressOfOrderDeliveriesCreateInput"] | undefined,
	update?: GraphQLTypes["AddressWithoutDeliveryAddressOfOrderDeliveriesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["OrderDeliveryUpsertAddressRelationInput"] | undefined,
	connect?: GraphQLTypes["AddressUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["AddressWithoutDeliveryAddressOfOrderDeliveriesUpdateInput"]: {
		name?: string | undefined,
	firstName?: string | undefined,
	lastName?: string | undefined,
	addressLine2?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	companyName?: string | undefined,
	companyIdentifier?: string | undefined,
	vatIdentifier?: string | undefined,
	externalIdentifier?: string | undefined,
	hidden?: boolean | undefined,
	customer?: GraphQLTypes["AddressUpdateCustomerEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	country?: GraphQLTypes["AddressUpdateCountryEntityRelationInput"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	googlePlaceId?: string | undefined,
	raw?: string | undefined,
	formatted?: string | undefined,
	geocodeGeneratedAt?: GraphQLTypes["DateTime"] | undefined,
	geocodeResponse?: string | undefined,
	deliveryZone?: GraphQLTypes["AddressUpdateDeliveryZoneEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["AddressUpdateMetaEntityRelationInput"] | undefined,
	gps?: GraphQLTypes["AddressUpdateGpsEntityRelationInput"] | undefined,
	geocodeValid?: boolean | undefined,
	fullName?: string | undefined,
	fakturoidSubjectId?: string | undefined,
	invoices?: Array<GraphQLTypes["AddressUpdateInvoicesEntityRelationInput"]> | undefined,
	addressLine1?: string | undefined,
	city?: string | undefined,
	postalCode?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddressOfOrders?: Array<GraphQLTypes["AddressUpdateBillingAddressOfOrdersEntityRelationInput"]> | undefined,
	defaultDeliveryAddressOfCustomer?: GraphQLTypes["AddressUpdateDefaultDeliveryAddressOfCustomerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderDeliveryUpsertAddressRelationInput"]: {
		update?: GraphQLTypes["AddressWithoutDeliveryAddressOfOrderDeliveriesUpdateInput"] | undefined,
	create?: GraphQLTypes["AddressWithoutDeliveryAddressOfOrderDeliveriesCreateInput"] | undefined
};
	["OrderEventUpsertDeliveryRelationInput"]: {
		update?: GraphQLTypes["OrderDeliveryWithoutEventsUpdateInput"] | undefined,
	create?: GraphQLTypes["OrderDeliveryWithoutEventsCreateInput"] | undefined
};
	["OrderUpsertEventsRelationInput"]: {
		by?: GraphQLTypes["OrderEventUniqueWhere"] | undefined,
	update?: GraphQLTypes["OrderEventWithoutOrderUpdateInput"] | undefined,
	create?: GraphQLTypes["OrderEventWithoutOrderCreateInput"] | undefined
};
	["AddressUpsertBillingAddressOfOrdersRelationInput"]: {
		by?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	update?: GraphQLTypes["OrderWithoutBillingAddressUpdateInput"] | undefined,
	create?: GraphQLTypes["OrderWithoutBillingAddressCreateInput"] | undefined
};
	["InvoiceUpsertAddressRelationInput"]: {
		update?: GraphQLTypes["AddressWithoutInvoicesUpdateInput"] | undefined,
	create?: GraphQLTypes["AddressWithoutInvoicesCreateInput"] | undefined
};
	["BillingSubjectUpsertInvoicesRelationInput"]: {
		by?: GraphQLTypes["InvoiceUniqueWhere"] | undefined,
	update?: GraphQLTypes["InvoiceWithoutBillingSubjectUpdateInput"] | undefined,
	create?: GraphQLTypes["InvoiceWithoutBillingSubjectCreateInput"] | undefined
};
	["CustomerUpsertBillingSubjectsRelationInput"]: {
		by?: GraphQLTypes["BillingSubjectUniqueWhere"] | undefined,
	update?: GraphQLTypes["BillingSubjectWithoutCustomerUpdateInput"] | undefined,
	create?: GraphQLTypes["BillingSubjectWithoutCustomerCreateInput"] | undefined
};
	["CartUpsertCustomerRelationInput"]: {
		update?: GraphQLTypes["CustomerWithoutCartsUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerWithoutCartsCreateInput"] | undefined
};
	["CartUpdateDeliveryAddressEntityRelationInput"]: {
		create?: GraphQLTypes["AddressCreateInput"] | undefined,
	update?: GraphQLTypes["AddressUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CartUpsertDeliveryAddressRelationInput"] | undefined,
	connect?: GraphQLTypes["AddressUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CartUpsertDeliveryAddressRelationInput"]: {
		update?: GraphQLTypes["AddressUpdateInput"] | undefined,
	create?: GraphQLTypes["AddressCreateInput"] | undefined
};
	["CartUpdateBillingAddressEntityRelationInput"]: {
		create?: GraphQLTypes["AddressCreateInput"] | undefined,
	update?: GraphQLTypes["AddressUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CartUpsertBillingAddressRelationInput"] | undefined,
	connect?: GraphQLTypes["AddressUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CartUpsertBillingAddressRelationInput"]: {
		update?: GraphQLTypes["AddressUpdateInput"] | undefined,
	create?: GraphQLTypes["AddressCreateInput"] | undefined
};
	["CartUpdateDeliveryEntityRelationInput"]: {
		create?: GraphQLTypes["ChannelDeliveryCreateInput"] | undefined,
	update?: GraphQLTypes["ChannelDeliveryUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CartUpsertDeliveryRelationInput"] | undefined,
	connect?: GraphQLTypes["ChannelDeliveryUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ChannelDeliveryUpdateInput"]: {
		order?: number | undefined,
	priceCents?: number | undefined,
	channel?: GraphQLTypes["ChannelDeliveryUpdateChannelEntityRelationInput"] | undefined,
	method?: GraphQLTypes["ChannelDeliveryUpdateMethodEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["ChannelDeliveryUpdateVatRateEntityRelationInput"] | undefined,
	defaultVisible?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["CartUpsertDeliveryRelationInput"]: {
		update?: GraphQLTypes["ChannelDeliveryUpdateInput"] | undefined,
	create?: GraphQLTypes["ChannelDeliveryCreateInput"] | undefined
};
	["CartUpdatePaymentEntityRelationInput"]: {
		create?: GraphQLTypes["ChannelPaymentCreateInput"] | undefined,
	update?: GraphQLTypes["ChannelPaymentUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CartUpsertPaymentRelationInput"] | undefined,
	connect?: GraphQLTypes["ChannelPaymentUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ChannelPaymentUpdateInput"]: {
		order?: number | undefined,
	channel?: GraphQLTypes["ChannelPaymentUpdateChannelEntityRelationInput"] | undefined,
	method?: GraphQLTypes["ChannelPaymentUpdateMethodEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["ChannelPaymentUpdateVatRateEntityRelationInput"] | undefined,
	requireBillingAddress?: boolean | undefined,
	provideReceipt?: boolean | undefined,
	requireBillingSubject?: boolean | undefined,
	allowOnlyForTags?: Array<GraphQLTypes["ChannelPaymentUpdateAllowOnlyForTagsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["CartUpsertPaymentRelationInput"]: {
		update?: GraphQLTypes["ChannelPaymentUpdateInput"] | undefined,
	create?: GraphQLTypes["ChannelPaymentCreateInput"] | undefined
};
	["CartUpdateBillingSubjectEntityRelationInput"]: {
		create?: GraphQLTypes["BillingSubjectCreateInput"] | undefined,
	update?: GraphQLTypes["BillingSubjectUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CartUpsertBillingSubjectRelationInput"] | undefined,
	connect?: GraphQLTypes["BillingSubjectUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["BillingSubjectUpdateInput"]: {
		name?: string | undefined,
	fullName?: string | undefined,
	addressLine1?: string | undefined,
	addressLine2?: string | undefined,
	city?: string | undefined,
	postalCode?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	companyName?: string | undefined,
	companyIdentifier?: string | undefined,
	vatIdentifier?: string | undefined,
	externalIdentifier?: string | undefined,
	hidden?: boolean | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	internalNote?: string | undefined,
	fakturoidSubjectId?: string | undefined,
	country?: GraphQLTypes["BillingSubjectUpdateCountryEntityRelationInput"] | undefined,
	customer?: GraphQLTypes["BillingSubjectUpdateCustomerEntityRelationInput"] | undefined,
	invoices?: Array<GraphQLTypes["BillingSubjectUpdateInvoicesEntityRelationInput"]> | undefined,
	defaultBillingSubjectOfCustomer?: GraphQLTypes["BillingSubjectUpdateDefaultBillingSubjectOfCustomerEntityRelationInput"] | undefined,
	orders?: Array<GraphQLTypes["BillingSubjectUpdateOrdersEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["CartUpsertBillingSubjectRelationInput"]: {
		update?: GraphQLTypes["BillingSubjectUpdateInput"] | undefined,
	create?: GraphQLTypes["BillingSubjectCreateInput"] | undefined
};
	["CartUpdatePriceLinesEntityRelationInput"]: {
		connect?: GraphQLTypes["CartPriceLineUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["CartPriceLineUniqueWhere"] | undefined,
	delete?: GraphQLTypes["CartPriceLineUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CartUpdateSummaryEntityRelationInput"]: {
		connect?: GraphQLTypes["CartSummaryUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["OrderUpsertCartRelationInput"]: {
		update?: GraphQLTypes["CartWithoutOrderUpdateInput"] | undefined,
	create?: GraphQLTypes["CartWithoutOrderCreateInput"] | undefined
};
	["OrderDiscountUpsertOrderRelationInput"]: {
		update?: GraphQLTypes["OrderWithoutDiscountsUpdateInput"] | undefined,
	create?: GraphQLTypes["OrderWithoutDiscountsCreateInput"] | undefined
};
	["OrderDiscountUpdateVoucherRedemptionEntityRelationInput"]: {
		create?: GraphQLTypes["VoucherRedemptionWithoutOrderDiscountCreateInput"] | undefined,
	update?: GraphQLTypes["VoucherRedemptionWithoutOrderDiscountUpdateInput"] | undefined,
	upsert?: GraphQLTypes["OrderDiscountUpsertVoucherRedemptionRelationInput"] | undefined,
	connect?: GraphQLTypes["VoucherRedemptionUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["VoucherRedemptionWithoutOrderDiscountUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	manualRedemptionNote?: string | undefined,
	customerCredit?: GraphQLTypes["VoucherRedemptionUpdateCustomerCreditEntityRelationInput"] | undefined,
	voucher?: GraphQLTypes["VoucherRedemptionUpdateVoucherEntityRelationInput"] | undefined,
	customer?: GraphQLTypes["VoucherRedemptionUpdateCustomerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderDiscountUpsertVoucherRedemptionRelationInput"]: {
		update?: GraphQLTypes["VoucherRedemptionWithoutOrderDiscountUpdateInput"] | undefined,
	create?: GraphQLTypes["VoucherRedemptionWithoutOrderDiscountCreateInput"] | undefined
};
	["CustomerCreditTransactionUpsertOrderDiscountRelationInput"]: {
		update?: GraphQLTypes["OrderDiscountWithoutCustomerCreditTransactionsUpdateInput"] | undefined,
	create?: GraphQLTypes["OrderDiscountWithoutCustomerCreditTransactionsCreateInput"] | undefined
};
	["VirtualProductEffectUpsertResultCustomerCreditTransactionRelationInput"]: {
		update?: GraphQLTypes["CustomerCreditTransactionWithoutVirtualProductEffectUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerCreditTransactionWithoutVirtualProductEffectCreateInput"] | undefined
};
	["OrderItemUpsertVirtualProductEffectsRelationInput"]: {
		by?: GraphQLTypes["VirtualProductEffectUniqueWhere"] | undefined,
	update?: GraphQLTypes["VirtualProductEffectWithoutOrderItemUpdateInput"] | undefined,
	create?: GraphQLTypes["VirtualProductEffectWithoutOrderItemCreateInput"] | undefined
};
	["OrderUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["OrderItemUniqueWhere"] | undefined,
	update?: GraphQLTypes["OrderItemWithoutOrderUpdateInput"] | undefined,
	create?: GraphQLTypes["OrderItemWithoutOrderCreateInput"] | undefined
};
	["VenueUpsertOrdersRelationInput"]: {
		by?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	update?: GraphQLTypes["OrderWithoutVenueUpdateInput"] | undefined,
	create?: GraphQLTypes["OrderWithoutVenueCreateInput"] | undefined
};
	["PointOfSaleTerminalUpsertVenueRelationInput"]: {
		update?: GraphQLTypes["VenueWithoutPointOfSaleTerminalsUpdateInput"] | undefined,
	create?: GraphQLTypes["VenueWithoutPointOfSaleTerminalsCreateInput"] | undefined
};
	["PointOfSaleApplicationDeviceUpsertTerminalRelationInput"]: {
		update?: GraphQLTypes["PointOfSaleTerminalWithoutApplicationDevicesUpdateInput"] | undefined,
	create?: GraphQLTypes["PointOfSaleTerminalWithoutApplicationDevicesCreateInput"] | undefined
};
	["PointOfSaleApplicationDeviceUpdateTicketPrintersEntityRelationInput"]: {
		create?: GraphQLTypes["PointOfSalePrinterWithoutApplicationDevicesTicketCreateInput"] | undefined,
	update?: GraphQLTypes["PointOfSaleApplicationDeviceUpdateTicketPrintersRelationInput"] | undefined,
	upsert?: GraphQLTypes["PointOfSaleApplicationDeviceUpsertTicketPrintersRelationInput"] | undefined,
	connect?: GraphQLTypes["PointOfSalePrinterUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PointOfSalePrinterUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PointOfSalePrinterUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PointOfSaleApplicationDeviceUpdateTicketPrintersRelationInput"]: {
		by?: GraphQLTypes["PointOfSalePrinterUniqueWhere"] | undefined,
	data?: GraphQLTypes["PointOfSalePrinterWithoutApplicationDevicesTicketUpdateInput"] | undefined
};
	["PointOfSalePrinterWithoutApplicationDevicesTicketUpdateInput"]: {
		internalName?: string | undefined,
	note?: string | undefined,
	ipAddress?: string | undefined,
	applicationDevicesReceipt?: Array<GraphQLTypes["PointOfSalePrinterUpdateApplicationDevicesReceiptEntityRelationInput"]> | undefined,
	venue?: GraphQLTypes["PointOfSalePrinterUpdateVenueEntityRelationInput"] | undefined,
	ticketCategories?: Array<GraphQLTypes["PointOfSalePrinterUpdateTicketCategoriesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleApplicationDeviceUpsertTicketPrintersRelationInput"]: {
		by?: GraphQLTypes["PointOfSalePrinterUniqueWhere"] | undefined,
	update?: GraphQLTypes["PointOfSalePrinterWithoutApplicationDevicesTicketUpdateInput"] | undefined,
	create?: GraphQLTypes["PointOfSalePrinterWithoutApplicationDevicesTicketCreateInput"] | undefined
};
	["IdentificationCodeUpsertApplicationDevicesRelationInput"]: {
		by?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined,
	update?: GraphQLTypes["PointOfSaleApplicationDeviceWithoutIdentificationCodeUpdateInput"] | undefined,
	create?: GraphQLTypes["PointOfSaleApplicationDeviceWithoutIdentificationCodeCreateInput"] | undefined
};
	["IdentificationCodeLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["IdentificationCodeWithoutLocalesUpdateInput"] | undefined,
	create?: GraphQLTypes["IdentificationCodeWithoutLocalesCreateInput"] | undefined
};
	["LocaleUpsertIdentificationCodesRelationInput"]: {
		by?: GraphQLTypes["IdentificationCodeLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["IdentificationCodeLocaleWithoutLocaleUpdateInput"] | undefined,
	create?: GraphQLTypes["IdentificationCodeLocaleWithoutLocaleCreateInput"] | undefined
};
	["LocaleUpdatePipelineStagesEntityRelationInput"]: {
		create?: GraphQLTypes["PipelineStageLocaleWithoutLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleUpdatePipelineStagesRelationInput"] | undefined,
	upsert?: GraphQLTypes["LocaleUpsertPipelineStagesRelationInput"] | undefined,
	connect?: GraphQLTypes["PipelineStageLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PipelineStageLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PipelineStageLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["LocaleUpdatePipelineStagesRelationInput"]: {
		by?: GraphQLTypes["PipelineStageLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["PipelineStageLocaleWithoutLocaleUpdateInput"] | undefined
};
	["PipelineStageLocaleWithoutLocaleUpdateInput"]: {
		name?: string | undefined,
	root?: GraphQLTypes["PipelineStageLocaleUpdateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PipelineStageLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["PipelineStageWithoutLocalesCreateInput"] | undefined,
	update?: GraphQLTypes["PipelineStageWithoutLocalesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PipelineStageLocaleUpsertRootRelationInput"] | undefined,
	connect?: GraphQLTypes["PipelineStageUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["PipelineStageWithoutLocalesUpdateInput"]: {
		items?: Array<GraphQLTypes["PipelineStageUpdateItemsEntityRelationInput"]> | undefined,
	pipeline?: GraphQLTypes["PipelineStageUpdatePipelineEntityRelationInput"] | undefined,
	order?: number | undefined,
	sentiment?: GraphQLTypes["PipelineStageUpdateSentimentEntityRelationInput"] | undefined,
	type?: GraphQLTypes["PipelineStageType"] | undefined,
	forms?: Array<GraphQLTypes["PipelineStageUpdateFormsEntityRelationInput"]> | undefined,
	showItemsWeight?: boolean | undefined,
	showItemsPrice?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PipelineStageLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["PipelineStageWithoutLocalesUpdateInput"] | undefined,
	create?: GraphQLTypes["PipelineStageWithoutLocalesCreateInput"] | undefined
};
	["LocaleUpsertPipelineStagesRelationInput"]: {
		by?: GraphQLTypes["PipelineStageLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["PipelineStageLocaleWithoutLocaleUpdateInput"] | undefined,
	create?: GraphQLTypes["PipelineStageLocaleWithoutLocaleCreateInput"] | undefined
};
	["PointOfSaleCategoryLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutPointOfSaleCategoriesUpdateInput"] | undefined,
	create?: GraphQLTypes["LocaleWithoutPointOfSaleCategoriesCreateInput"] | undefined
};
	["PointOfSaleCategoryUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["PointOfSaleCategoryLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["PointOfSaleCategoryLocaleWithoutRootUpdateInput"] | undefined,
	create?: GraphQLTypes["PointOfSaleCategoryLocaleWithoutRootCreateInput"] | undefined
};
	["PointOfSaleCategoryProductUpsertCategoryRelationInput"]: {
		update?: GraphQLTypes["PointOfSaleCategoryWithoutProductsUpdateInput"] | undefined,
	create?: GraphQLTypes["PointOfSaleCategoryWithoutProductsCreateInput"] | undefined
};
	["PointOfSaleCategoryProductLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["PointOfSaleCategoryProductWithoutLocalesUpdateInput"] | undefined,
	create?: GraphQLTypes["PointOfSaleCategoryProductWithoutLocalesCreateInput"] | undefined
};
	["LocaleUpsertPointOfSaleCategoryProductsRelationInput"]: {
		by?: GraphQLTypes["PointOfSaleCategoryProductLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["PointOfSaleCategoryProductLocaleWithoutLocaleUpdateInput"] | undefined,
	create?: GraphQLTypes["PointOfSaleCategoryProductLocaleWithoutLocaleCreateInput"] | undefined
};
	["IdentificationCodeLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutIdentificationCodesUpdateInput"] | undefined,
	create?: GraphQLTypes["LocaleWithoutIdentificationCodesCreateInput"] | undefined
};
	["IdentificationCodeUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["IdentificationCodeLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["IdentificationCodeLocaleWithoutRootUpdateInput"] | undefined,
	create?: GraphQLTypes["IdentificationCodeLocaleWithoutRootCreateInput"] | undefined
};
	["IdentificationAttemptUpsertCodeRelationInput"]: {
		update?: GraphQLTypes["IdentificationCodeWithoutAttemptsUpdateInput"] | undefined,
	create?: GraphQLTypes["IdentificationCodeWithoutAttemptsCreateInput"] | undefined
};
	["UserUpsertIdentificationAttemptsRelationInput"]: {
		by?: GraphQLTypes["IdentificationAttemptUniqueWhere"] | undefined,
	update?: GraphQLTypes["IdentificationAttemptWithoutUserUpdateInput"] | undefined,
	create?: GraphQLTypes["IdentificationAttemptWithoutUserCreateInput"] | undefined
};
	["DeviceIdentifierUpsertUpdatedByUserRelationInput"]: {
		update?: GraphQLTypes["UserUpdateInput"] | undefined,
	create?: GraphQLTypes["UserCreateInput"] | undefined
};
	["PointOfSaleApplicationDeviceUpsertIdentifierRelationInput"]: {
		update?: GraphQLTypes["DeviceIdentifierWithoutDeviceUpdateInput"] | undefined,
	create?: GraphQLTypes["DeviceIdentifierWithoutDeviceCreateInput"] | undefined
};
	["PointOfSalePrinterUpsertApplicationDevicesReceiptRelationInput"]: {
		by?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined,
	update?: GraphQLTypes["PointOfSaleApplicationDeviceWithoutReceiptPrinterUpdateInput"] | undefined,
	create?: GraphQLTypes["PointOfSaleApplicationDeviceWithoutReceiptPrinterCreateInput"] | undefined
};
	["VenueUpsertPointOfSalePrintersRelationInput"]: {
		by?: GraphQLTypes["PointOfSalePrinterUniqueWhere"] | undefined,
	update?: GraphQLTypes["PointOfSalePrinterWithoutVenueUpdateInput"] | undefined,
	create?: GraphQLTypes["PointOfSalePrinterWithoutVenueCreateInput"] | undefined
};
	["PointOfSaleApplicationDeviceUpsertVenueRelationInput"]: {
		update?: GraphQLTypes["VenueWithoutPointOfSaleApplicationDevicesUpdateInput"] | undefined,
	create?: GraphQLTypes["VenueWithoutPointOfSaleApplicationDevicesCreateInput"] | undefined
};
	["PointOfSaleTerminalUpsertApplicationDevicesRelationInput"]: {
		by?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined,
	update?: GraphQLTypes["PointOfSaleApplicationDeviceWithoutTerminalUpdateInput"] | undefined,
	create?: GraphQLTypes["PointOfSaleApplicationDeviceWithoutTerminalCreateInput"] | undefined
};
	["VenueUpsertPointOfSaleTerminalsRelationInput"]: {
		by?: GraphQLTypes["PointOfSaleTerminalUniqueWhere"] | undefined,
	update?: GraphQLTypes["PointOfSaleTerminalWithoutVenueUpdateInput"] | undefined,
	create?: GraphQLTypes["PointOfSaleTerminalWithoutVenueCreateInput"] | undefined
};
	["FulfillmentNoteUpsertVenuesRelationInput"]: {
		by?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	update?: GraphQLTypes["VenueWithoutFulfillmentNotesUpdateInput"] | undefined,
	create?: GraphQLTypes["VenueWithoutFulfillmentNotesCreateInput"] | undefined
};
	["ProductUpsertFulfillmentNotesRelationInput"]: {
		by?: GraphQLTypes["FulfillmentNoteUniqueWhere"] | undefined,
	update?: GraphQLTypes["FulfillmentNoteWithoutProductsUpdateInput"] | undefined,
	create?: GraphQLTypes["FulfillmentNoteWithoutProductsCreateInput"] | undefined
};
	["PointOfSaleCategoryProductUpsertProductRelationInput"]: {
		update?: GraphQLTypes["ProductUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductCreateInput"] | undefined
};
	["PointOfSaleCategoryProductUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["PointOfSaleCategoryProductLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["PointOfSaleCategoryProductUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["PointOfSaleCategoryProductUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["PointOfSaleCategoryProductLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PointOfSaleCategoryProductLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PointOfSaleCategoryProductLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PointOfSaleCategoryProductUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["PointOfSaleCategoryProductLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["PointOfSaleCategoryProductLocaleWithoutRootUpdateInput"] | undefined
};
	["PointOfSaleCategoryProductLocaleWithoutRootUpdateInput"]: {
		title?: string | undefined,
	locale?: GraphQLTypes["PointOfSaleCategoryProductLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleCategoryProductLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutPointOfSaleCategoryProductsCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutPointOfSaleCategoryProductsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PointOfSaleCategoryProductLocaleUpsertLocaleRelationInput"] | undefined,
	connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutPointOfSaleCategoryProductsUpdateInput"]: {
		businessCategories?: Array<GraphQLTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleCategoryProductLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutPointOfSaleCategoryProductsUpdateInput"] | undefined,
	create?: GraphQLTypes["LocaleWithoutPointOfSaleCategoryProductsCreateInput"] | undefined
};
	["PointOfSaleCategoryProductUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["PointOfSaleCategoryProductLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["PointOfSaleCategoryProductLocaleWithoutRootUpdateInput"] | undefined,
	create?: GraphQLTypes["PointOfSaleCategoryProductLocaleWithoutRootCreateInput"] | undefined
};
	["PointOfSaleCategoryUpsertProductsRelationInput"]: {
		by?: GraphQLTypes["PointOfSaleCategoryProductUniqueWhere"] | undefined,
	update?: GraphQLTypes["PointOfSaleCategoryProductWithoutCategoryUpdateInput"] | undefined,
	create?: GraphQLTypes["PointOfSaleCategoryProductWithoutCategoryCreateInput"] | undefined
};
	["PointOfSaleCategoryLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["PointOfSaleCategoryWithoutLocalesUpdateInput"] | undefined,
	create?: GraphQLTypes["PointOfSaleCategoryWithoutLocalesCreateInput"] | undefined
};
	["LocaleUpsertPointOfSaleCategoriesRelationInput"]: {
		by?: GraphQLTypes["PointOfSaleCategoryLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["PointOfSaleCategoryLocaleWithoutLocaleUpdateInput"] | undefined,
	create?: GraphQLTypes["PointOfSaleCategoryLocaleWithoutLocaleCreateInput"] | undefined
};
	["ProductLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutProductsUpdateInput"] | undefined,
	create?: GraphQLTypes["LocaleWithoutProductsCreateInput"] | undefined
};
	["ProductUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["ProductLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["ProductLocaleWithoutRootUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductLocaleWithoutRootCreateInput"] | undefined
};
	["ProductRecipeUpsertProductsRelationInput"]: {
		by?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	update?: GraphQLTypes["ProductWithoutRecipeUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductWithoutRecipeCreateInput"] | undefined
};
	["ProductRecipeUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["ProductRecipeLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["ProductRecipeUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["ProductRecipeUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductRecipeLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductRecipeLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductRecipeLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductRecipeUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["ProductRecipeLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["ProductRecipeLocaleWithoutRootUpdateInput"] | undefined
};
	["ProductRecipeLocaleWithoutRootUpdateInput"]: {
		name?: string | undefined,
	locale?: GraphQLTypes["ProductRecipeLocaleUpdateLocaleEntityRelationInput"] | undefined,
	description?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductRecipeLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutProductRecipesCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutProductRecipesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductRecipeLocaleUpsertLocaleRelationInput"] | undefined,
	connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutProductRecipesUpdateInput"]: {
		businessCategories?: Array<GraphQLTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductRecipeLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutProductRecipesUpdateInput"] | undefined,
	create?: GraphQLTypes["LocaleWithoutProductRecipesCreateInput"] | undefined
};
	["ProductRecipeUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["ProductRecipeLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["ProductRecipeLocaleWithoutRootUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductRecipeLocaleWithoutRootCreateInput"] | undefined
};
	["PreparedPackingQuantityUpsertRecipeRelationInput"]: {
		update?: GraphQLTypes["ProductRecipeUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductRecipeCreateInput"] | undefined
};
	["ProductPackingUpsertPreparedPackingQuantitiesRelationInput"]: {
		by?: GraphQLTypes["PreparedPackingQuantityUniqueWhere"] | undefined,
	update?: GraphQLTypes["PreparedPackingQuantityWithoutPackingUpdateInput"] | undefined,
	create?: GraphQLTypes["PreparedPackingQuantityWithoutPackingCreateInput"] | undefined
};
	["ProductPackingLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["ProductPackingWithoutLocalesUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductPackingWithoutLocalesCreateInput"] | undefined
};
	["LocaleUpsertProductPackingsRelationInput"]: {
		by?: GraphQLTypes["ProductPackingLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["ProductPackingLocaleWithoutLocaleUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductPackingLocaleWithoutLocaleCreateInput"] | undefined
};
	["DeliveryMethodLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutDeliveryMethodsUpdateInput"] | undefined,
	create?: GraphQLTypes["LocaleWithoutDeliveryMethodsCreateInput"] | undefined
};
	["DeliveryMethodUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["DeliveryMethodLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["DeliveryMethodLocaleWithoutRootUpdateInput"] | undefined,
	create?: GraphQLTypes["DeliveryMethodLocaleWithoutRootCreateInput"] | undefined
};
	["CourierUpsertDeliveryMethodsRelationInput"]: {
		by?: GraphQLTypes["DeliveryMethodUniqueWhere"] | undefined,
	update?: GraphQLTypes["DeliveryMethodWithoutCourierHandlersUpdateInput"] | undefined,
	create?: GraphQLTypes["DeliveryMethodWithoutCourierHandlersCreateInput"] | undefined
};
	["DeliveryRouteUpsertCourierRelationInput"]: {
		update?: GraphQLTypes["CourierWithoutRoutesUpdateInput"] | undefined,
	create?: GraphQLTypes["CourierWithoutRoutesCreateInput"] | undefined
};
	["DeliveryWaypointUpsertRouteRelationInput"]: {
		update?: GraphQLTypes["DeliveryRouteWithoutWaypointsUpdateInput"] | undefined,
	create?: GraphQLTypes["DeliveryRouteWithoutWaypointsCreateInput"] | undefined
};
	["OrderDeliveryUpsertDeliveryWaypointRelationInput"]: {
		update?: GraphQLTypes["DeliveryWaypointWithoutDeliveryUpdateInput"] | undefined,
	create?: GraphQLTypes["DeliveryWaypointWithoutDeliveryCreateInput"] | undefined
};
	["OrderUpsertDeliveryRelationInput"]: {
		update?: GraphQLTypes["OrderDeliveryWithoutOrderUpdateInput"] | undefined,
	create?: GraphQLTypes["OrderDeliveryWithoutOrderCreateInput"] | undefined
};
	["OrderEventUpsertOrderRelationInput"]: {
		update?: GraphQLTypes["OrderWithoutEventsUpdateInput"] | undefined,
	create?: GraphQLTypes["OrderWithoutEventsCreateInput"] | undefined
};
	["OrderPaymentUpsertEventsRelationInput"]: {
		by?: GraphQLTypes["OrderEventUniqueWhere"] | undefined,
	update?: GraphQLTypes["OrderEventWithoutPaymentUpdateInput"] | undefined,
	create?: GraphQLTypes["OrderEventWithoutPaymentCreateInput"] | undefined
};
	["InvoiceUpsertOrderPaymentsRelationInput"]: {
		by?: GraphQLTypes["OrderPaymentUniqueWhere"] | undefined,
	update?: GraphQLTypes["OrderPaymentWithoutInvoiceUpdateInput"] | undefined,
	create?: GraphQLTypes["OrderPaymentWithoutInvoiceCreateInput"] | undefined
};
	["CustomerUpsertInvoicesRelationInput"]: {
		by?: GraphQLTypes["InvoiceUniqueWhere"] | undefined,
	update?: GraphQLTypes["InvoiceWithoutCustomerUpdateInput"] | undefined,
	create?: GraphQLTypes["InvoiceWithoutCustomerCreateInput"] | undefined
};
	["AnonymousSessionUpsertCustomerRelationInput"]: {
		update?: GraphQLTypes["CustomerWithoutAnonymousSessionUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerWithoutAnonymousSessionCreateInput"] | undefined
};
	["UserDeviceUpsertAnonymousSessionRelationInput"]: {
		update?: GraphQLTypes["AnonymousSessionWithoutDevicesUpdateInput"] | undefined,
	create?: GraphQLTypes["AnonymousSessionWithoutDevicesCreateInput"] | undefined
};
	["UserUpsertDevicesRelationInput"]: {
		by?: GraphQLTypes["UserDeviceUniqueWhere"] | undefined,
	update?: GraphQLTypes["UserDeviceWithoutUserUpdateInput"] | undefined,
	create?: GraphQLTypes["UserDeviceWithoutUserCreateInput"] | undefined
};
	["IdentificationAttemptUpsertUserRelationInput"]: {
		update?: GraphQLTypes["UserWithoutIdentificationAttemptsUpdateInput"] | undefined,
	create?: GraphQLTypes["UserWithoutIdentificationAttemptsCreateInput"] | undefined
};
	["IdentificationCodeUpsertAttemptsRelationInput"]: {
		by?: GraphQLTypes["IdentificationAttemptUniqueWhere"] | undefined,
	update?: GraphQLTypes["IdentificationAttemptWithoutCodeUpdateInput"] | undefined,
	create?: GraphQLTypes["IdentificationAttemptWithoutCodeCreateInput"] | undefined
};
	["PointOfSaleApplicationDeviceUpsertIdentificationCodeRelationInput"]: {
		update?: GraphQLTypes["IdentificationCodeWithoutApplicationDevicesUpdateInput"] | undefined,
	create?: GraphQLTypes["IdentificationCodeWithoutApplicationDevicesCreateInput"] | undefined
};
	["VenueUpsertPointOfSaleApplicationDevicesRelationInput"]: {
		by?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined,
	update?: GraphQLTypes["PointOfSaleApplicationDeviceWithoutVenueUpdateInput"] | undefined,
	create?: GraphQLTypes["PointOfSaleApplicationDeviceWithoutVenueCreateInput"] | undefined
};
	["TimetableTemplateUpsertVenueRelationInput"]: {
		update?: GraphQLTypes["VenueWithoutTimetableTemplatesUpdateInput"] | undefined,
	create?: GraphQLTypes["VenueWithoutTimetableTemplatesCreateInput"] | undefined
};
	["TimetableShiftPositionUpsertTimetableTemplatesRelationInput"]: {
		by?: GraphQLTypes["TimetableTemplateUniqueWhere"] | undefined,
	update?: GraphQLTypes["TimetableTemplateWithoutPositionUpdateInput"] | undefined,
	create?: GraphQLTypes["TimetableTemplateWithoutPositionCreateInput"] | undefined
};
	["TimetableShiftGroupUpsertPositionRelationInput"]: {
		update?: GraphQLTypes["TimetableShiftPositionWithoutShiftGroupsUpdateInput"] | undefined,
	create?: GraphQLTypes["TimetableShiftPositionWithoutShiftGroupsCreateInput"] | undefined
};
	["TimetableShiftGroupUpdateGeneratedByTemplateEntityRelationInput"]: {
		create?: GraphQLTypes["TimetableTemplateCreateInput"] | undefined,
	update?: GraphQLTypes["TimetableTemplateUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TimetableShiftGroupUpsertGeneratedByTemplateRelationInput"] | undefined,
	connect?: GraphQLTypes["TimetableTemplateUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TimetableTemplateUpdateInput"]: {
		order?: number | undefined,
	startDate?: GraphQLTypes["Date"] | undefined,
	period?: number | undefined,
	slots?: number | undefined,
	position?: GraphQLTypes["TimetableTemplateUpdatePositionEntityRelationInput"] | undefined,
	staffOptions?: Array<GraphQLTypes["TimetableTemplateUpdateStaffOptionsEntityRelationInput"]> | undefined,
	internalName?: string | undefined,
	venue?: GraphQLTypes["TimetableTemplateUpdateVenueEntityRelationInput"] | undefined,
	employeeRole?: GraphQLTypes["TimetableTemplateUpdateEmployeeRoleEntityRelationInput"] | undefined,
	workdaysOnly?: boolean | undefined,
	monday?: boolean | undefined,
	tuesday?: boolean | undefined,
	wednesday?: boolean | undefined,
	thursday?: boolean | undefined,
	friday?: boolean | undefined,
	saturday?: boolean | undefined,
	sunday?: boolean | undefined,
	type?: GraphQLTypes["TemplateType"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableShiftGroupUpsertGeneratedByTemplateRelationInput"]: {
		update?: GraphQLTypes["TimetableTemplateUpdateInput"] | undefined,
	create?: GraphQLTypes["TimetableTemplateCreateInput"] | undefined
};
	["TimetableShiftUpsertGroupRelationInput"]: {
		update?: GraphQLTypes["TimetableShiftGroupWithoutShiftsUpdateInput"] | undefined,
	create?: GraphQLTypes["TimetableShiftGroupWithoutShiftsCreateInput"] | undefined
};
	["TimetableShiftUpdateQueueItemEntityRelationInput"]: {
		create?: GraphQLTypes["EmployeeQueueItemWithoutShiftCreateInput"] | undefined,
	update?: GraphQLTypes["EmployeeQueueItemWithoutShiftUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TimetableShiftUpsertQueueItemRelationInput"] | undefined,
	connect?: GraphQLTypes["EmployeeQueueItemUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["EmployeeQueueItemWithoutShiftUpdateInput"]: {
		start?: string | undefined,
	end?: string | undefined,
	queue?: GraphQLTypes["EmployeeQueueItemUpdateQueueEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["EmployeeQueueItemUpdateShiftsProfileEntityRelationInput"] | undefined,
	unassignInfo?: GraphQLTypes["EmployeeQueueItemUpdateUnassignInfoEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["EmployeeQueueItemUpdateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["EmployeeQueueItemUpdateUnassignInfoEntityRelationInput"]: {
		create?: GraphQLTypes["UnassignedShiftInfoWithoutQueueItemCreateInput"] | undefined,
	update?: GraphQLTypes["UnassignedShiftInfoWithoutQueueItemUpdateInput"] | undefined,
	upsert?: GraphQLTypes["EmployeeQueueItemUpsertUnassignInfoRelationInput"] | undefined,
	connect?: GraphQLTypes["UnassignedShiftInfoUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UnassignedShiftInfoWithoutQueueItemUpdateInput"]: {
		hoursMissed?: number | undefined,
	legacyReason?: GraphQLTypes["UnassignedInfoReason"] | undefined,
	reason?: GraphQLTypes["UnassignedShiftInfoUpdateReasonEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UnassignedShiftInfoUpdateReasonEntityRelationInput"]: {
		create?: GraphQLTypes["UnassignReasonCreateInput"] | undefined,
	update?: GraphQLTypes["UnassignReasonUpdateInput"] | undefined,
	upsert?: GraphQLTypes["UnassignedShiftInfoUpsertReasonRelationInput"] | undefined,
	connect?: GraphQLTypes["UnassignReasonUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["UnassignReasonUpdateInput"]: {
		order?: number | undefined,
	name?: string | undefined,
	venues?: Array<GraphQLTypes["UnassignReasonUpdateVenuesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["UnassignReasonUpdateVenuesEntityRelationInput"]: {
		create?: GraphQLTypes["VenueWithoutEnabledUnassignReasonsCreateInput"] | undefined,
	update?: GraphQLTypes["UnassignReasonUpdateVenuesRelationInput"] | undefined,
	upsert?: GraphQLTypes["UnassignReasonUpsertVenuesRelationInput"] | undefined,
	connect?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	delete?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["UnassignReasonUpdateVenuesRelationInput"]: {
		by?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	data?: GraphQLTypes["VenueWithoutEnabledUnassignReasonsUpdateInput"] | undefined
};
	["VenueWithoutEnabledUnassignReasonsUpdateInput"]: {
		name?: string | undefined,
	deadlineTemplate?: GraphQLTypes["VenueUpdateDeadlineTemplateEntityRelationInput"] | undefined,
	timetableDays?: Array<GraphQLTypes["VenueUpdateTimetableDaysEntityRelationInput"]> | undefined,
	timetableTemplates?: Array<GraphQLTypes["VenueUpdateTimetableTemplatesEntityRelationInput"]> | undefined,
	staffMembers?: Array<GraphQLTypes["VenueUpdateStaffMembersEntityRelationInput"]> | undefined,
	employeeRoles?: Array<GraphQLTypes["VenueUpdateEmployeeRolesEntityRelationInput"]> | undefined,
	pointOfSaleApplicationDevices?: Array<GraphQLTypes["VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined,
	pointOfSaleTerminals?: Array<GraphQLTypes["VenueUpdatePointOfSaleTerminalsEntityRelationInput"]> | undefined,
	pointOfSalePrinters?: Array<GraphQLTypes["VenueUpdatePointOfSalePrintersEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["VenueUpdateOrdersEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["VenueUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	areas?: Array<GraphQLTypes["VenueUpdateAreasEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["VenueUpdateCategoriesEntityRelationInput"]> | undefined,
	channels?: Array<GraphQLTypes["VenueUpdateChannelsEntityRelationInput"]> | undefined,
	address?: string | undefined,
	pointOfSalePngBase64ReceiptLogo?: string | undefined,
	pointOfSaleInitialView?: GraphQLTypes["PointOfSaleInitialView"] | undefined,
	pointOfSalePreferPrintReceipt?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["UnassignReasonUpsertVenuesRelationInput"]: {
		by?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	update?: GraphQLTypes["VenueWithoutEnabledUnassignReasonsUpdateInput"] | undefined,
	create?: GraphQLTypes["VenueWithoutEnabledUnassignReasonsCreateInput"] | undefined
};
	["UnassignedShiftInfoUpsertReasonRelationInput"]: {
		update?: GraphQLTypes["UnassignReasonUpdateInput"] | undefined,
	create?: GraphQLTypes["UnassignReasonCreateInput"] | undefined
};
	["EmployeeQueueItemUpsertUnassignInfoRelationInput"]: {
		update?: GraphQLTypes["UnassignedShiftInfoWithoutQueueItemUpdateInput"] | undefined,
	create?: GraphQLTypes["UnassignedShiftInfoWithoutQueueItemCreateInput"] | undefined
};
	["EmployeeQueueItemUpdateMetaEntityRelationInput"]: {
		connect?: GraphQLTypes["EmployeeQueueItemMetadataUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TimetableShiftUpsertQueueItemRelationInput"]: {
		update?: GraphQLTypes["EmployeeQueueItemWithoutShiftUpdateInput"] | undefined,
	create?: GraphQLTypes["EmployeeQueueItemWithoutShiftCreateInput"] | undefined
};
	["TimetableShiftUpdateSwapInfoEntityRelationInput"]: {
		create?: GraphQLTypes["TimetableShiftSwapInfoWithoutShiftCreateInput"] | undefined,
	update?: GraphQLTypes["TimetableShiftSwapInfoWithoutShiftUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TimetableShiftUpsertSwapInfoRelationInput"] | undefined,
	connect?: GraphQLTypes["TimetableShiftSwapInfoUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TimetableShiftSwapInfoWithoutShiftUpdateInput"]: {
		assigned?: GraphQLTypes["Date"] | undefined,
	requested?: boolean | undefined,
	confirmed?: boolean | undefined,
	swappedShiftsProfile?: GraphQLTypes["TimetableShiftSwapInfoUpdateSwappedShiftsProfileEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableShiftSwapInfoUpdateSwappedShiftsProfileEntityRelationInput"]: {
		create?: GraphQLTypes["ShiftsProfileCreateInput"] | undefined,
	update?: GraphQLTypes["ShiftsProfileUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TimetableShiftSwapInfoUpsertSwappedShiftsProfileRelationInput"] | undefined,
	connect?: GraphQLTypes["ShiftsProfileUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TimetableShiftSwapInfoUpsertSwappedShiftsProfileRelationInput"]: {
		update?: GraphQLTypes["ShiftsProfileUpdateInput"] | undefined,
	create?: GraphQLTypes["ShiftsProfileCreateInput"] | undefined
};
	["TimetableShiftUpsertSwapInfoRelationInput"]: {
		update?: GraphQLTypes["TimetableShiftSwapInfoWithoutShiftUpdateInput"] | undefined,
	create?: GraphQLTypes["TimetableShiftSwapInfoWithoutShiftCreateInput"] | undefined
};
	["ShiftsProfileUpsertShiftsRelationInput"]: {
		by?: GraphQLTypes["TimetableShiftUniqueWhere"] | undefined,
	update?: GraphQLTypes["TimetableShiftWithoutShiftsProfileUpdateInput"] | undefined,
	create?: GraphQLTypes["TimetableShiftWithoutShiftsProfileCreateInput"] | undefined
};
	["EmployeeQueueItemUpsertShiftsProfileRelationInput"]: {
		update?: GraphQLTypes["ShiftsProfileWithoutQueueItemsUpdateInput"] | undefined,
	create?: GraphQLTypes["ShiftsProfileWithoutQueueItemsCreateInput"] | undefined
};
	["EmployeeQueueItemUpdateShiftEntityRelationInput"]: {
		create?: GraphQLTypes["TimetableShiftWithoutQueueItemCreateInput"] | undefined,
	update?: GraphQLTypes["TimetableShiftWithoutQueueItemUpdateInput"] | undefined,
	upsert?: GraphQLTypes["EmployeeQueueItemUpsertShiftRelationInput"] | undefined,
	connect?: GraphQLTypes["TimetableShiftUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TimetableShiftWithoutQueueItemUpdateInput"]: {
		locked?: boolean | undefined,
	order?: number | undefined,
	assigned?: GraphQLTypes["Date"] | undefined,
	group?: GraphQLTypes["TimetableShiftUpdateGroupEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["TimetableShiftUpdateShiftsProfileEntityRelationInput"] | undefined,
	swapInfo?: GraphQLTypes["TimetableShiftUpdateSwapInfoEntityRelationInput"] | undefined,
	isOvertime?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["EmployeeQueueItemUpsertShiftRelationInput"]: {
		update?: GraphQLTypes["TimetableShiftWithoutQueueItemUpdateInput"] | undefined,
	create?: GraphQLTypes["TimetableShiftWithoutQueueItemCreateInput"] | undefined
};
	["EmployeeQueueUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["EmployeeQueueItemUniqueWhere"] | undefined,
	update?: GraphQLTypes["EmployeeQueueItemWithoutQueueUpdateInput"] | undefined,
	create?: GraphQLTypes["EmployeeQueueItemWithoutQueueCreateInput"] | undefined
};
	["TimetableShiftGroupUpsertQueueRelationInput"]: {
		update?: GraphQLTypes["EmployeeQueueWithoutShiftGroupUpdateInput"] | undefined,
	create?: GraphQLTypes["EmployeeQueueWithoutShiftGroupCreateInput"] | undefined
};
	["TimetableShiftPositionUpsertShiftGroupsRelationInput"]: {
		by?: GraphQLTypes["TimetableShiftGroupUniqueWhere"] | undefined,
	update?: GraphQLTypes["TimetableShiftGroupWithoutPositionUpdateInput"] | undefined,
	create?: GraphQLTypes["TimetableShiftGroupWithoutPositionCreateInput"] | undefined
};
	["TimetableTemplateUpsertPositionRelationInput"]: {
		update?: GraphQLTypes["TimetableShiftPositionWithoutTimetableTemplatesUpdateInput"] | undefined,
	create?: GraphQLTypes["TimetableShiftPositionWithoutTimetableTemplatesCreateInput"] | undefined
};
	["TimetableEmployeeRoleUpsertTimetableTemplatesRelationInput"]: {
		by?: GraphQLTypes["TimetableTemplateUniqueWhere"] | undefined,
	update?: GraphQLTypes["TimetableTemplateWithoutEmployeeRoleUpdateInput"] | undefined,
	create?: GraphQLTypes["TimetableTemplateWithoutEmployeeRoleCreateInput"] | undefined
};
	["TimetableShiftGroupUpsertTypeRelationInput"]: {
		update?: GraphQLTypes["TimetableEmployeeRoleWithoutShiftGroupsUpdateInput"] | undefined,
	create?: GraphQLTypes["TimetableEmployeeRoleWithoutShiftGroupsCreateInput"] | undefined
};
	["TimetableDayUpsertShiftGroupsRelationInput"]: {
		by?: GraphQLTypes["TimetableShiftGroupUniqueWhere"] | undefined,
	update?: GraphQLTypes["TimetableShiftGroupWithoutDayUpdateInput"] | undefined,
	create?: GraphQLTypes["TimetableShiftGroupWithoutDayCreateInput"] | undefined
};
	["TimetableDayUpdateMetaEntityRelationInput"]: {
		connect?: GraphQLTypes["TimetableDayMetadataUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["VenueUpsertTimetableDaysRelationInput"]: {
		by?: GraphQLTypes["TimetableDayUniqueWhere"] | undefined,
	update?: GraphQLTypes["TimetableDayWithoutVenueUpdateInput"] | undefined,
	create?: GraphQLTypes["TimetableDayWithoutVenueCreateInput"] | undefined
};
	["ChannelUpsertVenueRelationInput"]: {
		update?: GraphQLTypes["VenueWithoutChannelsUpdateInput"] | undefined,
	create?: GraphQLTypes["VenueWithoutChannelsCreateInput"] | undefined
};
	["TagUpsertPublicInChannelsRelationInput"]: {
		by?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	update?: GraphQLTypes["ChannelWithoutPublicTagsUpdateInput"] | undefined,
	create?: GraphQLTypes["ChannelWithoutPublicTagsCreateInput"] | undefined
};
	["DeliveryZoneUpsertDeliveryZonesOfTagsRelationInput"]: {
		by?: GraphQLTypes["TagUniqueWhere"] | undefined,
	update?: GraphQLTypes["TagWithoutDeliveryZonesUpdateInput"] | undefined,
	create?: GraphQLTypes["TagWithoutDeliveryZonesCreateInput"] | undefined
};
	["DeliveryZoneUpdateAddressesMetadataEntityRelationInput"]: {
		connect?: GraphQLTypes["AddressMetadataUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["AddressMetadataUniqueWhere"] | undefined,
	delete?: GraphQLTypes["AddressMetadataUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductUpsertDeliveryZonesRelationInput"]: {
		by?: GraphQLTypes["DeliveryZoneUniqueWhere"] | undefined,
	update?: GraphQLTypes["DeliveryZoneWithoutDeliveryZonesOfProductsUpdateInput"] | undefined,
	create?: GraphQLTypes["DeliveryZoneWithoutDeliveryZonesOfProductsCreateInput"] | undefined
};
	["FulfillmentNoteUpsertProductsRelationInput"]: {
		by?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	update?: GraphQLTypes["ProductWithoutFulfillmentNotesUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductWithoutFulfillmentNotesCreateInput"] | undefined
};
	["TagUpsertFulfillmentNotesRelationInput"]: {
		by?: GraphQLTypes["FulfillmentNoteUniqueWhere"] | undefined,
	update?: GraphQLTypes["FulfillmentNoteWithoutTagsUpdateInput"] | undefined,
	create?: GraphQLTypes["FulfillmentNoteWithoutTagsCreateInput"] | undefined
};
	["ChannelUpsertPublicTagsRelationInput"]: {
		by?: GraphQLTypes["TagUniqueWhere"] | undefined,
	update?: GraphQLTypes["TagWithoutPublicInChannelsUpdateInput"] | undefined,
	create?: GraphQLTypes["TagWithoutPublicInChannelsCreateInput"] | undefined
};
	["CustomerUpsertChannelsRelationInput"]: {
		by?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	update?: GraphQLTypes["ChannelWithoutCustomersUpdateInput"] | undefined,
	create?: GraphQLTypes["ChannelWithoutCustomersCreateInput"] | undefined
};
	["CustomerCreditUpsertCustomerRelationInput"]: {
		update?: GraphQLTypes["CustomerWithoutCreditsUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerWithoutCreditsCreateInput"] | undefined
};
	["CustomerCreditUpdateVoucherRedemptionEntityRelationInput"]: {
		create?: GraphQLTypes["VoucherRedemptionWithoutCustomerCreditCreateInput"] | undefined,
	update?: GraphQLTypes["VoucherRedemptionWithoutCustomerCreditUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CustomerCreditUpsertVoucherRedemptionRelationInput"] | undefined,
	connect?: GraphQLTypes["VoucherRedemptionUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["VoucherRedemptionWithoutCustomerCreditUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	manualRedemptionNote?: string | undefined,
	orderDiscount?: GraphQLTypes["VoucherRedemptionUpdateOrderDiscountEntityRelationInput"] | undefined,
	voucher?: GraphQLTypes["VoucherRedemptionUpdateVoucherEntityRelationInput"] | undefined,
	customer?: GraphQLTypes["VoucherRedemptionUpdateCustomerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreditUpsertVoucherRedemptionRelationInput"]: {
		update?: GraphQLTypes["VoucherRedemptionWithoutCustomerCreditUpdateInput"] | undefined,
	create?: GraphQLTypes["VoucherRedemptionWithoutCustomerCreditCreateInput"] | undefined
};
	["CustomerCreditTransactionUpsertCustomerCreditRelationInput"]: {
		update?: GraphQLTypes["CustomerCreditWithoutTransactionsUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerCreditWithoutTransactionsCreateInput"] | undefined
};
	["OrderDiscountUpsertCustomerCreditTransactionsRelationInput"]: {
		by?: GraphQLTypes["CustomerCreditTransactionUniqueWhere"] | undefined,
	update?: GraphQLTypes["CustomerCreditTransactionWithoutOrderDiscountUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerCreditTransactionWithoutOrderDiscountCreateInput"] | undefined
};
	["OrderUpsertDiscountsRelationInput"]: {
		by?: GraphQLTypes["OrderDiscountUniqueWhere"] | undefined,
	update?: GraphQLTypes["OrderDiscountWithoutOrderUpdateInput"] | undefined,
	create?: GraphQLTypes["OrderDiscountWithoutOrderCreateInput"] | undefined
};
	["OrderItemUpsertOrderRelationInput"]: {
		update?: GraphQLTypes["OrderWithoutItemsUpdateInput"] | undefined,
	create?: GraphQLTypes["OrderWithoutItemsCreateInput"] | undefined
};
	["ProductUpsertOrderItemsRelationInput"]: {
		by?: GraphQLTypes["OrderItemUniqueWhere"] | undefined,
	update?: GraphQLTypes["OrderItemWithoutProductUpdateInput"] | undefined,
	create?: GraphQLTypes["OrderItemWithoutProductCreateInput"] | undefined
};
	["StocksManagerUpsertManagedProductsRelationInput"]: {
		by?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	update?: GraphQLTypes["ProductWithoutManagerUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductWithoutManagerCreateInput"] | undefined
};
	["StaffUpsertStocksManagerRelationInput"]: {
		update?: GraphQLTypes["StocksManagerWithoutStaffUpdateInput"] | undefined,
	create?: GraphQLTypes["StocksManagerWithoutStaffCreateInput"] | undefined
};
	["StaffUpdateVenuesEntityRelationInput"]: {
		create?: GraphQLTypes["VenueWithoutStaffMembersCreateInput"] | undefined,
	update?: GraphQLTypes["StaffUpdateVenuesRelationInput"] | undefined,
	upsert?: GraphQLTypes["StaffUpsertVenuesRelationInput"] | undefined,
	connect?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	delete?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["StaffUpdateVenuesRelationInput"]: {
		by?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	data?: GraphQLTypes["VenueWithoutStaffMembersUpdateInput"] | undefined
};
	["VenueWithoutStaffMembersUpdateInput"]: {
		name?: string | undefined,
	deadlineTemplate?: GraphQLTypes["VenueUpdateDeadlineTemplateEntityRelationInput"] | undefined,
	timetableDays?: Array<GraphQLTypes["VenueUpdateTimetableDaysEntityRelationInput"]> | undefined,
	timetableTemplates?: Array<GraphQLTypes["VenueUpdateTimetableTemplatesEntityRelationInput"]> | undefined,
	employeeRoles?: Array<GraphQLTypes["VenueUpdateEmployeeRolesEntityRelationInput"]> | undefined,
	pointOfSaleApplicationDevices?: Array<GraphQLTypes["VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined,
	pointOfSaleTerminals?: Array<GraphQLTypes["VenueUpdatePointOfSaleTerminalsEntityRelationInput"]> | undefined,
	pointOfSalePrinters?: Array<GraphQLTypes["VenueUpdatePointOfSalePrintersEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["VenueUpdateOrdersEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["VenueUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	areas?: Array<GraphQLTypes["VenueUpdateAreasEntityRelationInput"]> | undefined,
	enabledUnassignReasons?: Array<GraphQLTypes["VenueUpdateEnabledUnassignReasonsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["VenueUpdateCategoriesEntityRelationInput"]> | undefined,
	channels?: Array<GraphQLTypes["VenueUpdateChannelsEntityRelationInput"]> | undefined,
	address?: string | undefined,
	pointOfSalePngBase64ReceiptLogo?: string | undefined,
	pointOfSaleInitialView?: GraphQLTypes["PointOfSaleInitialView"] | undefined,
	pointOfSalePreferPrintReceipt?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["StaffUpsertVenuesRelationInput"]: {
		by?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	update?: GraphQLTypes["VenueWithoutStaffMembersUpdateInput"] | undefined,
	create?: GraphQLTypes["VenueWithoutStaffMembersCreateInput"] | undefined
};
	["ShiftsManagerUpsertStaffRelationInput"]: {
		update?: GraphQLTypes["StaffWithoutShiftsManagerUpdateInput"] | undefined,
	create?: GraphQLTypes["StaffWithoutShiftsManagerCreateInput"] | undefined
};
	["TimetableEmployeeRoleUpsertShiftsManagersRelationInput"]: {
		by?: GraphQLTypes["ShiftsManagerUniqueWhere"] | undefined,
	update?: GraphQLTypes["ShiftsManagerWithoutManagedRolesUpdateInput"] | undefined,
	create?: GraphQLTypes["ShiftsManagerWithoutManagedRolesCreateInput"] | undefined
};
	["ShiftsProfileUpsertRolesRelationInput"]: {
		by?: GraphQLTypes["TimetableEmployeeRoleUniqueWhere"] | undefined,
	update?: GraphQLTypes["TimetableEmployeeRoleWithoutShiftsProfilesUpdateInput"] | undefined,
	create?: GraphQLTypes["TimetableEmployeeRoleWithoutShiftsProfilesCreateInput"] | undefined
};
	["StaffUpsertShiftsProfileRelationInput"]: {
		update?: GraphQLTypes["ShiftsProfileWithoutStaffUpdateInput"] | undefined,
	create?: GraphQLTypes["ShiftsProfileWithoutStaffCreateInput"] | undefined
};
	["UserUpsertStaffRelationInput"]: {
		update?: GraphQLTypes["StaffWithoutUserUpdateInput"] | undefined,
	create?: GraphQLTypes["StaffWithoutUserCreateInput"] | undefined
};
	["CustomerUpsertUserRelationInput"]: {
		update?: GraphQLTypes["UserWithoutCustomerUpdateInput"] | undefined,
	create?: GraphQLTypes["UserWithoutCustomerCreateInput"] | undefined
};
	["OrderUpsertCustomerRelationInput"]: {
		update?: GraphQLTypes["CustomerWithoutOrdersUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerWithoutOrdersCreateInput"] | undefined
};
	["CartUpsertOrderRelationInput"]: {
		update?: GraphQLTypes["OrderWithoutCartUpdateInput"] | undefined,
	create?: GraphQLTypes["OrderWithoutCartCreateInput"] | undefined
};
	["CustomerUpsertCartsRelationInput"]: {
		by?: GraphQLTypes["CartUniqueWhere"] | undefined,
	update?: GraphQLTypes["CartWithoutCustomerUpdateInput"] | undefined,
	create?: GraphQLTypes["CartWithoutCustomerCreateInput"] | undefined
};
	["UserUpsertCustomerRelationInput"]: {
		update?: GraphQLTypes["CustomerWithoutUserUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerWithoutUserCreateInput"] | undefined
};
	["StaffUpsertUserRelationInput"]: {
		update?: GraphQLTypes["UserWithoutStaffUpdateInput"] | undefined,
	create?: GraphQLTypes["UserWithoutStaffCreateInput"] | undefined
};
	["BusinessToBusinessManagerUpsertStaffRelationInput"]: {
		update?: GraphQLTypes["StaffWithoutBusinessToBusinessManagerUpdateInput"] | undefined,
	create?: GraphQLTypes["StaffWithoutBusinessToBusinessManagerCreateInput"] | undefined
};
	["BusinessCustomerUpsertAccountManagerRelationInput"]: {
		update?: GraphQLTypes["BusinessToBusinessManagerWithoutManagedBusinessesUpdateInput"] | undefined,
	create?: GraphQLTypes["BusinessToBusinessManagerWithoutManagedBusinessesCreateInput"] | undefined
};
	["BusinessCustomerUpdateLogoEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BusinessCustomerUpsertLogoRelationInput"] | undefined,
	connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["BusinessCustomerUpsertLogoRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["BusinessCustomerUpdateBusinessServiceEventsEntityRelationInput"]: {
		create?: GraphQLTypes["BusinessServiceEventWithoutBusinessCustomerCreateInput"] | undefined,
	update?: GraphQLTypes["BusinessCustomerUpdateBusinessServiceEventsRelationInput"] | undefined,
	upsert?: GraphQLTypes["BusinessCustomerUpsertBusinessServiceEventsRelationInput"] | undefined,
	connect?: GraphQLTypes["BusinessServiceEventUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["BusinessServiceEventUniqueWhere"] | undefined,
	delete?: GraphQLTypes["BusinessServiceEventUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["BusinessCustomerUpdateBusinessServiceEventsRelationInput"]: {
		by?: GraphQLTypes["BusinessServiceEventUniqueWhere"] | undefined,
	data?: GraphQLTypes["BusinessServiceEventWithoutBusinessCustomerUpdateInput"] | undefined
};
	["BusinessServiceEventWithoutBusinessCustomerUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	businessService?: GraphQLTypes["BusinessServiceEventUpdateBusinessServiceEntityRelationInput"] | undefined,
	filledNumberOfPeople?: number | undefined,
	filledInvoiced?: boolean | undefined,
	filledEquipment?: string | undefined,
	filledMillTamDem?: boolean | undefined,
	filledSOEspresso?: boolean | undefined,
	filledFilterCoffeeInMenu?: boolean | undefined,
	filledWaterMeterStatus?: string | undefined,
	filledServiceAction?: string | undefined,
	filledInvoiceIdentifier?: string | undefined,
	filledNote?: string | undefined,
	filledContact?: string | undefined,
	filledPhone?: boolean | undefined,
	filledEmail?: boolean | undefined,
	filledGrindingStonesCondition?: string | undefined,
	createdBy?: GraphQLTypes["BusinessServiceEventUpdateCreatedByEntityRelationInput"] | undefined,
	filledSupervisor?: GraphQLTypes["BusinessServiceEventUpdateFilledSupervisorEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessServiceEventUpdateBusinessServiceEntityRelationInput"]: {
		create?: GraphQLTypes["BusinessServiceCreateInput"] | undefined,
	update?: GraphQLTypes["BusinessServiceUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BusinessServiceEventUpsertBusinessServiceRelationInput"] | undefined,
	connect?: GraphQLTypes["BusinessServiceUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["BusinessServiceUpdateInput"]: {
		order?: number | undefined,
	requireNote?: number | undefined,
	locales?: Array<GraphQLTypes["BusinessServiceUpdateLocalesEntityRelationInput"]> | undefined,
	requireNumberOfPeople?: number | undefined,
	requireInvoiced?: number | undefined,
	requireEquipment?: number | undefined,
	requireMillTamDem?: number | undefined,
	requireSOEspresso?: number | undefined,
	requireFilterCoffeeInMenu?: number | undefined,
	requireWaterMeterStatus?: number | undefined,
	requireServiceAction?: number | undefined,
	optionsEquipment?: string | undefined,
	optionsServiceAction?: string | undefined,
	requireInvoiceIdentifier?: number | undefined,
	requireSupervisor?: number | undefined,
	requireContact?: number | undefined,
	requirePhone?: number | undefined,
	requireEmail?: number | undefined,
	requireGrindingStonesCondition?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessServiceUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["BusinessServiceLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["BusinessServiceUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["BusinessServiceUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["BusinessServiceLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["BusinessServiceLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["BusinessServiceLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["BusinessServiceUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["BusinessServiceLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["BusinessServiceLocaleWithoutRootUpdateInput"] | undefined
};
	["BusinessServiceLocaleWithoutRootUpdateInput"]: {
		name?: string | undefined,
	labelNote?: string | undefined,
	locale?: GraphQLTypes["BusinessServiceLocaleUpdateLocaleEntityRelationInput"] | undefined,
	labelNumberOfPeople?: string | undefined,
	labelInvoiced?: string | undefined,
	labelEquipment?: string | undefined,
	labelMillTamDem?: string | undefined,
	labelSOEspresso?: string | undefined,
	labelFilterCoffeeInMenu?: string | undefined,
	labelWaterMeterStatus?: string | undefined,
	labelServiceAction?: string | undefined,
	labelInvoiceIdentifier?: string | undefined,
	labelSupervisor?: string | undefined,
	labelContact?: string | undefined,
	labelPhone?: string | undefined,
	labelEmail?: string | undefined,
	labelGrindingStonesCondition?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessServiceLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutBusinessServicesCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutBusinessServicesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BusinessServiceLocaleUpsertLocaleRelationInput"] | undefined,
	connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutBusinessServicesUpdateInput"]: {
		businessCategories?: Array<GraphQLTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessServiceLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutBusinessServicesUpdateInput"] | undefined,
	create?: GraphQLTypes["LocaleWithoutBusinessServicesCreateInput"] | undefined
};
	["BusinessServiceUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["BusinessServiceLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["BusinessServiceLocaleWithoutRootUpdateInput"] | undefined,
	create?: GraphQLTypes["BusinessServiceLocaleWithoutRootCreateInput"] | undefined
};
	["BusinessServiceEventUpsertBusinessServiceRelationInput"]: {
		update?: GraphQLTypes["BusinessServiceUpdateInput"] | undefined,
	create?: GraphQLTypes["BusinessServiceCreateInput"] | undefined
};
	["BusinessServiceEventUpdateCreatedByEntityRelationInput"]: {
		create?: GraphQLTypes["StaffCreateInput"] | undefined,
	update?: GraphQLTypes["StaffUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BusinessServiceEventUpsertCreatedByRelationInput"] | undefined,
	connect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["StaffUpdateInput"]: {
		bartender?: GraphQLTypes["StaffUpdateBartenderEntityRelationInput"] | undefined,
	courier?: GraphQLTypes["StaffUpdateCourierEntityRelationInput"] | undefined,
	cleaner?: GraphQLTypes["StaffUpdateCleanerEntityRelationInput"] | undefined,
	shiftsManager?: GraphQLTypes["StaffUpdateShiftsManagerEntityRelationInput"] | undefined,
	businessToBusinessManager?: GraphQLTypes["StaffUpdateBusinessToBusinessManagerEntityRelationInput"] | undefined,
	user?: GraphQLTypes["StaffUpdateUserEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["StaffUpdateShiftsProfileEntityRelationInput"] | undefined,
	stocksManager?: GraphQLTypes["StaffUpdateStocksManagerEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["StaffUpdatePhotoEntityRelationInput"] | undefined,
	courierManager?: GraphQLTypes["StaffUpdateCourierManagerEntityRelationInput"] | undefined,
	picker?: GraphQLTypes["StaffUpdatePickerEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	remunerationProfile?: GraphQLTypes["StaffUpdateRemunerationProfileEntityRelationInput"] | undefined,
	cashier?: GraphQLTypes["StaffUpdateCashierEntityRelationInput"] | undefined,
	venues?: Array<GraphQLTypes["StaffUpdateVenuesEntityRelationInput"]> | undefined,
	internalBuyer?: GraphQLTypes["StaffUpdateInternalBuyerEntityRelationInput"] | undefined,
	salesManager?: GraphQLTypes["StaffUpdateSalesManagerEntityRelationInput"] | undefined,
	cashierManager?: GraphQLTypes["StaffUpdateCashierManagerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessServiceEventUpsertCreatedByRelationInput"]: {
		update?: GraphQLTypes["StaffUpdateInput"] | undefined,
	create?: GraphQLTypes["StaffCreateInput"] | undefined
};
	["BusinessServiceEventUpdateFilledSupervisorEntityRelationInput"]: {
		create?: GraphQLTypes["StaffCreateInput"] | undefined,
	update?: GraphQLTypes["StaffUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BusinessServiceEventUpsertFilledSupervisorRelationInput"] | undefined,
	connect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["BusinessServiceEventUpsertFilledSupervisorRelationInput"]: {
		update?: GraphQLTypes["StaffUpdateInput"] | undefined,
	create?: GraphQLTypes["StaffCreateInput"] | undefined
};
	["BusinessCustomerUpsertBusinessServiceEventsRelationInput"]: {
		by?: GraphQLTypes["BusinessServiceEventUniqueWhere"] | undefined,
	update?: GraphQLTypes["BusinessServiceEventWithoutBusinessCustomerUpdateInput"] | undefined,
	create?: GraphQLTypes["BusinessServiceEventWithoutBusinessCustomerCreateInput"] | undefined
};
	["BusinessCustomerUpdateDoubleshotCoffeeEquipmentEntityRelationInput"]: {
		create?: GraphQLTypes["DoubleshotCoffeeEquipmentCreateInput"] | undefined,
	update?: GraphQLTypes["DoubleshotCoffeeEquipmentUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BusinessCustomerUpsertDoubleshotCoffeeEquipmentRelationInput"] | undefined,
	connect?: GraphQLTypes["DoubleshotCoffeeEquipmentUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["DoubleshotCoffeeEquipmentUpdateInput"]: {
		espressoMachine?: string | undefined,
	espressoGrinder?: string | undefined,
	batchBrew?: string | undefined,
	batchGrinder?: string | undefined,
	waterFilter?: string | undefined,
	mechanicalFilter?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessCustomerUpsertDoubleshotCoffeeEquipmentRelationInput"]: {
		update?: GraphQLTypes["DoubleshotCoffeeEquipmentUpdateInput"] | undefined,
	create?: GraphQLTypes["DoubleshotCoffeeEquipmentCreateInput"] | undefined
};
	["CustomerUpsertOwnerOfBusinessesRelationInput"]: {
		by?: GraphQLTypes["BusinessCustomerUniqueWhere"] | undefined,
	update?: GraphQLTypes["BusinessCustomerWithoutOwnersUpdateInput"] | undefined,
	create?: GraphQLTypes["BusinessCustomerWithoutOwnersCreateInput"] | undefined
};
	["BusinessCustomerUpsertMembersRelationInput"]: {
		by?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	update?: GraphQLTypes["CustomerWithoutMemberOfBusinessesUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerWithoutMemberOfBusinessesCreateInput"] | undefined
};
	["BusinessToBusinessManagerUpsertManagedBusinessesRelationInput"]: {
		by?: GraphQLTypes["BusinessCustomerUniqueWhere"] | undefined,
	update?: GraphQLTypes["BusinessCustomerWithoutAccountManagerUpdateInput"] | undefined,
	create?: GraphQLTypes["BusinessCustomerWithoutAccountManagerCreateInput"] | undefined
};
	["StaffUpsertBusinessToBusinessManagerRelationInput"]: {
		update?: GraphQLTypes["BusinessToBusinessManagerWithoutStaffUpdateInput"] | undefined,
	create?: GraphQLTypes["BusinessToBusinessManagerWithoutStaffCreateInput"] | undefined
};
	["ShiftsProfileUpsertStaffRelationInput"]: {
		update?: GraphQLTypes["StaffWithoutShiftsProfileUpdateInput"] | undefined,
	create?: GraphQLTypes["StaffWithoutShiftsProfileCreateInput"] | undefined
};
	["TimetableEmployeeRoleUpsertShiftsProfilesRelationInput"]: {
		by?: GraphQLTypes["ShiftsProfileUniqueWhere"] | undefined,
	update?: GraphQLTypes["ShiftsProfileWithoutRolesUpdateInput"] | undefined,
	create?: GraphQLTypes["ShiftsProfileWithoutRolesCreateInput"] | undefined
};
	["TimetableDayNoteUpsertRoleRelationInput"]: {
		update?: GraphQLTypes["TimetableEmployeeRoleUpdateInput"] | undefined,
	create?: GraphQLTypes["TimetableEmployeeRoleCreateInput"] | undefined
};
	["TimetableDayUpsertNotesRelationInput"]: {
		by?: GraphQLTypes["TimetableDayNoteUniqueWhere"] | undefined,
	update?: GraphQLTypes["TimetableDayNoteWithoutDayUpdateInput"] | undefined,
	create?: GraphQLTypes["TimetableDayNoteWithoutDayCreateInput"] | undefined
};
	["TimetableDayUpdateVenueEntityRelationInput"]: {
		create?: GraphQLTypes["VenueWithoutTimetableDaysCreateInput"] | undefined,
	update?: GraphQLTypes["VenueWithoutTimetableDaysUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TimetableDayUpsertVenueRelationInput"] | undefined,
	connect?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["VenueWithoutTimetableDaysUpdateInput"]: {
		name?: string | undefined,
	deadlineTemplate?: GraphQLTypes["VenueUpdateDeadlineTemplateEntityRelationInput"] | undefined,
	timetableTemplates?: Array<GraphQLTypes["VenueUpdateTimetableTemplatesEntityRelationInput"]> | undefined,
	staffMembers?: Array<GraphQLTypes["VenueUpdateStaffMembersEntityRelationInput"]> | undefined,
	employeeRoles?: Array<GraphQLTypes["VenueUpdateEmployeeRolesEntityRelationInput"]> | undefined,
	pointOfSaleApplicationDevices?: Array<GraphQLTypes["VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined,
	pointOfSaleTerminals?: Array<GraphQLTypes["VenueUpdatePointOfSaleTerminalsEntityRelationInput"]> | undefined,
	pointOfSalePrinters?: Array<GraphQLTypes["VenueUpdatePointOfSalePrintersEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["VenueUpdateOrdersEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["VenueUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	areas?: Array<GraphQLTypes["VenueUpdateAreasEntityRelationInput"]> | undefined,
	enabledUnassignReasons?: Array<GraphQLTypes["VenueUpdateEnabledUnassignReasonsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["VenueUpdateCategoriesEntityRelationInput"]> | undefined,
	channels?: Array<GraphQLTypes["VenueUpdateChannelsEntityRelationInput"]> | undefined,
	address?: string | undefined,
	pointOfSalePngBase64ReceiptLogo?: string | undefined,
	pointOfSaleInitialView?: GraphQLTypes["PointOfSaleInitialView"] | undefined,
	pointOfSalePreferPrintReceipt?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableDayUpsertVenueRelationInput"]: {
		update?: GraphQLTypes["VenueWithoutTimetableDaysUpdateInput"] | undefined,
	create?: GraphQLTypes["VenueWithoutTimetableDaysCreateInput"] | undefined
};
	["TimetableShiftGroupUpsertDayRelationInput"]: {
		update?: GraphQLTypes["TimetableDayWithoutShiftGroupsUpdateInput"] | undefined,
	create?: GraphQLTypes["TimetableDayWithoutShiftGroupsCreateInput"] | undefined
};
	["EmployeeQueueUpsertShiftGroupRelationInput"]: {
		update?: GraphQLTypes["TimetableShiftGroupWithoutQueueUpdateInput"] | undefined,
	create?: GraphQLTypes["TimetableShiftGroupWithoutQueueCreateInput"] | undefined
};
	["EmployeeQueueItemUpsertQueueRelationInput"]: {
		update?: GraphQLTypes["EmployeeQueueWithoutItemsUpdateInput"] | undefined,
	create?: GraphQLTypes["EmployeeQueueWithoutItemsCreateInput"] | undefined
};
	["ShiftsProfileUpsertQueueItemsRelationInput"]: {
		by?: GraphQLTypes["EmployeeQueueItemUniqueWhere"] | undefined,
	update?: GraphQLTypes["EmployeeQueueItemWithoutShiftsProfileUpdateInput"] | undefined,
	create?: GraphQLTypes["EmployeeQueueItemWithoutShiftsProfileCreateInput"] | undefined
};
	["TimetableShiftUpsertShiftsProfileRelationInput"]: {
		update?: GraphQLTypes["ShiftsProfileWithoutShiftsUpdateInput"] | undefined,
	create?: GraphQLTypes["ShiftsProfileWithoutShiftsCreateInput"] | undefined
};
	["TimetableShiftGroupUpsertShiftsRelationInput"]: {
		by?: GraphQLTypes["TimetableShiftUniqueWhere"] | undefined,
	update?: GraphQLTypes["TimetableShiftWithoutGroupUpdateInput"] | undefined,
	create?: GraphQLTypes["TimetableShiftWithoutGroupCreateInput"] | undefined
};
	["TimetableEmployeeRoleUpsertShiftGroupsRelationInput"]: {
		by?: GraphQLTypes["TimetableShiftGroupUniqueWhere"] | undefined,
	update?: GraphQLTypes["TimetableShiftGroupWithoutTypeUpdateInput"] | undefined,
	create?: GraphQLTypes["TimetableShiftGroupWithoutTypeCreateInput"] | undefined
};
	["ShiftsManagerUpsertManagedRolesRelationInput"]: {
		by?: GraphQLTypes["TimetableEmployeeRoleUniqueWhere"] | undefined,
	update?: GraphQLTypes["TimetableEmployeeRoleWithoutShiftsManagersUpdateInput"] | undefined,
	create?: GraphQLTypes["TimetableEmployeeRoleWithoutShiftsManagersCreateInput"] | undefined
};
	["StaffUpsertShiftsManagerRelationInput"]: {
		update?: GraphQLTypes["ShiftsManagerWithoutStaffUpdateInput"] | undefined,
	create?: GraphQLTypes["ShiftsManagerWithoutStaffCreateInput"] | undefined
};
	["CourierUpsertStaffRelationInput"]: {
		update?: GraphQLTypes["StaffWithoutCourierUpdateInput"] | undefined,
	create?: GraphQLTypes["StaffWithoutCourierCreateInput"] | undefined
};
	["DeliveryMethodUpsertCourierHandlersRelationInput"]: {
		by?: GraphQLTypes["CourierUniqueWhere"] | undefined,
	update?: GraphQLTypes["CourierWithoutDeliveryMethodsUpdateInput"] | undefined,
	create?: GraphQLTypes["CourierWithoutDeliveryMethodsCreateInput"] | undefined
};
	["OrderDeliveryUpsertMethodRelationInput"]: {
		update?: GraphQLTypes["DeliveryMethodUpdateInput"] | undefined,
	create?: GraphQLTypes["DeliveryMethodCreateInput"] | undefined
};
	["DeliveryWaypointUpsertDeliveryRelationInput"]: {
		update?: GraphQLTypes["OrderDeliveryWithoutDeliveryWaypointUpdateInput"] | undefined,
	create?: GraphQLTypes["OrderDeliveryWithoutDeliveryWaypointCreateInput"] | undefined
};
	["DeliveryRouteUpsertWaypointsRelationInput"]: {
		by?: GraphQLTypes["DeliveryWaypointUniqueWhere"] | undefined,
	update?: GraphQLTypes["DeliveryWaypointWithoutRouteUpdateInput"] | undefined,
	create?: GraphQLTypes["DeliveryWaypointWithoutRouteCreateInput"] | undefined
};
	["CourierUpsertRoutesRelationInput"]: {
		by?: GraphQLTypes["DeliveryRouteUniqueWhere"] | undefined,
	update?: GraphQLTypes["DeliveryRouteWithoutCourierUpdateInput"] | undefined,
	create?: GraphQLTypes["DeliveryRouteWithoutCourierCreateInput"] | undefined
};
	["StaffUpsertCourierRelationInput"]: {
		update?: GraphQLTypes["CourierWithoutStaffUpdateInput"] | undefined,
	create?: GraphQLTypes["CourierWithoutStaffCreateInput"] | undefined
};
	["StocksManagerUpsertStaffRelationInput"]: {
		update?: GraphQLTypes["StaffWithoutStocksManagerUpdateInput"] | undefined,
	create?: GraphQLTypes["StaffWithoutStocksManagerCreateInput"] | undefined
};
	["ProductUpsertManagerRelationInput"]: {
		update?: GraphQLTypes["StocksManagerWithoutManagedProductsUpdateInput"] | undefined,
	create?: GraphQLTypes["StocksManagerWithoutManagedProductsCreateInput"] | undefined
};
	["VirtualProductUpsertProductRelationInput"]: {
		update?: GraphQLTypes["ProductWithoutVirtualProductUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductWithoutVirtualProductCreateInput"] | undefined
};
	["WorkspaceUpsertCreditsProductRelationInput"]: {
		update?: GraphQLTypes["VirtualProductUpdateInput"] | undefined,
	create?: GraphQLTypes["VirtualProductCreateInput"] | undefined
};
	["WorkspaceUpdateDiscountVatRateEntityRelationInput"]: {
		create?: GraphQLTypes["VatRateCreateInput"] | undefined,
	update?: GraphQLTypes["VatRateUpdateInput"] | undefined,
	upsert?: GraphQLTypes["WorkspaceUpsertDiscountVatRateRelationInput"] | undefined,
	connect?: GraphQLTypes["VatRateUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["WorkspaceUpsertDiscountVatRateRelationInput"]: {
		update?: GraphQLTypes["VatRateUpdateInput"] | undefined,
	create?: GraphQLTypes["VatRateCreateInput"] | undefined
};
	["FreshingContainerUpsertWorkspaceRelationInput"]: {
		update?: GraphQLTypes["WorkspaceWithoutFreshingContainersUpdateInput"] | undefined,
	create?: GraphQLTypes["WorkspaceWithoutFreshingContainersCreateInput"] | undefined
};
	["ProductIngredientUpsertFreshingContainerRelationInput"]: {
		update?: GraphQLTypes["FreshingContainerUpdateInput"] | undefined,
	create?: GraphQLTypes["FreshingContainerCreateInput"] | undefined
};
	["ProductIngredientUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductIngredientUpsertImageRelationInput"] | undefined,
	connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProductIngredientUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["ProductIngredientUpdateSuppliersEntityRelationInput"]: {
		create?: GraphQLTypes["IngredientSupplierListCreateInput"] | undefined,
	update?: GraphQLTypes["IngredientSupplierListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductIngredientUpsertSuppliersRelationInput"] | undefined,
	connect?: GraphQLTypes["IngredientSupplierListUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["IngredientSupplierListUpdateInput"]: {
		items?: Array<GraphQLTypes["IngredientSupplierListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["IngredientSupplierListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["IngredientSupplierItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["IngredientSupplierListUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["IngredientSupplierListUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["IngredientSupplierItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["IngredientSupplierItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["IngredientSupplierItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["IngredientSupplierListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["IngredientSupplierItemUniqueWhere"] | undefined,
	data?: GraphQLTypes["IngredientSupplierItemWithoutListUpdateInput"] | undefined
};
	["IngredientSupplierItemWithoutListUpdateInput"]: {
		order?: number | undefined,
	supplier?: GraphQLTypes["IngredientSupplierItemUpdateSupplierEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["IngredientSupplierItemUpdateSupplierEntityRelationInput"]: {
		create?: GraphQLTypes["IngredientSupplierCreateInput"] | undefined,
	update?: GraphQLTypes["IngredientSupplierUpdateInput"] | undefined,
	upsert?: GraphQLTypes["IngredientSupplierItemUpsertSupplierRelationInput"] | undefined,
	connect?: GraphQLTypes["IngredientSupplierUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["IngredientSupplierUpdateInput"]: {
		internalName?: string | undefined,
	internalNote?: string | undefined,
	locales?: Array<GraphQLTypes["IngredientSupplierUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["IngredientSupplierUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["IngredientSupplierLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["IngredientSupplierUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["IngredientSupplierUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["IngredientSupplierLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["IngredientSupplierLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["IngredientSupplierLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["IngredientSupplierUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["IngredientSupplierLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["IngredientSupplierLocaleWithoutRootUpdateInput"] | undefined
};
	["IngredientSupplierLocaleWithoutRootUpdateInput"]: {
		name?: string | undefined,
	locale?: GraphQLTypes["IngredientSupplierLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["IngredientSupplierLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutIngredientSuppliersCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutIngredientSuppliersUpdateInput"] | undefined,
	upsert?: GraphQLTypes["IngredientSupplierLocaleUpsertLocaleRelationInput"] | undefined,
	connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutIngredientSuppliersUpdateInput"]: {
		businessCategories?: Array<GraphQLTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["IngredientSupplierLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutIngredientSuppliersUpdateInput"] | undefined,
	create?: GraphQLTypes["LocaleWithoutIngredientSuppliersCreateInput"] | undefined
};
	["IngredientSupplierUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["IngredientSupplierLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["IngredientSupplierLocaleWithoutRootUpdateInput"] | undefined,
	create?: GraphQLTypes["IngredientSupplierLocaleWithoutRootCreateInput"] | undefined
};
	["IngredientSupplierItemUpsertSupplierRelationInput"]: {
		update?: GraphQLTypes["IngredientSupplierUpdateInput"] | undefined,
	create?: GraphQLTypes["IngredientSupplierCreateInput"] | undefined
};
	["IngredientSupplierListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["IngredientSupplierItemUniqueWhere"] | undefined,
	update?: GraphQLTypes["IngredientSupplierItemWithoutListUpdateInput"] | undefined,
	create?: GraphQLTypes["IngredientSupplierItemWithoutListCreateInput"] | undefined
};
	["ProductIngredientUpsertSuppliersRelationInput"]: {
		update?: GraphQLTypes["IngredientSupplierListUpdateInput"] | undefined,
	create?: GraphQLTypes["IngredientSupplierListCreateInput"] | undefined
};
	["AllergenUpsertIngredientsRelationInput"]: {
		by?: GraphQLTypes["ProductIngredientUniqueWhere"] | undefined,
	update?: GraphQLTypes["ProductIngredientWithoutAllergensUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductIngredientWithoutAllergensCreateInput"] | undefined
};
	["AllergenLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["AllergenWithoutLocalesUpdateInput"] | undefined,
	create?: GraphQLTypes["AllergenWithoutLocalesCreateInput"] | undefined
};
	["LocaleUpsertAllergensRelationInput"]: {
		by?: GraphQLTypes["AllergenLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["AllergenLocaleWithoutLocaleUpdateInput"] | undefined,
	create?: GraphQLTypes["AllergenLocaleWithoutLocaleCreateInput"] | undefined
};
	["OrderRecurrenceLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutOrderRecurrencesUpdateInput"] | undefined,
	create?: GraphQLTypes["LocaleWithoutOrderRecurrencesCreateInput"] | undefined
};
	["OrderRecurrenceUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["OrderRecurrenceLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["OrderRecurrenceLocaleWithoutRootUpdateInput"] | undefined,
	create?: GraphQLTypes["OrderRecurrenceLocaleWithoutRootCreateInput"] | undefined
};
	["BusinessCategoryUpsertRecurrencesRelationInput"]: {
		by?: GraphQLTypes["OrderRecurrenceUniqueWhere"] | undefined,
	update?: GraphQLTypes["OrderRecurrenceWithoutBusinessCategoryUpdateInput"] | undefined,
	create?: GraphQLTypes["OrderRecurrenceWithoutBusinessCategoryCreateInput"] | undefined
};
	["BusinessCategoryUpdateSpecificProductsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductListWithoutBusinessCategoryCreateInput"] | undefined,
	update?: GraphQLTypes["ProductListWithoutBusinessCategoryUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BusinessCategoryUpsertSpecificProductsRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductListUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProductListWithoutBusinessCategoryUpdateInput"]: {
		items?: Array<GraphQLTypes["ProductListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductListItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["ProductListUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["ProductListUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductListItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductListItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductListItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["ProductListItemUniqueWhere"] | undefined,
	data?: GraphQLTypes["ProductListItemWithoutListUpdateInput"] | undefined
};
	["ProductListItemWithoutListUpdateInput"]: {
		order?: number | undefined,
	product?: GraphQLTypes["ProductListItemUpdateProductEntityRelationInput"] | undefined,
	defaultQuantityForOrder?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductListItemUpdateProductEntityRelationInput"]: {
		create?: GraphQLTypes["ProductCreateInput"] | undefined,
	update?: GraphQLTypes["ProductUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductListItemUpsertProductRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProductListItemUpsertProductRelationInput"]: {
		update?: GraphQLTypes["ProductUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductCreateInput"] | undefined
};
	["ProductListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["ProductListItemUniqueWhere"] | undefined,
	update?: GraphQLTypes["ProductListItemWithoutListUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductListItemWithoutListCreateInput"] | undefined
};
	["BusinessCategoryUpsertSpecificProductsRelationInput"]: {
		update?: GraphQLTypes["ProductListWithoutBusinessCategoryUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductListWithoutBusinessCategoryCreateInput"] | undefined
};
	["BusinessCategoryUpdateSeasonalProductCategoriesEntityRelationInput"]: {
		create?: GraphQLTypes["ProductCategoryListWithoutSeasonalProductCategoriesOfBusinessCategoryCreateInput"] | undefined,
	update?: GraphQLTypes["ProductCategoryListWithoutSeasonalProductCategoriesOfBusinessCategoryUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BusinessCategoryUpsertSeasonalProductCategoriesRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductCategoryListUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProductCategoryListWithoutSeasonalProductCategoriesOfBusinessCategoryUpdateInput"]: {
		items?: Array<GraphQLTypes["ProductCategoryListUpdateItemsEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["ProductCategoryListUpdateLocalesEntityRelationInput"]> | undefined,
	specificProductsProductCategoriesOfBusinessCategory?: GraphQLTypes["ProductCategoryListUpdateSpecificProductsProductCategoriesOfBusinessCategoryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCategoryListUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["ProductCategoryListLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["ProductCategoryListUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["ProductCategoryListUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductCategoryListLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductCategoryListLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductCategoryListLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductCategoryListUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["ProductCategoryListLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["ProductCategoryListLocaleWithoutRootUpdateInput"] | undefined
};
	["ProductCategoryListLocaleWithoutRootUpdateInput"]: {
		name?: string | undefined,
	locale?: GraphQLTypes["ProductCategoryListLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCategoryListLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutProductCategoryListsCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutProductCategoryListsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductCategoryListLocaleUpsertLocaleRelationInput"] | undefined,
	connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutProductCategoryListsUpdateInput"]: {
		businessCategories?: Array<GraphQLTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCategoryListLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutProductCategoryListsUpdateInput"] | undefined,
	create?: GraphQLTypes["LocaleWithoutProductCategoryListsCreateInput"] | undefined
};
	["ProductCategoryListUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["ProductCategoryListLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["ProductCategoryListLocaleWithoutRootUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductCategoryListLocaleWithoutRootCreateInput"] | undefined
};
	["ProductCategoryListUpdateSpecificProductsProductCategoriesOfBusinessCategoryEntityRelationInput"]: {
		create?: GraphQLTypes["BusinessCategoryWithoutSpecificProductsProductCategoriesCreateInput"] | undefined,
	update?: GraphQLTypes["BusinessCategoryWithoutSpecificProductsProductCategoriesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductCategoryListUpsertSpecificProductsProductCategoriesOfBusinessCategoryRelationInput"] | undefined,
	connect?: GraphQLTypes["BusinessCategoryUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["BusinessCategoryWithoutSpecificProductsProductCategoriesUpdateInput"]: {
		order?: number | undefined,
	visibleToNewCustomers?: boolean | undefined,
	locales?: Array<GraphQLTypes["BusinessCategoryUpdateLocalesEntityRelationInput"]> | undefined,
	internalName?: string | undefined,
	businessCustomers?: Array<GraphQLTypes["BusinessCategoryUpdateBusinessCustomersEntityRelationInput"]> | undefined,
	recurrences?: Array<GraphQLTypes["BusinessCategoryUpdateRecurrencesEntityRelationInput"]> | undefined,
	specificProducts?: GraphQLTypes["BusinessCategoryUpdateSpecificProductsEntityRelationInput"] | undefined,
	seasonalProductCategories?: GraphQLTypes["BusinessCategoryUpdateSeasonalProductCategoriesEntityRelationInput"] | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCategoryListUpsertSpecificProductsProductCategoriesOfBusinessCategoryRelationInput"]: {
		update?: GraphQLTypes["BusinessCategoryWithoutSpecificProductsProductCategoriesUpdateInput"] | undefined,
	create?: GraphQLTypes["BusinessCategoryWithoutSpecificProductsProductCategoriesCreateInput"] | undefined
};
	["BusinessCategoryUpsertSeasonalProductCategoriesRelationInput"]: {
		update?: GraphQLTypes["ProductCategoryListWithoutSeasonalProductCategoriesOfBusinessCategoryUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductCategoryListWithoutSeasonalProductCategoriesOfBusinessCategoryCreateInput"] | undefined
};
	["BusinessCategoryUpdateSpecificProductsProductCategoriesEntityRelationInput"]: {
		create?: GraphQLTypes["ProductCategoryListWithoutSpecificProductsProductCategoriesOfBusinessCategoryCreateInput"] | undefined,
	update?: GraphQLTypes["ProductCategoryListWithoutSpecificProductsProductCategoriesOfBusinessCategoryUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BusinessCategoryUpsertSpecificProductsProductCategoriesRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductCategoryListUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProductCategoryListWithoutSpecificProductsProductCategoriesOfBusinessCategoryUpdateInput"]: {
		items?: Array<GraphQLTypes["ProductCategoryListUpdateItemsEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["ProductCategoryListUpdateLocalesEntityRelationInput"]> | undefined,
	seasonalProductCategoriesOfBusinessCategory?: GraphQLTypes["ProductCategoryListUpdateSeasonalProductCategoriesOfBusinessCategoryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCategoryListUpdateSeasonalProductCategoriesOfBusinessCategoryEntityRelationInput"]: {
		create?: GraphQLTypes["BusinessCategoryWithoutSeasonalProductCategoriesCreateInput"] | undefined,
	update?: GraphQLTypes["BusinessCategoryWithoutSeasonalProductCategoriesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductCategoryListUpsertSeasonalProductCategoriesOfBusinessCategoryRelationInput"] | undefined,
	connect?: GraphQLTypes["BusinessCategoryUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["BusinessCategoryWithoutSeasonalProductCategoriesUpdateInput"]: {
		order?: number | undefined,
	visibleToNewCustomers?: boolean | undefined,
	locales?: Array<GraphQLTypes["BusinessCategoryUpdateLocalesEntityRelationInput"]> | undefined,
	internalName?: string | undefined,
	businessCustomers?: Array<GraphQLTypes["BusinessCategoryUpdateBusinessCustomersEntityRelationInput"]> | undefined,
	recurrences?: Array<GraphQLTypes["BusinessCategoryUpdateRecurrencesEntityRelationInput"]> | undefined,
	specificProducts?: GraphQLTypes["BusinessCategoryUpdateSpecificProductsEntityRelationInput"] | undefined,
	specificProductsProductCategories?: GraphQLTypes["BusinessCategoryUpdateSpecificProductsProductCategoriesEntityRelationInput"] | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCategoryListUpsertSeasonalProductCategoriesOfBusinessCategoryRelationInput"]: {
		update?: GraphQLTypes["BusinessCategoryWithoutSeasonalProductCategoriesUpdateInput"] | undefined,
	create?: GraphQLTypes["BusinessCategoryWithoutSeasonalProductCategoriesCreateInput"] | undefined
};
	["BusinessCategoryUpsertSpecificProductsProductCategoriesRelationInput"]: {
		update?: GraphQLTypes["ProductCategoryListWithoutSpecificProductsProductCategoriesOfBusinessCategoryUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductCategoryListWithoutSpecificProductsProductCategoriesOfBusinessCategoryCreateInput"] | undefined
};
	["BusinessCustomerUpsertCategoryRelationInput"]: {
		update?: GraphQLTypes["BusinessCategoryWithoutBusinessCustomersUpdateInput"] | undefined,
	create?: GraphQLTypes["BusinessCategoryWithoutBusinessCustomersCreateInput"] | undefined
};
	["CustomerUpsertMemberOfBusinessesRelationInput"]: {
		by?: GraphQLTypes["BusinessCustomerUniqueWhere"] | undefined,
	update?: GraphQLTypes["BusinessCustomerWithoutMembersUpdateInput"] | undefined,
	create?: GraphQLTypes["BusinessCustomerWithoutMembersCreateInput"] | undefined
};
	["BusinessCustomerUpsertOwnersRelationInput"]: {
		by?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	update?: GraphQLTypes["CustomerWithoutOwnerOfBusinessesUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerWithoutOwnerOfBusinessesCreateInput"] | undefined
};
	["CustomerUpsertBusinessRelationInput"]: {
		update?: GraphQLTypes["BusinessCustomerWithoutCustomerUpdateInput"] | undefined,
	create?: GraphQLTypes["BusinessCustomerWithoutCustomerCreateInput"] | undefined
};
	["CustomerIngredientRatingUpsertCustomerRelationInput"]: {
		update?: GraphQLTypes["CustomerWithoutIngredientRatingsUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerWithoutIngredientRatingsCreateInput"] | undefined
};
	["ProductIngredientUpsertCustomerRatingsRelationInput"]: {
		by?: GraphQLTypes["CustomerIngredientRatingUniqueWhere"] | undefined,
	update?: GraphQLTypes["CustomerIngredientRatingWithoutIngredientUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerIngredientRatingWithoutIngredientCreateInput"] | undefined
};
	["ProductIngredientCategoryUpsertIngredientsRelationInput"]: {
		by?: GraphQLTypes["ProductIngredientUniqueWhere"] | undefined,
	update?: GraphQLTypes["ProductIngredientWithoutCategoriesUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductIngredientWithoutCategoriesCreateInput"] | undefined
};
	["ProductIngredientCategoryLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["ProductIngredientCategoryWithoutLocalesUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductIngredientCategoryWithoutLocalesCreateInput"] | undefined
};
	["LocaleUpsertProductIngredientCategoriesRelationInput"]: {
		by?: GraphQLTypes["ProductIngredientCategoryLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["ProductIngredientCategoryLocaleWithoutLocaleUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductIngredientCategoryLocaleWithoutLocaleCreateInput"] | undefined
};
	["PageLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutPagesUpdateInput"] | undefined,
	create?: GraphQLTypes["LocaleWithoutPagesCreateInput"] | undefined
};
	["LinkableUpsertPageRelationInput"]: {
		update?: GraphQLTypes["PageLocaleWithoutLinkUpdateInput"] | undefined,
	create?: GraphQLTypes["PageLocaleWithoutLinkCreateInput"] | undefined
};
	["LinkableUpdateRedirectEntityRelationInput"]: {
		create?: GraphQLTypes["RedirectWithoutLinkCreateInput"] | undefined,
	update?: GraphQLTypes["RedirectWithoutLinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["LinkableUpsertRedirectRelationInput"] | undefined,
	connect?: GraphQLTypes["RedirectUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["RedirectWithoutLinkUpdateInput"]: {
		target?: GraphQLTypes["RedirectUpdateTargetEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RedirectUpdateTargetEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"] | undefined,
	update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["RedirectUpsertTargetRelationInput"] | undefined,
	connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["RedirectUpsertTargetRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined
};
	["LinkableUpsertRedirectRelationInput"]: {
		update?: GraphQLTypes["RedirectWithoutLinkUpdateInput"] | undefined,
	create?: GraphQLTypes["RedirectWithoutLinkCreateInput"] | undefined
};
	["WikiPageUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutWikiPageUpdateInput"] | undefined,
	create?: GraphQLTypes["LinkableWithoutWikiPageCreateInput"] | undefined
};
	["WikiPageUpdateContentEntityRelationInput"]: {
		create?: GraphQLTypes["ContentCreateInput"] | undefined,
	update?: GraphQLTypes["ContentUpdateInput"] | undefined,
	upsert?: GraphQLTypes["WikiPageUpsertContentRelationInput"] | undefined,
	connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["WikiPageUpsertContentRelationInput"]: {
		update?: GraphQLTypes["ContentUpdateInput"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined
};
	["WikiPageUpsertParentRelationInput"]: {
		update?: GraphQLTypes["WikiPageWithoutChildrenUpdateInput"] | undefined,
	create?: GraphQLTypes["WikiPageWithoutChildrenCreateInput"] | undefined
};
	["WikiPageUpdateChildrenEntityRelationInput"]: {
		create?: GraphQLTypes["WikiPageWithoutParentCreateInput"] | undefined,
	update?: GraphQLTypes["WikiPageUpdateChildrenRelationInput"] | undefined,
	upsert?: GraphQLTypes["WikiPageUpsertChildrenRelationInput"] | undefined,
	connect?: GraphQLTypes["WikiPageUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["WikiPageUniqueWhere"] | undefined,
	delete?: GraphQLTypes["WikiPageUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["WikiPageUpdateChildrenRelationInput"]: {
		by?: GraphQLTypes["WikiPageUniqueWhere"] | undefined,
	data?: GraphQLTypes["WikiPageWithoutParentUpdateInput"] | undefined
};
	["WikiPageWithoutParentUpdateInput"]: {
		order?: number | undefined,
	title?: string | undefined,
	emoji?: string | undefined,
	link?: GraphQLTypes["WikiPageUpdateLinkEntityRelationInput"] | undefined,
	children?: Array<GraphQLTypes["WikiPageUpdateChildrenEntityRelationInput"]> | undefined,
	content?: GraphQLTypes["WikiPageUpdateContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["WikiPageUpsertChildrenRelationInput"]: {
		by?: GraphQLTypes["WikiPageUniqueWhere"] | undefined,
	update?: GraphQLTypes["WikiPageWithoutParentUpdateInput"] | undefined,
	create?: GraphQLTypes["WikiPageWithoutParentCreateInput"] | undefined
};
	["LinkableUpsertWikiPageRelationInput"]: {
		update?: GraphQLTypes["WikiPageWithoutLinkUpdateInput"] | undefined,
	create?: GraphQLTypes["WikiPageWithoutLinkCreateInput"] | undefined
};
	["PageLocaleUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutPageUpdateInput"] | undefined,
	create?: GraphQLTypes["LinkableWithoutPageCreateInput"] | undefined
};
	["LocaleUpsertPagesRelationInput"]: {
		by?: GraphQLTypes["PageLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["PageLocaleWithoutLocaleUpdateInput"] | undefined,
	create?: GraphQLTypes["PageLocaleWithoutLocaleCreateInput"] | undefined
};
	["BlogPostLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutBlogPostsUpdateInput"] | undefined,
	create?: GraphQLTypes["LocaleWithoutBlogPostsCreateInput"] | undefined
};
	["BlogPostLocaleUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"] | undefined,
	update?: GraphQLTypes["SeoUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BlogPostLocaleUpsertSeoRelationInput"] | undefined,
	connect?: GraphQLTypes["SeoUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["BlogPostLocaleUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"] | undefined,
	create?: GraphQLTypes["SeoCreateInput"] | undefined
};
	["BlogPostLocaleUpdateProductsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductCreateInput"] | undefined,
	update?: GraphQLTypes["BlogPostLocaleUpdateProductsRelationInput"] | undefined,
	upsert?: GraphQLTypes["BlogPostLocaleUpsertProductsRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["BlogPostLocaleUpdateProductsRelationInput"]: {
		by?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	data?: GraphQLTypes["ProductUpdateInput"] | undefined
};
	["BlogPostLocaleUpsertProductsRelationInput"]: {
		by?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	update?: GraphQLTypes["ProductUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductCreateInput"] | undefined
};
	["LinkableUpsertBlogPostRelationInput"]: {
		update?: GraphQLTypes["BlogPostLocaleWithoutLinkUpdateInput"] | undefined,
	create?: GraphQLTypes["BlogPostLocaleWithoutLinkCreateInput"] | undefined
};
	["LinkUpsertInternalLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableUpdateInput"] | undefined,
	create?: GraphQLTypes["LinkableCreateInput"] | undefined
};
	["ContentReferenceUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined
};
	["ContentReferenceUpdateBlogPostsEntityRelationInput"]: {
		create?: GraphQLTypes["BlogPostListCreateInput"] | undefined,
	update?: GraphQLTypes["BlogPostListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertBlogPostsRelationInput"] | undefined,
	connect?: GraphQLTypes["BlogPostListUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["BlogPostListUpdateInput"]: {
		items?: Array<GraphQLTypes["BlogPostListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["BlogPostListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["BlogPostListItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["BlogPostListUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["BlogPostListUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["BlogPostListItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["BlogPostListItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["BlogPostListItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["BlogPostListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["BlogPostListItemUniqueWhere"] | undefined,
	data?: GraphQLTypes["BlogPostListItemWithoutListUpdateInput"] | undefined
};
	["BlogPostListItemWithoutListUpdateInput"]: {
		order?: number | undefined,
	caption?: string | undefined,
	blogPost?: GraphQLTypes["BlogPostListItemUpdateBlogPostEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BlogPostListItemUpdateBlogPostEntityRelationInput"]: {
		create?: GraphQLTypes["BlogPostLocaleCreateInput"] | undefined,
	update?: GraphQLTypes["BlogPostLocaleUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BlogPostListItemUpsertBlogPostRelationInput"] | undefined,
	connect?: GraphQLTypes["BlogPostLocaleUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["BlogPostLocaleUpdateInput"]: {
		title?: string | undefined,
	availableForWeb?: boolean | undefined,
	availableForMobile?: boolean | undefined,
	root?: GraphQLTypes["BlogPostLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["BlogPostLocaleUpdateLocaleEntityRelationInput"] | undefined,
	cover?: GraphQLTypes["BlogPostLocaleUpdateCoverEntityRelationInput"] | undefined,
	content?: GraphQLTypes["BlogPostLocaleUpdateContentEntityRelationInput"] | undefined,
	link?: GraphQLTypes["BlogPostLocaleUpdateLinkEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["BlogPostLocaleUpdateSeoEntityRelationInput"] | undefined,
	products?: Array<GraphQLTypes["BlogPostLocaleUpdateProductsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["BlogPostLocaleUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutBlogPostCreateInput"] | undefined,
	update?: GraphQLTypes["LinkableWithoutBlogPostUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BlogPostLocaleUpsertLinkRelationInput"] | undefined,
	connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkableWithoutBlogPostUpdateInput"]: {
		url?: string | undefined,
	page?: GraphQLTypes["LinkableUpdatePageEntityRelationInput"] | undefined,
	wikiPage?: GraphQLTypes["LinkableUpdateWikiPageEntityRelationInput"] | undefined,
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BlogPostLocaleUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutBlogPostUpdateInput"] | undefined,
	create?: GraphQLTypes["LinkableWithoutBlogPostCreateInput"] | undefined
};
	["BlogPostListItemUpsertBlogPostRelationInput"]: {
		update?: GraphQLTypes["BlogPostLocaleUpdateInput"] | undefined,
	create?: GraphQLTypes["BlogPostLocaleCreateInput"] | undefined
};
	["BlogPostListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["BlogPostListItemUniqueWhere"] | undefined,
	update?: GraphQLTypes["BlogPostListItemWithoutListUpdateInput"] | undefined,
	create?: GraphQLTypes["BlogPostListItemWithoutListCreateInput"] | undefined
};
	["ContentReferenceUpsertBlogPostsRelationInput"]: {
		update?: GraphQLTypes["BlogPostListUpdateInput"] | undefined,
	create?: GraphQLTypes["BlogPostListCreateInput"] | undefined
};
	["ContentReferenceUpdateLinksEntityRelationInput"]: {
		create?: GraphQLTypes["LinkListCreateInput"] | undefined,
	update?: GraphQLTypes["LinkListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertLinksRelationInput"] | undefined,
	connect?: GraphQLTypes["LinkListUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ContentReferenceUpsertLinksRelationInput"]: {
		update?: GraphQLTypes["LinkListUpdateInput"] | undefined,
	create?: GraphQLTypes["LinkListCreateInput"] | undefined
};
	["ContentReferenceUpdateProductsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductListCreateInput"] | undefined,
	update?: GraphQLTypes["ProductListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertProductsRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductListUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProductListUpdateInput"]: {
		items?: Array<GraphQLTypes["ProductListUpdateItemsEntityRelationInput"]> | undefined,
	businessCategory?: GraphQLTypes["ProductListUpdateBusinessCategoryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductListUpdateBusinessCategoryEntityRelationInput"]: {
		create?: GraphQLTypes["BusinessCategoryWithoutSpecificProductsCreateInput"] | undefined,
	update?: GraphQLTypes["BusinessCategoryWithoutSpecificProductsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductListUpsertBusinessCategoryRelationInput"] | undefined,
	connect?: GraphQLTypes["BusinessCategoryUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["BusinessCategoryWithoutSpecificProductsUpdateInput"]: {
		order?: number | undefined,
	visibleToNewCustomers?: boolean | undefined,
	locales?: Array<GraphQLTypes["BusinessCategoryUpdateLocalesEntityRelationInput"]> | undefined,
	internalName?: string | undefined,
	businessCustomers?: Array<GraphQLTypes["BusinessCategoryUpdateBusinessCustomersEntityRelationInput"]> | undefined,
	recurrences?: Array<GraphQLTypes["BusinessCategoryUpdateRecurrencesEntityRelationInput"]> | undefined,
	seasonalProductCategories?: GraphQLTypes["BusinessCategoryUpdateSeasonalProductCategoriesEntityRelationInput"] | undefined,
	specificProductsProductCategories?: GraphQLTypes["BusinessCategoryUpdateSpecificProductsProductCategoriesEntityRelationInput"] | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductListUpsertBusinessCategoryRelationInput"]: {
		update?: GraphQLTypes["BusinessCategoryWithoutSpecificProductsUpdateInput"] | undefined,
	create?: GraphQLTypes["BusinessCategoryWithoutSpecificProductsCreateInput"] | undefined
};
	["ContentReferenceUpsertProductsRelationInput"]: {
		update?: GraphQLTypes["ProductListUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductListCreateInput"] | undefined
};
	["ContentReferenceUpdateHeroEntityRelationInput"]: {
		create?: GraphQLTypes["HeroCreateInput"] | undefined,
	update?: GraphQLTypes["HeroUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertHeroRelationInput"] | undefined,
	connect?: GraphQLTypes["HeroUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HeroUpdateInput"]: {
		showLogo?: boolean | undefined,
	middleContent?: string | undefined,
	medium?: GraphQLTypes["HeroUpdateMediumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["HeroUpdateMediumEntityRelationInput"]: {
		create?: GraphQLTypes["MediumCreateInput"] | undefined,
	update?: GraphQLTypes["MediumUpdateInput"] | undefined,
	upsert?: GraphQLTypes["HeroUpsertMediumRelationInput"] | undefined,
	connect?: GraphQLTypes["MediumUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["HeroUpsertMediumRelationInput"]: {
		update?: GraphQLTypes["MediumUpdateInput"] | undefined,
	create?: GraphQLTypes["MediumCreateInput"] | undefined
};
	["ContentReferenceUpsertHeroRelationInput"]: {
		update?: GraphQLTypes["HeroUpdateInput"] | undefined,
	create?: GraphQLTypes["HeroCreateInput"] | undefined
};
	["ContentReferenceUpdateGalleryEntityRelationInput"]: {
		create?: GraphQLTypes["GalleryCreateInput"] | undefined,
	update?: GraphQLTypes["GalleryUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertGalleryRelationInput"] | undefined,
	connect?: GraphQLTypes["GalleryUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GalleryUpdateInput"]: {
		items?: Array<GraphQLTypes["GalleryUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GalleryUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["GalleryItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["GalleryUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["GalleryUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["GalleryItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["GalleryItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["GalleryItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["GalleryUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["GalleryItemUniqueWhere"] | undefined,
	data?: GraphQLTypes["GalleryItemWithoutListUpdateInput"] | undefined
};
	["GalleryItemWithoutListUpdateInput"]: {
		order?: number | undefined,
	caption?: string | undefined,
	medium?: GraphQLTypes["GalleryItemUpdateMediumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GalleryItemUpdateMediumEntityRelationInput"]: {
		create?: GraphQLTypes["MediumCreateInput"] | undefined,
	update?: GraphQLTypes["MediumUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GalleryItemUpsertMediumRelationInput"] | undefined,
	connect?: GraphQLTypes["MediumUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GalleryItemUpsertMediumRelationInput"]: {
		update?: GraphQLTypes["MediumUpdateInput"] | undefined,
	create?: GraphQLTypes["MediumCreateInput"] | undefined
};
	["GalleryUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["GalleryItemUniqueWhere"] | undefined,
	update?: GraphQLTypes["GalleryItemWithoutListUpdateInput"] | undefined,
	create?: GraphQLTypes["GalleryItemWithoutListCreateInput"] | undefined
};
	["ContentReferenceUpsertGalleryRelationInput"]: {
		update?: GraphQLTypes["GalleryUpdateInput"] | undefined,
	create?: GraphQLTypes["GalleryCreateInput"] | undefined
};
	["ContentReferenceUpdateSocialsAndAppsEntityRelationInput"]: {
		create?: GraphQLTypes["SocialsAndAppsCreateInput"] | undefined,
	update?: GraphQLTypes["SocialsAndAppsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertSocialsAndAppsRelationInput"] | undefined,
	connect?: GraphQLTypes["SocialsAndAppsUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ContentReferenceUpsertSocialsAndAppsRelationInput"]: {
		update?: GraphQLTypes["SocialsAndAppsUpdateInput"] | undefined,
	create?: GraphQLTypes["SocialsAndAppsCreateInput"] | undefined
};
	["ContentReferenceUpdateProductGridEntityRelationInput"]: {
		create?: GraphQLTypes["ProductGridCreateInput"] | undefined,
	update?: GraphQLTypes["ProductGridUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertProductGridRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductGridUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProductGridUpdateInput"]: {
		isCarousel?: boolean | undefined,
	categories?: Array<GraphQLTypes["ProductGridUpdateCategoriesEntityRelationInput"]> | undefined,
	type?: GraphQLTypes["ProductGridType"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductGridUpdateCategoriesEntityRelationInput"]: {
		create?: GraphQLTypes["ProductGridCategoryWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["ProductGridUpdateCategoriesRelationInput"] | undefined,
	upsert?: GraphQLTypes["ProductGridUpsertCategoriesRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductGridCategoryUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductGridCategoryUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductGridCategoryUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductGridUpdateCategoriesRelationInput"]: {
		by?: GraphQLTypes["ProductGridCategoryUniqueWhere"] | undefined,
	data?: GraphQLTypes["ProductGridCategoryWithoutRootUpdateInput"] | undefined
};
	["ProductGridCategoryWithoutRootUpdateInput"]: {
		order?: number | undefined,
	title?: string | undefined,
	items?: Array<GraphQLTypes["ProductGridCategoryUpdateItemsEntityRelationInput"]> | undefined,
	images?: GraphQLTypes["ProductGridCategoryUpdateImagesEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductGridCategoryUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductGridItemWithoutCategoryCreateInput"] | undefined,
	update?: GraphQLTypes["ProductGridCategoryUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["ProductGridCategoryUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductGridItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductGridItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductGridItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductGridCategoryUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["ProductGridItemUniqueWhere"] | undefined,
	data?: GraphQLTypes["ProductGridItemWithoutCategoryUpdateInput"] | undefined
};
	["ProductGridItemWithoutCategoryUpdateInput"]: {
		order?: number | undefined,
	title?: string | undefined,
	lead?: string | undefined,
	product?: GraphQLTypes["ProductGridItemUpdateProductEntityRelationInput"] | undefined,
	medium?: GraphQLTypes["ProductGridItemUpdateMediumEntityRelationInput"] | undefined,
	link?: GraphQLTypes["ProductGridItemUpdateLinkEntityRelationInput"] | undefined,
	description?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductGridItemUpdateProductEntityRelationInput"]: {
		create?: GraphQLTypes["ProductCreateInput"] | undefined,
	update?: GraphQLTypes["ProductUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductGridItemUpsertProductRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProductGridItemUpsertProductRelationInput"]: {
		update?: GraphQLTypes["ProductUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductCreateInput"] | undefined
};
	["ProductGridItemUpdateMediumEntityRelationInput"]: {
		create?: GraphQLTypes["MediumCreateInput"] | undefined,
	update?: GraphQLTypes["MediumUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductGridItemUpsertMediumRelationInput"] | undefined,
	connect?: GraphQLTypes["MediumUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProductGridItemUpsertMediumRelationInput"]: {
		update?: GraphQLTypes["MediumUpdateInput"] | undefined,
	create?: GraphQLTypes["MediumCreateInput"] | undefined
};
	["ProductGridItemUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"] | undefined,
	update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductGridItemUpsertLinkRelationInput"] | undefined,
	connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProductGridItemUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined
};
	["ProductGridCategoryUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["ProductGridItemUniqueWhere"] | undefined,
	update?: GraphQLTypes["ProductGridItemWithoutCategoryUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductGridItemWithoutCategoryCreateInput"] | undefined
};
	["ProductGridCategoryUpdateImagesEntityRelationInput"]: {
		create?: GraphQLTypes["ImageListCreateInput"] | undefined,
	update?: GraphQLTypes["ImageListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductGridCategoryUpsertImagesRelationInput"] | undefined,
	connect?: GraphQLTypes["ImageListUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProductGridCategoryUpsertImagesRelationInput"]: {
		update?: GraphQLTypes["ImageListUpdateInput"] | undefined,
	create?: GraphQLTypes["ImageListCreateInput"] | undefined
};
	["ProductGridUpsertCategoriesRelationInput"]: {
		by?: GraphQLTypes["ProductGridCategoryUniqueWhere"] | undefined,
	update?: GraphQLTypes["ProductGridCategoryWithoutRootUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductGridCategoryWithoutRootCreateInput"] | undefined
};
	["ContentReferenceUpsertProductGridRelationInput"]: {
		update?: GraphQLTypes["ProductGridUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductGridCreateInput"] | undefined
};
	["ContentReferenceUpdateProductBannersEntityRelationInput"]: {
		create?: GraphQLTypes["ProductBannerListCreateInput"] | undefined,
	update?: GraphQLTypes["ProductBannerListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertProductBannersRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductBannerListUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProductBannerListUpdateInput"]: {
		items?: Array<GraphQLTypes["ProductBannerListUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductBannerListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductBannerItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["ProductBannerListUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["ProductBannerListUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductBannerItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ProductBannerItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ProductBannerItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ProductBannerListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["ProductBannerItemUniqueWhere"] | undefined,
	data?: GraphQLTypes["ProductBannerItemWithoutListUpdateInput"] | undefined
};
	["ProductBannerItemWithoutListUpdateInput"]: {
		order?: number | undefined,
	banner?: GraphQLTypes["ProductBannerItemUpdateBannerEntityRelationInput"] | undefined,
	size?: GraphQLTypes["ProductBannerItemSize"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductBannerItemUpdateBannerEntityRelationInput"]: {
		create?: GraphQLTypes["ProductBannerCreateInput"] | undefined,
	update?: GraphQLTypes["ProductBannerUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductBannerItemUpsertBannerRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductBannerUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProductBannerUpdateInput"]: {
		beforeTitle?: string | undefined,
	title?: string | undefined,
	label?: string | undefined,
	button?: GraphQLTypes["ProductBannerUpdateButtonEntityRelationInput"] | undefined,
	backgroundImage?: GraphQLTypes["ProductBannerUpdateBackgroundImageEntityRelationInput"] | undefined,
	productImage?: GraphQLTypes["ProductBannerUpdateProductImageEntityRelationInput"] | undefined,
	product?: GraphQLTypes["ProductBannerUpdateProductEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductBannerUpdateButtonEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"] | undefined,
	update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductBannerUpsertButtonRelationInput"] | undefined,
	connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProductBannerUpsertButtonRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined
};
	["ProductBannerUpdateBackgroundImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductBannerUpsertBackgroundImageRelationInput"] | undefined,
	connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProductBannerUpsertBackgroundImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["ProductBannerUpdateProductImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductBannerUpsertProductImageRelationInput"] | undefined,
	connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProductBannerUpsertProductImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["ProductBannerUpdateProductEntityRelationInput"]: {
		create?: GraphQLTypes["ProductCreateInput"] | undefined,
	update?: GraphQLTypes["ProductUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductBannerUpsertProductRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProductBannerUpsertProductRelationInput"]: {
		update?: GraphQLTypes["ProductUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductCreateInput"] | undefined
};
	["ProductBannerItemUpsertBannerRelationInput"]: {
		update?: GraphQLTypes["ProductBannerUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductBannerCreateInput"] | undefined
};
	["ProductBannerListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["ProductBannerItemUniqueWhere"] | undefined,
	update?: GraphQLTypes["ProductBannerItemWithoutListUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductBannerItemWithoutListCreateInput"] | undefined
};
	["ContentReferenceUpsertProductBannersRelationInput"]: {
		update?: GraphQLTypes["ProductBannerListUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductBannerListCreateInput"] | undefined
};
	["ContentReferenceUpdateDeliveryRegionsEntityRelationInput"]: {
		create?: GraphQLTypes["DeliveryRegionsCreateInput"] | undefined,
	update?: GraphQLTypes["DeliveryRegionsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertDeliveryRegionsRelationInput"] | undefined,
	connect?: GraphQLTypes["DeliveryRegionsUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ContentReferenceUpsertDeliveryRegionsRelationInput"]: {
		update?: GraphQLTypes["DeliveryRegionsUpdateInput"] | undefined,
	create?: GraphQLTypes["DeliveryRegionsCreateInput"] | undefined
};
	["ContentReferenceUpdateTextListEntityRelationInput"]: {
		create?: GraphQLTypes["TextListCreateInput"] | undefined,
	update?: GraphQLTypes["TextListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertTextListRelationInput"] | undefined,
	connect?: GraphQLTypes["TextListUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ContentReferenceUpsertTextListRelationInput"]: {
		update?: GraphQLTypes["TextListUpdateInput"] | undefined,
	create?: GraphQLTypes["TextListCreateInput"] | undefined
};
	["ContentReferenceUpdateGridTilesEntityRelationInput"]: {
		create?: GraphQLTypes["GridTilesCreateInput"] | undefined,
	update?: GraphQLTypes["GridTilesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertGridTilesRelationInput"] | undefined,
	connect?: GraphQLTypes["GridTilesUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GridTilesUpdateInput"]: {
		items?: Array<GraphQLTypes["GridTilesUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GridTilesUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["GridTileItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["GridTilesUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["GridTilesUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["GridTileItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["GridTileItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["GridTileItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["GridTilesUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["GridTileItemUniqueWhere"] | undefined,
	data?: GraphQLTypes["GridTileItemWithoutListUpdateInput"] | undefined
};
	["GridTileItemWithoutListUpdateInput"]: {
		order?: number | undefined,
	text?: string | undefined,
	medium?: GraphQLTypes["GridTileItemUpdateMediumEntityRelationInput"] | undefined,
	link?: GraphQLTypes["GridTileItemUpdateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GridTileItemUpdateMediumEntityRelationInput"]: {
		create?: GraphQLTypes["MediumCreateInput"] | undefined,
	update?: GraphQLTypes["MediumUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GridTileItemUpsertMediumRelationInput"] | undefined,
	connect?: GraphQLTypes["MediumUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GridTileItemUpsertMediumRelationInput"]: {
		update?: GraphQLTypes["MediumUpdateInput"] | undefined,
	create?: GraphQLTypes["MediumCreateInput"] | undefined
};
	["GridTileItemUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"] | undefined,
	update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GridTileItemUpsertLinkRelationInput"] | undefined,
	connect?: GraphQLTypes["LinkUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["GridTileItemUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"] | undefined,
	create?: GraphQLTypes["LinkCreateInput"] | undefined
};
	["GridTilesUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["GridTileItemUniqueWhere"] | undefined,
	update?: GraphQLTypes["GridTileItemWithoutListUpdateInput"] | undefined,
	create?: GraphQLTypes["GridTileItemWithoutListCreateInput"] | undefined
};
	["ContentReferenceUpsertGridTilesRelationInput"]: {
		update?: GraphQLTypes["GridTilesUpdateInput"] | undefined,
	create?: GraphQLTypes["GridTilesCreateInput"] | undefined
};
	["ContentBlockUpsertReferencesRelationInput"]: {
		by?: GraphQLTypes["ContentReferenceUniqueWhere"] | undefined,
	update?: GraphQLTypes["ContentReferenceWithoutBlockUpdateInput"] | undefined,
	create?: GraphQLTypes["ContentReferenceWithoutBlockCreateInput"] | undefined
};
	["ContentUpsertBlocksRelationInput"]: {
		by?: GraphQLTypes["ContentBlockUniqueWhere"] | undefined,
	update?: GraphQLTypes["ContentBlockWithoutContentUpdateInput"] | undefined,
	create?: GraphQLTypes["ContentBlockWithoutContentCreateInput"] | undefined
};
	["BlogPostLocaleUpsertContentRelationInput"]: {
		update?: GraphQLTypes["ContentUpdateInput"] | undefined,
	create?: GraphQLTypes["ContentCreateInput"] | undefined
};
	["LocaleUpsertBlogPostsRelationInput"]: {
		by?: GraphQLTypes["BlogPostLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["BlogPostLocaleWithoutLocaleUpdateInput"] | undefined,
	create?: GraphQLTypes["BlogPostLocaleWithoutLocaleCreateInput"] | undefined
};
	["BusinessCategoryLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutBusinessCategoriesUpdateInput"] | undefined,
	create?: GraphQLTypes["LocaleWithoutBusinessCategoriesCreateInput"] | undefined
};
	["BusinessCategoryUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["BusinessCategoryLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["BusinessCategoryLocaleWithoutRootUpdateInput"] | undefined,
	create?: GraphQLTypes["BusinessCategoryLocaleWithoutRootCreateInput"] | undefined
};
	["OrderRecurrenceUpsertBusinessCategoryRelationInput"]: {
		by?: GraphQLTypes["BusinessCategoryUniqueWhere"] | undefined,
	update?: GraphQLTypes["BusinessCategoryWithoutRecurrencesUpdateInput"] | undefined,
	create?: GraphQLTypes["BusinessCategoryWithoutRecurrencesCreateInput"] | undefined
};
	["OrderRecurrenceLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["OrderRecurrenceWithoutLocalesUpdateInput"] | undefined,
	create?: GraphQLTypes["OrderRecurrenceWithoutLocalesCreateInput"] | undefined
};
	["LocaleUpsertOrderRecurrencesRelationInput"]: {
		by?: GraphQLTypes["OrderRecurrenceLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["OrderRecurrenceLocaleWithoutLocaleUpdateInput"] | undefined,
	create?: GraphQLTypes["OrderRecurrenceLocaleWithoutLocaleCreateInput"] | undefined
};
	["AllergenLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutAllergensUpdateInput"] | undefined,
	create?: GraphQLTypes["LocaleWithoutAllergensCreateInput"] | undefined
};
	["AllergenUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["AllergenLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["AllergenLocaleWithoutRootUpdateInput"] | undefined,
	create?: GraphQLTypes["AllergenLocaleWithoutRootCreateInput"] | undefined
};
	["ProductIngredientUpsertAllergensRelationInput"]: {
		by?: GraphQLTypes["AllergenUniqueWhere"] | undefined,
	update?: GraphQLTypes["AllergenWithoutIngredientsUpdateInput"] | undefined,
	create?: GraphQLTypes["AllergenWithoutIngredientsCreateInput"] | undefined
};
	["ProductIngredientLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["ProductIngredientWithoutLocalesUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductIngredientWithoutLocalesCreateInput"] | undefined
};
	["LocaleUpsertProductIngredientsRelationInput"]: {
		by?: GraphQLTypes["ProductIngredientLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["ProductIngredientLocaleWithoutLocaleUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductIngredientLocaleWithoutLocaleCreateInput"] | undefined
};
	["ProductIngredientCategoryLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutProductIngredientCategoriesUpdateInput"] | undefined,
	create?: GraphQLTypes["LocaleWithoutProductIngredientCategoriesCreateInput"] | undefined
};
	["ProductIngredientCategoryUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["ProductIngredientCategoryLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["ProductIngredientCategoryLocaleWithoutRootUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductIngredientCategoryLocaleWithoutRootCreateInput"] | undefined
};
	["ProductIngredientUpsertCategoriesRelationInput"]: {
		by?: GraphQLTypes["ProductIngredientCategoryUniqueWhere"] | undefined,
	update?: GraphQLTypes["ProductIngredientCategoryWithoutIngredientsUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductIngredientCategoryWithoutIngredientsCreateInput"] | undefined
};
	["CustomerIngredientRatingUpsertIngredientRelationInput"]: {
		update?: GraphQLTypes["ProductIngredientWithoutCustomerRatingsUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductIngredientWithoutCustomerRatingsCreateInput"] | undefined
};
	["CustomerUpsertIngredientRatingsRelationInput"]: {
		by?: GraphQLTypes["CustomerIngredientRatingUniqueWhere"] | undefined,
	update?: GraphQLTypes["CustomerIngredientRatingWithoutCustomerUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerIngredientRatingWithoutCustomerCreateInput"] | undefined
};
	["CustomerGroupUpsertCustomersRelationInput"]: {
		by?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	update?: GraphQLTypes["CustomerWithoutGroupUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerWithoutGroupCreateInput"] | undefined
};
	["ProductGroupPriceUpsertGroupRelationInput"]: {
		update?: GraphQLTypes["CustomerGroupWithoutProductPricesUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerGroupWithoutProductPricesCreateInput"] | undefined
};
	["ProductUpsertGroupPricesRelationInput"]: {
		by?: GraphQLTypes["ProductGroupPriceUniqueWhere"] | undefined,
	update?: GraphQLTypes["ProductGroupPriceWithoutProductUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductGroupPriceWithoutProductCreateInput"] | undefined
};
	["DeliveryZoneUpsertDeliveryZonesOfProductsRelationInput"]: {
		by?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	update?: GraphQLTypes["ProductWithoutDeliveryZonesUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductWithoutDeliveryZonesCreateInput"] | undefined
};
	["TagUpsertDeliveryZonesRelationInput"]: {
		by?: GraphQLTypes["DeliveryZoneUniqueWhere"] | undefined,
	update?: GraphQLTypes["DeliveryZoneWithoutDeliveryZonesOfTagsUpdateInput"] | undefined,
	create?: GraphQLTypes["DeliveryZoneWithoutDeliveryZonesOfTagsCreateInput"] | undefined
};
	["ChannelUpsertAddTagsOnRegistrationRelationInput"]: {
		by?: GraphQLTypes["TagUniqueWhere"] | undefined,
	update?: GraphQLTypes["TagWithoutAddTagsOnRegistrationUpdateInput"] | undefined,
	create?: GraphQLTypes["TagWithoutAddTagsOnRegistrationCreateInput"] | undefined
};
	["CartUpsertChannelRelationInput"]: {
		update?: GraphQLTypes["ChannelWithoutCartsUpdateInput"] | undefined,
	create?: GraphQLTypes["ChannelWithoutCartsCreateInput"] | undefined
};
	["CartItemUpsertCartRelationInput"]: {
		update?: GraphQLTypes["CartWithoutItemsUpdateInput"] | undefined,
	create?: GraphQLTypes["CartWithoutItemsCreateInput"] | undefined
};
	["CartItemUpdateFulfillmentNotesEntityRelationInput"]: {
		create?: GraphQLTypes["FulfillmentNoteWithoutCartItemsCreateInput"] | undefined,
	update?: GraphQLTypes["CartItemUpdateFulfillmentNotesRelationInput"] | undefined,
	upsert?: GraphQLTypes["CartItemUpsertFulfillmentNotesRelationInput"] | undefined,
	connect?: GraphQLTypes["FulfillmentNoteUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["FulfillmentNoteUniqueWhere"] | undefined,
	delete?: GraphQLTypes["FulfillmentNoteUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["CartItemUpdateFulfillmentNotesRelationInput"]: {
		by?: GraphQLTypes["FulfillmentNoteUniqueWhere"] | undefined,
	data?: GraphQLTypes["FulfillmentNoteWithoutCartItemsUpdateInput"] | undefined
};
	["FulfillmentNoteWithoutCartItemsUpdateInput"]: {
		note?: string | undefined,
	products?: Array<GraphQLTypes["FulfillmentNoteUpdateProductsEntityRelationInput"]> | undefined,
	tags?: Array<GraphQLTypes["FulfillmentNoteUpdateTagsEntityRelationInput"]> | undefined,
	venues?: Array<GraphQLTypes["FulfillmentNoteUpdateVenuesEntityRelationInput"]> | undefined,
	orderItems?: Array<GraphQLTypes["FulfillmentNoteUpdateOrderItemsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["FulfillmentNoteUpdateOrdersEntityRelationInput"]> | undefined,
	highlight?: boolean | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	emoji?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["CartItemUpsertFulfillmentNotesRelationInput"]: {
		by?: GraphQLTypes["FulfillmentNoteUniqueWhere"] | undefined,
	update?: GraphQLTypes["FulfillmentNoteWithoutCartItemsUpdateInput"] | undefined,
	create?: GraphQLTypes["FulfillmentNoteWithoutCartItemsCreateInput"] | undefined
};
	["ProductUpsertCartItemsRelationInput"]: {
		by?: GraphQLTypes["CartItemUniqueWhere"] | undefined,
	update?: GraphQLTypes["CartItemWithoutProductUpdateInput"] | undefined,
	create?: GraphQLTypes["CartItemWithoutProductCreateInput"] | undefined
};
	["ProductGroupPriceUpsertProductRelationInput"]: {
		update?: GraphQLTypes["ProductWithoutGroupPricesUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductWithoutGroupPricesCreateInput"] | undefined
};
	["CustomerGroupUpsertProductPricesRelationInput"]: {
		by?: GraphQLTypes["ProductGroupPriceUniqueWhere"] | undefined,
	update?: GraphQLTypes["ProductGroupPriceWithoutGroupUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductGroupPriceWithoutGroupCreateInput"] | undefined
};
	["CustomerUpsertGroupRelationInput"]: {
		update?: GraphQLTypes["CustomerGroupWithoutCustomersUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerGroupWithoutCustomersCreateInput"] | undefined
};
	["ChannelUpsertCustomersRelationInput"]: {
		by?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	update?: GraphQLTypes["CustomerWithoutChannelsUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerWithoutChannelsCreateInput"] | undefined
};
	["TagUpsertAddTagsOnRegistrationRelationInput"]: {
		by?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	update?: GraphQLTypes["ChannelWithoutAddTagsOnRegistrationUpdateInput"] | undefined,
	create?: GraphQLTypes["ChannelWithoutAddTagsOnRegistrationCreateInput"] | undefined
};
	["ProductCategoryUpsertTagsRelationInput"]: {
		by?: GraphQLTypes["TagUniqueWhere"] | undefined,
	update?: GraphQLTypes["TagWithoutCategoriesUpdateInput"] | undefined,
	create?: GraphQLTypes["TagWithoutCategoriesCreateInput"] | undefined
};
	["ProductCategoryUpsertParentRelationInput"]: {
		update?: GraphQLTypes["ProductCategoryWithoutChildrenUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductCategoryWithoutChildrenCreateInput"] | undefined
};
	["TagUpsertCategoriesRelationInput"]: {
		by?: GraphQLTypes["ProductCategoryUniqueWhere"] | undefined,
	update?: GraphQLTypes["ProductCategoryWithoutTagsUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductCategoryWithoutTagsCreateInput"] | undefined
};
	["ProductUpsertTagsRelationInput"]: {
		by?: GraphQLTypes["TagUniqueWhere"] | undefined,
	update?: GraphQLTypes["TagWithoutProductsUpdateInput"] | undefined,
	create?: GraphQLTypes["TagWithoutProductsCreateInput"] | undefined
};
	["ProductCategoryUpsertProductsRelationInput"]: {
		by?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	update?: GraphQLTypes["ProductWithoutCategoriesUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductWithoutCategoriesCreateInput"] | undefined
};
	["ProductCategoryListItemUpsertProductCategoryRelationInput"]: {
		update?: GraphQLTypes["ProductCategoryUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductCategoryCreateInput"] | undefined
};
	["ProductCategoryListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["ProductCategoryListItemUniqueWhere"] | undefined,
	update?: GraphQLTypes["ProductCategoryListItemWithoutListUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductCategoryListItemWithoutListCreateInput"] | undefined
};
	["ProductCategoryListLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["ProductCategoryListWithoutLocalesUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductCategoryListWithoutLocalesCreateInput"] | undefined
};
	["LocaleUpsertProductCategoryListsRelationInput"]: {
		by?: GraphQLTypes["ProductCategoryListLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["ProductCategoryListLocaleWithoutLocaleUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductCategoryListLocaleWithoutLocaleCreateInput"] | undefined
};
	["ProductIngredientLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutProductIngredientsUpdateInput"] | undefined,
	create?: GraphQLTypes["LocaleWithoutProductIngredientsCreateInput"] | undefined
};
	["ProductIngredientUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["ProductIngredientLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["ProductIngredientLocaleWithoutRootUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductIngredientLocaleWithoutRootCreateInput"] | undefined
};
	["ProductIngredientItemUpsertIngredientRelationInput"]: {
		update?: GraphQLTypes["ProductIngredientUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductIngredientCreateInput"] | undefined
};
	["ProductIngredientItemUpdateQuantityEntityRelationInput"]: {
		create?: GraphQLTypes["ProductIngredientItemQuantityCreateInput"] | undefined,
	update?: GraphQLTypes["ProductIngredientItemQuantityUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductIngredientItemUpsertQuantityRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductIngredientItemQuantityUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProductIngredientItemQuantityUpdateInput"]: {
		unit?: GraphQLTypes["ProductIngredientItemQuantityUpdateUnitEntityRelationInput"] | undefined,
	value?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientItemQuantityUpdateUnitEntityRelationInput"]: {
		create?: GraphQLTypes["ProductIngredientItemQuantityUnitCreateInput"] | undefined,
	update?: GraphQLTypes["ProductIngredientItemQuantityUnitUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductIngredientItemQuantityUpsertUnitRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductIngredientItemQuantityUnitUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["ProductIngredientItemQuantityUpsertUnitRelationInput"]: {
		update?: GraphQLTypes["ProductIngredientItemQuantityUnitUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductIngredientItemQuantityUnitCreateInput"] | undefined
};
	["ProductIngredientItemUpsertQuantityRelationInput"]: {
		update?: GraphQLTypes["ProductIngredientItemQuantityUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductIngredientItemQuantityCreateInput"] | undefined
};
	["ProductRecipeUpsertIngredientsRelationInput"]: {
		by?: GraphQLTypes["ProductIngredientItemUniqueWhere"] | undefined,
	update?: GraphQLTypes["ProductIngredientItemWithoutRecipeUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductIngredientItemWithoutRecipeCreateInput"] | undefined
};
	["ProductUpsertRecipeRelationInput"]: {
		update?: GraphQLTypes["ProductRecipeWithoutProductsUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductRecipeWithoutProductsCreateInput"] | undefined
};
	["CartItemUpsertProductRelationInput"]: {
		update?: GraphQLTypes["ProductWithoutCartItemsUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductWithoutCartItemsCreateInput"] | undefined
};
	["CartUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["CartItemUniqueWhere"] | undefined,
	update?: GraphQLTypes["CartItemWithoutCartUpdateInput"] | undefined,
	create?: GraphQLTypes["CartItemWithoutCartCreateInput"] | undefined
};
	["ChannelUpsertCartsRelationInput"]: {
		by?: GraphQLTypes["CartUniqueWhere"] | undefined,
	update?: GraphQLTypes["CartWithoutChannelUpdateInput"] | undefined,
	create?: GraphQLTypes["CartWithoutChannelCreateInput"] | undefined
};
	["OrderUpsertChannelRelationInput"]: {
		update?: GraphQLTypes["ChannelUpdateInput"] | undefined,
	create?: GraphQLTypes["ChannelCreateInput"] | undefined
};
	["CustomerUpsertOrdersRelationInput"]: {
		by?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	update?: GraphQLTypes["OrderWithoutCustomerUpdateInput"] | undefined,
	create?: GraphQLTypes["OrderWithoutCustomerCreateInput"] | undefined
};
	["TagUpsertCustomersRelationInput"]: {
		by?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	update?: GraphQLTypes["CustomerWithoutTagsUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerWithoutTagsCreateInput"] | undefined
};
	["ChannelPaymentUpsertAllowOnlyForTagsRelationInput"]: {
		by?: GraphQLTypes["TagUniqueWhere"] | undefined,
	update?: GraphQLTypes["TagWithoutAllowChannelPaymentsUpdateInput"] | undefined,
	create?: GraphQLTypes["TagWithoutAllowChannelPaymentsCreateInput"] | undefined
};
	["VatRateUpsertChannelPaymentsRelationInput"]: {
		by?: GraphQLTypes["ChannelPaymentUniqueWhere"] | undefined,
	update?: GraphQLTypes["ChannelPaymentWithoutVatRateUpdateInput"] | undefined,
	create?: GraphQLTypes["ChannelPaymentWithoutVatRateCreateInput"] | undefined
};
	["ChannelDeliveryUpsertVatRateRelationInput"]: {
		update?: GraphQLTypes["VatRateWithoutChannelDeliveriesUpdateInput"] | undefined,
	create?: GraphQLTypes["VatRateWithoutChannelDeliveriesCreateInput"] | undefined
};
	["DeliveryMethodUpsertChannelsRelationInput"]: {
		by?: GraphQLTypes["ChannelDeliveryUniqueWhere"] | undefined,
	update?: GraphQLTypes["ChannelDeliveryWithoutMethodUpdateInput"] | undefined,
	create?: GraphQLTypes["ChannelDeliveryWithoutMethodCreateInput"] | undefined
};
	["PaymentMethodUpsertDeliveryMethodsRelationInput"]: {
		by?: GraphQLTypes["DeliveryMethodUniqueWhere"] | undefined,
	update?: GraphQLTypes["DeliveryMethodWithoutPaymentMethodsUpdateInput"] | undefined,
	create?: GraphQLTypes["DeliveryMethodWithoutPaymentMethodsCreateInput"] | undefined
};
	["ChannelPaymentUpsertMethodRelationInput"]: {
		update?: GraphQLTypes["PaymentMethodWithoutChannelsUpdateInput"] | undefined,
	create?: GraphQLTypes["PaymentMethodWithoutChannelsCreateInput"] | undefined
};
	["ChannelUpsertPaymentsRelationInput"]: {
		by?: GraphQLTypes["ChannelPaymentUniqueWhere"] | undefined,
	update?: GraphQLTypes["ChannelPaymentWithoutChannelUpdateInput"] | undefined,
	create?: GraphQLTypes["ChannelPaymentWithoutChannelCreateInput"] | undefined
};
	["ChannelDeliveryUpsertChannelRelationInput"]: {
		update?: GraphQLTypes["ChannelWithoutDeliveriesUpdateInput"] | undefined,
	create?: GraphQLTypes["ChannelWithoutDeliveriesCreateInput"] | undefined
};
	["VatRateUpsertChannelDeliveriesRelationInput"]: {
		by?: GraphQLTypes["ChannelDeliveryUniqueWhere"] | undefined,
	update?: GraphQLTypes["ChannelDeliveryWithoutVatRateUpdateInput"] | undefined,
	create?: GraphQLTypes["ChannelDeliveryWithoutVatRateCreateInput"] | undefined
};
	["CustomerCreditUpsertVatRateRelationInput"]: {
		update?: GraphQLTypes["VatRateUpdateInput"] | undefined,
	create?: GraphQLTypes["VatRateCreateInput"] | undefined
};
	["CustomerUpsertCreditsRelationInput"]: {
		by?: GraphQLTypes["CustomerCreditUniqueWhere"] | undefined,
	update?: GraphQLTypes["CustomerCreditWithoutCustomerUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerCreditWithoutCustomerCreateInput"] | undefined
};
	["BusinessCustomerUpsertCustomerRelationInput"]: {
		update?: GraphQLTypes["CustomerWithoutBusinessUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerWithoutBusinessCreateInput"] | undefined
};
	["BusinessCategoryUpsertBusinessCustomersRelationInput"]: {
		by?: GraphQLTypes["BusinessCustomerUniqueWhere"] | undefined,
	update?: GraphQLTypes["BusinessCustomerWithoutCategoryUpdateInput"] | undefined,
	create?: GraphQLTypes["BusinessCustomerWithoutCategoryCreateInput"] | undefined
};
	["BusinessCategoryLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["BusinessCategoryWithoutLocalesUpdateInput"] | undefined,
	create?: GraphQLTypes["BusinessCategoryWithoutLocalesCreateInput"] | undefined
};
	["LocaleUpsertBusinessCategoriesRelationInput"]: {
		by?: GraphQLTypes["BusinessCategoryLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["BusinessCategoryLocaleWithoutLocaleUpdateInput"] | undefined,
	create?: GraphQLTypes["BusinessCategoryLocaleWithoutLocaleCreateInput"] | undefined
};
	["ProductPackingLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutProductPackingsUpdateInput"] | undefined,
	create?: GraphQLTypes["LocaleWithoutProductPackingsCreateInput"] | undefined
};
	["ProductPackingUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["ProductPackingLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["ProductPackingLocaleWithoutRootUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductPackingLocaleWithoutRootCreateInput"] | undefined
};
	["ProductUpsertPackingRelationInput"]: {
		update?: GraphQLTypes["ProductPackingUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductPackingCreateInput"] | undefined
};
	["TagUpsertProductsRelationInput"]: {
		by?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	update?: GraphQLTypes["ProductWithoutTagsUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductWithoutTagsCreateInput"] | undefined
};
	["CustomerUpsertTagsRelationInput"]: {
		by?: GraphQLTypes["TagUniqueWhere"] | undefined,
	update?: GraphQLTypes["TagWithoutCustomersUpdateInput"] | undefined,
	create?: GraphQLTypes["TagWithoutCustomersCreateInput"] | undefined
};
	["InvoiceUpsertCustomerRelationInput"]: {
		update?: GraphQLTypes["CustomerWithoutInvoicesUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerWithoutInvoicesCreateInput"] | undefined
};
	["AddressUpsertInvoicesRelationInput"]: {
		by?: GraphQLTypes["InvoiceUniqueWhere"] | undefined,
	update?: GraphQLTypes["InvoiceWithoutAddressUpdateInput"] | undefined,
	create?: GraphQLTypes["InvoiceWithoutAddressCreateInput"] | undefined
};
	["DeliveryZoneUpsertAddressesRelationInput"]: {
		by?: GraphQLTypes["AddressUniqueWhere"] | undefined,
	update?: GraphQLTypes["AddressWithoutDeliveryZoneUpdateInput"] | undefined,
	create?: GraphQLTypes["AddressWithoutDeliveryZoneCreateInput"] | undefined
};
	["DeliveryMethodUpsertSuitableForDeliveryZonesRelationInput"]: {
		by?: GraphQLTypes["DeliveryZoneUniqueWhere"] | undefined,
	update?: GraphQLTypes["DeliveryZoneWithoutSuitableDeliveryMethodsUpdateInput"] | undefined,
	create?: GraphQLTypes["DeliveryZoneWithoutSuitableDeliveryMethodsCreateInput"] | undefined
};
	["ChannelDeliveryUpsertMethodRelationInput"]: {
		update?: GraphQLTypes["DeliveryMethodWithoutChannelsUpdateInput"] | undefined,
	create?: GraphQLTypes["DeliveryMethodWithoutChannelsCreateInput"] | undefined
};
	["ChannelUpsertDeliveriesRelationInput"]: {
		by?: GraphQLTypes["ChannelDeliveryUniqueWhere"] | undefined,
	update?: GraphQLTypes["ChannelDeliveryWithoutChannelUpdateInput"] | undefined,
	create?: GraphQLTypes["ChannelDeliveryWithoutChannelCreateInput"] | undefined
};
	["ChannelPaymentUpsertChannelRelationInput"]: {
		update?: GraphQLTypes["ChannelWithoutPaymentsUpdateInput"] | undefined,
	create?: GraphQLTypes["ChannelWithoutPaymentsCreateInput"] | undefined
};
	["PaymentMethodUpsertChannelsRelationInput"]: {
		by?: GraphQLTypes["ChannelPaymentUniqueWhere"] | undefined,
	update?: GraphQLTypes["ChannelPaymentWithoutMethodUpdateInput"] | undefined,
	create?: GraphQLTypes["ChannelPaymentWithoutMethodCreateInput"] | undefined
};
	["DeliveryMethodUpsertPaymentMethodsRelationInput"]: {
		by?: GraphQLTypes["PaymentMethodUniqueWhere"] | undefined,
	update?: GraphQLTypes["PaymentMethodWithoutDeliveryMethodsUpdateInput"] | undefined,
	create?: GraphQLTypes["PaymentMethodWithoutDeliveryMethodsCreateInput"] | undefined
};
	["DeliveryZoneUpsertSuitableDeliveryMethodsRelationInput"]: {
		by?: GraphQLTypes["DeliveryMethodUniqueWhere"] | undefined,
	update?: GraphQLTypes["DeliveryMethodWithoutSuitableForDeliveryZonesUpdateInput"] | undefined,
	create?: GraphQLTypes["DeliveryMethodWithoutSuitableForDeliveryZonesCreateInput"] | undefined
};
	["AddressUpsertDeliveryZoneRelationInput"]: {
		update?: GraphQLTypes["DeliveryZoneWithoutAddressesUpdateInput"] | undefined,
	create?: GraphQLTypes["DeliveryZoneWithoutAddressesCreateInput"] | undefined
};
	["CustomerUpsertAddressesRelationInput"]: {
		by?: GraphQLTypes["AddressUniqueWhere"] | undefined,
	update?: GraphQLTypes["AddressWithoutCustomerUpdateInput"] | undefined,
	create?: GraphQLTypes["AddressWithoutCustomerCreateInput"] | undefined
};
	["CustomerPaymentMethodUpsertCustomerRelationInput"]: {
		update?: GraphQLTypes["CustomerWithoutPaymentMethodsUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerWithoutPaymentMethodsCreateInput"] | undefined
};
	["CustomerUpsertDefaultPaymentMethodRelationInput"]: {
		update?: GraphQLTypes["CustomerPaymentMethodUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerPaymentMethodCreateInput"] | undefined
};
	["AddressUpsertCustomerRelationInput"]: {
		update?: GraphQLTypes["CustomerWithoutAddressesUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerWithoutAddressesCreateInput"] | undefined
};
	["CustomerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	addresses?: Array<GraphQLTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerCreateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerCreateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerCreatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerCreateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerCreateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerCreateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerCreateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerCreateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerCreateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerCreateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerUpdateInput"]: {
		addresses?: Array<GraphQLTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerUpdateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerUpdateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerUpdateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerUpdateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreditCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	initialCreditCents?: number | undefined,
	remainingCreditsCents?: number | undefined,
	expiresAt?: GraphQLTypes["DateTime"] | undefined,
	reason?: string | undefined,
	customer?: GraphQLTypes["CustomerCreditCreateCustomerEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["CustomerCreditCreateVatRateEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	transactions?: Array<GraphQLTypes["CustomerCreditCreateTransactionsEntityRelationInput"]> | undefined,
	voucherRedemption?: GraphQLTypes["CustomerCreditCreateVoucherRedemptionEntityRelationInput"] | undefined,
	invoiceUrl?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreditUpdateInput"]: {
		initialCreditCents?: number | undefined,
	remainingCreditsCents?: number | undefined,
	expiresAt?: GraphQLTypes["DateTime"] | undefined,
	reason?: string | undefined,
	customer?: GraphQLTypes["CustomerCreditUpdateCustomerEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["CustomerCreditUpdateVatRateEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	transactions?: Array<GraphQLTypes["CustomerCreditUpdateTransactionsEntityRelationInput"]> | undefined,
	voucherRedemption?: GraphQLTypes["CustomerCreditUpdateVoucherRedemptionEntityRelationInput"] | undefined,
	invoiceUrl?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerGroupConnection"]: {
	__typename: "CustomerGroupConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CustomerGroupEdge"]>
};
	["CustomerGroupEdge"]: {
	__typename: "CustomerGroupEdge",
	node: GraphQLTypes["CustomerGroup"]
};
	["CustomerGroupCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	productPrices?: Array<GraphQLTypes["CustomerGroupCreateProductPricesEntityRelationInput"]> | undefined,
	customers?: Array<GraphQLTypes["CustomerGroupCreateCustomersEntityRelationInput"]> | undefined,
	discountPermille?: number | undefined,
	code?: string | undefined,
	doubleshotLegacyId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerGroupUpdateInput"]: {
		name?: string | undefined,
	productPrices?: Array<GraphQLTypes["CustomerGroupUpdateProductPricesEntityRelationInput"]> | undefined,
	customers?: Array<GraphQLTypes["CustomerGroupUpdateCustomersEntityRelationInput"]> | undefined,
	discountPermille?: number | undefined,
	code?: string | undefined,
	doubleshotLegacyId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	state?: GraphQLTypes["OrderState"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	canceledAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	customer?: GraphQLTypes["OrderCreateCustomerEntityRelationInput"] | undefined,
	channel?: GraphQLTypes["OrderCreateChannelEntityRelationInput"] | undefined,
	discounts?: Array<GraphQLTypes["OrderCreateDiscountsEntityRelationInput"]> | undefined,
	delivery?: GraphQLTypes["OrderCreateDeliveryEntityRelationInput"] | undefined,
	items?: Array<GraphQLTypes["OrderCreateItemsEntityRelationInput"]> | undefined,
	internalNote?: string | undefined,
	cart?: GraphQLTypes["OrderCreateCartEntityRelationInput"] | undefined,
	events?: Array<GraphQLTypes["OrderCreateEventsEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddress?: GraphQLTypes["OrderCreateBillingAddressEntityRelationInput"] | undefined,
	priceLines?: Array<GraphQLTypes["OrderCreatePriceLinesEntityRelationInput"]> | undefined,
	payments?: Array<GraphQLTypes["OrderCreatePaymentsEntityRelationInput"]> | undefined,
	seq?: number | undefined,
	billingSubject?: GraphQLTypes["OrderCreateBillingSubjectEntityRelationInput"] | undefined,
	summary?: GraphQLTypes["OrderCreateSummaryEntityRelationInput"] | undefined,
	doubleshotLegacyId?: string | undefined,
	gratuity?: GraphQLTypes["OrderCreateGratuityEntityRelationInput"] | undefined,
	venue?: GraphQLTypes["OrderCreateVenueEntityRelationInput"] | undefined,
	fulfillmentNote?: string | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["OrderCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	doubleshotTotalWeightGrams?: number | undefined,
	doubleShotLegacyNumber?: string | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	doubleshotAdminUrl?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderUpdateInput"]: {
		state?: GraphQLTypes["OrderState"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	canceledAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	customer?: GraphQLTypes["OrderUpdateCustomerEntityRelationInput"] | undefined,
	channel?: GraphQLTypes["OrderUpdateChannelEntityRelationInput"] | undefined,
	discounts?: Array<GraphQLTypes["OrderUpdateDiscountsEntityRelationInput"]> | undefined,
	delivery?: GraphQLTypes["OrderUpdateDeliveryEntityRelationInput"] | undefined,
	items?: Array<GraphQLTypes["OrderUpdateItemsEntityRelationInput"]> | undefined,
	internalNote?: string | undefined,
	cart?: GraphQLTypes["OrderUpdateCartEntityRelationInput"] | undefined,
	events?: Array<GraphQLTypes["OrderUpdateEventsEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddress?: GraphQLTypes["OrderUpdateBillingAddressEntityRelationInput"] | undefined,
	priceLines?: Array<GraphQLTypes["OrderUpdatePriceLinesEntityRelationInput"]> | undefined,
	payments?: Array<GraphQLTypes["OrderUpdatePaymentsEntityRelationInput"]> | undefined,
	seq?: number | undefined,
	billingSubject?: GraphQLTypes["OrderUpdateBillingSubjectEntityRelationInput"] | undefined,
	summary?: GraphQLTypes["OrderUpdateSummaryEntityRelationInput"] | undefined,
	doubleshotLegacyId?: string | undefined,
	gratuity?: GraphQLTypes["OrderUpdateGratuityEntityRelationInput"] | undefined,
	venue?: GraphQLTypes["OrderUpdateVenueEntityRelationInput"] | undefined,
	fulfillmentNote?: string | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["OrderUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	doubleshotTotalWeightGrams?: number | undefined,
	doubleShotLegacyNumber?: string | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	doubleshotAdminUrl?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderDiscountCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	discountCents?: number | undefined,
	vatRate?: GraphQLTypes["OrderDiscountCreateVatRateEntityRelationInput"] | undefined,
	order?: GraphQLTypes["OrderDiscountCreateOrderEntityRelationInput"] | undefined,
	description?: string | undefined,
	type?: GraphQLTypes["OrderDiscountType"] | undefined,
	customerCreditTransactions?: Array<GraphQLTypes["OrderDiscountCreateCustomerCreditTransactionsEntityRelationInput"]> | undefined,
	voucherRedemption?: GraphQLTypes["OrderDiscountCreateVoucherRedemptionEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderDiscountUpdateInput"]: {
		discountCents?: number | undefined,
	vatRate?: GraphQLTypes["OrderDiscountUpdateVatRateEntityRelationInput"] | undefined,
	order?: GraphQLTypes["OrderDiscountUpdateOrderEntityRelationInput"] | undefined,
	description?: string | undefined,
	type?: GraphQLTypes["OrderDiscountType"] | undefined,
	customerCreditTransactions?: Array<GraphQLTypes["OrderDiscountUpdateCustomerCreditTransactionsEntityRelationInput"]> | undefined,
	voucherRedemption?: GraphQLTypes["OrderDiscountUpdateVoucherRedemptionEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderPaymentCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	data?: GraphQLTypes["Json"] | undefined,
	paymentCents?: number | undefined,
	method?: GraphQLTypes["OrderPaymentCreateMethodEntityRelationInput"] | undefined,
	failedAt?: GraphQLTypes["DateTime"] | undefined,
	state?: GraphQLTypes["OrderPaymentState"] | undefined,
	approvedAt?: GraphQLTypes["DateTime"] | undefined,
	events?: Array<GraphQLTypes["OrderPaymentCreateEventsEntityRelationInput"]> | undefined,
	order?: GraphQLTypes["OrderPaymentCreateOrderEntityRelationInput"] | undefined,
	invoice?: GraphQLTypes["OrderPaymentCreateInvoiceEntityRelationInput"] | undefined,
	walletType?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	publicReceiptUrl?: string | undefined,
	priceCents?: number | undefined,
	vatRate?: GraphQLTypes["OrderPaymentCreateVatRateEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["OrderPaymentCreateMetaEntityRelationInput"] | undefined,
	otherCurrencyPriceCents?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderPaymentUpdateInput"]: {
		data?: GraphQLTypes["Json"] | undefined,
	paymentCents?: number | undefined,
	method?: GraphQLTypes["OrderPaymentUpdateMethodEntityRelationInput"] | undefined,
	failedAt?: GraphQLTypes["DateTime"] | undefined,
	state?: GraphQLTypes["OrderPaymentState"] | undefined,
	approvedAt?: GraphQLTypes["DateTime"] | undefined,
	events?: Array<GraphQLTypes["OrderPaymentUpdateEventsEntityRelationInput"]> | undefined,
	order?: GraphQLTypes["OrderPaymentUpdateOrderEntityRelationInput"] | undefined,
	invoice?: GraphQLTypes["OrderPaymentUpdateInvoiceEntityRelationInput"] | undefined,
	walletType?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	publicReceiptUrl?: string | undefined,
	priceCents?: number | undefined,
	vatRate?: GraphQLTypes["OrderPaymentUpdateVatRateEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["OrderPaymentUpdateMetaEntityRelationInput"] | undefined,
	otherCurrencyPriceCents?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderDeliveryCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	priceCents?: number | undefined,
	deliveredAt?: GraphQLTypes["DateTime"] | undefined,
	method?: GraphQLTypes["OrderDeliveryCreateMethodEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["OrderDeliveryCreateVatRateEntityRelationInput"] | undefined,
	order?: GraphQLTypes["OrderDeliveryCreateOrderEntityRelationInput"] | undefined,
	expectedAt?: GraphQLTypes["DateTime"] | undefined,
	state?: GraphQLTypes["OrderDeliveryState"] | undefined,
	loadingDurationHours?: number | undefined,
	dispatchAt?: GraphQLTypes["DateTime"] | undefined,
	duration?: string | undefined,
	window?: string | undefined,
	expectedEndAt?: GraphQLTypes["DateTime"] | undefined,
	processingAt?: GraphQLTypes["DateTime"] | undefined,
	deliveringAt?: GraphQLTypes["DateTime"] | undefined,
	failedAt?: GraphQLTypes["DateTime"] | undefined,
	internalNote?: string | undefined,
	deliveryWaypoint?: GraphQLTypes["OrderDeliveryCreateDeliveryWaypointEntityRelationInput"] | undefined,
	events?: Array<GraphQLTypes["OrderDeliveryCreateEventsEntityRelationInput"]> | undefined,
	prepareAt?: GraphQLTypes["DateTime"] | undefined,
	liftagoRide?: GraphQLTypes["OrderDeliveryCreateLiftagoRideEntityRelationInput"] | undefined,
	pickedAt?: GraphQLTypes["DateTime"] | undefined,
	address?: GraphQLTypes["OrderDeliveryCreateAddressEntityRelationInput"] | undefined,
	trackingCode?: string | undefined,
	woltDriveDelivery?: GraphQLTypes["OrderDeliveryCreateWoltDriveDeliveryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderDeliveryUpdateInput"]: {
		priceCents?: number | undefined,
	deliveredAt?: GraphQLTypes["DateTime"] | undefined,
	method?: GraphQLTypes["OrderDeliveryUpdateMethodEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["OrderDeliveryUpdateVatRateEntityRelationInput"] | undefined,
	order?: GraphQLTypes["OrderDeliveryUpdateOrderEntityRelationInput"] | undefined,
	expectedAt?: GraphQLTypes["DateTime"] | undefined,
	state?: GraphQLTypes["OrderDeliveryState"] | undefined,
	loadingDurationHours?: number | undefined,
	dispatchAt?: GraphQLTypes["DateTime"] | undefined,
	duration?: string | undefined,
	window?: string | undefined,
	expectedEndAt?: GraphQLTypes["DateTime"] | undefined,
	processingAt?: GraphQLTypes["DateTime"] | undefined,
	deliveringAt?: GraphQLTypes["DateTime"] | undefined,
	failedAt?: GraphQLTypes["DateTime"] | undefined,
	internalNote?: string | undefined,
	deliveryWaypoint?: GraphQLTypes["OrderDeliveryUpdateDeliveryWaypointEntityRelationInput"] | undefined,
	events?: Array<GraphQLTypes["OrderDeliveryUpdateEventsEntityRelationInput"]> | undefined,
	prepareAt?: GraphQLTypes["DateTime"] | undefined,
	liftagoRide?: GraphQLTypes["OrderDeliveryUpdateLiftagoRideEntityRelationInput"] | undefined,
	pickedAt?: GraphQLTypes["DateTime"] | undefined,
	address?: GraphQLTypes["OrderDeliveryUpdateAddressEntityRelationInput"] | undefined,
	trackingCode?: string | undefined,
	woltDriveDelivery?: GraphQLTypes["OrderDeliveryUpdateWoltDriveDeliveryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unitPriceCents?: number | undefined,
	quantity?: number | undefined,
	vatRate?: GraphQLTypes["OrderItemCreateVatRateEntityRelationInput"] | undefined,
	order?: GraphQLTypes["OrderItemCreateOrderEntityRelationInput"] | undefined,
	virtualProductEffects?: Array<GraphQLTypes["OrderItemCreateVirtualProductEffectsEntityRelationInput"]> | undefined,
	pickedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["OrderItemCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	product?: GraphQLTypes["OrderItemCreateProductEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderItemUpdateInput"]: {
		unitPriceCents?: number | undefined,
	quantity?: number | undefined,
	vatRate?: GraphQLTypes["OrderItemUpdateVatRateEntityRelationInput"] | undefined,
	order?: GraphQLTypes["OrderItemUpdateOrderEntityRelationInput"] | undefined,
	virtualProductEffects?: Array<GraphQLTypes["OrderItemUpdateVirtualProductEffectsEntityRelationInput"]> | undefined,
	pickedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["OrderItemUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	product?: GraphQLTypes["OrderItemUpdateProductEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["VatRateConnection"]: {
	__typename: "VatRateConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["VatRateEdge"]>
};
	["VatRateEdge"]: {
	__typename: "VatRateEdge",
	node: GraphQLTypes["VatRate"]
};
	["ProductStockCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	quantity?: number | undefined,
	product?: GraphQLTypes["ProductStockCreateProductEntityRelationInput"] | undefined,
	store?: GraphQLTypes["ProductStockCreateStoreEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductStockCreateProductEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductWithoutStocksCreateInput"] | undefined
};
	["ProductWithoutStocksCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	priceCents?: number | undefined,
	notDiscountable?: boolean | undefined,
	packing?: GraphQLTypes["ProductCreatePackingEntityRelationInput"] | undefined,
	recipe?: GraphQLTypes["ProductCreateRecipeEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["ProductCreateTagsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["ProductCreateCategoriesEntityRelationInput"]> | undefined,
	vatRate?: GraphQLTypes["ProductCreateVatRateEntityRelationInput"] | undefined,
	groupPrices?: Array<GraphQLTypes["ProductCreateGroupPricesEntityRelationInput"]> | undefined,
	image?: GraphQLTypes["ProductCreateImageEntityRelationInput"] | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	cartItems?: Array<GraphQLTypes["ProductCreateCartItemsEntityRelationInput"]> | undefined,
	availability?: GraphQLTypes["ProductAvailability"] | undefined,
	order?: number | undefined,
	manager?: GraphQLTypes["ProductCreateManagerEntityRelationInput"] | undefined,
	orderItems?: Array<GraphQLTypes["ProductCreateOrderItemsEntityRelationInput"]> | undefined,
	maximumQuantityPerOrder?: number | undefined,
	inheritedCategories?: Array<GraphQLTypes["ProductCreateInheritedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["ProductCreateDeliveryZonesEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["ProductCreateLocalesEntityRelationInput"]> | undefined,
	archivedAt?: GraphQLTypes["DateTime"] | undefined,
	customerPrices?: Array<GraphQLTypes["ProductCreateCustomerPricesEntityRelationInput"]> | undefined,
	virtualProduct?: GraphQLTypes["ProductCreateVirtualProductEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["ProductCreateMetaEntityRelationInput"] | undefined,
	page?: GraphQLTypes["ProductCreatePageEntityRelationInput"] | undefined,
	salesDays?: Array<GraphQLTypes["ProductCreateSalesDaysEntityRelationInput"]> | undefined,
	salesWeeks?: Array<GraphQLTypes["ProductCreateSalesWeeksEntityRelationInput"]> | undefined,
	salesMonths?: Array<GraphQLTypes["ProductCreateSalesMonthsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["ProductCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	hasSubscription?: boolean | undefined,
	pointOfSaleTileColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductStockUpdateInput"]: {
		quantity?: number | undefined,
	product?: GraphQLTypes["ProductStockUpdateProductEntityRelationInput"] | undefined,
	store?: GraphQLTypes["ProductStockUpdateStoreEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductStockUpdateProductEntityRelationInput"]: {
		create?: GraphQLTypes["ProductWithoutStocksCreateInput"] | undefined,
	update?: GraphQLTypes["ProductWithoutStocksUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductStockUpsertProductRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["ProductWithoutStocksUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	priceCents?: number | undefined,
	notDiscountable?: boolean | undefined,
	packing?: GraphQLTypes["ProductUpdatePackingEntityRelationInput"] | undefined,
	recipe?: GraphQLTypes["ProductUpdateRecipeEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["ProductUpdateTagsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["ProductUpdateCategoriesEntityRelationInput"]> | undefined,
	vatRate?: GraphQLTypes["ProductUpdateVatRateEntityRelationInput"] | undefined,
	groupPrices?: Array<GraphQLTypes["ProductUpdateGroupPricesEntityRelationInput"]> | undefined,
	image?: GraphQLTypes["ProductUpdateImageEntityRelationInput"] | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	cartItems?: Array<GraphQLTypes["ProductUpdateCartItemsEntityRelationInput"]> | undefined,
	availability?: GraphQLTypes["ProductAvailability"] | undefined,
	order?: number | undefined,
	manager?: GraphQLTypes["ProductUpdateManagerEntityRelationInput"] | undefined,
	orderItems?: Array<GraphQLTypes["ProductUpdateOrderItemsEntityRelationInput"]> | undefined,
	maximumQuantityPerOrder?: number | undefined,
	inheritedCategories?: Array<GraphQLTypes["ProductUpdateInheritedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["ProductUpdateDeliveryZonesEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["ProductUpdateLocalesEntityRelationInput"]> | undefined,
	archivedAt?: GraphQLTypes["DateTime"] | undefined,
	customerPrices?: Array<GraphQLTypes["ProductUpdateCustomerPricesEntityRelationInput"]> | undefined,
	virtualProduct?: GraphQLTypes["ProductUpdateVirtualProductEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["ProductUpdateMetaEntityRelationInput"] | undefined,
	page?: GraphQLTypes["ProductUpdatePageEntityRelationInput"] | undefined,
	salesDays?: Array<GraphQLTypes["ProductUpdateSalesDaysEntityRelationInput"]> | undefined,
	salesWeeks?: Array<GraphQLTypes["ProductUpdateSalesWeeksEntityRelationInput"]> | undefined,
	salesMonths?: Array<GraphQLTypes["ProductUpdateSalesMonthsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["ProductUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	hasSubscription?: boolean | undefined,
	pointOfSaleTileColor?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductStockUpsertProductRelationInput"]: {
		update?: GraphQLTypes["ProductWithoutStocksUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductWithoutStocksCreateInput"] | undefined
};
	["ProductPackingConnection"]: {
	__typename: "ProductPackingConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductPackingEdge"]>
};
	["ProductPackingEdge"]: {
	__typename: "ProductPackingEdge",
	node: GraphQLTypes["ProductPacking"]
};
	["ProductGroupPriceCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	priceCents?: number | undefined,
	group?: GraphQLTypes["ProductGroupPriceCreateGroupEntityRelationInput"] | undefined,
	product?: GraphQLTypes["ProductGroupPriceCreateProductEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductGroupPriceUpdateInput"]: {
		priceCents?: number | undefined,
	group?: GraphQLTypes["ProductGroupPriceUpdateGroupEntityRelationInput"] | undefined,
	product?: GraphQLTypes["ProductGroupPriceUpdateProductEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductRecipeConnection"]: {
	__typename: "ProductRecipeConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductRecipeEdge"]>
};
	["ProductRecipeEdge"]: {
	__typename: "ProductRecipeEdge",
	node: GraphQLTypes["ProductRecipe"]
};
	["StoreConnection"]: {
	__typename: "StoreConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["StoreEdge"]>
};
	["StoreEdge"]: {
	__typename: "StoreEdge",
	node: GraphQLTypes["Store"]
};
	["TagCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	customers?: Array<GraphQLTypes["TagCreateCustomersEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["TagCreateProductsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["TagCreateCategoriesEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	addTagsOnRegistration?: Array<GraphQLTypes["TagCreateAddTagsOnRegistrationEntityRelationInput"]> | undefined,
	nestedCategories?: Array<GraphQLTypes["TagCreateNestedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["TagCreateDeliveryZonesEntityRelationInput"]> | undefined,
	publicInChannels?: Array<GraphQLTypes["TagCreatePublicInChannelsEntityRelationInput"]> | undefined,
	allowChannelPayments?: Array<GraphQLTypes["TagCreateAllowChannelPaymentsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["TagCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TagUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	customers?: Array<GraphQLTypes["TagUpdateCustomersEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["TagUpdateProductsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["TagUpdateCategoriesEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	addTagsOnRegistration?: Array<GraphQLTypes["TagUpdateAddTagsOnRegistrationEntityRelationInput"]> | undefined,
	nestedCategories?: Array<GraphQLTypes["TagUpdateNestedCategoriesEntityRelationInput"]> | undefined,
	deliveryZones?: Array<GraphQLTypes["TagUpdateDeliveryZonesEntityRelationInput"]> | undefined,
	publicInChannels?: Array<GraphQLTypes["TagUpdatePublicInChannelsEntityRelationInput"]> | undefined,
	allowChannelPayments?: Array<GraphQLTypes["TagUpdateAllowChannelPaymentsEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["TagUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerPermissionsConnection"]: {
	__typename: "CustomerPermissionsConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CustomerPermissionsEdge"]>
};
	["CustomerPermissionsEdge"]: {
	__typename: "CustomerPermissionsEdge",
	node: GraphQLTypes["CustomerPermissions"]
};
	["ImageConnection"]: {
	__typename: "ImageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ImageEdge"]>
};
	["ImageEdge"]: {
	__typename: "ImageEdge",
	node: GraphQLTypes["Image"]
};
	["BusinessCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	visibleToNewCustomers?: boolean | undefined,
	locales?: Array<GraphQLTypes["BusinessCategoryCreateLocalesEntityRelationInput"]> | undefined,
	internalName?: string | undefined,
	businessCustomers?: Array<GraphQLTypes["BusinessCategoryCreateBusinessCustomersEntityRelationInput"]> | undefined,
	recurrences?: Array<GraphQLTypes["BusinessCategoryCreateRecurrencesEntityRelationInput"]> | undefined,
	specificProducts?: GraphQLTypes["BusinessCategoryCreateSpecificProductsEntityRelationInput"] | undefined,
	seasonalProductCategories?: GraphQLTypes["BusinessCategoryCreateSeasonalProductCategoriesEntityRelationInput"] | undefined,
	specificProductsProductCategories?: GraphQLTypes["BusinessCategoryCreateSpecificProductsProductCategoriesEntityRelationInput"] | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessCategoryUpdateInput"]: {
		order?: number | undefined,
	visibleToNewCustomers?: boolean | undefined,
	locales?: Array<GraphQLTypes["BusinessCategoryUpdateLocalesEntityRelationInput"]> | undefined,
	internalName?: string | undefined,
	businessCustomers?: Array<GraphQLTypes["BusinessCategoryUpdateBusinessCustomersEntityRelationInput"]> | undefined,
	recurrences?: Array<GraphQLTypes["BusinessCategoryUpdateRecurrencesEntityRelationInput"]> | undefined,
	specificProducts?: GraphQLTypes["BusinessCategoryUpdateSpecificProductsEntityRelationInput"] | undefined,
	seasonalProductCategories?: GraphQLTypes["BusinessCategoryUpdateSeasonalProductCategoriesEntityRelationInput"] | undefined,
	specificProductsProductCategories?: GraphQLTypes["BusinessCategoryUpdateSpecificProductsProductCategoriesEntityRelationInput"] | undefined,
	slug?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductListConnection"]: {
	__typename: "ProductListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductListEdge"]>
};
	["ProductListEdge"]: {
	__typename: "ProductListEdge",
	node: GraphQLTypes["ProductList"]
};
	["ProductListItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	list?: GraphQLTypes["ProductListItemCreateListEntityRelationInput"] | undefined,
	product?: GraphQLTypes["ProductListItemCreateProductEntityRelationInput"] | undefined,
	defaultQuantityForOrder?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductListItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductListUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductListWithoutItemsCreateInput"] | undefined
};
	["ProductListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	businessCategory?: GraphQLTypes["ProductListCreateBusinessCategoryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductListItemUpdateInput"]: {
		order?: number | undefined,
	list?: GraphQLTypes["ProductListItemUpdateListEntityRelationInput"] | undefined,
	product?: GraphQLTypes["ProductListItemUpdateProductEntityRelationInput"] | undefined,
	defaultQuantityForOrder?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductListItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["ProductListWithoutItemsCreateInput"] | undefined,
	update?: GraphQLTypes["ProductListWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductListItemUpsertListRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductListUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["ProductListWithoutItemsUpdateInput"]: {
		businessCategory?: GraphQLTypes["ProductListUpdateBusinessCategoryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductListItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["ProductListWithoutItemsUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductListWithoutItemsCreateInput"] | undefined
};
	["ProductCategoryListConnection"]: {
	__typename: "ProductCategoryListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductCategoryListEdge"]>
};
	["ProductCategoryListEdge"]: {
	__typename: "ProductCategoryListEdge",
	node: GraphQLTypes["ProductCategoryList"]
};
	["ProductCategoryListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["ProductCategoryListCreateItemsEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["ProductCategoryListCreateLocalesEntityRelationInput"]> | undefined,
	seasonalProductCategoriesOfBusinessCategory?: GraphQLTypes["ProductCategoryListCreateSeasonalProductCategoriesOfBusinessCategoryEntityRelationInput"] | undefined,
	specificProductsProductCategoriesOfBusinessCategory?: GraphQLTypes["ProductCategoryListCreateSpecificProductsProductCategoriesOfBusinessCategoryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCategoryListUpdateInput"]: {
		items?: Array<GraphQLTypes["ProductCategoryListUpdateItemsEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["ProductCategoryListUpdateLocalesEntityRelationInput"]> | undefined,
	seasonalProductCategoriesOfBusinessCategory?: GraphQLTypes["ProductCategoryListUpdateSeasonalProductCategoriesOfBusinessCategoryEntityRelationInput"] | undefined,
	specificProductsProductCategoriesOfBusinessCategory?: GraphQLTypes["ProductCategoryListUpdateSpecificProductsProductCategoriesOfBusinessCategoryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCategoryListItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	list?: GraphQLTypes["ProductCategoryListItemCreateListEntityRelationInput"] | undefined,
	productCategory?: GraphQLTypes["ProductCategoryListItemCreateProductCategoryEntityRelationInput"] | undefined,
	showRecipeImages?: boolean | undefined,
	showPackingImages?: boolean | undefined,
	showAllAvailableProducts?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCategoryListItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductCategoryListUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductCategoryListWithoutItemsCreateInput"] | undefined
};
	["ProductCategoryListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locales?: Array<GraphQLTypes["ProductCategoryListCreateLocalesEntityRelationInput"]> | undefined,
	seasonalProductCategoriesOfBusinessCategory?: GraphQLTypes["ProductCategoryListCreateSeasonalProductCategoriesOfBusinessCategoryEntityRelationInput"] | undefined,
	specificProductsProductCategoriesOfBusinessCategory?: GraphQLTypes["ProductCategoryListCreateSpecificProductsProductCategoriesOfBusinessCategoryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCategoryListItemUpdateInput"]: {
		order?: number | undefined,
	list?: GraphQLTypes["ProductCategoryListItemUpdateListEntityRelationInput"] | undefined,
	productCategory?: GraphQLTypes["ProductCategoryListItemUpdateProductCategoryEntityRelationInput"] | undefined,
	showRecipeImages?: boolean | undefined,
	showPackingImages?: boolean | undefined,
	showAllAvailableProducts?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCategoryListItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["ProductCategoryListWithoutItemsCreateInput"] | undefined,
	update?: GraphQLTypes["ProductCategoryListWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductCategoryListItemUpsertListRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductCategoryListUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["ProductCategoryListWithoutItemsUpdateInput"]: {
		locales?: Array<GraphQLTypes["ProductCategoryListUpdateLocalesEntityRelationInput"]> | undefined,
	seasonalProductCategoriesOfBusinessCategory?: GraphQLTypes["ProductCategoryListUpdateSeasonalProductCategoriesOfBusinessCategoryEntityRelationInput"] | undefined,
	specificProductsProductCategoriesOfBusinessCategory?: GraphQLTypes["ProductCategoryListUpdateSpecificProductsProductCategoriesOfBusinessCategoryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCategoryListItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["ProductCategoryListWithoutItemsUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductCategoryListWithoutItemsCreateInput"] | undefined
};
	["BusinessCategoryLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	root?: GraphQLTypes["BusinessCategoryLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["BusinessCategoryLocaleCreateLocaleEntityRelationInput"] | undefined,
	title?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessCategoryLocaleUpdateInput"]: {
		name?: string | undefined,
	root?: GraphQLTypes["BusinessCategoryLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["BusinessCategoryLocaleUpdateLocaleEntityRelationInput"] | undefined,
	title?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleConnection"]: {
	__typename: "LocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LocaleEdge"]>
};
	["LocaleEdge"]: {
	__typename: "LocaleEdge",
	node: GraphQLTypes["Locale"]
};
	["LocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	businessCategories?: Array<GraphQLTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleCreateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleCreateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LocaleUpdateInput"]: {
		businessCategories?: Array<GraphQLTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCategoryListLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	root?: GraphQLTypes["ProductCategoryListLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["ProductCategoryListLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductCategoryListLocaleUpdateInput"]: {
		name?: string | undefined,
	root?: GraphQLTypes["ProductCategoryListLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["ProductCategoryListLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerNameConnection"]: {
	__typename: "CustomerNameConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CustomerNameEdge"]>
};
	["CustomerNameEdge"]: {
	__typename: "CustomerNameEdge",
	node: GraphQLTypes["CustomerName"]
};
	["CustomerNameCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	nominative?: string | undefined,
	vocative?: string | undefined,
	customer?: GraphQLTypes["CustomerNameCreateCustomerEntityRelationInput"] | undefined,
	aliases?: Array<GraphQLTypes["CustomerNameCreateAliasesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerNameCreateCustomerEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerWithoutNameCreateInput"] | undefined
};
	["CustomerWithoutNameCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	addresses?: Array<GraphQLTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerCreateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerCreateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerCreatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerCreateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerCreateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerCreateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerCreateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerCreateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerCreateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerNameUpdateInput"]: {
		nominative?: string | undefined,
	vocative?: string | undefined,
	customer?: GraphQLTypes["CustomerNameUpdateCustomerEntityRelationInput"] | undefined,
	aliases?: Array<GraphQLTypes["CustomerNameUpdateAliasesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerNameUpdateCustomerEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerWithoutNameCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerWithoutNameUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CustomerNameUpsertCustomerRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CustomerWithoutNameUpdateInput"]: {
		addresses?: Array<GraphQLTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerUpdateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerUpdateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerUpdateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerNameUpsertCustomerRelationInput"]: {
		update?: GraphQLTypes["CustomerWithoutNameUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerWithoutNameCreateInput"] | undefined
};
	["ProductIngredientItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	internalOrder?: number | undefined,
	recipe?: GraphQLTypes["ProductIngredientItemCreateRecipeEntityRelationInput"] | undefined,
	ingredient?: GraphQLTypes["ProductIngredientItemCreateIngredientEntityRelationInput"] | undefined,
	quantity?: GraphQLTypes["ProductIngredientItemCreateQuantityEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientItemCreateRecipeEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductRecipeUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductRecipeWithoutIngredientsCreateInput"] | undefined
};
	["ProductRecipeWithoutIngredientsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	products?: Array<GraphQLTypes["ProductRecipeCreateProductsEntityRelationInput"]> | undefined,
	internalNote?: string | undefined,
	color?: string | undefined,
	image?: GraphQLTypes["ProductRecipeCreateImageEntityRelationInput"] | undefined,
	icon?: GraphQLTypes["ProductRecipeCreateIconEntityRelationInput"] | undefined,
	needsPrepping?: boolean | undefined,
	locales?: Array<GraphQLTypes["ProductRecipeCreateLocalesEntityRelationInput"]> | undefined,
	gutTuning?: number | undefined,
	freshingContainer?: GraphQLTypes["ProductRecipeCreateFreshingContainerEntityRelationInput"] | undefined,
	description?: string | undefined,
	nutritionFacts?: GraphQLTypes["ProductRecipeCreateNutritionFactsEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientItemUpdateInput"]: {
		order?: number | undefined,
	internalOrder?: number | undefined,
	recipe?: GraphQLTypes["ProductIngredientItemUpdateRecipeEntityRelationInput"] | undefined,
	ingredient?: GraphQLTypes["ProductIngredientItemUpdateIngredientEntityRelationInput"] | undefined,
	quantity?: GraphQLTypes["ProductIngredientItemUpdateQuantityEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientItemUpdateRecipeEntityRelationInput"]: {
		create?: GraphQLTypes["ProductRecipeWithoutIngredientsCreateInput"] | undefined,
	update?: GraphQLTypes["ProductRecipeWithoutIngredientsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductIngredientItemUpsertRecipeRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductRecipeUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["ProductRecipeWithoutIngredientsUpdateInput"]: {
		name?: string | undefined,
	products?: Array<GraphQLTypes["ProductRecipeUpdateProductsEntityRelationInput"]> | undefined,
	internalNote?: string | undefined,
	color?: string | undefined,
	image?: GraphQLTypes["ProductRecipeUpdateImageEntityRelationInput"] | undefined,
	icon?: GraphQLTypes["ProductRecipeUpdateIconEntityRelationInput"] | undefined,
	needsPrepping?: boolean | undefined,
	locales?: Array<GraphQLTypes["ProductRecipeUpdateLocalesEntityRelationInput"]> | undefined,
	gutTuning?: number | undefined,
	freshingContainer?: GraphQLTypes["ProductRecipeUpdateFreshingContainerEntityRelationInput"] | undefined,
	description?: string | undefined,
	nutritionFacts?: GraphQLTypes["ProductRecipeUpdateNutritionFactsEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientItemUpsertRecipeRelationInput"]: {
		update?: GraphQLTypes["ProductRecipeWithoutIngredientsUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductRecipeWithoutIngredientsCreateInput"] | undefined
};
	["ProductIngredientItemQuantityConnection"]: {
	__typename: "ProductIngredientItemQuantityConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductIngredientItemQuantityEdge"]>
};
	["ProductIngredientItemQuantityEdge"]: {
	__typename: "ProductIngredientItemQuantityEdge",
	node: GraphQLTypes["ProductIngredientItemQuantity"]
};
	["ProductIngredientItemQuantityUnitConnection"]: {
	__typename: "ProductIngredientItemQuantityUnitConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductIngredientItemQuantityUnitEdge"]>
};
	["ProductIngredientItemQuantityUnitEdge"]: {
	__typename: "ProductIngredientItemQuantityUnitEdge",
	node: GraphQLTypes["ProductIngredientItemQuantityUnit"]
};
	["CustomerIngredientRatingCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	customer?: GraphQLTypes["CustomerIngredientRatingCreateCustomerEntityRelationInput"] | undefined,
	rating?: GraphQLTypes["CustomerIngredientRatingCreateRatingEntityRelationInput"] | undefined,
	ingredient?: GraphQLTypes["CustomerIngredientRatingCreateIngredientEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerIngredientRatingUpdateInput"]: {
		customer?: GraphQLTypes["CustomerIngredientRatingUpdateCustomerEntityRelationInput"] | undefined,
	rating?: GraphQLTypes["CustomerIngredientRatingUpdateRatingEntityRelationInput"] | undefined,
	ingredient?: GraphQLTypes["CustomerIngredientRatingUpdateIngredientEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientRatingConnection"]: {
	__typename: "ProductIngredientRatingConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductIngredientRatingEdge"]>
};
	["ProductIngredientRatingEdge"]: {
	__typename: "ProductIngredientRatingEdge",
	node: GraphQLTypes["ProductIngredientRating"]
};
	["ProductIngredientLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	root?: GraphQLTypes["ProductIngredientLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["ProductIngredientLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientLocaleUpdateInput"]: {
		name?: string | undefined,
	root?: GraphQLTypes["ProductIngredientLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["ProductIngredientLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderRecurrenceCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	internalName?: string | undefined,
	locales?: Array<GraphQLTypes["OrderRecurrenceCreateLocalesEntityRelationInput"]> | undefined,
	order?: number | undefined,
	businessCategory?: Array<GraphQLTypes["OrderRecurrenceCreateBusinessCategoryEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderRecurrenceUpdateInput"]: {
		internalName?: string | undefined,
	locales?: Array<GraphQLTypes["OrderRecurrenceUpdateLocalesEntityRelationInput"]> | undefined,
	order?: number | undefined,
	businessCategory?: Array<GraphQLTypes["OrderRecurrenceUpdateBusinessCategoryEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderRecurrenceLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	root?: GraphQLTypes["OrderRecurrenceLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["OrderRecurrenceLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderRecurrenceLocaleUpdateInput"]: {
		name?: string | undefined,
	root?: GraphQLTypes["OrderRecurrenceLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["OrderRecurrenceLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessCustomerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	customer?: GraphQLTypes["BusinessCustomerCreateCustomerEntityRelationInput"] | undefined,
	owners?: Array<GraphQLTypes["BusinessCustomerCreateOwnersEntityRelationInput"]> | undefined,
	members?: Array<GraphQLTypes["BusinessCustomerCreateMembersEntityRelationInput"]> | undefined,
	category?: GraphQLTypes["BusinessCustomerCreateCategoryEntityRelationInput"] | undefined,
	accountManager?: GraphQLTypes["BusinessCustomerCreateAccountManagerEntityRelationInput"] | undefined,
	logo?: GraphQLTypes["BusinessCustomerCreateLogoEntityRelationInput"] | undefined,
	note?: string | undefined,
	businessServiceEvents?: Array<GraphQLTypes["BusinessCustomerCreateBusinessServiceEventsEntityRelationInput"]> | undefined,
	doubleshotCoffeeEquipment?: GraphQLTypes["BusinessCustomerCreateDoubleshotCoffeeEquipmentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessCustomerUpdateInput"]: {
		name?: string | undefined,
	customer?: GraphQLTypes["BusinessCustomerUpdateCustomerEntityRelationInput"] | undefined,
	owners?: Array<GraphQLTypes["BusinessCustomerUpdateOwnersEntityRelationInput"]> | undefined,
	members?: Array<GraphQLTypes["BusinessCustomerUpdateMembersEntityRelationInput"]> | undefined,
	category?: GraphQLTypes["BusinessCustomerUpdateCategoryEntityRelationInput"] | undefined,
	accountManager?: GraphQLTypes["BusinessCustomerUpdateAccountManagerEntityRelationInput"] | undefined,
	logo?: GraphQLTypes["BusinessCustomerUpdateLogoEntityRelationInput"] | undefined,
	note?: string | undefined,
	businessServiceEvents?: Array<GraphQLTypes["BusinessCustomerUpdateBusinessServiceEventsEntityRelationInput"]> | undefined,
	doubleshotCoffeeEquipment?: GraphQLTypes["BusinessCustomerUpdateDoubleshotCoffeeEquipmentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	channels?: Array<GraphQLTypes["PointOfSaleCreateChannelsEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["PointOfSaleCreatePermissionsEntityRelationInput"] | undefined,
	tenantPersonId?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleCreateChannelsEntityRelationInput"]: {
		connect?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	create?: GraphQLTypes["ChannelWithoutPointOfSalesCreateInput"] | undefined,
	alias?: string | undefined
};
	["ChannelWithoutPointOfSalesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	disabled?: boolean | undefined,
	payments?: Array<GraphQLTypes["ChannelCreatePaymentsEntityRelationInput"]> | undefined,
	deliveries?: Array<GraphQLTypes["ChannelCreateDeliveriesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["ChannelCreateCartsEntityRelationInput"]> | undefined,
	customers?: Array<GraphQLTypes["ChannelCreateCustomersEntityRelationInput"]> | undefined,
	code?: GraphQLTypes["ChannelCode"] | undefined,
	addTagsOnRegistration?: Array<GraphQLTypes["ChannelCreateAddTagsOnRegistrationEntityRelationInput"]> | undefined,
	publicTags?: Array<GraphQLTypes["ChannelCreatePublicTagsEntityRelationInput"]> | undefined,
	venue?: GraphQLTypes["ChannelCreateVenueEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	channels?: Array<GraphQLTypes["PointOfSaleUpdateChannelsEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["PointOfSaleUpdatePermissionsEntityRelationInput"] | undefined,
	tenantPersonId?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleUpdateChannelsEntityRelationInput"]: {
		create?: GraphQLTypes["ChannelWithoutPointOfSalesCreateInput"] | undefined,
	update?: GraphQLTypes["PointOfSaleUpdateChannelsRelationInput"] | undefined,
	upsert?: GraphQLTypes["PointOfSaleUpsertChannelsRelationInput"] | undefined,
	connect?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PointOfSaleUpdateChannelsRelationInput"]: {
		by?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	data?: GraphQLTypes["ChannelWithoutPointOfSalesUpdateInput"] | undefined
};
	["ChannelWithoutPointOfSalesUpdateInput"]: {
		name?: string | undefined,
	disabled?: boolean | undefined,
	payments?: Array<GraphQLTypes["ChannelUpdatePaymentsEntityRelationInput"]> | undefined,
	deliveries?: Array<GraphQLTypes["ChannelUpdateDeliveriesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["ChannelUpdateCartsEntityRelationInput"]> | undefined,
	customers?: Array<GraphQLTypes["ChannelUpdateCustomersEntityRelationInput"]> | undefined,
	code?: GraphQLTypes["ChannelCode"] | undefined,
	addTagsOnRegistration?: Array<GraphQLTypes["ChannelUpdateAddTagsOnRegistrationEntityRelationInput"]> | undefined,
	publicTags?: Array<GraphQLTypes["ChannelUpdatePublicTagsEntityRelationInput"]> | undefined,
	venue?: GraphQLTypes["ChannelUpdateVenueEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleUpsertChannelsRelationInput"]: {
		by?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	update?: GraphQLTypes["ChannelWithoutPointOfSalesUpdateInput"] | undefined,
	create?: GraphQLTypes["ChannelWithoutPointOfSalesCreateInput"] | undefined
};
	["PointOfSalePermissionsConnection"]: {
	__typename: "PointOfSalePermissionsConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PointOfSalePermissionsEdge"]>
};
	["PointOfSalePermissionsEdge"]: {
	__typename: "PointOfSalePermissionsEdge",
	node: GraphQLTypes["PointOfSalePermissions"]
};
	["BlogConnection"]: {
	__typename: "BlogConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BlogEdge"]>
};
	["BlogEdge"]: {
	__typename: "BlogEdge",
	node: GraphQLTypes["Blog"]
};
	["BlogCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["BlogCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["BlogCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["BlogLocaleWithoutRootCreateInput"] | undefined,
	alias?: string | undefined
};
	["BlogLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	pageName?: string | undefined,
	title?: string | undefined,
	lead?: string | undefined,
	locale?: GraphQLTypes["BlogLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BlogLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutBlogsCreateInput"] | undefined
};
	["LocaleWithoutBlogsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	businessCategories?: Array<GraphQLTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleCreateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleCreateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["BlogUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["BlogUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["BlogUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["BlogLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["BlogUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["BlogUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["BlogLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["BlogLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["BlogLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["BlogUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["BlogLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["BlogLocaleWithoutRootUpdateInput"] | undefined
};
	["BlogLocaleWithoutRootUpdateInput"]: {
		pageName?: string | undefined,
	title?: string | undefined,
	lead?: string | undefined,
	locale?: GraphQLTypes["BlogLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BlogLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutBlogsCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutBlogsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BlogLocaleUpsertLocaleRelationInput"] | undefined,
	connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutBlogsUpdateInput"]: {
		businessCategories?: Array<GraphQLTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["BlogLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutBlogsUpdateInput"] | undefined,
	create?: GraphQLTypes["LocaleWithoutBlogsCreateInput"] | undefined
};
	["BlogUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["BlogLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["BlogLocaleWithoutRootUpdateInput"] | undefined,
	create?: GraphQLTypes["BlogLocaleWithoutRootCreateInput"] | undefined
};
	["BlogLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	pageName?: string | undefined,
	title?: string | undefined,
	lead?: string | undefined,
	root?: GraphQLTypes["BlogLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["BlogLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BlogLocaleUpdateInput"]: {
		pageName?: string | undefined,
	title?: string | undefined,
	lead?: string | undefined,
	root?: GraphQLTypes["BlogLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["BlogLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BlogPostConnection"]: {
	__typename: "BlogPostConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BlogPostEdge"]>
};
	["BlogPostEdge"]: {
	__typename: "BlogPostEdge",
	node: GraphQLTypes["BlogPost"]
};
	["BlogPostCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	locales?: Array<GraphQLTypes["BlogPostCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["BlogPostCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPostLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["BlogPostLocaleWithoutRootCreateInput"] | undefined,
	alias?: string | undefined
};
	["BlogPostLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	availableForWeb?: boolean | undefined,
	availableForMobile?: boolean | undefined,
	locale?: GraphQLTypes["BlogPostLocaleCreateLocaleEntityRelationInput"] | undefined,
	cover?: GraphQLTypes["BlogPostLocaleCreateCoverEntityRelationInput"] | undefined,
	content?: GraphQLTypes["BlogPostLocaleCreateContentEntityRelationInput"] | undefined,
	link?: GraphQLTypes["BlogPostLocaleCreateLinkEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["BlogPostLocaleCreateSeoEntityRelationInput"] | undefined,
	products?: Array<GraphQLTypes["BlogPostLocaleCreateProductsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["BlogPostUpdateInput"]: {
		order?: number | undefined,
	locales?: Array<GraphQLTypes["BlogPostUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["BlogPostUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["BlogPostLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["BlogPostUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["BlogPostUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["BlogPostLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["BlogPostLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["BlogPostLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["BlogPostUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["BlogPostLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["BlogPostLocaleWithoutRootUpdateInput"] | undefined
};
	["BlogPostLocaleWithoutRootUpdateInput"]: {
		title?: string | undefined,
	availableForWeb?: boolean | undefined,
	availableForMobile?: boolean | undefined,
	locale?: GraphQLTypes["BlogPostLocaleUpdateLocaleEntityRelationInput"] | undefined,
	cover?: GraphQLTypes["BlogPostLocaleUpdateCoverEntityRelationInput"] | undefined,
	content?: GraphQLTypes["BlogPostLocaleUpdateContentEntityRelationInput"] | undefined,
	link?: GraphQLTypes["BlogPostLocaleUpdateLinkEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["BlogPostLocaleUpdateSeoEntityRelationInput"] | undefined,
	products?: Array<GraphQLTypes["BlogPostLocaleUpdateProductsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["BlogPostUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["BlogPostLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["BlogPostLocaleWithoutRootUpdateInput"] | undefined,
	create?: GraphQLTypes["BlogPostLocaleWithoutRootCreateInput"] | undefined
};
	["ColorPalleteConnection"]: {
	__typename: "ColorPalleteConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ColorPalleteEdge"]>
};
	["ColorPalleteEdge"]: {
	__typename: "ColorPalleteEdge",
	node: GraphQLTypes["ColorPallete"]
};
	["ContentConnection"]: {
	__typename: "ContentConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentEdge"]>
};
	["ContentEdge"]: {
	__typename: "ContentEdge",
	node: GraphQLTypes["Content"]
};
	["ContentBlockCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	json?: string | undefined,
	content?: GraphQLTypes["ContentBlockCreateContentEntityRelationInput"] | undefined,
	references?: Array<GraphQLTypes["ContentBlockCreateReferencesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentBlockCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentWithoutBlocksCreateInput"] | undefined
};
	["ContentWithoutBlocksCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentBlockUpdateInput"]: {
		order?: number | undefined,
	json?: string | undefined,
	content?: GraphQLTypes["ContentBlockUpdateContentEntityRelationInput"] | undefined,
	references?: Array<GraphQLTypes["ContentBlockUpdateReferencesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentBlockUpdateContentEntityRelationInput"]: {
		create?: GraphQLTypes["ContentWithoutBlocksCreateInput"] | undefined,
	update?: GraphQLTypes["ContentWithoutBlocksUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentBlockUpsertContentRelationInput"] | undefined,
	connect?: GraphQLTypes["ContentUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["ContentWithoutBlocksUpdateInput"]: {
		_dummy_field_?: boolean | undefined
};
	["ContentBlockUpsertContentRelationInput"]: {
		update?: GraphQLTypes["ContentWithoutBlocksUpdateInput"] | undefined,
	create?: GraphQLTypes["ContentWithoutBlocksCreateInput"] | undefined
};
	["ContentReferenceCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["ContentReferenceType"] | undefined,
	primaryText?: string | undefined,
	secondaryText?: string | undefined,
	jsonContent?: string | undefined,
	block?: GraphQLTypes["ContentReferenceCreateBlockEntityRelationInput"] | undefined,
	colorPallete?: GraphQLTypes["ContentReferenceCreateColorPalleteEntityRelationInput"] | undefined,
	medium?: GraphQLTypes["ContentReferenceCreateMediumEntityRelationInput"] | undefined,
	link?: GraphQLTypes["ContentReferenceCreateLinkEntityRelationInput"] | undefined,
	blogPosts?: GraphQLTypes["ContentReferenceCreateBlogPostsEntityRelationInput"] | undefined,
	links?: GraphQLTypes["ContentReferenceCreateLinksEntityRelationInput"] | undefined,
	products?: GraphQLTypes["ContentReferenceCreateProductsEntityRelationInput"] | undefined,
	contentSize?: GraphQLTypes["ContentSize"] | undefined,
	misc?: string | undefined,
	hero?: GraphQLTypes["ContentReferenceCreateHeroEntityRelationInput"] | undefined,
	gallery?: GraphQLTypes["ContentReferenceCreateGalleryEntityRelationInput"] | undefined,
	socialsAndApps?: GraphQLTypes["ContentReferenceCreateSocialsAndAppsEntityRelationInput"] | undefined,
	productGrid?: GraphQLTypes["ContentReferenceCreateProductGridEntityRelationInput"] | undefined,
	productBanners?: GraphQLTypes["ContentReferenceCreateProductBannersEntityRelationInput"] | undefined,
	deliveryRegions?: GraphQLTypes["ContentReferenceCreateDeliveryRegionsEntityRelationInput"] | undefined,
	textList?: GraphQLTypes["ContentReferenceCreateTextListEntityRelationInput"] | undefined,
	gridTiles?: GraphQLTypes["ContentReferenceCreateGridTilesEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentReferenceCreateBlockEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentBlockUniqueWhere"] | undefined,
	create?: GraphQLTypes["ContentBlockWithoutReferencesCreateInput"] | undefined
};
	["ContentBlockWithoutReferencesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	json?: string | undefined,
	content?: GraphQLTypes["ContentBlockCreateContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentReferenceUpdateInput"]: {
		type?: GraphQLTypes["ContentReferenceType"] | undefined,
	primaryText?: string | undefined,
	secondaryText?: string | undefined,
	jsonContent?: string | undefined,
	block?: GraphQLTypes["ContentReferenceUpdateBlockEntityRelationInput"] | undefined,
	colorPallete?: GraphQLTypes["ContentReferenceUpdateColorPalleteEntityRelationInput"] | undefined,
	medium?: GraphQLTypes["ContentReferenceUpdateMediumEntityRelationInput"] | undefined,
	link?: GraphQLTypes["ContentReferenceUpdateLinkEntityRelationInput"] | undefined,
	blogPosts?: GraphQLTypes["ContentReferenceUpdateBlogPostsEntityRelationInput"] | undefined,
	links?: GraphQLTypes["ContentReferenceUpdateLinksEntityRelationInput"] | undefined,
	products?: GraphQLTypes["ContentReferenceUpdateProductsEntityRelationInput"] | undefined,
	contentSize?: GraphQLTypes["ContentSize"] | undefined,
	misc?: string | undefined,
	hero?: GraphQLTypes["ContentReferenceUpdateHeroEntityRelationInput"] | undefined,
	gallery?: GraphQLTypes["ContentReferenceUpdateGalleryEntityRelationInput"] | undefined,
	socialsAndApps?: GraphQLTypes["ContentReferenceUpdateSocialsAndAppsEntityRelationInput"] | undefined,
	productGrid?: GraphQLTypes["ContentReferenceUpdateProductGridEntityRelationInput"] | undefined,
	productBanners?: GraphQLTypes["ContentReferenceUpdateProductBannersEntityRelationInput"] | undefined,
	deliveryRegions?: GraphQLTypes["ContentReferenceUpdateDeliveryRegionsEntityRelationInput"] | undefined,
	textList?: GraphQLTypes["ContentReferenceUpdateTextListEntityRelationInput"] | undefined,
	gridTiles?: GraphQLTypes["ContentReferenceUpdateGridTilesEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentReferenceUpdateBlockEntityRelationInput"]: {
		create?: GraphQLTypes["ContentBlockWithoutReferencesCreateInput"] | undefined,
	update?: GraphQLTypes["ContentBlockWithoutReferencesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ContentReferenceUpsertBlockRelationInput"] | undefined,
	connect?: GraphQLTypes["ContentBlockUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["ContentBlockWithoutReferencesUpdateInput"]: {
		order?: number | undefined,
	json?: string | undefined,
	content?: GraphQLTypes["ContentBlockUpdateContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ContentReferenceUpsertBlockRelationInput"]: {
		update?: GraphQLTypes["ContentBlockWithoutReferencesUpdateInput"] | undefined,
	create?: GraphQLTypes["ContentBlockWithoutReferencesCreateInput"] | undefined
};
	["BlogPostListConnection"]: {
	__typename: "BlogPostListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BlogPostListEdge"]>
};
	["BlogPostListEdge"]: {
	__typename: "BlogPostListEdge",
	node: GraphQLTypes["BlogPostList"]
};
	["BlogPostListItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	caption?: string | undefined,
	list?: GraphQLTypes["BlogPostListItemCreateListEntityRelationInput"] | undefined,
	blogPost?: GraphQLTypes["BlogPostListItemCreateBlogPostEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BlogPostListItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPostListUniqueWhere"] | undefined,
	create?: GraphQLTypes["BlogPostListWithoutItemsCreateInput"] | undefined
};
	["BlogPostListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BlogPostListItemUpdateInput"]: {
		order?: number | undefined,
	caption?: string | undefined,
	list?: GraphQLTypes["BlogPostListItemUpdateListEntityRelationInput"] | undefined,
	blogPost?: GraphQLTypes["BlogPostListItemUpdateBlogPostEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BlogPostListItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["BlogPostListWithoutItemsCreateInput"] | undefined,
	update?: GraphQLTypes["BlogPostListWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BlogPostListItemUpsertListRelationInput"] | undefined,
	connect?: GraphQLTypes["BlogPostListUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["BlogPostListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean | undefined
};
	["BlogPostListItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["BlogPostListWithoutItemsUpdateInput"] | undefined,
	create?: GraphQLTypes["BlogPostListWithoutItemsCreateInput"] | undefined
};
	["LinkListConnection"]: {
	__typename: "LinkListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkListEdge"]>
};
	["LinkListEdge"]: {
	__typename: "LinkListEdge",
	node: GraphQLTypes["LinkList"]
};
	["LinkListItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	isPrimary?: boolean | undefined,
	list?: GraphQLTypes["LinkListItemCreateListEntityRelationInput"] | undefined,
	link?: GraphQLTypes["LinkListItemCreateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkListItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkListUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkListWithoutItemsCreateInput"] | undefined
};
	["LinkListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkListItemUpdateInput"]: {
		order?: number | undefined,
	isPrimary?: boolean | undefined,
	list?: GraphQLTypes["LinkListItemUpdateListEntityRelationInput"] | undefined,
	link?: GraphQLTypes["LinkListItemUpdateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LinkListItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["LinkListWithoutItemsCreateInput"] | undefined,
	update?: GraphQLTypes["LinkListWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["LinkListItemUpsertListRelationInput"] | undefined,
	connect?: GraphQLTypes["LinkListUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["LinkListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean | undefined
};
	["LinkListItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["LinkListWithoutItemsUpdateInput"] | undefined,
	create?: GraphQLTypes["LinkListWithoutItemsCreateInput"] | undefined
};
	["CoverConnection"]: {
	__typename: "CoverConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CoverEdge"]>
};
	["CoverEdge"]: {
	__typename: "CoverEdge",
	node: GraphQLTypes["Cover"]
};
	["LinkConnection"]: {
	__typename: "LinkConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkEdge"]>
};
	["LinkEdge"]: {
	__typename: "LinkEdge",
	node: GraphQLTypes["Link"]
};
	["LinkableConnection"]: {
	__typename: "LinkableConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkableEdge"]>
};
	["LinkableEdge"]: {
	__typename: "LinkableEdge",
	node: GraphQLTypes["Linkable"]
};
	["MediumConnection"]: {
	__typename: "MediumConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MediumEdge"]>
};
	["MediumEdge"]: {
	__typename: "MediumEdge",
	node: GraphQLTypes["Medium"]
};
	["VideoConnection"]: {
	__typename: "VideoConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["VideoEdge"]>
};
	["VideoEdge"]: {
	__typename: "VideoEdge",
	node: GraphQLTypes["Video"]
};
	["SeoConnection"]: {
	__typename: "SeoConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SeoEdge"]>
};
	["SeoEdge"]: {
	__typename: "SeoEdge",
	node: GraphQLTypes["Seo"]
};
	["ProtectedImage"]: {
	__typename: "ProtectedImage",
	_meta?: GraphQLTypes["ProtectedImageMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	url: string,
	width?: number | undefined,
	height?: number | undefined,
	size?: number | undefined,
	type?: string | undefined,
	alt?: string | undefined
};
	["ProtectedImageMeta"]: {
	__typename: "ProtectedImageMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	url?: GraphQLTypes["FieldMeta"] | undefined,
	width?: GraphQLTypes["FieldMeta"] | undefined,
	height?: GraphQLTypes["FieldMeta"] | undefined,
	size?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	alt?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProtectedImageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["ProtectedImageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	url?: GraphQLTypes["StringCondition"] | undefined,
	width?: GraphQLTypes["IntCondition"] | undefined,
	height?: GraphQLTypes["IntCondition"] | undefined,
	size?: GraphQLTypes["IntCondition"] | undefined,
	type?: GraphQLTypes["StringCondition"] | undefined,
	alt?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["ProtectedImageWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ProtectedImageWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ProtectedImageWhere"] | undefined
};
	["ProtectedImageOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	url?: GraphQLTypes["OrderDirection"] | undefined,
	width?: GraphQLTypes["OrderDirection"] | undefined,
	height?: GraphQLTypes["OrderDirection"] | undefined,
	size?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	alt?: GraphQLTypes["OrderDirection"] | undefined
};
	["ProtectedImageConnection"]: {
	__typename: "ProtectedImageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProtectedImageEdge"]>
};
	["ProtectedImageEdge"]: {
	__typename: "ProtectedImageEdge",
	node: GraphQLTypes["ProtectedImage"]
};
	["ProtectedImageCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	url?: string | undefined,
	width?: number | undefined,
	height?: number | undefined,
	size?: number | undefined,
	type?: string | undefined,
	alt?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProtectedImageUpdateInput"]: {
		url?: string | undefined,
	width?: number | undefined,
	height?: number | undefined,
	size?: number | undefined,
	type?: string | undefined,
	alt?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationDomainConnection"]: {
	__typename: "TranslationDomainConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TranslationDomainEdge"]>
};
	["TranslationDomainEdge"]: {
	__typename: "TranslationDomainEdge",
	node: GraphQLTypes["TranslationDomain"]
};
	["TranslationDomainCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	identifier?: string | undefined,
	name?: string | undefined,
	catalogues?: Array<GraphQLTypes["TranslationDomainCreateCataloguesEntityRelationInput"]> | undefined,
	keys?: Array<GraphQLTypes["TranslationDomainCreateKeysEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationDomainUpdateInput"]: {
		identifier?: string | undefined,
	name?: string | undefined,
	catalogues?: Array<GraphQLTypes["TranslationDomainUpdateCataloguesEntityRelationInput"]> | undefined,
	keys?: Array<GraphQLTypes["TranslationDomainUpdateKeysEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationKeyCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	identifier?: string | undefined,
	contentType?: GraphQLTypes["TranslationContentType"] | undefined,
	note?: string | undefined,
	domain?: GraphQLTypes["TranslationKeyCreateDomainEntityRelationInput"] | undefined,
	values?: Array<GraphQLTypes["TranslationKeyCreateValuesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationKeyUpdateInput"]: {
		identifier?: string | undefined,
	contentType?: GraphQLTypes["TranslationContentType"] | undefined,
	note?: string | undefined,
	domain?: GraphQLTypes["TranslationKeyUpdateDomainEntityRelationInput"] | undefined,
	values?: Array<GraphQLTypes["TranslationKeyUpdateValuesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationValueCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	value?: string | undefined,
	catalogue?: GraphQLTypes["TranslationValueCreateCatalogueEntityRelationInput"] | undefined,
	key?: GraphQLTypes["TranslationValueCreateKeyEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationValueUpdateInput"]: {
		value?: string | undefined,
	catalogue?: GraphQLTypes["TranslationValueUpdateCatalogueEntityRelationInput"] | undefined,
	key?: GraphQLTypes["TranslationValueUpdateKeyEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TranslationCataloguesIdentifierConnection"]: {
	__typename: "TranslationCataloguesIdentifierConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TranslationCataloguesIdentifierEdge"]>
};
	["TranslationCataloguesIdentifierEdge"]: {
	__typename: "TranslationCataloguesIdentifierEdge",
	node: GraphQLTypes["TranslationCataloguesIdentifier"]
};
	["SocialsAndAppsConnection"]: {
	__typename: "SocialsAndAppsConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SocialsAndAppsEdge"]>
};
	["SocialsAndAppsEdge"]: {
	__typename: "SocialsAndAppsEdge",
	node: GraphQLTypes["SocialsAndApps"]
};
	["ProductGridConnection"]: {
	__typename: "ProductGridConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductGridEdge"]>
};
	["ProductGridEdge"]: {
	__typename: "ProductGridEdge",
	node: GraphQLTypes["ProductGrid"]
};
	["ProductGridItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	title?: string | undefined,
	lead?: string | undefined,
	product?: GraphQLTypes["ProductGridItemCreateProductEntityRelationInput"] | undefined,
	medium?: GraphQLTypes["ProductGridItemCreateMediumEntityRelationInput"] | undefined,
	link?: GraphQLTypes["ProductGridItemCreateLinkEntityRelationInput"] | undefined,
	category?: GraphQLTypes["ProductGridItemCreateCategoryEntityRelationInput"] | undefined,
	description?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductGridItemCreateCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductGridCategoryUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductGridCategoryWithoutItemsCreateInput"] | undefined
};
	["ProductGridCategoryWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	title?: string | undefined,
	root?: GraphQLTypes["ProductGridCategoryCreateRootEntityRelationInput"] | undefined,
	images?: GraphQLTypes["ProductGridCategoryCreateImagesEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductGridCategoryCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductGridUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductGridWithoutCategoriesCreateInput"] | undefined
};
	["ProductGridWithoutCategoriesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	isCarousel?: boolean | undefined,
	type?: GraphQLTypes["ProductGridType"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductGridItemUpdateInput"]: {
		order?: number | undefined,
	title?: string | undefined,
	lead?: string | undefined,
	product?: GraphQLTypes["ProductGridItemUpdateProductEntityRelationInput"] | undefined,
	medium?: GraphQLTypes["ProductGridItemUpdateMediumEntityRelationInput"] | undefined,
	link?: GraphQLTypes["ProductGridItemUpdateLinkEntityRelationInput"] | undefined,
	category?: GraphQLTypes["ProductGridItemUpdateCategoryEntityRelationInput"] | undefined,
	description?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductGridItemUpdateCategoryEntityRelationInput"]: {
		create?: GraphQLTypes["ProductGridCategoryWithoutItemsCreateInput"] | undefined,
	update?: GraphQLTypes["ProductGridCategoryWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductGridItemUpsertCategoryRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductGridCategoryUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProductGridCategoryWithoutItemsUpdateInput"]: {
		order?: number | undefined,
	title?: string | undefined,
	root?: GraphQLTypes["ProductGridCategoryUpdateRootEntityRelationInput"] | undefined,
	images?: GraphQLTypes["ProductGridCategoryUpdateImagesEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductGridCategoryUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["ProductGridWithoutCategoriesCreateInput"] | undefined,
	update?: GraphQLTypes["ProductGridWithoutCategoriesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductGridCategoryUpsertRootRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductGridUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["ProductGridWithoutCategoriesUpdateInput"]: {
		isCarousel?: boolean | undefined,
	type?: GraphQLTypes["ProductGridType"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductGridCategoryUpsertRootRelationInput"]: {
		update?: GraphQLTypes["ProductGridWithoutCategoriesUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductGridWithoutCategoriesCreateInput"] | undefined
};
	["ProductGridItemUpsertCategoryRelationInput"]: {
		update?: GraphQLTypes["ProductGridCategoryWithoutItemsUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductGridCategoryWithoutItemsCreateInput"] | undefined
};
	["GalleryConnection"]: {
	__typename: "GalleryConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GalleryEdge"]>
};
	["GalleryEdge"]: {
	__typename: "GalleryEdge",
	node: GraphQLTypes["Gallery"]
};
	["GalleryItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	caption?: string | undefined,
	list?: GraphQLTypes["GalleryItemCreateListEntityRelationInput"] | undefined,
	medium?: GraphQLTypes["GalleryItemCreateMediumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GalleryItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["GalleryUniqueWhere"] | undefined,
	create?: GraphQLTypes["GalleryWithoutItemsCreateInput"] | undefined
};
	["GalleryWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GalleryItemUpdateInput"]: {
		order?: number | undefined,
	caption?: string | undefined,
	list?: GraphQLTypes["GalleryItemUpdateListEntityRelationInput"] | undefined,
	medium?: GraphQLTypes["GalleryItemUpdateMediumEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GalleryItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["GalleryWithoutItemsCreateInput"] | undefined,
	update?: GraphQLTypes["GalleryWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GalleryItemUpsertListRelationInput"] | undefined,
	connect?: GraphQLTypes["GalleryUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["GalleryWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean | undefined
};
	["GalleryItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["GalleryWithoutItemsUpdateInput"] | undefined,
	create?: GraphQLTypes["GalleryWithoutItemsCreateInput"] | undefined
};
	["HeroConnection"]: {
	__typename: "HeroConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["HeroEdge"]>
};
	["HeroEdge"]: {
	__typename: "HeroEdge",
	node: GraphQLTypes["Hero"]
};
	["SiteMenuConnection"]: {
	__typename: "SiteMenuConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SiteMenuEdge"]>
};
	["SiteMenuEdge"]: {
	__typename: "SiteMenuEdge",
	node: GraphQLTypes["SiteMenu"]
};
	["SiteMenuCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["SiteMenuCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["SiteMenuCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["MenuLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["MenuLocaleWithoutRootCreateInput"] | undefined,
	alias?: string | undefined
};
	["MenuLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locale?: GraphQLTypes["MenuLocaleCreateLocaleEntityRelationInput"] | undefined,
	items?: Array<GraphQLTypes["MenuLocaleCreateItemsEntityRelationInput"]> | undefined,
	secondaryItems?: GraphQLTypes["MenuLocaleCreateSecondaryItemsEntityRelationInput"] | undefined,
	eshopLink?: GraphQLTypes["MenuLocaleCreateEshopLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MenuLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutMenusCreateInput"] | undefined
};
	["LocaleWithoutMenusCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	businessCategories?: Array<GraphQLTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleCreateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleCreateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["SiteMenuUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	locales?: Array<GraphQLTypes["SiteMenuUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["SiteMenuUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["MenuLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["SiteMenuUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["SiteMenuUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["MenuLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["MenuLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["MenuLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["SiteMenuUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["MenuLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["MenuLocaleWithoutRootUpdateInput"] | undefined
};
	["MenuLocaleWithoutRootUpdateInput"]: {
		locale?: GraphQLTypes["MenuLocaleUpdateLocaleEntityRelationInput"] | undefined,
	items?: Array<GraphQLTypes["MenuLocaleUpdateItemsEntityRelationInput"]> | undefined,
	secondaryItems?: GraphQLTypes["MenuLocaleUpdateSecondaryItemsEntityRelationInput"] | undefined,
	eshopLink?: GraphQLTypes["MenuLocaleUpdateEshopLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MenuLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutMenusCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutMenusUpdateInput"] | undefined,
	upsert?: GraphQLTypes["MenuLocaleUpsertLocaleRelationInput"] | undefined,
	connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutMenusUpdateInput"]: {
		businessCategories?: Array<GraphQLTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined,
	subscriptionBoxes?: Array<GraphQLTypes["LocaleUpdateSubscriptionBoxesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["MenuLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutMenusUpdateInput"] | undefined,
	create?: GraphQLTypes["LocaleWithoutMenusCreateInput"] | undefined
};
	["SiteMenuUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["MenuLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["MenuLocaleWithoutRootUpdateInput"] | undefined,
	create?: GraphQLTypes["MenuLocaleWithoutRootCreateInput"] | undefined
};
	["MenuLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["MenuLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["MenuLocaleCreateLocaleEntityRelationInput"] | undefined,
	items?: Array<GraphQLTypes["MenuLocaleCreateItemsEntityRelationInput"]> | undefined,
	secondaryItems?: GraphQLTypes["MenuLocaleCreateSecondaryItemsEntityRelationInput"] | undefined,
	eshopLink?: GraphQLTypes["MenuLocaleCreateEshopLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MenuLocaleUpdateInput"]: {
		root?: GraphQLTypes["MenuLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["MenuLocaleUpdateLocaleEntityRelationInput"] | undefined,
	items?: Array<GraphQLTypes["MenuLocaleUpdateItemsEntityRelationInput"]> | undefined,
	secondaryItems?: GraphQLTypes["MenuLocaleUpdateSecondaryItemsEntityRelationInput"] | undefined,
	eshopLink?: GraphQLTypes["MenuLocaleUpdateEshopLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MenuItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	menu?: GraphQLTypes["MenuItemCreateMenuEntityRelationInput"] | undefined,
	link?: GraphQLTypes["MenuItemCreateLinkEntityRelationInput"] | undefined,
	subitems?: Array<GraphQLTypes["MenuItemCreateSubitemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["MenuItemCreateMenuEntityRelationInput"]: {
		connect?: GraphQLTypes["MenuLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["MenuLocaleWithoutItemsCreateInput"] | undefined
};
	["MenuLocaleWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	root?: GraphQLTypes["MenuLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["MenuLocaleCreateLocaleEntityRelationInput"] | undefined,
	secondaryItems?: GraphQLTypes["MenuLocaleCreateSecondaryItemsEntityRelationInput"] | undefined,
	eshopLink?: GraphQLTypes["MenuLocaleCreateEshopLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MenuItemUpdateInput"]: {
		order?: number | undefined,
	menu?: GraphQLTypes["MenuItemUpdateMenuEntityRelationInput"] | undefined,
	link?: GraphQLTypes["MenuItemUpdateLinkEntityRelationInput"] | undefined,
	subitems?: Array<GraphQLTypes["MenuItemUpdateSubitemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["MenuItemUpdateMenuEntityRelationInput"]: {
		create?: GraphQLTypes["MenuLocaleWithoutItemsCreateInput"] | undefined,
	update?: GraphQLTypes["MenuLocaleWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["MenuItemUpsertMenuRelationInput"] | undefined,
	connect?: GraphQLTypes["MenuLocaleUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["MenuLocaleWithoutItemsUpdateInput"]: {
		root?: GraphQLTypes["MenuLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["MenuLocaleUpdateLocaleEntityRelationInput"] | undefined,
	secondaryItems?: GraphQLTypes["MenuLocaleUpdateSecondaryItemsEntityRelationInput"] | undefined,
	eshopLink?: GraphQLTypes["MenuLocaleUpdateEshopLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MenuItemUpsertMenuRelationInput"]: {
		update?: GraphQLTypes["MenuLocaleWithoutItemsUpdateInput"] | undefined,
	create?: GraphQLTypes["MenuLocaleWithoutItemsCreateInput"] | undefined
};
	["PageConnection"]: {
	__typename: "PageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PageEdge"]>
};
	["PageEdge"]: {
	__typename: "PageEdge",
	node: GraphQLTypes["Page"]
};
	["PageLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	link?: GraphQLTypes["PageLocaleCreateLinkEntityRelationInput"] | undefined,
	root?: GraphQLTypes["PageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["PageLocaleCreateLocaleEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["PageLocaleCreateSeoEntityRelationInput"] | undefined,
	content?: GraphQLTypes["PageLocaleCreateContentEntityRelationInput"] | undefined,
	cover?: GraphQLTypes["PageLocaleCreateCoverEntityRelationInput"] | undefined,
	theme?: GraphQLTypes["PageTheme"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PageLocaleUpdateInput"]: {
		title?: string | undefined,
	link?: GraphQLTypes["PageLocaleUpdateLinkEntityRelationInput"] | undefined,
	root?: GraphQLTypes["PageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["PageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	seo?: GraphQLTypes["PageLocaleUpdateSeoEntityRelationInput"] | undefined,
	content?: GraphQLTypes["PageLocaleUpdateContentEntityRelationInput"] | undefined,
	cover?: GraphQLTypes["PageLocaleUpdateCoverEntityRelationInput"] | undefined,
	theme?: GraphQLTypes["PageTheme"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["WikiPageCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	title?: string | undefined,
	emoji?: string | undefined,
	link?: GraphQLTypes["WikiPageCreateLinkEntityRelationInput"] | undefined,
	parent?: GraphQLTypes["WikiPageCreateParentEntityRelationInput"] | undefined,
	children?: Array<GraphQLTypes["WikiPageCreateChildrenEntityRelationInput"]> | undefined,
	content?: GraphQLTypes["WikiPageCreateContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["WikiPageUpdateInput"]: {
		order?: number | undefined,
	title?: string | undefined,
	emoji?: string | undefined,
	link?: GraphQLTypes["WikiPageUpdateLinkEntityRelationInput"] | undefined,
	parent?: GraphQLTypes["WikiPageUpdateParentEntityRelationInput"] | undefined,
	children?: Array<GraphQLTypes["WikiPageUpdateChildrenEntityRelationInput"]> | undefined,
	content?: GraphQLTypes["WikiPageUpdateContentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MenuSubitemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["MenuSubitemType"] | undefined,
	title?: string | undefined,
	item?: GraphQLTypes["MenuSubitemCreateItemEntityRelationInput"] | undefined,
	links?: GraphQLTypes["MenuSubitemCreateLinksEntityRelationInput"] | undefined,
	products?: GraphQLTypes["MenuSubitemCreateProductsEntityRelationInput"] | undefined,
	delivery?: GraphQLTypes["MenuSubitemCreateDeliveryEntityRelationInput"] | undefined,
	contact?: GraphQLTypes["MenuSubitemCreateContactEntityRelationInput"] | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["MenuSubitemCreateItemEntityRelationInput"]: {
		connect?: GraphQLTypes["MenuItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["MenuItemWithoutSubitemsCreateInput"] | undefined
};
	["MenuItemWithoutSubitemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	menu?: GraphQLTypes["MenuItemCreateMenuEntityRelationInput"] | undefined,
	link?: GraphQLTypes["MenuItemCreateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MenuSubitemUpdateInput"]: {
		type?: GraphQLTypes["MenuSubitemType"] | undefined,
	title?: string | undefined,
	item?: GraphQLTypes["MenuSubitemUpdateItemEntityRelationInput"] | undefined,
	links?: GraphQLTypes["MenuSubitemUpdateLinksEntityRelationInput"] | undefined,
	products?: GraphQLTypes["MenuSubitemUpdateProductsEntityRelationInput"] | undefined,
	delivery?: GraphQLTypes["MenuSubitemUpdateDeliveryEntityRelationInput"] | undefined,
	contact?: GraphQLTypes["MenuSubitemUpdateContactEntityRelationInput"] | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["MenuSubitemUpdateItemEntityRelationInput"]: {
		create?: GraphQLTypes["MenuItemWithoutSubitemsCreateInput"] | undefined,
	update?: GraphQLTypes["MenuItemWithoutSubitemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["MenuSubitemUpsertItemRelationInput"] | undefined,
	connect?: GraphQLTypes["MenuItemUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["MenuItemWithoutSubitemsUpdateInput"]: {
		order?: number | undefined,
	menu?: GraphQLTypes["MenuItemUpdateMenuEntityRelationInput"] | undefined,
	link?: GraphQLTypes["MenuItemUpdateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MenuSubitemUpsertItemRelationInput"]: {
		update?: GraphQLTypes["MenuItemWithoutSubitemsUpdateInput"] | undefined,
	create?: GraphQLTypes["MenuItemWithoutSubitemsCreateInput"] | undefined
};
	["MenuLinkListConnection"]: {
	__typename: "MenuLinkListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MenuLinkListEdge"]>
};
	["MenuLinkListEdge"]: {
	__typename: "MenuLinkListEdge",
	node: GraphQLTypes["MenuLinkList"]
};
	["MenuLinkItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	list?: GraphQLTypes["MenuLinkItemCreateListEntityRelationInput"] | undefined,
	link?: GraphQLTypes["MenuLinkItemCreateLinkEntityRelationInput"] | undefined,
	image?: GraphQLTypes["MenuLinkItemCreateImageEntityRelationInput"] | undefined,
	description?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["MenuLinkItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["MenuLinkListUniqueWhere"] | undefined,
	create?: GraphQLTypes["MenuLinkListWithoutItemsCreateInput"] | undefined
};
	["MenuLinkListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["MenuLinkItemUpdateInput"]: {
		order?: number | undefined,
	list?: GraphQLTypes["MenuLinkItemUpdateListEntityRelationInput"] | undefined,
	link?: GraphQLTypes["MenuLinkItemUpdateLinkEntityRelationInput"] | undefined,
	image?: GraphQLTypes["MenuLinkItemUpdateImageEntityRelationInput"] | undefined,
	description?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["MenuLinkItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["MenuLinkListWithoutItemsCreateInput"] | undefined,
	update?: GraphQLTypes["MenuLinkListWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["MenuLinkItemUpsertListRelationInput"] | undefined,
	connect?: GraphQLTypes["MenuLinkListUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["MenuLinkListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean | undefined
};
	["MenuLinkItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["MenuLinkListWithoutItemsUpdateInput"] | undefined,
	create?: GraphQLTypes["MenuLinkListWithoutItemsCreateInput"] | undefined
};
	["MenuProductsConnection"]: {
	__typename: "MenuProductsConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MenuProductsEdge"]>
};
	["MenuProductsEdge"]: {
	__typename: "MenuProductsEdge",
	node: GraphQLTypes["MenuProducts"]
};
	["MenuDeliveryConnection"]: {
	__typename: "MenuDeliveryConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MenuDeliveryEdge"]>
};
	["MenuDeliveryEdge"]: {
	__typename: "MenuDeliveryEdge",
	node: GraphQLTypes["MenuDelivery"]
};
	["MenuContactConnection"]: {
	__typename: "MenuContactConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MenuContactEdge"]>
};
	["MenuContactEdge"]: {
	__typename: "MenuContactEdge",
	node: GraphQLTypes["MenuContact"]
};
	["DeadlineTemplateConnection"]: {
	__typename: "DeadlineTemplateConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DeadlineTemplateEdge"]>
};
	["DeadlineTemplateEdge"]: {
	__typename: "DeadlineTemplateEdge",
	node: GraphQLTypes["DeadlineTemplate"]
};
	["DeadlineTemplateCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	startDate?: GraphQLTypes["Date"] | undefined,
	period?: number | undefined,
	cutoff?: number | undefined,
	closed?: boolean | undefined,
	venue?: GraphQLTypes["DeadlineTemplateCreateVenueEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeadlineTemplateCreateVenueEntityRelationInput"]: {
		connect?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	create?: GraphQLTypes["VenueWithoutDeadlineTemplateCreateInput"] | undefined
};
	["VenueWithoutDeadlineTemplateCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	timetableDays?: Array<GraphQLTypes["VenueCreateTimetableDaysEntityRelationInput"]> | undefined,
	timetableTemplates?: Array<GraphQLTypes["VenueCreateTimetableTemplatesEntityRelationInput"]> | undefined,
	staffMembers?: Array<GraphQLTypes["VenueCreateStaffMembersEntityRelationInput"]> | undefined,
	employeeRoles?: Array<GraphQLTypes["VenueCreateEmployeeRolesEntityRelationInput"]> | undefined,
	pointOfSaleApplicationDevices?: Array<GraphQLTypes["VenueCreatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined,
	pointOfSaleTerminals?: Array<GraphQLTypes["VenueCreatePointOfSaleTerminalsEntityRelationInput"]> | undefined,
	pointOfSalePrinters?: Array<GraphQLTypes["VenueCreatePointOfSalePrintersEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["VenueCreateOrdersEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["VenueCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	areas?: Array<GraphQLTypes["VenueCreateAreasEntityRelationInput"]> | undefined,
	enabledUnassignReasons?: Array<GraphQLTypes["VenueCreateEnabledUnassignReasonsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["VenueCreateCategoriesEntityRelationInput"]> | undefined,
	channels?: Array<GraphQLTypes["VenueCreateChannelsEntityRelationInput"]> | undefined,
	address?: string | undefined,
	pointOfSalePngBase64ReceiptLogo?: string | undefined,
	pointOfSaleInitialView?: GraphQLTypes["PointOfSaleInitialView"] | undefined,
	pointOfSalePreferPrintReceipt?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeadlineTemplateUpdateInput"]: {
		startDate?: GraphQLTypes["Date"] | undefined,
	period?: number | undefined,
	cutoff?: number | undefined,
	closed?: boolean | undefined,
	venue?: GraphQLTypes["DeadlineTemplateUpdateVenueEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeadlineTemplateUpdateVenueEntityRelationInput"]: {
		create?: GraphQLTypes["VenueWithoutDeadlineTemplateCreateInput"] | undefined,
	update?: GraphQLTypes["VenueWithoutDeadlineTemplateUpdateInput"] | undefined,
	upsert?: GraphQLTypes["DeadlineTemplateUpsertVenueRelationInput"] | undefined,
	connect?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["VenueWithoutDeadlineTemplateUpdateInput"]: {
		name?: string | undefined,
	timetableDays?: Array<GraphQLTypes["VenueUpdateTimetableDaysEntityRelationInput"]> | undefined,
	timetableTemplates?: Array<GraphQLTypes["VenueUpdateTimetableTemplatesEntityRelationInput"]> | undefined,
	staffMembers?: Array<GraphQLTypes["VenueUpdateStaffMembersEntityRelationInput"]> | undefined,
	employeeRoles?: Array<GraphQLTypes["VenueUpdateEmployeeRolesEntityRelationInput"]> | undefined,
	pointOfSaleApplicationDevices?: Array<GraphQLTypes["VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined,
	pointOfSaleTerminals?: Array<GraphQLTypes["VenueUpdatePointOfSaleTerminalsEntityRelationInput"]> | undefined,
	pointOfSalePrinters?: Array<GraphQLTypes["VenueUpdatePointOfSalePrintersEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["VenueUpdateOrdersEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["VenueUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	areas?: Array<GraphQLTypes["VenueUpdateAreasEntityRelationInput"]> | undefined,
	enabledUnassignReasons?: Array<GraphQLTypes["VenueUpdateEnabledUnassignReasonsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["VenueUpdateCategoriesEntityRelationInput"]> | undefined,
	channels?: Array<GraphQLTypes["VenueUpdateChannelsEntityRelationInput"]> | undefined,
	address?: string | undefined,
	pointOfSalePngBase64ReceiptLogo?: string | undefined,
	pointOfSaleInitialView?: GraphQLTypes["PointOfSaleInitialView"] | undefined,
	pointOfSalePreferPrintReceipt?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeadlineTemplateUpsertVenueRelationInput"]: {
		update?: GraphQLTypes["VenueWithoutDeadlineTemplateUpdateInput"] | undefined,
	create?: GraphQLTypes["VenueWithoutDeadlineTemplateCreateInput"] | undefined
};
	["EmployeeQueueConnection"]: {
	__typename: "EmployeeQueueConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["EmployeeQueueEdge"]>
};
	["EmployeeQueueEdge"]: {
	__typename: "EmployeeQueueEdge",
	node: GraphQLTypes["EmployeeQueue"]
};
	["EmployeeQueueCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	shiftGroup?: GraphQLTypes["EmployeeQueueCreateShiftGroupEntityRelationInput"] | undefined,
	items?: Array<GraphQLTypes["EmployeeQueueCreateItemsEntityRelationInput"]> | undefined,
	contemberBugFix?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["EmployeeQueueUpdateInput"]: {
		shiftGroup?: GraphQLTypes["EmployeeQueueUpdateShiftGroupEntityRelationInput"] | undefined,
	items?: Array<GraphQLTypes["EmployeeQueueUpdateItemsEntityRelationInput"]> | undefined,
	contemberBugFix?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableDayCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	date?: GraphQLTypes["Date"] | undefined,
	type?: GraphQLTypes["TimetableDayType"] | undefined,
	shiftGroups?: Array<GraphQLTypes["TimetableDayCreateShiftGroupsEntityRelationInput"]> | undefined,
	tipsCents?: number | undefined,
	notes?: Array<GraphQLTypes["TimetableDayCreateNotesEntityRelationInput"]> | undefined,
	venue?: GraphQLTypes["TimetableDayCreateVenueEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["TimetableDayCreateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableDayUpdateInput"]: {
		date?: GraphQLTypes["Date"] | undefined,
	type?: GraphQLTypes["TimetableDayType"] | undefined,
	shiftGroups?: Array<GraphQLTypes["TimetableDayUpdateShiftGroupsEntityRelationInput"]> | undefined,
	tipsCents?: number | undefined,
	notes?: Array<GraphQLTypes["TimetableDayUpdateNotesEntityRelationInput"]> | undefined,
	venue?: GraphQLTypes["TimetableDayUpdateVenueEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["TimetableDayUpdateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableShiftCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locked?: boolean | undefined,
	order?: number | undefined,
	assigned?: GraphQLTypes["Date"] | undefined,
	group?: GraphQLTypes["TimetableShiftCreateGroupEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["TimetableShiftCreateShiftsProfileEntityRelationInput"] | undefined,
	queueItem?: GraphQLTypes["TimetableShiftCreateQueueItemEntityRelationInput"] | undefined,
	swapInfo?: GraphQLTypes["TimetableShiftCreateSwapInfoEntityRelationInput"] | undefined,
	isOvertime?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableShiftUpdateInput"]: {
		locked?: boolean | undefined,
	order?: number | undefined,
	assigned?: GraphQLTypes["Date"] | undefined,
	group?: GraphQLTypes["TimetableShiftUpdateGroupEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["TimetableShiftUpdateShiftsProfileEntityRelationInput"] | undefined,
	queueItem?: GraphQLTypes["TimetableShiftUpdateQueueItemEntityRelationInput"] | undefined,
	swapInfo?: GraphQLTypes["TimetableShiftUpdateSwapInfoEntityRelationInput"] | undefined,
	isOvertime?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableShiftGroupCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	shifts?: Array<GraphQLTypes["TimetableShiftGroupCreateShiftsEntityRelationInput"]> | undefined,
	day?: GraphQLTypes["TimetableShiftGroupCreateDayEntityRelationInput"] | undefined,
	type?: GraphQLTypes["TimetableShiftGroupCreateTypeEntityRelationInput"] | undefined,
	position?: GraphQLTypes["TimetableShiftGroupCreatePositionEntityRelationInput"] | undefined,
	queue?: GraphQLTypes["TimetableShiftGroupCreateQueueEntityRelationInput"] | undefined,
	generatedByTemplate?: GraphQLTypes["TimetableShiftGroupCreateGeneratedByTemplateEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableShiftGroupUpdateInput"]: {
		order?: number | undefined,
	shifts?: Array<GraphQLTypes["TimetableShiftGroupUpdateShiftsEntityRelationInput"]> | undefined,
	day?: GraphQLTypes["TimetableShiftGroupUpdateDayEntityRelationInput"] | undefined,
	type?: GraphQLTypes["TimetableShiftGroupUpdateTypeEntityRelationInput"] | undefined,
	position?: GraphQLTypes["TimetableShiftGroupUpdatePositionEntityRelationInput"] | undefined,
	queue?: GraphQLTypes["TimetableShiftGroupUpdateQueueEntityRelationInput"] | undefined,
	generatedByTemplate?: GraphQLTypes["TimetableShiftGroupUpdateGeneratedByTemplateEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableShiftPositionConnection"]: {
	__typename: "TimetableShiftPositionConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TimetableShiftPositionEdge"]>
};
	["TimetableShiftPositionEdge"]: {
	__typename: "TimetableShiftPositionEdge",
	node: GraphQLTypes["TimetableShiftPosition"]
};
	["TimetableShiftPositionCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	start?: string | undefined,
	end?: string | undefined,
	shiftGroups?: Array<GraphQLTypes["TimetableShiftPositionCreateShiftGroupsEntityRelationInput"]> | undefined,
	timetableTemplates?: Array<GraphQLTypes["TimetableShiftPositionCreateTimetableTemplatesEntityRelationInput"]> | undefined,
	isDynamic?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableShiftPositionUpdateInput"]: {
		name?: string | undefined,
	start?: string | undefined,
	end?: string | undefined,
	shiftGroups?: Array<GraphQLTypes["TimetableShiftPositionUpdateShiftGroupsEntityRelationInput"]> | undefined,
	timetableTemplates?: Array<GraphQLTypes["TimetableShiftPositionUpdateTimetableTemplatesEntityRelationInput"]> | undefined,
	isDynamic?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["CartCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	confirmedAt?: GraphQLTypes["DateTime"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	items?: Array<GraphQLTypes["CartCreateItemsEntityRelationInput"]> | undefined,
	handle?: string | undefined,
	state?: GraphQLTypes["CartState"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	channel?: GraphQLTypes["CartCreateChannelEntityRelationInput"] | undefined,
	order?: GraphQLTypes["CartCreateOrderEntityRelationInput"] | undefined,
	customer?: GraphQLTypes["CartCreateCustomerEntityRelationInput"] | undefined,
	deliveryAddress?: GraphQLTypes["CartCreateDeliveryAddressEntityRelationInput"] | undefined,
	billingAddress?: GraphQLTypes["CartCreateBillingAddressEntityRelationInput"] | undefined,
	deliveryOption?: string | undefined,
	paymentOption?: string | undefined,
	delivery?: GraphQLTypes["CartCreateDeliveryEntityRelationInput"] | undefined,
	payment?: GraphQLTypes["CartCreatePaymentEntityRelationInput"] | undefined,
	billingSubject?: GraphQLTypes["CartCreateBillingSubjectEntityRelationInput"] | undefined,
	priceLines?: Array<GraphQLTypes["CartCreatePriceLinesEntityRelationInput"]> | undefined,
	summary?: GraphQLTypes["CartCreateSummaryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CartUpdateInput"]: {
		confirmedAt?: GraphQLTypes["DateTime"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	items?: Array<GraphQLTypes["CartUpdateItemsEntityRelationInput"]> | undefined,
	handle?: string | undefined,
	state?: GraphQLTypes["CartState"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	channel?: GraphQLTypes["CartUpdateChannelEntityRelationInput"] | undefined,
	order?: GraphQLTypes["CartUpdateOrderEntityRelationInput"] | undefined,
	customer?: GraphQLTypes["CartUpdateCustomerEntityRelationInput"] | undefined,
	deliveryAddress?: GraphQLTypes["CartUpdateDeliveryAddressEntityRelationInput"] | undefined,
	billingAddress?: GraphQLTypes["CartUpdateBillingAddressEntityRelationInput"] | undefined,
	deliveryOption?: string | undefined,
	paymentOption?: string | undefined,
	delivery?: GraphQLTypes["CartUpdateDeliveryEntityRelationInput"] | undefined,
	payment?: GraphQLTypes["CartUpdatePaymentEntityRelationInput"] | undefined,
	billingSubject?: GraphQLTypes["CartUpdateBillingSubjectEntityRelationInput"] | undefined,
	priceLines?: Array<GraphQLTypes["CartUpdatePriceLinesEntityRelationInput"]> | undefined,
	summary?: GraphQLTypes["CartUpdateSummaryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CartItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	quantity?: number | undefined,
	cart?: GraphQLTypes["CartItemCreateCartEntityRelationInput"] | undefined,
	product?: GraphQLTypes["CartItemCreateProductEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	updatedAt?: GraphQLTypes["DateTime"] | undefined,
	fulfillmentNote?: string | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["CartItemCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["CartItemUpdateInput"]: {
		quantity?: number | undefined,
	cart?: GraphQLTypes["CartItemUpdateCartEntityRelationInput"] | undefined,
	product?: GraphQLTypes["CartItemUpdateProductEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	updatedAt?: GraphQLTypes["DateTime"] | undefined,
	fulfillmentNote?: string | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["CartItemUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["EmployeeQueueItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	start?: string | undefined,
	end?: string | undefined,
	queue?: GraphQLTypes["EmployeeQueueItemCreateQueueEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["EmployeeQueueItemCreateShiftsProfileEntityRelationInput"] | undefined,
	shift?: GraphQLTypes["EmployeeQueueItemCreateShiftEntityRelationInput"] | undefined,
	unassignInfo?: GraphQLTypes["EmployeeQueueItemCreateUnassignInfoEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["EmployeeQueueItemCreateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["EmployeeQueueItemUpdateInput"]: {
		start?: string | undefined,
	end?: string | undefined,
	queue?: GraphQLTypes["EmployeeQueueItemUpdateQueueEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["EmployeeQueueItemUpdateShiftsProfileEntityRelationInput"] | undefined,
	shift?: GraphQLTypes["EmployeeQueueItemUpdateShiftEntityRelationInput"] | undefined,
	unassignInfo?: GraphQLTypes["EmployeeQueueItemUpdateUnassignInfoEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["EmployeeQueueItemUpdateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ApplicationConnection"]: {
	__typename: "ApplicationConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ApplicationEdge"]>
};
	["ApplicationEdge"]: {
	__typename: "ApplicationEdge",
	node: GraphQLTypes["Application"]
};
	["ApplicationShortcutListConnection"]: {
	__typename: "ApplicationShortcutListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ApplicationShortcutListEdge"]>
};
	["ApplicationShortcutListEdge"]: {
	__typename: "ApplicationShortcutListEdge",
	node: GraphQLTypes["ApplicationShortcutList"]
};
	["ApplicationShortcutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["ApplicationShortcutListCreateItemsEntityRelationInput"]> | undefined,
	customer?: GraphQLTypes["ApplicationShortcutListCreateCustomerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ApplicationShortcutListCreateCustomerEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerWithoutShortcutListCreateInput"] | undefined
};
	["CustomerWithoutShortcutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	addresses?: Array<GraphQLTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerCreateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerCreateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerCreatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerCreateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerCreateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerCreateCartsEntityRelationInput"]> | undefined,
	user?: GraphQLTypes["CustomerCreateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerCreateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerCreateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerCreateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerCreateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ApplicationShortcutListUpdateInput"]: {
		items?: Array<GraphQLTypes["ApplicationShortcutListUpdateItemsEntityRelationInput"]> | undefined,
	customer?: GraphQLTypes["ApplicationShortcutListUpdateCustomerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ApplicationShortcutListUpdateCustomerEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerWithoutShortcutListCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerWithoutShortcutListUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ApplicationShortcutListUpsertCustomerRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CustomerWithoutShortcutListUpdateInput"]: {
		addresses?: Array<GraphQLTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerUpdateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerUpdateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined,
	user?: GraphQLTypes["CustomerUpdateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined,
	invoicingPlan?: GraphQLTypes["CustomerUpdateInvoicingPlanEntityRelationInput"] | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerUpdateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ApplicationShortcutListUpsertCustomerRelationInput"]: {
		update?: GraphQLTypes["CustomerWithoutShortcutListUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerWithoutShortcutListCreateInput"] | undefined
};
	["ApplicationShortcutListItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	application?: GraphQLTypes["ApplicationShortcutListItemCreateApplicationEntityRelationInput"] | undefined,
	list?: GraphQLTypes["ApplicationShortcutListItemCreateListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ApplicationShortcutListItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["ApplicationShortcutListUniqueWhere"] | undefined,
	create?: GraphQLTypes["ApplicationShortcutListWithoutItemsCreateInput"] | undefined
};
	["ApplicationShortcutListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	customer?: GraphQLTypes["ApplicationShortcutListCreateCustomerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ApplicationShortcutListItemUpdateInput"]: {
		order?: number | undefined,
	application?: GraphQLTypes["ApplicationShortcutListItemUpdateApplicationEntityRelationInput"] | undefined,
	list?: GraphQLTypes["ApplicationShortcutListItemUpdateListEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ApplicationShortcutListItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["ApplicationShortcutListWithoutItemsCreateInput"] | undefined,
	update?: GraphQLTypes["ApplicationShortcutListWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ApplicationShortcutListItemUpsertListRelationInput"] | undefined,
	connect?: GraphQLTypes["ApplicationShortcutListUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ApplicationShortcutListWithoutItemsUpdateInput"]: {
		customer?: GraphQLTypes["ApplicationShortcutListUpdateCustomerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ApplicationShortcutListItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["ApplicationShortcutListWithoutItemsUpdateInput"] | undefined,
	create?: GraphQLTypes["ApplicationShortcutListWithoutItemsCreateInput"] | undefined
};
	["ProductBannerConnection"]: {
	__typename: "ProductBannerConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductBannerEdge"]>
};
	["ProductBannerEdge"]: {
	__typename: "ProductBannerEdge",
	node: GraphQLTypes["ProductBanner"]
};
	["ProductBannerItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	list?: GraphQLTypes["ProductBannerItemCreateListEntityRelationInput"] | undefined,
	banner?: GraphQLTypes["ProductBannerItemCreateBannerEntityRelationInput"] | undefined,
	size?: GraphQLTypes["ProductBannerItemSize"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductBannerItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductBannerListUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductBannerListWithoutItemsCreateInput"] | undefined
};
	["ProductBannerListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductBannerItemUpdateInput"]: {
		order?: number | undefined,
	list?: GraphQLTypes["ProductBannerItemUpdateListEntityRelationInput"] | undefined,
	banner?: GraphQLTypes["ProductBannerItemUpdateBannerEntityRelationInput"] | undefined,
	size?: GraphQLTypes["ProductBannerItemSize"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductBannerItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["ProductBannerListWithoutItemsCreateInput"] | undefined,
	update?: GraphQLTypes["ProductBannerListWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ProductBannerItemUpsertListRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductBannerListUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ProductBannerListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean | undefined
};
	["ProductBannerItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["ProductBannerListWithoutItemsUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductBannerListWithoutItemsCreateInput"] | undefined
};
	["ProductBannerListConnection"]: {
	__typename: "ProductBannerListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductBannerListEdge"]>
};
	["ProductBannerListEdge"]: {
	__typename: "ProductBannerListEdge",
	node: GraphQLTypes["ProductBannerList"]
};
	["BartenderConnection"]: {
	__typename: "BartenderConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BartenderEdge"]>
};
	["BartenderEdge"]: {
	__typename: "BartenderEdge",
	node: GraphQLTypes["Bartender"]
};
	["BartenderCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	staff?: GraphQLTypes["BartenderCreateStaffEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BartenderCreateStaffEntityRelationInput"]: {
		connect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	create?: GraphQLTypes["StaffWithoutBartenderCreateInput"] | undefined
};
	["StaffWithoutBartenderCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	courier?: GraphQLTypes["StaffCreateCourierEntityRelationInput"] | undefined,
	cleaner?: GraphQLTypes["StaffCreateCleanerEntityRelationInput"] | undefined,
	shiftsManager?: GraphQLTypes["StaffCreateShiftsManagerEntityRelationInput"] | undefined,
	businessToBusinessManager?: GraphQLTypes["StaffCreateBusinessToBusinessManagerEntityRelationInput"] | undefined,
	user?: GraphQLTypes["StaffCreateUserEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["StaffCreateShiftsProfileEntityRelationInput"] | undefined,
	stocksManager?: GraphQLTypes["StaffCreateStocksManagerEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["StaffCreatePhotoEntityRelationInput"] | undefined,
	courierManager?: GraphQLTypes["StaffCreateCourierManagerEntityRelationInput"] | undefined,
	picker?: GraphQLTypes["StaffCreatePickerEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	remunerationProfile?: GraphQLTypes["StaffCreateRemunerationProfileEntityRelationInput"] | undefined,
	cashier?: GraphQLTypes["StaffCreateCashierEntityRelationInput"] | undefined,
	venues?: Array<GraphQLTypes["StaffCreateVenuesEntityRelationInput"]> | undefined,
	internalBuyer?: GraphQLTypes["StaffCreateInternalBuyerEntityRelationInput"] | undefined,
	salesManager?: GraphQLTypes["StaffCreateSalesManagerEntityRelationInput"] | undefined,
	cashierManager?: GraphQLTypes["StaffCreateCashierManagerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BartenderUpdateInput"]: {
		staff?: GraphQLTypes["BartenderUpdateStaffEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BartenderUpdateStaffEntityRelationInput"]: {
		create?: GraphQLTypes["StaffWithoutBartenderCreateInput"] | undefined,
	update?: GraphQLTypes["StaffWithoutBartenderUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BartenderUpsertStaffRelationInput"] | undefined,
	connect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["StaffWithoutBartenderUpdateInput"]: {
		courier?: GraphQLTypes["StaffUpdateCourierEntityRelationInput"] | undefined,
	cleaner?: GraphQLTypes["StaffUpdateCleanerEntityRelationInput"] | undefined,
	shiftsManager?: GraphQLTypes["StaffUpdateShiftsManagerEntityRelationInput"] | undefined,
	businessToBusinessManager?: GraphQLTypes["StaffUpdateBusinessToBusinessManagerEntityRelationInput"] | undefined,
	user?: GraphQLTypes["StaffUpdateUserEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["StaffUpdateShiftsProfileEntityRelationInput"] | undefined,
	stocksManager?: GraphQLTypes["StaffUpdateStocksManagerEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["StaffUpdatePhotoEntityRelationInput"] | undefined,
	courierManager?: GraphQLTypes["StaffUpdateCourierManagerEntityRelationInput"] | undefined,
	picker?: GraphQLTypes["StaffUpdatePickerEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	remunerationProfile?: GraphQLTypes["StaffUpdateRemunerationProfileEntityRelationInput"] | undefined,
	cashier?: GraphQLTypes["StaffUpdateCashierEntityRelationInput"] | undefined,
	venues?: Array<GraphQLTypes["StaffUpdateVenuesEntityRelationInput"]> | undefined,
	internalBuyer?: GraphQLTypes["StaffUpdateInternalBuyerEntityRelationInput"] | undefined,
	salesManager?: GraphQLTypes["StaffUpdateSalesManagerEntityRelationInput"] | undefined,
	cashierManager?: GraphQLTypes["StaffUpdateCashierManagerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BartenderUpsertStaffRelationInput"]: {
		update?: GraphQLTypes["StaffWithoutBartenderUpdateInput"] | undefined,
	create?: GraphQLTypes["StaffWithoutBartenderCreateInput"] | undefined
};
	["BusinessToBusinessManagerConnection"]: {
	__typename: "BusinessToBusinessManagerConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BusinessToBusinessManagerEdge"]>
};
	["BusinessToBusinessManagerEdge"]: {
	__typename: "BusinessToBusinessManagerEdge",
	node: GraphQLTypes["BusinessToBusinessManager"]
};
	["BusinessToBusinessManagerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	staff?: GraphQLTypes["BusinessToBusinessManagerCreateStaffEntityRelationInput"] | undefined,
	managedBusinesses?: Array<GraphQLTypes["BusinessToBusinessManagerCreateManagedBusinessesEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessToBusinessManagerUpdateInput"]: {
		staff?: GraphQLTypes["BusinessToBusinessManagerUpdateStaffEntityRelationInput"] | undefined,
	managedBusinesses?: Array<GraphQLTypes["BusinessToBusinessManagerUpdateManagedBusinessesEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CleanerConnection"]: {
	__typename: "CleanerConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CleanerEdge"]>
};
	["CleanerEdge"]: {
	__typename: "CleanerEdge",
	node: GraphQLTypes["Cleaner"]
};
	["CleanerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	staff?: GraphQLTypes["CleanerCreateStaffEntityRelationInput"] | undefined,
	canReachTopShelf?: boolean | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CleanerCreateStaffEntityRelationInput"]: {
		connect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	create?: GraphQLTypes["StaffWithoutCleanerCreateInput"] | undefined
};
	["StaffWithoutCleanerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	bartender?: GraphQLTypes["StaffCreateBartenderEntityRelationInput"] | undefined,
	courier?: GraphQLTypes["StaffCreateCourierEntityRelationInput"] | undefined,
	shiftsManager?: GraphQLTypes["StaffCreateShiftsManagerEntityRelationInput"] | undefined,
	businessToBusinessManager?: GraphQLTypes["StaffCreateBusinessToBusinessManagerEntityRelationInput"] | undefined,
	user?: GraphQLTypes["StaffCreateUserEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["StaffCreateShiftsProfileEntityRelationInput"] | undefined,
	stocksManager?: GraphQLTypes["StaffCreateStocksManagerEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["StaffCreatePhotoEntityRelationInput"] | undefined,
	courierManager?: GraphQLTypes["StaffCreateCourierManagerEntityRelationInput"] | undefined,
	picker?: GraphQLTypes["StaffCreatePickerEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	remunerationProfile?: GraphQLTypes["StaffCreateRemunerationProfileEntityRelationInput"] | undefined,
	cashier?: GraphQLTypes["StaffCreateCashierEntityRelationInput"] | undefined,
	venues?: Array<GraphQLTypes["StaffCreateVenuesEntityRelationInput"]> | undefined,
	internalBuyer?: GraphQLTypes["StaffCreateInternalBuyerEntityRelationInput"] | undefined,
	salesManager?: GraphQLTypes["StaffCreateSalesManagerEntityRelationInput"] | undefined,
	cashierManager?: GraphQLTypes["StaffCreateCashierManagerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CleanerUpdateInput"]: {
		staff?: GraphQLTypes["CleanerUpdateStaffEntityRelationInput"] | undefined,
	canReachTopShelf?: boolean | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CleanerUpdateStaffEntityRelationInput"]: {
		create?: GraphQLTypes["StaffWithoutCleanerCreateInput"] | undefined,
	update?: GraphQLTypes["StaffWithoutCleanerUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CleanerUpsertStaffRelationInput"] | undefined,
	connect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["StaffWithoutCleanerUpdateInput"]: {
		bartender?: GraphQLTypes["StaffUpdateBartenderEntityRelationInput"] | undefined,
	courier?: GraphQLTypes["StaffUpdateCourierEntityRelationInput"] | undefined,
	shiftsManager?: GraphQLTypes["StaffUpdateShiftsManagerEntityRelationInput"] | undefined,
	businessToBusinessManager?: GraphQLTypes["StaffUpdateBusinessToBusinessManagerEntityRelationInput"] | undefined,
	user?: GraphQLTypes["StaffUpdateUserEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["StaffUpdateShiftsProfileEntityRelationInput"] | undefined,
	stocksManager?: GraphQLTypes["StaffUpdateStocksManagerEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["StaffUpdatePhotoEntityRelationInput"] | undefined,
	courierManager?: GraphQLTypes["StaffUpdateCourierManagerEntityRelationInput"] | undefined,
	picker?: GraphQLTypes["StaffUpdatePickerEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	remunerationProfile?: GraphQLTypes["StaffUpdateRemunerationProfileEntityRelationInput"] | undefined,
	cashier?: GraphQLTypes["StaffUpdateCashierEntityRelationInput"] | undefined,
	venues?: Array<GraphQLTypes["StaffUpdateVenuesEntityRelationInput"]> | undefined,
	internalBuyer?: GraphQLTypes["StaffUpdateInternalBuyerEntityRelationInput"] | undefined,
	salesManager?: GraphQLTypes["StaffUpdateSalesManagerEntityRelationInput"] | undefined,
	cashierManager?: GraphQLTypes["StaffUpdateCashierManagerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CleanerUpsertStaffRelationInput"]: {
		update?: GraphQLTypes["StaffWithoutCleanerUpdateInput"] | undefined,
	create?: GraphQLTypes["StaffWithoutCleanerCreateInput"] | undefined
};
	["CourierCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	staff?: GraphQLTypes["CourierCreateStaffEntityRelationInput"] | undefined,
	routes?: Array<GraphQLTypes["CourierCreateRoutesEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	deliveryMethods?: Array<GraphQLTypes["CourierCreateDeliveryMethodsEntityRelationInput"]> | undefined,
	showInPicker?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["CourierUpdateInput"]: {
		staff?: GraphQLTypes["CourierUpdateStaffEntityRelationInput"] | undefined,
	routes?: Array<GraphQLTypes["CourierUpdateRoutesEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	deliveryMethods?: Array<GraphQLTypes["CourierUpdateDeliveryMethodsEntityRelationInput"]> | undefined,
	showInPicker?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ShiftsManagerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	staff?: GraphQLTypes["ShiftsManagerCreateStaffEntityRelationInput"] | undefined,
	managedRoles?: Array<GraphQLTypes["ShiftsManagerCreateManagedRolesEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ShiftsManagerUpdateInput"]: {
		staff?: GraphQLTypes["ShiftsManagerUpdateStaffEntityRelationInput"] | undefined,
	managedRoles?: Array<GraphQLTypes["ShiftsManagerUpdateManagedRolesEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserConnection"]: {
	__typename: "UserConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["UserEdge"]>
};
	["UserEdge"]: {
	__typename: "UserEdge",
	node: GraphQLTypes["User"]
};
	["ProductIngredientCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	internalName?: string | undefined,
	internalNote?: string | undefined,
	ingredients?: Array<GraphQLTypes["ProductIngredientCategoryCreateIngredientsEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["ProductIngredientCategoryCreateLocalesEntityRelationInput"]> | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientCategoryUpdateInput"]: {
		internalName?: string | undefined,
	internalNote?: string | undefined,
	ingredients?: Array<GraphQLTypes["ProductIngredientCategoryUpdateIngredientsEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["ProductIngredientCategoryUpdateLocalesEntityRelationInput"]> | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientCategoryLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	root?: GraphQLTypes["ProductIngredientCategoryLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["ProductIngredientCategoryLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductIngredientCategoryLocaleUpdateInput"]: {
		name?: string | undefined,
	root?: GraphQLTypes["ProductIngredientCategoryLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["ProductIngredientCategoryLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StocksManagerConnection"]: {
	__typename: "StocksManagerConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["StocksManagerEdge"]>
};
	["StocksManagerEdge"]: {
	__typename: "StocksManagerEdge",
	node: GraphQLTypes["StocksManager"]
};
	["StocksManagerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	staff?: GraphQLTypes["StocksManagerCreateStaffEntityRelationInput"] | undefined,
	managedProducts?: Array<GraphQLTypes["StocksManagerCreateManagedProductsEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StocksManagerUpdateInput"]: {
		staff?: GraphQLTypes["StocksManagerUpdateStaffEntityRelationInput"] | undefined,
	managedProducts?: Array<GraphQLTypes["StocksManagerUpdateManagedProductsEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryRouteCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	courier?: GraphQLTypes["DeliveryRouteCreateCourierEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	waypoints?: Array<GraphQLTypes["DeliveryRouteCreateWaypointsEntityRelationInput"]> | undefined,
	dispatchAt?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryRouteUpdateInput"]: {
		courier?: GraphQLTypes["DeliveryRouteUpdateCourierEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	waypoints?: Array<GraphQLTypes["DeliveryRouteUpdateWaypointsEntityRelationInput"]> | undefined,
	dispatchAt?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryWaypointCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	estimatedArrival?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	route?: GraphQLTypes["DeliveryWaypointCreateRouteEntityRelationInput"] | undefined,
	sortingOrder?: number | undefined,
	delivery?: GraphQLTypes["DeliveryWaypointCreateDeliveryEntityRelationInput"] | undefined,
	estimatedDistance?: number | undefined,
	estimatedDuration?: number | undefined,
	originDeparture?: GraphQLTypes["DateTime"] | undefined,
	originAddress?: string | undefined,
	transitMode?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryWaypointUpdateInput"]: {
		estimatedArrival?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	route?: GraphQLTypes["DeliveryWaypointUpdateRouteEntityRelationInput"] | undefined,
	sortingOrder?: number | undefined,
	delivery?: GraphQLTypes["DeliveryWaypointUpdateDeliveryEntityRelationInput"] | undefined,
	estimatedDistance?: number | undefined,
	estimatedDuration?: number | undefined,
	originDeparture?: GraphQLTypes["DateTime"] | undefined,
	originAddress?: string | undefined,
	transitMode?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["AllergenCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	internalName?: string | undefined,
	locales?: Array<GraphQLTypes["AllergenCreateLocalesEntityRelationInput"]> | undefined,
	ingredients?: Array<GraphQLTypes["AllergenCreateIngredientsEntityRelationInput"]> | undefined,
	code?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["AllergenUpdateInput"]: {
		internalName?: string | undefined,
	locales?: Array<GraphQLTypes["AllergenUpdateLocalesEntityRelationInput"]> | undefined,
	ingredients?: Array<GraphQLTypes["AllergenUpdateIngredientsEntityRelationInput"]> | undefined,
	code?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["AllergenLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	root?: GraphQLTypes["AllergenLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["AllergenLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["AllergenLocaleUpdateInput"]: {
		name?: string | undefined,
	root?: GraphQLTypes["AllergenLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["AllergenLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GpsConnection"]: {
	__typename: "GpsConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GpsEdge"]>
};
	["GpsEdge"]: {
	__typename: "GpsEdge",
	node: GraphQLTypes["Gps"]
};
	["GpsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	latitude?: number | undefined,
	longitude?: number | undefined,
	address?: GraphQLTypes["GpsCreateAddressEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GpsCreateAddressEntityRelationInput"]: {
		connect?: GraphQLTypes["AddressUniqueWhere"] | undefined,
	create?: GraphQLTypes["AddressWithoutGpsCreateInput"] | undefined
};
	["AddressWithoutGpsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	firstName?: string | undefined,
	lastName?: string | undefined,
	addressLine2?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	companyName?: string | undefined,
	companyIdentifier?: string | undefined,
	vatIdentifier?: string | undefined,
	externalIdentifier?: string | undefined,
	hidden?: boolean | undefined,
	customer?: GraphQLTypes["AddressCreateCustomerEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	country?: GraphQLTypes["AddressCreateCountryEntityRelationInput"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	googlePlaceId?: string | undefined,
	raw?: string | undefined,
	formatted?: string | undefined,
	geocodeGeneratedAt?: GraphQLTypes["DateTime"] | undefined,
	geocodeResponse?: string | undefined,
	deliveryZone?: GraphQLTypes["AddressCreateDeliveryZoneEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["AddressCreateMetaEntityRelationInput"] | undefined,
	geocodeValid?: boolean | undefined,
	fullName?: string | undefined,
	fakturoidSubjectId?: string | undefined,
	invoices?: Array<GraphQLTypes["AddressCreateInvoicesEntityRelationInput"]> | undefined,
	addressLine1?: string | undefined,
	city?: string | undefined,
	postalCode?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddressOfOrders?: Array<GraphQLTypes["AddressCreateBillingAddressOfOrdersEntityRelationInput"]> | undefined,
	deliveryAddressOfOrderDeliveries?: Array<GraphQLTypes["AddressCreateDeliveryAddressOfOrderDeliveriesEntityRelationInput"]> | undefined,
	defaultDeliveryAddressOfCustomer?: GraphQLTypes["AddressCreateDefaultDeliveryAddressOfCustomerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GpsUpdateInput"]: {
		latitude?: number | undefined,
	longitude?: number | undefined,
	address?: GraphQLTypes["GpsUpdateAddressEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GpsUpdateAddressEntityRelationInput"]: {
		create?: GraphQLTypes["AddressWithoutGpsCreateInput"] | undefined,
	update?: GraphQLTypes["AddressWithoutGpsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GpsUpsertAddressRelationInput"] | undefined,
	connect?: GraphQLTypes["AddressUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["AddressWithoutGpsUpdateInput"]: {
		name?: string | undefined,
	firstName?: string | undefined,
	lastName?: string | undefined,
	addressLine2?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	companyName?: string | undefined,
	companyIdentifier?: string | undefined,
	vatIdentifier?: string | undefined,
	externalIdentifier?: string | undefined,
	hidden?: boolean | undefined,
	customer?: GraphQLTypes["AddressUpdateCustomerEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	country?: GraphQLTypes["AddressUpdateCountryEntityRelationInput"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	googlePlaceId?: string | undefined,
	raw?: string | undefined,
	formatted?: string | undefined,
	geocodeGeneratedAt?: GraphQLTypes["DateTime"] | undefined,
	geocodeResponse?: string | undefined,
	deliveryZone?: GraphQLTypes["AddressUpdateDeliveryZoneEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["AddressUpdateMetaEntityRelationInput"] | undefined,
	geocodeValid?: boolean | undefined,
	fullName?: string | undefined,
	fakturoidSubjectId?: string | undefined,
	invoices?: Array<GraphQLTypes["AddressUpdateInvoicesEntityRelationInput"]> | undefined,
	addressLine1?: string | undefined,
	city?: string | undefined,
	postalCode?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddressOfOrders?: Array<GraphQLTypes["AddressUpdateBillingAddressOfOrdersEntityRelationInput"]> | undefined,
	deliveryAddressOfOrderDeliveries?: Array<GraphQLTypes["AddressUpdateDeliveryAddressOfOrderDeliveriesEntityRelationInput"]> | undefined,
	defaultDeliveryAddressOfCustomer?: GraphQLTypes["AddressUpdateDefaultDeliveryAddressOfCustomerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GpsUpsertAddressRelationInput"]: {
		update?: GraphQLTypes["AddressWithoutGpsUpdateInput"] | undefined,
	create?: GraphQLTypes["AddressWithoutGpsCreateInput"] | undefined
};
	["WeekHoursConnection"]: {
	__typename: "WeekHoursConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["WeekHoursEdge"]>
};
	["WeekHoursEdge"]: {
	__typename: "WeekHoursEdge",
	node: GraphQLTypes["WeekHours"]
};
	["PreparedIngredientQuantity"]: {
	__typename: "PreparedIngredientQuantity",
	_meta?: GraphQLTypes["PreparedIngredientQuantityMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	date: GraphQLTypes["Date"],
	quantity?: number | undefined,
	usedQuantity?: number | undefined,
	ingredient?: GraphQLTypes["ProductIngredient"] | undefined,
	unit?: GraphQLTypes["ProductIngredientItemQuantityUnit"] | undefined
};
	["PreparedIngredientQuantityMeta"]: {
	__typename: "PreparedIngredientQuantityMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	date?: GraphQLTypes["FieldMeta"] | undefined,
	quantity?: GraphQLTypes["FieldMeta"] | undefined,
	usedQuantity?: GraphQLTypes["FieldMeta"] | undefined,
	ingredient?: GraphQLTypes["FieldMeta"] | undefined,
	unit?: GraphQLTypes["FieldMeta"] | undefined
};
	["PreparedIngredientQuantityUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	date?: GraphQLTypes["Date"] | undefined,
	ingredient?: GraphQLTypes["ProductIngredientUniqueWhere"] | undefined,
	unit?: GraphQLTypes["ProductIngredientItemQuantityUnitUniqueWhere"] | undefined
};
	["PreparedIngredientQuantityWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	date?: GraphQLTypes["DateCondition"] | undefined,
	quantity?: GraphQLTypes["FloatCondition"] | undefined,
	usedQuantity?: GraphQLTypes["FloatCondition"] | undefined,
	ingredient?: GraphQLTypes["ProductIngredientWhere"] | undefined,
	unit?: GraphQLTypes["ProductIngredientItemQuantityUnitWhere"] | undefined,
	and?: Array<GraphQLTypes["PreparedIngredientQuantityWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PreparedIngredientQuantityWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PreparedIngredientQuantityWhere"] | undefined
};
	["PreparedIngredientQuantityOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	date?: GraphQLTypes["OrderDirection"] | undefined,
	quantity?: GraphQLTypes["OrderDirection"] | undefined,
	usedQuantity?: GraphQLTypes["OrderDirection"] | undefined,
	ingredient?: GraphQLTypes["ProductIngredientOrderBy"] | undefined,
	unit?: GraphQLTypes["ProductIngredientItemQuantityUnitOrderBy"] | undefined
};
	["PreparedIngredientQuantityConnection"]: {
	__typename: "PreparedIngredientQuantityConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PreparedIngredientQuantityEdge"]>
};
	["PreparedIngredientQuantityEdge"]: {
	__typename: "PreparedIngredientQuantityEdge",
	node: GraphQLTypes["PreparedIngredientQuantity"]
};
	["PreparedIngredientQuantityCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	date?: GraphQLTypes["Date"] | undefined,
	quantity?: number | undefined,
	usedQuantity?: number | undefined,
	ingredient?: GraphQLTypes["PreparedIngredientQuantityCreateIngredientEntityRelationInput"] | undefined,
	unit?: GraphQLTypes["PreparedIngredientQuantityCreateUnitEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PreparedIngredientQuantityCreateIngredientEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductIngredientUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductIngredientCreateInput"] | undefined
};
	["PreparedIngredientQuantityCreateUnitEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductIngredientItemQuantityUnitUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductIngredientItemQuantityUnitCreateInput"] | undefined
};
	["PreparedIngredientQuantityUpdateInput"]: {
		date?: GraphQLTypes["Date"] | undefined,
	quantity?: number | undefined,
	usedQuantity?: number | undefined,
	ingredient?: GraphQLTypes["PreparedIngredientQuantityUpdateIngredientEntityRelationInput"] | undefined,
	unit?: GraphQLTypes["PreparedIngredientQuantityUpdateUnitEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PreparedIngredientQuantityUpdateIngredientEntityRelationInput"]: {
		create?: GraphQLTypes["ProductIngredientCreateInput"] | undefined,
	update?: GraphQLTypes["ProductIngredientUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PreparedIngredientQuantityUpsertIngredientRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductIngredientUniqueWhere"] | undefined
};
	["PreparedIngredientQuantityUpsertIngredientRelationInput"]: {
		update?: GraphQLTypes["ProductIngredientUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductIngredientCreateInput"] | undefined
};
	["PreparedIngredientQuantityUpdateUnitEntityRelationInput"]: {
		create?: GraphQLTypes["ProductIngredientItemQuantityUnitCreateInput"] | undefined,
	update?: GraphQLTypes["ProductIngredientItemQuantityUnitUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PreparedIngredientQuantityUpsertUnitRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductIngredientItemQuantityUnitUniqueWhere"] | undefined
};
	["PreparedIngredientQuantityUpsertUnitRelationInput"]: {
		update?: GraphQLTypes["ProductIngredientItemQuantityUnitUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductIngredientItemQuantityUnitCreateInput"] | undefined
};
	["PreparedRecipeQuantity"]: {
	__typename: "PreparedRecipeQuantity",
	_meta?: GraphQLTypes["PreparedRecipeQuantityMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	date: GraphQLTypes["Date"],
	quantity?: number | undefined,
	recipe?: GraphQLTypes["ProductRecipe"] | undefined,
	usedQuantity?: number | undefined
};
	["PreparedRecipeQuantityMeta"]: {
	__typename: "PreparedRecipeQuantityMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	date?: GraphQLTypes["FieldMeta"] | undefined,
	quantity?: GraphQLTypes["FieldMeta"] | undefined,
	recipe?: GraphQLTypes["FieldMeta"] | undefined,
	usedQuantity?: GraphQLTypes["FieldMeta"] | undefined
};
	["PreparedRecipeQuantityUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	date?: GraphQLTypes["Date"] | undefined,
	recipe?: GraphQLTypes["ProductRecipeUniqueWhere"] | undefined
};
	["PreparedRecipeQuantityWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	date?: GraphQLTypes["DateCondition"] | undefined,
	quantity?: GraphQLTypes["FloatCondition"] | undefined,
	recipe?: GraphQLTypes["ProductRecipeWhere"] | undefined,
	usedQuantity?: GraphQLTypes["FloatCondition"] | undefined,
	and?: Array<GraphQLTypes["PreparedRecipeQuantityWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PreparedRecipeQuantityWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PreparedRecipeQuantityWhere"] | undefined
};
	["PreparedRecipeQuantityOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	date?: GraphQLTypes["OrderDirection"] | undefined,
	quantity?: GraphQLTypes["OrderDirection"] | undefined,
	recipe?: GraphQLTypes["ProductRecipeOrderBy"] | undefined,
	usedQuantity?: GraphQLTypes["OrderDirection"] | undefined
};
	["PreparedRecipeQuantityConnection"]: {
	__typename: "PreparedRecipeQuantityConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PreparedRecipeQuantityEdge"]>
};
	["PreparedRecipeQuantityEdge"]: {
	__typename: "PreparedRecipeQuantityEdge",
	node: GraphQLTypes["PreparedRecipeQuantity"]
};
	["PreparedRecipeQuantityCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	date?: GraphQLTypes["Date"] | undefined,
	quantity?: number | undefined,
	recipe?: GraphQLTypes["PreparedRecipeQuantityCreateRecipeEntityRelationInput"] | undefined,
	usedQuantity?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["PreparedRecipeQuantityCreateRecipeEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductRecipeUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductRecipeCreateInput"] | undefined
};
	["PreparedRecipeQuantityUpdateInput"]: {
		date?: GraphQLTypes["Date"] | undefined,
	quantity?: number | undefined,
	recipe?: GraphQLTypes["PreparedRecipeQuantityUpdateRecipeEntityRelationInput"] | undefined,
	usedQuantity?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["PreparedRecipeQuantityUpdateRecipeEntityRelationInput"]: {
		create?: GraphQLTypes["ProductRecipeCreateInput"] | undefined,
	update?: GraphQLTypes["ProductRecipeUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PreparedRecipeQuantityUpsertRecipeRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductRecipeUniqueWhere"] | undefined
};
	["PreparedRecipeQuantityUpsertRecipeRelationInput"]: {
		update?: GraphQLTypes["ProductRecipeUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductRecipeCreateInput"] | undefined
};
	["InternalOrder"]: {
	__typename: "InternalOrder",
	_meta?: GraphQLTypes["InternalOrderMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	state?: GraphQLTypes["InternalOrderState"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	canceledAt?: GraphQLTypes["DateTime"] | undefined,
	targetPlace?: string | undefined,
	note?: string | undefined,
	internalNote?: string | undefined,
	items: Array<GraphQLTypes["InternalOrderItem"]>,
	createdAt: GraphQLTypes["DateTime"],
	paginateItems: GraphQLTypes["InternalOrderItemConnection"]
};
	["InternalOrderMeta"]: {
	__typename: "InternalOrderMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	state?: GraphQLTypes["FieldMeta"] | undefined,
	fulfilledAt?: GraphQLTypes["FieldMeta"] | undefined,
	canceledAt?: GraphQLTypes["FieldMeta"] | undefined,
	targetPlace?: GraphQLTypes["FieldMeta"] | undefined,
	note?: GraphQLTypes["FieldMeta"] | undefined,
	internalNote?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined
};
	["InternalOrderState"]: InternalOrderState;
	["InternalOrderItem"]: {
	__typename: "InternalOrderItem",
	_meta?: GraphQLTypes["InternalOrderItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	quantity: number,
	internalOrder?: GraphQLTypes["InternalOrder"] | undefined,
	product?: GraphQLTypes["Product"] | undefined
};
	["InternalOrderItemMeta"]: {
	__typename: "InternalOrderItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	quantity?: GraphQLTypes["FieldMeta"] | undefined,
	internalOrder?: GraphQLTypes["FieldMeta"] | undefined,
	product?: GraphQLTypes["FieldMeta"] | undefined
};
	["InternalOrderWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	state?: GraphQLTypes["InternalOrderStateCondition"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	canceledAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	targetPlace?: GraphQLTypes["StringCondition"] | undefined,
	note?: GraphQLTypes["StringCondition"] | undefined,
	internalNote?: GraphQLTypes["StringCondition"] | undefined,
	items?: GraphQLTypes["InternalOrderItemWhere"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	and?: Array<GraphQLTypes["InternalOrderWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["InternalOrderWhere"] | undefined> | undefined,
	not?: GraphQLTypes["InternalOrderWhere"] | undefined
};
	["InternalOrderStateCondition"]: {
		and?: Array<GraphQLTypes["InternalOrderStateCondition"]> | undefined,
	or?: Array<GraphQLTypes["InternalOrderStateCondition"]> | undefined,
	not?: GraphQLTypes["InternalOrderStateCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["InternalOrderState"] | undefined,
	notEq?: GraphQLTypes["InternalOrderState"] | undefined,
	in?: Array<GraphQLTypes["InternalOrderState"]> | undefined,
	notIn?: Array<GraphQLTypes["InternalOrderState"]> | undefined,
	lt?: GraphQLTypes["InternalOrderState"] | undefined,
	lte?: GraphQLTypes["InternalOrderState"] | undefined,
	gt?: GraphQLTypes["InternalOrderState"] | undefined,
	gte?: GraphQLTypes["InternalOrderState"] | undefined
};
	["InternalOrderItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	quantity?: GraphQLTypes["IntCondition"] | undefined,
	internalOrder?: GraphQLTypes["InternalOrderWhere"] | undefined,
	product?: GraphQLTypes["ProductWhere"] | undefined,
	and?: Array<GraphQLTypes["InternalOrderItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["InternalOrderItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["InternalOrderItemWhere"] | undefined
};
	["InternalOrderItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	quantity?: GraphQLTypes["OrderDirection"] | undefined,
	internalOrder?: GraphQLTypes["InternalOrderOrderBy"] | undefined,
	product?: GraphQLTypes["ProductOrderBy"] | undefined
};
	["InternalOrderOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	state?: GraphQLTypes["OrderDirection"] | undefined,
	fulfilledAt?: GraphQLTypes["OrderDirection"] | undefined,
	canceledAt?: GraphQLTypes["OrderDirection"] | undefined,
	targetPlace?: GraphQLTypes["OrderDirection"] | undefined,
	note?: GraphQLTypes["OrderDirection"] | undefined,
	internalNote?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined
};
	["InternalOrderItemConnection"]: {
	__typename: "InternalOrderItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["InternalOrderItemEdge"]>
};
	["InternalOrderItemEdge"]: {
	__typename: "InternalOrderItemEdge",
	node: GraphQLTypes["InternalOrderItem"]
};
	["InternalOrderUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["InternalOrderItemUniqueWhere"] | undefined
};
	["InternalOrderItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["InternalOrderConnection"]: {
	__typename: "InternalOrderConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["InternalOrderEdge"]>
};
	["InternalOrderEdge"]: {
	__typename: "InternalOrderEdge",
	node: GraphQLTypes["InternalOrder"]
};
	["InternalOrderCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	state?: GraphQLTypes["InternalOrderState"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	canceledAt?: GraphQLTypes["DateTime"] | undefined,
	targetPlace?: string | undefined,
	note?: string | undefined,
	internalNote?: string | undefined,
	items?: Array<GraphQLTypes["InternalOrderCreateItemsEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InternalOrderCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["InternalOrderItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["InternalOrderItemWithoutInternalOrderCreateInput"] | undefined,
	alias?: string | undefined
};
	["InternalOrderItemWithoutInternalOrderCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	quantity?: number | undefined,
	product?: GraphQLTypes["InternalOrderItemCreateProductEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InternalOrderItemCreateProductEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductCreateInput"] | undefined
};
	["InternalOrderUpdateInput"]: {
		state?: GraphQLTypes["InternalOrderState"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	canceledAt?: GraphQLTypes["DateTime"] | undefined,
	targetPlace?: string | undefined,
	note?: string | undefined,
	internalNote?: string | undefined,
	items?: Array<GraphQLTypes["InternalOrderUpdateItemsEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InternalOrderUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["InternalOrderItemWithoutInternalOrderCreateInput"] | undefined,
	update?: GraphQLTypes["InternalOrderUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["InternalOrderUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["InternalOrderItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["InternalOrderItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["InternalOrderItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["InternalOrderUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["InternalOrderItemUniqueWhere"] | undefined,
	data?: GraphQLTypes["InternalOrderItemWithoutInternalOrderUpdateInput"] | undefined
};
	["InternalOrderItemWithoutInternalOrderUpdateInput"]: {
		quantity?: number | undefined,
	product?: GraphQLTypes["InternalOrderItemUpdateProductEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InternalOrderItemUpdateProductEntityRelationInput"]: {
		create?: GraphQLTypes["ProductCreateInput"] | undefined,
	update?: GraphQLTypes["ProductUpdateInput"] | undefined,
	upsert?: GraphQLTypes["InternalOrderItemUpsertProductRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductUniqueWhere"] | undefined
};
	["InternalOrderItemUpsertProductRelationInput"]: {
		update?: GraphQLTypes["ProductUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductCreateInput"] | undefined
};
	["InternalOrderUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["InternalOrderItemUniqueWhere"] | undefined,
	update?: GraphQLTypes["InternalOrderItemWithoutInternalOrderUpdateInput"] | undefined,
	create?: GraphQLTypes["InternalOrderItemWithoutInternalOrderCreateInput"] | undefined
};
	["InternalOrderItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	quantity?: number | undefined,
	internalOrder?: GraphQLTypes["InternalOrderItemCreateInternalOrderEntityRelationInput"] | undefined,
	product?: GraphQLTypes["InternalOrderItemCreateProductEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InternalOrderItemCreateInternalOrderEntityRelationInput"]: {
		connect?: GraphQLTypes["InternalOrderUniqueWhere"] | undefined,
	create?: GraphQLTypes["InternalOrderWithoutItemsCreateInput"] | undefined
};
	["InternalOrderWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	state?: GraphQLTypes["InternalOrderState"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	canceledAt?: GraphQLTypes["DateTime"] | undefined,
	targetPlace?: string | undefined,
	note?: string | undefined,
	internalNote?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InternalOrderItemUpdateInput"]: {
		quantity?: number | undefined,
	internalOrder?: GraphQLTypes["InternalOrderItemUpdateInternalOrderEntityRelationInput"] | undefined,
	product?: GraphQLTypes["InternalOrderItemUpdateProductEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InternalOrderItemUpdateInternalOrderEntityRelationInput"]: {
		create?: GraphQLTypes["InternalOrderWithoutItemsCreateInput"] | undefined,
	update?: GraphQLTypes["InternalOrderWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["InternalOrderItemUpsertInternalOrderRelationInput"] | undefined,
	connect?: GraphQLTypes["InternalOrderUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["InternalOrderWithoutItemsUpdateInput"]: {
		state?: GraphQLTypes["InternalOrderState"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	canceledAt?: GraphQLTypes["DateTime"] | undefined,
	targetPlace?: string | undefined,
	note?: string | undefined,
	internalNote?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InternalOrderItemUpsertInternalOrderRelationInput"]: {
		update?: GraphQLTypes["InternalOrderWithoutItemsUpdateInput"] | undefined,
	create?: GraphQLTypes["InternalOrderWithoutItemsCreateInput"] | undefined
};
	["PreparedPackingQuantityCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	date?: GraphQLTypes["Date"] | undefined,
	quantity?: number | undefined,
	recipe?: GraphQLTypes["PreparedPackingQuantityCreateRecipeEntityRelationInput"] | undefined,
	packing?: GraphQLTypes["PreparedPackingQuantityCreatePackingEntityRelationInput"] | undefined,
	packedInCardboard?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PreparedPackingQuantityCreatePackingEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductPackingUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductPackingWithoutPreparedPackingQuantitiesCreateInput"] | undefined
};
	["ProductPackingWithoutPreparedPackingQuantitiesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	image?: GraphQLTypes["ProductPackingCreateImageEntityRelationInput"] | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	volumeMl?: number | undefined,
	icon?: GraphQLTypes["ProductPackingCreateIconEntityRelationInput"] | undefined,
	shortName?: string | undefined,
	locales?: Array<GraphQLTypes["ProductPackingCreateLocalesEntityRelationInput"]> | undefined,
	isPackedInCardboard?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PreparedPackingQuantityUpdateInput"]: {
		date?: GraphQLTypes["Date"] | undefined,
	quantity?: number | undefined,
	recipe?: GraphQLTypes["PreparedPackingQuantityUpdateRecipeEntityRelationInput"] | undefined,
	packing?: GraphQLTypes["PreparedPackingQuantityUpdatePackingEntityRelationInput"] | undefined,
	packedInCardboard?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PreparedPackingQuantityUpdatePackingEntityRelationInput"]: {
		create?: GraphQLTypes["ProductPackingWithoutPreparedPackingQuantitiesCreateInput"] | undefined,
	update?: GraphQLTypes["ProductPackingWithoutPreparedPackingQuantitiesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PreparedPackingQuantityUpsertPackingRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductPackingUniqueWhere"] | undefined
};
	["ProductPackingWithoutPreparedPackingQuantitiesUpdateInput"]: {
		name?: string | undefined,
	image?: GraphQLTypes["ProductPackingUpdateImageEntityRelationInput"] | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	volumeMl?: number | undefined,
	icon?: GraphQLTypes["ProductPackingUpdateIconEntityRelationInput"] | undefined,
	shortName?: string | undefined,
	locales?: Array<GraphQLTypes["ProductPackingUpdateLocalesEntityRelationInput"]> | undefined,
	isPackedInCardboard?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PreparedPackingQuantityUpsertPackingRelationInput"]: {
		update?: GraphQLTypes["ProductPackingWithoutPreparedPackingQuantitiesUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductPackingWithoutPreparedPackingQuantitiesCreateInput"] | undefined
};
	["CourierManagerConnection"]: {
	__typename: "CourierManagerConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CourierManagerEdge"]>
};
	["CourierManagerEdge"]: {
	__typename: "CourierManagerEdge",
	node: GraphQLTypes["CourierManager"]
};
	["CourierManagerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	staff?: GraphQLTypes["CourierManagerCreateStaffEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CourierManagerCreateStaffEntityRelationInput"]: {
		connect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	create?: GraphQLTypes["StaffWithoutCourierManagerCreateInput"] | undefined
};
	["StaffWithoutCourierManagerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	bartender?: GraphQLTypes["StaffCreateBartenderEntityRelationInput"] | undefined,
	courier?: GraphQLTypes["StaffCreateCourierEntityRelationInput"] | undefined,
	cleaner?: GraphQLTypes["StaffCreateCleanerEntityRelationInput"] | undefined,
	shiftsManager?: GraphQLTypes["StaffCreateShiftsManagerEntityRelationInput"] | undefined,
	businessToBusinessManager?: GraphQLTypes["StaffCreateBusinessToBusinessManagerEntityRelationInput"] | undefined,
	user?: GraphQLTypes["StaffCreateUserEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["StaffCreateShiftsProfileEntityRelationInput"] | undefined,
	stocksManager?: GraphQLTypes["StaffCreateStocksManagerEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["StaffCreatePhotoEntityRelationInput"] | undefined,
	picker?: GraphQLTypes["StaffCreatePickerEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	remunerationProfile?: GraphQLTypes["StaffCreateRemunerationProfileEntityRelationInput"] | undefined,
	cashier?: GraphQLTypes["StaffCreateCashierEntityRelationInput"] | undefined,
	venues?: Array<GraphQLTypes["StaffCreateVenuesEntityRelationInput"]> | undefined,
	internalBuyer?: GraphQLTypes["StaffCreateInternalBuyerEntityRelationInput"] | undefined,
	salesManager?: GraphQLTypes["StaffCreateSalesManagerEntityRelationInput"] | undefined,
	cashierManager?: GraphQLTypes["StaffCreateCashierManagerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CourierManagerUpdateInput"]: {
		staff?: GraphQLTypes["CourierManagerUpdateStaffEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CourierManagerUpdateStaffEntityRelationInput"]: {
		create?: GraphQLTypes["StaffWithoutCourierManagerCreateInput"] | undefined,
	update?: GraphQLTypes["StaffWithoutCourierManagerUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CourierManagerUpsertStaffRelationInput"] | undefined,
	connect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["StaffWithoutCourierManagerUpdateInput"]: {
		bartender?: GraphQLTypes["StaffUpdateBartenderEntityRelationInput"] | undefined,
	courier?: GraphQLTypes["StaffUpdateCourierEntityRelationInput"] | undefined,
	cleaner?: GraphQLTypes["StaffUpdateCleanerEntityRelationInput"] | undefined,
	shiftsManager?: GraphQLTypes["StaffUpdateShiftsManagerEntityRelationInput"] | undefined,
	businessToBusinessManager?: GraphQLTypes["StaffUpdateBusinessToBusinessManagerEntityRelationInput"] | undefined,
	user?: GraphQLTypes["StaffUpdateUserEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["StaffUpdateShiftsProfileEntityRelationInput"] | undefined,
	stocksManager?: GraphQLTypes["StaffUpdateStocksManagerEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["StaffUpdatePhotoEntityRelationInput"] | undefined,
	picker?: GraphQLTypes["StaffUpdatePickerEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	remunerationProfile?: GraphQLTypes["StaffUpdateRemunerationProfileEntityRelationInput"] | undefined,
	cashier?: GraphQLTypes["StaffUpdateCashierEntityRelationInput"] | undefined,
	venues?: Array<GraphQLTypes["StaffUpdateVenuesEntityRelationInput"]> | undefined,
	internalBuyer?: GraphQLTypes["StaffUpdateInternalBuyerEntityRelationInput"] | undefined,
	salesManager?: GraphQLTypes["StaffUpdateSalesManagerEntityRelationInput"] | undefined,
	cashierManager?: GraphQLTypes["StaffUpdateCashierManagerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CourierManagerUpsertStaffRelationInput"]: {
		update?: GraphQLTypes["StaffWithoutCourierManagerUpdateInput"] | undefined,
	create?: GraphQLTypes["StaffWithoutCourierManagerCreateInput"] | undefined
};
	["DeliveryZoneCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	type?: GraphQLTypes["DeliveryZoneType"] | undefined,
	addresses?: Array<GraphQLTypes["DeliveryZoneCreateAddressesEntityRelationInput"]> | undefined,
	suitableDeliveryMethods?: Array<GraphQLTypes["DeliveryZoneCreateSuitableDeliveryMethodsEntityRelationInput"]> | undefined,
	deliveryZonesOfTags?: Array<GraphQLTypes["DeliveryZoneCreateDeliveryZonesOfTagsEntityRelationInput"]> | undefined,
	deliveryZonesOfProducts?: Array<GraphQLTypes["DeliveryZoneCreateDeliveryZonesOfProductsEntityRelationInput"]> | undefined,
	addressesMetadata?: Array<GraphQLTypes["DeliveryZoneCreateAddressesMetadataEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryZoneUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	type?: GraphQLTypes["DeliveryZoneType"] | undefined,
	addresses?: Array<GraphQLTypes["DeliveryZoneUpdateAddressesEntityRelationInput"]> | undefined,
	suitableDeliveryMethods?: Array<GraphQLTypes["DeliveryZoneUpdateSuitableDeliveryMethodsEntityRelationInput"]> | undefined,
	deliveryZonesOfTags?: Array<GraphQLTypes["DeliveryZoneUpdateDeliveryZonesOfTagsEntityRelationInput"]> | undefined,
	deliveryZonesOfProducts?: Array<GraphQLTypes["DeliveryZoneUpdateDeliveryZonesOfProductsEntityRelationInput"]> | undefined,
	addressesMetadata?: Array<GraphQLTypes["DeliveryZoneUpdateAddressesMetadataEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryTimelinePresetConnection"]: {
	__typename: "DeliveryTimelinePresetConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DeliveryTimelinePresetEdge"]>
};
	["DeliveryTimelinePresetEdge"]: {
	__typename: "DeliveryTimelinePresetEdge",
	node: GraphQLTypes["DeliveryTimelinePreset"]
};
	["DeliveryTimelinePresetCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["DeliveryTimelineType"] | undefined,
	duration?: string | undefined,
	window?: string | undefined,
	deliveryMethod?: GraphQLTypes["DeliveryTimelinePresetCreateDeliveryMethodEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryTimelinePresetCreateDeliveryMethodEntityRelationInput"]: {
		connect?: GraphQLTypes["DeliveryMethodUniqueWhere"] | undefined,
	create?: GraphQLTypes["DeliveryMethodWithoutTimelinePresetCreateInput"] | undefined
};
	["DeliveryMethodWithoutTimelinePresetCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	code?: string | undefined,
	enabled?: boolean | undefined,
	paymentMethods?: Array<GraphQLTypes["DeliveryMethodCreatePaymentMethodsEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	requireDeliveryAddress?: boolean | undefined,
	suitableForDeliveryZones?: Array<GraphQLTypes["DeliveryMethodCreateSuitableForDeliveryZonesEntityRelationInput"]> | undefined,
	channels?: Array<GraphQLTypes["DeliveryMethodCreateChannelsEntityRelationInput"]> | undefined,
	courierHandlers?: Array<GraphQLTypes["DeliveryMethodCreateCourierHandlersEntityRelationInput"]> | undefined,
	enableDeliveryTracking?: boolean | undefined,
	locales?: Array<GraphQLTypes["DeliveryMethodCreateLocalesEntityRelationInput"]> | undefined,
	woltDriveVenueId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryTimelinePresetUpdateInput"]: {
		type?: GraphQLTypes["DeliveryTimelineType"] | undefined,
	duration?: string | undefined,
	window?: string | undefined,
	deliveryMethod?: GraphQLTypes["DeliveryTimelinePresetUpdateDeliveryMethodEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryTimelinePresetUpdateDeliveryMethodEntityRelationInput"]: {
		create?: GraphQLTypes["DeliveryMethodWithoutTimelinePresetCreateInput"] | undefined,
	update?: GraphQLTypes["DeliveryMethodWithoutTimelinePresetUpdateInput"] | undefined,
	upsert?: GraphQLTypes["DeliveryTimelinePresetUpsertDeliveryMethodRelationInput"] | undefined,
	connect?: GraphQLTypes["DeliveryMethodUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["DeliveryMethodWithoutTimelinePresetUpdateInput"]: {
		name?: string | undefined,
	code?: string | undefined,
	enabled?: boolean | undefined,
	paymentMethods?: Array<GraphQLTypes["DeliveryMethodUpdatePaymentMethodsEntityRelationInput"]> | undefined,
	description?: string | undefined,
	internalNote?: string | undefined,
	requireDeliveryAddress?: boolean | undefined,
	suitableForDeliveryZones?: Array<GraphQLTypes["DeliveryMethodUpdateSuitableForDeliveryZonesEntityRelationInput"]> | undefined,
	channels?: Array<GraphQLTypes["DeliveryMethodUpdateChannelsEntityRelationInput"]> | undefined,
	courierHandlers?: Array<GraphQLTypes["DeliveryMethodUpdateCourierHandlersEntityRelationInput"]> | undefined,
	enableDeliveryTracking?: boolean | undefined,
	locales?: Array<GraphQLTypes["DeliveryMethodUpdateLocalesEntityRelationInput"]> | undefined,
	woltDriveVenueId?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryTimelinePresetUpsertDeliveryMethodRelationInput"]: {
		update?: GraphQLTypes["DeliveryMethodWithoutTimelinePresetUpdateInput"] | undefined,
	create?: GraphQLTypes["DeliveryMethodWithoutTimelinePresetCreateInput"] | undefined
};
	["OrderDeliveryTimeline"]: {
	__typename: "OrderDeliveryTimeline",
	_meta?: GraphQLTypes["OrderDeliveryTimelineMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["DeliveryTimelineType"],
	prepareAt: GraphQLTypes["DateTime"],
	loadingHours?: number | undefined,
	dispatchAt: GraphQLTypes["DateTime"],
	duration?: string | undefined,
	window?: string | undefined,
	expectedEndAt?: GraphQLTypes["DateTime"] | undefined,
	expectedAt: GraphQLTypes["DateTime"]
};
	["OrderDeliveryTimelineMeta"]: {
	__typename: "OrderDeliveryTimelineMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	prepareAt?: GraphQLTypes["FieldMeta"] | undefined,
	loadingHours?: GraphQLTypes["FieldMeta"] | undefined,
	dispatchAt?: GraphQLTypes["FieldMeta"] | undefined,
	duration?: GraphQLTypes["FieldMeta"] | undefined,
	window?: GraphQLTypes["FieldMeta"] | undefined,
	expectedEndAt?: GraphQLTypes["FieldMeta"] | undefined,
	expectedAt?: GraphQLTypes["FieldMeta"] | undefined
};
	["OrderDeliveryTimelineUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["OrderDeliveryTimelineWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	type?: GraphQLTypes["DeliveryTimelineTypeCondition"] | undefined,
	prepareAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	loadingHours?: GraphQLTypes["IntCondition"] | undefined,
	dispatchAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	duration?: GraphQLTypes["StringCondition"] | undefined,
	window?: GraphQLTypes["StringCondition"] | undefined,
	expectedEndAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	expectedAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	and?: Array<GraphQLTypes["OrderDeliveryTimelineWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["OrderDeliveryTimelineWhere"] | undefined> | undefined,
	not?: GraphQLTypes["OrderDeliveryTimelineWhere"] | undefined
};
	["OrderDeliveryTimelineOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	prepareAt?: GraphQLTypes["OrderDirection"] | undefined,
	loadingHours?: GraphQLTypes["OrderDirection"] | undefined,
	dispatchAt?: GraphQLTypes["OrderDirection"] | undefined,
	duration?: GraphQLTypes["OrderDirection"] | undefined,
	window?: GraphQLTypes["OrderDirection"] | undefined,
	expectedEndAt?: GraphQLTypes["OrderDirection"] | undefined,
	expectedAt?: GraphQLTypes["OrderDirection"] | undefined
};
	["OrderDeliveryTimelineConnection"]: {
	__typename: "OrderDeliveryTimelineConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["OrderDeliveryTimelineEdge"]>
};
	["OrderDeliveryTimelineEdge"]: {
	__typename: "OrderDeliveryTimelineEdge",
	node: GraphQLTypes["OrderDeliveryTimeline"]
};
	["OrderDeliveryTimelineCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["DeliveryTimelineType"] | undefined,
	prepareAt?: GraphQLTypes["DateTime"] | undefined,
	loadingHours?: number | undefined,
	dispatchAt?: GraphQLTypes["DateTime"] | undefined,
	duration?: string | undefined,
	window?: string | undefined,
	expectedEndAt?: GraphQLTypes["DateTime"] | undefined,
	expectedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderDeliveryTimelineUpdateInput"]: {
		type?: GraphQLTypes["DeliveryTimelineType"] | undefined,
	prepareAt?: GraphQLTypes["DateTime"] | undefined,
	loadingHours?: number | undefined,
	dispatchAt?: GraphQLTypes["DateTime"] | undefined,
	duration?: string | undefined,
	window?: string | undefined,
	expectedEndAt?: GraphQLTypes["DateTime"] | undefined,
	expectedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderEventCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: string | undefined,
	data?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	order?: GraphQLTypes["OrderEventCreateOrderEntityRelationInput"] | undefined,
	payment?: GraphQLTypes["OrderEventCreatePaymentEntityRelationInput"] | undefined,
	delivery?: GraphQLTypes["OrderEventCreateDeliveryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["OrderEventUpdateInput"]: {
		type?: string | undefined,
	data?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	order?: GraphQLTypes["OrderEventUpdateOrderEntityRelationInput"] | undefined,
	payment?: GraphQLTypes["OrderEventUpdatePaymentEntityRelationInput"] | undefined,
	delivery?: GraphQLTypes["OrderEventUpdateDeliveryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LiftagoRideConnection"]: {
	__typename: "LiftagoRideConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LiftagoRideEdge"]>
};
	["LiftagoRideEdge"]: {
	__typename: "LiftagoRideEdge",
	node: GraphQLTypes["LiftagoRide"]
};
	["LiftagoRideCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	liftagoId?: string | undefined,
	data?: string | undefined,
	updatedAt?: GraphQLTypes["DateTime"] | undefined,
	delivery?: GraphQLTypes["LiftagoRideCreateDeliveryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LiftagoRideCreateDeliveryEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderDeliveryUniqueWhere"] | undefined,
	create?: GraphQLTypes["OrderDeliveryWithoutLiftagoRideCreateInput"] | undefined
};
	["OrderDeliveryWithoutLiftagoRideCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	priceCents?: number | undefined,
	deliveredAt?: GraphQLTypes["DateTime"] | undefined,
	method?: GraphQLTypes["OrderDeliveryCreateMethodEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["OrderDeliveryCreateVatRateEntityRelationInput"] | undefined,
	order?: GraphQLTypes["OrderDeliveryCreateOrderEntityRelationInput"] | undefined,
	expectedAt?: GraphQLTypes["DateTime"] | undefined,
	state?: GraphQLTypes["OrderDeliveryState"] | undefined,
	loadingDurationHours?: number | undefined,
	dispatchAt?: GraphQLTypes["DateTime"] | undefined,
	duration?: string | undefined,
	window?: string | undefined,
	expectedEndAt?: GraphQLTypes["DateTime"] | undefined,
	processingAt?: GraphQLTypes["DateTime"] | undefined,
	deliveringAt?: GraphQLTypes["DateTime"] | undefined,
	failedAt?: GraphQLTypes["DateTime"] | undefined,
	internalNote?: string | undefined,
	deliveryWaypoint?: GraphQLTypes["OrderDeliveryCreateDeliveryWaypointEntityRelationInput"] | undefined,
	events?: Array<GraphQLTypes["OrderDeliveryCreateEventsEntityRelationInput"]> | undefined,
	prepareAt?: GraphQLTypes["DateTime"] | undefined,
	pickedAt?: GraphQLTypes["DateTime"] | undefined,
	address?: GraphQLTypes["OrderDeliveryCreateAddressEntityRelationInput"] | undefined,
	trackingCode?: string | undefined,
	woltDriveDelivery?: GraphQLTypes["OrderDeliveryCreateWoltDriveDeliveryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LiftagoRideUpdateInput"]: {
		liftagoId?: string | undefined,
	data?: string | undefined,
	updatedAt?: GraphQLTypes["DateTime"] | undefined,
	delivery?: GraphQLTypes["LiftagoRideUpdateDeliveryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LiftagoRideUpdateDeliveryEntityRelationInput"]: {
		create?: GraphQLTypes["OrderDeliveryWithoutLiftagoRideCreateInput"] | undefined,
	update?: GraphQLTypes["OrderDeliveryWithoutLiftagoRideUpdateInput"] | undefined,
	upsert?: GraphQLTypes["LiftagoRideUpsertDeliveryRelationInput"] | undefined,
	connect?: GraphQLTypes["OrderDeliveryUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["OrderDeliveryWithoutLiftagoRideUpdateInput"]: {
		priceCents?: number | undefined,
	deliveredAt?: GraphQLTypes["DateTime"] | undefined,
	method?: GraphQLTypes["OrderDeliveryUpdateMethodEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["OrderDeliveryUpdateVatRateEntityRelationInput"] | undefined,
	order?: GraphQLTypes["OrderDeliveryUpdateOrderEntityRelationInput"] | undefined,
	expectedAt?: GraphQLTypes["DateTime"] | undefined,
	state?: GraphQLTypes["OrderDeliveryState"] | undefined,
	loadingDurationHours?: number | undefined,
	dispatchAt?: GraphQLTypes["DateTime"] | undefined,
	duration?: string | undefined,
	window?: string | undefined,
	expectedEndAt?: GraphQLTypes["DateTime"] | undefined,
	processingAt?: GraphQLTypes["DateTime"] | undefined,
	deliveringAt?: GraphQLTypes["DateTime"] | undefined,
	failedAt?: GraphQLTypes["DateTime"] | undefined,
	internalNote?: string | undefined,
	deliveryWaypoint?: GraphQLTypes["OrderDeliveryUpdateDeliveryWaypointEntityRelationInput"] | undefined,
	events?: Array<GraphQLTypes["OrderDeliveryUpdateEventsEntityRelationInput"]> | undefined,
	prepareAt?: GraphQLTypes["DateTime"] | undefined,
	pickedAt?: GraphQLTypes["DateTime"] | undefined,
	address?: GraphQLTypes["OrderDeliveryUpdateAddressEntityRelationInput"] | undefined,
	trackingCode?: string | undefined,
	woltDriveDelivery?: GraphQLTypes["OrderDeliveryUpdateWoltDriveDeliveryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LiftagoRideUpsertDeliveryRelationInput"]: {
		update?: GraphQLTypes["OrderDeliveryWithoutLiftagoRideUpdateInput"] | undefined,
	create?: GraphQLTypes["OrderDeliveryWithoutLiftagoRideCreateInput"] | undefined
};
	["InvoiceCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	publicKey?: string | undefined,
	fakturoidId?: string | undefined,
	fakturoidData?: string | undefined,
	legacyUrl?: string | undefined,
	customer?: GraphQLTypes["InvoiceCreateCustomerEntityRelationInput"] | undefined,
	orderPayments?: Array<GraphQLTypes["InvoiceCreateOrderPaymentsEntityRelationInput"]> | undefined,
	address?: GraphQLTypes["InvoiceCreateAddressEntityRelationInput"] | undefined,
	publicUrl?: string | undefined,
	billingSubject?: GraphQLTypes["InvoiceCreateBillingSubjectEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InvoiceUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	publicKey?: string | undefined,
	fakturoidId?: string | undefined,
	fakturoidData?: string | undefined,
	legacyUrl?: string | undefined,
	customer?: GraphQLTypes["InvoiceUpdateCustomerEntityRelationInput"] | undefined,
	orderPayments?: Array<GraphQLTypes["InvoiceUpdateOrderPaymentsEntityRelationInput"]> | undefined,
	address?: GraphQLTypes["InvoiceUpdateAddressEntityRelationInput"] | undefined,
	publicUrl?: string | undefined,
	billingSubject?: GraphQLTypes["InvoiceUpdateBillingSubjectEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InvoicingPlanConnection"]: {
	__typename: "InvoicingPlanConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["InvoicingPlanEdge"]>
};
	["InvoicingPlanEdge"]: {
	__typename: "InvoicingPlanEdge",
	node: GraphQLTypes["InvoicingPlan"]
};
	["InvoicingPlanCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	customer?: GraphQLTypes["InvoicingPlanCreateCustomerEntityRelationInput"] | undefined,
	preset?: GraphQLTypes["InvoicingPlanCreatePresetEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InvoicingPlanCreateCustomerEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerWithoutInvoicingPlanCreateInput"] | undefined
};
	["CustomerWithoutInvoicingPlanCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	addresses?: Array<GraphQLTypes["CustomerCreateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerCreateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerCreateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerCreateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerCreateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerCreatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerCreateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerCreatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerCreateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerCreatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerCreateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerCreateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerCreateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerCreateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerCreateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerCreateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerCreateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerCreateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerCreateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerCreateInvoicesEntityRelationInput"]> | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerCreateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerCreateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerCreateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerCreateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerCreateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerCreateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerCreateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerCreateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerCreateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerCreateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerCreateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerCreateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InvoicingPlanUpdateInput"]: {
		customer?: GraphQLTypes["InvoicingPlanUpdateCustomerEntityRelationInput"] | undefined,
	preset?: GraphQLTypes["InvoicingPlanUpdatePresetEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InvoicingPlanUpdateCustomerEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerWithoutInvoicingPlanCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerWithoutInvoicingPlanUpdateInput"] | undefined,
	upsert?: GraphQLTypes["InvoicingPlanUpsertCustomerRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["CustomerWithoutInvoicingPlanUpdateInput"]: {
		addresses?: Array<GraphQLTypes["CustomerUpdateAddressesEntityRelationInput"]> | undefined,
	defaultBillingAddress?: GraphQLTypes["CustomerUpdateDefaultBillingAddressEntityRelationInput"] | undefined,
	defaultPaymentMethod?: GraphQLTypes["CustomerUpdateDefaultPaymentMethodEntityRelationInput"] | undefined,
	tags?: Array<GraphQLTypes["CustomerUpdateTagsEntityRelationInput"]> | undefined,
	credits?: Array<GraphQLTypes["CustomerUpdateCreditsEntityRelationInput"]> | undefined,
	paymentMethods?: Array<GraphQLTypes["CustomerUpdatePaymentMethodsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["CustomerUpdateOrdersEntityRelationInput"]> | undefined,
	permissions?: GraphQLTypes["CustomerUpdatePermissionsEntityRelationInput"] | undefined,
	group?: GraphQLTypes["CustomerUpdateGroupEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["CustomerUpdatePhotoEntityRelationInput"] | undefined,
	phone?: string | undefined,
	name?: GraphQLTypes["CustomerUpdateNameEntityRelationInput"] | undefined,
	internalNote?: string | undefined,
	welcomeMessage?: string | undefined,
	familiarity?: GraphQLTypes["CustomerFamiliarity"] | undefined,
	ingredientRatings?: Array<GraphQLTypes["CustomerUpdateIngredientRatingsEntityRelationInput"]> | undefined,
	business?: GraphQLTypes["CustomerUpdateBusinessEntityRelationInput"] | undefined,
	ownerOfBusinesses?: Array<GraphQLTypes["CustomerUpdateOwnerOfBusinessesEntityRelationInput"]> | undefined,
	memberOfBusinesses?: Array<GraphQLTypes["CustomerUpdateMemberOfBusinessesEntityRelationInput"]> | undefined,
	carts?: Array<GraphQLTypes["CustomerUpdateCartsEntityRelationInput"]> | undefined,
	shortcutList?: GraphQLTypes["CustomerUpdateShortcutListEntityRelationInput"] | undefined,
	user?: GraphQLTypes["CustomerUpdateUserEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["CustomerUpdateChannelsEntityRelationInput"]> | undefined,
	disabledAt?: GraphQLTypes["DateTime"] | undefined,
	invoices?: Array<GraphQLTypes["CustomerUpdateInvoicesEntityRelationInput"]> | undefined,
	email?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingSubjects?: Array<GraphQLTypes["CustomerUpdateBillingSubjectsEntityRelationInput"]> | undefined,
	offeredProducts?: Array<GraphQLTypes["CustomerUpdateOfferedProductsEntityRelationInput"]> | undefined,
	defaultDeliveryAddress?: GraphQLTypes["CustomerUpdateDefaultDeliveryAddressEntityRelationInput"] | undefined,
	defaultBillingSubject?: GraphQLTypes["CustomerUpdateDefaultBillingSubjectEntityRelationInput"] | undefined,
	prefersPackingsWithoutCardboard?: boolean | undefined,
	anonymousSession?: GraphQLTypes["CustomerUpdateAnonymousSessionEntityRelationInput"] | undefined,
	boughtVouchers?: Array<GraphQLTypes["CustomerUpdateBoughtVouchersEntityRelationInput"]> | undefined,
	ownsVouchers?: Array<GraphQLTypes["CustomerUpdateOwnsVouchersEntityRelationInput"]> | undefined,
	redeemedVouchers?: Array<GraphQLTypes["CustomerUpdateRedeemedVouchersEntityRelationInput"]> | undefined,
	spending?: GraphQLTypes["CustomerUpdateSpendingEntityRelationInput"] | undefined,
	customerTabs?: Array<GraphQLTypes["CustomerUpdateCustomerTabsEntityRelationInput"]> | undefined,
	lead?: Array<GraphQLTypes["CustomerUpdateLeadEntityRelationInput"]> | undefined,
	doubleshotLegacyId?: string | undefined,
	meta?: GraphQLTypes["CustomerUpdateMetaEntityRelationInput"] | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InvoicingPlanUpsertCustomerRelationInput"]: {
		update?: GraphQLTypes["CustomerWithoutInvoicingPlanUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerWithoutInvoicingPlanCreateInput"] | undefined
};
	["ProductPackingLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	shortName?: string | undefined,
	description?: string | undefined,
	root?: GraphQLTypes["ProductPackingLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["ProductPackingLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductPackingLocaleUpdateInput"]: {
		name?: string | undefined,
	shortName?: string | undefined,
	description?: string | undefined,
	root?: GraphQLTypes["ProductPackingLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["ProductPackingLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	description?: string | undefined,
	root?: GraphQLTypes["ProductLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["ProductLocaleCreateLocaleEntityRelationInput"] | undefined,
	featureList?: GraphQLTypes["ProductLocaleCreateFeatureListEntityRelationInput"] | undefined,
	printableName?: string | undefined,
	firstSticker?: string | undefined,
	secondSticker?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductLocaleUpdateInput"]: {
		name?: string | undefined,
	description?: string | undefined,
	root?: GraphQLTypes["ProductLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["ProductLocaleUpdateLocaleEntityRelationInput"] | undefined,
	featureList?: GraphQLTypes["ProductLocaleUpdateFeatureListEntityRelationInput"] | undefined,
	printableName?: string | undefined,
	firstSticker?: string | undefined,
	secondSticker?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductRecipeLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	root?: GraphQLTypes["ProductRecipeLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["ProductRecipeLocaleCreateLocaleEntityRelationInput"] | undefined,
	description?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductRecipeLocaleUpdateInput"]: {
		name?: string | undefined,
	root?: GraphQLTypes["ProductRecipeLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["ProductRecipeLocaleUpdateLocaleEntityRelationInput"] | undefined,
	description?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserDeviceCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	lastActiveAt?: GraphQLTypes["DateTime"] | undefined,
	platform?: string | undefined,
	deviceId?: string | undefined,
	notificationsEnabled?: boolean | undefined,
	user?: GraphQLTypes["UserDeviceCreateUserEntityRelationInput"] | undefined,
	appVersion?: string | undefined,
	osVersion?: string | undefined,
	apiVersion?: string | undefined,
	anonymousSession?: GraphQLTypes["UserDeviceCreateAnonymousSessionEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UserDeviceUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	lastActiveAt?: GraphQLTypes["DateTime"] | undefined,
	platform?: string | undefined,
	deviceId?: string | undefined,
	notificationsEnabled?: boolean | undefined,
	user?: GraphQLTypes["UserDeviceUpdateUserEntityRelationInput"] | undefined,
	appVersion?: string | undefined,
	osVersion?: string | undefined,
	apiVersion?: string | undefined,
	anonymousSession?: GraphQLTypes["UserDeviceUpdateAnonymousSessionEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProtectedAction"]: {
	__typename: "ProtectedAction",
	_meta?: GraphQLTypes["ProtectedActionMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["ProtectedActionType"],
	data?: GraphQLTypes["Json"] | undefined,
	publicKey: string,
	secretKeyHash: string,
	confirmKeyHash?: string | undefined,
	url?: string | undefined,
	createdAt: GraphQLTypes["DateTime"],
	expiresAt?: GraphQLTypes["DateTime"] | undefined,
	usedAt?: GraphQLTypes["DateTime"] | undefined,
	service?: string | undefined
};
	["ProtectedActionMeta"]: {
	__typename: "ProtectedActionMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	data?: GraphQLTypes["FieldMeta"] | undefined,
	publicKey?: GraphQLTypes["FieldMeta"] | undefined,
	secretKeyHash?: GraphQLTypes["FieldMeta"] | undefined,
	confirmKeyHash?: GraphQLTypes["FieldMeta"] | undefined,
	url?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	expiresAt?: GraphQLTypes["FieldMeta"] | undefined,
	usedAt?: GraphQLTypes["FieldMeta"] | undefined,
	service?: GraphQLTypes["FieldMeta"] | undefined
};
	["ProtectedActionType"]: ProtectedActionType;
	["ProtectedActionUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	publicKey?: string | undefined
};
	["ProtectedActionWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	type?: GraphQLTypes["ProtectedActionTypeCondition"] | undefined,
	data?: GraphQLTypes["JsonCondition"] | undefined,
	publicKey?: GraphQLTypes["StringCondition"] | undefined,
	secretKeyHash?: GraphQLTypes["StringCondition"] | undefined,
	confirmKeyHash?: GraphQLTypes["StringCondition"] | undefined,
	url?: GraphQLTypes["StringCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	expiresAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	usedAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	service?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["ProtectedActionWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ProtectedActionWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ProtectedActionWhere"] | undefined
};
	["ProtectedActionTypeCondition"]: {
		and?: Array<GraphQLTypes["ProtectedActionTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["ProtectedActionTypeCondition"]> | undefined,
	not?: GraphQLTypes["ProtectedActionTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["ProtectedActionType"] | undefined,
	notEq?: GraphQLTypes["ProtectedActionType"] | undefined,
	in?: Array<GraphQLTypes["ProtectedActionType"]> | undefined,
	notIn?: Array<GraphQLTypes["ProtectedActionType"]> | undefined,
	lt?: GraphQLTypes["ProtectedActionType"] | undefined,
	lte?: GraphQLTypes["ProtectedActionType"] | undefined,
	gt?: GraphQLTypes["ProtectedActionType"] | undefined,
	gte?: GraphQLTypes["ProtectedActionType"] | undefined
};
	["ProtectedActionOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	data?: GraphQLTypes["OrderDirection"] | undefined,
	publicKey?: GraphQLTypes["OrderDirection"] | undefined,
	secretKeyHash?: GraphQLTypes["OrderDirection"] | undefined,
	confirmKeyHash?: GraphQLTypes["OrderDirection"] | undefined,
	url?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	expiresAt?: GraphQLTypes["OrderDirection"] | undefined,
	usedAt?: GraphQLTypes["OrderDirection"] | undefined,
	service?: GraphQLTypes["OrderDirection"] | undefined
};
	["ProtectedActionConnection"]: {
	__typename: "ProtectedActionConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProtectedActionEdge"]>
};
	["ProtectedActionEdge"]: {
	__typename: "ProtectedActionEdge",
	node: GraphQLTypes["ProtectedAction"]
};
	["ProtectedActionCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["ProtectedActionType"] | undefined,
	data?: GraphQLTypes["Json"] | undefined,
	publicKey?: string | undefined,
	secretKeyHash?: string | undefined,
	confirmKeyHash?: string | undefined,
	url?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	expiresAt?: GraphQLTypes["DateTime"] | undefined,
	usedAt?: GraphQLTypes["DateTime"] | undefined,
	service?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProtectedActionUpdateInput"]: {
		type?: GraphQLTypes["ProtectedActionType"] | undefined,
	data?: GraphQLTypes["Json"] | undefined,
	publicKey?: string | undefined,
	secretKeyHash?: string | undefined,
	confirmKeyHash?: string | undefined,
	url?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	expiresAt?: GraphQLTypes["DateTime"] | undefined,
	usedAt?: GraphQLTypes["DateTime"] | undefined,
	service?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["PickerConnection"]: {
	__typename: "PickerConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PickerEdge"]>
};
	["PickerEdge"]: {
	__typename: "PickerEdge",
	node: GraphQLTypes["Picker"]
};
	["PickerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	staff?: GraphQLTypes["PickerCreateStaffEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PickerCreateStaffEntityRelationInput"]: {
		connect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	create?: GraphQLTypes["StaffWithoutPickerCreateInput"] | undefined
};
	["StaffWithoutPickerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	bartender?: GraphQLTypes["StaffCreateBartenderEntityRelationInput"] | undefined,
	courier?: GraphQLTypes["StaffCreateCourierEntityRelationInput"] | undefined,
	cleaner?: GraphQLTypes["StaffCreateCleanerEntityRelationInput"] | undefined,
	shiftsManager?: GraphQLTypes["StaffCreateShiftsManagerEntityRelationInput"] | undefined,
	businessToBusinessManager?: GraphQLTypes["StaffCreateBusinessToBusinessManagerEntityRelationInput"] | undefined,
	user?: GraphQLTypes["StaffCreateUserEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["StaffCreateShiftsProfileEntityRelationInput"] | undefined,
	stocksManager?: GraphQLTypes["StaffCreateStocksManagerEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["StaffCreatePhotoEntityRelationInput"] | undefined,
	courierManager?: GraphQLTypes["StaffCreateCourierManagerEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	remunerationProfile?: GraphQLTypes["StaffCreateRemunerationProfileEntityRelationInput"] | undefined,
	cashier?: GraphQLTypes["StaffCreateCashierEntityRelationInput"] | undefined,
	venues?: Array<GraphQLTypes["StaffCreateVenuesEntityRelationInput"]> | undefined,
	internalBuyer?: GraphQLTypes["StaffCreateInternalBuyerEntityRelationInput"] | undefined,
	salesManager?: GraphQLTypes["StaffCreateSalesManagerEntityRelationInput"] | undefined,
	cashierManager?: GraphQLTypes["StaffCreateCashierManagerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PickerUpdateInput"]: {
		staff?: GraphQLTypes["PickerUpdateStaffEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PickerUpdateStaffEntityRelationInput"]: {
		create?: GraphQLTypes["StaffWithoutPickerCreateInput"] | undefined,
	update?: GraphQLTypes["StaffWithoutPickerUpdateInput"] | undefined,
	upsert?: GraphQLTypes["PickerUpsertStaffRelationInput"] | undefined,
	connect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["StaffWithoutPickerUpdateInput"]: {
		bartender?: GraphQLTypes["StaffUpdateBartenderEntityRelationInput"] | undefined,
	courier?: GraphQLTypes["StaffUpdateCourierEntityRelationInput"] | undefined,
	cleaner?: GraphQLTypes["StaffUpdateCleanerEntityRelationInput"] | undefined,
	shiftsManager?: GraphQLTypes["StaffUpdateShiftsManagerEntityRelationInput"] | undefined,
	businessToBusinessManager?: GraphQLTypes["StaffUpdateBusinessToBusinessManagerEntityRelationInput"] | undefined,
	user?: GraphQLTypes["StaffUpdateUserEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["StaffUpdateShiftsProfileEntityRelationInput"] | undefined,
	stocksManager?: GraphQLTypes["StaffUpdateStocksManagerEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["StaffUpdatePhotoEntityRelationInput"] | undefined,
	courierManager?: GraphQLTypes["StaffUpdateCourierManagerEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	remunerationProfile?: GraphQLTypes["StaffUpdateRemunerationProfileEntityRelationInput"] | undefined,
	cashier?: GraphQLTypes["StaffUpdateCashierEntityRelationInput"] | undefined,
	venues?: Array<GraphQLTypes["StaffUpdateVenuesEntityRelationInput"]> | undefined,
	internalBuyer?: GraphQLTypes["StaffUpdateInternalBuyerEntityRelationInput"] | undefined,
	salesManager?: GraphQLTypes["StaffUpdateSalesManagerEntityRelationInput"] | undefined,
	cashierManager?: GraphQLTypes["StaffUpdateCashierManagerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PickerUpsertStaffRelationInput"]: {
		update?: GraphQLTypes["StaffWithoutPickerUpdateInput"] | undefined,
	create?: GraphQLTypes["StaffWithoutPickerCreateInput"] | undefined
};
	["TenantPerson"]: {
	__typename: "TenantPerson",
	_meta?: GraphQLTypes["TenantPersonMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	email?: string | undefined,
	externalIdentifier?: string | undefined,
	personId: GraphQLTypes["UUID"],
	identityId: GraphQLTypes["UUID"],
	globalRoles?: GraphQLTypes["Json"] | undefined,
	projectRoles?: GraphQLTypes["Json"] | undefined,
	projectRolesString?: string | undefined,
	externalIdentifiers?: GraphQLTypes["Json"] | undefined,
	externalIdentifiersString?: string | undefined
};
	["TenantPersonMeta"]: {
	__typename: "TenantPersonMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	email?: GraphQLTypes["FieldMeta"] | undefined,
	externalIdentifier?: GraphQLTypes["FieldMeta"] | undefined,
	personId?: GraphQLTypes["FieldMeta"] | undefined,
	identityId?: GraphQLTypes["FieldMeta"] | undefined,
	globalRoles?: GraphQLTypes["FieldMeta"] | undefined,
	projectRoles?: GraphQLTypes["FieldMeta"] | undefined,
	projectRolesString?: GraphQLTypes["FieldMeta"] | undefined,
	externalIdentifiers?: GraphQLTypes["FieldMeta"] | undefined,
	externalIdentifiersString?: GraphQLTypes["FieldMeta"] | undefined
};
	["TenantPersonUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["TenantPersonWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	email?: GraphQLTypes["StringCondition"] | undefined,
	externalIdentifier?: GraphQLTypes["StringCondition"] | undefined,
	personId?: GraphQLTypes["UUIDCondition"] | undefined,
	identityId?: GraphQLTypes["UUIDCondition"] | undefined,
	globalRoles?: GraphQLTypes["JsonCondition"] | undefined,
	projectRoles?: GraphQLTypes["JsonCondition"] | undefined,
	projectRolesString?: GraphQLTypes["StringCondition"] | undefined,
	externalIdentifiers?: GraphQLTypes["JsonCondition"] | undefined,
	externalIdentifiersString?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["TenantPersonWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["TenantPersonWhere"] | undefined> | undefined,
	not?: GraphQLTypes["TenantPersonWhere"] | undefined
};
	["TenantPersonOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	email?: GraphQLTypes["OrderDirection"] | undefined,
	externalIdentifier?: GraphQLTypes["OrderDirection"] | undefined,
	personId?: GraphQLTypes["OrderDirection"] | undefined,
	identityId?: GraphQLTypes["OrderDirection"] | undefined,
	globalRoles?: GraphQLTypes["OrderDirection"] | undefined,
	projectRoles?: GraphQLTypes["OrderDirection"] | undefined,
	projectRolesString?: GraphQLTypes["OrderDirection"] | undefined,
	externalIdentifiers?: GraphQLTypes["OrderDirection"] | undefined,
	externalIdentifiersString?: GraphQLTypes["OrderDirection"] | undefined
};
	["TenantPersonConnection"]: {
	__typename: "TenantPersonConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TenantPersonEdge"]>
};
	["TenantPersonEdge"]: {
	__typename: "TenantPersonEdge",
	node: GraphQLTypes["TenantPerson"]
};
	["TimetableTemplateStaffOptionsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	startTime?: string | undefined,
	endTime?: string | undefined,
	timetableTemplate?: GraphQLTypes["TimetableTemplateStaffOptionsCreateTimetableTemplateEntityRelationInput"] | undefined,
	autoAssignedEmployee?: GraphQLTypes["TimetableTemplateStaffOptionsCreateAutoAssignedEmployeeEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableTemplateStaffOptionsCreateTimetableTemplateEntityRelationInput"]: {
		connect?: GraphQLTypes["TimetableTemplateUniqueWhere"] | undefined,
	create?: GraphQLTypes["TimetableTemplateWithoutStaffOptionsCreateInput"] | undefined
};
	["TimetableTemplateWithoutStaffOptionsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	startDate?: GraphQLTypes["Date"] | undefined,
	period?: number | undefined,
	slots?: number | undefined,
	position?: GraphQLTypes["TimetableTemplateCreatePositionEntityRelationInput"] | undefined,
	internalName?: string | undefined,
	venue?: GraphQLTypes["TimetableTemplateCreateVenueEntityRelationInput"] | undefined,
	employeeRole?: GraphQLTypes["TimetableTemplateCreateEmployeeRoleEntityRelationInput"] | undefined,
	workdaysOnly?: boolean | undefined,
	monday?: boolean | undefined,
	tuesday?: boolean | undefined,
	wednesday?: boolean | undefined,
	thursday?: boolean | undefined,
	friday?: boolean | undefined,
	saturday?: boolean | undefined,
	sunday?: boolean | undefined,
	type?: GraphQLTypes["TemplateType"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableTemplateStaffOptionsUpdateInput"]: {
		startTime?: string | undefined,
	endTime?: string | undefined,
	timetableTemplate?: GraphQLTypes["TimetableTemplateStaffOptionsUpdateTimetableTemplateEntityRelationInput"] | undefined,
	autoAssignedEmployee?: GraphQLTypes["TimetableTemplateStaffOptionsUpdateAutoAssignedEmployeeEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableTemplateStaffOptionsUpdateTimetableTemplateEntityRelationInput"]: {
		create?: GraphQLTypes["TimetableTemplateWithoutStaffOptionsCreateInput"] | undefined,
	update?: GraphQLTypes["TimetableTemplateWithoutStaffOptionsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TimetableTemplateStaffOptionsUpsertTimetableTemplateRelationInput"] | undefined,
	connect?: GraphQLTypes["TimetableTemplateUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TimetableTemplateWithoutStaffOptionsUpdateInput"]: {
		order?: number | undefined,
	startDate?: GraphQLTypes["Date"] | undefined,
	period?: number | undefined,
	slots?: number | undefined,
	position?: GraphQLTypes["TimetableTemplateUpdatePositionEntityRelationInput"] | undefined,
	internalName?: string | undefined,
	venue?: GraphQLTypes["TimetableTemplateUpdateVenueEntityRelationInput"] | undefined,
	employeeRole?: GraphQLTypes["TimetableTemplateUpdateEmployeeRoleEntityRelationInput"] | undefined,
	workdaysOnly?: boolean | undefined,
	monday?: boolean | undefined,
	tuesday?: boolean | undefined,
	wednesday?: boolean | undefined,
	thursday?: boolean | undefined,
	friday?: boolean | undefined,
	saturday?: boolean | undefined,
	sunday?: boolean | undefined,
	type?: GraphQLTypes["TemplateType"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableTemplateStaffOptionsUpsertTimetableTemplateRelationInput"]: {
		update?: GraphQLTypes["TimetableTemplateWithoutStaffOptionsUpdateInput"] | undefined,
	create?: GraphQLTypes["TimetableTemplateWithoutStaffOptionsCreateInput"] | undefined
};
	["ShoppingList"]: {
	__typename: "ShoppingList",
	_meta?: GraphQLTypes["ShoppingListMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt: GraphQLTypes["DateTime"],
	items: Array<GraphQLTypes["ShoppingListItem"]>,
	supplier?: GraphQLTypes["IngredientSupplier"] | undefined,
	paginateItems: GraphQLTypes["ShoppingListItemConnection"]
};
	["ShoppingListMeta"]: {
	__typename: "ShoppingListMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined,
	supplier?: GraphQLTypes["FieldMeta"] | undefined
};
	["ShoppingListItem"]: {
	__typename: "ShoppingListItem",
	_meta?: GraphQLTypes["ShoppingListItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	amount?: number | undefined,
	list?: GraphQLTypes["ShoppingList"] | undefined,
	ingredient?: GraphQLTypes["ProductIngredient"] | undefined,
	preferredUnit?: GraphQLTypes["ProductIngredientItemQuantityUnit"] | undefined,
	wasPurcahsed?: boolean | undefined,
	wasTransferred?: boolean | undefined
};
	["ShoppingListItemMeta"]: {
	__typename: "ShoppingListItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	amount?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	ingredient?: GraphQLTypes["FieldMeta"] | undefined,
	preferredUnit?: GraphQLTypes["FieldMeta"] | undefined,
	wasPurcahsed?: GraphQLTypes["FieldMeta"] | undefined,
	wasTransferred?: GraphQLTypes["FieldMeta"] | undefined
};
	["ShoppingListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	items?: GraphQLTypes["ShoppingListItemWhere"] | undefined,
	supplier?: GraphQLTypes["IngredientSupplierWhere"] | undefined,
	and?: Array<GraphQLTypes["ShoppingListWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ShoppingListWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ShoppingListWhere"] | undefined
};
	["ShoppingListItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	amount?: GraphQLTypes["IntCondition"] | undefined,
	list?: GraphQLTypes["ShoppingListWhere"] | undefined,
	ingredient?: GraphQLTypes["ProductIngredientWhere"] | undefined,
	preferredUnit?: GraphQLTypes["ProductIngredientItemQuantityUnitWhere"] | undefined,
	wasPurcahsed?: GraphQLTypes["BooleanCondition"] | undefined,
	wasTransferred?: GraphQLTypes["BooleanCondition"] | undefined,
	and?: Array<GraphQLTypes["ShoppingListItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ShoppingListItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ShoppingListItemWhere"] | undefined
};
	["ShoppingListItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	amount?: GraphQLTypes["OrderDirection"] | undefined,
	list?: GraphQLTypes["ShoppingListOrderBy"] | undefined,
	ingredient?: GraphQLTypes["ProductIngredientOrderBy"] | undefined,
	preferredUnit?: GraphQLTypes["ProductIngredientItemQuantityUnitOrderBy"] | undefined,
	wasPurcahsed?: GraphQLTypes["OrderDirection"] | undefined,
	wasTransferred?: GraphQLTypes["OrderDirection"] | undefined
};
	["ShoppingListOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	supplier?: GraphQLTypes["IngredientSupplierOrderBy"] | undefined
};
	["ShoppingListItemConnection"]: {
	__typename: "ShoppingListItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ShoppingListItemEdge"]>
};
	["ShoppingListItemEdge"]: {
	__typename: "ShoppingListItemEdge",
	node: GraphQLTypes["ShoppingListItem"]
};
	["ShoppingListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	supplier?: GraphQLTypes["IngredientSupplierUniqueWhere"] | undefined,
	items?: GraphQLTypes["ShoppingListItemUniqueWhere"] | undefined
};
	["ShoppingListItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["ShoppingListConnection"]: {
	__typename: "ShoppingListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ShoppingListEdge"]>
};
	["ShoppingListEdge"]: {
	__typename: "ShoppingListEdge",
	node: GraphQLTypes["ShoppingList"]
};
	["ShoppingListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	items?: Array<GraphQLTypes["ShoppingListCreateItemsEntityRelationInput"]> | undefined,
	supplier?: GraphQLTypes["ShoppingListCreateSupplierEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ShoppingListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["ShoppingListItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["ShoppingListItemWithoutListCreateInput"] | undefined,
	alias?: string | undefined
};
	["ShoppingListItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	amount?: number | undefined,
	ingredient?: GraphQLTypes["ShoppingListItemCreateIngredientEntityRelationInput"] | undefined,
	preferredUnit?: GraphQLTypes["ShoppingListItemCreatePreferredUnitEntityRelationInput"] | undefined,
	wasPurcahsed?: boolean | undefined,
	wasTransferred?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ShoppingListItemCreateIngredientEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductIngredientUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductIngredientCreateInput"] | undefined
};
	["ShoppingListItemCreatePreferredUnitEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductIngredientItemQuantityUnitUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductIngredientItemQuantityUnitCreateInput"] | undefined
};
	["ShoppingListCreateSupplierEntityRelationInput"]: {
		connect?: GraphQLTypes["IngredientSupplierUniqueWhere"] | undefined,
	create?: GraphQLTypes["IngredientSupplierCreateInput"] | undefined
};
	["ShoppingListUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	items?: Array<GraphQLTypes["ShoppingListUpdateItemsEntityRelationInput"]> | undefined,
	supplier?: GraphQLTypes["ShoppingListUpdateSupplierEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ShoppingListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["ShoppingListItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["ShoppingListUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["ShoppingListUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["ShoppingListItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ShoppingListItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ShoppingListItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ShoppingListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["ShoppingListItemUniqueWhere"] | undefined,
	data?: GraphQLTypes["ShoppingListItemWithoutListUpdateInput"] | undefined
};
	["ShoppingListItemWithoutListUpdateInput"]: {
		amount?: number | undefined,
	ingredient?: GraphQLTypes["ShoppingListItemUpdateIngredientEntityRelationInput"] | undefined,
	preferredUnit?: GraphQLTypes["ShoppingListItemUpdatePreferredUnitEntityRelationInput"] | undefined,
	wasPurcahsed?: boolean | undefined,
	wasTransferred?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ShoppingListItemUpdateIngredientEntityRelationInput"]: {
		create?: GraphQLTypes["ProductIngredientCreateInput"] | undefined,
	update?: GraphQLTypes["ProductIngredientUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ShoppingListItemUpsertIngredientRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductIngredientUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["ShoppingListItemUpsertIngredientRelationInput"]: {
		update?: GraphQLTypes["ProductIngredientUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductIngredientCreateInput"] | undefined
};
	["ShoppingListItemUpdatePreferredUnitEntityRelationInput"]: {
		create?: GraphQLTypes["ProductIngredientItemQuantityUnitCreateInput"] | undefined,
	update?: GraphQLTypes["ProductIngredientItemQuantityUnitUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ShoppingListItemUpsertPreferredUnitRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductIngredientItemQuantityUnitUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ShoppingListItemUpsertPreferredUnitRelationInput"]: {
		update?: GraphQLTypes["ProductIngredientItemQuantityUnitUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductIngredientItemQuantityUnitCreateInput"] | undefined
};
	["ShoppingListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["ShoppingListItemUniqueWhere"] | undefined,
	update?: GraphQLTypes["ShoppingListItemWithoutListUpdateInput"] | undefined,
	create?: GraphQLTypes["ShoppingListItemWithoutListCreateInput"] | undefined
};
	["ShoppingListUpdateSupplierEntityRelationInput"]: {
		create?: GraphQLTypes["IngredientSupplierCreateInput"] | undefined,
	update?: GraphQLTypes["IngredientSupplierUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ShoppingListUpsertSupplierRelationInput"] | undefined,
	connect?: GraphQLTypes["IngredientSupplierUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["ShoppingListUpsertSupplierRelationInput"]: {
		update?: GraphQLTypes["IngredientSupplierUpdateInput"] | undefined,
	create?: GraphQLTypes["IngredientSupplierCreateInput"] | undefined
};
	["SuppliesPurchase"]: {
	__typename: "SuppliesPurchase",
	_meta?: GraphQLTypes["SuppliesPurchaseMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	createdAt: GraphQLTypes["DateTime"],
	items: Array<GraphQLTypes["SuppliesPurchaseItem"]>,
	supplier?: GraphQLTypes["IngredientSupplier"] | undefined,
	requestedDeliveryDate?: GraphQLTypes["Date"] | undefined,
	paginateItems: GraphQLTypes["SuppliesPurchaseItemConnection"]
};
	["SuppliesPurchaseMeta"]: {
	__typename: "SuppliesPurchaseMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined,
	supplier?: GraphQLTypes["FieldMeta"] | undefined,
	requestedDeliveryDate?: GraphQLTypes["FieldMeta"] | undefined
};
	["SuppliesPurchaseItem"]: {
	__typename: "SuppliesPurchaseItem",
	_meta?: GraphQLTypes["SuppliesPurchaseItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	amount?: number | undefined,
	list?: GraphQLTypes["SuppliesPurchase"] | undefined,
	ingredient?: GraphQLTypes["ProductIngredient"] | undefined,
	pricePaidCents?: number | undefined,
	preferredUnit?: GraphQLTypes["ProductIngredientItemQuantityUnit"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	purchasedAt?: GraphQLTypes["DateTime"] | undefined,
	purchasedBy?: GraphQLTypes["Staff"] | undefined
};
	["SuppliesPurchaseItemMeta"]: {
	__typename: "SuppliesPurchaseItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	amount?: GraphQLTypes["FieldMeta"] | undefined,
	list?: GraphQLTypes["FieldMeta"] | undefined,
	ingredient?: GraphQLTypes["FieldMeta"] | undefined,
	pricePaidCents?: GraphQLTypes["FieldMeta"] | undefined,
	preferredUnit?: GraphQLTypes["FieldMeta"] | undefined,
	deletedAt?: GraphQLTypes["FieldMeta"] | undefined,
	purchasedAt?: GraphQLTypes["FieldMeta"] | undefined,
	purchasedBy?: GraphQLTypes["FieldMeta"] | undefined
};
	["SuppliesPurchaseWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	items?: GraphQLTypes["SuppliesPurchaseItemWhere"] | undefined,
	supplier?: GraphQLTypes["IngredientSupplierWhere"] | undefined,
	requestedDeliveryDate?: GraphQLTypes["DateCondition"] | undefined,
	and?: Array<GraphQLTypes["SuppliesPurchaseWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["SuppliesPurchaseWhere"] | undefined> | undefined,
	not?: GraphQLTypes["SuppliesPurchaseWhere"] | undefined
};
	["SuppliesPurchaseItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	amount?: GraphQLTypes["IntCondition"] | undefined,
	list?: GraphQLTypes["SuppliesPurchaseWhere"] | undefined,
	ingredient?: GraphQLTypes["ProductIngredientWhere"] | undefined,
	pricePaidCents?: GraphQLTypes["IntCondition"] | undefined,
	preferredUnit?: GraphQLTypes["ProductIngredientItemQuantityUnitWhere"] | undefined,
	deletedAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	purchasedAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	purchasedBy?: GraphQLTypes["StaffWhere"] | undefined,
	and?: Array<GraphQLTypes["SuppliesPurchaseItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["SuppliesPurchaseItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["SuppliesPurchaseItemWhere"] | undefined
};
	["SuppliesPurchaseItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	amount?: GraphQLTypes["OrderDirection"] | undefined,
	list?: GraphQLTypes["SuppliesPurchaseOrderBy"] | undefined,
	ingredient?: GraphQLTypes["ProductIngredientOrderBy"] | undefined,
	pricePaidCents?: GraphQLTypes["OrderDirection"] | undefined,
	preferredUnit?: GraphQLTypes["ProductIngredientItemQuantityUnitOrderBy"] | undefined,
	deletedAt?: GraphQLTypes["OrderDirection"] | undefined,
	purchasedAt?: GraphQLTypes["OrderDirection"] | undefined,
	purchasedBy?: GraphQLTypes["StaffOrderBy"] | undefined
};
	["SuppliesPurchaseOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	supplier?: GraphQLTypes["IngredientSupplierOrderBy"] | undefined,
	requestedDeliveryDate?: GraphQLTypes["OrderDirection"] | undefined
};
	["SuppliesPurchaseItemConnection"]: {
	__typename: "SuppliesPurchaseItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SuppliesPurchaseItemEdge"]>
};
	["SuppliesPurchaseItemEdge"]: {
	__typename: "SuppliesPurchaseItemEdge",
	node: GraphQLTypes["SuppliesPurchaseItem"]
};
	["SuppliesPurchaseUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	supplier?: GraphQLTypes["IngredientSupplierUniqueWhere"] | undefined,
	items?: GraphQLTypes["SuppliesPurchaseItemUniqueWhere"] | undefined
};
	["SuppliesPurchaseItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["SuppliesPurchaseConnection"]: {
	__typename: "SuppliesPurchaseConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SuppliesPurchaseEdge"]>
};
	["SuppliesPurchaseEdge"]: {
	__typename: "SuppliesPurchaseEdge",
	node: GraphQLTypes["SuppliesPurchase"]
};
	["SuppliesPurchaseCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	items?: Array<GraphQLTypes["SuppliesPurchaseCreateItemsEntityRelationInput"]> | undefined,
	supplier?: GraphQLTypes["SuppliesPurchaseCreateSupplierEntityRelationInput"] | undefined,
	requestedDeliveryDate?: GraphQLTypes["Date"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SuppliesPurchaseCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["SuppliesPurchaseItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["SuppliesPurchaseItemWithoutListCreateInput"] | undefined,
	alias?: string | undefined
};
	["SuppliesPurchaseItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	amount?: number | undefined,
	ingredient?: GraphQLTypes["SuppliesPurchaseItemCreateIngredientEntityRelationInput"] | undefined,
	pricePaidCents?: number | undefined,
	preferredUnit?: GraphQLTypes["SuppliesPurchaseItemCreatePreferredUnitEntityRelationInput"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	purchasedAt?: GraphQLTypes["DateTime"] | undefined,
	purchasedBy?: GraphQLTypes["SuppliesPurchaseItemCreatePurchasedByEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SuppliesPurchaseItemCreateIngredientEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductIngredientUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductIngredientCreateInput"] | undefined
};
	["SuppliesPurchaseItemCreatePreferredUnitEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductIngredientItemQuantityUnitUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductIngredientItemQuantityUnitCreateInput"] | undefined
};
	["SuppliesPurchaseItemCreatePurchasedByEntityRelationInput"]: {
		connect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	create?: GraphQLTypes["StaffCreateInput"] | undefined
};
	["SuppliesPurchaseCreateSupplierEntityRelationInput"]: {
		connect?: GraphQLTypes["IngredientSupplierUniqueWhere"] | undefined,
	create?: GraphQLTypes["IngredientSupplierCreateInput"] | undefined
};
	["SuppliesPurchaseUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	items?: Array<GraphQLTypes["SuppliesPurchaseUpdateItemsEntityRelationInput"]> | undefined,
	supplier?: GraphQLTypes["SuppliesPurchaseUpdateSupplierEntityRelationInput"] | undefined,
	requestedDeliveryDate?: GraphQLTypes["Date"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SuppliesPurchaseUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["SuppliesPurchaseItemWithoutListCreateInput"] | undefined,
	update?: GraphQLTypes["SuppliesPurchaseUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["SuppliesPurchaseUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["SuppliesPurchaseItemUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["SuppliesPurchaseItemUniqueWhere"] | undefined,
	delete?: GraphQLTypes["SuppliesPurchaseItemUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["SuppliesPurchaseUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["SuppliesPurchaseItemUniqueWhere"] | undefined,
	data?: GraphQLTypes["SuppliesPurchaseItemWithoutListUpdateInput"] | undefined
};
	["SuppliesPurchaseItemWithoutListUpdateInput"]: {
		amount?: number | undefined,
	ingredient?: GraphQLTypes["SuppliesPurchaseItemUpdateIngredientEntityRelationInput"] | undefined,
	pricePaidCents?: number | undefined,
	preferredUnit?: GraphQLTypes["SuppliesPurchaseItemUpdatePreferredUnitEntityRelationInput"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	purchasedAt?: GraphQLTypes["DateTime"] | undefined,
	purchasedBy?: GraphQLTypes["SuppliesPurchaseItemUpdatePurchasedByEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SuppliesPurchaseItemUpdateIngredientEntityRelationInput"]: {
		create?: GraphQLTypes["ProductIngredientCreateInput"] | undefined,
	update?: GraphQLTypes["ProductIngredientUpdateInput"] | undefined,
	upsert?: GraphQLTypes["SuppliesPurchaseItemUpsertIngredientRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductIngredientUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["SuppliesPurchaseItemUpsertIngredientRelationInput"]: {
		update?: GraphQLTypes["ProductIngredientUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductIngredientCreateInput"] | undefined
};
	["SuppliesPurchaseItemUpdatePreferredUnitEntityRelationInput"]: {
		create?: GraphQLTypes["ProductIngredientItemQuantityUnitCreateInput"] | undefined,
	update?: GraphQLTypes["ProductIngredientItemQuantityUnitUpdateInput"] | undefined,
	upsert?: GraphQLTypes["SuppliesPurchaseItemUpsertPreferredUnitRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductIngredientItemQuantityUnitUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["SuppliesPurchaseItemUpsertPreferredUnitRelationInput"]: {
		update?: GraphQLTypes["ProductIngredientItemQuantityUnitUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductIngredientItemQuantityUnitCreateInput"] | undefined
};
	["SuppliesPurchaseItemUpdatePurchasedByEntityRelationInput"]: {
		create?: GraphQLTypes["StaffCreateInput"] | undefined,
	update?: GraphQLTypes["StaffUpdateInput"] | undefined,
	upsert?: GraphQLTypes["SuppliesPurchaseItemUpsertPurchasedByRelationInput"] | undefined,
	connect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["SuppliesPurchaseItemUpsertPurchasedByRelationInput"]: {
		update?: GraphQLTypes["StaffUpdateInput"] | undefined,
	create?: GraphQLTypes["StaffCreateInput"] | undefined
};
	["SuppliesPurchaseUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["SuppliesPurchaseItemUniqueWhere"] | undefined,
	update?: GraphQLTypes["SuppliesPurchaseItemWithoutListUpdateInput"] | undefined,
	create?: GraphQLTypes["SuppliesPurchaseItemWithoutListCreateInput"] | undefined
};
	["SuppliesPurchaseUpdateSupplierEntityRelationInput"]: {
		create?: GraphQLTypes["IngredientSupplierCreateInput"] | undefined,
	update?: GraphQLTypes["IngredientSupplierUpdateInput"] | undefined,
	upsert?: GraphQLTypes["SuppliesPurchaseUpsertSupplierRelationInput"] | undefined,
	connect?: GraphQLTypes["IngredientSupplierUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["SuppliesPurchaseUpsertSupplierRelationInput"]: {
		update?: GraphQLTypes["IngredientSupplierUpdateInput"] | undefined,
	create?: GraphQLTypes["IngredientSupplierCreateInput"] | undefined
};
	["InvoicingPresetConnection"]: {
	__typename: "InvoicingPresetConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["InvoicingPresetEdge"]>
};
	["InvoicingPresetEdge"]: {
	__typename: "InvoicingPresetEdge",
	node: GraphQLTypes["InvoicingPreset"]
};
	["InvoicingPresetCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["InvoicingPresetType"] | undefined,
	startsAt?: GraphQLTypes["DateTime"] | undefined,
	endsAt?: GraphQLTypes["DateTime"] | undefined,
	intervalOfDays?: number | undefined,
	invoicingPlan?: GraphQLTypes["InvoicingPresetCreateInvoicingPlanEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InvoicingPresetCreateInvoicingPlanEntityRelationInput"]: {
		connect?: GraphQLTypes["InvoicingPlanUniqueWhere"] | undefined,
	create?: GraphQLTypes["InvoicingPlanWithoutPresetCreateInput"] | undefined
};
	["InvoicingPlanWithoutPresetCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	customer?: GraphQLTypes["InvoicingPlanCreateCustomerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InvoicingPresetUpdateInput"]: {
		type?: GraphQLTypes["InvoicingPresetType"] | undefined,
	startsAt?: GraphQLTypes["DateTime"] | undefined,
	endsAt?: GraphQLTypes["DateTime"] | undefined,
	intervalOfDays?: number | undefined,
	invoicingPlan?: GraphQLTypes["InvoicingPresetUpdateInvoicingPlanEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InvoicingPresetUpdateInvoicingPlanEntityRelationInput"]: {
		create?: GraphQLTypes["InvoicingPlanWithoutPresetCreateInput"] | undefined,
	update?: GraphQLTypes["InvoicingPlanWithoutPresetUpdateInput"] | undefined,
	upsert?: GraphQLTypes["InvoicingPresetUpsertInvoicingPlanRelationInput"] | undefined,
	connect?: GraphQLTypes["InvoicingPlanUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["InvoicingPlanWithoutPresetUpdateInput"]: {
		customer?: GraphQLTypes["InvoicingPlanUpdateCustomerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InvoicingPresetUpsertInvoicingPlanRelationInput"]: {
		update?: GraphQLTypes["InvoicingPlanWithoutPresetUpdateInput"] | undefined,
	create?: GraphQLTypes["InvoicingPlanWithoutPresetCreateInput"] | undefined
};
	["LogRecord"]: {
	__typename: "LogRecord",
	_meta?: GraphQLTypes["LogRecordMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	level: number,
	type: string,
	message?: string | undefined,
	data?: GraphQLTypes["Json"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	shouldBeResolved?: boolean | undefined,
	resolvedAt?: GraphQLTypes["DateTime"] | undefined,
	resolvedBy?: GraphQLTypes["User"] | undefined
};
	["LogRecordMeta"]: {
	__typename: "LogRecordMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	level?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	message?: GraphQLTypes["FieldMeta"] | undefined,
	data?: GraphQLTypes["FieldMeta"] | undefined,
	createdAt?: GraphQLTypes["FieldMeta"] | undefined,
	shouldBeResolved?: GraphQLTypes["FieldMeta"] | undefined,
	resolvedAt?: GraphQLTypes["FieldMeta"] | undefined,
	resolvedBy?: GraphQLTypes["FieldMeta"] | undefined
};
	["LogRecordUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["LogRecordWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	level?: GraphQLTypes["IntCondition"] | undefined,
	type?: GraphQLTypes["StringCondition"] | undefined,
	message?: GraphQLTypes["StringCondition"] | undefined,
	data?: GraphQLTypes["JsonCondition"] | undefined,
	createdAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	shouldBeResolved?: GraphQLTypes["BooleanCondition"] | undefined,
	resolvedAt?: GraphQLTypes["DateTimeCondition"] | undefined,
	resolvedBy?: GraphQLTypes["UserWhere"] | undefined,
	and?: Array<GraphQLTypes["LogRecordWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["LogRecordWhere"] | undefined> | undefined,
	not?: GraphQLTypes["LogRecordWhere"] | undefined
};
	["LogRecordOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	level?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	message?: GraphQLTypes["OrderDirection"] | undefined,
	data?: GraphQLTypes["OrderDirection"] | undefined,
	createdAt?: GraphQLTypes["OrderDirection"] | undefined,
	shouldBeResolved?: GraphQLTypes["OrderDirection"] | undefined,
	resolvedAt?: GraphQLTypes["OrderDirection"] | undefined,
	resolvedBy?: GraphQLTypes["UserOrderBy"] | undefined
};
	["LogRecordConnection"]: {
	__typename: "LogRecordConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LogRecordEdge"]>
};
	["LogRecordEdge"]: {
	__typename: "LogRecordEdge",
	node: GraphQLTypes["LogRecord"]
};
	["LogRecordCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	level?: number | undefined,
	type?: string | undefined,
	message?: string | undefined,
	data?: GraphQLTypes["Json"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	shouldBeResolved?: boolean | undefined,
	resolvedAt?: GraphQLTypes["DateTime"] | undefined,
	resolvedBy?: GraphQLTypes["LogRecordCreateResolvedByEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LogRecordCreateResolvedByEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"] | undefined,
	create?: GraphQLTypes["UserCreateInput"] | undefined
};
	["LogRecordUpdateInput"]: {
		level?: number | undefined,
	type?: string | undefined,
	message?: string | undefined,
	data?: GraphQLTypes["Json"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	shouldBeResolved?: boolean | undefined,
	resolvedAt?: GraphQLTypes["DateTime"] | undefined,
	resolvedBy?: GraphQLTypes["LogRecordUpdateResolvedByEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LogRecordUpdateResolvedByEntityRelationInput"]: {
		create?: GraphQLTypes["UserCreateInput"] | undefined,
	update?: GraphQLTypes["UserUpdateInput"] | undefined,
	upsert?: GraphQLTypes["LogRecordUpsertResolvedByRelationInput"] | undefined,
	connect?: GraphQLTypes["UserUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LogRecordUpsertResolvedByRelationInput"]: {
		update?: GraphQLTypes["UserUpdateInput"] | undefined,
	create?: GraphQLTypes["UserCreateInput"] | undefined
};
	["ShoppingListItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	amount?: number | undefined,
	list?: GraphQLTypes["ShoppingListItemCreateListEntityRelationInput"] | undefined,
	ingredient?: GraphQLTypes["ShoppingListItemCreateIngredientEntityRelationInput"] | undefined,
	preferredUnit?: GraphQLTypes["ShoppingListItemCreatePreferredUnitEntityRelationInput"] | undefined,
	wasPurcahsed?: boolean | undefined,
	wasTransferred?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ShoppingListItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["ShoppingListUniqueWhere"] | undefined,
	create?: GraphQLTypes["ShoppingListWithoutItemsCreateInput"] | undefined
};
	["ShoppingListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	supplier?: GraphQLTypes["ShoppingListCreateSupplierEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ShoppingListItemUpdateInput"]: {
		amount?: number | undefined,
	list?: GraphQLTypes["ShoppingListItemUpdateListEntityRelationInput"] | undefined,
	ingredient?: GraphQLTypes["ShoppingListItemUpdateIngredientEntityRelationInput"] | undefined,
	preferredUnit?: GraphQLTypes["ShoppingListItemUpdatePreferredUnitEntityRelationInput"] | undefined,
	wasPurcahsed?: boolean | undefined,
	wasTransferred?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ShoppingListItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["ShoppingListWithoutItemsCreateInput"] | undefined,
	update?: GraphQLTypes["ShoppingListWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ShoppingListItemUpsertListRelationInput"] | undefined,
	connect?: GraphQLTypes["ShoppingListUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["ShoppingListWithoutItemsUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	supplier?: GraphQLTypes["ShoppingListUpdateSupplierEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ShoppingListItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["ShoppingListWithoutItemsUpdateInput"] | undefined,
	create?: GraphQLTypes["ShoppingListWithoutItemsCreateInput"] | undefined
};
	["SuppliesPurchaseItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	amount?: number | undefined,
	list?: GraphQLTypes["SuppliesPurchaseItemCreateListEntityRelationInput"] | undefined,
	ingredient?: GraphQLTypes["SuppliesPurchaseItemCreateIngredientEntityRelationInput"] | undefined,
	pricePaidCents?: number | undefined,
	preferredUnit?: GraphQLTypes["SuppliesPurchaseItemCreatePreferredUnitEntityRelationInput"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	purchasedAt?: GraphQLTypes["DateTime"] | undefined,
	purchasedBy?: GraphQLTypes["SuppliesPurchaseItemCreatePurchasedByEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SuppliesPurchaseItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["SuppliesPurchaseUniqueWhere"] | undefined,
	create?: GraphQLTypes["SuppliesPurchaseWithoutItemsCreateInput"] | undefined
};
	["SuppliesPurchaseWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	supplier?: GraphQLTypes["SuppliesPurchaseCreateSupplierEntityRelationInput"] | undefined,
	requestedDeliveryDate?: GraphQLTypes["Date"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SuppliesPurchaseItemUpdateInput"]: {
		amount?: number | undefined,
	list?: GraphQLTypes["SuppliesPurchaseItemUpdateListEntityRelationInput"] | undefined,
	ingredient?: GraphQLTypes["SuppliesPurchaseItemUpdateIngredientEntityRelationInput"] | undefined,
	pricePaidCents?: number | undefined,
	preferredUnit?: GraphQLTypes["SuppliesPurchaseItemUpdatePreferredUnitEntityRelationInput"] | undefined,
	deletedAt?: GraphQLTypes["DateTime"] | undefined,
	purchasedAt?: GraphQLTypes["DateTime"] | undefined,
	purchasedBy?: GraphQLTypes["SuppliesPurchaseItemUpdatePurchasedByEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SuppliesPurchaseItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["SuppliesPurchaseWithoutItemsCreateInput"] | undefined,
	update?: GraphQLTypes["SuppliesPurchaseWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["SuppliesPurchaseItemUpsertListRelationInput"] | undefined,
	connect?: GraphQLTypes["SuppliesPurchaseUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["SuppliesPurchaseWithoutItemsUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	supplier?: GraphQLTypes["SuppliesPurchaseUpdateSupplierEntityRelationInput"] | undefined,
	requestedDeliveryDate?: GraphQLTypes["Date"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SuppliesPurchaseItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["SuppliesPurchaseWithoutItemsUpdateInput"] | undefined,
	create?: GraphQLTypes["SuppliesPurchaseWithoutItemsCreateInput"] | undefined
};
	["CustomerCreditTransactionCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	amountCents?: number | undefined,
	customerCredit?: GraphQLTypes["CustomerCreditTransactionCreateCustomerCreditEntityRelationInput"] | undefined,
	orderDiscount?: GraphQLTypes["CustomerCreditTransactionCreateOrderDiscountEntityRelationInput"] | undefined,
	virtualProductEffect?: GraphQLTypes["CustomerCreditTransactionCreateVirtualProductEffectEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerCreditTransactionUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	amountCents?: number | undefined,
	customerCredit?: GraphQLTypes["CustomerCreditTransactionUpdateCustomerCreditEntityRelationInput"] | undefined,
	orderDiscount?: GraphQLTypes["CustomerCreditTransactionUpdateOrderDiscountEntityRelationInput"] | undefined,
	virtualProductEffect?: GraphQLTypes["CustomerCreditTransactionUpdateVirtualProductEffectEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["VirtualProductConnection"]: {
	__typename: "VirtualProductConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["VirtualProductEdge"]>
};
	["VirtualProductEdge"]: {
	__typename: "VirtualProductEdge",
	node: GraphQLTypes["VirtualProduct"]
};
	["VirtualProductEffectCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	succeededAt?: GraphQLTypes["DateTime"] | undefined,
	orderItem?: GraphQLTypes["VirtualProductEffectCreateOrderItemEntityRelationInput"] | undefined,
	failedAt?: GraphQLTypes["DateTime"] | undefined,
	revertedAt?: GraphQLTypes["DateTime"] | undefined,
	resultCustomerCreditTransaction?: GraphQLTypes["VirtualProductEffectCreateResultCustomerCreditTransactionEntityRelationInput"] | undefined,
	resultVouchers?: Array<GraphQLTypes["VirtualProductEffectCreateResultVouchersEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["VirtualProductEffectUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	succeededAt?: GraphQLTypes["DateTime"] | undefined,
	orderItem?: GraphQLTypes["VirtualProductEffectUpdateOrderItemEntityRelationInput"] | undefined,
	failedAt?: GraphQLTypes["DateTime"] | undefined,
	revertedAt?: GraphQLTypes["DateTime"] | undefined,
	resultCustomerCreditTransaction?: GraphQLTypes["VirtualProductEffectUpdateResultCustomerCreditTransactionEntityRelationInput"] | undefined,
	resultVouchers?: Array<GraphQLTypes["VirtualProductEffectUpdateResultVouchersEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductMetadataConnection"]: {
	__typename: "ProductMetadataConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductMetadataEdge"]>
};
	["ProductMetadataEdge"]: {
	__typename: "ProductMetadataEdge",
	node: GraphQLTypes["ProductMetadata"]
};
	["EmploymentInformationCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	hourlyRate?: number | undefined,
	remunerationProfiles?: GraphQLTypes["EmploymentInformationCreateRemunerationProfilesEntityRelationInput"] | undefined,
	monthlySalary?: number | undefined,
	type?: GraphQLTypes["EmploymentType"] | undefined,
	name?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["EmploymentInformationCreateRemunerationProfilesEntityRelationInput"]: {
		connect?: GraphQLTypes["RemunerationProfileUniqueWhere"] | undefined,
	create?: GraphQLTypes["RemunerationProfileWithoutEmploymentInformationCreateInput"] | undefined
};
	["RemunerationProfileWithoutEmploymentInformationCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	workMonths?: GraphQLTypes["RemunerationProfileCreateWorkMonthsEntityRelationInput"] | undefined,
	staff?: GraphQLTypes["RemunerationProfileCreateStaffEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RemunerationProfileCreateStaffEntityRelationInput"]: {
		connect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	create?: GraphQLTypes["StaffWithoutRemunerationProfileCreateInput"] | undefined
};
	["StaffWithoutRemunerationProfileCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	bartender?: GraphQLTypes["StaffCreateBartenderEntityRelationInput"] | undefined,
	courier?: GraphQLTypes["StaffCreateCourierEntityRelationInput"] | undefined,
	cleaner?: GraphQLTypes["StaffCreateCleanerEntityRelationInput"] | undefined,
	shiftsManager?: GraphQLTypes["StaffCreateShiftsManagerEntityRelationInput"] | undefined,
	businessToBusinessManager?: GraphQLTypes["StaffCreateBusinessToBusinessManagerEntityRelationInput"] | undefined,
	user?: GraphQLTypes["StaffCreateUserEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["StaffCreateShiftsProfileEntityRelationInput"] | undefined,
	stocksManager?: GraphQLTypes["StaffCreateStocksManagerEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["StaffCreatePhotoEntityRelationInput"] | undefined,
	courierManager?: GraphQLTypes["StaffCreateCourierManagerEntityRelationInput"] | undefined,
	picker?: GraphQLTypes["StaffCreatePickerEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	cashier?: GraphQLTypes["StaffCreateCashierEntityRelationInput"] | undefined,
	venues?: Array<GraphQLTypes["StaffCreateVenuesEntityRelationInput"]> | undefined,
	internalBuyer?: GraphQLTypes["StaffCreateInternalBuyerEntityRelationInput"] | undefined,
	salesManager?: GraphQLTypes["StaffCreateSalesManagerEntityRelationInput"] | undefined,
	cashierManager?: GraphQLTypes["StaffCreateCashierManagerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["EmploymentInformationUpdateInput"]: {
		hourlyRate?: number | undefined,
	remunerationProfiles?: GraphQLTypes["EmploymentInformationUpdateRemunerationProfilesEntityRelationInput"] | undefined,
	monthlySalary?: number | undefined,
	type?: GraphQLTypes["EmploymentType"] | undefined,
	name?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["EmploymentInformationUpdateRemunerationProfilesEntityRelationInput"]: {
		create?: GraphQLTypes["RemunerationProfileWithoutEmploymentInformationCreateInput"] | undefined,
	update?: GraphQLTypes["RemunerationProfileWithoutEmploymentInformationUpdateInput"] | undefined,
	upsert?: GraphQLTypes["EmploymentInformationUpsertRemunerationProfilesRelationInput"] | undefined,
	connect?: GraphQLTypes["RemunerationProfileUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["RemunerationProfileWithoutEmploymentInformationUpdateInput"]: {
		workMonths?: GraphQLTypes["RemunerationProfileUpdateWorkMonthsEntityRelationInput"] | undefined,
	staff?: GraphQLTypes["RemunerationProfileUpdateStaffEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RemunerationProfileUpdateStaffEntityRelationInput"]: {
		create?: GraphQLTypes["StaffWithoutRemunerationProfileCreateInput"] | undefined,
	update?: GraphQLTypes["StaffWithoutRemunerationProfileUpdateInput"] | undefined,
	upsert?: GraphQLTypes["RemunerationProfileUpsertStaffRelationInput"] | undefined,
	connect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["StaffWithoutRemunerationProfileUpdateInput"]: {
		bartender?: GraphQLTypes["StaffUpdateBartenderEntityRelationInput"] | undefined,
	courier?: GraphQLTypes["StaffUpdateCourierEntityRelationInput"] | undefined,
	cleaner?: GraphQLTypes["StaffUpdateCleanerEntityRelationInput"] | undefined,
	shiftsManager?: GraphQLTypes["StaffUpdateShiftsManagerEntityRelationInput"] | undefined,
	businessToBusinessManager?: GraphQLTypes["StaffUpdateBusinessToBusinessManagerEntityRelationInput"] | undefined,
	user?: GraphQLTypes["StaffUpdateUserEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["StaffUpdateShiftsProfileEntityRelationInput"] | undefined,
	stocksManager?: GraphQLTypes["StaffUpdateStocksManagerEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["StaffUpdatePhotoEntityRelationInput"] | undefined,
	courierManager?: GraphQLTypes["StaffUpdateCourierManagerEntityRelationInput"] | undefined,
	picker?: GraphQLTypes["StaffUpdatePickerEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	cashier?: GraphQLTypes["StaffUpdateCashierEntityRelationInput"] | undefined,
	venues?: Array<GraphQLTypes["StaffUpdateVenuesEntityRelationInput"]> | undefined,
	internalBuyer?: GraphQLTypes["StaffUpdateInternalBuyerEntityRelationInput"] | undefined,
	salesManager?: GraphQLTypes["StaffUpdateSalesManagerEntityRelationInput"] | undefined,
	cashierManager?: GraphQLTypes["StaffUpdateCashierManagerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RemunerationProfileUpsertStaffRelationInput"]: {
		update?: GraphQLTypes["StaffWithoutRemunerationProfileUpdateInput"] | undefined,
	create?: GraphQLTypes["StaffWithoutRemunerationProfileCreateInput"] | undefined
};
	["EmploymentInformationUpsertRemunerationProfilesRelationInput"]: {
		update?: GraphQLTypes["RemunerationProfileWithoutEmploymentInformationUpdateInput"] | undefined,
	create?: GraphQLTypes["RemunerationProfileWithoutEmploymentInformationCreateInput"] | undefined
};
	["RemunerationProfileCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	employmentInformation?: Array<GraphQLTypes["RemunerationProfileCreateEmploymentInformationEntityRelationInput"]> | undefined,
	workMonths?: GraphQLTypes["RemunerationProfileCreateWorkMonthsEntityRelationInput"] | undefined,
	staff?: GraphQLTypes["RemunerationProfileCreateStaffEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RemunerationProfileUpdateInput"]: {
		employmentInformation?: Array<GraphQLTypes["RemunerationProfileUpdateEmploymentInformationEntityRelationInput"]> | undefined,
	workMonths?: GraphQLTypes["RemunerationProfileUpdateWorkMonthsEntityRelationInput"] | undefined,
	staff?: GraphQLTypes["RemunerationProfileUpdateStaffEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["WorkMonthConnection"]: {
	__typename: "WorkMonthConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["WorkMonthEdge"]>
};
	["WorkMonthEdge"]: {
	__typename: "WorkMonthEdge",
	node: GraphQLTypes["WorkMonth"]
};
	["WorkMonthCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	year?: number | undefined,
	month?: number | undefined,
	hoursWorked?: number | undefined,
	billableHours?: number | undefined,
	remunerationProfile?: Array<GraphQLTypes["WorkMonthCreateRemunerationProfileEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["WorkMonthCreateRemunerationProfileEntityRelationInput"]: {
		connect?: GraphQLTypes["RemunerationProfileUniqueWhere"] | undefined,
	create?: GraphQLTypes["RemunerationProfileWithoutWorkMonthsCreateInput"] | undefined,
	alias?: string | undefined
};
	["RemunerationProfileWithoutWorkMonthsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	employmentInformation?: Array<GraphQLTypes["RemunerationProfileCreateEmploymentInformationEntityRelationInput"]> | undefined,
	staff?: GraphQLTypes["RemunerationProfileCreateStaffEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["WorkMonthUpdateInput"]: {
		year?: number | undefined,
	month?: number | undefined,
	hoursWorked?: number | undefined,
	billableHours?: number | undefined,
	remunerationProfile?: Array<GraphQLTypes["WorkMonthUpdateRemunerationProfileEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["WorkMonthUpdateRemunerationProfileEntityRelationInput"]: {
		create?: GraphQLTypes["RemunerationProfileWithoutWorkMonthsCreateInput"] | undefined,
	update?: GraphQLTypes["WorkMonthUpdateRemunerationProfileRelationInput"] | undefined,
	upsert?: GraphQLTypes["WorkMonthUpsertRemunerationProfileRelationInput"] | undefined,
	connect?: GraphQLTypes["RemunerationProfileUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["RemunerationProfileUniqueWhere"] | undefined,
	delete?: GraphQLTypes["RemunerationProfileUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["WorkMonthUpdateRemunerationProfileRelationInput"]: {
		by?: GraphQLTypes["RemunerationProfileUniqueWhere"] | undefined,
	data?: GraphQLTypes["RemunerationProfileWithoutWorkMonthsUpdateInput"] | undefined
};
	["RemunerationProfileWithoutWorkMonthsUpdateInput"]: {
		employmentInformation?: Array<GraphQLTypes["RemunerationProfileUpdateEmploymentInformationEntityRelationInput"]> | undefined,
	staff?: GraphQLTypes["RemunerationProfileUpdateStaffEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["WorkMonthUpsertRemunerationProfileRelationInput"]: {
		by?: GraphQLTypes["RemunerationProfileUniqueWhere"] | undefined,
	update?: GraphQLTypes["RemunerationProfileWithoutWorkMonthsUpdateInput"] | undefined,
	create?: GraphQLTypes["RemunerationProfileWithoutWorkMonthsCreateInput"] | undefined
};
	["SalaryOptions"]: {
	__typename: "SalaryOptions",
	_meta?: GraphQLTypes["SalaryOptionsMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	overtimeMultiplier?: number | undefined,
	publicHolidayMultiplier?: number | undefined,
	weekendMultiplier?: number | undefined,
	unique: GraphQLTypes["One"],
	partTimeMonthlySalaryLimit?: number | undefined
};
	["SalaryOptionsMeta"]: {
	__typename: "SalaryOptionsMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	overtimeMultiplier?: GraphQLTypes["FieldMeta"] | undefined,
	publicHolidayMultiplier?: GraphQLTypes["FieldMeta"] | undefined,
	weekendMultiplier?: GraphQLTypes["FieldMeta"] | undefined,
	unique?: GraphQLTypes["FieldMeta"] | undefined,
	partTimeMonthlySalaryLimit?: GraphQLTypes["FieldMeta"] | undefined
};
	["SalaryOptionsUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined
};
	["SalaryOptionsWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	overtimeMultiplier?: GraphQLTypes["FloatCondition"] | undefined,
	publicHolidayMultiplier?: GraphQLTypes["FloatCondition"] | undefined,
	weekendMultiplier?: GraphQLTypes["FloatCondition"] | undefined,
	unique?: GraphQLTypes["OneCondition"] | undefined,
	partTimeMonthlySalaryLimit?: GraphQLTypes["IntCondition"] | undefined,
	and?: Array<GraphQLTypes["SalaryOptionsWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["SalaryOptionsWhere"] | undefined> | undefined,
	not?: GraphQLTypes["SalaryOptionsWhere"] | undefined
};
	["SalaryOptionsOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	overtimeMultiplier?: GraphQLTypes["OrderDirection"] | undefined,
	publicHolidayMultiplier?: GraphQLTypes["OrderDirection"] | undefined,
	weekendMultiplier?: GraphQLTypes["OrderDirection"] | undefined,
	unique?: GraphQLTypes["OrderDirection"] | undefined,
	partTimeMonthlySalaryLimit?: GraphQLTypes["OrderDirection"] | undefined
};
	["SalaryOptionsConnection"]: {
	__typename: "SalaryOptionsConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SalaryOptionsEdge"]>
};
	["SalaryOptionsEdge"]: {
	__typename: "SalaryOptionsEdge",
	node: GraphQLTypes["SalaryOptions"]
};
	["SalaryOptionsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	overtimeMultiplier?: number | undefined,
	publicHolidayMultiplier?: number | undefined,
	weekendMultiplier?: number | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	partTimeMonthlySalaryLimit?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["SalaryOptionsUpdateInput"]: {
		overtimeMultiplier?: number | undefined,
	publicHolidayMultiplier?: number | undefined,
	weekendMultiplier?: number | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	partTimeMonthlySalaryLimit?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableShiftSwapInfoConnection"]: {
	__typename: "TimetableShiftSwapInfoConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TimetableShiftSwapInfoEdge"]>
};
	["TimetableShiftSwapInfoEdge"]: {
	__typename: "TimetableShiftSwapInfoEdge",
	node: GraphQLTypes["TimetableShiftSwapInfo"]
};
	["TimetableShiftSwapInfoCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	assigned?: GraphQLTypes["Date"] | undefined,
	requested?: boolean | undefined,
	confirmed?: boolean | undefined,
	swappedShiftsProfile?: GraphQLTypes["TimetableShiftSwapInfoCreateSwappedShiftsProfileEntityRelationInput"] | undefined,
	shift?: GraphQLTypes["TimetableShiftSwapInfoCreateShiftEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableShiftSwapInfoCreateShiftEntityRelationInput"]: {
		connect?: GraphQLTypes["TimetableShiftUniqueWhere"] | undefined,
	create?: GraphQLTypes["TimetableShiftWithoutSwapInfoCreateInput"] | undefined
};
	["TimetableShiftWithoutSwapInfoCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locked?: boolean | undefined,
	order?: number | undefined,
	assigned?: GraphQLTypes["Date"] | undefined,
	group?: GraphQLTypes["TimetableShiftCreateGroupEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["TimetableShiftCreateShiftsProfileEntityRelationInput"] | undefined,
	queueItem?: GraphQLTypes["TimetableShiftCreateQueueItemEntityRelationInput"] | undefined,
	isOvertime?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableShiftSwapInfoUpdateInput"]: {
		assigned?: GraphQLTypes["Date"] | undefined,
	requested?: boolean | undefined,
	confirmed?: boolean | undefined,
	swappedShiftsProfile?: GraphQLTypes["TimetableShiftSwapInfoUpdateSwappedShiftsProfileEntityRelationInput"] | undefined,
	shift?: GraphQLTypes["TimetableShiftSwapInfoUpdateShiftEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableShiftSwapInfoUpdateShiftEntityRelationInput"]: {
		create?: GraphQLTypes["TimetableShiftWithoutSwapInfoCreateInput"] | undefined,
	update?: GraphQLTypes["TimetableShiftWithoutSwapInfoUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TimetableShiftSwapInfoUpsertShiftRelationInput"] | undefined,
	connect?: GraphQLTypes["TimetableShiftUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["TimetableShiftWithoutSwapInfoUpdateInput"]: {
		locked?: boolean | undefined,
	order?: number | undefined,
	assigned?: GraphQLTypes["Date"] | undefined,
	group?: GraphQLTypes["TimetableShiftUpdateGroupEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["TimetableShiftUpdateShiftsProfileEntityRelationInput"] | undefined,
	queueItem?: GraphQLTypes["TimetableShiftUpdateQueueItemEntityRelationInput"] | undefined,
	isOvertime?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableShiftSwapInfoUpsertShiftRelationInput"]: {
		update?: GraphQLTypes["TimetableShiftWithoutSwapInfoUpdateInput"] | undefined,
	create?: GraphQLTypes["TimetableShiftWithoutSwapInfoCreateInput"] | undefined
};
	["ProductGridCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	title?: string | undefined,
	root?: GraphQLTypes["ProductGridCategoryCreateRootEntityRelationInput"] | undefined,
	items?: Array<GraphQLTypes["ProductGridCategoryCreateItemsEntityRelationInput"]> | undefined,
	images?: GraphQLTypes["ProductGridCategoryCreateImagesEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ProductGridCategoryUpdateInput"]: {
		order?: number | undefined,
	title?: string | undefined,
	root?: GraphQLTypes["ProductGridCategoryUpdateRootEntityRelationInput"] | undefined,
	items?: Array<GraphQLTypes["ProductGridCategoryUpdateItemsEntityRelationInput"]> | undefined,
	images?: GraphQLTypes["ProductGridCategoryUpdateImagesEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CashierConnection"]: {
	__typename: "CashierConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CashierEdge"]>
};
	["CashierEdge"]: {
	__typename: "CashierEdge",
	node: GraphQLTypes["Cashier"]
};
	["CashierCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	staff?: GraphQLTypes["CashierCreateStaffEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CashierCreateStaffEntityRelationInput"]: {
		connect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	create?: GraphQLTypes["StaffWithoutCashierCreateInput"] | undefined
};
	["StaffWithoutCashierCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	bartender?: GraphQLTypes["StaffCreateBartenderEntityRelationInput"] | undefined,
	courier?: GraphQLTypes["StaffCreateCourierEntityRelationInput"] | undefined,
	cleaner?: GraphQLTypes["StaffCreateCleanerEntityRelationInput"] | undefined,
	shiftsManager?: GraphQLTypes["StaffCreateShiftsManagerEntityRelationInput"] | undefined,
	businessToBusinessManager?: GraphQLTypes["StaffCreateBusinessToBusinessManagerEntityRelationInput"] | undefined,
	user?: GraphQLTypes["StaffCreateUserEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["StaffCreateShiftsProfileEntityRelationInput"] | undefined,
	stocksManager?: GraphQLTypes["StaffCreateStocksManagerEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["StaffCreatePhotoEntityRelationInput"] | undefined,
	courierManager?: GraphQLTypes["StaffCreateCourierManagerEntityRelationInput"] | undefined,
	picker?: GraphQLTypes["StaffCreatePickerEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	remunerationProfile?: GraphQLTypes["StaffCreateRemunerationProfileEntityRelationInput"] | undefined,
	venues?: Array<GraphQLTypes["StaffCreateVenuesEntityRelationInput"]> | undefined,
	internalBuyer?: GraphQLTypes["StaffCreateInternalBuyerEntityRelationInput"] | undefined,
	salesManager?: GraphQLTypes["StaffCreateSalesManagerEntityRelationInput"] | undefined,
	cashierManager?: GraphQLTypes["StaffCreateCashierManagerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CashierUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	staff?: GraphQLTypes["CashierUpdateStaffEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CashierUpdateStaffEntityRelationInput"]: {
		create?: GraphQLTypes["StaffWithoutCashierCreateInput"] | undefined,
	update?: GraphQLTypes["StaffWithoutCashierUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CashierUpsertStaffRelationInput"] | undefined,
	connect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["StaffWithoutCashierUpdateInput"]: {
		bartender?: GraphQLTypes["StaffUpdateBartenderEntityRelationInput"] | undefined,
	courier?: GraphQLTypes["StaffUpdateCourierEntityRelationInput"] | undefined,
	cleaner?: GraphQLTypes["StaffUpdateCleanerEntityRelationInput"] | undefined,
	shiftsManager?: GraphQLTypes["StaffUpdateShiftsManagerEntityRelationInput"] | undefined,
	businessToBusinessManager?: GraphQLTypes["StaffUpdateBusinessToBusinessManagerEntityRelationInput"] | undefined,
	user?: GraphQLTypes["StaffUpdateUserEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["StaffUpdateShiftsProfileEntityRelationInput"] | undefined,
	stocksManager?: GraphQLTypes["StaffUpdateStocksManagerEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["StaffUpdatePhotoEntityRelationInput"] | undefined,
	courierManager?: GraphQLTypes["StaffUpdateCourierManagerEntityRelationInput"] | undefined,
	picker?: GraphQLTypes["StaffUpdatePickerEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	remunerationProfile?: GraphQLTypes["StaffUpdateRemunerationProfileEntityRelationInput"] | undefined,
	venues?: Array<GraphQLTypes["StaffUpdateVenuesEntityRelationInput"]> | undefined,
	internalBuyer?: GraphQLTypes["StaffUpdateInternalBuyerEntityRelationInput"] | undefined,
	salesManager?: GraphQLTypes["StaffUpdateSalesManagerEntityRelationInput"] | undefined,
	cashierManager?: GraphQLTypes["StaffUpdateCashierManagerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CashierUpsertStaffRelationInput"]: {
		update?: GraphQLTypes["StaffWithoutCashierUpdateInput"] | undefined,
	create?: GraphQLTypes["StaffWithoutCashierCreateInput"] | undefined
};
	["PointOfSaleCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	slug?: string | undefined,
	locales?: Array<GraphQLTypes["PointOfSaleCategoryCreateLocalesEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["PointOfSaleCategoryCreateProductsEntityRelationInput"]> | undefined,
	category?: GraphQLTypes["PointOfSaleCategoryCreateCategoryEntityRelationInput"] | undefined,
	venue?: GraphQLTypes["PointOfSaleCategoryCreateVenueEntityRelationInput"] | undefined,
	ticketPrinters?: Array<GraphQLTypes["PointOfSaleCategoryCreateTicketPrintersEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleCategoryUpdateInput"]: {
		order?: number | undefined,
	slug?: string | undefined,
	locales?: Array<GraphQLTypes["PointOfSaleCategoryUpdateLocalesEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["PointOfSaleCategoryUpdateProductsEntityRelationInput"]> | undefined,
	category?: GraphQLTypes["PointOfSaleCategoryUpdateCategoryEntityRelationInput"] | undefined,
	venue?: GraphQLTypes["PointOfSaleCategoryUpdateVenueEntityRelationInput"] | undefined,
	ticketPrinters?: Array<GraphQLTypes["PointOfSaleCategoryUpdateTicketPrintersEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleCategoryLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	root?: GraphQLTypes["PointOfSaleCategoryLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["PointOfSaleCategoryLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleCategoryLocaleUpdateInput"]: {
		title?: string | undefined,
	root?: GraphQLTypes["PointOfSaleCategoryLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["PointOfSaleCategoryLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleCategoryProductCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	category?: GraphQLTypes["PointOfSaleCategoryProductCreateCategoryEntityRelationInput"] | undefined,
	product?: GraphQLTypes["PointOfSaleCategoryProductCreateProductEntityRelationInput"] | undefined,
	locales?: Array<GraphQLTypes["PointOfSaleCategoryProductCreateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleCategoryProductUpdateInput"]: {
		order?: number | undefined,
	category?: GraphQLTypes["PointOfSaleCategoryProductUpdateCategoryEntityRelationInput"] | undefined,
	product?: GraphQLTypes["PointOfSaleCategoryProductUpdateProductEntityRelationInput"] | undefined,
	locales?: Array<GraphQLTypes["PointOfSaleCategoryProductUpdateLocalesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleCategoryProductLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	root?: GraphQLTypes["PointOfSaleCategoryProductLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["PointOfSaleCategoryProductLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleCategoryProductLocaleUpdateInput"]: {
		title?: string | undefined,
	root?: GraphQLTypes["PointOfSaleCategoryProductLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["PointOfSaleCategoryProductLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerTabCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	color?: string | undefined,
	items?: Array<GraphQLTypes["CustomerTabCreateItemsEntityRelationInput"]> | undefined,
	name?: string | undefined,
	meta?: GraphQLTypes["CustomerTabCreateMetaEntityRelationInput"] | undefined,
	customer?: GraphQLTypes["CustomerTabCreateCustomerEntityRelationInput"] | undefined,
	table?: GraphQLTypes["CustomerTabCreateTableEntityRelationInput"] | undefined,
	seat?: GraphQLTypes["CustomerTabCreateSeatEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerTabUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	color?: string | undefined,
	items?: Array<GraphQLTypes["CustomerTabUpdateItemsEntityRelationInput"]> | undefined,
	name?: string | undefined,
	meta?: GraphQLTypes["CustomerTabUpdateMetaEntityRelationInput"] | undefined,
	customer?: GraphQLTypes["CustomerTabUpdateCustomerEntityRelationInput"] | undefined,
	table?: GraphQLTypes["CustomerTabUpdateTableEntityRelationInput"] | undefined,
	seat?: GraphQLTypes["CustomerTabUpdateSeatEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerTabItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	addedAt?: GraphQLTypes["DateTime"] | undefined,
	tab?: GraphQLTypes["CustomerTabItemCreateTabEntityRelationInput"] | undefined,
	product?: GraphQLTypes["CustomerTabItemCreateProductEntityRelationInput"] | undefined,
	paidAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerTabItemCreateTabEntityRelationInput"]: {
		connect?: GraphQLTypes["CustomerTabUniqueWhere"] | undefined,
	create?: GraphQLTypes["CustomerTabWithoutItemsCreateInput"] | undefined
};
	["CustomerTabWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	color?: string | undefined,
	name?: string | undefined,
	meta?: GraphQLTypes["CustomerTabCreateMetaEntityRelationInput"] | undefined,
	customer?: GraphQLTypes["CustomerTabCreateCustomerEntityRelationInput"] | undefined,
	table?: GraphQLTypes["CustomerTabCreateTableEntityRelationInput"] | undefined,
	seat?: GraphQLTypes["CustomerTabCreateSeatEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerTabItemUpdateInput"]: {
		addedAt?: GraphQLTypes["DateTime"] | undefined,
	tab?: GraphQLTypes["CustomerTabItemUpdateTabEntityRelationInput"] | undefined,
	product?: GraphQLTypes["CustomerTabItemUpdateProductEntityRelationInput"] | undefined,
	paidAt?: GraphQLTypes["DateTime"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerTabItemUpdateTabEntityRelationInput"]: {
		create?: GraphQLTypes["CustomerTabWithoutItemsCreateInput"] | undefined,
	update?: GraphQLTypes["CustomerTabWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CustomerTabItemUpsertTabRelationInput"] | undefined,
	connect?: GraphQLTypes["CustomerTabUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["CustomerTabWithoutItemsUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	color?: string | undefined,
	name?: string | undefined,
	meta?: GraphQLTypes["CustomerTabUpdateMetaEntityRelationInput"] | undefined,
	customer?: GraphQLTypes["CustomerTabUpdateCustomerEntityRelationInput"] | undefined,
	table?: GraphQLTypes["CustomerTabUpdateTableEntityRelationInput"] | undefined,
	seat?: GraphQLTypes["CustomerTabUpdateSeatEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerTabItemUpsertTabRelationInput"]: {
		update?: GraphQLTypes["CustomerTabWithoutItemsUpdateInput"] | undefined,
	create?: GraphQLTypes["CustomerTabWithoutItemsCreateInput"] | undefined
};
	["AnonymousSessionConnection"]: {
	__typename: "AnonymousSessionConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["AnonymousSessionEdge"]>
};
	["AnonymousSessionEdge"]: {
	__typename: "AnonymousSessionEdge",
	node: GraphQLTypes["AnonymousSession"]
};
	["AnonymousSessionCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	lastActiveAt?: GraphQLTypes["DateTime"] | undefined,
	anonymousSessionKey?: string | undefined,
	email?: string | undefined,
	name?: string | undefined,
	internalNote?: string | undefined,
	customer?: GraphQLTypes["AnonymousSessionCreateCustomerEntityRelationInput"] | undefined,
	devices?: Array<GraphQLTypes["AnonymousSessionCreateDevicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["AnonymousSessionUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	lastActiveAt?: GraphQLTypes["DateTime"] | undefined,
	anonymousSessionKey?: string | undefined,
	email?: string | undefined,
	name?: string | undefined,
	internalNote?: string | undefined,
	customer?: GraphQLTypes["AnonymousSessionUpdateCustomerEntityRelationInput"] | undefined,
	devices?: Array<GraphQLTypes["AnonymousSessionUpdateDevicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["VoucherCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	activatedAt?: GraphQLTypes["DateTime"] | undefined,
	expiresAt?: GraphQLTypes["DateTime"] | undefined,
	internalNote?: string | undefined,
	note?: string | undefined,
	code?: string | undefined,
	type?: GraphQLTypes["VoucherType"] | undefined,
	creditCents?: number | undefined,
	buyer?: GraphQLTypes["VoucherCreateBuyerEntityRelationInput"] | undefined,
	owner?: GraphQLTypes["VoucherCreateOwnerEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["VoucherCreateVatRateEntityRelationInput"] | undefined,
	virtualProductEffect?: GraphQLTypes["VoucherCreateVirtualProductEffectEntityRelationInput"] | undefined,
	redemption?: GraphQLTypes["VoucherCreateRedemptionEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["VoucherUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	activatedAt?: GraphQLTypes["DateTime"] | undefined,
	expiresAt?: GraphQLTypes["DateTime"] | undefined,
	internalNote?: string | undefined,
	note?: string | undefined,
	code?: string | undefined,
	type?: GraphQLTypes["VoucherType"] | undefined,
	creditCents?: number | undefined,
	buyer?: GraphQLTypes["VoucherUpdateBuyerEntityRelationInput"] | undefined,
	owner?: GraphQLTypes["VoucherUpdateOwnerEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["VoucherUpdateVatRateEntityRelationInput"] | undefined,
	virtualProductEffect?: GraphQLTypes["VoucherUpdateVirtualProductEffectEntityRelationInput"] | undefined,
	redemption?: GraphQLTypes["VoucherUpdateRedemptionEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["VoucherRedemptionCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	manualRedemptionNote?: string | undefined,
	customerCredit?: GraphQLTypes["VoucherRedemptionCreateCustomerCreditEntityRelationInput"] | undefined,
	orderDiscount?: GraphQLTypes["VoucherRedemptionCreateOrderDiscountEntityRelationInput"] | undefined,
	voucher?: GraphQLTypes["VoucherRedemptionCreateVoucherEntityRelationInput"] | undefined,
	customer?: GraphQLTypes["VoucherRedemptionCreateCustomerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["VoucherRedemptionUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	manualRedemptionNote?: string | undefined,
	customerCredit?: GraphQLTypes["VoucherRedemptionUpdateCustomerCreditEntityRelationInput"] | undefined,
	orderDiscount?: GraphQLTypes["VoucherRedemptionUpdateOrderDiscountEntityRelationInput"] | undefined,
	voucher?: GraphQLTypes["VoucherRedemptionUpdateVoucherEntityRelationInput"] | undefined,
	customer?: GraphQLTypes["VoucherRedemptionUpdateCustomerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UnassignedShiftInfoConnection"]: {
	__typename: "UnassignedShiftInfoConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["UnassignedShiftInfoEdge"]>
};
	["UnassignedShiftInfoEdge"]: {
	__typename: "UnassignedShiftInfoEdge",
	node: GraphQLTypes["UnassignedShiftInfo"]
};
	["UnassignedShiftInfoCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	hoursMissed?: number | undefined,
	queueItem?: GraphQLTypes["UnassignedShiftInfoCreateQueueItemEntityRelationInput"] | undefined,
	legacyReason?: GraphQLTypes["UnassignedInfoReason"] | undefined,
	reason?: GraphQLTypes["UnassignedShiftInfoCreateReasonEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UnassignedShiftInfoCreateQueueItemEntityRelationInput"]: {
		connect?: GraphQLTypes["EmployeeQueueItemUniqueWhere"] | undefined,
	create?: GraphQLTypes["EmployeeQueueItemWithoutUnassignInfoCreateInput"] | undefined
};
	["EmployeeQueueItemWithoutUnassignInfoCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	start?: string | undefined,
	end?: string | undefined,
	queue?: GraphQLTypes["EmployeeQueueItemCreateQueueEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["EmployeeQueueItemCreateShiftsProfileEntityRelationInput"] | undefined,
	shift?: GraphQLTypes["EmployeeQueueItemCreateShiftEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["EmployeeQueueItemCreateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UnassignedShiftInfoUpdateInput"]: {
		hoursMissed?: number | undefined,
	queueItem?: GraphQLTypes["UnassignedShiftInfoUpdateQueueItemEntityRelationInput"] | undefined,
	legacyReason?: GraphQLTypes["UnassignedInfoReason"] | undefined,
	reason?: GraphQLTypes["UnassignedShiftInfoUpdateReasonEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UnassignedShiftInfoUpdateQueueItemEntityRelationInput"]: {
		create?: GraphQLTypes["EmployeeQueueItemWithoutUnassignInfoCreateInput"] | undefined,
	update?: GraphQLTypes["EmployeeQueueItemWithoutUnassignInfoUpdateInput"] | undefined,
	upsert?: GraphQLTypes["UnassignedShiftInfoUpsertQueueItemRelationInput"] | undefined,
	connect?: GraphQLTypes["EmployeeQueueItemUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["EmployeeQueueItemWithoutUnassignInfoUpdateInput"]: {
		start?: string | undefined,
	end?: string | undefined,
	queue?: GraphQLTypes["EmployeeQueueItemUpdateQueueEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["EmployeeQueueItemUpdateShiftsProfileEntityRelationInput"] | undefined,
	shift?: GraphQLTypes["EmployeeQueueItemUpdateShiftEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["EmployeeQueueItemUpdateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["UnassignedShiftInfoUpsertQueueItemRelationInput"]: {
		update?: GraphQLTypes["EmployeeQueueItemWithoutUnassignInfoUpdateInput"] | undefined,
	create?: GraphQLTypes["EmployeeQueueItemWithoutUnassignInfoCreateInput"] | undefined
};
	["TextItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	text?: string | undefined,
	list?: GraphQLTypes["TextItemCreateListEntityRelationInput"] | undefined,
	title?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["TextItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["TextListUniqueWhere"] | undefined,
	create?: GraphQLTypes["TextListWithoutItemsCreateInput"] | undefined
};
	["TextListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TextItemUpdateInput"]: {
		order?: number | undefined,
	text?: string | undefined,
	list?: GraphQLTypes["TextItemUpdateListEntityRelationInput"] | undefined,
	title?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["TextItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["TextListWithoutItemsCreateInput"] | undefined,
	update?: GraphQLTypes["TextListWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TextItemUpsertListRelationInput"] | undefined,
	connect?: GraphQLTypes["TextListUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["TextListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean | undefined
};
	["TextItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["TextListWithoutItemsUpdateInput"] | undefined,
	create?: GraphQLTypes["TextListWithoutItemsCreateInput"] | undefined
};
	["TextListConnection"]: {
	__typename: "TextListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TextListEdge"]>
};
	["TextListEdge"]: {
	__typename: "TextListEdge",
	node: GraphQLTypes["TextList"]
};
	["EmployeeQueueItemMetadataConnection"]: {
	__typename: "EmployeeQueueItemMetadataConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["EmployeeQueueItemMetadataEdge"]>
};
	["EmployeeQueueItemMetadataEdge"]: {
	__typename: "EmployeeQueueItemMetadataEdge",
	node: GraphQLTypes["EmployeeQueueItemMetadata"]
};
	["DeliveryRegionsConnection"]: {
	__typename: "DeliveryRegionsConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DeliveryRegionsEdge"]>
};
	["DeliveryRegionsEdge"]: {
	__typename: "DeliveryRegionsEdge",
	node: GraphQLTypes["DeliveryRegions"]
};
	["DeliveryRegionsItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	title?: string | undefined,
	offerLabel?: string | undefined,
	list?: GraphQLTypes["DeliveryRegionsItemCreateListEntityRelationInput"] | undefined,
	image?: GraphQLTypes["DeliveryRegionsItemCreateImageEntityRelationInput"] | undefined,
	textList?: GraphQLTypes["DeliveryRegionsItemCreateTextListEntityRelationInput"] | undefined,
	gallery?: GraphQLTypes["DeliveryRegionsItemCreateGalleryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryRegionsItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["DeliveryRegionsUniqueWhere"] | undefined,
	create?: GraphQLTypes["DeliveryRegionsWithoutItemsCreateInput"] | undefined
};
	["DeliveryRegionsWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryRegionsItemUpdateInput"]: {
		order?: number | undefined,
	title?: string | undefined,
	offerLabel?: string | undefined,
	list?: GraphQLTypes["DeliveryRegionsItemUpdateListEntityRelationInput"] | undefined,
	image?: GraphQLTypes["DeliveryRegionsItemUpdateImageEntityRelationInput"] | undefined,
	textList?: GraphQLTypes["DeliveryRegionsItemUpdateTextListEntityRelationInput"] | undefined,
	gallery?: GraphQLTypes["DeliveryRegionsItemUpdateGalleryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryRegionsItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["DeliveryRegionsWithoutItemsCreateInput"] | undefined,
	update?: GraphQLTypes["DeliveryRegionsWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["DeliveryRegionsItemUpsertListRelationInput"] | undefined,
	connect?: GraphQLTypes["DeliveryRegionsUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["DeliveryRegionsWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean | undefined
};
	["DeliveryRegionsItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["DeliveryRegionsWithoutItemsUpdateInput"] | undefined,
	create?: GraphQLTypes["DeliveryRegionsWithoutItemsCreateInput"] | undefined
};
	["ImageListConnection"]: {
	__typename: "ImageListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ImageListEdge"]>
};
	["ImageListEdge"]: {
	__typename: "ImageListEdge",
	node: GraphQLTypes["ImageList"]
};
	["ImageListItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	list?: GraphQLTypes["ImageListItemCreateListEntityRelationInput"] | undefined,
	image?: GraphQLTypes["ImageListItemCreateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageListItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageListUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageListWithoutItemsCreateInput"] | undefined
};
	["ImageListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageListItemUpdateInput"]: {
		order?: number | undefined,
	list?: GraphQLTypes["ImageListItemUpdateListEntityRelationInput"] | undefined,
	image?: GraphQLTypes["ImageListItemUpdateImageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ImageListItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["ImageListWithoutItemsCreateInput"] | undefined,
	update?: GraphQLTypes["ImageListWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ImageListItemUpsertListRelationInput"] | undefined,
	connect?: GraphQLTypes["ImageListUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["ImageListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean | undefined
};
	["ImageListItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["ImageListWithoutItemsUpdateInput"] | undefined,
	create?: GraphQLTypes["ImageListWithoutItemsCreateInput"] | undefined
};
	["TimetablesEmployeePrivilegesConnection"]: {
	__typename: "TimetablesEmployeePrivilegesConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TimetablesEmployeePrivilegesEdge"]>
};
	["TimetablesEmployeePrivilegesEdge"]: {
	__typename: "TimetablesEmployeePrivilegesEdge",
	node: GraphQLTypes["TimetablesEmployeePrivileges"]
};
	["TimetablesEmployeePrivilegesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	venueEmployeeRole?: GraphQLTypes["TimetablesEmployeePrivilegesCreateVenueEmployeeRoleEntityRelationInput"] | undefined,
	read?: boolean | undefined,
	unassign?: boolean | undefined,
	assign?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetablesEmployeePrivilegesCreateVenueEmployeeRoleEntityRelationInput"]: {
		connect?: GraphQLTypes["VenueEmployeeRoleUniqueWhere"] | undefined,
	create?: GraphQLTypes["VenueEmployeeRoleWithoutEmployeePrivilegesCreateInput"] | undefined
};
	["VenueEmployeeRoleWithoutEmployeePrivilegesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	venue?: GraphQLTypes["VenueEmployeeRoleCreateVenueEntityRelationInput"] | undefined,
	role?: GraphQLTypes["VenueEmployeeRoleCreateRoleEntityRelationInput"] | undefined,
	getsTipsShare?: boolean | undefined,
	notesEnabled?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["VenueEmployeeRoleCreateVenueEntityRelationInput"]: {
		connect?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	create?: GraphQLTypes["VenueWithoutEmployeeRolesCreateInput"] | undefined
};
	["VenueWithoutEmployeeRolesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	deadlineTemplate?: GraphQLTypes["VenueCreateDeadlineTemplateEntityRelationInput"] | undefined,
	timetableDays?: Array<GraphQLTypes["VenueCreateTimetableDaysEntityRelationInput"]> | undefined,
	timetableTemplates?: Array<GraphQLTypes["VenueCreateTimetableTemplatesEntityRelationInput"]> | undefined,
	staffMembers?: Array<GraphQLTypes["VenueCreateStaffMembersEntityRelationInput"]> | undefined,
	pointOfSaleApplicationDevices?: Array<GraphQLTypes["VenueCreatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined,
	pointOfSaleTerminals?: Array<GraphQLTypes["VenueCreatePointOfSaleTerminalsEntityRelationInput"]> | undefined,
	pointOfSalePrinters?: Array<GraphQLTypes["VenueCreatePointOfSalePrintersEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["VenueCreateOrdersEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["VenueCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	areas?: Array<GraphQLTypes["VenueCreateAreasEntityRelationInput"]> | undefined,
	enabledUnassignReasons?: Array<GraphQLTypes["VenueCreateEnabledUnassignReasonsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["VenueCreateCategoriesEntityRelationInput"]> | undefined,
	channels?: Array<GraphQLTypes["VenueCreateChannelsEntityRelationInput"]> | undefined,
	address?: string | undefined,
	pointOfSalePngBase64ReceiptLogo?: string | undefined,
	pointOfSaleInitialView?: GraphQLTypes["PointOfSaleInitialView"] | undefined,
	pointOfSalePreferPrintReceipt?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetablesEmployeePrivilegesUpdateInput"]: {
		venueEmployeeRole?: GraphQLTypes["TimetablesEmployeePrivilegesUpdateVenueEmployeeRoleEntityRelationInput"] | undefined,
	read?: boolean | undefined,
	unassign?: boolean | undefined,
	assign?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetablesEmployeePrivilegesUpdateVenueEmployeeRoleEntityRelationInput"]: {
		create?: GraphQLTypes["VenueEmployeeRoleWithoutEmployeePrivilegesCreateInput"] | undefined,
	update?: GraphQLTypes["VenueEmployeeRoleWithoutEmployeePrivilegesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TimetablesEmployeePrivilegesUpsertVenueEmployeeRoleRelationInput"] | undefined,
	connect?: GraphQLTypes["VenueEmployeeRoleUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["VenueEmployeeRoleWithoutEmployeePrivilegesUpdateInput"]: {
		order?: number | undefined,
	venue?: GraphQLTypes["VenueEmployeeRoleUpdateVenueEntityRelationInput"] | undefined,
	role?: GraphQLTypes["VenueEmployeeRoleUpdateRoleEntityRelationInput"] | undefined,
	getsTipsShare?: boolean | undefined,
	notesEnabled?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["VenueEmployeeRoleUpdateVenueEntityRelationInput"]: {
		create?: GraphQLTypes["VenueWithoutEmployeeRolesCreateInput"] | undefined,
	update?: GraphQLTypes["VenueWithoutEmployeeRolesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["VenueEmployeeRoleUpsertVenueRelationInput"] | undefined,
	connect?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["VenueWithoutEmployeeRolesUpdateInput"]: {
		name?: string | undefined,
	deadlineTemplate?: GraphQLTypes["VenueUpdateDeadlineTemplateEntityRelationInput"] | undefined,
	timetableDays?: Array<GraphQLTypes["VenueUpdateTimetableDaysEntityRelationInput"]> | undefined,
	timetableTemplates?: Array<GraphQLTypes["VenueUpdateTimetableTemplatesEntityRelationInput"]> | undefined,
	staffMembers?: Array<GraphQLTypes["VenueUpdateStaffMembersEntityRelationInput"]> | undefined,
	pointOfSaleApplicationDevices?: Array<GraphQLTypes["VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined,
	pointOfSaleTerminals?: Array<GraphQLTypes["VenueUpdatePointOfSaleTerminalsEntityRelationInput"]> | undefined,
	pointOfSalePrinters?: Array<GraphQLTypes["VenueUpdatePointOfSalePrintersEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["VenueUpdateOrdersEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["VenueUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	areas?: Array<GraphQLTypes["VenueUpdateAreasEntityRelationInput"]> | undefined,
	enabledUnassignReasons?: Array<GraphQLTypes["VenueUpdateEnabledUnassignReasonsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["VenueUpdateCategoriesEntityRelationInput"]> | undefined,
	channels?: Array<GraphQLTypes["VenueUpdateChannelsEntityRelationInput"]> | undefined,
	address?: string | undefined,
	pointOfSalePngBase64ReceiptLogo?: string | undefined,
	pointOfSaleInitialView?: GraphQLTypes["PointOfSaleInitialView"] | undefined,
	pointOfSalePreferPrintReceipt?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["VenueEmployeeRoleUpsertVenueRelationInput"]: {
		update?: GraphQLTypes["VenueWithoutEmployeeRolesUpdateInput"] | undefined,
	create?: GraphQLTypes["VenueWithoutEmployeeRolesCreateInput"] | undefined
};
	["TimetablesEmployeePrivilegesUpsertVenueEmployeeRoleRelationInput"]: {
		update?: GraphQLTypes["VenueEmployeeRoleWithoutEmployeePrivilegesUpdateInput"] | undefined,
	create?: GraphQLTypes["VenueEmployeeRoleWithoutEmployeePrivilegesCreateInput"] | undefined
};
	["TimetableDayNoteCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	note?: string | undefined,
	day?: GraphQLTypes["TimetableDayNoteCreateDayEntityRelationInput"] | undefined,
	role?: GraphQLTypes["TimetableDayNoteCreateRoleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableDayNoteCreateDayEntityRelationInput"]: {
		connect?: GraphQLTypes["TimetableDayUniqueWhere"] | undefined,
	create?: GraphQLTypes["TimetableDayWithoutNotesCreateInput"] | undefined
};
	["TimetableDayWithoutNotesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	date?: GraphQLTypes["Date"] | undefined,
	type?: GraphQLTypes["TimetableDayType"] | undefined,
	shiftGroups?: Array<GraphQLTypes["TimetableDayCreateShiftGroupsEntityRelationInput"]> | undefined,
	tipsCents?: number | undefined,
	venue?: GraphQLTypes["TimetableDayCreateVenueEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["TimetableDayCreateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableDayNoteUpdateInput"]: {
		order?: number | undefined,
	note?: string | undefined,
	day?: GraphQLTypes["TimetableDayNoteUpdateDayEntityRelationInput"] | undefined,
	role?: GraphQLTypes["TimetableDayNoteUpdateRoleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableDayNoteUpdateDayEntityRelationInput"]: {
		create?: GraphQLTypes["TimetableDayWithoutNotesCreateInput"] | undefined,
	update?: GraphQLTypes["TimetableDayWithoutNotesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["TimetableDayNoteUpsertDayRelationInput"] | undefined,
	connect?: GraphQLTypes["TimetableDayUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["TimetableDayWithoutNotesUpdateInput"]: {
		date?: GraphQLTypes["Date"] | undefined,
	type?: GraphQLTypes["TimetableDayType"] | undefined,
	shiftGroups?: Array<GraphQLTypes["TimetableDayUpdateShiftGroupsEntityRelationInput"]> | undefined,
	tipsCents?: number | undefined,
	venue?: GraphQLTypes["TimetableDayUpdateVenueEntityRelationInput"] | undefined,
	meta?: GraphQLTypes["TimetableDayUpdateMetaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableDayNoteUpsertDayRelationInput"]: {
		update?: GraphQLTypes["TimetableDayWithoutNotesUpdateInput"] | undefined,
	create?: GraphQLTypes["TimetableDayWithoutNotesCreateInput"] | undefined
};
	["DeliveryMethodLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	description?: string | undefined,
	trackingCodeUrlTemplate?: string | undefined,
	processingTitle?: string | undefined,
	processingText?: string | undefined,
	processingIconUrl?: string | undefined,
	dispatchedTitle?: string | undefined,
	dispatchedText?: string | undefined,
	dispatchedIconUrl?: string | undefined,
	fulfilledTitle?: string | undefined,
	fulfilledText?: string | undefined,
	fulfilledIconUrl?: string | undefined,
	locale?: GraphQLTypes["DeliveryMethodLocaleCreateLocaleEntityRelationInput"] | undefined,
	root?: GraphQLTypes["DeliveryMethodLocaleCreateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeliveryMethodLocaleUpdateInput"]: {
		name?: string | undefined,
	description?: string | undefined,
	trackingCodeUrlTemplate?: string | undefined,
	processingTitle?: string | undefined,
	processingText?: string | undefined,
	processingIconUrl?: string | undefined,
	dispatchedTitle?: string | undefined,
	dispatchedText?: string | undefined,
	dispatchedIconUrl?: string | undefined,
	fulfilledTitle?: string | undefined,
	fulfilledText?: string | undefined,
	fulfilledIconUrl?: string | undefined,
	locale?: GraphQLTypes["DeliveryMethodLocaleUpdateLocaleEntityRelationInput"] | undefined,
	root?: GraphQLTypes["DeliveryMethodLocaleUpdateRootEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["IngredientSupplierConnection"]: {
	__typename: "IngredientSupplierConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["IngredientSupplierEdge"]>
};
	["IngredientSupplierEdge"]: {
	__typename: "IngredientSupplierEdge",
	node: GraphQLTypes["IngredientSupplier"]
};
	["IngredientSupplierItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	list?: GraphQLTypes["IngredientSupplierItemCreateListEntityRelationInput"] | undefined,
	supplier?: GraphQLTypes["IngredientSupplierItemCreateSupplierEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["IngredientSupplierItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["IngredientSupplierListUniqueWhere"] | undefined,
	create?: GraphQLTypes["IngredientSupplierListWithoutItemsCreateInput"] | undefined
};
	["IngredientSupplierListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["IngredientSupplierItemUpdateInput"]: {
		order?: number | undefined,
	list?: GraphQLTypes["IngredientSupplierItemUpdateListEntityRelationInput"] | undefined,
	supplier?: GraphQLTypes["IngredientSupplierItemUpdateSupplierEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["IngredientSupplierItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["IngredientSupplierListWithoutItemsCreateInput"] | undefined,
	update?: GraphQLTypes["IngredientSupplierListWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["IngredientSupplierItemUpsertListRelationInput"] | undefined,
	connect?: GraphQLTypes["IngredientSupplierListUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["IngredientSupplierListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean | undefined
};
	["IngredientSupplierItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["IngredientSupplierListWithoutItemsUpdateInput"] | undefined,
	create?: GraphQLTypes["IngredientSupplierListWithoutItemsCreateInput"] | undefined
};
	["IngredientSupplierListConnection"]: {
	__typename: "IngredientSupplierListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["IngredientSupplierListEdge"]>
};
	["IngredientSupplierListEdge"]: {
	__typename: "IngredientSupplierListEdge",
	node: GraphQLTypes["IngredientSupplierList"]
};
	["IngredientSupplierLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	root?: GraphQLTypes["IngredientSupplierLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["IngredientSupplierLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["IngredientSupplierLocaleUpdateInput"]: {
		name?: string | undefined,
	root?: GraphQLTypes["IngredientSupplierLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["IngredientSupplierLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RedirectConnection"]: {
	__typename: "RedirectConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["RedirectEdge"]>
};
	["RedirectEdge"]: {
	__typename: "RedirectEdge",
	node: GraphQLTypes["Redirect"]
};
	["RedirectCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	link?: GraphQLTypes["RedirectCreateLinkEntityRelationInput"] | undefined,
	target?: GraphQLTypes["RedirectCreateTargetEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RedirectCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	create?: GraphQLTypes["LinkableWithoutRedirectCreateInput"] | undefined
};
	["LinkableWithoutRedirectCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	url?: string | undefined,
	blogPost?: GraphQLTypes["LinkableCreateBlogPostEntityRelationInput"] | undefined,
	page?: GraphQLTypes["LinkableCreatePageEntityRelationInput"] | undefined,
	wikiPage?: GraphQLTypes["LinkableCreateWikiPageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RedirectUpdateInput"]: {
		link?: GraphQLTypes["RedirectUpdateLinkEntityRelationInput"] | undefined,
	target?: GraphQLTypes["RedirectUpdateTargetEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RedirectUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutRedirectCreateInput"] | undefined,
	update?: GraphQLTypes["LinkableWithoutRedirectUpdateInput"] | undefined,
	upsert?: GraphQLTypes["RedirectUpsertLinkRelationInput"] | undefined,
	connect?: GraphQLTypes["LinkableUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["LinkableWithoutRedirectUpdateInput"]: {
		url?: string | undefined,
	blogPost?: GraphQLTypes["LinkableUpdateBlogPostEntityRelationInput"] | undefined,
	page?: GraphQLTypes["LinkableUpdatePageEntityRelationInput"] | undefined,
	wikiPage?: GraphQLTypes["LinkableUpdateWikiPageEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RedirectUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutRedirectUpdateInput"] | undefined,
	create?: GraphQLTypes["LinkableWithoutRedirectCreateInput"] | undefined
};
	["NutritionFactsConnection"]: {
	__typename: "NutritionFactsConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["NutritionFactsEdge"]>
};
	["NutritionFactsEdge"]: {
	__typename: "NutritionFactsEdge",
	node: GraphQLTypes["NutritionFacts"]
};
	["VenueCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	deadlineTemplate?: GraphQLTypes["VenueCreateDeadlineTemplateEntityRelationInput"] | undefined,
	timetableDays?: Array<GraphQLTypes["VenueCreateTimetableDaysEntityRelationInput"]> | undefined,
	timetableTemplates?: Array<GraphQLTypes["VenueCreateTimetableTemplatesEntityRelationInput"]> | undefined,
	staffMembers?: Array<GraphQLTypes["VenueCreateStaffMembersEntityRelationInput"]> | undefined,
	employeeRoles?: Array<GraphQLTypes["VenueCreateEmployeeRolesEntityRelationInput"]> | undefined,
	pointOfSaleApplicationDevices?: Array<GraphQLTypes["VenueCreatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined,
	pointOfSaleTerminals?: Array<GraphQLTypes["VenueCreatePointOfSaleTerminalsEntityRelationInput"]> | undefined,
	pointOfSalePrinters?: Array<GraphQLTypes["VenueCreatePointOfSalePrintersEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["VenueCreateOrdersEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["VenueCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	areas?: Array<GraphQLTypes["VenueCreateAreasEntityRelationInput"]> | undefined,
	enabledUnassignReasons?: Array<GraphQLTypes["VenueCreateEnabledUnassignReasonsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["VenueCreateCategoriesEntityRelationInput"]> | undefined,
	channels?: Array<GraphQLTypes["VenueCreateChannelsEntityRelationInput"]> | undefined,
	address?: string | undefined,
	pointOfSalePngBase64ReceiptLogo?: string | undefined,
	pointOfSaleInitialView?: GraphQLTypes["PointOfSaleInitialView"] | undefined,
	pointOfSalePreferPrintReceipt?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["VenueUpdateInput"]: {
		name?: string | undefined,
	deadlineTemplate?: GraphQLTypes["VenueUpdateDeadlineTemplateEntityRelationInput"] | undefined,
	timetableDays?: Array<GraphQLTypes["VenueUpdateTimetableDaysEntityRelationInput"]> | undefined,
	timetableTemplates?: Array<GraphQLTypes["VenueUpdateTimetableTemplatesEntityRelationInput"]> | undefined,
	staffMembers?: Array<GraphQLTypes["VenueUpdateStaffMembersEntityRelationInput"]> | undefined,
	employeeRoles?: Array<GraphQLTypes["VenueUpdateEmployeeRolesEntityRelationInput"]> | undefined,
	pointOfSaleApplicationDevices?: Array<GraphQLTypes["VenueUpdatePointOfSaleApplicationDevicesEntityRelationInput"]> | undefined,
	pointOfSaleTerminals?: Array<GraphQLTypes["VenueUpdatePointOfSaleTerminalsEntityRelationInput"]> | undefined,
	pointOfSalePrinters?: Array<GraphQLTypes["VenueUpdatePointOfSalePrintersEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["VenueUpdateOrdersEntityRelationInput"]> | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["VenueUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	areas?: Array<GraphQLTypes["VenueUpdateAreasEntityRelationInput"]> | undefined,
	enabledUnassignReasons?: Array<GraphQLTypes["VenueUpdateEnabledUnassignReasonsEntityRelationInput"]> | undefined,
	categories?: Array<GraphQLTypes["VenueUpdateCategoriesEntityRelationInput"]> | undefined,
	channels?: Array<GraphQLTypes["VenueUpdateChannelsEntityRelationInput"]> | undefined,
	address?: string | undefined,
	pointOfSalePngBase64ReceiptLogo?: string | undefined,
	pointOfSaleInitialView?: GraphQLTypes["PointOfSaleInitialView"] | undefined,
	pointOfSalePreferPrintReceipt?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["WorkspaceConnection"]: {
	__typename: "WorkspaceConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["WorkspaceEdge"]>
};
	["WorkspaceEdge"]: {
	__typename: "WorkspaceEdge",
	node: GraphQLTypes["Workspace"]
};
	["WorkspaceCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	orderDeadlineTime?: string | undefined,
	ordersLoadingDurationHours?: number | undefined,
	freshingContainerVolumeMl?: number | undefined,
	freshingPrepareOrderByOffsetMinutes?: number | undefined,
	checkoutUrlTemplate?: string | undefined,
	orderUrlTemplate?: string | undefined,
	paymentUrlTemplate?: string | undefined,
	customerProfileUrlTemplate?: string | undefined,
	userProfileUrlTemplate?: string | undefined,
	messengerUrl?: string | undefined,
	messengerIosUrl?: string | undefined,
	messengerAndroidUrl?: string | undefined,
	freshingContainers?: Array<GraphQLTypes["WorkspaceCreateFreshingContainersEntityRelationInput"]> | undefined,
	openingHours?: GraphQLTypes["WorkspaceCreateOpeningHoursEntityRelationInput"] | undefined,
	workingHours?: GraphQLTypes["WorkspaceCreateWorkingHoursEntityRelationInput"] | undefined,
	defaultFreshingContainer?: GraphQLTypes["WorkspaceCreateDefaultFreshingContainerEntityRelationInput"] | undefined,
	creditsProduct?: GraphQLTypes["WorkspaceCreateCreditsProductEntityRelationInput"] | undefined,
	discountVatRate?: GraphQLTypes["WorkspaceCreateDiscountVatRateEntityRelationInput"] | undefined,
	name?: string | undefined,
	businessAddress?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["WorkspaceCreateFreshingContainersEntityRelationInput"]: {
		connect?: GraphQLTypes["FreshingContainerUniqueWhere"] | undefined,
	create?: GraphQLTypes["FreshingContainerWithoutWorkspaceCreateInput"] | undefined,
	alias?: string | undefined
};
	["FreshingContainerWithoutWorkspaceCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	volumeMl?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["WorkspaceUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	orderDeadlineTime?: string | undefined,
	ordersLoadingDurationHours?: number | undefined,
	freshingContainerVolumeMl?: number | undefined,
	freshingPrepareOrderByOffsetMinutes?: number | undefined,
	checkoutUrlTemplate?: string | undefined,
	orderUrlTemplate?: string | undefined,
	paymentUrlTemplate?: string | undefined,
	customerProfileUrlTemplate?: string | undefined,
	userProfileUrlTemplate?: string | undefined,
	messengerUrl?: string | undefined,
	messengerIosUrl?: string | undefined,
	messengerAndroidUrl?: string | undefined,
	freshingContainers?: Array<GraphQLTypes["WorkspaceUpdateFreshingContainersEntityRelationInput"]> | undefined,
	openingHours?: GraphQLTypes["WorkspaceUpdateOpeningHoursEntityRelationInput"] | undefined,
	workingHours?: GraphQLTypes["WorkspaceUpdateWorkingHoursEntityRelationInput"] | undefined,
	defaultFreshingContainer?: GraphQLTypes["WorkspaceUpdateDefaultFreshingContainerEntityRelationInput"] | undefined,
	creditsProduct?: GraphQLTypes["WorkspaceUpdateCreditsProductEntityRelationInput"] | undefined,
	discountVatRate?: GraphQLTypes["WorkspaceUpdateDiscountVatRateEntityRelationInput"] | undefined,
	name?: string | undefined,
	businessAddress?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["WorkspaceUpdateFreshingContainersEntityRelationInput"]: {
		create?: GraphQLTypes["FreshingContainerWithoutWorkspaceCreateInput"] | undefined,
	update?: GraphQLTypes["WorkspaceUpdateFreshingContainersRelationInput"] | undefined,
	upsert?: GraphQLTypes["WorkspaceUpsertFreshingContainersRelationInput"] | undefined,
	connect?: GraphQLTypes["FreshingContainerUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["FreshingContainerUniqueWhere"] | undefined,
	delete?: GraphQLTypes["FreshingContainerUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["WorkspaceUpdateFreshingContainersRelationInput"]: {
		by?: GraphQLTypes["FreshingContainerUniqueWhere"] | undefined,
	data?: GraphQLTypes["FreshingContainerWithoutWorkspaceUpdateInput"] | undefined
};
	["FreshingContainerWithoutWorkspaceUpdateInput"]: {
		order?: number | undefined,
	volumeMl?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["WorkspaceUpsertFreshingContainersRelationInput"]: {
		by?: GraphQLTypes["FreshingContainerUniqueWhere"] | undefined,
	update?: GraphQLTypes["FreshingContainerWithoutWorkspaceUpdateInput"] | undefined,
	create?: GraphQLTypes["FreshingContainerWithoutWorkspaceCreateInput"] | undefined
};
	["InternalBuyerConnection"]: {
	__typename: "InternalBuyerConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["InternalBuyerEdge"]>
};
	["InternalBuyerEdge"]: {
	__typename: "InternalBuyerEdge",
	node: GraphQLTypes["InternalBuyer"]
};
	["InternalBuyerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	staff?: GraphQLTypes["InternalBuyerCreateStaffEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InternalBuyerCreateStaffEntityRelationInput"]: {
		connect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	create?: GraphQLTypes["StaffWithoutInternalBuyerCreateInput"] | undefined
};
	["StaffWithoutInternalBuyerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	bartender?: GraphQLTypes["StaffCreateBartenderEntityRelationInput"] | undefined,
	courier?: GraphQLTypes["StaffCreateCourierEntityRelationInput"] | undefined,
	cleaner?: GraphQLTypes["StaffCreateCleanerEntityRelationInput"] | undefined,
	shiftsManager?: GraphQLTypes["StaffCreateShiftsManagerEntityRelationInput"] | undefined,
	businessToBusinessManager?: GraphQLTypes["StaffCreateBusinessToBusinessManagerEntityRelationInput"] | undefined,
	user?: GraphQLTypes["StaffCreateUserEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["StaffCreateShiftsProfileEntityRelationInput"] | undefined,
	stocksManager?: GraphQLTypes["StaffCreateStocksManagerEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["StaffCreatePhotoEntityRelationInput"] | undefined,
	courierManager?: GraphQLTypes["StaffCreateCourierManagerEntityRelationInput"] | undefined,
	picker?: GraphQLTypes["StaffCreatePickerEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	remunerationProfile?: GraphQLTypes["StaffCreateRemunerationProfileEntityRelationInput"] | undefined,
	cashier?: GraphQLTypes["StaffCreateCashierEntityRelationInput"] | undefined,
	venues?: Array<GraphQLTypes["StaffCreateVenuesEntityRelationInput"]> | undefined,
	salesManager?: GraphQLTypes["StaffCreateSalesManagerEntityRelationInput"] | undefined,
	cashierManager?: GraphQLTypes["StaffCreateCashierManagerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InternalBuyerUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	staff?: GraphQLTypes["InternalBuyerUpdateStaffEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InternalBuyerUpdateStaffEntityRelationInput"]: {
		create?: GraphQLTypes["StaffWithoutInternalBuyerCreateInput"] | undefined,
	update?: GraphQLTypes["StaffWithoutInternalBuyerUpdateInput"] | undefined,
	upsert?: GraphQLTypes["InternalBuyerUpsertStaffRelationInput"] | undefined,
	connect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["StaffWithoutInternalBuyerUpdateInput"]: {
		bartender?: GraphQLTypes["StaffUpdateBartenderEntityRelationInput"] | undefined,
	courier?: GraphQLTypes["StaffUpdateCourierEntityRelationInput"] | undefined,
	cleaner?: GraphQLTypes["StaffUpdateCleanerEntityRelationInput"] | undefined,
	shiftsManager?: GraphQLTypes["StaffUpdateShiftsManagerEntityRelationInput"] | undefined,
	businessToBusinessManager?: GraphQLTypes["StaffUpdateBusinessToBusinessManagerEntityRelationInput"] | undefined,
	user?: GraphQLTypes["StaffUpdateUserEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["StaffUpdateShiftsProfileEntityRelationInput"] | undefined,
	stocksManager?: GraphQLTypes["StaffUpdateStocksManagerEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["StaffUpdatePhotoEntityRelationInput"] | undefined,
	courierManager?: GraphQLTypes["StaffUpdateCourierManagerEntityRelationInput"] | undefined,
	picker?: GraphQLTypes["StaffUpdatePickerEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	remunerationProfile?: GraphQLTypes["StaffUpdateRemunerationProfileEntityRelationInput"] | undefined,
	cashier?: GraphQLTypes["StaffUpdateCashierEntityRelationInput"] | undefined,
	venues?: Array<GraphQLTypes["StaffUpdateVenuesEntityRelationInput"]> | undefined,
	salesManager?: GraphQLTypes["StaffUpdateSalesManagerEntityRelationInput"] | undefined,
	cashierManager?: GraphQLTypes["StaffUpdateCashierManagerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["InternalBuyerUpsertStaffRelationInput"]: {
		update?: GraphQLTypes["StaffWithoutInternalBuyerUpdateInput"] | undefined,
	create?: GraphQLTypes["StaffWithoutInternalBuyerCreateInput"] | undefined
};
	["CartSummaryConnection"]: {
	__typename: "CartSummaryConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CartSummaryEdge"]>
};
	["CartSummaryEdge"]: {
	__typename: "CartSummaryEdge",
	node: GraphQLTypes["CartSummary"]
};
	["OrderSummaryConnection"]: {
	__typename: "OrderSummaryConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["OrderSummaryEdge"]>
};
	["OrderSummaryEdge"]: {
	__typename: "OrderSummaryEdge",
	node: GraphQLTypes["OrderSummary"]
};
	["CustomerSpendingConnection"]: {
	__typename: "CustomerSpendingConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CustomerSpendingEdge"]>
};
	["CustomerSpendingEdge"]: {
	__typename: "CustomerSpendingEdge",
	node: GraphQLTypes["CustomerSpending"]
};
	["OrderPaymentMetadataConnection"]: {
	__typename: "OrderPaymentMetadataConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["OrderPaymentMetadataEdge"]>
};
	["OrderPaymentMetadataEdge"]: {
	__typename: "OrderPaymentMetadataEdge",
	node: GraphQLTypes["OrderPaymentMetadata"]
};
	["UserMetadataConnection"]: {
	__typename: "UserMetadataConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["UserMetadataEdge"]>
};
	["UserMetadataEdge"]: {
	__typename: "UserMetadataEdge",
	node: GraphQLTypes["UserMetadata"]
};
	["CustomerTabMetadataConnection"]: {
	__typename: "CustomerTabMetadataConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CustomerTabMetadataEdge"]>
};
	["CustomerTabMetadataEdge"]: {
	__typename: "CustomerTabMetadataEdge",
	node: GraphQLTypes["CustomerTabMetadata"]
};
	["VenueEmployeeRoleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	employeePrivileges?: GraphQLTypes["VenueEmployeeRoleCreateEmployeePrivilegesEntityRelationInput"] | undefined,
	venue?: GraphQLTypes["VenueEmployeeRoleCreateVenueEntityRelationInput"] | undefined,
	role?: GraphQLTypes["VenueEmployeeRoleCreateRoleEntityRelationInput"] | undefined,
	getsTipsShare?: boolean | undefined,
	notesEnabled?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["VenueEmployeeRoleUpdateInput"]: {
		order?: number | undefined,
	employeePrivileges?: GraphQLTypes["VenueEmployeeRoleUpdateEmployeePrivilegesEntityRelationInput"] | undefined,
	venue?: GraphQLTypes["VenueEmployeeRoleUpdateVenueEntityRelationInput"] | undefined,
	role?: GraphQLTypes["VenueEmployeeRoleUpdateRoleEntityRelationInput"] | undefined,
	getsTipsShare?: boolean | undefined,
	notesEnabled?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["IdentificationAttemptCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	code?: GraphQLTypes["IdentificationAttemptCreateCodeEntityRelationInput"] | undefined,
	user?: GraphQLTypes["IdentificationAttemptCreateUserEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["IdentificationAttemptUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	code?: GraphQLTypes["IdentificationAttemptUpdateCodeEntityRelationInput"] | undefined,
	user?: GraphQLTypes["IdentificationAttemptUpdateUserEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["IdentificationCodeConnection"]: {
	__typename: "IdentificationCodeConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["IdentificationCodeEdge"]>
};
	["IdentificationCodeEdge"]: {
	__typename: "IdentificationCodeEdge",
	node: GraphQLTypes["IdentificationCode"]
};
	["IdentificationCodeCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	attempts?: Array<GraphQLTypes["IdentificationCodeCreateAttemptsEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["IdentificationCodeCreateLocalesEntityRelationInput"]> | undefined,
	internalName?: string | undefined,
	applicationDevices?: Array<GraphQLTypes["IdentificationCodeCreateApplicationDevicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["IdentificationCodeUpdateInput"]: {
		code?: string | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	attempts?: Array<GraphQLTypes["IdentificationCodeUpdateAttemptsEntityRelationInput"]> | undefined,
	locales?: Array<GraphQLTypes["IdentificationCodeUpdateLocalesEntityRelationInput"]> | undefined,
	internalName?: string | undefined,
	applicationDevices?: Array<GraphQLTypes["IdentificationCodeUpdateApplicationDevicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["IdentificationCodeLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	successMessage?: string | undefined,
	root?: GraphQLTypes["IdentificationCodeLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["IdentificationCodeLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["IdentificationCodeLocaleUpdateInput"]: {
		successMessage?: string | undefined,
	root?: GraphQLTypes["IdentificationCodeLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["IdentificationCodeLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PipelineConnection"]: {
	__typename: "PipelineConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PipelineEdge"]>
};
	["PipelineEdge"]: {
	__typename: "PipelineEdge",
	node: GraphQLTypes["Pipeline"]
};
	["PipelineCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	stages?: Array<GraphQLTypes["PipelineCreateStagesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PipelineCreateStagesEntityRelationInput"]: {
		connect?: GraphQLTypes["PipelineStageUniqueWhere"] | undefined,
	create?: GraphQLTypes["PipelineStageWithoutPipelineCreateInput"] | undefined,
	alias?: string | undefined
};
	["PipelineStageWithoutPipelineCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["PipelineStageCreateItemsEntityRelationInput"]> | undefined,
	order?: number | undefined,
	locales?: Array<GraphQLTypes["PipelineStageCreateLocalesEntityRelationInput"]> | undefined,
	sentiment?: GraphQLTypes["PipelineStageCreateSentimentEntityRelationInput"] | undefined,
	type?: GraphQLTypes["PipelineStageType"] | undefined,
	forms?: Array<GraphQLTypes["PipelineStageCreateFormsEntityRelationInput"]> | undefined,
	showItemsWeight?: boolean | undefined,
	showItemsPrice?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PipelineUpdateInput"]: {
		unique?: GraphQLTypes["One"] | undefined,
	stages?: Array<GraphQLTypes["PipelineUpdateStagesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PipelineUpdateStagesEntityRelationInput"]: {
		create?: GraphQLTypes["PipelineStageWithoutPipelineCreateInput"] | undefined,
	update?: GraphQLTypes["PipelineUpdateStagesRelationInput"] | undefined,
	upsert?: GraphQLTypes["PipelineUpsertStagesRelationInput"] | undefined,
	connect?: GraphQLTypes["PipelineStageUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PipelineStageUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PipelineStageUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["PipelineUpdateStagesRelationInput"]: {
		by?: GraphQLTypes["PipelineStageUniqueWhere"] | undefined,
	data?: GraphQLTypes["PipelineStageWithoutPipelineUpdateInput"] | undefined
};
	["PipelineStageWithoutPipelineUpdateInput"]: {
		items?: Array<GraphQLTypes["PipelineStageUpdateItemsEntityRelationInput"]> | undefined,
	order?: number | undefined,
	locales?: Array<GraphQLTypes["PipelineStageUpdateLocalesEntityRelationInput"]> | undefined,
	sentiment?: GraphQLTypes["PipelineStageUpdateSentimentEntityRelationInput"] | undefined,
	type?: GraphQLTypes["PipelineStageType"] | undefined,
	forms?: Array<GraphQLTypes["PipelineStageUpdateFormsEntityRelationInput"]> | undefined,
	showItemsWeight?: boolean | undefined,
	showItemsPrice?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PipelineUpsertStagesRelationInput"]: {
		by?: GraphQLTypes["PipelineStageUniqueWhere"] | undefined,
	update?: GraphQLTypes["PipelineStageWithoutPipelineUpdateInput"] | undefined,
	create?: GraphQLTypes["PipelineStageWithoutPipelineCreateInput"] | undefined
};
	["PipelineLeadCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	stageItem?: GraphQLTypes["PipelineLeadCreateStageItemEntityRelationInput"] | undefined,
	contactPerson?: string | undefined,
	customer?: GraphQLTypes["PipelineLeadCreateCustomerEntityRelationInput"] | undefined,
	cafeType?: string | undefined,
	offerType?: string | undefined,
	ownMachine?: boolean | undefined,
	customerCity?: string | undefined,
	companyId?: string | undefined,
	customerName?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	form?: GraphQLTypes["PipelineLeadCreateFormEntityRelationInput"] | undefined,
	meta?: string | undefined,
	multiroasterType?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["PipelineLeadUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	stageItem?: GraphQLTypes["PipelineLeadUpdateStageItemEntityRelationInput"] | undefined,
	contactPerson?: string | undefined,
	customer?: GraphQLTypes["PipelineLeadUpdateCustomerEntityRelationInput"] | undefined,
	cafeType?: string | undefined,
	offerType?: string | undefined,
	ownMachine?: boolean | undefined,
	customerCity?: string | undefined,
	companyId?: string | undefined,
	customerName?: string | undefined,
	email?: string | undefined,
	phone?: string | undefined,
	form?: GraphQLTypes["PipelineLeadUpdateFormEntityRelationInput"] | undefined,
	meta?: string | undefined,
	multiroasterType?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["PipelineStageCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["PipelineStageCreateItemsEntityRelationInput"]> | undefined,
	pipeline?: GraphQLTypes["PipelineStageCreatePipelineEntityRelationInput"] | undefined,
	order?: number | undefined,
	locales?: Array<GraphQLTypes["PipelineStageCreateLocalesEntityRelationInput"]> | undefined,
	sentiment?: GraphQLTypes["PipelineStageCreateSentimentEntityRelationInput"] | undefined,
	type?: GraphQLTypes["PipelineStageType"] | undefined,
	forms?: Array<GraphQLTypes["PipelineStageCreateFormsEntityRelationInput"]> | undefined,
	showItemsWeight?: boolean | undefined,
	showItemsPrice?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PipelineStageUpdateInput"]: {
		items?: Array<GraphQLTypes["PipelineStageUpdateItemsEntityRelationInput"]> | undefined,
	pipeline?: GraphQLTypes["PipelineStageUpdatePipelineEntityRelationInput"] | undefined,
	order?: number | undefined,
	locales?: Array<GraphQLTypes["PipelineStageUpdateLocalesEntityRelationInput"]> | undefined,
	sentiment?: GraphQLTypes["PipelineStageUpdateSentimentEntityRelationInput"] | undefined,
	type?: GraphQLTypes["PipelineStageType"] | undefined,
	forms?: Array<GraphQLTypes["PipelineStageUpdateFormsEntityRelationInput"]> | undefined,
	showItemsWeight?: boolean | undefined,
	showItemsPrice?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["PipelineStageItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	list?: GraphQLTypes["PipelineStageItemCreateListEntityRelationInput"] | undefined,
	lead?: GraphQLTypes["PipelineStageItemCreateLeadEntityRelationInput"] | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["PipelineStageItemUpdateInput"]: {
		list?: GraphQLTypes["PipelineStageItemUpdateListEntityRelationInput"] | undefined,
	lead?: GraphQLTypes["PipelineStageItemUpdateLeadEntityRelationInput"] | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["PipelineStageLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	root?: GraphQLTypes["PipelineStageLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["PipelineStageLocaleCreateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PipelineStageLocaleUpdateInput"]: {
		name?: string | undefined,
	root?: GraphQLTypes["PipelineStageLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["PipelineStageLocaleUpdateLocaleEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SalesManagerConnection"]: {
	__typename: "SalesManagerConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SalesManagerEdge"]>
};
	["SalesManagerEdge"]: {
	__typename: "SalesManagerEdge",
	node: GraphQLTypes["SalesManager"]
};
	["SalesManagerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	staff?: GraphQLTypes["SalesManagerCreateStaffEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	countries?: Array<GraphQLTypes["SalesManagerCreateCountriesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["SalesManagerCreateStaffEntityRelationInput"]: {
		connect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	create?: GraphQLTypes["StaffWithoutSalesManagerCreateInput"] | undefined
};
	["StaffWithoutSalesManagerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	bartender?: GraphQLTypes["StaffCreateBartenderEntityRelationInput"] | undefined,
	courier?: GraphQLTypes["StaffCreateCourierEntityRelationInput"] | undefined,
	cleaner?: GraphQLTypes["StaffCreateCleanerEntityRelationInput"] | undefined,
	shiftsManager?: GraphQLTypes["StaffCreateShiftsManagerEntityRelationInput"] | undefined,
	businessToBusinessManager?: GraphQLTypes["StaffCreateBusinessToBusinessManagerEntityRelationInput"] | undefined,
	user?: GraphQLTypes["StaffCreateUserEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["StaffCreateShiftsProfileEntityRelationInput"] | undefined,
	stocksManager?: GraphQLTypes["StaffCreateStocksManagerEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["StaffCreatePhotoEntityRelationInput"] | undefined,
	courierManager?: GraphQLTypes["StaffCreateCourierManagerEntityRelationInput"] | undefined,
	picker?: GraphQLTypes["StaffCreatePickerEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	remunerationProfile?: GraphQLTypes["StaffCreateRemunerationProfileEntityRelationInput"] | undefined,
	cashier?: GraphQLTypes["StaffCreateCashierEntityRelationInput"] | undefined,
	venues?: Array<GraphQLTypes["StaffCreateVenuesEntityRelationInput"]> | undefined,
	internalBuyer?: GraphQLTypes["StaffCreateInternalBuyerEntityRelationInput"] | undefined,
	cashierManager?: GraphQLTypes["StaffCreateCashierManagerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SalesManagerUpdateInput"]: {
		staff?: GraphQLTypes["SalesManagerUpdateStaffEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	countries?: Array<GraphQLTypes["SalesManagerUpdateCountriesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["SalesManagerUpdateStaffEntityRelationInput"]: {
		create?: GraphQLTypes["StaffWithoutSalesManagerCreateInput"] | undefined,
	update?: GraphQLTypes["StaffWithoutSalesManagerUpdateInput"] | undefined,
	upsert?: GraphQLTypes["SalesManagerUpsertStaffRelationInput"] | undefined,
	connect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["StaffWithoutSalesManagerUpdateInput"]: {
		bartender?: GraphQLTypes["StaffUpdateBartenderEntityRelationInput"] | undefined,
	courier?: GraphQLTypes["StaffUpdateCourierEntityRelationInput"] | undefined,
	cleaner?: GraphQLTypes["StaffUpdateCleanerEntityRelationInput"] | undefined,
	shiftsManager?: GraphQLTypes["StaffUpdateShiftsManagerEntityRelationInput"] | undefined,
	businessToBusinessManager?: GraphQLTypes["StaffUpdateBusinessToBusinessManagerEntityRelationInput"] | undefined,
	user?: GraphQLTypes["StaffUpdateUserEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["StaffUpdateShiftsProfileEntityRelationInput"] | undefined,
	stocksManager?: GraphQLTypes["StaffUpdateStocksManagerEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["StaffUpdatePhotoEntityRelationInput"] | undefined,
	courierManager?: GraphQLTypes["StaffUpdateCourierManagerEntityRelationInput"] | undefined,
	picker?: GraphQLTypes["StaffUpdatePickerEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	remunerationProfile?: GraphQLTypes["StaffUpdateRemunerationProfileEntityRelationInput"] | undefined,
	cashier?: GraphQLTypes["StaffUpdateCashierEntityRelationInput"] | undefined,
	venues?: Array<GraphQLTypes["StaffUpdateVenuesEntityRelationInput"]> | undefined,
	internalBuyer?: GraphQLTypes["StaffUpdateInternalBuyerEntityRelationInput"] | undefined,
	cashierManager?: GraphQLTypes["StaffUpdateCashierManagerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SalesManagerUpsertStaffRelationInput"]: {
		update?: GraphQLTypes["StaffWithoutSalesManagerUpdateInput"] | undefined,
	create?: GraphQLTypes["StaffWithoutSalesManagerCreateInput"] | undefined
};
	["CashierManagerConnection"]: {
	__typename: "CashierManagerConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CashierManagerEdge"]>
};
	["CashierManagerEdge"]: {
	__typename: "CashierManagerEdge",
	node: GraphQLTypes["CashierManager"]
};
	["CashierManagerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	staff?: GraphQLTypes["CashierManagerCreateStaffEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CashierManagerCreateStaffEntityRelationInput"]: {
		connect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	create?: GraphQLTypes["StaffWithoutCashierManagerCreateInput"] | undefined
};
	["StaffWithoutCashierManagerCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	bartender?: GraphQLTypes["StaffCreateBartenderEntityRelationInput"] | undefined,
	courier?: GraphQLTypes["StaffCreateCourierEntityRelationInput"] | undefined,
	cleaner?: GraphQLTypes["StaffCreateCleanerEntityRelationInput"] | undefined,
	shiftsManager?: GraphQLTypes["StaffCreateShiftsManagerEntityRelationInput"] | undefined,
	businessToBusinessManager?: GraphQLTypes["StaffCreateBusinessToBusinessManagerEntityRelationInput"] | undefined,
	user?: GraphQLTypes["StaffCreateUserEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["StaffCreateShiftsProfileEntityRelationInput"] | undefined,
	stocksManager?: GraphQLTypes["StaffCreateStocksManagerEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["StaffCreatePhotoEntityRelationInput"] | undefined,
	courierManager?: GraphQLTypes["StaffCreateCourierManagerEntityRelationInput"] | undefined,
	picker?: GraphQLTypes["StaffCreatePickerEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	remunerationProfile?: GraphQLTypes["StaffCreateRemunerationProfileEntityRelationInput"] | undefined,
	cashier?: GraphQLTypes["StaffCreateCashierEntityRelationInput"] | undefined,
	venues?: Array<GraphQLTypes["StaffCreateVenuesEntityRelationInput"]> | undefined,
	internalBuyer?: GraphQLTypes["StaffCreateInternalBuyerEntityRelationInput"] | undefined,
	salesManager?: GraphQLTypes["StaffCreateSalesManagerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CashierManagerUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	staff?: GraphQLTypes["CashierManagerUpdateStaffEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CashierManagerUpdateStaffEntityRelationInput"]: {
		create?: GraphQLTypes["StaffWithoutCashierManagerCreateInput"] | undefined,
	update?: GraphQLTypes["StaffWithoutCashierManagerUpdateInput"] | undefined,
	upsert?: GraphQLTypes["CashierManagerUpsertStaffRelationInput"] | undefined,
	connect?: GraphQLTypes["StaffUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["StaffWithoutCashierManagerUpdateInput"]: {
		bartender?: GraphQLTypes["StaffUpdateBartenderEntityRelationInput"] | undefined,
	courier?: GraphQLTypes["StaffUpdateCourierEntityRelationInput"] | undefined,
	cleaner?: GraphQLTypes["StaffUpdateCleanerEntityRelationInput"] | undefined,
	shiftsManager?: GraphQLTypes["StaffUpdateShiftsManagerEntityRelationInput"] | undefined,
	businessToBusinessManager?: GraphQLTypes["StaffUpdateBusinessToBusinessManagerEntityRelationInput"] | undefined,
	user?: GraphQLTypes["StaffUpdateUserEntityRelationInput"] | undefined,
	shiftsProfile?: GraphQLTypes["StaffUpdateShiftsProfileEntityRelationInput"] | undefined,
	stocksManager?: GraphQLTypes["StaffUpdateStocksManagerEntityRelationInput"] | undefined,
	photo?: GraphQLTypes["StaffUpdatePhotoEntityRelationInput"] | undefined,
	courierManager?: GraphQLTypes["StaffUpdateCourierManagerEntityRelationInput"] | undefined,
	picker?: GraphQLTypes["StaffUpdatePickerEntityRelationInput"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	remunerationProfile?: GraphQLTypes["StaffUpdateRemunerationProfileEntityRelationInput"] | undefined,
	cashier?: GraphQLTypes["StaffUpdateCashierEntityRelationInput"] | undefined,
	venues?: Array<GraphQLTypes["StaffUpdateVenuesEntityRelationInput"]> | undefined,
	internalBuyer?: GraphQLTypes["StaffUpdateInternalBuyerEntityRelationInput"] | undefined,
	salesManager?: GraphQLTypes["StaffUpdateSalesManagerEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["CashierManagerUpsertStaffRelationInput"]: {
		update?: GraphQLTypes["StaffWithoutCashierManagerUpdateInput"] | undefined,
	create?: GraphQLTypes["StaffWithoutCashierManagerCreateInput"] | undefined
};
	["UserRolesConnection"]: {
	__typename: "UserRolesConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["UserRolesEdge"]>
};
	["UserRolesEdge"]: {
	__typename: "UserRolesEdge",
	node: GraphQLTypes["UserRoles"]
};
	["PointOfSaleApplicationDeviceCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	internalName?: string | undefined,
	note?: string | undefined,
	venue?: GraphQLTypes["PointOfSaleApplicationDeviceCreateVenueEntityRelationInput"] | undefined,
	identificationCode?: GraphQLTypes["PointOfSaleApplicationDeviceCreateIdentificationCodeEntityRelationInput"] | undefined,
	identifier?: GraphQLTypes["PointOfSaleApplicationDeviceCreateIdentifierEntityRelationInput"] | undefined,
	terminal?: GraphQLTypes["PointOfSaleApplicationDeviceCreateTerminalEntityRelationInput"] | undefined,
	receiptPrinter?: GraphQLTypes["PointOfSaleApplicationDeviceCreateReceiptPrinterEntityRelationInput"] | undefined,
	ticketPrinters?: Array<GraphQLTypes["PointOfSaleApplicationDeviceCreateTicketPrintersEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleApplicationDeviceUpdateInput"]: {
		internalName?: string | undefined,
	note?: string | undefined,
	venue?: GraphQLTypes["PointOfSaleApplicationDeviceUpdateVenueEntityRelationInput"] | undefined,
	identificationCode?: GraphQLTypes["PointOfSaleApplicationDeviceUpdateIdentificationCodeEntityRelationInput"] | undefined,
	identifier?: GraphQLTypes["PointOfSaleApplicationDeviceUpdateIdentifierEntityRelationInput"] | undefined,
	terminal?: GraphQLTypes["PointOfSaleApplicationDeviceUpdateTerminalEntityRelationInput"] | undefined,
	receiptPrinter?: GraphQLTypes["PointOfSaleApplicationDeviceUpdateReceiptPrinterEntityRelationInput"] | undefined,
	ticketPrinters?: Array<GraphQLTypes["PointOfSaleApplicationDeviceUpdateTicketPrintersEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleTerminalCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	internalName?: string | undefined,
	note?: string | undefined,
	venue?: GraphQLTypes["PointOfSaleTerminalCreateVenueEntityRelationInput"] | undefined,
	applicationDevices?: Array<GraphQLTypes["PointOfSaleTerminalCreateApplicationDevicesEntityRelationInput"]> | undefined,
	ipAddress?: string | undefined,
	port?: number | undefined,
	type?: GraphQLTypes["PointOfSaleTerminalType"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSaleTerminalUpdateInput"]: {
		internalName?: string | undefined,
	note?: string | undefined,
	venue?: GraphQLTypes["PointOfSaleTerminalUpdateVenueEntityRelationInput"] | undefined,
	applicationDevices?: Array<GraphQLTypes["PointOfSaleTerminalUpdateApplicationDevicesEntityRelationInput"]> | undefined,
	ipAddress?: string | undefined,
	port?: number | undefined,
	type?: GraphQLTypes["PointOfSaleTerminalType"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["PipelineStageSentimentConnection"]: {
	__typename: "PipelineStageSentimentConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PipelineStageSentimentEdge"]>
};
	["PipelineStageSentimentEdge"]: {
	__typename: "PipelineStageSentimentEdge",
	node: GraphQLTypes["PipelineStageSentiment"]
};
	["DeviceIdentifierConnection"]: {
	__typename: "DeviceIdentifierConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DeviceIdentifierEdge"]>
};
	["DeviceIdentifierEdge"]: {
	__typename: "DeviceIdentifierEdge",
	node: GraphQLTypes["DeviceIdentifier"]
};
	["DeviceIdentifierCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	internalName?: string | undefined,
	device?: GraphQLTypes["DeviceIdentifierCreateDeviceEntityRelationInput"] | undefined,
	updatedAt?: GraphQLTypes["DateTime"] | undefined,
	platform?: string | undefined,
	resolution?: string | undefined,
	devicePixelRatio?: number | undefined,
	updatedByUser?: GraphQLTypes["DeviceIdentifierCreateUpdatedByUserEntityRelationInput"] | undefined,
	identifier?: string | undefined,
	applicationVersionIdentifier?: string | undefined,
	lastPointOfSaleSynchronizationErrorRawDetails?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeviceIdentifierCreateDeviceEntityRelationInput"]: {
		connect?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined,
	create?: GraphQLTypes["PointOfSaleApplicationDeviceWithoutIdentifierCreateInput"] | undefined
};
	["PointOfSaleApplicationDeviceWithoutIdentifierCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	internalName?: string | undefined,
	note?: string | undefined,
	venue?: GraphQLTypes["PointOfSaleApplicationDeviceCreateVenueEntityRelationInput"] | undefined,
	identificationCode?: GraphQLTypes["PointOfSaleApplicationDeviceCreateIdentificationCodeEntityRelationInput"] | undefined,
	terminal?: GraphQLTypes["PointOfSaleApplicationDeviceCreateTerminalEntityRelationInput"] | undefined,
	receiptPrinter?: GraphQLTypes["PointOfSaleApplicationDeviceCreateReceiptPrinterEntityRelationInput"] | undefined,
	ticketPrinters?: Array<GraphQLTypes["PointOfSaleApplicationDeviceCreateTicketPrintersEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeviceIdentifierUpdateInput"]: {
		internalName?: string | undefined,
	device?: GraphQLTypes["DeviceIdentifierUpdateDeviceEntityRelationInput"] | undefined,
	updatedAt?: GraphQLTypes["DateTime"] | undefined,
	platform?: string | undefined,
	resolution?: string | undefined,
	devicePixelRatio?: number | undefined,
	updatedByUser?: GraphQLTypes["DeviceIdentifierUpdateUpdatedByUserEntityRelationInput"] | undefined,
	identifier?: string | undefined,
	applicationVersionIdentifier?: string | undefined,
	lastPointOfSaleSynchronizationErrorRawDetails?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeviceIdentifierUpdateDeviceEntityRelationInput"]: {
		create?: GraphQLTypes["PointOfSaleApplicationDeviceWithoutIdentifierCreateInput"] | undefined,
	update?: GraphQLTypes["PointOfSaleApplicationDeviceWithoutIdentifierUpdateInput"] | undefined,
	upsert?: GraphQLTypes["DeviceIdentifierUpsertDeviceRelationInput"] | undefined,
	connect?: GraphQLTypes["PointOfSaleApplicationDeviceUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["PointOfSaleApplicationDeviceWithoutIdentifierUpdateInput"]: {
		internalName?: string | undefined,
	note?: string | undefined,
	venue?: GraphQLTypes["PointOfSaleApplicationDeviceUpdateVenueEntityRelationInput"] | undefined,
	identificationCode?: GraphQLTypes["PointOfSaleApplicationDeviceUpdateIdentificationCodeEntityRelationInput"] | undefined,
	terminal?: GraphQLTypes["PointOfSaleApplicationDeviceUpdateTerminalEntityRelationInput"] | undefined,
	receiptPrinter?: GraphQLTypes["PointOfSaleApplicationDeviceUpdateReceiptPrinterEntityRelationInput"] | undefined,
	ticketPrinters?: Array<GraphQLTypes["PointOfSaleApplicationDeviceUpdateTicketPrintersEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["DeviceIdentifierUpsertDeviceRelationInput"]: {
		update?: GraphQLTypes["PointOfSaleApplicationDeviceWithoutIdentifierUpdateInput"] | undefined,
	create?: GraphQLTypes["PointOfSaleApplicationDeviceWithoutIdentifierCreateInput"] | undefined
};
	["DeviceIdentifierMetadataConnection"]: {
	__typename: "DeviceIdentifierMetadataConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DeviceIdentifierMetadataEdge"]>
};
	["DeviceIdentifierMetadataEdge"]: {
	__typename: "DeviceIdentifierMetadataEdge",
	node: GraphQLTypes["DeviceIdentifierMetadata"]
};
	["PointOfSalePrinterCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	internalName?: string | undefined,
	note?: string | undefined,
	ipAddress?: string | undefined,
	applicationDevicesReceipt?: Array<GraphQLTypes["PointOfSalePrinterCreateApplicationDevicesReceiptEntityRelationInput"]> | undefined,
	applicationDevicesTicket?: Array<GraphQLTypes["PointOfSalePrinterCreateApplicationDevicesTicketEntityRelationInput"]> | undefined,
	venue?: GraphQLTypes["PointOfSalePrinterCreateVenueEntityRelationInput"] | undefined,
	ticketCategories?: Array<GraphQLTypes["PointOfSalePrinterCreateTicketCategoriesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["PointOfSalePrinterUpdateInput"]: {
		internalName?: string | undefined,
	note?: string | undefined,
	ipAddress?: string | undefined,
	applicationDevicesReceipt?: Array<GraphQLTypes["PointOfSalePrinterUpdateApplicationDevicesReceiptEntityRelationInput"]> | undefined,
	applicationDevicesTicket?: Array<GraphQLTypes["PointOfSalePrinterUpdateApplicationDevicesTicketEntityRelationInput"]> | undefined,
	venue?: GraphQLTypes["PointOfSalePrinterUpdateVenueEntityRelationInput"] | undefined,
	ticketCategories?: Array<GraphQLTypes["PointOfSalePrinterUpdateTicketCategoriesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["GratuityConnection"]: {
	__typename: "GratuityConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GratuityEdge"]>
};
	["GratuityEdge"]: {
	__typename: "GratuityEdge",
	node: GraphQLTypes["Gratuity"]
};
	["GratuityCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	amountCents?: number | undefined,
	order?: GraphQLTypes["GratuityCreateOrderEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GratuityCreateOrderEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	create?: GraphQLTypes["OrderWithoutGratuityCreateInput"] | undefined
};
	["OrderWithoutGratuityCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	state?: GraphQLTypes["OrderState"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	canceledAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	customer?: GraphQLTypes["OrderCreateCustomerEntityRelationInput"] | undefined,
	channel?: GraphQLTypes["OrderCreateChannelEntityRelationInput"] | undefined,
	discounts?: Array<GraphQLTypes["OrderCreateDiscountsEntityRelationInput"]> | undefined,
	delivery?: GraphQLTypes["OrderCreateDeliveryEntityRelationInput"] | undefined,
	items?: Array<GraphQLTypes["OrderCreateItemsEntityRelationInput"]> | undefined,
	internalNote?: string | undefined,
	cart?: GraphQLTypes["OrderCreateCartEntityRelationInput"] | undefined,
	events?: Array<GraphQLTypes["OrderCreateEventsEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddress?: GraphQLTypes["OrderCreateBillingAddressEntityRelationInput"] | undefined,
	priceLines?: Array<GraphQLTypes["OrderCreatePriceLinesEntityRelationInput"]> | undefined,
	payments?: Array<GraphQLTypes["OrderCreatePaymentsEntityRelationInput"]> | undefined,
	seq?: number | undefined,
	billingSubject?: GraphQLTypes["OrderCreateBillingSubjectEntityRelationInput"] | undefined,
	summary?: GraphQLTypes["OrderCreateSummaryEntityRelationInput"] | undefined,
	doubleshotLegacyId?: string | undefined,
	venue?: GraphQLTypes["OrderCreateVenueEntityRelationInput"] | undefined,
	fulfillmentNote?: string | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["OrderCreateFulfillmentNotesEntityRelationInput"]> | undefined,
	doubleshotTotalWeightGrams?: number | undefined,
	doubleShotLegacyNumber?: string | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	doubleshotAdminUrl?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GratuityUpdateInput"]: {
		amountCents?: number | undefined,
	order?: GraphQLTypes["GratuityUpdateOrderEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GratuityUpdateOrderEntityRelationInput"]: {
		create?: GraphQLTypes["OrderWithoutGratuityCreateInput"] | undefined,
	update?: GraphQLTypes["OrderWithoutGratuityUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GratuityUpsertOrderRelationInput"] | undefined,
	connect?: GraphQLTypes["OrderUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["OrderWithoutGratuityUpdateInput"]: {
		state?: GraphQLTypes["OrderState"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	canceledAt?: GraphQLTypes["DateTime"] | undefined,
	note?: string | undefined,
	customer?: GraphQLTypes["OrderUpdateCustomerEntityRelationInput"] | undefined,
	channel?: GraphQLTypes["OrderUpdateChannelEntityRelationInput"] | undefined,
	discounts?: Array<GraphQLTypes["OrderUpdateDiscountsEntityRelationInput"]> | undefined,
	delivery?: GraphQLTypes["OrderUpdateDeliveryEntityRelationInput"] | undefined,
	items?: Array<GraphQLTypes["OrderUpdateItemsEntityRelationInput"]> | undefined,
	internalNote?: string | undefined,
	cart?: GraphQLTypes["OrderUpdateCartEntityRelationInput"] | undefined,
	events?: Array<GraphQLTypes["OrderUpdateEventsEntityRelationInput"]> | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	billingAddress?: GraphQLTypes["OrderUpdateBillingAddressEntityRelationInput"] | undefined,
	priceLines?: Array<GraphQLTypes["OrderUpdatePriceLinesEntityRelationInput"]> | undefined,
	payments?: Array<GraphQLTypes["OrderUpdatePaymentsEntityRelationInput"]> | undefined,
	seq?: number | undefined,
	billingSubject?: GraphQLTypes["OrderUpdateBillingSubjectEntityRelationInput"] | undefined,
	summary?: GraphQLTypes["OrderUpdateSummaryEntityRelationInput"] | undefined,
	doubleshotLegacyId?: string | undefined,
	venue?: GraphQLTypes["OrderUpdateVenueEntityRelationInput"] | undefined,
	fulfillmentNote?: string | undefined,
	fulfillmentNotes?: Array<GraphQLTypes["OrderUpdateFulfillmentNotesEntityRelationInput"]> | undefined,
	doubleshotTotalWeightGrams?: number | undefined,
	doubleShotLegacyNumber?: string | undefined,
	doubleshotLastUpdatedAt?: GraphQLTypes["DateTime"] | undefined,
	doubleshotAdminUrl?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GratuityUpsertOrderRelationInput"]: {
		update?: GraphQLTypes["OrderWithoutGratuityUpdateInput"] | undefined,
	create?: GraphQLTypes["OrderWithoutGratuityCreateInput"] | undefined
};
	["FulfillmentNoteCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	note?: string | undefined,
	products?: Array<GraphQLTypes["FulfillmentNoteCreateProductsEntityRelationInput"]> | undefined,
	tags?: Array<GraphQLTypes["FulfillmentNoteCreateTagsEntityRelationInput"]> | undefined,
	venues?: Array<GraphQLTypes["FulfillmentNoteCreateVenuesEntityRelationInput"]> | undefined,
	cartItems?: Array<GraphQLTypes["FulfillmentNoteCreateCartItemsEntityRelationInput"]> | undefined,
	orderItems?: Array<GraphQLTypes["FulfillmentNoteCreateOrderItemsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["FulfillmentNoteCreateOrdersEntityRelationInput"]> | undefined,
	highlight?: boolean | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	emoji?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["FulfillmentNoteUpdateInput"]: {
		note?: string | undefined,
	products?: Array<GraphQLTypes["FulfillmentNoteUpdateProductsEntityRelationInput"]> | undefined,
	tags?: Array<GraphQLTypes["FulfillmentNoteUpdateTagsEntityRelationInput"]> | undefined,
	venues?: Array<GraphQLTypes["FulfillmentNoteUpdateVenuesEntityRelationInput"]> | undefined,
	cartItems?: Array<GraphQLTypes["FulfillmentNoteUpdateCartItemsEntityRelationInput"]> | undefined,
	orderItems?: Array<GraphQLTypes["FulfillmentNoteUpdateOrderItemsEntityRelationInput"]> | undefined,
	orders?: Array<GraphQLTypes["FulfillmentNoteUpdateOrdersEntityRelationInput"]> | undefined,
	highlight?: boolean | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	emoji?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["CustomerMetadataConnection"]: {
	__typename: "CustomerMetadataConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CustomerMetadataEdge"]>
};
	["CustomerMetadataEdge"]: {
	__typename: "CustomerMetadataEdge",
	node: GraphQLTypes["CustomerMetadata"]
};
	["LeadFormCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	code?: string | undefined,
	stage?: GraphQLTypes["LeadFormCreateStageEntityRelationInput"] | undefined,
	leads?: Array<GraphQLTypes["LeadFormCreateLeadsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LeadFormUpdateInput"]: {
		code?: string | undefined,
	stage?: GraphQLTypes["LeadFormUpdateStageEntityRelationInput"] | undefined,
	leads?: Array<GraphQLTypes["LeadFormUpdateLeadsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["SubscriptionBoxConnection"]: {
	__typename: "SubscriptionBoxConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SubscriptionBoxEdge"]>
};
	["SubscriptionBoxEdge"]: {
	__typename: "SubscriptionBoxEdge",
	node: GraphQLTypes["SubscriptionBox"]
};
	["SubscriptionBoxCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	locales?: Array<GraphQLTypes["SubscriptionBoxCreateLocalesEntityRelationInput"]> | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SubscriptionBoxCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["SubscriptionBoxLocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["SubscriptionBoxLocaleWithoutRootCreateInput"] | undefined,
	alias?: string | undefined
};
	["SubscriptionBoxLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	stickerText?: string | undefined,
	descriptionText?: string | undefined,
	locale?: GraphQLTypes["SubscriptionBoxLocaleCreateLocaleEntityRelationInput"] | undefined,
	secondaryTitle?: string | undefined,
	texts?: GraphQLTypes["SubscriptionBoxLocaleCreateTextsEntityRelationInput"] | undefined,
	secondaryTexts?: GraphQLTypes["SubscriptionBoxLocaleCreateSecondaryTextsEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SubscriptionBoxLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	create?: GraphQLTypes["LocaleWithoutSubscriptionBoxesCreateInput"] | undefined
};
	["LocaleWithoutSubscriptionBoxesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	businessCategories?: Array<GraphQLTypes["LocaleCreateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleCreateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleCreateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleCreateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleCreateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleCreateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleCreateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleCreateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleCreateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleCreateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleCreateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleCreateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleCreateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleCreatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleCreateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleCreateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleCreateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleCreatePipelineStagesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleCreateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["SubscriptionBoxUpdateInput"]: {
		locales?: Array<GraphQLTypes["SubscriptionBoxUpdateLocalesEntityRelationInput"]> | undefined,
	unique?: GraphQLTypes["One"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SubscriptionBoxUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["SubscriptionBoxLocaleWithoutRootCreateInput"] | undefined,
	update?: GraphQLTypes["SubscriptionBoxUpdateLocalesRelationInput"] | undefined,
	upsert?: GraphQLTypes["SubscriptionBoxUpsertLocalesRelationInput"] | undefined,
	connect?: GraphQLTypes["SubscriptionBoxLocaleUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["SubscriptionBoxLocaleUniqueWhere"] | undefined,
	delete?: GraphQLTypes["SubscriptionBoxLocaleUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["SubscriptionBoxUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["SubscriptionBoxLocaleUniqueWhere"] | undefined,
	data?: GraphQLTypes["SubscriptionBoxLocaleWithoutRootUpdateInput"] | undefined
};
	["SubscriptionBoxLocaleWithoutRootUpdateInput"]: {
		title?: string | undefined,
	stickerText?: string | undefined,
	descriptionText?: string | undefined,
	locale?: GraphQLTypes["SubscriptionBoxLocaleUpdateLocaleEntityRelationInput"] | undefined,
	secondaryTitle?: string | undefined,
	texts?: GraphQLTypes["SubscriptionBoxLocaleUpdateTextsEntityRelationInput"] | undefined,
	secondaryTexts?: GraphQLTypes["SubscriptionBoxLocaleUpdateSecondaryTextsEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SubscriptionBoxLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutSubscriptionBoxesCreateInput"] | undefined,
	update?: GraphQLTypes["LocaleWithoutSubscriptionBoxesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["SubscriptionBoxLocaleUpsertLocaleRelationInput"] | undefined,
	connect?: GraphQLTypes["LocaleUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["LocaleWithoutSubscriptionBoxesUpdateInput"]: {
		businessCategories?: Array<GraphQLTypes["LocaleUpdateBusinessCategoriesEntityRelationInput"]> | undefined,
	productCategoryLists?: Array<GraphQLTypes["LocaleUpdateProductCategoryListsEntityRelationInput"]> | undefined,
	productIngredients?: Array<GraphQLTypes["LocaleUpdateProductIngredientsEntityRelationInput"]> | undefined,
	orderRecurrences?: Array<GraphQLTypes["LocaleUpdateOrderRecurrencesEntityRelationInput"]> | undefined,
	blogs?: Array<GraphQLTypes["LocaleUpdateBlogsEntityRelationInput"]> | undefined,
	blogPosts?: Array<GraphQLTypes["LocaleUpdateBlogPostsEntityRelationInput"]> | undefined,
	identifier?: GraphQLTypes["LocaleUpdateIdentifierEntityRelationInput"] | undefined,
	menus?: Array<GraphQLTypes["LocaleUpdateMenusEntityRelationInput"]> | undefined,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]> | undefined,
	productIngredientCategories?: Array<GraphQLTypes["LocaleUpdateProductIngredientCategoriesEntityRelationInput"]> | undefined,
	allergens?: Array<GraphQLTypes["LocaleUpdateAllergensEntityRelationInput"]> | undefined,
	productPackings?: Array<GraphQLTypes["LocaleUpdateProductPackingsEntityRelationInput"]> | undefined,
	products?: Array<GraphQLTypes["LocaleUpdateProductsEntityRelationInput"]> | undefined,
	productRecipes?: Array<GraphQLTypes["LocaleUpdateProductRecipesEntityRelationInput"]> | undefined,
	pointOfSaleCategories?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoriesEntityRelationInput"]> | undefined,
	pointOfSaleCategoryProducts?: Array<GraphQLTypes["LocaleUpdatePointOfSaleCategoryProductsEntityRelationInput"]> | undefined,
	deliveryMethods?: Array<GraphQLTypes["LocaleUpdateDeliveryMethodsEntityRelationInput"]> | undefined,
	ingredientSuppliers?: Array<GraphQLTypes["LocaleUpdateIngredientSuppliersEntityRelationInput"]> | undefined,
	identificationCodes?: Array<GraphQLTypes["LocaleUpdateIdentificationCodesEntityRelationInput"]> | undefined,
	pipelineStages?: Array<GraphQLTypes["LocaleUpdatePipelineStagesEntityRelationInput"]> | undefined,
	businessServices?: Array<GraphQLTypes["LocaleUpdateBusinessServicesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["SubscriptionBoxLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutSubscriptionBoxesUpdateInput"] | undefined,
	create?: GraphQLTypes["LocaleWithoutSubscriptionBoxesCreateInput"] | undefined
};
	["SubscriptionBoxUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["SubscriptionBoxLocaleUniqueWhere"] | undefined,
	update?: GraphQLTypes["SubscriptionBoxLocaleWithoutRootUpdateInput"] | undefined,
	create?: GraphQLTypes["SubscriptionBoxLocaleWithoutRootCreateInput"] | undefined
};
	["SubscriptionBoxLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	title?: string | undefined,
	stickerText?: string | undefined,
	descriptionText?: string | undefined,
	root?: GraphQLTypes["SubscriptionBoxLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["SubscriptionBoxLocaleCreateLocaleEntityRelationInput"] | undefined,
	secondaryTitle?: string | undefined,
	texts?: GraphQLTypes["SubscriptionBoxLocaleCreateTextsEntityRelationInput"] | undefined,
	secondaryTexts?: GraphQLTypes["SubscriptionBoxLocaleCreateSecondaryTextsEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SubscriptionBoxLocaleUpdateInput"]: {
		title?: string | undefined,
	stickerText?: string | undefined,
	descriptionText?: string | undefined,
	root?: GraphQLTypes["SubscriptionBoxLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["SubscriptionBoxLocaleUpdateLocaleEntityRelationInput"] | undefined,
	secondaryTitle?: string | undefined,
	texts?: GraphQLTypes["SubscriptionBoxLocaleUpdateTextsEntityRelationInput"] | undefined,
	secondaryTexts?: GraphQLTypes["SubscriptionBoxLocaleUpdateSecondaryTextsEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TimetableDayMetadataConnection"]: {
	__typename: "TimetableDayMetadataConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TimetableDayMetadataEdge"]>
};
	["TimetableDayMetadataEdge"]: {
	__typename: "TimetableDayMetadataEdge",
	node: GraphQLTypes["TimetableDayMetadata"]
};
	["BusinessServiceConnection"]: {
	__typename: "BusinessServiceConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BusinessServiceEdge"]>
};
	["BusinessServiceEdge"]: {
	__typename: "BusinessServiceEdge",
	node: GraphQLTypes["BusinessService"]
};
	["BusinessServiceEventCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	createdAt?: GraphQLTypes["DateTime"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	businessCustomer?: GraphQLTypes["BusinessServiceEventCreateBusinessCustomerEntityRelationInput"] | undefined,
	businessService?: GraphQLTypes["BusinessServiceEventCreateBusinessServiceEntityRelationInput"] | undefined,
	filledNumberOfPeople?: number | undefined,
	filledInvoiced?: boolean | undefined,
	filledEquipment?: string | undefined,
	filledMillTamDem?: boolean | undefined,
	filledSOEspresso?: boolean | undefined,
	filledFilterCoffeeInMenu?: boolean | undefined,
	filledWaterMeterStatus?: string | undefined,
	filledServiceAction?: string | undefined,
	filledInvoiceIdentifier?: string | undefined,
	filledNote?: string | undefined,
	filledContact?: string | undefined,
	filledPhone?: boolean | undefined,
	filledEmail?: boolean | undefined,
	filledGrindingStonesCondition?: string | undefined,
	createdBy?: GraphQLTypes["BusinessServiceEventCreateCreatedByEntityRelationInput"] | undefined,
	filledSupervisor?: GraphQLTypes["BusinessServiceEventCreateFilledSupervisorEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessServiceEventCreateBusinessCustomerEntityRelationInput"]: {
		connect?: GraphQLTypes["BusinessCustomerUniqueWhere"] | undefined,
	create?: GraphQLTypes["BusinessCustomerWithoutBusinessServiceEventsCreateInput"] | undefined
};
	["BusinessCustomerWithoutBusinessServiceEventsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	customer?: GraphQLTypes["BusinessCustomerCreateCustomerEntityRelationInput"] | undefined,
	owners?: Array<GraphQLTypes["BusinessCustomerCreateOwnersEntityRelationInput"]> | undefined,
	members?: Array<GraphQLTypes["BusinessCustomerCreateMembersEntityRelationInput"]> | undefined,
	category?: GraphQLTypes["BusinessCustomerCreateCategoryEntityRelationInput"] | undefined,
	accountManager?: GraphQLTypes["BusinessCustomerCreateAccountManagerEntityRelationInput"] | undefined,
	logo?: GraphQLTypes["BusinessCustomerCreateLogoEntityRelationInput"] | undefined,
	note?: string | undefined,
	doubleshotCoffeeEquipment?: GraphQLTypes["BusinessCustomerCreateDoubleshotCoffeeEquipmentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessServiceEventUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"] | undefined,
	fulfilledAt?: GraphQLTypes["DateTime"] | undefined,
	businessCustomer?: GraphQLTypes["BusinessServiceEventUpdateBusinessCustomerEntityRelationInput"] | undefined,
	businessService?: GraphQLTypes["BusinessServiceEventUpdateBusinessServiceEntityRelationInput"] | undefined,
	filledNumberOfPeople?: number | undefined,
	filledInvoiced?: boolean | undefined,
	filledEquipment?: string | undefined,
	filledMillTamDem?: boolean | undefined,
	filledSOEspresso?: boolean | undefined,
	filledFilterCoffeeInMenu?: boolean | undefined,
	filledWaterMeterStatus?: string | undefined,
	filledServiceAction?: string | undefined,
	filledInvoiceIdentifier?: string | undefined,
	filledNote?: string | undefined,
	filledContact?: string | undefined,
	filledPhone?: boolean | undefined,
	filledEmail?: boolean | undefined,
	filledGrindingStonesCondition?: string | undefined,
	createdBy?: GraphQLTypes["BusinessServiceEventUpdateCreatedByEntityRelationInput"] | undefined,
	filledSupervisor?: GraphQLTypes["BusinessServiceEventUpdateFilledSupervisorEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessServiceEventUpdateBusinessCustomerEntityRelationInput"]: {
		create?: GraphQLTypes["BusinessCustomerWithoutBusinessServiceEventsCreateInput"] | undefined,
	update?: GraphQLTypes["BusinessCustomerWithoutBusinessServiceEventsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["BusinessServiceEventUpsertBusinessCustomerRelationInput"] | undefined,
	connect?: GraphQLTypes["BusinessCustomerUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["BusinessCustomerWithoutBusinessServiceEventsUpdateInput"]: {
		name?: string | undefined,
	customer?: GraphQLTypes["BusinessCustomerUpdateCustomerEntityRelationInput"] | undefined,
	owners?: Array<GraphQLTypes["BusinessCustomerUpdateOwnersEntityRelationInput"]> | undefined,
	members?: Array<GraphQLTypes["BusinessCustomerUpdateMembersEntityRelationInput"]> | undefined,
	category?: GraphQLTypes["BusinessCustomerUpdateCategoryEntityRelationInput"] | undefined,
	accountManager?: GraphQLTypes["BusinessCustomerUpdateAccountManagerEntityRelationInput"] | undefined,
	logo?: GraphQLTypes["BusinessCustomerUpdateLogoEntityRelationInput"] | undefined,
	note?: string | undefined,
	doubleshotCoffeeEquipment?: GraphQLTypes["BusinessCustomerUpdateDoubleshotCoffeeEquipmentEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessServiceEventUpsertBusinessCustomerRelationInput"]: {
		update?: GraphQLTypes["BusinessCustomerWithoutBusinessServiceEventsUpdateInput"] | undefined,
	create?: GraphQLTypes["BusinessCustomerWithoutBusinessServiceEventsCreateInput"] | undefined
};
	["BusinessServiceLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	labelNote?: string | undefined,
	root?: GraphQLTypes["BusinessServiceLocaleCreateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["BusinessServiceLocaleCreateLocaleEntityRelationInput"] | undefined,
	labelNumberOfPeople?: string | undefined,
	labelInvoiced?: string | undefined,
	labelEquipment?: string | undefined,
	labelMillTamDem?: string | undefined,
	labelSOEspresso?: string | undefined,
	labelFilterCoffeeInMenu?: string | undefined,
	labelWaterMeterStatus?: string | undefined,
	labelServiceAction?: string | undefined,
	labelInvoiceIdentifier?: string | undefined,
	labelSupervisor?: string | undefined,
	labelContact?: string | undefined,
	labelPhone?: string | undefined,
	labelEmail?: string | undefined,
	labelGrindingStonesCondition?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["BusinessServiceLocaleUpdateInput"]: {
		name?: string | undefined,
	labelNote?: string | undefined,
	root?: GraphQLTypes["BusinessServiceLocaleUpdateRootEntityRelationInput"] | undefined,
	locale?: GraphQLTypes["BusinessServiceLocaleUpdateLocaleEntityRelationInput"] | undefined,
	labelNumberOfPeople?: string | undefined,
	labelInvoiced?: string | undefined,
	labelEquipment?: string | undefined,
	labelMillTamDem?: string | undefined,
	labelSOEspresso?: string | undefined,
	labelFilterCoffeeInMenu?: string | undefined,
	labelWaterMeterStatus?: string | undefined,
	labelServiceAction?: string | undefined,
	labelInvoiceIdentifier?: string | undefined,
	labelSupervisor?: string | undefined,
	labelContact?: string | undefined,
	labelPhone?: string | undefined,
	labelEmail?: string | undefined,
	labelGrindingStonesCondition?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["GridTileItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	text?: string | undefined,
	list?: GraphQLTypes["GridTileItemCreateListEntityRelationInput"] | undefined,
	medium?: GraphQLTypes["GridTileItemCreateMediumEntityRelationInput"] | undefined,
	link?: GraphQLTypes["GridTileItemCreateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GridTileItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["GridTilesUniqueWhere"] | undefined,
	create?: GraphQLTypes["GridTilesWithoutItemsCreateInput"] | undefined
};
	["GridTilesWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GridTileItemUpdateInput"]: {
		order?: number | undefined,
	text?: string | undefined,
	list?: GraphQLTypes["GridTileItemUpdateListEntityRelationInput"] | undefined,
	medium?: GraphQLTypes["GridTileItemUpdateMediumEntityRelationInput"] | undefined,
	link?: GraphQLTypes["GridTileItemUpdateLinkEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["GridTileItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["GridTilesWithoutItemsCreateInput"] | undefined,
	update?: GraphQLTypes["GridTilesWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["GridTileItemUpsertListRelationInput"] | undefined,
	connect?: GraphQLTypes["GridTilesUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["GridTilesWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean | undefined
};
	["GridTileItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["GridTilesWithoutItemsUpdateInput"] | undefined,
	create?: GraphQLTypes["GridTilesWithoutItemsCreateInput"] | undefined
};
	["GridTilesConnection"]: {
	__typename: "GridTilesConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GridTilesEdge"]>
};
	["GridTilesEdge"]: {
	__typename: "GridTilesEdge",
	node: GraphQLTypes["GridTiles"]
};
	["AreaCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	name?: string | undefined,
	venue?: GraphQLTypes["AreaCreateVenueEntityRelationInput"] | undefined,
	tables?: Array<GraphQLTypes["AreaCreateTablesEntityRelationInput"]> | undefined,
	lines?: Array<GraphQLTypes["AreaCreateLinesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["AreaUpdateInput"]: {
		order?: number | undefined,
	name?: string | undefined,
	venue?: GraphQLTypes["AreaUpdateVenueEntityRelationInput"] | undefined,
	tables?: Array<GraphQLTypes["AreaUpdateTablesEntityRelationInput"]> | undefined,
	lines?: Array<GraphQLTypes["AreaUpdateLinesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["Position"]: {
	__typename: "Position",
	_meta?: GraphQLTypes["PositionMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	x: number,
	y: number
};
	["PositionMeta"]: {
	__typename: "PositionMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	x?: GraphQLTypes["FieldMeta"] | undefined,
	y?: GraphQLTypes["FieldMeta"] | undefined
};
	["PositionUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["PositionWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	x?: GraphQLTypes["IntCondition"] | undefined,
	y?: GraphQLTypes["IntCondition"] | undefined,
	and?: Array<GraphQLTypes["PositionWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["PositionWhere"] | undefined> | undefined,
	not?: GraphQLTypes["PositionWhere"] | undefined
};
	["PositionOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	x?: GraphQLTypes["OrderDirection"] | undefined,
	y?: GraphQLTypes["OrderDirection"] | undefined
};
	["PositionConnection"]: {
	__typename: "PositionConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PositionEdge"]>
};
	["PositionEdge"]: {
	__typename: "PositionEdge",
	node: GraphQLTypes["Position"]
};
	["PositionCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	x?: number | undefined,
	y?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["PositionUpdateInput"]: {
		x?: number | undefined,
	y?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["StatsEnabledWidgetType"]: {
	__typename: "StatsEnabledWidgetType",
	_meta?: GraphQLTypes["StatsEnabledWidgetTypeMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["StatsEnabledWidgetTypeType"],
	layout?: GraphQLTypes["StatsWidgetsLayout"] | undefined
};
	["StatsEnabledWidgetTypeMeta"]: {
	__typename: "StatsEnabledWidgetTypeMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	layout?: GraphQLTypes["FieldMeta"] | undefined
};
	["StatsEnabledWidgetTypeType"]: StatsEnabledWidgetTypeType;
	["StatsWidgetsLayout"]: {
	__typename: "StatsWidgetsLayout",
	_meta?: GraphQLTypes["StatsWidgetsLayoutMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	enabledWidgetTypes: Array<GraphQLTypes["StatsEnabledWidgetType"]>,
	items: Array<GraphQLTypes["StatsWidget"]>,
	enabledWidgetTypesByType?: GraphQLTypes["StatsEnabledWidgetType"] | undefined,
	paginateEnabledWidgetTypes: GraphQLTypes["StatsEnabledWidgetTypeConnection"],
	paginateItems: GraphQLTypes["StatsWidgetConnection"]
};
	["StatsWidgetsLayoutMeta"]: {
	__typename: "StatsWidgetsLayoutMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	enabledWidgetTypes?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined
};
	["StatsEnabledWidgetTypeWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	type?: GraphQLTypes["StatsEnabledWidgetTypeTypeCondition"] | undefined,
	layout?: GraphQLTypes["StatsWidgetsLayoutWhere"] | undefined,
	and?: Array<GraphQLTypes["StatsEnabledWidgetTypeWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["StatsEnabledWidgetTypeWhere"] | undefined> | undefined,
	not?: GraphQLTypes["StatsEnabledWidgetTypeWhere"] | undefined
};
	["StatsEnabledWidgetTypeTypeCondition"]: {
		and?: Array<GraphQLTypes["StatsEnabledWidgetTypeTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["StatsEnabledWidgetTypeTypeCondition"]> | undefined,
	not?: GraphQLTypes["StatsEnabledWidgetTypeTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["StatsEnabledWidgetTypeType"] | undefined,
	notEq?: GraphQLTypes["StatsEnabledWidgetTypeType"] | undefined,
	in?: Array<GraphQLTypes["StatsEnabledWidgetTypeType"]> | undefined,
	notIn?: Array<GraphQLTypes["StatsEnabledWidgetTypeType"]> | undefined,
	lt?: GraphQLTypes["StatsEnabledWidgetTypeType"] | undefined,
	lte?: GraphQLTypes["StatsEnabledWidgetTypeType"] | undefined,
	gt?: GraphQLTypes["StatsEnabledWidgetTypeType"] | undefined,
	gte?: GraphQLTypes["StatsEnabledWidgetTypeType"] | undefined
};
	["StatsWidgetsLayoutWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	enabledWidgetTypes?: GraphQLTypes["StatsEnabledWidgetTypeWhere"] | undefined,
	items?: GraphQLTypes["StatsWidgetWhere"] | undefined,
	and?: Array<GraphQLTypes["StatsWidgetsLayoutWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["StatsWidgetsLayoutWhere"] | undefined> | undefined,
	not?: GraphQLTypes["StatsWidgetsLayoutWhere"] | undefined
};
	["StatsWidgetWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	size?: GraphQLTypes["IntCondition"] | undefined,
	type?: GraphQLTypes["StatsEnabledWidgetTypeTypeCondition"] | undefined,
	link?: GraphQLTypes["StringCondition"] | undefined,
	title?: GraphQLTypes["StringCondition"] | undefined,
	timeFrame?: GraphQLTypes["StatsWidgetTimeFrameCondition"] | undefined,
	layout?: GraphQLTypes["StatsWidgetsLayoutWhere"] | undefined,
	icon?: GraphQLTypes["ImageWhere"] | undefined,
	channels?: GraphQLTypes["ChannelWhere"] | undefined,
	productCategory?: GraphQLTypes["ProductCategoryWhere"] | undefined,
	paymentMethods?: GraphQLTypes["PaymentMethodWhere"] | undefined,
	hoursFrom?: GraphQLTypes["StringCondition"] | undefined,
	hoursTo?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["StatsWidgetWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["StatsWidgetWhere"] | undefined> | undefined,
	not?: GraphQLTypes["StatsWidgetWhere"] | undefined
};
	["StatsWidgetTimeFrameCondition"]: {
		and?: Array<GraphQLTypes["StatsWidgetTimeFrameCondition"]> | undefined,
	or?: Array<GraphQLTypes["StatsWidgetTimeFrameCondition"]> | undefined,
	not?: GraphQLTypes["StatsWidgetTimeFrameCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["StatsWidgetTimeFrame"] | undefined,
	notEq?: GraphQLTypes["StatsWidgetTimeFrame"] | undefined,
	in?: Array<GraphQLTypes["StatsWidgetTimeFrame"]> | undefined,
	notIn?: Array<GraphQLTypes["StatsWidgetTimeFrame"]> | undefined,
	lt?: GraphQLTypes["StatsWidgetTimeFrame"] | undefined,
	lte?: GraphQLTypes["StatsWidgetTimeFrame"] | undefined,
	gt?: GraphQLTypes["StatsWidgetTimeFrame"] | undefined,
	gte?: GraphQLTypes["StatsWidgetTimeFrame"] | undefined
};
	["StatsWidgetTimeFrame"]: StatsWidgetTimeFrame;
	["StatsEnabledWidgetTypeOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	layout?: GraphQLTypes["StatsWidgetsLayoutOrderBy"] | undefined
};
	["StatsWidgetsLayoutOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined
};
	["StatsWidget"]: {
	__typename: "StatsWidget",
	_meta?: GraphQLTypes["StatsWidgetMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	order: number,
	size: number,
	type: GraphQLTypes["StatsEnabledWidgetTypeType"],
	link?: string | undefined,
	title?: string | undefined,
	timeFrame: GraphQLTypes["StatsWidgetTimeFrame"],
	layout?: GraphQLTypes["StatsWidgetsLayout"] | undefined,
	icon?: GraphQLTypes["Image"] | undefined,
	channels: Array<GraphQLTypes["Channel"]>,
	productCategory?: GraphQLTypes["ProductCategory"] | undefined,
	paymentMethods: Array<GraphQLTypes["PaymentMethod"]>,
	hoursFrom?: string | undefined,
	hoursTo?: string | undefined,
	paginateChannels: GraphQLTypes["ChannelConnection"],
	paginatePaymentMethods: GraphQLTypes["PaymentMethodConnection"]
};
	["StatsWidgetMeta"]: {
	__typename: "StatsWidgetMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined,
	size?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	link?: GraphQLTypes["FieldMeta"] | undefined,
	title?: GraphQLTypes["FieldMeta"] | undefined,
	timeFrame?: GraphQLTypes["FieldMeta"] | undefined,
	layout?: GraphQLTypes["FieldMeta"] | undefined,
	icon?: GraphQLTypes["FieldMeta"] | undefined,
	channels?: GraphQLTypes["FieldMeta"] | undefined,
	productCategory?: GraphQLTypes["FieldMeta"] | undefined,
	paymentMethods?: GraphQLTypes["FieldMeta"] | undefined,
	hoursFrom?: GraphQLTypes["FieldMeta"] | undefined,
	hoursTo?: GraphQLTypes["FieldMeta"] | undefined
};
	["StatsWidgetOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined,
	size?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	link?: GraphQLTypes["OrderDirection"] | undefined,
	title?: GraphQLTypes["OrderDirection"] | undefined,
	timeFrame?: GraphQLTypes["OrderDirection"] | undefined,
	layout?: GraphQLTypes["StatsWidgetsLayoutOrderBy"] | undefined,
	icon?: GraphQLTypes["ImageOrderBy"] | undefined,
	productCategory?: GraphQLTypes["ProductCategoryOrderBy"] | undefined,
	hoursFrom?: GraphQLTypes["OrderDirection"] | undefined,
	hoursTo?: GraphQLTypes["OrderDirection"] | undefined
};
	["StatsWidgetsLayoutEnabledWidgetTypesByTypeUniqueWhere"]: {
		type?: GraphQLTypes["StatsEnabledWidgetTypeType"] | undefined
};
	["StatsEnabledWidgetTypeConnection"]: {
	__typename: "StatsEnabledWidgetTypeConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["StatsEnabledWidgetTypeEdge"]>
};
	["StatsEnabledWidgetTypeEdge"]: {
	__typename: "StatsEnabledWidgetTypeEdge",
	node: GraphQLTypes["StatsEnabledWidgetType"]
};
	["StatsWidgetConnection"]: {
	__typename: "StatsWidgetConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["StatsWidgetEdge"]>
};
	["StatsWidgetEdge"]: {
	__typename: "StatsWidgetEdge",
	node: GraphQLTypes["StatsWidget"]
};
	["StatsEnabledWidgetTypeUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	layout?: GraphQLTypes["StatsWidgetsLayoutUniqueWhere"] | undefined,
	type?: GraphQLTypes["StatsEnabledWidgetTypeType"] | undefined
};
	["StatsWidgetsLayoutUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	enabledWidgetTypes?: GraphQLTypes["StatsEnabledWidgetTypeUniqueWhere"] | undefined,
	items?: GraphQLTypes["StatsWidgetUniqueWhere"] | undefined
};
	["StatsWidgetUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["StatsEnabledWidgetTypeCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["StatsEnabledWidgetTypeType"] | undefined,
	layout?: GraphQLTypes["StatsEnabledWidgetTypeCreateLayoutEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StatsEnabledWidgetTypeCreateLayoutEntityRelationInput"]: {
		connect?: GraphQLTypes["StatsWidgetsLayoutUniqueWhere"] | undefined,
	create?: GraphQLTypes["StatsWidgetsLayoutWithoutEnabledWidgetTypesCreateInput"] | undefined
};
	["StatsWidgetsLayoutWithoutEnabledWidgetTypesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: Array<GraphQLTypes["StatsWidgetsLayoutCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["StatsWidgetsLayoutCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["StatsWidgetUniqueWhere"] | undefined,
	create?: GraphQLTypes["StatsWidgetWithoutLayoutCreateInput"] | undefined,
	alias?: string | undefined
};
	["StatsWidgetWithoutLayoutCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	size?: number | undefined,
	type?: GraphQLTypes["StatsEnabledWidgetTypeType"] | undefined,
	link?: string | undefined,
	title?: string | undefined,
	timeFrame?: GraphQLTypes["StatsWidgetTimeFrame"] | undefined,
	icon?: GraphQLTypes["StatsWidgetCreateIconEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["StatsWidgetCreateChannelsEntityRelationInput"]> | undefined,
	productCategory?: GraphQLTypes["StatsWidgetCreateProductCategoryEntityRelationInput"] | undefined,
	paymentMethods?: Array<GraphQLTypes["StatsWidgetCreatePaymentMethodsEntityRelationInput"]> | undefined,
	hoursFrom?: string | undefined,
	hoursTo?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["StatsWidgetCreateIconEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["StatsWidgetCreateChannelsEntityRelationInput"]: {
		connect?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	create?: GraphQLTypes["ChannelCreateInput"] | undefined,
	alias?: string | undefined
};
	["StatsWidgetCreateProductCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductCategoryUniqueWhere"] | undefined,
	create?: GraphQLTypes["ProductCategoryCreateInput"] | undefined
};
	["StatsWidgetCreatePaymentMethodsEntityRelationInput"]: {
		connect?: GraphQLTypes["PaymentMethodUniqueWhere"] | undefined,
	create?: GraphQLTypes["PaymentMethodCreateInput"] | undefined,
	alias?: string | undefined
};
	["StatsEnabledWidgetTypeUpdateInput"]: {
		type?: GraphQLTypes["StatsEnabledWidgetTypeType"] | undefined,
	layout?: GraphQLTypes["StatsEnabledWidgetTypeUpdateLayoutEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StatsEnabledWidgetTypeUpdateLayoutEntityRelationInput"]: {
		create?: GraphQLTypes["StatsWidgetsLayoutWithoutEnabledWidgetTypesCreateInput"] | undefined,
	update?: GraphQLTypes["StatsWidgetsLayoutWithoutEnabledWidgetTypesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["StatsEnabledWidgetTypeUpsertLayoutRelationInput"] | undefined,
	connect?: GraphQLTypes["StatsWidgetsLayoutUniqueWhere"] | undefined
};
	["StatsWidgetsLayoutWithoutEnabledWidgetTypesUpdateInput"]: {
		items?: Array<GraphQLTypes["StatsWidgetsLayoutUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["StatsWidgetsLayoutUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["StatsWidgetWithoutLayoutCreateInput"] | undefined,
	update?: GraphQLTypes["StatsWidgetsLayoutUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["StatsWidgetsLayoutUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["StatsWidgetUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["StatsWidgetUniqueWhere"] | undefined,
	delete?: GraphQLTypes["StatsWidgetUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["StatsWidgetsLayoutUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["StatsWidgetUniqueWhere"] | undefined,
	data?: GraphQLTypes["StatsWidgetWithoutLayoutUpdateInput"] | undefined
};
	["StatsWidgetWithoutLayoutUpdateInput"]: {
		order?: number | undefined,
	size?: number | undefined,
	type?: GraphQLTypes["StatsEnabledWidgetTypeType"] | undefined,
	link?: string | undefined,
	title?: string | undefined,
	timeFrame?: GraphQLTypes["StatsWidgetTimeFrame"] | undefined,
	icon?: GraphQLTypes["StatsWidgetUpdateIconEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["StatsWidgetUpdateChannelsEntityRelationInput"]> | undefined,
	productCategory?: GraphQLTypes["StatsWidgetUpdateProductCategoryEntityRelationInput"] | undefined,
	paymentMethods?: Array<GraphQLTypes["StatsWidgetUpdatePaymentMethodsEntityRelationInput"]> | undefined,
	hoursFrom?: string | undefined,
	hoursTo?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["StatsWidgetUpdateIconEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"] | undefined,
	update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	upsert?: GraphQLTypes["StatsWidgetUpsertIconRelationInput"] | undefined,
	connect?: GraphQLTypes["ImageUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["StatsWidgetUpsertIconRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"] | undefined,
	create?: GraphQLTypes["ImageCreateInput"] | undefined
};
	["StatsWidgetUpdateChannelsEntityRelationInput"]: {
		create?: GraphQLTypes["ChannelCreateInput"] | undefined,
	update?: GraphQLTypes["StatsWidgetUpdateChannelsRelationInput"] | undefined,
	upsert?: GraphQLTypes["StatsWidgetUpsertChannelsRelationInput"] | undefined,
	connect?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["StatsWidgetUpdateChannelsRelationInput"]: {
		by?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	data?: GraphQLTypes["ChannelUpdateInput"] | undefined
};
	["StatsWidgetUpsertChannelsRelationInput"]: {
		by?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	update?: GraphQLTypes["ChannelUpdateInput"] | undefined,
	create?: GraphQLTypes["ChannelCreateInput"] | undefined
};
	["StatsWidgetUpdateProductCategoryEntityRelationInput"]: {
		create?: GraphQLTypes["ProductCategoryCreateInput"] | undefined,
	update?: GraphQLTypes["ProductCategoryUpdateInput"] | undefined,
	upsert?: GraphQLTypes["StatsWidgetUpsertProductCategoryRelationInput"] | undefined,
	connect?: GraphQLTypes["ProductCategoryUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["StatsWidgetUpsertProductCategoryRelationInput"]: {
		update?: GraphQLTypes["ProductCategoryUpdateInput"] | undefined,
	create?: GraphQLTypes["ProductCategoryCreateInput"] | undefined
};
	["StatsWidgetUpdatePaymentMethodsEntityRelationInput"]: {
		create?: GraphQLTypes["PaymentMethodCreateInput"] | undefined,
	update?: GraphQLTypes["StatsWidgetUpdatePaymentMethodsRelationInput"] | undefined,
	upsert?: GraphQLTypes["StatsWidgetUpsertPaymentMethodsRelationInput"] | undefined,
	connect?: GraphQLTypes["PaymentMethodUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["PaymentMethodUniqueWhere"] | undefined,
	delete?: GraphQLTypes["PaymentMethodUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["StatsWidgetUpdatePaymentMethodsRelationInput"]: {
		by?: GraphQLTypes["PaymentMethodUniqueWhere"] | undefined,
	data?: GraphQLTypes["PaymentMethodUpdateInput"] | undefined
};
	["StatsWidgetUpsertPaymentMethodsRelationInput"]: {
		by?: GraphQLTypes["PaymentMethodUniqueWhere"] | undefined,
	update?: GraphQLTypes["PaymentMethodUpdateInput"] | undefined,
	create?: GraphQLTypes["PaymentMethodCreateInput"] | undefined
};
	["StatsWidgetsLayoutUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["StatsWidgetUniqueWhere"] | undefined,
	update?: GraphQLTypes["StatsWidgetWithoutLayoutUpdateInput"] | undefined,
	create?: GraphQLTypes["StatsWidgetWithoutLayoutCreateInput"] | undefined
};
	["StatsEnabledWidgetTypeUpsertLayoutRelationInput"]: {
		update?: GraphQLTypes["StatsWidgetsLayoutWithoutEnabledWidgetTypesUpdateInput"] | undefined,
	create?: GraphQLTypes["StatsWidgetsLayoutWithoutEnabledWidgetTypesCreateInput"] | undefined
};
	["StatsWidgetCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	size?: number | undefined,
	type?: GraphQLTypes["StatsEnabledWidgetTypeType"] | undefined,
	link?: string | undefined,
	title?: string | undefined,
	timeFrame?: GraphQLTypes["StatsWidgetTimeFrame"] | undefined,
	layout?: GraphQLTypes["StatsWidgetCreateLayoutEntityRelationInput"] | undefined,
	icon?: GraphQLTypes["StatsWidgetCreateIconEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["StatsWidgetCreateChannelsEntityRelationInput"]> | undefined,
	productCategory?: GraphQLTypes["StatsWidgetCreateProductCategoryEntityRelationInput"] | undefined,
	paymentMethods?: Array<GraphQLTypes["StatsWidgetCreatePaymentMethodsEntityRelationInput"]> | undefined,
	hoursFrom?: string | undefined,
	hoursTo?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["StatsWidgetCreateLayoutEntityRelationInput"]: {
		connect?: GraphQLTypes["StatsWidgetsLayoutUniqueWhere"] | undefined,
	create?: GraphQLTypes["StatsWidgetsLayoutWithoutItemsCreateInput"] | undefined
};
	["StatsWidgetsLayoutWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	enabledWidgetTypes?: Array<GraphQLTypes["StatsWidgetsLayoutCreateEnabledWidgetTypesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["StatsWidgetsLayoutCreateEnabledWidgetTypesEntityRelationInput"]: {
		connect?: GraphQLTypes["StatsEnabledWidgetTypeUniqueWhere"] | undefined,
	create?: GraphQLTypes["StatsEnabledWidgetTypeWithoutLayoutCreateInput"] | undefined,
	alias?: string | undefined
};
	["StatsEnabledWidgetTypeWithoutLayoutCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["StatsEnabledWidgetTypeType"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StatsWidgetUpdateInput"]: {
		order?: number | undefined,
	size?: number | undefined,
	type?: GraphQLTypes["StatsEnabledWidgetTypeType"] | undefined,
	link?: string | undefined,
	title?: string | undefined,
	timeFrame?: GraphQLTypes["StatsWidgetTimeFrame"] | undefined,
	layout?: GraphQLTypes["StatsWidgetUpdateLayoutEntityRelationInput"] | undefined,
	icon?: GraphQLTypes["StatsWidgetUpdateIconEntityRelationInput"] | undefined,
	channels?: Array<GraphQLTypes["StatsWidgetUpdateChannelsEntityRelationInput"]> | undefined,
	productCategory?: GraphQLTypes["StatsWidgetUpdateProductCategoryEntityRelationInput"] | undefined,
	paymentMethods?: Array<GraphQLTypes["StatsWidgetUpdatePaymentMethodsEntityRelationInput"]> | undefined,
	hoursFrom?: string | undefined,
	hoursTo?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["StatsWidgetUpdateLayoutEntityRelationInput"]: {
		create?: GraphQLTypes["StatsWidgetsLayoutWithoutItemsCreateInput"] | undefined,
	update?: GraphQLTypes["StatsWidgetsLayoutWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["StatsWidgetUpsertLayoutRelationInput"] | undefined,
	connect?: GraphQLTypes["StatsWidgetsLayoutUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["StatsWidgetsLayoutWithoutItemsUpdateInput"]: {
		enabledWidgetTypes?: Array<GraphQLTypes["StatsWidgetsLayoutUpdateEnabledWidgetTypesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["StatsWidgetsLayoutUpdateEnabledWidgetTypesEntityRelationInput"]: {
		create?: GraphQLTypes["StatsEnabledWidgetTypeWithoutLayoutCreateInput"] | undefined,
	update?: GraphQLTypes["StatsWidgetsLayoutUpdateEnabledWidgetTypesRelationInput"] | undefined,
	upsert?: GraphQLTypes["StatsWidgetsLayoutUpsertEnabledWidgetTypesRelationInput"] | undefined,
	connect?: GraphQLTypes["StatsEnabledWidgetTypeUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["StatsEnabledWidgetTypeUniqueWhere"] | undefined,
	delete?: GraphQLTypes["StatsEnabledWidgetTypeUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["StatsWidgetsLayoutUpdateEnabledWidgetTypesRelationInput"]: {
		by?: GraphQLTypes["StatsEnabledWidgetTypeUniqueWhere"] | undefined,
	data?: GraphQLTypes["StatsEnabledWidgetTypeWithoutLayoutUpdateInput"] | undefined
};
	["StatsEnabledWidgetTypeWithoutLayoutUpdateInput"]: {
		type?: GraphQLTypes["StatsEnabledWidgetTypeType"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StatsWidgetsLayoutUpsertEnabledWidgetTypesRelationInput"]: {
		by?: GraphQLTypes["StatsEnabledWidgetTypeUniqueWhere"] | undefined,
	update?: GraphQLTypes["StatsEnabledWidgetTypeWithoutLayoutUpdateInput"] | undefined,
	create?: GraphQLTypes["StatsEnabledWidgetTypeWithoutLayoutCreateInput"] | undefined
};
	["StatsWidgetUpsertLayoutRelationInput"]: {
		update?: GraphQLTypes["StatsWidgetsLayoutWithoutItemsUpdateInput"] | undefined,
	create?: GraphQLTypes["StatsWidgetsLayoutWithoutItemsCreateInput"] | undefined
};
	["StatsWidgetsLayoutConnection"]: {
	__typename: "StatsWidgetsLayoutConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["StatsWidgetsLayoutEdge"]>
};
	["StatsWidgetsLayoutEdge"]: {
	__typename: "StatsWidgetsLayoutEdge",
	node: GraphQLTypes["StatsWidgetsLayout"]
};
	["StatsWidgetsLayoutCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	enabledWidgetTypes?: Array<GraphQLTypes["StatsWidgetsLayoutCreateEnabledWidgetTypesEntityRelationInput"]> | undefined,
	items?: Array<GraphQLTypes["StatsWidgetsLayoutCreateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["StatsWidgetsLayoutUpdateInput"]: {
		enabledWidgetTypes?: Array<GraphQLTypes["StatsWidgetsLayoutUpdateEnabledWidgetTypesEntityRelationInput"]> | undefined,
	items?: Array<GraphQLTypes["StatsWidgetsLayoutUpdateItemsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeatCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	positionX?: number | undefined,
	positionY?: number | undefined,
	name?: string | undefined,
	color?: string | undefined,
	customerTabs?: Array<GraphQLTypes["SeatCreateCustomerTabsEntityRelationInput"]> | undefined,
	table?: GraphQLTypes["SeatCreateTableEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["SeatUpdateInput"]: {
		positionX?: number | undefined,
	positionY?: number | undefined,
	name?: string | undefined,
	color?: string | undefined,
	customerTabs?: Array<GraphQLTypes["SeatUpdateCustomerTabsEntityRelationInput"]> | undefined,
	table?: GraphQLTypes["SeatUpdateTableEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["TableCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	shape?: GraphQLTypes["TableShape"] | undefined,
	width?: number | undefined,
	height?: number | undefined,
	positionX?: number | undefined,
	positionY?: number | undefined,
	name?: string | undefined,
	color?: string | undefined,
	customerTabs?: Array<GraphQLTypes["TableCreateCustomerTabsEntityRelationInput"]> | undefined,
	area?: GraphQLTypes["TableCreateAreaEntityRelationInput"] | undefined,
	seats?: Array<GraphQLTypes["TableCreateSeatsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["TableUpdateInput"]: {
		shape?: GraphQLTypes["TableShape"] | undefined,
	width?: number | undefined,
	height?: number | undefined,
	positionX?: number | undefined,
	positionY?: number | undefined,
	name?: string | undefined,
	color?: string | undefined,
	customerTabs?: Array<GraphQLTypes["TableUpdateCustomerTabsEntityRelationInput"]> | undefined,
	area?: GraphQLTypes["TableUpdateAreaEntityRelationInput"] | undefined,
	seats?: Array<GraphQLTypes["TableUpdateSeatsEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["StatsPage"]: {
	__typename: "StatsPage",
	_meta?: GraphQLTypes["StatsPageMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["StatsPageType"],
	enabled: boolean,
	widgets?: GraphQLTypes["StatsWidgetsLayout"] | undefined
};
	["StatsPageMeta"]: {
	__typename: "StatsPageMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	enabled?: GraphQLTypes["FieldMeta"] | undefined,
	widgets?: GraphQLTypes["FieldMeta"] | undefined
};
	["StatsPageType"]: StatsPageType;
	["StatsPageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["StatsPageType"] | undefined,
	widgets?: GraphQLTypes["StatsWidgetsLayoutUniqueWhere"] | undefined
};
	["StatsPageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	type?: GraphQLTypes["StatsPageTypeCondition"] | undefined,
	enabled?: GraphQLTypes["BooleanCondition"] | undefined,
	widgets?: GraphQLTypes["StatsWidgetsLayoutWhere"] | undefined,
	and?: Array<GraphQLTypes["StatsPageWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["StatsPageWhere"] | undefined> | undefined,
	not?: GraphQLTypes["StatsPageWhere"] | undefined
};
	["StatsPageTypeCondition"]: {
		and?: Array<GraphQLTypes["StatsPageTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["StatsPageTypeCondition"]> | undefined,
	not?: GraphQLTypes["StatsPageTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["StatsPageType"] | undefined,
	notEq?: GraphQLTypes["StatsPageType"] | undefined,
	in?: Array<GraphQLTypes["StatsPageType"]> | undefined,
	notIn?: Array<GraphQLTypes["StatsPageType"]> | undefined,
	lt?: GraphQLTypes["StatsPageType"] | undefined,
	lte?: GraphQLTypes["StatsPageType"] | undefined,
	gt?: GraphQLTypes["StatsPageType"] | undefined,
	gte?: GraphQLTypes["StatsPageType"] | undefined
};
	["StatsPageOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	enabled?: GraphQLTypes["OrderDirection"] | undefined,
	widgets?: GraphQLTypes["StatsWidgetsLayoutOrderBy"] | undefined
};
	["StatsPageConnection"]: {
	__typename: "StatsPageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["StatsPageEdge"]>
};
	["StatsPageEdge"]: {
	__typename: "StatsPageEdge",
	node: GraphQLTypes["StatsPage"]
};
	["StatsPageCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	type?: GraphQLTypes["StatsPageType"] | undefined,
	enabled?: boolean | undefined,
	widgets?: GraphQLTypes["StatsPageCreateWidgetsEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StatsPageCreateWidgetsEntityRelationInput"]: {
		connect?: GraphQLTypes["StatsWidgetsLayoutUniqueWhere"] | undefined,
	create?: GraphQLTypes["StatsWidgetsLayoutCreateInput"] | undefined
};
	["StatsPageUpdateInput"]: {
		type?: GraphQLTypes["StatsPageType"] | undefined,
	enabled?: boolean | undefined,
	widgets?: GraphQLTypes["StatsPageUpdateWidgetsEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["StatsPageUpdateWidgetsEntityRelationInput"]: {
		create?: GraphQLTypes["StatsWidgetsLayoutCreateInput"] | undefined,
	update?: GraphQLTypes["StatsWidgetsLayoutUpdateInput"] | undefined,
	upsert?: GraphQLTypes["StatsPageUpsertWidgetsRelationInput"] | undefined,
	connect?: GraphQLTypes["StatsWidgetsLayoutUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["StatsPageUpsertWidgetsRelationInput"]: {
		update?: GraphQLTypes["StatsWidgetsLayoutUpdateInput"] | undefined,
	create?: GraphQLTypes["StatsWidgetsLayoutCreateInput"] | undefined
};
	["DoubleshotCoffeeEquipmentConnection"]: {
	__typename: "DoubleshotCoffeeEquipmentConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DoubleshotCoffeeEquipmentEdge"]>
};
	["DoubleshotCoffeeEquipmentEdge"]: {
	__typename: "DoubleshotCoffeeEquipmentEdge",
	node: GraphQLTypes["DoubleshotCoffeeEquipment"]
};
	["Expense"]: {
	__typename: "Expense",
	_meta?: GraphQLTypes["ExpenseMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	type: GraphQLTypes["ExpenseType"],
	category?: GraphQLTypes["ExpenseCategory"] | undefined,
	supplier?: GraphQLTypes["IngredientSupplier"] | undefined,
	changes: Array<GraphQLTypes["ExpenseChange"]>,
	documents: Array<GraphQLTypes["ExpenseDocument"]>,
	terms: Array<GraphQLTypes["ExpenseTerm"]>,
	venue?: GraphQLTypes["Venue"] | undefined,
	paidByCash: boolean,
	changesByDate?: GraphQLTypes["ExpenseChange"] | undefined,
	documentsByFile?: GraphQLTypes["ExpenseDocument"] | undefined,
	paginateChanges: GraphQLTypes["ExpenseChangeConnection"],
	paginateDocuments: GraphQLTypes["ExpenseDocumentConnection"],
	paginateTerms: GraphQLTypes["ExpenseTermConnection"]
};
	["ExpenseMeta"]: {
	__typename: "ExpenseMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	category?: GraphQLTypes["FieldMeta"] | undefined,
	supplier?: GraphQLTypes["FieldMeta"] | undefined,
	changes?: GraphQLTypes["FieldMeta"] | undefined,
	documents?: GraphQLTypes["FieldMeta"] | undefined,
	terms?: GraphQLTypes["FieldMeta"] | undefined,
	venue?: GraphQLTypes["FieldMeta"] | undefined,
	paidByCash?: GraphQLTypes["FieldMeta"] | undefined
};
	["ExpenseType"]: ExpenseType;
	["ExpenseCategory"]: {
	__typename: "ExpenseCategory",
	_meta?: GraphQLTypes["ExpenseCategoryMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	items: Array<GraphQLTypes["Expense"]>,
	order: number,
	itemsByChanges?: GraphQLTypes["Expense"] | undefined,
	itemsByDocuments?: GraphQLTypes["Expense"] | undefined,
	itemsByTerms?: GraphQLTypes["Expense"] | undefined,
	paginateItems: GraphQLTypes["ExpenseConnection"]
};
	["ExpenseCategoryMeta"]: {
	__typename: "ExpenseCategoryMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	items?: GraphQLTypes["FieldMeta"] | undefined,
	order?: GraphQLTypes["FieldMeta"] | undefined
};
	["ExpenseWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	type?: GraphQLTypes["ExpenseTypeCondition"] | undefined,
	category?: GraphQLTypes["ExpenseCategoryWhere"] | undefined,
	supplier?: GraphQLTypes["IngredientSupplierWhere"] | undefined,
	changes?: GraphQLTypes["ExpenseChangeWhere"] | undefined,
	documents?: GraphQLTypes["ExpenseDocumentWhere"] | undefined,
	terms?: GraphQLTypes["ExpenseTermWhere"] | undefined,
	venue?: GraphQLTypes["VenueWhere"] | undefined,
	paidByCash?: GraphQLTypes["BooleanCondition"] | undefined,
	and?: Array<GraphQLTypes["ExpenseWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ExpenseWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ExpenseWhere"] | undefined
};
	["ExpenseTypeCondition"]: {
		and?: Array<GraphQLTypes["ExpenseTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["ExpenseTypeCondition"]> | undefined,
	not?: GraphQLTypes["ExpenseTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["ExpenseType"] | undefined,
	notEq?: GraphQLTypes["ExpenseType"] | undefined,
	in?: Array<GraphQLTypes["ExpenseType"]> | undefined,
	notIn?: Array<GraphQLTypes["ExpenseType"]> | undefined,
	lt?: GraphQLTypes["ExpenseType"] | undefined,
	lte?: GraphQLTypes["ExpenseType"] | undefined,
	gt?: GraphQLTypes["ExpenseType"] | undefined,
	gte?: GraphQLTypes["ExpenseType"] | undefined
};
	["ExpenseCategoryWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	items?: GraphQLTypes["ExpenseWhere"] | undefined,
	order?: GraphQLTypes["IntCondition"] | undefined,
	and?: Array<GraphQLTypes["ExpenseCategoryWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ExpenseCategoryWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ExpenseCategoryWhere"] | undefined
};
	["ExpenseChangeWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	date?: GraphQLTypes["DateCondition"] | undefined,
	amountCents?: GraphQLTypes["IntCondition"] | undefined,
	expense?: GraphQLTypes["ExpenseWhere"] | undefined,
	and?: Array<GraphQLTypes["ExpenseChangeWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ExpenseChangeWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ExpenseChangeWhere"] | undefined
};
	["ExpenseDocumentWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	expense?: GraphQLTypes["ExpenseWhere"] | undefined,
	amountCents?: GraphQLTypes["IntCondition"] | undefined,
	file?: GraphQLTypes["FileWhere"] | undefined,
	date?: GraphQLTypes["DateCondition"] | undefined,
	termDate?: GraphQLTypes["DateCondition"] | undefined,
	and?: Array<GraphQLTypes["ExpenseDocumentWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ExpenseDocumentWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ExpenseDocumentWhere"] | undefined
};
	["FileWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	url?: GraphQLTypes["StringCondition"] | undefined,
	size?: GraphQLTypes["IntCondition"] | undefined,
	type?: GraphQLTypes["StringCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	and?: Array<GraphQLTypes["FileWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["FileWhere"] | undefined> | undefined,
	not?: GraphQLTypes["FileWhere"] | undefined
};
	["ExpenseTermWhere"]: {
		id?: GraphQLTypes["StringCondition"] | undefined,
	date?: GraphQLTypes["DateCondition"] | undefined,
	amountCents?: GraphQLTypes["IntCondition"] | undefined,
	expense?: GraphQLTypes["ExpenseWhere"] | undefined,
	and?: Array<GraphQLTypes["ExpenseTermWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["ExpenseTermWhere"] | undefined> | undefined,
	not?: GraphQLTypes["ExpenseTermWhere"] | undefined
};
	["ExpenseOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	category?: GraphQLTypes["ExpenseCategoryOrderBy"] | undefined,
	supplier?: GraphQLTypes["IngredientSupplierOrderBy"] | undefined,
	venue?: GraphQLTypes["VenueOrderBy"] | undefined,
	paidByCash?: GraphQLTypes["OrderDirection"] | undefined
};
	["ExpenseCategoryOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	order?: GraphQLTypes["OrderDirection"] | undefined
};
	["ExpenseCategoryItemsByChangesUniqueWhere"]: {
		changes?: GraphQLTypes["ExpenseChangeUniqueWhere"] | undefined
};
	["ExpenseChangeUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	expense?: GraphQLTypes["ExpenseUniqueWhere"] | undefined,
	date?: GraphQLTypes["Date"] | undefined
};
	["ExpenseUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	changes?: GraphQLTypes["ExpenseChangeUniqueWhere"] | undefined,
	documents?: GraphQLTypes["ExpenseDocumentUniqueWhere"] | undefined,
	terms?: GraphQLTypes["ExpenseTermUniqueWhere"] | undefined
};
	["ExpenseDocumentUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	file?: GraphQLTypes["FileUniqueWhere"] | undefined
};
	["FileUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["ExpenseTermUniqueWhere"]: {
		id?: string | undefined
};
	["ExpenseCategoryItemsByDocumentsUniqueWhere"]: {
		documents?: GraphQLTypes["ExpenseDocumentUniqueWhere"] | undefined
};
	["ExpenseCategoryItemsByTermsUniqueWhere"]: {
		terms?: GraphQLTypes["ExpenseTermUniqueWhere"] | undefined
};
	["ExpenseConnection"]: {
	__typename: "ExpenseConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ExpenseEdge"]>
};
	["ExpenseEdge"]: {
	__typename: "ExpenseEdge",
	node: GraphQLTypes["Expense"]
};
	["ExpenseChange"]: {
	__typename: "ExpenseChange",
	_meta?: GraphQLTypes["ExpenseChangeMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	date: GraphQLTypes["Date"],
	amountCents: number,
	expense?: GraphQLTypes["Expense"] | undefined
};
	["ExpenseChangeMeta"]: {
	__typename: "ExpenseChangeMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	date?: GraphQLTypes["FieldMeta"] | undefined,
	amountCents?: GraphQLTypes["FieldMeta"] | undefined,
	expense?: GraphQLTypes["FieldMeta"] | undefined
};
	["ExpenseChangeOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	date?: GraphQLTypes["OrderDirection"] | undefined,
	amountCents?: GraphQLTypes["OrderDirection"] | undefined,
	expense?: GraphQLTypes["ExpenseOrderBy"] | undefined
};
	["ExpenseDocument"]: {
	__typename: "ExpenseDocument",
	_meta?: GraphQLTypes["ExpenseDocumentMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	expense?: GraphQLTypes["Expense"] | undefined,
	amountCents: number,
	file?: GraphQLTypes["File"] | undefined,
	date: GraphQLTypes["Date"],
	termDate: GraphQLTypes["Date"]
};
	["ExpenseDocumentMeta"]: {
	__typename: "ExpenseDocumentMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	expense?: GraphQLTypes["FieldMeta"] | undefined,
	amountCents?: GraphQLTypes["FieldMeta"] | undefined,
	file?: GraphQLTypes["FieldMeta"] | undefined,
	date?: GraphQLTypes["FieldMeta"] | undefined,
	termDate?: GraphQLTypes["FieldMeta"] | undefined
};
	["File"]: {
	__typename: "File",
	_meta?: GraphQLTypes["FileMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	url: string,
	size?: number | undefined,
	type?: string | undefined,
	name?: string | undefined
};
	["FileMeta"]: {
	__typename: "FileMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	url?: GraphQLTypes["FieldMeta"] | undefined,
	size?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined
};
	["ExpenseDocumentOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	expense?: GraphQLTypes["ExpenseOrderBy"] | undefined,
	amountCents?: GraphQLTypes["OrderDirection"] | undefined,
	file?: GraphQLTypes["FileOrderBy"] | undefined,
	date?: GraphQLTypes["OrderDirection"] | undefined,
	termDate?: GraphQLTypes["OrderDirection"] | undefined
};
	["FileOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	url?: GraphQLTypes["OrderDirection"] | undefined,
	size?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined
};
	["ExpenseTerm"]: {
	__typename: "ExpenseTerm",
	_meta?: GraphQLTypes["ExpenseTermMeta"] | undefined,
	id: string,
	date: GraphQLTypes["Date"],
	amountCents: number,
	expense?: GraphQLTypes["Expense"] | undefined
};
	["ExpenseTermMeta"]: {
	__typename: "ExpenseTermMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	date?: GraphQLTypes["FieldMeta"] | undefined,
	amountCents?: GraphQLTypes["FieldMeta"] | undefined,
	expense?: GraphQLTypes["FieldMeta"] | undefined
};
	["ExpenseTermOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	date?: GraphQLTypes["OrderDirection"] | undefined,
	amountCents?: GraphQLTypes["OrderDirection"] | undefined,
	expense?: GraphQLTypes["ExpenseOrderBy"] | undefined
};
	["ExpenseChangesByDateUniqueWhere"]: {
		date?: GraphQLTypes["Date"] | undefined
};
	["ExpenseDocumentsByFileUniqueWhere"]: {
		file?: GraphQLTypes["FileUniqueWhere"] | undefined
};
	["ExpenseChangeConnection"]: {
	__typename: "ExpenseChangeConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ExpenseChangeEdge"]>
};
	["ExpenseChangeEdge"]: {
	__typename: "ExpenseChangeEdge",
	node: GraphQLTypes["ExpenseChange"]
};
	["ExpenseDocumentConnection"]: {
	__typename: "ExpenseDocumentConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ExpenseDocumentEdge"]>
};
	["ExpenseDocumentEdge"]: {
	__typename: "ExpenseDocumentEdge",
	node: GraphQLTypes["ExpenseDocument"]
};
	["ExpenseTermConnection"]: {
	__typename: "ExpenseTermConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ExpenseTermEdge"]>
};
	["ExpenseTermEdge"]: {
	__typename: "ExpenseTermEdge",
	node: GraphQLTypes["ExpenseTerm"]
};
	["ExpenseCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	type?: GraphQLTypes["ExpenseType"] | undefined,
	category?: GraphQLTypes["ExpenseCreateCategoryEntityRelationInput"] | undefined,
	supplier?: GraphQLTypes["ExpenseCreateSupplierEntityRelationInput"] | undefined,
	changes?: Array<GraphQLTypes["ExpenseCreateChangesEntityRelationInput"]> | undefined,
	documents?: Array<GraphQLTypes["ExpenseCreateDocumentsEntityRelationInput"]> | undefined,
	terms?: Array<GraphQLTypes["ExpenseCreateTermsEntityRelationInput"]> | undefined,
	venue?: GraphQLTypes["ExpenseCreateVenueEntityRelationInput"] | undefined,
	paidByCash?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ExpenseCreateCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["ExpenseCategoryUniqueWhere"] | undefined,
	create?: GraphQLTypes["ExpenseCategoryWithoutItemsCreateInput"] | undefined
};
	["ExpenseCategoryUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	items?: GraphQLTypes["ExpenseUniqueWhere"] | undefined
};
	["ExpenseCategoryWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["ExpenseCreateSupplierEntityRelationInput"]: {
		connect?: GraphQLTypes["IngredientSupplierUniqueWhere"] | undefined,
	create?: GraphQLTypes["IngredientSupplierCreateInput"] | undefined
};
	["ExpenseCreateChangesEntityRelationInput"]: {
		connect?: GraphQLTypes["ExpenseChangeUniqueWhere"] | undefined,
	create?: GraphQLTypes["ExpenseChangeWithoutExpenseCreateInput"] | undefined,
	alias?: string | undefined
};
	["ExpenseChangeWithoutExpenseCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	date?: GraphQLTypes["Date"] | undefined,
	amountCents?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["ExpenseCreateDocumentsEntityRelationInput"]: {
		connect?: GraphQLTypes["ExpenseDocumentUniqueWhere"] | undefined,
	create?: GraphQLTypes["ExpenseDocumentWithoutExpenseCreateInput"] | undefined,
	alias?: string | undefined
};
	["ExpenseDocumentWithoutExpenseCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	amountCents?: number | undefined,
	file?: GraphQLTypes["ExpenseDocumentCreateFileEntityRelationInput"] | undefined,
	date?: GraphQLTypes["Date"] | undefined,
	termDate?: GraphQLTypes["Date"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ExpenseDocumentCreateFileEntityRelationInput"]: {
		connect?: GraphQLTypes["FileUniqueWhere"] | undefined,
	create?: GraphQLTypes["FileCreateInput"] | undefined
};
	["FileCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	url?: string | undefined,
	size?: number | undefined,
	type?: string | undefined,
	name?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ExpenseCreateTermsEntityRelationInput"]: {
		connect?: GraphQLTypes["ExpenseTermUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ExpenseCreateVenueEntityRelationInput"]: {
		connect?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	create?: GraphQLTypes["VenueCreateInput"] | undefined
};
	["ExpenseUpdateInput"]: {
		name?: string | undefined,
	type?: GraphQLTypes["ExpenseType"] | undefined,
	category?: GraphQLTypes["ExpenseUpdateCategoryEntityRelationInput"] | undefined,
	supplier?: GraphQLTypes["ExpenseUpdateSupplierEntityRelationInput"] | undefined,
	changes?: Array<GraphQLTypes["ExpenseUpdateChangesEntityRelationInput"]> | undefined,
	documents?: Array<GraphQLTypes["ExpenseUpdateDocumentsEntityRelationInput"]> | undefined,
	terms?: Array<GraphQLTypes["ExpenseUpdateTermsEntityRelationInput"]> | undefined,
	venue?: GraphQLTypes["ExpenseUpdateVenueEntityRelationInput"] | undefined,
	paidByCash?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ExpenseUpdateCategoryEntityRelationInput"]: {
		create?: GraphQLTypes["ExpenseCategoryWithoutItemsCreateInput"] | undefined,
	update?: GraphQLTypes["ExpenseCategoryWithoutItemsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ExpenseUpsertCategoryRelationInput"] | undefined,
	connect?: GraphQLTypes["ExpenseCategoryUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ExpenseCategoryWithoutItemsUpdateInput"]: {
		name?: string | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["ExpenseUpsertCategoryRelationInput"]: {
		update?: GraphQLTypes["ExpenseCategoryWithoutItemsUpdateInput"] | undefined,
	create?: GraphQLTypes["ExpenseCategoryWithoutItemsCreateInput"] | undefined
};
	["ExpenseUpdateSupplierEntityRelationInput"]: {
		create?: GraphQLTypes["IngredientSupplierCreateInput"] | undefined,
	update?: GraphQLTypes["IngredientSupplierUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ExpenseUpsertSupplierRelationInput"] | undefined,
	connect?: GraphQLTypes["IngredientSupplierUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ExpenseUpsertSupplierRelationInput"]: {
		update?: GraphQLTypes["IngredientSupplierUpdateInput"] | undefined,
	create?: GraphQLTypes["IngredientSupplierCreateInput"] | undefined
};
	["ExpenseUpdateChangesEntityRelationInput"]: {
		create?: GraphQLTypes["ExpenseChangeWithoutExpenseCreateInput"] | undefined,
	update?: GraphQLTypes["ExpenseUpdateChangesRelationInput"] | undefined,
	upsert?: GraphQLTypes["ExpenseUpsertChangesRelationInput"] | undefined,
	connect?: GraphQLTypes["ExpenseChangeUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ExpenseChangeUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ExpenseChangeUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ExpenseUpdateChangesRelationInput"]: {
		by?: GraphQLTypes["ExpenseChangeUniqueWhere"] | undefined,
	data?: GraphQLTypes["ExpenseChangeWithoutExpenseUpdateInput"] | undefined
};
	["ExpenseChangeWithoutExpenseUpdateInput"]: {
		date?: GraphQLTypes["Date"] | undefined,
	amountCents?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["ExpenseUpsertChangesRelationInput"]: {
		by?: GraphQLTypes["ExpenseChangeUniqueWhere"] | undefined,
	update?: GraphQLTypes["ExpenseChangeWithoutExpenseUpdateInput"] | undefined,
	create?: GraphQLTypes["ExpenseChangeWithoutExpenseCreateInput"] | undefined
};
	["ExpenseUpdateDocumentsEntityRelationInput"]: {
		create?: GraphQLTypes["ExpenseDocumentWithoutExpenseCreateInput"] | undefined,
	update?: GraphQLTypes["ExpenseUpdateDocumentsRelationInput"] | undefined,
	upsert?: GraphQLTypes["ExpenseUpsertDocumentsRelationInput"] | undefined,
	connect?: GraphQLTypes["ExpenseDocumentUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ExpenseDocumentUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ExpenseDocumentUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ExpenseUpdateDocumentsRelationInput"]: {
		by?: GraphQLTypes["ExpenseDocumentUniqueWhere"] | undefined,
	data?: GraphQLTypes["ExpenseDocumentWithoutExpenseUpdateInput"] | undefined
};
	["ExpenseDocumentWithoutExpenseUpdateInput"]: {
		amountCents?: number | undefined,
	file?: GraphQLTypes["ExpenseDocumentUpdateFileEntityRelationInput"] | undefined,
	date?: GraphQLTypes["Date"] | undefined,
	termDate?: GraphQLTypes["Date"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ExpenseDocumentUpdateFileEntityRelationInput"]: {
		create?: GraphQLTypes["FileCreateInput"] | undefined,
	update?: GraphQLTypes["FileUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ExpenseDocumentUpsertFileRelationInput"] | undefined,
	connect?: GraphQLTypes["FileUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["FileUpdateInput"]: {
		url?: string | undefined,
	size?: number | undefined,
	type?: string | undefined,
	name?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["ExpenseDocumentUpsertFileRelationInput"]: {
		update?: GraphQLTypes["FileUpdateInput"] | undefined,
	create?: GraphQLTypes["FileCreateInput"] | undefined
};
	["ExpenseUpsertDocumentsRelationInput"]: {
		by?: GraphQLTypes["ExpenseDocumentUniqueWhere"] | undefined,
	update?: GraphQLTypes["ExpenseDocumentWithoutExpenseUpdateInput"] | undefined,
	create?: GraphQLTypes["ExpenseDocumentWithoutExpenseCreateInput"] | undefined
};
	["ExpenseUpdateTermsEntityRelationInput"]: {
		connect?: GraphQLTypes["ExpenseTermUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ExpenseTermUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ExpenseTermUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ExpenseUpdateVenueEntityRelationInput"]: {
		create?: GraphQLTypes["VenueCreateInput"] | undefined,
	update?: GraphQLTypes["VenueUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ExpenseUpsertVenueRelationInput"] | undefined,
	connect?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ExpenseUpsertVenueRelationInput"]: {
		update?: GraphQLTypes["VenueUpdateInput"] | undefined,
	create?: GraphQLTypes["VenueCreateInput"] | undefined
};
	["ExpenseCategoryConnection"]: {
	__typename: "ExpenseCategoryConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ExpenseCategoryEdge"]>
};
	["ExpenseCategoryEdge"]: {
	__typename: "ExpenseCategoryEdge",
	node: GraphQLTypes["ExpenseCategory"]
};
	["ExpenseCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	items?: Array<GraphQLTypes["ExpenseCategoryCreateItemsEntityRelationInput"]> | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["ExpenseCategoryCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["ExpenseUniqueWhere"] | undefined,
	create?: GraphQLTypes["ExpenseWithoutCategoryCreateInput"] | undefined,
	alias?: string | undefined
};
	["ExpenseWithoutCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	type?: GraphQLTypes["ExpenseType"] | undefined,
	supplier?: GraphQLTypes["ExpenseCreateSupplierEntityRelationInput"] | undefined,
	changes?: Array<GraphQLTypes["ExpenseCreateChangesEntityRelationInput"]> | undefined,
	documents?: Array<GraphQLTypes["ExpenseCreateDocumentsEntityRelationInput"]> | undefined,
	terms?: Array<GraphQLTypes["ExpenseCreateTermsEntityRelationInput"]> | undefined,
	venue?: GraphQLTypes["ExpenseCreateVenueEntityRelationInput"] | undefined,
	paidByCash?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ExpenseCategoryUpdateInput"]: {
		name?: string | undefined,
	items?: Array<GraphQLTypes["ExpenseCategoryUpdateItemsEntityRelationInput"]> | undefined,
	order?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["ExpenseCategoryUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["ExpenseWithoutCategoryCreateInput"] | undefined,
	update?: GraphQLTypes["ExpenseCategoryUpdateItemsRelationInput"] | undefined,
	upsert?: GraphQLTypes["ExpenseCategoryUpsertItemsRelationInput"] | undefined,
	connect?: GraphQLTypes["ExpenseUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["ExpenseUniqueWhere"] | undefined,
	delete?: GraphQLTypes["ExpenseUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["ExpenseCategoryUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["ExpenseUniqueWhere"] | undefined,
	data?: GraphQLTypes["ExpenseWithoutCategoryUpdateInput"] | undefined
};
	["ExpenseWithoutCategoryUpdateInput"]: {
		name?: string | undefined,
	type?: GraphQLTypes["ExpenseType"] | undefined,
	supplier?: GraphQLTypes["ExpenseUpdateSupplierEntityRelationInput"] | undefined,
	changes?: Array<GraphQLTypes["ExpenseUpdateChangesEntityRelationInput"]> | undefined,
	documents?: Array<GraphQLTypes["ExpenseUpdateDocumentsEntityRelationInput"]> | undefined,
	terms?: Array<GraphQLTypes["ExpenseUpdateTermsEntityRelationInput"]> | undefined,
	venue?: GraphQLTypes["ExpenseUpdateVenueEntityRelationInput"] | undefined,
	paidByCash?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ExpenseCategoryUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["ExpenseUniqueWhere"] | undefined,
	update?: GraphQLTypes["ExpenseWithoutCategoryUpdateInput"] | undefined,
	create?: GraphQLTypes["ExpenseWithoutCategoryCreateInput"] | undefined
};
	["ExpenseChangeCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	date?: GraphQLTypes["Date"] | undefined,
	amountCents?: number | undefined,
	expense?: GraphQLTypes["ExpenseChangeCreateExpenseEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ExpenseChangeCreateExpenseEntityRelationInput"]: {
		connect?: GraphQLTypes["ExpenseUniqueWhere"] | undefined,
	create?: GraphQLTypes["ExpenseWithoutChangesCreateInput"] | undefined
};
	["ExpenseWithoutChangesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	type?: GraphQLTypes["ExpenseType"] | undefined,
	category?: GraphQLTypes["ExpenseCreateCategoryEntityRelationInput"] | undefined,
	supplier?: GraphQLTypes["ExpenseCreateSupplierEntityRelationInput"] | undefined,
	documents?: Array<GraphQLTypes["ExpenseCreateDocumentsEntityRelationInput"]> | undefined,
	terms?: Array<GraphQLTypes["ExpenseCreateTermsEntityRelationInput"]> | undefined,
	venue?: GraphQLTypes["ExpenseCreateVenueEntityRelationInput"] | undefined,
	paidByCash?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ExpenseChangeUpdateInput"]: {
		date?: GraphQLTypes["Date"] | undefined,
	amountCents?: number | undefined,
	expense?: GraphQLTypes["ExpenseChangeUpdateExpenseEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ExpenseChangeUpdateExpenseEntityRelationInput"]: {
		create?: GraphQLTypes["ExpenseWithoutChangesCreateInput"] | undefined,
	update?: GraphQLTypes["ExpenseWithoutChangesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ExpenseChangeUpsertExpenseRelationInput"] | undefined,
	connect?: GraphQLTypes["ExpenseUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["ExpenseWithoutChangesUpdateInput"]: {
		name?: string | undefined,
	type?: GraphQLTypes["ExpenseType"] | undefined,
	category?: GraphQLTypes["ExpenseUpdateCategoryEntityRelationInput"] | undefined,
	supplier?: GraphQLTypes["ExpenseUpdateSupplierEntityRelationInput"] | undefined,
	documents?: Array<GraphQLTypes["ExpenseUpdateDocumentsEntityRelationInput"]> | undefined,
	terms?: Array<GraphQLTypes["ExpenseUpdateTermsEntityRelationInput"]> | undefined,
	venue?: GraphQLTypes["ExpenseUpdateVenueEntityRelationInput"] | undefined,
	paidByCash?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ExpenseChangeUpsertExpenseRelationInput"]: {
		update?: GraphQLTypes["ExpenseWithoutChangesUpdateInput"] | undefined,
	create?: GraphQLTypes["ExpenseWithoutChangesCreateInput"] | undefined
};
	["ExpenseDocumentCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	expense?: GraphQLTypes["ExpenseDocumentCreateExpenseEntityRelationInput"] | undefined,
	amountCents?: number | undefined,
	file?: GraphQLTypes["ExpenseDocumentCreateFileEntityRelationInput"] | undefined,
	date?: GraphQLTypes["Date"] | undefined,
	termDate?: GraphQLTypes["Date"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ExpenseDocumentCreateExpenseEntityRelationInput"]: {
		connect?: GraphQLTypes["ExpenseUniqueWhere"] | undefined,
	create?: GraphQLTypes["ExpenseWithoutDocumentsCreateInput"] | undefined
};
	["ExpenseWithoutDocumentsCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	type?: GraphQLTypes["ExpenseType"] | undefined,
	category?: GraphQLTypes["ExpenseCreateCategoryEntityRelationInput"] | undefined,
	supplier?: GraphQLTypes["ExpenseCreateSupplierEntityRelationInput"] | undefined,
	changes?: Array<GraphQLTypes["ExpenseCreateChangesEntityRelationInput"]> | undefined,
	terms?: Array<GraphQLTypes["ExpenseCreateTermsEntityRelationInput"]> | undefined,
	venue?: GraphQLTypes["ExpenseCreateVenueEntityRelationInput"] | undefined,
	paidByCash?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ExpenseDocumentUpdateInput"]: {
		expense?: GraphQLTypes["ExpenseDocumentUpdateExpenseEntityRelationInput"] | undefined,
	amountCents?: number | undefined,
	file?: GraphQLTypes["ExpenseDocumentUpdateFileEntityRelationInput"] | undefined,
	date?: GraphQLTypes["Date"] | undefined,
	termDate?: GraphQLTypes["Date"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["ExpenseDocumentUpdateExpenseEntityRelationInput"]: {
		create?: GraphQLTypes["ExpenseWithoutDocumentsCreateInput"] | undefined,
	update?: GraphQLTypes["ExpenseWithoutDocumentsUpdateInput"] | undefined,
	upsert?: GraphQLTypes["ExpenseDocumentUpsertExpenseRelationInput"] | undefined,
	connect?: GraphQLTypes["ExpenseUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["ExpenseWithoutDocumentsUpdateInput"]: {
		name?: string | undefined,
	type?: GraphQLTypes["ExpenseType"] | undefined,
	category?: GraphQLTypes["ExpenseUpdateCategoryEntityRelationInput"] | undefined,
	supplier?: GraphQLTypes["ExpenseUpdateSupplierEntityRelationInput"] | undefined,
	changes?: Array<GraphQLTypes["ExpenseUpdateChangesEntityRelationInput"]> | undefined,
	terms?: Array<GraphQLTypes["ExpenseUpdateTermsEntityRelationInput"]> | undefined,
	venue?: GraphQLTypes["ExpenseUpdateVenueEntityRelationInput"] | undefined,
	paidByCash?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["ExpenseDocumentUpsertExpenseRelationInput"]: {
		update?: GraphQLTypes["ExpenseWithoutDocumentsUpdateInput"] | undefined,
	create?: GraphQLTypes["ExpenseWithoutDocumentsCreateInput"] | undefined
};
	["RevenuePrediction"]: {
	__typename: "RevenuePrediction",
	_meta?: GraphQLTypes["RevenuePredictionMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	name: string,
	type: GraphQLTypes["RevenuePredictionType"],
	channel?: GraphQLTypes["Channel"] | undefined,
	changes: Array<GraphQLTypes["RevenuePredictionChange"]>,
	alwaysIncludeInTotalRevenue: boolean,
	recurrencePeriod: GraphQLTypes["RecurrencePeriod"],
	monday: boolean,
	tuesday: boolean,
	wednesday: boolean,
	thursday: boolean,
	friday: boolean,
	saturday: boolean,
	sunday: boolean,
	terms: Array<GraphQLTypes["RevenuePredictionTerm"]>,
	paymentMethod?: GraphQLTypes["PaymentMethod"] | undefined,
	changesByDate?: GraphQLTypes["RevenuePredictionChange"] | undefined,
	paginateChanges: GraphQLTypes["RevenuePredictionChangeConnection"],
	paginateTerms: GraphQLTypes["RevenuePredictionTermConnection"]
};
	["RevenuePredictionMeta"]: {
	__typename: "RevenuePredictionMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	name?: GraphQLTypes["FieldMeta"] | undefined,
	type?: GraphQLTypes["FieldMeta"] | undefined,
	channel?: GraphQLTypes["FieldMeta"] | undefined,
	changes?: GraphQLTypes["FieldMeta"] | undefined,
	alwaysIncludeInTotalRevenue?: GraphQLTypes["FieldMeta"] | undefined,
	recurrencePeriod?: GraphQLTypes["FieldMeta"] | undefined,
	monday?: GraphQLTypes["FieldMeta"] | undefined,
	tuesday?: GraphQLTypes["FieldMeta"] | undefined,
	wednesday?: GraphQLTypes["FieldMeta"] | undefined,
	thursday?: GraphQLTypes["FieldMeta"] | undefined,
	friday?: GraphQLTypes["FieldMeta"] | undefined,
	saturday?: GraphQLTypes["FieldMeta"] | undefined,
	sunday?: GraphQLTypes["FieldMeta"] | undefined,
	terms?: GraphQLTypes["FieldMeta"] | undefined,
	paymentMethod?: GraphQLTypes["FieldMeta"] | undefined
};
	["RevenuePredictionType"]: RevenuePredictionType;
	["RevenuePredictionChange"]: {
	__typename: "RevenuePredictionChange",
	_meta?: GraphQLTypes["RevenuePredictionChangeMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	date: GraphQLTypes["Date"],
	amountCents: number,
	prediction?: GraphQLTypes["RevenuePrediction"] | undefined
};
	["RevenuePredictionChangeMeta"]: {
	__typename: "RevenuePredictionChangeMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	date?: GraphQLTypes["FieldMeta"] | undefined,
	amountCents?: GraphQLTypes["FieldMeta"] | undefined,
	prediction?: GraphQLTypes["FieldMeta"] | undefined
};
	["RevenuePredictionWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	name?: GraphQLTypes["StringCondition"] | undefined,
	type?: GraphQLTypes["RevenuePredictionTypeCondition"] | undefined,
	channel?: GraphQLTypes["ChannelWhere"] | undefined,
	changes?: GraphQLTypes["RevenuePredictionChangeWhere"] | undefined,
	alwaysIncludeInTotalRevenue?: GraphQLTypes["BooleanCondition"] | undefined,
	recurrencePeriod?: GraphQLTypes["RecurrencePeriodCondition"] | undefined,
	monday?: GraphQLTypes["BooleanCondition"] | undefined,
	tuesday?: GraphQLTypes["BooleanCondition"] | undefined,
	wednesday?: GraphQLTypes["BooleanCondition"] | undefined,
	thursday?: GraphQLTypes["BooleanCondition"] | undefined,
	friday?: GraphQLTypes["BooleanCondition"] | undefined,
	saturday?: GraphQLTypes["BooleanCondition"] | undefined,
	sunday?: GraphQLTypes["BooleanCondition"] | undefined,
	terms?: GraphQLTypes["RevenuePredictionTermWhere"] | undefined,
	paymentMethod?: GraphQLTypes["PaymentMethodWhere"] | undefined,
	and?: Array<GraphQLTypes["RevenuePredictionWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["RevenuePredictionWhere"] | undefined> | undefined,
	not?: GraphQLTypes["RevenuePredictionWhere"] | undefined
};
	["RevenuePredictionTypeCondition"]: {
		and?: Array<GraphQLTypes["RevenuePredictionTypeCondition"]> | undefined,
	or?: Array<GraphQLTypes["RevenuePredictionTypeCondition"]> | undefined,
	not?: GraphQLTypes["RevenuePredictionTypeCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["RevenuePredictionType"] | undefined,
	notEq?: GraphQLTypes["RevenuePredictionType"] | undefined,
	in?: Array<GraphQLTypes["RevenuePredictionType"]> | undefined,
	notIn?: Array<GraphQLTypes["RevenuePredictionType"]> | undefined,
	lt?: GraphQLTypes["RevenuePredictionType"] | undefined,
	lte?: GraphQLTypes["RevenuePredictionType"] | undefined,
	gt?: GraphQLTypes["RevenuePredictionType"] | undefined,
	gte?: GraphQLTypes["RevenuePredictionType"] | undefined
};
	["RevenuePredictionChangeWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	date?: GraphQLTypes["DateCondition"] | undefined,
	amountCents?: GraphQLTypes["IntCondition"] | undefined,
	prediction?: GraphQLTypes["RevenuePredictionWhere"] | undefined,
	and?: Array<GraphQLTypes["RevenuePredictionChangeWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["RevenuePredictionChangeWhere"] | undefined> | undefined,
	not?: GraphQLTypes["RevenuePredictionChangeWhere"] | undefined
};
	["RecurrencePeriodCondition"]: {
		and?: Array<GraphQLTypes["RecurrencePeriodCondition"]> | undefined,
	or?: Array<GraphQLTypes["RecurrencePeriodCondition"]> | undefined,
	not?: GraphQLTypes["RecurrencePeriodCondition"] | undefined,
	null?: boolean | undefined,
	isNull?: boolean | undefined,
	eq?: GraphQLTypes["RecurrencePeriod"] | undefined,
	notEq?: GraphQLTypes["RecurrencePeriod"] | undefined,
	in?: Array<GraphQLTypes["RecurrencePeriod"]> | undefined,
	notIn?: Array<GraphQLTypes["RecurrencePeriod"]> | undefined,
	lt?: GraphQLTypes["RecurrencePeriod"] | undefined,
	lte?: GraphQLTypes["RecurrencePeriod"] | undefined,
	gt?: GraphQLTypes["RecurrencePeriod"] | undefined,
	gte?: GraphQLTypes["RecurrencePeriod"] | undefined
};
	["RecurrencePeriod"]: RecurrencePeriod;
	["RevenuePredictionTermWhere"]: {
		id?: GraphQLTypes["StringCondition"] | undefined,
	date?: GraphQLTypes["DateCondition"] | undefined,
	amountCents?: GraphQLTypes["IntCondition"] | undefined,
	prediction?: GraphQLTypes["RevenuePredictionWhere"] | undefined,
	and?: Array<GraphQLTypes["RevenuePredictionTermWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["RevenuePredictionTermWhere"] | undefined> | undefined,
	not?: GraphQLTypes["RevenuePredictionTermWhere"] | undefined
};
	["RevenuePredictionChangeOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	date?: GraphQLTypes["OrderDirection"] | undefined,
	amountCents?: GraphQLTypes["OrderDirection"] | undefined,
	prediction?: GraphQLTypes["RevenuePredictionOrderBy"] | undefined
};
	["RevenuePredictionOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	name?: GraphQLTypes["OrderDirection"] | undefined,
	type?: GraphQLTypes["OrderDirection"] | undefined,
	channel?: GraphQLTypes["ChannelOrderBy"] | undefined,
	alwaysIncludeInTotalRevenue?: GraphQLTypes["OrderDirection"] | undefined,
	recurrencePeriod?: GraphQLTypes["OrderDirection"] | undefined,
	monday?: GraphQLTypes["OrderDirection"] | undefined,
	tuesday?: GraphQLTypes["OrderDirection"] | undefined,
	wednesday?: GraphQLTypes["OrderDirection"] | undefined,
	thursday?: GraphQLTypes["OrderDirection"] | undefined,
	friday?: GraphQLTypes["OrderDirection"] | undefined,
	saturday?: GraphQLTypes["OrderDirection"] | undefined,
	sunday?: GraphQLTypes["OrderDirection"] | undefined,
	paymentMethod?: GraphQLTypes["PaymentMethodOrderBy"] | undefined
};
	["RevenuePredictionTerm"]: {
	__typename: "RevenuePredictionTerm",
	_meta?: GraphQLTypes["RevenuePredictionTermMeta"] | undefined,
	id: string,
	date: GraphQLTypes["Date"],
	amountCents: number,
	prediction?: GraphQLTypes["RevenuePrediction"] | undefined
};
	["RevenuePredictionTermMeta"]: {
	__typename: "RevenuePredictionTermMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	date?: GraphQLTypes["FieldMeta"] | undefined,
	amountCents?: GraphQLTypes["FieldMeta"] | undefined,
	prediction?: GraphQLTypes["FieldMeta"] | undefined
};
	["RevenuePredictionTermOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	date?: GraphQLTypes["OrderDirection"] | undefined,
	amountCents?: GraphQLTypes["OrderDirection"] | undefined,
	prediction?: GraphQLTypes["RevenuePredictionOrderBy"] | undefined
};
	["RevenuePredictionChangesByDateUniqueWhere"]: {
		date?: GraphQLTypes["Date"] | undefined
};
	["RevenuePredictionChangeConnection"]: {
	__typename: "RevenuePredictionChangeConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["RevenuePredictionChangeEdge"]>
};
	["RevenuePredictionChangeEdge"]: {
	__typename: "RevenuePredictionChangeEdge",
	node: GraphQLTypes["RevenuePredictionChange"]
};
	["RevenuePredictionTermConnection"]: {
	__typename: "RevenuePredictionTermConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["RevenuePredictionTermEdge"]>
};
	["RevenuePredictionTermEdge"]: {
	__typename: "RevenuePredictionTermEdge",
	node: GraphQLTypes["RevenuePredictionTerm"]
};
	["RevenuePredictionUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	changes?: GraphQLTypes["RevenuePredictionChangeUniqueWhere"] | undefined,
	terms?: GraphQLTypes["RevenuePredictionTermUniqueWhere"] | undefined
};
	["RevenuePredictionChangeUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	prediction?: GraphQLTypes["RevenuePredictionUniqueWhere"] | undefined,
	date?: GraphQLTypes["Date"] | undefined
};
	["RevenuePredictionTermUniqueWhere"]: {
		id?: string | undefined
};
	["RevenuePredictionConnection"]: {
	__typename: "RevenuePredictionConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["RevenuePredictionEdge"]>
};
	["RevenuePredictionEdge"]: {
	__typename: "RevenuePredictionEdge",
	node: GraphQLTypes["RevenuePrediction"]
};
	["RevenuePredictionCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	type?: GraphQLTypes["RevenuePredictionType"] | undefined,
	channel?: GraphQLTypes["RevenuePredictionCreateChannelEntityRelationInput"] | undefined,
	changes?: Array<GraphQLTypes["RevenuePredictionCreateChangesEntityRelationInput"]> | undefined,
	alwaysIncludeInTotalRevenue?: boolean | undefined,
	recurrencePeriod?: GraphQLTypes["RecurrencePeriod"] | undefined,
	monday?: boolean | undefined,
	tuesday?: boolean | undefined,
	wednesday?: boolean | undefined,
	thursday?: boolean | undefined,
	friday?: boolean | undefined,
	saturday?: boolean | undefined,
	sunday?: boolean | undefined,
	terms?: Array<GraphQLTypes["RevenuePredictionCreateTermsEntityRelationInput"]> | undefined,
	paymentMethod?: GraphQLTypes["RevenuePredictionCreatePaymentMethodEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RevenuePredictionCreateChannelEntityRelationInput"]: {
		connect?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	create?: GraphQLTypes["ChannelCreateInput"] | undefined
};
	["RevenuePredictionCreateChangesEntityRelationInput"]: {
		connect?: GraphQLTypes["RevenuePredictionChangeUniqueWhere"] | undefined,
	create?: GraphQLTypes["RevenuePredictionChangeWithoutPredictionCreateInput"] | undefined,
	alias?: string | undefined
};
	["RevenuePredictionChangeWithoutPredictionCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	date?: GraphQLTypes["Date"] | undefined,
	amountCents?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["RevenuePredictionCreateTermsEntityRelationInput"]: {
		connect?: GraphQLTypes["RevenuePredictionTermUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["RevenuePredictionCreatePaymentMethodEntityRelationInput"]: {
		connect?: GraphQLTypes["PaymentMethodUniqueWhere"] | undefined,
	create?: GraphQLTypes["PaymentMethodCreateInput"] | undefined
};
	["RevenuePredictionUpdateInput"]: {
		name?: string | undefined,
	type?: GraphQLTypes["RevenuePredictionType"] | undefined,
	channel?: GraphQLTypes["RevenuePredictionUpdateChannelEntityRelationInput"] | undefined,
	changes?: Array<GraphQLTypes["RevenuePredictionUpdateChangesEntityRelationInput"]> | undefined,
	alwaysIncludeInTotalRevenue?: boolean | undefined,
	recurrencePeriod?: GraphQLTypes["RecurrencePeriod"] | undefined,
	monday?: boolean | undefined,
	tuesday?: boolean | undefined,
	wednesday?: boolean | undefined,
	thursday?: boolean | undefined,
	friday?: boolean | undefined,
	saturday?: boolean | undefined,
	sunday?: boolean | undefined,
	terms?: Array<GraphQLTypes["RevenuePredictionUpdateTermsEntityRelationInput"]> | undefined,
	paymentMethod?: GraphQLTypes["RevenuePredictionUpdatePaymentMethodEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RevenuePredictionUpdateChannelEntityRelationInput"]: {
		create?: GraphQLTypes["ChannelCreateInput"] | undefined,
	update?: GraphQLTypes["ChannelUpdateInput"] | undefined,
	upsert?: GraphQLTypes["RevenuePredictionUpsertChannelRelationInput"] | undefined,
	connect?: GraphQLTypes["ChannelUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["RevenuePredictionUpsertChannelRelationInput"]: {
		update?: GraphQLTypes["ChannelUpdateInput"] | undefined,
	create?: GraphQLTypes["ChannelCreateInput"] | undefined
};
	["RevenuePredictionUpdateChangesEntityRelationInput"]: {
		create?: GraphQLTypes["RevenuePredictionChangeWithoutPredictionCreateInput"] | undefined,
	update?: GraphQLTypes["RevenuePredictionUpdateChangesRelationInput"] | undefined,
	upsert?: GraphQLTypes["RevenuePredictionUpsertChangesRelationInput"] | undefined,
	connect?: GraphQLTypes["RevenuePredictionChangeUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["RevenuePredictionChangeUniqueWhere"] | undefined,
	delete?: GraphQLTypes["RevenuePredictionChangeUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["RevenuePredictionUpdateChangesRelationInput"]: {
		by?: GraphQLTypes["RevenuePredictionChangeUniqueWhere"] | undefined,
	data?: GraphQLTypes["RevenuePredictionChangeWithoutPredictionUpdateInput"] | undefined
};
	["RevenuePredictionChangeWithoutPredictionUpdateInput"]: {
		date?: GraphQLTypes["Date"] | undefined,
	amountCents?: number | undefined,
	_dummy_field_?: boolean | undefined
};
	["RevenuePredictionUpsertChangesRelationInput"]: {
		by?: GraphQLTypes["RevenuePredictionChangeUniqueWhere"] | undefined,
	update?: GraphQLTypes["RevenuePredictionChangeWithoutPredictionUpdateInput"] | undefined,
	create?: GraphQLTypes["RevenuePredictionChangeWithoutPredictionCreateInput"] | undefined
};
	["RevenuePredictionUpdateTermsEntityRelationInput"]: {
		connect?: GraphQLTypes["RevenuePredictionTermUniqueWhere"] | undefined,
	disconnect?: GraphQLTypes["RevenuePredictionTermUniqueWhere"] | undefined,
	delete?: GraphQLTypes["RevenuePredictionTermUniqueWhere"] | undefined,
	alias?: string | undefined
};
	["RevenuePredictionUpdatePaymentMethodEntityRelationInput"]: {
		create?: GraphQLTypes["PaymentMethodCreateInput"] | undefined,
	update?: GraphQLTypes["PaymentMethodUpdateInput"] | undefined,
	upsert?: GraphQLTypes["RevenuePredictionUpsertPaymentMethodRelationInput"] | undefined,
	connect?: GraphQLTypes["PaymentMethodUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["RevenuePredictionUpsertPaymentMethodRelationInput"]: {
		update?: GraphQLTypes["PaymentMethodUpdateInput"] | undefined,
	create?: GraphQLTypes["PaymentMethodCreateInput"] | undefined
};
	["RevenuePredictionChangeCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	date?: GraphQLTypes["Date"] | undefined,
	amountCents?: number | undefined,
	prediction?: GraphQLTypes["RevenuePredictionChangeCreatePredictionEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RevenuePredictionChangeCreatePredictionEntityRelationInput"]: {
		connect?: GraphQLTypes["RevenuePredictionUniqueWhere"] | undefined,
	create?: GraphQLTypes["RevenuePredictionWithoutChangesCreateInput"] | undefined
};
	["RevenuePredictionWithoutChangesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	name?: string | undefined,
	type?: GraphQLTypes["RevenuePredictionType"] | undefined,
	channel?: GraphQLTypes["RevenuePredictionCreateChannelEntityRelationInput"] | undefined,
	alwaysIncludeInTotalRevenue?: boolean | undefined,
	recurrencePeriod?: GraphQLTypes["RecurrencePeriod"] | undefined,
	monday?: boolean | undefined,
	tuesday?: boolean | undefined,
	wednesday?: boolean | undefined,
	thursday?: boolean | undefined,
	friday?: boolean | undefined,
	saturday?: boolean | undefined,
	sunday?: boolean | undefined,
	terms?: Array<GraphQLTypes["RevenuePredictionCreateTermsEntityRelationInput"]> | undefined,
	paymentMethod?: GraphQLTypes["RevenuePredictionCreatePaymentMethodEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RevenuePredictionChangeUpdateInput"]: {
		date?: GraphQLTypes["Date"] | undefined,
	amountCents?: number | undefined,
	prediction?: GraphQLTypes["RevenuePredictionChangeUpdatePredictionEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RevenuePredictionChangeUpdatePredictionEntityRelationInput"]: {
		create?: GraphQLTypes["RevenuePredictionWithoutChangesCreateInput"] | undefined,
	update?: GraphQLTypes["RevenuePredictionWithoutChangesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["RevenuePredictionChangeUpsertPredictionRelationInput"] | undefined,
	connect?: GraphQLTypes["RevenuePredictionUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["RevenuePredictionWithoutChangesUpdateInput"]: {
		name?: string | undefined,
	type?: GraphQLTypes["RevenuePredictionType"] | undefined,
	channel?: GraphQLTypes["RevenuePredictionUpdateChannelEntityRelationInput"] | undefined,
	alwaysIncludeInTotalRevenue?: boolean | undefined,
	recurrencePeriod?: GraphQLTypes["RecurrencePeriod"] | undefined,
	monday?: boolean | undefined,
	tuesday?: boolean | undefined,
	wednesday?: boolean | undefined,
	thursday?: boolean | undefined,
	friday?: boolean | undefined,
	saturday?: boolean | undefined,
	sunday?: boolean | undefined,
	terms?: Array<GraphQLTypes["RevenuePredictionUpdateTermsEntityRelationInput"]> | undefined,
	paymentMethod?: GraphQLTypes["RevenuePredictionUpdatePaymentMethodEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["RevenuePredictionChangeUpsertPredictionRelationInput"]: {
		update?: GraphQLTypes["RevenuePredictionWithoutChangesUpdateInput"] | undefined,
	create?: GraphQLTypes["RevenuePredictionWithoutChangesCreateInput"] | undefined
};
	["FileConnection"]: {
	__typename: "FileConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FileEdge"]>
};
	["FileEdge"]: {
	__typename: "FileEdge",
	node: GraphQLTypes["File"]
};
	["LineCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	positionStartX?: number | undefined,
	positionStartY?: number | undefined,
	positionEndX?: number | undefined,
	positionEndY?: number | undefined,
	area?: GraphQLTypes["LineCreateAreaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LineCreateAreaEntityRelationInput"]: {
		connect?: GraphQLTypes["AreaUniqueWhere"] | undefined,
	create?: GraphQLTypes["AreaWithoutLinesCreateInput"] | undefined
};
	["AreaWithoutLinesCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	order?: number | undefined,
	name?: string | undefined,
	venue?: GraphQLTypes["AreaCreateVenueEntityRelationInput"] | undefined,
	tables?: Array<GraphQLTypes["AreaCreateTablesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LineUpdateInput"]: {
		positionStartX?: number | undefined,
	positionStartY?: number | undefined,
	positionEndX?: number | undefined,
	positionEndY?: number | undefined,
	area?: GraphQLTypes["LineUpdateAreaEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["LineUpdateAreaEntityRelationInput"]: {
		create?: GraphQLTypes["AreaWithoutLinesCreateInput"] | undefined,
	update?: GraphQLTypes["AreaWithoutLinesUpdateInput"] | undefined,
	upsert?: GraphQLTypes["LineUpsertAreaRelationInput"] | undefined,
	connect?: GraphQLTypes["AreaUniqueWhere"] | undefined,
	delete?: boolean | undefined
};
	["AreaWithoutLinesUpdateInput"]: {
		order?: number | undefined,
	name?: string | undefined,
	venue?: GraphQLTypes["AreaUpdateVenueEntityRelationInput"] | undefined,
	tables?: Array<GraphQLTypes["AreaUpdateTablesEntityRelationInput"]> | undefined,
	_dummy_field_?: boolean | undefined
};
	["LineUpsertAreaRelationInput"]: {
		update?: GraphQLTypes["AreaWithoutLinesUpdateInput"] | undefined,
	create?: GraphQLTypes["AreaWithoutLinesCreateInput"] | undefined
};
	["FinancesBalanceItem"]: {
	__typename: "FinancesBalanceItem",
	_meta?: GraphQLTypes["FinancesBalanceItemMeta"] | undefined,
	id: GraphQLTypes["UUID"],
	amountCents: number,
	date: GraphQLTypes["Date"],
	venue?: GraphQLTypes["Venue"] | undefined,
	paidByCash: boolean
};
	["FinancesBalanceItemMeta"]: {
	__typename: "FinancesBalanceItemMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	amountCents?: GraphQLTypes["FieldMeta"] | undefined,
	date?: GraphQLTypes["FieldMeta"] | undefined,
	venue?: GraphQLTypes["FieldMeta"] | undefined,
	paidByCash?: GraphQLTypes["FieldMeta"] | undefined
};
	["FinancesBalanceItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"] | undefined
};
	["FinancesBalanceItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"] | undefined,
	amountCents?: GraphQLTypes["IntCondition"] | undefined,
	date?: GraphQLTypes["DateCondition"] | undefined,
	venue?: GraphQLTypes["VenueWhere"] | undefined,
	paidByCash?: GraphQLTypes["BooleanCondition"] | undefined,
	and?: Array<GraphQLTypes["FinancesBalanceItemWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["FinancesBalanceItemWhere"] | undefined> | undefined,
	not?: GraphQLTypes["FinancesBalanceItemWhere"] | undefined
};
	["FinancesBalanceItemOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	amountCents?: GraphQLTypes["OrderDirection"] | undefined,
	date?: GraphQLTypes["OrderDirection"] | undefined,
	venue?: GraphQLTypes["VenueOrderBy"] | undefined,
	paidByCash?: GraphQLTypes["OrderDirection"] | undefined
};
	["FinancesBalanceItemConnection"]: {
	__typename: "FinancesBalanceItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FinancesBalanceItemEdge"]>
};
	["FinancesBalanceItemEdge"]: {
	__typename: "FinancesBalanceItemEdge",
	node: GraphQLTypes["FinancesBalanceItem"]
};
	["FinancesBalanceItemCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	amountCents?: number | undefined,
	date?: GraphQLTypes["Date"] | undefined,
	venue?: GraphQLTypes["FinancesBalanceItemCreateVenueEntityRelationInput"] | undefined,
	paidByCash?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["FinancesBalanceItemCreateVenueEntityRelationInput"]: {
		connect?: GraphQLTypes["VenueUniqueWhere"] | undefined,
	create?: GraphQLTypes["VenueCreateInput"] | undefined
};
	["FinancesBalanceItemUpdateInput"]: {
		amountCents?: number | undefined,
	date?: GraphQLTypes["Date"] | undefined,
	venue?: GraphQLTypes["FinancesBalanceItemUpdateVenueEntityRelationInput"] | undefined,
	paidByCash?: boolean | undefined,
	_dummy_field_?: boolean | undefined
};
	["FinancesBalanceItemUpdateVenueEntityRelationInput"]: {
		create?: GraphQLTypes["VenueCreateInput"] | undefined,
	update?: GraphQLTypes["VenueUpdateInput"] | undefined,
	upsert?: GraphQLTypes["FinancesBalanceItemUpsertVenueRelationInput"] | undefined,
	connect?: GraphQLTypes["VenueUniqueWhere"] | undefined
};
	["FinancesBalanceItemUpsertVenueRelationInput"]: {
		update?: GraphQLTypes["VenueUpdateInput"] | undefined,
	create?: GraphQLTypes["VenueCreateInput"] | undefined
};
	["OrderPaymentStatsByDay"]: {
	__typename: "OrderPaymentStatsByDay",
	_meta?: GraphQLTypes["OrderPaymentStatsByDayMeta"] | undefined,
	id: string,
	day: GraphQLTypes["Date"],
	totalGratuityCents: number,
	reducedGratuityCents: number,
	channel?: GraphQLTypes["Channel"] | undefined,
	paymentMethod?: GraphQLTypes["PaymentMethod"] | undefined
};
	["OrderPaymentStatsByDayMeta"]: {
	__typename: "OrderPaymentStatsByDayMeta",
	id?: GraphQLTypes["FieldMeta"] | undefined,
	day?: GraphQLTypes["FieldMeta"] | undefined,
	totalGratuityCents?: GraphQLTypes["FieldMeta"] | undefined,
	reducedGratuityCents?: GraphQLTypes["FieldMeta"] | undefined,
	channel?: GraphQLTypes["FieldMeta"] | undefined,
	paymentMethod?: GraphQLTypes["FieldMeta"] | undefined
};
	["OrderPaymentStatsByDayUniqueWhere"]: {
		id?: string | undefined
};
	["OrderPaymentStatsByDayWhere"]: {
		id?: GraphQLTypes["StringCondition"] | undefined,
	day?: GraphQLTypes["DateCondition"] | undefined,
	totalGratuityCents?: GraphQLTypes["IntCondition"] | undefined,
	reducedGratuityCents?: GraphQLTypes["IntCondition"] | undefined,
	channel?: GraphQLTypes["ChannelWhere"] | undefined,
	paymentMethod?: GraphQLTypes["PaymentMethodWhere"] | undefined,
	and?: Array<GraphQLTypes["OrderPaymentStatsByDayWhere"] | undefined> | undefined,
	or?: Array<GraphQLTypes["OrderPaymentStatsByDayWhere"] | undefined> | undefined,
	not?: GraphQLTypes["OrderPaymentStatsByDayWhere"] | undefined
};
	["OrderPaymentStatsByDayOrderBy"]: {
		_random?: boolean | undefined,
	_randomSeeded?: number | undefined,
	id?: GraphQLTypes["OrderDirection"] | undefined,
	day?: GraphQLTypes["OrderDirection"] | undefined,
	totalGratuityCents?: GraphQLTypes["OrderDirection"] | undefined,
	reducedGratuityCents?: GraphQLTypes["OrderDirection"] | undefined,
	channel?: GraphQLTypes["ChannelOrderBy"] | undefined,
	paymentMethod?: GraphQLTypes["PaymentMethodOrderBy"] | undefined
};
	["OrderPaymentStatsByDayConnection"]: {
	__typename: "OrderPaymentStatsByDayConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["OrderPaymentStatsByDayEdge"]>
};
	["OrderPaymentStatsByDayEdge"]: {
	__typename: "OrderPaymentStatsByDayEdge",
	node: GraphQLTypes["OrderPaymentStatsByDay"]
};
	["WoltDriveDeliveryConnection"]: {
	__typename: "WoltDriveDeliveryConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["WoltDriveDeliveryEdge"]>
};
	["WoltDriveDeliveryEdge"]: {
	__typename: "WoltDriveDeliveryEdge",
	node: GraphQLTypes["WoltDriveDelivery"]
};
	["WoltDriveDeliveryCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	state?: GraphQLTypes["WoltDriveDeliveryState"] | undefined,
	shipmentPromiseId?: string | undefined,
	deliveryPrice?: number | undefined,
	deliveryPriceCurrency?: string | undefined,
	shipmentPromiseResponse?: string | undefined,
	deliveryOrderId?: string | undefined,
	trackingUrl?: string | undefined,
	deliverOrderResponse?: string | undefined,
	delivery?: GraphQLTypes["WoltDriveDeliveryCreateDeliveryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["WoltDriveDeliveryCreateDeliveryEntityRelationInput"]: {
		connect?: GraphQLTypes["OrderDeliveryUniqueWhere"] | undefined,
	create?: GraphQLTypes["OrderDeliveryWithoutWoltDriveDeliveryCreateInput"] | undefined
};
	["OrderDeliveryWithoutWoltDriveDeliveryCreateInput"]: {
		id?: GraphQLTypes["UUID"] | undefined,
	priceCents?: number | undefined,
	deliveredAt?: GraphQLTypes["DateTime"] | undefined,
	method?: GraphQLTypes["OrderDeliveryCreateMethodEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["OrderDeliveryCreateVatRateEntityRelationInput"] | undefined,
	order?: GraphQLTypes["OrderDeliveryCreateOrderEntityRelationInput"] | undefined,
	expectedAt?: GraphQLTypes["DateTime"] | undefined,
	state?: GraphQLTypes["OrderDeliveryState"] | undefined,
	loadingDurationHours?: number | undefined,
	dispatchAt?: GraphQLTypes["DateTime"] | undefined,
	duration?: string | undefined,
	window?: string | undefined,
	expectedEndAt?: GraphQLTypes["DateTime"] | undefined,
	processingAt?: GraphQLTypes["DateTime"] | undefined,
	deliveringAt?: GraphQLTypes["DateTime"] | undefined,
	failedAt?: GraphQLTypes["DateTime"] | undefined,
	internalNote?: string | undefined,
	deliveryWaypoint?: GraphQLTypes["OrderDeliveryCreateDeliveryWaypointEntityRelationInput"] | undefined,
	events?: Array<GraphQLTypes["OrderDeliveryCreateEventsEntityRelationInput"]> | undefined,
	prepareAt?: GraphQLTypes["DateTime"] | undefined,
	liftagoRide?: GraphQLTypes["OrderDeliveryCreateLiftagoRideEntityRelationInput"] | undefined,
	pickedAt?: GraphQLTypes["DateTime"] | undefined,
	address?: GraphQLTypes["OrderDeliveryCreateAddressEntityRelationInput"] | undefined,
	trackingCode?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["WoltDriveDeliveryUpdateInput"]: {
		state?: GraphQLTypes["WoltDriveDeliveryState"] | undefined,
	shipmentPromiseId?: string | undefined,
	deliveryPrice?: number | undefined,
	deliveryPriceCurrency?: string | undefined,
	shipmentPromiseResponse?: string | undefined,
	deliveryOrderId?: string | undefined,
	trackingUrl?: string | undefined,
	deliverOrderResponse?: string | undefined,
	delivery?: GraphQLTypes["WoltDriveDeliveryUpdateDeliveryEntityRelationInput"] | undefined,
	_dummy_field_?: boolean | undefined
};
	["WoltDriveDeliveryUpdateDeliveryEntityRelationInput"]: {
		create?: GraphQLTypes["OrderDeliveryWithoutWoltDriveDeliveryCreateInput"] | undefined,
	update?: GraphQLTypes["OrderDeliveryWithoutWoltDriveDeliveryUpdateInput"] | undefined,
	upsert?: GraphQLTypes["WoltDriveDeliveryUpsertDeliveryRelationInput"] | undefined,
	connect?: GraphQLTypes["OrderDeliveryUniqueWhere"] | undefined,
	disconnect?: boolean | undefined,
	delete?: boolean | undefined
};
	["OrderDeliveryWithoutWoltDriveDeliveryUpdateInput"]: {
		priceCents?: number | undefined,
	deliveredAt?: GraphQLTypes["DateTime"] | undefined,
	method?: GraphQLTypes["OrderDeliveryUpdateMethodEntityRelationInput"] | undefined,
	vatRate?: GraphQLTypes["OrderDeliveryUpdateVatRateEntityRelationInput"] | undefined,
	order?: GraphQLTypes["OrderDeliveryUpdateOrderEntityRelationInput"] | undefined,
	expectedAt?: GraphQLTypes["DateTime"] | undefined,
	state?: GraphQLTypes["OrderDeliveryState"] | undefined,
	loadingDurationHours?: number | undefined,
	dispatchAt?: GraphQLTypes["DateTime"] | undefined,
	duration?: string | undefined,
	window?: string | undefined,
	expectedEndAt?: GraphQLTypes["DateTime"] | undefined,
	processingAt?: GraphQLTypes["DateTime"] | undefined,
	deliveringAt?: GraphQLTypes["DateTime"] | undefined,
	failedAt?: GraphQLTypes["DateTime"] | undefined,
	internalNote?: string | undefined,
	deliveryWaypoint?: GraphQLTypes["OrderDeliveryUpdateDeliveryWaypointEntityRelationInput"] | undefined,
	events?: Array<GraphQLTypes["OrderDeliveryUpdateEventsEntityRelationInput"]> | undefined,
	prepareAt?: GraphQLTypes["DateTime"] | undefined,
	liftagoRide?: GraphQLTypes["OrderDeliveryUpdateLiftagoRideEntityRelationInput"] | undefined,
	pickedAt?: GraphQLTypes["DateTime"] | undefined,
	address?: GraphQLTypes["OrderDeliveryUpdateAddressEntityRelationInput"] | undefined,
	trackingCode?: string | undefined,
	_dummy_field_?: boolean | undefined
};
	["WoltDriveDeliveryUpsertDeliveryRelationInput"]: {
		update?: GraphQLTypes["OrderDeliveryWithoutWoltDriveDeliveryUpdateInput"] | undefined,
	create?: GraphQLTypes["OrderDeliveryWithoutWoltDriveDeliveryCreateInput"] | undefined
};
	["QueryTransaction"]: {
	__typename: "QueryTransaction",
	getAddress?: GraphQLTypes["Address"] | undefined,
	listAddress: Array<GraphQLTypes["Address"]>,
	paginateAddress: GraphQLTypes["AddressConnection"],
	validateCreateAddress: GraphQLTypes["_ValidationResult"],
	validateUpdateAddress: GraphQLTypes["_ValidationResult"],
	getCountry?: GraphQLTypes["Country"] | undefined,
	listCountry: Array<GraphQLTypes["Country"]>,
	paginateCountry: GraphQLTypes["CountryConnection"],
	validateCreateCountry: GraphQLTypes["_ValidationResult"],
	validateUpdateCountry: GraphQLTypes["_ValidationResult"],
	getChannel?: GraphQLTypes["Channel"] | undefined,
	listChannel: Array<GraphQLTypes["Channel"]>,
	paginateChannel: GraphQLTypes["ChannelConnection"],
	validateCreateChannel: GraphQLTypes["_ValidationResult"],
	validateUpdateChannel: GraphQLTypes["_ValidationResult"],
	getChannelPayment?: GraphQLTypes["ChannelPayment"] | undefined,
	listChannelPayment: Array<GraphQLTypes["ChannelPayment"]>,
	paginateChannelPayment: GraphQLTypes["ChannelPaymentConnection"],
	validateCreateChannelPayment: GraphQLTypes["_ValidationResult"],
	validateUpdateChannelPayment: GraphQLTypes["_ValidationResult"],
	getChannelDelivery?: GraphQLTypes["ChannelDelivery"] | undefined,
	listChannelDelivery: Array<GraphQLTypes["ChannelDelivery"]>,
	paginateChannelDelivery: GraphQLTypes["ChannelDeliveryConnection"],
	validateCreateChannelDelivery: GraphQLTypes["_ValidationResult"],
	validateUpdateChannelDelivery: GraphQLTypes["_ValidationResult"],
	getCustomer?: GraphQLTypes["Customer"] | undefined,
	listCustomer: Array<GraphQLTypes["Customer"]>,
	paginateCustomer: GraphQLTypes["CustomerConnection"],
	validateCreateCustomer: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomer: GraphQLTypes["_ValidationResult"],
	getCustomerCredit?: GraphQLTypes["CustomerCredit"] | undefined,
	listCustomerCredit: Array<GraphQLTypes["CustomerCredit"]>,
	paginateCustomerCredit: GraphQLTypes["CustomerCreditConnection"],
	validateCreateCustomerCredit: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomerCredit: GraphQLTypes["_ValidationResult"],
	getCustomerGroup?: GraphQLTypes["CustomerGroup"] | undefined,
	listCustomerGroup: Array<GraphQLTypes["CustomerGroup"]>,
	paginateCustomerGroup: GraphQLTypes["CustomerGroupConnection"],
	validateCreateCustomerGroup: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomerGroup: GraphQLTypes["_ValidationResult"],
	getCustomerPaymentMethod?: GraphQLTypes["CustomerPaymentMethod"] | undefined,
	listCustomerPaymentMethod: Array<GraphQLTypes["CustomerPaymentMethod"]>,
	paginateCustomerPaymentMethod: GraphQLTypes["CustomerPaymentMethodConnection"],
	validateCreateCustomerPaymentMethod: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomerPaymentMethod: GraphQLTypes["_ValidationResult"],
	getDeliveryMethod?: GraphQLTypes["DeliveryMethod"] | undefined,
	listDeliveryMethod: Array<GraphQLTypes["DeliveryMethod"]>,
	paginateDeliveryMethod: GraphQLTypes["DeliveryMethodConnection"],
	validateCreateDeliveryMethod: GraphQLTypes["_ValidationResult"],
	validateUpdateDeliveryMethod: GraphQLTypes["_ValidationResult"],
	getOrder?: GraphQLTypes["Order"] | undefined,
	listOrder: Array<GraphQLTypes["Order"]>,
	paginateOrder: GraphQLTypes["OrderConnection"],
	validateCreateOrder: GraphQLTypes["_ValidationResult"],
	validateUpdateOrder: GraphQLTypes["_ValidationResult"],
	getOrderDiscount?: GraphQLTypes["OrderDiscount"] | undefined,
	listOrderDiscount: Array<GraphQLTypes["OrderDiscount"]>,
	paginateOrderDiscount: GraphQLTypes["OrderDiscountConnection"],
	validateCreateOrderDiscount: GraphQLTypes["_ValidationResult"],
	validateUpdateOrderDiscount: GraphQLTypes["_ValidationResult"],
	getOrderPayment?: GraphQLTypes["OrderPayment"] | undefined,
	listOrderPayment: Array<GraphQLTypes["OrderPayment"]>,
	paginateOrderPayment: GraphQLTypes["OrderPaymentConnection"],
	validateCreateOrderPayment: GraphQLTypes["_ValidationResult"],
	validateUpdateOrderPayment: GraphQLTypes["_ValidationResult"],
	getOrderDelivery?: GraphQLTypes["OrderDelivery"] | undefined,
	listOrderDelivery: Array<GraphQLTypes["OrderDelivery"]>,
	paginateOrderDelivery: GraphQLTypes["OrderDeliveryConnection"],
	validateCreateOrderDelivery: GraphQLTypes["_ValidationResult"],
	validateUpdateOrderDelivery: GraphQLTypes["_ValidationResult"],
	getOrderItem?: GraphQLTypes["OrderItem"] | undefined,
	listOrderItem: Array<GraphQLTypes["OrderItem"]>,
	paginateOrderItem: GraphQLTypes["OrderItemConnection"],
	validateCreateOrderItem: GraphQLTypes["_ValidationResult"],
	validateUpdateOrderItem: GraphQLTypes["_ValidationResult"],
	getPaymentMethod?: GraphQLTypes["PaymentMethod"] | undefined,
	listPaymentMethod: Array<GraphQLTypes["PaymentMethod"]>,
	paginatePaymentMethod: GraphQLTypes["PaymentMethodConnection"],
	validateCreatePaymentMethod: GraphQLTypes["_ValidationResult"],
	validateUpdatePaymentMethod: GraphQLTypes["_ValidationResult"],
	getVatRate?: GraphQLTypes["VatRate"] | undefined,
	listVatRate: Array<GraphQLTypes["VatRate"]>,
	paginateVatRate: GraphQLTypes["VatRateConnection"],
	validateCreateVatRate: GraphQLTypes["_ValidationResult"],
	validateUpdateVatRate: GraphQLTypes["_ValidationResult"],
	getProduct?: GraphQLTypes["Product"] | undefined,
	listProduct: Array<GraphQLTypes["Product"]>,
	paginateProduct: GraphQLTypes["ProductConnection"],
	validateCreateProduct: GraphQLTypes["_ValidationResult"],
	validateUpdateProduct: GraphQLTypes["_ValidationResult"],
	getProductStock?: GraphQLTypes["ProductStock"] | undefined,
	listProductStock: Array<GraphQLTypes["ProductStock"]>,
	paginateProductStock: GraphQLTypes["ProductStockConnection"],
	validateCreateProductStock: GraphQLTypes["_ValidationResult"],
	validateUpdateProductStock: GraphQLTypes["_ValidationResult"],
	getProductPacking?: GraphQLTypes["ProductPacking"] | undefined,
	listProductPacking: Array<GraphQLTypes["ProductPacking"]>,
	paginateProductPacking: GraphQLTypes["ProductPackingConnection"],
	validateCreateProductPacking: GraphQLTypes["_ValidationResult"],
	validateUpdateProductPacking: GraphQLTypes["_ValidationResult"],
	getProductGroupPrice?: GraphQLTypes["ProductGroupPrice"] | undefined,
	listProductGroupPrice: Array<GraphQLTypes["ProductGroupPrice"]>,
	paginateProductGroupPrice: GraphQLTypes["ProductGroupPriceConnection"],
	validateCreateProductGroupPrice: GraphQLTypes["_ValidationResult"],
	validateUpdateProductGroupPrice: GraphQLTypes["_ValidationResult"],
	getProductRecipe?: GraphQLTypes["ProductRecipe"] | undefined,
	listProductRecipe: Array<GraphQLTypes["ProductRecipe"]>,
	paginateProductRecipe: GraphQLTypes["ProductRecipeConnection"],
	validateCreateProductRecipe: GraphQLTypes["_ValidationResult"],
	validateUpdateProductRecipe: GraphQLTypes["_ValidationResult"],
	getProductCategory?: GraphQLTypes["ProductCategory"] | undefined,
	listProductCategory: Array<GraphQLTypes["ProductCategory"]>,
	paginateProductCategory: GraphQLTypes["ProductCategoryConnection"],
	validateCreateProductCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateProductCategory: GraphQLTypes["_ValidationResult"],
	getStore?: GraphQLTypes["Store"] | undefined,
	listStore: Array<GraphQLTypes["Store"]>,
	paginateStore: GraphQLTypes["StoreConnection"],
	validateCreateStore: GraphQLTypes["_ValidationResult"],
	validateUpdateStore: GraphQLTypes["_ValidationResult"],
	getTag?: GraphQLTypes["Tag"] | undefined,
	listTag: Array<GraphQLTypes["Tag"]>,
	paginateTag: GraphQLTypes["TagConnection"],
	validateCreateTag: GraphQLTypes["_ValidationResult"],
	validateUpdateTag: GraphQLTypes["_ValidationResult"],
	getCustomerPermissions?: GraphQLTypes["CustomerPermissions"] | undefined,
	listCustomerPermissions: Array<GraphQLTypes["CustomerPermissions"]>,
	paginateCustomerPermissions: GraphQLTypes["CustomerPermissionsConnection"],
	getImage?: GraphQLTypes["Image"] | undefined,
	listImage: Array<GraphQLTypes["Image"]>,
	paginateImage: GraphQLTypes["ImageConnection"],
	validateCreateImage: GraphQLTypes["_ValidationResult"],
	validateUpdateImage: GraphQLTypes["_ValidationResult"],
	getBusinessCategory?: GraphQLTypes["BusinessCategory"] | undefined,
	listBusinessCategory: Array<GraphQLTypes["BusinessCategory"]>,
	paginateBusinessCategory: GraphQLTypes["BusinessCategoryConnection"],
	validateCreateBusinessCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateBusinessCategory: GraphQLTypes["_ValidationResult"],
	getProductList?: GraphQLTypes["ProductList"] | undefined,
	listProductList: Array<GraphQLTypes["ProductList"]>,
	paginateProductList: GraphQLTypes["ProductListConnection"],
	validateCreateProductList: GraphQLTypes["_ValidationResult"],
	validateUpdateProductList: GraphQLTypes["_ValidationResult"],
	getProductListItem?: GraphQLTypes["ProductListItem"] | undefined,
	listProductListItem: Array<GraphQLTypes["ProductListItem"]>,
	paginateProductListItem: GraphQLTypes["ProductListItemConnection"],
	validateCreateProductListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateProductListItem: GraphQLTypes["_ValidationResult"],
	getProductCategoryList?: GraphQLTypes["ProductCategoryList"] | undefined,
	listProductCategoryList: Array<GraphQLTypes["ProductCategoryList"]>,
	paginateProductCategoryList: GraphQLTypes["ProductCategoryListConnection"],
	validateCreateProductCategoryList: GraphQLTypes["_ValidationResult"],
	validateUpdateProductCategoryList: GraphQLTypes["_ValidationResult"],
	getProductCategoryListItem?: GraphQLTypes["ProductCategoryListItem"] | undefined,
	listProductCategoryListItem: Array<GraphQLTypes["ProductCategoryListItem"]>,
	paginateProductCategoryListItem: GraphQLTypes["ProductCategoryListItemConnection"],
	validateCreateProductCategoryListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateProductCategoryListItem: GraphQLTypes["_ValidationResult"],
	getBusinessCategoryLocale?: GraphQLTypes["BusinessCategoryLocale"] | undefined,
	listBusinessCategoryLocale: Array<GraphQLTypes["BusinessCategoryLocale"]>,
	paginateBusinessCategoryLocale: GraphQLTypes["BusinessCategoryLocaleConnection"],
	validateCreateBusinessCategoryLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateBusinessCategoryLocale: GraphQLTypes["_ValidationResult"],
	getLocale?: GraphQLTypes["Locale"] | undefined,
	listLocale: Array<GraphQLTypes["Locale"]>,
	paginateLocale: GraphQLTypes["LocaleConnection"],
	validateCreateLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateLocale: GraphQLTypes["_ValidationResult"],
	getProductCategoryListLocale?: GraphQLTypes["ProductCategoryListLocale"] | undefined,
	listProductCategoryListLocale: Array<GraphQLTypes["ProductCategoryListLocale"]>,
	paginateProductCategoryListLocale: GraphQLTypes["ProductCategoryListLocaleConnection"],
	validateCreateProductCategoryListLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateProductCategoryListLocale: GraphQLTypes["_ValidationResult"],
	getCustomerName?: GraphQLTypes["CustomerName"] | undefined,
	listCustomerName: Array<GraphQLTypes["CustomerName"]>,
	paginateCustomerName: GraphQLTypes["CustomerNameConnection"],
	validateCreateCustomerName: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomerName: GraphQLTypes["_ValidationResult"],
	getCustomerAlias?: GraphQLTypes["CustomerAlias"] | undefined,
	listCustomerAlias: Array<GraphQLTypes["CustomerAlias"]>,
	paginateCustomerAlias: GraphQLTypes["CustomerAliasConnection"],
	validateCreateCustomerAlias: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomerAlias: GraphQLTypes["_ValidationResult"],
	getProductIngredientItem?: GraphQLTypes["ProductIngredientItem"] | undefined,
	listProductIngredientItem: Array<GraphQLTypes["ProductIngredientItem"]>,
	paginateProductIngredientItem: GraphQLTypes["ProductIngredientItemConnection"],
	validateCreateProductIngredientItem: GraphQLTypes["_ValidationResult"],
	validateUpdateProductIngredientItem: GraphQLTypes["_ValidationResult"],
	getProductIngredientItemQuantity?: GraphQLTypes["ProductIngredientItemQuantity"] | undefined,
	listProductIngredientItemQuantity: Array<GraphQLTypes["ProductIngredientItemQuantity"]>,
	paginateProductIngredientItemQuantity: GraphQLTypes["ProductIngredientItemQuantityConnection"],
	validateCreateProductIngredientItemQuantity: GraphQLTypes["_ValidationResult"],
	validateUpdateProductIngredientItemQuantity: GraphQLTypes["_ValidationResult"],
	getProductIngredientItemQuantityUnit?: GraphQLTypes["ProductIngredientItemQuantityUnit"] | undefined,
	listProductIngredientItemQuantityUnit: Array<GraphQLTypes["ProductIngredientItemQuantityUnit"]>,
	paginateProductIngredientItemQuantityUnit: GraphQLTypes["ProductIngredientItemQuantityUnitConnection"],
	validateCreateProductIngredientItemQuantityUnit: GraphQLTypes["_ValidationResult"],
	validateUpdateProductIngredientItemQuantityUnit: GraphQLTypes["_ValidationResult"],
	getProductIngredient?: GraphQLTypes["ProductIngredient"] | undefined,
	listProductIngredient: Array<GraphQLTypes["ProductIngredient"]>,
	paginateProductIngredient: GraphQLTypes["ProductIngredientConnection"],
	validateCreateProductIngredient: GraphQLTypes["_ValidationResult"],
	validateUpdateProductIngredient: GraphQLTypes["_ValidationResult"],
	getCustomerIngredientRating?: GraphQLTypes["CustomerIngredientRating"] | undefined,
	listCustomerIngredientRating: Array<GraphQLTypes["CustomerIngredientRating"]>,
	paginateCustomerIngredientRating: GraphQLTypes["CustomerIngredientRatingConnection"],
	validateCreateCustomerIngredientRating: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomerIngredientRating: GraphQLTypes["_ValidationResult"],
	getProductIngredientRating?: GraphQLTypes["ProductIngredientRating"] | undefined,
	listProductIngredientRating: Array<GraphQLTypes["ProductIngredientRating"]>,
	paginateProductIngredientRating: GraphQLTypes["ProductIngredientRatingConnection"],
	validateCreateProductIngredientRating: GraphQLTypes["_ValidationResult"],
	validateUpdateProductIngredientRating: GraphQLTypes["_ValidationResult"],
	getProductIngredientLocale?: GraphQLTypes["ProductIngredientLocale"] | undefined,
	listProductIngredientLocale: Array<GraphQLTypes["ProductIngredientLocale"]>,
	paginateProductIngredientLocale: GraphQLTypes["ProductIngredientLocaleConnection"],
	validateCreateProductIngredientLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateProductIngredientLocale: GraphQLTypes["_ValidationResult"],
	getOrderRecurrence?: GraphQLTypes["OrderRecurrence"] | undefined,
	listOrderRecurrence: Array<GraphQLTypes["OrderRecurrence"]>,
	paginateOrderRecurrence: GraphQLTypes["OrderRecurrenceConnection"],
	validateCreateOrderRecurrence: GraphQLTypes["_ValidationResult"],
	validateUpdateOrderRecurrence: GraphQLTypes["_ValidationResult"],
	getOrderRecurrenceLocale?: GraphQLTypes["OrderRecurrenceLocale"] | undefined,
	listOrderRecurrenceLocale: Array<GraphQLTypes["OrderRecurrenceLocale"]>,
	paginateOrderRecurrenceLocale: GraphQLTypes["OrderRecurrenceLocaleConnection"],
	validateCreateOrderRecurrenceLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateOrderRecurrenceLocale: GraphQLTypes["_ValidationResult"],
	getBusinessCustomer?: GraphQLTypes["BusinessCustomer"] | undefined,
	listBusinessCustomer: Array<GraphQLTypes["BusinessCustomer"]>,
	paginateBusinessCustomer: GraphQLTypes["BusinessCustomerConnection"],
	validateCreateBusinessCustomer: GraphQLTypes["_ValidationResult"],
	validateUpdateBusinessCustomer: GraphQLTypes["_ValidationResult"],
	getPointOfSale?: GraphQLTypes["PointOfSale"] | undefined,
	listPointOfSale: Array<GraphQLTypes["PointOfSale"]>,
	paginatePointOfSale: GraphQLTypes["PointOfSaleConnection"],
	validateCreatePointOfSale: GraphQLTypes["_ValidationResult"],
	validateUpdatePointOfSale: GraphQLTypes["_ValidationResult"],
	getStaff?: GraphQLTypes["Staff"] | undefined,
	listStaff: Array<GraphQLTypes["Staff"]>,
	paginateStaff: GraphQLTypes["StaffConnection"],
	validateCreateStaff: GraphQLTypes["_ValidationResult"],
	validateUpdateStaff: GraphQLTypes["_ValidationResult"],
	getPointOfSalePermissions?: GraphQLTypes["PointOfSalePermissions"] | undefined,
	listPointOfSalePermissions: Array<GraphQLTypes["PointOfSalePermissions"]>,
	paginatePointOfSalePermissions: GraphQLTypes["PointOfSalePermissionsConnection"],
	getBlog?: GraphQLTypes["Blog"] | undefined,
	listBlog: Array<GraphQLTypes["Blog"]>,
	paginateBlog: GraphQLTypes["BlogConnection"],
	validateCreateBlog: GraphQLTypes["_ValidationResult"],
	validateUpdateBlog: GraphQLTypes["_ValidationResult"],
	getBlogLocale?: GraphQLTypes["BlogLocale"] | undefined,
	listBlogLocale: Array<GraphQLTypes["BlogLocale"]>,
	paginateBlogLocale: GraphQLTypes["BlogLocaleConnection"],
	validateCreateBlogLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateBlogLocale: GraphQLTypes["_ValidationResult"],
	getBlogPost?: GraphQLTypes["BlogPost"] | undefined,
	listBlogPost: Array<GraphQLTypes["BlogPost"]>,
	paginateBlogPost: GraphQLTypes["BlogPostConnection"],
	validateCreateBlogPost: GraphQLTypes["_ValidationResult"],
	validateUpdateBlogPost: GraphQLTypes["_ValidationResult"],
	getBlogPostLocale?: GraphQLTypes["BlogPostLocale"] | undefined,
	listBlogPostLocale: Array<GraphQLTypes["BlogPostLocale"]>,
	paginateBlogPostLocale: GraphQLTypes["BlogPostLocaleConnection"],
	validateCreateBlogPostLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateBlogPostLocale: GraphQLTypes["_ValidationResult"],
	getColorPallete?: GraphQLTypes["ColorPallete"] | undefined,
	listColorPallete: Array<GraphQLTypes["ColorPallete"]>,
	paginateColorPallete: GraphQLTypes["ColorPalleteConnection"],
	validateCreateColorPallete: GraphQLTypes["_ValidationResult"],
	validateUpdateColorPallete: GraphQLTypes["_ValidationResult"],
	getContent?: GraphQLTypes["Content"] | undefined,
	listContent: Array<GraphQLTypes["Content"]>,
	paginateContent: GraphQLTypes["ContentConnection"],
	validateCreateContent: GraphQLTypes["_ValidationResult"],
	validateUpdateContent: GraphQLTypes["_ValidationResult"],
	getContentBlock?: GraphQLTypes["ContentBlock"] | undefined,
	listContentBlock: Array<GraphQLTypes["ContentBlock"]>,
	paginateContentBlock: GraphQLTypes["ContentBlockConnection"],
	validateCreateContentBlock: GraphQLTypes["_ValidationResult"],
	validateUpdateContentBlock: GraphQLTypes["_ValidationResult"],
	getContentReference?: GraphQLTypes["ContentReference"] | undefined,
	listContentReference: Array<GraphQLTypes["ContentReference"]>,
	paginateContentReference: GraphQLTypes["ContentReferenceConnection"],
	validateCreateContentReference: GraphQLTypes["_ValidationResult"],
	validateUpdateContentReference: GraphQLTypes["_ValidationResult"],
	getBlogPostList?: GraphQLTypes["BlogPostList"] | undefined,
	listBlogPostList: Array<GraphQLTypes["BlogPostList"]>,
	paginateBlogPostList: GraphQLTypes["BlogPostListConnection"],
	validateCreateBlogPostList: GraphQLTypes["_ValidationResult"],
	validateUpdateBlogPostList: GraphQLTypes["_ValidationResult"],
	getBlogPostListItem?: GraphQLTypes["BlogPostListItem"] | undefined,
	listBlogPostListItem: Array<GraphQLTypes["BlogPostListItem"]>,
	paginateBlogPostListItem: GraphQLTypes["BlogPostListItemConnection"],
	validateCreateBlogPostListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateBlogPostListItem: GraphQLTypes["_ValidationResult"],
	getLinkList?: GraphQLTypes["LinkList"] | undefined,
	listLinkList: Array<GraphQLTypes["LinkList"]>,
	paginateLinkList: GraphQLTypes["LinkListConnection"],
	validateCreateLinkList: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkList: GraphQLTypes["_ValidationResult"],
	getLinkListItem?: GraphQLTypes["LinkListItem"] | undefined,
	listLinkListItem: Array<GraphQLTypes["LinkListItem"]>,
	paginateLinkListItem: GraphQLTypes["LinkListItemConnection"],
	validateCreateLinkListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkListItem: GraphQLTypes["_ValidationResult"],
	getCover?: GraphQLTypes["Cover"] | undefined,
	listCover: Array<GraphQLTypes["Cover"]>,
	paginateCover: GraphQLTypes["CoverConnection"],
	validateCreateCover: GraphQLTypes["_ValidationResult"],
	validateUpdateCover: GraphQLTypes["_ValidationResult"],
	getLink?: GraphQLTypes["Link"] | undefined,
	listLink: Array<GraphQLTypes["Link"]>,
	paginateLink: GraphQLTypes["LinkConnection"],
	validateCreateLink: GraphQLTypes["_ValidationResult"],
	validateUpdateLink: GraphQLTypes["_ValidationResult"],
	getLinkable?: GraphQLTypes["Linkable"] | undefined,
	listLinkable: Array<GraphQLTypes["Linkable"]>,
	paginateLinkable: GraphQLTypes["LinkableConnection"],
	validateCreateLinkable: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkable: GraphQLTypes["_ValidationResult"],
	getMedium?: GraphQLTypes["Medium"] | undefined,
	listMedium: Array<GraphQLTypes["Medium"]>,
	paginateMedium: GraphQLTypes["MediumConnection"],
	validateCreateMedium: GraphQLTypes["_ValidationResult"],
	validateUpdateMedium: GraphQLTypes["_ValidationResult"],
	getVideo?: GraphQLTypes["Video"] | undefined,
	listVideo: Array<GraphQLTypes["Video"]>,
	paginateVideo: GraphQLTypes["VideoConnection"],
	validateCreateVideo: GraphQLTypes["_ValidationResult"],
	validateUpdateVideo: GraphQLTypes["_ValidationResult"],
	getSeo?: GraphQLTypes["Seo"] | undefined,
	listSeo: Array<GraphQLTypes["Seo"]>,
	paginateSeo: GraphQLTypes["SeoConnection"],
	validateCreateSeo: GraphQLTypes["_ValidationResult"],
	validateUpdateSeo: GraphQLTypes["_ValidationResult"],
	getProtectedImage?: GraphQLTypes["ProtectedImage"] | undefined,
	listProtectedImage: Array<GraphQLTypes["ProtectedImage"]>,
	paginateProtectedImage: GraphQLTypes["ProtectedImageConnection"],
	validateCreateProtectedImage: GraphQLTypes["_ValidationResult"],
	validateUpdateProtectedImage: GraphQLTypes["_ValidationResult"],
	getTranslationDomain?: GraphQLTypes["TranslationDomain"] | undefined,
	listTranslationDomain: Array<GraphQLTypes["TranslationDomain"]>,
	paginateTranslationDomain: GraphQLTypes["TranslationDomainConnection"],
	validateCreateTranslationDomain: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationDomain: GraphQLTypes["_ValidationResult"],
	getTranslationCatalogue?: GraphQLTypes["TranslationCatalogue"] | undefined,
	listTranslationCatalogue: Array<GraphQLTypes["TranslationCatalogue"]>,
	paginateTranslationCatalogue: GraphQLTypes["TranslationCatalogueConnection"],
	validateCreateTranslationCatalogue: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationCatalogue: GraphQLTypes["_ValidationResult"],
	getTranslationKey?: GraphQLTypes["TranslationKey"] | undefined,
	listTranslationKey: Array<GraphQLTypes["TranslationKey"]>,
	paginateTranslationKey: GraphQLTypes["TranslationKeyConnection"],
	validateCreateTranslationKey: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationKey: GraphQLTypes["_ValidationResult"],
	getTranslationValue?: GraphQLTypes["TranslationValue"] | undefined,
	listTranslationValue: Array<GraphQLTypes["TranslationValue"]>,
	paginateTranslationValue: GraphQLTypes["TranslationValueConnection"],
	validateCreateTranslationValue: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationValue: GraphQLTypes["_ValidationResult"],
	getTranslationCataloguesIdentifier?: GraphQLTypes["TranslationCataloguesIdentifier"] | undefined,
	listTranslationCataloguesIdentifier: Array<GraphQLTypes["TranslationCataloguesIdentifier"]>,
	paginateTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierConnection"],
	validateCreateTranslationCataloguesIdentifier: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationCataloguesIdentifier: GraphQLTypes["_ValidationResult"],
	getSocialsAndApps?: GraphQLTypes["SocialsAndApps"] | undefined,
	listSocialsAndApps: Array<GraphQLTypes["SocialsAndApps"]>,
	paginateSocialsAndApps: GraphQLTypes["SocialsAndAppsConnection"],
	validateCreateSocialsAndApps: GraphQLTypes["_ValidationResult"],
	validateUpdateSocialsAndApps: GraphQLTypes["_ValidationResult"],
	getProductGrid?: GraphQLTypes["ProductGrid"] | undefined,
	listProductGrid: Array<GraphQLTypes["ProductGrid"]>,
	paginateProductGrid: GraphQLTypes["ProductGridConnection"],
	validateCreateProductGrid: GraphQLTypes["_ValidationResult"],
	validateUpdateProductGrid: GraphQLTypes["_ValidationResult"],
	getProductGridItem?: GraphQLTypes["ProductGridItem"] | undefined,
	listProductGridItem: Array<GraphQLTypes["ProductGridItem"]>,
	paginateProductGridItem: GraphQLTypes["ProductGridItemConnection"],
	validateCreateProductGridItem: GraphQLTypes["_ValidationResult"],
	validateUpdateProductGridItem: GraphQLTypes["_ValidationResult"],
	getGallery?: GraphQLTypes["Gallery"] | undefined,
	listGallery: Array<GraphQLTypes["Gallery"]>,
	paginateGallery: GraphQLTypes["GalleryConnection"],
	validateCreateGallery: GraphQLTypes["_ValidationResult"],
	validateUpdateGallery: GraphQLTypes["_ValidationResult"],
	getGalleryItem?: GraphQLTypes["GalleryItem"] | undefined,
	listGalleryItem: Array<GraphQLTypes["GalleryItem"]>,
	paginateGalleryItem: GraphQLTypes["GalleryItemConnection"],
	validateCreateGalleryItem: GraphQLTypes["_ValidationResult"],
	validateUpdateGalleryItem: GraphQLTypes["_ValidationResult"],
	getHero?: GraphQLTypes["Hero"] | undefined,
	listHero: Array<GraphQLTypes["Hero"]>,
	paginateHero: GraphQLTypes["HeroConnection"],
	validateCreateHero: GraphQLTypes["_ValidationResult"],
	validateUpdateHero: GraphQLTypes["_ValidationResult"],
	getSiteMenu?: GraphQLTypes["SiteMenu"] | undefined,
	listSiteMenu: Array<GraphQLTypes["SiteMenu"]>,
	paginateSiteMenu: GraphQLTypes["SiteMenuConnection"],
	validateCreateSiteMenu: GraphQLTypes["_ValidationResult"],
	validateUpdateSiteMenu: GraphQLTypes["_ValidationResult"],
	getMenuLocale?: GraphQLTypes["MenuLocale"] | undefined,
	listMenuLocale: Array<GraphQLTypes["MenuLocale"]>,
	paginateMenuLocale: GraphQLTypes["MenuLocaleConnection"],
	validateCreateMenuLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateMenuLocale: GraphQLTypes["_ValidationResult"],
	getMenuItem?: GraphQLTypes["MenuItem"] | undefined,
	listMenuItem: Array<GraphQLTypes["MenuItem"]>,
	paginateMenuItem: GraphQLTypes["MenuItemConnection"],
	validateCreateMenuItem: GraphQLTypes["_ValidationResult"],
	validateUpdateMenuItem: GraphQLTypes["_ValidationResult"],
	getPage?: GraphQLTypes["Page"] | undefined,
	listPage: Array<GraphQLTypes["Page"]>,
	paginatePage: GraphQLTypes["PageConnection"],
	validateCreatePage: GraphQLTypes["_ValidationResult"],
	validateUpdatePage: GraphQLTypes["_ValidationResult"],
	getPageLocale?: GraphQLTypes["PageLocale"] | undefined,
	listPageLocale: Array<GraphQLTypes["PageLocale"]>,
	paginatePageLocale: GraphQLTypes["PageLocaleConnection"],
	validateCreatePageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdatePageLocale: GraphQLTypes["_ValidationResult"],
	getWikiPage?: GraphQLTypes["WikiPage"] | undefined,
	listWikiPage: Array<GraphQLTypes["WikiPage"]>,
	paginateWikiPage: GraphQLTypes["WikiPageConnection"],
	validateCreateWikiPage: GraphQLTypes["_ValidationResult"],
	validateUpdateWikiPage: GraphQLTypes["_ValidationResult"],
	getMenuSubitem?: GraphQLTypes["MenuSubitem"] | undefined,
	listMenuSubitem: Array<GraphQLTypes["MenuSubitem"]>,
	paginateMenuSubitem: GraphQLTypes["MenuSubitemConnection"],
	validateCreateMenuSubitem: GraphQLTypes["_ValidationResult"],
	validateUpdateMenuSubitem: GraphQLTypes["_ValidationResult"],
	getMenuLinkList?: GraphQLTypes["MenuLinkList"] | undefined,
	listMenuLinkList: Array<GraphQLTypes["MenuLinkList"]>,
	paginateMenuLinkList: GraphQLTypes["MenuLinkListConnection"],
	validateCreateMenuLinkList: GraphQLTypes["_ValidationResult"],
	validateUpdateMenuLinkList: GraphQLTypes["_ValidationResult"],
	getMenuLinkItem?: GraphQLTypes["MenuLinkItem"] | undefined,
	listMenuLinkItem: Array<GraphQLTypes["MenuLinkItem"]>,
	paginateMenuLinkItem: GraphQLTypes["MenuLinkItemConnection"],
	validateCreateMenuLinkItem: GraphQLTypes["_ValidationResult"],
	validateUpdateMenuLinkItem: GraphQLTypes["_ValidationResult"],
	getMenuProducts?: GraphQLTypes["MenuProducts"] | undefined,
	listMenuProducts: Array<GraphQLTypes["MenuProducts"]>,
	paginateMenuProducts: GraphQLTypes["MenuProductsConnection"],
	validateCreateMenuProducts: GraphQLTypes["_ValidationResult"],
	validateUpdateMenuProducts: GraphQLTypes["_ValidationResult"],
	getMenuDelivery?: GraphQLTypes["MenuDelivery"] | undefined,
	listMenuDelivery: Array<GraphQLTypes["MenuDelivery"]>,
	paginateMenuDelivery: GraphQLTypes["MenuDeliveryConnection"],
	validateCreateMenuDelivery: GraphQLTypes["_ValidationResult"],
	validateUpdateMenuDelivery: GraphQLTypes["_ValidationResult"],
	getMenuContact?: GraphQLTypes["MenuContact"] | undefined,
	listMenuContact: Array<GraphQLTypes["MenuContact"]>,
	paginateMenuContact: GraphQLTypes["MenuContactConnection"],
	validateCreateMenuContact: GraphQLTypes["_ValidationResult"],
	validateUpdateMenuContact: GraphQLTypes["_ValidationResult"],
	getDeadlineTemplate?: GraphQLTypes["DeadlineTemplate"] | undefined,
	listDeadlineTemplate: Array<GraphQLTypes["DeadlineTemplate"]>,
	paginateDeadlineTemplate: GraphQLTypes["DeadlineTemplateConnection"],
	validateCreateDeadlineTemplate: GraphQLTypes["_ValidationResult"],
	validateUpdateDeadlineTemplate: GraphQLTypes["_ValidationResult"],
	getEmployeeQueue?: GraphQLTypes["EmployeeQueue"] | undefined,
	listEmployeeQueue: Array<GraphQLTypes["EmployeeQueue"]>,
	paginateEmployeeQueue: GraphQLTypes["EmployeeQueueConnection"],
	validateCreateEmployeeQueue: GraphQLTypes["_ValidationResult"],
	validateUpdateEmployeeQueue: GraphQLTypes["_ValidationResult"],
	getTimetableDay?: GraphQLTypes["TimetableDay"] | undefined,
	listTimetableDay: Array<GraphQLTypes["TimetableDay"]>,
	paginateTimetableDay: GraphQLTypes["TimetableDayConnection"],
	validateCreateTimetableDay: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetableDay: GraphQLTypes["_ValidationResult"],
	getTimetableEmployeeRole?: GraphQLTypes["TimetableEmployeeRole"] | undefined,
	listTimetableEmployeeRole: Array<GraphQLTypes["TimetableEmployeeRole"]>,
	paginateTimetableEmployeeRole: GraphQLTypes["TimetableEmployeeRoleConnection"],
	validateCreateTimetableEmployeeRole: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetableEmployeeRole: GraphQLTypes["_ValidationResult"],
	getTimetableShift?: GraphQLTypes["TimetableShift"] | undefined,
	listTimetableShift: Array<GraphQLTypes["TimetableShift"]>,
	paginateTimetableShift: GraphQLTypes["TimetableShiftConnection"],
	validateCreateTimetableShift: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetableShift: GraphQLTypes["_ValidationResult"],
	getTimetableShiftGroup?: GraphQLTypes["TimetableShiftGroup"] | undefined,
	listTimetableShiftGroup: Array<GraphQLTypes["TimetableShiftGroup"]>,
	paginateTimetableShiftGroup: GraphQLTypes["TimetableShiftGroupConnection"],
	validateCreateTimetableShiftGroup: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetableShiftGroup: GraphQLTypes["_ValidationResult"],
	getTimetableShiftPosition?: GraphQLTypes["TimetableShiftPosition"] | undefined,
	listTimetableShiftPosition: Array<GraphQLTypes["TimetableShiftPosition"]>,
	paginateTimetableShiftPosition: GraphQLTypes["TimetableShiftPositionConnection"],
	validateCreateTimetableShiftPosition: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetableShiftPosition: GraphQLTypes["_ValidationResult"],
	getTimetableTemplate?: GraphQLTypes["TimetableTemplate"] | undefined,
	listTimetableTemplate: Array<GraphQLTypes["TimetableTemplate"]>,
	paginateTimetableTemplate: GraphQLTypes["TimetableTemplateConnection"],
	validateCreateTimetableTemplate: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetableTemplate: GraphQLTypes["_ValidationResult"],
	getCart?: GraphQLTypes["Cart"] | undefined,
	listCart: Array<GraphQLTypes["Cart"]>,
	paginateCart: GraphQLTypes["CartConnection"],
	validateCreateCart: GraphQLTypes["_ValidationResult"],
	validateUpdateCart: GraphQLTypes["_ValidationResult"],
	getCartItem?: GraphQLTypes["CartItem"] | undefined,
	listCartItem: Array<GraphQLTypes["CartItem"]>,
	paginateCartItem: GraphQLTypes["CartItemConnection"],
	validateCreateCartItem: GraphQLTypes["_ValidationResult"],
	validateUpdateCartItem: GraphQLTypes["_ValidationResult"],
	getEmployeeQueueItem?: GraphQLTypes["EmployeeQueueItem"] | undefined,
	listEmployeeQueueItem: Array<GraphQLTypes["EmployeeQueueItem"]>,
	paginateEmployeeQueueItem: GraphQLTypes["EmployeeQueueItemConnection"],
	validateCreateEmployeeQueueItem: GraphQLTypes["_ValidationResult"],
	validateUpdateEmployeeQueueItem: GraphQLTypes["_ValidationResult"],
	getApplication?: GraphQLTypes["Application"] | undefined,
	listApplication: Array<GraphQLTypes["Application"]>,
	paginateApplication: GraphQLTypes["ApplicationConnection"],
	validateCreateApplication: GraphQLTypes["_ValidationResult"],
	validateUpdateApplication: GraphQLTypes["_ValidationResult"],
	getApplicationShortcutList?: GraphQLTypes["ApplicationShortcutList"] | undefined,
	listApplicationShortcutList: Array<GraphQLTypes["ApplicationShortcutList"]>,
	paginateApplicationShortcutList: GraphQLTypes["ApplicationShortcutListConnection"],
	validateCreateApplicationShortcutList: GraphQLTypes["_ValidationResult"],
	validateUpdateApplicationShortcutList: GraphQLTypes["_ValidationResult"],
	getApplicationShortcutListItem?: GraphQLTypes["ApplicationShortcutListItem"] | undefined,
	listApplicationShortcutListItem: Array<GraphQLTypes["ApplicationShortcutListItem"]>,
	paginateApplicationShortcutListItem: GraphQLTypes["ApplicationShortcutListItemConnection"],
	validateCreateApplicationShortcutListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateApplicationShortcutListItem: GraphQLTypes["_ValidationResult"],
	getProductBanner?: GraphQLTypes["ProductBanner"] | undefined,
	listProductBanner: Array<GraphQLTypes["ProductBanner"]>,
	paginateProductBanner: GraphQLTypes["ProductBannerConnection"],
	validateCreateProductBanner: GraphQLTypes["_ValidationResult"],
	validateUpdateProductBanner: GraphQLTypes["_ValidationResult"],
	getProductBannerItem?: GraphQLTypes["ProductBannerItem"] | undefined,
	listProductBannerItem: Array<GraphQLTypes["ProductBannerItem"]>,
	paginateProductBannerItem: GraphQLTypes["ProductBannerItemConnection"],
	validateCreateProductBannerItem: GraphQLTypes["_ValidationResult"],
	validateUpdateProductBannerItem: GraphQLTypes["_ValidationResult"],
	getProductBannerList?: GraphQLTypes["ProductBannerList"] | undefined,
	listProductBannerList: Array<GraphQLTypes["ProductBannerList"]>,
	paginateProductBannerList: GraphQLTypes["ProductBannerListConnection"],
	validateCreateProductBannerList: GraphQLTypes["_ValidationResult"],
	validateUpdateProductBannerList: GraphQLTypes["_ValidationResult"],
	getBartender?: GraphQLTypes["Bartender"] | undefined,
	listBartender: Array<GraphQLTypes["Bartender"]>,
	paginateBartender: GraphQLTypes["BartenderConnection"],
	validateCreateBartender: GraphQLTypes["_ValidationResult"],
	validateUpdateBartender: GraphQLTypes["_ValidationResult"],
	getBusinessToBusinessManager?: GraphQLTypes["BusinessToBusinessManager"] | undefined,
	listBusinessToBusinessManager: Array<GraphQLTypes["BusinessToBusinessManager"]>,
	paginateBusinessToBusinessManager: GraphQLTypes["BusinessToBusinessManagerConnection"],
	validateCreateBusinessToBusinessManager: GraphQLTypes["_ValidationResult"],
	validateUpdateBusinessToBusinessManager: GraphQLTypes["_ValidationResult"],
	getCleaner?: GraphQLTypes["Cleaner"] | undefined,
	listCleaner: Array<GraphQLTypes["Cleaner"]>,
	paginateCleaner: GraphQLTypes["CleanerConnection"],
	validateCreateCleaner: GraphQLTypes["_ValidationResult"],
	validateUpdateCleaner: GraphQLTypes["_ValidationResult"],
	getCourier?: GraphQLTypes["Courier"] | undefined,
	listCourier: Array<GraphQLTypes["Courier"]>,
	paginateCourier: GraphQLTypes["CourierConnection"],
	validateCreateCourier: GraphQLTypes["_ValidationResult"],
	validateUpdateCourier: GraphQLTypes["_ValidationResult"],
	getShiftsManager?: GraphQLTypes["ShiftsManager"] | undefined,
	listShiftsManager: Array<GraphQLTypes["ShiftsManager"]>,
	paginateShiftsManager: GraphQLTypes["ShiftsManagerConnection"],
	validateCreateShiftsManager: GraphQLTypes["_ValidationResult"],
	validateUpdateShiftsManager: GraphQLTypes["_ValidationResult"],
	getUser?: GraphQLTypes["User"] | undefined,
	listUser: Array<GraphQLTypes["User"]>,
	paginateUser: GraphQLTypes["UserConnection"],
	validateCreateUser: GraphQLTypes["_ValidationResult"],
	validateUpdateUser: GraphQLTypes["_ValidationResult"],
	getShiftsProfile?: GraphQLTypes["ShiftsProfile"] | undefined,
	listShiftsProfile: Array<GraphQLTypes["ShiftsProfile"]>,
	paginateShiftsProfile: GraphQLTypes["ShiftsProfileConnection"],
	validateCreateShiftsProfile: GraphQLTypes["_ValidationResult"],
	validateUpdateShiftsProfile: GraphQLTypes["_ValidationResult"],
	getProductIngredientCategory?: GraphQLTypes["ProductIngredientCategory"] | undefined,
	listProductIngredientCategory: Array<GraphQLTypes["ProductIngredientCategory"]>,
	paginateProductIngredientCategory: GraphQLTypes["ProductIngredientCategoryConnection"],
	validateCreateProductIngredientCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateProductIngredientCategory: GraphQLTypes["_ValidationResult"],
	getProductIngredientCategoryLocale?: GraphQLTypes["ProductIngredientCategoryLocale"] | undefined,
	listProductIngredientCategoryLocale: Array<GraphQLTypes["ProductIngredientCategoryLocale"]>,
	paginateProductIngredientCategoryLocale: GraphQLTypes["ProductIngredientCategoryLocaleConnection"],
	validateCreateProductIngredientCategoryLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateProductIngredientCategoryLocale: GraphQLTypes["_ValidationResult"],
	getStocksManager?: GraphQLTypes["StocksManager"] | undefined,
	listStocksManager: Array<GraphQLTypes["StocksManager"]>,
	paginateStocksManager: GraphQLTypes["StocksManagerConnection"],
	validateCreateStocksManager: GraphQLTypes["_ValidationResult"],
	validateUpdateStocksManager: GraphQLTypes["_ValidationResult"],
	getDeliveryRoute?: GraphQLTypes["DeliveryRoute"] | undefined,
	listDeliveryRoute: Array<GraphQLTypes["DeliveryRoute"]>,
	paginateDeliveryRoute: GraphQLTypes["DeliveryRouteConnection"],
	validateCreateDeliveryRoute: GraphQLTypes["_ValidationResult"],
	validateUpdateDeliveryRoute: GraphQLTypes["_ValidationResult"],
	getDeliveryWaypoint?: GraphQLTypes["DeliveryWaypoint"] | undefined,
	listDeliveryWaypoint: Array<GraphQLTypes["DeliveryWaypoint"]>,
	paginateDeliveryWaypoint: GraphQLTypes["DeliveryWaypointConnection"],
	validateCreateDeliveryWaypoint: GraphQLTypes["_ValidationResult"],
	validateUpdateDeliveryWaypoint: GraphQLTypes["_ValidationResult"],
	getAllergen?: GraphQLTypes["Allergen"] | undefined,
	listAllergen: Array<GraphQLTypes["Allergen"]>,
	paginateAllergen: GraphQLTypes["AllergenConnection"],
	validateCreateAllergen: GraphQLTypes["_ValidationResult"],
	validateUpdateAllergen: GraphQLTypes["_ValidationResult"],
	getAllergenLocale?: GraphQLTypes["AllergenLocale"] | undefined,
	listAllergenLocale: Array<GraphQLTypes["AllergenLocale"]>,
	paginateAllergenLocale: GraphQLTypes["AllergenLocaleConnection"],
	validateCreateAllergenLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateAllergenLocale: GraphQLTypes["_ValidationResult"],
	getGps?: GraphQLTypes["Gps"] | undefined,
	listGps: Array<GraphQLTypes["Gps"]>,
	paginateGps: GraphQLTypes["GpsConnection"],
	validateCreateGps: GraphQLTypes["_ValidationResult"],
	validateUpdateGps: GraphQLTypes["_ValidationResult"],
	getProductCategoryTree?: GraphQLTypes["ProductCategoryTree"] | undefined,
	listProductCategoryTree: Array<GraphQLTypes["ProductCategoryTree"]>,
	paginateProductCategoryTree: GraphQLTypes["ProductCategoryTreeConnection"],
	getInheritedProductCategoryTag?: GraphQLTypes["InheritedProductCategoryTag"] | undefined,
	listInheritedProductCategoryTag: Array<GraphQLTypes["InheritedProductCategoryTag"]>,
	paginateInheritedProductCategoryTag: GraphQLTypes["InheritedProductCategoryTagConnection"],
	getNestedProductCategoryProduct?: GraphQLTypes["NestedProductCategoryProduct"] | undefined,
	listNestedProductCategoryProduct: Array<GraphQLTypes["NestedProductCategoryProduct"]>,
	paginateNestedProductCategoryProduct: GraphQLTypes["NestedProductCategoryProductConnection"],
	getWeekHours?: GraphQLTypes["WeekHours"] | undefined,
	listWeekHours: Array<GraphQLTypes["WeekHours"]>,
	paginateWeekHours: GraphQLTypes["WeekHoursConnection"],
	validateCreateWeekHours: GraphQLTypes["_ValidationResult"],
	validateUpdateWeekHours: GraphQLTypes["_ValidationResult"],
	getPreparedIngredientQuantity?: GraphQLTypes["PreparedIngredientQuantity"] | undefined,
	listPreparedIngredientQuantity: Array<GraphQLTypes["PreparedIngredientQuantity"]>,
	paginatePreparedIngredientQuantity: GraphQLTypes["PreparedIngredientQuantityConnection"],
	validateCreatePreparedIngredientQuantity: GraphQLTypes["_ValidationResult"],
	validateUpdatePreparedIngredientQuantity: GraphQLTypes["_ValidationResult"],
	getPreparedRecipeQuantity?: GraphQLTypes["PreparedRecipeQuantity"] | undefined,
	listPreparedRecipeQuantity: Array<GraphQLTypes["PreparedRecipeQuantity"]>,
	paginatePreparedRecipeQuantity: GraphQLTypes["PreparedRecipeQuantityConnection"],
	validateCreatePreparedRecipeQuantity: GraphQLTypes["_ValidationResult"],
	validateUpdatePreparedRecipeQuantity: GraphQLTypes["_ValidationResult"],
	getInternalOrder?: GraphQLTypes["InternalOrder"] | undefined,
	listInternalOrder: Array<GraphQLTypes["InternalOrder"]>,
	paginateInternalOrder: GraphQLTypes["InternalOrderConnection"],
	validateCreateInternalOrder: GraphQLTypes["_ValidationResult"],
	validateUpdateInternalOrder: GraphQLTypes["_ValidationResult"],
	getInternalOrderItem?: GraphQLTypes["InternalOrderItem"] | undefined,
	listInternalOrderItem: Array<GraphQLTypes["InternalOrderItem"]>,
	paginateInternalOrderItem: GraphQLTypes["InternalOrderItemConnection"],
	validateCreateInternalOrderItem: GraphQLTypes["_ValidationResult"],
	validateUpdateInternalOrderItem: GraphQLTypes["_ValidationResult"],
	getPreparedPackingQuantity?: GraphQLTypes["PreparedPackingQuantity"] | undefined,
	listPreparedPackingQuantity: Array<GraphQLTypes["PreparedPackingQuantity"]>,
	paginatePreparedPackingQuantity: GraphQLTypes["PreparedPackingQuantityConnection"],
	validateCreatePreparedPackingQuantity: GraphQLTypes["_ValidationResult"],
	validateUpdatePreparedPackingQuantity: GraphQLTypes["_ValidationResult"],
	getCourierManager?: GraphQLTypes["CourierManager"] | undefined,
	listCourierManager: Array<GraphQLTypes["CourierManager"]>,
	paginateCourierManager: GraphQLTypes["CourierManagerConnection"],
	validateCreateCourierManager: GraphQLTypes["_ValidationResult"],
	validateUpdateCourierManager: GraphQLTypes["_ValidationResult"],
	getDeliveryZone?: GraphQLTypes["DeliveryZone"] | undefined,
	listDeliveryZone: Array<GraphQLTypes["DeliveryZone"]>,
	paginateDeliveryZone: GraphQLTypes["DeliveryZoneConnection"],
	validateCreateDeliveryZone: GraphQLTypes["_ValidationResult"],
	validateUpdateDeliveryZone: GraphQLTypes["_ValidationResult"],
	getAddressMetadata?: GraphQLTypes["AddressMetadata"] | undefined,
	listAddressMetadata: Array<GraphQLTypes["AddressMetadata"]>,
	paginateAddressMetadata: GraphQLTypes["AddressMetadataConnection"],
	getDeliveryTimelinePreset?: GraphQLTypes["DeliveryTimelinePreset"] | undefined,
	listDeliveryTimelinePreset: Array<GraphQLTypes["DeliveryTimelinePreset"]>,
	paginateDeliveryTimelinePreset: GraphQLTypes["DeliveryTimelinePresetConnection"],
	validateCreateDeliveryTimelinePreset: GraphQLTypes["_ValidationResult"],
	validateUpdateDeliveryTimelinePreset: GraphQLTypes["_ValidationResult"],
	getOrderDeliveryTimeline?: GraphQLTypes["OrderDeliveryTimeline"] | undefined,
	listOrderDeliveryTimeline: Array<GraphQLTypes["OrderDeliveryTimeline"]>,
	paginateOrderDeliveryTimeline: GraphQLTypes["OrderDeliveryTimelineConnection"],
	validateCreateOrderDeliveryTimeline: GraphQLTypes["_ValidationResult"],
	validateUpdateOrderDeliveryTimeline: GraphQLTypes["_ValidationResult"],
	getOrderEvent?: GraphQLTypes["OrderEvent"] | undefined,
	listOrderEvent: Array<GraphQLTypes["OrderEvent"]>,
	paginateOrderEvent: GraphQLTypes["OrderEventConnection"],
	validateCreateOrderEvent: GraphQLTypes["_ValidationResult"],
	validateUpdateOrderEvent: GraphQLTypes["_ValidationResult"],
	getLiftagoRide?: GraphQLTypes["LiftagoRide"] | undefined,
	listLiftagoRide: Array<GraphQLTypes["LiftagoRide"]>,
	paginateLiftagoRide: GraphQLTypes["LiftagoRideConnection"],
	validateCreateLiftagoRide: GraphQLTypes["_ValidationResult"],
	validateUpdateLiftagoRide: GraphQLTypes["_ValidationResult"],
	getInvoice?: GraphQLTypes["Invoice"] | undefined,
	listInvoice: Array<GraphQLTypes["Invoice"]>,
	paginateInvoice: GraphQLTypes["InvoiceConnection"],
	validateCreateInvoice: GraphQLTypes["_ValidationResult"],
	validateUpdateInvoice: GraphQLTypes["_ValidationResult"],
	getInvoicingPlan?: GraphQLTypes["InvoicingPlan"] | undefined,
	listInvoicingPlan: Array<GraphQLTypes["InvoicingPlan"]>,
	paginateInvoicingPlan: GraphQLTypes["InvoicingPlanConnection"],
	validateCreateInvoicingPlan: GraphQLTypes["_ValidationResult"],
	validateUpdateInvoicingPlan: GraphQLTypes["_ValidationResult"],
	getProductPackingLocale?: GraphQLTypes["ProductPackingLocale"] | undefined,
	listProductPackingLocale: Array<GraphQLTypes["ProductPackingLocale"]>,
	paginateProductPackingLocale: GraphQLTypes["ProductPackingLocaleConnection"],
	validateCreateProductPackingLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateProductPackingLocale: GraphQLTypes["_ValidationResult"],
	getProductLocale?: GraphQLTypes["ProductLocale"] | undefined,
	listProductLocale: Array<GraphQLTypes["ProductLocale"]>,
	paginateProductLocale: GraphQLTypes["ProductLocaleConnection"],
	validateCreateProductLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateProductLocale: GraphQLTypes["_ValidationResult"],
	getProductRecipeLocale?: GraphQLTypes["ProductRecipeLocale"] | undefined,
	listProductRecipeLocale: Array<GraphQLTypes["ProductRecipeLocale"]>,
	paginateProductRecipeLocale: GraphQLTypes["ProductRecipeLocaleConnection"],
	validateCreateProductRecipeLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateProductRecipeLocale: GraphQLTypes["_ValidationResult"],
	getUserDevice?: GraphQLTypes["UserDevice"] | undefined,
	listUserDevice: Array<GraphQLTypes["UserDevice"]>,
	paginateUserDevice: GraphQLTypes["UserDeviceConnection"],
	validateCreateUserDevice: GraphQLTypes["_ValidationResult"],
	validateUpdateUserDevice: GraphQLTypes["_ValidationResult"],
	getProtectedAction?: GraphQLTypes["ProtectedAction"] | undefined,
	listProtectedAction: Array<GraphQLTypes["ProtectedAction"]>,
	paginateProtectedAction: GraphQLTypes["ProtectedActionConnection"],
	validateCreateProtectedAction: GraphQLTypes["_ValidationResult"],
	validateUpdateProtectedAction: GraphQLTypes["_ValidationResult"],
	getPicker?: GraphQLTypes["Picker"] | undefined,
	listPicker: Array<GraphQLTypes["Picker"]>,
	paginatePicker: GraphQLTypes["PickerConnection"],
	validateCreatePicker: GraphQLTypes["_ValidationResult"],
	validateUpdatePicker: GraphQLTypes["_ValidationResult"],
	getTenantPerson?: GraphQLTypes["TenantPerson"] | undefined,
	listTenantPerson: Array<GraphQLTypes["TenantPerson"]>,
	paginateTenantPerson: GraphQLTypes["TenantPersonConnection"],
	getTimetableTemplateStaffOptions?: GraphQLTypes["TimetableTemplateStaffOptions"] | undefined,
	listTimetableTemplateStaffOptions: Array<GraphQLTypes["TimetableTemplateStaffOptions"]>,
	paginateTimetableTemplateStaffOptions: GraphQLTypes["TimetableTemplateStaffOptionsConnection"],
	validateCreateTimetableTemplateStaffOptions: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetableTemplateStaffOptions: GraphQLTypes["_ValidationResult"],
	getShoppingList?: GraphQLTypes["ShoppingList"] | undefined,
	listShoppingList: Array<GraphQLTypes["ShoppingList"]>,
	paginateShoppingList: GraphQLTypes["ShoppingListConnection"],
	validateCreateShoppingList: GraphQLTypes["_ValidationResult"],
	validateUpdateShoppingList: GraphQLTypes["_ValidationResult"],
	getSuppliesPurchase?: GraphQLTypes["SuppliesPurchase"] | undefined,
	listSuppliesPurchase: Array<GraphQLTypes["SuppliesPurchase"]>,
	paginateSuppliesPurchase: GraphQLTypes["SuppliesPurchaseConnection"],
	validateCreateSuppliesPurchase: GraphQLTypes["_ValidationResult"],
	validateUpdateSuppliesPurchase: GraphQLTypes["_ValidationResult"],
	getInvoicingPreset?: GraphQLTypes["InvoicingPreset"] | undefined,
	listInvoicingPreset: Array<GraphQLTypes["InvoicingPreset"]>,
	paginateInvoicingPreset: GraphQLTypes["InvoicingPresetConnection"],
	validateCreateInvoicingPreset: GraphQLTypes["_ValidationResult"],
	validateUpdateInvoicingPreset: GraphQLTypes["_ValidationResult"],
	getLogRecord?: GraphQLTypes["LogRecord"] | undefined,
	listLogRecord: Array<GraphQLTypes["LogRecord"]>,
	paginateLogRecord: GraphQLTypes["LogRecordConnection"],
	validateCreateLogRecord: GraphQLTypes["_ValidationResult"],
	validateUpdateLogRecord: GraphQLTypes["_ValidationResult"],
	getBillingSubject?: GraphQLTypes["BillingSubject"] | undefined,
	listBillingSubject: Array<GraphQLTypes["BillingSubject"]>,
	paginateBillingSubject: GraphQLTypes["BillingSubjectConnection"],
	validateCreateBillingSubject: GraphQLTypes["_ValidationResult"],
	validateUpdateBillingSubject: GraphQLTypes["_ValidationResult"],
	getProductCustomerPrice?: GraphQLTypes["ProductCustomerPrice"] | undefined,
	listProductCustomerPrice: Array<GraphQLTypes["ProductCustomerPrice"]>,
	paginateProductCustomerPrice: GraphQLTypes["ProductCustomerPriceConnection"],
	getCartPriceLine?: GraphQLTypes["CartPriceLine"] | undefined,
	listCartPriceLine: Array<GraphQLTypes["CartPriceLine"]>,
	paginateCartPriceLine: GraphQLTypes["CartPriceLineConnection"],
	getShoppingListItem?: GraphQLTypes["ShoppingListItem"] | undefined,
	listShoppingListItem: Array<GraphQLTypes["ShoppingListItem"]>,
	paginateShoppingListItem: GraphQLTypes["ShoppingListItemConnection"],
	validateCreateShoppingListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateShoppingListItem: GraphQLTypes["_ValidationResult"],
	getSuppliesPurchaseItem?: GraphQLTypes["SuppliesPurchaseItem"] | undefined,
	listSuppliesPurchaseItem: Array<GraphQLTypes["SuppliesPurchaseItem"]>,
	paginateSuppliesPurchaseItem: GraphQLTypes["SuppliesPurchaseItemConnection"],
	validateCreateSuppliesPurchaseItem: GraphQLTypes["_ValidationResult"],
	validateUpdateSuppliesPurchaseItem: GraphQLTypes["_ValidationResult"],
	getCustomerCreditTransaction?: GraphQLTypes["CustomerCreditTransaction"] | undefined,
	listCustomerCreditTransaction: Array<GraphQLTypes["CustomerCreditTransaction"]>,
	paginateCustomerCreditTransaction: GraphQLTypes["CustomerCreditTransactionConnection"],
	validateCreateCustomerCreditTransaction: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomerCreditTransaction: GraphQLTypes["_ValidationResult"],
	getVirtualProduct?: GraphQLTypes["VirtualProduct"] | undefined,
	listVirtualProduct: Array<GraphQLTypes["VirtualProduct"]>,
	paginateVirtualProduct: GraphQLTypes["VirtualProductConnection"],
	validateCreateVirtualProduct: GraphQLTypes["_ValidationResult"],
	validateUpdateVirtualProduct: GraphQLTypes["_ValidationResult"],
	getVirtualProductEffect?: GraphQLTypes["VirtualProductEffect"] | undefined,
	listVirtualProductEffect: Array<GraphQLTypes["VirtualProductEffect"]>,
	paginateVirtualProductEffect: GraphQLTypes["VirtualProductEffectConnection"],
	validateCreateVirtualProductEffect: GraphQLTypes["_ValidationResult"],
	validateUpdateVirtualProductEffect: GraphQLTypes["_ValidationResult"],
	getOrderPriceLine?: GraphQLTypes["OrderPriceLine"] | undefined,
	listOrderPriceLine: Array<GraphQLTypes["OrderPriceLine"]>,
	paginateOrderPriceLine: GraphQLTypes["OrderPriceLineConnection"],
	getProductMetadata?: GraphQLTypes["ProductMetadata"] | undefined,
	listProductMetadata: Array<GraphQLTypes["ProductMetadata"]>,
	paginateProductMetadata: GraphQLTypes["ProductMetadataConnection"],
	getEmploymentInformation?: GraphQLTypes["EmploymentInformation"] | undefined,
	listEmploymentInformation: Array<GraphQLTypes["EmploymentInformation"]>,
	paginateEmploymentInformation: GraphQLTypes["EmploymentInformationConnection"],
	validateCreateEmploymentInformation: GraphQLTypes["_ValidationResult"],
	validateUpdateEmploymentInformation: GraphQLTypes["_ValidationResult"],
	getRemunerationProfile?: GraphQLTypes["RemunerationProfile"] | undefined,
	listRemunerationProfile: Array<GraphQLTypes["RemunerationProfile"]>,
	paginateRemunerationProfile: GraphQLTypes["RemunerationProfileConnection"],
	validateCreateRemunerationProfile: GraphQLTypes["_ValidationResult"],
	validateUpdateRemunerationProfile: GraphQLTypes["_ValidationResult"],
	getWorkMonth?: GraphQLTypes["WorkMonth"] | undefined,
	listWorkMonth: Array<GraphQLTypes["WorkMonth"]>,
	paginateWorkMonth: GraphQLTypes["WorkMonthConnection"],
	validateCreateWorkMonth: GraphQLTypes["_ValidationResult"],
	validateUpdateWorkMonth: GraphQLTypes["_ValidationResult"],
	getSalaryOptions?: GraphQLTypes["SalaryOptions"] | undefined,
	listSalaryOptions: Array<GraphQLTypes["SalaryOptions"]>,
	paginateSalaryOptions: GraphQLTypes["SalaryOptionsConnection"],
	validateCreateSalaryOptions: GraphQLTypes["_ValidationResult"],
	validateUpdateSalaryOptions: GraphQLTypes["_ValidationResult"],
	getTimetableShiftSwapInfo?: GraphQLTypes["TimetableShiftSwapInfo"] | undefined,
	listTimetableShiftSwapInfo: Array<GraphQLTypes["TimetableShiftSwapInfo"]>,
	paginateTimetableShiftSwapInfo: GraphQLTypes["TimetableShiftSwapInfoConnection"],
	validateCreateTimetableShiftSwapInfo: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetableShiftSwapInfo: GraphQLTypes["_ValidationResult"],
	getProductGridCategory?: GraphQLTypes["ProductGridCategory"] | undefined,
	listProductGridCategory: Array<GraphQLTypes["ProductGridCategory"]>,
	paginateProductGridCategory: GraphQLTypes["ProductGridCategoryConnection"],
	validateCreateProductGridCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateProductGridCategory: GraphQLTypes["_ValidationResult"],
	getCashier?: GraphQLTypes["Cashier"] | undefined,
	listCashier: Array<GraphQLTypes["Cashier"]>,
	paginateCashier: GraphQLTypes["CashierConnection"],
	validateCreateCashier: GraphQLTypes["_ValidationResult"],
	validateUpdateCashier: GraphQLTypes["_ValidationResult"],
	getPointOfSaleCategory?: GraphQLTypes["PointOfSaleCategory"] | undefined,
	listPointOfSaleCategory: Array<GraphQLTypes["PointOfSaleCategory"]>,
	paginatePointOfSaleCategory: GraphQLTypes["PointOfSaleCategoryConnection"],
	validateCreatePointOfSaleCategory: GraphQLTypes["_ValidationResult"],
	validateUpdatePointOfSaleCategory: GraphQLTypes["_ValidationResult"],
	getPointOfSaleCategoryLocale?: GraphQLTypes["PointOfSaleCategoryLocale"] | undefined,
	listPointOfSaleCategoryLocale: Array<GraphQLTypes["PointOfSaleCategoryLocale"]>,
	paginatePointOfSaleCategoryLocale: GraphQLTypes["PointOfSaleCategoryLocaleConnection"],
	validateCreatePointOfSaleCategoryLocale: GraphQLTypes["_ValidationResult"],
	validateUpdatePointOfSaleCategoryLocale: GraphQLTypes["_ValidationResult"],
	getPointOfSaleCategoryProduct?: GraphQLTypes["PointOfSaleCategoryProduct"] | undefined,
	listPointOfSaleCategoryProduct: Array<GraphQLTypes["PointOfSaleCategoryProduct"]>,
	paginatePointOfSaleCategoryProduct: GraphQLTypes["PointOfSaleCategoryProductConnection"],
	validateCreatePointOfSaleCategoryProduct: GraphQLTypes["_ValidationResult"],
	validateUpdatePointOfSaleCategoryProduct: GraphQLTypes["_ValidationResult"],
	getPointOfSaleCategoryProductLocale?: GraphQLTypes["PointOfSaleCategoryProductLocale"] | undefined,
	listPointOfSaleCategoryProductLocale: Array<GraphQLTypes["PointOfSaleCategoryProductLocale"]>,
	paginatePointOfSaleCategoryProductLocale: GraphQLTypes["PointOfSaleCategoryProductLocaleConnection"],
	validateCreatePointOfSaleCategoryProductLocale: GraphQLTypes["_ValidationResult"],
	validateUpdatePointOfSaleCategoryProductLocale: GraphQLTypes["_ValidationResult"],
	getCustomerTab?: GraphQLTypes["CustomerTab"] | undefined,
	listCustomerTab: Array<GraphQLTypes["CustomerTab"]>,
	paginateCustomerTab: GraphQLTypes["CustomerTabConnection"],
	validateCreateCustomerTab: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomerTab: GraphQLTypes["_ValidationResult"],
	getCustomerTabItem?: GraphQLTypes["CustomerTabItem"] | undefined,
	listCustomerTabItem: Array<GraphQLTypes["CustomerTabItem"]>,
	paginateCustomerTabItem: GraphQLTypes["CustomerTabItemConnection"],
	validateCreateCustomerTabItem: GraphQLTypes["_ValidationResult"],
	validateUpdateCustomerTabItem: GraphQLTypes["_ValidationResult"],
	getAnonymousSession?: GraphQLTypes["AnonymousSession"] | undefined,
	listAnonymousSession: Array<GraphQLTypes["AnonymousSession"]>,
	paginateAnonymousSession: GraphQLTypes["AnonymousSessionConnection"],
	validateCreateAnonymousSession: GraphQLTypes["_ValidationResult"],
	validateUpdateAnonymousSession: GraphQLTypes["_ValidationResult"],
	getVoucher?: GraphQLTypes["Voucher"] | undefined,
	listVoucher: Array<GraphQLTypes["Voucher"]>,
	paginateVoucher: GraphQLTypes["VoucherConnection"],
	validateCreateVoucher: GraphQLTypes["_ValidationResult"],
	validateUpdateVoucher: GraphQLTypes["_ValidationResult"],
	getVoucherRedemption?: GraphQLTypes["VoucherRedemption"] | undefined,
	listVoucherRedemption: Array<GraphQLTypes["VoucherRedemption"]>,
	paginateVoucherRedemption: GraphQLTypes["VoucherRedemptionConnection"],
	validateCreateVoucherRedemption: GraphQLTypes["_ValidationResult"],
	validateUpdateVoucherRedemption: GraphQLTypes["_ValidationResult"],
	getUnassignedShiftInfo?: GraphQLTypes["UnassignedShiftInfo"] | undefined,
	listUnassignedShiftInfo: Array<GraphQLTypes["UnassignedShiftInfo"]>,
	paginateUnassignedShiftInfo: GraphQLTypes["UnassignedShiftInfoConnection"],
	validateCreateUnassignedShiftInfo: GraphQLTypes["_ValidationResult"],
	validateUpdateUnassignedShiftInfo: GraphQLTypes["_ValidationResult"],
	getFreshingContainer?: GraphQLTypes["FreshingContainer"] | undefined,
	listFreshingContainer: Array<GraphQLTypes["FreshingContainer"]>,
	paginateFreshingContainer: GraphQLTypes["FreshingContainerConnection"],
	validateCreateFreshingContainer: GraphQLTypes["_ValidationResult"],
	validateUpdateFreshingContainer: GraphQLTypes["_ValidationResult"],
	getTextItem?: GraphQLTypes["TextItem"] | undefined,
	listTextItem: Array<GraphQLTypes["TextItem"]>,
	paginateTextItem: GraphQLTypes["TextItemConnection"],
	validateCreateTextItem: GraphQLTypes["_ValidationResult"],
	validateUpdateTextItem: GraphQLTypes["_ValidationResult"],
	getTextList?: GraphQLTypes["TextList"] | undefined,
	listTextList: Array<GraphQLTypes["TextList"]>,
	paginateTextList: GraphQLTypes["TextListConnection"],
	validateCreateTextList: GraphQLTypes["_ValidationResult"],
	validateUpdateTextList: GraphQLTypes["_ValidationResult"],
	getEmployeeQueueItemMetadata?: GraphQLTypes["EmployeeQueueItemMetadata"] | undefined,
	listEmployeeQueueItemMetadata: Array<GraphQLTypes["EmployeeQueueItemMetadata"]>,
	paginateEmployeeQueueItemMetadata: GraphQLTypes["EmployeeQueueItemMetadataConnection"],
	getDeliveryRegions?: GraphQLTypes["DeliveryRegions"] | undefined,
	listDeliveryRegions: Array<GraphQLTypes["DeliveryRegions"]>,
	paginateDeliveryRegions: GraphQLTypes["DeliveryRegionsConnection"],
	validateCreateDeliveryRegions: GraphQLTypes["_ValidationResult"],
	validateUpdateDeliveryRegions: GraphQLTypes["_ValidationResult"],
	getDeliveryRegionsItem?: GraphQLTypes["DeliveryRegionsItem"] | undefined,
	listDeliveryRegionsItem: Array<GraphQLTypes["DeliveryRegionsItem"]>,
	paginateDeliveryRegionsItem: GraphQLTypes["DeliveryRegionsItemConnection"],
	validateCreateDeliveryRegionsItem: GraphQLTypes["_ValidationResult"],
	validateUpdateDeliveryRegionsItem: GraphQLTypes["_ValidationResult"],
	getImageList?: GraphQLTypes["ImageList"] | undefined,
	listImageList: Array<GraphQLTypes["ImageList"]>,
	paginateImageList: GraphQLTypes["ImageListConnection"],
	validateCreateImageList: GraphQLTypes["_ValidationResult"],
	validateUpdateImageList: GraphQLTypes["_ValidationResult"],
	getImageListItem?: GraphQLTypes["ImageListItem"] | undefined,
	listImageListItem: Array<GraphQLTypes["ImageListItem"]>,
	paginateImageListItem: GraphQLTypes["ImageListItemConnection"],
	validateCreateImageListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateImageListItem: GraphQLTypes["_ValidationResult"],
	getProductSalesDay?: GraphQLTypes["ProductSalesDay"] | undefined,
	listProductSalesDay: Array<GraphQLTypes["ProductSalesDay"]>,
	paginateProductSalesDay: GraphQLTypes["ProductSalesDayConnection"],
	getProductSalesMonth?: GraphQLTypes["ProductSalesMonth"] | undefined,
	listProductSalesMonth: Array<GraphQLTypes["ProductSalesMonth"]>,
	paginateProductSalesMonth: GraphQLTypes["ProductSalesMonthConnection"],
	getProductSalesWeek?: GraphQLTypes["ProductSalesWeek"] | undefined,
	listProductSalesWeek: Array<GraphQLTypes["ProductSalesWeek"]>,
	paginateProductSalesWeek: GraphQLTypes["ProductSalesWeekConnection"],
	getTimetablesEmployeePrivileges?: GraphQLTypes["TimetablesEmployeePrivileges"] | undefined,
	listTimetablesEmployeePrivileges: Array<GraphQLTypes["TimetablesEmployeePrivileges"]>,
	paginateTimetablesEmployeePrivileges: GraphQLTypes["TimetablesEmployeePrivilegesConnection"],
	validateCreateTimetablesEmployeePrivileges: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetablesEmployeePrivileges: GraphQLTypes["_ValidationResult"],
	getTimetableDayNote?: GraphQLTypes["TimetableDayNote"] | undefined,
	listTimetableDayNote: Array<GraphQLTypes["TimetableDayNote"]>,
	paginateTimetableDayNote: GraphQLTypes["TimetableDayNoteConnection"],
	validateCreateTimetableDayNote: GraphQLTypes["_ValidationResult"],
	validateUpdateTimetableDayNote: GraphQLTypes["_ValidationResult"],
	getDeliveryMethodLocale?: GraphQLTypes["DeliveryMethodLocale"] | undefined,
	listDeliveryMethodLocale: Array<GraphQLTypes["DeliveryMethodLocale"]>,
	paginateDeliveryMethodLocale: GraphQLTypes["DeliveryMethodLocaleConnection"],
	validateCreateDeliveryMethodLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateDeliveryMethodLocale: GraphQLTypes["_ValidationResult"],
	getIngredientSupplier?: GraphQLTypes["IngredientSupplier"] | undefined,
	listIngredientSupplier: Array<GraphQLTypes["IngredientSupplier"]>,
	paginateIngredientSupplier: GraphQLTypes["IngredientSupplierConnection"],
	validateCreateIngredientSupplier: GraphQLTypes["_ValidationResult"],
	validateUpdateIngredientSupplier: GraphQLTypes["_ValidationResult"],
	getIngredientSupplierItem?: GraphQLTypes["IngredientSupplierItem"] | undefined,
	listIngredientSupplierItem: Array<GraphQLTypes["IngredientSupplierItem"]>,
	paginateIngredientSupplierItem: GraphQLTypes["IngredientSupplierItemConnection"],
	validateCreateIngredientSupplierItem: GraphQLTypes["_ValidationResult"],
	validateUpdateIngredientSupplierItem: GraphQLTypes["_ValidationResult"],
	getIngredientSupplierList?: GraphQLTypes["IngredientSupplierList"] | undefined,
	listIngredientSupplierList: Array<GraphQLTypes["IngredientSupplierList"]>,
	paginateIngredientSupplierList: GraphQLTypes["IngredientSupplierListConnection"],
	validateCreateIngredientSupplierList: GraphQLTypes["_ValidationResult"],
	validateUpdateIngredientSupplierList: GraphQLTypes["_ValidationResult"],
	getIngredientSupplierLocale?: GraphQLTypes["IngredientSupplierLocale"] | undefined,
	listIngredientSupplierLocale: Array<GraphQLTypes["IngredientSupplierLocale"]>,
	paginateIngredientSupplierLocale: GraphQLTypes["IngredientSupplierLocaleConnection"],
	validateCreateIngredientSupplierLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateIngredientSupplierLocale: GraphQLTypes["_ValidationResult"],
	getRedirect?: GraphQLTypes["Redirect"] | undefined,
	listRedirect: Array<GraphQLTypes["Redirect"]>,
	paginateRedirect: GraphQLTypes["RedirectConnection"],
	validateCreateRedirect: GraphQLTypes["_ValidationResult"],
	validateUpdateRedirect: GraphQLTypes["_ValidationResult"],
	getNutritionFacts?: GraphQLTypes["NutritionFacts"] | undefined,
	listNutritionFacts: Array<GraphQLTypes["NutritionFacts"]>,
	paginateNutritionFacts: GraphQLTypes["NutritionFactsConnection"],
	validateCreateNutritionFacts: GraphQLTypes["_ValidationResult"],
	validateUpdateNutritionFacts: GraphQLTypes["_ValidationResult"],
	getVenue?: GraphQLTypes["Venue"] | undefined,
	listVenue: Array<GraphQLTypes["Venue"]>,
	paginateVenue: GraphQLTypes["VenueConnection"],
	validateCreateVenue: GraphQLTypes["_ValidationResult"],
	validateUpdateVenue: GraphQLTypes["_ValidationResult"],
	getWorkspace?: GraphQLTypes["Workspace"] | undefined,
	listWorkspace: Array<GraphQLTypes["Workspace"]>,
	paginateWorkspace: GraphQLTypes["WorkspaceConnection"],
	validateCreateWorkspace: GraphQLTypes["_ValidationResult"],
	validateUpdateWorkspace: GraphQLTypes["_ValidationResult"],
	getInternalBuyer?: GraphQLTypes["InternalBuyer"] | undefined,
	listInternalBuyer: Array<GraphQLTypes["InternalBuyer"]>,
	paginateInternalBuyer: GraphQLTypes["InternalBuyerConnection"],
	validateCreateInternalBuyer: GraphQLTypes["_ValidationResult"],
	validateUpdateInternalBuyer: GraphQLTypes["_ValidationResult"],
	getCartSummary?: GraphQLTypes["CartSummary"] | undefined,
	listCartSummary: Array<GraphQLTypes["CartSummary"]>,
	paginateCartSummary: GraphQLTypes["CartSummaryConnection"],
	getOrderSummary?: GraphQLTypes["OrderSummary"] | undefined,
	listOrderSummary: Array<GraphQLTypes["OrderSummary"]>,
	paginateOrderSummary: GraphQLTypes["OrderSummaryConnection"],
	getCustomerSpending?: GraphQLTypes["CustomerSpending"] | undefined,
	listCustomerSpending: Array<GraphQLTypes["CustomerSpending"]>,
	paginateCustomerSpending: GraphQLTypes["CustomerSpendingConnection"],
	getOrderPaymentMetadata?: GraphQLTypes["OrderPaymentMetadata"] | undefined,
	listOrderPaymentMetadata: Array<GraphQLTypes["OrderPaymentMetadata"]>,
	paginateOrderPaymentMetadata: GraphQLTypes["OrderPaymentMetadataConnection"],
	getUserMetadata?: GraphQLTypes["UserMetadata"] | undefined,
	listUserMetadata: Array<GraphQLTypes["UserMetadata"]>,
	paginateUserMetadata: GraphQLTypes["UserMetadataConnection"],
	getCustomerTabMetadata?: GraphQLTypes["CustomerTabMetadata"] | undefined,
	listCustomerTabMetadata: Array<GraphQLTypes["CustomerTabMetadata"]>,
	paginateCustomerTabMetadata: GraphQLTypes["CustomerTabMetadataConnection"],
	getVenueEmployeeRole?: GraphQLTypes["VenueEmployeeRole"] | undefined,
	listVenueEmployeeRole: Array<GraphQLTypes["VenueEmployeeRole"]>,
	paginateVenueEmployeeRole: GraphQLTypes["VenueEmployeeRoleConnection"],
	validateCreateVenueEmployeeRole: GraphQLTypes["_ValidationResult"],
	validateUpdateVenueEmployeeRole: GraphQLTypes["_ValidationResult"],
	getIdentificationAttempt?: GraphQLTypes["IdentificationAttempt"] | undefined,
	listIdentificationAttempt: Array<GraphQLTypes["IdentificationAttempt"]>,
	paginateIdentificationAttempt: GraphQLTypes["IdentificationAttemptConnection"],
	validateCreateIdentificationAttempt: GraphQLTypes["_ValidationResult"],
	validateUpdateIdentificationAttempt: GraphQLTypes["_ValidationResult"],
	getIdentificationCode?: GraphQLTypes["IdentificationCode"] | undefined,
	listIdentificationCode: Array<GraphQLTypes["IdentificationCode"]>,
	paginateIdentificationCode: GraphQLTypes["IdentificationCodeConnection"],
	validateCreateIdentificationCode: GraphQLTypes["_ValidationResult"],
	validateUpdateIdentificationCode: GraphQLTypes["_ValidationResult"],
	getIdentificationCodeLocale?: GraphQLTypes["IdentificationCodeLocale"] | undefined,
	listIdentificationCodeLocale: Array<GraphQLTypes["IdentificationCodeLocale"]>,
	paginateIdentificationCodeLocale: GraphQLTypes["IdentificationCodeLocaleConnection"],
	validateCreateIdentificationCodeLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateIdentificationCodeLocale: GraphQLTypes["_ValidationResult"],
	getPipeline?: GraphQLTypes["Pipeline"] | undefined,
	listPipeline: Array<GraphQLTypes["Pipeline"]>,
	paginatePipeline: GraphQLTypes["PipelineConnection"],
	validateCreatePipeline: GraphQLTypes["_ValidationResult"],
	validateUpdatePipeline: GraphQLTypes["_ValidationResult"],
	getPipelineLead?: GraphQLTypes["PipelineLead"] | undefined,
	listPipelineLead: Array<GraphQLTypes["PipelineLead"]>,
	paginatePipelineLead: GraphQLTypes["PipelineLeadConnection"],
	validateCreatePipelineLead: GraphQLTypes["_ValidationResult"],
	validateUpdatePipelineLead: GraphQLTypes["_ValidationResult"],
	getPipelineStage?: GraphQLTypes["PipelineStage"] | undefined,
	listPipelineStage: Array<GraphQLTypes["PipelineStage"]>,
	paginatePipelineStage: GraphQLTypes["PipelineStageConnection"],
	validateCreatePipelineStage: GraphQLTypes["_ValidationResult"],
	validateUpdatePipelineStage: GraphQLTypes["_ValidationResult"],
	getPipelineStageItem?: GraphQLTypes["PipelineStageItem"] | undefined,
	listPipelineStageItem: Array<GraphQLTypes["PipelineStageItem"]>,
	paginatePipelineStageItem: GraphQLTypes["PipelineStageItemConnection"],
	validateCreatePipelineStageItem: GraphQLTypes["_ValidationResult"],
	validateUpdatePipelineStageItem: GraphQLTypes["_ValidationResult"],
	getPipelineStageLocale?: GraphQLTypes["PipelineStageLocale"] | undefined,
	listPipelineStageLocale: Array<GraphQLTypes["PipelineStageLocale"]>,
	paginatePipelineStageLocale: GraphQLTypes["PipelineStageLocaleConnection"],
	validateCreatePipelineStageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdatePipelineStageLocale: GraphQLTypes["_ValidationResult"],
	getSalesManager?: GraphQLTypes["SalesManager"] | undefined,
	listSalesManager: Array<GraphQLTypes["SalesManager"]>,
	paginateSalesManager: GraphQLTypes["SalesManagerConnection"],
	validateCreateSalesManager: GraphQLTypes["_ValidationResult"],
	validateUpdateSalesManager: GraphQLTypes["_ValidationResult"],
	getCashierManager?: GraphQLTypes["CashierManager"] | undefined,
	listCashierManager: Array<GraphQLTypes["CashierManager"]>,
	paginateCashierManager: GraphQLTypes["CashierManagerConnection"],
	validateCreateCashierManager: GraphQLTypes["_ValidationResult"],
	validateUpdateCashierManager: GraphQLTypes["_ValidationResult"],
	getUserRoles?: GraphQLTypes["UserRoles"] | undefined,
	listUserRoles: Array<GraphQLTypes["UserRoles"]>,
	paginateUserRoles: GraphQLTypes["UserRolesConnection"],
	getPointOfSaleApplicationDevice?: GraphQLTypes["PointOfSaleApplicationDevice"] | undefined,
	listPointOfSaleApplicationDevice: Array<GraphQLTypes["PointOfSaleApplicationDevice"]>,
	paginatePointOfSaleApplicationDevice: GraphQLTypes["PointOfSaleApplicationDeviceConnection"],
	validateCreatePointOfSaleApplicationDevice: GraphQLTypes["_ValidationResult"],
	validateUpdatePointOfSaleApplicationDevice: GraphQLTypes["_ValidationResult"],
	getPointOfSaleTerminal?: GraphQLTypes["PointOfSaleTerminal"] | undefined,
	listPointOfSaleTerminal: Array<GraphQLTypes["PointOfSaleTerminal"]>,
	paginatePointOfSaleTerminal: GraphQLTypes["PointOfSaleTerminalConnection"],
	validateCreatePointOfSaleTerminal: GraphQLTypes["_ValidationResult"],
	validateUpdatePointOfSaleTerminal: GraphQLTypes["_ValidationResult"],
	getPipelineStageSentiment?: GraphQLTypes["PipelineStageSentiment"] | undefined,
	listPipelineStageSentiment: Array<GraphQLTypes["PipelineStageSentiment"]>,
	paginatePipelineStageSentiment: GraphQLTypes["PipelineStageSentimentConnection"],
	validateCreatePipelineStageSentiment: GraphQLTypes["_ValidationResult"],
	validateUpdatePipelineStageSentiment: GraphQLTypes["_ValidationResult"],
	getDeviceIdentifier?: GraphQLTypes["DeviceIdentifier"] | undefined,
	listDeviceIdentifier: Array<GraphQLTypes["DeviceIdentifier"]>,
	paginateDeviceIdentifier: GraphQLTypes["DeviceIdentifierConnection"],
	validateCreateDeviceIdentifier: GraphQLTypes["_ValidationResult"],
	validateUpdateDeviceIdentifier: GraphQLTypes["_ValidationResult"],
	getDeviceIdentifierMetadata?: GraphQLTypes["DeviceIdentifierMetadata"] | undefined,
	listDeviceIdentifierMetadata: Array<GraphQLTypes["DeviceIdentifierMetadata"]>,
	paginateDeviceIdentifierMetadata: GraphQLTypes["DeviceIdentifierMetadataConnection"],
	getPointOfSalePrinter?: GraphQLTypes["PointOfSalePrinter"] | undefined,
	listPointOfSalePrinter: Array<GraphQLTypes["PointOfSalePrinter"]>,
	paginatePointOfSalePrinter: GraphQLTypes["PointOfSalePrinterConnection"],
	validateCreatePointOfSalePrinter: GraphQLTypes["_ValidationResult"],
	validateUpdatePointOfSalePrinter: GraphQLTypes["_ValidationResult"],
	getGratuity?: GraphQLTypes["Gratuity"] | undefined,
	listGratuity: Array<GraphQLTypes["Gratuity"]>,
	paginateGratuity: GraphQLTypes["GratuityConnection"],
	validateCreateGratuity: GraphQLTypes["_ValidationResult"],
	validateUpdateGratuity: GraphQLTypes["_ValidationResult"],
	getFulfillmentNote?: GraphQLTypes["FulfillmentNote"] | undefined,
	listFulfillmentNote: Array<GraphQLTypes["FulfillmentNote"]>,
	paginateFulfillmentNote: GraphQLTypes["FulfillmentNoteConnection"],
	validateCreateFulfillmentNote: GraphQLTypes["_ValidationResult"],
	validateUpdateFulfillmentNote: GraphQLTypes["_ValidationResult"],
	getCustomerMetadata?: GraphQLTypes["CustomerMetadata"] | undefined,
	listCustomerMetadata: Array<GraphQLTypes["CustomerMetadata"]>,
	paginateCustomerMetadata: GraphQLTypes["CustomerMetadataConnection"],
	getLeadForm?: GraphQLTypes["LeadForm"] | undefined,
	listLeadForm: Array<GraphQLTypes["LeadForm"]>,
	paginateLeadForm: GraphQLTypes["LeadFormConnection"],
	validateCreateLeadForm: GraphQLTypes["_ValidationResult"],
	validateUpdateLeadForm: GraphQLTypes["_ValidationResult"],
	getSubscriptionBox?: GraphQLTypes["SubscriptionBox"] | undefined,
	listSubscriptionBox: Array<GraphQLTypes["SubscriptionBox"]>,
	paginateSubscriptionBox: GraphQLTypes["SubscriptionBoxConnection"],
	validateCreateSubscriptionBox: GraphQLTypes["_ValidationResult"],
	validateUpdateSubscriptionBox: GraphQLTypes["_ValidationResult"],
	getSubscriptionBoxLocale?: GraphQLTypes["SubscriptionBoxLocale"] | undefined,
	listSubscriptionBoxLocale: Array<GraphQLTypes["SubscriptionBoxLocale"]>,
	paginateSubscriptionBoxLocale: GraphQLTypes["SubscriptionBoxLocaleConnection"],
	validateCreateSubscriptionBoxLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateSubscriptionBoxLocale: GraphQLTypes["_ValidationResult"],
	getTimetableDayMetadata?: GraphQLTypes["TimetableDayMetadata"] | undefined,
	listTimetableDayMetadata: Array<GraphQLTypes["TimetableDayMetadata"]>,
	paginateTimetableDayMetadata: GraphQLTypes["TimetableDayMetadataConnection"],
	getBusinessService?: GraphQLTypes["BusinessService"] | undefined,
	listBusinessService: Array<GraphQLTypes["BusinessService"]>,
	paginateBusinessService: GraphQLTypes["BusinessServiceConnection"],
	validateCreateBusinessService: GraphQLTypes["_ValidationResult"],
	validateUpdateBusinessService: GraphQLTypes["_ValidationResult"],
	getBusinessServiceEvent?: GraphQLTypes["BusinessServiceEvent"] | undefined,
	listBusinessServiceEvent: Array<GraphQLTypes["BusinessServiceEvent"]>,
	paginateBusinessServiceEvent: GraphQLTypes["BusinessServiceEventConnection"],
	validateCreateBusinessServiceEvent: GraphQLTypes["_ValidationResult"],
	validateUpdateBusinessServiceEvent: GraphQLTypes["_ValidationResult"],
	getBusinessServiceLocale?: GraphQLTypes["BusinessServiceLocale"] | undefined,
	listBusinessServiceLocale: Array<GraphQLTypes["BusinessServiceLocale"]>,
	paginateBusinessServiceLocale: GraphQLTypes["BusinessServiceLocaleConnection"],
	validateCreateBusinessServiceLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateBusinessServiceLocale: GraphQLTypes["_ValidationResult"],
	getGridTileItem?: GraphQLTypes["GridTileItem"] | undefined,
	listGridTileItem: Array<GraphQLTypes["GridTileItem"]>,
	paginateGridTileItem: GraphQLTypes["GridTileItemConnection"],
	validateCreateGridTileItem: GraphQLTypes["_ValidationResult"],
	validateUpdateGridTileItem: GraphQLTypes["_ValidationResult"],
	getGridTiles?: GraphQLTypes["GridTiles"] | undefined,
	listGridTiles: Array<GraphQLTypes["GridTiles"]>,
	paginateGridTiles: GraphQLTypes["GridTilesConnection"],
	validateCreateGridTiles: GraphQLTypes["_ValidationResult"],
	validateUpdateGridTiles: GraphQLTypes["_ValidationResult"],
	getArea?: GraphQLTypes["Area"] | undefined,
	listArea: Array<GraphQLTypes["Area"]>,
	paginateArea: GraphQLTypes["AreaConnection"],
	validateCreateArea: GraphQLTypes["_ValidationResult"],
	validateUpdateArea: GraphQLTypes["_ValidationResult"],
	getPosition?: GraphQLTypes["Position"] | undefined,
	listPosition: Array<GraphQLTypes["Position"]>,
	paginatePosition: GraphQLTypes["PositionConnection"],
	validateCreatePosition: GraphQLTypes["_ValidationResult"],
	validateUpdatePosition: GraphQLTypes["_ValidationResult"],
	getStatsEnabledWidgetType?: GraphQLTypes["StatsEnabledWidgetType"] | undefined,
	listStatsEnabledWidgetType: Array<GraphQLTypes["StatsEnabledWidgetType"]>,
	paginateStatsEnabledWidgetType: GraphQLTypes["StatsEnabledWidgetTypeConnection"],
	validateCreateStatsEnabledWidgetType: GraphQLTypes["_ValidationResult"],
	validateUpdateStatsEnabledWidgetType: GraphQLTypes["_ValidationResult"],
	getStatsWidget?: GraphQLTypes["StatsWidget"] | undefined,
	listStatsWidget: Array<GraphQLTypes["StatsWidget"]>,
	paginateStatsWidget: GraphQLTypes["StatsWidgetConnection"],
	validateCreateStatsWidget: GraphQLTypes["_ValidationResult"],
	validateUpdateStatsWidget: GraphQLTypes["_ValidationResult"],
	getStatsWidgetsLayout?: GraphQLTypes["StatsWidgetsLayout"] | undefined,
	listStatsWidgetsLayout: Array<GraphQLTypes["StatsWidgetsLayout"]>,
	paginateStatsWidgetsLayout: GraphQLTypes["StatsWidgetsLayoutConnection"],
	validateCreateStatsWidgetsLayout: GraphQLTypes["_ValidationResult"],
	validateUpdateStatsWidgetsLayout: GraphQLTypes["_ValidationResult"],
	getSeat?: GraphQLTypes["Seat"] | undefined,
	listSeat: Array<GraphQLTypes["Seat"]>,
	paginateSeat: GraphQLTypes["SeatConnection"],
	validateCreateSeat: GraphQLTypes["_ValidationResult"],
	validateUpdateSeat: GraphQLTypes["_ValidationResult"],
	getTable?: GraphQLTypes["Table"] | undefined,
	listTable: Array<GraphQLTypes["Table"]>,
	paginateTable: GraphQLTypes["TableConnection"],
	validateCreateTable: GraphQLTypes["_ValidationResult"],
	validateUpdateTable: GraphQLTypes["_ValidationResult"],
	getStatsPage?: GraphQLTypes["StatsPage"] | undefined,
	listStatsPage: Array<GraphQLTypes["StatsPage"]>,
	paginateStatsPage: GraphQLTypes["StatsPageConnection"],
	validateCreateStatsPage: GraphQLTypes["_ValidationResult"],
	validateUpdateStatsPage: GraphQLTypes["_ValidationResult"],
	getUnassignReason?: GraphQLTypes["UnassignReason"] | undefined,
	listUnassignReason: Array<GraphQLTypes["UnassignReason"]>,
	paginateUnassignReason: GraphQLTypes["UnassignReasonConnection"],
	validateCreateUnassignReason: GraphQLTypes["_ValidationResult"],
	validateUpdateUnassignReason: GraphQLTypes["_ValidationResult"],
	getDoubleshotCoffeeEquipment?: GraphQLTypes["DoubleshotCoffeeEquipment"] | undefined,
	listDoubleshotCoffeeEquipment: Array<GraphQLTypes["DoubleshotCoffeeEquipment"]>,
	paginateDoubleshotCoffeeEquipment: GraphQLTypes["DoubleshotCoffeeEquipmentConnection"],
	validateCreateDoubleshotCoffeeEquipment: GraphQLTypes["_ValidationResult"],
	validateUpdateDoubleshotCoffeeEquipment: GraphQLTypes["_ValidationResult"],
	getExpense?: GraphQLTypes["Expense"] | undefined,
	listExpense: Array<GraphQLTypes["Expense"]>,
	paginateExpense: GraphQLTypes["ExpenseConnection"],
	validateCreateExpense: GraphQLTypes["_ValidationResult"],
	validateUpdateExpense: GraphQLTypes["_ValidationResult"],
	getExpenseCategory?: GraphQLTypes["ExpenseCategory"] | undefined,
	listExpenseCategory: Array<GraphQLTypes["ExpenseCategory"]>,
	paginateExpenseCategory: GraphQLTypes["ExpenseCategoryConnection"],
	validateCreateExpenseCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateExpenseCategory: GraphQLTypes["_ValidationResult"],
	getExpenseChange?: GraphQLTypes["ExpenseChange"] | undefined,
	listExpenseChange: Array<GraphQLTypes["ExpenseChange"]>,
	paginateExpenseChange: GraphQLTypes["ExpenseChangeConnection"],
	validateCreateExpenseChange: GraphQLTypes["_ValidationResult"],
	validateUpdateExpenseChange: GraphQLTypes["_ValidationResult"],
	getExpenseDocument?: GraphQLTypes["ExpenseDocument"] | undefined,
	listExpenseDocument: Array<GraphQLTypes["ExpenseDocument"]>,
	paginateExpenseDocument: GraphQLTypes["ExpenseDocumentConnection"],
	validateCreateExpenseDocument: GraphQLTypes["_ValidationResult"],
	validateUpdateExpenseDocument: GraphQLTypes["_ValidationResult"],
	getRevenuePrediction?: GraphQLTypes["RevenuePrediction"] | undefined,
	listRevenuePrediction: Array<GraphQLTypes["RevenuePrediction"]>,
	paginateRevenuePrediction: GraphQLTypes["RevenuePredictionConnection"],
	validateCreateRevenuePrediction: GraphQLTypes["_ValidationResult"],
	validateUpdateRevenuePrediction: GraphQLTypes["_ValidationResult"],
	getRevenuePredictionChange?: GraphQLTypes["RevenuePredictionChange"] | undefined,
	listRevenuePredictionChange: Array<GraphQLTypes["RevenuePredictionChange"]>,
	paginateRevenuePredictionChange: GraphQLTypes["RevenuePredictionChangeConnection"],
	validateCreateRevenuePredictionChange: GraphQLTypes["_ValidationResult"],
	validateUpdateRevenuePredictionChange: GraphQLTypes["_ValidationResult"],
	getFile?: GraphQLTypes["File"] | undefined,
	listFile: Array<GraphQLTypes["File"]>,
	paginateFile: GraphQLTypes["FileConnection"],
	validateCreateFile: GraphQLTypes["_ValidationResult"],
	validateUpdateFile: GraphQLTypes["_ValidationResult"],
	getExpenseTerm?: GraphQLTypes["ExpenseTerm"] | undefined,
	listExpenseTerm: Array<GraphQLTypes["ExpenseTerm"]>,
	paginateExpenseTerm: GraphQLTypes["ExpenseTermConnection"],
	getLine?: GraphQLTypes["Line"] | undefined,
	listLine: Array<GraphQLTypes["Line"]>,
	paginateLine: GraphQLTypes["LineConnection"],
	validateCreateLine: GraphQLTypes["_ValidationResult"],
	validateUpdateLine: GraphQLTypes["_ValidationResult"],
	getFinancesBalanceItem?: GraphQLTypes["FinancesBalanceItem"] | undefined,
	listFinancesBalanceItem: Array<GraphQLTypes["FinancesBalanceItem"]>,
	paginateFinancesBalanceItem: GraphQLTypes["FinancesBalanceItemConnection"],
	validateCreateFinancesBalanceItem: GraphQLTypes["_ValidationResult"],
	validateUpdateFinancesBalanceItem: GraphQLTypes["_ValidationResult"],
	getRevenuePredictionTerm?: GraphQLTypes["RevenuePredictionTerm"] | undefined,
	listRevenuePredictionTerm: Array<GraphQLTypes["RevenuePredictionTerm"]>,
	paginateRevenuePredictionTerm: GraphQLTypes["RevenuePredictionTermConnection"],
	getOrderPaymentStatsByDay?: GraphQLTypes["OrderPaymentStatsByDay"] | undefined,
	listOrderPaymentStatsByDay: Array<GraphQLTypes["OrderPaymentStatsByDay"]>,
	paginateOrderPaymentStatsByDay: GraphQLTypes["OrderPaymentStatsByDayConnection"],
	getWoltDriveDelivery?: GraphQLTypes["WoltDriveDelivery"] | undefined,
	listWoltDriveDelivery: Array<GraphQLTypes["WoltDriveDelivery"]>,
	paginateWoltDriveDelivery: GraphQLTypes["WoltDriveDeliveryConnection"],
	validateCreateWoltDriveDelivery: GraphQLTypes["_ValidationResult"],
	validateUpdateWoltDriveDelivery: GraphQLTypes["_ValidationResult"]
};
	["Info"]: {
	__typename: "Info",
	description?: string | undefined
};
	["Mutation"]: {
	__typename: "Mutation",
	createAddress: GraphQLTypes["AddressCreateResult"],
	deleteAddress: GraphQLTypes["AddressDeleteResult"],
	updateAddress: GraphQLTypes["AddressUpdateResult"],
	upsertAddress: GraphQLTypes["AddressUpsertResult"],
	createCountry: GraphQLTypes["CountryCreateResult"],
	deleteCountry: GraphQLTypes["CountryDeleteResult"],
	updateCountry: GraphQLTypes["CountryUpdateResult"],
	upsertCountry: GraphQLTypes["CountryUpsertResult"],
	createChannel: GraphQLTypes["ChannelCreateResult"],
	deleteChannel: GraphQLTypes["ChannelDeleteResult"],
	updateChannel: GraphQLTypes["ChannelUpdateResult"],
	upsertChannel: GraphQLTypes["ChannelUpsertResult"],
	createChannelPayment: GraphQLTypes["ChannelPaymentCreateResult"],
	deleteChannelPayment: GraphQLTypes["ChannelPaymentDeleteResult"],
	updateChannelPayment: GraphQLTypes["ChannelPaymentUpdateResult"],
	upsertChannelPayment: GraphQLTypes["ChannelPaymentUpsertResult"],
	createChannelDelivery: GraphQLTypes["ChannelDeliveryCreateResult"],
	deleteChannelDelivery: GraphQLTypes["ChannelDeliveryDeleteResult"],
	updateChannelDelivery: GraphQLTypes["ChannelDeliveryUpdateResult"],
	upsertChannelDelivery: GraphQLTypes["ChannelDeliveryUpsertResult"],
	createCustomer: GraphQLTypes["CustomerCreateResult"],
	deleteCustomer: GraphQLTypes["CustomerDeleteResult"],
	updateCustomer: GraphQLTypes["CustomerUpdateResult"],
	upsertCustomer: GraphQLTypes["CustomerUpsertResult"],
	createCustomerCredit: GraphQLTypes["CustomerCreditCreateResult"],
	deleteCustomerCredit: GraphQLTypes["CustomerCreditDeleteResult"],
	updateCustomerCredit: GraphQLTypes["CustomerCreditUpdateResult"],
	upsertCustomerCredit: GraphQLTypes["CustomerCreditUpsertResult"],
	createCustomerGroup: GraphQLTypes["CustomerGroupCreateResult"],
	deleteCustomerGroup: GraphQLTypes["CustomerGroupDeleteResult"],
	updateCustomerGroup: GraphQLTypes["CustomerGroupUpdateResult"],
	upsertCustomerGroup: GraphQLTypes["CustomerGroupUpsertResult"],
	createCustomerPaymentMethod: GraphQLTypes["CustomerPaymentMethodCreateResult"],
	deleteCustomerPaymentMethod: GraphQLTypes["CustomerPaymentMethodDeleteResult"],
	updateCustomerPaymentMethod: GraphQLTypes["CustomerPaymentMethodUpdateResult"],
	upsertCustomerPaymentMethod: GraphQLTypes["CustomerPaymentMethodUpsertResult"],
	createDeliveryMethod: GraphQLTypes["DeliveryMethodCreateResult"],
	deleteDeliveryMethod: GraphQLTypes["DeliveryMethodDeleteResult"],
	updateDeliveryMethod: GraphQLTypes["DeliveryMethodUpdateResult"],
	upsertDeliveryMethod: GraphQLTypes["DeliveryMethodUpsertResult"],
	createOrder: GraphQLTypes["OrderCreateResult"],
	deleteOrder: GraphQLTypes["OrderDeleteResult"],
	updateOrder: GraphQLTypes["OrderUpdateResult"],
	upsertOrder: GraphQLTypes["OrderUpsertResult"],
	createOrderDiscount: GraphQLTypes["OrderDiscountCreateResult"],
	deleteOrderDiscount: GraphQLTypes["OrderDiscountDeleteResult"],
	updateOrderDiscount: GraphQLTypes["OrderDiscountUpdateResult"],
	upsertOrderDiscount: GraphQLTypes["OrderDiscountUpsertResult"],
	createOrderPayment: GraphQLTypes["OrderPaymentCreateResult"],
	deleteOrderPayment: GraphQLTypes["OrderPaymentDeleteResult"],
	updateOrderPayment: GraphQLTypes["OrderPaymentUpdateResult"],
	upsertOrderPayment: GraphQLTypes["OrderPaymentUpsertResult"],
	createOrderDelivery: GraphQLTypes["OrderDeliveryCreateResult"],
	deleteOrderDelivery: GraphQLTypes["OrderDeliveryDeleteResult"],
	updateOrderDelivery: GraphQLTypes["OrderDeliveryUpdateResult"],
	upsertOrderDelivery: GraphQLTypes["OrderDeliveryUpsertResult"],
	createOrderItem: GraphQLTypes["OrderItemCreateResult"],
	deleteOrderItem: GraphQLTypes["OrderItemDeleteResult"],
	updateOrderItem: GraphQLTypes["OrderItemUpdateResult"],
	upsertOrderItem: GraphQLTypes["OrderItemUpsertResult"],
	createPaymentMethod: GraphQLTypes["PaymentMethodCreateResult"],
	deletePaymentMethod: GraphQLTypes["PaymentMethodDeleteResult"],
	updatePaymentMethod: GraphQLTypes["PaymentMethodUpdateResult"],
	upsertPaymentMethod: GraphQLTypes["PaymentMethodUpsertResult"],
	createVatRate: GraphQLTypes["VatRateCreateResult"],
	deleteVatRate: GraphQLTypes["VatRateDeleteResult"],
	updateVatRate: GraphQLTypes["VatRateUpdateResult"],
	upsertVatRate: GraphQLTypes["VatRateUpsertResult"],
	createProduct: GraphQLTypes["ProductCreateResult"],
	deleteProduct: GraphQLTypes["ProductDeleteResult"],
	updateProduct: GraphQLTypes["ProductUpdateResult"],
	upsertProduct: GraphQLTypes["ProductUpsertResult"],
	createProductStock: GraphQLTypes["ProductStockCreateResult"],
	deleteProductStock: GraphQLTypes["ProductStockDeleteResult"],
	updateProductStock: GraphQLTypes["ProductStockUpdateResult"],
	upsertProductStock: GraphQLTypes["ProductStockUpsertResult"],
	createProductPacking: GraphQLTypes["ProductPackingCreateResult"],
	deleteProductPacking: GraphQLTypes["ProductPackingDeleteResult"],
	updateProductPacking: GraphQLTypes["ProductPackingUpdateResult"],
	upsertProductPacking: GraphQLTypes["ProductPackingUpsertResult"],
	createProductGroupPrice: GraphQLTypes["ProductGroupPriceCreateResult"],
	deleteProductGroupPrice: GraphQLTypes["ProductGroupPriceDeleteResult"],
	updateProductGroupPrice: GraphQLTypes["ProductGroupPriceUpdateResult"],
	upsertProductGroupPrice: GraphQLTypes["ProductGroupPriceUpsertResult"],
	createProductRecipe: GraphQLTypes["ProductRecipeCreateResult"],
	deleteProductRecipe: GraphQLTypes["ProductRecipeDeleteResult"],
	updateProductRecipe: GraphQLTypes["ProductRecipeUpdateResult"],
	upsertProductRecipe: GraphQLTypes["ProductRecipeUpsertResult"],
	createProductCategory: GraphQLTypes["ProductCategoryCreateResult"],
	deleteProductCategory: GraphQLTypes["ProductCategoryDeleteResult"],
	updateProductCategory: GraphQLTypes["ProductCategoryUpdateResult"],
	upsertProductCategory: GraphQLTypes["ProductCategoryUpsertResult"],
	createStore: GraphQLTypes["StoreCreateResult"],
	deleteStore: GraphQLTypes["StoreDeleteResult"],
	updateStore: GraphQLTypes["StoreUpdateResult"],
	upsertStore: GraphQLTypes["StoreUpsertResult"],
	createTag: GraphQLTypes["TagCreateResult"],
	deleteTag: GraphQLTypes["TagDeleteResult"],
	updateTag: GraphQLTypes["TagUpdateResult"],
	upsertTag: GraphQLTypes["TagUpsertResult"],
	createImage: GraphQLTypes["ImageCreateResult"],
	deleteImage: GraphQLTypes["ImageDeleteResult"],
	updateImage: GraphQLTypes["ImageUpdateResult"],
	upsertImage: GraphQLTypes["ImageUpsertResult"],
	createBusinessCategory: GraphQLTypes["BusinessCategoryCreateResult"],
	deleteBusinessCategory: GraphQLTypes["BusinessCategoryDeleteResult"],
	updateBusinessCategory: GraphQLTypes["BusinessCategoryUpdateResult"],
	upsertBusinessCategory: GraphQLTypes["BusinessCategoryUpsertResult"],
	createProductList: GraphQLTypes["ProductListCreateResult"],
	deleteProductList: GraphQLTypes["ProductListDeleteResult"],
	updateProductList: GraphQLTypes["ProductListUpdateResult"],
	upsertProductList: GraphQLTypes["ProductListUpsertResult"],
	createProductListItem: GraphQLTypes["ProductListItemCreateResult"],
	deleteProductListItem: GraphQLTypes["ProductListItemDeleteResult"],
	updateProductListItem: GraphQLTypes["ProductListItemUpdateResult"],
	upsertProductListItem: GraphQLTypes["ProductListItemUpsertResult"],
	createProductCategoryList: GraphQLTypes["ProductCategoryListCreateResult"],
	deleteProductCategoryList: GraphQLTypes["ProductCategoryListDeleteResult"],
	updateProductCategoryList: GraphQLTypes["ProductCategoryListUpdateResult"],
	upsertProductCategoryList: GraphQLTypes["ProductCategoryListUpsertResult"],
	createProductCategoryListItem: GraphQLTypes["ProductCategoryListItemCreateResult"],
	deleteProductCategoryListItem: GraphQLTypes["ProductCategoryListItemDeleteResult"],
	updateProductCategoryListItem: GraphQLTypes["ProductCategoryListItemUpdateResult"],
	upsertProductCategoryListItem: GraphQLTypes["ProductCategoryListItemUpsertResult"],
	createBusinessCategoryLocale: GraphQLTypes["BusinessCategoryLocaleCreateResult"],
	deleteBusinessCategoryLocale: GraphQLTypes["BusinessCategoryLocaleDeleteResult"],
	updateBusinessCategoryLocale: GraphQLTypes["BusinessCategoryLocaleUpdateResult"],
	upsertBusinessCategoryLocale: GraphQLTypes["BusinessCategoryLocaleUpsertResult"],
	createLocale: GraphQLTypes["LocaleCreateResult"],
	deleteLocale: GraphQLTypes["LocaleDeleteResult"],
	updateLocale: GraphQLTypes["LocaleUpdateResult"],
	upsertLocale: GraphQLTypes["LocaleUpsertResult"],
	createProductCategoryListLocale: GraphQLTypes["ProductCategoryListLocaleCreateResult"],
	deleteProductCategoryListLocale: GraphQLTypes["ProductCategoryListLocaleDeleteResult"],
	updateProductCategoryListLocale: GraphQLTypes["ProductCategoryListLocaleUpdateResult"],
	upsertProductCategoryListLocale: GraphQLTypes["ProductCategoryListLocaleUpsertResult"],
	createCustomerName: GraphQLTypes["CustomerNameCreateResult"],
	deleteCustomerName: GraphQLTypes["CustomerNameDeleteResult"],
	updateCustomerName: GraphQLTypes["CustomerNameUpdateResult"],
	upsertCustomerName: GraphQLTypes["CustomerNameUpsertResult"],
	createCustomerAlias: GraphQLTypes["CustomerAliasCreateResult"],
	deleteCustomerAlias: GraphQLTypes["CustomerAliasDeleteResult"],
	updateCustomerAlias: GraphQLTypes["CustomerAliasUpdateResult"],
	upsertCustomerAlias: GraphQLTypes["CustomerAliasUpsertResult"],
	createProductIngredientItem: GraphQLTypes["ProductIngredientItemCreateResult"],
	deleteProductIngredientItem: GraphQLTypes["ProductIngredientItemDeleteResult"],
	updateProductIngredientItem: GraphQLTypes["ProductIngredientItemUpdateResult"],
	upsertProductIngredientItem: GraphQLTypes["ProductIngredientItemUpsertResult"],
	createProductIngredientItemQuantity: GraphQLTypes["ProductIngredientItemQuantityCreateResult"],
	deleteProductIngredientItemQuantity: GraphQLTypes["ProductIngredientItemQuantityDeleteResult"],
	updateProductIngredientItemQuantity: GraphQLTypes["ProductIngredientItemQuantityUpdateResult"],
	upsertProductIngredientItemQuantity: GraphQLTypes["ProductIngredientItemQuantityUpsertResult"],
	createProductIngredientItemQuantityUnit: GraphQLTypes["ProductIngredientItemQuantityUnitCreateResult"],
	deleteProductIngredientItemQuantityUnit: GraphQLTypes["ProductIngredientItemQuantityUnitDeleteResult"],
	updateProductIngredientItemQuantityUnit: GraphQLTypes["ProductIngredientItemQuantityUnitUpdateResult"],
	upsertProductIngredientItemQuantityUnit: GraphQLTypes["ProductIngredientItemQuantityUnitUpsertResult"],
	createProductIngredient: GraphQLTypes["ProductIngredientCreateResult"],
	deleteProductIngredient: GraphQLTypes["ProductIngredientDeleteResult"],
	updateProductIngredient: GraphQLTypes["ProductIngredientUpdateResult"],
	upsertProductIngredient: GraphQLTypes["ProductIngredientUpsertResult"],
	createCustomerIngredientRating: GraphQLTypes["CustomerIngredientRatingCreateResult"],
	deleteCustomerIngredientRating: GraphQLTypes["CustomerIngredientRatingDeleteResult"],
	updateCustomerIngredientRating: GraphQLTypes["CustomerIngredientRatingUpdateResult"],
	upsertCustomerIngredientRating: GraphQLTypes["CustomerIngredientRatingUpsertResult"],
	createProductIngredientRating: GraphQLTypes["ProductIngredientRatingCreateResult"],
	deleteProductIngredientRating: GraphQLTypes["ProductIngredientRatingDeleteResult"],
	updateProductIngredientRating: GraphQLTypes["ProductIngredientRatingUpdateResult"],
	upsertProductIngredientRating: GraphQLTypes["ProductIngredientRatingUpsertResult"],
	createProductIngredientLocale: GraphQLTypes["ProductIngredientLocaleCreateResult"],
	deleteProductIngredientLocale: GraphQLTypes["ProductIngredientLocaleDeleteResult"],
	updateProductIngredientLocale: GraphQLTypes["ProductIngredientLocaleUpdateResult"],
	upsertProductIngredientLocale: GraphQLTypes["ProductIngredientLocaleUpsertResult"],
	createOrderRecurrence: GraphQLTypes["OrderRecurrenceCreateResult"],
	deleteOrderRecurrence: GraphQLTypes["OrderRecurrenceDeleteResult"],
	updateOrderRecurrence: GraphQLTypes["OrderRecurrenceUpdateResult"],
	upsertOrderRecurrence: GraphQLTypes["OrderRecurrenceUpsertResult"],
	createOrderRecurrenceLocale: GraphQLTypes["OrderRecurrenceLocaleCreateResult"],
	deleteOrderRecurrenceLocale: GraphQLTypes["OrderRecurrenceLocaleDeleteResult"],
	updateOrderRecurrenceLocale: GraphQLTypes["OrderRecurrenceLocaleUpdateResult"],
	upsertOrderRecurrenceLocale: GraphQLTypes["OrderRecurrenceLocaleUpsertResult"],
	createBusinessCustomer: GraphQLTypes["BusinessCustomerCreateResult"],
	deleteBusinessCustomer: GraphQLTypes["BusinessCustomerDeleteResult"],
	updateBusinessCustomer: GraphQLTypes["BusinessCustomerUpdateResult"],
	upsertBusinessCustomer: GraphQLTypes["BusinessCustomerUpsertResult"],
	createPointOfSale: GraphQLTypes["PointOfSaleCreateResult"],
	deletePointOfSale: GraphQLTypes["PointOfSaleDeleteResult"],
	updatePointOfSale: GraphQLTypes["PointOfSaleUpdateResult"],
	upsertPointOfSale: GraphQLTypes["PointOfSaleUpsertResult"],
	createStaff: GraphQLTypes["StaffCreateResult"],
	deleteStaff: GraphQLTypes["StaffDeleteResult"],
	updateStaff: GraphQLTypes["StaffUpdateResult"],
	upsertStaff: GraphQLTypes["StaffUpsertResult"],
	createBlog: GraphQLTypes["BlogCreateResult"],
	deleteBlog: GraphQLTypes["BlogDeleteResult"],
	updateBlog: GraphQLTypes["BlogUpdateResult"],
	upsertBlog: GraphQLTypes["BlogUpsertResult"],
	createBlogLocale: GraphQLTypes["BlogLocaleCreateResult"],
	deleteBlogLocale: GraphQLTypes["BlogLocaleDeleteResult"],
	updateBlogLocale: GraphQLTypes["BlogLocaleUpdateResult"],
	upsertBlogLocale: GraphQLTypes["BlogLocaleUpsertResult"],
	createBlogPost: GraphQLTypes["BlogPostCreateResult"],
	deleteBlogPost: GraphQLTypes["BlogPostDeleteResult"],
	updateBlogPost: GraphQLTypes["BlogPostUpdateResult"],
	upsertBlogPost: GraphQLTypes["BlogPostUpsertResult"],
	createBlogPostLocale: GraphQLTypes["BlogPostLocaleCreateResult"],
	deleteBlogPostLocale: GraphQLTypes["BlogPostLocaleDeleteResult"],
	updateBlogPostLocale: GraphQLTypes["BlogPostLocaleUpdateResult"],
	upsertBlogPostLocale: GraphQLTypes["BlogPostLocaleUpsertResult"],
	createColorPallete: GraphQLTypes["ColorPalleteCreateResult"],
	deleteColorPallete: GraphQLTypes["ColorPalleteDeleteResult"],
	updateColorPallete: GraphQLTypes["ColorPalleteUpdateResult"],
	upsertColorPallete: GraphQLTypes["ColorPalleteUpsertResult"],
	createContent: GraphQLTypes["ContentCreateResult"],
	deleteContent: GraphQLTypes["ContentDeleteResult"],
	updateContent: GraphQLTypes["ContentUpdateResult"],
	upsertContent: GraphQLTypes["ContentUpsertResult"],
	createContentBlock: GraphQLTypes["ContentBlockCreateResult"],
	deleteContentBlock: GraphQLTypes["ContentBlockDeleteResult"],
	updateContentBlock: GraphQLTypes["ContentBlockUpdateResult"],
	upsertContentBlock: GraphQLTypes["ContentBlockUpsertResult"],
	createContentReference: GraphQLTypes["ContentReferenceCreateResult"],
	deleteContentReference: GraphQLTypes["ContentReferenceDeleteResult"],
	updateContentReference: GraphQLTypes["ContentReferenceUpdateResult"],
	upsertContentReference: GraphQLTypes["ContentReferenceUpsertResult"],
	createBlogPostList: GraphQLTypes["BlogPostListCreateResult"],
	deleteBlogPostList: GraphQLTypes["BlogPostListDeleteResult"],
	updateBlogPostList: GraphQLTypes["BlogPostListUpdateResult"],
	upsertBlogPostList: GraphQLTypes["BlogPostListUpsertResult"],
	createBlogPostListItem: GraphQLTypes["BlogPostListItemCreateResult"],
	deleteBlogPostListItem: GraphQLTypes["BlogPostListItemDeleteResult"],
	updateBlogPostListItem: GraphQLTypes["BlogPostListItemUpdateResult"],
	upsertBlogPostListItem: GraphQLTypes["BlogPostListItemUpsertResult"],
	createLinkList: GraphQLTypes["LinkListCreateResult"],
	deleteLinkList: GraphQLTypes["LinkListDeleteResult"],
	updateLinkList: GraphQLTypes["LinkListUpdateResult"],
	upsertLinkList: GraphQLTypes["LinkListUpsertResult"],
	createLinkListItem: GraphQLTypes["LinkListItemCreateResult"],
	deleteLinkListItem: GraphQLTypes["LinkListItemDeleteResult"],
	updateLinkListItem: GraphQLTypes["LinkListItemUpdateResult"],
	upsertLinkListItem: GraphQLTypes["LinkListItemUpsertResult"],
	createCover: GraphQLTypes["CoverCreateResult"],
	deleteCover: GraphQLTypes["CoverDeleteResult"],
	updateCover: GraphQLTypes["CoverUpdateResult"],
	upsertCover: GraphQLTypes["CoverUpsertResult"],
	createLink: GraphQLTypes["LinkCreateResult"],
	deleteLink: GraphQLTypes["LinkDeleteResult"],
	updateLink: GraphQLTypes["LinkUpdateResult"],
	upsertLink: GraphQLTypes["LinkUpsertResult"],
	createLinkable: GraphQLTypes["LinkableCreateResult"],
	deleteLinkable: GraphQLTypes["LinkableDeleteResult"],
	updateLinkable: GraphQLTypes["LinkableUpdateResult"],
	upsertLinkable: GraphQLTypes["LinkableUpsertResult"],
	createMedium: GraphQLTypes["MediumCreateResult"],
	deleteMedium: GraphQLTypes["MediumDeleteResult"],
	updateMedium: GraphQLTypes["MediumUpdateResult"],
	upsertMedium: GraphQLTypes["MediumUpsertResult"],
	createVideo: GraphQLTypes["VideoCreateResult"],
	deleteVideo: GraphQLTypes["VideoDeleteResult"],
	updateVideo: GraphQLTypes["VideoUpdateResult"],
	upsertVideo: GraphQLTypes["VideoUpsertResult"],
	createSeo: GraphQLTypes["SeoCreateResult"],
	deleteSeo: GraphQLTypes["SeoDeleteResult"],
	updateSeo: GraphQLTypes["SeoUpdateResult"],
	upsertSeo: GraphQLTypes["SeoUpsertResult"],
	createProtectedImage: GraphQLTypes["ProtectedImageCreateResult"],
	deleteProtectedImage: GraphQLTypes["ProtectedImageDeleteResult"],
	updateProtectedImage: GraphQLTypes["ProtectedImageUpdateResult"],
	upsertProtectedImage: GraphQLTypes["ProtectedImageUpsertResult"],
	createTranslationDomain: GraphQLTypes["TranslationDomainCreateResult"],
	deleteTranslationDomain: GraphQLTypes["TranslationDomainDeleteResult"],
	updateTranslationDomain: GraphQLTypes["TranslationDomainUpdateResult"],
	upsertTranslationDomain: GraphQLTypes["TranslationDomainUpsertResult"],
	createTranslationCatalogue: GraphQLTypes["TranslationCatalogueCreateResult"],
	deleteTranslationCatalogue: GraphQLTypes["TranslationCatalogueDeleteResult"],
	updateTranslationCatalogue: GraphQLTypes["TranslationCatalogueUpdateResult"],
	upsertTranslationCatalogue: GraphQLTypes["TranslationCatalogueUpsertResult"],
	createTranslationKey: GraphQLTypes["TranslationKeyCreateResult"],
	deleteTranslationKey: GraphQLTypes["TranslationKeyDeleteResult"],
	updateTranslationKey: GraphQLTypes["TranslationKeyUpdateResult"],
	upsertTranslationKey: GraphQLTypes["TranslationKeyUpsertResult"],
	createTranslationValue: GraphQLTypes["TranslationValueCreateResult"],
	deleteTranslationValue: GraphQLTypes["TranslationValueDeleteResult"],
	updateTranslationValue: GraphQLTypes["TranslationValueUpdateResult"],
	upsertTranslationValue: GraphQLTypes["TranslationValueUpsertResult"],
	createTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierCreateResult"],
	deleteTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierDeleteResult"],
	updateTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierUpdateResult"],
	upsertTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierUpsertResult"],
	createSocialsAndApps: GraphQLTypes["SocialsAndAppsCreateResult"],
	deleteSocialsAndApps: GraphQLTypes["SocialsAndAppsDeleteResult"],
	updateSocialsAndApps: GraphQLTypes["SocialsAndAppsUpdateResult"],
	upsertSocialsAndApps: GraphQLTypes["SocialsAndAppsUpsertResult"],
	createProductGrid: GraphQLTypes["ProductGridCreateResult"],
	deleteProductGrid: GraphQLTypes["ProductGridDeleteResult"],
	updateProductGrid: GraphQLTypes["ProductGridUpdateResult"],
	upsertProductGrid: GraphQLTypes["ProductGridUpsertResult"],
	createProductGridItem: GraphQLTypes["ProductGridItemCreateResult"],
	deleteProductGridItem: GraphQLTypes["ProductGridItemDeleteResult"],
	updateProductGridItem: GraphQLTypes["ProductGridItemUpdateResult"],
	upsertProductGridItem: GraphQLTypes["ProductGridItemUpsertResult"],
	createGallery: GraphQLTypes["GalleryCreateResult"],
	deleteGallery: GraphQLTypes["GalleryDeleteResult"],
	updateGallery: GraphQLTypes["GalleryUpdateResult"],
	upsertGallery: GraphQLTypes["GalleryUpsertResult"],
	createGalleryItem: GraphQLTypes["GalleryItemCreateResult"],
	deleteGalleryItem: GraphQLTypes["GalleryItemDeleteResult"],
	updateGalleryItem: GraphQLTypes["GalleryItemUpdateResult"],
	upsertGalleryItem: GraphQLTypes["GalleryItemUpsertResult"],
	createHero: GraphQLTypes["HeroCreateResult"],
	deleteHero: GraphQLTypes["HeroDeleteResult"],
	updateHero: GraphQLTypes["HeroUpdateResult"],
	upsertHero: GraphQLTypes["HeroUpsertResult"],
	createSiteMenu: GraphQLTypes["SiteMenuCreateResult"],
	deleteSiteMenu: GraphQLTypes["SiteMenuDeleteResult"],
	updateSiteMenu: GraphQLTypes["SiteMenuUpdateResult"],
	upsertSiteMenu: GraphQLTypes["SiteMenuUpsertResult"],
	createMenuLocale: GraphQLTypes["MenuLocaleCreateResult"],
	deleteMenuLocale: GraphQLTypes["MenuLocaleDeleteResult"],
	updateMenuLocale: GraphQLTypes["MenuLocaleUpdateResult"],
	upsertMenuLocale: GraphQLTypes["MenuLocaleUpsertResult"],
	createMenuItem: GraphQLTypes["MenuItemCreateResult"],
	deleteMenuItem: GraphQLTypes["MenuItemDeleteResult"],
	updateMenuItem: GraphQLTypes["MenuItemUpdateResult"],
	upsertMenuItem: GraphQLTypes["MenuItemUpsertResult"],
	createPage: GraphQLTypes["PageCreateResult"],
	deletePage: GraphQLTypes["PageDeleteResult"],
	updatePage: GraphQLTypes["PageUpdateResult"],
	upsertPage: GraphQLTypes["PageUpsertResult"],
	createPageLocale: GraphQLTypes["PageLocaleCreateResult"],
	deletePageLocale: GraphQLTypes["PageLocaleDeleteResult"],
	updatePageLocale: GraphQLTypes["PageLocaleUpdateResult"],
	upsertPageLocale: GraphQLTypes["PageLocaleUpsertResult"],
	createWikiPage: GraphQLTypes["WikiPageCreateResult"],
	deleteWikiPage: GraphQLTypes["WikiPageDeleteResult"],
	updateWikiPage: GraphQLTypes["WikiPageUpdateResult"],
	upsertWikiPage: GraphQLTypes["WikiPageUpsertResult"],
	createMenuSubitem: GraphQLTypes["MenuSubitemCreateResult"],
	deleteMenuSubitem: GraphQLTypes["MenuSubitemDeleteResult"],
	updateMenuSubitem: GraphQLTypes["MenuSubitemUpdateResult"],
	upsertMenuSubitem: GraphQLTypes["MenuSubitemUpsertResult"],
	createMenuLinkList: GraphQLTypes["MenuLinkListCreateResult"],
	deleteMenuLinkList: GraphQLTypes["MenuLinkListDeleteResult"],
	updateMenuLinkList: GraphQLTypes["MenuLinkListUpdateResult"],
	upsertMenuLinkList: GraphQLTypes["MenuLinkListUpsertResult"],
	createMenuLinkItem: GraphQLTypes["MenuLinkItemCreateResult"],
	deleteMenuLinkItem: GraphQLTypes["MenuLinkItemDeleteResult"],
	updateMenuLinkItem: GraphQLTypes["MenuLinkItemUpdateResult"],
	upsertMenuLinkItem: GraphQLTypes["MenuLinkItemUpsertResult"],
	createMenuProducts: GraphQLTypes["MenuProductsCreateResult"],
	deleteMenuProducts: GraphQLTypes["MenuProductsDeleteResult"],
	updateMenuProducts: GraphQLTypes["MenuProductsUpdateResult"],
	upsertMenuProducts: GraphQLTypes["MenuProductsUpsertResult"],
	createMenuDelivery: GraphQLTypes["MenuDeliveryCreateResult"],
	deleteMenuDelivery: GraphQLTypes["MenuDeliveryDeleteResult"],
	updateMenuDelivery: GraphQLTypes["MenuDeliveryUpdateResult"],
	upsertMenuDelivery: GraphQLTypes["MenuDeliveryUpsertResult"],
	createMenuContact: GraphQLTypes["MenuContactCreateResult"],
	deleteMenuContact: GraphQLTypes["MenuContactDeleteResult"],
	updateMenuContact: GraphQLTypes["MenuContactUpdateResult"],
	upsertMenuContact: GraphQLTypes["MenuContactUpsertResult"],
	createDeadlineTemplate: GraphQLTypes["DeadlineTemplateCreateResult"],
	deleteDeadlineTemplate: GraphQLTypes["DeadlineTemplateDeleteResult"],
	updateDeadlineTemplate: GraphQLTypes["DeadlineTemplateUpdateResult"],
	upsertDeadlineTemplate: GraphQLTypes["DeadlineTemplateUpsertResult"],
	createEmployeeQueue: GraphQLTypes["EmployeeQueueCreateResult"],
	deleteEmployeeQueue: GraphQLTypes["EmployeeQueueDeleteResult"],
	updateEmployeeQueue: GraphQLTypes["EmployeeQueueUpdateResult"],
	upsertEmployeeQueue: GraphQLTypes["EmployeeQueueUpsertResult"],
	createTimetableDay: GraphQLTypes["TimetableDayCreateResult"],
	deleteTimetableDay: GraphQLTypes["TimetableDayDeleteResult"],
	updateTimetableDay: GraphQLTypes["TimetableDayUpdateResult"],
	upsertTimetableDay: GraphQLTypes["TimetableDayUpsertResult"],
	createTimetableEmployeeRole: GraphQLTypes["TimetableEmployeeRoleCreateResult"],
	deleteTimetableEmployeeRole: GraphQLTypes["TimetableEmployeeRoleDeleteResult"],
	updateTimetableEmployeeRole: GraphQLTypes["TimetableEmployeeRoleUpdateResult"],
	upsertTimetableEmployeeRole: GraphQLTypes["TimetableEmployeeRoleUpsertResult"],
	createTimetableShift: GraphQLTypes["TimetableShiftCreateResult"],
	deleteTimetableShift: GraphQLTypes["TimetableShiftDeleteResult"],
	updateTimetableShift: GraphQLTypes["TimetableShiftUpdateResult"],
	upsertTimetableShift: GraphQLTypes["TimetableShiftUpsertResult"],
	createTimetableShiftGroup: GraphQLTypes["TimetableShiftGroupCreateResult"],
	deleteTimetableShiftGroup: GraphQLTypes["TimetableShiftGroupDeleteResult"],
	updateTimetableShiftGroup: GraphQLTypes["TimetableShiftGroupUpdateResult"],
	upsertTimetableShiftGroup: GraphQLTypes["TimetableShiftGroupUpsertResult"],
	createTimetableShiftPosition: GraphQLTypes["TimetableShiftPositionCreateResult"],
	deleteTimetableShiftPosition: GraphQLTypes["TimetableShiftPositionDeleteResult"],
	updateTimetableShiftPosition: GraphQLTypes["TimetableShiftPositionUpdateResult"],
	upsertTimetableShiftPosition: GraphQLTypes["TimetableShiftPositionUpsertResult"],
	createTimetableTemplate: GraphQLTypes["TimetableTemplateCreateResult"],
	deleteTimetableTemplate: GraphQLTypes["TimetableTemplateDeleteResult"],
	updateTimetableTemplate: GraphQLTypes["TimetableTemplateUpdateResult"],
	upsertTimetableTemplate: GraphQLTypes["TimetableTemplateUpsertResult"],
	createCart: GraphQLTypes["CartCreateResult"],
	deleteCart: GraphQLTypes["CartDeleteResult"],
	updateCart: GraphQLTypes["CartUpdateResult"],
	upsertCart: GraphQLTypes["CartUpsertResult"],
	createCartItem: GraphQLTypes["CartItemCreateResult"],
	deleteCartItem: GraphQLTypes["CartItemDeleteResult"],
	updateCartItem: GraphQLTypes["CartItemUpdateResult"],
	upsertCartItem: GraphQLTypes["CartItemUpsertResult"],
	createEmployeeQueueItem: GraphQLTypes["EmployeeQueueItemCreateResult"],
	deleteEmployeeQueueItem: GraphQLTypes["EmployeeQueueItemDeleteResult"],
	updateEmployeeQueueItem: GraphQLTypes["EmployeeQueueItemUpdateResult"],
	upsertEmployeeQueueItem: GraphQLTypes["EmployeeQueueItemUpsertResult"],
	createApplication: GraphQLTypes["ApplicationCreateResult"],
	deleteApplication: GraphQLTypes["ApplicationDeleteResult"],
	updateApplication: GraphQLTypes["ApplicationUpdateResult"],
	upsertApplication: GraphQLTypes["ApplicationUpsertResult"],
	createApplicationShortcutList: GraphQLTypes["ApplicationShortcutListCreateResult"],
	deleteApplicationShortcutList: GraphQLTypes["ApplicationShortcutListDeleteResult"],
	updateApplicationShortcutList: GraphQLTypes["ApplicationShortcutListUpdateResult"],
	upsertApplicationShortcutList: GraphQLTypes["ApplicationShortcutListUpsertResult"],
	createApplicationShortcutListItem: GraphQLTypes["ApplicationShortcutListItemCreateResult"],
	deleteApplicationShortcutListItem: GraphQLTypes["ApplicationShortcutListItemDeleteResult"],
	updateApplicationShortcutListItem: GraphQLTypes["ApplicationShortcutListItemUpdateResult"],
	upsertApplicationShortcutListItem: GraphQLTypes["ApplicationShortcutListItemUpsertResult"],
	createProductBanner: GraphQLTypes["ProductBannerCreateResult"],
	deleteProductBanner: GraphQLTypes["ProductBannerDeleteResult"],
	updateProductBanner: GraphQLTypes["ProductBannerUpdateResult"],
	upsertProductBanner: GraphQLTypes["ProductBannerUpsertResult"],
	createProductBannerItem: GraphQLTypes["ProductBannerItemCreateResult"],
	deleteProductBannerItem: GraphQLTypes["ProductBannerItemDeleteResult"],
	updateProductBannerItem: GraphQLTypes["ProductBannerItemUpdateResult"],
	upsertProductBannerItem: GraphQLTypes["ProductBannerItemUpsertResult"],
	createProductBannerList: GraphQLTypes["ProductBannerListCreateResult"],
	deleteProductBannerList: GraphQLTypes["ProductBannerListDeleteResult"],
	updateProductBannerList: GraphQLTypes["ProductBannerListUpdateResult"],
	upsertProductBannerList: GraphQLTypes["ProductBannerListUpsertResult"],
	createBartender: GraphQLTypes["BartenderCreateResult"],
	deleteBartender: GraphQLTypes["BartenderDeleteResult"],
	updateBartender: GraphQLTypes["BartenderUpdateResult"],
	upsertBartender: GraphQLTypes["BartenderUpsertResult"],
	createBusinessToBusinessManager: GraphQLTypes["BusinessToBusinessManagerCreateResult"],
	deleteBusinessToBusinessManager: GraphQLTypes["BusinessToBusinessManagerDeleteResult"],
	updateBusinessToBusinessManager: GraphQLTypes["BusinessToBusinessManagerUpdateResult"],
	upsertBusinessToBusinessManager: GraphQLTypes["BusinessToBusinessManagerUpsertResult"],
	createCleaner: GraphQLTypes["CleanerCreateResult"],
	deleteCleaner: GraphQLTypes["CleanerDeleteResult"],
	updateCleaner: GraphQLTypes["CleanerUpdateResult"],
	upsertCleaner: GraphQLTypes["CleanerUpsertResult"],
	createCourier: GraphQLTypes["CourierCreateResult"],
	deleteCourier: GraphQLTypes["CourierDeleteResult"],
	updateCourier: GraphQLTypes["CourierUpdateResult"],
	upsertCourier: GraphQLTypes["CourierUpsertResult"],
	createShiftsManager: GraphQLTypes["ShiftsManagerCreateResult"],
	deleteShiftsManager: GraphQLTypes["ShiftsManagerDeleteResult"],
	updateShiftsManager: GraphQLTypes["ShiftsManagerUpdateResult"],
	upsertShiftsManager: GraphQLTypes["ShiftsManagerUpsertResult"],
	createUser: GraphQLTypes["UserCreateResult"],
	deleteUser: GraphQLTypes["UserDeleteResult"],
	updateUser: GraphQLTypes["UserUpdateResult"],
	upsertUser: GraphQLTypes["UserUpsertResult"],
	createShiftsProfile: GraphQLTypes["ShiftsProfileCreateResult"],
	deleteShiftsProfile: GraphQLTypes["ShiftsProfileDeleteResult"],
	updateShiftsProfile: GraphQLTypes["ShiftsProfileUpdateResult"],
	upsertShiftsProfile: GraphQLTypes["ShiftsProfileUpsertResult"],
	createProductIngredientCategory: GraphQLTypes["ProductIngredientCategoryCreateResult"],
	deleteProductIngredientCategory: GraphQLTypes["ProductIngredientCategoryDeleteResult"],
	updateProductIngredientCategory: GraphQLTypes["ProductIngredientCategoryUpdateResult"],
	upsertProductIngredientCategory: GraphQLTypes["ProductIngredientCategoryUpsertResult"],
	createProductIngredientCategoryLocale: GraphQLTypes["ProductIngredientCategoryLocaleCreateResult"],
	deleteProductIngredientCategoryLocale: GraphQLTypes["ProductIngredientCategoryLocaleDeleteResult"],
	updateProductIngredientCategoryLocale: GraphQLTypes["ProductIngredientCategoryLocaleUpdateResult"],
	upsertProductIngredientCategoryLocale: GraphQLTypes["ProductIngredientCategoryLocaleUpsertResult"],
	createStocksManager: GraphQLTypes["StocksManagerCreateResult"],
	deleteStocksManager: GraphQLTypes["StocksManagerDeleteResult"],
	updateStocksManager: GraphQLTypes["StocksManagerUpdateResult"],
	upsertStocksManager: GraphQLTypes["StocksManagerUpsertResult"],
	createDeliveryRoute: GraphQLTypes["DeliveryRouteCreateResult"],
	deleteDeliveryRoute: GraphQLTypes["DeliveryRouteDeleteResult"],
	updateDeliveryRoute: GraphQLTypes["DeliveryRouteUpdateResult"],
	upsertDeliveryRoute: GraphQLTypes["DeliveryRouteUpsertResult"],
	createDeliveryWaypoint: GraphQLTypes["DeliveryWaypointCreateResult"],
	deleteDeliveryWaypoint: GraphQLTypes["DeliveryWaypointDeleteResult"],
	updateDeliveryWaypoint: GraphQLTypes["DeliveryWaypointUpdateResult"],
	upsertDeliveryWaypoint: GraphQLTypes["DeliveryWaypointUpsertResult"],
	createAllergen: GraphQLTypes["AllergenCreateResult"],
	deleteAllergen: GraphQLTypes["AllergenDeleteResult"],
	updateAllergen: GraphQLTypes["AllergenUpdateResult"],
	upsertAllergen: GraphQLTypes["AllergenUpsertResult"],
	createAllergenLocale: GraphQLTypes["AllergenLocaleCreateResult"],
	deleteAllergenLocale: GraphQLTypes["AllergenLocaleDeleteResult"],
	updateAllergenLocale: GraphQLTypes["AllergenLocaleUpdateResult"],
	upsertAllergenLocale: GraphQLTypes["AllergenLocaleUpsertResult"],
	createGps: GraphQLTypes["GpsCreateResult"],
	deleteGps: GraphQLTypes["GpsDeleteResult"],
	updateGps: GraphQLTypes["GpsUpdateResult"],
	upsertGps: GraphQLTypes["GpsUpsertResult"],
	createWeekHours: GraphQLTypes["WeekHoursCreateResult"],
	deleteWeekHours: GraphQLTypes["WeekHoursDeleteResult"],
	updateWeekHours: GraphQLTypes["WeekHoursUpdateResult"],
	upsertWeekHours: GraphQLTypes["WeekHoursUpsertResult"],
	createPreparedIngredientQuantity: GraphQLTypes["PreparedIngredientQuantityCreateResult"],
	deletePreparedIngredientQuantity: GraphQLTypes["PreparedIngredientQuantityDeleteResult"],
	updatePreparedIngredientQuantity: GraphQLTypes["PreparedIngredientQuantityUpdateResult"],
	upsertPreparedIngredientQuantity: GraphQLTypes["PreparedIngredientQuantityUpsertResult"],
	createPreparedRecipeQuantity: GraphQLTypes["PreparedRecipeQuantityCreateResult"],
	deletePreparedRecipeQuantity: GraphQLTypes["PreparedRecipeQuantityDeleteResult"],
	updatePreparedRecipeQuantity: GraphQLTypes["PreparedRecipeQuantityUpdateResult"],
	upsertPreparedRecipeQuantity: GraphQLTypes["PreparedRecipeQuantityUpsertResult"],
	createInternalOrder: GraphQLTypes["InternalOrderCreateResult"],
	deleteInternalOrder: GraphQLTypes["InternalOrderDeleteResult"],
	updateInternalOrder: GraphQLTypes["InternalOrderUpdateResult"],
	upsertInternalOrder: GraphQLTypes["InternalOrderUpsertResult"],
	createInternalOrderItem: GraphQLTypes["InternalOrderItemCreateResult"],
	deleteInternalOrderItem: GraphQLTypes["InternalOrderItemDeleteResult"],
	updateInternalOrderItem: GraphQLTypes["InternalOrderItemUpdateResult"],
	upsertInternalOrderItem: GraphQLTypes["InternalOrderItemUpsertResult"],
	createPreparedPackingQuantity: GraphQLTypes["PreparedPackingQuantityCreateResult"],
	deletePreparedPackingQuantity: GraphQLTypes["PreparedPackingQuantityDeleteResult"],
	updatePreparedPackingQuantity: GraphQLTypes["PreparedPackingQuantityUpdateResult"],
	upsertPreparedPackingQuantity: GraphQLTypes["PreparedPackingQuantityUpsertResult"],
	createCourierManager: GraphQLTypes["CourierManagerCreateResult"],
	deleteCourierManager: GraphQLTypes["CourierManagerDeleteResult"],
	updateCourierManager: GraphQLTypes["CourierManagerUpdateResult"],
	upsertCourierManager: GraphQLTypes["CourierManagerUpsertResult"],
	createDeliveryZone: GraphQLTypes["DeliveryZoneCreateResult"],
	deleteDeliveryZone: GraphQLTypes["DeliveryZoneDeleteResult"],
	updateDeliveryZone: GraphQLTypes["DeliveryZoneUpdateResult"],
	upsertDeliveryZone: GraphQLTypes["DeliveryZoneUpsertResult"],
	createDeliveryTimelinePreset: GraphQLTypes["DeliveryTimelinePresetCreateResult"],
	deleteDeliveryTimelinePreset: GraphQLTypes["DeliveryTimelinePresetDeleteResult"],
	updateDeliveryTimelinePreset: GraphQLTypes["DeliveryTimelinePresetUpdateResult"],
	upsertDeliveryTimelinePreset: GraphQLTypes["DeliveryTimelinePresetUpsertResult"],
	createOrderDeliveryTimeline: GraphQLTypes["OrderDeliveryTimelineCreateResult"],
	deleteOrderDeliveryTimeline: GraphQLTypes["OrderDeliveryTimelineDeleteResult"],
	updateOrderDeliveryTimeline: GraphQLTypes["OrderDeliveryTimelineUpdateResult"],
	upsertOrderDeliveryTimeline: GraphQLTypes["OrderDeliveryTimelineUpsertResult"],
	createOrderEvent: GraphQLTypes["OrderEventCreateResult"],
	deleteOrderEvent: GraphQLTypes["OrderEventDeleteResult"],
	updateOrderEvent: GraphQLTypes["OrderEventUpdateResult"],
	upsertOrderEvent: GraphQLTypes["OrderEventUpsertResult"],
	createLiftagoRide: GraphQLTypes["LiftagoRideCreateResult"],
	deleteLiftagoRide: GraphQLTypes["LiftagoRideDeleteResult"],
	updateLiftagoRide: GraphQLTypes["LiftagoRideUpdateResult"],
	upsertLiftagoRide: GraphQLTypes["LiftagoRideUpsertResult"],
	createInvoice: GraphQLTypes["InvoiceCreateResult"],
	deleteInvoice: GraphQLTypes["InvoiceDeleteResult"],
	updateInvoice: GraphQLTypes["InvoiceUpdateResult"],
	upsertInvoice: GraphQLTypes["InvoiceUpsertResult"],
	createInvoicingPlan: GraphQLTypes["InvoicingPlanCreateResult"],
	deleteInvoicingPlan: GraphQLTypes["InvoicingPlanDeleteResult"],
	updateInvoicingPlan: GraphQLTypes["InvoicingPlanUpdateResult"],
	upsertInvoicingPlan: GraphQLTypes["InvoicingPlanUpsertResult"],
	createProductPackingLocale: GraphQLTypes["ProductPackingLocaleCreateResult"],
	deleteProductPackingLocale: GraphQLTypes["ProductPackingLocaleDeleteResult"],
	updateProductPackingLocale: GraphQLTypes["ProductPackingLocaleUpdateResult"],
	upsertProductPackingLocale: GraphQLTypes["ProductPackingLocaleUpsertResult"],
	createProductLocale: GraphQLTypes["ProductLocaleCreateResult"],
	deleteProductLocale: GraphQLTypes["ProductLocaleDeleteResult"],
	updateProductLocale: GraphQLTypes["ProductLocaleUpdateResult"],
	upsertProductLocale: GraphQLTypes["ProductLocaleUpsertResult"],
	createProductRecipeLocale: GraphQLTypes["ProductRecipeLocaleCreateResult"],
	deleteProductRecipeLocale: GraphQLTypes["ProductRecipeLocaleDeleteResult"],
	updateProductRecipeLocale: GraphQLTypes["ProductRecipeLocaleUpdateResult"],
	upsertProductRecipeLocale: GraphQLTypes["ProductRecipeLocaleUpsertResult"],
	createUserDevice: GraphQLTypes["UserDeviceCreateResult"],
	deleteUserDevice: GraphQLTypes["UserDeviceDeleteResult"],
	updateUserDevice: GraphQLTypes["UserDeviceUpdateResult"],
	upsertUserDevice: GraphQLTypes["UserDeviceUpsertResult"],
	createProtectedAction: GraphQLTypes["ProtectedActionCreateResult"],
	deleteProtectedAction: GraphQLTypes["ProtectedActionDeleteResult"],
	updateProtectedAction: GraphQLTypes["ProtectedActionUpdateResult"],
	upsertProtectedAction: GraphQLTypes["ProtectedActionUpsertResult"],
	createPicker: GraphQLTypes["PickerCreateResult"],
	deletePicker: GraphQLTypes["PickerDeleteResult"],
	updatePicker: GraphQLTypes["PickerUpdateResult"],
	upsertPicker: GraphQLTypes["PickerUpsertResult"],
	createTimetableTemplateStaffOptions: GraphQLTypes["TimetableTemplateStaffOptionsCreateResult"],
	deleteTimetableTemplateStaffOptions: GraphQLTypes["TimetableTemplateStaffOptionsDeleteResult"],
	updateTimetableTemplateStaffOptions: GraphQLTypes["TimetableTemplateStaffOptionsUpdateResult"],
	upsertTimetableTemplateStaffOptions: GraphQLTypes["TimetableTemplateStaffOptionsUpsertResult"],
	createShoppingList: GraphQLTypes["ShoppingListCreateResult"],
	deleteShoppingList: GraphQLTypes["ShoppingListDeleteResult"],
	updateShoppingList: GraphQLTypes["ShoppingListUpdateResult"],
	upsertShoppingList: GraphQLTypes["ShoppingListUpsertResult"],
	createSuppliesPurchase: GraphQLTypes["SuppliesPurchaseCreateResult"],
	deleteSuppliesPurchase: GraphQLTypes["SuppliesPurchaseDeleteResult"],
	updateSuppliesPurchase: GraphQLTypes["SuppliesPurchaseUpdateResult"],
	upsertSuppliesPurchase: GraphQLTypes["SuppliesPurchaseUpsertResult"],
	createInvoicingPreset: GraphQLTypes["InvoicingPresetCreateResult"],
	deleteInvoicingPreset: GraphQLTypes["InvoicingPresetDeleteResult"],
	updateInvoicingPreset: GraphQLTypes["InvoicingPresetUpdateResult"],
	upsertInvoicingPreset: GraphQLTypes["InvoicingPresetUpsertResult"],
	createLogRecord: GraphQLTypes["LogRecordCreateResult"],
	deleteLogRecord: GraphQLTypes["LogRecordDeleteResult"],
	updateLogRecord: GraphQLTypes["LogRecordUpdateResult"],
	upsertLogRecord: GraphQLTypes["LogRecordUpsertResult"],
	createBillingSubject: GraphQLTypes["BillingSubjectCreateResult"],
	deleteBillingSubject: GraphQLTypes["BillingSubjectDeleteResult"],
	updateBillingSubject: GraphQLTypes["BillingSubjectUpdateResult"],
	upsertBillingSubject: GraphQLTypes["BillingSubjectUpsertResult"],
	createShoppingListItem: GraphQLTypes["ShoppingListItemCreateResult"],
	deleteShoppingListItem: GraphQLTypes["ShoppingListItemDeleteResult"],
	updateShoppingListItem: GraphQLTypes["ShoppingListItemUpdateResult"],
	upsertShoppingListItem: GraphQLTypes["ShoppingListItemUpsertResult"],
	createSuppliesPurchaseItem: GraphQLTypes["SuppliesPurchaseItemCreateResult"],
	deleteSuppliesPurchaseItem: GraphQLTypes["SuppliesPurchaseItemDeleteResult"],
	updateSuppliesPurchaseItem: GraphQLTypes["SuppliesPurchaseItemUpdateResult"],
	upsertSuppliesPurchaseItem: GraphQLTypes["SuppliesPurchaseItemUpsertResult"],
	createCustomerCreditTransaction: GraphQLTypes["CustomerCreditTransactionCreateResult"],
	deleteCustomerCreditTransaction: GraphQLTypes["CustomerCreditTransactionDeleteResult"],
	updateCustomerCreditTransaction: GraphQLTypes["CustomerCreditTransactionUpdateResult"],
	upsertCustomerCreditTransaction: GraphQLTypes["CustomerCreditTransactionUpsertResult"],
	createVirtualProduct: GraphQLTypes["VirtualProductCreateResult"],
	deleteVirtualProduct: GraphQLTypes["VirtualProductDeleteResult"],
	updateVirtualProduct: GraphQLTypes["VirtualProductUpdateResult"],
	upsertVirtualProduct: GraphQLTypes["VirtualProductUpsertResult"],
	createVirtualProductEffect: GraphQLTypes["VirtualProductEffectCreateResult"],
	deleteVirtualProductEffect: GraphQLTypes["VirtualProductEffectDeleteResult"],
	updateVirtualProductEffect: GraphQLTypes["VirtualProductEffectUpdateResult"],
	upsertVirtualProductEffect: GraphQLTypes["VirtualProductEffectUpsertResult"],
	createEmploymentInformation: GraphQLTypes["EmploymentInformationCreateResult"],
	deleteEmploymentInformation: GraphQLTypes["EmploymentInformationDeleteResult"],
	updateEmploymentInformation: GraphQLTypes["EmploymentInformationUpdateResult"],
	upsertEmploymentInformation: GraphQLTypes["EmploymentInformationUpsertResult"],
	createRemunerationProfile: GraphQLTypes["RemunerationProfileCreateResult"],
	deleteRemunerationProfile: GraphQLTypes["RemunerationProfileDeleteResult"],
	updateRemunerationProfile: GraphQLTypes["RemunerationProfileUpdateResult"],
	upsertRemunerationProfile: GraphQLTypes["RemunerationProfileUpsertResult"],
	createWorkMonth: GraphQLTypes["WorkMonthCreateResult"],
	deleteWorkMonth: GraphQLTypes["WorkMonthDeleteResult"],
	updateWorkMonth: GraphQLTypes["WorkMonthUpdateResult"],
	upsertWorkMonth: GraphQLTypes["WorkMonthUpsertResult"],
	createSalaryOptions: GraphQLTypes["SalaryOptionsCreateResult"],
	deleteSalaryOptions: GraphQLTypes["SalaryOptionsDeleteResult"],
	updateSalaryOptions: GraphQLTypes["SalaryOptionsUpdateResult"],
	upsertSalaryOptions: GraphQLTypes["SalaryOptionsUpsertResult"],
	createTimetableShiftSwapInfo: GraphQLTypes["TimetableShiftSwapInfoCreateResult"],
	deleteTimetableShiftSwapInfo: GraphQLTypes["TimetableShiftSwapInfoDeleteResult"],
	updateTimetableShiftSwapInfo: GraphQLTypes["TimetableShiftSwapInfoUpdateResult"],
	upsertTimetableShiftSwapInfo: GraphQLTypes["TimetableShiftSwapInfoUpsertResult"],
	createProductGridCategory: GraphQLTypes["ProductGridCategoryCreateResult"],
	deleteProductGridCategory: GraphQLTypes["ProductGridCategoryDeleteResult"],
	updateProductGridCategory: GraphQLTypes["ProductGridCategoryUpdateResult"],
	upsertProductGridCategory: GraphQLTypes["ProductGridCategoryUpsertResult"],
	createCashier: GraphQLTypes["CashierCreateResult"],
	deleteCashier: GraphQLTypes["CashierDeleteResult"],
	updateCashier: GraphQLTypes["CashierUpdateResult"],
	upsertCashier: GraphQLTypes["CashierUpsertResult"],
	createPointOfSaleCategory: GraphQLTypes["PointOfSaleCategoryCreateResult"],
	deletePointOfSaleCategory: GraphQLTypes["PointOfSaleCategoryDeleteResult"],
	updatePointOfSaleCategory: GraphQLTypes["PointOfSaleCategoryUpdateResult"],
	upsertPointOfSaleCategory: GraphQLTypes["PointOfSaleCategoryUpsertResult"],
	createPointOfSaleCategoryLocale: GraphQLTypes["PointOfSaleCategoryLocaleCreateResult"],
	deletePointOfSaleCategoryLocale: GraphQLTypes["PointOfSaleCategoryLocaleDeleteResult"],
	updatePointOfSaleCategoryLocale: GraphQLTypes["PointOfSaleCategoryLocaleUpdateResult"],
	upsertPointOfSaleCategoryLocale: GraphQLTypes["PointOfSaleCategoryLocaleUpsertResult"],
	createPointOfSaleCategoryProduct: GraphQLTypes["PointOfSaleCategoryProductCreateResult"],
	deletePointOfSaleCategoryProduct: GraphQLTypes["PointOfSaleCategoryProductDeleteResult"],
	updatePointOfSaleCategoryProduct: GraphQLTypes["PointOfSaleCategoryProductUpdateResult"],
	upsertPointOfSaleCategoryProduct: GraphQLTypes["PointOfSaleCategoryProductUpsertResult"],
	createPointOfSaleCategoryProductLocale: GraphQLTypes["PointOfSaleCategoryProductLocaleCreateResult"],
	deletePointOfSaleCategoryProductLocale: GraphQLTypes["PointOfSaleCategoryProductLocaleDeleteResult"],
	updatePointOfSaleCategoryProductLocale: GraphQLTypes["PointOfSaleCategoryProductLocaleUpdateResult"],
	upsertPointOfSaleCategoryProductLocale: GraphQLTypes["PointOfSaleCategoryProductLocaleUpsertResult"],
	createCustomerTab: GraphQLTypes["CustomerTabCreateResult"],
	deleteCustomerTab: GraphQLTypes["CustomerTabDeleteResult"],
	updateCustomerTab: GraphQLTypes["CustomerTabUpdateResult"],
	upsertCustomerTab: GraphQLTypes["CustomerTabUpsertResult"],
	createCustomerTabItem: GraphQLTypes["CustomerTabItemCreateResult"],
	deleteCustomerTabItem: GraphQLTypes["CustomerTabItemDeleteResult"],
	updateCustomerTabItem: GraphQLTypes["CustomerTabItemUpdateResult"],
	upsertCustomerTabItem: GraphQLTypes["CustomerTabItemUpsertResult"],
	createAnonymousSession: GraphQLTypes["AnonymousSessionCreateResult"],
	deleteAnonymousSession: GraphQLTypes["AnonymousSessionDeleteResult"],
	updateAnonymousSession: GraphQLTypes["AnonymousSessionUpdateResult"],
	upsertAnonymousSession: GraphQLTypes["AnonymousSessionUpsertResult"],
	createVoucher: GraphQLTypes["VoucherCreateResult"],
	deleteVoucher: GraphQLTypes["VoucherDeleteResult"],
	updateVoucher: GraphQLTypes["VoucherUpdateResult"],
	upsertVoucher: GraphQLTypes["VoucherUpsertResult"],
	createVoucherRedemption: GraphQLTypes["VoucherRedemptionCreateResult"],
	deleteVoucherRedemption: GraphQLTypes["VoucherRedemptionDeleteResult"],
	updateVoucherRedemption: GraphQLTypes["VoucherRedemptionUpdateResult"],
	upsertVoucherRedemption: GraphQLTypes["VoucherRedemptionUpsertResult"],
	createUnassignedShiftInfo: GraphQLTypes["UnassignedShiftInfoCreateResult"],
	deleteUnassignedShiftInfo: GraphQLTypes["UnassignedShiftInfoDeleteResult"],
	updateUnassignedShiftInfo: GraphQLTypes["UnassignedShiftInfoUpdateResult"],
	upsertUnassignedShiftInfo: GraphQLTypes["UnassignedShiftInfoUpsertResult"],
	createFreshingContainer: GraphQLTypes["FreshingContainerCreateResult"],
	deleteFreshingContainer: GraphQLTypes["FreshingContainerDeleteResult"],
	updateFreshingContainer: GraphQLTypes["FreshingContainerUpdateResult"],
	upsertFreshingContainer: GraphQLTypes["FreshingContainerUpsertResult"],
	createTextItem: GraphQLTypes["TextItemCreateResult"],
	deleteTextItem: GraphQLTypes["TextItemDeleteResult"],
	updateTextItem: GraphQLTypes["TextItemUpdateResult"],
	upsertTextItem: GraphQLTypes["TextItemUpsertResult"],
	createTextList: GraphQLTypes["TextListCreateResult"],
	deleteTextList: GraphQLTypes["TextListDeleteResult"],
	updateTextList: GraphQLTypes["TextListUpdateResult"],
	upsertTextList: GraphQLTypes["TextListUpsertResult"],
	createDeliveryRegions: GraphQLTypes["DeliveryRegionsCreateResult"],
	deleteDeliveryRegions: GraphQLTypes["DeliveryRegionsDeleteResult"],
	updateDeliveryRegions: GraphQLTypes["DeliveryRegionsUpdateResult"],
	upsertDeliveryRegions: GraphQLTypes["DeliveryRegionsUpsertResult"],
	createDeliveryRegionsItem: GraphQLTypes["DeliveryRegionsItemCreateResult"],
	deleteDeliveryRegionsItem: GraphQLTypes["DeliveryRegionsItemDeleteResult"],
	updateDeliveryRegionsItem: GraphQLTypes["DeliveryRegionsItemUpdateResult"],
	upsertDeliveryRegionsItem: GraphQLTypes["DeliveryRegionsItemUpsertResult"],
	createImageList: GraphQLTypes["ImageListCreateResult"],
	deleteImageList: GraphQLTypes["ImageListDeleteResult"],
	updateImageList: GraphQLTypes["ImageListUpdateResult"],
	upsertImageList: GraphQLTypes["ImageListUpsertResult"],
	createImageListItem: GraphQLTypes["ImageListItemCreateResult"],
	deleteImageListItem: GraphQLTypes["ImageListItemDeleteResult"],
	updateImageListItem: GraphQLTypes["ImageListItemUpdateResult"],
	upsertImageListItem: GraphQLTypes["ImageListItemUpsertResult"],
	createTimetablesEmployeePrivileges: GraphQLTypes["TimetablesEmployeePrivilegesCreateResult"],
	deleteTimetablesEmployeePrivileges: GraphQLTypes["TimetablesEmployeePrivilegesDeleteResult"],
	updateTimetablesEmployeePrivileges: GraphQLTypes["TimetablesEmployeePrivilegesUpdateResult"],
	upsertTimetablesEmployeePrivileges: GraphQLTypes["TimetablesEmployeePrivilegesUpsertResult"],
	createTimetableDayNote: GraphQLTypes["TimetableDayNoteCreateResult"],
	deleteTimetableDayNote: GraphQLTypes["TimetableDayNoteDeleteResult"],
	updateTimetableDayNote: GraphQLTypes["TimetableDayNoteUpdateResult"],
	upsertTimetableDayNote: GraphQLTypes["TimetableDayNoteUpsertResult"],
	createDeliveryMethodLocale: GraphQLTypes["DeliveryMethodLocaleCreateResult"],
	deleteDeliveryMethodLocale: GraphQLTypes["DeliveryMethodLocaleDeleteResult"],
	updateDeliveryMethodLocale: GraphQLTypes["DeliveryMethodLocaleUpdateResult"],
	upsertDeliveryMethodLocale: GraphQLTypes["DeliveryMethodLocaleUpsertResult"],
	createIngredientSupplier: GraphQLTypes["IngredientSupplierCreateResult"],
	deleteIngredientSupplier: GraphQLTypes["IngredientSupplierDeleteResult"],
	updateIngredientSupplier: GraphQLTypes["IngredientSupplierUpdateResult"],
	upsertIngredientSupplier: GraphQLTypes["IngredientSupplierUpsertResult"],
	createIngredientSupplierItem: GraphQLTypes["IngredientSupplierItemCreateResult"],
	deleteIngredientSupplierItem: GraphQLTypes["IngredientSupplierItemDeleteResult"],
	updateIngredientSupplierItem: GraphQLTypes["IngredientSupplierItemUpdateResult"],
	upsertIngredientSupplierItem: GraphQLTypes["IngredientSupplierItemUpsertResult"],
	createIngredientSupplierList: GraphQLTypes["IngredientSupplierListCreateResult"],
	deleteIngredientSupplierList: GraphQLTypes["IngredientSupplierListDeleteResult"],
	updateIngredientSupplierList: GraphQLTypes["IngredientSupplierListUpdateResult"],
	upsertIngredientSupplierList: GraphQLTypes["IngredientSupplierListUpsertResult"],
	createIngredientSupplierLocale: GraphQLTypes["IngredientSupplierLocaleCreateResult"],
	deleteIngredientSupplierLocale: GraphQLTypes["IngredientSupplierLocaleDeleteResult"],
	updateIngredientSupplierLocale: GraphQLTypes["IngredientSupplierLocaleUpdateResult"],
	upsertIngredientSupplierLocale: GraphQLTypes["IngredientSupplierLocaleUpsertResult"],
	createRedirect: GraphQLTypes["RedirectCreateResult"],
	deleteRedirect: GraphQLTypes["RedirectDeleteResult"],
	updateRedirect: GraphQLTypes["RedirectUpdateResult"],
	upsertRedirect: GraphQLTypes["RedirectUpsertResult"],
	createNutritionFacts: GraphQLTypes["NutritionFactsCreateResult"],
	deleteNutritionFacts: GraphQLTypes["NutritionFactsDeleteResult"],
	updateNutritionFacts: GraphQLTypes["NutritionFactsUpdateResult"],
	upsertNutritionFacts: GraphQLTypes["NutritionFactsUpsertResult"],
	createVenue: GraphQLTypes["VenueCreateResult"],
	deleteVenue: GraphQLTypes["VenueDeleteResult"],
	updateVenue: GraphQLTypes["VenueUpdateResult"],
	upsertVenue: GraphQLTypes["VenueUpsertResult"],
	createWorkspace: GraphQLTypes["WorkspaceCreateResult"],
	deleteWorkspace: GraphQLTypes["WorkspaceDeleteResult"],
	updateWorkspace: GraphQLTypes["WorkspaceUpdateResult"],
	upsertWorkspace: GraphQLTypes["WorkspaceUpsertResult"],
	createInternalBuyer: GraphQLTypes["InternalBuyerCreateResult"],
	deleteInternalBuyer: GraphQLTypes["InternalBuyerDeleteResult"],
	updateInternalBuyer: GraphQLTypes["InternalBuyerUpdateResult"],
	upsertInternalBuyer: GraphQLTypes["InternalBuyerUpsertResult"],
	createVenueEmployeeRole: GraphQLTypes["VenueEmployeeRoleCreateResult"],
	deleteVenueEmployeeRole: GraphQLTypes["VenueEmployeeRoleDeleteResult"],
	updateVenueEmployeeRole: GraphQLTypes["VenueEmployeeRoleUpdateResult"],
	upsertVenueEmployeeRole: GraphQLTypes["VenueEmployeeRoleUpsertResult"],
	createIdentificationAttempt: GraphQLTypes["IdentificationAttemptCreateResult"],
	deleteIdentificationAttempt: GraphQLTypes["IdentificationAttemptDeleteResult"],
	updateIdentificationAttempt: GraphQLTypes["IdentificationAttemptUpdateResult"],
	upsertIdentificationAttempt: GraphQLTypes["IdentificationAttemptUpsertResult"],
	createIdentificationCode: GraphQLTypes["IdentificationCodeCreateResult"],
	deleteIdentificationCode: GraphQLTypes["IdentificationCodeDeleteResult"],
	updateIdentificationCode: GraphQLTypes["IdentificationCodeUpdateResult"],
	upsertIdentificationCode: GraphQLTypes["IdentificationCodeUpsertResult"],
	createIdentificationCodeLocale: GraphQLTypes["IdentificationCodeLocaleCreateResult"],
	deleteIdentificationCodeLocale: GraphQLTypes["IdentificationCodeLocaleDeleteResult"],
	updateIdentificationCodeLocale: GraphQLTypes["IdentificationCodeLocaleUpdateResult"],
	upsertIdentificationCodeLocale: GraphQLTypes["IdentificationCodeLocaleUpsertResult"],
	createPipeline: GraphQLTypes["PipelineCreateResult"],
	deletePipeline: GraphQLTypes["PipelineDeleteResult"],
	updatePipeline: GraphQLTypes["PipelineUpdateResult"],
	upsertPipeline: GraphQLTypes["PipelineUpsertResult"],
	createPipelineLead: GraphQLTypes["PipelineLeadCreateResult"],
	deletePipelineLead: GraphQLTypes["PipelineLeadDeleteResult"],
	updatePipelineLead: GraphQLTypes["PipelineLeadUpdateResult"],
	upsertPipelineLead: GraphQLTypes["PipelineLeadUpsertResult"],
	createPipelineStage: GraphQLTypes["PipelineStageCreateResult"],
	deletePipelineStage: GraphQLTypes["PipelineStageDeleteResult"],
	updatePipelineStage: GraphQLTypes["PipelineStageUpdateResult"],
	upsertPipelineStage: GraphQLTypes["PipelineStageUpsertResult"],
	createPipelineStageItem: GraphQLTypes["PipelineStageItemCreateResult"],
	deletePipelineStageItem: GraphQLTypes["PipelineStageItemDeleteResult"],
	updatePipelineStageItem: GraphQLTypes["PipelineStageItemUpdateResult"],
	upsertPipelineStageItem: GraphQLTypes["PipelineStageItemUpsertResult"],
	createPipelineStageLocale: GraphQLTypes["PipelineStageLocaleCreateResult"],
	deletePipelineStageLocale: GraphQLTypes["PipelineStageLocaleDeleteResult"],
	updatePipelineStageLocale: GraphQLTypes["PipelineStageLocaleUpdateResult"],
	upsertPipelineStageLocale: GraphQLTypes["PipelineStageLocaleUpsertResult"],
	createSalesManager: GraphQLTypes["SalesManagerCreateResult"],
	deleteSalesManager: GraphQLTypes["SalesManagerDeleteResult"],
	updateSalesManager: GraphQLTypes["SalesManagerUpdateResult"],
	upsertSalesManager: GraphQLTypes["SalesManagerUpsertResult"],
	createCashierManager: GraphQLTypes["CashierManagerCreateResult"],
	deleteCashierManager: GraphQLTypes["CashierManagerDeleteResult"],
	updateCashierManager: GraphQLTypes["CashierManagerUpdateResult"],
	upsertCashierManager: GraphQLTypes["CashierManagerUpsertResult"],
	createPointOfSaleApplicationDevice: GraphQLTypes["PointOfSaleApplicationDeviceCreateResult"],
	deletePointOfSaleApplicationDevice: GraphQLTypes["PointOfSaleApplicationDeviceDeleteResult"],
	updatePointOfSaleApplicationDevice: GraphQLTypes["PointOfSaleApplicationDeviceUpdateResult"],
	upsertPointOfSaleApplicationDevice: GraphQLTypes["PointOfSaleApplicationDeviceUpsertResult"],
	createPointOfSaleTerminal: GraphQLTypes["PointOfSaleTerminalCreateResult"],
	deletePointOfSaleTerminal: GraphQLTypes["PointOfSaleTerminalDeleteResult"],
	updatePointOfSaleTerminal: GraphQLTypes["PointOfSaleTerminalUpdateResult"],
	upsertPointOfSaleTerminal: GraphQLTypes["PointOfSaleTerminalUpsertResult"],
	createPipelineStageSentiment: GraphQLTypes["PipelineStageSentimentCreateResult"],
	deletePipelineStageSentiment: GraphQLTypes["PipelineStageSentimentDeleteResult"],
	updatePipelineStageSentiment: GraphQLTypes["PipelineStageSentimentUpdateResult"],
	upsertPipelineStageSentiment: GraphQLTypes["PipelineStageSentimentUpsertResult"],
	createDeviceIdentifier: GraphQLTypes["DeviceIdentifierCreateResult"],
	deleteDeviceIdentifier: GraphQLTypes["DeviceIdentifierDeleteResult"],
	updateDeviceIdentifier: GraphQLTypes["DeviceIdentifierUpdateResult"],
	upsertDeviceIdentifier: GraphQLTypes["DeviceIdentifierUpsertResult"],
	createPointOfSalePrinter: GraphQLTypes["PointOfSalePrinterCreateResult"],
	deletePointOfSalePrinter: GraphQLTypes["PointOfSalePrinterDeleteResult"],
	updatePointOfSalePrinter: GraphQLTypes["PointOfSalePrinterUpdateResult"],
	upsertPointOfSalePrinter: GraphQLTypes["PointOfSalePrinterUpsertResult"],
	createGratuity: GraphQLTypes["GratuityCreateResult"],
	deleteGratuity: GraphQLTypes["GratuityDeleteResult"],
	updateGratuity: GraphQLTypes["GratuityUpdateResult"],
	upsertGratuity: GraphQLTypes["GratuityUpsertResult"],
	createFulfillmentNote: GraphQLTypes["FulfillmentNoteCreateResult"],
	deleteFulfillmentNote: GraphQLTypes["FulfillmentNoteDeleteResult"],
	updateFulfillmentNote: GraphQLTypes["FulfillmentNoteUpdateResult"],
	upsertFulfillmentNote: GraphQLTypes["FulfillmentNoteUpsertResult"],
	createLeadForm: GraphQLTypes["LeadFormCreateResult"],
	deleteLeadForm: GraphQLTypes["LeadFormDeleteResult"],
	updateLeadForm: GraphQLTypes["LeadFormUpdateResult"],
	upsertLeadForm: GraphQLTypes["LeadFormUpsertResult"],
	createSubscriptionBox: GraphQLTypes["SubscriptionBoxCreateResult"],
	deleteSubscriptionBox: GraphQLTypes["SubscriptionBoxDeleteResult"],
	updateSubscriptionBox: GraphQLTypes["SubscriptionBoxUpdateResult"],
	upsertSubscriptionBox: GraphQLTypes["SubscriptionBoxUpsertResult"],
	createSubscriptionBoxLocale: GraphQLTypes["SubscriptionBoxLocaleCreateResult"],
	deleteSubscriptionBoxLocale: GraphQLTypes["SubscriptionBoxLocaleDeleteResult"],
	updateSubscriptionBoxLocale: GraphQLTypes["SubscriptionBoxLocaleUpdateResult"],
	upsertSubscriptionBoxLocale: GraphQLTypes["SubscriptionBoxLocaleUpsertResult"],
	createBusinessService: GraphQLTypes["BusinessServiceCreateResult"],
	deleteBusinessService: GraphQLTypes["BusinessServiceDeleteResult"],
	updateBusinessService: GraphQLTypes["BusinessServiceUpdateResult"],
	upsertBusinessService: GraphQLTypes["BusinessServiceUpsertResult"],
	createBusinessServiceEvent: GraphQLTypes["BusinessServiceEventCreateResult"],
	deleteBusinessServiceEvent: GraphQLTypes["BusinessServiceEventDeleteResult"],
	updateBusinessServiceEvent: GraphQLTypes["BusinessServiceEventUpdateResult"],
	upsertBusinessServiceEvent: GraphQLTypes["BusinessServiceEventUpsertResult"],
	createBusinessServiceLocale: GraphQLTypes["BusinessServiceLocaleCreateResult"],
	deleteBusinessServiceLocale: GraphQLTypes["BusinessServiceLocaleDeleteResult"],
	updateBusinessServiceLocale: GraphQLTypes["BusinessServiceLocaleUpdateResult"],
	upsertBusinessServiceLocale: GraphQLTypes["BusinessServiceLocaleUpsertResult"],
	createGridTileItem: GraphQLTypes["GridTileItemCreateResult"],
	deleteGridTileItem: GraphQLTypes["GridTileItemDeleteResult"],
	updateGridTileItem: GraphQLTypes["GridTileItemUpdateResult"],
	upsertGridTileItem: GraphQLTypes["GridTileItemUpsertResult"],
	createGridTiles: GraphQLTypes["GridTilesCreateResult"],
	deleteGridTiles: GraphQLTypes["GridTilesDeleteResult"],
	updateGridTiles: GraphQLTypes["GridTilesUpdateResult"],
	upsertGridTiles: GraphQLTypes["GridTilesUpsertResult"],
	createArea: GraphQLTypes["AreaCreateResult"],
	deleteArea: GraphQLTypes["AreaDeleteResult"],
	updateArea: GraphQLTypes["AreaUpdateResult"],
	upsertArea: GraphQLTypes["AreaUpsertResult"],
	createPosition: GraphQLTypes["PositionCreateResult"],
	deletePosition: GraphQLTypes["PositionDeleteResult"],
	updatePosition: GraphQLTypes["PositionUpdateResult"],
	upsertPosition: GraphQLTypes["PositionUpsertResult"],
	createStatsEnabledWidgetType: GraphQLTypes["StatsEnabledWidgetTypeCreateResult"],
	deleteStatsEnabledWidgetType: GraphQLTypes["StatsEnabledWidgetTypeDeleteResult"],
	updateStatsEnabledWidgetType: GraphQLTypes["StatsEnabledWidgetTypeUpdateResult"],
	upsertStatsEnabledWidgetType: GraphQLTypes["StatsEnabledWidgetTypeUpsertResult"],
	createStatsWidget: GraphQLTypes["StatsWidgetCreateResult"],
	deleteStatsWidget: GraphQLTypes["StatsWidgetDeleteResult"],
	updateStatsWidget: GraphQLTypes["StatsWidgetUpdateResult"],
	upsertStatsWidget: GraphQLTypes["StatsWidgetUpsertResult"],
	createStatsWidgetsLayout: GraphQLTypes["StatsWidgetsLayoutCreateResult"],
	deleteStatsWidgetsLayout: GraphQLTypes["StatsWidgetsLayoutDeleteResult"],
	updateStatsWidgetsLayout: GraphQLTypes["StatsWidgetsLayoutUpdateResult"],
	upsertStatsWidgetsLayout: GraphQLTypes["StatsWidgetsLayoutUpsertResult"],
	createSeat: GraphQLTypes["SeatCreateResult"],
	deleteSeat: GraphQLTypes["SeatDeleteResult"],
	updateSeat: GraphQLTypes["SeatUpdateResult"],
	upsertSeat: GraphQLTypes["SeatUpsertResult"],
	createTable: GraphQLTypes["TableCreateResult"],
	deleteTable: GraphQLTypes["TableDeleteResult"],
	updateTable: GraphQLTypes["TableUpdateResult"],
	upsertTable: GraphQLTypes["TableUpsertResult"],
	createStatsPage: GraphQLTypes["StatsPageCreateResult"],
	deleteStatsPage: GraphQLTypes["StatsPageDeleteResult"],
	updateStatsPage: GraphQLTypes["StatsPageUpdateResult"],
	upsertStatsPage: GraphQLTypes["StatsPageUpsertResult"],
	createUnassignReason: GraphQLTypes["UnassignReasonCreateResult"],
	deleteUnassignReason: GraphQLTypes["UnassignReasonDeleteResult"],
	updateUnassignReason: GraphQLTypes["UnassignReasonUpdateResult"],
	upsertUnassignReason: GraphQLTypes["UnassignReasonUpsertResult"],
	createDoubleshotCoffeeEquipment: GraphQLTypes["DoubleshotCoffeeEquipmentCreateResult"],
	deleteDoubleshotCoffeeEquipment: GraphQLTypes["DoubleshotCoffeeEquipmentDeleteResult"],
	updateDoubleshotCoffeeEquipment: GraphQLTypes["DoubleshotCoffeeEquipmentUpdateResult"],
	upsertDoubleshotCoffeeEquipment: GraphQLTypes["DoubleshotCoffeeEquipmentUpsertResult"],
	createExpense: GraphQLTypes["ExpenseCreateResult"],
	deleteExpense: GraphQLTypes["ExpenseDeleteResult"],
	updateExpense: GraphQLTypes["ExpenseUpdateResult"],
	upsertExpense: GraphQLTypes["ExpenseUpsertResult"],
	createExpenseCategory: GraphQLTypes["ExpenseCategoryCreateResult"],
	deleteExpenseCategory: GraphQLTypes["ExpenseCategoryDeleteResult"],
	updateExpenseCategory: GraphQLTypes["ExpenseCategoryUpdateResult"],
	upsertExpenseCategory: GraphQLTypes["ExpenseCategoryUpsertResult"],
	createExpenseChange: GraphQLTypes["ExpenseChangeCreateResult"],
	deleteExpenseChange: GraphQLTypes["ExpenseChangeDeleteResult"],
	updateExpenseChange: GraphQLTypes["ExpenseChangeUpdateResult"],
	upsertExpenseChange: GraphQLTypes["ExpenseChangeUpsertResult"],
	createExpenseDocument: GraphQLTypes["ExpenseDocumentCreateResult"],
	deleteExpenseDocument: GraphQLTypes["ExpenseDocumentDeleteResult"],
	updateExpenseDocument: GraphQLTypes["ExpenseDocumentUpdateResult"],
	upsertExpenseDocument: GraphQLTypes["ExpenseDocumentUpsertResult"],
	createRevenuePrediction: GraphQLTypes["RevenuePredictionCreateResult"],
	deleteRevenuePrediction: GraphQLTypes["RevenuePredictionDeleteResult"],
	updateRevenuePrediction: GraphQLTypes["RevenuePredictionUpdateResult"],
	upsertRevenuePrediction: GraphQLTypes["RevenuePredictionUpsertResult"],
	createRevenuePredictionChange: GraphQLTypes["RevenuePredictionChangeCreateResult"],
	deleteRevenuePredictionChange: GraphQLTypes["RevenuePredictionChangeDeleteResult"],
	updateRevenuePredictionChange: GraphQLTypes["RevenuePredictionChangeUpdateResult"],
	upsertRevenuePredictionChange: GraphQLTypes["RevenuePredictionChangeUpsertResult"],
	createFile: GraphQLTypes["FileCreateResult"],
	deleteFile: GraphQLTypes["FileDeleteResult"],
	updateFile: GraphQLTypes["FileUpdateResult"],
	upsertFile: GraphQLTypes["FileUpsertResult"],
	createLine: GraphQLTypes["LineCreateResult"],
	deleteLine: GraphQLTypes["LineDeleteResult"],
	updateLine: GraphQLTypes["LineUpdateResult"],
	upsertLine: GraphQLTypes["LineUpsertResult"],
	createFinancesBalanceItem: GraphQLTypes["FinancesBalanceItemCreateResult"],
	deleteFinancesBalanceItem: GraphQLTypes["FinancesBalanceItemDeleteResult"],
	updateFinancesBalanceItem: GraphQLTypes["FinancesBalanceItemUpdateResult"],
	upsertFinancesBalanceItem: GraphQLTypes["FinancesBalanceItemUpsertResult"],
	createWoltDriveDelivery: GraphQLTypes["WoltDriveDeliveryCreateResult"],
	deleteWoltDriveDelivery: GraphQLTypes["WoltDriveDeliveryDeleteResult"],
	updateWoltDriveDelivery: GraphQLTypes["WoltDriveDeliveryUpdateResult"],
	upsertWoltDriveDelivery: GraphQLTypes["WoltDriveDeliveryUpsertResult"],
	transaction: GraphQLTypes["MutationTransaction"],
	query: GraphQLTypes["Query"],
	generateUploadUrl: GraphQLTypes["S3SignedUpload"],
	generateReadUrl: GraphQLTypes["S3SignedRead"]
};
	["AddressCreateResult"]: {
	__typename: "AddressCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Address"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MutationResult"]: {
	__typename:"AddressCreateResult" | "AddressDeleteResult" | "AddressUpdateResult" | "AddressUpsertResult" | "CountryCreateResult" | "CountryDeleteResult" | "CountryUpdateResult" | "CountryUpsertResult" | "ChannelCreateResult" | "ChannelDeleteResult" | "ChannelUpdateResult" | "ChannelUpsertResult" | "ChannelPaymentCreateResult" | "ChannelPaymentDeleteResult" | "ChannelPaymentUpdateResult" | "ChannelPaymentUpsertResult" | "ChannelDeliveryCreateResult" | "ChannelDeliveryDeleteResult" | "ChannelDeliveryUpdateResult" | "ChannelDeliveryUpsertResult" | "CustomerCreateResult" | "CustomerDeleteResult" | "CustomerUpdateResult" | "CustomerUpsertResult" | "CustomerCreditCreateResult" | "CustomerCreditDeleteResult" | "CustomerCreditUpdateResult" | "CustomerCreditUpsertResult" | "CustomerGroupCreateResult" | "CustomerGroupDeleteResult" | "CustomerGroupUpdateResult" | "CustomerGroupUpsertResult" | "CustomerPaymentMethodCreateResult" | "CustomerPaymentMethodDeleteResult" | "CustomerPaymentMethodUpdateResult" | "CustomerPaymentMethodUpsertResult" | "DeliveryMethodCreateResult" | "DeliveryMethodDeleteResult" | "DeliveryMethodUpdateResult" | "DeliveryMethodUpsertResult" | "OrderCreateResult" | "OrderDeleteResult" | "OrderUpdateResult" | "OrderUpsertResult" | "OrderDiscountCreateResult" | "OrderDiscountDeleteResult" | "OrderDiscountUpdateResult" | "OrderDiscountUpsertResult" | "OrderPaymentCreateResult" | "OrderPaymentDeleteResult" | "OrderPaymentUpdateResult" | "OrderPaymentUpsertResult" | "OrderDeliveryCreateResult" | "OrderDeliveryDeleteResult" | "OrderDeliveryUpdateResult" | "OrderDeliveryUpsertResult" | "OrderItemCreateResult" | "OrderItemDeleteResult" | "OrderItemUpdateResult" | "OrderItemUpsertResult" | "PaymentMethodCreateResult" | "PaymentMethodDeleteResult" | "PaymentMethodUpdateResult" | "PaymentMethodUpsertResult" | "VatRateCreateResult" | "VatRateDeleteResult" | "VatRateUpdateResult" | "VatRateUpsertResult" | "ProductCreateResult" | "ProductDeleteResult" | "ProductUpdateResult" | "ProductUpsertResult" | "ProductStockCreateResult" | "ProductStockDeleteResult" | "ProductStockUpdateResult" | "ProductStockUpsertResult" | "ProductPackingCreateResult" | "ProductPackingDeleteResult" | "ProductPackingUpdateResult" | "ProductPackingUpsertResult" | "ProductGroupPriceCreateResult" | "ProductGroupPriceDeleteResult" | "ProductGroupPriceUpdateResult" | "ProductGroupPriceUpsertResult" | "ProductRecipeCreateResult" | "ProductRecipeDeleteResult" | "ProductRecipeUpdateResult" | "ProductRecipeUpsertResult" | "ProductCategoryCreateResult" | "ProductCategoryDeleteResult" | "ProductCategoryUpdateResult" | "ProductCategoryUpsertResult" | "StoreCreateResult" | "StoreDeleteResult" | "StoreUpdateResult" | "StoreUpsertResult" | "TagCreateResult" | "TagDeleteResult" | "TagUpdateResult" | "TagUpsertResult" | "ImageCreateResult" | "ImageDeleteResult" | "ImageUpdateResult" | "ImageUpsertResult" | "BusinessCategoryCreateResult" | "BusinessCategoryDeleteResult" | "BusinessCategoryUpdateResult" | "BusinessCategoryUpsertResult" | "ProductListCreateResult" | "ProductListDeleteResult" | "ProductListUpdateResult" | "ProductListUpsertResult" | "ProductListItemCreateResult" | "ProductListItemDeleteResult" | "ProductListItemUpdateResult" | "ProductListItemUpsertResult" | "ProductCategoryListCreateResult" | "ProductCategoryListDeleteResult" | "ProductCategoryListUpdateResult" | "ProductCategoryListUpsertResult" | "ProductCategoryListItemCreateResult" | "ProductCategoryListItemDeleteResult" | "ProductCategoryListItemUpdateResult" | "ProductCategoryListItemUpsertResult" | "BusinessCategoryLocaleCreateResult" | "BusinessCategoryLocaleDeleteResult" | "BusinessCategoryLocaleUpdateResult" | "BusinessCategoryLocaleUpsertResult" | "LocaleCreateResult" | "LocaleDeleteResult" | "LocaleUpdateResult" | "LocaleUpsertResult" | "ProductCategoryListLocaleCreateResult" | "ProductCategoryListLocaleDeleteResult" | "ProductCategoryListLocaleUpdateResult" | "ProductCategoryListLocaleUpsertResult" | "CustomerNameCreateResult" | "CustomerNameDeleteResult" | "CustomerNameUpdateResult" | "CustomerNameUpsertResult" | "CustomerAliasCreateResult" | "CustomerAliasDeleteResult" | "CustomerAliasUpdateResult" | "CustomerAliasUpsertResult" | "ProductIngredientItemCreateResult" | "ProductIngredientItemDeleteResult" | "ProductIngredientItemUpdateResult" | "ProductIngredientItemUpsertResult" | "ProductIngredientItemQuantityCreateResult" | "ProductIngredientItemQuantityDeleteResult" | "ProductIngredientItemQuantityUpdateResult" | "ProductIngredientItemQuantityUpsertResult" | "ProductIngredientItemQuantityUnitCreateResult" | "ProductIngredientItemQuantityUnitDeleteResult" | "ProductIngredientItemQuantityUnitUpdateResult" | "ProductIngredientItemQuantityUnitUpsertResult" | "ProductIngredientCreateResult" | "ProductIngredientDeleteResult" | "ProductIngredientUpdateResult" | "ProductIngredientUpsertResult" | "CustomerIngredientRatingCreateResult" | "CustomerIngredientRatingDeleteResult" | "CustomerIngredientRatingUpdateResult" | "CustomerIngredientRatingUpsertResult" | "ProductIngredientRatingCreateResult" | "ProductIngredientRatingDeleteResult" | "ProductIngredientRatingUpdateResult" | "ProductIngredientRatingUpsertResult" | "ProductIngredientLocaleCreateResult" | "ProductIngredientLocaleDeleteResult" | "ProductIngredientLocaleUpdateResult" | "ProductIngredientLocaleUpsertResult" | "OrderRecurrenceCreateResult" | "OrderRecurrenceDeleteResult" | "OrderRecurrenceUpdateResult" | "OrderRecurrenceUpsertResult" | "OrderRecurrenceLocaleCreateResult" | "OrderRecurrenceLocaleDeleteResult" | "OrderRecurrenceLocaleUpdateResult" | "OrderRecurrenceLocaleUpsertResult" | "BusinessCustomerCreateResult" | "BusinessCustomerDeleteResult" | "BusinessCustomerUpdateResult" | "BusinessCustomerUpsertResult" | "PointOfSaleCreateResult" | "PointOfSaleDeleteResult" | "PointOfSaleUpdateResult" | "PointOfSaleUpsertResult" | "StaffCreateResult" | "StaffDeleteResult" | "StaffUpdateResult" | "StaffUpsertResult" | "BlogCreateResult" | "BlogDeleteResult" | "BlogUpdateResult" | "BlogUpsertResult" | "BlogLocaleCreateResult" | "BlogLocaleDeleteResult" | "BlogLocaleUpdateResult" | "BlogLocaleUpsertResult" | "BlogPostCreateResult" | "BlogPostDeleteResult" | "BlogPostUpdateResult" | "BlogPostUpsertResult" | "BlogPostLocaleCreateResult" | "BlogPostLocaleDeleteResult" | "BlogPostLocaleUpdateResult" | "BlogPostLocaleUpsertResult" | "ColorPalleteCreateResult" | "ColorPalleteDeleteResult" | "ColorPalleteUpdateResult" | "ColorPalleteUpsertResult" | "ContentCreateResult" | "ContentDeleteResult" | "ContentUpdateResult" | "ContentUpsertResult" | "ContentBlockCreateResult" | "ContentBlockDeleteResult" | "ContentBlockUpdateResult" | "ContentBlockUpsertResult" | "ContentReferenceCreateResult" | "ContentReferenceDeleteResult" | "ContentReferenceUpdateResult" | "ContentReferenceUpsertResult" | "BlogPostListCreateResult" | "BlogPostListDeleteResult" | "BlogPostListUpdateResult" | "BlogPostListUpsertResult" | "BlogPostListItemCreateResult" | "BlogPostListItemDeleteResult" | "BlogPostListItemUpdateResult" | "BlogPostListItemUpsertResult" | "LinkListCreateResult" | "LinkListDeleteResult" | "LinkListUpdateResult" | "LinkListUpsertResult" | "LinkListItemCreateResult" | "LinkListItemDeleteResult" | "LinkListItemUpdateResult" | "LinkListItemUpsertResult" | "CoverCreateResult" | "CoverDeleteResult" | "CoverUpdateResult" | "CoverUpsertResult" | "LinkCreateResult" | "LinkDeleteResult" | "LinkUpdateResult" | "LinkUpsertResult" | "LinkableCreateResult" | "LinkableDeleteResult" | "LinkableUpdateResult" | "LinkableUpsertResult" | "MediumCreateResult" | "MediumDeleteResult" | "MediumUpdateResult" | "MediumUpsertResult" | "VideoCreateResult" | "VideoDeleteResult" | "VideoUpdateResult" | "VideoUpsertResult" | "SeoCreateResult" | "SeoDeleteResult" | "SeoUpdateResult" | "SeoUpsertResult" | "ProtectedImageCreateResult" | "ProtectedImageDeleteResult" | "ProtectedImageUpdateResult" | "ProtectedImageUpsertResult" | "TranslationDomainCreateResult" | "TranslationDomainDeleteResult" | "TranslationDomainUpdateResult" | "TranslationDomainUpsertResult" | "TranslationCatalogueCreateResult" | "TranslationCatalogueDeleteResult" | "TranslationCatalogueUpdateResult" | "TranslationCatalogueUpsertResult" | "TranslationKeyCreateResult" | "TranslationKeyDeleteResult" | "TranslationKeyUpdateResult" | "TranslationKeyUpsertResult" | "TranslationValueCreateResult" | "TranslationValueDeleteResult" | "TranslationValueUpdateResult" | "TranslationValueUpsertResult" | "TranslationCataloguesIdentifierCreateResult" | "TranslationCataloguesIdentifierDeleteResult" | "TranslationCataloguesIdentifierUpdateResult" | "TranslationCataloguesIdentifierUpsertResult" | "SocialsAndAppsCreateResult" | "SocialsAndAppsDeleteResult" | "SocialsAndAppsUpdateResult" | "SocialsAndAppsUpsertResult" | "ProductGridCreateResult" | "ProductGridDeleteResult" | "ProductGridUpdateResult" | "ProductGridUpsertResult" | "ProductGridItemCreateResult" | "ProductGridItemDeleteResult" | "ProductGridItemUpdateResult" | "ProductGridItemUpsertResult" | "GalleryCreateResult" | "GalleryDeleteResult" | "GalleryUpdateResult" | "GalleryUpsertResult" | "GalleryItemCreateResult" | "GalleryItemDeleteResult" | "GalleryItemUpdateResult" | "GalleryItemUpsertResult" | "HeroCreateResult" | "HeroDeleteResult" | "HeroUpdateResult" | "HeroUpsertResult" | "SiteMenuCreateResult" | "SiteMenuDeleteResult" | "SiteMenuUpdateResult" | "SiteMenuUpsertResult" | "MenuLocaleCreateResult" | "MenuLocaleDeleteResult" | "MenuLocaleUpdateResult" | "MenuLocaleUpsertResult" | "MenuItemCreateResult" | "MenuItemDeleteResult" | "MenuItemUpdateResult" | "MenuItemUpsertResult" | "PageCreateResult" | "PageDeleteResult" | "PageUpdateResult" | "PageUpsertResult" | "PageLocaleCreateResult" | "PageLocaleDeleteResult" | "PageLocaleUpdateResult" | "PageLocaleUpsertResult" | "WikiPageCreateResult" | "WikiPageDeleteResult" | "WikiPageUpdateResult" | "WikiPageUpsertResult" | "MenuSubitemCreateResult" | "MenuSubitemDeleteResult" | "MenuSubitemUpdateResult" | "MenuSubitemUpsertResult" | "MenuLinkListCreateResult" | "MenuLinkListDeleteResult" | "MenuLinkListUpdateResult" | "MenuLinkListUpsertResult" | "MenuLinkItemCreateResult" | "MenuLinkItemDeleteResult" | "MenuLinkItemUpdateResult" | "MenuLinkItemUpsertResult" | "MenuProductsCreateResult" | "MenuProductsDeleteResult" | "MenuProductsUpdateResult" | "MenuProductsUpsertResult" | "MenuDeliveryCreateResult" | "MenuDeliveryDeleteResult" | "MenuDeliveryUpdateResult" | "MenuDeliveryUpsertResult" | "MenuContactCreateResult" | "MenuContactDeleteResult" | "MenuContactUpdateResult" | "MenuContactUpsertResult" | "DeadlineTemplateCreateResult" | "DeadlineTemplateDeleteResult" | "DeadlineTemplateUpdateResult" | "DeadlineTemplateUpsertResult" | "EmployeeQueueCreateResult" | "EmployeeQueueDeleteResult" | "EmployeeQueueUpdateResult" | "EmployeeQueueUpsertResult" | "TimetableDayCreateResult" | "TimetableDayDeleteResult" | "TimetableDayUpdateResult" | "TimetableDayUpsertResult" | "TimetableEmployeeRoleCreateResult" | "TimetableEmployeeRoleDeleteResult" | "TimetableEmployeeRoleUpdateResult" | "TimetableEmployeeRoleUpsertResult" | "TimetableShiftCreateResult" | "TimetableShiftDeleteResult" | "TimetableShiftUpdateResult" | "TimetableShiftUpsertResult" | "TimetableShiftGroupCreateResult" | "TimetableShiftGroupDeleteResult" | "TimetableShiftGroupUpdateResult" | "TimetableShiftGroupUpsertResult" | "TimetableShiftPositionCreateResult" | "TimetableShiftPositionDeleteResult" | "TimetableShiftPositionUpdateResult" | "TimetableShiftPositionUpsertResult" | "TimetableTemplateCreateResult" | "TimetableTemplateDeleteResult" | "TimetableTemplateUpdateResult" | "TimetableTemplateUpsertResult" | "CartCreateResult" | "CartDeleteResult" | "CartUpdateResult" | "CartUpsertResult" | "CartItemCreateResult" | "CartItemDeleteResult" | "CartItemUpdateResult" | "CartItemUpsertResult" | "EmployeeQueueItemCreateResult" | "EmployeeQueueItemDeleteResult" | "EmployeeQueueItemUpdateResult" | "EmployeeQueueItemUpsertResult" | "ApplicationCreateResult" | "ApplicationDeleteResult" | "ApplicationUpdateResult" | "ApplicationUpsertResult" | "ApplicationShortcutListCreateResult" | "ApplicationShortcutListDeleteResult" | "ApplicationShortcutListUpdateResult" | "ApplicationShortcutListUpsertResult" | "ApplicationShortcutListItemCreateResult" | "ApplicationShortcutListItemDeleteResult" | "ApplicationShortcutListItemUpdateResult" | "ApplicationShortcutListItemUpsertResult" | "ProductBannerCreateResult" | "ProductBannerDeleteResult" | "ProductBannerUpdateResult" | "ProductBannerUpsertResult" | "ProductBannerItemCreateResult" | "ProductBannerItemDeleteResult" | "ProductBannerItemUpdateResult" | "ProductBannerItemUpsertResult" | "ProductBannerListCreateResult" | "ProductBannerListDeleteResult" | "ProductBannerListUpdateResult" | "ProductBannerListUpsertResult" | "BartenderCreateResult" | "BartenderDeleteResult" | "BartenderUpdateResult" | "BartenderUpsertResult" | "BusinessToBusinessManagerCreateResult" | "BusinessToBusinessManagerDeleteResult" | "BusinessToBusinessManagerUpdateResult" | "BusinessToBusinessManagerUpsertResult" | "CleanerCreateResult" | "CleanerDeleteResult" | "CleanerUpdateResult" | "CleanerUpsertResult" | "CourierCreateResult" | "CourierDeleteResult" | "CourierUpdateResult" | "CourierUpsertResult" | "ShiftsManagerCreateResult" | "ShiftsManagerDeleteResult" | "ShiftsManagerUpdateResult" | "ShiftsManagerUpsertResult" | "UserCreateResult" | "UserDeleteResult" | "UserUpdateResult" | "UserUpsertResult" | "ShiftsProfileCreateResult" | "ShiftsProfileDeleteResult" | "ShiftsProfileUpdateResult" | "ShiftsProfileUpsertResult" | "ProductIngredientCategoryCreateResult" | "ProductIngredientCategoryDeleteResult" | "ProductIngredientCategoryUpdateResult" | "ProductIngredientCategoryUpsertResult" | "ProductIngredientCategoryLocaleCreateResult" | "ProductIngredientCategoryLocaleDeleteResult" | "ProductIngredientCategoryLocaleUpdateResult" | "ProductIngredientCategoryLocaleUpsertResult" | "StocksManagerCreateResult" | "StocksManagerDeleteResult" | "StocksManagerUpdateResult" | "StocksManagerUpsertResult" | "DeliveryRouteCreateResult" | "DeliveryRouteDeleteResult" | "DeliveryRouteUpdateResult" | "DeliveryRouteUpsertResult" | "DeliveryWaypointCreateResult" | "DeliveryWaypointDeleteResult" | "DeliveryWaypointUpdateResult" | "DeliveryWaypointUpsertResult" | "AllergenCreateResult" | "AllergenDeleteResult" | "AllergenUpdateResult" | "AllergenUpsertResult" | "AllergenLocaleCreateResult" | "AllergenLocaleDeleteResult" | "AllergenLocaleUpdateResult" | "AllergenLocaleUpsertResult" | "GpsCreateResult" | "GpsDeleteResult" | "GpsUpdateResult" | "GpsUpsertResult" | "WeekHoursCreateResult" | "WeekHoursDeleteResult" | "WeekHoursUpdateResult" | "WeekHoursUpsertResult" | "PreparedIngredientQuantityCreateResult" | "PreparedIngredientQuantityDeleteResult" | "PreparedIngredientQuantityUpdateResult" | "PreparedIngredientQuantityUpsertResult" | "PreparedRecipeQuantityCreateResult" | "PreparedRecipeQuantityDeleteResult" | "PreparedRecipeQuantityUpdateResult" | "PreparedRecipeQuantityUpsertResult" | "InternalOrderCreateResult" | "InternalOrderDeleteResult" | "InternalOrderUpdateResult" | "InternalOrderUpsertResult" | "InternalOrderItemCreateResult" | "InternalOrderItemDeleteResult" | "InternalOrderItemUpdateResult" | "InternalOrderItemUpsertResult" | "PreparedPackingQuantityCreateResult" | "PreparedPackingQuantityDeleteResult" | "PreparedPackingQuantityUpdateResult" | "PreparedPackingQuantityUpsertResult" | "CourierManagerCreateResult" | "CourierManagerDeleteResult" | "CourierManagerUpdateResult" | "CourierManagerUpsertResult" | "DeliveryZoneCreateResult" | "DeliveryZoneDeleteResult" | "DeliveryZoneUpdateResult" | "DeliveryZoneUpsertResult" | "DeliveryTimelinePresetCreateResult" | "DeliveryTimelinePresetDeleteResult" | "DeliveryTimelinePresetUpdateResult" | "DeliveryTimelinePresetUpsertResult" | "OrderDeliveryTimelineCreateResult" | "OrderDeliveryTimelineDeleteResult" | "OrderDeliveryTimelineUpdateResult" | "OrderDeliveryTimelineUpsertResult" | "OrderEventCreateResult" | "OrderEventDeleteResult" | "OrderEventUpdateResult" | "OrderEventUpsertResult" | "LiftagoRideCreateResult" | "LiftagoRideDeleteResult" | "LiftagoRideUpdateResult" | "LiftagoRideUpsertResult" | "InvoiceCreateResult" | "InvoiceDeleteResult" | "InvoiceUpdateResult" | "InvoiceUpsertResult" | "InvoicingPlanCreateResult" | "InvoicingPlanDeleteResult" | "InvoicingPlanUpdateResult" | "InvoicingPlanUpsertResult" | "ProductPackingLocaleCreateResult" | "ProductPackingLocaleDeleteResult" | "ProductPackingLocaleUpdateResult" | "ProductPackingLocaleUpsertResult" | "ProductLocaleCreateResult" | "ProductLocaleDeleteResult" | "ProductLocaleUpdateResult" | "ProductLocaleUpsertResult" | "ProductRecipeLocaleCreateResult" | "ProductRecipeLocaleDeleteResult" | "ProductRecipeLocaleUpdateResult" | "ProductRecipeLocaleUpsertResult" | "UserDeviceCreateResult" | "UserDeviceDeleteResult" | "UserDeviceUpdateResult" | "UserDeviceUpsertResult" | "ProtectedActionCreateResult" | "ProtectedActionDeleteResult" | "ProtectedActionUpdateResult" | "ProtectedActionUpsertResult" | "PickerCreateResult" | "PickerDeleteResult" | "PickerUpdateResult" | "PickerUpsertResult" | "TimetableTemplateStaffOptionsCreateResult" | "TimetableTemplateStaffOptionsDeleteResult" | "TimetableTemplateStaffOptionsUpdateResult" | "TimetableTemplateStaffOptionsUpsertResult" | "ShoppingListCreateResult" | "ShoppingListDeleteResult" | "ShoppingListUpdateResult" | "ShoppingListUpsertResult" | "SuppliesPurchaseCreateResult" | "SuppliesPurchaseDeleteResult" | "SuppliesPurchaseUpdateResult" | "SuppliesPurchaseUpsertResult" | "InvoicingPresetCreateResult" | "InvoicingPresetDeleteResult" | "InvoicingPresetUpdateResult" | "InvoicingPresetUpsertResult" | "LogRecordCreateResult" | "LogRecordDeleteResult" | "LogRecordUpdateResult" | "LogRecordUpsertResult" | "BillingSubjectCreateResult" | "BillingSubjectDeleteResult" | "BillingSubjectUpdateResult" | "BillingSubjectUpsertResult" | "ShoppingListItemCreateResult" | "ShoppingListItemDeleteResult" | "ShoppingListItemUpdateResult" | "ShoppingListItemUpsertResult" | "SuppliesPurchaseItemCreateResult" | "SuppliesPurchaseItemDeleteResult" | "SuppliesPurchaseItemUpdateResult" | "SuppliesPurchaseItemUpsertResult" | "CustomerCreditTransactionCreateResult" | "CustomerCreditTransactionDeleteResult" | "CustomerCreditTransactionUpdateResult" | "CustomerCreditTransactionUpsertResult" | "VirtualProductCreateResult" | "VirtualProductDeleteResult" | "VirtualProductUpdateResult" | "VirtualProductUpsertResult" | "VirtualProductEffectCreateResult" | "VirtualProductEffectDeleteResult" | "VirtualProductEffectUpdateResult" | "VirtualProductEffectUpsertResult" | "EmploymentInformationCreateResult" | "EmploymentInformationDeleteResult" | "EmploymentInformationUpdateResult" | "EmploymentInformationUpsertResult" | "RemunerationProfileCreateResult" | "RemunerationProfileDeleteResult" | "RemunerationProfileUpdateResult" | "RemunerationProfileUpsertResult" | "WorkMonthCreateResult" | "WorkMonthDeleteResult" | "WorkMonthUpdateResult" | "WorkMonthUpsertResult" | "SalaryOptionsCreateResult" | "SalaryOptionsDeleteResult" | "SalaryOptionsUpdateResult" | "SalaryOptionsUpsertResult" | "TimetableShiftSwapInfoCreateResult" | "TimetableShiftSwapInfoDeleteResult" | "TimetableShiftSwapInfoUpdateResult" | "TimetableShiftSwapInfoUpsertResult" | "ProductGridCategoryCreateResult" | "ProductGridCategoryDeleteResult" | "ProductGridCategoryUpdateResult" | "ProductGridCategoryUpsertResult" | "CashierCreateResult" | "CashierDeleteResult" | "CashierUpdateResult" | "CashierUpsertResult" | "PointOfSaleCategoryCreateResult" | "PointOfSaleCategoryDeleteResult" | "PointOfSaleCategoryUpdateResult" | "PointOfSaleCategoryUpsertResult" | "PointOfSaleCategoryLocaleCreateResult" | "PointOfSaleCategoryLocaleDeleteResult" | "PointOfSaleCategoryLocaleUpdateResult" | "PointOfSaleCategoryLocaleUpsertResult" | "PointOfSaleCategoryProductCreateResult" | "PointOfSaleCategoryProductDeleteResult" | "PointOfSaleCategoryProductUpdateResult" | "PointOfSaleCategoryProductUpsertResult" | "PointOfSaleCategoryProductLocaleCreateResult" | "PointOfSaleCategoryProductLocaleDeleteResult" | "PointOfSaleCategoryProductLocaleUpdateResult" | "PointOfSaleCategoryProductLocaleUpsertResult" | "CustomerTabCreateResult" | "CustomerTabDeleteResult" | "CustomerTabUpdateResult" | "CustomerTabUpsertResult" | "CustomerTabItemCreateResult" | "CustomerTabItemDeleteResult" | "CustomerTabItemUpdateResult" | "CustomerTabItemUpsertResult" | "AnonymousSessionCreateResult" | "AnonymousSessionDeleteResult" | "AnonymousSessionUpdateResult" | "AnonymousSessionUpsertResult" | "VoucherCreateResult" | "VoucherDeleteResult" | "VoucherUpdateResult" | "VoucherUpsertResult" | "VoucherRedemptionCreateResult" | "VoucherRedemptionDeleteResult" | "VoucherRedemptionUpdateResult" | "VoucherRedemptionUpsertResult" | "UnassignedShiftInfoCreateResult" | "UnassignedShiftInfoDeleteResult" | "UnassignedShiftInfoUpdateResult" | "UnassignedShiftInfoUpsertResult" | "FreshingContainerCreateResult" | "FreshingContainerDeleteResult" | "FreshingContainerUpdateResult" | "FreshingContainerUpsertResult" | "TextItemCreateResult" | "TextItemDeleteResult" | "TextItemUpdateResult" | "TextItemUpsertResult" | "TextListCreateResult" | "TextListDeleteResult" | "TextListUpdateResult" | "TextListUpsertResult" | "DeliveryRegionsCreateResult" | "DeliveryRegionsDeleteResult" | "DeliveryRegionsUpdateResult" | "DeliveryRegionsUpsertResult" | "DeliveryRegionsItemCreateResult" | "DeliveryRegionsItemDeleteResult" | "DeliveryRegionsItemUpdateResult" | "DeliveryRegionsItemUpsertResult" | "ImageListCreateResult" | "ImageListDeleteResult" | "ImageListUpdateResult" | "ImageListUpsertResult" | "ImageListItemCreateResult" | "ImageListItemDeleteResult" | "ImageListItemUpdateResult" | "ImageListItemUpsertResult" | "TimetablesEmployeePrivilegesCreateResult" | "TimetablesEmployeePrivilegesDeleteResult" | "TimetablesEmployeePrivilegesUpdateResult" | "TimetablesEmployeePrivilegesUpsertResult" | "TimetableDayNoteCreateResult" | "TimetableDayNoteDeleteResult" | "TimetableDayNoteUpdateResult" | "TimetableDayNoteUpsertResult" | "DeliveryMethodLocaleCreateResult" | "DeliveryMethodLocaleDeleteResult" | "DeliveryMethodLocaleUpdateResult" | "DeliveryMethodLocaleUpsertResult" | "IngredientSupplierCreateResult" | "IngredientSupplierDeleteResult" | "IngredientSupplierUpdateResult" | "IngredientSupplierUpsertResult" | "IngredientSupplierItemCreateResult" | "IngredientSupplierItemDeleteResult" | "IngredientSupplierItemUpdateResult" | "IngredientSupplierItemUpsertResult" | "IngredientSupplierListCreateResult" | "IngredientSupplierListDeleteResult" | "IngredientSupplierListUpdateResult" | "IngredientSupplierListUpsertResult" | "IngredientSupplierLocaleCreateResult" | "IngredientSupplierLocaleDeleteResult" | "IngredientSupplierLocaleUpdateResult" | "IngredientSupplierLocaleUpsertResult" | "RedirectCreateResult" | "RedirectDeleteResult" | "RedirectUpdateResult" | "RedirectUpsertResult" | "NutritionFactsCreateResult" | "NutritionFactsDeleteResult" | "NutritionFactsUpdateResult" | "NutritionFactsUpsertResult" | "VenueCreateResult" | "VenueDeleteResult" | "VenueUpdateResult" | "VenueUpsertResult" | "WorkspaceCreateResult" | "WorkspaceDeleteResult" | "WorkspaceUpdateResult" | "WorkspaceUpsertResult" | "InternalBuyerCreateResult" | "InternalBuyerDeleteResult" | "InternalBuyerUpdateResult" | "InternalBuyerUpsertResult" | "VenueEmployeeRoleCreateResult" | "VenueEmployeeRoleDeleteResult" | "VenueEmployeeRoleUpdateResult" | "VenueEmployeeRoleUpsertResult" | "IdentificationAttemptCreateResult" | "IdentificationAttemptDeleteResult" | "IdentificationAttemptUpdateResult" | "IdentificationAttemptUpsertResult" | "IdentificationCodeCreateResult" | "IdentificationCodeDeleteResult" | "IdentificationCodeUpdateResult" | "IdentificationCodeUpsertResult" | "IdentificationCodeLocaleCreateResult" | "IdentificationCodeLocaleDeleteResult" | "IdentificationCodeLocaleUpdateResult" | "IdentificationCodeLocaleUpsertResult" | "PipelineCreateResult" | "PipelineDeleteResult" | "PipelineUpdateResult" | "PipelineUpsertResult" | "PipelineLeadCreateResult" | "PipelineLeadDeleteResult" | "PipelineLeadUpdateResult" | "PipelineLeadUpsertResult" | "PipelineStageCreateResult" | "PipelineStageDeleteResult" | "PipelineStageUpdateResult" | "PipelineStageUpsertResult" | "PipelineStageItemCreateResult" | "PipelineStageItemDeleteResult" | "PipelineStageItemUpdateResult" | "PipelineStageItemUpsertResult" | "PipelineStageLocaleCreateResult" | "PipelineStageLocaleDeleteResult" | "PipelineStageLocaleUpdateResult" | "PipelineStageLocaleUpsertResult" | "SalesManagerCreateResult" | "SalesManagerDeleteResult" | "SalesManagerUpdateResult" | "SalesManagerUpsertResult" | "CashierManagerCreateResult" | "CashierManagerDeleteResult" | "CashierManagerUpdateResult" | "CashierManagerUpsertResult" | "PointOfSaleApplicationDeviceCreateResult" | "PointOfSaleApplicationDeviceDeleteResult" | "PointOfSaleApplicationDeviceUpdateResult" | "PointOfSaleApplicationDeviceUpsertResult" | "PointOfSaleTerminalCreateResult" | "PointOfSaleTerminalDeleteResult" | "PointOfSaleTerminalUpdateResult" | "PointOfSaleTerminalUpsertResult" | "PipelineStageSentimentCreateResult" | "PipelineStageSentimentDeleteResult" | "PipelineStageSentimentUpdateResult" | "PipelineStageSentimentUpsertResult" | "DeviceIdentifierCreateResult" | "DeviceIdentifierDeleteResult" | "DeviceIdentifierUpdateResult" | "DeviceIdentifierUpsertResult" | "PointOfSalePrinterCreateResult" | "PointOfSalePrinterDeleteResult" | "PointOfSalePrinterUpdateResult" | "PointOfSalePrinterUpsertResult" | "GratuityCreateResult" | "GratuityDeleteResult" | "GratuityUpdateResult" | "GratuityUpsertResult" | "FulfillmentNoteCreateResult" | "FulfillmentNoteDeleteResult" | "FulfillmentNoteUpdateResult" | "FulfillmentNoteUpsertResult" | "LeadFormCreateResult" | "LeadFormDeleteResult" | "LeadFormUpdateResult" | "LeadFormUpsertResult" | "SubscriptionBoxCreateResult" | "SubscriptionBoxDeleteResult" | "SubscriptionBoxUpdateResult" | "SubscriptionBoxUpsertResult" | "SubscriptionBoxLocaleCreateResult" | "SubscriptionBoxLocaleDeleteResult" | "SubscriptionBoxLocaleUpdateResult" | "SubscriptionBoxLocaleUpsertResult" | "BusinessServiceCreateResult" | "BusinessServiceDeleteResult" | "BusinessServiceUpdateResult" | "BusinessServiceUpsertResult" | "BusinessServiceEventCreateResult" | "BusinessServiceEventDeleteResult" | "BusinessServiceEventUpdateResult" | "BusinessServiceEventUpsertResult" | "BusinessServiceLocaleCreateResult" | "BusinessServiceLocaleDeleteResult" | "BusinessServiceLocaleUpdateResult" | "BusinessServiceLocaleUpsertResult" | "GridTileItemCreateResult" | "GridTileItemDeleteResult" | "GridTileItemUpdateResult" | "GridTileItemUpsertResult" | "GridTilesCreateResult" | "GridTilesDeleteResult" | "GridTilesUpdateResult" | "GridTilesUpsertResult" | "AreaCreateResult" | "AreaDeleteResult" | "AreaUpdateResult" | "AreaUpsertResult" | "PositionCreateResult" | "PositionDeleteResult" | "PositionUpdateResult" | "PositionUpsertResult" | "StatsEnabledWidgetTypeCreateResult" | "StatsEnabledWidgetTypeDeleteResult" | "StatsEnabledWidgetTypeUpdateResult" | "StatsEnabledWidgetTypeUpsertResult" | "StatsWidgetCreateResult" | "StatsWidgetDeleteResult" | "StatsWidgetUpdateResult" | "StatsWidgetUpsertResult" | "StatsWidgetsLayoutCreateResult" | "StatsWidgetsLayoutDeleteResult" | "StatsWidgetsLayoutUpdateResult" | "StatsWidgetsLayoutUpsertResult" | "SeatCreateResult" | "SeatDeleteResult" | "SeatUpdateResult" | "SeatUpsertResult" | "TableCreateResult" | "TableDeleteResult" | "TableUpdateResult" | "TableUpsertResult" | "StatsPageCreateResult" | "StatsPageDeleteResult" | "StatsPageUpdateResult" | "StatsPageUpsertResult" | "UnassignReasonCreateResult" | "UnassignReasonDeleteResult" | "UnassignReasonUpdateResult" | "UnassignReasonUpsertResult" | "DoubleshotCoffeeEquipmentCreateResult" | "DoubleshotCoffeeEquipmentDeleteResult" | "DoubleshotCoffeeEquipmentUpdateResult" | "DoubleshotCoffeeEquipmentUpsertResult" | "ExpenseCreateResult" | "ExpenseDeleteResult" | "ExpenseUpdateResult" | "ExpenseUpsertResult" | "ExpenseCategoryCreateResult" | "ExpenseCategoryDeleteResult" | "ExpenseCategoryUpdateResult" | "ExpenseCategoryUpsertResult" | "ExpenseChangeCreateResult" | "ExpenseChangeDeleteResult" | "ExpenseChangeUpdateResult" | "ExpenseChangeUpsertResult" | "ExpenseDocumentCreateResult" | "ExpenseDocumentDeleteResult" | "ExpenseDocumentUpdateResult" | "ExpenseDocumentUpsertResult" | "RevenuePredictionCreateResult" | "RevenuePredictionDeleteResult" | "RevenuePredictionUpdateResult" | "RevenuePredictionUpsertResult" | "RevenuePredictionChangeCreateResult" | "RevenuePredictionChangeDeleteResult" | "RevenuePredictionChangeUpdateResult" | "RevenuePredictionChangeUpsertResult" | "FileCreateResult" | "FileDeleteResult" | "FileUpdateResult" | "FileUpsertResult" | "LineCreateResult" | "LineDeleteResult" | "LineUpdateResult" | "LineUpsertResult" | "FinancesBalanceItemCreateResult" | "FinancesBalanceItemDeleteResult" | "FinancesBalanceItemUpdateResult" | "FinancesBalanceItemUpsertResult" | "WoltDriveDeliveryCreateResult" | "WoltDriveDeliveryDeleteResult" | "WoltDriveDeliveryUpdateResult" | "WoltDriveDeliveryUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>
	['...on AddressCreateResult']: '__union' & GraphQLTypes["AddressCreateResult"];
	['...on AddressDeleteResult']: '__union' & GraphQLTypes["AddressDeleteResult"];
	['...on AddressUpdateResult']: '__union' & GraphQLTypes["AddressUpdateResult"];
	['...on AddressUpsertResult']: '__union' & GraphQLTypes["AddressUpsertResult"];
	['...on CountryCreateResult']: '__union' & GraphQLTypes["CountryCreateResult"];
	['...on CountryDeleteResult']: '__union' & GraphQLTypes["CountryDeleteResult"];
	['...on CountryUpdateResult']: '__union' & GraphQLTypes["CountryUpdateResult"];
	['...on CountryUpsertResult']: '__union' & GraphQLTypes["CountryUpsertResult"];
	['...on ChannelCreateResult']: '__union' & GraphQLTypes["ChannelCreateResult"];
	['...on ChannelDeleteResult']: '__union' & GraphQLTypes["ChannelDeleteResult"];
	['...on ChannelUpdateResult']: '__union' & GraphQLTypes["ChannelUpdateResult"];
	['...on ChannelUpsertResult']: '__union' & GraphQLTypes["ChannelUpsertResult"];
	['...on ChannelPaymentCreateResult']: '__union' & GraphQLTypes["ChannelPaymentCreateResult"];
	['...on ChannelPaymentDeleteResult']: '__union' & GraphQLTypes["ChannelPaymentDeleteResult"];
	['...on ChannelPaymentUpdateResult']: '__union' & GraphQLTypes["ChannelPaymentUpdateResult"];
	['...on ChannelPaymentUpsertResult']: '__union' & GraphQLTypes["ChannelPaymentUpsertResult"];
	['...on ChannelDeliveryCreateResult']: '__union' & GraphQLTypes["ChannelDeliveryCreateResult"];
	['...on ChannelDeliveryDeleteResult']: '__union' & GraphQLTypes["ChannelDeliveryDeleteResult"];
	['...on ChannelDeliveryUpdateResult']: '__union' & GraphQLTypes["ChannelDeliveryUpdateResult"];
	['...on ChannelDeliveryUpsertResult']: '__union' & GraphQLTypes["ChannelDeliveryUpsertResult"];
	['...on CustomerCreateResult']: '__union' & GraphQLTypes["CustomerCreateResult"];
	['...on CustomerDeleteResult']: '__union' & GraphQLTypes["CustomerDeleteResult"];
	['...on CustomerUpdateResult']: '__union' & GraphQLTypes["CustomerUpdateResult"];
	['...on CustomerUpsertResult']: '__union' & GraphQLTypes["CustomerUpsertResult"];
	['...on CustomerCreditCreateResult']: '__union' & GraphQLTypes["CustomerCreditCreateResult"];
	['...on CustomerCreditDeleteResult']: '__union' & GraphQLTypes["CustomerCreditDeleteResult"];
	['...on CustomerCreditUpdateResult']: '__union' & GraphQLTypes["CustomerCreditUpdateResult"];
	['...on CustomerCreditUpsertResult']: '__union' & GraphQLTypes["CustomerCreditUpsertResult"];
	['...on CustomerGroupCreateResult']: '__union' & GraphQLTypes["CustomerGroupCreateResult"];
	['...on CustomerGroupDeleteResult']: '__union' & GraphQLTypes["CustomerGroupDeleteResult"];
	['...on CustomerGroupUpdateResult']: '__union' & GraphQLTypes["CustomerGroupUpdateResult"];
	['...on CustomerGroupUpsertResult']: '__union' & GraphQLTypes["CustomerGroupUpsertResult"];
	['...on CustomerPaymentMethodCreateResult']: '__union' & GraphQLTypes["CustomerPaymentMethodCreateResult"];
	['...on CustomerPaymentMethodDeleteResult']: '__union' & GraphQLTypes["CustomerPaymentMethodDeleteResult"];
	['...on CustomerPaymentMethodUpdateResult']: '__union' & GraphQLTypes["CustomerPaymentMethodUpdateResult"];
	['...on CustomerPaymentMethodUpsertResult']: '__union' & GraphQLTypes["CustomerPaymentMethodUpsertResult"];
	['...on DeliveryMethodCreateResult']: '__union' & GraphQLTypes["DeliveryMethodCreateResult"];
	['...on DeliveryMethodDeleteResult']: '__union' & GraphQLTypes["DeliveryMethodDeleteResult"];
	['...on DeliveryMethodUpdateResult']: '__union' & GraphQLTypes["DeliveryMethodUpdateResult"];
	['...on DeliveryMethodUpsertResult']: '__union' & GraphQLTypes["DeliveryMethodUpsertResult"];
	['...on OrderCreateResult']: '__union' & GraphQLTypes["OrderCreateResult"];
	['...on OrderDeleteResult']: '__union' & GraphQLTypes["OrderDeleteResult"];
	['...on OrderUpdateResult']: '__union' & GraphQLTypes["OrderUpdateResult"];
	['...on OrderUpsertResult']: '__union' & GraphQLTypes["OrderUpsertResult"];
	['...on OrderDiscountCreateResult']: '__union' & GraphQLTypes["OrderDiscountCreateResult"];
	['...on OrderDiscountDeleteResult']: '__union' & GraphQLTypes["OrderDiscountDeleteResult"];
	['...on OrderDiscountUpdateResult']: '__union' & GraphQLTypes["OrderDiscountUpdateResult"];
	['...on OrderDiscountUpsertResult']: '__union' & GraphQLTypes["OrderDiscountUpsertResult"];
	['...on OrderPaymentCreateResult']: '__union' & GraphQLTypes["OrderPaymentCreateResult"];
	['...on OrderPaymentDeleteResult']: '__union' & GraphQLTypes["OrderPaymentDeleteResult"];
	['...on OrderPaymentUpdateResult']: '__union' & GraphQLTypes["OrderPaymentUpdateResult"];
	['...on OrderPaymentUpsertResult']: '__union' & GraphQLTypes["OrderPaymentUpsertResult"];
	['...on OrderDeliveryCreateResult']: '__union' & GraphQLTypes["OrderDeliveryCreateResult"];
	['...on OrderDeliveryDeleteResult']: '__union' & GraphQLTypes["OrderDeliveryDeleteResult"];
	['...on OrderDeliveryUpdateResult']: '__union' & GraphQLTypes["OrderDeliveryUpdateResult"];
	['...on OrderDeliveryUpsertResult']: '__union' & GraphQLTypes["OrderDeliveryUpsertResult"];
	['...on OrderItemCreateResult']: '__union' & GraphQLTypes["OrderItemCreateResult"];
	['...on OrderItemDeleteResult']: '__union' & GraphQLTypes["OrderItemDeleteResult"];
	['...on OrderItemUpdateResult']: '__union' & GraphQLTypes["OrderItemUpdateResult"];
	['...on OrderItemUpsertResult']: '__union' & GraphQLTypes["OrderItemUpsertResult"];
	['...on PaymentMethodCreateResult']: '__union' & GraphQLTypes["PaymentMethodCreateResult"];
	['...on PaymentMethodDeleteResult']: '__union' & GraphQLTypes["PaymentMethodDeleteResult"];
	['...on PaymentMethodUpdateResult']: '__union' & GraphQLTypes["PaymentMethodUpdateResult"];
	['...on PaymentMethodUpsertResult']: '__union' & GraphQLTypes["PaymentMethodUpsertResult"];
	['...on VatRateCreateResult']: '__union' & GraphQLTypes["VatRateCreateResult"];
	['...on VatRateDeleteResult']: '__union' & GraphQLTypes["VatRateDeleteResult"];
	['...on VatRateUpdateResult']: '__union' & GraphQLTypes["VatRateUpdateResult"];
	['...on VatRateUpsertResult']: '__union' & GraphQLTypes["VatRateUpsertResult"];
	['...on ProductCreateResult']: '__union' & GraphQLTypes["ProductCreateResult"];
	['...on ProductDeleteResult']: '__union' & GraphQLTypes["ProductDeleteResult"];
	['...on ProductUpdateResult']: '__union' & GraphQLTypes["ProductUpdateResult"];
	['...on ProductUpsertResult']: '__union' & GraphQLTypes["ProductUpsertResult"];
	['...on ProductStockCreateResult']: '__union' & GraphQLTypes["ProductStockCreateResult"];
	['...on ProductStockDeleteResult']: '__union' & GraphQLTypes["ProductStockDeleteResult"];
	['...on ProductStockUpdateResult']: '__union' & GraphQLTypes["ProductStockUpdateResult"];
	['...on ProductStockUpsertResult']: '__union' & GraphQLTypes["ProductStockUpsertResult"];
	['...on ProductPackingCreateResult']: '__union' & GraphQLTypes["ProductPackingCreateResult"];
	['...on ProductPackingDeleteResult']: '__union' & GraphQLTypes["ProductPackingDeleteResult"];
	['...on ProductPackingUpdateResult']: '__union' & GraphQLTypes["ProductPackingUpdateResult"];
	['...on ProductPackingUpsertResult']: '__union' & GraphQLTypes["ProductPackingUpsertResult"];
	['...on ProductGroupPriceCreateResult']: '__union' & GraphQLTypes["ProductGroupPriceCreateResult"];
	['...on ProductGroupPriceDeleteResult']: '__union' & GraphQLTypes["ProductGroupPriceDeleteResult"];
	['...on ProductGroupPriceUpdateResult']: '__union' & GraphQLTypes["ProductGroupPriceUpdateResult"];
	['...on ProductGroupPriceUpsertResult']: '__union' & GraphQLTypes["ProductGroupPriceUpsertResult"];
	['...on ProductRecipeCreateResult']: '__union' & GraphQLTypes["ProductRecipeCreateResult"];
	['...on ProductRecipeDeleteResult']: '__union' & GraphQLTypes["ProductRecipeDeleteResult"];
	['...on ProductRecipeUpdateResult']: '__union' & GraphQLTypes["ProductRecipeUpdateResult"];
	['...on ProductRecipeUpsertResult']: '__union' & GraphQLTypes["ProductRecipeUpsertResult"];
	['...on ProductCategoryCreateResult']: '__union' & GraphQLTypes["ProductCategoryCreateResult"];
	['...on ProductCategoryDeleteResult']: '__union' & GraphQLTypes["ProductCategoryDeleteResult"];
	['...on ProductCategoryUpdateResult']: '__union' & GraphQLTypes["ProductCategoryUpdateResult"];
	['...on ProductCategoryUpsertResult']: '__union' & GraphQLTypes["ProductCategoryUpsertResult"];
	['...on StoreCreateResult']: '__union' & GraphQLTypes["StoreCreateResult"];
	['...on StoreDeleteResult']: '__union' & GraphQLTypes["StoreDeleteResult"];
	['...on StoreUpdateResult']: '__union' & GraphQLTypes["StoreUpdateResult"];
	['...on StoreUpsertResult']: '__union' & GraphQLTypes["StoreUpsertResult"];
	['...on TagCreateResult']: '__union' & GraphQLTypes["TagCreateResult"];
	['...on TagDeleteResult']: '__union' & GraphQLTypes["TagDeleteResult"];
	['...on TagUpdateResult']: '__union' & GraphQLTypes["TagUpdateResult"];
	['...on TagUpsertResult']: '__union' & GraphQLTypes["TagUpsertResult"];
	['...on ImageCreateResult']: '__union' & GraphQLTypes["ImageCreateResult"];
	['...on ImageDeleteResult']: '__union' & GraphQLTypes["ImageDeleteResult"];
	['...on ImageUpdateResult']: '__union' & GraphQLTypes["ImageUpdateResult"];
	['...on ImageUpsertResult']: '__union' & GraphQLTypes["ImageUpsertResult"];
	['...on BusinessCategoryCreateResult']: '__union' & GraphQLTypes["BusinessCategoryCreateResult"];
	['...on BusinessCategoryDeleteResult']: '__union' & GraphQLTypes["BusinessCategoryDeleteResult"];
	['...on BusinessCategoryUpdateResult']: '__union' & GraphQLTypes["BusinessCategoryUpdateResult"];
	['...on BusinessCategoryUpsertResult']: '__union' & GraphQLTypes["BusinessCategoryUpsertResult"];
	['...on ProductListCreateResult']: '__union' & GraphQLTypes["ProductListCreateResult"];
	['...on ProductListDeleteResult']: '__union' & GraphQLTypes["ProductListDeleteResult"];
	['...on ProductListUpdateResult']: '__union' & GraphQLTypes["ProductListUpdateResult"];
	['...on ProductListUpsertResult']: '__union' & GraphQLTypes["ProductListUpsertResult"];
	['...on ProductListItemCreateResult']: '__union' & GraphQLTypes["ProductListItemCreateResult"];
	['...on ProductListItemDeleteResult']: '__union' & GraphQLTypes["ProductListItemDeleteResult"];
	['...on ProductListItemUpdateResult']: '__union' & GraphQLTypes["ProductListItemUpdateResult"];
	['...on ProductListItemUpsertResult']: '__union' & GraphQLTypes["ProductListItemUpsertResult"];
	['...on ProductCategoryListCreateResult']: '__union' & GraphQLTypes["ProductCategoryListCreateResult"];
	['...on ProductCategoryListDeleteResult']: '__union' & GraphQLTypes["ProductCategoryListDeleteResult"];
	['...on ProductCategoryListUpdateResult']: '__union' & GraphQLTypes["ProductCategoryListUpdateResult"];
	['...on ProductCategoryListUpsertResult']: '__union' & GraphQLTypes["ProductCategoryListUpsertResult"];
	['...on ProductCategoryListItemCreateResult']: '__union' & GraphQLTypes["ProductCategoryListItemCreateResult"];
	['...on ProductCategoryListItemDeleteResult']: '__union' & GraphQLTypes["ProductCategoryListItemDeleteResult"];
	['...on ProductCategoryListItemUpdateResult']: '__union' & GraphQLTypes["ProductCategoryListItemUpdateResult"];
	['...on ProductCategoryListItemUpsertResult']: '__union' & GraphQLTypes["ProductCategoryListItemUpsertResult"];
	['...on BusinessCategoryLocaleCreateResult']: '__union' & GraphQLTypes["BusinessCategoryLocaleCreateResult"];
	['...on BusinessCategoryLocaleDeleteResult']: '__union' & GraphQLTypes["BusinessCategoryLocaleDeleteResult"];
	['...on BusinessCategoryLocaleUpdateResult']: '__union' & GraphQLTypes["BusinessCategoryLocaleUpdateResult"];
	['...on BusinessCategoryLocaleUpsertResult']: '__union' & GraphQLTypes["BusinessCategoryLocaleUpsertResult"];
	['...on LocaleCreateResult']: '__union' & GraphQLTypes["LocaleCreateResult"];
	['...on LocaleDeleteResult']: '__union' & GraphQLTypes["LocaleDeleteResult"];
	['...on LocaleUpdateResult']: '__union' & GraphQLTypes["LocaleUpdateResult"];
	['...on LocaleUpsertResult']: '__union' & GraphQLTypes["LocaleUpsertResult"];
	['...on ProductCategoryListLocaleCreateResult']: '__union' & GraphQLTypes["ProductCategoryListLocaleCreateResult"];
	['...on ProductCategoryListLocaleDeleteResult']: '__union' & GraphQLTypes["ProductCategoryListLocaleDeleteResult"];
	['...on ProductCategoryListLocaleUpdateResult']: '__union' & GraphQLTypes["ProductCategoryListLocaleUpdateResult"];
	['...on ProductCategoryListLocaleUpsertResult']: '__union' & GraphQLTypes["ProductCategoryListLocaleUpsertResult"];
	['...on CustomerNameCreateResult']: '__union' & GraphQLTypes["CustomerNameCreateResult"];
	['...on CustomerNameDeleteResult']: '__union' & GraphQLTypes["CustomerNameDeleteResult"];
	['...on CustomerNameUpdateResult']: '__union' & GraphQLTypes["CustomerNameUpdateResult"];
	['...on CustomerNameUpsertResult']: '__union' & GraphQLTypes["CustomerNameUpsertResult"];
	['...on CustomerAliasCreateResult']: '__union' & GraphQLTypes["CustomerAliasCreateResult"];
	['...on CustomerAliasDeleteResult']: '__union' & GraphQLTypes["CustomerAliasDeleteResult"];
	['...on CustomerAliasUpdateResult']: '__union' & GraphQLTypes["CustomerAliasUpdateResult"];
	['...on CustomerAliasUpsertResult']: '__union' & GraphQLTypes["CustomerAliasUpsertResult"];
	['...on ProductIngredientItemCreateResult']: '__union' & GraphQLTypes["ProductIngredientItemCreateResult"];
	['...on ProductIngredientItemDeleteResult']: '__union' & GraphQLTypes["ProductIngredientItemDeleteResult"];
	['...on ProductIngredientItemUpdateResult']: '__union' & GraphQLTypes["ProductIngredientItemUpdateResult"];
	['...on ProductIngredientItemUpsertResult']: '__union' & GraphQLTypes["ProductIngredientItemUpsertResult"];
	['...on ProductIngredientItemQuantityCreateResult']: '__union' & GraphQLTypes["ProductIngredientItemQuantityCreateResult"];
	['...on ProductIngredientItemQuantityDeleteResult']: '__union' & GraphQLTypes["ProductIngredientItemQuantityDeleteResult"];
	['...on ProductIngredientItemQuantityUpdateResult']: '__union' & GraphQLTypes["ProductIngredientItemQuantityUpdateResult"];
	['...on ProductIngredientItemQuantityUpsertResult']: '__union' & GraphQLTypes["ProductIngredientItemQuantityUpsertResult"];
	['...on ProductIngredientItemQuantityUnitCreateResult']: '__union' & GraphQLTypes["ProductIngredientItemQuantityUnitCreateResult"];
	['...on ProductIngredientItemQuantityUnitDeleteResult']: '__union' & GraphQLTypes["ProductIngredientItemQuantityUnitDeleteResult"];
	['...on ProductIngredientItemQuantityUnitUpdateResult']: '__union' & GraphQLTypes["ProductIngredientItemQuantityUnitUpdateResult"];
	['...on ProductIngredientItemQuantityUnitUpsertResult']: '__union' & GraphQLTypes["ProductIngredientItemQuantityUnitUpsertResult"];
	['...on ProductIngredientCreateResult']: '__union' & GraphQLTypes["ProductIngredientCreateResult"];
	['...on ProductIngredientDeleteResult']: '__union' & GraphQLTypes["ProductIngredientDeleteResult"];
	['...on ProductIngredientUpdateResult']: '__union' & GraphQLTypes["ProductIngredientUpdateResult"];
	['...on ProductIngredientUpsertResult']: '__union' & GraphQLTypes["ProductIngredientUpsertResult"];
	['...on CustomerIngredientRatingCreateResult']: '__union' & GraphQLTypes["CustomerIngredientRatingCreateResult"];
	['...on CustomerIngredientRatingDeleteResult']: '__union' & GraphQLTypes["CustomerIngredientRatingDeleteResult"];
	['...on CustomerIngredientRatingUpdateResult']: '__union' & GraphQLTypes["CustomerIngredientRatingUpdateResult"];
	['...on CustomerIngredientRatingUpsertResult']: '__union' & GraphQLTypes["CustomerIngredientRatingUpsertResult"];
	['...on ProductIngredientRatingCreateResult']: '__union' & GraphQLTypes["ProductIngredientRatingCreateResult"];
	['...on ProductIngredientRatingDeleteResult']: '__union' & GraphQLTypes["ProductIngredientRatingDeleteResult"];
	['...on ProductIngredientRatingUpdateResult']: '__union' & GraphQLTypes["ProductIngredientRatingUpdateResult"];
	['...on ProductIngredientRatingUpsertResult']: '__union' & GraphQLTypes["ProductIngredientRatingUpsertResult"];
	['...on ProductIngredientLocaleCreateResult']: '__union' & GraphQLTypes["ProductIngredientLocaleCreateResult"];
	['...on ProductIngredientLocaleDeleteResult']: '__union' & GraphQLTypes["ProductIngredientLocaleDeleteResult"];
	['...on ProductIngredientLocaleUpdateResult']: '__union' & GraphQLTypes["ProductIngredientLocaleUpdateResult"];
	['...on ProductIngredientLocaleUpsertResult']: '__union' & GraphQLTypes["ProductIngredientLocaleUpsertResult"];
	['...on OrderRecurrenceCreateResult']: '__union' & GraphQLTypes["OrderRecurrenceCreateResult"];
	['...on OrderRecurrenceDeleteResult']: '__union' & GraphQLTypes["OrderRecurrenceDeleteResult"];
	['...on OrderRecurrenceUpdateResult']: '__union' & GraphQLTypes["OrderRecurrenceUpdateResult"];
	['...on OrderRecurrenceUpsertResult']: '__union' & GraphQLTypes["OrderRecurrenceUpsertResult"];
	['...on OrderRecurrenceLocaleCreateResult']: '__union' & GraphQLTypes["OrderRecurrenceLocaleCreateResult"];
	['...on OrderRecurrenceLocaleDeleteResult']: '__union' & GraphQLTypes["OrderRecurrenceLocaleDeleteResult"];
	['...on OrderRecurrenceLocaleUpdateResult']: '__union' & GraphQLTypes["OrderRecurrenceLocaleUpdateResult"];
	['...on OrderRecurrenceLocaleUpsertResult']: '__union' & GraphQLTypes["OrderRecurrenceLocaleUpsertResult"];
	['...on BusinessCustomerCreateResult']: '__union' & GraphQLTypes["BusinessCustomerCreateResult"];
	['...on BusinessCustomerDeleteResult']: '__union' & GraphQLTypes["BusinessCustomerDeleteResult"];
	['...on BusinessCustomerUpdateResult']: '__union' & GraphQLTypes["BusinessCustomerUpdateResult"];
	['...on BusinessCustomerUpsertResult']: '__union' & GraphQLTypes["BusinessCustomerUpsertResult"];
	['...on PointOfSaleCreateResult']: '__union' & GraphQLTypes["PointOfSaleCreateResult"];
	['...on PointOfSaleDeleteResult']: '__union' & GraphQLTypes["PointOfSaleDeleteResult"];
	['...on PointOfSaleUpdateResult']: '__union' & GraphQLTypes["PointOfSaleUpdateResult"];
	['...on PointOfSaleUpsertResult']: '__union' & GraphQLTypes["PointOfSaleUpsertResult"];
	['...on StaffCreateResult']: '__union' & GraphQLTypes["StaffCreateResult"];
	['...on StaffDeleteResult']: '__union' & GraphQLTypes["StaffDeleteResult"];
	['...on StaffUpdateResult']: '__union' & GraphQLTypes["StaffUpdateResult"];
	['...on StaffUpsertResult']: '__union' & GraphQLTypes["StaffUpsertResult"];
	['...on BlogCreateResult']: '__union' & GraphQLTypes["BlogCreateResult"];
	['...on BlogDeleteResult']: '__union' & GraphQLTypes["BlogDeleteResult"];
	['...on BlogUpdateResult']: '__union' & GraphQLTypes["BlogUpdateResult"];
	['...on BlogUpsertResult']: '__union' & GraphQLTypes["BlogUpsertResult"];
	['...on BlogLocaleCreateResult']: '__union' & GraphQLTypes["BlogLocaleCreateResult"];
	['...on BlogLocaleDeleteResult']: '__union' & GraphQLTypes["BlogLocaleDeleteResult"];
	['...on BlogLocaleUpdateResult']: '__union' & GraphQLTypes["BlogLocaleUpdateResult"];
	['...on BlogLocaleUpsertResult']: '__union' & GraphQLTypes["BlogLocaleUpsertResult"];
	['...on BlogPostCreateResult']: '__union' & GraphQLTypes["BlogPostCreateResult"];
	['...on BlogPostDeleteResult']: '__union' & GraphQLTypes["BlogPostDeleteResult"];
	['...on BlogPostUpdateResult']: '__union' & GraphQLTypes["BlogPostUpdateResult"];
	['...on BlogPostUpsertResult']: '__union' & GraphQLTypes["BlogPostUpsertResult"];
	['...on BlogPostLocaleCreateResult']: '__union' & GraphQLTypes["BlogPostLocaleCreateResult"];
	['...on BlogPostLocaleDeleteResult']: '__union' & GraphQLTypes["BlogPostLocaleDeleteResult"];
	['...on BlogPostLocaleUpdateResult']: '__union' & GraphQLTypes["BlogPostLocaleUpdateResult"];
	['...on BlogPostLocaleUpsertResult']: '__union' & GraphQLTypes["BlogPostLocaleUpsertResult"];
	['...on ColorPalleteCreateResult']: '__union' & GraphQLTypes["ColorPalleteCreateResult"];
	['...on ColorPalleteDeleteResult']: '__union' & GraphQLTypes["ColorPalleteDeleteResult"];
	['...on ColorPalleteUpdateResult']: '__union' & GraphQLTypes["ColorPalleteUpdateResult"];
	['...on ColorPalleteUpsertResult']: '__union' & GraphQLTypes["ColorPalleteUpsertResult"];
	['...on ContentCreateResult']: '__union' & GraphQLTypes["ContentCreateResult"];
	['...on ContentDeleteResult']: '__union' & GraphQLTypes["ContentDeleteResult"];
	['...on ContentUpdateResult']: '__union' & GraphQLTypes["ContentUpdateResult"];
	['...on ContentUpsertResult']: '__union' & GraphQLTypes["ContentUpsertResult"];
	['...on ContentBlockCreateResult']: '__union' & GraphQLTypes["ContentBlockCreateResult"];
	['...on ContentBlockDeleteResult']: '__union' & GraphQLTypes["ContentBlockDeleteResult"];
	['...on ContentBlockUpdateResult']: '__union' & GraphQLTypes["ContentBlockUpdateResult"];
	['...on ContentBlockUpsertResult']: '__union' & GraphQLTypes["ContentBlockUpsertResult"];
	['...on ContentReferenceCreateResult']: '__union' & GraphQLTypes["ContentReferenceCreateResult"];
	['...on ContentReferenceDeleteResult']: '__union' & GraphQLTypes["ContentReferenceDeleteResult"];
	['...on ContentReferenceUpdateResult']: '__union' & GraphQLTypes["ContentReferenceUpdateResult"];
	['...on ContentReferenceUpsertResult']: '__union' & GraphQLTypes["ContentReferenceUpsertResult"];
	['...on BlogPostListCreateResult']: '__union' & GraphQLTypes["BlogPostListCreateResult"];
	['...on BlogPostListDeleteResult']: '__union' & GraphQLTypes["BlogPostListDeleteResult"];
	['...on BlogPostListUpdateResult']: '__union' & GraphQLTypes["BlogPostListUpdateResult"];
	['...on BlogPostListUpsertResult']: '__union' & GraphQLTypes["BlogPostListUpsertResult"];
	['...on BlogPostListItemCreateResult']: '__union' & GraphQLTypes["BlogPostListItemCreateResult"];
	['...on BlogPostListItemDeleteResult']: '__union' & GraphQLTypes["BlogPostListItemDeleteResult"];
	['...on BlogPostListItemUpdateResult']: '__union' & GraphQLTypes["BlogPostListItemUpdateResult"];
	['...on BlogPostListItemUpsertResult']: '__union' & GraphQLTypes["BlogPostListItemUpsertResult"];
	['...on LinkListCreateResult']: '__union' & GraphQLTypes["LinkListCreateResult"];
	['...on LinkListDeleteResult']: '__union' & GraphQLTypes["LinkListDeleteResult"];
	['...on LinkListUpdateResult']: '__union' & GraphQLTypes["LinkListUpdateResult"];
	['...on LinkListUpsertResult']: '__union' & GraphQLTypes["LinkListUpsertResult"];
	['...on LinkListItemCreateResult']: '__union' & GraphQLTypes["LinkListItemCreateResult"];
	['...on LinkListItemDeleteResult']: '__union' & GraphQLTypes["LinkListItemDeleteResult"];
	['...on LinkListItemUpdateResult']: '__union' & GraphQLTypes["LinkListItemUpdateResult"];
	['...on LinkListItemUpsertResult']: '__union' & GraphQLTypes["LinkListItemUpsertResult"];
	['...on CoverCreateResult']: '__union' & GraphQLTypes["CoverCreateResult"];
	['...on CoverDeleteResult']: '__union' & GraphQLTypes["CoverDeleteResult"];
	['...on CoverUpdateResult']: '__union' & GraphQLTypes["CoverUpdateResult"];
	['...on CoverUpsertResult']: '__union' & GraphQLTypes["CoverUpsertResult"];
	['...on LinkCreateResult']: '__union' & GraphQLTypes["LinkCreateResult"];
	['...on LinkDeleteResult']: '__union' & GraphQLTypes["LinkDeleteResult"];
	['...on LinkUpdateResult']: '__union' & GraphQLTypes["LinkUpdateResult"];
	['...on LinkUpsertResult']: '__union' & GraphQLTypes["LinkUpsertResult"];
	['...on LinkableCreateResult']: '__union' & GraphQLTypes["LinkableCreateResult"];
	['...on LinkableDeleteResult']: '__union' & GraphQLTypes["LinkableDeleteResult"];
	['...on LinkableUpdateResult']: '__union' & GraphQLTypes["LinkableUpdateResult"];
	['...on LinkableUpsertResult']: '__union' & GraphQLTypes["LinkableUpsertResult"];
	['...on MediumCreateResult']: '__union' & GraphQLTypes["MediumCreateResult"];
	['...on MediumDeleteResult']: '__union' & GraphQLTypes["MediumDeleteResult"];
	['...on MediumUpdateResult']: '__union' & GraphQLTypes["MediumUpdateResult"];
	['...on MediumUpsertResult']: '__union' & GraphQLTypes["MediumUpsertResult"];
	['...on VideoCreateResult']: '__union' & GraphQLTypes["VideoCreateResult"];
	['...on VideoDeleteResult']: '__union' & GraphQLTypes["VideoDeleteResult"];
	['...on VideoUpdateResult']: '__union' & GraphQLTypes["VideoUpdateResult"];
	['...on VideoUpsertResult']: '__union' & GraphQLTypes["VideoUpsertResult"];
	['...on SeoCreateResult']: '__union' & GraphQLTypes["SeoCreateResult"];
	['...on SeoDeleteResult']: '__union' & GraphQLTypes["SeoDeleteResult"];
	['...on SeoUpdateResult']: '__union' & GraphQLTypes["SeoUpdateResult"];
	['...on SeoUpsertResult']: '__union' & GraphQLTypes["SeoUpsertResult"];
	['...on ProtectedImageCreateResult']: '__union' & GraphQLTypes["ProtectedImageCreateResult"];
	['...on ProtectedImageDeleteResult']: '__union' & GraphQLTypes["ProtectedImageDeleteResult"];
	['...on ProtectedImageUpdateResult']: '__union' & GraphQLTypes["ProtectedImageUpdateResult"];
	['...on ProtectedImageUpsertResult']: '__union' & GraphQLTypes["ProtectedImageUpsertResult"];
	['...on TranslationDomainCreateResult']: '__union' & GraphQLTypes["TranslationDomainCreateResult"];
	['...on TranslationDomainDeleteResult']: '__union' & GraphQLTypes["TranslationDomainDeleteResult"];
	['...on TranslationDomainUpdateResult']: '__union' & GraphQLTypes["TranslationDomainUpdateResult"];
	['...on TranslationDomainUpsertResult']: '__union' & GraphQLTypes["TranslationDomainUpsertResult"];
	['...on TranslationCatalogueCreateResult']: '__union' & GraphQLTypes["TranslationCatalogueCreateResult"];
	['...on TranslationCatalogueDeleteResult']: '__union' & GraphQLTypes["TranslationCatalogueDeleteResult"];
	['...on TranslationCatalogueUpdateResult']: '__union' & GraphQLTypes["TranslationCatalogueUpdateResult"];
	['...on TranslationCatalogueUpsertResult']: '__union' & GraphQLTypes["TranslationCatalogueUpsertResult"];
	['...on TranslationKeyCreateResult']: '__union' & GraphQLTypes["TranslationKeyCreateResult"];
	['...on TranslationKeyDeleteResult']: '__union' & GraphQLTypes["TranslationKeyDeleteResult"];
	['...on TranslationKeyUpdateResult']: '__union' & GraphQLTypes["TranslationKeyUpdateResult"];
	['...on TranslationKeyUpsertResult']: '__union' & GraphQLTypes["TranslationKeyUpsertResult"];
	['...on TranslationValueCreateResult']: '__union' & GraphQLTypes["TranslationValueCreateResult"];
	['...on TranslationValueDeleteResult']: '__union' & GraphQLTypes["TranslationValueDeleteResult"];
	['...on TranslationValueUpdateResult']: '__union' & GraphQLTypes["TranslationValueUpdateResult"];
	['...on TranslationValueUpsertResult']: '__union' & GraphQLTypes["TranslationValueUpsertResult"];
	['...on TranslationCataloguesIdentifierCreateResult']: '__union' & GraphQLTypes["TranslationCataloguesIdentifierCreateResult"];
	['...on TranslationCataloguesIdentifierDeleteResult']: '__union' & GraphQLTypes["TranslationCataloguesIdentifierDeleteResult"];
	['...on TranslationCataloguesIdentifierUpdateResult']: '__union' & GraphQLTypes["TranslationCataloguesIdentifierUpdateResult"];
	['...on TranslationCataloguesIdentifierUpsertResult']: '__union' & GraphQLTypes["TranslationCataloguesIdentifierUpsertResult"];
	['...on SocialsAndAppsCreateResult']: '__union' & GraphQLTypes["SocialsAndAppsCreateResult"];
	['...on SocialsAndAppsDeleteResult']: '__union' & GraphQLTypes["SocialsAndAppsDeleteResult"];
	['...on SocialsAndAppsUpdateResult']: '__union' & GraphQLTypes["SocialsAndAppsUpdateResult"];
	['...on SocialsAndAppsUpsertResult']: '__union' & GraphQLTypes["SocialsAndAppsUpsertResult"];
	['...on ProductGridCreateResult']: '__union' & GraphQLTypes["ProductGridCreateResult"];
	['...on ProductGridDeleteResult']: '__union' & GraphQLTypes["ProductGridDeleteResult"];
	['...on ProductGridUpdateResult']: '__union' & GraphQLTypes["ProductGridUpdateResult"];
	['...on ProductGridUpsertResult']: '__union' & GraphQLTypes["ProductGridUpsertResult"];
	['...on ProductGridItemCreateResult']: '__union' & GraphQLTypes["ProductGridItemCreateResult"];
	['...on ProductGridItemDeleteResult']: '__union' & GraphQLTypes["ProductGridItemDeleteResult"];
	['...on ProductGridItemUpdateResult']: '__union' & GraphQLTypes["ProductGridItemUpdateResult"];
	['...on ProductGridItemUpsertResult']: '__union' & GraphQLTypes["ProductGridItemUpsertResult"];
	['...on GalleryCreateResult']: '__union' & GraphQLTypes["GalleryCreateResult"];
	['...on GalleryDeleteResult']: '__union' & GraphQLTypes["GalleryDeleteResult"];
	['...on GalleryUpdateResult']: '__union' & GraphQLTypes["GalleryUpdateResult"];
	['...on GalleryUpsertResult']: '__union' & GraphQLTypes["GalleryUpsertResult"];
	['...on GalleryItemCreateResult']: '__union' & GraphQLTypes["GalleryItemCreateResult"];
	['...on GalleryItemDeleteResult']: '__union' & GraphQLTypes["GalleryItemDeleteResult"];
	['...on GalleryItemUpdateResult']: '__union' & GraphQLTypes["GalleryItemUpdateResult"];
	['...on GalleryItemUpsertResult']: '__union' & GraphQLTypes["GalleryItemUpsertResult"];
	['...on HeroCreateResult']: '__union' & GraphQLTypes["HeroCreateResult"];
	['...on HeroDeleteResult']: '__union' & GraphQLTypes["HeroDeleteResult"];
	['...on HeroUpdateResult']: '__union' & GraphQLTypes["HeroUpdateResult"];
	['...on HeroUpsertResult']: '__union' & GraphQLTypes["HeroUpsertResult"];
	['...on SiteMenuCreateResult']: '__union' & GraphQLTypes["SiteMenuCreateResult"];
	['...on SiteMenuDeleteResult']: '__union' & GraphQLTypes["SiteMenuDeleteResult"];
	['...on SiteMenuUpdateResult']: '__union' & GraphQLTypes["SiteMenuUpdateResult"];
	['...on SiteMenuUpsertResult']: '__union' & GraphQLTypes["SiteMenuUpsertResult"];
	['...on MenuLocaleCreateResult']: '__union' & GraphQLTypes["MenuLocaleCreateResult"];
	['...on MenuLocaleDeleteResult']: '__union' & GraphQLTypes["MenuLocaleDeleteResult"];
	['...on MenuLocaleUpdateResult']: '__union' & GraphQLTypes["MenuLocaleUpdateResult"];
	['...on MenuLocaleUpsertResult']: '__union' & GraphQLTypes["MenuLocaleUpsertResult"];
	['...on MenuItemCreateResult']: '__union' & GraphQLTypes["MenuItemCreateResult"];
	['...on MenuItemDeleteResult']: '__union' & GraphQLTypes["MenuItemDeleteResult"];
	['...on MenuItemUpdateResult']: '__union' & GraphQLTypes["MenuItemUpdateResult"];
	['...on MenuItemUpsertResult']: '__union' & GraphQLTypes["MenuItemUpsertResult"];
	['...on PageCreateResult']: '__union' & GraphQLTypes["PageCreateResult"];
	['...on PageDeleteResult']: '__union' & GraphQLTypes["PageDeleteResult"];
	['...on PageUpdateResult']: '__union' & GraphQLTypes["PageUpdateResult"];
	['...on PageUpsertResult']: '__union' & GraphQLTypes["PageUpsertResult"];
	['...on PageLocaleCreateResult']: '__union' & GraphQLTypes["PageLocaleCreateResult"];
	['...on PageLocaleDeleteResult']: '__union' & GraphQLTypes["PageLocaleDeleteResult"];
	['...on PageLocaleUpdateResult']: '__union' & GraphQLTypes["PageLocaleUpdateResult"];
	['...on PageLocaleUpsertResult']: '__union' & GraphQLTypes["PageLocaleUpsertResult"];
	['...on WikiPageCreateResult']: '__union' & GraphQLTypes["WikiPageCreateResult"];
	['...on WikiPageDeleteResult']: '__union' & GraphQLTypes["WikiPageDeleteResult"];
	['...on WikiPageUpdateResult']: '__union' & GraphQLTypes["WikiPageUpdateResult"];
	['...on WikiPageUpsertResult']: '__union' & GraphQLTypes["WikiPageUpsertResult"];
	['...on MenuSubitemCreateResult']: '__union' & GraphQLTypes["MenuSubitemCreateResult"];
	['...on MenuSubitemDeleteResult']: '__union' & GraphQLTypes["MenuSubitemDeleteResult"];
	['...on MenuSubitemUpdateResult']: '__union' & GraphQLTypes["MenuSubitemUpdateResult"];
	['...on MenuSubitemUpsertResult']: '__union' & GraphQLTypes["MenuSubitemUpsertResult"];
	['...on MenuLinkListCreateResult']: '__union' & GraphQLTypes["MenuLinkListCreateResult"];
	['...on MenuLinkListDeleteResult']: '__union' & GraphQLTypes["MenuLinkListDeleteResult"];
	['...on MenuLinkListUpdateResult']: '__union' & GraphQLTypes["MenuLinkListUpdateResult"];
	['...on MenuLinkListUpsertResult']: '__union' & GraphQLTypes["MenuLinkListUpsertResult"];
	['...on MenuLinkItemCreateResult']: '__union' & GraphQLTypes["MenuLinkItemCreateResult"];
	['...on MenuLinkItemDeleteResult']: '__union' & GraphQLTypes["MenuLinkItemDeleteResult"];
	['...on MenuLinkItemUpdateResult']: '__union' & GraphQLTypes["MenuLinkItemUpdateResult"];
	['...on MenuLinkItemUpsertResult']: '__union' & GraphQLTypes["MenuLinkItemUpsertResult"];
	['...on MenuProductsCreateResult']: '__union' & GraphQLTypes["MenuProductsCreateResult"];
	['...on MenuProductsDeleteResult']: '__union' & GraphQLTypes["MenuProductsDeleteResult"];
	['...on MenuProductsUpdateResult']: '__union' & GraphQLTypes["MenuProductsUpdateResult"];
	['...on MenuProductsUpsertResult']: '__union' & GraphQLTypes["MenuProductsUpsertResult"];
	['...on MenuDeliveryCreateResult']: '__union' & GraphQLTypes["MenuDeliveryCreateResult"];
	['...on MenuDeliveryDeleteResult']: '__union' & GraphQLTypes["MenuDeliveryDeleteResult"];
	['...on MenuDeliveryUpdateResult']: '__union' & GraphQLTypes["MenuDeliveryUpdateResult"];
	['...on MenuDeliveryUpsertResult']: '__union' & GraphQLTypes["MenuDeliveryUpsertResult"];
	['...on MenuContactCreateResult']: '__union' & GraphQLTypes["MenuContactCreateResult"];
	['...on MenuContactDeleteResult']: '__union' & GraphQLTypes["MenuContactDeleteResult"];
	['...on MenuContactUpdateResult']: '__union' & GraphQLTypes["MenuContactUpdateResult"];
	['...on MenuContactUpsertResult']: '__union' & GraphQLTypes["MenuContactUpsertResult"];
	['...on DeadlineTemplateCreateResult']: '__union' & GraphQLTypes["DeadlineTemplateCreateResult"];
	['...on DeadlineTemplateDeleteResult']: '__union' & GraphQLTypes["DeadlineTemplateDeleteResult"];
	['...on DeadlineTemplateUpdateResult']: '__union' & GraphQLTypes["DeadlineTemplateUpdateResult"];
	['...on DeadlineTemplateUpsertResult']: '__union' & GraphQLTypes["DeadlineTemplateUpsertResult"];
	['...on EmployeeQueueCreateResult']: '__union' & GraphQLTypes["EmployeeQueueCreateResult"];
	['...on EmployeeQueueDeleteResult']: '__union' & GraphQLTypes["EmployeeQueueDeleteResult"];
	['...on EmployeeQueueUpdateResult']: '__union' & GraphQLTypes["EmployeeQueueUpdateResult"];
	['...on EmployeeQueueUpsertResult']: '__union' & GraphQLTypes["EmployeeQueueUpsertResult"];
	['...on TimetableDayCreateResult']: '__union' & GraphQLTypes["TimetableDayCreateResult"];
	['...on TimetableDayDeleteResult']: '__union' & GraphQLTypes["TimetableDayDeleteResult"];
	['...on TimetableDayUpdateResult']: '__union' & GraphQLTypes["TimetableDayUpdateResult"];
	['...on TimetableDayUpsertResult']: '__union' & GraphQLTypes["TimetableDayUpsertResult"];
	['...on TimetableEmployeeRoleCreateResult']: '__union' & GraphQLTypes["TimetableEmployeeRoleCreateResult"];
	['...on TimetableEmployeeRoleDeleteResult']: '__union' & GraphQLTypes["TimetableEmployeeRoleDeleteResult"];
	['...on TimetableEmployeeRoleUpdateResult']: '__union' & GraphQLTypes["TimetableEmployeeRoleUpdateResult"];
	['...on TimetableEmployeeRoleUpsertResult']: '__union' & GraphQLTypes["TimetableEmployeeRoleUpsertResult"];
	['...on TimetableShiftCreateResult']: '__union' & GraphQLTypes["TimetableShiftCreateResult"];
	['...on TimetableShiftDeleteResult']: '__union' & GraphQLTypes["TimetableShiftDeleteResult"];
	['...on TimetableShiftUpdateResult']: '__union' & GraphQLTypes["TimetableShiftUpdateResult"];
	['...on TimetableShiftUpsertResult']: '__union' & GraphQLTypes["TimetableShiftUpsertResult"];
	['...on TimetableShiftGroupCreateResult']: '__union' & GraphQLTypes["TimetableShiftGroupCreateResult"];
	['...on TimetableShiftGroupDeleteResult']: '__union' & GraphQLTypes["TimetableShiftGroupDeleteResult"];
	['...on TimetableShiftGroupUpdateResult']: '__union' & GraphQLTypes["TimetableShiftGroupUpdateResult"];
	['...on TimetableShiftGroupUpsertResult']: '__union' & GraphQLTypes["TimetableShiftGroupUpsertResult"];
	['...on TimetableShiftPositionCreateResult']: '__union' & GraphQLTypes["TimetableShiftPositionCreateResult"];
	['...on TimetableShiftPositionDeleteResult']: '__union' & GraphQLTypes["TimetableShiftPositionDeleteResult"];
	['...on TimetableShiftPositionUpdateResult']: '__union' & GraphQLTypes["TimetableShiftPositionUpdateResult"];
	['...on TimetableShiftPositionUpsertResult']: '__union' & GraphQLTypes["TimetableShiftPositionUpsertResult"];
	['...on TimetableTemplateCreateResult']: '__union' & GraphQLTypes["TimetableTemplateCreateResult"];
	['...on TimetableTemplateDeleteResult']: '__union' & GraphQLTypes["TimetableTemplateDeleteResult"];
	['...on TimetableTemplateUpdateResult']: '__union' & GraphQLTypes["TimetableTemplateUpdateResult"];
	['...on TimetableTemplateUpsertResult']: '__union' & GraphQLTypes["TimetableTemplateUpsertResult"];
	['...on CartCreateResult']: '__union' & GraphQLTypes["CartCreateResult"];
	['...on CartDeleteResult']: '__union' & GraphQLTypes["CartDeleteResult"];
	['...on CartUpdateResult']: '__union' & GraphQLTypes["CartUpdateResult"];
	['...on CartUpsertResult']: '__union' & GraphQLTypes["CartUpsertResult"];
	['...on CartItemCreateResult']: '__union' & GraphQLTypes["CartItemCreateResult"];
	['...on CartItemDeleteResult']: '__union' & GraphQLTypes["CartItemDeleteResult"];
	['...on CartItemUpdateResult']: '__union' & GraphQLTypes["CartItemUpdateResult"];
	['...on CartItemUpsertResult']: '__union' & GraphQLTypes["CartItemUpsertResult"];
	['...on EmployeeQueueItemCreateResult']: '__union' & GraphQLTypes["EmployeeQueueItemCreateResult"];
	['...on EmployeeQueueItemDeleteResult']: '__union' & GraphQLTypes["EmployeeQueueItemDeleteResult"];
	['...on EmployeeQueueItemUpdateResult']: '__union' & GraphQLTypes["EmployeeQueueItemUpdateResult"];
	['...on EmployeeQueueItemUpsertResult']: '__union' & GraphQLTypes["EmployeeQueueItemUpsertResult"];
	['...on ApplicationCreateResult']: '__union' & GraphQLTypes["ApplicationCreateResult"];
	['...on ApplicationDeleteResult']: '__union' & GraphQLTypes["ApplicationDeleteResult"];
	['...on ApplicationUpdateResult']: '__union' & GraphQLTypes["ApplicationUpdateResult"];
	['...on ApplicationUpsertResult']: '__union' & GraphQLTypes["ApplicationUpsertResult"];
	['...on ApplicationShortcutListCreateResult']: '__union' & GraphQLTypes["ApplicationShortcutListCreateResult"];
	['...on ApplicationShortcutListDeleteResult']: '__union' & GraphQLTypes["ApplicationShortcutListDeleteResult"];
	['...on ApplicationShortcutListUpdateResult']: '__union' & GraphQLTypes["ApplicationShortcutListUpdateResult"];
	['...on ApplicationShortcutListUpsertResult']: '__union' & GraphQLTypes["ApplicationShortcutListUpsertResult"];
	['...on ApplicationShortcutListItemCreateResult']: '__union' & GraphQLTypes["ApplicationShortcutListItemCreateResult"];
	['...on ApplicationShortcutListItemDeleteResult']: '__union' & GraphQLTypes["ApplicationShortcutListItemDeleteResult"];
	['...on ApplicationShortcutListItemUpdateResult']: '__union' & GraphQLTypes["ApplicationShortcutListItemUpdateResult"];
	['...on ApplicationShortcutListItemUpsertResult']: '__union' & GraphQLTypes["ApplicationShortcutListItemUpsertResult"];
	['...on ProductBannerCreateResult']: '__union' & GraphQLTypes["ProductBannerCreateResult"];
	['...on ProductBannerDeleteResult']: '__union' & GraphQLTypes["ProductBannerDeleteResult"];
	['...on ProductBannerUpdateResult']: '__union' & GraphQLTypes["ProductBannerUpdateResult"];
	['...on ProductBannerUpsertResult']: '__union' & GraphQLTypes["ProductBannerUpsertResult"];
	['...on ProductBannerItemCreateResult']: '__union' & GraphQLTypes["ProductBannerItemCreateResult"];
	['...on ProductBannerItemDeleteResult']: '__union' & GraphQLTypes["ProductBannerItemDeleteResult"];
	['...on ProductBannerItemUpdateResult']: '__union' & GraphQLTypes["ProductBannerItemUpdateResult"];
	['...on ProductBannerItemUpsertResult']: '__union' & GraphQLTypes["ProductBannerItemUpsertResult"];
	['...on ProductBannerListCreateResult']: '__union' & GraphQLTypes["ProductBannerListCreateResult"];
	['...on ProductBannerListDeleteResult']: '__union' & GraphQLTypes["ProductBannerListDeleteResult"];
	['...on ProductBannerListUpdateResult']: '__union' & GraphQLTypes["ProductBannerListUpdateResult"];
	['...on ProductBannerListUpsertResult']: '__union' & GraphQLTypes["ProductBannerListUpsertResult"];
	['...on BartenderCreateResult']: '__union' & GraphQLTypes["BartenderCreateResult"];
	['...on BartenderDeleteResult']: '__union' & GraphQLTypes["BartenderDeleteResult"];
	['...on BartenderUpdateResult']: '__union' & GraphQLTypes["BartenderUpdateResult"];
	['...on BartenderUpsertResult']: '__union' & GraphQLTypes["BartenderUpsertResult"];
	['...on BusinessToBusinessManagerCreateResult']: '__union' & GraphQLTypes["BusinessToBusinessManagerCreateResult"];
	['...on BusinessToBusinessManagerDeleteResult']: '__union' & GraphQLTypes["BusinessToBusinessManagerDeleteResult"];
	['...on BusinessToBusinessManagerUpdateResult']: '__union' & GraphQLTypes["BusinessToBusinessManagerUpdateResult"];
	['...on BusinessToBusinessManagerUpsertResult']: '__union' & GraphQLTypes["BusinessToBusinessManagerUpsertResult"];
	['...on CleanerCreateResult']: '__union' & GraphQLTypes["CleanerCreateResult"];
	['...on CleanerDeleteResult']: '__union' & GraphQLTypes["CleanerDeleteResult"];
	['...on CleanerUpdateResult']: '__union' & GraphQLTypes["CleanerUpdateResult"];
	['...on CleanerUpsertResult']: '__union' & GraphQLTypes["CleanerUpsertResult"];
	['...on CourierCreateResult']: '__union' & GraphQLTypes["CourierCreateResult"];
	['...on CourierDeleteResult']: '__union' & GraphQLTypes["CourierDeleteResult"];
	['...on CourierUpdateResult']: '__union' & GraphQLTypes["CourierUpdateResult"];
	['...on CourierUpsertResult']: '__union' & GraphQLTypes["CourierUpsertResult"];
	['...on ShiftsManagerCreateResult']: '__union' & GraphQLTypes["ShiftsManagerCreateResult"];
	['...on ShiftsManagerDeleteResult']: '__union' & GraphQLTypes["ShiftsManagerDeleteResult"];
	['...on ShiftsManagerUpdateResult']: '__union' & GraphQLTypes["ShiftsManagerUpdateResult"];
	['...on ShiftsManagerUpsertResult']: '__union' & GraphQLTypes["ShiftsManagerUpsertResult"];
	['...on UserCreateResult']: '__union' & GraphQLTypes["UserCreateResult"];
	['...on UserDeleteResult']: '__union' & GraphQLTypes["UserDeleteResult"];
	['...on UserUpdateResult']: '__union' & GraphQLTypes["UserUpdateResult"];
	['...on UserUpsertResult']: '__union' & GraphQLTypes["UserUpsertResult"];
	['...on ShiftsProfileCreateResult']: '__union' & GraphQLTypes["ShiftsProfileCreateResult"];
	['...on ShiftsProfileDeleteResult']: '__union' & GraphQLTypes["ShiftsProfileDeleteResult"];
	['...on ShiftsProfileUpdateResult']: '__union' & GraphQLTypes["ShiftsProfileUpdateResult"];
	['...on ShiftsProfileUpsertResult']: '__union' & GraphQLTypes["ShiftsProfileUpsertResult"];
	['...on ProductIngredientCategoryCreateResult']: '__union' & GraphQLTypes["ProductIngredientCategoryCreateResult"];
	['...on ProductIngredientCategoryDeleteResult']: '__union' & GraphQLTypes["ProductIngredientCategoryDeleteResult"];
	['...on ProductIngredientCategoryUpdateResult']: '__union' & GraphQLTypes["ProductIngredientCategoryUpdateResult"];
	['...on ProductIngredientCategoryUpsertResult']: '__union' & GraphQLTypes["ProductIngredientCategoryUpsertResult"];
	['...on ProductIngredientCategoryLocaleCreateResult']: '__union' & GraphQLTypes["ProductIngredientCategoryLocaleCreateResult"];
	['...on ProductIngredientCategoryLocaleDeleteResult']: '__union' & GraphQLTypes["ProductIngredientCategoryLocaleDeleteResult"];
	['...on ProductIngredientCategoryLocaleUpdateResult']: '__union' & GraphQLTypes["ProductIngredientCategoryLocaleUpdateResult"];
	['...on ProductIngredientCategoryLocaleUpsertResult']: '__union' & GraphQLTypes["ProductIngredientCategoryLocaleUpsertResult"];
	['...on StocksManagerCreateResult']: '__union' & GraphQLTypes["StocksManagerCreateResult"];
	['...on StocksManagerDeleteResult']: '__union' & GraphQLTypes["StocksManagerDeleteResult"];
	['...on StocksManagerUpdateResult']: '__union' & GraphQLTypes["StocksManagerUpdateResult"];
	['...on StocksManagerUpsertResult']: '__union' & GraphQLTypes["StocksManagerUpsertResult"];
	['...on DeliveryRouteCreateResult']: '__union' & GraphQLTypes["DeliveryRouteCreateResult"];
	['...on DeliveryRouteDeleteResult']: '__union' & GraphQLTypes["DeliveryRouteDeleteResult"];
	['...on DeliveryRouteUpdateResult']: '__union' & GraphQLTypes["DeliveryRouteUpdateResult"];
	['...on DeliveryRouteUpsertResult']: '__union' & GraphQLTypes["DeliveryRouteUpsertResult"];
	['...on DeliveryWaypointCreateResult']: '__union' & GraphQLTypes["DeliveryWaypointCreateResult"];
	['...on DeliveryWaypointDeleteResult']: '__union' & GraphQLTypes["DeliveryWaypointDeleteResult"];
	['...on DeliveryWaypointUpdateResult']: '__union' & GraphQLTypes["DeliveryWaypointUpdateResult"];
	['...on DeliveryWaypointUpsertResult']: '__union' & GraphQLTypes["DeliveryWaypointUpsertResult"];
	['...on AllergenCreateResult']: '__union' & GraphQLTypes["AllergenCreateResult"];
	['...on AllergenDeleteResult']: '__union' & GraphQLTypes["AllergenDeleteResult"];
	['...on AllergenUpdateResult']: '__union' & GraphQLTypes["AllergenUpdateResult"];
	['...on AllergenUpsertResult']: '__union' & GraphQLTypes["AllergenUpsertResult"];
	['...on AllergenLocaleCreateResult']: '__union' & GraphQLTypes["AllergenLocaleCreateResult"];
	['...on AllergenLocaleDeleteResult']: '__union' & GraphQLTypes["AllergenLocaleDeleteResult"];
	['...on AllergenLocaleUpdateResult']: '__union' & GraphQLTypes["AllergenLocaleUpdateResult"];
	['...on AllergenLocaleUpsertResult']: '__union' & GraphQLTypes["AllergenLocaleUpsertResult"];
	['...on GpsCreateResult']: '__union' & GraphQLTypes["GpsCreateResult"];
	['...on GpsDeleteResult']: '__union' & GraphQLTypes["GpsDeleteResult"];
	['...on GpsUpdateResult']: '__union' & GraphQLTypes["GpsUpdateResult"];
	['...on GpsUpsertResult']: '__union' & GraphQLTypes["GpsUpsertResult"];
	['...on WeekHoursCreateResult']: '__union' & GraphQLTypes["WeekHoursCreateResult"];
	['...on WeekHoursDeleteResult']: '__union' & GraphQLTypes["WeekHoursDeleteResult"];
	['...on WeekHoursUpdateResult']: '__union' & GraphQLTypes["WeekHoursUpdateResult"];
	['...on WeekHoursUpsertResult']: '__union' & GraphQLTypes["WeekHoursUpsertResult"];
	['...on PreparedIngredientQuantityCreateResult']: '__union' & GraphQLTypes["PreparedIngredientQuantityCreateResult"];
	['...on PreparedIngredientQuantityDeleteResult']: '__union' & GraphQLTypes["PreparedIngredientQuantityDeleteResult"];
	['...on PreparedIngredientQuantityUpdateResult']: '__union' & GraphQLTypes["PreparedIngredientQuantityUpdateResult"];
	['...on PreparedIngredientQuantityUpsertResult']: '__union' & GraphQLTypes["PreparedIngredientQuantityUpsertResult"];
	['...on PreparedRecipeQuantityCreateResult']: '__union' & GraphQLTypes["PreparedRecipeQuantityCreateResult"];
	['...on PreparedRecipeQuantityDeleteResult']: '__union' & GraphQLTypes["PreparedRecipeQuantityDeleteResult"];
	['...on PreparedRecipeQuantityUpdateResult']: '__union' & GraphQLTypes["PreparedRecipeQuantityUpdateResult"];
	['...on PreparedRecipeQuantityUpsertResult']: '__union' & GraphQLTypes["PreparedRecipeQuantityUpsertResult"];
	['...on InternalOrderCreateResult']: '__union' & GraphQLTypes["InternalOrderCreateResult"];
	['...on InternalOrderDeleteResult']: '__union' & GraphQLTypes["InternalOrderDeleteResult"];
	['...on InternalOrderUpdateResult']: '__union' & GraphQLTypes["InternalOrderUpdateResult"];
	['...on InternalOrderUpsertResult']: '__union' & GraphQLTypes["InternalOrderUpsertResult"];
	['...on InternalOrderItemCreateResult']: '__union' & GraphQLTypes["InternalOrderItemCreateResult"];
	['...on InternalOrderItemDeleteResult']: '__union' & GraphQLTypes["InternalOrderItemDeleteResult"];
	['...on InternalOrderItemUpdateResult']: '__union' & GraphQLTypes["InternalOrderItemUpdateResult"];
	['...on InternalOrderItemUpsertResult']: '__union' & GraphQLTypes["InternalOrderItemUpsertResult"];
	['...on PreparedPackingQuantityCreateResult']: '__union' & GraphQLTypes["PreparedPackingQuantityCreateResult"];
	['...on PreparedPackingQuantityDeleteResult']: '__union' & GraphQLTypes["PreparedPackingQuantityDeleteResult"];
	['...on PreparedPackingQuantityUpdateResult']: '__union' & GraphQLTypes["PreparedPackingQuantityUpdateResult"];
	['...on PreparedPackingQuantityUpsertResult']: '__union' & GraphQLTypes["PreparedPackingQuantityUpsertResult"];
	['...on CourierManagerCreateResult']: '__union' & GraphQLTypes["CourierManagerCreateResult"];
	['...on CourierManagerDeleteResult']: '__union' & GraphQLTypes["CourierManagerDeleteResult"];
	['...on CourierManagerUpdateResult']: '__union' & GraphQLTypes["CourierManagerUpdateResult"];
	['...on CourierManagerUpsertResult']: '__union' & GraphQLTypes["CourierManagerUpsertResult"];
	['...on DeliveryZoneCreateResult']: '__union' & GraphQLTypes["DeliveryZoneCreateResult"];
	['...on DeliveryZoneDeleteResult']: '__union' & GraphQLTypes["DeliveryZoneDeleteResult"];
	['...on DeliveryZoneUpdateResult']: '__union' & GraphQLTypes["DeliveryZoneUpdateResult"];
	['...on DeliveryZoneUpsertResult']: '__union' & GraphQLTypes["DeliveryZoneUpsertResult"];
	['...on DeliveryTimelinePresetCreateResult']: '__union' & GraphQLTypes["DeliveryTimelinePresetCreateResult"];
	['...on DeliveryTimelinePresetDeleteResult']: '__union' & GraphQLTypes["DeliveryTimelinePresetDeleteResult"];
	['...on DeliveryTimelinePresetUpdateResult']: '__union' & GraphQLTypes["DeliveryTimelinePresetUpdateResult"];
	['...on DeliveryTimelinePresetUpsertResult']: '__union' & GraphQLTypes["DeliveryTimelinePresetUpsertResult"];
	['...on OrderDeliveryTimelineCreateResult']: '__union' & GraphQLTypes["OrderDeliveryTimelineCreateResult"];
	['...on OrderDeliveryTimelineDeleteResult']: '__union' & GraphQLTypes["OrderDeliveryTimelineDeleteResult"];
	['...on OrderDeliveryTimelineUpdateResult']: '__union' & GraphQLTypes["OrderDeliveryTimelineUpdateResult"];
	['...on OrderDeliveryTimelineUpsertResult']: '__union' & GraphQLTypes["OrderDeliveryTimelineUpsertResult"];
	['...on OrderEventCreateResult']: '__union' & GraphQLTypes["OrderEventCreateResult"];
	['...on OrderEventDeleteResult']: '__union' & GraphQLTypes["OrderEventDeleteResult"];
	['...on OrderEventUpdateResult']: '__union' & GraphQLTypes["OrderEventUpdateResult"];
	['...on OrderEventUpsertResult']: '__union' & GraphQLTypes["OrderEventUpsertResult"];
	['...on LiftagoRideCreateResult']: '__union' & GraphQLTypes["LiftagoRideCreateResult"];
	['...on LiftagoRideDeleteResult']: '__union' & GraphQLTypes["LiftagoRideDeleteResult"];
	['...on LiftagoRideUpdateResult']: '__union' & GraphQLTypes["LiftagoRideUpdateResult"];
	['...on LiftagoRideUpsertResult']: '__union' & GraphQLTypes["LiftagoRideUpsertResult"];
	['...on InvoiceCreateResult']: '__union' & GraphQLTypes["InvoiceCreateResult"];
	['...on InvoiceDeleteResult']: '__union' & GraphQLTypes["InvoiceDeleteResult"];
	['...on InvoiceUpdateResult']: '__union' & GraphQLTypes["InvoiceUpdateResult"];
	['...on InvoiceUpsertResult']: '__union' & GraphQLTypes["InvoiceUpsertResult"];
	['...on InvoicingPlanCreateResult']: '__union' & GraphQLTypes["InvoicingPlanCreateResult"];
	['...on InvoicingPlanDeleteResult']: '__union' & GraphQLTypes["InvoicingPlanDeleteResult"];
	['...on InvoicingPlanUpdateResult']: '__union' & GraphQLTypes["InvoicingPlanUpdateResult"];
	['...on InvoicingPlanUpsertResult']: '__union' & GraphQLTypes["InvoicingPlanUpsertResult"];
	['...on ProductPackingLocaleCreateResult']: '__union' & GraphQLTypes["ProductPackingLocaleCreateResult"];
	['...on ProductPackingLocaleDeleteResult']: '__union' & GraphQLTypes["ProductPackingLocaleDeleteResult"];
	['...on ProductPackingLocaleUpdateResult']: '__union' & GraphQLTypes["ProductPackingLocaleUpdateResult"];
	['...on ProductPackingLocaleUpsertResult']: '__union' & GraphQLTypes["ProductPackingLocaleUpsertResult"];
	['...on ProductLocaleCreateResult']: '__union' & GraphQLTypes["ProductLocaleCreateResult"];
	['...on ProductLocaleDeleteResult']: '__union' & GraphQLTypes["ProductLocaleDeleteResult"];
	['...on ProductLocaleUpdateResult']: '__union' & GraphQLTypes["ProductLocaleUpdateResult"];
	['...on ProductLocaleUpsertResult']: '__union' & GraphQLTypes["ProductLocaleUpsertResult"];
	['...on ProductRecipeLocaleCreateResult']: '__union' & GraphQLTypes["ProductRecipeLocaleCreateResult"];
	['...on ProductRecipeLocaleDeleteResult']: '__union' & GraphQLTypes["ProductRecipeLocaleDeleteResult"];
	['...on ProductRecipeLocaleUpdateResult']: '__union' & GraphQLTypes["ProductRecipeLocaleUpdateResult"];
	['...on ProductRecipeLocaleUpsertResult']: '__union' & GraphQLTypes["ProductRecipeLocaleUpsertResult"];
	['...on UserDeviceCreateResult']: '__union' & GraphQLTypes["UserDeviceCreateResult"];
	['...on UserDeviceDeleteResult']: '__union' & GraphQLTypes["UserDeviceDeleteResult"];
	['...on UserDeviceUpdateResult']: '__union' & GraphQLTypes["UserDeviceUpdateResult"];
	['...on UserDeviceUpsertResult']: '__union' & GraphQLTypes["UserDeviceUpsertResult"];
	['...on ProtectedActionCreateResult']: '__union' & GraphQLTypes["ProtectedActionCreateResult"];
	['...on ProtectedActionDeleteResult']: '__union' & GraphQLTypes["ProtectedActionDeleteResult"];
	['...on ProtectedActionUpdateResult']: '__union' & GraphQLTypes["ProtectedActionUpdateResult"];
	['...on ProtectedActionUpsertResult']: '__union' & GraphQLTypes["ProtectedActionUpsertResult"];
	['...on PickerCreateResult']: '__union' & GraphQLTypes["PickerCreateResult"];
	['...on PickerDeleteResult']: '__union' & GraphQLTypes["PickerDeleteResult"];
	['...on PickerUpdateResult']: '__union' & GraphQLTypes["PickerUpdateResult"];
	['...on PickerUpsertResult']: '__union' & GraphQLTypes["PickerUpsertResult"];
	['...on TimetableTemplateStaffOptionsCreateResult']: '__union' & GraphQLTypes["TimetableTemplateStaffOptionsCreateResult"];
	['...on TimetableTemplateStaffOptionsDeleteResult']: '__union' & GraphQLTypes["TimetableTemplateStaffOptionsDeleteResult"];
	['...on TimetableTemplateStaffOptionsUpdateResult']: '__union' & GraphQLTypes["TimetableTemplateStaffOptionsUpdateResult"];
	['...on TimetableTemplateStaffOptionsUpsertResult']: '__union' & GraphQLTypes["TimetableTemplateStaffOptionsUpsertResult"];
	['...on ShoppingListCreateResult']: '__union' & GraphQLTypes["ShoppingListCreateResult"];
	['...on ShoppingListDeleteResult']: '__union' & GraphQLTypes["ShoppingListDeleteResult"];
	['...on ShoppingListUpdateResult']: '__union' & GraphQLTypes["ShoppingListUpdateResult"];
	['...on ShoppingListUpsertResult']: '__union' & GraphQLTypes["ShoppingListUpsertResult"];
	['...on SuppliesPurchaseCreateResult']: '__union' & GraphQLTypes["SuppliesPurchaseCreateResult"];
	['...on SuppliesPurchaseDeleteResult']: '__union' & GraphQLTypes["SuppliesPurchaseDeleteResult"];
	['...on SuppliesPurchaseUpdateResult']: '__union' & GraphQLTypes["SuppliesPurchaseUpdateResult"];
	['...on SuppliesPurchaseUpsertResult']: '__union' & GraphQLTypes["SuppliesPurchaseUpsertResult"];
	['...on InvoicingPresetCreateResult']: '__union' & GraphQLTypes["InvoicingPresetCreateResult"];
	['...on InvoicingPresetDeleteResult']: '__union' & GraphQLTypes["InvoicingPresetDeleteResult"];
	['...on InvoicingPresetUpdateResult']: '__union' & GraphQLTypes["InvoicingPresetUpdateResult"];
	['...on InvoicingPresetUpsertResult']: '__union' & GraphQLTypes["InvoicingPresetUpsertResult"];
	['...on LogRecordCreateResult']: '__union' & GraphQLTypes["LogRecordCreateResult"];
	['...on LogRecordDeleteResult']: '__union' & GraphQLTypes["LogRecordDeleteResult"];
	['...on LogRecordUpdateResult']: '__union' & GraphQLTypes["LogRecordUpdateResult"];
	['...on LogRecordUpsertResult']: '__union' & GraphQLTypes["LogRecordUpsertResult"];
	['...on BillingSubjectCreateResult']: '__union' & GraphQLTypes["BillingSubjectCreateResult"];
	['...on BillingSubjectDeleteResult']: '__union' & GraphQLTypes["BillingSubjectDeleteResult"];
	['...on BillingSubjectUpdateResult']: '__union' & GraphQLTypes["BillingSubjectUpdateResult"];
	['...on BillingSubjectUpsertResult']: '__union' & GraphQLTypes["BillingSubjectUpsertResult"];
	['...on ShoppingListItemCreateResult']: '__union' & GraphQLTypes["ShoppingListItemCreateResult"];
	['...on ShoppingListItemDeleteResult']: '__union' & GraphQLTypes["ShoppingListItemDeleteResult"];
	['...on ShoppingListItemUpdateResult']: '__union' & GraphQLTypes["ShoppingListItemUpdateResult"];
	['...on ShoppingListItemUpsertResult']: '__union' & GraphQLTypes["ShoppingListItemUpsertResult"];
	['...on SuppliesPurchaseItemCreateResult']: '__union' & GraphQLTypes["SuppliesPurchaseItemCreateResult"];
	['...on SuppliesPurchaseItemDeleteResult']: '__union' & GraphQLTypes["SuppliesPurchaseItemDeleteResult"];
	['...on SuppliesPurchaseItemUpdateResult']: '__union' & GraphQLTypes["SuppliesPurchaseItemUpdateResult"];
	['...on SuppliesPurchaseItemUpsertResult']: '__union' & GraphQLTypes["SuppliesPurchaseItemUpsertResult"];
	['...on CustomerCreditTransactionCreateResult']: '__union' & GraphQLTypes["CustomerCreditTransactionCreateResult"];
	['...on CustomerCreditTransactionDeleteResult']: '__union' & GraphQLTypes["CustomerCreditTransactionDeleteResult"];
	['...on CustomerCreditTransactionUpdateResult']: '__union' & GraphQLTypes["CustomerCreditTransactionUpdateResult"];
	['...on CustomerCreditTransactionUpsertResult']: '__union' & GraphQLTypes["CustomerCreditTransactionUpsertResult"];
	['...on VirtualProductCreateResult']: '__union' & GraphQLTypes["VirtualProductCreateResult"];
	['...on VirtualProductDeleteResult']: '__union' & GraphQLTypes["VirtualProductDeleteResult"];
	['...on VirtualProductUpdateResult']: '__union' & GraphQLTypes["VirtualProductUpdateResult"];
	['...on VirtualProductUpsertResult']: '__union' & GraphQLTypes["VirtualProductUpsertResult"];
	['...on VirtualProductEffectCreateResult']: '__union' & GraphQLTypes["VirtualProductEffectCreateResult"];
	['...on VirtualProductEffectDeleteResult']: '__union' & GraphQLTypes["VirtualProductEffectDeleteResult"];
	['...on VirtualProductEffectUpdateResult']: '__union' & GraphQLTypes["VirtualProductEffectUpdateResult"];
	['...on VirtualProductEffectUpsertResult']: '__union' & GraphQLTypes["VirtualProductEffectUpsertResult"];
	['...on EmploymentInformationCreateResult']: '__union' & GraphQLTypes["EmploymentInformationCreateResult"];
	['...on EmploymentInformationDeleteResult']: '__union' & GraphQLTypes["EmploymentInformationDeleteResult"];
	['...on EmploymentInformationUpdateResult']: '__union' & GraphQLTypes["EmploymentInformationUpdateResult"];
	['...on EmploymentInformationUpsertResult']: '__union' & GraphQLTypes["EmploymentInformationUpsertResult"];
	['...on RemunerationProfileCreateResult']: '__union' & GraphQLTypes["RemunerationProfileCreateResult"];
	['...on RemunerationProfileDeleteResult']: '__union' & GraphQLTypes["RemunerationProfileDeleteResult"];
	['...on RemunerationProfileUpdateResult']: '__union' & GraphQLTypes["RemunerationProfileUpdateResult"];
	['...on RemunerationProfileUpsertResult']: '__union' & GraphQLTypes["RemunerationProfileUpsertResult"];
	['...on WorkMonthCreateResult']: '__union' & GraphQLTypes["WorkMonthCreateResult"];
	['...on WorkMonthDeleteResult']: '__union' & GraphQLTypes["WorkMonthDeleteResult"];
	['...on WorkMonthUpdateResult']: '__union' & GraphQLTypes["WorkMonthUpdateResult"];
	['...on WorkMonthUpsertResult']: '__union' & GraphQLTypes["WorkMonthUpsertResult"];
	['...on SalaryOptionsCreateResult']: '__union' & GraphQLTypes["SalaryOptionsCreateResult"];
	['...on SalaryOptionsDeleteResult']: '__union' & GraphQLTypes["SalaryOptionsDeleteResult"];
	['...on SalaryOptionsUpdateResult']: '__union' & GraphQLTypes["SalaryOptionsUpdateResult"];
	['...on SalaryOptionsUpsertResult']: '__union' & GraphQLTypes["SalaryOptionsUpsertResult"];
	['...on TimetableShiftSwapInfoCreateResult']: '__union' & GraphQLTypes["TimetableShiftSwapInfoCreateResult"];
	['...on TimetableShiftSwapInfoDeleteResult']: '__union' & GraphQLTypes["TimetableShiftSwapInfoDeleteResult"];
	['...on TimetableShiftSwapInfoUpdateResult']: '__union' & GraphQLTypes["TimetableShiftSwapInfoUpdateResult"];
	['...on TimetableShiftSwapInfoUpsertResult']: '__union' & GraphQLTypes["TimetableShiftSwapInfoUpsertResult"];
	['...on ProductGridCategoryCreateResult']: '__union' & GraphQLTypes["ProductGridCategoryCreateResult"];
	['...on ProductGridCategoryDeleteResult']: '__union' & GraphQLTypes["ProductGridCategoryDeleteResult"];
	['...on ProductGridCategoryUpdateResult']: '__union' & GraphQLTypes["ProductGridCategoryUpdateResult"];
	['...on ProductGridCategoryUpsertResult']: '__union' & GraphQLTypes["ProductGridCategoryUpsertResult"];
	['...on CashierCreateResult']: '__union' & GraphQLTypes["CashierCreateResult"];
	['...on CashierDeleteResult']: '__union' & GraphQLTypes["CashierDeleteResult"];
	['...on CashierUpdateResult']: '__union' & GraphQLTypes["CashierUpdateResult"];
	['...on CashierUpsertResult']: '__union' & GraphQLTypes["CashierUpsertResult"];
	['...on PointOfSaleCategoryCreateResult']: '__union' & GraphQLTypes["PointOfSaleCategoryCreateResult"];
	['...on PointOfSaleCategoryDeleteResult']: '__union' & GraphQLTypes["PointOfSaleCategoryDeleteResult"];
	['...on PointOfSaleCategoryUpdateResult']: '__union' & GraphQLTypes["PointOfSaleCategoryUpdateResult"];
	['...on PointOfSaleCategoryUpsertResult']: '__union' & GraphQLTypes["PointOfSaleCategoryUpsertResult"];
	['...on PointOfSaleCategoryLocaleCreateResult']: '__union' & GraphQLTypes["PointOfSaleCategoryLocaleCreateResult"];
	['...on PointOfSaleCategoryLocaleDeleteResult']: '__union' & GraphQLTypes["PointOfSaleCategoryLocaleDeleteResult"];
	['...on PointOfSaleCategoryLocaleUpdateResult']: '__union' & GraphQLTypes["PointOfSaleCategoryLocaleUpdateResult"];
	['...on PointOfSaleCategoryLocaleUpsertResult']: '__union' & GraphQLTypes["PointOfSaleCategoryLocaleUpsertResult"];
	['...on PointOfSaleCategoryProductCreateResult']: '__union' & GraphQLTypes["PointOfSaleCategoryProductCreateResult"];
	['...on PointOfSaleCategoryProductDeleteResult']: '__union' & GraphQLTypes["PointOfSaleCategoryProductDeleteResult"];
	['...on PointOfSaleCategoryProductUpdateResult']: '__union' & GraphQLTypes["PointOfSaleCategoryProductUpdateResult"];
	['...on PointOfSaleCategoryProductUpsertResult']: '__union' & GraphQLTypes["PointOfSaleCategoryProductUpsertResult"];
	['...on PointOfSaleCategoryProductLocaleCreateResult']: '__union' & GraphQLTypes["PointOfSaleCategoryProductLocaleCreateResult"];
	['...on PointOfSaleCategoryProductLocaleDeleteResult']: '__union' & GraphQLTypes["PointOfSaleCategoryProductLocaleDeleteResult"];
	['...on PointOfSaleCategoryProductLocaleUpdateResult']: '__union' & GraphQLTypes["PointOfSaleCategoryProductLocaleUpdateResult"];
	['...on PointOfSaleCategoryProductLocaleUpsertResult']: '__union' & GraphQLTypes["PointOfSaleCategoryProductLocaleUpsertResult"];
	['...on CustomerTabCreateResult']: '__union' & GraphQLTypes["CustomerTabCreateResult"];
	['...on CustomerTabDeleteResult']: '__union' & GraphQLTypes["CustomerTabDeleteResult"];
	['...on CustomerTabUpdateResult']: '__union' & GraphQLTypes["CustomerTabUpdateResult"];
	['...on CustomerTabUpsertResult']: '__union' & GraphQLTypes["CustomerTabUpsertResult"];
	['...on CustomerTabItemCreateResult']: '__union' & GraphQLTypes["CustomerTabItemCreateResult"];
	['...on CustomerTabItemDeleteResult']: '__union' & GraphQLTypes["CustomerTabItemDeleteResult"];
	['...on CustomerTabItemUpdateResult']: '__union' & GraphQLTypes["CustomerTabItemUpdateResult"];
	['...on CustomerTabItemUpsertResult']: '__union' & GraphQLTypes["CustomerTabItemUpsertResult"];
	['...on AnonymousSessionCreateResult']: '__union' & GraphQLTypes["AnonymousSessionCreateResult"];
	['...on AnonymousSessionDeleteResult']: '__union' & GraphQLTypes["AnonymousSessionDeleteResult"];
	['...on AnonymousSessionUpdateResult']: '__union' & GraphQLTypes["AnonymousSessionUpdateResult"];
	['...on AnonymousSessionUpsertResult']: '__union' & GraphQLTypes["AnonymousSessionUpsertResult"];
	['...on VoucherCreateResult']: '__union' & GraphQLTypes["VoucherCreateResult"];
	['...on VoucherDeleteResult']: '__union' & GraphQLTypes["VoucherDeleteResult"];
	['...on VoucherUpdateResult']: '__union' & GraphQLTypes["VoucherUpdateResult"];
	['...on VoucherUpsertResult']: '__union' & GraphQLTypes["VoucherUpsertResult"];
	['...on VoucherRedemptionCreateResult']: '__union' & GraphQLTypes["VoucherRedemptionCreateResult"];
	['...on VoucherRedemptionDeleteResult']: '__union' & GraphQLTypes["VoucherRedemptionDeleteResult"];
	['...on VoucherRedemptionUpdateResult']: '__union' & GraphQLTypes["VoucherRedemptionUpdateResult"];
	['...on VoucherRedemptionUpsertResult']: '__union' & GraphQLTypes["VoucherRedemptionUpsertResult"];
	['...on UnassignedShiftInfoCreateResult']: '__union' & GraphQLTypes["UnassignedShiftInfoCreateResult"];
	['...on UnassignedShiftInfoDeleteResult']: '__union' & GraphQLTypes["UnassignedShiftInfoDeleteResult"];
	['...on UnassignedShiftInfoUpdateResult']: '__union' & GraphQLTypes["UnassignedShiftInfoUpdateResult"];
	['...on UnassignedShiftInfoUpsertResult']: '__union' & GraphQLTypes["UnassignedShiftInfoUpsertResult"];
	['...on FreshingContainerCreateResult']: '__union' & GraphQLTypes["FreshingContainerCreateResult"];
	['...on FreshingContainerDeleteResult']: '__union' & GraphQLTypes["FreshingContainerDeleteResult"];
	['...on FreshingContainerUpdateResult']: '__union' & GraphQLTypes["FreshingContainerUpdateResult"];
	['...on FreshingContainerUpsertResult']: '__union' & GraphQLTypes["FreshingContainerUpsertResult"];
	['...on TextItemCreateResult']: '__union' & GraphQLTypes["TextItemCreateResult"];
	['...on TextItemDeleteResult']: '__union' & GraphQLTypes["TextItemDeleteResult"];
	['...on TextItemUpdateResult']: '__union' & GraphQLTypes["TextItemUpdateResult"];
	['...on TextItemUpsertResult']: '__union' & GraphQLTypes["TextItemUpsertResult"];
	['...on TextListCreateResult']: '__union' & GraphQLTypes["TextListCreateResult"];
	['...on TextListDeleteResult']: '__union' & GraphQLTypes["TextListDeleteResult"];
	['...on TextListUpdateResult']: '__union' & GraphQLTypes["TextListUpdateResult"];
	['...on TextListUpsertResult']: '__union' & GraphQLTypes["TextListUpsertResult"];
	['...on DeliveryRegionsCreateResult']: '__union' & GraphQLTypes["DeliveryRegionsCreateResult"];
	['...on DeliveryRegionsDeleteResult']: '__union' & GraphQLTypes["DeliveryRegionsDeleteResult"];
	['...on DeliveryRegionsUpdateResult']: '__union' & GraphQLTypes["DeliveryRegionsUpdateResult"];
	['...on DeliveryRegionsUpsertResult']: '__union' & GraphQLTypes["DeliveryRegionsUpsertResult"];
	['...on DeliveryRegionsItemCreateResult']: '__union' & GraphQLTypes["DeliveryRegionsItemCreateResult"];
	['...on DeliveryRegionsItemDeleteResult']: '__union' & GraphQLTypes["DeliveryRegionsItemDeleteResult"];
	['...on DeliveryRegionsItemUpdateResult']: '__union' & GraphQLTypes["DeliveryRegionsItemUpdateResult"];
	['...on DeliveryRegionsItemUpsertResult']: '__union' & GraphQLTypes["DeliveryRegionsItemUpsertResult"];
	['...on ImageListCreateResult']: '__union' & GraphQLTypes["ImageListCreateResult"];
	['...on ImageListDeleteResult']: '__union' & GraphQLTypes["ImageListDeleteResult"];
	['...on ImageListUpdateResult']: '__union' & GraphQLTypes["ImageListUpdateResult"];
	['...on ImageListUpsertResult']: '__union' & GraphQLTypes["ImageListUpsertResult"];
	['...on ImageListItemCreateResult']: '__union' & GraphQLTypes["ImageListItemCreateResult"];
	['...on ImageListItemDeleteResult']: '__union' & GraphQLTypes["ImageListItemDeleteResult"];
	['...on ImageListItemUpdateResult']: '__union' & GraphQLTypes["ImageListItemUpdateResult"];
	['...on ImageListItemUpsertResult']: '__union' & GraphQLTypes["ImageListItemUpsertResult"];
	['...on TimetablesEmployeePrivilegesCreateResult']: '__union' & GraphQLTypes["TimetablesEmployeePrivilegesCreateResult"];
	['...on TimetablesEmployeePrivilegesDeleteResult']: '__union' & GraphQLTypes["TimetablesEmployeePrivilegesDeleteResult"];
	['...on TimetablesEmployeePrivilegesUpdateResult']: '__union' & GraphQLTypes["TimetablesEmployeePrivilegesUpdateResult"];
	['...on TimetablesEmployeePrivilegesUpsertResult']: '__union' & GraphQLTypes["TimetablesEmployeePrivilegesUpsertResult"];
	['...on TimetableDayNoteCreateResult']: '__union' & GraphQLTypes["TimetableDayNoteCreateResult"];
	['...on TimetableDayNoteDeleteResult']: '__union' & GraphQLTypes["TimetableDayNoteDeleteResult"];
	['...on TimetableDayNoteUpdateResult']: '__union' & GraphQLTypes["TimetableDayNoteUpdateResult"];
	['...on TimetableDayNoteUpsertResult']: '__union' & GraphQLTypes["TimetableDayNoteUpsertResult"];
	['...on DeliveryMethodLocaleCreateResult']: '__union' & GraphQLTypes["DeliveryMethodLocaleCreateResult"];
	['...on DeliveryMethodLocaleDeleteResult']: '__union' & GraphQLTypes["DeliveryMethodLocaleDeleteResult"];
	['...on DeliveryMethodLocaleUpdateResult']: '__union' & GraphQLTypes["DeliveryMethodLocaleUpdateResult"];
	['...on DeliveryMethodLocaleUpsertResult']: '__union' & GraphQLTypes["DeliveryMethodLocaleUpsertResult"];
	['...on IngredientSupplierCreateResult']: '__union' & GraphQLTypes["IngredientSupplierCreateResult"];
	['...on IngredientSupplierDeleteResult']: '__union' & GraphQLTypes["IngredientSupplierDeleteResult"];
	['...on IngredientSupplierUpdateResult']: '__union' & GraphQLTypes["IngredientSupplierUpdateResult"];
	['...on IngredientSupplierUpsertResult']: '__union' & GraphQLTypes["IngredientSupplierUpsertResult"];
	['...on IngredientSupplierItemCreateResult']: '__union' & GraphQLTypes["IngredientSupplierItemCreateResult"];
	['...on IngredientSupplierItemDeleteResult']: '__union' & GraphQLTypes["IngredientSupplierItemDeleteResult"];
	['...on IngredientSupplierItemUpdateResult']: '__union' & GraphQLTypes["IngredientSupplierItemUpdateResult"];
	['...on IngredientSupplierItemUpsertResult']: '__union' & GraphQLTypes["IngredientSupplierItemUpsertResult"];
	['...on IngredientSupplierListCreateResult']: '__union' & GraphQLTypes["IngredientSupplierListCreateResult"];
	['...on IngredientSupplierListDeleteResult']: '__union' & GraphQLTypes["IngredientSupplierListDeleteResult"];
	['...on IngredientSupplierListUpdateResult']: '__union' & GraphQLTypes["IngredientSupplierListUpdateResult"];
	['...on IngredientSupplierListUpsertResult']: '__union' & GraphQLTypes["IngredientSupplierListUpsertResult"];
	['...on IngredientSupplierLocaleCreateResult']: '__union' & GraphQLTypes["IngredientSupplierLocaleCreateResult"];
	['...on IngredientSupplierLocaleDeleteResult']: '__union' & GraphQLTypes["IngredientSupplierLocaleDeleteResult"];
	['...on IngredientSupplierLocaleUpdateResult']: '__union' & GraphQLTypes["IngredientSupplierLocaleUpdateResult"];
	['...on IngredientSupplierLocaleUpsertResult']: '__union' & GraphQLTypes["IngredientSupplierLocaleUpsertResult"];
	['...on RedirectCreateResult']: '__union' & GraphQLTypes["RedirectCreateResult"];
	['...on RedirectDeleteResult']: '__union' & GraphQLTypes["RedirectDeleteResult"];
	['...on RedirectUpdateResult']: '__union' & GraphQLTypes["RedirectUpdateResult"];
	['...on RedirectUpsertResult']: '__union' & GraphQLTypes["RedirectUpsertResult"];
	['...on NutritionFactsCreateResult']: '__union' & GraphQLTypes["NutritionFactsCreateResult"];
	['...on NutritionFactsDeleteResult']: '__union' & GraphQLTypes["NutritionFactsDeleteResult"];
	['...on NutritionFactsUpdateResult']: '__union' & GraphQLTypes["NutritionFactsUpdateResult"];
	['...on NutritionFactsUpsertResult']: '__union' & GraphQLTypes["NutritionFactsUpsertResult"];
	['...on VenueCreateResult']: '__union' & GraphQLTypes["VenueCreateResult"];
	['...on VenueDeleteResult']: '__union' & GraphQLTypes["VenueDeleteResult"];
	['...on VenueUpdateResult']: '__union' & GraphQLTypes["VenueUpdateResult"];
	['...on VenueUpsertResult']: '__union' & GraphQLTypes["VenueUpsertResult"];
	['...on WorkspaceCreateResult']: '__union' & GraphQLTypes["WorkspaceCreateResult"];
	['...on WorkspaceDeleteResult']: '__union' & GraphQLTypes["WorkspaceDeleteResult"];
	['...on WorkspaceUpdateResult']: '__union' & GraphQLTypes["WorkspaceUpdateResult"];
	['...on WorkspaceUpsertResult']: '__union' & GraphQLTypes["WorkspaceUpsertResult"];
	['...on InternalBuyerCreateResult']: '__union' & GraphQLTypes["InternalBuyerCreateResult"];
	['...on InternalBuyerDeleteResult']: '__union' & GraphQLTypes["InternalBuyerDeleteResult"];
	['...on InternalBuyerUpdateResult']: '__union' & GraphQLTypes["InternalBuyerUpdateResult"];
	['...on InternalBuyerUpsertResult']: '__union' & GraphQLTypes["InternalBuyerUpsertResult"];
	['...on VenueEmployeeRoleCreateResult']: '__union' & GraphQLTypes["VenueEmployeeRoleCreateResult"];
	['...on VenueEmployeeRoleDeleteResult']: '__union' & GraphQLTypes["VenueEmployeeRoleDeleteResult"];
	['...on VenueEmployeeRoleUpdateResult']: '__union' & GraphQLTypes["VenueEmployeeRoleUpdateResult"];
	['...on VenueEmployeeRoleUpsertResult']: '__union' & GraphQLTypes["VenueEmployeeRoleUpsertResult"];
	['...on IdentificationAttemptCreateResult']: '__union' & GraphQLTypes["IdentificationAttemptCreateResult"];
	['...on IdentificationAttemptDeleteResult']: '__union' & GraphQLTypes["IdentificationAttemptDeleteResult"];
	['...on IdentificationAttemptUpdateResult']: '__union' & GraphQLTypes["IdentificationAttemptUpdateResult"];
	['...on IdentificationAttemptUpsertResult']: '__union' & GraphQLTypes["IdentificationAttemptUpsertResult"];
	['...on IdentificationCodeCreateResult']: '__union' & GraphQLTypes["IdentificationCodeCreateResult"];
	['...on IdentificationCodeDeleteResult']: '__union' & GraphQLTypes["IdentificationCodeDeleteResult"];
	['...on IdentificationCodeUpdateResult']: '__union' & GraphQLTypes["IdentificationCodeUpdateResult"];
	['...on IdentificationCodeUpsertResult']: '__union' & GraphQLTypes["IdentificationCodeUpsertResult"];
	['...on IdentificationCodeLocaleCreateResult']: '__union' & GraphQLTypes["IdentificationCodeLocaleCreateResult"];
	['...on IdentificationCodeLocaleDeleteResult']: '__union' & GraphQLTypes["IdentificationCodeLocaleDeleteResult"];
	['...on IdentificationCodeLocaleUpdateResult']: '__union' & GraphQLTypes["IdentificationCodeLocaleUpdateResult"];
	['...on IdentificationCodeLocaleUpsertResult']: '__union' & GraphQLTypes["IdentificationCodeLocaleUpsertResult"];
	['...on PipelineCreateResult']: '__union' & GraphQLTypes["PipelineCreateResult"];
	['...on PipelineDeleteResult']: '__union' & GraphQLTypes["PipelineDeleteResult"];
	['...on PipelineUpdateResult']: '__union' & GraphQLTypes["PipelineUpdateResult"];
	['...on PipelineUpsertResult']: '__union' & GraphQLTypes["PipelineUpsertResult"];
	['...on PipelineLeadCreateResult']: '__union' & GraphQLTypes["PipelineLeadCreateResult"];
	['...on PipelineLeadDeleteResult']: '__union' & GraphQLTypes["PipelineLeadDeleteResult"];
	['...on PipelineLeadUpdateResult']: '__union' & GraphQLTypes["PipelineLeadUpdateResult"];
	['...on PipelineLeadUpsertResult']: '__union' & GraphQLTypes["PipelineLeadUpsertResult"];
	['...on PipelineStageCreateResult']: '__union' & GraphQLTypes["PipelineStageCreateResult"];
	['...on PipelineStageDeleteResult']: '__union' & GraphQLTypes["PipelineStageDeleteResult"];
	['...on PipelineStageUpdateResult']: '__union' & GraphQLTypes["PipelineStageUpdateResult"];
	['...on PipelineStageUpsertResult']: '__union' & GraphQLTypes["PipelineStageUpsertResult"];
	['...on PipelineStageItemCreateResult']: '__union' & GraphQLTypes["PipelineStageItemCreateResult"];
	['...on PipelineStageItemDeleteResult']: '__union' & GraphQLTypes["PipelineStageItemDeleteResult"];
	['...on PipelineStageItemUpdateResult']: '__union' & GraphQLTypes["PipelineStageItemUpdateResult"];
	['...on PipelineStageItemUpsertResult']: '__union' & GraphQLTypes["PipelineStageItemUpsertResult"];
	['...on PipelineStageLocaleCreateResult']: '__union' & GraphQLTypes["PipelineStageLocaleCreateResult"];
	['...on PipelineStageLocaleDeleteResult']: '__union' & GraphQLTypes["PipelineStageLocaleDeleteResult"];
	['...on PipelineStageLocaleUpdateResult']: '__union' & GraphQLTypes["PipelineStageLocaleUpdateResult"];
	['...on PipelineStageLocaleUpsertResult']: '__union' & GraphQLTypes["PipelineStageLocaleUpsertResult"];
	['...on SalesManagerCreateResult']: '__union' & GraphQLTypes["SalesManagerCreateResult"];
	['...on SalesManagerDeleteResult']: '__union' & GraphQLTypes["SalesManagerDeleteResult"];
	['...on SalesManagerUpdateResult']: '__union' & GraphQLTypes["SalesManagerUpdateResult"];
	['...on SalesManagerUpsertResult']: '__union' & GraphQLTypes["SalesManagerUpsertResult"];
	['...on CashierManagerCreateResult']: '__union' & GraphQLTypes["CashierManagerCreateResult"];
	['...on CashierManagerDeleteResult']: '__union' & GraphQLTypes["CashierManagerDeleteResult"];
	['...on CashierManagerUpdateResult']: '__union' & GraphQLTypes["CashierManagerUpdateResult"];
	['...on CashierManagerUpsertResult']: '__union' & GraphQLTypes["CashierManagerUpsertResult"];
	['...on PointOfSaleApplicationDeviceCreateResult']: '__union' & GraphQLTypes["PointOfSaleApplicationDeviceCreateResult"];
	['...on PointOfSaleApplicationDeviceDeleteResult']: '__union' & GraphQLTypes["PointOfSaleApplicationDeviceDeleteResult"];
	['...on PointOfSaleApplicationDeviceUpdateResult']: '__union' & GraphQLTypes["PointOfSaleApplicationDeviceUpdateResult"];
	['...on PointOfSaleApplicationDeviceUpsertResult']: '__union' & GraphQLTypes["PointOfSaleApplicationDeviceUpsertResult"];
	['...on PointOfSaleTerminalCreateResult']: '__union' & GraphQLTypes["PointOfSaleTerminalCreateResult"];
	['...on PointOfSaleTerminalDeleteResult']: '__union' & GraphQLTypes["PointOfSaleTerminalDeleteResult"];
	['...on PointOfSaleTerminalUpdateResult']: '__union' & GraphQLTypes["PointOfSaleTerminalUpdateResult"];
	['...on PointOfSaleTerminalUpsertResult']: '__union' & GraphQLTypes["PointOfSaleTerminalUpsertResult"];
	['...on PipelineStageSentimentCreateResult']: '__union' & GraphQLTypes["PipelineStageSentimentCreateResult"];
	['...on PipelineStageSentimentDeleteResult']: '__union' & GraphQLTypes["PipelineStageSentimentDeleteResult"];
	['...on PipelineStageSentimentUpdateResult']: '__union' & GraphQLTypes["PipelineStageSentimentUpdateResult"];
	['...on PipelineStageSentimentUpsertResult']: '__union' & GraphQLTypes["PipelineStageSentimentUpsertResult"];
	['...on DeviceIdentifierCreateResult']: '__union' & GraphQLTypes["DeviceIdentifierCreateResult"];
	['...on DeviceIdentifierDeleteResult']: '__union' & GraphQLTypes["DeviceIdentifierDeleteResult"];
	['...on DeviceIdentifierUpdateResult']: '__union' & GraphQLTypes["DeviceIdentifierUpdateResult"];
	['...on DeviceIdentifierUpsertResult']: '__union' & GraphQLTypes["DeviceIdentifierUpsertResult"];
	['...on PointOfSalePrinterCreateResult']: '__union' & GraphQLTypes["PointOfSalePrinterCreateResult"];
	['...on PointOfSalePrinterDeleteResult']: '__union' & GraphQLTypes["PointOfSalePrinterDeleteResult"];
	['...on PointOfSalePrinterUpdateResult']: '__union' & GraphQLTypes["PointOfSalePrinterUpdateResult"];
	['...on PointOfSalePrinterUpsertResult']: '__union' & GraphQLTypes["PointOfSalePrinterUpsertResult"];
	['...on GratuityCreateResult']: '__union' & GraphQLTypes["GratuityCreateResult"];
	['...on GratuityDeleteResult']: '__union' & GraphQLTypes["GratuityDeleteResult"];
	['...on GratuityUpdateResult']: '__union' & GraphQLTypes["GratuityUpdateResult"];
	['...on GratuityUpsertResult']: '__union' & GraphQLTypes["GratuityUpsertResult"];
	['...on FulfillmentNoteCreateResult']: '__union' & GraphQLTypes["FulfillmentNoteCreateResult"];
	['...on FulfillmentNoteDeleteResult']: '__union' & GraphQLTypes["FulfillmentNoteDeleteResult"];
	['...on FulfillmentNoteUpdateResult']: '__union' & GraphQLTypes["FulfillmentNoteUpdateResult"];
	['...on FulfillmentNoteUpsertResult']: '__union' & GraphQLTypes["FulfillmentNoteUpsertResult"];
	['...on LeadFormCreateResult']: '__union' & GraphQLTypes["LeadFormCreateResult"];
	['...on LeadFormDeleteResult']: '__union' & GraphQLTypes["LeadFormDeleteResult"];
	['...on LeadFormUpdateResult']: '__union' & GraphQLTypes["LeadFormUpdateResult"];
	['...on LeadFormUpsertResult']: '__union' & GraphQLTypes["LeadFormUpsertResult"];
	['...on SubscriptionBoxCreateResult']: '__union' & GraphQLTypes["SubscriptionBoxCreateResult"];
	['...on SubscriptionBoxDeleteResult']: '__union' & GraphQLTypes["SubscriptionBoxDeleteResult"];
	['...on SubscriptionBoxUpdateResult']: '__union' & GraphQLTypes["SubscriptionBoxUpdateResult"];
	['...on SubscriptionBoxUpsertResult']: '__union' & GraphQLTypes["SubscriptionBoxUpsertResult"];
	['...on SubscriptionBoxLocaleCreateResult']: '__union' & GraphQLTypes["SubscriptionBoxLocaleCreateResult"];
	['...on SubscriptionBoxLocaleDeleteResult']: '__union' & GraphQLTypes["SubscriptionBoxLocaleDeleteResult"];
	['...on SubscriptionBoxLocaleUpdateResult']: '__union' & GraphQLTypes["SubscriptionBoxLocaleUpdateResult"];
	['...on SubscriptionBoxLocaleUpsertResult']: '__union' & GraphQLTypes["SubscriptionBoxLocaleUpsertResult"];
	['...on BusinessServiceCreateResult']: '__union' & GraphQLTypes["BusinessServiceCreateResult"];
	['...on BusinessServiceDeleteResult']: '__union' & GraphQLTypes["BusinessServiceDeleteResult"];
	['...on BusinessServiceUpdateResult']: '__union' & GraphQLTypes["BusinessServiceUpdateResult"];
	['...on BusinessServiceUpsertResult']: '__union' & GraphQLTypes["BusinessServiceUpsertResult"];
	['...on BusinessServiceEventCreateResult']: '__union' & GraphQLTypes["BusinessServiceEventCreateResult"];
	['...on BusinessServiceEventDeleteResult']: '__union' & GraphQLTypes["BusinessServiceEventDeleteResult"];
	['...on BusinessServiceEventUpdateResult']: '__union' & GraphQLTypes["BusinessServiceEventUpdateResult"];
	['...on BusinessServiceEventUpsertResult']: '__union' & GraphQLTypes["BusinessServiceEventUpsertResult"];
	['...on BusinessServiceLocaleCreateResult']: '__union' & GraphQLTypes["BusinessServiceLocaleCreateResult"];
	['...on BusinessServiceLocaleDeleteResult']: '__union' & GraphQLTypes["BusinessServiceLocaleDeleteResult"];
	['...on BusinessServiceLocaleUpdateResult']: '__union' & GraphQLTypes["BusinessServiceLocaleUpdateResult"];
	['...on BusinessServiceLocaleUpsertResult']: '__union' & GraphQLTypes["BusinessServiceLocaleUpsertResult"];
	['...on GridTileItemCreateResult']: '__union' & GraphQLTypes["GridTileItemCreateResult"];
	['...on GridTileItemDeleteResult']: '__union' & GraphQLTypes["GridTileItemDeleteResult"];
	['...on GridTileItemUpdateResult']: '__union' & GraphQLTypes["GridTileItemUpdateResult"];
	['...on GridTileItemUpsertResult']: '__union' & GraphQLTypes["GridTileItemUpsertResult"];
	['...on GridTilesCreateResult']: '__union' & GraphQLTypes["GridTilesCreateResult"];
	['...on GridTilesDeleteResult']: '__union' & GraphQLTypes["GridTilesDeleteResult"];
	['...on GridTilesUpdateResult']: '__union' & GraphQLTypes["GridTilesUpdateResult"];
	['...on GridTilesUpsertResult']: '__union' & GraphQLTypes["GridTilesUpsertResult"];
	['...on AreaCreateResult']: '__union' & GraphQLTypes["AreaCreateResult"];
	['...on AreaDeleteResult']: '__union' & GraphQLTypes["AreaDeleteResult"];
	['...on AreaUpdateResult']: '__union' & GraphQLTypes["AreaUpdateResult"];
	['...on AreaUpsertResult']: '__union' & GraphQLTypes["AreaUpsertResult"];
	['...on PositionCreateResult']: '__union' & GraphQLTypes["PositionCreateResult"];
	['...on PositionDeleteResult']: '__union' & GraphQLTypes["PositionDeleteResult"];
	['...on PositionUpdateResult']: '__union' & GraphQLTypes["PositionUpdateResult"];
	['...on PositionUpsertResult']: '__union' & GraphQLTypes["PositionUpsertResult"];
	['...on StatsEnabledWidgetTypeCreateResult']: '__union' & GraphQLTypes["StatsEnabledWidgetTypeCreateResult"];
	['...on StatsEnabledWidgetTypeDeleteResult']: '__union' & GraphQLTypes["StatsEnabledWidgetTypeDeleteResult"];
	['...on StatsEnabledWidgetTypeUpdateResult']: '__union' & GraphQLTypes["StatsEnabledWidgetTypeUpdateResult"];
	['...on StatsEnabledWidgetTypeUpsertResult']: '__union' & GraphQLTypes["StatsEnabledWidgetTypeUpsertResult"];
	['...on StatsWidgetCreateResult']: '__union' & GraphQLTypes["StatsWidgetCreateResult"];
	['...on StatsWidgetDeleteResult']: '__union' & GraphQLTypes["StatsWidgetDeleteResult"];
	['...on StatsWidgetUpdateResult']: '__union' & GraphQLTypes["StatsWidgetUpdateResult"];
	['...on StatsWidgetUpsertResult']: '__union' & GraphQLTypes["StatsWidgetUpsertResult"];
	['...on StatsWidgetsLayoutCreateResult']: '__union' & GraphQLTypes["StatsWidgetsLayoutCreateResult"];
	['...on StatsWidgetsLayoutDeleteResult']: '__union' & GraphQLTypes["StatsWidgetsLayoutDeleteResult"];
	['...on StatsWidgetsLayoutUpdateResult']: '__union' & GraphQLTypes["StatsWidgetsLayoutUpdateResult"];
	['...on StatsWidgetsLayoutUpsertResult']: '__union' & GraphQLTypes["StatsWidgetsLayoutUpsertResult"];
	['...on SeatCreateResult']: '__union' & GraphQLTypes["SeatCreateResult"];
	['...on SeatDeleteResult']: '__union' & GraphQLTypes["SeatDeleteResult"];
	['...on SeatUpdateResult']: '__union' & GraphQLTypes["SeatUpdateResult"];
	['...on SeatUpsertResult']: '__union' & GraphQLTypes["SeatUpsertResult"];
	['...on TableCreateResult']: '__union' & GraphQLTypes["TableCreateResult"];
	['...on TableDeleteResult']: '__union' & GraphQLTypes["TableDeleteResult"];
	['...on TableUpdateResult']: '__union' & GraphQLTypes["TableUpdateResult"];
	['...on TableUpsertResult']: '__union' & GraphQLTypes["TableUpsertResult"];
	['...on StatsPageCreateResult']: '__union' & GraphQLTypes["StatsPageCreateResult"];
	['...on StatsPageDeleteResult']: '__union' & GraphQLTypes["StatsPageDeleteResult"];
	['...on StatsPageUpdateResult']: '__union' & GraphQLTypes["StatsPageUpdateResult"];
	['...on StatsPageUpsertResult']: '__union' & GraphQLTypes["StatsPageUpsertResult"];
	['...on UnassignReasonCreateResult']: '__union' & GraphQLTypes["UnassignReasonCreateResult"];
	['...on UnassignReasonDeleteResult']: '__union' & GraphQLTypes["UnassignReasonDeleteResult"];
	['...on UnassignReasonUpdateResult']: '__union' & GraphQLTypes["UnassignReasonUpdateResult"];
	['...on UnassignReasonUpsertResult']: '__union' & GraphQLTypes["UnassignReasonUpsertResult"];
	['...on DoubleshotCoffeeEquipmentCreateResult']: '__union' & GraphQLTypes["DoubleshotCoffeeEquipmentCreateResult"];
	['...on DoubleshotCoffeeEquipmentDeleteResult']: '__union' & GraphQLTypes["DoubleshotCoffeeEquipmentDeleteResult"];
	['...on DoubleshotCoffeeEquipmentUpdateResult']: '__union' & GraphQLTypes["DoubleshotCoffeeEquipmentUpdateResult"];
	['...on DoubleshotCoffeeEquipmentUpsertResult']: '__union' & GraphQLTypes["DoubleshotCoffeeEquipmentUpsertResult"];
	['...on ExpenseCreateResult']: '__union' & GraphQLTypes["ExpenseCreateResult"];
	['...on ExpenseDeleteResult']: '__union' & GraphQLTypes["ExpenseDeleteResult"];
	['...on ExpenseUpdateResult']: '__union' & GraphQLTypes["ExpenseUpdateResult"];
	['...on ExpenseUpsertResult']: '__union' & GraphQLTypes["ExpenseUpsertResult"];
	['...on ExpenseCategoryCreateResult']: '__union' & GraphQLTypes["ExpenseCategoryCreateResult"];
	['...on ExpenseCategoryDeleteResult']: '__union' & GraphQLTypes["ExpenseCategoryDeleteResult"];
	['...on ExpenseCategoryUpdateResult']: '__union' & GraphQLTypes["ExpenseCategoryUpdateResult"];
	['...on ExpenseCategoryUpsertResult']: '__union' & GraphQLTypes["ExpenseCategoryUpsertResult"];
	['...on ExpenseChangeCreateResult']: '__union' & GraphQLTypes["ExpenseChangeCreateResult"];
	['...on ExpenseChangeDeleteResult']: '__union' & GraphQLTypes["ExpenseChangeDeleteResult"];
	['...on ExpenseChangeUpdateResult']: '__union' & GraphQLTypes["ExpenseChangeUpdateResult"];
	['...on ExpenseChangeUpsertResult']: '__union' & GraphQLTypes["ExpenseChangeUpsertResult"];
	['...on ExpenseDocumentCreateResult']: '__union' & GraphQLTypes["ExpenseDocumentCreateResult"];
	['...on ExpenseDocumentDeleteResult']: '__union' & GraphQLTypes["ExpenseDocumentDeleteResult"];
	['...on ExpenseDocumentUpdateResult']: '__union' & GraphQLTypes["ExpenseDocumentUpdateResult"];
	['...on ExpenseDocumentUpsertResult']: '__union' & GraphQLTypes["ExpenseDocumentUpsertResult"];
	['...on RevenuePredictionCreateResult']: '__union' & GraphQLTypes["RevenuePredictionCreateResult"];
	['...on RevenuePredictionDeleteResult']: '__union' & GraphQLTypes["RevenuePredictionDeleteResult"];
	['...on RevenuePredictionUpdateResult']: '__union' & GraphQLTypes["RevenuePredictionUpdateResult"];
	['...on RevenuePredictionUpsertResult']: '__union' & GraphQLTypes["RevenuePredictionUpsertResult"];
	['...on RevenuePredictionChangeCreateResult']: '__union' & GraphQLTypes["RevenuePredictionChangeCreateResult"];
	['...on RevenuePredictionChangeDeleteResult']: '__union' & GraphQLTypes["RevenuePredictionChangeDeleteResult"];
	['...on RevenuePredictionChangeUpdateResult']: '__union' & GraphQLTypes["RevenuePredictionChangeUpdateResult"];
	['...on RevenuePredictionChangeUpsertResult']: '__union' & GraphQLTypes["RevenuePredictionChangeUpsertResult"];
	['...on FileCreateResult']: '__union' & GraphQLTypes["FileCreateResult"];
	['...on FileDeleteResult']: '__union' & GraphQLTypes["FileDeleteResult"];
	['...on FileUpdateResult']: '__union' & GraphQLTypes["FileUpdateResult"];
	['...on FileUpsertResult']: '__union' & GraphQLTypes["FileUpsertResult"];
	['...on LineCreateResult']: '__union' & GraphQLTypes["LineCreateResult"];
	['...on LineDeleteResult']: '__union' & GraphQLTypes["LineDeleteResult"];
	['...on LineUpdateResult']: '__union' & GraphQLTypes["LineUpdateResult"];
	['...on LineUpsertResult']: '__union' & GraphQLTypes["LineUpsertResult"];
	['...on FinancesBalanceItemCreateResult']: '__union' & GraphQLTypes["FinancesBalanceItemCreateResult"];
	['...on FinancesBalanceItemDeleteResult']: '__union' & GraphQLTypes["FinancesBalanceItemDeleteResult"];
	['...on FinancesBalanceItemUpdateResult']: '__union' & GraphQLTypes["FinancesBalanceItemUpdateResult"];
	['...on FinancesBalanceItemUpsertResult']: '__union' & GraphQLTypes["FinancesBalanceItemUpsertResult"];
	['...on WoltDriveDeliveryCreateResult']: '__union' & GraphQLTypes["WoltDriveDeliveryCreateResult"];
	['...on WoltDriveDeliveryDeleteResult']: '__union' & GraphQLTypes["WoltDriveDeliveryDeleteResult"];
	['...on WoltDriveDeliveryUpdateResult']: '__union' & GraphQLTypes["WoltDriveDeliveryUpdateResult"];
	['...on WoltDriveDeliveryUpsertResult']: '__union' & GraphQLTypes["WoltDriveDeliveryUpsertResult"];
};
	["_MutationError"]: {
	__typename: "_MutationError",
	path: Array<GraphQLTypes["_PathFragment"]>,
	paths: Array<Array<GraphQLTypes["_PathFragment"]>>,
	type: GraphQLTypes["_MutationErrorType"],
	message?: string | undefined
};
	["_MutationErrorType"]: _MutationErrorType;
	["AddressDeleteResult"]: {
	__typename: "AddressDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Address"] | undefined
};
	["AddressUpdateResult"]: {
	__typename: "AddressUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Address"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["AddressUpsertResult"]: {
	__typename: "AddressUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Address"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CountryCreateResult"]: {
	__typename: "CountryCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Country"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CountryDeleteResult"]: {
	__typename: "CountryDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Country"] | undefined
};
	["CountryUpdateResult"]: {
	__typename: "CountryUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Country"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CountryUpsertResult"]: {
	__typename: "CountryUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Country"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ChannelCreateResult"]: {
	__typename: "ChannelCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Channel"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ChannelDeleteResult"]: {
	__typename: "ChannelDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Channel"] | undefined
};
	["ChannelUpdateResult"]: {
	__typename: "ChannelUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Channel"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ChannelUpsertResult"]: {
	__typename: "ChannelUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Channel"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ChannelPaymentCreateResult"]: {
	__typename: "ChannelPaymentCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ChannelPayment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ChannelPaymentDeleteResult"]: {
	__typename: "ChannelPaymentDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ChannelPayment"] | undefined
};
	["ChannelPaymentUpdateResult"]: {
	__typename: "ChannelPaymentUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ChannelPayment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ChannelPaymentUpsertResult"]: {
	__typename: "ChannelPaymentUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ChannelPayment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ChannelDeliveryCreateResult"]: {
	__typename: "ChannelDeliveryCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ChannelDelivery"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ChannelDeliveryDeleteResult"]: {
	__typename: "ChannelDeliveryDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ChannelDelivery"] | undefined
};
	["ChannelDeliveryUpdateResult"]: {
	__typename: "ChannelDeliveryUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ChannelDelivery"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ChannelDeliveryUpsertResult"]: {
	__typename: "ChannelDeliveryUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ChannelDelivery"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerCreateResult"]: {
	__typename: "CustomerCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Customer"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerDeleteResult"]: {
	__typename: "CustomerDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Customer"] | undefined
};
	["CustomerUpdateResult"]: {
	__typename: "CustomerUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Customer"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerUpsertResult"]: {
	__typename: "CustomerUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Customer"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerCreditCreateResult"]: {
	__typename: "CustomerCreditCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerCredit"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerCreditDeleteResult"]: {
	__typename: "CustomerCreditDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerCredit"] | undefined
};
	["CustomerCreditUpdateResult"]: {
	__typename: "CustomerCreditUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerCredit"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerCreditUpsertResult"]: {
	__typename: "CustomerCreditUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerCredit"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerGroupCreateResult"]: {
	__typename: "CustomerGroupCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerGroup"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerGroupDeleteResult"]: {
	__typename: "CustomerGroupDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerGroup"] | undefined
};
	["CustomerGroupUpdateResult"]: {
	__typename: "CustomerGroupUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerGroup"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerGroupUpsertResult"]: {
	__typename: "CustomerGroupUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerGroup"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerPaymentMethodCreateResult"]: {
	__typename: "CustomerPaymentMethodCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerPaymentMethod"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerPaymentMethodDeleteResult"]: {
	__typename: "CustomerPaymentMethodDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerPaymentMethod"] | undefined
};
	["CustomerPaymentMethodUpdateResult"]: {
	__typename: "CustomerPaymentMethodUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerPaymentMethod"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerPaymentMethodUpsertResult"]: {
	__typename: "CustomerPaymentMethodUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerPaymentMethod"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryMethodCreateResult"]: {
	__typename: "DeliveryMethodCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryMethod"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryMethodDeleteResult"]: {
	__typename: "DeliveryMethodDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryMethod"] | undefined
};
	["DeliveryMethodUpdateResult"]: {
	__typename: "DeliveryMethodUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryMethod"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryMethodUpsertResult"]: {
	__typename: "DeliveryMethodUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryMethod"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderCreateResult"]: {
	__typename: "OrderCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Order"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderDeleteResult"]: {
	__typename: "OrderDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Order"] | undefined
};
	["OrderUpdateResult"]: {
	__typename: "OrderUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Order"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderUpsertResult"]: {
	__typename: "OrderUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Order"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderDiscountCreateResult"]: {
	__typename: "OrderDiscountCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderDiscount"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderDiscountDeleteResult"]: {
	__typename: "OrderDiscountDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderDiscount"] | undefined
};
	["OrderDiscountUpdateResult"]: {
	__typename: "OrderDiscountUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderDiscount"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderDiscountUpsertResult"]: {
	__typename: "OrderDiscountUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderDiscount"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderPaymentCreateResult"]: {
	__typename: "OrderPaymentCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderPayment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderPaymentDeleteResult"]: {
	__typename: "OrderPaymentDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderPayment"] | undefined
};
	["OrderPaymentUpdateResult"]: {
	__typename: "OrderPaymentUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderPayment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderPaymentUpsertResult"]: {
	__typename: "OrderPaymentUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderPayment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderDeliveryCreateResult"]: {
	__typename: "OrderDeliveryCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderDelivery"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderDeliveryDeleteResult"]: {
	__typename: "OrderDeliveryDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderDelivery"] | undefined
};
	["OrderDeliveryUpdateResult"]: {
	__typename: "OrderDeliveryUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderDelivery"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderDeliveryUpsertResult"]: {
	__typename: "OrderDeliveryUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderDelivery"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderItemCreateResult"]: {
	__typename: "OrderItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderItemDeleteResult"]: {
	__typename: "OrderItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderItem"] | undefined
};
	["OrderItemUpdateResult"]: {
	__typename: "OrderItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderItemUpsertResult"]: {
	__typename: "OrderItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PaymentMethodCreateResult"]: {
	__typename: "PaymentMethodCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PaymentMethod"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PaymentMethodDeleteResult"]: {
	__typename: "PaymentMethodDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PaymentMethod"] | undefined
};
	["PaymentMethodUpdateResult"]: {
	__typename: "PaymentMethodUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PaymentMethod"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PaymentMethodUpsertResult"]: {
	__typename: "PaymentMethodUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PaymentMethod"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VatRateCreateResult"]: {
	__typename: "VatRateCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VatRate"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VatRateDeleteResult"]: {
	__typename: "VatRateDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VatRate"] | undefined
};
	["VatRateUpdateResult"]: {
	__typename: "VatRateUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VatRate"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VatRateUpsertResult"]: {
	__typename: "VatRateUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VatRate"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductCreateResult"]: {
	__typename: "ProductCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Product"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductDeleteResult"]: {
	__typename: "ProductDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Product"] | undefined
};
	["ProductUpdateResult"]: {
	__typename: "ProductUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Product"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductUpsertResult"]: {
	__typename: "ProductUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Product"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductStockCreateResult"]: {
	__typename: "ProductStockCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductStock"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductStockDeleteResult"]: {
	__typename: "ProductStockDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductStock"] | undefined
};
	["ProductStockUpdateResult"]: {
	__typename: "ProductStockUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductStock"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductStockUpsertResult"]: {
	__typename: "ProductStockUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductStock"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductPackingCreateResult"]: {
	__typename: "ProductPackingCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductPacking"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductPackingDeleteResult"]: {
	__typename: "ProductPackingDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductPacking"] | undefined
};
	["ProductPackingUpdateResult"]: {
	__typename: "ProductPackingUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductPacking"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductPackingUpsertResult"]: {
	__typename: "ProductPackingUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductPacking"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductGroupPriceCreateResult"]: {
	__typename: "ProductGroupPriceCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGroupPrice"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductGroupPriceDeleteResult"]: {
	__typename: "ProductGroupPriceDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGroupPrice"] | undefined
};
	["ProductGroupPriceUpdateResult"]: {
	__typename: "ProductGroupPriceUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGroupPrice"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductGroupPriceUpsertResult"]: {
	__typename: "ProductGroupPriceUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGroupPrice"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductRecipeCreateResult"]: {
	__typename: "ProductRecipeCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductRecipe"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductRecipeDeleteResult"]: {
	__typename: "ProductRecipeDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductRecipe"] | undefined
};
	["ProductRecipeUpdateResult"]: {
	__typename: "ProductRecipeUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductRecipe"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductRecipeUpsertResult"]: {
	__typename: "ProductRecipeUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductRecipe"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductCategoryCreateResult"]: {
	__typename: "ProductCategoryCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductCategory"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductCategoryDeleteResult"]: {
	__typename: "ProductCategoryDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductCategory"] | undefined
};
	["ProductCategoryUpdateResult"]: {
	__typename: "ProductCategoryUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductCategory"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductCategoryUpsertResult"]: {
	__typename: "ProductCategoryUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductCategory"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StoreCreateResult"]: {
	__typename: "StoreCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Store"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StoreDeleteResult"]: {
	__typename: "StoreDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Store"] | undefined
};
	["StoreUpdateResult"]: {
	__typename: "StoreUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Store"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StoreUpsertResult"]: {
	__typename: "StoreUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Store"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TagCreateResult"]: {
	__typename: "TagCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Tag"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TagDeleteResult"]: {
	__typename: "TagDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Tag"] | undefined
};
	["TagUpdateResult"]: {
	__typename: "TagUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Tag"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TagUpsertResult"]: {
	__typename: "TagUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Tag"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageCreateResult"]: {
	__typename: "ImageCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageDeleteResult"]: {
	__typename: "ImageDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"] | undefined
};
	["ImageUpdateResult"]: {
	__typename: "ImageUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageUpsertResult"]: {
	__typename: "ImageUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessCategoryCreateResult"]: {
	__typename: "BusinessCategoryCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessCategory"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessCategoryDeleteResult"]: {
	__typename: "BusinessCategoryDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessCategory"] | undefined
};
	["BusinessCategoryUpdateResult"]: {
	__typename: "BusinessCategoryUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessCategory"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessCategoryUpsertResult"]: {
	__typename: "BusinessCategoryUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessCategory"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductListCreateResult"]: {
	__typename: "ProductListCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductListDeleteResult"]: {
	__typename: "ProductListDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductList"] | undefined
};
	["ProductListUpdateResult"]: {
	__typename: "ProductListUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductListUpsertResult"]: {
	__typename: "ProductListUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductListItemCreateResult"]: {
	__typename: "ProductListItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductListItemDeleteResult"]: {
	__typename: "ProductListItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductListItem"] | undefined
};
	["ProductListItemUpdateResult"]: {
	__typename: "ProductListItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductListItemUpsertResult"]: {
	__typename: "ProductListItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductCategoryListCreateResult"]: {
	__typename: "ProductCategoryListCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductCategoryList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductCategoryListDeleteResult"]: {
	__typename: "ProductCategoryListDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductCategoryList"] | undefined
};
	["ProductCategoryListUpdateResult"]: {
	__typename: "ProductCategoryListUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductCategoryList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductCategoryListUpsertResult"]: {
	__typename: "ProductCategoryListUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductCategoryList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductCategoryListItemCreateResult"]: {
	__typename: "ProductCategoryListItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductCategoryListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductCategoryListItemDeleteResult"]: {
	__typename: "ProductCategoryListItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductCategoryListItem"] | undefined
};
	["ProductCategoryListItemUpdateResult"]: {
	__typename: "ProductCategoryListItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductCategoryListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductCategoryListItemUpsertResult"]: {
	__typename: "ProductCategoryListItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductCategoryListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessCategoryLocaleCreateResult"]: {
	__typename: "BusinessCategoryLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessCategoryLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessCategoryLocaleDeleteResult"]: {
	__typename: "BusinessCategoryLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessCategoryLocale"] | undefined
};
	["BusinessCategoryLocaleUpdateResult"]: {
	__typename: "BusinessCategoryLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessCategoryLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessCategoryLocaleUpsertResult"]: {
	__typename: "BusinessCategoryLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessCategoryLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LocaleCreateResult"]: {
	__typename: "LocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Locale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LocaleDeleteResult"]: {
	__typename: "LocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Locale"] | undefined
};
	["LocaleUpdateResult"]: {
	__typename: "LocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Locale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LocaleUpsertResult"]: {
	__typename: "LocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Locale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductCategoryListLocaleCreateResult"]: {
	__typename: "ProductCategoryListLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductCategoryListLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductCategoryListLocaleDeleteResult"]: {
	__typename: "ProductCategoryListLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductCategoryListLocale"] | undefined
};
	["ProductCategoryListLocaleUpdateResult"]: {
	__typename: "ProductCategoryListLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductCategoryListLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductCategoryListLocaleUpsertResult"]: {
	__typename: "ProductCategoryListLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductCategoryListLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerNameCreateResult"]: {
	__typename: "CustomerNameCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerName"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerNameDeleteResult"]: {
	__typename: "CustomerNameDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerName"] | undefined
};
	["CustomerNameUpdateResult"]: {
	__typename: "CustomerNameUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerName"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerNameUpsertResult"]: {
	__typename: "CustomerNameUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerName"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerAliasCreateResult"]: {
	__typename: "CustomerAliasCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerAlias"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerAliasDeleteResult"]: {
	__typename: "CustomerAliasDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerAlias"] | undefined
};
	["CustomerAliasUpdateResult"]: {
	__typename: "CustomerAliasUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerAlias"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerAliasUpsertResult"]: {
	__typename: "CustomerAliasUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerAlias"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientItemCreateResult"]: {
	__typename: "ProductIngredientItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientItemDeleteResult"]: {
	__typename: "ProductIngredientItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientItem"] | undefined
};
	["ProductIngredientItemUpdateResult"]: {
	__typename: "ProductIngredientItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientItemUpsertResult"]: {
	__typename: "ProductIngredientItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientItemQuantityCreateResult"]: {
	__typename: "ProductIngredientItemQuantityCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientItemQuantity"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientItemQuantityDeleteResult"]: {
	__typename: "ProductIngredientItemQuantityDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientItemQuantity"] | undefined
};
	["ProductIngredientItemQuantityUpdateResult"]: {
	__typename: "ProductIngredientItemQuantityUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientItemQuantity"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientItemQuantityUpsertResult"]: {
	__typename: "ProductIngredientItemQuantityUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientItemQuantity"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientItemQuantityUnitCreateResult"]: {
	__typename: "ProductIngredientItemQuantityUnitCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientItemQuantityUnit"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientItemQuantityUnitDeleteResult"]: {
	__typename: "ProductIngredientItemQuantityUnitDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientItemQuantityUnit"] | undefined
};
	["ProductIngredientItemQuantityUnitUpdateResult"]: {
	__typename: "ProductIngredientItemQuantityUnitUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientItemQuantityUnit"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientItemQuantityUnitUpsertResult"]: {
	__typename: "ProductIngredientItemQuantityUnitUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientItemQuantityUnit"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientCreateResult"]: {
	__typename: "ProductIngredientCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredient"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientDeleteResult"]: {
	__typename: "ProductIngredientDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredient"] | undefined
};
	["ProductIngredientUpdateResult"]: {
	__typename: "ProductIngredientUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredient"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientUpsertResult"]: {
	__typename: "ProductIngredientUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredient"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerIngredientRatingCreateResult"]: {
	__typename: "CustomerIngredientRatingCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerIngredientRating"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerIngredientRatingDeleteResult"]: {
	__typename: "CustomerIngredientRatingDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerIngredientRating"] | undefined
};
	["CustomerIngredientRatingUpdateResult"]: {
	__typename: "CustomerIngredientRatingUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerIngredientRating"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerIngredientRatingUpsertResult"]: {
	__typename: "CustomerIngredientRatingUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerIngredientRating"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientRatingCreateResult"]: {
	__typename: "ProductIngredientRatingCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientRating"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientRatingDeleteResult"]: {
	__typename: "ProductIngredientRatingDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientRating"] | undefined
};
	["ProductIngredientRatingUpdateResult"]: {
	__typename: "ProductIngredientRatingUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientRating"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientRatingUpsertResult"]: {
	__typename: "ProductIngredientRatingUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientRating"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientLocaleCreateResult"]: {
	__typename: "ProductIngredientLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientLocaleDeleteResult"]: {
	__typename: "ProductIngredientLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientLocale"] | undefined
};
	["ProductIngredientLocaleUpdateResult"]: {
	__typename: "ProductIngredientLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientLocaleUpsertResult"]: {
	__typename: "ProductIngredientLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderRecurrenceCreateResult"]: {
	__typename: "OrderRecurrenceCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderRecurrence"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderRecurrenceDeleteResult"]: {
	__typename: "OrderRecurrenceDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderRecurrence"] | undefined
};
	["OrderRecurrenceUpdateResult"]: {
	__typename: "OrderRecurrenceUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderRecurrence"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderRecurrenceUpsertResult"]: {
	__typename: "OrderRecurrenceUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderRecurrence"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderRecurrenceLocaleCreateResult"]: {
	__typename: "OrderRecurrenceLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderRecurrenceLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderRecurrenceLocaleDeleteResult"]: {
	__typename: "OrderRecurrenceLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderRecurrenceLocale"] | undefined
};
	["OrderRecurrenceLocaleUpdateResult"]: {
	__typename: "OrderRecurrenceLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderRecurrenceLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderRecurrenceLocaleUpsertResult"]: {
	__typename: "OrderRecurrenceLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderRecurrenceLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessCustomerCreateResult"]: {
	__typename: "BusinessCustomerCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessCustomer"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessCustomerDeleteResult"]: {
	__typename: "BusinessCustomerDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessCustomer"] | undefined
};
	["BusinessCustomerUpdateResult"]: {
	__typename: "BusinessCustomerUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessCustomer"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessCustomerUpsertResult"]: {
	__typename: "BusinessCustomerUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessCustomer"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleCreateResult"]: {
	__typename: "PointOfSaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleDeleteResult"]: {
	__typename: "PointOfSaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSale"] | undefined
};
	["PointOfSaleUpdateResult"]: {
	__typename: "PointOfSaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleUpsertResult"]: {
	__typename: "PointOfSaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StaffCreateResult"]: {
	__typename: "StaffCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Staff"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StaffDeleteResult"]: {
	__typename: "StaffDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Staff"] | undefined
};
	["StaffUpdateResult"]: {
	__typename: "StaffUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Staff"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StaffUpsertResult"]: {
	__typename: "StaffUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Staff"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogCreateResult"]: {
	__typename: "BlogCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Blog"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogDeleteResult"]: {
	__typename: "BlogDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Blog"] | undefined
};
	["BlogUpdateResult"]: {
	__typename: "BlogUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Blog"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogUpsertResult"]: {
	__typename: "BlogUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Blog"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogLocaleCreateResult"]: {
	__typename: "BlogLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogLocaleDeleteResult"]: {
	__typename: "BlogLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogLocale"] | undefined
};
	["BlogLocaleUpdateResult"]: {
	__typename: "BlogLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogLocaleUpsertResult"]: {
	__typename: "BlogLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostCreateResult"]: {
	__typename: "BlogPostCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPost"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostDeleteResult"]: {
	__typename: "BlogPostDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPost"] | undefined
};
	["BlogPostUpdateResult"]: {
	__typename: "BlogPostUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPost"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostUpsertResult"]: {
	__typename: "BlogPostUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPost"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostLocaleCreateResult"]: {
	__typename: "BlogPostLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostLocaleDeleteResult"]: {
	__typename: "BlogPostLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostLocale"] | undefined
};
	["BlogPostLocaleUpdateResult"]: {
	__typename: "BlogPostLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostLocaleUpsertResult"]: {
	__typename: "BlogPostLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ColorPalleteCreateResult"]: {
	__typename: "ColorPalleteCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ColorPallete"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ColorPalleteDeleteResult"]: {
	__typename: "ColorPalleteDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ColorPallete"] | undefined
};
	["ColorPalleteUpdateResult"]: {
	__typename: "ColorPalleteUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ColorPallete"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ColorPalleteUpsertResult"]: {
	__typename: "ColorPalleteUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ColorPallete"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentCreateResult"]: {
	__typename: "ContentCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentDeleteResult"]: {
	__typename: "ContentDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"] | undefined
};
	["ContentUpdateResult"]: {
	__typename: "ContentUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentUpsertResult"]: {
	__typename: "ContentUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentBlockCreateResult"]: {
	__typename: "ContentBlockCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentBlockDeleteResult"]: {
	__typename: "ContentBlockDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"] | undefined
};
	["ContentBlockUpdateResult"]: {
	__typename: "ContentBlockUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentBlockUpsertResult"]: {
	__typename: "ContentBlockUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceCreateResult"]: {
	__typename: "ContentReferenceCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceDeleteResult"]: {
	__typename: "ContentReferenceDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"] | undefined
};
	["ContentReferenceUpdateResult"]: {
	__typename: "ContentReferenceUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceUpsertResult"]: {
	__typename: "ContentReferenceUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostListCreateResult"]: {
	__typename: "BlogPostListCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostListDeleteResult"]: {
	__typename: "BlogPostListDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostList"] | undefined
};
	["BlogPostListUpdateResult"]: {
	__typename: "BlogPostListUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostListUpsertResult"]: {
	__typename: "BlogPostListUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostListItemCreateResult"]: {
	__typename: "BlogPostListItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostListItemDeleteResult"]: {
	__typename: "BlogPostListItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostListItem"] | undefined
};
	["BlogPostListItemUpdateResult"]: {
	__typename: "BlogPostListItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostListItemUpsertResult"]: {
	__typename: "BlogPostListItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkListCreateResult"]: {
	__typename: "LinkListCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkListDeleteResult"]: {
	__typename: "LinkListDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkList"] | undefined
};
	["LinkListUpdateResult"]: {
	__typename: "LinkListUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkListUpsertResult"]: {
	__typename: "LinkListUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkListItemCreateResult"]: {
	__typename: "LinkListItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkListItemDeleteResult"]: {
	__typename: "LinkListItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkListItem"] | undefined
};
	["LinkListItemUpdateResult"]: {
	__typename: "LinkListItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkListItemUpsertResult"]: {
	__typename: "LinkListItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CoverCreateResult"]: {
	__typename: "CoverCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Cover"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CoverDeleteResult"]: {
	__typename: "CoverDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Cover"] | undefined
};
	["CoverUpdateResult"]: {
	__typename: "CoverUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Cover"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CoverUpsertResult"]: {
	__typename: "CoverUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Cover"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkCreateResult"]: {
	__typename: "LinkCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkDeleteResult"]: {
	__typename: "LinkDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"] | undefined
};
	["LinkUpdateResult"]: {
	__typename: "LinkUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkUpsertResult"]: {
	__typename: "LinkUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkableCreateResult"]: {
	__typename: "LinkableCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkableDeleteResult"]: {
	__typename: "LinkableDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"] | undefined
};
	["LinkableUpdateResult"]: {
	__typename: "LinkableUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkableUpsertResult"]: {
	__typename: "LinkableUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumCreateResult"]: {
	__typename: "MediumCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Medium"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumDeleteResult"]: {
	__typename: "MediumDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Medium"] | undefined
};
	["MediumUpdateResult"]: {
	__typename: "MediumUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Medium"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumUpsertResult"]: {
	__typename: "MediumUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Medium"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VideoCreateResult"]: {
	__typename: "VideoCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Video"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VideoDeleteResult"]: {
	__typename: "VideoDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Video"] | undefined
};
	["VideoUpdateResult"]: {
	__typename: "VideoUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Video"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VideoUpsertResult"]: {
	__typename: "VideoUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Video"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoCreateResult"]: {
	__typename: "SeoCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoDeleteResult"]: {
	__typename: "SeoDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"] | undefined
};
	["SeoUpdateResult"]: {
	__typename: "SeoUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoUpsertResult"]: {
	__typename: "SeoUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProtectedImageCreateResult"]: {
	__typename: "ProtectedImageCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProtectedImage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProtectedImageDeleteResult"]: {
	__typename: "ProtectedImageDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProtectedImage"] | undefined
};
	["ProtectedImageUpdateResult"]: {
	__typename: "ProtectedImageUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProtectedImage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProtectedImageUpsertResult"]: {
	__typename: "ProtectedImageUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProtectedImage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationDomainCreateResult"]: {
	__typename: "TranslationDomainCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationDomain"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationDomainDeleteResult"]: {
	__typename: "TranslationDomainDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationDomain"] | undefined
};
	["TranslationDomainUpdateResult"]: {
	__typename: "TranslationDomainUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationDomain"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationDomainUpsertResult"]: {
	__typename: "TranslationDomainUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationDomain"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationCatalogueCreateResult"]: {
	__typename: "TranslationCatalogueCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCatalogue"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationCatalogueDeleteResult"]: {
	__typename: "TranslationCatalogueDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCatalogue"] | undefined
};
	["TranslationCatalogueUpdateResult"]: {
	__typename: "TranslationCatalogueUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCatalogue"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationCatalogueUpsertResult"]: {
	__typename: "TranslationCatalogueUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCatalogue"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationKeyCreateResult"]: {
	__typename: "TranslationKeyCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationKey"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationKeyDeleteResult"]: {
	__typename: "TranslationKeyDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationKey"] | undefined
};
	["TranslationKeyUpdateResult"]: {
	__typename: "TranslationKeyUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationKey"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationKeyUpsertResult"]: {
	__typename: "TranslationKeyUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationKey"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationValueCreateResult"]: {
	__typename: "TranslationValueCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationValue"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationValueDeleteResult"]: {
	__typename: "TranslationValueDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationValue"] | undefined
};
	["TranslationValueUpdateResult"]: {
	__typename: "TranslationValueUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationValue"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationValueUpsertResult"]: {
	__typename: "TranslationValueUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationValue"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationCataloguesIdentifierCreateResult"]: {
	__typename: "TranslationCataloguesIdentifierCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCataloguesIdentifier"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationCataloguesIdentifierDeleteResult"]: {
	__typename: "TranslationCataloguesIdentifierDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCataloguesIdentifier"] | undefined
};
	["TranslationCataloguesIdentifierUpdateResult"]: {
	__typename: "TranslationCataloguesIdentifierUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCataloguesIdentifier"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationCataloguesIdentifierUpsertResult"]: {
	__typename: "TranslationCataloguesIdentifierUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCataloguesIdentifier"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialsAndAppsCreateResult"]: {
	__typename: "SocialsAndAppsCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialsAndApps"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialsAndAppsDeleteResult"]: {
	__typename: "SocialsAndAppsDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialsAndApps"] | undefined
};
	["SocialsAndAppsUpdateResult"]: {
	__typename: "SocialsAndAppsUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialsAndApps"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialsAndAppsUpsertResult"]: {
	__typename: "SocialsAndAppsUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialsAndApps"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductGridCreateResult"]: {
	__typename: "ProductGridCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGrid"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductGridDeleteResult"]: {
	__typename: "ProductGridDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGrid"] | undefined
};
	["ProductGridUpdateResult"]: {
	__typename: "ProductGridUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGrid"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductGridUpsertResult"]: {
	__typename: "ProductGridUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGrid"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductGridItemCreateResult"]: {
	__typename: "ProductGridItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGridItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductGridItemDeleteResult"]: {
	__typename: "ProductGridItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGridItem"] | undefined
};
	["ProductGridItemUpdateResult"]: {
	__typename: "ProductGridItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGridItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductGridItemUpsertResult"]: {
	__typename: "ProductGridItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGridItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryCreateResult"]: {
	__typename: "GalleryCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gallery"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryDeleteResult"]: {
	__typename: "GalleryDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gallery"] | undefined
};
	["GalleryUpdateResult"]: {
	__typename: "GalleryUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gallery"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryUpsertResult"]: {
	__typename: "GalleryUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gallery"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryItemCreateResult"]: {
	__typename: "GalleryItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GalleryItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryItemDeleteResult"]: {
	__typename: "GalleryItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GalleryItem"] | undefined
};
	["GalleryItemUpdateResult"]: {
	__typename: "GalleryItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GalleryItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryItemUpsertResult"]: {
	__typename: "GalleryItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GalleryItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeroCreateResult"]: {
	__typename: "HeroCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Hero"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeroDeleteResult"]: {
	__typename: "HeroDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Hero"] | undefined
};
	["HeroUpdateResult"]: {
	__typename: "HeroUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Hero"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeroUpsertResult"]: {
	__typename: "HeroUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Hero"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SiteMenuCreateResult"]: {
	__typename: "SiteMenuCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SiteMenu"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SiteMenuDeleteResult"]: {
	__typename: "SiteMenuDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SiteMenu"] | undefined
};
	["SiteMenuUpdateResult"]: {
	__typename: "SiteMenuUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SiteMenu"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SiteMenuUpsertResult"]: {
	__typename: "SiteMenuUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SiteMenu"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuLocaleCreateResult"]: {
	__typename: "MenuLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuLocaleDeleteResult"]: {
	__typename: "MenuLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuLocale"] | undefined
};
	["MenuLocaleUpdateResult"]: {
	__typename: "MenuLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuLocaleUpsertResult"]: {
	__typename: "MenuLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuItemCreateResult"]: {
	__typename: "MenuItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuItemDeleteResult"]: {
	__typename: "MenuItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuItem"] | undefined
};
	["MenuItemUpdateResult"]: {
	__typename: "MenuItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuItemUpsertResult"]: {
	__typename: "MenuItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PageCreateResult"]: {
	__typename: "PageCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Page"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PageDeleteResult"]: {
	__typename: "PageDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Page"] | undefined
};
	["PageUpdateResult"]: {
	__typename: "PageUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Page"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PageUpsertResult"]: {
	__typename: "PageUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Page"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PageLocaleCreateResult"]: {
	__typename: "PageLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PageLocaleDeleteResult"]: {
	__typename: "PageLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PageLocale"] | undefined
};
	["PageLocaleUpdateResult"]: {
	__typename: "PageLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PageLocaleUpsertResult"]: {
	__typename: "PageLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["WikiPageCreateResult"]: {
	__typename: "WikiPageCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["WikiPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["WikiPageDeleteResult"]: {
	__typename: "WikiPageDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["WikiPage"] | undefined
};
	["WikiPageUpdateResult"]: {
	__typename: "WikiPageUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["WikiPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["WikiPageUpsertResult"]: {
	__typename: "WikiPageUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["WikiPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuSubitemCreateResult"]: {
	__typename: "MenuSubitemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuSubitem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuSubitemDeleteResult"]: {
	__typename: "MenuSubitemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuSubitem"] | undefined
};
	["MenuSubitemUpdateResult"]: {
	__typename: "MenuSubitemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuSubitem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuSubitemUpsertResult"]: {
	__typename: "MenuSubitemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuSubitem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuLinkListCreateResult"]: {
	__typename: "MenuLinkListCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuLinkList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuLinkListDeleteResult"]: {
	__typename: "MenuLinkListDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuLinkList"] | undefined
};
	["MenuLinkListUpdateResult"]: {
	__typename: "MenuLinkListUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuLinkList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuLinkListUpsertResult"]: {
	__typename: "MenuLinkListUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuLinkList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuLinkItemCreateResult"]: {
	__typename: "MenuLinkItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuLinkItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuLinkItemDeleteResult"]: {
	__typename: "MenuLinkItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuLinkItem"] | undefined
};
	["MenuLinkItemUpdateResult"]: {
	__typename: "MenuLinkItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuLinkItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuLinkItemUpsertResult"]: {
	__typename: "MenuLinkItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuLinkItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuProductsCreateResult"]: {
	__typename: "MenuProductsCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuProducts"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuProductsDeleteResult"]: {
	__typename: "MenuProductsDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuProducts"] | undefined
};
	["MenuProductsUpdateResult"]: {
	__typename: "MenuProductsUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuProducts"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuProductsUpsertResult"]: {
	__typename: "MenuProductsUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuProducts"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuDeliveryCreateResult"]: {
	__typename: "MenuDeliveryCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuDelivery"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuDeliveryDeleteResult"]: {
	__typename: "MenuDeliveryDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuDelivery"] | undefined
};
	["MenuDeliveryUpdateResult"]: {
	__typename: "MenuDeliveryUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuDelivery"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuDeliveryUpsertResult"]: {
	__typename: "MenuDeliveryUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuDelivery"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuContactCreateResult"]: {
	__typename: "MenuContactCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuContact"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuContactDeleteResult"]: {
	__typename: "MenuContactDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuContact"] | undefined
};
	["MenuContactUpdateResult"]: {
	__typename: "MenuContactUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuContact"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuContactUpsertResult"]: {
	__typename: "MenuContactUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuContact"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeadlineTemplateCreateResult"]: {
	__typename: "DeadlineTemplateCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeadlineTemplate"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeadlineTemplateDeleteResult"]: {
	__typename: "DeadlineTemplateDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeadlineTemplate"] | undefined
};
	["DeadlineTemplateUpdateResult"]: {
	__typename: "DeadlineTemplateUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeadlineTemplate"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeadlineTemplateUpsertResult"]: {
	__typename: "DeadlineTemplateUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeadlineTemplate"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["EmployeeQueueCreateResult"]: {
	__typename: "EmployeeQueueCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EmployeeQueue"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["EmployeeQueueDeleteResult"]: {
	__typename: "EmployeeQueueDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EmployeeQueue"] | undefined
};
	["EmployeeQueueUpdateResult"]: {
	__typename: "EmployeeQueueUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EmployeeQueue"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["EmployeeQueueUpsertResult"]: {
	__typename: "EmployeeQueueUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EmployeeQueue"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableDayCreateResult"]: {
	__typename: "TimetableDayCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableDay"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableDayDeleteResult"]: {
	__typename: "TimetableDayDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableDay"] | undefined
};
	["TimetableDayUpdateResult"]: {
	__typename: "TimetableDayUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableDay"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableDayUpsertResult"]: {
	__typename: "TimetableDayUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableDay"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableEmployeeRoleCreateResult"]: {
	__typename: "TimetableEmployeeRoleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableEmployeeRole"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableEmployeeRoleDeleteResult"]: {
	__typename: "TimetableEmployeeRoleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableEmployeeRole"] | undefined
};
	["TimetableEmployeeRoleUpdateResult"]: {
	__typename: "TimetableEmployeeRoleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableEmployeeRole"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableEmployeeRoleUpsertResult"]: {
	__typename: "TimetableEmployeeRoleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableEmployeeRole"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableShiftCreateResult"]: {
	__typename: "TimetableShiftCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableShift"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableShiftDeleteResult"]: {
	__typename: "TimetableShiftDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableShift"] | undefined
};
	["TimetableShiftUpdateResult"]: {
	__typename: "TimetableShiftUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableShift"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableShiftUpsertResult"]: {
	__typename: "TimetableShiftUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableShift"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableShiftGroupCreateResult"]: {
	__typename: "TimetableShiftGroupCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableShiftGroup"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableShiftGroupDeleteResult"]: {
	__typename: "TimetableShiftGroupDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableShiftGroup"] | undefined
};
	["TimetableShiftGroupUpdateResult"]: {
	__typename: "TimetableShiftGroupUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableShiftGroup"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableShiftGroupUpsertResult"]: {
	__typename: "TimetableShiftGroupUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableShiftGroup"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableShiftPositionCreateResult"]: {
	__typename: "TimetableShiftPositionCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableShiftPosition"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableShiftPositionDeleteResult"]: {
	__typename: "TimetableShiftPositionDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableShiftPosition"] | undefined
};
	["TimetableShiftPositionUpdateResult"]: {
	__typename: "TimetableShiftPositionUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableShiftPosition"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableShiftPositionUpsertResult"]: {
	__typename: "TimetableShiftPositionUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableShiftPosition"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableTemplateCreateResult"]: {
	__typename: "TimetableTemplateCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableTemplate"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableTemplateDeleteResult"]: {
	__typename: "TimetableTemplateDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableTemplate"] | undefined
};
	["TimetableTemplateUpdateResult"]: {
	__typename: "TimetableTemplateUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableTemplate"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableTemplateUpsertResult"]: {
	__typename: "TimetableTemplateUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableTemplate"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CartCreateResult"]: {
	__typename: "CartCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Cart"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CartDeleteResult"]: {
	__typename: "CartDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Cart"] | undefined
};
	["CartUpdateResult"]: {
	__typename: "CartUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Cart"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CartUpsertResult"]: {
	__typename: "CartUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Cart"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CartItemCreateResult"]: {
	__typename: "CartItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CartItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CartItemDeleteResult"]: {
	__typename: "CartItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CartItem"] | undefined
};
	["CartItemUpdateResult"]: {
	__typename: "CartItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CartItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CartItemUpsertResult"]: {
	__typename: "CartItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CartItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["EmployeeQueueItemCreateResult"]: {
	__typename: "EmployeeQueueItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EmployeeQueueItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["EmployeeQueueItemDeleteResult"]: {
	__typename: "EmployeeQueueItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EmployeeQueueItem"] | undefined
};
	["EmployeeQueueItemUpdateResult"]: {
	__typename: "EmployeeQueueItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EmployeeQueueItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["EmployeeQueueItemUpsertResult"]: {
	__typename: "EmployeeQueueItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EmployeeQueueItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ApplicationCreateResult"]: {
	__typename: "ApplicationCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Application"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ApplicationDeleteResult"]: {
	__typename: "ApplicationDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Application"] | undefined
};
	["ApplicationUpdateResult"]: {
	__typename: "ApplicationUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Application"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ApplicationUpsertResult"]: {
	__typename: "ApplicationUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Application"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ApplicationShortcutListCreateResult"]: {
	__typename: "ApplicationShortcutListCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ApplicationShortcutList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ApplicationShortcutListDeleteResult"]: {
	__typename: "ApplicationShortcutListDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ApplicationShortcutList"] | undefined
};
	["ApplicationShortcutListUpdateResult"]: {
	__typename: "ApplicationShortcutListUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ApplicationShortcutList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ApplicationShortcutListUpsertResult"]: {
	__typename: "ApplicationShortcutListUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ApplicationShortcutList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ApplicationShortcutListItemCreateResult"]: {
	__typename: "ApplicationShortcutListItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ApplicationShortcutListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ApplicationShortcutListItemDeleteResult"]: {
	__typename: "ApplicationShortcutListItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ApplicationShortcutListItem"] | undefined
};
	["ApplicationShortcutListItemUpdateResult"]: {
	__typename: "ApplicationShortcutListItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ApplicationShortcutListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ApplicationShortcutListItemUpsertResult"]: {
	__typename: "ApplicationShortcutListItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ApplicationShortcutListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductBannerCreateResult"]: {
	__typename: "ProductBannerCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductBanner"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductBannerDeleteResult"]: {
	__typename: "ProductBannerDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductBanner"] | undefined
};
	["ProductBannerUpdateResult"]: {
	__typename: "ProductBannerUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductBanner"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductBannerUpsertResult"]: {
	__typename: "ProductBannerUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductBanner"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductBannerItemCreateResult"]: {
	__typename: "ProductBannerItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductBannerItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductBannerItemDeleteResult"]: {
	__typename: "ProductBannerItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductBannerItem"] | undefined
};
	["ProductBannerItemUpdateResult"]: {
	__typename: "ProductBannerItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductBannerItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductBannerItemUpsertResult"]: {
	__typename: "ProductBannerItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductBannerItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductBannerListCreateResult"]: {
	__typename: "ProductBannerListCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductBannerList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductBannerListDeleteResult"]: {
	__typename: "ProductBannerListDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductBannerList"] | undefined
};
	["ProductBannerListUpdateResult"]: {
	__typename: "ProductBannerListUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductBannerList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductBannerListUpsertResult"]: {
	__typename: "ProductBannerListUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductBannerList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BartenderCreateResult"]: {
	__typename: "BartenderCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Bartender"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BartenderDeleteResult"]: {
	__typename: "BartenderDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Bartender"] | undefined
};
	["BartenderUpdateResult"]: {
	__typename: "BartenderUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Bartender"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BartenderUpsertResult"]: {
	__typename: "BartenderUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Bartender"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessToBusinessManagerCreateResult"]: {
	__typename: "BusinessToBusinessManagerCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessToBusinessManager"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessToBusinessManagerDeleteResult"]: {
	__typename: "BusinessToBusinessManagerDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessToBusinessManager"] | undefined
};
	["BusinessToBusinessManagerUpdateResult"]: {
	__typename: "BusinessToBusinessManagerUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessToBusinessManager"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessToBusinessManagerUpsertResult"]: {
	__typename: "BusinessToBusinessManagerUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessToBusinessManager"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CleanerCreateResult"]: {
	__typename: "CleanerCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Cleaner"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CleanerDeleteResult"]: {
	__typename: "CleanerDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Cleaner"] | undefined
};
	["CleanerUpdateResult"]: {
	__typename: "CleanerUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Cleaner"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CleanerUpsertResult"]: {
	__typename: "CleanerUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Cleaner"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CourierCreateResult"]: {
	__typename: "CourierCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Courier"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CourierDeleteResult"]: {
	__typename: "CourierDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Courier"] | undefined
};
	["CourierUpdateResult"]: {
	__typename: "CourierUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Courier"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CourierUpsertResult"]: {
	__typename: "CourierUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Courier"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShiftsManagerCreateResult"]: {
	__typename: "ShiftsManagerCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShiftsManager"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShiftsManagerDeleteResult"]: {
	__typename: "ShiftsManagerDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShiftsManager"] | undefined
};
	["ShiftsManagerUpdateResult"]: {
	__typename: "ShiftsManagerUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShiftsManager"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShiftsManagerUpsertResult"]: {
	__typename: "ShiftsManagerUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShiftsManager"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UserCreateResult"]: {
	__typename: "UserCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["User"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UserDeleteResult"]: {
	__typename: "UserDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["User"] | undefined
};
	["UserUpdateResult"]: {
	__typename: "UserUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["User"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UserUpsertResult"]: {
	__typename: "UserUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["User"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShiftsProfileCreateResult"]: {
	__typename: "ShiftsProfileCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShiftsProfile"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShiftsProfileDeleteResult"]: {
	__typename: "ShiftsProfileDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShiftsProfile"] | undefined
};
	["ShiftsProfileUpdateResult"]: {
	__typename: "ShiftsProfileUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShiftsProfile"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShiftsProfileUpsertResult"]: {
	__typename: "ShiftsProfileUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShiftsProfile"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientCategoryCreateResult"]: {
	__typename: "ProductIngredientCategoryCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientCategory"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientCategoryDeleteResult"]: {
	__typename: "ProductIngredientCategoryDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientCategory"] | undefined
};
	["ProductIngredientCategoryUpdateResult"]: {
	__typename: "ProductIngredientCategoryUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientCategory"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientCategoryUpsertResult"]: {
	__typename: "ProductIngredientCategoryUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientCategory"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientCategoryLocaleCreateResult"]: {
	__typename: "ProductIngredientCategoryLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientCategoryLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientCategoryLocaleDeleteResult"]: {
	__typename: "ProductIngredientCategoryLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientCategoryLocale"] | undefined
};
	["ProductIngredientCategoryLocaleUpdateResult"]: {
	__typename: "ProductIngredientCategoryLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientCategoryLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductIngredientCategoryLocaleUpsertResult"]: {
	__typename: "ProductIngredientCategoryLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductIngredientCategoryLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StocksManagerCreateResult"]: {
	__typename: "StocksManagerCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StocksManager"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StocksManagerDeleteResult"]: {
	__typename: "StocksManagerDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StocksManager"] | undefined
};
	["StocksManagerUpdateResult"]: {
	__typename: "StocksManagerUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StocksManager"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StocksManagerUpsertResult"]: {
	__typename: "StocksManagerUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StocksManager"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryRouteCreateResult"]: {
	__typename: "DeliveryRouteCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryRoute"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryRouteDeleteResult"]: {
	__typename: "DeliveryRouteDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryRoute"] | undefined
};
	["DeliveryRouteUpdateResult"]: {
	__typename: "DeliveryRouteUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryRoute"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryRouteUpsertResult"]: {
	__typename: "DeliveryRouteUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryRoute"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryWaypointCreateResult"]: {
	__typename: "DeliveryWaypointCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryWaypoint"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryWaypointDeleteResult"]: {
	__typename: "DeliveryWaypointDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryWaypoint"] | undefined
};
	["DeliveryWaypointUpdateResult"]: {
	__typename: "DeliveryWaypointUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryWaypoint"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryWaypointUpsertResult"]: {
	__typename: "DeliveryWaypointUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryWaypoint"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["AllergenCreateResult"]: {
	__typename: "AllergenCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Allergen"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["AllergenDeleteResult"]: {
	__typename: "AllergenDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Allergen"] | undefined
};
	["AllergenUpdateResult"]: {
	__typename: "AllergenUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Allergen"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["AllergenUpsertResult"]: {
	__typename: "AllergenUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Allergen"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["AllergenLocaleCreateResult"]: {
	__typename: "AllergenLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AllergenLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["AllergenLocaleDeleteResult"]: {
	__typename: "AllergenLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AllergenLocale"] | undefined
};
	["AllergenLocaleUpdateResult"]: {
	__typename: "AllergenLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AllergenLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["AllergenLocaleUpsertResult"]: {
	__typename: "AllergenLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AllergenLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GpsCreateResult"]: {
	__typename: "GpsCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gps"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GpsDeleteResult"]: {
	__typename: "GpsDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gps"] | undefined
};
	["GpsUpdateResult"]: {
	__typename: "GpsUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gps"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GpsUpsertResult"]: {
	__typename: "GpsUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gps"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["WeekHoursCreateResult"]: {
	__typename: "WeekHoursCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["WeekHours"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["WeekHoursDeleteResult"]: {
	__typename: "WeekHoursDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["WeekHours"] | undefined
};
	["WeekHoursUpdateResult"]: {
	__typename: "WeekHoursUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["WeekHours"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["WeekHoursUpsertResult"]: {
	__typename: "WeekHoursUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["WeekHours"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PreparedIngredientQuantityCreateResult"]: {
	__typename: "PreparedIngredientQuantityCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PreparedIngredientQuantity"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PreparedIngredientQuantityDeleteResult"]: {
	__typename: "PreparedIngredientQuantityDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PreparedIngredientQuantity"] | undefined
};
	["PreparedIngredientQuantityUpdateResult"]: {
	__typename: "PreparedIngredientQuantityUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PreparedIngredientQuantity"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PreparedIngredientQuantityUpsertResult"]: {
	__typename: "PreparedIngredientQuantityUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PreparedIngredientQuantity"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PreparedRecipeQuantityCreateResult"]: {
	__typename: "PreparedRecipeQuantityCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PreparedRecipeQuantity"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PreparedRecipeQuantityDeleteResult"]: {
	__typename: "PreparedRecipeQuantityDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PreparedRecipeQuantity"] | undefined
};
	["PreparedRecipeQuantityUpdateResult"]: {
	__typename: "PreparedRecipeQuantityUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PreparedRecipeQuantity"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PreparedRecipeQuantityUpsertResult"]: {
	__typename: "PreparedRecipeQuantityUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PreparedRecipeQuantity"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InternalOrderCreateResult"]: {
	__typename: "InternalOrderCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InternalOrder"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InternalOrderDeleteResult"]: {
	__typename: "InternalOrderDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InternalOrder"] | undefined
};
	["InternalOrderUpdateResult"]: {
	__typename: "InternalOrderUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InternalOrder"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InternalOrderUpsertResult"]: {
	__typename: "InternalOrderUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InternalOrder"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InternalOrderItemCreateResult"]: {
	__typename: "InternalOrderItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InternalOrderItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InternalOrderItemDeleteResult"]: {
	__typename: "InternalOrderItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InternalOrderItem"] | undefined
};
	["InternalOrderItemUpdateResult"]: {
	__typename: "InternalOrderItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InternalOrderItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InternalOrderItemUpsertResult"]: {
	__typename: "InternalOrderItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InternalOrderItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PreparedPackingQuantityCreateResult"]: {
	__typename: "PreparedPackingQuantityCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PreparedPackingQuantity"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PreparedPackingQuantityDeleteResult"]: {
	__typename: "PreparedPackingQuantityDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PreparedPackingQuantity"] | undefined
};
	["PreparedPackingQuantityUpdateResult"]: {
	__typename: "PreparedPackingQuantityUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PreparedPackingQuantity"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PreparedPackingQuantityUpsertResult"]: {
	__typename: "PreparedPackingQuantityUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PreparedPackingQuantity"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CourierManagerCreateResult"]: {
	__typename: "CourierManagerCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CourierManager"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CourierManagerDeleteResult"]: {
	__typename: "CourierManagerDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CourierManager"] | undefined
};
	["CourierManagerUpdateResult"]: {
	__typename: "CourierManagerUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CourierManager"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CourierManagerUpsertResult"]: {
	__typename: "CourierManagerUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CourierManager"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryZoneCreateResult"]: {
	__typename: "DeliveryZoneCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryZone"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryZoneDeleteResult"]: {
	__typename: "DeliveryZoneDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryZone"] | undefined
};
	["DeliveryZoneUpdateResult"]: {
	__typename: "DeliveryZoneUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryZone"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryZoneUpsertResult"]: {
	__typename: "DeliveryZoneUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryZone"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryTimelinePresetCreateResult"]: {
	__typename: "DeliveryTimelinePresetCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryTimelinePreset"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryTimelinePresetDeleteResult"]: {
	__typename: "DeliveryTimelinePresetDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryTimelinePreset"] | undefined
};
	["DeliveryTimelinePresetUpdateResult"]: {
	__typename: "DeliveryTimelinePresetUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryTimelinePreset"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryTimelinePresetUpsertResult"]: {
	__typename: "DeliveryTimelinePresetUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryTimelinePreset"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderDeliveryTimelineCreateResult"]: {
	__typename: "OrderDeliveryTimelineCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderDeliveryTimeline"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderDeliveryTimelineDeleteResult"]: {
	__typename: "OrderDeliveryTimelineDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderDeliveryTimeline"] | undefined
};
	["OrderDeliveryTimelineUpdateResult"]: {
	__typename: "OrderDeliveryTimelineUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderDeliveryTimeline"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderDeliveryTimelineUpsertResult"]: {
	__typename: "OrderDeliveryTimelineUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderDeliveryTimeline"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderEventCreateResult"]: {
	__typename: "OrderEventCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderEvent"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderEventDeleteResult"]: {
	__typename: "OrderEventDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderEvent"] | undefined
};
	["OrderEventUpdateResult"]: {
	__typename: "OrderEventUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderEvent"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["OrderEventUpsertResult"]: {
	__typename: "OrderEventUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OrderEvent"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LiftagoRideCreateResult"]: {
	__typename: "LiftagoRideCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LiftagoRide"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LiftagoRideDeleteResult"]: {
	__typename: "LiftagoRideDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LiftagoRide"] | undefined
};
	["LiftagoRideUpdateResult"]: {
	__typename: "LiftagoRideUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LiftagoRide"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LiftagoRideUpsertResult"]: {
	__typename: "LiftagoRideUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LiftagoRide"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InvoiceCreateResult"]: {
	__typename: "InvoiceCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Invoice"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InvoiceDeleteResult"]: {
	__typename: "InvoiceDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Invoice"] | undefined
};
	["InvoiceUpdateResult"]: {
	__typename: "InvoiceUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Invoice"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InvoiceUpsertResult"]: {
	__typename: "InvoiceUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Invoice"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InvoicingPlanCreateResult"]: {
	__typename: "InvoicingPlanCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InvoicingPlan"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InvoicingPlanDeleteResult"]: {
	__typename: "InvoicingPlanDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InvoicingPlan"] | undefined
};
	["InvoicingPlanUpdateResult"]: {
	__typename: "InvoicingPlanUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InvoicingPlan"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InvoicingPlanUpsertResult"]: {
	__typename: "InvoicingPlanUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InvoicingPlan"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductPackingLocaleCreateResult"]: {
	__typename: "ProductPackingLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductPackingLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductPackingLocaleDeleteResult"]: {
	__typename: "ProductPackingLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductPackingLocale"] | undefined
};
	["ProductPackingLocaleUpdateResult"]: {
	__typename: "ProductPackingLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductPackingLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductPackingLocaleUpsertResult"]: {
	__typename: "ProductPackingLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductPackingLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductLocaleCreateResult"]: {
	__typename: "ProductLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductLocaleDeleteResult"]: {
	__typename: "ProductLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductLocale"] | undefined
};
	["ProductLocaleUpdateResult"]: {
	__typename: "ProductLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductLocaleUpsertResult"]: {
	__typename: "ProductLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductRecipeLocaleCreateResult"]: {
	__typename: "ProductRecipeLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductRecipeLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductRecipeLocaleDeleteResult"]: {
	__typename: "ProductRecipeLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductRecipeLocale"] | undefined
};
	["ProductRecipeLocaleUpdateResult"]: {
	__typename: "ProductRecipeLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductRecipeLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductRecipeLocaleUpsertResult"]: {
	__typename: "ProductRecipeLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductRecipeLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UserDeviceCreateResult"]: {
	__typename: "UserDeviceCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UserDevice"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UserDeviceDeleteResult"]: {
	__typename: "UserDeviceDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UserDevice"] | undefined
};
	["UserDeviceUpdateResult"]: {
	__typename: "UserDeviceUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UserDevice"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UserDeviceUpsertResult"]: {
	__typename: "UserDeviceUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UserDevice"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProtectedActionCreateResult"]: {
	__typename: "ProtectedActionCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProtectedAction"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProtectedActionDeleteResult"]: {
	__typename: "ProtectedActionDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProtectedAction"] | undefined
};
	["ProtectedActionUpdateResult"]: {
	__typename: "ProtectedActionUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProtectedAction"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProtectedActionUpsertResult"]: {
	__typename: "ProtectedActionUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProtectedAction"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PickerCreateResult"]: {
	__typename: "PickerCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Picker"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PickerDeleteResult"]: {
	__typename: "PickerDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Picker"] | undefined
};
	["PickerUpdateResult"]: {
	__typename: "PickerUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Picker"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PickerUpsertResult"]: {
	__typename: "PickerUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Picker"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableTemplateStaffOptionsCreateResult"]: {
	__typename: "TimetableTemplateStaffOptionsCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableTemplateStaffOptions"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableTemplateStaffOptionsDeleteResult"]: {
	__typename: "TimetableTemplateStaffOptionsDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableTemplateStaffOptions"] | undefined
};
	["TimetableTemplateStaffOptionsUpdateResult"]: {
	__typename: "TimetableTemplateStaffOptionsUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableTemplateStaffOptions"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableTemplateStaffOptionsUpsertResult"]: {
	__typename: "TimetableTemplateStaffOptionsUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableTemplateStaffOptions"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShoppingListCreateResult"]: {
	__typename: "ShoppingListCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShoppingList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShoppingListDeleteResult"]: {
	__typename: "ShoppingListDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShoppingList"] | undefined
};
	["ShoppingListUpdateResult"]: {
	__typename: "ShoppingListUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShoppingList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShoppingListUpsertResult"]: {
	__typename: "ShoppingListUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShoppingList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SuppliesPurchaseCreateResult"]: {
	__typename: "SuppliesPurchaseCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SuppliesPurchase"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SuppliesPurchaseDeleteResult"]: {
	__typename: "SuppliesPurchaseDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SuppliesPurchase"] | undefined
};
	["SuppliesPurchaseUpdateResult"]: {
	__typename: "SuppliesPurchaseUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SuppliesPurchase"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SuppliesPurchaseUpsertResult"]: {
	__typename: "SuppliesPurchaseUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SuppliesPurchase"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InvoicingPresetCreateResult"]: {
	__typename: "InvoicingPresetCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InvoicingPreset"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InvoicingPresetDeleteResult"]: {
	__typename: "InvoicingPresetDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InvoicingPreset"] | undefined
};
	["InvoicingPresetUpdateResult"]: {
	__typename: "InvoicingPresetUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InvoicingPreset"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InvoicingPresetUpsertResult"]: {
	__typename: "InvoicingPresetUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InvoicingPreset"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LogRecordCreateResult"]: {
	__typename: "LogRecordCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LogRecord"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LogRecordDeleteResult"]: {
	__typename: "LogRecordDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LogRecord"] | undefined
};
	["LogRecordUpdateResult"]: {
	__typename: "LogRecordUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LogRecord"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LogRecordUpsertResult"]: {
	__typename: "LogRecordUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LogRecord"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BillingSubjectCreateResult"]: {
	__typename: "BillingSubjectCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BillingSubject"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BillingSubjectDeleteResult"]: {
	__typename: "BillingSubjectDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BillingSubject"] | undefined
};
	["BillingSubjectUpdateResult"]: {
	__typename: "BillingSubjectUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BillingSubject"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BillingSubjectUpsertResult"]: {
	__typename: "BillingSubjectUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BillingSubject"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShoppingListItemCreateResult"]: {
	__typename: "ShoppingListItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShoppingListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShoppingListItemDeleteResult"]: {
	__typename: "ShoppingListItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShoppingListItem"] | undefined
};
	["ShoppingListItemUpdateResult"]: {
	__typename: "ShoppingListItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShoppingListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShoppingListItemUpsertResult"]: {
	__typename: "ShoppingListItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShoppingListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SuppliesPurchaseItemCreateResult"]: {
	__typename: "SuppliesPurchaseItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SuppliesPurchaseItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SuppliesPurchaseItemDeleteResult"]: {
	__typename: "SuppliesPurchaseItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SuppliesPurchaseItem"] | undefined
};
	["SuppliesPurchaseItemUpdateResult"]: {
	__typename: "SuppliesPurchaseItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SuppliesPurchaseItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SuppliesPurchaseItemUpsertResult"]: {
	__typename: "SuppliesPurchaseItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SuppliesPurchaseItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerCreditTransactionCreateResult"]: {
	__typename: "CustomerCreditTransactionCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerCreditTransaction"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerCreditTransactionDeleteResult"]: {
	__typename: "CustomerCreditTransactionDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerCreditTransaction"] | undefined
};
	["CustomerCreditTransactionUpdateResult"]: {
	__typename: "CustomerCreditTransactionUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerCreditTransaction"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerCreditTransactionUpsertResult"]: {
	__typename: "CustomerCreditTransactionUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerCreditTransaction"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VirtualProductCreateResult"]: {
	__typename: "VirtualProductCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VirtualProduct"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VirtualProductDeleteResult"]: {
	__typename: "VirtualProductDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VirtualProduct"] | undefined
};
	["VirtualProductUpdateResult"]: {
	__typename: "VirtualProductUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VirtualProduct"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VirtualProductUpsertResult"]: {
	__typename: "VirtualProductUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VirtualProduct"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VirtualProductEffectCreateResult"]: {
	__typename: "VirtualProductEffectCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VirtualProductEffect"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VirtualProductEffectDeleteResult"]: {
	__typename: "VirtualProductEffectDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VirtualProductEffect"] | undefined
};
	["VirtualProductEffectUpdateResult"]: {
	__typename: "VirtualProductEffectUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VirtualProductEffect"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VirtualProductEffectUpsertResult"]: {
	__typename: "VirtualProductEffectUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VirtualProductEffect"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["EmploymentInformationCreateResult"]: {
	__typename: "EmploymentInformationCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EmploymentInformation"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["EmploymentInformationDeleteResult"]: {
	__typename: "EmploymentInformationDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EmploymentInformation"] | undefined
};
	["EmploymentInformationUpdateResult"]: {
	__typename: "EmploymentInformationUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EmploymentInformation"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["EmploymentInformationUpsertResult"]: {
	__typename: "EmploymentInformationUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EmploymentInformation"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RemunerationProfileCreateResult"]: {
	__typename: "RemunerationProfileCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RemunerationProfile"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RemunerationProfileDeleteResult"]: {
	__typename: "RemunerationProfileDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RemunerationProfile"] | undefined
};
	["RemunerationProfileUpdateResult"]: {
	__typename: "RemunerationProfileUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RemunerationProfile"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RemunerationProfileUpsertResult"]: {
	__typename: "RemunerationProfileUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RemunerationProfile"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["WorkMonthCreateResult"]: {
	__typename: "WorkMonthCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["WorkMonth"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["WorkMonthDeleteResult"]: {
	__typename: "WorkMonthDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["WorkMonth"] | undefined
};
	["WorkMonthUpdateResult"]: {
	__typename: "WorkMonthUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["WorkMonth"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["WorkMonthUpsertResult"]: {
	__typename: "WorkMonthUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["WorkMonth"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SalaryOptionsCreateResult"]: {
	__typename: "SalaryOptionsCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SalaryOptions"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SalaryOptionsDeleteResult"]: {
	__typename: "SalaryOptionsDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SalaryOptions"] | undefined
};
	["SalaryOptionsUpdateResult"]: {
	__typename: "SalaryOptionsUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SalaryOptions"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SalaryOptionsUpsertResult"]: {
	__typename: "SalaryOptionsUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SalaryOptions"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableShiftSwapInfoCreateResult"]: {
	__typename: "TimetableShiftSwapInfoCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableShiftSwapInfo"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableShiftSwapInfoDeleteResult"]: {
	__typename: "TimetableShiftSwapInfoDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableShiftSwapInfo"] | undefined
};
	["TimetableShiftSwapInfoUpdateResult"]: {
	__typename: "TimetableShiftSwapInfoUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableShiftSwapInfo"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableShiftSwapInfoUpsertResult"]: {
	__typename: "TimetableShiftSwapInfoUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableShiftSwapInfo"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductGridCategoryCreateResult"]: {
	__typename: "ProductGridCategoryCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGridCategory"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductGridCategoryDeleteResult"]: {
	__typename: "ProductGridCategoryDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGridCategory"] | undefined
};
	["ProductGridCategoryUpdateResult"]: {
	__typename: "ProductGridCategoryUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGridCategory"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductGridCategoryUpsertResult"]: {
	__typename: "ProductGridCategoryUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGridCategory"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CashierCreateResult"]: {
	__typename: "CashierCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Cashier"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CashierDeleteResult"]: {
	__typename: "CashierDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Cashier"] | undefined
};
	["CashierUpdateResult"]: {
	__typename: "CashierUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Cashier"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CashierUpsertResult"]: {
	__typename: "CashierUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Cashier"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleCategoryCreateResult"]: {
	__typename: "PointOfSaleCategoryCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleCategory"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleCategoryDeleteResult"]: {
	__typename: "PointOfSaleCategoryDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleCategory"] | undefined
};
	["PointOfSaleCategoryUpdateResult"]: {
	__typename: "PointOfSaleCategoryUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleCategory"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleCategoryUpsertResult"]: {
	__typename: "PointOfSaleCategoryUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleCategory"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleCategoryLocaleCreateResult"]: {
	__typename: "PointOfSaleCategoryLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleCategoryLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleCategoryLocaleDeleteResult"]: {
	__typename: "PointOfSaleCategoryLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleCategoryLocale"] | undefined
};
	["PointOfSaleCategoryLocaleUpdateResult"]: {
	__typename: "PointOfSaleCategoryLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleCategoryLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleCategoryLocaleUpsertResult"]: {
	__typename: "PointOfSaleCategoryLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleCategoryLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleCategoryProductCreateResult"]: {
	__typename: "PointOfSaleCategoryProductCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleCategoryProduct"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleCategoryProductDeleteResult"]: {
	__typename: "PointOfSaleCategoryProductDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleCategoryProduct"] | undefined
};
	["PointOfSaleCategoryProductUpdateResult"]: {
	__typename: "PointOfSaleCategoryProductUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleCategoryProduct"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleCategoryProductUpsertResult"]: {
	__typename: "PointOfSaleCategoryProductUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleCategoryProduct"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleCategoryProductLocaleCreateResult"]: {
	__typename: "PointOfSaleCategoryProductLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleCategoryProductLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleCategoryProductLocaleDeleteResult"]: {
	__typename: "PointOfSaleCategoryProductLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleCategoryProductLocale"] | undefined
};
	["PointOfSaleCategoryProductLocaleUpdateResult"]: {
	__typename: "PointOfSaleCategoryProductLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleCategoryProductLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleCategoryProductLocaleUpsertResult"]: {
	__typename: "PointOfSaleCategoryProductLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleCategoryProductLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerTabCreateResult"]: {
	__typename: "CustomerTabCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerTab"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerTabDeleteResult"]: {
	__typename: "CustomerTabDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerTab"] | undefined
};
	["CustomerTabUpdateResult"]: {
	__typename: "CustomerTabUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerTab"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerTabUpsertResult"]: {
	__typename: "CustomerTabUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerTab"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerTabItemCreateResult"]: {
	__typename: "CustomerTabItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerTabItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerTabItemDeleteResult"]: {
	__typename: "CustomerTabItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerTabItem"] | undefined
};
	["CustomerTabItemUpdateResult"]: {
	__typename: "CustomerTabItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerTabItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CustomerTabItemUpsertResult"]: {
	__typename: "CustomerTabItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CustomerTabItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["AnonymousSessionCreateResult"]: {
	__typename: "AnonymousSessionCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AnonymousSession"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["AnonymousSessionDeleteResult"]: {
	__typename: "AnonymousSessionDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AnonymousSession"] | undefined
};
	["AnonymousSessionUpdateResult"]: {
	__typename: "AnonymousSessionUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AnonymousSession"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["AnonymousSessionUpsertResult"]: {
	__typename: "AnonymousSessionUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AnonymousSession"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VoucherCreateResult"]: {
	__typename: "VoucherCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Voucher"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VoucherDeleteResult"]: {
	__typename: "VoucherDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Voucher"] | undefined
};
	["VoucherUpdateResult"]: {
	__typename: "VoucherUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Voucher"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VoucherUpsertResult"]: {
	__typename: "VoucherUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Voucher"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VoucherRedemptionCreateResult"]: {
	__typename: "VoucherRedemptionCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VoucherRedemption"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VoucherRedemptionDeleteResult"]: {
	__typename: "VoucherRedemptionDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VoucherRedemption"] | undefined
};
	["VoucherRedemptionUpdateResult"]: {
	__typename: "VoucherRedemptionUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VoucherRedemption"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VoucherRedemptionUpsertResult"]: {
	__typename: "VoucherRedemptionUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VoucherRedemption"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UnassignedShiftInfoCreateResult"]: {
	__typename: "UnassignedShiftInfoCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UnassignedShiftInfo"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UnassignedShiftInfoDeleteResult"]: {
	__typename: "UnassignedShiftInfoDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UnassignedShiftInfo"] | undefined
};
	["UnassignedShiftInfoUpdateResult"]: {
	__typename: "UnassignedShiftInfoUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UnassignedShiftInfo"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UnassignedShiftInfoUpsertResult"]: {
	__typename: "UnassignedShiftInfoUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UnassignedShiftInfo"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FreshingContainerCreateResult"]: {
	__typename: "FreshingContainerCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FreshingContainer"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FreshingContainerDeleteResult"]: {
	__typename: "FreshingContainerDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FreshingContainer"] | undefined
};
	["FreshingContainerUpdateResult"]: {
	__typename: "FreshingContainerUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FreshingContainer"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FreshingContainerUpsertResult"]: {
	__typename: "FreshingContainerUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FreshingContainer"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextItemCreateResult"]: {
	__typename: "TextItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextItemDeleteResult"]: {
	__typename: "TextItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextItem"] | undefined
};
	["TextItemUpdateResult"]: {
	__typename: "TextItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextItemUpsertResult"]: {
	__typename: "TextItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextListCreateResult"]: {
	__typename: "TextListCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextListDeleteResult"]: {
	__typename: "TextListDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextList"] | undefined
};
	["TextListUpdateResult"]: {
	__typename: "TextListUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextListUpsertResult"]: {
	__typename: "TextListUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryRegionsCreateResult"]: {
	__typename: "DeliveryRegionsCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryRegions"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryRegionsDeleteResult"]: {
	__typename: "DeliveryRegionsDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryRegions"] | undefined
};
	["DeliveryRegionsUpdateResult"]: {
	__typename: "DeliveryRegionsUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryRegions"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryRegionsUpsertResult"]: {
	__typename: "DeliveryRegionsUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryRegions"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryRegionsItemCreateResult"]: {
	__typename: "DeliveryRegionsItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryRegionsItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryRegionsItemDeleteResult"]: {
	__typename: "DeliveryRegionsItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryRegionsItem"] | undefined
};
	["DeliveryRegionsItemUpdateResult"]: {
	__typename: "DeliveryRegionsItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryRegionsItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryRegionsItemUpsertResult"]: {
	__typename: "DeliveryRegionsItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryRegionsItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageListCreateResult"]: {
	__typename: "ImageListCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageListDeleteResult"]: {
	__typename: "ImageListDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageList"] | undefined
};
	["ImageListUpdateResult"]: {
	__typename: "ImageListUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageListUpsertResult"]: {
	__typename: "ImageListUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageListItemCreateResult"]: {
	__typename: "ImageListItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageListItemDeleteResult"]: {
	__typename: "ImageListItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageListItem"] | undefined
};
	["ImageListItemUpdateResult"]: {
	__typename: "ImageListItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageListItemUpsertResult"]: {
	__typename: "ImageListItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageListItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetablesEmployeePrivilegesCreateResult"]: {
	__typename: "TimetablesEmployeePrivilegesCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetablesEmployeePrivileges"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetablesEmployeePrivilegesDeleteResult"]: {
	__typename: "TimetablesEmployeePrivilegesDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetablesEmployeePrivileges"] | undefined
};
	["TimetablesEmployeePrivilegesUpdateResult"]: {
	__typename: "TimetablesEmployeePrivilegesUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetablesEmployeePrivileges"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetablesEmployeePrivilegesUpsertResult"]: {
	__typename: "TimetablesEmployeePrivilegesUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetablesEmployeePrivileges"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableDayNoteCreateResult"]: {
	__typename: "TimetableDayNoteCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableDayNote"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableDayNoteDeleteResult"]: {
	__typename: "TimetableDayNoteDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableDayNote"] | undefined
};
	["TimetableDayNoteUpdateResult"]: {
	__typename: "TimetableDayNoteUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableDayNote"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimetableDayNoteUpsertResult"]: {
	__typename: "TimetableDayNoteUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimetableDayNote"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryMethodLocaleCreateResult"]: {
	__typename: "DeliveryMethodLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryMethodLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryMethodLocaleDeleteResult"]: {
	__typename: "DeliveryMethodLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryMethodLocale"] | undefined
};
	["DeliveryMethodLocaleUpdateResult"]: {
	__typename: "DeliveryMethodLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryMethodLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeliveryMethodLocaleUpsertResult"]: {
	__typename: "DeliveryMethodLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeliveryMethodLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IngredientSupplierCreateResult"]: {
	__typename: "IngredientSupplierCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IngredientSupplier"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IngredientSupplierDeleteResult"]: {
	__typename: "IngredientSupplierDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IngredientSupplier"] | undefined
};
	["IngredientSupplierUpdateResult"]: {
	__typename: "IngredientSupplierUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IngredientSupplier"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IngredientSupplierUpsertResult"]: {
	__typename: "IngredientSupplierUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IngredientSupplier"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IngredientSupplierItemCreateResult"]: {
	__typename: "IngredientSupplierItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IngredientSupplierItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IngredientSupplierItemDeleteResult"]: {
	__typename: "IngredientSupplierItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IngredientSupplierItem"] | undefined
};
	["IngredientSupplierItemUpdateResult"]: {
	__typename: "IngredientSupplierItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IngredientSupplierItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IngredientSupplierItemUpsertResult"]: {
	__typename: "IngredientSupplierItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IngredientSupplierItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IngredientSupplierListCreateResult"]: {
	__typename: "IngredientSupplierListCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IngredientSupplierList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IngredientSupplierListDeleteResult"]: {
	__typename: "IngredientSupplierListDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IngredientSupplierList"] | undefined
};
	["IngredientSupplierListUpdateResult"]: {
	__typename: "IngredientSupplierListUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IngredientSupplierList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IngredientSupplierListUpsertResult"]: {
	__typename: "IngredientSupplierListUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IngredientSupplierList"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IngredientSupplierLocaleCreateResult"]: {
	__typename: "IngredientSupplierLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IngredientSupplierLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IngredientSupplierLocaleDeleteResult"]: {
	__typename: "IngredientSupplierLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IngredientSupplierLocale"] | undefined
};
	["IngredientSupplierLocaleUpdateResult"]: {
	__typename: "IngredientSupplierLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IngredientSupplierLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IngredientSupplierLocaleUpsertResult"]: {
	__typename: "IngredientSupplierLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IngredientSupplierLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RedirectCreateResult"]: {
	__typename: "RedirectCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Redirect"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RedirectDeleteResult"]: {
	__typename: "RedirectDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Redirect"] | undefined
};
	["RedirectUpdateResult"]: {
	__typename: "RedirectUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Redirect"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RedirectUpsertResult"]: {
	__typename: "RedirectUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Redirect"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["NutritionFactsCreateResult"]: {
	__typename: "NutritionFactsCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NutritionFacts"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["NutritionFactsDeleteResult"]: {
	__typename: "NutritionFactsDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NutritionFacts"] | undefined
};
	["NutritionFactsUpdateResult"]: {
	__typename: "NutritionFactsUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NutritionFacts"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["NutritionFactsUpsertResult"]: {
	__typename: "NutritionFactsUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NutritionFacts"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VenueCreateResult"]: {
	__typename: "VenueCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Venue"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VenueDeleteResult"]: {
	__typename: "VenueDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Venue"] | undefined
};
	["VenueUpdateResult"]: {
	__typename: "VenueUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Venue"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VenueUpsertResult"]: {
	__typename: "VenueUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Venue"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["WorkspaceCreateResult"]: {
	__typename: "WorkspaceCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Workspace"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["WorkspaceDeleteResult"]: {
	__typename: "WorkspaceDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Workspace"] | undefined
};
	["WorkspaceUpdateResult"]: {
	__typename: "WorkspaceUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Workspace"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["WorkspaceUpsertResult"]: {
	__typename: "WorkspaceUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Workspace"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InternalBuyerCreateResult"]: {
	__typename: "InternalBuyerCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InternalBuyer"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InternalBuyerDeleteResult"]: {
	__typename: "InternalBuyerDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InternalBuyer"] | undefined
};
	["InternalBuyerUpdateResult"]: {
	__typename: "InternalBuyerUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InternalBuyer"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["InternalBuyerUpsertResult"]: {
	__typename: "InternalBuyerUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InternalBuyer"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VenueEmployeeRoleCreateResult"]: {
	__typename: "VenueEmployeeRoleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VenueEmployeeRole"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VenueEmployeeRoleDeleteResult"]: {
	__typename: "VenueEmployeeRoleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VenueEmployeeRole"] | undefined
};
	["VenueEmployeeRoleUpdateResult"]: {
	__typename: "VenueEmployeeRoleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VenueEmployeeRole"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["VenueEmployeeRoleUpsertResult"]: {
	__typename: "VenueEmployeeRoleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["VenueEmployeeRole"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IdentificationAttemptCreateResult"]: {
	__typename: "IdentificationAttemptCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IdentificationAttempt"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IdentificationAttemptDeleteResult"]: {
	__typename: "IdentificationAttemptDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IdentificationAttempt"] | undefined
};
	["IdentificationAttemptUpdateResult"]: {
	__typename: "IdentificationAttemptUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IdentificationAttempt"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IdentificationAttemptUpsertResult"]: {
	__typename: "IdentificationAttemptUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IdentificationAttempt"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IdentificationCodeCreateResult"]: {
	__typename: "IdentificationCodeCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IdentificationCode"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IdentificationCodeDeleteResult"]: {
	__typename: "IdentificationCodeDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IdentificationCode"] | undefined
};
	["IdentificationCodeUpdateResult"]: {
	__typename: "IdentificationCodeUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IdentificationCode"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IdentificationCodeUpsertResult"]: {
	__typename: "IdentificationCodeUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IdentificationCode"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IdentificationCodeLocaleCreateResult"]: {
	__typename: "IdentificationCodeLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IdentificationCodeLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IdentificationCodeLocaleDeleteResult"]: {
	__typename: "IdentificationCodeLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IdentificationCodeLocale"] | undefined
};
	["IdentificationCodeLocaleUpdateResult"]: {
	__typename: "IdentificationCodeLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IdentificationCodeLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["IdentificationCodeLocaleUpsertResult"]: {
	__typename: "IdentificationCodeLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IdentificationCodeLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PipelineCreateResult"]: {
	__typename: "PipelineCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Pipeline"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PipelineDeleteResult"]: {
	__typename: "PipelineDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Pipeline"] | undefined
};
	["PipelineUpdateResult"]: {
	__typename: "PipelineUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Pipeline"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PipelineUpsertResult"]: {
	__typename: "PipelineUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Pipeline"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PipelineLeadCreateResult"]: {
	__typename: "PipelineLeadCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineLead"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PipelineLeadDeleteResult"]: {
	__typename: "PipelineLeadDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineLead"] | undefined
};
	["PipelineLeadUpdateResult"]: {
	__typename: "PipelineLeadUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineLead"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PipelineLeadUpsertResult"]: {
	__typename: "PipelineLeadUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineLead"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PipelineStageCreateResult"]: {
	__typename: "PipelineStageCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineStage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PipelineStageDeleteResult"]: {
	__typename: "PipelineStageDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineStage"] | undefined
};
	["PipelineStageUpdateResult"]: {
	__typename: "PipelineStageUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineStage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PipelineStageUpsertResult"]: {
	__typename: "PipelineStageUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineStage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PipelineStageItemCreateResult"]: {
	__typename: "PipelineStageItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineStageItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PipelineStageItemDeleteResult"]: {
	__typename: "PipelineStageItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineStageItem"] | undefined
};
	["PipelineStageItemUpdateResult"]: {
	__typename: "PipelineStageItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineStageItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PipelineStageItemUpsertResult"]: {
	__typename: "PipelineStageItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineStageItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PipelineStageLocaleCreateResult"]: {
	__typename: "PipelineStageLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineStageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PipelineStageLocaleDeleteResult"]: {
	__typename: "PipelineStageLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineStageLocale"] | undefined
};
	["PipelineStageLocaleUpdateResult"]: {
	__typename: "PipelineStageLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineStageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PipelineStageLocaleUpsertResult"]: {
	__typename: "PipelineStageLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineStageLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SalesManagerCreateResult"]: {
	__typename: "SalesManagerCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SalesManager"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SalesManagerDeleteResult"]: {
	__typename: "SalesManagerDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SalesManager"] | undefined
};
	["SalesManagerUpdateResult"]: {
	__typename: "SalesManagerUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SalesManager"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SalesManagerUpsertResult"]: {
	__typename: "SalesManagerUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SalesManager"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CashierManagerCreateResult"]: {
	__typename: "CashierManagerCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CashierManager"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CashierManagerDeleteResult"]: {
	__typename: "CashierManagerDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CashierManager"] | undefined
};
	["CashierManagerUpdateResult"]: {
	__typename: "CashierManagerUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CashierManager"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["CashierManagerUpsertResult"]: {
	__typename: "CashierManagerUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CashierManager"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleApplicationDeviceCreateResult"]: {
	__typename: "PointOfSaleApplicationDeviceCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleApplicationDevice"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleApplicationDeviceDeleteResult"]: {
	__typename: "PointOfSaleApplicationDeviceDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleApplicationDevice"] | undefined
};
	["PointOfSaleApplicationDeviceUpdateResult"]: {
	__typename: "PointOfSaleApplicationDeviceUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleApplicationDevice"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleApplicationDeviceUpsertResult"]: {
	__typename: "PointOfSaleApplicationDeviceUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleApplicationDevice"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleTerminalCreateResult"]: {
	__typename: "PointOfSaleTerminalCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleTerminal"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleTerminalDeleteResult"]: {
	__typename: "PointOfSaleTerminalDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleTerminal"] | undefined
};
	["PointOfSaleTerminalUpdateResult"]: {
	__typename: "PointOfSaleTerminalUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleTerminal"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSaleTerminalUpsertResult"]: {
	__typename: "PointOfSaleTerminalUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSaleTerminal"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PipelineStageSentimentCreateResult"]: {
	__typename: "PipelineStageSentimentCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineStageSentiment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PipelineStageSentimentDeleteResult"]: {
	__typename: "PipelineStageSentimentDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineStageSentiment"] | undefined
};
	["PipelineStageSentimentUpdateResult"]: {
	__typename: "PipelineStageSentimentUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineStageSentiment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PipelineStageSentimentUpsertResult"]: {
	__typename: "PipelineStageSentimentUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PipelineStageSentiment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeviceIdentifierCreateResult"]: {
	__typename: "DeviceIdentifierCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeviceIdentifier"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeviceIdentifierDeleteResult"]: {
	__typename: "DeviceIdentifierDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeviceIdentifier"] | undefined
};
	["DeviceIdentifierUpdateResult"]: {
	__typename: "DeviceIdentifierUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeviceIdentifier"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DeviceIdentifierUpsertResult"]: {
	__typename: "DeviceIdentifierUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DeviceIdentifier"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSalePrinterCreateResult"]: {
	__typename: "PointOfSalePrinterCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSalePrinter"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSalePrinterDeleteResult"]: {
	__typename: "PointOfSalePrinterDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSalePrinter"] | undefined
};
	["PointOfSalePrinterUpdateResult"]: {
	__typename: "PointOfSalePrinterUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSalePrinter"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PointOfSalePrinterUpsertResult"]: {
	__typename: "PointOfSalePrinterUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PointOfSalePrinter"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GratuityCreateResult"]: {
	__typename: "GratuityCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gratuity"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GratuityDeleteResult"]: {
	__typename: "GratuityDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gratuity"] | undefined
};
	["GratuityUpdateResult"]: {
	__typename: "GratuityUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gratuity"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GratuityUpsertResult"]: {
	__typename: "GratuityUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gratuity"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FulfillmentNoteCreateResult"]: {
	__typename: "FulfillmentNoteCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FulfillmentNote"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FulfillmentNoteDeleteResult"]: {
	__typename: "FulfillmentNoteDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FulfillmentNote"] | undefined
};
	["FulfillmentNoteUpdateResult"]: {
	__typename: "FulfillmentNoteUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FulfillmentNote"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FulfillmentNoteUpsertResult"]: {
	__typename: "FulfillmentNoteUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FulfillmentNote"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LeadFormCreateResult"]: {
	__typename: "LeadFormCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LeadForm"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LeadFormDeleteResult"]: {
	__typename: "LeadFormDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LeadForm"] | undefined
};
	["LeadFormUpdateResult"]: {
	__typename: "LeadFormUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LeadForm"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LeadFormUpsertResult"]: {
	__typename: "LeadFormUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LeadForm"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SubscriptionBoxCreateResult"]: {
	__typename: "SubscriptionBoxCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubscriptionBox"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SubscriptionBoxDeleteResult"]: {
	__typename: "SubscriptionBoxDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubscriptionBox"] | undefined
};
	["SubscriptionBoxUpdateResult"]: {
	__typename: "SubscriptionBoxUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubscriptionBox"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SubscriptionBoxUpsertResult"]: {
	__typename: "SubscriptionBoxUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubscriptionBox"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SubscriptionBoxLocaleCreateResult"]: {
	__typename: "SubscriptionBoxLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubscriptionBoxLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SubscriptionBoxLocaleDeleteResult"]: {
	__typename: "SubscriptionBoxLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubscriptionBoxLocale"] | undefined
};
	["SubscriptionBoxLocaleUpdateResult"]: {
	__typename: "SubscriptionBoxLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubscriptionBoxLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SubscriptionBoxLocaleUpsertResult"]: {
	__typename: "SubscriptionBoxLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubscriptionBoxLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessServiceCreateResult"]: {
	__typename: "BusinessServiceCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessService"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessServiceDeleteResult"]: {
	__typename: "BusinessServiceDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessService"] | undefined
};
	["BusinessServiceUpdateResult"]: {
	__typename: "BusinessServiceUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessService"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessServiceUpsertResult"]: {
	__typename: "BusinessServiceUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessService"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessServiceEventCreateResult"]: {
	__typename: "BusinessServiceEventCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessServiceEvent"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessServiceEventDeleteResult"]: {
	__typename: "BusinessServiceEventDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessServiceEvent"] | undefined
};
	["BusinessServiceEventUpdateResult"]: {
	__typename: "BusinessServiceEventUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessServiceEvent"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessServiceEventUpsertResult"]: {
	__typename: "BusinessServiceEventUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessServiceEvent"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessServiceLocaleCreateResult"]: {
	__typename: "BusinessServiceLocaleCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessServiceLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessServiceLocaleDeleteResult"]: {
	__typename: "BusinessServiceLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessServiceLocale"] | undefined
};
	["BusinessServiceLocaleUpdateResult"]: {
	__typename: "BusinessServiceLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessServiceLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessServiceLocaleUpsertResult"]: {
	__typename: "BusinessServiceLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessServiceLocale"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GridTileItemCreateResult"]: {
	__typename: "GridTileItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GridTileItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GridTileItemDeleteResult"]: {
	__typename: "GridTileItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GridTileItem"] | undefined
};
	["GridTileItemUpdateResult"]: {
	__typename: "GridTileItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GridTileItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GridTileItemUpsertResult"]: {
	__typename: "GridTileItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GridTileItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GridTilesCreateResult"]: {
	__typename: "GridTilesCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GridTiles"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GridTilesDeleteResult"]: {
	__typename: "GridTilesDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GridTiles"] | undefined
};
	["GridTilesUpdateResult"]: {
	__typename: "GridTilesUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GridTiles"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["GridTilesUpsertResult"]: {
	__typename: "GridTilesUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GridTiles"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["AreaCreateResult"]: {
	__typename: "AreaCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Area"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["AreaDeleteResult"]: {
	__typename: "AreaDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Area"] | undefined
};
	["AreaUpdateResult"]: {
	__typename: "AreaUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Area"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["AreaUpsertResult"]: {
	__typename: "AreaUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Area"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PositionCreateResult"]: {
	__typename: "PositionCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Position"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PositionDeleteResult"]: {
	__typename: "PositionDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Position"] | undefined
};
	["PositionUpdateResult"]: {
	__typename: "PositionUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Position"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["PositionUpsertResult"]: {
	__typename: "PositionUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Position"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StatsEnabledWidgetTypeCreateResult"]: {
	__typename: "StatsEnabledWidgetTypeCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StatsEnabledWidgetType"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StatsEnabledWidgetTypeDeleteResult"]: {
	__typename: "StatsEnabledWidgetTypeDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StatsEnabledWidgetType"] | undefined
};
	["StatsEnabledWidgetTypeUpdateResult"]: {
	__typename: "StatsEnabledWidgetTypeUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StatsEnabledWidgetType"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StatsEnabledWidgetTypeUpsertResult"]: {
	__typename: "StatsEnabledWidgetTypeUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StatsEnabledWidgetType"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StatsWidgetCreateResult"]: {
	__typename: "StatsWidgetCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StatsWidget"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StatsWidgetDeleteResult"]: {
	__typename: "StatsWidgetDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StatsWidget"] | undefined
};
	["StatsWidgetUpdateResult"]: {
	__typename: "StatsWidgetUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StatsWidget"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StatsWidgetUpsertResult"]: {
	__typename: "StatsWidgetUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StatsWidget"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StatsWidgetsLayoutCreateResult"]: {
	__typename: "StatsWidgetsLayoutCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StatsWidgetsLayout"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StatsWidgetsLayoutDeleteResult"]: {
	__typename: "StatsWidgetsLayoutDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StatsWidgetsLayout"] | undefined
};
	["StatsWidgetsLayoutUpdateResult"]: {
	__typename: "StatsWidgetsLayoutUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StatsWidgetsLayout"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StatsWidgetsLayoutUpsertResult"]: {
	__typename: "StatsWidgetsLayoutUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StatsWidgetsLayout"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeatCreateResult"]: {
	__typename: "SeatCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seat"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeatDeleteResult"]: {
	__typename: "SeatDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seat"] | undefined
};
	["SeatUpdateResult"]: {
	__typename: "SeatUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seat"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeatUpsertResult"]: {
	__typename: "SeatUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seat"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TableCreateResult"]: {
	__typename: "TableCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Table"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TableDeleteResult"]: {
	__typename: "TableDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Table"] | undefined
};
	["TableUpdateResult"]: {
	__typename: "TableUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Table"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["TableUpsertResult"]: {
	__typename: "TableUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Table"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StatsPageCreateResult"]: {
	__typename: "StatsPageCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StatsPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StatsPageDeleteResult"]: {
	__typename: "StatsPageDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StatsPage"] | undefined
};
	["StatsPageUpdateResult"]: {
	__typename: "StatsPageUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StatsPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["StatsPageUpsertResult"]: {
	__typename: "StatsPageUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StatsPage"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UnassignReasonCreateResult"]: {
	__typename: "UnassignReasonCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UnassignReason"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UnassignReasonDeleteResult"]: {
	__typename: "UnassignReasonDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UnassignReason"] | undefined
};
	["UnassignReasonUpdateResult"]: {
	__typename: "UnassignReasonUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UnassignReason"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["UnassignReasonUpsertResult"]: {
	__typename: "UnassignReasonUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UnassignReason"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DoubleshotCoffeeEquipmentCreateResult"]: {
	__typename: "DoubleshotCoffeeEquipmentCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DoubleshotCoffeeEquipment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DoubleshotCoffeeEquipmentDeleteResult"]: {
	__typename: "DoubleshotCoffeeEquipmentDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DoubleshotCoffeeEquipment"] | undefined
};
	["DoubleshotCoffeeEquipmentUpdateResult"]: {
	__typename: "DoubleshotCoffeeEquipmentUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DoubleshotCoffeeEquipment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["DoubleshotCoffeeEquipmentUpsertResult"]: {
	__typename: "DoubleshotCoffeeEquipmentUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DoubleshotCoffeeEquipment"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ExpenseCreateResult"]: {
	__typename: "ExpenseCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Expense"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ExpenseDeleteResult"]: {
	__typename: "ExpenseDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Expense"] | undefined
};
	["ExpenseUpdateResult"]: {
	__typename: "ExpenseUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Expense"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ExpenseUpsertResult"]: {
	__typename: "ExpenseUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Expense"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ExpenseCategoryCreateResult"]: {
	__typename: "ExpenseCategoryCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ExpenseCategory"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ExpenseCategoryDeleteResult"]: {
	__typename: "ExpenseCategoryDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ExpenseCategory"] | undefined
};
	["ExpenseCategoryUpdateResult"]: {
	__typename: "ExpenseCategoryUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ExpenseCategory"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ExpenseCategoryUpsertResult"]: {
	__typename: "ExpenseCategoryUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ExpenseCategory"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ExpenseChangeCreateResult"]: {
	__typename: "ExpenseChangeCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ExpenseChange"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ExpenseChangeDeleteResult"]: {
	__typename: "ExpenseChangeDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ExpenseChange"] | undefined
};
	["ExpenseChangeUpdateResult"]: {
	__typename: "ExpenseChangeUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ExpenseChange"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ExpenseChangeUpsertResult"]: {
	__typename: "ExpenseChangeUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ExpenseChange"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ExpenseDocumentCreateResult"]: {
	__typename: "ExpenseDocumentCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ExpenseDocument"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ExpenseDocumentDeleteResult"]: {
	__typename: "ExpenseDocumentDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ExpenseDocument"] | undefined
};
	["ExpenseDocumentUpdateResult"]: {
	__typename: "ExpenseDocumentUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ExpenseDocument"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["ExpenseDocumentUpsertResult"]: {
	__typename: "ExpenseDocumentUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ExpenseDocument"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RevenuePredictionCreateResult"]: {
	__typename: "RevenuePredictionCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RevenuePrediction"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RevenuePredictionDeleteResult"]: {
	__typename: "RevenuePredictionDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RevenuePrediction"] | undefined
};
	["RevenuePredictionUpdateResult"]: {
	__typename: "RevenuePredictionUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RevenuePrediction"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RevenuePredictionUpsertResult"]: {
	__typename: "RevenuePredictionUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RevenuePrediction"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RevenuePredictionChangeCreateResult"]: {
	__typename: "RevenuePredictionChangeCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RevenuePredictionChange"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RevenuePredictionChangeDeleteResult"]: {
	__typename: "RevenuePredictionChangeDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RevenuePredictionChange"] | undefined
};
	["RevenuePredictionChangeUpdateResult"]: {
	__typename: "RevenuePredictionChangeUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RevenuePredictionChange"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["RevenuePredictionChangeUpsertResult"]: {
	__typename: "RevenuePredictionChangeUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RevenuePredictionChange"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FileCreateResult"]: {
	__typename: "FileCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["File"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FileDeleteResult"]: {
	__typename: "FileDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["File"] | undefined
};
	["FileUpdateResult"]: {
	__typename: "FileUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["File"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FileUpsertResult"]: {
	__typename: "FileUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["File"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LineCreateResult"]: {
	__typename: "LineCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Line"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LineDeleteResult"]: {
	__typename: "LineDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Line"] | undefined
};
	["LineUpdateResult"]: {
	__typename: "LineUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Line"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["LineUpsertResult"]: {
	__typename: "LineUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Line"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FinancesBalanceItemCreateResult"]: {
	__typename: "FinancesBalanceItemCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FinancesBalanceItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FinancesBalanceItemDeleteResult"]: {
	__typename: "FinancesBalanceItemDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FinancesBalanceItem"] | undefined
};
	["FinancesBalanceItemUpdateResult"]: {
	__typename: "FinancesBalanceItemUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FinancesBalanceItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["FinancesBalanceItemUpsertResult"]: {
	__typename: "FinancesBalanceItemUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FinancesBalanceItem"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["WoltDriveDeliveryCreateResult"]: {
	__typename: "WoltDriveDeliveryCreateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["WoltDriveDelivery"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["WoltDriveDeliveryDeleteResult"]: {
	__typename: "WoltDriveDeliveryDeleteResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["WoltDriveDelivery"] | undefined
};
	["WoltDriveDeliveryUpdateResult"]: {
	__typename: "WoltDriveDeliveryUpdateResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["WoltDriveDelivery"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["WoltDriveDeliveryUpsertResult"]: {
	__typename: "WoltDriveDeliveryUpsertResult",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["WoltDriveDelivery"] | undefined,
	validation: GraphQLTypes["_ValidationResult"]
};
	["MutationTransaction"]: {
	__typename: "MutationTransaction",
	ok: boolean,
	errorMessage?: string | undefined,
	errors: Array<GraphQLTypes["_MutationError"]>,
	validation: GraphQLTypes["_ValidationResult"],
	createAddress: GraphQLTypes["AddressCreateResult"],
	deleteAddress: GraphQLTypes["AddressDeleteResult"],
	updateAddress: GraphQLTypes["AddressUpdateResult"],
	upsertAddress: GraphQLTypes["AddressUpsertResult"],
	createCountry: GraphQLTypes["CountryCreateResult"],
	deleteCountry: GraphQLTypes["CountryDeleteResult"],
	updateCountry: GraphQLTypes["CountryUpdateResult"],
	upsertCountry: GraphQLTypes["CountryUpsertResult"],
	createChannel: GraphQLTypes["ChannelCreateResult"],
	deleteChannel: GraphQLTypes["ChannelDeleteResult"],
	updateChannel: GraphQLTypes["ChannelUpdateResult"],
	upsertChannel: GraphQLTypes["ChannelUpsertResult"],
	createChannelPayment: GraphQLTypes["ChannelPaymentCreateResult"],
	deleteChannelPayment: GraphQLTypes["ChannelPaymentDeleteResult"],
	updateChannelPayment: GraphQLTypes["ChannelPaymentUpdateResult"],
	upsertChannelPayment: GraphQLTypes["ChannelPaymentUpsertResult"],
	createChannelDelivery: GraphQLTypes["ChannelDeliveryCreateResult"],
	deleteChannelDelivery: GraphQLTypes["ChannelDeliveryDeleteResult"],
	updateChannelDelivery: GraphQLTypes["ChannelDeliveryUpdateResult"],
	upsertChannelDelivery: GraphQLTypes["ChannelDeliveryUpsertResult"],
	createCustomer: GraphQLTypes["CustomerCreateResult"],
	deleteCustomer: GraphQLTypes["CustomerDeleteResult"],
	updateCustomer: GraphQLTypes["CustomerUpdateResult"],
	upsertCustomer: GraphQLTypes["CustomerUpsertResult"],
	createCustomerCredit: GraphQLTypes["CustomerCreditCreateResult"],
	deleteCustomerCredit: GraphQLTypes["CustomerCreditDeleteResult"],
	updateCustomerCredit: GraphQLTypes["CustomerCreditUpdateResult"],
	upsertCustomerCredit: GraphQLTypes["CustomerCreditUpsertResult"],
	createCustomerGroup: GraphQLTypes["CustomerGroupCreateResult"],
	deleteCustomerGroup: GraphQLTypes["CustomerGroupDeleteResult"],
	updateCustomerGroup: GraphQLTypes["CustomerGroupUpdateResult"],
	upsertCustomerGroup: GraphQLTypes["CustomerGroupUpsertResult"],
	createCustomerPaymentMethod: GraphQLTypes["CustomerPaymentMethodCreateResult"],
	deleteCustomerPaymentMethod: GraphQLTypes["CustomerPaymentMethodDeleteResult"],
	updateCustomerPaymentMethod: GraphQLTypes["CustomerPaymentMethodUpdateResult"],
	upsertCustomerPaymentMethod: GraphQLTypes["CustomerPaymentMethodUpsertResult"],
	createDeliveryMethod: GraphQLTypes["DeliveryMethodCreateResult"],
	deleteDeliveryMethod: GraphQLTypes["DeliveryMethodDeleteResult"],
	updateDeliveryMethod: GraphQLTypes["DeliveryMethodUpdateResult"],
	upsertDeliveryMethod: GraphQLTypes["DeliveryMethodUpsertResult"],
	createOrder: GraphQLTypes["OrderCreateResult"],
	deleteOrder: GraphQLTypes["OrderDeleteResult"],
	updateOrder: GraphQLTypes["OrderUpdateResult"],
	upsertOrder: GraphQLTypes["OrderUpsertResult"],
	createOrderDiscount: GraphQLTypes["OrderDiscountCreateResult"],
	deleteOrderDiscount: GraphQLTypes["OrderDiscountDeleteResult"],
	updateOrderDiscount: GraphQLTypes["OrderDiscountUpdateResult"],
	upsertOrderDiscount: GraphQLTypes["OrderDiscountUpsertResult"],
	createOrderPayment: GraphQLTypes["OrderPaymentCreateResult"],
	deleteOrderPayment: GraphQLTypes["OrderPaymentDeleteResult"],
	updateOrderPayment: GraphQLTypes["OrderPaymentUpdateResult"],
	upsertOrderPayment: GraphQLTypes["OrderPaymentUpsertResult"],
	createOrderDelivery: GraphQLTypes["OrderDeliveryCreateResult"],
	deleteOrderDelivery: GraphQLTypes["OrderDeliveryDeleteResult"],
	updateOrderDelivery: GraphQLTypes["OrderDeliveryUpdateResult"],
	upsertOrderDelivery: GraphQLTypes["OrderDeliveryUpsertResult"],
	createOrderItem: GraphQLTypes["OrderItemCreateResult"],
	deleteOrderItem: GraphQLTypes["OrderItemDeleteResult"],
	updateOrderItem: GraphQLTypes["OrderItemUpdateResult"],
	upsertOrderItem: GraphQLTypes["OrderItemUpsertResult"],
	createPaymentMethod: GraphQLTypes["PaymentMethodCreateResult"],
	deletePaymentMethod: GraphQLTypes["PaymentMethodDeleteResult"],
	updatePaymentMethod: GraphQLTypes["PaymentMethodUpdateResult"],
	upsertPaymentMethod: GraphQLTypes["PaymentMethodUpsertResult"],
	createVatRate: GraphQLTypes["VatRateCreateResult"],
	deleteVatRate: GraphQLTypes["VatRateDeleteResult"],
	updateVatRate: GraphQLTypes["VatRateUpdateResult"],
	upsertVatRate: GraphQLTypes["VatRateUpsertResult"],
	createProduct: GraphQLTypes["ProductCreateResult"],
	deleteProduct: GraphQLTypes["ProductDeleteResult"],
	updateProduct: GraphQLTypes["ProductUpdateResult"],
	upsertProduct: GraphQLTypes["ProductUpsertResult"],
	createProductStock: GraphQLTypes["ProductStockCreateResult"],
	deleteProductStock: GraphQLTypes["ProductStockDeleteResult"],
	updateProductStock: GraphQLTypes["ProductStockUpdateResult"],
	upsertProductStock: GraphQLTypes["ProductStockUpsertResult"],
	createProductPacking: GraphQLTypes["ProductPackingCreateResult"],
	deleteProductPacking: GraphQLTypes["ProductPackingDeleteResult"],
	updateProductPacking: GraphQLTypes["ProductPackingUpdateResult"],
	upsertProductPacking: GraphQLTypes["ProductPackingUpsertResult"],
	createProductGroupPrice: GraphQLTypes["ProductGroupPriceCreateResult"],
	deleteProductGroupPrice: GraphQLTypes["ProductGroupPriceDeleteResult"],
	updateProductGroupPrice: GraphQLTypes["ProductGroupPriceUpdateResult"],
	upsertProductGroupPrice: GraphQLTypes["ProductGroupPriceUpsertResult"],
	createProductRecipe: GraphQLTypes["ProductRecipeCreateResult"],
	deleteProductRecipe: GraphQLTypes["ProductRecipeDeleteResult"],
	updateProductRecipe: GraphQLTypes["ProductRecipeUpdateResult"],
	upsertProductRecipe: GraphQLTypes["ProductRecipeUpsertResult"],
	createProductCategory: GraphQLTypes["ProductCategoryCreateResult"],
	deleteProductCategory: GraphQLTypes["ProductCategoryDeleteResult"],
	updateProductCategory: GraphQLTypes["ProductCategoryUpdateResult"],
	upsertProductCategory: GraphQLTypes["ProductCategoryUpsertResult"],
	createStore: GraphQLTypes["StoreCreateResult"],
	deleteStore: GraphQLTypes["StoreDeleteResult"],
	updateStore: GraphQLTypes["StoreUpdateResult"],
	upsertStore: GraphQLTypes["StoreUpsertResult"],
	createTag: GraphQLTypes["TagCreateResult"],
	deleteTag: GraphQLTypes["TagDeleteResult"],
	updateTag: GraphQLTypes["TagUpdateResult"],
	upsertTag: GraphQLTypes["TagUpsertResult"],
	createImage: GraphQLTypes["ImageCreateResult"],
	deleteImage: GraphQLTypes["ImageDeleteResult"],
	updateImage: GraphQLTypes["ImageUpdateResult"],
	upsertImage: GraphQLTypes["ImageUpsertResult"],
	createBusinessCategory: GraphQLTypes["BusinessCategoryCreateResult"],
	deleteBusinessCategory: GraphQLTypes["BusinessCategoryDeleteResult"],
	updateBusinessCategory: GraphQLTypes["BusinessCategoryUpdateResult"],
	upsertBusinessCategory: GraphQLTypes["BusinessCategoryUpsertResult"],
	createProductList: GraphQLTypes["ProductListCreateResult"],
	deleteProductList: GraphQLTypes["ProductListDeleteResult"],
	updateProductList: GraphQLTypes["ProductListUpdateResult"],
	upsertProductList: GraphQLTypes["ProductListUpsertResult"],
	createProductListItem: GraphQLTypes["ProductListItemCreateResult"],
	deleteProductListItem: GraphQLTypes["ProductListItemDeleteResult"],
	updateProductListItem: GraphQLTypes["ProductListItemUpdateResult"],
	upsertProductListItem: GraphQLTypes["ProductListItemUpsertResult"],
	createProductCategoryList: GraphQLTypes["ProductCategoryListCreateResult"],
	deleteProductCategoryList: GraphQLTypes["ProductCategoryListDeleteResult"],
	updateProductCategoryList: GraphQLTypes["ProductCategoryListUpdateResult"],
	upsertProductCategoryList: GraphQLTypes["ProductCategoryListUpsertResult"],
	createProductCategoryListItem: GraphQLTypes["ProductCategoryListItemCreateResult"],
	deleteProductCategoryListItem: GraphQLTypes["ProductCategoryListItemDeleteResult"],
	updateProductCategoryListItem: GraphQLTypes["ProductCategoryListItemUpdateResult"],
	upsertProductCategoryListItem: GraphQLTypes["ProductCategoryListItemUpsertResult"],
	createBusinessCategoryLocale: GraphQLTypes["BusinessCategoryLocaleCreateResult"],
	deleteBusinessCategoryLocale: GraphQLTypes["BusinessCategoryLocaleDeleteResult"],
	updateBusinessCategoryLocale: GraphQLTypes["BusinessCategoryLocaleUpdateResult"],
	upsertBusinessCategoryLocale: GraphQLTypes["BusinessCategoryLocaleUpsertResult"],
	createLocale: GraphQLTypes["LocaleCreateResult"],
	deleteLocale: GraphQLTypes["LocaleDeleteResult"],
	updateLocale: GraphQLTypes["LocaleUpdateResult"],
	upsertLocale: GraphQLTypes["LocaleUpsertResult"],
	createProductCategoryListLocale: GraphQLTypes["ProductCategoryListLocaleCreateResult"],
	deleteProductCategoryListLocale: GraphQLTypes["ProductCategoryListLocaleDeleteResult"],
	updateProductCategoryListLocale: GraphQLTypes["ProductCategoryListLocaleUpdateResult"],
	upsertProductCategoryListLocale: GraphQLTypes["ProductCategoryListLocaleUpsertResult"],
	createCustomerName: GraphQLTypes["CustomerNameCreateResult"],
	deleteCustomerName: GraphQLTypes["CustomerNameDeleteResult"],
	updateCustomerName: GraphQLTypes["CustomerNameUpdateResult"],
	upsertCustomerName: GraphQLTypes["CustomerNameUpsertResult"],
	createCustomerAlias: GraphQLTypes["CustomerAliasCreateResult"],
	deleteCustomerAlias: GraphQLTypes["CustomerAliasDeleteResult"],
	updateCustomerAlias: GraphQLTypes["CustomerAliasUpdateResult"],
	upsertCustomerAlias: GraphQLTypes["CustomerAliasUpsertResult"],
	createProductIngredientItem: GraphQLTypes["ProductIngredientItemCreateResult"],
	deleteProductIngredientItem: GraphQLTypes["ProductIngredientItemDeleteResult"],
	updateProductIngredientItem: GraphQLTypes["ProductIngredientItemUpdateResult"],
	upsertProductIngredientItem: GraphQLTypes["ProductIngredientItemUpsertResult"],
	createProductIngredientItemQuantity: GraphQLTypes["ProductIngredientItemQuantityCreateResult"],
	deleteProductIngredientItemQuantity: GraphQLTypes["ProductIngredientItemQuantityDeleteResult"],
	updateProductIngredientItemQuantity: GraphQLTypes["ProductIngredientItemQuantityUpdateResult"],
	upsertProductIngredientItemQuantity: GraphQLTypes["ProductIngredientItemQuantityUpsertResult"],
	createProductIngredientItemQuantityUnit: GraphQLTypes["ProductIngredientItemQuantityUnitCreateResult"],
	deleteProductIngredientItemQuantityUnit: GraphQLTypes["ProductIngredientItemQuantityUnitDeleteResult"],
	updateProductIngredientItemQuantityUnit: GraphQLTypes["ProductIngredientItemQuantityUnitUpdateResult"],
	upsertProductIngredientItemQuantityUnit: GraphQLTypes["ProductIngredientItemQuantityUnitUpsertResult"],
	createProductIngredient: GraphQLTypes["ProductIngredientCreateResult"],
	deleteProductIngredient: GraphQLTypes["ProductIngredientDeleteResult"],
	updateProductIngredient: GraphQLTypes["ProductIngredientUpdateResult"],
	upsertProductIngredient: GraphQLTypes["ProductIngredientUpsertResult"],
	createCustomerIngredientRating: GraphQLTypes["CustomerIngredientRatingCreateResult"],
	deleteCustomerIngredientRating: GraphQLTypes["CustomerIngredientRatingDeleteResult"],
	updateCustomerIngredientRating: GraphQLTypes["CustomerIngredientRatingUpdateResult"],
	upsertCustomerIngredientRating: GraphQLTypes["CustomerIngredientRatingUpsertResult"],
	createProductIngredientRating: GraphQLTypes["ProductIngredientRatingCreateResult"],
	deleteProductIngredientRating: GraphQLTypes["ProductIngredientRatingDeleteResult"],
	updateProductIngredientRating: GraphQLTypes["ProductIngredientRatingUpdateResult"],
	upsertProductIngredientRating: GraphQLTypes["ProductIngredientRatingUpsertResult"],
	createProductIngredientLocale: GraphQLTypes["ProductIngredientLocaleCreateResult"],
	deleteProductIngredientLocale: GraphQLTypes["ProductIngredientLocaleDeleteResult"],
	updateProductIngredientLocale: GraphQLTypes["ProductIngredientLocaleUpdateResult"],
	upsertProductIngredientLocale: GraphQLTypes["ProductIngredientLocaleUpsertResult"],
	createOrderRecurrence: GraphQLTypes["OrderRecurrenceCreateResult"],
	deleteOrderRecurrence: GraphQLTypes["OrderRecurrenceDeleteResult"],
	updateOrderRecurrence: GraphQLTypes["OrderRecurrenceUpdateResult"],
	upsertOrderRecurrence: GraphQLTypes["OrderRecurrenceUpsertResult"],
	createOrderRecurrenceLocale: GraphQLTypes["OrderRecurrenceLocaleCreateResult"],
	deleteOrderRecurrenceLocale: GraphQLTypes["OrderRecurrenceLocaleDeleteResult"],
	updateOrderRecurrenceLocale: GraphQLTypes["OrderRecurrenceLocaleUpdateResult"],
	upsertOrderRecurrenceLocale: GraphQLTypes["OrderRecurrenceLocaleUpsertResult"],
	createBusinessCustomer: GraphQLTypes["BusinessCustomerCreateResult"],
	deleteBusinessCustomer: GraphQLTypes["BusinessCustomerDeleteResult"],
	updateBusinessCustomer: GraphQLTypes["BusinessCustomerUpdateResult"],
	upsertBusinessCustomer: GraphQLTypes["BusinessCustomerUpsertResult"],
	createPointOfSale: GraphQLTypes["PointOfSaleCreateResult"],
	deletePointOfSale: GraphQLTypes["PointOfSaleDeleteResult"],
	updatePointOfSale: GraphQLTypes["PointOfSaleUpdateResult"],
	upsertPointOfSale: GraphQLTypes["PointOfSaleUpsertResult"],
	createStaff: GraphQLTypes["StaffCreateResult"],
	deleteStaff: GraphQLTypes["StaffDeleteResult"],
	updateStaff: GraphQLTypes["StaffUpdateResult"],
	upsertStaff: GraphQLTypes["StaffUpsertResult"],
	createBlog: GraphQLTypes["BlogCreateResult"],
	deleteBlog: GraphQLTypes["BlogDeleteResult"],
	updateBlog: GraphQLTypes["BlogUpdateResult"],
	upsertBlog: GraphQLTypes["BlogUpsertResult"],
	createBlogLocale: GraphQLTypes["BlogLocaleCreateResult"],
	deleteBlogLocale: GraphQLTypes["BlogLocaleDeleteResult"],
	updateBlogLocale: GraphQLTypes["BlogLocaleUpdateResult"],
	upsertBlogLocale: GraphQLTypes["BlogLocaleUpsertResult"],
	createBlogPost: GraphQLTypes["BlogPostCreateResult"],
	deleteBlogPost: GraphQLTypes["BlogPostDeleteResult"],
	updateBlogPost: GraphQLTypes["BlogPostUpdateResult"],
	upsertBlogPost: GraphQLTypes["BlogPostUpsertResult"],
	createBlogPostLocale: GraphQLTypes["BlogPostLocaleCreateResult"],
	deleteBlogPostLocale: GraphQLTypes["BlogPostLocaleDeleteResult"],
	updateBlogPostLocale: GraphQLTypes["BlogPostLocaleUpdateResult"],
	upsertBlogPostLocale: GraphQLTypes["BlogPostLocaleUpsertResult"],
	createColorPallete: GraphQLTypes["ColorPalleteCreateResult"],
	deleteColorPallete: GraphQLTypes["ColorPalleteDeleteResult"],
	updateColorPallete: GraphQLTypes["ColorPalleteUpdateResult"],
	upsertColorPallete: GraphQLTypes["ColorPalleteUpsertResult"],
	createContent: GraphQLTypes["ContentCreateResult"],
	deleteContent: GraphQLTypes["ContentDeleteResult"],
	updateContent: GraphQLTypes["ContentUpdateResult"],
	upsertContent: GraphQLTypes["ContentUpsertResult"],
	createContentBlock: GraphQLTypes["ContentBlockCreateResult"],
	deleteContentBlock: GraphQLTypes["ContentBlockDeleteResult"],
	updateContentBlock: GraphQLTypes["ContentBlockUpdateResult"],
	upsertContentBlock: GraphQLTypes["ContentBlockUpsertResult"],
	createContentReference: GraphQLTypes["ContentReferenceCreateResult"],
	deleteContentReference: GraphQLTypes["ContentReferenceDeleteResult"],
	updateContentReference: GraphQLTypes["ContentReferenceUpdateResult"],
	upsertContentReference: GraphQLTypes["ContentReferenceUpsertResult"],
	createBlogPostList: GraphQLTypes["BlogPostListCreateResult"],
	deleteBlogPostList: GraphQLTypes["BlogPostListDeleteResult"],
	updateBlogPostList: GraphQLTypes["BlogPostListUpdateResult"],
	upsertBlogPostList: GraphQLTypes["BlogPostListUpsertResult"],
	createBlogPostListItem: GraphQLTypes["BlogPostListItemCreateResult"],
	deleteBlogPostListItem: GraphQLTypes["BlogPostListItemDeleteResult"],
	updateBlogPostListItem: GraphQLTypes["BlogPostListItemUpdateResult"],
	upsertBlogPostListItem: GraphQLTypes["BlogPostListItemUpsertResult"],
	createLinkList: GraphQLTypes["LinkListCreateResult"],
	deleteLinkList: GraphQLTypes["LinkListDeleteResult"],
	updateLinkList: GraphQLTypes["LinkListUpdateResult"],
	upsertLinkList: GraphQLTypes["LinkListUpsertResult"],
	createLinkListItem: GraphQLTypes["LinkListItemCreateResult"],
	deleteLinkListItem: GraphQLTypes["LinkListItemDeleteResult"],
	updateLinkListItem: GraphQLTypes["LinkListItemUpdateResult"],
	upsertLinkListItem: GraphQLTypes["LinkListItemUpsertResult"],
	createCover: GraphQLTypes["CoverCreateResult"],
	deleteCover: GraphQLTypes["CoverDeleteResult"],
	updateCover: GraphQLTypes["CoverUpdateResult"],
	upsertCover: GraphQLTypes["CoverUpsertResult"],
	createLink: GraphQLTypes["LinkCreateResult"],
	deleteLink: GraphQLTypes["LinkDeleteResult"],
	updateLink: GraphQLTypes["LinkUpdateResult"],
	upsertLink: GraphQLTypes["LinkUpsertResult"],
	createLinkable: GraphQLTypes["LinkableCreateResult"],
	deleteLinkable: GraphQLTypes["LinkableDeleteResult"],
	updateLinkable: GraphQLTypes["LinkableUpdateResult"],
	upsertLinkable: GraphQLTypes["LinkableUpsertResult"],
	createMedium: GraphQLTypes["MediumCreateResult"],
	deleteMedium: GraphQLTypes["MediumDeleteResult"],
	updateMedium: GraphQLTypes["MediumUpdateResult"],
	upsertMedium: GraphQLTypes["MediumUpsertResult"],
	createVideo: GraphQLTypes["VideoCreateResult"],
	deleteVideo: GraphQLTypes["VideoDeleteResult"],
	updateVideo: GraphQLTypes["VideoUpdateResult"],
	upsertVideo: GraphQLTypes["VideoUpsertResult"],
	createSeo: GraphQLTypes["SeoCreateResult"],
	deleteSeo: GraphQLTypes["SeoDeleteResult"],
	updateSeo: GraphQLTypes["SeoUpdateResult"],
	upsertSeo: GraphQLTypes["SeoUpsertResult"],
	createProtectedImage: GraphQLTypes["ProtectedImageCreateResult"],
	deleteProtectedImage: GraphQLTypes["ProtectedImageDeleteResult"],
	updateProtectedImage: GraphQLTypes["ProtectedImageUpdateResult"],
	upsertProtectedImage: GraphQLTypes["ProtectedImageUpsertResult"],
	createTranslationDomain: GraphQLTypes["TranslationDomainCreateResult"],
	deleteTranslationDomain: GraphQLTypes["TranslationDomainDeleteResult"],
	updateTranslationDomain: GraphQLTypes["TranslationDomainUpdateResult"],
	upsertTranslationDomain: GraphQLTypes["TranslationDomainUpsertResult"],
	createTranslationCatalogue: GraphQLTypes["TranslationCatalogueCreateResult"],
	deleteTranslationCatalogue: GraphQLTypes["TranslationCatalogueDeleteResult"],
	updateTranslationCatalogue: GraphQLTypes["TranslationCatalogueUpdateResult"],
	upsertTranslationCatalogue: GraphQLTypes["TranslationCatalogueUpsertResult"],
	createTranslationKey: GraphQLTypes["TranslationKeyCreateResult"],
	deleteTranslationKey: GraphQLTypes["TranslationKeyDeleteResult"],
	updateTranslationKey: GraphQLTypes["TranslationKeyUpdateResult"],
	upsertTranslationKey: GraphQLTypes["TranslationKeyUpsertResult"],
	createTranslationValue: GraphQLTypes["TranslationValueCreateResult"],
	deleteTranslationValue: GraphQLTypes["TranslationValueDeleteResult"],
	updateTranslationValue: GraphQLTypes["TranslationValueUpdateResult"],
	upsertTranslationValue: GraphQLTypes["TranslationValueUpsertResult"],
	createTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierCreateResult"],
	deleteTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierDeleteResult"],
	updateTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierUpdateResult"],
	upsertTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierUpsertResult"],
	createSocialsAndApps: GraphQLTypes["SocialsAndAppsCreateResult"],
	deleteSocialsAndApps: GraphQLTypes["SocialsAndAppsDeleteResult"],
	updateSocialsAndApps: GraphQLTypes["SocialsAndAppsUpdateResult"],
	upsertSocialsAndApps: GraphQLTypes["SocialsAndAppsUpsertResult"],
	createProductGrid: GraphQLTypes["ProductGridCreateResult"],
	deleteProductGrid: GraphQLTypes["ProductGridDeleteResult"],
	updateProductGrid: GraphQLTypes["ProductGridUpdateResult"],
	upsertProductGrid: GraphQLTypes["ProductGridUpsertResult"],
	createProductGridItem: GraphQLTypes["ProductGridItemCreateResult"],
	deleteProductGridItem: GraphQLTypes["ProductGridItemDeleteResult"],
	updateProductGridItem: GraphQLTypes["ProductGridItemUpdateResult"],
	upsertProductGridItem: GraphQLTypes["ProductGridItemUpsertResult"],
	createGallery: GraphQLTypes["GalleryCreateResult"],
	deleteGallery: GraphQLTypes["GalleryDeleteResult"],
	updateGallery: GraphQLTypes["GalleryUpdateResult"],
	upsertGallery: GraphQLTypes["GalleryUpsertResult"],
	createGalleryItem: GraphQLTypes["GalleryItemCreateResult"],
	deleteGalleryItem: GraphQLTypes["GalleryItemDeleteResult"],
	updateGalleryItem: GraphQLTypes["GalleryItemUpdateResult"],
	upsertGalleryItem: GraphQLTypes["GalleryItemUpsertResult"],
	createHero: GraphQLTypes["HeroCreateResult"],
	deleteHero: GraphQLTypes["HeroDeleteResult"],
	updateHero: GraphQLTypes["HeroUpdateResult"],
	upsertHero: GraphQLTypes["HeroUpsertResult"],
	createSiteMenu: GraphQLTypes["SiteMenuCreateResult"],
	deleteSiteMenu: GraphQLTypes["SiteMenuDeleteResult"],
	updateSiteMenu: GraphQLTypes["SiteMenuUpdateResult"],
	upsertSiteMenu: GraphQLTypes["SiteMenuUpsertResult"],
	createMenuLocale: GraphQLTypes["MenuLocaleCreateResult"],
	deleteMenuLocale: GraphQLTypes["MenuLocaleDeleteResult"],
	updateMenuLocale: GraphQLTypes["MenuLocaleUpdateResult"],
	upsertMenuLocale: GraphQLTypes["MenuLocaleUpsertResult"],
	createMenuItem: GraphQLTypes["MenuItemCreateResult"],
	deleteMenuItem: GraphQLTypes["MenuItemDeleteResult"],
	updateMenuItem: GraphQLTypes["MenuItemUpdateResult"],
	upsertMenuItem: GraphQLTypes["MenuItemUpsertResult"],
	createPage: GraphQLTypes["PageCreateResult"],
	deletePage: GraphQLTypes["PageDeleteResult"],
	updatePage: GraphQLTypes["PageUpdateResult"],
	upsertPage: GraphQLTypes["PageUpsertResult"],
	createPageLocale: GraphQLTypes["PageLocaleCreateResult"],
	deletePageLocale: GraphQLTypes["PageLocaleDeleteResult"],
	updatePageLocale: GraphQLTypes["PageLocaleUpdateResult"],
	upsertPageLocale: GraphQLTypes["PageLocaleUpsertResult"],
	createWikiPage: GraphQLTypes["WikiPageCreateResult"],
	deleteWikiPage: GraphQLTypes["WikiPageDeleteResult"],
	updateWikiPage: GraphQLTypes["WikiPageUpdateResult"],
	upsertWikiPage: GraphQLTypes["WikiPageUpsertResult"],
	createMenuSubitem: GraphQLTypes["MenuSubitemCreateResult"],
	deleteMenuSubitem: GraphQLTypes["MenuSubitemDeleteResult"],
	updateMenuSubitem: GraphQLTypes["MenuSubitemUpdateResult"],
	upsertMenuSubitem: GraphQLTypes["MenuSubitemUpsertResult"],
	createMenuLinkList: GraphQLTypes["MenuLinkListCreateResult"],
	deleteMenuLinkList: GraphQLTypes["MenuLinkListDeleteResult"],
	updateMenuLinkList: GraphQLTypes["MenuLinkListUpdateResult"],
	upsertMenuLinkList: GraphQLTypes["MenuLinkListUpsertResult"],
	createMenuLinkItem: GraphQLTypes["MenuLinkItemCreateResult"],
	deleteMenuLinkItem: GraphQLTypes["MenuLinkItemDeleteResult"],
	updateMenuLinkItem: GraphQLTypes["MenuLinkItemUpdateResult"],
	upsertMenuLinkItem: GraphQLTypes["MenuLinkItemUpsertResult"],
	createMenuProducts: GraphQLTypes["MenuProductsCreateResult"],
	deleteMenuProducts: GraphQLTypes["MenuProductsDeleteResult"],
	updateMenuProducts: GraphQLTypes["MenuProductsUpdateResult"],
	upsertMenuProducts: GraphQLTypes["MenuProductsUpsertResult"],
	createMenuDelivery: GraphQLTypes["MenuDeliveryCreateResult"],
	deleteMenuDelivery: GraphQLTypes["MenuDeliveryDeleteResult"],
	updateMenuDelivery: GraphQLTypes["MenuDeliveryUpdateResult"],
	upsertMenuDelivery: GraphQLTypes["MenuDeliveryUpsertResult"],
	createMenuContact: GraphQLTypes["MenuContactCreateResult"],
	deleteMenuContact: GraphQLTypes["MenuContactDeleteResult"],
	updateMenuContact: GraphQLTypes["MenuContactUpdateResult"],
	upsertMenuContact: GraphQLTypes["MenuContactUpsertResult"],
	createDeadlineTemplate: GraphQLTypes["DeadlineTemplateCreateResult"],
	deleteDeadlineTemplate: GraphQLTypes["DeadlineTemplateDeleteResult"],
	updateDeadlineTemplate: GraphQLTypes["DeadlineTemplateUpdateResult"],
	upsertDeadlineTemplate: GraphQLTypes["DeadlineTemplateUpsertResult"],
	createEmployeeQueue: GraphQLTypes["EmployeeQueueCreateResult"],
	deleteEmployeeQueue: GraphQLTypes["EmployeeQueueDeleteResult"],
	updateEmployeeQueue: GraphQLTypes["EmployeeQueueUpdateResult"],
	upsertEmployeeQueue: GraphQLTypes["EmployeeQueueUpsertResult"],
	createTimetableDay: GraphQLTypes["TimetableDayCreateResult"],
	deleteTimetableDay: GraphQLTypes["TimetableDayDeleteResult"],
	updateTimetableDay: GraphQLTypes["TimetableDayUpdateResult"],
	upsertTimetableDay: GraphQLTypes["TimetableDayUpsertResult"],
	createTimetableEmployeeRole: GraphQLTypes["TimetableEmployeeRoleCreateResult"],
	deleteTimetableEmployeeRole: GraphQLTypes["TimetableEmployeeRoleDeleteResult"],
	updateTimetableEmployeeRole: GraphQLTypes["TimetableEmployeeRoleUpdateResult"],
	upsertTimetableEmployeeRole: GraphQLTypes["TimetableEmployeeRoleUpsertResult"],
	createTimetableShift: GraphQLTypes["TimetableShiftCreateResult"],
	deleteTimetableShift: GraphQLTypes["TimetableShiftDeleteResult"],
	updateTimetableShift: GraphQLTypes["TimetableShiftUpdateResult"],
	upsertTimetableShift: GraphQLTypes["TimetableShiftUpsertResult"],
	createTimetableShiftGroup: GraphQLTypes["TimetableShiftGroupCreateResult"],
	deleteTimetableShiftGroup: GraphQLTypes["TimetableShiftGroupDeleteResult"],
	updateTimetableShiftGroup: GraphQLTypes["TimetableShiftGroupUpdateResult"],
	upsertTimetableShiftGroup: GraphQLTypes["TimetableShiftGroupUpsertResult"],
	createTimetableShiftPosition: GraphQLTypes["TimetableShiftPositionCreateResult"],
	deleteTimetableShiftPosition: GraphQLTypes["TimetableShiftPositionDeleteResult"],
	updateTimetableShiftPosition: GraphQLTypes["TimetableShiftPositionUpdateResult"],
	upsertTimetableShiftPosition: GraphQLTypes["TimetableShiftPositionUpsertResult"],
	createTimetableTemplate: GraphQLTypes["TimetableTemplateCreateResult"],
	deleteTimetableTemplate: GraphQLTypes["TimetableTemplateDeleteResult"],
	updateTimetableTemplate: GraphQLTypes["TimetableTemplateUpdateResult"],
	upsertTimetableTemplate: GraphQLTypes["TimetableTemplateUpsertResult"],
	createCart: GraphQLTypes["CartCreateResult"],
	deleteCart: GraphQLTypes["CartDeleteResult"],
	updateCart: GraphQLTypes["CartUpdateResult"],
	upsertCart: GraphQLTypes["CartUpsertResult"],
	createCartItem: GraphQLTypes["CartItemCreateResult"],
	deleteCartItem: GraphQLTypes["CartItemDeleteResult"],
	updateCartItem: GraphQLTypes["CartItemUpdateResult"],
	upsertCartItem: GraphQLTypes["CartItemUpsertResult"],
	createEmployeeQueueItem: GraphQLTypes["EmployeeQueueItemCreateResult"],
	deleteEmployeeQueueItem: GraphQLTypes["EmployeeQueueItemDeleteResult"],
	updateEmployeeQueueItem: GraphQLTypes["EmployeeQueueItemUpdateResult"],
	upsertEmployeeQueueItem: GraphQLTypes["EmployeeQueueItemUpsertResult"],
	createApplication: GraphQLTypes["ApplicationCreateResult"],
	deleteApplication: GraphQLTypes["ApplicationDeleteResult"],
	updateApplication: GraphQLTypes["ApplicationUpdateResult"],
	upsertApplication: GraphQLTypes["ApplicationUpsertResult"],
	createApplicationShortcutList: GraphQLTypes["ApplicationShortcutListCreateResult"],
	deleteApplicationShortcutList: GraphQLTypes["ApplicationShortcutListDeleteResult"],
	updateApplicationShortcutList: GraphQLTypes["ApplicationShortcutListUpdateResult"],
	upsertApplicationShortcutList: GraphQLTypes["ApplicationShortcutListUpsertResult"],
	createApplicationShortcutListItem: GraphQLTypes["ApplicationShortcutListItemCreateResult"],
	deleteApplicationShortcutListItem: GraphQLTypes["ApplicationShortcutListItemDeleteResult"],
	updateApplicationShortcutListItem: GraphQLTypes["ApplicationShortcutListItemUpdateResult"],
	upsertApplicationShortcutListItem: GraphQLTypes["ApplicationShortcutListItemUpsertResult"],
	createProductBanner: GraphQLTypes["ProductBannerCreateResult"],
	deleteProductBanner: GraphQLTypes["ProductBannerDeleteResult"],
	updateProductBanner: GraphQLTypes["ProductBannerUpdateResult"],
	upsertProductBanner: GraphQLTypes["ProductBannerUpsertResult"],
	createProductBannerItem: GraphQLTypes["ProductBannerItemCreateResult"],
	deleteProductBannerItem: GraphQLTypes["ProductBannerItemDeleteResult"],
	updateProductBannerItem: GraphQLTypes["ProductBannerItemUpdateResult"],
	upsertProductBannerItem: GraphQLTypes["ProductBannerItemUpsertResult"],
	createProductBannerList: GraphQLTypes["ProductBannerListCreateResult"],
	deleteProductBannerList: GraphQLTypes["ProductBannerListDeleteResult"],
	updateProductBannerList: GraphQLTypes["ProductBannerListUpdateResult"],
	upsertProductBannerList: GraphQLTypes["ProductBannerListUpsertResult"],
	createBartender: GraphQLTypes["BartenderCreateResult"],
	deleteBartender: GraphQLTypes["BartenderDeleteResult"],
	updateBartender: GraphQLTypes["BartenderUpdateResult"],
	upsertBartender: GraphQLTypes["BartenderUpsertResult"],
	createBusinessToBusinessManager: GraphQLTypes["BusinessToBusinessManagerCreateResult"],
	deleteBusinessToBusinessManager: GraphQLTypes["BusinessToBusinessManagerDeleteResult"],
	updateBusinessToBusinessManager: GraphQLTypes["BusinessToBusinessManagerUpdateResult"],
	upsertBusinessToBusinessManager: GraphQLTypes["BusinessToBusinessManagerUpsertResult"],
	createCleaner: GraphQLTypes["CleanerCreateResult"],
	deleteCleaner: GraphQLTypes["CleanerDeleteResult"],
	updateCleaner: GraphQLTypes["CleanerUpdateResult"],
	upsertCleaner: GraphQLTypes["CleanerUpsertResult"],
	createCourier: GraphQLTypes["CourierCreateResult"],
	deleteCourier: GraphQLTypes["CourierDeleteResult"],
	updateCourier: GraphQLTypes["CourierUpdateResult"],
	upsertCourier: GraphQLTypes["CourierUpsertResult"],
	createShiftsManager: GraphQLTypes["ShiftsManagerCreateResult"],
	deleteShiftsManager: GraphQLTypes["ShiftsManagerDeleteResult"],
	updateShiftsManager: GraphQLTypes["ShiftsManagerUpdateResult"],
	upsertShiftsManager: GraphQLTypes["ShiftsManagerUpsertResult"],
	createUser: GraphQLTypes["UserCreateResult"],
	deleteUser: GraphQLTypes["UserDeleteResult"],
	updateUser: GraphQLTypes["UserUpdateResult"],
	upsertUser: GraphQLTypes["UserUpsertResult"],
	createShiftsProfile: GraphQLTypes["ShiftsProfileCreateResult"],
	deleteShiftsProfile: GraphQLTypes["ShiftsProfileDeleteResult"],
	updateShiftsProfile: GraphQLTypes["ShiftsProfileUpdateResult"],
	upsertShiftsProfile: GraphQLTypes["ShiftsProfileUpsertResult"],
	createProductIngredientCategory: GraphQLTypes["ProductIngredientCategoryCreateResult"],
	deleteProductIngredientCategory: GraphQLTypes["ProductIngredientCategoryDeleteResult"],
	updateProductIngredientCategory: GraphQLTypes["ProductIngredientCategoryUpdateResult"],
	upsertProductIngredientCategory: GraphQLTypes["ProductIngredientCategoryUpsertResult"],
	createProductIngredientCategoryLocale: GraphQLTypes["ProductIngredientCategoryLocaleCreateResult"],
	deleteProductIngredientCategoryLocale: GraphQLTypes["ProductIngredientCategoryLocaleDeleteResult"],
	updateProductIngredientCategoryLocale: GraphQLTypes["ProductIngredientCategoryLocaleUpdateResult"],
	upsertProductIngredientCategoryLocale: GraphQLTypes["ProductIngredientCategoryLocaleUpsertResult"],
	createStocksManager: GraphQLTypes["StocksManagerCreateResult"],
	deleteStocksManager: GraphQLTypes["StocksManagerDeleteResult"],
	updateStocksManager: GraphQLTypes["StocksManagerUpdateResult"],
	upsertStocksManager: GraphQLTypes["StocksManagerUpsertResult"],
	createDeliveryRoute: GraphQLTypes["DeliveryRouteCreateResult"],
	deleteDeliveryRoute: GraphQLTypes["DeliveryRouteDeleteResult"],
	updateDeliveryRoute: GraphQLTypes["DeliveryRouteUpdateResult"],
	upsertDeliveryRoute: GraphQLTypes["DeliveryRouteUpsertResult"],
	createDeliveryWaypoint: GraphQLTypes["DeliveryWaypointCreateResult"],
	deleteDeliveryWaypoint: GraphQLTypes["DeliveryWaypointDeleteResult"],
	updateDeliveryWaypoint: GraphQLTypes["DeliveryWaypointUpdateResult"],
	upsertDeliveryWaypoint: GraphQLTypes["DeliveryWaypointUpsertResult"],
	createAllergen: GraphQLTypes["AllergenCreateResult"],
	deleteAllergen: GraphQLTypes["AllergenDeleteResult"],
	updateAllergen: GraphQLTypes["AllergenUpdateResult"],
	upsertAllergen: GraphQLTypes["AllergenUpsertResult"],
	createAllergenLocale: GraphQLTypes["AllergenLocaleCreateResult"],
	deleteAllergenLocale: GraphQLTypes["AllergenLocaleDeleteResult"],
	updateAllergenLocale: GraphQLTypes["AllergenLocaleUpdateResult"],
	upsertAllergenLocale: GraphQLTypes["AllergenLocaleUpsertResult"],
	createGps: GraphQLTypes["GpsCreateResult"],
	deleteGps: GraphQLTypes["GpsDeleteResult"],
	updateGps: GraphQLTypes["GpsUpdateResult"],
	upsertGps: GraphQLTypes["GpsUpsertResult"],
	createWeekHours: GraphQLTypes["WeekHoursCreateResult"],
	deleteWeekHours: GraphQLTypes["WeekHoursDeleteResult"],
	updateWeekHours: GraphQLTypes["WeekHoursUpdateResult"],
	upsertWeekHours: GraphQLTypes["WeekHoursUpsertResult"],
	createPreparedIngredientQuantity: GraphQLTypes["PreparedIngredientQuantityCreateResult"],
	deletePreparedIngredientQuantity: GraphQLTypes["PreparedIngredientQuantityDeleteResult"],
	updatePreparedIngredientQuantity: GraphQLTypes["PreparedIngredientQuantityUpdateResult"],
	upsertPreparedIngredientQuantity: GraphQLTypes["PreparedIngredientQuantityUpsertResult"],
	createPreparedRecipeQuantity: GraphQLTypes["PreparedRecipeQuantityCreateResult"],
	deletePreparedRecipeQuantity: GraphQLTypes["PreparedRecipeQuantityDeleteResult"],
	updatePreparedRecipeQuantity: GraphQLTypes["PreparedRecipeQuantityUpdateResult"],
	upsertPreparedRecipeQuantity: GraphQLTypes["PreparedRecipeQuantityUpsertResult"],
	createInternalOrder: GraphQLTypes["InternalOrderCreateResult"],
	deleteInternalOrder: GraphQLTypes["InternalOrderDeleteResult"],
	updateInternalOrder: GraphQLTypes["InternalOrderUpdateResult"],
	upsertInternalOrder: GraphQLTypes["InternalOrderUpsertResult"],
	createInternalOrderItem: GraphQLTypes["InternalOrderItemCreateResult"],
	deleteInternalOrderItem: GraphQLTypes["InternalOrderItemDeleteResult"],
	updateInternalOrderItem: GraphQLTypes["InternalOrderItemUpdateResult"],
	upsertInternalOrderItem: GraphQLTypes["InternalOrderItemUpsertResult"],
	createPreparedPackingQuantity: GraphQLTypes["PreparedPackingQuantityCreateResult"],
	deletePreparedPackingQuantity: GraphQLTypes["PreparedPackingQuantityDeleteResult"],
	updatePreparedPackingQuantity: GraphQLTypes["PreparedPackingQuantityUpdateResult"],
	upsertPreparedPackingQuantity: GraphQLTypes["PreparedPackingQuantityUpsertResult"],
	createCourierManager: GraphQLTypes["CourierManagerCreateResult"],
	deleteCourierManager: GraphQLTypes["CourierManagerDeleteResult"],
	updateCourierManager: GraphQLTypes["CourierManagerUpdateResult"],
	upsertCourierManager: GraphQLTypes["CourierManagerUpsertResult"],
	createDeliveryZone: GraphQLTypes["DeliveryZoneCreateResult"],
	deleteDeliveryZone: GraphQLTypes["DeliveryZoneDeleteResult"],
	updateDeliveryZone: GraphQLTypes["DeliveryZoneUpdateResult"],
	upsertDeliveryZone: GraphQLTypes["DeliveryZoneUpsertResult"],
	createDeliveryTimelinePreset: GraphQLTypes["DeliveryTimelinePresetCreateResult"],
	deleteDeliveryTimelinePreset: GraphQLTypes["DeliveryTimelinePresetDeleteResult"],
	updateDeliveryTimelinePreset: GraphQLTypes["DeliveryTimelinePresetUpdateResult"],
	upsertDeliveryTimelinePreset: GraphQLTypes["DeliveryTimelinePresetUpsertResult"],
	createOrderDeliveryTimeline: GraphQLTypes["OrderDeliveryTimelineCreateResult"],
	deleteOrderDeliveryTimeline: GraphQLTypes["OrderDeliveryTimelineDeleteResult"],
	updateOrderDeliveryTimeline: GraphQLTypes["OrderDeliveryTimelineUpdateResult"],
	upsertOrderDeliveryTimeline: GraphQLTypes["OrderDeliveryTimelineUpsertResult"],
	createOrderEvent: GraphQLTypes["OrderEventCreateResult"],
	deleteOrderEvent: GraphQLTypes["OrderEventDeleteResult"],
	updateOrderEvent: GraphQLTypes["OrderEventUpdateResult"],
	upsertOrderEvent: GraphQLTypes["OrderEventUpsertResult"],
	createLiftagoRide: GraphQLTypes["LiftagoRideCreateResult"],
	deleteLiftagoRide: GraphQLTypes["LiftagoRideDeleteResult"],
	updateLiftagoRide: GraphQLTypes["LiftagoRideUpdateResult"],
	upsertLiftagoRide: GraphQLTypes["LiftagoRideUpsertResult"],
	createInvoice: GraphQLTypes["InvoiceCreateResult"],
	deleteInvoice: GraphQLTypes["InvoiceDeleteResult"],
	updateInvoice: GraphQLTypes["InvoiceUpdateResult"],
	upsertInvoice: GraphQLTypes["InvoiceUpsertResult"],
	createInvoicingPlan: GraphQLTypes["InvoicingPlanCreateResult"],
	deleteInvoicingPlan: GraphQLTypes["InvoicingPlanDeleteResult"],
	updateInvoicingPlan: GraphQLTypes["InvoicingPlanUpdateResult"],
	upsertInvoicingPlan: GraphQLTypes["InvoicingPlanUpsertResult"],
	createProductPackingLocale: GraphQLTypes["ProductPackingLocaleCreateResult"],
	deleteProductPackingLocale: GraphQLTypes["ProductPackingLocaleDeleteResult"],
	updateProductPackingLocale: GraphQLTypes["ProductPackingLocaleUpdateResult"],
	upsertProductPackingLocale: GraphQLTypes["ProductPackingLocaleUpsertResult"],
	createProductLocale: GraphQLTypes["ProductLocaleCreateResult"],
	deleteProductLocale: GraphQLTypes["ProductLocaleDeleteResult"],
	updateProductLocale: GraphQLTypes["ProductLocaleUpdateResult"],
	upsertProductLocale: GraphQLTypes["ProductLocaleUpsertResult"],
	createProductRecipeLocale: GraphQLTypes["ProductRecipeLocaleCreateResult"],
	deleteProductRecipeLocale: GraphQLTypes["ProductRecipeLocaleDeleteResult"],
	updateProductRecipeLocale: GraphQLTypes["ProductRecipeLocaleUpdateResult"],
	upsertProductRecipeLocale: GraphQLTypes["ProductRecipeLocaleUpsertResult"],
	createUserDevice: GraphQLTypes["UserDeviceCreateResult"],
	deleteUserDevice: GraphQLTypes["UserDeviceDeleteResult"],
	updateUserDevice: GraphQLTypes["UserDeviceUpdateResult"],
	upsertUserDevice: GraphQLTypes["UserDeviceUpsertResult"],
	createProtectedAction: GraphQLTypes["ProtectedActionCreateResult"],
	deleteProtectedAction: GraphQLTypes["ProtectedActionDeleteResult"],
	updateProtectedAction: GraphQLTypes["ProtectedActionUpdateResult"],
	upsertProtectedAction: GraphQLTypes["ProtectedActionUpsertResult"],
	createPicker: GraphQLTypes["PickerCreateResult"],
	deletePicker: GraphQLTypes["PickerDeleteResult"],
	updatePicker: GraphQLTypes["PickerUpdateResult"],
	upsertPicker: GraphQLTypes["PickerUpsertResult"],
	createTimetableTemplateStaffOptions: GraphQLTypes["TimetableTemplateStaffOptionsCreateResult"],
	deleteTimetableTemplateStaffOptions: GraphQLTypes["TimetableTemplateStaffOptionsDeleteResult"],
	updateTimetableTemplateStaffOptions: GraphQLTypes["TimetableTemplateStaffOptionsUpdateResult"],
	upsertTimetableTemplateStaffOptions: GraphQLTypes["TimetableTemplateStaffOptionsUpsertResult"],
	createShoppingList: GraphQLTypes["ShoppingListCreateResult"],
	deleteShoppingList: GraphQLTypes["ShoppingListDeleteResult"],
	updateShoppingList: GraphQLTypes["ShoppingListUpdateResult"],
	upsertShoppingList: GraphQLTypes["ShoppingListUpsertResult"],
	createSuppliesPurchase: GraphQLTypes["SuppliesPurchaseCreateResult"],
	deleteSuppliesPurchase: GraphQLTypes["SuppliesPurchaseDeleteResult"],
	updateSuppliesPurchase: GraphQLTypes["SuppliesPurchaseUpdateResult"],
	upsertSuppliesPurchase: GraphQLTypes["SuppliesPurchaseUpsertResult"],
	createInvoicingPreset: GraphQLTypes["InvoicingPresetCreateResult"],
	deleteInvoicingPreset: GraphQLTypes["InvoicingPresetDeleteResult"],
	updateInvoicingPreset: GraphQLTypes["InvoicingPresetUpdateResult"],
	upsertInvoicingPreset: GraphQLTypes["InvoicingPresetUpsertResult"],
	createLogRecord: GraphQLTypes["LogRecordCreateResult"],
	deleteLogRecord: GraphQLTypes["LogRecordDeleteResult"],
	updateLogRecord: GraphQLTypes["LogRecordUpdateResult"],
	upsertLogRecord: GraphQLTypes["LogRecordUpsertResult"],
	createBillingSubject: GraphQLTypes["BillingSubjectCreateResult"],
	deleteBillingSubject: GraphQLTypes["BillingSubjectDeleteResult"],
	updateBillingSubject: GraphQLTypes["BillingSubjectUpdateResult"],
	upsertBillingSubject: GraphQLTypes["BillingSubjectUpsertResult"],
	createShoppingListItem: GraphQLTypes["ShoppingListItemCreateResult"],
	deleteShoppingListItem: GraphQLTypes["ShoppingListItemDeleteResult"],
	updateShoppingListItem: GraphQLTypes["ShoppingListItemUpdateResult"],
	upsertShoppingListItem: GraphQLTypes["ShoppingListItemUpsertResult"],
	createSuppliesPurchaseItem: GraphQLTypes["SuppliesPurchaseItemCreateResult"],
	deleteSuppliesPurchaseItem: GraphQLTypes["SuppliesPurchaseItemDeleteResult"],
	updateSuppliesPurchaseItem: GraphQLTypes["SuppliesPurchaseItemUpdateResult"],
	upsertSuppliesPurchaseItem: GraphQLTypes["SuppliesPurchaseItemUpsertResult"],
	createCustomerCreditTransaction: GraphQLTypes["CustomerCreditTransactionCreateResult"],
	deleteCustomerCreditTransaction: GraphQLTypes["CustomerCreditTransactionDeleteResult"],
	updateCustomerCreditTransaction: GraphQLTypes["CustomerCreditTransactionUpdateResult"],
	upsertCustomerCreditTransaction: GraphQLTypes["CustomerCreditTransactionUpsertResult"],
	createVirtualProduct: GraphQLTypes["VirtualProductCreateResult"],
	deleteVirtualProduct: GraphQLTypes["VirtualProductDeleteResult"],
	updateVirtualProduct: GraphQLTypes["VirtualProductUpdateResult"],
	upsertVirtualProduct: GraphQLTypes["VirtualProductUpsertResult"],
	createVirtualProductEffect: GraphQLTypes["VirtualProductEffectCreateResult"],
	deleteVirtualProductEffect: GraphQLTypes["VirtualProductEffectDeleteResult"],
	updateVirtualProductEffect: GraphQLTypes["VirtualProductEffectUpdateResult"],
	upsertVirtualProductEffect: GraphQLTypes["VirtualProductEffectUpsertResult"],
	createEmploymentInformation: GraphQLTypes["EmploymentInformationCreateResult"],
	deleteEmploymentInformation: GraphQLTypes["EmploymentInformationDeleteResult"],
	updateEmploymentInformation: GraphQLTypes["EmploymentInformationUpdateResult"],
	upsertEmploymentInformation: GraphQLTypes["EmploymentInformationUpsertResult"],
	createRemunerationProfile: GraphQLTypes["RemunerationProfileCreateResult"],
	deleteRemunerationProfile: GraphQLTypes["RemunerationProfileDeleteResult"],
	updateRemunerationProfile: GraphQLTypes["RemunerationProfileUpdateResult"],
	upsertRemunerationProfile: GraphQLTypes["RemunerationProfileUpsertResult"],
	createWorkMonth: GraphQLTypes["WorkMonthCreateResult"],
	deleteWorkMonth: GraphQLTypes["WorkMonthDeleteResult"],
	updateWorkMonth: GraphQLTypes["WorkMonthUpdateResult"],
	upsertWorkMonth: GraphQLTypes["WorkMonthUpsertResult"],
	createSalaryOptions: GraphQLTypes["SalaryOptionsCreateResult"],
	deleteSalaryOptions: GraphQLTypes["SalaryOptionsDeleteResult"],
	updateSalaryOptions: GraphQLTypes["SalaryOptionsUpdateResult"],
	upsertSalaryOptions: GraphQLTypes["SalaryOptionsUpsertResult"],
	createTimetableShiftSwapInfo: GraphQLTypes["TimetableShiftSwapInfoCreateResult"],
	deleteTimetableShiftSwapInfo: GraphQLTypes["TimetableShiftSwapInfoDeleteResult"],
	updateTimetableShiftSwapInfo: GraphQLTypes["TimetableShiftSwapInfoUpdateResult"],
	upsertTimetableShiftSwapInfo: GraphQLTypes["TimetableShiftSwapInfoUpsertResult"],
	createProductGridCategory: GraphQLTypes["ProductGridCategoryCreateResult"],
	deleteProductGridCategory: GraphQLTypes["ProductGridCategoryDeleteResult"],
	updateProductGridCategory: GraphQLTypes["ProductGridCategoryUpdateResult"],
	upsertProductGridCategory: GraphQLTypes["ProductGridCategoryUpsertResult"],
	createCashier: GraphQLTypes["CashierCreateResult"],
	deleteCashier: GraphQLTypes["CashierDeleteResult"],
	updateCashier: GraphQLTypes["CashierUpdateResult"],
	upsertCashier: GraphQLTypes["CashierUpsertResult"],
	createPointOfSaleCategory: GraphQLTypes["PointOfSaleCategoryCreateResult"],
	deletePointOfSaleCategory: GraphQLTypes["PointOfSaleCategoryDeleteResult"],
	updatePointOfSaleCategory: GraphQLTypes["PointOfSaleCategoryUpdateResult"],
	upsertPointOfSaleCategory: GraphQLTypes["PointOfSaleCategoryUpsertResult"],
	createPointOfSaleCategoryLocale: GraphQLTypes["PointOfSaleCategoryLocaleCreateResult"],
	deletePointOfSaleCategoryLocale: GraphQLTypes["PointOfSaleCategoryLocaleDeleteResult"],
	updatePointOfSaleCategoryLocale: GraphQLTypes["PointOfSaleCategoryLocaleUpdateResult"],
	upsertPointOfSaleCategoryLocale: GraphQLTypes["PointOfSaleCategoryLocaleUpsertResult"],
	createPointOfSaleCategoryProduct: GraphQLTypes["PointOfSaleCategoryProductCreateResult"],
	deletePointOfSaleCategoryProduct: GraphQLTypes["PointOfSaleCategoryProductDeleteResult"],
	updatePointOfSaleCategoryProduct: GraphQLTypes["PointOfSaleCategoryProductUpdateResult"],
	upsertPointOfSaleCategoryProduct: GraphQLTypes["PointOfSaleCategoryProductUpsertResult"],
	createPointOfSaleCategoryProductLocale: GraphQLTypes["PointOfSaleCategoryProductLocaleCreateResult"],
	deletePointOfSaleCategoryProductLocale: GraphQLTypes["PointOfSaleCategoryProductLocaleDeleteResult"],
	updatePointOfSaleCategoryProductLocale: GraphQLTypes["PointOfSaleCategoryProductLocaleUpdateResult"],
	upsertPointOfSaleCategoryProductLocale: GraphQLTypes["PointOfSaleCategoryProductLocaleUpsertResult"],
	createCustomerTab: GraphQLTypes["CustomerTabCreateResult"],
	deleteCustomerTab: GraphQLTypes["CustomerTabDeleteResult"],
	updateCustomerTab: GraphQLTypes["CustomerTabUpdateResult"],
	upsertCustomerTab: GraphQLTypes["CustomerTabUpsertResult"],
	createCustomerTabItem: GraphQLTypes["CustomerTabItemCreateResult"],
	deleteCustomerTabItem: GraphQLTypes["CustomerTabItemDeleteResult"],
	updateCustomerTabItem: GraphQLTypes["CustomerTabItemUpdateResult"],
	upsertCustomerTabItem: GraphQLTypes["CustomerTabItemUpsertResult"],
	createAnonymousSession: GraphQLTypes["AnonymousSessionCreateResult"],
	deleteAnonymousSession: GraphQLTypes["AnonymousSessionDeleteResult"],
	updateAnonymousSession: GraphQLTypes["AnonymousSessionUpdateResult"],
	upsertAnonymousSession: GraphQLTypes["AnonymousSessionUpsertResult"],
	createVoucher: GraphQLTypes["VoucherCreateResult"],
	deleteVoucher: GraphQLTypes["VoucherDeleteResult"],
	updateVoucher: GraphQLTypes["VoucherUpdateResult"],
	upsertVoucher: GraphQLTypes["VoucherUpsertResult"],
	createVoucherRedemption: GraphQLTypes["VoucherRedemptionCreateResult"],
	deleteVoucherRedemption: GraphQLTypes["VoucherRedemptionDeleteResult"],
	updateVoucherRedemption: GraphQLTypes["VoucherRedemptionUpdateResult"],
	upsertVoucherRedemption: GraphQLTypes["VoucherRedemptionUpsertResult"],
	createUnassignedShiftInfo: GraphQLTypes["UnassignedShiftInfoCreateResult"],
	deleteUnassignedShiftInfo: GraphQLTypes["UnassignedShiftInfoDeleteResult"],
	updateUnassignedShiftInfo: GraphQLTypes["UnassignedShiftInfoUpdateResult"],
	upsertUnassignedShiftInfo: GraphQLTypes["UnassignedShiftInfoUpsertResult"],
	createFreshingContainer: GraphQLTypes["FreshingContainerCreateResult"],
	deleteFreshingContainer: GraphQLTypes["FreshingContainerDeleteResult"],
	updateFreshingContainer: GraphQLTypes["FreshingContainerUpdateResult"],
	upsertFreshingContainer: GraphQLTypes["FreshingContainerUpsertResult"],
	createTextItem: GraphQLTypes["TextItemCreateResult"],
	deleteTextItem: GraphQLTypes["TextItemDeleteResult"],
	updateTextItem: GraphQLTypes["TextItemUpdateResult"],
	upsertTextItem: GraphQLTypes["TextItemUpsertResult"],
	createTextList: GraphQLTypes["TextListCreateResult"],
	deleteTextList: GraphQLTypes["TextListDeleteResult"],
	updateTextList: GraphQLTypes["TextListUpdateResult"],
	upsertTextList: GraphQLTypes["TextListUpsertResult"],
	createDeliveryRegions: GraphQLTypes["DeliveryRegionsCreateResult"],
	deleteDeliveryRegions: GraphQLTypes["DeliveryRegionsDeleteResult"],
	updateDeliveryRegions: GraphQLTypes["DeliveryRegionsUpdateResult"],
	upsertDeliveryRegions: GraphQLTypes["DeliveryRegionsUpsertResult"],
	createDeliveryRegionsItem: GraphQLTypes["DeliveryRegionsItemCreateResult"],
	deleteDeliveryRegionsItem: GraphQLTypes["DeliveryRegionsItemDeleteResult"],
	updateDeliveryRegionsItem: GraphQLTypes["DeliveryRegionsItemUpdateResult"],
	upsertDeliveryRegionsItem: GraphQLTypes["DeliveryRegionsItemUpsertResult"],
	createImageList: GraphQLTypes["ImageListCreateResult"],
	deleteImageList: GraphQLTypes["ImageListDeleteResult"],
	updateImageList: GraphQLTypes["ImageListUpdateResult"],
	upsertImageList: GraphQLTypes["ImageListUpsertResult"],
	createImageListItem: GraphQLTypes["ImageListItemCreateResult"],
	deleteImageListItem: GraphQLTypes["ImageListItemDeleteResult"],
	updateImageListItem: GraphQLTypes["ImageListItemUpdateResult"],
	upsertImageListItem: GraphQLTypes["ImageListItemUpsertResult"],
	createTimetablesEmployeePrivileges: GraphQLTypes["TimetablesEmployeePrivilegesCreateResult"],
	deleteTimetablesEmployeePrivileges: GraphQLTypes["TimetablesEmployeePrivilegesDeleteResult"],
	updateTimetablesEmployeePrivileges: GraphQLTypes["TimetablesEmployeePrivilegesUpdateResult"],
	upsertTimetablesEmployeePrivileges: GraphQLTypes["TimetablesEmployeePrivilegesUpsertResult"],
	createTimetableDayNote: GraphQLTypes["TimetableDayNoteCreateResult"],
	deleteTimetableDayNote: GraphQLTypes["TimetableDayNoteDeleteResult"],
	updateTimetableDayNote: GraphQLTypes["TimetableDayNoteUpdateResult"],
	upsertTimetableDayNote: GraphQLTypes["TimetableDayNoteUpsertResult"],
	createDeliveryMethodLocale: GraphQLTypes["DeliveryMethodLocaleCreateResult"],
	deleteDeliveryMethodLocale: GraphQLTypes["DeliveryMethodLocaleDeleteResult"],
	updateDeliveryMethodLocale: GraphQLTypes["DeliveryMethodLocaleUpdateResult"],
	upsertDeliveryMethodLocale: GraphQLTypes["DeliveryMethodLocaleUpsertResult"],
	createIngredientSupplier: GraphQLTypes["IngredientSupplierCreateResult"],
	deleteIngredientSupplier: GraphQLTypes["IngredientSupplierDeleteResult"],
	updateIngredientSupplier: GraphQLTypes["IngredientSupplierUpdateResult"],
	upsertIngredientSupplier: GraphQLTypes["IngredientSupplierUpsertResult"],
	createIngredientSupplierItem: GraphQLTypes["IngredientSupplierItemCreateResult"],
	deleteIngredientSupplierItem: GraphQLTypes["IngredientSupplierItemDeleteResult"],
	updateIngredientSupplierItem: GraphQLTypes["IngredientSupplierItemUpdateResult"],
	upsertIngredientSupplierItem: GraphQLTypes["IngredientSupplierItemUpsertResult"],
	createIngredientSupplierList: GraphQLTypes["IngredientSupplierListCreateResult"],
	deleteIngredientSupplierList: GraphQLTypes["IngredientSupplierListDeleteResult"],
	updateIngredientSupplierList: GraphQLTypes["IngredientSupplierListUpdateResult"],
	upsertIngredientSupplierList: GraphQLTypes["IngredientSupplierListUpsertResult"],
	createIngredientSupplierLocale: GraphQLTypes["IngredientSupplierLocaleCreateResult"],
	deleteIngredientSupplierLocale: GraphQLTypes["IngredientSupplierLocaleDeleteResult"],
	updateIngredientSupplierLocale: GraphQLTypes["IngredientSupplierLocaleUpdateResult"],
	upsertIngredientSupplierLocale: GraphQLTypes["IngredientSupplierLocaleUpsertResult"],
	createRedirect: GraphQLTypes["RedirectCreateResult"],
	deleteRedirect: GraphQLTypes["RedirectDeleteResult"],
	updateRedirect: GraphQLTypes["RedirectUpdateResult"],
	upsertRedirect: GraphQLTypes["RedirectUpsertResult"],
	createNutritionFacts: GraphQLTypes["NutritionFactsCreateResult"],
	deleteNutritionFacts: GraphQLTypes["NutritionFactsDeleteResult"],
	updateNutritionFacts: GraphQLTypes["NutritionFactsUpdateResult"],
	upsertNutritionFacts: GraphQLTypes["NutritionFactsUpsertResult"],
	createVenue: GraphQLTypes["VenueCreateResult"],
	deleteVenue: GraphQLTypes["VenueDeleteResult"],
	updateVenue: GraphQLTypes["VenueUpdateResult"],
	upsertVenue: GraphQLTypes["VenueUpsertResult"],
	createWorkspace: GraphQLTypes["WorkspaceCreateResult"],
	deleteWorkspace: GraphQLTypes["WorkspaceDeleteResult"],
	updateWorkspace: GraphQLTypes["WorkspaceUpdateResult"],
	upsertWorkspace: GraphQLTypes["WorkspaceUpsertResult"],
	createInternalBuyer: GraphQLTypes["InternalBuyerCreateResult"],
	deleteInternalBuyer: GraphQLTypes["InternalBuyerDeleteResult"],
	updateInternalBuyer: GraphQLTypes["InternalBuyerUpdateResult"],
	upsertInternalBuyer: GraphQLTypes["InternalBuyerUpsertResult"],
	createVenueEmployeeRole: GraphQLTypes["VenueEmployeeRoleCreateResult"],
	deleteVenueEmployeeRole: GraphQLTypes["VenueEmployeeRoleDeleteResult"],
	updateVenueEmployeeRole: GraphQLTypes["VenueEmployeeRoleUpdateResult"],
	upsertVenueEmployeeRole: GraphQLTypes["VenueEmployeeRoleUpsertResult"],
	createIdentificationAttempt: GraphQLTypes["IdentificationAttemptCreateResult"],
	deleteIdentificationAttempt: GraphQLTypes["IdentificationAttemptDeleteResult"],
	updateIdentificationAttempt: GraphQLTypes["IdentificationAttemptUpdateResult"],
	upsertIdentificationAttempt: GraphQLTypes["IdentificationAttemptUpsertResult"],
	createIdentificationCode: GraphQLTypes["IdentificationCodeCreateResult"],
	deleteIdentificationCode: GraphQLTypes["IdentificationCodeDeleteResult"],
	updateIdentificationCode: GraphQLTypes["IdentificationCodeUpdateResult"],
	upsertIdentificationCode: GraphQLTypes["IdentificationCodeUpsertResult"],
	createIdentificationCodeLocale: GraphQLTypes["IdentificationCodeLocaleCreateResult"],
	deleteIdentificationCodeLocale: GraphQLTypes["IdentificationCodeLocaleDeleteResult"],
	updateIdentificationCodeLocale: GraphQLTypes["IdentificationCodeLocaleUpdateResult"],
	upsertIdentificationCodeLocale: GraphQLTypes["IdentificationCodeLocaleUpsertResult"],
	createPipeline: GraphQLTypes["PipelineCreateResult"],
	deletePipeline: GraphQLTypes["PipelineDeleteResult"],
	updatePipeline: GraphQLTypes["PipelineUpdateResult"],
	upsertPipeline: GraphQLTypes["PipelineUpsertResult"],
	createPipelineLead: GraphQLTypes["PipelineLeadCreateResult"],
	deletePipelineLead: GraphQLTypes["PipelineLeadDeleteResult"],
	updatePipelineLead: GraphQLTypes["PipelineLeadUpdateResult"],
	upsertPipelineLead: GraphQLTypes["PipelineLeadUpsertResult"],
	createPipelineStage: GraphQLTypes["PipelineStageCreateResult"],
	deletePipelineStage: GraphQLTypes["PipelineStageDeleteResult"],
	updatePipelineStage: GraphQLTypes["PipelineStageUpdateResult"],
	upsertPipelineStage: GraphQLTypes["PipelineStageUpsertResult"],
	createPipelineStageItem: GraphQLTypes["PipelineStageItemCreateResult"],
	deletePipelineStageItem: GraphQLTypes["PipelineStageItemDeleteResult"],
	updatePipelineStageItem: GraphQLTypes["PipelineStageItemUpdateResult"],
	upsertPipelineStageItem: GraphQLTypes["PipelineStageItemUpsertResult"],
	createPipelineStageLocale: GraphQLTypes["PipelineStageLocaleCreateResult"],
	deletePipelineStageLocale: GraphQLTypes["PipelineStageLocaleDeleteResult"],
	updatePipelineStageLocale: GraphQLTypes["PipelineStageLocaleUpdateResult"],
	upsertPipelineStageLocale: GraphQLTypes["PipelineStageLocaleUpsertResult"],
	createSalesManager: GraphQLTypes["SalesManagerCreateResult"],
	deleteSalesManager: GraphQLTypes["SalesManagerDeleteResult"],
	updateSalesManager: GraphQLTypes["SalesManagerUpdateResult"],
	upsertSalesManager: GraphQLTypes["SalesManagerUpsertResult"],
	createCashierManager: GraphQLTypes["CashierManagerCreateResult"],
	deleteCashierManager: GraphQLTypes["CashierManagerDeleteResult"],
	updateCashierManager: GraphQLTypes["CashierManagerUpdateResult"],
	upsertCashierManager: GraphQLTypes["CashierManagerUpsertResult"],
	createPointOfSaleApplicationDevice: GraphQLTypes["PointOfSaleApplicationDeviceCreateResult"],
	deletePointOfSaleApplicationDevice: GraphQLTypes["PointOfSaleApplicationDeviceDeleteResult"],
	updatePointOfSaleApplicationDevice: GraphQLTypes["PointOfSaleApplicationDeviceUpdateResult"],
	upsertPointOfSaleApplicationDevice: GraphQLTypes["PointOfSaleApplicationDeviceUpsertResult"],
	createPointOfSaleTerminal: GraphQLTypes["PointOfSaleTerminalCreateResult"],
	deletePointOfSaleTerminal: GraphQLTypes["PointOfSaleTerminalDeleteResult"],
	updatePointOfSaleTerminal: GraphQLTypes["PointOfSaleTerminalUpdateResult"],
	upsertPointOfSaleTerminal: GraphQLTypes["PointOfSaleTerminalUpsertResult"],
	createPipelineStageSentiment: GraphQLTypes["PipelineStageSentimentCreateResult"],
	deletePipelineStageSentiment: GraphQLTypes["PipelineStageSentimentDeleteResult"],
	updatePipelineStageSentiment: GraphQLTypes["PipelineStageSentimentUpdateResult"],
	upsertPipelineStageSentiment: GraphQLTypes["PipelineStageSentimentUpsertResult"],
	createDeviceIdentifier: GraphQLTypes["DeviceIdentifierCreateResult"],
	deleteDeviceIdentifier: GraphQLTypes["DeviceIdentifierDeleteResult"],
	updateDeviceIdentifier: GraphQLTypes["DeviceIdentifierUpdateResult"],
	upsertDeviceIdentifier: GraphQLTypes["DeviceIdentifierUpsertResult"],
	createPointOfSalePrinter: GraphQLTypes["PointOfSalePrinterCreateResult"],
	deletePointOfSalePrinter: GraphQLTypes["PointOfSalePrinterDeleteResult"],
	updatePointOfSalePrinter: GraphQLTypes["PointOfSalePrinterUpdateResult"],
	upsertPointOfSalePrinter: GraphQLTypes["PointOfSalePrinterUpsertResult"],
	createGratuity: GraphQLTypes["GratuityCreateResult"],
	deleteGratuity: GraphQLTypes["GratuityDeleteResult"],
	updateGratuity: GraphQLTypes["GratuityUpdateResult"],
	upsertGratuity: GraphQLTypes["GratuityUpsertResult"],
	createFulfillmentNote: GraphQLTypes["FulfillmentNoteCreateResult"],
	deleteFulfillmentNote: GraphQLTypes["FulfillmentNoteDeleteResult"],
	updateFulfillmentNote: GraphQLTypes["FulfillmentNoteUpdateResult"],
	upsertFulfillmentNote: GraphQLTypes["FulfillmentNoteUpsertResult"],
	createLeadForm: GraphQLTypes["LeadFormCreateResult"],
	deleteLeadForm: GraphQLTypes["LeadFormDeleteResult"],
	updateLeadForm: GraphQLTypes["LeadFormUpdateResult"],
	upsertLeadForm: GraphQLTypes["LeadFormUpsertResult"],
	createSubscriptionBox: GraphQLTypes["SubscriptionBoxCreateResult"],
	deleteSubscriptionBox: GraphQLTypes["SubscriptionBoxDeleteResult"],
	updateSubscriptionBox: GraphQLTypes["SubscriptionBoxUpdateResult"],
	upsertSubscriptionBox: GraphQLTypes["SubscriptionBoxUpsertResult"],
	createSubscriptionBoxLocale: GraphQLTypes["SubscriptionBoxLocaleCreateResult"],
	deleteSubscriptionBoxLocale: GraphQLTypes["SubscriptionBoxLocaleDeleteResult"],
	updateSubscriptionBoxLocale: GraphQLTypes["SubscriptionBoxLocaleUpdateResult"],
	upsertSubscriptionBoxLocale: GraphQLTypes["SubscriptionBoxLocaleUpsertResult"],
	createBusinessService: GraphQLTypes["BusinessServiceCreateResult"],
	deleteBusinessService: GraphQLTypes["BusinessServiceDeleteResult"],
	updateBusinessService: GraphQLTypes["BusinessServiceUpdateResult"],
	upsertBusinessService: GraphQLTypes["BusinessServiceUpsertResult"],
	createBusinessServiceEvent: GraphQLTypes["BusinessServiceEventCreateResult"],
	deleteBusinessServiceEvent: GraphQLTypes["BusinessServiceEventDeleteResult"],
	updateBusinessServiceEvent: GraphQLTypes["BusinessServiceEventUpdateResult"],
	upsertBusinessServiceEvent: GraphQLTypes["BusinessServiceEventUpsertResult"],
	createBusinessServiceLocale: GraphQLTypes["BusinessServiceLocaleCreateResult"],
	deleteBusinessServiceLocale: GraphQLTypes["BusinessServiceLocaleDeleteResult"],
	updateBusinessServiceLocale: GraphQLTypes["BusinessServiceLocaleUpdateResult"],
	upsertBusinessServiceLocale: GraphQLTypes["BusinessServiceLocaleUpsertResult"],
	createGridTileItem: GraphQLTypes["GridTileItemCreateResult"],
	deleteGridTileItem: GraphQLTypes["GridTileItemDeleteResult"],
	updateGridTileItem: GraphQLTypes["GridTileItemUpdateResult"],
	upsertGridTileItem: GraphQLTypes["GridTileItemUpsertResult"],
	createGridTiles: GraphQLTypes["GridTilesCreateResult"],
	deleteGridTiles: GraphQLTypes["GridTilesDeleteResult"],
	updateGridTiles: GraphQLTypes["GridTilesUpdateResult"],
	upsertGridTiles: GraphQLTypes["GridTilesUpsertResult"],
	createArea: GraphQLTypes["AreaCreateResult"],
	deleteArea: GraphQLTypes["AreaDeleteResult"],
	updateArea: GraphQLTypes["AreaUpdateResult"],
	upsertArea: GraphQLTypes["AreaUpsertResult"],
	createPosition: GraphQLTypes["PositionCreateResult"],
	deletePosition: GraphQLTypes["PositionDeleteResult"],
	updatePosition: GraphQLTypes["PositionUpdateResult"],
	upsertPosition: GraphQLTypes["PositionUpsertResult"],
	createStatsEnabledWidgetType: GraphQLTypes["StatsEnabledWidgetTypeCreateResult"],
	deleteStatsEnabledWidgetType: GraphQLTypes["StatsEnabledWidgetTypeDeleteResult"],
	updateStatsEnabledWidgetType: GraphQLTypes["StatsEnabledWidgetTypeUpdateResult"],
	upsertStatsEnabledWidgetType: GraphQLTypes["StatsEnabledWidgetTypeUpsertResult"],
	createStatsWidget: GraphQLTypes["StatsWidgetCreateResult"],
	deleteStatsWidget: GraphQLTypes["StatsWidgetDeleteResult"],
	updateStatsWidget: GraphQLTypes["StatsWidgetUpdateResult"],
	upsertStatsWidget: GraphQLTypes["StatsWidgetUpsertResult"],
	createStatsWidgetsLayout: GraphQLTypes["StatsWidgetsLayoutCreateResult"],
	deleteStatsWidgetsLayout: GraphQLTypes["StatsWidgetsLayoutDeleteResult"],
	updateStatsWidgetsLayout: GraphQLTypes["StatsWidgetsLayoutUpdateResult"],
	upsertStatsWidgetsLayout: GraphQLTypes["StatsWidgetsLayoutUpsertResult"],
	createSeat: GraphQLTypes["SeatCreateResult"],
	deleteSeat: GraphQLTypes["SeatDeleteResult"],
	updateSeat: GraphQLTypes["SeatUpdateResult"],
	upsertSeat: GraphQLTypes["SeatUpsertResult"],
	createTable: GraphQLTypes["TableCreateResult"],
	deleteTable: GraphQLTypes["TableDeleteResult"],
	updateTable: GraphQLTypes["TableUpdateResult"],
	upsertTable: GraphQLTypes["TableUpsertResult"],
	createStatsPage: GraphQLTypes["StatsPageCreateResult"],
	deleteStatsPage: GraphQLTypes["StatsPageDeleteResult"],
	updateStatsPage: GraphQLTypes["StatsPageUpdateResult"],
	upsertStatsPage: GraphQLTypes["StatsPageUpsertResult"],
	createUnassignReason: GraphQLTypes["UnassignReasonCreateResult"],
	deleteUnassignReason: GraphQLTypes["UnassignReasonDeleteResult"],
	updateUnassignReason: GraphQLTypes["UnassignReasonUpdateResult"],
	upsertUnassignReason: GraphQLTypes["UnassignReasonUpsertResult"],
	createDoubleshotCoffeeEquipment: GraphQLTypes["DoubleshotCoffeeEquipmentCreateResult"],
	deleteDoubleshotCoffeeEquipment: GraphQLTypes["DoubleshotCoffeeEquipmentDeleteResult"],
	updateDoubleshotCoffeeEquipment: GraphQLTypes["DoubleshotCoffeeEquipmentUpdateResult"],
	upsertDoubleshotCoffeeEquipment: GraphQLTypes["DoubleshotCoffeeEquipmentUpsertResult"],
	createExpense: GraphQLTypes["ExpenseCreateResult"],
	deleteExpense: GraphQLTypes["ExpenseDeleteResult"],
	updateExpense: GraphQLTypes["ExpenseUpdateResult"],
	upsertExpense: GraphQLTypes["ExpenseUpsertResult"],
	createExpenseCategory: GraphQLTypes["ExpenseCategoryCreateResult"],
	deleteExpenseCategory: GraphQLTypes["ExpenseCategoryDeleteResult"],
	updateExpenseCategory: GraphQLTypes["ExpenseCategoryUpdateResult"],
	upsertExpenseCategory: GraphQLTypes["ExpenseCategoryUpsertResult"],
	createExpenseChange: GraphQLTypes["ExpenseChangeCreateResult"],
	deleteExpenseChange: GraphQLTypes["ExpenseChangeDeleteResult"],
	updateExpenseChange: GraphQLTypes["ExpenseChangeUpdateResult"],
	upsertExpenseChange: GraphQLTypes["ExpenseChangeUpsertResult"],
	createExpenseDocument: GraphQLTypes["ExpenseDocumentCreateResult"],
	deleteExpenseDocument: GraphQLTypes["ExpenseDocumentDeleteResult"],
	updateExpenseDocument: GraphQLTypes["ExpenseDocumentUpdateResult"],
	upsertExpenseDocument: GraphQLTypes["ExpenseDocumentUpsertResult"],
	createRevenuePrediction: GraphQLTypes["RevenuePredictionCreateResult"],
	deleteRevenuePrediction: GraphQLTypes["RevenuePredictionDeleteResult"],
	updateRevenuePrediction: GraphQLTypes["RevenuePredictionUpdateResult"],
	upsertRevenuePrediction: GraphQLTypes["RevenuePredictionUpsertResult"],
	createRevenuePredictionChange: GraphQLTypes["RevenuePredictionChangeCreateResult"],
	deleteRevenuePredictionChange: GraphQLTypes["RevenuePredictionChangeDeleteResult"],
	updateRevenuePredictionChange: GraphQLTypes["RevenuePredictionChangeUpdateResult"],
	upsertRevenuePredictionChange: GraphQLTypes["RevenuePredictionChangeUpsertResult"],
	createFile: GraphQLTypes["FileCreateResult"],
	deleteFile: GraphQLTypes["FileDeleteResult"],
	updateFile: GraphQLTypes["FileUpdateResult"],
	upsertFile: GraphQLTypes["FileUpsertResult"],
	createLine: GraphQLTypes["LineCreateResult"],
	deleteLine: GraphQLTypes["LineDeleteResult"],
	updateLine: GraphQLTypes["LineUpdateResult"],
	upsertLine: GraphQLTypes["LineUpsertResult"],
	createFinancesBalanceItem: GraphQLTypes["FinancesBalanceItemCreateResult"],
	deleteFinancesBalanceItem: GraphQLTypes["FinancesBalanceItemDeleteResult"],
	updateFinancesBalanceItem: GraphQLTypes["FinancesBalanceItemUpdateResult"],
	upsertFinancesBalanceItem: GraphQLTypes["FinancesBalanceItemUpsertResult"],
	createWoltDriveDelivery: GraphQLTypes["WoltDriveDeliveryCreateResult"],
	deleteWoltDriveDelivery: GraphQLTypes["WoltDriveDeliveryDeleteResult"],
	updateWoltDriveDelivery: GraphQLTypes["WoltDriveDeliveryUpdateResult"],
	upsertWoltDriveDelivery: GraphQLTypes["WoltDriveDeliveryUpsertResult"],
	query?: GraphQLTypes["Query"] | undefined
};
	["MutationTransactionOptions"]: {
		deferForeignKeyConstraints?: boolean | undefined
};
	["_Schema"]: {
	__typename: "_Schema",
	enums: Array<GraphQLTypes["_Enum"]>,
	entities: Array<GraphQLTypes["_Entity"]>
};
	["_Entity"]: {
	__typename: "_Entity",
	name: string,
	customPrimaryAllowed: boolean,
	fields: Array<GraphQLTypes["_Field"]>,
	unique: Array<GraphQLTypes["_UniqueConstraint"]>
};
	["_UniqueConstraint"]: {
	__typename: "_UniqueConstraint",
	fields: Array<string>
};
	["_Field"]: {
	__typename:"_Column" | "_Relation",
	name: string,
	type: string,
	nullable?: boolean | undefined,
	rules: Array<GraphQLTypes["_Rule"]>,
	validators: Array<GraphQLTypes["_Validator"]>
	['...on _Column']: '__union' & GraphQLTypes["_Column"];
	['...on _Relation']: '__union' & GraphQLTypes["_Relation"];
};
	["_Column"]: {
	__typename: "_Column",
	name: string,
	type: string,
	enumName?: string | undefined,
	defaultValue?: GraphQLTypes["Json"] | undefined,
	nullable: boolean,
	rules: Array<GraphQLTypes["_Rule"]>,
	validators: Array<GraphQLTypes["_Validator"]>
};
	["_OnDeleteBehaviour"]: _OnDeleteBehaviour;
	["_RelationSide"]: _RelationSide;
	["_OrderByDirection"]: _OrderByDirection;
	["_OrderBy"]: {
	__typename: "_OrderBy",
	path: Array<string>,
	direction: GraphQLTypes["_OrderByDirection"]
};
	["_Relation"]: {
	__typename: "_Relation",
	name: string,
	type: string,
	side: GraphQLTypes["_RelationSide"],
	targetEntity: string,
	ownedBy?: string | undefined,
	inversedBy?: string | undefined,
	nullable?: boolean | undefined,
	onDelete?: GraphQLTypes["_OnDeleteBehaviour"] | undefined,
	orphanRemoval?: boolean | undefined,
	orderBy?: Array<GraphQLTypes["_OrderBy"]> | undefined,
	rules: Array<GraphQLTypes["_Rule"]>,
	validators: Array<GraphQLTypes["_Validator"]>
};
	["_Rule"]: {
	__typename: "_Rule",
	message?: GraphQLTypes["_RuleMessage"] | undefined,
	validator: number
};
	["_Validator"]: {
	__typename: "_Validator",
	operation: string,
	arguments: Array<GraphQLTypes["_Argument"]>
};
	["_Argument"]:{
        	__typename:"_ValidatorArgument" | "_PathArgument" | "_LiteralArgument"
        	['...on _ValidatorArgument']: '__union' & GraphQLTypes["_ValidatorArgument"];
	['...on _PathArgument']: '__union' & GraphQLTypes["_PathArgument"];
	['...on _LiteralArgument']: '__union' & GraphQLTypes["_LiteralArgument"];
};
	["_ValidatorArgument"]: {
	__typename: "_ValidatorArgument",
	validator: number
};
	["_PathArgument"]: {
	__typename: "_PathArgument",
	path: Array<string>
};
	["_LiteralArgument"]: {
	__typename: "_LiteralArgument",
	value?: GraphQLTypes["Json"] | undefined
};
	["_RuleMessage"]: {
	__typename: "_RuleMessage",
	text?: string | undefined
};
	["_Enum"]: {
	__typename: "_Enum",
	name: string,
	values: Array<string>
};
	["S3SignedUpload"]: {
	__typename: "S3SignedUpload",
	url: string,
	headers: Array<GraphQLTypes["S3Header"]>,
	method: string,
	/** Allowed patterns:
** */
	objectKey: string,
	bucket: string,
	publicUrl: string
};
	["S3Header"]: {
	__typename: "S3Header",
	key: string,
	value: string
};
	["S3SignedRead"]: {
	__typename: "S3SignedRead",
	url: string,
	headers: Array<GraphQLTypes["S3Header"]>,
	method: string,
	/** Allowed patterns:
** */
	objectKey: string,
	bucket: string
}
    }
export type DeliveryZoneType = "Shop" | "Prague" | "CZ" | "Abroad" | "Virtual";

export type TimetableDayType = "open" | "closed";

export type UnassignedInfoReason = "sickness" | "vacation" | "other";

export type TemplateType = "inInterval" | "selectedDays";

export type PointOfSaleTerminalType = "manual" | "switchio" | "globalpayments";

export type OrderState = "created" | "waitingForPayment" | "processing" | "dispatched" | "fulfilled" | "canceled";

export type OrderDiscountType = "Manual" | "Credits" | "Voucher";

export type VoucherType = "Credits";

export type OrderPaymentState = "created" | "approved" | "failed";

export type OrderPriceLineType = "discount" | "item" | "delivery";

export type TableShape = "rectangle" | "ellipse";

export type PointOfSaleInitialView = "categories" | "areas";

export type CartState = "created" | "confirmed" | "deleted";

export type CartPriceLineType = "item";

export type ChannelCode = "b2b" | "eshop" | "app" | "pos" | "web" | "all" | "legacy";

export type VatRatePreset = "zero" | "default";

export type OrderDeliveryState = "processing" | "picked" | "delivering" | "delivered" | "failed";

export type WoltDriveDeliveryState = "shipmentPromise" | "created" | "pickedUp" | "delivered";

export type EmploymentType = "full_time" | "part_time";

export type One = "One";

export type VirtualProductType = "Credits" | "Voucher";

export type VirtualProductPhysicalRepresentationType = "None" | "Optional" | "Required";

export type MediumType = "image" | "video";

export type ColorTheme = "light" | "dark";

export type ContentReferenceType = "button" | "medium" | "products" | "productBanners" | "links" | "link" | "blogPosts" | "content" | "gallery" | "hero" | "hr" | "marquee" | "productGrid" | "relatedBlogPosts" | "socialsAndApps" | "titleWithImage" | "deliveryRegions" | "collapsibleTexts" | "gridTiles";

export type LinkType = "internal" | "external" | "download";

export type PageTheme = "goodlok" | "childish";

export type ContentSize = "small" | "medium" | "large";

export type ProductGridType = "default" | "carousel" | "smallGrid";

export type ProductBannerItemSize = "small" | "medium" | "large" | "fullWidth";

export type TranslationContentType = "textPlain" | "textHtml";

export type MenuSubitemType = "links" | "products" | "delivery" | "contact";

export type PipelineStageType = "successful" | "failed" | "ordered" | "unassigned" | "regular";

export type ProductAvailability = "stockDependent" | "available" | "unavailable";

export type DeliveryTimelineType = "asap" | "day" | "halfAnHour" | "wholeNextDay";

export type PaymentMethodType = "credit" | "stripe" | "cash" | "invoice" | "import";

export type CustomerFamiliarity = "cizi" | "pratelskeVykani" | "slusneTykani" | "tykani" | "sikana";

export type InvoicingPresetType = "AdHoc" | "WhenFulfilled" | "FirstDayOfMonth" | "IntervalOfDays";

export type OrderDirection = "asc" | "desc" | "ascNullsFirst" | "descNullsLast";

export type InternalOrderState = "created" | "fulfilled" | "canceled";

export type ProtectedActionType = "ResetPassword" | "VerifyEmail" | "Authorization";

export type StatsEnabledWidgetTypeType = "revenue" | "numberOfCustomers" | "numberOfCustomersHourly" | "averageCustomerSpending" | "topProduct" | "dailyGratuity" | "salesByProductCategories" | "productSales" | "cashRegisterBalance" | "revenueByHours" | "revenueWeeklyComparison" | "dailyRevenue";

export type StatsWidgetTimeFrame = "day" | "week" | "month" | "year" | "allTime";

export type StatsPageType = "dashboard" | "sales" | "b2b" | "employees";

export type ExpenseType = "periodic" | "disposable";

export type RevenuePredictionType = "periodic" | "disposable";

export type RecurrencePeriod = "day" | "month";

export type _MutationErrorType = "NotNullConstraintViolation" | "UniqueConstraintViolation" | "ForeignKeyConstraintViolation" | "NotFoundOrDenied" | "NonUniqueWhereInput" | "InvalidDataInput" | "SqlError";

export type _OnDeleteBehaviour = "restrict" | "cascade" | "setNull";

export type _RelationSide = "owning" | "inverse";

export type _OrderByDirection = "asc" | "desc";

export const createZeusVariables = useZeusVariables

export type FragmentResult<K extends keyof GraphQLTypes, Q extends unknown | ((...args: any[]) => unknown)> = InputType<
	GraphQLTypes[K],
	Q extends (...args: any[]) => unknown ? ReturnType<Q> : Q
>